export const portData = [
  {
   value: "Ndola (ZMNLA)",
   label: "Ndola (ZMNLA)"
  },
  {
   value: "Ngoma (ZMZGM)",
   label: "Ngoma (ZMZGM)"
  },
  {
   value: "Senanga (ZMSXG)",
   label: "Senanga (ZMSXG)"
  },
  {
   value: "Sesheke (ZMSJQ)",
   label: "Sesheke (ZMSJQ)"
  },
  {
   value: "Solwezi (ZMSLI)",
   label: "Solwezi (ZMSLI)"
  },
  {
   value: "Zambezi (ZMBBZ)",
   label: "Zambezi (ZMBBZ)"
  },
  {
   value: "Bata (ZWBAT)",
   label: "Bata (ZWBAT)"
  },
  {
   value: "Buffalo Range (ZWBFO)",
   label: "Buffalo Range (ZWBFO)"
  },
  {
   value: "Bulawayo (ZWBUQ)",
   label: "Bulawayo (ZWBUQ)"
  },
  {
   value: "Gweru (ZWGWE)",
   label: "Gweru (ZWGWE)"
  },
  {
   value: "Harare (ZWHRE)",
   label: "Harare (ZWHRE)"
  },
  {
   value: "Kariba (ZWKAB)",
   label: "Kariba (ZWKAB)"
  },
  {
   value: "Kwekwe (ZWKWE)",
   label: "Kwekwe (ZWKWE)"
  },
  {
   value: "Mutare (ZWUTA)",
   label: "Mutare (ZWUTA)"
  },
  {
   value: "Victoria Falls (ZWVFA)",
   label: "Victoria Falls (ZWVFA)"
  },
  {
   value: "destination in international waters (XXXXXX)",
   label: "destination in international waters (XXXXXX)"
  },
  {
   value: "Nassau New Providence I. (BSNAS)",
   label: "Nassau New Providence I. (BSNAS)"
  },
  {
   value: "Puerto Ayora Isla Santa Cruz (ECAYO)",
   label: "Puerto Ayora Isla Santa Cruz (ECAYO)"
  },
  {
   value: "Jable Las Palmas (Dupl. JAE) (ESJAP)",
   label: "Jable Las Palmas (Dupl. JAE) (ESJAP)"
  },
  {
   value: "Hofn Hornafjørdur \/APT (ISHFN)",
   label: "Hofn Hornafjørdur \/APT (ISHFN)"
  },
  {
   value: "Kirakira San Cristobal Is (SBIRA)",
   label: "Kirakira San Cristobal Is (SBIRA)"
  },
  {
   value: "TUGLAKABAD (TKD)",
   label: "TUGLAKABAD (TKD)"
  },
  {
   value: "Tuglakabad (INNDP1)",
   label: "Tuglakabad (INNDP1)"
  },
  {
   value: "Port Elizabeth (ZAPLZ)",
   label: "Port Elizabeth (ZAPLZ)"
  },
  {
   value: "Port Nolloth (ZANOL)",
   label: "Port Nolloth (ZANOL)"
  },
  {
   value: "Pretoria (ZAPRY)",
   label: "Pretoria (ZAPRY)"
  },
  {
   value: "Prospecton (ZAPTN)",
   label: "Prospecton (ZAPTN)"
  },
  {
   value: "Ramatlhabama (ZARMB)",
   label: "Ramatlhabama (ZARMB)"
  },
  {
   value: "Richards Bay (ZARCB)",
   label: "Richards Bay (ZARCB)"
  },
  {
   value: "Saldanha Bay (ZASDB)",
   label: "Saldanha Bay (ZASDB)"
  },
  {
   value: "Secunda (ZAZEC)",
   label: "Secunda (ZAZEC)"
  },
  {
   value: "Simonstown (ZASMN)",
   label: "Simonstown (ZASMN)"
  },
  {
   value: "Sishen (ZASIS)",
   label: "Sishen (ZASIS)"
  },
  {
   value: "Skukuza (ZASZK)",
   label: "Skukuza (ZASZK)"
  },
  {
   value: "Springbok (ZASBU)",
   label: "Springbok (ZASBU)"
  },
  {
   value: "Springs (ZASPR)",
   label: "Springs (ZASPR)"
  },
  {
   value: "Swellendam (ZASWE)",
   label: "Swellendam (ZASWE)"
  },
  {
   value: "Tzaneen (ZALTA)",
   label: "Tzaneen (ZALTA)"
  },
  {
   value: "Uitenhage (ZAUHG)",
   label: "Uitenhage (ZAUHG)"
  },
  {
   value: "Umtata (ZAUTT)",
   label: "Umtata (ZAUTT)"
  },
  {
   value: "Upington (ZAUTN)",
   label: "Upington (ZAUTN)"
  },
  {
   value: "Vredendal (ZAVRE)",
   label: "Vredendal (ZAVRE)"
  },
  {
   value: "Vryburg (ZAVRU)",
   label: "Vryburg (ZAVRU)"
  },
  {
   value: "Vryheid (ZAVYD)",
   label: "Vryheid (ZAVYD)"
  },
  {
   value: "Welkom (ZAWEL)",
   label: "Welkom (ZAWEL)"
  },
  {
   value: "Chachacha (ZMCHA)",
   label: "Chachacha (ZMCHA)"
  },
  {
   value: "Chipata (ZMCIP)",
   label: "Chipata (ZMCIP)"
  },
  {
   value: "Choma (ZMCHO)",
   label: "Choma (ZMCHO)"
  },
  {
   value: "Kabwe (ZMQKE)",
   label: "Kabwe (ZMQKE)"
  },
  {
   value: "Kafue (ZMKAF)",
   label: "Kafue (ZMKAF)"
  },
  {
   value: "Kalabo (ZMKLB)",
   label: "Kalabo (ZMKLB)"
  },
  {
   value: "Kalomo (ZMKAO)",
   label: "Kalomo (ZMKAO)"
  },
  {
   value: "Kasaba Bay (ZMZKB)",
   label: "Kasaba Bay (ZMZKB)"
  },
  {
   value: "Kasama (ZMKAA)",
   label: "Kasama (ZMKAA)"
  },
  {
   value: "Kitwe (ZMKIW)",
   label: "Kitwe (ZMKIW)"
  },
  {
   value: "Livingstone (ZMLVI)",
   label: "Livingstone (ZMLVI)"
  },
  {
   value: "Luanshya (ZMLUA)",
   label: "Luanshya (ZMLUA)"
  },
  {
   value: "Lukulu (ZMLXU)",
   label: "Lukulu (ZMLXU)"
  },
  {
   value: "Lumamba (ZMLUM)",
   label: "Lumamba (ZMLUM)"
  },
  {
   value: "Lusaka (ZMLUN)",
   label: "Lusaka (ZMLUN)"
  },
  {
   value: "Mansa (ZMMNS)",
   label: "Mansa (ZMMNS)"
  },
  {
   value: "Maramba (ZMMRB)",
   label: "Maramba (ZMMRB)"
  },
  {
   value: "Mfuwe (ZMMFU)",
   label: "Mfuwe (ZMMFU)"
  },
  {
   value: "Mongu (ZMMNR)",
   label: "Mongu (ZMMNR)"
  },
  {
   value: "Mufulira (ZMMFR)",
   label: "Mufulira (ZMMFR)"
  },
  {
   value: "Alexander Bay (ZAALJ)",
   label: "Alexander Bay (ZAALJ)"
  },
  {
   value: "Algoa Bay (ZAAOB)",
   label: "Algoa Bay (ZAAOB)"
  },
  {
   value: "Beit Bridge (ZABBR)",
   label: "Beit Bridge (ZABBR)"
  },
  {
   value: "Bloemfontein (ZABFN)",
   label: "Bloemfontein (ZABFN)"
  },
  {
   value: "Booysens (ZABYS)",
   label: "Booysens (ZABYS)"
  },
  {
   value: "Brakpan (ZABRK)",
   label: "Brakpan (ZABRK)"
  },
  {
   value: "Bronkhorstpruit (ZABHT)",
   label: "Bronkhorstpruit (ZABHT)"
  },
  {
   value: "Cape Town (ZACPT)",
   label: "Cape Town (ZACPT)"
  },
  {
   value: "City Deep (ZACTD)",
   label: "City Deep (ZACTD)"
  },
  {
   value: "Durban (ZADUR)",
   label: "Durban (ZADUR)"
  },
  {
   value: "East London (ZAELS)",
   label: "East London (ZAELS)"
  },
  {
   value: "Elandsfontein (ZAELA)",
   label: "Elandsfontein (ZAELA)"
  },
  {
   value: "Ficksburg (ZAFCB)",
   label: "Ficksburg (ZAFCB)"
  },
  {
   value: "Fordsburg (ZAFBG)",
   label: "Fordsburg (ZAFBG)"
  },
  {
   value: "George (ZAGRJ)",
   label: "George (ZAGRJ)"
  },
  {
   value: "Germiston (ZAGRM)",
   label: "Germiston (ZAGRM)"
  },
  {
   value: "Heidelberg (ZAHEI)",
   label: "Heidelberg (ZAHEI)"
  },
  {
   value: "Johannesburg (ZAJNB)",
   label: "Johannesburg (ZAJNB)"
  },
  {
   value: "Kempton Park (ZAKMP)",
   label: "Kempton Park (ZAKMP)"
  },
  {
   value: "Kimberley (ZAKIM)",
   label: "Kimberley (ZAKIM)"
  },
  {
   value: "Kleinzee (ZAKLZ)",
   label: "Kleinzee (ZAKLZ)"
  },
  {
   value: "Koinghaas (ZAKIG)",
   label: "Koinghaas (ZAKIG)"
  },
  {
   value: "Komatipoort (ZAKOF)",
   label: "Komatipoort (ZAKOF)"
  },
  {
   value: "Koster (ZAKST)",
   label: "Koster (ZAKST)"
  },
  {
   value: "Krugersdorp (ZAKDP)",
   label: "Krugersdorp (ZAKDP)"
  },
  {
   value: "Lanseria (ZAHLA)",
   label: "Lanseria (ZAHLA)"
  },
  {
   value: "Mafikeng (ZAMFK)",
   label: "Mafikeng (ZAMFK)"
  },
  {
   value: "Margate (ZAMGH)",
   label: "Margate (ZAMGH)"
  },
  {
   value: "Messina (ZAMEZ)",
   label: "Messina (ZAMEZ)"
  },
  {
   value: "Mmabatho (ZAMBD)",
   label: "Mmabatho (ZAMBD)"
  },
  {
   value: "Mossel Bay (ZAMZY)",
   label: "Mossel Bay (ZAMZY)"
  },
  {
   value: "Nelspruit (ZANLP)",
   label: "Nelspruit (ZANLP)"
  },
  {
   value: "Oshoek (ZAOSH)",
   label: "Oshoek (ZAOSH)"
  },
  {
   value: "Oudtshoorn (ZAOUH)",
   label: "Oudtshoorn (ZAOUH)"
  },
  {
   value: "Phalaborwa (ZAPHW)",
   label: "Phalaborwa (ZAPHW)"
  },
  {
   value: "Pietermaritzburg (ZAPZB)",
   label: "Pietermaritzburg (ZAPZB)"
  },
  {
   value: "Pietersburg (ZAPTG)",
   label: "Pietersburg (ZAPTG)"
  },
  {
   value: "Pinetown (ZAPNT)",
   label: "Pinetown (ZAPNT)"
  },
  {
   value: "Plettenberg Bay (ZAPBZ)",
   label: "Plettenberg Bay (ZAPBZ)"
  },
  {
   value: "Lawdar (YELAW)",
   label: "Lawdar (YELAW)"
  },
  {
   value: "Loheiya (YELOH)",
   label: "Loheiya (YELOH)"
  },
  {
   value: "Mareb (YEMYN)",
   label: "Mareb (YEMYN)"
  },
  {
   value: "Mokha (YEMOK)",
   label: "Mokha (YEMOK)"
  },
  {
   value: "Mukalla (YEMKX)",
   label: "Mukalla (YEMKX)"
  },
  {
   value: "Nishtun (YENIS)",
   label: "Nishtun (YENIS)"
  },
  {
   value: "Perim I. (YEPRM)",
   label: "Perim I. (YEPRM)"
  },
  {
   value: "Qishn (YEIHN)",
   label: "Qishn (YEIHN)"
  },
  {
   value: "Ras Al Kalib (YERAK)",
   label: "Ras Al Kalib (YERAK)"
  },
  {
   value: "Ras Isa Terminal (YERAI)",
   label: "Ras Isa Terminal (YERAI)"
  },
  {
   value: "Riyan Mukalla (YERIY)",
   label: "Riyan Mukalla (YERIY)"
  },
  {
   value: "Sadah (YESYE)",
   label: "Sadah (YESYE)"
  },
  {
   value: "Saleef Port (YESAL)",
   label: "Saleef Port (YESAL)"
  },
  {
   value: "Sana'a (YESAH)",
   label: "Sana'a (YESAH)"
  },
  {
   value: "Seiyun (YEGXF)",
   label: "Seiyun (YEGXF)"
  },
  {
   value: "Socotra I. (YESCT)",
   label: "Socotra I. (YESCT)"
  },
  {
   value: "Taiz (YETAI)",
   label: "Taiz (YETAI)"
  },
  {
   value: "Dzaoudzi (YTDZA)",
   label: "Dzaoudzi (YTDZA)"
  },
  {
   value: "Mamoudzou (YTMAM)",
   label: "Mamoudzou (YTMAM)"
  },
  {
   value: "Arilje (YUARJ)",
   label: "Arilje (YUARJ)"
  },
  {
   value: "Bakar (YUBAK)",
   label: "Bakar (YUBAK)"
  },
  {
   value: "Bar (YUBAR)",
   label: "Bar (YUBAR)"
  },
  {
   value: "Belgrade (Beograd) (YUBEG)",
   label: "Belgrade (Beograd) (YUBEG)"
  },
  {
   value: "Bijela (YUBIJ)",
   label: "Bijela (YUBIJ)"
  },
  {
   value: "Kikinda (YUKAY)",
   label: "Kikinda (YUKAY)"
  },
  {
   value: "Koprivnica (YUKOV)",
   label: "Koprivnica (YUKOV)"
  },
  {
   value: "Kotor (YUKOT)",
   label: "Kotor (YUKOT)"
  },
  {
   value: "Krang (YUKGY)",
   label: "Krang (YUKGY)"
  },
  {
   value: "Novi Sad (YUNVS)",
   label: "Novi Sad (YUNVS)"
  },
  {
   value: "Novo Mesto (YUNVJ)",
   label: "Novo Mesto (YUNVJ)"
  },
  {
   value: "Pancevo (YUPYJ)",
   label: "Pancevo (YUPYJ)"
  },
  {
   value: "Podgorica (YUTGD)",
   label: "Podgorica (YUTGD)"
  },
  {
   value: "Prilepa (YUPPJ)",
   label: "Prilepa (YUPPJ)"
  },
  {
   value: "Pristina (YUPRN)",
   label: "Pristina (YUPRN)"
  },
  {
   value: "Strumica (YUSTR)",
   label: "Strumica (YUSTR)"
  },
  {
   value: "Tihaljina (YUTJH)",
   label: "Tihaljina (YUTJH)"
  },
  {
   value: "Tivat (YUTIV)",
   label: "Tivat (YUTIV)"
  },
  {
   value: "Trzic (YUTZI)",
   label: "Trzic (YUTZI)"
  },
  {
   value: "Valjevo (YUVLJ)",
   label: "Valjevo (YUVLJ)"
  },
  {
   value: "Vinica (YUVNJ)",
   label: "Vinica (YUVNJ)"
  },
  {
   value: "Vranje (YUVRA)",
   label: "Vranje (YUVRA)"
  },
  {
   value: "Zelenika (YUZEL)",
   label: "Zelenika (YUZEL)"
  },
  {
   value: "Thanh Hoa (VNTHO)",
   label: "Thanh Hoa (VNTHO)"
  },
  {
   value: "Tuy Hoa (VNTBB)",
   label: "Tuy Hoa (VNTBB)"
  },
  {
   value: "Vinh (VNVNH)",
   label: "Vinh (VNVNH)"
  },
  {
   value: "Vinh Loi (VNVLO)",
   label: "Vinh Loi (VNVLO)"
  },
  {
   value: "Vung Tau (VNVUT)",
   label: "Vung Tau (VNVUT)"
  },
  {
   value: "Aneityum (VUAUY)",
   label: "Aneityum (VUAUY)"
  },
  {
   value: "Dillons Bay (VUDLY)",
   label: "Dillons Bay (VUDLY)"
  },
  {
   value: "Espiritu Santo (VUSON)",
   label: "Espiritu Santo (VUSON)"
  },
  {
   value: "Ipota (VUIPA)",
   label: "Ipota (VUIPA)"
  },
  {
   value: "Lamap (VULPM)",
   label: "Lamap (VULPM)"
  },
  {
   value: "Lamen Bay (VULNB)",
   label: "Lamen Bay (VULNB)"
  },
  {
   value: "Longana (VULOD)",
   label: "Longana (VULOD)"
  },
  {
   value: "Lonorore (VULNE)",
   label: "Lonorore (VULNE)"
  },
  {
   value: "Norsup (VUNUS)",
   label: "Norsup (VUNUS)"
  },
  {
   value: "Port Sandwich (VUPSA)",
   label: "Port Sandwich (VUPSA)"
  },
  {
   value: "Port Vila (VUVLI)",
   label: "Port Vila (VUVLI)"
  },
  {
   value: "Santo (VUSAN)",
   label: "Santo (VUSAN)"
  },
  {
   value: "Sola (VUSLH)",
   label: "Sola (VUSLH)"
  },
  {
   value: "Tanna (VUTAH)",
   label: "Tanna (VUTAH)"
  },
  {
   value: "Tongoa (VUTGH)",
   label: "Tongoa (VUTGH)"
  },
  {
   value: "Valesdir (VUVLS)",
   label: "Valesdir (VUVLS)"
  },
  {
   value: "Walaha (VUWLH)",
   label: "Walaha (VUWLH)"
  },
  {
   value: "Futuna Island (WFFUT)",
   label: "Futuna Island (WFFUT)"
  },
  {
   value: "Mata-Utu (WFMAU)",
   label: "Mata-Utu (WFMAU)"
  },
  {
   value: "Apia (WSAPW)",
   label: "Apia (WSAPW)"
  },
  {
   value: "Asau (WSAAU)",
   label: "Asau (WSAAU)"
  },
  {
   value: "Salelologa (WSSAL)",
   label: "Salelologa (WSSAL)"
  },
  {
   value: "Savaii (WSSAV)",
   label: "Savaii (WSSAV)"
  },
  {
   value: "\"Co-operation Zone A (AU (XZOCA)",
   label: "\"Co-operation Zone A (AU (XZOCA)"
  },
  {
   value: "Abbse (YEEAB)",
   label: "Abbse (YEEAB)"
  },
  {
   value: "Aden (YEADE)",
   label: "Aden (YEADE)"
  },
  {
   value: "Ahwar (YEAHW)",
   label: "Ahwar (YEAHW)"
  },
  {
   value: "Ash Shihr (YEASR)",
   label: "Ash Shihr (YEASR)"
  },
  {
   value: "Beihan (YEBHN)",
   label: "Beihan (YEBHN)"
  },
  {
   value: "Bogoa (YEBOG)",
   label: "Bogoa (YEBOG)"
  },
  {
   value: "El Katieb (YEELK)",
   label: "El Katieb (YEELK)"
  },
  {
   value: "Harad (YEHAR)",
   label: "Harad (YEHAR)"
  },
  {
   value: "Haura (YEHAU)",
   label: "Haura (YEHAU)"
  },
  {
   value: "Hodeidah (YEHOD)",
   label: "Hodeidah (YEHOD)"
  },
  {
   value: "Ibb (YEIBB)",
   label: "Ibb (YEIBB)"
  },
  {
   value: "Kamaran (YEKAM)",
   label: "Kamaran (YEKAM)"
  },
  {
   value: "Khokha (YEKHO)",
   label: "Khokha (YEKHO)"
  },
  {
   value: "\"Christiansted (VICTD)",
   label: "\"Christiansted (VICTD)"
  },
  {
   value: "Cruz Bay (VICZB)",
   label: "Cruz Bay (VICZB)"
  },
  {
   value: "\"Frederiksted (VIFRD)",
   label: "\"Frederiksted (VIFRD)"
  },
  {
   value: "Hovic (VIHOC)",
   label: "Hovic (VIHOC)"
  },
  {
   value: "Limetree Bay (VILIB)",
   label: "Limetree Bay (VILIB)"
  },
  {
   value: "St Croix Island (VISTX)",
   label: "St Croix Island (VISTX)"
  },
  {
   value: "St John (VISJN)",
   label: "St John (VISJN)"
  },
  {
   value: "St Thomas Island (VISTT)",
   label: "St Thomas Island (VISTT)"
  },
  {
   value: "Benthuy (VNBEN)",
   label: "Benthuy (VNBEN)"
  },
  {
   value: "Cam Pha (VNCPH)",
   label: "Cam Pha (VNCPH)"
  },
  {
   value: "Camranh (VNCRB)",
   label: "Camranh (VNCRB)"
  },
  {
   value: "Can Tho (VNVCA)",
   label: "Can Tho (VNVCA)"
  },
  {
   value: "Da Nang (VNDAD)",
   label: "Da Nang (VNDAD)"
  },
  {
   value: "Dong Hoi (VNDOH)",
   label: "Dong Hoi (VNDOH)"
  },
  {
   value: "Ha Tinh (VNHAT)",
   label: "Ha Tinh (VNHAT)"
  },
  {
   value: "Haiphong (VNHPH)",
   label: "Haiphong (VNHPH)"
  },
  {
   value: "Hanoi (VNHAN)",
   label: "Hanoi (VNHAN)"
  },
  {
   value: "Ho Chi Minh City (VNSGN)",
   label: "Ho Chi Minh City (VNSGN)"
  },
  {
   value: "Hoai An (VNHAA)",
   label: "Hoai An (VNHAA)"
  },
  {
   value: "Hoai Nhon (VNHNH)",
   label: "Hoai Nhon (VNHNH)"
  },
  {
   value: "Hoi An (VNHIA)",
   label: "Hoi An (VNHIA)"
  },
  {
   value: "Hon Chong (VNHCH)",
   label: "Hon Chong (VNHCH)"
  },
  {
   value: "Hongai (VNHON)",
   label: "Hongai (VNHON)"
  },
  {
   value: "Hue (VNHUI)",
   label: "Hue (VNHUI)"
  },
  {
   value: "Khonh Hung (VNKHU)",
   label: "Khonh Hung (VNKHU)"
  },
  {
   value: "Mong Cai (VNMOC)",
   label: "Mong Cai (VNMOC)"
  },
  {
   value: "My Tho (VNMUT)",
   label: "My Tho (VNMUT)"
  },
  {
   value: "Nam Dinh (VNNMD)",
   label: "Nam Dinh (VNNMD)"
  },
  {
   value: "Nghe Tinh (VNNGT)",
   label: "Nghe Tinh (VNNGT)"
  },
  {
   value: "Nha Trang (VNNHA)",
   label: "Nha Trang (VNNHA)"
  },
  {
   value: "Phan Rang (VNPHA)",
   label: "Phan Rang (VNPHA)"
  },
  {
   value: "Phan Thiet (VNPHH)",
   label: "Phan Thiet (VNPHH)"
  },
  {
   value: "Phu My (VNPHU)",
   label: "Phu My (VNPHU)"
  },
  {
   value: "Phuoe Le (VNPHL)",
   label: "Phuoe Le (VNPHL)"
  },
  {
   value: "Quang Long (VNQUL)",
   label: "Quang Long (VNQUL)"
  },
  {
   value: "Quang Ngai (VNXNG)",
   label: "Quang Ngai (VNXNG)"
  },
  {
   value: "Quang Tri (VNQUT)",
   label: "Quang Tri (VNQUT)"
  },
  {
   value: "Qui Nhon (VNUIH)",
   label: "Qui Nhon (VNUIH)"
  },
  {
   value: "Red Beach (VNRBE)",
   label: "Red Beach (VNRBE)"
  },
  {
   value: "Thang Binh (VNTBI)",
   label: "Thang Binh (VNTBI)"
  },
  {
   value: "Pamatacual (VEPAM)",
   label: "Pamatacual (VEPAM)"
  },
  {
   value: "Pampatar (VEPMP)",
   label: "Pampatar (VEPMP)"
  },
  {
   value: "Paradero (VEPAR)",
   label: "Paradero (VEPAR)"
  },
  {
   value: "Pertigalete (VEPRG)",
   label: "Pertigalete (VEPRG)"
  },
  {
   value: "Porlamar (VEPMV)",
   label: "Porlamar (VEPMV)"
  },
  {
   value: "Puerto Ayacucho (VEPYH)",
   label: "Puerto Ayacucho (VEPYH)"
  },
  {
   value: "Puerto Cabello (VEPBL)",
   label: "Puerto Cabello (VEPBL)"
  },
  {
   value: "Puerto de Hierro (VEPHO)",
   label: "Puerto de Hierro (VEPHO)"
  },
  {
   value: "Puerto La Cruz (VEPCZ)",
   label: "Puerto La Cruz (VEPCZ)"
  },
  {
   value: "Puerto Miranda\/Maracaibo L. (VEMIV)",
   label: "Puerto Miranda\/Maracaibo L. (VEMIV)"
  },
  {
   value: "Puerto Ordaz (VEPZO)",
   label: "Puerto Ordaz (VEPZO)"
  },
  {
   value: "Puerto Paez (VEPPZ)",
   label: "Puerto Paez (VEPPZ)"
  },
  {
   value: "Puerto Sucre (VEPSU)",
   label: "Puerto Sucre (VEPSU)"
  },
  {
   value: "Punta Camacho (VEPCA)",
   label: "Punta Camacho (VEPCA)"
  },
  {
   value: "Punta Cardon (VEPCN)",
   label: "Punta Cardon (VEPCN)"
  },
  {
   value: "Punta Cuchillo (VEPCU)",
   label: "Punta Cuchillo (VEPCU)"
  },
  {
   value: "Punta de Palmas (VEPLV)",
   label: "Punta de Palmas (VEPLV)"
  },
  {
   value: "Punta de Piedra (VEPPD)",
   label: "Punta de Piedra (VEPPD)"
  },
  {
   value: "Punto Fijo (VEPFI)",
   label: "Punto Fijo (VEPFI)"
  },
  {
   value: "Quanta (VEQAA)",
   label: "Quanta (VEQAA)"
  },
  {
   value: "San Antonio (VESVZ)",
   label: "San Antonio (VESVZ)"
  },
  {
   value: "San Carlos (VESCA)",
   label: "San Carlos (VESCA)"
  },
  {
   value: "San Felipe (VESNF)",
   label: "San Felipe (VESNF)"
  },
  {
   value: "San Félix (VESFX)",
   label: "San Félix (VESFX)"
  },
  {
   value: "San Fernando de Apure (VESFD)",
   label: "San Fernando de Apure (VESFD)"
  },
  {
   value: "San Lorenzo\/Maracaibo L (VESLV)",
   label: "San Lorenzo\/Maracaibo L (VESLV)"
  },
  {
   value: "San Tome (VESOM)",
   label: "San Tome (VESOM)"
  },
  {
   value: "Santa Barbara Ed (VESTB)",
   label: "Santa Barbara Ed (VESTB)"
  },
  {
   value: "Santo Domingo (VESTD)",
   label: "Santo Domingo (VESTD)"
  },
  {
   value: "Tia Juana\/Maracaibo L (VETJV)",
   label: "Tia Juana\/Maracaibo L (VETJV)"
  },
  {
   value: "Turiamo (VETUR)",
   label: "Turiamo (VETUR)"
  },
  {
   value: "Valera (VEVLV)",
   label: "Valera (VEVLV)"
  },
  {
   value: "\"Beef Island (VGEIS)",
   label: "\"Beef Island (VGEIS)"
  },
  {
   value: "\"Road Town (VGRAD)",
   label: "\"Road Town (VGRAD)"
  },
  {
   value: "Tortola (VGTOV)",
   label: "Tortola (VGTOV)"
  },
  {
   value: "Virgin Gorda (VGVIJ)",
   label: "Virgin Gorda (VGVIJ)"
  },
  {
   value: "\"Charlotte Amalie (VICHA)",
   label: "\"Charlotte Amalie (VICHA)"
  },
  {
   value: "Cabimas\/Maracaibo L (VECBS)",
   label: "Cabimas\/Maracaibo L (VECBS)"
  },
  {
   value: "Caicara de Orinoco (VECXA)",
   label: "Caicara de Orinoco (VECXA)"
  },
  {
   value: "Canaima (VECAJ)",
   label: "Canaima (VECAJ)"
  },
  {
   value: "Caracas (VECCS)",
   label: "Caracas (VECCS)"
  },
  {
   value: "Caripito (VECAR)",
   label: "Caripito (VECAR)"
  },
  {
   value: "Carupano (VECUP)",
   label: "Carupano (VECUP)"
  },
  {
   value: "Catia La Mar (VECLM)",
   label: "Catia La Mar (VECLM)"
  },
  {
   value: "Chichiriviche (VECHV)",
   label: "Chichiriviche (VECHV)"
  },
  {
   value: "Ciudad Bolivar (VECBL)",
   label: "Ciudad Bolivar (VECBL)"
  },
  {
   value: "Ciudad Guayana (VECGU)",
   label: "Ciudad Guayana (VECGU)"
  },
  {
   value: "Coloncha (VECOL)",
   label: "Coloncha (VECOL)"
  },
  {
   value: "Coro (VECZE)",
   label: "Coro (VECZE)"
  },
  {
   value: "Cumana (VECUM)",
   label: "Cumana (VECUM)"
  },
  {
   value: "Cumarebo (VECMR)",
   label: "Cumarebo (VECMR)"
  },
  {
   value: "El Guamache (VEEGU)",
   label: "El Guamache (VEEGU)"
  },
  {
   value: "El Palito (VEELP)",
   label: "El Palito (VEELP)"
  },
  {
   value: "El Tablazo\/Maracaibo L (VEETV)",
   label: "El Tablazo\/Maracaibo L (VEETV)"
  },
  {
   value: "Guanare (VEGUQ)",
   label: "Guanare (VEGUQ)"
  },
  {
   value: "Guanta (VEGUT)",
   label: "Guanta (VEGUT)"
  },
  {
   value: "Guaranao Bay (VEGUB)",
   label: "Guaranao Bay (VEGUB)"
  },
  {
   value: "Guiria (VEGUI)",
   label: "Guiria (VEGUI)"
  },
  {
   value: "José Maria Vargas (VEJMV)",
   label: "José Maria Vargas (VEJMV)"
  },
  {
   value: "La Ceiba\/Maracaibo L (VELCV)",
   label: "La Ceiba\/Maracaibo L (VELCV)"
  },
  {
   value: "La Estacada (VELEC)",
   label: "La Estacada (VELEC)"
  },
  {
   value: "La Fria (VELFR)",
   label: "La Fria (VELFR)"
  },
  {
   value: "La Guaira (VELAG)",
   label: "La Guaira (VELAG)"
  },
  {
   value: "La Salina\/Maracaibo L (VELSV)",
   label: "La Salina\/Maracaibo L (VELSV)"
  },
  {
   value: "La Vela de Coro (VELVL)",
   label: "La Vela de Coro (VELVL)"
  },
  {
   value: "Lagunillas (VELGY)",
   label: "Lagunillas (VELGY)"
  },
  {
   value: "Lama (VELAM)",
   label: "Lama (VELAM)"
  },
  {
   value: "Las Piedras (VELSP)",
   label: "Las Piedras (VELSP)"
  },
  {
   value: "Maiqueta (VEMAI)",
   label: "Maiqueta (VEMAI)"
  },
  {
   value: "Maracaibo (VEMAR)",
   label: "Maracaibo (VEMAR)"
  },
  {
   value: "Margarita (VEMGT)",
   label: "Margarita (VEMGT)"
  },
  {
   value: "Matanzas (VEMTV)",
   label: "Matanzas (VEMTV)"
  },
  {
   value: "Maturin (VEMUN)",
   label: "Maturin (VEMUN)"
  },
  {
   value: "Merida (VEMRD)",
   label: "Merida (VEMRD)"
  },
  {
   value: "Palmarejo\/Maracaibo L. (VEPMR)",
   label: "Palmarejo\/Maracaibo L. (VEPMR)"
  },
  {
   value: "Palua (VEPLA)",
   label: "Palua (VEPLA)"
  },
  {
   value: "Melo (UYMLZ)",
   label: "Melo (UYMLZ)"
  },
  {
   value: "Mercedes (UYMER)",
   label: "Mercedes (UYMER)"
  },
  {
   value: "Minas (UYMIN)",
   label: "Minas (UYMIN)"
  },
  {
   value: "Montevideo (UYMVD)",
   label: "Montevideo (UYMVD)"
  },
  {
   value: "Nueva Palmira (UYNVP)",
   label: "Nueva Palmira (UYNVP)"
  },
  {
   value: "Pando (UYPDO)",
   label: "Pando (UYPDO)"
  },
  {
   value: "Paysandu (UYPDU)",
   label: "Paysandu (UYPDU)"
  },
  {
   value: "Punta del Este (UYPDP)",
   label: "Punta del Este (UYPDP)"
  },
  {
   value: "Rivera (UYRVY)",
   label: "Rivera (UYRVY)"
  },
  {
   value: "Rocha (UYRCH)",
   label: "Rocha (UYRCH)"
  },
  {
   value: "Salto (UYSTY)",
   label: "Salto (UYSTY)"
  },
  {
   value: "San José (UYSJS)",
   label: "San José (UYSJS)"
  },
  {
   value: "San José de Carrasco (UYSJC)",
   label: "San José de Carrasco (UYSJC)"
  },
  {
   value: "Solymar (UYSYM)",
   label: "Solymar (UYSYM)"
  },
  {
   value: "Tacuarembo (UYTAW)",
   label: "Tacuarembo (UYTAW)"
  },
  {
   value: "Treinta y Tres (UYTYT)",
   label: "Treinta y Tres (UYTYT)"
  },
  {
   value: "Trinidad (UYTRI)",
   label: "Trinidad (UYTRI)"
  },
  {
   value: "Vichadero (UYVCH)",
   label: "Vichadero (UYVCH)"
  },
  {
   value: "Almalyk (UZALK)",
   label: "Almalyk (UZALK)"
  },
  {
   value: "Bukhara (UZBHK)",
   label: "Bukhara (UZBHK)"
  },
  {
   value: "Fergana (UZFEG)",
   label: "Fergana (UZFEG)"
  },
  {
   value: "Samarkand (UZSKD)",
   label: "Samarkand (UZSKD)"
  },
  {
   value: "Tashkent (UZTAS)",
   label: "Tashkent (UZTAS)"
  },
  {
   value: "Urgench (UZUGC)",
   label: "Urgench (UZUGC)"
  },
  {
   value: "Vatican City (VAVAT)",
   label: "Vatican City (VAVAT)"
  },
  {
   value: "\"Kingstown (VCKTN)",
   label: "\"Kingstown (VCKTN)"
  },
  {
   value: "Mustique Island (VCMQS)",
   label: "Mustique Island (VCMQS)"
  },
  {
   value: "\"Port Elisabeth (VCBQU)",
   label: "\"Port Elisabeth (VCBQU)"
  },
  {
   value: "St Vincent (VCSVD)",
   label: "St Vincent (VCSVD)"
  },
  {
   value: "Union Island (VCUNI)",
   label: "Union Island (VCUNI)"
  },
  {
   value: "Acarigua (VEAGV)",
   label: "Acarigua (VEAGV)"
  },
  {
   value: "Amuay (VEAMY)",
   label: "Amuay (VEAMY)"
  },
  {
   value: "Anaco (VEAAO)",
   label: "Anaco (VEAAO)"
  },
  {
   value: "Araya (VEARA)",
   label: "Araya (VEARA)"
  },
  {
   value: "Bachaquero\/Maracaibo L (VEBAV)",
   label: "Bachaquero\/Maracaibo L (VEBAV)"
  },
  {
   value: "Bajo Grande\/Maracaibo L (VEBJV)",
   label: "Bajo Grande\/Maracaibo L (VEBJV)"
  },
  {
   value: "Barcelona (VEBLA)",
   label: "Barcelona (VEBLA)"
  },
  {
   value: "Barinas (VEBNS)",
   label: "Barinas (VEBNS)"
  },
  {
   value: "Barquisimeto (VEBRM)",
   label: "Barquisimeto (VEBRM)"
  },
  {
   value: "Forest View (USFTW)",
   label: "Forest View (USFTW)"
  },
  {
   value: "Fort Worth (USFWT)",
   label: "Fort Worth (USFWT)"
  },
  {
   value: "Franklin Lakes (USFRL)",
   label: "Franklin Lakes (USFRL)"
  },
  {
   value: "Glenolden (USGNE)",
   label: "Glenolden (USGNE)"
  },
  {
   value: "Hampshire (USHPS)",
   label: "Hampshire (USHPS)"
  },
  {
   value: "Hendersonville (USHVE)",
   label: "Hendersonville (USHVE)"
  },
  {
   value: "Hutchinson (USHCH)",
   label: "Hutchinson (USHCH)"
  },
  {
   value: "Ivoryton (USIYN)",
   label: "Ivoryton (USIYN)"
  },
  {
   value: "Lake Forest (USLFC)",
   label: "Lake Forest (USLFC)"
  },
  {
   value: "Lynn (USLZN)",
   label: "Lynn (USLZN)"
  },
  {
   value: "Miamiville (USMAM)",
   label: "Miamiville (USMAM)"
  },
  {
   value: "Middleton (USMYN)",
   label: "Middleton (USMYN)"
  },
  {
   value: "Minneapolis (USMES)",
   label: "Minneapolis (USMES)"
  },
  {
   value: "New Port Richey (USNRH)",
   label: "New Port Richey (USNRH)"
  },
  {
   value: "Parma (USPAM)",
   label: "Parma (USPAM)"
  },
  {
   value: "Saint James (USTJS)",
   label: "Saint James (USTJS)"
  },
  {
   value: "Southwick (USSZW)",
   label: "Southwick (USSZW)"
  },
  {
   value: "Vance (USVCE)",
   label: "Vance (USVCE)"
  },
  {
   value: "West Des Moines (USWEM)",
   label: "West Des Moines (USWEM)"
  },
  {
   value: "West Hartford (USWHF)",
   label: "West Hartford (USWHF)"
  },
  {
   value: "Weston (USWSC)",
   label: "Weston (USWSC)"
  },
  {
   value: "Windsor Locks (USWLC)",
   label: "Windsor Locks (USWLC)"
  },
  {
   value: "Winsted (USWNS)",
   label: "Winsted (USWNS)"
  },
  {
   value: "Woodlawn (USWON)",
   label: "Woodlawn (USWON)"
  },
  {
   value: "Carlsbad (USCLD)",
   label: "Carlsbad (USCLD)"
  },
  {
   value: "Artigas (UYATI)",
   label: "Artigas (UYATI)"
  },
  {
   value: "Bella Union (UYBUV)",
   label: "Bella Union (UYBUV)"
  },
  {
   value: "Canelones (UYCAN)",
   label: "Canelones (UYCAN)"
  },
  {
   value: "Carmelo (UYCAR)",
   label: "Carmelo (UYCAR)"
  },
  {
   value: "Chuy (UYCHY)",
   label: "Chuy (UYCHY)"
  },
  {
   value: "Colonia (UYCYR)",
   label: "Colonia (UYCYR)"
  },
  {
   value: "Colonia del Sacramento (UYCDS)",
   label: "Colonia del Sacramento (UYCDS)"
  },
  {
   value: "Colonia Suiza (UYCLZ)",
   label: "Colonia Suiza (UYCLZ)"
  },
  {
   value: "Durazno (UYDZO)",
   label: "Durazno (UYDZO)"
  },
  {
   value: "Florida (UYFDA)",
   label: "Florida (UYFDA)"
  },
  {
   value: "Fray Bentos (UYFZB)",
   label: "Fray Bentos (UYFZB)"
  },
  {
   value: "Jose Ignacio Terminal (UYJIT)",
   label: "Jose Ignacio Terminal (UYJIT)"
  },
  {
   value: "La Paloma\/Rocha (UYLAP)",
   label: "La Paloma\/Rocha (UYLAP)"
  },
  {
   value: "La Paz (UYLPZ)",
   label: "La Paz (UYLPZ)"
  },
  {
   value: "Lagomar (UYLAG)",
   label: "Lagomar (UYLAG)"
  },
  {
   value: "Las Piedras (UYLPS)",
   label: "Las Piedras (UYLPS)"
  },
  {
   value: "Maldonado (UYMDO)",
   label: "Maldonado (UYMDO)"
  },
  {
   value: "York (USTHV)",
   label: "York (USTHV)"
  },
  {
   value: "Yorklyn (USYRL)",
   label: "Yorklyn (USYRL)"
  },
  {
   value: "Yorktown (USYRT)",
   label: "Yorktown (USYRT)"
  },
  {
   value: "Yorktown (USYKW)",
   label: "Yorktown (USYKW)"
  },
  {
   value: "Yorktown Heights (USYKH)",
   label: "Yorktown Heights (USYKH)"
  },
  {
   value: "Yorkville (USYRV)",
   label: "Yorkville (USYRV)"
  },
  {
   value: "Youngsville (USYGV)",
   label: "Youngsville (USYGV)"
  },
  {
   value: "Youngsville (USYOU)",
   label: "Youngsville (USYOU)"
  },
  {
   value: "Youngwood (USYGW)",
   label: "Youngwood (USYGW)"
  },
  {
   value: "Yountville (USYTV)",
   label: "Yountville (USYTV)"
  },
  {
   value: "Ypsilanti (USYPS)",
   label: "Ypsilanti (USYPS)"
  },
  {
   value: "Yuba City (USYUB)",
   label: "Yuba City (USYUB)"
  },
  {
   value: "Yucaipa (USYUC)",
   label: "Yucaipa (USYUC)"
  },
  {
   value: "Yulee (USYUL)",
   label: "Yulee (USYUL)"
  },
  {
   value: "Yuma (USYUM)",
   label: "Yuma (USYUM)"
  },
  {
   value: "Zachar Bay (USKZB)",
   label: "Zachar Bay (USKZB)"
  },
  {
   value: "Zachary (USZQK)",
   label: "Zachary (USZQK)"
  },
  {
   value: "Zanesville (USZZV)",
   label: "Zanesville (USZZV)"
  },
  {
   value: "Zebulon (USZBL)",
   label: "Zebulon (USZBL)"
  },
  {
   value: "Zeeland (USZLD)",
   label: "Zeeland (USZLD)"
  },
  {
   value: "Zelienople (USZEL)",
   label: "Zelienople (USZEL)"
  },
  {
   value: "Zellwood (USZWD)",
   label: "Zellwood (USZWD)"
  },
  {
   value: "Zephyr Cove (USZFC)",
   label: "Zephyr Cove (USZFC)"
  },
  {
   value: "Zieglerville (USZGL)",
   label: "Zieglerville (USZGL)"
  },
  {
   value: "Zillah (USZIL)",
   label: "Zillah (USZIL)"
  },
  {
   value: "Zimmerman (USZIE)",
   label: "Zimmerman (USZIE)"
  },
  {
   value: "Zion (USZIO)",
   label: "Zion (USZIO)"
  },
  {
   value: "Zionsville (USZYV)",
   label: "Zionsville (USZYV)"
  },
  {
   value: "Albion (USALI)",
   label: "Albion (USALI)"
  },
  {
   value: "Big Pine Key (USBPY)",
   label: "Big Pine Key (USBPY)"
  },
  {
   value: "Bunn (USBNY)",
   label: "Bunn (USBNY)"
  },
  {
   value: "Cary (USAYI)",
   label: "Cary (USAYI)"
  },
  {
   value: "Chittenango (USCGO)",
   label: "Chittenango (USCGO)"
  },
  {
   value: "Clearwater (USCWR)",
   label: "Clearwater (USCWR)"
  },
  {
   value: "Dallas (USDAL)",
   label: "Dallas (USDAL)"
  },
  {
   value: "Diamond (USDMD)",
   label: "Diamond (USDMD)"
  },
  {
   value: "East Longmeadow (USETL)",
   label: "East Longmeadow (USETL)"
  },
  {
   value: "East Windsor (USEWO)",
   label: "East Windsor (USEWO)"
  },
  {
   value: "Ely (USLYU)",
   label: "Ely (USLYU)"
  },
  {
   value: "Embarkadero San Fransisco (USEMB)",
   label: "Embarkadero San Fransisco (USEMB)"
  },
  {
   value: "Essex (USEEX)",
   label: "Essex (USEEX)"
  },
  {
   value: "Fergus Falls (USFFM)",
   label: "Fergus Falls (USFFM)"
  },
  {
   value: "Worcester (USORH)",
   label: "Worcester (USORH)"
  },
  {
   value: "Worland (USWRL)",
   label: "Worland (USWRL)"
  },
  {
   value: "Worth (USWRI)",
   label: "Worth (USWRI)"
  },
  {
   value: "Wortham (USWRX)",
   label: "Wortham (USWRX)"
  },
  {
   value: "Worthington (USOTG)",
   label: "Worthington (USOTG)"
  },
  {
   value: "Worthington (USWGH)",
   label: "Worthington (USWGH)"
  },
  {
   value: "Wrangell (USWRG)",
   label: "Wrangell (USWRG)"
  },
  {
   value: "Wrens (USUZM)",
   label: "Wrens (USUZM)"
  },
  {
   value: "Wright City (USWCU)",
   label: "Wright City (USWCU)"
  },
  {
   value: "Wrightstown (USWGZ)",
   label: "Wrightstown (USWGZ)"
  },
  {
   value: "Wrightsville (USXOG)",
   label: "Wrightsville (USXOG)"
  },
  {
   value: "Wrightwood (USWNW)",
   label: "Wrightwood (USWNW)"
  },
  {
   value: "Wyalusing (USWYC)",
   label: "Wyalusing (USWYC)"
  },
  {
   value: "Wyandancot (USWYY)",
   label: "Wyandancot (USWYY)"
  },
  {
   value: "Wyandotte (USWYD)",
   label: "Wyandotte (USWYD)"
  },
  {
   value: "Wyemills (USWYI)",
   label: "Wyemills (USWYI)"
  },
  {
   value: "Wylie (USWYH)",
   label: "Wylie (USWYH)"
  },
  {
   value: "Wynne (USWYQ)",
   label: "Wynne (USWYQ)"
  },
  {
   value: "Wyoming (USWYW)",
   label: "Wyoming (USWYW)"
  },
  {
   value: "Wyoming (USWVX)",
   label: "Wyoming (USWVX)"
  },
  {
   value: "Wyoming (USWYM)",
   label: "Wyoming (USWYM)"
  },
  {
   value: "Wyoming (USWYP)",
   label: "Wyoming (USWYP)"
  },
  {
   value: "Wyomissing (USWGP)",
   label: "Wyomissing (USWGP)"
  },
  {
   value: "Wyona (USWYZ)",
   label: "Wyona (USWYZ)"
  },
  {
   value: "Wytheville (USWEV)",
   label: "Wytheville (USWEV)"
  },
  {
   value: "Xenia (USXOL)",
   label: "Xenia (USXOL)"
  },
  {
   value: "Yadkinville (USYAD)",
   label: "Yadkinville (USYAD)"
  },
  {
   value: "Yahala (USYAH)",
   label: "Yahala (USYAH)"
  },
  {
   value: "Yakima (USYKM)",
   label: "Yakima (USYKM)"
  },
  {
   value: "Yakutat (USYAK)",
   label: "Yakutat (USYAK)"
  },
  {
   value: "Yamhill (USYHJ)",
   label: "Yamhill (USYHJ)"
  },
  {
   value: "Yankton (USYKN)",
   label: "Yankton (USYKN)"
  },
  {
   value: "Yaphank (USYNK)",
   label: "Yaphank (USYNK)"
  },
  {
   value: "Yardville (USYDV)",
   label: "Yardville (USYDV)"
  },
  {
   value: "Yarmouth (USYAR)",
   label: "Yarmouth (USYAR)"
  },
  {
   value: "Yellville (USYEL)",
   label: "Yellville (USYEL)"
  },
  {
   value: "Yerington (USEYR)",
   label: "Yerington (USEYR)"
  },
  {
   value: "Yonkers (USYON)",
   label: "Yonkers (USYON)"
  },
  {
   value: "Yorba Linda (USYBL)",
   label: "Yorba Linda (USYBL)"
  },
  {
   value: "York (USYRK)",
   label: "York (USYRK)"
  },
  {
   value: "York (USYOR)",
   label: "York (USYOR)"
  },
  {
   value: "York (USYRN)",
   label: "York (USYRN)"
  },
  {
   value: "Wittmann (USWTJ)",
   label: "Wittmann (USWTJ)"
  },
  {
   value: "Wixom (USWIX)",
   label: "Wixom (USWIX)"
  },
  {
   value: "Woburn (USWBN)",
   label: "Woburn (USWBN)"
  },
  {
   value: "Womelsdorf (USWDF)",
   label: "Womelsdorf (USWDF)"
  },
  {
   value: "Wood Dale (USWDD)",
   label: "Wood Dale (USWDD)"
  },
  {
   value: "Wood River (USWRV)",
   label: "Wood River (USWRV)"
  },
  {
   value: "Wood Village (USWUV)",
   label: "Wood Village (USWUV)"
  },
  {
   value: "Wood-Ridge (USWOD)",
   label: "Wood-Ridge (USWOD)"
  },
  {
   value: "Woodale (USWDL)",
   label: "Woodale (USWDL)"
  },
  {
   value: "Woodbridge (USWOO)",
   label: "Woodbridge (USWOO)"
  },
  {
   value: "Woodbridge (USWBX)",
   label: "Woodbridge (USWBX)"
  },
  {
   value: "Woodburn (USWUB)",
   label: "Woodburn (USWUB)"
  },
  {
   value: "Woodburn (USWBJ)",
   label: "Woodburn (USWBJ)"
  },
  {
   value: "Woodbury (USXNO)",
   label: "Woodbury (USXNO)"
  },
  {
   value: "Woodbury (USWDY)",
   label: "Woodbury (USWDY)"
  },
  {
   value: "Woodbury (USWOJ)",
   label: "Woodbury (USWOJ)"
  },
  {
   value: "Woodinville (USWDV)",
   label: "Woodinville (USWDV)"
  },
  {
   value: "Woodlake (USWUL)",
   label: "Woodlake (USWUL)"
  },
  {
   value: "Woodland (USWOA)",
   label: "Woodland (USWOA)"
  },
  {
   value: "Woodland (USWUX)",
   label: "Woodland (USWUX)"
  },
  {
   value: "Woodland (USWDQ)",
   label: "Woodland (USWDQ)"
  },
  {
   value: "Woodland Hills (USWPD)",
   label: "Woodland Hills (USWPD)"
  },
  {
   value: "Woodlawn (USWDI)",
   label: "Woodlawn (USWDI)"
  },
  {
   value: "Woodridge (USWOQ)",
   label: "Woodridge (USWOQ)"
  },
  {
   value: "Woodridge (USWRQ)",
   label: "Woodridge (USWRQ)"
  },
  {
   value: "Woodridge (USUZI)",
   label: "Woodridge (USUZI)"
  },
  {
   value: "Woods Hole (USWOH)",
   label: "Woods Hole (USWOH)"
  },
  {
   value: "Woods Mill (USXNY)",
   label: "Woods Mill (USXNY)"
  },
  {
   value: "Woodside (USWOS)",
   label: "Woodside (USWOS)"
  },
  {
   value: "Woodson Terrace\/St Louis (USWTR)",
   label: "Woodson Terrace\/St Louis (USWTR)"
  },
  {
   value: "Woodstock (USWDS)",
   label: "Woodstock (USWDS)"
  },
  {
   value: "Woodstock (USWOY)",
   label: "Woodstock (USWOY)"
  },
  {
   value: "Woodstock (USWOZ)",
   label: "Woodstock (USWOZ)"
  },
  {
   value: "Woodstock (USWDK)",
   label: "Woodstock (USWDK)"
  },
  {
   value: "Woodstock (USWUD)",
   label: "Woodstock (USWUD)"
  },
  {
   value: "Woodsville (USWOE)",
   label: "Woodsville (USWOE)"
  },
  {
   value: "Woodward (USWWR)",
   label: "Woodward (USWWR)"
  },
  {
   value: "Woodway (USWUF)",
   label: "Woodway (USWUF)"
  },
  {
   value: "Woonsocket (USSFN)",
   label: "Woonsocket (USSFN)"
  },
  {
   value: "Wooster (USBJJ)",
   label: "Wooster (USBJJ)"
  },
  {
   value: "Winchester (USWCH)",
   label: "Winchester (USWCH)"
  },
  {
   value: "Winchester (USWCS)",
   label: "Winchester (USWCS)"
  },
  {
   value: "Winchester (USWFZ)",
   label: "Winchester (USWFZ)"
  },
  {
   value: "Windber (USWID)",
   label: "Windber (USWID)"
  },
  {
   value: "Windcap (USXNQ)",
   label: "Windcap (USXNQ)"
  },
  {
   value: "Winder (USWDR)",
   label: "Winder (USWDR)"
  },
  {
   value: "Windermere (USWMY)",
   label: "Windermere (USWMY)"
  },
  {
   value: "Windgap (USWNG)",
   label: "Windgap (USWNG)"
  },
  {
   value: "Windom (USMWM)",
   label: "Windom (USMWM)"
  },
  {
   value: "Windsor (USXOC)",
   label: "Windsor (USXOC)"
  },
  {
   value: "Windsor (USWOX)",
   label: "Windsor (USWOX)"
  },
  {
   value: "Windsor (USWSR)",
   label: "Windsor (USWSR)"
  },
  {
   value: "Windsor (USWND)",
   label: "Windsor (USWND)"
  },
  {
   value: "Windsor (USWNJ)",
   label: "Windsor (USWNJ)"
  },
  {
   value: "Windsor (USXNS)",
   label: "Windsor (USXNS)"
  },
  {
   value: "Windsor (USWIV)",
   label: "Windsor (USWIV)"
  },
  {
   value: "Windsor Locks-Hartford Apt (USBDL)",
   label: "Windsor Locks-Hartford Apt (USBDL)"
  },
  {
   value: "Winfield (USWLD)",
   label: "Winfield (USWLD)"
  },
  {
   value: "Winfield (USINK)",
   label: "Winfield (USINK)"
  },
  {
   value: "Winfield (USWIF)",
   label: "Winfield (USWIF)"
  },
  {
   value: "Winlock (USWQW)",
   label: "Winlock (USWQW)"
  },
  {
   value: "Winnemucca (USWMC)",
   label: "Winnemucca (USWMC)"
  },
  {
   value: "Winnsboro (USWBO)",
   label: "Winnsboro (USWBO)"
  },
  {
   value: "Winnsboro (USWYL)",
   label: "Winnsboro (USWYL)"
  },
  {
   value: "Winnsboro (USWNB)",
   label: "Winnsboro (USWNB)"
  },
  {
   value: "Winona (USONA)",
   label: "Winona (USONA)"
  },
  {
   value: "Winslow (USWSE)",
   label: "Winslow (USWSE)"
  },
  {
   value: "Winsted (USWJN)",
   label: "Winsted (USWJN)"
  },
  {
   value: "Winston (USWSN)",
   label: "Winston (USWSN)"
  },
  {
   value: "Winston-Salem (USINT)",
   label: "Winston-Salem (USINT)"
  },
  {
   value: "Winter Garden (USWTG)",
   label: "Winter Garden (USWTG)"
  },
  {
   value: "Winter Haven (USGIF)",
   label: "Winter Haven (USGIF)"
  },
  {
   value: "Winter Park (USWPK)",
   label: "Winter Park (USWPK)"
  },
  {
   value: "Winterport (USWIE)",
   label: "Winterport (USWIE)"
  },
  {
   value: "Winthrop (USWIG)",
   label: "Winthrop (USWIG)"
  },
  {
   value: "Winthrop Harbor (USWPX)",
   label: "Winthrop Harbor (USWPX)"
  },
  {
   value: "Winton (USWXZ)",
   label: "Winton (USWXZ)"
  },
  {
   value: "Wiscasset (USISS)",
   label: "Wiscasset (USISS)"
  },
  {
   value: "Wisconsin Rapids (USISW)",
   label: "Wisconsin Rapids (USISW)"
  },
  {
   value: "Wissahickon (USWIZ)",
   label: "Wissahickon (USWIZ)"
  },
  {
   value: "Williamsport (USIPT)",
   label: "Williamsport (USIPT)"
  },
  {
   value: "Williamston (USWQX)",
   label: "Williamston (USWQX)"
  },
  {
   value: "Williamstown (USWZP)",
   label: "Williamstown (USWZP)"
  },
  {
   value: "Williamstown (USWMS)",
   label: "Williamstown (USWMS)"
  },
  {
   value: "Williamstown (USWZJ)",
   label: "Williamstown (USWZJ)"
  },
  {
   value: "Willingboro (USWLO)",
   label: "Willingboro (USWLO)"
  },
  {
   value: "Willis (USWYX)",
   label: "Willis (USWYX)"
  },
  {
   value: "Williston (USWIT)",
   label: "Williston (USWIT)"
  },
  {
   value: "Williston (USUZN)",
   label: "Williston (USUZN)"
  },
  {
   value: "Williston (USWIL)",
   label: "Williston (USWIL)"
  },
  {
   value: "Willits (USWZI)",
   label: "Willits (USWZI)"
  },
  {
   value: "Willmar (USILL)",
   label: "Willmar (USILL)"
  },
  {
   value: "Willoughby (USLNN)",
   label: "Willoughby (USLNN)"
  },
  {
   value: "Willow (USWOW)",
   label: "Willow (USWOW)"
  },
  {
   value: "Willow Brook (USWLB)",
   label: "Willow Brook (USWLB)"
  },
  {
   value: "Willow Grove (USNXX)",
   label: "Willow Grove (USNXX)"
  },
  {
   value: "Willow Island (USWWY)",
   label: "Willow Island (USWWY)"
  },
  {
   value: "Willow Springs (USWZG)",
   label: "Willow Springs (USWZG)"
  },
  {
   value: "Willow Wood (USWIW)",
   label: "Willow Wood (USWIW)"
  },
  {
   value: "Willowbrook (USWVW)",
   label: "Willowbrook (USWVW)"
  },
  {
   value: "Willowbrook (USXNZ)",
   label: "Willowbrook (USXNZ)"
  },
  {
   value: "Wills Point (USWIP)",
   label: "Wills Point (USWIP)"
  },
  {
   value: "Willsboro (USWSI)",
   label: "Willsboro (USWSI)"
  },
  {
   value: "Wilmington (USILN)",
   label: "Wilmington (USILN)"
  },
  {
   value: "Wilmington (USILM)",
   label: "Wilmington (USILM)"
  },
  {
   value: "Wilmington (USWOM)",
   label: "Wilmington (USWOM)"
  },
  {
   value: "Wilmington (USWQG)",
   label: "Wilmington (USWQG)"
  },
  {
   value: "Wilmington (USWTN)",
   label: "Wilmington (USWTN)"
  },
  {
   value: "Wilmington (USILG)",
   label: "Wilmington (USILG)"
  },
  {
   value: "Wilson (USWIQ)",
   label: "Wilson (USWIQ)"
  },
  {
   value: "Wilson (USWSO)",
   label: "Wilson (USWSO)"
  },
  {
   value: "Wilsonville (USWJX)",
   label: "Wilsonville (USWJX)"
  },
  {
   value: "Wilton (USQCW)",
   label: "Wilton (USQCW)"
  },
  {
   value: "Wilton (USWYT)",
   label: "Wilton (USWYT)"
  },
  {
   value: "Wimauma (USWIU)",
   label: "Wimauma (USWIU)"
  },
  {
   value: "Winamac (USWLZ)",
   label: "Winamac (USWLZ)"
  },
  {
   value: "Winchendon (USWCD)",
   label: "Winchendon (USWCD)"
  },
  {
   value: "Winchester (USWIN)",
   label: "Winchester (USWIN)"
  },
  {
   value: "Winchester (USWGO)",
   label: "Winchester (USWGO)"
  },
  {
   value: "Winchester (USWCV)",
   label: "Winchester (USWCV)"
  },
  {
   value: "Whitehall (USWMQ)",
   label: "Whitehall (USWMQ)"
  },
  {
   value: "Whitehall (USWHW)",
   label: "Whitehall (USWHW)"
  },
  {
   value: "Whitehall (USWHY)",
   label: "Whitehall (USWHY)"
  },
  {
   value: "Whitehouse (USWWS)",
   label: "Whitehouse (USWWS)"
  },
  {
   value: "Whitestone (USWYS)",
   label: "Whitestone (USWYS)"
  },
  {
   value: "Whitestone (USWZQ)",
   label: "Whitestone (USWZQ)"
  },
  {
   value: "Whitestone (USWHO)",
   label: "Whitestone (USWHO)"
  },
  {
   value: "Whitetail (USWHS)",
   label: "Whitetail (USWHS)"
  },
  {
   value: "Whiteville (USWVN)",
   label: "Whiteville (USWVN)"
  },
  {
   value: "Whiteville (USWHV)",
   label: "Whiteville (USWHV)"
  },
  {
   value: "Whiting (USWTI)",
   label: "Whiting (USWTI)"
  },
  {
   value: "Whitinsville (USWXM)",
   label: "Whitinsville (USWXM)"
  },
  {
   value: "Whitlash (USWHL)",
   label: "Whitlash (USWHL)"
  },
  {
   value: "Whitlock (USWJI)",
   label: "Whitlock (USWJI)"
  },
  {
   value: "Whittier (USWQF)",
   label: "Whittier (USWQF)"
  },
  {
   value: "Whittier (USWHR)",
   label: "Whittier (USWHR)"
  },
  {
   value: "Whittington (USWUG)",
   label: "Whittington (USWUG)"
  },
  {
   value: "Wichita (USICT)",
   label: "Wichita (USICT)"
  },
  {
   value: "Wickliffe (USWKY)",
   label: "Wickliffe (USWKY)"
  },
  {
   value: "Wiggins (USWGG)",
   label: "Wiggins (USWGG)"
  },
  {
   value: "Wilberton (USXNN)",
   label: "Wilberton (USXNN)"
  },
  {
   value: "Wilder (USWIJ)",
   label: "Wilder (USWIJ)"
  },
  {
   value: "Wilder (USWII)",
   label: "Wilder (USWII)"
  },
  {
   value: "Wildes Corner (USXNT)",
   label: "Wildes Corner (USXNT)"
  },
  {
   value: "Wildwood (USWWF)",
   label: "Wildwood (USWWF)"
  },
  {
   value: "Wilkes-Barre-Scranton (USAVP)",
   label: "Wilkes-Barre-Scranton (USAVP)"
  },
  {
   value: "Wilkesboro (USIKB)",
   label: "Wilkesboro (USIKB)"
  },
  {
   value: "Wilkesville (USWKV)",
   label: "Wilkesville (USWKV)"
  },
  {
   value: "Wilkinsonville (USWKM)",
   label: "Wilkinsonville (USWKM)"
  },
  {
   value: "Willapa Harbour (USACQ)",
   label: "Willapa Harbour (USACQ)"
  },
  {
   value: "Willard (USWLA)",
   label: "Willard (USWLA)"
  },
  {
   value: "Willgrove (USWGV)",
   label: "Willgrove (USWGV)"
  },
  {
   value: "Williamette River (USWIR)",
   label: "Williamette River (USWIR)"
  },
  {
   value: "Williamsburg (USWUZ)",
   label: "Williamsburg (USWUZ)"
  },
  {
   value: "Williamsburg (USWGY)",
   label: "Williamsburg (USWGY)"
  },
  {
   value: "Williamsburg (USWBK)",
   label: "Williamsburg (USWBK)"
  },
  {
   value: "Williamsburg-Hampton-Newpt News (USPHF)",
   label: "Williamsburg-Hampton-Newpt News (USPHF)"
  },
  {
   value: "Williamson (USWIS)",
   label: "Williamson (USWIS)"
  },
  {
   value: "Williamsport (USWFP)",
   label: "Williamsport (USWFP)"
  },
  {
   value: "Westminster (USWME)",
   label: "Westminster (USWME)"
  },
  {
   value: "Westminster (USWMZ)",
   label: "Westminster (USWMZ)"
  },
  {
   value: "Westmont (USWJO)",
   label: "Westmont (USWJO)"
  },
  {
   value: "Westmoreland (USWML)",
   label: "Westmoreland (USWML)"
  },
  {
   value: "Weston (USWSY)",
   label: "Weston (USWSY)"
  },
  {
   value: "Weston (USXOB)",
   label: "Weston (USXOB)"
  },
  {
   value: "Westover (USWXO)",
   label: "Westover (USWXO)"
  },
  {
   value: "Westport (USWSZ)",
   label: "Westport (USWSZ)"
  },
  {
   value: "Westport (USWPP)",
   label: "Westport (USWPP)"
  },
  {
   value: "Westport (USWPT)",
   label: "Westport (USWPT)"
  },
  {
   value: "Westville (USWVE)",
   label: "Westville (USWVE)"
  },
  {
   value: "Westwego (USWWO)",
   label: "Westwego (USWWO)"
  },
  {
   value: "Westwood (USXOA)",
   label: "Westwood (USXOA)"
  },
  {
   value: "Westwood (USWWD)",
   label: "Westwood (USWWD)"
  },
  {
   value: "Westwood (USXOI)",
   label: "Westwood (USXOI)"
  },
  {
   value: "Westwood Village (USWPJ)",
   label: "Westwood Village (USWPJ)"
  },
  {
   value: "Wethersfield (USWRF)",
   label: "Wethersfield (USWRF)"
  },
  {
   value: "\"Wexford (USWXD)",
   label: "\"Wexford (USWXD)"
  },
  {
   value: "Weyauwega (USWWI)",
   label: "Weyauwega (USWWI)"
  },
  {
   value: "Weyers Cave (USWGQ)",
   label: "Weyers Cave (USWGQ)"
  },
  {
   value: "Weymouth (USWEY)",
   label: "Weymouth (USWEY)"
  },
  {
   value: "Wharton (USWAH)",
   label: "Wharton (USWAH)"
  },
  {
   value: "Wharton (USWHT)",
   label: "Wharton (USWHT)"
  },
  {
   value: "Wheatland (USWGL)",
   label: "Wheatland (USWGL)"
  },
  {
   value: "Wheatland (USWFW)",
   label: "Wheatland (USWFW)"
  },
  {
   value: "Wheaton (USWEA)",
   label: "Wheaton (USWEA)"
  },
  {
   value: "Wheatridge (USWQE)",
   label: "Wheatridge (USWQE)"
  },
  {
   value: "Wheeling (USWHE)",
   label: "Wheeling (USWHE)"
  },
  {
   value: "Wheeling (USHLG)",
   label: "Wheeling (USHLG)"
  },
  {
   value: "Whippany (USWHI)",
   label: "Whippany (USWHI)"
  },
  {
   value: "White Bear Lake (USWTE)",
   label: "White Bear Lake (USWTE)"
  },
  {
   value: "White Bluff (USWBB)",
   label: "White Bluff (USWBB)"
  },
  {
   value: "White City (USWCY)",
   label: "White City (USWCY)"
  },
  {
   value: "White Pigeon (USWPI)",
   label: "White Pigeon (USWPI)"
  },
  {
   value: "White Plains (USWTS)",
   label: "White Plains (USWTS)"
  },
  {
   value: "White River Junction (USWVT)",
   label: "White River Junction (USWVT)"
  },
  {
   value: "White Sands (USWSD)",
   label: "White Sands (USWSD)"
  },
  {
   value: "White Springs (USWTH)",
   label: "White Springs (USWTH)"
  },
  {
   value: "White Swan (USWZW)",
   label: "White Swan (USWZW)"
  },
  {
   value: "Whitefish (USWXI)",
   label: "Whitefish (USWXI)"
  },
  {
   value: "West Palm Beach (USPBI)",
   label: "West Palm Beach (USPBI)"
  },
  {
   value: "West Plains (USWPN)",
   label: "West Plains (USWPN)"
  },
  {
   value: "West Point (USWPM)",
   label: "West Point (USWPM)"
  },
  {
   value: "West Point (USWPO)",
   label: "West Point (USWPO)"
  },
  {
   value: "West Point (USWTP)",
   label: "West Point (USWTP)"
  },
  {
   value: "\"West Redding (USWRD)",
   label: "\"West Redding (USWRD)"
  },
  {
   value: "West Roxbury (USWRY)",
   label: "West Roxbury (USWRY)"
  },
  {
   value: "West Sacramento (USWSM)",
   label: "West Sacramento (USWSM)"
  },
  {
   value: "West Sedona (USXOM)",
   label: "West Sedona (USXOM)"
  },
  {
   value: "West Seneca (USWSA)",
   label: "West Seneca (USWSA)"
  },
  {
   value: "West Springfield (USWSP)",
   label: "West Springfield (USWSP)"
  },
  {
   value: "West Union (USWUQ)",
   label: "West Union (USWUQ)"
  },
  {
   value: "West Unity (USWUT)",
   label: "West Unity (USWUT)"
  },
  {
   value: "West Wareham (USWWH)",
   label: "West Wareham (USWWH)"
  },
  {
   value: "West Warren (USWWN)",
   label: "West Warren (USWWN)"
  },
  {
   value: "West Warwick (USXOJ)",
   label: "West Warwick (USXOJ)"
  },
  {
   value: "West Windsor (USWWJ)",
   label: "West Windsor (USWWJ)"
  },
  {
   value: "Westborough (USWSB)",
   label: "Westborough (USWSB)"
  },
  {
   value: "Westbrook (USWZK)",
   label: "Westbrook (USWZK)"
  },
  {
   value: "Westbrook (USWTB)",
   label: "Westbrook (USWTB)"
  },
  {
   value: "Westbury (USWBY)",
   label: "Westbury (USWBY)"
  },
  {
   value: "Westchester (USWQH)",
   label: "Westchester (USWQH)"
  },
  {
   value: "Westchester (USXNP)",
   label: "Westchester (USXNP)"
  },
  {
   value: "Westerly (USWST)",
   label: "Westerly (USWST)"
  },
  {
   value: "Westernport (USWPZ)",
   label: "Westernport (USWPZ)"
  },
  {
   value: "Westerville (USWTY)",
   label: "Westerville (USWTY)"
  },
  {
   value: "Westfield (USWFI)",
   label: "Westfield (USWFI)"
  },
  {
   value: "Westfield (USBAF)",
   label: "Westfield (USBAF)"
  },
  {
   value: "Westfield (USWSF)",
   label: "Westfield (USWSF)"
  },
  {
   value: "Westfield (USWXY)",
   label: "Westfield (USWXY)"
  },
  {
   value: "Westford (USWFR)",
   label: "Westford (USWFR)"
  },
  {
   value: "\"Westhope (USWHP)",
   label: "\"Westhope (USWHP)"
  },
  {
   value: "Westlake (USWLK)",
   label: "Westlake (USWLK)"
  },
  {
   value: "Westlake (USWQL)",
   label: "Westlake (USWQL)"
  },
  {
   value: "Westlake Villlage (USWQV)",
   label: "Westlake Villlage (USWQV)"
  },
  {
   value: "Westland (USWSJ)",
   label: "Westland (USWSJ)"
  },
  {
   value: "Westminster (USWMD)",
   label: "Westminster (USWMD)"
  },
  {
   value: "Westminster (USWMR)",
   label: "Westminster (USWMR)"
  },
  {
   value: "Westminster (USWMI)",
   label: "Westminster (USWMI)"
  },
  {
   value: "West Bridgewater (USWBW)",
   label: "West Bridgewater (USWBW)"
  },
  {
   value: "West Caldwell (USWCL)",
   label: "West Caldwell (USWCL)"
  },
  {
   value: "West Carrollton (USWCA)",
   label: "West Carrollton (USWCA)"
  },
  {
   value: "West Chester (USWZC)",
   label: "West Chester (USWZC)"
  },
  {
   value: "West Chester (USWCR)",
   label: "West Chester (USWCR)"
  },
  {
   value: "West Chesterfield (USWCF)",
   label: "West Chesterfield (USWCF)"
  },
  {
   value: "West Chicago (USWCI)",
   label: "West Chicago (USWCI)"
  },
  {
   value: "West Clarendon (USWCN)",
   label: "West Clarendon (USWCN)"
  },
  {
   value: "West Columbia (USWCB)",
   label: "West Columbia (USWCB)"
  },
  {
   value: "West Conshohocken (USWCK)",
   label: "West Conshohocken (USWCK)"
  },
  {
   value: "West Covina (USWKZ)",
   label: "West Covina (USWKZ)"
  },
  {
   value: "West Coxsackie (USWCX)",
   label: "West Coxsackie (USWCX)"
  },
  {
   value: "West Creek (USWCE)",
   label: "West Creek (USWCE)"
  },
  {
   value: "West Deptford (USWDP)",
   label: "West Deptford (USWDP)"
  },
  {
   value: "West Elizabeth (USWEZ)",
   label: "West Elizabeth (USWEZ)"
  },
  {
   value: "West End (USWNZ)",
   label: "West End (USWNZ)"
  },
  {
   value: "West Foreland (USWFO)",
   label: "West Foreland (USWFO)"
  },
  {
   value: "West Greenwich (USWEG)",
   label: "West Greenwich (USWEG)"
  },
  {
   value: "West Groten (USWGM)",
   label: "West Groten (USWGM)"
  },
  {
   value: "West Hanover (USWVR)",
   label: "West Hanover (USWVR)"
  },
  {
   value: "West Hatfield (USWHD)",
   label: "West Hatfield (USWHD)"
  },
  {
   value: "West Have (USWHC)",
   label: "West Have (USWHC)"
  },
  {
   value: "West Haven (USWHN)",
   label: "West Haven (USWHN)"
  },
  {
   value: "West Hazleton (USWHA)",
   label: "West Hazleton (USWHA)"
  },
  {
   value: "West Helena (USWHQ)",
   label: "West Helena (USWHQ)"
  },
  {
   value: "West Hollywood (USWWU)",
   label: "West Hollywood (USWWU)"
  },
  {
   value: "West Jefferson (USXNV)",
   label: "West Jefferson (USXNV)"
  },
  {
   value: "West Lebanon (USWLI)",
   label: "West Lebanon (USWLI)"
  },
  {
   value: "West Lebanon (USWPQ)",
   label: "West Lebanon (USWPQ)"
  },
  {
   value: "West Linn (USWJL)",
   label: "West Linn (USWJL)"
  },
  {
   value: "West Los Angeles (USWQJ)",
   label: "West Los Angeles (USWQJ)"
  },
  {
   value: "West Memphis (USAWM)",
   label: "West Memphis (USAWM)"
  },
  {
   value: "West Middlesex (USWMN)",
   label: "West Middlesex (USWMN)"
  },
  {
   value: "West Mifflin (USWMF)",
   label: "West Mifflin (USWMF)"
  },
  {
   value: "West Monroe (USWMO)",
   label: "West Monroe (USWMO)"
  },
  {
   value: "West New York (USWNY)",
   label: "West New York (USWNY)"
  },
  {
   value: "West Nyack (USUZL)",
   label: "West Nyack (USUZL)"
  },
  {
   value: "Waynesboro (USWYB)",
   label: "Waynesboro (USWYB)"
  },
  {
   value: "Waynesboro (USWYU)",
   label: "Waynesboro (USWYU)"
  },
  {
   value: "Waynesboro (USWYO)",
   label: "Waynesboro (USWYO)"
  },
  {
   value: "Waynesboro (USWGS)",
   label: "Waynesboro (USWGS)"
  },
  {
   value: "Waynesboro (USWYG)",
   label: "Waynesboro (USWYG)"
  },
  {
   value: "Waynesville (USWYV)",
   label: "Waynesville (USWYV)"
  },
  {
   value: "Waynesville (USWAZ)",
   label: "Waynesville (USWAZ)"
  },
  {
   value: "Weatherford (USWYA)",
   label: "Weatherford (USWYA)"
  },
  {
   value: "Weatherly (USWEH)",
   label: "Weatherly (USWEH)"
  },
  {
   value: "Weaverville (USWVV)",
   label: "Weaverville (USWVV)"
  },
  {
   value: "Webster (USUZJ)",
   label: "Webster (USUZJ)"
  },
  {
   value: "Webster (USWEB)",
   label: "Webster (USWEB)"
  },
  {
   value: "Webster City (USEBS)",
   label: "Webster City (USEBS)"
  },
  {
   value: "Weehawken (USWJQ)",
   label: "Weehawken (USWJQ)"
  },
  {
   value: "Weeks (USWKL)",
   label: "Weeks (USWKL)"
  },
  {
   value: "Weimar (USWJR)",
   label: "Weimar (USWJR)"
  },
  {
   value: "Weiner (USWNA)",
   label: "Weiner (USWNA)"
  },
  {
   value: "Weirton (USWET)",
   label: "Weirton (USWET)"
  },
  {
   value: "Weldon (USWEO)",
   label: "Weldon (USWEO)"
  },
  {
   value: "Wellesley (USWEL)",
   label: "Wellesley (USWEL)"
  },
  {
   value: "Wellford (USWEF)",
   label: "Wellford (USWEF)"
  },
  {
   value: "Wellington (USWGN)",
   label: "Wellington (USWGN)"
  },
  {
   value: "Wellman (USWNX)",
   label: "Wellman (USWNX)"
  },
  {
   value: "Wells (USWZM)",
   label: "Wells (USWZM)"
  },
  {
   value: "Wellsboro (USWBP)",
   label: "Wellsboro (USWBP)"
  },
  {
   value: "Wellsburg (USWES)",
   label: "Wellsburg (USWES)"
  },
  {
   value: "Wellsville (USWSV)",
   label: "Wellsville (USWSV)"
  },
  {
   value: "Wellsville (USWVM)",
   label: "Wellsville (USWVM)"
  },
  {
   value: "Wenatchee (USEAT)",
   label: "Wenatchee (USEAT)"
  },
  {
   value: "Wendell (USWDE)",
   label: "Wendell (USWDE)"
  },
  {
   value: "Wendell (USWDX)",
   label: "Wendell (USWDX)"
  },
  {
   value: "Wendover (USWDW)",
   label: "Wendover (USWDW)"
  },
  {
   value: "Weskan (USWKX)",
   label: "Weskan (USWKX)"
  },
  {
   value: "Weslaco (USWKO)",
   label: "Weslaco (USWKO)"
  },
  {
   value: "West Bath (USWVZ)",
   label: "West Bath (USWVZ)"
  },
  {
   value: "West Bend (USWBD)",
   label: "West Bend (USWBD)"
  },
  {
   value: "West Bend (USETB)",
   label: "West Bend (USETB)"
  },
  {
   value: "West Berlin (USWBS)",
   label: "West Berlin (USWBS)"
  },
  {
   value: "West Bloomfield (USWBF)",
   label: "West Bloomfield (USWBF)"
  },
  {
   value: "West Branch (USWBC)",
   label: "West Branch (USWBC)"
  },
  {
   value: "Waterman (USWTA)",
   label: "Waterman (USWTA)"
  },
  {
   value: "Watertown (USART)",
   label: "Watertown (USART)"
  },
  {
   value: "Watertown (USWAF)",
   label: "Watertown (USWAF)"
  },
  {
   value: "Watertown (USATY)",
   label: "Watertown (USATY)"
  },
  {
   value: "Watertown (USWTW)",
   label: "Watertown (USWTW)"
  },
  {
   value: "Watertown (USWTT)",
   label: "Watertown (USWTT)"
  },
  {
   value: "Watertown (USWWZ)",
   label: "Watertown (USWWZ)"
  },
  {
   value: "Waterville (USWVS)",
   label: "Waterville (USWVS)"
  },
  {
   value: "Waterville (USWVL)",
   label: "Waterville (USWVL)"
  },
  {
   value: "Watervliet (USWTV)",
   label: "Watervliet (USWTV)"
  },
  {
   value: "Watervliet (USXOE)",
   label: "Watervliet (USXOE)"
  },
  {
   value: "Watkins Glenn (USWKG)",
   label: "Watkins Glenn (USWKG)"
  },
  {
   value: "Watkinsville (USWTK)",
   label: "Watkinsville (USWTK)"
  },
  {
   value: "Watseka (USXOD)",
   label: "Watseka (USXOD)"
  },
  {
   value: "Watsonville (USWVI)",
   label: "Watsonville (USWVI)"
  },
  {
   value: "Watts (USWJZ)",
   label: "Watts (USWJZ)"
  },
  {
   value: "Wauconda (USWQN)",
   label: "Wauconda (USWQN)"
  },
  {
   value: "Waukegan (USUGN)",
   label: "Waukegan (USUGN)"
  },
  {
   value: "Waukesha (USUES)",
   label: "Waukesha (USUES)"
  },
  {
   value: "Wauna (USWAU)",
   label: "Wauna (USWAU)"
  },
  {
   value: "Waunakee (USWKW)",
   label: "Waunakee (USWKW)"
  },
  {
   value: "Wausau (USAUW)",
   label: "Wausau (USAUW)"
  },
  {
   value: "Wauseon (USWUN)",
   label: "Wauseon (USWUN)"
  },
  {
   value: "Wautoma (USWWX)",
   label: "Wautoma (USWWX)"
  },
  {
   value: "Wauwatosa (USXOH)",
   label: "Wauwatosa (USXOH)"
  },
  {
   value: "Waverly (USWFY)",
   label: "Waverly (USWFY)"
  },
  {
   value: "Waverly (USXOF)",
   label: "Waverly (USXOF)"
  },
  {
   value: "Waverly (USWAV)",
   label: "Waverly (USWAV)"
  },
  {
   value: "Waverly (USWVB)",
   label: "Waverly (USWVB)"
  },
  {
   value: "Waverly (USWFX)",
   label: "Waverly (USWFX)"
  },
  {
   value: "Waverly (USWVQ)",
   label: "Waverly (USWVQ)"
  },
  {
   value: "Waverly (USWVY)",
   label: "Waverly (USWVY)"
  },
  {
   value: "Waxahachie (USWAX)",
   label: "Waxahachie (USWAX)"
  },
  {
   value: "Waxdale (USXNR)",
   label: "Waxdale (USXNR)"
  },
  {
   value: "Waycross (USAYS)",
   label: "Waycross (USAYS)"
  },
  {
   value: "Wayland (USWXQ)",
   label: "Wayland (USWXQ)"
  },
  {
   value: "Waymart (USWYR)",
   label: "Waymart (USWYR)"
  },
  {
   value: "Wayne (USWNP)",
   label: "Wayne (USWNP)"
  },
  {
   value: "Wayne (USWYE)",
   label: "Wayne (USWYE)"
  },
  {
   value: "Wayne (USWYN)",
   label: "Wayne (USWYN)"
  },
  {
   value: "Wayne (USWYJ)",
   label: "Wayne (USWYJ)"
  },
  {
   value: "Wayne (USWNE)",
   label: "Wayne (USWNE)"
  },
  {
   value: "Warren (USWRN)",
   label: "Warren (USWRN)"
  },
  {
   value: "Warren (USWPA)",
   label: "Warren (USWPA)"
  },
  {
   value: "Warren (USWAJ)",
   label: "Warren (USWAJ)"
  },
  {
   value: "Warrendale (USWRR)",
   label: "Warrendale (USWRR)"
  },
  {
   value: "Warrensburg (USSZL)",
   label: "Warrensburg (USSZL)"
  },
  {
   value: "Warrensville Heights (USWHH)",
   label: "Warrensville Heights (USWHH)"
  },
  {
   value: "Warrenton (USWRT)",
   label: "Warrenton (USWRT)"
  },
  {
   value: "Warrenton (USWFT)",
   label: "Warrenton (USWFT)"
  },
  {
   value: "Warrenton (USWUO)",
   label: "Warrenton (USWUO)"
  },
  {
   value: "Warrenton (USWTO)",
   label: "Warrenton (USWTO)"
  },
  {
   value: "Warrenton (USWVJ)",
   label: "Warrenton (USWVJ)"
  },
  {
   value: "Warrick (USWRZ)",
   label: "Warrick (USWRZ)"
  },
  {
   value: "Warrington (USWRA)",
   label: "Warrington (USWRA)"
  },
  {
   value: "Warroad (USRRT)",
   label: "Warroad (USRRT)"
  },
  {
   value: "Warsaw (USWWT)",
   label: "Warsaw (USWWT)"
  },
  {
   value: "Warsaw (USWAP)",
   label: "Warsaw (USWAP)"
  },
  {
   value: "Warwick (USUZO)",
   label: "Warwick (USUZO)"
  },
  {
   value: "Wasco (USWQS)",
   label: "Wasco (USWQS)"
  },
  {
   value: "Waseca (USWKA)",
   label: "Waseca (USWKA)"
  },
  {
   value: "Washington (USWSG)",
   label: "Washington (USWSG)"
  },
  {
   value: "Washington (USWWV)",
   label: "Washington (USWWV)"
  },
  {
   value: "Washington (USWSH)",
   label: "Washington (USWSH)"
  },
  {
   value: "Washington (USWQY)",
   label: "Washington (USWQY)"
  },
  {
   value: "Washington (USOCW)",
   label: "Washington (USOCW)"
  },
  {
   value: "Washington (USWSQ)",
   label: "Washington (USWSQ)"
  },
  {
   value: "Washington (USWSK)",
   label: "Washington (USWSK)"
  },
  {
   value: "Washington Crossing (USWCG)",
   label: "Washington Crossing (USWCG)"
  },
  {
   value: "Washington Metr. Area (USWAS)",
   label: "Washington Metr. Area (USWAS)"
  },
  {
   value: "Washingtonville (USWSL)",
   label: "Washingtonville (USWSL)"
  },
  {
   value: "Washougal (USWXG)",
   label: "Washougal (USWXG)"
  },
  {
   value: "Wasilla (USWWA)",
   label: "Wasilla (USWWA)"
  },
  {
   value: "Waterbury (USWAT)",
   label: "Waterbury (USWAT)"
  },
  {
   value: "Waterbury (USWBV)",
   label: "Waterbury (USWBV)"
  },
  {
   value: "Waterford (USWTM)",
   label: "Waterford (USWTM)"
  },
  {
   value: "Waterford (USWVD)",
   label: "Waterford (USWVD)"
  },
  {
   value: "Waterford (USUZK)",
   label: "Waterford (USUZK)"
  },
  {
   value: "Waterford Works (USWFJ)",
   label: "Waterford Works (USWFJ)"
  },
  {
   value: "Waterloo (USWLW)",
   label: "Waterloo (USWLW)"
  },
  {
   value: "Waterloo (USALO)",
   label: "Waterloo (USALO)"
  },
  {
   value: "Waterloo (USWTL)",
   label: "Waterloo (USWTL)"
  },
  {
   value: "Wallingford (USWFD)",
   label: "Wallingford (USWFD)"
  },
  {
   value: "Wallington (USWLT)",
   label: "Wallington (USWLT)"
  },
  {
   value: "Wallisville (USWLV)",
   label: "Wallisville (USWLV)"
  },
  {
   value: "Wallkill (USWAK)",
   label: "Wallkill (USWAK)"
  },
  {
   value: "Walls (USWLS)",
   label: "Walls (USWLS)"
  },
  {
   value: "Wallula (USWUW)",
   label: "Wallula (USWUW)"
  },
  {
   value: "Walnut (USWLU)",
   label: "Walnut (USWLU)"
  },
  {
   value: "Walnut Creek (USWKK)",
   label: "Walnut Creek (USWKK)"
  },
  {
   value: "Walnut Grove (USWLN)",
   label: "Walnut Grove (USWLN)"
  },
  {
   value: "Walnut Grove (USWAG)",
   label: "Walnut Grove (USWAG)"
  },
  {
   value: "Walnut Ridge (USARG)",
   label: "Walnut Ridge (USARG)"
  },
  {
   value: "Walpole (USWLP)",
   label: "Walpole (USWLP)"
  },
  {
   value: "Walpole (USWPL)",
   label: "Walpole (USWPL)"
  },
  {
   value: "Walterboro (USRBW)",
   label: "Walterboro (USRBW)"
  },
  {
   value: "Waltham (USWLM)",
   label: "Waltham (USWLM)"
  },
  {
   value: "Walthourville (USWXA)",
   label: "Walthourville (USWXA)"
  },
  {
   value: "Walton Beach (USWBZ)",
   label: "Walton Beach (USWBZ)"
  },
  {
   value: "Walton Hills (USWJP)",
   label: "Walton Hills (USWJP)"
  },
  {
   value: "Walworth (USWAW)",
   label: "Walworth (USWAW)"
  },
  {
   value: "Wamego (USWAO)",
   label: "Wamego (USWAO)"
  },
  {
   value: "Wampum (USWMM)",
   label: "Wampum (USWMM)"
  },
  {
   value: "Wanamingo (USWAN)",
   label: "Wanamingo (USWAN)"
  },
  {
   value: "Wankie (USWKJ)",
   label: "Wankie (USWKJ)"
  },
  {
   value: "Wapakoneta (USAXV)",
   label: "Wapakoneta (USAXV)"
  },
  {
   value: "Wapato (USWPW)",
   label: "Wapato (USWPW)"
  },
  {
   value: "Wappingers Falls (USWFS)",
   label: "Wappingers Falls (USWFS)"
  },
  {
   value: "Warcham (USWCM)",
   label: "Warcham (USWCM)"
  },
  {
   value: "Ward Hill (USWHZ)",
   label: "Ward Hill (USWHZ)"
  },
  {
   value: "Warden (USWEW)",
   label: "Warden (USWEW)"
  },
  {
   value: "Wardensville (USWAE)",
   label: "Wardensville (USWAE)"
  },
  {
   value: "Ware (USUWA)",
   label: "Ware (USUWA)"
  },
  {
   value: "Wareham (USWMV)",
   label: "Wareham (USWMV)"
  },
  {
   value: "Warehouse Point (USWPC)",
   label: "Warehouse Point (USWPC)"
  },
  {
   value: "Warm Springs (USWJY)",
   label: "Warm Springs (USWJY)"
  },
  {
   value: "Warminster (USWAA)",
   label: "Warminster (USWAA)"
  },
  {
   value: "Warner Robins (USWRB)",
   label: "Warner Robins (USWRB)"
  },
  {
   value: "Warners (USWRS)",
   label: "Warners (USWRS)"
  },
  {
   value: "Warren (USWQR)",
   label: "Warren (USWQR)"
  },
  {
   value: "Warren (USWXN)",
   label: "Warren (USWXN)"
  },
  {
   value: "Warren (USWAM)",
   label: "Warren (USWAM)"
  },
  {
   value: "Visalia (USVIS)",
   label: "Visalia (USVIS)"
  },
  {
   value: "Vista (USVTI)",
   label: "Vista (USVTI)"
  },
  {
   value: "Vivian (USVVN)",
   label: "Vivian (USVVN)"
  },
  {
   value: "Vogleyville (USVOY)",
   label: "Vogleyville (USVOY)"
  },
  {
   value: "Volta (USVTA)",
   label: "Volta (USVTA)"
  },
  {
   value: "Vonore (USVQN)",
   label: "Vonore (USVQN)"
  },
  {
   value: "Voorhees (USVHJ)",
   label: "Voorhees (USVHJ)"
  },
  {
   value: "Voorheesville (USVOO)",
   label: "Voorheesville (USVOO)"
  },
  {
   value: "Wabash (USWBH)",
   label: "Wabash (USWBH)"
  },
  {
   value: "Wabasha (USWZA)",
   label: "Wabasha (USWZA)"
  },
  {
   value: "Wabasso (USWBA)",
   label: "Wabasso (USWBA)"
  },
  {
   value: "Wabasso (USWPS)",
   label: "Wabasso (USWPS)"
  },
  {
   value: "Waco (USACT)",
   label: "Waco (USACT)"
  },
  {
   value: "Waconia (USWQO)",
   label: "Waconia (USWQO)"
  },
  {
   value: "Waddington (USWAD)",
   label: "Waddington (USWAD)"
  },
  {
   value: "Wadena (USWDN)",
   label: "Wadena (USWDN)"
  },
  {
   value: "Wadsworth (USWDT)",
   label: "Wadsworth (USWDT)"
  },
  {
   value: "Wagner (USXNU)",
   label: "Wagner (USXNU)"
  },
  {
   value: "Wagontown (USWGW)",
   label: "Wagontown (USWGW)"
  },
  {
   value: "Wagram (USWAQ)",
   label: "Wagram (USWAQ)"
  },
  {
   value: "Wailuku (Maui) (USWZV)",
   label: "Wailuku (Maui) (USWZV)"
  },
  {
   value: "Waimanalo (USBLW)",
   label: "Waimanalo (USBLW)"
  },
  {
   value: "Wainscott (USWIY)",
   label: "Wainscott (USWIY)"
  },
  {
   value: "Waipahu (Oahu) (USWPH)",
   label: "Waipahu (Oahu) (USWPH)"
  },
  {
   value: "Waitsfield (USWAI)",
   label: "Waitsfield (USWAI)"
  },
  {
   value: "Wakefield (USWJK)",
   label: "Wakefield (USWJK)"
  },
  {
   value: "Wakefield (USWKF)",
   label: "Wakefield (USWKF)"
  },
  {
   value: "Walden (USWDA)",
   label: "Walden (USWDA)"
  },
  {
   value: "Waldo (USWLF)",
   label: "Waldo (USWLF)"
  },
  {
   value: "Waldorf (USWFM)",
   label: "Waldorf (USWFM)"
  },
  {
   value: "Waldron (USWDM)",
   label: "Waldron (USWDM)"
  },
  {
   value: "Waldwick (USWWK)",
   label: "Waldwick (USWWK)"
  },
  {
   value: "Waldworth (USWLH)",
   label: "Waldworth (USWLH)"
  },
  {
   value: "Walhalla (USWAL)",
   label: "Walhalla (USWAL)"
  },
  {
   value: "Walhalla (USWHJ)",
   label: "Walhalla (USWHJ)"
  },
  {
   value: "Walkersville (USXNX)",
   label: "Walkersville (USXNX)"
  },
  {
   value: "Walkill (USWLL)",
   label: "Walkill (USWLL)"
  },
  {
   value: "Walla Walla (USALW)",
   label: "Walla Walla (USALW)"
  },
  {
   value: "Wallace (USWLE)",
   label: "Wallace (USWLE)"
  },
  {
   value: "Walled Lake (USWBL)",
   label: "Walled Lake (USWBL)"
  },
  {
   value: "Waller (USWLR)",
   label: "Waller (USWLR)"
  },
  {
   value: "Venice (USVNC)",
   label: "Venice (USVNC)"
  },
  {
   value: "Venice (USXNL)",
   label: "Venice (USXNL)"
  },
  {
   value: "Venice (USVCI)",
   label: "Venice (USVCI)"
  },
  {
   value: "Ventura-Oxnard (USOXR)",
   label: "Ventura-Oxnard (USOXR)"
  },
  {
   value: "Verdi (USVEI)",
   label: "Verdi (USVEI)"
  },
  {
   value: "Verdugo City (USVCU)",
   label: "Verdugo City (USVCU)"
  },
  {
   value: "Vernon (USVEL)",
   label: "Vernon (USVEL)"
  },
  {
   value: "Vernon (USVRT)",
   label: "Vernon (USVRT)"
  },
  {
   value: "Vernon (USVCA)",
   label: "Vernon (USVCA)"
  },
  {
   value: "Vernon (USVNN)",
   label: "Vernon (USVNN)"
  },
  {
   value: "Vernon Hill (USVHI)",
   label: "Vernon Hill (USVHI)"
  },
  {
   value: "Vero Beach (USVRB)",
   label: "Vero Beach (USVRB)"
  },
  {
   value: "Verona (USVRV)",
   label: "Verona (USVRV)"
  },
  {
   value: "Verona (USVEA)",
   label: "Verona (USVEA)"
  },
  {
   value: "Verona (USVNA)",
   label: "Verona (USVNA)"
  },
  {
   value: "Verona (USVER)",
   label: "Verona (USVER)"
  },
  {
   value: "Verona (USVEO)",
   label: "Verona (USVEO)"
  },
  {
   value: "Versailles (USVSI)",
   label: "Versailles (USVSI)"
  },
  {
   value: "Versailles (USVSS)",
   label: "Versailles (USVSS)"
  },
  {
   value: "Vesper (USVES)",
   label: "Vesper (USVES)"
  },
  {
   value: "Vestaburg (USVTB)",
   label: "Vestaburg (USVTB)"
  },
  {
   value: "Vickery (USVIK)",
   label: "Vickery (USVIK)"
  },
  {
   value: "Vicksburg (USVKS)",
   label: "Vicksburg (USVKS)"
  },
  {
   value: "Victor (USVCW)",
   label: "Victor (USVCW)"
  },
  {
   value: "Victoria (USVCT)",
   label: "Victoria (USVCT)"
  },
  {
   value: "Victorville (USVCV)",
   label: "Victorville (USVCV)"
  },
  {
   value: "Victory (USVTY)",
   label: "Victory (USVTY)"
  },
  {
   value: "Vidalia (USVDL)",
   label: "Vidalia (USVDL)"
  },
  {
   value: "Vienna (USVHO)",
   label: "Vienna (USVHO)"
  },
  {
   value: "Vienna (USVIV)",
   label: "Vienna (USVIV)"
  },
  {
   value: "Vienna (USVWV)",
   label: "Vienna (USVWV)"
  },
  {
   value: "Villa Park (USVPR)",
   label: "Villa Park (USVPR)"
  },
  {
   value: "Villa Park (USVPK)",
   label: "Villa Park (USVPK)"
  },
  {
   value: "Villa Rica (USVLR)",
   label: "Villa Rica (USVLR)"
  },
  {
   value: "Vincennes (USOEA)",
   label: "Vincennes (USOEA)"
  },
  {
   value: "Vineland (USVIN)",
   label: "Vineland (USVIN)"
  },
  {
   value: "Vineyard Haven (USVYH)",
   label: "Vineyard Haven (USVYH)"
  },
  {
   value: "Vint Hill Farms (USVHF)",
   label: "Vint Hill Farms (USVHF)"
  },
  {
   value: "Vinton (USVTW)",
   label: "Vinton (USVTW)"
  },
  {
   value: "Vinton (USXNM)",
   label: "Vinton (USXNM)"
  },
  {
   value: "Virginia Beach (USVAB)",
   label: "Virginia Beach (USVAB)"
  },
  {
   value: "Usibelli (USUEI)",
   label: "Usibelli (USUEI)"
  },
  {
   value: "Usk (USUSK)",
   label: "Usk (USUSK)"
  },
  {
   value: "Utica (USUCA)",
   label: "Utica (USUCA)"
  },
  {
   value: "Utica (USUTQ)",
   label: "Utica (USUTQ)"
  },
  {
   value: "Utica (USUIZ)",
   label: "Utica (USUIZ)"
  },
  {
   value: "Uvalde (USUVA)",
   label: "Uvalde (USUVA)"
  },
  {
   value: "Uyak (USKUY)",
   label: "Uyak (USKUY)"
  },
  {
   value: "Vacaville (USVCX)",
   label: "Vacaville (USVCX)"
  },
  {
   value: "Vadnais Heights (USVSH)",
   label: "Vadnais Heights (USVSH)"
  },
  {
   value: "Vail (USVAC)",
   label: "Vail (USVAC)"
  },
  {
   value: "Vailsgate (USVAI)",
   label: "Vailsgate (USVAI)"
  },
  {
   value: "Valatie (USVAT)",
   label: "Valatie (USVAT)"
  },
  {
   value: "Valdese (USVAL)",
   label: "Valdese (USVAL)"
  },
  {
   value: "Valdez (USVDZ)",
   label: "Valdez (USVDZ)"
  },
  {
   value: "Valdosta (USVLD)",
   label: "Valdosta (USVLD)"
  },
  {
   value: "Vale (USVNQ)",
   label: "Vale (USVNQ)"
  },
  {
   value: "Valencia (USVEC)",
   label: "Valencia (USVEC)"
  },
  {
   value: "Valentine (USVTN)",
   label: "Valentine (USVTN)"
  },
  {
   value: "Valentine (USVLT)",
   label: "Valentine (USVLT)"
  },
  {
   value: "Vallejo (USVLO)",
   label: "Vallejo (USVLO)"
  },
  {
   value: "Valley (USVLY)",
   label: "Valley (USVLY)"
  },
  {
   value: "Valley City (USVCO)",
   label: "Valley City (USVCO)"
  },
  {
   value: "Valley Cottage (USVCJ)",
   label: "Valley Cottage (USVCJ)"
  },
  {
   value: "Valley Forge (USVFG)",
   label: "Valley Forge (USVFG)"
  },
  {
   value: "Valley Stream (USVSR)",
   label: "Valley Stream (USVSR)"
  },
  {
   value: "Valley View (USVVW)",
   label: "Valley View (USVVW)"
  },
  {
   value: "Valmy (USVYM)",
   label: "Valmy (USVYM)"
  },
  {
   value: "Valparaiso (USVPZ)",
   label: "Valparaiso (USVPZ)"
  },
  {
   value: "Van Buren (USVBU)",
   label: "Van Buren (USVBU)"
  },
  {
   value: "Van Buren (USVAM)",
   label: "Van Buren (USVAM)"
  },
  {
   value: "Van Buren (USVBN)",
   label: "Van Buren (USVBN)"
  },
  {
   value: "Van Nuys (USVNY)",
   label: "Van Nuys (USVNY)"
  },
  {
   value: "Van Wert (USVNW)",
   label: "Van Wert (USVNW)"
  },
  {
   value: "Van Wyck (USVWC)",
   label: "Van Wyck (USVWC)"
  },
  {
   value: "Vanceboro (USVBO)",
   label: "Vanceboro (USVBO)"
  },
  {
   value: "Vancouver (USBCC)",
   label: "Vancouver (USBCC)"
  },
  {
   value: "Vandalia (USVNL)",
   label: "Vandalia (USVNL)"
  },
  {
   value: "Vandalia (USVDH)",
   label: "Vandalia (USVDH)"
  },
  {
   value: "Vardaman (USVDW)",
   label: "Vardaman (USVDW)"
  },
  {
   value: "Vassar (USVAS)",
   label: "Vassar (USVAS)"
  },
  {
   value: "Vauxhall (USVHX)",
   label: "Vauxhall (USVHX)"
  },
  {
   value: "Vega (USVEX)",
   label: "Vega (USVEX)"
  },
  {
   value: "Two Rivers (USTWO)",
   label: "Two Rivers (USTWO)"
  },
  {
   value: "Two Rivers (USTWR)",
   label: "Two Rivers (USTWR)"
  },
  {
   value: "Ty Ty (USTYA)",
   label: "Ty Ty (USTYA)"
  },
  {
   value: "Tyler (USTYL)",
   label: "Tyler (USTYL)"
  },
  {
   value: "Tyler (USTYR)",
   label: "Tyler (USTYR)"
  },
  {
   value: "Tyndall (USTJF)",
   label: "Tyndall (USTJF)"
  },
  {
   value: "Tyonek (USTYE)",
   label: "Tyonek (USTYE)"
  },
  {
   value: "Tyro (USTYJ)",
   label: "Tyro (USTYJ)"
  },
  {
   value: "Tyrone (USXNK)",
   label: "Tyrone (USXNK)"
  },
  {
   value: "Uganik (USUGI)",
   label: "Uganik (USUGI)"
  },
  {
   value: "Ugashik (USUGS)",
   label: "Ugashik (USUGS)"
  },
  {
   value: "Uhrichsville (USUHV)",
   label: "Uhrichsville (USUHV)"
  },
  {
   value: "Ukiah (USUKI)",
   label: "Ukiah (USUKI)"
  },
  {
   value: "Ulysses (USUSY)",
   label: "Ulysses (USUSY)"
  },
  {
   value: "Umatilla (USUMT)",
   label: "Umatilla (USUMT)"
  },
  {
   value: "Umatilla (USUMA)",
   label: "Umatilla (USUMA)"
  },
  {
   value: "Unadilla (USUDL)",
   label: "Unadilla (USUDL)"
  },
  {
   value: "Unalaska (USUAA)",
   label: "Unalaska (USUAA)"
  },
  {
   value: "Union (USUON)",
   label: "Union (USUON)"
  },
  {
   value: "Union (USUIL)",
   label: "Union (USUIL)"
  },
  {
   value: "Union (USUNI)",
   label: "Union (USUNI)"
  },
  {
   value: "Union (USUCS)",
   label: "Union (USUCS)"
  },
  {
   value: "Union City (USUCY)",
   label: "Union City (USUCY)"
  },
  {
   value: "Union City (USUCC)",
   label: "Union City (USUCC)"
  },
  {
   value: "Union City (USUCG)",
   label: "Union City (USUCG)"
  },
  {
   value: "Union City (USUNO)",
   label: "Union City (USUNO)"
  },
  {
   value: "Union City (USUCJ)",
   label: "Union City (USUCJ)"
  },
  {
   value: "Union City (USUNN)",
   label: "Union City (USUNN)"
  },
  {
   value: "Union Grove (USUGR)",
   label: "Union Grove (USUGR)"
  },
  {
   value: "Union Springs (USUSP)",
   label: "Union Springs (USUSP)"
  },
  {
   value: "Uniontown (USUTN)",
   label: "Uniontown (USUTN)"
  },
  {
   value: "Universal City (USUVC)",
   label: "Universal City (USUVC)"
  },
  {
   value: "University Park (USUPK)",
   label: "University Park (USUPK)"
  },
  {
   value: "Upland (USCCB)",
   label: "Upland (USCCB)"
  },
  {
   value: "Upper Darby (USUDY)",
   label: "Upper Darby (USUDY)"
  },
  {
   value: "Upper Marlboro (USUPM)",
   label: "Upper Marlboro (USUPM)"
  },
  {
   value: "Upper Sandusky (USUPE)",
   label: "Upper Sandusky (USUPE)"
  },
  {
   value: "Urania (USURN)",
   label: "Urania (USURN)"
  },
  {
   value: "Urbana (USURO)",
   label: "Urbana (USURO)"
  },
  {
   value: "Urbana (USURB)",
   label: "Urbana (USURB)"
  },
  {
   value: "Urbandale (USUBL)",
   label: "Urbandale (USUBL)"
  },
  {
   value: "Troy (USTYM)",
   label: "Troy (USTYM)"
  },
  {
   value: "Troy (USTOI)",
   label: "Troy (USTOI)"
  },
  {
   value: "Troy (USTYH)",
   label: "Troy (USTYH)"
  },
  {
   value: "Truckee (USTKF)",
   label: "Truckee (USTKF)"
  },
  {
   value: "Trumann (USTMN)",
   label: "Trumann (USTMN)"
  },
  {
   value: "Trumbauersville (USTBV)",
   label: "Trumbauersville (USTBV)"
  },
  {
   value: "Trumbull (USTBL)",
   label: "Trumbull (USTBL)"
  },
  {
   value: "Trussville (USTRU)",
   label: "Trussville (USTRU)"
  },
  {
   value: "Truth Or Consequences (USTCS)",
   label: "Truth Or Consequences (USTCS)"
  },
  {
   value: "Tualatin (USTWL)",
   label: "Tualatin (USTWL)"
  },
  {
   value: "Tucker (USTUC)",
   label: "Tucker (USTUC)"
  },
  {
   value: "Tucson (USTUS)",
   label: "Tucson (USTUS)"
  },
  {
   value: "Tucumcari (USTCC)",
   label: "Tucumcari (USTCC)"
  },
  {
   value: "Tujunga (USTJN)",
   label: "Tujunga (USTJN)"
  },
  {
   value: "Tukwila (USTUK)",
   label: "Tukwila (USTUK)"
  },
  {
   value: "Tulare (USTLR)",
   label: "Tulare (USTLR)"
  },
  {
   value: "Tulelake (USTKL)",
   label: "Tulelake (USTKL)"
  },
  {
   value: "Tulia (USTLA)",
   label: "Tulia (USTLA)"
  },
  {
   value: "Tullahoma (USTHA)",
   label: "Tullahoma (USTHA)"
  },
  {
   value: "Tullytown (USTLT)",
   label: "Tullytown (USTLT)"
  },
  {
   value: "Tulsa (USTUL)",
   label: "Tulsa (USTUL)"
  },
  {
   value: "Tumwater (USTUW)",
   label: "Tumwater (USTUW)"
  },
  {
   value: "Tunkhannock (USTKK)",
   label: "Tunkhannock (USTKK)"
  },
  {
   value: "Tunnel Hill (USXNI)",
   label: "Tunnel Hill (USXNI)"
  },
  {
   value: "Tupelo (USTUP)",
   label: "Tupelo (USTUP)"
  },
  {
   value: "Turkey (USTUQ)",
   label: "Turkey (USTUQ)"
  },
  {
   value: "Turlock (USTLK)",
   label: "Turlock (USTLK)"
  },
  {
   value: "Turner (USTUR)",
   label: "Turner (USTUR)"
  },
  {
   value: "Tuscaloosa (USTCL)",
   label: "Tuscaloosa (USTCL)"
  },
  {
   value: "Tuscola (USXNH)",
   label: "Tuscola (USXNH)"
  },
  {
   value: "Tuscolumbia (USTUA)",
   label: "Tuscolumbia (USTUA)"
  },
  {
   value: "Tuscumbia (USTSC)",
   label: "Tuscumbia (USTSC)"
  },
  {
   value: "Tustin (USTNC)",
   label: "Tustin (USTNC)"
  },
  {
   value: "Tutwiler (USTUT)",
   label: "Tutwiler (USTUT)"
  },
  {
   value: "Tuxedo (USTXD)",
   label: "Tuxedo (USTXD)"
  },
  {
   value: "Tuxedo Park (USXND)",
   label: "Tuxedo Park (USXND)"
  },
  {
   value: "Twentynine Palms (USTNP)",
   label: "Twentynine Palms (USTNP)"
  },
  {
   value: "Twin Falls (USTWF)",
   label: "Twin Falls (USTWF)"
  },
  {
   value: "Twinsburg (USTBG)",
   label: "Twinsburg (USTBG)"
  },
  {
   value: "Twisp (USTWI)",
   label: "Twisp (USTWI)"
  },
  {
   value: "Two Harbors (USTHB)",
   label: "Two Harbors (USTHB)"
  },
  {
   value: "Topton (USXNF)",
   label: "Topton (USXNF)"
  },
  {
   value: "Toronto (USTOD)",
   label: "Toronto (USTOD)"
  },
  {
   value: "Torrance (USTOA)",
   label: "Torrance (USTOA)"
  },
  {
   value: "Torrington (USTGT)",
   label: "Torrington (USTGT)"
  },
  {
   value: "Torrington (USTOR)",
   label: "Torrington (USTOR)"
  },
  {
   value: "Tote (USTTG)",
   label: "Tote (USTTG)"
  },
  {
   value: "Totowa (USTOT)",
   label: "Totowa (USTOT)"
  },
  {
   value: "Towaco (USTWJ)",
   label: "Towaco (USTWJ)"
  },
  {
   value: "Towanda (USTOW)",
   label: "Towanda (USTOW)"
  },
  {
   value: "Tower City (USTWC)",
   label: "Tower City (USTWC)"
  },
  {
   value: "Town East (USTED)",
   label: "Town East (USTED)"
  },
  {
   value: "Townsend (USTWB)",
   label: "Townsend (USTWB)"
  },
  {
   value: "Townshend (USTSD)",
   label: "Townshend (USTSD)"
  },
  {
   value: "Towson (USTWS)",
   label: "Towson (USTWS)"
  },
  {
   value: "Tracy (USTRC)",
   label: "Tracy (USTRC)"
  },
  {
   value: "Trainer (USTRP)",
   label: "Trainer (USTRP)"
  },
  {
   value: "Travelers Rest (USXNJ)",
   label: "Travelers Rest (USXNJ)"
  },
  {
   value: "Traver (USTVY)",
   label: "Traver (USTVY)"
  },
  {
   value: "Traverse City (USTVC)",
   label: "Traverse City (USTVC)"
  },
  {
   value: "Treasure Island (USTSU)",
   label: "Treasure Island (USTSU)"
  },
  {
   value: "Tremont (USTMX)",
   label: "Tremont (USTMX)"
  },
  {
   value: "Tremonton (USTRT)",
   label: "Tremonton (USTRT)"
  },
  {
   value: "Tremount (USTRE)",
   label: "Tremount (USTRE)"
  },
  {
   value: "Trenton (USTEQ)",
   label: "Trenton (USTEQ)"
  },
  {
   value: "Trenton (USTTN)",
   label: "Trenton (USTTN)"
  },
  {
   value: "Trenton (USXNG)",
   label: "Trenton (USXNG)"
  },
  {
   value: "Trenton (USTNR)",
   label: "Trenton (USTNR)"
  },
  {
   value: "Trenton (USTRX)",
   label: "Trenton (USTRX)"
  },
  {
   value: "Trevor (USTVO)",
   label: "Trevor (USTVO)"
  },
  {
   value: "Trevorton (USTVR)",
   label: "Trevorton (USTVR)"
  },
  {
   value: "Trevose (USTVS)",
   label: "Trevose (USTVS)"
  },
  {
   value: "Trion (USTNG)",
   label: "Trion (USTNG)"
  },
  {
   value: "Troup (USTXP)",
   label: "Troup (USTXP)"
  },
  {
   value: "Trout River (USTRR)",
   label: "Trout River (USTRR)"
  },
  {
   value: "Troutdale (USTTD)",
   label: "Troutdale (USTTD)"
  },
  {
   value: "Troutman (USTRZ)",
   label: "Troutman (USTRZ)"
  },
  {
   value: "Troutville (USUZG)",
   label: "Troutville (USUZG)"
  },
  {
   value: "Troy (USTYX)",
   label: "Troy (USTYX)"
  },
  {
   value: "Troy (USTTY)",
   label: "Troy (USTTY)"
  },
  {
   value: "Troy (USTRY)",
   label: "Troy (USTRY)"
  },
  {
   value: "Troy (USTYI)",
   label: "Troy (USTYI)"
  },
  {
   value: "Troy (USTYU)",
   label: "Troy (USTYU)"
  },
  {
   value: "Thordale (USTHR)",
   label: "Thordale (USTHR)"
  },
  {
   value: "Thorofare (USTRF)",
   label: "Thorofare (USTRF)"
  },
  {
   value: "Thousand Oaks (USJTO)",
   label: "Thousand Oaks (USJTO)"
  },
  {
   value: "Three Rivers (USTRJ)",
   label: "Three Rivers (USTRJ)"
  },
  {
   value: "Three Rivers (USHAI)",
   label: "Three Rivers (USHAI)"
  },
  {
   value: "Ticonderoga (USTIC)",
   label: "Ticonderoga (USTIC)"
  },
  {
   value: "Tiffin (USTFN)",
   label: "Tiffin (USTFN)"
  },
  {
   value: "Tifton (USTMA)",
   label: "Tifton (USTMA)"
  },
  {
   value: "Tigard (USTID)",
   label: "Tigard (USTID)"
  },
  {
   value: "Tillamook (USTLM)",
   label: "Tillamook (USTLM)"
  },
  {
   value: "Timberville (USTMB)",
   label: "Timberville (USTMB)"
  },
  {
   value: "Timonium (USTUM)",
   label: "Timonium (USTUM)"
  },
  {
   value: "Tinley Park (USTNL)",
   label: "Tinley Park (USTNL)"
  },
  {
   value: "Tinton Falls (USTIN)",
   label: "Tinton Falls (USTIN)"
  },
  {
   value: "Tipp City (USUZE)",
   label: "Tipp City (USUZE)"
  },
  {
   value: "Tipton (USTPO)",
   label: "Tipton (USTPO)"
  },
  {
   value: "Tipton (USTII)",
   label: "Tipton (USTII)"
  },
  {
   value: "Tiptonville (USTPV)",
   label: "Tiptonville (USTPV)"
  },
  {
   value: "Titusville (USTIT)",
   label: "Titusville (USTIT)"
  },
  {
   value: "Tiverton (USTIV)",
   label: "Tiverton (USTIV)"
  },
  {
   value: "Toano (USTXV)",
   label: "Toano (USTXV)"
  },
  {
   value: "Tobaccoville (USTQO)",
   label: "Tobaccoville (USTQO)"
  },
  {
   value: "Tobyhanna (USTBP)",
   label: "Tobyhanna (USTBP)"
  },
  {
   value: "Toccoa (USTOC)",
   label: "Toccoa (USTOC)"
  },
  {
   value: "Tolar (USTXS)",
   label: "Tolar (USTXS)"
  },
  {
   value: "Toledo (USTQD)",
   label: "Toledo (USTQD)"
  },
  {
   value: "Toledo (USTOL)",
   label: "Toledo (USTOL)"
  },
  {
   value: "Toledo (USTDO)",
   label: "Toledo (USTDO)"
  },
  {
   value: "Tolland (USTLD)",
   label: "Tolland (USTLD)"
  },
  {
   value: "Tolleson (USOLQ)",
   label: "Tolleson (USOLQ)"
  },
  {
   value: "Toluca Lake (USTQL)",
   label: "Toluca Lake (USTQL)"
  },
  {
   value: "Tomball (USTOB)",
   label: "Tomball (USTOB)"
  },
  {
   value: "Tompkinsville (USTPM)",
   label: "Tompkinsville (USTPM)"
  },
  {
   value: "Toms River (USMJX)",
   label: "Toms River (USMJX)"
  },
  {
   value: "Tonawanda (USUZF)",
   label: "Tonawanda (USUZF)"
  },
  {
   value: "Tonopah (USTPH)",
   label: "Tonopah (USTPH)"
  },
  {
   value: "Tooele (USTOO)",
   label: "Tooele (USTOO)"
  },
  {
   value: "Topeka (USTOP)",
   label: "Topeka (USTOP)"
  },
  {
   value: "Topeka (USTQK)",
   label: "Topeka (USTQK)"
  },
  {
   value: "Topeka (USTKE)",
   label: "Topeka (USTKE)"
  },
  {
   value: "Toppenish (USTPP)",
   label: "Toppenish (USTPP)"
  },
  {
   value: "Taylorville (USTBD)",
   label: "Taylorville (USTBD)"
  },
  {
   value: "Tazewell (USTZW)",
   label: "Tazewell (USTZW)"
  },
  {
   value: "Teaneck (USTEA)",
   label: "Teaneck (USTEA)"
  },
  {
   value: "Tecate (USTEC)",
   label: "Tecate (USTEC)"
  },
  {
   value: "Tecumseh (USTZZ)",
   label: "Tecumseh (USTZZ)"
  },
  {
   value: "Tecumseh (USTCU)",
   label: "Tecumseh (USTCU)"
  },
  {
   value: "Telford (USTEF)",
   label: "Telford (USTEF)"
  },
  {
   value: "Tell City (USTEL)",
   label: "Tell City (USTEL)"
  },
  {
   value: "Temecula (USTMC)",
   label: "Temecula (USTMC)"
  },
  {
   value: "Tempe (USTPE)",
   label: "Tempe (USTPE)"
  },
  {
   value: "Temperance (USTEV)",
   label: "Temperance (USTEV)"
  },
  {
   value: "Temperanceville (USTEM)",
   label: "Temperanceville (USTEM)"
  },
  {
   value: "Temple (USTPL)",
   label: "Temple (USTPL)"
  },
  {
   value: "Temple (USTML)",
   label: "Temple (USTML)"
  },
  {
   value: "Temple (USTMP)",
   label: "Temple (USTMP)"
  },
  {
   value: "Temple City (USTCI)",
   label: "Temple City (USTCI)"
  },
  {
   value: "Tennent (USTEN)",
   label: "Tennent (USTEN)"
  },
  {
   value: "Tequesta (USTEU)",
   label: "Tequesta (USTEU)"
  },
  {
   value: "Terminal Island (USTIY)",
   label: "Terminal Island (USTIY)"
  },
  {
   value: "Terre Haute (USHUF)",
   label: "Terre Haute (USHUF)"
  },
  {
   value: "Terrell (USTEE)",
   label: "Terrell (USTEE)"
  },
  {
   value: "Teterboro (USTEB)",
   label: "Teterboro (USTEB)"
  },
  {
   value: "Teutopolis (USTTX)",
   label: "Teutopolis (USTTX)"
  },
  {
   value: "Tewksbury (USTEW)",
   label: "Tewksbury (USTEW)"
  },
  {
   value: "Texarkana (USTXK)",
   label: "Texarkana (USTXK)"
  },
  {
   value: "Texarkana (USTEK)",
   label: "Texarkana (USTEK)"
  },
  {
   value: "Texas (USTXA)",
   label: "Texas (USTXA)"
  },
  {
   value: "Texas City (USTXT)",
   label: "Texas City (USTXT)"
  },
  {
   value: "Thacker (USTHK)",
   label: "Thacker (USTHK)"
  },
  {
   value: "Theodore (USTEO)",
   label: "Theodore (USTEO)"
  },
  {
   value: "Thermal (USTRM)",
   label: "Thermal (USTRM)"
  },
  {
   value: "Thibodaux (USTHI)",
   label: "Thibodaux (USTHI)"
  },
  {
   value: "Thief River Falls (USTVF)",
   label: "Thief River Falls (USTVF)"
  },
  {
   value: "Thomaston (USTHO)",
   label: "Thomaston (USTHO)"
  },
  {
   value: "Thomaston (USTHS)",
   label: "Thomaston (USTHS)"
  },
  {
   value: "Thomaston (USTSK)",
   label: "Thomaston (USTSK)"
  },
  {
   value: "Thomasville (USTVI)",
   label: "Thomasville (USTVI)"
  },
  {
   value: "Thomasville (USTHM)",
   label: "Thomasville (USTHM)"
  },
  {
   value: "Thomson (USTXN)",
   label: "Thomson (USTXN)"
  },
  {
   value: "Thomson (USTSJ)",
   label: "Thomson (USTSJ)"
  },
  {
   value: "Swepsonville (USSWZ)",
   label: "Swepsonville (USSWZ)"
  },
  {
   value: "Swissvale (USSWI)",
   label: "Swissvale (USSWI)"
  },
  {
   value: "Sycamore (USSYC)",
   label: "Sycamore (USSYC)"
  },
  {
   value: "Sylacauga (USSYU)",
   label: "Sylacauga (USSYU)"
  },
  {
   value: "Sylmar (USSYY)",
   label: "Sylmar (USSYY)"
  },
  {
   value: "Sylvania (USXMZ)",
   label: "Sylvania (USXMZ)"
  },
  {
   value: "Sylvester (USSYV)",
   label: "Sylvester (USSYV)"
  },
  {
   value: "Syosset (USSYN)",
   label: "Syosset (USSYN)"
  },
  {
   value: "Syracuse (USSYR)",
   label: "Syracuse (USSYR)"
  },
  {
   value: "Syracuse (USSYZ)",
   label: "Syracuse (USSYZ)"
  },
  {
   value: "Tabor (USXNC)",
   label: "Tabor (USXNC)"
  },
  {
   value: "Tacoma (USTIW)",
   label: "Tacoma (USTIW)"
  },
  {
   value: "Taconite-Silver Bay (USTCT)",
   label: "Taconite-Silver Bay (USTCT)"
  },
  {
   value: "Taft (USTFT)",
   label: "Taft (USTFT)"
  },
  {
   value: "Tahlequah (USTGU)",
   label: "Tahlequah (USTGU)"
  },
  {
   value: "Tahoe City (USTAC)",
   label: "Tahoe City (USTAC)"
  },
  {
   value: "Tahoka (USTAH)",
   label: "Tahoka (USTAH)"
  },
  {
   value: "Talkeetna (USTKA)",
   label: "Talkeetna (USTKA)"
  },
  {
   value: "Talladega (USASN)",
   label: "Talladega (USASN)"
  },
  {
   value: "Tallahassee (USTLH)",
   label: "Tallahassee (USTLH)"
  },
  {
   value: "Tallapoosa (USTAL)",
   label: "Tallapoosa (USTAL)"
  },
  {
   value: "Tallmadge (USTGE)",
   label: "Tallmadge (USTGE)"
  },
  {
   value: "Tamaqua (USTMQ)",
   label: "Tamaqua (USTMQ)"
  },
  {
   value: "Tampa (USTPA)",
   label: "Tampa (USTPA)"
  },
  {
   value: "Taneytown (USTFY)",
   label: "Taneytown (USTFY)"
  },
  {
   value: "Taos (USTSM)",
   label: "Taos (USTSM)"
  },
  {
   value: "Tappahannock (USTKV)",
   label: "Tappahannock (USTKV)"
  },
  {
   value: "Tappan (USTAP)",
   label: "Tappan (USTAP)"
  },
  {
   value: "Tarboro (USUZD)",
   label: "Tarboro (USUZD)"
  },
  {
   value: "Tarentum (USTTM)",
   label: "Tarentum (USTTM)"
  },
  {
   value: "Tarrant (USTNW)",
   label: "Tarrant (USTNW)"
  },
  {
   value: "Tarzana (USTZR)",
   label: "Tarzana (USTZR)"
  },
  {
   value: "Tate (USTTE)",
   label: "Tate (USTTE)"
  },
  {
   value: "Taunton (USTNS)",
   label: "Taunton (USTNS)"
  },
  {
   value: "Taylor (USXNE)",
   label: "Taylor (USXNE)"
  },
  {
   value: "Taylor (USTYP)",
   label: "Taylor (USTYP)"
  },
  {
   value: "Taylor (USTYT)",
   label: "Taylor (USTYT)"
  },
  {
   value: "Taylor (USTAO)",
   label: "Taylor (USTAO)"
  },
  {
   value: "Taylors (USTYQ)",
   label: "Taylors (USTYQ)"
  },
  {
   value: "Taylorsville (USTYN)",
   label: "Taylorsville (USTYN)"
  },
  {
   value: "Taylorsville (USTYV)",
   label: "Taylorsville (USTYV)"
  },
  {
   value: "Summit (USAAO)",
   label: "Summit (USAAO)"
  },
  {
   value: "Summitville (USSVO)",
   label: "Summitville (USSVO)"
  },
  {
   value: "Sumner (USXMH)",
   label: "Sumner (USXMH)"
  },
  {
   value: "Sumter (USSSC)",
   label: "Sumter (USSSC)"
  },
  {
   value: "Sumter (USSMS)",
   label: "Sumter (USSMS)"
  },
  {
   value: "Sun City (USSCI)",
   label: "Sun City (USSCI)"
  },
  {
   value: "Sun City (USSJY)",
   label: "Sun City (USSJY)"
  },
  {
   value: "Sun Prairie (USSPE)",
   label: "Sun Prairie (USSPE)"
  },
  {
   value: "Sun Valley (USSVY)",
   label: "Sun Valley (USSVY)"
  },
  {
   value: "Sunbury (USSRZ)",
   label: "Sunbury (USSRZ)"
  },
  {
   value: "Sunbury (USSRJ)",
   label: "Sunbury (USSRJ)"
  },
  {
   value: "Suncook (USSCJ)",
   label: "Suncook (USSCJ)"
  },
  {
   value: "Sunland (USSND)",
   label: "Sunland (USSND)"
  },
  {
   value: "Sunny Point (USSUT)",
   label: "Sunny Point (USSUT)"
  },
  {
   value: "Sunnyside (USSUY)",
   label: "Sunnyside (USSUY)"
  },
  {
   value: "Sunnyvale (USSUC)",
   label: "Sunnyvale (USSUC)"
  },
  {
   value: "Sunnyvale (USSVD)",
   label: "Sunnyvale (USSVD)"
  },
  {
   value: "Sunriver (USSRI)",
   label: "Sunriver (USSRI)"
  },
  {
   value: "Sunset Beach (USSBE)",
   label: "Sunset Beach (USSBE)"
  },
  {
   value: "Sunset Whitney Ranch (USSWE)",
   label: "Sunset Whitney Ranch (USSWE)"
  },
  {
   value: "Sunshine (USSHA)",
   label: "Sunshine (USSHA)"
  },
  {
   value: "Superior (USSUW)",
   label: "Superior (USSUW)"
  },
  {
   value: "Supreme (USSYX)",
   label: "Supreme (USSYX)"
  },
  {
   value: "Surgoinsville (USSVE)",
   label: "Surgoinsville (USSVE)"
  },
  {
   value: "Suring (USSGZ)",
   label: "Suring (USSGZ)"
  },
  {
   value: "Sussex (USSSY)",
   label: "Sussex (USSSY)"
  },
  {
   value: "Sutherlin (USSLD)",
   label: "Sutherlin (USSLD)"
  },
  {
   value: "Sutton (USSUN)",
   label: "Sutton (USSUN)"
  },
  {
   value: "Sutton (USSLQ)",
   label: "Sutton (USSLQ)"
  },
  {
   value: "Sutton (USTTO)",
   label: "Sutton (USTTO)"
  },
  {
   value: "Suwanee (USSVG)",
   label: "Suwanee (USSVG)"
  },
  {
   value: "Swainsboro (USSWJ)",
   label: "Swainsboro (USSWJ)"
  },
  {
   value: "Swannanoa (USSNO)",
   label: "Swannanoa (USSNO)"
  },
  {
   value: "Swanton (USSWQ)",
   label: "Swanton (USSWQ)"
  },
  {
   value: "Swanton (USSWA)",
   label: "Swanton (USSWA)"
  },
  {
   value: "Swedesboro (USSDS)",
   label: "Swedesboro (USSDS)"
  },
  {
   value: "Sweet Home (USHOE)",
   label: "Sweet Home (USHOE)"
  },
  {
   value: "Sweetgrass (USSWG)",
   label: "Sweetgrass (USSWG)"
  },
  {
   value: "Sweetwater (USAAJ)",
   label: "Sweetwater (USAAJ)"
  },
  {
   value: "Sweetwater (USSWW)",
   label: "Sweetwater (USSWW)"
  },
  {
   value: "Strathen (USSHZ)",
   label: "Strathen (USSHZ)"
  },
  {
   value: "Strathmere (USSMM)",
   label: "Strathmere (USSMM)"
  },
  {
   value: "Strathmore (USSMJ)",
   label: "Strathmore (USSMJ)"
  },
  {
   value: "Straughn (USUYY)",
   label: "Straughn (USUYY)"
  },
  {
   value: "Strausstown (USSTW)",
   label: "Strausstown (USSTW)"
  },
  {
   value: "Streamwood (USSMW)",
   label: "Streamwood (USSMW)"
  },
  {
   value: "Streator (USSTR)",
   label: "Streator (USSTR)"
  },
  {
   value: "Streetsboro (USSBH)",
   label: "Streetsboro (USSBH)"
  },
  {
   value: "Strinestown (USXMS)",
   label: "Strinestown (USXMS)"
  },
  {
   value: "Strong (USSXE)",
   label: "Strong (USSXE)"
  },
  {
   value: "Strongsville (USSSV)",
   label: "Strongsville (USSSV)"
  },
  {
   value: "Stroudsburg (USSDG)",
   label: "Stroudsburg (USSDG)"
  },
  {
   value: "Stuart (USSUA)",
   label: "Stuart (USSUA)"
  },
  {
   value: "Studio City (USSCY)",
   label: "Studio City (USSCY)"
  },
  {
   value: "Sturgeon Bay (USSUE)",
   label: "Sturgeon Bay (USSUE)"
  },
  {
   value: "Sturgis (USIRS)",
   label: "Sturgis (USIRS)"
  },
  {
   value: "Sturtevant (USSRX)",
   label: "Sturtevant (USSRX)"
  },
  {
   value: "Stuttgart (USSGT)",
   label: "Stuttgart (USSGT)"
  },
  {
   value: "Sublimity (USSUZ)",
   label: "Sublimity (USSUZ)"
  },
  {
   value: "Succasunna (USSQJ)",
   label: "Succasunna (USSQJ)"
  },
  {
   value: "Success (USSUQ)",
   label: "Success (USSUQ)"
  },
  {
   value: "Sudan (USSUD)",
   label: "Sudan (USSUD)"
  },
  {
   value: "Sudbury (USSUR)",
   label: "Sudbury (USSUR)"
  },
  {
   value: "Suffern (USSUJ)",
   label: "Suffern (USSUJ)"
  },
  {
   value: "Suffield (USXLV)",
   label: "Suffield (USXLV)"
  },
  {
   value: "Suffolk (USSUF)",
   label: "Suffolk (USSUF)"
  },
  {
   value: "Sugar Grove (USSGX)",
   label: "Sugar Grove (USSGX)"
  },
  {
   value: "Sugar Land (USSGR)",
   label: "Sugar Land (USSGR)"
  },
  {
   value: "Suisun (USSIX)",
   label: "Suisun (USSIX)"
  },
  {
   value: "Suisun Bay (USSUB)",
   label: "Suisun Bay (USSUB)"
  },
  {
   value: "Suitland (USSIL)",
   label: "Suitland (USSIL)"
  },
  {
   value: "Sulligent (USSUG)",
   label: "Sulligent (USSUG)"
  },
  {
   value: "Sulphur (USSLP)",
   label: "Sulphur (USSLP)"
  },
  {
   value: "Sulphur Springs (USSLR)",
   label: "Sulphur Springs (USSLR)"
  },
  {
   value: "Sumas (USACF)",
   label: "Sumas (USACF)"
  },
  {
   value: "Summerhill (USSUH)",
   label: "Summerhill (USSUH)"
  },
  {
   value: "Summersville (USSWV)",
   label: "Summersville (USSWV)"
  },
  {
   value: "Summerville (USUZC)",
   label: "Summerville (USUZC)"
  },
  {
   value: "Summit (USSMZ)",
   label: "Summit (USSMZ)"
  },
  {
   value: "Summit (USXMV)",
   label: "Summit (USXMV)"
  },
  {
   value: "Summit (USUYX)",
   label: "Summit (USUYX)"
  },
  {
   value: "Statesboro (USTBR)",
   label: "Statesboro (USTBR)"
  },
  {
   value: "Statesville (USSVH)",
   label: "Statesville (USSVH)"
  },
  {
   value: "Staunton (USSHD)",
   label: "Staunton (USSHD)"
  },
  {
   value: "Stayton (USSAY)",
   label: "Stayton (USSAY)"
  },
  {
   value: "Steamboat Springs (USSBS)",
   label: "Steamboat Springs (USSBS)"
  },
  {
   value: "Steilacoom (USSIC)",
   label: "Steilacoom (USSIC)"
  },
  {
   value: "Stephenville (USSEP)",
   label: "Stephenville (USSEP)"
  },
  {
   value: "Sterling (USSGV)",
   label: "Sterling (USSGV)"
  },
  {
   value: "Sterling (USSEK)",
   label: "Sterling (USSEK)"
  },
  {
   value: "Sterling (USXLS)",
   label: "Sterling (USXLS)"
  },
  {
   value: "Sterling (USSGI)",
   label: "Sterling (USSGI)"
  },
  {
   value: "Sterling (USSIG)",
   label: "Sterling (USSIG)"
  },
  {
   value: "Sterling (USSTK)",
   label: "Sterling (USSTK)"
  },
  {
   value: "Sterling Heights (USSEH)",
   label: "Sterling Heights (USSEH)"
  },
  {
   value: "Sterlington (USSEX)",
   label: "Sterlington (USSEX)"
  },
  {
   value: "Steubenville (USUYJ)",
   label: "Steubenville (USUYJ)"
  },
  {
   value: "Stevens Point (USSTE)",
   label: "Stevens Point (USSTE)"
  },
  {
   value: "Stevenson (USSJZ)",
   label: "Stevenson (USSJZ)"
  },
  {
   value: "Stevensville (USSVV)",
   label: "Stevensville (USSVV)"
  },
  {
   value: "Stillwater (USSWO)",
   label: "Stillwater (USSWO)"
  },
  {
   value: "Stockbridge (USSKB)",
   label: "Stockbridge (USSKB)"
  },
  {
   value: "Stockertown (USSTT)",
   label: "Stockertown (USSTT)"
  },
  {
   value: "Stockton (USSCK)",
   label: "Stockton (USSCK)"
  },
  {
   value: "Stone (USSTO)",
   label: "Stone (USSTO)"
  },
  {
   value: "Stone Mountain (USSMU)",
   label: "Stone Mountain (USSMU)"
  },
  {
   value: "Stoneham (USSTU)",
   label: "Stoneham (USSTU)"
  },
  {
   value: "Stonehurst (USSHT)",
   label: "Stonehurst (USSHT)"
  },
  {
   value: "Stoneville (USSVX)",
   label: "Stoneville (USSVX)"
  },
  {
   value: "Stoneville (USSTV)",
   label: "Stoneville (USSTV)"
  },
  {
   value: "Stonewall (USSWL)",
   label: "Stonewall (USSWL)"
  },
  {
   value: "Storm Lake (USSLB)",
   label: "Storm Lake (USSLB)"
  },
  {
   value: "Stoughton (USSOU)",
   label: "Stoughton (USSOU)"
  },
  {
   value: "Stow (USSWT)",
   label: "Stow (USSWT)"
  },
  {
   value: "Stow (USMMN)",
   label: "Stow (USMMN)"
  },
  {
   value: "Strafford (USSFF)",
   label: "Strafford (USSFF)"
  },
  {
   value: "Strasburg (USSBG)",
   label: "Strasburg (USSBG)"
  },
  {
   value: "Strasburg (USSRS)",
   label: "Strasburg (USSRS)"
  },
  {
   value: "Stratford (USJSD)",
   label: "Stratford (USJSD)"
  },
  {
   value: "Stratford (USSDZ)",
   label: "Stratford (USSDZ)"
  },
  {
   value: "Stratham (USSMH)",
   label: "Stratham (USSMH)"
  },
  {
   value: "Springfield (USSFY)",
   label: "Springfield (USSFY)"
  },
  {
   value: "Springfield (USSFK)",
   label: "Springfield (USSFK)"
  },
  {
   value: "Springfield (USSPI)",
   label: "Springfield (USSPI)"
  },
  {
   value: "Springhill (USSIQ)",
   label: "Springhill (USSIQ)"
  },
  {
   value: "Springville (USSPL)",
   label: "Springville (USSPL)"
  },
  {
   value: "Springville (USXMN)",
   label: "Springville (USXMN)"
  },
  {
   value: "Spruce Pine (USSPU)",
   label: "Spruce Pine (USSPU)"
  },
  {
   value: "Squaw Valley (USSQT)",
   label: "Squaw Valley (USSQT)"
  },
  {
   value: "St Albans (USSTA)",
   label: "St Albans (USSTA)"
  },
  {
   value: "St Albans-Quincy (USQAD)",
   label: "St Albans-Quincy (USQAD)"
  },
  {
   value: "St George Island (USSTG)",
   label: "St George Island (USSTG)"
  },
  {
   value: "St Helens (USSTH)",
   label: "St Helens (USSTH)"
  },
  {
   value: "St John (USSJN)",
   label: "St John (USSJN)"
  },
  {
   value: "St Joseph (USSTJ)",
   label: "St Joseph (USSTJ)"
  },
  {
   value: "St Joseph (USSJS)",
   label: "St Joseph (USSJS)"
  },
  {
   value: "St Louis (USSTL)",
   label: "St Louis (USSTL)"
  },
  {
   value: "St Paul (USPUL)",
   label: "St Paul (USPUL)"
  },
  {
   value: "St Paul (USSTP)",
   label: "St Paul (USSTP)"
  },
  {
   value: "St Petersburg (USPIE)",
   label: "St Petersburg (USPIE)"
  },
  {
   value: "St Rose (USSRE)",
   label: "St Rose (USSRE)"
  },
  {
   value: "Stafford (USSTB)",
   label: "Stafford (USSTB)"
  },
  {
   value: "Stafford (USSTD)",
   label: "Stafford (USSTD)"
  },
  {
   value: "Stafford Springs (USSFC)",
   label: "Stafford Springs (USSFC)"
  },
  {
   value: "Staley (USSZY)",
   label: "Staley (USSZY)"
  },
  {
   value: "Stamford (USSTF)",
   label: "Stamford (USSTF)"
  },
  {
   value: "Stamford (USXLX)",
   label: "Stamford (USXLX)"
  },
  {
   value: "Stamford (USSDJ)",
   label: "Stamford (USSDJ)"
  },
  {
   value: "Stamps (USSTM)",
   label: "Stamps (USSTM)"
  },
  {
   value: "Stanhope (USSTN)",
   label: "Stanhope (USSTN)"
  },
  {
   value: "Stanley (USUZA)",
   label: "Stanley (USUZA)"
  },
  {
   value: "Stanley (USSYJ)",
   label: "Stanley (USSYJ)"
  },
  {
   value: "Stanleytown (USSZT)",
   label: "Stanleytown (USSZT)"
  },
  {
   value: "Stanton (USSTI)",
   label: "Stanton (USSTI)"
  },
  {
   value: "Stanton (USSTX)",
   label: "Stanton (USSTX)"
  },
  {
   value: "Stanwood (USSNW)",
   label: "Stanwood (USSNW)"
  },
  {
   value: "Starke (USXMU)",
   label: "Starke (USXMU)"
  },
  {
   value: "Starkville (USSTQ)",
   label: "Starkville (USSTQ)"
  },
  {
   value: "Startex (USXMT)",
   label: "Startex (USXMT)"
  },
  {
   value: "State College (USSCE)",
   label: "State College (USSCE)"
  },
  {
   value: "Staten Island (USUYU)",
   label: "Staten Island (USUYU)"
  },
  {
   value: "Sparrows Point (USSRT)",
   label: "Sparrows Point (USSRT)"
  },
  {
   value: "Sparta (USSQH)",
   label: "Sparta (USSQH)"
  },
  {
   value: "Sparta (USSZA)",
   label: "Sparta (USSZA)"
  },
  {
   value: "Sparta (USSPX)",
   label: "Sparta (USSPX)"
  },
  {
   value: "Sparta (USCMY)",
   label: "Sparta (USCMY)"
  },
  {
   value: "Sparta (USSAR)",
   label: "Sparta (USSAR)"
  },
  {
   value: "Spartanburg (USSPA)",
   label: "Spartanburg (USSPA)"
  },
  {
   value: "Spenard (USSNX)",
   label: "Spenard (USSNX)"
  },
  {
   value: "Spencer (USSPP)",
   label: "Spencer (USSPP)"
  },
  {
   value: "Spencer (USSPC)",
   label: "Spencer (USSPC)"
  },
  {
   value: "Spencer (USSPW)",
   label: "Spencer (USSPW)"
  },
  {
   value: "Spencer (USSNZ)",
   label: "Spencer (USSNZ)"
  },
  {
   value: "Spencer (USSCM)",
   label: "Spencer (USSCM)"
  },
  {
   value: "Spikewook (USSKW)",
   label: "Spikewook (USSKW)"
  },
  {
   value: "Spindale (USSEQ)",
   label: "Spindale (USSEQ)"
  },
  {
   value: "Spirit Lake (USRTL)",
   label: "Spirit Lake (USRTL)"
  },
  {
   value: "Spirit Of St Louis Apt\/St Louis (USSUS)",
   label: "Spirit Of St Louis Apt\/St Louis (USSUS)"
  },
  {
   value: "Spokane (USGEG)",
   label: "Spokane (USGEG)"
  },
  {
   value: "Spooner (USSPO)",
   label: "Spooner (USSPO)"
  },
  {
   value: "Spotswood (USSAW)",
   label: "Spotswood (USSAW)"
  },
  {
   value: "Spring (USABS)",
   label: "Spring (USABS)"
  },
  {
   value: "Spring City (USUYL)",
   label: "Spring City (USUYL)"
  },
  {
   value: "Spring City (USSIY)",
   label: "Spring City (USSIY)"
  },
  {
   value: "Spring Hill (USSHI)",
   label: "Spring Hill (USSHI)"
  },
  {
   value: "Spring Hope (USSRO)",
   label: "Spring Hope (USSRO)"
  },
  {
   value: "Spring House (USSGU)",
   label: "Spring House (USSGU)"
  },
  {
   value: "Spring Park (USSOS)",
   label: "Spring Park (USSOS)"
  },
  {
   value: "Spring Valley (USSPV)",
   label: "Spring Valley (USSPV)"
  },
  {
   value: "Spring Valley (USSPN)",
   label: "Spring Valley (USSPN)"
  },
  {
   value: "Springboro (USSQO)",
   label: "Springboro (USSQO)"
  },
  {
   value: "Springdale (USSRL)",
   label: "Springdale (USSRL)"
  },
  {
   value: "Springdale (USSPD)",
   label: "Springdale (USSPD)"
  },
  {
   value: "Springdale (USSPZ)",
   label: "Springdale (USSPZ)"
  },
  {
   value: "Springfield (USSGF)",
   label: "Springfield (USSGF)"
  },
  {
   value: "Springfield (USSFI)",
   label: "Springfield (USSFI)"
  },
  {
   value: "Springfield (USSGH)",
   label: "Springfield (USSGH)"
  },
  {
   value: "Springfield (USSPY)",
   label: "Springfield (USSPY)"
  },
  {
   value: "Springfield (USSRG)",
   label: "Springfield (USSRG)"
  },
  {
   value: "Springfield (USSPG)",
   label: "Springfield (USSPG)"
  },
  {
   value: "Springfield (USVSF)",
   label: "Springfield (USVSF)"
  },
  {
   value: "South Lee (USSDT)",
   label: "South Lee (USSDT)"
  },
  {
   value: "South Miami (USXMF)",
   label: "South Miami (USXMF)"
  },
  {
   value: "South Norwalk (USSON)",
   label: "South Norwalk (USSON)"
  },
  {
   value: "South Paris (USSSA)",
   label: "South Paris (USSSA)"
  },
  {
   value: "South Pasadena (USSSD)",
   label: "South Pasadena (USSSD)"
  },
  {
   value: "South Pierce (USSSQ)",
   label: "South Pierce (USSSQ)"
  },
  {
   value: "South Pittsburg (USSWU)",
   label: "South Pittsburg (USSWU)"
  },
  {
   value: "South Plainfield (USSPF)",
   label: "South Plainfield (USSPF)"
  },
  {
   value: "South Point (USSPH)",
   label: "South Point (USSPH)"
  },
  {
   value: "South Portland (USSOX)",
   label: "South Portland (USSOX)"
  },
  {
   value: "South Range (USSSP)",
   label: "South Range (USSSP)"
  },
  {
   value: "South River (USSST)",
   label: "South River (USSST)"
  },
  {
   value: "South River (USSSE)",
   label: "South River (USSSE)"
  },
  {
   value: "South San Francisco (USSYF)",
   label: "South San Francisco (USSYF)"
  },
  {
   value: "South Shore (USSSH)",
   label: "South Shore (USSSH)"
  },
  {
   value: "South Sioux City (USSSU)",
   label: "South Sioux City (USSSU)"
  },
  {
   value: "South Warwick (USSWR)",
   label: "South Warwick (USSWR)"
  },
  {
   value: "South West Miami (USSWM)",
   label: "South West Miami (USSWM)"
  },
  {
   value: "South Windham (USSWX)",
   label: "South Windham (USSWX)"
  },
  {
   value: "South Windsor (USXMM)",
   label: "South Windsor (USXMM)"
  },
  {
   value: "Southampton (USSJL)",
   label: "Southampton (USSJL)"
  },
  {
   value: "Southampton (USSSK)",
   label: "Southampton (USSSK)"
  },
  {
   value: "Southard (USSSF)",
   label: "Southard (USSSF)"
  },
  {
   value: "Southaven (USSVQ)",
   label: "Southaven (USSVQ)"
  },
  {
   value: "Southborough (USSZV)",
   label: "Southborough (USSZV)"
  },
  {
   value: "Southbury (USSBU)",
   label: "Southbury (USSBU)"
  },
  {
   value: "Southern Pines (USSOP)",
   label: "Southern Pines (USSOP)"
  },
  {
   value: "Southfield (USSFJ)",
   label: "Southfield (USSFJ)"
  },
  {
   value: "Southgate (USSFA)",
   label: "Southgate (USSFA)"
  },
  {
   value: "Southington (USSNG)",
   label: "Southington (USSNG)"
  },
  {
   value: "Southlake (USZLE)",
   label: "Southlake (USZLE)"
  },
  {
   value: "Southport (USXMK)",
   label: "Southport (USXMK)"
  },
  {
   value: "Southwark (USXMR)",
   label: "Southwark (USXMR)"
  },
  {
   value: "Spanaway (USSWY)",
   label: "Spanaway (USSWY)"
  },
  {
   value: "Spanish Fork (USSFU)",
   label: "Spanish Fork (USSFU)"
  },
  {
   value: "Sparks (USSRM)",
   label: "Sparks (USSRM)"
  },
  {
   value: "Sparks (USSPM)",
   label: "Sparks (USSPM)"
  },
  {
   value: "Sparks (USSPK)",
   label: "Sparks (USSPK)"
  },
  {
   value: "Solana Beach (USSZB)",
   label: "Solana Beach (USSZB)"
  },
  {
   value: "Soldotna (USSXQ)",
   label: "Soldotna (USSXQ)"
  },
  {
   value: "Solomon (USSBO)",
   label: "Solomon (USSBO)"
  },
  {
   value: "Solon (USSOO)",
   label: "Solon (USSOO)"
  },
  {
   value: "Somerdale (USSMV)",
   label: "Somerdale (USSMV)"
  },
  {
   value: "Somerset (USSZR)",
   label: "Somerset (USSZR)"
  },
  {
   value: "Somerset (USSOZ)",
   label: "Somerset (USSOZ)"
  },
  {
   value: "Somerset (USSOJ)",
   label: "Somerset (USSOJ)"
  },
  {
   value: "Somerset (USSME)",
   label: "Somerset (USSME)"
  },
  {
   value: "Somersworth (USSSX)",
   label: "Somersworth (USSSX)"
  },
  {
   value: "Somerville (USSOM)",
   label: "Somerville (USSOM)"
  },
  {
   value: "Somerville (USUZB)",
   label: "Somerville (USUZB)"
  },
  {
   value: "Somis (USSSJ)",
   label: "Somis (USSSJ)"
  },
  {
   value: "Sonoma (USSOY)",
   label: "Sonoma (USSOY)"
  },
  {
   value: "Sonora (USSOR)",
   label: "Sonora (USSOR)"
  },
  {
   value: "Sophia (USSAZ)",
   label: "Sophia (USSAZ)"
  },
  {
   value: "Soquel (USSOL)",
   label: "Soquel (USSOL)"
  },
  {
   value: "Souderton (USSOT)",
   label: "Souderton (USSOT)"
  },
  {
   value: "South Bay (USSOF)",
   label: "South Bay (USSOF)"
  },
  {
   value: "South Beloit (USSBL)",
   label: "South Beloit (USSBL)"
  },
  {
   value: "South Bend (USSBN)",
   label: "South Bend (USSBN)"
  },
  {
   value: "South Bend (USACJ)",
   label: "South Bend (USACJ)"
  },
  {
   value: "South Bond-Raymond (USSBR)",
   label: "South Bond-Raymond (USSBR)"
  },
  {
   value: "South Boston (USSOG)",
   label: "South Boston (USSOG)"
  },
  {
   value: "South Boston (USSBC)",
   label: "South Boston (USSBC)"
  },
  {
   value: "South Brunswick (USXLN)",
   label: "South Brunswick (USXLN)"
  },
  {
   value: "South Charleston (USSCT)",
   label: "South Charleston (USSCT)"
  },
  {
   value: "South Dayton (USSOI)",
   label: "South Dayton (USSOI)"
  },
  {
   value: "South El Monte (USSDM)",
   label: "South El Monte (USSDM)"
  },
  {
   value: "South Gate (USSGC)",
   label: "South Gate (USSGC)"
  },
  {
   value: "South Grafton (USSOQ)",
   label: "South Grafton (USSOQ)"
  },
  {
   value: "South Hadley (USSYM)",
   label: "South Hadley (USSYM)"
  },
  {
   value: "South Haven (USUYT)",
   label: "South Haven (USUYT)"
  },
  {
   value: "South Haven (USSOH)",
   label: "South Haven (USSOH)"
  },
  {
   value: "South Hill (USSDO)",
   label: "South Hill (USSDO)"
  },
  {
   value: "South Holland (USSUI)",
   label: "South Holland (USSUI)"
  },
  {
   value: "South Johnson City (USSDR)",
   label: "South Johnson City (USSDR)"
  },
  {
   value: "South Kearny (USSKY)",
   label: "South Kearny (USSKY)"
  },
  {
   value: "South Lake Tahoe (USTVL)",
   label: "South Lake Tahoe (USTVL)"
  },
  {
   value: "Sixela (USSXM)",
   label: "Sixela (USSXM)"
  },
  {
   value: "Skagway (USSGY)",
   label: "Skagway (USSGY)"
  },
  {
   value: "Skillman (USSQM)",
   label: "Skillman (USSQM)"
  },
  {
   value: "Skokie (USSOK)",
   label: "Skokie (USSOK)"
  },
  {
   value: "Skowkegan (USSKO)",
   label: "Skowkegan (USSKO)"
  },
  {
   value: "Skyland (USUYZ)",
   label: "Skyland (USUYZ)"
  },
  {
   value: "Slate Hill (USSVK)",
   label: "Slate Hill (USSVK)"
  },
  {
   value: "Slater (USSVM)",
   label: "Slater (USSVM)"
  },
  {
   value: "Slatersville (USSLV)",
   label: "Slatersville (USSLV)"
  },
  {
   value: "Slatington (USSVP)",
   label: "Slatington (USSVP)"
  },
  {
   value: "Slaton (USXME)",
   label: "Slaton (USXME)"
  },
  {
   value: "Sledge (USSLJ)",
   label: "Sledge (USSLJ)"
  },
  {
   value: "Sleepy Eye (USSYE)",
   label: "Sleepy Eye (USSYE)"
  },
  {
   value: "Slidell (USUYN)",
   label: "Slidell (USUYN)"
  },
  {
   value: "Slippery Rock (USSVT)",
   label: "Slippery Rock (USSVT)"
  },
  {
   value: "Smartt (USSDB)",
   label: "Smartt (USSDB)"
  },
  {
   value: "Smith's Bluff (USSML)",
   label: "Smith's Bluff (USSML)"
  },
  {
   value: "Smithfield (USSMT)",
   label: "Smithfield (USSMT)"
  },
  {
   value: "Smithfield (USSFZ)",
   label: "Smithfield (USSFZ)"
  },
  {
   value: "Smithfield (USUYV)",
   label: "Smithfield (USUYV)"
  },
  {
   value: "Smithfield (USSMF)",
   label: "Smithfield (USSMF)"
  },
  {
   value: "Smithfield (USSDE)",
   label: "Smithfield (USSDE)"
  },
  {
   value: "Smiths Creek (USSDF)",
   label: "Smiths Creek (USSDF)"
  },
  {
   value: "Smithtown (USSVW)",
   label: "Smithtown (USSVW)"
  },
  {
   value: "Smithville (USSMI)",
   label: "Smithville (USSMI)"
  },
  {
   value: "Smyrna (USSDK)",
   label: "Smyrna (USSDK)"
  },
  {
   value: "Smyrna (USSMY)",
   label: "Smyrna (USSMY)"
  },
  {
   value: "Smyrna (USMQY)",
   label: "Smyrna (USMQY)"
  },
  {
   value: "Snead (USSDD)",
   label: "Snead (USSDD)"
  },
  {
   value: "Sneedville (USSQY)",
   label: "Sneedville (USSQY)"
  },
  {
   value: "Sneedville (USSZQ)",
   label: "Sneedville (USSZQ)"
  },
  {
   value: "Snowflake (USSFL)",
   label: "Snowflake (USSFL)"
  },
  {
   value: "Snyder (USSNK)",
   label: "Snyder (USSNK)"
  },
  {
   value: "Snyder (USSSN)",
   label: "Snyder (USSSN)"
  },
  {
   value: "Society Hill (USSXS)",
   label: "Society Hill (USSXS)"
  },
  {
   value: "Socorro (USONM)",
   label: "Socorro (USONM)"
  },
  {
   value: "Soddy City (USUYM)",
   label: "Soddy City (USUYM)"
  },
  {
   value: "Soddy-Daisy (USXML)",
   label: "Soddy-Daisy (USXML)"
  },
  {
   value: "Sodus (USSOB)",
   label: "Sodus (USSOB)"
  },
  {
   value: "Sodus (USUYO)",
   label: "Sodus (USUYO)"
  },
  {
   value: "Sodus Point (USSOD)",
   label: "Sodus Point (USSOD)"
  },
  {
   value: "Sherrard (USSJK)",
   label: "Sherrard (USSJK)"
  },
  {
   value: "Sherwood (USSJU)",
   label: "Sherwood (USSJU)"
  },
  {
   value: "Sherwood (USSHW)",
   label: "Sherwood (USSHW)"
  },
  {
   value: "Shickshinny (USSVB)",
   label: "Shickshinny (USSVB)"
  },
  {
   value: "Shippensburg (USSVC)",
   label: "Shippensburg (USSVC)"
  },
  {
   value: "Shiremanstown (USSVF)",
   label: "Shiremanstown (USSVF)"
  },
  {
   value: "Shirley (USSJR)",
   label: "Shirley (USSJR)"
  },
  {
   value: "Shoreham (USXLZ)",
   label: "Shoreham (USXLZ)"
  },
  {
   value: "Shoreham (USSRH)",
   label: "Shoreham (USSRH)"
  },
  {
   value: "Shorewood (USSJV)",
   label: "Shorewood (USSJV)"
  },
  {
   value: "Show Low (USSOW)",
   label: "Show Low (USSOW)"
  },
  {
   value: "Showell (USSIH)",
   label: "Showell (USSIH)"
  },
  {
   value: "Shreveport (USSHV)",
   label: "Shreveport (USSHV)"
  },
  {
   value: "Shrewsbury (USSHU)",
   label: "Shrewsbury (USSHU)"
  },
  {
   value: "Shrub Oak (USSHK)",
   label: "Shrub Oak (USSHK)"
  },
  {
   value: "Sidney (USSNY)",
   label: "Sidney (USSNY)"
  },
  {
   value: "Sidney (USSXY)",
   label: "Sidney (USSXY)"
  },
  {
   value: "Sidney (USSNP)",
   label: "Sidney (USSNP)"
  },
  {
   value: "Sierra Madre (USSIM)",
   label: "Sierra Madre (USSIM)"
  },
  {
   value: "Signal Hill (USSII)",
   label: "Signal Hill (USSII)"
  },
  {
   value: "Sikeston (USSIK)",
   label: "Sikeston (USSIK)"
  },
  {
   value: "Siler City (USSIR)",
   label: "Siler City (USSIR)"
  },
  {
   value: "Siloam Springs (USSLG)",
   label: "Siloam Springs (USSLG)"
  },
  {
   value: "Silsbee (USXLP)",
   label: "Silsbee (USXLP)"
  },
  {
   value: "Silver Bay (USSIB)",
   label: "Silver Bay (USSIB)"
  },
  {
   value: "Silver City (USSZI)",
   label: "Silver City (USSZI)"
  },
  {
   value: "Silver Creek (USSXV)",
   label: "Silver Creek (USSXV)"
  },
  {
   value: "Silver Spring (USSIS)",
   label: "Silver Spring (USSIS)"
  },
  {
   value: "Silver Springs (USSIE)",
   label: "Silver Springs (USSIE)"
  },
  {
   value: "Silver Springs (USSVS)",
   label: "Silver Springs (USSVS)"
  },
  {
   value: "Silverdale (USSIF)",
   label: "Silverdale (USSIF)"
  },
  {
   value: "Simi Valley (USSIU)",
   label: "Simi Valley (USSIU)"
  },
  {
   value: "Simpsonville (USSRY)",
   label: "Simpsonville (USSRY)"
  },
  {
   value: "Simpsonville (USSIJ)",
   label: "Simpsonville (USSIJ)"
  },
  {
   value: "Singer Island (USSIN)",
   label: "Singer Island (USSIN)"
  },
  {
   value: "Sinking Springs (USSKS)",
   label: "Sinking Springs (USSKS)"
  },
  {
   value: "Sioux Center (USSNT)",
   label: "Sioux Center (USSNT)"
  },
  {
   value: "Sioux City (USSUX)",
   label: "Sioux City (USSUX)"
  },
  {
   value: "Sioux Falls (USFSD)",
   label: "Sioux Falls (USFSD)"
  },
  {
   value: "Sitka (USSIT)",
   label: "Sitka (USSIT)"
  },
  {
   value: "Sharon Hill (USSHL)",
   label: "Sharon Hill (USSHL)"
  },
  {
   value: "Sharon Springs (USSHS)",
   label: "Sharon Springs (USSHS)"
  },
  {
   value: "Sharonville (USXMA)",
   label: "Sharonville (USXMA)"
  },
  {
   value: "Shattuck (USSUK)",
   label: "Shattuck (USSUK)"
  },
  {
   value: "Shawano (USSWS)",
   label: "Shawano (USSWS)"
  },
  {
   value: "Shawnee (USSNL)",
   label: "Shawnee (USSNL)"
  },
  {
   value: "Shawnee (USSHC)",
   label: "Shawnee (USSHC)"
  },
  {
   value: "Shawnee Mission (USSHB)",
   label: "Shawnee Mission (USSHB)"
  },
  {
   value: "Sheboygan (USSBM)",
   label: "Sheboygan (USSBM)"
  },
  {
   value: "Sheboygan Falls (USSBF)",
   label: "Sheboygan Falls (USSBF)"
  },
  {
   value: "Sheffield (USSHF)",
   label: "Sheffield (USSHF)"
  },
  {
   value: "Shelby (USSEY)",
   label: "Shelby (USSEY)"
  },
  {
   value: "Shelby (USSBX)",
   label: "Shelby (USSBX)"
  },
  {
   value: "Shelby (USSHG)",
   label: "Shelby (USSHG)"
  },
  {
   value: "Shelby (USSHH)",
   label: "Shelby (USSHH)"
  },
  {
   value: "Shelbyville (USSQG)",
   label: "Shelbyville (USSQG)"
  },
  {
   value: "Shelbyville (USSYI)",
   label: "Shelbyville (USSYI)"
  },
  {
   value: "Shelbyville (USSVZ)",
   label: "Shelbyville (USSVZ)"
  },
  {
   value: "Shelbyville (USSYH)",
   label: "Shelbyville (USSYH)"
  },
  {
   value: "Shelbyville (USSBV)",
   label: "Shelbyville (USSBV)"
  },
  {
   value: "Sheldon (USXMB)",
   label: "Sheldon (USXMB)"
  },
  {
   value: "Sheldon (USSQP)",
   label: "Sheldon (USSQP)"
  },
  {
   value: "Sheldon (USSEI)",
   label: "Sheldon (USSEI)"
  },
  {
   value: "Sheldon Springs (USSQK)",
   label: "Sheldon Springs (USSQK)"
  },
  {
   value: "Shellman (USXMC)",
   label: "Shellman (USXMC)"
  },
  {
   value: "Shelton (USSQR)",
   label: "Shelton (USSQR)"
  },
  {
   value: "Shelton (USSHN)",
   label: "Shelton (USSHN)"
  },
  {
   value: "Shenandoah (USSQA)",
   label: "Shenandoah (USSQA)"
  },
  {
   value: "Shenandoah (USUYS)",
   label: "Shenandoah (USUYS)"
  },
  {
   value: "Shenandoah (USSZH)",
   label: "Shenandoah (USSZH)"
  },
  {
   value: "Shepherdsville (USSQN)",
   label: "Shepherdsville (USSQN)"
  },
  {
   value: "Sherburne (USSRR)",
   label: "Sherburne (USSRR)"
  },
  {
   value: "Sheridan (USSIW)",
   label: "Sheridan (USSIW)"
  },
  {
   value: "Sheridan (USSJG)",
   label: "Sheridan (USSJG)"
  },
  {
   value: "Sheridan (USSHR)",
   label: "Sheridan (USSHR)"
  },
  {
   value: "Sheriden (USSRD)",
   label: "Sheriden (USSRD)"
  },
  {
   value: "Sherman (USXMP)",
   label: "Sherman (USXMP)"
  },
  {
   value: "Sherman (USSZM)",
   label: "Sherman (USSZM)"
  },
  {
   value: "Sherman (USSHP)",
   label: "Sherman (USSHP)"
  },
  {
   value: "Sherman Oaks (USSJJ)",
   label: "Sherman Oaks (USSJJ)"
  },
  {
   value: "Sellersburg (USSEU)",
   label: "Sellersburg (USSEU)"
  },
  {
   value: "Selma (USSQC)",
   label: "Selma (USSQC)"
  },
  {
   value: "Selma (USSQD)",
   label: "Selma (USSQD)"
  },
  {
   value: "Selma (USSQZ)",
   label: "Selma (USSQZ)"
  },
  {
   value: "Selma (USSES)",
   label: "Selma (USSES)"
  },
  {
   value: "Selmer (USSQE)",
   label: "Selmer (USSQE)"
  },
  {
   value: "Seminole (USSOE)",
   label: "Seminole (USSOE)"
  },
  {
   value: "Seminole (USXMD)",
   label: "Seminole (USXMD)"
  },
  {
   value: "Senatobia (USSEN)",
   label: "Senatobia (USSEN)"
  },
  {
   value: "Seneca (USXMI)",
   label: "Seneca (USXMI)"
  },
  {
   value: "Seneca (USSQW)",
   label: "Seneca (USSQW)"
  },
  {
   value: "Seneca (USSNE)",
   label: "Seneca (USSNE)"
  },
  {
   value: "Seneca (USUYP)",
   label: "Seneca (USUYP)"
  },
  {
   value: "Seneca Falls (USSCC)",
   label: "Seneca Falls (USSCC)"
  },
  {
   value: "Senecaville (USXMJ)",
   label: "Senecaville (USXMJ)"
  },
  {
   value: "Sepulveda (USSQF)",
   label: "Sepulveda (USSQF)"
  },
  {
   value: "Sequim (USSQV)",
   label: "Sequim (USSQV)"
  },
  {
   value: "Severn (USSEV)",
   label: "Severn (USSEV)"
  },
  {
   value: "Severn (USSVN)",
   label: "Severn (USSVN)"
  },
  {
   value: "Severn (USSVJ)",
   label: "Severn (USSVJ)"
  },
  {
   value: "Severna Park (USSNR)",
   label: "Severna Park (USSNR)"
  },
  {
   value: "Sevier (USSXR)",
   label: "Sevier (USSXR)"
  },
  {
   value: "Sevierville (USSVU)",
   label: "Sevierville (USSVU)"
  },
  {
   value: "Sewanee (USUOS)",
   label: "Sewanee (USUOS)"
  },
  {
   value: "Seward (USSWD)",
   label: "Seward (USSWD)"
  },
  {
   value: "Seward (USSEW)",
   label: "Seward (USSEW)"
  },
  {
   value: "Sewaren (USSWN)",
   label: "Sewaren (USSWN)"
  },
  {
   value: "Sewells Point (USSWP)",
   label: "Sewells Point (USSWP)"
  },
  {
   value: "Seymour (USSZK)",
   label: "Seymour (USSZK)"
  },
  {
   value: "Seymour (USSER)",
   label: "Seymour (USSER)"
  },
  {
   value: "Seymour (USSEJ)",
   label: "Seymour (USSEJ)"
  },
  {
   value: "Seymour (USSET)",
   label: "Seymour (USSET)"
  },
  {
   value: "Seymour (USSYW)",
   label: "Seymour (USSYW)"
  },
  {
   value: "Shady Dale (USSZJ)",
   label: "Shady Dale (USSZJ)"
  },
  {
   value: "Shady Side (USSHY)",
   label: "Shady Side (USSHY)"
  },
  {
   value: "Shafter (USMIT)",
   label: "Shafter (USMIT)"
  },
  {
   value: "Shakopee (USSKE)",
   label: "Shakopee (USSKE)"
  },
  {
   value: "Shaller (USSJI)",
   label: "Shaller (USSJI)"
  },
  {
   value: "Shannon (USSZN)",
   label: "Shannon (USSZN)"
  },
  {
   value: "Shannon (USSHO)",
   label: "Shannon (USSHO)"
  },
  {
   value: "Sharon (USSHQ)",
   label: "Sharon (USSHQ)"
  },
  {
   value: "Sharon (USSHM)",
   label: "Sharon (USSHM)"
  },
  {
   value: "Scotland Neck (USSCD)",
   label: "Scotland Neck (USSCD)"
  },
  {
   value: "Scott City (USSCQ)",
   label: "Scott City (USSCQ)"
  },
  {
   value: "Scottdale (USSZD)",
   label: "Scottdale (USSZD)"
  },
  {
   value: "Scottdale (USSZE)",
   label: "Scottdale (USSZE)"
  },
  {
   value: "Scottland Neck (USSNC)",
   label: "Scottland Neck (USSNC)"
  },
  {
   value: "Scottsbluff (USBFF)",
   label: "Scottsbluff (USBFF)"
  },
  {
   value: "Scottsboro (USSCB)",
   label: "Scottsboro (USSCB)"
  },
  {
   value: "Scottsburg (USSCR)",
   label: "Scottsburg (USSCR)"
  },
  {
   value: "Scottsdale (USSTZ)",
   label: "Scottsdale (USSTZ)"
  },
  {
   value: "Scottsville (USSCV)",
   label: "Scottsville (USSCV)"
  },
  {
   value: "Scottsville (USSZF)",
   label: "Scottsville (USSZF)"
  },
  {
   value: "Scottville (USSCN)",
   label: "Scottville (USSCN)"
  },
  {
   value: "Seabrook (USSEO)",
   label: "Seabrook (USSEO)"
  },
  {
   value: "Seabrook (USSBJ)",
   label: "Seabrook (USSBJ)"
  },
  {
   value: "Seadrift (USXLR)",
   label: "Seadrift (USXLR)"
  },
  {
   value: "Seaford (USSFE)",
   label: "Seaford (USSFE)"
  },
  {
   value: "Seagoville (USSVI)",
   label: "Seagoville (USSVI)"
  },
  {
   value: "Seagraves (USSGK)",
   label: "Seagraves (USSGK)"
  },
  {
   value: "Seal Beach (USSLH)",
   label: "Seal Beach (USSLH)"
  },
  {
   value: "Sealy (USSLY)",
   label: "Sealy (USSLY)"
  },
  {
   value: "Searcy (USSRC)",
   label: "Searcy (USSRC)"
  },
  {
   value: "Searsport (USSRP)",
   label: "Searsport (USSRP)"
  },
  {
   value: "Seaside (USXLU)",
   label: "Seaside (USXLU)"
  },
  {
   value: "Seatac (USSEZ)",
   label: "Seatac (USSEZ)"
  },
  {
   value: "Seattle (USSEA)",
   label: "Seattle (USSEA)"
  },
  {
   value: "Sebastian (USXNB)",
   label: "Sebastian (USXNB)"
  },
  {
   value: "Sebastian (USSZG)",
   label: "Sebastian (USSZG)"
  },
  {
   value: "Sebastopol (USSYD)",
   label: "Sebastopol (USSYD)"
  },
  {
   value: "Sebastopol (USXLO)",
   label: "Sebastopol (USXLO)"
  },
  {
   value: "Sebewaing (USSWB)",
   label: "Sebewaing (USSWB)"
  },
  {
   value: "Sebring (USSEF)",
   label: "Sebring (USSEF)"
  },
  {
   value: "Sebring (USSEB)",
   label: "Sebring (USSEB)"
  },
  {
   value: "Secaucus (USUYK)",
   label: "Secaucus (USUYK)"
  },
  {
   value: "Sedalia (USDMO)",
   label: "Sedalia (USDMO)"
  },
  {
   value: "Sedona (USSDX)",
   label: "Sedona (USSDX)"
  },
  {
   value: "Seekonk (USSWK)",
   label: "Seekonk (USSWK)"
  },
  {
   value: "Seguin (USSEG)",
   label: "Seguin (USSEG)"
  },
  {
   value: "Seiple (USSEC)",
   label: "Seiple (USSEC)"
  },
  {
   value: "Selby (USSEL)",
   label: "Selby (USSEL)"
  },
  {
   value: "Seldovia (USSOV)",
   label: "Seldovia (USSOV)"
  },
  {
   value: "Selkirk (USSKK)",
   label: "Selkirk (USSKK)"
  },
  {
   value: "Saratoga (USXMQ)",
   label: "Saratoga (USXMQ)"
  },
  {
   value: "Saratoga Springs (USSGA)",
   label: "Saratoga Springs (USSGA)"
  },
  {
   value: "Sardis (USSSR)",
   label: "Sardis (USSSR)"
  },
  {
   value: "Sarles (USSAO)",
   label: "Sarles (USSAO)"
  },
  {
   value: "Sasabe (USSAS)",
   label: "Sasabe (USSAS)"
  },
  {
   value: "Sasser (USSAH)",
   label: "Sasser (USSAH)"
  },
  {
   value: "Saugerties (USSUV)",
   label: "Saugerties (USSUV)"
  },
  {
   value: "Sauget (USSAU)",
   label: "Sauget (USSAU)"
  },
  {
   value: "Sauk Rapids (USSXP)",
   label: "Sauk Rapids (USSXP)"
  },
  {
   value: "Sauk Village (USSXL)",
   label: "Sauk Village (USSXL)"
  },
  {
   value: "Sault Ste Marie (USSSM)",
   label: "Sault Ste Marie (USSSM)"
  },
  {
   value: "Sausalito (USJMC)",
   label: "Sausalito (USJMC)"
  },
  {
   value: "Savage (USSGE)",
   label: "Savage (USSGE)"
  },
  {
   value: "Savage (USXLY)",
   label: "Savage (USXLY)"
  },
  {
   value: "Savanna (USSNQ)",
   label: "Savanna (USSNQ)"
  },
  {
   value: "Savannah (USSAV)",
   label: "Savannah (USSAV)"
  },
  {
   value: "Savannah (USXMX)",
   label: "Savannah (USXMX)"
  },
  {
   value: "Savoy (USSVA)",
   label: "Savoy (USSVA)"
  },
  {
   value: "Saybrook (USSYK)",
   label: "Saybrook (USSYK)"
  },
  {
   value: "Sayerville (USXNA)",
   label: "Sayerville (USXNA)"
  },
  {
   value: "Sayville (USSYS)",
   label: "Sayville (USSYS)"
  },
  {
   value: "Scapoose (USSCA)",
   label: "Scapoose (USSCA)"
  },
  {
   value: "Scarborough (USSZX)",
   label: "Scarborough (USSZX)"
  },
  {
   value: "Scarsdale (USSCG)",
   label: "Scarsdale (USSCG)"
  },
  {
   value: "Schaller (USSHX)",
   label: "Schaller (USSHX)"
  },
  {
   value: "Schaumburg (USJMH)",
   label: "Schaumburg (USJMH)"
  },
  {
   value: "Schenectady (USSCH)",
   label: "Schenectady (USSCH)"
  },
  {
   value: "Schenley (USSCP)",
   label: "Schenley (USSCP)"
  },
  {
   value: "Schiller Park (USSID)",
   label: "Schiller Park (USSID)"
  },
  {
   value: "Schofield (USSFW)",
   label: "Schofield (USSFW)"
  },
  {
   value: "Scholls (USSZC)",
   label: "Scholls (USSZC)"
  },
  {
   value: "Schuyler (USSHJ)",
   label: "Schuyler (USSHJ)"
  },
  {
   value: "Schuylkill (USSKL)",
   label: "Schuylkill (USSKL)"
  },
  {
   value: "Schuylkill Haven (USSKU)",
   label: "Schuylkill Haven (USSKU)"
  },
  {
   value: "Scituate (USSCU)",
   label: "Scituate (USSCU)"
  },
  {
   value: "Scobey (USSCO)",
   label: "Scobey (USSCO)"
  },
  {
   value: "Scobeyville (USSCW)",
   label: "Scobeyville (USSCW)"
  },
  {
   value: "Scofield (USXLQ)",
   label: "Scofield (USXLQ)"
  },
  {
   value: "Scotch Plains (USSPJ)",
   label: "Scotch Plains (USSPJ)"
  },
  {
   value: "Scotia (USSIA)",
   label: "Scotia (USSIA)"
  },
  {
   value: "Scotia (USSOA)",
   label: "Scotia (USSOA)"
  },
  {
   value: "San Martin (USSXJ)",
   label: "San Martin (USSXJ)"
  },
  {
   value: "San Mateo (USSMK)",
   label: "San Mateo (USSMK)"
  },
  {
   value: "San Pablo (USSAK)",
   label: "San Pablo (USSAK)"
  },
  {
   value: "San Pablo Bay (USSPB)",
   label: "San Pablo Bay (USSPB)"
  },
  {
   value: "San Pedro (USSPQ)",
   label: "San Pedro (USSPQ)"
  },
  {
   value: "San Rafael (USSRF)",
   label: "San Rafael (USSRF)"
  },
  {
   value: "San Ramon (USSJB)",
   label: "San Ramon (USSJB)"
  },
  {
   value: "San Ysidro (USSYO)",
   label: "San Ysidro (USSYO)"
  },
  {
   value: "Sand City (USSDC)",
   label: "Sand City (USSDC)"
  },
  {
   value: "Sand Point (USSDP)",
   label: "Sand Point (USSDP)"
  },
  {
   value: "Sand Springs (USSDQ)",
   label: "Sand Springs (USSDQ)"
  },
  {
   value: "Sanderson (USSDI)",
   label: "Sanderson (USSDI)"
  },
  {
   value: "Sandersville (USSNV)",
   label: "Sandersville (USSNV)"
  },
  {
   value: "Sandston (USSAX)",
   label: "Sandston (USSAX)"
  },
  {
   value: "Sandusky (USSDW)",
   label: "Sandusky (USSDW)"
  },
  {
   value: "Sandusky (USSDY)",
   label: "Sandusky (USSDY)"
  },
  {
   value: "Sandwich (USSWH)",
   label: "Sandwich (USSWH)"
  },
  {
   value: "Sandwich (USSWC)",
   label: "Sandwich (USSWC)"
  },
  {
   value: "Sandy (USSJD)",
   label: "Sandy (USSJD)"
  },
  {
   value: "Sandy (USSJE)",
   label: "Sandy (USSJE)"
  },
  {
   value: "Sandy Point (USSYP)",
   label: "Sandy Point (USSYP)"
  },
  {
   value: "Sanford (USSFM)",
   label: "Sanford (USSFM)"
  },
  {
   value: "Sanford (USSFB)",
   label: "Sanford (USSFB)"
  },
  {
   value: "Sanford (USSCF)",
   label: "Sanford (USSCF)"
  },
  {
   value: "Sanger (USSRK)",
   label: "Sanger (USSRK)"
  },
  {
   value: "Santa Ana (USSNA)",
   label: "Santa Ana (USSNA)"
  },
  {
   value: "Santa Barbara (USSBA)",
   label: "Santa Barbara (USSBA)"
  },
  {
   value: "Santa Clara (USSCZ)",
   label: "Santa Clara (USSCZ)"
  },
  {
   value: "Santa Clarita (USSAM)",
   label: "Santa Clarita (USSAM)"
  },
  {
   value: "Santa Cruz (USSRU)",
   label: "Santa Cruz (USSRU)"
  },
  {
   value: "Santa Fe (USSAF)",
   label: "Santa Fe (USSAF)"
  },
  {
   value: "Santa Fe Springs (USUYR)",
   label: "Santa Fe Springs (USUYR)"
  },
  {
   value: "Santa Maria (USSMX)",
   label: "Santa Maria (USSMX)"
  },
  {
   value: "Santa Monica (USSMO)",
   label: "Santa Monica (USSMO)"
  },
  {
   value: "Santa Paula (USSZP)",
   label: "Santa Paula (USSZP)"
  },
  {
   value: "Santa Rosa (USSTS)",
   label: "Santa Rosa (USSTS)"
  },
  {
   value: "Santa Teresa (USSXT)",
   label: "Santa Teresa (USSXT)"
  },
  {
   value: "Santee (USSXD)",
   label: "Santee (USSXD)"
  },
  {
   value: "Saranac Lake (USSLK)",
   label: "Saranac Lake (USSLK)"
  },
  {
   value: "Sarasota (USSRB)",
   label: "Sarasota (USSRB)"
  },
  {
   value: "Salem (USSMQ)",
   label: "Salem (USSMQ)"
  },
  {
   value: "Salem (USSMN)",
   label: "Salem (USSMN)"
  },
  {
   value: "Salem (USSEM)",
   label: "Salem (USSEM)"
  },
  {
   value: "Salem (USSAE)",
   label: "Salem (USSAE)"
  },
  {
   value: "Salem (USSLE)",
   label: "Salem (USSLE)"
  },
  {
   value: "Salem (USUYQ)",
   label: "Salem (USUYQ)"
  },
  {
   value: "Salem (USSLO)",
   label: "Salem (USSLO)"
  },
  {
   value: "Salem (USSLF)",
   label: "Salem (USSLF)"
  },
  {
   value: "Salida (USSLT)",
   label: "Salida (USSLT)"
  },
  {
   value: "Salina (USSLN)",
   label: "Salina (USSLN)"
  },
  {
   value: "Salinas (USSNS)",
   label: "Salinas (USSNS)"
  },
  {
   value: "Salisbury (USSBY)",
   label: "Salisbury (USSBY)"
  },
  {
   value: "Salisbury (USSRW)",
   label: "Salisbury (USSRW)"
  },
  {
   value: "Salisbury (USSLS)",
   label: "Salisbury (USSLS)"
  },
  {
   value: "Sallisaw (USSLA)",
   label: "Sallisaw (USSLA)"
  },
  {
   value: "Salt Lake City (USSLC)",
   label: "Salt Lake City (USSLC)"
  },
  {
   value: "Saltillo (USSLL)",
   label: "Saltillo (USSLL)"
  },
  {
   value: "Sampit (USSMP)",
   label: "Sampit (USSMP)"
  },
  {
   value: "Samson (USSXN)",
   label: "Samson (USSXN)"
  },
  {
   value: "San Angelo (USSJT)",
   label: "San Angelo (USSJT)"
  },
  {
   value: "San Antonio (USSAT)",
   label: "San Antonio (USSAT)"
  },
  {
   value: "San Bernardino (USSBT)",
   label: "San Bernardino (USSBT)"
  },
  {
   value: "San Bruno (USSXB)",
   label: "San Bruno (USSXB)"
  },
  {
   value: "San Carlos (USSQL)",
   label: "San Carlos (USSQL)"
  },
  {
   value: "San Clemente (USXMO)",
   label: "San Clemente (USXMO)"
  },
  {
   value: "San Diego (USSGQ)",
   label: "San Diego (USSGQ)"
  },
  {
   value: "San Diego (USSIO)",
   label: "San Diego (USSIO)"
  },
  {
   value: "San Diego (USSAN)",
   label: "San Diego (USSAN)"
  },
  {
   value: "San Dimas (USSAD)",
   label: "San Dimas (USSAD)"
  },
  {
   value: "San Fernando (USSFR)",
   label: "San Fernando (USSFR)"
  },
  {
   value: "San Francisco (USSFO)",
   label: "San Francisco (USSFO)"
  },
  {
   value: "San Gabriel (USSGG)",
   label: "San Gabriel (USSGG)"
  },
  {
   value: "San Jose (USSJC)",
   label: "San Jose (USSJC)"
  },
  {
   value: "San Juan Capistrano (USSAJ)",
   label: "San Juan Capistrano (USSAJ)"
  },
  {
   value: "San Leandro (USSNH)",
   label: "San Leandro (USSNH)"
  },
  {
   value: "San Luis (USSLI)",
   label: "San Luis (USSLI)"
  },
  {
   value: "San Luis (USSLU)",
   label: "San Luis (USSLU)"
  },
  {
   value: "San Luis Obispo (USCSL)",
   label: "San Luis Obispo (USCSL)"
  },
  {
   value: "San Marcos (USSNM)",
   label: "San Marcos (USSNM)"
  },
  {
   value: "San Marcos (USSMC)",
   label: "San Marcos (USSMC)"
  },
  {
   value: "San Marino (USSMD)",
   label: "San Marino (USSMD)"
  },
  {
   value: "Saint Bernard Parish (USSBD)",
   label: "Saint Bernard Parish (USSBD)"
  },
  {
   value: "Saint Charles (USABP)",
   label: "Saint Charles (USABP)"
  },
  {
   value: "Saint Charles (USSSL)",
   label: "Saint Charles (USSSL)"
  },
  {
   value: "Saint Clair (USSCL)",
   label: "Saint Clair (USSCL)"
  },
  {
   value: "Saint Clairsville (USSCS)",
   label: "Saint Clairsville (USSCS)"
  },
  {
   value: "Saint Cloud (USSOC)",
   label: "Saint Cloud (USSOC)"
  },
  {
   value: "Saint Cloud (USSTC)",
   label: "Saint Cloud (USSTC)"
  },
  {
   value: "Saint Francisville (USSFV)",
   label: "Saint Francisville (USSFV)"
  },
  {
   value: "Saint Gabriel (USSGL)",
   label: "Saint Gabriel (USSGL)"
  },
  {
   value: "Saint George (USSGS)",
   label: "Saint George (USSGS)"
  },
  {
   value: "Saint George Island (USSGJ)",
   label: "Saint George Island (USSGJ)"
  },
  {
   value: "Saint Helena (USSHE)",
   label: "Saint Helena (USSHE)"
  },
  {
   value: "Saint Helens (USSXO)",
   label: "Saint Helens (USSXO)"
  },
  {
   value: "Saint James (USSJA)",
   label: "Saint James (USSJA)"
  },
  {
   value: "Saint James (USSJM)",
   label: "Saint James (USSJM)"
  },
  {
   value: "Saint Joseph (USSJH)",
   label: "Saint Joseph (USSJH)"
  },
  {
   value: "Saint Joseph (USSJP)",
   label: "Saint Joseph (USSJP)"
  },
  {
   value: "Saint Joseph (USSXX)",
   label: "Saint Joseph (USSXX)"
  },
  {
   value: "Saint Joseph (USSJF)",
   label: "Saint Joseph (USSJF)"
  },
  {
   value: "Saint Joseph (USXLM)",
   label: "Saint Joseph (USXLM)"
  },
  {
   value: "Saint Louis (USSXZ)",
   label: "Saint Louis (USSXZ)"
  },
  {
   value: "Saint Louis (USSYA)",
   label: "Saint Louis (USSYA)"
  },
  {
   value: "Saint Louis (USSLX)",
   label: "Saint Louis (USSLX)"
  },
  {
   value: "Saint Louis Park (USSLZ)",
   label: "Saint Louis Park (USSLZ)"
  },
  {
   value: "Saint Martinville (USSIV)",
   label: "Saint Martinville (USSIV)"
  },
  {
   value: "Saint Marys (USSJW)",
   label: "Saint Marys (USSJW)"
  },
  {
   value: "Saint Marys (USSSW)",
   label: "Saint Marys (USSSW)"
  },
  {
   value: "Saint Marys (USSJX)",
   label: "Saint Marys (USSJX)"
  },
  {
   value: "Saint Marys (USSMA)",
   label: "Saint Marys (USSMA)"
  },
  {
   value: "Saint Matthews (USSMB)",
   label: "Saint Matthews (USSMB)"
  },
  {
   value: "Saint Nazianz (USSZZ)",
   label: "Saint Nazianz (USSZZ)"
  },
  {
   value: "Saint Paul (USSXW)",
   label: "Saint Paul (USSXW)"
  },
  {
   value: "Saint Pauls (USSXH)",
   label: "Saint Pauls (USSXH)"
  },
  {
   value: "Saint Peters (USSQS)",
   label: "Saint Peters (USSQS)"
  },
  {
   value: "Saint Petersburg (USSPT)",
   label: "Saint Petersburg (USSPT)"
  },
  {
   value: "Saint Simons Island (USSSS)",
   label: "Saint Simons Island (USSSS)"
  },
  {
   value: "Salem (USSLM)",
   label: "Salem (USSLM)"
  },
  {
   value: "Roxboro (USRXB)",
   label: "Roxboro (USRXB)"
  },
  {
   value: "Roxbury (USRXY)",
   label: "Roxbury (USRXY)"
  },
  {
   value: "Roxbury (USRXQ)",
   label: "Roxbury (USRXQ)"
  },
  {
   value: "Roy (USRYW)",
   label: "Roy (USRYW)"
  },
  {
   value: "Royal Center (USRYC)",
   label: "Royal Center (USRYC)"
  },
  {
   value: "Royal City (USXLB)",
   label: "Royal City (USXLB)"
  },
  {
   value: "Royal Oak (USRYM)",
   label: "Royal Oak (USRYM)"
  },
  {
   value: "Royersford (USUYH)",
   label: "Royersford (USUYH)"
  },
  {
   value: "Royse City (USRYX)",
   label: "Royse City (USRYX)"
  },
  {
   value: "Royston (USROY)",
   label: "Royston (USROY)"
  },
  {
   value: "Rubonia (USRUB)",
   label: "Rubonia (USRUB)"
  },
  {
   value: "Ruidoso (USRUI)",
   label: "Ruidoso (USRUI)"
  },
  {
   value: "Rule (USRUL)",
   label: "Rule (USRUL)"
  },
  {
   value: "Ruleville (USRVI)",
   label: "Ruleville (USRVI)"
  },
  {
   value: "Rumford (USRFM)",
   label: "Rumford (USRFM)"
  },
  {
   value: "Rural Hall (USRQH)",
   label: "Rural Hall (USRQH)"
  },
  {
   value: "Rural Retreat (USRRE)",
   label: "Rural Retreat (USRRE)"
  },
  {
   value: "Rush (USRQY)",
   label: "Rush (USRQY)"
  },
  {
   value: "Ruskin (USRKN)",
   label: "Ruskin (USRKN)"
  },
  {
   value: "Russ Berrie (USRUJ)",
   label: "Russ Berrie (USRUJ)"
  },
  {
   value: "Russell (USRZL)",
   label: "Russell (USRZL)"
  },
  {
   value: "Russellville (USRSL)",
   label: "Russellville (USRSL)"
  },
  {
   value: "Russellville (USRUV)",
   label: "Russellville (USRUV)"
  },
  {
   value: "Russelville (USRUS)",
   label: "Russelville (USRUS)"
  },
  {
   value: "Rutherford (USUYI)",
   label: "Rutherford (USUYI)"
  },
  {
   value: "Rutherford (Cf US UYI) (USRTH)",
   label: "Rutherford (Cf US UYI) (USRTH)"
  },
  {
   value: "Rutherfordton (USRUR)",
   label: "Rutherfordton (USRUR)"
  },
  {
   value: "Rutland (USRUT)",
   label: "Rutland (USRUT)"
  },
  {
   value: "Rutledge (USRUA)",
   label: "Rutledge (USRUA)"
  },
  {
   value: "Sabine (USSAB)",
   label: "Sabine (USSAB)"
  },
  {
   value: "Sacramento (USSAC)",
   label: "Sacramento (USSAC)"
  },
  {
   value: "Saddle Brook (USSBK)",
   label: "Saddle Brook (USSBK)"
  },
  {
   value: "Saegertown (USXLL)",
   label: "Saegertown (USXLL)"
  },
  {
   value: "Safety Harbor (USSFP)",
   label: "Safety Harbor (USSFP)"
  },
  {
   value: "Sagentown (USSGN)",
   label: "Sagentown (USSGN)"
  },
  {
   value: "Saginaw (USSAG)",
   label: "Saginaw (USSAG)"
  },
  {
   value: "Saginaw (USSJQ)",
   label: "Saginaw (USSJQ)"
  },
  {
   value: "Saint Albans (USSBQ)",
   label: "Saint Albans (USSBQ)"
  },
  {
   value: "Saint Augustine (USXMY)",
   label: "Saint Augustine (USXMY)"
  },
  {
   value: "Saint Bernard (USSSB)",
   label: "Saint Bernard (USSSB)"
  },
  {
   value: "Romulus (USRUZ)",
   label: "Romulus (USRUZ)"
  },
  {
   value: "Ronan (USRNW)",
   label: "Ronan (USRNW)"
  },
  {
   value: "Ronkonkoma (USRKK)",
   label: "Ronkonkoma (USRKK)"
  },
  {
   value: "Ronkonkoms (USRKM)",
   label: "Ronkonkoms (USRKM)"
  },
  {
   value: "Roopville (USRPV)",
   label: "Roopville (USRPV)"
  },
  {
   value: "Roosville (USROO)",
   label: "Roosville (USROO)"
  },
  {
   value: "Ropesville (USRVP)",
   label: "Ropesville (USRVP)"
  },
  {
   value: "Roscoe (USRSQ)",
   label: "Roscoe (USRSQ)"
  },
  {
   value: "Rose Hill (USRZH)",
   label: "Rose Hill (USRZH)"
  },
  {
   value: "Roseau (USROX)",
   label: "Roseau (USROX)"
  },
  {
   value: "Roseburg (USRBG)",
   label: "Roseburg (USRBG)"
  },
  {
   value: "Rosedale (USRDA)",
   label: "Rosedale (USRDA)"
  },
  {
   value: "Roseland (USRLB)",
   label: "Roseland (USRLB)"
  },
  {
   value: "Roselle (USRLE)",
   label: "Roselle (USRLE)"
  },
  {
   value: "Roselle (USRLL)",
   label: "Roselle (USRLL)"
  },
  {
   value: "Rosemead (USRFS)",
   label: "Rosemead (USRFS)"
  },
  {
   value: "Rosemont (USROP)",
   label: "Rosemont (USROP)"
  },
  {
   value: "Rosemont (USRSI)",
   label: "Rosemont (USRSI)"
  },
  {
   value: "Rosemount (USRMM)",
   label: "Rosemount (USRMM)"
  },
  {
   value: "Rosendale (USRSN)",
   label: "Rosendale (USRSN)"
  },
  {
   value: "Rosenhayn (USRSH)",
   label: "Rosenhayn (USRSH)"
  },
  {
   value: "Roseville (USROS)",
   label: "Roseville (USROS)"
  },
  {
   value: "Roseville (USRVE)",
   label: "Roseville (USRVE)"
  },
  {
   value: "Roseville (USRSV)",
   label: "Roseville (USRSV)"
  },
  {
   value: "Roseville (USRVC)",
   label: "Roseville (USRVC)"
  },
  {
   value: "Rossford (USRSO)",
   label: "Rossford (USRSO)"
  },
  {
   value: "Rossmoor (USRRY)",
   label: "Rossmoor (USRRY)"
  },
  {
   value: "Rossville (USRSS)",
   label: "Rossville (USRSS)"
  },
  {
   value: "Roswell (USROW)",
   label: "Roswell (USROW)"
  },
  {
   value: "Roswell (USRWE)",
   label: "Roswell (USRWE)"
  },
  {
   value: "Rotan (USRTX)",
   label: "Rotan (USRTX)"
  },
  {
   value: "Rothschild (USRTS)",
   label: "Rothschild (USRTS)"
  },
  {
   value: "Rotterdam Junction (USRJN)",
   label: "Rotterdam Junction (USRJN)"
  },
  {
   value: "Round Lake (USRUC)",
   label: "Round Lake (USRUC)"
  },
  {
   value: "Round Mountain (USROM)",
   label: "Round Mountain (USROM)"
  },
  {
   value: "Round Rock (USRRX)",
   label: "Round Rock (USRRX)"
  },
  {
   value: "Rouses Point (USRSX)",
   label: "Rouses Point (USRSX)"
  },
  {
   value: "Rouseville (USRYV)",
   label: "Rouseville (USRYV)"
  },
  {
   value: "Rowesville (USXLK)",
   label: "Rowesville (USXLK)"
  },
  {
   value: "Rowland Heights (USRHW)",
   label: "Rowland Heights (USRHW)"
  },
  {
   value: "Rowley (USRWY)",
   label: "Rowley (USRWY)"
  },
  {
   value: "Rockford (USRFD)",
   label: "Rockford (USRFD)"
  },
  {
   value: "Rockford (USRCF)",
   label: "Rockford (USRCF)"
  },
  {
   value: "Rockford (USRFK)",
   label: "Rockford (USRFK)"
  },
  {
   value: "Rockhill (USRVH)",
   label: "Rockhill (USRVH)"
  },
  {
   value: "Rockingham (USXLH)",
   label: "Rockingham (USXLH)"
  },
  {
   value: "Rockingham (USRGM)",
   label: "Rockingham (USRGM)"
  },
  {
   value: "Rockland (USRCA)",
   label: "Rockland (USRCA)"
  },
  {
   value: "Rockland (USRKD)",
   label: "Rockland (USRKD)"
  },
  {
   value: "Rockledge (USRKE)",
   label: "Rockledge (USRKE)"
  },
  {
   value: "Rockleigh (USRXH)",
   label: "Rockleigh (USRXH)"
  },
  {
   value: "Rocklin (USRKC)",
   label: "Rocklin (USRKC)"
  },
  {
   value: "Rockport (USRPR)",
   label: "Rockport (USRPR)"
  },
  {
   value: "Rockport (USRKP)",
   label: "Rockport (USRKP)"
  },
  {
   value: "Rockport (USRKO)",
   label: "Rockport (USRKO)"
  },
  {
   value: "Rockport (USRQP)",
   label: "Rockport (USRQP)"
  },
  {
   value: "Rockton (USRKT)",
   label: "Rockton (USRKT)"
  },
  {
   value: "Rockville (USRKV)",
   label: "Rockville (USRKV)"
  },
  {
   value: "Rockwall (USXLI)",
   label: "Rockwall (USXLI)"
  },
  {
   value: "Rockwood (USRQO)",
   label: "Rockwood (USRQO)"
  },
  {
   value: "Rockwood (USRKW)",
   label: "Rockwood (USRKW)"
  },
  {
   value: "Rocky Ford (USRKF)",
   label: "Rocky Ford (USRKF)"
  },
  {
   value: "Rocky Hill (USROK)",
   label: "Rocky Hill (USROK)"
  },
  {
   value: "Rocky Mount (USROV)",
   label: "Rocky Mount (USROV)"
  },
  {
   value: "Rocky Mount (USRWI)",
   label: "Rocky Mount (USRWI)"
  },
  {
   value: "Rocky Mountains (USRMT)",
   label: "Rocky Mountains (USRMT)"
  },
  {
   value: "Rocky Point (USRCP)",
   label: "Rocky Point (USRCP)"
  },
  {
   value: "Roebling (USRQJ)",
   label: "Roebling (USRQJ)"
  },
  {
   value: "Roebuck (USRQB)",
   label: "Roebuck (USRQB)"
  },
  {
   value: "Roger Ciry (USRCY)",
   label: "Roger Ciry (USRCY)"
  },
  {
   value: "Rogers (USROG)",
   label: "Rogers (USROG)"
  },
  {
   value: "Rogers (USRJM)",
   label: "Rogers (USRJM)"
  },
  {
   value: "Rohnert Park (USRFH)",
   label: "Rohnert Park (USRFH)"
  },
  {
   value: "Rolla (USRLA)",
   label: "Rolla (USRLA)"
  },
  {
   value: "Rolling Fork (USRFY)",
   label: "Rolling Fork (USRFY)"
  },
  {
   value: "Rolling Hills (USRHJ)",
   label: "Rolling Hills (USRHJ)"
  },
  {
   value: "Rolling Meadows (USRLM)",
   label: "Rolling Meadows (USRLM)"
  },
  {
   value: "Roma (USFAL)",
   label: "Roma (USFAL)"
  },
  {
   value: "Rome (USRME)",
   label: "Rome (USRME)"
  },
  {
   value: "Rome (USRMG)",
   label: "Rome (USRMG)"
  },
  {
   value: "Romeo (USRMO)",
   label: "Romeo (USRMO)"
  },
  {
   value: "Romulus (USROU)",
   label: "Romulus (USROU)"
  },
  {
   value: "River Rouge (USRRJ)",
   label: "River Rouge (USRRJ)"
  },
  {
   value: "Riverdale (USRDL)",
   label: "Riverdale (USRDL)"
  },
  {
   value: "Riverdale (USRVL)",
   label: "Riverdale (USRVL)"
  },
  {
   value: "Riverdale (USRRD)",
   label: "Riverdale (USRRD)"
  },
  {
   value: "Riverhead (USRHD)",
   label: "Riverhead (USRHD)"
  },
  {
   value: "Riverside (USRVM)",
   label: "Riverside (USRVM)"
  },
  {
   value: "Riverside (USRAL)",
   label: "Riverside (USRAL)"
  },
  {
   value: "Riverside (USRSD)",
   label: "Riverside (USRSD)"
  },
  {
   value: "Riverton (USRIW)",
   label: "Riverton (USRIW)"
  },
  {
   value: "Riverton (USRVJ)",
   label: "Riverton (USRVJ)"
  },
  {
   value: "Riverview (USRVW)",
   label: "Riverview (USRVW)"
  },
  {
   value: "Riviera Beach (USRBH)",
   label: "Riviera Beach (USRBH)"
  },
  {
   value: "Roanoke (USROA)",
   label: "Roanoke (USROA)"
  },
  {
   value: "Roanoke Rapids (USRZZ)",
   label: "Roanoke Rapids (USRZZ)"
  },
  {
   value: "Roaring Rapids (USRRR)",
   label: "Roaring Rapids (USRRR)"
  },
  {
   value: "Roaring River (USRVX)",
   label: "Roaring River (USRVX)"
  },
  {
   value: "Roaring Springs (USRRS)",
   label: "Roaring Springs (USRRS)"
  },
  {
   value: "Robbins (USRBN)",
   label: "Robbins (USRBN)"
  },
  {
   value: "Robbinsville (USRBB)",
   label: "Robbinsville (USRBB)"
  },
  {
   value: "Robbinsville (USRBV)",
   label: "Robbinsville (USRBV)"
  },
  {
   value: "Robesonia (USRBE)",
   label: "Robesonia (USRBE)"
  },
  {
   value: "Robinson (USROB)",
   label: "Robinson (USROB)"
  },
  {
   value: "Rochell (USRCL)",
   label: "Rochell (USRCL)"
  },
  {
   value: "Rochelle (USROL)",
   label: "Rochelle (USROL)"
  },
  {
   value: "Rochester (USROR)",
   label: "Rochester (USROR)"
  },
  {
   value: "Rochester (USRST)",
   label: "Rochester (USRST)"
  },
  {
   value: "Rochester (USROC)",
   label: "Rochester (USROC)"
  },
  {
   value: "Rochester (USRHR)",
   label: "Rochester (USRHR)"
  },
  {
   value: "Rochester (USRXT)",
   label: "Rochester (USRXT)"
  },
  {
   value: "Rochester (USRCW)",
   label: "Rochester (USRCW)"
  },
  {
   value: "Rochester (USRCE)",
   label: "Rochester (USRCE)"
  },
  {
   value: "Rochester (USRCZ)",
   label: "Rochester (USRCZ)"
  },
  {
   value: "Rock Falls (USRFI)",
   label: "Rock Falls (USRFI)"
  },
  {
   value: "Rock Hill (USRKH)",
   label: "Rock Hill (USRKH)"
  },
  {
   value: "Rock Hill (USRHC)",
   label: "Rock Hill (USRHC)"
  },
  {
   value: "Rock Island (USUYF)",
   label: "Rock Island (USUYF)"
  },
  {
   value: "Rock Island (USRKI)",
   label: "Rock Island (USRKI)"
  },
  {
   value: "Rock Springs (USRKS)",
   label: "Rock Springs (USRKS)"
  },
  {
   value: "Rockaway (USRKJ)",
   label: "Rockaway (USRKJ)"
  },
  {
   value: "Rockdale (USROE)",
   label: "Rockdale (USROE)"
  },
  {
   value: "Richmond (USXLA)",
   label: "Richmond (USXLA)"
  },
  {
   value: "Richmond Beach (USRJJ)",
   label: "Richmond Beach (USRJJ)"
  },
  {
   value: "Richmond Highlands (USRJH)",
   label: "Richmond Highlands (USRJH)"
  },
  {
   value: "Richmond Hill (USRJK)",
   label: "Richmond Hill (USRJK)"
  },
  {
   value: "Richmondville (USRHL)",
   label: "Richmondville (USRHL)"
  },
  {
   value: "Richwood (USRWO)",
   label: "Richwood (USRWO)"
  },
  {
   value: "Riddle (USRIR)",
   label: "Riddle (USRIR)"
  },
  {
   value: "Ridgefield (USUYE)",
   label: "Ridgefield (USUYE)"
  },
  {
   value: "Ridgefield Park (USRFP)",
   label: "Ridgefield Park (USRFP)"
  },
  {
   value: "Ridgeland (USRDE)",
   label: "Ridgeland (USRDE)"
  },
  {
   value: "Ridgeville (USRIS)",
   label: "Ridgeville (USRIS)"
  },
  {
   value: "Ridgeway (USRIT)",
   label: "Ridgeway (USRIT)"
  },
  {
   value: "Ridgeway (USRJV)",
   label: "Ridgeway (USRJV)"
  },
  {
   value: "Ridgewood (USRWD)",
   label: "Ridgewood (USRWD)"
  },
  {
   value: "Ridgewood (USRGO)",
   label: "Ridgewood (USRGO)"
  },
  {
   value: "Ridgway (USXLE)",
   label: "Ridgway (USXLE)"
  },
  {
   value: "Ridgway (USRJW)",
   label: "Ridgway (USRJW)"
  },
  {
   value: "Ridley Park (USRPK)",
   label: "Ridley Park (USRPK)"
  },
  {
   value: "Riegal Wood (USRGW)",
   label: "Riegal Wood (USRGW)"
  },
  {
   value: "Riegelwood (USRGL)",
   label: "Riegelwood (USRGL)"
  },
  {
   value: "Rienzi (USRZI)",
   label: "Rienzi (USRZI)"
  },
  {
   value: "Rifle (USRIL)",
   label: "Rifle (USRIL)"
  },
  {
   value: "Rincon (USRIK)",
   label: "Rincon (USRIK)"
  },
  {
   value: "Ringgold (USRXV)",
   label: "Ringgold (USRXV)"
  },
  {
   value: "Ringgold (USRJO)",
   label: "Ringgold (USRJO)"
  },
  {
   value: "Ringgold (USRGD)",
   label: "Ringgold (USRGD)"
  },
  {
   value: "Ringwood (USRIO)",
   label: "Ringwood (USRIO)"
  },
  {
   value: "Rio Grande City (USRGC)",
   label: "Rio Grande City (USRGC)"
  },
  {
   value: "Rio Linda (USRLI)",
   label: "Rio Linda (USRLI)"
  },
  {
   value: "Rio Rancho (USRRC)",
   label: "Rio Rancho (USRRC)"
  },
  {
   value: "Rio Rico (USRRQ)",
   label: "Rio Rico (USRRQ)"
  },
  {
   value: "Rio Vista (USRVA)",
   label: "Rio Vista (USRVA)"
  },
  {
   value: "Ripley (USRPL)",
   label: "Ripley (USRPL)"
  },
  {
   value: "Ripley (USRPM)",
   label: "Ripley (USRPM)"
  },
  {
   value: "Ripon (USRIP)",
   label: "Ripon (USRIP)"
  },
  {
   value: "Ripon (USRPN)",
   label: "Ripon (USRPN)"
  },
  {
   value: "Ririe (USRIH)",
   label: "Ririe (USRIH)"
  },
  {
   value: "Rising Sun (USRUN)",
   label: "Rising Sun (USRUN)"
  },
  {
   value: "Rittman (USRTN)",
   label: "Rittman (USRTN)"
  },
  {
   value: "River Falls (USRFW)",
   label: "River Falls (USRFW)"
  },
  {
   value: "River Falls (USRIF)",
   label: "River Falls (USRIF)"
  },
  {
   value: "Reedley (USRDC)",
   label: "Reedley (USRDC)"
  },
  {
   value: "Reedville (USREV)",
   label: "Reedville (USREV)"
  },
  {
   value: "Reese (USRMI)",
   label: "Reese (USRMI)"
  },
  {
   value: "Regal (USQRE)",
   label: "Regal (USQRE)"
  },
  {
   value: "Register (USRGT)",
   label: "Register (USRGT)"
  },
  {
   value: "Reidsville (USRIV)",
   label: "Reidsville (USRIV)"
  },
  {
   value: "Relay (USRLW)",
   label: "Relay (USRLW)"
  },
  {
   value: "Remington (USRXG)",
   label: "Remington (USRXG)"
  },
  {
   value: "Remington (USXLJ)",
   label: "Remington (USXLJ)"
  },
  {
   value: "Remus (USRUQ)",
   label: "Remus (USRUQ)"
  },
  {
   value: "Reno (USRNO)",
   label: "Reno (USRNO)"
  },
  {
   value: "Rensselaer (USRER)",
   label: "Rensselaer (USRER)"
  },
  {
   value: "Renton (USRNT)",
   label: "Renton (USRNT)"
  },
  {
   value: "Resaca (USRQG)",
   label: "Resaca (USRQG)"
  },
  {
   value: "Reseda (USRSJ)",
   label: "Reseda (USRSJ)"
  },
  {
   value: "Reserve (USRSF)",
   label: "Reserve (USRSF)"
  },
  {
   value: "Reston (USRTV)",
   label: "Reston (USRTV)"
  },
  {
   value: "Revere (USRVR)",
   label: "Revere (USRVR)"
  },
  {
   value: "Rex (USREX)",
   label: "Rex (USREX)"
  },
  {
   value: "Rexburg (USRBI)",
   label: "Rexburg (USRBI)"
  },
  {
   value: "Reynolds (USREY)",
   label: "Reynolds (USREY)"
  },
  {
   value: "Reynoldsburg (USRYG)",
   label: "Reynoldsburg (USRYG)"
  },
  {
   value: "Rhinelander (USRHI)",
   label: "Rhinelander (USRHI)"
  },
  {
   value: "Rialto (USRLO)",
   label: "Rialto (USRLO)"
  },
  {
   value: "Rice Lake (USRIE)",
   label: "Rice Lake (USRIE)"
  },
  {
   value: "Riceboro (USRCG)",
   label: "Riceboro (USRCG)"
  },
  {
   value: "Richardson (USRCR)",
   label: "Richardson (USRCR)"
  },
  {
   value: "Richburg (USRXJ)",
   label: "Richburg (USRXJ)"
  },
  {
   value: "Richfield (USREQ)",
   label: "Richfield (USREQ)"
  },
  {
   value: "Richfield (USRCM)",
   label: "Richfield (USRCM)"
  },
  {
   value: "Richford (USRFR)",
   label: "Richford (USRFR)"
  },
  {
   value: "Richland (USRLD)",
   label: "Richland (USRLD)"
  },
  {
   value: "Richland (USQCL)",
   label: "Richland (USQCL)"
  },
  {
   value: "Richland (USRJL)",
   label: "Richland (USRJL)"
  },
  {
   value: "Richland (USRLV)",
   label: "Richland (USRLV)"
  },
  {
   value: "Richland Center (USRLC)",
   label: "Richland Center (USRLC)"
  },
  {
   value: "Richland Hills (USXLG)",
   label: "Richland Hills (USXLG)"
  },
  {
   value: "Richlands (USRCI)",
   label: "Richlands (USRCI)"
  },
  {
   value: "Richmond (USRHM)",
   label: "Richmond (USRHM)"
  },
  {
   value: "Richmond (USRCH)",
   label: "Richmond (USRCH)"
  },
  {
   value: "Richmond (USRID)",
   label: "Richmond (USRID)"
  },
  {
   value: "Richmond (USRIC)",
   label: "Richmond (USRIC)"
  },
  {
   value: "Ransomville (USRSP)",
   label: "Ransomville (USRSP)"
  },
  {
   value: "Ranson (USRAS)",
   label: "Ranson (USRAS)"
  },
  {
   value: "Rantoul (USRNL)",
   label: "Rantoul (USRNL)"
  },
  {
   value: "Rapid City (USRCS)",
   label: "Rapid City (USRCS)"
  },
  {
   value: "Rapid City (USRAP)",
   label: "Rapid City (USRAP)"
  },
  {
   value: "Raritan (USRAT)",
   label: "Raritan (USRAT)"
  },
  {
   value: "Raton (USRAN)",
   label: "Raton (USRAN)"
  },
  {
   value: "Ravenna (USRVD)",
   label: "Ravenna (USRVD)"
  },
  {
   value: "Ravenswood (USRWW)",
   label: "Ravenswood (USRWW)"
  },
  {
   value: "Rawlins (USRWL)",
   label: "Rawlins (USRWL)"
  },
  {
   value: "Raymond (USRND)",
   label: "Raymond (USRND)"
  },
  {
   value: "Raymond (USUYG)",
   label: "Raymond (USUYG)"
  },
  {
   value: "Raymond (USACC)",
   label: "Raymond (USACC)"
  },
  {
   value: "Raymondville (USRMV)",
   label: "Raymondville (USRMV)"
  },
  {
   value: "Raymore (USRAM)",
   label: "Raymore (USRAM)"
  },
  {
   value: "Rayne (USRYL)",
   label: "Rayne (USRYL)"
  },
  {
   value: "Raynham (USXLF)",
   label: "Raynham (USXLF)"
  },
  {
   value: "Rayville (USRVY)",
   label: "Rayville (USRVY)"
  },
  {
   value: "Reading (USRDG)",
   label: "Reading (USRDG)"
  },
  {
   value: "Reading (USRDI)",
   label: "Reading (USRDI)"
  },
  {
   value: "Reading (USRAD)",
   label: "Reading (USRAD)"
  },
  {
   value: "Readville (USREA)",
   label: "Readville (USREA)"
  },
  {
   value: "Red Bank (USREN)",
   label: "Red Bank (USREN)"
  },
  {
   value: "Red Bay (USRDY)",
   label: "Red Bay (USRDY)"
  },
  {
   value: "Red Bluff (USRBL)",
   label: "Red Bluff (USRBL)"
  },
  {
   value: "Red Hill (USRHX)",
   label: "Red Hill (USRHX)"
  },
  {
   value: "Red Hook (USREW)",
   label: "Red Hook (USREW)"
  },
  {
   value: "Red Lion (USRLN)",
   label: "Red Lion (USRLN)"
  },
  {
   value: "Red River Ad (USRRV)",
   label: "Red River Ad (USRRV)"
  },
  {
   value: "Red Springs (USRPG)",
   label: "Red Springs (USRPG)"
  },
  {
   value: "Red Wing (USRDW)",
   label: "Red Wing (USRDW)"
  },
  {
   value: "Reddick (USREB)",
   label: "Reddick (USREB)"
  },
  {
   value: "Redding (USRDD)",
   label: "Redding (USRDD)"
  },
  {
   value: "Redfield (USRFQ)",
   label: "Redfield (USRFQ)"
  },
  {
   value: "Redford (USRDF)",
   label: "Redford (USRDF)"
  },
  {
   value: "Redlands (USRLS)",
   label: "Redlands (USRLS)"
  },
  {
   value: "Redmond (USXLC)",
   label: "Redmond (USXLC)"
  },
  {
   value: "Redmond (USRDM)",
   label: "Redmond (USRDM)"
  },
  {
   value: "Redondo Beach (USRBD)",
   label: "Redondo Beach (USRBD)"
  },
  {
   value: "Redwood City (USRWC)",
   label: "Redwood City (USRWC)"
  },
  {
   value: "Reed City (USRCT)",
   label: "Reed City (USRCT)"
  },
  {
   value: "Quakertown (USUKT)",
   label: "Quakertown (USUKT)"
  },
  {
   value: "Quanah (USQNT)",
   label: "Quanah (USQNT)"
  },
  {
   value: "Queens (USQEE)",
   label: "Queens (USQEE)"
  },
  {
   value: "Queenstown (USQUE)",
   label: "Queenstown (USQUE)"
  },
  {
   value: "Quincy (USQNC)",
   label: "Quincy (USQNC)"
  },
  {
   value: "Quincy (USQUY)",
   label: "Quincy (USQUY)"
  },
  {
   value: "Quincy (USMQI)",
   label: "Quincy (USMQI)"
  },
  {
   value: "Quincy (USQCY)",
   label: "Quincy (USQCY)"
  },
  {
   value: "Quincy (USUIN)",
   label: "Quincy (USUIN)"
  },
  {
   value: "Quitague (USQTG)",
   label: "Quitague (USQTG)"
  },
  {
   value: "Quitman (USQTM)",
   label: "Quitman (USQTM)"
  },
  {
   value: "Quitman (USQMN)",
   label: "Quitman (USQMN)"
  },
  {
   value: "Quogue (USQUO)",
   label: "Quogue (USQUO)"
  },
  {
   value: "Quonset Point (USNCO)",
   label: "Quonset Point (USNCO)"
  },
  {
   value: "Rabun Gap (USRGG)",
   label: "Rabun Gap (USRGG)"
  },
  {
   value: "Racine (USRAC)",
   label: "Racine (USRAC)"
  },
  {
   value: "Radcliff (USQRD)",
   label: "Radcliff (USQRD)"
  },
  {
   value: "Radford (USXLD)",
   label: "Radford (USXLD)"
  },
  {
   value: "Radnor (USRAR)",
   label: "Radnor (USRAR)"
  },
  {
   value: "Raeford (USRFN)",
   label: "Raeford (USRFN)"
  },
  {
   value: "Rahway (USRAH)",
   label: "Rahway (USRAH)"
  },
  {
   value: "Rainier (USRAI)",
   label: "Rainier (USRAI)"
  },
  {
   value: "Raleigh-Durham (USRDU)",
   label: "Raleigh-Durham (USRDU)"
  },
  {
   value: "Ralls (USXKZ)",
   label: "Ralls (USXKZ)"
  },
  {
   value: "Ramapo (USRYP)",
   label: "Ramapo (USRYP)"
  },
  {
   value: "Ramona (USRNX)",
   label: "Ramona (USRNX)"
  },
  {
   value: "Ramseur (USRSR)",
   label: "Ramseur (USRSR)"
  },
  {
   value: "Ramsey (USRMJ)",
   label: "Ramsey (USRMJ)"
  },
  {
   value: "Ranburne (USRBR)",
   label: "Ranburne (USRBR)"
  },
  {
   value: "Rancho (USRBK)",
   label: "Rancho (USRBK)"
  },
  {
   value: "Rancho Cordova (USRZC)",
   label: "Rancho Cordova (USRZC)"
  },
  {
   value: "Rancho Cucamonga (USRCU)",
   label: "Rancho Cucamonga (USRCU)"
  },
  {
   value: "Rancho Palos Verdes (USRAZ)",
   label: "Rancho Palos Verdes (USRAZ)"
  },
  {
   value: "Rancho Park (USRPQ)",
   label: "Rancho Park (USRPQ)"
  },
  {
   value: "Rancho Sante Fe (USRSU)",
   label: "Rancho Sante Fe (USRSU)"
  },
  {
   value: "Randleman (USRNJ)",
   label: "Randleman (USRNJ)"
  },
  {
   value: "Randolph (USRDH)",
   label: "Randolph (USRDH)"
  },
  {
   value: "Randolph (USRNP)",
   label: "Randolph (USRNP)"
  },
  {
   value: "Randolph (USRLP)",
   label: "Randolph (USRLP)"
  },
  {
   value: "Ranier (USIFR)",
   label: "Ranier (USIFR)"
  },
  {
   value: "Ransom (USRNS)",
   label: "Ransom (USRNS)"
  },
  {
   value: "Prairieville (USPRA)",
   label: "Prairieville (USPRA)"
  },
  {
   value: "Prattville (USPRV)",
   label: "Prattville (USPRV)"
  },
  {
   value: "Prescott (USPRC)",
   label: "Prescott (USPRC)"
  },
  {
   value: "Prescott (USPQW)",
   label: "Prescott (USPQW)"
  },
  {
   value: "Presidio (USPRE)",
   label: "Presidio (USPRE)"
  },
  {
   value: "Presque Isle (USPQI)",
   label: "Presque Isle (USPQI)"
  },
  {
   value: "Preston (USPRF)",
   label: "Preston (USPRF)"
  },
  {
   value: "Preston (USPBV)",
   label: "Preston (USPBV)"
  },
  {
   value: "Preston (USPRH)",
   label: "Preston (USPRH)"
  },
  {
   value: "Prichard (USPYC)",
   label: "Prichard (USPYC)"
  },
  {
   value: "Princeton (USPCT)",
   label: "Princeton (USPCT)"
  },
  {
   value: "Princeton (USXKH)",
   label: "Princeton (USXKH)"
  },
  {
   value: "Princeton (USPCJ)",
   label: "Princeton (USPCJ)"
  },
  {
   value: "Princeton (USXKU)",
   label: "Princeton (USXKU)"
  },
  {
   value: "Prineville (USPRZ)",
   label: "Prineville (USPRZ)"
  },
  {
   value: "Prior Lake (USPKE)",
   label: "Prior Lake (USPKE)"
  },
  {
   value: "Proctorville (USPVV)",
   label: "Proctorville (USPVV)"
  },
  {
   value: "Progresso (USPRG)",
   label: "Progresso (USPRG)"
  },
  {
   value: "Prospect (USPOP)",
   label: "Prospect (USPOP)"
  },
  {
   value: "Prospect (USXKR)",
   label: "Prospect (USXKR)"
  },
  {
   value: "Prospect Harbor (USPHM)",
   label: "Prospect Harbor (USPHM)"
  },
  {
   value: "Prosperity (USXKP)",
   label: "Prosperity (USXKP)"
  },
  {
   value: "Prosser (USPWS)",
   label: "Prosser (USPWS)"
  },
  {
   value: "Providence (USPVD)",
   label: "Providence (USPVD)"
  },
  {
   value: "Providence Forge (USPFG)",
   label: "Providence Forge (USPFG)"
  },
  {
   value: "Provincetown (USPVC)",
   label: "Provincetown (USPVC)"
  },
  {
   value: "Provo (USPVU)",
   label: "Provo (USPVU)"
  },
  {
   value: "Prudhoe (USPUO)",
   label: "Prudhoe (USPUO)"
  },
  {
   value: "Pryor (USPYR)",
   label: "Pryor (USPYR)"
  },
  {
   value: "Pueblo (USPUB)",
   label: "Pueblo (USPUB)"
  },
  {
   value: "Puget Sound (USPUG)",
   label: "Puget Sound (USPUG)"
  },
  {
   value: "Pulaski (USUYB)",
   label: "Pulaski (USUYB)"
  },
  {
   value: "Pulaski (USPKL)",
   label: "Pulaski (USPKL)"
  },
  {
   value: "Pulaski (USPUA)",
   label: "Pulaski (USPUA)"
  },
  {
   value: "Pullman (USPUW)",
   label: "Pullman (USPUW)"
  },
  {
   value: "Punta Gorda (USPGD)",
   label: "Punta Gorda (USPGD)"
  },
  {
   value: "Purvis (USPVR)",
   label: "Purvis (USPVR)"
  },
  {
   value: "Putnam (USPUN)",
   label: "Putnam (USPUN)"
  },
  {
   value: "Putney (USPUT)",
   label: "Putney (USPUT)"
  },
  {
   value: "Puyallup (USPUY)",
   label: "Puyallup (USPUY)"
  },
  {
   value: "Quakertown (USQKT)",
   label: "Quakertown (USQKT)"
  },
  {
   value: "Port Wakefield (USPTU)",
   label: "Port Wakefield (USPTU)"
  },
  {
   value: "Port Washington (USPWA)",
   label: "Port Washington (USPWA)"
  },
  {
   value: "Port Washington (USPOW)",
   label: "Port Washington (USPOW)"
  },
  {
   value: "Port Washington (USPTY)",
   label: "Port Washington (USPTY)"
  },
  {
   value: "Port Wentworth (USPWN)",
   label: "Port Wentworth (USPWN)"
  },
  {
   value: "Port Williams (USPWI)",
   label: "Port Williams (USPWI)"
  },
  {
   value: "Portage (USXKX)",
   label: "Portage (USXKX)"
  },
  {
   value: "Portal (USPTL)",
   label: "Portal (USPTL)"
  },
  {
   value: "Portales (USPXM)",
   label: "Portales (USPXM)"
  },
  {
   value: "Porter (USPWO)",
   label: "Porter (USPWO)"
  },
  {
   value: "Porterville (USPTV)",
   label: "Porterville (USPTV)"
  },
  {
   value: "Porthill (USPTH)",
   label: "Porthill (USPTH)"
  },
  {
   value: "Portland (USPDB)",
   label: "Portland (USPDB)"
  },
  {
   value: "Portland (USPQD)",
   label: "Portland (USPQD)"
  },
  {
   value: "Portland (USPWM)",
   label: "Portland (USPWM)"
  },
  {
   value: "Portland (USPJD)",
   label: "Portland (USPJD)"
  },
  {
   value: "Portland (USPTQ)",
   label: "Portland (USPTQ)"
  },
  {
   value: "Portland (USPDX)",
   label: "Portland (USPDX)"
  },
  {
   value: "Portsmouth (USPMH)",
   label: "Portsmouth (USPMH)"
  },
  {
   value: "Portsmouth (USPSM)",
   label: "Portsmouth (USPSM)"
  },
  {
   value: "Portsmouth (USPTM)",
   label: "Portsmouth (USPTM)"
  },
  {
   value: "Poseyville (USPYZ)",
   label: "Poseyville (USPYZ)"
  },
  {
   value: "Post (USPZS)",
   label: "Post (USPZS)"
  },
  {
   value: "Post Falls (USPFI)",
   label: "Post Falls (USPFI)"
  },
  {
   value: "Poteau (USRKR)",
   label: "Poteau (USRKR)"
  },
  {
   value: "Potomac (USPAC)",
   label: "Potomac (USPAC)"
  },
  {
   value: "Potosi (USPSI)",
   label: "Potosi (USPSI)"
  },
  {
   value: "Potsdam (USPPT)",
   label: "Potsdam (USPPT)"
  },
  {
   value: "Pottersburg (USPOG)",
   label: "Pottersburg (USPOG)"
  },
  {
   value: "Pottstown (USPTW)",
   label: "Pottstown (USPTW)"
  },
  {
   value: "Pottsville (USPSV)",
   label: "Pottsville (USPSV)"
  },
  {
   value: "Poughkeepsie (USPOU)",
   label: "Poughkeepsie (USPOU)"
  },
  {
   value: "Pounding Mills (USPDM)",
   label: "Pounding Mills (USPDM)"
  },
  {
   value: "Powder Springs (USPDS)",
   label: "Powder Springs (USPDS)"
  },
  {
   value: "Powell (USPOY)",
   label: "Powell (USPOY)"
  },
  {
   value: "Powell-River (USPWR)",
   label: "Powell-River (USPWR)"
  },
  {
   value: "Powers Lake (USXKY)",
   label: "Powers Lake (USXKY)"
  },
  {
   value: "Poynette (USPOV)",
   label: "Poynette (USPOV)"
  },
  {
   value: "Prairie (USUYA)",
   label: "Prairie (USUYA)"
  },
  {
   value: "Prairie Du Chien (USPCD)",
   label: "Prairie Du Chien (USPCD)"
  },
  {
   value: "Port Chester (USUXZ)",
   label: "Port Chester (USUXZ)"
  },
  {
   value: "Port Clinton (USPTT)",
   label: "Port Clinton (USPTT)"
  },
  {
   value: "Port Costa (USPCX)",
   label: "Port Costa (USPCX)"
  },
  {
   value: "Port Edwards (USPDW)",
   label: "Port Edwards (USPDW)"
  },
  {
   value: "Port Elizabeth (USPEB)",
   label: "Port Elizabeth (USPEB)"
  },
  {
   value: "Port Everglades (USPEF)",
   label: "Port Everglades (USPEF)"
  },
  {
   value: "Port Gamble (USPGH)",
   label: "Port Gamble (USPGH)"
  },
  {
   value: "Port Gibson (USPGB)",
   label: "Port Gibson (USPGB)"
  },
  {
   value: "Port Graham (USPGM)",
   label: "Port Graham (USPGM)"
  },
  {
   value: "Port Hadlock (USABC)",
   label: "Port Hadlock (USABC)"
  },
  {
   value: "Port Hudson (USPHV)",
   label: "Port Hudson (USPHV)"
  },
  {
   value: "Port Hueneme (USNTD)",
   label: "Port Hueneme (USNTD)"
  },
  {
   value: "Port Huron (USPHN)",
   label: "Port Huron (USPHN)"
  },
  {
   value: "Port Isabel-Brownsville (USPIS)",
   label: "Port Isabel-Brownsville (USPIS)"
  },
  {
   value: "Port Ivory (USPIY)",
   label: "Port Ivory (USPIY)"
  },
  {
   value: "Port Jefferson (USPTJ)",
   label: "Port Jefferson (USPTJ)"
  },
  {
   value: "Port Lavaca (USPLV)",
   label: "Port Lavaca (USPLV)"
  },
  {
   value: "Port Lions (USPDL)",
   label: "Port Lions (USPDL)"
  },
  {
   value: "Port Ludlow (USPLU)",
   label: "Port Ludlow (USPLU)"
  },
  {
   value: "Port Manatee (USPME)",
   label: "Port Manatee (USPME)"
  },
  {
   value: "Port Neches (USPON)",
   label: "Port Neches (USPON)"
  },
  {
   value: "Port Newark (USPNJ)",
   label: "Port Newark (USPNJ)"
  },
  {
   value: "Port of Palm Beach (USPBC)",
   label: "Port of Palm Beach (USPBC)"
  },
  {
   value: "Port Orange (USPOE)",
   label: "Port Orange (USPOE)"
  },
  {
   value: "Port Orchard (USPXO)",
   label: "Port Orchard (USPXO)"
  },
  {
   value: "Port Providence (USPPR)",
   label: "Port Providence (USPPR)"
  },
  {
   value: "Port Reading (USPRD)",
   label: "Port Reading (USPRD)"
  },
  {
   value: "Port Rishely (USPTF)",
   label: "Port Rishely (USPTF)"
  },
  {
   value: "Port Royal (USPRL)",
   label: "Port Royal (USPRL)"
  },
  {
   value: "Port Saint Joe (USPXJ)",
   label: "Port Saint Joe (USPXJ)"
  },
  {
   value: "Port Saint Lucie (USPZL)",
   label: "Port Saint Lucie (USPZL)"
  },
  {
   value: "Port San Luis (USPSL)",
   label: "Port San Luis (USPSL)"
  },
  {
   value: "Port Side (USPRT)",
   label: "Port Side (USPRT)"
  },
  {
   value: "Port St Joe (USPSJ)",
   label: "Port St Joe (USPSJ)"
  },
  {
   value: "Port Sulphur (USSUL)",
   label: "Port Sulphur (USSUL)"
  },
  {
   value: "Port Tampa (USPOT)",
   label: "Port Tampa (USPOT)"
  },
  {
   value: "Port Townsend (USTWD)",
   label: "Port Townsend (USTWD)"
  },
  {
   value: "Port Trevorton (USPVT)",
   label: "Port Trevorton (USPVT)"
  },
  {
   value: "Plymouth (USPMW)",
   label: "Plymouth (USPMW)"
  },
  {
   value: "Plymouth Meeting (USPMM)",
   label: "Plymouth Meeting (USPMM)"
  },
  {
   value: "Pocatello (USPIH)",
   label: "Pocatello (USPIH)"
  },
  {
   value: "Pocomoke City (USPCK)",
   label: "Pocomoke City (USPCK)"
  },
  {
   value: "Pocono Manor (USPOR)",
   label: "Pocono Manor (USPOR)"
  },
  {
   value: "Poinciana (USPFL)",
   label: "Poinciana (USPFL)"
  },
  {
   value: "Point Comfort (USPCR)",
   label: "Point Comfort (USPCR)"
  },
  {
   value: "Point Harlan (USPHR)",
   label: "Point Harlan (USPHR)"
  },
  {
   value: "Point Judith (USPJH)",
   label: "Point Judith (USPJH)"
  },
  {
   value: "Point Pleasant (USPPZ)",
   label: "Point Pleasant (USPPZ)"
  },
  {
   value: "Point Roberts (USPRS)",
   label: "Point Roberts (USPRS)"
  },
  {
   value: "Pointe A La Hache (USPHC)",
   label: "Pointe A La Hache (USPHC)"
  },
  {
   value: "Poland Spring (USPLD)",
   label: "Poland Spring (USPLD)"
  },
  {
   value: "Polo (USPOO)",
   label: "Polo (USPOO)"
  },
  {
   value: "Pomfret (USPFR)",
   label: "Pomfret (USPFR)"
  },
  {
   value: "Pomona (USPQC)",
   label: "Pomona (USPQC)"
  },
  {
   value: "Pomona (USPMA)",
   label: "Pomona (USPMA)"
  },
  {
   value: "Pompano Beach (USPPM)",
   label: "Pompano Beach (USPPM)"
  },
  {
   value: "Pompton Plains (USPMJ)",
   label: "Pompton Plains (USPMJ)"
  },
  {
   value: "Ponca City (USPNC)",
   label: "Ponca City (USPNC)"
  },
  {
   value: "Ponchatula (USPCS)",
   label: "Ponchatula (USPCS)"
  },
  {
   value: "Pontiac (USPIB)",
   label: "Pontiac (USPIB)"
  },
  {
   value: "Pontiac (USPTK)",
   label: "Pontiac (USPTK)"
  },
  {
   value: "Pontiac (USPOI)",
   label: "Pontiac (USPOI)"
  },
  {
   value: "Pontotoc (USPOK)",
   label: "Pontotoc (USPOK)"
  },
  {
   value: "Pooler (USPLR)",
   label: "Pooler (USPLR)"
  },
  {
   value: "Poplar Bluff (USPWB)",
   label: "Poplar Bluff (USPWB)"
  },
  {
   value: "Poplar Bluff (USPOF)",
   label: "Poplar Bluff (USPOF)"
  },
  {
   value: "Port Allegany (USPTG)",
   label: "Port Allegany (USPTG)"
  },
  {
   value: "Port Allen (USPLL)",
   label: "Port Allen (USPLL)"
  },
  {
   value: "Port Allen (USPAL)",
   label: "Port Allen (USPAL)"
  },
  {
   value: "Port Angeles (USCLM)",
   label: "Port Angeles (USCLM)"
  },
  {
   value: "Port Arthur (USPOA)",
   label: "Port Arthur (USPOA)"
  },
  {
   value: "Port Bailey (USKPY)",
   label: "Port Bailey (USKPY)"
  },
  {
   value: "Port Bienville (USPBW)",
   label: "Port Bienville (USPBW)"
  },
  {
   value: "Port Blakely (USPRY)",
   label: "Port Blakely (USPRY)"
  },
  {
   value: "Port Bolivar (USPOB)",
   label: "Port Bolivar (USPOB)"
  },
  {
   value: "Port Canaveral (USPCA)",
   label: "Port Canaveral (USPCA)"
  },
  {
   value: "Port Charlotte (USPCH)",
   label: "Port Charlotte (USPCH)"
  },
  {
   value: "Plain City (USPLX)",
   label: "Plain City (USPLX)"
  },
  {
   value: "Plainfield (USPFD)",
   label: "Plainfield (USPFD)"
  },
  {
   value: "Plainfield (USPLF)",
   label: "Plainfield (USPLF)"
  },
  {
   value: "Plainfield (USPLI)",
   label: "Plainfield (USPLI)"
  },
  {
   value: "Plainfield (USPNF)",
   label: "Plainfield (USPNF)"
  },
  {
   value: "Plains (USPLG)",
   label: "Plains (USPLG)"
  },
  {
   value: "Plains (USPLS)",
   label: "Plains (USPLS)"
  },
  {
   value: "Plainsboro (USXKM)",
   label: "Plainsboro (USXKM)"
  },
  {
   value: "Plainsview (USPSW)",
   label: "Plainsview (USPSW)"
  },
  {
   value: "Plainview (USPVW)",
   label: "Plainview (USPVW)"
  },
  {
   value: "Plainview (USPVX)",
   label: "Plainview (USPVX)"
  },
  {
   value: "Plainview (USPLJ)",
   label: "Plainview (USPLJ)"
  },
  {
   value: "Plainview (USPVN)",
   label: "Plainview (USPVN)"
  },
  {
   value: "Plainville (USPVI)",
   label: "Plainville (USPVI)"
  },
  {
   value: "Plainville (USPVG)",
   label: "Plainville (USPVG)"
  },
  {
   value: "Plainville (USXKV)",
   label: "Plainville (USXKV)"
  },
  {
   value: "Plainwell (USPNW)",
   label: "Plainwell (USPNW)"
  },
  {
   value: "Plaistow (USPZX)",
   label: "Plaistow (USPZX)"
  },
  {
   value: "Plano (USPNO)",
   label: "Plano (USPNO)"
  },
  {
   value: "Plano (USPXL)",
   label: "Plano (USPXL)"
  },
  {
   value: "Plant City (USPCI)",
   label: "Plant City (USPCI)"
  },
  {
   value: "Plaquemine (USPLQ)",
   label: "Plaquemine (USPLQ)"
  },
  {
   value: "Platteville (USPLO)",
   label: "Platteville (USPLO)"
  },
  {
   value: "Plattsburgh (USPLB)",
   label: "Plattsburgh (USPLB)"
  },
  {
   value: "Playa Del Rey (USPYQ)",
   label: "Playa Del Rey (USPYQ)"
  },
  {
   value: "Pleasant Grove (USPXG)",
   label: "Pleasant Grove (USPXG)"
  },
  {
   value: "Pleasant Hill (USPFH)",
   label: "Pleasant Hill (USPFH)"
  },
  {
   value: "Pleasanton (USJBS)",
   label: "Pleasanton (USJBS)"
  },
  {
   value: "Pleasantville (USUXV)",
   label: "Pleasantville (USUXV)"
  },
  {
   value: "Plover (USPLW)",
   label: "Plover (USPLW)"
  },
  {
   value: "Plymouth (USPMY)",
   label: "Plymouth (USPMY)"
  },
  {
   value: "Plymouth (USPLH)",
   label: "Plymouth (USPLH)"
  },
  {
   value: "Plymouth (USPVH)",
   label: "Plymouth (USPVH)"
  },
  {
   value: "Plymouth (USXKN)",
   label: "Plymouth (USXKN)"
  },
  {
   value: "Plymouth (USPIM)",
   label: "Plymouth (USPIM)"
  },
  {
   value: "Plymouth (USUXY)",
   label: "Plymouth (USUXY)"
  },
  {
   value: "Plymouth (USPYM)",
   label: "Plymouth (USPYM)"
  },
  {
   value: "Plymouth (USPLY)",
   label: "Plymouth (USPLY)"
  },
  {
   value: "Plymouth (USPMF)",
   label: "Plymouth (USPMF)"
  },
  {
   value: "Plymouth (USPYT)",
   label: "Plymouth (USPYT)"
  },
  {
   value: "Pine Bluff (USPBF)",
   label: "Pine Bluff (USPBF)"
  },
  {
   value: "Pine Brook (USPBO)",
   label: "Pine Brook (USPBO)"
  },
  {
   value: "Pine Hall (USPNH)",
   label: "Pine Hall (USPNH)"
  },
  {
   value: "Pine Hill (USPID)",
   label: "Pine Hill (USPID)"
  },
  {
   value: "Pine Island (USPNI)",
   label: "Pine Island (USPNI)"
  },
  {
   value: "Pine River (USPRW)",
   label: "Pine River (USPRW)"
  },
  {
   value: "Pinecreek (USPIN)",
   label: "Pinecreek (USPIN)"
  },
  {
   value: "Pinedale (USPNL)",
   label: "Pinedale (USPNL)"
  },
  {
   value: "Pinehurst (USPHZ)",
   label: "Pinehurst (USPHZ)"
  },
  {
   value: "Pinehurst (USPHS)",
   label: "Pinehurst (USPHS)"
  },
  {
   value: "Pineland (USPLN)",
   label: "Pineland (USPLN)"
  },
  {
   value: "Pinellas Park (USPPB)",
   label: "Pinellas Park (USPPB)"
  },
  {
   value: "Pineville (USXKO)",
   label: "Pineville (USXKO)"
  },
  {
   value: "Pineville (USPMC)",
   label: "Pineville (USPMC)"
  },
  {
   value: "Pineville (USPIV)",
   label: "Pineville (USPIV)"
  },
  {
   value: "Pineville (USPVL)",
   label: "Pineville (USPVL)"
  },
  {
   value: "Pineville (USPVE)",
   label: "Pineville (USPVE)"
  },
  {
   value: "Pineville (USPNV)",
   label: "Pineville (USPNV)"
  },
  {
   value: "Piney Point (USPYP)",
   label: "Piney Point (USPYP)"
  },
  {
   value: "Pinson (USPYN)",
   label: "Pinson (USPYN)"
  },
  {
   value: "Pioneer (USPYH)",
   label: "Pioneer (USPYH)"
  },
  {
   value: "Pipersville (USPIP)",
   label: "Pipersville (USPIP)"
  },
  {
   value: "Pipestone (USPPE)",
   label: "Pipestone (USPPE)"
  },
  {
   value: "Piqua (USPQA)",
   label: "Piqua (USPQA)"
  },
  {
   value: "Piscataway (USPIL)",
   label: "Piscataway (USPIL)"
  },
  {
   value: "Pisgah (USPGA)",
   label: "Pisgah (USPGA)"
  },
  {
   value: "Pisgah Forest (USPGF)",
   label: "Pisgah Forest (USPGF)"
  },
  {
   value: "Pitsburg (USPBR)",
   label: "Pitsburg (USPBR)"
  },
  {
   value: "Pittsboro (USPII)",
   label: "Pittsboro (USPII)"
  },
  {
   value: "Pittsburg (USPTS)",
   label: "Pittsburg (USPTS)"
  },
  {
   value: "Pittsburg (USPHG)",
   label: "Pittsburg (USPHG)"
  },
  {
   value: "Pittsburg (USPBG)",
   label: "Pittsburg (USPBG)"
  },
  {
   value: "Pittsburgh (USPIT)",
   label: "Pittsburgh (USPIT)"
  },
  {
   value: "Pittsfield (USPSF)",
   label: "Pittsfield (USPSF)"
  },
  {
   value: "Pittsfield (USPTZ)",
   label: "Pittsfield (USPTZ)"
  },
  {
   value: "Pittsford (USPDY)",
   label: "Pittsford (USPDY)"
  },
  {
   value: "Pittston (USPTO)",
   label: "Pittston (USPTO)"
  },
  {
   value: "Pixley (USPXY)",
   label: "Pixley (USPXY)"
  },
  {
   value: "Placentia (USPCC)",
   label: "Placentia (USPCC)"
  },
  {
   value: "Placerville (USPVF)",
   label: "Placerville (USPVF)"
  },
  {
   value: "Peru (USGUS)",
   label: "Peru (USGUS)"
  },
  {
   value: "Perun (USPRN)",
   label: "Perun (USPRN)"
  },
  {
   value: "Peshtigo (USPSH)",
   label: "Peshtigo (USPSH)"
  },
  {
   value: "Petaluma (USPUM)",
   label: "Petaluma (USPUM)"
  },
  {
   value: "Peterman (USPEE)",
   label: "Peterman (USPEE)"
  },
  {
   value: "Petersburg (USPSG)",
   label: "Petersburg (USPSG)"
  },
  {
   value: "Petersburg (USPBU)",
   label: "Petersburg (USPBU)"
  },
  {
   value: "Petersburg (USPTB)",
   label: "Petersburg (USPTB)"
  },
  {
   value: "Petoskey (USPET)",
   label: "Petoskey (USPET)"
  },
  {
   value: "Petrolia (USPEO)",
   label: "Petrolia (USPEO)"
  },
  {
   value: "Pewamo (USPZE)",
   label: "Pewamo (USPZE)"
  },
  {
   value: "Pewaukee (USPEW)",
   label: "Pewaukee (USPEW)"
  },
  {
   value: "Pharr (USPFX)",
   label: "Pharr (USPFX)"
  },
  {
   value: "Phenix City (USPHA)",
   label: "Phenix City (USPHA)"
  },
  {
   value: "Philadelphia (USPXX)",
   label: "Philadelphia (USPXX)"
  },
  {
   value: "Philadelphia (USPHL)",
   label: "Philadelphia (USPHL)"
  },
  {
   value: "Philippi (USPPI)",
   label: "Philippi (USPPI)"
  },
  {
   value: "Philips (USPJP)",
   label: "Philips (USPJP)"
  },
  {
   value: "Phillipsburg (USPHI)",
   label: "Phillipsburg (USPHI)"
  },
  {
   value: "Phoenix (USPHX)",
   label: "Phoenix (USPHX)"
  },
  {
   value: "Phoenixville (USPXV)",
   label: "Phoenixville (USPXV)"
  },
  {
   value: "Pica Long Beach (USPBE)",
   label: "Pica Long Beach (USPBE)"
  },
  {
   value: "Picacho (USPIZ)",
   label: "Picacho (USPIZ)"
  },
  {
   value: "Picayune (USPCU)",
   label: "Picayune (USPCU)"
  },
  {
   value: "Pickens (USLQK)",
   label: "Pickens (USLQK)"
  },
  {
   value: "Pico Rivera (USPQU)",
   label: "Pico Rivera (USPQU)"
  },
  {
   value: "Piedmont (USPVK)",
   label: "Piedmont (USPVK)"
  },
  {
   value: "Piedmont (USPIX)",
   label: "Piedmont (USPIX)"
  },
  {
   value: "Piedmont (USPIQ)",
   label: "Piedmont (USPIQ)"
  },
  {
   value: "Piedmont (USPIJ)",
   label: "Piedmont (USPIJ)"
  },
  {
   value: "Piegan (USPGN)",
   label: "Piegan (USPGN)"
  },
  {
   value: "Pierce (USPJK)",
   label: "Pierce (USPJK)"
  },
  {
   value: "Pierre (USPIR)",
   label: "Pierre (USPIR)"
  },
  {
   value: "Pierson (USPIF)",
   label: "Pierson (USPIF)"
  },
  {
   value: "Pierson (USPIO)",
   label: "Pierson (USPIO)"
  },
  {
   value: "Pigeon (USPIG)",
   label: "Pigeon (USPIG)"
  },
  {
   value: "Piggott (USPZY)",
   label: "Piggott (USPZY)"
  },
  {
   value: "Pikesville (USPXZ)",
   label: "Pikesville (USPXZ)"
  },
  {
   value: "Pikeville (USPIK)",
   label: "Pikeville (USPIK)"
  },
  {
   value: "Pikeville (USPKK)",
   label: "Pikeville (USPKK)"
  },
  {
   value: "Pilottown (USPIW)",
   label: "Pilottown (USPIW)"
  },
  {
   value: "Pejepscot (USPZJ)",
   label: "Pejepscot (USPZJ)"
  },
  {
   value: "Pekin (USPEQ)",
   label: "Pekin (USPEQ)"
  },
  {
   value: "Pekin (USPKI)",
   label: "Pekin (USPKI)"
  },
  {
   value: "Pelahatchie (USPHP)",
   label: "Pelahatchie (USPHP)"
  },
  {
   value: "Pelham (USPEH)",
   label: "Pelham (USPEH)"
  },
  {
   value: "Pelham (USPHW)",
   label: "Pelham (USPHW)"
  },
  {
   value: "Pelham Manor (USPEX)",
   label: "Pelham Manor (USPEX)"
  },
  {
   value: "Pelican (USPEC)",
   label: "Pelican (USPEC)"
  },
  {
   value: "Pelican (USPQL)",
   label: "Pelican (USPQL)"
  },
  {
   value: "Pella (USPEL)",
   label: "Pella (USPEL)"
  },
  {
   value: "Pemberville (USPEM)",
   label: "Pemberville (USPEM)"
  },
  {
   value: "Pembina (USPMB)",
   label: "Pembina (USPMB)"
  },
  {
   value: "Pembroke (USPBD)",
   label: "Pembroke (USPBD)"
  },
  {
   value: "Pendergrass (USPGG)",
   label: "Pendergrass (USPGG)"
  },
  {
   value: "Pendleton (USPDN)",
   label: "Pendleton (USPDN)"
  },
  {
   value: "Pendleton (USPDT)",
   label: "Pendleton (USPDT)"
  },
  {
   value: "Penn Run (USPNR)",
   label: "Penn Run (USPNR)"
  },
  {
   value: "Penn Valley (USPVA)",
   label: "Penn Valley (USPVA)"
  },
  {
   value: "Penndel (USPEN)",
   label: "Penndel (USPEN)"
  },
  {
   value: "Pennington (USPGT)",
   label: "Pennington (USPGT)"
  },
  {
   value: "Pennington Gap (USXKK)",
   label: "Pennington Gap (USXKK)"
  },
  {
   value: "Pennsauken (USPPS)",
   label: "Pennsauken (USPPS)"
  },
  {
   value: "Pennsville (USPFJ)",
   label: "Pennsville (USPFJ)"
  },
  {
   value: "Pensacola (USPNS)",
   label: "Pensacola (USPNS)"
  },
  {
   value: "Pensauken (USPSU)",
   label: "Pensauken (USPSU)"
  },
  {
   value: "Peoria (USPEI)",
   label: "Peoria (USPEI)"
  },
  {
   value: "Peoria (USPIA)",
   label: "Peoria (USPIA)"
  },
  {
   value: "Peosta (USPST)",
   label: "Peosta (USPST)"
  },
  {
   value: "Pepperell (USPEP)",
   label: "Pepperell (USPEP)"
  },
  {
   value: "Pequaneck (USPQN)",
   label: "Pequaneck (USPQN)"
  },
  {
   value: "Perham (USXKJ)",
   label: "Perham (USXKJ)"
  },
  {
   value: "Perrine (USPRI)",
   label: "Perrine (USPRI)"
  },
  {
   value: "Perris (USPER)",
   label: "Perris (USPER)"
  },
  {
   value: "Perry (USFPY)",
   label: "Perry (USFPY)"
  },
  {
   value: "Perry (USPYG)",
   label: "Perry (USPYG)"
  },
  {
   value: "Perry (USPQY)",
   label: "Perry (USPQY)"
  },
  {
   value: "Perry (USPRR)",
   label: "Perry (USPRR)"
  },
  {
   value: "Perrysburg (USXKQ)",
   label: "Perrysburg (USXKQ)"
  },
  {
   value: "Perrysville (USPYV)",
   label: "Perrysville (USPYV)"
  },
  {
   value: "Perryville (USPYX)",
   label: "Perryville (USPYX)"
  },
  {
   value: "Perth Amboy (USPAY)",
   label: "Perth Amboy (USPAY)"
  },
  {
   value: "Peru (USVYS)",
   label: "Peru (USVYS)"
  },
  {
   value: "Pasco (USPSC)",
   label: "Pasco (USPSC)"
  },
  {
   value: "Paso Robles (USPRB)",
   label: "Paso Robles (USPRB)"
  },
  {
   value: "Pass Christian (USPCM)",
   label: "Pass Christian (USPCM)"
  },
  {
   value: "Passaic (USPSE)",
   label: "Passaic (USPSE)"
  },
  {
   value: "Pateros (USXKT)",
   label: "Pateros (USXKT)"
  },
  {
   value: "Paterson (USPAT)",
   label: "Paterson (USPAT)"
  },
  {
   value: "Patterson (USPAN)",
   label: "Patterson (USPAN)"
  },
  {
   value: "Patterson (USPCQ)",
   label: "Patterson (USPCQ)"
  },
  {
   value: "Patterson (USPNQ)",
   label: "Patterson (USPNQ)"
  },
  {
   value: "Patterson (USUYC)",
   label: "Patterson (USUYC)"
  },
  {
   value: "Paul (USPAZ)",
   label: "Paul (USPAZ)"
  },
  {
   value: "Paulding (USPOH)",
   label: "Paulding (USPOH)"
  },
  {
   value: "Pauline (USPQS)",
   label: "Pauline (USPQS)"
  },
  {
   value: "Pauls Valley (USPVY)",
   label: "Pauls Valley (USPVY)"
  },
  {
   value: "Paulsboro (USPAU)",
   label: "Paulsboro (USPAU)"
  },
  {
   value: "Paw Paw (USPPW)",
   label: "Paw Paw (USPPW)"
  },
  {
   value: "Paw Paw (USUXT)",
   label: "Paw Paw (USUXT)"
  },
  {
   value: "Pawcatuck (USPWP)",
   label: "Pawcatuck (USPWP)"
  },
  {
   value: "Pawling (USPWL)",
   label: "Pawling (USPWL)"
  },
  {
   value: "Pawnee (USPWE)",
   label: "Pawnee (USPWE)"
  },
  {
   value: "Pawtucket (USPAW)",
   label: "Pawtucket (USPAW)"
  },
  {
   value: "Paxinos (USPXS)",
   label: "Paxinos (USPXS)"
  },
  {
   value: "Paxon (USPXF)",
   label: "Paxon (USPXF)"
  },
  {
   value: "Paxson (USPAX)",
   label: "Paxson (USPAX)"
  },
  {
   value: "Payette (USPYE)",
   label: "Payette (USPYE)"
  },
  {
   value: "Paynesville (USPYW)",
   label: "Paynesville (USPYW)"
  },
  {
   value: "Payson (USPYU)",
   label: "Payson (USPYU)"
  },
  {
   value: "Peabody (USPED)",
   label: "Peabody (USPED)"
  },
  {
   value: "Peace Dale (USPDA)",
   label: "Peace Dale (USPDA)"
  },
  {
   value: "Peach Glen (USPCG)",
   label: "Peach Glen (USPCG)"
  },
  {
   value: "Peachtree City (USPTC)",
   label: "Peachtree City (USPTC)"
  },
  {
   value: "Pearl (USPES)",
   label: "Pearl (USPES)"
  },
  {
   value: "Pearl City (USPEZ)",
   label: "Pearl City (USPEZ)"
  },
  {
   value: "Pearl City (Oahu) (USPLC)",
   label: "Pearl City (Oahu) (USPLC)"
  },
  {
   value: "Pearl Harbor (USPEA)",
   label: "Pearl Harbor (USPEA)"
  },
  {
   value: "Pearl River (USPAV)",
   label: "Pearl River (USPAV)"
  },
  {
   value: "Pearland (USPND)",
   label: "Pearland (USPND)"
  },
  {
   value: "Pearson (USPEJ)",
   label: "Pearson (USPEJ)"
  },
  {
   value: "Pecos (USPQO)",
   label: "Pecos (USPQO)"
  },
  {
   value: "Pedricktown (USPKN)",
   label: "Pedricktown (USPKN)"
  },
  {
   value: "Peeksville (USPEK)",
   label: "Peeksville (USPEK)"
  },
  {
   value: "Palmer (USPAQ)",
   label: "Palmer (USPAQ)"
  },
  {
   value: "Palmer (USPMX)",
   label: "Palmer (USPMX)"
  },
  {
   value: "Palmerton (USPLA)",
   label: "Palmerton (USPLA)"
  },
  {
   value: "Palmetto (USPMT)",
   label: "Palmetto (USPMT)"
  },
  {
   value: "Palmetto (USPFP)",
   label: "Palmetto (USPFP)"
  },
  {
   value: "Palmyra (USPYA)",
   label: "Palmyra (USPYA)"
  },
  {
   value: "Palmyra (USPBJ)",
   label: "Palmyra (USPBJ)"
  },
  {
   value: "Palo Alto (USPAO)",
   label: "Palo Alto (USPAO)"
  },
  {
   value: "Pampa (USPPA)",
   label: "Pampa (USPPA)"
  },
  {
   value: "Pampano Beach (USPMP)",
   label: "Pampano Beach (USPMP)"
  },
  {
   value: "Panama City (USPFN)",
   label: "Panama City (USPFN)"
  },
  {
   value: "Pandora (USPKO)",
   label: "Pandora (USPKO)"
  },
  {
   value: "Panorama City (USPHQ)",
   label: "Panorama City (USPHQ)"
  },
  {
   value: "Paragould (USPGR)",
   label: "Paragould (USPGR)"
  },
  {
   value: "Paramount (USPMQ)",
   label: "Paramount (USPMQ)"
  },
  {
   value: "Paramus (USPRM)",
   label: "Paramus (USPRM)"
  },
  {
   value: "Paris (USPRP)",
   label: "Paris (USPRP)"
  },
  {
   value: "Paris (USPZT)",
   label: "Paris (USPZT)"
  },
  {
   value: "Paris (USPHT)",
   label: "Paris (USPHT)"
  },
  {
   value: "Paris (USPRX)",
   label: "Paris (USPRX)"
  },
  {
   value: "Park City (USPKC)",
   label: "Park City (USPKC)"
  },
  {
   value: "Park Forest (USPFO)",
   label: "Park Forest (USPFO)"
  },
  {
   value: "Park Junction (USPKJ)",
   label: "Park Junction (USPKJ)"
  },
  {
   value: "Park Rapids (USPKD)",
   label: "Park Rapids (USPKD)"
  },
  {
   value: "Parker (USPKW)",
   label: "Parker (USPKW)"
  },
  {
   value: "Parkersburg\/Marietta (USPKB)",
   label: "Parkersburg\/Marietta (USPKB)"
  },
  {
   value: "Parkesburg (USPKP)",
   label: "Parkesburg (USPKP)"
  },
  {
   value: "Parkridge (USPRK)",
   label: "Parkridge (USPRK)"
  },
  {
   value: "Parkrose (USPKZ)",
   label: "Parkrose (USPKZ)"
  },
  {
   value: "Parksley (USPKY)",
   label: "Parksley (USPKY)"
  },
  {
   value: "Parkwood (USPGW)",
   label: "Parkwood (USPGW)"
  },
  {
   value: "Parlier (USPAR)",
   label: "Parlier (USPAR)"
  },
  {
   value: "Parlin (USPUJ)",
   label: "Parlin (USPUJ)"
  },
  {
   value: "Parma (USPBH)",
   label: "Parma (USPBH)"
  },
  {
   value: "Parris Island (USXKL)",
   label: "Parris Island (USXKL)"
  },
  {
   value: "Parsipanny (USPPY)",
   label: "Parsipanny (USPPY)"
  },
  {
   value: "Parsons (USPPF)",
   label: "Parsons (USPPF)"
  },
  {
   value: "Parsons (USPWV)",
   label: "Parsons (USPWV)"
  },
  {
   value: "Pasadena (USPSD)",
   label: "Pasadena (USPSD)"
  },
  {
   value: "Pasadena (USPAS)",
   label: "Pasadena (USPAS)"
  },
  {
   value: "Pascagoula (USPGL)",
   label: "Pascagoula (USPGL)"
  },
  {
   value: "Owatonna (USOWA)",
   label: "Owatonna (USOWA)"
  },
  {
   value: "Owendale (USODL)",
   label: "Owendale (USODL)"
  },
  {
   value: "Owensboro (USOWB)",
   label: "Owensboro (USOWB)"
  },
  {
   value: "Owensville (USOWV)",
   label: "Owensville (USOWV)"
  },
  {
   value: "Owings Mills (USOWI)",
   label: "Owings Mills (USOWI)"
  },
  {
   value: "Owosso (USOWO)",
   label: "Owosso (USOWO)"
  },
  {
   value: "Oxford (USOFD)",
   label: "Oxford (USOFD)"
  },
  {
   value: "Oxford (USOXC)",
   label: "Oxford (USOXC)"
  },
  {
   value: "Oxford (USOXG)",
   label: "Oxford (USOXG)"
  },
  {
   value: "Oxford (USOXA)",
   label: "Oxford (USOXA)"
  },
  {
   value: "Oxford (USOXB)",
   label: "Oxford (USOXB)"
  },
  {
   value: "Oxford (USUOX)",
   label: "Oxford (USUOX)"
  },
  {
   value: "Oxford (USOXF)",
   label: "Oxford (USOXF)"
  },
  {
   value: "Oxford (USOXD)",
   label: "Oxford (USOXD)"
  },
  {
   value: "Oxford (USOXO)",
   label: "Oxford (USOXO)"
  },
  {
   value: "Oyster Bay (USOYS)",
   label: "Oyster Bay (USOYS)"
  },
  {
   value: "Ozark (USOZR)",
   label: "Ozark (USOZR)"
  },
  {
   value: "Ozark (USOZK)",
   label: "Ozark (USOZK)"
  },
  {
   value: "Ozone Park (USOZO)",
   label: "Ozone Park (USOZO)"
  },
  {
   value: "Pabst (USPBT)",
   label: "Pabst (USPBT)"
  },
  {
   value: "Pace (USPCE)",
   label: "Pace (USPCE)"
  },
  {
   value: "Pacific Palisades (USPPH)",
   label: "Pacific Palisades (USPPH)"
  },
  {
   value: "Pacifica (USPFQ)",
   label: "Pacifica (USPFQ)"
  },
  {
   value: "Pacoima (USPUQ)",
   label: "Pacoima (USPUQ)"
  },
  {
   value: "Paden City (USPCY)",
   label: "Paden City (USPCY)"
  },
  {
   value: "Paducah (USPAH)",
   label: "Paducah (USPAH)"
  },
  {
   value: "Paducah (USXKG)",
   label: "Paducah (USXKG)"
  },
  {
   value: "Pahokee (USPHK)",
   label: "Pahokee (USPHK)"
  },
  {
   value: "Pahrump (USPQV)",
   label: "Pahrump (USPQV)"
  },
  {
   value: "Painesville (USPVZ)",
   label: "Painesville (USPVZ)"
  },
  {
   value: "Painted Post (USPWY)",
   label: "Painted Post (USPWY)"
  },
  {
   value: "Palatine (USPLE)",
   label: "Palatine (USPLE)"
  },
  {
   value: "Palatka (USPLT)",
   label: "Palatka (USPLT)"
  },
  {
   value: "Palestine (USPSN)",
   label: "Palestine (USPSN)"
  },
  {
   value: "Palisade (USPDE)",
   label: "Palisade (USPDE)"
  },
  {
   value: "Palisades Park (USPSA)",
   label: "Palisades Park (USPSA)"
  },
  {
   value: "Palm Bay (USPKF)",
   label: "Palm Bay (USPKF)"
  },
  {
   value: "Palm Beach (USPAB)",
   label: "Palm Beach (USPAB)"
  },
  {
   value: "Palm Coast (USPLM)",
   label: "Palm Coast (USPLM)"
  },
  {
   value: "Palm Harbor (USXKI)",
   label: "Palm Harbor (USXKI)"
  },
  {
   value: "Palm Springs (USPSP)",
   label: "Palm Springs (USPSP)"
  },
  {
   value: "Orangeville (USOGV)",
   label: "Orangeville (USOGV)"
  },
  {
   value: "Orcas (USXJY)",
   label: "Orcas (USXJY)"
  },
  {
   value: "Orchard Park (USOPY)",
   label: "Orchard Park (USOPY)"
  },
  {
   value: "Orchards (USOCJ)",
   label: "Orchards (USOCJ)"
  },
  {
   value: "Ordbend (USORY)",
   label: "Ordbend (USORY)"
  },
  {
   value: "Orefield (USXKD)",
   label: "Orefield (USXKD)"
  },
  {
   value: "Oregon (USOGI)",
   label: "Oregon (USOGI)"
  },
  {
   value: "Oregon City (USORC)",
   label: "Oregon City (USORC)"
  },
  {
   value: "Orem (USOEU)",
   label: "Orem (USOEU)"
  },
  {
   value: "Orestes (USORU)",
   label: "Orestes (USORU)"
  },
  {
   value: "Oriskany (USOKY)",
   label: "Oriskany (USOKY)"
  },
  {
   value: "Oriskany Falls (USOFY)",
   label: "Oriskany Falls (USOFY)"
  },
  {
   value: "Orland Park (USXKC)",
   label: "Orland Park (USXKC)"
  },
  {
   value: "Orlando (USORL)",
   label: "Orlando (USORL)"
  },
  {
   value: "Orleans (USORZ)",
   label: "Orleans (USORZ)"
  },
  {
   value: "Orleans (USORJ)",
   label: "Orleans (USORJ)"
  },
  {
   value: "Ormond Beach (USODB)",
   label: "Ormond Beach (USODB)"
  },
  {
   value: "Oroville (USOVW)",
   label: "Oroville (USOVW)"
  },
  {
   value: "Orrtanna (USOTP)",
   label: "Orrtanna (USOTP)"
  },
  {
   value: "Orrville (USORR)",
   label: "Orrville (USORR)"
  },
  {
   value: "Orting (USXKE)",
   label: "Orting (USXKE)"
  },
  {
   value: "Orwell (USORW)",
   label: "Orwell (USORW)"
  },
  {
   value: "Orwigsburg (USOWP)",
   label: "Orwigsburg (USOWP)"
  },
  {
   value: "Osceola (USOSA)",
   label: "Osceola (USOSA)"
  },
  {
   value: "Oscoda (USOSC)",
   label: "Oscoda (USOSC)"
  },
  {
   value: "Oshkosh (USOSH)",
   label: "Oshkosh (USOSH)"
  },
  {
   value: "Oskaloosa (USOOA)",
   label: "Oskaloosa (USOOA)"
  },
  {
   value: "Oslo (USOSL)",
   label: "Oslo (USOSL)"
  },
  {
   value: "Osseo (USOZZ)",
   label: "Osseo (USOZZ)"
  },
  {
   value: "Ossining (USOSS)",
   label: "Ossining (USOSS)"
  },
  {
   value: "Ostrica (USOST)",
   label: "Ostrica (USOST)"
  },
  {
   value: "Oswego (USOSW)",
   label: "Oswego (USOSW)"
  },
  {
   value: "Othello (USXKF)",
   label: "Othello (USXKF)"
  },
  {
   value: "Otis Orchards (USOOW)",
   label: "Otis Orchards (USOOW)"
  },
  {
   value: "Ottawa (USOTW)",
   label: "Ottawa (USOTW)"
  },
  {
   value: "Ottawa (USOTR)",
   label: "Ottawa (USOTR)"
  },
  {
   value: "Ottawa (USOTQ)",
   label: "Ottawa (USOTQ)"
  },
  {
   value: "Ottumwa (USOTM)",
   label: "Ottumwa (USOTM)"
  },
  {
   value: "Otwell (USOVZ)",
   label: "Otwell (USOVZ)"
  },
  {
   value: "Ouray (USOUR)",
   label: "Ouray (USOUR)"
  },
  {
   value: "Overland Park (USOVL)",
   label: "Overland Park (USOVL)"
  },
  {
   value: "Overpeck (USOVR)",
   label: "Overpeck (USOVR)"
  },
  {
   value: "Old Monroe (USOZI)",
   label: "Old Monroe (USOZI)"
  },
  {
   value: "Old Saybrook (USOSY)",
   label: "Old Saybrook (USOSY)"
  },
  {
   value: "Old Town (USOLD)",
   label: "Old Town (USOLD)"
  },
  {
   value: "Oldsmar (USABA)",
   label: "Oldsmar (USABA)"
  },
  {
   value: "Olean (USOLE)",
   label: "Olean (USOLE)"
  },
  {
   value: "Olive (USOIE)",
   label: "Olive (USOIE)"
  },
  {
   value: "Olive Branch (USOLV)",
   label: "Olive Branch (USOLV)"
  },
  {
   value: "Olivia (USOIV)",
   label: "Olivia (USOIV)"
  },
  {
   value: "Olney (USOLY)",
   label: "Olney (USOLY)"
  },
  {
   value: "Olney (USOEY)",
   label: "Olney (USOEY)"
  },
  {
   value: "Olney (USONY)",
   label: "Olney (USONY)"
  },
  {
   value: "Olympia (USOLZ)",
   label: "Olympia (USOLZ)"
  },
  {
   value: "Olympia (USOLM)",
   label: "Olympia (USOLM)"
  },
  {
   value: "Olympia Fields (USOAN)",
   label: "Olympia Fields (USOAN)"
  },
  {
   value: "Omaha (USOMA)",
   label: "Omaha (USOMA)"
  },
  {
   value: "Omak (USOMK)",
   label: "Omak (USOMK)"
  },
  {
   value: "Onalaska (USOAA)",
   label: "Onalaska (USOAA)"
  },
  {
   value: "Oneco (USONE)",
   label: "Oneco (USONE)"
  },
  {
   value: "Oneida (USOND)",
   label: "Oneida (USOND)"
  },
  {
   value: "Oneida (USOYI)",
   label: "Oneida (USOYI)"
  },
  {
   value: "Oneida (USONI)",
   label: "Oneida (USONI)"
  },
  {
   value: "Onekama (USONK)",
   label: "Onekama (USONK)"
  },
  {
   value: "Oneonta (USONH)",
   label: "Oneonta (USONH)"
  },
  {
   value: "Ono (USONP)",
   label: "Ono (USONP)"
  },
  {
   value: "Onondaga (USOGQ)",
   label: "Onondaga (USOGQ)"
  },
  {
   value: "Onset (USONL)",
   label: "Onset (USONL)"
  },
  {
   value: "Ontario (USONT)",
   label: "Ontario (USONT)"
  },
  {
   value: "Ontario (USONO)",
   label: "Ontario (USONO)"
  },
  {
   value: "Opa Locka (USOPK)",
   label: "Opa Locka (USOPK)"
  },
  {
   value: "Opelika (USOPI)",
   label: "Opelika (USOPI)"
  },
  {
   value: "Opelousas (USOPL)",
   label: "Opelousas (USOPL)"
  },
  {
   value: "Opheim (USOPH)",
   label: "Opheim (USOPH)"
  },
  {
   value: "Opp (USOPA)",
   label: "Opp (USOPA)"
  },
  {
   value: "Oradel (USORD)",
   label: "Oradel (USORD)"
  },
  {
   value: "Orange (USJOR)",
   label: "Orange (USJOR)"
  },
  {
   value: "Orange (USORB)",
   label: "Orange (USORB)"
  },
  {
   value: "Orange (USORG)",
   label: "Orange (USORG)"
  },
  {
   value: "Orange (USOGE)",
   label: "Orange (USOGE)"
  },
  {
   value: "Orange Cove (USOCC)",
   label: "Orange Cove (USOCC)"
  },
  {
   value: "Orange Park (USORP)",
   label: "Orange Park (USORP)"
  },
  {
   value: "Orangeburg (USOBG)",
   label: "Orangeburg (USOBG)"
  },
  {
   value: "Orangeburg (USOGB)",
   label: "Orangeburg (USOGB)"
  },
  {
   value: "Oakland (USOAK)",
   label: "Oakland (USOAK)"
  },
  {
   value: "Oaklawn (USOKL)",
   label: "Oaklawn (USOKL)"
  },
  {
   value: "Oakley (USOQY)",
   label: "Oakley (USOQY)"
  },
  {
   value: "Oakmont (USUXS)",
   label: "Oakmont (USUXS)"
  },
  {
   value: "Oakridge (USOQR)",
   label: "Oakridge (USOQR)"
  },
  {
   value: "Oaks (USOKS)",
   label: "Oaks (USOKS)"
  },
  {
   value: "Oakwood (USOKW)",
   label: "Oakwood (USOKW)"
  },
  {
   value: "Oasis (USOXX)",
   label: "Oasis (USOXX)"
  },
  {
   value: "Obetz (USOBE)",
   label: "Obetz (USOBE)"
  },
  {
   value: "Obispo (USOBO)",
   label: "Obispo (USOBO)"
  },
  {
   value: "Ocala (USOCF)",
   label: "Ocala (USOCF)"
  },
  {
   value: "Ocean (USOCY)",
   label: "Ocean (USOCY)"
  },
  {
   value: "Oceanside (USXJX)",
   label: "Oceanside (USXJX)"
  },
  {
   value: "Oceanside (USOCN)",
   label: "Oceanside (USOCN)"
  },
  {
   value: "Oceanway (USOCE)",
   label: "Oceanway (USOCE)"
  },
  {
   value: "Ochlocknee (USOCG)",
   label: "Ochlocknee (USOCG)"
  },
  {
   value: "Ocilla (USOLA)",
   label: "Ocilla (USOLA)"
  },
  {
   value: "Oconomowoc (USOCO)",
   label: "Oconomowoc (USOCO)"
  },
  {
   value: "Oconto Falls (USXJV)",
   label: "Oconto Falls (USXJV)"
  },
  {
   value: "Odell (USODW)",
   label: "Odell (USODW)"
  },
  {
   value: "Odenton (USODN)",
   label: "Odenton (USODN)"
  },
  {
   value: "Odessa (USODF)",
   label: "Odessa (USODF)"
  },
  {
   value: "Odessa (USOSD)",
   label: "Odessa (USOSD)"
  },
  {
   value: "Oelwein (USOLW)",
   label: "Oelwein (USOLW)"
  },
  {
   value: "Ogden (USOGD)",
   label: "Ogden (USOGD)"
  },
  {
   value: "Ogdensburg (USOGS)",
   label: "Ogdensburg (USOGS)"
  },
  {
   value: "Oglethorpe (USOHQ)",
   label: "Oglethorpe (USOHQ)"
  },
  {
   value: "Oil City (USOIL)",
   label: "Oil City (USOIL)"
  },
  {
   value: "Oildale (USODC)",
   label: "Oildale (USODC)"
  },
  {
   value: "Okahumpka (USOHP)",
   label: "Okahumpka (USOHP)"
  },
  {
   value: "Okeelanta (USOLT)",
   label: "Okeelanta (USOLT)"
  },
  {
   value: "Okeene (USOKN)",
   label: "Okeene (USOKN)"
  },
  {
   value: "Oklahoma City (USOKC)",
   label: "Oklahoma City (USOKC)"
  },
  {
   value: "Oklawaha (USOKJ)",
   label: "Oklawaha (USOKJ)"
  },
  {
   value: "Okolona (USOKA)",
   label: "Okolona (USOKA)"
  },
  {
   value: "Olathe (USOLB)",
   label: "Olathe (USOLB)"
  },
  {
   value: "Old Bridge (USODR)",
   label: "Old Bridge (USODR)"
  },
  {
   value: "Old Forge (USXJZ)",
   label: "Old Forge (USXJZ)"
  },
  {
   value: "Old Fort (USOLF)",
   label: "Old Fort (USOLF)"
  },
  {
   value: "Old Fort (USOFO)",
   label: "Old Fort (USOFO)"
  },
  {
   value: "Old Hickory (USOHC)",
   label: "Old Hickory (USOHC)"
  },
  {
   value: "Old Hickory (USXKA)",
   label: "Old Hickory (USXKA)"
  },
  {
   value: "Norwalk (USXJR)",
   label: "Norwalk (USXJR)"
  },
  {
   value: "Norwalk (USNAQ)",
   label: "Norwalk (USNAQ)"
  },
  {
   value: "Norwich (USNOC)",
   label: "Norwich (USNOC)"
  },
  {
   value: "Norwich (USOIC)",
   label: "Norwich (USOIC)"
  },
  {
   value: "Norwood (USOWD)",
   label: "Norwood (USOWD)"
  },
  {
   value: "Norwood (USNXO)",
   label: "Norwood (USNXO)"
  },
  {
   value: "Norwood (USNRD)",
   label: "Norwood (USNRD)"
  },
  {
   value: "Norwood (USNDY)",
   label: "Norwood (USNDY)"
  },
  {
   value: "Nottingham (USNHG)",
   label: "Nottingham (USNHG)"
  },
  {
   value: "Nova (USXJP)",
   label: "Nova (USXJP)"
  },
  {
   value: "Novato (USNOT)",
   label: "Novato (USNOT)"
  },
  {
   value: "Novi (USNOV)",
   label: "Novi (USNOV)"
  },
  {
   value: "Nowata (USNTK)",
   label: "Nowata (USNTK)"
  },
  {
   value: "Noyes (USNOY)",
   label: "Noyes (USNOY)"
  },
  {
   value: "Nutley (USNUT)",
   label: "Nutley (USNUT)"
  },
  {
   value: "Nyack (USNYX)",
   label: "Nyack (USNYX)"
  },
  {
   value: "O'brien (USOIN)",
   label: "O'brien (USOIN)"
  },
  {
   value: "O'donnell (USODO)",
   label: "O'donnell (USODO)"
  },
  {
   value: "O'fallon (USOFL)",
   label: "O'fallon (USOFL)"
  },
  {
   value: "\"Oahu (USHDH)",
   label: "\"Oahu (USHDH)"
  },
  {
   value: "Oak (USOKP)",
   label: "Oak (USOKP)"
  },
  {
   value: "Oak Brook (USQHO)",
   label: "Oak Brook (USQHO)"
  },
  {
   value: "Oak Creek (USOAC)",
   label: "Oak Creek (USOAC)"
  },
  {
   value: "Oak Forest (USOFR)",
   label: "Oak Forest (USOFR)"
  },
  {
   value: "Oak Grove (USOGK)",
   label: "Oak Grove (USOGK)"
  },
  {
   value: "Oak Grove (USOGA)",
   label: "Oak Grove (USOGA)"
  },
  {
   value: "Oak Harbor (USOHO)",
   label: "Oak Harbor (USOHO)"
  },
  {
   value: "Oak Hill (USOQH)",
   label: "Oak Hill (USOQH)"
  },
  {
   value: "Oak Island (USOKI)",
   label: "Oak Island (USOKI)"
  },
  {
   value: "Oak Ridge (USORE)",
   label: "Oak Ridge (USORE)"
  },
  {
   value: "Oak Ridge (USOKR)",
   label: "Oak Ridge (USOKR)"
  },
  {
   value: "Oakbrook (USOAB)",
   label: "Oakbrook (USOAB)"
  },
  {
   value: "Oakcreek (USOCK)",
   label: "Oakcreek (USOCK)"
  },
  {
   value: "Oakdale (USOKQ)",
   label: "Oakdale (USOKQ)"
  },
  {
   value: "Oakdale (USODA)",
   label: "Oakdale (USODA)"
  },
  {
   value: "Oakdale (USOKM)",
   label: "Oakdale (USOKM)"
  },
  {
   value: "Oakdale (USUXR)",
   label: "Oakdale (USUXR)"
  },
  {
   value: "Oakfield (USOKF)",
   label: "Oakfield (USOKF)"
  },
  {
   value: "Oakhurst (USOKH)",
   label: "Oakhurst (USOKH)"
  },
  {
   value: "Oakland (USXKB)",
   label: "Oakland (USXKB)"
  },
  {
   value: "Oakland (USOKD)",
   label: "Oakland (USOKD)"
  },
  {
   value: "Oakland (USOLI)",
   label: "Oakland (USOLI)"
  },
  {
   value: "North Kingsville (USNKV)",
   label: "North Kingsville (USNKV)"
  },
  {
   value: "North Lawrence (USNLY)",
   label: "North Lawrence (USNLY)"
  },
  {
   value: "North Little Rock (USNLW)",
   label: "North Little Rock (USNLW)"
  },
  {
   value: "North Loup (USNLQ)",
   label: "North Loup (USNLQ)"
  },
  {
   value: "North Newton (USNNW)",
   label: "North Newton (USNNW)"
  },
  {
   value: "North Olmsted (USNOD)",
   label: "North Olmsted (USNOD)"
  },
  {
   value: "North Plains (USNPY)",
   label: "North Plains (USNPY)"
  },
  {
   value: "North Platte (USLBF)",
   label: "North Platte (USLBF)"
  },
  {
   value: "North Pole (USNTP)",
   label: "North Pole (USNTP)"
  },
  {
   value: "North Prarie (USNPE)",
   label: "North Prarie (USNPE)"
  },
  {
   value: "North Reading (USNRG)",
   label: "North Reading (USNRG)"
  },
  {
   value: "North Richland Hills (USNOI)",
   label: "North Richland Hills (USNOI)"
  },
  {
   value: "North Ridgeville (USNJR)",
   label: "North Ridgeville (USNJR)"
  },
  {
   value: "North Salt Lake (USNSL)",
   label: "North Salt Lake (USNSL)"
  },
  {
   value: "North Scituate (USNCT)",
   label: "North Scituate (USNCT)"
  },
  {
   value: "North Smithfield (USNSM)",
   label: "North Smithfield (USNSM)"
  },
  {
   value: "North Syracuse (USNSI)",
   label: "North Syracuse (USNSI)"
  },
  {
   value: "North Tonawanda (USXJQ)",
   label: "North Tonawanda (USXJQ)"
  },
  {
   value: "North Troy (USNTY)",
   label: "North Troy (USNTY)"
  },
  {
   value: "North Vernon (USNVY)",
   label: "North Vernon (USNVY)"
  },
  {
   value: "North Weymouth (USNWY)",
   label: "North Weymouth (USNWY)"
  },
  {
   value: "North Wilkesboro (USNWB)",
   label: "North Wilkesboro (USNWB)"
  },
  {
   value: "Northampton (USNHM)",
   label: "Northampton (USNHM)"
  },
  {
   value: "Northborough (USNBO)",
   label: "Northborough (USNBO)"
  },
  {
   value: "Northbridge (USNTG)",
   label: "Northbridge (USNTG)"
  },
  {
   value: "Northbrook (USOBK)",
   label: "Northbrook (USOBK)"
  },
  {
   value: "Northfield (USXJO)",
   label: "Northfield (USXJO)"
  },
  {
   value: "Northfield (USNRE)",
   label: "Northfield (USNRE)"
  },
  {
   value: "Northgate (USNGT)",
   label: "Northgate (USNGT)"
  },
  {
   value: "Northglenn (USNGL)",
   label: "Northglenn (USNGL)"
  },
  {
   value: "Northlake (USNTI)",
   label: "Northlake (USNTI)"
  },
  {
   value: "Northridge (USNRJ)",
   label: "Northridge (USNRJ)"
  },
  {
   value: "Northumberland (USNUM)",
   label: "Northumberland (USNUM)"
  },
  {
   value: "Northvale (USNVL)",
   label: "Northvale (USNVL)"
  },
  {
   value: "Northville (Riverhead) (USNVR)",
   label: "Northville (Riverhead) (USNVR)"
  },
  {
   value: "Norton (USNNM)",
   label: "Norton (USNNM)"
  },
  {
   value: "Norton (USNRT)",
   label: "Norton (USNRT)"
  },
  {
   value: "Norwalk (USORQ)",
   label: "Norwalk (USORQ)"
  },
  {
   value: "Norman (USOUN)",
   label: "Norman (USOUN)"
  },
  {
   value: "Norphlet (USNFA)",
   label: "Norphlet (USNFA)"
  },
  {
   value: "Norristown (USNIC)",
   label: "Norristown (USNIC)"
  },
  {
   value: "Norristown (USUXQ)",
   label: "Norristown (USUXQ)"
  },
  {
   value: "Norsworthy (USNSW)",
   label: "Norsworthy (USNSW)"
  },
  {
   value: "North (USNRR)",
   label: "North (USNRR)"
  },
  {
   value: "North Andover (USXJM)",
   label: "North Andover (USXJM)"
  },
  {
   value: "North Arlington (USNJT)",
   label: "North Arlington (USNJT)"
  },
  {
   value: "North Attleboro (USNTT)",
   label: "North Attleboro (USNTT)"
  },
  {
   value: "North Babylon (USNBY)",
   label: "North Babylon (USNBY)"
  },
  {
   value: "North Bend (USOTH)",
   label: "North Bend (USOTH)"
  },
  {
   value: "North Bergen (USNBN)",
   label: "North Bergen (USNBN)"
  },
  {
   value: "North Berwick (USNBM)",
   label: "North Berwick (USNBM)"
  },
  {
   value: "North Billerica (USNBA)",
   label: "North Billerica (USNBA)"
  },
  {
   value: "North Branch (USXJN)",
   label: "North Branch (USXJN)"
  },
  {
   value: "North Branford (USNBC)",
   label: "North Branford (USNBC)"
  },
  {
   value: "North Bridge (USNBR)",
   label: "North Bridge (USNBR)"
  },
  {
   value: "North Brunswick (USNBS)",
   label: "North Brunswick (USNBS)"
  },
  {
   value: "North Canaan (USNCC)",
   label: "North Canaan (USNCC)"
  },
  {
   value: "North Canton (USUXJ)",
   label: "North Canton (USUXJ)"
  },
  {
   value: "North Charleston (USNTS)",
   label: "North Charleston (USNTS)"
  },
  {
   value: "North Charlotte (USNCN)",
   label: "North Charlotte (USNCN)"
  },
  {
   value: "North Chicago (USNTA)",
   label: "North Chicago (USNTA)"
  },
  {
   value: "North City (USNXY)",
   label: "North City (USNXY)"
  },
  {
   value: "North Clarendon (USNCR)",
   label: "North Clarendon (USNCR)"
  },
  {
   value: "North Cove (USNCV)",
   label: "North Cove (USNCV)"
  },
  {
   value: "North Dighton (USNDG)",
   label: "North Dighton (USNDG)"
  },
  {
   value: "North East (USNEA)",
   label: "North East (USNEA)"
  },
  {
   value: "North East Apt\/Philadelphia (USPNE)",
   label: "North East Apt\/Philadelphia (USPNE)"
  },
  {
   value: "North Grafton (USNGR)",
   label: "North Grafton (USNGR)"
  },
  {
   value: "North Haven (USNOH)",
   label: "North Haven (USNOH)"
  },
  {
   value: "North Haven (USNHV)",
   label: "North Haven (USNHV)"
  },
  {
   value: "North Highlands (USNDC)",
   label: "North Highlands (USNDC)"
  },
  {
   value: "North Hollywood (USNHD)",
   label: "North Hollywood (USNHD)"
  },
  {
   value: "North Huntingdon (USNHU)",
   label: "North Huntingdon (USNHU)"
  },
  {
   value: "North Kansas City (USNKY)",
   label: "North Kansas City (USNKY)"
  },
  {
   value: "North Kingstown (USNKT)",
   label: "North Kingstown (USNKT)"
  },
  {
   value: "Newton (USNTC)",
   label: "Newton (USNTC)"
  },
  {
   value: "Newton (USNWN)",
   label: "Newton (USNWN)"
  },
  {
   value: "Newton Falls (USNFL)",
   label: "Newton Falls (USNFL)"
  },
  {
   value: "Newton Upper Falls (USNFM)",
   label: "Newton Upper Falls (USNFM)"
  },
  {
   value: "Newtown (USNWX)",
   label: "Newtown (USNWX)"
  },
  {
   value: "Newtown (USNTW)",
   label: "Newtown (USNTW)"
  },
  {
   value: "Newtown Square (USNTQ)",
   label: "Newtown Square (USNTQ)"
  },
  {
   value: "Niagara (USNGW)",
   label: "Niagara (USNGW)"
  },
  {
   value: "Niagara Falls (USIAG)",
   label: "Niagara Falls (USIAG)"
  },
  {
   value: "Nice (USNCQ)",
   label: "Nice (USNCQ)"
  },
  {
   value: "Niceville (USNIV)",
   label: "Niceville (USNIV)"
  },
  {
   value: "Nicholasville (USNCK)",
   label: "Nicholasville (USNCK)"
  },
  {
   value: "Nichols (USNCL)",
   label: "Nichols (USNCL)"
  },
  {
   value: "Nicollet (USNQL)",
   label: "Nicollet (USNQL)"
  },
  {
   value: "Nighthawk (USNIH)",
   label: "Nighthawk (USNIH)"
  },
  {
   value: "Nikishka (USNQK)",
   label: "Nikishka (USNQK)"
  },
  {
   value: "Nikiski (USNKI)",
   label: "Nikiski (USNKI)"
  },
  {
   value: "Niles (USNIZ)",
   label: "Niles (USNIZ)"
  },
  {
   value: "Niles (USNIL)",
   label: "Niles (USNIL)"
  },
  {
   value: "Niles (USNLE)",
   label: "Niles (USNLE)"
  },
  {
   value: "Niles (USNLS)",
   label: "Niles (USNLS)"
  },
  {
   value: "Ninilchik (USNIN)",
   label: "Ninilchik (USNIN)"
  },
  {
   value: "Nipomo (USNIO)",
   label: "Nipomo (USNIO)"
  },
  {
   value: "Nitro (USNIT)",
   label: "Nitro (USNIT)"
  },
  {
   value: "Nixa (USNXI)",
   label: "Nixa (USNXI)"
  },
  {
   value: "Noblesville (USNVB)",
   label: "Noblesville (USNVB)"
  },
  {
   value: "Nocona (USNTX)",
   label: "Nocona (USNTX)"
  },
  {
   value: "Noel (USNOE)",
   label: "Noel (USNOE)"
  },
  {
   value: "Nogales (USOLS)",
   label: "Nogales (USOLS)"
  },
  {
   value: "Nokomis (USNQM)",
   label: "Nokomis (USNQM)"
  },
  {
   value: "Nome (USOME)",
   label: "Nome (USOME)"
  },
  {
   value: "Noonan (USNOO)",
   label: "Noonan (USNOO)"
  },
  {
   value: "Norco (USNQO)",
   label: "Norco (USNQO)"
  },
  {
   value: "Norco (USNCM)",
   label: "Norco (USNCM)"
  },
  {
   value: "Norcross (USUXN)",
   label: "Norcross (USUXN)"
  },
  {
   value: "Norden (USNDQ)",
   label: "Norden (USNDQ)"
  },
  {
   value: "Norfolk (USNOR)",
   label: "Norfolk (USNOR)"
  },
  {
   value: "Norfolk (USOFK)",
   label: "Norfolk (USOFK)"
  },
  {
   value: "Norfolk (USORF)",
   label: "Norfolk (USORF)"
  },
  {
   value: "Norfolk-Newport News (USNEN)",
   label: "Norfolk-Newport News (USNEN)"
  },
  {
   value: "Norlina (USNRL)",
   label: "Norlina (USNRL)"
  },
  {
   value: "Normal (USNRI)",
   label: "Normal (USNRI)"
  },
  {
   value: "Newark Apt\/New York (USEWR)",
   label: "Newark Apt\/New York (USEWR)"
  },
  {
   value: "Newark Valley (USNUV)",
   label: "Newark Valley (USNUV)"
  },
  {
   value: "Newberg (USNUG)",
   label: "Newberg (USNUG)"
  },
  {
   value: "Newbern (USNBE)",
   label: "Newbern (USNBE)"
  },
  {
   value: "Newberry (USNBF)",
   label: "Newberry (USNBF)"
  },
  {
   value: "Newberry (USNBZ)",
   label: "Newberry (USNBZ)"
  },
  {
   value: "Newberry Springs (USNYS)",
   label: "Newberry Springs (USNYS)"
  },
  {
   value: "Newburg (USNWR)",
   label: "Newburg (USNWR)"
  },
  {
   value: "Newburgh (USSWF)",
   label: "Newburgh (USSWF)"
  },
  {
   value: "Newbury (USNEY)",
   label: "Newbury (USNEY)"
  },
  {
   value: "Newbury Park (USNVK)",
   label: "Newbury Park (USNVK)"
  },
  {
   value: "Newcastle (USNUC)",
   label: "Newcastle (USNUC)"
  },
  {
   value: "Newcomerstown (USNXQ)",
   label: "Newcomerstown (USNXQ)"
  },
  {
   value: "Newell (USNVG)",
   label: "Newell (USNVG)"
  },
  {
   value: "Newfield (USNWF)",
   label: "Newfield (USNWF)"
  },
  {
   value: "Newfoundland (USNFY)",
   label: "Newfoundland (USNFY)"
  },
  {
   value: "Newington (USNWG)",
   label: "Newington (USNWG)"
  },
  {
   value: "Newington (USNWZ)",
   label: "Newington (USNWZ)"
  },
  {
   value: "Newington (USNQG)",
   label: "Newington (USNQG)"
  },
  {
   value: "Newman (USNMW)",
   label: "Newman (USNMW)"
  },
  {
   value: "Newmarket (USNMK)",
   label: "Newmarket (USNMK)"
  },
  {
   value: "Newnan (USNAN)",
   label: "Newnan (USNAN)"
  },
  {
   value: "Newport (USNPF)",
   label: "Newport (USNPF)"
  },
  {
   value: "Newport (USNPR)",
   label: "Newport (USNPR)"
  },
  {
   value: "Newport (USNPT)",
   label: "Newport (USNPT)"
  },
  {
   value: "Newport (USNPO)",
   label: "Newport (USNPO)"
  },
  {
   value: "Newport (USEFK)",
   label: "Newport (USEFK)"
  },
  {
   value: "Newport (USNWH)",
   label: "Newport (USNWH)"
  },
  {
   value: "Newport (USNPD)",
   label: "Newport (USNPD)"
  },
  {
   value: "Newport (USNPN)",
   label: "Newport (USNPN)"
  },
  {
   value: "Newport (USNOP)",
   label: "Newport (USNOP)"
  },
  {
   value: "Newport (USNPM)",
   label: "Newport (USNPM)"
  },
  {
   value: "Newport (USXJU)",
   label: "Newport (USXJU)"
  },
  {
   value: "Newport Beach (USJNP)",
   label: "Newport Beach (USJNP)"
  },
  {
   value: "Newton (USNTN)",
   label: "Newton (USNTN)"
  },
  {
   value: "Newton (USNOU)",
   label: "Newton (USNOU)"
  },
  {
   value: "Newton (USOXP)",
   label: "Newton (USOXP)"
  },
  {
   value: "Newton (USEWK)",
   label: "Newton (USEWK)"
  },
  {
   value: "Newton (USNMQ)",
   label: "Newton (USNMQ)"
  },
  {
   value: "Newton (USTNU)",
   label: "Newton (USTNU)"
  },
  {
   value: "Newton (USNUW)",
   label: "Newton (USNUW)"
  },
  {
   value: "New Hartford (USNHT)",
   label: "New Hartford (USNHT)"
  },
  {
   value: "New Haven (USHVN)",
   label: "New Haven (USHVN)"
  },
  {
   value: "New Holland (USUXL)",
   label: "New Holland (USUXL)"
  },
  {
   value: "New Holstein (USNWE)",
   label: "New Holstein (USNWE)"
  },
  {
   value: "New Hope (USNHO)",
   label: "New Hope (USNHO)"
  },
  {
   value: "New Hope (USNHI)",
   label: "New Hope (USNHI)"
  },
  {
   value: "New Hyde Park (USNHY)",
   label: "New Hyde Park (USNHY)"
  },
  {
   value: "New Iberia (USARA)",
   label: "New Iberia (USARA)"
  },
  {
   value: "New Johnsonville (USNWJ)",
   label: "New Johnsonville (USNWJ)"
  },
  {
   value: "New Kensington (USNKP)",
   label: "New Kensington (USNKP)"
  },
  {
   value: "New Kings Town (USUXM)",
   label: "New Kings Town (USUXM)"
  },
  {
   value: "New Kingston (USNEF)",
   label: "New Kingston (USNEF)"
  },
  {
   value: "New Kingstown (USXJT)",
   label: "New Kingstown (USXJT)"
  },
  {
   value: "New Knoxville (USNKX)",
   label: "New Knoxville (USNKX)"
  },
  {
   value: "New London (USNLD)",
   label: "New London (USNLD)"
  },
  {
   value: "New Milford (USNEM)",
   label: "New Milford (USNEM)"
  },
  {
   value: "New Milford (USNMF)",
   label: "New Milford (USNMF)"
  },
  {
   value: "New Orleans (USMSY)",
   label: "New Orleans (USMSY)"
  },
  {
   value: "New Oxford (USNXF)",
   label: "New Oxford (USNXF)"
  },
  {
   value: "New Philadelphia (USPHD)",
   label: "New Philadelphia (USPHD)"
  },
  {
   value: "New Philadelphia (USNPP)",
   label: "New Philadelphia (USNPP)"
  },
  {
   value: "New Prague (USNWP)",
   label: "New Prague (USNWP)"
  },
  {
   value: "New Richmond (USRNH)",
   label: "New Richmond (USRNH)"
  },
  {
   value: "New Rochelle (USUXO)",
   label: "New Rochelle (USUXO)"
  },
  {
   value: "New Stanton (USNST)",
   label: "New Stanton (USNST)"
  },
  {
   value: "New Tazewell (USNWW)",
   label: "New Tazewell (USNWW)"
  },
  {
   value: "New Troy (USXJS)",
   label: "New Troy (USXJS)"
  },
  {
   value: "New Ulm (USULM)",
   label: "New Ulm (USULM)"
  },
  {
   value: "New Vienna (USNVH)",
   label: "New Vienna (USNVH)"
  },
  {
   value: "New Waverly (USNWV)",
   label: "New Waverly (USNWV)"
  },
  {
   value: "New Windsor (USNWM)",
   label: "New Windsor (USNWM)"
  },
  {
   value: "New Windsor (USNWI)",
   label: "New Windsor (USNWI)"
  },
  {
   value: "New York (USNYC)",
   label: "New York (USNYC)"
  },
  {
   value: "New York Mills (USNYQ)",
   label: "New York Mills (USNYQ)"
  },
  {
   value: "Newald (USNDW)",
   label: "Newald (USNDW)"
  },
  {
   value: "Newark (USNEK)",
   label: "Newark (USNEK)"
  },
  {
   value: "Newark (USNNY)",
   label: "Newark (USNNY)"
  },
  {
   value: "Newark (USNKQ)",
   label: "Newark (USNKQ)"
  },
  {
   value: "Newark (USNWK)",
   label: "Newark (USNWK)"
  },
  {
   value: "Neenah (USUXK)",
   label: "Neenah (USUXK)"
  },
  {
   value: "Nelson (USNLG)",
   label: "Nelson (USNLG)"
  },
  {
   value: "Nelsonville (USNNV)",
   label: "Nelsonville (USNNV)"
  },
  {
   value: "Nenana (USENN)",
   label: "Nenana (USENN)"
  },
  {
   value: "Neosho (USEOS)",
   label: "Neosho (USEOS)"
  },
  {
   value: "Neptune City (USNPC)",
   label: "Neptune City (USNPC)"
  },
  {
   value: "Nesconset (USNES)",
   label: "Nesconset (USNES)"
  },
  {
   value: "Neshanic Station (USNSN)",
   label: "Neshanic Station (USNSN)"
  },
  {
   value: "Nesquehoning (USNSQ)",
   label: "Nesquehoning (USNSQ)"
  },
  {
   value: "Netcong (USNEQ)",
   label: "Netcong (USNEQ)"
  },
  {
   value: "Nettleton (USNNL)",
   label: "Nettleton (USNNL)"
  },
  {
   value: "Nevada (USNVD)",
   label: "Nevada (USNVD)"
  },
  {
   value: "Nevada City (USNFC)",
   label: "Nevada City (USNFC)"
  },
  {
   value: "Neville Island (USNVI)",
   label: "Neville Island (USNVI)"
  },
  {
   value: "New Albany (USNWA)",
   label: "New Albany (USNWA)"
  },
  {
   value: "New Albany (USNAM)",
   label: "New Albany (USNAM)"
  },
  {
   value: "New Baden (USNDI)",
   label: "New Baden (USNDI)"
  },
  {
   value: "New Baltimore (USNBT)",
   label: "New Baltimore (USNBT)"
  },
  {
   value: "New Bedford (USEWB)",
   label: "New Bedford (USEWB)"
  },
  {
   value: "New Berlin (USNUY)",
   label: "New Berlin (USNUY)"
  },
  {
   value: "New Berlin (USNBB)",
   label: "New Berlin (USNBB)"
  },
  {
   value: "New Bern (USEWN)",
   label: "New Bern (USEWN)"
  },
  {
   value: "New Boston (USNBX)",
   label: "New Boston (USNBX)"
  },
  {
   value: "New Braunfels (USNHB)",
   label: "New Braunfels (USNHB)"
  },
  {
   value: "New Bremen (USUXI)",
   label: "New Bremen (USUXI)"
  },
  {
   value: "New Brighton (USNBI)",
   label: "New Brighton (USNBI)"
  },
  {
   value: "New Brighton (USNET)",
   label: "New Brighton (USNET)"
  },
  {
   value: "New Britain (USNWT)",
   label: "New Britain (USNWT)"
  },
  {
   value: "New Brunswick (USNBJ)",
   label: "New Brunswick (USNBJ)"
  },
  {
   value: "New Caanan (USNWC)",
   label: "New Caanan (USNWC)"
  },
  {
   value: "New Castle (USNCD)",
   label: "New Castle (USNCD)"
  },
  {
   value: "New Castle (USNQS)",
   label: "New Castle (USNQS)"
  },
  {
   value: "New Castle (USNCP)",
   label: "New Castle (USNCP)"
  },
  {
   value: "New Centerville (USNVP)",
   label: "New Centerville (USNVP)"
  },
  {
   value: "New Cumberland (USNWD)",
   label: "New Cumberland (USNWD)"
  },
  {
   value: "New Deal (USNXD)",
   label: "New Deal (USNXD)"
  },
  {
   value: "New Eagle (USNXG)",
   label: "New Eagle (USNXG)"
  },
  {
   value: "New Egypt (USNGP)",
   label: "New Egypt (USNGP)"
  },
  {
   value: "New Hampton (USNIM)",
   label: "New Hampton (USNIM)"
  },
  {
   value: "Muskegon-Manistee (USMST)",
   label: "Muskegon-Manistee (USMST)"
  },
  {
   value: "Muskogee (USMKO)",
   label: "Muskogee (USMKO)"
  },
  {
   value: "Myrtle (USXJL)",
   label: "Myrtle (USXJL)"
  },
  {
   value: "Myrtle Beach (USMYR)",
   label: "Myrtle Beach (USMYR)"
  },
  {
   value: "Myrtle Grove (USMYG)",
   label: "Myrtle Grove (USMYG)"
  },
  {
   value: "Myrtle Point (USMFG)",
   label: "Myrtle Point (USMFG)"
  },
  {
   value: "Mystic (USMYC)",
   label: "Mystic (USMYC)"
  },
  {
   value: "Naco (USNAC)",
   label: "Naco (USNAC)"
  },
  {
   value: "Nacogdoches (USOCH)",
   label: "Nacogdoches (USOCH)"
  },
  {
   value: "Naheola (USNHA)",
   label: "Naheola (USNHA)"
  },
  {
   value: "Naknek (USNNK)",
   label: "Naknek (USNNK)"
  },
  {
   value: "Nampa (USNPA)",
   label: "Nampa (USNPA)"
  },
  {
   value: "Napa (USAPC)",
   label: "Napa (USAPC)"
  },
  {
   value: "Naperville (USNPV)",
   label: "Naperville (USNPV)"
  },
  {
   value: "Naples (USNPK)",
   label: "Naples (USNPK)"
  },
  {
   value: "Naples (USAPF)",
   label: "Naples (USAPF)"
  },
  {
   value: "Napoleon (USNAL)",
   label: "Napoleon (USNAL)"
  },
  {
   value: "Napoleonville (USNVW)",
   label: "Napoleonville (USNVW)"
  },
  {
   value: "Narragansett (USNGU)",
   label: "Narragansett (USNGU)"
  },
  {
   value: "Nashua (USASH)",
   label: "Nashua (USASH)"
  },
  {
   value: "Nashville (USNSH)",
   label: "Nashville (USNSH)"
  },
  {
   value: "Nashville (USNXV)",
   label: "Nashville (USNXV)"
  },
  {
   value: "Nashville (USBNA)",
   label: "Nashville (USBNA)"
  },
  {
   value: "Natchez (USHEZ)",
   label: "Natchez (USHEZ)"
  },
  {
   value: "National Apt\/Washington (USDCA)",
   label: "National Apt\/Washington (USDCA)"
  },
  {
   value: "National City (USNLN)",
   label: "National City (USNLN)"
  },
  {
   value: "National City (USNCI)",
   label: "National City (USNCI)"
  },
  {
   value: "National Gardens (USNTL)",
   label: "National Gardens (USNTL)"
  },
  {
   value: "Natrium (USNRM)",
   label: "Natrium (USNRM)"
  },
  {
   value: "Natural Bridge (USNAT)",
   label: "Natural Bridge (USNAT)"
  },
  {
   value: "Naugatuck (USNGK)",
   label: "Naugatuck (USNGK)"
  },
  {
   value: "Nawiliwili (USNWL)",
   label: "Nawiliwili (USNWL)"
  },
  {
   value: "Nazareth (USNAZ)",
   label: "Nazareth (USNAZ)"
  },
  {
   value: "Neah Bay (USNEB)",
   label: "Neah Bay (USNEB)"
  },
  {
   value: "Neche (USNEC)",
   label: "Neche (USNEC)"
  },
  {
   value: "Nederland (USNDD)",
   label: "Nederland (USNDD)"
  },
  {
   value: "Nederland (USNDX)",
   label: "Nederland (USNDX)"
  },
  {
   value: "Needham (USNEE)",
   label: "Needham (USNEE)"
  },
  {
   value: "Needville (USNDV)",
   label: "Needville (USNDV)"
  },
  {
   value: "Neelys (USNMO)",
   label: "Neelys (USNMO)"
  },
  {
   value: "Mount Vernon (USMXF)",
   label: "Mount Vernon (USMXF)"
  },
  {
   value: "Mount Vernon (USMVN)",
   label: "Mount Vernon (USMVN)"
  },
  {
   value: "Mount Wolf (USMWF)",
   label: "Mount Wolf (USMWF)"
  },
  {
   value: "Mountain City (USMFM)",
   label: "Mountain City (USMFM)"
  },
  {
   value: "Mountain Home (USWMH)",
   label: "Mountain Home (USWMH)"
  },
  {
   value: "Mountain Home (USMUO)",
   label: "Mountain Home (USMUO)"
  },
  {
   value: "Mountain Home (USMHU)",
   label: "Mountain Home (USMHU)"
  },
  {
   value: "Mountain Home (USMUM)",
   label: "Mountain Home (USMUM)"
  },
  {
   value: "Mountain Pass (USMTS)",
   label: "Mountain Pass (USMTS)"
  },
  {
   value: "Mountain Top (USMUV)",
   label: "Mountain Top (USMUV)"
  },
  {
   value: "Mountain View (USNUQ)",
   label: "Mountain View (USNUQ)"
  },
  {
   value: "Mountain View (USMUK)",
   label: "Mountain View (USMUK)"
  },
  {
   value: "Mountain View (USMUL)",
   label: "Mountain View (USMUL)"
  },
  {
   value: "Mountainside (USMSJ)",
   label: "Mountainside (USMSJ)"
  },
  {
   value: "Mountlake Terrace (USXJI)",
   label: "Mountlake Terrace (USXJI)"
  },
  {
   value: "Mountplier (USMPI)",
   label: "Mountplier (USMPI)"
  },
  {
   value: "Mountsville (USUXC)",
   label: "Mountsville (USUXC)"
  },
  {
   value: "Mountville (USXJH)",
   label: "Mountville (USXJH)"
  },
  {
   value: "Mulberry (USMUF)",
   label: "Mulberry (USMUF)"
  },
  {
   value: "Muleshoe (USMUE)",
   label: "Muleshoe (USMUE)"
  },
  {
   value: "Mullica Hill (USMHJ)",
   label: "Mullica Hill (USMHJ)"
  },
  {
   value: "Mullins (USMXU)",
   label: "Mullins (USMXU)"
  },
  {
   value: "Muncie (USMUB)",
   label: "Muncie (USMUB)"
  },
  {
   value: "Muncie (USMIE)",
   label: "Muncie (USMIE)"
  },
  {
   value: "Muncy (USMUN)",
   label: "Muncy (USMUN)"
  },
  {
   value: "Mundelein (USMUJ)",
   label: "Mundelein (USMUJ)"
  },
  {
   value: "Munising (USMUI)",
   label: "Munising (USMUI)"
  },
  {
   value: "Munster (USMUQ)",
   label: "Munster (USMUQ)"
  },
  {
   value: "Murchison (USMUS)",
   label: "Murchison (USMUS)"
  },
  {
   value: "Murfreesboro (USMUC)",
   label: "Murfreesboro (USMUC)"
  },
  {
   value: "Murfreesboro (USMRF)",
   label: "Murfreesboro (USMRF)"
  },
  {
   value: "Murray (USCEY)",
   label: "Murray (USCEY)"
  },
  {
   value: "Murray (USMUY)",
   label: "Murray (USMUY)"
  },
  {
   value: "Murray Hill (USMYU)",
   label: "Murray Hill (USMYU)"
  },
  {
   value: "Murtaugh (USMMG)",
   label: "Murtaugh (USMMG)"
  },
  {
   value: "Muscatine (USMUT)",
   label: "Muscatine (USMUT)"
  },
  {
   value: "Muscle Shoals-Florence Apt (USMSL)",
   label: "Muscle Shoals-Florence Apt (USMSL)"
  },
  {
   value: "Muscoda (USMUZ)",
   label: "Muscoda (USMUZ)"
  },
  {
   value: "Muskegon (USMKG)",
   label: "Muskegon (USMKG)"
  },
  {
   value: "Mount Airy (USMJQ)",
   label: "Mount Airy (USMJQ)"
  },
  {
   value: "Mount Berry (USMJR)",
   label: "Mount Berry (USMJR)"
  },
  {
   value: "Mount Bethel (USMXT)",
   label: "Mount Bethel (USMXT)"
  },
  {
   value: "Mount Clemens (USMTC)",
   label: "Mount Clemens (USMTC)"
  },
  {
   value: "Mount Dora (USMUD)",
   label: "Mount Dora (USMUD)"
  },
  {
   value: "Mount Gilead (USMGQ)",
   label: "Mount Gilead (USMGQ)"
  },
  {
   value: "Mount Holly (USMHX)",
   label: "Mount Holly (USMHX)"
  },
  {
   value: "Mount Holly (USLLY)",
   label: "Mount Holly (USLLY)"
  },
  {
   value: "Mount Holly (USUQS)",
   label: "Mount Holly (USUQS)"
  },
  {
   value: "Mount Jackson (USUQV)",
   label: "Mount Jackson (USUQV)"
  },
  {
   value: "Mount Joy (USMJY)",
   label: "Mount Joy (USMJY)"
  },
  {
   value: "Mount Kisco (USMKS)",
   label: "Mount Kisco (USMKS)"
  },
  {
   value: "Mount Laural (USMUR)",
   label: "Mount Laural (USMUR)"
  },
  {
   value: "Mount Laurel (USLUJ)",
   label: "Mount Laurel (USLUJ)"
  },
  {
   value: "Mount Laurent (USMRU)",
   label: "Mount Laurent (USMRU)"
  },
  {
   value: "Mount Morris (USMXR)",
   label: "Mount Morris (USMXR)"
  },
  {
   value: "Mount Olive (USMNO)",
   label: "Mount Olive (USMNO)"
  },
  {
   value: "Mount Olive (USMOU)",
   label: "Mount Olive (USMOU)"
  },
  {
   value: "Mount Orab (USMXQ)",
   label: "Mount Orab (USMXQ)"
  },
  {
   value: "Mount Pleasant (USMPH)",
   label: "Mount Pleasant (USMPH)"
  },
  {
   value: "Mount Pleasant (USMPS)",
   label: "Mount Pleasant (USMPS)"
  },
  {
   value: "Mount Pleasant (USMPL)",
   label: "Mount Pleasant (USMPL)"
  },
  {
   value: "Mount Pleasant (USMOP)",
   label: "Mount Pleasant (USMOP)"
  },
  {
   value: "Mount Pleasant (USMPY)",
   label: "Mount Pleasant (USMPY)"
  },
  {
   value: "Mount Pleasant (USMPN)",
   label: "Mount Pleasant (USMPN)"
  },
  {
   value: "Mount Pleasant (USMTT)",
   label: "Mount Pleasant (USMTT)"
  },
  {
   value: "Mount Pocono (USMXP)",
   label: "Mount Pocono (USMXP)"
  },
  {
   value: "Mount Prospect (USMUP)",
   label: "Mount Prospect (USMUP)"
  },
  {
   value: "Mount Prospect (USMPC)",
   label: "Mount Prospect (USMPC)"
  },
  {
   value: "Mount Pulaski (USMPK)",
   label: "Mount Pulaski (USMPK)"
  },
  {
   value: "Mount Sterling (USMGK)",
   label: "Mount Sterling (USMGK)"
  },
  {
   value: "Mount Union (USMUU)",
   label: "Mount Union (USMUU)"
  },
  {
   value: "Mount Vernon (USMXC)",
   label: "Mount Vernon (USMXC)"
  },
  {
   value: "Mount Vernon (USMVW)",
   label: "Mount Vernon (USMVW)"
  },
  {
   value: "Mount Vernon (USMVX)",
   label: "Mount Vernon (USMVX)"
  },
  {
   value: "Mount Vernon (USMVH)",
   label: "Mount Vernon (USMVH)"
  },
  {
   value: "Mount Vernon (USMXH)",
   label: "Mount Vernon (USMXH)"
  },
  {
   value: "Mount Vernon (USMVS)",
   label: "Mount Vernon (USMVS)"
  },
  {
   value: "Morgan Hill (USMJV)",
   label: "Morgan Hill (USMJV)"
  },
  {
   value: "Morgans Point (USMPP)",
   label: "Morgans Point (USMPP)"
  },
  {
   value: "Morganton (USMRN)",
   label: "Morganton (USMRN)"
  },
  {
   value: "Morgantown (USMGW)",
   label: "Morgantown (USMGW)"
  },
  {
   value: "Morgantown (USMWG)",
   label: "Morgantown (USMWG)"
  },
  {
   value: "Morgantown (USMGG)",
   label: "Morgantown (USMGG)"
  },
  {
   value: "Morgantown (USMJZ)",
   label: "Morgantown (USMJZ)"
  },
  {
   value: "Morgantown (USMGP)",
   label: "Morgantown (USMGP)"
  },
  {
   value: "Morral (USMJC)",
   label: "Morral (USMJC)"
  },
  {
   value: "Morrill (USMOK)",
   label: "Morrill (USMOK)"
  },
  {
   value: "Morrilton (USMPJ)",
   label: "Morrilton (USMPJ)"
  },
  {
   value: "Morris (USMSW)",
   label: "Morris (USMSW)"
  },
  {
   value: "Morris Plains (USMPA)",
   label: "Morris Plains (USMPA)"
  },
  {
   value: "Morrison (USMJE)",
   label: "Morrison (USMJE)"
  },
  {
   value: "Morrison (USMMQ)",
   label: "Morrison (USMMQ)"
  },
  {
   value: "Morrison (USMJF)",
   label: "Morrison (USMJF)"
  },
  {
   value: "Morriston (USMRT)",
   label: "Morriston (USMRT)"
  },
  {
   value: "Morristown (USMMU)",
   label: "Morristown (USMMU)"
  },
  {
   value: "Morristown (USMOR)",
   label: "Morristown (USMOR)"
  },
  {
   value: "Morristown (USMJG)",
   label: "Morristown (USMJG)"
  },
  {
   value: "Morrisville (USXIO)",
   label: "Morrisville (USXIO)"
  },
  {
   value: "Morrisville (USMZL)",
   label: "Morrisville (USMZL)"
  },
  {
   value: "Morro Bay (USMJK)",
   label: "Morro Bay (USMJK)"
  },
  {
   value: "Morrow (USMRW)",
   label: "Morrow (USMRW)"
  },
  {
   value: "Morton (USMTI)",
   label: "Morton (USMTI)"
  },
  {
   value: "Morton (USMNQ)",
   label: "Morton (USMNQ)"
  },
  {
   value: "Morton Grove (USMGV)",
   label: "Morton Grove (USMGV)"
  },
  {
   value: "Moscow (USMJL)",
   label: "Moscow (USMJL)"
  },
  {
   value: "Moses Lake (USMWH)",
   label: "Moses Lake (USMWH)"
  },
  {
   value: "Moss (USMJN)",
   label: "Moss (USMJN)"
  },
  {
   value: "Moss Landing (USMLG)",
   label: "Moss Landing (USMLG)"
  },
  {
   value: "Moss Point (USMOG)",
   label: "Moss Point (USMOG)"
  },
  {
   value: "Mossville (USMVJ)",
   label: "Mossville (USMVJ)"
  },
  {
   value: "Motley (USMOF)",
   label: "Motley (USMOF)"
  },
  {
   value: "Moulton (USMUW)",
   label: "Moulton (USMUW)"
  },
  {
   value: "Moultrie (USMGR)",
   label: "Moultrie (USMGR)"
  },
  {
   value: "Mounds View (USMJO)",
   label: "Mounds View (USMJO)"
  },
  {
   value: "Moundsville (USMFZ)",
   label: "Moundsville (USMFZ)"
  },
  {
   value: "Moundville (USMOA)",
   label: "Moundville (USMOA)"
  },
  {
   value: "Mount Airy (USMYM)",
   label: "Mount Airy (USMYM)"
  },
  {
   value: "Montgomery (USMGJ)",
   label: "Montgomery (USMGJ)"
  },
  {
   value: "Montgomery (USMGM)",
   label: "Montgomery (USMGM)"
  },
  {
   value: "Montgomeryville (USUXG)",
   label: "Montgomeryville (USUXG)"
  },
  {
   value: "Monticello (USMOC)",
   label: "Monticello (USMOC)"
  },
  {
   value: "Monticello (USMOQ)",
   label: "Monticello (USMOQ)"
  },
  {
   value: "Monticello (USMQC)",
   label: "Monticello (USMQC)"
  },
  {
   value: "Monticello (USMXO)",
   label: "Monticello (USMXO)"
  },
  {
   value: "Monticello (USMQD)",
   label: "Monticello (USMQD)"
  },
  {
   value: "Monticello (USMOS)",
   label: "Monticello (USMOS)"
  },
  {
   value: "Monticello (USMCZ)",
   label: "Monticello (USMCZ)"
  },
  {
   value: "Montoursville (USMBC)",
   label: "Montoursville (USMBC)"
  },
  {
   value: "Montpelier \/ BARRE (USMPV)",
   label: "Montpelier \/ BARRE (USMPV)"
  },
  {
   value: "Montpelier (USXIX)",
   label: "Montpelier (USXIX)"
  },
  {
   value: "Montpelier (USMNT)",
   label: "Montpelier (USMNT)"
  },
  {
   value: "Montrose (USMTJ)",
   label: "Montrose (USMTJ)"
  },
  {
   value: "Montrose (USMBH)",
   label: "Montrose (USMBH)"
  },
  {
   value: "Montvale (USQMV)",
   label: "Montvale (USQMV)"
  },
  {
   value: "Montville (USMBM)",
   label: "Montville (USMBM)"
  },
  {
   value: "Montville (USMDB)",
   label: "Montville (USMDB)"
  },
  {
   value: "Monument (USMEB)",
   label: "Monument (USMEB)"
  },
  {
   value: "Moonachie (USMPG)",
   label: "Moonachie (USMPG)"
  },
  {
   value: "Moore (USMBW)",
   label: "Moore (USMBW)"
  },
  {
   value: "Moores Mill (USMQE)",
   label: "Moores Mill (USMQE)"
  },
  {
   value: "Moorestown (USMRJ)",
   label: "Moorestown (USMRJ)"
  },
  {
   value: "Mooresville (USMYZ)",
   label: "Mooresville (USMYZ)"
  },
  {
   value: "Mooresville (USXJK)",
   label: "Mooresville (USXJK)"
  },
  {
   value: "Moorhead (USXIH)",
   label: "Moorhead (USXIH)"
  },
  {
   value: "Moorlands (USMPF)",
   label: "Moorlands (USMPF)"
  },
  {
   value: "Moorpark (USMQK)",
   label: "Moorpark (USMQK)"
  },
  {
   value: "Moose Pass (USMPE)",
   label: "Moose Pass (USMPE)"
  },
  {
   value: "Moosic (USUXB)",
   label: "Moosic (USUXB)"
  },
  {
   value: "Mora (USMJM)",
   label: "Mora (USMJM)"
  },
  {
   value: "Moraine (USMRE)",
   label: "Moraine (USMRE)"
  },
  {
   value: "Morattico (USMJS)",
   label: "Morattico (USMJS)"
  },
  {
   value: "Morehead (USMRK)",
   label: "Morehead (USMRK)"
  },
  {
   value: "Morehead City (USMRH)",
   label: "Morehead City (USMRH)"
  },
  {
   value: "Moreo (USMRO)",
   label: "Moreo (USMRO)"
  },
  {
   value: "Morgan (USMRG)",
   label: "Morgan (USMRG)"
  },
  {
   value: "Morgan City (USMGN)",
   label: "Morgan City (USMGN)"
  },
  {
   value: "Morgan City (USPTN)",
   label: "Morgan City (USPTN)"
  },
  {
   value: "Mogadore (USMGD)",
   label: "Mogadore (USMGD)"
  },
  {
   value: "Mojava (USMOJ)",
   label: "Mojava (USMOJ)"
  },
  {
   value: "Molalla (USMOL)",
   label: "Molalla (USMOL)"
  },
  {
   value: "Moline (USMLI)",
   label: "Moline (USMLI)"
  },
  {
   value: "Momence (USMME)",
   label: "Momence (USMME)"
  },
  {
   value: "Mona Island (USOIS)",
   label: "Mona Island (USOIS)"
  },
  {
   value: "Monaca (USMNP)",
   label: "Monaca (USMNP)"
  },
  {
   value: "Moncks Corner (USMNK)",
   label: "Moncks Corner (USMNK)"
  },
  {
   value: "Moncure (USMCP)",
   label: "Moncure (USMCP)"
  },
  {
   value: "Monett (USMMO)",
   label: "Monett (USMMO)"
  },
  {
   value: "Monmouth (USMMS)",
   label: "Monmouth (USMMS)"
  },
  {
   value: "Monmouth (USMNI)",
   label: "Monmouth (USMNI)"
  },
  {
   value: "Monmouth Junction (USMJU)",
   label: "Monmouth Junction (USMJU)"
  },
  {
   value: "Monomnie (USXIV)",
   label: "Monomnie (USXIV)"
  },
  {
   value: "Monona (USMXJ)",
   label: "Monona (USMXJ)"
  },
  {
   value: "Monongahela (USMXX)",
   label: "Monongahela (USMXX)"
  },
  {
   value: "Monroe (USMOE)",
   label: "Monroe (USMOE)"
  },
  {
   value: "Monroe (USMOI)",
   label: "Monroe (USMOI)"
  },
  {
   value: "Monroe (USMNR)",
   label: "Monroe (USMNR)"
  },
  {
   value: "Monroe (USNRO)",
   label: "Monroe (USNRO)"
  },
  {
   value: "Monroe (USMOW)",
   label: "Monroe (USMOW)"
  },
  {
   value: "Monroe (USMWI)",
   label: "Monroe (USMWI)"
  },
  {
   value: "Monroe (USMLU)",
   label: "Monroe (USMLU)"
  },
  {
   value: "Monroe Park (USMPQ)",
   label: "Monroe Park (USMPQ)"
  },
  {
   value: "Monroeville (USMVC)",
   label: "Monroeville (USMVC)"
  },
  {
   value: "Monrovia (USXIY)",
   label: "Monrovia (USXIY)"
  },
  {
   value: "Monsey (USMYH)",
   label: "Monsey (USMYH)"
  },
  {
   value: "Monson (USMZS)",
   label: "Monson (USMZS)"
  },
  {
   value: "Montclair (USMZT)",
   label: "Montclair (USMZT)"
  },
  {
   value: "Montclair (USMLR)",
   label: "Montclair (USMLR)"
  },
  {
   value: "Monte Alto (USMXZ)",
   label: "Monte Alto (USMXZ)"
  },
  {
   value: "Montebello (USMTB)",
   label: "Montebello (USMTB)"
  },
  {
   value: "Monterey (USMXY)",
   label: "Monterey (USMXY)"
  },
  {
   value: "Monterey Park (USMZU)",
   label: "Monterey Park (USMZU)"
  },
  {
   value: "Monterey\/Carmel Apt (USMRY)",
   label: "Monterey\/Carmel Apt (USMRY)"
  },
  {
   value: "Montesano (USMZW)",
   label: "Montesano (USMZW)"
  },
  {
   value: "Montevallo (USMVO)",
   label: "Montevallo (USMVO)"
  },
  {
   value: "Montezuma (USMOZ)",
   label: "Montezuma (USMOZ)"
  },
  {
   value: "Montezuma (USMZM)",
   label: "Montezuma (USMZM)"
  },
  {
   value: "Montgomery (USXIL)",
   label: "Montgomery (USXIL)"
  },
  {
   value: "Montgomery (USMGH)",
   label: "Montgomery (USMGH)"
  },
  {
   value: "Milton-Freewater (USMZH)",
   label: "Milton-Freewater (USMZH)"
  },
  {
   value: "Milville (USMVF)",
   label: "Milville (USMVF)"
  },
  {
   value: "Milwaukee (USMKE)",
   label: "Milwaukee (USMKE)"
  },
  {
   value: "Milwaukie (USMLK)",
   label: "Milwaukie (USMLK)"
  },
  {
   value: "Minatare (USMXK)",
   label: "Minatare (USMXK)"
  },
  {
   value: "Minden (USMYX)",
   label: "Minden (USMYX)"
  },
  {
   value: "Minden City (USMCY)",
   label: "Minden City (USMCY)"
  },
  {
   value: "Mineola (USMNA)",
   label: "Mineola (USMNA)"
  },
  {
   value: "Mineola (USMIX)",
   label: "Mineola (USMIX)"
  },
  {
   value: "Mineral Wells (USMWE)",
   label: "Mineral Wells (USMWE)"
  },
  {
   value: "Mineral Wells (USMWL)",
   label: "Mineral Wells (USMWL)"
  },
  {
   value: "Minersville (USMVP)",
   label: "Minersville (USMVP)"
  },
  {
   value: "Minerva (USMNV)",
   label: "Minerva (USMNV)"
  },
  {
   value: "Mingo (USMIG)",
   label: "Mingo (USMIG)"
  },
  {
   value: "Mingo Junction (USXIM)",
   label: "Mingo Junction (USXIM)"
  },
  {
   value: "Minneapolis\/St Paul Apt (USMSP)",
   label: "Minneapolis\/St Paul Apt (USMSP)"
  },
  {
   value: "Minnehaha (USMHA)",
   label: "Minnehaha (USMHA)"
  },
  {
   value: "Minnetonka (USMKA)",
   label: "Minnetonka (USMKA)"
  },
  {
   value: "Minocqua (USARV)",
   label: "Minocqua (USARV)"
  },
  {
   value: "Minot (USMOT)",
   label: "Minot (USMOT)"
  },
  {
   value: "Minster (USMZO)",
   label: "Minster (USMZO)"
  },
  {
   value: "Mippon Express (USXIP)",
   label: "Mippon Express (USXIP)"
  },
  {
   value: "Mira Loma (USMIK)",
   label: "Mira Loma (USMIK)"
  },
  {
   value: "Mira Mesa (USMLM)",
   label: "Mira Mesa (USMLM)"
  },
  {
   value: "Miramar (USMMR)",
   label: "Miramar (USMMR)"
  },
  {
   value: "Mishawaka (USMCJ)",
   label: "Mishawaka (USMCJ)"
  },
  {
   value: "Mission Hills (USMJH)",
   label: "Mission Hills (USMJH)"
  },
  {
   value: "Mission San Jose (USMJJ)",
   label: "Mission San Jose (USMJJ)"
  },
  {
   value: "Mission Viejo (USMJI)",
   label: "Mission Viejo (USMJI)"
  },
  {
   value: "Missoula (USMSO)",
   label: "Missoula (USMSO)"
  },
  {
   value: "Mitchell (USMHE)",
   label: "Mitchell (USMHE)"
  },
  {
   value: "Mitchell (USMHC)",
   label: "Mitchell (USMHC)"
  },
  {
   value: "Mitchell (USMIH)",
   label: "Mitchell (USMIH)"
  },
  {
   value: "Moberly (USMBY)",
   label: "Moberly (USMBY)"
  },
  {
   value: "Mobile (USMOB)",
   label: "Mobile (USMOB)"
  },
  {
   value: "Mobridge (USMBG)",
   label: "Mobridge (USMBG)"
  },
  {
   value: "Mocksville (USMSV)",
   label: "Mocksville (USMSV)"
  },
  {
   value: "Modena (USMEY)",
   label: "Modena (USMEY)"
  },
  {
   value: "Modesto (USMOD)",
   label: "Modesto (USMOD)"
  },
  {
   value: "Modesto (USMDZ)",
   label: "Modesto (USMDZ)"
  },
  {
   value: "Milan (USUQZ)",
   label: "Milan (USUQZ)"
  },
  {
   value: "Milbank (USMBK)",
   label: "Milbank (USMBK)"
  },
  {
   value: "Milbridge (USMLQ)",
   label: "Milbridge (USMLQ)"
  },
  {
   value: "Miles (USMSI)",
   label: "Miles (USMSI)"
  },
  {
   value: "Milesburg (USUQY)",
   label: "Milesburg (USUQY)"
  },
  {
   value: "Milford (USXIK)",
   label: "Milford (USXIK)"
  },
  {
   value: "Milford (USMLF)",
   label: "Milford (USMLF)"
  },
  {
   value: "Milford (USMEQ)",
   label: "Milford (USMEQ)"
  },
  {
   value: "Milford (USMFJ)",
   label: "Milford (USMFJ)"
  },
  {
   value: "Milford (USMFF)",
   label: "Milford (USMFF)"
  },
  {
   value: "Milford (USMII)",
   label: "Milford (USMII)"
  },
  {
   value: "Milford (USMIF)",
   label: "Milford (USMIF)"
  },
  {
   value: "Milford (USMFO)",
   label: "Milford (USMFO)"
  },
  {
   value: "Milford (USMFW)",
   label: "Milford (USMFW)"
  },
  {
   value: "Milford (USMIO)",
   label: "Milford (USMIO)"
  },
  {
   value: "Milford (USMFQ)",
   label: "Milford (USMFQ)"
  },
  {
   value: "Mill Hall (USMHP)",
   label: "Mill Hall (USMHP)"
  },
  {
   value: "Millbrae (USMBA)",
   label: "Millbrae (USMBA)"
  },
  {
   value: "Millbrook (USMBJ)",
   label: "Millbrook (USMBJ)"
  },
  {
   value: "Millburn (USXIR)",
   label: "Millburn (USXIR)"
  },
  {
   value: "Millbury (USMBT)",
   label: "Millbury (USMBT)"
  },
  {
   value: "Millbury (USXID)",
   label: "Millbury (USXID)"
  },
  {
   value: "Milledgeville (USMLJ)",
   label: "Milledgeville (USMLJ)"
  },
  {
   value: "Millersburg (USMLV)",
   label: "Millersburg (USMLV)"
  },
  {
   value: "Millersville (USMVL)",
   label: "Millersville (USMVL)"
  },
  {
   value: "Millington (USMTL)",
   label: "Millington (USMTL)"
  },
  {
   value: "Millington (USMGY)",
   label: "Millington (USMGY)"
  },
  {
   value: "Millington (USMZD)",
   label: "Millington (USMZD)"
  },
  {
   value: "Millinocket (USMLT)",
   label: "Millinocket (USMLT)"
  },
  {
   value: "Millsboro (USMBD)",
   label: "Millsboro (USMBD)"
  },
  {
   value: "Milltown (USMMJ)",
   label: "Milltown (USMMJ)"
  },
  {
   value: "Millville (USMIV)",
   label: "Millville (USMIV)"
  },
  {
   value: "Milner (USMXD)",
   label: "Milner (USMXD)"
  },
  {
   value: "Milpitas (USMPT)",
   label: "Milpitas (USMPT)"
  },
  {
   value: "Milroy (USMZE)",
   label: "Milroy (USMZE)"
  },
  {
   value: "Milton (USMLW)",
   label: "Milton (USMLW)"
  },
  {
   value: "Milton (USNSE)",
   label: "Milton (USNSE)"
  },
  {
   value: "Milton (USMXW)",
   label: "Milton (USMXW)"
  },
  {
   value: "Milton (USMXL)",
   label: "Milton (USMXL)"
  },
  {
   value: "Milton (USMZG)",
   label: "Milton (USMZG)"
  },
  {
   value: "Milton (USMTP)",
   label: "Milton (USMTP)"
  },
  {
   value: "Miami Lakes (USMMK)",
   label: "Miami Lakes (USMMK)"
  },
  {
   value: "Miami Springs (USMIZ)",
   label: "Miami Springs (USMIZ)"
  },
  {
   value: "Michigan Center (USMNC)",
   label: "Michigan Center (USMNC)"
  },
  {
   value: "Michigan City (USMGC)",
   label: "Michigan City (USMGC)"
  },
  {
   value: "Mickleton (USXIQ)",
   label: "Mickleton (USXIQ)"
  },
  {
   value: "Middle Granville (USMGI)",
   label: "Middle Granville (USMGI)"
  },
  {
   value: "Middle River (USMDV)",
   label: "Middle River (USMDV)"
  },
  {
   value: "Middle Village (USMVG)",
   label: "Middle Village (USMVG)"
  },
  {
   value: "Middleboro (USMID)",
   label: "Middleboro (USMID)"
  },
  {
   value: "Middleburgh Heights (USMBV)",
   label: "Middleburgh Heights (USMBV)"
  },
  {
   value: "Middlebury (USMDU)",
   label: "Middlebury (USMDU)"
  },
  {
   value: "Middlebury (USMBU)",
   label: "Middlebury (USMBU)"
  },
  {
   value: "Middleport (USMIP)",
   label: "Middleport (USMIP)"
  },
  {
   value: "Middlesboro (USMBR)",
   label: "Middlesboro (USMBR)"
  },
  {
   value: "Middlesex (USMIS)",
   label: "Middlesex (USMIS)"
  },
  {
   value: "Middleton (USMJP)",
   label: "Middleton (USMJP)"
  },
  {
   value: "Middleton (USMDW)",
   label: "Middleton (USMDW)"
  },
  {
   value: "Middletown (USXIN)",
   label: "Middletown (USXIN)"
  },
  {
   value: "Middletown (USMIU)",
   label: "Middletown (USMIU)"
  },
  {
   value: "Middletown (USMIJ)",
   label: "Middletown (USMIJ)"
  },
  {
   value: "Middletown (USMIY)",
   label: "Middletown (USMIY)"
  },
  {
   value: "Middletown (USMWO)",
   label: "Middletown (USMWO)"
  },
  {
   value: "Middletown (USUQT)",
   label: "Middletown (USUQT)"
  },
  {
   value: "Middletown (USMWV)",
   label: "Middletown (USMWV)"
  },
  {
   value: "Middleville (USMVK)",
   label: "Middleville (USMVK)"
  },
  {
   value: "Midland (USMLD)",
   label: "Midland (USMLD)"
  },
  {
   value: "Midland (USMAF)",
   label: "Midland (USMAF)"
  },
  {
   value: "Midland (USMDD)",
   label: "Midland (USMDD)"
  },
  {
   value: "Midland Park (USMDL)",
   label: "Midland Park (USMDL)"
  },
  {
   value: "Midland-Bay City-Saginaw (USMBS)",
   label: "Midland-Bay City-Saginaw (USMBS)"
  },
  {
   value: "Midlothian (USMIB)",
   label: "Midlothian (USMIB)"
  },
  {
   value: "Midlothian (USMLH)",
   label: "Midlothian (USMLH)"
  },
  {
   value: "Midvale (USMZC)",
   label: "Midvale (USMZC)"
  },
  {
   value: "Midway (USMYF)",
   label: "Midway (USMYF)"
  },
  {
   value: "Midway (USMWY)",
   label: "Midway (USMWY)"
  },
  {
   value: "Midway City (USMWC)",
   label: "Midway City (USMWC)"
  },
  {
   value: "Mifflinville (USMFV)",
   label: "Mifflinville (USMFV)"
  },
  {
   value: "Milan (USMXN)",
   label: "Milan (USMXN)"
  },
  {
   value: "Milan (USMIQ)",
   label: "Milan (USMIQ)"
  },
  {
   value: "Menomonie (USMMM)",
   label: "Menomonie (USMMM)"
  },
  {
   value: "Menomonie Fall (USUQP)",
   label: "Menomonie Fall (USUQP)"
  },
  {
   value: "Menonmone (USXIZ)",
   label: "Menonmone (USXIZ)"
  },
  {
   value: "Mentone (USMZQ)",
   label: "Mentone (USMZQ)"
  },
  {
   value: "Mentor (USMEO)",
   label: "Mentor (USMEO)"
  },
  {
   value: "Mequon (USMQU)",
   label: "Mequon (USMQU)"
  },
  {
   value: "Merced (USMCE)",
   label: "Merced (USMCE)"
  },
  {
   value: "Mercedes (USMRS)",
   label: "Mercedes (USMRS)"
  },
  {
   value: "Mercer (USMQX)",
   label: "Mercer (USMQX)"
  },
  {
   value: "Mercer Island (USMQZ)",
   label: "Mercer Island (USMQZ)"
  },
  {
   value: "Meriden (USMRD)",
   label: "Meriden (USMRD)"
  },
  {
   value: "Meridian (USMZA)",
   label: "Meridian (USMZA)"
  },
  {
   value: "Meridian (USMJA)",
   label: "Meridian (USMJA)"
  },
  {
   value: "Meridian (USMEI)",
   label: "Meridian (USMEI)"
  },
  {
   value: "Meridianville (USMLZ)",
   label: "Meridianville (USMLZ)"
  },
  {
   value: "Mermentau (USMNU)",
   label: "Mermentau (USMNU)"
  },
  {
   value: "Merrick (USMER)",
   label: "Merrick (USMER)"
  },
  {
   value: "Merrill (USRRL)",
   label: "Merrill (USRRL)"
  },
  {
   value: "Merrill (USMMD)",
   label: "Merrill (USMMD)"
  },
  {
   value: "Merrillville (USMEL)",
   label: "Merrillville (USMEL)"
  },
  {
   value: "Merrimack (USMRM)",
   label: "Merrimack (USMRM)"
  },
  {
   value: "Merritt Island (USMBF)",
   label: "Merritt Island (USMBF)"
  },
  {
   value: "Mertztown (USMZP)",
   label: "Mertztown (USMZP)"
  },
  {
   value: "Mesa (USMQA)",
   label: "Mesa (USMQA)"
  },
  {
   value: "Mesa (USMSC)",
   label: "Mesa (USMSC)"
  },
  {
   value: "Mesilla Park (USMSX)",
   label: "Mesilla Park (USMSX)"
  },
  {
   value: "Mesquite (USMQS)",
   label: "Mesquite (USMQS)"
  },
  {
   value: "Mesquite (USMSQ)",
   label: "Mesquite (USMSQ)"
  },
  {
   value: "Mesquite (USMFH)",
   label: "Mesquite (USMFH)"
  },
  {
   value: "Meta (USMZB)",
   label: "Meta (USMZB)"
  },
  {
   value: "Metairie (USMTE)",
   label: "Metairie (USMTE)"
  },
  {
   value: "Metaline Falls (USMTF)",
   label: "Metaline Falls (USMTF)"
  },
  {
   value: "Metarie (USUXF)",
   label: "Metarie (USUXF)"
  },
  {
   value: "Methuen (USMZJ)",
   label: "Methuen (USMZJ)"
  },
  {
   value: "Metlakatla (USMTM)",
   label: "Metlakatla (USMTM)"
  },
  {
   value: "Metropolis (USMET)",
   label: "Metropolis (USMET)"
  },
  {
   value: "Metuchen (USMEU)",
   label: "Metuchen (USMEU)"
  },
  {
   value: "Metzger (USMTY)",
   label: "Metzger (USMTY)"
  },
  {
   value: "Mexia (USMAX)",
   label: "Mexia (USMAX)"
  },
  {
   value: "Mexico (USMXI)",
   label: "Mexico (USMXI)"
  },
  {
   value: "Miami (USMIA)",
   label: "Miami (USMIA)"
  },
  {
   value: "Mcmurray (USMCM)",
   label: "Mcmurray (USMCM)"
  },
  {
   value: "Mcnary (USMRX)",
   label: "Mcnary (USMRX)"
  },
  {
   value: "Mcpherson (USMPR)",
   label: "Mcpherson (USMPR)"
  },
  {
   value: "Mcveytown (USMVT)",
   label: "Mcveytown (USMVT)"
  },
  {
   value: "Meadow Lands (USMLS)",
   label: "Meadow Lands (USMLS)"
  },
  {
   value: "Meadville (USMEJ)",
   label: "Meadville (USMEJ)"
  },
  {
   value: "Mebane (USMBN)",
   label: "Mebane (USMBN)"
  },
  {
   value: "Mecca (USMEX)",
   label: "Mecca (USMEX)"
  },
  {
   value: "Mechanicsburg (USMCB)",
   label: "Mechanicsburg (USMCB)"
  },
  {
   value: "Mechanicsville (USMEV)",
   label: "Mechanicsville (USMEV)"
  },
  {
   value: "Mechanicville (USMHV)",
   label: "Mechanicville (USMHV)"
  },
  {
   value: "Medfield (USMDC)",
   label: "Medfield (USMDC)"
  },
  {
   value: "Medford (USMDF)",
   label: "Medford (USMDF)"
  },
  {
   value: "Medford (USMFC)",
   label: "Medford (USMFC)"
  },
  {
   value: "Medford (USUQN)",
   label: "Medford (USUQN)"
  },
  {
   value: "Medford (USMDE)",
   label: "Medford (USMDE)"
  },
  {
   value: "Medford (USMFR)",
   label: "Medford (USMFR)"
  },
  {
   value: "Media (USXIJ)",
   label: "Media (USXIJ)"
  },
  {
   value: "Medina (USMDK)",
   label: "Medina (USMDK)"
  },
  {
   value: "Medina (USMDQ)",
   label: "Medina (USMDQ)"
  },
  {
   value: "Medley (USMDY)",
   label: "Medley (USMDY)"
  },
  {
   value: "Meedham (USMDM)",
   label: "Meedham (USMDM)"
  },
  {
   value: "Mehoopany (USMEH)",
   label: "Mehoopany (USMEH)"
  },
  {
   value: "Melba (USMKB)",
   label: "Melba (USMKB)"
  },
  {
   value: "Melbourne (USMLB)",
   label: "Melbourne (USMLB)"
  },
  {
   value: "Melbourne Beach (USMBE)",
   label: "Melbourne Beach (USMBE)"
  },
  {
   value: "Mellville (USMVI)",
   label: "Mellville (USMVI)"
  },
  {
   value: "Melrose (USMLO)",
   label: "Melrose (USMLO)"
  },
  {
   value: "Melrose (USMMZ)",
   label: "Melrose (USMMZ)"
  },
  {
   value: "Melrose Park (USMRP)",
   label: "Melrose Park (USMRP)"
  },
  {
   value: "Melville (USZMV)",
   label: "Melville (USZMV)"
  },
  {
   value: "Memphis (USMEM)",
   label: "Memphis (USMEM)"
  },
  {
   value: "Memphis (USMTX)",
   label: "Memphis (USMTX)"
  },
  {
   value: "Menasha (USMEZ)",
   label: "Menasha (USMEZ)"
  },
  {
   value: "Mendocino (USMND)",
   label: "Mendocino (USMND)"
  },
  {
   value: "Mendota (USMEN)",
   label: "Mendota (USMEN)"
  },
  {
   value: "Menford (USMFS)",
   label: "Menford (USMFS)"
  },
  {
   value: "Menlo (USMNL)",
   label: "Menlo (USMNL)"
  },
  {
   value: "Menlo Park (USMKU)",
   label: "Menlo Park (USMKU)"
  },
  {
   value: "Menominee (USMNM)",
   label: "Menominee (USMNM)"
  },
  {
   value: "Menomonee Falls (USMMF)",
   label: "Menomonee Falls (USMMF)"
  },
  {
   value: "Maybrook (USMYQ)",
   label: "Maybrook (USMYQ)"
  },
  {
   value: "Mayfield (USMAY)",
   label: "Mayfield (USMAY)"
  },
  {
   value: "Mayfield (USMFP)",
   label: "Mayfield (USMFP)"
  },
  {
   value: "Mayo (USMAA)",
   label: "Mayo (USMAA)"
  },
  {
   value: "Mayodan (USMYO)",
   label: "Mayodan (USMYO)"
  },
  {
   value: "Mays Landing (USMYJ)",
   label: "Mays Landing (USMYJ)"
  },
  {
   value: "Maysville (USMYK)",
   label: "Maysville (USMYK)"
  },
  {
   value: "Mayville (USMYI)",
   label: "Mayville (USMYI)"
  },
  {
   value: "Maywood (USMYA)",
   label: "Maywood (USMYA)"
  },
  {
   value: "Maywood (USMYW)",
   label: "Maywood (USMYW)"
  },
  {
   value: "Maywood (USMYD)",
   label: "Maywood (USMYD)"
  },
  {
   value: "Maywood Park (USMZK)",
   label: "Maywood Park (USMZK)"
  },
  {
   value: "Mc Adenville (USMCV)",
   label: "Mc Adenville (USMCV)"
  },
  {
   value: "Mc Adoo (USMCA)",
   label: "Mc Adoo (USMCA)"
  },
  {
   value: "Mc Alester (USMLC)",
   label: "Mc Alester (USMLC)"
  },
  {
   value: "Mc Bride (USMBI)",
   label: "Mc Bride (USMBI)"
  },
  {
   value: "Mc Comb (USMOM)",
   label: "Mc Comb (USMOM)"
  },
  {
   value: "Mc Cook (USMCO)",
   label: "Mc Cook (USMCO)"
  },
  {
   value: "Mc Cook (USUQM)",
   label: "Mc Cook (USUQM)"
  },
  {
   value: "Mc Dermott (USMMH)",
   label: "Mc Dermott (USMMH)"
  },
  {
   value: "Mc Donald (USMDP)",
   label: "Mc Donald (USMDP)"
  },
  {
   value: "Mc Donough (USMCH)",
   label: "Mc Donough (USMCH)"
  },
  {
   value: "Mc Farland (USMCF)",
   label: "Mc Farland (USMCF)"
  },
  {
   value: "Mc Henry (USMHB)",
   label: "Mc Henry (USMHB)"
  },
  {
   value: "Mc Keesport (USMCK)",
   label: "Mc Keesport (USMCK)"
  },
  {
   value: "Mc Kenzie (USUQX)",
   label: "Mc Kenzie (USUQX)"
  },
  {
   value: "Mc Kinney (USMCT)",
   label: "Mc Kinney (USMCT)"
  },
  {
   value: "Mc Minnville (USMMV)",
   label: "Mc Minnville (USMMV)"
  },
  {
   value: "Mc Rae (USMQW)",
   label: "Mc Rae (USMQW)"
  },
  {
   value: "Mcallen-Mission (USMFE)",
   label: "Mcallen-Mission (USMFE)"
  },
  {
   value: "Mcarthur (USMCU)",
   label: "Mcarthur (USMCU)"
  },
  {
   value: "Mcbee (USXIE)",
   label: "Mcbee (USXIE)"
  },
  {
   value: "Mcconnellsburg (USMNB)",
   label: "Mcconnellsburg (USMNB)"
  },
  {
   value: "Mccrocken (USMKN)",
   label: "Mccrocken (USMKN)"
  },
  {
   value: "Mccrory (USMCC)",
   label: "Mccrory (USMCC)"
  },
  {
   value: "Mcgraw Park (USMWK)",
   label: "Mcgraw Park (USMWK)"
  },
  {
   value: "Mcintosh (USMZI)",
   label: "Mcintosh (USMZI)"
  },
  {
   value: "Mcintyre (USMCQ)",
   label: "Mcintyre (USMCQ)"
  },
  {
   value: "Mckinley Park (USMLA)",
   label: "Mckinley Park (USMLA)"
  },
  {
   value: "Mcmillin (USMMW)",
   label: "Mcmillin (USMMW)"
  },
  {
   value: "Mcminnville (USMMC)",
   label: "Mcminnville (USMMC)"
  },
  {
   value: "Mart (USMRA)",
   label: "Mart (USMRA)"
  },
  {
   value: "Martel (USXJE)",
   label: "Martel (USXJE)"
  },
  {
   value: "Martin (USMAN)",
   label: "Martin (USMAN)"
  },
  {
   value: "Martin (USMMT)",
   label: "Martin (USMMT)"
  },
  {
   value: "Martin Mariet\/Baltimore (USMTN)",
   label: "Martin Mariet\/Baltimore (USMTN)"
  },
  {
   value: "Martinez (USMRZ)",
   label: "Martinez (USMRZ)"
  },
  {
   value: "Martins Creek (USMQP)",
   label: "Martins Creek (USMQP)"
  },
  {
   value: "Martins Ferry (USMFY)",
   label: "Martins Ferry (USMFY)"
  },
  {
   value: "Martinsburg (USMRB)",
   label: "Martinsburg (USMRB)"
  },
  {
   value: "Martinsburg-Altoona (USAOO)",
   label: "Martinsburg-Altoona (USAOO)"
  },
  {
   value: "Martinsville (USMOX)",
   label: "Martinsville (USMOX)"
  },
  {
   value: "Martinsville (USMTV)",
   label: "Martinsville (USMTV)"
  },
  {
   value: "Maryland Heights (USMHM)",
   label: "Maryland Heights (USMHM)"
  },
  {
   value: "Marysville (USMYV)",
   label: "Marysville (USMYV)"
  },
  {
   value: "Marysville (USMYE)",
   label: "Marysville (USMYE)"
  },
  {
   value: "Marysville (USMYL)",
   label: "Marysville (USMYL)"
  },
  {
   value: "Marysville (USMRV)",
   label: "Marysville (USMRV)"
  },
  {
   value: "Marysville (USMYP)",
   label: "Marysville (USMYP)"
  },
  {
   value: "Marysville (USMYS)",
   label: "Marysville (USMYS)"
  },
  {
   value: "Maryville (USMVE)",
   label: "Maryville (USMVE)"
  },
  {
   value: "Maryville (USMRL)",
   label: "Maryville (USMRL)"
  },
  {
   value: "Masaryktown (USMSA)",
   label: "Masaryktown (USMSA)"
  },
  {
   value: "Mason (USMWJ)",
   label: "Mason (USMWJ)"
  },
  {
   value: "Mason (USUXE)",
   label: "Mason (USUXE)"
  },
  {
   value: "Mason City (USMCW)",
   label: "Mason City (USMCW)"
  },
  {
   value: "Maspeth (USMTH)",
   label: "Maspeth (USMTH)"
  },
  {
   value: "Massena (USMSS)",
   label: "Massena (USMSS)"
  },
  {
   value: "Massillon (USXJF)",
   label: "Massillon (USXJF)"
  },
  {
   value: "Masury (USMSU)",
   label: "Masury (USMSU)"
  },
  {
   value: "Matanuska (USMTU)",
   label: "Matanuska (USMTU)"
  },
  {
   value: "Mathews (USMJW)",
   label: "Mathews (USMJW)"
  },
  {
   value: "Mattapoisett (USMTQ)",
   label: "Mattapoisett (USMTQ)"
  },
  {
   value: "Matthews (USMUA)",
   label: "Matthews (USMUA)"
  },
  {
   value: "Mattoon (USMTO)",
   label: "Mattoon (USMTO)"
  },
  {
   value: "Mattydale (USMTD)",
   label: "Mattydale (USMTD)"
  },
  {
   value: "Mauldin (USMAU)",
   label: "Mauldin (USMAU)"
  },
  {
   value: "Maumee (USMMY)",
   label: "Maumee (USMMY)"
  },
  {
   value: "Maumelle (USMLE)",
   label: "Maumelle (USMLE)"
  },
  {
   value: "Max Meadows (USMXM)",
   label: "Max Meadows (USMXM)"
  },
  {
   value: "Maxton (USMXE)",
   label: "Maxton (USMXE)"
  },
  {
   value: "Marathon (USMHO)",
   label: "Marathon (USMHO)"
  },
  {
   value: "Marathon (USMHH)",
   label: "Marathon (USMHH)"
  },
  {
   value: "Marble Falls (USMFA)",
   label: "Marble Falls (USMFA)"
  },
  {
   value: "Marceline (USMOV)",
   label: "Marceline (USMOV)"
  },
  {
   value: "Marcus Hook (USMAH)",
   label: "Marcus Hook (USMAH)"
  },
  {
   value: "Marengo (USMGO)",
   label: "Marengo (USMGO)"
  },
  {
   value: "Margate (USMGT)",
   label: "Margate (USMGT)"
  },
  {
   value: "Marianna (USMNF)",
   label: "Marianna (USMNF)"
  },
  {
   value: "Mariemont (USMRI)",
   label: "Mariemont (USMRI)"
  },
  {
   value: "Marietta (USMGE)",
   label: "Marietta (USMGE)"
  },
  {
   value: "Marietta (USMIR)",
   label: "Marietta (USMIR)"
  },
  {
   value: "Marietta (USMPD)",
   label: "Marietta (USMPD)"
  },
  {
   value: "Marina (USMAK)",
   label: "Marina (USMAK)"
  },
  {
   value: "Marina Del Ray (USMDX)",
   label: "Marina Del Ray (USMDX)"
  },
  {
   value: "Marinette (USMOY)",
   label: "Marinette (USMOY)"
  },
  {
   value: "Marion (USMQM)",
   label: "Marion (USMQM)"
  },
  {
   value: "Marion (USXJC)",
   label: "Marion (USXJC)"
  },
  {
   value: "Marion (USXJD)",
   label: "Marion (USXJD)"
  },
  {
   value: "Marion (USMNN)",
   label: "Marion (USMNN)"
  },
  {
   value: "Marion (USMXB)",
   label: "Marion (USMXB)"
  },
  {
   value: "Marion (USMIN)",
   label: "Marion (USMIN)"
  },
  {
   value: "Marion (USMZZ)",
   label: "Marion (USMZZ)"
  },
  {
   value: "Marion (USMWA)",
   label: "Marion (USMWA)"
  },
  {
   value: "Marion (USMSR)",
   label: "Marion (USMSR)"
  },
  {
   value: "Markesan (USMKK)",
   label: "Markesan (USMKK)"
  },
  {
   value: "Markham (USMKM)",
   label: "Markham (USMKM)"
  },
  {
   value: "Markle (USMQL)",
   label: "Markle (USMQL)"
  },
  {
   value: "Marlboro (USMBO)",
   label: "Marlboro (USMBO)"
  },
  {
   value: "Marlette (USMQH)",
   label: "Marlette (USMQH)"
  },
  {
   value: "Marlton (USMJT)",
   label: "Marlton (USMJT)"
  },
  {
   value: "Marquette (USMQT)",
   label: "Marquette (USMQT)"
  },
  {
   value: "Marrero (USMAR)",
   label: "Marrero (USMAR)"
  },
  {
   value: "Mars (USXJB)",
   label: "Mars (USXJB)"
  },
  {
   value: "Marshall (USMHG)",
   label: "Marshall (USMHG)"
  },
  {
   value: "Marshall (USASL)",
   label: "Marshall (USASL)"
  },
  {
   value: "Marshall (USMML)",
   label: "Marshall (USMML)"
  },
  {
   value: "Marshall (USMHL)",
   label: "Marshall (USMHL)"
  },
  {
   value: "Marshalltown (USMIW)",
   label: "Marshalltown (USMIW)"
  },
  {
   value: "Marshfield (USMFB)",
   label: "Marshfield (USMFB)"
  },
  {
   value: "Marshfield (USMFI)",
   label: "Marshfield (USMFI)"
  },
  {
   value: "Marshville (USMHD)",
   label: "Marshville (USMHD)"
  },
  {
   value: "Marsing (USMSG)",
   label: "Marsing (USMSG)"
  },
  {
   value: "Manchester (USMHI)",
   label: "Manchester (USMHI)"
  },
  {
   value: "Manchester (USMNX)",
   label: "Manchester (USMNX)"
  },
  {
   value: "Manchester (USMNY)",
   label: "Manchester (USMNY)"
  },
  {
   value: "Manchester Center (USMNJ)",
   label: "Manchester Center (USMNJ)"
  },
  {
   value: "Mancos (USMCS)",
   label: "Mancos (USMCS)"
  },
  {
   value: "Mandeville (USMAB)",
   label: "Mandeville (USMAB)"
  },
  {
   value: "Manetapan (USMQN)",
   label: "Manetapan (USMQN)"
  },
  {
   value: "Manhattan (USMHK)",
   label: "Manhattan (USMHK)"
  },
  {
   value: "Manhattan (USMHN)",
   label: "Manhattan (USMHN)"
  },
  {
   value: "Manhattan Beach (USMBQ)",
   label: "Manhattan Beach (USMBQ)"
  },
  {
   value: "Manheim (USMHF)",
   label: "Manheim (USMHF)"
  },
  {
   value: "Manistee (USMBL)",
   label: "Manistee (USMBL)"
  },
  {
   value: "Manitowoc (USMTW)",
   label: "Manitowoc (USMTW)"
  },
  {
   value: "Mankato (USMKT)",
   label: "Mankato (USMKT)"
  },
  {
   value: "Manley Hot Springs (USMLY)",
   label: "Manley Hot Springs (USMLY)"
  },
  {
   value: "Manning (USMNG)",
   label: "Manning (USMNG)"
  },
  {
   value: "Manor (USMAQ)",
   label: "Manor (USMAQ)"
  },
  {
   value: "Mansfield (USMAS)",
   label: "Mansfield (USMAS)"
  },
  {
   value: "Mansfield (USMNS)",
   label: "Mansfield (USMNS)"
  },
  {
   value: "Mansfield (USMFD)",
   label: "Mansfield (USMFD)"
  },
  {
   value: "Mansfield (USMFL)",
   label: "Mansfield (USMFL)"
  },
  {
   value: "Mansfield (USMSF)",
   label: "Mansfield (USMSF)"
  },
  {
   value: "Manson (USMON)",
   label: "Manson (USMON)"
  },
  {
   value: "Manteca (USMTA)",
   label: "Manteca (USMTA)"
  },
  {
   value: "Mantee (USMTZ)",
   label: "Mantee (USMTZ)"
  },
  {
   value: "Manteno (USMTR)",
   label: "Manteno (USMTR)"
  },
  {
   value: "Manvel (USMAV)",
   label: "Manvel (USMAV)"
  },
  {
   value: "Manver (USMWP)",
   label: "Manver (USMWP)"
  },
  {
   value: "Maple Grove (USMPO)",
   label: "Maple Grove (USMPO)"
  },
  {
   value: "Maple Heights (USMAP)",
   label: "Maple Heights (USMAP)"
  },
  {
   value: "Maple Hills (USMPU)",
   label: "Maple Hills (USMPU)"
  },
  {
   value: "Maple Island (USMIM)",
   label: "Maple Island (USMIM)"
  },
  {
   value: "Maple Park (USMEP)",
   label: "Maple Park (USMEP)"
  },
  {
   value: "Maple Shade (USXJA)",
   label: "Maple Shade (USXJA)"
  },
  {
   value: "Mapleton (USXIS)",
   label: "Mapleton (USXIS)"
  },
  {
   value: "Mapleton (USMPZ)",
   label: "Mapleton (USMPZ)"
  },
  {
   value: "Mapleville (USMPX)",
   label: "Mapleville (USMPX)"
  },
  {
   value: "Maplewood (USMPW)",
   label: "Maplewood (USMPW)"
  },
  {
   value: "Maquoketa (USMQO)",
   label: "Maquoketa (USMQO)"
  },
  {
   value: "Mar Vista (USMVA)",
   label: "Mar Vista (USMVA)"
  },
  {
   value: "Madawaska (USMAD)",
   label: "Madawaska (USMAD)"
  },
  {
   value: "Madelia (USMDA)",
   label: "Madelia (USMDA)"
  },
  {
   value: "Madera (USMAE)",
   label: "Madera (USMAE)"
  },
  {
   value: "Madill (USMIL)",
   label: "Madill (USMIL)"
  },
  {
   value: "Madison (USMSM)",
   label: "Madison (USMSM)"
  },
  {
   value: "Madison (USMAO)",
   label: "Madison (USMAO)"
  },
  {
   value: "Madison (USMDI)",
   label: "Madison (USMDI)"
  },
  {
   value: "Madison (USMSD)",
   label: "Madison (USMSD)"
  },
  {
   value: "Madison (USMSN)",
   label: "Madison (USMSN)"
  },
  {
   value: "Madison (USMDN)",
   label: "Madison (USMDN)"
  },
  {
   value: "Madison (USMDJ)",
   label: "Madison (USMDJ)"
  },
  {
   value: "Madison (USMDS)",
   label: "Madison (USMDS)"
  },
  {
   value: "Madison (USMAZ)",
   label: "Madison (USMAZ)"
  },
  {
   value: "Madison (USMYY)",
   label: "Madison (USMYY)"
  },
  {
   value: "Madison (USAAL)",
   label: "Madison (USAAL)"
  },
  {
   value: "Madison Heights (USMSH)",
   label: "Madison Heights (USMSH)"
  },
  {
   value: "Madisonville (USMVQ)",
   label: "Madisonville (USMVQ)"
  },
  {
   value: "Magna (USXIU)",
   label: "Magna (USXIU)"
  },
  {
   value: "Magnolia (USMAG)",
   label: "Magnolia (USMAG)"
  },
  {
   value: "Magnolia (USAGO)",
   label: "Magnolia (USAGO)"
  },
  {
   value: "Magnolia Park (USMLP)",
   label: "Magnolia Park (USMLP)"
  },
  {
   value: "Mahopac (USMAJ)",
   label: "Mahopac (USMAJ)"
  },
  {
   value: "Mahrt (USMAT)",
   label: "Mahrt (USMAT)"
  },
  {
   value: "Mahwah (USMHW)",
   label: "Mahwah (USMHW)"
  },
  {
   value: "Maida (USMAI)",
   label: "Maida (USMAI)"
  },
  {
   value: "Maiden (USUQO)",
   label: "Maiden (USUQO)"
  },
  {
   value: "Malaga (USMGA)",
   label: "Malaga (USMGA)"
  },
  {
   value: "Malden (USMAW)",
   label: "Malden (USMAW)"
  },
  {
   value: "Malden (USXII)",
   label: "Malden (USXII)"
  },
  {
   value: "Malibu (USMAL)",
   label: "Malibu (USMAL)"
  },
  {
   value: "Malin (USMLN)",
   label: "Malin (USMLN)"
  },
  {
   value: "Malott (USXIT)",
   label: "Malott (USXIT)"
  },
  {
   value: "Malta (USMXA)",
   label: "Malta (USMXA)"
  },
  {
   value: "Malvern (USMVY)",
   label: "Malvern (USMVY)"
  },
  {
   value: "Mamaroneck (USUQJ)",
   label: "Mamaroneck (USUQJ)"
  },
  {
   value: "Mamou (USMUX)",
   label: "Mamou (USMUX)"
  },
  {
   value: "Manassas (USMNZ)",
   label: "Manassas (USMNZ)"
  },
  {
   value: "Manatee (USMEE)",
   label: "Manatee (USMEE)"
  },
  {
   value: "Manawa (USMWW)",
   label: "Manawa (USMWW)"
  },
  {
   value: "Manchester (USMNE)",
   label: "Manchester (USMNE)"
  },
  {
   value: "Manchester (USMCR)",
   label: "Manchester (USMCR)"
  },
  {
   value: "Manchester (USMHT)",
   label: "Manchester (USMHT)"
  },
  {
   value: "Ludlow (USLDM)",
   label: "Ludlow (USLDM)"
  },
  {
   value: "Lufkin (USLFK)",
   label: "Lufkin (USLFK)"
  },
  {
   value: "Lugoff (USLOF)",
   label: "Lugoff (USLOF)"
  },
  {
   value: "Luke (USLUK)",
   label: "Luke (USLUK)"
  },
  {
   value: "Lukeville (USLUD)",
   label: "Lukeville (USLUD)"
  },
  {
   value: "Luling (USLYG)",
   label: "Luling (USLYG)"
  },
  {
   value: "Lumber Bridge (USLUB)",
   label: "Lumber Bridge (USLUB)"
  },
  {
   value: "Lumberton (USLMB)",
   label: "Lumberton (USLMB)"
  },
  {
   value: "Lumberton (USLBS)",
   label: "Lumberton (USLBS)"
  },
  {
   value: "Lumberton (USLBT)",
   label: "Lumberton (USLBT)"
  },
  {
   value: "Lumpkin (USLKN)",
   label: "Lumpkin (USLKN)"
  },
  {
   value: "Lunenburg (USLUG)",
   label: "Lunenburg (USLUG)"
  },
  {
   value: "Luray (USLRA)",
   label: "Luray (USLRA)"
  },
  {
   value: "Lutts (USLYZ)",
   label: "Lutts (USLYZ)"
  },
  {
   value: "Luverne (USLZW)",
   label: "Luverne (USLZW)"
  },
  {
   value: "Lyman (USUQH)",
   label: "Lyman (USUQH)"
  },
  {
   value: "Lyme (USLYE)",
   label: "Lyme (USLYE)"
  },
  {
   value: "Lynbrook (USLYB)",
   label: "Lynbrook (USLYB)"
  },
  {
   value: "Lynchburg (USLYX)",
   label: "Lynchburg (USLYX)"
  },
  {
   value: "Lynchburg (USLYH)",
   label: "Lynchburg (USLYH)"
  },
  {
   value: "Lynden (USLYN)",
   label: "Lynden (USLYN)"
  },
  {
   value: "Lyndhurst (USLDT)",
   label: "Lyndhurst (USLDT)"
  },
  {
   value: "Lynhurst (USUQD)",
   label: "Lynhurst (USUQD)"
  },
  {
   value: "Lynn (USLYA)",
   label: "Lynn (USLYA)"
  },
  {
   value: "Lynn (USLYI)",
   label: "Lynn (USLYI)"
  },
  {
   value: "Lynwood (USLYJ)",
   label: "Lynwood (USLYJ)"
  },
  {
   value: "Lynwood (USLYF)",
   label: "Lynwood (USLYF)"
  },
  {
   value: "Lyons (USLYS)",
   label: "Lyons (USLYS)"
  },
  {
   value: "Lyons (USLYO)",
   label: "Lyons (USLYO)"
  },
  {
   value: "Lyons (USLYY)",
   label: "Lyons (USLYY)"
  },
  {
   value: "Lyoth (USLOH)",
   label: "Lyoth (USLOH)"
  },
  {
   value: "Lytton (USLYT)",
   label: "Lytton (USLYT)"
  },
  {
   value: "Maben (USMBX)",
   label: "Maben (USMBX)"
  },
  {
   value: "Mabie (USXIC)",
   label: "Mabie (USXIC)"
  },
  {
   value: "Mableton (USUQL)",
   label: "Mableton (USUQL)"
  },
  {
   value: "Macdoel (USMCL)",
   label: "Macdoel (USMCL)"
  },
  {
   value: "Macedon (USXIG)",
   label: "Macedon (USXIG)"
  },
  {
   value: "Macedonia (USXIF)",
   label: "Macedonia (USXIF)"
  },
  {
   value: "Mackinac Island (USMCD)",
   label: "Mackinac Island (USMCD)"
  },
  {
   value: "Macomb (USMQB)",
   label: "Macomb (USMQB)"
  },
  {
   value: "Macon (USMCN)",
   label: "Macon (USMCN)"
  },
  {
   value: "Macon (USMAC)",
   label: "Macon (USMAC)"
  },
  {
   value: "Longwood (USLGW)",
   label: "Longwood (USLGW)"
  },
  {
   value: "Lonoke (USLOK)",
   label: "Lonoke (USLOK)"
  },
  {
   value: "Loop (USLPP)",
   label: "Loop (USLPP)"
  },
  {
   value: "Lorain (USLRN)",
   label: "Lorain (USLRN)"
  },
  {
   value: "Lorain (USLOR)",
   label: "Lorain (USLOR)"
  },
  {
   value: "Lordstown (USLLO)",
   label: "Lordstown (USLLO)"
  },
  {
   value: "Lorton (USLPV)",
   label: "Lorton (USLPV)"
  },
  {
   value: "Los Alamitos (USLAT)",
   label: "Los Alamitos (USLAT)"
  },
  {
   value: "Los Alamos (USLAM)",
   label: "Los Alamos (USLAM)"
  },
  {
   value: "Los Altos (USLLT)",
   label: "Los Altos (USLLT)"
  },
  {
   value: "Los Altos Hills (USLAH)",
   label: "Los Altos Hills (USLAH)"
  },
  {
   value: "Los Angeles (USLAX)",
   label: "Los Angeles (USLAX)"
  },
  {
   value: "Los Banos (USLSN)",
   label: "Los Banos (USLSN)"
  },
  {
   value: "Los Gatos (USLXX)",
   label: "Los Gatos (USLXX)"
  },
  {
   value: "Los Nietos (USLNE)",
   label: "Los Nietos (USLNE)"
  },
  {
   value: "Loudon (USXHU)",
   label: "Loudon (USXHU)"
  },
  {
   value: "Louisa (USLOW)",
   label: "Louisa (USLOW)"
  },
  {
   value: "Louisburg (USLFN)",
   label: "Louisburg (USLFN)"
  },
  {
   value: "Louise (USLOU)",
   label: "Louise (USLOU)"
  },
  {
   value: "Louisiana (USLUA)",
   label: "Louisiana (USLUA)"
  },
  {
   value: "Louisville (USLUY)",
   label: "Louisville (USLUY)"
  },
  {
   value: "Louisville (USLOS)",
   label: "Louisville (USLOS)"
  },
  {
   value: "Louisville (USLMS)",
   label: "Louisville (USLMS)"
  },
  {
   value: "Louisville (USLUE)",
   label: "Louisville (USLUE)"
  },
  {
   value: "Louisville (USLUV)",
   label: "Louisville (USLUV)"
  },
  {
   value: "\"Louisville (USLUI)",
   label: "\"Louisville (USLUI)"
  },
  {
   value: "Lovejoy (USLVJ)",
   label: "Lovejoy (USLVJ)"
  },
  {
   value: "Loveland (USLOV)",
   label: "Loveland (USLOV)"
  },
  {
   value: "Loveland (USXHT)",
   label: "Loveland (USXHT)"
  },
  {
   value: "Lovington (USLOJ)",
   label: "Lovington (USLOJ)"
  },
  {
   value: "Lowell (USLWL)",
   label: "Lowell (USLWL)"
  },
  {
   value: "Lowell (USLPB)",
   label: "Lowell (USLPB)"
  },
  {
   value: "Lowell (USLJW)",
   label: "Lowell (USLJW)"
  },
  {
   value: "Lowland (USLLQ)",
   label: "Lowland (USLLQ)"
  },
  {
   value: "Lowville (USLWF)",
   label: "Lowville (USLWF)"
  },
  {
   value: "Loxley (USLXY)",
   label: "Loxley (USLXY)"
  },
  {
   value: "Luana (USLUN)",
   label: "Luana (USLUN)"
  },
  {
   value: "Lubbock (USLBB)",
   label: "Lubbock (USLBB)"
  },
  {
   value: "Lucern Valley (USLCB)",
   label: "Lucern Valley (USLCB)"
  },
  {
   value: "Luck (USLUC)",
   label: "Luck (USLUC)"
  },
  {
   value: "Ludlow (USLLW)",
   label: "Ludlow (USLLW)"
  },
  {
   value: "Livingston (USLVO)",
   label: "Livingston (USLVO)"
  },
  {
   value: "Livingston (USLVT)",
   label: "Livingston (USLVT)"
  },
  {
   value: "Livingston (USXHX)",
   label: "Livingston (USXHX)"
  },
  {
   value: "Livingston (USLYV)",
   label: "Livingston (USLYV)"
  },
  {
   value: "Livonia (USLIV)",
   label: "Livonia (USLIV)"
  },
  {
   value: "Lock Haven (USLHV)",
   label: "Lock Haven (USLHV)"
  },
  {
   value: "Lockbourne (USLCK)",
   label: "Lockbourne (USLCK)"
  },
  {
   value: "Lockland (USLKL)",
   label: "Lockland (USLKL)"
  },
  {
   value: "Lockney (USLQY)",
   label: "Lockney (USLQY)"
  },
  {
   value: "Lockport (USLOP)",
   label: "Lockport (USLOP)"
  },
  {
   value: "Lockport (USLOT)",
   label: "Lockport (USLOT)"
  },
  {
   value: "Lockport (USLPT)",
   label: "Lockport (USLPT)"
  },
  {
   value: "Locust Grove (USXHN)",
   label: "Locust Grove (USXHN)"
  },
  {
   value: "Locust Summit (USXHY)",
   label: "Locust Summit (USXHY)"
  },
  {
   value: "Lodi (USLDI)",
   label: "Lodi (USLDI)"
  },
  {
   value: "Lodi (USLOI)",
   label: "Lodi (USLOI)"
  },
  {
   value: "Logan (USOGN)",
   label: "Logan (USOGN)"
  },
  {
   value: "Logan (USLGU)",
   label: "Logan (USLGU)"
  },
  {
   value: "Logan Airport (USLGZ)",
   label: "Logan Airport (USLGZ)"
  },
  {
   value: "Logansport (USLGP)",
   label: "Logansport (USLGP)"
  },
  {
   value: "Logansport (USLST)",
   label: "Logansport (USLST)"
  },
  {
   value: "Lombard (USLOM)",
   label: "Lombard (USLOM)"
  },
  {
   value: "Lometa (USLTA)",
   label: "Lometa (USLTA)"
  },
  {
   value: "Lomira (USXHR)",
   label: "Lomira (USXHR)"
  },
  {
   value: "Lomita (USLOA)",
   label: "Lomita (USLOA)"
  },
  {
   value: "Lompoc (USLPC)",
   label: "Lompoc (USLPC)"
  },
  {
   value: "London (USLDN)",
   label: "London (USLDN)"
  },
  {
   value: "Londonderry (USLOD)",
   label: "Londonderry (USLOD)"
  },
  {
   value: "Lone Star (USLSX)",
   label: "Lone Star (USLSX)"
  },
  {
   value: "Long Beach (USLGB)",
   label: "Long Beach (USLGB)"
  },
  {
   value: "Long Grove (USLGG)",
   label: "Long Grove (USLGG)"
  },
  {
   value: "Long Island (USUQC)",
   label: "Long Island (USUQC)"
  },
  {
   value: "Long Island City (USXHO)",
   label: "Long Island City (USXHO)"
  },
  {
   value: "Long Lake (USLLE)",
   label: "Long Lake (USLLE)"
  },
  {
   value: "Long Prairie (USLLP)",
   label: "Long Prairie (USLLP)"
  },
  {
   value: "Long Valley (USLGJ)",
   label: "Long Valley (USLGJ)"
  },
  {
   value: "Longmont (USLNG)",
   label: "Longmont (USLNG)"
  },
  {
   value: "Longview (USLGV)",
   label: "Longview (USLGV)"
  },
  {
   value: "Longview \/ KILGORE (USGGG)",
   label: "Longview \/ KILGORE (USGGG)"
  },
  {
   value: "Longview (USLOG)",
   label: "Longview (USLOG)"
  },
  {
   value: "Lindsay (USLSY)",
   label: "Lindsay (USLSY)"
  },
  {
   value: "Lindsay (USLZK)",
   label: "Lindsay (USLZK)"
  },
  {
   value: "Lindsborg (USLDB)",
   label: "Lindsborg (USLDB)"
  },
  {
   value: "Lineville (USLNV)",
   label: "Lineville (USLNV)"
  },
  {
   value: "Linn (USLNJ)",
   label: "Linn (USLNJ)"
  },
  {
   value: "Linthicum (USLNM)",
   label: "Linthicum (USLNM)"
  },
  {
   value: "Linthicum Heights (USLTU)",
   label: "Linthicum Heights (USLTU)"
  },
  {
   value: "Linwood (USLYW)",
   label: "Linwood (USLYW)"
  },
  {
   value: "Linwood (USLNZ)",
   label: "Linwood (USLNZ)"
  },
  {
   value: "Linwood (USLIW)",
   label: "Linwood (USLIW)"
  },
  {
   value: "Lionville (USLIN)",
   label: "Lionville (USLIN)"
  },
  {
   value: "Lisbon (USLJB)",
   label: "Lisbon (USLJB)"
  },
  {
   value: "Lisbon (USLZI)",
   label: "Lisbon (USLZI)"
  },
  {
   value: "Lisle (USLSA)",
   label: "Lisle (USLSA)"
  },
  {
   value: "Listerhill (USLIS)",
   label: "Listerhill (USLIS)"
  },
  {
   value: "Litchfield (USXHZ)",
   label: "Litchfield (USXHZ)"
  },
  {
   value: "Litchfield (USLTD)",
   label: "Litchfield (USLTD)"
  },
  {
   value: "Litchfield (USLHF)",
   label: "Litchfield (USLHF)"
  },
  {
   value: "Lithia Springs (USLTH)",
   label: "Lithia Springs (USLTH)"
  },
  {
   value: "Lithonia (USLIO)",
   label: "Lithonia (USLIO)"
  },
  {
   value: "Lititz (USLTI)",
   label: "Lititz (USLTI)"
  },
  {
   value: "Litiz (USLTP)",
   label: "Litiz (USLTP)"
  },
  {
   value: "Little Canada (USLCD)",
   label: "Little Canada (USLCD)"
  },
  {
   value: "Little Chute (USLTC)",
   label: "Little Chute (USLTC)"
  },
  {
   value: "Little Falls (USLFJ)",
   label: "Little Falls (USLFJ)"
  },
  {
   value: "Little Ferry (USLTF)",
   label: "Little Ferry (USLTF)"
  },
  {
   value: "Little Neck (USLYK)",
   label: "Little Neck (USLYK)"
  },
  {
   value: "Little Rock (USLIT)",
   label: "Little Rock (USLIT)"
  },
  {
   value: "Littlefield (USLIF)",
   label: "Littlefield (USLIF)"
  },
  {
   value: "Littleton (USLTL)",
   label: "Littleton (USLTL)"
  },
  {
   value: "Littleton (USLTO)",
   label: "Littleton (USLTO)"
  },
  {
   value: "Littleton (USLTN)",
   label: "Littleton (USLTN)"
  },
  {
   value: "Live Oak (USLOQ)",
   label: "Live Oak (USLOQ)"
  },
  {
   value: "Livermore (USLVK)",
   label: "Livermore (USLVK)"
  },
  {
   value: "Liverpool (USLVL)",
   label: "Liverpool (USLVL)"
  },
  {
   value: "Liverpool (USLII)",
   label: "Liverpool (USLII)"
  },
  {
   value: "Liverpool (USLVP)",
   label: "Liverpool (USLVP)"
  },
  {
   value: "Livingston (USLVG)",
   label: "Livingston (USLVG)"
  },
  {
   value: "Livingston (USLIX)",
   label: "Livingston (USLIX)"
  },
  {
   value: "Livingston (USLVY)",
   label: "Livingston (USLVY)"
  },
  {
   value: "Lexington (USLET)",
   label: "Lexington (USLET)"
  },
  {
   value: "Lexington (USLXG)",
   label: "Lexington (USLXG)"
  },
  {
   value: "Lexington (USLEL)",
   label: "Lexington (USLEL)"
  },
  {
   value: "Lexington (USLXN)",
   label: "Lexington (USLXN)"
  },
  {
   value: "Lexington (USLXI)",
   label: "Lexington (USLXI)"
  },
  {
   value: "Lexington (USLEX)",
   label: "Lexington (USLEX)"
  },
  {
   value: "Lexington (USLXT)",
   label: "Lexington (USLXT)"
  },
  {
   value: "Lexington (USLXH)",
   label: "Lexington (USLXH)"
  },
  {
   value: "Lexington (USLXM)",
   label: "Lexington (USLXM)"
  },
  {
   value: "Libby (USLBZ)",
   label: "Libby (USLBZ)"
  },
  {
   value: "Liberal (USLBL)",
   label: "Liberal (USLBL)"
  },
  {
   value: "Liberty (USLBI)",
   label: "Liberty (USLBI)"
  },
  {
   value: "Liberty (USLBY)",
   label: "Liberty (USLBY)"
  },
  {
   value: "Liberty (USLBX)",
   label: "Liberty (USLBX)"
  },
  {
   value: "Liberty Lake (USLLK)",
   label: "Liberty Lake (USLLK)"
  },
  {
   value: "Libertyville (USLBV)",
   label: "Libertyville (USLBV)"
  },
  {
   value: "Lightfoot (USXHM)",
   label: "Lightfoot (USXHM)"
  },
  {
   value: "Ligonier (USLGI)",
   label: "Ligonier (USLGI)"
  },
  {
   value: "Ligonier (USLIG)",
   label: "Ligonier (USLIG)"
  },
  {
   value: "Lihue (Kauai) (USLIH)",
   label: "Lihue (Kauai) (USLIH)"
  },
  {
   value: "Lilburn (USLLG)",
   label: "Lilburn (USLLG)"
  },
  {
   value: "Lillington (USLLL)",
   label: "Lillington (USLLL)"
  },
  {
   value: "Lima (USLIA)",
   label: "Lima (USLIA)"
  },
  {
   value: "Limestone (USLIZ)",
   label: "Limestone (USLIZ)"
  },
  {
   value: "Limon (USLIC)",
   label: "Limon (USLIC)"
  },
  {
   value: "Lincoln (USLCN)",
   label: "Lincoln (USLCN)"
  },
  {
   value: "Lincoln (USLLN)",
   label: "Lincoln (USLLN)"
  },
  {
   value: "Lincoln (USLCL)",
   label: "Lincoln (USLCL)"
  },
  {
   value: "Lincoln (USLNK)",
   label: "Lincoln (USLNK)"
  },
  {
   value: "Lincoln Center (USLCE)",
   label: "Lincoln Center (USLCE)"
  },
  {
   value: "Lincoln Park (USLPJ)",
   label: "Lincoln Park (USLPJ)"
  },
  {
   value: "Lincoln Park (USLIP)",
   label: "Lincoln Park (USLIP)"
  },
  {
   value: "Lincolnton (USLCT)",
   label: "Lincolnton (USLCT)"
  },
  {
   value: "Lincolnwood (USLCW)",
   label: "Lincolnwood (USLCW)"
  },
  {
   value: "Lindale (USLDL)",
   label: "Lindale (USLDL)"
  },
  {
   value: "Lindale (USLID)",
   label: "Lindale (USLID)"
  },
  {
   value: "Linden (USLDE)",
   label: "Linden (USLDE)"
  },
  {
   value: "Linden (USLDJ)",
   label: "Linden (USLDJ)"
  },
  {
   value: "Linden (USLYD)",
   label: "Linden (USLYD)"
  },
  {
   value: "Linden (USLNA)",
   label: "Linden (USLNA)"
  },
  {
   value: "Lindenhurst (USLDH)",
   label: "Lindenhurst (USLDH)"
  },
  {
   value: "Leesburg (USLES)",
   label: "Leesburg (USLES)"
  },
  {
   value: "Leesburg (USLSO)",
   label: "Leesburg (USLSO)"
  },
  {
   value: "Leesport (USLPO)",
   label: "Leesport (USLPO)"
  },
  {
   value: "Leesville (USUJZ)",
   label: "Leesville (USUJZ)"
  },
  {
   value: "Leesville (USLSV)",
   label: "Leesville (USLSV)"
  },
  {
   value: "Leetsdale (USLSL)",
   label: "Leetsdale (USLSL)"
  },
  {
   value: "Lehi (USLEI)",
   label: "Lehi (USLEI)"
  },
  {
   value: "Lehigh Valley (USLHO)",
   label: "Lehigh Valley (USLHO)"
  },
  {
   value: "Leicester (USLCM)",
   label: "Leicester (USLCM)"
  },
  {
   value: "Leighton (USLGT)",
   label: "Leighton (USLGT)"
  },
  {
   value: "Leipsic (USLPS)",
   label: "Leipsic (USLPS)"
  },
  {
   value: "Leitchfield (USLCF)",
   label: "Leitchfield (USLCF)"
  },
  {
   value: "Leland (USLLD)",
   label: "Leland (USLLD)"
  },
  {
   value: "Lemeta (USLMZ)",
   label: "Lemeta (USLMZ)"
  },
  {
   value: "Lemont (USLMJ)",
   label: "Lemont (USLMJ)"
  },
  {
   value: "Lemoyne (USLYP)",
   label: "Lemoyne (USLYP)"
  },
  {
   value: "Lena (USLEN)",
   label: "Lena (USLEN)"
  },
  {
   value: "Lena (USLWX)",
   label: "Lena (USLWX)"
  },
  {
   value: "Lenexa (USLXA)",
   label: "Lenexa (USLXA)"
  },
  {
   value: "Lennox (USLOX)",
   label: "Lennox (USLOX)"
  },
  {
   value: "Lenoir (USLER)",
   label: "Lenoir (USLER)"
  },
  {
   value: "Lenoir City (USLZZ)",
   label: "Lenoir City (USLZZ)"
  },
  {
   value: "Lenox (USLXK)",
   label: "Lenox (USLXK)"
  },
  {
   value: "Lenox (USLNX)",
   label: "Lenox (USLNX)"
  },
  {
   value: "Lenoy (USLEY)",
   label: "Lenoy (USLEY)"
  },
  {
   value: "Leola (USLLA)",
   label: "Leola (USLLA)"
  },
  {
   value: "Leominster (USLEM)",
   label: "Leominster (USLEM)"
  },
  {
   value: "Lester (USLEZ)",
   label: "Lester (USLEZ)"
  },
  {
   value: "Levelland (USLVD)",
   label: "Levelland (USLVD)"
  },
  {
   value: "Levittown (USLTT)",
   label: "Levittown (USLTT)"
  },
  {
   value: "Lewes (USLWP)",
   label: "Lewes (USLWP)"
  },
  {
   value: "Lewisberg (USLWQ)",
   label: "Lewisberg (USLWQ)"
  },
  {
   value: "Lewisburg (USLFQ)",
   label: "Lewisburg (USLFQ)"
  },
  {
   value: "Lewisburg (USLSB)",
   label: "Lewisburg (USLSB)"
  },
  {
   value: "Lewisburg (USLBU)",
   label: "Lewisburg (USLBU)"
  },
  {
   value: "Lewisburg (USLWB)",
   label: "Lewisburg (USLWB)"
  },
  {
   value: "Lewiston (USLWS)",
   label: "Lewiston (USLWS)"
  },
  {
   value: "Lewiston (USLUT)",
   label: "Lewiston (USLUT)"
  },
  {
   value: "Lewiston (USRED)",
   label: "Lewiston (USRED)"
  },
  {
   value: "Lewistown (USLWW)",
   label: "Lewistown (USLWW)"
  },
  {
   value: "Lewisville (USLWI)",
   label: "Lewisville (USLWI)"
  },
  {
   value: "Lewisville (USLJV)",
   label: "Lewisville (USLJV)"
  },
  {
   value: "Lawrence (USLWR)",
   label: "Lawrence (USLWR)"
  },
  {
   value: "Lawrence (USLWN)",
   label: "Lawrence (USLWN)"
  },
  {
   value: "Lawrenceburg (USLVU)",
   label: "Lawrenceburg (USLVU)"
  },
  {
   value: "Lawrenceburg (USXHH)",
   label: "Lawrenceburg (USXHH)"
  },
  {
   value: "Lawrenceburg (USLAQ)",
   label: "Lawrenceburg (USLAQ)"
  },
  {
   value: "Lawrenceville (USLWV)",
   label: "Lawrenceville (USLWV)"
  },
  {
   value: "Lawrenceville (USLAV)",
   label: "Lawrenceville (USLAV)"
  },
  {
   value: "Lawrenceville (USLRV)",
   label: "Lawrenceville (USLRV)"
  },
  {
   value: "Lawton (USLAW)",
   label: "Lawton (USLAW)"
  },
  {
   value: "Le Compte (USLCG)",
   label: "Le Compte (USLCG)"
  },
  {
   value: "Le Mont (USLMD)",
   label: "Le Mont (USLMD)"
  },
  {
   value: "Le Roy (USUQG)",
   label: "Le Roy (USUQG)"
  },
  {
   value: "Le Suer (USUQA)",
   label: "Le Suer (USUQA)"
  },
  {
   value: "Le Sueur (USLUU)",
   label: "Le Sueur (USLUU)"
  },
  {
   value: "Leadville (USLXV)",
   label: "Leadville (USLXV)"
  },
  {
   value: "Leander (USLEA)",
   label: "Leander (USLEA)"
  },
  {
   value: "Leavenworth (USXIA)",
   label: "Leavenworth (USXIA)"
  },
  {
   value: "Leavenworth (USLVN)",
   label: "Leavenworth (USLVN)"
  },
  {
   value: "Leavittsburg (USLVX)",
   label: "Leavittsburg (USLVX)"
  },
  {
   value: "Leawood (USLWK)",
   label: "Leawood (USLWK)"
  },
  {
   value: "Lebanon (USLBO)",
   label: "Lebanon (USLBO)"
  },
  {
   value: "Lebanon (USLBD)",
   label: "Lebanon (USLBD)"
  },
  {
   value: "Lebanon (USLFA)",
   label: "Lebanon (USLFA)"
  },
  {
   value: "Lebanon (USLBM)",
   label: "Lebanon (USLBM)"
  },
  {
   value: "Lebanon (USLEB)",
   label: "Lebanon (USLEB)"
  },
  {
   value: "Lebanon (USXHL)",
   label: "Lebanon (USXHL)"
  },
  {
   value: "Lebanon (USLNB)",
   label: "Lebanon (USLNB)"
  },
  {
   value: "Lebanon (USLON)",
   label: "Lebanon (USLON)"
  },
  {
   value: "Lebanon (USLBP)",
   label: "Lebanon (USLBP)"
  },
  {
   value: "Lebanon (USLBN)",
   label: "Lebanon (USLBN)"
  },
  {
   value: "Lecompte (USLCP)",
   label: "Lecompte (USLCP)"
  },
  {
   value: "Ledgewood (USLWO)",
   label: "Ledgewood (USLWO)"
  },
  {
   value: "Lee (USLEH)",
   label: "Lee (USLEH)"
  },
  {
   value: "Lee's Summit (USLSM)",
   label: "Lee's Summit (USLSM)"
  },
  {
   value: "Leechburg (USLEC)",
   label: "Leechburg (USLEC)"
  },
  {
   value: "Leeds (USLDS)",
   label: "Leeds (USLDS)"
  },
  {
   value: "Leeds (USXHK)",
   label: "Leeds (USXHK)"
  },
  {
   value: "Leeds (USLED)",
   label: "Leeds (USLED)"
  },
  {
   value: "Lees Summit (USLSU)",
   label: "Lees Summit (USLSU)"
  },
  {
   value: "Leesburg (USLZG)",
   label: "Leesburg (USLZG)"
  },
  {
   value: "Leesburg (USLEE)",
   label: "Leesburg (USLEE)"
  },
  {
   value: "Landover (USLDR)",
   label: "Landover (USLDR)"
  },
  {
   value: "Landsdowne (USLAZ)",
   label: "Landsdowne (USLAZ)"
  },
  {
   value: "Lanett (USLTE)",
   label: "Lanett (USLTE)"
  },
  {
   value: "Langeloth (USLHH)",
   label: "Langeloth (USLHH)"
  },
  {
   value: "Langhorne (USXHS)",
   label: "Langhorne (USXHS)"
  },
  {
   value: "Langley (USLGY)",
   label: "Langley (USLGY)"
  },
  {
   value: "Langley (USLGL)",
   label: "Langley (USLGL)"
  },
  {
   value: "Langsville (USXIB)",
   label: "Langsville (USXIB)"
  },
  {
   value: "Lanham (USLME)",
   label: "Lanham (USLME)"
  },
  {
   value: "Lansdale (USLSD)",
   label: "Lansdale (USLSD)"
  },
  {
   value: "Lansdale (USLND)",
   label: "Lansdale (USLND)"
  },
  {
   value: "Lansdowne (USLDW)",
   label: "Lansdowne (USLDW)"
  },
  {
   value: "Lansford (USLZP)",
   label: "Lansford (USLZP)"
  },
  {
   value: "Lansing (USLSI)",
   label: "Lansing (USLSI)"
  },
  {
   value: "Lansing (USLNI)",
   label: "Lansing (USLNI)"
  },
  {
   value: "Lansing (USLAN)",
   label: "Lansing (USLAN)"
  },
  {
   value: "Lansing (USLNP)",
   label: "Lansing (USLNP)"
  },
  {
   value: "Lantana (USLNT)",
   label: "Lantana (USLNT)"
  },
  {
   value: "Laona (USLNU)",
   label: "Laona (USLNU)"
  },
  {
   value: "Lapoint (USLPI)",
   label: "Lapoint (USLPI)"
  },
  {
   value: "Laramie (USLAR)",
   label: "Laramie (USLAR)"
  },
  {
   value: "Laredo (USLRD)",
   label: "Laredo (USLRD)"
  },
  {
   value: "Largo (USXHV)",
   label: "Largo (USXHV)"
  },
  {
   value: "Larose (USLRS)",
   label: "Larose (USLRS)"
  },
  {
   value: "Larson Bay (USLBA)",
   label: "Larson Bay (USLBA)"
  },
  {
   value: "Las Cruces (USLRU)",
   label: "Las Cruces (USLRU)"
  },
  {
   value: "Las Vegas (USLAS)",
   label: "Las Vegas (USLAS)"
  },
  {
   value: "Latham (USLTM)",
   label: "Latham (USLTM)"
  },
  {
   value: "Lathan (USLTY)",
   label: "Lathan (USLTY)"
  },
  {
   value: "Lathrop (USLRO)",
   label: "Lathrop (USLRO)"
  },
  {
   value: "Lauderhill (USLAD)",
   label: "Lauderhill (USLAD)"
  },
  {
   value: "Laurel (USLRM)",
   label: "Laurel (USLRM)"
  },
  {
   value: "Laurel (USLUL)",
   label: "Laurel (USLUL)"
  },
  {
   value: "Laurens (USLUS)",
   label: "Laurens (USLUS)"
  },
  {
   value: "Laurens (USLOZ)",
   label: "Laurens (USLOZ)"
  },
  {
   value: "Laurens (USLSC)",
   label: "Laurens (USLSC)"
  },
  {
   value: "Laurier (USLAU)",
   label: "Laurier (USLAU)"
  },
  {
   value: "Laurinburg (USLRB)",
   label: "Laurinburg (USLRB)"
  },
  {
   value: "Lavaca (USLVC)",
   label: "Lavaca (USLVC)"
  },
  {
   value: "Lawndale (USLWJ)",
   label: "Lawndale (USLWJ)"
  },
  {
   value: "Lawrence (USLWC)",
   label: "Lawrence (USLWC)"
  },
  {
   value: "Lawrence (USLWE)",
   label: "Lawrence (USLWE)"
  },
  {
   value: "Lake Odessa (USLQO)",
   label: "Lake Odessa (USLQO)"
  },
  {
   value: "Lake Oswego (USLOO)",
   label: "Lake Oswego (USLOO)"
  },
  {
   value: "Lake Placid (USLPF)",
   label: "Lake Placid (USLPF)"
  },
  {
   value: "Lake Success (USLKS)",
   label: "Lake Success (USLKS)"
  },
  {
   value: "Lake Villa (USVIL)",
   label: "Lake Villa (USVIL)"
  },
  {
   value: "Lake Wales (USLWA)",
   label: "Lake Wales (USLWA)"
  },
  {
   value: "Lake Winola (USLXJ)",
   label: "Lake Winola (USLXJ)"
  },
  {
   value: "Lake Worth (USLWH)",
   label: "Lake Worth (USLWH)"
  },
  {
   value: "Lake Zurich (USLKZ)",
   label: "Lake Zurich (USLKZ)"
  },
  {
   value: "Lakehurst (USNEL)",
   label: "Lakehurst (USNEL)"
  },
  {
   value: "Lakeland (USLAL)",
   label: "Lakeland (USLAL)"
  },
  {
   value: "Lakemills (USLMW)",
   label: "Lakemills (USLMW)"
  },
  {
   value: "Lakeport (USLKP)",
   label: "Lakeport (USLKP)"
  },
  {
   value: "Lakeview (USLQW)",
   label: "Lakeview (USLQW)"
  },
  {
   value: "Lakeview (USLKV)",
   label: "Lakeview (USLKV)"
  },
  {
   value: "Lakeview (USLKX)",
   label: "Lakeview (USLKX)"
  },
  {
   value: "Lakeview (USLVE)",
   label: "Lakeview (USLVE)"
  },
  {
   value: "Lakeview (USLVW)",
   label: "Lakeview (USLVW)"
  },
  {
   value: "Lakeville (USLQV)",
   label: "Lakeville (USLQV)"
  },
  {
   value: "Lakeville (USLKK)",
   label: "Lakeville (USLKK)"
  },
  {
   value: "Lakeville (USLVA)",
   label: "Lakeville (USLVA)"
  },
  {
   value: "Lakewood (USLKY)",
   label: "Lakewood (USLKY)"
  },
  {
   value: "Lakewood (USLQQ)",
   label: "Lakewood (USLQQ)"
  },
  {
   value: "Lakewood (USLJK)",
   label: "Lakewood (USLJK)"
  },
  {
   value: "Lakewood (USLWG)",
   label: "Lakewood (USLWG)"
  },
  {
   value: "Lakewood (USLKW)",
   label: "Lakewood (USLKW)"
  },
  {
   value: "Lamar (USLAA)",
   label: "Lamar (USLAA)"
  },
  {
   value: "Lamar (USLDF)",
   label: "Lamar (USLDF)"
  },
  {
   value: "Lambertville (USLMV)",
   label: "Lambertville (USLMV)"
  },
  {
   value: "Lamesa (USXHG)",
   label: "Lamesa (USXHG)"
  },
  {
   value: "Lanai (USLNH)",
   label: "Lanai (USLNH)"
  },
  {
   value: "Lancaster (USWJF)",
   label: "Lancaster (USWJF)"
  },
  {
   value: "Lancaster (USUQE)",
   label: "Lancaster (USUQE)"
  },
  {
   value: "Lancaster (USLNC)",
   label: "Lancaster (USLNC)"
  },
  {
   value: "Lancaster (USLNS)",
   label: "Lancaster (USLNS)"
  },
  {
   value: "Lancaster (USLNW)",
   label: "Lancaster (USLNW)"
  },
  {
   value: "Lancaster (USLTX)",
   label: "Lancaster (USLTX)"
  },
  {
   value: "Land O' Lakes (USLOL)",
   label: "Land O' Lakes (USLOL)"
  },
  {
   value: "Landis (USLFD)",
   label: "Landis (USLFD)"
  },
  {
   value: "Landisville (USLDV)",
   label: "Landisville (USLDV)"
  },
  {
   value: "Lando (USLNO)",
   label: "Lando (USLNO)"
  },
  {
   value: "La Place (USLPL)",
   label: "La Place (USLPL)"
  },
  {
   value: "La Plata (USLAP)",
   label: "La Plata (USLAP)"
  },
  {
   value: "La Porte (USLAO)",
   label: "La Porte (USLAO)"
  },
  {
   value: "La Porte (USUQF)",
   label: "La Porte (USUQF)"
  },
  {
   value: "La Puente (USLVR)",
   label: "La Puente (USLVR)"
  },
  {
   value: "La Salle (USUJY)",
   label: "La Salle (USUJY)"
  },
  {
   value: "La Vergne (USLVV)",
   label: "La Vergne (USLVV)"
  },
  {
   value: "La Verne (USPOC)",
   label: "La Verne (USPOC)"
  },
  {
   value: "Lacey (USLAY)",
   label: "Lacey (USLAY)"
  },
  {
   value: "Lackawana (USXHP)",
   label: "Lackawana (USXHP)"
  },
  {
   value: "Ladd (USLDD)",
   label: "Ladd (USLDD)"
  },
  {
   value: "Ladonia (USLDX)",
   label: "Ladonia (USLDX)"
  },
  {
   value: "Ladson (USLDC)",
   label: "Ladson (USLDC)"
  },
  {
   value: "Ladson (USLDZ)",
   label: "Ladson (USLDZ)"
  },
  {
   value: "Lady Lake (USLAK)",
   label: "Lady Lake (USLAK)"
  },
  {
   value: "Lafayette (USLZX)",
   label: "Lafayette (USLZX)"
  },
  {
   value: "Lafayette (USLFG)",
   label: "Lafayette (USLFG)"
  },
  {
   value: "Lafayette (USLAF)",
   label: "Lafayette (USLAF)"
  },
  {
   value: "Lafayette (USLFT)",
   label: "Lafayette (USLFT)"
  },
  {
   value: "Lafayette (USLFW)",
   label: "Lafayette (USLFW)"
  },
  {
   value: "Lafayette (USLQJ)",
   label: "Lafayette (USLQJ)"
  },
  {
   value: "Laflin (USLFP)",
   label: "Laflin (USLFP)"
  },
  {
   value: "Lagrange (USLGN)",
   label: "Lagrange (USLGN)"
  },
  {
   value: "Laguna Beach (USLBE)",
   label: "Laguna Beach (USLBE)"
  },
  {
   value: "Laguna Hills (USLHI)",
   label: "Laguna Hills (USLHI)"
  },
  {
   value: "Laguna Miguel (USLMG)",
   label: "Laguna Miguel (USLMG)"
  },
  {
   value: "Lahaina (USLHN)",
   label: "Lahaina (USLHN)"
  },
  {
   value: "Lake Alfred (USLKA)",
   label: "Lake Alfred (USLKA)"
  },
  {
   value: "Lake Bluff (USLBC)",
   label: "Lake Bluff (USLBC)"
  },
  {
   value: "Lake Charles (USLCH)",
   label: "Lake Charles (USLCH)"
  },
  {
   value: "Lake City (USLKB)",
   label: "Lake City (USLKB)"
  },
  {
   value: "Lake City (USXHJ)",
   label: "Lake City (USXHJ)"
  },
  {
   value: "Lake City (USLKC)",
   label: "Lake City (USLKC)"
  },
  {
   value: "Lake Forest (USLFR)",
   label: "Lake Forest (USLFR)"
  },
  {
   value: "Lake Forest Park (USLPK)",
   label: "Lake Forest Park (USLPK)"
  },
  {
   value: "Lake Geneva (USXES)",
   label: "Lake Geneva (USXES)"
  },
  {
   value: "Lake Hamilton (USLHM)",
   label: "Lake Hamilton (USLHM)"
  },
  {
   value: "Lake Harbor (USLKH)",
   label: "Lake Harbor (USLKH)"
  },
  {
   value: "Lake Mary (USLKM)",
   label: "Lake Mary (USLKM)"
  },
  {
   value: "Lake Mills (USXHQ)",
   label: "Lake Mills (USXHQ)"
  },
  {
   value: "Kingston (USA) (USKSN)",
   label: "Kingston (USA) (USKSN)"
  },
  {
   value: "Kingstree (USKGS)",
   label: "Kingstree (USKGS)"
  },
  {
   value: "Kingsville (USNQI)",
   label: "Kingsville (USNQI)"
  },
  {
   value: "Kingswood (USKIW)",
   label: "Kingswood (USKIW)"
  },
  {
   value: "Kingwood (USKGD)",
   label: "Kingwood (USKGD)"
  },
  {
   value: "Kinnelon (USUJX)",
   label: "Kinnelon (USUJX)"
  },
  {
   value: "Kinston (USISO)",
   label: "Kinston (USISO)"
  },
  {
   value: "Kinwood (USKIO)",
   label: "Kinwood (USKIO)"
  },
  {
   value: "Kirkland (USXHF)",
   label: "Kirkland (USXHF)"
  },
  {
   value: "Kirksville (USIRK)",
   label: "Kirksville (USIRK)"
  },
  {
   value: "Kissimmee (USISM)",
   label: "Kissimmee (USISM)"
  },
  {
   value: "Kittanning (USKTG)",
   label: "Kittanning (USKTG)"
  },
  {
   value: "Klamath Falls (USLMT)",
   label: "Klamath Falls (USLMT)"
  },
  {
   value: "Klawock (USKLW)",
   label: "Klawock (USKLW)"
  },
  {
   value: "Knox (USKNX)",
   label: "Knox (USKNX)"
  },
  {
   value: "Knoxville (USTYS)",
   label: "Knoxville (USTYS)"
  },
  {
   value: "Kodiak (USADQ)",
   label: "Kodiak (USADQ)"
  },
  {
   value: "Kohler (USKOR)",
   label: "Kohler (USKOR)"
  },
  {
   value: "Kokomo (USOKK)",
   label: "Kokomo (USOKK)"
  },
  {
   value: "Kosciusko (USOSX)",
   label: "Kosciusko (USOSX)"
  },
  {
   value: "Kosse (USKST)",
   label: "Kosse (USKST)"
  },
  {
   value: "Kreamer (USKRP)",
   label: "Kreamer (USKRP)"
  },
  {
   value: "Kulpsville (USKUP)",
   label: "Kulpsville (USKUP)"
  },
  {
   value: "Kuparuk (USUUK)",
   label: "Kuparuk (USUUK)"
  },
  {
   value: "L'Anse (USLAJ)",
   label: "L'Anse (USLAJ)"
  },
  {
   value: "La Belle (USLFL)",
   label: "La Belle (USLFL)"
  },
  {
   value: "La Canada (USLCA)",
   label: "La Canada (USLCA)"
  },
  {
   value: "La Conner (USXHI)",
   label: "La Conner (USXHI)"
  },
  {
   value: "La Crescenta (USLCR)",
   label: "La Crescenta (USLCR)"
  },
  {
   value: "La Crosse (USLSE)",
   label: "La Crosse (USLSE)"
  },
  {
   value: "La Feria (USLFX)",
   label: "La Feria (USLFX)"
  },
  {
   value: "La Follette (USLFO)",
   label: "La Follette (USLFO)"
  },
  {
   value: "La Grande (USLGD)",
   label: "La Grande (USLGD)"
  },
  {
   value: "La Grange (USLGX)",
   label: "La Grange (USLGX)"
  },
  {
   value: "La Grange (USLGC)",
   label: "La Grange (USLGC)"
  },
  {
   value: "La Grange (USLAI)",
   label: "La Grange (USLAI)"
  },
  {
   value: "La Guardia Apt\/New York (USLGA)",
   label: "La Guardia Apt\/New York (USLGA)"
  },
  {
   value: "La Habra (USLHB)",
   label: "La Habra (USLHB)"
  },
  {
   value: "La Junta (USLJH)",
   label: "La Junta (USLJH)"
  },
  {
   value: "La Mirada (USLMI)",
   label: "La Mirada (USLMI)"
  },
  {
   value: "La Palma (USLPA)",
   label: "La Palma (USLPA)"
  },
  {
   value: "Keokuk (USEOK)",
   label: "Keokuk (USEOK)"
  },
  {
   value: "Kerman (USKMQ)",
   label: "Kerman (USKMQ)"
  },
  {
   value: "Kernersville (USKRN)",
   label: "Kernersville (USKRN)"
  },
  {
   value: "Kerrville (USERV)",
   label: "Kerrville (USERV)"
  },
  {
   value: "Kershaw (USKRW)",
   label: "Kershaw (USKRW)"
  },
  {
   value: "Ketchikan (USKTN)",
   label: "Ketchikan (USKTN)"
  },
  {
   value: "Kettering (USKTR)",
   label: "Kettering (USKTR)"
  },
  {
   value: "Kewanee (USKEW)",
   label: "Kewanee (USKEW)"
  },
  {
   value: "Kewaskum (USKWI)",
   label: "Kewaskum (USKWI)"
  },
  {
   value: "Key Biscayne (USKBS)",
   label: "Key Biscayne (USKBS)"
  },
  {
   value: "Key West (USEYW)",
   label: "Key West (USEYW)"
  },
  {
   value: "Keyport (USKEY)",
   label: "Keyport (USKEY)"
  },
  {
   value: "Kidron (USKID)",
   label: "Kidron (USKID)"
  },
  {
   value: "Killbuck (USKKH)",
   label: "Killbuck (USKKH)"
  },
  {
   value: "Killeen (USILE)",
   label: "Killeen (USILE)"
  },
  {
   value: "Killingly (USKIL)",
   label: "Killingly (USKIL)"
  },
  {
   value: "Kiln (USKIU)",
   label: "Kiln (USKIU)"
  },
  {
   value: "Kimberly (USKIY)",
   label: "Kimberly (USKIY)"
  },
  {
   value: "Kimberly (USKBL)",
   label: "Kimberly (USKBL)"
  },
  {
   value: "Kimberton (USKIM)",
   label: "Kimberton (USKIM)"
  },
  {
   value: "King (USKIG)",
   label: "King (USKIG)"
  },
  {
   value: "King City (USKIC)",
   label: "King City (USKIC)"
  },
  {
   value: "King City (USKCY)",
   label: "King City (USKCY)"
  },
  {
   value: "King Cove (USKVC)",
   label: "King Cove (USKVC)"
  },
  {
   value: "Kingman (USIGM)",
   label: "Kingman (USIGM)"
  },
  {
   value: "Kingman (USKNG)",
   label: "Kingman (USKNG)"
  },
  {
   value: "Kings Bay (USKBA)",
   label: "Kings Bay (USKBA)"
  },
  {
   value: "Kings Beach (USKBJ)",
   label: "Kings Beach (USKBJ)"
  },
  {
   value: "Kings Creek (USKCS)",
   label: "Kings Creek (USKCS)"
  },
  {
   value: "Kings Mountain (USKIN)",
   label: "Kings Mountain (USKIN)"
  },
  {
   value: "Kingsburg (USKBG)",
   label: "Kingsburg (USKBG)"
  },
  {
   value: "Kingsmountain (USKMT)",
   label: "Kingsmountain (USKMT)"
  },
  {
   value: "Kingsport-Johnson City Apt (USTRI)",
   label: "Kingsport-Johnson City Apt (USTRI)"
  },
  {
   value: "Kingston (USKGN)",
   label: "Kingston (USKGN)"
  },
  {
   value: "Kingston (USKIT)",
   label: "Kingston (USKIT)"
  },
  {
   value: "Kingston (USKNJ)",
   label: "Kingston (USKNJ)"
  },
  {
   value: "Kingston (USKGT)",
   label: "Kingston (USKGT)"
  },
  {
   value: "Kingston (USKNS)",
   label: "Kingston (USKNS)"
  },
  {
   value: "Kingston (USKTQ)",
   label: "Kingston (USKTQ)"
  },
  {
   value: "Kingston (USKGX)",
   label: "Kingston (USKGX)"
  },
  {
   value: "Kawaihae (USKWH)",
   label: "Kawaihae (USKWH)"
  },
  {
   value: "Kearne (USXHD)",
   label: "Kearne (USXHD)"
  },
  {
   value: "Kearney (USEAR)",
   label: "Kearney (USEAR)"
  },
  {
   value: "Kearney (USKER)",
   label: "Kearney (USKER)"
  },
  {
   value: "Kearney (USKYE)",
   label: "Kearney (USKYE)"
  },
  {
   value: "Kearny (USXHE)",
   label: "Kearny (USXHE)"
  },
  {
   value: "Keasbey (USKEA)",
   label: "Keasbey (USKEA)"
  },
  {
   value: "Keenan (USKNA)",
   label: "Keenan (USKNA)"
  },
  {
   value: "Keller (USKEX)",
   label: "Keller (USKEX)"
  },
  {
   value: "Kellogg (USKGI)",
   label: "Kellogg (USKGI)"
  },
  {
   value: "Kellogg (USKLO)",
   label: "Kellogg (USKLO)"
  },
  {
   value: "Kelso (USKLS)",
   label: "Kelso (USKLS)"
  },
  {
   value: "Kenai (USENA)",
   label: "Kenai (USENA)"
  },
  {
   value: "Kenansville (USKNV)",
   label: "Kenansville (USKNV)"
  },
  {
   value: "Kenbridge (USKEG)",
   label: "Kenbridge (USKEG)"
  },
  {
   value: "Kendall (USKDL)",
   label: "Kendall (USKDL)"
  },
  {
   value: "Kendall (USKLL)",
   label: "Kendall (USKLL)"
  },
  {
   value: "Kendallville (USKDV)",
   label: "Kendallville (USKDV)"
  },
  {
   value: "Kendrick (USKDR)",
   label: "Kendrick (USKDR)"
  },
  {
   value: "Kenedy (USKDY)",
   label: "Kenedy (USKDY)"
  },
  {
   value: "Kenilworth (USKWT)",
   label: "Kenilworth (USKWT)"
  },
  {
   value: "Kenmore Air Harbor (USAAY)",
   label: "Kenmore Air Harbor (USAAY)"
  },
  {
   value: "Kennebunk (USKBN)",
   label: "Kennebunk (USKBN)"
  },
  {
   value: "Kennedale (USKED)",
   label: "Kennedale (USKED)"
  },
  {
   value: "Kenner (USKES)",
   label: "Kenner (USKES)"
  },
  {
   value: "Kennesaw (USKSW)",
   label: "Kennesaw (USKSW)"
  },
  {
   value: "Kennett (USKNT)",
   label: "Kennett (USKNT)"
  },
  {
   value: "Kennett Square (USKNN)",
   label: "Kennett Square (USKNN)"
  },
  {
   value: "Kennewick (USKWK)",
   label: "Kennewick (USKWK)"
  },
  {
   value: "Kenosha (USENW)",
   label: "Kenosha (USENW)"
  },
  {
   value: "Kenova (USKVA)",
   label: "Kenova (USKVA)"
  },
  {
   value: "Kensington (USKTP)",
   label: "Kensington (USKTP)"
  },
  {
   value: "Kensington (USKGZ)",
   label: "Kensington (USKGZ)"
  },
  {
   value: "Kent (USKTO)",
   label: "Kent (USKTO)"
  },
  {
   value: "Kent (USKET)",
   label: "Kent (USKET)"
  },
  {
   value: "Kentland (USKKT)",
   label: "Kentland (USKKT)"
  },
  {
   value: "Kenton (USKTH)",
   label: "Kenton (USKTH)"
  },
  {
   value: "Kenton (USKYO)",
   label: "Kenton (USKYO)"
  },
  {
   value: "Kenton (USKNQ)",
   label: "Kenton (USKNQ)"
  },
  {
   value: "Kentwood (USKNU)",
   label: "Kentwood (USKNU)"
  },
  {
   value: "Kentwood (USKWD)",
   label: "Kentwood (USKWD)"
  },
  {
   value: "Kenyon (USKYN)",
   label: "Kenyon (USKYN)"
  },
  {
   value: "Jonesboro (USJOO)",
   label: "Jonesboro (USJOO)"
  },
  {
   value: "Jonesboro (USJBR)",
   label: "Jonesboro (USJBR)"
  },
  {
   value: "Jonesport (USJON)",
   label: "Jonesport (USJON)"
  },
  {
   value: "Jonesville (USJOE)",
   label: "Jonesville (USJOE)"
  },
  {
   value: "Jonesville (USJOV)",
   label: "Jonesville (USJOV)"
  },
  {
   value: "Jonesville (USJLX)",
   label: "Jonesville (USJLX)"
  },
  {
   value: "Joplin (USJLN)",
   label: "Joplin (USJLN)"
  },
  {
   value: "Joppa (USJOP)",
   label: "Joppa (USJOP)"
  },
  {
   value: "Josephtown (USJTN)",
   label: "Josephtown (USJTN)"
  },
  {
   value: "Joslin (USJSL)",
   label: "Joslin (USJSL)"
  },
  {
   value: "Junction (USJCT)",
   label: "Junction (USJCT)"
  },
  {
   value: "Junction City (USJCC)",
   label: "Junction City (USJCC)"
  },
  {
   value: "Juneau (USUNU)",
   label: "Juneau (USUNU)"
  },
  {
   value: "Juneau (USJNU)",
   label: "Juneau (USJNU)"
  },
  {
   value: "Jupiter (USJPT)",
   label: "Jupiter (USJPT)"
  },
  {
   value: "Kahului (USOGG)",
   label: "Kahului (USOGG)"
  },
  {
   value: "Kailua (Maui) (USKUI)",
   label: "Kailua (Maui) (USKUI)"
  },
  {
   value: "Kailua (Oahu) (USKQO)",
   label: "Kailua (Oahu) (USKQO)"
  },
  {
   value: "Kailua Kona (USKHH)",
   label: "Kailua Kona (USKHH)"
  },
  {
   value: "Kake (USKAE)",
   label: "Kake (USKAE)"
  },
  {
   value: "Kalama (USKAL)",
   label: "Kalama (USKAL)"
  },
  {
   value: "Kalamazoo (USKLZ)",
   label: "Kalamazoo (USKLZ)"
  },
  {
   value: "Kalida (USKLD)",
   label: "Kalida (USKLD)"
  },
  {
   value: "Kalispell (USFCA)",
   label: "Kalispell (USFCA)"
  },
  {
   value: "Kane (USKAN)",
   label: "Kane (USKAN)"
  },
  {
   value: "Kaneohe (USKEH)",
   label: "Kaneohe (USKEH)"
  },
  {
   value: "Kaneville (USKAV)",
   label: "Kaneville (USKAV)"
  },
  {
   value: "Kankakee (USIKK)",
   label: "Kankakee (USIKK)"
  },
  {
   value: "Kannapolis (USKNP)",
   label: "Kannapolis (USKNP)"
  },
  {
   value: "Kanova (USKAA)",
   label: "Kanova (USKAA)"
  },
  {
   value: "Kansas City (USKCK)",
   label: "Kansas City (USKCK)"
  },
  {
   value: "Kansas City (USMKC)",
   label: "Kansas City (USMKC)"
  },
  {
   value: "Kaplan (USKPL)",
   label: "Kaplan (USKPL)"
  },
  {
   value: "Karns City (USKCZ)",
   label: "Karns City (USKCZ)"
  },
  {
   value: "Karthaus (USKHX)",
   label: "Karthaus (USKHX)"
  },
  {
   value: "Kasilof (USKFO)",
   label: "Kasilof (USKFO)"
  },
  {
   value: "Kasitna Bay (USKAS)",
   label: "Kasitna Bay (USKAS)"
  },
  {
   value: "Katonah (USKAT)",
   label: "Katonah (USKAT)"
  },
  {
   value: "Katy (USKTX)",
   label: "Katy (USKTX)"
  },
  {
   value: "Kaukauna (USKAU)",
   label: "Kaukauna (USKAU)"
  },
  {
   value: "Kaunakakai (Molokai) (USKKA)",
   label: "Kaunakakai (Molokai) (USKKA)"
  },
  {
   value: "Jefferson (USEFW)",
   label: "Jefferson (USEFW)"
  },
  {
   value: "Jefferson (USJFE)",
   label: "Jefferson (USJFE)"
  },
  {
   value: "Jefferson (USJFF)",
   label: "Jefferson (USJFF)"
  },
  {
   value: "Jefferson (USJFL)",
   label: "Jefferson (USJFL)"
  },
  {
   value: "Jefferson (USJFN)",
   label: "Jefferson (USJFN)"
  },
  {
   value: "Jefferson (USJFS)",
   label: "Jefferson (USJFS)"
  },
  {
   value: "Jefferson City (USJEF)",
   label: "Jefferson City (USJEF)"
  },
  {
   value: "Jefferson City (USJCN)",
   label: "Jefferson City (USJCN)"
  },
  {
   value: "Jefferson Island (USJED)",
   label: "Jefferson Island (USJED)"
  },
  {
   value: "Jefferson Junction (USJFJ)",
   label: "Jefferson Junction (USJFJ)"
  },
  {
   value: "Jeffersontown (USJET)",
   label: "Jeffersontown (USJET)"
  },
  {
   value: "Jeffersonville (USJEE)",
   label: "Jeffersonville (USJEE)"
  },
  {
   value: "Jeffersonville (USJEV)",
   label: "Jeffersonville (USJEV)"
  },
  {
   value: "Jeffersonville (USJFV)",
   label: "Jeffersonville (USJFV)"
  },
  {
   value: "Jenkintown (USJKT)",
   label: "Jenkintown (USJKT)"
  },
  {
   value: "Jennings (USJLA)",
   label: "Jennings (USJLA)"
  },
  {
   value: "Jericho (USJRI)",
   label: "Jericho (USJRI)"
  },
  {
   value: "Jerome (USJER)",
   label: "Jerome (USJER)"
  },
  {
   value: "Jerome (USJRM)",
   label: "Jerome (USJRM)"
  },
  {
   value: "Jersey City (USJEC)",
   label: "Jersey City (USJEC)"
  },
  {
   value: "Jessup (USXHB)",
   label: "Jessup (USXHB)"
  },
  {
   value: "Jessup (USJEP)",
   label: "Jessup (USJEP)"
  },
  {
   value: "Jesup (USJES)",
   label: "Jesup (USJES)"
  },
  {
   value: "Jewett (USJTT)",
   label: "Jewett (USJTT)"
  },
  {
   value: "Jewett City (USJWT)",
   label: "Jewett City (USJWT)"
  },
  {
   value: "Jobos (USJOB)",
   label: "Jobos (USJOB)"
  },
  {
   value: "John F. Kennedy Apt\/New York (USJFK)",
   label: "John F. Kennedy Apt\/New York (USJFK)"
  },
  {
   value: "Johns Island (USJIS)",
   label: "Johns Island (USJIS)"
  },
  {
   value: "Johnson (USJNY)",
   label: "Johnson (USJNY)"
  },
  {
   value: "Johnson City (USJOH)",
   label: "Johnson City (USJOH)"
  },
  {
   value: "Johnson City (USJCY)",
   label: "Johnson City (USJCY)"
  },
  {
   value: "Johnson Creek (USXHC)",
   label: "Johnson Creek (USXHC)"
  },
  {
   value: "Johnsonburg (USJHB)",
   label: "Johnsonburg (USJHB)"
  },
  {
   value: "Johnsonville (USJHV)",
   label: "Johnsonville (USJHV)"
  },
  {
   value: "Johnston (USJHN)",
   label: "Johnston (USJHN)"
  },
  {
   value: "Johnston (USJOS)",
   label: "Johnston (USJOS)"
  },
  {
   value: "Johnstown (USJTW)",
   label: "Johnstown (USJTW)"
  },
  {
   value: "Johnstown (USJST)",
   label: "Johnstown (USJST)"
  },
  {
   value: "Joliet (USJOT)",
   label: "Joliet (USJOT)"
  },
  {
   value: "Isola (USISA)",
   label: "Isola (USISA)"
  },
  {
   value: "Issaquah (USISQ)",
   label: "Issaquah (USISQ)"
  },
  {
   value: "Ita Stewart (USITW)",
   label: "Ita Stewart (USITW)"
  },
  {
   value: "Itasca (USITS)",
   label: "Itasca (USITS)"
  },
  {
   value: "Ithaca (USITH)",
   label: "Ithaca (USITH)"
  },
  {
   value: "Itta Bena (USIBA)",
   label: "Itta Bena (USIBA)"
  },
  {
   value: "Ivanhoe (USIVO)",
   label: "Ivanhoe (USIVO)"
  },
  {
   value: "Ivorydale (USIVF)",
   label: "Ivorydale (USIVF)"
  },
  {
   value: "Jacinto (USJCX)",
   label: "Jacinto (USJCX)"
  },
  {
   value: "Jack (USJCK)",
   label: "Jack (USJCK)"
  },
  {
   value: "Jackman (USJAM)",
   label: "Jackman (USJAM)"
  },
  {
   value: "Jackson (USJAC)",
   label: "Jackson (USJAC)"
  },
  {
   value: "Jackson (USJKS)",
   label: "Jackson (USJKS)"
  },
  {
   value: "Jackson (USJKG)",
   label: "Jackson (USJKG)"
  },
  {
   value: "Jackson (USJXN)",
   label: "Jackson (USJXN)"
  },
  {
   value: "Jackson (USJAA)",
   label: "Jackson (USJAA)"
  },
  {
   value: "Jackson (USJAN)",
   label: "Jackson (USJAN)"
  },
  {
   value: "Jackson (USMKL)",
   label: "Jackson (USMKL)"
  },
  {
   value: "Jackson (USJAW)",
   label: "Jackson (USJAW)"
  },
  {
   value: "Jackson Center (USJCR)",
   label: "Jackson Center (USJCR)"
  },
  {
   value: "Jackson Heights (USJKH)",
   label: "Jackson Heights (USJKH)"
  },
  {
   value: "Jacksonboro (USJKB)",
   label: "Jacksonboro (USJKB)"
  },
  {
   value: "Jacksonville (USJAO)",
   label: "Jacksonville (USJAO)"
  },
  {
   value: "Jacksonville (USOAJ)",
   label: "Jacksonville (USOAJ)"
  },
  {
   value: "Jacksonville (USIJX)",
   label: "Jacksonville (USIJX)"
  },
  {
   value: "Jacksonville (USJAX)",
   label: "Jacksonville (USJAX)"
  },
  {
   value: "Jacksonville (USJQS)",
   label: "Jacksonville (USJQS)"
  },
  {
   value: "Jacksonville (USJKV)",
   label: "Jacksonville (USJKV)"
  },
  {
   value: "Jacksonville (USLRF)",
   label: "Jacksonville (USLRF)"
  },
  {
   value: "Jaffrey (USAFN)",
   label: "Jaffrey (USAFN)"
  },
  {
   value: "Jamaica (USUJV)",
   label: "Jamaica (USUJV)"
  },
  {
   value: "Jamestown (USJMW)",
   label: "Jamestown (USJMW)"
  },
  {
   value: "Jamestown (USJMT)",
   label: "Jamestown (USJMT)"
  },
  {
   value: "Jamestown (USJMS)",
   label: "Jamestown (USJMS)"
  },
  {
   value: "Jamestown (USJHW)",
   label: "Jamestown (USJHW)"
  },
  {
   value: "Jamesville (USJMV)",
   label: "Jamesville (USJMV)"
  },
  {
   value: "Janesville (USJVL)",
   label: "Janesville (USJVL)"
  },
  {
   value: "Jasper (USJAP)",
   label: "Jasper (USJAP)"
  },
  {
   value: "Jasper (USJAS)",
   label: "Jasper (USJAS)"
  },
  {
   value: "Jeannette (USJEA)",
   label: "Jeannette (USJEA)"
  },
  {
   value: "Jeannette (USJNR)",
   label: "Jeannette (USJNR)"
  },
  {
   value: "Independence (USIDC)",
   label: "Independence (USIDC)"
  },
  {
   value: "Indian Trail (USITR)",
   label: "Indian Trail (USITR)"
  },
  {
   value: "Indiana (USIDI)",
   label: "Indiana (USIDI)"
  },
  {
   value: "Indianapolis (USIND)",
   label: "Indianapolis (USIND)"
  },
  {
   value: "Indianola (USIDL)",
   label: "Indianola (USIDL)"
  },
  {
   value: "Indianola (USIDN)",
   label: "Indianola (USIDN)"
  },
  {
   value: "Indianola (USINI)",
   label: "Indianola (USINI)"
  },
  {
   value: "Indiantown (USIDT)",
   label: "Indiantown (USIDT)"
  },
  {
   value: "Indio (USIDO)",
   label: "Indio (USIDO)"
  },
  {
   value: "Industrial Airport (USIAQ)",
   label: "Industrial Airport (USIAQ)"
  },
  {
   value: "Industry (USINU)",
   label: "Industry (USINU)"
  },
  {
   value: "Inglewood (USING)",
   label: "Inglewood (USING)"
  },
  {
   value: "Inman (USINM)",
   label: "Inman (USINM)"
  },
  {
   value: "Institute (USINA)",
   label: "Institute (USINA)"
  },
  {
   value: "International Falls (USINL)",
   label: "International Falls (USINL)"
  },
  {
   value: "Inver Grove Heights (USIVV)",
   label: "Inver Grove Heights (USIVV)"
  },
  {
   value: "Inverness (USIVR)",
   label: "Inverness (USIVR)"
  },
  {
   value: "Inwood (USINO)",
   label: "Inwood (USINO)"
  },
  {
   value: "Inwood (USIWV)",
   label: "Inwood (USIWV)"
  },
  {
   value: "Iola (USIOL)",
   label: "Iola (USIOL)"
  },
  {
   value: "Iowa City (USIOW)",
   label: "Iowa City (USIOW)"
  },
  {
   value: "Iowa Falls (USIFA)",
   label: "Iowa Falls (USIFA)"
  },
  {
   value: "Iowa Park (USIPK)",
   label: "Iowa Park (USIPK)"
  },
  {
   value: "Ipswich (USIPW)",
   label: "Ipswich (USIPW)"
  },
  {
   value: "Irmo (USIRM)",
   label: "Irmo (USIRM)"
  },
  {
   value: "Iron City (USIRC)",
   label: "Iron City (USIRC)"
  },
  {
   value: "Iron Mountain (USIMT)",
   label: "Iron Mountain (USIMT)"
  },
  {
   value: "Ironton (USIRN)",
   label: "Ironton (USIRN)"
  },
  {
   value: "Irvine (USIVN)",
   label: "Irvine (USIVN)"
  },
  {
   value: "Irving (USIRV)",
   label: "Irving (USIRV)"
  },
  {
   value: "Irving (USIRT)",
   label: "Irving (USIRT)"
  },
  {
   value: "Irvington (USIVT)",
   label: "Irvington (USIVT)"
  },
  {
   value: "Irvington (USIRZ)",
   label: "Irvington (USIRZ)"
  },
  {
   value: "Irvington (USIRG)",
   label: "Irvington (USIRG)"
  },
  {
   value: "Irvington (USIRJ)",
   label: "Irvington (USIRJ)"
  },
  {
   value: "Irwin (USIPA)",
   label: "Irwin (USIPA)"
  },
  {
   value: "Irwindale (USIRD)",
   label: "Irwindale (USIRD)"
  },
  {
   value: "Iselin (USINJ)",
   label: "Iselin (USINJ)"
  },
  {
   value: "Ishpeming (USISB)",
   label: "Ishpeming (USISB)"
  },
  {
   value: "Islip (USISP)",
   label: "Islip (USISP)"
  },
  {
   value: "Huntington Valley (USUJU)",
   label: "Huntington Valley (USUJU)"
  },
  {
   value: "Huntington-Ashland Apt (USHTS)",
   label: "Huntington-Ashland Apt (USHTS)"
  },
  {
   value: "Huntley (USHTQ)",
   label: "Huntley (USHTQ)"
  },
  {
   value: "Hunts Point (USHPT)",
   label: "Hunts Point (USHPT)"
  },
  {
   value: "Huntsville (USHTV)",
   label: "Huntsville (USHTV)"
  },
  {
   value: "Huntsville (USHSV)",
   label: "Huntsville (USHSV)"
  },
  {
   value: "Huntsville (USHSW)",
   label: "Huntsville (USHSW)"
  },
  {
   value: "Hurlock (USHUC)",
   label: "Hurlock (USHUC)"
  },
  {
   value: "Huron (USHUB)",
   label: "Huron (USHUB)"
  },
  {
   value: "Huron (USHON)",
   label: "Huron (USHON)"
  },
  {
   value: "Hurst (USHUR)",
   label: "Hurst (USHUR)"
  },
  {
   value: "Hurt (USHUJ)",
   label: "Hurt (USHUJ)"
  },
  {
   value: "Hustonville (USHUK)",
   label: "Hustonville (USHUK)"
  },
  {
   value: "Hutchins (USHTC)",
   label: "Hutchins (USHTC)"
  },
  {
   value: "Hutchinson (USHTK)",
   label: "Hutchinson (USHTK)"
  },
  {
   value: "Hutchinson (USHUT)",
   label: "Hutchinson (USHUT)"
  },
  {
   value: "Huxford (USHXO)",
   label: "Huxford (USHXO)"
  },
  {
   value: "Hwange (USWKI)",
   label: "Hwange (USWKI)"
  },
  {
   value: "Hyannis (USHYA)",
   label: "Hyannis (USHYA)"
  },
  {
   value: "Hyattsville (USXGZ)",
   label: "Hyattsville (USXGZ)"
  },
  {
   value: "Hydaburg (USHYG)",
   label: "Hydaburg (USHYG)"
  },
  {
   value: "Hyde (USHYD)",
   label: "Hyde (USHYD)"
  },
  {
   value: "Hyde Park (USHYE)",
   label: "Hyde Park (USHYE)"
  },
  {
   value: "Hyde Park (USHEK)",
   label: "Hyde Park (USHEK)"
  },
  {
   value: "Hyde Park (USHYR)",
   label: "Hyde Park (USHYR)"
  },
  {
   value: "Hypoluxo (USHYP)",
   label: "Hypoluxo (USHYP)"
  },
  {
   value: "Iberia (USIBE)",
   label: "Iberia (USIBE)"
  },
  {
   value: "Ida Grove (USIDG)",
   label: "Ida Grove (USIDG)"
  },
  {
   value: "Idaho Falls (USIDA)",
   label: "Idaho Falls (USIDA)"
  },
  {
   value: "Idaho Springs (USIDH)",
   label: "Idaho Springs (USIDH)"
  },
  {
   value: "Illiopolis (USILP)",
   label: "Illiopolis (USILP)"
  },
  {
   value: "Imlay City (USILA)",
   label: "Imlay City (USILA)"
  },
  {
   value: "Immokalee (USIMM)",
   label: "Immokalee (USIMM)"
  },
  {
   value: "Imperial (USIMP)",
   label: "Imperial (USIMP)"
  },
  {
   value: "Imperial (USIML)",
   label: "Imperial (USIML)"
  },
  {
   value: "Imperial Beach (USNRS)",
   label: "Imperial Beach (USNRS)"
  },
  {
   value: "Imperial-El Centro Apt (USIPL)",
   label: "Imperial-El Centro Apt (USIPL)"
  },
  {
   value: "Independence (USIDP)",
   label: "Independence (USIDP)"
  },
  {
   value: "Independence (USIPM)",
   label: "Independence (USIPM)"
  },
  {
   value: "Independence (USIDE)",
   label: "Independence (USIDE)"
  },
  {
   value: "Houlka (USHKQ)",
   label: "Houlka (USHKQ)"
  },
  {
   value: "Houlton (USHUL)",
   label: "Houlton (USHUL)"
  },
  {
   value: "Houma (USHUM)",
   label: "Houma (USHUM)"
  },
  {
   value: "Housatonic (USHUQ)",
   label: "Housatonic (USHUQ)"
  },
  {
   value: "Houston (USHQN)",
   label: "Houston (USHQN)"
  },
  {
   value: "Houston (USHSM)",
   label: "Houston (USHSM)"
  },
  {
   value: "Houston (USHOU)",
   label: "Houston (USHOU)"
  },
  {
   value: "Houston (USHSO)",
   label: "Houston (USHSO)"
  },
  {
   value: "Howard (USHWR)",
   label: "Howard (USHWR)"
  },
  {
   value: "Howard Beach (USXGO)",
   label: "Howard Beach (USXGO)"
  },
  {
   value: "Howell (USHWL)",
   label: "Howell (USHWL)"
  },
  {
   value: "Howell (USHOJ)",
   label: "Howell (USHOJ)"
  },
  {
   value: "Howey In The Hills (USHWE)",
   label: "Howey In The Hills (USHWE)"
  },
  {
   value: "Hubbard (USXGA)",
   label: "Hubbard (USXGA)"
  },
  {
   value: "Hubbard (USHBI)",
   label: "Hubbard (USHBI)"
  },
  {
   value: "Huber (USHUA)",
   label: "Huber (USHUA)"
  },
  {
   value: "Hudson (USHUD)",
   label: "Hudson (USHUD)"
  },
  {
   value: "Hudson (USHUO)",
   label: "Hudson (USHUO)"
  },
  {
   value: "Hudson (USXGV)",
   label: "Hudson (USXGV)"
  },
  {
   value: "Hudson (USHDM)",
   label: "Hudson (USHDM)"
  },
  {
   value: "Hudson (USHDS)",
   label: "Hudson (USHDS)"
  },
  {
   value: "Hudson (USHCC)",
   label: "Hudson (USHCC)"
  },
  {
   value: "Hudson Falls (USHFY)",
   label: "Hudson Falls (USHFY)"
  },
  {
   value: "Hudsonville (USHUV)",
   label: "Hudsonville (USHUV)"
  },
  {
   value: "Hugo (USHUG)",
   label: "Hugo (USHUG)"
  },
  {
   value: "Humble (USHMX)",
   label: "Humble (USHMX)"
  },
  {
   value: "Humboldt (USHUE)",
   label: "Humboldt (USHUE)"
  },
  {
   value: "Humboldt (USHHB)",
   label: "Humboldt (USHHB)"
  },
  {
   value: "Humboldt Bay (USHBY)",
   label: "Humboldt Bay (USHBY)"
  },
  {
   value: "Humbolt (USHUX)",
   label: "Humbolt (USHUX)"
  },
  {
   value: "Hummelstown (USHWP)",
   label: "Hummelstown (USHWP)"
  },
  {
   value: "Hunt Valley (USHVD)",
   label: "Hunt Valley (USHVD)"
  },
  {
   value: "Huntersville (USXGS)",
   label: "Huntersville (USXGS)"
  },
  {
   value: "Hunting (USHNT)",
   label: "Hunting (USHNT)"
  },
  {
   value: "Huntingburg (USHNB)",
   label: "Huntingburg (USHNB)"
  },
  {
   value: "Huntingdon (USHTG)",
   label: "Huntingdon (USHTG)"
  },
  {
   value: "Huntingdon Valley (USHVY)",
   label: "Huntingdon Valley (USHVY)"
  },
  {
   value: "Huntington (USHUN)",
   label: "Huntington (USHUN)"
  },
  {
   value: "Huntington (USHTZ)",
   label: "Huntington (USHTZ)"
  },
  {
   value: "Huntington Beach (USHTD)",
   label: "Huntington Beach (USHTD)"
  },
  {
   value: "Huntington Park (USHNG)",
   label: "Huntington Park (USHNG)"
  },
  {
   value: "Holt (USHCN)",
   label: "Holt (USHCN)"
  },
  {
   value: "Holtsville (USHOV)",
   label: "Holtsville (USHOV)"
  },
  {
   value: "Holy Hill (USHHQ)",
   label: "Holy Hill (USHHQ)"
  },
  {
   value: "Holyoke (USHYK)",
   label: "Holyoke (USHYK)"
  },
  {
   value: "Holyoke (USUJQ)",
   label: "Holyoke (USUJQ)"
  },
  {
   value: "Homedale (USHMI)",
   label: "Homedale (USHMI)"
  },
  {
   value: "Homer (USHOI)",
   label: "Homer (USHOI)"
  },
  {
   value: "Homerville (USHMV)",
   label: "Homerville (USHMV)"
  },
  {
   value: "Homestead (USHST)",
   label: "Homestead (USHST)"
  },
  {
   value: "Hondo (USXGN)",
   label: "Hondo (USXGN)"
  },
  {
   value: "Honesdale (USHOD)",
   label: "Honesdale (USHOD)"
  },
  {
   value: "Honey Brook (USHNY)",
   label: "Honey Brook (USHNY)"
  },
  {
   value: "Honeywell Inc (USHPP)",
   label: "Honeywell Inc (USHPP)"
  },
  {
   value: "Honolulu (USHNL)",
   label: "Honolulu (USHNL)"
  },
  {
   value: "Hood (USHJQ)",
   label: "Hood (USHJQ)"
  },
  {
   value: "Hood River (USHDX)",
   label: "Hood River (USHDX)"
  },
  {
   value: "Hoonah (USHNH)",
   label: "Hoonah (USHNH)"
  },
  {
   value: "Hoopeston (USHUP)",
   label: "Hoopeston (USHUP)"
  },
  {
   value: "Hoosick Falls (USXGB)",
   label: "Hoosick Falls (USXGB)"
  },
  {
   value: "Hoosierlift (USHOF)",
   label: "Hoosierlift (USHOF)"
  },
  {
   value: "Hoover (USHVA)",
   label: "Hoover (USHVA)"
  },
  {
   value: "Hope (USHPR)",
   label: "Hope (USHPR)"
  },
  {
   value: "Hope (USHPI)",
   label: "Hope (USHPI)"
  },
  {
   value: "Hope Mills (USHXM)",
   label: "Hope Mills (USHXM)"
  },
  {
   value: "Hopedale (USHPX)",
   label: "Hopedale (USHPX)"
  },
  {
   value: "Hopelawn (USHZJ)",
   label: "Hopelawn (USHZJ)"
  },
  {
   value: "Hopeville (USHPE)",
   label: "Hopeville (USHPE)"
  },
  {
   value: "Hopewell (USHEW)",
   label: "Hopewell (USHEW)"
  },
  {
   value: "Hopewell (USHPW)",
   label: "Hopewell (USHPW)"
  },
  {
   value: "Hopkins (USHPO)",
   label: "Hopkins (USHPO)"
  },
  {
   value: "Hopkinsville (USHOP)",
   label: "Hopkinsville (USHOP)"
  },
  {
   value: "Hoquiam-Aberdeen Apt (USHQM)",
   label: "Hoquiam-Aberdeen Apt (USHQM)"
  },
  {
   value: "Horicon (USHRW)",
   label: "Horicon (USHRW)"
  },
  {
   value: "Horn Lake (USHQA)",
   label: "Horn Lake (USHQA)"
  },
  {
   value: "Hornell (USHNW)",
   label: "Hornell (USHNW)"
  },
  {
   value: "Horse Head (USHHN)",
   label: "Horse Head (USHHN)"
  },
  {
   value: "Horse Heaven Grp (USHHG)",
   label: "Horse Heaven Grp (USHHG)"
  },
  {
   value: "Horseheads (USHRH)",
   label: "Horseheads (USHRH)"
  },
  {
   value: "Horsham (USHOA)",
   label: "Horsham (USHOA)"
  },
  {
   value: "Hot Springs (USHOT)",
   label: "Hot Springs (USHOT)"
  },
  {
   value: "Houghton (USHTL)",
   label: "Houghton (USHTL)"
  },
  {
   value: "Hillsboro (USHIO)",
   label: "Hillsboro (USHIO)"
  },
  {
   value: "Hillsborough (USHQB)",
   label: "Hillsborough (USHQB)"
  },
  {
   value: "Hillsdale (USHSE)",
   label: "Hillsdale (USHSE)"
  },
  {
   value: "Hillside (USUJO)",
   label: "Hillside (USUJO)"
  },
  {
   value: "Hillside (USHLS)",
   label: "Hillside (USHLS)"
  },
  {
   value: "Hillsville (USHIV)",
   label: "Hillsville (USHIV)"
  },
  {
   value: "Hilo (USITO)",
   label: "Hilo (USITO)"
  },
  {
   value: "Hinckley (USHKL)",
   label: "Hinckley (USHKL)"
  },
  {
   value: "Hinesburg (USHIU)",
   label: "Hinesburg (USHIU)"
  },
  {
   value: "Hingham (USHGM)",
   label: "Hingham (USHGM)"
  },
  {
   value: "Hinkle (USXGI)",
   label: "Hinkle (USXGI)"
  },
  {
   value: "Hinkley (USHLH)",
   label: "Hinkley (USHLH)"
  },
  {
   value: "Hinsdale (USHSA)",
   label: "Hinsdale (USHSA)"
  },
  {
   value: "Hinsdale (USHDL)",
   label: "Hinsdale (USHDL)"
  },
  {
   value: "Hinton (USHIE)",
   label: "Hinton (USHIE)"
  },
  {
   value: "Hixson (USHXS)",
   label: "Hixson (USHXS)"
  },
  {
   value: "Hobart (USHBA)",
   label: "Hobart (USHBA)"
  },
  {
   value: "Hobe Sound (USHBE)",
   label: "Hobe Sound (USHBE)"
  },
  {
   value: "Hoboken (USHOB)",
   label: "Hoboken (USHOB)"
  },
  {
   value: "Hockessin (USHCS)",
   label: "Hockessin (USHCS)"
  },
  {
   value: "Hodgkins (USHOK)",
   label: "Hodgkins (USHOK)"
  },
  {
   value: "Hoffman Estates (USHFF)",
   label: "Hoffman Estates (USHFF)"
  },
  {
   value: "Hogansville (USHGA)",
   label: "Hogansville (USHGA)"
  },
  {
   value: "Holbrook (USHOL)",
   label: "Holbrook (USHOL)"
  },
  {
   value: "Holcomb (USHLQ)",
   label: "Holcomb (USHLQ)"
  },
  {
   value: "Holland (USHLM)",
   label: "Holland (USHLM)"
  },
  {
   value: "Holland (USXGJ)",
   label: "Holland (USXGJ)"
  },
  {
   value: "Holland (USHOO)",
   label: "Holland (USHOO)"
  },
  {
   value: "Holland (USHLX)",
   label: "Holland (USHLX)"
  },
  {
   value: "Hollis (USHSH)",
   label: "Hollis (USHSH)"
  },
  {
   value: "Hollister (USHLI)",
   label: "Hollister (USHLI)"
  },
  {
   value: "Holliston (USXGP)",
   label: "Holliston (USXGP)"
  },
  {
   value: "Holly (USHOC)",
   label: "Holly (USHOC)"
  },
  {
   value: "Holly Hill (USHHI)",
   label: "Holly Hill (USHHI)"
  },
  {
   value: "Holly Pond (USHLP)",
   label: "Holly Pond (USHLP)"
  },
  {
   value: "Hollywood (USHWW)",
   label: "Hollywood (USHWW)"
  },
  {
   value: "Hollywood (USHLW)",
   label: "Hollywood (USHLW)"
  },
  {
   value: "Hollywood (USHWO)",
   label: "Hollywood (USHWO)"
  },
  {
   value: "Holmdel (USHDZ)",
   label: "Holmdel (USHDZ)"
  },
  {
   value: "Holstein (USHSN)",
   label: "Holstein (USHSN)"
  },
  {
   value: "Holston (USHYC)",
   label: "Holston (USHYC)"
  },
  {
   value: "Hermiston (USHES)",
   label: "Hermiston (USHES)"
  },
  {
   value: "Hermosa Beach (USHBH)",
   label: "Hermosa Beach (USHBH)"
  },
  {
   value: "Hernando (USHND)",
   label: "Hernando (USHND)"
  },
  {
   value: "Herndon (USHRV)",
   label: "Herndon (USHRV)"
  },
  {
   value: "Herrin (USHER)",
   label: "Herrin (USHER)"
  },
  {
   value: "Hershey (USHEH)",
   label: "Hershey (USHEH)"
  },
  {
   value: "Hesperia (USHQP)",
   label: "Hesperia (USHQP)"
  },
  {
   value: "Hesston (USHET)",
   label: "Hesston (USHET)"
  },
  {
   value: "Hialeah (USHLF)",
   label: "Hialeah (USHLF)"
  },
  {
   value: "Hibbing (USHIB)",
   label: "Hibbing (USHIB)"
  },
  {
   value: "Hickory (USHIY)",
   label: "Hickory (USHIY)"
  },
  {
   value: "Hickory (USHKY)",
   label: "Hickory (USHKY)"
  },
  {
   value: "Hicksville (USUJM)",
   label: "Hicksville (USUJM)"
  },
  {
   value: "Hidalgo (USHID)",
   label: "Hidalgo (USHID)"
  },
  {
   value: "Hiddenite (USHDD)",
   label: "Hiddenite (USHDD)"
  },
  {
   value: "Higbee (USXGH)",
   label: "Higbee (USXGH)"
  },
  {
   value: "Higganum (USHIG)",
   label: "Higganum (USHIG)"
  },
  {
   value: "High Springs (USHSS)",
   label: "High Springs (USHSS)"
  },
  {
   value: "Highgate (USXGE)",
   label: "Highgate (USXGE)"
  },
  {
   value: "Highgate Springs (USHIS)",
   label: "Highgate Springs (USHIS)"
  },
  {
   value: "Highgrove (USHQF)",
   label: "Highgrove (USHQF)"
  },
  {
   value: "Highland (USHIQ)",
   label: "Highland (USHIQ)"
  },
  {
   value: "Highland (USHII)",
   label: "Highland (USHII)"
  },
  {
   value: "Highland (USHIJ)",
   label: "Highland (USHIJ)"
  },
  {
   value: "Highland (USHIH)",
   label: "Highland (USHIH)"
  },
  {
   value: "Highland Heights (USHIK)",
   label: "Highland Heights (USHIK)"
  },
  {
   value: "Highland Park (USHIP)",
   label: "Highland Park (USHIP)"
  },
  {
   value: "Highland Park (USHGH)",
   label: "Highland Park (USHGH)"
  },
  {
   value: "Highland Park (USHIA)",
   label: "Highland Park (USHIA)"
  },
  {
   value: "Highlands (USHQW)",
   label: "Highlands (USHQW)"
  },
  {
   value: "Hightstown (USHGT)",
   label: "Hightstown (USHGT)"
  },
  {
   value: "Hightstown (USUJT)",
   label: "Hightstown (USUJT)"
  },
  {
   value: "Highway Highlands (USHQH)",
   label: "Highway Highlands (USHQH)"
  },
  {
   value: "Hilbert (USHBB)",
   label: "Hilbert (USHBB)"
  },
  {
   value: "Hildebran (USHDR)",
   label: "Hildebran (USHDR)"
  },
  {
   value: "Hilliard (USHDF)",
   label: "Hilliard (USHDF)"
  },
  {
   value: "Hilliard (USHJL)",
   label: "Hilliard (USHJL)"
  },
  {
   value: "Hills (USHIL)",
   label: "Hills (USHIL)"
  },
  {
   value: "Hillsboro (USHLL)",
   label: "Hillsboro (USHLL)"
  },
  {
   value: "Hillsboro (USHJW)",
   label: "Hillsboro (USHJW)"
  },
  {
   value: "Hazelton (USHZT)",
   label: "Hazelton (USHZT)"
  },
  {
   value: "Hazelwood (USHZW)",
   label: "Hazelwood (USHZW)"
  },
  {
   value: "Hazlehurst (USHZH)",
   label: "Hazlehurst (USHZH)"
  },
  {
   value: "Hazlehurst (USHZU)",
   label: "Hazlehurst (USHZU)"
  },
  {
   value: "Hazleton (USHZL)",
   label: "Hazleton (USHZL)"
  },
  {
   value: "Headland (USHED)",
   label: "Headland (USHED)"
  },
  {
   value: "Healdsburg (USHLA)",
   label: "Healdsburg (USHLA)"
  },
  {
   value: "Healy (USHLZ)",
   label: "Healy (USHLZ)"
  },
  {
   value: "Hearne (USHEA)",
   label: "Hearne (USHEA)"
  },
  {
   value: "Heath (USXGT)",
   label: "Heath (USXGT)"
  },
  {
   value: "Heber Springs (USHSP)",
   label: "Heber Springs (USHSP)"
  },
  {
   value: "Hebron (USHEO)",
   label: "Hebron (USHEO)"
  },
  {
   value: "Hebron (USHBN)",
   label: "Hebron (USHBN)"
  },
  {
   value: "Hebron (USHEB)",
   label: "Hebron (USHEB)"
  },
  {
   value: "Heflin (USHEF)",
   label: "Heflin (USHEF)"
  },
  {
   value: "Heidelberg (USHDQ)",
   label: "Heidelberg (USHDQ)"
  },
  {
   value: "Heidlersburg (USHBZ)",
   label: "Heidlersburg (USHBZ)"
  },
  {
   value: "Helena (USHEE)",
   label: "Helena (USHEE)"
  },
  {
   value: "Helena (USHLN)",
   label: "Helena (USHLN)"
  },
  {
   value: "Hellertown (USHEL)",
   label: "Hellertown (USHEL)"
  },
  {
   value: "Helm (USHEU)",
   label: "Helm (USHEU)"
  },
  {
   value: "Hemet (USHMT)",
   label: "Hemet (USHMT)"
  },
  {
   value: "Hemingway (USHWY)",
   label: "Hemingway (USHWY)"
  },
  {
   value: "Hemlock (USHEM)",
   label: "Hemlock (USHEM)"
  },
  {
   value: "Hempstead (USHEP)",
   label: "Hempstead (USHEP)"
  },
  {
   value: "Henderson (USHXN)",
   label: "Henderson (USHXN)"
  },
  {
   value: "Henderson (USXGD)",
   label: "Henderson (USXGD)"
  },
  {
   value: "Henderson (USHDO)",
   label: "Henderson (USHDO)"
  },
  {
   value: "Henderson (USHNZ)",
   label: "Henderson (USHNZ)"
  },
  {
   value: "Henderson (USHDT)",
   label: "Henderson (USHDT)"
  },
  {
   value: "Henderson (USHXR)",
   label: "Henderson (USHXR)"
  },
  {
   value: "Henderson (USHEN)",
   label: "Henderson (USHEN)"
  },
  {
   value: "Hendersonville (USHDV)",
   label: "Hendersonville (USHDV)"
  },
  {
   value: "Henniker (USHKR)",
   label: "Henniker (USHKR)"
  },
  {
   value: "Henrietta (USHTX)",
   label: "Henrietta (USHTX)"
  },
  {
   value: "Henry (USHYY)",
   label: "Henry (USHYY)"
  },
  {
   value: "Henryetta (USHYO)",
   label: "Henryetta (USHYO)"
  },
  {
   value: "Hepzibah (USHZB)",
   label: "Hepzibah (USHZB)"
  },
  {
   value: "Hereford (USHFR)",
   label: "Hereford (USHFR)"
  },
  {
   value: "Herkimer (USHHY)",
   label: "Herkimer (USHHY)"
  },
  {
   value: "Herlong (USAHC)",
   label: "Herlong (USAHC)"
  },
  {
   value: "Hartsdale (USHAS)",
   label: "Hartsdale (USHAS)"
  },
  {
   value: "Hartselle (USHTE)",
   label: "Hartselle (USHTE)"
  },
  {
   value: "Hartsville (USHVS)",
   label: "Hartsville (USHVS)"
  },
  {
   value: "Hartville (USHVI)",
   label: "Hartville (USHVI)"
  },
  {
   value: "Hartwell (USHTM)",
   label: "Hartwell (USHTM)"
  },
  {
   value: "Harvard (USHRU)",
   label: "Harvard (USHRU)"
  },
  {
   value: "Harvey (USHRY)",
   label: "Harvey (USHRY)"
  },
  {
   value: "Harvey (USHMJ)",
   label: "Harvey (USHMJ)"
  },
  {
   value: "Haskell (USHQL)",
   label: "Haskell (USHQL)"
  },
  {
   value: "Hastings (USHSI)",
   label: "Hastings (USHSI)"
  },
  {
   value: "Hastings (USXGR)",
   label: "Hastings (USXGR)"
  },
  {
   value: "Hastings-On-Hudson (USHOX)",
   label: "Hastings-On-Hudson (USHOX)"
  },
  {
   value: "Hatboro (USHTP)",
   label: "Hatboro (USHTP)"
  },
  {
   value: "Hatfield (USHFE)",
   label: "Hatfield (USHFE)"
  },
  {
   value: "Hatfield (USHAT)",
   label: "Hatfield (USHAT)"
  },
  {
   value: "Hattiesburg (USHBG)",
   label: "Hattiesburg (USHBG)"
  },
  {
   value: "Hauppage (USHAP)",
   label: "Hauppage (USHAP)"
  },
  {
   value: "Havana (USHVV)",
   label: "Havana (USHVV)"
  },
  {
   value: "Haverhill (USHAV)",
   label: "Haverhill (USHAV)"
  },
  {
   value: "Haverhill (USHHO)",
   label: "Haverhill (USHHO)"
  },
  {
   value: "Haverstraw (USHVT)",
   label: "Haverstraw (USHVT)"
  },
  {
   value: "Havertown (USHAA)",
   label: "Havertown (USHAA)"
  },
  {
   value: "Havre (USHVR)",
   label: "Havre (USHVR)"
  },
  {
   value: "Havre De Grace (USHDC)",
   label: "Havre De Grace (USHDC)"
  },
  {
   value: "Haw River (USHRX)",
   label: "Haw River (USHRX)"
  },
  {
   value: "Hawaiian Gardens (USHGN)",
   label: "Hawaiian Gardens (USHGN)"
  },
  {
   value: "Hawarden (USXGX)",
   label: "Hawarden (USXGX)"
  },
  {
   value: "Hawkins (USHWZ)",
   label: "Hawkins (USHWZ)"
  },
  {
   value: "Hawkinsville (USHAZ)",
   label: "Hawkinsville (USHAZ)"
  },
  {
   value: "Hawley (USXGY)",
   label: "Hawley (USXGY)"
  },
  {
   value: "Hawthorne (USHTH)",
   label: "Hawthorne (USHTH)"
  },
  {
   value: "Hawthorne (USHAW)",
   label: "Hawthorne (USHAW)"
  },
  {
   value: "Hawthorne (USHTI)",
   label: "Hawthorne (USHTI)"
  },
  {
   value: "Hawthorne (USHHR)",
   label: "Hawthorne (USHHR)"
  },
  {
   value: "Haynesville (USXHA)",
   label: "Haynesville (USXHA)"
  },
  {
   value: "Hays (USHYS)",
   label: "Hays (USHYS)"
  },
  {
   value: "Hayward (USHWD)",
   label: "Hayward (USHWD)"
  },
  {
   value: "Hayward (USHWM)",
   label: "Hayward (USHWM)"
  },
  {
   value: "Hazard (USUJL)",
   label: "Hazard (USUJL)"
  },
  {
   value: "Hazel Dell (USHQZ)",
   label: "Hazel Dell (USHQZ)"
  },
  {
   value: "Hazelhurst (USHHZ)",
   label: "Hazelhurst (USHHZ)"
  },
  {
   value: "Hansboro (USHBO)",
   label: "Hansboro (USHBO)"
  },
  {
   value: "Hansen (USHNI)",
   label: "Hansen (USHNI)"
  },
  {
   value: "Hansing (USHHS)",
   label: "Hansing (USHHS)"
  },
  {
   value: "Hanson (USUJP)",
   label: "Hanson (USUJP)"
  },
  {
   value: "Hapeville (USHPL)",
   label: "Hapeville (USHPL)"
  },
  {
   value: "Happy Valley (USHQV)",
   label: "Happy Valley (USHQV)"
  },
  {
   value: "Harahan (USHRJ)",
   label: "Harahan (USHRJ)"
  },
  {
   value: "Harbeson (USHBD)",
   label: "Harbeson (USHBD)"
  },
  {
   value: "Harbor City (USHRB)",
   label: "Harbor City (USHRB)"
  },
  {
   value: "Harding (USHDP)",
   label: "Harding (USHDP)"
  },
  {
   value: "Hardwick (USHWK)",
   label: "Hardwick (USHWK)"
  },
  {
   value: "Harford (USHCZ)",
   label: "Harford (USHCZ)"
  },
  {
   value: "Harlan (USHYI)",
   label: "Harlan (USHYI)"
  },
  {
   value: "Harlem (USHRE)",
   label: "Harlem (USHRE)"
  },
  {
   value: "Harleysville (USHVP)",
   label: "Harleysville (USHVP)"
  },
  {
   value: "Harlingen (USHRL)",
   label: "Harlingen (USHRL)"
  },
  {
   value: "Harmans (USHMA)",
   label: "Harmans (USHMA)"
  },
  {
   value: "Harmon (USHYQ)",
   label: "Harmon (USHYQ)"
  },
  {
   value: "Harmony (USHSC)",
   label: "Harmony (USHSC)"
  },
  {
   value: "Harpersfield (USHRP)",
   label: "Harpersfield (USHRP)"
  },
  {
   value: "Harriman (USHRI)",
   label: "Harriman (USHRI)"
  },
  {
   value: "Harriman (USHYZ)",
   label: "Harriman (USHYZ)"
  },
  {
   value: "Harrington (USHRR)",
   label: "Harrington (USHRR)"
  },
  {
   value: "Harris County (USHCX)",
   label: "Harris County (USHCX)"
  },
  {
   value: "Harrisburg (USHSB)",
   label: "Harrisburg (USHSB)"
  },
  {
   value: "Harrisburg (USHSR)",
   label: "Harrisburg (USHSR)"
  },
  {
   value: "Harrisburg (USHAR)",
   label: "Harrisburg (USHAR)"
  },
  {
   value: "Harrison (USHAB)",
   label: "Harrison (USHAB)"
  },
  {
   value: "Harrison (USHRO)",
   label: "Harrison (USHRO)"
  },
  {
   value: "Harrisonburg (USHBV)",
   label: "Harrisonburg (USHBV)"
  },
  {
   value: "Harrisonville (USHMO)",
   label: "Harrisonville (USHMO)"
  },
  {
   value: "Harrisville (USHVW)",
   label: "Harrisville (USHVW)"
  },
  {
   value: "Harrodsburg (USHBF)",
   label: "Harrodsburg (USHBF)"
  },
  {
   value: "Hart (USHRT)",
   label: "Hart (USHRT)"
  },
  {
   value: "Hartford (USHFI)",
   label: "Hartford (USHFI)"
  },
  {
   value: "Hartford (USHAF)",
   label: "Hartford (USHAF)"
  },
  {
   value: "Hartford (USHTT)",
   label: "Hartford (USHTT)"
  },
  {
   value: "Hartford (USHFD)",
   label: "Hartford (USHFD)"
  },
  {
   value: "Hartford City (USHFC)",
   label: "Hartford City (USHFC)"
  },
  {
   value: "Hartland (USHAQ)",
   label: "Hartland (USHAQ)"
  },
  {
   value: "Hartley (USHTY)",
   label: "Hartley (USHTY)"
  },
  {
   value: "Hallendale (USHAE)",
   label: "Hallendale (USHAE)"
  },
  {
   value: "Halls (USHLJ)",
   label: "Halls (USHLJ)"
  },
  {
   value: "Halsey (USHZO)",
   label: "Halsey (USHZO)"
  },
  {
   value: "Haltom City (USHCY)",
   label: "Haltom City (USHCY)"
  },
  {
   value: "Hamburg (USHAM)",
   label: "Hamburg (USHAM)"
  },
  {
   value: "Hamburg (USHXV)",
   label: "Hamburg (USHXV)"
  },
  {
   value: "Hamburg (USHMQ)",
   label: "Hamburg (USHMQ)"
  },
  {
   value: "Hamburg (USHBQ)",
   label: "Hamburg (USHBQ)"
  },
  {
   value: "Hamden (USAEU)",
   label: "Hamden (USAEU)"
  },
  {
   value: "Hamilton (USHTN)",
   label: "Hamilton (USHTN)"
  },
  {
   value: "Hamilton (USHFN)",
   label: "Hamilton (USHFN)"
  },
  {
   value: "Hamilton (USXGM)",
   label: "Hamilton (USXGM)"
  },
  {
   value: "Hamilton (USHMZ)",
   label: "Hamilton (USHMZ)"
  },
  {
   value: "Hamilton (USHLT)",
   label: "Hamilton (USHLT)"
  },
  {
   value: "Hamilton (USHAO)",
   label: "Hamilton (USHAO)"
  },
  {
   value: "Hamilton City (USHCB)",
   label: "Hamilton City (USHCB)"
  },
  {
   value: "Hamlet (USHML)",
   label: "Hamlet (USHML)"
  },
  {
   value: "Hamlin (USXGK)",
   label: "Hamlin (USXGK)"
  },
  {
   value: "Hammond (USHXB)",
   label: "Hammond (USHXB)"
  },
  {
   value: "Hammond (USHMN)",
   label: "Hammond (USHMN)"
  },
  {
   value: "Hammond (USHLO)",
   label: "Hammond (USHLO)"
  },
  {
   value: "Hammondsport (USHMP)",
   label: "Hammondsport (USHMP)"
  },
  {
   value: "Hammonton (USXGL)",
   label: "Hammonton (USXGL)"
  },
  {
   value: "Hampstead (USHMS)",
   label: "Hampstead (USHMS)"
  },
  {
   value: "Hampton (USHPN)",
   label: "Hampton (USHPN)"
  },
  {
   value: "Hampton (USUJS)",
   label: "Hampton (USUJS)"
  },
  {
   value: "Hampton (USHPF)",
   label: "Hampton (USHPF)"
  },
  {
   value: "Hampton Falls (USHXP)",
   label: "Hampton Falls (USHXP)"
  },
  {
   value: "Hamtramck (USXGU)",
   label: "Hamtramck (USXGU)"
  },
  {
   value: "Hanahan (USUJN)",
   label: "Hanahan (USUJN)"
  },
  {
   value: "Hanburg (USHBR)",
   label: "Hanburg (USHBR)"
  },
  {
   value: "Hanceville (USHCV)",
   label: "Hanceville (USHCV)"
  },
  {
   value: "Hanford (USHNF)",
   label: "Hanford (USHNF)"
  },
  {
   value: "Hannah (USHNA)",
   label: "Hannah (USHNA)"
  },
  {
   value: "Hannibal (USHNM)",
   label: "Hannibal (USHNM)"
  },
  {
   value: "Hanover (USHVM)",
   label: "Hanover (USHVM)"
  },
  {
   value: "Hanover (USHAN)",
   label: "Hanover (USHAN)"
  },
  {
   value: "Hanover (USHNP)",
   label: "Hanover (USHNP)"
  },
  {
   value: "Hanover (USHVQ)",
   label: "Hanover (USHVQ)"
  },
  {
   value: "Hanover Park (USHPK)",
   label: "Hanover Park (USHPK)"
  },
  {
   value: "Hanoverton (USHNN)",
   label: "Hanoverton (USHNN)"
  },
  {
   value: "Grove (USGFQ)",
   label: "Grove (USGFQ)"
  },
  {
   value: "Grove City (USGRO)",
   label: "Grove City (USGRO)"
  },
  {
   value: "Grove Hill (USGVH)",
   label: "Grove Hill (USGVH)"
  },
  {
   value: "Groveland (USGVD)",
   label: "Groveland (USGVD)"
  },
  {
   value: "Groveland (USGVE)",
   label: "Groveland (USGVE)"
  },
  {
   value: "Groveport (USGVN)",
   label: "Groveport (USGVN)"
  },
  {
   value: "Groveport (USGVP)",
   label: "Groveport (USGVP)"
  },
  {
   value: "Groveton (USGRT)",
   label: "Groveton (USGRT)"
  },
  {
   value: "Grundy Center (USGCN)",
   label: "Grundy Center (USGCN)"
  },
  {
   value: "Guild (USGIG)",
   label: "Guild (USGIG)"
  },
  {
   value: "Guilderland Center (USGUW)",
   label: "Guilderland Center (USGUW)"
  },
  {
   value: "Guilds Lake (USGUI)",
   label: "Guilds Lake (USGUI)"
  },
  {
   value: "Guin (USGWU)",
   label: "Guin (USGWU)"
  },
  {
   value: "Gulf Shores (USGUF)",
   label: "Gulf Shores (USGUF)"
  },
  {
   value: "Gulfport (USGPT)",
   label: "Gulfport (USGPT)"
  },
  {
   value: "Guntown (USGTO)",
   label: "Guntown (USGTO)"
  },
  {
   value: "Gurdon (USGUO)",
   label: "Gurdon (USGUO)"
  },
  {
   value: "Gurnee (USGUR)",
   label: "Gurnee (USGUR)"
  },
  {
   value: "Gustine (USGUT)",
   label: "Gustine (USGUT)"
  },
  {
   value: "Gwynedd (USGWY)",
   label: "Gwynedd (USGWY)"
  },
  {
   value: "Gypsum (USGPU)",
   label: "Gypsum (USGPU)"
  },
  {
   value: "Hacienda Heights (USHHE)",
   label: "Hacienda Heights (USHHE)"
  },
  {
   value: "Hackensack (USHCK)",
   label: "Hackensack (USHCK)"
  },
  {
   value: "Hackettstown (USHCT)",
   label: "Hackettstown (USHCT)"
  },
  {
   value: "Haddock (USHDK)",
   label: "Haddock (USHDK)"
  },
  {
   value: "Haddonfield (USHFL)",
   label: "Haddonfield (USHFL)"
  },
  {
   value: "Hadley (USHDY)",
   label: "Hadley (USHDY)"
  },
  {
   value: "Hager City (USXGC)",
   label: "Hager City (USXGC)"
  },
  {
   value: "Hagerstown (USHGR)",
   label: "Hagerstown (USHGR)"
  },
  {
   value: "Hahira (USXGF)",
   label: "Hahira (USXGF)"
  },
  {
   value: "Hahnville (USHAH)",
   label: "Hahnville (USHAH)"
  },
  {
   value: "Haines (USHNS)",
   label: "Haines (USHNS)"
  },
  {
   value: "Haines City (USHCF)",
   label: "Haines City (USHCF)"
  },
  {
   value: "Hainesport (USHNC)",
   label: "Hainesport (USHNC)"
  },
  {
   value: "Haledon (USHLD)",
   label: "Haledon (USHLD)"
  },
  {
   value: "Hales Corners (USHZR)",
   label: "Hales Corners (USHZR)"
  },
  {
   value: "Halethorpe (USHPH)",
   label: "Halethorpe (USHPH)"
  },
  {
   value: "Haleyville (USHLY)",
   label: "Haleyville (USHLY)"
  },
  {
   value: "Half Moon Bay (USHFW)",
   label: "Half Moon Bay (USHFW)"
  },
  {
   value: "Hallandale (USHAL)",
   label: "Hallandale (USHAL)"
  },
  {
   value: "Greenleaf (USGWF)",
   label: "Greenleaf (USGWF)"
  },
  {
   value: "Greensboro (USGNO)",
   label: "Greensboro (USGNO)"
  },
  {
   value: "Greensboro-High Point (USGSO)",
   label: "Greensboro-High Point (USGSO)"
  },
  {
   value: "Greensburg (USUJK)",
   label: "Greensburg (USUJK)"
  },
  {
   value: "Greensburg (USAEH)",
   label: "Greensburg (USAEH)"
  },
  {
   value: "Greensburg (USGRS)",
   label: "Greensburg (USGRS)"
  },
  {
   value: "Greenview Hills (USGWH)",
   label: "Greenview Hills (USGWH)"
  },
  {
   value: "Greenville (USGRN)",
   label: "Greenville (USGRN)"
  },
  {
   value: "Greenville (USGCY)",
   label: "Greenville (USGCY)"
  },
  {
   value: "Greenville (USGLH)",
   label: "Greenville (USGLH)"
  },
  {
   value: "Greenville (USGNY)",
   label: "Greenville (USGNY)"
  },
  {
   value: "Greenville (USGVT)",
   label: "Greenville (USGVT)"
  },
  {
   value: "Greenville (USGSP)",
   label: "Greenville (USGSP)"
  },
  {
   value: "Greenville (USGNP)",
   label: "Greenville (USGNP)"
  },
  {
   value: "Greenville (USPGV)",
   label: "Greenville (USPGV)"
  },
  {
   value: "Greenville (USGLV)",
   label: "Greenville (USGLV)"
  },
  {
   value: "Greenville (USGNM)",
   label: "Greenville (USGNM)"
  },
  {
   value: "Greenville (USGVQ)",
   label: "Greenville (USGVQ)"
  },
  {
   value: "Greenville (USGRE)",
   label: "Greenville (USGRE)"
  },
  {
   value: "Greenville (USGGH)",
   label: "Greenville (USGGH)"
  },
  {
   value: "Greenwich (USGRH)",
   label: "Greenwich (USGRH)"
  },
  {
   value: "Greenwich (USGRW)",
   label: "Greenwich (USGRW)"
  },
  {
   value: "Greenwich (USGNA)",
   label: "Greenwich (USGNA)"
  },
  {
   value: "Greenwood (USGNW)",
   label: "Greenwood (USGNW)"
  },
  {
   value: "Greenwood (USGWD)",
   label: "Greenwood (USGWD)"
  },
  {
   value: "Greenwood (USGRD)",
   label: "Greenwood (USGRD)"
  },
  {
   value: "Greenwood (USGWO)",
   label: "Greenwood (USGWO)"
  },
  {
   value: "Grenada (USUJH)",
   label: "Grenada (USUJH)"
  },
  {
   value: "Gresham (USGHO)",
   label: "Gresham (USGHO)"
  },
  {
   value: "Gretna (USGTL)",
   label: "Gretna (USGTL)"
  },
  {
   value: "Gridley (USXFY)",
   label: "Gridley (USXFY)"
  },
  {
   value: "Griffin (USGRZ)",
   label: "Griffin (USGRZ)"
  },
  {
   value: "Griffin (USGFI)",
   label: "Griffin (USGFI)"
  },
  {
   value: "Griffith (USGYF)",
   label: "Griffith (USGYF)"
  },
  {
   value: "Griffith Park (USGFP)",
   label: "Griffith Park (USGFP)"
  },
  {
   value: "Grimes (USGJM)",
   label: "Grimes (USGJM)"
  },
  {
   value: "Grinnell (USGIW)",
   label: "Grinnell (USGIW)"
  },
  {
   value: "Griswoldville (USGSV)",
   label: "Griswoldville (USGSV)"
  },
  {
   value: "Groton (USGDM)",
   label: "Groton (USGDM)"
  },
  {
   value: "Groton-New London Apt (USGON)",
   label: "Groton-New London Apt (USGON)"
  },
  {
   value: "Grandview (USGVW)",
   label: "Grandview (USGVW)"
  },
  {
   value: "Grandview (USGFV)",
   label: "Grandview (USGFV)"
  },
  {
   value: "Granite City (USGZI)",
   label: "Granite City (USGZI)"
  },
  {
   value: "Granite City (USGCX)",
   label: "Granite City (USGCX)"
  },
  {
   value: "Granite Falls (USGFA)",
   label: "Granite Falls (USGFA)"
  },
  {
   value: "Graniteville (USGTV)",
   label: "Graniteville (USGTV)"
  },
  {
   value: "Grant (USGTJ)",
   label: "Grant (USGTJ)"
  },
  {
   value: "Grant (USGNB)",
   label: "Grant (USGNB)"
  },
  {
   value: "Grant Park (USGRK)",
   label: "Grant Park (USGRK)"
  },
  {
   value: "Grants Pass (USXFX)",
   label: "Grants Pass (USXFX)"
  },
  {
   value: "Grantsburg (USGBU)",
   label: "Grantsburg (USGBU)"
  },
  {
   value: "Granville (USGVI)",
   label: "Granville (USGVI)"
  },
  {
   value: "Grapeland (USGPL)",
   label: "Grapeland (USGPL)"
  },
  {
   value: "Grapevine (USGPV)",
   label: "Grapevine (USGPV)"
  },
  {
   value: "Grass Valley (USGYC)",
   label: "Grass Valley (USGYC)"
  },
  {
   value: "Gray (USGRG)",
   label: "Gray (USGRG)"
  },
  {
   value: "Grays River (USGRV)",
   label: "Grays River (USGRV)"
  },
  {
   value: "Great Bend (USGBD)",
   label: "Great Bend (USGBD)"
  },
  {
   value: "Great Falls (USGTF)",
   label: "Great Falls (USGTF)"
  },
  {
   value: "Great Lakes (USGRL)",
   label: "Great Lakes (USGRL)"
  },
  {
   value: "Great Neck (USGNK)",
   label: "Great Neck (USGNK)"
  },
  {
   value: "Greeley (USGXY)",
   label: "Greeley (USGXY)"
  },
  {
   value: "Green Bay (USGRB)",
   label: "Green Bay (USGRB)"
  },
  {
   value: "Green Cove Springs (USGCS)",
   label: "Green Cove Springs (USGCS)"
  },
  {
   value: "Green Island (USXFV)",
   label: "Green Island (USXFV)"
  },
  {
   value: "Green Isle (USGIM)",
   label: "Green Isle (USGIM)"
  },
  {
   value: "Green River (USGVV)",
   label: "Green River (USGVV)"
  },
  {
   value: "Green Springs (USGCP)",
   label: "Green Springs (USGCP)"
  },
  {
   value: "Green Tree (USGTP)",
   label: "Green Tree (USGTP)"
  },
  {
   value: "Greenbelt (USGLT)",
   label: "Greenbelt (USGLT)"
  },
  {
   value: "Greencastle (USGXQ)",
   label: "Greencastle (USGXQ)"
  },
  {
   value: "Greencastle (USGRP)",
   label: "Greencastle (USGRP)"
  },
  {
   value: "Greeneville (USGTS)",
   label: "Greeneville (USGTS)"
  },
  {
   value: "Greenfield (USGFC)",
   label: "Greenfield (USGFC)"
  },
  {
   value: "Greenfield (USGNH)",
   label: "Greenfield (USGNH)"
  },
  {
   value: "Greenfield (USGNF)",
   label: "Greenfield (USGNF)"
  },
  {
   value: "Greenfield (USGIA)",
   label: "Greenfield (USGIA)"
  },
  {
   value: "Greenfield (USGFH)",
   label: "Greenfield (USGFH)"
  },
  {
   value: "Greenland (USGNN)",
   label: "Greenland (USGNN)"
  },
  {
   value: "Greenland (USGNL)",
   label: "Greenland (USGNL)"
  },
  {
   value: "Goodland (USGLD)",
   label: "Goodland (USGLD)"
  },
  {
   value: "Goodlettsville (USGDT)",
   label: "Goodlettsville (USGDT)"
  },
  {
   value: "Goodman (USGGP)",
   label: "Goodman (USGGP)"
  },
  {
   value: "Goodwater (USGWT)",
   label: "Goodwater (USGWT)"
  },
  {
   value: "Goodyear (USGGY)",
   label: "Goodyear (USGGY)"
  },
  {
   value: "Goose Creek (USGSC)",
   label: "Goose Creek (USGSC)"
  },
  {
   value: "Gordon (USGOR)",
   label: "Gordon (USGOR)"
  },
  {
   value: "Gordonsville (USGDV)",
   label: "Gordonsville (USGDV)"
  },
  {
   value: "Gorham (USGHH)",
   label: "Gorham (USGHH)"
  },
  {
   value: "Goshen (USGOS)",
   label: "Goshen (USGOS)"
  },
  {
   value: "Goshen (USGSH)",
   label: "Goshen (USGSH)"
  },
  {
   value: "Goulds (USGOU)",
   label: "Goulds (USGOU)"
  },
  {
   value: "Gouldsboro (USGGO)",
   label: "Gouldsboro (USGGO)"
  },
  {
   value: "Grace (USGCE)",
   label: "Grace (USGCE)"
  },
  {
   value: "Graceville (USGCV)",
   label: "Graceville (USGCV)"
  },
  {
   value: "Graceville (USGRC)",
   label: "Graceville (USGRC)"
  },
  {
   value: "Graehl (USGHQ)",
   label: "Graehl (USGHQ)"
  },
  {
   value: "Grafton (USGFT)",
   label: "Grafton (USGFT)"
  },
  {
   value: "Grafton (USGFO)",
   label: "Grafton (USGFO)"
  },
  {
   value: "Grafton (USGXF)",
   label: "Grafton (USGXF)"
  },
  {
   value: "Grafton (USGFN)",
   label: "Grafton (USGFN)"
  },
  {
   value: "Graham (USGMR)",
   label: "Graham (USGMR)"
  },
  {
   value: "Graham (USGHT)",
   label: "Graham (USGHT)"
  },
  {
   value: "Graham (USGRQ)",
   label: "Graham (USGRQ)"
  },
  {
   value: "Grain Valley (USGIV)",
   label: "Grain Valley (USGIV)"
  },
  {
   value: "Gramercy (USGRY)",
   label: "Gramercy (USGRY)"
  },
  {
   value: "Granada Hills (USGHL)",
   label: "Granada Hills (USGHL)"
  },
  {
   value: "Granbury (USGUY)",
   label: "Granbury (USGUY)"
  },
  {
   value: "Granby (USEGC)",
   label: "Granby (USEGC)"
  },
  {
   value: "Grand Forks (USGFK)",
   label: "Grand Forks (USGFK)"
  },
  {
   value: "Grand Haven (USGHN)",
   label: "Grand Haven (USGHN)"
  },
  {
   value: "Grand Island (USGRI)",
   label: "Grand Island (USGRI)"
  },
  {
   value: "Grand Isle (USGIJ)",
   label: "Grand Isle (USGIJ)"
  },
  {
   value: "Grand Junction (USGJT)",
   label: "Grand Junction (USGJT)"
  },
  {
   value: "Grand Junction (USGRJ)",
   label: "Grand Junction (USGRJ)"
  },
  {
   value: "Grand Portage (USGRA)",
   label: "Grand Portage (USGRA)"
  },
  {
   value: "Grand Prairie (USGDP)",
   label: "Grand Prairie (USGDP)"
  },
  {
   value: "Grand Rapids (USGPZ)",
   label: "Grand Rapids (USGPZ)"
  },
  {
   value: "Grand Rapids (USGRR)",
   label: "Grand Rapids (USGRR)"
  },
  {
   value: "Grand Ridge (USGYJ)",
   label: "Grand Ridge (USGYJ)"
  },
  {
   value: "Glen Rock (USGLK)",
   label: "Glen Rock (USGLK)"
  },
  {
   value: "Glen Rose (USGLY)",
   label: "Glen Rose (USGLY)"
  },
  {
   value: "Glen View (USGVX)",
   label: "Glen View (USGVX)"
  },
  {
   value: "Glenbrook (USGLM)",
   label: "Glenbrook (USGLM)"
  },
  {
   value: "Glendale (USGDW)",
   label: "Glendale (USGDW)"
  },
  {
   value: "Glendale (USGDA)",
   label: "Glendale (USGDA)"
  },
  {
   value: "Glendale (USJGX)",
   label: "Glendale (USJGX)"
  },
  {
   value: "Glendale (USGAW)",
   label: "Glendale (USGAW)"
  },
  {
   value: "Glendale (USGDL)",
   label: "Glendale (USGDL)"
  },
  {
   value: "Glendale (USGWV)",
   label: "Glendale (USGWV)"
  },
  {
   value: "Glendale Hghts (USGHI)",
   label: "Glendale Hghts (USGHI)"
  },
  {
   value: "Glendora (USGDQ)",
   label: "Glendora (USGDQ)"
  },
  {
   value: "Glenford (USGFD)",
   label: "Glenford (USGFD)"
  },
  {
   value: "Glenmont (USGTZ)",
   label: "Glenmont (USGTZ)"
  },
  {
   value: "Glenn Da (USGLG)",
   label: "Glenn Da (USGLG)"
  },
  {
   value: "Glennallen (USGLQ)",
   label: "Glennallen (USGLQ)"
  },
  {
   value: "Glens Falls (USGFL)",
   label: "Glens Falls (USGFL)"
  },
  {
   value: "Glens Ferry (USGFY)",
   label: "Glens Ferry (USGFY)"
  },
  {
   value: "Glenshaw (USGWL)",
   label: "Glenshaw (USGWL)"
  },
  {
   value: "Glenview (USNBU)",
   label: "Glenview (USNBU)"
  },
  {
   value: "Glenwood (USGWX)",
   label: "Glenwood (USGWX)"
  },
  {
   value: "Glenwood Springs (USGWS)",
   label: "Glenwood Springs (USGWS)"
  },
  {
   value: "Globe (USGBA)",
   label: "Globe (USGBA)"
  },
  {
   value: "Gloster (USGLU)",
   label: "Gloster (USGLU)"
  },
  {
   value: "Gloucester (USGLO)",
   label: "Gloucester (USGLO)"
  },
  {
   value: "Gloucester City (USGLC)",
   label: "Gloucester City (USGLC)"
  },
  {
   value: "Gloversville (USGVK)",
   label: "Gloversville (USGVK)"
  },
  {
   value: "Gnadenhutten (USGND)",
   label: "Gnadenhutten (USGND)"
  },
  {
   value: "Godfrey (USGDF)",
   label: "Godfrey (USGDF)"
  },
  {
   value: "Godwin (USGOD)",
   label: "Godwin (USGOD)"
  },
  {
   value: "Gold Beach (USGOL)",
   label: "Gold Beach (USGOL)"
  },
  {
   value: "Golden (USGOE)",
   label: "Golden (USGOE)"
  },
  {
   value: "Golden (USGDO)",
   label: "Golden (USGDO)"
  },
  {
   value: "Golden Valley (USGVY)",
   label: "Golden Valley (USGVY)"
  },
  {
   value: "Goldsboro (USGSB)",
   label: "Goldsboro (USGSB)"
  },
  {
   value: "Goldston (USGLJ)",
   label: "Goldston (USGLJ)"
  },
  {
   value: "Gonzales (USGZS)",
   label: "Gonzales (USGZS)"
  },
  {
   value: "Gonzales (USGZL)",
   label: "Gonzales (USGZL)"
  },
  {
   value: "Gonzales (USGNZ)",
   label: "Gonzales (USGNZ)"
  },
  {
   value: "Good Hope (USGDH)",
   label: "Good Hope (USGDH)"
  },
  {
   value: "Gooding (USGNG)",
   label: "Gooding (USGNG)"
  },
  {
   value: "Georgetown (USGEO)",
   label: "Georgetown (USGEO)"
  },
  {
   value: "Georgetown (USGXT)",
   label: "Georgetown (USGXT)"
  },
  {
   value: "Georgetown (USGGE)",
   label: "Georgetown (USGGE)"
  },
  {
   value: "Georgetown (USGED)",
   label: "Georgetown (USGED)"
  },
  {
   value: "Georgetown (USGEW)",
   label: "Georgetown (USGEW)"
  },
  {
   value: "Georgia (USGGA)",
   label: "Georgia (USGGA)"
  },
  {
   value: "Gering (USXFU)",
   label: "Gering (USXFU)"
  },
  {
   value: "Germansville (USGJF)",
   label: "Germansville (USGJF)"
  },
  {
   value: "Germantown (USGMT)",
   label: "Germantown (USGMT)"
  },
  {
   value: "Gettysburg (USGTY)",
   label: "Gettysburg (USGTY)"
  },
  {
   value: "Gibbsboro (USGBB)",
   label: "Gibbsboro (USGBB)"
  },
  {
   value: "Gibralter (USUJG)",
   label: "Gibralter (USUJG)"
  },
  {
   value: "Gibson (USGIZ)",
   label: "Gibson (USGIZ)"
  },
  {
   value: "Gibsonia (USGJJ)",
   label: "Gibsonia (USGJJ)"
  },
  {
   value: "Gibsonton (USAEF)",
   label: "Gibsonton (USAEF)"
  },
  {
   value: "Gig Harbor (USGGZ)",
   label: "Gig Harbor (USGGZ)"
  },
  {
   value: "Gilbertsville (USGXV)",
   label: "Gilbertsville (USGXV)"
  },
  {
   value: "Gilcrest (USGCT)",
   label: "Gilcrest (USGCT)"
  },
  {
   value: "Gillett (USGTT)",
   label: "Gillett (USGTT)"
  },
  {
   value: "Gillette (USGIL)",
   label: "Gillette (USGIL)"
  },
  {
   value: "Gillette (USGCC)",
   label: "Gillette (USGCC)"
  },
  {
   value: "Gilmer (USGIX)",
   label: "Gilmer (USGIX)"
  },
  {
   value: "Gilroy (USGIR)",
   label: "Gilroy (USGIR)"
  },
  {
   value: "Girdwood (USGWK)",
   label: "Girdwood (USGWK)"
  },
  {
   value: "Glacier (USGLA)",
   label: "Glacier (USGLA)"
  },
  {
   value: "Gladstone (USGDE)",
   label: "Gladstone (USGDE)"
  },
  {
   value: "Gladstone (USGTU)",
   label: "Gladstone (USGTU)"
  },
  {
   value: "Glasgow (USGSG)",
   label: "Glasgow (USGSG)"
  },
  {
   value: "Glasgow (USGGW)",
   label: "Glasgow (USGGW)"
  },
  {
   value: "Glasgow (USGGS)",
   label: "Glasgow (USGGS)"
  },
  {
   value: "Glasgow (USGLW)",
   label: "Glasgow (USGLW)"
  },
  {
   value: "Glassboro (USGLR)",
   label: "Glassboro (USGLR)"
  },
  {
   value: "Glassport (USGPX)",
   label: "Glassport (USGPX)"
  },
  {
   value: "Glastonbury (USGLL)",
   label: "Glastonbury (USGLL)"
  },
  {
   value: "Gleason (USGLZ)",
   label: "Gleason (USGLZ)"
  },
  {
   value: "Gleed (USXFT)",
   label: "Gleed (USXFT)"
  },
  {
   value: "Glen Allen (USGCD)",
   label: "Glen Allen (USGCD)"
  },
  {
   value: "Glen Allen (USGEU)",
   label: "Glen Allen (USGEU)"
  },
  {
   value: "Glen Burnie (USGBM)",
   label: "Glen Burnie (USGBM)"
  },
  {
   value: "Glen Cove (USGLN)",
   label: "Glen Cove (USGLN)"
  },
  {
   value: "Glen Ellyn (USGEY)",
   label: "Glen Ellyn (USGEY)"
  },
  {
   value: "Galt (USGAQ)",
   label: "Galt (USGAQ)"
  },
  {
   value: "Galveston (USGLS)",
   label: "Galveston (USGLS)"
  },
  {
   value: "Garden City (USJHC)",
   label: "Garden City (USJHC)"
  },
  {
   value: "Garden City (USGAR)",
   label: "Garden City (USGAR)"
  },
  {
   value: "Garden City (USGCG)",
   label: "Garden City (USGCG)"
  },
  {
   value: "Garden City (USGCK)",
   label: "Garden City (USGCK)"
  },
  {
   value: "Garden Grove (USGGR)",
   label: "Garden Grove (USGGR)"
  },
  {
   value: "Gardena (USGAC)",
   label: "Gardena (USGAC)"
  },
  {
   value: "Gardiner (USGDN)",
   label: "Gardiner (USGDN)"
  },
  {
   value: "Gardiner (USGDR)",
   label: "Gardiner (USGDR)"
  },
  {
   value: "Gardner (USGDZ)",
   label: "Gardner (USGDZ)"
  },
  {
   value: "Gardner (USGDY)",
   label: "Gardner (USGDY)"
  },
  {
   value: "Gardners (USGPE)",
   label: "Gardners (USGPE)"
  },
  {
   value: "Garfield (USGAF)",
   label: "Garfield (USGAF)"
  },
  {
   value: "Garfield Heights (USGHZ)",
   label: "Garfield Heights (USGHZ)"
  },
  {
   value: "Garland (USGRX)",
   label: "Garland (USGRX)"
  },
  {
   value: "Garnder (USGDX)",
   label: "Garnder (USGDX)"
  },
  {
   value: "Garrettsville (USGZV)",
   label: "Garrettsville (USGZV)"
  },
  {
   value: "Garrison (USGSZ)",
   label: "Garrison (USGSZ)"
  },
  {
   value: "Garrison (USGAM)",
   label: "Garrison (USGAM)"
  },
  {
   value: "Garville (USGAE)",
   label: "Garville (USGAE)"
  },
  {
   value: "Garwood (USXFZ)",
   label: "Garwood (USXFZ)"
  },
  {
   value: "Gary (USGYY)",
   label: "Gary (USGYY)"
  },
  {
   value: "Garyville (USGYV)",
   label: "Garyville (USGYV)"
  },
  {
   value: "Gas City (USGCI)",
   label: "Gas City (USGCI)"
  },
  {
   value: "Gassaway (USGSY)",
   label: "Gassaway (USGSY)"
  },
  {
   value: "Gassville (USGAV)",
   label: "Gassville (USGAV)"
  },
  {
   value: "Gaston (USGST)",
   label: "Gaston (USGST)"
  },
  {
   value: "Gaston (USGSN)",
   label: "Gaston (USGSN)"
  },
  {
   value: "Gastonia (USXFS)",
   label: "Gastonia (USXFS)"
  },
  {
   value: "Gaylord (USGYD)",
   label: "Gaylord (USGYD)"
  },
  {
   value: "Gaylord (USGAY)",
   label: "Gaylord (USGAY)"
  },
  {
   value: "Geismar (USGSM)",
   label: "Geismar (USGSM)"
  },
  {
   value: "Genesee (USGJC)",
   label: "Genesee (USGJC)"
  },
  {
   value: "Geneva (USUJI)",
   label: "Geneva (USUJI)"
  },
  {
   value: "Geneva (USGNI)",
   label: "Geneva (USGNI)"
  },
  {
   value: "Geneva (USGEN)",
   label: "Geneva (USGEN)"
  },
  {
   value: "Genoa (USGOI)",
   label: "Genoa (USGOI)"
  },
  {
   value: "George (USGWA)",
   label: "George (USGWA)"
  },
  {
   value: "Georgetown (USGEQ)",
   label: "Georgetown (USGEQ)"
  },
  {
   value: "Georgetown (USGER)",
   label: "Georgetown (USGER)"
  },
  {
   value: "Fremont (USFEM)",
   label: "Fremont (USFEM)"
  },
  {
   value: "Fremont (USFET)",
   label: "Fremont (USFET)"
  },
  {
   value: "Fremont (USXFK)",
   label: "Fremont (USXFK)"
  },
  {
   value: "Fremont (USFNC)",
   label: "Fremont (USFNC)"
  },
  {
   value: "Fresno (USFAT)",
   label: "Fresno (USFAT)"
  },
  {
   value: "Friday Harbor (USFRD)",
   label: "Friday Harbor (USFRD)"
  },
  {
   value: "Fridley (USFDU)",
   label: "Fridley (USFDU)"
  },
  {
   value: "Friendship (USFRF)",
   label: "Friendship (USFRF)"
  },
  {
   value: "Friona (USFTX)",
   label: "Friona (USFTX)"
  },
  {
   value: "Frisco (USFSC)",
   label: "Frisco (USFSC)"
  },
  {
   value: "Frisco (USFCK)",
   label: "Frisco (USFCK)"
  },
  {
   value: "Frisco City (USFCB)",
   label: "Frisco City (USFCB)"
  },
  {
   value: "Frogmore (USFGM)",
   label: "Frogmore (USFGM)"
  },
  {
   value: "Frohna (USFHN)",
   label: "Frohna (USFHN)"
  },
  {
   value: "Front Royal (USFRR)",
   label: "Front Royal (USFRR)"
  },
  {
   value: "Frontier (USFRO)",
   label: "Frontier (USFRO)"
  },
  {
   value: "Frostproof (USFRU)",
   label: "Frostproof (USFRU)"
  },
  {
   value: "Fuel (USFXT)",
   label: "Fuel (USFXT)"
  },
  {
   value: "Fullerton (USFUL)",
   label: "Fullerton (USFUL)"
  },
  {
   value: "Fulton (USFTZ)",
   label: "Fulton (USFTZ)"
  },
  {
   value: "Fulton (USFUN)",
   label: "Fulton (USFUN)"
  },
  {
   value: "Fulton (USFUT)",
   label: "Fulton (USFUT)"
  },
  {
   value: "Gabbs (USGAB)",
   label: "Gabbs (USGAB)"
  },
  {
   value: "Gadsden (USGAD)",
   label: "Gadsden (USGAD)"
  },
  {
   value: "Gadsen (USGAS)",
   label: "Gadsen (USGAS)"
  },
  {
   value: "Gaffney (USAEE)",
   label: "Gaffney (USAEE)"
  },
  {
   value: "Gainesboro (USGBT)",
   label: "Gainesboro (USGBT)"
  },
  {
   value: "Gainesville (USGNV)",
   label: "Gainesville (USGNV)"
  },
  {
   value: "Gainesville (USGVL)",
   label: "Gainesville (USGVL)"
  },
  {
   value: "Gainesville (USGIY)",
   label: "Gainesville (USGIY)"
  },
  {
   value: "Gainesville (USGLE)",
   label: "Gainesville (USGLE)"
  },
  {
   value: "Gaithersburg (USGAI)",
   label: "Gaithersburg (USGAI)"
  },
  {
   value: "Galax (USGLX)",
   label: "Galax (USGLX)"
  },
  {
   value: "Galena (USGAL)",
   label: "Galena (USGAL)"
  },
  {
   value: "Galena Park (USGPK)",
   label: "Galena Park (USGPK)"
  },
  {
   value: "Galesburg (USGBG)",
   label: "Galesburg (USGBG)"
  },
  {
   value: "Gallatin (USAED)",
   label: "Gallatin (USAED)"
  },
  {
   value: "Gallipolis (USGAP)",
   label: "Gallipolis (USGAP)"
  },
  {
   value: "Gallipolis Ferry (USGFE)",
   label: "Gallipolis Ferry (USGFE)"
  },
  {
   value: "Gallman (USGMX)",
   label: "Gallman (USGMX)"
  },
  {
   value: "Gallup (USGUP)",
   label: "Gallup (USGUP)"
  },
  {
   value: "Frank (USFQR)",
   label: "Frank (USFQR)"
  },
  {
   value: "Frankenmuth (USFKM)",
   label: "Frankenmuth (USFKM)"
  },
  {
   value: "Frankford (USFRK)",
   label: "Frankford (USFRK)"
  },
  {
   value: "Frankfort (USFFT)",
   label: "Frankfort (USFFT)"
  },
  {
   value: "Frankfort (USFKR)",
   label: "Frankfort (USFKR)"
  },
  {
   value: "Franklin (USUJA)",
   label: "Franklin (USUJA)"
  },
  {
   value: "Franklin (USFLN)",
   label: "Franklin (USFLN)"
  },
  {
   value: "Franklin (USFLW)",
   label: "Franklin (USFLW)"
  },
  {
   value: "Franklin (USFKN)",
   label: "Franklin (USFKN)"
  },
  {
   value: "Franklin (USFLH)",
   label: "Franklin (USFLH)"
  },
  {
   value: "Franklin (USFNN)",
   label: "Franklin (USFNN)"
  },
  {
   value: "Franklin (USFLK)",
   label: "Franklin (USFLK)"
  },
  {
   value: "Franklin (USFKI)",
   label: "Franklin (USFKI)"
  },
  {
   value: "Franklin (USFQL)",
   label: "Franklin (USFQL)"
  },
  {
   value: "Franklin (USFKA)",
   label: "Franklin (USFKA)"
  },
  {
   value: "Franklin (USFKL)",
   label: "Franklin (USFKL)"
  },
  {
   value: "Franklin Park (USFLI)",
   label: "Franklin Park (USFLI)"
  },
  {
   value: "Franklin Square (USFSR)",
   label: "Franklin Square (USFSR)"
  },
  {
   value: "Franklington (USFLC)",
   label: "Franklington (USFLC)"
  },
  {
   value: "Franklinton (USFTN)",
   label: "Franklinton (USFTN)"
  },
  {
   value: "Franklinville (USFRA)",
   label: "Franklinville (USFRA)"
  },
  {
   value: "Franklinville (USFQV)",
   label: "Franklinville (USFQV)"
  },
  {
   value: "Franksville (USFVW)",
   label: "Franksville (USFVW)"
  },
  {
   value: "Fraser (USFZY)",
   label: "Fraser (USFZY)"
  },
  {
   value: "Fraser (USXFQ)",
   label: "Fraser (USXFQ)"
  },
  {
   value: "Frazer (USFRZ)",
   label: "Frazer (USFRZ)"
  },
  {
   value: "Frederick (USFDK)",
   label: "Frederick (USFDK)"
  },
  {
   value: "Frederick (USFDR)",
   label: "Frederick (USFDR)"
  },
  {
   value: "Fredericksburg (USFDB)",
   label: "Fredericksburg (USFDB)"
  },
  {
   value: "Fredericksburg (USFXG)",
   label: "Fredericksburg (USFXG)"
  },
  {
   value: "Fredericksburg (USFKX)",
   label: "Fredericksburg (USFKX)"
  },
  {
   value: "Fredericsburg (USFRB)",
   label: "Fredericsburg (USFRB)"
  },
  {
   value: "Fredonia (USFDO)",
   label: "Fredonia (USFDO)"
  },
  {
   value: "Fredonia (USFEO)",
   label: "Fredonia (USFEO)"
  },
  {
   value: "Freehold (USFEH)",
   label: "Freehold (USFEH)"
  },
  {
   value: "Freeland (USFEN)",
   label: "Freeland (USFEN)"
  },
  {
   value: "Freeport (USFEP)",
   label: "Freeport (USFEP)"
  },
  {
   value: "Freeport (USFRX)",
   label: "Freeport (USFRX)"
  },
  {
   value: "Freeport (USFRP)",
   label: "Freeport (USFRP)"
  },
  {
   value: "Freindship (USFDH)",
   label: "Freindship (USFDH)"
  },
  {
   value: "Fort Gaines (USFTG)",
   label: "Fort Gaines (USFTG)"
  },
  {
   value: "Fort Gillem (USUJF)",
   label: "Fort Gillem (USUJF)"
  },
  {
   value: "Fort Kent (USFKT)",
   label: "Fort Kent (USFKT)"
  },
  {
   value: "Fort Lauderdale (USFLL)",
   label: "Fort Lauderdale (USFLL)"
  },
  {
   value: "Fort Leavenworth (USFLV)",
   label: "Fort Leavenworth (USFLV)"
  },
  {
   value: "Fort Lee (USFTL)",
   label: "Fort Lee (USFTL)"
  },
  {
   value: "Fort Madison (USFMS)",
   label: "Fort Madison (USFMS)"
  },
  {
   value: "Fort Morgan (USFMG)",
   label: "Fort Morgan (USFMG)"
  },
  {
   value: "Fort Myers (USFMY)",
   label: "Fort Myers (USFMY)"
  },
  {
   value: "Fort Payne (USFPN)",
   label: "Fort Payne (USFPN)"
  },
  {
   value: "Fort Pierce (USFPR)",
   label: "Fort Pierce (USFPR)"
  },
  {
   value: "Fort Riley (USFRI)",
   label: "Fort Riley (USFRI)"
  },
  {
   value: "Fort Scott (USFSK)",
   label: "Fort Scott (USFSK)"
  },
  {
   value: "Fort Smith (USUJE)",
   label: "Fort Smith (USUJE)"
  },
  {
   value: "Fort Smith (USFSM)",
   label: "Fort Smith (USFSM)"
  },
  {
   value: "Fort Stockton (USFST)",
   label: "Fort Stockton (USFST)"
  },
  {
   value: "Fort Sumner (USFSU)",
   label: "Fort Sumner (USFSU)"
  },
  {
   value: "Fort Valley (USFTV)",
   label: "Fort Valley (USFTV)"
  },
  {
   value: "Fort Walton Beach (USFWB)",
   label: "Fort Walton Beach (USFWB)"
  },
  {
   value: "Fort Washington (USFWY)",
   label: "Fort Washington (USFWY)"
  },
  {
   value: "Fort Washington (USQFW)",
   label: "Fort Washington (USQFW)"
  },
  {
   value: "Fort Wayne (USFWA)",
   label: "Fort Wayne (USFWA)"
  },
  {
   value: "Fort Wright (USFWR)",
   label: "Fort Wright (USFWR)"
  },
  {
   value: "Fort Yukon (USFYU)",
   label: "Fort Yukon (USFYU)"
  },
  {
   value: "Fortuna (USFTQ)",
   label: "Fortuna (USFTQ)"
  },
  {
   value: "Fortuna (USFRT)",
   label: "Fortuna (USFRT)"
  },
  {
   value: "Forty Fort (USFOV)",
   label: "Forty Fort (USFOV)"
  },
  {
   value: "Foster City (USFCI)",
   label: "Foster City (USFCI)"
  },
  {
   value: "Fostoria (USFSO)",
   label: "Fostoria (USFSO)"
  },
  {
   value: "Fountain Inn (USFIS)",
   label: "Fountain Inn (USFIS)"
  },
  {
   value: "Fountain Valley (USFVC)",
   label: "Fountain Valley (USFVC)"
  },
  {
   value: "Fowler (USFOW)",
   label: "Fowler (USFOW)"
  },
  {
   value: "Fox River Grove (USFOZ)",
   label: "Fox River Grove (USFOZ)"
  },
  {
   value: "Foxboro (USFXB)",
   label: "Foxboro (USFXB)"
  },
  {
   value: "Foxcroft (USFOX)",
   label: "Foxcroft (USFOX)"
  },
  {
   value: "Frackville (USFTJ)",
   label: "Frackville (USFTJ)"
  },
  {
   value: "Framingham (USFRH)",
   label: "Framingham (USFRH)"
  },
  {
   value: "Franconia (USFSA)",
   label: "Franconia (USFSA)"
  },
  {
   value: "Frank (USFQP)",
   label: "Frank (USFQP)"
  },
  {
   value: "Florissant (USFOT)",
   label: "Florissant (USFOT)"
  },
  {
   value: "Flowery Branch (USFLB)",
   label: "Flowery Branch (USFLB)"
  },
  {
   value: "Flowood (USFWD)",
   label: "Flowood (USFWD)"
  },
  {
   value: "Floydada (USFDD)",
   label: "Floydada (USFDD)"
  },
  {
   value: "Floyds Knobs (USFNI)",
   label: "Floyds Knobs (USFNI)"
  },
  {
   value: "Flushing (USFUH)",
   label: "Flushing (USFUH)"
  },
  {
   value: "Flushing (USFSG)",
   label: "Flushing (USFSG)"
  },
  {
   value: "Flushing Apt\/New York (USFLU)",
   label: "Flushing Apt\/New York (USFLU)"
  },
  {
   value: "Foert Scott (USUJC)",
   label: "Foert Scott (USUJC)"
  },
  {
   value: "Fogelsville (USFOG)",
   label: "Fogelsville (USFOG)"
  },
  {
   value: "Folcroft (USUJD)",
   label: "Folcroft (USUJD)"
  },
  {
   value: "Foley (USFLS)",
   label: "Foley (USFLS)"
  },
  {
   value: "Follansbee (USFOO)",
   label: "Follansbee (USFOO)"
  },
  {
   value: "Folsom (USFOU)",
   label: "Folsom (USFOU)"
  },
  {
   value: "Folsom (USFOJ)",
   label: "Folsom (USFOJ)"
  },
  {
   value: "Fond du Lac (USFLD)",
   label: "Fond du Lac (USFLD)"
  },
  {
   value: "Fontana (USXFR)",
   label: "Fontana (USXFR)"
  },
  {
   value: "Ford City (USFCT)",
   label: "Ford City (USFCT)"
  },
  {
   value: "Fords (USAEB)",
   label: "Fords (USAEB)"
  },
  {
   value: "Forest (USFTI)",
   label: "Forest (USFTI)"
  },
  {
   value: "Forest City (USFXY)",
   label: "Forest City (USFXY)"
  },
  {
   value: "Forest City (USFCN)",
   label: "Forest City (USFCN)"
  },
  {
   value: "Forest Grove (USFGV)",
   label: "Forest Grove (USFGV)"
  },
  {
   value: "Forest Lake (USFSL)",
   label: "Forest Lake (USFSL)"
  },
  {
   value: "Forest Park (USFOP)",
   label: "Forest Park (USFOP)"
  },
  {
   value: "Forest Park (USFPA)",
   label: "Forest Park (USFPA)"
  },
  {
   value: "Forestville (USFOE)",
   label: "Forestville (USFOE)"
  },
  {
   value: "Forestville (USFVL)",
   label: "Forestville (USFVL)"
  },
  {
   value: "Forney (USFNX)",
   label: "Forney (USFNX)"
  },
  {
   value: "Forrest (USFRS)",
   label: "Forrest (USFRS)"
  },
  {
   value: "Forrest City (USFCY)",
   label: "Forrest City (USFCY)"
  },
  {
   value: "Fort Smith (USFTA)",
   label: "Fort Smith (USFTA)"
  },
  {
   value: "Fort Atkinson (USXFO)",
   label: "Fort Atkinson (USXFO)"
  },
  {
   value: "Fort Bragg (USFOB)",
   label: "Fort Bragg (USFOB)"
  },
  {
   value: "Fort Collins (USFNL)",
   label: "Fort Collins (USFNL)"
  },
  {
   value: "Fort Covington (USFCO)",
   label: "Fort Covington (USFCO)"
  },
  {
   value: "Fort Dodge (USFOD)",
   label: "Fort Dodge (USFOD)"
  },
  {
   value: "Fort Edwards (USFTE)",
   label: "Fort Edwards (USFTE)"
  },
  {
   value: "Fort Fairfield (USFFA)",
   label: "Fort Fairfield (USFFA)"
  },
  {
   value: "Ferry (USFRY)",
   label: "Ferry (USFRY)"
  },
  {
   value: "Ferrysburg (USFER)",
   label: "Ferrysburg (USFER)"
  },
  {
   value: "Feura Bush (USXFJ)",
   label: "Feura Bush (USXFJ)"
  },
  {
   value: "Fieldsboro (USFDJ)",
   label: "Fieldsboro (USFDJ)"
  },
  {
   value: "Fife (USFFS)",
   label: "Fife (USFFS)"
  },
  {
   value: "Fiffe (USFIF)",
   label: "Fiffe (USFIF)"
  },
  {
   value: "Filer (USFII)",
   label: "Filer (USFII)"
  },
  {
   value: "Filer City (USFIC)",
   label: "Filer City (USFIC)"
  },
  {
   value: "Fillmore (USFMO)",
   label: "Fillmore (USFMO)"
  },
  {
   value: "Finderne (USXFL)",
   label: "Finderne (USXFL)"
  },
  {
   value: "Findlay (USFIN)",
   label: "Findlay (USFIN)"
  },
  {
   value: "Findlay (USFDY)",
   label: "Findlay (USFDY)"
  },
  {
   value: "Firebaugh (USFIR)",
   label: "Firebaugh (USFIR)"
  },
  {
   value: "Fisher (USFZR)",
   label: "Fisher (USFZR)"
  },
  {
   value: "Fishersville (USFHV)",
   label: "Fishersville (USFHV)"
  },
  {
   value: "Fisherville (USFSV)",
   label: "Fisherville (USFSV)"
  },
  {
   value: "Fitchburg (USFIT)",
   label: "Fitchburg (USFIT)"
  },
  {
   value: "Fitchville (USFCH)",
   label: "Fitchville (USFCH)"
  },
  {
   value: "Fitzgerald (USFZG)",
   label: "Fitzgerald (USFZG)"
  },
  {
   value: "Five Corners (USFYC)",
   label: "Five Corners (USFYC)"
  },
  {
   value: "Five Points (USFIV)",
   label: "Five Points (USFIV)"
  },
  {
   value: "Flagstaff (USFLG)",
   label: "Flagstaff (USFLG)"
  },
  {
   value: "Flanders (USFDZ)",
   label: "Flanders (USFDZ)"
  },
  {
   value: "Flat River (USUJB)",
   label: "Flat River (USUJB)"
  },
  {
   value: "Flatrock (USFLF)",
   label: "Flatrock (USFLF)"
  },
  {
   value: "Fledge (USFLQ)",
   label: "Fledge (USFLQ)"
  },
  {
   value: "Fleetwood (USFWP)",
   label: "Fleetwood (USFWP)"
  },
  {
   value: "Flemington (USFLE)",
   label: "Flemington (USFLE)"
  },
  {
   value: "Fletcher (USFHE)",
   label: "Fletcher (USFHE)"
  },
  {
   value: "Flint (USFNT)",
   label: "Flint (USFNT)"
  },
  {
   value: "Flintridge (USFRE)",
   label: "Flintridge (USFRE)"
  },
  {
   value: "Flora (USAEA)",
   label: "Flora (USAEA)"
  },
  {
   value: "Flora (USFOI)",
   label: "Flora (USFOI)"
  },
  {
   value: "Floral Park (USFLP)",
   label: "Floral Park (USFLP)"
  },
  {
   value: "Florence (USFKY)",
   label: "Florence (USFKY)"
  },
  {
   value: "Florence (USFLX)",
   label: "Florence (USFLX)"
  },
  {
   value: "Florence (USFCL)",
   label: "Florence (USFCL)"
  },
  {
   value: "Florence (USFLO)",
   label: "Florence (USFLO)"
  },
  {
   value: "Florence (USFLR)",
   label: "Florence (USFLR)"
  },
  {
   value: "Florence (USFLM)",
   label: "Florence (USFLM)"
  },
  {
   value: "Florida (USFID)",
   label: "Florida (USFID)"
  },
  {
   value: "Fallbrook (USFOR)",
   label: "Fallbrook (USFOR)"
  },
  {
   value: "Fallon (USFXN)",
   label: "Fallon (USFXN)"
  },
  {
   value: "Falls Church (USFAC)",
   label: "Falls Church (USFAC)"
  },
  {
   value: "Falls Mills (USXFM)",
   label: "Falls Mills (USXFM)"
  },
  {
   value: "Fallsington (USFSI)",
   label: "Fallsington (USFSI)"
  },
  {
   value: "Fancher (USFCR)",
   label: "Fancher (USFCR)"
  },
  {
   value: "Fanwood (USFWJ)",
   label: "Fanwood (USFWJ)"
  },
  {
   value: "Fargo (USFAR)",
   label: "Fargo (USFAR)"
  },
  {
   value: "Fargo (USFRC)",
   label: "Fargo (USFRC)"
  },
  {
   value: "Faribault (USFBL)",
   label: "Faribault (USFBL)"
  },
  {
   value: "Faringdale (USUFZ)",
   label: "Faringdale (USUFZ)"
  },
  {
   value: "Farmers Branch (USFBX)",
   label: "Farmers Branch (USFBX)"
  },
  {
   value: "Farmingdale (USFMJ)",
   label: "Farmingdale (USFMJ)"
  },
  {
   value: "Farmingdale (USFRG)",
   label: "Farmingdale (USFRG)"
  },
  {
   value: "Farmington (USFAM)",
   label: "Farmington (USFAM)"
  },
  {
   value: "Farmington (USFMN)",
   label: "Farmington (USFMN)"
  },
  {
   value: "Farmington (USFMI)",
   label: "Farmington (USFMI)"
  },
  {
   value: "Farmington (USFMQ)",
   label: "Farmington (USFMQ)"
  },
  {
   value: "Farmington (USFMF)",
   label: "Farmington (USFMF)"
  },
  {
   value: "Farmington Hills (USFHI)",
   label: "Farmington Hills (USFHI)"
  },
  {
   value: "Farmville (USFRV)",
   label: "Farmville (USFRV)"
  },
  {
   value: "Farmville (USFMV)",
   label: "Farmville (USFMV)"
  },
  {
   value: "Farwell (USFAW)",
   label: "Farwell (USFAW)"
  },
  {
   value: "Faulkner (USFAQ)",
   label: "Faulkner (USFAQ)"
  },
  {
   value: "Fayette (USFYT)",
   label: "Fayette (USFYT)"
  },
  {
   value: "Fayetteville (USFYV)",
   label: "Fayetteville (USFYV)"
  },
  {
   value: "Fayetteville (USFYM)",
   label: "Fayetteville (USFYM)"
  },
  {
   value: "Fayetteville (USFAY)",
   label: "Fayetteville (USFAY)"
  },
  {
   value: "Feasterville (USFEA)",
   label: "Feasterville (USFEA)"
  },
  {
   value: "Federal Way (USFDW)",
   label: "Federal Way (USFDW)"
  },
  {
   value: "Federalsburg (USFDL)",
   label: "Federalsburg (USFDL)"
  },
  {
   value: "Felida (USFYD)",
   label: "Felida (USFYD)"
  },
  {
   value: "Fenimore (USPNM)",
   label: "Fenimore (USPNM)"
  },
  {
   value: "Fenton (USFNM)",
   label: "Fenton (USFNM)"
  },
  {
   value: "Ferdinand (USFDA)",
   label: "Ferdinand (USFDA)"
  },
  {
   value: "Fernandina Beach (USFEB)",
   label: "Fernandina Beach (USFEB)"
  },
  {
   value: "Ferndale (USFDT)",
   label: "Ferndale (USFDT)"
  },
  {
   value: "Ferndale (USFEE)",
   label: "Ferndale (USFEE)"
  },
  {
   value: "Fernley (USFYR)",
   label: "Fernley (USFYR)"
  },
  {
   value: "Fernwood (USFWE)",
   label: "Fernwood (USFWE)"
  },
  {
   value: "Ewa Beach (Oahu) (USEWH)",
   label: "Ewa Beach (Oahu) (USEWH)"
  },
  {
   value: "Excel Corp (USEXL)",
   label: "Excel Corp (USEXL)"
  },
  {
   value: "Exeter (USEXP)",
   label: "Exeter (USEXP)"
  },
  {
   value: "Exeter (USEXE)",
   label: "Exeter (USEXE)"
  },
  {
   value: "Exeter (USEXT)",
   label: "Exeter (USEXT)"
  },
  {
   value: "Exmore (USEXA)",
   label: "Exmore (USEXA)"
  },
  {
   value: "Export (USEPT)",
   label: "Export (USEPT)"
  },
  {
   value: "Exton (USEXN)",
   label: "Exton (USEXN)"
  },
  {
   value: "Eynon (USEYP)",
   label: "Eynon (USEYP)"
  },
  {
   value: "Fabens (USFAB)",
   label: "Fabens (USFAB)"
  },
  {
   value: "Fair Hill (USFHP)",
   label: "Fair Hill (USFHP)"
  },
  {
   value: "Fair Lawn (USFLY)",
   label: "Fair Lawn (USFLY)"
  },
  {
   value: "Fair Oaks (USFOK)",
   label: "Fair Oaks (USFOK)"
  },
  {
   value: "Fairbanks (USFAI)",
   label: "Fairbanks (USFAI)"
  },
  {
   value: "Fairborn (USFBA)",
   label: "Fairborn (USFBA)"
  },
  {
   value: "Fairbury (USFBY)",
   label: "Fairbury (USFBY)"
  },
  {
   value: "Fairfax (USFFX)",
   label: "Fairfax (USFFX)"
  },
  {
   value: "Fairfax (USFXX)",
   label: "Fairfax (USFXX)"
  },
  {
   value: "Fairfield (USFAO)",
   label: "Fairfield (USFAO)"
  },
  {
   value: "Fairfield (USFAE)",
   label: "Fairfield (USFAE)"
  },
  {
   value: "Fairfield (USFFY)",
   label: "Fairfield (USFFY)"
  },
  {
   value: "Fairfield (USFLA)",
   label: "Fairfield (USFLA)"
  },
  {
   value: "Fairfield (USFFL)",
   label: "Fairfield (USFFL)"
  },
  {
   value: "Fairfield (USFAF)",
   label: "Fairfield (USFAF)"
  },
  {
   value: "Fairfield (USSUU)",
   label: "Fairfield (USSUU)"
  },
  {
   value: "Fairfield (USFFB)",
   label: "Fairfield (USFFB)"
  },
  {
   value: "Fairfield (USFAX)",
   label: "Fairfield (USFAX)"
  },
  {
   value: "Fairforest (USFFR)",
   label: "Fairforest (USFFR)"
  },
  {
   value: "Fairgrove (USFAG)",
   label: "Fairgrove (USFAG)"
  },
  {
   value: "Fairhaven (USFVH)",
   label: "Fairhaven (USFVH)"
  },
  {
   value: "Fairless Hills (USFAH)",
   label: "Fairless Hills (USFAH)"
  },
  {
   value: "Fairmont (USFMK)",
   label: "Fairmont (USFMK)"
  },
  {
   value: "Fairmont (USFRM)",
   label: "Fairmont (USFRM)"
  },
  {
   value: "Fairmont (USFAN)",
   label: "Fairmont (USFAN)"
  },
  {
   value: "Fairmont (USXFI)",
   label: "Fairmont (USXFI)"
  },
  {
   value: "Fairmount (USFMU)",
   label: "Fairmount (USFMU)"
  },
  {
   value: "Fairport (USFPT)",
   label: "Fairport (USFPT)"
  },
  {
   value: "Fairport (USXFP)",
   label: "Fairport (USXFP)"
  },
  {
   value: "Fairview (USFVI)",
   label: "Fairview (USFVI)"
  },
  {
   value: "Faison (USFZO)",
   label: "Faison (USFZO)"
  },
  {
   value: "Falkner (USXFN)",
   label: "Falkner (USXFN)"
  },
  {
   value: "Englewood Cliffs (USENG)",
   label: "Englewood Cliffs (USENG)"
  },
  {
   value: "Englishtown (USUFX)",
   label: "Englishtown (USUFX)"
  },
  {
   value: "Enid (USWDG)",
   label: "Enid (USWDG)"
  },
  {
   value: "Enka (USENK)",
   label: "Enka (USENK)"
  },
  {
   value: "Ennis (USENE)",
   label: "Ennis (USENE)"
  },
  {
   value: "Enoree (USEON)",
   label: "Enoree (USEON)"
  },
  {
   value: "Enterprise (USETS)",
   label: "Enterprise (USETS)"
  },
  {
   value: "Ephrata (USEHP)",
   label: "Ephrata (USEHP)"
  },
  {
   value: "Ephrata (USEPH)",
   label: "Ephrata (USEPH)"
  },
  {
   value: "Erie (USERI)",
   label: "Erie (USERI)"
  },
  {
   value: "Erie (USERZ)",
   label: "Erie (USERZ)"
  },
  {
   value: "Erlanger (USERL)",
   label: "Erlanger (USERL)"
  },
  {
   value: "Erwin (USEWJ)",
   label: "Erwin (USEWJ)"
  },
  {
   value: "Erwin (USERW)",
   label: "Erwin (USERW)"
  },
  {
   value: "Escanaba (USESC)",
   label: "Escanaba (USESC)"
  },
  {
   value: "Escondido (USECD)",
   label: "Escondido (USECD)"
  },
  {
   value: "Esmond (USESM)",
   label: "Esmond (USESM)"
  },
  {
   value: "Essex Junction (USESS)",
   label: "Essex Junction (USESS)"
  },
  {
   value: "Essington (USETX)",
   label: "Essington (USETX)"
  },
  {
   value: "Estacada (USEXQ)",
   label: "Estacada (USEXQ)"
  },
  {
   value: "Estero Bay (USESB)",
   label: "Estero Bay (USESB)"
  },
  {
   value: "Estherville (USEST)",
   label: "Estherville (USEST)"
  },
  {
   value: "Etowah (USETO)",
   label: "Etowah (USETO)"
  },
  {
   value: "Euclid (USEUC)",
   label: "Euclid (USEUC)"
  },
  {
   value: "Eufaula (USEUF)",
   label: "Eufaula (USEUF)"
  },
  {
   value: "Eugene (USEUG)",
   label: "Eugene (USEUG)"
  },
  {
   value: "Eureka (USEKA)",
   label: "Eureka (USEKA)"
  },
  {
   value: "Eustis (USEUS)",
   label: "Eustis (USEUS)"
  },
  {
   value: "Evadale (USEVA)",
   label: "Evadale (USEVA)"
  },
  {
   value: "Evans (USEVG)",
   label: "Evans (USEVG)"
  },
  {
   value: "Evans (USEVB)",
   label: "Evans (USEVB)"
  },
  {
   value: "Evans City (USEVC)",
   label: "Evans City (USEVC)"
  },
  {
   value: "Evanston (USEVD)",
   label: "Evanston (USEVD)"
  },
  {
   value: "Evanston (USEVW)",
   label: "Evanston (USEVW)"
  },
  {
   value: "Evansville (USEVV)",
   label: "Evansville (USEVV)"
  },
  {
   value: "Evansville (USEVS)",
   label: "Evansville (USEVS)"
  },
  {
   value: "Evendale (USEVL)",
   label: "Evendale (USEVL)"
  },
  {
   value: "Ever City (USECY)",
   label: "Ever City (USECY)"
  },
  {
   value: "Everett (USEVT)",
   label: "Everett (USEVT)"
  },
  {
   value: "Everett (USPAE)",
   label: "Everett (USPAE)"
  },
  {
   value: "Evergreen (USEVR)",
   label: "Evergreen (USEVR)"
  },
  {
   value: "Evergreen (USEXG)",
   label: "Evergreen (USEXG)"
  },
  {
   value: "Elkin (USELK)",
   label: "Elkin (USELK)"
  },
  {
   value: "Elkins (USELE)",
   label: "Elkins (USELE)"
  },
  {
   value: "Elkins (USEKN)",
   label: "Elkins (USEKN)"
  },
  {
   value: "Elkland (USELQ)",
   label: "Elkland (USELQ)"
  },
  {
   value: "Elko (USEKO)",
   label: "Elko (USEKO)"
  },
  {
   value: "Elkridge (USEKD)",
   label: "Elkridge (USEKD)"
  },
  {
   value: "Elkton (USEKV)",
   label: "Elkton (USEKV)"
  },
  {
   value: "Elkton (USELT)",
   label: "Elkton (USELT)"
  },
  {
   value: "Ellensburg (USELN)",
   label: "Ellensburg (USELN)"
  },
  {
   value: "Ellicottville (USELV)",
   label: "Ellicottville (USELV)"
  },
  {
   value: "Ellisville (USELU)",
   label: "Ellisville (USELU)"
  },
  {
   value: "Ellisville (USEVM)",
   label: "Ellisville (USEVM)"
  },
  {
   value: "Elloree (USEOR)",
   label: "Elloree (USEOR)"
  },
  {
   value: "Ellsinore (USEZI)",
   label: "Ellsinore (USEZI)"
  },
  {
   value: "Ellsworth (USEWT)",
   label: "Ellsworth (USEWT)"
  },
  {
   value: "Ellwood City (USXFH)",
   label: "Ellwood City (USXFH)"
  },
  {
   value: "Elmhurst (USELR)",
   label: "Elmhurst (USELR)"
  },
  {
   value: "Elmira Heights (USEMR)",
   label: "Elmira Heights (USEMR)"
  },
  {
   value: "Elmira-Corning (USELM)",
   label: "Elmira-Corning (USELM)"
  },
  {
   value: "Elmore (USEMO)",
   label: "Elmore (USEMO)"
  },
  {
   value: "Elmsford (USUFR)",
   label: "Elmsford (USUFR)"
  },
  {
   value: "Elmwood Park (USEWP)",
   label: "Elmwood Park (USEWP)"
  },
  {
   value: "Elsie (USEIL)",
   label: "Elsie (USEIL)"
  },
  {
   value: "Elwell (USEWE)",
   label: "Elwell (USEWE)"
  },
  {
   value: "Elwood (USELW)",
   label: "Elwood (USELW)"
  },
  {
   value: "Elwood (USELL)",
   label: "Elwood (USELL)"
  },
  {
   value: "Elwood (USEWI)",
   label: "Elwood (USEWI)"
  },
  {
   value: "Elwood (USEWW)",
   label: "Elwood (USEWW)"
  },
  {
   value: "Ely (USELY)",
   label: "Ely (USELY)"
  },
  {
   value: "Elyria (USEIA)",
   label: "Elyria (USEIA)"
  },
  {
   value: "Emelle (USEMA)",
   label: "Emelle (USEMA)"
  },
  {
   value: "Emeryville (USJEM)",
   label: "Emeryville (USJEM)"
  },
  {
   value: "Emigsville (USEGS)",
   label: "Emigsville (USEGS)"
  },
  {
   value: "Emmett (USEEI)",
   label: "Emmett (USEEI)"
  },
  {
   value: "Emporia (USEMP)",
   label: "Emporia (USEMP)"
  },
  {
   value: "Emporium (USEUI)",
   label: "Emporium (USEUI)"
  },
  {
   value: "Encinata (USXFE)",
   label: "Encinata (USXFE)"
  },
  {
   value: "Encino (USENO)",
   label: "Encino (USENO)"
  },
  {
   value: "Endeavor (USEND)",
   label: "Endeavor (USEND)"
  },
  {
   value: "Enfield (USENF)",
   label: "Enfield (USENF)"
  },
  {
   value: "Englewood (USEWD)",
   label: "Englewood (USEWD)"
  },
  {
   value: "Englewood (USQTS)",
   label: "Englewood (USQTS)"
  },
  {
   value: "Edmonds (USEOW)",
   label: "Edmonds (USEOW)"
  },
  {
   value: "Edmonston (USEOT)",
   label: "Edmonston (USEOT)"
  },
  {
   value: "Edwardsville (USEDW)",
   label: "Edwardsville (USEDW)"
  },
  {
   value: "Effingham (USEFI)",
   label: "Effingham (USEFI)"
  },
  {
   value: "Efiwanda (USEFS)",
   label: "Efiwanda (USEFS)"
  },
  {
   value: "Egegik (USEGX)",
   label: "Egegik (USEGX)"
  },
  {
   value: "Egg Harbor (USEGG)",
   label: "Egg Harbor (USEGG)"
  },
  {
   value: "Eight Mile (USEIG)",
   label: "Eight Mile (USEIG)"
  },
  {
   value: "Eklutna (USEUL)",
   label: "Eklutna (USEUL)"
  },
  {
   value: "Ekuk (USKKU)",
   label: "Ekuk (USKKU)"
  },
  {
   value: "El Cajon (USCJN)",
   label: "El Cajon (USCJN)"
  },
  {
   value: "El Capitan (USELC)",
   label: "El Capitan (USELC)"
  },
  {
   value: "El Cerrito (USECQ)",
   label: "El Cerrito (USECQ)"
  },
  {
   value: "El Dorado (USELD)",
   label: "El Dorado (USELD)"
  },
  {
   value: "El Dorado Springs (USEOO)",
   label: "El Dorado Springs (USEOO)"
  },
  {
   value: "El Medina (USEMD)",
   label: "El Medina (USEMD)"
  },
  {
   value: "El Modeno (USEMW)",
   label: "El Modeno (USEMW)"
  },
  {
   value: "El Monte (USEMT)",
   label: "El Monte (USEMT)"
  },
  {
   value: "El Paso (USELP)",
   label: "El Paso (USELP)"
  },
  {
   value: "El Segundo (USELS)",
   label: "El Segundo (USELS)"
  },
  {
   value: "El Sereno (USEZR)",
   label: "El Sereno (USEZR)"
  },
  {
   value: "El Toro (USETR)",
   label: "El Toro (USETR)"
  },
  {
   value: "Elberton (USELB)",
   label: "Elberton (USELB)"
  },
  {
   value: "Elco (USEQO)",
   label: "Elco (USEQO)"
  },
  {
   value: "Eldersburg (USEMC)",
   label: "Eldersburg (USEMC)"
  },
  {
   value: "Eldon (USEDT)",
   label: "Eldon (USEDT)"
  },
  {
   value: "Eldy (USELA)",
   label: "Eldy (USELA)"
  },
  {
   value: "Elfrida (USERD)",
   label: "Elfrida (USERD)"
  },
  {
   value: "Elgin (USEGN)",
   label: "Elgin (USEGN)"
  },
  {
   value: "Elgin (USEGE)",
   label: "Elgin (USEGE)"
  },
  {
   value: "Elizabeth (USELZ)",
   label: "Elizabeth (USELZ)"
  },
  {
   value: "Elizabeth City (USECG)",
   label: "Elizabeth City (USECG)"
  },
  {
   value: "Elizabethton (USEZB)",
   label: "Elizabethton (USEZB)"
  },
  {
   value: "Elizabethtown (USEZW)",
   label: "Elizabethtown (USEZW)"
  },
  {
   value: "Elizabethtown (USEKX)",
   label: "Elizabethtown (USEKX)"
  },
  {
   value: "Elizabethtown (USEZT)",
   label: "Elizabethtown (USEZT)"
  },
  {
   value: "Elk Grove (USEGK)",
   label: "Elk Grove (USEGK)"
  },
  {
   value: "Elk Grove Village (USEGV)",
   label: "Elk Grove Village (USEGV)"
  },
  {
   value: "Elkhart (USEKI)",
   label: "Elkhart (USEKI)"
  },
  {
   value: "Elkhorn (USELH)",
   label: "Elkhorn (USELH)"
  },
  {
   value: "East Windsor (USEWS)",
   label: "East Windsor (USEWS)"
  },
  {
   value: "Eastchester (USETJ)",
   label: "Eastchester (USETJ)"
  },
  {
   value: "Eastford (USEFD)",
   label: "Eastford (USEFD)"
  },
  {
   value: "Easthampton (USEHN)",
   label: "Easthampton (USEHN)"
  },
  {
   value: "Eastman (USEZG)",
   label: "Eastman (USEZG)"
  },
  {
   value: "Easton (USXFF)",
   label: "Easton (USXFF)"
  },
  {
   value: "Easton (USETM)",
   label: "Easton (USETM)"
  },
  {
   value: "Eastover (USEAS)",
   label: "Eastover (USEAS)"
  },
  {
   value: "Eastport (USEPM)",
   label: "Eastport (USEPM)"
  },
  {
   value: "Eastport (USEPI)",
   label: "Eastport (USEPI)"
  },
  {
   value: "Eaton (USEAN)",
   label: "Eaton (USEAN)"
  },
  {
   value: "Eaton (USETN)",
   label: "Eaton (USETN)"
  },
  {
   value: "Eaton Park (USEDA)",
   label: "Eaton Park (USEDA)"
  },
  {
   value: "Eaton Rapids (USETP)",
   label: "Eaton Rapids (USETP)"
  },
  {
   value: "Eatonton (USAAX)",
   label: "Eatonton (USAAX)"
  },
  {
   value: "Eatontown (USEAJ)",
   label: "Eatontown (USEAJ)"
  },
  {
   value: "Eau Claire (USEAU)",
   label: "Eau Claire (USEAU)"
  },
  {
   value: "Ebensburg (USEBE)",
   label: "Ebensburg (USEBE)"
  },
  {
   value: "Ecorse (USEKP)",
   label: "Ecorse (USEKP)"
  },
  {
   value: "Ecru (USEQU)",
   label: "Ecru (USEQU)"
  },
  {
   value: "Edcouch (USEDX)",
   label: "Edcouch (USEDX)"
  },
  {
   value: "Eddystone (USESX)",
   label: "Eddystone (USESX)"
  },
  {
   value: "Eddyville (USEYV)",
   label: "Eddyville (USEYV)"
  },
  {
   value: "Eden (USEDY)",
   label: "Eden (USEDY)"
  },
  {
   value: "Eden (USEWF)",
   label: "Eden (USEWF)"
  },
  {
   value: "Eden (USEDB)",
   label: "Eden (USEDB)"
  },
  {
   value: "Eden (USEDI)",
   label: "Eden (USEDI)"
  },
  {
   value: "Eden Prairie (USEDP)",
   label: "Eden Prairie (USEDP)"
  },
  {
   value: "Edenton (USEDE)",
   label: "Edenton (USEDE)"
  },
  {
   value: "Edgefield (USEDF)",
   label: "Edgefield (USEDF)"
  },
  {
   value: "Edgemont (USEGM)",
   label: "Edgemont (USEGM)"
  },
  {
   value: "Edgemoor (USEGU)",
   label: "Edgemoor (USEGU)"
  },
  {
   value: "Edgerton (USEGT)",
   label: "Edgerton (USEGT)"
  },
  {
   value: "Edgewater (USEJW)",
   label: "Edgewater (USEJW)"
  },
  {
   value: "Edgewater (USEGW)",
   label: "Edgewater (USEGW)"
  },
  {
   value: "Edgewood (USEDG)",
   label: "Edgewood (USEDG)"
  },
  {
   value: "Edinburg (USEDQ)",
   label: "Edinburg (USEDQ)"
  },
  {
   value: "Edinburg (USEQX)",
   label: "Edinburg (USEQX)"
  },
  {
   value: "Edinburgh (USENB)",
   label: "Edinburgh (USENB)"
  },
  {
   value: "Edison (USEDN)",
   label: "Edison (USEDN)"
  },
  {
   value: "Edison (USEDS)",
   label: "Edison (USEDS)"
  },
  {
   value: "Edmond (USEOD)",
   label: "Edmond (USEOD)"
  },
  {
   value: "East Camden (USECN)",
   label: "East Camden (USECN)"
  },
  {
   value: "East Chicago (USECH)",
   label: "East Chicago (USECH)"
  },
  {
   value: "East Danville (USEZV)",
   label: "East Danville (USEZV)"
  },
  {
   value: "East Douglas (USEDO)",
   label: "East Douglas (USEDO)"
  },
  {
   value: "East Farmingdale (USEFR)",
   label: "East Farmingdale (USEFR)"
  },
  {
   value: "East Flat Rock (USERK)",
   label: "East Flat Rock (USERK)"
  },
  {
   value: "East Goshen (USEGO)",
   label: "East Goshen (USEGO)"
  },
  {
   value: "East Granby (USEBY)",
   label: "East Granby (USEBY)"
  },
  {
   value: "East Grand Forks (USEGQ)",
   label: "East Grand Forks (USEGQ)"
  },
  {
   value: "East Greenbush (USEGY)",
   label: "East Greenbush (USEGY)"
  },
  {
   value: "East Greenville (USUFT)",
   label: "East Greenville (USUFT)"
  },
  {
   value: "East Greenwich (USUFU)",
   label: "East Greenwich (USUFU)"
  },
  {
   value: "East Hanover (USEHA)",
   label: "East Hanover (USEHA)"
  },
  {
   value: "East Hartford (USEHT)",
   label: "East Hartford (USEHT)"
  },
  {
   value: "East Haven (USEHV)",
   label: "East Haven (USEHV)"
  },
  {
   value: "East Irvine (USEAI)",
   label: "East Irvine (USEAI)"
  },
  {
   value: "East Jordan (USEJD)",
   label: "East Jordan (USEJD)"
  },
  {
   value: "East Liberty (USELI)",
   label: "East Liberty (USELI)"
  },
  {
   value: "East Liverpool (USELO)",
   label: "East Liverpool (USELO)"
  },
  {
   value: "East London (USXFD)",
   label: "East London (USXFD)"
  },
  {
   value: "East Los Angeles (USETA)",
   label: "East Los Angeles (USETA)"
  },
  {
   value: "East Millinocket (USEMI)",
   label: "East Millinocket (USEMI)"
  },
  {
   value: "East Moline (USEMN)",
   label: "East Moline (USEMN)"
  },
  {
   value: "East Newark (USETK)",
   label: "East Newark (USETK)"
  },
  {
   value: "East Norwalk (USENQ)",
   label: "East Norwalk (USENQ)"
  },
  {
   value: "East Palo Alto (USEPD)",
   label: "East Palo Alto (USEPD)"
  },
  {
   value: "East Peoria (USEPO)",
   label: "East Peoria (USEPO)"
  },
  {
   value: "East Point (USEPG)",
   label: "East Point (USEPG)"
  },
  {
   value: "East Providence (USEPR)",
   label: "East Providence (USEPR)"
  },
  {
   value: "East Providence (USEPJ)",
   label: "East Providence (USEPJ)"
  },
  {
   value: "East Quogue (USEQG)",
   label: "East Quogue (USEQG)"
  },
  {
   value: "East Rutherford (USERU)",
   label: "East Rutherford (USERU)"
  },
  {
   value: "East Saint Louis (USESL)",
   label: "East Saint Louis (USESL)"
  },
  {
   value: "East Sparta (USESO)",
   label: "East Sparta (USESO)"
  },
  {
   value: "East Stroudsburg (USESP)",
   label: "East Stroudsburg (USESP)"
  },
  {
   value: "East Syracuse (USESY)",
   label: "East Syracuse (USESY)"
  },
  {
   value: "East Weymouth (USEWY)",
   label: "East Weymouth (USEWY)"
  },
  {
   value: "Dunkirk (USDKK)",
   label: "Dunkirk (USDKK)"
  },
  {
   value: "Dunkirk (USDKD)",
   label: "Dunkirk (USDKD)"
  },
  {
   value: "Dunmore (USDNZ)",
   label: "Dunmore (USDNZ)"
  },
  {
   value: "Dunn (USDUM)",
   label: "Dunn (USDUM)"
  },
  {
   value: "Dunn (USDUZ)",
   label: "Dunn (USDUZ)"
  },
  {
   value: "Dunseith (USDUN)",
   label: "Dunseith (USDUN)"
  },
  {
   value: "Duquoin (USDUQ)",
   label: "Duquoin (USDUQ)"
  },
  {
   value: "Durand (USDDI)",
   label: "Durand (USDDI)"
  },
  {
   value: "Durand (USDXD)",
   label: "Durand (USDXD)"
  },
  {
   value: "Durango (USDRO)",
   label: "Durango (USDRO)"
  },
  {
   value: "Durant (USDUA)",
   label: "Durant (USDUA)"
  },
  {
   value: "Durbin (USDUW)",
   label: "Durbin (USDUW)"
  },
  {
   value: "Durham (USDHQ)",
   label: "Durham (USDHQ)"
  },
  {
   value: "Durham (USDHH)",
   label: "Durham (USDHH)"
  },
  {
   value: "Duryea (USDYA)",
   label: "Duryea (USDYA)"
  },
  {
   value: "Dushore (USDUS)",
   label: "Dushore (USDUS)"
  },
  {
   value: "Dutch Harbor (USDUT)",
   label: "Dutch Harbor (USDUT)"
  },
  {
   value: "Dwight (USDWI)",
   label: "Dwight (USDWI)"
  },
  {
   value: "Dyer (USDYS)",
   label: "Dyer (USDYS)"
  },
  {
   value: "Dyersburg (USDYR)",
   label: "Dyersburg (USDYR)"
  },
  {
   value: "Dyersville (USDYE)",
   label: "Dyersville (USDYE)"
  },
  {
   value: "Eagan (USUFS)",
   label: "Eagan (USUFS)"
  },
  {
   value: "Eagle Grove (USEGF)",
   label: "Eagle Grove (USEGF)"
  },
  {
   value: "Eagle Pass (USEGP)",
   label: "Eagle Pass (USEGP)"
  },
  {
   value: "Eagle Point (USEAG)",
   label: "Eagle Point (USEAG)"
  },
  {
   value: "Eagle River (USERQ)",
   label: "Eagle River (USERQ)"
  },
  {
   value: "Eagle Rock (USERO)",
   label: "Eagle Rock (USERO)"
  },
  {
   value: "Earle (USEAM)",
   label: "Earle (USEAM)"
  },
  {
   value: "Earth City (USETC)",
   label: "Earth City (USETC)"
  },
  {
   value: "Easley (USEAL)",
   label: "Easley (USEAL)"
  },
  {
   value: "East Alton (USEOL)",
   label: "East Alton (USEOL)"
  },
  {
   value: "East Aurora (USEAO)",
   label: "East Aurora (USEAO)"
  },
  {
   value: "East Berlin (USEBL)",
   label: "East Berlin (USEBL)"
  },
  {
   value: "East Berlin (USAAV)",
   label: "East Berlin (USAAV)"
  },
  {
   value: "East Boston (USEBN)",
   label: "East Boston (USEBN)"
  },
  {
   value: "East Bridgeport (USEBC)",
   label: "East Bridgeport (USEBC)"
  },
  {
   value: "East Bridgewater (USEAB)",
   label: "East Bridgewater (USEAB)"
  },
  {
   value: "East Brookfield (USEBQ)",
   label: "East Brookfield (USEBQ)"
  },
  {
   value: "East Brunswick (USEBR)",
   label: "East Brunswick (USEBR)"
  },
  {
   value: "East Butler (USEBT)",
   label: "East Butler (USEBT)"
  },
  {
   value: "East Cambridge (USECM)",
   label: "East Cambridge (USECM)"
  },
  {
   value: "Dover (USDOR)",
   label: "Dover (USDOR)"
  },
  {
   value: "Dowagiac (USDOW)",
   label: "Dowagiac (USDOW)"
  },
  {
   value: "Downers Grove (USUFO)",
   label: "Downers Grove (USUFO)"
  },
  {
   value: "Downey (USDWZ)",
   label: "Downey (USDWZ)"
  },
  {
   value: "Downey (USJDY)",
   label: "Downey (USJDY)"
  },
  {
   value: "Downingtown (USDNT)",
   label: "Downingtown (USDNT)"
  },
  {
   value: "Doyle (USXFC)",
   label: "Doyle (USXFC)"
  },
  {
   value: "Doylestown (USDYL)",
   label: "Doylestown (USDYL)"
  },
  {
   value: "Dracut (USXEV)",
   label: "Dracut (USXEV)"
  },
  {
   value: "Dravosburg (USDVB)",
   label: "Dravosburg (USDVB)"
  },
  {
   value: "Drayton Plains (USDMI)",
   label: "Drayton Plains (USDMI)"
  },
  {
   value: "Dresden (USDRE)",
   label: "Dresden (USDRE)"
  },
  {
   value: "Dresden (USAAU)",
   label: "Dresden (USAAU)"
  },
  {
   value: "Dresser (USDSW)",
   label: "Dresser (USDSW)"
  },
  {
   value: "Drexel (USDRX)",
   label: "Drexel (USDRX)"
  },
  {
   value: "Drift River (USDRF)",
   label: "Drift River (USDRF)"
  },
  {
   value: "Dry Branch (USDRY)",
   label: "Dry Branch (USDRY)"
  },
  {
   value: "Dry Ridge (USDDJ)",
   label: "Dry Ridge (USDDJ)"
  },
  {
   value: "Du Pont (USABX)",
   label: "Du Pont (USABX)"
  },
  {
   value: "Duarte (USDUB)",
   label: "Duarte (USDUB)"
  },
  {
   value: "Dublin (USDQB)",
   label: "Dublin (USDQB)"
  },
  {
   value: "Dublin (USDBN)",
   label: "Dublin (USDBN)"
  },
  {
   value: "Dublin (USDUO)",
   label: "Dublin (USDUO)"
  },
  {
   value: "Dublin (USPSK)",
   label: "Dublin (USPSK)"
  },
  {
   value: "Dubois (USDBS)",
   label: "Dubois (USDBS)"
  },
  {
   value: "Dubois (USDUJ)",
   label: "Dubois (USDUJ)"
  },
  {
   value: "Dubois (USDBI)",
   label: "Dubois (USDBI)"
  },
  {
   value: "Dubuque (USDBQ)",
   label: "Dubuque (USDBQ)"
  },
  {
   value: "Dugway (USDPG)",
   label: "Dugway (USDPG)"
  },
  {
   value: "Dulles Int Apt\/Washington (USIAD)",
   label: "Dulles Int Apt\/Washington (USIAD)"
  },
  {
   value: "Duluth (USDLH)",
   label: "Duluth (USDLH)"
  },
  {
   value: "Duluth (USDGA)",
   label: "Duluth (USDGA)"
  },
  {
   value: "Dumas (USDMS)",
   label: "Dumas (USDMS)"
  },
  {
   value: "Dumas (USDUX)",
   label: "Dumas (USDUX)"
  },
  {
   value: "Dunbar (USDWV)",
   label: "Dunbar (USDWV)"
  },
  {
   value: "Duncan (USDNK)",
   label: "Duncan (USDNK)"
  },
  {
   value: "Duncansville (USDUV)",
   label: "Duncansville (USDUV)"
  },
  {
   value: "Dundalk (USDDQ)",
   label: "Dundalk (USDDQ)"
  },
  {
   value: "Dundee (USDYI)",
   label: "Dundee (USDYI)"
  },
  {
   value: "Dundee (USDYK)",
   label: "Dundee (USDYK)"
  },
  {
   value: "Dunedin (USDNB)",
   label: "Dunedin (USDNB)"
  },
  {
   value: "Dunellen (USDUC)",
   label: "Dunellen (USDUC)"
  },
  {
   value: "Dillon (USDLL)",
   label: "Dillon (USDLL)"
  },
  {
   value: "Dillwyn (USUFP)",
   label: "Dillwyn (USUFP)"
  },
  {
   value: "Dilworth (USDWH)",
   label: "Dilworth (USDWH)"
  },
  {
   value: "Dilworth (USDLW)",
   label: "Dilworth (USDLW)"
  },
  {
   value: "Dimondale (USDML)",
   label: "Dimondale (USDML)"
  },
  {
   value: "Dinuba (USDIU)",
   label: "Dinuba (USDIU)"
  },
  {
   value: "Disputanta (USDPV)",
   label: "Disputanta (USDPV)"
  },
  {
   value: "Dixon (USDXN)",
   label: "Dixon (USDXN)"
  },
  {
   value: "Dixon (USDXC)",
   label: "Dixon (USDXC)"
  },
  {
   value: "Dodge (USDDG)",
   label: "Dodge (USDDG)"
  },
  {
   value: "Dodge Center (USXEU)",
   label: "Dodge Center (USXEU)"
  },
  {
   value: "Dodge City (USDDC)",
   label: "Dodge City (USDDC)"
  },
  {
   value: "Doe Run (USDOE)",
   label: "Doe Run (USDOE)"
  },
  {
   value: "Dollar Bay (USDXY)",
   label: "Dollar Bay (USDXY)"
  },
  {
   value: "Dolomite (USDOL)",
   label: "Dolomite (USDOL)"
  },
  {
   value: "Dominguez (USDMZ)",
   label: "Dominguez (USDMZ)"
  },
  {
   value: "Dominguez Hills (USDIZ)",
   label: "Dominguez Hills (USDIZ)"
  },
  {
   value: "Donaldson (USDON)",
   label: "Donaldson (USDON)"
  },
  {
   value: "Donaldsonville (USDNA)",
   label: "Donaldsonville (USDNA)"
  },
  {
   value: "Dongola (USDNG)",
   label: "Dongola (USDNG)"
  },
  {
   value: "Donna (USXEY)",
   label: "Donna (USXEY)"
  },
  {
   value: "Donnelly (USDYX)",
   label: "Donnelly (USDYX)"
  },
  {
   value: "Donora (USDRP)",
   label: "Donora (USDRP)"
  },
  {
   value: "Donville (USDVI)",
   label: "Donville (USDVI)"
  },
  {
   value: "Doraville (USDRH)",
   label: "Doraville (USDRH)"
  },
  {
   value: "Dorchester (USDCS)",
   label: "Dorchester (USDCS)"
  },
  {
   value: "Dorrance (USDCK)",
   label: "Dorrance (USDCK)"
  },
  {
   value: "Dorsey (USDRS)",
   label: "Dorsey (USDRS)"
  },
  {
   value: "Doswell (USDOS)",
   label: "Doswell (USDOS)"
  },
  {
   value: "Dothan (USDHN)",
   label: "Dothan (USDHN)"
  },
  {
   value: "Douglas (USDUG)",
   label: "Douglas (USDUG)"
  },
  {
   value: "Douglas (USDGZ)",
   label: "Douglas (USDGZ)"
  },
  {
   value: "Douglas (USDOU)",
   label: "Douglas (USDOU)"
  },
  {
   value: "Douglas (USDGW)",
   label: "Douglas (USDGW)"
  },
  {
   value: "Douglassville (USDGL)",
   label: "Douglassville (USDGL)"
  },
  {
   value: "Douglaston (USDGN)",
   label: "Douglaston (USDGN)"
  },
  {
   value: "Douglasville (USDGV)",
   label: "Douglasville (USDGV)"
  },
  {
   value: "Dover (USDER)",
   label: "Dover (USDER)"
  },
  {
   value: "Dover (USDVJ)",
   label: "Dover (USDVJ)"
  },
  {
   value: "Dover (USXEZ)",
   label: "Dover (USXEZ)"
  },
  {
   value: "Dover (USDRV)",
   label: "Dover (USDRV)"
  },
  {
   value: "Dover (USDOO)",
   label: "Dover (USDOO)"
  },
  {
   value: "Deming (USDMN)",
   label: "Deming (USDMN)"
  },
  {
   value: "Demopolis (USDMP)",
   label: "Demopolis (USDMP)"
  },
  {
   value: "Denali (USDNI)",
   label: "Denali (USDNI)"
  },
  {
   value: "Denham Springs (USDNM)",
   label: "Denham Springs (USDNM)"
  },
  {
   value: "Denison (USDSZ)",
   label: "Denison (USDSZ)"
  },
  {
   value: "Denison (USDNS)",
   label: "Denison (USDNS)"
  },
  {
   value: "Denton (USDTN)",
   label: "Denton (USDTN)"
  },
  {
   value: "Denver (USDID)",
   label: "Denver (USDID)"
  },
  {
   value: "Denver (USDEN)",
   label: "Denver (USDEN)"
  },
  {
   value: "Denver (USDNQ)",
   label: "Denver (USDNQ)"
  },
  {
   value: "Denver City (USDVC)",
   label: "Denver City (USDVC)"
  },
  {
   value: "Denville (USDVL)",
   label: "Denville (USDVL)"
  },
  {
   value: "Depew (USDPE)",
   label: "Depew (USDPE)"
  },
  {
   value: "Deposit (USDPI)",
   label: "Deposit (USDPI)"
  },
  {
   value: "Deptford (USDPF)",
   label: "Deptford (USDPF)"
  },
  {
   value: "Derby (USDCT)",
   label: "Derby (USDCT)"
  },
  {
   value: "Derby Line (USDBY)",
   label: "Derby Line (USDBY)"
  },
  {
   value: "Derma (USDIM)",
   label: "Derma (USDIM)"
  },
  {
   value: "Derry (USDNP)",
   label: "Derry (USDNP)"
  },
  {
   value: "Des Moines (USDSM)",
   label: "Des Moines (USDSM)"
  },
  {
   value: "Des Plaines (USDES)",
   label: "Des Plaines (USDES)"
  },
  {
   value: "Desert Hot Springs (USDHS)",
   label: "Desert Hot Springs (USDHS)"
  },
  {
   value: "Destrehan (USNEW)",
   label: "Destrehan (USNEW)"
  },
  {
   value: "Detour (USDTO)",
   label: "Detour (USDTO)"
  },
  {
   value: "Detroit (USDTR)",
   label: "Detroit (USDTR)"
  },
  {
   value: "Detroit City (USDET)",
   label: "Detroit City (USDET)"
  },
  {
   value: "Detroit Lakes (USDTL)",
   label: "Detroit Lakes (USDTL)"
  },
  {
   value: "Devine (USDVD)",
   label: "Devine (USDVD)"
  },
  {
   value: "Devon (USDEV)",
   label: "Devon (USDEV)"
  },
  {
   value: "Dewey (USDWO)",
   label: "Dewey (USDWO)"
  },
  {
   value: "Dewitt (USDEW)",
   label: "Dewitt (USDEW)"
  },
  {
   value: "Dewitt (USDEZ)",
   label: "Dewitt (USDEZ)"
  },
  {
   value: "Dewitt (USDWW)",
   label: "Dewitt (USDWW)"
  },
  {
   value: "Dexter (USDXE)",
   label: "Dexter (USDXE)"
  },
  {
   value: "Dexter (USXFB)",
   label: "Dexter (USXFB)"
  },
  {
   value: "Diamond Bar (USDBR)",
   label: "Diamond Bar (USDBR)"
  },
  {
   value: "Diamond Springs (USDXG)",
   label: "Diamond Springs (USDXG)"
  },
  {
   value: "Diboll (USDIB)",
   label: "Diboll (USDIB)"
  },
  {
   value: "Dickinson (USDIK)",
   label: "Dickinson (USDIK)"
  },
  {
   value: "Dickinson (USDSX)",
   label: "Dickinson (USDSX)"
  },
  {
   value: "Dierks (USDKS)",
   label: "Dierks (USDKS)"
  },
  {
   value: "Dighton (USDGT)",
   label: "Dighton (USDGT)"
  },
  {
   value: "Decatur (USDTV)",
   label: "Decatur (USDTV)"
  },
  {
   value: "Decatur (USDEC)",
   label: "Decatur (USDEC)"
  },
  {
   value: "Decatur (USDEM)",
   label: "Decatur (USDEM)"
  },
  {
   value: "Decatur (USXEX)",
   label: "Decatur (USXEX)"
  },
  {
   value: "Declo (USDCL)",
   label: "Declo (USDCL)"
  },
  {
   value: "Decorah (USDEH)",
   label: "Decorah (USDEH)"
  },
  {
   value: "Dedham (USDED)",
   label: "Dedham (USDED)"
  },
  {
   value: "Deep River (USDEQ)",
   label: "Deep River (USDEQ)"
  },
  {
   value: "Deepwater (USDPW)",
   label: "Deepwater (USDPW)"
  },
  {
   value: "Deer Park (USDPK)",
   label: "Deer Park (USDPK)"
  },
  {
   value: "Deer Park (USDEX)",
   label: "Deer Park (USDEX)"
  },
  {
   value: "Deer Park (USXFA)",
   label: "Deer Park (USXFA)"
  },
  {
   value: "Deerfield (USDRD)",
   label: "Deerfield (USDRD)"
  },
  {
   value: "Deerfield (USDFD)",
   label: "Deerfield (USDFD)"
  },
  {
   value: "Deerfield (USDFL)",
   label: "Deerfield (USDFL)"
  },
  {
   value: "Deerfield (USDFM)",
   label: "Deerfield (USDFM)"
  },
  {
   value: "Deerfield (USDLZ)",
   label: "Deerfield (USDLZ)"
  },
  {
   value: "Deerfield Beach (USDEE)",
   label: "Deerfield Beach (USDEE)"
  },
  {
   value: "Deerpark (USDPA)",
   label: "Deerpark (USDPA)"
  },
  {
   value: "Defense (USDFX)",
   label: "Defense (USDFX)"
  },
  {
   value: "Deferiet (USDEF)",
   label: "Deferiet (USDEF)"
  },
  {
   value: "Defiance (USDFI)",
   label: "Defiance (USDFI)"
  },
  {
   value: "Del Bonita (USDBA)",
   label: "Del Bonita (USDBA)"
  },
  {
   value: "Del Rio (USDRT)",
   label: "Del Rio (USDRT)"
  },
  {
   value: "Delair (USDLA)",
   label: "Delair (USDLA)"
  },
  {
   value: "Delanco (USDLJ)",
   label: "Delanco (USDLJ)"
  },
  {
   value: "Delano (USDOX)",
   label: "Delano (USDOX)"
  },
  {
   value: "Delano (USDLN)",
   label: "Delano (USDLN)"
  },
  {
   value: "Delano (USDNO)",
   label: "Delano (USDNO)"
  },
  {
   value: "Delavan (USDEA)",
   label: "Delavan (USDEA)"
  },
  {
   value: "Delaware (USDEL)",
   label: "Delaware (USDEL)"
  },
  {
   value: "Delaware (USDWE)",
   label: "Delaware (USDWE)"
  },
  {
   value: "Delaware City (USDCI)",
   label: "Delaware City (USDCI)"
  },
  {
   value: "Delaware Water Gap (USDWG)",
   label: "Delaware Water Gap (USDWG)"
  },
  {
   value: "Delevan (USDVZ)",
   label: "Delevan (USDVZ)"
  },
  {
   value: "Delisle (USDLE)",
   label: "Delisle (USDLE)"
  },
  {
   value: "Delphos (USDEP)",
   label: "Delphos (USDEP)"
  },
  {
   value: "Delran (USDRJ)",
   label: "Delran (USDRJ)"
  },
  {
   value: "Delray Beach (USDEY)",
   label: "Delray Beach (USDEY)"
  },
  {
   value: "Delta Junction (USDJN)",
   label: "Delta Junction (USDJN)"
  },
  {
   value: "Deltona (USDLT)",
   label: "Deltona (USDLT)"
  },
  {
   value: "Danville (USDNV)",
   label: "Danville (USDNV)"
  },
  {
   value: "Danville (USDLV)",
   label: "Danville (USDLV)"
  },
  {
   value: "Darby (USDBB)",
   label: "Darby (USDBB)"
  },
  {
   value: "Dardanelle (USDAA)",
   label: "Dardanelle (USDAA)"
  },
  {
   value: "Darien (USDRU)",
   label: "Darien (USDRU)"
  },
  {
   value: "Darlington (USDRN)",
   label: "Darlington (USDRN)"
  },
  {
   value: "Darlington (USDLP)",
   label: "Darlington (USDLP)"
  },
  {
   value: "Darrow (USDRR)",
   label: "Darrow (USDRR)"
  },
  {
   value: "Davant (USDVT)",
   label: "Davant (USDVT)"
  },
  {
   value: "Davenport (USDAV)",
   label: "Davenport (USDAV)"
  },
  {
   value: "Davenport (USDVN)",
   label: "Davenport (USDVN)"
  },
  {
   value: "Davenport (USDVP)",
   label: "Davenport (USDVP)"
  },
  {
   value: "Davidson (USDAO)",
   label: "Davidson (USDAO)"
  },
  {
   value: "Davie (USDVF)",
   label: "Davie (USDVF)"
  },
  {
   value: "Davie (USDVE)",
   label: "Davie (USDVE)"
  },
  {
   value: "Davis (USDAS)",
   label: "Davis (USDAS)"
  },
  {
   value: "Davisville (USDVV)",
   label: "Davisville (USDVV)"
  },
  {
   value: "Dawson (USDAW)",
   label: "Dawson (USDAW)"
  },
  {
   value: "Dawson Springs (USDSG)",
   label: "Dawson Springs (USDSG)"
  },
  {
   value: "Dayton (USDYT)",
   label: "Dayton (USDYT)"
  },
  {
   value: "Dayton (USDAY)",
   label: "Dayton (USDAY)"
  },
  {
   value: "Dayton (USDYV)",
   label: "Dayton (USDYV)"
  },
  {
   value: "Dayton (USXET)",
   label: "Dayton (USXET)"
  },
  {
   value: "Dayton (USDAT)",
   label: "Dayton (USDAT)"
  },
  {
   value: "Dayton (USDTX)",
   label: "Dayton (USDTX)"
  },
  {
   value: "Dayton (USDYW)",
   label: "Dayton (USDYW)"
  },
  {
   value: "Dayton (USDYJ)",
   label: "Dayton (USDYJ)"
  },
  {
   value: "Daytona Beach (USDAB)",
   label: "Daytona Beach (USDAB)"
  },
  {
   value: "Dayville (USDLK)",
   label: "Dayville (USDLK)"
  },
  {
   value: "De Forest (USDFO)",
   label: "De Forest (USDFO)"
  },
  {
   value: "De Funiak Springs (USDFN)",
   label: "De Funiak Springs (USDFN)"
  },
  {
   value: "De Kalb (USDEK)",
   label: "De Kalb (USDEK)"
  },
  {
   value: "De Land (USDLD)",
   label: "De Land (USDLD)"
  },
  {
   value: "De Leon Springs (USDLF)",
   label: "De Leon Springs (USDLF)"
  },
  {
   value: "De Pere (USDRW)",
   label: "De Pere (USDRW)"
  },
  {
   value: "De Ridder (USDRI)",
   label: "De Ridder (USDRI)"
  },
  {
   value: "De Witt (USDWT)",
   label: "De Witt (USDWT)"
  },
  {
   value: "De Witt (USDWA)",
   label: "De Witt (USDWA)"
  },
  {
   value: "Dearborn (USDEO)",
   label: "Dearborn (USDEO)"
  },
  {
   value: "Decatur (USDCG)",
   label: "Decatur (USDCG)"
  },
  {
   value: "Decatur (USDCU)",
   label: "Decatur (USDCU)"
  },
  {
   value: "Cumming (USCMG)",
   label: "Cumming (USCMG)"
  },
  {
   value: "Cupertino (USCUO)",
   label: "Cupertino (USCUO)"
  },
  {
   value: "Curwensville (USCUI)",
   label: "Curwensville (USCUI)"
  },
  {
   value: "Cut And Shoot (USCUF)",
   label: "Cut And Shoot (USCUF)"
  },
  {
   value: "Cutler (USCUG)",
   label: "Cutler (USCUG)"
  },
  {
   value: "Cuyahoga Falls (USCUH)",
   label: "Cuyahoga Falls (USCUH)"
  },
  {
   value: "Cynthiana (USCAZ)",
   label: "Cynthiana (USCAZ)"
  },
  {
   value: "Cypress (USCYQ)",
   label: "Cypress (USCYQ)"
  },
  {
   value: "Cypress (USCYX)",
   label: "Cypress (USCYX)"
  },
  {
   value: "Dacula (USDQL)",
   label: "Dacula (USDQL)"
  },
  {
   value: "Dade City (USDDB)",
   label: "Dade City (USDDB)"
  },
  {
   value: "Dahlonega (USDHL)",
   label: "Dahlonega (USDHL)"
  },
  {
   value: "Dailey (USDAI)",
   label: "Dailey (USDAI)"
  },
  {
   value: "Daingerfield (USDFG)",
   label: "Daingerfield (USDFG)"
  },
  {
   value: "Dairy Valley (USDVA)",
   label: "Dairy Valley (USDVA)"
  },
  {
   value: "Dakota City (USDAK)",
   label: "Dakota City (USDAK)"
  },
  {
   value: "Dakota City (USDKC)",
   label: "Dakota City (USDKC)"
  },
  {
   value: "Dalhart (USDHT)",
   label: "Dalhart (USDHT)"
  },
  {
   value: "Dallas (USDLG)",
   label: "Dallas (USDLG)"
  },
  {
   value: "Dallas (USDSP)",
   label: "Dallas (USDSP)"
  },
  {
   value: "Dallas (USDAE)",
   label: "Dallas (USDAE)"
  },
  {
   value: "Dallas (USDAC)",
   label: "Dallas (USDAC)"
  },
  {
   value: "Dallas-Fort Worth Reg Apt (USDFW)",
   label: "Dallas-Fort Worth Reg Apt (USDFW)"
  },
  {
   value: "Dallastown (USDLS)",
   label: "Dallastown (USDLS)"
  },
  {
   value: "Dalton (USDPQ)",
   label: "Dalton (USDPQ)"
  },
  {
   value: "Dalton (USDNN)",
   label: "Dalton (USDNN)"
  },
  {
   value: "Dalton Cacha (USDLC)",
   label: "Dalton Cacha (USDLC)"
  },
  {
   value: "Daly City (USDXL)",
   label: "Daly City (USDXL)"
  },
  {
   value: "Damascus (USDAM)",
   label: "Damascus (USDAM)"
  },
  {
   value: "Damascus (USDSC)",
   label: "Damascus (USDSC)"
  },
  {
   value: "Danbury (USDAU)",
   label: "Danbury (USDAU)"
  },
  {
   value: "Danbury (USDXR)",
   label: "Danbury (USDXR)"
  },
  {
   value: "Dandridge (USDAX)",
   label: "Dandridge (USDAX)"
  },
  {
   value: "Dania (USDAD)",
   label: "Dania (USDAD)"
  },
  {
   value: "Danielson (USDSO)",
   label: "Danielson (USDSO)"
  },
  {
   value: "Danvers (USDVR)",
   label: "Danvers (USDVR)"
  },
  {
   value: "Danville (USAAT)",
   label: "Danville (USAAT)"
  },
  {
   value: "Danville (USDAN)",
   label: "Danville (USDAN)"
  },
  {
   value: "Danville (USDAP)",
   label: "Danville (USDAP)"
  },
  {
   value: "Danville (USDXV)",
   label: "Danville (USDXV)"
  },
  {
   value: "Danville (USDVK)",
   label: "Danville (USDVK)"
  },
  {
   value: "Crescent (USCQN)",
   label: "Crescent (USCQN)"
  },
  {
   value: "Crescent City (USCEC)",
   label: "Crescent City (USCEC)"
  },
  {
   value: "Cresco (USCTG)",
   label: "Cresco (USCTG)"
  },
  {
   value: "Cresco (USCFK)",
   label: "Cresco (USCFK)"
  },
  {
   value: "Cresskill (USCYJ)",
   label: "Cresskill (USCYJ)"
  },
  {
   value: "Cressona (USCKA)",
   label: "Cressona (USCKA)"
  },
  {
   value: "Creston (USCSQ)",
   label: "Creston (USCSQ)"
  },
  {
   value: "Crestview (USCEW)",
   label: "Crestview (USCEW)"
  },
  {
   value: "Crestwood (USCWB)",
   label: "Crestwood (USCWB)"
  },
  {
   value: "Crete (USCTF)",
   label: "Crete (USCTF)"
  },
  {
   value: "Creve Coeur (USCXD)",
   label: "Creve Coeur (USCXD)"
  },
  {
   value: "Crisfield (USCRI)",
   label: "Crisfield (USCRI)"
  },
  {
   value: "Crockett (USCRM)",
   label: "Crockett (USCRM)"
  },
  {
   value: "Crockett (USXOK)",
   label: "Crockett (USXOK)"
  },
  {
   value: "Crosby (USCGM)",
   label: "Crosby (USCGM)"
  },
  {
   value: "Crosby (USCXF)",
   label: "Crosby (USCXF)"
  },
  {
   value: "Crosbyton (USCXY)",
   label: "Crosbyton (USCXY)"
  },
  {
   value: "Cross Junction (USCXG)",
   label: "Cross Junction (USCXG)"
  },
  {
   value: "Cross Plains (USCXH)",
   label: "Cross Plains (USCXH)"
  },
  {
   value: "Crossett (USCRT)",
   label: "Crossett (USCRT)"
  },
  {
   value: "Crossville (USCSV)",
   label: "Crossville (USCSV)"
  },
  {
   value: "Croswell (USCXA)",
   label: "Croswell (USCXA)"
  },
  {
   value: "Crothersville (USCVH)",
   label: "Crothersville (USCVH)"
  },
  {
   value: "Croton (USCYO)",
   label: "Croton (USCYO)"
  },
  {
   value: "Crowley (USCWL)",
   label: "Crowley (USCWL)"
  },
  {
   value: "Crows Landing (USNRC)",
   label: "Crows Landing (USNRC)"
  },
  {
   value: "Croydon (USCWG)",
   label: "Croydon (USCWG)"
  },
  {
   value: "Crozet (USCXC)",
   label: "Crozet (USCXC)"
  },
  {
   value: "Crystal City (USCYY)",
   label: "Crystal City (USCYY)"
  },
  {
   value: "Crystal Lake (USCYF)",
   label: "Crystal Lake (USCYF)"
  },
  {
   value: "Crystal Springs (USCYH)",
   label: "Crystal Springs (USCYH)"
  },
  {
   value: "Cucamonga (USCUA)",
   label: "Cucamonga (USCUA)"
  },
  {
   value: "Cudahy (USCUY)",
   label: "Cudahy (USCUY)"
  },
  {
   value: "Cudahy (USCUD)",
   label: "Cudahy (USCUD)"
  },
  {
   value: "Cullman (USCUL)",
   label: "Cullman (USCUL)"
  },
  {
   value: "Culpeper (USAAR)",
   label: "Culpeper (USAAR)"
  },
  {
   value: "Culver City (USCVR)",
   label: "Culver City (USCVR)"
  },
  {
   value: "Culver Elect (USXDS)",
   label: "Culver Elect (USXDS)"
  },
  {
   value: "Cumberland (USCUE)",
   label: "Cumberland (USCUE)"
  },
  {
   value: "Cumberland (USCBE)",
   label: "Cumberland (USCBE)"
  },
  {
   value: "Corning (USCZC)",
   label: "Corning (USCZC)"
  },
  {
   value: "Cornwells Heights (USCZD)",
   label: "Cornwells Heights (USCZD)"
  },
  {
   value: "Corona (USCZE)",
   label: "Corona (USCZE)"
  },
  {
   value: "Corpus Christi (USCRP)",
   label: "Corpus Christi (USCRP)"
  },
  {
   value: "Corsica (USCZJ)",
   label: "Corsica (USCZJ)"
  },
  {
   value: "Corsicana (USCRS)",
   label: "Corsicana (USCRS)"
  },
  {
   value: "Corte Madera (USCZL)",
   label: "Corte Madera (USCZL)"
  },
  {
   value: "Cortland (USCTX)",
   label: "Cortland (USCTX)"
  },
  {
   value: "Corvallis-Albany (USCVO)",
   label: "Corvallis-Albany (USCVO)"
  },
  {
   value: "Corydon (USCZB)",
   label: "Corydon (USCZB)"
  },
  {
   value: "Coshocton (USCSC)",
   label: "Coshocton (USCSC)"
  },
  {
   value: "Cosmopolis (USCPS)",
   label: "Cosmopolis (USCPS)"
  },
  {
   value: "Costa Mesa (USCZN)",
   label: "Costa Mesa (USCZN)"
  },
  {
   value: "Cottondale (USCTM)",
   label: "Cottondale (USCTM)"
  },
  {
   value: "Cottonwood (USCZP)",
   label: "Cottonwood (USCZP)"
  },
  {
   value: "Cottonwood (USCZO)",
   label: "Cottonwood (USCZO)"
  },
  {
   value: "Coudersport (USCZQ)",
   label: "Coudersport (USCZQ)"
  },
  {
   value: "Counce (USCUC)",
   label: "Counce (USCUC)"
  },
  {
   value: "Council Bluffs (USCBF)",
   label: "Council Bluffs (USCBF)"
  },
  {
   value: "Country Side (USCBJ)",
   label: "Country Side (USCBJ)"
  },
  {
   value: "Coupeville (USCBL)",
   label: "Coupeville (USCBL)"
  },
  {
   value: "Courtland (USCBR)",
   label: "Courtland (USCBR)"
  },
  {
   value: "Courtland (USCBQ)",
   label: "Courtland (USCBQ)"
  },
  {
   value: "Courtland (USCBP)",
   label: "Courtland (USCBP)"
  },
  {
   value: "Coventry (USADO)",
   label: "Coventry (USADO)"
  },
  {
   value: "Covesville (USCBZ)",
   label: "Covesville (USCBZ)"
  },
  {
   value: "Covina (USCVQ)",
   label: "Covina (USCVQ)"
  },
  {
   value: "Covington (USCVJ)",
   label: "Covington (USCVJ)"
  },
  {
   value: "Covington (USCVF)",
   label: "Covington (USCVF)"
  },
  {
   value: "Covington (USAAH)",
   label: "Covington (USAAH)"
  },
  {
   value: "Covington (USCVK)",
   label: "Covington (USCVK)"
  },
  {
   value: "Cowpens (USCPQ)",
   label: "Cowpens (USCPQ)"
  },
  {
   value: "Cranberry Lake (USCPD)",
   label: "Cranberry Lake (USCPD)"
  },
  {
   value: "Cranbury (USCQE)",
   label: "Cranbury (USCQE)"
  },
  {
   value: "Crandburry (USUFM)",
   label: "Crandburry (USUFM)"
  },
  {
   value: "Crandon Lakes (USUFD)",
   label: "Crandon Lakes (USUFD)"
  },
  {
   value: "Cranford (USCQG)",
   label: "Cranford (USCQG)"
  },
  {
   value: "Cranston (USCQH)",
   label: "Cranston (USCQH)"
  },
  {
   value: "Crawfordsville (USCFB)",
   label: "Crawfordsville (USCFB)"
  },
  {
   value: "Creighton (USCQK)",
   label: "Creighton (USCQK)"
  },
  {
   value: "Connell (USXEB)",
   label: "Connell (USXEB)"
  },
  {
   value: "Connellsville (USCQP)",
   label: "Connellsville (USCQP)"
  },
  {
   value: "Connersville (USCEV)",
   label: "Connersville (USCEV)"
  },
  {
   value: "Conover (USCNK)",
   label: "Conover (USCNK)"
  },
  {
   value: "Conroe (USCXO)",
   label: "Conroe (USCXO)"
  },
  {
   value: "Conshohocken (USCSH)",
   label: "Conshohocken (USCSH)"
  },
  {
   value: "Contoocook (USCTI)",
   label: "Contoocook (USCTI)"
  },
  {
   value: "Convent (USCEN)",
   label: "Convent (USCEN)"
  },
  {
   value: "Convent (USCNV)",
   label: "Convent (USCNV)"
  },
  {
   value: "Conway (USACZ)",
   label: "Conway (USACZ)"
  },
  {
   value: "Conway (USADP)",
   label: "Conway (USADP)"
  },
  {
   value: "Conyers (USCYR)",
   label: "Conyers (USCYR)"
  },
  {
   value: "Cookeville (USUAU)",
   label: "Cookeville (USUAU)"
  },
  {
   value: "Cookville (USCKZ)",
   label: "Cookville (USCKZ)"
  },
  {
   value: "Coon Rapids (USCRN)",
   label: "Coon Rapids (USCRN)"
  },
  {
   value: "Coon Rapids (USXEG)",
   label: "Coon Rapids (USXEG)"
  },
  {
   value: "Cooper Landing (USCEI)",
   label: "Cooper Landing (USCEI)"
  },
  {
   value: "Cooper River (USCEH)",
   label: "Cooper River (USCEH)"
  },
  {
   value: "Coopersburg (USCPU)",
   label: "Coopersburg (USCPU)"
  },
  {
   value: "Coos Bay (USCOB)",
   label: "Coos Bay (USCOB)"
  },
  {
   value: "Copiague (USCET)",
   label: "Copiague (USCET)"
  },
  {
   value: "Copinth (USCOJ)",
   label: "Copinth (USCOJ)"
  },
  {
   value: "Copley (USCPY)",
   label: "Copley (USCPY)"
  },
  {
   value: "Coppell (USCEJ)",
   label: "Coppell (USCEJ)"
  },
  {
   value: "Copperhill (USCPI)",
   label: "Copperhill (USCPI)"
  },
  {
   value: "Coral Springs (USCPJ)",
   label: "Coral Springs (USCPJ)"
  },
  {
   value: "Coralville (USCVB)",
   label: "Coralville (USCVB)"
  },
  {
   value: "Coram (USUFF)",
   label: "Coram (USUFF)"
  },
  {
   value: "Coraopolis (USCPP)",
   label: "Coraopolis (USCPP)"
  },
  {
   value: "Corbin (USCBI)",
   label: "Corbin (USCBI)"
  },
  {
   value: "Corcoran (USCRO)",
   label: "Corcoran (USCRO)"
  },
  {
   value: "Cordele (USADF)",
   label: "Cordele (USADF)"
  },
  {
   value: "Cordova (USCDV)",
   label: "Cordova (USCDV)"
  },
  {
   value: "Cordova (USCYV)",
   label: "Cordova (USCYV)"
  },
  {
   value: "Corinth (USXEM)",
   label: "Corinth (USXEM)"
  },
  {
   value: "Corinth (USCRX)",
   label: "Corinth (USCRX)"
  },
  {
   value: "Corlenius (USCZG)",
   label: "Corlenius (USCZG)"
  },
  {
   value: "Cornelia (USCZA)",
   label: "Cornelia (USCZA)"
  },
  {
   value: "Cornelius Pass (USCZH)",
   label: "Cornelius Pass (USCZH)"
  },
  {
   value: "Corning (USCGC)",
   label: "Corning (USCGC)"
  },
  {
   value: "Corning (USADB)",
   label: "Corning (USADB)"
  },
  {
   value: "Colorado Springs (USCOS)",
   label: "Colorado Springs (USCOS)"
  },
  {
   value: "Colquitt (USCOQ)",
   label: "Colquitt (USCOQ)"
  },
  {
   value: "Colrain (USXEE)",
   label: "Colrain (USXEE)"
  },
  {
   value: "Colton (USRTO)",
   label: "Colton (USRTO)"
  },
  {
   value: "Colts Neck (USCTN)",
   label: "Colts Neck (USCTN)"
  },
  {
   value: "Columbia (USCOU)",
   label: "Columbia (USCOU)"
  },
  {
   value: "Columbia (USCOZ)",
   label: "Columbia (USCOZ)"
  },
  {
   value: "Columbia (USACW)",
   label: "Columbia (USACW)"
  },
  {
   value: "Columbia (USCFM)",
   label: "Columbia (USCFM)"
  },
  {
   value: "Columbia (USCKP)",
   label: "Columbia (USCKP)"
  },
  {
   value: "Columbia (USCAE)",
   label: "Columbia (USCAE)"
  },
  {
   value: "Columbia (USMRC)",
   label: "Columbia (USMRC)"
  },
  {
   value: "Columbia (USCQL)",
   label: "Columbia (USCQL)"
  },
  {
   value: "Columbia City (USCAJ)",
   label: "Columbia City (USCAJ)"
  },
  {
   value: "Columbia Station (USCAF)",
   label: "Columbia Station (USCAF)"
  },
  {
   value: "Columbiana (USCOG)",
   label: "Columbiana (USCOG)"
  },
  {
   value: "Columbus (USCLU)",
   label: "Columbus (USCLU)"
  },
  {
   value: "Columbus (USCBW)",
   label: "Columbus (USCBW)"
  },
  {
   value: "Columbus (USCSG)",
   label: "Columbus (USCSG)"
  },
  {
   value: "Columbus (USUBS)",
   label: "Columbus (USUBS)"
  },
  {
   value: "Columbus (USCUS)",
   label: "Columbus (USCUS)"
  },
  {
   value: "Columbus (USVDA)",
   label: "Columbus (USVDA)"
  },
  {
   value: "Columbus (USOLU)",
   label: "Columbus (USOLU)"
  },
  {
   value: "Columbus (USCMH)",
   label: "Columbus (USCMH)"
  },
  {
   value: "Columbus Junction (USCQB)",
   label: "Columbus Junction (USCQB)"
  },
  {
   value: "Colusa (USCQC)",
   label: "Colusa (USCQC)"
  },
  {
   value: "Colwich (USCWO)",
   label: "Colwich (USCWO)"
  },
  {
   value: "Comanche (USCMJ)",
   label: "Comanche (USCMJ)"
  },
  {
   value: "Comanche (USCMC)",
   label: "Comanche (USCMC)"
  },
  {
   value: "Combined Locks (USXDM)",
   label: "Combined Locks (USXDM)"
  },
  {
   value: "Commack (USCMF)",
   label: "Commack (USCMF)"
  },
  {
   value: "Commerce (USCRC)",
   label: "Commerce (USCRC)"
  },
  {
   value: "Commerce City (USCMT)",
   label: "Commerce City (USCMT)"
  },
  {
   value: "Compton (USCPM)",
   label: "Compton (USCPM)"
  },
  {
   value: "Comstock (USCVC)",
   label: "Comstock (USCVC)"
  },
  {
   value: "Comyn (USCYM)",
   label: "Comyn (USCYM)"
  },
  {
   value: "Concord (USCON)",
   label: "Concord (USCON)"
  },
  {
   value: "Concord (USCCR)",
   label: "Concord (USCCR)"
  },
  {
   value: "Concord (USXEA)",
   label: "Concord (USXEA)"
  },
  {
   value: "Conley (USCNY)",
   label: "Conley (USCNY)"
  },
  {
   value: "Conneaut (USCDY)",
   label: "Conneaut (USCDY)"
  },
  {
   value: "Coachella (USCOC)",
   label: "Coachella (USCOC)"
  },
  {
   value: "Coal City (USCOY)",
   label: "Coal City (USCOY)"
  },
  {
   value: "Coatesville (USCTH)",
   label: "Coatesville (USCTH)"
  },
  {
   value: "Coburg (USCUR)",
   label: "Coburg (USCUR)"
  },
  {
   value: "Cockeysville (USCCQ)",
   label: "Cockeysville (USCCQ)"
  },
  {
   value: "Cocoa (USCOI)",
   label: "Cocoa (USCOI)"
  },
  {
   value: "Coconut Creek (USCCU)",
   label: "Coconut Creek (USCCU)"
  },
  {
   value: "Cody (USCOD)",
   label: "Cody (USCOD)"
  },
  {
   value: "Coeur D'Alene (USCOE)",
   label: "Coeur D'Alene (USCOE)"
  },
  {
   value: "Coffeeville (USCFV)",
   label: "Coffeeville (USCFV)"
  },
  {
   value: "Cohasset (USXEF)",
   label: "Cohasset (USXEF)"
  },
  {
   value: "Cohoes (USCOO)",
   label: "Cohoes (USCOO)"
  },
  {
   value: "Cohutta (USAAG)",
   label: "Cohutta (USAAG)"
  },
  {
   value: "Cokato (USCOK)",
   label: "Cokato (USCOK)"
  },
  {
   value: "Colbert (USCOL)",
   label: "Colbert (USCOL)"
  },
  {
   value: "Colby (USCBK)",
   label: "Colby (USCBK)"
  },
  {
   value: "Colchester (USCCV)",
   label: "Colchester (USCCV)"
  },
  {
   value: "Cold Spring (USCDM)",
   label: "Cold Spring (USCDM)"
  },
  {
   value: "Coldwater (USCWA)",
   label: "Coldwater (USCWA)"
  },
  {
   value: "Coldwater (USCOW)",
   label: "Coldwater (USCOW)"
  },
  {
   value: "Colebrook (USCKN)",
   label: "Colebrook (USCKN)"
  },
  {
   value: "Coleman (USCMA)",
   label: "Coleman (USCMA)"
  },
  {
   value: "Colfax (USCOF)",
   label: "Colfax (USCOF)"
  },
  {
   value: "College (USCEQ)",
   label: "College (USCEQ)"
  },
  {
   value: "College Grove (USCGG)",
   label: "College Grove (USCGG)"
  },
  {
   value: "College Park (USCPG)",
   label: "College Park (USCPG)"
  },
  {
   value: "College Park (USCGP)",
   label: "College Park (USCGP)"
  },
  {
   value: "College Point (USCOP)",
   label: "College Point (USCOP)"
  },
  {
   value: "Collegedale (USCGD)",
   label: "Collegedale (USCGD)"
  },
  {
   value: "Collegeville (USCGV)",
   label: "Collegeville (USCGV)"
  },
  {
   value: "Collierville (USCIV)",
   label: "Collierville (USCIV)"
  },
  {
   value: "Collingdale (USCGL)",
   label: "Collingdale (USCGL)"
  },
  {
   value: "Collingswood (USCWD)",
   label: "Collingswood (USCWD)"
  },
  {
   value: "Collins (USCNA)",
   label: "Collins (USCNA)"
  },
  {
   value: "Colma (USCOM)",
   label: "Colma (USCOM)"
  },
  {
   value: "Colmar (USCOX)",
   label: "Colmar (USCOX)"
  },
  {
   value: "Coloma (USCMK)",
   label: "Coloma (USCMK)"
  },
  {
   value: "Colonial Heights (USCNJ)",
   label: "Colonial Heights (USCNJ)"
  },
  {
   value: "Colora (USCOR)",
   label: "Colora (USCOR)"
  },
  {
   value: "Colorado City (USCXP)",
   label: "Colorado City (USCXP)"
  },
  {
   value: "Clermont (USCFW)",
   label: "Clermont (USCFW)"
  },
  {
   value: "Clermont (USCXN)",
   label: "Clermont (USCXN)"
  },
  {
   value: "Cleveland (USCVT)",
   label: "Cleveland (USCVT)"
  },
  {
   value: "Cleveland (USCLE)",
   label: "Cleveland (USCLE)"
  },
  {
   value: "Cleveland (USCQV)",
   label: "Cleveland (USCQV)"
  },
  {
   value: "Cleveland (USUAI)",
   label: "Cleveland (USUAI)"
  },
  {
   value: "Cleveland (USCAV)",
   label: "Cleveland (USCAV)"
  },
  {
   value: "Cleveland (USCVW)",
   label: "Cleveland (USCVW)"
  },
  {
   value: "Cleveland (USCVD)",
   label: "Cleveland (USCVD)"
  },
  {
   value: "Clevland (USLEV)",
   label: "Clevland (USLEV)"
  },
  {
   value: "Clewiston (USXDX)",
   label: "Clewiston (USXDX)"
  },
  {
   value: "Cliffside (USACN)",
   label: "Cliffside (USACN)"
  },
  {
   value: "Cliffside Park (USCSD)",
   label: "Cliffside Park (USCSD)"
  },
  {
   value: "Cliffwood (USCLF)",
   label: "Cliffwood (USCLF)"
  },
  {
   value: "Clifton (USCFX)",
   label: "Clifton (USCFX)"
  },
  {
   value: "Clifton (USCFT)",
   label: "Clifton (USCFT)"
  },
  {
   value: "Clifton Heights (USCFH)",
   label: "Clifton Heights (USCFH)"
  },
  {
   value: "Clifton Park (USCFP)",
   label: "Clifton Park (USCFP)"
  },
  {
   value: "Clifton Springs (USCSS)",
   label: "Clifton Springs (USCSS)"
  },
  {
   value: "Clinton (USCNG)",
   label: "Clinton (USCNG)"
  },
  {
   value: "Clinton (USCQT)",
   label: "Clinton (USCQT)"
  },
  {
   value: "Clinton (USCSM)",
   label: "Clinton (USCSM)"
  },
  {
   value: "Clinton (USCTZ)",
   label: "Clinton (USCTZ)"
  },
  {
   value: "Clinton (USCKC)",
   label: "Clinton (USCKC)"
  },
  {
   value: "Clinton (USCNC)",
   label: "Clinton (USCNC)"
  },
  {
   value: "Clinton (USCNB)",
   label: "Clinton (USCNB)"
  },
  {
   value: "Clinton (USCCN)",
   label: "Clinton (USCCN)"
  },
  {
   value: "Clinton (USCIX)",
   label: "Clinton (USCIX)"
  },
  {
   value: "Clinton (USCWI)",
   label: "Clinton (USCWI)"
  },
  {
   value: "Clinton (USCLB)",
   label: "Clinton (USCLB)"
  },
  {
   value: "Clinton (USCLN)",
   label: "Clinton (USCLN)"
  },
  {
   value: "Clinton Township (USCQJ)",
   label: "Clinton Township (USCQJ)"
  },
  {
   value: "Cloquet (USCQM)",
   label: "Cloquet (USCQM)"
  },
  {
   value: "Clover (USXEP)",
   label: "Clover (USXEP)"
  },
  {
   value: "Cloverdale (USCVV)",
   label: "Cloverdale (USCVV)"
  },
  {
   value: "Cloverport (USCVP)",
   label: "Cloverport (USCVP)"
  },
  {
   value: "Clovis (USCVS)",
   label: "Clovis (USCVS)"
  },
  {
   value: "Clovis (USCVN)",
   label: "Clovis (USCVN)"
  },
  {
   value: "Clyattville (USCYE)",
   label: "Clyattville (USCYE)"
  },
  {
   value: "Clyde (USCYB)",
   label: "Clyde (USCYB)"
  },
  {
   value: "Clyde (USCYA)",
   label: "Clyde (USCYA)"
  },
  {
   value: "Clam Gulch (USCLG)",
   label: "Clam Gulch (USCLG)"
  },
  {
   value: "Claremont (USCEO)",
   label: "Claremont (USCEO)"
  },
  {
   value: "Claremont (USCNH)",
   label: "Claremont (USCNH)"
  },
  {
   value: "Claremont (USCOT)",
   label: "Claremont (USCOT)"
  },
  {
   value: "Clarinda (USICL)",
   label: "Clarinda (USICL)"
  },
  {
   value: "Clarita (USCXE)",
   label: "Clarita (USCXE)"
  },
  {
   value: "Clarks Summit (USCKU)",
   label: "Clarks Summit (USCKU)"
  },
  {
   value: "Clarksboro (USCKJ)",
   label: "Clarksboro (USCKJ)"
  },
  {
   value: "Clarksburg (USCKB)",
   label: "Clarksburg (USCKB)"
  },
  {
   value: "Clarksburg (USCLX)",
   label: "Clarksburg (USCLX)"
  },
  {
   value: "Clarksdale (USCKM)",
   label: "Clarksdale (USCKM)"
  },
  {
   value: "Clarkston (USCKS)",
   label: "Clarkston (USCKS)"
  },
  {
   value: "Clarkston (USCKL)",
   label: "Clarkston (USCKL)"
  },
  {
   value: "Clarksville (USCVY)",
   label: "Clarksville (USCVY)"
  },
  {
   value: "Clarksville (USCLI)",
   label: "Clarksville (USCLI)"
  },
  {
   value: "Clarksville (USXEO)",
   label: "Clarksville (USXEO)"
  },
  {
   value: "Clarksville (USCKV)",
   label: "Clarksville (USCKV)"
  },
  {
   value: "Clarksville (USCLV)",
   label: "Clarksville (USCLV)"
  },
  {
   value: "Clarkton (USCKR)",
   label: "Clarkton (USCKR)"
  },
  {
   value: "Claverack (USCLK)",
   label: "Claverack (USCLK)"
  },
  {
   value: "Claxton (USCXT)",
   label: "Claxton (USCXT)"
  },
  {
   value: "Clay Center (USCYK)",
   label: "Clay Center (USCYK)"
  },
  {
   value: "Claymont (USCLA)",
   label: "Claymont (USCLA)"
  },
  {
   value: "Clayton (USCME)",
   label: "Clayton (USCME)"
  },
  {
   value: "Clayton (USCYT)",
   label: "Clayton (USCYT)"
  },
  {
   value: "Clayton (USCYN)",
   label: "Clayton (USCYN)"
  },
  {
   value: "Clayton (USCKY)",
   label: "Clayton (USCKY)"
  },
  {
   value: "Clayton (USCLY)",
   label: "Clayton (USCLY)"
  },
  {
   value: "Clayton (USCQY)",
   label: "Clayton (USCQY)"
  },
  {
   value: "Clear (USCXI)",
   label: "Clear (USCXI)"
  },
  {
   value: "Clearfield (USCQU)",
   label: "Clearfield (USCQU)"
  },
  {
   value: "Clearfield (USPSB)",
   label: "Clearfield (USPSB)"
  },
  {
   value: "Clearing (USCIZ)",
   label: "Clearing (USCIZ)"
  },
  {
   value: "Clearlake (USCLC)",
   label: "Clearlake (USCLC)"
  },
  {
   value: "Clearwater (USCLW)",
   label: "Clearwater (USCLW)"
  },
  {
   value: "Cleburne (USCEX)",
   label: "Cleburne (USCEX)"
  },
  {
   value: "Clements (USCLZ)",
   label: "Clements (USCLZ)"
  },
  {
   value: "Clemmons (USCMO)",
   label: "Clemmons (USCMO)"
  },
  {
   value: "Clemson (USCEU)",
   label: "Clemson (USCEU)"
  },
  {
   value: "Cleona (USXER)",
   label: "Cleona (USXER)"
  },
  {
   value: "Clermont (USCLO)",
   label: "Clermont (USCLO)"
  },
  {
   value: "Chicago (USCHI)",
   label: "Chicago (USCHI)"
  },
  {
   value: "Chicago Heights (USCGH)",
   label: "Chicago Heights (USCGH)"
  },
  {
   value: "Chicago Ridge (USCRG)",
   label: "Chicago Ridge (USCRG)"
  },
  {
   value: "Chickamauga (USCSW)",
   label: "Chickamauga (USCSW)"
  },
  {
   value: "Chickasha (USCHK)",
   label: "Chickasha (USCHK)"
  },
  {
   value: "Chico (USCIC)",
   label: "Chico (USCIC)"
  },
  {
   value: "Chicopee (USCCE)",
   label: "Chicopee (USCCE)"
  },
  {
   value: "Chicopee (USCEF)",
   label: "Chicopee (USCEF)"
  },
  {
   value: "Chignik (USKCL)",
   label: "Chignik (USKCL)"
  },
  {
   value: "Childress (USCDS)",
   label: "Childress (USCDS)"
  },
  {
   value: "Childs (USCDP)",
   label: "Childs (USCDP)"
  },
  {
   value: "Chilhowie (USCWE)",
   label: "Chilhowie (USCWE)"
  },
  {
   value: "Chili (USCII)",
   label: "Chili (USCII)"
  },
  {
   value: "Chillicothe (USCIY)",
   label: "Chillicothe (USCIY)"
  },
  {
   value: "Chillicothe (USUFC)",
   label: "Chillicothe (USUFC)"
  },
  {
   value: "Chilton (USCNI)",
   label: "Chilton (USCNI)"
  },
  {
   value: "Chino (USCNO)",
   label: "Chino (USCNO)"
  },
  {
   value: "Chino Valley (USCIO)",
   label: "Chino Valley (USCIO)"
  },
  {
   value: "Chippewa Falls (USCPF)",
   label: "Chippewa Falls (USCPF)"
  },
  {
   value: "Chocolate Bayou (USCCL)",
   label: "Chocolate Bayou (USCCL)"
  },
  {
   value: "Chocowinity (USCQW)",
   label: "Chocowinity (USCQW)"
  },
  {
   value: "Choctaw (USCKW)",
   label: "Choctaw (USCKW)"
  },
  {
   value: "Christiansburg (USCBG)",
   label: "Christiansburg (USCBG)"
  },
  {
   value: "Chugiak (USCHR)",
   label: "Chugiak (USCHR)"
  },
  {
   value: "Chula Vista (USCUV)",
   label: "Chula Vista (USCUV)"
  },
  {
   value: "Church Hill (USUFB)",
   label: "Church Hill (USUFB)"
  },
  {
   value: "Church Hill (USCRH)",
   label: "Church Hill (USCRH)"
  },
  {
   value: "Cicero (USXDN)",
   label: "Cicero (USXDN)"
  },
  {
   value: "Cincinnati (USCVG)",
   label: "Cincinnati (USCVG)"
  },
  {
   value: "Cinnaminson (USXDU)",
   label: "Cinnaminson (USXDU)"
  },
  {
   value: "Cirarlake (USXEH)",
   label: "Cirarlake (USXEH)"
  },
  {
   value: "Circleville (USCIR)",
   label: "Circleville (USCIR)"
  },
  {
   value: "Cisco (USCIS)",
   label: "Cisco (USCIS)"
  },
  {
   value: "Citronelle (USCIT)",
   label: "Citronelle (USCIT)"
  },
  {
   value: "Citrus Heights (USCTU)",
   label: "Citrus Heights (USCTU)"
  },
  {
   value: "City Of Commerce (USCCF)",
   label: "City Of Commerce (USCCF)"
  },
  {
   value: "City of Industry (USJID)",
   label: "City of Industry (USJID)"
  },
  {
   value: "Clackamas (USCQX)",
   label: "Clackamas (USCQX)"
  },
  {
   value: "Clairton (USCGN)",
   label: "Clairton (USCGN)"
  },
  {
   value: "Chatsworth (USCWH)",
   label: "Chatsworth (USCWH)"
  },
  {
   value: "Chatsworth (USXDT)",
   label: "Chatsworth (USXDT)"
  },
  {
   value: "Chattahoochee (USCTE)",
   label: "Chattahoochee (USCTE)"
  },
  {
   value: "Chattanooga (USCHA)",
   label: "Chattanooga (USCHA)"
  },
  {
   value: "Chebanse (USCSB)",
   label: "Chebanse (USCSB)"
  },
  {
   value: "Cheboygan (USCHG)",
   label: "Cheboygan (USCHG)"
  },
  {
   value: "Cheektowaga (USCKT)",
   label: "Cheektowaga (USCKT)"
  },
  {
   value: "Chehalis (USCLS)",
   label: "Chehalis (USCLS)"
  },
  {
   value: "Chelan (USXDV)",
   label: "Chelan (USXDV)"
  },
  {
   value: "Chelmsford (USCMD)",
   label: "Chelmsford (USCMD)"
  },
  {
   value: "Chelsea (USCSE)",
   label: "Chelsea (USCSE)"
  },
  {
   value: "Cheraw (USHCW)",
   label: "Cheraw (USHCW)"
  },
  {
   value: "Cheriton (USCKH)",
   label: "Cheriton (USCKH)"
  },
  {
   value: "Cherokee (USCKE)",
   label: "Cherokee (USCKE)"
  },
  {
   value: "Cherokee Falls (USCKF)",
   label: "Cherokee Falls (USCKF)"
  },
  {
   value: "Cherry Hill (USCIL)",
   label: "Cherry Hill (USCIL)"
  },
  {
   value: "Cherry Point (USCPO)",
   label: "Cherry Point (USCPO)"
  },
  {
   value: "Cherry Valley (USCHV)",
   label: "Cherry Valley (USCHV)"
  },
  {
   value: "Cherryville (USCHJ)",
   label: "Cherryville (USCHJ)"
  },
  {
   value: "Chesapeake (USUFG)",
   label: "Chesapeake (USUFG)"
  },
  {
   value: "Cheshire (USCHC)",
   label: "Cheshire (USCHC)"
  },
  {
   value: "Chesnee (USCNE)",
   label: "Chesnee (USCNE)"
  },
  {
   value: "Chester (USADJ)",
   label: "Chester (USADJ)"
  },
  {
   value: "Chester (USCSI)",
   label: "Chester (USCSI)"
  },
  {
   value: "Chester (USCYZ)",
   label: "Chester (USCYZ)"
  },
  {
   value: "Chester (USCSR)",
   label: "Chester (USCSR)"
  },
  {
   value: "Chester (USCHT)",
   label: "Chester (USCHT)"
  },
  {
   value: "Chester (USCQZ)",
   label: "Chester (USCQZ)"
  },
  {
   value: "Chester (USCSZ)",
   label: "Chester (USCSZ)"
  },
  {
   value: "Chester (USACL)",
   label: "Chester (USACL)"
  },
  {
   value: "Chesterfield (USCFL)",
   label: "Chesterfield (USCFL)"
  },
  {
   value: "Chesterfield (USXDR)",
   label: "Chesterfield (USXDR)"
  },
  {
   value: "Chesterfield (USCFE)",
   label: "Chesterfield (USCFE)"
  },
  {
   value: "Chestertown (USCWN)",
   label: "Chestertown (USCWN)"
  },
  {
   value: "Chestnut (USCUT)",
   label: "Chestnut (USCUT)"
  },
  {
   value: "Chestnut Ridge (USCDG)",
   label: "Chestnut Ridge (USCDG)"
  },
  {
   value: "Cheswick (USCWK)",
   label: "Cheswick (USCWK)"
  },
  {
   value: "Cheswold (USCHW)",
   label: "Cheswold (USCHW)"
  },
  {
   value: "Cheverley (USCFY)",
   label: "Cheverley (USCFY)"
  },
  {
   value: "Cheyenne (USCYS)",
   label: "Cheyenne (USCYS)"
  },
  {
   value: "Chadron (USCDR)",
   label: "Chadron (USCDR)"
  },
  {
   value: "Chagrin Falls (USCFO)",
   label: "Chagrin Falls (USCFO)"
  },
  {
   value: "Chalfont (USCHF)",
   label: "Chalfont (USCHF)"
  },
  {
   value: "Chalmette (USCLQ)",
   label: "Chalmette (USCLQ)"
  },
  {
   value: "Chambersburg (USCBB)",
   label: "Chambersburg (USCBB)"
  },
  {
   value: "Chamblee (USCMM)",
   label: "Chamblee (USCMM)"
  },
  {
   value: "Champaign (USCMI)",
   label: "Champaign (USCMI)"
  },
  {
   value: "Champion (USCHP)",
   label: "Champion (USCHP)"
  },
  {
   value: "Champlain (USCHM)",
   label: "Champlain (USCHM)"
  },
  {
   value: "Champlain-Rouses Pt. (USCPX)",
   label: "Champlain-Rouses Pt. (USCPX)"
  },
  {
   value: "Chandler (USCHD)",
   label: "Chandler (USCHD)"
  },
  {
   value: "Chandler (USCHZ)",
   label: "Chandler (USCHZ)"
  },
  {
   value: "Chanhassen (USCHQ)",
   label: "Chanhassen (USCHQ)"
  },
  {
   value: "Channahon (USCHH)",
   label: "Channahon (USCHH)"
  },
  {
   value: "Channelview (USCUW)",
   label: "Channelview (USCUW)"
  },
  {
   value: "Chantilly (USCYL)",
   label: "Chantilly (USCYL)"
  },
  {
   value: "Chanute (USCNU)",
   label: "Chanute (USCNU)"
  },
  {
   value: "Chapel Hill (USCHE)",
   label: "Chapel Hill (USCHE)"
  },
  {
   value: "Chapel Hill (USCIH)",
   label: "Chapel Hill (USCIH)"
  },
  {
   value: "Chapman (USCEP)",
   label: "Chapman (USCEP)"
  },
  {
   value: "Chardon (USCDO)",
   label: "Chardon (USCDO)"
  },
  {
   value: "Chariton (USCIQ)",
   label: "Chariton (USCIQ)"
  },
  {
   value: "Charles Town (USCTO)",
   label: "Charles Town (USCTO)"
  },
  {
   value: "Charleston (USCTC)",
   label: "Charleston (USCTC)"
  },
  {
   value: "Charleston (USCST)",
   label: "Charleston (USCST)"
  },
  {
   value: "Charleston (USCRW)",
   label: "Charleston (USCRW)"
  },
  {
   value: "Charleston (USCLR)",
   label: "Charleston (USCLR)"
  },
  {
   value: "Charleston (USCHU)",
   label: "Charleston (USCHU)"
  },
  {
   value: "Charleston (USCHS)",
   label: "Charleston (USCHS)"
  },
  {
   value: "Charlestown (USXEK)",
   label: "Charlestown (USXEK)"
  },
  {
   value: "Charlestown (USCHN)",
   label: "Charlestown (USCHN)"
  },
  {
   value: "Charlevoix (USCSX)",
   label: "Charlevoix (USCSX)"
  },
  {
   value: "Charlotte (USCLT)",
   label: "Charlotte (USCLT)"
  },
  {
   value: "Charlotte (USCRQ)",
   label: "Charlotte (USCRQ)"
  },
  {
   value: "Charlottesville (USCHO)",
   label: "Charlottesville (USCHO)"
  },
  {
   value: "Charter Oak (USCOA)",
   label: "Charter Oak (USCOA)"
  },
  {
   value: "Chaska (USACM)",
   label: "Chaska (USACM)"
  },
  {
   value: "Chateaugay (USCTY)",
   label: "Chateaugay (USCTY)"
  },
  {
   value: "Chatham (USCIF)",
   label: "Chatham (USCIF)"
  },
  {
   value: "Chatham (USCWM)",
   label: "Chatham (USCWM)"
  },
  {
   value: "Cayce (USCYC)",
   label: "Cayce (USCYC)"
  },
  {
   value: "Cayuga (USCYG)",
   label: "Cayuga (USCYG)"
  },
  {
   value: "Cayuta (USCYU)",
   label: "Cayuta (USCYU)"
  },
  {
   value: "Cecilton (USCYD)",
   label: "Cecilton (USCYD)"
  },
  {
   value: "Cedar Bayou (USCBA)",
   label: "Cedar Bayou (USCBA)"
  },
  {
   value: "Cedar City (USCDC)",
   label: "Cedar City (USCDC)"
  },
  {
   value: "Cedar Falls (USCRD)",
   label: "Cedar Falls (USCRD)"
  },
  {
   value: "Cedar Falls (USXDP)",
   label: "Cedar Falls (USXDP)"
  },
  {
   value: "Cedar Grove (USCGR)",
   label: "Cedar Grove (USCGR)"
  },
  {
   value: "Cedar Grove (USCED)",
   label: "Cedar Grove (USCED)"
  },
  {
   value: "Cedar Hills (USCHL)",
   label: "Cedar Hills (USCHL)"
  },
  {
   value: "Cedar Knolls (USCJJ)",
   label: "Cedar Knolls (USCJJ)"
  },
  {
   value: "Cedar Park (USCPK)",
   label: "Cedar Park (USCPK)"
  },
  {
   value: "Cedar Rapids (USCID)",
   label: "Cedar Rapids (USCID)"
  },
  {
   value: "Cedar Springs (USCES)",
   label: "Cedar Springs (USCES)"
  },
  {
   value: "Cedarburg (USCEG)",
   label: "Cedarburg (USCEG)"
  },
  {
   value: "Cedartown (USCDI)",
   label: "Cedartown (USCDI)"
  },
  {
   value: "Cedarville (USXDQ)",
   label: "Cedarville (USXDQ)"
  },
  {
   value: "Cedarville (USXDO)",
   label: "Cedarville (USXDO)"
  },
  {
   value: "Celina (USCEA)",
   label: "Celina (USCEA)"
  },
  {
   value: "Cementon (USACS)",
   label: "Cementon (USACS)"
  },
  {
   value: "Centerbrook (USCBC)",
   label: "Centerbrook (USCBC)"
  },
  {
   value: "Centereach (USCCW)",
   label: "Centereach (USCCW)"
  },
  {
   value: "Centerport (USCTT)",
   label: "Centerport (USCTT)"
  },
  {
   value: "Centerville (USCXW)",
   label: "Centerville (USCXW)"
  },
  {
   value: "Centerville (USCVZ)",
   label: "Centerville (USCVZ)"
  },
  {
   value: "Centerville (USCEE)",
   label: "Centerville (USCEE)"
  },
  {
   value: "Centerville (USCVE)",
   label: "Centerville (USCVE)"
  },
  {
   value: "Centerville (USCIA)",
   label: "Centerville (USCIA)"
  },
  {
   value: "Central (USCTL)",
   label: "Central (USCTL)"
  },
  {
   value: "Central Falls (USACH)",
   label: "Central Falls (USACH)"
  },
  {
   value: "Central Islip (USCIP)",
   label: "Central Islip (USCIP)"
  },
  {
   value: "Centralia (USENL)",
   label: "Centralia (USENL)"
  },
  {
   value: "Centralia (USCFJ)",
   label: "Centralia (USCFJ)"
  },
  {
   value: "Centralia (USCRA)",
   label: "Centralia (USCRA)"
  },
  {
   value: "Centre (USCER)",
   label: "Centre (USCER)"
  },
  {
   value: "Ceres (USCRZ)",
   label: "Ceres (USCRZ)"
  },
  {
   value: "Cerritos (USCEK)",
   label: "Cerritos (USCEK)"
  },
  {
   value: "Chadbourn (USCHB)",
   label: "Chadbourn (USCHB)"
  },
  {
   value: "Chadds Ford (USCFR)",
   label: "Chadds Ford (USCFR)"
  },
  {
   value: "Carroll (USCIN)",
   label: "Carroll (USCIN)"
  },
  {
   value: "Carrollton (USCRR)",
   label: "Carrollton (USCRR)"
  },
  {
   value: "Carrollton (USCRK)",
   label: "Carrollton (USCRK)"
  },
  {
   value: "Carrollton (USCAX)",
   label: "Carrollton (USCAX)"
  },
  {
   value: "Carrollton (USCLL)",
   label: "Carrollton (USCLL)"
  },
  {
   value: "Carson (USCRU)",
   label: "Carson (USCRU)"
  },
  {
   value: "Carson City (USCSN)",
   label: "Carson City (USCSN)"
  },
  {
   value: "Carsonville (USCSU)",
   label: "Carsonville (USCSU)"
  },
  {
   value: "Carter Lake (USCTR)",
   label: "Carter Lake (USCTR)"
  },
  {
   value: "Carteret (USCSF)",
   label: "Carteret (USCSF)"
  },
  {
   value: "Cartersville (USUFK)",
   label: "Cartersville (USUFK)"
  },
  {
   value: "Carthage (USCGT)",
   label: "Carthage (USCGT)"
  },
  {
   value: "Carthage (USCZT)",
   label: "Carthage (USCZT)"
  },
  {
   value: "Carthage (USCEM)",
   label: "Carthage (USCEM)"
  },
  {
   value: "Carthage (USCCG)",
   label: "Carthage (USCCG)"
  },
  {
   value: "Carver (USCXB)",
   label: "Carver (USCXB)"
  },
  {
   value: "Cary (USCFC)",
   label: "Cary (USCFC)"
  },
  {
   value: "Caryville (USXEN)",
   label: "Caryville (USXEN)"
  },
  {
   value: "Casa Grande (USCGZ)",
   label: "Casa Grande (USCGZ)"
  },
  {
   value: "Cashiers (USCEZ)",
   label: "Cashiers (USCEZ)"
  },
  {
   value: "Cashmere (USXEI)",
   label: "Cashmere (USXEI)"
  },
  {
   value: "Casnovia (USCSO)",
   label: "Casnovia (USCSO)"
  },
  {
   value: "Casper (USCPR)",
   label: "Casper (USCPR)"
  },
  {
   value: "Caspian (USCSP)",
   label: "Caspian (USCSP)"
  },
  {
   value: "Castine (USCAS)",
   label: "Castine (USCAS)"
  },
  {
   value: "Castle Hayne (USCHY)",
   label: "Castle Hayne (USCHY)"
  },
  {
   value: "Castle Island (USCAI)",
   label: "Castle Island (USCAI)"
  },
  {
   value: "Castleton On Hudson (USCOH)",
   label: "Castleton On Hudson (USCOH)"
  },
  {
   value: "Castro Valley (USCVA)",
   label: "Castro Valley (USCVA)"
  },
  {
   value: "Castroville (USCTV)",
   label: "Castroville (USCTV)"
  },
  {
   value: "Catalina Is (USCKI)",
   label: "Catalina Is (USCKI)"
  },
  {
   value: "Catasauqua (USXEJ)",
   label: "Catasauqua (USXEJ)"
  },
  {
   value: "Catawba (USCTW)",
   label: "Catawba (USCTW)"
  },
  {
   value: "Catawba (USCTB)",
   label: "Catawba (USCTB)"
  },
  {
   value: "Catlettsburg (USCGK)",
   label: "Catlettsburg (USCGK)"
  },
  {
   value: "Catonsville (USCVM)",
   label: "Catonsville (USCVM)"
  },
  {
   value: "Catoosa (USXEL)",
   label: "Catoosa (USXEL)"
  },
  {
   value: "Catskill (USACG)",
   label: "Catskill (USACG)"
  },
  {
   value: "Cave Junction (USCWJ)",
   label: "Cave Junction (USCWJ)"
  },
  {
   value: "Cavendish (USCVX)",
   label: "Cavendish (USCVX)"
  },
  {
   value: "Canton (USCTJ)",
   label: "Canton (USCTJ)"
  },
  {
   value: "Canton (USCNZ)",
   label: "Canton (USCNZ)"
  },
  {
   value: "Canton-Akron Reg Apt (USCAK)",
   label: "Canton-Akron Reg Apt (USCAK)"
  },
  {
   value: "Cantonment (USCQF)",
   label: "Cantonment (USCQF)"
  },
  {
   value: "Cantwell (USCNW)",
   label: "Cantwell (USCNW)"
  },
  {
   value: "Cape Canaveral (USCPV)",
   label: "Cape Canaveral (USCPV)"
  },
  {
   value: "Cape Charles (USCCJ)",
   label: "Cape Charles (USCCJ)"
  },
  {
   value: "Cape Charles City (USCCC)",
   label: "Cape Charles City (USCCC)"
  },
  {
   value: "Cape Elizabeth (USCEL)",
   label: "Cape Elizabeth (USCEL)"
  },
  {
   value: "Cape Fear (USCFN)",
   label: "Cape Fear (USCFN)"
  },
  {
   value: "Cape Girardeau (USCGI)",
   label: "Cape Girardeau (USCGI)"
  },
  {
   value: "Cape Hatteras (USCPH)",
   label: "Cape Hatteras (USCPH)"
  },
  {
   value: "Cape Sabine (USCSA)",
   label: "Cape Sabine (USCSA)"
  },
  {
   value: "Cape Vincent (USCVI)",
   label: "Cape Vincent (USCVI)"
  },
  {
   value: "Capers Island (USCYI)",
   label: "Capers Island (USCYI)"
  },
  {
   value: "Capistrano Beach (USCPZ)",
   label: "Capistrano Beach (USCPZ)"
  },
  {
   value: "Capitan (USCAP)",
   label: "Capitan (USCAP)"
  },
  {
   value: "Capitol Heights (USACD)",
   label: "Capitol Heights (USACD)"
  },
  {
   value: "Carbondale (USCBD)",
   label: "Carbondale (USCBD)"
  },
  {
   value: "Carbondale (USCQD)",
   label: "Carbondale (USCQD)"
  },
  {
   value: "Carbury (USCBY)",
   label: "Carbury (USCBY)"
  },
  {
   value: "Careywood (USCRY)",
   label: "Careywood (USCRY)"
  },
  {
   value: "Cargo City (USCGY)",
   label: "Cargo City (USCGY)"
  },
  {
   value: "Carle Place (USCPC)",
   label: "Carle Place (USCPC)"
  },
  {
   value: "Carleton (USCNL)",
   label: "Carleton (USCNL)"
  },
  {
   value: "Carlisle (USCQI)",
   label: "Carlisle (USCQI)"
  },
  {
   value: "Carlisle (USCRL)",
   label: "Carlisle (USCRL)"
  },
  {
   value: "Carlisle (USUFI)",
   label: "Carlisle (USUFI)"
  },
  {
   value: "Carlstadt (USUAK)",
   label: "Carlstadt (USUAK)"
  },
  {
   value: "Carman (USCRJ)",
   label: "Carman (USCRJ)"
  },
  {
   value: "Carmel (USCMZ)",
   label: "Carmel (USCMZ)"
  },
  {
   value: "Carmel Valley (USCMV)",
   label: "Carmel Valley (USCMV)"
  },
  {
   value: "Carnegie (USCRE)",
   label: "Carnegie (USCRE)"
  },
  {
   value: "Carol Stream (USACE)",
   label: "Carol Stream (USACE)"
  },
  {
   value: "Carpentersville (USCRV)",
   label: "Carpentersville (USCRV)"
  },
  {
   value: "Carpinteria (USCPT)",
   label: "Carpinteria (USCPT)"
  },
  {
   value: "Carquinez Strait (USCAR)",
   label: "Carquinez Strait (USCAR)"
  },
  {
   value: "Carrabelle (USCRB)",
   label: "Carrabelle (USCRB)"
  },
  {
   value: "Carrizozo (USUFH)",
   label: "Carrizozo (USUFH)"
  },
  {
   value: "Cambridge Springs (USUFJ)",
   label: "Cambridge Springs (USUFJ)"
  },
  {
   value: "Camden (USCDH)",
   label: "Camden (USCDH)"
  },
  {
   value: "Camden (USCDE)",
   label: "Camden (USCDE)"
  },
  {
   value: "Camden (USCDN)",
   label: "Camden (USCDN)"
  },
  {
   value: "Camden (USCAT)",
   label: "Camden (USCAT)"
  },
  {
   value: "Camdenton (USCDT)",
   label: "Camdenton (USCDT)"
  },
  {
   value: "Cameron (USCXM)",
   label: "Cameron (USCXM)"
  },
  {
   value: "Camilla (USCML)",
   label: "Camilla (USCML)"
  },
  {
   value: "Camino (USCMN)",
   label: "Camino (USCMN)"
  },
  {
   value: "Camp Hill (USXDZ)",
   label: "Camp Hill (USXDZ)"
  },
  {
   value: "Camp Lejeune (USCLJ)",
   label: "Camp Lejeune (USCLJ)"
  },
  {
   value: "Campbell (USCPB)",
   label: "Campbell (USCPB)"
  },
  {
   value: "Campbell (USCPL)",
   label: "Campbell (USCPL)"
  },
  {
   value: "Campbell (USCPE)",
   label: "Campbell (USCPE)"
  },
  {
   value: "Campbellsburg (USCBU)",
   label: "Campbellsburg (USCBU)"
  },
  {
   value: "Campbellsville (USCMP)",
   label: "Campbellsville (USCMP)"
  },
  {
   value: "Camphill (USADC)",
   label: "Camphill (USADC)"
  },
  {
   value: "Campobello (USCBO)",
   label: "Campobello (USCBO)"
  },
  {
   value: "Campti (USCIM)",
   label: "Campti (USCIM)"
  },
  {
   value: "Campton (USCTP)",
   label: "Campton (USCTP)"
  },
  {
   value: "Canajoharie (USCJH)",
   label: "Canajoharie (USCJH)"
  },
  {
   value: "Canal Fulton (USCFI)",
   label: "Canal Fulton (USCFI)"
  },
  {
   value: "Canal Winchester (USXEQ)",
   label: "Canal Winchester (USXEQ)"
  },
  {
   value: "Canandaigua (USCND)",
   label: "Canandaigua (USCND)"
  },
  {
   value: "Canastota (USCNS)",
   label: "Canastota (USCNS)"
  },
  {
   value: "Canaudigua (USXED)",
   label: "Canaudigua (USXED)"
  },
  {
   value: "Canaveral (USCVL)",
   label: "Canaveral (USCVL)"
  },
  {
   value: "Canby (USCAB)",
   label: "Canby (USCAB)"
  },
  {
   value: "Cando (USXEC)",
   label: "Cando (USXEC)"
  },
  {
   value: "Candor (USCNR)",
   label: "Candor (USCNR)"
  },
  {
   value: "Canfield (USCNF)",
   label: "Canfield (USCNF)"
  },
  {
   value: "Cannon Beach (USCBX)",
   label: "Cannon Beach (USCBX)"
  },
  {
   value: "Cannon Falls (USCFA)",
   label: "Cannon Falls (USCFA)"
  },
  {
   value: "Canoga Park (USCPA)",
   label: "Canoga Park (USCPA)"
  },
  {
   value: "Canonsburg (USCNN)",
   label: "Canonsburg (USCNN)"
  },
  {
   value: "Canton (USCTK)",
   label: "Canton (USCTK)"
  },
  {
   value: "Canton (USCIG)",
   label: "Canton (USCIG)"
  },
  {
   value: "Canton (USCNQ)",
   label: "Canton (USCNQ)"
  },
  {
   value: "Canton (USCNP)",
   label: "Canton (USCNP)"
  },
  {
   value: "Canton (USCNT)",
   label: "Canton (USCNT)"
  },
  {
   value: "Canton (USACU)",
   label: "Canton (USACU)"
  },
  {
   value: "Bushnell (USBGC)",
   label: "Bushnell (USBGC)"
  },
  {
   value: "Bustleton (USXCB)",
   label: "Bustleton (USXCB)"
  },
  {
   value: "Butler (USBGF)",
   label: "Butler (USBGF)"
  },
  {
   value: "Butler (USBGG)",
   label: "Butler (USBGG)"
  },
  {
   value: "Butler (USBTP)",
   label: "Butler (USBTP)"
  },
  {
   value: "Butler (USXDG)",
   label: "Butler (USXDG)"
  },
  {
   value: "Butte (USBTM)",
   label: "Butte (USBTM)"
  },
  {
   value: "Butternut (USBGH)",
   label: "Butternut (USBGH)"
  },
  {
   value: "Byberry (USBYQ)",
   label: "Byberry (USBYQ)"
  },
  {
   value: "Byhalia (USBHA)",
   label: "Byhalia (USBHA)"
  },
  {
   value: "Byram (USBYM)",
   label: "Byram (USBYM)"
  },
  {
   value: "Byron (USBYR)",
   label: "Byron (USBYR)"
  },
  {
   value: "Byron Center (USBYK)",
   label: "Byron Center (USBYK)"
  },
  {
   value: "Cactus (USCAC)",
   label: "Cactus (USCAC)"
  },
  {
   value: "Caddo Mills (USXDY)",
   label: "Caddo Mills (USXDY)"
  },
  {
   value: "Cadillac (USCAD)",
   label: "Cadillac (USCAD)"
  },
  {
   value: "Cairo (USCAO)",
   label: "Cairo (USCAO)"
  },
  {
   value: "Calais (USCAL)",
   label: "Calais (USCAL)"
  },
  {
   value: "Calcasieu (USCAU)",
   label: "Calcasieu (USCAU)"
  },
  {
   value: "Caldwell (USCDX)",
   label: "Caldwell (USCDX)"
  },
  {
   value: "Caldwell (USCDW)",
   label: "Caldwell (USCDW)"
  },
  {
   value: "Caldwell (USCAQ)",
   label: "Caldwell (USCAQ)"
  },
  {
   value: "Calera (USCEB)",
   label: "Calera (USCEB)"
  },
  {
   value: "Calexico (USCXL)",
   label: "Calexico (USCXL)"
  },
  {
   value: "Calhoun (USCAH)",
   label: "Calhoun (USCAH)"
  },
  {
   value: "Calhoun City (USCCI)",
   label: "Calhoun City (USCCI)"
  },
  {
   value: "Calimesa (USCAA)",
   label: "Calimesa (USCAA)"
  },
  {
   value: "Calistoga (USCAG)",
   label: "Calistoga (USCAG)"
  },
  {
   value: "Calumet (USCLH)",
   label: "Calumet (USCLH)"
  },
  {
   value: "Calumet City (USCAY)",
   label: "Calumet City (USCAY)"
  },
  {
   value: "Calumet Park (USCLP)",
   label: "Calumet Park (USCLP)"
  },
  {
   value: "Calvert City (USCCT)",
   label: "Calvert City (USCCT)"
  },
  {
   value: "Camanche (USCAN)",
   label: "Camanche (USCAN)"
  },
  {
   value: "Camano Is. (USCMW)",
   label: "Camano Is. (USCMW)"
  },
  {
   value: "Camarillo (USCMR)",
   label: "Camarillo (USCMR)"
  },
  {
   value: "Camas (USCMS)",
   label: "Camas (USCMS)"
  },
  {
   value: "Cambridge (USCGE)",
   label: "Cambridge (USCGE)"
  },
  {
   value: "Cambridge (USCBH)",
   label: "Cambridge (USCBH)"
  },
  {
   value: "Cambridge (USCMB)",
   label: "Cambridge (USCMB)"
  },
  {
   value: "Cambridge (USJHY)",
   label: "Cambridge (USJHY)"
  },
  {
   value: "Cambridge City (USCCY)",
   label: "Cambridge City (USCCY)"
  },
  {
   value: "Bude (USBUD)",
   label: "Bude (USBUD)"
  },
  {
   value: "Buena (USBUE)",
   label: "Buena (USBUE)"
  },
  {
   value: "Buena (USBJY)",
   label: "Buena (USBJY)"
  },
  {
   value: "Buena Park (USBUN)",
   label: "Buena Park (USBUN)"
  },
  {
   value: "Buffalo (USBYG)",
   label: "Buffalo (USBYG)"
  },
  {
   value: "Buffalo (USBFU)",
   label: "Buffalo (USBFU)"
  },
  {
   value: "Buffalo (USBUF)",
   label: "Buffalo (USBUF)"
  },
  {
   value: "Buffalo Grove (USBGO)",
   label: "Buffalo Grove (USBGO)"
  },
  {
   value: "Buffalo Lake (USBUG)",
   label: "Buffalo Lake (USBUG)"
  },
  {
   value: "Buffton (USBFY)",
   label: "Buffton (USBFY)"
  },
  {
   value: "Buford (USBFA)",
   label: "Buford (USBFA)"
  },
  {
   value: "Buhl (USBHL)",
   label: "Buhl (USBHL)"
  },
  {
   value: "Bulville (USUBZ)",
   label: "Bulville (USUBZ)"
  },
  {
   value: "Buras (USBUS)",
   label: "Buras (USBUS)"
  },
  {
   value: "Burbank (USBUR)",
   label: "Burbank (USBUR)"
  },
  {
   value: "Burbank (USBUK)",
   label: "Burbank (USBUK)"
  },
  {
   value: "Burkville (USBQL)",
   label: "Burkville (USBQL)"
  },
  {
   value: "Burleson (USBND)",
   label: "Burleson (USBND)"
  },
  {
   value: "Burley (USBYP)",
   label: "Burley (USBYP)"
  },
  {
   value: "Burley\/Rupert Apt (USBYI)",
   label: "Burley\/Rupert Apt (USBYI)"
  },
  {
   value: "Burlingame (USBGI)",
   label: "Burlingame (USBGI)"
  },
  {
   value: "Burlington (USBUU)",
   label: "Burlington (USBUU)"
  },
  {
   value: "Burlington (USBRL)",
   label: "Burlington (USBRL)"
  },
  {
   value: "Burlington (USBGZ)",
   label: "Burlington (USBGZ)"
  },
  {
   value: "Burlington (USBBF)",
   label: "Burlington (USBBF)"
  },
  {
   value: "Burlington (USXDD)",
   label: "Burlington (USXDD)"
  },
  {
   value: "Burlington (USBUH)",
   label: "Burlington (USBUH)"
  },
  {
   value: "Burlington (USBGV)",
   label: "Burlington (USBGV)"
  },
  {
   value: "Burlington (USBTV)",
   label: "Burlington (USBTV)"
  },
  {
   value: "Burlington (USBGA)",
   label: "Burlington (USBGA)"
  },
  {
   value: "Burlington (USBUW)",
   label: "Burlington (USBUW)"
  },
  {
   value: "Burlington (USXCU)",
   label: "Burlington (USXCU)"
  },
  {
   value: "Burney (USBYN)",
   label: "Burney (USBYN)"
  },
  {
   value: "Burnham (USBHP)",
   label: "Burnham (USBHP)"
  },
  {
   value: "Burns Harbour (USBNB)",
   label: "Burns Harbour (USBNB)"
  },
  {
   value: "Burnsville (USBYO)",
   label: "Burnsville (USBYO)"
  },
  {
   value: "Burr Oak (USBUQ)",
   label: "Burr Oak (USBUQ)"
  },
  {
   value: "Burr Ridge (USBGB)",
   label: "Burr Ridge (USBGB)"
  },
  {
   value: "Burt (USBTU)",
   label: "Burt (USBTU)"
  },
  {
   value: "Burton (USBUT)",
   label: "Burton (USBUT)"
  },
  {
   value: "Burtonsville (USBUV)",
   label: "Burtonsville (USBUV)"
  },
  {
   value: "Brookline (USBJK)",
   label: "Brookline (USBJK)"
  },
  {
   value: "Brookline (USBMA)",
   label: "Brookline (USBMA)"
  },
  {
   value: "Brooklyn (USBOY)",
   label: "Brooklyn (USBOY)"
  },
  {
   value: "Brooklyn (USBKU)",
   label: "Brooklyn (USBKU)"
  },
  {
   value: "Brooklyn Center (USXCX)",
   label: "Brooklyn Center (USXCX)"
  },
  {
   value: "Brooklyn Heights (USBHS)",
   label: "Brooklyn Heights (USBHS)"
  },
  {
   value: "Brooklyn Park (USBJQ)",
   label: "Brooklyn Park (USBJQ)"
  },
  {
   value: "Brooklyn Park (USBQP)",
   label: "Brooklyn Park (USBQP)"
  },
  {
   value: "Brookpark (USBPO)",
   label: "Brookpark (USBPO)"
  },
  {
   value: "Brooks (USBRS)",
   label: "Brooks (USBRS)"
  },
  {
   value: "Brookshire (USXDI)",
   label: "Brookshire (USXDI)"
  },
  {
   value: "Brooksville (USBKJ)",
   label: "Brooksville (USBKJ)"
  },
  {
   value: "Brookville (USBVP)",
   label: "Brookville (USBVP)"
  },
  {
   value: "Brookwood (USBWA)",
   label: "Brookwood (USBWA)"
  },
  {
   value: "Broomall (USXCM)",
   label: "Broomall (USXCM)"
  },
  {
   value: "Broomfield (USBJC)",
   label: "Broomfield (USBJC)"
  },
  {
   value: "Brown Deer (USXCQ)",
   label: "Brown Deer (USXCQ)"
  },
  {
   value: "Brownfield (USBXU)",
   label: "Brownfield (USBXU)"
  },
  {
   value: "Browns Summit (USXCL)",
   label: "Browns Summit (USXCL)"
  },
  {
   value: "Brownstown (USBYW)",
   label: "Brownstown (USBYW)"
  },
  {
   value: "Brownstown (USBXV)",
   label: "Brownstown (USBXV)"
  },
  {
   value: "Brownsville (USBRO)",
   label: "Brownsville (USBRO)"
  },
  {
   value: "Brownsville (USBSD)",
   label: "Brownsville (USBSD)"
  },
  {
   value: "Brownton (USBWW)",
   label: "Brownton (USBWW)"
  },
  {
   value: "Brownwood (USBWD)",
   label: "Brownwood (USBWD)"
  },
  {
   value: "Brunswick (USBCK)",
   label: "Brunswick (USBCK)"
  },
  {
   value: "Brunswick (USSSI)",
   label: "Brunswick (USSSI)"
  },
  {
   value: "Brunswick (USNHZ)",
   label: "Brunswick (USNHZ)"
  },
  {
   value: "Brush (USBHQ)",
   label: "Brush (USBHQ)"
  },
  {
   value: "Bryan (USBRY)",
   label: "Bryan (USBRY)"
  },
  {
   value: "Bryan (USCFD)",
   label: "Bryan (USCFD)"
  },
  {
   value: "Bryn Mawr (USBYE)",
   label: "Bryn Mawr (USBYE)"
  },
  {
   value: "Bryson City (USBYF)",
   label: "Bryson City (USBYF)"
  },
  {
   value: "Buchanan (USBUC)",
   label: "Buchanan (USBUC)"
  },
  {
   value: "Buckeye (USBKI)",
   label: "Buckeye (USBKI)"
  },
  {
   value: "Buckhannon (USBHN)",
   label: "Buckhannon (USBHN)"
  },
  {
   value: "Buckley (USBUZ)",
   label: "Buckley (USBUZ)"
  },
  {
   value: "Bucks (USBKA)",
   label: "Bucks (USBKA)"
  },
  {
   value: "Bucksport (USBUP)",
   label: "Bucksport (USBUP)"
  },
  {
   value: "Bucyrus (USBXW)",
   label: "Bucyrus (USBXW)"
  },
  {
   value: "Bridgewater (USBJW)",
   label: "Bridgewater (USBJW)"
  },
  {
   value: "Bridgewater (USBQF)",
   label: "Bridgewater (USBQF)"
  },
  {
   value: "Brier (USBQG)",
   label: "Brier (USBQG)"
  },
  {
   value: "Brigham City (USBMC)",
   label: "Brigham City (USBMC)"
  },
  {
   value: "Brighton (USBHO)",
   label: "Brighton (USBHO)"
  },
  {
   value: "Brighton (USBTO)",
   label: "Brighton (USBTO)"
  },
  {
   value: "Brighton (USBGK)",
   label: "Brighton (USBGK)"
  },
  {
   value: "Brillion (USXCJ)",
   label: "Brillion (USXCJ)"
  },
  {
   value: "Brimfield (USBRM)",
   label: "Brimfield (USBRM)"
  },
  {
   value: "Brisbane (USBSA)",
   label: "Brisbane (USBSA)"
  },
  {
   value: "Bristol (USBCO)",
   label: "Bristol (USBCO)"
  },
  {
   value: "Bristol (USBSO)",
   label: "Bristol (USBSO)"
  },
  {
   value: "Bristol (USBSJ)",
   label: "Bristol (USBSJ)"
  },
  {
   value: "Bristol (USBSX)",
   label: "Bristol (USBSX)"
  },
  {
   value: "Bristol (USUAC)",
   label: "Bristol (USUAC)"
  },
  {
   value: "Bristol (USBRT)",
   label: "Bristol (USBRT)"
  },
  {
   value: "Bristol (USBSE)",
   label: "Bristol (USBSE)"
  },
  {
   value: "Bristol Bay (USBBA)",
   label: "Bristol Bay (USBBA)"
  },
  {
   value: "Broadview (USBRJ)",
   label: "Broadview (USBRJ)"
  },
  {
   value: "Broadway (USBYJ)",
   label: "Broadway (USBYJ)"
  },
  {
   value: "Broadway (USBPQ)",
   label: "Broadway (USBPQ)"
  },
  {
   value: "Broadway (USBDW)",
   label: "Broadway (USBDW)"
  },
  {
   value: "Brockport (USBPK)",
   label: "Brockport (USBPK)"
  },
  {
   value: "Brockton (USBKS)",
   label: "Brockton (USBKS)"
  },
  {
   value: "Brockway (USBKY)",
   label: "Brockway (USBKY)"
  },
  {
   value: "Brodnax (USBXQ)",
   label: "Brodnax (USBXQ)"
  },
  {
   value: "Broken Arrow (USBWQ)",
   label: "Broken Arrow (USBWQ)"
  },
  {
   value: "Broken Bow (USBBW)",
   label: "Broken Bow (USBBW)"
  },
  {
   value: "Bronx (USBRX)",
   label: "Bronx (USBRX)"
  },
  {
   value: "Bronxville (USBNX)",
   label: "Bronxville (USBNX)"
  },
  {
   value: "Brook Park (USBPC)",
   label: "Brook Park (USBPC)"
  },
  {
   value: "Brook Park (USBKP)",
   label: "Brook Park (USBKP)"
  },
  {
   value: "Brook Park (USBRP)",
   label: "Brook Park (USBRP)"
  },
  {
   value: "Brookfield (USBKC)",
   label: "Brookfield (USBKC)"
  },
  {
   value: "Brookfield (USBKZ)",
   label: "Brookfield (USBKZ)"
  },
  {
   value: "Brookfield (USBFZ)",
   label: "Brookfield (USBFZ)"
  },
  {
   value: "Brookfield (USXCH)",
   label: "Brookfield (USXCH)"
  },
  {
   value: "Brookhaven (USBKN)",
   label: "Brookhaven (USBKN)"
  },
  {
   value: "Brookings (USBKX)",
   label: "Brookings (USBKX)"
  },
  {
   value: "Brookley (USBKR)",
   label: "Brookley (USBKR)"
  },
  {
   value: "Brookline (USUBT)",
   label: "Brookline (USUBT)"
  },
  {
   value: "Brandywine (USXDL)",
   label: "Brandywine (USXDL)"
  },
  {
   value: "Branford (USBFC)",
   label: "Branford (USBFC)"
  },
  {
   value: "Brattleboro-Keene (USEEN)",
   label: "Brattleboro-Keene (USEEN)"
  },
  {
   value: "Brawley (USBWL)",
   label: "Brawley (USBWL)"
  },
  {
   value: "Brea (USBQE)",
   label: "Brea (USBQE)"
  },
  {
   value: "Breaux Bridge (USBXB)",
   label: "Breaux Bridge (USBXB)"
  },
  {
   value: "Breckenridge (USBKD)",
   label: "Breckenridge (USBKD)"
  },
  {
   value: "Breckenridge (USBYY)",
   label: "Breckenridge (USBYY)"
  },
  {
   value: "Brecksville (USBKV)",
   label: "Brecksville (USBKV)"
  },
  {
   value: "Breese (USBXD)",
   label: "Breese (USBXD)"
  },
  {
   value: "Bremen (USBXE)",
   label: "Bremen (USBXE)"
  },
  {
   value: "Bremerton (USPWT)",
   label: "Bremerton (USPWT)"
  },
  {
   value: "Brenham (USXCO)",
   label: "Brenham (USXCO)"
  },
  {
   value: "Brentwood (USBXF)",
   label: "Brentwood (USBXF)"
  },
  {
   value: "Brentwood (USBXG)",
   label: "Brentwood (USBXG)"
  },
  {
   value: "Brentwood (USBQB)",
   label: "Brentwood (USBQB)"
  },
  {
   value: "Brentwood (USBWE)",
   label: "Brentwood (USBWE)"
  },
  {
   value: "Brewer (USBXH)",
   label: "Brewer (USBXH)"
  },
  {
   value: "Brewster (USBRR)",
   label: "Brewster (USBRR)"
  },
  {
   value: "Brewster (USBXI)",
   label: "Brewster (USBXI)"
  },
  {
   value: "Brewton (USBXJ)",
   label: "Brewton (USBXJ)"
  },
  {
   value: "Brian (USBXL)",
   label: "Brian (USBXL)"
  },
  {
   value: "Bricktown (USBIT)",
   label: "Bricktown (USBIT)"
  },
  {
   value: "Bridesburg (USXCE)",
   label: "Bridesburg (USXCE)"
  },
  {
   value: "Bridgeburg (USBJB)",
   label: "Bridgeburg (USBJB)"
  },
  {
   value: "Bridgeport (USXCS)",
   label: "Bridgeport (USXCS)"
  },
  {
   value: "Bridgeport (USXDJ)",
   label: "Bridgeport (USXDJ)"
  },
  {
   value: "Bridgeport (USBPG)",
   label: "Bridgeport (USBPG)"
  },
  {
   value: "Bridgeport (USBGP)",
   label: "Bridgeport (USBGP)"
  },
  {
   value: "Bridgeport (USBPM)",
   label: "Bridgeport (USBPM)"
  },
  {
   value: "Bridgeport (USBDR)",
   label: "Bridgeport (USBDR)"
  },
  {
   value: "Bridgeport (USBXM)",
   label: "Bridgeport (USBXM)"
  },
  {
   value: "Bridger (USBIQ)",
   label: "Bridger (USBIQ)"
  },
  {
   value: "Bridgeton (USBMZ)",
   label: "Bridgeton (USBMZ)"
  },
  {
   value: "Bridgeton (USBGY)",
   label: "Bridgeton (USBGY)"
  },
  {
   value: "Bridgetown (USBJT)",
   label: "Bridgetown (USBJT)"
  },
  {
   value: "Bridgeview (USQVW)",
   label: "Bridgeview (USQVW)"
  },
  {
   value: "Bridgeville (USXCT)",
   label: "Bridgeville (USXCT)"
  },
  {
   value: "Bridgewater (USBDT)",
   label: "Bridgewater (USBDT)"
  },
  {
   value: "Bridgewater (USBGW)",
   label: "Bridgewater (USBGW)"
  },
  {
   value: "Boring (USBHG)",
   label: "Boring (USBHG)"
  },
  {
   value: "Boscobel (USBBE)",
   label: "Boscobel (USBBE)"
  },
  {
   value: "Bossier City (USBSR)",
   label: "Bossier City (USBSR)"
  },
  {
   value: "Boston (USBSN)",
   label: "Boston (USBSN)"
  },
  {
   value: "Boston (USBOS)",
   label: "Boston (USBOS)"
  },
  {
   value: "Botkins (USBTK)",
   label: "Botkins (USBTK)"
  },
  {
   value: "Botsford (USBOF)",
   label: "Botsford (USBOF)"
  },
  {
   value: "Boulder (USWBU)",
   label: "Boulder (USWBU)"
  },
  {
   value: "Bound Brook (USBBK)",
   label: "Bound Brook (USBBK)"
  },
  {
   value: "Boundary (USBPF)",
   label: "Boundary (USBPF)"
  },
  {
   value: "Bountiful (USBTF)",
   label: "Bountiful (USBTF)"
  },
  {
   value: "Bourne (USBOR)",
   label: "Bourne (USBOR)"
  },
  {
   value: "Bow (USBOX)",
   label: "Bow (USBOX)"
  },
  {
   value: "Bowerston (USBWN)",
   label: "Bowerston (USBWN)"
  },
  {
   value: "Bowling Green (USBWG)",
   label: "Bowling Green (USBWG)"
  },
  {
   value: "Bowling Green (USBWO)",
   label: "Bowling Green (USBWO)"
  },
  {
   value: "Bowmanstown (USBMW)",
   label: "Bowmanstown (USBMW)"
  },
  {
   value: "Bowmansville (USBWV)",
   label: "Bowmansville (USBWV)"
  },
  {
   value: "Box Springs (USBXP)",
   label: "Box Springs (USBXP)"
  },
  {
   value: "Boyceville (USBYC)",
   label: "Boyceville (USBYC)"
  },
  {
   value: "Boyertown (USBOE)",
   label: "Boyertown (USBOE)"
  },
  {
   value: "Boyle Heights (USXDK)",
   label: "Boyle Heights (USXDK)"
  },
  {
   value: "Boynton Beach (USBYB)",
   label: "Boynton Beach (USBYB)"
  },
  {
   value: "Bozeman (USBZM)",
   label: "Bozeman (USBZM)"
  },
  {
   value: "Bradbury (USBUA)",
   label: "Bradbury (USBUA)"
  },
  {
   value: "Braddock (USBDD)",
   label: "Braddock (USBDD)"
  },
  {
   value: "Bradenton-Sarasota Apt (USSRQ)",
   label: "Bradenton-Sarasota Apt (USSRQ)"
  },
  {
   value: "Bradford (USBDF)",
   label: "Bradford (USBDF)"
  },
  {
   value: "Bradford (USBFD)",
   label: "Bradford (USBFD)"
  },
  {
   value: "Bradley (USBYL)",
   label: "Bradley (USBYL)"
  },
  {
   value: "Bradner (USBHD)",
   label: "Bradner (USBHD)"
  },
  {
   value: "Bradwood (USBRA)",
   label: "Bradwood (USBRA)"
  },
  {
   value: "Brady (USBBD)",
   label: "Brady (USBBD)"
  },
  {
   value: "Brainards (USBQS)",
   label: "Brainards (USBQS)"
  },
  {
   value: "Brainerd (USBRD)",
   label: "Brainerd (USBRD)"
  },
  {
   value: "Braintree (USBTC)",
   label: "Braintree (USBTC)"
  },
  {
   value: "Braithwaite (USBWT)",
   label: "Braithwaite (USBWT)"
  },
  {
   value: "Brandenburg (USBNR)",
   label: "Brandenburg (USBNR)"
  },
  {
   value: "Brandenton (USBBI)",
   label: "Brandenton (USBBI)"
  },
  {
   value: "Brandon (USBXX)",
   label: "Brandon (USBXX)"
  },
  {
   value: "Blue Springs (USBPR)",
   label: "Blue Springs (USBPR)"
  },
  {
   value: "\"Bluefield (USBFW)",
   label: "\"Bluefield (USBFW)"
  },
  {
   value: "Bluefield\/Princeton (USBLF)",
   label: "Bluefield\/Princeton (USBLF)"
  },
  {
   value: "Bluff (USXDB)",
   label: "Bluff (USXDB)"
  },
  {
   value: "Bluffton (USBLU)",
   label: "Bluffton (USBLU)"
  },
  {
   value: "Bluffton (USBFE)",
   label: "Bluffton (USBFE)"
  },
  {
   value: "Bluffton (USBHK)",
   label: "Bluffton (USBHK)"
  },
  {
   value: "Blytheville (USBYH)",
   label: "Blytheville (USBYH)"
  },
  {
   value: "Blythewood (USUBV)",
   label: "Blythewood (USUBV)"
  },
  {
   value: "Boardman (USBDM)",
   label: "Boardman (USBDM)"
  },
  {
   value: "Boardman (USBDA)",
   label: "Boardman (USBDA)"
  },
  {
   value: "Bobger (USBOB)",
   label: "Bobger (USBOB)"
  },
  {
   value: "Boca Raton (USBCT)",
   label: "Boca Raton (USBCT)"
  },
  {
   value: "Bocagrande (USBCG)",
   label: "Bocagrande (USBCG)"
  },
  {
   value: "Bogalusa (USBXA)",
   label: "Bogalusa (USBXA)"
  },
  {
   value: "Bogota (USBOG)",
   label: "Bogota (USBOG)"
  },
  {
   value: "Bohemia (USBOH)",
   label: "Bohemia (USBOH)"
  },
  {
   value: "Boise (USBOI)",
   label: "Boise (USBOI)"
  },
  {
   value: "Bolivar (USBOV)",
   label: "Bolivar (USBOV)"
  },
  {
   value: "Bolivar (USXCR)",
   label: "Bolivar (USXCR)"
  },
  {
   value: "Bolton (USBOL)",
   label: "Bolton (USBOL)"
  },
  {
   value: "Bon Air (USBOA)",
   label: "Bon Air (USBOA)"
  },
  {
   value: "Bon Wier (USBWX)",
   label: "Bon Wier (USBWX)"
  },
  {
   value: "Bonanza (USBON)",
   label: "Bonanza (USBON)"
  },
  {
   value: "Bonduel (USBOU)",
   label: "Bonduel (USBOU)"
  },
  {
   value: "Bonger (USBOZ)",
   label: "Bonger (USBOZ)"
  },
  {
   value: "Bonham (USBOM)",
   label: "Bonham (USBOM)"
  },
  {
   value: "Bonita Springs (USBOP)",
   label: "Bonita Springs (USBOP)"
  },
  {
   value: "Bonner Springs (USBSU)",
   label: "Bonner Springs (USBSU)"
  },
  {
   value: "Bonsall (USBPE)",
   label: "Bonsall (USBPE)"
  },
  {
   value: "Boone (USXCP)",
   label: "Boone (USXCP)"
  },
  {
   value: "Boone (USBNW)",
   label: "Boone (USBNW)"
  },
  {
   value: "Booneville (USBOQ)",
   label: "Booneville (USBOQ)"
  },
  {
   value: "Booneville (USBOO)",
   label: "Booneville (USBOO)"
  },
  {
   value: "Boonton (USBTB)",
   label: "Boonton (USBTB)"
  },
  {
   value: "Boonville (USBVQ)",
   label: "Boonville (USBVQ)"
  },
  {
   value: "Boonville (USBVM)",
   label: "Boonville (USBVM)"
  },
  {
   value: "Boonville (USBVL)",
   label: "Boonville (USBVL)"
  },
  {
   value: "Boothwyn (USXDA)",
   label: "Boothwyn (USXDA)"
  },
  {
   value: "Borden (USBDI)",
   label: "Borden (USBDI)"
  },
  {
   value: "Bordentown (USBOJ)",
   label: "Bordentown (USBOJ)"
  },
  {
   value: "Blacksburg (USBBH)",
   label: "Blacksburg (USBBH)"
  },
  {
   value: "Blacksburg (USBCB)",
   label: "Blacksburg (USBCB)"
  },
  {
   value: "Blackstone (USBKT)",
   label: "Blackstone (USBKT)"
  },
  {
   value: "Blacktone (USXCK)",
   label: "Blacktone (USXCK)"
  },
  {
   value: "Blackwood (USBQW)",
   label: "Blackwood (USBQW)"
  },
  {
   value: "Bladenboro (USBXO)",
   label: "Bladenboro (USBXO)"
  },
  {
   value: "Bladensburg (USBDZ)",
   label: "Bladensburg (USBDZ)"
  },
  {
   value: "Blaine (USBWS)",
   label: "Blaine (USBWS)"
  },
  {
   value: "Blaine (USBLA)",
   label: "Blaine (USBLA)"
  },
  {
   value: "Blaine (USBNE)",
   label: "Blaine (USBNE)"
  },
  {
   value: "Blair (USBAJ)",
   label: "Blair (USBAJ)"
  },
  {
   value: "Blair (USBIW)",
   label: "Blair (USBIW)"
  },
  {
   value: "Blairsville (USBSI)",
   label: "Blairsville (USBSI)"
  },
  {
   value: "Blakely (USBMU)",
   label: "Blakely (USBMU)"
  },
  {
   value: "Bland (USBDQ)",
   label: "Bland (USBDQ)"
  },
  {
   value: "Bland (USBDC)",
   label: "Bland (USBDC)"
  },
  {
   value: "Blandon (USBDN)",
   label: "Blandon (USBDN)"
  },
  {
   value: "Blauvelt (USBUY)",
   label: "Blauvelt (USBUY)"
  },
  {
   value: "Blissfield (USBLS)",
   label: "Blissfield (USBLS)"
  },
  {
   value: "Bloomfield (USAAC)",
   label: "Bloomfield (USAAC)"
  },
  {
   value: "Bloomfield (USBMF)",
   label: "Bloomfield (USBMF)"
  },
  {
   value: "Bloomfield (USBMN)",
   label: "Bloomfield (USBMN)"
  },
  {
   value: "Bloomingburg (USBBU)",
   label: "Bloomingburg (USBBU)"
  },
  {
   value: "Bloomingburg (USBMB)",
   label: "Bloomingburg (USBMB)"
  },
  {
   value: "Bloomingdale (USBGL)",
   label: "Bloomingdale (USBGL)"
  },
  {
   value: "Bloomington (USBLT)",
   label: "Bloomington (USBLT)"
  },
  {
   value: "Bloomington (USBMG)",
   label: "Bloomington (USBMG)"
  },
  {
   value: "Bloomington (USBQI)",
   label: "Bloomington (USBQI)"
  },
  {
   value: "Bloomington (USBLO)",
   label: "Bloomington (USBLO)"
  },
  {
   value: "Bloomsburg (USBSB)",
   label: "Bloomsburg (USBSB)"
  },
  {
   value: "Bloomsbury (USBBQ)",
   label: "Bloomsbury (USBBQ)"
  },
  {
   value: "Blowing Rock (USBWK)",
   label: "Blowing Rock (USBWK)"
  },
  {
   value: "Blue Ash (USXDC)",
   label: "Blue Ash (USXDC)"
  },
  {
   value: "Blue Bell (USBBX)",
   label: "Blue Bell (USBBX)"
  },
  {
   value: "Blue Island (USBCU)",
   label: "Blue Island (USBCU)"
  },
  {
   value: "Blue Lake (USBUL)",
   label: "Blue Lake (USBUL)"
  },
  {
   value: "Blue Mountain (USXCN)",
   label: "Blue Mountain (USXCN)"
  },
  {
   value: "Blue Rapids (USBPD)",
   label: "Blue Rapids (USBPD)"
  },
  {
   value: "Blue Ridge Summit (USBJP)",
   label: "Blue Ridge Summit (USBJP)"
  },
  {
   value: "Blue Springs (USBZY)",
   label: "Blue Springs (USBZY)"
  },
  {
   value: "Bethany (USBHH)",
   label: "Bethany (USBHH)"
  },
  {
   value: "Bethany (USBTW)",
   label: "Bethany (USBTW)"
  },
  {
   value: "Bethel (USBTJ)",
   label: "Bethel (USBTJ)"
  },
  {
   value: "Bethel (USBTG)",
   label: "Bethel (USBTG)"
  },
  {
   value: "Bethel (USXBV)",
   label: "Bethel (USXBV)"
  },
  {
   value: "Bethesda (USBZH)",
   label: "Bethesda (USBZH)"
  },
  {
   value: "Bethune (USBTE)",
   label: "Bethune (USBTE)"
  },
  {
   value: "Bettendorf (USBTD)",
   label: "Bettendorf (USBTD)"
  },
  {
   value: "Beverly (USBVY)",
   label: "Beverly (USBVY)"
  },
  {
   value: "Beverly (USXDF)",
   label: "Beverly (USXDF)"
  },
  {
   value: "Beverly (USBVR)",
   label: "Beverly (USBVR)"
  },
  {
   value: "Beverly Hills (USBVH)",
   label: "Beverly Hills (USBVH)"
  },
  {
   value: "Biddeford (USBDJ)",
   label: "Biddeford (USBDJ)"
  },
  {
   value: "Big Bear Lake (USBBL)",
   label: "Big Bear Lake (USBBL)"
  },
  {
   value: "Big Delta (USBIG)",
   label: "Big Delta (USBIG)"
  },
  {
   value: "Big Island (USXCD)",
   label: "Big Island (USXCD)"
  },
  {
   value: "Big Lake (USBGQ)",
   label: "Big Lake (USBGQ)"
  },
  {
   value: "Big Mountain (USBMO)",
   label: "Big Mountain (USBMO)"
  },
  {
   value: "Big Rapids (USWBR)",
   label: "Big Rapids (USWBR)"
  },
  {
   value: "Big Sandy (USBDY)",
   label: "Big Sandy (USBDY)"
  },
  {
   value: "Big Spring (USHCA)",
   label: "Big Spring (USHCA)"
  },
  {
   value: "Biglerville (USBIP)",
   label: "Biglerville (USBIP)"
  },
  {
   value: "Billerica (USBMS)",
   label: "Billerica (USBMS)"
  },
  {
   value: "Billings (USBIL)",
   label: "Billings (USBIL)"
  },
  {
   value: "Biloxi (USBIX)",
   label: "Biloxi (USBIX)"
  },
  {
   value: "Bingen (USXCF)",
   label: "Bingen (USXCF)"
  },
  {
   value: "Binghampton-Endicott-Johnson Cty (USBGM)",
   label: "Binghampton-Endicott-Johnson Cty (USBGM)"
  },
  {
   value: "Birchwood (USBIR)",
   label: "Birchwood (USBIR)"
  },
  {
   value: "Bird In Hand (USXCG)",
   label: "Bird In Hand (USXCG)"
  },
  {
   value: "Birdsboro (USBIB)",
   label: "Birdsboro (USBIB)"
  },
  {
   value: "Birmingham (USBHM)",
   label: "Birmingham (USBHM)"
  },
  {
   value: "Birmingham (USBIZ)",
   label: "Birmingham (USBIZ)"
  },
  {
   value: "Birmingham (USBIN)",
   label: "Birmingham (USBIN)"
  },
  {
   value: "Bishop (USBHX)",
   label: "Bishop (USBHX)"
  },
  {
   value: "Bishop (USBIH)",
   label: "Bishop (USBIH)"
  },
  {
   value: "Bishopville (USBIV)",
   label: "Bishopville (USBIV)"
  },
  {
   value: "Bismarck (USBIS)",
   label: "Bismarck (USBIS)"
  },
  {
   value: "Black Creek (USBLC)",
   label: "Black Creek (USBLC)"
  },
  {
   value: "Black Mountain (USBQM)",
   label: "Black Mountain (USBQM)"
  },
  {
   value: "Blackfoot (USBLK)",
   label: "Blackfoot (USBLK)"
  },
  {
   value: "Bennettsville (USBTN)",
   label: "Bennettsville (USBTN)"
  },
  {
   value: "Bennington (USBGN)",
   label: "Bennington (USBGN)"
  },
  {
   value: "Bensalem (USBNM)",
   label: "Bensalem (USBNM)"
  },
  {
   value: "Bensen (USBNS)",
   label: "Bensen (USBNS)"
  },
  {
   value: "Bensenville (USBNV)",
   label: "Bensenville (USBNV)"
  },
  {
   value: "Benson (USBNZ)",
   label: "Benson (USBNZ)"
  },
  {
   value: "Benton (USBXN)",
   label: "Benton (USBXN)"
  },
  {
   value: "Benton (USBTQ)",
   label: "Benton (USBTQ)"
  },
  {
   value: "Benton (USBTZ)",
   label: "Benton (USBTZ)"
  },
  {
   value: "Benton Harbor (USBEH)",
   label: "Benton Harbor (USBEH)"
  },
  {
   value: "Bentonville (USBNT)",
   label: "Bentonville (USBNT)"
  },
  {
   value: "Berea (USBEU)",
   label: "Berea (USBEU)"
  },
  {
   value: "Bergenfield (USBRF)",
   label: "Bergenfield (USBRF)"
  },
  {
   value: "Bergholtz (USBRH)",
   label: "Bergholtz (USBRH)"
  },
  {
   value: "Bergholz (USBHZ)",
   label: "Bergholz (USBHZ)"
  },
  {
   value: "Berkeley (USJBK)",
   label: "Berkeley (USJBK)"
  },
  {
   value: "Berkeley (USBQU)",
   label: "Berkeley (USBQU)"
  },
  {
   value: "Berkeley Heights (USBHE)",
   label: "Berkeley Heights (USBHE)"
  },
  {
   value: "Berkeley Springs (USBEI)",
   label: "Berkeley Springs (USBEI)"
  },
  {
   value: "Berkely (USBKK)",
   label: "Berkely (USBKK)"
  },
  {
   value: "Berkholz (USXCI)",
   label: "Berkholz (USXCI)"
  },
  {
   value: "Berlin (USBIK)",
   label: "Berlin (USBIK)"
  },
  {
   value: "Berlin (USBML)",
   label: "Berlin (USBML)"
  },
  {
   value: "Berlin (USXBT)",
   label: "Berlin (USXBT)"
  },
  {
   value: "Berlin (USBRI)",
   label: "Berlin (USBRI)"
  },
  {
   value: "Berlin (USBRB)",
   label: "Berlin (USBRB)"
  },
  {
   value: "Bern (USBRC)",
   label: "Bern (USBRC)"
  },
  {
   value: "Bernalillo (USBEO)",
   label: "Bernalillo (USBEO)"
  },
  {
   value: "Bernardsville (USBRV)",
   label: "Bernardsville (USBRV)"
  },
  {
   value: "Berryton (USBEY)",
   label: "Berryton (USBEY)"
  },
  {
   value: "Berryville (USBYV)",
   label: "Berryville (USBYV)"
  },
  {
   value: "Bertram (USXCY)",
   label: "Bertram (USXCY)"
  },
  {
   value: "Berwick (USXDH)",
   label: "Berwick (USXDH)"
  },
  {
   value: "Berwick (USBER)",
   label: "Berwick (USBER)"
  },
  {
   value: "Berwyn (USBWY)",
   label: "Berwyn (USBWY)"
  },
  {
   value: "Berwyn (USBEW)",
   label: "Berwyn (USBEW)"
  },
  {
   value: "Bessemer (USBMV)",
   label: "Bessemer (USBMV)"
  },
  {
   value: "Bessemer City (USUBX)",
   label: "Bessemer City (USUBX)"
  },
  {
   value: "Bessemer City (USAAD)",
   label: "Bessemer City (USAAD)"
  },
  {
   value: "Bethany (USBTX)",
   label: "Bethany (USBTX)"
  },
  {
   value: "Bethany (USBHY)",
   label: "Bethany (USBHY)"
  },
  {
   value: "Bell (USBQC)",
   label: "Bell (USBQC)"
  },
  {
   value: "Bell Bay (USAAB)",
   label: "Bell Bay (USAAB)"
  },
  {
   value: "Bell Gardens (USBLG)",
   label: "Bell Gardens (USBLG)"
  },
  {
   value: "Bellaire (USBAR)",
   label: "Bellaire (USBAR)"
  },
  {
   value: "Belle Glade (USBCF)",
   label: "Belle Glade (USBCF)"
  },
  {
   value: "Belle Mead (USBLJ)",
   label: "Belle Mead (USBLJ)"
  },
  {
   value: "Belle Plaine (USBLP)",
   label: "Belle Plaine (USBLP)"
  },
  {
   value: "Belle Vernon (USBVN)",
   label: "Belle Vernon (USBVN)"
  },
  {
   value: "\"Belle (USBLE)",
   label: "\"Belle (USBLE)"
  },
  {
   value: "Bellefontaine (USBGJ)",
   label: "Bellefontaine (USBGJ)"
  },
  {
   value: "Bellefontaine (USBFN)",
   label: "Bellefontaine (USBFN)"
  },
  {
   value: "Belleville (USBLQ)",
   label: "Belleville (USBLQ)"
  },
  {
   value: "Belleville (USBLV)",
   label: "Belleville (USBLV)"
  },
  {
   value: "Belleville (USBLZ)",
   label: "Belleville (USBLZ)"
  },
  {
   value: "Belleville (USUBU)",
   label: "Belleville (USUBU)"
  },
  {
   value: "Bellevue (USBVE)",
   label: "Bellevue (USBVE)"
  },
  {
   value: "Bellevue (USBEG)",
   label: "Bellevue (USBEG)"
  },
  {
   value: "Bellevue (USXDE)",
   label: "Bellevue (USXDE)"
  },
  {
   value: "Bellevue (USXBX)",
   label: "Bellevue (USXBX)"
  },
  {
   value: "Bellflower (USBFX)",
   label: "Bellflower (USBFX)"
  },
  {
   value: "Bellingham (USBIM)",
   label: "Bellingham (USBIM)"
  },
  {
   value: "Bellingham (USBLI)",
   label: "Bellingham (USBLI)"
  },
  {
   value: "Bellmawr (USBWR)",
   label: "Bellmawr (USBWR)"
  },
  {
   value: "Bellville (USBFV)",
   label: "Bellville (USBFV)"
  },
  {
   value: "Bellville (USBVB)",
   label: "Bellville (USBVB)"
  },
  {
   value: "Bellwood (USUFA)",
   label: "Bellwood (USUFA)"
  },
  {
   value: "Belmar (USBLM)",
   label: "Belmar (USBLM)"
  },
  {
   value: "Belmont (USBMQ)",
   label: "Belmont (USBMQ)"
  },
  {
   value: "Belmont (USBVT)",
   label: "Belmont (USBVT)"
  },
  {
   value: "Belmont (USBMM)",
   label: "Belmont (USBMM)"
  },
  {
   value: "Beloit (USBOT)",
   label: "Beloit (USBOT)"
  },
  {
   value: "Belpre (USBEP)",
   label: "Belpre (USBEP)"
  },
  {
   value: "Belton (USXCZ)",
   label: "Belton (USXCZ)"
  },
  {
   value: "Beltsville (USBES)",
   label: "Beltsville (USBES)"
  },
  {
   value: "Belvidere (USBVJ)",
   label: "Belvidere (USBVJ)"
  },
  {
   value: "Belvidere (USXBU)",
   label: "Belvidere (USXBU)"
  },
  {
   value: "Belzoni (USBEZ)",
   label: "Belzoni (USBEZ)"
  },
  {
   value: "Bemidji (USBJI)",
   label: "Bemidji (USBJI)"
  },
  {
   value: "Bena (USBEN)",
   label: "Bena (USBEN)"
  },
  {
   value: "Benicia (USBNC)",
   label: "Benicia (USBNC)"
  },
  {
   value: "Benjes (USBNJ)",
   label: "Benjes (USBNJ)"
  },
  {
   value: "Bayport (USBPZ)",
   label: "Bayport (USBPZ)"
  },
  {
   value: "Bayport (USBPX)",
   label: "Bayport (USBPX)"
  },
  {
   value: "Baytown (USHPY)",
   label: "Baytown (USHPY)"
  },
  {
   value: "Beachwood (USBEQ)",
   label: "Beachwood (USBEQ)"
  },
  {
   value: "Beacon Falls (USBEK)",
   label: "Beacon Falls (USBEK)"
  },
  {
   value: "Beacon Hills (USBAH)",
   label: "Beacon Hills (USBAH)"
  },
  {
   value: "Bean Station (USBST)",
   label: "Bean Station (USBST)"
  },
  {
   value: "Bearden (USBJD)",
   label: "Bearden (USBJD)"
  },
  {
   value: "Beardstown (USBEA)",
   label: "Beardstown (USBEA)"
  },
  {
   value: "Beatrice (USBIE)",
   label: "Beatrice (USBIE)"
  },
  {
   value: "Beaufort (USBFT)",
   label: "Beaufort (USBFT)"
  },
  {
   value: "Beaufort-Morehead City (USBFO)",
   label: "Beaufort-Morehead City (USBFO)"
  },
  {
   value: "Beaumont (USBPT)",
   label: "Beaumont (USBPT)"
  },
  {
   value: "Beaver Dam (USBEV)",
   label: "Beaver Dam (USBEV)"
  },
  {
   value: "Beaver Dam (USBVA)",
   label: "Beaver Dam (USBVA)"
  },
  {
   value: "Beaver Falls (USBVF)",
   label: "Beaver Falls (USBVF)"
  },
  {
   value: "Beaver Falls (USBFP)",
   label: "Beaver Falls (USBFP)"
  },
  {
   value: "Beaverton (USBVW)",
   label: "Beaverton (USBVW)"
  },
  {
   value: "Beckemeyer (USBEC)",
   label: "Beckemeyer (USBEC)"
  },
  {
   value: "Beckley (USBKW)",
   label: "Beckley (USBKW)"
  },
  {
   value: "Bedford (USXBZ)",
   label: "Bedford (USXBZ)"
  },
  {
   value: "Bedford (USXBY)",
   label: "Bedford (USXBY)"
  },
  {
   value: "Bedford (USBOD)",
   label: "Bedford (USBOD)"
  },
  {
   value: "Bedford (USBED)",
   label: "Bedford (USBED)"
  },
  {
   value: "Bedford (USBFR)",
   label: "Bedford (USBFR)"
  },
  {
   value: "Bedford (USXCA)",
   label: "Bedford (USXCA)"
  },
  {
   value: "Bedford Heights (USBFH)",
   label: "Bedford Heights (USBFH)"
  },
  {
   value: "Bedford Heights (USBDH)",
   label: "Bedford Heights (USBDH)"
  },
  {
   value: "Bedford Park (USBDP)",
   label: "Bedford Park (USBDP)"
  },
  {
   value: "Beech Bottom (USBBV)",
   label: "Beech Bottom (USBBV)"
  },
  {
   value: "Beech Island (USBEE)",
   label: "Beech Island (USBEE)"
  },
  {
   value: "Beecher Falls (USBEF)",
   label: "Beecher Falls (USBEF)"
  },
  {
   value: "Beeville (USNIR)",
   label: "Beeville (USNIR)"
  },
  {
   value: "Bel Air (USBLX)",
   label: "Bel Air (USBLX)"
  },
  {
   value: "Belair (USBLB)",
   label: "Belair (USBLB)"
  },
  {
   value: "Belcamp (USBMP)",
   label: "Belcamp (USBMP)"
  },
  {
   value: "Belding (USXCC)",
   label: "Belding (USXCC)"
  },
  {
   value: "Belen (USBLN)",
   label: "Belen (USBLN)"
  },
  {
   value: "Belfast (USBEL)",
   label: "Belfast (USBEL)"
  },
  {
   value: "Belgium (USBGU)",
   label: "Belgium (USBGU)"
  },
  {
   value: "Barrington (USBRZ)",
   label: "Barrington (USBRZ)"
  },
  {
   value: "Barrington (USBRQ)",
   label: "Barrington (USBRQ)"
  },
  {
   value: "Barstow (USBZW)",
   label: "Barstow (USBZW)"
  },
  {
   value: "Bartlesville (USBVO)",
   label: "Bartlesville (USBVO)"
  },
  {
   value: "Bartlett (USBTT)",
   label: "Bartlett (USBTT)"
  },
  {
   value: "Bartlett Springs (USBSP)",
   label: "Bartlett Springs (USBSP)"
  },
  {
   value: "Bartow (USBOW)",
   label: "Bartow (USBOW)"
  },
  {
   value: "Bartow (USABO)",
   label: "Bartow (USABO)"
  },
  {
   value: "Bascom (USBSC)",
   label: "Bascom (USBSC)"
  },
  {
   value: "Basin (USXBR)",
   label: "Basin (USXBR)"
  },
  {
   value: "Basking Ridge (USBSK)",
   label: "Basking Ridge (USBSK)"
  },
  {
   value: "Bassett (USBAC)",
   label: "Bassett (USBAC)"
  },
  {
   value: "Bassett (USBSS)",
   label: "Bassett (USBSS)"
  },
  {
   value: "Bastrop (USBAS)",
   label: "Bastrop (USBAS)"
  },
  {
   value: "Batavia (USBTA)",
   label: "Batavia (USBTA)"
  },
  {
   value: "Batavia (USBIA)",
   label: "Batavia (USBIA)"
  },
  {
   value: "Batavia (USBUX)",
   label: "Batavia (USBUX)"
  },
  {
   value: "Batesburg (USBBG)",
   label: "Batesburg (USBBG)"
  },
  {
   value: "Batesville (USBVZ)",
   label: "Batesville (USBVZ)"
  },
  {
   value: "Batesville (USBVX)",
   label: "Batesville (USBVX)"
  },
  {
   value: "Batesville (USBTS)",
   label: "Batesville (USBTS)"
  },
  {
   value: "Batesville (USHLB)",
   label: "Batesville (USHLB)"
  },
  {
   value: "Bath (USXBP)",
   label: "Bath (USXBP)"
  },
  {
   value: "Bath (USBTH)",
   label: "Bath (USBTH)"
  },
  {
   value: "Baton Rouge (USBTR)",
   label: "Baton Rouge (USBTR)"
  },
  {
   value: "Battle Creek (USBTL)",
   label: "Battle Creek (USBTL)"
  },
  {
   value: "Battle Ground (USBRU)",
   label: "Battle Ground (USBRU)"
  },
  {
   value: "Battleboro (USBBO)",
   label: "Battleboro (USBBO)"
  },
  {
   value: "Baudette (USBDE)",
   label: "Baudette (USBDE)"
  },
  {
   value: "Bauxite (USBXT)",
   label: "Bauxite (USBXT)"
  },
  {
   value: "Baxley (USBYX)",
   label: "Baxley (USBYX)"
  },
  {
   value: "Baxter (USBXR)",
   label: "Baxter (USBXR)"
  },
  {
   value: "Bay Meadows (USBYT)",
   label: "Bay Meadows (USBYT)"
  },
  {
   value: "Bay Minetta (USBYZ)",
   label: "Bay Minetta (USBYZ)"
  },
  {
   value: "Bay Minette (USBME)",
   label: "Bay Minette (USBME)"
  },
  {
   value: "Bay Saint Louis (USBSL)",
   label: "Bay Saint Louis (USBSL)"
  },
  {
   value: "Bay Shore (USBSH)",
   label: "Bay Shore (USBSH)"
  },
  {
   value: "Bayard (USBYD)",
   label: "Bayard (USBYD)"
  },
  {
   value: "Bayonne (USBAY)",
   label: "Bayonne (USBAY)"
  },
  {
   value: "Bayou la Batre (USBYU)",
   label: "Bayou la Batre (USBYU)"
  },
  {
   value: "Bayport (USBPB)",
   label: "Bayport (USBPB)"
  },
  {
   value: "Azusa (USAZU)",
   label: "Azusa (USAZU)"
  },
  {
   value: "Babcock (USBAK)",
   label: "Babcock (USBAK)"
  },
  {
   value: "Babylon (USBBY)",
   label: "Babylon (USBBY)"
  },
  {
   value: "Bad Axe (USBAA)",
   label: "Bad Axe (USBAA)"
  },
  {
   value: "Badin (USBAN)",
   label: "Badin (USBAN)"
  },
  {
   value: "Bagdad (USBAG)",
   label: "Bagdad (USBAG)"
  },
  {
   value: "Bagdad (USBGT)",
   label: "Bagdad (USBGT)"
  },
  {
   value: "Bailey (USBAI)",
   label: "Bailey (USBAI)"
  },
  {
   value: "Bainbridge (USBGE)",
   label: "Bainbridge (USBGE)"
  },
  {
   value: "Bainbridge (USBCA)",
   label: "Bainbridge (USBCA)"
  },
  {
   value: "Baker (USBKE)",
   label: "Baker (USBKE)"
  },
  {
   value: "Bakersfield (USBFL)",
   label: "Bakersfield (USBFL)"
  },
  {
   value: "Balboa (USBAZ)",
   label: "Balboa (USBAZ)"
  },
  {
   value: "Baldwin (USBAD)",
   label: "Baldwin (USBAD)"
  },
  {
   value: "Baldwin (USBAX)",
   label: "Baldwin (USBAX)"
  },
  {
   value: "Baldwin (USBAQ)",
   label: "Baldwin (USBAQ)"
  },
  {
   value: "Baldwin (USBBJ)",
   label: "Baldwin (USBBJ)"
  },
  {
   value: "Baldwin Park (USBWP)",
   label: "Baldwin Park (USBWP)"
  },
  {
   value: "Balfour (USBAW)",
   label: "Balfour (USBAW)"
  },
  {
   value: "Ballinger (USBLR)",
   label: "Ballinger (USBLR)"
  },
  {
   value: "Ballston Spa (USBQY)",
   label: "Ballston Spa (USBQY)"
  },
  {
   value: "Ballwin (USBLL)",
   label: "Ballwin (USBLL)"
  },
  {
   value: "Bally (USBLY)",
   label: "Bally (USBLY)"
  },
  {
   value: "Balmat (USXBS)",
   label: "Balmat (USXBS)"
  },
  {
   value: "Baltimore (USBAL)",
   label: "Baltimore (USBAL)"
  },
  {
   value: "Baltimore-Washington Int Apt (USBWI)",
   label: "Baltimore-Washington Int Apt (USBWI)"
  },
  {
   value: "Bamberg (USBAM)",
   label: "Bamberg (USBAM)"
  },
  {
   value: "Bangor (USBGR)",
   label: "Bangor (USBGR)"
  },
  {
   value: "Bannockburn (USBNN)",
   label: "Bannockburn (USBNN)"
  },
  {
   value: "Bar Harbor (USBHB)",
   label: "Bar Harbor (USBHB)"
  },
  {
   value: "Baraboo (USXBQ)",
   label: "Baraboo (USXBQ)"
  },
  {
   value: "Barbers Point (Oahu) (USNAX)",
   label: "Barbers Point (Oahu) (USNAX)"
  },
  {
   value: "Barberton (USBAT)",
   label: "Barberton (USBAT)"
  },
  {
   value: "Barbours Cut (USBBT)",
   label: "Barbours Cut (USBBT)"
  },
  {
   value: "Bardstown (USXCV)",
   label: "Bardstown (USXCV)"
  },
  {
   value: "Barlow (USBAO)",
   label: "Barlow (USBAO)"
  },
  {
   value: "Barnesville (USBAV)",
   label: "Barnesville (USBAV)"
  },
  {
   value: "Barnesville (USBZC)",
   label: "Barnesville (USBZC)"
  },
  {
   value: "Barnhart (USBHT)",
   label: "Barnhart (USBHT)"
  },
  {
   value: "Barnsdall (USUVB)",
   label: "Barnsdall (USUVB)"
  },
  {
   value: "Barrington (USBRN)",
   label: "Barrington (USBRN)"
  },
  {
   value: "Auburn (USAUI)",
   label: "Auburn (USAUI)"
  },
  {
   value: "Auburn (USAUO)",
   label: "Auburn (USAUO)"
  },
  {
   value: "Auburn (USAUJ)",
   label: "Auburn (USAUJ)"
  },
  {
   value: "Auburn Heights (USAUH)",
   label: "Auburn Heights (USAUH)"
  },
  {
   value: "Auburn-Lewiston (USLEW)",
   label: "Auburn-Lewiston (USLEW)"
  },
  {
   value: "Auburndale (USAUD)",
   label: "Auburndale (USAUD)"
  },
  {
   value: "Audubon (USAAQ)",
   label: "Audubon (USAAQ)"
  },
  {
   value: "Augusta (USAUT)",
   label: "Augusta (USAUT)"
  },
  {
   value: "Augusta (USAGS)",
   label: "Augusta (USAGS)"
  },
  {
   value: "Augusta (USAUG)",
   label: "Augusta (USAUG)"
  },
  {
   value: "Aulander (USAUY)",
   label: "Aulander (USAUY)"
  },
  {
   value: "Aurora (USAAN)",
   label: "Aurora (USAAN)"
  },
  {
   value: "Aurora (USAUF)",
   label: "Aurora (USAUF)"
  },
  {
   value: "Aurora (USAUX)",
   label: "Aurora (USAUX)"
  },
  {
   value: "Aurora (USAUQ)",
   label: "Aurora (USAUQ)"
  },
  {
   value: "Aurora (USAUZ)",
   label: "Aurora (USAUZ)"
  },
  {
   value: "Aurora (USAUC)",
   label: "Aurora (USAUC)"
  },
  {
   value: "Aurora (USAUR)",
   label: "Aurora (USAUR)"
  },
  {
   value: "Aurora (USAUU)",
   label: "Aurora (USAUU)"
  },
  {
   value: "Austell (USAUL)",
   label: "Austell (USAUL)"
  },
  {
   value: "Austin (USASQ)",
   label: "Austin (USASQ)"
  },
  {
   value: "Austin (USAUS)",
   label: "Austin (USAUS)"
  },
  {
   value: "Austin (USAUM)",
   label: "Austin (USAUM)"
  },
  {
   value: "Austin (USXBJ)",
   label: "Austin (USXBJ)"
  },
  {
   value: "Austintown (USAUV)",
   label: "Austintown (USAUV)"
  },
  {
   value: "Avant (USAVA)",
   label: "Avant (USAVA)"
  },
  {
   value: "Avard (USXBK)",
   label: "Avard (USXBK)"
  },
  {
   value: "Avenel (USAVE)",
   label: "Avenel (USAVE)"
  },
  {
   value: "Avery (USAVT)",
   label: "Avery (USAVT)"
  },
  {
   value: "Avery Island (USAVI)",
   label: "Avery Island (USAVI)"
  },
  {
   value: "Avoca (USAOC)",
   label: "Avoca (USAOC)"
  },
  {
   value: "Avon (USAVQ)",
   label: "Avon (USAVQ)"
  },
  {
   value: "Avon (USAVV)",
   label: "Avon (USAVV)"
  },
  {
   value: "Avon (USAVN)",
   label: "Avon (USAVN)"
  },
  {
   value: "Avon (USAVZ)",
   label: "Avon (USAVZ)"
  },
  {
   value: "Avon (USAVY)",
   label: "Avon (USAVY)"
  },
  {
   value: "Avon Lake (USAVC)",
   label: "Avon Lake (USAVC)"
  },
  {
   value: "Avon Lake (USAVK)",
   label: "Avon Lake (USAVK)"
  },
  {
   value: "Avon Park (USAVO)",
   label: "Avon Park (USAVO)"
  },
  {
   value: "Avondale (USAVD)",
   label: "Avondale (USAVD)"
  },
  {
   value: "Avonmore (USAVM)",
   label: "Avonmore (USAVM)"
  },
  {
   value: "Ayer (USAER)",
   label: "Ayer (USAER)"
  },
  {
   value: "Ayersville (USAYR)",
   label: "Ayersville (USAYR)"
  },
  {
   value: "Ashland (USAXM)",
   label: "Ashland (USAXM)"
  },
  {
   value: "Ashland (USALY)",
   label: "Ashland (USALY)"
  },
  {
   value: "Ashland (USASD)",
   label: "Ashland (USASD)"
  },
  {
   value: "Ashland (USASK)",
   label: "Ashland (USASK)"
  },
  {
   value: "Ashland City (USXBN)",
   label: "Ashland City (USXBN)"
  },
  {
   value: "Ashtabula (USASF)",
   label: "Ashtabula (USASF)"
  },
  {
   value: "Ashton (USASV)",
   label: "Ashton (USASV)"
  },
  {
   value: "Ashton (USAYA)",
   label: "Ashton (USAYA)"
  },
  {
   value: "Ashville (USASO)",
   label: "Ashville (USASO)"
  },
  {
   value: "Aspers (USUBR)",
   label: "Aspers (USUBR)"
  },
  {
   value: "Assonet (USASJ)",
   label: "Assonet (USASJ)"
  },
  {
   value: "Assumption (USAMP)",
   label: "Assumption (USAMP)"
  },
  {
   value: "Aston (USXBF)",
   label: "Aston (USXBF)"
  },
  {
   value: "Astoria (USAST)",
   label: "Astoria (USAST)"
  },
  {
   value: "Astoria (USASA)",
   label: "Astoria (USASA)"
  },
  {
   value: "Atchison (USATQ)",
   label: "Atchison (USATQ)"
  },
  {
   value: "Atglen (USATE)",
   label: "Atglen (USATE)"
  },
  {
   value: "Athens (USATA)",
   label: "Athens (USATA)"
  },
  {
   value: "Athens (USAHN)",
   label: "Athens (USAHN)"
  },
  {
   value: "Athens (USATO)",
   label: "Athens (USATO)"
  },
  {
   value: "Athens (USATN)",
   label: "Athens (USATN)"
  },
  {
   value: "Athens (USMMI)",
   label: "Athens (USMMI)"
  },
  {
   value: "Athens (USAWX)",
   label: "Athens (USAWX)"
  },
  {
   value: "Atherton (USATC)",
   label: "Atherton (USATC)"
  },
  {
   value: "Athol (USATD)",
   label: "Athol (USATD)"
  },
  {
   value: "Athol (USAHO)",
   label: "Athol (USAHO)"
  },
  {
   value: "Atkins (USATF)",
   label: "Atkins (USATF)"
  },
  {
   value: "Atkinson (USAKS)",
   label: "Atkinson (USAKS)"
  },
  {
   value: "Atlanta (USATL)",
   label: "Atlanta (USATL)"
  },
  {
   value: "Atlantic City (USAIY)",
   label: "Atlantic City (USAIY)"
  },
  {
   value: "Atlas Point (USATP)",
   label: "Atlas Point (USATP)"
  },
  {
   value: "Atreco (USATR)",
   label: "Atreco (USATR)"
  },
  {
   value: "Attalla (USAAA)",
   label: "Attalla (USAAA)"
  },
  {
   value: "Attapulgus (USAPS)",
   label: "Attapulgus (USAPS)"
  },
  {
   value: "Attleboro (USAOM)",
   label: "Attleboro (USAOM)"
  },
  {
   value: "Atwater (USATZ)",
   label: "Atwater (USATZ)"
  },
  {
   value: "Atwood (USATG)",
   label: "Atwood (USATG)"
  },
  {
   value: "Atwood (USAWD)",
   label: "Atwood (USAWD)"
  },
  {
   value: "Au Gres (USXBI)",
   label: "Au Gres (USXBI)"
  },
  {
   value: "Auburn (USABM)",
   label: "Auburn (USABM)"
  },
  {
   value: "Auburn (USABU)",
   label: "Auburn (USABU)"
  },
  {
   value: "Auburn (USAUB)",
   label: "Auburn (USAUB)"
  },
  {
   value: "Archbald (USAHB)",
   label: "Archbald (USAHB)"
  },
  {
   value: "Archbold (USARO)",
   label: "Archbold (USARO)"
  },
  {
   value: "Archdale (USXAZ)",
   label: "Archdale (USXAZ)"
  },
  {
   value: "Archibald (USARQ)",
   label: "Archibald (USARQ)"
  },
  {
   value: "Arco Ak (USAAK)",
   label: "Arco Ak (USAAK)"
  },
  {
   value: "Arcola (USAKV)",
   label: "Arcola (USAKV)"
  },
  {
   value: "Arcola (USXAY)",
   label: "Arcola (USXAY)"
  },
  {
   value: "Arden (USAYY)",
   label: "Arden (USAYY)"
  },
  {
   value: "Arden Hills (USARH)",
   label: "Arden Hills (USARH)"
  },
  {
   value: "Ardmore (USADM)",
   label: "Ardmore (USADM)"
  },
  {
   value: "Ardsley (USADY)",
   label: "Ardsley (USADY)"
  },
  {
   value: "Arenzville (USARS)",
   label: "Arenzville (USARS)"
  },
  {
   value: "Argo (USXBB)",
   label: "Argo (USXBB)"
  },
  {
   value: "Arkansas City (USARK)",
   label: "Arkansas City (USARK)"
  },
  {
   value: "Arleta (USARR)",
   label: "Arleta (USARR)"
  },
  {
   value: "Arley (USARL)",
   label: "Arley (USARL)"
  },
  {
   value: "Arlington (USARD)",
   label: "Arlington (USARD)"
  },
  {
   value: "Arlington (USARE)",
   label: "Arlington (USARE)"
  },
  {
   value: "Arlington (USARF)",
   label: "Arlington (USARF)"
  },
  {
   value: "Arlington (USARJ)",
   label: "Arlington (USARJ)"
  },
  {
   value: "Arlington (USARP)",
   label: "Arlington (USARP)"
  },
  {
   value: "Arlington (USXBC)",
   label: "Arlington (USXBC)"
  },
  {
   value: "Arlington (USAZZ)",
   label: "Arlington (USAZZ)"
  },
  {
   value: "Arlington (USXBM)",
   label: "Arlington (USXBM)"
  },
  {
   value: "Arlington Heights (USJLH)",
   label: "Arlington Heights (USJLH)"
  },
  {
   value: "Armonk (USAXC)",
   label: "Armonk (USAXC)"
  },
  {
   value: "Armorel (USAXE)",
   label: "Armorel (USAXE)"
  },
  {
   value: "Armuchee (USARM)",
   label: "Armuchee (USARM)"
  },
  {
   value: "Arnold (USAXF)",
   label: "Arnold (USAXF)"
  },
  {
   value: "Artesia (USATM)",
   label: "Artesia (USATM)"
  },
  {
   value: "Artesia (USATS)",
   label: "Artesia (USATS)"
  },
  {
   value: "Arthur (USAXH)",
   label: "Arthur (USAXH)"
  },
  {
   value: "Arvin (USAXI)",
   label: "Arvin (USAXI)"
  },
  {
   value: "Ashburn (USABN)",
   label: "Ashburn (USABN)"
  },
  {
   value: "Ashdown (USADN)",
   label: "Ashdown (USADN)"
  },
  {
   value: "Asheboro (USASR)",
   label: "Asheboro (USASR)"
  },
  {
   value: "Asheville-Hendersonville (USAVL)",
   label: "Asheville-Hendersonville (USAVL)"
  },
  {
   value: "Ashland (USXBH)",
   label: "Ashland (USXBH)"
  },
  {
   value: "Ashland (USALD)",
   label: "Ashland (USALD)"
  },
  {
   value: "Ashland (USASX)",
   label: "Ashland (USASX)"
  },
  {
   value: "Ashland (USAYQ)",
   label: "Ashland (USAYQ)"
  },
  {
   value: "Andersonville (USUBK)",
   label: "Andersonville (USUBK)"
  },
  {
   value: "Andover (USANR)",
   label: "Andover (USANR)"
  },
  {
   value: "Andrade (USANU)",
   label: "Andrade (USANU)"
  },
  {
   value: "Andrews (USADR)",
   label: "Andrews (USADR)"
  },
  {
   value: "Andrews (USUBO)",
   label: "Andrews (USUBO)"
  },
  {
   value: "Androscoggin (USAGG)",
   label: "Androscoggin (USAGG)"
  },
  {
   value: "Angier (USANG)",
   label: "Angier (USANG)"
  },
  {
   value: "Angola (USANQ)",
   label: "Angola (USANQ)"
  },
  {
   value: "Ankeny (USAKE)",
   label: "Ankeny (USAKE)"
  },
  {
   value: "Anmoor (USANM)",
   label: "Anmoor (USANM)"
  },
  {
   value: "Ann Arbor (USARB)",
   label: "Ann Arbor (USARB)"
  },
  {
   value: "Annapolis (USANP)",
   label: "Annapolis (USANP)"
  },
  {
   value: "Anniston (USANB)",
   label: "Anniston (USANB)"
  },
  {
   value: "Annville (USAIL)",
   label: "Annville (USAIL)"
  },
  {
   value: "Anoka (USANK)",
   label: "Anoka (USANK)"
  },
  {
   value: "Ansonia (USANS)",
   label: "Ansonia (USANS)"
  },
  {
   value: "Anthony (USUBM)",
   label: "Anthony (USUBM)"
  },
  {
   value: "Antigo (USUBN)",
   label: "Antigo (USUBN)"
  },
  {
   value: "Antioch (USANZ)",
   label: "Antioch (USANZ)"
  },
  {
   value: "Antler (USANT)",
   label: "Antler (USANT)"
  },
  {
   value: "Antonia (USANX)",
   label: "Antonia (USANX)"
  },
  {
   value: "Apache Junction (USAPJ)",
   label: "Apache Junction (USAPJ)"
  },
  {
   value: "Apalachicola (USAAF)",
   label: "Apalachicola (USAAF)"
  },
  {
   value: "Apex (USAPX)",
   label: "Apex (USAPX)"
  },
  {
   value: "Apharetta (USAPR)",
   label: "Apharetta (USAPR)"
  },
  {
   value: "Apopka (USAOP)",
   label: "Apopka (USAOP)"
  },
  {
   value: "Appalachia (USXAV)",
   label: "Appalachia (USXAV)"
  },
  {
   value: "Applause Woodland Hills (USAPW)",
   label: "Applause Woodland Hills (USAPW)"
  },
  {
   value: "Apple Grove (USXAU)",
   label: "Apple Grove (USXAU)"
  },
  {
   value: "Apple Valley (USAPV)",
   label: "Apple Valley (USAPV)"
  },
  {
   value: "Appleton (USAPP)",
   label: "Appleton (USAPP)"
  },
  {
   value: "Appleton (USATW)",
   label: "Appleton (USATW)"
  },
  {
   value: "Appomattox (USXAX)",
   label: "Appomattox (USXAX)"
  },
  {
   value: "Aptos (USAPO)",
   label: "Aptos (USAPO)"
  },
  {
   value: "Arab (USRAB)",
   label: "Arab (USRAB)"
  },
  {
   value: "Arabi (USAQX)",
   label: "Arabi (USAQX)"
  },
  {
   value: "Arbuckle (USARU)",
   label: "Arbuckle (USARU)"
  },
  {
   value: "Arcadia (USARI)",
   label: "Arcadia (USARI)"
  },
  {
   value: "Arcadia (USARZ)",
   label: "Arcadia (USARZ)"
  },
  {
   value: "Arcadia (USJAR)",
   label: "Arcadia (USJAR)"
  },
  {
   value: "Arcadia (USADI)",
   label: "Arcadia (USADI)"
  },
  {
   value: "Altadena (USAZA)",
   label: "Altadena (USAZA)"
  },
  {
   value: "Altaloma (USAZM)",
   label: "Altaloma (USAZM)"
  },
  {
   value: "Altamahaw (USUBD)",
   label: "Altamahaw (USUBD)"
  },
  {
   value: "Altamont (USAZN)",
   label: "Altamont (USAZN)"
  },
  {
   value: "Altamonte Springs (USASP)",
   label: "Altamonte Springs (USASP)"
  },
  {
   value: "Altavista (USATV)",
   label: "Altavista (USATV)"
  },
  {
   value: "Alton (USALN)",
   label: "Alton (USALN)"
  },
  {
   value: "Altoona (USAZQ)",
   label: "Altoona (USAZQ)"
  },
  {
   value: "Altoona (USAZP)",
   label: "Altoona (USAZP)"
  },
  {
   value: "Altus (USLTS)",
   label: "Altus (USLTS)"
  },
  {
   value: "Altus (USAZX)",
   label: "Altus (USAZX)"
  },
  {
   value: "Alum Rock (USAZT)",
   label: "Alum Rock (USAZT)"
  },
  {
   value: "Alvarado (USAZB)",
   label: "Alvarado (USAZB)"
  },
  {
   value: "Alvin (USAZC)",
   label: "Alvin (USAZC)"
  },
  {
   value: "Alviso (USAZD)",
   label: "Alviso (USAZD)"
  },
  {
   value: "Alyeska (USAQY)",
   label: "Alyeska (USAQY)"
  },
  {
   value: "Amana (USUBG)",
   label: "Amana (USUBG)"
  },
  {
   value: "Amarillo (USAMA)",
   label: "Amarillo (USAMA)"
  },
  {
   value: "Ambler (USABL)",
   label: "Ambler (USABL)"
  },
  {
   value: "Amboy (USAMY)",
   label: "Amboy (USAMY)"
  },
  {
   value: "Ambridge (USUBF)",
   label: "Ambridge (USUBF)"
  },
  {
   value: "Ambrose (USAMB)",
   label: "Ambrose (USAMB)"
  },
  {
   value: "Amelia (USAML)",
   label: "Amelia (USAML)"
  },
  {
   value: "Americus (USAMU)",
   label: "Americus (USAMU)"
  },
  {
   value: "Amery (USAHH)",
   label: "Amery (USAHH)"
  },
  {
   value: "Ames (USAMW)",
   label: "Ames (USAMW)"
  },
  {
   value: "Amherst (USAMH)",
   label: "Amherst (USAMH)"
  },
  {
   value: "Amherst (USAHR)",
   label: "Amherst (USAHR)"
  },
  {
   value: "Amherst (USUBI)",
   label: "Amherst (USUBI)"
  },
  {
   value: "Amite (USUBH)",
   label: "Amite (USUBH)"
  },
  {
   value: "Amityville (USAYZ)",
   label: "Amityville (USAYZ)"
  },
  {
   value: "Amory (USARY)",
   label: "Amory (USARY)"
  },
  {
   value: "Ampthill (USXBD)",
   label: "Ampthill (USXBD)"
  },
  {
   value: "Amsterdam (USAMS)",
   label: "Amsterdam (USAMS)"
  },
  {
   value: "Anacortes (USOTS)",
   label: "Anacortes (USOTS)"
  },
  {
   value: "Anaheim (USANA)",
   label: "Anaheim (USANA)"
  },
  {
   value: "Anchor Point (USACP)",
   label: "Anchor Point (USACP)"
  },
  {
   value: "Anchorage (USANC)",
   label: "Anchorage (USANC)"
  },
  {
   value: "Andalusia (USADL)",
   label: "Andalusia (USADL)"
  },
  {
   value: "Anderson (USAND)",
   label: "Anderson (USAND)"
  },
  {
   value: "Anderson (USAID)",
   label: "Anderson (USAID)"
  },
  {
   value: "Anderson (USANE)",
   label: "Anderson (USANE)"
  },
  {
   value: "Alburtis (USALU)",
   label: "Alburtis (USALU)"
  },
  {
   value: "Alcan (USALC)",
   label: "Alcan (USALC)"
  },
  {
   value: "Alcoa (USACO)",
   label: "Alcoa (USACO)"
  },
  {
   value: "Alexander City (USALX)",
   label: "Alexander City (USALX)"
  },
  {
   value: "Alexandria (USAXR)",
   label: "Alexandria (USAXR)"
  },
  {
   value: "Alexandria (USAXN)",
   label: "Alexandria (USAXN)"
  },
  {
   value: "Alexandria (USAXA)",
   label: "Alexandria (USAXA)"
  },
  {
   value: "Alexandria (USESF)",
   label: "Alexandria (USESF)"
  },
  {
   value: "Alexandria (USAXD)",
   label: "Alexandria (USAXD)"
  },
  {
   value: "Alexandria Bay (USAXB)",
   label: "Alexandria Bay (USAXB)"
  },
  {
   value: "Algiers (USUAY)",
   label: "Algiers (USUAY)"
  },
  {
   value: "Algoma (USAMZ)",
   label: "Algoma (USAMZ)"
  },
  {
   value: "Algona (USUBJ)",
   label: "Algona (USUBJ)"
  },
  {
   value: "Algonac (USALG)",
   label: "Algonac (USALG)"
  },
  {
   value: "Alhambra (USALH)",
   label: "Alhambra (USALH)"
  },
  {
   value: "Aliceville (USAIV)",
   label: "Aliceville (USAIV)"
  },
  {
   value: "Alicia (USACA)",
   label: "Alicia (USACA)"
  },
  {
   value: "Aliquippa (USAQP)",
   label: "Aliquippa (USAQP)"
  },
  {
   value: "\"Aliso Viejo (USAVJ)",
   label: "\"Aliso Viejo (USAVJ)"
  },
  {
   value: "Alitak (USALZ)",
   label: "Alitak (USALZ)"
  },
  {
   value: "Allegan (USALL)",
   label: "Allegan (USALL)"
  },
  {
   value: "Allegheney (USUBP)",
   label: "Allegheney (USUBP)"
  },
  {
   value: "Allen Park (USAPK)",
   label: "Allen Park (USAPK)"
  },
  {
   value: "Allendale (USUAZ)",
   label: "Allendale (USUAZ)"
  },
  {
   value: "Allentown (USAEW)",
   label: "Allentown (USAEW)"
  },
  {
   value: "Allentown-Bethlehem-Easton Apt (USABE)",
   label: "Allentown-Bethlehem-Easton Apt (USABE)"
  },
  {
   value: "Allerton (USALT)",
   label: "Allerton (USALT)"
  },
  {
   value: "Alliance (USAIA)",
   label: "Alliance (USAIA)"
  },
  {
   value: "Alliance (USAIH)",
   label: "Alliance (USAIH)"
  },
  {
   value: "Allison Park (USALK)",
   label: "Allison Park (USALK)"
  },
  {
   value: "Alloy (USAOY)",
   label: "Alloy (USAOY)"
  },
  {
   value: "Allston (USXBE)",
   label: "Allston (USXBE)"
  },
  {
   value: "Alma (USAMQ)",
   label: "Alma (USAMQ)"
  },
  {
   value: "Alma (USAMN)",
   label: "Alma (USAMN)"
  },
  {
   value: "Aloha (USAHA)",
   label: "Aloha (USAHA)"
  },
  {
   value: "Alpena (USAPN)",
   label: "Alpena (USAPN)"
  },
  {
   value: "Alpharetta (USAAI)",
   label: "Alpharetta (USAAI)"
  },
  {
   value: "Alpine (USAPL)",
   label: "Alpine (USAPL)"
  },
  {
   value: "Alsen (USAEN)",
   label: "Alsen (USAEN)"
  },
  {
   value: "Alsip (USUBC)",
   label: "Alsip (USUBC)"
  },
  {
   value: "Alta (USXBO)",
   label: "Alta (USXBO)"
  },
  {
   value: "Adams (USUAN)",
   label: "Adams (USUAN)"
  },
  {
   value: "Adams (USUAT)",
   label: "Adams (USUAT)"
  },
  {
   value: "Adamsville (USUAM)",
   label: "Adamsville (USUAM)"
  },
  {
   value: "Addis (USADD)",
   label: "Addis (USADD)"
  },
  {
   value: "Addison (USADS)",
   label: "Addison (USADS)"
  },
  {
   value: "Addison (USUAP)",
   label: "Addison (USUAP)"
  },
  {
   value: "Addison (USADX)",
   label: "Addison (USADX)"
  },
  {
   value: "Addyston (USUAS)",
   label: "Addyston (USUAS)"
  },
  {
   value: "Adel (USADE)",
   label: "Adel (USADE)"
  },
  {
   value: "Adger (USAGE)",
   label: "Adger (USAGE)"
  },
  {
   value: "Adidas (USADU)",
   label: "Adidas (USADU)"
  },
  {
   value: "Adrian (USADG)",
   label: "Adrian (USADG)"
  },
  {
   value: "Adrian (USUAO)",
   label: "Adrian (USUAO)"
  },
  {
   value: "Advance (USUAR)",
   label: "Advance (USUAR)"
  },
  {
   value: "Afognak (USAFK)",
   label: "Afognak (USAFK)"
  },
  {
   value: "Afton (USAFO)",
   label: "Afton (USAFO)"
  },
  {
   value: "Afton (USAFT)",
   label: "Afton (USAFT)"
  },
  {
   value: "Afton (USUAV)",
   label: "Afton (USUAV)"
  },
  {
   value: "Agawam (USXBL)",
   label: "Agawam (USXBL)"
  },
  {
   value: "Agoura (USUAX)",
   label: "Agoura (USUAX)"
  },
  {
   value: "Agro (USAGR)",
   label: "Agro (USAGR)"
  },
  {
   value: "Aiea (Oahu) (USAIE)",
   label: "Aiea (Oahu) (USAIE)"
  },
  {
   value: "Aiken (USAIK)",
   label: "Aiken (USAIK)"
  },
  {
   value: "Akron (USAKR)",
   label: "Akron (USAKR)"
  },
  {
   value: "Akron (USARN)",
   label: "Akron (USARN)"
  },
  {
   value: "Akutan (USAKU)",
   label: "Akutan (USAKU)"
  },
  {
   value: "Alamance (USAMC)",
   label: "Alamance (USAMC)"
  },
  {
   value: "Alameda (USNGZ)",
   label: "Alameda (USNGZ)"
  },
  {
   value: "Alamo (USUBB)",
   label: "Alamo (USUBB)"
  },
  {
   value: "Alamo (USAMT)",
   label: "Alamo (USAMT)"
  },
  {
   value: "Alamo (USAMO)",
   label: "Alamo (USAMO)"
  },
  {
   value: "Alamogordo (USALM)",
   label: "Alamogordo (USALM)"
  },
  {
   value: "Albany (USALA)",
   label: "Albany (USALA)"
  },
  {
   value: "Albany (USABY)",
   label: "Albany (USABY)"
  },
  {
   value: "Albany (USALB)",
   label: "Albany (USALB)"
  },
  {
   value: "Albany (USUBA)",
   label: "Albany (USUBA)"
  },
  {
   value: "Albany (USUBE)",
   label: "Albany (USUBE)"
  },
  {
   value: "Albemarle (USUAD)",
   label: "Albemarle (USUAD)"
  },
  {
   value: "Albert Lea (USAEL)",
   label: "Albert Lea (USAEL)"
  },
  {
   value: "Albertville (USABV)",
   label: "Albertville (USABV)"
  },
  {
   value: "Albertville (USALV)",
   label: "Albertville (USALV)"
  },
  {
   value: "Albion (USAON)",
   label: "Albion (USAON)"
  },
  {
   value: "Albuquerque (USABQ)",
   label: "Albuquerque (USABQ)"
  },
  {
   value: "Jinja (UGJIN)",
   label: "Jinja (UGJIN)"
  },
  {
   value: "Kabale (UGKAB)",
   label: "Kabale (UGKAB)"
  },
  {
   value: "Kampala (UGKLA)",
   label: "Kampala (UGKLA)"
  },
  {
   value: "Kasese (UGKSE)",
   label: "Kasese (UGKSE)"
  },
  {
   value: "Lira (UGLIR)",
   label: "Lira (UGLIR)"
  },
  {
   value: "Masaka (UGMSK)",
   label: "Masaka (UGMSK)"
  },
  {
   value: "Masindi (UGKCU)",
   label: "Masindi (UGKCU)"
  },
  {
   value: "Mbale (UGMBA)",
   label: "Mbale (UGMBA)"
  },
  {
   value: "Mbarara (UGMBQ)",
   label: "Mbarara (UGMBQ)"
  },
  {
   value: "Mubende (UGMUB)",
   label: "Mubende (UGMUB)"
  },
  {
   value: "Soroti (UGSRT)",
   label: "Soroti (UGSRT)"
  },
  {
   value: "Tororo (UGTRY)",
   label: "Tororo (UGTRY)"
  },
  {
   value: "Baker Island (UMBAK)",
   label: "Baker Island (UMBAK)"
  },
  {
   value: "Howland Island (UMHOW)",
   label: "Howland Island (UMHOW)"
  },
  {
   value: "Jarvis Island (UMJAR)",
   label: "Jarvis Island (UMJAR)"
  },
  {
   value: "Johnston Atoll (UMJON)",
   label: "Johnston Atoll (UMJON)"
  },
  {
   value: "Kingman Reef (UMKIN)",
   label: "Kingman Reef (UMKIN)"
  },
  {
   value: "Midway Islands (UMMDY)",
   label: "Midway Islands (UMMDY)"
  },
  {
   value: "Navassa Island (UMNAV)",
   label: "Navassa Island (UMNAV)"
  },
  {
   value: "Palmyra Atoll (UMPAL)",
   label: "Palmyra Atoll (UMPAL)"
  },
  {
   value: "Wake Island (UMAWK)",
   label: "Wake Island (UMAWK)"
  },
  {
   value: "Abbeville (USABB)",
   label: "Abbeville (USABB)"
  },
  {
   value: "Abbeville (USUAB)",
   label: "Abbeville (USUAB)"
  },
  {
   value: "Abbeville (USABF)",
   label: "Abbeville (USABF)"
  },
  {
   value: "Abbotsford (USABD)",
   label: "Abbotsford (USABD)"
  },
  {
   value: "Aberdeen (USAPG)",
   label: "Aberdeen (USAPG)"
  },
  {
   value: "Aberdeen (USABR)",
   label: "Aberdeen (USABR)"
  },
  {
   value: "Aberdeen (USUAE)",
   label: "Aberdeen (USUAE)"
  },
  {
   value: "Aberdeen (USXBA)",
   label: "Aberdeen (USXBA)"
  },
  {
   value: "Abernathy (USUAF)",
   label: "Abernathy (USUAF)"
  },
  {
   value: "Abilene (USABZ)",
   label: "Abilene (USABZ)"
  },
  {
   value: "Abilene (USABI)",
   label: "Abilene (USABI)"
  },
  {
   value: "Abingdon (USABG)",
   label: "Abingdon (USABG)"
  },
  {
   value: "Ackerman (USUAG)",
   label: "Ackerman (USUAG)"
  },
  {
   value: "Ackley (USAKY)",
   label: "Ackley (USAKY)"
  },
  {
   value: "Acton (USUAH)",
   label: "Acton (USUAH)"
  },
  {
   value: "Acworth (USAWR)",
   label: "Acworth (USAWR)"
  },
  {
   value: "Ada (USADT)",
   label: "Ada (USADT)"
  },
  {
   value: "Ada (USADZ)",
   label: "Ada (USADZ)"
  },
  {
   value: "Adairsville (USADV)",
   label: "Adairsville (USADV)"
  },
  {
   value: "Adak Island\/Adak Apt (USADK)",
   label: "Adak Island\/Adak Apt (USADK)"
  },
  {
   value: "Wesha (TZWHA)",
   label: "Wesha (TZWHA)"
  },
  {
   value: "Zanzibar (TZZNZ)",
   label: "Zanzibar (TZZNZ)"
  },
  {
   value: "Belgorod-Dnestrovskiy (UABGD)",
   label: "Belgorod-Dnestrovskiy (UABGD)"
  },
  {
   value: "Berdyansk (UAERD)",
   label: "Berdyansk (UAERD)"
  },
  {
   value: "Borispol Apt\/Kiev (UAKBP)",
   label: "Borispol Apt\/Kiev (UAKBP)"
  },
  {
   value: "Chop (UACOP)",
   label: "Chop (UACOP)"
  },
  {
   value: "Chop-Chierna (UACCI)",
   label: "Chop-Chierna (UACCI)"
  },
  {
   value: "Chop-Zakhon (UACZA)",
   label: "Chop-Zakhon (UACZA)"
  },
  {
   value: "Donetsk (UADOK)",
   label: "Donetsk (UADOK)"
  },
  {
   value: "Feodosiya (UAFEO)",
   label: "Feodosiya (UAFEO)"
  },
  {
   value: "Ilyichevsk (UAILK)",
   label: "Ilyichevsk (UAILK)"
  },
  {
   value: "Izmail (UAIZM)",
   label: "Izmail (UAIZM)"
  },
  {
   value: "Kerch (UAKEH)",
   label: "Kerch (UAKEH)"
  },
  {
   value: "Kharkov (UAHRK)",
   label: "Kharkov (UAHRK)"
  },
  {
   value: "Kherson (UAKHE)",
   label: "Kherson (UAKHE)"
  },
  {
   value: "Kiev (UAIEV)",
   label: "Kiev (UAIEV)"
  },
  {
   value: "Kiliya (UAKIA)",
   label: "Kiliya (UAKIA)"
  },
  {
   value: "L'viv (UALVI)",
   label: "L'viv (UALVI)"
  },
  {
   value: "Lwow (UALWO)",
   label: "Lwow (UALWO)"
  },
  {
   value: "Mariupol (Ex Zhdanov) (UAMPW)",
   label: "Mariupol (Ex Zhdanov) (UAMPW)"
  },
  {
   value: "Mostiska (UAMKA)",
   label: "Mostiska (UAMKA)"
  },
  {
   value: "Nikolayev (UANIK)",
   label: "Nikolayev (UANIK)"
  },
  {
   value: "Odessa (UAODS)",
   label: "Odessa (UAODS)"
  },
  {
   value: "Prut (UAPRU)",
   label: "Prut (UAPRU)"
  },
  {
   value: "Rava Ruskaya (UARAR)",
   label: "Rava Ruskaya (UARAR)"
  },
  {
   value: "Reni (UARNI)",
   label: "Reni (UARNI)"
  },
  {
   value: "Sevastopol (UASVP)",
   label: "Sevastopol (UASVP)"
  },
  {
   value: "Shakhtersk (UASHA)",
   label: "Shakhtersk (UASHA)"
  },
  {
   value: "Simferopol (UASIP)",
   label: "Simferopol (UASIP)"
  },
  {
   value: "Uglegorsk (UAUGL)",
   label: "Uglegorsk (UAUGL)"
  },
  {
   value: "Ust Donetskiy (UAUSD)",
   label: "Ust Donetskiy (UAUSD)"
  },
  {
   value: "Ust Dunaysk (UAUDY)",
   label: "Ust Dunaysk (UAUDY)"
  },
  {
   value: "Uzhgorod (UAUZH)",
   label: "Uzhgorod (UAUZH)"
  },
  {
   value: "Vladimir-Volynskiy (UAVLV)",
   label: "Vladimir-Volynskiy (UAVLV)"
  },
  {
   value: "Yalta (UAYAL)",
   label: "Yalta (UAYAL)"
  },
  {
   value: "Yuzhnyy (UAYUZ)",
   label: "Yuzhnyy (UAYUZ)"
  },
  {
   value: "Zaporozhye (UAOZH)",
   label: "Zaporozhye (UAOZH)"
  },
  {
   value: "Bugembe (UGBUG)",
   label: "Bugembe (UGBUG)"
  },
  {
   value: "Busia (UGBUS)",
   label: "Busia (UGBUS)"
  },
  {
   value: "Entebbe (UGEBB)",
   label: "Entebbe (UGEBB)"
  },
  {
   value: "Fort Portal (UGFPO)",
   label: "Fort Portal (UGFPO)"
  },
  {
   value: "Hualien (TWHUN)",
   label: "Hualien (TWHUN)"
  },
  {
   value: "Kaohsiung (TWKHH)",
   label: "Kaohsiung (TWKHH)"
  },
  {
   value: "Keelung (Chilung) (TWKEL)",
   label: "Keelung (Chilung) (TWKEL)"
  },
  {
   value: "Kepz (TWKEZ)",
   label: "Kepz (TWKEZ)"
  },
  {
   value: "Makung (TWMZG)",
   label: "Makung (TWMZG)"
  },
  {
   value: "\"Nepz (TWNEZ)",
   label: "\"Nepz (TWNEZ)"
  },
  {
   value: "Suao (TWSUO)",
   label: "Suao (TWSUO)"
  },
  {
   value: "Taichung (TWTXG)",
   label: "Taichung (TWTXG)"
  },
  {
   value: "Tainan (TWTNN)",
   label: "Tainan (TWTNN)"
  },
  {
   value: "Taipei (TWTPE)",
   label: "Taipei (TWTPE)"
  },
  {
   value: "Taitung (TWTTT)",
   label: "Taitung (TWTTT)"
  },
  {
   value: "Taoyuan (TWTYN)",
   label: "Taoyuan (TWTYN)"
  },
  {
   value: "Tung Hai (TWTGH)",
   label: "Tung Hai (TWTGH)"
  },
  {
   value: "Arusha (TZARK)",
   label: "Arusha (TZARK)"
  },
  {
   value: "Bukoba (TZBKZ)",
   label: "Bukoba (TZBKZ)"
  },
  {
   value: "Dar Es Salaam (TZDAR)",
   label: "Dar Es Salaam (TZDAR)"
  },
  {
   value: "Dodoma (TZDOD)",
   label: "Dodoma (TZDOD)"
  },
  {
   value: "Geita (TZGIT)",
   label: "Geita (TZGIT)"
  },
  {
   value: "Kigoma (TZTKQ)",
   label: "Kigoma (TZTKQ)"
  },
  {
   value: "Kilimanjaro (TZJRO)",
   label: "Kilimanjaro (TZJRO)"
  },
  {
   value: "Kilwa (TZKIY)",
   label: "Kilwa (TZKIY)"
  },
  {
   value: "Kilwa Kivinje (TZKIK)",
   label: "Kilwa Kivinje (TZKIK)"
  },
  {
   value: "Kilwa Masoko (TZKIM)",
   label: "Kilwa Masoko (TZKIM)"
  },
  {
   value: "Lindi (TZLDI)",
   label: "Lindi (TZLDI)"
  },
  {
   value: "Mafia (TZMFA)",
   label: "Mafia (TZMFA)"
  },
  {
   value: "Michiuja (TZMIC)",
   label: "Michiuja (TZMIC)"
  },
  {
   value: "Mikindani (TZMIK)",
   label: "Mikindani (TZMIK)"
  },
  {
   value: "\"Mkokotoni (TZMKO)",
   label: "\"Mkokotoni (TZMKO)"
  },
  {
   value: "Mohoro (TZMOH)",
   label: "Mohoro (TZMOH)"
  },
  {
   value: "Mtsora (TZMTS)",
   label: "Mtsora (TZMTS)"
  },
  {
   value: "Mtwara (TZMYW)",
   label: "Mtwara (TZMYW)"
  },
  {
   value: "Musoma (TZMUZ)",
   label: "Musoma (TZMUZ)"
  },
  {
   value: "Mwanza (TZMWZ)",
   label: "Mwanza (TZMWZ)"
  },
  {
   value: "Nachingwea (TZNCH)",
   label: "Nachingwea (TZNCH)"
  },
  {
   value: "Pangani (TZPAN)",
   label: "Pangani (TZPAN)"
  },
  {
   value: "Pemba (TZPMA)",
   label: "Pemba (TZPMA)"
  },
  {
   value: "Rijiju (TZRIJ)",
   label: "Rijiju (TZRIJ)"
  },
  {
   value: "Samanga (TZSAM)",
   label: "Samanga (TZSAM)"
  },
  {
   value: "Songea (TZSGX)",
   label: "Songea (TZSGX)"
  },
  {
   value: "Tabora (TZTBO)",
   label: "Tabora (TZTBO)"
  },
  {
   value: "Tanga (TZTGT)",
   label: "Tanga (TZTGT)"
  },
  {
   value: "Tunduna (TZTUN)",
   label: "Tunduna (TZTUN)"
  },
  {
   value: "Urla (TRURL)",
   label: "Urla (TRURL)"
  },
  {
   value: "Usak (TRUSA)",
   label: "Usak (TRUSA)"
  },
  {
   value: "Usak apt (TRUSQ)",
   label: "Usak apt (TRUSQ)"
  },
  {
   value: "Uskudar (TRUSK)",
   label: "Uskudar (TRUSK)"
  },
  {
   value: "Uzunkopru (TRUZU)",
   label: "Uzunkopru (TRUZU)"
  },
  {
   value: "Van (TRVAN)",
   label: "Van (TRVAN)"
  },
  {
   value: "Vize (TRVIZ)",
   label: "Vize (TRVIZ)"
  },
  {
   value: "Yakacik (TRYAK)",
   label: "Yakacik (TRYAK)"
  },
  {
   value: "Yalova (TRYAL)",
   label: "Yalova (TRYAL)"
  },
  {
   value: "Yalvac (TRYLV)",
   label: "Yalvac (TRYLV)"
  },
  {
   value: "Yarimca (TRYAR)",
   label: "Yarimca (TRYAR)"
  },
  {
   value: "Yatagan (TRYTG)",
   label: "Yatagan (TRYTG)"
  },
  {
   value: "Yenibosna (TRYBS)",
   label: "Yenibosna (TRYBS)"
  },
  {
   value: "Yenice (TRYEN)",
   label: "Yenice (TRYEN)"
  },
  {
   value: "Yenipazar (TRYPZ)",
   label: "Yenipazar (TRYPZ)"
  },
  {
   value: "Yenipazar (TRYEZ)",
   label: "Yenipazar (TRYEZ)"
  },
  {
   value: "Yenisehir (TRYSR)",
   label: "Yenisehir (TRYSR)"
  },
  {
   value: "Yesilkoy (TRYES)",
   label: "Yesilkoy (TRYES)"
  },
  {
   value: "Yozgat (TRYOZ)",
   label: "Yozgat (TRYOZ)"
  },
  {
   value: "Yumurtalik Bay (TRYUM)",
   label: "Yumurtalik Bay (TRYUM)"
  },
  {
   value: "Zeytinburnu (TRZEY)",
   label: "Zeytinburnu (TRZEY)"
  },
  {
   value: "Zonguldak (TRZON)",
   label: "Zonguldak (TRZON)"
  },
  {
   value: "Chaguaramas (TTCHA)",
   label: "Chaguaramas (TTCHA)"
  },
  {
   value: "La Brea (Brighton) (TTLAB)",
   label: "La Brea (Brighton) (TTLAB)"
  },
  {
   value: "Piarco (TTPIA)",
   label: "Piarco (TTPIA)"
  },
  {
   value: "Plymouth (TTPLY)",
   label: "Plymouth (TTPLY)"
  },
  {
   value: "Point Fortin (TTPTF)",
   label: "Point Fortin (TTPTF)"
  },
  {
   value: "Point Galeota (TTPTG)",
   label: "Point Galeota (TTPTG)"
  },
  {
   value: "Point Lisas (TTPTS)",
   label: "Point Lisas (TTPTS)"
  },
  {
   value: "Pointe a Pierre (TTPTP)",
   label: "Pointe a Pierre (TTPTP)"
  },
  {
   value: "Port of Spain (TTPOS)",
   label: "Port of Spain (TTPOS)"
  },
  {
   value: "San Fernando (TTSFE)",
   label: "San Fernando (TTSFE)"
  },
  {
   value: "Scarborough\/Tobago (TTSCA)",
   label: "Scarborough\/Tobago (TTSCA)"
  },
  {
   value: "Tembladora (TTTEM)",
   label: "Tembladora (TTTEM)"
  },
  {
   value: "Tobago (TTTAB)",
   label: "Tobago (TTTAB)"
  },
  {
   value: "Tunapuna (TTTUN)",
   label: "Tunapuna (TTTUN)"
  },
  {
   value: "Funafuti (TVFUN)",
   label: "Funafuti (TVFUN)"
  },
  {
   value: "An Ping (TWAPG)",
   label: "An Ping (TWAPG)"
  },
  {
   value: "Chiayi (TWCYI)",
   label: "Chiayi (TWCYI)"
  },
  {
   value: "Chung-Li (TWCLI)",
   label: "Chung-Li (TWCLI)"
  },
  {
   value: "Sincan (TRSCN)",
   label: "Sincan (TRSCN)"
  },
  {
   value: "Sindirgi (TRSDG)",
   label: "Sindirgi (TRSDG)"
  },
  {
   value: "Sinop (TRSIC)",
   label: "Sinop (TRSIC)"
  },
  {
   value: "Sirinevler (TRSRN)",
   label: "Sirinevler (TRSRN)"
  },
  {
   value: "Sirkeci (TRSIR)",
   label: "Sirkeci (TRSIR)"
  },
  {
   value: "Sisli (TRSIS)",
   label: "Sisli (TRSIS)"
  },
  {
   value: "Sivas (TRVAS)",
   label: "Sivas (TRVAS)"
  },
  {
   value: "Sivasli (TRSVS)",
   label: "Sivasli (TRSVS)"
  },
  {
   value: "Sivrihisar (TRSVR)",
   label: "Sivrihisar (TRSVR)"
  },
  {
   value: "Sogut (TRSGT)",
   label: "Sogut (TRSGT)"
  },
  {
   value: "Soke (TRSKE)",
   label: "Soke (TRSKE)"
  },
  {
   value: "Soma (TRSMA)",
   label: "Soma (TRSMA)"
  },
  {
   value: "Suadiye (TRSUA)",
   label: "Suadiye (TRSUA)"
  },
  {
   value: "Sultandagi (TRSDI)",
   label: "Sultandagi (TRSDI)"
  },
  {
   value: "Sultanhisar (TRSHR)",
   label: "Sultanhisar (TRSHR)"
  },
  {
   value: "Surmene (TRSUR)",
   label: "Surmene (TRSUR)"
  },
  {
   value: "Susurluk (TRSSL)",
   label: "Susurluk (TRSSL)"
  },
  {
   value: "Sutluce (TRSUT)",
   label: "Sutluce (TRSUT)"
  },
  {
   value: "Tarabya (TRTBY)",
   label: "Tarabya (TRTBY)"
  },
  {
   value: "Tarsus (TRTAR)",
   label: "Tarsus (TRTAR)"
  },
  {
   value: "Tasdelen (TRTSD)",
   label: "Tasdelen (TRTSD)"
  },
  {
   value: "Tasucu (TRTAS)",
   label: "Tasucu (TRTAS)"
  },
  {
   value: "Tavas (TRTAV)",
   label: "Tavas (TRTAV)"
  },
  {
   value: "Tavsanli (TRTVS)",
   label: "Tavsanli (TRTVS)"
  },
  {
   value: "Tefenni (TRTFN)",
   label: "Tefenni (TRTFN)"
  },
  {
   value: "Tekirdag (TRTEK)",
   label: "Tekirdag (TRTEK)"
  },
  {
   value: "Tekirdag apt (TRTEQ)",
   label: "Tekirdag apt (TRTEQ)"
  },
  {
   value: "Tire (TRTRE)",
   label: "Tire (TRTRE)"
  },
  {
   value: "Tirebolu (TRTIR)",
   label: "Tirebolu (TRTIR)"
  },
  {
   value: "Tokat (TRTJK)",
   label: "Tokat (TRTJK)"
  },
  {
   value: "Topcular (TRTOC)",
   label: "Topcular (TRTOC)"
  },
  {
   value: "Topkapi (TRTOP)",
   label: "Topkapi (TRTOP)"
  },
  {
   value: "Torbali (TRTOR)",
   label: "Torbali (TRTOR)"
  },
  {
   value: "Trabzon (TRTZX)",
   label: "Trabzon (TRTZX)"
  },
  {
   value: "Tunceli (TRTUN)",
   label: "Tunceli (TRTUN)"
  },
  {
   value: "Turan (TRTUR)",
   label: "Turan (TRTUR)"
  },
  {
   value: "Turgutlu (TRTGL)",
   label: "Turgutlu (TRTGL)"
  },
  {
   value: "Tutunciftlik (TRTUT)",
   label: "Tutunciftlik (TRTUT)"
  },
  {
   value: "Tuzla (TRTUZ)",
   label: "Tuzla (TRTUZ)"
  },
  {
   value: "Ula (TRULA)",
   label: "Ula (TRULA)"
  },
  {
   value: "Ulubey (TRULU)",
   label: "Ulubey (TRULU)"
  },
  {
   value: "Umraniye (TRUMR)",
   label: "Umraniye (TRUMR)"
  },
  {
   value: "Unye (TRUNY)",
   label: "Unye (TRUNY)"
  },
  {
   value: "Payas (TRPAY)",
   label: "Payas (TRPAY)"
  },
  {
   value: "\"Pazarkule (TRPAZ)",
   label: "\"Pazarkule (TRPAZ)"
  },
  {
   value: "Pazaryeri (TRPYI)",
   label: "Pazaryeri (TRPYI)"
  },
  {
   value: "Pehlivankoy (TRPEH)",
   label: "Pehlivankoy (TRPEH)"
  },
  {
   value: "Pendik (TRPEN)",
   label: "Pendik (TRPEN)"
  },
  {
   value: "Pinarhisar (TRPIN)",
   label: "Pinarhisar (TRPIN)"
  },
  {
   value: "Polatli (TRPTL)",
   label: "Polatli (TRPTL)"
  },
  {
   value: "Rahmanlar (TRRAH)",
   label: "Rahmanlar (TRRAH)"
  },
  {
   value: "Raman (TRRAM)",
   label: "Raman (TRRAM)"
  },
  {
   value: "Rami (TRRAI)",
   label: "Rami (TRRAI)"
  },
  {
   value: "Resadiye (TRRES)",
   label: "Resadiye (TRRES)"
  },
  {
   value: "Rize (TRRIZ)",
   label: "Rize (TRRIZ)"
  },
  {
   value: "S.Karaagac (TRSKR)",
   label: "S.Karaagac (TRSKR)"
  },
  {
   value: "Salihli (TRSAL)",
   label: "Salihli (TRSAL)"
  },
  {
   value: "Samandira (TRSAM)",
   label: "Samandira (TRSAM)"
  },
  {
   value: "Samsun (TRSSX)",
   label: "Samsun (TRSSX)"
  },
  {
   value: "Sanliurfa (TRSFQ)",
   label: "Sanliurfa (TRSFQ)"
  },
  {
   value: "Sapanca (TRSCA)",
   label: "Sapanca (TRSCA)"
  },
  {
   value: "Saphane (TRSHN)",
   label: "Saphane (TRSHN)"
  },
  {
   value: "Saray (TRSAR)",
   label: "Saray (TRSAR)"
  },
  {
   value: "Saraykoy (TRSKY)",
   label: "Saraykoy (TRSKY)"
  },
  {
   value: "Sarayonu (TRSNU)",
   label: "Sarayonu (TRSNU)"
  },
  {
   value: "Sarigazi (TRSRG)",
   label: "Sarigazi (TRSRG)"
  },
  {
   value: "Sarigol (TRSGL)",
   label: "Sarigol (TRSGL)"
  },
  {
   value: "Sariyer (TRSRY)",
   label: "Sariyer (TRSRY)"
  },
  {
   value: "Sarkoy (TRSRK)",
   label: "Sarkoy (TRSRK)"
  },
  {
   value: "Saruhanli (TRSHL)",
   label: "Saruhanli (TRSHL)"
  },
  {
   value: "Sefakoy (TRSEF)",
   label: "Sefakoy (TRSEF)"
  },
  {
   value: "Seferhisar (TRSFH)",
   label: "Seferhisar (TRSFH)"
  },
  {
   value: "Selcuk (TRSCK)",
   label: "Selcuk (TRSCK)"
  },
  {
   value: "Selimiye (TRSEL)",
   label: "Selimiye (TRSEL)"
  },
  {
   value: "Senirkent (TRSEN)",
   label: "Senirkent (TRSEN)"
  },
  {
   value: "Sereflikochisar (TRSKH)",
   label: "Sereflikochisar (TRSKH)"
  },
  {
   value: "Serik (TRSEI)",
   label: "Serik (TRSEI)"
  },
  {
   value: "Serviburun (TRSER)",
   label: "Serviburun (TRSER)"
  },
  {
   value: "Seydisehir (TRSEY)",
   label: "Seydisehir (TRSEY)"
  },
  {
   value: "Seyitgazi (TRSYT)",
   label: "Seyitgazi (TRSYT)"
  },
  {
   value: "Seyrantepe (TRSYR)",
   label: "Seyrantepe (TRSYR)"
  },
  {
   value: "Siirt (TRSXZ)",
   label: "Siirt (TRSXZ)"
  },
  {
   value: "Silivri (TRSIL)",
   label: "Silivri (TRSIL)"
  },
  {
   value: "Simav (TRSMV)",
   label: "Simav (TRSMV)"
  },
  {
   value: "Manyas (TRMYS)",
   label: "Manyas (TRMYS)"
  },
  {
   value: "Mardin (TRMDN)",
   label: "Mardin (TRMDN)"
  },
  {
   value: "Marmara Adasi (TRMRA)",
   label: "Marmara Adasi (TRMRA)"
  },
  {
   value: "Marmara Ereglisi (TRMAR)",
   label: "Marmara Ereglisi (TRMAR)"
  },
  {
   value: "Marmaris (TRMRM)",
   label: "Marmaris (TRMRM)"
  },
  {
   value: "Maslak (TRMAS)",
   label: "Maslak (TRMAS)"
  },
  {
   value: "Menderes (TRMEN)",
   label: "Menderes (TRMEN)"
  },
  {
   value: "Menemen (TRMNM)",
   label: "Menemen (TRMNM)"
  },
  {
   value: "Meric (TRMRC)",
   label: "Meric (TRMRC)"
  },
  {
   value: "Merkez apt\/Balikesir (TRMQJ)",
   label: "Merkez apt\/Balikesir (TRMQJ)"
  },
  {
   value: "Mersin (TRMER)",
   label: "Mersin (TRMER)"
  },
  {
   value: "Merter (TRMRT)",
   label: "Merter (TRMRT)"
  },
  {
   value: "Merzifon (TRMZH)",
   label: "Merzifon (TRMZH)"
  },
  {
   value: "Mevlanakapi (TRMEK)",
   label: "Mevlanakapi (TRMEK)"
  },
  {
   value: "Milas (TRMIL)",
   label: "Milas (TRMIL)"
  },
  {
   value: "Mudanya (TRMUD)",
   label: "Mudanya (TRMUD)"
  },
  {
   value: "Mudurnu (TRMDR)",
   label: "Mudurnu (TRMDR)"
  },
  {
   value: "Mugla (TRMUG)",
   label: "Mugla (TRMUG)"
  },
  {
   value: "Muratli (TRMUR)",
   label: "Muratli (TRMUR)"
  },
  {
   value: "Mus (TRMSR)",
   label: "Mus (TRMSR)"
  },
  {
   value: "Mut (TRMUT)",
   label: "Mut (TRMUT)"
  },
  {
   value: "Nallihan (TRNAL)",
   label: "Nallihan (TRNAL)"
  },
  {
   value: "Nazilli (TRNZL)",
   label: "Nazilli (TRNZL)"
  },
  {
   value: "Nemrut Bay (TRNEM)",
   label: "Nemrut Bay (TRNEM)"
  },
  {
   value: "Nevsehir (TRNEV)",
   label: "Nevsehir (TRNEV)"
  },
  {
   value: "Nevsehir apt (TRNAV)",
   label: "Nevsehir apt (TRNAV)"
  },
  {
   value: "Nigde (TRNIG)",
   label: "Nigde (TRNIG)"
  },
  {
   value: "Odemis (TRODE)",
   label: "Odemis (TRODE)"
  },
  {
   value: "Odunluk (TRODU)",
   label: "Odunluk (TRODU)"
  },
  {
   value: "Okmeydani (TROKM)",
   label: "Okmeydani (TROKM)"
  },
  {
   value: "Omerli (TROME)",
   label: "Omerli (TROME)"
  },
  {
   value: "Ordu (TRORD)",
   label: "Ordu (TRORD)"
  },
  {
   value: "Orhaneli (TROHL)",
   label: "Orhaneli (TROHL)"
  },
  {
   value: "Orhangazi (TROGZ)",
   label: "Orhangazi (TROGZ)"
  },
  {
   value: "Orhanli (TRORH)",
   label: "Orhanli (TRORH)"
  },
  {
   value: "Ornektepe (TRORN)",
   label: "Ornektepe (TRORN)"
  },
  {
   value: "Ortaca (TRORT)",
   label: "Ortaca (TRORT)"
  },
  {
   value: "Osmaneli (TROLI)",
   label: "Osmaneli (TROLI)"
  },
  {
   value: "Osmangazi (TROSZ)",
   label: "Osmangazi (TROSZ)"
  },
  {
   value: "Osmaniye (TROSE)",
   label: "Osmaniye (TROSE)"
  },
  {
   value: "Pamukova (TRPOV)",
   label: "Pamukova (TRPOV)"
  },
  {
   value: "Pasabahce (TRPAS)",
   label: "Pasabahce (TRPAS)"
  },
  {
   value: "Kesan (TRKES)",
   label: "Kesan (TRKES)"
  },
  {
   value: "Kestel (TRKSL)",
   label: "Kestel (TRKSL)"
  },
  {
   value: "Kinik (TRKNK)",
   label: "Kinik (TRKNK)"
  },
  {
   value: "Kiraz (TRKRZ)",
   label: "Kiraz (TRKRZ)"
  },
  {
   value: "Kirikkale (TRKRK)",
   label: "Kirikkale (TRKRK)"
  },
  {
   value: "Kirkagac (TRKIC)",
   label: "Kirkagac (TRKIC)"
  },
  {
   value: "Kirklareli (TRKIR)",
   label: "Kirklareli (TRKIR)"
  },
  {
   value: "Kirsehir (TRKSH)",
   label: "Kirsehir (TRKSH)"
  },
  {
   value: "Kizilcahamam (TRKZM)",
   label: "Kizilcahamam (TRKZM)"
  },
  {
   value: "Kocaeli (TRKCO)",
   label: "Kocaeli (TRKCO)"
  },
  {
   value: "Kocarli (TRKCL)",
   label: "Kocarli (TRKCL)"
  },
  {
   value: "Konya (TRKYA)",
   label: "Konya (TRKYA)"
  },
  {
   value: "Konya Ereglisi (TRERG)",
   label: "Konya Ereglisi (TRERG)"
  },
  {
   value: "Korkuteli (TRKOR)",
   label: "Korkuteli (TRKOR)"
  },
  {
   value: "Kosk (TRKSK)",
   label: "Kosk (TRKSK)"
  },
  {
   value: "Koycegiz (TRKCZ)",
   label: "Koycegiz (TRKCZ)"
  },
  {
   value: "Kozan (TRKZN)",
   label: "Kozan (TRKZN)"
  },
  {
   value: "Kozyatagi (TRKOZ)",
   label: "Kozyatagi (TRKOZ)"
  },
  {
   value: "Kucukcekmece (TRKCE)",
   label: "Kucukcekmece (TRKCE)"
  },
  {
   value: "Kucukkuy (TRKUK)",
   label: "Kucukkuy (TRKUK)"
  },
  {
   value: "Kucukyali (TRKUY)",
   label: "Kucukyali (TRKUY)"
  },
  {
   value: "Kula (TRKLA)",
   label: "Kula (TRKLA)"
  },
  {
   value: "Kulu (TRKUL)",
   label: "Kulu (TRKUL)"
  },
  {
   value: "Kumluca (TRKUM)",
   label: "Kumluca (TRKUM)"
  },
  {
   value: "Kurtkoy (TRKUR)",
   label: "Kurtkoy (TRKUR)"
  },
  {
   value: "Kusadasi (TRKUS)",
   label: "Kusadasi (TRKUS)"
  },
  {
   value: "Kusukkuyu (TRKOC)",
   label: "Kusukkuyu (TRKOC)"
  },
  {
   value: "Kutahya (TRKTY)",
   label: "Kutahya (TRKTY)"
  },
  {
   value: "Kuyucak (TRKCK)",
   label: "Kuyucak (TRKCK)"
  },
  {
   value: "Lalapasa (TRLAL)",
   label: "Lalapasa (TRLAL)"
  },
  {
   value: "Lapseki (TRLAP)",
   label: "Lapseki (TRLAP)"
  },
  {
   value: "Levent (TRLEV)",
   label: "Levent (TRLEV)"
  },
  {
   value: "Luleburgaz (TRLUL)",
   label: "Luleburgaz (TRLUL)"
  },
  {
   value: "M.Kemalpasa (TRMKP)",
   label: "M.Kemalpasa (TRMKP)"
  },
  {
   value: "Mahmudiye (TRMHM)",
   label: "Mahmudiye (TRMHM)"
  },
  {
   value: "Mahmutbey (TRMAH)",
   label: "Mahmutbey (TRMAH)"
  },
  {
   value: "Malatya (TRMLX)",
   label: "Malatya (TRMLX)"
  },
  {
   value: "Malkara (TRMLK)",
   label: "Malkara (TRMLK)"
  },
  {
   value: "Maltepe (TRMAL)",
   label: "Maltepe (TRMAL)"
  },
  {
   value: "Manavgat (TRMVG)",
   label: "Manavgat (TRMVG)"
  },
  {
   value: "Manisa (TRMAM)",
   label: "Manisa (TRMAM)"
  },
  {
   value: "Istanbul (TRIST)",
   label: "Istanbul (TRIST)"
  },
  {
   value: "Izmir (Smyrna) (TRIZM)",
   label: "Izmir (Smyrna) (TRIZM)"
  },
  {
   value: "Izmit (TRIZT)",
   label: "Izmit (TRIZT)"
  },
  {
   value: "Iznik (TRIZK)",
   label: "Iznik (TRIZK)"
  },
  {
   value: "Kadikoy (TRKAD)",
   label: "Kadikoy (TRKAD)"
  },
  {
   value: "Kadinhani (TRKHN)",
   label: "Kadinhani (TRKHN)"
  },
  {
   value: "Kagithane (TRKAG)",
   label: "Kagithane (TRKAG)"
  },
  {
   value: "Kahramanmaras (TRKCM)",
   label: "Kahramanmaras (TRKCM)"
  },
  {
   value: "Kalekoy (TRKAL)",
   label: "Kalekoy (TRKAL)"
  },
  {
   value: "Kandira (TRKAN)",
   label: "Kandira (TRKAN)"
  },
  {
   value: "Kapikoy (TRKPY)",
   label: "Kapikoy (TRKPY)"
  },
  {
   value: "Kapikule (TRKPU)",
   label: "Kapikule (TRKPU)"
  },
  {
   value: "Karabiga (TRKRB)",
   label: "Karabiga (TRKRB)"
  },
  {
   value: "Karabuk (TRKBK)",
   label: "Karabuk (TRKBK)"
  },
  {
   value: "Karaburun (TRKBN)",
   label: "Karaburun (TRKBN)"
  },
  {
   value: "Karacabey (TRKBY)",
   label: "Karacabey (TRKBY)"
  },
  {
   value: "Karacasu (TRKCU)",
   label: "Karacasu (TRKCU)"
  },
  {
   value: "Karahanli (TRKRH)",
   label: "Karahanli (TRKRH)"
  },
  {
   value: "Karaman (TRKMN)",
   label: "Karaman (TRKMN)"
  },
  {
   value: "Karamursel (TRKRM)",
   label: "Karamursel (TRKRM)"
  },
  {
   value: "Karapinar (TRKPN)",
   label: "Karapinar (TRKPN)"
  },
  {
   value: "Karasu (TRKRS)",
   label: "Karasu (TRKRS)"
  },
  {
   value: "Karpuzlu (TRKLU)",
   label: "Karpuzlu (TRKLU)"
  },
  {
   value: "Kars (TRKSY)",
   label: "Kars (TRKSY)"
  },
  {
   value: "Kartal (TRKAR)",
   label: "Kartal (TRKAR)"
  },
  {
   value: "Kas (TRKAS)",
   label: "Kas (TRKAS)"
  },
  {
   value: "Kastamonu (TRKTM)",
   label: "Kastamonu (TRKTM)"
  },
  {
   value: "Kastamonu apt (TRKFS)",
   label: "Kastamonu apt (TRKFS)"
  },
  {
   value: "Kaynarca (TRKAY)",
   label: "Kaynarca (TRKAY)"
  },
  {
   value: "Kaynarca (TRKCA)",
   label: "Kaynarca (TRKCA)"
  },
  {
   value: "Kayseri (TRASR)",
   label: "Kayseri (TRASR)"
  },
  {
   value: "Kazan (TRKZZ)",
   label: "Kazan (TRKZZ)"
  },
  {
   value: "Kazimkarabekir (TRKKB)",
   label: "Kazimkarabekir (TRKKB)"
  },
  {
   value: "Kazlicesme (TRKAZ)",
   label: "Kazlicesme (TRKAZ)"
  },
  {
   value: "Keban (TRKEB)",
   label: "Keban (TRKEB)"
  },
  {
   value: "Keciborlu (TRKCB)",
   label: "Keciborlu (TRKCB)"
  },
  {
   value: "Keles (TRKLS)",
   label: "Keles (TRKLS)"
  },
  {
   value: "Kemalpasa (TRKPS)",
   label: "Kemalpasa (TRKPS)"
  },
  {
   value: "Kemer (TRKMR)",
   label: "Kemer (TRKMR)"
  },
  {
   value: "Kemerburgaz (TRKEM)",
   label: "Kemerburgaz (TRKEM)"
  },
  {
   value: "Kepsut (TRKST)",
   label: "Kepsut (TRKST)"
  },
  {
   value: "Golmarmara (TRGMA)",
   label: "Golmarmara (TRGMA)"
  },
  {
   value: "Golpazari (TRGLP)",
   label: "Golpazari (TRGLP)"
  },
  {
   value: "Gonen (TRGON)",
   label: "Gonen (TRGON)"
  },
  {
   value: "Gordes (TRGDS)",
   label: "Gordes (TRGDS)"
  },
  {
   value: "Gorele (TRGOR)",
   label: "Gorele (TRGOR)"
  },
  {
   value: "Goynuk (TRGYN)",
   label: "Goynuk (TRGYN)"
  },
  {
   value: "Goztepe (TRGOZ)",
   label: "Goztepe (TRGOZ)"
  },
  {
   value: "Gulluk (TRGUL)",
   label: "Gulluk (TRGUL)"
  },
  {
   value: "Gumushane (TRGHN)",
   label: "Gumushane (TRGHN)"
  },
  {
   value: "Gunesli (TRGUN)",
   label: "Gunesli (TRGUN)"
  },
  {
   value: "Gungoren (TRGUG)",
   label: "Gungoren (TRGUG)"
  },
  {
   value: "Gursu (TRGRS)",
   label: "Gursu (TRGRS)"
  },
  {
   value: "Habibler (TRHAB)",
   label: "Habibler (TRHAB)"
  },
  {
   value: "Hadimkoy (TRHAD)",
   label: "Hadimkoy (TRHAD)"
  },
  {
   value: "Hakkari (TRHAK)",
   label: "Hakkari (TRHAK)"
  },
  {
   value: "Halkali (TRHAL)",
   label: "Halkali (TRHAL)"
  },
  {
   value: "\"Haramidere (TRHAR)",
   label: "\"Haramidere (TRHAR)"
  },
  {
   value: "Hasanpasa (TRHAP)",
   label: "Hasanpasa (TRHAP)"
  },
  {
   value: "Haskoy (TRHAS)",
   label: "Haskoy (TRHAS)"
  },
  {
   value: "Hatay (TRHAT)",
   label: "Hatay (TRHAT)"
  },
  {
   value: "Havran (TRHVR)",
   label: "Havran (TRHVR)"
  },
  {
   value: "Havsa (TRHAV)",
   label: "Havsa (TRHAV)"
  },
  {
   value: "Haydarpasa (TRHAY)",
   label: "Haydarpasa (TRHAY)"
  },
  {
   value: "Haymana (TRHMA)",
   label: "Haymana (TRHMA)"
  },
  {
   value: "Hayrabolu (TRHYR)",
   label: "Hayrabolu (TRHYR)"
  },
  {
   value: "Hendek (TRHEN)",
   label: "Hendek (TRHEN)"
  },
  {
   value: "Hereke (TRHER)",
   label: "Hereke (TRHER)"
  },
  {
   value: "Hisaronou (TRHIS)",
   label: "Hisaronou (TRHIS)"
  },
  {
   value: "Hopa (TRHOP)",
   label: "Hopa (TRHOP)"
  },
  {
   value: "Icerenkoy (TRICE)",
   label: "Icerenkoy (TRICE)"
  },
  {
   value: "Igdir (TRIGD)",
   label: "Igdir (TRIGD)"
  },
  {
   value: "Igneada (TRIGN)",
   label: "Igneada (TRIGN)"
  },
  {
   value: "Ikitelli (TRIKI)",
   label: "Ikitelli (TRIKI)"
  },
  {
   value: "Ilgin (TRILG)",
   label: "Ilgin (TRILG)"
  },
  {
   value: "Incirliova (TRICO)",
   label: "Incirliova (TRICO)"
  },
  {
   value: "Inebolu (TRINE)",
   label: "Inebolu (TRINE)"
  },
  {
   value: "Inegol (TRINL)",
   label: "Inegol (TRINL)"
  },
  {
   value: "Inhisar (TRINH)",
   label: "Inhisar (TRINH)"
  },
  {
   value: "Inonu (TRINO)",
   label: "Inonu (TRINO)"
  },
  {
   value: "Ipsala (TRIPS)",
   label: "Ipsala (TRIPS)"
  },
  {
   value: "Iskenderun (TRISK)",
   label: "Iskenderun (TRISK)"
  },
  {
   value: "Isparta (TRISE)",
   label: "Isparta (TRISE)"
  },
  {
   value: "Eminonu (TREMI)",
   label: "Eminonu (TREMI)"
  },
  {
   value: "Emirdag (TREMG)",
   label: "Emirdag (TREMG)"
  },
  {
   value: "Emirgazi (TREGZ)",
   label: "Emirgazi (TREGZ)"
  },
  {
   value: "Enez (TRENE)",
   label: "Enez (TRENE)"
  },
  {
   value: "Erdek (TRERK)",
   label: "Erdek (TRERK)"
  },
  {
   value: "Eregli (TRERE)",
   label: "Eregli (TRERE)"
  },
  {
   value: "Eregli (TRELI)",
   label: "Eregli (TRELI)"
  },
  {
   value: "Erenkoy (TRERN)",
   label: "Erenkoy (TRERN)"
  },
  {
   value: "Erzincan (TRERC)",
   label: "Erzincan (TRERC)"
  },
  {
   value: "Erzurum (TRERZ)",
   label: "Erzurum (TRERZ)"
  },
  {
   value: "Esenboga Apt\/Ankara (TRESB)",
   label: "Esenboga Apt\/Ankara (TRESB)"
  },
  {
   value: "Esenler (TRESE)",
   label: "Esenler (TRESE)"
  },
  {
   value: "Esenyurt (TRESY)",
   label: "Esenyurt (TRESY)"
  },
  {
   value: "Eskisehir (TRESK)",
   label: "Eskisehir (TRESK)"
  },
  {
   value: "Eskisehir Amadoulu U apt (TRAOE)",
   label: "Eskisehir Amadoulu U apt (TRAOE)"
  },
  {
   value: "Esme (TRESM)",
   label: "Esme (TRESM)"
  },
  {
   value: "Etiler (TRETI)",
   label: "Etiler (TRETI)"
  },
  {
   value: "Eyup (TREYU)",
   label: "Eyup (TREYU)"
  },
  {
   value: "Ezine (TREZI)",
   label: "Ezine (TREZI)"
  },
  {
   value: "Fatsa (TRFAS)",
   label: "Fatsa (TRFAS)"
  },
  {
   value: "Fethiye (TRFET)",
   label: "Fethiye (TRFET)"
  },
  {
   value: "Fikirtepe (TRFIK)",
   label: "Fikirtepe (TRFIK)"
  },
  {
   value: "Finike (TRFIN)",
   label: "Finike (TRFIN)"
  },
  {
   value: "Florya (TRFLO)",
   label: "Florya (TRFLO)"
  },
  {
   value: "Foca (TRFOC)",
   label: "Foca (TRFOC)"
  },
  {
   value: "Galata (TRGTA)",
   label: "Galata (TRGTA)"
  },
  {
   value: "Gayrettepe (TRGAY)",
   label: "Gayrettepe (TRGAY)"
  },
  {
   value: "Gaziantep (TRGZT)",
   label: "Gaziantep (TRGZT)"
  },
  {
   value: "Gaziosmanpasa (TRGAZ)",
   label: "Gaziosmanpasa (TRGAZ)"
  },
  {
   value: "Gebze (TRGEB)",
   label: "Gebze (TRGEB)"
  },
  {
   value: "Gediz (TRGDZ)",
   label: "Gediz (TRGDZ)"
  },
  {
   value: "Gelibolu (TRGEL)",
   label: "Gelibolu (TRGEL)"
  },
  {
   value: "Gemlik (TRGEM)",
   label: "Gemlik (TRGEM)"
  },
  {
   value: "Gerede (TRGER)",
   label: "Gerede (TRGER)"
  },
  {
   value: "Germencik (TRGRK)",
   label: "Germencik (TRGRK)"
  },
  {
   value: "Geyve (TRGEY)",
   label: "Geyve (TRGEY)"
  },
  {
   value: "Giresun (TRGIR)",
   label: "Giresun (TRGIR)"
  },
  {
   value: "Gocek (TRGCK)",
   label: "Gocek (TRGCK)"
  },
  {
   value: "Gokceada (TRGCA)",
   label: "Gokceada (TRGCA)"
  },
  {
   value: "Gokova (TRGKV)",
   label: "Gokova (TRGKV)"
  },
  {
   value: "Golbasi (TRGBS)",
   label: "Golbasi (TRGBS)"
  },
  {
   value: "Golcuk (TRGOK)",
   label: "Golcuk (TRGOK)"
  },
  {
   value: "Cevizli (TRCEV)",
   label: "Cevizli (TRCEV)"
  },
  {
   value: "Ceyhan (TRCEY)",
   label: "Ceyhan (TRCEY)"
  },
  {
   value: "Cide (TRCID)",
   label: "Cide (TRCID)"
  },
  {
   value: "Ciftehavuzlar (TRCIF)",
   label: "Ciftehavuzlar (TRCIF)"
  },
  {
   value: "Cigli (TRCIG)",
   label: "Cigli (TRCIG)"
  },
  {
   value: "Cigne (TRCNE)",
   label: "Cigne (TRCNE)"
  },
  {
   value: "Cihanbeyli (TRCHB)",
   label: "Cihanbeyli (TRCHB)"
  },
  {
   value: "Cine (TRCIN)",
   label: "Cine (TRCIN)"
  },
  {
   value: "Cobanlar (TRCNR)",
   label: "Cobanlar (TRCNR)"
  },
  {
   value: "Cubuklu (TRCUB)",
   label: "Cubuklu (TRCUB)"
  },
  {
   value: "Cumra (TRCMR)",
   label: "Cumra (TRCMR)"
  },
  {
   value: "Dalaman (TRDLM)",
   label: "Dalaman (TRDLM)"
  },
  {
   value: "Darica (TRDAR)",
   label: "Darica (TRDAR)"
  },
  {
   value: "Datca (TRDAT)",
   label: "Datca (TRDAT)"
  },
  {
   value: "Dazkiri (TRDAZ)",
   label: "Dazkiri (TRDAZ)"
  },
  {
   value: "Demirci (TRDCI)",
   label: "Demirci (TRDCI)"
  },
  {
   value: "Demirkoy (TRDEM)",
   label: "Demirkoy (TRDEM)"
  },
  {
   value: "Denizli (TRDNZ)",
   label: "Denizli (TRDNZ)"
  },
  {
   value: "Derekoy (TRDEK)",
   label: "Derekoy (TRDEK)"
  },
  {
   value: "Derince (TRDRC)",
   label: "Derince (TRDRC)"
  },
  {
   value: "Devrek (TRDRK)",
   label: "Devrek (TRDRK)"
  },
  {
   value: "Didim (TRDDM)",
   label: "Didim (TRDDM)"
  },
  {
   value: "Dikili (TRDIK)",
   label: "Dikili (TRDIK)"
  },
  {
   value: "Diliskelesi (TRDIL)",
   label: "Diliskelesi (TRDIL)"
  },
  {
   value: "Dilovasi (TRDLV)",
   label: "Dilovasi (TRDLV)"
  },
  {
   value: "Dinar (TRDNR)",
   label: "Dinar (TRDNR)"
  },
  {
   value: "Diyarbakir (TRDIY)",
   label: "Diyarbakir (TRDIY)"
  },
  {
   value: "Doganhisar (TRDHN)",
   label: "Doganhisar (TRDHN)"
  },
  {
   value: "Dolayoba (TRDOL)",
   label: "Dolayoba (TRDOL)"
  },
  {
   value: "Domanic (TRDMC)",
   label: "Domanic (TRDMC)"
  },
  {
   value: "Dortyol (TRDYL)",
   label: "Dortyol (TRDYL)"
  },
  {
   value: "Dudullu (TRDUD)",
   label: "Dudullu (TRDUD)"
  },
  {
   value: "Dumlupinar (TRDPR)",
   label: "Dumlupinar (TRDPR)"
  },
  {
   value: "Dursunbey (TRDRY)",
   label: "Dursunbey (TRDRY)"
  },
  {
   value: "Duzce (TRDUZ)",
   label: "Duzce (TRDUZ)"
  },
  {
   value: "Eceabat (TRECE)",
   label: "Eceabat (TRECE)"
  },
  {
   value: "Edincik (TREDK)",
   label: "Edincik (TREDK)"
  },
  {
   value: "Edirne (TREDI)",
   label: "Edirne (TREDI)"
  },
  {
   value: "Edremit (TREDO)",
   label: "Edremit (TREDO)"
  },
  {
   value: "Egirdir (TREGI)",
   label: "Egirdir (TREGI)"
  },
  {
   value: "Elazig (TREZS)",
   label: "Elazig (TREZS)"
  },
  {
   value: "Elmali (TRELM)",
   label: "Elmali (TRELM)"
  },
  {
   value: "Emet (TREME)",
   label: "Emet (TREME)"
  },
  {
   value: "Beypazari (TRBPZ)",
   label: "Beypazari (TRBPZ)"
  },
  {
   value: "Beysehir (TRBYS)",
   label: "Beysehir (TRBYS)"
  },
  {
   value: "Biga (TRBIG)",
   label: "Biga (TRBIG)"
  },
  {
   value: "Bigadic (TRBGD)",
   label: "Bigadic (TRBGD)"
  },
  {
   value: "Bilecik (TRBIL)",
   label: "Bilecik (TRBIL)"
  },
  {
   value: "Bingol (TRBIN)",
   label: "Bingol (TRBIN)"
  },
  {
   value: "Bodrum (TRBXN)",
   label: "Bodrum (TRBXN)"
  },
  {
   value: "Bogazagzi (TRBOG)",
   label: "Bogazagzi (TRBOG)"
  },
  {
   value: "Bolu (TRBOL)",
   label: "Bolu (TRBOL)"
  },
  {
   value: "Bolvadin (TRBVN)",
   label: "Bolvadin (TRBVN)"
  },
  {
   value: "Bornova (TRBOR)",
   label: "Bornova (TRBOR)"
  },
  {
   value: "Bostanci (TRBOS)",
   label: "Bostanci (TRBOS)"
  },
  {
   value: "Bozburun (TRBZB)",
   label: "Bozburun (TRBZB)"
  },
  {
   value: "Bozcaada (TRBZC)",
   label: "Bozcaada (TRBZC)"
  },
  {
   value: "Bozdogan (TRBDG)",
   label: "Bozdogan (TRBDG)"
  },
  {
   value: "Bozuyuk (TRBZY)",
   label: "Bozuyuk (TRBZY)"
  },
  {
   value: "Buca (TRBUC)",
   label: "Buca (TRBUC)"
  },
  {
   value: "Bucak (TRBCK)",
   label: "Bucak (TRBCK)"
  },
  {
   value: "Buharkent (TRBUH)",
   label: "Buharkent (TRBUH)"
  },
  {
   value: "Buldan (TRBDN)",
   label: "Buldan (TRBDN)"
  },
  {
   value: "Burdur (TRBDR)",
   label: "Burdur (TRBDR)"
  },
  {
   value: "Burhaniye (TRBHN)",
   label: "Burhaniye (TRBHN)"
  },
  {
   value: "Bursa (TRBTZ)",
   label: "Bursa (TRBTZ)"
  },
  {
   value: "Buyukcekmece (TRBCE)",
   label: "Buyukcekmece (TRBCE)"
  },
  {
   value: "Buyukcukur (TRBUY)",
   label: "Buyukcukur (TRBUY)"
  },
  {
   value: "Cal (TRCAL)",
   label: "Cal (TRCAL)"
  },
  {
   value: "Camalti (TRCAM)",
   label: "Camalti (TRCAM)"
  },
  {
   value: "Camlica (TRCML)",
   label: "Camlica (TRCML)"
  },
  {
   value: "Camlidere (TRCDR)",
   label: "Camlidere (TRCDR)"
  },
  {
   value: "Can (TRCAN)",
   label: "Can (TRCAN)"
  },
  {
   value: "Canakkale (TRCKZ)",
   label: "Canakkale (TRCKZ)"
  },
  {
   value: "Cankiri (TRCKR)",
   label: "Cankiri (TRCKR)"
  },
  {
   value: "Cardak (TRCAR)",
   label: "Cardak (TRCAR)"
  },
  {
   value: "Carsamba apt\/Samsun (TRSZF)",
   label: "Carsamba apt\/Samsun (TRSZF)"
  },
  {
   value: "Catalca (TRCAT)",
   label: "Catalca (TRCAT)"
  },
  {
   value: "Cavdir (TRCVD)",
   label: "Cavdir (TRCVD)"
  },
  {
   value: "Cay (TRCCY)",
   label: "Cay (TRCCY)"
  },
  {
   value: "Caycuma (TRCUM)",
   label: "Caycuma (TRCUM)"
  },
  {
   value: "Cayirova (TRCAY)",
   label: "Cayirova (TRCAY)"
  },
  {
   value: "Celtik (TRCTK)",
   label: "Celtik (TRCTK)"
  },
  {
   value: "Cerkezköy (TRCKY)",
   label: "Cerkezköy (TRCKY)"
  },
  {
   value: "Cesme (TRCES)",
   label: "Cesme (TRCES)"
  },
  {
   value: "Altinkum (TRAYD)",
   label: "Altinkum (TRAYD)"
  },
  {
   value: "Altintepe (TRALT)",
   label: "Altintepe (TRALT)"
  },
  {
   value: "Amasra (TRAMA)",
   label: "Amasra (TRAMA)"
  },
  {
   value: "Amasya (TRAMY)",
   label: "Amasya (TRAMY)"
  },
  {
   value: "Ambarli (TRAMB)",
   label: "Ambarli (TRAMB)"
  },
  {
   value: "Anadolukavagi (TRADK)",
   label: "Anadolukavagi (TRADK)"
  },
  {
   value: "Anamur (TRANA)",
   label: "Anamur (TRANA)"
  },
  {
   value: "Ankara (TRANK)",
   label: "Ankara (TRANK)"
  },
  {
   value: "Antalya (TRAYT)",
   label: "Antalya (TRAYT)"
  },
  {
   value: "Artvin (TRAVN)",
   label: "Artvin (TRAVN)"
  },
  {
   value: "Avcilar (TRAVC)",
   label: "Avcilar (TRAVC)"
  },
  {
   value: "Ayancik (TRAYA)",
   label: "Ayancik (TRAYA)"
  },
  {
   value: "Ayas (TRAYS)",
   label: "Ayas (TRAYS)"
  },
  {
   value: "Ayazaga (TRAYZ)",
   label: "Ayazaga (TRAYZ)"
  },
  {
   value: "Aydin (TRADN)",
   label: "Aydin (TRADN)"
  },
  {
   value: "Aydinlikoy (TRAYK)",
   label: "Aydinlikoy (TRAYK)"
  },
  {
   value: "Ayranci (TRARI)",
   label: "Ayranci (TRARI)"
  },
  {
   value: "Ayvalik (TRAYV)",
   label: "Ayvalik (TRAYV)"
  },
  {
   value: "Babadag (TRBBD)",
   label: "Babadag (TRBBD)"
  },
  {
   value: "Babaeski (TRBAB)",
   label: "Babaeski (TRBAB)"
  },
  {
   value: "Bafra (TRBAF)",
   label: "Bafra (TRBAF)"
  },
  {
   value: "Bagcilar (TRBAG)",
   label: "Bagcilar (TRBAG)"
  },
  {
   value: "Bahcelievler (TRBAH)",
   label: "Bahcelievler (TRBAH)"
  },
  {
   value: "Bakirkoy (TRBAK)",
   label: "Bakirkoy (TRBAK)"
  },
  {
   value: "Bala (TRBLA)",
   label: "Bala (TRBLA)"
  },
  {
   value: "Balikesir (TRBZI)",
   label: "Balikesir (TRBZI)"
  },
  {
   value: "Balya (TRBLY)",
   label: "Balya (TRBLY)"
  },
  {
   value: "Banaz (TRBAN)",
   label: "Banaz (TRBAN)"
  },
  {
   value: "Bandirmar (TRBDM)",
   label: "Bandirmar (TRBDM)"
  },
  {
   value: "Bartin (TRBTN)",
   label: "Bartin (TRBTN)"
  },
  {
   value: "Basmahaner (TRBAS)",
   label: "Basmahaner (TRBAS)"
  },
  {
   value: "Basmakci (TRBKC)",
   label: "Basmakci (TRBKC)"
  },
  {
   value: "Batman (TRBAL)",
   label: "Batman (TRBAL)"
  },
  {
   value: "Bayburt (TRBYT)",
   label: "Bayburt (TRBYT)"
  },
  {
   value: "Bayindir (TRBYN)",
   label: "Bayindir (TRBYN)"
  },
  {
   value: "Bayramic (TRBYM)",
   label: "Bayramic (TRBYM)"
  },
  {
   value: "Bayramoglu (TRBYR)",
   label: "Bayramoglu (TRBYR)"
  },
  {
   value: "Bayrampasa (TRBAY)",
   label: "Bayrampasa (TRBAY)"
  },
  {
   value: "Bergama (TRBER)",
   label: "Bergama (TRBER)"
  },
  {
   value: "Beydag (TRBYD)",
   label: "Beydag (TRBYD)"
  },
  {
   value: "Beykoz (TRBEY)",
   label: "Beykoz (TRBEY)"
  },
  {
   value: "Beylikduzu (TRBYL)",
   label: "Beylikduzu (TRBYL)"
  },
  {
   value: "La Goulette Nord (Halqueloued) (TNLGN)",
   label: "La Goulette Nord (Halqueloued) (TNLGN)"
  },
  {
   value: "La Skhirra (TNLSK)",
   label: "La Skhirra (TNLSK)"
  },
  {
   value: "Mahares (TNMAH)",
   label: "Mahares (TNMAH)"
  },
  {
   value: "Mateur (TNMAT)",
   label: "Mateur (TNMAT)"
  },
  {
   value: "Menzel Bourguiba (TNMBA)",
   label: "Menzel Bourguiba (TNMBA)"
  },
  {
   value: "Menzel Temime (TNMTE)",
   label: "Menzel Temime (TNMTE)"
  },
  {
   value: "Moknine (TNMOK)",
   label: "Moknine (TNMOK)"
  },
  {
   value: "Monastir (TNMIR)",
   label: "Monastir (TNMIR)"
  },
  {
   value: "Nabeul (TNNAB)",
   label: "Nabeul (TNNAB)"
  },
  {
   value: "Rades\/Tunis (TNRDS)",
   label: "Rades\/Tunis (TNRDS)"
  },
  {
   value: "Sfax (TNSFA)",
   label: "Sfax (TNSFA)"
  },
  {
   value: "Sousse (TNSUS)",
   label: "Sousse (TNSUS)"
  },
  {
   value: "Tabarka (TNTBJ)",
   label: "Tabarka (TNTBJ)"
  },
  {
   value: "Tunis (TNTUN)",
   label: "Tunis (TNTUN)"
  },
  {
   value: "Eua (TOEUA)",
   label: "Eua (TOEUA)"
  },
  {
   value: "Ha'apai (TOHPA)",
   label: "Ha'apai (TOHPA)"
  },
  {
   value: "Neiafu (TONEI)",
   label: "Neiafu (TONEI)"
  },
  {
   value: "Nuku'alofa-Tongatapu (TOTBU)",
   label: "Nuku'alofa-Tongatapu (TOTBU)"
  },
  {
   value: "Pangai (TOPAN)",
   label: "Pangai (TOPAN)"
  },
  {
   value: "Vava'u (TOVAV)",
   label: "Vava'u (TOVAV)"
  },
  {
   value: "Dili (TPDIL)",
   label: "Dili (TPDIL)"
  },
  {
   value: "Acibadem (TRACI)",
   label: "Acibadem (TRACI)"
  },
  {
   value: "Acipayam (TRAPY)",
   label: "Acipayam (TRAPY)"
  },
  {
   value: "Adana (TRADA)",
   label: "Adana (TRADA)"
  },
  {
   value: "Adapazari (TRADZ)",
   label: "Adapazari (TRADZ)"
  },
  {
   value: "Adiyaman (TRADI)",
   label: "Adiyaman (TRADI)"
  },
  {
   value: "Afyon (TRAFY)",
   label: "Afyon (TRAFY)"
  },
  {
   value: "Agri (TRAJI)",
   label: "Agri (TRAJI)"
  },
  {
   value: "Ahmetli (TRAHM)",
   label: "Ahmetli (TRAHM)"
  },
  {
   value: "Akcaabat (TRAKB)",
   label: "Akcaabat (TRAKB)"
  },
  {
   value: "Akcay (TRAKY)",
   label: "Akcay (TRAKY)"
  },
  {
   value: "Akhisar (TRAHS)",
   label: "Akhisar (TRAHS)"
  },
  {
   value: "Aksaray (TRARY)",
   label: "Aksaray (TRARY)"
  },
  {
   value: "Aksaray (TRAKS)",
   label: "Aksaray (TRAKS)"
  },
  {
   value: "Aksehir (TRAHR)",
   label: "Aksehir (TRAHR)"
  },
  {
   value: "Akseki (TRAKI)",
   label: "Akseki (TRAKI)"
  },
  {
   value: "Akyazi (TRAKZ)",
   label: "Akyazi (TRAKZ)"
  },
  {
   value: "Alanya (TRALA)",
   label: "Alanya (TRALA)"
  },
  {
   value: "Alapli (TRAPI)",
   label: "Alapli (TRAPI)"
  },
  {
   value: "Alasehir (TRASH)",
   label: "Alasehir (TRASH)"
  },
  {
   value: "Alemdag (TRALE)",
   label: "Alemdag (TRALE)"
  },
  {
   value: "Aliaga (TRALI)",
   label: "Aliaga (TRALI)"
  },
  {
   value: "Phra Nakhon si Ayutthaya (THPNA)",
   label: "Phra Nakhon si Ayutthaya (THPNA)"
  },
  {
   value: "Phra Pradeng (THPPA)",
   label: "Phra Pradeng (THPPA)"
  },
  {
   value: "Phrae (THPRH)",
   label: "Phrae (THPRH)"
  },
  {
   value: "Phuket (THHKT)",
   label: "Phuket (THHKT)"
  },
  {
   value: "Ranong (THUNN)",
   label: "Ranong (THUNN)"
  },
  {
   value: "Samut Prakarn (THSPR)",
   label: "Samut Prakarn (THSPR)"
  },
  {
   value: "Sattahip (THSAT)",
   label: "Sattahip (THSAT)"
  },
  {
   value: "Sichol (THSIC)",
   label: "Sichol (THSIC)"
  },
  {
   value: "Singora (THSIN)",
   label: "Singora (THSIN)"
  },
  {
   value: "Songkhla (THSGZ)",
   label: "Songkhla (THSGZ)"
  },
  {
   value: "Sre Kaew (THSKW)",
   label: "Sre Kaew (THSKW)"
  },
  {
   value: "Sriracha (THSRI)",
   label: "Sriracha (THSRI)"
  },
  {
   value: "Ta-Chalaeb (THTAC)",
   label: "Ta-Chalaeb (THTAC)"
  },
  {
   value: "Tha Sala (THTHA)",
   label: "Tha Sala (THTHA)"
  },
  {
   value: "Thai prosperity terminal (THTPT)",
   label: "Thai prosperity terminal (THTPT)"
  },
  {
   value: "Trang (THTST)",
   label: "Trang (THTST)"
  },
  {
   value: "Ubon Ratchathani (THUBP)",
   label: "Ubon Ratchathani (THUBP)"
  },
  {
   value: "Udon Thani (THUTH)",
   label: "Udon Thani (THUTH)"
  },
  {
   value: "Unithai Container Terminal (THUCT)",
   label: "Unithai Container Terminal (THUCT)"
  },
  {
   value: "Yala (THYAL)",
   label: "Yala (THYAL)"
  },
  {
   value: "BANGPAKONG (THBGP)",
   label: "BANGPAKONG (THBGP)"
  },
  {
   value: "Dushanbe (TJDYU)",
   label: "Dushanbe (TJDYU)"
  },
  {
   value: "Ashkhabad (TMASB)",
   label: "Ashkhabad (TMASB)"
  },
  {
   value: "Kushka (TMKUK)",
   label: "Kushka (TMKUK)"
  },
  {
   value: "Sarakhs (TMSRK)",
   label: "Sarakhs (TMSRK)"
  },
  {
   value: "Tchardjou (TMCRZ)",
   label: "Tchardjou (TMCRZ)"
  },
  {
   value: "Termez (TMTMZ)",
   label: "Termez (TMTMZ)"
  },
  {
   value: "Turkmanbashi (TMKRW)",
   label: "Turkmanbashi (TMKRW)"
  },
  {
   value: "Ashtart Terminal (TNASH)",
   label: "Ashtart Terminal (TNASH)"
  },
  {
   value: "Beja (TNBEJ)",
   label: "Beja (TNBEJ)"
  },
  {
   value: "Ben Gardane (TNBGA)",
   label: "Ben Gardane (TNBGA)"
  },
  {
   value: "Bizerte (TNBIZ)",
   label: "Bizerte (TNBIZ)"
  },
  {
   value: "Djerba (TNDJE)",
   label: "Djerba (TNDJE)"
  },
  {
   value: "Ezzahra (TNEZA)",
   label: "Ezzahra (TNEZA)"
  },
  {
   value: "Gabes (TNGAE)",
   label: "Gabes (TNGAE)"
  },
  {
   value: "Kalaa Kebira (TNKKE)",
   label: "Kalaa Kebira (TNKKE)"
  },
  {
   value: "Kelibia (TNKEL)",
   label: "Kelibia (TNKEL)"
  },
  {
   value: "Kerkena (TNKER)",
   label: "Kerkena (TNKER)"
  },
  {
   value: "Korba (TNKOR)",
   label: "Korba (TNKOR)"
  },
  {
   value: "Bangnara (THBNG)",
   label: "Bangnara (THBNG)"
  },
  {
   value: "Banlaem (THBNL)",
   label: "Banlaem (THBNL)"
  },
  {
   value: "Chachoengsao (THCSD)",
   label: "Chachoengsao (THCSD)"
  },
  {
   value: "Chanthaburi (THCHA)",
   label: "Chanthaburi (THCHA)"
  },
  {
   value: "Chiang Mai (THCNX)",
   label: "Chiang Mai (THCNX)"
  },
  {
   value: "Chiang Rai (THCEI)",
   label: "Chiang Rai (THCEI)"
  },
  {
   value: "Chon Buri (THCHB)",
   label: "Chon Buri (THCHB)"
  },
  {
   value: "Chumporn (THCHU)",
   label: "Chumporn (THCHU)"
  },
  {
   value: "Hat Yai (THHDY)",
   label: "Hat Yai (THHDY)"
  },
  {
   value: "Kanjang (THKAN)",
   label: "Kanjang (THKAN)"
  },
  {
   value: "Khanom (THKHA)",
   label: "Khanom (THKHA)"
  },
  {
   value: "Khon Kaen (THKKC)",
   label: "Khon Kaen (THKKC)"
  },
  {
   value: "Klong Yai (THKLY)",
   label: "Klong Yai (THKLY)"
  },
  {
   value: "Koh Lanta (THKLA)",
   label: "Koh Lanta (THKLA)"
  },
  {
   value: "Koh Nok (THKNO)",
   label: "Koh Nok (THKNO)"
  },
  {
   value: "Koh Samui (THUSM)",
   label: "Koh Samui (THUSM)"
  },
  {
   value: "Koh Sichang (THKSI)",
   label: "Koh Sichang (THKSI)"
  },
  {
   value: "Koh Yao (THKYO)",
   label: "Koh Yao (THKYO)"
  },
  {
   value: "Krabi (THKBV)",
   label: "Krabi (THKBV)"
  },
  {
   value: "Laem Chabang (THLCH)",
   label: "Laem Chabang (THLCH)"
  },
  {
   value: "Lampang (THLPT)",
   label: "Lampang (THLPT)"
  },
  {
   value: "Lang Suan (THLAS)",
   label: "Lang Suan (THLAS)"
  },
  {
   value: "Larm Charang (THLAC)",
   label: "Larm Charang (THLAC)"
  },
  {
   value: "Lat Krabang (THLKR)",
   label: "Lat Krabang (THLKR)"
  },
  {
   value: "Loei (THLOE)",
   label: "Loei (THLOE)"
  },
  {
   value: "Mab Tapud (THMAT)",
   label: "Mab Tapud (THMAT)"
  },
  {
   value: "Mae Hong Son (THHGN)",
   label: "Mae Hong Son (THHGN)"
  },
  {
   value: "Meklong (THMEK)",
   label: "Meklong (THMEK)"
  },
  {
   value: "Nakhom Phanom (THKOP)",
   label: "Nakhom Phanom (THKOP)"
  },
  {
   value: "Nakhon Si Thamamrat (THNST)",
   label: "Nakhon Si Thamamrat (THNST)"
  },
  {
   value: "Nan (THNNT)",
   label: "Nan (THNNT)"
  },
  {
   value: "Narathiwat (THNAW)",
   label: "Narathiwat (THNAW)"
  },
  {
   value: "Nong Bua Lamphoo (THNBO)",
   label: "Nong Bua Lamphoo (THNBO)"
  },
  {
   value: "Nong Khat (THQJX)",
   label: "Nong Khat (THQJX)"
  },
  {
   value: "Pakbara (THPKB)",
   label: "Pakbara (THPKB)"
  },
  {
   value: "Paknam (THPKN)",
   label: "Paknam (THPKN)"
  },
  {
   value: "Pakpanang (THPKP)",
   label: "Pakpanang (THPKP)"
  },
  {
   value: "Pattani (THPAN)",
   label: "Pattani (THPAN)"
  },
  {
   value: "Phangnga (THPHA)",
   label: "Phangnga (THPHA)"
  },
  {
   value: "Phitsanulok (THPHS)",
   label: "Phitsanulok (THPHS)"
  },
  {
   value: "Si Francisco Macoros (SVSFM)",
   label: "Si Francisco Macoros (SVSFM)"
  },
  {
   value: "Aleppo (Alep) (SYALP)",
   label: "Aleppo (Alep) (SYALP)"
  },
  {
   value: "Baniyas (SYBAN)",
   label: "Baniyas (SYBAN)"
  },
  {
   value: "Damascus (Damas) (SYDAM)",
   label: "Damascus (Damas) (SYDAM)"
  },
  {
   value: "Deirezzor (SYDEZ)",
   label: "Deirezzor (SYDEZ)"
  },
  {
   value: "Dera'a (SYQDR)",
   label: "Dera'a (SYQDR)"
  },
  {
   value: "Hama (SYQHM)",
   label: "Hama (SYQHM)"
  },
  {
   value: "Kameshli (SYKAC)",
   label: "Kameshli (SYKAC)"
  },
  {
   value: "Latakia (SYLTK)",
   label: "Latakia (SYLTK)"
  },
  {
   value: "Ruad Island (SYRUI)",
   label: "Ruad Island (SYRUI)"
  },
  {
   value: "Tartous (SYTTS)",
   label: "Tartous (SYTTS)"
  },
  {
   value: "Wasit (SYWST)",
   label: "Wasit (SYWST)"
  },
  {
   value: "Manzini (SZMTS)",
   label: "Manzini (SZMTS)"
  },
  {
   value: "Matsapha (SZMAT)",
   label: "Matsapha (SZMAT)"
  },
  {
   value: "Mbabane (SZQMN)",
   label: "Mbabane (SZQMN)"
  },
  {
   value: "Grand Turk Island (TCGDT)",
   label: "Grand Turk Island (TCGDT)"
  },
  {
   value: "Middle Caicos (TCMDS)",
   label: "Middle Caicos (TCMDS)"
  },
  {
   value: "North Caicos (TCNCA)",
   label: "North Caicos (TCNCA)"
  },
  {
   value: "Pine Cay (TCPIC)",
   label: "Pine Cay (TCPIC)"
  },
  {
   value: "Providenciales (TCPLS)",
   label: "Providenciales (TCPLS)"
  },
  {
   value: "Salt Cay (TCSLX)",
   label: "Salt Cay (TCSLX)"
  },
  {
   value: "South Caicos (TCXSC)",
   label: "South Caicos (TCXSC)"
  },
  {
   value: "Abecher (TDAEH)",
   label: "Abecher (TDAEH)"
  },
  {
   value: "Ati (TDATV)",
   label: "Ati (TDATV)"
  },
  {
   value: "Bol (TDOTC)",
   label: "Bol (TDOTC)"
  },
  {
   value: "Bongor (TDOGR)",
   label: "Bongor (TDOGR)"
  },
  {
   value: "Gadang-Haddad-Dandi (TDGHD)",
   label: "Gadang-Haddad-Dandi (TDGHD)"
  },
  {
   value: "Melfi (TDMEF)",
   label: "Melfi (TDMEF)"
  },
  {
   value: "Mongo (TDMVO)",
   label: "Mongo (TDMVO)"
  },
  {
   value: "Moundou (TDMQQ)",
   label: "Moundou (TDMQQ)"
  },
  {
   value: "N'djamena (TDNDJ)",
   label: "N'djamena (TDNDJ)"
  },
  {
   value: "Sarh (TDSRH)",
   label: "Sarh (TDSRH)"
  },
  {
   value: "Anecho (TGANE)",
   label: "Anecho (TGANE)"
  },
  {
   value: "Kpeme (TGKPE)",
   label: "Kpeme (TGKPE)"
  },
  {
   value: "Lome (TGLFW)",
   label: "Lome (TGLFW)"
  },
  {
   value: "Amnat Charoen (THCAN)",
   label: "Amnat Charoen (THCAN)"
  },
  {
   value: "Aranyaprathet (THARA)",
   label: "Aranyaprathet (THARA)"
  },
  {
   value: "Ban Kantang (THBNK)",
   label: "Ban Kantang (THBNK)"
  },
  {
   value: "Ban Tajua Pa (THBTP)",
   label: "Ban Tajua Pa (THBTP)"
  },
  {
   value: "Bandon (THBND)",
   label: "Bandon (THBND)"
  },
  {
   value: "Bangkok (THBKK)",
   label: "Bangkok (THBKK)"
  },
  {
   value: "Nieuw Nickerie (SRICK)",
   label: "Nieuw Nickerie (SRICK)"
  },
  {
   value: "Paramaribo (SRPBM)",
   label: "Paramaribo (SRPBM)"
  },
  {
   value: "Paranam (SRPRM)",
   label: "Paranam (SRPRM)"
  },
  {
   value: "Smalkalden (SRSMA)",
   label: "Smalkalden (SRSMA)"
  },
  {
   value: "Stoelmans Eiland (SRSMZ)",
   label: "Stoelmans Eiland (SRSMZ)"
  },
  {
   value: "Wageningen (SRAGI)",
   label: "Wageningen (SRAGI)"
  },
  {
   value: "Angolares (STANG)",
   label: "Angolares (STANG)"
  },
  {
   value: "Bissao (STBSO)",
   label: "Bissao (STBSO)"
  },
  {
   value: "Bolama (STBOZ)",
   label: "Bolama (STBOZ)"
  },
  {
   value: "Guadalupe (STGUA)",
   label: "Guadalupe (STGUA)"
  },
  {
   value: "Madalena (STMAD)",
   label: "Madalena (STMAD)"
  },
  {
   value: "Neves (STNEV)",
   label: "Neves (STNEV)"
  },
  {
   value: "Principe (STPCP)",
   label: "Principe (STPCP)"
  },
  {
   value: "Ribeira Afonso (STRIA)",
   label: "Ribeira Afonso (STRIA)"
  },
  {
   value: "Santana (STSTA)",
   label: "Santana (STSTA)"
  },
  {
   value: "Santo Amaro (STSAM)",
   label: "Santo Amaro (STSAM)"
  },
  {
   value: "Santo Antonio (STSAA)",
   label: "Santo Antonio (STSAA)"
  },
  {
   value: "Sao Tome Island (STTMS)",
   label: "Sao Tome Island (STTMS)"
  },
  {
   value: "Stormskaer (STSOK)",
   label: "Stormskaer (STSOK)"
  },
  {
   value: "Trindade (STTRI)",
   label: "Trindade (STTRI)"
  },
  {
   value: "Acajutla (SVAQJ)",
   label: "Acajutla (SVAQJ)"
  },
  {
   value: "Bani (SVBAN)",
   label: "Bani (SVBAN)"
  },
  {
   value: "Barahona (SVBAR)",
   label: "Barahona (SVBAR)"
  },
  {
   value: "Boca Chica (SVBCH)",
   label: "Boca Chica (SVBCH)"
  },
  {
   value: "Cabo Jojo (SVCJO)",
   label: "Cabo Jojo (SVCJO)"
  },
  {
   value: "Haina (SVHAI)",
   label: "Haina (SVHAI)"
  },
  {
   value: "La Libertad (SVLLD)",
   label: "La Libertad (SVLLD)"
  },
  {
   value: "La Romana (SVLRO)",
   label: "La Romana (SVLRO)"
  },
  {
   value: "La Union (SVLUN)",
   label: "La Union (SVLUN)"
  },
  {
   value: "Manzanillo (SVMAN)",
   label: "Manzanillo (SVMAN)"
  },
  {
   value: "Metapan (SVMET)",
   label: "Metapan (SVMET)"
  },
  {
   value: "Palenque (SVPAL)",
   label: "Palenque (SVPAL)"
  },
  {
   value: "Puerto Viejo De Azua (SVPVA)",
   label: "Puerto Viejo De Azua (SVPVA)"
  },
  {
   value: "Sabana (SVSAB)",
   label: "Sabana (SVSAB)"
  },
  {
   value: "San Pedro De Marcoris (SVSPM)",
   label: "San Pedro De Marcoris (SVSPM)"
  },
  {
   value: "San Salvador (SVSAL)",
   label: "San Salvador (SVSAL)"
  },
  {
   value: "Sanchez (SVSCH)",
   label: "Sanchez (SVSCH)"
  },
  {
   value: "Santa Ana (SVSTA)",
   label: "Santa Ana (SVSTA)"
  },
  {
   value: "Santo Domingo (SVSDO)",
   label: "Santo Domingo (SVSDO)"
  },
  {
   value: "Santo Tomas De Castilla (SVSCI)",
   label: "Santo Tomas De Castilla (SVSCI)"
  },
  {
   value: "Vysne Nemecke (SKVYN)",
   label: "Vysne Nemecke (SKVYN)"
  },
  {
   value: "Vysny Komarnik (SKVSK)",
   label: "Vysny Komarnik (SKVSK)"
  },
  {
   value: "Zilina (SKILZ)",
   label: "Zilina (SKILZ)"
  },
  {
   value: "Novaky (SKNKY)",
   label: "Novaky (SKNKY)"
  },
  {
   value: "Topol'cany (SKTCY)",
   label: "Topol'cany (SKTCY)"
  },
  {
   value: "Bo (SLKBS)",
   label: "Bo (SLKBS)"
  },
  {
   value: "Bonthe (SLBTE)",
   label: "Bonthe (SLBTE)"
  },
  {
   value: "Freetown (SLFNA)",
   label: "Freetown (SLFNA)"
  },
  {
   value: "Gbangbatok (SLGBK)",
   label: "Gbangbatok (SLGBK)"
  },
  {
   value: "Hastings Apt\/Freetown (SLHGS)",
   label: "Hastings Apt\/Freetown (SLHGS)"
  },
  {
   value: "Kenema (SLKEN)",
   label: "Kenema (SLKEN)"
  },
  {
   value: "Muta (SLMUT)",
   label: "Muta (SLMUT)"
  },
  {
   value: "Nitti (SLNIT)",
   label: "Nitti (SLNIT)"
  },
  {
   value: "Pepel (SLPEP)",
   label: "Pepel (SLPEP)"
  },
  {
   value: "Sherbro (SLSBO)",
   label: "Sherbro (SLSBO)"
  },
  {
   value: "San Marino (SMSAI)",
   label: "San Marino (SMSAI)"
  },
  {
   value: "Bakel (SNBXE)",
   label: "Bakel (SNBXE)"
  },
  {
   value: "Cap Skirring (SNCSK)",
   label: "Cap Skirring (SNCSK)"
  },
  {
   value: "Dakar (SNDKR)",
   label: "Dakar (SNDKR)"
  },
  {
   value: "Foundiougne (SNFOU)",
   label: "Foundiougne (SNFOU)"
  },
  {
   value: "Kaolack (SNKLC)",
   label: "Kaolack (SNKLC)"
  },
  {
   value: "Kedougou (SNKGG)",
   label: "Kedougou (SNKGG)"
  },
  {
   value: "Lyndiane (SNLYN)",
   label: "Lyndiane (SNLYN)"
  },
  {
   value: "M'bao Terminal (SNMBA)",
   label: "M'bao Terminal (SNMBA)"
  },
  {
   value: "Matam (SNMAX)",
   label: "Matam (SNMAX)"
  },
  {
   value: "Richard Toll (SNRDT)",
   label: "Richard Toll (SNRDT)"
  },
  {
   value: "Simenti (SNSMY)",
   label: "Simenti (SNSMY)"
  },
  {
   value: "St Louis (SNXLS)",
   label: "St Louis (SNXLS)"
  },
  {
   value: "Tambacounda (SNTUD)",
   label: "Tambacounda (SNTUD)"
  },
  {
   value: "Ziguinchor (SNZIG)",
   label: "Ziguinchor (SNZIG)"
  },
  {
   value: "Alula (SOALU)",
   label: "Alula (SOALU)"
  },
  {
   value: "Berbera (SOBBO)",
   label: "Berbera (SOBBO)"
  },
  {
   value: "Bossaso (SOBSA)",
   label: "Bossaso (SOBSA)"
  },
  {
   value: "Burao (SOBUO)",
   label: "Burao (SOBUO)"
  },
  {
   value: "Dante (Ras Hafun) (SODAN)",
   label: "Dante (Ras Hafun) (SODAN)"
  },
  {
   value: "Gardo (SOGSR)",
   label: "Gardo (SOGSR)"
  },
  {
   value: "Hargeisa (SOHGA)",
   label: "Hargeisa (SOHGA)"
  },
  {
   value: "Kismayu (SOKMU)",
   label: "Kismayu (SOKMU)"
  },
  {
   value: "Merca (SOMER)",
   label: "Merca (SOMER)"
  },
  {
   value: "Mogadishu (SOMGQ)",
   label: "Mogadishu (SOMGQ)"
  },
  {
   value: "Albina (SRABN)",
   label: "Albina (SRABN)"
  },
  {
   value: "Moengo (SRMOJ)",
   label: "Moengo (SRMOJ)"
  },
  {
   value: "Medvedov (SKMED)",
   label: "Medvedov (SKMED)"
  },
  {
   value: "Milhost (SKMIL)",
   label: "Milhost (SKMIL)"
  },
  {
   value: "Mnisek nad Popradom (SKMPA)",
   label: "Mnisek nad Popradom (SKMPA)"
  },
  {
   value: "Moravske Lieskové (SKMOL)",
   label: "Moravske Lieskové (SKMOL)"
  },
  {
   value: "Moravsky Svaty Jan (SKMSJ)",
   label: "Moravsky Svaty Jan (SKMSJ)"
  },
  {
   value: "Myjava (SKMYJ)",
   label: "Myjava (SKMYJ)"
  },
  {
   value: "Myjava-Vrbovce (SKMYV)",
   label: "Myjava-Vrbovce (SKMYV)"
  },
  {
   value: "Nitra (SKNRA)",
   label: "Nitra (SKNRA)"
  },
  {
   value: "Nova Bosaca (SKNOB)",
   label: "Nova Bosaca (SKNOB)"
  },
  {
   value: "Nove Zamky (SKNOV)",
   label: "Nove Zamky (SKNOV)"
  },
  {
   value: "Oravska Polhora (SKORP)",
   label: "Oravska Polhora (SKORP)"
  },
  {
   value: "Palota (SKPAL)",
   label: "Palota (SKPAL)"
  },
  {
   value: "Piestany (SKPZY)",
   label: "Piestany (SKPZY)"
  },
  {
   value: "Plavec (SKPLA)",
   label: "Plavec (SKPLA)"
  },
  {
   value: "Podspady (SKPOD)",
   label: "Podspady (SKPOD)"
  },
  {
   value: "Podzavoz (Milosova) (SKPOM)",
   label: "Podzavoz (Milosova) (SKPOM)"
  },
  {
   value: "Puchov (SKPCV)",
   label: "Puchov (SKPCV)"
  },
  {
   value: "Revuca (SKREV)",
   label: "Revuca (SKREV)"
  },
  {
   value: "Rusovce\/Bratislava (SKRSV)",
   label: "Rusovce\/Bratislava (SKRSV)"
  },
  {
   value: "Sahy (SKSHA)",
   label: "Sahy (SKSHA)"
  },
  {
   value: "Salka (SKSAL)",
   label: "Salka (SKSAL)"
  },
  {
   value: "Siatorska Bukovinka (SKSIB)",
   label: "Siatorska Bukovinka (SKSIB)"
  },
  {
   value: "Skalica (SKSKA)",
   label: "Skalica (SKSKA)"
  },
  {
   value: "Skalité (SKSKE)",
   label: "Skalité (SKSKE)"
  },
  {
   value: "Skalité-Zwardon (SKSKZ)",
   label: "Skalité-Zwardon (SKSKZ)"
  },
  {
   value: "Sliac (SKSLD)",
   label: "Sliac (SKSLD)"
  },
  {
   value: "Slovenske Darmoty (SKSDA)",
   label: "Slovenske Darmoty (SKSDA)"
  },
  {
   value: "Slovenské Nové Mesto (SKSSA)",
   label: "Slovenské Nové Mesto (SKSSA)"
  },
  {
   value: "Spisska Nova Ves (SKSNV)",
   label: "Spisska Nova Ves (SKSNV)"
  },
  {
   value: "Srvcinovec (SKSVR)",
   label: "Srvcinovec (SKSVR)"
  },
  {
   value: "Stropkov (SKSPV)",
   label: "Stropkov (SKSPV)"
  },
  {
   value: "Sturovo (SKSRA)",
   label: "Sturovo (SKSRA)"
  },
  {
   value: "Sucha Hora (SKSUH)",
   label: "Sucha Hora (SKSUH)"
  },
  {
   value: "Svit (SKSVT)",
   label: "Svit (SKSVT)"
  },
  {
   value: "Tatry\/Poprad (SKTAT)",
   label: "Tatry\/Poprad (SKTAT)"
  },
  {
   value: "Trancianska Tapla (SKTRT)",
   label: "Trancianska Tapla (SKTRT)"
  },
  {
   value: "Trstena (SKTSA)",
   label: "Trstena (SKTSA)"
  },
  {
   value: "Ubla (SKUBL)",
   label: "Ubla (SKUBL)"
  },
  {
   value: "\"Vefky Kamenec (SKVEK)",
   label: "\"Vefky Kamenec (SKVEK)"
  },
  {
   value: "Vrable (SKVBE)",
   label: "Vrable (SKVBE)"
  },
  {
   value: "Ny Ålesund (SJNYA)",
   label: "Ny Ålesund (SJNYA)"
  },
  {
   value: "Sveagruva (SJSVE)",
   label: "Sveagruva (SJSVE)"
  },
  {
   value: "Banska Bystrica (SKBBY)",
   label: "Banska Bystrica (SKBBY)"
  },
  {
   value: "Becherov (SKBEC)",
   label: "Becherov (SKBEC)"
  },
  {
   value: "Bratislava (SKBTS)",
   label: "Bratislava (SKBTS)"
  },
  {
   value: "Bratislava Port (SKBAB)",
   label: "Bratislava Port (SKBAB)"
  },
  {
   value: "Bratislava-Devinska Nova Ves (SKBAA)",
   label: "Bratislava-Devinska Nova Ves (SKBAA)"
  },
  {
   value: "Bratislava-Petrzalka (SKBRP)",
   label: "Bratislava-Petrzalka (SKBRP)"
  },
  {
   value: "Brodské (SKBRO)",
   label: "Brodské (SKBRO)"
  },
  {
   value: "Cadca (SKCAD)",
   label: "Cadca (SKCAD)"
  },
  {
   value: "Cana (SKCAN)",
   label: "Cana (SKCAN)"
  },
  {
   value: "Cerveny Kamen (SKCEK)",
   label: "Cerveny Kamen (SKCEK)"
  },
  {
   value: "Cierna nad Tisou (SKCNT)",
   label: "Cierna nad Tisou (SKCNT)"
  },
  {
   value: "Domica (SKDOM)",
   label: "Domica (SKDOM)"
  },
  {
   value: "Drietoma (SKDRI)",
   label: "Drietoma (SKDRI)"
  },
  {
   value: "Dunajske Streda (SKDJA)",
   label: "Dunajske Streda (SKDJA)"
  },
  {
   value: "Filakovo (SKFIA)",
   label: "Filakovo (SKFIA)"
  },
  {
   value: "Holic (SKHOL)",
   label: "Holic (SKHOL)"
  },
  {
   value: "Horné Srnie \/ HOSTOVCE (SKHOS)",
   label: "Horné Srnie \/ HOSTOVCE (SKHOS)"
  },
  {
   value: "Hranicna P.H. (SKHHA)",
   label: "Hranicna P.H. (SKHHA)"
  },
  {
   value: "Hricov (SKHRI)",
   label: "Hricov (SKHRI)"
  },
  {
   value: "Jarovce (SKJAR)",
   label: "Jarovce (SKJAR)"
  },
  {
   value: "\"Javorina (SKJAV)",
   label: "\"Javorina (SKJAV)"
  },
  {
   value: "Kalonda (SKKAL)",
   label: "Kalonda (SKKAL)"
  },
  {
   value: "Klokocov (SKKLO)",
   label: "Klokocov (SKKLO)"
  },
  {
   value: "Komarno (SKKNA)",
   label: "Komarno (SKKNA)"
  },
  {
   value: "Komarno Port (SKKNP)",
   label: "Komarno Port (SKKNP)"
  },
  {
   value: "Kosice-letisko (SKKSC)",
   label: "Kosice-letisko (SKKSC)"
  },
  {
   value: "Kral (SKKRA)",
   label: "Kral (SKKRA)"
  },
  {
   value: "Kuty (SKKUT)",
   label: "Kuty (SKKUT)"
  },
  {
   value: "Lenartovce (SKLEN)",
   label: "Lenartovce (SKLEN)"
  },
  {
   value: "Liptovsky Mikulas (SKLIM)",
   label: "Liptovsky Mikulas (SKLIM)"
  },
  {
   value: "Lucenec (SKLUE)",
   label: "Lucenec (SKLUE)"
  },
  {
   value: "Luky p Makytou-Horni Lidéc (SKLMH)",
   label: "Luky p Makytou-Horni Lidéc (SKLMH)"
  },
  {
   value: "Lysa nad Dunajcom (SKLYD)",
   label: "Lysa nad Dunajcom (SKLYD)"
  },
  {
   value: "Lysa pod Makytou-Strelna (SKLMS)",
   label: "Lysa pod Makytou-Strelna (SKLMS)"
  },
  {
   value: "Makov-Horni Becva (SKMHB)",
   label: "Makov-Horni Becva (SKMHB)"
  },
  {
   value: "Martin (SKMRT)",
   label: "Martin (SKMRT)"
  },
  {
   value: "Matovské Vojkovské (SKMVA)",
   label: "Matovské Vojkovské (SKMVA)"
  },
  {
   value: "Vittsjo (SEVSJ)",
   label: "Vittsjo (SEVSJ)"
  },
  {
   value: "Vivstavarv (SEVIV)",
   label: "Vivstavarv (SEVIV)"
  },
  {
   value: "Wallhamn (SEWAL)",
   label: "Wallhamn (SEWAL)"
  },
  {
   value: "Ystad (SEYST)",
   label: "Ystad (SEYST)"
  },
  {
   value: "Jurong (SGJUR)",
   label: "Jurong (SGJUR)"
  },
  {
   value: "Keppel Wharves (SGKEP)",
   label: "Keppel Wharves (SGKEP)"
  },
  {
   value: "Pasir Panjan Wharves (SGPAP)",
   label: "Pasir Panjan Wharves (SGPAP)"
  },
  {
   value: "Pulan Ayer Chawan (SGAYC)",
   label: "Pulan Ayer Chawan (SGAYC)"
  },
  {
   value: "Pulau Bukom (SGPUB)",
   label: "Pulau Bukom (SGPUB)"
  },
  {
   value: "Pulau Sebarok (SGSEB)",
   label: "Pulau Sebarok (SGSEB)"
  },
  {
   value: "Seletar (SGSLT)",
   label: "Seletar (SGSLT)"
  },
  {
   value: "Sembawang Port (SGSEM)",
   label: "Sembawang Port (SGSEM)"
  },
  {
   value: "Singapore (SGSIN)",
   label: "Singapore (SGSIN)"
  },
  {
   value: "Singapore Container Terminal (SGSCT)",
   label: "Singapore Container Terminal (SGSCT)"
  },
  {
   value: "Tanjong Pagar (SGTPG)",
   label: "Tanjong Pagar (SGTPG)"
  },
  {
   value: "Tanjong Penjuru (SGTPN)",
   label: "Tanjong Penjuru (SGTPN)"
  },
  {
   value: "Telok Ayer Basin (SGTAY)",
   label: "Telok Ayer Basin (SGTAY)"
  },
  {
   value: "Woodlands (SGWDL)",
   label: "Woodlands (SGWDL)"
  },
  {
   value: "Ascencion (SHASC)",
   label: "Ascencion (SHASC)"
  },
  {
   value: "Georgetown (SHASI)",
   label: "Georgetown (SHASI)"
  },
  {
   value: "Jamestown (SHSHN)",
   label: "Jamestown (SHSHN)"
  },
  {
   value: "Tristan da Cunha (SHTDC)",
   label: "Tristan da Cunha (SHTDC)"
  },
  {
   value: "Anhovo (SIANH)",
   label: "Anhovo (SIANH)"
  },
  {
   value: "Bovec (SIBVC)",
   label: "Bovec (SIBVC)"
  },
  {
   value: "Domzale (SIDZE)",
   label: "Domzale (SIDZE)"
  },
  {
   value: "Izola (SIIZO)",
   label: "Izola (SIIZO)"
  },
  {
   value: "Kamnik (SIKNK)",
   label: "Kamnik (SIKNK)"
  },
  {
   value: "Kocevje (SIKCV)",
   label: "Kocevje (SIKCV)"
  },
  {
   value: "Koper (SIKOP)",
   label: "Koper (SIKOP)"
  },
  {
   value: "Kranj (SIKRJ)",
   label: "Kranj (SIKRJ)"
  },
  {
   value: "Ljubljana (SILJU)",
   label: "Ljubljana (SILJU)"
  },
  {
   value: "Ljuztomer (SILJR)",
   label: "Ljuztomer (SILJR)"
  },
  {
   value: "Maribor (SIMBX)",
   label: "Maribor (SIMBX)"
  },
  {
   value: "Piran (SIPIR)",
   label: "Piran (SIPIR)"
  },
  {
   value: "Portoroz (SIPOW)",
   label: "Portoroz (SIPOW)"
  },
  {
   value: "Rogaska Slatina (SIRSA)",
   label: "Rogaska Slatina (SIRSA)"
  },
  {
   value: "Velenje (SIVEL)",
   label: "Velenje (SIVEL)"
  },
  {
   value: "Zalec (SIZAL)",
   label: "Zalec (SIZAL)"
  },
  {
   value: "Barentsburg (SJBAR)",
   label: "Barentsburg (SJBAR)"
  },
  {
   value: "Longyearbyen (SJLYR)",
   label: "Longyearbyen (SJLYR)"
  },
  {
   value: "Tyngsjo (SETYN)",
   label: "Tyngsjo (SETYN)"
  },
  {
   value: "Tyresö (SETYS)",
   label: "Tyresö (SETYS)"
  },
  {
   value: "Uddevalla (SEUDD)",
   label: "Uddevalla (SEUDD)"
  },
  {
   value: "Ugglarp (SEUGG)",
   label: "Ugglarp (SEUGG)"
  },
  {
   value: "Ulebergshamn (SEUGN)",
   label: "Ulebergshamn (SEUGN)"
  },
  {
   value: "Ulfvik (SEULF)",
   label: "Ulfvik (SEULF)"
  },
  {
   value: "Ullared (SEULD)",
   label: "Ullared (SEULD)"
  },
  {
   value: "Ulricehamn (SEULR)",
   label: "Ulricehamn (SEULR)"
  },
  {
   value: "Umeå (SEUME)",
   label: "Umeå (SEUME)"
  },
  {
   value: "Unnaryd (SEURD)",
   label: "Unnaryd (SEURD)"
  },
  {
   value: "Upplands Väsby (SEUPL)",
   label: "Upplands Väsby (SEUPL)"
  },
  {
   value: "Uppsala (SEUPP)",
   label: "Uppsala (SEUPP)"
  },
  {
   value: "Ursviken (SEURS)",
   label: "Ursviken (SEURS)"
  },
  {
   value: "Utansjö (SEUTA)",
   label: "Utansjö (SEUTA)"
  },
  {
   value: "Väderstad (SEVDS)",
   label: "Väderstad (SEVDS)"
  },
  {
   value: "Vaggeryd (SEVGD)",
   label: "Vaggeryd (SEVGD)"
  },
  {
   value: "Väja (SEVAJ)",
   label: "Väja (SEVAJ)"
  },
  {
   value: "Vålberg (SEVAA)",
   label: "Vålberg (SEVAA)"
  },
  {
   value: "Valbo (SEVLB)",
   label: "Valbo (SEVLB)"
  },
  {
   value: "Valdemarsvik (SEVAK)",
   label: "Valdemarsvik (SEVAK)"
  },
  {
   value: "Vallvik (SEVAL)",
   label: "Vallvik (SEVAL)"
  },
  {
   value: "Vänersborg (SEVAN)",
   label: "Vänersborg (SEVAN)"
  },
  {
   value: "Vara (SEVAX)",
   label: "Vara (SEVAX)"
  },
  {
   value: "Varberg (SEVAG)",
   label: "Varberg (SEVAG)"
  },
  {
   value: "Vårgårda (SEVRG)",
   label: "Vårgårda (SEVRG)"
  },
  {
   value: "Vargön (SEVGN)",
   label: "Vargön (SEVGN)"
  },
  {
   value: "Värnamo (SEVAR)",
   label: "Värnamo (SEVAR)"
  },
  {
   value: "Västerås (SEVST)",
   label: "Västerås (SEVST)"
  },
  {
   value: "Västervik (SEVVK)",
   label: "Västervik (SEVVK)"
  },
  {
   value: "Västra Frölunda\/Göteborg (SEVFA)",
   label: "Västra Frölunda\/Göteborg (SEVFA)"
  },
  {
   value: "Vaxholm (SEVHM)",
   label: "Vaxholm (SEVHM)"
  },
  {
   value: "Växjö (SEVXO)",
   label: "Växjö (SEVXO)"
  },
  {
   value: "Våxtorp (SEVXT)",
   label: "Våxtorp (SEVXT)"
  },
  {
   value: "Verkebäck (SEVER)",
   label: "Verkebäck (SEVER)"
  },
  {
   value: "Vetlanda (SEVTL)",
   label: "Vetlanda (SEVTL)"
  },
  {
   value: "Vimmerby (SEVIM)",
   label: "Vimmerby (SEVIM)"
  },
  {
   value: "Vindeln (SEVIN)",
   label: "Vindeln (SEVIN)"
  },
  {
   value: "Vinslöv (SEVIS)",
   label: "Vinslöv (SEVIS)"
  },
  {
   value: "Visby (SEVBY)",
   label: "Visby (SEVBY)"
  },
  {
   value: "Viskafors (SEVKF)",
   label: "Viskafors (SEVKF)"
  },
  {
   value: "Vislanda (SEVLN)",
   label: "Vislanda (SEVLN)"
  },
  {
   value: "Vittaryd (SEVIT)",
   label: "Vittaryd (SEVIT)"
  },
  {
   value: "Stugsund (SESTU)",
   label: "Stugsund (SESTU)"
  },
  {
   value: "Sund (SESUN)",
   label: "Sund (SESUN)"
  },
  {
   value: "Sundbyberg (SESUG)",
   label: "Sundbyberg (SESUG)"
  },
  {
   value: "Sundsvall (SESDL)",
   label: "Sundsvall (SESDL)"
  },
  {
   value: "Surahammar (SESUH)",
   label: "Surahammar (SESUH)"
  },
  {
   value: "Surte (SESUR)",
   label: "Surte (SESUR)"
  },
  {
   value: "Svanö (SESVX)",
   label: "Svanö (SESVX)"
  },
  {
   value: "Svärdsjö (SESVO)",
   label: "Svärdsjö (SESVO)"
  },
  {
   value: "Svartvik (SESVK)",
   label: "Svartvik (SESVK)"
  },
  {
   value: "Svedala (SESEA)",
   label: "Svedala (SESEA)"
  },
  {
   value: "Sveg (SEEVG)",
   label: "Sveg (SEEVG)"
  },
  {
   value: "Täby (SETBY)",
   label: "Täby (SETBY)"
  },
  {
   value: "Tanumshede (SETAN)",
   label: "Tanumshede (SETAN)"
  },
  {
   value: "Tenhult (SETNH)",
   label: "Tenhult (SETNH)"
  },
  {
   value: "Tibro (SETIB)",
   label: "Tibro (SETIB)"
  },
  {
   value: "Tidaholm (SETID)",
   label: "Tidaholm (SETID)"
  },
  {
   value: "Timrå (SETIM)",
   label: "Timrå (SETIM)"
  },
  {
   value: "Tingsryd (SETIN)",
   label: "Tingsryd (SETIN)"
  },
  {
   value: "Tjörnarp (SETJP)",
   label: "Tjörnarp (SETJP)"
  },
  {
   value: "Töcksfors (SETKF)",
   label: "Töcksfors (SETKF)"
  },
  {
   value: "Tollarp (SETLL)",
   label: "Tollarp (SETLL)"
  },
  {
   value: "Tomelilla (SETOM)",
   label: "Tomelilla (SETOM)"
  },
  {
   value: "Töre (SETOE)",
   label: "Töre (SETOE)"
  },
  {
   value: "Töreboda (SETOB)",
   label: "Töreboda (SETOB)"
  },
  {
   value: "Torekov (SETOV)",
   label: "Torekov (SETOV)"
  },
  {
   value: "Torsås (SETOR)",
   label: "Torsås (SETOR)"
  },
  {
   value: "Torsby (SETYF)",
   label: "Torsby (SETYF)"
  },
  {
   value: "Torshälla (SETOA)",
   label: "Torshälla (SETOA)"
  },
  {
   value: "Torslanda (SETRL)",
   label: "Torslanda (SETRL)"
  },
  {
   value: "Torsvik (SETVK)",
   label: "Torsvik (SETVK)"
  },
  {
   value: "Tranås (SETNS)",
   label: "Tranås (SETNS)"
  },
  {
   value: "Tranemo (SETAO)",
   label: "Tranemo (SETAO)"
  },
  {
   value: "Trångsviken (SETRA)",
   label: "Trångsviken (SETRA)"
  },
  {
   value: "Traryd (SETRD)",
   label: "Traryd (SETRD)"
  },
  {
   value: "Tråvad (SETRR)",
   label: "Tråvad (SETRR)"
  },
  {
   value: "Trelleborg (SETRG)",
   label: "Trelleborg (SETRG)"
  },
  {
   value: "Trollhättan (SETHN)",
   label: "Trollhättan (SETHN)"
  },
  {
   value: "Trosa (SETRS)",
   label: "Trosa (SETRS)"
  },
  {
   value: "Tumba (SETUM)",
   label: "Tumba (SETUM)"
  },
  {
   value: "Tunadal (SETUN)",
   label: "Tunadal (SETUN)"
  },
  {
   value: "Tungelsta (SETUL)",
   label: "Tungelsta (SETUL)"
  },
  {
   value: "Tygelsjö (SETYG)",
   label: "Tygelsjö (SETYG)"
  },
  {
   value: "Skene (SESKZ)",
   label: "Skene (SESKZ)"
  },
  {
   value: "Skogås (SESGZ)",
   label: "Skogås (SESGZ)"
  },
  {
   value: "Skoghall (SESKO)",
   label: "Skoghall (SESKO)"
  },
  {
   value: "Skönvik (SESKK)",
   label: "Skönvik (SESKK)"
  },
  {
   value: "Skövde (SESKV)",
   label: "Skövde (SESKV)"
  },
  {
   value: "Skredsvik (SESKR)",
   label: "Skredsvik (SESKR)"
  },
  {
   value: "Skultuna (SESTZ)",
   label: "Skultuna (SESTZ)"
  },
  {
   value: "Skurup (SESKU)",
   label: "Skurup (SESKU)"
  },
  {
   value: "Skuthamn (SESKN)",
   label: "Skuthamn (SESKN)"
  },
  {
   value: "Skutskär (SESSR)",
   label: "Skutskär (SESSR)"
  },
  {
   value: "Slite (SESLI)",
   label: "Slite (SESLI)"
  },
  {
   value: "Smålandsstenar (SESMA)",
   label: "Smålandsstenar (SESMA)"
  },
  {
   value: "Smedjebacken (SESME)",
   label: "Smedjebacken (SESME)"
  },
  {
   value: "Smögen (SESMO)",
   label: "Smögen (SESMO)"
  },
  {
   value: "Söderfors (SESDR)",
   label: "Söderfors (SESDR)"
  },
  {
   value: "Söderhamn (SESOO)",
   label: "Söderhamn (SESOO)"
  },
  {
   value: "Söderköping (SESOG)",
   label: "Söderköping (SESOG)"
  },
  {
   value: "Södertälje (SESOE)",
   label: "Södertälje (SESOE)"
  },
  {
   value: "Sollefteå (SESLF)",
   label: "Sollefteå (SESLF)"
  },
  {
   value: "Sollentuna (SESOA)",
   label: "Sollentuna (SESOA)"
  },
  {
   value: "Solna (SESLN)",
   label: "Solna (SESLN)"
  },
  {
   value: "Sölvesborg (SESOL)",
   label: "Sölvesborg (SESOL)"
  },
  {
   value: "Söråker (SESOR)",
   label: "Söråker (SESOR)"
  },
  {
   value: "Sösdala (SESSL)",
   label: "Sösdala (SESSL)"
  },
  {
   value: "Spånga (SESPA)",
   label: "Spånga (SESPA)"
  },
  {
   value: "Språngsviken (SESPR)",
   label: "Språngsviken (SESPR)"
  },
  {
   value: "Staffanstorp (SESTP)",
   label: "Staffanstorp (SESTP)"
  },
  {
   value: "Ställdalen (SESTD)",
   label: "Ställdalen (SESTD)"
  },
  {
   value: "Stensjö (SESSO)",
   label: "Stensjö (SESSO)"
  },
  {
   value: "Stenungsund (SESTE)",
   label: "Stenungsund (SESTE)"
  },
  {
   value: "Stocka (SESTA)",
   label: "Stocka (SESTA)"
  },
  {
   value: "Stockholm (SESTO)",
   label: "Stockholm (SESTO)"
  },
  {
   value: "Stocksund (SESUD)",
   label: "Stocksund (SESUD)"
  },
  {
   value: "Stockvik (SESTK)",
   label: "Stockvik (SESTK)"
  },
  {
   value: "Stora Vika (SESTV)",
   label: "Stora Vika (SESTV)"
  },
  {
   value: "Storlien (SESTN)",
   label: "Storlien (SESTN)"
  },
  {
   value: "Storugns (SESUS)",
   label: "Storugns (SESUS)"
  },
  {
   value: "Storvik (SESOK)",
   label: "Storvik (SESOK)"
  },
  {
   value: "Strängnäs (SESTQ)",
   label: "Strängnäs (SESTQ)"
  },
  {
   value: "Strömnäs (SESTS)",
   label: "Strömnäs (SESTS)"
  },
  {
   value: "Strömstad (SESMD)",
   label: "Strömstad (SESMD)"
  },
  {
   value: "Reftele (SEREP)",
   label: "Reftele (SEREP)"
  },
  {
   value: "Rone (SEROE)",
   label: "Rone (SEROE)"
  },
  {
   value: "Ronehamn (SERNH)",
   label: "Ronehamn (SERNH)"
  },
  {
   value: "Rönnang (SERNG)",
   label: "Rönnang (SERNG)"
  },
  {
   value: "Ronneby (SERNB)",
   label: "Ronneby (SERNB)"
  },
  {
   value: "Ronnebyhamn (SERBY)",
   label: "Ronnebyhamn (SERBY)"
  },
  {
   value: "Rönnskär (SEROR)",
   label: "Rönnskär (SEROR)"
  },
  {
   value: "Rönnskärsverken (SEROV)",
   label: "Rönnskärsverken (SEROV)"
  },
  {
   value: "Rosersberg (SEROS)",
   label: "Rosersberg (SEROS)"
  },
  {
   value: "Rotebro (SEROT)",
   label: "Rotebro (SEROT)"
  },
  {
   value: "Rundvik (SERUV)",
   label: "Rundvik (SERUV)"
  },
  {
   value: "Runsten (SERUN)",
   label: "Runsten (SERUN)"
  },
  {
   value: "Ryd (SERYZ)",
   label: "Ryd (SERYZ)"
  },
  {
   value: "Rydsgård (SERYD)",
   label: "Rydsgård (SERYD)"
  },
  {
   value: "Säffle (SESAF)",
   label: "Säffle (SESAF)"
  },
  {
   value: "Sala (SESAL)",
   label: "Sala (SESAL)"
  },
  {
   value: "Salmis (SESMS)",
   label: "Salmis (SESMS)"
  },
  {
   value: "Saltkällan (SESTL)",
   label: "Saltkällan (SESTL)"
  },
  {
   value: "Saltsjö-Boo (SESBB)",
   label: "Saltsjö-Boo (SESBB)"
  },
  {
   value: "Saltsjöbaden (SESBN)",
   label: "Saltsjöbaden (SESBN)"
  },
  {
   value: "Sandarne (SESAE)",
   label: "Sandarne (SESAE)"
  },
  {
   value: "Sandvik (SESAK)",
   label: "Sandvik (SESAK)"
  },
  {
   value: "Sandviken (SESAN)",
   label: "Sandviken (SESAN)"
  },
  {
   value: "Sätra Brunn (SESBV)",
   label: "Sätra Brunn (SESBV)"
  },
  {
   value: "Sävsjö (SESJQ)",
   label: "Sävsjö (SESJQ)"
  },
  {
   value: "Sennan (SESNN)",
   label: "Sennan (SESNN)"
  },
  {
   value: "Seskarö (SESES)",
   label: "Seskarö (SESES)"
  },
  {
   value: "Sigtuna (SESGT)",
   label: "Sigtuna (SESGT)"
  },
  {
   value: "Sikeå (SESIK)",
   label: "Sikeå (SESIK)"
  },
  {
   value: "Silverdalen (SESVD)",
   label: "Silverdalen (SESVD)"
  },
  {
   value: "Simrishamn (SESIM)",
   label: "Simrishamn (SESIM)"
  },
  {
   value: "Sjöbo (SESBO)",
   label: "Sjöbo (SESBO)"
  },
  {
   value: "Skalhamn (SESKL)",
   label: "Skalhamn (SESKL)"
  },
  {
   value: "Skänninge (SESKG)",
   label: "Skänninge (SESKG)"
  },
  {
   value: "Skåpafors (SESKA)",
   label: "Skåpafors (SESKA)"
  },
  {
   value: "Skärblacka (SESKB)",
   label: "Skärblacka (SESKB)"
  },
  {
   value: "Skärhamn (SESKM)",
   label: "Skärhamn (SESKM)"
  },
  {
   value: "Skärholmen\/Stockholm (SESKH)",
   label: "Skärholmen\/Stockholm (SESKH)"
  },
  {
   value: "Skattkärr (SESKT)",
   label: "Skattkärr (SESKT)"
  },
  {
   value: "Skellefteå (SESFT)",
   label: "Skellefteå (SESFT)"
  },
  {
   value: "Skelleftehamn (SESKE)",
   label: "Skelleftehamn (SESKE)"
  },
  {
   value: "Norrköping (SENRK)",
   label: "Norrköping (SENRK)"
  },
  {
   value: "Norrsundet (SENOT)",
   label: "Norrsundet (SENOT)"
  },
  {
   value: "Norrtälje (SENOE)",
   label: "Norrtälje (SENOE)"
  },
  {
   value: "Norsborg (SENRS)",
   label: "Norsborg (SENRS)"
  },
  {
   value: "Nossebro (SENSO)",
   label: "Nossebro (SENSO)"
  },
  {
   value: "Nybro (SENYB)",
   label: "Nybro (SENYB)"
  },
  {
   value: "Nyhamn (SENHN)",
   label: "Nyhamn (SENHN)"
  },
  {
   value: "Nyköping (SENYO)",
   label: "Nyköping (SENYO)"
  },
  {
   value: "Nymölla (SENYM)",
   label: "Nymölla (SENYM)"
  },
  {
   value: "Nynäshamn (SENYN)",
   label: "Nynäshamn (SENYN)"
  },
  {
   value: "Nyvarp (SENYP)",
   label: "Nyvarp (SENYP)"
  },
  {
   value: "Oaxen (SEOAX)",
   label: "Oaxen (SEOAX)"
  },
  {
   value: "Obbola (SEOBB)",
   label: "Obbola (SEOBB)"
  },
  {
   value: "Ockelbo (SEOCK)",
   label: "Ockelbo (SEOCK)"
  },
  {
   value: "Öckerö (SEOCO)",
   label: "Öckerö (SEOCO)"
  },
  {
   value: "Ödeshög (SEODE)",
   label: "Ödeshög (SEODE)"
  },
  {
   value: "Olofström (SEOLO)",
   label: "Olofström (SEOLO)"
  },
  {
   value: "Örebro (SEORB)",
   label: "Örebro (SEORB)"
  },
  {
   value: "Öregrund (SEOGR)",
   label: "Öregrund (SEOGR)"
  },
  {
   value: "Örkelljunga (SEORK)",
   label: "Örkelljunga (SEORK)"
  },
  {
   value: "Örnsköldsvik (SEOER)",
   label: "Örnsköldsvik (SEOER)"
  },
  {
   value: "Orrefors (SEOFS)",
   label: "Orrefors (SEOFS)"
  },
  {
   value: "Orsa (SEORS)",
   label: "Orsa (SEORS)"
  },
  {
   value: "Ortviken (SEORT)",
   label: "Ortviken (SEORT)"
  },
  {
   value: "Orviken (SEORV)",
   label: "Orviken (SEORV)"
  },
  {
   value: "Osby (SEOSB)",
   label: "Osby (SEOSB)"
  },
  {
   value: "Oskarshamn (SEOSK)",
   label: "Oskarshamn (SEOSK)"
  },
  {
   value: "Östersund (SEOSD)",
   label: "Östersund (SEOSD)"
  },
  {
   value: "Östrand (SEOST)",
   label: "Östrand (SEOST)"
  },
  {
   value: "Otterbäcken (SEOTT)",
   label: "Otterbäcken (SEOTT)"
  },
  {
   value: "Överlida (SEOVL)",
   label: "Överlida (SEOVL)"
  },
  {
   value: "Oxelösund (SEOXE)",
   label: "Oxelösund (SEOXE)"
  },
  {
   value: "Pajala (SEPJA)",
   label: "Pajala (SEPJA)"
  },
  {
   value: "Partille (SEPAR)",
   label: "Partille (SEPAR)"
  },
  {
   value: "Påskallavik (SEPAS)",
   label: "Påskallavik (SEPAS)"
  },
  {
   value: "Perstorp (SEPPK)",
   label: "Perstorp (SEPPK)"
  },
  {
   value: "Piteå (SEPIT)",
   label: "Piteå (SEPIT)"
  },
  {
   value: "Råå (SERAA)",
   label: "Råå (SERAA)"
  },
  {
   value: "Ramnäs (SERAN)",
   label: "Ramnäs (SERAN)"
  },
  {
   value: "Ramvik (SERAM)",
   label: "Ramvik (SERAM)"
  },
  {
   value: "Rasta (SERST)",
   label: "Rasta (SERST)"
  },
  {
   value: "Rättvik (SERVK)",
   label: "Rättvik (SERVK)"
  },
  {
   value: "Mantorp (SEMAP)",
   label: "Mantorp (SEMAP)"
  },
  {
   value: "Marieberg (SEMAR)",
   label: "Marieberg (SEMAR)"
  },
  {
   value: "Mariefred (SEMRF)",
   label: "Mariefred (SEMRF)"
  },
  {
   value: "Marieholm (SEMRH)",
   label: "Marieholm (SEMRH)"
  },
  {
   value: "Mariestad (SEMAD)",
   label: "Mariestad (SEMAD)"
  },
  {
   value: "Markaryd (SEMRK)",
   label: "Markaryd (SEMRK)"
  },
  {
   value: "Märsta (SEMST)",
   label: "Märsta (SEMST)"
  },
  {
   value: "Marstrand (SEMSD)",
   label: "Marstrand (SEMSD)"
  },
  {
   value: "Marsviken (SEMAN)",
   label: "Marsviken (SEMAN)"
  },
  {
   value: "Maryvik (SEMVK)",
   label: "Maryvik (SEMVK)"
  },
  {
   value: "Matfors (SEMAT)",
   label: "Matfors (SEMAT)"
  },
  {
   value: "Mattmar (SEMTM)",
   label: "Mattmar (SEMTM)"
  },
  {
   value: "Mellerud (SEMEL)",
   label: "Mellerud (SEMEL)"
  },
  {
   value: "Mem (SEMEM)",
   label: "Mem (SEMEM)"
  },
  {
   value: "Mjölby (SEMJB)",
   label: "Mjölby (SEMJB)"
  },
  {
   value: "Mo (SEMOO)",
   label: "Mo (SEMOO)"
  },
  {
   value: "Mollösund (SEMLO)",
   label: "Mollösund (SEMLO)"
  },
  {
   value: "Mölndal (SEMND)",
   label: "Mölndal (SEMND)"
  },
  {
   value: "Mölnlycke (SEMOE)",
   label: "Mölnlycke (SEMOE)"
  },
  {
   value: "Mönsterås (SEMON)",
   label: "Mönsterås (SEMON)"
  },
  {
   value: "Mora (SEMRA)",
   label: "Mora (SEMRA)"
  },
  {
   value: "Mörarp (SEMOP)",
   label: "Mörarp (SEMOP)"
  },
  {
   value: "Mörbylånga (SEMOR)",
   label: "Mörbylånga (SEMOR)"
  },
  {
   value: "Motala (SEMOT)",
   label: "Motala (SEMOT)"
  },
  {
   value: "Mullsjö (SEMUL)",
   label: "Mullsjö (SEMUL)"
  },
  {
   value: "Munkedal (SEMUK)",
   label: "Munkedal (SEMUK)"
  },
  {
   value: "Munkedalhamn (SEMDM)",
   label: "Munkedalhamn (SEMDM)"
  },
  {
   value: "Munkfors (SEMNF)",
   label: "Munkfors (SEMNF)"
  },
  {
   value: "Munksund (SEMUN)",
   label: "Munksund (SEMUN)"
  },
  {
   value: "Nacka (SENAC)",
   label: "Nacka (SENAC)"
  },
  {
   value: "Nacka Strand (SENCS)",
   label: "Nacka Strand (SENCS)"
  },
  {
   value: "Näs (SENAS)",
   label: "Näs (SENAS)"
  },
  {
   value: "Nässjö (SENSJ)",
   label: "Nässjö (SENSJ)"
  },
  {
   value: "Näsviken (SENVK)",
   label: "Näsviken (SENVK)"
  },
  {
   value: "Nävekvarn (SENAV)",
   label: "Nävekvarn (SENAV)"
  },
  {
   value: "Nol (ports) (SENOL)",
   label: "Nol (ports) (SENOL)"
  },
  {
   value: "Norberg (SENBG)",
   label: "Norberg (SENBG)"
  },
  {
   value: "Nordmaling (SENOG)",
   label: "Nordmaling (SENOG)"
  },
  {
   value: "Norrahammar (SENHR)",
   label: "Norrahammar (SENHR)"
  },
  {
   value: "Norrbottens Järnverk-SSAB (SENJA)",
   label: "Norrbottens Järnverk-SSAB (SENJA)"
  },
  {
   value: "Norrbyskär (SENOR)",
   label: "Norrbyskär (SENOR)"
  },
  {
   value: "Kungsängen (SEKNN)",
   label: "Kungsängen (SEKNN)"
  },
  {
   value: "Kungsbacka (SEKUA)",
   label: "Kungsbacka (SEKUA)"
  },
  {
   value: "Kungshamn (SEKUN)",
   label: "Kungshamn (SEKUN)"
  },
  {
   value: "Kungsör (SEKGR)",
   label: "Kungsör (SEKGR)"
  },
  {
   value: "Kvänum (SEKVM)",
   label: "Kvänum (SEKVM)"
  },
  {
   value: "Kvarnholmen (SEKVA)",
   label: "Kvarnholmen (SEKVA)"
  },
  {
   value: "Kyrkebyn (SEKYR)",
   label: "Kyrkebyn (SEKYR)"
  },
  {
   value: "Lammhult (SELAM)",
   label: "Lammhult (SELAM)"
  },
  {
   value: "Landsbro (SELAO)",
   label: "Landsbro (SELAO)"
  },
  {
   value: "Landskrona (SELAA)",
   label: "Landskrona (SELAA)"
  },
  {
   value: "Långasjö (SELAN)",
   label: "Långasjö (SELAN)"
  },
  {
   value: "Långshyttan (SELNG)",
   label: "Långshyttan (SELNG)"
  },
  {
   value: "Laxa (SELAX)",
   label: "Laxa (SELAX)"
  },
  {
   value: "Lenhovda (SELDV)",
   label: "Lenhovda (SELDV)"
  },
  {
   value: "Lerum (SELER)",
   label: "Lerum (SELER)"
  },
  {
   value: "Lesjöfors (SELES)",
   label: "Lesjöfors (SELES)"
  },
  {
   value: "Lidhult (SELIT)",
   label: "Lidhult (SELIT)"
  },
  {
   value: "Lidingö (SELIO)",
   label: "Lidingö (SELIO)"
  },
  {
   value: "Lidköping (SELDK)",
   label: "Lidköping (SELDK)"
  },
  {
   value: "Liljendal (SELIL)",
   label: "Liljendal (SELIL)"
  },
  {
   value: "Lilla Edet (SELED)",
   label: "Lilla Edet (SELED)"
  },
  {
   value: "Limhamn (SELIM)",
   label: "Limhamn (SELIM)"
  },
  {
   value: "Limmared (SELMD)",
   label: "Limmared (SELMD)"
  },
  {
   value: "Linanäs (SELIS)",
   label: "Linanäs (SELIS)"
  },
  {
   value: "Lindesberg (SELDG)",
   label: "Lindesberg (SELDG)"
  },
  {
   value: "Linköping (SELPI)",
   label: "Linköping (SELPI)"
  },
  {
   value: "Ljungby (SELJY)",
   label: "Ljungby (SELJY)"
  },
  {
   value: "Ljusne (SELJU)",
   label: "Ljusne (SELJU)"
  },
  {
   value: "Lödöse (SELDO)",
   label: "Lödöse (SELDO)"
  },
  {
   value: "Lofsdalen (SELDN)",
   label: "Lofsdalen (SELDN)"
  },
  {
   value: "Lomma (SELOM)",
   label: "Lomma (SELOM)"
  },
  {
   value: "Loudden\/Stockholm (SELOU)",
   label: "Loudden\/Stockholm (SELOU)"
  },
  {
   value: "Lövånger (SELVR)",
   label: "Lövånger (SELVR)"
  },
  {
   value: "Lövholmen (SELUN)",
   label: "Lövholmen (SELUN)"
  },
  {
   value: "Ludvika (SELUV)",
   label: "Ludvika (SELUV)"
  },
  {
   value: "Lugnvik (SELUG)",
   label: "Lugnvik (SELUG)"
  },
  {
   value: "Luleå (SELLA)",
   label: "Luleå (SELLA)"
  },
  {
   value: "Lund (SELUD)",
   label: "Lund (SELUD)"
  },
  {
   value: "Lyckeby (SELBY)",
   label: "Lyckeby (SELBY)"
  },
  {
   value: "Lysekil (SELYS)",
   label: "Lysekil (SELYS)"
  },
  {
   value: "Malmö (SEMMA)",
   label: "Malmö (SEMMA)"
  },
  {
   value: "Malung (SEMLU)",
   label: "Malung (SEMLU)"
  },
  {
   value: "Kåge (SEKAG)",
   label: "Kåge (SEKAG)"
  },
  {
   value: "Kalix (SEKAX)",
   label: "Kalix (SEKAX)"
  },
  {
   value: "Källby (SEKBY)",
   label: "Källby (SEKBY)"
  },
  {
   value: "Kalmar (SEKLR)",
   label: "Kalmar (SEKLR)"
  },
  {
   value: "Kapellskär (SEKPS)",
   label: "Kapellskär (SEKPS)"
  },
  {
   value: "Kappelshamn (SEKPH)",
   label: "Kappelshamn (SEKPH)"
  },
  {
   value: "Karehamn (SEKRH)",
   label: "Karehamn (SEKRH)"
  },
  {
   value: "Karlsborg Axelvik (SEKXV)",
   label: "Karlsborg Axelvik (SEKXV)"
  },
  {
   value: "Karlshamn (SEKAN)",
   label: "Karlshamn (SEKAN)"
  },
  {
   value: "Karlsholmsbruk (SEKBK)",
   label: "Karlsholmsbruk (SEKBK)"
  },
  {
   value: "Karlskoga (SEKSK)",
   label: "Karlskoga (SEKSK)"
  },
  {
   value: "Karlskrona (SEKAA)",
   label: "Karlskrona (SEKAA)"
  },
  {
   value: "Karlstad (SEKSD)",
   label: "Karlstad (SEKSD)"
  },
  {
   value: "Karlsvik (SEKAK)",
   label: "Karlsvik (SEKAK)"
  },
  {
   value: "Karpalund (SEKPA)",
   label: "Karpalund (SEKPA)"
  },
  {
   value: "Karskär (SEKAS)",
   label: "Karskär (SEKAS)"
  },
  {
   value: "Katthammarsvik (SEKAT)",
   label: "Katthammarsvik (SEKAT)"
  },
  {
   value: "Kättilstorp (SEKAE)",
   label: "Kättilstorp (SEKAE)"
  },
  {
   value: "Kävlinge (SEKVL)",
   label: "Kävlinge (SEKVL)"
  },
  {
   value: "Kinna (SEKIA)",
   label: "Kinna (SEKIA)"
  },
  {
   value: "Kiruna (SEKRN)",
   label: "Kiruna (SEKRN)"
  },
  {
   value: "Kista (SEKIS)",
   label: "Kista (SEKIS)"
  },
  {
   value: "Klintehamn (SEKLI)",
   label: "Klintehamn (SEKLI)"
  },
  {
   value: "Klippan (SEKLP)",
   label: "Klippan (SEKLP)"
  },
  {
   value: "Knivsta (SEKNA)",
   label: "Knivsta (SEKNA)"
  },
  {
   value: "Kolsva (SEKOA)",
   label: "Kolsva (SEKOA)"
  },
  {
   value: "Köping (SEKOG)",
   label: "Köping (SEKOG)"
  },
  {
   value: "Köpmanholmen (SEKMH)",
   label: "Köpmanholmen (SEKMH)"
  },
  {
   value: "Kopparberg (SEKPO)",
   label: "Kopparberg (SEKPO)"
  },
  {
   value: "Kopparverkshamnen (SEKVH)",
   label: "Kopparverkshamnen (SEKVH)"
  },
  {
   value: "Korsberga (SEKOR)",
   label: "Korsberga (SEKOR)"
  },
  {
   value: "Korsnäs (SEKOS)",
   label: "Korsnäs (SEKOS)"
  },
  {
   value: "Koskullskulle (SEKSL)",
   label: "Koskullskulle (SEKSL)"
  },
  {
   value: "Kosta (SEKST)",
   label: "Kosta (SEKST)"
  },
  {
   value: "Kramfors (SEKRF)",
   label: "Kramfors (SEKRF)"
  },
  {
   value: "Kristianstad (SEKID)",
   label: "Kristianstad (SEKID)"
  },
  {
   value: "Kristinehamn (SEKHN)",
   label: "Kristinehamn (SEKHN)"
  },
  {
   value: "Krylbo (SEKRY)",
   label: "Krylbo (SEKRY)"
  },
  {
   value: "Kubikenborg (SEKUB)",
   label: "Kubikenborg (SEKUB)"
  },
  {
   value: "Kumla (SEKUM)",
   label: "Kumla (SEKUM)"
  },
  {
   value: "Kungälv (SEKUV)",
   label: "Kungälv (SEKUV)"
  },
  {
   value: "Helgenäs (SEHLN)",
   label: "Helgenäs (SEHLN)"
  },
  {
   value: "Helsingborg (SEHEL)",
   label: "Helsingborg (SEHEL)"
  },
  {
   value: "Helsingborg-Ängelholm apt (SEAGH)",
   label: "Helsingborg-Ängelholm apt (SEAGH)"
  },
  {
   value: "Herräng (SEHER)",
   label: "Herräng (SEHER)"
  },
  {
   value: "Herrljunga (SEHEJ)",
   label: "Herrljunga (SEHEJ)"
  },
  {
   value: "Hillerstorp (SEHIL)",
   label: "Hillerstorp (SEHIL)"
  },
  {
   value: "Hisings Backa (SEHBA)",
   label: "Hisings Backa (SEHBA)"
  },
  {
   value: "Hittarp (SEHIT)",
   label: "Hittarp (SEHIT)"
  },
  {
   value: "Hjärnarp (SEHJA)",
   label: "Hjärnarp (SEHJA)"
  },
  {
   value: "Hjo (SEHJO)",
   label: "Hjo (SEHJO)"
  },
  {
   value: "Hjorted (SEHJD)",
   label: "Hjorted (SEHJD)"
  },
  {
   value: "Hofors (SEHOF)",
   label: "Hofors (SEHOF)"
  },
  {
   value: "Höganäs (SEHOG)",
   label: "Höganäs (SEHOG)"
  },
  {
   value: "Högsäter (SEHOR)",
   label: "Högsäter (SEHOR)"
  },
  {
   value: "Högsjö (SEHGS)",
   label: "Högsjö (SEHGS)"
  },
  {
   value: "Holmsjö (SEHOL)",
   label: "Holmsjö (SEHOL)"
  },
  {
   value: "Holmsund (SEHLD)",
   label: "Holmsund (SEHLD)"
  },
  {
   value: "Holsbybrunn (SEHBB)",
   label: "Holsbybrunn (SEHBB)"
  },
  {
   value: "Hönsäter (SEHON)",
   label: "Hönsäter (SEHON)"
  },
  {
   value: "Horndal (SEHRN)",
   label: "Horndal (SEHRN)"
  },
  {
   value: "Hörneborg (SEHNB)",
   label: "Hörneborg (SEHNB)"
  },
  {
   value: "Hörnefors (SEHNF)",
   label: "Hörnefors (SEHNF)"
  },
  {
   value: "Hova (SEHVA)",
   label: "Hova (SEHVA)"
  },
  {
   value: "Hovslätt (SEHZS)",
   label: "Hovslätt (SEHZS)"
  },
  {
   value: "Huddinge (SEHUE)",
   label: "Huddinge (SEHUE)"
  },
  {
   value: "Hudiksvall (SEHUV)",
   label: "Hudiksvall (SEHUV)"
  },
  {
   value: "Hultsfred (SEHLF)",
   label: "Hultsfred (SEHLF)"
  },
  {
   value: "Hunnebostrand (SEHUN)",
   label: "Hunnebostrand (SEHUN)"
  },
  {
   value: "Husqvarna (SEHSQ)",
   label: "Husqvarna (SEHSQ)"
  },
  {
   value: "Husum (SEHUS)",
   label: "Husum (SEHUS)"
  },
  {
   value: "Hyltebruk (SEHYL)",
   label: "Hyltebruk (SEHYL)"
  },
  {
   value: "Hyppeln (SEHYP)",
   label: "Hyppeln (SEHYP)"
  },
  {
   value: "Iggesund (SEIGG)",
   label: "Iggesund (SEIGG)"
  },
  {
   value: "Jämjö (SEJMJ)",
   label: "Jämjö (SEJMJ)"
  },
  {
   value: "Järfälla (SEJAR)",
   label: "Järfälla (SEJAR)"
  },
  {
   value: "Jättersön (SEJAT)",
   label: "Jättersön (SEJAT)"
  },
  {
   value: "Johannedal (SEJOH)",
   label: "Johannedal (SEJOH)"
  },
  {
   value: "Johanneshov (SEJHV)",
   label: "Johanneshov (SEJHV)"
  },
  {
   value: "Jönköping (SEJKG)",
   label: "Jönköping (SEJKG)"
  },
  {
   value: "Jonsered (SEJON)",
   label: "Jonsered (SEJON)"
  },
  {
   value: "Jordbro (SEJOR)",
   label: "Jordbro (SEJOR)"
  },
  {
   value: "Grängesberg (SEGRN)",
   label: "Grängesberg (SEGRN)"
  },
  {
   value: "Grankullaviken (SEGKV)",
   label: "Grankullaviken (SEGKV)"
  },
  {
   value: "Gravarne (SEGVN)",
   label: "Gravarne (SEGVN)"
  },
  {
   value: "Grebbestad (SEGRE)",
   label: "Grebbestad (SEGRE)"
  },
  {
   value: "Grevie (SEGRV)",
   label: "Grevie (SEGRV)"
  },
  {
   value: "Grimsås (SEGRI)",
   label: "Grimsås (SEGRI)"
  },
  {
   value: "Grisslehamn (SEGRH)",
   label: "Grisslehamn (SEGRH)"
  },
  {
   value: "Grums (SEGMS)",
   label: "Grums (SEGMS)"
  },
  {
   value: "Grundsund (SEGRD)",
   label: "Grundsund (SEGRD)"
  },
  {
   value: "Grundvik (SEGRK)",
   label: "Grundvik (SEGRK)"
  },
  {
   value: "Gruvön (SEGRU)",
   label: "Gruvön (SEGRU)"
  },
  {
   value: "Grycksbo (SEGRY)",
   label: "Grycksbo (SEGRY)"
  },
  {
   value: "Grytgöl (SEGRT)",
   label: "Grytgöl (SEGRT)"
  },
  {
   value: "Gunnebo (SEGUN)",
   label: "Gunnebo (SEGUN)"
  },
  {
   value: "Gustafsvik (SEGUS)",
   label: "Gustafsvik (SEGUS)"
  },
  {
   value: "Gustafsvik\/Stockholm (SEGKS)",
   label: "Gustafsvik\/Stockholm (SEGKS)"
  },
  {
   value: "Gustavsberg (SEGUB)",
   label: "Gustavsberg (SEGUB)"
  },
  {
   value: "Habo (SEHAB)",
   label: "Habo (SEHAB)"
  },
  {
   value: "Hagen (SEHAG)",
   label: "Hagen (SEHAG)"
  },
  {
   value: "Hägersten\/Stockholm (SEHGR)",
   label: "Hägersten\/Stockholm (SEHGR)"
  },
  {
   value: "Hagfors (SEHFS)",
   label: "Hagfors (SEHFS)"
  },
  {
   value: "Hallaryd (SEHYD)",
   label: "Hallaryd (SEHYD)"
  },
  {
   value: "Hällefors (SEHLL)",
   label: "Hällefors (SEHLL)"
  },
  {
   value: "Hällekis (SEHLS)",
   label: "Hällekis (SEHLS)"
  },
  {
   value: "Hallstahammar (SEHAL)",
   label: "Hallstahammar (SEHAL)"
  },
  {
   value: "Hallstanäs (SEHAS)",
   label: "Hallstanäs (SEHAS)"
  },
  {
   value: "Hallstavik (SEHAK)",
   label: "Hallstavik (SEHAK)"
  },
  {
   value: "Halmstad (SEHAD)",
   label: "Halmstad (SEHAD)"
  },
  {
   value: "Hamburgsund (SEHBG)",
   label: "Hamburgsund (SEHBG)"
  },
  {
   value: "Hanaskog (SEHNK)",
   label: "Hanaskog (SEHNK)"
  },
  {
   value: "Haninge (SEHNE)",
   label: "Haninge (SEHNE)"
  },
  {
   value: "Haparanda (SEHAA)",
   label: "Haparanda (SEHAA)"
  },
  {
   value: "Haraholmen (SEHAH)",
   label: "Haraholmen (SEHAH)"
  },
  {
   value: "Hargshamn (SEHAN)",
   label: "Hargshamn (SEHAN)"
  },
  {
   value: "Härnösand (SEHND)",
   label: "Härnösand (SEHND)"
  },
  {
   value: "Harsprånget (SEHAR)",
   label: "Harsprånget (SEHAR)"
  },
  {
   value: "Hässelbyverket\/Stockhom (SEHBV)",
   label: "Hässelbyverket\/Stockhom (SEHBV)"
  },
  {
   value: "Hässleholm (SEHSM)",
   label: "Hässleholm (SEHSM)"
  },
  {
   value: "Hästveda (SEHVD)",
   label: "Hästveda (SEHVD)"
  },
  {
   value: "Hedemora (SEHED)",
   label: "Hedemora (SEHED)"
  },
  {
   value: "Falköping (SEFKG)",
   label: "Falköping (SEFKG)"
  },
  {
   value: "Falsterbo (SEFSB)",
   label: "Falsterbo (SEFSB)"
  },
  {
   value: "Falun (SEFAN)",
   label: "Falun (SEFAN)"
  },
  {
   value: "Färjestaden (SEFAR)",
   label: "Färjestaden (SEFAR)"
  },
  {
   value: "Farösund (SEFSD)",
   label: "Farösund (SEFSD)"
  },
  {
   value: "Fellingsbro (SEFEL)",
   label: "Fellingsbro (SEFEL)"
  },
  {
   value: "Figeholm (SEFIG)",
   label: "Figeholm (SEFIG)"
  },
  {
   value: "Filipstad (SEFIL)",
   label: "Filipstad (SEFIL)"
  },
  {
   value: "Finspång (SEFIN)",
   label: "Finspång (SEFIN)"
  },
  {
   value: "Fiskebäck (SEFIS)",
   label: "Fiskebäck (SEFIS)"
  },
  {
   value: "Fiskebackskil (SEFBK)",
   label: "Fiskebackskil (SEFBK)"
  },
  {
   value: "Fjällbacka (SEFJA)",
   label: "Fjällbacka (SEFJA)"
  },
  {
   value: "Flaxenvik (SEFLX)",
   label: "Flaxenvik (SEFLX)"
  },
  {
   value: "Flemingsberg\/Stockholm (SEFLM)",
   label: "Flemingsberg\/Stockholm (SEFLM)"
  },
  {
   value: "Flen (SEFLE)",
   label: "Flen (SEFLE)"
  },
  {
   value: "Floby (SEFBY)",
   label: "Floby (SEFBY)"
  },
  {
   value: "Fors (SEFRS)",
   label: "Fors (SEFRS)"
  },
  {
   value: "Forserum (SEFOM)",
   label: "Forserum (SEFOM)"
  },
  {
   value: "Forshaga (SEFOS)",
   label: "Forshaga (SEFOS)"
  },
  {
   value: "Forsheda (SEFHD)",
   label: "Forsheda (SEFHD)"
  },
  {
   value: "Forsmark (SEFOR)",
   label: "Forsmark (SEFOR)"
  },
  {
   value: "Forsvik (SEFVK)",
   label: "Forsvik (SEFVK)"
  },
  {
   value: "Frånö (SEFRA)",
   label: "Frånö (SEFRA)"
  },
  {
   value: "Fristad (SEFRI)",
   label: "Fristad (SEFRI)"
  },
  {
   value: "Fritsla (SEFTY)",
   label: "Fritsla (SEFTY)"
  },
  {
   value: "Gäddviken (SEGAD)",
   label: "Gäddviken (SEGAD)"
  },
  {
   value: "Gagnef (SEGGF)",
   label: "Gagnef (SEGGF)"
  },
  {
   value: "Gällivare (SEGEV)",
   label: "Gällivare (SEGEV)"
  },
  {
   value: "Gamleby (SEGAM)",
   label: "Gamleby (SEGAM)"
  },
  {
   value: "Gånghester (SEGHR)",
   label: "Gånghester (SEGHR)"
  },
  {
   value: "Garphyttan (SEGAR)",
   label: "Garphyttan (SEGAR)"
  },
  {
   value: "Gävle (SEGVX)",
   label: "Gävle (SEGVX)"
  },
  {
   value: "Getinge (SEGET)",
   label: "Getinge (SEGET)"
  },
  {
   value: "Gislaved (SEGIS)",
   label: "Gislaved (SEGIS)"
  },
  {
   value: "Glanshammar (SEGLA)",
   label: "Glanshammar (SEGLA)"
  },
  {
   value: "Glimåkra (SEGLI)",
   label: "Glimåkra (SEGLI)"
  },
  {
   value: "Gnarp (SEGNA)",
   label: "Gnarp (SEGNA)"
  },
  {
   value: "Gnosjö (SEGNO)",
   label: "Gnosjö (SEGNO)"
  },
  {
   value: "Göta (SEGOA)",
   label: "Göta (SEGOA)"
  },
  {
   value: "Göteborg (SEGOT)",
   label: "Göteborg (SEGOT)"
  },
  {
   value: "Götene (SEGOE)",
   label: "Götene (SEGOE)"
  },
  {
   value: "Gråbo (SEGRA)",
   label: "Gråbo (SEGRA)"
  },
  {
   value: "Bredviken (SEBRE)",
   label: "Bredviken (SEBRE)"
  },
  {
   value: "Brofjorden (SEBRO)",
   label: "Brofjorden (SEBRO)"
  },
  {
   value: "Bromma apt\/Stockholm (SEBMA)",
   label: "Bromma apt\/Stockholm (SEBMA)"
  },
  {
   value: "Bromölla (SEBRM)",
   label: "Bromölla (SEBRM)"
  },
  {
   value: "Brottby (SEBRT)",
   label: "Brottby (SEBRT)"
  },
  {
   value: "Bureå (SEBUR)",
   label: "Bureå (SEBUR)"
  },
  {
   value: "Burgsvik (SEBUV)",
   label: "Burgsvik (SEBUV)"
  },
  {
   value: "Byske (Brännfors) (SEBYS)",
   label: "Byske (Brännfors) (SEBYS)"
  },
  {
   value: "Byxelkrok (SEBYX)",
   label: "Byxelkrok (SEBYX)"
  },
  {
   value: "Charlottenberg (SECHA)",
   label: "Charlottenberg (SECHA)"
  },
  {
   value: "Dalarö (SEDLA)",
   label: "Dalarö (SEDLA)"
  },
  {
   value: "Dalby (SEDLB)",
   label: "Dalby (SEDLB)"
  },
  {
   value: "Dals-Långed (SEDAL)",
   label: "Dals-Långed (SEDAL)"
  },
  {
   value: "Dalsjöfors (SEDFO)",
   label: "Dalsjöfors (SEDFO)"
  },
  {
   value: "Dalstorp (SEDLP)",
   label: "Dalstorp (SEDLP)"
  },
  {
   value: "Danderyd (SEDND)",
   label: "Danderyd (SEDND)"
  },
  {
   value: "Dannemora (SEDAN)",
   label: "Dannemora (SEDAN)"
  },
  {
   value: "Degerfors (SEDFS)",
   label: "Degerfors (SEDFS)"
  },
  {
   value: "Degerhamn (SEDEG)",
   label: "Degerhamn (SEDEG)"
  },
  {
   value: "Djupvik (SEDJP)",
   label: "Djupvik (SEDJP)"
  },
  {
   value: "Djurmo (SEDJU)",
   label: "Djurmo (SEDJU)"
  },
  {
   value: "Djurön (SEDJN)",
   label: "Djurön (SEDJN)"
  },
  {
   value: "Domsjö (SEDOM)",
   label: "Domsjö (SEDOM)"
  },
  {
   value: "Donsö (SEDON)",
   label: "Donsö (SEDON)"
  },
  {
   value: "Dynäs (SEDYN)",
   label: "Dynäs (SEDYN)"
  },
  {
   value: "Ed (SEEDZ)",
   label: "Ed (SEEDZ)"
  },
  {
   value: "Edsbyn (SEEDS)",
   label: "Edsbyn (SEEDS)"
  },
  {
   value: "Ekenässjön (SEEEN)",
   label: "Ekenässjön (SEEEN)"
  },
  {
   value: "Ekerö (SEEKE)",
   label: "Ekerö (SEEKE)"
  },
  {
   value: "Eksjö (SEEKS)",
   label: "Eksjö (SEEKS)"
  },
  {
   value: "Emmaboda (SEEMM)",
   label: "Emmaboda (SEEMM)"
  },
  {
   value: "Emmaljunga (SEAJG)",
   label: "Emmaljunga (SEAJG)"
  },
  {
   value: "Enebyberg (SEENE)",
   label: "Enebyberg (SEENE)"
  },
  {
   value: "Eneryda (SEENA)",
   label: "Eneryda (SEENA)"
  },
  {
   value: "Enköping (SEENK)",
   label: "Enköping (SEENK)"
  },
  {
   value: "Ersmark (SEERS)",
   label: "Ersmark (SEERS)"
  },
  {
   value: "Eskilstuna (SEEKT)",
   label: "Eskilstuna (SEEKT)"
  },
  {
   value: "Eslöv (SEESL)",
   label: "Eslöv (SEESL)"
  },
  {
   value: "Essvik (SEESS)",
   label: "Essvik (SEESS)"
  },
  {
   value: "Fagersta (SEFAA)",
   label: "Fagersta (SEFAA)"
  },
  {
   value: "Fagervik (SEFAK)",
   label: "Fagervik (SEFAK)"
  },
  {
   value: "Falkenberg (SEFAG)",
   label: "Falkenberg (SEFAG)"
  },
  {
   value: "Ballingslöv (SEBAL)",
   label: "Ballingslöv (SEBAL)"
  },
  {
   value: "Bällstaviken (SEBLV)",
   label: "Bällstaviken (SEBLV)"
  },
  {
   value: "Bålsta (SEBAA)",
   label: "Bålsta (SEBAA)"
  },
  {
   value: "Bankeryd (SEBND)",
   label: "Bankeryd (SEBND)"
  },
  {
   value: "Barsebäckshamn (SEBBH)",
   label: "Barsebäckshamn (SEBBH)"
  },
  {
   value: "Bastad (SEBAS)",
   label: "Bastad (SEBAS)"
  },
  {
   value: "Båtskärsnäs (SEBAT)",
   label: "Båtskärsnäs (SEBAT)"
  },
  {
   value: "Bengtsfors (SEBTF)",
   label: "Bengtsfors (SEBTF)"
  },
  {
   value: "Bergkvara (SEBEA)",
   label: "Bergkvara (SEBEA)"
  },
  {
   value: "Bergs oljehamn (SEBER)",
   label: "Bergs oljehamn (SEBER)"
  },
  {
   value: "Bergshamra (SEBHM)",
   label: "Bergshamra (SEBHM)"
  },
  {
   value: "Billesholm (SEBIM)",
   label: "Billesholm (SEBIM)"
  },
  {
   value: "Billingsfors (SEBIL)",
   label: "Billingsfors (SEBIL)"
  },
  {
   value: "Bispgården (SEBPG)",
   label: "Bispgården (SEBPG)"
  },
  {
   value: "Bjärnum (SEBJA)",
   label: "Bjärnum (SEBJA)"
  },
  {
   value: "Björklinge (SEBJK)",
   label: "Björklinge (SEBJK)"
  },
  {
   value: "Bjorneborg (SEBJN)",
   label: "Bjorneborg (SEBJN)"
  },
  {
   value: "Blankaholm (SEBLA)",
   label: "Blankaholm (SEBLA)"
  },
  {
   value: "Blidsberg (SEBBG)",
   label: "Blidsberg (SEBBG)"
  },
  {
   value: "Böda (SEBDQ)",
   label: "Böda (SEBDQ)"
  },
  {
   value: "Bodafors (SEBDS)",
   label: "Bodafors (SEBDS)"
  },
  {
   value: "Boden (SEBOD)",
   label: "Boden (SEBOD)"
  },
  {
   value: "Bohus (SEBOH)",
   label: "Bohus (SEBOH)"
  },
  {
   value: "Boliden (SEBOI)",
   label: "Boliden (SEBOI)"
  },
  {
   value: "Bollebygd (SEBLL)",
   label: "Bollebygd (SEBLL)"
  },
  {
   value: "Bollnäs (SEBLS)",
   label: "Bollnäs (SEBLS)"
  },
  {
   value: "Bollstabruk (SEBOL)",
   label: "Bollstabruk (SEBOL)"
  },
  {
   value: "Borås (SEBOS)",
   label: "Borås (SEBOS)"
  },
  {
   value: "Borensberg (SEBOG)",
   label: "Borensberg (SEBOG)"
  },
  {
   value: "Borghamn (SEBON)",
   label: "Borghamn (SEBON)"
  },
  {
   value: "Borgholm (SEBOM)",
   label: "Borgholm (SEBOM)"
  },
  {
   value: "Borgstena (SEBGS)",
   label: "Borgstena (SEBGS)"
  },
  {
   value: "Borlänge (SEBLE)",
   label: "Borlänge (SEBLE)"
  },
  {
   value: "Bottnaryd (SEBOT)",
   label: "Bottnaryd (SEBOT)"
  },
  {
   value: "Bovallstrand (SEBLD)",
   label: "Bovallstrand (SEBLD)"
  },
  {
   value: "Boxholm (SEBOX)",
   label: "Boxholm (SEBOX)"
  },
  {
   value: "Bräkne-Hoby (SEBRH)",
   label: "Bräkne-Hoby (SEBRH)"
  },
  {
   value: "Brålanda (SEBRA)",
   label: "Brålanda (SEBRA)"
  },
  {
   value: "Brännfors (SEBNF)",
   label: "Brännfors (SEBNF)"
  },
  {
   value: "Bråvik (SEBVK)",
   label: "Bråvik (SEBVK)"
  },
  {
   value: "Bredaryd (SEBRD)",
   label: "Bredaryd (SEBRD)"
  },
  {
   value: "Ala (SEALA)",
   label: "Ala (SEALA)"
  },
  {
   value: "Alfredshem (SEALF)",
   label: "Alfredshem (SEALF)"
  },
  {
   value: "Älghult (SEAHT)",
   label: "Älghult (SEAHT)"
  },
  {
   value: "Alingsås (SEALI)",
   label: "Alingsås (SEALI)"
  },
  {
   value: "Älmhult (SEALM)",
   label: "Älmhult (SEALM)"
  },
  {
   value: "Almvik (SEAVK)",
   label: "Almvik (SEAVK)"
  },
  {
   value: "Älvängen (SEAGN)",
   label: "Älvängen (SEAGN)"
  },
  {
   value: "Ãlvenäs (SEALN)",
   label: "Ãlvenäs (SEALN)"
  },
  {
   value: "Alvesta (SEALV)",
   label: "Alvesta (SEALV)"
  },
  {
   value: "Åmål (SEAMA)",
   label: "Åmål (SEAMA)"
  },
  {
   value: "Anderstorp (SEANP)",
   label: "Anderstorp (SEANP)"
  },
  {
   value: "Aneby (SEABY)",
   label: "Aneby (SEABY)"
  },
  {
   value: "Ängelholm (SEANG)",
   label: "Ängelholm (SEANG)"
  },
  {
   value: "Ankarsvik (SEANK)",
   label: "Ankarsvik (SEANK)"
  },
  {
   value: "Ar (SEAAR)",
   label: "Ar (SEAAR)"
  },
  {
   value: "Arboga (SEARA)",
   label: "Arboga (SEARA)"
  },
  {
   value: "Arbrå (SEARB)",
   label: "Arbrå (SEARB)"
  },
  {
   value: "Arildslage (SEADG)",
   label: "Arildslage (SEADG)"
  },
  {
   value: "Årjäng (SEARJ)",
   label: "Årjäng (SEARJ)"
  },
  {
   value: "Arjeplog (SEARG)",
   label: "Arjeplog (SEARG)"
  },
  {
   value: "Arkosund (SEASU)",
   label: "Arkosund (SEASU)"
  },
  {
   value: "Arlanda Apt\/Stockholm (SEARN)",
   label: "Arlanda Apt\/Stockholm (SEARN)"
  },
  {
   value: "Arlandastad (SEART)",
   label: "Arlandastad (SEART)"
  },
  {
   value: "Arlöv (SEARL)",
   label: "Arlöv (SEARL)"
  },
  {
   value: "Arninge (SEARI)",
   label: "Arninge (SEARI)"
  },
  {
   value: "Arnöviken (SEARK)",
   label: "Arnöviken (SEARK)"
  },
  {
   value: "Årsta\/Stockholm (SEARS)",
   label: "Årsta\/Stockholm (SEARS)"
  },
  {
   value: "Årstadal (SEARD)",
   label: "Årstadal (SEARD)"
  },
  {
   value: "Arvidsjaur (SEAJR)",
   label: "Arvidsjaur (SEAJR)"
  },
  {
   value: "Arvika (SEARV)",
   label: "Arvika (SEARV)"
  },
  {
   value: "Asarum (SEASA)",
   label: "Asarum (SEASA)"
  },
  {
   value: "Åseda (SEAAS)",
   label: "Åseda (SEAAS)"
  },
  {
   value: "Åsensbruk (SEASE)",
   label: "Åsensbruk (SEASE)"
  },
  {
   value: "Askersund (SEASD)",
   label: "Askersund (SEASD)"
  },
  {
   value: "Åskloster (SEASK)",
   label: "Åskloster (SEASK)"
  },
  {
   value: "Åstorp (SEAST)",
   label: "Åstorp (SEAST)"
  },
  {
   value: "Åtvidaberg (SEATV)",
   label: "Åtvidaberg (SEATV)"
  },
  {
   value: "Avesta (SEAVE)",
   label: "Avesta (SEAVE)"
  },
  {
   value: "Axelsvik (Karlsborg?) (SEAXE)",
   label: "Axelsvik (Karlsborg?) (SEAXE)"
  },
  {
   value: "Bäckfors (SEBFS)",
   label: "Bäckfors (SEBFS)"
  },
  {
   value: "Bäckhammar (SEBAR)",
   label: "Bäckhammar (SEBAR)"
  },
  {
   value: "Bäckviken (SEBAC)",
   label: "Bäckviken (SEBAC)"
  },
  {
   value: "\"Munda (SBMUA)",
   label: "\"Munda (SBMUA)"
  },
  {
   value: "\"Noro (SBNOR)",
   label: "\"Noro (SBNOR)"
  },
  {
   value: "\"Onepusu (SBONE)",
   label: "\"Onepusu (SBONE)"
  },
  {
   value: "\"Parasi (SBPRS)",
   label: "\"Parasi (SBPRS)"
  },
  {
   value: "Rennell Island (SBRNL)",
   label: "Rennell Island (SBRNL)"
  },
  {
   value: "\"Ringi Cove (SBRIN)",
   label: "\"Ringi Cove (SBRIN)"
  },
  {
   value: "Santa Cruz Is (SBSCZ)",
   label: "Santa Cruz Is (SBSCZ)"
  },
  {
   value: "\"Sege (SBEGM)",
   label: "\"Sege (SBEGM)"
  },
  {
   value: "\"Shortland Harbour (SBSHH)",
   label: "\"Shortland Harbour (SBSHH)"
  },
  {
   value: "\"Tulagi (SBTLG)",
   label: "\"Tulagi (SBTLG)"
  },
  {
   value: "Viru Harbour (SBVIU)",
   label: "Viru Harbour (SBVIU)"
  },
  {
   value: "\"Yandina (SBXYA)",
   label: "\"Yandina (SBXYA)"
  },
  {
   value: "Bird Island (SCBDI)",
   label: "Bird Island (SCBDI)"
  },
  {
   value: "Mahe (SCMAW)",
   label: "Mahe (SCMAW)"
  },
  {
   value: "Mahe Island Apt (SCSEZ)",
   label: "Mahe Island Apt (SCSEZ)"
  },
  {
   value: "Port Victoria (SCPOV)",
   label: "Port Victoria (SCPOV)"
  },
  {
   value: "Praslin Island (SCPRI)",
   label: "Praslin Island (SCPRI)"
  },
  {
   value: "Atbara (SDATB)",
   label: "Atbara (SDATB)"
  },
  {
   value: "Dongola (SDDOG)",
   label: "Dongola (SDDOG)"
  },
  {
   value: "El Fasher (SDELF)",
   label: "El Fasher (SDELF)"
  },
  {
   value: "El Obeid (SDEBD)",
   label: "El Obeid (SDEBD)"
  },
  {
   value: "Geneina (SDEGN)",
   label: "Geneina (SDEGN)"
  },
  {
   value: "Juba (SDJUM)",
   label: "Juba (SDJUM)"
  },
  {
   value: "Kassala (SDKSL)",
   label: "Kassala (SDKSL)"
  },
  {
   value: "Khartoum (SDKRT)",
   label: "Khartoum (SDKRT)"
  },
  {
   value: "Malakal (SDMAK)",
   label: "Malakal (SDMAK)"
  },
  {
   value: "Merowe (SDMWE)",
   label: "Merowe (SDMWE)"
  },
  {
   value: "New Halfa (SDNHF)",
   label: "New Halfa (SDNHF)"
  },
  {
   value: "Port Sudan (SDPZU)",
   label: "Port Sudan (SDPZU)"
  },
  {
   value: "Roseires (SDRSS)",
   label: "Roseires (SDRSS)"
  },
  {
   value: "Swakin (SDSWA)",
   label: "Swakin (SDSWA)"
  },
  {
   value: "Wau (SDWUU)",
   label: "Wau (SDWUU)"
  },
  {
   value: "Àby (SEABI)",
   label: "Àby (SEABI)"
  },
  {
   value: "Agnesberg (SEAGB)",
   label: "Agnesberg (SEAGB)"
  },
  {
   value: "Agö (SEAGO)",
   label: "Agö (SEAGO)"
  },
  {
   value: "Åhus (SEAHU)",
   label: "Åhus (SEAHU)"
  },
  {
   value: "Åkers Styckebruk (SEAAK)",
   label: "Åkers Styckebruk (SEAAK)"
  },
  {
   value: "Åkersberga (SEAKA)",
   label: "Åkersberga (SEAKA)"
  },
  {
   value: "Manfouha (SAMUF)",
   label: "Manfouha (SAMUF)"
  },
  {
   value: "Medina (SAMED)",
   label: "Medina (SAMED)"
  },
  {
   value: "Nejran (SAEAM)",
   label: "Nejran (SAEAM)"
  },
  {
   value: "Qalsn (SAQAL)",
   label: "Qalsn (SAQAL)"
  },
  {
   value: "Qurayyah (SAQUR)",
   label: "Qurayyah (SAQUR)"
  },
  {
   value: "Rabigh (SARAB)",
   label: "Rabigh (SARAB)"
  },
  {
   value: "Rafha (SARAH)",
   label: "Rafha (SARAH)"
  },
  {
   value: "Ras al Khafji (SARAR)",
   label: "Ras al Khafji (SARAR)"
  },
  {
   value: "Ras al Mishab (SARAM)",
   label: "Ras al Mishab (SARAM)"
  },
  {
   value: "Ras Tanura (SARTA)",
   label: "Ras Tanura (SARTA)"
  },
  {
   value: "Riyadh (SARUH)",
   label: "Riyadh (SARUH)"
  },
  {
   value: "Salboukh (SASUH)",
   label: "Salboukh (SASUH)"
  },
  {
   value: "Sharurah (SASHW)",
   label: "Sharurah (SASHW)"
  },
  {
   value: "Tabuk (SATUU)",
   label: "Tabuk (SATUU)"
  },
  {
   value: "Taif (SATIF)",
   label: "Taif (SATIF)"
  },
  {
   value: "Turaif (SATUI)",
   label: "Turaif (SATUI)"
  },
  {
   value: "Umm Laji (SAVLA)",
   label: "Umm Laji (SAVLA)"
  },
  {
   value: "Unayzah (SAUZH)",
   label: "Unayzah (SAUZH)"
  },
  {
   value: "Wadi ad Dawasir (SAWAE)",
   label: "Wadi ad Dawasir (SAWAE)"
  },
  {
   value: "Waisumah (SAAWI)",
   label: "Waisumah (SAAWI)"
  },
  {
   value: "Wedjh (SAEJH)",
   label: "Wedjh (SAEJH)"
  },
  {
   value: "Yanbo (SAYNB)",
   label: "Yanbo (SAYNB)"
  },
  {
   value: "Zulayfayn (SAZUY)",
   label: "Zulayfayn (SAZUY)"
  },
  {
   value: "\"Allardyce Harbour (SBALB)",
   label: "\"Allardyce Harbour (SBALB)"
  },
  {
   value: "Aola Bay (SBAOB)",
   label: "Aola Bay (SBAOB)"
  },
  {
   value: "\"Auki (SBAKS)",
   label: "\"Auki (SBAKS)"
  },
  {
   value: "\"Avu Avu (SBAVU)",
   label: "\"Avu Avu (SBAVU)"
  },
  {
   value: "\"Balalae (SBBAS)",
   label: "\"Balalae (SBBAS)"
  },
  {
   value: "Bellona Is (SBBNY)",
   label: "Bellona Is (SBBNY)"
  },
  {
   value: "\"Choiseul Bay (SBCHY)",
   label: "\"Choiseul Bay (SBCHY)"
  },
  {
   value: "\"Fera Island (SBFRE)",
   label: "\"Fera Island (SBFRE)"
  },
  {
   value: "Gizo Is (SBGZO)",
   label: "Gizo Is (SBGZO)"
  },
  {
   value: "\"Honiara (SBHIR)",
   label: "\"Honiara (SBHIR)"
  },
  {
   value: "\"Lever Harbour (SBLEV)",
   label: "\"Lever Harbour (SBLEV)"
  },
  {
   value: "Lofung (SBLOF)",
   label: "Lofung (SBLOF)"
  },
  {
   value: "\"Marau Sound (SBRUS)",
   label: "\"Marau Sound (SBRUS)"
  },
  {
   value: "\"Mbambanakira (SBMBU)",
   label: "\"Mbambanakira (SBMBU)"
  },
  {
   value: "Vyborg (RUVYG)",
   label: "Vyborg (RUVYG)"
  },
  {
   value: "Yagelnaya Bukhta (RUYAB)",
   label: "Yagelnaya Bukhta (RUYAB)"
  },
  {
   value: "Yagodnyy (RUYAG)",
   label: "Yagodnyy (RUYAG)"
  },
  {
   value: "Yaroslavl (RUIAR)",
   label: "Yaroslavl (RUIAR)"
  },
  {
   value: "Yeysk (RUYEY)",
   label: "Yeysk (RUYEY)"
  },
  {
   value: "Zabaikalsk (RUZBK)",
   label: "Zabaikalsk (RUZBK)"
  },
  {
   value: "\"Zavyalova (RUZAO)",
   label: "\"Zavyalova (RUZAO)"
  },
  {
   value: "Zeleniy Mys (RUZEM)",
   label: "Zeleniy Mys (RUZEM)"
  },
  {
   value: "Zheleznodorozhniy (RUZHL)",
   label: "Zheleznodorozhniy (RUZHL)"
  },
  {
   value: "Akhtubinsk (RUABS)",
   label: "Akhtubinsk (RUABS)"
  },
  {
   value: "Makhachkala (RUMCX)",
   label: "Makhachkala (RUMCX)"
  },
  {
   value: "Kigali (RWKGL)",
   label: "Kigali (RWKGL)"
  },
  {
   value: "Abu Al Khoosh (SAAAK)",
   label: "Abu Al Khoosh (SAAAK)"
  },
  {
   value: "Al Bahah (SABAH)",
   label: "Al Bahah (SABAH)"
  },
  {
   value: "Al Hada (SAAHA)",
   label: "Al Hada (SAAHA)"
  },
  {
   value: "Al Hudaydah (Hodeida) (SAHDY)",
   label: "Al Hudaydah (Hodeida) (SAHDY)"
  },
  {
   value: "Al Kharj (SAAKH)",
   label: "Al Kharj (SAAKH)"
  },
  {
   value: "Al Khobar (SAALK)",
   label: "Al Khobar (SAALK)"
  },
  {
   value: "Ar Rass (SAARR)",
   label: "Ar Rass (SAARR)"
  },
  {
   value: "Bisha (SABHH)",
   label: "Bisha (SABHH)"
  },
  {
   value: "Damman (SADMN)",
   label: "Damman (SADMN)"
  },
  {
   value: "Dhahran (SADHA)",
   label: "Dhahran (SADHA)"
  },
  {
   value: "Dhuba (SADHU)",
   label: "Dhuba (SADHU)"
  },
  {
   value: "Gassim (SAELQ)",
   label: "Gassim (SAELQ)"
  },
  {
   value: "Gizan (SAGIZ)",
   label: "Gizan (SAGIZ)"
  },
  {
   value: "Gurayat (SAURY)",
   label: "Gurayat (SAURY)"
  },
  {
   value: "Hafar al Batin (SAHBT)",
   label: "Hafar al Batin (SAHBT)"
  },
  {
   value: "Hail (SAHAS)",
   label: "Hail (SAHAS)"
  },
  {
   value: "Hofuf (SAHOF)",
   label: "Hofuf (SAHOF)"
  },
  {
   value: "Ienbo (SAIEB)",
   label: "Ienbo (SAIEB)"
  },
  {
   value: "Jeddah (SAJED)",
   label: "Jeddah (SAJED)"
  },
  {
   value: "Jizan (SAJIZ)",
   label: "Jizan (SAJIZ)"
  },
  {
   value: "Jouf (SAAJF)",
   label: "Jouf (SAAJF)"
  },
  {
   value: "Juaymah Terminal (SAJUT)",
   label: "Juaymah Terminal (SAJUT)"
  },
  {
   value: "Jubail (SAJUB)",
   label: "Jubail (SAJUB)"
  },
  {
   value: "Khamis Mushayt (SAKMX)",
   label: "Khamis Mushayt (SAKMX)"
  },
  {
   value: "King Fhad (SAKFH)",
   label: "King Fhad (SAKFH)"
  },
  {
   value: "King Khalid (SAKKH)",
   label: "King Khalid (SAKKH)"
  },
  {
   value: "Lith (SALIT)",
   label: "Lith (SALIT)"
  },
  {
   value: "Makkah (SAMAK)",
   label: "Makkah (SAMAK)"
  },
  {
   value: "Manailih (SAMAN)",
   label: "Manailih (SAMAN)"
  },
  {
   value: "Segezha (RUSEG)",
   label: "Segezha (RUSEG)"
  },
  {
   value: "Serpukhov (RUSHV)",
   label: "Serpukhov (RUSHV)"
  },
  {
   value: "Severo-Kurilsk (RUSVK)",
   label: "Severo-Kurilsk (RUSVK)"
  },
  {
   value: "Severodvinsk (RUSEW)",
   label: "Severodvinsk (RUSEW)"
  },
  {
   value: "Severomorsk (RUSRM)",
   label: "Severomorsk (RUSRM)"
  },
  {
   value: "Shakhtersk (RUSHA)",
   label: "Shakhtersk (RUSHA)"
  },
  {
   value: "Sheremetyevo Apt\/Moscow (RUSVO)",
   label: "Sheremetyevo Apt\/Moscow (RUSVO)"
  },
  {
   value: "Slavyanka (RUSKA)",
   label: "Slavyanka (RUSKA)"
  },
  {
   value: "Sochi (RUSOC)",
   label: "Sochi (RUSOC)"
  },
  {
   value: "Solovyevsk (RUSLV)",
   label: "Solovyevsk (RUSLV)"
  },
  {
   value: "Sovetskaya Gavan (RUSOG)",
   label: "Sovetskaya Gavan (RUSOG)"
  },
  {
   value: "\"Spafaryeva (RUSPA)",
   label: "\"Spafaryeva (RUSPA)"
  },
  {
   value: "St Petersburg (Ex Leningrad) (RULED)",
   label: "St Petersburg (Ex Leningrad) (RULED)"
  },
  {
   value: "Stavropol (RUSTW)",
   label: "Stavropol (RUSTW)"
  },
  {
   value: "Svetlaya (RUSVE)",
   label: "Svetlaya (RUSVE)"
  },
  {
   value: "Svetogorsk (RUSVG)",
   label: "Svetogorsk (RUSVG)"
  },
  {
   value: "Syzran (RUSYZ)",
   label: "Syzran (RUSYZ)"
  },
  {
   value: "Taganrog (RUTAG)",
   label: "Taganrog (RUTAG)"
  },
  {
   value: "Tauisk (RUTAU)",
   label: "Tauisk (RUTAU)"
  },
  {
   value: "Tiksi (RUIKS)",
   label: "Tiksi (RUIKS)"
  },
  {
   value: "Tolyatti (RUTTI)",
   label: "Tolyatti (RUTTI)"
  },
  {
   value: "Trifonov Ruchey (RUTRR)",
   label: "Trifonov Ruchey (RUTRR)"
  },
  {
   value: "Tuapse (RUTUA)",
   label: "Tuapse (RUTUA)"
  },
  {
   value: "Ufa (RUUFA)",
   label: "Ufa (RUUFA)"
  },
  {
   value: "Uglegorsk (RUUGL)",
   label: "Uglegorsk (RUUGL)"
  },
  {
   value: "Ulyanovsk (RUULY)",
   label: "Ulyanovsk (RUULY)"
  },
  {
   value: "Umba (RUUMB)",
   label: "Umba (RUUMB)"
  },
  {
   value: "Ura Guba (RUURA)",
   label: "Ura Guba (RUURA)"
  },
  {
   value: "Ust-Kamchatsk (RUUSK)",
   label: "Ust-Kamchatsk (RUUSK)"
  },
  {
   value: "Vanino (RUVNN)",
   label: "Vanino (RUVNN)"
  },
  {
   value: "Velikaya Kema (RUKMV)",
   label: "Velikaya Kema (RUKMV)"
  },
  {
   value: "Velikij Ustyug (RUVUS)",
   label: "Velikij Ustyug (RUVUS)"
  },
  {
   value: "Vladikaukaz (RUVLA)",
   label: "Vladikaukaz (RUVLA)"
  },
  {
   value: "Vladivostok (RUVVO)",
   label: "Vladivostok (RUVVO)"
  },
  {
   value: "Vnukovo Apt\/Moscow (RUVKO)",
   label: "Vnukovo Apt\/Moscow (RUVKO)"
  },
  {
   value: "Volgograd (RUVOG)",
   label: "Volgograd (RUVOG)"
  },
  {
   value: "\"Vostochniy (RUVYP)",
   label: "\"Vostochniy (RUVYP)"
  },
  {
   value: "\"Vozrozhdeniya (RUVZB)",
   label: "\"Vozrozhdeniya (RUVZB)"
  },
  {
   value: "Vyartsilya (RUVYA)",
   label: "Vyartsilya (RUVYA)"
  },
  {
   value: "Murmansk (RUMMK)",
   label: "Murmansk (RUMMK)"
  },
  {
   value: "Naberzhniye Chelny (RUNAC)",
   label: "Naberzhniye Chelny (RUNAC)"
  },
  {
   value: "Nakhodka (RUNJK)",
   label: "Nakhodka (RUNJK)"
  },
  {
   value: "Naryan Mar (RUNNM)",
   label: "Naryan Mar (RUNNM)"
  },
  {
   value: "Naushki (RUNKI)",
   label: "Naushki (RUNKI)"
  },
  {
   value: "Nevelsk (RUNEV)",
   label: "Nevelsk (RUNEV)"
  },
  {
   value: "Nikolayevsk-na-Amure (RUNIA)",
   label: "Nikolayevsk-na-Amure (RUNIA)"
  },
  {
   value: "Nizhniy Novgorod (Ex Gorkiy) (RUGOJ)",
   label: "Nizhniy Novgorod (Ex Gorkiy) (RUGOJ)"
  },
  {
   value: "\"Novaya Zemlya (RUNOZ)",
   label: "\"Novaya Zemlya (RUNOZ)"
  },
  {
   value: "Novorossiysk (RUNVS)",
   label: "Novorossiysk (RUNVS)"
  },
  {
   value: "Novosibirsk (RUOVB)",
   label: "Novosibirsk (RUOVB)"
  },
  {
   value: "Okhotsk (RUOHO)",
   label: "Okhotsk (RUOHO)"
  },
  {
   value: "Oktiabrskij (RUOKT)",
   label: "Oktiabrskij (RUOKT)"
  },
  {
   value: "\"Oleniy (RUOLO)",
   label: "\"Oleniy (RUOLO)"
  },
  {
   value: "\"Olenya (RUOLG)",
   label: "\"Olenya (RUOLG)"
  },
  {
   value: "Omsk (RUOMS)",
   label: "Omsk (RUOMS)"
  },
  {
   value: "Onega (RUONG)",
   label: "Onega (RUONG)"
  },
  {
   value: "Or'ol (RUORL)",
   label: "Or'ol (RUORL)"
  },
  {
   value: "Orenburg (RUORE)",
   label: "Orenburg (RUORE)"
  },
  {
   value: "\"Ozerko (RUOZK)",
   label: "\"Ozerko (RUOZK)"
  },
  {
   value: "Pavlovo (RUPLO)",
   label: "Pavlovo (RUPLO)"
  },
  {
   value: "Pechenga (RUPCE)",
   label: "Pechenga (RUPCE)"
  },
  {
   value: "Pechora (RUPEX)",
   label: "Pechora (RUPEX)"
  },
  {
   value: "Petrokrepost (RUPEK)",
   label: "Petrokrepost (RUPEK)"
  },
  {
   value: "Petropavlovsk-Kamchatskiy (RUPKC)",
   label: "Petropavlovsk-Kamchatskiy (RUPKC)"
  },
  {
   value: "Petrozavodsk (RUPES)",
   label: "Petrozavodsk (RUPES)"
  },
  {
   value: "Pevek (RUPWE)",
   label: "Pevek (RUPWE)"
  },
  {
   value: "Plastun (RUPTN)",
   label: "Plastun (RUPTN)"
  },
  {
   value: "Poronaisk (RUPRN)",
   label: "Poronaisk (RUPRN)"
  },
  {
   value: "Posyet (RUPSE)",
   label: "Posyet (RUPSE)"
  },
  {
   value: "Primorsk (Koivisto) (RUPRI)",
   label: "Primorsk (Koivisto) (RUPRI)"
  },
  {
   value: "\"Provideniya (RUPVS)",
   label: "\"Provideniya (RUPVS)"
  },
  {
   value: "Pskov (RUPKV)",
   label: "Pskov (RUPKV)"
  },
  {
   value: "Pudozh (RUPUD)",
   label: "Pudozh (RUPUD)"
  },
  {
   value: "Rostov (RUROV)",
   label: "Rostov (RUROV)"
  },
  {
   value: "Rudnaya Pristan (RURDP)",
   label: "Rudnaya Pristan (RURDP)"
  },
  {
   value: "Rybinsk (RURYB)",
   label: "Rybinsk (RURYB)"
  },
  {
   value: "Samara (Ex Kuibyshev) (RUKUF)",
   label: "Samara (Ex Kuibyshev) (RUKUF)"
  },
  {
   value: "Saratov (RURTW)",
   label: "Saratov (RURTW)"
  },
  {
   value: "Iokanka (RUIOK)",
   label: "Iokanka (RUIOK)"
  },
  {
   value: "Irkutsk (RUIKT)",
   label: "Irkutsk (RUIKT)"
  },
  {
   value: "Ivangorod (RUIVA)",
   label: "Ivangorod (RUIVA)"
  },
  {
   value: "Kaliningrad (RUKGD)",
   label: "Kaliningrad (RUKGD)"
  },
  {
   value: "Kaliningrad(Moskowskaja) (RUKAD)",
   label: "Kaliningrad(Moskowskaja) (RUKAD)"
  },
  {
   value: "Kamskoye Ustye (RUKMU)",
   label: "Kamskoye Ustye (RUKMU)"
  },
  {
   value: "Kandalaksha (RUKAN)",
   label: "Kandalaksha (RUKAN)"
  },
  {
   value: "Kazan (RUKZN)",
   label: "Kazan (RUKZN)"
  },
  {
   value: "Kem (RUKEM)",
   label: "Kem (RUKEM)"
  },
  {
   value: "Keret (RUKER)",
   label: "Keret (RUKER)"
  },
  {
   value: "Khabarovsk (RUKHV)",
   label: "Khabarovsk (RUKHV)"
  },
  {
   value: "Khasan (RUKHS)",
   label: "Khasan (RUKHS)"
  },
  {
   value: "Kholmsk (RUKHO)",
   label: "Kholmsk (RUKHO)"
  },
  {
   value: "Khyrov (RUHYR)",
   label: "Khyrov (RUHYR)"
  },
  {
   value: "Kildin (RUKDN)",
   label: "Kildin (RUKDN)"
  },
  {
   value: "Kineshma (RUKIN)",
   label: "Kineshma (RUKIN)"
  },
  {
   value: "Kirov (RUKVX)",
   label: "Kirov (RUKVX)"
  },
  {
   value: "Kislaya Guba (RUKSL)",
   label: "Kislaya Guba (RUKSL)"
  },
  {
   value: "Korf (RUKRF)",
   label: "Korf (RUKRF)"
  },
  {
   value: "Korsakov (RUKOR)",
   label: "Korsakov (RUKOR)"
  },
  {
   value: "Krasnodar (RUKRR)",
   label: "Krasnodar (RUKRR)"
  },
  {
   value: "Krasnojarsk (RUKJA)",
   label: "Krasnojarsk (RUKJA)"
  },
  {
   value: "Krasnovodsk (RUKNV)",
   label: "Krasnovodsk (RUKNV)"
  },
  {
   value: "Kronshtadt (RUKDT)",
   label: "Kronshtadt (RUKDT)"
  },
  {
   value: "Kultuk (RUKUL)",
   label: "Kultuk (RUKUL)"
  },
  {
   value: "Kursk (RUURS)",
   label: "Kursk (RUURS)"
  },
  {
   value: "Lazarev (RULAZ)",
   label: "Lazarev (RULAZ)"
  },
  {
   value: "Linakhamari (RULNR)",
   label: "Linakhamari (RULNR)"
  },
  {
   value: "Lipetsk (Lipeck) (RULPK)",
   label: "Lipetsk (Lipeck) (RULPK)"
  },
  {
   value: "Lomonosov (RULOM)",
   label: "Lomonosov (RULOM)"
  },
  {
   value: "Luzhaika (RULKA)",
   label: "Luzhaika (RULKA)"
  },
  {
   value: "\"Magadansky (RUMAG)",
   label: "\"Magadansky (RUMAG)"
  },
  {
   value: "Mago (RUMGO)",
   label: "Mago (RUMGO)"
  },
  {
   value: "Malaya Kheta (RUKMM)",
   label: "Malaya Kheta (RUKMM)"
  },
  {
   value: "Mamonova (RUMMO)",
   label: "Mamonova (RUMMO)"
  },
  {
   value: "Medvezhyegorsk (RUMEG)",
   label: "Medvezhyegorsk (RUMEG)"
  },
  {
   value: "Mezen (RUMEZ)",
   label: "Mezen (RUMEZ)"
  },
  {
   value: "Mineralnye Vody (RUMRV)",
   label: "Mineralnye Vody (RUMRV)"
  },
  {
   value: "Mondy (RUMND)",
   label: "Mondy (RUMND)"
  },
  {
   value: "Moskalvo (RUMVO)",
   label: "Moskalvo (RUMVO)"
  },
  {
   value: "Moskva (RUMOW)",
   label: "Moskva (RUMOW)"
  },
  {
   value: "Tirgu Mures (ROTGM)",
   label: "Tirgu Mures (ROTGM)"
  },
  {
   value: "Tulcea (ROTCE)",
   label: "Tulcea (ROTCE)"
  },
  {
   value: "Turnu Magurele (ROTUM)",
   label: "Turnu Magurele (ROTUM)"
  },
  {
   value: "Valea Luimihai (ROVAM)",
   label: "Valea Luimihai (ROVAM)"
  },
  {
   value: "Vama Veche (ROVAV)",
   label: "Vama Veche (ROVAV)"
  },
  {
   value: "Varsand (ROVAS)",
   label: "Varsand (ROVAS)"
  },
  {
   value: "Vicsani (ROVIS)",
   label: "Vicsani (ROVIS)"
  },
  {
   value: "Zimnicea (ROZIC)",
   label: "Zimnicea (ROZIC)"
  },
  {
   value: "Adler\/Sochi (RUAER)",
   label: "Adler\/Sochi (RUAER)"
  },
  {
   value: "Akhtari (RUAHR)",
   label: "Akhtari (RUAHR)"
  },
  {
   value: "Almetyevsk (RUATK)",
   label: "Almetyevsk (RUATK)"
  },
  {
   value: "Ambetsu (RUAMB)",
   label: "Ambetsu (RUAMB)"
  },
  {
   value: "Anadyr (RUDYR)",
   label: "Anadyr (RUDYR)"
  },
  {
   value: "Anapa (RUAAQ)",
   label: "Anapa (RUAAQ)"
  },
  {
   value: "Arkhangelsk (RUARH)",
   label: "Arkhangelsk (RUARH)"
  },
  {
   value: "Arman (Magadan) (RUARM)",
   label: "Arman (Magadan) (RUARM)"
  },
  {
   value: "Astrakhan (RUASF)",
   label: "Astrakhan (RUASF)"
  },
  {
   value: "Azov (RUAZO)",
   label: "Azov (RUAZO)"
  },
  {
   value: "Bagrationovsk (RUBGR)",
   label: "Bagrationovsk (RUBGR)"
  },
  {
   value: "Balakovo (RUBWO)",
   label: "Balakovo (RUBWO)"
  },
  {
   value: "Baltiysk (RUBLT)",
   label: "Baltiysk (RUBLT)"
  },
  {
   value: "Bektyashka (RUBKH)",
   label: "Bektyashka (RUBKH)"
  },
  {
   value: "Belomorsk (RUBEM)",
   label: "Belomorsk (RUBEM)"
  },
  {
   value: "Belushye (RUBEL)",
   label: "Belushye (RUBEL)"
  },
  {
   value: "\"Beringovskiy (RUBER)",
   label: "\"Beringovskiy (RUBER)"
  },
  {
   value: "Biysk (RUBIY)",
   label: "Biysk (RUBIY)"
  },
  {
   value: "Blagoveschensk (RUBQS)",
   label: "Blagoveschensk (RUBQS)"
  },
  {
   value: "Bratsk (RUBTK)",
   label: "Bratsk (RUBTK)"
  },
  {
   value: "Bukhta Olga (RUOLB)",
   label: "Bukhta Olga (RUOLB)"
  },
  {
   value: "Cherepovets (RUCEE)",
   label: "Cherepovets (RUCEE)"
  },
  {
   value: "Chikacheva (RUCIH)",
   label: "Chikacheva (RUCIH)"
  },
  {
   value: "De-Kastri (RUDKA)",
   label: "De-Kastri (RUDKA)"
  },
  {
   value: "Domedovo Apt\/Moscow (RUDME)",
   label: "Domedovo Apt\/Moscow (RUDME)"
  },
  {
   value: "Dudinka (RUDUD)",
   label: "Dudinka (RUDUD)"
  },
  {
   value: "Dyaikovo (RUDYA)",
   label: "Dyaikovo (RUDYA)"
  },
  {
   value: "Egvekinot (RUEGV)",
   label: "Egvekinot (RUEGV)"
  },
  {
   value: "Golchikka (RUGKA)",
   label: "Golchikka (RUGKA)"
  },
  {
   value: "Gremikha (RUGRH)",
   label: "Gremikha (RUGRH)"
  },
  {
   value: "Grodekovo (RUGRK)",
   label: "Grodekovo (RUGRK)"
  },
  {
   value: "Igarka (RUIAA)",
   label: "Igarka (RUIAA)"
  },
  {
   value: "Giurgiu Nord (ROGRN)",
   label: "Giurgiu Nord (ROGRN)"
  },
  {
   value: "Halmeu (ROHAL)",
   label: "Halmeu (ROHAL)"
  },
  {
   value: "Iasi (ROIAS)",
   label: "Iasi (ROIAS)"
  },
  {
   value: "Jimbolia (ROJIL)",
   label: "Jimbolia (ROJIL)"
  },
  {
   value: "Mangalia (ROMAG)",
   label: "Mangalia (ROMAG)"
  },
  {
   value: "Medgidia (ROMED)",
   label: "Medgidia (ROMED)"
  },
  {
   value: "Midia (ROMID)",
   label: "Midia (ROMID)"
  },
  {
   value: "Moldova Veche (ROMOV)",
   label: "Moldova Veche (ROMOV)"
  },
  {
   value: "Naidas (RONAD)",
   label: "Naidas (RONAD)"
  },
  {
   value: "Negru Voda (RONEV)",
   label: "Negru Voda (RONEV)"
  },
  {
   value: "Nicolae Balcescu (RONIB)",
   label: "Nicolae Balcescu (RONIB)"
  },
  {
   value: "Nicolina (RONIN)",
   label: "Nicolina (RONIN)"
  },
  {
   value: "Oltenita (ROOLT)",
   label: "Oltenita (ROOLT)"
  },
  {
   value: "Oradea (ROOMR)",
   label: "Oradea (ROOMR)"
  },
  {
   value: "Orsova (ROORV)",
   label: "Orsova (ROORV)"
  },
  {
   value: "Otopeni Apt\/Bucuresti (ROOTP)",
   label: "Otopeni Apt\/Bucuresti (ROOTP)"
  },
  {
   value: "Piatra Neamt (ROPIN)",
   label: "Piatra Neamt (ROPIN)"
  },
  {
   value: "Pitesti (ROPIT)",
   label: "Pitesti (ROPIT)"
  },
  {
   value: "Ploiesti Triaj (ROPLT)",
   label: "Ploiesti Triaj (ROPLT)"
  },
  {
   value: "Portile De Fier Doi (ROPFD)",
   label: "Portile De Fier Doi (ROPFD)"
  },
  {
   value: "Portile De Fier Unu (ROPFU)",
   label: "Portile De Fier Unu (ROPFU)"
  },
  {
   value: "Radauti (RORAU)",
   label: "Radauti (RORAU)"
  },
  {
   value: "Resita Nord (ROREN)",
   label: "Resita Nord (ROREN)"
  },
  {
   value: "Resita Sud (RORES)",
   label: "Resita Sud (RORES)"
  },
  {
   value: "Rimnicu Vilcea (RORIV)",
   label: "Rimnicu Vilcea (RORIV)"
  },
  {
   value: "Roznov (RORZV)",
   label: "Roznov (RORZV)"
  },
  {
   value: "Salonta (ROSAT)",
   label: "Salonta (ROSAT)"
  },
  {
   value: "Satu Mare (ROSUJ)",
   label: "Satu Mare (ROSUJ)"
  },
  {
   value: "Sibiu (ROSBZ)",
   label: "Sibiu (ROSBZ)"
  },
  {
   value: "Sighetu Marmatiei (ROSIM)",
   label: "Sighetu Marmatiei (ROSIM)"
  },
  {
   value: "Simeria Triaj (ROSIT)",
   label: "Simeria Triaj (ROSIT)"
  },
  {
   value: "Socola (ROSOL)",
   label: "Socola (ROSOL)"
  },
  {
   value: "Someseni (ROSOM)",
   label: "Someseni (ROSOM)"
  },
  {
   value: "Stamora Moravita (ROSTM)",
   label: "Stamora Moravita (ROSTM)"
  },
  {
   value: "Suceava (ROSCV)",
   label: "Suceava (ROSCV)"
  },
  {
   value: "Suceava Nord (ROSUN)",
   label: "Suceava Nord (ROSUN)"
  },
  {
   value: "Sulina (Port et Zone Franche) (ROSUL)",
   label: "Sulina (Port et Zone Franche) (ROSUL)"
  },
  {
   value: "Timisoara (ROTSR)",
   label: "Timisoara (ROTSR)"
  },
  {
   value: "Timisoara Nord (ROTSN)",
   label: "Timisoara Nord (ROTSN)"
  },
  {
   value: "Umm Said (QAUMS)",
   label: "Umm Said (QAUMS)"
  },
  {
   value: "Le Port (RELPT)",
   label: "Le Port (RELPT)"
  },
  {
   value: "Pointe des Galets (REPDG)",
   label: "Pointe des Galets (REPDG)"
  },
  {
   value: "St Denis de La Reunion (RERUN)",
   label: "St Denis de La Reunion (RERUN)"
  },
  {
   value: "Agigea (ROAGI)",
   label: "Agigea (ROAGI)"
  },
  {
   value: "Arad (ROARW)",
   label: "Arad (ROARW)"
  },
  {
   value: "Bacau (ROBCM)",
   label: "Bacau (ROBCM)"
  },
  {
   value: "Baia Mare (ROBAY)",
   label: "Baia Mare (ROBAY)"
  },
  {
   value: "Baneasa Apt\/Bucuresti (ROBPU)",
   label: "Baneasa Apt\/Bucuresti (ROBPU)"
  },
  {
   value: "Basarabi (ROBAB)",
   label: "Basarabi (ROBAB)"
  },
  {
   value: "Bistrita (ROBIT)",
   label: "Bistrita (ROBIT)"
  },
  {
   value: "Bors (ROBOR)",
   label: "Bors (ROBOR)"
  },
  {
   value: "Botosani (ROBOS)",
   label: "Botosani (ROBOS)"
  },
  {
   value: "Braila (ROBRA)",
   label: "Braila (ROBRA)"
  },
  {
   value: "Brasov (ROBRV)",
   label: "Brasov (ROBRV)"
  },
  {
   value: "Bucuresti (ROBUH)",
   label: "Bucuresti (ROBUH)"
  },
  {
   value: "Bucuresti 50 Vama (ROBUV)",
   label: "Bucuresti 50 Vama (ROBUV)"
  },
  {
   value: "Bucuresti Basarab (ROBUB)",
   label: "Bucuresti Basarab (ROBUB)"
  },
  {
   value: "Bucuresti Intrepozite (ROBUI)",
   label: "Bucuresti Intrepozite (ROBUI)"
  },
  {
   value: "Bucuresti Nord (ROBUN)",
   label: "Bucuresti Nord (ROBUN)"
  },
  {
   value: "Bucuresti-Baneasa Apt (ROBBU)",
   label: "Bucuresti-Baneasa Apt (ROBBU)"
  },
  {
   value: "Buzau (ROBUZ)",
   label: "Buzau (ROBUZ)"
  },
  {
   value: "Calafat (ROCAF)",
   label: "Calafat (ROCAF)"
  },
  {
   value: "Calarasi (ROCAS)",
   label: "Calarasi (ROCAS)"
  },
  {
   value: "Caransebes (ROCSB)",
   label: "Caransebes (ROCSB)"
  },
  {
   value: "Carei (ROCAR)",
   label: "Carei (ROCAR)"
  },
  {
   value: "Cernavoda (ROCEV)",
   label: "Cernavoda (ROCEV)"
  },
  {
   value: "Cluj Napoca (ROCLJ)",
   label: "Cluj Napoca (ROCLJ)"
  },
  {
   value: "Constanta (ROCND)",
   label: "Constanta (ROCND)"
  },
  {
   value: "Corabia (ROCOB)",
   label: "Corabia (ROCOB)"
  },
  {
   value: "Craiova (ROCRA)",
   label: "Craiova (ROCRA)"
  },
  {
   value: "Curtici (ROCUT)",
   label: "Curtici (ROCUT)"
  },
  {
   value: "Dornesti (RODOR)",
   label: "Dornesti (RODOR)"
  },
  {
   value: "Drobeta Turnu Severin (RODTS)",
   label: "Drobeta Turnu Severin (RODTS)"
  },
  {
   value: "Episcopia Bihor (ROEPB)",
   label: "Episcopia Bihor (ROEPB)"
  },
  {
   value: "Falciu (ROFAC)",
   label: "Falciu (ROFAC)"
  },
  {
   value: "Focsani (ROFOS)",
   label: "Focsani (ROFOS)"
  },
  {
   value: "Galati (ROGAL)",
   label: "Galati (ROGAL)"
  },
  {
   value: "Galati Transbordare (ROGAT)",
   label: "Galati Transbordare (ROGAT)"
  },
  {
   value: "Giurgiu (ROGRG)",
   label: "Giurgiu (ROGRG)"
  },
  {
   value: "Seixal (PTSEI)",
   label: "Seixal (PTSEI)"
  },
  {
   value: "Setubal (PTSET)",
   label: "Setubal (PTSET)"
  },
  {
   value: "Sines (PTSIE)",
   label: "Sines (PTSIE)"
  },
  {
   value: "Soure (PTSOU)",
   label: "Soure (PTSOU)"
  },
  {
   value: "Terceira Island (PTTER)",
   label: "Terceira Island (PTTER)"
  },
  {
   value: "Tomar (PTTMR)",
   label: "Tomar (PTTMR)"
  },
  {
   value: "Torres Novas (PTTNV)",
   label: "Torres Novas (PTTNV)"
  },
  {
   value: "Torres Vedras (PTTVE)",
   label: "Torres Vedras (PTTVE)"
  },
  {
   value: "Tramagal (PTTGL)",
   label: "Tramagal (PTTGL)"
  },
  {
   value: "Trofa (PTTRO)",
   label: "Trofa (PTTRO)"
  },
  {
   value: "Valongo (PTVAL)",
   label: "Valongo (PTVAL)"
  },
  {
   value: "Velas (PTVEL)",
   label: "Velas (PTVEL)"
  },
  {
   value: "Vialonga (PTVIA)",
   label: "Vialonga (PTVIA)"
  },
  {
   value: "Viana Do Castelo (PTVDC)",
   label: "Viana Do Castelo (PTVDC)"
  },
  {
   value: "Vila da ponte (PTVLD)",
   label: "Vila da ponte (PTVLD)"
  },
  {
   value: "Vila do Porto (PTVDP)",
   label: "Vila do Porto (PTVDP)"
  },
  {
   value: "Vila Franca De Xira (PTVFX)",
   label: "Vila Franca De Xira (PTVFX)"
  },
  {
   value: "Vila Nova de Famalicao (PTVNF)",
   label: "Vila Nova de Famalicao (PTVNF)"
  },
  {
   value: "Vila Nova De Gaia (PTVNG)",
   label: "Vila Nova De Gaia (PTVNG)"
  },
  {
   value: "Vila Nova do Corvo (PTVNC)",
   label: "Vila Nova do Corvo (PTVNC)"
  },
  {
   value: "Vila Real de Santo Antonio (PTVRL)",
   label: "Vila Real de Santo Antonio (PTVRL)"
  },
  {
   value: "Viseu (PTVSE)",
   label: "Viseu (PTVSE)"
  },
  {
   value: "Zona Franca da Madeira (PTZFM)",
   label: "Zona Franca da Madeira (PTZFM)"
  },
  {
   value: "Cesar (PTCSR)",
   label: "Cesar (PTCSR)"
  },
  {
   value: "Famalicao (PTFAM)",
   label: "Famalicao (PTFAM)"
  },
  {
   value: "Loures (PTLRS)",
   label: "Loures (PTLRS)"
  },
  {
   value: "Angaur (PWANG)",
   label: "Angaur (PWANG)"
  },
  {
   value: "Koror (PWROR)",
   label: "Koror (PWROR)"
  },
  {
   value: "Asuncion (PYASU)",
   label: "Asuncion (PYASU)"
  },
  {
   value: "Ciudad del Este (PYAGT)",
   label: "Ciudad del Este (PYAGT)"
  },
  {
   value: "Concepcion (PYCNP)",
   label: "Concepcion (PYCNP)"
  },
  {
   value: "Encarnacion (PYENO)",
   label: "Encarnacion (PYENO)"
  },
  {
   value: "Ita Enramada (PYITE)",
   label: "Ita Enramada (PYITE)"
  },
  {
   value: "Pilar (PYPIL)",
   label: "Pilar (PYPIL)"
  },
  {
   value: "San Antonio (PYSAN)",
   label: "San Antonio (PYSAN)"
  },
  {
   value: "San Lorenzo (PYSLO)",
   label: "San Lorenzo (PYSLO)"
  },
  {
   value: "Villeta (PYVLL)",
   label: "Villeta (PYVLL)"
  },
  {
   value: "Doha (QADOH)",
   label: "Doha (QADOH)"
  },
  {
   value: "Halul (QAHAL)",
   label: "Halul (QAHAL)"
  },
  {
   value: "Hanna (QAHNA)",
   label: "Hanna (QAHNA)"
  },
  {
   value: "Ovar (PTOVA)",
   label: "Ovar (PTOVA)"
  },
  {
   value: "Palmela (PTPAL)",
   label: "Palmela (PTPAL)"
  },
  {
   value: "Peniche (PTPEN)",
   label: "Peniche (PTPEN)"
  },
  {
   value: "Pero Pinheiro (PTPPH)",
   label: "Pero Pinheiro (PTPPH)"
  },
  {
   value: "Piedade (PTPID)",
   label: "Piedade (PTPID)"
  },
  {
   value: "Plombal (PTPLO)",
   label: "Plombal (PTPLO)"
  },
  {
   value: "Pomaron (PTPOM)",
   label: "Pomaron (PTPOM)"
  },
  {
   value: "Pombal (PTPOB)",
   label: "Pombal (PTPOB)"
  },
  {
   value: "Ponta Delgada (PTPDL)",
   label: "Ponta Delgada (PTPDL)"
  },
  {
   value: "Ponte de Sor (PTPDS)",
   label: "Ponte de Sor (PTPDS)"
  },
  {
   value: "Portalegre (PTPOR)",
   label: "Portalegre (PTPOR)"
  },
  {
   value: "Portimao (PTPRM)",
   label: "Portimao (PTPRM)"
  },
  {
   value: "Porto (PTOPO)",
   label: "Porto (PTOPO)"
  },
  {
   value: "Porto de Mos (PTPDM)",
   label: "Porto de Mos (PTPDM)"
  },
  {
   value: "Porto Santo (PTPXO)",
   label: "Porto Santo (PTPXO)"
  },
  {
   value: "Povoa de Santa Iria (PTPSI)",
   label: "Povoa de Santa Iria (PTPSI)"
  },
  {
   value: "Povoa de Varzim (PTPDV)",
   label: "Povoa de Varzim (PTPDV)"
  },
  {
   value: "Praia da Vitoria (PTPRV)",
   label: "Praia da Vitoria (PTPRV)"
  },
  {
   value: "Praia do Graziosa (PTPRG)",
   label: "Praia do Graziosa (PTPRG)"
  },
  {
   value: "Puerto Real (PTPUE)",
   label: "Puerto Real (PTPUE)"
  },
  {
   value: "Queluz (PTQDB)",
   label: "Queluz (PTQDB)"
  },
  {
   value: "Revidem (PTREV)",
   label: "Revidem (PTREV)"
  },
  {
   value: "Rio de Mouro (PTRDM)",
   label: "Rio de Mouro (PTRDM)"
  },
  {
   value: "Rio Maior (PTRMA)",
   label: "Rio Maior (PTRMA)"
  },
  {
   value: "Rio Tinto (PTRTI)",
   label: "Rio Tinto (PTRTI)"
  },
  {
   value: "Riomeao (PTRIO)",
   label: "Riomeao (PTRIO)"
  },
  {
   value: "S Cosme do Vale (PTSCV)",
   label: "S Cosme do Vale (PTSCV)"
  },
  {
   value: "Sacavem (PTSAC)",
   label: "Sacavem (PTSAC)"
  },
  {
   value: "Salgueiro (PTSGU)",
   label: "Salgueiro (PTSGU)"
  },
  {
   value: "Salir de Matos (PTSDM)",
   label: "Salir de Matos (PTSDM)"
  },
  {
   value: "Sangalhos (PTSAN)",
   label: "Sangalhos (PTSAN)"
  },
  {
   value: "Santa Cruz das Flores (PTSCF)",
   label: "Santa Cruz das Flores (PTSCF)"
  },
  {
   value: "Santa Cruz de Graciosa (PTSCG)",
   label: "Santa Cruz de Graciosa (PTSCG)"
  },
  {
   value: "Santa Maria (PTSMA)",
   label: "Santa Maria (PTSMA)"
  },
  {
   value: "Santa Maria De Lamas (PTSML)",
   label: "Santa Maria De Lamas (PTSML)"
  },
  {
   value: "Santarem (PTSNT)",
   label: "Santarem (PTSNT)"
  },
  {
   value: "Santo Tirso (PTSTI)",
   label: "Santo Tirso (PTSTI)"
  },
  {
   value: "Sâo Mateus (PTSMT)",
   label: "Sâo Mateus (PTSMT)"
  },
  {
   value: "Sao Miguel (PTSMI)",
   label: "Sao Miguel (PTSMI)"
  },
  {
   value: "Flores Island (PTFLW)",
   label: "Flores Island (PTFLW)"
  },
  {
   value: "Freixierio (PTFXO)",
   label: "Freixierio (PTFXO)"
  },
  {
   value: "\"Funchal (PTFNC)",
   label: "\"Funchal (PTFNC)"
  },
  {
   value: "Gondomar (PTGON)",
   label: "Gondomar (PTGON)"
  },
  {
   value: "Grijo (PTGRI)",
   label: "Grijo (PTGRI)"
  },
  {
   value: "Guarda (PTGDA)",
   label: "Guarda (PTGDA)"
  },
  {
   value: "Guimaraes (PTGUI)",
   label: "Guimaraes (PTGUI)"
  },
  {
   value: "Horta (PTHOR)",
   label: "Horta (PTHOR)"
  },
  {
   value: "Ilhavo (PTILH)",
   label: "Ilhavo (PTILH)"
  },
  {
   value: "Lagoa Algarve (PTLGA)",
   label: "Lagoa Algarve (PTLGA)"
  },
  {
   value: "Lagos (PTLOS)",
   label: "Lagos (PTLOS)"
  },
  {
   value: "Lajes da Pico (PTLDP)",
   label: "Lajes da Pico (PTLDP)"
  },
  {
   value: "Lajes das Flores (PTLAJ)",
   label: "Lajes das Flores (PTLAJ)"
  },
  {
   value: "Leiria (PTLEA)",
   label: "Leiria (PTLEA)"
  },
  {
   value: "Leirosa (PTLER)",
   label: "Leirosa (PTLER)"
  },
  {
   value: "Leixoes (PTLEI)",
   label: "Leixoes (PTLEI)"
  },
  {
   value: "Linda a Velha (PTLAV)",
   label: "Linda a Velha (PTLAV)"
  },
  {
   value: "Linho (PTLSI)",
   label: "Linho (PTLSI)"
  },
  {
   value: "Lisboa (PTLIS)",
   label: "Lisboa (PTLIS)"
  },
  {
   value: "Lourosa (PTLOU)",
   label: "Lourosa (PTLOU)"
  },
  {
   value: "Lousada (PTLOA)",
   label: "Lousada (PTLOA)"
  },
  {
   value: "Madalena (PTMAD)",
   label: "Madalena (PTMAD)"
  },
  {
   value: "Mafra (PTMFR)",
   label: "Mafra (PTMFR)"
  },
  {
   value: "Maia (PTMAI)",
   label: "Maia (PTMAI)"
  },
  {
   value: "Marco de Canavezes (PTMRC)",
   label: "Marco de Canavezes (PTMRC)"
  },
  {
   value: "Marimha Grande (PTMGR)",
   label: "Marimha Grande (PTMGR)"
  },
  {
   value: "Matosinhos (PTMAT)",
   label: "Matosinhos (PTMAT)"
  },
  {
   value: "Memoriz (PTMEM)",
   label: "Memoriz (PTMEM)"
  },
  {
   value: "Men Martins (PTMMA)",
   label: "Men Martins (PTMMA)"
  },
  {
   value: "Minde (PTMIN)",
   label: "Minde (PTMIN)"
  },
  {
   value: "Montijo (PTMON)",
   label: "Montijo (PTMON)"
  },
  {
   value: "Morelena (PTMOR)",
   label: "Morelena (PTMOR)"
  },
  {
   value: "Mozelos (PTMZL)",
   label: "Mozelos (PTMZL)"
  },
  {
   value: "Murca (PTMUR)",
   label: "Murca (PTMUR)"
  },
  {
   value: "Nelas (PTNEL)",
   label: "Nelas (PTNEL)"
  },
  {
   value: "Odivelas (PTODI)",
   label: "Odivelas (PTODI)"
  },
  {
   value: "Oeiras (PTOEI)",
   label: "Oeiras (PTOEI)"
  },
  {
   value: "Olhao (PTOLH)",
   label: "Olhao (PTOLH)"
  },
  {
   value: "Oliveira de Azemeis (PTODA)",
   label: "Oliveira de Azemeis (PTODA)"
  },
  {
   value: "Oliveira do Bairro (PTOLI)",
   label: "Oliveira do Bairro (PTOLI)"
  },
  {
   value: "Outeiro (PTOUT)",
   label: "Outeiro (PTOUT)"
  },
  {
   value: "Alverca (PTALV)",
   label: "Alverca (PTALV)"
  },
  {
   value: "Amadora (PTAMA)",
   label: "Amadora (PTAMA)"
  },
  {
   value: "Anadia (PTANA)",
   label: "Anadia (PTANA)"
  },
  {
   value: "Angra do Heroismo (PTADH)",
   label: "Angra do Heroismo (PTADH)"
  },
  {
   value: "Arbunheira (PTARB)",
   label: "Arbunheira (PTARB)"
  },
  {
   value: "Avanca (PTAVC)",
   label: "Avanca (PTAVC)"
  },
  {
   value: "Aveiras de Cima (PTADC)",
   label: "Aveiras de Cima (PTADC)"
  },
  {
   value: "Aveiro (PTAVE)",
   label: "Aveiro (PTAVE)"
  },
  {
   value: "Azambuja (PTAZA)",
   label: "Azambuja (PTAZA)"
  },
  {
   value: "Banatica\/Lisboa (PTBAN)",
   label: "Banatica\/Lisboa (PTBAN)"
  },
  {
   value: "Barcelos (PTBAR)",
   label: "Barcelos (PTBAR)"
  },
  {
   value: "Barreiro (PTBRO)",
   label: "Barreiro (PTBRO)"
  },
  {
   value: "Batalha (PTBAT)",
   label: "Batalha (PTBAT)"
  },
  {
   value: "Belém (PTBML)",
   label: "Belém (PTBML)"
  },
  {
   value: "Bombarral (PTBOM)",
   label: "Bombarral (PTBOM)"
  },
  {
   value: "Braga (PTBGZ)",
   label: "Braga (PTBGZ)"
  },
  {
   value: "Cabeco (PTCAB)",
   label: "Cabeco (PTCAB)"
  },
  {
   value: "Cacem (PTCAC)",
   label: "Cacem (PTCAC)"
  },
  {
   value: "Cais do Pico (PTCDP)",
   label: "Cais do Pico (PTCDP)"
  },
  {
   value: "Caldas da Reinha (PTCDR)",
   label: "Caldas da Reinha (PTCDR)"
  },
  {
   value: "Calheta (PTCAL)",
   label: "Calheta (PTCAL)"
  },
  {
   value: "Camarate (PTCMT)",
   label: "Camarate (PTCMT)"
  },
  {
   value: "Carregado (PTCRR)",
   label: "Carregado (PTCRR)"
  },
  {
   value: "Cartaxo (PTCXO)",
   label: "Cartaxo (PTCXO)"
  },
  {
   value: "Carvalhos (PTCAR)",
   label: "Carvalhos (PTCAR)"
  },
  {
   value: "Cascais (PTCAS)",
   label: "Cascais (PTCAS)"
  },
  {
   value: "Castelo Branco (PTCBR)",
   label: "Castelo Branco (PTCBR)"
  },
  {
   value: "Coimbrao (PTCOI)",
   label: "Coimbrao (PTCOI)"
  },
  {
   value: "Condeixa a Nova (PTCAN)",
   label: "Condeixa a Nova (PTCAN)"
  },
  {
   value: "Constanzia (PTCON)",
   label: "Constanzia (PTCON)"
  },
  {
   value: "Covilha (PTCOV)",
   label: "Covilha (PTCOV)"
  },
  {
   value: "Espinho (PTESP)",
   label: "Espinho (PTESP)"
  },
  {
   value: "Estoril (PTEST)",
   label: "Estoril (PTEST)"
  },
  {
   value: "Estremoz (PTESZ)",
   label: "Estremoz (PTESZ)"
  },
  {
   value: "Evora (PTEVR)",
   label: "Evora (PTEVR)"
  },
  {
   value: "Fafundo (PTFAF)",
   label: "Fafundo (PTFAF)"
  },
  {
   value: "Faial (PTFIL)",
   label: "Faial (PTFIL)"
  },
  {
   value: "Faro (PTFAO)",
   label: "Faro (PTFAO)"
  },
  {
   value: "Fatima (PTFTM)",
   label: "Fatima (PTFTM)"
  },
  {
   value: "Felgueiras (PTFEL)",
   label: "Felgueiras (PTFEL)"
  },
  {
   value: "Figueira da Foz (PTFDF)",
   label: "Figueira da Foz (PTFDF)"
  },
  {
   value: "Isabela (PRISB)",
   label: "Isabela (PRISB)"
  },
  {
   value: "Jayuya (PRJAY)",
   label: "Jayuya (PRJAY)"
  },
  {
   value: "Jicome (PRJIC)",
   label: "Jicome (PRJIC)"
  },
  {
   value: "Juana Diaz (PRJDI)",
   label: "Juana Diaz (PRJDI)"
  },
  {
   value: "Juncos (PRJUN)",
   label: "Juncos (PRJUN)"
  },
  {
   value: "Lajas (PRLJS)",
   label: "Lajas (PRLJS)"
  },
  {
   value: "Las Mareas (Guayama) (PRLAM)",
   label: "Las Mareas (Guayama) (PRLAM)"
  },
  {
   value: "Luquillo (PRLUQ)",
   label: "Luquillo (PRLUQ)"
  },
  {
   value: "Maricao (PRMAR)",
   label: "Maricao (PRMAR)"
  },
  {
   value: "Mayagüez (PRMAZ)",
   label: "Mayagüez (PRMAZ)"
  },
  {
   value: "Miramar (PRMIR)",
   label: "Miramar (PRMIR)"
  },
  {
   value: "Naguabo (PRNAG)",
   label: "Naguabo (PRNAG)"
  },
  {
   value: "Noxell (PRNXL)",
   label: "Noxell (PRNXL)"
  },
  {
   value: "Penuelas (PRPEN)",
   label: "Penuelas (PRPEN)"
  },
  {
   value: "Ponce (PRPSE)",
   label: "Ponce (PRPSE)"
  },
  {
   value: "Port Yabucoa (PRPYA)",
   label: "Port Yabucoa (PRPYA)"
  },
  {
   value: "Puerto Jobos (PRPJO)",
   label: "Puerto Jobos (PRPJO)"
  },
  {
   value: "Puerto Nuevo (PRPNU)",
   label: "Puerto Nuevo (PRPNU)"
  },
  {
   value: "Rio Piedras (PRRPS)",
   label: "Rio Piedras (PRRPS)"
  },
  {
   value: "Sabana Grande (PRSGR)",
   label: "Sabana Grande (PRSGR)"
  },
  {
   value: "San Juan (PRSJU)",
   label: "San Juan (PRSJU)"
  },
  {
   value: "Toa Baja (PRTBJ)",
   label: "Toa Baja (PRTBJ)"
  },
  {
   value: "Tottillas (PRTOT)",
   label: "Tottillas (PRTOT)"
  },
  {
   value: "Utuadoo (PRUTU)",
   label: "Utuadoo (PRUTU)"
  },
  {
   value: "Vega Alta (PRVAL)",
   label: "Vega Alta (PRVAL)"
  },
  {
   value: "Vega Baja (PRVBA)",
   label: "Vega Baja (PRVBA)"
  },
  {
   value: "Vieques (PRVQS)",
   label: "Vieques (PRVQS)"
  },
  {
   value: "Yabucoa (PRYAB)",
   label: "Yabucoa (PRYAB)"
  },
  {
   value: "Yauco (PRYAU)",
   label: "Yauco (PRYAU)"
  },
  {
   value: "Abrunheira (PTABR)",
   label: "Abrunheira (PTABR)"
  },
  {
   value: "Agualva (PTUGV)",
   label: "Agualva (PTUGV)"
  },
  {
   value: "Agueda (PTAGU)",
   label: "Agueda (PTAGU)"
  },
  {
   value: "Albergaria (PTALB)",
   label: "Albergaria (PTALB)"
  },
  {
   value: "Albufeira (PTABF)",
   label: "Albufeira (PTABF)"
  },
  {
   value: "Alcacer do Sal (PTADS)",
   label: "Alcacer do Sal (PTADS)"
  },
  {
   value: "Alcanena (PTALC)",
   label: "Alcanena (PTALC)"
  },
  {
   value: "Alcobaca (PTALO)",
   label: "Alcobaca (PTALO)"
  },
  {
   value: "Alcochete (PTALE)",
   label: "Alcochete (PTALE)"
  },
  {
   value: "Alenquer (PTALN)",
   label: "Alenquer (PTALN)"
  },
  {
   value: "Alferrarede-Abrantes (PTARE)",
   label: "Alferrarede-Abrantes (PTARE)"
  },
  {
   value: "Almada (PTALM)",
   label: "Almada (PTALM)"
  },
  {
   value: "Zpowtuchola (PLZPO)",
   label: "Zpowtuchola (PLZPO)"
  },
  {
   value: "Zyrardow (PLZYR)",
   label: "Zyrardow (PLZYR)"
  },
  {
   value: "St Pierre (PMFSP)",
   label: "St Pierre (PMFSP)"
  },
  {
   value: "Pitcairn Is (PNPCN)",
   label: "Pitcairn Is (PNPCN)"
  },
  {
   value: "Adjuntas (PRADJ)",
   label: "Adjuntas (PRADJ)"
  },
  {
   value: "Aguada (PRAGU)",
   label: "Aguada (PRAGU)"
  },
  {
   value: "Aguadilla (PRBQN)",
   label: "Aguadilla (PRBQN)"
  },
  {
   value: "Aibonito (PRAIB)",
   label: "Aibonito (PRAIB)"
  },
  {
   value: "Albonito (PRALB)",
   label: "Albonito (PRALB)"
  },
  {
   value: "Anasco (PRANA)",
   label: "Anasco (PRANA)"
  },
  {
   value: "Arecibo (PRARE)",
   label: "Arecibo (PRARE)"
  },
  {
   value: "Arroyo\/Guayama (PRARR)",
   label: "Arroyo\/Guayama (PRARR)"
  },
  {
   value: "Barceloneta (PRBAR)",
   label: "Barceloneta (PRBAR)"
  },
  {
   value: "Barranquitas (PRBAS)",
   label: "Barranquitas (PRBAS)"
  },
  {
   value: "Bayamon (PRBAY)",
   label: "Bayamon (PRBAY)"
  },
  {
   value: "Caguas (PRCAG)",
   label: "Caguas (PRCAG)"
  },
  {
   value: "Camuy (PRCAM)",
   label: "Camuy (PRCAM)"
  },
  {
   value: "Canovannas (PRCAN)",
   label: "Canovannas (PRCAN)"
  },
  {
   value: "Caparra Heights (PRCAH)",
   label: "Caparra Heights (PRCAH)"
  },
  {
   value: "Carolina (PRCAR)",
   label: "Carolina (PRCAR)"
  },
  {
   value: "Catano (PRCAT)",
   label: "Catano (PRCAT)"
  },
  {
   value: "Cayey (PRCAY)",
   label: "Cayey (PRCAY)"
  },
  {
   value: "Cidar (PRCID)",
   label: "Cidar (PRCID)"
  },
  {
   value: "Cidra (PRCIA)",
   label: "Cidra (PRCIA)"
  },
  {
   value: "Coamo (PRCOA)",
   label: "Coamo (PRCOA)"
  },
  {
   value: "Comerco (PRCOM)",
   label: "Comerco (PRCOM)"
  },
  {
   value: "Comerio (PRCOE)",
   label: "Comerio (PRCOE)"
  },
  {
   value: "Culebra (PRCPX)",
   label: "Culebra (PRCPX)"
  },
  {
   value: "\"Cupey (PRCUP)",
   label: "\"Cupey (PRCUP)"
  },
  {
   value: "Dorado (PRDDP)",
   label: "Dorado (PRDDP)"
  },
  {
   value: "Fajardo (PRFAJ)",
   label: "Fajardo (PRFAJ)"
  },
  {
   value: "Guabano (PRGUA)",
   label: "Guabano (PRGUA)"
  },
  {
   value: "Guanica Harbour (PRGUX)",
   label: "Guanica Harbour (PRGUX)"
  },
  {
   value: "Guayama (PRGMA)",
   label: "Guayama (PRGMA)"
  },
  {
   value: "Guayanilla (PRGUY)",
   label: "Guayanilla (PRGUY)"
  },
  {
   value: "Guaynabo (PRGUO)",
   label: "Guaynabo (PRGUO)"
  },
  {
   value: "Gurabo (PRGUR)",
   label: "Gurabo (PRGUR)"
  },
  {
   value: "Hata Dejas (PRHDE)",
   label: "Hata Dejas (PRHDE)"
  },
  {
   value: "Hatillo (PRHTL)",
   label: "Hatillo (PRHTL)"
  },
  {
   value: "Hato Rey (PRHRE)",
   label: "Hato Rey (PRHRE)"
  },
  {
   value: "Humacao (PRHUC)",
   label: "Humacao (PRHUC)"
  },
  {
   value: "Rudna gwizdanow (PLRGZ)",
   label: "Rudna gwizdanow (PLRGZ)"
  },
  {
   value: "Rzeszow (PLRZE)",
   label: "Rzeszow (PLRZE)"
  },
  {
   value: "Sanok (PLSNK)",
   label: "Sanok (PLSNK)"
  },
  {
   value: "Siedice (PLSIE)",
   label: "Siedice (PLSIE)"
  },
  {
   value: "Sieradz (PLSIR)",
   label: "Sieradz (PLSIR)"
  },
  {
   value: "Skierniewice (PLSKI)",
   label: "Skierniewice (PLSKI)"
  },
  {
   value: "Skwierzyna (PLSKW)",
   label: "Skwierzyna (PLSKW)"
  },
  {
   value: "Slupsk (PLSLP)",
   label: "Slupsk (PLSLP)"
  },
  {
   value: "Sokolka (PLSOK)",
   label: "Sokolka (PLSOK)"
  },
  {
   value: "Sokolow Podlaski (PLSPO)",
   label: "Sokolow Podlaski (PLSPO)"
  },
  {
   value: "Sopot (PLSOP)",
   label: "Sopot (PLSOP)"
  },
  {
   value: "Sosnowiec (PLSWC)",
   label: "Sosnowiec (PLSWC)"
  },
  {
   value: "Sroda (PLSRW)",
   label: "Sroda (PLSRW)"
  },
  {
   value: "Staporkow (PLSPW)",
   label: "Staporkow (PLSPW)"
  },
  {
   value: "Stepnica (PLSPA)",
   label: "Stepnica (PLSPA)"
  },
  {
   value: "Suwalki (PLSWL)",
   label: "Suwalki (PLSWL)"
  },
  {
   value: "Swinoujscie (PLSWI)",
   label: "Swinoujscie (PLSWI)"
  },
  {
   value: "Szczecin (PLSZZ)",
   label: "Szczecin (PLSZZ)"
  },
  {
   value: "Szczecinek (PLSZC)",
   label: "Szczecinek (PLSZC)"
  },
  {
   value: "Tarnow (PLTAR)",
   label: "Tarnow (PLTAR)"
  },
  {
   value: "Tarnowskie Gory (PLTGO)",
   label: "Tarnowskie Gory (PLTGO)"
  },
  {
   value: "Tczew (PLTZW)",
   label: "Tczew (PLTZW)"
  },
  {
   value: "Torun (PLTOR)",
   label: "Torun (PLTOR)"
  },
  {
   value: "Trawniki (PLTRA)",
   label: "Trawniki (PLTRA)"
  },
  {
   value: "Tuchola (PLTUC)",
   label: "Tuchola (PLTUC)"
  },
  {
   value: "Tychy (PLTYY)",
   label: "Tychy (PLTYY)"
  },
  {
   value: "Ustka (PLUST)",
   label: "Ustka (PLUST)"
  },
  {
   value: "Walbrzych (PLWZH)",
   label: "Walbrzych (PLWZH)"
  },
  {
   value: "Warszawa (PLWAW)",
   label: "Warszawa (PLWAW)"
  },
  {
   value: "Wilkowice (PLWWE)",
   label: "Wilkowice (PLWWE)"
  },
  {
   value: "Wladyslawowo (PLWLA)",
   label: "Wladyslawowo (PLWLA)"
  },
  {
   value: "Wloclawek (PLWLO)",
   label: "Wloclawek (PLWLO)"
  },
  {
   value: "Wolomin (PLWLM)",
   label: "Wolomin (PLWLM)"
  },
  {
   value: "Wolow (PLWOI)",
   label: "Wolow (PLWOI)"
  },
  {
   value: "Wroclaw (PLWRO)",
   label: "Wroclaw (PLWRO)"
  },
  {
   value: "Wygledi (PLWYG)",
   label: "Wygledi (PLWYG)"
  },
  {
   value: "Zabrze (PLZAB)",
   label: "Zabrze (PLZAB)"
  },
  {
   value: "Zagan (PLZAG)",
   label: "Zagan (PLZAG)"
  },
  {
   value: "Zamosc (PLZAM)",
   label: "Zamosc (PLZAM)"
  },
  {
   value: "Zawiercie (PLZWR)",
   label: "Zawiercie (PLZWR)"
  },
  {
   value: "Zdunska Wola (PLZDU)",
   label: "Zdunska Wola (PLZDU)"
  },
  {
   value: "Lubawa (PLLUB)",
   label: "Lubawa (PLLUB)"
  },
  {
   value: "Lubawka (PLLWK)",
   label: "Lubawka (PLLWK)"
  },
  {
   value: "Lublin (PLLUL)",
   label: "Lublin (PLLUL)"
  },
  {
   value: "Makow (PLMAK)",
   label: "Makow (PLMAK)"
  },
  {
   value: "Makow Mazowiecki (PLMMZ)",
   label: "Makow Mazowiecki (PLMMZ)"
  },
  {
   value: "Malbork (PLMLB)",
   label: "Malbork (PLMLB)"
  },
  {
   value: "Milicz (PLMLZ)",
   label: "Milicz (PLMLZ)"
  },
  {
   value: "Mlawa (PLMLA)",
   label: "Mlawa (PLMLA)"
  },
  {
   value: "Murowana Goslina (PLMUR)",
   label: "Murowana Goslina (PLMUR)"
  },
  {
   value: "Myslakowice (PLMYS)",
   label: "Myslakowice (PLMYS)"
  },
  {
   value: "Myslowice (PLMYL)",
   label: "Myslowice (PLMYL)"
  },
  {
   value: "Neufahrwasser (PLNFW)",
   label: "Neufahrwasser (PLNFW)"
  },
  {
   value: "Niepolomice (PLNPL)",
   label: "Niepolomice (PLNPL)"
  },
  {
   value: "Nisko (PLNIS)",
   label: "Nisko (PLNIS)"
  },
  {
   value: "Nowy Port (PLNOW)",
   label: "Nowy Port (PLNOW)"
  },
  {
   value: "Olecko (PLOLC)",
   label: "Olecko (PLOLC)"
  },
  {
   value: "Olsztyn (PLOLS)",
   label: "Olsztyn (PLOLS)"
  },
  {
   value: "Omianki (PLOAI)",
   label: "Omianki (PLOAI)"
  },
  {
   value: "Opatow (PLOPA)",
   label: "Opatow (PLOPA)"
  },
  {
   value: "Opole (PLOPO)",
   label: "Opole (PLOPO)"
  },
  {
   value: "Orneta (PLORN)",
   label: "Orneta (PLORN)"
  },
  {
   value: "Ostroda (PLOST)",
   label: "Ostroda (PLOST)"
  },
  {
   value: "Ostrow Wielkopolski (PLOWK)",
   label: "Ostrow Wielkopolski (PLOWK)"
  },
  {
   value: "Ostrowiec (PLOIE)",
   label: "Ostrowiec (PLOIE)"
  },
  {
   value: "Pabjanice (PLPAB)",
   label: "Pabjanice (PLPAB)"
  },
  {
   value: "Parczew (PLPRC)",
   label: "Parczew (PLPRC)"
  },
  {
   value: "Pila (PLPIL)",
   label: "Pila (PLPIL)"
  },
  {
   value: "Piotrkow (PLPIO)",
   label: "Piotrkow (PLPIO)"
  },
  {
   value: "Plock (PLPLO)",
   label: "Plock (PLPLO)"
  },
  {
   value: "Police (PLPLC)",
   label: "Police (PLPLC)"
  },
  {
   value: "Poznan (PLPOZ)",
   label: "Poznan (PLPOZ)"
  },
  {
   value: "Praszka (PLPZA)",
   label: "Praszka (PLPZA)"
  },
  {
   value: "Prudnik (PLPRU)",
   label: "Prudnik (PLPRU)"
  },
  {
   value: "Przemysl (PLPRZ)",
   label: "Przemysl (PLPRZ)"
  },
  {
   value: "Przysucha (PLPZY)",
   label: "Przysucha (PLPZY)"
  },
  {
   value: "Pyskowice (PLPYS)",
   label: "Pyskowice (PLPYS)"
  },
  {
   value: "Raciborz (PLRCZ)",
   label: "Raciborz (PLRCZ)"
  },
  {
   value: "Radom (PLRDM)",
   label: "Radom (PLRDM)"
  },
  {
   value: "Radomsko (PLRAD)",
   label: "Radomsko (PLRAD)"
  },
  {
   value: "Rawa Mazowiecka (PLRMA)",
   label: "Rawa Mazowiecka (PLRMA)"
  },
  {
   value: "Rawicz (PLRAW)",
   label: "Rawicz (PLRAW)"
  },
  {
   value: "Ruda Slaska (PLRDS)",
   label: "Ruda Slaska (PLRDS)"
  },
  {
   value: "Bydgoszcz (PLBZG)",
   label: "Bydgoszcz (PLBZG)"
  },
  {
   value: "Bytom (PLBYT)",
   label: "Bytom (PLBYT)"
  },
  {
   value: "Chelm Lubelska (PLCLK)",
   label: "Chelm Lubelska (PLCLK)"
  },
  {
   value: "Chodziez (PLCHD)",
   label: "Chodziez (PLCHD)"
  },
  {
   value: "Chorzow (PLCZW)",
   label: "Chorzow (PLCZW)"
  },
  {
   value: "Darlowo (PLDAR)",
   label: "Darlowo (PLDAR)"
  },
  {
   value: "Debica (PLDEB)",
   label: "Debica (PLDEB)"
  },
  {
   value: "Dobczyce (PLDCE)",
   label: "Dobczyce (PLDCE)"
  },
  {
   value: "Dobrzykowice Wroclawskie (PLDZE)",
   label: "Dobrzykowice Wroclawskie (PLDZE)"
  },
  {
   value: "Elblag (PLELB)",
   label: "Elblag (PLELB)"
  },
  {
   value: "Gdansk (PLGDN)",
   label: "Gdansk (PLGDN)"
  },
  {
   value: "Gdynia (PLGDY)",
   label: "Gdynia (PLGDY)"
  },
  {
   value: "Glinki (PLGKI)",
   label: "Glinki (PLGKI)"
  },
  {
   value: "Gniewkowo (PLGNW)",
   label: "Gniewkowo (PLGNW)"
  },
  {
   value: "Goclaw (PLGCW)",
   label: "Goclaw (PLGCW)"
  },
  {
   value: "Gostyn (PLGTY)",
   label: "Gostyn (PLGTY)"
  },
  {
   value: "Grudziadz (PLGRU)",
   label: "Grudziadz (PLGRU)"
  },
  {
   value: "Hel (PLHEL)",
   label: "Hel (PLHEL)"
  },
  {
   value: "Jaroslaw (PLJAR)",
   label: "Jaroslaw (PLJAR)"
  },
  {
   value: "Jastkowice (PLJKO)",
   label: "Jastkowice (PLJKO)"
  },
  {
   value: "Jastrzebie Zdroj (PLJZB)",
   label: "Jastrzebie Zdroj (PLJZB)"
  },
  {
   value: "Kalisz (PLKAL)",
   label: "Kalisz (PLKAL)"
  },
  {
   value: "Kamienna Gora (PLKAM)",
   label: "Kamienna Gora (PLKAM)"
  },
  {
   value: "Katowice (PLKTW)",
   label: "Katowice (PLKTW)"
  },
  {
   value: "Kielce (PLKLC)",
   label: "Kielce (PLKLC)"
  },
  {
   value: "Klikawa (PLKLI)",
   label: "Klikawa (PLKLI)"
  },
  {
   value: "Klodzko (PLKLO)",
   label: "Klodzko (PLKLO)"
  },
  {
   value: "Kluczbork (PLKLU)",
   label: "Kluczbork (PLKLU)"
  },
  {
   value: "Kolo (PLKLQ)",
   label: "Kolo (PLKLQ)"
  },
  {
   value: "Kolobrzeg (PLKOL)",
   label: "Kolobrzeg (PLKOL)"
  },
  {
   value: "Koszalin (PLOSZ)",
   label: "Koszalin (PLOSZ)"
  },
  {
   value: "Krakow (PLKRK)",
   label: "Krakow (PLKRK)"
  },
  {
   value: "Krasnystaw (PLKRA)",
   label: "Krasnystaw (PLKRA)"
  },
  {
   value: "Krosno (PLKRO)",
   label: "Krosno (PLKRO)"
  },
  {
   value: "Krotoszyn (PLKRN)",
   label: "Krotoszyn (PLKRN)"
  },
  {
   value: "Kucelinska (PLKCL)",
   label: "Kucelinska (PLKCL)"
  },
  {
   value: "Kutno (PLKUT)",
   label: "Kutno (PLKUT)"
  },
  {
   value: "Kwidzyn (PLKWD)",
   label: "Kwidzyn (PLKWD)"
  },
  {
   value: "Legnica (PLLEG)",
   label: "Legnica (PLLEG)"
  },
  {
   value: "Lodz (PLLOD)",
   label: "Lodz (PLLOD)"
  },
  {
   value: "Lowicz (PLLOW)",
   label: "Lowicz (PLLOW)"
  },
  {
   value: "Lubartow (PLLBR)",
   label: "Lubartow (PLLBR)"
  },
  {
   value: "Karachi (PKKHI)",
   label: "Karachi (PKKHI)"
  },
  {
   value: "Keti Bunder (PKKBU)",
   label: "Keti Bunder (PKKBU)"
  },
  {
   value: "Khokhroper (PKKRB)",
   label: "Khokhroper (PKKRB)"
  },
  {
   value: "Khuzdar (PKKDD)",
   label: "Khuzdar (PKKDD)"
  },
  {
   value: "Koh-I-Taftan (PKTFT)",
   label: "Koh-I-Taftan (PKTFT)"
  },
  {
   value: "Kohat (PKOHT)",
   label: "Kohat (PKOHT)"
  },
  {
   value: "Lahore (PKLHE)",
   label: "Lahore (PKLHE)"
  },
  {
   value: "Mianwali (PKMWD)",
   label: "Mianwali (PKMWD)"
  },
  {
   value: "Mirpur Khas (= Sindhri) (PKMPD)",
   label: "Mirpur Khas (= Sindhri) (PKMPD)"
  },
  {
   value: "Mogulpura\/Lahore (PKMGP)",
   label: "Mogulpura\/Lahore (PKMGP)"
  },
  {
   value: "Mohenjodaro (PKMJD)",
   label: "Mohenjodaro (PKMJD)"
  },
  {
   value: "Muhammad Bin Qasim\/Karachi (PKBQM)",
   label: "Muhammad Bin Qasim\/Karachi (PKBQM)"
  },
  {
   value: "Multan (PKMUX)",
   label: "Multan (PKMUX)"
  },
  {
   value: "Muzaffarabad (PKMFG)",
   label: "Muzaffarabad (PKMFG)"
  },
  {
   value: "Muzaffargarh (PKMZJ)",
   label: "Muzaffargarh (PKMZJ)"
  },
  {
   value: "Nawabshah (PKWNS)",
   label: "Nawabshah (PKWNS)"
  },
  {
   value: "Nok Kundi (PKNDD)",
   label: "Nok Kundi (PKNDD)"
  },
  {
   value: "Ormara (PKORW)",
   label: "Ormara (PKORW)"
  },
  {
   value: "Panjgur (PKPJG)",
   label: "Panjgur (PKPJG)"
  },
  {
   value: "Pasni (PKPSI)",
   label: "Pasni (PKPSI)"
  },
  {
   value: "Peshawar (PKPEW)",
   label: "Peshawar (PKPEW)"
  },
  {
   value: "Quetta (PKUET)",
   label: "Quetta (PKUET)"
  },
  {
   value: "Rahim Yar Khan (PKRYK)",
   label: "Rahim Yar Khan (PKRYK)"
  },
  {
   value: "Rawala Kot (PKRAZ)",
   label: "Rawala Kot (PKRAZ)"
  },
  {
   value: "Rawalpindi (PKRWP)",
   label: "Rawalpindi (PKRWP)"
  },
  {
   value: "Saidu Sharif (PKSDT)",
   label: "Saidu Sharif (PKSDT)"
  },
  {
   value: "Sialkot (PKSKT)",
   label: "Sialkot (PKSKT)"
  },
  {
   value: "Skardu (PKKDU)",
   label: "Skardu (PKKDU)"
  },
  {
   value: "Sui (PKSUL)",
   label: "Sui (PKSUL)"
  },
  {
   value: "Sukkur (PKSKZ)",
   label: "Sukkur (PKSKZ)"
  },
  {
   value: "Tarbela (PKTLB)",
   label: "Tarbela (PKTLB)"
  },
  {
   value: "Torkham (PKTOR)",
   label: "Torkham (PKTOR)"
  },
  {
   value: "Turbat (PKTUK)",
   label: "Turbat (PKTUK)"
  },
  {
   value: "Wagah (PKWGH)",
   label: "Wagah (PKWGH)"
  },
  {
   value: "Zhob (PKPZH)",
   label: "Zhob (PKPZH)"
  },
  {
   value: "Bartoszyce (PLBAR)",
   label: "Bartoszyce (PLBAR)"
  },
  {
   value: "Bialystok (PLBIA)",
   label: "Bialystok (PLBIA)"
  },
  {
   value: "Bielsk Podlaski (PLBLS)",
   label: "Bielsk Podlaski (PLBLS)"
  },
  {
   value: "Bielsko-Biala (PLBIB)",
   label: "Bielsko-Biala (PLBIB)"
  },
  {
   value: "Bochnia (PLBCA)",
   label: "Bochnia (PLBCA)"
  },
  {
   value: "Taytay\/Puerto Princesa (PHTAY)",
   label: "Taytay\/Puerto Princesa (PHTAY)"
  },
  {
   value: "Tibungco\/Davao (PHTIB)",
   label: "Tibungco\/Davao (PHTIB)"
  },
  {
   value: "Toboso\/Dumaguete (PHTOB)",
   label: "Toboso\/Dumaguete (PHTOB)"
  },
  {
   value: "Toledo\/Cebu (PHTLD)",
   label: "Toledo\/Cebu (PHTLD)"
  },
  {
   value: "Tolong\/Dumaguete (PHTLG)",
   label: "Tolong\/Dumaguete (PHTLG)"
  },
  {
   value: "Tolopo (PHTLP)",
   label: "Tolopo (PHTLP)"
  },
  {
   value: "Tolosa\/Tacloban (PHTLS)",
   label: "Tolosa\/Tacloban (PHTLS)"
  },
  {
   value: "Troloban (PHTRO)",
   label: "Troloban (PHTRO)"
  },
  {
   value: "Tuguegarao (PHTUG)",
   label: "Tuguegarao (PHTUG)"
  },
  {
   value: "Tuguis\/Dadiangas (PHTGI)",
   label: "Tuguis\/Dadiangas (PHTGI)"
  },
  {
   value: "Tungawan Bay\/Zamboanga (PHTGW)",
   label: "Tungawan Bay\/Zamboanga (PHTGW)"
  },
  {
   value: "Ulugan Bay (PHULY)",
   label: "Ulugan Bay (PHULY)"
  },
  {
   value: "Umrur (PHURR)",
   label: "Umrur (PHURR)"
  },
  {
   value: "\"Victorias (PHVCS)",
   label: "\"Victorias (PHVCS)"
  },
  {
   value: "Villanueva (PHVNV)",
   label: "Villanueva (PHVNV)"
  },
  {
   value: "Virac (PHVRC)",
   label: "Virac (PHVRC)"
  },
  {
   value: "Vitali\/Zamoanga (PHVTL)",
   label: "Vitali\/Zamoanga (PHVTL)"
  },
  {
   value: "Vito\/Iloilo (PHVTO)",
   label: "Vito\/Iloilo (PHVTO)"
  },
  {
   value: "Wasag\/Dadiangas (PHWAS)",
   label: "Wasag\/Dadiangas (PHWAS)"
  },
  {
   value: "Wawa\/Batangas (PHWAW)",
   label: "Wawa\/Batangas (PHWAW)"
  },
  {
   value: "\"Zamboanga (PHZAM)",
   label: "\"Zamboanga (PHZAM)"
  },
  {
   value: "CALACA (PHCAA)",
   label: "CALACA (PHCAA)"
  },
  {
   value: "CALAMBA (PHCAL)",
   label: "CALAMBA (PHCAL)"
  },
  {
   value: "Bahawalpur (PKBHV)",
   label: "Bahawalpur (PKBHV)"
  },
  {
   value: "Bannu (PKBNP)",
   label: "Bannu (PKBNP)"
  },
  {
   value: "Chamam (PKCMN)",
   label: "Chamam (PKCMN)"
  },
  {
   value: "Chitral (PKCJL)",
   label: "Chitral (PKCJL)"
  },
  {
   value: "Dadu (PKDDU)",
   label: "Dadu (PKDDU)"
  },
  {
   value: "Dalbandin (PKDBA)",
   label: "Dalbandin (PKDBA)"
  },
  {
   value: "Dera Ghazi Khan (PKDEA)",
   label: "Dera Ghazi Khan (PKDEA)"
  },
  {
   value: "Dera Ismail Khan (PKDSK)",
   label: "Dera Ismail Khan (PKDSK)"
  },
  {
   value: "Faisalabad (PKLYP)",
   label: "Faisalabad (PKLYP)"
  },
  {
   value: "Gilgit (PKGIL)",
   label: "Gilgit (PKGIL)"
  },
  {
   value: "Gujrat (PKGRT)",
   label: "Gujrat (PKGRT)"
  },
  {
   value: "Gwadar (PKGWD)",
   label: "Gwadar (PKGWD)"
  },
  {
   value: "Hyderabad (PKHDD)",
   label: "Hyderabad (PKHDD)"
  },
  {
   value: "Islamabad (PKISB)",
   label: "Islamabad (PKISB)"
  },
  {
   value: "Jacobabad (PKJAG)",
   label: "Jacobabad (PKJAG)"
  },
  {
   value: "Jiwani (PKJIW)",
   label: "Jiwani (PKJIW)"
  },
  {
   value: "Santa Catalina\/Dumaguete (PHSCT)",
   label: "Santa Catalina\/Dumaguete (PHSCT)"
  },
  {
   value: "Santa Cruz\/Sual (PHSCR)",
   label: "Santa Cruz\/Sual (PHSCR)"
  },
  {
   value: "Santa Lucia\/Puerto Princesa (PHSLU)",
   label: "Santa Lucia\/Puerto Princesa (PHSLU)"
  },
  {
   value: "Santa Maria\/Zamboanga (PHSMA)",
   label: "Santa Maria\/Zamboanga (PHSMA)"
  },
  {
   value: "Santa Nino (PHSNI)",
   label: "Santa Nino (PHSNI)"
  },
  {
   value: "Sasa\/Davao (PHSAS)",
   label: "Sasa\/Davao (PHSAS)"
  },
  {
   value: "Sayao\/Batangas (PHSAY)",
   label: "Sayao\/Batangas (PHSAY)"
  },
  {
   value: "\"Siain (PHSIN)",
   label: "\"Siain (PHSIN)"
  },
  {
   value: "Siari\/Ozamis (PHSIR)",
   label: "Siari\/Ozamis (PHSIR)"
  },
  {
   value: "Siay\/Zamboanga (PHSIY)",
   label: "Siay\/Zamboanga (PHSIY)"
  },
  {
   value: "Sigayan\/Parang (PHSIG)",
   label: "Sigayan\/Parang (PHSIG)"
  },
  {
   value: "Sindangan\/Ozamis (PHSDG)",
   label: "Sindangan\/Ozamis (PHSDG)"
  },
  {
   value: "Siocon\/Zamboanga (PHXSO)",
   label: "Siocon\/Zamboanga (PHXSO)"
  },
  {
   value: "Sogod\/Tacloban (PHSGD)",
   label: "Sogod\/Tacloban (PHSGD)"
  },
  {
   value: "Sorsogon\/Legaspi (PHSOR)",
   label: "Sorsogon\/Legaspi (PHSOR)"
  },
  {
   value: "Sual (PHSUA)",
   label: "Sual (PHSUA)"
  },
  {
   value: "Subic Bay (PHSFS)",
   label: "Subic Bay (PHSFS)"
  },
  {
   value: "Sultan Kudarat\/Dadiangas (PHSKU)",
   label: "Sultan Kudarat\/Dadiangas (PHSKU)"
  },
  {
   value: "\"Surigao (PHSUG)",
   label: "\"Surigao (PHSUG)"
  },
  {
   value: "Tabaco\/Legaspi (PHTBC)",
   label: "Tabaco\/Legaspi (PHTBC)"
  },
  {
   value: "Tabangoa (PHTBG)",
   label: "Tabangoa (PHTBG)"
  },
  {
   value: "Tablas (PHTBH)",
   label: "Tablas (PHTBH)"
  },
  {
   value: "\"Tacloban (PHTAC)",
   label: "\"Tacloban (PHTAC)"
  },
  {
   value: "Tagabuli\/Davao (PHTBU)",
   label: "Tagabuli\/Davao (PHTBU)"
  },
  {
   value: "\"Tagbilaran (PHTAG)",
   label: "\"Tagbilaran (PHTAG)"
  },
  {
   value: "Tagkawayan\/Siain (PHTKW)",
   label: "Tagkawayan\/Siain (PHTKW)"
  },
  {
   value: "Tagoloan Mis. Or\/Cagayan De Oro (PHTGO)",
   label: "Tagoloan Mis. Or\/Cagayan De Oro (PHTGO)"
  },
  {
   value: "Tagudin\/San Fernando (PHTGD)",
   label: "Tagudin\/San Fernando (PHTGD)"
  },
  {
   value: "Taguilon\/Ozamis (PHTGL)",
   label: "Taguilon\/Ozamis (PHTGL)"
  },
  {
   value: "Taguite Bay\/Zamboanga (PHTGT)",
   label: "Taguite Bay\/Zamboanga (PHTGT)"
  },
  {
   value: "Talomo\/Davao (PHTLM)",
   label: "Talomo\/Davao (PHTLM)"
  },
  {
   value: "Tambungon\/Davao (PHTGN)",
   label: "Tambungon\/Davao (PHTGN)"
  },
  {
   value: "Tanauan\/Tacloban (PHTNU)",
   label: "Tanauan\/Tacloban (PHTNU)"
  },
  {
   value: "Tandag\/Bislig (PHTDG)",
   label: "Tandag\/Bislig (PHTDG)"
  },
  {
   value: "Tandoc (PHTDC)",
   label: "Tandoc (PHTDC)"
  },
  {
   value: "Pinamalayan\/Batangas (PHPIN)",
   label: "Pinamalayan\/Batangas (PHPIN)"
  },
  {
   value: "Plaridel\/Ozamis (PHPLA)",
   label: "Plaridel\/Ozamis (PHPLA)"
  },
  {
   value: "Polandoc\/Ozamis (PHPDC)",
   label: "Polandoc\/Ozamis (PHPDC)"
  },
  {
   value: "Pollilio\/Siain (PHPLL)",
   label: "Pollilio\/Siain (PHPLL)"
  },
  {
   value: "Polloc (PHPLC)",
   label: "Polloc (PHPLC)"
  },
  {
   value: "Poro\/San Fernando (PHPRO)",
   label: "Poro\/San Fernando (PHPRO)"
  },
  {
   value: "Port Barton\/Palawan (PHPBA)",
   label: "Port Barton\/Palawan (PHPBA)"
  },
  {
   value: "Port Holland (PHPHD)",
   label: "Port Holland (PHPHD)"
  },
  {
   value: "\"Puerto Princesa (PHPPS)",
   label: "\"Puerto Princesa (PHPPS)"
  },
  {
   value: "Puerto Santa Maria (PHPSM)",
   label: "Puerto Santa Maria (PHPSM)"
  },
  {
   value: "Pugad\/Bislig (PHPUG)",
   label: "Pugad\/Bislig (PHPUG)"
  },
  {
   value: "Pulupandan (PHPUL)",
   label: "Pulupandan (PHPUL)"
  },
  {
   value: "Puntalinao\/Mati (PHPTL)",
   label: "Puntalinao\/Mati (PHPTL)"
  },
  {
   value: "Punti\/Aparri (PHPNT)",
   label: "Punti\/Aparri (PHPNT)"
  },
  {
   value: "Queson\/Siain (PHQUE)",
   label: "Queson\/Siain (PHQUE)"
  },
  {
   value: "Quiddiao\/Aparri (PHQUI)",
   label: "Quiddiao\/Aparri (PHQUI)"
  },
  {
   value: "Quinabigan (PHQBI)",
   label: "Quinabigan (PHQBI)"
  },
  {
   value: "Quinablagan\/Mati (PHQBL)",
   label: "Quinablagan\/Mati (PHQBL)"
  },
  {
   value: "Quipit Bay\/Ozamis (PHQPT)",
   label: "Quipit Bay\/Ozamis (PHQPT)"
  },
  {
   value: "Real\/Siain (PHREA)",
   label: "Real\/Siain (PHREA)"
  },
  {
   value: "Romblon (PHRLN)",
   label: "Romblon (PHRLN)"
  },
  {
   value: "Rosario (PHRSO)",
   label: "Rosario (PHRSO)"
  },
  {
   value: "Roxas\/Puerto Princesa (PHRXS)",
   label: "Roxas\/Puerto Princesa (PHRXS)"
  },
  {
   value: "Sabang (PHSBG)",
   label: "Sabang (PHSBG)"
  },
  {
   value: "Sabbot\/Siain (PHSBB)",
   label: "Sabbot\/Siain (PHSBB)"
  },
  {
   value: "Sablayan\/Batangas (PHSBY)",
   label: "Sablayan\/Batangas (PHSBY)"
  },
  {
   value: "Sagay\/Iloilo (PHSAG)",
   label: "Sagay\/Iloilo (PHSAG)"
  },
  {
   value: "San Carlos\/Dumaguete (PHSCA)",
   label: "San Carlos\/Dumaguete (PHSCA)"
  },
  {
   value: "\"San Fernando (PHSFE)",
   label: "\"San Fernando (PHSFE)"
  },
  {
   value: "San Ignacio\/Mati (PHSIO)",
   label: "San Ignacio\/Mati (PHSIO)"
  },
  {
   value: "San Isidro\/Sanjose (PHSIS)",
   label: "San Isidro\/Sanjose (PHSIS)"
  },
  {
   value: "\"San Jose (PHSJI)",
   label: "\"San Jose (PHSJI)"
  },
  {
   value: "San Pio Quinto\/Aparri (PHSPQ)",
   label: "San Pio Quinto\/Aparri (PHSPQ)"
  },
  {
   value: "San Teodoro\/Batangas (PHSTE)",
   label: "San Teodoro\/Batangas (PHSTE)"
  },
  {
   value: "Sangi\/Cebu (PHSNG)",
   label: "Sangi\/Cebu (PHSNG)"
  },
  {
   value: "Santa Anna\/Aparri (PHSAN)",
   label: "Santa Anna\/Aparri (PHSAN)"
  },
  {
   value: "Nabulao Bay\/Iloilo (PHNAB)",
   label: "Nabulao Bay\/Iloilo (PHNAB)"
  },
  {
   value: "Naga\/Zamboanga (PHWNP)",
   label: "Naga\/Zamboanga (PHWNP)"
  },
  {
   value: "Nagh (PHNGH)",
   label: "Nagh (PHNGH)"
  },
  {
   value: "Nalungga\/Iloilo (PHNAL)",
   label: "Nalungga\/Iloilo (PHNAL)"
  },
  {
   value: "Napot Point (PHNPT)",
   label: "Napot Point (PHNPT)"
  },
  {
   value: "Napsan\/Puerto Princesa (PHNAP)",
   label: "Napsan\/Puerto Princesa (PHNAP)"
  },
  {
   value: "Naris Point\/Puerto Princesa (PHNAR)",
   label: "Naris Point\/Puerto Princesa (PHNAR)"
  },
  {
   value: "Nasipit\/Masao (PHNAS)",
   label: "Nasipit\/Masao (PHNAS)"
  },
  {
   value: "\"Nasugbu (PHNUG)",
   label: "\"Nasugbu (PHNUG)"
  },
  {
   value: "Nato (PHNTO)",
   label: "Nato (PHNTO)"
  },
  {
   value: "Nonoc\/Surigao Del Norte (PHNON)",
   label: "Nonoc\/Surigao Del Norte (PHNON)"
  },
  {
   value: "Olongapo (PHOLO)",
   label: "Olongapo (PHOLO)"
  },
  {
   value: "Opol\/Cagayan De Oro (PHOPO)",
   label: "Opol\/Cagayan De Oro (PHOPO)"
  },
  {
   value: "Oras\/Catbalogan (PHORS)",
   label: "Oras\/Catbalogan (PHORS)"
  },
  {
   value: "Orayuita (PHORA)",
   label: "Orayuita (PHORA)"
  },
  {
   value: "Ormoc\/Tacloban (PHORC)",
   label: "Ormoc\/Tacloban (PHORC)"
  },
  {
   value: "Oteiza\/Bislig (PHOTE)",
   label: "Oteiza\/Bislig (PHOTE)"
  },
  {
   value: "\"Ozamis (PHOZC)",
   label: "\"Ozamis (PHOZC)"
  },
  {
   value: "Pacio de Rozas\/Batangas (PHPDR)",
   label: "Pacio de Rozas\/Batangas (PHPDR)"
  },
  {
   value: "Pagadian\/Zamboanga (PHPAG)",
   label: "Pagadian\/Zamboanga (PHPAG)"
  },
  {
   value: "Palamit Bay\/San Jose (PHPLB)",
   label: "Palamit Bay\/San Jose (PHPLB)"
  },
  {
   value: "Palapag\/San Jose (PHPLP)",
   label: "Palapag\/San Jose (PHPLP)"
  },
  {
   value: "Palawan\/Ozamis (PHPLW)",
   label: "Palawan\/Ozamis (PHPLW)"
  },
  {
   value: "Pamintayan\/Zamboanga (PHPMT)",
   label: "Pamintayan\/Zamboanga (PHPMT)"
  },
  {
   value: "Pampanga (PHPAM)",
   label: "Pampanga (PHPAM)"
  },
  {
   value: "Pamplona\/Aparri (PHPPL)",
   label: "Pamplona\/Aparri (PHPPL)"
  },
  {
   value: "Panabutan\/Zamboanga (PHPNB)",
   label: "Panabutan\/Zamboanga (PHPNB)"
  },
  {
   value: "Panacan\/Davao (PHPCN)",
   label: "Panacan\/Davao (PHPCN)"
  },
  {
   value: "Panacosa\/Puerto Princesa (PHPCA)",
   label: "Panacosa\/Puerto Princesa (PHPCA)"
  },
  {
   value: "Pangutaran\/Jolo (PHPGT)",
   label: "Pangutaran\/Jolo (PHPGT)"
  },
  {
   value: "Paninirongan\/Sanjose (PHPNN)",
   label: "Paninirongan\/Sanjose (PHPNN)"
  },
  {
   value: "Parang (PHPRA)",
   label: "Parang (PHPRA)"
  },
  {
   value: "Pasalang Bay\/Aparri (PHPSL)",
   label: "Pasalang Bay\/Aparri (PHPSL)"
  },
  {
   value: "\"Pasay (PHPAS)",
   label: "\"Pasay (PHPAS)"
  },
  {
   value: "Paselang Pagudpud\/S Fernando (PHPPP)",
   label: "Paselang Pagudpud\/S Fernando (PHPPP)"
  },
  {
   value: "Magalona\/Iloilo (PHMGA)",
   label: "Magalona\/Iloilo (PHMGA)"
  },
  {
   value: "Magellanes\/Masao (PHMLS)",
   label: "Magellanes\/Masao (PHMLS)"
  },
  {
   value: "Magueda Bay\/Catbalogan (PHMGB)",
   label: "Magueda Bay\/Catbalogan (PHMGB)"
  },
  {
   value: "Maibini\/Davao (PHMAB)",
   label: "Maibini\/Davao (PHMAB)"
  },
  {
   value: "Maitum\/Dadiangas (PHMAI)",
   label: "Maitum\/Dadiangas (PHMAI)"
  },
  {
   value: "Makar\/Dadiangas (PHMAK)",
   label: "Makar\/Dadiangas (PHMAK)"
  },
  {
   value: "Malabang (PHMLP)",
   label: "Malabang (PHMLP)"
  },
  {
   value: "Malalag\/Davao (PHMLL)",
   label: "Malalag\/Davao (PHMLL)"
  },
  {
   value: "Malasugat Bay\/Zamboanga (PHMSB)",
   label: "Malasugat Bay\/Zamboanga (PHMSB)"
  },
  {
   value: "Malusobay (PHMLB)",
   label: "Malusobay (PHMLB)"
  },
  {
   value: "Mambagid (PHMGI)",
   label: "Mambagid (PHMGI)"
  },
  {
   value: "Mamburao (PHMBO)",
   label: "Mamburao (PHMBO)"
  },
  {
   value: "Manansalay\/Batangas (PHMSY)",
   label: "Manansalay\/Batangas (PHMSY)"
  },
  {
   value: "Manay\/Mati (PHMNY)",
   label: "Manay\/Mati (PHMNY)"
  },
  {
   value: "Mangogoy\/Bislig (PHMGG)",
   label: "Mangogoy\/Bislig (PHMGG)"
  },
  {
   value: "Manila (PHMNL)",
   label: "Manila (PHMNL)"
  },
  {
   value: "Manila South Harbour (PHMNS)",
   label: "Manila South Harbour (PHMNS)"
  },
  {
   value: "Marinduque (PHMRQ)",
   label: "Marinduque (PHMRQ)"
  },
  {
   value: "Marinhatag\/Bislig (PHMHT)",
   label: "Marinhatag\/Bislig (PHMHT)"
  },
  {
   value: "\"Mariveles (PHMVS)",
   label: "\"Mariveles (PHMVS)"
  },
  {
   value: "Masao (PHMAS)",
   label: "Masao (PHMAS)"
  },
  {
   value: "Masbate (PHMBT)",
   label: "Masbate (PHMBT)"
  },
  {
   value: "Masinloc\/Sual (PHMSC)",
   label: "Masinloc\/Sual (PHMSC)"
  },
  {
   value: "Matho Cortez\/Bislig (PHMAC)",
   label: "Matho Cortez\/Bislig (PHMAC)"
  },
  {
   value: "\"Mati (PHMXI)",
   label: "\"Mati (PHMXI)"
  },
  {
   value: "Matina Aplaya\/Davao (PHMTA)",
   label: "Matina Aplaya\/Davao (PHMTA)"
  },
  {
   value: "Medina\/Cagayan De Oro (PHMDN)",
   label: "Medina\/Cagayan De Oro (PHMDN)"
  },
  {
   value: "Mercedes\/Jose Panganiban (PHMCD)",
   label: "Mercedes\/Jose Panganiban (PHMCD)"
  },
  {
   value: "Milbuk\/Dadiangas (PHMIL)",
   label: "Milbuk\/Dadiangas (PHMIL)"
  },
  {
   value: "Misamis Occ.\/Ozamis (PHMIO)",
   label: "Misamis Occ.\/Ozamis (PHMIO)"
  },
  {
   value: "Misamis Or.\/Cagayan De Oro (PHMIC)",
   label: "Misamis Or.\/Cagayan De Oro (PHMIC)"
  },
  {
   value: "Mission\/Aparri (PHMSS)",
   label: "Mission\/Aparri (PHMSS)"
  },
  {
   value: "Monserrat\/Mati (PHMON)",
   label: "Monserrat\/Mati (PHMON)"
  },
  {
   value: "Morong\/Mariveles (PHMOR)",
   label: "Morong\/Mariveles (PHMOR)"
  },
  {
   value: "Mulanay\/Siain (PHMUL)",
   label: "Mulanay\/Siain (PHMUL)"
  },
  {
   value: "Murcilagus\/Ozamis (PHMUR)",
   label: "Murcilagus\/Ozamis (PHMUR)"
  },
  {
   value: "Kipit\/Ozamis (PHKIP)",
   label: "Kipit\/Ozamis (PHKIP)"
  },
  {
   value: "Kiwalan\/Iligan (PHKIW)",
   label: "Kiwalan\/Iligan (PHKIW)"
  },
  {
   value: "Kolambugan\/Iligan (PHKOL)",
   label: "Kolambugan\/Iligan (PHKOL)"
  },
  {
   value: "Kumalarang\/Zamboanga (PHKUM)",
   label: "Kumalarang\/Zamboanga (PHKUM)"
  },
  {
   value: "La Paz\/Iloilo (PHLPZ)",
   label: "La Paz\/Iloilo (PHLPZ)"
  },
  {
   value: "La Rap\/Jose Panganiban (PHLRP)",
   label: "La Rap\/Jose Panganiban (PHLRP)"
  },
  {
   value: "Labason\/Zamboanga (PHLAB)",
   label: "Labason\/Zamboanga (PHLAB)"
  },
  {
   value: "Lagondy River (PHLAY)",
   label: "Lagondy River (PHLAY)"
  },
  {
   value: "Lagonoy\/Jose Panganiban (PHLAG)",
   label: "Lagonoy\/Jose Panganiban (PHLAG)"
  },
  {
   value: "Lamit Bay\/Jose Panganiban (PHLAM)",
   label: "Lamit Bay\/Jose Panganiban (PHLAM)"
  },
  {
   value: "Lanuza\/Bislig (PHLAN)",
   label: "Lanuza\/Bislig (PHLAN)"
  },
  {
   value: "\"Laoag (PHLAO)",
   label: "\"Laoag (PHLAO)"
  },
  {
   value: "Lapu-Lapu (Camotes Sea) (PHLPU)",
   label: "Lapu-Lapu (Camotes Sea) (PHLPU)"
  },
  {
   value: "Lebak\/Parang (PHLBK)",
   label: "Lebak\/Parang (PHLBK)"
  },
  {
   value: "\"Legaspi (PHLGP)",
   label: "\"Legaspi (PHLGP)"
  },
  {
   value: "Leyte (PHLEY)",
   label: "Leyte (PHLEY)"
  },
  {
   value: "Lianga\/Bislig (PHLIA)",
   label: "Lianga\/Bislig (PHLIA)"
  },
  {
   value: "Libjo\/Surigao (PHLIB)",
   label: "Libjo\/Surigao (PHLIB)"
  },
  {
   value: "Limay\/Bataan (PHLIM)",
   label: "Limay\/Bataan (PHLIM)"
  },
  {
   value: "\"Lingayen (PHLIN)",
   label: "\"Lingayen (PHLIN)"
  },
  {
   value: "Lingig\/Bislig (PHLGG)",
   label: "Lingig\/Bislig (PHLGG)"
  },
  {
   value: "Linik\/Dadiangas (PHLNK)",
   label: "Linik\/Dadiangas (PHLNK)"
  },
  {
   value: "Lipa (PHLPA)",
   label: "Lipa (PHLPA)"
  },
  {
   value: "Lomuyon\/Dadiangas (PHLOM)",
   label: "Lomuyon\/Dadiangas (PHLOM)"
  },
  {
   value: "Long Point\/Puerto Princesa (PHLOP)",
   label: "Long Point\/Puerto Princesa (PHLOP)"
  },
  {
   value: "Looc Bay\/San Jose (PHLOO)",
   label: "Looc Bay\/San Jose (PHLOO)"
  },
  {
   value: "Lugait\/Cagayan De Oro (PHLUG)",
   label: "Lugait\/Cagayan De Oro (PHLUG)"
  },
  {
   value: "Lumasal\/Dadiangas (PHLUM)",
   label: "Lumasal\/Dadiangas (PHLUM)"
  },
  {
   value: "Lunao\/Cagayan De Oro (PHLNO)",
   label: "Lunao\/Cagayan De Oro (PHLNO)"
  },
  {
   value: "Maasin (PHMAA)",
   label: "Maasin (PHMAA)"
  },
  {
   value: "Mabaguid (PHMGD)",
   label: "Mabaguid (PHMGD)"
  },
  {
   value: "Maco\/Davao (PHMCO)",
   label: "Maco\/Davao (PHMCO)"
  },
  {
   value: "Macojalan\/Ozamis (PHMCJ)",
   label: "Macojalan\/Ozamis (PHMCJ)"
  },
  {
   value: "Mactan Island (PHNOP)",
   label: "Mactan Island (PHNOP)"
  },
  {
   value: "Madaum\/Davao (PHMAD)",
   label: "Madaum\/Davao (PHMAD)"
  },
  {
   value: "Gachitorena\/Jose Panganiban (PHGAC)",
   label: "Gachitorena\/Jose Panganiban (PHGAC)"
  },
  {
   value: "Gasan (PHGAS)",
   label: "Gasan (PHGAS)"
  },
  {
   value: "General Island\/Bislig (PHGNI)",
   label: "General Island\/Bislig (PHGNI)"
  },
  {
   value: "General Santos\/Dadiangas (PHGES)",
   label: "General Santos\/Dadiangas (PHGES)"
  },
  {
   value: "Gigaguit\/Surigao (PHGGG)",
   label: "Gigaguit\/Surigao (PHGGG)"
  },
  {
   value: "Gigmote\/Legaspi (PHGGM)",
   label: "Gigmote\/Legaspi (PHGGM)"
  },
  {
   value: "Gingoog\/Masao (PHGIN)",
   label: "Gingoog\/Masao (PHGIN)"
  },
  {
   value: "Guimaras\/Iloilo (PHGMS)",
   label: "Guimaras\/Iloilo (PHGMS)"
  },
  {
   value: "Guinabasan (PHGUI)",
   label: "Guinabasan (PHGUI)"
  },
  {
   value: "Hagnava Bay (PHHYB)",
   label: "Hagnava Bay (PHHYB)"
  },
  {
   value: "Hijo Wharf\/Davao (PHHIJ)",
   label: "Hijo Wharf\/Davao (PHHIJ)"
  },
  {
   value: "Himamayalan\/Iloilo (PHHIM)",
   label: "Himamayalan\/Iloilo (PHHIM)"
  },
  {
   value: "Hinatuan\/Bislig (PHHNT)",
   label: "Hinatuan\/Bislig (PHHNT)"
  },
  {
   value: "Hinigaran\/Iloilo (PHHNG)",
   label: "Hinigaran\/Iloilo (PHHNG)"
  },
  {
   value: "Hinobaan\/Iloilo (PHHNB)",
   label: "Hinobaan\/Iloilo (PHHNB)"
  },
  {
   value: "Hondagua\/Siain (PHHON)",
   label: "Hondagua\/Siain (PHHON)"
  },
  {
   value: "Hook Bay\/Siain (PHHOO)",
   label: "Hook Bay\/Siain (PHHOO)"
  },
  {
   value: "\"Iligan (PHIGN)",
   label: "\"Iligan (PHIGN)"
  },
  {
   value: "\"Iloilo (PHILO)",
   label: "\"Iloilo (PHILO)"
  },
  {
   value: "Inampulugan Island (PHINP)",
   label: "Inampulugan Island (PHINP)"
  },
  {
   value: "Ipil\/Zamboanga (PHIPE)",
   label: "Ipil\/Zamboanga (PHIPE)"
  },
  {
   value: "Isabel (PHISL)",
   label: "Isabel (PHISL)"
  },
  {
   value: "Isabela de Basilan\/Basilan (PHISB)",
   label: "Isabela de Basilan\/Basilan (PHISB)"
  },
  {
   value: "Jagna (PHJAG)",
   label: "Jagna (PHJAG)"
  },
  {
   value: "Jasaan\/Cagayan De Oro (PHJAS)",
   label: "Jasaan\/Cagayan De Oro (PHJAS)"
  },
  {
   value: "Jimenez\/Ozamis (PHJNZ)",
   label: "Jimenez\/Ozamis (PHJNZ)"
  },
  {
   value: "Jolo (PHJOL)",
   label: "Jolo (PHJOL)"
  },
  {
   value: "\"Jose Panganiban (PHJPM)",
   label: "\"Jose Panganiban (PHJPM)"
  },
  {
   value: "Kabasalan\/Zamboanga (PHKAS)",
   label: "Kabasalan\/Zamboanga (PHKAS)"
  },
  {
   value: "Kalibo (PHKLO)",
   label: "Kalibo (PHKLO)"
  },
  {
   value: "Karomatan\/Iligan (PHKAR)",
   label: "Karomatan\/Iligan (PHKAR)"
  },
  {
   value: "Katipunan\/Ozamis (PHKAT)",
   label: "Katipunan\/Ozamis (PHKAT)"
  },
  {
   value: "Kiamba\/Dadiangas (PHKIA)",
   label: "Kiamba\/Dadiangas (PHKIA)"
  },
  {
   value: "Kilbay Point\/Jose Panganiban (PHKIL)",
   label: "Kilbay Point\/Jose Panganiban (PHKIL)"
  },
  {
   value: "Kinogitan\/Iligan (PHKIN)",
   label: "Kinogitan\/Iligan (PHKIN)"
  },
  {
   value: "Canaybon\/Catbalogan (PHCNY)",
   label: "Canaybon\/Catbalogan (PHCNY)"
  },
  {
   value: "Cantilan\/Surigao (PHCNT)",
   label: "Cantilan\/Surigao (PHCNT)"
  },
  {
   value: "Capalonga\/Siain (PHCPL)",
   label: "Capalonga\/Siain (PHCPL)"
  },
  {
   value: "Caraga\/Mati (PHCRG)",
   label: "Caraga\/Mati (PHCRG)"
  },
  {
   value: "Cartagena\/Iloilo (PHCRT)",
   label: "Cartagena\/Iloilo (PHCRT)"
  },
  {
   value: "Casiguran\/Siain (PHCGG)",
   label: "Casiguran\/Siain (PHCGG)"
  },
  {
   value: "Castanas (PHCST)",
   label: "Castanas (PHCST)"
  },
  {
   value: "Casul Bay\/Ozamis (PHCSB)",
   label: "Casul Bay\/Ozamis (PHCSB)"
  },
  {
   value: "Catamon Bay\/Iloilo (PHCTB)",
   label: "Catamon Bay\/Iloilo (PHCTB)"
  },
  {
   value: "Catanauan (PHCUN)",
   label: "Catanauan (PHCUN)"
  },
  {
   value: "\"Catbalogan (PHCTS)",
   label: "\"Catbalogan (PHCTS)"
  },
  {
   value: "Cauayan (PHCYZ)",
   label: "Cauayan (PHCYZ)"
  },
  {
   value: "\"Cavite (PHCVE)",
   label: "\"Cavite (PHCVE)"
  },
  {
   value: "Cebu (PHCEB)",
   label: "Cebu (PHCEB)"
  },
  {
   value: "Claveria\/Aparri (PHCLV)",
   label: "Claveria\/Aparri (PHCLV)"
  },
  {
   value: "\"Cotabato (PHCBO)",
   label: "\"Cotabato (PHCBO)"
  },
  {
   value: "Culion (PHCUJ)",
   label: "Culion (PHCUJ)"
  },
  {
   value: "Currimao (PHCMO)",
   label: "Currimao (PHCMO)"
  },
  {
   value: "Curuan\/Zamboanga (PHCUR)",
   label: "Curuan\/Zamboanga (PHCUR)"
  },
  {
   value: "\"Dadiangas (PHDAD)",
   label: "\"Dadiangas (PHDAD)"
  },
  {
   value: "Dahikan Bay (PHDCB)",
   label: "Dahikan Bay (PHDCB)"
  },
  {
   value: "\"Davao (PHDVO)",
   label: "\"Davao (PHDVO)"
  },
  {
   value: "Diapitan\/Siain (PHDPT)",
   label: "Diapitan\/Siain (PHDPT)"
  },
  {
   value: "Diaraboan\/Siain (PHDRB)",
   label: "Diaraboan\/Siain (PHDRB)"
  },
  {
   value: "Diculum\/Zamboanga (PHDIC)",
   label: "Diculum\/Zamboanga (PHDIC)"
  },
  {
   value: "Didadongan\/Aparri (PHDID)",
   label: "Didadongan\/Aparri (PHDID)"
  },
  {
   value: "Dinadiawan\/Aparri (PHDDW)",
   label: "Dinadiawan\/Aparri (PHDDW)"
  },
  {
   value: "Dinagat Island\/Surigao (PHDNG)",
   label: "Dinagat Island\/Surigao (PHDNG)"
  },
  {
   value: "Dinalongan\/Siain (PHDNL)",
   label: "Dinalongan\/Siain (PHDNL)"
  },
  {
   value: "Dingalan\/Siain (PHDGL)",
   label: "Dingalan\/Siain (PHDGL)"
  },
  {
   value: "Diotorin\/Siain (PHDIO)",
   label: "Diotorin\/Siain (PHDIO)"
  },
  {
   value: "Dipolog\/Ozamis (PHDPL)",
   label: "Dipolog\/Ozamis (PHDPL)"
  },
  {
   value: "Dirgalan (PHDIR)",
   label: "Dirgalan (PHDIR)"
  },
  {
   value: "Divilacan\/Aparri (PHDIV)",
   label: "Divilacan\/Aparri (PHDIV)"
  },
  {
   value: "Dumaguete (PHDGT)",
   label: "Dumaguete (PHDGT)"
  },
  {
   value: "El Nido\/Puerto Princesa (PHENI)",
   label: "El Nido\/Puerto Princesa (PHENI)"
  },
  {
   value: "Bauan\/Batangas (PHBAU)",
   label: "Bauan\/Batangas (PHBAU)"
  },
  {
   value: "Bayabas\/Bislig (PHBYS)",
   label: "Bayabas\/Bislig (PHBYS)"
  },
  {
   value: "Bayang Point (PHBYP)",
   label: "Bayang Point (PHBYP)"
  },
  {
   value: "Bayawan\/Dumaguete (PHBYW)",
   label: "Bayawan\/Dumaguete (PHBYW)"
  },
  {
   value: "Baybay\/Tacloban (PHBYB)",
   label: "Baybay\/Tacloban (PHBYB)"
  },
  {
   value: "\"Bislig (PHBPH)",
   label: "\"Bislig (PHBPH)"
  },
  {
   value: "Biyawa\/Davao (PHBIY)",
   label: "Biyawa\/Davao (PHBIY)"
  },
  {
   value: "\"Boac (PHBOA)",
   label: "\"Boac (PHBOA)"
  },
  {
   value: "Bogo\/Cagayan De Oro (PHBOG)",
   label: "Bogo\/Cagayan De Oro (PHBOG)"
  },
  {
   value: "Bolos Point\/Aparri (PHBLP)",
   label: "Bolos Point\/Aparri (PHBLP)"
  },
  {
   value: "Borongan (PHBGV)",
   label: "Borongan (PHBGV)"
  },
  {
   value: "Boston\/Davao (PHBOS)",
   label: "Boston\/Davao (PHBOS)"
  },
  {
   value: "Brooks Point\/Siain (PHBRP)",
   label: "Brooks Point\/Siain (PHBRP)"
  },
  {
   value: "Bucar Grande\/Suriagao (PHBGR)",
   label: "Bucar Grande\/Suriagao (PHBGR)"
  },
  {
   value: "Budbud\/Davao (PHBUD)",
   label: "Budbud\/Davao (PHBUD)"
  },
  {
   value: "Bugo (PHBUG)",
   label: "Bugo (PHBUG)"
  },
  {
   value: "\"Bulan (PHBUL)",
   label: "\"Bulan (PHBUL)"
  },
  {
   value: "Burdees\/Siain (PHBUR)",
   label: "Burdees\/Siain (PHBUR)"
  },
  {
   value: "Butuan Bay\/Masao (PHBXU)",
   label: "Butuan Bay\/Masao (PHBXU)"
  },
  {
   value: "Cabugao Bay\/Legaspi (PHCAB)",
   label: "Cabugao Bay\/Legaspi (PHCAB)"
  },
  {
   value: "Cadiz (PHCAZ)",
   label: "Cadiz (PHCAZ)"
  },
  {
   value: "\"Cagayan de Oro (PHCGY)",
   label: "\"Cagayan de Oro (PHCGY)"
  },
  {
   value: "Cajodiocan\/Siain (PHCAJ)",
   label: "Cajodiocan\/Siain (PHCAJ)"
  },
  {
   value: "Calag-Calag\/Dumaguete (PHCCG)",
   label: "Calag-Calag\/Dumaguete (PHCCG)"
  },
  {
   value: "Calaguitan\/Tacloban (PHCGT)",
   label: "Calaguitan\/Tacloban (PHCGT)"
  },
  {
   value: "Calapan\/Batangas (PHCLP)",
   label: "Calapan\/Batangas (PHCLP)"
  },
  {
   value: "Calbayog (PHCYP)",
   label: "Calbayog (PHCYP)"
  },
  {
   value: "Calbayong\/Catbalogan (PHCBY)",
   label: "Calbayong\/Catbalogan (PHCBY)"
  },
  {
   value: "Caldera Bay\/Zamboanga (PHCDB)",
   label: "Caldera Bay\/Zamboanga (PHCDB)"
  },
  {
   value: "Calowayan\/Catabalogan (PHCWY)",
   label: "Calowayan\/Catabalogan (PHCWY)"
  },
  {
   value: "Calug Point\/Zamboanga (PHCGP)",
   label: "Calug Point\/Zamboanga (PHCGP)"
  },
  {
   value: "Calugian\/Tacloban (PHCUG)",
   label: "Calugian\/Tacloban (PHCUG)"
  },
  {
   value: "Camalagawan\/Aparri (PHCML)",
   label: "Camalagawan\/Aparri (PHCML)"
  },
  {
   value: "Camarines Norte\/Jose Panganiban (PHCAM)",
   label: "Camarines Norte\/Jose Panganiban (PHCAM)"
  },
  {
   value: "Camiguin Island\/Aparri (PHCGM)",
   label: "Camiguin Island\/Aparri (PHCGM)"
  },
  {
   value: "Amunitan\/Aparri (PHAMU)",
   label: "Amunitan\/Aparri (PHAMU)"
  },
  {
   value: "Anakan\/Masao (PHANA)",
   label: "Anakan\/Masao (PHANA)"
  },
  {
   value: "Angeles (PHAGL)",
   label: "Angeles (PHAGL)"
  },
  {
   value: "\"Aparri (PHAPR)",
   label: "\"Aparri (PHAPR)"
  },
  {
   value: "Aras Asan\/Bislig (PHARA)",
   label: "Aras Asan\/Bislig (PHARA)"
  },
  {
   value: "Atimonan\/Siain (PHATI)",
   label: "Atimonan\/Siain (PHATI)"
  },
  {
   value: "Babato\/Dadiangas (PHBAB)",
   label: "Babato\/Dadiangas (PHBAB)"
  },
  {
   value: "\"Bacolod (PHBCD)",
   label: "\"Bacolod (PHBCD)"
  },
  {
   value: "Bacon\/Legaspi (PHBCO)",
   label: "Bacon\/Legaspi (PHBCO)"
  },
  {
   value: "Baculin\/Mati (PHBCU)",
   label: "Baculin\/Mati (PHBCU)"
  },
  {
   value: "Bagac (PHBGC)",
   label: "Bagac (PHBGC)"
  },
  {
   value: "Baganga\/Mati (PHBNQ)",
   label: "Baganga\/Mati (PHBNQ)"
  },
  {
   value: "Bagui Bay\/San Fernando (PHBGI)",
   label: "Bagui Bay\/San Fernando (PHBGI)"
  },
  {
   value: "Baguio (PHBAG)",
   label: "Baguio (PHBAG)"
  },
  {
   value: "Bais\/Dumaguete (PHBAI)",
   label: "Bais\/Dumaguete (PHBAI)"
  },
  {
   value: "Balabac\/Iligan (PHBLC)",
   label: "Balabac\/Iligan (PHBLC)"
  },
  {
   value: "Balaboe (PHBAL)",
   label: "Balaboe (PHBAL)"
  },
  {
   value: "Balanga\/Batan (PHBLA)",
   label: "Balanga\/Batan (PHBLA)"
  },
  {
   value: "Balengan\/Siain (PHBLN)",
   label: "Balengan\/Siain (PHBLN)"
  },
  {
   value: "Baler\/Siain (PHBQA)",
   label: "Baler\/Siain (PHBQA)"
  },
  {
   value: "Balingasag\/Cagay Apt De Oro (PHBGS)",
   label: "Balingasag\/Cagay Apt De Oro (PHBGS)"
  },
  {
   value: "Balintang\/Puerto Princesa (PHBLT)",
   label: "Balintang\/Puerto Princesa (PHBLT)"
  },
  {
   value: "Balogo\/Batangas (PHBLG)",
   label: "Balogo\/Batangas (PHBLG)"
  },
  {
   value: "Balumo\/Zamboanga (PHBLU)",
   label: "Balumo\/Zamboanga (PHBLU)"
  },
  {
   value: "Banawan\/Dadiangas (PHBNW)",
   label: "Banawan\/Dadiangas (PHBNW)"
  },
  {
   value: "Bantayon\/San Jose (PHBTY)",
   label: "Bantayon\/San Jose (PHBTY)"
  },
  {
   value: "Barobo\/Bislig (PHBRB)",
   label: "Barobo\/Bislig (PHBRB)"
  },
  {
   value: "Barton\/Puerto Princesa (PHBRT)",
   label: "Barton\/Puerto Princesa (PHBRT)"
  },
  {
   value: "Basco (PHBSO)",
   label: "Basco (PHBSO)"
  },
  {
   value: "Basey\/Catbalogan (PHBSY)",
   label: "Basey\/Catbalogan (PHBSY)"
  },
  {
   value: "Basiauang\/Dadiangas (PHBAS)",
   label: "Basiauang\/Dadiangas (PHBAS)"
  },
  {
   value: "\"Basilan City (PHBCT)",
   label: "\"Basilan City (PHBCT)"
  },
  {
   value: "\"Bataan (PHBTN)",
   label: "\"Bataan (PHBTN)"
  },
  {
   value: "\"Batangas (PHBTG)",
   label: "\"Batangas (PHBTG)"
  },
  {
   value: "Batarasa\/Puerto Princesa (PHBTS)",
   label: "Batarasa\/Puerto Princesa (PHBTS)"
  },
  {
   value: "Simbai (PGSIM)",
   label: "Simbai (PGSIM)"
  },
  {
   value: "Sipul (PGSPL)",
   label: "Sipul (PGSPL)"
  },
  {
   value: "Sokar Island (PGSOI)",
   label: "Sokar Island (PGSOI)"
  },
  {
   value: "Stockholm (PGSMP)",
   label: "Stockholm (PGSMP)"
  },
  {
   value: "Tabibuga (PGTBA)",
   label: "Tabibuga (PGTBA)"
  },
  {
   value: "Tabubil (PGTBG)",
   label: "Tabubil (PGTBG)"
  },
  {
   value: "Tagula (PGTGL)",
   label: "Tagula (PGTGL)"
  },
  {
   value: "Talasea (PGTLW)",
   label: "Talasea (PGTLW)"
  },
  {
   value: "Tambutyo Island (PGTAI)",
   label: "Tambutyo Island (PGTAI)"
  },
  {
   value: "Tapini (PGTPI)",
   label: "Tapini (PGTPI)"
  },
  {
   value: "Tari (PGTIZ)",
   label: "Tari (PGTIZ)"
  },
  {
   value: "Taskul (PGTSK)",
   label: "Taskul (PGTSK)"
  },
  {
   value: "Taugu Island (PGTAU)",
   label: "Taugu Island (PGTAU)"
  },
  {
   value: "Telefomin (PGTFM)",
   label: "Telefomin (PGTFM)"
  },
  {
   value: "Teptep (PGTEP)",
   label: "Teptep (PGTEP)"
  },
  {
   value: "Terapo (PGTEO)",
   label: "Terapo (PGTEO)"
  },
  {
   value: "Tetabedi (PGTDB)",
   label: "Tetabedi (PGTDB)"
  },
  {
   value: "Tingwon (PGTIG)",
   label: "Tingwon (PGTIG)"
  },
  {
   value: "Tol (PGTLO)",
   label: "Tol (PGTLO)"
  },
  {
   value: "Tolokiwa Island (PGTOI)",
   label: "Tolokiwa Island (PGTOI)"
  },
  {
   value: "Torokina (PGTOK)",
   label: "Torokina (PGTOK)"
  },
  {
   value: "Tufi (PGTFI)",
   label: "Tufi (PGTFI)"
  },
  {
   value: "Uvol (PGUVO)",
   label: "Uvol (PGUVO)"
  },
  {
   value: "Vanimo (PGVAI)",
   label: "Vanimo (PGVAI)"
  },
  {
   value: "Wabo (PGWAO)",
   label: "Wabo (PGWAO)"
  },
  {
   value: "Wakunai (PGWKN)",
   label: "Wakunai (PGWKN)"
  },
  {
   value: "Wanigela (PGAGL)",
   label: "Wanigela (PGAGL)"
  },
  {
   value: "Wapenamanda (PGWBM)",
   label: "Wapenamanda (PGWBM)"
  },
  {
   value: "Wau (PGWUG)",
   label: "Wau (PGWUG)"
  },
  {
   value: "Weam (PGWEP)",
   label: "Weam (PGWEP)"
  },
  {
   value: "Wedau (PGWED)",
   label: "Wedau (PGWED)"
  },
  {
   value: "Wewak (PGWWK)",
   label: "Wewak (PGWWK)"
  },
  {
   value: "Witu (PGWIU)",
   label: "Witu (PGWIU)"
  },
  {
   value: "Woitape (PGWTP)",
   label: "Woitape (PGWTP)"
  },
  {
   value: "Woodlark (PGWOK)",
   label: "Woodlark (PGWOK)"
  },
  {
   value: "Wuvulu Is (PGWUV)",
   label: "Wuvulu Is (PGWUV)"
  },
  {
   value: "Yule Island (PGRKU)",
   label: "Yule Island (PGRKU)"
  },
  {
   value: "Abulog\/Aparri (PHABU)",
   label: "Abulog\/Aparri (PHABU)"
  },
  {
   value: "Adlay\/Bislig (PHADL)",
   label: "Adlay\/Bislig (PHADL)"
  },
  {
   value: "Aheron\/Ozamis (PHAHE)",
   label: "Aheron\/Ozamis (PHAHE)"
  },
  {
   value: "Alasang\/Siain (PHALA)",
   label: "Alasang\/Siain (PHALA)"
  },
  {
   value: "Aleran\/Ozamis (PHALE)",
   label: "Aleran\/Ozamis (PHALE)"
  },
  {
   value: "Manus Island (PGMAS)",
   label: "Manus Island (PGMAS)"
  },
  {
   value: "Mapua (PGMPU)",
   label: "Mapua (PGMPU)"
  },
  {
   value: "Margarima (PGMGG)",
   label: "Margarima (PGMGG)"
  },
  {
   value: "Mendi (PGMDU)",
   label: "Mendi (PGMDU)"
  },
  {
   value: "Menyamya (PGMYX)",
   label: "Menyamya (PGMYX)"
  },
  {
   value: "Mielelek (PGMIE)",
   label: "Mielelek (PGMIE)"
  },
  {
   value: "Misima Island (PGMIS)",
   label: "Misima Island (PGMIS)"
  },
  {
   value: "Morehead (PGMHY)",
   label: "Morehead (PGMHY)"
  },
  {
   value: "Mount Hagen (PGHGU)",
   label: "Mount Hagen (PGHGU)"
  },
  {
   value: "Munduku (PGMDM)",
   label: "Munduku (PGMDM)"
  },
  {
   value: "Mussau (PGMWU)",
   label: "Mussau (PGMWU)"
  },
  {
   value: "Namatanai (PGATN)",
   label: "Namatanai (PGATN)"
  },
  {
   value: "Namudi (PGNDI)",
   label: "Namudi (PGNDI)"
  },
  {
   value: "Nissan Island (PGIIS)",
   label: "Nissan Island (PGIIS)"
  },
  {
   value: "Nowata (PGNWT)",
   label: "Nowata (PGNWT)"
  },
  {
   value: "Nuku (PGUKU)",
   label: "Nuku (PGUKU)"
  },
  {
   value: "Open Bay (PGOPB)",
   label: "Open Bay (PGOPB)"
  },
  {
   value: "Orobay (PGROR)",
   label: "Orobay (PGROR)"
  },
  {
   value: "Pambwa (PGPAW)",
   label: "Pambwa (PGPAW)"
  },
  {
   value: "Pimaga (PGPMP)",
   label: "Pimaga (PGPMP)"
  },
  {
   value: "Popondetta (PGPNP)",
   label: "Popondetta (PGPNP)"
  },
  {
   value: "Porgera (PGRGE)",
   label: "Porgera (PGRGE)"
  },
  {
   value: "Port Moresby (PGPOM)",
   label: "Port Moresby (PGPOM)"
  },
  {
   value: "Puas (PGPUA)",
   label: "Puas (PGPUA)"
  },
  {
   value: "Pumani (PGPMN)",
   label: "Pumani (PGPMN)"
  },
  {
   value: "Rabaraba (PGRBP)",
   label: "Rabaraba (PGRBP)"
  },
  {
   value: "Rabaul (PGRAB)",
   label: "Rabaul (PGRAB)"
  },
  {
   value: "Rakanda (PGRAA)",
   label: "Rakanda (PGRAA)"
  },
  {
   value: "Rambutyo Island (PGRAM)",
   label: "Rambutyo Island (PGRAM)"
  },
  {
   value: "Robinson River (PGRNR)",
   label: "Robinson River (PGRNR)"
  },
  {
   value: "Russel Island (PGRVI)",
   label: "Russel Island (PGRVI)"
  },
  {
   value: "Sabah (PGSBV)",
   label: "Sabah (PGSBV)"
  },
  {
   value: "Safia (PGSFU)",
   label: "Safia (PGSFU)"
  },
  {
   value: "Sagarai (PGSGJ)",
   label: "Sagarai (PGSGJ)"
  },
  {
   value: "Saidor (PGSDI)",
   label: "Saidor (PGSDI)"
  },
  {
   value: "Salamaua (PGSMU)",
   label: "Salamaua (PGSMU)"
  },
  {
   value: "Salamo (PGSAM)",
   label: "Salamo (PGSAM)"
  },
  {
   value: "Samarai (PGSQT)",
   label: "Samarai (PGSQT)"
  },
  {
   value: "Schauten (PGSCH)",
   label: "Schauten (PGSCH)"
  },
  {
   value: "Sehulea (PGSXH)",
   label: "Sehulea (PGSXH)"
  },
  {
   value: "Siassi (PGSSS)",
   label: "Siassi (PGSSS)"
  },
  {
   value: "Sila (PGSIL)",
   label: "Sila (PGSIL)"
  },
  {
   value: "Kagi (PGKGW)",
   label: "Kagi (PGKGW)"
  },
  {
   value: "Kaintiba (PGKZF)",
   label: "Kaintiba (PGKZF)"
  },
  {
   value: "Kairuka (PGKRK)",
   label: "Kairuka (PGKRK)"
  },
  {
   value: "Kakapo (PGKPP)",
   label: "Kakapo (PGKPP)"
  },
  {
   value: "Kalo (PGKLO)",
   label: "Kalo (PGKLO)"
  },
  {
   value: "Kamiraba (PGKJU)",
   label: "Kamiraba (PGKJU)"
  },
  {
   value: "Kanabea (PGKEX)",
   label: "Kanabea (PGKEX)"
  },
  {
   value: "Kandep (PGKDP)",
   label: "Kandep (PGKDP)"
  },
  {
   value: "Kandrian (PGKDR)",
   label: "Kandrian (PGKDR)"
  },
  {
   value: "Kar Kar (PGKRX)",
   label: "Kar Kar (PGKRX)"
  },
  {
   value: "Karimui (PGKMR)",
   label: "Karimui (PGKMR)"
  },
  {
   value: "Kavieng (PGKVG)",
   label: "Kavieng (PGKVG)"
  },
  {
   value: "Kerema (PGKMA)",
   label: "Kerema (PGKMA)"
  },
  {
   value: "Kieta (PGKIE)",
   label: "Kieta (PGKIE)"
  },
  {
   value: "Kikori (PGKRI)",
   label: "Kikori (PGKRI)"
  },
  {
   value: "Kimbe (PGKIM)",
   label: "Kimbe (PGKIM)"
  },
  {
   value: "Kiunga (PGUNG)",
   label: "Kiunga (PGUNG)"
  },
  {
   value: "Kokoda (PGKKD)",
   label: "Kokoda (PGKKD)"
  },
  {
   value: "Kokoro (PGKOR)",
   label: "Kokoro (PGKOR)"
  },
  {
   value: "Kol (PGKQL)",
   label: "Kol (PGKQL)"
  },
  {
   value: "Komo-Manda (PGKOM)",
   label: "Komo-Manda (PGKOM)"
  },
  {
   value: "Kopiago (PGKPA)",
   label: "Kopiago (PGKPA)"
  },
  {
   value: "Koroba (PGKDE)",
   label: "Koroba (PGKDE)"
  },
  {
   value: "Kundiawa (PGCMU)",
   label: "Kundiawa (PGCMU)"
  },
  {
   value: "Kupiano (PGKUP)",
   label: "Kupiano (PGKUP)"
  },
  {
   value: "Lablab (PGLAB)",
   label: "Lablab (PGLAB)"
  },
  {
   value: "Lae (PGLAE)",
   label: "Lae (PGLAE)"
  },
  {
   value: "Langimar (PGLNM)",
   label: "Langimar (PGLNM)"
  },
  {
   value: "Lese (PGLNG)",
   label: "Lese (PGLNG)"
  },
  {
   value: "Lihir Island (PGLNV)",
   label: "Lihir Island (PGLNV)"
  },
  {
   value: "Loloho (PGLOL)",
   label: "Loloho (PGLOL)"
  },
  {
   value: "\"Lorengau (PGLOR)",
   label: "\"Lorengau (PGLOR)"
  },
  {
   value: "Losuia (PGLSA)",
   label: "Losuia (PGLSA)"
  },
  {
   value: "Lumi (PGLMI)",
   label: "Lumi (PGLMI)"
  },
  {
   value: "Madang (PGMAG)",
   label: "Madang (PGMAG)"
  },
  {
   value: "Malalaua (PGMLQ)",
   label: "Malalaua (PGMLQ)"
  },
  {
   value: "Malekolon (PGMKN)",
   label: "Malekolon (PGMKN)"
  },
  {
   value: "Mamai (PGMAP)",
   label: "Mamai (PGMAP)"
  },
  {
   value: "Manam Island (PGMAM)",
   label: "Manam Island (PGMAM)"
  },
  {
   value: "Manare (PGMRM)",
   label: "Manare (PGMRM)"
  },
  {
   value: "Manga (PGMGP)",
   label: "Manga (PGMGP)"
  },
  {
   value: "Manumu (PGUUU)",
   label: "Manumu (PGUUU)"
  },
  {
   value: "Biniguni (PGXBN)",
   label: "Biniguni (PGXBN)"
  },
  {
   value: "Boang (PGBOV)",
   label: "Boang (PGBOV)"
  },
  {
   value: "Bodinumu (PGBNM)",
   label: "Bodinumu (PGBNM)"
  },
  {
   value: "Boroko (PGBOR)",
   label: "Boroko (PGBOR)"
  },
  {
   value: "Buin (PGUBI)",
   label: "Buin (PGUBI)"
  },
  {
   value: "Buka (PGBUA)",
   label: "Buka (PGBUA)"
  },
  {
   value: "Bulolo (PGBUL)",
   label: "Bulolo (PGBUL)"
  },
  {
   value: "Buna (PGBNA)",
   label: "Buna (PGBNA)"
  },
  {
   value: "Bundi (PGBNT)",
   label: "Bundi (PGBNT)"
  },
  {
   value: "Cape Gloucester (PGCGC)",
   label: "Cape Gloucester (PGCGC)"
  },
  {
   value: "Cape Rodney (PGCPN)",
   label: "Cape Rodney (PGCPN)"
  },
  {
   value: "Cape Vogel (PGCVL)",
   label: "Cape Vogel (PGCVL)"
  },
  {
   value: "Daru (PGDAU)",
   label: "Daru (PGDAU)"
  },
  {
   value: "Dorobisoro (PGDOO)",
   label: "Dorobisoro (PGDOO)"
  },
  {
   value: "Efogi (PGEFG)",
   label: "Efogi (PGEFG)"
  },
  {
   value: "Embessa (PGEMS)",
   label: "Embessa (PGEMS)"
  },
  {
   value: "Emirau (PGEMI)",
   label: "Emirau (PGEMI)"
  },
  {
   value: "Erave (PGERE)",
   label: "Erave (PGERE)"
  },
  {
   value: "Esa'ala (PGESA)",
   label: "Esa'ala (PGESA)"
  },
  {
   value: "Fane (PGFNE)",
   label: "Fane (PGFNE)"
  },
  {
   value: "Finschhafen (PGFIN)",
   label: "Finschhafen (PGFIN)"
  },
  {
   value: "Fulleborn (PGFUB)",
   label: "Fulleborn (PGFUB)"
  },
  {
   value: "Garaina (PGGAR)",
   label: "Garaina (PGGAR)"
  },
  {
   value: "Garuahi (PGGRH)",
   label: "Garuahi (PGGRH)"
  },
  {
   value: "Gasmata Island (PGGMI)",
   label: "Gasmata Island (PGGMI)"
  },
  {
   value: "Gilau (PGGIL)",
   label: "Gilau (PGGIL)"
  },
  {
   value: "Goroka (PGGKA)",
   label: "Goroka (PGGKA)"
  },
  {
   value: "Green Islands (PGGEI)",
   label: "Green Islands (PGGEI)"
  },
  {
   value: "Guari (PGGUG)",
   label: "Guari (PGGUG)"
  },
  {
   value: "Gusap (PGGAP)",
   label: "Gusap (PGGAP)"
  },
  {
   value: "Hayfields (PGHYF)",
   label: "Hayfields (PGHYF)"
  },
  {
   value: "Hoskins (PGHKN)",
   label: "Hoskins (PGHKN)"
  },
  {
   value: "Iamalele (PGIMA)",
   label: "Iamalele (PGIMA)"
  },
  {
   value: "Ihu (PGIHU)",
   label: "Ihu (PGIHU)"
  },
  {
   value: "Imonda (PGIMD)",
   label: "Imonda (PGIMD)"
  },
  {
   value: "Inus (PGIUS)",
   label: "Inus (PGIUS)"
  },
  {
   value: "Iokea (PGIOK)",
   label: "Iokea (PGIOK)"
  },
  {
   value: "Ioma (PGIOP)",
   label: "Ioma (PGIOP)"
  },
  {
   value: "Itokama (PGITK)",
   label: "Itokama (PGITK)"
  },
  {
   value: "Jacksons (PGJAC)",
   label: "Jacksons (PGJAC)"
  },
  {
   value: "Jacquinot Bay (PGJAQ)",
   label: "Jacquinot Bay (PGJAQ)"
  },
  {
   value: "Josephstaal (PGJOP)",
   label: "Josephstaal (PGJOP)"
  },
  {
   value: "Kaukura (PFKKR)",
   label: "Kaukura (PFKKR)"
  },
  {
   value: "Makemo (PFMKP)",
   label: "Makemo (PFMKP)"
  },
  {
   value: "Manihi (PFXMH)",
   label: "Manihi (PFXMH)"
  },
  {
   value: "Mataiva (PFMVT)",
   label: "Mataiva (PFMVT)"
  },
  {
   value: "Maupiti (PFMAU)",
   label: "Maupiti (PFMAU)"
  },
  {
   value: "Moorea (PFMOZ)",
   label: "Moorea (PFMOZ)"
  },
  {
   value: "Nuku Hiva (PFNHV)",
   label: "Nuku Hiva (PFNHV)"
  },
  {
   value: "Papeete (PFPPT)",
   label: "Papeete (PFPPT)"
  },
  {
   value: "Raiatea (PFRFP)",
   label: "Raiatea (PFRFP)"
  },
  {
   value: "Rangiroa (PFRGI)",
   label: "Rangiroa (PFRGI)"
  },
  {
   value: "Rurutu (PFRUR)",
   label: "Rurutu (PFRUR)"
  },
  {
   value: "Taiohae (PFTAI)",
   label: "Taiohae (PFTAI)"
  },
  {
   value: "Takapoto (PFTKP)",
   label: "Takapoto (PFTKP)"
  },
  {
   value: "Tikehau (PFTIH)",
   label: "Tikehau (PFTIH)"
  },
  {
   value: "Tubuai (PFTUB)",
   label: "Tubuai (PFTUB)"
  },
  {
   value: "Ua Huka (PFUAH)",
   label: "Ua Huka (PFUAH)"
  },
  {
   value: "Ua Pou (PFUAP)",
   label: "Ua Pou (PFUAP)"
  },
  {
   value: "Uturoa (PFUTU)",
   label: "Uturoa (PFUTU)"
  },
  {
   value: "Vaitape (PFVAI)",
   label: "Vaitape (PFVAI)"
  },
  {
   value: "Abau (PGABW)",
   label: "Abau (PGABW)"
  },
  {
   value: "Ahioma (PGAHO)",
   label: "Ahioma (PGAHO)"
  },
  {
   value: "Aiome (PGAIE)",
   label: "Aiome (PGAIE)"
  },
  {
   value: "Aitape (PGATP)",
   label: "Aitape (PGATP)"
  },
  {
   value: "Aiyura (PGAYU)",
   label: "Aiyura (PGAYU)"
  },
  {
   value: "Akinum (PGAKI)",
   label: "Akinum (PGAKI)"
  },
  {
   value: "Alotau (PGGUR)",
   label: "Alotau (PGGUR)"
  },
  {
   value: "Ama (PGAMF)",
   label: "Ama (PGAMF)"
  },
  {
   value: "Amanab (PGAMU)",
   label: "Amanab (PGAMU)"
  },
  {
   value: "Amazon Bay (PGAZB)",
   label: "Amazon Bay (PGAZB)"
  },
  {
   value: "Ambunti (PGAUJ)",
   label: "Ambunti (PGAUJ)"
  },
  {
   value: "Aneway Bay (PGANB)",
   label: "Aneway Bay (PGANB)"
  },
  {
   value: "Angoram (PGAGG)",
   label: "Angoram (PGAGG)"
  },
  {
   value: "Aragip (PGARP)",
   label: "Aragip (PGARP)"
  },
  {
   value: "Aseki (PGAEK)",
   label: "Aseki (PGAEK)"
  },
  {
   value: "Baibara (PGBAP)",
   label: "Baibara (PGBAP)"
  },
  {
   value: "Baimuru (PGVMU)",
   label: "Baimuru (PGVMU)"
  },
  {
   value: "Bali (PGBAJ)",
   label: "Bali (PGBAJ)"
  },
  {
   value: "Balimo (PGOPU)",
   label: "Balimo (PGOPU)"
  },
  {
   value: "Bamu (PGBMZ)",
   label: "Bamu (PGBMZ)"
  },
  {
   value: "Banz (PGBNZ)",
   label: "Banz (PGBNZ)"
  },
  {
   value: "Bereina (PGBEA)",
   label: "Bereina (PGBEA)"
  },
  {
   value: "Bewani (PGBWP)",
   label: "Bewani (PGBWP)"
  },
  {
   value: "Bialla (PGBAA)",
   label: "Bialla (PGBAA)"
  },
  {
   value: "Los Organos (PELOO)",
   label: "Los Organos (PELOO)"
  },
  {
   value: "Mancora (PEMCA)",
   label: "Mancora (PEMCA)"
  },
  {
   value: "Matarani (PEMRI)",
   label: "Matarani (PEMRI)"
  },
  {
   value: "Mollendo (PEMLQ)",
   label: "Mollendo (PEMLQ)"
  },
  {
   value: "Negritos (PENGS)",
   label: "Negritos (PENGS)"
  },
  {
   value: "Pacasmayo (PEPAC)",
   label: "Pacasmayo (PEPAC)"
  },
  {
   value: "Paita (PEPAI)",
   label: "Paita (PEPAI)"
  },
  {
   value: "Paramonga (PEPAM)",
   label: "Paramonga (PEPAM)"
  },
  {
   value: "Pimentel (PEPMT)",
   label: "Pimentel (PEPMT)"
  },
  {
   value: "Pisco (PEPIO)",
   label: "Pisco (PEPIO)"
  },
  {
   value: "Piura (PEPIU)",
   label: "Piura (PEPIU)"
  },
  {
   value: "Pto Bayovar (PEPUB)",
   label: "Pto Bayovar (PEPUB)"
  },
  {
   value: "Pucallpa (PEPCL)",
   label: "Pucallpa (PEPCL)"
  },
  {
   value: "Puerto Chicama (PEPCH)",
   label: "Puerto Chicama (PEPCH)"
  },
  {
   value: "Puerto Maldonado (PEPEM)",
   label: "Puerto Maldonado (PEPEM)"
  },
  {
   value: "Puno (PEPUN)",
   label: "Puno (PEPUN)"
  },
  {
   value: "Rioja (PERIJ)",
   label: "Rioja (PERIJ)"
  },
  {
   value: "Salaverry (PESVY)",
   label: "Salaverry (PESVY)"
  },
  {
   value: "Samanco (PESAM)",
   label: "Samanco (PESAM)"
  },
  {
   value: "San Juan (PESJA)",
   label: "San Juan (PESJA)"
  },
  {
   value: "San Nicolas (PESNX)",
   label: "San Nicolas (PESNX)"
  },
  {
   value: "Supe (PESUP)",
   label: "Supe (PESUP)"
  },
  {
   value: "Tacna (PETCQ)",
   label: "Tacna (PETCQ)"
  },
  {
   value: "Talara (PETYL)",
   label: "Talara (PETYL)"
  },
  {
   value: "Tambo De Mora (PETDM)",
   label: "Tambo De Mora (PETDM)"
  },
  {
   value: "Tarapoto (PETPP)",
   label: "Tarapoto (PETPP)"
  },
  {
   value: "Tingo Maria (PETGI)",
   label: "Tingo Maria (PETGI)"
  },
  {
   value: "Trujillo (PETRU)",
   label: "Trujillo (PETRU)"
  },
  {
   value: "Tumbes (PETBP)",
   label: "Tumbes (PETBP)"
  },
  {
   value: "Yurimaguas (PEYMS)",
   label: "Yurimaguas (PEYMS)"
  },
  {
   value: "Zorritos (PEZOR)",
   label: "Zorritos (PEZOR)"
  },
  {
   value: "LA OROYA (PELOA)",
   label: "LA OROYA (PELOA)"
  },
  {
   value: "Ahurei (PFAHU)",
   label: "Ahurei (PFAHU)"
  },
  {
   value: "Anaa (PFAAA)",
   label: "Anaa (PFAAA)"
  },
  {
   value: "Apataki (PFAPK)",
   label: "Apataki (PFAPK)"
  },
  {
   value: "Atuona (PFAUQ)",
   label: "Atuona (PFAUQ)"
  },
  {
   value: "Bora Bora (PFBOB)",
   label: "Bora Bora (PFBOB)"
  },
  {
   value: "\"Faaa (PFFAA)",
   label: "\"Faaa (PFFAA)"
  },
  {
   value: "Fakarava (PFFAV)",
   label: "Fakarava (PFFAV)"
  },
  {
   value: "Gambier Is (PFGMR)",
   label: "Gambier Is (PFGMR)"
  },
  {
   value: "Hao Is (PFHOI)",
   label: "Hao Is (PFHOI)"
  },
  {
   value: "Huahine (PFHUH)",
   label: "Huahine (PFHUH)"
  },
  {
   value: "Pedregal (PAPED)",
   label: "Pedregal (PAPED)"
  },
  {
   value: "Pedro Miguel (PAPOE)",
   label: "Pedro Miguel (PAPOE)"
  },
  {
   value: "Playon Chico (PAPYC)",
   label: "Playon Chico (PAPYC)"
  },
  {
   value: "Pto Bello (PAPBE)",
   label: "Pto Bello (PAPBE)"
  },
  {
   value: "Pto Obaldia (PAPUE)",
   label: "Pto Obaldia (PAPUE)"
  },
  {
   value: "Puerto Armuelles (PAAML)",
   label: "Puerto Armuelles (PAAML)"
  },
  {
   value: "Puerto Limon (PALIO)",
   label: "Puerto Limon (PALIO)"
  },
  {
   value: "Rio Alzucar (PARIZ)",
   label: "Rio Alzucar (PARIZ)"
  },
  {
   value: "Rio Sidra (PARSI)",
   label: "Rio Sidra (PARSI)"
  },
  {
   value: "Rio Tigre (PARIT)",
   label: "Rio Tigre (PARIT)"
  },
  {
   value: "Sambu (PASAX)",
   label: "Sambu (PASAX)"
  },
  {
   value: "Santa Fe (PASFW)",
   label: "Santa Fe (PASFW)"
  },
  {
   value: "Tubala (PATUW)",
   label: "Tubala (PATUW)"
  },
  {
   value: "Tupile (PATUE)",
   label: "Tupile (PATUE)"
  },
  {
   value: "Ustupo (PAUTU)",
   label: "Ustupo (PAUTU)"
  },
  {
   value: "Vacamonte (PAVAC)",
   label: "Vacamonte (PAVAC)"
  },
  {
   value: "Yavisa (PAPYV)",
   label: "Yavisa (PAPYV)"
  },
  {
   value: "Ancon (PEANC)",
   label: "Ancon (PEANC)"
  },
  {
   value: "Andahuaylas (PEANS)",
   label: "Andahuaylas (PEANS)"
  },
  {
   value: "Anta (PEATA)",
   label: "Anta (PEATA)"
  },
  {
   value: "Arequipa (PEAQP)",
   label: "Arequipa (PEAQP)"
  },
  {
   value: "Atico (PEATI)",
   label: "Atico (PEATI)"
  },
  {
   value: "Ayacucho (PEAYP)",
   label: "Ayacucho (PEAYP)"
  },
  {
   value: "Cabo Blanco (PECAB)",
   label: "Cabo Blanco (PECAB)"
  },
  {
   value: "Cajamarca (PECJA)",
   label: "Cajamarca (PECJA)"
  },
  {
   value: "Callao (PECLL)",
   label: "Callao (PECLL)"
  },
  {
   value: "Chancay (PECHY)",
   label: "Chancay (PECHY)"
  },
  {
   value: "Chiclayo (PECIX)",
   label: "Chiclayo (PECIX)"
  },
  {
   value: "Chimbote (PECHM)",
   label: "Chimbote (PECHM)"
  },
  {
   value: "Etén (PEEEN)",
   label: "Etén (PEEEN)"
  },
  {
   value: "General San Martin (PEGSM)",
   label: "General San Martin (PEGSM)"
  },
  {
   value: "Huacho (PEHCO)",
   label: "Huacho (PEHCO)"
  },
  {
   value: "Huanuco (PEHUU)",
   label: "Huanuco (PEHUU)"
  },
  {
   value: "Huarmey (PEHUY)",
   label: "Huarmey (PEHUY)"
  },
  {
   value: "Ilo (PEILQ)",
   label: "Ilo (PEILQ)"
  },
  {
   value: "Iquitos (PEIQT)",
   label: "Iquitos (PEIQT)"
  },
  {
   value: "Juanjui (PEJJI)",
   label: "Juanjui (PEJJI)"
  },
  {
   value: "La Pampilla (PELPP)",
   label: "La Pampilla (PELPP)"
  },
  {
   value: "La Plancharda (PELPN)",
   label: "La Plancharda (PELPN)"
  },
  {
   value: "Lima (PELIM)",
   label: "Lima (PELIM)"
  },
  {
   value: "Lobitos (PELOB)",
   label: "Lobitos (PELOB)"
  },
  {
   value: "Muscat (OMMCT)",
   label: "Muscat (OMMCT)"
  },
  {
   value: "Muthra (OMMUT)",
   label: "Muthra (OMMUT)"
  },
  {
   value: "Port Qaboos (OMOPQ)",
   label: "Port Qaboos (OMOPQ)"
  },
  {
   value: "Raysut (OMRAY)",
   label: "Raysut (OMRAY)"
  },
  {
   value: "Ruwi (OMRWI)",
   label: "Ruwi (OMRWI)"
  },
  {
   value: "Salalah (OMSLL)",
   label: "Salalah (OMSLL)"
  },
  {
   value: "Sohar (OMSOH)",
   label: "Sohar (OMSOH)"
  },
  {
   value: "Thumrait (OMTTH)",
   label: "Thumrait (OMTTH)"
  },
  {
   value: "Achutupo (PAACU)",
   label: "Achutupo (PAACU)"
  },
  {
   value: "Aguadulce (PAAGD)",
   label: "Aguadulce (PAAGD)"
  },
  {
   value: "Almirante (PAPAM)",
   label: "Almirante (PAPAM)"
  },
  {
   value: "Bahia de las Minas (PAPBM)",
   label: "Bahia de las Minas (PAPBM)"
  },
  {
   value: "Balboa (PABLB)",
   label: "Balboa (PABLB)"
  },
  {
   value: "Caledonia (PACDE)",
   label: "Caledonia (PACDE)"
  },
  {
   value: "Carti (PACTE)",
   label: "Carti (PACTE)"
  },
  {
   value: "Changuinola (PACHX)",
   label: "Changuinola (PACHX)"
  },
  {
   value: "Charco Azul (PACHA)",
   label: "Charco Azul (PACHA)"
  },
  {
   value: "Chiriqui Grande (PACHG)",
   label: "Chiriqui Grande (PACHG)"
  },
  {
   value: "Chitre (PACTD)",
   label: "Chitre (PACTD)"
  },
  {
   value: "Coco Solo (PACSO)",
   label: "Coco Solo (PACSO)"
  },
  {
   value: "Colon (PAONX)",
   label: "Colon (PAONX)"
  },
  {
   value: "Colon Free Zone (PACFZ)",
   label: "Colon Free Zone (PACFZ)"
  },
  {
   value: "Corazon De Jesus (PACZJ)",
   label: "Corazon De Jesus (PACZJ)"
  },
  {
   value: "Cristobal (PACTB)",
   label: "Cristobal (PACTB)"
  },
  {
   value: "David (PADAV)",
   label: "David (PADAV)"
  },
  {
   value: "El Porvenir (PAPVE)",
   label: "El Porvenir (PAPVE)"
  },
  {
   value: "El Real (PAELE)",
   label: "El Real (PAELE)"
  },
  {
   value: "Gamboa (PAGBA)",
   label: "Gamboa (PAGBA)"
  },
  {
   value: "Garachine (PAGHE)",
   label: "Garachine (PAGHE)"
  },
  {
   value: "Gatun (PAGTN)",
   label: "Gatun (PAGTN)"
  },
  {
   value: "Jaque (PAJQE)",
   label: "Jaque (PAJQE)"
  },
  {
   value: "La Palma (PAPLP)",
   label: "La Palma (PAPLP)"
  },
  {
   value: "Las Minas (PAMNP)",
   label: "Las Minas (PAMNP)"
  },
  {
   value: "Mamitupo (PAMPI)",
   label: "Mamitupo (PAMPI)"
  },
  {
   value: "Manzanillo (PAMIT)",
   label: "Manzanillo (PAMIT)"
  },
  {
   value: "Miraflores (PAMFS)",
   label: "Miraflores (PAMFS)"
  },
  {
   value: "Mulatupo (PAMPP)",
   label: "Mulatupo (PAMPP)"
  },
  {
   value: "Nargana (PANGN)",
   label: "Nargana (PANGN)"
  },
  {
   value: "Panama City (PAPTY)",
   label: "Panama City (PAPTY)"
  },
  {
   value: "Paraiso (PAPAI)",
   label: "Paraiso (PAPAI)"
  },
  {
   value: "Payardi (PAPAY)",
   label: "Payardi (PAPAY)"
  },
  {
   value: "Pukekohe (NZPKK)",
   label: "Pukekohe (NZPKK)"
  },
  {
   value: "Queenstown (NZZQN)",
   label: "Queenstown (NZZQN)"
  },
  {
   value: "Raglan (NZRAG)",
   label: "Raglan (NZRAG)"
  },
  {
   value: "Rangiuru (NZRAU)",
   label: "Rangiuru (NZRAU)"
  },
  {
   value: "Rotorua (NZROT)",
   label: "Rotorua (NZROT)"
  },
  {
   value: "Taharoa (NZTHH)",
   label: "Taharoa (NZTHH)"
  },
  {
   value: "Takaka (NZKTF)",
   label: "Takaka (NZKTF)"
  },
  {
   value: "Takapau (NZTKU)",
   label: "Takapau (NZTKU)"
  },
  {
   value: "Tarakohe (NZTKH)",
   label: "Tarakohe (NZTKH)"
  },
  {
   value: "Taupo (NZTUO)",
   label: "Taupo (NZTUO)"
  },
  {
   value: "Tauranga (NZTRG)",
   label: "Tauranga (NZTRG)"
  },
  {
   value: "Te Anau (NZTEU)",
   label: "Te Anau (NZTEU)"
  },
  {
   value: "Temuka (NZTKA)",
   label: "Temuka (NZTKA)"
  },
  {
   value: "Thames (NZTMZ)",
   label: "Thames (NZTMZ)"
  },
  {
   value: "Timaru (NZTIU)",
   label: "Timaru (NZTIU)"
  },
  {
   value: "Upper Hutt (NZUBA)",
   label: "Upper Hutt (NZUBA)"
  },
  {
   value: "Waharoa (NZWAT)",
   label: "Waharoa (NZWAT)"
  },
  {
   value: "Waikari (NZWKI)",
   label: "Waikari (NZWKI)"
  },
  {
   value: "Waikawa (NZWKW)",
   label: "Waikawa (NZWKW)"
  },
  {
   value: "Waipukunau (NZWJL)",
   label: "Waipukunau (NZWJL)"
  },
  {
   value: "Wairau (NZWAR)",
   label: "Wairau (NZWAR)"
  },
  {
   value: "Wairoa (NZWIR)",
   label: "Wairoa (NZWIR)"
  },
  {
   value: "Waitaki (NZWTI)",
   label: "Waitaki (NZWTI)"
  },
  {
   value: "Waitangi (NZWTG)",
   label: "Waitangi (NZWTG)"
  },
  {
   value: "Waitoa (NZWAA)",
   label: "Waitoa (NZWAA)"
  },
  {
   value: "Wanganui (NZWAG)",
   label: "Wanganui (NZWAG)"
  },
  {
   value: "Warkworth (NZWWA)",
   label: "Warkworth (NZWWA)"
  },
  {
   value: "Waverley Harbour (NZWAV)",
   label: "Waverley Harbour (NZWAV)"
  },
  {
   value: "Wellington (NZWLG)",
   label: "Wellington (NZWLG)"
  },
  {
   value: "Westport (NZWSZ)",
   label: "Westport (NZWSZ)"
  },
  {
   value: "Whakatane (NZWHK)",
   label: "Whakatane (NZWHK)"
  },
  {
   value: "Whangaparapara (NZWHN)",
   label: "Whangaparapara (NZWHN)"
  },
  {
   value: "Whangarei (NZWRE)",
   label: "Whangarei (NZWRE)"
  },
  {
   value: "Whekenui (NZWHE)",
   label: "Whekenui (NZWHE)"
  },
  {
   value: "Whenuapai (NZWNP)",
   label: "Whenuapai (NZWNP)"
  },
  {
   value: "Wiri (NZWII)",
   label: "Wiri (NZWII)"
  },
  {
   value: "Fahal (OMFAH)",
   label: "Fahal (OMFAH)"
  },
  {
   value: "Masirah Island (OMMSH)",
   label: "Masirah Island (OMMSH)"
  },
  {
   value: "Min-Al-Fahal (OMMFH)",
   label: "Min-Al-Fahal (OMMFH)"
  },
  {
   value: "Mina Qaboos (OMMNQ)",
   label: "Mina Qaboos (OMMNQ)"
  },
  {
   value: "Golden Bay (NZGOB)",
   label: "Golden Bay (NZGOB)"
  },
  {
   value: "Great Barrier Is (NZGBZ)",
   label: "Great Barrier Is (NZGBZ)"
  },
  {
   value: "Greymouth (NZGMN)",
   label: "Greymouth (NZGMN)"
  },
  {
   value: "Hamilton (NZHLZ)",
   label: "Hamilton (NZHLZ)"
  },
  {
   value: "Hokitika (NZHKK)",
   label: "Hokitika (NZHKK)"
  },
  {
   value: "Horotiu (NZHOU)",
   label: "Horotiu (NZHOU)"
  },
  {
   value: "Invercargill (NZIVC)",
   label: "Invercargill (NZIVC)"
  },
  {
   value: "Kaiapoi (NZKAP)",
   label: "Kaiapoi (NZKAP)"
  },
  {
   value: "Kaikohe (NZKKO)",
   label: "Kaikohe (NZKKO)"
  },
  {
   value: "Kaikoura (NZKBZ)",
   label: "Kaikoura (NZKBZ)"
  },
  {
   value: "Kaitaia (NZKAT)",
   label: "Kaitaia (NZKAT)"
  },
  {
   value: "Kaitangata (NZKTG)",
   label: "Kaitangata (NZKTG)"
  },
  {
   value: "Levin (NZLEV)",
   label: "Levin (NZLEV)"
  },
  {
   value: "Lorneville (NZLRV)",
   label: "Lorneville (NZLRV)"
  },
  {
   value: "Lower Hutt (NZLYJ)",
   label: "Lower Hutt (NZLYJ)"
  },
  {
   value: "Lyttelton (NZLYT)",
   label: "Lyttelton (NZLYT)"
  },
  {
   value: "Marsden Point (NZMAP)",
   label: "Marsden Point (NZMAP)"
  },
  {
   value: "Matamata (NZMTA)",
   label: "Matamata (NZMTA)"
  },
  {
   value: "Mataura (NZMTR)",
   label: "Mataura (NZMTR)"
  },
  {
   value: "Moerewa (NZMOE)",
   label: "Moerewa (NZMOE)"
  },
  {
   value: "Motueka (NZMZP)",
   label: "Motueka (NZMZP)"
  },
  {
   value: "Mount Cook (NZMON)",
   label: "Mount Cook (NZMON)"
  },
  {
   value: "Mount Maunganui (NZMMU)",
   label: "Mount Maunganui (NZMMU)"
  },
  {
   value: "Napier \/ HASTINGS (NZNPE)",
   label: "Napier \/ HASTINGS (NZNPE)"
  },
  {
   value: "Nelson (NZNSN)",
   label: "Nelson (NZNSN)"
  },
  {
   value: "New Plymouth \/ Port Taranaki (NZNPL)",
   label: "New Plymouth \/ Port Taranaki (NZNPL)"
  },
  {
   value: "Oamaru (NZOAM)",
   label: "Oamaru (NZOAM)"
  },
  {
   value: "Ohakea (NZOHA)",
   label: "Ohakea (NZOHA)"
  },
  {
   value: "Onehunga (Manukau Harbour) (NZONE)",
   label: "Onehunga (Manukau Harbour) (NZONE)"
  },
  {
   value: "Opua (Bay Of Island) (NZOPX)",
   label: "Opua (Bay Of Island) (NZOPX)"
  },
  {
   value: "Orini (Oringi) (NZORI)",
   label: "Orini (Oringi) (NZORI)"
  },
  {
   value: "Otago Harbour (NZORR)",
   label: "Otago Harbour (NZORR)"
  },
  {
   value: "Palmerston (NZPMS)",
   label: "Palmerston (NZPMS)"
  },
  {
   value: "Palmerston North (NZPMR)",
   label: "Palmerston North (NZPMR)"
  },
  {
   value: "Penrose (NZPEO)",
   label: "Penrose (NZPEO)"
  },
  {
   value: "Picton (NZPCN)",
   label: "Picton (NZPCN)"
  },
  {
   value: "Port Chalmers (Dunedin Harbour) (NZPOE)",
   label: "Port Chalmers (Dunedin Harbour) (NZPOE)"
  },
  {
   value: "Volda (NOVDA)",
   label: "Volda (NOVDA)"
  },
  {
   value: "Voss (NOVOS)",
   label: "Voss (NOVOS)"
  },
  {
   value: "Ølen (NOOLN)",
   label: "Ølen (NOOLN)"
  },
  {
   value: "Ørje (NOORJ)",
   label: "Ørje (NOORJ)"
  },
  {
   value: "Ørland (NOOLA)",
   label: "Ørland (NOOLA)"
  },
  {
   value: "Ørskog (NOOSG)",
   label: "Ørskog (NOOSG)"
  },
  {
   value: "Ørsta (NOORS)",
   label: "Ørsta (NOORS)"
  },
  {
   value: "Ørsta-Volda (NOHOV)",
   label: "Ørsta-Volda (NOHOV)"
  },
  {
   value: "Øye (NOOYE)",
   label: "Øye (NOOYE)"
  },
  {
   value: "Øygarden (NOOYG)",
   label: "Øygarden (NOOYG)"
  },
  {
   value: "Annapurna (NPANP)",
   label: "Annapurna (NPANP)"
  },
  {
   value: "Biratnagar (NPBIR)",
   label: "Biratnagar (NPBIR)"
  },
  {
   value: "Birgunj (NPBRG)",
   label: "Birgunj (NPBRG)"
  },
  {
   value: "Dhaulagiri (NPDHG)",
   label: "Dhaulagiri (NPDHG)"
  },
  {
   value: "Kailali (NPKAI)",
   label: "Kailali (NPKAI)"
  },
  {
   value: "Kakarbitta (Jhapa) (NPKAK)",
   label: "Kakarbitta (Jhapa) (NPKAK)"
  },
  {
   value: "Kathmandu (NPKTM)",
   label: "Kathmandu (NPKTM)"
  },
  {
   value: "Pokhara (NPPKR)",
   label: "Pokhara (NPPKR)"
  },
  {
   value: "Simara (NPSIF)",
   label: "Simara (NPSIF)"
  },
  {
   value: "Sunauli (NPSUN)",
   label: "Sunauli (NPSUN)"
  },
  {
   value: "Nauru Island (NRINU)",
   label: "Nauru Island (NRINU)"
  },
  {
   value: "Niue Island (NUIUE)",
   label: "Niue Island (NUIUE)"
  },
  {
   value: "Akaroa (NZAKA)",
   label: "Akaroa (NZAKA)"
  },
  {
   value: "Alexandra (NZALR)",
   label: "Alexandra (NZALR)"
  },
  {
   value: "Ardmore (NZAMZ)",
   label: "Ardmore (NZAMZ)"
  },
  {
   value: "Ashburton (NZASG)",
   label: "Ashburton (NZASG)"
  },
  {
   value: "Auckland (NZAKL)",
   label: "Auckland (NZAKL)"
  },
  {
   value: "Blenheim (NZBHE)",
   label: "Blenheim (NZBHE)"
  },
  {
   value: "Bluff (NZBLU)",
   label: "Bluff (NZBLU)"
  },
  {
   value: "Cambridge (NZCGE)",
   label: "Cambridge (NZCGE)"
  },
  {
   value: "Chatham Island (NZCHT)",
   label: "Chatham Island (NZCHT)"
  },
  {
   value: "Cheviot (NZCHE)",
   label: "Cheviot (NZCHE)"
  },
  {
   value: "Christchurch (NZCHC)",
   label: "Christchurch (NZCHC)"
  },
  {
   value: "Dargaville (NZDGR)",
   label: "Dargaville (NZDGR)"
  },
  {
   value: "Deep Cove (NZDPC)",
   label: "Deep Cove (NZDPC)"
  },
  {
   value: "Devonport (NZDEV)",
   label: "Devonport (NZDEV)"
  },
  {
   value: "Doubtful Sound (NZDGO)",
   label: "Doubtful Sound (NZDGO)"
  },
  {
   value: "Dunedin (NZDUD)",
   label: "Dunedin (NZDUD)"
  },
  {
   value: "Fortrose (NZFOR)",
   label: "Fortrose (NZFOR)"
  },
  {
   value: "Foxton (NZFOX)",
   label: "Foxton (NZFOX)"
  },
  {
   value: "Gisborne (NZGIS)",
   label: "Gisborne (NZGIS)"
  },
  {
   value: "Tysfjord (NOTYF)",
   label: "Tysfjord (NOTYF)"
  },
  {
   value: "Tysnes (NOTYN)",
   label: "Tysnes (NOTYN)"
  },
  {
   value: "Tyssedal (NOTSX)",
   label: "Tyssedal (NOTSX)"
  },
  {
   value: "Tysvær (NOTYV)",
   label: "Tysvær (NOTYV)"
  },
  {
   value: "Tømrefjord (NOTOM)",
   label: "Tømrefjord (NOTOM)"
  },
  {
   value: "Tønsberg (NOTON)",
   label: "Tønsberg (NOTON)"
  },
  {
   value: "Ullensvang (NOULL)",
   label: "Ullensvang (NOULL)"
  },
  {
   value: "Ulset (NOULT)",
   label: "Ulset (NOULT)"
  },
  {
   value: "Ulsteinvik (NOULS)",
   label: "Ulsteinvik (NOULS)"
  },
  {
   value: "Ulven (NOULV)",
   label: "Ulven (NOULV)"
  },
  {
   value: "Ulvik (NOUVK)",
   label: "Ulvik (NOUVK)"
  },
  {
   value: "Utsira (NOUTS)",
   label: "Utsira (NOUTS)"
  },
  {
   value: "Utvær (NOUVR)",
   label: "Utvær (NOUVR)"
  },
  {
   value: "Vadheim (NOVHM)",
   label: "Vadheim (NOVHM)"
  },
  {
   value: "Vadsø (NOVDS)",
   label: "Vadsø (NOVDS)"
  },
  {
   value: "Værøy (NOVEY)",
   label: "Værøy (NOVEY)"
  },
  {
   value: "Vågan (NOVGN)",
   label: "Vågan (NOVGN)"
  },
  {
   value: "Vågsøy (NOVGY)",
   label: "Vågsøy (NOVGY)"
  },
  {
   value: "Vaksdal (NOVAK)",
   label: "Vaksdal (NOVAK)"
  },
  {
   value: "Våle (NOVAA)",
   label: "Våle (NOVAA)"
  },
  {
   value: "Valløy (NOVAL)",
   label: "Valløy (NOVAL)"
  },
  {
   value: "Vanse (NOVSE)",
   label: "Vanse (NOVSE)"
  },
  {
   value: "Vanvikan-Leksvik (NOVAN)",
   label: "Vanvikan-Leksvik (NOVAN)"
  },
  {
   value: "Vanylven (NOVAY)",
   label: "Vanylven (NOVAY)"
  },
  {
   value: "Varangerbotn (NOVAB)",
   label: "Varangerbotn (NOVAB)"
  },
  {
   value: "Vardø (NOVAO)",
   label: "Vardø (NOVAO)"
  },
  {
   value: "Vefsn (NOVEF)",
   label: "Vefsn (NOVEF)"
  },
  {
   value: "Vega (NOVEG)",
   label: "Vega (NOVEG)"
  },
  {
   value: "Veggli (NOVGG)",
   label: "Veggli (NOVGG)"
  },
  {
   value: "Vennesla (NOVNA)",
   label: "Vennesla (NOVNA)"
  },
  {
   value: "Verdal (NOVER)",
   label: "Verdal (NOVER)"
  },
  {
   value: "Verran (NOVRR)",
   label: "Verran (NOVRR)"
  },
  {
   value: "Vescre Gran (NOVGR)",
   label: "Vescre Gran (NOVGR)"
  },
  {
   value: "Vestby (NOVSY)",
   label: "Vestby (NOVSY)"
  },
  {
   value: "Vestnes (NOVST)",
   label: "Vestnes (NOVST)"
  },
  {
   value: "Vestvågøy (NOVVY)",
   label: "Vestvågøy (NOVVY)"
  },
  {
   value: "Vettre (NOVTR)",
   label: "Vettre (NOVTR)"
  },
  {
   value: "Vevelstad (NOVEV)",
   label: "Vevelstad (NOVEV)"
  },
  {
   value: "Vik i Sogn (NOVIS)",
   label: "Vik i Sogn (NOVIS)"
  },
  {
   value: "Vikholmen (NOVHN)",
   label: "Vikholmen (NOVHN)"
  },
  {
   value: "Vikna (NOVKN)",
   label: "Vikna (NOVKN)"
  },
  {
   value: "Vindafjord (NOVIF)",
   label: "Vindafjord (NOVIF)"
  },
  {
   value: "Stryn (NOSTR)",
   label: "Stryn (NOSTR)"
  },
  {
   value: "Sture (NOSTU)",
   label: "Sture (NOSTU)"
  },
  {
   value: "Sula (NOSUA)",
   label: "Sula (NOSUA)"
  },
  {
   value: "Suldal (NOSUL)",
   label: "Suldal (NOSUL)"
  },
  {
   value: "Sund (NOSND)",
   label: "Sund (NOSND)"
  },
  {
   value: "Sunndalsøra (NOSUN)",
   label: "Sunndalsøra (NOSUN)"
  },
  {
   value: "Surnadal (NOSUR)",
   label: "Surnadal (NOSUR)"
  },
  {
   value: "Sveiø (NOSVO)",
   label: "Sveiø (NOSVO)"
  },
  {
   value: "Svelgen (NOSVE)",
   label: "Svelgen (NOSVE)"
  },
  {
   value: "Svelvik (NOSVV)",
   label: "Svelvik (NOSVV)"
  },
  {
   value: "Svinesund (NOSVD)",
   label: "Svinesund (NOSVD)"
  },
  {
   value: "Svolvær (NOSVJ)",
   label: "Svolvær (NOSVJ)"
  },
  {
   value: "Sykkylven (NOSYK)",
   label: "Sykkylven (NOSYK)"
  },
  {
   value: "Søgne (NOSNE)",
   label: "Søgne (NOSNE)"
  },
  {
   value: "Sømna (NOSMN)",
   label: "Sømna (NOSMN)"
  },
  {
   value: "Sør-Varanger (NOSVA)",
   label: "Sør-Varanger (NOSVA)"
  },
  {
   value: "Sørfold (NOSOF)",
   label: "Sørfold (NOSOF)"
  },
  {
   value: "Sørreisa (NOSRA)",
   label: "Sørreisa (NOSRA)"
  },
  {
   value: "Sørumsand (NOSOE)",
   label: "Sørumsand (NOSOE)"
  },
  {
   value: "Sørøya (NOSOA)",
   label: "Sørøya (NOSOA)"
  },
  {
   value: "Tana (NOTAA)",
   label: "Tana (NOTAA)"
  },
  {
   value: "Tananger (NOTAE)",
   label: "Tananger (NOTAE)"
  },
  {
   value: "Tau (NOTAU)",
   label: "Tau (NOTAU)"
  },
  {
   value: "Thamshamn (NOTHA)",
   label: "Thamshamn (NOTHA)"
  },
  {
   value: "Tiller (NOTIL)",
   label: "Tiller (NOTIL)"
  },
  {
   value: "Tingvoll (NOTIN)",
   label: "Tingvoll (NOTIN)"
  },
  {
   value: "Tjeldsund (NOTJS)",
   label: "Tjeldsund (NOTJS)"
  },
  {
   value: "Tjøme (NOTJO)",
   label: "Tjøme (NOTJO)"
  },
  {
   value: "Tjørvåg (NOTJR)",
   label: "Tjørvåg (NOTJR)"
  },
  {
   value: "Tofte i Hurum (NOTOF)",
   label: "Tofte i Hurum (NOTOF)"
  },
  {
   value: "Torsken (NOTOR)",
   label: "Torsken (NOTOR)"
  },
  {
   value: "Torvastad (NOTSD)",
   label: "Torvastad (NOTSD)"
  },
  {
   value: "Træna (NOTRA)",
   label: "Træna (NOTRA)"
  },
  {
   value: "Tranøy (NOTRY)",
   label: "Tranøy (NOTRY)"
  },
  {
   value: "Tretten (NOTRE)",
   label: "Tretten (NOTRE)"
  },
  {
   value: "Tromsø (NOTOS)",
   label: "Tromsø (NOTOS)"
  },
  {
   value: "Trondheim (NOTRD)",
   label: "Trondheim (NOTRD)"
  },
  {
   value: "Trones (NOTNS)",
   label: "Trones (NOTNS)"
  },
  {
   value: "Tunborg (NOTUN)",
   label: "Tunborg (NOTUN)"
  },
  {
   value: "Tustna (NOTUS)",
   label: "Tustna (NOTUS)"
  },
  {
   value: "Tvedestrand (NOTVE)",
   label: "Tvedestrand (NOTVE)"
  },
  {
   value: "Tveit (NOTVT)",
   label: "Tveit (NOTVT)"
  },
  {
   value: "Skien (NOSKE)",
   label: "Skien (NOSKE)"
  },
  {
   value: "Skjerstad (NOSST)",
   label: "Skjerstad (NOSST)"
  },
  {
   value: "Skjervøy (NOSKY)",
   label: "Skjervøy (NOSKY)"
  },
  {
   value: "Skjetten (NOSKJ)",
   label: "Skjetten (NOSKJ)"
  },
  {
   value: "Skodje (NOSKO)",
   label: "Skodje (NOSKO)"
  },
  {
   value: "Skogn (NOSKX)",
   label: "Skogn (NOSKX)"
  },
  {
   value: "Skudeneshavn (NOSKU)",
   label: "Skudeneshavn (NOSKU)"
  },
  {
   value: "Skytta (NOSYA)",
   label: "Skytta (NOSYA)"
  },
  {
   value: "Slagen (NOSGE)",
   label: "Slagen (NOSGE)"
  },
  {
   value: "Slagenstangen (NOSLG)",
   label: "Slagenstangen (NOSLG)"
  },
  {
   value: "Slemmestad (NOSLM)",
   label: "Slemmestad (NOSLM)"
  },
  {
   value: "Slependen (NOSLE)",
   label: "Slependen (NOSLE)"
  },
  {
   value: "Smøla (NOSMO)",
   label: "Smøla (NOSMO)"
  },
  {
   value: "Snillfjord (NOSNI)",
   label: "Snillfjord (NOSNI)"
  },
  {
   value: "Sogndal (NOSOG)",
   label: "Sogndal (NOSOG)"
  },
  {
   value: "Sokndal (NOSOK)",
   label: "Sokndal (NOSOK)"
  },
  {
   value: "Sola (NOSLA)",
   label: "Sola (NOSLA)"
  },
  {
   value: "Solund (NOSLD)",
   label: "Solund (NOSLD)"
  },
  {
   value: "Sortland (NOSLX)",
   label: "Sortland (NOSLX)"
  },
  {
   value: "Sotra (NOSRX)",
   label: "Sotra (NOSRX)"
  },
  {
   value: "Spjelkavik (NOSPV)",
   label: "Spjelkavik (NOSPV)"
  },
  {
   value: "Stabekk (NOSBK)",
   label: "Stabekk (NOSBK)"
  },
  {
   value: "Stamsund (NOSUZ)",
   label: "Stamsund (NOSUZ)"
  },
  {
   value: "Stange (NOSTN)",
   label: "Stange (NOSTN)"
  },
  {
   value: "Statfjord Terminal (NOSTT)",
   label: "Statfjord Terminal (NOSTT)"
  },
  {
   value: "Stathelle (NOSTA)",
   label: "Stathelle (NOSTA)"
  },
  {
   value: "Stavanger (NOSVG)",
   label: "Stavanger (NOSVG)"
  },
  {
   value: "Stavern (NOSTV)",
   label: "Stavern (NOSTV)"
  },
  {
   value: "Steigen (NOSTG)",
   label: "Steigen (NOSTG)"
  },
  {
   value: "Steilene (NOSTL)",
   label: "Steilene (NOSTL)"
  },
  {
   value: "Steinkjær (NOSTE)",
   label: "Steinkjær (NOSTE)"
  },
  {
   value: "Steinsund (NOSSD)",
   label: "Steinsund (NOSSD)"
  },
  {
   value: "Stjørdal (NOSTJ)",
   label: "Stjørdal (NOSTJ)"
  },
  {
   value: "Stokke (NOSTK)",
   label: "Stokke (NOSTK)"
  },
  {
   value: "Stokmarknes (NOSKN)",
   label: "Stokmarknes (NOSKN)"
  },
  {
   value: "Stord (NOSRP)",
   label: "Stord (NOSRP)"
  },
  {
   value: "Stordal (NOSDZ)",
   label: "Stordal (NOSDZ)"
  },
  {
   value: "Storfjord (NOSTF)",
   label: "Storfjord (NOSTF)"
  },
  {
   value: "Storskog (NOSTS)",
   label: "Storskog (NOSTS)"
  },
  {
   value: "Strand (NOSTD)",
   label: "Strand (NOSTD)"
  },
  {
   value: "Stranda (NOSRN)",
   label: "Stranda (NOSRN)"
  },
  {
   value: "Straumgjerde (NOSGJ)",
   label: "Straumgjerde (NOSGJ)"
  },
  {
   value: "Risnes (NORNS)",
   label: "Risnes (NORNS)"
  },
  {
   value: "Risør (NORIS)",
   label: "Risør (NORIS)"
  },
  {
   value: "Rjukan (NORKN)",
   label: "Rjukan (NORKN)"
  },
  {
   value: "Roan (NOROA)",
   label: "Roan (NOROA)"
  },
  {
   value: "Rollag (NORLL)",
   label: "Rollag (NORLL)"
  },
  {
   value: "Rolvsøy (NORVY)",
   label: "Rolvsøy (NORVY)"
  },
  {
   value: "Rygge (NORYG)",
   label: "Rygge (NORYG)"
  },
  {
   value: "Rødøy (NORDY)",
   label: "Rødøy (NORDY)"
  },
  {
   value: "Røros (NORRS)",
   label: "Røros (NORRS)"
  },
  {
   value: "Rørvik (NORVK)",
   label: "Rørvik (NORVK)"
  },
  {
   value: "Røst (NORET)",
   label: "Røst (NORET)"
  },
  {
   value: "Røyken (NOROE)",
   label: "Røyken (NOROE)"
  },
  {
   value: "Sagene (NOSGN)",
   label: "Sagene (NOSGN)"
  },
  {
   value: "Salangen (NOSAL)",
   label: "Salangen (NOSAL)"
  },
  {
   value: "Salsbruket (NOSBU)",
   label: "Salsbruket (NOSBU)"
  },
  {
   value: "Saltdal (NOSDL)",
   label: "Saltdal (NOSDL)"
  },
  {
   value: "Samnanger (NOSAM)",
   label: "Samnanger (NOSAM)"
  },
  {
   value: "Sandane (NOSDN)",
   label: "Sandane (NOSDN)"
  },
  {
   value: "Sande (NOSDX)",
   label: "Sande (NOSDX)"
  },
  {
   value: "Sandefjord (NOSAD)",
   label: "Sandefjord (NOSAD)"
  },
  {
   value: "Sandnes (NOSAS)",
   label: "Sandnes (NOSAS)"
  },
  {
   value: "Sandnessjøen (NOSSJ)",
   label: "Sandnessjøen (NOSSJ)"
  },
  {
   value: "Sandvika (NOSDI)",
   label: "Sandvika (NOSDI)"
  },
  {
   value: "Sandøy (NOSAY)",
   label: "Sandøy (NOSAY)"
  },
  {
   value: "Sarpsborg (NOSPG)",
   label: "Sarpsborg (NOSPG)"
  },
  {
   value: "Sauda (NOSAU)",
   label: "Sauda (NOSAU)"
  },
  {
   value: "Selje (NOSJE)",
   label: "Selje (NOSJE)"
  },
  {
   value: "Seljord (NOSEL)",
   label: "Seljord (NOSEL)"
  },
  {
   value: "Sellebakk (NOSEK)",
   label: "Sellebakk (NOSEK)"
  },
  {
   value: "Sem-Tønsberg (NOSET)",
   label: "Sem-Tønsberg (NOSET)"
  },
  {
   value: "Senja (NOSJA)",
   label: "Senja (NOSJA)"
  },
  {
   value: "Sjøholt (NOSJO)",
   label: "Sjøholt (NOSJO)"
  },
  {
   value: "Skaland (NOSAA)",
   label: "Skaland (NOSAA)"
  },
  {
   value: "Skånevik (NOSEI)",
   label: "Skånevik (NOSEI)"
  },
  {
   value: "Skånland (NOSKL)",
   label: "Skånland (NOSKL)"
  },
  {
   value: "Skårer (NOSKA)",
   label: "Skårer (NOSKA)"
  },
  {
   value: "Skarnes (NOSKR)",
   label: "Skarnes (NOSKR)"
  },
  {
   value: "Skatval-Stjordal (NOSKS)",
   label: "Skatval-Stjordal (NOSKS)"
  },
  {
   value: "Skaun (NOSAN)",
   label: "Skaun (NOSAN)"
  },
  {
   value: "Skedsmokorset (NOSKD)",
   label: "Skedsmokorset (NOSKD)"
  },
  {
   value: "Ski (NOSIK)",
   label: "Ski (NOSIK)"
  },
  {
   value: "Skibotn (NOSKB)",
   label: "Skibotn (NOSKB)"
  },
  {
   value: "Nesodden (NONEO)",
   label: "Nesodden (NONEO)"
  },
  {
   value: "Nesseby (NONSB)",
   label: "Nesseby (NONSB)"
  },
  {
   value: "Nesset (NONST)",
   label: "Nesset (NONST)"
  },
  {
   value: "Norddal (NONOD)",
   label: "Norddal (NONOD)"
  },
  {
   value: "Nordfjordeid (NONFD)",
   label: "Nordfjordeid (NONFD)"
  },
  {
   value: "Nordkapp (NONOK)",
   label: "Nordkapp (NONOK)"
  },
  {
   value: "Nordkjosbotn (NONKB)",
   label: "Nordkjosbotn (NONKB)"
  },
  {
   value: "Nordreisa (NONOR)",
   label: "Nordreisa (NONOR)"
  },
  {
   value: "Norheimsund (NONHS)",
   label: "Norheimsund (NONHS)"
  },
  {
   value: "Notodden (NONTB)",
   label: "Notodden (NONTB)"
  },
  {
   value: "Nygard (NONYG)",
   label: "Nygard (NONYG)"
  },
  {
   value: "Nøtterøy (NONTY)",
   label: "Nøtterøy (NONTY)"
  },
  {
   value: "Odda (NOODD)",
   label: "Odda (NOODD)"
  },
  {
   value: "Oksnes (NOOKS)",
   label: "Oksnes (NOOKS)"
  },
  {
   value: "Olden (NOOLD)",
   label: "Olden (NOOLD)"
  },
  {
   value: "Oppdal (NOOPP)",
   label: "Oppdal (NOOPP)"
  },
  {
   value: "Oppegård (NOOPG)",
   label: "Oppegård (NOOPG)"
  },
  {
   value: "Orkanger (NOORK)",
   label: "Orkanger (NOORK)"
  },
  {
   value: "Orkdal (NOORD)",
   label: "Orkdal (NOORD)"
  },
  {
   value: "Os (NOOOS)",
   label: "Os (NOOOS)"
  },
  {
   value: "Oseberg (NOOBG)",
   label: "Oseberg (NOOBG)"
  },
  {
   value: "Osen (NOOSN)",
   label: "Osen (NOOSN)"
  },
  {
   value: "Oslo (NOOSL)",
   label: "Oslo (NOOSL)"
  },
  {
   value: "Osterøy (NOOST)",
   label: "Osterøy (NOOST)"
  },
  {
   value: "Otta (NOOTT)",
   label: "Otta (NOOTT)"
  },
  {
   value: "Porsanger (NOPAR)",
   label: "Porsanger (NOPAR)"
  },
  {
   value: "Porsgrunn (NOPOR)",
   label: "Porsgrunn (NOPOR)"
  },
  {
   value: "Råde (NORAD)",
   label: "Råde (NORAD)"
  },
  {
   value: "Radøy (NORAY)",
   label: "Radøy (NORAY)"
  },
  {
   value: "Rafnes (NORAF)",
   label: "Rafnes (NORAF)"
  },
  {
   value: "Ramfjordnes (NORMJ)",
   label: "Ramfjordnes (NORMJ)"
  },
  {
   value: "Ramsund (NORAM)",
   label: "Ramsund (NORAM)"
  },
  {
   value: "Rana (NORNA)",
   label: "Rana (NORNA)"
  },
  {
   value: "Randaberg (NORDB)",
   label: "Randaberg (NORDB)"
  },
  {
   value: "Raudsandnes (NORSN)",
   label: "Raudsandnes (NORSN)"
  },
  {
   value: "Raufoss (NORFS)",
   label: "Raufoss (NORFS)"
  },
  {
   value: "Rauma (NORAU)",
   label: "Rauma (NORAU)"
  },
  {
   value: "Rekefjord (NOREK)",
   label: "Rekefjord (NOREK)"
  },
  {
   value: "Rekkestad (NORAA)",
   label: "Rekkestad (NORAA)"
  },
  {
   value: "Rennesøy (NOREN)",
   label: "Rennesøy (NOREN)"
  },
  {
   value: "Ringebu (NORIN)",
   label: "Ringebu (NORIN)"
  },
  {
   value: "Risløkka (NORIA)",
   label: "Risløkka (NORIA)"
  },
  {
   value: "Lyngør (NOLNG)",
   label: "Lyngør (NOLNG)"
  },
  {
   value: "Lysaker (NOLYS)",
   label: "Lysaker (NOLYS)"
  },
  {
   value: "Lødingen (NOLOD)",
   label: "Lødingen (NOLOD)"
  },
  {
   value: "Magnor (NOMAG)",
   label: "Magnor (NOMAG)"
  },
  {
   value: "Malm (NOMLM)",
   label: "Malm (NOMLM)"
  },
  {
   value: "Målselv (NOMAV)",
   label: "Målselv (NOMAV)"
  },
  {
   value: "Malvik (NOMAK)",
   label: "Malvik (NOMAK)"
  },
  {
   value: "Måløy (NOMAY)",
   label: "Måløy (NOMAY)"
  },
  {
   value: "Mandal (NOMAN)",
   label: "Mandal (NOMAN)"
  },
  {
   value: "Marikoven (NOMAR)",
   label: "Marikoven (NOMAR)"
  },
  {
   value: "Masfjorden (NOMSF)",
   label: "Masfjorden (NOMSF)"
  },
  {
   value: "Måsøy (NOMSY)",
   label: "Måsøy (NOMSY)"
  },
  {
   value: "Mehamn (NOMEH)",
   label: "Mehamn (NOMEH)"
  },
  {
   value: "Meland (NOMLD)",
   label: "Meland (NOMLD)"
  },
  {
   value: "Melbu (NOMEL)",
   label: "Melbu (NOMEL)"
  },
  {
   value: "Melhus (NOMLS)",
   label: "Melhus (NOMLS)"
  },
  {
   value: "Meløy (NOMEY)",
   label: "Meløy (NOMEY)"
  },
  {
   value: "Menstad (NOMEN)",
   label: "Menstad (NOMEN)"
  },
  {
   value: "Midsund (NOMID)",
   label: "Midsund (NOMID)"
  },
  {
   value: "Minde (NOMIN)",
   label: "Minde (NOMIN)"
  },
  {
   value: "Mindleheim (NOMLH)",
   label: "Mindleheim (NOMLH)"
  },
  {
   value: "Mjøndalen (NOMJO)",
   label: "Mjøndalen (NOMJO)"
  },
  {
   value: "Mo i Rana (NOMQN)",
   label: "Mo i Rana (NOMQN)"
  },
  {
   value: "Modalen (NOMOD)",
   label: "Modalen (NOMOD)"
  },
  {
   value: "Molde (NOMOL)",
   label: "Molde (NOMOL)"
  },
  {
   value: "Mongstad (NOMON)",
   label: "Mongstad (NOMON)"
  },
  {
   value: "Mosjøen (NOMJF)",
   label: "Mosjøen (NOMJF)"
  },
  {
   value: "Moskenes (NOMSK)",
   label: "Moskenes (NOMSK)"
  },
  {
   value: "Moss (NOMSS)",
   label: "Moss (NOMSS)"
  },
  {
   value: "Mosvik (NOMSV)",
   label: "Mosvik (NOMSV)"
  },
  {
   value: "Muruvik (NOMRV)",
   label: "Muruvik (NOMRV)"
  },
  {
   value: "Myre-Oksnes (NOMYO)",
   label: "Myre-Oksnes (NOMYO)"
  },
  {
   value: "Mysen (NOMYS)",
   label: "Mysen (NOMYS)"
  },
  {
   value: "Nærbø (NONAE)",
   label: "Nærbø (NONAE)"
  },
  {
   value: "Nærsnes (NONSS)",
   label: "Nærsnes (NONSS)"
  },
  {
   value: "Nærøy (NONRY)",
   label: "Nærøy (NONRY)"
  },
  {
   value: "Namdalseid (NONDE)",
   label: "Namdalseid (NONDE)"
  },
  {
   value: "Namsos (NOOSY)",
   label: "Namsos (NOOSY)"
  },
  {
   value: "Nanset (NONAN)",
   label: "Nanset (NONAN)"
  },
  {
   value: "Narvik (NONVK)",
   label: "Narvik (NONVK)"
  },
  {
   value: "Naustdal (NONAU)",
   label: "Naustdal (NONAU)"
  },
  {
   value: "Nesflaten-Suldal (NONES)",
   label: "Nesflaten-Suldal (NONES)"
  },
  {
   value: "Kraakerøy (NOKRY)",
   label: "Kraakerøy (NOKRY)"
  },
  {
   value: "Kragerø (NOKRA)",
   label: "Kragerø (NOKRA)"
  },
  {
   value: "Kristiansand (NOKRS)",
   label: "Kristiansand (NOKRS)"
  },
  {
   value: "Kristiansund (NOKSU)",
   label: "Kristiansund (NOKSU)"
  },
  {
   value: "Krokstadelva (NOKSA)",
   label: "Krokstadelva (NOKSA)"
  },
  {
   value: "Kvæfjord (NOKVF)",
   label: "Kvæfjord (NOKVF)"
  },
  {
   value: "Kvænangen (NOKVN)",
   label: "Kvænangen (NOKVN)"
  },
  {
   value: "Kvalsund (NOKVS)",
   label: "Kvalsund (NOKVS)"
  },
  {
   value: "Kvam (NOKVM)",
   label: "Kvam (NOKVM)"
  },
  {
   value: "Kvinesdal (NOKVD)",
   label: "Kvinesdal (NOKVD)"
  },
  {
   value: "Kvinnherad (NOKVH)",
   label: "Kvinnherad (NOKVH)"
  },
  {
   value: "Kvitsøy (NOKSY)",
   label: "Kvitsøy (NOKSY)"
  },
  {
   value: "Kyrksæterøra (NOKYR)",
   label: "Kyrksæterøra (NOKYR)"
  },
  {
   value: "Lærdal (NOLRD)",
   label: "Lærdal (NOLRD)"
  },
  {
   value: "Lakselv (NOLKL)",
   label: "Lakselv (NOLKL)"
  },
  {
   value: "Langesund (NOLAD)",
   label: "Langesund (NOLAD)"
  },
  {
   value: "Larkollen (NOLRK)",
   label: "Larkollen (NOLRK)"
  },
  {
   value: "Larvik (NOLAR)",
   label: "Larvik (NOLAR)"
  },
  {
   value: "Lavangen (NOLAV)",
   label: "Lavangen (NOLAV)"
  },
  {
   value: "Lebesby (NOLEB)",
   label: "Lebesby (NOLEB)"
  },
  {
   value: "Leikanger (NOLEK)",
   label: "Leikanger (NOLEK)"
  },
  {
   value: "Leirfjord (NOLEF)",
   label: "Leirfjord (NOLEF)"
  },
  {
   value: "Leirvik (NOLRI)",
   label: "Leirvik (NOLRI)"
  },
  {
   value: "Leka (NOLKA)",
   label: "Leka (NOLKA)"
  },
  {
   value: "Leksvik (NOLKV)",
   label: "Leksvik (NOLKV)"
  },
  {
   value: "Lensvik (NOLEN)",
   label: "Lensvik (NOLEN)"
  },
  {
   value: "Lervik (NOLER)",
   label: "Lervik (NOLER)"
  },
  {
   value: "Levanger (NOLEV)",
   label: "Levanger (NOLEV)"
  },
  {
   value: "Lier (NOLIE)",
   label: "Lier (NOLIE)"
  },
  {
   value: "Lillehammer (NOLLH)",
   label: "Lillehammer (NOLLH)"
  },
  {
   value: "Lillesand (NOLIL)",
   label: "Lillesand (NOLIL)"
  },
  {
   value: "Lillestrøm (NOLST)",
   label: "Lillestrøm (NOLST)"
  },
  {
   value: "Lindås (NOLIN)",
   label: "Lindås (NOLIN)"
  },
  {
   value: "Lindesnes (NOLDS)",
   label: "Lindesnes (NOLDS)"
  },
  {
   value: "Lom (NOLOM)",
   label: "Lom (NOLOM)"
  },
  {
   value: "Loppa (NOLOP)",
   label: "Loppa (NOLOP)"
  },
  {
   value: "Lurøy (NOLUR)",
   label: "Lurøy (NOLUR)"
  },
  {
   value: "Luster (NOLUS)",
   label: "Luster (NOLUS)"
  },
  {
   value: "Lutnes (NOLUT)",
   label: "Lutnes (NOLUT)"
  },
  {
   value: "Lyngdal (NOLND)",
   label: "Lyngdal (NOLND)"
  },
  {
   value: "Lyngen (NOLYN)",
   label: "Lyngen (NOLYN)"
  },
  {
   value: "Hurum (NOHUR)",
   label: "Hurum (NOHUR)"
  },
  {
   value: "Husnes (NOHUS)",
   label: "Husnes (NOHUS)"
  },
  {
   value: "Hvaler (NOHVA)",
   label: "Hvaler (NOHVA)"
  },
  {
   value: "Hvalstad (NOHVL)",
   label: "Hvalstad (NOHVL)"
  },
  {
   value: "Hyllestadø (NOHYL)",
   label: "Hyllestadø (NOHYL)"
  },
  {
   value: "Hyne (NOHYN)",
   label: "Hyne (NOHYN)"
  },
  {
   value: "Hølen (NOHLN)",
   label: "Hølen (NOHLN)"
  },
  {
   value: "Hønefoss (NOHFS)",
   label: "Hønefoss (NOHFS)"
  },
  {
   value: "Høyanger (NOHYR)",
   label: "Høyanger (NOHYR)"
  },
  {
   value: "Høylandet (NOHLT)",
   label: "Høylandet (NOHLT)"
  },
  {
   value: "Ibestad (NOIBE)",
   label: "Ibestad (NOIBE)"
  },
  {
   value: "Ikornnes (NOIKR)",
   label: "Ikornnes (NOIKR)"
  },
  {
   value: "Inderøy (NOIND)",
   label: "Inderøy (NOIND)"
  },
  {
   value: "Jarlsberg Apt\/Tönsberg (NOJAR)",
   label: "Jarlsberg Apt\/Tönsberg (NOJAR)"
  },
  {
   value: "Jessheim (NOJSH)",
   label: "Jessheim (NOJSH)"
  },
  {
   value: "Jevnaker (NOJVK)",
   label: "Jevnaker (NOJVK)"
  },
  {
   value: "Jondal (NOJON)",
   label: "Jondal (NOJON)"
  },
  {
   value: "Jørpeland (NOJLD)",
   label: "Jørpeland (NOJLD)"
  },
  {
   value: "Jøssinghamn (NOJSS)",
   label: "Jøssinghamn (NOJSS)"
  },
  {
   value: "Kåfjord (NOKAF)",
   label: "Kåfjord (NOKAF)"
  },
  {
   value: "Kalvaag (NOKVA)",
   label: "Kalvaag (NOKVA)"
  },
  {
   value: "Kambo (NOKMO)",
   label: "Kambo (NOKMO)"
  },
  {
   value: "Karasjok (NOKSJ)",
   label: "Karasjok (NOKSJ)"
  },
  {
   value: "Karlsøy (NOKAY)",
   label: "Karlsøy (NOKAY)"
  },
  {
   value: "Karmsund (NOKAS)",
   label: "Karmsund (NOKAS)"
  },
  {
   value: "Karmøy (NOKMY)",
   label: "Karmøy (NOKMY)"
  },
  {
   value: "Karstø (NOKAR)",
   label: "Karstø (NOKAR)"
  },
  {
   value: "Kaupanger (NOKPG)",
   label: "Kaupanger (NOKPG)"
  },
  {
   value: "Kautokeino (NOKTK)",
   label: "Kautokeino (NOKTK)"
  },
  {
   value: "Kilsund (NOKSD)",
   label: "Kilsund (NOKSD)"
  },
  {
   value: "Kinsarvik (NOKIV)",
   label: "Kinsarvik (NOKIV)"
  },
  {
   value: "Kirkenes (NOKKN)",
   label: "Kirkenes (NOKKN)"
  },
  {
   value: "Kjøpsvik (NOKJK)",
   label: "Kjøpsvik (NOKJK)"
  },
  {
   value: "Klepp (NOKLP)",
   label: "Klepp (NOKLP)"
  },
  {
   value: "Kløfta (NOKLO)",
   label: "Kløfta (NOKLO)"
  },
  {
   value: "Knarrevik (NOKRV)",
   label: "Knarrevik (NOKRV)"
  },
  {
   value: "Kolbotn (NOKBT)",
   label: "Kolbotn (NOKBT)"
  },
  {
   value: "Kongsberg (NOKSB)",
   label: "Kongsberg (NOKSB)"
  },
  {
   value: "Kongsvinger (NOKSV)",
   label: "Kongsvinger (NOKSV)"
  },
  {
   value: "Kopervik (NOKOP)",
   label: "Kopervik (NOKOP)"
  },
  {
   value: "Koppang (NOKPP)",
   label: "Koppang (NOKPP)"
  },
  {
   value: "Grimstad (NOGTD)",
   label: "Grimstad (NOGTD)"
  },
  {
   value: "Grong (NOGRO)",
   label: "Grong (NOGRO)"
  },
  {
   value: "Gulen (NOGUL)",
   label: "Gulen (NOGUL)"
  },
  {
   value: "Hå (NOHAA)",
   label: "Hå (NOHAA)"
  },
  {
   value: "Hadsel (NOHAD)",
   label: "Hadsel (NOHAD)"
  },
  {
   value: "Hafrsfjord (NOHHF)",
   label: "Hafrsfjord (NOHHF)"
  },
  {
   value: "Hågan (NOHAG)",
   label: "Hågan (NOHAG)"
  },
  {
   value: "Halden (NOHAL)",
   label: "Halden (NOHAL)"
  },
  {
   value: "Halsa (NOHLS)",
   label: "Halsa (NOHLS)"
  },
  {
   value: "Halvorshavn (NOHAN)",
   label: "Halvorshavn (NOHAN)"
  },
  {
   value: "Hamar (NOHMR)",
   label: "Hamar (NOHMR)"
  },
  {
   value: "Hamarøy (NOHMY)",
   label: "Hamarøy (NOHMY)"
  },
  {
   value: "Hammerfall (NOHFL)",
   label: "Hammerfall (NOHFL)"
  },
  {
   value: "Hammerfest (NOHFT)",
   label: "Hammerfest (NOHFT)"
  },
  {
   value: "Haram (NOHAR)",
   label: "Haram (NOHAR)"
  },
  {
   value: "Hareid (NOHRI)",
   label: "Hareid (NOHRI)"
  },
  {
   value: "Harstad (NOHRD)",
   label: "Harstad (NOHRD)"
  },
  {
   value: "Haslum (NOHAS)",
   label: "Haslum (NOHAS)"
  },
  {
   value: "Hasvik (NOHVK)",
   label: "Hasvik (NOHVK)"
  },
  {
   value: "Haugesund (NOHAU)",
   label: "Haugesund (NOHAU)"
  },
  {
   value: "Haugsvik (NOHGV)",
   label: "Haugsvik (NOHGV)"
  },
  {
   value: "Håvik (NOHVI)",
   label: "Håvik (NOHVI)"
  },
  {
   value: "Heklestrand (NOHEK)",
   label: "Heklestrand (NOHEK)"
  },
  {
   value: "Hemne (NOHME)",
   label: "Hemne (NOHME)"
  },
  {
   value: "Hemnes (NOHMS)",
   label: "Hemnes (NOHMS)"
  },
  {
   value: "Hemnesberget (NOHNE)",
   label: "Hemnesberget (NOHNE)"
  },
  {
   value: "Herre-Bamble (NOHRE)",
   label: "Herre-Bamble (NOHRE)"
  },
  {
   value: "Herøy (NOHER)",
   label: "Herøy (NOHER)"
  },
  {
   value: "Herøya (NOHRY)",
   label: "Herøya (NOHRY)"
  },
  {
   value: "Hestvika (NOHES)",
   label: "Hestvika (NOHES)"
  },
  {
   value: "Hitra (NOHIT)",
   label: "Hitra (NOHIT)"
  },
  {
   value: "Hjelmland (NOHJL)",
   label: "Hjelmland (NOHJL)"
  },
  {
   value: "Hjerkinn (NOHJE)",
   label: "Hjerkinn (NOHJE)"
  },
  {
   value: "Holla (NOHLA)",
   label: "Holla (NOHLA)"
  },
  {
   value: "Holmedal (NOHLM)",
   label: "Holmedal (NOHLM)"
  },
  {
   value: "Holmestrand (NOHOL)",
   label: "Holmestrand (NOHOL)"
  },
  {
   value: "Hommelvik (NOHOK)",
   label: "Hommelvik (NOHOK)"
  },
  {
   value: "Honningsvåg (NOHVG)",
   label: "Honningsvåg (NOHVG)"
  },
  {
   value: "Hornindal (NOHND)",
   label: "Hornindal (NOHND)"
  },
  {
   value: "Horten (NOHOR)",
   label: "Horten (NOHOR)"
  },
  {
   value: "Hunndalen (NOHUN)",
   label: "Hunndalen (NOHUN)"
  },
  {
   value: "Fjaler (NOFJA)",
   label: "Fjaler (NOFJA)"
  },
  {
   value: "Fjell (NOFJE)",
   label: "Fjell (NOFJE)"
  },
  {
   value: "Fjelldal (NOFJL)",
   label: "Fjelldal (NOFJL)"
  },
  {
   value: "Flakstad (NOFKS)",
   label: "Flakstad (NOFKS)"
  },
  {
   value: "Flatanger (NOFLT)",
   label: "Flatanger (NOFLT)"
  },
  {
   value: "Flekkefjord (NOFFD)",
   label: "Flekkefjord (NOFFD)"
  },
  {
   value: "Flora (NOFRO)",
   label: "Flora (NOFRO)"
  },
  {
   value: "Foldafoss (NOFOL)",
   label: "Foldafoss (NOFOL)"
  },
  {
   value: "Förde (NOFDE)",
   label: "Förde (NOFDE)"
  },
  {
   value: "Forsand (NOFOR)",
   label: "Forsand (NOFOR)"
  },
  {
   value: "Fortun-Luster (NOFTL)",
   label: "Fortun-Luster (NOFTL)"
  },
  {
   value: "Forus (NOFRS)",
   label: "Forus (NOFRS)"
  },
  {
   value: "Fosnavåg (NOFOS)",
   label: "Fosnavåg (NOFOS)"
  },
  {
   value: "Fosnes (NOFSN)",
   label: "Fosnes (NOFSN)"
  },
  {
   value: "Fræena (NOFRE)",
   label: "Fræena (NOFRE)"
  },
  {
   value: "Fredrikstad (NOFRK)",
   label: "Fredrikstad (NOFRK)"
  },
  {
   value: "Frei (NOFRJ)",
   label: "Frei (NOFRJ)"
  },
  {
   value: "Frogn (NOFRN)",
   label: "Frogn (NOFRN)"
  },
  {
   value: "Frosta (NOFRT)",
   label: "Frosta (NOFRT)"
  },
  {
   value: "Frøya (NOFRA)",
   label: "Frøya (NOFRA)"
  },
  {
   value: "Fusa (NOFUS)",
   label: "Fusa (NOFUS)"
  },
  {
   value: "Gamle Fredrikstad (NOGFR)",
   label: "Gamle Fredrikstad (NOGFR)"
  },
  {
   value: "Gamvik (NOGAM)",
   label: "Gamvik (NOGAM)"
  },
  {
   value: "Garnes (NOGNE)",
   label: "Garnes (NOGNE)"
  },
  {
   value: "Gaular (NOGAU)",
   label: "Gaular (NOGAU)"
  },
  {
   value: "Geilo (NOGEI)",
   label: "Geilo (NOGEI)"
  },
  {
   value: "Geiranger (NOGNR)",
   label: "Geiranger (NOGNR)"
  },
  {
   value: "Geithus (NOGTH)",
   label: "Geithus (NOGTH)"
  },
  {
   value: "Gibostad (NOGBD)",
   label: "Gibostad (NOGBD)"
  },
  {
   value: "Gildeskål (NOGIL)",
   label: "Gildeskål (NOGIL)"
  },
  {
   value: "Giske (NOGIS)",
   label: "Giske (NOGIS)"
  },
  {
   value: "Gjemnes (NOGJM)",
   label: "Gjemnes (NOGJM)"
  },
  {
   value: "Gjesdal (NOGJS)",
   label: "Gjesdal (NOGJS)"
  },
  {
   value: "Gjøvik (NOGVK)",
   label: "Gjøvik (NOGVK)"
  },
  {
   value: "Glomfjord (NOGLO)",
   label: "Glomfjord (NOGLO)"
  },
  {
   value: "Gloppen (NOGLP)",
   label: "Gloppen (NOGLP)"
  },
  {
   value: "Gol (NOGLL)",
   label: "Gol (NOGLL)"
  },
  {
   value: "Granvin (NOGRV)",
   label: "Granvin (NOGRV)"
  },
  {
   value: "Gratangen (NOGRT)",
   label: "Gratangen (NOGRT)"
  },
  {
   value: "Gravdal (NOGRD)",
   label: "Gravdal (NOGRD)"
  },
  {
   value: "Greaker (NOGRE)",
   label: "Greaker (NOGRE)"
  },
  {
   value: "Grenland (NOGVL)",
   label: "Grenland (NOGVL)"
  },
  {
   value: "Brakstad (NOBKD)",
   label: "Brakstad (NOBKD)"
  },
  {
   value: "Brattvåg (NOBRV)",
   label: "Brattvåg (NOBRV)"
  },
  {
   value: "Bremanger (NOBRE)",
   label: "Bremanger (NOBRE)"
  },
  {
   value: "Brevik (NOBVK)",
   label: "Brevik (NOBVK)"
  },
  {
   value: "Bryne (NOBRY)",
   label: "Bryne (NOBRY)"
  },
  {
   value: "Brønnøy (NOBRO)",
   label: "Brønnøy (NOBRO)"
  },
  {
   value: "Brønnøysund (NOBNN)",
   label: "Brønnøysund (NOBNN)"
  },
  {
   value: "Buviken (NOBUV)",
   label: "Buviken (NOBUV)"
  },
  {
   value: "Bø (NOBOX)",
   label: "Bø (NOBOX)"
  },
  {
   value: "Bømlo (NOBOM)",
   label: "Bømlo (NOBOM)"
  },
  {
   value: "Disenå (NODIS)",
   label: "Disenå (NODIS)"
  },
  {
   value: "Dombås (NODOM)",
   label: "Dombås (NODOM)"
  },
  {
   value: "Drag (NODRG)",
   label: "Drag (NODRG)"
  },
  {
   value: "Drammen (NODRM)",
   label: "Drammen (NODRM)"
  },
  {
   value: "Drevsjø (NODRE)",
   label: "Drevsjø (NODRE)"
  },
  {
   value: "Drøbak (NODRK)",
   label: "Drøbak (NODRK)"
  },
  {
   value: "Dyrvik (NODYR)",
   label: "Dyrvik (NODYR)"
  },
  {
   value: "Dyrøy (NODYY)",
   label: "Dyrøy (NODYY)"
  },
  {
   value: "Dønna (NODON)",
   label: "Dønna (NODON)"
  },
  {
   value: "Eid (NOEID)",
   label: "Eid (NOEID)"
  },
  {
   value: "Eide (NOEDE)",
   label: "Eide (NOEDE)"
  },
  {
   value: "Eidfjord (NOEDF)",
   label: "Eidfjord (NOEDF)"
  },
  {
   value: "Eigersund (NOEGD)",
   label: "Eigersund (NOEGD)"
  },
  {
   value: "Eikefet (NOEKF)",
   label: "Eikefet (NOEKF)"
  },
  {
   value: "Eina (NOENA)",
   label: "Eina (NOENA)"
  },
  {
   value: "Elvebakken (NOEBN)",
   label: "Elvebakken (NOEBN)"
  },
  {
   value: "Elverum (NOELV)",
   label: "Elverum (NOELV)"
  },
  {
   value: "Etne (NOETN)",
   label: "Etne (NOETN)"
  },
  {
   value: "Evenes (NOEVE)",
   label: "Evenes (NOEVE)"
  },
  {
   value: "Evje (NOEVJ)",
   label: "Evje (NOEVJ)"
  },
  {
   value: "Eydehavn (NOEYD)",
   label: "Eydehavn (NOEYD)"
  },
  {
   value: "Fagernes (NOFGN)",
   label: "Fagernes (NOFGN)"
  },
  {
   value: "Fagerstrand (NOFAX)",
   label: "Fagerstrand (NOFAX)"
  },
  {
   value: "Farsund (NOFAN)",
   label: "Farsund (NOFAN)"
  },
  {
   value: "Fauske (NOFAU)",
   label: "Fauske (NOFAU)"
  },
  {
   value: "Fedje (NOFED)",
   label: "Fedje (NOFED)"
  },
  {
   value: "Finneid (NOFND)",
   label: "Finneid (NOFND)"
  },
  {
   value: "Finnsnes (NOFNE)",
   label: "Finnsnes (NOFNE)"
  },
  {
   value: "Finnøy (NOFNY)",
   label: "Finnøy (NOFNY)"
  },
  {
   value: "Fiska (NOFIS)",
   label: "Fiska (NOFIS)"
  },
  {
   value: "Fiskeneset (NOFNT)",
   label: "Fiskeneset (NOFNT)"
  },
  {
   value: "Fitjar (NOFIT)",
   label: "Fitjar (NOFIT)"
  },
  {
   value: "Arnes (NOARN)",
   label: "Arnes (NOARN)"
  },
  {
   value: "Ås (NOAAS)",
   label: "Ås (NOAAS)"
  },
  {
   value: "Asker (NOASK)",
   label: "Asker (NOASK)"
  },
  {
   value: "Askim (NOASM)",
   label: "Askim (NOASM)"
  },
  {
   value: "Askvoll (NOASL)",
   label: "Askvoll (NOASL)"
  },
  {
   value: "Askøy (NOASY)",
   label: "Askøy (NOASY)"
  },
  {
   value: "Aukra (NOAUK)",
   label: "Aukra (NOAUK)"
  },
  {
   value: "Aure (NOAUE)",
   label: "Aure (NOAUE)"
  },
  {
   value: "Aurland (NOAUL)",
   label: "Aurland (NOAUL)"
  },
  {
   value: "Aurskog (NOAUR)",
   label: "Aurskog (NOAUR)"
  },
  {
   value: "Austevoll (NOASV)",
   label: "Austevoll (NOASV)"
  },
  {
   value: "Austrheim (NOASH)",
   label: "Austrheim (NOASH)"
  },
  {
   value: "Avaldnes (NOAVA)",
   label: "Avaldnes (NOAVA)"
  },
  {
   value: "Averøy (NOAVE)",
   label: "Averøy (NOAVE)"
  },
  {
   value: "Bærum (NOBAR)",
   label: "Bærum (NOBAR)"
  },
  {
   value: "Balestrand (NOBLS)",
   label: "Balestrand (NOBLS)"
  },
  {
   value: "Balholm (NOBHL)",
   label: "Balholm (NOBHL)"
  },
  {
   value: "Ballangen (NOBLL)",
   label: "Ballangen (NOBLL)"
  },
  {
   value: "Ballstad (NOBSD)",
   label: "Ballstad (NOBSD)"
  },
  {
   value: "Balsfjord (NOBAF)",
   label: "Balsfjord (NOBAF)"
  },
  {
   value: "Bamble (NOBAM)",
   label: "Bamble (NOBAM)"
  },
  {
   value: "Bangsund (NOBSU)",
   label: "Bangsund (NOBSU)"
  },
  {
   value: "Bardufoss (NOBDU)",
   label: "Bardufoss (NOBDU)"
  },
  {
   value: "Barkåker (NOBAK)",
   label: "Barkåker (NOBAK)"
  },
  {
   value: "Båtsfjord (NOBJF)",
   label: "Båtsfjord (NOBJF)"
  },
  {
   value: "Beiarn (NOBEJ)",
   label: "Beiarn (NOBEJ)"
  },
  {
   value: "Berg (NOBER)",
   label: "Berg (NOBER)"
  },
  {
   value: "Bergen (NOBGO)",
   label: "Bergen (NOBGO)"
  },
  {
   value: "Berkak (NOBRK)",
   label: "Berkak (NOBRK)"
  },
  {
   value: "Berlevag (NOBVG)",
   label: "Berlevag (NOBVG)"
  },
  {
   value: "Bindal (NOBIN)",
   label: "Bindal (NOBIN)"
  },
  {
   value: "Bismo (NOBIS)",
   label: "Bismo (NOBIS)"
  },
  {
   value: "Bjarkøy (NOBJY)",
   label: "Bjarkøy (NOBJY)"
  },
  {
   value: "Bjerke (NOBJK)",
   label: "Bjerke (NOBJK)"
  },
  {
   value: "Bjugn (NOBJU)",
   label: "Bjugn (NOBJU)"
  },
  {
   value: "Bjørkås (NOBJX)",
   label: "Bjørkås (NOBJX)"
  },
  {
   value: "Bodø (NOBOO)",
   label: "Bodø (NOBOO)"
  },
  {
   value: "Bokn (NOBOK)",
   label: "Bokn (NOBOK)"
  },
  {
   value: "Borg (NOBRG)",
   label: "Borg (NOBRG)"
  },
  {
   value: "Borge (NOBGE)",
   label: "Borge (NOBGE)"
  },
  {
   value: "Borgenhaugen (NOBOR)",
   label: "Borgenhaugen (NOBOR)"
  },
  {
   value: "Borgestad (NOBGS)",
   label: "Borgestad (NOBGS)"
  },
  {
   value: "Borre (NOBRR)",
   label: "Borre (NOBRR)"
  },
  {
   value: "Zenderen (NLZND)",
   label: "Zenderen (NLZND)"
  },
  {
   value: "Zetten (NLZET)",
   label: "Zetten (NLZET)"
  },
  {
   value: "Zevenaar (NLZEV)",
   label: "Zevenaar (NLZEV)"
  },
  {
   value: "Zevenbergen (NLZVB)",
   label: "Zevenbergen (NLZVB)"
  },
  {
   value: "Zevenhuizen (Friesland) (NLZHU)",
   label: "Zevenhuizen (Friesland) (NLZHU)"
  },
  {
   value: "Zevenhuizen (Utrecht) (NLZHN)",
   label: "Zevenhuizen (Utrecht) (NLZHN)"
  },
  {
   value: "Zierikzee (NLZIE)",
   label: "Zierikzee (NLZIE)"
  },
  {
   value: "Zoelen (NLZOE)",
   label: "Zoelen (NLZOE)"
  },
  {
   value: "Zoetermeer (NLZTM)",
   label: "Zoetermeer (NLZTM)"
  },
  {
   value: "Zoeterwoude-Rijndijk (NLZWD)",
   label: "Zoeterwoude-Rijndijk (NLZWD)"
  },
  {
   value: "Zoutkamp (NLZOT)",
   label: "Zoutkamp (NLZOT)"
  },
  {
   value: "Zuidland (NLZUL)",
   label: "Zuidland (NLZUL)"
  },
  {
   value: "Zundert (NLZUD)",
   label: "Zundert (NLZUD)"
  },
  {
   value: "Zutphen (NLZUT)",
   label: "Zutphen (NLZUT)"
  },
  {
   value: "Zwaag (NLZAG)",
   label: "Zwaag (NLZAG)"
  },
  {
   value: "Zwaagdijk (NLZGD)",
   label: "Zwaagdijk (NLZGD)"
  },
  {
   value: "Zwaagwesteinde (NLZWE)",
   label: "Zwaagwesteinde (NLZWE)"
  },
  {
   value: "Zwammerdam (NLZMM)",
   label: "Zwammerdam (NLZMM)"
  },
  {
   value: "Zwanenburg (NLZWA)",
   label: "Zwanenburg (NLZWA)"
  },
  {
   value: "Zwartsluis (NLZWS)",
   label: "Zwartsluis (NLZWS)"
  },
  {
   value: "Zwijndrecht (NLZWI)",
   label: "Zwijndrecht (NLZWI)"
  },
  {
   value: "Zwolle (NLZWO)",
   label: "Zwolle (NLZWO)"
  },
  {
   value: "Aaheim (NOAHM)",
   label: "Aaheim (NOAHM)"
  },
  {
   value: "Aakrehamn (NOAKM)",
   label: "Aakrehamn (NOAKM)"
  },
  {
   value: "Aarebakken (NOABN)",
   label: "Aarebakken (NOABN)"
  },
  {
   value: "Åfjord (NOAAF)",
   label: "Åfjord (NOAAF)"
  },
  {
   value: "Agdenes (NOAGD)",
   label: "Agdenes (NOAGD)"
  },
  {
   value: "Agnefest (NOAFT)",
   label: "Agnefest (NOAFT)"
  },
  {
   value: "Ågotnes (NOAGO)",
   label: "Ågotnes (NOAGO)"
  },
  {
   value: "Ålesund (NOAES)",
   label: "Ålesund (NOAES)"
  },
  {
   value: "Alnabru (NOALN)",
   label: "Alnabru (NOALN)"
  },
  {
   value: "Alstahaug (NOALS)",
   label: "Alstahaug (NOALS)"
  },
  {
   value: "Alta (NOALF)",
   label: "Alta (NOALF)"
  },
  {
   value: "Alvik (NOAAV)",
   label: "Alvik (NOAAV)"
  },
  {
   value: "Åndalsnes (NOAND)",
   label: "Åndalsnes (NOAND)"
  },
  {
   value: "Andebu (NOANU)",
   label: "Andebu (NOANU)"
  },
  {
   value: "Andenes (NOADN)",
   label: "Andenes (NOADN)"
  },
  {
   value: "Andøy (NOADY)",
   label: "Andøy (NOADY)"
  },
  {
   value: "Årdal (NOAAN)",
   label: "Årdal (NOAAN)"
  },
  {
   value: "Årdalstangen (NOARD)",
   label: "Årdalstangen (NOARD)"
  },
  {
   value: "Arendal (NOARE)",
   label: "Arendal (NOARE)"
  },
  {
   value: "Wervershoof (NLWEH)",
   label: "Wervershoof (NLWEH)"
  },
  {
   value: "Wessem (NLWSM)",
   label: "Wessem (NLWSM)"
  },
  {
   value: "West-Terschelling (NLWTE)",
   label: "West-Terschelling (NLWTE)"
  },
  {
   value: "Westdorpe (NLWDP)",
   label: "Westdorpe (NLWDP)"
  },
  {
   value: "Westerhaar-Vriezenveensewijk (NLWES)",
   label: "Westerhaar-Vriezenveensewijk (NLWES)"
  },
  {
   value: "Westervoort (NLWEV)",
   label: "Westervoort (NLWEV)"
  },
  {
   value: "Westknollendam (NLWAM)",
   label: "Westknollendam (NLWAM)"
  },
  {
   value: "Westmaas (NLWEM)",
   label: "Westmaas (NLWEM)"
  },
  {
   value: "Westwoud (NLWTU)",
   label: "Westwoud (NLWTU)"
  },
  {
   value: "Westzaan (NLWTZ)",
   label: "Westzaan (NLWTZ)"
  },
  {
   value: "Wierden (NLWID)",
   label: "Wierden (NLWID)"
  },
  {
   value: "Wieringerwerf (NLWIW)",
   label: "Wieringerwerf (NLWIW)"
  },
  {
   value: "Wijchen (NLWCH)",
   label: "Wijchen (NLWCH)"
  },
  {
   value: "Wijde Wormer (NLWWR)",
   label: "Wijde Wormer (NLWWR)"
  },
  {
   value: "Wijdenes (NLWDS)",
   label: "Wijdenes (NLWDS)"
  },
  {
   value: "Wijhe (NLWIJ)",
   label: "Wijhe (NLWIJ)"
  },
  {
   value: "Wijk (NLWIK)",
   label: "Wijk (NLWIK)"
  },
  {
   value: "Wijk bij Duurstede (NLWBD)",
   label: "Wijk bij Duurstede (NLWBD)"
  },
  {
   value: "Wildervank (NLWLD)",
   label: "Wildervank (NLWLD)"
  },
  {
   value: "Willemstad (NLWIS)",
   label: "Willemstad (NLWIS)"
  },
  {
   value: "Wilnis (NLWLN)",
   label: "Wilnis (NLWLN)"
  },
  {
   value: "Winkel (NLWNK)",
   label: "Winkel (NLWNK)"
  },
  {
   value: "Winschoten (NLWSC)",
   label: "Winschoten (NLWSC)"
  },
  {
   value: "Winterswijk (NLWTW)",
   label: "Winterswijk (NLWTW)"
  },
  {
   value: "Woerden (NLWOR)",
   label: "Woerden (NLWOR)"
  },
  {
   value: "Wognum (NLWGN)",
   label: "Wognum (NLWGN)"
  },
  {
   value: "Wolvega (NLWVG)",
   label: "Wolvega (NLWVG)"
  },
  {
   value: "Wormer (NLWMO)",
   label: "Wormer (NLWMO)"
  },
  {
   value: "Wormerveer (NLWRV)",
   label: "Wormerveer (NLWRV)"
  },
  {
   value: "Woudenberg (NLWDB)",
   label: "Woudenberg (NLWDB)"
  },
  {
   value: "Woudrichem (NLWCM)",
   label: "Woudrichem (NLWCM)"
  },
  {
   value: "Wouw (NLWOU)",
   label: "Wouw (NLWOU)"
  },
  {
   value: "Yerseke (NLYSK)",
   label: "Yerseke (NLYSK)"
  },
  {
   value: "Ypenburg (NLYPG)",
   label: "Ypenburg (NLYPG)"
  },
  {
   value: "Zaandam (NLZAA)",
   label: "Zaandam (NLZAA)"
  },
  {
   value: "Zaandijk (NLZAD)",
   label: "Zaandijk (NLZAD)"
  },
  {
   value: "Zalk (NLZLK)",
   label: "Zalk (NLZLK)"
  },
  {
   value: "Zaltbommel (NLZLB)",
   label: "Zaltbommel (NLZLB)"
  },
  {
   value: "Zandvoort (NLZDV)",
   label: "Zandvoort (NLZDV)"
  },
  {
   value: "Zeddam (NLZDM)",
   label: "Zeddam (NLZDM)"
  },
  {
   value: "Vlissingen (NLVLI)",
   label: "Vlissingen (NLVLI)"
  },
  {
   value: "Vlodrop (NLVLD)",
   label: "Vlodrop (NLVLD)"
  },
  {
   value: "Volendam (NLVOD)",
   label: "Volendam (NLVOD)"
  },
  {
   value: "Voorburg (NLVOB)",
   label: "Voorburg (NLVOB)"
  },
  {
   value: "Voorhout (NLVOH)",
   label: "Voorhout (NLVOH)"
  },
  {
   value: "Voorschoten (NLVOS)",
   label: "Voorschoten (NLVOS)"
  },
  {
   value: "Voorst (NLVRS)",
   label: "Voorst (NLVRS)"
  },
  {
   value: "Voorthuizen (NLVHZ)",
   label: "Voorthuizen (NLVHZ)"
  },
  {
   value: "Vredenduin (NLVDN)",
   label: "Vredenduin (NLVDN)"
  },
  {
   value: "Vreeland (NLVRD)",
   label: "Vreeland (NLVRD)"
  },
  {
   value: "Vriezenveen (NLVRZ)",
   label: "Vriezenveen (NLVRZ)"
  },
  {
   value: "Vroomshoop (NLVRH)",
   label: "Vroomshoop (NLVRH)"
  },
  {
   value: "Vught (NLVGT)",
   label: "Vught (NLVGT)"
  },
  {
   value: "Vuren (NLVRN)",
   label: "Vuren (NLVRN)"
  },
  {
   value: "Waalhaven (NLWAL)",
   label: "Waalhaven (NLWAL)"
  },
  {
   value: "Waalre (NLWAA)",
   label: "Waalre (NLWAA)"
  },
  {
   value: "Waalwijk (NLWLK)",
   label: "Waalwijk (NLWLK)"
  },
  {
   value: "Waardenburg (NLWAB)",
   label: "Waardenburg (NLWAB)"
  },
  {
   value: "Waarland (NLWRL)",
   label: "Waarland (NLWRL)"
  },
  {
   value: "Waddinxveen (NLWAD)",
   label: "Waddinxveen (NLWAD)"
  },
  {
   value: "Wageningen (NLWGW)",
   label: "Wageningen (NLWGW)"
  },
  {
   value: "Wamel (NLWXM)",
   label: "Wamel (NLWXM)"
  },
  {
   value: "Wanroij (NLWAJ)",
   label: "Wanroij (NLWAJ)"
  },
  {
   value: "Wapenveld (NLWAP)",
   label: "Wapenveld (NLWAP)"
  },
  {
   value: "Warder (NLWRD)",
   label: "Warder (NLWRD)"
  },
  {
   value: "Warffum (NLWFM)",
   label: "Warffum (NLWFM)"
  },
  {
   value: "Warmenhuizen (NLWMH)",
   label: "Warmenhuizen (NLWMH)"
  },
  {
   value: "Warmond (NLWRM)",
   label: "Warmond (NLWRM)"
  },
  {
   value: "Warnsveld (NLWAR)",
   label: "Warnsveld (NLWAR)"
  },
  {
   value: "Waspik (NLWPI)",
   label: "Waspik (NLWPI)"
  },
  {
   value: "Wasrik (NLWSR)",
   label: "Wasrik (NLWSR)"
  },
  {
   value: "Wassenaar (NLWSS)",
   label: "Wassenaar (NLWSS)"
  },
  {
   value: "Wateringen (NLWAT)",
   label: "Wateringen (NLWAT)"
  },
  {
   value: "Weert (NLWRT)",
   label: "Weert (NLWRT)"
  },
  {
   value: "Weesp (NLWSP)",
   label: "Weesp (NLWSP)"
  },
  {
   value: "Wehl (NLWHL)",
   label: "Wehl (NLWHL)"
  },
  {
   value: "Weidum (NLWDM)",
   label: "Weidum (NLWDM)"
  },
  {
   value: "Wellerlooi (NLWLL)",
   label: "Wellerlooi (NLWLL)"
  },
  {
   value: "Wemeldinge (NLWED)",
   label: "Wemeldinge (NLWED)"
  },
  {
   value: "Werkendam (NLWKD)",
   label: "Werkendam (NLWKD)"
  },
  {
   value: "Wernhout (NLWHT)",
   label: "Wernhout (NLWHT)"
  },
  {
   value: "Tilburg (NLTLB)",
   label: "Tilburg (NLTLB)"
  },
  {
   value: "Tubbergen (NLTBB)",
   label: "Tubbergen (NLTBB)"
  },
  {
   value: "Tuitjenhorn (NLTUH)",
   label: "Tuitjenhorn (NLTUH)"
  },
  {
   value: "Twello (NLTWE)",
   label: "Twello (NLTWE)"
  },
  {
   value: "Uden (NLUDE)",
   label: "Uden (NLUDE)"
  },
  {
   value: "Udenhout (NLUDH)",
   label: "Udenhout (NLUDH)"
  },
  {
   value: "Uithoorn (NLUIT)",
   label: "Uithoorn (NLUIT)"
  },
  {
   value: "Uithuizen (NLUTZ)",
   label: "Uithuizen (NLUTZ)"
  },
  {
   value: "Ulestraten (NLULS)",
   label: "Ulestraten (NLULS)"
  },
  {
   value: "Ulft (NLULF)",
   label: "Ulft (NLULF)"
  },
  {
   value: "Ulrum (NLULR)",
   label: "Ulrum (NLULR)"
  },
  {
   value: "Urk (NLURK)",
   label: "Urk (NLURK)"
  },
  {
   value: "Ursem (NLURS)",
   label: "Ursem (NLURS)"
  },
  {
   value: "Utrecht (NLUTC)",
   label: "Utrecht (NLUTC)"
  },
  {
   value: "Vaals (NLVLS)",
   label: "Vaals (NLVLS)"
  },
  {
   value: "Vaassen (NLVAA)",
   label: "Vaassen (NLVAA)"
  },
  {
   value: "Valkenburg (NLVLK)",
   label: "Valkenburg (NLVLK)"
  },
  {
   value: "Valkenswaard (NLVAL)",
   label: "Valkenswaard (NLVAL)"
  },
  {
   value: "Van Essen (NLVNE)",
   label: "Van Essen (NLVNE)"
  },
  {
   value: "Varsseveld (NLVSR)",
   label: "Varsseveld (NLVSR)"
  },
  {
   value: "Veendam (NLVDM)",
   label: "Veendam (NLVDM)"
  },
  {
   value: "Veenendaal (NLVEE)",
   label: "Veenendaal (NLVEE)"
  },
  {
   value: "Veghel (NLVEG)",
   label: "Veghel (NLVEG)"
  },
  {
   value: "Veldhoven (NLVDH)",
   label: "Veldhoven (NLVDH)"
  },
  {
   value: "Veldriel (NLVHA)",
   label: "Veldriel (NLVHA)"
  },
  {
   value: "Velp (NLVEP)",
   label: "Velp (NLVEP)"
  },
  {
   value: "Velsen (NLVEL)",
   label: "Velsen (NLVEL)"
  },
  {
   value: "Velserbroek (NLVBK)",
   label: "Velserbroek (NLVBK)"
  },
  {
   value: "Venhuizen (NLVNH)",
   label: "Venhuizen (NLVNH)"
  },
  {
   value: "Venlo (NLVEN)",
   label: "Venlo (NLVEN)"
  },
  {
   value: "Venlo-Autoweg (NLVLO)",
   label: "Venlo-Autoweg (NLVLO)"
  },
  {
   value: "Venray (NLVNR)",
   label: "Venray (NLVNR)"
  },
  {
   value: "Vessem (NLVSM)",
   label: "Vessem (NLVSM)"
  },
  {
   value: "Vianen (NLVAN)",
   label: "Vianen (NLVAN)"
  },
  {
   value: "Vieraakker (NLVKK)",
   label: "Vieraakker (NLVKK)"
  },
  {
   value: "Vierlingsbeek (NLVIE)",
   label: "Vierlingsbeek (NLVIE)"
  },
  {
   value: "Vijfhuizen (NLVIJ)",
   label: "Vijfhuizen (NLVIJ)"
  },
  {
   value: "Vinkeveen (NLVIV)",
   label: "Vinkeveen (NLVIV)"
  },
  {
   value: "Vlaardingen (NLVLA)",
   label: "Vlaardingen (NLVLA)"
  },
  {
   value: "Vleuten (NLVLT)",
   label: "Vleuten (NLVLT)"
  },
  {
   value: "Vlieland (NLVLL)",
   label: "Vlieland (NLVLL)"
  },
  {
   value: "Vlijmen (NLVLM)",
   label: "Vlijmen (NLVLM)"
  },
  {
   value: "Smallingerland (NLSML)",
   label: "Smallingerland (NLSML)"
  },
  {
   value: "Sneek (NLSNK)",
   label: "Sneek (NLSNK)"
  },
  {
   value: "Snelrewaard (NLSNW)",
   label: "Snelrewaard (NLSNW)"
  },
  {
   value: "Soest (NLSOE)",
   label: "Soest (NLSOE)"
  },
  {
   value: "Soesterberg (NLSOS)",
   label: "Soesterberg (NLSOS)"
  },
  {
   value: "Someren (NLSOM)",
   label: "Someren (NLSOM)"
  },
  {
   value: "Son (NLSON)",
   label: "Son (NLSON)"
  },
  {
   value: "Spaarndam (NLSPD)",
   label: "Spaarndam (NLSPD)"
  },
  {
   value: "Spakenburg (NLSPK)",
   label: "Spakenburg (NLSPK)"
  },
  {
   value: "Spanbroek (NLSPB)",
   label: "Spanbroek (NLSPB)"
  },
  {
   value: "Spaubeek (NLSPA)",
   label: "Spaubeek (NLSPA)"
  },
  {
   value: "Spijk (NLSJK)",
   label: "Spijk (NLSJK)"
  },
  {
   value: "Spijkenisse (NLSPI)",
   label: "Spijkenisse (NLSPI)"
  },
  {
   value: "Sprang Capelle (NLSCA)",
   label: "Sprang Capelle (NLSCA)"
  },
  {
   value: "St Cloud (NLSUD)",
   label: "St Cloud (NLSUD)"
  },
  {
   value: "St Maarten (NLSMN)",
   label: "St Maarten (NLSMN)"
  },
  {
   value: "St Oedenrode (NLOED)",
   label: "St Oedenrode (NLOED)"
  },
  {
   value: "St Willebrord (NLSWB)",
   label: "St Willebrord (NLSWB)"
  },
  {
   value: "Stadskanaal (NLSTK)",
   label: "Stadskanaal (NLSTK)"
  },
  {
   value: "Staphorst (NLSTH)",
   label: "Staphorst (NLSTH)"
  },
  {
   value: "Stavoren (NLSTA)",
   label: "Stavoren (NLSTA)"
  },
  {
   value: "Steenbergen (NLSTE)",
   label: "Steenbergen (NLSTE)"
  },
  {
   value: "Steenwijk (NLSTW)",
   label: "Steenwijk (NLSTW)"
  },
  {
   value: "Stein (NLSTI)",
   label: "Stein (NLSTI)"
  },
  {
   value: "Stellendam (NLSTD)",
   label: "Stellendam (NLSTD)"
  },
  {
   value: "Stiens (NLSTN)",
   label: "Stiens (NLSTN)"
  },
  {
   value: "Strijbeek (NLSJB)",
   label: "Strijbeek (NLSJB)"
  },
  {
   value: "Strijen (NLTRJ)",
   label: "Strijen (NLTRJ)"
  },
  {
   value: "Surhuisterveen (NLSUR)",
   label: "Surhuisterveen (NLSUR)"
  },
  {
   value: "Swalmen (NLSWM)",
   label: "Swalmen (NLSWM)"
  },
  {
   value: "t-Goy (NLGOY)",
   label: "t-Goy (NLGOY)"
  },
  {
   value: "t-Zand (NLTZA)",
   label: "t-Zand (NLTZA)"
  },
  {
   value: "Tegelen (NLTEG)",
   label: "Tegelen (NLTEG)"
  },
  {
   value: "Ter Aar (NLTEA)",
   label: "Ter Aar (NLTEA)"
  },
  {
   value: "Ter Apel (NLTPH)",
   label: "Ter Apel (NLTPH)"
  },
  {
   value: "Ter Apelkanaal (NLTAK)",
   label: "Ter Apelkanaal (NLTAK)"
  },
  {
   value: "Terborg (NLTBO)",
   label: "Terborg (NLTBO)"
  },
  {
   value: "Terneuzen (NLTNZ)",
   label: "Terneuzen (NLTNZ)"
  },
  {
   value: "Texel (NLTEX)",
   label: "Texel (NLTEX)"
  },
  {
   value: "Tholen (NLTHO)",
   label: "Tholen (NLTHO)"
  },
  {
   value: "Tiel (NLTIE)",
   label: "Tiel (NLTIE)"
  },
  {
   value: "Rijswijk (NLRYS)",
   label: "Rijswijk (NLRYS)"
  },
  {
   value: "Roden (NLROD)",
   label: "Roden (NLROD)"
  },
  {
   value: "Rodenrijs (NLROR)",
   label: "Rodenrijs (NLROR)"
  },
  {
   value: "Roelofarendsveen (NLRAV)",
   label: "Roelofarendsveen (NLRAV)"
  },
  {
   value: "Roermond (NLOMD)",
   label: "Roermond (NLOMD)"
  },
  {
   value: "Roggel (NLROG)",
   label: "Roggel (NLROG)"
  },
  {
   value: "Roosendaal (NLROO)",
   label: "Roosendaal (NLROO)"
  },
  {
   value: "Rosmalen (NLRMA)",
   label: "Rosmalen (NLRMA)"
  },
  {
   value: "Rotterdam (NLRTM)",
   label: "Rotterdam (NLRTM)"
  },
  {
   value: "Rozenburg (NLROZ)",
   label: "Rozenburg (NLROZ)"
  },
  {
   value: "Rozendaal (NLRZD)",
   label: "Rozendaal (NLRZD)"
  },
  {
   value: "Rucphen (NLRCP)",
   label: "Rucphen (NLRCP)"
  },
  {
   value: "Rumpt (NLRUM)",
   label: "Rumpt (NLRUM)"
  },
  {
   value: "s-Gravendeel (NLGRA)",
   label: "s-Gravendeel (NLGRA)"
  },
  {
   value: "s-Gravenmoer (NLSGM)",
   label: "s-Gravenmoer (NLSGM)"
  },
  {
   value: "s-Gravenpolder (NLSGP)",
   label: "s-Gravenpolder (NLSGP)"
  },
  {
   value: "s-Gravenzande (NLGRZ)",
   label: "s-Gravenzande (NLGRZ)"
  },
  {
   value: "S-Heerenberg (NLHRB)",
   label: "S-Heerenberg (NLHRB)"
  },
  {
   value: "s-Heerenbroek (NLSHB)",
   label: "s-Heerenbroek (NLSHB)"
  },
  {
   value: "s-Heerenhoek (NLSHE)",
   label: "s-Heerenhoek (NLSHE)"
  },
  {
   value: "s-Hertogenbosch (NLHTB)",
   label: "s-Hertogenbosch (NLHTB)"
  },
  {
   value: "Sappemeer (NLSAP)",
   label: "Sappemeer (NLSAP)"
  },
  {
   value: "Sas Van Gent (NLSVG)",
   label: "Sas Van Gent (NLSVG)"
  },
  {
   value: "Sassenheim (NLSAS)",
   label: "Sassenheim (NLSAS)"
  },
  {
   value: "Scheemda (NLSMD)",
   label: "Scheemda (NLSMD)"
  },
  {
   value: "Scherpenzeel (NLSRP)",
   label: "Scherpenzeel (NLSRP)"
  },
  {
   value: "Scheveningen (NLSCE)",
   label: "Scheveningen (NLSCE)"
  },
  {
   value: "Schiedam (NLSCI)",
   label: "Schiedam (NLSCI)"
  },
  {
   value: "Schijndel (NLSND)",
   label: "Schijndel (NLSND)"
  },
  {
   value: "Schin Op Geul (NLSOG)",
   label: "Schin Op Geul (NLSOG)"
  },
  {
   value: "Schinnen (NLSCN)",
   label: "Schinnen (NLSCN)"
  },
  {
   value: "Schiphol (NLSPL)",
   label: "Schiphol (NLSPL)"
  },
  {
   value: "Schoonebeek (NLSCB)",
   label: "Schoonebeek (NLSCB)"
  },
  {
   value: "Schoonhoven (NLSHH)",
   label: "Schoonhoven (NLSHH)"
  },
  {
   value: "Silvolde (NLSIV)",
   label: "Silvolde (NLSIV)"
  },
  {
   value: "Sittard (NLSIT)",
   label: "Sittard (NLSIT)"
  },
  {
   value: "Sliedrecht (NLSLD)",
   label: "Sliedrecht (NLSLD)"
  },
  {
   value: "Slikkerveer (NLSLI)",
   label: "Slikkerveer (NLSLI)"
  },
  {
   value: "Sluis (NLSLS)",
   label: "Sluis (NLSLS)"
  },
  {
   value: "Sluiskil (NLSLU)",
   label: "Sluiskil (NLSLU)"
  },
  {
   value: "Ospel (NLOSP)",
   label: "Ospel (NLOSP)"
  },
  {
   value: "Oss (NLOSS)",
   label: "Oss (NLOSS)"
  },
  {
   value: "Oud Gastel (NLOUG)",
   label: "Oud Gastel (NLOUG)"
  },
  {
   value: "Oud Vroenhoven (NLOVR)",
   label: "Oud Vroenhoven (NLOVR)"
  },
  {
   value: "Oud-Beijerland (NLOBL)",
   label: "Oud-Beijerland (NLOBL)"
  },
  {
   value: "Oud-Vossemeer (NLOVM)",
   label: "Oud-Vossemeer (NLOVM)"
  },
  {
   value: "Oude Pekela (NLODP)",
   label: "Oude Pekela (NLODP)"
  },
  {
   value: "Oude-Tonge (NLODT)",
   label: "Oude-Tonge (NLODT)"
  },
  {
   value: "Oudenbosch (NLOBO)",
   label: "Oudenbosch (NLOBO)"
  },
  {
   value: "Oudenhoorn (NLODH)",
   label: "Oudenhoorn (NLODH)"
  },
  {
   value: "Ouderkerk Aan Den Ijssel (NLOAI)",
   label: "Ouderkerk Aan Den Ijssel (NLOAI)"
  },
  {
   value: "Oudewater (NLODW)",
   label: "Oudewater (NLODW)"
  },
  {
   value: "Ovezande (NLOVZ)",
   label: "Ovezande (NLOVZ)"
  },
  {
   value: "Panningen (NLPAN)",
   label: "Panningen (NLPAN)"
  },
  {
   value: "Papendrecht (NLPAP)",
   label: "Papendrecht (NLPAP)"
  },
  {
   value: "Pernis (NLPER)",
   label: "Pernis (NLPER)"
  },
  {
   value: "Petten (NLPTT)",
   label: "Petten (NLPTT)"
  },
  {
   value: "Pijnacker (NLPIJ)",
   label: "Pijnacker (NLPIJ)"
  },
  {
   value: "Poeldijk (NLPDK)",
   label: "Poeldijk (NLPDK)"
  },
  {
   value: "Poortvliet (NLPVT)",
   label: "Poortvliet (NLPVT)"
  },
  {
   value: "Prinsenbeek (NLPRB)",
   label: "Prinsenbeek (NLPRB)"
  },
  {
   value: "Purmerend (NLPUM)",
   label: "Purmerend (NLPUM)"
  },
  {
   value: "Putte (NLPUT)",
   label: "Putte (NLPUT)"
  },
  {
   value: "Raalte (NLQDS)",
   label: "Raalte (NLQDS)"
  },
  {
   value: "Raamsdonksveer (NLRAA)",
   label: "Raamsdonksveer (NLRAA)"
  },
  {
   value: "Ravenstein (NLRAS)",
   label: "Ravenstein (NLRAS)"
  },
  {
   value: "Reeuwijk (NLRUW)",
   label: "Reeuwijk (NLRUW)"
  },
  {
   value: "Reimerswaal (NLREW)",
   label: "Reimerswaal (NLREW)"
  },
  {
   value: "Renkum (NLRNK)",
   label: "Renkum (NLRNK)"
  },
  {
   value: "Reusel (NLRSL)",
   label: "Reusel (NLRSL)"
  },
  {
   value: "Reuver (NLREU)",
   label: "Reuver (NLREU)"
  },
  {
   value: "Rheden (NLRHD)",
   label: "Rheden (NLRHD)"
  },
  {
   value: "Rhenen (NLRHE)",
   label: "Rhenen (NLRHE)"
  },
  {
   value: "Rhoon (NLRHO)",
   label: "Rhoon (NLRHO)"
  },
  {
   value: "Ridderkerk (NLRID)",
   label: "Ridderkerk (NLRID)"
  },
  {
   value: "Riel (NLRIE)",
   label: "Riel (NLRIE)"
  },
  {
   value: "Rijen (NLRJE)",
   label: "Rijen (NLRJE)"
  },
  {
   value: "Rijkevoort (NLRJV)",
   label: "Rijkevoort (NLRJV)"
  },
  {
   value: "Rijnsburg (NLRBG)",
   label: "Rijnsburg (NLRBG)"
  },
  {
   value: "Rijsbergen (NLRYB)",
   label: "Rijsbergen (NLRYB)"
  },
  {
   value: "Rijssen (NLRJS)",
   label: "Rijssen (NLRJS)"
  },
  {
   value: "Nieuwenhagen (NLNIH)",
   label: "Nieuwenhagen (NLNIH)"
  },
  {
   value: "Nieuwerkerk a\/d Ijssel (NLNIE)",
   label: "Nieuwerkerk a\/d Ijssel (NLNIE)"
  },
  {
   value: "Nieuwkoop (NLNWK)",
   label: "Nieuwkoop (NLNWK)"
  },
  {
   value: "Nieuwpoort (NLNWP)",
   label: "Nieuwpoort (NLNWP)"
  },
  {
   value: "Nieuwstadt (NLNWS)",
   label: "Nieuwstadt (NLNWS)"
  },
  {
   value: "Nieuwveen (NLNWV)",
   label: "Nieuwveen (NLNWV)"
  },
  {
   value: "Niewediep (NLNDI)",
   label: "Niewediep (NLNDI)"
  },
  {
   value: "Nijkerk (NLNKK)",
   label: "Nijkerk (NLNKK)"
  },
  {
   value: "Nijkerkerveen (NLNKV)",
   label: "Nijkerkerveen (NLNKV)"
  },
  {
   value: "Nijmegen (NLNIJ)",
   label: "Nijmegen (NLNIJ)"
  },
  {
   value: "Nijverdal (NLNVD)",
   label: "Nijverdal (NLNVD)"
  },
  {
   value: "Nispen (NLNIS)",
   label: "Nispen (NLNIS)"
  },
  {
   value: "Nisse (NLNSS)",
   label: "Nisse (NLNSS)"
  },
  {
   value: "Noord-Scharwoude (NLNSW)",
   label: "Noord-Scharwoude (NLNSW)"
  },
  {
   value: "Noordwijk-aan-Zee (NLNDL)",
   label: "Noordwijk-aan-Zee (NLNDL)"
  },
  {
   value: "Noordwijkerhout (NLNOJ)",
   label: "Noordwijkerhout (NLNOJ)"
  },
  {
   value: "Nootdorp (NLNDP)",
   label: "Nootdorp (NLNDP)"
  },
  {
   value: "Nuenen (NLNNN)",
   label: "Nuenen (NLNNN)"
  },
  {
   value: "Nuis (NLNUI)",
   label: "Nuis (NLNUI)"
  },
  {
   value: "Numansdorp (NLNUD)",
   label: "Numansdorp (NLNUD)"
  },
  {
   value: "Nunspeet (NLNUN)",
   label: "Nunspeet (NLNUN)"
  },
  {
   value: "Nuth (NLNTH)",
   label: "Nuth (NLNTH)"
  },
  {
   value: "Obdam (NLOBD)",
   label: "Obdam (NLOBD)"
  },
  {
   value: "Ochten (NLOCC)",
   label: "Ochten (NLOCC)"
  },
  {
   value: "Odijk (NLODK)",
   label: "Odijk (NLODK)"
  },
  {
   value: "Oegstgeest (NLOGE)",
   label: "Oegstgeest (NLOGE)"
  },
  {
   value: "Oirschot (NLOIH)",
   label: "Oirschot (NLOIH)"
  },
  {
   value: "Oisterwijk (NLOIW)",
   label: "Oisterwijk (NLOIW)"
  },
  {
   value: "Oldeberkoop (NLOLD)",
   label: "Oldeberkoop (NLOLD)"
  },
  {
   value: "Oldemarkt (NLOLK)",
   label: "Oldemarkt (NLOLK)"
  },
  {
   value: "Oldenzaal (NLOLZ)",
   label: "Oldenzaal (NLOLZ)"
  },
  {
   value: "Ommen (NLOMM)",
   label: "Ommen (NLOMM)"
  },
  {
   value: "Ooij (NLOOY)",
   label: "Ooij (NLOOY)"
  },
  {
   value: "Oostdijk (NLOSD)",
   label: "Oostdijk (NLOSD)"
  },
  {
   value: "Oosterbeek (NLOSB)",
   label: "Oosterbeek (NLOSB)"
  },
  {
   value: "Oosterhout (NLOOS)",
   label: "Oosterhout (NLOOS)"
  },
  {
   value: "Oosterschelde (NLOSE)",
   label: "Oosterschelde (NLOSE)"
  },
  {
   value: "Oostrum (NLOST)",
   label: "Oostrum (NLOST)"
  },
  {
   value: "Oostvoorne (NLOVN)",
   label: "Oostvoorne (NLOVN)"
  },
  {
   value: "Ootmarsum (NLOOT)",
   label: "Ootmarsum (NLOOT)"
  },
  {
   value: "Maldegem (NLMLD)",
   label: "Maldegem (NLMLD)"
  },
  {
   value: "Malden (NLMAD)",
   label: "Malden (NLMAD)"
  },
  {
   value: "Markelo (NLMAR)",
   label: "Markelo (NLMAR)"
  },
  {
   value: "Marknesse (NLMAN)",
   label: "Marknesse (NLMAN)"
  },
  {
   value: "Maurik (NLMAU)",
   label: "Maurik (NLMAU)"
  },
  {
   value: "Medemblik (NLMDM)",
   label: "Medemblik (NLMDM)"
  },
  {
   value: "Meer (NLMEE)",
   label: "Meer (NLMEE)"
  },
  {
   value: "Meerlo-Wansum (NLMEW)",
   label: "Meerlo-Wansum (NLMEW)"
  },
  {
   value: "Meers (NLMES)",
   label: "Meers (NLMES)"
  },
  {
   value: "Melick (NLMCK)",
   label: "Melick (NLMCK)"
  },
  {
   value: "Meppel (NLMEP)",
   label: "Meppel (NLMEP)"
  },
  {
   value: "Merkelbeek (NLMEB)",
   label: "Merkelbeek (NLMEB)"
  },
  {
   value: "Middelbeers (NLMDB)",
   label: "Middelbeers (NLMDB)"
  },
  {
   value: "Middelburg (NLMID)",
   label: "Middelburg (NLMID)"
  },
  {
   value: "Middelharnis (NLMIH)",
   label: "Middelharnis (NLMIH)"
  },
  {
   value: "Middelie (NLMVE)",
   label: "Middelie (NLMVE)"
  },
  {
   value: "Mierlo (NLMIE)",
   label: "Mierlo (NLMIE)"
  },
  {
   value: "Mijdrecht (NLMIJ)",
   label: "Mijdrecht (NLMIJ)"
  },
  {
   value: "Mill (NLMLL)",
   label: "Mill (NLMLL)"
  },
  {
   value: "Moerdijk (NLMOE)",
   label: "Moerdijk (NLMOE)"
  },
  {
   value: "Moerkapelle (NLMKP)",
   label: "Moerkapelle (NLMKP)"
  },
  {
   value: "Molenaarsgraaf (NLMOG)",
   label: "Molenaarsgraaf (NLMOG)"
  },
  {
   value: "Monnickendam (NLMNN)",
   label: "Monnickendam (NLMNN)"
  },
  {
   value: "Monster (NLMON)",
   label: "Monster (NLMON)"
  },
  {
   value: "Montfoort (NLMNT)",
   label: "Montfoort (NLMNT)"
  },
  {
   value: "Moordrecht (NLMOO)",
   label: "Moordrecht (NLMOO)"
  },
  {
   value: "Naaldwijk (NLNAW)",
   label: "Naaldwijk (NLNAW)"
  },
  {
   value: "Naarden (NLNAA)",
   label: "Naarden (NLNAA)"
  },
  {
   value: "Nagele (NLNLG)",
   label: "Nagele (NLNLG)"
  },
  {
   value: "Nederhorst Den Berg (NLNDB)",
   label: "Nederhorst Den Berg (NLNDB)"
  },
  {
   value: "Nederweert (NLNRW)",
   label: "Nederweert (NLNRW)"
  },
  {
   value: "Neer (NLNER)",
   label: "Neer (NLNER)"
  },
  {
   value: "Nieuw Lekkerland (NLNLK)",
   label: "Nieuw Lekkerland (NLNLK)"
  },
  {
   value: "Nieuw Vennep (NLNVE)",
   label: "Nieuw Vennep (NLNVE)"
  },
  {
   value: "Nieuw-Loosdrecht (NLLSR)",
   label: "Nieuw-Loosdrecht (NLLSR)"
  },
  {
   value: "Nieuw-Vennep (NLNVP)",
   label: "Nieuw-Vennep (NLNVP)"
  },
  {
   value: "Nieuwe Schans (NLNSC)",
   label: "Nieuwe Schans (NLNSC)"
  },
  {
   value: "Nieuwe Schans-Bunderneuland (NLNSB)",
   label: "Nieuwe Schans-Bunderneuland (NLNSB)"
  },
  {
   value: "Nieuwe Tonge (NLNWT)",
   label: "Nieuwe Tonge (NLNWT)"
  },
  {
   value: "Nieuwegein (NLNWG)",
   label: "Nieuwegein (NLNWG)"
  },
  {
   value: "Lauwersoog (NLLAN)",
   label: "Lauwersoog (NLLAN)"
  },
  {
   value: "Leek (NLLEE)",
   label: "Leek (NLLEE)"
  },
  {
   value: "Leerdam (NLLRD)",
   label: "Leerdam (NLLRD)"
  },
  {
   value: "Leeuwarden (NLLWR)",
   label: "Leeuwarden (NLLWR)"
  },
  {
   value: "Leiden (NLLID)",
   label: "Leiden (NLLID)"
  },
  {
   value: "Leiderdorp (NLLDD)",
   label: "Leiderdorp (NLLDD)"
  },
  {
   value: "Leidschendam (NLLDS)",
   label: "Leidschendam (NLLDS)"
  },
  {
   value: "Leimuiden (NLLMU)",
   label: "Leimuiden (NLLMU)"
  },
  {
   value: "Lekkerkerk (NLLEK)",
   label: "Lekkerkerk (NLLEK)"
  },
  {
   value: "Lelystad (NLLEY)",
   label: "Lelystad (NLLEY)"
  },
  {
   value: "Lemmer (NLLMR)",
   label: "Lemmer (NLLMR)"
  },
  {
   value: "Lemsterland (NLLEM)",
   label: "Lemsterland (NLLEM)"
  },
  {
   value: "Lent (NLLNT)",
   label: "Lent (NLLNT)"
  },
  {
   value: "Leusden (NLLEU)",
   label: "Leusden (NLLEU)"
  },
  {
   value: "Leuth (NLLTH)",
   label: "Leuth (NLLTH)"
  },
  {
   value: "Lexmond (NLLXM)",
   label: "Lexmond (NLLXM)"
  },
  {
   value: "Lichtenvoorde (NLLCV)",
   label: "Lichtenvoorde (NLLCV)"
  },
  {
   value: "Lienden (NLLIE)",
   label: "Lienden (NLLIE)"
  },
  {
   value: "Limmen (NLLMM)",
   label: "Limmen (NLLMM)"
  },
  {
   value: "Linschoten (NLLSC)",
   label: "Linschoten (NLLSC)"
  },
  {
   value: "Lisse (NLQDG)",
   label: "Lisse (NLQDG)"
  },
  {
   value: "Lith (NLLIT)",
   label: "Lith (NLLIT)"
  },
  {
   value: "Lobith (NLLOB)",
   label: "Lobith (NLLOB)"
  },
  {
   value: "Lochem (NLLCH)",
   label: "Lochem (NLLCH)"
  },
  {
   value: "Loenen (NLLON)",
   label: "Loenen (NLLON)"
  },
  {
   value: "Loenen aan de Vecht (NLLAV)",
   label: "Loenen aan de Vecht (NLLAV)"
  },
  {
   value: "Lomm (NLLOM)",
   label: "Lomm (NLLOM)"
  },
  {
   value: "Lopik (NLLPK)",
   label: "Lopik (NLLPK)"
  },
  {
   value: "Losser (NLLOS)",
   label: "Losser (NLLOS)"
  },
  {
   value: "Maarheeze (NLMHZ)",
   label: "Maarheeze (NLMHZ)"
  },
  {
   value: "Maarsbergen (NLMAB)",
   label: "Maarsbergen (NLMAB)"
  },
  {
   value: "Maarssen (NLMSS)",
   label: "Maarssen (NLMSS)"
  },
  {
   value: "Maarssenbroek (NLMRS)",
   label: "Maarssenbroek (NLMRS)"
  },
  {
   value: "Maartensdijk (NLMRT)",
   label: "Maartensdijk (NLMRT)"
  },
  {
   value: "Maasbracht (NLMSB)",
   label: "Maasbracht (NLMSB)"
  },
  {
   value: "Maasdam (NLMSD)",
   label: "Maasdam (NLMSD)"
  },
  {
   value: "Maasland (NLMAL)",
   label: "Maasland (NLMAL)"
  },
  {
   value: "Maassluis (NLMSL)",
   label: "Maassluis (NLMSL)"
  },
  {
   value: "Maastricht (NLMST)",
   label: "Maastricht (NLMST)"
  },
  {
   value: "Maasvlakte (NLMSV)",
   label: "Maasvlakte (NLMSV)"
  },
  {
   value: "Made (NLQDJ)",
   label: "Made (NLQDJ)"
  },
  {
   value: "Houten (NLHOU)",
   label: "Houten (NLHOU)"
  },
  {
   value: "Huis ter Heide (NLHTH)",
   label: "Huis ter Heide (NLHTH)"
  },
  {
   value: "Huizen (NLHUI)",
   label: "Huizen (NLHUI)"
  },
  {
   value: "Hulst (NLHUL)",
   label: "Hulst (NLHUL)"
  },
  {
   value: "IJmuiden (NLIJM)",
   label: "IJmuiden (NLIJM)"
  },
  {
   value: "Ijsselstein (NLIJI)",
   label: "Ijsselstein (NLIJI)"
  },
  {
   value: "Ilpendam (NLILP)",
   label: "Ilpendam (NLILP)"
  },
  {
   value: "Ittervoort (NLITT)",
   label: "Ittervoort (NLITT)"
  },
  {
   value: "Joure (NLJOU)",
   label: "Joure (NLJOU)"
  },
  {
   value: "Julianadorp (NLJLD)",
   label: "Julianadorp (NLJLD)"
  },
  {
   value: "Kaag (NLKAG)",
   label: "Kaag (NLKAG)"
  },
  {
   value: "Kaatsheuvel (NLKTS)",
   label: "Kaatsheuvel (NLKTS)"
  },
  {
   value: "Kamerik (NLKMR)",
   label: "Kamerik (NLKMR)"
  },
  {
   value: "Kampen (NLKAM)",
   label: "Kampen (NLKAM)"
  },
  {
   value: "Kapellebrug (NLKAP)",
   label: "Kapellebrug (NLKAP)"
  },
  {
   value: "Katwijk Aan Zee (NLKAZ)",
   label: "Katwijk Aan Zee (NLKAZ)"
  },
  {
   value: "Keijenborg (NLKEB)",
   label: "Keijenborg (NLKEB)"
  },
  {
   value: "Kerkrade (NLKER)",
   label: "Kerkrade (NLKER)"
  },
  {
   value: "Kessel (NLKSL)",
   label: "Kessel (NLKSL)"
  },
  {
   value: "Kesteren (NLKST)",
   label: "Kesteren (NLKST)"
  },
  {
   value: "Kinderdijk (NLKIJ)",
   label: "Kinderdijk (NLKIJ)"
  },
  {
   value: "Klaaswaal (NLKLW)",
   label: "Klaaswaal (NLKLW)"
  },
  {
   value: "Klazienaveen (NLKLZ)",
   label: "Klazienaveen (NLKLZ)"
  },
  {
   value: "Kloosterzande (NLKLT)",
   label: "Kloosterzande (NLKLT)"
  },
  {
   value: "Koewacht (NLKWT)",
   label: "Koewacht (NLKWT)"
  },
  {
   value: "Koog Aan De Zaan (NLKGZ)",
   label: "Koog Aan De Zaan (NLKGZ)"
  },
  {
   value: "Kortenhoef (NLKTH)",
   label: "Kortenhoef (NLKTH)"
  },
  {
   value: "Kortgene (NLKOG)",
   label: "Kortgene (NLKOG)"
  },
  {
   value: "Koudekerke (NLKOK)",
   label: "Koudekerke (NLKOK)"
  },
  {
   value: "Krimpen Aan De Lek (NLKRP)",
   label: "Krimpen Aan De Lek (NLKRP)"
  },
  {
   value: "Krommenie (NLKRM)",
   label: "Krommenie (NLKRM)"
  },
  {
   value: "Kruiningen (NLKRU)",
   label: "Kruiningen (NLKRU)"
  },
  {
   value: "Kwadendamme (NLKWA)",
   label: "Kwadendamme (NLKWA)"
  },
  {
   value: "Kwintsheul (NLKWS)",
   label: "Kwintsheul (NLKWS)"
  },
  {
   value: "Lage Weide (NLLAW)",
   label: "Lage Weide (NLLAW)"
  },
  {
   value: "Landgraaf (NLLAF)",
   label: "Landgraaf (NLLAF)"
  },
  {
   value: "Landsmeer (NLLAM)",
   label: "Landsmeer (NLLAM)"
  },
  {
   value: "Langerak (NLLAG)",
   label: "Langerak (NLLAG)"
  },
  {
   value: "Langezwaag (NLLZG)",
   label: "Langezwaag (NLLZG)"
  },
  {
   value: "Laren (NLLAR)",
   label: "Laren (NLLAR)"
  },
  {
   value: "Heiloo (NLHLO)",
   label: "Heiloo (NLHLO)"
  },
  {
   value: "Heinen (NLHNN)",
   label: "Heinen (NLHNN)"
  },
  {
   value: "Heinenoord (NLHOD)",
   label: "Heinenoord (NLHOD)"
  },
  {
   value: "Heinkenszand (NLHZA)",
   label: "Heinkenszand (NLHZA)"
  },
  {
   value: "Heino (NLHNO)",
   label: "Heino (NLHNO)"
  },
  {
   value: "Helden (NLHEL)",
   label: "Helden (NLHEL)"
  },
  {
   value: "Hellevoetsluis (NLHSL)",
   label: "Hellevoetsluis (NLHSL)"
  },
  {
   value: "Helmond (NLHLM)",
   label: "Helmond (NLHLM)"
  },
  {
   value: "Helvoirt (NLHVO)",
   label: "Helvoirt (NLHVO)"
  },
  {
   value: "Hendrik-Ido-Ambacht (NLHIA)",
   label: "Hendrik-Ido-Ambacht (NLHIA)"
  },
  {
   value: "Hengelo (NLHGL)",
   label: "Hengelo (NLHGL)"
  },
  {
   value: "Herkenbosch (NLHRK)",
   label: "Herkenbosch (NLHRK)"
  },
  {
   value: "Herkingen (NLHKI)",
   label: "Herkingen (NLHKI)"
  },
  {
   value: "Herveld (NLHVD)",
   label: "Herveld (NLHVD)"
  },
  {
   value: "Heteren (NLHTR)",
   label: "Heteren (NLHTR)"
  },
  {
   value: "Heurne (NLHEU)",
   label: "Heurne (NLHEU)"
  },
  {
   value: "Heythuysen (NLHYY)",
   label: "Heythuysen (NLHYY)"
  },
  {
   value: "Hillegom (NLHIL)",
   label: "Hillegom (NLHIL)"
  },
  {
   value: "Hilversum (NLHVS)",
   label: "Hilversum (NLHVS)"
  },
  {
   value: "Hoek van Holland (NLHVH)",
   label: "Hoek van Holland (NLHVH)"
  },
  {
   value: "Hoensbroek (NLHBR)",
   label: "Hoensbroek (NLHBR)"
  },
  {
   value: "Hoevelaken (NLHOE)",
   label: "Hoevelaken (NLHOE)"
  },
  {
   value: "Hoeven (NLHON)",
   label: "Hoeven (NLHON)"
  },
  {
   value: "Holten (NLHLT)",
   label: "Holten (NLHLT)"
  },
  {
   value: "Honselersdijk (NLHNS)",
   label: "Honselersdijk (NLHNS)"
  },
  {
   value: "Hontenisse (NLHTN)",
   label: "Hontenisse (NLHTN)"
  },
  {
   value: "Hoofddorp (NLHFD)",
   label: "Hoofddorp (NLHFD)"
  },
  {
   value: "Hooge Zwaluwe (NLHOZ)",
   label: "Hooge Zwaluwe (NLHOZ)"
  },
  {
   value: "Hoogerheide (NLHOH)",
   label: "Hoogerheide (NLHOH)"
  },
  {
   value: "Hoogeveen (NLHOV)",
   label: "Hoogeveen (NLHOV)"
  },
  {
   value: "Hoogezand (NLHZD)",
   label: "Hoogezand (NLHZD)"
  },
  {
   value: "Hoogezand-Sappemeer (NLHGZ)",
   label: "Hoogezand-Sappemeer (NLHGZ)"
  },
  {
   value: "Hoogkarspel (NLHKP)",
   label: "Hoogkarspel (NLHKP)"
  },
  {
   value: "Hoogland (NLHOL)",
   label: "Hoogland (NLHOL)"
  },
  {
   value: "Hooglanderveen (NLHOG)",
   label: "Hooglanderveen (NLHOG)"
  },
  {
   value: "Hoogvliet (NLHGV)",
   label: "Hoogvliet (NLHGV)"
  },
  {
   value: "Hoorn (NLHRN)",
   label: "Hoorn (NLHRN)"
  },
  {
   value: "Hoornaar (NLHNA)",
   label: "Hoornaar (NLHNA)"
  },
  {
   value: "Hordijkerveld (NLHOR)",
   label: "Hordijkerveld (NLHOR)"
  },
  {
   value: "Horst (NLHRS)",
   label: "Horst (NLHRS)"
  },
  {
   value: "Gouderak (NLGDK)",
   label: "Gouderak (NLGDK)"
  },
  {
   value: "Goudswaard (NLGOW)",
   label: "Goudswaard (NLGOW)"
  },
  {
   value: "Grevenbicht (NLGBC)",
   label: "Grevenbicht (NLGBC)"
  },
  {
   value: "Groenendijk (NLGRK)",
   label: "Groenendijk (NLGRK)"
  },
  {
   value: "Groenlo (NLGRN)",
   label: "Groenlo (NLGRN)"
  },
  {
   value: "Groessen (NLGRS)",
   label: "Groessen (NLGRS)"
  },
  {
   value: "Groningen (NLGRQ)",
   label: "Groningen (NLGRQ)"
  },
  {
   value: "Groot-Ammers (NLGRO)",
   label: "Groot-Ammers (NLGRO)"
  },
  {
   value: "Grubbenvorst (NLGBV)",
   label: "Grubbenvorst (NLGBV)"
  },
  {
   value: "Haaksbergen (NLHKH)",
   label: "Haaksbergen (NLHKH)"
  },
  {
   value: "Haarlem (NLHAA)",
   label: "Haarlem (NLHAA)"
  },
  {
   value: "Haastrecht (NLHCH)",
   label: "Haastrecht (NLHCH)"
  },
  {
   value: "Haelen (NLHAE)",
   label: "Haelen (NLHAE)"
  },
  {
   value: "Halfweg (NLHFW)",
   label: "Halfweg (NLHFW)"
  },
  {
   value: "Hallum (NLHLL)",
   label: "Hallum (NLHLL)"
  },
  {
   value: "Halsteren (NLHAL)",
   label: "Halsteren (NLHAL)"
  },
  {
   value: "Hank (NLHNK)",
   label: "Hank (NLHNK)"
  },
  {
   value: "Hansweert (NLHAN)",
   label: "Hansweert (NLHAN)"
  },
  {
   value: "Hapert (NLHAP)",
   label: "Hapert (NLHAP)"
  },
  {
   value: "Hardenberg (NLHBG)",
   label: "Hardenberg (NLHBG)"
  },
  {
   value: "Harderwijk (NLHRD)",
   label: "Harderwijk (NLHRD)"
  },
  {
   value: "Hardinxveld-Giessendam (NLHRX)",
   label: "Hardinxveld-Giessendam (NLHRX)"
  },
  {
   value: "Harlingen (NLHAR)",
   label: "Harlingen (NLHAR)"
  },
  {
   value: "Harmelen (NLHAM)",
   label: "Harmelen (NLHAM)"
  },
  {
   value: "Hasselt (NLHAS)",
   label: "Hasselt (NLHAS)"
  },
  {
   value: "Hattemerbroek (NLHTK)",
   label: "Hattemerbroek (NLHTK)"
  },
  {
   value: "Haulerwijk (NLHAU)",
   label: "Haulerwijk (NLHAU)"
  },
  {
   value: "Hazerswoude (NLHAZ)",
   label: "Hazerswoude (NLHAZ)"
  },
  {
   value: "Hedel (NLHDL)",
   label: "Hedel (NLHDL)"
  },
  {
   value: "Heel (NLHEE)",
   label: "Heel (NLHEE)"
  },
  {
   value: "Heemskerk (NLHKE)",
   label: "Heemskerk (NLHKE)"
  },
  {
   value: "Heemstede (NLHMS)",
   label: "Heemstede (NLHMS)"
  },
  {
   value: "Heerenveen (NLHRV)",
   label: "Heerenveen (NLHRV)"
  },
  {
   value: "Heerewaarden (NLHRW)",
   label: "Heerewaarden (NLHRW)"
  },
  {
   value: "Heerhugowaard (NLHHW)",
   label: "Heerhugowaard (NLHHW)"
  },
  {
   value: "Heerjansdam (NLHKF)",
   label: "Heerjansdam (NLHKF)"
  },
  {
   value: "Heerlen-Autoweg (NLHRL)",
   label: "Heerlen-Autoweg (NLHRL)"
  },
  {
   value: "Heesch (NLHEC)",
   label: "Heesch (NLHEC)"
  },
  {
   value: "Heeze (NLHZE)",
   label: "Heeze (NLHZE)"
  },
  {
   value: "Heijen (NLHEJ)",
   label: "Heijen (NLHEJ)"
  },
  {
   value: "Enschede (NLENS)",
   label: "Enschede (NLENS)"
  },
  {
   value: "Enspijk (NLENP)",
   label: "Enspijk (NLENP)"
  },
  {
   value: "Epe (NLEPE)",
   label: "Epe (NLEPE)"
  },
  {
   value: "Epen (NLEPN)",
   label: "Epen (NLEPN)"
  },
  {
   value: "Eric (NLERI)",
   label: "Eric (NLERI)"
  },
  {
   value: "Ermelo (NLERM)",
   label: "Ermelo (NLERM)"
  },
  {
   value: "Erp (NLERP)",
   label: "Erp (NLERP)"
  },
  {
   value: "Espel (NLESP)",
   label: "Espel (NLESP)"
  },
  {
   value: "Etten Leur (NLETT)",
   label: "Etten Leur (NLETT)"
  },
  {
   value: "Farmsum (NLFAR)",
   label: "Farmsum (NLFAR)"
  },
  {
   value: "Feerwerd (NLFEE)",
   label: "Feerwerd (NLFEE)"
  },
  {
   value: "Fijnaart (NLFFJ)",
   label: "Fijnaart (NLFFJ)"
  },
  {
   value: "Foxhol (NLFOX)",
   label: "Foxhol (NLFOX)"
  },
  {
   value: "Franeker (NLFRK)",
   label: "Franeker (NLFRK)"
  },
  {
   value: "Gameren (NLGAM)",
   label: "Gameren (NLGAM)"
  },
  {
   value: "Garderen (NLGAR)",
   label: "Garderen (NLGAR)"
  },
  {
   value: "Gassel (NLGAS)",
   label: "Gassel (NLGAS)"
  },
  {
   value: "Gasteren (NLGST)",
   label: "Gasteren (NLGST)"
  },
  {
   value: "Geertruidenberg (NLGTB)",
   label: "Geertruidenberg (NLGTB)"
  },
  {
   value: "Geervliet (NLGRV)",
   label: "Geervliet (NLGRV)"
  },
  {
   value: "Geesburg (NLGSB)",
   label: "Geesburg (NLGSB)"
  },
  {
   value: "Geldermalsen (NLGDM)",
   label: "Geldermalsen (NLGDM)"
  },
  {
   value: "Geldrop (NLGLD)",
   label: "Geldrop (NLGLD)"
  },
  {
   value: "Geleen (NLGEE)",
   label: "Geleen (NLGEE)"
  },
  {
   value: "Gellicum (NLGEC)",
   label: "Gellicum (NLGEC)"
  },
  {
   value: "Gemert (NLGEM)",
   label: "Gemert (NLGEM)"
  },
  {
   value: "Genderen (NLGND)",
   label: "Genderen (NLGND)"
  },
  {
   value: "Gendringen (NLGGN)",
   label: "Gendringen (NLGGN)"
  },
  {
   value: "Genemuiden (NLGNM)",
   label: "Genemuiden (NLGNM)"
  },
  {
   value: "Gennep (NLGEN)",
   label: "Gennep (NLGEN)"
  },
  {
   value: "Giesbeek (NLGIB)",
   label: "Giesbeek (NLGIB)"
  },
  {
   value: "Giessen (NLGIS)",
   label: "Giessen (NLGIS)"
  },
  {
   value: "Giessendam (NLGSM)",
   label: "Giessendam (NLGSM)"
  },
  {
   value: "Gilze (NLGZE)",
   label: "Gilze (NLGZE)"
  },
  {
   value: "Gilzerijen (NLGZR)",
   label: "Gilzerijen (NLGZR)"
  },
  {
   value: "Glanerbrug (NLGLA)",
   label: "Glanerbrug (NLGLA)"
  },
  {
   value: "Goedereede (NLGDR)",
   label: "Goedereede (NLGDR)"
  },
  {
   value: "Goes (NLGOE)",
   label: "Goes (NLGOE)"
  },
  {
   value: "Goirle (NLGOI)",
   label: "Goirle (NLGOI)"
  },
  {
   value: "Goor (NLGOO)",
   label: "Goor (NLGOO)"
  },
  {
   value: "Gorinchem (NLGOR)",
   label: "Gorinchem (NLGOR)"
  },
  {
   value: "Gouda (NLGOU)",
   label: "Gouda (NLGOU)"
  },
  {
   value: "Dieren (NLDIR)",
   label: "Dieren (NLDIR)"
  },
  {
   value: "Diever (NLDIE)",
   label: "Diever (NLDIE)"
  },
  {
   value: "Dinteloord (NLDIN)",
   label: "Dinteloord (NLDIN)"
  },
  {
   value: "Dinxperlo (NLDXP)",
   label: "Dinxperlo (NLDXP)"
  },
  {
   value: "Dirksland (NLDRK)",
   label: "Dirksland (NLDRK)"
  },
  {
   value: "Doesburg (NLDOE)",
   label: "Doesburg (NLDOE)"
  },
  {
   value: "Doetinchem (NLDOI)",
   label: "Doetinchem (NLDOI)"
  },
  {
   value: "Dokkum (NLDOK)",
   label: "Dokkum (NLDOK)"
  },
  {
   value: "Dongen (NLDON)",
   label: "Dongen (NLDON)"
  },
  {
   value: "Doorn (NLDOO)",
   label: "Doorn (NLDOO)"
  },
  {
   value: "Dordrecht (NLDOR)",
   label: "Dordrecht (NLDOR)"
  },
  {
   value: "Drachten (NLDRA)",
   label: "Drachten (NLDRA)"
  },
  {
   value: "Driebergen (NLDRI)",
   label: "Driebergen (NLDRI)"
  },
  {
   value: "Dronten (NLDRO)",
   label: "Dronten (NLDRO)"
  },
  {
   value: "Drunen (NLDRN)",
   label: "Drunen (NLDRN)"
  },
  {
   value: "Druten (NLDRU)",
   label: "Druten (NLDRU)"
  },
  {
   value: "Duiven (NLDUI)",
   label: "Duiven (NLDUI)"
  },
  {
   value: "Duizel (NLDUZ)",
   label: "Duizel (NLDUZ)"
  },
  {
   value: "Echt (NLECH)",
   label: "Echt (NLECH)"
  },
  {
   value: "Echteld (NLECD)",
   label: "Echteld (NLECD)"
  },
  {
   value: "Edam (NLEDM)",
   label: "Edam (NLEDM)"
  },
  {
   value: "Ede (NLEDE)",
   label: "Ede (NLEDE)"
  },
  {
   value: "Eede (NLEED)",
   label: "Eede (NLEED)"
  },
  {
   value: "Eemshaven (NLEEM)",
   label: "Eemshaven (NLEEM)"
  },
  {
   value: "Eenrum (NLEEN)",
   label: "Eenrum (NLEEN)"
  },
  {
   value: "Eerbeek (NLEEE)",
   label: "Eerbeek (NLEEE)"
  },
  {
   value: "Eersel (NLQCT)",
   label: "Eersel (NLQCT)"
  },
  {
   value: "Egchel (NLEGL)",
   label: "Egchel (NLEGL)"
  },
  {
   value: "Egmond aan Zee (NLEAZ)",
   label: "Egmond aan Zee (NLEAZ)"
  },
  {
   value: "Eibergen (NLEIB)",
   label: "Eibergen (NLEIB)"
  },
  {
   value: "Eijsden (NLEYS)",
   label: "Eijsden (NLEYS)"
  },
  {
   value: "Eindhoven (NLEIN)",
   label: "Eindhoven (NLEIN)"
  },
  {
   value: "Elburg (NLELB)",
   label: "Elburg (NLELB)"
  },
  {
   value: "Ellecom (NLELL)",
   label: "Ellecom (NLELL)"
  },
  {
   value: "Elst (NLQCU)",
   label: "Elst (NLQCU)"
  },
  {
   value: "Emmeloord (NLEML)",
   label: "Emmeloord (NLEML)"
  },
  {
   value: "Emmen (NLEMM)",
   label: "Emmen (NLEMM)"
  },
  {
   value: "Emmer-Compascuum (NLEMC)",
   label: "Emmer-Compascuum (NLEMC)"
  },
  {
   value: "Emmer-Erfscheideveen (NLEME)",
   label: "Emmer-Erfscheideveen (NLEME)"
  },
  {
   value: "Engwierum (NLENG)",
   label: "Engwierum (NLENG)"
  },
  {
   value: "Enkhuizen (NLENK)",
   label: "Enkhuizen (NLENK)"
  },
  {
   value: "Ens (NLENX)",
   label: "Ens (NLENX)"
  },
  {
   value: "Brunssum (NLBRN)",
   label: "Brunssum (NLBRN)"
  },
  {
   value: "Budel (NLBUD)",
   label: "Budel (NLBUD)"
  },
  {
   value: "Buesingheliede (NLBUE)",
   label: "Buesingheliede (NLBUE)"
  },
  {
   value: "Bunnik (NLBUK)",
   label: "Bunnik (NLBUK)"
  },
  {
   value: "Bunnink (NLBNK)",
   label: "Bunnink (NLBNK)"
  },
  {
   value: "Bunschoten (NLBUN)",
   label: "Bunschoten (NLBUN)"
  },
  {
   value: "Bussum (NLBSS)",
   label: "Bussum (NLBSS)"
  },
  {
   value: "Capelle (NLCAP)",
   label: "Capelle (NLCAP)"
  },
  {
   value: "Capelle aan den IJssel (NLCPI)",
   label: "Capelle aan den IJssel (NLCPI)"
  },
  {
   value: "Castricum (NLCAS)",
   label: "Castricum (NLCAS)"
  },
  {
   value: "Coevorden (NLCOE)",
   label: "Coevorden (NLCOE)"
  },
  {
   value: "Cothen (NLCOT)",
   label: "Cothen (NLCOT)"
  },
  {
   value: "Cruquius (NLCRU)",
   label: "Cruquius (NLCRU)"
  },
  {
   value: "Cuijk (NLCUY)",
   label: "Cuijk (NLCUY)"
  },
  {
   value: "Culemborg (NLCUB)",
   label: "Culemborg (NLCUB)"
  },
  {
   value: "Dalfsen (NLDAL)",
   label: "Dalfsen (NLDAL)"
  },
  {
   value: "De Bilt (NLDBI)",
   label: "De Bilt (NLDBI)"
  },
  {
   value: "De Kempen (NLDKP)",
   label: "De Kempen (NLDKP)"
  },
  {
   value: "De Krim (NLDKR)",
   label: "De Krim (NLDKR)"
  },
  {
   value: "De Kwakel (NLDKW)",
   label: "De Kwakel (NLDKW)"
  },
  {
   value: "De Lier (NLDLR)",
   label: "De Lier (NLDLR)"
  },
  {
   value: "De Lutte (NLDLU)",
   label: "De Lutte (NLDLU)"
  },
  {
   value: "De Meern (NLDEM)",
   label: "De Meern (NLDEM)"
  },
  {
   value: "De Poppe-Springbiel (NLDPS)",
   label: "De Poppe-Springbiel (NLDPS)"
  },
  {
   value: "De Wilp (NLDEW)",
   label: "De Wilp (NLDEW)"
  },
  {
   value: "De Zilk (NLDZK)",
   label: "De Zilk (NLDZK)"
  },
  {
   value: "Dedemsvaart (NLDED)",
   label: "Dedemsvaart (NLDED)"
  },
  {
   value: "Delfgauw (NLDGW)",
   label: "Delfgauw (NLDGW)"
  },
  {
   value: "Delft (NLDFT)",
   label: "Delft (NLDFT)"
  },
  {
   value: "Delfzijl (NLDZL)",
   label: "Delfzijl (NLDZL)"
  },
  {
   value: "Den Dolder (NLDDO)",
   label: "Den Dolder (NLDDO)"
  },
  {
   value: "Den Haag (S-Gravenhage) (NLHAG)",
   label: "Den Haag (S-Gravenhage) (NLHAG)"
  },
  {
   value: "Den Helder (NLDHR)",
   label: "Den Helder (NLDHR)"
  },
  {
   value: "Den Hoorn (NLDHN)",
   label: "Den Hoorn (NLDHN)"
  },
  {
   value: "\"Den Hootn (NLDTK)",
   label: "\"Den Hootn (NLDTK)"
  },
  {
   value: "Denekamp-Frensdorferhaar (NLDEN)",
   label: "Denekamp-Frensdorferhaar (NLDEN)"
  },
  {
   value: "Deurne (NLDEU)",
   label: "Deurne (NLDEU)"
  },
  {
   value: "Deventer (NLDEV)",
   label: "Deventer (NLDEV)"
  },
  {
   value: "Didam (NLDDM)",
   label: "Didam (NLDDM)"
  },
  {
   value: "Diemen (NLDIM)",
   label: "Diemen (NLDIM)"
  },
  {
   value: "Berkel en Rodenrijs (NLBER)",
   label: "Berkel en Rodenrijs (NLBER)"
  },
  {
   value: "Berkel-Enschot (NLBES)",
   label: "Berkel-Enschot (NLBES)"
  },
  {
   value: "Best (NLBST)",
   label: "Best (NLBST)"
  },
  {
   value: "Beugen (NLBEU)",
   label: "Beugen (NLBEU)"
  },
  {
   value: "Beuningen (NLBNN)",
   label: "Beuningen (NLBNN)"
  },
  {
   value: "Beusichem (NLBEC)",
   label: "Beusichem (NLBEC)"
  },
  {
   value: "Beverwijk (NLBEV)",
   label: "Beverwijk (NLBEV)"
  },
  {
   value: "Bilthoven (NLBHV)",
   label: "Bilthoven (NLBHV)"
  },
  {
   value: "Binnenmaas (NLBNM)",
   label: "Binnenmaas (NLBNM)"
  },
  {
   value: "Blaaksedijk (NLBLD)",
   label: "Blaaksedijk (NLBLD)"
  },
  {
   value: "Bladel (NLBLL)",
   label: "Bladel (NLBLL)"
  },
  {
   value: "Blaricum (NLBLA)",
   label: "Blaricum (NLBLA)"
  },
  {
   value: "Bleiswijk (NLBLW)",
   label: "Bleiswijk (NLBLW)"
  },
  {
   value: "Bleskensgraaf (NLBLG)",
   label: "Bleskensgraaf (NLBLG)"
  },
  {
   value: "Bloemendaal (NLBMD)",
   label: "Bloemendaal (NLBMD)"
  },
  {
   value: "Blokker (NLBLK)",
   label: "Blokker (NLBLK)"
  },
  {
   value: "Bodegraven (NLBOG)",
   label: "Bodegraven (NLBOG)"
  },
  {
   value: "Boekelo (NLBKL)",
   label: "Boekelo (NLBKL)"
  },
  {
   value: "Bolsward (NLBOL)",
   label: "Bolsward (NLBOL)"
  },
  {
   value: "Boortmeerkerk (NLBMK)",
   label: "Boortmeerkerk (NLBMK)"
  },
  {
   value: "Borculo (NLBRC)",
   label: "Borculo (NLBRC)"
  },
  {
   value: "Born (NLBON)",
   label: "Born (NLBON)"
  },
  {
   value: "Bornerbroek (NLBNB)",
   label: "Bornerbroek (NLBNB)"
  },
  {
   value: "Borssele (NLBOR)",
   label: "Borssele (NLBOR)"
  },
  {
   value: "Boskoop (NLBSK)",
   label: "Boskoop (NLBSK)"
  },
  {
   value: "Botlek (NLBOT)",
   label: "Botlek (NLBOT)"
  },
  {
   value: "Boxmeer (NLBOX)",
   label: "Boxmeer (NLBOX)"
  },
  {
   value: "Boxtel (NLBXT)",
   label: "Boxtel (NLBXT)"
  },
  {
   value: "Brakel (NLBRK)",
   label: "Brakel (NLBRK)"
  },
  {
   value: "Breda (NLBRD)",
   label: "Breda (NLBRD)"
  },
  {
   value: "Breezand (NLBRZ)",
   label: "Breezand (NLBRZ)"
  },
  {
   value: "Breskens (NLBRS)",
   label: "Breskens (NLBRS)"
  },
  {
   value: "Breukelen (NLRUK)",
   label: "Breukelen (NLRUK)"
  },
  {
   value: "Brielle (NLBRI)",
   label: "Brielle (NLBRI)"
  },
  {
   value: "Broek in Waterland (NLBIW)",
   label: "Broek in Waterland (NLBIW)"
  },
  {
   value: "Broek op Langedijk (NLBRL)",
   label: "Broek op Langedijk (NLBRL)"
  },
  {
   value: "Brouwershaven (NLBRO)",
   label: "Brouwershaven (NLBRO)"
  },
  {
   value: "Bruchem (NLBRU)",
   label: "Bruchem (NLBRU)"
  },
  {
   value: "Bruinisse (NLBSE)",
   label: "Bruinisse (NLBSE)"
  },
  {
   value: "Brummen (NLBRM)",
   label: "Brummen (NLBRM)"
  },
  {
   value: "Arcen (NLARC)",
   label: "Arcen (NLARC)"
  },
  {
   value: "Arkel (NLARK)",
   label: "Arkel (NLARK)"
  },
  {
   value: "Arnemuiden (NLARM)",
   label: "Arnemuiden (NLARM)"
  },
  {
   value: "Arnhem (NLARN)",
   label: "Arnhem (NLARN)"
  },
  {
   value: "Asperen (NLASP)",
   label: "Asperen (NLASP)"
  },
  {
   value: "Assen (NLASS)",
   label: "Assen (NLASS)"
  },
  {
   value: "Assendelft (NLASD)",
   label: "Assendelft (NLASD)"
  },
  {
   value: "Asten (NLAST)",
   label: "Asten (NLAST)"
  },
  {
   value: "Avenhorn (NLAVE)",
   label: "Avenhorn (NLAVE)"
  },
  {
   value: "Baarle-Nassau (NLBNS)",
   label: "Baarle-Nassau (NLBNS)"
  },
  {
   value: "Baarlo (NLBLO)",
   label: "Baarlo (NLBLO)"
  },
  {
   value: "Baarn (NLBAA)",
   label: "Baarn (NLBAA)"
  },
  {
   value: "Badhoevedorp (NLBAD)",
   label: "Badhoevedorp (NLBAD)"
  },
  {
   value: "Baexem (NLBXE)",
   label: "Baexem (NLBXE)"
  },
  {
   value: "Baflo (NLBAF)",
   label: "Baflo (NLBAF)"
  },
  {
   value: "Balk (NLBAL)",
   label: "Balk (NLBAL)"
  },
  {
   value: "Balkbrug (NLBKB)",
   label: "Balkbrug (NLBKB)"
  },
  {
   value: "Barendrecht (NLBRR)",
   label: "Barendrecht (NLBRR)"
  },
  {
   value: "Barneveld (NLBAR)",
   label: "Barneveld (NLBAR)"
  },
  {
   value: "Bathmen (NLBTH)",
   label: "Bathmen (NLBTH)"
  },
  {
   value: "Bavel (NLBAV)",
   label: "Bavel (NLBAV)"
  },
  {
   value: "Bedum (NLBED)",
   label: "Bedum (NLBED)"
  },
  {
   value: "Beek (NLBEQ)",
   label: "Beek (NLBEQ)"
  },
  {
   value: "Beek en Donk (NLBEE)",
   label: "Beek en Donk (NLBEE)"
  },
  {
   value: "Beesd (NLBSD)",
   label: "Beesd (NLBSD)"
  },
  {
   value: "Beilen (NLBEI)",
   label: "Beilen (NLBEI)"
  },
  {
   value: "Beiswijk (NLBEW)",
   label: "Beiswijk (NLBEW)"
  },
  {
   value: "Beneden-Leeuwen (NLBUW)",
   label: "Beneden-Leeuwen (NLBUW)"
  },
  {
   value: "Bennebroek (NLBEB)",
   label: "Bennebroek (NLBEB)"
  },
  {
   value: "Bennekom (NLBKM)",
   label: "Bennekom (NLBKM)"
  },
  {
   value: "Benthuizen (NLBHZ)",
   label: "Benthuizen (NLBHZ)"
  },
  {
   value: "Bentveld (NLBEN)",
   label: "Bentveld (NLBEN)"
  },
  {
   value: "Berg en Terblijt (NLBTT)",
   label: "Berg en Terblijt (NLBTT)"
  },
  {
   value: "Bergambacht (NLBGB)",
   label: "Bergambacht (NLBGB)"
  },
  {
   value: "Bergeijk (NLBEY)",
   label: "Bergeijk (NLBEY)"
  },
  {
   value: "Bergen (NLBEG)",
   label: "Bergen (NLBEG)"
  },
  {
   value: "Bergen Op Zoom (NLBZM)",
   label: "Bergen Op Zoom (NLBZM)"
  },
  {
   value: "Bergh-Autoweg (NLBEH)",
   label: "Bergh-Autoweg (NLBEH)"
  },
  {
   value: "Bergschenhoek (NLBEK)",
   label: "Bergschenhoek (NLBEK)"
  },
  {
   value: "Bergum (NLBGU)",
   label: "Bergum (NLBGU)"
  },
  {
   value: "Berkel (NLBKE)",
   label: "Berkel (NLBKE)"
  },
  {
   value: "Prinzapolca (NIPRI)",
   label: "Prinzapolca (NIPRI)"
  },
  {
   value: "Puerto Cabezas (NIPUZ)",
   label: "Puerto Cabezas (NIPUZ)"
  },
  {
   value: "Puerto Sandino (NIPSN)",
   label: "Puerto Sandino (NIPSN)"
  },
  {
   value: "Rio Blanco (NIRIB)",
   label: "Rio Blanco (NIRIB)"
  },
  {
   value: "San Juan del Sur (NISJS)",
   label: "San Juan del Sur (NISJS)"
  },
  {
   value: "Siuna (NISIU)",
   label: "Siuna (NISIU)"
  },
  {
   value: "Waspam (NIWSP)",
   label: "Waspam (NIWSP)"
  },
  {
   value: "LEON (NILEO)",
   label: "LEON (NILEO)"
  },
  {
   value: "Aalburg (NLALB)",
   label: "Aalburg (NLALB)"
  },
  {
   value: "Aalsmeer (NLAAM)",
   label: "Aalsmeer (NLAAM)"
  },
  {
   value: "Aalst (NLAAL)",
   label: "Aalst (NLAAL)"
  },
  {
   value: "Aalten (NLLTE)",
   label: "Aalten (NLLTE)"
  },
  {
   value: "Aardenburg (NLAAR)",
   label: "Aardenburg (NLAAR)"
  },
  {
   value: "Aarle Rixtel (NLARI)",
   label: "Aarle Rixtel (NLARI)"
  },
  {
   value: "Abbekerk (NLABB)",
   label: "Abbekerk (NLABB)"
  },
  {
   value: "Abbenbroek (NLABK)",
   label: "Abbenbroek (NLABK)"
  },
  {
   value: "Abcoude (NLABC)",
   label: "Abcoude (NLABC)"
  },
  {
   value: "Acht (NLQCJ)",
   label: "Acht (NLQCJ)"
  },
  {
   value: "Aerdenhout (NLAEH)",
   label: "Aerdenhout (NLAEH)"
  },
  {
   value: "Akersloot (NLAKL)",
   label: "Akersloot (NLAKL)"
  },
  {
   value: "Akkrum (NLAKR)",
   label: "Akkrum (NLAKR)"
  },
  {
   value: "Alblasserdam (NLABL)",
   label: "Alblasserdam (NLABL)"
  },
  {
   value: "Alkmaar (NLALK)",
   label: "Alkmaar (NLALK)"
  },
  {
   value: "Almelo (NLALM)",
   label: "Almelo (NLALM)"
  },
  {
   value: "Almere (NLAER)",
   label: "Almere (NLAER)"
  },
  {
   value: "Almkerk (NLAKK)",
   label: "Almkerk (NLAKK)"
  },
  {
   value: "Alphen aan den Rijn (NLAPN)",
   label: "Alphen aan den Rijn (NLAPN)"
  },
  {
   value: "Ameland (NLAML)",
   label: "Ameland (NLAML)"
  },
  {
   value: "Amerongen (NLAMR)",
   label: "Amerongen (NLAMR)"
  },
  {
   value: "Amersfoort (NLAME)",
   label: "Amersfoort (NLAME)"
  },
  {
   value: "Ammerzoden (NLAMZ)",
   label: "Ammerzoden (NLAMZ)"
  },
  {
   value: "Amstelveen (NLAMV)",
   label: "Amstelveen (NLAMV)"
  },
  {
   value: "Amsterdam (NLAMS)",
   label: "Amsterdam (NLAMS)"
  },
  {
   value: "Andel (NLANL)",
   label: "Andel (NLANL)"
  },
  {
   value: "Andelst (NLANT)",
   label: "Andelst (NLANT)"
  },
  {
   value: "Andijk (NLAIJ)",
   label: "Andijk (NLAIJ)"
  },
  {
   value: "Anjum (NLAJM)",
   label: "Anjum (NLAJM)"
  },
  {
   value: "Anna Paulowna (NLANP)",
   label: "Anna Paulowna (NLANP)"
  },
  {
   value: "Annen (NLNNE)",
   label: "Annen (NLNNE)"
  },
  {
   value: "Apeldoorn (NLAPE)",
   label: "Apeldoorn (NLAPE)"
  },
  {
   value: "Appingedam (NLAPP)",
   label: "Appingedam (NLAPP)"
  },
  {
   value: "Benin City (NGBNI)",
   label: "Benin City (NGBNI)"
  },
  {
   value: "Bonny (NGBON)",
   label: "Bonny (NGBON)"
  },
  {
   value: "Brass (NGBRA)",
   label: "Brass (NGBRA)"
  },
  {
   value: "Burutu (NGBUR)",
   label: "Burutu (NGBUR)"
  },
  {
   value: "Calabar (NGCBQ)",
   label: "Calabar (NGCBQ)"
  },
  {
   value: "Denema (NGDEN)",
   label: "Denema (NGDEN)"
  },
  {
   value: "Eket (NGEKE)",
   label: "Eket (NGEKE)"
  },
  {
   value: "Enugu (NGENU)",
   label: "Enugu (NGENU)"
  },
  {
   value: "Escravos (NGESC)",
   label: "Escravos (NGESC)"
  },
  {
   value: "Forcados (NGFOR)",
   label: "Forcados (NGFOR)"
  },
  {
   value: "Greek Port (NGGRP)",
   label: "Greek Port (NGGRP)"
  },
  {
   value: "Ibadan (NGIBA)",
   label: "Ibadan (NGIBA)"
  },
  {
   value: "Jos (NGJOS)",
   label: "Jos (NGJOS)"
  },
  {
   value: "Kaduna (NGKAD)",
   label: "Kaduna (NGKAD)"
  },
  {
   value: "Kano (NGKAN)",
   label: "Kano (NGKAN)"
  },
  {
   value: "Koko (NGKOK)",
   label: "Koko (NGKOK)"
  },
  {
   value: "Kula (NGKUL)",
   label: "Kula (NGKUL)"
  },
  {
   value: "Lagos (NGLOS)",
   label: "Lagos (NGLOS)"
  },
  {
   value: "Maiduguri (NGMIU)",
   label: "Maiduguri (NGMIU)"
  },
  {
   value: "Moudi Terminal (NGMOT)",
   label: "Moudi Terminal (NGMOT)"
  },
  {
   value: "Okrika (NGOKR)",
   label: "Okrika (NGOKR)"
  },
  {
   value: "Onne (NGONN)",
   label: "Onne (NGONN)"
  },
  {
   value: "Oron (NGORO)",
   label: "Oron (NGORO)"
  },
  {
   value: "Pennington (NGPEN)",
   label: "Pennington (NGPEN)"
  },
  {
   value: "Port Harcourt (NGPHC)",
   label: "Port Harcourt (NGPHC)"
  },
  {
   value: "Qua Iboe (NGQIB)",
   label: "Qua Iboe (NGQIB)"
  },
  {
   value: "Que Oboe Terminal\/Eket (NGOBO)",
   label: "Que Oboe Terminal\/Eket (NGOBO)"
  },
  {
   value: "Rio Del Rey (NGRDR)",
   label: "Rio Del Rey (NGRDR)"
  },
  {
   value: "Sapele (NGSPL)",
   label: "Sapele (NGSPL)"
  },
  {
   value: "Sokoto (NGSKO)",
   label: "Sokoto (NGSKO)"
  },
  {
   value: "Tiko (NGTIK)",
   label: "Tiko (NGTIK)"
  },
  {
   value: "Tincan\/Lagos (NGTIN)",
   label: "Tincan\/Lagos (NGTIN)"
  },
  {
   value: "Warri (NGWAR)",
   label: "Warri (NGWAR)"
  },
  {
   value: "Yola (NGYOL)",
   label: "Yola (NGYOL)"
  },
  {
   value: "Bluefields (NIBEF)",
   label: "Bluefields (NIBEF)"
  },
  {
   value: "Bonanza (NIBZA)",
   label: "Bonanza (NIBZA)"
  },
  {
   value: "Chinandega (NICHI)",
   label: "Chinandega (NICHI)"
  },
  {
   value: "Corinto (NICIO)",
   label: "Corinto (NICIO)"
  },
  {
   value: "Corn Island (NIRNI)",
   label: "Corn Island (NIRNI)"
  },
  {
   value: "El Bluff (NIELB)",
   label: "El Bluff (NIELB)"
  },
  {
   value: "Managua (NIMGA)",
   label: "Managua (NIMGA)"
  },
  {
   value: "Masaya (NIMAS)",
   label: "Masaya (NIMAS)"
  },
  {
   value: "Keetmanshoop (NAKMP)",
   label: "Keetmanshoop (NAKMP)"
  },
  {
   value: "Luderitz (NALUD)",
   label: "Luderitz (NALUD)"
  },
  {
   value: "Mariental (NAMAR)",
   label: "Mariental (NAMAR)"
  },
  {
   value: "Oranjemund (NAOMD)",
   label: "Oranjemund (NAOMD)"
  },
  {
   value: "Oshakati (NAOHI)",
   label: "Oshakati (NAOHI)"
  },
  {
   value: "Otjiwarongo (NAOTJ)",
   label: "Otjiwarongo (NAOTJ)"
  },
  {
   value: "Swakopmund (NASWP)",
   label: "Swakopmund (NASWP)"
  },
  {
   value: "Tsumeb (NATSB)",
   label: "Tsumeb (NATSB)"
  },
  {
   value: "Walvis Bay (NAWVB)",
   label: "Walvis Bay (NAWVB)"
  },
  {
   value: "Windhoek (NAWDH)",
   label: "Windhoek (NAWDH)"
  },
  {
   value: "Woordoewer (NAWOR)",
   label: "Woordoewer (NAWOR)"
  },
  {
   value: "Baie Ugue (NCBUG)",
   label: "Baie Ugue (NCBUG)"
  },
  {
   value: "Belep Island (NCBMY)",
   label: "Belep Island (NCBMY)"
  },
  {
   value: "Ducos (NCDUS)",
   label: "Ducos (NCDUS)"
  },
  {
   value: "Houailou (NCHLU)",
   label: "Houailou (NCHLU)"
  },
  {
   value: "Ile Des Pins (NCILP)",
   label: "Ile Des Pins (NCILP)"
  },
  {
   value: "Kone (NCKNQ)",
   label: "Kone (NCKNQ)"
  },
  {
   value: "Kouaoua (NCKOU)",
   label: "Kouaoua (NCKOU)"
  },
  {
   value: "Koumac (NCKOC)",
   label: "Koumac (NCKOC)"
  },
  {
   value: "Mare (NCMEE)",
   label: "Mare (NCMEE)"
  },
  {
   value: "Mueo (NCPDC)",
   label: "Mueo (NCPDC)"
  },
  {
   value: "Nakety (NCNAK)",
   label: "Nakety (NCNAK)"
  },
  {
   value: "Nepoui (NCNEP)",
   label: "Nepoui (NCNEP)"
  },
  {
   value: "Noumea (NCNOU)",
   label: "Noumea (NCNOU)"
  },
  {
   value: "Ouvea (NCUVE)",
   label: "Ouvea (NCUVE)"
  },
  {
   value: "Poro (NCPOR)",
   label: "Poro (NCPOR)"
  },
  {
   value: "Teoudie (NCTUD)",
   label: "Teoudie (NCTUD)"
  },
  {
   value: "Thio (NCTHI)",
   label: "Thio (NCTHI)"
  },
  {
   value: "Tontouta (NCTON)",
   label: "Tontouta (NCTON)"
  },
  {
   value: "Touho (NCTOU)",
   label: "Touho (NCTOU)"
  },
  {
   value: "Agades (NEAJY)",
   label: "Agades (NEAJY)"
  },
  {
   value: "Arlit (NERLT)",
   label: "Arlit (NERLT)"
  },
  {
   value: "Maradi (NEMFQ)",
   label: "Maradi (NEMFQ)"
  },
  {
   value: "Niamey (NENIM)",
   label: "Niamey (NENIM)"
  },
  {
   value: "Tahoua (NETHZ)",
   label: "Tahoua (NETHZ)"
  },
  {
   value: "Zinder (NEZND)",
   label: "Zinder (NEZND)"
  },
  {
   value: "Norfolk Island (NFNLK)",
   label: "Norfolk Island (NFNLK)"
  },
  {
   value: "Abonnema (NGABO)",
   label: "Abonnema (NGABO)"
  },
  {
   value: "Ado (NGADO)",
   label: "Ado (NGADO)"
  },
  {
   value: "Antan Terminal (NGANT)",
   label: "Antan Terminal (NGANT)"
  },
  {
   value: "Apapa (NGAPP)",
   label: "Apapa (NGAPP)"
  },
  {
   value: "Badagri (NGBAD)",
   label: "Badagri (NGBAD)"
  },
  {
   value: "Bakana (NGBKA)",
   label: "Bakana (NGBKA)"
  },
  {
   value: "Bazaruto Island (MZBZB)",
   label: "Bazaruto Island (MZBZB)"
  },
  {
   value: "Beira (MZBEW)",
   label: "Beira (MZBEW)"
  },
  {
   value: "Bela Vista (MZBEL)",
   label: "Bela Vista (MZBEL)"
  },
  {
   value: "Benguera Island (MZBCW)",
   label: "Benguera Island (MZBCW)"
  },
  {
   value: "Caia (MZCMZ)",
   label: "Caia (MZCMZ)"
  },
  {
   value: "Chimoio (MZVPY)",
   label: "Chimoio (MZVPY)"
  },
  {
   value: "Chinde (MZINE)",
   label: "Chinde (MZINE)"
  },
  {
   value: "Gurue (MZVJQ)",
   label: "Gurue (MZVJQ)"
  },
  {
   value: "Ibo (MZIBO)",
   label: "Ibo (MZIBO)"
  },
  {
   value: "Inhambane (MZINH)",
   label: "Inhambane (MZINH)"
  },
  {
   value: "Inhaminga (MZIMG)",
   label: "Inhaminga (MZIMG)"
  },
  {
   value: "Lichinga (MZVXC)",
   label: "Lichinga (MZVXC)"
  },
  {
   value: "Luabo (MZLBM)",
   label: "Luabo (MZLBM)"
  },
  {
   value: "Lumbo (MZLMO)",
   label: "Lumbo (MZLMO)"
  },
  {
   value: "Macuse (MZMCU)",
   label: "Macuse (MZMCU)"
  },
  {
   value: "Maganja Da Costa (MZMJS)",
   label: "Maganja Da Costa (MZMJS)"
  },
  {
   value: "Magaruque (MZMFW)",
   label: "Magaruque (MZMFW)"
  },
  {
   value: "Maputo (MZMPM)",
   label: "Maputo (MZMPM)"
  },
  {
   value: "Marromeu (MZRRM)",
   label: "Marromeu (MZRRM)"
  },
  {
   value: "Massinga (MZMSG)",
   label: "Massinga (MZMSG)"
  },
  {
   value: "Matola (MZMAT)",
   label: "Matola (MZMAT)"
  },
  {
   value: "Memba (MZMEM)",
   label: "Memba (MZMEM)"
  },
  {
   value: "Mocambique (MZMZQ)",
   label: "Mocambique (MZMZQ)"
  },
  {
   value: "Mocimboa Praia (MZMZB)",
   label: "Mocimboa Praia (MZMZB)"
  },
  {
   value: "Moma (MZMMW)",
   label: "Moma (MZMMW)"
  },
  {
   value: "Montepuez (MZMTU)",
   label: "Montepuez (MZMTU)"
  },
  {
   value: "Morrumbene (MZMOR)",
   label: "Morrumbene (MZMOR)"
  },
  {
   value: "Mueda (MZMUD)",
   label: "Mueda (MZMUD)"
  },
  {
   value: "Nacala (MZMNC)",
   label: "Nacala (MZMNC)"
  },
  {
   value: "Nampula (MZAPL)",
   label: "Nampula (MZAPL)"
  },
  {
   value: "Nangade (MZNND)",
   label: "Nangade (MZNND)"
  },
  {
   value: "Nova Sofala (MZNSO)",
   label: "Nova Sofala (MZNSO)"
  },
  {
   value: "Palma (MZLMZ)",
   label: "Palma (MZLMZ)"
  },
  {
   value: "Pebane (MZPEB)",
   label: "Pebane (MZPEB)"
  },
  {
   value: "Pemba (MZPOL)",
   label: "Pemba (MZPOL)"
  },
  {
   value: "Porto Belo (MZPBE)",
   label: "Porto Belo (MZPBE)"
  },
  {
   value: "Quelimane (MZUEL)",
   label: "Quelimane (MZUEL)"
  },
  {
   value: "Santa Carolina (MZNTC)",
   label: "Santa Carolina (MZNTC)"
  },
  {
   value: "Tete (MZTET)",
   label: "Tete (MZTET)"
  },
  {
   value: "Xai Xai (MZVJB)",
   label: "Xai Xai (MZVJB)"
  },
  {
   value: "Grootfontein (NAGFY)",
   label: "Grootfontein (NAGFY)"
  },
  {
   value: "Karasburg (NAKAS)",
   label: "Karasburg (NAKAS)"
  },
  {
   value: "\"Simpangan (MYSPG)",
   label: "\"Simpangan (MYSPG)"
  },
  {
   value: "\"Simunjan (MYSMJ)",
   label: "\"Simunjan (MYSMJ)"
  },
  {
   value: "Sindumin (MYSDM)",
   label: "Sindumin (MYSDM)"
  },
  {
   value: "\"Sipitang (MYSPT)",
   label: "\"Sipitang (MYSPT)"
  },
  {
   value: "Siran (MYSIR)",
   label: "Siran (MYSIR)"
  },
  {
   value: "\"Sirikin (MYSRK)",
   label: "\"Sirikin (MYSRK)"
  },
  {
   value: "Sri Medan (MYSME)",
   label: "Sri Medan (MYSME)"
  },
  {
   value: "\"Sundar (MYSDR)",
   label: "\"Sundar (MYSDR)"
  },
  {
   value: "Sungai Papan Estate (MYSPE)",
   label: "Sungai Papan Estate (MYSPE)"
  },
  {
   value: "Sungai Rengit (MYSRE)",
   label: "Sungai Rengit (MYSRE)"
  },
  {
   value: "\"Sungei Way (MYSUW)",
   label: "\"Sungei Way (MYSUW)"
  },
  {
   value: "Tandjung Tengelili (MYTTE)",
   label: "Tandjung Tengelili (MYTTE)"
  },
  {
   value: "Tanjong Baran (MYTBA)",
   label: "Tanjong Baran (MYTBA)"
  },
  {
   value: "Tanjong Berhala (MYTBE)",
   label: "Tanjong Berhala (MYTBE)"
  },
  {
   value: "Tanjong Dawai (MYTDA)",
   label: "Tanjong Dawai (MYTDA)"
  },
  {
   value: "Tanjong Kidurong (MYTKI)",
   label: "Tanjong Kidurong (MYTKI)"
  },
  {
   value: "Tanjong Kling (MYTKL)",
   label: "Tanjong Kling (MYTKL)"
  },
  {
   value: "Tanjong Kupang (MYTKP)",
   label: "Tanjong Kupang (MYTKP)"
  },
  {
   value: "\"Tanjong Mani (MYTMI)",
   label: "\"Tanjong Mani (MYTMI)"
  },
  {
   value: "Tanjong Pelepas (MYTPP)",
   label: "Tanjong Pelepas (MYTPP)"
  },
  {
   value: "Tanjong Surat (MYTSR)",
   label: "Tanjong Surat (MYTSR)"
  },
  {
   value: "Tapis Terminal (MYTAT)",
   label: "Tapis Terminal (MYTAT)"
  },
  {
   value: "\"Tawau (MYTWU)",
   label: "\"Tawau (MYTWU)"
  },
  {
   value: "Telok Anson (MYTAN)",
   label: "Telok Anson (MYTAN)"
  },
  {
   value: "Telok Intan (MYTAS)",
   label: "Telok Intan (MYTAS)"
  },
  {
   value: "Telok Ramunia (MYTRM)",
   label: "Telok Ramunia (MYTRM)"
  },
  {
   value: "\"Tengku (MYTEN)",
   label: "\"Tengku (MYTEN)"
  },
  {
   value: "Tioman (MYTOD)",
   label: "Tioman (MYTOD)"
  },
  {
   value: "Tomanggong (MYTMG)",
   label: "Tomanggong (MYTMG)"
  },
  {
   value: "Tumbum (MYTMB)",
   label: "Tumbum (MYTMB)"
  },
  {
   value: "Tumpat (MYTUM)",
   label: "Tumpat (MYTUM)"
  },
  {
   value: "Tungku (MYTUN)",
   label: "Tungku (MYTUN)"
  },
  {
   value: "\"Wallace Bay (MYWAL)",
   label: "\"Wallace Bay (MYWAL)"
  },
  {
   value: "\"Weston (MYWES)",
   label: "\"Weston (MYWES)"
  },
  {
   value: "Alto Molocue (MZAME)",
   label: "Alto Molocue (MZAME)"
  },
  {
   value: "Angoche (MZANO)",
   label: "Angoche (MZANO)"
  },
  {
   value: "Bajone (MZBJN)",
   label: "Bajone (MZBJN)"
  },
  {
   value: "Mersing (MYMEP)",
   label: "Mersing (MYMEP)"
  },
  {
   value: "\"Miri (MYMYY)",
   label: "\"Miri (MYMYY)"
  },
  {
   value: "Muar (MYMUA)",
   label: "Muar (MYMUA)"
  },
  {
   value: "\"Mukah (MYMKM)",
   label: "\"Mukah (MYMKM)"
  },
  {
   value: "\"Paloh (MYPAL)",
   label: "\"Paloh (MYPAL)"
  },
  {
   value: "Pamol (MYPAY)",
   label: "Pamol (MYPAY)"
  },
  {
   value: "Panchang (MYPAN)",
   label: "Panchang (MYPAN)"
  },
  {
   value: "Pasir Gogok (MYPAS)",
   label: "Pasir Gogok (MYPAS)"
  },
  {
   value: "\"Pasir Gudang (MYPGU)",
   label: "\"Pasir Gudang (MYPGU)"
  },
  {
   value: "Pasir Hitam (MYPHI)",
   label: "Pasir Hitam (MYPHI)"
  },
  {
   value: "Pedena (MYPED)",
   label: "Pedena (MYPED)"
  },
  {
   value: "Penang (Georgetown) (MYPEN)",
   label: "Penang (Georgetown) (MYPEN)"
  },
  {
   value: "Penggarang\/Tanj.Pengileh (MYPGG)",
   label: "Penggarang\/Tanj.Pengileh (MYPGG)"
  },
  {
   value: "Pengkalan Kubor (MYPKK)",
   label: "Pengkalan Kubor (MYPKK)"
  },
  {
   value: "Pontian (MYPOW)",
   label: "Pontian (MYPOW)"
  },
  {
   value: "Port Dickson (MYPDI)",
   label: "Port Dickson (MYPDI)"
  },
  {
   value: "Port Kelang (MYPKG)",
   label: "Port Kelang (MYPKG)"
  },
  {
   value: "Prai (MYPRA)",
   label: "Prai (MYPRA)"
  },
  {
   value: "\"Pulau Batik (MYPBA)",
   label: "\"Pulau Batik (MYPBA)"
  },
  {
   value: "Pulau Pisang (MYPPI)",
   label: "Pulau Pisang (MYPPI)"
  },
  {
   value: "\"Pulau Tambisan (MYPTB)",
   label: "\"Pulau Tambisan (MYPTB)"
  },
  {
   value: "\"Punang (MYPUN)",
   label: "\"Punang (MYPUN)"
  },
  {
   value: "Ranau (MYRNU)",
   label: "Ranau (MYRNU)"
  },
  {
   value: "\"Rejang (MYREJ)",
   label: "\"Rejang (MYREJ)"
  },
  {
   value: "\"Sambu (MYSAM)",
   label: "\"Sambu (MYSAM)"
  },
  {
   value: "\"Sandakan (MYSDK)",
   label: "\"Sandakan (MYSDK)"
  },
  {
   value: "\"Sarikai (MYSAR)",
   label: "\"Sarikai (MYSAR)"
  },
  {
   value: "\"Sejingkat (MYSEJ)",
   label: "\"Sejingkat (MYSEJ)"
  },
  {
   value: "\"Selalang (MYSEL)",
   label: "\"Selalang (MYSEL)"
  },
  {
   value: "\"Sematan (MYBSE)",
   label: "\"Sematan (MYBSE)"
  },
  {
   value: "\"Semporna (MYSMM)",
   label: "\"Semporna (MYSMM)"
  },
  {
   value: "Sepangar (MYSEP)",
   label: "Sepangar (MYSEP)"
  },
  {
   value: "Shah Alam (MYSHA)",
   label: "Shah Alam (MYSHA)"
  },
  {
   value: "\"Sibu (MYSBW)",
   label: "\"Sibu (MYSBW)"
  },
  {
   value: "Sijingkat (MYSIJ)",
   label: "Sijingkat (MYSIJ)"
  },
  {
   value: "Silay (MYSIL)",
   label: "Silay (MYSIL)"
  },
  {
   value: "\"Simanggang (MYSMG)",
   label: "\"Simanggang (MYSMG)"
  },
  {
   value: "Kota Tinggi (MYKTI)",
   label: "Kota Tinggi (MYKTI)"
  },
  {
   value: "Krety (MYKRE)",
   label: "Krety (MYKRE)"
  },
  {
   value: "Kuala Baram (MYKBA)",
   label: "Kuala Baram (MYKBA)"
  },
  {
   value: "\"Kuala Belud (MYKBE)",
   label: "\"Kuala Belud (MYKBE)"
  },
  {
   value: "Kuala Besar (MYKBS)",
   label: "Kuala Besar (MYKBS)"
  },
  {
   value: "Kuala Gula (MYKUG)",
   label: "Kuala Gula (MYKUG)"
  },
  {
   value: "Kuala Kedah (MYKKH)",
   label: "Kuala Kedah (MYKKH)"
  },
  {
   value: "Kuala Lumpur (MYKUL)",
   label: "Kuala Lumpur (MYKUL)"
  },
  {
   value: "\"Kuala Penyu (MYKPU)",
   label: "\"Kuala Penyu (MYKPU)"
  },
  {
   value: "Kuala Perlis (MYKPS)",
   label: "Kuala Perlis (MYKPS)"
  },
  {
   value: "Kuala Rompin (MYPRN)",
   label: "Kuala Rompin (MYPRN)"
  },
  {
   value: "Kuala Sedili (MYKSD)",
   label: "Kuala Sedili (MYKSD)"
  },
  {
   value: "\"Kuala Segama (MYKSG)",
   label: "\"Kuala Segama (MYKSG)"
  },
  {
   value: "Kuala Selangor (MYKSL)",
   label: "Kuala Selangor (MYKSL)"
  },
  {
   value: "Kuala Terengganu (MYTGG)",
   label: "Kuala Terengganu (MYTGG)"
  },
  {
   value: "Kuantan (Tanjong Gelang) (MYKUA)",
   label: "Kuantan (Tanjong Gelang) (MYKUA)"
  },
  {
   value: "\"Kuching (MYKCH)",
   label: "\"Kuching (MYKCH)"
  },
  {
   value: "\"Kudat (MYKUD)",
   label: "\"Kudat (MYKUD)"
  },
  {
   value: "Kukup (MYKKP)",
   label: "Kukup (MYKKP)"
  },
  {
   value: "\"Kunak (MYKUN)",
   label: "\"Kunak (MYKUN)"
  },
  {
   value: "\"Labuan Hadji (MYLBH)",
   label: "\"Labuan Hadji (MYLBH)"
  },
  {
   value: "\"Labuan (MYLBU)",
   label: "\"Labuan (MYLBU)"
  },
  {
   value: "\"Lahad Datu (MYLDU)",
   label: "\"Lahad Datu (MYLDU)"
  },
  {
   value: "Langkawi (MYLGK)",
   label: "Langkawi (MYLGK)"
  },
  {
   value: "\"Lawas (MYLWY)",
   label: "\"Lawas (MYLWY)"
  },
  {
   value: "\"Limbang (MYLMN)",
   label: "\"Limbang (MYLMN)"
  },
  {
   value: "\"Lingga (MYLGG)",
   label: "\"Lingga (MYLGG)"
  },
  {
   value: "Long Semado (MYLSM)",
   label: "Long Semado (MYLSM)"
  },
  {
   value: "Long Seridan (MYODN)",
   label: "Long Seridan (MYODN)"
  },
  {
   value: "Long Sukang (MYLSU)",
   label: "Long Sukang (MYLSU)"
  },
  {
   value: "Lumut (MYLUM)",
   label: "Lumut (MYLUM)"
  },
  {
   value: "\"Lundu (MYLUN)",
   label: "\"Lundu (MYLUN)"
  },
  {
   value: "\"Lutong (MYLUT)",
   label: "\"Lutong (MYLUT)"
  },
  {
   value: "Malacca (MYMKZ)",
   label: "Malacca (MYMKZ)"
  },
  {
   value: "\"Marudi (MYMUR)",
   label: "\"Marudi (MYMUR)"
  },
  {
   value: "\"Mempakul (MYMEM)",
   label: "\"Mempakul (MYMEM)"
  },
  {
   value: "Menasi (MYMEN)",
   label: "Menasi (MYMEN)"
  },
  {
   value: "\"Bandau (MYBDV)",
   label: "\"Bandau (MYBDV)"
  },
  {
   value: "\"Banggau (MYBGU)",
   label: "\"Banggau (MYBGU)"
  },
  {
   value: "Bario (MYBBN)",
   label: "Bario (MYBBN)"
  },
  {
   value: "\"Batu Batu (MYBBA)",
   label: "\"Batu Batu (MYBBA)"
  },
  {
   value: "\"Batu Lingtan (MYBLI)",
   label: "\"Batu Lingtan (MYBLI)"
  },
  {
   value: "Batu Pahat (MYBAT)",
   label: "Batu Pahat (MYBAT)"
  },
  {
   value: "\"Bau (MYBAU)",
   label: "\"Bau (MYBAU)"
  },
  {
   value: "\"Belaga (MYBLG)",
   label: "\"Belaga (MYBLG)"
  },
  {
   value: "\"Beluran (MYBEL)",
   label: "\"Beluran (MYBEL)"
  },
  {
   value: "\"Benut (MYBNT)",
   label: "\"Benut (MYBNT)"
  },
  {
   value: "Besut (Kuala Besut) (MYBST)",
   label: "Besut (Kuala Besut) (MYBST)"
  },
  {
   value: "\"Betong (MYBTG)",
   label: "\"Betong (MYBTG)"
  },
  {
   value: "\"Biawak (MYBIA)",
   label: "\"Biawak (MYBIA)"
  },
  {
   value: "\"Binatang (MYBNG)",
   label: "\"Binatang (MYBNG)"
  },
  {
   value: "Bintangor (MYBTN)",
   label: "Bintangor (MYBTN)"
  },
  {
   value: "\"Bintulu (MYBTU)",
   label: "\"Bintulu (MYBTU)"
  },
  {
   value: "\"Bunan Gega (MYBGG)",
   label: "\"Bunan Gega (MYBGG)"
  },
  {
   value: "Danjindawai (MYDDW)",
   label: "Danjindawai (MYDDW)"
  },
  {
   value: "\"Daro (MYDRO)",
   label: "\"Daro (MYDRO)"
  },
  {
   value: "Dungun (Kuala Dungun) (MYDGN)",
   label: "Dungun (Kuala Dungun) (MYDGN)"
  },
  {
   value: "Endau (MYEND)",
   label: "Endau (MYEND)"
  },
  {
   value: "Hutan Melingtang (MYHUM)",
   label: "Hutan Melingtang (MYHUM)"
  },
  {
   value: "Ipoh (MYIPH)",
   label: "Ipoh (MYIPH)"
  },
  {
   value: "\"Jambongan (MYJAM)",
   label: "\"Jambongan (MYJAM)"
  },
  {
   value: "\"Jitra (MYJTA)",
   label: "\"Jitra (MYJTA)"
  },
  {
   value: "Johor Bahru (MYJHB)",
   label: "Johor Bahru (MYJHB)"
  },
  {
   value: "\"Kabong (MYKAB)",
   label: "\"Kabong (MYKAB)"
  },
  {
   value: "\"Kapit (MYKPI)",
   label: "\"Kapit (MYKPI)"
  },
  {
   value: "Kejit (MYKES)",
   label: "Kejit (MYKES)"
  },
  {
   value: "Kemaman (MYKEM)",
   label: "Kemaman (MYKEM)"
  },
  {
   value: "Kerteh Terminal (MYKET)",
   label: "Kerteh Terminal (MYKET)"
  },
  {
   value: "Kijal (MYKIJ)",
   label: "Kijal (MYKIJ)"
  },
  {
   value: "\"Kimanis (MYKIM)",
   label: "\"Kimanis (MYKIM)"
  },
  {
   value: "\"Kota Belud (MYKBD)",
   label: "\"Kota Belud (MYKBD)"
  },
  {
   value: "Kota Bharu (MYKBR)",
   label: "Kota Bharu (MYKBR)"
  },
  {
   value: "\"Kota Kinabalu (MYBKI)",
   label: "\"Kota Kinabalu (MYBKI)"
  },
  {
   value: "San Luis Rio Colorado (MXUAC)",
   label: "San Luis Rio Colorado (MXUAC)"
  },
  {
   value: "San Marcos Island (MXSMI)",
   label: "San Marcos Island (MXSMI)"
  },
  {
   value: "San Nicholas de los Garza (MXSND)",
   label: "San Nicholas de los Garza (MXSND)"
  },
  {
   value: "San Quintin (MXSNQ)",
   label: "San Quintin (MXSNQ)"
  },
  {
   value: "Santa Rosalia (MXSRL)",
   label: "Santa Rosalia (MXSRL)"
  },
  {
   value: "Sonoyt (MXSON)",
   label: "Sonoyt (MXSON)"
  },
  {
   value: "Tampico (MXTAM)",
   label: "Tampico (MXTAM)"
  },
  {
   value: "Tamuin (MXTSL)",
   label: "Tamuin (MXTSL)"
  },
  {
   value: "Tapachula (MXTAP)",
   label: "Tapachula (MXTAP)"
  },
  {
   value: "Tecuala (MXTCU)",
   label: "Tecuala (MXTCU)"
  },
  {
   value: "Tehuacan (MXTCN)",
   label: "Tehuacan (MXTCN)"
  },
  {
   value: "Tenabo (MXTEN)",
   label: "Tenabo (MXTEN)"
  },
  {
   value: "Tepeji (MXTPR)",
   label: "Tepeji (MXTPR)"
  },
  {
   value: "Tepic (MXTPQ)",
   label: "Tepic (MXTPQ)"
  },
  {
   value: "Texcoco (MXTXO)",
   label: "Texcoco (MXTXO)"
  },
  {
   value: "Tijuana (MXTIJ)",
   label: "Tijuana (MXTIJ)"
  },
  {
   value: "Tizimin (MXTZM)",
   label: "Tizimin (MXTZM)"
  },
  {
   value: "Tlaquepaque (MXTLQ)",
   label: "Tlaquepaque (MXTLQ)"
  },
  {
   value: "Tlaxcala (MXTXL)",
   label: "Tlaxcala (MXTXL)"
  },
  {
   value: "Toluca (MXTLC)",
   label: "Toluca (MXTLC)"
  },
  {
   value: "Topolobampo (MXTPB)",
   label: "Topolobampo (MXTPB)"
  },
  {
   value: "Torreon (MXTRC)",
   label: "Torreon (MXTRC)"
  },
  {
   value: "Tulum (MXTUY)",
   label: "Tulum (MXTUY)"
  },
  {
   value: "Tuxpan (MXTUX)",
   label: "Tuxpan (MXTUX)"
  },
  {
   value: "Tuxtla Gutierrez (MXTGZ)",
   label: "Tuxtla Gutierrez (MXTGZ)"
  },
  {
   value: "Uruapan (MXUPN)",
   label: "Uruapan (MXUPN)"
  },
  {
   value: "Veracruz (MXVER)",
   label: "Veracruz (MXVER)"
  },
  {
   value: "Villa Constitucion (MXVIB)",
   label: "Villa Constitucion (MXVIB)"
  },
  {
   value: "Villahermosa (MXVSA)",
   label: "Villahermosa (MXVSA)"
  },
  {
   value: "Yukalpeten (MXYUK)",
   label: "Yukalpeten (MXYUK)"
  },
  {
   value: "Zacatecas (MXZCL)",
   label: "Zacatecas (MXZCL)"
  },
  {
   value: "Zamora (MXZMM)",
   label: "Zamora (MXZMM)"
  },
  {
   value: "Zapopan (MXZAP)",
   label: "Zapopan (MXZAP)"
  },
  {
   value: "Zihuatanejo (MXXIH)",
   label: "Zihuatanejo (MXXIH)"
  },
  {
   value: "Alor Setar (MYAOR)",
   label: "Alor Setar (MYAOR)"
  },
  {
   value: "Bagan Datok (MYBAG)",
   label: "Bagan Datok (MYBAG)"
  },
  {
   value: "Bagan Luar (Butterworth) (MYBWH)",
   label: "Bagan Luar (Butterworth) (MYBWH)"
  },
  {
   value: "Bakalalan (MYBKM)",
   label: "Bakalalan (MYBKM)"
  },
  {
   value: "Bakapit (MYBKP)",
   label: "Bakapit (MYBKP)"
  },
  {
   value: "Bandar Maharani (MYBMA)",
   label: "Bandar Maharani (MYBMA)"
  },
  {
   value: "Orizaba (MXORI)",
   label: "Orizaba (MXORI)"
  },
  {
   value: "Pachuca (MXPAC)",
   label: "Pachuca (MXPAC)"
  },
  {
   value: "Palenque (MXPQM)",
   label: "Palenque (MXPQM)"
  },
  {
   value: "Pantaco (MXPAN)",
   label: "Pantaco (MXPAN)"
  },
  {
   value: "Parras (MXPRS)",
   label: "Parras (MXPRS)"
  },
  {
   value: "Pesqueria (MXPQA)",
   label: "Pesqueria (MXPQA)"
  },
  {
   value: "Piedras Negras (MXPIE)",
   label: "Piedras Negras (MXPIE)"
  },
  {
   value: "Pinotepa Nacional (MXPNO)",
   label: "Pinotepa Nacional (MXPNO)"
  },
  {
   value: "Playa del Carmen (MXPCM)",
   label: "Playa del Carmen (MXPCM)"
  },
  {
   value: "Pochutla (MXPUH)",
   label: "Pochutla (MXPUH)"
  },
  {
   value: "Port Isabel (MXPIB)",
   label: "Port Isabel (MXPIB)"
  },
  {
   value: "Poza Rica (MXPAZ)",
   label: "Poza Rica (MXPAZ)"
  },
  {
   value: "Progreso (MXPGO)",
   label: "Progreso (MXPGO)"
  },
  {
   value: "Puebla (MXPBC)",
   label: "Puebla (MXPBC)"
  },
  {
   value: "Puerto Escondido (MXPXM)",
   label: "Puerto Escondido (MXPXM)"
  },
  {
   value: "Puerto Juarez (MXPJZ)",
   label: "Puerto Juarez (MXPJZ)"
  },
  {
   value: "Puerto Madero (MXPMD)",
   label: "Puerto Madero (MXPMD)"
  },
  {
   value: "Puérto Mexico (MXPMX)",
   label: "Puérto Mexico (MXPMX)"
  },
  {
   value: "Puerto Morelos (MXPMS)",
   label: "Puerto Morelos (MXPMS)"
  },
  {
   value: "Puerto Peñasco (MXPPE)",
   label: "Puerto Peñasco (MXPPE)"
  },
  {
   value: "Puerto Vallarta (MXPVR)",
   label: "Puerto Vallarta (MXPVR)"
  },
  {
   value: "Punta Chivato (MXPCV)",
   label: "Punta Chivato (MXPCV)"
  },
  {
   value: "Punta Colorada (MXPCO)",
   label: "Punta Colorada (MXPCO)"
  },
  {
   value: "Queretaro (MXQRO)",
   label: "Queretaro (MXQRO)"
  },
  {
   value: "Ramos Aripze (MXRMA)",
   label: "Ramos Aripze (MXRMA)"
  },
  {
   value: "Reynosa (MXREX)",
   label: "Reynosa (MXREX)"
  },
  {
   value: "Rosarito Terminal (MXRST)",
   label: "Rosarito Terminal (MXRST)"
  },
  {
   value: "S.Cristobal deL Casas (MXSZT)",
   label: "S.Cristobal deL Casas (MXSZT)"
  },
  {
   value: "Salina Cruz (MXSCX)",
   label: "Salina Cruz (MXSCX)"
  },
  {
   value: "Saltillo (MXSLW)",
   label: "Saltillo (MXSLW)"
  },
  {
   value: "San Blas (MXSBS)",
   label: "San Blas (MXSBS)"
  },
  {
   value: "San Carlos (MXSCR)",
   label: "San Carlos (MXSCR)"
  },
  {
   value: "San Felipe (MXSFH)",
   label: "San Felipe (MXSFH)"
  },
  {
   value: "San Ignacio (MXSGM)",
   label: "San Ignacio (MXSGM)"
  },
  {
   value: "San Jose Cabo (MXSJD)",
   label: "San Jose Cabo (MXSJD)"
  },
  {
   value: "San Juan de la Costa (MXSJC)",
   label: "San Juan de la Costa (MXSJC)"
  },
  {
   value: "San Lorenzo (MXSLO)",
   label: "San Lorenzo (MXSLO)"
  },
  {
   value: "San Luis Potosi (MXSLP)",
   label: "San Luis Potosi (MXSLP)"
  },
  {
   value: "Guadalajara (MXGDL)",
   label: "Guadalajara (MXGDL)"
  },
  {
   value: "Guanajuato (MXGUA)",
   label: "Guanajuato (MXGUA)"
  },
  {
   value: "Guaymas (MXGYM)",
   label: "Guaymas (MXGYM)"
  },
  {
   value: "Guerrero Negro (MXGUB)",
   label: "Guerrero Negro (MXGUB)"
  },
  {
   value: "Hermosillo (MXHMO)",
   label: "Hermosillo (MXHMO)"
  },
  {
   value: "Huatabampo (MXHUA)",
   label: "Huatabampo (MXHUA)"
  },
  {
   value: "Isla Mujeres (MXISJ)",
   label: "Isla Mujeres (MXISJ)"
  },
  {
   value: "Ixtapa\/Zihuatanejo (MXZIH)",
   label: "Ixtapa\/Zihuatanejo (MXZIH)"
  },
  {
   value: "Ixtepec (MXIZT)",
   label: "Ixtepec (MXIZT)"
  },
  {
   value: "Jalapa (MXJAL)",
   label: "Jalapa (MXJAL)"
  },
  {
   value: "Juarez (MXJRZ)",
   label: "Juarez (MXJRZ)"
  },
  {
   value: "La Paz (MXLAP)",
   label: "La Paz (MXLAP)"
  },
  {
   value: "Lagos de Moreno (MXLOM)",
   label: "Lagos de Moreno (MXLOM)"
  },
  {
   value: "Lazaro Cardenas (MXLZC)",
   label: "Lazaro Cardenas (MXLZC)"
  },
  {
   value: "Leon (MXLEN)",
   label: "Leon (MXLEN)"
  },
  {
   value: "Lerma (MXLER)",
   label: "Lerma (MXLER)"
  },
  {
   value: "Loreto (MXLTO)",
   label: "Loreto (MXLTO)"
  },
  {
   value: "Los Mochis (MXLMM)",
   label: "Los Mochis (MXLMM)"
  },
  {
   value: "Manzanillo (MXZLO)",
   label: "Manzanillo (MXZLO)"
  },
  {
   value: "Matamoros (MXMAM)",
   label: "Matamoros (MXMAM)"
  },
  {
   value: "Mazatlan (MXMZT)",
   label: "Mazatlan (MXMZT)"
  },
  {
   value: "Merida (MXMID)",
   label: "Merida (MXMID)"
  },
  {
   value: "Mexicali (MXMXL)",
   label: "Mexicali (MXMXL)"
  },
  {
   value: "Mexico City (MXMEX)",
   label: "Mexico City (MXMEX)"
  },
  {
   value: "Minatitlan (MXMTT)",
   label: "Minatitlan (MXMTT)"
  },
  {
   value: "Monclova (MXLOV)",
   label: "Monclova (MXLOV)"
  },
  {
   value: "Monterrey (MXMTY)",
   label: "Monterrey (MXMTY)"
  },
  {
   value: "Morelia (MXMLM)",
   label: "Morelia (MXMLM)"
  },
  {
   value: "Morro Redondo (MXMRE)",
   label: "Morro Redondo (MXMRE)"
  },
  {
   value: "Mulege (MXMUG)",
   label: "Mulege (MXMUG)"
  },
  {
   value: "Nanchital (MXNAN)",
   label: "Nanchital (MXNAN)"
  },
  {
   value: "Naucalpan De Juarez (MXNDJ)",
   label: "Naucalpan De Juarez (MXNDJ)"
  },
  {
   value: "Nautla (MXNAU)",
   label: "Nautla (MXNAU)"
  },
  {
   value: "Navaja Sonora (MXNVS)",
   label: "Navaja Sonora (MXNVS)"
  },
  {
   value: "Nogales \/ NACOZARI DE GARCIA (MXNOG)",
   label: "Nogales \/ NACOZARI DE GARCIA (MXNOG)"
  },
  {
   value: "Nueva Casas Grandes (MXNCG)",
   label: "Nueva Casas Grandes (MXNCG)"
  },
  {
   value: "Nuevo Laredo (MXNLD)",
   label: "Nuevo Laredo (MXNLD)"
  },
  {
   value: "Oaxaca (MXOAX)",
   label: "Oaxaca (MXOAX)"
  },
  {
   value: "Ojinaga (MXOJI)",
   label: "Ojinaga (MXOJI)"
  },
  {
   value: "Acapulco (MXACA)",
   label: "Acapulco (MXACA)"
  },
  {
   value: "Acuna (MXACU)",
   label: "Acuna (MXACU)"
  },
  {
   value: "Aguascalientes (MXAGU)",
   label: "Aguascalientes (MXAGU)"
  },
  {
   value: "Altamira (MXATM)",
   label: "Altamira (MXATM)"
  },
  {
   value: "Alvarado (MXAVD)",
   label: "Alvarado (MXAVD)"
  },
  {
   value: "Alvaro Obregon (MXAOB)",
   label: "Alvaro Obregon (MXAOB)"
  },
  {
   value: "Apatzingan (MXAZG)",
   label: "Apatzingan (MXAZG)"
  },
  {
   value: "Apodaca (MXAPD)",
   label: "Apodaca (MXAPD)"
  },
  {
   value: "Bahia Angeles (MXBHL)",
   label: "Bahia Angeles (MXBHL)"
  },
  {
   value: "Campeche (MXCPE)",
   label: "Campeche (MXCPE)"
  },
  {
   value: "Cancun (MXCUN)",
   label: "Cancun (MXCUN)"
  },
  {
   value: "Cardenas (MXCDN)",
   label: "Cardenas (MXCDN)"
  },
  {
   value: "Cayo Arcas Terminal (MXCAT)",
   label: "Cayo Arcas Terminal (MXCAT)"
  },
  {
   value: "Chetumal (MXCTM)",
   label: "Chetumal (MXCTM)"
  },
  {
   value: "Chichen Itza (MXCZA)",
   label: "Chichen Itza (MXCZA)"
  },
  {
   value: "Chihuahua (MXCUU)",
   label: "Chihuahua (MXCUU)"
  },
  {
   value: "Chilpancingo (MXCHI)",
   label: "Chilpancingo (MXCHI)"
  },
  {
   value: "Ciudad Acuna (MXACN)",
   label: "Ciudad Acuna (MXACN)"
  },
  {
   value: "Ciudad Constitucion (MXCUA)",
   label: "Ciudad Constitucion (MXCUA)"
  },
  {
   value: "Ciudad del Carmen (MXCME)",
   label: "Ciudad del Carmen (MXCME)"
  },
  {
   value: "Ciudad Juarez (MXCJS)",
   label: "Ciudad Juarez (MXCJS)"
  },
  {
   value: "Ciudad Obregon (MXCEN)",
   label: "Ciudad Obregon (MXCEN)"
  },
  {
   value: "Ciudad Victora (MXCVM)",
   label: "Ciudad Victora (MXCVM)"
  },
  {
   value: "Coatzacoalcos (MXCOA)",
   label: "Coatzacoalcos (MXCOA)"
  },
  {
   value: "Col Portales (MXCPT)",
   label: "Col Portales (MXCPT)"
  },
  {
   value: "Colima (MXCOL)",
   label: "Colima (MXCOL)"
  },
  {
   value: "Comitan (MXCJT)",
   label: "Comitan (MXCJT)"
  },
  {
   value: "Cozumel (MXCZM)",
   label: "Cozumel (MXCZM)"
  },
  {
   value: "Cuauhtemoc (MXCHT)",
   label: "Cuauhtemoc (MXCHT)"
  },
  {
   value: "Cuautitlan (MXCUT)",
   label: "Cuautitlan (MXCUT)"
  },
  {
   value: "Cuernavaca (MXCVC)",
   label: "Cuernavaca (MXCVC)"
  },
  {
   value: "Culiacan (MXCUL)",
   label: "Culiacan (MXCUL)"
  },
  {
   value: "Dos Bocas Terminal (MXDBT)",
   label: "Dos Bocas Terminal (MXDBT)"
  },
  {
   value: "Durango (MXDGO)",
   label: "Durango (MXDGO)"
  },
  {
   value: "El Salto (MXELS)",
   label: "El Salto (MXELS)"
  },
  {
   value: "Eldorado (MXELD)",
   label: "Eldorado (MXELD)"
  },
  {
   value: "Ensenada (MXESE)",
   label: "Ensenada (MXESE)"
  },
  {
   value: "Frontera (MXFRN)",
   label: "Frontera (MXFRN)"
  },
  {
   value: "Gomez Palacio (MXGMP)",
   label: "Gomez Palacio (MXGMP)"
  },
  {
   value: "Chinguitti (MRCGT)",
   label: "Chinguitti (MRCGT)"
  },
  {
   value: "El Gouera (MRZLG)",
   label: "El Gouera (MRZLG)"
  },
  {
   value: "Fderik (MRFGD)",
   label: "Fderik (MRFGD)"
  },
  {
   value: "Kaedi (MRKED)",
   label: "Kaedi (MRKED)"
  },
  {
   value: "Kiffa (MRKFA)",
   label: "Kiffa (MRKFA)"
  },
  {
   value: "Mbout (MRMBR)",
   label: "Mbout (MRMBR)"
  },
  {
   value: "Moudjeria (MRMOM)",
   label: "Moudjeria (MRMOM)"
  },
  {
   value: "Nema (MREMN)",
   label: "Nema (MREMN)"
  },
  {
   value: "Nouadhibou (MRNDB)",
   label: "Nouadhibou (MRNDB)"
  },
  {
   value: "Nouakchott (MRNKC)",
   label: "Nouakchott (MRNKC)"
  },
  {
   value: "Point Central (MRPCE)",
   label: "Point Central (MRPCE)"
  },
  {
   value: "Selibaby (MRSEY)",
   label: "Selibaby (MRSEY)"
  },
  {
   value: "Tamchakett (MRTHT)",
   label: "Tamchakett (MRTHT)"
  },
  {
   value: "Tichitt (MRTHI)",
   label: "Tichitt (MRTHI)"
  },
  {
   value: "Tidjikja (MRTIY)",
   label: "Tidjikja (MRTIY)"
  },
  {
   value: "Timbedra (MRTMD)",
   label: "Timbedra (MRTMD)"
  },
  {
   value: "Zouerate (MROUZ)",
   label: "Zouerate (MROUZ)"
  },
  {
   value: "Little Bay (MSLTB)",
   label: "Little Bay (MSLTB)"
  },
  {
   value: "Montserrat (MSMNI)",
   label: "Montserrat (MSMNI)"
  },
  {
   value: "Plymouth (MSPLY)",
   label: "Plymouth (MSPLY)"
  },
  {
   value: "Comino (MTJCO)",
   label: "Comino (MTJCO)"
  },
  {
   value: "Gozo (MTGZM)",
   label: "Gozo (MTGZM)"
  },
  {
   value: "Malta (Valetta) (MTMLA)",
   label: "Malta (Valetta) (MTMLA)"
  },
  {
   value: "Marsaxlokk (MTMAR)",
   label: "Marsaxlokk (MTMAR)"
  },
  {
   value: "Paola (MTPAO)",
   label: "Paola (MTPAO)"
  },
  {
   value: "Qormi (MTRMI)",
   label: "Qormi (MTRMI)"
  },
  {
   value: "Curepipe (MUCUR)",
   label: "Curepipe (MUCUR)"
  },
  {
   value: "Port Louis (MUPLU)",
   label: "Port Louis (MUPLU)"
  },
  {
   value: "Rodrigues Is (MURRG)",
   label: "Rodrigues Is (MURRG)"
  },
  {
   value: "CLOVERDALE (MUCDE)",
   label: "CLOVERDALE (MUCDE)"
  },
  {
   value: "Gan Island (MVGAN)",
   label: "Gan Island (MVGAN)"
  },
  {
   value: "Hanimaadhoo (MVHAQ)",
   label: "Hanimaadhoo (MVHAQ)"
  },
  {
   value: "Kaadedhdhoo (MVKDM)",
   label: "Kaadedhdhoo (MVKDM)"
  },
  {
   value: "Kadhdhoo (MVKDO)",
   label: "Kadhdhoo (MVKDO)"
  },
  {
   value: "Kelai (MVKEL)",
   label: "Kelai (MVKEL)"
  },
  {
   value: "Male (MVMLE)",
   label: "Male (MVMLE)"
  },
  {
   value: "Blantyre (MWBLZ)",
   label: "Blantyre (MWBLZ)"
  },
  {
   value: "Karonga (MWKGJ)",
   label: "Karonga (MWKGJ)"
  },
  {
   value: "Lilongwe (MWLLW)",
   label: "Lilongwe (MWLLW)"
  },
  {
   value: "Limbe (MWLBE)",
   label: "Limbe (MWLBE)"
  },
  {
   value: "Mzuzu (MWZZU)",
   label: "Mzuzu (MWZZU)"
  },
  {
   value: "Abreojos (MXAJS)",
   label: "Abreojos (MXAJS)"
  },
  {
   value: "Tachilek (MMTHL)",
   label: "Tachilek (MMTHL)"
  },
  {
   value: "Tah Sala (MMTAS)",
   label: "Tah Sala (MMTAS)"
  },
  {
   value: "Tavoy (MMTAV)",
   label: "Tavoy (MMTAV)"
  },
  {
   value: "Tenassesim (MMTEN)",
   label: "Tenassesim (MMTEN)"
  },
  {
   value: "Terutao Island (MMTER)",
   label: "Terutao Island (MMTER)"
  },
  {
   value: "Thandwe (Ex Sandoway) (MMSNW)",
   label: "Thandwe (Ex Sandoway) (MMSNW)"
  },
  {
   value: "Thaton (MMTHA)",
   label: "Thaton (MMTHA)"
  },
  {
   value: "Tilin (MMTIO)",
   label: "Tilin (MMTIO)"
  },
  {
   value: "Victoria Point (MMVIC)",
   label: "Victoria Point (MMVIC)"
  },
  {
   value: "Yangon (MMRGN)",
   label: "Yangon (MMRGN)"
  },
  {
   value: "Ye (MMXYE)",
   label: "Ye (MMXYE)"
  },
  {
   value: "Altai (MNLTI)",
   label: "Altai (MNLTI)"
  },
  {
   value: "Arvaikheer (MNAVK)",
   label: "Arvaikheer (MNAVK)"
  },
  {
   value: "Baruun-Urt (MNUUN)",
   label: "Baruun-Urt (MNUUN)"
  },
  {
   value: "Bayankhongor (MNBYN)",
   label: "Bayankhongor (MNBYN)"
  },
  {
   value: "Bulgan (MNUGA)",
   label: "Bulgan (MNUGA)"
  },
  {
   value: "Choibalsan (MNCOQ)",
   label: "Choibalsan (MNCOQ)"
  },
  {
   value: "Dalanzadgad (MNDLZ)",
   label: "Dalanzadgad (MNDLZ)"
  },
  {
   value: "Erdenet (MNERT)",
   label: "Erdenet (MNERT)"
  },
  {
   value: "Kharkhorin (MNKHR)",
   label: "Kharkhorin (MNKHR)"
  },
  {
   value: "Khovd (MNHVD)",
   label: "Khovd (MNHVD)"
  },
  {
   value: "Khujirt (MNHJT)",
   label: "Khujirt (MNHJT)"
  },
  {
   value: "Mandalgobi (MNMXW)",
   label: "Mandalgobi (MNMXW)"
  },
  {
   value: "Moron (MNMXV)",
   label: "Moron (MNMXV)"
  },
  {
   value: "Tsetserleg (MNTSZ)",
   label: "Tsetserleg (MNTSZ)"
  },
  {
   value: "Ulaanbaatar (MNULN)",
   label: "Ulaanbaatar (MNULN)"
  },
  {
   value: "Ulaangom (MNULO)",
   label: "Ulaangom (MNULO)"
  },
  {
   value: "Ulgit (MNULG)",
   label: "Ulgit (MNULG)"
  },
  {
   value: "Uliastai (MNULZ)",
   label: "Uliastai (MNULZ)"
  },
  {
   value: "Underkhaan (MNUNR)",
   label: "Underkhaan (MNUNR)"
  },
  {
   value: "Macau (MOFMM)",
   label: "Macau (MOFMM)"
  },
  {
   value: "Rota (MPROP)",
   label: "Rota (MPROP)"
  },
  {
   value: "Saipan (MPSPN)",
   label: "Saipan (MPSPN)"
  },
  {
   value: "Tinian (MPTIQ)",
   label: "Tinian (MPTIQ)"
  },
  {
   value: "Fort-de-France (MQFDF)",
   label: "Fort-de-France (MQFDF)"
  },
  {
   value: "St Pierre (MQSPI)",
   label: "St Pierre (MQSPI)"
  },
  {
   value: "Aioun el Atrouss (MRAEO)",
   label: "Aioun el Atrouss (MRAEO)"
  },
  {
   value: "Akjoujt (MRAJJ)",
   label: "Akjoujt (MRAJJ)"
  },
  {
   value: "Aleg (MRLEG)",
   label: "Aleg (MRLEG)"
  },
  {
   value: "Atar (MRATR)",
   label: "Atar (MRATR)"
  },
  {
   value: "Boghe (MRBGH)",
   label: "Boghe (MRBGH)"
  },
  {
   value: "Boutilimit (MROTL)",
   label: "Boutilimit (MROTL)"
  },
  {
   value: "Akyab (Sittwe) (MMAKY)",
   label: "Akyab (Sittwe) (MMAKY)"
  },
  {
   value: "Bagan (MMBPE)",
   label: "Bagan (MMBPE)"
  },
  {
   value: "Bassein (MMBSX)",
   label: "Bassein (MMBSX)"
  },
  {
   value: "Bhamo (MMBMO)",
   label: "Bhamo (MMBMO)"
  },
  {
   value: "Bilin (MMBIL)",
   label: "Bilin (MMBIL)"
  },
  {
   value: "Bogale (MMBOG)",
   label: "Bogale (MMBOG)"
  },
  {
   value: "Dawe (MMTVY)",
   label: "Dawe (MMTVY)"
  },
  {
   value: "Gangaw (MMGAW)",
   label: "Gangaw (MMGAW)"
  },
  {
   value: "Gwa (MMGWA)",
   label: "Gwa (MMGWA)"
  },
  {
   value: "Heho (MMHEN)",
   label: "Heho (MMHEN)"
  },
  {
   value: "Henzada (MMHEB)",
   label: "Henzada (MMHEB)"
  },
  {
   value: "Homalin (MMHOX)",
   label: "Homalin (MMHOX)"
  },
  {
   value: "Insein (MMINS)",
   label: "Insein (MMINS)"
  },
  {
   value: "Kalemyo (MMKMV)",
   label: "Kalemyo (MMKMV)"
  },
  {
   value: "Kawthaung (MMKAW)",
   label: "Kawthaung (MMKAW)"
  },
  {
   value: "Keng Tung (MMKET)",
   label: "Keng Tung (MMKET)"
  },
  {
   value: "Khamti (MMKHM)",
   label: "Khamti (MMKHM)"
  },
  {
   value: "Kyaikiat (MMKYA)",
   label: "Kyaikiat (MMKYA)"
  },
  {
   value: "Kyaukpyu (MMKYP)",
   label: "Kyaukpyu (MMKYP)"
  },
  {
   value: "Kyauktaw (MMKYT)",
   label: "Kyauktaw (MMKYT)"
  },
  {
   value: "Lashio (MMLSH)",
   label: "Lashio (MMLSH)"
  },
  {
   value: "Loikaw (MMLIW)",
   label: "Loikaw (MMLIW)"
  },
  {
   value: "Magwe (MMMWQ)",
   label: "Magwe (MMMWQ)"
  },
  {
   value: "Manaung (MMMGU)",
   label: "Manaung (MMMGU)"
  },
  {
   value: "Mandalay (MMMDL)",
   label: "Mandalay (MMMDL)"
  },
  {
   value: "Martaban (MMMAR)",
   label: "Martaban (MMMAR)"
  },
  {
   value: "Mawlamyine (Moulmein) (MMMNU)",
   label: "Mawlamyine (Moulmein) (MMMNU)"
  },
  {
   value: "Mergui (MMMER)",
   label: "Mergui (MMMER)"
  },
  {
   value: "Momeik (MMMOE)",
   label: "Momeik (MMMOE)"
  },
  {
   value: "Mong Hsat (MMMOG)",
   label: "Mong Hsat (MMMOG)"
  },
  {
   value: "Mong Ton (MMMGK)",
   label: "Mong Ton (MMMGK)"
  },
  {
   value: "Murdon (MMMUR)",
   label: "Murdon (MMMUR)"
  },
  {
   value: "Myeik (MMMGZ)",
   label: "Myeik (MMMGZ)"
  },
  {
   value: "Myitkyina (MMMYT)",
   label: "Myitkyina (MMMYT)"
  },
  {
   value: "Namsang (MMNMS)",
   label: "Namsang (MMNMS)"
  },
  {
   value: "Namtu (MMNMT)",
   label: "Namtu (MMNMT)"
  },
  {
   value: "Nyaung-U (MMNYU)",
   label: "Nyaung-U (MMNYU)"
  },
  {
   value: "Pa-An (MMPAA)",
   label: "Pa-An (MMPAA)"
  },
  {
   value: "Pakokku (MMPKK)",
   label: "Pakokku (MMPKK)"
  },
  {
   value: "Papun (MMPPU)",
   label: "Papun (MMPPU)"
  },
  {
   value: "Pauk (MMPAU)",
   label: "Pauk (MMPAU)"
  },
  {
   value: "Pegu (MMPEG)",
   label: "Pegu (MMPEG)"
  },
  {
   value: "Putao (MMPBU)",
   label: "Putao (MMPBU)"
  },
  {
   value: "Gevgelia (MKGVL)",
   label: "Gevgelia (MKGVL)"
  },
  {
   value: "Gostivar (MKGST)",
   label: "Gostivar (MKGST)"
  },
  {
   value: "Jacince (MKJNC)",
   label: "Jacince (MKJNC)"
  },
  {
   value: "Kafasan (MKKFN)",
   label: "Kafasan (MKKFN)"
  },
  {
   value: "Kavadarci (MKKVD)",
   label: "Kavadarci (MKKVD)"
  },
  {
   value: "Kicevo (MKKCV)",
   label: "Kicevo (MKKCV)"
  },
  {
   value: "Kumanovo (MKKUM)",
   label: "Kumanovo (MKKUM)"
  },
  {
   value: "Medzitilija (MKMTL)",
   label: "Medzitilija (MKMTL)"
  },
  {
   value: "Negotino (MKNGT)",
   label: "Negotino (MKNGT)"
  },
  {
   value: "Novo Selo (MKNSL)",
   label: "Novo Selo (MKNSL)"
  },
  {
   value: "Ohrid (MKOHD)",
   label: "Ohrid (MKOHD)"
  },
  {
   value: "Pelince (MKPLN)",
   label: "Pelince (MKPLN)"
  },
  {
   value: "Petrovec (MKPTR)",
   label: "Petrovec (MKPTR)"
  },
  {
   value: "Prilep (MKPLP)",
   label: "Prilep (MKPLP)"
  },
  {
   value: "Resen (MKRSN)",
   label: "Resen (MKRSN)"
  },
  {
   value: "Skopje (MKSKP)",
   label: "Skopje (MKSKP)"
  },
  {
   value: "Sopot (MKSPT)",
   label: "Sopot (MKSPT)"
  },
  {
   value: "Star Dojran (MKSDR)",
   label: "Star Dojran (MKSDR)"
  },
  {
   value: "Stenje (MKSTE)",
   label: "Stenje (MKSTE)"
  },
  {
   value: "Stip (MKSTP)",
   label: "Stip (MKSTP)"
  },
  {
   value: "Struga (MKSTG)",
   label: "Struga (MKSTG)"
  },
  {
   value: "Strumica (MKSTM)",
   label: "Strumica (MKSTM)"
  },
  {
   value: "Sveti Naum (MKSTN)",
   label: "Sveti Naum (MKSTN)"
  },
  {
   value: "Tabanovce (MKTBN)",
   label: "Tabanovce (MKTBN)"
  },
  {
   value: "Tetovo (MKTEV)",
   label: "Tetovo (MKTEV)"
  },
  {
   value: "Trubarevo (MKTBR)",
   label: "Trubarevo (MKTBR)"
  },
  {
   value: "Veles (MKVLS)",
   label: "Veles (MKVLS)"
  },
  {
   value: "Volkovo (MKVLK)",
   label: "Volkovo (MKVLK)"
  },
  {
   value: "Bamako (MLBKO)",
   label: "Bamako (MLBKO)"
  },
  {
   value: "Bla (MLBLA)",
   label: "Bla (MLBLA)"
  },
  {
   value: "Bougoni (MLBGI)",
   label: "Bougoni (MLBGI)"
  },
  {
   value: "Fana (MLFAN)",
   label: "Fana (MLFAN)"
  },
  {
   value: "Gao (MLGAQ)",
   label: "Gao (MLGAQ)"
  },
  {
   value: "Kayes (MLKYS)",
   label: "Kayes (MLKYS)"
  },
  {
   value: "Kemparana (MLKPR)",
   label: "Kemparana (MLKPR)"
  },
  {
   value: "Kita (MLKIT)",
   label: "Kita (MLKIT)"
  },
  {
   value: "Koulikoro (MLIKO)",
   label: "Koulikoro (MLIKO)"
  },
  {
   value: "Koutiala (MLKTX)",
   label: "Koutiala (MLKTX)"
  },
  {
   value: "Mopti (MLMZI)",
   label: "Mopti (MLMZI)"
  },
  {
   value: "Nara (MLNRM)",
   label: "Nara (MLNRM)"
  },
  {
   value: "Nioro (MLNIX)",
   label: "Nioro (MLNIX)"
  },
  {
   value: "Ouolossébougou (MLOLB)",
   label: "Ouolossébougou (MLOLB)"
  },
  {
   value: "Segou (MLSZU)",
   label: "Segou (MLSZU)"
  },
  {
   value: "MAHANA (MLMAH)",
   label: "MAHANA (MLMAH)"
  },
  {
   value: "Sainte Marie (MGSMS)",
   label: "Sainte Marie (MGSMS)"
  },
  {
   value: "Sambava (MGSVB)",
   label: "Sambava (MGSVB)"
  },
  {
   value: "Soalala (MGDWB)",
   label: "Soalala (MGDWB)"
  },
  {
   value: "Tamatave (Toamasina) (MGTMM)",
   label: "Tamatave (Toamasina) (MGTMM)"
  },
  {
   value: "Tambohorano (MGWTA)",
   label: "Tambohorano (MGWTA)"
  },
  {
   value: "Tanandava (MGTDV)",
   label: "Tanandava (MGTDV)"
  },
  {
   value: "Toamasina (MGTOA)",
   label: "Toamasina (MGTOA)"
  },
  {
   value: "Tsaratanana (MGTTS)",
   label: "Tsaratanana (MGTTS)"
  },
  {
   value: "Tsiroanomandidy (MGWTS)",
   label: "Tsiroanomandidy (MGWTS)"
  },
  {
   value: "Tulear (Toliara) (MGTLE)",
   label: "Tulear (Toliara) (MGTLE)"
  },
  {
   value: "Vangaindrano (MGVND)",
   label: "Vangaindrano (MGVND)"
  },
  {
   value: "Vatomandry (MGVAT)",
   label: "Vatomandry (MGVAT)"
  },
  {
   value: "Vehiperro (MGVEH)",
   label: "Vehiperro (MGVEH)"
  },
  {
   value: "Vohemar (MGVOH)",
   label: "Vohemar (MGVOH)"
  },
  {
   value: "Kwajalein (MHKWA)",
   label: "Kwajalein (MHKWA)"
  },
  {
   value: "Lae Island (MHLML)",
   label: "Lae Island (MHLML)"
  },
  {
   value: "Likiep Island (MHLIK)",
   label: "Likiep Island (MHLIK)"
  },
  {
   value: "Loen (MHLOF)",
   label: "Loen (MHLOF)"
  },
  {
   value: "Majkin (MHMJE)",
   label: "Majkin (MHMJE)"
  },
  {
   value: "Majuro (MHMAJ)",
   label: "Majuro (MHMAJ)"
  },
  {
   value: "Maloelap Island (MHMAV)",
   label: "Maloelap Island (MHMAV)"
  },
  {
   value: "Mejit Island (MHMJB)",
   label: "Mejit Island (MHMJB)"
  },
  {
   value: "Mili Island (MHMIJ)",
   label: "Mili Island (MHMIJ)"
  },
  {
   value: "Namdrik Island (MHNDK)",
   label: "Namdrik Island (MHNDK)"
  },
  {
   value: "Namu (MHNMU)",
   label: "Namu (MHNMU)"
  },
  {
   value: "Rongelap Island (MHRNP)",
   label: "Rongelap Island (MHRNP)"
  },
  {
   value: "Tabal (MHTBV)",
   label: "Tabal (MHTBV)"
  },
  {
   value: "Taroa (MHTAR)",
   label: "Taroa (MHTAR)"
  },
  {
   value: "Tinak Island (MHTIC)",
   label: "Tinak Island (MHTIC)"
  },
  {
   value: "Ujae Island (MHUJE)",
   label: "Ujae Island (MHUJE)"
  },
  {
   value: "Utirik Island (MHUTK)",
   label: "Utirik Island (MHUTK)"
  },
  {
   value: "Woja (MHWJA)",
   label: "Woja (MHWJA)"
  },
  {
   value: "Wotho Island (MHWTO)",
   label: "Wotho Island (MHWTO)"
  },
  {
   value: "Wotje Island (MHWTE)",
   label: "Wotje Island (MHWTE)"
  },
  {
   value: "Berovo (MKBRV)",
   label: "Berovo (MKBRV)"
  },
  {
   value: "Bitola (MKBTL)",
   label: "Bitola (MKBTL)"
  },
  {
   value: "Blace (MKBLC)",
   label: "Blace (MKBLC)"
  },
  {
   value: "Blato (MKBLT)",
   label: "Blato (MKBLT)"
  },
  {
   value: "Bogorodica (MKBRD)",
   label: "Bogorodica (MKBRD)"
  },
  {
   value: "Delcevo (MKDLV)",
   label: "Delcevo (MKDLV)"
  },
  {
   value: "Deve Bair (MKDVB)",
   label: "Deve Bair (MKDVB)"
  },
  {
   value: "Bealanana (MGWBE)",
   label: "Bealanana (MGWBE)"
  },
  {
   value: "Befandriana (MGWBD)",
   label: "Befandriana (MGWBD)"
  },
  {
   value: "Bekily (MGOVA)",
   label: "Bekily (MGOVA)"
  },
  {
   value: "Belo (MGBMD)",
   label: "Belo (MGBMD)"
  },
  {
   value: "Beroroha (MGWBO)",
   label: "Beroroha (MGWBO)"
  },
  {
   value: "Besakoa (MGBSV)",
   label: "Besakoa (MGBSV)"
  },
  {
   value: "Besalampy (MGBPY)",
   label: "Besalampy (MGBPY)"
  },
  {
   value: "Betioky (MGBKU)",
   label: "Betioky (MGBKU)"
  },
  {
   value: "Brickaville (MGBIK)",
   label: "Brickaville (MGBIK)"
  },
  {
   value: "Doany (MGDOA)",
   label: "Doany (MGDOA)"
  },
  {
   value: "Farafangana (MGRVA)",
   label: "Farafangana (MGRVA)"
  },
  {
   value: "Fianarantsoa (MGWFI)",
   label: "Fianarantsoa (MGWFI)"
  },
  {
   value: "Fort Dauphin (Toalagnaro) (MGFTU)",
   label: "Fort Dauphin (Toalagnaro) (MGFTU)"
  },
  {
   value: "Hell-Ville (MGHLV)",
   label: "Hell-Ville (MGHLV)"
  },
  {
   value: "Ihosy (MGIHO)",
   label: "Ihosy (MGIHO)"
  },
  {
   value: "Ilaka (MGILK)",
   label: "Ilaka (MGILK)"
  },
  {
   value: "Madirovalo (MGWMV)",
   label: "Madirovalo (MGWMV)"
  },
  {
   value: "Mahanoro (MGVVB)",
   label: "Mahanoro (MGVVB)"
  },
  {
   value: "Maintirano (MGMXT)",
   label: "Maintirano (MGMXT)"
  },
  {
   value: "Majunga (Mahajanga) (MGMJN)",
   label: "Majunga (Mahajanga) (MGMJN)"
  },
  {
   value: "Malaimbandy (MGWML)",
   label: "Malaimbandy (MGWML)"
  },
  {
   value: "Mampikony (MGWMP)",
   label: "Mampikony (MGWMP)"
  },
  {
   value: "Manakara (MGWVK)",
   label: "Manakara (MGWVK)"
  },
  {
   value: "Mananara (MGWMR)",
   label: "Mananara (MGWMR)"
  },
  {
   value: "Mananjary (MGMNJ)",
   label: "Mananjary (MGMNJ)"
  },
  {
   value: "Mandabe (MGWMD)",
   label: "Mandabe (MGWMD)"
  },
  {
   value: "Mandritsara (MGWMA)",
   label: "Mandritsara (MGWMA)"
  },
  {
   value: "Manja (MGMJA)",
   label: "Manja (MGMJA)"
  },
  {
   value: "Manombo (MGMOB)",
   label: "Manombo (MGMOB)"
  },
  {
   value: "Maroantsetra (MGWMN)",
   label: "Maroantsetra (MGWMN)"
  },
  {
   value: "Miandrivazo (MGZVA)",
   label: "Miandrivazo (MGZVA)"
  },
  {
   value: "Morafenobe (MGTVA)",
   label: "Morafenobe (MGTVA)"
  },
  {
   value: "Morombe (MGMXM)",
   label: "Morombe (MGMXM)"
  },
  {
   value: "Morondava (MGMOQ)",
   label: "Morondava (MGMOQ)"
  },
  {
   value: "Mutsamudo (MGMWD)",
   label: "Mutsamudo (MGMWD)"
  },
  {
   value: "Nossi-Be (MGNOS)",
   label: "Nossi-Be (MGNOS)"
  },
  {
   value: "Nosy-Varika (MGNOV)",
   label: "Nosy-Varika (MGNOV)"
  },
  {
   value: "Port Berge (Vaovao) (MGWPB)",
   label: "Port Berge (Vaovao) (MGWPB)"
  },
  {
   value: "Port Saint Louis (MGPSL)",
   label: "Port Saint Louis (MGPSL)"
  },
  {
   value: "Oujda (MAOUD)",
   label: "Oujda (MAOUD)"
  },
  {
   value: "Rabat (MARBA)",
   label: "Rabat (MARBA)"
  },
  {
   value: "Safi (MASFI)",
   label: "Safi (MASFI)"
  },
  {
   value: "Sale (MASAL)",
   label: "Sale (MASAL)"
  },
  {
   value: "Settat (MASET)",
   label: "Settat (MASET)"
  },
  {
   value: "Sidi Ifni (MASII)",
   label: "Sidi Ifni (MASII)"
  },
  {
   value: "Sidi Kacem (MASIK)",
   label: "Sidi Kacem (MASIK)"
  },
  {
   value: "Smara (MASMW)",
   label: "Smara (MASMW)"
  },
  {
   value: "Tan Tan (MATTA)",
   label: "Tan Tan (MATTA)"
  },
  {
   value: "Tangier (MATNG)",
   label: "Tangier (MATNG)"
  },
  {
   value: "Tarfaya (MATFY)",
   label: "Tarfaya (MATFY)"
  },
  {
   value: "Taroudannt (MATAR)",
   label: "Taroudannt (MATAR)"
  },
  {
   value: "Taza (MATAZ)",
   label: "Taza (MATAZ)"
  },
  {
   value: "Tetuan (MATTU)",
   label: "Tetuan (MATTU)"
  },
  {
   value: "Monaco (MCMON)",
   label: "Monaco (MCMON)"
  },
  {
   value: "Monte Carlo (MCMCM)",
   label: "Monte Carlo (MCMCM)"
  },
  {
   value: "Balti (Bel'cy) (MDBEL)",
   label: "Balti (Bel'cy) (MDBEL)"
  },
  {
   value: "Berestovitsa (MDBRS)",
   label: "Berestovitsa (MDBRS)"
  },
  {
   value: "Kishinev (MDKIV)",
   label: "Kishinev (MDKIV)"
  },
  {
   value: "Ungeny (MDUNG)",
   label: "Ungeny (MDUNG)"
  },
  {
   value: "Ambanja \/ IVATO (MGIVA)",
   label: "Ambanja \/ IVATO (MGIVA)"
  },
  {
   value: "Ambatolahy (MGAHY)",
   label: "Ambatolahy (MGAHY)"
  },
  {
   value: "Ambatomainty (MGAMY)",
   label: "Ambatomainty (MGAMY)"
  },
  {
   value: "Ambatondrazaka (MGWAM)",
   label: "Ambatondrazaka (MGWAM)"
  },
  {
   value: "Ambilobe (MGAMB)",
   label: "Ambilobe (MGAMB)"
  },
  {
   value: "Ampanihy (MGAMP)",
   label: "Ampanihy (MGAMP)"
  },
  {
   value: "Analalava (MGHVA)",
   label: "Analalava (MGHVA)"
  },
  {
   value: "Andapa (MGZWA)",
   label: "Andapa (MGZWA)"
  },
  {
   value: "Andriamena (MGWAD)",
   label: "Andriamena (MGWAD)"
  },
  {
   value: "Androka (MGADK)",
   label: "Androka (MGADK)"
  },
  {
   value: "Ankavandra (MGJVA)",
   label: "Ankavandra (MGJVA)"
  },
  {
   value: "Ankazoabo (MGWAK)",
   label: "Ankazoabo (MGWAK)"
  },
  {
   value: "Ankorefo (MGWOR)",
   label: "Ankorefo (MGWOR)"
  },
  {
   value: "Antalaha (MGANM)",
   label: "Antalaha (MGANM)"
  },
  {
   value: "Antananarivo (MGTNR)",
   label: "Antananarivo (MGTNR)"
  },
  {
   value: "Antsalova (MGWAQ)",
   label: "Antsalova (MGWAQ)"
  },
  {
   value: "Antsirabe (MGATJ)",
   label: "Antsirabe (MGATJ)"
  },
  {
   value: "Antsiranana (MGDIE)",
   label: "Antsiranana (MGDIE)"
  },
  {
   value: "Antsohihy (MGWAI)",
   label: "Antsohihy (MGWAI)"
  },
  {
   value: "Barren Islands (MGBRR)",
   label: "Barren Islands (MGBRR)"
  },
  {
   value: "Tukrah (LYTUK)",
   label: "Tukrah (LYTUK)"
  },
  {
   value: "Zawia Terminal (Azzawiya) (LYZAW)",
   label: "Zawia Terminal (Azzawiya) (LYZAW)"
  },
  {
   value: "Zliten (LYZLI)",
   label: "Zliten (LYZLI)"
  },
  {
   value: "Zuara (LYZUA)",
   label: "Zuara (LYZUA)"
  },
  {
   value: "Zueitina (LYZUE)",
   label: "Zueitina (LYZUE)"
  },
  {
   value: "Zwara (LYWAX)",
   label: "Zwara (LYWAX)"
  },
  {
   value: "Agadir (MAAGA)",
   label: "Agadir (MAAGA)"
  },
  {
   value: "Al Hoceima (MAAHU)",
   label: "Al Hoceima (MAAHU)"
  },
  {
   value: "Asilah (MAASI)",
   label: "Asilah (MAASI)"
  },
  {
   value: "Azemmour (MAAZE)",
   label: "Azemmour (MAAZE)"
  },
  {
   value: "Azrou (MAAZR)",
   label: "Azrou (MAAZR)"
  },
  {
   value: "Bengherir (MABEN)",
   label: "Bengherir (MABEN)"
  },
  {
   value: "Beni Mellal (MABEM)",
   label: "Beni Mellal (MABEM)"
  },
  {
   value: "Berkane (MABER)",
   label: "Berkane (MABER)"
  },
  {
   value: "Berrechid (MABED)",
   label: "Berrechid (MABED)"
  },
  {
   value: "Bouznika (MABOU)",
   label: "Bouznika (MABOU)"
  },
  {
   value: "Breich (MABRE)",
   label: "Breich (MABRE)"
  },
  {
   value: "Casablanca (MACAS)",
   label: "Casablanca (MACAS)"
  },
  {
   value: "Dakhla (MAVIL)",
   label: "Dakhla (MAVIL)"
  },
  {
   value: "El Jadida (MAELJ)",
   label: "El Jadida (MAELJ)"
  },
  {
   value: "Errachidia (MAERH)",
   label: "Errachidia (MAERH)"
  },
  {
   value: "Essaouira (MAESS)",
   label: "Essaouira (MAESS)"
  },
  {
   value: "Fez (MAFEZ)",
   label: "Fez (MAFEZ)"
  },
  {
   value: "Goulimime (MAGLN)",
   label: "Goulimime (MAGLN)"
  },
  {
   value: "Jorf Lasfar (MAJFL)",
   label: "Jorf Lasfar (MAJFL)"
  },
  {
   value: "Kasba Tadla (MAKAT)",
   label: "Kasba Tadla (MAKAT)"
  },
  {
   value: "Kenitra (Ex Port Lyautey) (MANNA)",
   label: "Kenitra (Ex Port Lyautey) (MANNA)"
  },
  {
   value: "Khemisset (MAKHE)",
   label: "Khemisset (MAKHE)"
  },
  {
   value: "Khouribga (MAKHA)",
   label: "Khouribga (MAKHA)"
  },
  {
   value: "Ksar Es Souk (MASEK)",
   label: "Ksar Es Souk (MASEK)"
  },
  {
   value: "Laayoune (El Aaiun) (MAEUN)",
   label: "Laayoune (El Aaiun) (MAEUN)"
  },
  {
   value: "Larache (MALAR)",
   label: "Larache (MALAR)"
  },
  {
   value: "Marrakach (MARAK)",
   label: "Marrakach (MARAK)"
  },
  {
   value: "Mazagan (MAMAZ)",
   label: "Mazagan (MAMAZ)"
  },
  {
   value: "Meknes (MAMEK)",
   label: "Meknes (MAMEK)"
  },
  {
   value: "Mogador (MAMOG)",
   label: "Mogador (MAMOG)"
  },
  {
   value: "Mohammedia (MAMOH)",
   label: "Mohammedia (MAMOH)"
  },
  {
   value: "Nador (MANDR)",
   label: "Nador (MANDR)"
  },
  {
   value: "Nouasseur (MANOU)",
   label: "Nouasseur (MANOU)"
  },
  {
   value: "Ouarzazate (MAOZZ)",
   label: "Ouarzazate (MAOZZ)"
  },
  {
   value: "Steinfort (LUSKK)",
   label: "Steinfort (LUSKK)"
  },
  {
   value: "Steinsel (LUSTE)",
   label: "Steinsel (LUSTE)"
  },
  {
   value: "Troisvierges (LUTRO)",
   label: "Troisvierges (LUTRO)"
  },
  {
   value: "Vianden (LUVIA)",
   label: "Vianden (LUVIA)"
  },
  {
   value: "Wiltz (LUWIL)",
   label: "Wiltz (LUWIL)"
  },
  {
   value: "Daugavpils (LVDGP)",
   label: "Daugavpils (LVDGP)"
  },
  {
   value: "Liepaya (LVLPX)",
   label: "Liepaya (LVLPX)"
  },
  {
   value: "Riga (LVRIX)",
   label: "Riga (LVRIX)"
  },
  {
   value: "Ventspils (LVVNT)",
   label: "Ventspils (LVVNT)"
  },
  {
   value: "Abu Kammash (LYABK)",
   label: "Abu Kammash (LYABK)"
  },
  {
   value: "Al Bayda (LYABA)",
   label: "Al Bayda (LYABA)"
  },
  {
   value: "Al Khofra (Kufra) (LYAKF)",
   label: "Al Khofra (Kufra) (LYAKF)"
  },
  {
   value: "Apollonia (LYAPO)",
   label: "Apollonia (LYAPO)"
  },
  {
   value: "Beida (LYLAQ)",
   label: "Beida (LYLAQ)"
  },
  {
   value: "Bingazi (Benghazi) (LYBEN)",
   label: "Bingazi (Benghazi) (LYBEN)"
  },
  {
   value: "Brack (LYBCQ)",
   label: "Brack (LYBCQ)"
  },
  {
   value: "Buert El Hsun (LYBUA)",
   label: "Buert El Hsun (LYBUA)"
  },
  {
   value: "Darnah (LYDRX)",
   label: "Darnah (LYDRX)"
  },
  {
   value: "Derna (LYDNF)",
   label: "Derna (LYDNF)"
  },
  {
   value: "El Bardia (LYBAR)",
   label: "El Bardia (LYBAR)"
  },
  {
   value: "El Bouri (LYBOU)",
   label: "El Bouri (LYBOU)"
  },
  {
   value: "Es Sider (LYESI)",
   label: "Es Sider (LYESI)"
  },
  {
   value: "Ghadames (LYLTD)",
   label: "Ghadames (LYLTD)"
  },
  {
   value: "Ghat (LYGHT)",
   label: "Ghat (LYGHT)"
  },
  {
   value: "Khoms (LYKHO)",
   label: "Khoms (LYKHO)"
  },
  {
   value: "Marsa Brega (LYLMQ)",
   label: "Marsa Brega (LYLMQ)"
  },
  {
   value: "Marsa El Hania (LYMEH)",
   label: "Marsa El Hania (LYMEH)"
  },
  {
   value: "Marsa el Hariga (LYMHR)",
   label: "Marsa el Hariga (LYMHR)"
  },
  {
   value: "Misurata (LYMRA)",
   label: "Misurata (LYMRA)"
  },
  {
   value: "Mitiga (LYMJI)",
   label: "Mitiga (LYMJI)"
  },
  {
   value: "Nafoora (LYNFR)",
   label: "Nafoora (LYNFR)"
  },
  {
   value: "Ras el Hilal (LYREH)",
   label: "Ras el Hilal (LYREH)"
  },
  {
   value: "Ras Lanuf (LYRLA)",
   label: "Ras Lanuf (LYRLA)"
  },
  {
   value: "Sebha (LYSEB)",
   label: "Sebha (LYSEB)"
  },
  {
   value: "Sert (LYSRX)",
   label: "Sert (LYSRX)"
  },
  {
   value: "Sirte (Surt) (LYSRT)",
   label: "Sirte (Surt) (LYSRT)"
  },
  {
   value: "Soussah (LYSOU)",
   label: "Soussah (LYSOU)"
  },
  {
   value: "Tagiura (LYTAG)",
   label: "Tagiura (LYTAG)"
  },
  {
   value: "Tobruk (LYTOB)",
   label: "Tobruk (LYTOB)"
  },
  {
   value: "Toulmeitha (LYTOA)",
   label: "Toulmeitha (LYTOA)"
  },
  {
   value: "Tripoli (LYTIP)",
   label: "Tripoli (LYTIP)"
  },
  {
   value: "Qachas Nek (LSUNE)",
   label: "Qachas Nek (LSUNE)"
  },
  {
   value: "Quthing (LSUTG)",
   label: "Quthing (LSUTG)"
  },
  {
   value: "Sehonghong (LSSHK)",
   label: "Sehonghong (LSSHK)"
  },
  {
   value: "Sekakes (LSSKQ)",
   label: "Sekakes (LSSKQ)"
  },
  {
   value: "Semongkong (LSSOK)",
   label: "Semongkong (LSSOK)"
  },
  {
   value: "Seshutes (LSSHZ)",
   label: "Seshutes (LSSHZ)"
  },
  {
   value: "Thaba-Tseka (LSTHB)",
   label: "Thaba-Tseka (LSTHB)"
  },
  {
   value: "Tlokoeng (LSTKO)",
   label: "Tlokoeng (LSTKO)"
  },
  {
   value: "Birzai (LTBRZ)",
   label: "Birzai (LTBRZ)"
  },
  {
   value: "Kaltene (LTKLT)",
   label: "Kaltene (LTKLT)"
  },
  {
   value: "Kaunas (LTKUN)",
   label: "Kaunas (LTKUN)"
  },
  {
   value: "Klaipeda (LTKLJ)",
   label: "Klaipeda (LTKLJ)"
  },
  {
   value: "Liepaja (LTLIE)",
   label: "Liepaja (LTLIE)"
  },
  {
   value: "Mamonova (LTMMO)",
   label: "Mamonova (LTMMO)"
  },
  {
   value: "Marijampole (LTMJP)",
   label: "Marijampole (LTMJP)"
  },
  {
   value: "Naujamiestis (LTNJM)",
   label: "Naujamiestis (LTNJM)"
  },
  {
   value: "Palanga (LTPLQ)",
   label: "Palanga (LTPLQ)"
  },
  {
   value: "Panevezys (LTPNV)",
   label: "Panevezys (LTPNV)"
  },
  {
   value: "Rumiskies (LTRUM)",
   label: "Rumiskies (LTRUM)"
  },
  {
   value: "Shauliaj (LTHLJ)",
   label: "Shauliaj (LTHLJ)"
  },
  {
   value: "Siauliai (LTSQQ)",
   label: "Siauliai (LTSQQ)"
  },
  {
   value: "Vilnius (LTVNO)",
   label: "Vilnius (LTVNO)"
  },
  {
   value: "Bettembourg (LUBET)",
   label: "Bettembourg (LUBET)"
  },
  {
   value: "Bissen (LUBSN)",
   label: "Bissen (LUBSN)"
  },
  {
   value: "Capellen (LUCPL)",
   label: "Capellen (LUCPL)"
  },
  {
   value: "Clervaux (LUCEL)",
   label: "Clervaux (LUCEL)"
  },
  {
   value: "Colmarberg (LUCOL)",
   label: "Colmarberg (LUCOL)"
  },
  {
   value: "Contern (LUCTN)",
   label: "Contern (LUCTN)"
  },
  {
   value: "Diekirch (LUDIE)",
   label: "Diekirch (LUDIE)"
  },
  {
   value: "Dudelange (LUDUD)",
   label: "Dudelange (LUDUD)"
  },
  {
   value: "Echternach (LUECH)",
   label: "Echternach (LUECH)"
  },
  {
   value: "Erpeldange (LUEDE)",
   label: "Erpeldange (LUEDE)"
  },
  {
   value: "Ettelbruck (LUETT)",
   label: "Ettelbruck (LUETT)"
  },
  {
   value: "Helmsange (LUHSG)",
   label: "Helmsange (LUHSG)"
  },
  {
   value: "Hosingen (LUHOS)",
   label: "Hosingen (LUHOS)"
  },
  {
   value: "Leudelange (LULDL)",
   label: "Leudelange (LULDL)"
  },
  {
   value: "Luxembourg (LULUX)",
   label: "Luxembourg (LULUX)"
  },
  {
   value: "Mosingen (LUMOS)",
   label: "Mosingen (LUMOS)"
  },
  {
   value: "Niedercorn (LUNDC)",
   label: "Niedercorn (LUNDC)"
  },
  {
   value: "Rodange (LUROD)",
   label: "Rodange (LUROD)"
  },
  {
   value: "Sanem (LUSAN)",
   label: "Sanem (LUSAN)"
  },
  {
   value: "Point Pedro (LKPPE)",
   label: "Point Pedro (LKPPE)"
  },
  {
   value: "Pulmoddai (LKPUL)",
   label: "Pulmoddai (LKPUL)"
  },
  {
   value: "Ratmalana Apt-Colombo (LKRML)",
   label: "Ratmalana Apt-Colombo (LKRML)"
  },
  {
   value: "Talaimannar (LKTAL)",
   label: "Talaimannar (LKTAL)"
  },
  {
   value: "Trincomalee (LKTRR)",
   label: "Trincomalee (LKTRR)"
  },
  {
   value: "KATUNAYAKE (LKKAT)",
   label: "KATUNAYAKE (LKKAT)"
  },
  {
   value: "Bella Yella (LRBYL)",
   label: "Bella Yella (LRBYL)"
  },
  {
   value: "Buchanan (LRUCN)",
   label: "Buchanan (LRUCN)"
  },
  {
   value: "Cape Mount (LRCMT)",
   label: "Cape Mount (LRCMT)"
  },
  {
   value: "Cape Palmas (LRCPA)",
   label: "Cape Palmas (LRCPA)"
  },
  {
   value: "Fimibo (LRFIM)",
   label: "Fimibo (LRFIM)"
  },
  {
   value: "Foya (LRFOY)",
   label: "Foya (LRFOY)"
  },
  {
   value: "Grand Bassa (LRGBS)",
   label: "Grand Bassa (LRGBS)"
  },
  {
   value: "Grand Cess (LRGRC)",
   label: "Grand Cess (LRGRC)"
  },
  {
   value: "Greenville (LRGRE)",
   label: "Greenville (LRGRE)"
  },
  {
   value: "Harbel (LRHBL)",
   label: "Harbel (LRHBL)"
  },
  {
   value: "Harper (LRHAR)",
   label: "Harper (LRHAR)"
  },
  {
   value: "Lower Buchanan (LRLOB)",
   label: "Lower Buchanan (LRLOB)"
  },
  {
   value: "Marshall (LRMAR)",
   label: "Marshall (LRMAR)"
  },
  {
   value: "Monrovia (LRMLW)",
   label: "Monrovia (LRMLW)"
  },
  {
   value: "Nimba (LRNIA)",
   label: "Nimba (LRNIA)"
  },
  {
   value: "Rivercess (LRRVC)",
   label: "Rivercess (LRRVC)"
  },
  {
   value: "Robertsport (LRROX)",
   label: "Robertsport (LRROX)"
  },
  {
   value: "Sarioe Bay (LRSAB)",
   label: "Sarioe Bay (LRSAB)"
  },
  {
   value: "Sasstown (LRSAZ)",
   label: "Sasstown (LRSAZ)"
  },
  {
   value: "Sinoe (LRSNI)",
   label: "Sinoe (LRSNI)"
  },
  {
   value: "Tapeta (LRTPT)",
   label: "Tapeta (LRTPT)"
  },
  {
   value: "Tchien (LRTHC)",
   label: "Tchien (LRTHC)"
  },
  {
   value: "Trade Town (LRTRT)",
   label: "Trade Town (LRTRT)"
  },
  {
   value: "Voinjama (LRVOI)",
   label: "Voinjama (LRVOI)"
  },
  {
   value: "Weasua (LRWES)",
   label: "Weasua (LRWES)"
  },
  {
   value: "Wologissi (LRWOI)",
   label: "Wologissi (LRWOI)"
  },
  {
   value: "Lebakeng (LSLEF)",
   label: "Lebakeng (LSLEF)"
  },
  {
   value: "Leribe (LSLRB)",
   label: "Leribe (LSLRB)"
  },
  {
   value: "Lesobeng (LSLES)",
   label: "Lesobeng (LSLES)"
  },
  {
   value: "Mafeteng (LSMFC)",
   label: "Mafeteng (LSMFC)"
  },
  {
   value: "Maseru (LSMSU)",
   label: "Maseru (LSMSU)"
  },
  {
   value: "Matsaile (LSMSG)",
   label: "Matsaile (LSMSG)"
  },
  {
   value: "Mokhotlong (LSMKH)",
   label: "Mokhotlong (LSMKH)"
  },
  {
   value: "Nkaus (LSNKU)",
   label: "Nkaus (LSNKU)"
  },
  {
   value: "Pelaneng (LSPEL)",
   label: "Pelaneng (LSPEL)"
  },
  {
   value: "Udomxay (LAUDO)",
   label: "Udomxay (LAUDO)"
  },
  {
   value: "Vangrieng (LAVGG)",
   label: "Vangrieng (LAVGG)"
  },
  {
   value: "Vangtoud (LAVAN)",
   label: "Vangtoud (LAVAN)"
  },
  {
   value: "Viengxay (LAVNG)",
   label: "Viengxay (LAVNG)"
  },
  {
   value: "Vientiane (LAVTE)",
   label: "Vientiane (LAVTE)"
  },
  {
   value: "Xayabury (LAXAY)",
   label: "Xayabury (LAXAY)"
  },
  {
   value: "Xieng Khouang (LAXKH)",
   label: "Xieng Khouang (LAXKH)"
  },
  {
   value: "Xienglom (LAXIE)",
   label: "Xienglom (LAXIE)"
  },
  {
   value: "Beirut (LBBEY)",
   label: "Beirut (LBBEY)"
  },
  {
   value: "Chekka (LBCHK)",
   label: "Chekka (LBCHK)"
  },
  {
   value: "Jieh (LBJIE)",
   label: "Jieh (LBJIE)"
  },
  {
   value: "Jounieh (LBQJN)",
   label: "Jounieh (LBQJN)"
  },
  {
   value: "Khalde (LBKHA)",
   label: "Khalde (LBKHA)"
  },
  {
   value: "Ouzai (LBOUZ)",
   label: "Ouzai (LBOUZ)"
  },
  {
   value: "Ras Selata (LBRST)",
   label: "Ras Selata (LBRST)"
  },
  {
   value: "Sayda (LBSAY)",
   label: "Sayda (LBSAY)"
  },
  {
   value: "Selaata (LBSEL)",
   label: "Selaata (LBSEL)"
  },
  {
   value: "Sidon (LBSDN)",
   label: "Sidon (LBSDN)"
  },
  {
   value: "Sur (Tyre) (LBSUR)",
   label: "Sur (Tyre) (LBSUR)"
  },
  {
   value: "Tripoli (LBKYE)",
   label: "Tripoli (LBKYE)"
  },
  {
   value: "Zahrani Terminal (LBZHR)",
   label: "Zahrani Terminal (LBZHR)"
  },
  {
   value: "Cul de Sac (LCCDS)",
   label: "Cul de Sac (LCCDS)"
  },
  {
   value: "St Lucia (Castries) (LCSLU)",
   label: "St Lucia (Castries) (LCSLU)"
  },
  {
   value: "Vieux Fort (LCVIF)",
   label: "Vieux Fort (LCVIF)"
  },
  {
   value: "Triesen (LITES)",
   label: "Triesen (LITES)"
  },
  {
   value: "Anuradhapura (LKADP)",
   label: "Anuradhapura (LKADP)"
  },
  {
   value: "Batticoloa (LKBTC)",
   label: "Batticoloa (LKBTC)"
  },
  {
   value: "Beruwala (LKBRW)",
   label: "Beruwala (LKBRW)"
  },
  {
   value: "Colombo (LKCMB)",
   label: "Colombo (LKCMB)"
  },
  {
   value: "Gal Oya (LKGOY)",
   label: "Gal Oya (LKGOY)"
  },
  {
   value: "Galle (LKGAL)",
   label: "Galle (LKGAL)"
  },
  {
   value: "Hambantota (LKHBA)",
   label: "Hambantota (LKHBA)"
  },
  {
   value: "Jaffna (LKJAF)",
   label: "Jaffna (LKJAF)"
  },
  {
   value: "Kalpitiya (LKKAL)",
   label: "Kalpitiya (LKKAL)"
  },
  {
   value: "Kalutara (LKKLT)",
   label: "Kalutara (LKKLT)"
  },
  {
   value: "Kandy (LKKAN)",
   label: "Kandy (LKKAN)"
  },
  {
   value: "Kankesanturai (LKKNK)",
   label: "Kankesanturai (LKKNK)"
  },
  {
   value: "Kayts (LKKAY)",
   label: "Kayts (LKKAY)"
  },
  {
   value: "Mannar (LKMAN)",
   label: "Mannar (LKMAN)"
  },
  {
   value: "Minneriya (LKMNH)",
   label: "Minneriya (LKMNH)"
  },
  {
   value: "Mulativu (LKMUL)",
   label: "Mulativu (LKMUL)"
  },
  {
   value: "Akhtubinsk (KZAKX)",
   label: "Akhtubinsk (KZAKX)"
  },
  {
   value: "Aktau (KZAAU)",
   label: "Aktau (KZAAU)"
  },
  {
   value: "Almaty (KZALA)",
   label: "Almaty (KZALA)"
  },
  {
   value: "Arkalyk (KZAYK)",
   label: "Arkalyk (KZAYK)"
  },
  {
   value: "Astana (Ex Tselinograd) (KZAST)",
   label: "Astana (Ex Tselinograd) (KZAST)"
  },
  {
   value: "Atbasar (KZATX)",
   label: "Atbasar (KZATX)"
  },
  {
   value: "Atyrau (Ex Guryev) (KZGUW)",
   label: "Atyrau (Ex Guryev) (KZGUW)"
  },
  {
   value: "Balhash (KZBXH)",
   label: "Balhash (KZBXH)"
  },
  {
   value: "Burundai (KZBXJ)",
   label: "Burundai (KZBXJ)"
  },
  {
   value: "Ekibastuz (KZEKB)",
   label: "Ekibastuz (KZEKB)"
  },
  {
   value: "Horgos (KZHOR)",
   label: "Horgos (KZHOR)"
  },
  {
   value: "Karaganda (KZKGF)",
   label: "Karaganda (KZKGF)"
  },
  {
   value: "Kokchetau (KZKOV)",
   label: "Kokchetau (KZKOV)"
  },
  {
   value: "Kordai (KZKOR)",
   label: "Kordai (KZKOR)"
  },
  {
   value: "Kostanay (KZKSN)",
   label: "Kostanay (KZKSN)"
  },
  {
   value: "Kzyl-Orda (KZKZO)",
   label: "Kzyl-Orda (KZKZO)"
  },
  {
   value: "Lisakovsk (KZLKK)",
   label: "Lisakovsk (KZLKK)"
  },
  {
   value: "Shimkent (KZCIT)",
   label: "Shimkent (KZCIT)"
  },
  {
   value: "Taldy-Kurgan (KZTDK)",
   label: "Taldy-Kurgan (KZTDK)"
  },
  {
   value: "Uralsk (KZURA)",
   label: "Uralsk (KZURA)"
  },
  {
   value: "Ust-Kamenogorsk (KZUKK)",
   label: "Ust-Kamenogorsk (KZUKK)"
  },
  {
   value: "Zaisan (KZSZI)",
   label: "Zaisan (KZSZI)"
  },
  {
   value: "Zhairem (KZHRC)",
   label: "Zhairem (KZHRC)"
  },
  {
   value: "Zhambyl (KZDMB)",
   label: "Zhambyl (KZDMB)"
  },
  {
   value: "Zhezkazgan (KZDZN)",
   label: "Zhezkazgan (KZDZN)"
  },
  {
   value: "Attopeu (LAAOU)",
   label: "Attopeu (LAAOU)"
  },
  {
   value: "Ban Houei (LAOUI)",
   label: "Ban Houei (LAOUI)"
  },
  {
   value: "Houeisay (LAHOE)",
   label: "Houeisay (LAHOE)"
  },
  {
   value: "Khong (LAKOG)",
   label: "Khong (LAKOG)"
  },
  {
   value: "Luang Namtha (LALXG)",
   label: "Luang Namtha (LALXG)"
  },
  {
   value: "Luang Prabang (LALPQ)",
   label: "Luang Prabang (LALPQ)"
  },
  {
   value: "Muong Sai (LAUON)",
   label: "Muong Sai (LAUON)"
  },
  {
   value: "Oudomxay (LAODY)",
   label: "Oudomxay (LAODY)"
  },
  {
   value: "Paksane (LAPKS)",
   label: "Paksane (LAPKS)"
  },
  {
   value: "Pakxe (LAPKZ)",
   label: "Pakxe (LAPKZ)"
  },
  {
   value: "Sam Neua (LANEU)",
   label: "Sam Neua (LANEU)"
  },
  {
   value: "Saravane (LAVNA)",
   label: "Saravane (LAVNA)"
  },
  {
   value: "Savannakhet (LASAV)",
   label: "Savannakhet (LASAV)"
  },
  {
   value: "Sayaboury (LAZBY)",
   label: "Sayaboury (LAZBY)"
  },
  {
   value: "Seno (LASND)",
   label: "Seno (LASND)"
  },
  {
   value: "Thakhek (LATHK)",
   label: "Thakhek (LATHK)"
  },
  {
   value: "Sokcho (KRSHO)",
   label: "Sokcho (KRSHO)"
  },
  {
   value: "Su Won City (KRSWU)",
   label: "Su Won City (KRSWU)"
  },
  {
   value: "Sunchon (KRSYS)",
   label: "Sunchon (KRSYS)"
  },
  {
   value: "Sungnam (Seoul Ab) (KRSSN)",
   label: "Sungnam (Seoul Ab) (KRSSN)"
  },
  {
   value: "Suwon (KRSUO)",
   label: "Suwon (KRSUO)"
  },
  {
   value: "Taean (KRTAN)",
   label: "Taean (KRTAN)"
  },
  {
   value: "Taedok (KRQET)",
   label: "Taedok (KRQET)"
  },
  {
   value: "Taegu (KRTAE)",
   label: "Taegu (KRTAE)"
  },
  {
   value: "Taejon (KRTJN)",
   label: "Taejon (KRTJN)"
  },
  {
   value: "Taesan (KRTSN)",
   label: "Taesan (KRTSN)"
  },
  {
   value: "Tangjin (KRTJI)",
   label: "Tangjin (KRTJI)"
  },
  {
   value: "Tonghae (KRTGH)",
   label: "Tonghae (KRTGH)"
  },
  {
   value: "Tongyoung (KRTYG)",
   label: "Tongyoung (KRTYG)"
  },
  {
   value: "Uiwang (KRUWN)",
   label: "Uiwang (KRUWN)"
  },
  {
   value: "Ulsan (KRUSN)",
   label: "Ulsan (KRUSN)"
  },
  {
   value: "Wando (KRWND)",
   label: "Wando (KRWND)"
  },
  {
   value: "Wonju (KRWJU)",
   label: "Wonju (KRWJU)"
  },
  {
   value: "Yangsan (KRYSN)",
   label: "Yangsan (KRYSN)"
  },
  {
   value: "Yechon (KRYEC)",
   label: "Yechon (KRYEC)"
  },
  {
   value: "Yochon (KRYOC)",
   label: "Yochon (KRYOC)"
  },
  {
   value: "Yosu (KRYOS)",
   label: "Yosu (KRYOS)"
  },
  {
   value: "Yosu apt (KRRSU)",
   label: "Yosu apt (KRRSU)"
  },
  {
   value: "ANYANG (KRANY)",
   label: "ANYANG (KRANY)"
  },
  {
   value: "CHONAN (KRCHO)",
   label: "CHONAN (KRCHO)"
  },
  {
   value: "Jahran (KWJAH)",
   label: "Jahran (KWJAH)"
  },
  {
   value: "Jebel Dhana (KWJBD)",
   label: "Jebel Dhana (KWJBD)"
  },
  {
   value: "Juaymah (KWJUA)",
   label: "Juaymah (KWJUA)"
  },
  {
   value: "Khor al Mufatta (KWKWM)",
   label: "Khor al Mufatta (KWKWM)"
  },
  {
   value: "Kuwait (KWKWI)",
   label: "Kuwait (KWKWI)"
  },
  {
   value: "Mina Abd Allah (KWMIB)",
   label: "Mina Abd Allah (KWMIB)"
  },
  {
   value: "Mina al Ahmadi (KWMEA)",
   label: "Mina al Ahmadi (KWMEA)"
  },
  {
   value: "Mina Alo Manti (KWMAM)",
   label: "Mina Alo Manti (KWMAM)"
  },
  {
   value: "Mina Saud (KWMIS)",
   label: "Mina Saud (KWMIS)"
  },
  {
   value: "Ras Al-Khafji (KWRAK)",
   label: "Ras Al-Khafji (KWRAK)"
  },
  {
   value: "Safat (KWSAF)",
   label: "Safat (KWSAF)"
  },
  {
   value: "Shuaiba (KWSAA)",
   label: "Shuaiba (KWSAA)"
  },
  {
   value: "Shuwaikh (KWSWK)",
   label: "Shuwaikh (KWSWK)"
  },
  {
   value: "Cayman Brac Is (KYCYB)",
   label: "Cayman Brac Is (KYCYB)"
  },
  {
   value: "\"Georgetown (KYGEC)",
   label: "\"Georgetown (KYGEC)"
  },
  {
   value: "Grand Cayman (KYGCM)",
   label: "Grand Cayman (KYGCM)"
  },
  {
   value: "Little Cayman (KYLYB)",
   label: "Little Cayman (KYLYB)"
  },
  {
   value: "SINUIJU (KPSII)",
   label: "SINUIJU (KPSII)"
  },
  {
   value: "Boryoung (KRBOR)",
   label: "Boryoung (KRBOR)"
  },
  {
   value: "Changhang (KRCHG)",
   label: "Changhang (KRCHG)"
  },
  {
   value: "Cheju (KRCHA)",
   label: "Cheju (KRCHA)"
  },
  {
   value: "Cheongju (KRCJJ)",
   label: "Cheongju (KRCJJ)"
  },
  {
   value: "Chinhae (KRCHF)",
   label: "Chinhae (KRCHF)"
  },
  {
   value: "Chinju (KRHIN)",
   label: "Chinju (KRHIN)"
  },
  {
   value: "Chonju (KRCHN)",
   label: "Chonju (KRCHN)"
  },
  {
   value: "Chungju (KRCHU)",
   label: "Chungju (KRCHU)"
  },
  {
   value: "Daebul (KRDBL)",
   label: "Daebul (KRDBL)"
  },
  {
   value: "Geoje (KRJGE)",
   label: "Geoje (KRJGE)"
  },
  {
   value: "Hyanpoong (KRHYP)",
   label: "Hyanpoong (KRHYP)"
  },
  {
   value: "Inchon (KRINC)",
   label: "Inchon (KRINC)"
  },
  {
   value: "Jangsung (KRJSN)",
   label: "Jangsung (KRJSN)"
  },
  {
   value: "Kamchun (KRKCN)",
   label: "Kamchun (KRKCN)"
  },
  {
   value: "Kangnung (KRKAG)",
   label: "Kangnung (KRKAG)"
  },
  {
   value: "Kimhae (KRKMH)",
   label: "Kimhae (KRKMH)"
  },
  {
   value: "Kohyon (KRKHN)",
   label: "Kohyon (KRKHN)"
  },
  {
   value: "Koje (KRKJE)",
   label: "Koje (KRKJE)"
  },
  {
   value: "Kojong (KRKOJ)",
   label: "Kojong (KRKOJ)"
  },
  {
   value: "Kunpo (KRKUP)",
   label: "Kunpo (KRKUP)"
  },
  {
   value: "Kunsan (KRKUV)",
   label: "Kunsan (KRKUV)"
  },
  {
   value: "Kusan (KRKUZ)",
   label: "Kusan (KRKUZ)"
  },
  {
   value: "Kwangju (KRKWJ)",
   label: "Kwangju (KRKWJ)"
  },
  {
   value: "Kwangyang (KRKAN)",
   label: "Kwangyang (KRKAN)"
  },
  {
   value: "Masan (KRMAS)",
   label: "Masan (KRMAS)"
  },
  {
   value: "Mipo (KRMIP)",
   label: "Mipo (KRMIP)"
  },
  {
   value: "Mokpo (KRMOK)",
   label: "Mokpo (KRMOK)"
  },
  {
   value: "Mokpo apt (KRMPK)",
   label: "Mokpo apt (KRMPK)"
  },
  {
   value: "Mukho (KRMUK)",
   label: "Mukho (KRMUK)"
  },
  {
   value: "Okkye (KROKK)",
   label: "Okkye (KROKK)"
  },
  {
   value: "Okpo (KROKP)",
   label: "Okpo (KROKP)"
  },
  {
   value: "Onsan (KRONS)",
   label: "Onsan (KRONS)"
  },
  {
   value: "Osan (KROSN)",
   label: "Osan (KROSN)"
  },
  {
   value: "Panmoonjeom (KRPMJ)",
   label: "Panmoonjeom (KRPMJ)"
  },
  {
   value: "Pohang (KRKPO)",
   label: "Pohang (KRKPO)"
  },
  {
   value: "Pusan (KRPUS)",
   label: "Pusan (KRPUS)"
  },
  {
   value: "Pyongtaek (KRPTK)",
   label: "Pyongtaek (KRPTK)"
  },
  {
   value: "Samchok (KRSUK)",
   label: "Samchok (KRSUK)"
  },
  {
   value: "Samchonpo (KRSCP)",
   label: "Samchonpo (KRSCP)"
  },
  {
   value: "Seoul Kimpo apt (KRSEL)",
   label: "Seoul Kimpo apt (KRSEL)"
  },
  {
   value: "Shinhang (KRSHG)",
   label: "Shinhang (KRSHG)"
  },
  {
   value: "Sogwipo (KRSPO)",
   label: "Sogwipo (KRSPO)"
  },
  {
   value: "Canton Island (KICIS)",
   label: "Canton Island (KICIS)"
  },
  {
   value: "Christmas Island (KICXI)",
   label: "Christmas Island (KICXI)"
  },
  {
   value: "Fanning Islands (KIFIS)",
   label: "Fanning Islands (KIFIS)"
  },
  {
   value: "Kuria (KIKUC)",
   label: "Kuria (KIKUC)"
  },
  {
   value: "Maiana (KIMNK)",
   label: "Maiana (KIMNK)"
  },
  {
   value: "Makin Island (KIMTK)",
   label: "Makin Island (KIMTK)"
  },
  {
   value: "Marakei (KIMZK)",
   label: "Marakei (KIMZK)"
  },
  {
   value: "Nikunau (KINIG)",
   label: "Nikunau (KINIG)"
  },
  {
   value: "Nonouti (KINON)",
   label: "Nonouti (KINON)"
  },
  {
   value: "Onotoa (KIOOT)",
   label: "Onotoa (KIOOT)"
  },
  {
   value: "Phoenix Islands (KIPHO)",
   label: "Phoenix Islands (KIPHO)"
  },
  {
   value: "Tabiteuea North (KITBF)",
   label: "Tabiteuea North (KITBF)"
  },
  {
   value: "Tabiteuea South (KITSU)",
   label: "Tabiteuea South (KITSU)"
  },
  {
   value: "Tabuaeran (KITNV)",
   label: "Tabuaeran (KITNV)"
  },
  {
   value: "Tamana Island (KITMN)",
   label: "Tamana Island (KITMN)"
  },
  {
   value: "Tarawa (KITRW)",
   label: "Tarawa (KITRW)"
  },
  {
   value: "Teraina (KITNQ)",
   label: "Teraina (KITNQ)"
  },
  {
   value: "Washington Islands (KIWNI)",
   label: "Washington Islands (KIWNI)"
  },
  {
   value: "Anjouan (KMAJN)",
   label: "Anjouan (KMAJN)"
  },
  {
   value: "Dzaoudzi (KMDZA)",
   label: "Dzaoudzi (KMDZA)"
  },
  {
   value: "Foumbouni (KMFOU)",
   label: "Foumbouni (KMFOU)"
  },
  {
   value: "Hahaya Apt\/Moroni (KMHAH)",
   label: "Hahaya Apt\/Moroni (KMHAH)"
  },
  {
   value: "Mamoutsou (KMMMO)",
   label: "Mamoutsou (KMMMO)"
  },
  {
   value: "Moheli (KMNWA)",
   label: "Moheli (KMNWA)"
  },
  {
   value: "Moroni (KMYVA)",
   label: "Moroni (KMYVA)"
  },
  {
   value: "Mutsamudu (KMMUT)",
   label: "Mutsamudu (KMMUT)"
  },
  {
   value: "\"Basseterre (KNBAS)",
   label: "\"Basseterre (KNBAS)"
  },
  {
   value: "\"NEVIS (KNNEV)",
   label: "\"NEVIS (KNNEV)"
  },
  {
   value: "St Kitts (KNSKB)",
   label: "St Kitts (KNSKB)"
  },
  {
   value: "Bumpyo (Rempo) (KPREM)",
   label: "Bumpyo (Rempo) (KPREM)"
  },
  {
   value: "Chongjin (KPCHO)",
   label: "Chongjin (KPCHO)"
  },
  {
   value: "Gensan (KPGEN)",
   label: "Gensan (KPGEN)"
  },
  {
   value: "Haeju (KPHAE)",
   label: "Haeju (KPHAE)"
  },
  {
   value: "Hungnam (KPHGM)",
   label: "Hungnam (KPHGM)"
  },
  {
   value: "Najin (KPNJN)",
   label: "Najin (KPNJN)"
  },
  {
   value: "Nampo (KPNAM)",
   label: "Nampo (KPNAM)"
  },
  {
   value: "Pyongyang (KPFNJ)",
   label: "Pyongyang (KPFNJ)"
  },
  {
   value: "Songjin (KPSON)",
   label: "Songjin (KPSON)"
  },
  {
   value: "Wonsan (KPWON)",
   label: "Wonsan (KPWON)"
  },
  {
   value: "KAESONG (KPKSN)",
   label: "KAESONG (KPKSN)"
  },
  {
   value: "Malindi (KEMYD)",
   label: "Malindi (KEMYD)"
  },
  {
   value: "Mandera (KENDE)",
   label: "Mandera (KENDE)"
  },
  {
   value: "Mara Lodges (KEMRE)",
   label: "Mara Lodges (KEMRE)"
  },
  {
   value: "Marsabit (KERBT)",
   label: "Marsabit (KERBT)"
  },
  {
   value: "Mombasa (KEMBA)",
   label: "Mombasa (KEMBA)"
  },
  {
   value: "Moyale (KEOYL)",
   label: "Moyale (KEOYL)"
  },
  {
   value: "Mumias (KEMUM)",
   label: "Mumias (KEMUM)"
  },
  {
   value: "Nairobi (KENBO)",
   label: "Nairobi (KENBO)"
  },
  {
   value: "Nakuru (KENUU)",
   label: "Nakuru (KENUU)"
  },
  {
   value: "Nanyuki (KENYK)",
   label: "Nanyuki (KENYK)"
  },
  {
   value: "Nyeri (KENYE)",
   label: "Nyeri (KENYE)"
  },
  {
   value: "Nzoia (KENZO)",
   label: "Nzoia (KENZO)"
  },
  {
   value: "Samburu (KEUAS)",
   label: "Samburu (KEUAS)"
  },
  {
   value: "Ukunda (KEUKA)",
   label: "Ukunda (KEUKA)"
  },
  {
   value: "Wajir (KEWJR)",
   label: "Wajir (KEWJR)"
  },
  {
   value: "Wilson Apt\/Nairobi (KEWIL)",
   label: "Wilson Apt\/Nairobi (KEWIL)"
  },
  {
   value: "Bishkek (Ex Frunze) (KGFRU)",
   label: "Bishkek (Ex Frunze) (KGFRU)"
  },
  {
   value: "Osh (KGOSS)",
   label: "Osh (KGOSS)"
  },
  {
   value: "Battambang (KHBBM)",
   label: "Battambang (KHBBM)"
  },
  {
   value: "Cheko (KHCHE)",
   label: "Cheko (KHCHE)"
  },
  {
   value: "Kampot (KHKMT)",
   label: "Kampot (KHKMT)"
  },
  {
   value: "Kas Kong (KHKKO)",
   label: "Kas Kong (KHKKO)"
  },
  {
   value: "Koh Kong (KHKKZ)",
   label: "Koh Kong (KHKKZ)"
  },
  {
   value: "Kompong Thom (KHKZK)",
   label: "Kompong Thom (KHKZK)"
  },
  {
   value: "Kompong-Chhna (KHKZC)",
   label: "Kompong-Chhna (KHKZC)"
  },
  {
   value: "Krakor (KHKZD)",
   label: "Krakor (KHKZD)"
  },
  {
   value: "Kratie (KHKTI)",
   label: "Kratie (KHKTI)"
  },
  {
   value: "Mundulkiri (KHMWV)",
   label: "Mundulkiri (KHMWV)"
  },
  {
   value: "Oddor Meanche (KHOMY)",
   label: "Oddor Meanche (KHOMY)"
  },
  {
   value: "Pailin (KHPAI)",
   label: "Pailin (KHPAI)"
  },
  {
   value: "Phnom Penh (KHPNH)",
   label: "Phnom Penh (KHPNH)"
  },
  {
   value: "Ratanakiri (KHRBE)",
   label: "Ratanakiri (KHRBE)"
  },
  {
   value: "Siem Reap (KHREP)",
   label: "Siem Reap (KHREP)"
  },
  {
   value: "Sihanoukville (Kompong Saom) (KHKOS)",
   label: "Sihanoukville (Kompong Saom) (KHKOS)"
  },
  {
   value: "Stung Treng (KHTNX)",
   label: "Stung Treng (KHTNX)"
  },
  {
   value: "Svay Rieng (KHSVR)",
   label: "Svay Rieng (KHSVR)"
  },
  {
   value: "Abaiang (KIABF)",
   label: "Abaiang (KIABF)"
  },
  {
   value: "Abemama (KIAEA)",
   label: "Abemama (KIAEA)"
  },
  {
   value: "Aranuka (KIAAK)",
   label: "Aranuka (KIAAK)"
  },
  {
   value: "Arorae Island (KIAIS)",
   label: "Arorae Island (KIAIS)"
  },
  {
   value: "Beru (KIBEZ)",
   label: "Beru (KIBEZ)"
  },
  {
   value: "Butaritari (KIBBG)",
   label: "Butaritari (KIBBG)"
  },
  {
   value: "Yuge (JPYGE)",
   label: "Yuge (JPYGE)"
  },
  {
   value: "Yuki (JPYUK)",
   label: "Yuki (JPYUK)"
  },
  {
   value: "Yumachi (JPYMC)",
   label: "Yumachi (JPYMC)"
  },
  {
   value: "Yumugi (JPYMU)",
   label: "Yumugi (JPYMU)"
  },
  {
   value: "Yunomochiki (JPYNM)",
   label: "Yunomochiki (JPYNM)"
  },
  {
   value: "Yunotsu (JPYNT)",
   label: "Yunotsu (JPYNT)"
  },
  {
   value: "\"Yura (JPYRA)",
   label: "\"Yura (JPYRA)"
  },
  {
   value: "\"Yura (JPYUJ)",
   label: "\"Yura (JPYUJ)"
  },
  {
   value: "\"Yura (JPYUA)",
   label: "\"Yura (JPYUA)"
  },
  {
   value: "\"Yura (JPYUR)",
   label: "\"Yura (JPYUR)"
  },
  {
   value: "Yurigahama (JPYRG)",
   label: "Yurigahama (JPYRG)"
  },
  {
   value: "Yusu (JPYUS)",
   label: "Yusu (JPYUS)"
  },
  {
   value: "Yutai (JPYTI)",
   label: "Yutai (JPYTI)"
  },
  {
   value: "Yuu (JPYUU)",
   label: "Yuu (JPYUU)"
  },
  {
   value: "Yuwan (JPYWN)",
   label: "Yuwan (JPYWN)"
  },
  {
   value: "Zamami (JPZMM)",
   label: "Zamami (JPZMM)"
  },
  {
   value: "GIFU (JPGIF)",
   label: "GIFU (JPGIF)"
  },
  {
   value: "KADENA (JPDNA)",
   label: "KADENA (JPDNA)"
  },
  {
   value: "SAGAMIHA (JPSGH)",
   label: "SAGAMIHA (JPSGH)"
  },
  {
   value: "Amboseli (KEASV)",
   label: "Amboseli (KEASV)"
  },
  {
   value: "Bamburi (KEBMQ)",
   label: "Bamburi (KEBMQ)"
  },
  {
   value: "Eldoret (KEEDL)",
   label: "Eldoret (KEEDL)"
  },
  {
   value: "Eliye Springs (KEEYS)",
   label: "Eliye Springs (KEEYS)"
  },
  {
   value: "Embakasi (KEEMB)",
   label: "Embakasi (KEEMB)"
  },
  {
   value: "Fergusons Gulf (KEFER)",
   label: "Fergusons Gulf (KEFER)"
  },
  {
   value: "Garissa (KEGAS)",
   label: "Garissa (KEGAS)"
  },
  {
   value: "Hola (KEHOA)",
   label: "Hola (KEHOA)"
  },
  {
   value: "Kalokol (KEKLK)",
   label: "Kalokol (KEKLK)"
  },
  {
   value: "Kericho (KEKEY)",
   label: "Kericho (KEKEY)"
  },
  {
   value: "Kerio Valley (KEKRV)",
   label: "Kerio Valley (KEKRV)"
  },
  {
   value: "Kilaguni (KEILU)",
   label: "Kilaguni (KEILU)"
  },
  {
   value: "Kilindini (KEKIL)",
   label: "Kilindini (KEKIL)"
  },
  {
   value: "Kisumu (KEKIS)",
   label: "Kisumu (KEKIS)"
  },
  {
   value: "Kitale (KEKTL)",
   label: "Kitale (KEKTL)"
  },
  {
   value: "Kiunga (KEKIU)",
   label: "Kiunga (KEKIU)"
  },
  {
   value: "Kiwayu (KEKWY)",
   label: "Kiwayu (KEKWY)"
  },
  {
   value: "Lake Baringo (KELBN)",
   label: "Lake Baringo (KELBN)"
  },
  {
   value: "Lake Rudolf (KELKU)",
   label: "Lake Rudolf (KELKU)"
  },
  {
   value: "Lamu (KELAU)",
   label: "Lamu (KELAU)"
  },
  {
   value: "Liboi (KELBK)",
   label: "Liboi (KELBK)"
  },
  {
   value: "Lodwar (KELOK)",
   label: "Lodwar (KELOK)"
  },
  {
   value: "Lokichoggio (KELKG)",
   label: "Lokichoggio (KELKG)"
  },
  {
   value: "Loyangalani (KELOY)",
   label: "Loyangalani (KELOY)"
  },
  {
   value: "Yanagi (JPYAA)",
   label: "Yanagi (JPYAA)"
  },
  {
   value: "Yanai (JPYAN)",
   label: "Yanai (JPYAN)"
  },
  {
   value: "Yani (JPYNI)",
   label: "Yani (JPYNI)"
  },
  {
   value: "Yanma (JPYNN)",
   label: "Yanma (JPYNN)"
  },
  {
   value: "Yasugi (JPYSG)",
   label: "Yasugi (JPYSG)"
  },
  {
   value: "Yasumiya (JPYAS)",
   label: "Yasumiya (JPYAS)"
  },
  {
   value: "Yasurahama (JPYMA)",
   label: "Yasurahama (JPYMA)"
  },
  {
   value: "Yatsushiro (JPYAT)",
   label: "Yatsushiro (JPYAT)"
  },
  {
   value: "Yawata\/Kitakyushu (JPYWT)",
   label: "Yawata\/Kitakyushu (JPYWT)"
  },
  {
   value: "Yawatahama (JPYWH)",
   label: "Yawatahama (JPYWH)"
  },
  {
   value: "Yobuko (JPYBK)",
   label: "Yobuko (JPYBK)"
  },
  {
   value: "Yoichi (JPYIC)",
   label: "Yoichi (JPYIC)"
  },
  {
   value: "Yoichigaura (JPYOC)",
   label: "Yoichigaura (JPYOC)"
  },
  {
   value: "Yokkaichi (JPYKK)",
   label: "Yokkaichi (JPYKK)"
  },
  {
   value: "Yokohama (JPYOK)",
   label: "Yokohama (JPYOK)"
  },
  {
   value: "Yokoshima\/Kurahashi (JPYKS)",
   label: "Yokoshima\/Kurahashi (JPYKS)"
  },
  {
   value: "Yokosuka (JPYOS)",
   label: "Yokosuka (JPYOS)"
  },
  {
   value: "Yokota Apt\/Tokyo (JPOKO)",
   label: "Yokota Apt\/Tokyo (JPOKO)"
  },
  {
   value: "\"Yokota (JPYKT)",
   label: "\"Yokota (JPYKT)"
  },
  {
   value: "Yonago (JPYGJ)",
   label: "Yonago (JPYGJ)"
  },
  {
   value: "Yonagunijima (JPOGN)",
   label: "Yonagunijima (JPOGN)"
  },
  {
   value: "Yonegura (JPYOG)",
   label: "Yonegura (JPYOG)"
  },
  {
   value: "Yonouzu (JPYNZ)",
   label: "Yonouzu (JPYNZ)"
  },
  {
   value: "Yoro (JPYOR)",
   label: "Yoro (JPYOR)"
  },
  {
   value: "Yoronjima (JPRNJ)",
   label: "Yoronjima (JPRNJ)"
  },
  {
   value: "Yoshiase (JPYSS)",
   label: "Yoshiase (JPYSS)"
  },
  {
   value: "\"Yoshida (JPYDA)",
   label: "\"Yoshida (JPYDA)"
  },
  {
   value: "\"Yoshida (JPYSD)",
   label: "\"Yoshida (JPYSD)"
  },
  {
   value: "Yoshima (JPYSM)",
   label: "Yoshima (JPYSM)"
  },
  {
   value: "Yoshimi (JPYHI)",
   label: "Yoshimi (JPYHI)"
  },
  {
   value: "Yoshinozaki (JPYSN)",
   label: "Yoshinozaki (JPYSN)"
  },
  {
   value: "Yoshiura (JPYSU)",
   label: "Yoshiura (JPYSU)"
  },
  {
   value: "Yoshiura\/Misumi (JPYSR)",
   label: "Yoshiura\/Misumi (JPYSR)"
  },
  {
   value: "Yoshiura\/Yunotsu (JPYHA)",
   label: "Yoshiura\/Yunotsu (JPYHA)"
  },
  {
   value: "Yoshizu (JPYSZ)",
   label: "Yoshizu (JPYSZ)"
  },
  {
   value: "Yotsukura (JPYOT)",
   label: "Yotsukura (JPYOT)"
  },
  {
   value: "Youra (JPYOU)",
   label: "Youra (JPYOU)"
  },
  {
   value: "Yuasahiro (JPYSH)",
   label: "Yuasahiro (JPYSH)"
  },
  {
   value: "Yubetsu (JPYBT)",
   label: "Yubetsu (JPYBT)"
  },
  {
   value: "Yudomari (JPYDM)",
   label: "Yudomari (JPYDM)"
  },
  {
   value: "\"Utsumi (JPUTM)",
   label: "\"Utsumi (JPUTM)"
  },
  {
   value: "\"Utsumi (JPUTS)",
   label: "\"Utsumi (JPUTS)"
  },
  {
   value: "Uwajima (JPUWA)",
   label: "Uwajima (JPUWA)"
  },
  {
   value: "Uzuki (JPUZK)",
   label: "Uzuki (JPUZK)"
  },
  {
   value: "Wada (JPWDA)",
   label: "Wada (JPWDA)"
  },
  {
   value: "Wadomari (JPWAD)",
   label: "Wadomari (JPWAD)"
  },
  {
   value: "Waita (JPWAI)",
   label: "Waita (JPWAI)"
  },
  {
   value: "Wajima (JPWJM)",
   label: "Wajima (JPWJM)"
  },
  {
   value: "\"Wakamatsu (JPWTU)",
   label: "\"Wakamatsu (JPWTU)"
  },
  {
   value: "Wakamatsu\/Kitakyushuu (JPWAM)",
   label: "Wakamatsu\/Kitakyushuu (JPWAM)"
  },
  {
   value: "Wakatsu (JPWKT)",
   label: "Wakatsu (JPWKT)"
  },
  {
   value: "Wakayama (JPWAK)",
   label: "Wakayama (JPWAK)"
  },
  {
   value: "Wakimisaki (JPWKI)",
   label: "Wakimisaki (JPWKI)"
  },
  {
   value: "Wakimoto (JPWMT)",
   label: "Wakimoto (JPWMT)"
  },
  {
   value: "Wakinosawa (JPWKW)",
   label: "Wakinosawa (JPWKW)"
  },
  {
   value: "Wakizaki (JPWKZ)",
   label: "Wakizaki (JPWKZ)"
  },
  {
   value: "Wakkanai (JPWKJ)",
   label: "Wakkanai (JPWKJ)"
  },
  {
   value: "Wakura (JPWKR)",
   label: "Wakura (JPWKR)"
  },
  {
   value: "Wan (JPWAN)",
   label: "Wan (JPWAN)"
  },
  {
   value: "Waniura (JPWNI)",
   label: "Waniura (JPWNI)"
  },
  {
   value: "Wano (JPWNA)",
   label: "Wano (JPWNA)"
  },
  {
   value: "Washibeyanoura (JPWSB)",
   label: "Washibeyanoura (JPWSB)"
  },
  {
   value: "Watanoha (JPWAT)",
   label: "Watanoha (JPWAT)"
  },
  {
   value: "Yaene (JPYNE)",
   label: "Yaene (JPYNE)"
  },
  {
   value: "\"Yagi (JPYAG)",
   label: "\"Yagi (JPYAG)"
  },
  {
   value: "\"Yagi (JPYGI)",
   label: "\"Yagi (JPYGI)"
  },
  {
   value: "Yagishiri (JPYGR)",
   label: "Yagishiri (JPYGR)"
  },
  {
   value: "Yaizu (JPYZU)",
   label: "Yaizu (JPYZU)"
  },
  {
   value: "Yakushima (JPKUM)",
   label: "Yakushima (JPKUM)"
  },
  {
   value: "Yakuzu (JPYKU)",
   label: "Yakuzu (JPYKU)"
  },
  {
   value: "Yamada (JPYQD)",
   label: "Yamada (JPYQD)"
  },
  {
   value: "\"Yamada (JPYMD)",
   label: "\"Yamada (JPYMD)"
  },
  {
   value: "\"Yamada (JPYAD)",
   label: "\"Yamada (JPYAD)"
  },
  {
   value: "Yamagata (JPGAJ)",
   label: "Yamagata (JPGAJ)"
  },
  {
   value: "Yamagawa (JPYAM)",
   label: "Yamagawa (JPYAM)"
  },
  {
   value: "Yamaguchi (JPYMG)",
   label: "Yamaguchi (JPYMG)"
  },
  {
   value: "Yamaguchihigashi (JPYGH)",
   label: "Yamaguchihigashi (JPYGH)"
  },
  {
   value: "Yamanoura (JPYMN)",
   label: "Yamanoura (JPYMN)"
  },
  {
   value: "Yamatani (JPYMT)",
   label: "Yamatani (JPYMT)"
  },
  {
   value: "Uchiumi (JPUCH)",
   label: "Uchiumi (JPUCH)"
  },
  {
   value: "\"Uchiura (JPUCU)",
   label: "\"Uchiura (JPUCU)"
  },
  {
   value: "\"Uchiura (JPUCR)",
   label: "\"Uchiura (JPUCR)"
  },
  {
   value: "Udo (JPUDD)",
   label: "Udo (JPUDD)"
  },
  {
   value: "Udono (JPUDO)",
   label: "Udono (JPUDO)"
  },
  {
   value: "Uechi (JPUEC)",
   label: "Uechi (JPUEC)"
  },
  {
   value: "Uga (JPUGA)",
   label: "Uga (JPUGA)"
  },
  {
   value: "Ugusu (JPUGU)",
   label: "Ugusu (JPUGU)"
  },
  {
   value: "Ujina (JPUJI)",
   label: "Ujina (JPUJI)"
  },
  {
   value: "Ujiyamada (JPUJY)",
   label: "Ujiyamada (JPUJY)"
  },
  {
   value: "Ukejima (JPUKJ)",
   label: "Ukejima (JPUKJ)"
  },
  {
   value: "Uken (JPUKN)",
   label: "Uken (JPUKN)"
  },
  {
   value: "Ukitsu (JPUKT)",
   label: "Ukitsu (JPUKT)"
  },
  {
   value: "Ukui (JPUKI)",
   label: "Ukui (JPUKI)"
  },
  {
   value: "Umagoe (JPUMG)",
   label: "Umagoe (JPUMG)"
  },
  {
   value: "Uno (JPUNO)",
   label: "Uno (JPUNO)"
  },
  {
   value: "Unoshima (JPUNS)",
   label: "Unoshima (JPUNS)"
  },
  {
   value: "Unten (JPUNT)",
   label: "Unten (JPUNT)"
  },
  {
   value: "Uomi (JPUOM)",
   label: "Uomi (JPUOM)"
  },
  {
   value: "\"Uozu (JPUOU)",
   label: "\"Uozu (JPUOU)"
  },
  {
   value: "\"Uozu (JPUOZ)",
   label: "\"Uozu (JPUOZ)"
  },
  {
   value: "Ura (JPURA)",
   label: "Ura (JPURA)"
  },
  {
   value: "Uraga (JPURG)",
   label: "Uraga (JPURG)"
  },
  {
   value: "Uragami (JPURM)",
   label: "Uragami (JPURM)"
  },
  {
   value: "Urago (JPUAO)",
   label: "Urago (JPUAO)"
  },
  {
   value: "Urahara (JPURH)",
   label: "Urahara (JPURH)"
  },
  {
   value: "Urakawa (JPURK)",
   label: "Urakawa (JPURK)"
  },
  {
   value: "Uranomae (JPUNM)",
   label: "Uranomae (JPUNM)"
  },
  {
   value: "Urashiro (JPURR)",
   label: "Urashiro (JPURR)"
  },
  {
   value: "Urasoko (JPURS)",
   label: "Urasoko (JPURS)"
  },
  {
   value: "Usa\/Tosa (JPUSA)",
   label: "Usa\/Tosa (JPUSA)"
  },
  {
   value: "Ushibuka (JPUBK)",
   label: "Ushibuka (JPUBK)"
  },
  {
   value: "Ushigakubijima (JPUSG)",
   label: "Ushigakubijima (JPUSG)"
  },
  {
   value: "Ushimado (JPUSH)",
   label: "Ushimado (JPUSH)"
  },
  {
   value: "Ushine (JPUSI)",
   label: "Ushine (JPUSI)"
  },
  {
   value: "Ushitsu (JPUST)",
   label: "Ushitsu (JPUST)"
  },
  {
   value: "Usujiri (JPUSJ)",
   label: "Usujiri (JPUSJ)"
  },
  {
   value: "Usuka (JPUKA)",
   label: "Usuka (JPUKA)"
  },
  {
   value: "Usuki (JPUSK)",
   label: "Usuki (JPUSK)"
  },
  {
   value: "Usuno (JPUSN)",
   label: "Usuno (JPUSN)"
  },
  {
   value: "Usunoura (JPUSU)",
   label: "Usunoura (JPUSU)"
  },
  {
   value: "Utazu (JPUTZ)",
   label: "Utazu (JPUTZ)"
  },
  {
   value: "Tosashimizu (JPTSZ)",
   label: "Tosashimizu (JPTSZ)"
  },
  {
   value: "\"Toshima (JPTJO)",
   label: "\"Toshima (JPTJO)"
  },
  {
   value: "\"Toshima (JPTOX)",
   label: "\"Toshima (JPTOX)"
  },
  {
   value: "Totoro (JPTOT)",
   label: "Totoro (JPTOT)"
  },
  {
   value: "Tottori (JPTTJ)",
   label: "Tottori (JPTTJ)"
  },
  {
   value: "Touyo (JPTOU)",
   label: "Touyo (JPTOU)"
  },
  {
   value: "Toyama (JPTOY)",
   label: "Toyama (JPTOY)"
  },
  {
   value: "Toyamashinko (JPTOS)",
   label: "Toyamashinko (JPTOS)"
  },
  {
   value: "\"Toyohama (JPTYJ)",
   label: "\"Toyohama (JPTYJ)"
  },
  {
   value: "\"Toyohama (JPTYH)",
   label: "\"Toyohama (JPTYH)"
  },
  {
   value: "Toyohashi (JPTHS)",
   label: "Toyohashi (JPTHS)"
  },
  {
   value: "Toyoshige (JPTUS)",
   label: "Toyoshige (JPTUS)"
  },
  {
   value: "Toyoura (JPTYR)",
   label: "Toyoura (JPTYR)"
  },
  {
   value: "Tsu (JPTSU)",
   label: "Tsu (JPTSU)"
  },
  {
   value: "Tsuchiura (JPTCH)",
   label: "Tsuchiura (JPTCH)"
  },
  {
   value: "Tsuda (JPTUD)",
   label: "Tsuda (JPTUD)"
  },
  {
   value: "Tsui (JPTUI)",
   label: "Tsui (JPTUI)"
  },
  {
   value: "Tsuiyama (JPTYN)",
   label: "Tsuiyama (JPTYN)"
  },
  {
   value: "Tsukinokawa (JPTWA)",
   label: "Tsukinokawa (JPTWA)"
  },
  {
   value: "Tsukumi (JPTMI)",
   label: "Tsukumi (JPTMI)"
  },
  {
   value: "Tsukumo (JPTUU)",
   label: "Tsukumo (JPTUU)"
  },
  {
   value: "Tsuna (JPTNA)",
   label: "Tsuna (JPTNA)"
  },
  {
   value: "Tsuneishi (JPTNI)",
   label: "Tsuneishi (JPTNI)"
  },
  {
   value: "Tsunoshima (JPTNS)",
   label: "Tsunoshima (JPTNS)"
  },
  {
   value: "Tsuruga (JPTRG)",
   label: "Tsuruga (JPTRG)"
  },
  {
   value: "Tsurumi (JPTRM)",
   label: "Tsurumi (JPTRM)"
  },
  {
   value: "\"Tsurumi (JPTRU)",
   label: "\"Tsurumi (JPTRU)"
  },
  {
   value: "Tsurusaki (JPTSK)",
   label: "Tsurusaki (JPTSK)"
  },
  {
   value: "Tsuruuchi (JPTRC)",
   label: "Tsuruuchi (JPTRC)"
  },
  {
   value: "Tsushi (JPTSH)",
   label: "Tsushi (JPTSH)"
  },
  {
   value: "Tsushima (JPTSJ)",
   label: "Tsushima (JPTSJ)"
  },
  {
   value: "Tsutsu (JPTST)",
   label: "Tsutsu (JPTST)"
  },
  {
   value: "Tsutsumi (JPTTM)",
   label: "Tsutsumi (JPTTM)"
  },
  {
   value: "Tsuyoshi (JPTYP)",
   label: "Tsuyoshi (JPTYP)"
  },
  {
   value: "Ube (JPUBJ)",
   label: "Ube (JPUBJ)"
  },
  {
   value: "Ubuyu (JPUBY)",
   label: "Ubuyu (JPUBY)"
  },
  {
   value: "Uchihana (JPUHH)",
   label: "Uchihana (JPUHH)"
  },
  {
   value: "Uchinomi (JPUCN)",
   label: "Uchinomi (JPUCN)"
  },
  {
   value: "Uchinoura (JPUUR)",
   label: "Uchinoura (JPUUR)"
  },
  {
   value: "Uchinourahetsuka (JPUNU)",
   label: "Uchinourahetsuka (JPUNU)"
  },
  {
   value: "Toba (JPTOB)",
   label: "Toba (JPTOB)"
  },
  {
   value: "Tobata\/Kitakyushu (JPTBT)",
   label: "Tobata\/Kitakyushu (JPTBT)"
  },
  {
   value: "Tobo (JPTBO)",
   label: "Tobo (JPTBO)"
  },
  {
   value: "Todohokke (JPTOD)",
   label: "Todohokke (JPTOD)"
  },
  {
   value: "Toga (JPTOJ)",
   label: "Toga (JPTOJ)"
  },
  {
   value: "Togi (JPTOG)",
   label: "Togi (JPTOG)"
  },
  {
   value: "Toguchi (JPTGC)",
   label: "Toguchi (JPTGC)"
  },
  {
   value: "Tohda (JPTDA)",
   label: "Tohda (JPTDA)"
  },
  {
   value: "Toi (JPTOI)",
   label: "Toi (JPTOI)"
  },
  {
   value: "Tojima (JPTJM)",
   label: "Tojima (JPTJM)"
  },
  {
   value: "Tokachi (JPTOK)",
   label: "Tokachi (JPTOK)"
  },
  {
   value: "Tokai (JPTKA)",
   label: "Tokai (JPTKA)"
  },
  {
   value: "Tokashiki (JPTJS)",
   label: "Tokashiki (JPTJS)"
  },
  {
   value: "Tokitsu (JPTTU)",
   label: "Tokitsu (JPTTU)"
  },
  {
   value: "Tokoname (JPTXN)",
   label: "Tokoname (JPTXN)"
  },
  {
   value: "Tokonami (JPTKO)",
   label: "Tokonami (JPTKO)"
  },
  {
   value: "Tokoro (JPTKR)",
   label: "Tokoro (JPTKR)"
  },
  {
   value: "Tokuchi (JPTCC)",
   label: "Tokuchi (JPTCC)"
  },
  {
   value: "Tokujin (JPTKJ)",
   label: "Tokujin (JPTKJ)"
  },
  {
   value: "Tokunoshima (JPTKN)",
   label: "Tokunoshima (JPTKN)"
  },
  {
   value: "Tokushima (JPTKS)",
   label: "Tokushima (JPTKS)"
  },
  {
   value: "TokushimaKomatsushima? (JPTKX)",
   label: "TokushimaKomatsushima? (JPTKX)"
  },
  {
   value: "Tokuyama (JPTKY)",
   label: "Tokuyama (JPTKY)"
  },
  {
   value: "Tokyo (JPTYO)",
   label: "Tokyo (JPTYO)"
  },
  {
   value: "Tomakomai (JPTMK)",
   label: "Tomakomai (JPTMK)"
  },
  {
   value: "Tomamae (JPTJJ)",
   label: "Tomamae (JPTJJ)"
  },
  {
   value: "\"Tomar (JPTMR)",
   label: "\"Tomar (JPTMR)"
  },
  {
   value: "Tomari\/Shiribeshi (JPTMA)",
   label: "Tomari\/Shiribeshi (JPTMA)"
  },
  {
   value: "Tomariura (JPTRR)",
   label: "Tomariura (JPTRR)"
  },
  {
   value: "Tomie (JPTME)",
   label: "Tomie (JPTME)"
  },
  {
   value: "Tomiku (JPTMM)",
   label: "Tomiku (JPTMM)"
  },
  {
   value: "\"Tomioka (JPTMO)",
   label: "\"Tomioka (JPTMO)"
  },
  {
   value: "\"Tomioka (JPTOM)",
   label: "\"Tomioka (JPTOM)"
  },
  {
   value: "Tomitsu (JPTMU)",
   label: "Tomitsu (JPTMU)"
  },
  {
   value: "Tonda (JPTND)",
   label: "Tonda (JPTND)"
  },
  {
   value: "Tonosho (JPTNO)",
   label: "Tonosho (JPTNO)"
  },
  {
   value: "Tonoshohigash (JPTNH)",
   label: "Tonoshohigash (JPTNH)"
  },
  {
   value: "Tonoura (JPTON)",
   label: "Tonoura (JPTON)"
  },
  {
   value: "Toride (JPTOR)",
   label: "Toride (JPTOR)"
  },
  {
   value: "Tororo (JPTRO)",
   label: "Tororo (JPTRO)"
  },
  {
   value: "Taki (JPTKI)",
   label: "Taki (JPTKI)"
  },
  {
   value: "Takuma (JPTKM)",
   label: "Takuma (JPTKM)"
  },
  {
   value: "Takuno (JPTKU)",
   label: "Takuno (JPTKU)"
  },
  {
   value: "Tamano (JPTAM)",
   label: "Tamano (JPTAM)"
  },
  {
   value: "Tamanoura (JPTMN)",
   label: "Tamanoura (JPTMN)"
  },
  {
   value: "\"Tamatsu (JPTMS)",
   label: "\"Tamatsu (JPTMS)"
  },
  {
   value: "\"Tamatsu (JPTMT)",
   label: "\"Tamatsu (JPTMT)"
  },
  {
   value: "Tamatsukuri (JPTAI)",
   label: "Tamatsukuri (JPTAI)"
  },
  {
   value: "Tanabe (JPTAE)",
   label: "Tanabe (JPTAE)"
  },
  {
   value: "Tanagawa (JPTAN)",
   label: "Tanagawa (JPTAN)"
  },
  {
   value: "Tanasoko (JPTNK)",
   label: "Tanasoko (JPTNK)"
  },
  {
   value: "Tanegashima (JPTNE)",
   label: "Tanegashima (JPTNE)"
  },
  {
   value: "Tannowa (JPTAW)",
   label: "Tannowa (JPTAW)"
  },
  {
   value: "Tanohama (JPTHM)",
   label: "Tanohama (JPTHM)"
  },
  {
   value: "\"Tanoura (JPTUR)",
   label: "\"Tanoura (JPTUR)"
  },
  {
   value: "\"Tanoura (JPTNR)",
   label: "\"Tanoura (JPTNR)"
  },
  {
   value: "Tanoura\/Kitakyushu (JPTNU)",
   label: "Tanoura\/Kitakyushu (JPTNU)"
  },
  {
   value: "Tanowaki (JPTNW)",
   label: "Tanowaki (JPTNW)"
  },
  {
   value: "Taramajima (JPTRA)",
   label: "Taramajima (JPTRA)"
  },
  {
   value: "Tarugahama (JPTRH)",
   label: "Tarugahama (JPTRH)"
  },
  {
   value: "Tarumi\/Kobe (JPTRI)",
   label: "Tarumi\/Kobe (JPTRI)"
  },
  {
   value: "Tarumizu (JPTMZ)",
   label: "Tarumizu (JPTMZ)"
  },
  {
   value: "Tasumi (JPTSS)",
   label: "Tasumi (JPTSS)"
  },
  {
   value: "\"Tateishi (JPTET)",
   label: "\"Tateishi (JPTET)"
  },
  {
   value: "\"Tateishi (JPTTS)",
   label: "\"Tateishi (JPTTS)"
  },
  {
   value: "Tateyama (JPTTY)",
   label: "Tateyama (JPTTY)"
  },
  {
   value: "Tatsugo (JPTAT)",
   label: "Tatsugo (JPTAT)"
  },
  {
   value: "Taura (JPTAU)",
   label: "Taura (JPTAU)"
  },
  {
   value: "Tayui (JPTYU)",
   label: "Tayui (JPTYU)"
  },
  {
   value: "Tei (JPTEI)",
   label: "Tei (JPTEI)"
  },
  {
   value: "Teishi (JPTIS)",
   label: "Teishi (JPTIS)"
  },
  {
   value: "Tekutsuku (JPTEK)",
   label: "Tekutsuku (JPTEK)"
  },
  {
   value: "Teradomari (JPTRD)",
   label: "Teradomari (JPTRD)"
  },
  {
   value: "Terazu\/Matsue (JPTZU)",
   label: "Terazu\/Matsue (JPTZU)"
  },
  {
   value: "Terazu\/Yatsuka (JPTRZ)",
   label: "Terazu\/Yatsuka (JPTRZ)"
  },
  {
   value: "Teshima (JPTSI)",
   label: "Teshima (JPTSI)"
  },
  {
   value: "Teshio (JPTSO)",
   label: "Teshio (JPTSO)"
  },
  {
   value: "Teuchi (JPTEU)",
   label: "Teuchi (JPTEU)"
  },
  {
   value: "Teuri (JPTER)",
   label: "Teuri (JPTER)"
  },
  {
   value: "Tago (JPTAO)",
   label: "Tago (JPTAO)"
  },
  {
   value: "Tagonoura (JPTGO)",
   label: "Tagonoura (JPTGO)"
  },
  {
   value: "Taguma (JPTGM)",
   label: "Taguma (JPTGM)"
  },
  {
   value: "Tahara (JPTAR)",
   label: "Tahara (JPTAR)"
  },
  {
   value: "Tai (JPTAZ)",
   label: "Tai (JPTAZ)"
  },
  {
   value: "Tainokawa (JPTKW)",
   label: "Tainokawa (JPTKW)"
  },
  {
   value: "Tainouchi (JPTAL)",
   label: "Tainouchi (JPTAL)"
  },
  {
   value: "Tainoura (JPTIN)",
   label: "Tainoura (JPTIN)"
  },
  {
   value: "Taira (JPTAQ)",
   label: "Taira (JPTAQ)"
  },
  {
   value: "Tairadate (JPTDT)",
   label: "Tairadate (JPTDT)"
  },
  {
   value: "Taisha (JPTIA)",
   label: "Taisha (JPTIA)"
  },
  {
   value: "Taiza (JPTZA)",
   label: "Taiza (JPTZA)"
  },
  {
   value: "\"Tajiri (JPTAJ)",
   label: "\"Tajiri (JPTAJ)"
  },
  {
   value: "\"Tajiri (JPTJR)",
   label: "\"Tajiri (JPTJR)"
  },
  {
   value: "Takada (JPTKD)",
   label: "Takada (JPTKD)"
  },
  {
   value: "\"Takahama (JPTAH)",
   label: "\"Takahama (JPTAH)"
  },
  {
   value: "Takahama\/Amakusa (JPTKH)",
   label: "Takahama\/Amakusa (JPTKH)"
  },
  {
   value: "Takamatsu (JPTAK)",
   label: "Takamatsu (JPTAK)"
  },
  {
   value: "Takami (JPTMJ)",
   label: "Takami (JPTMJ)"
  },
  {
   value: "Takamijima (JPTAA)",
   label: "Takamijima (JPTAA)"
  },
  {
   value: "Takanabe (JPTNB)",
   label: "Takanabe (JPTNB)"
  },
  {
   value: "Takanokuchi (JPTKC)",
   label: "Takanokuchi (JPTKC)"
  },
  {
   value: "Takaoka (JPTKK)",
   label: "Takaoka (JPTKK)"
  },
  {
   value: "Takarajima (JPTJI)",
   label: "Takarajima (JPTJI)"
  },
  {
   value: "Takasago (JPTSG)",
   label: "Takasago (JPTSG)"
  },
  {
   value: "Takashima\/Masuda (JPTJK)",
   label: "Takashima\/Masuda (JPTJK)"
  },
  {
   value: "Takashima\/Nishisonogo (JPTSM)",
   label: "Takashima\/Nishisonogo (JPTSM)"
  },
  {
   value: "\"Takasu (JPTXK)",
   label: "\"Takasu (JPTXK)"
  },
  {
   value: "\"Takasu (JPTKG)",
   label: "\"Takasu (JPTKG)"
  },
  {
   value: "Take (JPTEE)",
   label: "Take (JPTEE)"
  },
  {
   value: "Takedatsu (JPTDJ)",
   label: "Takedatsu (JPTDJ)"
  },
  {
   value: "Takehara (JPTHR)",
   label: "Takehara (JPTHR)"
  },
  {
   value: "Takena (JPTEA)",
   label: "Takena (JPTEA)"
  },
  {
   value: "Takeno (JPTKE)",
   label: "Takeno (JPTKE)"
  },
  {
   value: "Takeshiki (JPTAS)",
   label: "Takeshiki (JPTAS)"
  },
  {
   value: "Takeshima (JPTSX)",
   label: "Takeshima (JPTSX)"
  },
  {
   value: "Taketomihigashi (JPTTH)",
   label: "Taketomihigashi (JPTTH)"
  },
  {
   value: "Taketoyo (JPTKT)",
   label: "Taketoyo (JPTKT)"
  },
  {
   value: "Takezaki (JPTKZ)",
   label: "Takezaki (JPTKZ)"
  },
  {
   value: "Shizuura (JPSZU)",
   label: "Shizuura (JPSZU)"
  },
  {
   value: "Shonan (JPSNN)",
   label: "Shonan (JPSNN)"
  },
  {
   value: "Shoura (JPSYO)",
   label: "Shoura (JPSYO)"
  },
  {
   value: "Shukunoura (JPSNR)",
   label: "Shukunoura (JPSNR)"
  },
  {
   value: "Shushi (JPSHU)",
   label: "Shushi (JPSHU)"
  },
  {
   value: "Sodegaura (JPSDU)",
   label: "Sodegaura (JPSDU)"
  },
  {
   value: "Sogo (JPSOG)",
   label: "Sogo (JPSOG)"
  },
  {
   value: "Sonai\/Taketomi (JPSNI)",
   label: "Sonai\/Taketomi (JPSNI)"
  },
  {
   value: "Sonai\/Yonaguni (JPSNA)",
   label: "Sonai\/Yonaguni (JPSNA)"
  },
  {
   value: "Sone (JPSNE)",
   label: "Sone (JPSNE)"
  },
  {
   value: "Sonogi (JPSGX)",
   label: "Sonogi (JPSGX)"
  },
  {
   value: "Sonoura (JPSOR)",
   label: "Sonoura (JPSOR)"
  },
  {
   value: "Sonoyama (JPSYM)",
   label: "Sonoyama (JPSYM)"
  },
  {
   value: "Sotodomari\/Nishiumi (JPSOT)",
   label: "Sotodomari\/Nishiumi (JPSOT)"
  },
  {
   value: "Souma (JPSMA)",
   label: "Souma (JPSMA)"
  },
  {
   value: "Soya (JPSOY)",
   label: "Soya (JPSOY)"
  },
  {
   value: "Sozu (JPSOZ)",
   label: "Sozu (JPSOZ)"
  },
  {
   value: "Suga (JPSUG)",
   label: "Suga (JPSUG)"
  },
  {
   value: "Sugawa (JPSUU)",
   label: "Sugawa (JPSUU)"
  },
  {
   value: "Suge (JPSGE)",
   label: "Suge (JPSGE)"
  },
  {
   value: "Sugeura (JPSUR)",
   label: "Sugeura (JPSUR)"
  },
  {
   value: "Sukumo (JPSUK)",
   label: "Sukumo (JPSUK)"
  },
  {
   value: "Sumie (JPSMI)",
   label: "Sumie (JPSMI)"
  },
  {
   value: "Suminoe (JPSUM)",
   label: "Suminoe (JPSUM)"
  },
  {
   value: "Sumiyoshi (JPSMY)",
   label: "Sumiyoshi (JPSMY)"
  },
  {
   value: "\"Sumoto (JPSUH)",
   label: "\"Sumoto (JPSUH)"
  },
  {
   value: "\"Sumoto (JPSUT)",
   label: "\"Sumoto (JPSUT)"
  },
  {
   value: "Sunami (JPSXM)",
   label: "Sunami (JPSXM)"
  },
  {
   value: "Sunoe (JPSUE)",
   label: "Sunoe (JPSUE)"
  },
  {
   value: "Susa (JPSUS)",
   label: "Susa (JPSUS)"
  },
  {
   value: "Susaki (JPSUZ)",
   label: "Susaki (JPSUZ)"
  },
  {
   value: "Suttsu (JPSTU)",
   label: "Suttsu (JPSTU)"
  },
  {
   value: "Suwa (JPSUW)",
   label: "Suwa (JPSUW)"
  },
  {
   value: "Tabira (JPTBR)",
   label: "Tabira (JPTBR)"
  },
  {
   value: "Tabu (JPTBU)",
   label: "Tabu (JPTBU)"
  },
  {
   value: "Tabugawa (JPTAB)",
   label: "Tabugawa (JPTAB)"
  },
  {
   value: "Tachibana (JPTBN)",
   label: "Tachibana (JPTBN)"
  },
  {
   value: "Tachiyama (JPTAC)",
   label: "Tachiyama (JPTAC)"
  },
  {
   value: "Tadanoumi (JPTDN)",
   label: "Tadanoumi (JPTDN)"
  },
  {
   value: "Tadotsu (JPTAD)",
   label: "Tadotsu (JPTAD)"
  },
  {
   value: "Tagi (JPTAG)",
   label: "Tagi (JPTAG)"
  },
  {
   value: "\"Shinkawa (JPSKW)",
   label: "\"Shinkawa (JPSKW)"
  },
  {
   value: "Shinkiba (JPSHK)",
   label: "Shinkiba (JPSHK)"
  },
  {
   value: "Shinojima (JPSNJ)",
   label: "Shinojima (JPSNJ)"
  },
  {
   value: "Shinokawa (JPSNW)",
   label: "Shinokawa (JPSNW)"
  },
  {
   value: "Shinzaike (JPSNZ)",
   label: "Shinzaike (JPSNZ)"
  },
  {
   value: "Shiogama (JPSGM)",
   label: "Shiogama (JPSGM)"
  },
  {
   value: "Shiogatani (JPSGT)",
   label: "Shiogatani (JPSGT)"
  },
  {
   value: "Shiohama (JPSOH)",
   label: "Shiohama (JPSOH)"
  },
  {
   value: "\"Shioya (JPSIO)",
   label: "\"Shioya (JPSIO)"
  },
  {
   value: "\"Shioya (JPSYA)",
   label: "\"Shioya (JPSYA)"
  },
  {
   value: "Shioyagamoto (JPSYG)",
   label: "Shioyagamoto (JPSYG)"
  },
  {
   value: "\"Shirahama (JPSRX)",
   label: "\"Shirahama (JPSRX)"
  },
  {
   value: "\"Shirahama (JPSRH)",
   label: "\"Shirahama (JPSRH)"
  },
  {
   value: "\"Shirahama (JPSHH)",
   label: "\"Shirahama (JPSHH)"
  },
  {
   value: "\"Shirahama (JPSIR)",
   label: "\"Shirahama (JPSIR)"
  },
  {
   value: "\"Shirahama (JPSIH)",
   label: "\"Shirahama (JPSIH)"
  },
  {
   value: "\"Shirahama (JPSHM)",
   label: "\"Shirahama (JPSHM)"
  },
  {
   value: "Shirakata (JPSRT)",
   label: "Shirakata (JPSRT)"
  },
  {
   value: "Shiraki (JPSRA)",
   label: "Shiraki (JPSRA)"
  },
  {
   value: "Shiraku (JPSKU)",
   label: "Shiraku (JPSKU)"
  },
  {
   value: "Shiraoi (JPSRO)",
   label: "Shiraoi (JPSRO)"
  },
  {
   value: "Shiriyazaki (JPSYZ)",
   label: "Shiriyazaki (JPSYZ)"
  },
  {
   value: "Shiro (JPSRJ)",
   label: "Shiro (JPSRJ)"
  },
  {
   value: "Shiroko (JPSJR)",
   label: "Shiroko (JPSJR)"
  },
  {
   value: "Shirosaki (JPSRK)",
   label: "Shirosaki (JPSRK)"
  },
  {
   value: "Shirose (JPSRS)",
   label: "Shirose (JPSRS)"
  },
  {
   value: "Shirotori (JPSTR)",
   label: "Shirotori (JPSTR)"
  },
  {
   value: "Shisakajima (JPSSJ)",
   label: "Shisakajima (JPSSJ)"
  },
  {
   value: "Shishiboe (JPSSH)",
   label: "Shishiboe (JPSSH)"
  },
  {
   value: "\"Shishijima (JPSJI)",
   label: "\"Shishijima (JPSJI)"
  },
  {
   value: "\"Shishijima (JPSJM)",
   label: "\"Shishijima (JPSJM)"
  },
  {
   value: "Shishikui (JPSIS)",
   label: "Shishikui (JPSIS)"
  },
  {
   value: "Shishimi (JPSSM)",
   label: "Shishimi (JPSSM)"
  },
  {
   value: "Shitaba (JPSTB)",
   label: "Shitaba (JPSTB)"
  },
  {
   value: "Shitanoe (JPSNO)",
   label: "Shitanoe (JPSNO)"
  },
  {
   value: "Shitanoura (JPSIT)",
   label: "Shitanoura (JPSIT)"
  },
  {
   value: "Shitooke (JPSDK)",
   label: "Shitooke (JPSDK)"
  },
  {
   value: "Shizugawa (JPSZG)",
   label: "Shizugawa (JPSZG)"
  },
  {
   value: "Sezaki (JPSEZ)",
   label: "Sezaki (JPSEZ)"
  },
  {
   value: "Shari (JPSHR)",
   label: "Shari (JPSHR)"
  },
  {
   value: "Shibaura (JPSBU)",
   label: "Shibaura (JPSBU)"
  },
  {
   value: "Shibayama (JPSBY)",
   label: "Shibayama (JPSBY)"
  },
  {
   value: "Shibukawa (JPSKB)",
   label: "Shibukawa (JPSKB)"
  },
  {
   value: "Shibushi (JPSBS)",
   label: "Shibushi (JPSBS)"
  },
  {
   value: "Shichirinagahama (JPSCH)",
   label: "Shichirinagahama (JPSCH)"
  },
  {
   value: "Shichirui (JPSCR)",
   label: "Shichirui (JPSCR)"
  },
  {
   value: "Shido (JPSID)",
   label: "Shido (JPSID)"
  },
  {
   value: "Shigei (JPSIG)",
   label: "Shigei (JPSIG)"
  },
  {
   value: "Shigetomi (JPSGI)",
   label: "Shigetomi (JPSGI)"
  },
  {
   value: "Shiinoki (JPSIN)",
   label: "Shiinoki (JPSIN)"
  },
  {
   value: "Shikama (JPSKM)",
   label: "Shikama (JPSKM)"
  },
  {
   value: "Shikamachi (JPSIK)",
   label: "Shikamachi (JPSIK)"
  },
  {
   value: "Shikata (JPSTJ)",
   label: "Shikata (JPSTJ)"
  },
  {
   value: "Shikaura (JPSAR)",
   label: "Shikaura (JPSAR)"
  },
  {
   value: "Shikinejima (JPSKN)",
   label: "Shikinejima (JPSKN)"
  },
  {
   value: "Shimabara (JPSMB)",
   label: "Shimabara (JPSMB)"
  },
  {
   value: "Shimama (JPSIM)",
   label: "Shimama (JPSIM)"
  },
  {
   value: "Shimamaki (JPSMM)",
   label: "Shimamaki (JPSMM)"
  },
  {
   value: "Shimanoura (JPSNU)",
   label: "Shimanoura (JPSNU)"
  },
  {
   value: "Shimazuya (JPSHZ)",
   label: "Shimazuya (JPSHZ)"
  },
  {
   value: "Shimizu (JPSMZ)",
   label: "Shimizu (JPSMZ)"
  },
  {
   value: "\"Shimoda (JPSMO)",
   label: "\"Shimoda (JPSMO)"
  },
  {
   value: "\"Shimoda (JPSIA)",
   label: "\"Shimoda (JPSIA)"
  },
  {
   value: "\"Shimoda (JPSMD)",
   label: "\"Shimoda (JPSMD)"
  },
  {
   value: "Shimodomari\/Mikame (JPSMR)",
   label: "Shimodomari\/Mikame (JPSMR)"
  },
  {
   value: "Shimohisage (JPSMH)",
   label: "Shimohisage (JPSMH)"
  },
  {
   value: "Shimojishima (JPSHI)",
   label: "Shimojishima (JPSHI)"
  },
  {
   value: "Shimokawaguchi (JPSWA)",
   label: "Shimokawaguchi (JPSWA)"
  },
  {
   value: "Shimonokae (JPSOO)",
   label: "Shimonokae (JPSOO)"
  },
  {
   value: "Shimonoseki (JPSHS)",
   label: "Shimonoseki (JPSHS)"
  },
  {
   value: "Shimotsu (JPSMT)",
   label: "Shimotsu (JPSMT)"
  },
  {
   value: "Shimotsui (JPSTI)",
   label: "Shimotsui (JPSTI)"
  },
  {
   value: "Shimotsuura (JPSSA)",
   label: "Shimotsuura (JPSSA)"
  },
  {
   value: "Shinagawa (JPSHG)",
   label: "Shinagawa (JPSHG)"
  },
  {
   value: "Shingu (JPSHN)",
   label: "Shingu (JPSHN)"
  },
  {
   value: "Shinjima (JPSZI)",
   label: "Shinjima (JPSZI)"
  },
  {
   value: "\"Shinkawa (JPSNK)",
   label: "\"Shinkawa (JPSNK)"
  },
  {
   value: "Sakata (JPSKT)",
   label: "Sakata (JPSKT)"
  },
  {
   value: "Sakate (JPSAT)",
   label: "Sakate (JPSAT)"
  },
  {
   value: "Sakihama (JPSKH)",
   label: "Sakihama (JPSKH)"
  },
  {
   value: "Sakimui (JPSMU)",
   label: "Sakimui (JPSMU)"
  },
  {
   value: "Sakito (JPSTO)",
   label: "Sakito (JPSTO)"
  },
  {
   value: "Sakitsu (JPSAU)",
   label: "Sakitsu (JPSAU)"
  },
  {
   value: "Sakoshi (JPSKO)",
   label: "Sakoshi (JPSKO)"
  },
  {
   value: "Sakuraikako (JPSKR)",
   label: "Sakuraikako (JPSKR)"
  },
  {
   value: "Sakurajima (JPSRZ)",
   label: "Sakurajima (JPSRZ)"
  },
  {
   value: "Samani (JPSAM)",
   label: "Samani (JPSAM)"
  },
  {
   value: "Same (JPSME)",
   label: "Same (JPSME)"
  },
  {
   value: "Samukawa (JPSMK)",
   label: "Samukawa (JPSMK)"
  },
  {
   value: "Sanagi (JPSNX)",
   label: "Sanagi (JPSNX)"
  },
  {
   value: "Sanami (JPSNM)",
   label: "Sanami (JPSNM)"
  },
  {
   value: "Sanbonmatsu (JPSAN)",
   label: "Sanbonmatsu (JPSAN)"
  },
  {
   value: "Sapporo (JPSPK)",
   label: "Sapporo (JPSPK)"
  },
  {
   value: "Sasago (JPSAS)",
   label: "Sasago (JPSAS)"
  },
  {
   value: "Sasebo (JPSSB)",
   label: "Sasebo (JPSSB)"
  },
  {
   value: "Sashiki (JPSSI)",
   label: "Sashiki (JPSSI)"
  },
  {
   value: "Sasue (JPSSE)",
   label: "Sasue (JPSSE)"
  },
  {
   value: "Sasuna (JPSSN)",
   label: "Sasuna (JPSSN)"
  },
  {
   value: "Sata (JPSTA)",
   label: "Sata (JPSTA)"
  },
  {
   value: "Sato (JPSAO)",
   label: "Sato (JPSAO)"
  },
  {
   value: "Satoura (JPSTE)",
   label: "Satoura (JPSTE)"
  },
  {
   value: "Satsukawawan (JPSTW)",
   label: "Satsukawawan (JPSTW)"
  },
  {
   value: "Sayama (JPSAA)",
   label: "Sayama (JPSAA)"
  },
  {
   value: "Saza (JPSAZ)",
   label: "Saza (JPSAZ)"
  },
  {
   value: "Se\/Izuhara (JPSEQ)",
   label: "Se\/Izuhara (JPSEQ)"
  },
  {
   value: "Segawa (JPSGW)",
   label: "Segawa (JPSGW)"
  },
  {
   value: "Seigaura (JPSEG)",
   label: "Seigaura (JPSEG)"
  },
  {
   value: "Sekinehama (JPSEK)",
   label: "Sekinehama (JPSEK)"
  },
  {
   value: "Sekiya (JPSKY)",
   label: "Sekiya (JPSKY)"
  },
  {
   value: "\"Sendai (JPSEN)",
   label: "\"Sendai (JPSEN)"
  },
  {
   value: "\"Sendai (JPSDJ)",
   label: "\"Sendai (JPSDJ)"
  },
  {
   value: "Sendaishinko (JPSDS)",
   label: "Sendaishinko (JPSDS)"
  },
  {
   value: "Senzaki (JPSZK)",
   label: "Senzaki (JPSZK)"
  },
  {
   value: "Sesoko (JPSES)",
   label: "Sesoko (JPSES)"
  },
  {
   value: "Setana (JPSTN)",
   label: "Setana (JPSTN)"
  },
  {
   value: "\"Seto (JPSXT)",
   label: "\"Seto (JPSXT)"
  },
  {
   value: "\"Seto (JPSTT)",
   label: "\"Seto (JPSTT)"
  },
  {
   value: "Setoda (JPSTD)",
   label: "Setoda (JPSTD)"
  },
  {
   value: "Oura\/Marugame (JPORX)",
   label: "Oura\/Marugame (JPORX)"
  },
  {
   value: "Oura\/Uchinoura (JPORR)",
   label: "Oura\/Uchinoura (JPORR)"
  },
  {
   value: "Owase (JPOWA)",
   label: "Owase (JPOWA)"
  },
  {
   value: "Oyabu (JPOYB)",
   label: "Oyabu (JPOYB)"
  },
  {
   value: "Ozaki (JPOZX)",
   label: "Ozaki (JPOZX)"
  },
  {
   value: "Ozu (JPOOO)",
   label: "Ozu (JPOOO)"
  },
  {
   value: "Ozuku (JPOZU)",
   label: "Ozuku (JPOZU)"
  },
  {
   value: "Rausu (JPRAU)",
   label: "Rausu (JPRAU)"
  },
  {
   value: "Rebun (JPRBJ)",
   label: "Rebun (JPRBJ)"
  },
  {
   value: "Reihoku (JPRHK)",
   label: "Reihoku (JPRHK)"
  },
  {
   value: "Rishiri (JPRIS)",
   label: "Rishiri (JPRIS)"
  },
  {
   value: "Rokko Island (JPRKO)",
   label: "Rokko Island (JPRKO)"
  },
  {
   value: "Ronden (JPRND)",
   label: "Ronden (JPRND)"
  },
  {
   value: "Rumoi (JPRMI)",
   label: "Rumoi (JPRMI)"
  },
  {
   value: "Ryohshida (JPRYS)",
   label: "Ryohshida (JPRYS)"
  },
  {
   value: "Ryotsu (JPRYO)",
   label: "Ryotsu (JPRYO)"
  },
  {
   value: "Ryugamizu (JPRYG)",
   label: "Ryugamizu (JPRYG)"
  },
  {
   value: "Saba (JPSAB)",
   label: "Saba (JPSAB)"
  },
  {
   value: "Sado (JPSDO)",
   label: "Sado (JPSDO)"
  },
  {
   value: "\"Saga (JPSGA)",
   label: "\"Saga (JPSGA)"
  },
  {
   value: "\"Saga (JPQSG)",
   label: "\"Saga (JPQSG)"
  },
  {
   value: "Saganoseki (JPSAG)",
   label: "Saganoseki (JPSAG)"
  },
  {
   value: "Sagara (JPSGR)",
   label: "Sagara (JPSGR)"
  },
  {
   value: "Sagawa (JPSAW)",
   label: "Sagawa (JPSAW)"
  },
  {
   value: "Sagi (JPSGJ)",
   label: "Sagi (JPSGJ)"
  },
  {
   value: "\"Sai (JPSJA)",
   label: "\"Sai (JPSJA)"
  },
  {
   value: "\"Sai (JPSAC)",
   label: "\"Sai (JPSAC)"
  },
  {
   value: "Saidaiji (JPSDZ)",
   label: "Saidaiji (JPSDZ)"
  },
  {
   value: "Saidoh (JPSAD)",
   label: "Saidoh (JPSAD)"
  },
  {
   value: "\"Saigo (JPSGU)",
   label: "\"Saigo (JPSGU)"
  },
  {
   value: "\"Saigo (JPSAI)",
   label: "\"Saigo (JPSAI)"
  },
  {
   value: "Saijo (JPSAJ)",
   label: "Saijo (JPSAJ)"
  },
  {
   value: "Saiki (JPSAE)",
   label: "Saiki (JPSAE)"
  },
  {
   value: "Saitozaki (JPSTZ)",
   label: "Saitozaki (JPSTZ)"
  },
  {
   value: "Saizaki (JPSSK)",
   label: "Saizaki (JPSSK)"
  },
  {
   value: "Sakai (JPSAK)",
   label: "Sakai (JPSAK)"
  },
  {
   value: "Sakaide (JPSKD)",
   label: "Sakaide (JPSKD)"
  },
  {
   value: "Sakaiminato (JPSMN)",
   label: "Sakaiminato (JPSMN)"
  },
  {
   value: "Sakaisenboku (JPSBK)",
   label: "Sakaisenboku (JPSBK)"
  },
  {
   value: "Sakaki (JPSKK)",
   label: "Sakaki (JPSKK)"
  },
  {
   value: "Omura (JPOMJ)",
   label: "Omura (JPOMJ)"
  },
  {
   value: "Omuta (JPOMU)",
   label: "Omuta (JPOMU)"
  },
  {
   value: "Onagawa (JPONG)",
   label: "Onagawa (JPONG)"
  },
  {
   value: "Onahama (JPONA)",
   label: "Onahama (JPONA)"
  },
  {
   value: "Ongachi (JPOGC)",
   label: "Ongachi (JPOGC)"
  },
  {
   value: "Oniike (JPONJ)",
   label: "Oniike (JPONJ)"
  },
  {
   value: "Oniki (JPONK)",
   label: "Oniki (JPONK)"
  },
  {
   value: "Onishi (JPONI)",
   label: "Onishi (JPONI)"
  },
  {
   value: "Oniwaki (JPONW)",
   label: "Oniwaki (JPONW)"
  },
  {
   value: "Onoaida (JPOAD)",
   label: "Onoaida (JPOAD)"
  },
  {
   value: "Onoda (JPOND)",
   label: "Onoda (JPOND)"
  },
  {
   value: "Onomichi (JPONO)",
   label: "Onomichi (JPONO)"
  },
  {
   value: "OnomichiItozaki (JPONX)",
   label: "OnomichiItozaki (JPONX)"
  },
  {
   value: "Onuki (JPONU)",
   label: "Onuki (JPONU)"
  },
  {
   value: "Origami (JPORG)",
   label: "Origami (JPORG)"
  },
  {
   value: "Orino (JPORN)",
   label: "Orino (JPORN)"
  },
  {
   value: "Osaka (JPOSA)",
   label: "Osaka (JPOSA)"
  },
  {
   value: "\"Osaka (JPOUK)",
   label: "\"Osaka (JPOUK)"
  },
  {
   value: "\"Osaki (JPOSX)",
   label: "\"Osaki (JPOSX)"
  },
  {
   value: "\"Osaki (JPOSK)",
   label: "\"Osaki (JPOSK)"
  },
  {
   value: "Osaki\/Mitsushima (JPOSN)",
   label: "Osaki\/Mitsushima (JPOSN)"
  },
  {
   value: "Osako (JPOJO)",
   label: "Osako (JPOJO)"
  },
  {
   value: "Osato (JPOTO)",
   label: "Osato (JPOTO)"
  },
  {
   value: "Osetoyanagi (JPOST)",
   label: "Osetoyanagi (JPOST)"
  },
  {
   value: "Oshidomari (JPOSD)",
   label: "Oshidomari (JPOSD)"
  },
  {
   value: "\"Oshima (JPOSL)",
   label: "\"Oshima (JPOSL)"
  },
  {
   value: "Osoe (JPOSE)",
   label: "Osoe (JPOSE)"
  },
  {
   value: "Osuki (JPOSU)",
   label: "Osuki (JPOSU)"
  },
  {
   value: "Otake (JPOTK)",
   label: "Otake (JPOTK)"
  },
  {
   value: "Otao (JPOTA)",
   label: "Otao (JPOTA)"
  },
  {
   value: "Otaru (JPOTR)",
   label: "Otaru (JPOTR)"
  },
  {
   value: "Otawa (JPOTW)",
   label: "Otawa (JPOTW)"
  },
  {
   value: "Otomi (JPOTM)",
   label: "Otomi (JPOTM)"
  },
  {
   value: "\"Otsu (JPOSJ)",
   label: "\"Otsu (JPOSJ)"
  },
  {
   value: "\"Otsu (JPOTU)",
   label: "\"Otsu (JPOTU)"
  },
  {
   value: "Otsuchi (JPOTJ)",
   label: "Otsuchi (JPOTJ)"
  },
  {
   value: "\"Oura (JPOOA)",
   label: "\"Oura (JPOOA)"
  },
  {
   value: "Oura\/Ariake (JPOUA)",
   label: "Oura\/Ariake (JPOUA)"
  },
  {
   value: "Oura\/Kamitsushima (JPOUR)",
   label: "Oura\/Kamitsushima (JPOUR)"
  },
  {
   value: "Oura\/Kasaoka (JPOOR)",
   label: "Oura\/Kasaoka (JPOOR)"
  },
  {
   value: "Oiso (JPOIS)",
   label: "Oiso (JPOIS)"
  },
  {
   value: "Oita (JPOIT)",
   label: "Oita (JPOIT)"
  },
  {
   value: "Ojika (JPOJI)",
   label: "Ojika (JPOJI)"
  },
  {
   value: "Ojoya (JPOYA)",
   label: "Ojoya (JPOYA)"
  },
  {
   value: "Okada (JPOAA)",
   label: "Okada (JPOAA)"
  },
  {
   value: "Okadama Apt\/Sapporo (JPOKD)",
   label: "Okadama Apt\/Sapporo (JPOKD)"
  },
  {
   value: "Okamoto (JPOKM)",
   label: "Okamoto (JPOKM)"
  },
  {
   value: "Okamura (JPOMR)",
   label: "Okamura (JPOMR)"
  },
  {
   value: "\"Okawa (JPOOW)",
   label: "\"Okawa (JPOOW)"
  },
  {
   value: "\"Okawa (JPOKW)",
   label: "\"Okawa (JPOKW)"
  },
  {
   value: "Okayama (JPOKJ)",
   label: "Okayama (JPOKJ)"
  },
  {
   value: "Oki (JPOKI)",
   label: "Oki (JPOKI)"
  },
  {
   value: "Okinajima (JPOKN)",
   label: "Okinajima (JPOKN)"
  },
  {
   value: "Okinawa (JPOKA)",
   label: "Okinawa (JPOKA)"
  },
  {
   value: "Okinoerabu (JPOKE)",
   label: "Okinoerabu (JPOKE)"
  },
  {
   value: "Okinokojima (JPOKK)",
   label: "Okinokojima (JPOKK)"
  },
  {
   value: "\"Okitsu (JPOKC)",
   label: "\"Okitsu (JPOKC)"
  },
  {
   value: "\"Okitsu (JPOKT)",
   label: "\"Okitsu (JPOKT)"
  },
  {
   value: "\"Okiura (JPOIU)",
   label: "\"Okiura (JPOIU)"
  },
  {
   value: "\"Okiura (JPOKX)",
   label: "\"Okiura (JPOKX)"
  },
  {
   value: "Okiuranishi (JPOKS)",
   label: "Okiuranishi (JPOKS)"
  },
  {
   value: "Okogi (JPOKG)",
   label: "Okogi (JPOKG)"
  },
  {
   value: "Oku (JPOKU)",
   label: "Oku (JPOKU)"
  },
  {
   value: "\"Okubo (JPOOJ)",
   label: "\"Okubo (JPOOJ)"
  },
  {
   value: "\"Okubo (JPOKB)",
   label: "\"Okubo (JPOKB)"
  },
  {
   value: "Okunouchi (JPOCH)",
   label: "Okunouchi (JPOCH)"
  },
  {
   value: "Okushiri (JPOIR)",
   label: "Okushiri (JPOIR)"
  },
  {
   value: "Oma (JPOAX)",
   label: "Oma (JPOAX)"
  },
  {
   value: "Omaezaki (JPOMZ)",
   label: "Omaezaki (JPOMZ)"
  },
  {
   value: "Omi (JPOMI)",
   label: "Omi (JPOMI)"
  },
  {
   value: "Ominato (JPOMT)",
   label: "Ominato (JPOMT)"
  },
  {
   value: "Omishima (JPOMS)",
   label: "Omishima (JPOMS)"
  },
  {
   value: "Omiyaji (JPOMY)",
   label: "Omiyaji (JPOMY)"
  },
  {
   value: "Omodaka (JPOMD)",
   label: "Omodaka (JPOMD)"
  },
  {
   value: "Omon (JPOMN)",
   label: "Omon (JPOMN)"
  },
  {
   value: "Omonawa (JPOMW)",
   label: "Omonawa (JPOMW)"
  },
  {
   value: "Omosu (JPOJM)",
   label: "Omosu (JPOJM)"
  },
  {
   value: "Omotehama (JPOMH)",
   label: "Omotehama (JPOMH)"
  },
  {
   value: "Omoto (JPOMO)",
   label: "Omoto (JPOMO)"
  },
  {
   value: "Omu (JPOUM)",
   label: "Omu (JPOUM)"
  },
  {
   value: "Oginohama (JPOGH)",
   label: "Oginohama (JPOGH)"
  },
  {
   value: "Ogomori (JPOGM)",
   label: "Ogomori (JPOGM)"
  },
  {
   value: "\"Ohama (JPOHM)",
   label: "\"Ohama (JPOHM)"
  },
  {
   value: "\"Ohama (JPOHA)",
   label: "\"Ohama (JPOHA)"
  },
  {
   value: "\"Ohama (JPKHM)",
   label: "\"Ohama (JPKHM)"
  },
  {
   value: "\"Ohama (JPOOH)",
   label: "\"Ohama (JPOOH)"
  },
  {
   value: "\"Ohama (JPOMX)",
   label: "\"Ohama (JPOMX)"
  },
  {
   value: "Ohata (JPOHT)",
   label: "Ohata (JPOHT)"
  },
  {
   value: "\"Ohbe (JPOBX)",
   label: "\"Ohbe (JPOBX)"
  },
  {
   value: "Ohbishima (JPOBS)",
   label: "Ohbishima (JPOBS)"
  },
  {
   value: "Ohbukura\/Uwajima (JPOKR)",
   label: "Ohbukura\/Uwajima (JPOKR)"
  },
  {
   value: "Ohdana (JPODN)",
   label: "Ohdana (JPODN)"
  },
  {
   value: "Ohfukaura (JPOFR)",
   label: "Ohfukaura (JPOFR)"
  },
  {
   value: "Ohfunakoshi (JPOFK)",
   label: "Ohfunakoshi (JPOFK)"
  },
  {
   value: "Ohfunato (JPOFT)",
   label: "Ohfunato (JPOFT)"
  },
  {
   value: "Ohgaki (JPOOG)",
   label: "Ohgaki (JPOOG)"
  },
  {
   value: "Ohgasari (JPOSR)",
   label: "Ohgasari (JPOSR)"
  },
  {
   value: "Ohge (JPOGE)",
   label: "Ohge (JPOGE)"
  },
  {
   value: "Ohgishima (JPOGS)",
   label: "Ohgishima (JPOGS)"
  },
  {
   value: "Ohgushi (JPOGU)",
   label: "Ohgushi (JPOGU)"
  },
  {
   value: "Ohi (JPOHO)",
   label: "Ohi (JPOHO)"
  },
  {
   value: "Ohigawa (JPOIG)",
   label: "Ohigawa (JPOIG)"
  },
  {
   value: "Ohkawara (JPOKH)",
   label: "Ohkawara (JPOKH)"
  },
  {
   value: "Ohnejime (JPONE)",
   label: "Ohnejime (JPONE)"
  },
  {
   value: "Ohnishi\/Ohsaki (JPONS)",
   label: "Ohnishi\/Ohsaki (JPONS)"
  },
  {
   value: "Ohnoh (JPOON)",
   label: "Ohnoh (JPOON)"
  },
  {
   value: "Ohra (JPORA)",
   label: "Ohra (JPORA)"
  },
  {
   value: "Ohse (JPOUS)",
   label: "Ohse (JPOUS)"
  },
  {
   value: "\"Ohshima (JPOSI)",
   label: "\"Ohshima (JPOSI)"
  },
  {
   value: "\"Ohshima (JPOSS)",
   label: "\"Ohshima (JPOSS)"
  },
  {
   value: "\"Ohshima (JPOOM)",
   label: "\"Ohshima (JPOOM)"
  },
  {
   value: "\"Ohshima (JPOSO)",
   label: "\"Ohshima (JPOSO)"
  },
  {
   value: "\"Ohshima (JPOSH)",
   label: "\"Ohshima (JPOSH)"
  },
  {
   value: "\"Ohshima (JPOSM)",
   label: "\"Ohshima (JPOSM)"
  },
  {
   value: "\"Ohshima (JPOIM)",
   label: "\"Ohshima (JPOIM)"
  },
  {
   value: "Ohshima\/Hagi (JPHGS)",
   label: "Ohshima\/Hagi (JPHGS)"
  },
  {
   value: "Ohyama\/Mitsushima (JPOYM)",
   label: "Ohyama\/Mitsushima (JPOYM)"
  },
  {
   value: "Ohzuku (JPOZJ)",
   label: "Ohzuku (JPOZJ)"
  },
  {
   value: "Nishishioya (JPNSH)",
   label: "Nishishioya (JPNSH)"
  },
  {
   value: "Nishiura (JPNUR)",
   label: "Nishiura (JPNUR)"
  },
  {
   value: "Nita (JPNIA)",
   label: "Nita (JPNIA)"
  },
  {
   value: "Nobeoka (JPNOB)",
   label: "Nobeoka (JPNOB)"
  },
  {
   value: "Nobeokashinko (JPNBS)",
   label: "Nobeokashinko (JPNBS)"
  },
  {
   value: "Nobu\/Mitsushima (JPNBU)",
   label: "Nobu\/Mitsushima (JPNBU)"
  },
  {
   value: "Noh (JPNOU)",
   label: "Noh (JPNOU)"
  },
  {
   value: "Nohara (JPNOH)",
   label: "Nohara (JPNOH)"
  },
  {
   value: "Noheji (JPNHJ)",
   label: "Noheji (JPNHJ)"
  },
  {
   value: "Noho (JPNQH)",
   label: "Noho (JPNQH)"
  },
  {
   value: "Nojiri (JPNJR)",
   label: "Nojiri (JPNJR)"
  },
  {
   value: "Nomaike (JPNMK)",
   label: "Nomaike (JPNMK)"
  },
  {
   value: "Nomi (JPNMI)",
   label: "Nomi (JPNMI)"
  },
  {
   value: "Nomizaki (JPNOM)",
   label: "Nomizaki (JPNOM)"
  },
  {
   value: "Nonohama (JPNON)",
   label: "Nonohama (JPNON)"
  },
  {
   value: "Nonoichi (JPNCO)",
   label: "Nonoichi (JPNCO)"
  },
  {
   value: "Noshiro (JPNSR)",
   label: "Noshiro (JPNSR)"
  },
  {
   value: "Numazu (JPNUM)",
   label: "Numazu (JPNUM)"
  },
  {
   value: "Nunohama (JPNNH)",
   label: "Nunohama (JPNNH)"
  },
  {
   value: "Nyugawa (JPNWA)",
   label: "Nyugawa (JPNWA)"
  },
  {
   value: "Nyukou (JPNYK)",
   label: "Nyukou (JPNYK)"
  },
  {
   value: "Nyuzu (JPNYZ)",
   label: "Nyuzu (JPNYZ)"
  },
  {
   value: "Oarai (JPOAR)",
   label: "Oarai (JPOAR)"
  },
  {
   value: "\"Obama (JPOBA)",
   label: "\"Obama (JPOBA)"
  },
  {
   value: "\"Obama (JPOBB)",
   label: "\"Obama (JPOBB)"
  },
  {
   value: "\"Obama (JPOBM)",
   label: "\"Obama (JPOBM)"
  },
  {
   value: "Obatake (JPOOB)",
   label: "Obatake (JPOOB)"
  },
  {
   value: "\"Obe (JPOBE)",
   label: "\"Obe (JPOBE)"
  },
  {
   value: "Obihiro (JPOBO)",
   label: "Obihiro (JPOBO)"
  },
  {
   value: "Ochiyo (JPOOC)",
   label: "Ochiyo (JPOOC)"
  },
  {
   value: "Odahigashi (JPODA)",
   label: "Odahigashi (JPODA)"
  },
  {
   value: "Odeshima (JPODS)",
   label: "Odeshima (JPODS)"
  },
  {
   value: "Odoh (JPODO)",
   label: "Odoh (JPODO)"
  },
  {
   value: "Odomari (JPODM)",
   label: "Odomari (JPODM)"
  },
  {
   value: "Ogaki (JPOGG)",
   label: "Ogaki (JPOGG)"
  },
  {
   value: "Ogasawara (JPOGA)",
   label: "Ogasawara (JPOGA)"
  },
  {
   value: "Ogatsu (JPOAT)",
   label: "Ogatsu (JPOAT)"
  },
  {
   value: "\"Ogi (JPOII)",
   label: "\"Ogi (JPOII)"
  },
  {
   value: "\"Ogi (JPOGK)",
   label: "\"Ogi (JPOGK)"
  },
  {
   value: "\"Ogi (JPOGI)",
   label: "\"Ogi (JPOGI)"
  },
  {
   value: "Ogifushi (JPOGF)",
   label: "Ogifushi (JPOGF)"
  },
  {
   value: "Nanatsuyama (JPNTY)",
   label: "Nanatsuyama (JPNTY)"
  },
  {
   value: "Nanko (JPNKO)",
   label: "Nanko (JPNKO)"
  },
  {
   value: "Nanyo (JPNYO)",
   label: "Nanyo (JPNYO)"
  },
  {
   value: "Naoetsu (JPNAO)",
   label: "Naoetsu (JPNAO)"
  },
  {
   value: "Naoshima (JPNAS)",
   label: "Naoshima (JPNAS)"
  },
  {
   value: "Narao (JPNRO)",
   label: "Narao (JPNRO)"
  },
  {
   value: "Narita Apt\/Tokyo (JPNRT)",
   label: "Narita Apt\/Tokyo (JPNRT)"
  },
  {
   value: "Narushima (JPNRS)",
   label: "Narushima (JPNRS)"
  },
  {
   value: "Naruto (JPNRU)",
   label: "Naruto (JPNRU)"
  },
  {
   value: "Nasa (JPNSX)",
   label: "Nasa (JPNSX)"
  },
  {
   value: "Naze (JPNAZ)",
   label: "Naze (JPNAZ)"
  },
  {
   value: "Neghishi\/Yokohama (JPNGI)",
   label: "Neghishi\/Yokohama (JPNGI)"
  },
  {
   value: "Nejime (JPNEJ)",
   label: "Nejime (JPNEJ)"
  },
  {
   value: "Nemuro (JPNEM)",
   label: "Nemuro (JPNEM)"
  },
  {
   value: "Nenokuchi (JPNNK)",
   label: "Nenokuchi (JPNNK)"
  },
  {
   value: "Neo (JPNEO)",
   label: "Neo (JPNEO)"
  },
  {
   value: "Neyagawa (JPNYW)",
   label: "Neyagawa (JPNYW)"
  },
  {
   value: "Nezugaseki (JPNEZ)",
   label: "Nezugaseki (JPNEZ)"
  },
  {
   value: "Nichinan (JPNIC)",
   label: "Nichinan (JPNIC)"
  },
  {
   value: "Nigishima (JPNXG)",
   label: "Nigishima (JPNXG)"
  },
  {
   value: "Nii (JPNIX)",
   label: "Nii (JPNIX)"
  },
  {
   value: "Niigata (JPKIJ)",
   label: "Niigata (JPKIJ)"
  },
  {
   value: "Niigatahigashi (JPNIH)",
   label: "Niigatahigashi (JPNIH)"
  },
  {
   value: "Niigatanishi (JPNIN)",
   label: "Niigatanishi (JPNIN)"
  },
  {
   value: "Niihama (JPIHA)",
   label: "Niihama (JPIHA)"
  },
  {
   value: "Niijima (JPNIJ)",
   label: "Niijima (JPNIJ)"
  },
  {
   value: "Nima (JPNIM)",
   label: "Nima (JPNIM)"
  },
  {
   value: "Nio (JPNIO)",
   label: "Nio (JPNIO)"
  },
  {
   value: "Nishi\/Kitadaito (JPNID)",
   label: "Nishi\/Kitadaito (JPNID)"
  },
  {
   value: "Nishi\/Minamidaito (JPNDI)",
   label: "Nishi\/Minamidaito (JPNDI)"
  },
  {
   value: "Nishibe (JPNSB)",
   label: "Nishibe (JPNSB)"
  },
  {
   value: "Nishiesan (JPNSI)",
   label: "Nishiesan (JPNSI)"
  },
  {
   value: "Nishihara (JPNHR)",
   label: "Nishihara (JPNHR)"
  },
  {
   value: "Nishikata (JPNST)",
   label: "Nishikata (JPNST)"
  },
  {
   value: "Nishiki (JPNSK)",
   label: "Nishiki (JPNSK)"
  },
  {
   value: "Nishimaizuru (JPMAW)",
   label: "Nishimaizuru (JPMAW)"
  },
  {
   value: "Nishimura (JPNSM)",
   label: "Nishimura (JPNSM)"
  },
  {
   value: "Nishinaka (JPNIS)",
   label: "Nishinaka (JPNIS)"
  },
  {
   value: "Nishinomiya (JPNYA)",
   label: "Nishinomiya (JPNYA)"
  },
  {
   value: "Nishinoomote (JPIIN)",
   label: "Nishinoomote (JPIIN)"
  },
  {
   value: "\"Nagasu (JPNSU)",
   label: "\"Nagasu (JPNSU)"
  },
  {
   value: "\"Nagaura (JPNAA)",
   label: "\"Nagaura (JPNAA)"
  },
  {
   value: "Nagaura\/Yokosuka (JPNGR)",
   label: "Nagaura\/Yokosuka (JPNGR)"
  },
  {
   value: "Nagayama (JPMGY)",
   label: "Nagayama (JPMGY)"
  },
  {
   value: "Nagayo (JPNAY)",
   label: "Nagayo (JPNAY)"
  },
  {
   value: "Nagimi (JPNGM)",
   label: "Nagimi (JPNGM)"
  },
  {
   value: "Nagouda (JPNGD)",
   label: "Nagouda (JPNGD)"
  },
  {
   value: "\"Nagoya (JPNGO)",
   label: "\"Nagoya (JPNGO)"
  },
  {
   value: "\"Nagoya (JPNGY)",
   label: "\"Nagoya (JPNGY)"
  },
  {
   value: "Naha (JPNAH)",
   label: "Naha (JPNAH)"
  },
  {
   value: "Nahari (JPNHI)",
   label: "Nahari (JPNHI)"
  },
  {
   value: "Naigainoura (JPNGN)",
   label: "Naigainoura (JPNGN)"
  },
  {
   value: "Nakada (JPNKD)",
   label: "Nakada (JPNKD)"
  },
  {
   value: "Nakagusuku (JPNAK)",
   label: "Nakagusuku (JPNAK)"
  },
  {
   value: "\"Nakahama (JPNHA)",
   label: "\"Nakahama (JPNHA)"
  },
  {
   value: "\"Nakahama (JPNKJ)",
   label: "\"Nakahama (JPNKJ)"
  },
  {
   value: "\"Nakahama (JPNKH)",
   label: "\"Nakahama (JPNKH)"
  },
  {
   value: "Nakajima (JPNJM)",
   label: "Nakajima (JPNJM)"
  },
  {
   value: "Nakakoshi (JPNGK)",
   label: "Nakakoshi (JPNGK)"
  },
  {
   value: "Nakakoshiki (JPNKK)",
   label: "Nakakoshiki (JPNKK)"
  },
  {
   value: "\"Nakama (JPNKL)",
   label: "\"Nakama (JPNKL)"
  },
  {
   value: "\"Nakama (JPNKM)",
   label: "\"Nakama (JPNKM)"
  },
  {
   value: "Nakaminato (JPNMT)",
   label: "Nakaminato (JPNMT)"
  },
  {
   value: "Nakanosaku (JPNKX)",
   label: "Nakanosaku (JPNKX)"
  },
  {
   value: "Nakanoseki (JPNAN)",
   label: "Nakanoseki (JPNAN)"
  },
  {
   value: "Nakanoshima (JPNKS)",
   label: "Nakanoshima (JPNKS)"
  },
  {
   value: "Nakanoura (JPNKN)",
   label: "Nakanoura (JPNKN)"
  },
  {
   value: "Nakashibetsu (JPSHB)",
   label: "Nakashibetsu (JPSHB)"
  },
  {
   value: "Nakashima (JPNKZ)",
   label: "Nakashima (JPNKZ)"
  },
  {
   value: "\"Nakata (JPNKT)",
   label: "\"Nakata (JPNKT)"
  },
  {
   value: "\"Nakata (JPNTX)",
   label: "\"Nakata (JPNTX)"
  },
  {
   value: "Nakatsu (JPNAT)",
   label: "Nakatsu (JPNAT)"
  },
  {
   value: "Nakayama (JPNKY)",
   label: "Nakayama (JPNKY)"
  },
  {
   value: "Nakiri (JPNKR)",
   label: "Nakiri (JPNKR)"
  },
  {
   value: "Nama (JPNAM)",
   label: "Nama (JPNAM)"
  },
  {
   value: "Namikata (JPNIT)",
   label: "Namikata (JPNIT)"
  },
  {
   value: "Nanao (JPNNO)",
   label: "Nanao (JPNNO)"
  },
  {
   value: "Nanatsugama (JPNNT)",
   label: "Nanatsugama (JPNNT)"
  },
  {
   value: "Motoura\/Azuma (JPMTO)",
   label: "Motoura\/Azuma (JPMTO)"
  },
  {
   value: "Motoura\/Toshima (JPMOU)",
   label: "Motoura\/Toshima (JPMOU)"
  },
  {
   value: "Motozaru (JPMZR)",
   label: "Motozaru (JPMZR)"
  },
  {
   value: "Mugi (JPMUG)",
   label: "Mugi (JPMUG)"
  },
  {
   value: "Mukaishima (JPMUK)",
   label: "Mukaishima (JPMUK)"
  },
  {
   value: "Mukata (JPMKA)",
   label: "Mukata (JPMKA)"
  },
  {
   value: "Mukunoura (JPMKU)",
   label: "Mukunoura (JPMKU)"
  },
  {
   value: "Mure (JPMRE)",
   label: "Mure (JPMRE)"
  },
  {
   value: "Murokita (JPMRO)",
   label: "Murokita (JPMRO)"
  },
  {
   value: "Muromoto (JPMRM)",
   label: "Muromoto (JPMRM)"
  },
  {
   value: "Muroran (JPMUR)",
   label: "Muroran (JPMUR)"
  },
  {
   value: "Murotomisaki (JPMRJ)",
   label: "Murotomisaki (JPMRJ)"
  },
  {
   value: "\"Murotsu (JPMRS)",
   label: "\"Murotsu (JPMRS)"
  },
  {
   value: "\"Murotsu (JPMUX)",
   label: "\"Murotsu (JPMUX)"
  },
  {
   value: "\"Murotsu (JPMRT)",
   label: "\"Murotsu (JPMRT)"
  },
  {
   value: "Murozumi (JPMZM)",
   label: "Murozumi (JPMZM)"
  },
  {
   value: "Musashi (JPMSH)",
   label: "Musashi (JPMSH)"
  },
  {
   value: "Muta (JPSDA)",
   label: "Muta (JPSDA)"
  },
  {
   value: "Mutsuogawara (JPMUT)",
   label: "Mutsuogawara (JPMUT)"
  },
  {
   value: "Mutsure (JPMTR)",
   label: "Mutsure (JPMTR)"
  },
  {
   value: "Muya (JPMYA)",
   label: "Muya (JPMYA)"
  },
  {
   value: "Naarai (JPNAR)",
   label: "Naarai (JPNAR)"
  },
  {
   value: "Nadahama (JPNAD)",
   label: "Nadahama (JPNAD)"
  },
  {
   value: "Nadayama (JPNDY)",
   label: "Nadayama (JPNDY)"
  },
  {
   value: "\"Nagae (JPNEX)",
   label: "\"Nagae (JPNEX)"
  },
  {
   value: "\"Nagae (JPNGE)",
   label: "\"Nagae (JPNGE)"
  },
  {
   value: "\"Nagahama (JPNMA)",
   label: "\"Nagahama (JPNMA)"
  },
  {
   value: "\"Nagahama (JPNHM)",
   label: "\"Nagahama (JPNHM)"
  },
  {
   value: "\"Nagahama (JPNGH)",
   label: "\"Nagahama (JPNGH)"
  },
  {
   value: "\"Nagahama (JPNAG)",
   label: "\"Nagahama (JPNAG)"
  },
  {
   value: "Nagame (JPNGG)",
   label: "Nagame (JPNGG)"
  },
  {
   value: "Nagano (JPNNG)",
   label: "Nagano (JPNNG)"
  },
  {
   value: "Nagara (JPNAB)",
   label: "Nagara (JPNAB)"
  },
  {
   value: "Nagasaki (JPNGS)",
   label: "Nagasaki (JPNGS)"
  },
  {
   value: "NagasakiMieShikimi (JPNMX)",
   label: "NagasakiMieShikimi (JPNMX)"
  },
  {
   value: "Nagasakinohana (JPNHN)",
   label: "Nagasakinohana (JPNHN)"
  },
  {
   value: "Nagashima (JPNSA)",
   label: "Nagashima (JPNSA)"
  },
  {
   value: "\"Nagasu (JPNGU)",
   label: "\"Nagasu (JPNGU)"
  },
  {
   value: "\"Mitaka (JPMTA)",
   label: "\"Mitaka (JPMTA)"
  },
  {
   value: "Mitarai (JPMTI)",
   label: "Mitarai (JPMTI)"
  },
  {
   value: "\"Mito (JPMQT)",
   label: "\"Mito (JPMQT)"
  },
  {
   value: "Mitsuhama (JPMTH)",
   label: "Mitsuhama (JPMTH)"
  },
  {
   value: "Mitsukoshima (JPMKS)",
   label: "Mitsukoshima (JPMKS)"
  },
  {
   value: "Mitsukue (JPMTK)",
   label: "Mitsukue (JPMTK)"
  },
  {
   value: "Miura\/Mitsushima (JPMIR)",
   label: "Miura\/Mitsushima (JPMIR)"
  },
  {
   value: "Miyagahama (JPMYG)",
   label: "Miyagahama (JPMYG)"
  },
  {
   value: "Miyakejima Apt\/Tokyo (JPMYE)",
   label: "Miyakejima Apt\/Tokyo (JPMYE)"
  },
  {
   value: "\"Miyako (JPMYK)",
   label: "\"Miyako (JPMYK)"
  },
  {
   value: "Miyakojima (JPMMY)",
   label: "Miyakojima (JPMMY)"
  },
  {
   value: "\"Miyanoura (JPMUY)",
   label: "\"Miyanoura (JPMUY)"
  },
  {
   value: "\"Miyanoura (JPMNR)",
   label: "\"Miyanoura (JPMNR)"
  },
  {
   value: "Miyanoura\/Azuma (JPMYN)",
   label: "Miyanoura\/Azuma (JPMYN)"
  },
  {
   value: "Miyanoura\/Kamiyaku (JPMNO)",
   label: "Miyanoura\/Kamiyaku (JPMNO)"
  },
  {
   value: "Miyaura (JPMYU)",
   label: "Miyaura (JPMYU)"
  },
  {
   value: "\"Miyazaki (JPMZK)",
   label: "\"Miyazaki (JPMZK)"
  },
  {
   value: "\"Miyazaki (JPKMI)",
   label: "\"Miyazaki (JPKMI)"
  },
  {
   value: "Miyazu (JPMIY)",
   label: "Miyazu (JPMIY)"
  },
  {
   value: "Mizusaki (JPMZS)",
   label: "Mizusaki (JPMZS)"
  },
  {
   value: "Mizushima (JPMIZ)",
   label: "Mizushima (JPMIZ)"
  },
  {
   value: "Mochidoi (JPMCD)",
   label: "Mochidoi (JPMCD)"
  },
  {
   value: "Mochiishi (JPMCH)",
   label: "Mochiishi (JPMCH)"
  },
  {
   value: "Mogi (JPMOG)",
   label: "Mogi (JPMOG)"
  },
  {
   value: "Mogine (JPMGN)",
   label: "Mogine (JPMGN)"
  },
  {
   value: "Moji\/Kitakyushu (JPMOJ)",
   label: "Moji\/Kitakyushu (JPMOJ)"
  },
  {
   value: "Monbetsu\/Abashiri (JPMBE)",
   label: "Monbetsu\/Abashiri (JPMBE)"
  },
  {
   value: "Monoi (JPMOX)",
   label: "Monoi (JPMOX)"
  },
  {
   value: "Morakui (JPMRK)",
   label: "Morakui (JPMRK)"
  },
  {
   value: "Mori (JPMOR)",
   label: "Mori (JPMOR)"
  },
  {
   value: "Moriage (JPMRG)",
   label: "Moriage (JPMRG)"
  },
  {
   value: "Morie (JPMOO)",
   label: "Morie (JPMOO)"
  },
  {
   value: "Morinohama (JPMRH)",
   label: "Morinohama (JPMRH)"
  },
  {
   value: "Morioka (JPMRW)",
   label: "Morioka (JPMRW)"
  },
  {
   value: "Morodomi (JPMOM)",
   label: "Morodomi (JPMOM)"
  },
  {
   value: "Morozaki (JPMRZ)",
   label: "Morozaki (JPMRZ)"
  },
  {
   value: "Motobu (JPMBT)",
   label: "Motobu (JPMBT)"
  },
  {
   value: "Motomachi (JPMOT)",
   label: "Motomachi (JPMOT)"
  },
  {
   value: "Mei (JPMEN)",
   label: "Mei (JPMEN)"
  },
  {
   value: "Meihama (JPMEI)",
   label: "Meihama (JPMEI)"
  },
  {
   value: "Meitsu (JPMET)",
   label: "Meitsu (JPMET)"
  },
  {
   value: "Memanbetsu (JPMMB)",
   label: "Memanbetsu (JPMMB)"
  },
  {
   value: "MieShikimi (JPMSI)",
   label: "MieShikimi (JPMSI)"
  },
  {
   value: "Mihara (JPMHR)",
   label: "Mihara (JPMHR)"
  },
  {
   value: "Mihonoseki (JPMIH)",
   label: "Mihonoseki (JPMIH)"
  },
  {
   value: "Mihowan (JPMHN)",
   label: "Mihowan (JPMHN)"
  },
  {
   value: "\"Miike (JPMIJ)",
   label: "\"Miike (JPMIJ)"
  },
  {
   value: "\"Miike (JPMII)",
   label: "\"Miike (JPMII)"
  },
  {
   value: "Mikame (JPMKM)",
   label: "Mikame (JPMKM)"
  },
  {
   value: "Mikawa (JPMKW)",
   label: "Mikawa (JPMKW)"
  },
  {
   value: "Mikisato (JPMKJ)",
   label: "Mikisato (JPMKJ)"
  },
  {
   value: "Mikurajima (JPMKR)",
   label: "Mikurajima (JPMKR)"
  },
  {
   value: "Mimitsu (JPMMT)",
   label: "Mimitsu (JPMMT)"
  },
  {
   value: "Minamata (JPMIN)",
   label: "Minamata (JPMIN)"
  },
  {
   value: "Minami (JPMNM)",
   label: "Minami (JPMNM)"
  },
  {
   value: "Minamidaitojima (JPMMD)",
   label: "Minamidaitojima (JPMMD)"
  },
  {
   value: "\"Minato (JPMNT)",
   label: "\"Minato (JPMNT)"
  },
  {
   value: "Mine (JPMNE)",
   label: "Mine (JPMNE)"
  },
  {
   value: "Minmaya (JPMNY)",
   label: "Minmaya (JPMNY)"
  },
  {
   value: "Minna\/Motobu (JPMNJ)",
   label: "Minna\/Motobu (JPMNJ)"
  },
  {
   value: "Minna\/Tarama (JPMNN)",
   label: "Minna\/Tarama (JPMNN)"
  },
  {
   value: "\"Misaki (JPMSX)",
   label: "\"Misaki (JPMSX)"
  },
  {
   value: "\"Misaki (JPMIK)",
   label: "\"Misaki (JPMIK)"
  },
  {
   value: "\"Misaki (JPMKI)",
   label: "\"Misaki (JPMKI)"
  },
  {
   value: "Misato (JPMST)",
   label: "Misato (JPMST)"
  },
  {
   value: "Misawa (JPMSJ)",
   label: "Misawa (JPMSJ)"
  },
  {
   value: "\"Mishima (JPMSM)",
   label: "\"Mishima (JPMSM)"
  },
  {
   value: "MishimaKawanoe (JPMKX)",
   label: "MishimaKawanoe (JPMKX)"
  },
  {
   value: "Mishiro (JPMSR)",
   label: "Mishiro (JPMSR)"
  },
  {
   value: "Misho (JPMSO)",
   label: "Misho (JPMSO)"
  },
  {
   value: "\"Misumi (JPMIS)",
   label: "\"Misumi (JPMIS)"
  },
  {
   value: "\"Misumi (JPMMI)",
   label: "\"Misumi (JPMMI)"
  },
  {
   value: "Mita (JPMXT)",
   label: "Mita (JPMXT)"
  },
  {
   value: "Mitachi (JPMTC)",
   label: "Mitachi (JPMTC)"
  },
  {
   value: "Mitajiri (JPMJR)",
   label: "Mitajiri (JPMJR)"
  },
  {
   value: "MitajiriNakanoseki (JPMNX)",
   label: "MitajiriNakanoseki (JPMNX)"
  },
  {
   value: "\"Mitaka (JPMIT)",
   label: "\"Mitaka (JPMIT)"
  },
  {
   value: "Mageshimamisaki (JPMMM)",
   label: "Mageshimamisaki (JPMMM)"
  },
  {
   value: "Magome (JPMGM)",
   label: "Magome (JPMGM)"
  },
  {
   value: "Maguchi (JPMGC)",
   label: "Maguchi (JPMGC)"
  },
  {
   value: "Magusa (JPMGU)",
   label: "Magusa (JPMGU)"
  },
  {
   value: "Maizuru (JPMAI)",
   label: "Maizuru (JPMAI)"
  },
  {
   value: "Makigawa (JPMKG)",
   label: "Makigawa (JPMKG)"
  },
  {
   value: "Makiyama (JPMAK)",
   label: "Makiyama (JPMAK)"
  },
  {
   value: "Makurazaki (JPMKK)",
   label: "Makurazaki (JPMKK)"
  },
  {
   value: "Manazuru (JPMNA)",
   label: "Manazuru (JPMNA)"
  },
  {
   value: "Marugame (JPMAR)",
   label: "Marugame (JPMAR)"
  },
  {
   value: "Maruichibi (JPMAB)",
   label: "Maruichibi (JPMAB)"
  },
  {
   value: "Maruiwa (JPMWA)",
   label: "Maruiwa (JPMWA)"
  },
  {
   value: "Maruo (JPMRU)",
   label: "Maruo (JPMRU)"
  },
  {
   value: "Masaki (JPMAS)",
   label: "Masaki (JPMAS)"
  },
  {
   value: "Mashike (JPMSK)",
   label: "Mashike (JPMSK)"
  },
  {
   value: "\"Masuda (JPMDJ)",
   label: "\"Masuda (JPMDJ)"
  },
  {
   value: "\"Masuda (JPMSD)",
   label: "\"Masuda (JPMSD)"
  },
  {
   value: "Matama (JPMAM)",
   label: "Matama (JPMAM)"
  },
  {
   value: "Mategata (JPMAG)",
   label: "Mategata (JPMAG)"
  },
  {
   value: "Matoya (JPMTY)",
   label: "Matoya (JPMTY)"
  },
  {
   value: "Matsue (JPMTE)",
   label: "Matsue (JPMTE)"
  },
  {
   value: "Matsugaura (JPMGA)",
   label: "Matsugaura (JPMGA)"
  },
  {
   value: "Matsumae (JPMTM)",
   label: "Matsumae (JPMTM)"
  },
  {
   value: "Matsumoto (JPMMJ)",
   label: "Matsumoto (JPMMJ)"
  },
  {
   value: "Matsunaga (JPMNG)",
   label: "Matsunaga (JPMNG)"
  },
  {
   value: "Matsuo (JPMAO)",
   label: "Matsuo (JPMAO)"
  },
  {
   value: "Matsusaka (JPMSA)",
   label: "Matsusaka (JPMSA)"
  },
  {
   value: "\"Matsushima (JPMRA)",
   label: "\"Matsushima (JPMRA)"
  },
  {
   value: "\"Matsushima (JPMSS)",
   label: "\"Matsushima (JPMSS)"
  },
  {
   value: "\"Matsushima (JPMAT)",
   label: "\"Matsushima (JPMAT)"
  },
  {
   value: "\"Matsuura (JPMAU)",
   label: "\"Matsuura (JPMAU)"
  },
  {
   value: "\"Matsuura (JPMTS)",
   label: "\"Matsuura (JPMTS)"
  },
  {
   value: "\"Matsuura (JPMTU)",
   label: "\"Matsuura (JPMTU)"
  },
  {
   value: "Matsuyama (JPMYJ)",
   label: "Matsuyama (JPMYJ)"
  },
  {
   value: "Matsuzaki (JPMTZ)",
   label: "Matsuzaki (JPMTZ)"
  },
  {
   value: "Mawari (JPMWR)",
   label: "Mawari (JPMWR)"
  },
  {
   value: "Mebaruzaki (JPMBR)",
   label: "Mebaruzaki (JPMBR)"
  },
  {
   value: "Megi (JPMEG)",
   label: "Megi (JPMEG)"
  },
  {
   value: "Megoshima (JPMGS)",
   label: "Megoshima (JPMGS)"
  },
  {
   value: "Kumihama (JPKMH)",
   label: "Kumihama (JPKMH)"
  },
  {
   value: "Kunehama (JPKNH)",
   label: "Kunehama (JPKNH)"
  },
  {
   value: "Kuniga (JPKNG)",
   label: "Kuniga (JPKNG)"
  },
  {
   value: "Kunisaki (JPKNS)",
   label: "Kunisaki (JPKNS)"
  },
  {
   value: "Kurahashi (JPKHS)",
   label: "Kurahashi (JPKHS)"
  },
  {
   value: "Kuramai (JPKRC)",
   label: "Kuramai (JPKRC)"
  },
  {
   value: "Kuranotani (JPKRN)",
   label: "Kuranotani (JPKRN)"
  },
  {
   value: "\"Kure (JPKUE)",
   label: "\"Kure (JPKUE)"
  },
  {
   value: "\"Kure (JPKRE)",
   label: "\"Kure (JPKRE)"
  },
  {
   value: "Kurihama (JPKRH)",
   label: "Kurihama (JPKRH)"
  },
  {
   value: "Kurii (JPKRU)",
   label: "Kurii (JPKRU)"
  },
  {
   value: "Kurimamaehama (JPKHJ)",
   label: "Kurimamaehama (JPKHJ)"
  },
  {
   value: "Kurio (JPKRI)",
   label: "Kurio (JPKRI)"
  },
  {
   value: "Kuroda (JPKRD)",
   label: "Kuroda (JPKRD)"
  },
  {
   value: "Kuroi (JPKRX)",
   label: "Kuroi (JPKRX)"
  },
  {
   value: "Kurokami (JPKRM)",
   label: "Kurokami (JPKRM)"
  },
  {
   value: "Kuronohama (JPKUX)",
   label: "Kuronohama (JPKUX)"
  },
  {
   value: "Kurosaki (JPKSK)",
   label: "Kurosaki (JPKSK)"
  },
  {
   value: "\"Kuroshima (JPKRO)",
   label: "\"Kuroshima (JPKRO)"
  },
  {
   value: "\"Kuroshima (JPKRJ)",
   label: "\"Kuroshima (JPKRJ)"
  },
  {
   value: "Kurushima (JPKRS)",
   label: "Kurushima (JPKRS)"
  },
  {
   value: "Kushikino (JPKSO)",
   label: "Kushikino (JPKSO)"
  },
  {
   value: "Kushiku (JPKKK)",
   label: "Kushiku (JPKKK)"
  },
  {
   value: "Kushimoto (JPKUJ)",
   label: "Kushimoto (JPKUJ)"
  },
  {
   value: "Kushiro (JPKUH)",
   label: "Kushiro (JPKUH)"
  },
  {
   value: "Kusubo (JPKSB)",
   label: "Kusubo (JPKSB)"
  },
  {
   value: "Kusukawa (JPKXK)",
   label: "Kusukawa (JPKXK)"
  },
  {
   value: "Kute (JPKUT)",
   label: "Kute (JPKUT)"
  },
  {
   value: "Kutsugata (JPKTG)",
   label: "Kutsugata (JPKTG)"
  },
  {
   value: "Kuwana (JPKNA)",
   label: "Kuwana (JPKNA)"
  },
  {
   value: "Kuwanoura (JPKUW)",
   label: "Kuwanoura (JPKUW)"
  },
  {
   value: "Kuyama (JPKYM)",
   label: "Kuyama (JPKYM)"
  },
  {
   value: "Kuzu (JPKUZ)",
   label: "Kuzu (JPKUZ)"
  },
  {
   value: "Kyoto (JPUKY)",
   label: "Kyoto (JPUKY)"
  },
  {
   value: "Maebashi (JPMAE)",
   label: "Maebashi (JPMAE)"
  },
  {
   value: "Maedomari\/Iheya (JPMAD)",
   label: "Maedomari\/Iheya (JPMAD)"
  },
  {
   value: "Maedomari\/Tarama (JPMDR)",
   label: "Maedomari\/Tarama (JPMDR)"
  },
  {
   value: "Maehama (JPMHM)",
   label: "Maehama (JPMHM)"
  },
  {
   value: "Maenohama (JPMMA)",
   label: "Maenohama (JPMMA)"
  },
  {
   value: "Maeura (JPMER)",
   label: "Maeura (JPMER)"
  },
  {
   value: "Konagai (JPKNI)",
   label: "Konagai (JPKNI)"
  },
  {
   value: "Konan (JPKOF)",
   label: "Konan (JPKOF)"
  },
  {
   value: "Konbukariishi (JPKNB)",
   label: "Konbukariishi (JPKNB)"
  },
  {
   value: "Koniya (JPKNY)",
   label: "Koniya (JPKNY)"
  },
  {
   value: "Konoshima (JPKON)",
   label: "Konoshima (JPKON)"
  },
  {
   value: "Konoura (JPKNO)",
   label: "Konoura (JPKNO)"
  },
  {
   value: "Kose (JPKOS)",
   label: "Kose (JPKOS)"
  },
  {
   value: "Koshima (JPKJJ)",
   label: "Koshima (JPKJJ)"
  },
  {
   value: "Kosuki (JPKSX)",
   label: "Kosuki (JPKSX)"
  },
  {
   value: "Kotakarajima (JPKTJ)",
   label: "Kotakarajima (JPKTJ)"
  },
  {
   value: "Kotoura (JPJKT)",
   label: "Kotoura (JPJKT)"
  },
  {
   value: "Kottoi (JPKTO)",
   label: "Kottoi (JPKTO)"
  },
  {
   value: "\"Koura (JPKOR)",
   label: "\"Koura (JPKOR)"
  },
  {
   value: "\"Koura (JPKJU)",
   label: "\"Koura (JPKJU)"
  },
  {
   value: "Kouri (JPKKR)",
   label: "Kouri (JPKKR)"
  },
  {
   value: "Kowa (JPKWX)",
   label: "Kowa (JPKWX)"
  },
  {
   value: "Koyoh\/Etajima (JPKOY)",
   label: "Koyoh\/Etajima (JPKOY)"
  },
  {
   value: "Koyoh\/Kawajiri (JPKYO)",
   label: "Koyoh\/Kawajiri (JPKYO)"
  },
  {
   value: "Koza (JPKOB)",
   label: "Koza (JPKOB)"
  },
  {
   value: "Kozai (JPKZJ)",
   label: "Kozai (JPKZJ)"
  },
  {
   value: "Kozera (JPKZE)",
   label: "Kozera (JPKZE)"
  },
  {
   value: "Kozukushi (JPKZK)",
   label: "Kozukushi (JPKZK)"
  },
  {
   value: "Kozuna (JPKOZ)",
   label: "Kozuna (JPKOZ)"
  },
  {
   value: "Kubuki (JPKBU)",
   label: "Kubuki (JPKBU)"
  },
  {
   value: "Kubura (JPKBR)",
   label: "Kubura (JPKBR)"
  },
  {
   value: "Kuchinofukuura (JPKCF)",
   label: "Kuchinofukuura (JPKCF)"
  },
  {
   value: "Kuchinotsu (JPKUC)",
   label: "Kuchinotsu (JPKUC)"
  },
  {
   value: "Kudadon (JPKJD)",
   label: "Kudadon (JPKJD)"
  },
  {
   value: "Kudamatsu (JPKUD)",
   label: "Kudamatsu (JPKUD)"
  },
  {
   value: "Kugui (JPKUG)",
   label: "Kugui (JPKUG)"
  },
  {
   value: "\"Kuji (JPKKU)",
   label: "\"Kuji (JPKKU)"
  },
  {
   value: "\"Kuji (JPKJI)",
   label: "\"Kuji (JPKJI)"
  },
  {
   value: "Kujiragaura (JPKRR)",
   label: "Kujiragaura (JPKRR)"
  },
  {
   value: "Kuka (JPKGB)",
   label: "Kuka (JPKGB)"
  },
  {
   value: "Kumagaya (JPKMG)",
   label: "Kumagaya (JPKMG)"
  },
  {
   value: "Kumage (JPKGE)",
   label: "Kumage (JPKGE)"
  },
  {
   value: "Kumago (JPKGO)",
   label: "Kumago (JPKGO)"
  },
  {
   value: "Kumamoto (JPKMJ)",
   label: "Kumamoto (JPKMJ)"
  },
  {
   value: "Kumanoe (JPKUU)",
   label: "Kumanoe (JPKUU)"
  },
  {
   value: "Kumeshima (JPKMS)",
   label: "Kumeshima (JPKMS)"
  },
  {
   value: "Kitakyushu-Kokura (JPKOK)",
   label: "Kitakyushu-Kokura (JPKOK)"
  },
  {
   value: "Kitanada (JPKTA)",
   label: "Kitanada (JPKTA)"
  },
  {
   value: "\"Kitaura (JPKJT)",
   label: "\"Kitaura (JPKJT)"
  },
  {
   value: "\"Kitaura (JPKIR)",
   label: "\"Kitaura (JPKIR)"
  },
  {
   value: "\"Kitaura (JPKTR)",
   label: "\"Kitaura (JPKTR)"
  },
  {
   value: "\"Kitaura (JPKIT)",
   label: "\"Kitaura (JPKIT)"
  },
  {
   value: "Kobato (JPKBT)",
   label: "Kobato (JPKBT)"
  },
  {
   value: "Kobe (JPUKB)",
   label: "Kobe (JPUKB)"
  },
  {
   value: "Kobishima (JPKBS)",
   label: "Kobishima (JPKBS)"
  },
  {
   value: "Kobui (JPKBI)",
   label: "Kobui (JPKBI)"
  },
  {
   value: "Kochi (JPKCZ)",
   label: "Kochi (JPKCZ)"
  },
  {
   value: "Kodai (JPKDI)",
   label: "Kodai (JPKDI)"
  },
  {
   value: "Kodakashima (JPKDK)",
   label: "Kodakashima (JPKDK)"
  },
  {
   value: "\"Kodomari (JPKOD)",
   label: "\"Kodomari (JPKOD)"
  },
  {
   value: "\"Kodomari (JPKDM)",
   label: "\"Kodomari (JPKDM)"
  },
  {
   value: "Koguchi (JPKGC)",
   label: "Koguchi (JPKGC)"
  },
  {
   value: "\"Kogushi (JPKOG)",
   label: "\"Kogushi (JPKOG)"
  },
  {
   value: "\"Kogushi (JPKGS)",
   label: "\"Kogushi (JPKGS)"
  },
  {
   value: "Kohama (JPKOH)",
   label: "Kohama (JPKOH)"
  },
  {
   value: "Kohjima (JPKJA)",
   label: "Kohjima (JPKJA)"
  },
  {
   value: "Kohjiro (JPKZR)",
   label: "Kohjiro (JPKZR)"
  },
  {
   value: "Kohmen (JPKOO)",
   label: "Kohmen (JPKOO)"
  },
  {
   value: "Kohnoura (JPKNR)",
   label: "Kohnoura (JPKNR)"
  },
  {
   value: "Kohtsufukae (JPKFU)",
   label: "Kohtsufukae (JPKFU)"
  },
  {
   value: "Kohtsuura (JPKTU)",
   label: "Kohtsuura (JPKTU)"
  },
  {
   value: "Kohzaki (JPKKL)",
   label: "Kohzaki (JPKKL)"
  },
  {
   value: "Kohzujima (JPKOU)",
   label: "Kohzujima (JPKOU)"
  },
  {
   value: "Koike\/Uwajima (JPKOI)",
   label: "Koike\/Uwajima (JPKOI)"
  },
  {
   value: "Kokubo (JPKKB)",
   label: "Kokubo (JPKKB)"
  },
  {
   value: "Komaki (JPKKI)",
   label: "Komaki (JPKKI)"
  },
  {
   value: "\"Komatsu (JPKMX)",
   label: "\"Komatsu (JPKMX)"
  },
  {
   value: "\"Komatsu (JPKMQ)",
   label: "\"Komatsu (JPKMQ)"
  },
  {
   value: "Komatsushima (JPKOM)",
   label: "Komatsushima (JPKOM)"
  },
  {
   value: "Komenotsu (JPKKO)",
   label: "Komenotsu (JPKKO)"
  },
  {
   value: "Kominato (JPKMN)",
   label: "Kominato (JPKMN)"
  },
  {
   value: "Komoda (JPKMD)",
   label: "Komoda (JPKMD)"
  },
  {
   value: "Komoe (JPKAX)",
   label: "Komoe (JPKAX)"
  },
  {
   value: "Komukae (JPKKE)",
   label: "Komukae (JPKKE)"
  },
  {
   value: "Kazume (JPKZM)",
   label: "Kazume (JPKZM)"
  },
  {
   value: "Kazusaminato (JPKZS)",
   label: "Kazusaminato (JPKZS)"
  },
  {
   value: "Kebuki (JPKEB)",
   label: "Kebuki (JPKEB)"
  },
  {
   value: "Kechi (JPKEC)",
   label: "Kechi (JPKEC)"
  },
  {
   value: "Kegoya (JPKEG)",
   label: "Kegoya (JPKEG)"
  },
  {
   value: "Keraji (JPKEJ)",
   label: "Keraji (JPKEJ)"
  },
  {
   value: "Kerama (JPKJP)",
   label: "Kerama (JPKJP)"
  },
  {
   value: "Keruma (JPKEM)",
   label: "Keruma (JPKEM)"
  },
  {
   value: "Kesennuma (JPKSN)",
   label: "Kesennuma (JPKSN)"
  },
  {
   value: "Kiami (JPKIA)",
   label: "Kiami (JPKIA)"
  },
  {
   value: "Kibe (JPKIB)",
   label: "Kibe (JPKIB)"
  },
  {
   value: "Kigasajima (JPKGJ)",
   label: "Kigasajima (JPKGJ)"
  },
  {
   value: "Kihara (JPKHR)",
   label: "Kihara (JPKHR)"
  },
  {
   value: "Kiire (JPKII)",
   label: "Kiire (JPKII)"
  },
  {
   value: "Kijima (JPKZI)",
   label: "Kijima (JPKZI)"
  },
  {
   value: "Kikaigashima\/Kagoshima (JPKKX)",
   label: "Kikaigashima\/Kagoshima (JPKKX)"
  },
  {
   value: "Kikuma (JPKIK)",
   label: "Kikuma (JPKIK)"
  },
  {
   value: "Kimitsu (JPKMT)",
   label: "Kimitsu (JPKMT)"
  },
  {
   value: "Kin (JPKNN)",
   label: "Kin (JPKNN)"
  },
  {
   value: "Kineshima (JPKIM)",
   label: "Kineshima (JPKIM)"
  },
  {
   value: "Kinjo (JPKJO)",
   label: "Kinjo (JPKJO)"
  },
  {
   value: "Kinkasan (JPKNK)",
   label: "Kinkasan (JPKNK)"
  },
  {
   value: "KinNakagusuku (JPKNX)",
   label: "KinNakagusuku (JPKNX)"
  },
  {
   value: "Kinoe (JPKNE)",
   label: "Kinoe (JPKNE)"
  },
  {
   value: "Kinomoto (JPKNT)",
   label: "Kinomoto (JPKNT)"
  },
  {
   value: "Kinuura (JPKNU)",
   label: "Kinuura (JPKNU)"
  },
  {
   value: "Kinwan (JPKIN)",
   label: "Kinwan (JPKIN)"
  },
  {
   value: "Kiriishi (JPKJR)",
   label: "Kiriishi (JPKJR)"
  },
  {
   value: "Kiritappu (JPKRT)",
   label: "Kiritappu (JPKRT)"
  },
  {
   value: "Kisakata (JPKST)",
   label: "Kisakata (JPKST)"
  },
  {
   value: "Kisane (JPKNJ)",
   label: "Kisane (JPKNJ)"
  },
  {
   value: "Kisarazu (JPKZU)",
   label: "Kisarazu (JPKZU)"
  },
  {
   value: "Kisawa (JPKIW)",
   label: "Kisawa (JPKIW)"
  },
  {
   value: "Kishiku (JPKSH)",
   label: "Kishiku (JPKSH)"
  },
  {
   value: "Kishira (JPKSR)",
   label: "Kishira (JPKSR)"
  },
  {
   value: "Kishiwada (JPKDA)",
   label: "Kishiwada (JPKDA)"
  },
  {
   value: "Kita\/Kitadaito (JPKTX)",
   label: "Kita\/Kitadaito (JPKTX)"
  },
  {
   value: "Kita\/Minamidaito (JPKDX)",
   label: "Kita\/Minamidaito (JPKDX)"
  },
  {
   value: "Kitadaito (JPKTD)",
   label: "Kitadaito (JPKTD)"
  },
  {
   value: "Kitakijima (JPKTL)",
   label: "Kitakijima (JPKTL)"
  },
  {
   value: "Kitakyushu (JPKKJ)",
   label: "Kitakyushu (JPKKJ)"
  },
  {
   value: "Kasaoka (JPKSA)",
   label: "Kasaoka (JPKSA)"
  },
  {
   value: "\"Kasasa (JPKSS)",
   label: "\"Kasasa (JPKSS)"
  },
  {
   value: "\"Kasasa (JPKSY)",
   label: "\"Kasasa (JPKSY)"
  },
  {
   value: "Kasaura (JPKAC)",
   label: "Kasaura (JPKAC)"
  },
  {
   value: "Kasedo (JPKDJ)",
   label: "Kasedo (JPKDJ)"
  },
  {
   value: "Kashikojima (JPKKZ)",
   label: "Kashikojima (JPKKZ)"
  },
  {
   value: "\"Kashima (JPKSC)",
   label: "\"Kashima (JPKSC)"
  },
  {
   value: "\"Kashima (JPKSM)",
   label: "\"Kashima (JPKSM)"
  },
  {
   value: "Kashimae (JPKAE)",
   label: "Kashimae (JPKAE)"
  },
  {
   value: "Kashino (JPKAO)",
   label: "Kashino (JPKAO)"
  },
  {
   value: "\"Kashiwa (JPKSW)",
   label: "\"Kashiwa (JPKSW)"
  },
  {
   value: "Kashiwazaki (JPKWZ)",
   label: "Kashiwazaki (JPKWZ)"
  },
  {
   value: "Kasugai (JPKGI)",
   label: "Kasugai (JPKGI)"
  },
  {
   value: "Kasumi (JPKXS)",
   label: "Kasumi (JPKXS)"
  },
  {
   value: "Kata (JPKTZ)",
   label: "Kata (JPKTZ)"
  },
  {
   value: "Katadomari (JPKDR)",
   label: "Katadomari (JPKDR)"
  },
  {
   value: "Kataichi (JPKTI)",
   label: "Kataichi (JPKTI)"
  },
  {
   value: "Katakami (JPKKM)",
   label: "Katakami (JPKKM)"
  },
  {
   value: "Kataku (JPKTK)",
   label: "Kataku (JPKTK)"
  },
  {
   value: "Katashima (JPKTS)",
   label: "Katashima (JPKTS)"
  },
  {
   value: "Katasoba (JPKBA)",
   label: "Katasoba (JPKBA)"
  },
  {
   value: "Katsumoto (JPKSU)",
   label: "Katsumoto (JPKSU)"
  },
  {
   value: "Katsuta (JPKSI)",
   label: "Katsuta (JPKSI)"
  },
  {
   value: "\"Katsuura (JPKUR)",
   label: "\"Katsuura (JPKUR)"
  },
  {
   value: "\"Katsuura (JPKAT)",
   label: "\"Katsuura (JPKAT)"
  },
  {
   value: "\"Kawachi (JPKCH)",
   label: "\"Kawachi (JPKCH)"
  },
  {
   value: "\"Kawachi (JPKWC)",
   label: "\"Kawachi (JPKWC)"
  },
  {
   value: "\"Kawajiri (JPKWJ)",
   label: "\"Kawajiri (JPKWJ)"
  },
  {
   value: "\"Kawajiri (JPKWR)",
   label: "\"Kawajiri (JPKWR)"
  },
  {
   value: "Kawanazu (JPKWA)",
   label: "Kawanazu (JPKWA)"
  },
  {
   value: "Kawanoe (JPKWN)",
   label: "Kawanoe (JPKWN)"
  },
  {
   value: "Kawanoishi (JPKWI)",
   label: "Kawanoishi (JPKWI)"
  },
  {
   value: "Kawarago (JPKAG)",
   label: "Kawarago (JPKAG)"
  },
  {
   value: "Kawasaki (JPKWS)",
   label: "Kawasaki (JPKWS)"
  },
  {
   value: "Kawashimo (JPKWM)",
   label: "Kawashimo (JPKWM)"
  },
  {
   value: "Kawatana (JPKWT)",
   label: "Kawatana (JPKWT)"
  },
  {
   value: "Kawauchi (JPKAW)",
   label: "Kawauchi (JPKAW)"
  },
  {
   value: "Kazuhara (JPKZH)",
   label: "Kazuhara (JPKZH)"
  },
  {
   value: "Kajiki (JPKJK)",
   label: "Kajiki (JPKJK)"
  },
  {
   value: "Kakeroma (JPKER)",
   label: "Kakeroma (JPKER)"
  },
  {
   value: "Kakogawa (JPKGA)",
   label: "Kakogawa (JPKGA)"
  },
  {
   value: "Kama (JPKMA)",
   label: "Kama (JPKMA)"
  },
  {
   value: "\"Kama (JPKAJ)",
   label: "\"Kama (JPKAJ)"
  },
  {
   value: "Kamae (JPKME)",
   label: "Kamae (JPKME)"
  },
  {
   value: "Kamagari (JPKGR)",
   label: "Kamagari (JPKGR)"
  },
  {
   value: "Kamaishi (JPKIS)",
   label: "Kamaishi (JPKIS)"
  },
  {
   value: "Kameike (JPKEE)",
   label: "Kameike (JPKEE)"
  },
  {
   value: "Kametoku (JPKAM)",
   label: "Kametoku (JPKAM)"
  },
  {
   value: "\"Kameura (JPKJM)",
   label: "\"Kameura (JPKJM)"
  },
  {
   value: "\"Kameura (JPKMR)",
   label: "\"Kameura (JPKMR)"
  },
  {
   value: "Kamihira (JPKAH)",
   label: "Kamihira (JPKAH)"
  },
  {
   value: "Kamikatetsu (JPKKT)",
   label: "Kamikatetsu (JPKKT)"
  },
  {
   value: "Kamikawaguchi (JPKMW)",
   label: "Kamikawaguchi (JPKMW)"
  },
  {
   value: "Kaminato (JPKMM)",
   label: "Kaminato (JPKMM)"
  },
  {
   value: "Kaminofuruta (JPKMF)",
   label: "Kaminofuruta (JPKMF)"
  },
  {
   value: "Kaminokae (JPKMK)",
   label: "Kaminokae (JPKMK)"
  },
  {
   value: "Kaminoseki (JPKOX)",
   label: "Kaminoseki (JPKOX)"
  },
  {
   value: "Kamiura (JPKMU)",
   label: "Kamiura (JPKMU)"
  },
  {
   value: "Kamiyakunagata (JPKMY)",
   label: "Kamiyakunagata (JPKMY)"
  },
  {
   value: "Kamo (JPKMO)",
   label: "Kamo (JPKMO)"
  },
  {
   value: "Kamoise (JPKSE)",
   label: "Kamoise (JPKSE)"
  },
  {
   value: "Kanayaki (JPKYK)",
   label: "Kanayaki (JPKYK)"
  },
  {
   value: "Kanazawa (JPKNZ)",
   label: "Kanazawa (JPKNZ)"
  },
  {
   value: "\"Kanda (JPKND)",
   label: "\"Kanda (JPKND)"
  },
  {
   value: "Kanegusuku (JPKGU)",
   label: "Kanegusuku (JPKGU)"
  },
  {
   value: "Kannonji (JPKJN)",
   label: "Kannonji (JPKJN)"
  },
  {
   value: "Kannoura (JPKRA)",
   label: "Kannoura (JPKRA)"
  },
  {
   value: "Kanokawa (JPKKW)",
   label: "Kanokawa (JPKKW)"
  },
  {
   value: "Kanoya (JPKYA)",
   label: "Kanoya (JPKYA)"
  },
  {
   value: "Kansai Int Apt (JPKIX)",
   label: "Kansai Int Apt (JPKIX)"
  },
  {
   value: "Karakizaki (JPKRK)",
   label: "Karakizaki (JPKRK)"
  },
  {
   value: "Karakuma (JPKKA)",
   label: "Karakuma (JPKKA)"
  },
  {
   value: "Karatomari (JPKTM)",
   label: "Karatomari (JPKTM)"
  },
  {
   value: "Karatsu (JPKAR)",
   label: "Karatsu (JPKAR)"
  },
  {
   value: "\"Kariya (JPKRY)",
   label: "\"Kariya (JPKRY)"
  },
  {
   value: "Karubi (JPKRB)",
   label: "Karubi (JPKRB)"
  },
  {
   value: "Karuno (JPKAN)",
   label: "Karuno (JPKAN)"
  },
  {
   value: "Kasado (JPKSD)",
   label: "Kasado (JPKSD)"
  },
  {
   value: "\"Itoh (JPITJ)",
   label: "\"Itoh (JPITJ)"
  },
  {
   value: "Itozaki (JPITO)",
   label: "Itozaki (JPITO)"
  },
  {
   value: "Itsukushima (JPITS)",
   label: "Itsukushima (JPITS)"
  },
  {
   value: "Iwafune (JPIWH)",
   label: "Iwafune (JPIWH)"
  },
  {
   value: "\"Iwagi (JPIWG)",
   label: "\"Iwagi (JPIWG)"
  },
  {
   value: "Iwaki (JPIWI)",
   label: "Iwaki (JPIWI)"
  },
  {
   value: "Iwakuni (JPIWK)",
   label: "Iwakuni (JPIWK)"
  },
  {
   value: "Iwamatsu (JPIWA)",
   label: "Iwamatsu (JPIWA)"
  },
  {
   value: "Iwanai (JPIWN)",
   label: "Iwanai (JPIWN)"
  },
  {
   value: "Iwaya (JPIWY)",
   label: "Iwaya (JPIWY)"
  },
  {
   value: "Iwayadomari (JPIDM)",
   label: "Iwayadomari (JPIDM)"
  },
  {
   value: "\"Iwojima (JPIOU)",
   label: "\"Iwojima (JPIOU)"
  },
  {
   value: "\"Iwojima (JPIWO)",
   label: "\"Iwojima (JPIWO)"
  },
  {
   value: "\"Iwojima (JPIWT)",
   label: "\"Iwojima (JPIWT)"
  },
  {
   value: "Iya (JPIYA)",
   label: "Iya (JPIYA)"
  },
  {
   value: "Iyo (JPIYO)",
   label: "Iyo (JPIYO)"
  },
  {
   value: "Iyomishima (JPIYM)",
   label: "Iyomishima (JPIYM)"
  },
  {
   value: "Izuhara (JPIZH)",
   label: "Izuhara (JPIZH)"
  },
  {
   value: "Izuka (JPIZU)",
   label: "Izuka (JPIZU)"
  },
  {
   value: "\"Izumi (JPIZM)",
   label: "\"Izumi (JPIZM)"
  },
  {
   value: "\"Izumi (JPIZI)",
   label: "\"Izumi (JPIZI)"
  },
  {
   value: "Izumisano (JPIZS)",
   label: "Izumisano (JPIZS)"
  },
  {
   value: "Izumo (JPIZO)",
   label: "Izumo (JPIZO)"
  },
  {
   value: "Jokawauchi (JPJKW)",
   label: "Jokawauchi (JPJKW)"
  },
  {
   value: "Jonoshita (JPJON)",
   label: "Jonoshita (JPJON)"
  },
  {
   value: "Kabanoki (JPKAB)",
   label: "Kabanoki (JPKAB)"
  },
  {
   value: "Kabashima (JPKBM)",
   label: "Kabashima (JPKBM)"
  },
  {
   value: "Kada (JPKAA)",
   label: "Kada (JPKAA)"
  },
  {
   value: "Kadokawa (JPKDW)",
   label: "Kadokawa (JPKDW)"
  },
  {
   value: "Kadokura (JPKDO)",
   label: "Kadokura (JPKDO)"
  },
  {
   value: "Kafuka (JPKBK)",
   label: "Kafuka (JPKBK)"
  },
  {
   value: "Kafuri (JPKAF)",
   label: "Kafuri (JPKAF)"
  },
  {
   value: "\"Kaga (JPKJG)",
   label: "\"Kaga (JPKJG)"
  },
  {
   value: "Kagami (JPKGM)",
   label: "Kagami (JPKGM)"
  },
  {
   value: "Kagoshima (JPKOJ)",
   label: "Kagoshima (JPKOJ)"
  },
  {
   value: "Kaigata (JPKGT)",
   label: "Kaigata (JPKGT)"
  },
  {
   value: "Kainan (JPKAI)",
   label: "Kainan (JPKAI)"
  },
  {
   value: "Kaita (JPKAD)",
   label: "Kaita (JPKAD)"
  },
  {
   value: "Kaizaki (JPKAZ)",
   label: "Kaizaki (JPKAZ)"
  },
  {
   value: "Kaizuka (JPKZA)",
   label: "Kaizuka (JPKZA)"
  },
  {
   value: "Ikunohama (JPIKU)",
   label: "Ikunohama (JPIKU)"
  },
  {
   value: "Imabari (JPIMB)",
   label: "Imabari (JPIMB)"
  },
  {
   value: "Imafuku (JPIMA)",
   label: "Imafuku (JPIMA)"
  },
  {
   value: "Imagire (JPIGR)",
   label: "Imagire (JPIGR)"
  },
  {
   value: "Imari (JPIMI)",
   label: "Imari (JPIMI)"
  },
  {
   value: "Imazato (JPIMT)",
   label: "Imazato (JPIMT)"
  },
  {
   value: "Imazu (JPIMZ)",
   label: "Imazu (JPIMZ)"
  },
  {
   value: "Imi (JPIMM)",
   label: "Imi (JPIMM)"
  },
  {
   value: "Ina (JPINA)",
   label: "Ina (JPINA)"
  },
  {
   value: "Inatori (JPINR)",
   label: "Inatori (JPINR)"
  },
  {
   value: "Indohji (JPIDJ)",
   label: "Indohji (JPIDJ)"
  },
  {
   value: "Ine (JPINE)",
   label: "Ine (JPINE)"
  },
  {
   value: "Innoshima (JPINS)",
   label: "Innoshima (JPINS)"
  },
  {
   value: "Inobe (JPINO)",
   label: "Inobe (JPINO)"
  },
  {
   value: "\"Inokuchi (JPIUH)",
   label: "\"Inokuchi (JPIUH)"
  },
  {
   value: "\"Inokushi (JPINK)",
   label: "\"Inokushi (JPINK)"
  },
  {
   value: "Inonada (JPIND)",
   label: "Inonada (JPIND)"
  },
  {
   value: "Inugaura (JPING)",
   label: "Inugaura (JPING)"
  },
  {
   value: "Inujima (JPINZ)",
   label: "Inujima (JPINZ)"
  },
  {
   value: "Irago (JPIRK)",
   label: "Irago (JPIRK)"
  },
  {
   value: "Isahaya (JPISY)",
   label: "Isahaya (JPISY)"
  },
  {
   value: "Ise (JPISE)",
   label: "Ise (JPISE)"
  },
  {
   value: "Iseki (JPISK)",
   label: "Iseki (JPISK)"
  },
  {
   value: "Isezaki (JPISZ)",
   label: "Isezaki (JPISZ)"
  },
  {
   value: "Ishiba (JPISB)",
   label: "Ishiba (JPISB)"
  },
  {
   value: "Ishida (JPISD)",
   label: "Ishida (JPISD)"
  },
  {
   value: "Ishigakijima (JPISG)",
   label: "Ishigakijima (JPISG)"
  },
  {
   value: "Ishikari (JPISI)",
   label: "Ishikari (JPISI)"
  },
  {
   value: "Ishikariwan (JPISW)",
   label: "Ishikariwan (JPISW)"
  },
  {
   value: "Ishikariwanshinko (JPISS)",
   label: "Ishikariwanshinko (JPISS)"
  },
  {
   value: "Ishikawagun (JPIAG)",
   label: "Ishikawagun (JPIAG)"
  },
  {
   value: "Ishima (JPISH)",
   label: "Ishima (JPISH)"
  },
  {
   value: "Ishinomaki (JPISM)",
   label: "Ishinomaki (JPISM)"
  },
  {
   value: "Ishiwaki (JPISC)",
   label: "Ishiwaki (JPISC)"
  },
  {
   value: "Isozaki (JPISX)",
   label: "Isozaki (JPISX)"
  },
  {
   value: "Issai (JPISA)",
   label: "Issai (JPISA)"
  },
  {
   value: "Isshiki (JPIKJ)",
   label: "Isshiki (JPIKJ)"
  },
  {
   value: "Isso (JPKYR)",
   label: "Isso (JPKYR)"
  },
  {
   value: "Isuwan (JPISU)",
   label: "Isuwan (JPISU)"
  },
  {
   value: "Itako (JPITK)",
   label: "Itako (JPITK)"
  },
  {
   value: "\"Itoh (JPITU)",
   label: "\"Itoh (JPITU)"
  },
  {
   value: "Honjima (JPHJA)",
   label: "Honjima (JPHJA)"
  },
  {
   value: "\"Honjo (JPHON)",
   label: "\"Honjo (JPHON)"
  },
  {
   value: "\"Honjo (JPHNJ)",
   label: "\"Honjo (JPHNJ)"
  },
  {
   value: "Honkushima (JPHKM)",
   label: "Honkushima (JPHKM)"
  },
  {
   value: "Honmoku (JPHNN)",
   label: "Honmoku (JPHNN)"
  },
  {
   value: "Hoppozaki (JPHPP)",
   label: "Hoppozaki (JPHPP)"
  },
  {
   value: "Horie (JPHRE)",
   label: "Horie (JPHRE)"
  },
  {
   value: "Horikappu (JPHRI)",
   label: "Horikappu (JPHRI)"
  },
  {
   value: "\"Hoshika (JPHSI)",
   label: "\"Hoshika (JPHSI)"
  },
  {
   value: "\"Hoshika (JPHOS)",
   label: "\"Hoshika (JPHOS)"
  },
  {
   value: "Hososhima (JPHSM)",
   label: "Hososhima (JPHSM)"
  },
  {
   value: "Hotokegaura (JPHOT)",
   label: "Hotokegaura (JPHOT)"
  },
  {
   value: "Hyakkan (JPHKK)",
   label: "Hyakkan (JPHKK)"
  },
  {
   value: "Hyakunoura (JPHYR)",
   label: "Hyakunoura (JPHYR)"
  },
  {
   value: "Hyugadomari (JPHYG)",
   label: "Hyugadomari (JPHYG)"
  },
  {
   value: "Iburi (JPIBR)",
   label: "Iburi (JPIBR)"
  },
  {
   value: "Ibusuki (JPIBS)",
   label: "Ibusuki (JPIBS)"
  },
  {
   value: "Icchoda (JPICD)",
   label: "Icchoda (JPICD)"
  },
  {
   value: "Ichihara (JPICH)",
   label: "Ichihara (JPICH)"
  },
  {
   value: "Ichikawa (JPICK)",
   label: "Ichikawa (JPICK)"
  },
  {
   value: "Iejima\/Okinawa (JPIEJ)",
   label: "Iejima\/Okinawa (JPIEJ)"
  },
  {
   value: "\"Ieshima (JPIES)",
   label: "\"Ieshima (JPIES)"
  },
  {
   value: "Ieura (JPIER)",
   label: "Ieura (JPIER)"
  },
  {
   value: "Igo (JPIGO)",
   label: "Igo (JPIGO)"
  },
  {
   value: "Ihota (JPIHO)",
   label: "Ihota (JPIHO)"
  },
  {
   value: "Ii (JPIII)",
   label: "Ii (JPIII)"
  },
  {
   value: "Iibi (JPIIB)",
   label: "Iibi (JPIIB)"
  },
  {
   value: "Iida (JPIDA)",
   label: "Iida (JPIDA)"
  },
  {
   value: "Iinoseto (JPINT)",
   label: "Iinoseto (JPINT)"
  },
  {
   value: "Ikara (JPIKR)",
   label: "Ikara (JPIKR)"
  },
  {
   value: "Ikata (JPIKT)",
   label: "Ikata (JPIKT)"
  },
  {
   value: "\"Ikeda (JPIKA)",
   label: "\"Ikeda (JPIKA)"
  },
  {
   value: "\"Ikeda (JPIKD)",
   label: "\"Ikeda (JPIKD)"
  },
  {
   value: "Ikeshima (JPIKE)",
   label: "Ikeshima (JPIKE)"
  },
  {
   value: "Iki (JPIKI)",
   label: "Iki (JPIKI)"
  },
  {
   value: "Ikina (JPIKN)",
   label: "Ikina (JPIKN)"
  },
  {
   value: "Ikitsuki (JPIKK)",
   label: "Ikitsuki (JPIKK)"
  },
  {
   value: "Ikitsukishima (JPIKS)",
   label: "Ikitsukishima (JPIKS)"
  },
  {
   value: "Ikuchi (JPIKC)",
   label: "Ikuchi (JPIKC)"
  },
  {
   value: "Himedo (JPHDO)",
   label: "Himedo (JPHDO)"
  },
  {
   value: "Himeji (JPHIM)",
   label: "Himeji (JPHIM)"
  },
  {
   value: "Himekawa (JPHMK)",
   label: "Himekawa (JPHMK)"
  },
  {
   value: "Himenoura (JPHNR)",
   label: "Himenoura (JPHNR)"
  },
  {
   value: "Himeshima (JPHMH)",
   label: "Himeshima (JPHMH)"
  },
  {
   value: "Himi (JPHMJ)",
   label: "Himi (JPHMJ)"
  },
  {
   value: "Himosashi (JPHMS)",
   label: "Himosashi (JPHMS)"
  },
  {
   value: "Hinagu (JPHNG)",
   label: "Hinagu (JPHNG)"
  },
  {
   value: "Hinase (JPHIN)",
   label: "Hinase (JPHIN)"
  },
  {
   value: "Hinoshima (JPHNS)",
   label: "Hinoshima (JPHNS)"
  },
  {
   value: "Hinozu (JPHNZ)",
   label: "Hinozu (JPHNZ)"
  },
  {
   value: "Hirado (JPHRD)",
   label: "Hirado (JPHRD)"
  },
  {
   value: "Hirai (JPHRJ)",
   label: "Hirai (JPHRJ)"
  },
  {
   value: "Hiraiwa (JPHRW)",
   label: "Hiraiwa (JPHRW)"
  },
  {
   value: "Hirakata (JPHRK)",
   label: "Hirakata (JPHRK)"
  },
  {
   value: "Hirao (JPHRA)",
   label: "Hirao (JPHRA)"
  },
  {
   value: "Hirara (JPHRR)",
   label: "Hirara (JPHRR)"
  },
  {
   value: "Hirasaki (JPHII)",
   label: "Hirasaki (JPHII)"
  },
  {
   value: "Hirasawa (JPHSW)",
   label: "Hirasawa (JPHSW)"
  },
  {
   value: "Hirase (JPHRS)",
   label: "Hirase (JPHRS)"
  },
  {
   value: "Hiro (JPHRO)",
   label: "Hiro (JPHRO)"
  },
  {
   value: "Hirohata (JPHRH)",
   label: "Hirohata (JPHRH)"
  },
  {
   value: "Hiroo (JPHIR)",
   label: "Hiroo (JPHIR)"
  },
  {
   value: "Hiroshima (JPHIJ)",
   label: "Hiroshima (JPHIJ)"
  },
  {
   value: "\"Hirota (JPHTA)",
   label: "\"Hirota (JPHTA)"
  },
  {
   value: "\"Hirota (JPHJT)",
   label: "\"Hirota (JPHJT)"
  },
  {
   value: "Hiroura (JPHRU)",
   label: "Hiroura (JPHRU)"
  },
  {
   value: "Hirugaura (JPHGU)",
   label: "Hirugaura (JPHGU)"
  },
  {
   value: "Hisanohama (JPHSN)",
   label: "Hisanohama (JPHSN)"
  },
  {
   value: "Hisayoshi (JPHYS)",
   label: "Hisayoshi (JPHYS)"
  },
  {
   value: "Hishima (JPHMA)",
   label: "Hishima (JPHMA)"
  },
  {
   value: "Hitachi (JPHTC)",
   label: "Hitachi (JPHTC)"
  },
  {
   value: "Hitachinaka (JPHIC)",
   label: "Hitachinaka (JPHIC)"
  },
  {
   value: "Hitakatsu (JPHTK)",
   label: "Hitakatsu (JPHTK)"
  },
  {
   value: "Hitsushima (JPHTS)",
   label: "Hitsushima (JPHTS)"
  },
  {
   value: "Hiwasa (JPHWS)",
   label: "Hiwasa (JPHWS)"
  },
  {
   value: "Hizenohshima (JPHIZ)",
   label: "Hizenohshima (JPHIZ)"
  },
  {
   value: "Hoda (JPHUD)",
   label: "Hoda (JPHUD)"
  },
  {
   value: "Hohomi (JPHHM)",
   label: "Hohomi (JPHHM)"
  },
  {
   value: "Hojo (JPHJO)",
   label: "Hojo (JPHJO)"
  },
  {
   value: "Hondo (JPHOD)",
   label: "Hondo (JPHOD)"
  },
  {
   value: "Hannoura (JPHUR)",
   label: "Hannoura (JPHUR)"
  },
  {
   value: "Hanyu (JPHNY)",
   label: "Hanyu (JPHNY)"
  },
  {
   value: "Hara (JPHAR)",
   label: "Hara (JPHAR)"
  },
  {
   value: "Haramachi (JPHRM)",
   label: "Haramachi (JPHRM)"
  },
  {
   value: "Hase (JPHSS)",
   label: "Hase (JPHSS)"
  },
  {
   value: "Hashi (JPHSH)",
   label: "Hashi (JPHSH)"
  },
  {
   value: "Hashihama (JPHAS)",
   label: "Hashihama (JPHAS)"
  },
  {
   value: "Hashima (JPHAH)",
   label: "Hashima (JPHAH)"
  },
  {
   value: "Hashirajima (JPHSR)",
   label: "Hashirajima (JPHSR)"
  },
  {
   value: "Hata (JPHTT)",
   label: "Hata (JPHTT)"
  },
  {
   value: "Hatami (JPHMI)",
   label: "Hatami (JPHMI)"
  },
  {
   value: "Hateruma (JPHTR)",
   label: "Hateruma (JPHTR)"
  },
  {
   value: "Hatoma (JPHTO)",
   label: "Hatoma (JPHTO)"
  },
  {
   value: "Hayakawa (JPHYK)",
   label: "Hayakawa (JPHYK)"
  },
  {
   value: "Hayama (JPHYM)",
   label: "Hayama (JPHYM)"
  },
  {
   value: "Hayato (JPHYT)",
   label: "Hayato (JPHYT)"
  },
  {
   value: "Heda (JPHAD)",
   label: "Heda (JPHAD)"
  },
  {
   value: "Hekinan (JPHKN)",
   label: "Hekinan (JPHKN)"
  },
  {
   value: "Henza (JPHEI)",
   label: "Henza (JPHEI)"
  },
  {
   value: "Hesaki (JPHES)",
   label: "Hesaki (JPHES)"
  },
  {
   value: "Heta (JPHET)",
   label: "Heta (JPHET)"
  },
  {
   value: "Hetono (JPHED)",
   label: "Hetono (JPHED)"
  },
  {
   value: "Hiagari\/Kitakiushu (JPHIA)",
   label: "Hiagari\/Kitakiushu (JPHIA)"
  },
  {
   value: "Hibi (JPHIB)",
   label: "Hibi (JPHIB)"
  },
  {
   value: "Hibikinada (JPHBK)",
   label: "Hibikinada (JPHBK)"
  },
  {
   value: "Hiburi (JPHBR)",
   label: "Hiburi (JPHBR)"
  },
  {
   value: "Hidaka (JPHDK)",
   label: "Hidaka (JPHDK)"
  },
  {
   value: "Higashi-Ogishima (JPHIO)",
   label: "Higashi-Ogishima (JPHIO)"
  },
  {
   value: "Higashiharima (JPHHR)",
   label: "Higashiharima (JPHHR)"
  },
  {
   value: "Higashihazu (JPHGH)",
   label: "Higashihazu (JPHGH)"
  },
  {
   value: "Higashinohama (JPHHH)",
   label: "Higashinohama (JPHHH)"
  },
  {
   value: "Higashishioya (JPHIG)",
   label: "Higashishioya (JPHIG)"
  },
  {
   value: "Hiji (JPHJI)",
   label: "Hiji (JPHJI)"
  },
  {
   value: "Hikami (JPHKI)",
   label: "Hikami (JPHKI)"
  },
  {
   value: "Hikari (JPHKR)",
   label: "Hikari (JPHKR)"
  },
  {
   value: "Hiketa (JPHEA)",
   label: "Hiketa (JPHEA)"
  },
  {
   value: "Hiki (JPHIK)",
   label: "Hiki (JPHIK)"
  },
  {
   value: "Hikimoto (JPHMT)",
   label: "Hikimoto (JPHMT)"
  },
  {
   value: "Hikone (JPHIE)",
   label: "Hikone (JPHIE)"
  },
  {
   value: "Hikoshima (JPHIS)",
   label: "Hikoshima (JPHIS)"
  },
  {
   value: "Hikozaki (JPHKZ)",
   label: "Hikozaki (JPHKZ)"
  },
  {
   value: "Gyohda (JPGYA)",
   label: "Gyohda (JPGYA)"
  },
  {
   value: "Haboro (JPHBO)",
   label: "Haboro (JPHBO)"
  },
  {
   value: "\"Habu (JPHAU)",
   label: "\"Habu (JPHAU)"
  },
  {
   value: "\"Habu (JPHBB)",
   label: "\"Habu (JPHBB)"
  },
  {
   value: "\"Habu (JPHAB)",
   label: "\"Habu (JPHAB)"
  },
  {
   value: "Hachigo (JPHGO)",
   label: "Hachigo (JPHGO)"
  },
  {
   value: "Hachijojima (JPHAC)",
   label: "Hachijojima (JPHAC)"
  },
  {
   value: "Hachinohe (JPHHE)",
   label: "Hachinohe (JPHHE)"
  },
  {
   value: "Hadano (JPHNO)",
   label: "Hadano (JPHNO)"
  },
  {
   value: "Haenohama (JPHAE)",
   label: "Haenohama (JPHAE)"
  },
  {
   value: "Hagi (JPHAG)",
   label: "Hagi (JPHAG)"
  },
  {
   value: "Haibara (JPHBA)",
   label: "Haibara (JPHBA)"
  },
  {
   value: "Haiki (JPHAI)",
   label: "Haiki (JPHAI)"
  },
  {
   value: "Hakata\/Fukuoka (JPHKT)",
   label: "Hakata\/Fukuoka (JPHKT)"
  },
  {
   value: "Hakatashima (JPHKS)",
   label: "Hakatashima (JPHKS)"
  },
  {
   value: "Hakodate (JPHKD)",
   label: "Hakodate (JPHKD)"
  },
  {
   value: "Hakoura (JPHKU)",
   label: "Hakoura (JPHKU)"
  },
  {
   value: "Hakui (JPUIA)",
   label: "Hakui (JPUIA)"
  },
  {
   value: "Hamada (JPHMD)",
   label: "Hamada (JPHMD)"
  },
  {
   value: "Hamaguri (JPHMG)",
   label: "Hamaguri (JPHMG)"
  },
  {
   value: "Hamajima (JPHJM)",
   label: "Hamajima (JPHJM)"
  },
  {
   value: "Hamajiri (JPHJR)",
   label: "Hamajiri (JPHJR)"
  },
  {
   value: "Hamakanaya (JPHKW)",
   label: "Hamakanaya (JPHKW)"
  },
  {
   value: "Hamamatsu (JPHMM)",
   label: "Hamamatsu (JPHMM)"
  },
  {
   value: "Hamana (JPHMN)",
   label: "Hamana (JPHMN)"
  },
  {
   value: "Hamasaka (JPHKJ)",
   label: "Hamasaka (JPHKJ)"
  },
  {
   value: "Hamasaki (JPHMX)",
   label: "Hamasaki (JPHMX)"
  },
  {
   value: "Hamasako (JPHSK)",
   label: "Hamasako (JPHSK)"
  },
  {
   value: "Hamasarufutsu (JPHAM)",
   label: "Hamasarufutsu (JPHAM)"
  },
  {
   value: "Hamasuki (JPHSU)",
   label: "Hamasuki (JPHSU)"
  },
  {
   value: "Hamatsuwaki (JPHWA)",
   label: "Hamatsuwaki (JPHWA)"
  },
  {
   value: "Hamawaki (JPHMW)",
   label: "Hamawaki (JPHMW)"
  },
  {
   value: "Hami (JPHAA)",
   label: "Hami (JPHAA)"
  },
  {
   value: "Hamochi (JPHMC)",
   label: "Hamochi (JPHMC)"
  },
  {
   value: "Hanamaki (JPHNA)",
   label: "Hanamaki (JPHNA)"
  },
  {
   value: "Hanasaki (JPHNK)",
   label: "Hanasaki (JPHNK)"
  },
  {
   value: "Handa (JPHDA)",
   label: "Handa (JPHDA)"
  },
  {
   value: "Hane (JPHNE)",
   label: "Hane (JPHNE)"
  },
  {
   value: "Haneda Apt\/Tokyo (JPHND)",
   label: "Haneda Apt\/Tokyo (JPHND)"
  },
  {
   value: "Hannan (JPHAN)",
   label: "Hannan (JPHAN)"
  },
  {
   value: "Funakakushi (JPFSH)",
   label: "Funakakushi (JPFSH)"
  },
  {
   value: "Funakoshi (JPFNS)",
   label: "Funakoshi (JPFNS)"
  },
  {
   value: "Funauki (JPFNU)",
   label: "Funauki (JPFNU)"
  },
  {
   value: "Funaura (JPFNR)",
   label: "Funaura (JPFNR)"
  },
  {
   value: "Funaya (JPFNA)",
   label: "Funaya (JPFNA)"
  },
  {
   value: "Funazu (JPFNZ)",
   label: "Funazu (JPFNZ)"
  },
  {
   value: "Furubira (JPFHR)",
   label: "Furubira (JPFHR)"
  },
  {
   value: "\"Furue (JPFRX)",
   label: "\"Furue (JPFRX)"
  },
  {
   value: "\"Furue (JPFRU)",
   label: "\"Furue (JPFRU)"
  },
  {
   value: "\"Furue (JPFRM)",
   label: "\"Furue (JPFRM)"
  },
  {
   value: "\"Furue (JPFRE)",
   label: "\"Furue (JPFRE)"
  },
  {
   value: "Furuike (JPFRK)",
   label: "Furuike (JPFRK)"
  },
  {
   value: "Furukawa (JPFKW)",
   label: "Furukawa (JPFKW)"
  },
  {
   value: "Furumi (JPURU)",
   label: "Furumi (JPURU)"
  },
  {
   value: "\"Furusato (JPFST)",
   label: "\"Furusato (JPFST)"
  },
  {
   value: "\"Furusato (JPFRS)",
   label: "\"Furusato (JPFRS)"
  },
  {
   value: "Fushiki (JPFSK)",
   label: "Fushiki (JPFSK)"
  },
  {
   value: "Fushimi (JPFUS)",
   label: "Fushimi (JPFUS)"
  },
  {
   value: "Futae (JPFTE)",
   label: "Futae (JPFTE)"
  },
  {
   value: "Futagawa (JPFGW)",
   label: "Futagawa (JPFGW)"
  },
  {
   value: "Futago (JPFTG)",
   label: "Futago (JPFTG)"
  },
  {
   value: "Futajima (JPFUT)",
   label: "Futajima (JPFUT)"
  },
  {
   value: "Futamado (JPFMD)",
   label: "Futamado (JPFMD)"
  },
  {
   value: "\"Futamata (JPFMT)",
   label: "\"Futamata (JPFMT)"
  },
  {
   value: "\"Futamata (JPFTT)",
   label: "\"Futamata (JPFTT)"
  },
  {
   value: "\"Futami (JPHUT)",
   label: "\"Futami (JPHUT)"
  },
  {
   value: "\"Futami (JPHTM)",
   label: "\"Futami (JPHTM)"
  },
  {
   value: "Futenma (JPFTM)",
   label: "Futenma (JPFTM)"
  },
  {
   value: "Gamagori (JPGAM)",
   label: "Gamagori (JPGAM)"
  },
  {
   value: "Gendentokai (JPGPT)",
   label: "Gendentokai (JPGPT)"
  },
  {
   value: "Ginowan (JPGNW)",
   label: "Ginowan (JPGNW)"
  },
  {
   value: "Gohnokubi (JPGKB)",
   label: "Gohnokubi (JPGKB)"
  },
  {
   value: "Gohtsu (JPGOT)",
   label: "Gohtsu (JPGOT)"
  },
  {
   value: "Goi\/Ichihara (JPGOI)",
   label: "Goi\/Ichihara (JPGOI)"
  },
  {
   value: "Gokan (JPGKN)",
   label: "Gokan (JPGKN)"
  },
  {
   value: "Gokasho (JPGKS)",
   label: "Gokasho (JPGKS)"
  },
  {
   value: "Gonoura (JPGON)",
   label: "Gonoura (JPGON)"
  },
  {
   value: "Gunge (JPGNG)",
   label: "Gunge (JPGNG)"
  },
  {
   value: "Esashi\/Soya (JPESS)",
   label: "Esashi\/Soya (JPESS)"
  },
  {
   value: "Eshima (JPESM)",
   label: "Eshima (JPESM)"
  },
  {
   value: "Etajima (JPETA)",
   label: "Etajima (JPETA)"
  },
  {
   value: "Etomo (JPETM)",
   label: "Etomo (JPETM)"
  },
  {
   value: "Ezaki (JPEZA)",
   label: "Ezaki (JPEZA)"
  },
  {
   value: "Fuchinomoto (JPFCM)",
   label: "Fuchinomoto (JPFCM)"
  },
  {
   value: "Fugusaki (JPFGS)",
   label: "Fugusaki (JPFGS)"
  },
  {
   value: "Fuji (JPFUI)",
   label: "Fuji (JPFUI)"
  },
  {
   value: "Fujino (JPFJN)",
   label: "Fujino (JPFJN)"
  },
  {
   value: "\"Fukae (JPFKH)",
   label: "\"Fukae (JPFKH)"
  },
  {
   value: "\"Fukae (JPFAE)",
   label: "\"Fukae (JPFAE)"
  },
  {
   value: "Fukai (JPFKI)",
   label: "Fukai (JPFKI)"
  },
  {
   value: "Fukami (JPFUM)",
   label: "Fukami (JPFUM)"
  },
  {
   value: "Fukari (JPFRI)",
   label: "Fukari (JPFRI)"
  },
  {
   value: "\"Fukaura (JPFKK)",
   label: "\"Fukaura (JPFKK)"
  },
  {
   value: "\"Fukaura (JPFKR)",
   label: "\"Fukaura (JPFKR)"
  },
  {
   value: "Fukawa (JPFUW)",
   label: "Fukawa (JPFUW)"
  },
  {
   value: "Fukaya (JPFKA)",
   label: "Fukaya (JPFKA)"
  },
  {
   value: "Fuke (JPFUE)",
   label: "Fuke (JPFUE)"
  },
  {
   value: "Fukuda (JPFKD)",
   label: "Fukuda (JPFKD)"
  },
  {
   value: "\"Fukue (JPFKE)",
   label: "\"Fukue (JPFKE)"
  },
  {
   value: "\"Fukue (JPFUJ)",
   label: "\"Fukue (JPFUJ)"
  },
  {
   value: "Fukui (JPFKJ)",
   label: "Fukui (JPFKJ)"
  },
  {
   value: "Fukuoka (JPFUK)",
   label: "Fukuoka (JPFUK)"
  },
  {
   value: "\"Fukura (JPFRA)",
   label: "\"Fukura (JPFRA)"
  },
  {
   value: "\"Fukura (JPFUU)",
   label: "\"Fukura (JPFUU)"
  },
  {
   value: "Fukuro (JPFUO)",
   label: "Fukuro (JPFUO)"
  },
  {
   value: "\"Fukushima (JPFMS)",
   label: "\"Fukushima (JPFMS)"
  },
  {
   value: "\"Fukushima (JPFKS)",
   label: "\"Fukushima (JPFKS)"
  },
  {
   value: "\"Fukushima (JPFKM)",
   label: "\"Fukushima (JPFKM)"
  },
  {
   value: "\"Fukuura (JPFUR)",
   label: "\"Fukuura (JPFUR)"
  },
  {
   value: "\"Fukuura (JPFRJ)",
   label: "\"Fukuura (JPFRJ)"
  },
  {
   value: "\"Fukuura (JPFUA)",
   label: "\"Fukuura (JPFUA)"
  },
  {
   value: "\"Fukuyama (JPFKY)",
   label: "\"Fukuyama (JPFKY)"
  },
  {
   value: "\"Fukuyama (JPFYM)",
   label: "\"Fukuyama (JPFYM)"
  },
  {
   value: "Funabashi (JPFNB)",
   label: "Funabashi (JPFNB)"
  },
  {
   value: "Funadomari (JPFND)",
   label: "Funadomari (JPFND)"
  },
  {
   value: "Funagawa (JPFNK)",
   label: "Funagawa (JPFNK)"
  },
  {
   value: "\"Beppu (JPBEP)",
   label: "\"Beppu (JPBEP)"
  },
  {
   value: "\"Beppu (JPBPU)",
   label: "\"Beppu (JPBPU)"
  },
  {
   value: "Beppushinko (JPBFS)",
   label: "Beppushinko (JPBFS)"
  },
  {
   value: "Bohdomari (JPBDM)",
   label: "Bohdomari (JPBDM)"
  },
  {
   value: "Boma (JPBOM)",
   label: "Boma (JPBOM)"
  },
  {
   value: "Byobu (JPBYO)",
   label: "Byobu (JPBYO)"
  },
  {
   value: "Chiba (JPCHB)",
   label: "Chiba (JPCHB)"
  },
  {
   value: "Chichii (JPCHH)",
   label: "Chichii (JPCHH)"
  },
  {
   value: "Chiju (JPCJU)",
   label: "Chiju (JPCJU)"
  },
  {
   value: "Chikubushima (JPCHK)",
   label: "Chikubushima (JPCHK)"
  },
  {
   value: "Chikumi (JPCKM)",
   label: "Chikumi (JPCKM)"
  },
  {
   value: "China (JPCHI)",
   label: "China (JPCHI)"
  },
  {
   value: "Chinase (JPCNS)",
   label: "Chinase (JPCNS)"
  },
  {
   value: "Chio (JPCIO)",
   label: "Chio (JPCIO)"
  },
  {
   value: "Chita (JPCTA)",
   label: "Chita (JPCTA)"
  },
  {
   value: "Chitose Apt\/Sapporo (JPCTS)",
   label: "Chitose Apt\/Sapporo (JPCTS)"
  },
  {
   value: "\"Chitose (JPCHT)",
   label: "\"Chitose (JPCHT)"
  },
  {
   value: "Chiyozaki (JPCYZ)",
   label: "Chiyozaki (JPCYZ)"
  },
  {
   value: "Chofu (JPCHF)",
   label: "Chofu (JPCHF)"
  },
  {
   value: "Choshi (JPCHO)",
   label: "Choshi (JPCHO)"
  },
  {
   value: "Churui (JPCHU)",
   label: "Churui (JPCHU)"
  },
  {
   value: "Daito (JPDTU)",
   label: "Daito (JPDTU)"
  },
  {
   value: "Date (JPDAT)",
   label: "Date (JPDAT)"
  },
  {
   value: "Dohshiro (JPDSR)",
   label: "Dohshiro (JPDSR)"
  },
  {
   value: "Dohzaki (JPDZK)",
   label: "Dohzaki (JPDZK)"
  },
  {
   value: "Ebito (JPEBI)",
   label: "Ebito (JPEBI)"
  },
  {
   value: "Ego (JPEGO)",
   label: "Ego (JPEGO)"
  },
  {
   value: "Ei (JPEII)",
   label: "Ei (JPEII)"
  },
  {
   value: "Eigashima (JPEGS)",
   label: "Eigashima (JPEGS)"
  },
  {
   value: "Eishi (JPEIS)",
   label: "Eishi (JPEIS)"
  },
  {
   value: "Ejima (JPEJM)",
   label: "Ejima (JPEJM)"
  },
  {
   value: "Emukae (JPEMU)",
   label: "Emukae (JPEMU)"
  },
  {
   value: "En (JPENN)",
   label: "En (JPENN)"
  },
  {
   value: "Ena (JPENA)",
   label: "Ena (JPENA)"
  },
  {
   value: "Enohama (JPENH)",
   label: "Enohama (JPENH)"
  },
  {
   value: "Enokizu (JPEKZ)",
   label: "Enokizu (JPEKZ)"
  },
  {
   value: "\"Enoura (JPENR)",
   label: "\"Enoura (JPENR)"
  },
  {
   value: "Enoura\/Shizuoka (JPENO)",
   label: "Enoura\/Shizuoka (JPENO)"
  },
  {
   value: "Erimo (JPEMM)",
   label: "Erimo (JPEMM)"
  },
  {
   value: "Esaki (JPESK)",
   label: "Esaki (JPESK)"
  },
  {
   value: "Esashi\/Hiyama (JPESI)",
   label: "Esashi\/Hiyama (JPESI)"
  },
  {
   value: "Amurogama (JPARG)",
   label: "Amurogama (JPARG)"
  },
  {
   value: "Anamizu (JPANM)",
   label: "Anamizu (JPANM)"
  },
  {
   value: "Anan (JPANA)",
   label: "Anan (JPANA)"
  },
  {
   value: "Anbo (JPANB)",
   label: "Anbo (JPANB)"
  },
  {
   value: "Anegasaki (JPANE)",
   label: "Anegasaki (JPANE)"
  },
  {
   value: "Anjo (JPAJO)",
   label: "Anjo (JPAJO)"
  },
  {
   value: "Aoe (JPAOE)",
   label: "Aoe (JPAOE)"
  },
  {
   value: "Aogashima (JPAOG)",
   label: "Aogashima (JPAOG)"
  },
  {
   value: "Aokata (JPAOK)",
   label: "Aokata (JPAOK)"
  },
  {
   value: "Aoki (JPAOI)",
   label: "Aoki (JPAOI)"
  },
  {
   value: "Aomori (JPAOJ)",
   label: "Aomori (JPAOJ)"
  },
  {
   value: "Aonae (JPAON)",
   label: "Aonae (JPAON)"
  },
  {
   value: "Aoshima (JPAOS)",
   label: "Aoshima (JPAOS)"
  },
  {
   value: "Arao (JPARO)",
   label: "Arao (JPARO)"
  },
  {
   value: "Arari (JPARA)",
   label: "Arari (JPARA)"
  },
  {
   value: "Arikawa (JPARK)",
   label: "Arikawa (JPARK)"
  },
  {
   value: "Arimura (JPAMR)",
   label: "Arimura (JPAMR)"
  },
  {
   value: "Arouzu (JPARZ)",
   label: "Arouzu (JPARZ)"
  },
  {
   value: "Asa (JPASA)",
   label: "Asa (JPASA)"
  },
  {
   value: "Asahikawa (JPAKJ)",
   label: "Asahikawa (JPAKJ)"
  },
  {
   value: "Asakawa (JPASW)",
   label: "Asakawa (JPASW)"
  },
  {
   value: "Asami (JPASM)",
   label: "Asami (JPASM)"
  },
  {
   value: "Asamogawa (JPAMG)",
   label: "Asamogawa (JPAMG)"
  },
  {
   value: "Ashibe (JPASB)",
   label: "Ashibe (JPASB)"
  },
  {
   value: "Ashinoura (JPASH)",
   label: "Ashinoura (JPASH)"
  },
  {
   value: "Ashitoku (JPAST)",
   label: "Ashitoku (JPAST)"
  },
  {
   value: "\"Ashiya (JPASZ)",
   label: "\"Ashiya (JPASZ)"
  },
  {
   value: "Ashizuri (JPASR)",
   label: "Ashizuri (JPASR)"
  },
  {
   value: "Atami (JPAMI)",
   label: "Atami (JPAMI)"
  },
  {
   value: "Atatajima (JPATT)",
   label: "Atatajima (JPATT)"
  },
  {
   value: "Atsugi (JPNJA)",
   label: "Atsugi (JPNJA)"
  },
  {
   value: "Atsuki (JPATK)",
   label: "Atsuki (JPATK)"
  },
  {
   value: "Atsumi (JPATM)",
   label: "Atsumi (JPATM)"
  },
  {
   value: "Awa (JPAWA)",
   label: "Awa (JPAWA)"
  },
  {
   value: "Awajikoryunotsubasa (JPTBS)",
   label: "Awajikoryunotsubasa (JPTBS)"
  },
  {
   value: "Awano (JPYYA)",
   label: "Awano (JPYYA)"
  },
  {
   value: "Awashima (JPAWS)",
   label: "Awashima (JPAWS)"
  },
  {
   value: "Awashimanishi (JPAWM)",
   label: "Awashimanishi (JPAWM)"
  },
  {
   value: "Awazu (JPAWZ)",
   label: "Awazu (JPAWZ)"
  },
  {
   value: "Ayukawa (JPAYU)",
   label: "Ayukawa (JPAYU)"
  },
  {
   value: "Azako (JPAKW)",
   label: "Azako (JPAKW)"
  },
  {
   value: "Azu (JPAZU)",
   label: "Azu (JPAZU)"
  },
  {
   value: "\"Aikawa (JPAIW)",
   label: "\"Aikawa (JPAIW)"
  },
  {
   value: "\"Aikawa (JPAIK)",
   label: "\"Aikawa (JPAIK)"
  },
  {
   value: "Ainoura\/Sasebo (JPAIN)",
   label: "Ainoura\/Sasebo (JPAIN)"
  },
  {
   value: "Ainouraaoki\/Naru (JPAIA)",
   label: "Ainouraaoki\/Naru (JPAIA)"
  },
  {
   value: "Aio (JPAII)",
   label: "Aio (JPAII)"
  },
  {
   value: "Aioi (JPAIO)",
   label: "Aioi (JPAIO)"
  },
  {
   value: "Aishima (JPAIM)",
   label: "Aishima (JPAIM)"
  },
  {
   value: "\"Aizu (JPAIZ)",
   label: "\"Aizu (JPAIZ)"
  },
  {
   value: "Aja (JPAJX)",
   label: "Aja (JPAJX)"
  },
  {
   value: "Aji (JPAJI)",
   label: "Aji (JPAJI)"
  },
  {
   value: "Ajigasawa (JPAJK)",
   label: "Ajigasawa (JPAJK)"
  },
  {
   value: "Ajino (JPAJN)",
   label: "Ajino (JPAJN)"
  },
  {
   value: "\"Ajiro (JPAZR)",
   label: "\"Ajiro (JPAZR)"
  },
  {
   value: "\"Ajiro (JPAJR)",
   label: "\"Ajiro (JPAJR)"
  },
  {
   value: "\"Ajiro (JPAZJ)",
   label: "\"Ajiro (JPAZJ)"
  },
  {
   value: "Ajisu (JPACH)",
   label: "Ajisu (JPACH)"
  },
  {
   value: "Akadomari (JPAKD)",
   label: "Akadomari (JPAKD)"
  },
  {
   value: "Akakina (JPAKG)",
   label: "Akakina (JPAKG)"
  },
  {
   value: "Akamizu (JPAKM)",
   label: "Akamizu (JPAKM)"
  },
  {
   value: "\"Akasaki (JPAKK)",
   label: "\"Akasaki (JPAKK)"
  },
  {
   value: "\"Akasaki (JPASK)",
   label: "\"Akasaki (JPASK)"
  },
  {
   value: "Akashi (JPAKA)",
   label: "Akashi (JPAKA)"
  },
  {
   value: "Akehama (JPAKH)",
   label: "Akehama (JPAKH)"
  },
  {
   value: "Akita (JPAXT)",
   label: "Akita (JPAXT)"
  },
  {
   value: "Akitsu (JPAKT)",
   label: "Akitsu (JPAKT)"
  },
  {
   value: "Akkeshi (JPAKE)",
   label: "Akkeshi (JPAKE)"
  },
  {
   value: "Akoh (JPAKO)",
   label: "Akoh (JPAKO)"
  },
  {
   value: "Akohbaru (JPAKB)",
   label: "Akohbaru (JPAKB)"
  },
  {
   value: "Akune (JPAKN)",
   label: "Akune (JPAKN)"
  },
  {
   value: "\"Ama (JPAMM)",
   label: "\"Ama (JPAMM)"
  },
  {
   value: "\"Ama (JPAAM)",
   label: "\"Ama (JPAAM)"
  },
  {
   value: "Amagasaki (JPAMA)",
   label: "Amagasaki (JPAMA)"
  },
  {
   value: "AmagasakiNishinomiyaAshiya (JPAMX)",
   label: "AmagasakiNishinomiyaAshiya (JPAMX)"
  },
  {
   value: "Amaji (JPAMJ)",
   label: "Amaji (JPAMJ)"
  },
  {
   value: "Amamioshima (JPASJ)",
   label: "Amamioshima (JPASJ)"
  },
  {
   value: "Amasaki (JPAMS)",
   label: "Amasaki (JPAMS)"
  },
  {
   value: "Amatsuke (JPAMT)",
   label: "Amatsuke (JPAMT)"
  },
  {
   value: "Amiya (JPAMY)",
   label: "Amiya (JPAMY)"
  },
  {
   value: "Amura (JPAMU)",
   label: "Amura (JPAMU)"
  },
  {
   value: "Georgetown (JMGGT)",
   label: "Georgetown (JMGGT)"
  },
  {
   value: "Kingston (JMKIN)",
   label: "Kingston (JMKIN)"
  },
  {
   value: "Lucea (JMLUC)",
   label: "Lucea (JMLUC)"
  },
  {
   value: "Mandeville (JMMVJ)",
   label: "Mandeville (JMMVJ)"
  },
  {
   value: "Montego Bay (JMMBJ)",
   label: "Montego Bay (JMMBJ)"
  },
  {
   value: "Negril (JMNEG)",
   label: "Negril (JMNEG)"
  },
  {
   value: "Ocho Rios (JMOCJ)",
   label: "Ocho Rios (JMOCJ)"
  },
  {
   value: "Oraca-Bessa (JMORC)",
   label: "Oraca-Bessa (JMORC)"
  },
  {
   value: "Port Antonio (JMPOT)",
   label: "Port Antonio (JMPOT)"
  },
  {
   value: "Port Esquivel (JMPEV)",
   label: "Port Esquivel (JMPEV)"
  },
  {
   value: "Port Kaiser (JMPKS)",
   label: "Port Kaiser (JMPKS)"
  },
  {
   value: "Port Morant (JMPMO)",
   label: "Port Morant (JMPMO)"
  },
  {
   value: "Port Rhoades (JMPRH)",
   label: "Port Rhoades (JMPRH)"
  },
  {
   value: "Port Royal (JMPRO)",
   label: "Port Royal (JMPRO)"
  },
  {
   value: "Rio Bueno (JMRIB)",
   label: "Rio Bueno (JMRIB)"
  },
  {
   value: "Rocky Point (JMROP)",
   label: "Rocky Point (JMROP)"
  },
  {
   value: "Salt River (JMSRI)",
   label: "Salt River (JMSRI)"
  },
  {
   value: "Savanna la Mar (JMSLM)",
   label: "Savanna la Mar (JMSLM)"
  },
  {
   value: "Spanish Town (JMSPT)",
   label: "Spanish Town (JMSPT)"
  },
  {
   value: "St Anns Bay (JMSAW)",
   label: "St Anns Bay (JMSAW)"
  },
  {
   value: "St Thomas (JMSTH)",
   label: "St Thomas (JMSTH)"
  },
  {
   value: "Amman (JOAMM)",
   label: "Amman (JOAMM)"
  },
  {
   value: "Aqaba (El Akaba) (JOAQJ)",
   label: "Aqaba (El Akaba) (JOAQJ)"
  },
  {
   value: "Aqaba Free Zone (JOAQB)",
   label: "Aqaba Free Zone (JOAQB)"
  },
  {
   value: "Irbid (JOQIR)",
   label: "Irbid (JOQIR)"
  },
  {
   value: "Maan (JOMPQ)",
   label: "Maan (JOMPQ)"
  },
  {
   value: "Zarqa (JOZAR)",
   label: "Zarqa (JOZAR)"
  },
  {
   value: "Abashiri (JPABA)",
   label: "Abashiri (JPABA)"
  },
  {
   value: "Abohshita (JPABS)",
   label: "Abohshita (JPABS)"
  },
  {
   value: "Aboshi\/Himeji (JPABO)",
   label: "Aboshi\/Himeji (JPABO)"
  },
  {
   value: "Aburatsu (JPABU)",
   label: "Aburatsu (JPABU)"
  },
  {
   value: "Abuto (JPABT)",
   label: "Abuto (JPABT)"
  },
  {
   value: "Ade (JPADE)",
   label: "Ade (JPADE)"
  },
  {
   value: "Ado (JPADO)",
   label: "Ado (JPADO)"
  },
  {
   value: "Agenosho (JPAGN)",
   label: "Agenosho (JPAGN)"
  },
  {
   value: "Ageshima (JPAGS)",
   label: "Ageshima (JPAGS)"
  },
  {
   value: "Agonoura (JPAGR)",
   label: "Agonoura (JPAGR)"
  },
  {
   value: "Aguni (JPAGJ)",
   label: "Aguni (JPAGJ)"
  },
  {
   value: "Aika (JPAKZ)",
   label: "Aika (JPAKZ)"
  },
  {
   value: "Aikakita (JPAKI)",
   label: "Aikakita (JPAKI)"
  },
  {
   value: "Villotta di Chions (ITVTA)",
   label: "Villotta di Chions (ITVTA)"
  },
  {
   value: "Vimodrone (ITVMD)",
   label: "Vimodrone (ITVMD)"
  },
  {
   value: "Vincentina (ITVNC)",
   label: "Vincentina (ITVNC)"
  },
  {
   value: "Vinovo (ITVVO)",
   label: "Vinovo (ITVVO)"
  },
  {
   value: "Viterbo (ITVIT)",
   label: "Viterbo (ITVIT)"
  },
  {
   value: "Vitorchiano (ITVEP)",
   label: "Vitorchiano (ITVEP)"
  },
  {
   value: "Vittoria (ITVTO)",
   label: "Vittoria (ITVTO)"
  },
  {
   value: "Vittorio Veneto (ITVRV)",
   label: "Vittorio Veneto (ITVRV)"
  },
  {
   value: "Vittuone (ITVEV)",
   label: "Vittuone (ITVEV)"
  },
  {
   value: "Voghera (ITVGH)",
   label: "Voghera (ITVGH)"
  },
  {
   value: "Volano (ITVLN)",
   label: "Volano (ITVLN)"
  },
  {
   value: "Volargne (ITVLG)",
   label: "Volargne (ITVLG)"
  },
  {
   value: "Volpiano (ITVPI)",
   label: "Volpiano (ITVPI)"
  },
  {
   value: "Voltri (ITVTI)",
   label: "Voltri (ITVTI)"
  },
  {
   value: "Volvera (ITVOL)",
   label: "Volvera (ITVOL)"
  },
  {
   value: "Vulcano porto (ITVUL)",
   label: "Vulcano porto (ITVUL)"
  },
  {
   value: "Zandobbio (ITZAN)",
   label: "Zandobbio (ITZAN)"
  },
  {
   value: "Zane (ITZNE)",
   label: "Zane (ITZNE)"
  },
  {
   value: "Zanica (ITZNC)",
   label: "Zanica (ITZNC)"
  },
  {
   value: "Zeccone (ITZCC)",
   label: "Zeccone (ITZCC)"
  },
  {
   value: "Zermeghedo (ITZRM)",
   label: "Zermeghedo (ITZRM)"
  },
  {
   value: "Zero Branco (ITZBO)",
   label: "Zero Branco (ITZBO)"
  },
  {
   value: "Zevio (ITZVO)",
   label: "Zevio (ITZVO)"
  },
  {
   value: "Zimella (ITZML)",
   label: "Zimella (ITZML)"
  },
  {
   value: "Zingonia (ITZIN)",
   label: "Zingonia (ITZIN)"
  },
  {
   value: "Zocco (ITZCO)",
   label: "Zocco (ITZCO)"
  },
  {
   value: "Zogno (ITZGO)",
   label: "Zogno (ITZGO)"
  },
  {
   value: "Zola Predosa (ITZOL)",
   label: "Zola Predosa (ITZOL)"
  },
  {
   value: "Zugliano (ITZUG)",
   label: "Zugliano (ITZUG)"
  },
  {
   value: "Casalfiumanese (ITCAF)",
   label: "Casalfiumanese (ITCAF)"
  },
  {
   value: "Cerea (ITCRX)",
   label: "Cerea (ITCRX)"
  },
  {
   value: "Empoli (ITEPI)",
   label: "Empoli (ITEPI)"
  },
  {
   value: "Manta (ITMNA)",
   label: "Manta (ITMNA)"
  },
  {
   value: "Olgiate Comasco (ITOLC)",
   label: "Olgiate Comasco (ITOLC)"
  },
  {
   value: "San Giovanni in Persiceto (ITGIP)",
   label: "San Giovanni in Persiceto (ITGIP)"
  },
  {
   value: "San Martino Di Lupari (ITSMU)",
   label: "San Martino Di Lupari (ITSMU)"
  },
  {
   value: "Sasso Marconi (ITSSM)",
   label: "Sasso Marconi (ITSSM)"
  },
  {
   value: "Alligator Pond (JMALP)",
   label: "Alligator Pond (JMALP)"
  },
  {
   value: "Black River (JMBLR)",
   label: "Black River (JMBLR)"
  },
  {
   value: "Bowden (JMBWN)",
   label: "Bowden (JMBWN)"
  },
  {
   value: "Falmouth (JMFMH)",
   label: "Falmouth (JMFMH)"
  },
  {
   value: "Venragono (ITVQG)",
   label: "Venragono (ITVQG)"
  },
  {
   value: "Ventimiglia (ITVEN)",
   label: "Ventimiglia (ITVEN)"
  },
  {
   value: "Ventotene (ITVTT)",
   label: "Ventotene (ITVTT)"
  },
  {
   value: "Vercelli (ITVRL)",
   label: "Vercelli (ITVRL)"
  },
  {
   value: "Vercurago (ITVCR)",
   label: "Vercurago (ITVCR)"
  },
  {
   value: "Verdellino (ITVRD)",
   label: "Verdellino (ITVRD)"
  },
  {
   value: "Verderio (ITVDR)",
   label: "Verderio (ITVDR)"
  },
  {
   value: "Vergnasco (ITVRG)",
   label: "Vergnasco (ITVRG)"
  },
  {
   value: "Vernezzo (ITVNZ)",
   label: "Vernezzo (ITVNZ)"
  },
  {
   value: "Verolanuova (ITVER)",
   label: "Verolanuova (ITVER)"
  },
  {
   value: "Verolavecchia (ITVRA)",
   label: "Verolavecchia (ITVRA)"
  },
  {
   value: "Verona (ITVRN)",
   label: "Verona (ITVRN)"
  },
  {
   value: "Vertemate (ITVTM)",
   label: "Vertemate (ITVTM)"
  },
  {
   value: "Verucchio (ITVRC)",
   label: "Verucchio (ITVRC)"
  },
  {
   value: "Vezzano (ITVZZ)",
   label: "Vezzano (ITVZZ)"
  },
  {
   value: "Viandronno (ITVND)",
   label: "Viandronno (ITVND)"
  },
  {
   value: "Viareggio (ITVIA)",
   label: "Viareggio (ITVIA)"
  },
  {
   value: "Vibo Valentia (ITVVA)",
   label: "Vibo Valentia (ITVVA)"
  },
  {
   value: "Vicenza (ITVIC)",
   label: "Vicenza (ITVIC)"
  },
  {
   value: "Vico (ITVCO)",
   label: "Vico (ITVCO)"
  },
  {
   value: "Vieste (ITVIE)",
   label: "Vieste (ITVIE)"
  },
  {
   value: "Vigevano (ITVGV)",
   label: "Vigevano (ITVGV)"
  },
  {
   value: "Vighizzolo Di Cantu (ITVDC)",
   label: "Vighizzolo Di Cantu (ITVDC)"
  },
  {
   value: "Vigliano (ITVIG)",
   label: "Vigliano (ITVIG)"
  },
  {
   value: "Vignole Borbera (ITVBA)",
   label: "Vignole Borbera (ITVBA)"
  },
  {
   value: "Vigolzone (ITVGZ)",
   label: "Vigolzone (ITVGZ)"
  },
  {
   value: "Vigonza (ITVIZ)",
   label: "Vigonza (ITVIZ)"
  },
  {
   value: "Villa Cortese (ITVLC)",
   label: "Villa Cortese (ITVLC)"
  },
  {
   value: "Villa d'Ogna (ITVIL)",
   label: "Villa d'Ogna (ITVIL)"
  },
  {
   value: "Villa di Serio (ITVLD)",
   label: "Villa di Serio (ITVLD)"
  },
  {
   value: "Villa Sesso (ITVSS)",
   label: "Villa Sesso (ITVSS)"
  },
  {
   value: "Villalba (ITVLB)",
   label: "Villalba (ITVLB)"
  },
  {
   value: "Villanova (ITVNV)",
   label: "Villanova (ITVNV)"
  },
  {
   value: "Villanova Camposanpiero (ITVCA)",
   label: "Villanova Camposanpiero (ITVCA)"
  },
  {
   value: "Villanova d'Ardenghi (ITVNA)",
   label: "Villanova d'Ardenghi (ITVNA)"
  },
  {
   value: "Villanova Monferrato (ITVMF)",
   label: "Villanova Monferrato (ITVMF)"
  },
  {
   value: "Villasanta (ITVSN)",
   label: "Villasanta (ITVSN)"
  },
  {
   value: "Villastellone (ITVSI)",
   label: "Villastellone (ITVSI)"
  },
  {
   value: "Villaverla (ITVVL)",
   label: "Villaverla (ITVVL)"
  },
  {
   value: "Tradate (ITTRD)",
   label: "Tradate (ITTRD)"
  },
  {
   value: "Trani (ITTNI)",
   label: "Trani (ITTNI)"
  },
  {
   value: "Trapani (ITTPS)",
   label: "Trapani (ITTPS)"
  },
  {
   value: "Trebaseleghe (ITTBE)",
   label: "Trebaseleghe (ITTBE)"
  },
  {
   value: "Trecate (ITTRE)",
   label: "Trecate (ITTRE)"
  },
  {
   value: "Tregnago (ITTEG)",
   label: "Tregnago (ITTEG)"
  },
  {
   value: "Tremiti (ITTMT)",
   label: "Tremiti (ITTMT)"
  },
  {
   value: "Trento (ITTRT)",
   label: "Trento (ITTRT)"
  },
  {
   value: "Trestina (ITTST)",
   label: "Trestina (ITTST)"
  },
  {
   value: "Treviglio (ITTVG)",
   label: "Treviglio (ITTVG)"
  },
  {
   value: "Trevignano (ITTGN)",
   label: "Trevignano (ITTGN)"
  },
  {
   value: "Treviso (ITTRV)",
   label: "Treviso (ITTRV)"
  },
  {
   value: "Trieste (ITTRS)",
   label: "Trieste (ITTRS)"
  },
  {
   value: "Trissano (Vicenza) (ITTSA)",
   label: "Trissano (Vicenza) (ITTSA)"
  },
  {
   value: "Trissino (ITTRO)",
   label: "Trissino (ITTRO)"
  },
  {
   value: "Trompia (ITTRM)",
   label: "Trompia (ITTRM)"
  },
  {
   value: "Turate (ITTRA)",
   label: "Turate (ITTRA)"
  },
  {
   value: "Turbigo (ITTGO)",
   label: "Turbigo (ITTGO)"
  },
  {
   value: "Udine (ITUDN)",
   label: "Udine (ITUDN)"
  },
  {
   value: "Urgnano (ITURG)",
   label: "Urgnano (ITURG)"
  },
  {
   value: "Ustica (ITUST)",
   label: "Ustica (ITUST)"
  },
  {
   value: "Va Olonia (ITVOA)",
   label: "Va Olonia (ITVOA)"
  },
  {
   value: "Vada (ITVDA)",
   label: "Vada (ITVDA)"
  },
  {
   value: "Vado Ligure (ITVDL)",
   label: "Vado Ligure (ITVDL)"
  },
  {
   value: "Vado\/Bologna (ITVAD)",
   label: "Vado\/Bologna (ITVAD)"
  },
  {
   value: "Vado\/Lucca (ITVDO)",
   label: "Vado\/Lucca (ITVDO)"
  },
  {
   value: "Vagliagli (ITVGL)",
   label: "Vagliagli (ITVGL)"
  },
  {
   value: "Valdagno (ITVGO)",
   label: "Valdagno (ITVGO)"
  },
  {
   value: "Vallacupa (ITVAL)",
   label: "Vallacupa (ITVAL)"
  },
  {
   value: "Valmadrera (ITVLM)",
   label: "Valmadrera (ITVLM)"
  },
  {
   value: "Valvasone (ITVVE)",
   label: "Valvasone (ITVVE)"
  },
  {
   value: "Vandoles (ITVDS)",
   label: "Vandoles (ITVDS)"
  },
  {
   value: "Varese (ITVAR)",
   label: "Varese (ITVAR)"
  },
  {
   value: "Vasto (ITVSO)",
   label: "Vasto (ITVSO)"
  },
  {
   value: "Veggia (ITVGI)",
   label: "Veggia (ITVGI)"
  },
  {
   value: "Velo D'astico (ITVED)",
   label: "Velo D'astico (ITVED)"
  },
  {
   value: "Venari Reale (ITVRE)",
   label: "Venari Reale (ITVRE)"
  },
  {
   value: "Venegono (ITVEG)",
   label: "Venegono (ITVEG)"
  },
  {
   value: "Venezia (ITVCE)",
   label: "Venezia (ITVCE)"
  },
  {
   value: "Vengiate (ITVNG)",
   label: "Vengiate (ITVNG)"
  },
  {
   value: "Veniano (ITVNO)",
   label: "Veniano (ITVNO)"
  },
  {
   value: "Spino d'Adda (ITSDA)",
   label: "Spino d'Adda (ITSDA)"
  },
  {
   value: "Spoleto (ITSLT)",
   label: "Spoleto (ITSLT)"
  },
  {
   value: "St Angelo Scalo (ITSTA)",
   label: "St Angelo Scalo (ITSTA)"
  },
  {
   value: "Stabbia (ITSBI)",
   label: "Stabbia (ITSBI)"
  },
  {
   value: "Stagno (ITSTG)",
   label: "Stagno (ITSTG)"
  },
  {
   value: "Strevi (ITSVI)",
   label: "Strevi (ITSVI)"
  },
  {
   value: "Stromboli (ITSTR)",
   label: "Stromboli (ITSTR)"
  },
  {
   value: "Susegana (ITSUS)",
   label: "Susegana (ITSUS)"
  },
  {
   value: "Suzzara (ITSZA)",
   label: "Suzzara (ITSZA)"
  },
  {
   value: "Talamone (ITTAL)",
   label: "Talamone (ITTAL)"
  },
  {
   value: "Taranto (ITTAR)",
   label: "Taranto (ITTAR)"
  },
  {
   value: "Tavernelle (ITTVN)",
   label: "Tavernelle (ITTVN)"
  },
  {
   value: "Taverol (ITTAV)",
   label: "Taverol (ITTAV)"
  },
  {
   value: "Taveroza (ITTVE)",
   label: "Taveroza (ITTVE)"
  },
  {
   value: "Telgate (ITTEL)",
   label: "Telgate (ITTEL)"
  },
  {
   value: "Teramo (ITTEO)",
   label: "Teramo (ITTEO)"
  },
  {
   value: "Termini Imereses (ITTRI)",
   label: "Termini Imereses (ITTRI)"
  },
  {
   value: "Termoli (ITTMI)",
   label: "Termoli (ITTMI)"
  },
  {
   value: "Terni (ITTER)",
   label: "Terni (ITTER)"
  },
  {
   value: "Terracina (ITTRC)",
   label: "Terracina (ITTRC)"
  },
  {
   value: "Terruggia (ITTRR)",
   label: "Terruggia (ITTRR)"
  },
  {
   value: "Tezze (ITTZZ)",
   label: "Tezze (ITTZZ)"
  },
  {
   value: "Thiene (ITTHE)",
   label: "Thiene (ITTHE)"
  },
  {
   value: "Tirano (ITTNO)",
   label: "Tirano (ITTNO)"
  },
  {
   value: "Tirrenia (ITTTF)",
   label: "Tirrenia (ITTTF)"
  },
  {
   value: "Tivoli (ITTIV)",
   label: "Tivoli (ITTIV)"
  },
  {
   value: "Tizzoro (ITTIZ)",
   label: "Tizzoro (ITTIZ)"
  },
  {
   value: "Tombolo (ITTOM)",
   label: "Tombolo (ITTOM)"
  },
  {
   value: "Torgiano (ITTXO)",
   label: "Torgiano (ITTXO)"
  },
  {
   value: "Torino (ITTRN)",
   label: "Torino (ITTRN)"
  },
  {
   value: "Torino di Sangro (ITTDS)",
   label: "Torino di Sangro (ITTDS)"
  },
  {
   value: "Tornaco (ITTOR)",
   label: "Tornaco (ITTOR)"
  },
  {
   value: "Torre Annunziata (ITTOA)",
   label: "Torre Annunziata (ITTOA)"
  },
  {
   value: "Torre del Greco (ITTDG)",
   label: "Torre del Greco (ITTDG)"
  },
  {
   value: "Torregrande (ITTGR)",
   label: "Torregrande (ITTGR)"
  },
  {
   value: "Torrevecchia Teatina (ITTAT)",
   label: "Torrevecchia Teatina (ITTAT)"
  },
  {
   value: "Tortoli (ITTTB)",
   label: "Tortoli (ITTTB)"
  },
  {
   value: "Tortona (ITTTA)",
   label: "Tortona (ITTTA)"
  },
  {
   value: "Torviscosa (ITTVC)",
   label: "Torviscosa (ITTVC)"
  },
  {
   value: "Toscanella Di Dozza (ITTDZ)",
   label: "Toscanella Di Dozza (ITTDZ)"
  },
  {
   value: "Serravalle Scrivia (ITSRV)",
   label: "Serravalle Scrivia (ITSRV)"
  },
  {
   value: "Sessa Aurunca (ITSAU)",
   label: "Sessa Aurunca (ITSAU)"
  },
  {
   value: "Sesto Calende (ITSEE)",
   label: "Sesto Calende (ITSEE)"
  },
  {
   value: "Sesto Fiorentino (ITSTF)",
   label: "Sesto Fiorentino (ITSTF)"
  },
  {
   value: "Sesto San Giovanni (ITSSG)",
   label: "Sesto San Giovanni (ITSSG)"
  },
  {
   value: "Settecamini (ITSET)",
   label: "Settecamini (ITSET)"
  },
  {
   value: "Settimello-Calenzano (ITSEC)",
   label: "Settimello-Calenzano (ITSEC)"
  },
  {
   value: "Settimo Milanese (ITSTI)",
   label: "Settimo Milanese (ITSTI)"
  },
  {
   value: "Settimo Torinese (ITSTT)",
   label: "Settimo Torinese (ITSTT)"
  },
  {
   value: "Seveso (ITSEV)",
   label: "Seveso (ITSEV)"
  },
  {
   value: "Siderno Marina (ITSID)",
   label: "Siderno Marina (ITSID)"
  },
  {
   value: "Siena (ITSNA)",
   label: "Siena (ITSNA)"
  },
  {
   value: "Sigonella (ITNSY)",
   label: "Sigonella (ITNSY)"
  },
  {
   value: "Siracusa (ITSIR)",
   label: "Siracusa (ITSIR)"
  },
  {
   value: "Soiano Del Lago (ITSDL)",
   label: "Soiano Del Lago (ITSDL)"
  },
  {
   value: "Solara di Bomporto (ITSBM)",
   label: "Solara di Bomporto (ITSBM)"
  },
  {
   value: "Solaro (ITSOO)",
   label: "Solaro (ITSOO)"
  },
  {
   value: "Solbiate (ITSBT)",
   label: "Solbiate (ITSBT)"
  },
  {
   value: "Solbiate Arno (ITSBA)",
   label: "Solbiate Arno (ITSBA)"
  },
  {
   value: "Solbiate Olona (ITSBO)",
   label: "Solbiate Olona (ITSBO)"
  },
  {
   value: "Solero (ITSLR)",
   label: "Solero (ITSLR)"
  },
  {
   value: "Soligano di Castelvetro (ITLDC)",
   label: "Soligano di Castelvetro (ITLDC)"
  },
  {
   value: "Solignano (ITSLG)",
   label: "Solignano (ITSLG)"
  },
  {
   value: "Solofra (ITSOL)",
   label: "Solofra (ITSOL)"
  },
  {
   value: "Solofra Avellino (ITSOA)",
   label: "Solofra Avellino (ITSOA)"
  },
  {
   value: "Solto Collina (ITSTO)",
   label: "Solto Collina (ITSTO)"
  },
  {
   value: "Sommacampagna (ITSCG)",
   label: "Sommacampagna (ITSCG)"
  },
  {
   value: "Soncino (ITSON)",
   label: "Soncino (ITSON)"
  },
  {
   value: "Sondrio (ITSND)",
   label: "Sondrio (ITSND)"
  },
  {
   value: "Sorbolo (ITSOR)",
   label: "Sorbolo (ITSOR)"
  },
  {
   value: "Sordevolo (ITSRD)",
   label: "Sordevolo (ITSRD)"
  },
  {
   value: "Sorrento (ITRRO)",
   label: "Sorrento (ITRRO)"
  },
  {
   value: "Sossano (ITSOS)",
   label: "Sossano (ITSOS)"
  },
  {
   value: "Spello (ITSPL)",
   label: "Spello (ITSPL)"
  },
  {
   value: "Spezzano Albaese (ITSPZ)",
   label: "Spezzano Albaese (ITSPZ)"
  },
  {
   value: "Spilimbergo (ITSBG)",
   label: "Spilimbergo (ITSBG)"
  },
  {
   value: "Spilimberto (ITSPI)",
   label: "Spilimberto (ITSPI)"
  },
  {
   value: "Spinetta (ITSPN)",
   label: "Spinetta (ITSPN)"
  },
  {
   value: "Sant'Agostino (ITSAO)",
   label: "Sant'Agostino (ITSAO)"
  },
  {
   value: "Santa Agata Di Militelo (ITSAG)",
   label: "Santa Agata Di Militelo (ITSAG)"
  },
  {
   value: "Santa Croce (ITSCR)",
   label: "Santa Croce (ITSCR)"
  },
  {
   value: "Santa Croce Sull'Arno (ITQGD)",
   label: "Santa Croce Sull'Arno (ITQGD)"
  },
  {
   value: "Santa Margherita Ligure (ITSML)",
   label: "Santa Margherita Ligure (ITSML)"
  },
  {
   value: "Santa Maria (ITSMA)",
   label: "Santa Maria (ITSMA)"
  },
  {
   value: "Santa Maria Capua Vetere (ITSMC)",
   label: "Santa Maria Capua Vetere (ITSMC)"
  },
  {
   value: "Santa Maria Di Sala (ITSMS)",
   label: "Santa Maria Di Sala (ITSMS)"
  },
  {
   value: "Santa Maria Nueva (ITSMN)",
   label: "Santa Maria Nueva (ITSMN)"
  },
  {
   value: "Santa Panagia (ITSPA)",
   label: "Santa Panagia (ITSPA)"
  },
  {
   value: "Santa Teresa Di Gallura (ITSTE)",
   label: "Santa Teresa Di Gallura (ITSTE)"
  },
  {
   value: "Santa Vittoria D'alba (ITSVD)",
   label: "Santa Vittoria D'alba (ITSVD)"
  },
  {
   value: "Santeramo in Colle (ITSRC)",
   label: "Santeramo in Colle (ITSRC)"
  },
  {
   value: "Santo Stefano di Magra (ITQGO)",
   label: "Santo Stefano di Magra (ITQGO)"
  },
  {
   value: "Sarego (ITSRG)",
   label: "Sarego (ITSRG)"
  },
  {
   value: "Sarmeola di Rubano (ITSDR)",
   label: "Sarmeola di Rubano (ITSDR)"
  },
  {
   value: "Saronno (ITSRN)",
   label: "Saronno (ITSRN)"
  },
  {
   value: "Sassari (ITQSS)",
   label: "Sassari (ITQSS)"
  },
  {
   value: "Sassello (ITSSL)",
   label: "Sassello (ITSSL)"
  },
  {
   value: "Sassuolo (ITSSU)",
   label: "Sassuolo (ITSSU)"
  },
  {
   value: "Savignano Sul Panaro (ITSSP)",
   label: "Savignano Sul Panaro (ITSSP)"
  },
  {
   value: "Savignone (ITSAV)",
   label: "Savignone (ITSAV)"
  },
  {
   value: "Savona (ITSVN)",
   label: "Savona (ITSVN)"
  },
  {
   value: "Scandiano (ITSCA)",
   label: "Scandiano (ITSCA)"
  },
  {
   value: "Scanzano Jonico (ITSZJ)",
   label: "Scanzano Jonico (ITSZJ)"
  },
  {
   value: "Schio (ITSCH)",
   label: "Schio (ITSCH)"
  },
  {
   value: "Scicli (ITSCI)",
   label: "Scicli (ITSCI)"
  },
  {
   value: "Scilla (ITSLL)",
   label: "Scilla (ITSLL)"
  },
  {
   value: "Scoglitti (ITSCO)",
   label: "Scoglitti (ITSCO)"
  },
  {
   value: "Seano (ITSNO)",
   label: "Seano (ITSNO)"
  },
  {
   value: "Sega di Cavaion (ITSDC)",
   label: "Sega di Cavaion (ITSDC)"
  },
  {
   value: "Segme Di Vielo (ITSDV)",
   label: "Segme Di Vielo (ITSDV)"
  },
  {
   value: "Segrate (ITSGE)",
   label: "Segrate (ITSGE)"
  },
  {
   value: "Sella Corsico (ITSEL)",
   label: "Sella Corsico (ITSEL)"
  },
  {
   value: "Seregno (ITSGO)",
   label: "Seregno (ITSGO)"
  },
  {
   value: "Seriate (ITSER)",
   label: "Seriate (ITSER)"
  },
  {
   value: "Serralunga D'alba (ITSRR)",
   label: "Serralunga D'alba (ITSRR)"
  },
  {
   value: "San Giovanni Bianco (ITSGB)",
   label: "San Giovanni Bianco (ITSGB)"
  },
  {
   value: "San Giovanni Lupatoto (ITSGL)",
   label: "San Giovanni Lupatoto (ITSGL)"
  },
  {
   value: "San Giovanni Valdarno (ITSGV)",
   label: "San Giovanni Valdarno (ITSGV)"
  },
  {
   value: "San Giuliano (ITSGI)",
   label: "San Giuliano (ITSGI)"
  },
  {
   value: "San Guiseppe (ITSGU)",
   label: "San Guiseppe (ITSGU)"
  },
  {
   value: "San Lazzaro di Savena (ITSLS)",
   label: "San Lazzaro di Savena (ITSLS)"
  },
  {
   value: "San Marco Argetano (ITSMR)",
   label: "San Marco Argetano (ITSMR)"
  },
  {
   value: "San Martino dell Argine (ITSMD)",
   label: "San Martino dell Argine (ITSMD)"
  },
  {
   value: "San Michele di Ganzaria (ITSMG)",
   label: "San Michele di Ganzaria (ITSMG)"
  },
  {
   value: "San Michele Extra (ITSMX)",
   label: "San Michele Extra (ITSMX)"
  },
  {
   value: "San Michele Mondovi (ITSMM)",
   label: "San Michele Mondovi (ITSMM)"
  },
  {
   value: "San Michele Prazzo (ITSMP)",
   label: "San Michele Prazzo (ITSMP)"
  },
  {
   value: "San Miniato (ITSMI)",
   label: "San Miniato (ITSMI)"
  },
  {
   value: "San Nicola Al Strada (ITSNS)",
   label: "San Nicola Al Strada (ITSNS)"
  },
  {
   value: "San Nicolo Ferrarese (ITSNF)",
   label: "San Nicolo Ferrarese (ITSNF)"
  },
  {
   value: "San Pancrazio (ITSPC)",
   label: "San Pancrazio (ITSPC)"
  },
  {
   value: "San Pietro (ITSNP)",
   label: "San Pietro (ITSNP)"
  },
  {
   value: "San Pietro in Casale (ITSPS)",
   label: "San Pietro in Casale (ITSPS)"
  },
  {
   value: "San Pietro Mussolini (ITSPM)",
   label: "San Pietro Mussolini (ITSPM)"
  },
  {
   value: "San Polo Di Podenzano (ITSPP)",
   label: "San Polo Di Podenzano (ITSPP)"
  },
  {
   value: "San Polo di Torrile (ITSPD)",
   label: "San Polo di Torrile (ITSPD)"
  },
  {
   value: "San Remo (ITSRE)",
   label: "San Remo (ITSRE)"
  },
  {
   value: "San Rocco (ITSAR)",
   label: "San Rocco (ITSAR)"
  },
  {
   value: "San Salvo (ITSSA)",
   label: "San Salvo (ITSSA)"
  },
  {
   value: "San Severo (ITSVO)",
   label: "San Severo (ITSVO)"
  },
  {
   value: "San Sisto (ITSSO)",
   label: "San Sisto (ITSSO)"
  },
  {
   value: "San Stefano Belbo (ITSSB)",
   label: "San Stefano Belbo (ITSSB)"
  },
  {
   value: "San Vendemiano (ITSNV)",
   label: "San Vendemiano (ITSNV)"
  },
  {
   value: "San Vito al Tagliamento (ITSVT)",
   label: "San Vito al Tagliamento (ITSVT)"
  },
  {
   value: "San Vito di Leguzzano (ITSVL)",
   label: "San Vito di Leguzzano (ITSVL)"
  },
  {
   value: "San Vito lo Capo (ITSVC)",
   label: "San Vito lo Capo (ITSVC)"
  },
  {
   value: "San Zeno naviglio (ITSZN)",
   label: "San Zeno naviglio (ITSZN)"
  },
  {
   value: "Sandigliano (ITSAN)",
   label: "Sandigliano (ITSAN)"
  },
  {
   value: "Sandrigo (ITSDG)",
   label: "Sandrigo (ITSDG)"
  },
  {
   value: "Sant' Antioco (ITSAT)",
   label: "Sant' Antioco (ITSAT)"
  },
  {
   value: "Rondissone (ITRON)",
   label: "Rondissone (ITRON)"
  },
  {
   value: "Rosa (ITROS)",
   label: "Rosa (ITROS)"
  },
  {
   value: "Roseto Degli Abruzzi (ITRDA)",
   label: "Roseto Degli Abruzzi (ITRDA)"
  },
  {
   value: "Rossano (ITRSN)",
   label: "Rossano (ITRSN)"
  },
  {
   value: "Roteglia (ITROT)",
   label: "Roteglia (ITROT)"
  },
  {
   value: "Roveleto (ITROV)",
   label: "Roveleto (ITROV)"
  },
  {
   value: "Rovereto (ITRTO)",
   label: "Rovereto (ITRTO)"
  },
  {
   value: "Rozzano (ITRZO)",
   label: "Rozzano (ITRZO)"
  },
  {
   value: "Rubiera (ITRUB)",
   label: "Rubiera (ITRUB)"
  },
  {
   value: "Rufina (ITRFN)",
   label: "Rufina (ITRFN)"
  },
  {
   value: "Rutigliano (ITRLL)",
   label: "Rutigliano (ITRLL)"
  },
  {
   value: "Sabbionetta (ITSAB)",
   label: "Sabbionetta (ITSAB)"
  },
  {
   value: "Sacile (ITSCL)",
   label: "Sacile (ITSCL)"
  },
  {
   value: "Salerno (ITSAL)",
   label: "Salerno (ITSAL)"
  },
  {
   value: "Salgareda (ITSGR)",
   label: "Salgareda (ITSGR)"
  },
  {
   value: "Salina (ITSLA)",
   label: "Salina (ITSLA)"
  },
  {
   value: "Salo (ITSLO)",
   label: "Salo (ITSLO)"
  },
  {
   value: "Salussola (ITSLU)",
   label: "Salussola (ITSLU)"
  },
  {
   value: "Salvaterra (ITELV)",
   label: "Salvaterra (ITELV)"
  },
  {
   value: "Sambuca di Pesa (ITSBC)",
   label: "Sambuca di Pesa (ITSBC)"
  },
  {
   value: "Sambuceto (ITSAM)",
   label: "Sambuceto (ITSAM)"
  },
  {
   value: "San Agata Irpina (ITSAI)",
   label: "San Agata Irpina (ITSAI)"
  },
  {
   value: "San Albano Stura (ITSAS)",
   label: "San Albano Stura (ITSAS)"
  },
  {
   value: "San Benedetto del Tronto (ITSDB)",
   label: "San Benedetto del Tronto (ITSDB)"
  },
  {
   value: "San Bonifacio (ITSBF)",
   label: "San Bonifacio (ITSBF)"
  },
  {
   value: "San Candido (ITSCD)",
   label: "San Candido (ITSCD)"
  },
  {
   value: "San Casciano di Pesa (ITSCP)",
   label: "San Casciano di Pesa (ITSCP)"
  },
  {
   value: "San Clemente (ITSCM)",
   label: "San Clemente (ITSCM)"
  },
  {
   value: "San Dona di Piave (ITSDP)",
   label: "San Dona di Piave (ITSDP)"
  },
  {
   value: "San Donato (ITSDT)",
   label: "San Donato (ITSDT)"
  },
  {
   value: "San Felice sul Panaro (ITSFP)",
   label: "San Felice sul Panaro (ITSFP)"
  },
  {
   value: "San Fior (ITSFR)",
   label: "San Fior (ITSFR)"
  },
  {
   value: "San Flice (ITSCE)",
   label: "San Flice (ITSCE)"
  },
  {
   value: "San Giorgio a Liri (ITSIL)",
   label: "San Giorgio a Liri (ITSIL)"
  },
  {
   value: "San Giorgio di Nogaro (ITSGD)",
   label: "San Giorgio di Nogaro (ITSGD)"
  },
  {
   value: "San Giorgio di Piano (ITSGP)",
   label: "San Giorgio di Piano (ITSGP)"
  },
  {
   value: "San Giorgio do Nogara (ITSGG)",
   label: "San Giorgio do Nogara (ITSGG)"
  },
  {
   value: "San Giovanni al Natisone (ITSGN)",
   label: "San Giovanni al Natisone (ITSGN)"
  },
  {
   value: "Radda in chianti (ITRIC)",
   label: "Radda in chianti (ITRIC)"
  },
  {
   value: "Ragusa (ITRGA)",
   label: "Ragusa (ITRGA)"
  },
  {
   value: "Rapalano terme (ITRLT)",
   label: "Rapalano terme (ITRLT)"
  },
  {
   value: "Ravenna (ITRAN)",
   label: "Ravenna (ITRAN)"
  },
  {
   value: "Recanati (ITRNT)",
   label: "Recanati (ITRNT)"
  },
  {
   value: "Refrontolo (ITRFC)",
   label: "Refrontolo (ITRFC)"
  },
  {
   value: "Reggio Calabria (ITREG)",
   label: "Reggio Calabria (ITREG)"
  },
  {
   value: "Reggio Nell Emilia (ITRNE)",
   label: "Reggio Nell Emilia (ITRNE)"
  },
  {
   value: "Reggiolo (ITRGO)",
   label: "Reggiolo (ITRGO)"
  },
  {
   value: "Resana (ITRSA)",
   label: "Resana (ITRSA)"
  },
  {
   value: "Rescaldina (ITRSC)",
   label: "Rescaldina (ITRSC)"
  },
  {
   value: "Ressato (ITRST)",
   label: "Ressato (ITRST)"
  },
  {
   value: "Revere (ITRVR)",
   label: "Revere (ITRVR)"
  },
  {
   value: "Rho (ITRHO)",
   label: "Rho (ITRHO)"
  },
  {
   value: "Riese pio Decimo (ITRPD)",
   label: "Riese pio Decimo (ITRPD)"
  },
  {
   value: "Rieti (ITRTI)",
   label: "Rieti (ITRTI)"
  },
  {
   value: "Rimini (ITRMI)",
   label: "Rimini (ITRMI)"
  },
  {
   value: "Rio Marina (ITRMA)",
   label: "Rio Marina (ITRMA)"
  },
  {
   value: "Rio Saliceto (ITRSL)",
   label: "Rio Saliceto (ITRSL)"
  },
  {
   value: "Ripaberarda (ITRPB)",
   label: "Ripaberarda (ITRPB)"
  },
  {
   value: "Riposto (ITRPT)",
   label: "Riposto (ITRPT)"
  },
  {
   value: "Riva del Garda (ITRDG)",
   label: "Riva del Garda (ITRDG)"
  },
  {
   value: "Rivalta Scrivia (ITRIV)",
   label: "Rivalta Scrivia (ITRIV)"
  },
  {
   value: "Rivarolo Canavese (ITRVV)",
   label: "Rivarolo Canavese (ITRVV)"
  },
  {
   value: "Rivarolo Del Re (ITRDR)",
   label: "Rivarolo Del Re (ITRDR)"
  },
  {
   value: "Rivoli (ITRVL)",
   label: "Rivoli (ITRVL)"
  },
  {
   value: "Rivoli Veronese (ITRIO)",
   label: "Rivoli Veronese (ITRIO)"
  },
  {
   value: "Robassomero (ITRBS)",
   label: "Robassomero (ITRBS)"
  },
  {
   value: "Robecco (ITRBC)",
   label: "Robecco (ITRBC)"
  },
  {
   value: "Rocca Pietore (ITRQI)",
   label: "Rocca Pietore (ITRQI)"
  },
  {
   value: "Rocca San Casciano (ITRQS)",
   label: "Rocca San Casciano (ITRQS)"
  },
  {
   value: "Rocoaro Terme (ITRRT)",
   label: "Rocoaro Terme (ITRRT)"
  },
  {
   value: "Rodi Garganico (ITRGG)",
   label: "Rodi Garganico (ITRGG)"
  },
  {
   value: "Rogeno (ITREN)",
   label: "Rogeno (ITREN)"
  },
  {
   value: "Rogno (ITRGN)",
   label: "Rogno (ITRGN)"
  },
  {
   value: "\"Rogoredo (ITROG)",
   label: "\"Rogoredo (ITROG)"
  },
  {
   value: "Roma (ITROM)",
   label: "Roma (ITROM)"
  },
  {
   value: "Romans D'isonzo (ITRDS)",
   label: "Romans D'isonzo (ITRDS)"
  },
  {
   value: "Romas D'isanzo (ITRDZ)",
   label: "Romas D'isanzo (ITRDZ)"
  },
  {
   value: "Porto Empedocle (ITPEM)",
   label: "Porto Empedocle (ITPEM)"
  },
  {
   value: "Porto Foxi (Sarroch) (ITPFX)",
   label: "Porto Foxi (Sarroch) (ITPFX)"
  },
  {
   value: "Porto Garibaldi (ITPGA)",
   label: "Porto Garibaldi (ITPGA)"
  },
  {
   value: "Porto Gruaro (ITPGR)",
   label: "Porto Gruaro (ITPGR)"
  },
  {
   value: "Porto Lignano (ITPLI)",
   label: "Porto Lignano (ITPLI)"
  },
  {
   value: "Porto Marghera (ITPMA)",
   label: "Porto Marghera (ITPMA)"
  },
  {
   value: "Porto Maurizio (ITPMZ)",
   label: "Porto Maurizio (ITPMZ)"
  },
  {
   value: "Porto Nogaro (ITPNG)",
   label: "Porto Nogaro (ITPNG)"
  },
  {
   value: "Porto Santo Stefano (ITPSS)",
   label: "Porto Santo Stefano (ITPSS)"
  },
  {
   value: "Porto Torres (ITPTO)",
   label: "Porto Torres (ITPTO)"
  },
  {
   value: "Porto Vesme (Portoscuso) (ITPVE)",
   label: "Porto Vesme (Portoscuso) (ITPVE)"
  },
  {
   value: "Portoferraio (ITPFE)",
   label: "Portoferraio (ITPFE)"
  },
  {
   value: "Portofino (ITPTF)",
   label: "Portofino (ITPTF)"
  },
  {
   value: "Positano (ITPOS)",
   label: "Positano (ITPOS)"
  },
  {
   value: "Potenza Picena (ITPTP)",
   label: "Potenza Picena (ITPTP)"
  },
  {
   value: "Pove del Grappa (ITPDG)",
   label: "Pove del Grappa (ITPDG)"
  },
  {
   value: "Poviglio (ITPVI)",
   label: "Poviglio (ITPVI)"
  },
  {
   value: "Pozzallo (ITPZL)",
   label: "Pozzallo (ITPZL)"
  },
  {
   value: "Pozzolo Formigaro (ITPZF)",
   label: "Pozzolo Formigaro (ITPZF)"
  },
  {
   value: "Pozzuoli (ITPOZ)",
   label: "Pozzuoli (ITPOZ)"
  },
  {
   value: "Prati (ITPKF)",
   label: "Prati (ITPKF)"
  },
  {
   value: "Prato (ITOTA)",
   label: "Prato (ITOTA)"
  },
  {
   value: "Pratovecchio (ITPVC)",
   label: "Pratovecchio (ITPVC)"
  },
  {
   value: "Pratrivero (ITPRA)",
   label: "Pratrivero (ITPRA)"
  },
  {
   value: "Pray Biellese (ITPRB)",
   label: "Pray Biellese (ITPRB)"
  },
  {
   value: "Predazzo (ITPRZ)",
   label: "Predazzo (ITPRZ)"
  },
  {
   value: "Pregnana Milanese (ITPRM)",
   label: "Pregnana Milanese (ITPRM)"
  },
  {
   value: "Premariacco (ITPMC)",
   label: "Premariacco (ITPMC)"
  },
  {
   value: "Pressuro (ITPRE)",
   label: "Pressuro (ITPRE)"
  },
  {
   value: "Prevalle (ITPVA)",
   label: "Prevalle (ITPVA)"
  },
  {
   value: "Priolo (ITPRI)",
   label: "Priolo (ITPRI)"
  },
  {
   value: "Priolo Gargallo (ITPRL)",
   label: "Priolo Gargallo (ITPRL)"
  },
  {
   value: "Procida (ITPRO)",
   label: "Procida (ITPRO)"
  },
  {
   value: "Quarto (ITQTO)",
   label: "Quarto (ITQTO)"
  },
  {
   value: "Querceta (ITQRC)",
   label: "Querceta (ITQRC)"
  },
  {
   value: "Quinto Di Treviso (ITQTD)",
   label: "Quinto Di Treviso (ITQTD)"
  },
  {
   value: "Quinzano D'oglio (ITQNZ)",
   label: "Quinzano D'oglio (ITQNZ)"
  },
  {
   value: "Racconigi (ITRAC)",
   label: "Racconigi (ITRAC)"
  },
  {
   value: "Pieve Sestina Cesena (ITPSC)",
   label: "Pieve Sestina Cesena (ITPSC)"
  },
  {
   value: "Pinerolo (ITPIL)",
   label: "Pinerolo (ITPIL)"
  },
  {
   value: "Pioltello (ITPLO)",
   label: "Pioltello (ITPLO)"
  },
  {
   value: "Piombino (ITPIO)",
   label: "Piombino (ITPIO)"
  },
  {
   value: "Pisa (ITPSA)",
   label: "Pisa (ITPSA)"
  },
  {
   value: "Pistoia (ITPIS)",
   label: "Pistoia (ITPIS)"
  },
  {
   value: "Podenzano (ITPOD)",
   label: "Podenzano (ITPOD)"
  },
  {
   value: "Poggibonsi (ITPGG)",
   label: "Poggibonsi (ITPGG)"
  },
  {
   value: "Poke (ITPOK)",
   label: "Poke (ITPOK)"
  },
  {
   value: "Polesine (ITPLS)",
   label: "Polesine (ITPLS)"
  },
  {
   value: "Policastro Bussentino (ITPLB)",
   label: "Policastro Bussentino (ITPLB)"
  },
  {
   value: "Pomezia (ITPOM)",
   label: "Pomezia (ITPOM)"
  },
  {
   value: "Pontassieve (ITPON)",
   label: "Pontassieve (ITPON)"
  },
  {
   value: "Ponte A Egola (ITPAE)",
   label: "Ponte A Egola (ITPAE)"
  },
  {
   value: "Ponte a Moriano (ITPAM)",
   label: "Ponte a Moriano (ITPAM)"
  },
  {
   value: "Ponte Buggianese (ITPGQ)",
   label: "Ponte Buggianese (ITPGQ)"
  },
  {
   value: "Ponte dell'Olio (ITPDL)",
   label: "Ponte dell'Olio (ITPDL)"
  },
  {
   value: "Ponte Fornaci (ITPFO)",
   label: "Ponte Fornaci (ITPFO)"
  },
  {
   value: "Ponte Nova (ITPNO)",
   label: "Ponte Nova (ITPNO)"
  },
  {
   value: "Ponte s Pietro (ITPSP)",
   label: "Ponte s Pietro (ITPSP)"
  },
  {
   value: "Pontecchio (ITPCC)",
   label: "Pontecchio (ITPCC)"
  },
  {
   value: "Pontecchio Marconi (ITPNT)",
   label: "Pontecchio Marconi (ITPNT)"
  },
  {
   value: "Pontedassio (ITPOO)",
   label: "Pontedassio (ITPOO)"
  },
  {
   value: "Pontedecimo (ITPTD)",
   label: "Pontedecimo (ITPTD)"
  },
  {
   value: "Pontinia (ITPTA)",
   label: "Pontinia (ITPTA)"
  },
  {
   value: "Pontruolo Nuovo (ITPNU)",
   label: "Pontruolo Nuovo (ITPNU)"
  },
  {
   value: "Ponza (ITPNZ)",
   label: "Ponza (ITPNZ)"
  },
  {
   value: "\"Ponzano (ITPZO)",
   label: "\"Ponzano (ITPZO)"
  },
  {
   value: "Ponzone (ITPZE)",
   label: "Ponzone (ITPZE)"
  },
  {
   value: "Porcari (ITPOC)",
   label: "Porcari (ITPOC)"
  },
  {
   value: "Pordenone (ITPRD)",
   label: "Pordenone (ITPRD)"
  },
  {
   value: "Porrena (ITPRN)",
   label: "Porrena (ITPRN)"
  },
  {
   value: "Porretta Terme (ITPRT)",
   label: "Porretta Terme (ITPRT)"
  },
  {
   value: "Portici (ITPTC)",
   label: "Portici (ITPTC)"
  },
  {
   value: "Portiglioni (ITPGL)",
   label: "Portiglioni (ITPGL)"
  },
  {
   value: "Porto Azzurro (ITPAZ)",
   label: "Porto Azzurro (ITPAZ)"
  },
  {
   value: "Porto Cervo (ITPCE)",
   label: "Porto Cervo (ITPCE)"
  },
  {
   value: "Porto Corsini (ITPCS)",
   label: "Porto Corsini (ITPCS)"
  },
  {
   value: "Porto d'Ischia (ITPDI)",
   label: "Porto d'Ischia (ITPDI)"
  },
  {
   value: "Padova (ITPDA)",
   label: "Padova (ITPDA)"
  },
  {
   value: "Palau (ITPAU)",
   label: "Palau (ITPAU)"
  },
  {
   value: "Palazzola Milanese (ITPLM)",
   label: "Palazzola Milanese (ITPLM)"
  },
  {
   value: "Palazzolo sull'Oglio (ITPSO)",
   label: "Palazzolo sull'Oglio (ITPSO)"
  },
  {
   value: "Palermo (ITPMO)",
   label: "Palermo (ITPMO)"
  },
  {
   value: "Pallanza (ITPZA)",
   label: "Pallanza (ITPZA)"
  },
  {
   value: "Paluzzola D' Stella (ITPAL)",
   label: "Paluzzola D' Stella (ITPAL)"
  },
  {
   value: "Panarea (ITPAN)",
   label: "Panarea (ITPAN)"
  },
  {
   value: "Pandino (ITPDO)",
   label: "Pandino (ITPDO)"
  },
  {
   value: "Pantelleria (ITPNL)",
   label: "Pantelleria (ITPNL)"
  },
  {
   value: "Panzano (ITPXZ)",
   label: "Panzano (ITPXZ)"
  },
  {
   value: "Parabiago (ITPRG)",
   label: "Parabiago (ITPRG)"
  },
  {
   value: "Paranto (ITPAT)",
   label: "Paranto (ITPAT)"
  },
  {
   value: "Parma (ITPMF)",
   label: "Parma (ITPMF)"
  },
  {
   value: "Pastrengo (ITPST)",
   label: "Pastrengo (ITPST)"
  },
  {
   value: "Paterno (ITPTR)",
   label: "Paterno (ITPTR)"
  },
  {
   value: "Patti (ITPTI)",
   label: "Patti (ITPTI)"
  },
  {
   value: "Pavia (ITPAV)",
   label: "Pavia (ITPAV)"
  },
  {
   value: "Pavullo (ITPVO)",
   label: "Pavullo (ITPVO)"
  },
  {
   value: "Percato (ITPRC)",
   label: "Percato (ITPRC)"
  },
  {
   value: "Percoto (ITPCO)",
   label: "Percoto (ITPCO)"
  },
  {
   value: "Pergine (ITPGI)",
   label: "Pergine (ITPGI)"
  },
  {
   value: "Persico (ITPRS)",
   label: "Persico (ITPRS)"
  },
  {
   value: "Perugia (ITPEG)",
   label: "Perugia (ITPEG)"
  },
  {
   value: "Pesaro (ITPES)",
   label: "Pesaro (ITPES)"
  },
  {
   value: "Pescara (ITPSR)",
   label: "Pescara (ITPSR)"
  },
  {
   value: "Peschici (ITPCH)",
   label: "Peschici (ITPCH)"
  },
  {
   value: "Peschiera Borromeo (ITPSB)",
   label: "Peschiera Borromeo (ITPSB)"
  },
  {
   value: "Peschiera del Garda (ITPLU)",
   label: "Peschiera del Garda (ITPLU)"
  },
  {
   value: "Pessano con Bornago (ITPCB)",
   label: "Pessano con Bornago (ITPCB)"
  },
  {
   value: "Pessione (ITPSN)",
   label: "Pessione (ITPSN)"
  },
  {
   value: "Pettinengo (ITPET)",
   label: "Pettinengo (ITPET)"
  },
  {
   value: "Piacenza (ITPCZ)",
   label: "Piacenza (ITPCZ)"
  },
  {
   value: "Pianella (ITPIN)",
   label: "Pianella (ITPIN)"
  },
  {
   value: "Pianosa (ITPIA)",
   label: "Pianosa (ITPIA)"
  },
  {
   value: "Piantedo (ITPIT)",
   label: "Piantedo (ITPIT)"
  },
  {
   value: "Piazza Brembana (ITPZB)",
   label: "Piazza Brembana (ITPZB)"
  },
  {
   value: "Pietrasanta (ITPIE)",
   label: "Pietrasanta (ITPIE)"
  },
  {
   value: "Pieve di Soligo (ITPVD)",
   label: "Pieve di Soligo (ITPVD)"
  },
  {
   value: "Pieve di Cenio (ITPDC)",
   label: "Pieve di Cenio (ITPDC)"
  },
  {
   value: "Novate Milanese (ITNML)",
   label: "Novate Milanese (ITNML)"
  },
  {
   value: "Nove (ITNOE)",
   label: "Nove (ITNOE)"
  },
  {
   value: "Novedrate (ITNVT)",
   label: "Novedrate (ITNVT)"
  },
  {
   value: "Novello (ITZMD)",
   label: "Novello (ITZMD)"
  },
  {
   value: "Nuova Olonio (ITNVO)",
   label: "Nuova Olonio (ITNVO)"
  },
  {
   value: "Nuvolento (ITNVE)",
   label: "Nuvolento (ITNVE)"
  },
  {
   value: "Nuvolera (ITNVL)",
   label: "Nuvolera (ITNVL)"
  },
  {
   value: "Occhieppo Inferiore (ITOCI)",
   label: "Occhieppo Inferiore (ITOCI)"
  },
  {
   value: "Occhiobello (ITOHB)",
   label: "Occhiobello (ITOHB)"
  },
  {
   value: "Occimiano (ITOCO)",
   label: "Occimiano (ITOCO)"
  },
  {
   value: "Oderzo (ITODZ)",
   label: "Oderzo (ITODZ)"
  },
  {
   value: "Odolo (ITODL)",
   label: "Odolo (ITODL)"
  },
  {
   value: "Offa Eango (ITOEO)",
   label: "Offa Eango (ITOEO)"
  },
  {
   value: "Oggiono (ITOGG)",
   label: "Oggiono (ITOGG)"
  },
  {
   value: "Olbia (Terranova) (ITOLB)",
   label: "Olbia (Terranova) (ITOLB)"
  },
  {
   value: "Oleggio (ITOLE)",
   label: "Oleggio (ITOLE)"
  },
  {
   value: "Olginate (ITOLG)",
   label: "Olginate (ITOLG)"
  },
  {
   value: "Olona (ITOLO)",
   label: "Olona (ITOLO)"
  },
  {
   value: "Oneglia (ITONE)",
   label: "Oneglia (ITONE)"
  },
  {
   value: "Ora (ITORA)",
   label: "Ora (ITORA)"
  },
  {
   value: "Orbassano (ITOBS)",
   label: "Orbassano (ITOBS)"
  },
  {
   value: "Orio Al Serio (ITBGY)",
   label: "Orio Al Serio (ITBGY)"
  },
  {
   value: "Orio Litta (Milano) (ITORI)",
   label: "Orio Litta (Milano) (ITORI)"
  },
  {
   value: "Oristano (ITQOS)",
   label: "Oristano (ITQOS)"
  },
  {
   value: "Orsago (ITOSG)",
   label: "Orsago (ITOSG)"
  },
  {
   value: "Orta Nova (ITORT)",
   label: "Orta Nova (ITORT)"
  },
  {
   value: "Ortona (ITOTN)",
   label: "Ortona (ITOTN)"
  },
  {
   value: "Osimo (ITOSM)",
   label: "Osimo (ITOSM)"
  },
  {
   value: "Osio Di Sopra (ITOSI)",
   label: "Osio Di Sopra (ITOSI)"
  },
  {
   value: "Osmannoro (ITONN)",
   label: "Osmannoro (ITONN)"
  },
  {
   value: "Ospedaletti (ITOPD)",
   label: "Ospedaletti (ITOPD)"
  },
  {
   value: "Ospitaletto (ITOSP)",
   label: "Ospitaletto (ITOSP)"
  },
  {
   value: "Oste-Montemurlo (ITOMM)",
   label: "Oste-Montemurlo (ITOMM)"
  },
  {
   value: "Otranto (ITOTO)",
   label: "Otranto (ITOTO)"
  },
  {
   value: "Ottan Nuovo (ITONO)",
   label: "Ottan Nuovo (ITONO)"
  },
  {
   value: "Ovada (ITOVD)",
   label: "Ovada (ITOVD)"
  },
  {
   value: "Ozzano dell Emilia (ITOZE)",
   label: "Ozzano dell Emilia (ITOZE)"
  },
  {
   value: "Pachino (ITPAC)",
   label: "Pachino (ITPAC)"
  },
  {
   value: "Paderno Dugnano (ITPDD)",
   label: "Paderno Dugnano (ITPDD)"
  },
  {
   value: "Paderno Poncheilli (ITPAP)",
   label: "Paderno Poncheilli (ITPAP)"
  },
  {
   value: "Monte Porzio (ITMOP)",
   label: "Monte Porzio (ITMOP)"
  },
  {
   value: "Monte San Pietro (ITMSP)",
   label: "Monte San Pietro (ITMSP)"
  },
  {
   value: "Monte san Savino (ITMTE)",
   label: "Monte san Savino (ITMTE)"
  },
  {
   value: "Montebelluna (ITMOA)",
   label: "Montebelluna (ITMOA)"
  },
  {
   value: "Montecchio Maggiore (ITMMG)",
   label: "Montecchio Maggiore (ITMMG)"
  },
  {
   value: "Montegiorgio (ITMTG)",
   label: "Montegiorgio (ITMTG)"
  },
  {
   value: "Montelabbate (ITMNB)",
   label: "Montelabbate (ITMNB)"
  },
  {
   value: "Montelupo Albese (ITMOK)",
   label: "Montelupo Albese (ITMOK)"
  },
  {
   value: "Montemarano1 (ITMOM)",
   label: "Montemarano1 (ITMOM)"
  },
  {
   value: "Montemurlo (ITMOO)",
   label: "Montemurlo (ITMOO)"
  },
  {
   value: "Monteriggioni (ITMIG)",
   label: "Monteriggioni (ITMIG)"
  },
  {
   value: "Monteveglio (ITMPT)",
   label: "Monteveglio (ITMPT)"
  },
  {
   value: "Montichiari (ITMCH)",
   label: "Montichiari (ITMCH)"
  },
  {
   value: "Montirone (ITMRO)",
   label: "Montirone (ITMRO)"
  },
  {
   value: "Monza (ITMZA)",
   label: "Monza (ITMZA)"
  },
  {
   value: "Morano Calabro (ITMOC)",
   label: "Morano Calabro (ITMOC)"
  },
  {
   value: "Morciano di Romagna (ITMDR)",
   label: "Morciano di Romagna (ITMDR)"
  },
  {
   value: "Mordano (ITMOR)",
   label: "Mordano (ITMOR)"
  },
  {
   value: "Morolo (ITMOS)",
   label: "Morolo (ITMOS)"
  },
  {
   value: "Mortara (ITMTA)",
   label: "Mortara (ITMTA)"
  },
  {
   value: "Motta di Livenza (ITMTL)",
   label: "Motta di Livenza (ITMTL)"
  },
  {
   value: "Mozzanica (ITMOZ)",
   label: "Mozzanica (ITMOZ)"
  },
  {
   value: "Mozzecane (ITMZZ)",
   label: "Mozzecane (ITMZZ)"
  },
  {
   value: "Mugnani Di Napoli (ITMUG)",
   label: "Mugnani Di Napoli (ITMUG)"
  },
  {
   value: "Mussolente (ITMUS)",
   label: "Mussolente (ITMUS)"
  },
  {
   value: "Nagora (ITNAG)",
   label: "Nagora (ITNAG)"
  },
  {
   value: "Napoli (ITNAP)",
   label: "Napoli (ITNAP)"
  },
  {
   value: "Negrar (ITNGR)",
   label: "Negrar (ITNGR)"
  },
  {
   value: "Nera (ITNRA)",
   label: "Nera (ITNRA)"
  },
  {
   value: "Nerviano (ITNER)",
   label: "Nerviano (ITNER)"
  },
  {
   value: "Nichelino (ITNLO)",
   label: "Nichelino (ITNLO)"
  },
  {
   value: "Nigoline Bonomelli (ITNDL)",
   label: "Nigoline Bonomelli (ITNDL)"
  },
  {
   value: "Niscemi (ITNSC)",
   label: "Niscemi (ITNSC)"
  },
  {
   value: "Nocera (ITNOC)",
   label: "Nocera (ITNOC)"
  },
  {
   value: "Nogara (ITNOR)",
   label: "Nogara (ITNOR)"
  },
  {
   value: "Nogarole Rocca (ITNRC)",
   label: "Nogarole Rocca (ITNRC)"
  },
  {
   value: "Nonantola (ITNON)",
   label: "Nonantola (ITNON)"
  },
  {
   value: "Novara (ITNVR)",
   label: "Novara (ITNVR)"
  },
  {
   value: "Novate Mezzola (ITNVM)",
   label: "Novate Mezzola (ITNVM)"
  },
  {
   value: "Matera (ITMTR)",
   label: "Matera (ITMTR)"
  },
  {
   value: "Mazara del Vallo (ITMAZ)",
   label: "Mazara del Vallo (ITMAZ)"
  },
  {
   value: "Meda (ITMED)",
   label: "Meda (ITMED)"
  },
  {
   value: "Meduno (ITMDO)",
   label: "Meduno (ITMDO)"
  },
  {
   value: "Melilli (ITMEL)",
   label: "Melilli (ITMEL)"
  },
  {
   value: "Melzo (ITMZO)",
   label: "Melzo (ITMZO)"
  },
  {
   value: "Meolo (ITMEO)",
   label: "Meolo (ITMEO)"
  },
  {
   value: "Mercato san Severino (ITMCS)",
   label: "Mercato san Severino (ITMCS)"
  },
  {
   value: "Merone (ITMER)",
   label: "Merone (ITMER)"
  },
  {
   value: "Mesagne (ITMES)",
   label: "Mesagne (ITMES)"
  },
  {
   value: "Messina (ITMSN)",
   label: "Messina (ITMSN)"
  },
  {
   value: "Mezzocorona (ITMCR)",
   label: "Mezzocorona (ITMCR)"
  },
  {
   value: "Mezzolombardo (ITMEZ)",
   label: "Mezzolombardo (ITMEZ)"
  },
  {
   value: "Mignagola (ITMIN)",
   label: "Mignagola (ITMIN)"
  },
  {
   value: "Mignagola di Carbonera (ITMNG)",
   label: "Mignagola di Carbonera (ITMNG)"
  },
  {
   value: "Milano (ITMIL)",
   label: "Milano (ITMIL)"
  },
  {
   value: "Milazzo (ITMLZ)",
   label: "Milazzo (ITMLZ)"
  },
  {
   value: "Millesimo (ITMSO)",
   label: "Millesimo (ITMSO)"
  },
  {
   value: "Minerbio (ITMNR)",
   label: "Minerbio (ITMNR)"
  },
  {
   value: "Mira (ITMIA)",
   label: "Mira (ITMIA)"
  },
  {
   value: "Mirandola (ITMID)",
   label: "Mirandola (ITMID)"
  },
  {
   value: "Mirano (ITMIR)",
   label: "Mirano (ITMIR)"
  },
  {
   value: "Modena (ITMOD)",
   label: "Modena (ITMOD)"
  },
  {
   value: "Modigliana (ITMDG)",
   label: "Modigliana (ITMDG)"
  },
  {
   value: "Moimacco (ITMOI)",
   label: "Moimacco (ITMOI)"
  },
  {
   value: "Molfetta (ITMOL)",
   label: "Molfetta (ITMOL)"
  },
  {
   value: "Molinella (ITMLA)",
   label: "Molinella (ITMLA)"
  },
  {
   value: "Molinetto-Ciliverghe (ITMCI)",
   label: "Molinetto-Ciliverghe (ITMCI)"
  },
  {
   value: "Mollicciara (ITMJC)",
   label: "Mollicciara (ITMJC)"
  },
  {
   value: "Molteno (ITMTO)",
   label: "Molteno (ITMTO)"
  },
  {
   value: "Moncalieri (ITMON)",
   label: "Moncalieri (ITMON)"
  },
  {
   value: "Mondovi (ITMVI)",
   label: "Mondovi (ITMVI)"
  },
  {
   value: "Monfalcone (ITMNF)",
   label: "Monfalcone (ITMNF)"
  },
  {
   value: "Monopoli (ITMNP)",
   label: "Monopoli (ITMNP)"
  },
  {
   value: "Monsano (ITMNO)",
   label: "Monsano (ITMNO)"
  },
  {
   value: "Monselice (ITMOE)",
   label: "Monselice (ITMOE)"
  },
  {
   value: "Monsummano Terme (ITMOT)",
   label: "Monsummano Terme (ITMOT)"
  },
  {
   value: "Montalcino (ITMLC)",
   label: "Montalcino (ITMLC)"
  },
  {
   value: "Montale (ITMNT)",
   label: "Montale (ITMNT)"
  },
  {
   value: "Montale Rangone (ITMRE)",
   label: "Montale Rangone (ITMRE)"
  },
  {
   value: "Luino (ITLUI)",
   label: "Luino (ITLUI)"
  },
  {
   value: "Lunata (ITLKT)",
   label: "Lunata (ITLKT)"
  },
  {
   value: "Luttach (ITLTH)",
   label: "Luttach (ITLTH)"
  },
  {
   value: "Macerata (ITMCA)",
   label: "Macerata (ITMCA)"
  },
  {
   value: "Macherio (ITMAC)",
   label: "Macherio (ITMAC)"
  },
  {
   value: "Maddalena (ITMDA)",
   label: "Maddalena (ITMDA)"
  },
  {
   value: "Madigano (ITMAD)",
   label: "Madigano (ITMAD)"
  },
  {
   value: "Maerne (ITMAE)",
   label: "Maerne (ITMAE)"
  },
  {
   value: "Magenta (ITMGA)",
   label: "Magenta (ITMGA)"
  },
  {
   value: "Maggiore (ITMGG)",
   label: "Maggiore (ITMGG)"
  },
  {
   value: "Maghisi (ITMAG)",
   label: "Maghisi (ITMAG)"
  },
  {
   value: "Magnisi (ITMGN)",
   label: "Magnisi (ITMGN)"
  },
  {
   value: "Mairano (ITMAI)",
   label: "Mairano (ITMAI)"
  },
  {
   value: "Malgesso (ITMAL)",
   label: "Malgesso (ITMAL)"
  },
  {
   value: "Malnate (ITMAT)",
   label: "Malnate (ITMAT)"
  },
  {
   value: "Malo (ITMLO)",
   label: "Malo (ITMLO)"
  },
  {
   value: "Malpensa Apt\/Milano (ITMXP)",
   label: "Malpensa Apt\/Milano (ITMXP)"
  },
  {
   value: "Mandrio di Correggio (ITMNC)",
   label: "Mandrio di Correggio (ITMNC)"
  },
  {
   value: "Manerbio (ITMRB)",
   label: "Manerbio (ITMRB)"
  },
  {
   value: "Manfredonia (ITMFR)",
   label: "Manfredonia (ITMFR)"
  },
  {
   value: "Mantova (ITMAN)",
   label: "Mantova (ITMAN)"
  },
  {
   value: "Manzano (ITMNZ)",
   label: "Manzano (ITMNZ)"
  },
  {
   value: "Mappano (ITMPP)",
   label: "Mappano (ITMPP)"
  },
  {
   value: "Maranello (ITMAR)",
   label: "Maranello (ITMAR)"
  },
  {
   value: "Marano Ticino (ITMTC)",
   label: "Marano Ticino (ITMTC)"
  },
  {
   value: "Marano Vicentino (ITMRV)",
   label: "Marano Vicentino (ITMRV)"
  },
  {
   value: "Marettimo (ITMMO)",
   label: "Marettimo (ITMMO)"
  },
  {
   value: "Marghera (ITMAA)",
   label: "Marghera (ITMAA)"
  },
  {
   value: "Mariano Comense (ITMCE)",
   label: "Mariano Comense (ITMCE)"
  },
  {
   value: "Marina di Carrara (ITMDC)",
   label: "Marina di Carrara (ITMDC)"
  },
  {
   value: "Marnello (ITMRN)",
   label: "Marnello (ITMRN)"
  },
  {
   value: "Marsaiu (ITMAU)",
   label: "Marsaiu (ITMAU)"
  },
  {
   value: "Marsala (ITMRA)",
   label: "Marsala (ITMRA)"
  },
  {
   value: "Marsciano (ITMRS)",
   label: "Marsciano (ITMRS)"
  },
  {
   value: "Martinsicuro (ITMTS)",
   label: "Martinsicuro (ITMTS)"
  },
  {
   value: "Maslianico (ITMLN)",
   label: "Maslianico (ITMLN)"
  },
  {
   value: "Massa (ITMSA)",
   label: "Massa (ITMSA)"
  },
  {
   value: "Massa Fiscaglia (ITMAF)",
   label: "Massa Fiscaglia (ITMAF)"
  },
  {
   value: "Massa Lombarda (ITMSL)",
   label: "Massa Lombarda (ITMSL)"
  },
  {
   value: "Massarosa (ITMSS)",
   label: "Massarosa (ITMSS)"
  },
  {
   value: "Lanciole Di Pitelio (ITLAN)",
   label: "Lanciole Di Pitelio (ITLAN)"
  },
  {
   value: "Landriano (ITLDO)",
   label: "Landriano (ITLDO)"
  },
  {
   value: "Larciano (ITLRC)",
   label: "Larciano (ITLRC)"
  },
  {
   value: "Larderello (ITLAR)",
   label: "Larderello (ITLAR)"
  },
  {
   value: "Lariano (ITLNO)",
   label: "Lariano (ITLNO)"
  },
  {
   value: "Lastra (ITLTA)",
   label: "Lastra (ITLTA)"
  },
  {
   value: "Lastra a Signa (ITLJB)",
   label: "Lastra a Signa (ITLJB)"
  },
  {
   value: "Laterina (ITLAA)",
   label: "Laterina (ITLAA)"
  },
  {
   value: "Latina (ITLTN)",
   label: "Latina (ITLTN)"
  },
  {
   value: "Latisana (ITLSN)",
   label: "Latisana (ITLSN)"
  },
  {
   value: "Laveno (ITVOE)",
   label: "Laveno (ITVOE)"
  },
  {
   value: "Lecce (ITLCC)",
   label: "Lecce (ITLCC)"
  },
  {
   value: "Lecco (ITLCO)",
   label: "Lecco (ITLCO)"
  },
  {
   value: "Legnano (ITLGN)",
   label: "Legnano (ITLGN)"
  },
  {
   value: "Legnara (ITLGR)",
   label: "Legnara (ITLGR)"
  },
  {
   value: "Leini (ITLEI)",
   label: "Leini (ITLEI)"
  },
  {
   value: "Lello (ITLEL)",
   label: "Lello (ITLEL)"
  },
  {
   value: "Lentini (ITENT)",
   label: "Lentini (ITENT)"
  },
  {
   value: "Lesse (ITLES)",
   label: "Lesse (ITLES)"
  },
  {
   value: "Levanzo (ITLEV)",
   label: "Levanzo (ITLEV)"
  },
  {
   value: "Licata (ITLIC)",
   label: "Licata (ITLIC)"
  },
  {
   value: "Limbiate (ITLMB)",
   label: "Limbiate (ITLMB)"
  },
  {
   value: "Limena (ITLMA)",
   label: "Limena (ITLMA)"
  },
  {
   value: "Limite sull'Arno (ITLSA)",
   label: "Limite sull'Arno (ITLSA)"
  },
  {
   value: "Limito (ITLIM)",
   label: "Limito (ITLIM)"
  },
  {
   value: "Linate Apt\/Milano (ITLIN)",
   label: "Linate Apt\/Milano (ITLIN)"
  },
  {
   value: "Linosa (ITLIU)",
   label: "Linosa (ITLIU)"
  },
  {
   value: "Lipari (ITLIP)",
   label: "Lipari (ITLIP)"
  },
  {
   value: "Liscate (ITLIS)",
   label: "Liscate (ITLIS)"
  },
  {
   value: "Lisiko (ITLSK)",
   label: "Lisiko (ITLSK)"
  },
  {
   value: "Lissone (ITLSO)",
   label: "Lissone (ITLSO)"
  },
  {
   value: "Livorno (ITLIV)",
   label: "Livorno (ITLIV)"
  },
  {
   value: "Lodi (ITLDI)",
   label: "Lodi (ITLDI)"
  },
  {
   value: "Loiano (ITLIA)",
   label: "Loiano (ITLIA)"
  },
  {
   value: "Lombardore (ITLBD)",
   label: "Lombardore (ITLBD)"
  },
  {
   value: "Lonate Ceppino (ITLPP)",
   label: "Lonate Ceppino (ITLPP)"
  },
  {
   value: "Lovere (ITLVR)",
   label: "Lovere (ITLVR)"
  },
  {
   value: "Lucca (ITLCV)",
   label: "Lucca (ITLCV)"
  },
  {
   value: "Lucignano (ITLCG)",
   label: "Lucignano (ITLCG)"
  },
  {
   value: "Lugo di Grezzana (ITLGZ)",
   label: "Lugo di Grezzana (ITLGZ)"
  },
  {
   value: "Lugo di Vincenza (ITLDV)",
   label: "Lugo di Vincenza (ITLDV)"
  },
  {
   value: "Gorla Maggiore (ITGLM)",
   label: "Gorla Maggiore (ITGLM)"
  },
  {
   value: "Gorla Minore (ITGME)",
   label: "Gorla Minore (ITGME)"
  },
  {
   value: "Gozzano (ITGZO)",
   label: "Gozzano (ITGZO)"
  },
  {
   value: "Grado (ITGRD)",
   label: "Grado (ITGRD)"
  },
  {
   value: "Graglia (ITGGL)",
   label: "Graglia (ITGGL)"
  },
  {
   value: "Gragnano (ITGNO)",
   label: "Gragnano (ITGNO)"
  },
  {
   value: "Grassobbio (ITGRA)",
   label: "Grassobbio (ITGRA)"
  },
  {
   value: "Gravellona Toce (ITGVT)",
   label: "Gravellona Toce (ITGVT)"
  },
  {
   value: "Greve in Chianti (ITGIC)",
   label: "Greve in Chianti (ITGIC)"
  },
  {
   value: "Grezzana (ITGRZ)",
   label: "Grezzana (ITGRZ)"
  },
  {
   value: "Grono (ITGRO)",
   label: "Grono (ITGRO)"
  },
  {
   value: "Grosseto (ITGRS)",
   label: "Grosseto (ITGRS)"
  },
  {
   value: "Grugliasco (ITGRG)",
   label: "Grugliasco (ITGRG)"
  },
  {
   value: "Grugnole di Mornago (ITGDM)",
   label: "Grugnole di Mornago (ITGDM)"
  },
  {
   value: "Grumello delmonte (ITGMD)",
   label: "Grumello delmonte (ITGMD)"
  },
  {
   value: "Gualdo tadino (ITGTD)",
   label: "Gualdo tadino (ITGTD)"
  },
  {
   value: "Gualtieri (ITGLT)",
   label: "Gualtieri (ITGLT)"
  },
  {
   value: "Guardamiglio (ITGUA)",
   label: "Guardamiglio (ITGUA)"
  },
  {
   value: "Guastalla (ITGUS)",
   label: "Guastalla (ITGUS)"
  },
  {
   value: "Imola (ITIML)",
   label: "Imola (ITIML)"
  },
  {
   value: "Imperia (ITIMP)",
   label: "Imperia (ITIMP)"
  },
  {
   value: "Invorio (ITINV)",
   label: "Invorio (ITINV)"
  },
  {
   value: "Ischia (ITISH)",
   label: "Ischia (ITISH)"
  },
  {
   value: "Isola del Giglio (ITIDG)",
   label: "Isola del Giglio (ITIDG)"
  },
  {
   value: "Isola Santo Stefano (ITISS)",
   label: "Isola Santo Stefano (ITISS)"
  },
  {
   value: "Isolo Ortonova (ITISO)",
   label: "Isolo Ortonova (ITISO)"
  },
  {
   value: "Ispica (ITISP)",
   label: "Ispica (ITISP)"
  },
  {
   value: "Istrana (ITIST)",
   label: "Istrana (ITIST)"
  },
  {
   value: "Jerago con Orago (ITJCO)",
   label: "Jerago con Orago (ITJCO)"
  },
  {
   value: "Jesolo (ITJLO)",
   label: "Jesolo (ITJLO)"
  },
  {
   value: "L'aquila (ITLAQ)",
   label: "L'aquila (ITLAQ)"
  },
  {
   value: "La Morra (ITLAM)",
   label: "La Morra (ITLAM)"
  },
  {
   value: "La Spezia (ITSPE)",
   label: "La Spezia (ITSPE)"
  },
  {
   value: "La Turino (ITLAT)",
   label: "La Turino (ITLAT)"
  },
  {
   value: "Lainate (ITLTE)",
   label: "Lainate (ITLTE)"
  },
  {
   value: "Lamezia-Terme (ITSUF)",
   label: "Lamezia-Terme (ITSUF)"
  },
  {
   value: "Lampedusa (ITLMP)",
   label: "Lampedusa (ITLMP)"
  },
  {
   value: "Lamporechio (ITLMO)",
   label: "Lamporechio (ITLMO)"
  },
  {
   value: "Lancenigo (ITLGO)",
   label: "Lancenigo (ITLGO)"
  },
  {
   value: "Formigine (ITFMG)",
   label: "Formigine (ITFMG)"
  },
  {
   value: "Fornacette (ITFON)",
   label: "Fornacette (ITFON)"
  },
  {
   value: "Fosalta D Prtogruaro (ITFOD)",
   label: "Fosalta D Prtogruaro (ITFOD)"
  },
  {
   value: "Fossalta di Piave (ITFDV)",
   label: "Fossalta di Piave (ITFDV)"
  },
  {
   value: "Fossano (ITFSS)",
   label: "Fossano (ITFSS)"
  },
  {
   value: "Frascati (ITFRA)",
   label: "Frascati (ITFRA)"
  },
  {
   value: "Frosinone (ITFRO)",
   label: "Frosinone (ITFRO)"
  },
  {
   value: "Fucecchio (ITFUC)",
   label: "Fucecchio (ITFUC)"
  },
  {
   value: "Funo D'argelato (ITFUN)",
   label: "Funo D'argelato (ITFUN)"
  },
  {
   value: "Fusino (ITFSO)",
   label: "Fusino (ITFSO)"
  },
  {
   value: "Fustina (ITFUS)",
   label: "Fustina (ITFUS)"
  },
  {
   value: "Gaeta (ITGAE)",
   label: "Gaeta (ITGAE)"
  },
  {
   value: "Galbiate (ITGBA)",
   label: "Galbiate (ITGBA)"
  },
  {
   value: "Gallarate (ITGTE)",
   label: "Gallarate (ITGTE)"
  },
  {
   value: "Gallico (ITGAO)",
   label: "Gallico (ITGAO)"
  },
  {
   value: "Galliera (ITGLL)",
   label: "Galliera (ITGLL)"
  },
  {
   value: "Galliera Veneta (ITGVE)",
   label: "Galliera Veneta (ITGVE)"
  },
  {
   value: "Gallipoli (ITGAL)",
   label: "Gallipoli (ITGAL)"
  },
  {
   value: "Gambara (ITGMB)",
   label: "Gambara (ITGMB)"
  },
  {
   value: "Gambolo (ITGAM)",
   label: "Gambolo (ITGAM)"
  },
  {
   value: "Garagnano (ITGGO)",
   label: "Garagnano (ITGGO)"
  },
  {
   value: "Gardone Valtrompia (ITGAR)",
   label: "Gardone Valtrompia (ITGAR)"
  },
  {
   value: "Gassino (ITGSO)",
   label: "Gassino (ITGSO)"
  },
  {
   value: "Gattatico (ITGTC)",
   label: "Gattatico (ITGTC)"
  },
  {
   value: "Gattinara (ITGTA)",
   label: "Gattinara (ITGTA)"
  },
  {
   value: "Gavi (ITGAV)",
   label: "Gavi (ITGAV)"
  },
  {
   value: "Gazzola (ITGED)",
   label: "Gazzola (ITGED)"
  },
  {
   value: "Gela (ITGEA)",
   label: "Gela (ITGEA)"
  },
  {
   value: "Gemona del Friuli (ITGDF)",
   label: "Gemona del Friuli (ITGDF)"
  },
  {
   value: "Genoa (ITGOA)",
   label: "Genoa (ITGOA)"
  },
  {
   value: "Giannutri (ITGII)",
   label: "Giannutri (ITGII)"
  },
  {
   value: "Giardini (ITGIA)",
   label: "Giardini (ITGIA)"
  },
  {
   value: "Ginestra (ITGFT)",
   label: "Ginestra (ITGFT)"
  },
  {
   value: "Ginostra (ITGOS)",
   label: "Ginostra (ITGOS)"
  },
  {
   value: "Gioia Tauro (ITGIT)",
   label: "Gioia Tauro (ITGIT)"
  },
  {
   value: "Golfo Aranci (ITGAI)",
   label: "Golfo Aranci (ITGAI)"
  },
  {
   value: "Gonnosfanadiga (ITGON)",
   label: "Gonnosfanadiga (ITGON)"
  },
  {
   value: "Gorgona (ITGOR)",
   label: "Gorgona (ITGOR)"
  },
  {
   value: "Gorizia (ITGZA)",
   label: "Gorizia (ITGZA)"
  },
  {
   value: "Faenza (ITFAE)",
   label: "Faenza (ITFAE)"
  },
  {
   value: "Fagagna (ITFAA)",
   label: "Fagagna (ITFAA)"
  },
  {
   value: "Falconara (ITFAL)",
   label: "Falconara (ITFAL)"
  },
  {
   value: "Fanano (ITFNO)",
   label: "Fanano (ITFNO)"
  },
  {
   value: "Favara (ITFVR)",
   label: "Favara (ITFVR)"
  },
  {
   value: "Favignana (ITFAV)",
   label: "Favignana (ITFAV)"
  },
  {
   value: "Fegino (ITFEG)",
   label: "Fegino (ITFEG)"
  },
  {
   value: "Felitto (ITFTO)",
   label: "Felitto (ITFTO)"
  },
  {
   value: "Fellette Di Romano (ITFEL)",
   label: "Fellette Di Romano (ITFEL)"
  },
  {
   value: "Feltre (ITFTE)",
   label: "Feltre (ITFTE)"
  },
  {
   value: "Fermignano (ITFMN)",
   label: "Fermignano (ITFMN)"
  },
  {
   value: "Fermo (ITFER)",
   label: "Fermo (ITFER)"
  },
  {
   value: "Ferrara (ITFRR)",
   label: "Ferrara (ITFRR)"
  },
  {
   value: "Ferrazza (ITFRZ)",
   label: "Ferrazza (ITFRZ)"
  },
  {
   value: "Fidenza (ITFDZ)",
   label: "Fidenza (ITFDZ)"
  },
  {
   value: "Fiesso Umbertiano (ITFUT)",
   label: "Fiesso Umbertiano (ITFUT)"
  },
  {
   value: "Figine Valdarno (ITFVD)",
   label: "Figine Valdarno (ITFVD)"
  },
  {
   value: "Figino (ITFGN)",
   label: "Figino (ITFGN)"
  },
  {
   value: "Figino Serenza (ITFSZ)",
   label: "Figino Serenza (ITFSZ)"
  },
  {
   value: "Filicudi Porto (ITFPO)",
   label: "Filicudi Porto (ITFPO)"
  },
  {
   value: "Finale Emilia (ITFIE)",
   label: "Finale Emilia (ITFIE)"
  },
  {
   value: "Fiorano (FRN) (ITFIR)",
   label: "Fiorano (FRN) (ITFIR)"
  },
  {
   value: "Fiorano Modenese (ITFRN)",
   label: "Fiorano Modenese (ITFRN)"
  },
  {
   value: "Fiorenzuola D'arda (ITFNZ)",
   label: "Fiorenzuola D'arda (ITFNZ)"
  },
  {
   value: "Firenze (ITFLR)",
   label: "Firenze (ITFLR)"
  },
  {
   value: "Firenzuola (ITFBO)",
   label: "Firenzuola (ITFBO)"
  },
  {
   value: "Fiume Veneto (ITFIU)",
   label: "Fiume Veneto (ITFIU)"
  },
  {
   value: "Fiumicino\/FUMICINO APT ROMA (ITFCO)",
   label: "Fiumicino\/FUMICINO APT ROMA (ITFCO)"
  },
  {
   value: "Flero (ITFEO)",
   label: "Flero (ITFEO)"
  },
  {
   value: "Florano Modenese (ITFMD)",
   label: "Florano Modenese (ITFMD)"
  },
  {
   value: "Flumeri (ITFLM)",
   label: "Flumeri (ITFLM)"
  },
  {
   value: "Foggia (ITFOG)",
   label: "Foggia (ITFOG)"
  },
  {
   value: "Folignano (ITFLO)",
   label: "Folignano (ITFLO)"
  },
  {
   value: "Follonica (ITFOL)",
   label: "Follonica (ITFOL)"
  },
  {
   value: "Fombio (ITFBI)",
   label: "Fombio (ITFBI)"
  },
  {
   value: "Fontanafredda (ITFTF)",
   label: "Fontanafredda (ITFTF)"
  },
  {
   value: "Forli (ITFRL)",
   label: "Forli (ITFRL)"
  },
  {
   value: "Forlimpopoli (ITFPP)",
   label: "Forlimpopoli (ITFPP)"
  },
  {
   value: "Formia (ITFOM)",
   label: "Formia (ITFOM)"
  },
  {
   value: "Costa di Mezzate (ITCMZ)",
   label: "Costa di Mezzate (ITCMZ)"
  },
  {
   value: "Cotignola (ITCXN)",
   label: "Cotignola (ITCXN)"
  },
  {
   value: "Creazzo (ITCZZ)",
   label: "Creazzo (ITCZZ)"
  },
  {
   value: "Crema (ITCMR)",
   label: "Crema (ITCMR)"
  },
  {
   value: "Cremona (ITCRE)",
   label: "Cremona (ITCRE)"
  },
  {
   value: "Crescentino (ITCRC)",
   label: "Crescentino (ITCRC)"
  },
  {
   value: "Crescentio (ITCXO)",
   label: "Crescentio (ITCXO)"
  },
  {
   value: "Crespellano (ITCPO)",
   label: "Crespellano (ITCPO)"
  },
  {
   value: "Crevalcore (ITCVO)",
   label: "Crevalcore (ITCVO)"
  },
  {
   value: "Croce (ITCRO)",
   label: "Croce (ITCRO)"
  },
  {
   value: "Croce Sull'arno Fi- (ITCSU)",
   label: "Croce Sull'arno Fi- (ITCSU)"
  },
  {
   value: "Crocetta (ITCTT)",
   label: "Crocetta (ITCTT)"
  },
  {
   value: "Crotone (ITCRV)",
   label: "Crotone (ITCRV)"
  },
  {
   value: "Crugola di Mornago (ITCGM)",
   label: "Crugola di Mornago (ITCGM)"
  },
  {
   value: "Cuneo (ITCUN)",
   label: "Cuneo (ITCUN)"
  },
  {
   value: "Cusinati Di Rosa (ITCUS)",
   label: "Cusinati Di Rosa (ITCUS)"
  },
  {
   value: "Cvaion Veronese (ITCVN)",
   label: "Cvaion Veronese (ITCVN)"
  },
  {
   value: "Dalmine (ITDME)",
   label: "Dalmine (ITDME)"
  },
  {
   value: "Daverio (ITDVO)",
   label: "Daverio (ITDVO)"
  },
  {
   value: "Decimomannu (ITDCI)",
   label: "Decimomannu (ITDCI)"
  },
  {
   value: "Derulo (ITDER)",
   label: "Derulo (ITDER)"
  },
  {
   value: "Dervio (ITDEV)",
   label: "Dervio (ITDEV)"
  },
  {
   value: "Desenzano del Garda (ITDDG)",
   label: "Desenzano del Garda (ITDDG)"
  },
  {
   value: "Desio (ITDES)",
   label: "Desio (ITDES)"
  },
  {
   value: "Di Barga (ITDIB)",
   label: "Di Barga (ITDIB)"
  },
  {
   value: "Dogana (ITDOG)",
   label: "Dogana (ITDOG)"
  },
  {
   value: "Dogana do Ortonovo (ITDDO)",
   label: "Dogana do Ortonovo (ITDDO)"
  },
  {
   value: "Dolo (ITDOL)",
   label: "Dolo (ITDOL)"
  },
  {
   value: "Domegliara (ITDGL)",
   label: "Domegliara (ITDGL)"
  },
  {
   value: "Domodossola (ITDOM)",
   label: "Domodossola (ITDOM)"
  },
  {
   value: "Dosimo (ITDOS)",
   label: "Dosimo (ITDOS)"
  },
  {
   value: "Dueville (ITDUV)",
   label: "Dueville (ITDUV)"
  },
  {
   value: "Eboli (ITEBB)",
   label: "Eboli (ITEBB)"
  },
  {
   value: "Elba (ITEBA)",
   label: "Elba (ITEBA)"
  },
  {
   value: "Enna (ITENO)",
   label: "Enna (ITENO)"
  },
  {
   value: "Erba (ITERB)",
   label: "Erba (ITERB)"
  },
  {
   value: "Ercolano (ITERC)",
   label: "Ercolano (ITERC)"
  },
  {
   value: "Este (ITEST)",
   label: "Este (ITEST)"
  },
  {
   value: "Fabriano (ITFBR)",
   label: "Fabriano (ITFBR)"
  },
  {
   value: "Fabrica di Roma (ITFDR)",
   label: "Fabrica di Roma (ITFDR)"
  },
  {
   value: "Cividale del Friuli (ITCIF)",
   label: "Cividale del Friuli (ITCIF)"
  },
  {
   value: "Civita Castellana (ITCCA)",
   label: "Civita Castellana (ITCCA)"
  },
  {
   value: "Civitanova Marche (ITIOA)",
   label: "Civitanova Marche (ITIOA)"
  },
  {
   value: "Civitavecchia (ITCVV)",
   label: "Civitavecchia (ITCVV)"
  },
  {
   value: "Civitella in Val di Chiana (ITCTV)",
   label: "Civitella in Val di Chiana (ITCTV)"
  },
  {
   value: "Cizzolo (ITCIZ)",
   label: "Cizzolo (ITCIZ)"
  },
  {
   value: "Clusone (ITCUE)",
   label: "Clusone (ITCUE)"
  },
  {
   value: "Codogno (ITCGN)",
   label: "Codogno (ITCGN)"
  },
  {
   value: "Cogollo Del Cengio (ITCGO)",
   label: "Cogollo Del Cengio (ITCGO)"
  },
  {
   value: "Colico (ITCOL)",
   label: "Colico (ITCOL)"
  },
  {
   value: "Collalto (ITCLT)",
   label: "Collalto (ITCLT)"
  },
  {
   value: "Colle di v d'Elsa (ITCDL)",
   label: "Colle di v d'Elsa (ITCDL)"
  },
  {
   value: "Collebeato (ITCLL)",
   label: "Collebeato (ITCLL)"
  },
  {
   value: "Collecchio (ITCCH)",
   label: "Collecchio (ITCCH)"
  },
  {
   value: "Colleferro (ITCFO)",
   label: "Colleferro (ITCFO)"
  },
  {
   value: "Collesalvetti (ITCOI)",
   label: "Collesalvetti (ITCOI)"
  },
  {
   value: "Cologna Veneta (ITCGV)",
   label: "Cologna Veneta (ITCGV)"
  },
  {
   value: "Colognola ai Colli (ITCNL)",
   label: "Colognola ai Colli (ITCNL)"
  },
  {
   value: "Comiso (ITCIY)",
   label: "Comiso (ITCIY)"
  },
  {
   value: "Como (ITOMO)",
   label: "Como (ITOMO)"
  },
  {
   value: "Condove (ITCON)",
   label: "Condove (ITCON)"
  },
  {
   value: "Conegliano (ITCOG)",
   label: "Conegliano (ITCOG)"
  },
  {
   value: "Contrada Torremozza (ITCOA)",
   label: "Contrada Torremozza (ITCOA)"
  },
  {
   value: "Corana (ITCNA)",
   label: "Corana (ITCNA)"
  },
  {
   value: "Corcagnano (ITCOR)",
   label: "Corcagnano (ITCOR)"
  },
  {
   value: "Coriano (ITCOO)",
   label: "Coriano (ITCOO)"
  },
  {
   value: "Cormano (ITCMN)",
   label: "Cormano (ITCMN)"
  },
  {
   value: "Cormons (ITCMS)",
   label: "Cormons (ITCMS)"
  },
  {
   value: "Cornedo Vincentino (ITCOV)",
   label: "Cornedo Vincentino (ITCOV)"
  },
  {
   value: "Corniglio (ITCRN)",
   label: "Corniglio (ITCRN)"
  },
  {
   value: "Correggio (ITCGG)",
   label: "Correggio (ITCGG)"
  },
  {
   value: "Corsico (ITCRS)",
   label: "Corsico (ITCRS)"
  },
  {
   value: "Corte Tegge (ITCTE)",
   label: "Corte Tegge (ITCTE)"
  },
  {
   value: "Cortenuova (ITCRT)",
   label: "Cortenuova (ITCRT)"
  },
  {
   value: "Cortina d'Ampezzo (ITCDF)",
   label: "Cortina d'Ampezzo (ITCDF)"
  },
  {
   value: "Cosenza (ITQCS)",
   label: "Cosenza (ITQCS)"
  },
  {
   value: "Cossato (ITCOS)",
   label: "Cossato (ITCOS)"
  },
  {
   value: "Cosseria (ITCRI)",
   label: "Cosseria (ITCRI)"
  },
  {
   value: "Cavo (ITCVX)",
   label: "Cavo (ITCVX)"
  },
  {
   value: "Cavriago (ITCVI)",
   label: "Cavriago (ITCVI)"
  },
  {
   value: "Cazzano sant'Andrea (ITCZS)",
   label: "Cazzano sant'Andrea (ITCZS)"
  },
  {
   value: "Cecchina (ITCCC)",
   label: "Cecchina (ITCCC)"
  },
  {
   value: "Cecchini di Pasiano (ITCDP)",
   label: "Cecchini di Pasiano (ITCDP)"
  },
  {
   value: "Cecina (ITCEC)",
   label: "Cecina (ITCEC)"
  },
  {
   value: "Cenia (ITCNI)",
   label: "Cenia (ITCNI)"
  },
  {
   value: "Ceranesi (ITCER)",
   label: "Ceranesi (ITCER)"
  },
  {
   value: "Ceriano Laghetto (ITCLO)",
   label: "Ceriano Laghetto (ITCLO)"
  },
  {
   value: "Cerignola (ITCEA)",
   label: "Cerignola (ITCEA)"
  },
  {
   value: "Cermenate (ITCEE)",
   label: "Cermenate (ITCEE)"
  },
  {
   value: "Cernusco (ITCNO)",
   label: "Cernusco (ITCNO)"
  },
  {
   value: "Certaldo (ITCET)",
   label: "Certaldo (ITCET)"
  },
  {
   value: "Cervarese (ITCVR)",
   label: "Cervarese (ITCVR)"
  },
  {
   value: "Cesano Maderno (ITCEM)",
   label: "Cesano Maderno (ITCEM)"
  },
  {
   value: "Cesara Novara (ITCEN)",
   label: "Cesara Novara (ITCEN)"
  },
  {
   value: "Cesena (ITCEZ)",
   label: "Cesena (ITCEZ)"
  },
  {
   value: "Cessalto (ITCES)",
   label: "Cessalto (ITCES)"
  },
  {
   value: "Cherasco (ITCHE)",
   label: "Cherasco (ITCHE)"
  },
  {
   value: "Chiampo (ITCHO)",
   label: "Chiampo (ITCHO)"
  },
  {
   value: "Chiara (ITCHR)",
   label: "Chiara (ITCHR)"
  },
  {
   value: "Chiasso (ITCHS)",
   label: "Chiasso (ITCHS)"
  },
  {
   value: "Chiavazza (ITCHA)",
   label: "Chiavazza (ITCHA)"
  },
  {
   value: "Chiavenna (ITCHV)",
   label: "Chiavenna (ITCHV)"
  },
  {
   value: "Chiesa Valmalenco (ITCVM)",
   label: "Chiesa Valmalenco (ITCVM)"
  },
  {
   value: "Chieti (ITCII)",
   label: "Chieti (ITCII)"
  },
  {
   value: "Chioggia (ITCHI)",
   label: "Chioggia (ITCHI)"
  },
  {
   value: "Chiopris Viscone (ITCVS)",
   label: "Chiopris Viscone (ITCVS)"
  },
  {
   value: "Chiusa D Ginestreto (ITCDG)",
   label: "Chiusa D Ginestreto (ITCDG)"
  },
  {
   value: "Ciampino Apt\/Roma (ITCIA)",
   label: "Ciampino Apt\/Roma (ITCIA)"
  },
  {
   value: "Cimadolmo (ITCIM)",
   label: "Cimadolmo (ITCIM)"
  },
  {
   value: "Cinisello Balsamo (ITCIB)",
   label: "Cinisello Balsamo (ITCIB)"
  },
  {
   value: "Cirie (ITCIR)",
   label: "Cirie (ITCIR)"
  },
  {
   value: "Cisano Bergamasco (ITCBG)",
   label: "Cisano Bergamasco (ITCBG)"
  },
  {
   value: "Ciserano (ITCQQ)",
   label: "Ciserano (ITCQQ)"
  },
  {
   value: "Cisterna di Latina (ITCIS)",
   label: "Cisterna di Latina (ITCIS)"
  },
  {
   value: "Citta Di Castello (ITCDC)",
   label: "Citta Di Castello (ITCDC)"
  },
  {
   value: "Cittadella (ITCIT)",
   label: "Cittadella (ITCIT)"
  },
  {
   value: "Castagnaro (ITCTN)",
   label: "Castagnaro (ITCTN)"
  },
  {
   value: "Castano Primo (ITCPR)",
   label: "Castano Primo (ITCPR)"
  },
  {
   value: "Casteggio (ITCTG)",
   label: "Casteggio (ITCTG)"
  },
  {
   value: "Castegnato (ITCEG)",
   label: "Castegnato (ITCEG)"
  },
  {
   value: "Castel Boglione (ITCBO)",
   label: "Castel Boglione (ITCBO)"
  },
  {
   value: "Castel Bolognese (ITCBL)",
   label: "Castel Bolognese (ITCBL)"
  },
  {
   value: "Castel Madama (ITCMA)",
   label: "Castel Madama (ITCMA)"
  },
  {
   value: "Castel Maggiore (ITCMG)",
   label: "Castel Maggiore (ITCMG)"
  },
  {
   value: "Castelbeforte (ITCBF)",
   label: "Castelbeforte (ITCBF)"
  },
  {
   value: "Castelfidardo (ITCFD)",
   label: "Castelfidardo (ITCFD)"
  },
  {
   value: "Castelfranco Di Sopra (ITCFA)",
   label: "Castelfranco Di Sopra (ITCFA)"
  },
  {
   value: "Castelfranco Emilia (ITCFE)",
   label: "Castelfranco Emilia (ITCFE)"
  },
  {
   value: "Castelfranco Veneto (ITCFV)",
   label: "Castelfranco Veneto (ITCFV)"
  },
  {
   value: "Castelgamberto (ITCSG)",
   label: "Castelgamberto (ITCSG)"
  },
  {
   value: "Castella Di Godego (ITCSY)",
   label: "Castella Di Godego (ITCSY)"
  },
  {
   value: "Castellammare Del Golfo (ITCTR)",
   label: "Castellammare Del Golfo (ITCTR)"
  },
  {
   value: "Castellammare Di Stabia (ITCAS)",
   label: "Castellammare Di Stabia (ITCAS)"
  },
  {
   value: "Castellana (ITCVA)",
   label: "Castellana (ITCVA)"
  },
  {
   value: "Castellanza (ITCSZ)",
   label: "Castellanza (ITCSZ)"
  },
  {
   value: "Castellarano (ITCTO)",
   label: "Castellarano (ITCTO)"
  },
  {
   value: "Castellina in Chianti (ITCSC)",
   label: "Castellina in Chianti (ITCSC)"
  },
  {
   value: "Castello (ITCEO)",
   label: "Castello (ITCEO)"
  },
  {
   value: "Castello D'annone (ITQSA)",
   label: "Castello D'annone (ITQSA)"
  },
  {
   value: "Castelnuovo (ITCSV)",
   label: "Castelnuovo (ITCSV)"
  },
  {
   value: "Castelnuovo Scrivia (ITCNS)",
   label: "Castelnuovo Scrivia (ITCNS)"
  },
  {
   value: "Castelnuovo del Garda (ITCED)",
   label: "Castelnuovo del Garda (ITCED)"
  },
  {
   value: "Castelovati (ITCVT)",
   label: "Castelovati (ITCVT)"
  },
  {
   value: "Castelvetro Piacentino (ITCVP)",
   label: "Castelvetro Piacentino (ITCVP)"
  },
  {
   value: "Castenedolo (ITCTD)",
   label: "Castenedolo (ITCTD)"
  },
  {
   value: "Castiglione (ITCGL)",
   label: "Castiglione (ITCGL)"
  },
  {
   value: "Castrette di Villorba (ITCDV)",
   label: "Castrette di Villorba (ITCDV)"
  },
  {
   value: "Castronno (ITCNN)",
   label: "Castronno (ITCNN)"
  },
  {
   value: "Catania (ITCTA)",
   label: "Catania (ITCTA)"
  },
  {
   value: "Catanzaro (ITQCZ)",
   label: "Catanzaro (ITQCZ)"
  },
  {
   value: "Cavallirio (ITCAV)",
   label: "Cavallirio (ITCAV)"
  },
  {
   value: "Cavarzere (ITCVZ)",
   label: "Cavarzere (ITCVZ)"
  },
  {
   value: "Capriate San Gervasio (ITCPI)",
   label: "Capriate San Gervasio (ITCPI)"
  },
  {
   value: "Capua (ITCPU)",
   label: "Capua (ITCPU)"
  },
  {
   value: "Caramagna (ITCAR)",
   label: "Caramagna (ITCAR)"
  },
  {
   value: "Caravaggio (ITCVG)",
   label: "Caravaggio (ITCVG)"
  },
  {
   value: "Carbonera (ITCRB)",
   label: "Carbonera (ITCRB)"
  },
  {
   value: "Carcare (ITCAC)",
   label: "Carcare (ITCAC)"
  },
  {
   value: "Carloforte (ITCLF)",
   label: "Carloforte (ITCLF)"
  },
  {
   value: "Carmagnola (ITCRM)",
   label: "Carmagnola (ITCRM)"
  },
  {
   value: "Carmignano (ITCXM)",
   label: "Carmignano (ITCXM)"
  },
  {
   value: "Carmignano di Brenta (ITCMI)",
   label: "Carmignano di Brenta (ITCMI)"
  },
  {
   value: "Carobbio degli Angeli (ITCBX)",
   label: "Carobbio degli Angeli (ITCBX)"
  },
  {
   value: "Caronno Pertusella (ITCOP)",
   label: "Caronno Pertusella (ITCOP)"
  },
  {
   value: "Carpenedolo (ITCRP)",
   label: "Carpenedolo (ITCRP)"
  },
  {
   value: "Carpi (ITRPI)",
   label: "Carpi (ITRPI)"
  },
  {
   value: "Carrara (ITCRA)",
   label: "Carrara (ITCRA)"
  },
  {
   value: "Carugate (ITCRU)",
   label: "Carugate (ITCRU)"
  },
  {
   value: "Casale (ITCXV)",
   label: "Casale (ITCXV)"
  },
  {
   value: "Casale sul Sile (ITCSS)",
   label: "Casale sul Sile (ITCSS)"
  },
  {
   value: "Casalecchio Di Reno (ITCSR)",
   label: "Casalecchio Di Reno (ITCSR)"
  },
  {
   value: "Casalgrande (ITCLG)",
   label: "Casalgrande (ITCLG)"
  },
  {
   value: "Casalmaggiore (ITCSM)",
   label: "Casalmaggiore (ITCSM)"
  },
  {
   value: "Casamicciola (ITCML)",
   label: "Casamicciola (ITCML)"
  },
  {
   value: "Casandrino (ITCSN)",
   label: "Casandrino (ITCSN)"
  },
  {
   value: "Casarile (ITCSE)",
   label: "Casarile (ITCSE)"
  },
  {
   value: "Casaza Ligure (ITCZL)",
   label: "Casaza Ligure (ITCZL)"
  },
  {
   value: "Cascina (ITCCN)",
   label: "Cascina (ITCCN)"
  },
  {
   value: "Casella d'Asolo (ITCDA)",
   label: "Casella d'Asolo (ITCDA)"
  },
  {
   value: "Caselle di Altivole (ITCSL)",
   label: "Caselle di Altivole (ITCSL)"
  },
  {
   value: "Caselle Torinese (ITCTI)",
   label: "Caselle Torinese (ITCTI)"
  },
  {
   value: "Caserta (ITCST)",
   label: "Caserta (ITCST)"
  },
  {
   value: "Casinalbo (ITCSI)",
   label: "Casinalbo (ITCSI)"
  },
  {
   value: "Casnate (ITCNE)",
   label: "Casnate (ITCNE)"
  },
  {
   value: "Casnigo (ITCGI)",
   label: "Casnigo (ITCGI)"
  },
  {
   value: "Cassano Dadda (ITCDD)",
   label: "Cassano Dadda (ITCDD)"
  },
  {
   value: "Cassano Spinola (ITCSP)",
   label: "Cassano Spinola (ITCSP)"
  },
  {
   value: "Cassina de'Pecchi (ITCPC)",
   label: "Cassina de'Pecchi (ITCPC)"
  },
  {
   value: "Cassinelta (ITCSA)",
   label: "Cassinelta (ITCSA)"
  },
  {
   value: "Cassino (ITCSO)",
   label: "Cassino (ITCSO)"
  },
  {
   value: "Busca (ITBWA)",
   label: "Busca (ITBWA)"
  },
  {
   value: "Bussero (ITBUS)",
   label: "Bussero (ITBUS)"
  },
  {
   value: "Busseto (ITBST)",
   label: "Busseto (ITBST)"
  },
  {
   value: "Busto Arsizio (ITBUA)",
   label: "Busto Arsizio (ITBUA)"
  },
  {
   value: "Busto Garolfo (ITBUG)",
   label: "Busto Garolfo (ITBUG)"
  },
  {
   value: "Buttrio (ITBTT)",
   label: "Buttrio (ITBTT)"
  },
  {
   value: "Ca' Degli Oppi (ITCDO)",
   label: "Ca' Degli Oppi (ITCDO)"
  },
  {
   value: "Cabiate (ITCAB)",
   label: "Cabiate (ITCAB)"
  },
  {
   value: "Cagliari (ITCAG)",
   label: "Cagliari (ITCAG)"
  },
  {
   value: "Cairate (ITCEU)",
   label: "Cairate (ITCEU)"
  },
  {
   value: "Caivano (ITCAI)",
   label: "Caivano (ITCAI)"
  },
  {
   value: "Calasetta (ITCLS)",
   label: "Calasetta (ITCLS)"
  },
  {
   value: "Calderara di Reno (ITDRI)",
   label: "Calderara di Reno (ITDRI)"
  },
  {
   value: "Calderari (ITCDI)",
   label: "Calderari (ITCDI)"
  },
  {
   value: "Calderino D Monti (ITCDM)",
   label: "Calderino D Monti (ITCDM)"
  },
  {
   value: "Calenzano (ITCAL)",
   label: "Calenzano (ITCAL)"
  },
  {
   value: "Caltanissetta (ITCTS)",
   label: "Caltanissetta (ITCTS)"
  },
  {
   value: "Cambiago (ITCAM)",
   label: "Cambiago (ITCAM)"
  },
  {
   value: "Cambiano (ITCIN)",
   label: "Cambiano (ITCIN)"
  },
  {
   value: "Camerano (ITCAO)",
   label: "Camerano (ITCAO)"
  },
  {
   value: "Camin Rione di Padova (ITCRD)",
   label: "Camin Rione di Padova (ITCRD)"
  },
  {
   value: "Campagnola (ITCAA)",
   label: "Campagnola (ITCAA)"
  },
  {
   value: "Campegina (ITCPG)",
   label: "Campegina (ITCPG)"
  },
  {
   value: "Campi Bisenzio (ITCBZ)",
   label: "Campi Bisenzio (ITCBZ)"
  },
  {
   value: "Campo Galliano (ITCGA)",
   label: "Campo Galliano (ITCGA)"
  },
  {
   value: "Campobasso (ITCOB)",
   label: "Campobasso (ITCOB)"
  },
  {
   value: "Campodarsego (ITCAP)",
   label: "Campodarsego (ITCAP)"
  },
  {
   value: "Camposampiero (ITCPS)",
   label: "Camposampiero (ITCPS)"
  },
  {
   value: "Candelbosco di Sopra (ITCAD)",
   label: "Candelbosco di Sopra (ITCAD)"
  },
  {
   value: "Candiana (ITCND)",
   label: "Candiana (ITCND)"
  },
  {
   value: "Canegrate (ITCAE)",
   label: "Canegrate (ITCAE)"
  },
  {
   value: "Caneli (ITCEI)",
   label: "Caneli (ITCEI)"
  },
  {
   value: "Canelli (ITCAN)",
   label: "Canelli (ITCAN)"
  },
  {
   value: "Canetto (ITCNT)",
   label: "Canetto (ITCNT)"
  },
  {
   value: "Cantu (ITCAU)",
   label: "Cantu (ITCAU)"
  },
  {
   value: "Capraia (ITCPA)",
   label: "Capraia (ITCPA)"
  },
  {
   value: "Capri (ITPRJ)",
   label: "Capri (ITPRJ)"
  },
  {
   value: "Capriano del Colle (ITCRL)",
   label: "Capriano del Colle (ITCRL)"
  },
  {
   value: "Bomporto (ITBOM)",
   label: "Bomporto (ITBOM)"
  },
  {
   value: "Bondeno (ITBON)",
   label: "Bondeno (ITBON)"
  },
  {
   value: "Borgo a Mozzano (ITBMZ)",
   label: "Borgo a Mozzano (ITBMZ)"
  },
  {
   value: "Borgo Di Trevi (ITBOR)",
   label: "Borgo Di Trevi (ITBOR)"
  },
  {
   value: "Borgo Panigale (ITBPG)",
   label: "Borgo Panigale (ITBPG)"
  },
  {
   value: "Borgo San Dalmazzo (ITBSD)",
   label: "Borgo San Dalmazzo (ITBSD)"
  },
  {
   value: "Borgo San Lorenzo (ITBSL)",
   label: "Borgo San Lorenzo (ITBSL)"
  },
  {
   value: "Borgo Ticino (ITBGT)",
   label: "Borgo Ticino (ITBGT)"
  },
  {
   value: "Borgofranco D'ivrea (ITBOG)",
   label: "Borgofranco D'ivrea (ITBOG)"
  },
  {
   value: "Borgolavezzaro (ITBOO)",
   label: "Borgolavezzaro (ITBOO)"
  },
  {
   value: "Borgomanero (ITBMR)",
   label: "Borgomanero (ITBMR)"
  },
  {
   value: "Borgonovo Val Tidone (ITBVT)",
   label: "Borgonovo Val Tidone (ITBVT)"
  },
  {
   value: "Borgosesia (ITBGM)",
   label: "Borgosesia (ITBGM)"
  },
  {
   value: "Botega D Colborgolo (ITBOT)",
   label: "Botega D Colborgolo (ITBOT)"
  },
  {
   value: "Bovalenta (ITBOV)",
   label: "Bovalenta (ITBOV)"
  },
  {
   value: "Boves (ITBVS)",
   label: "Boves (ITBVS)"
  },
  {
   value: "Bovisio Masciago (ITBMO)",
   label: "Bovisio Masciago (ITBMO)"
  },
  {
   value: "Bovolone (ITBVL)",
   label: "Bovolone (ITBVL)"
  },
  {
   value: "Bra (ITBRA)",
   label: "Bra (ITBRA)"
  },
  {
   value: "Breganze (ITBGZ)",
   label: "Breganze (ITBGZ)"
  },
  {
   value: "Bregnano (ITBNO)",
   label: "Bregnano (ITBNO)"
  },
  {
   value: "Brembate Di Sopra (ITBRS)",
   label: "Brembate Di Sopra (ITBRS)"
  },
  {
   value: "Brendola (Vicenza) (ITBRN)",
   label: "Brendola (Vicenza) (ITBRN)"
  },
  {
   value: "Brescello (ITBRE)",
   label: "Brescello (ITBRE)"
  },
  {
   value: "Brescia (ITBRC)",
   label: "Brescia (ITBRC)"
  },
  {
   value: "Bresso (ITBSO)",
   label: "Bresso (ITBSO)"
  },
  {
   value: "Brianza (ITBZI)",
   label: "Brianza (ITBZI)"
  },
  {
   value: "Briga Novarese (ITBRG)",
   label: "Briga Novarese (ITBRG)"
  },
  {
   value: "Brindisi (ITBDS)",
   label: "Brindisi (ITBDS)"
  },
  {
   value: "Brisighella (ITBSG)",
   label: "Brisighella (ITBSG)"
  },
  {
   value: "Brivio (ITBVI)",
   label: "Brivio (ITBVI)"
  },
  {
   value: "Brugnera (ITBGN)",
   label: "Brugnera (ITBGN)"
  },
  {
   value: "Bruino (ITBUN)",
   label: "Bruino (ITBUN)"
  },
  {
   value: "Bruneck (ITBEK)",
   label: "Bruneck (ITBEK)"
  },
  {
   value: "Bruzolo di Susa (ITBZD)",
   label: "Bruzolo di Susa (ITBZD)"
  },
  {
   value: "Bubano di Mordano (ITBBO)",
   label: "Bubano di Mordano (ITBBO)"
  },
  {
   value: "Buccinasco (ITBUC)",
   label: "Buccinasco (ITBUC)"
  },
  {
   value: "Busana (ITBSN)",
   label: "Busana (ITBSN)"
  },
  {
   value: "Bagnoli di Sopra (ITBGS)",
   label: "Bagnoli di Sopra (ITBGS)"
  },
  {
   value: "Bagnolo in Pano (ITBGP)",
   label: "Bagnolo in Pano (ITBGP)"
  },
  {
   value: "Bagnolo Mella (ITBAM)",
   label: "Bagnolo Mella (ITBAM)"
  },
  {
   value: "Baia (ITBAI)",
   label: "Baia (ITBAI)"
  },
  {
   value: "Baiso (ITIOB)",
   label: "Baiso (ITIOB)"
  },
  {
   value: "Bando (ITBND)",
   label: "Bando (ITBND)"
  },
  {
   value: "Barcellona (ITBAR)",
   label: "Barcellona (ITBAR)"
  },
  {
   value: "Bardolino (ITBLI)",
   label: "Bardolino (ITBLI)"
  },
  {
   value: "Bari (ITBRI)",
   label: "Bari (ITBRI)"
  },
  {
   value: "Barletta (ITBLT)",
   label: "Barletta (ITBLT)"
  },
  {
   value: "Barrafranca (ITBRF)",
   label: "Barrafranca (ITBRF)"
  },
  {
   value: "Basiano (ITBAO)",
   label: "Basiano (ITBAO)"
  },
  {
   value: "Bassano del Grappa (ITBDG)",
   label: "Bassano del Grappa (ITBDG)"
  },
  {
   value: "Bastia Umbra (ITBAS)",
   label: "Bastia Umbra (ITBAS)"
  },
  {
   value: "Bastiglia (ITBTG)",
   label: "Bastiglia (ITBTG)"
  },
  {
   value: "Battapaglia (ITBAT)",
   label: "Battapaglia (ITBAT)"
  },
  {
   value: "Baveno (ITBVN)",
   label: "Baveno (ITBVN)"
  },
  {
   value: "Bazzano (ITBZN)",
   label: "Bazzano (ITBZN)"
  },
  {
   value: "Bedizzole(Brescia) (ITBED)",
   label: "Bedizzole(Brescia) (ITBED)"
  },
  {
   value: "Bellano (ITBEL)",
   label: "Bellano (ITBEL)"
  },
  {
   value: "Belluno (ITBLX)",
   label: "Belluno (ITBLX)"
  },
  {
   value: "Bellusco (ITBLL)",
   label: "Bellusco (ITBLL)"
  },
  {
   value: "Benevento (ITBEN)",
   label: "Benevento (ITBEN)"
  },
  {
   value: "Bentivoglio (ITBVG)",
   label: "Bentivoglio (ITBVG)"
  },
  {
   value: "Bergamo (ITBGO)",
   label: "Bergamo (ITBGO)"
  },
  {
   value: "Bertinoro (ITBIN)",
   label: "Bertinoro (ITBIN)"
  },
  {
   value: "Bianconese di Fontevivo (ITBDF)",
   label: "Bianconese di Fontevivo (ITBDF)"
  },
  {
   value: "Biassono (ITBIA)",
   label: "Biassono (ITBIA)"
  },
  {
   value: "Bibbiena (ITBBB)",
   label: "Bibbiena (ITBBB)"
  },
  {
   value: "Biella (ITBIE)",
   label: "Biella (ITBIE)"
  },
  {
   value: "Bigolino (ITBIG)",
   label: "Bigolino (ITBIG)"
  },
  {
   value: "Binasco (ITBIO)",
   label: "Binasco (ITBIO)"
  },
  {
   value: "Bitonto (ITBTO)",
   label: "Bitonto (ITBTO)"
  },
  {
   value: "Bitritto (ITBIT)",
   label: "Bitritto (ITBIT)"
  },
  {
   value: "Bolgare (ITBGR)",
   label: "Bolgare (ITBGR)"
  },
  {
   value: "Bolgheri (ITBHI)",
   label: "Bolgheri (ITBHI)"
  },
  {
   value: "Bologna (ITBLQ)",
   label: "Bologna (ITBLQ)"
  },
  {
   value: "Bolognetta (ITBOL)",
   label: "Bolognetta (ITBOL)"
  },
  {
   value: "Bolzaneto (ITBLZ)",
   label: "Bolzaneto (ITBLZ)"
  },
  {
   value: "Bolzano (ITBZO)",
   label: "Bolzano (ITBZO)"
  },
  {
   value: "Altavilla (ITALV)",
   label: "Altavilla (ITALV)"
  },
  {
   value: "Amalfi (ITAMA)",
   label: "Amalfi (ITAMA)"
  },
  {
   value: "Ampezzo (ITAPZ)",
   label: "Ampezzo (ITAPZ)"
  },
  {
   value: "Anagni (ITANA)",
   label: "Anagni (ITANA)"
  },
  {
   value: "Ancona (ITAOI)",
   label: "Ancona (ITAOI)"
  },
  {
   value: "Andria (ITADR)",
   label: "Andria (ITADR)"
  },
  {
   value: "Anzio (ITANZ)",
   label: "Anzio (ITANZ)"
  },
  {
   value: "Anzola Dell'emilia (ITADE)",
   label: "Anzola Dell'emilia (ITADE)"
  },
  {
   value: "Aosta (ITAOT)",
   label: "Aosta (ITAOT)"
  },
  {
   value: "Arbatax (ITATX)",
   label: "Arbatax (ITATX)"
  },
  {
   value: "Arco (ITACO)",
   label: "Arco (ITACO)"
  },
  {
   value: "Arcore (ITARC)",
   label: "Arcore (ITARC)"
  },
  {
   value: "Arezzo (ITARE)",
   label: "Arezzo (ITARE)"
  },
  {
   value: "Arluno (ITAKA)",
   label: "Arluno (ITAKA)"
  },
  {
   value: "Arquata Scrivia (ITARQ)",
   label: "Arquata Scrivia (ITARQ)"
  },
  {
   value: "Arquota (ITAQU)",
   label: "Arquota (ITAQU)"
  },
  {
   value: "Arsiero (ITARS)",
   label: "Arsiero (ITARS)"
  },
  {
   value: "Arzano (ITARZ)",
   label: "Arzano (ITARZ)"
  },
  {
   value: "Arzergrande (ITAKD)",
   label: "Arzergrande (ITAKD)"
  },
  {
   value: "Arzignano (ITARI)",
   label: "Arzignano (ITARI)"
  },
  {
   value: "Ascoli Piceno (ITASP)",
   label: "Ascoli Piceno (ITASP)"
  },
  {
   value: "Asola (ITASL)",
   label: "Asola (ITASL)"
  },
  {
   value: "Asolo (ITASO)",
   label: "Asolo (ITASO)"
  },
  {
   value: "Assago (ITASS)",
   label: "Assago (ITASS)"
  },
  {
   value: "Assisi (ITASI)",
   label: "Assisi (ITASI)"
  },
  {
   value: "Asti (ITAST)",
   label: "Asti (ITAST)"
  },
  {
   value: "Augusta (ITAUG)",
   label: "Augusta (ITAUG)"
  },
  {
   value: "Avellino (ITAVE)",
   label: "Avellino (ITAVE)"
  },
  {
   value: "Avenza (ITAVN)",
   label: "Avenza (ITAVN)"
  },
  {
   value: "Avezzano (ITAVZ)",
   label: "Avezzano (ITAVZ)"
  },
  {
   value: "Aviano (ITAVI)",
   label: "Aviano (ITAVI)"
  },
  {
   value: "Avola (ITAVO)",
   label: "Avola (ITAVO)"
  },
  {
   value: "Bacoli (ITBCI)",
   label: "Bacoli (ITBCI)"
  },
  {
   value: "Badia Calavena (ITBVA)",
   label: "Badia Calavena (ITBVA)"
  },
  {
   value: "Badia Cantignano (ITBCG)",
   label: "Badia Cantignano (ITBCG)"
  },
  {
   value: "Baggiovara (ITBGG)",
   label: "Baggiovara (ITBGG)"
  },
  {
   value: "Bagnasco (ITBNS)",
   label: "Bagnasco (ITBNS)"
  },
  {
   value: "Bagni Ai Tivoli (ITBAV)",
   label: "Bagni Ai Tivoli (ITBAV)"
  },
  {
   value: "Bagno a Ripoli (ITBRL)",
   label: "Bagno a Ripoli (ITBRL)"
  },
  {
   value: "Bagno-Rubiera (ITBAG)",
   label: "Bagno-Rubiera (ITBAG)"
  },
  {
   value: "Bagnoli (ITBLN)",
   label: "Bagnoli (ITBLN)"
  },
  {
   value: "Skerjafjördur (ISKJF)",
   label: "Skerjafjördur (ISKJF)"
  },
  {
   value: "Stodhvarfjørdur (ISSTD)",
   label: "Stodhvarfjørdur (ISSTD)"
  },
  {
   value: "Straumsvik (ISSTR)",
   label: "Straumsvik (ISSTR)"
  },
  {
   value: "Stykkisholmur høfn (ISSTY)",
   label: "Stykkisholmur høfn (ISSTY)"
  },
  {
   value: "Sudavik (ISSUV)",
   label: "Sudavik (ISSUV)"
  },
  {
   value: "Sudureyri\/Sugandafjord (ISSUD)",
   label: "Sudureyri\/Sugandafjord (ISSUD)"
  },
  {
   value: "Svalbardseyri (ISSVA)",
   label: "Svalbardseyri (ISSVA)"
  },
  {
   value: "Talknafjørdur\/Sveinseyri (ISTAL)",
   label: "Talknafjørdur\/Sveinseyri (ISTAL)"
  },
  {
   value: "Thingeyri (ISTEY)",
   label: "Thingeyri (ISTEY)"
  },
  {
   value: "Thorlakshofn (ISTHH)",
   label: "Thorlakshofn (ISTHH)"
  },
  {
   value: "Thorshofn (ISTHO)",
   label: "Thorshofn (ISTHO)"
  },
  {
   value: "Vestmannaeyjar høfn (ISVES)",
   label: "Vestmannaeyjar høfn (ISVES)"
  },
  {
   value: "Vopnafjørdur (ISVPN)",
   label: "Vopnafjørdur (ISVPN)"
  },
  {
   value: "Acate (ITACA)",
   label: "Acate (ITACA)"
  },
  {
   value: "Acireale (ITACR)",
   label: "Acireale (ITACR)"
  },
  {
   value: "Acquaviva Picena (ITACQ)",
   label: "Acquaviva Picena (ITACQ)"
  },
  {
   value: "Acqui (ITACI)",
   label: "Acqui (ITACI)"
  },
  {
   value: "Adellino (ITADO)",
   label: "Adellino (ITADO)"
  },
  {
   value: "Adro (ITARO)",
   label: "Adro (ITARO)"
  },
  {
   value: "Afragola (ITAFR)",
   label: "Afragola (ITAFR)"
  },
  {
   value: "Agliana (ITAGL)",
   label: "Agliana (ITAGL)"
  },
  {
   value: "Agrigento (ITAGR)",
   label: "Agrigento (ITAGR)"
  },
  {
   value: "Airasca (ITAIA)",
   label: "Airasca (ITAIA)"
  },
  {
   value: "Ala (ITALA)",
   label: "Ala (ITALA)"
  },
  {
   value: "Albano Sant Alessandro (ITASA)",
   label: "Albano Sant Alessandro (ITASA)"
  },
  {
   value: "Albavilla (ITAVA)",
   label: "Albavilla (ITAVA)"
  },
  {
   value: "Albenga (ITALL)",
   label: "Albenga (ITALL)"
  },
  {
   value: "Albino (ITABN)",
   label: "Albino (ITABN)"
  },
  {
   value: "Albisola Marina (ITASM)",
   label: "Albisola Marina (ITASM)"
  },
  {
   value: "Albizzate (ITALB)",
   label: "Albizzate (ITALB)"
  },
  {
   value: "Alcamo (ITALC)",
   label: "Alcamo (ITALC)"
  },
  {
   value: "Aldino (ITADN)",
   label: "Aldino (ITADN)"
  },
  {
   value: "Alessandria (ITALE)",
   label: "Alessandria (ITALE)"
  },
  {
   value: "Alghero (ITAHO)",
   label: "Alghero (ITAHO)"
  },
  {
   value: "Aliano (ITANO)",
   label: "Aliano (ITANO)"
  },
  {
   value: "Alicudi (ITALI)",
   label: "Alicudi (ITALI)"
  },
  {
   value: "Alme (ITALM)",
   label: "Alme (ITALM)"
  },
  {
   value: "Altamura (ITATM)",
   label: "Altamura (ITATM)"
  },
  {
   value: "Altare (ITALT)",
   label: "Altare (ITALT)"
  },
  {
   value: "Grundartangi (ISGRT)",
   label: "Grundartangi (ISGRT)"
  },
  {
   value: "Gufunes\/Reykjavik (ISGUF)",
   label: "Gufunes\/Reykjavik (ISGUF)"
  },
  {
   value: "Hafnarfjørdur (ISHAF)",
   label: "Hafnarfjørdur (ISHAF)"
  },
  {
   value: "Hjalteyri (ISHJA)",
   label: "Hjalteyri (ISHJA)"
  },
  {
   value: "Hofsos (ISHOF)",
   label: "Hofsos (ISHOF)"
  },
  {
   value: "Holmavik (ISHVK)",
   label: "Holmavik (ISHVK)"
  },
  {
   value: "Hrisey (ISHRI)",
   label: "Hrisey (ISHRI)"
  },
  {
   value: "Husavik høfn (ISHUS)",
   label: "Husavik høfn (ISHUS)"
  },
  {
   value: "Hvalfjørdur (ISHVR)",
   label: "Hvalfjørdur (ISHVR)"
  },
  {
   value: "Hvammstangi (ISHVM)",
   label: "Hvammstangi (ISHVM)"
  },
  {
   value: "Isafjördur apt (ISIFJ)",
   label: "Isafjördur apt (ISIFJ)"
  },
  {
   value: "Isafjørdur høfn (ISISA)",
   label: "Isafjørdur høfn (ISISA)"
  },
  {
   value: "Keflavik (ISKEF)",
   label: "Keflavik (ISKEF)"
  },
  {
   value: "Keflavikurkaupstadur (ISKEV)",
   label: "Keflavikurkaupstadur (ISKEV)"
  },
  {
   value: "Kopasker høfn (ISKOP)",
   label: "Kopasker høfn (ISKOP)"
  },
  {
   value: "Kopavogur (ISKOV)",
   label: "Kopavogur (ISKOV)"
  },
  {
   value: "Krokfjardarnes (ISKRO)",
   label: "Krokfjardarnes (ISKRO)"
  },
  {
   value: "Mjofjördur (ISMJO)",
   label: "Mjofjördur (ISMJO)"
  },
  {
   value: "Myvatn (ISMVA)",
   label: "Myvatn (ISMVA)"
  },
  {
   value: "Neskaupstadur (ISNES)",
   label: "Neskaupstadur (ISNES)"
  },
  {
   value: "Njardvik (ISNJA)",
   label: "Njardvik (ISNJA)"
  },
  {
   value: "Nordurfjördur (ISNOU)",
   label: "Nordurfjördur (ISNOU)"
  },
  {
   value: "Olafsfjørdur (ISOLF)",
   label: "Olafsfjørdur (ISOLF)"
  },
  {
   value: "Olafsvik (ISOLV)",
   label: "Olafsvik (ISOLV)"
  },
  {
   value: "Ospakseyri (ISOSP)",
   label: "Ospakseyri (ISOSP)"
  },
  {
   value: "Patreksfjørdur høfn (ISPAT)",
   label: "Patreksfjørdur høfn (ISPAT)"
  },
  {
   value: "Raufarhøfn (ISRAU)",
   label: "Raufarhøfn (ISRAU)"
  },
  {
   value: "Reydarfjørdur (ISRFJ)",
   label: "Reydarfjørdur (ISRFJ)"
  },
  {
   value: "Reykholar (ISRHA)",
   label: "Reykholar (ISRHA)"
  },
  {
   value: "Reykjavik (ISREY)",
   label: "Reykjavik (ISREY)"
  },
  {
   value: "Rif-Hellisandur (ISRIF)",
   label: "Rif-Hellisandur (ISRIF)"
  },
  {
   value: "Sandgerdi (ISSAN)",
   label: "Sandgerdi (ISSAN)"
  },
  {
   value: "Saudarkrokur høfn (ISSAU)",
   label: "Saudarkrokur høfn (ISSAU)"
  },
  {
   value: "Selfoss (ISSEL)",
   label: "Selfoss (ISSEL)"
  },
  {
   value: "Selfoss apt (ISSFS)",
   label: "Selfoss apt (ISSFS)"
  },
  {
   value: "Seydisfjørdur (ISSEY)",
   label: "Seydisfjørdur (ISSEY)"
  },
  {
   value: "Siglufjørdur høfn (ISSIG)",
   label: "Siglufjørdur høfn (ISSIG)"
  },
  {
   value: "Skagastrond (ISSKA)",
   label: "Skagastrond (ISSKA)"
  },
  {
   value: "Sirjan (IRSRJ)",
   label: "Sirjan (IRSRJ)"
  },
  {
   value: "Sirri Island (IRSXI)",
   label: "Sirri Island (IRSXI)"
  },
  {
   value: "Tabas (IRTCX)",
   label: "Tabas (IRTCX)"
  },
  {
   value: "Tabriz (IRTBZ)",
   label: "Tabriz (IRTBZ)"
  },
  {
   value: "Tajabad (IRTAJ)",
   label: "Tajabad (IRTAJ)"
  },
  {
   value: "Tehran (IRTHR)",
   label: "Tehran (IRTHR)"
  },
  {
   value: "Urmieh (IROMH)",
   label: "Urmieh (IROMH)"
  },
  {
   value: "Yazd (IRAZD)",
   label: "Yazd (IRAZD)"
  },
  {
   value: "Zabol (IRACZ)",
   label: "Zabol (IRACZ)"
  },
  {
   value: "Zahedan (IRZAH)",
   label: "Zahedan (IRZAH)"
  },
  {
   value: "Akranes (ISAKR)",
   label: "Akranes (ISAKR)"
  },
  {
   value: "Akureyri (ISAKU)",
   label: "Akureyri (ISAKU)"
  },
  {
   value: "Akureyri apt (ISAEY)",
   label: "Akureyri apt (ISAEY)"
  },
  {
   value: "Bakkafjørdur (ISBAK)",
   label: "Bakkafjørdur (ISBAK)"
  },
  {
   value: "Bildudalur høfn (ISBIL)",
   label: "Bildudalur høfn (ISBIL)"
  },
  {
   value: "Bildudalur apt (ISBIU)",
   label: "Bildudalur apt (ISBIU)"
  },
  {
   value: "Blonduos (ISBLO)",
   label: "Blonduos (ISBLO)"
  },
  {
   value: "Bolungavik (ISBOL)",
   label: "Bolungavik (ISBOL)"
  },
  {
   value: "Bordeyri (ISBOI)",
   label: "Bordeyri (ISBOI)"
  },
  {
   value: "Borgarfjørdur eystri (ISBGJ)",
   label: "Borgarfjørdur eystri (ISBGJ)"
  },
  {
   value: "Borgarnes (ISBOR)",
   label: "Borgarnes (ISBOR)"
  },
  {
   value: "Breiddalsvik (ISBRE)",
   label: "Breiddalsvik (ISBRE)"
  },
  {
   value: "Budardalur \/ BUDIR (ISBUD)",
   label: "Budardalur \/ BUDIR (ISBUD)"
  },
  {
   value: "Dalvik (ISDAL)",
   label: "Dalvik (ISDAL)"
  },
  {
   value: "Djupavik (ISDPV)",
   label: "Djupavik (ISDPV)"
  },
  {
   value: "Djupivogur (ISDJU)",
   label: "Djupivogur (ISDJU)"
  },
  {
   value: "Drangsnes (ISDRA)",
   label: "Drangsnes (ISDRA)"
  },
  {
   value: "Egilsstadir (ISEGS)",
   label: "Egilsstadir (ISEGS)"
  },
  {
   value: "Eskifjørdur høfn (ISESK)",
   label: "Eskifjørdur høfn (ISESK)"
  },
  {
   value: "Eskifjørdur apt (ISEFJ)",
   label: "Eskifjørdur apt (ISEFJ)"
  },
  {
   value: "Fagurholsmyri (ISFAG)",
   label: "Fagurholsmyri (ISFAG)"
  },
  {
   value: "Faskrudsfjørdur (ISFAS)",
   label: "Faskrudsfjørdur (ISFAS)"
  },
  {
   value: "Flateyri (ISFLA)",
   label: "Flateyri (ISFLA)"
  },
  {
   value: "Flateyri apt (ISFLI)",
   label: "Flateyri apt (ISFLI)"
  },
  {
   value: "Gjogur (ISGJR)",
   label: "Gjogur (ISGJR)"
  },
  {
   value: "Grenivik (ISGRE)",
   label: "Grenivik (ISGRE)"
  },
  {
   value: "Grimsey (ISGRY)",
   label: "Grimsey (ISGRY)"
  },
  {
   value: "Grindavik (ISGRI)",
   label: "Grindavik (ISGRI)"
  },
  {
   value: "Grundarfjørdur (ISGRF)",
   label: "Grundarfjørdur (ISGRF)"
  },
  {
   value: "Gheshm (IRGSM)",
   label: "Gheshm (IRGSM)"
  },
  {
   value: "Hamadan (IRHDM)",
   label: "Hamadan (IRHDM)"
  },
  {
   value: "Harta Point (IRHTP)",
   label: "Harta Point (IRHTP)"
  },
  {
   value: "Henjam (IRHEJ)",
   label: "Henjam (IRHEJ)"
  },
  {
   value: "Hormuz (IRHOR)",
   label: "Hormuz (IRHOR)"
  },
  {
   value: "Imam Hasan (IRIMH)",
   label: "Imam Hasan (IRIMH)"
  },
  {
   value: "Isfahan (IRIFN)",
   label: "Isfahan (IRIFN)"
  },
  {
   value: "Jask (IRJAK)",
   label: "Jask (IRJAK)"
  },
  {
   value: "Kangan (IRKNR)",
   label: "Kangan (IRKNR)"
  },
  {
   value: "Karaj (IRQKC)",
   label: "Karaj (IRQKC)"
  },
  {
   value: "Kashan (IRKAS)",
   label: "Kashan (IRKAS)"
  },
  {
   value: "Kerman (IRKER)",
   label: "Kerman (IRKER)"
  },
  {
   value: "Kermanshah (Baktharan) (IRKSH)",
   label: "Kermanshah (Baktharan) (IRKSH)"
  },
  {
   value: "Khaneh (IRKHA)",
   label: "Khaneh (IRKHA)"
  },
  {
   value: "Khark Island (IRKHK)",
   label: "Khark Island (IRKHK)"
  },
  {
   value: "Khorramabad (IRKHD)",
   label: "Khorramabad (IRKHD)"
  },
  {
   value: "Khorramshahr (IRKHO)",
   label: "Khorramshahr (IRKHO)"
  },
  {
   value: "Khosravi (IRKHS)",
   label: "Khosravi (IRKHS)"
  },
  {
   value: "Kish Island (IRKIH)",
   label: "Kish Island (IRKIH)"
  },
  {
   value: "Lar (IRLRR)",
   label: "Lar (IRLRR)"
  },
  {
   value: "Lavan (IRLVP)",
   label: "Lavan (IRLVP)"
  },
  {
   value: "Lingah (IRLIN)",
   label: "Lingah (IRLIN)"
  },
  {
   value: "Mashad (IRMHD)",
   label: "Mashad (IRMHD)"
  },
  {
   value: "Mosul (IROSM)",
   label: "Mosul (IROSM)"
  },
  {
   value: "Now Shahr (IRNSH)",
   label: "Now Shahr (IRNSH)"
  },
  {
   value: "Orumiyeh (IRORU)",
   label: "Orumiyeh (IRORU)"
  },
  {
   value: "Persepolis (IRWPS)",
   label: "Persepolis (IRWPS)"
  },
  {
   value: "Qeshm (IRQSM)",
   label: "Qeshm (IRQSM)"
  },
  {
   value: "Qeshm island (IRQSH)",
   label: "Qeshm island (IRQSH)"
  },
  {
   value: "Qum (IRQUM)",
   label: "Qum (IRQUM)"
  },
  {
   value: "Rafsanjan (IRRJN)",
   label: "Rafsanjan (IRRJN)"
  },
  {
   value: "Ramsar (IRRZR)",
   label: "Ramsar (IRRZR)"
  },
  {
   value: "Ras Bahrgan (IRRBA)",
   label: "Ras Bahrgan (IRRBA)"
  },
  {
   value: "Rasht (IRRAS)",
   label: "Rasht (IRRAS)"
  },
  {
   value: "Ratawi (IRRTM)",
   label: "Ratawi (IRRTM)"
  },
  {
   value: "Samawa (IRSMW)",
   label: "Samawa (IRSMW)"
  },
  {
   value: "Sanandaj (IRSDG)",
   label: "Sanandaj (IRSDG)"
  },
  {
   value: "Sarakhs (IRCKT)",
   label: "Sarakhs (IRCKT)"
  },
  {
   value: "Sari (IRSIX)",
   label: "Sari (IRSIX)"
  },
  {
   value: "Sary (IRSRY)",
   label: "Sary (IRSRY)"
  },
  {
   value: "Saveh (IRSVH)",
   label: "Saveh (IRSVH)"
  },
  {
   value: "Shiraz (IRSYZ)",
   label: "Shiraz (IRSYZ)"
  },
  {
   value: "Shyah Bander (IRSHB)",
   label: "Shyah Bander (IRSHB)"
  },
  {
   value: "Mosul (IQOSM)",
   label: "Mosul (IQOSM)"
  },
  {
   value: "Najat (IQNAS)",
   label: "Najat (IQNAS)"
  },
  {
   value: "Nassiriyah (IQNRH)",
   label: "Nassiriyah (IQNRH)"
  },
  {
   value: "Numaniya (IQNMA)",
   label: "Numaniya (IQNMA)"
  },
  {
   value: "Ramadi (IQRMD)",
   label: "Ramadi (IQRMD)"
  },
  {
   value: "Ratawi (IQRTM)",
   label: "Ratawi (IQRTM)"
  },
  {
   value: "Samara (IQSAM)",
   label: "Samara (IQSAM)"
  },
  {
   value: "Samawa (As-Samawah) (IQSMW)",
   label: "Samawa (As-Samawah) (IQSMW)"
  },
  {
   value: "Shuaiba (IQSBA)",
   label: "Shuaiba (IQSBA)"
  },
  {
   value: "Sulaimaniyah (IQSYH)",
   label: "Sulaimaniyah (IQSYH)"
  },
  {
   value: "Tikrit (IQTKT)",
   label: "Tikrit (IQTKT)"
  },
  {
   value: "Umm Qasr (IQUQR)",
   label: "Umm Qasr (IQUQR)"
  },
  {
   value: "Abadan (IRABD)",
   label: "Abadan (IRABD)"
  },
  {
   value: "Ahwaz (IRAWZ)",
   label: "Ahwaz (IRAWZ)"
  },
  {
   value: "Al Uzsayr (IRUZA)",
   label: "Al Uzsayr (IRUZA)"
  },
  {
   value: "Amara (IRAMR)",
   label: "Amara (IRAMR)"
  },
  {
   value: "Ardabil (IRADU)",
   label: "Ardabil (IRADU)"
  },
  {
   value: "Astara (IRASR)",
   label: "Astara (IRASR)"
  },
  {
   value: "Babolsar (IRBBL)",
   label: "Babolsar (IRBBL)"
  },
  {
   value: "Bahregan (IRIAQ)",
   label: "Bahregan (IRIAQ)"
  },
  {
   value: "Bajgiran (IRBAJ)",
   label: "Bajgiran (IRBAJ)"
  },
  {
   value: "Bam (IRBXR)",
   label: "Bam (IRBXR)"
  },
  {
   value: "Bandar Abbas (IRBND)",
   label: "Bandar Abbas (IRBND)"
  },
  {
   value: "Bandar Anzali (IRBAZ)",
   label: "Bandar Anzali (IRBAZ)"
  },
  {
   value: "Bandar Khomeini (IRBKM)",
   label: "Bandar Khomeini (IRBKM)"
  },
  {
   value: "Bandar Lengeh (IRBDH)",
   label: "Bandar Lengeh (IRBDH)"
  },
  {
   value: "Bandar Mahshahr (IRMRX)",
   label: "Bandar Mahshahr (IRMRX)"
  },
  {
   value: "Bandar Mashur (IRBMR)",
   label: "Bandar Mashur (IRBMR)"
  },
  {
   value: "Bandar Shahid Rejaie (IRBSR)",
   label: "Bandar Shahid Rejaie (IRBSR)"
  },
  {
   value: "Bandar Shahpour (IRBPR)",
   label: "Bandar Shahpour (IRBPR)"
  },
  {
   value: "Bandar-e Gaz (IRBRG)",
   label: "Bandar-e Gaz (IRBRG)"
  },
  {
   value: "Basargan (IRDGN)",
   label: "Basargan (IRDGN)"
  },
  {
   value: "Birjand (IRXBJ)",
   label: "Birjand (IRXBJ)"
  },
  {
   value: "Bojnord (IRBJB)",
   label: "Bojnord (IRBJB)"
  },
  {
   value: "Bushehr (IRBUZ)",
   label: "Bushehr (IRBUZ)"
  },
  {
   value: "Chah-Bahar (IRZBR)",
   label: "Chah-Bahar (IRZBR)"
  },
  {
   value: "Cyrus Terminal (IRCYT)",
   label: "Cyrus Terminal (IRCYT)"
  },
  {
   value: "Djulfa (Jolfa (IRDJU)",
   label: "Djulfa (Jolfa (IRDJU)"
  },
  {
   value: "Esfahan (IRESF)",
   label: "Esfahan (IRESF)"
  },
  {
   value: "Ghazvin (Qazwin) (IRGHA)",
   label: "Ghazvin (Qazwin) (IRGHA)"
  },
  {
   value: "Trombay (INTMP1)",
   label: "Trombay (INTMP1)"
  },
  {
   value: "Thana (INTNA1)",
   label: "Thana (INTNA1)"
  },
  {
   value: "Tondi (INTND1)",
   label: "Tondi (INTND1)"
  },
  {
   value: "Tungi (INTNG8)",
   label: "Tungi (INTNG8)"
  },
  {
   value: "Tankari (INTNK1)",
   label: "Tankari (INTNK1)"
  },
  {
   value: "Thopputhurai (INTPH1)",
   label: "Thopputhurai (INTPH1)"
  },
  {
   value: "Talpona (INTPN1)",
   label: "Talpona (INTPN1)"
  },
  {
   value: "Tarapur (INTRP1)",
   label: "Tarapur (INTRP1)"
  },
  {
   value: "T.T. Shed (Kidderpore) (INTTS8)",
   label: "T.T. Shed (Kidderpore) (INTTS8)"
  },
  {
   value: "Ultapani (INULP8)",
   label: "Ultapani (INULP8)"
  },
  {
   value: "Ulwa (INULW1)",
   label: "Ulwa (INULW1)"
  },
  {
   value: "Umarsadi (INUMR1)",
   label: "Umarsadi (INUMR1)"
  },
  {
   value: "Uttan (INUTN1)",
   label: "Uttan (INUTN1)"
  },
  {
   value: "Vengurla (INVNG1)",
   label: "Vengurla (INVNG1)"
  },
  {
   value: "Varavda (INVRD1)",
   label: "Varavda (INVRD1)"
  },
  {
   value: "Vadarevu (INVRU1)",
   label: "Vadarevu (INVRU1)"
  },
  {
   value: "Varsova (INVSV1)",
   label: "Varsova (INVSV1)"
  },
  {
   value: "Vijaydurg (INVYD1)",
   label: "Vijaydurg (INVYD1)"
  },
  {
   value: "Abu Al Fulus (IQALF)",
   label: "Abu Al Fulus (IQALF)"
  },
  {
   value: "Abu Al Khasib (IQALK)",
   label: "Abu Al Khasib (IQALK)"
  },
  {
   value: "Al Kut (IQKUT)",
   label: "Al Kut (IQKUT)"
  },
  {
   value: "Al Uzayr (IQUZA)",
   label: "Al Uzayr (IQUZA)"
  },
  {
   value: "Al Zubair (IQZUB)",
   label: "Al Zubair (IQZUB)"
  },
  {
   value: "Amara (Al-Amarah) (IQAMA)",
   label: "Amara (Al-Amarah) (IQAMA)"
  },
  {
   value: "Arak (IQARK)",
   label: "Arak (IQARK)"
  },
  {
   value: "Arbil (IQABL)",
   label: "Arbil (IQABL)"
  },
  {
   value: "Baghdad (IQBGW)",
   label: "Baghdad (IQBGW)"
  },
  {
   value: "Baigi (IQBAI)",
   label: "Baigi (IQBAI)"
  },
  {
   value: "Basra (IQBSR)",
   label: "Basra (IQBSR)"
  },
  {
   value: "Diwaniyah (IQDIW)",
   label: "Diwaniyah (IQDIW)"
  },
  {
   value: "Dohuk (IQDOK)",
   label: "Dohuk (IQDOK)"
  },
  {
   value: "Falluja (IQFAL)",
   label: "Falluja (IQFAL)"
  },
  {
   value: "Fao (IQFAO)",
   label: "Fao (IQFAO)"
  },
  {
   value: "Hillah (IQHIL)",
   label: "Hillah (IQHIL)"
  },
  {
   value: "Hindiya (IQHND)",
   label: "Hindiya (IQHND)"
  },
  {
   value: "Hit (IQHIT)",
   label: "Hit (IQHIT)"
  },
  {
   value: "Iskandariyha (IQIKD)",
   label: "Iskandariyha (IQIKD)"
  },
  {
   value: "Karbala (IQKAR)",
   label: "Karbala (IQKAR)"
  },
  {
   value: "Khor Al Amaya (IQKHA)",
   label: "Khor Al Amaya (IQKHA)"
  },
  {
   value: "Khor al Zubair (IQKAZ)",
   label: "Khor al Zubair (IQKAZ)"
  },
  {
   value: "Kirkuk (IQKIK)",
   label: "Kirkuk (IQKIK)"
  },
  {
   value: "Kufa (IQKFA)",
   label: "Kufa (IQKFA)"
  },
  {
   value: "Mandali (IQMAN)",
   label: "Mandali (IQMAN)"
  },
  {
   value: "Mawsil (IQMAW)",
   label: "Mawsil (IQMAW)"
  },
  {
   value: "Mina Al Bakir (IQMAB)",
   label: "Mina Al Bakir (IQMAB)"
  },
  {
   value: "\"Navabunder(with its sub-ports):(I) Sima (INNVB1)",
   label: "\"Navabunder(with its sub-ports):(I) Sima (INNVB1)"
  },
  {
   value: "Navaspur (INNVP1)",
   label: "Navaspur (INNVP1)"
  },
  {
   value: "Nivti (INNVT1)",
   label: "Nivti (INNVT1)"
  },
  {
   value: "Newapur (INNWP1)",
   label: "Newapur (INNWP1)"
  },
  {
   value: "Onjal (INONJ1)",
   label: "Onjal (INONJ1)"
  },
  {
   value: "Phulbari (INPHB8)",
   label: "Phulbari (INPHB8)"
  },
  {
   value: "Pamban (INPMB1)",
   label: "Pamban (INPMB1)"
  },
  {
   value: "Panjim (INPNJ1)",
   label: "Panjim (INPNJ1)"
  },
  {
   value: "Ponnani (INPNN1)",
   label: "Ponnani (INPNN1)"
  },
  {
   value: "Panitanki(Naxalbari) (INPNT8)",
   label: "Panitanki(Naxalbari) (INPNT8)"
  },
  {
   value: "Pellet Plant Jetty at Shiroda (INPPJ1)",
   label: "Pellet Plant Jetty at Shiroda (INPPJ1)"
  },
  {
   value: "Purangad (INPRG1)",
   label: "Purangad (INPRG1)"
  },
  {
   value: "Palshet (INPSH1)",
   label: "Palshet (INPSH1)"
  },
  {
   value: "Portonovo (INPTN1)",
   label: "Portonovo (INPTN1)"
  },
  {
   value: "Petrapole Road (INPTP8)",
   label: "Petrapole Road (INPTP8)"
  },
  {
   value: "Radhikapur Railway Station (INRDP2)",
   label: "Radhikapur Railway Station (INRDP2)"
  },
  {
   value: "Old Raghna Bazar (INRGB8)",
   label: "Old Raghna Bazar (INRGB8)"
  },
  {
   value: "Ranghat Bay (INRGT1)",
   label: "Ranghat Bay (INRGT1)"
  },
  {
   value: "Ryngku (INRGU8)",
   label: "Ryngku (INRGU8)"
  },
  {
   value: "Rajpara (INRJP1)",
   label: "Rajpara (INRJP1)"
  },
  {
   value: "Rajpuri (INRJR1)",
   label: "Rajpuri (INRJR1)"
  },
  {
   value: "Rajakkamangalam (INRKG1)",
   label: "Rajakkamangalam (INRKG1)"
  },
  {
   value: "Ranaghat Railway Station (INRNG2)",
   label: "Ranaghat Railway Station (INRNG2)"
  },
  {
   value: "Rameshwaram (INRWR1)",
   label: "Rameshwaram (INRWR1)"
  },
  {
   value: "Raxaul (INRXL8)",
   label: "Raxaul (INRXL8)"
  },
  {
   value: "Sabroom (INSAB8)",
   label: "Sabroom (INSAB8)"
  },
  {
   value: "Sinbhour (INSBH1)",
   label: "Sinbhour (INSBH1)"
  },
  {
   value: "Shella Bazar (INSBZ8)",
   label: "Shella Bazar (INSBZ8)"
  },
  {
   value: "Sinbhour Port (INSHP1)",
   label: "Sinbhour Port (INSHP1)"
  },
  {
   value: "Sukhia Pokhari (INSKP8)",
   label: "Sukhia Pokhari (INSKP8)"
  },
  {
   value: "Silcher R.M.S. Office (INSLR2)",
   label: "Silcher R.M.S. Office (INSLR2)"
  },
  {
   value: "Silcher Steamerghat (INSLR8)",
   label: "Silcher Steamerghat (INSLR8)"
  },
  {
   value: "Srimantapur (INSMP8)",
   label: "Srimantapur (INSMP8)"
  },
  {
   value: "Simor (INSMR1)",
   label: "Simor (INSMR1)"
  },
  {
   value: "Sonabarsa (INSNB8)",
   label: "Sonabarsa (INSNB8)"
  },
  {
   value: "Singabad Railway Station (INSNG2)",
   label: "Singabad Railway Station (INSNG2)"
  },
  {
   value: "Sonauli (INSNL8)",
   label: "Sonauli (INSNL8)"
  },
  {
   value: "Surasani-Yanam (INSRV1)",
   label: "Surasani-Yanam (INSRV1)"
  },
  {
   value: "Sitai (INSTI8)",
   label: "Sitai (INSTI8)"
  },
  {
   value: "Satpati (INSTP1)",
   label: "Satpati (INSTP1)"
  },
  {
   value: "Sutarkandi (INSTR8)",
   label: "Sutarkandi (INSTR8)"
  },
  {
   value: "Shriwardhan (INSWD1)",
   label: "Shriwardhan (INSWD1)"
  },
  {
   value: "Thal (INTHL1)",
   label: "Thal (INTHL1)"
  },
  {
   value: "Tezpur Steamerghat (INTJP8)",
   label: "Tezpur Steamerghat (INTJP8)"
  },
  {
   value: "Tikonia (INTKN8)",
   label: "Tikonia (INTKN8)"
  },
  {
   value: "Kilakari (INKKR1)",
   label: "Kilakari (INKKR1)"
  },
  {
   value: "Kalyan (INKLY1)",
   label: "Kalyan (INKLY1)"
  },
  {
   value: "Kumbharu (INKMB1)",
   label: "Kumbharu (INKMB1)"
  },
  {
   value: "Kankudy (INKND1)",
   label: "Kankudy (INKND1)"
  },
  {
   value: "Kunauli (INKNL8)",
   label: "Kunauli (INKNL8)"
  },
  {
   value: "Karanja (INKRN1)",
   label: "Karanja (INKRN1)"
  },
  {
   value: "Kiranpani (INKRP1)",
   label: "Kiranpani (INKRP1)"
  },
  {
   value: "Kasargod (INKSG1)",
   label: "Kasargod (INKSG1)"
  },
  {
   value: "Kelshi (INKSH1)",
   label: "Kelshi (INKSH1)"
  },
  {
   value: "Kulasekarapatnam (INKSP1)",
   label: "Kulasekarapatnam (INKSP1)"
  },
  {
   value: "Kotda (INKTD1)",
   label: "Kotda (INKTD1)"
  },
  {
   value: "Katarniyaghat (INKTG8)",
   label: "Katarniyaghat (INKTG8)"
  },
  {
   value: "Kiltan Island (INKTI1)",
   label: "Kiltan Island (INKTI1)"
  },
  {
   value: "Kathihar (INKTR8)",
   label: "Kathihar (INKTR8)"
  },
  {
   value: "Koteshwar (INKTW1)",
   label: "Koteshwar (INKTW1)"
  },
  {
   value: "Kavi (INKVI1)",
   label: "Kavi (INKVI1)"
  },
  {
   value: "Kovalam (INKVL1)",
   label: "Kovalam (INKVL1)"
  },
  {
   value: "Kavaratti Island (INKVT1)",
   label: "Kavaratti Island (INKVT1)"
  },
  {
   value: "Khunwa (INKWA8)",
   label: "Khunwa (INKWA8)"
  },
  {
   value: "Khowaighat (INKWG8)",
   label: "Khowaighat (INKWG8)"
  },
  {
   value: "Karimganj Railway Station (INKXJ2)",
   label: "Karimganj Railway Station (INKXJ2)"
  },
  {
   value: "Lalgola Town (INLGL8)",
   label: "Lalgola Town (INLGL8)"
  },
  {
   value: "Leapuram (INLPR1)",
   label: "Leapuram (INLPR1)"
  },
  {
   value: "Latu Bazar (INLTB8)",
   label: "Latu Bazar (INLTB8)"
  },
  {
   value: "Meadows (INMDW1)",
   label: "Meadows (INMDW1)"
  },
  {
   value: "Mahendraganj (INMGH8)",
   label: "Mahendraganj (INMGH8)"
  },
  {
   value: "Kotawalighat (Mohedipur) (INMHD8)",
   label: "Kotawalighat (Mohedipur) (INMHD8)"
  },
  {
   value: "Mahe (INMHE1)",
   label: "Mahe (INMHE1)"
  },
  {
   value: "Mahurighat (INMHG8)",
   label: "Mahurighat (INMHG8)"
  },
  {
   value: "Mahisashan Railway Station (INMHN2)",
   label: "Mahisashan Railway Station (INMHN2)"
  },
  {
   value: "Manikarchar (INMKC8)",
   label: "Manikarchar (INMKC8)"
  },
  {
   value: "Mallipuram (INMLP1)",
   label: "Mallipuram (INMLP1)"
  },
  {
   value: "Malwan (INMLW1)",
   label: "Malwan (INMLW1)"
  },
  {
   value: "Munabao Railway Station (INMNB2)",
   label: "Munabao Railway Station (INMNB2)"
  },
  {
   value: "Manori (INMNR1)",
   label: "Manori (INMNR1)"
  },
  {
   value: "Mandwa (INMNW1)",
   label: "Mandwa (INMNW1)"
  },
  {
   value: "Mora (INMRA1)",
   label: "Mora (INMRA1)"
  },
  {
   value: "Murad (INMRD1)",
   label: "Murad (INMRD1)"
  },
  {
   value: "Moreh (INMRE8)",
   label: "Moreh (INMRE8)"
  },
  {
   value: "Metwad (INMTW1)",
   label: "Metwad (INMTW1)"
  },
  {
   value: "Mayabandar (INMYB1)",
   label: "Mayabandar (INMYB1)"
  },
  {
   value: "Nandgaon (INNDG1)",
   label: "Nandgaon (INNDG1)"
  },
  {
   value: "Nepalgunj Road (INNGR8)",
   label: "Nepalgunj Road (INNGR8)"
  },
  {
   value: "Village Namgaya Shipkila (INNGS8)",
   label: "Village Namgaya Shipkila (INNGS8)"
  },
  {
   value: "Namkhana (INNKN8)",
   label: "Namkhana (INNKN8)"
  },
  {
   value: "Neamati steamer Ghat (INNMT8)",
   label: "Neamati steamer Ghat (INNMT8)"
  },
  {
   value: "Nampong (INNPG8)",
   label: "Nampong (INNPG8)"
  },
  {
   value: "Dhalaighat (INDHL8)",
   label: "Dhalaighat (INDHL8)"
  },
  {
   value: "Dahanu (INDHN1)",
   label: "Dahanu (INDHN1)"
  },
  {
   value: "Dholera (INDHR1)",
   label: "Dholera (INDHR1)"
  },
  {
   value: "Dharchula (INDLA8)",
   label: "Dharchula (INDLA8)"
  },
  {
   value: "Delhi Railway Station (INDLI2)",
   label: "Delhi Railway Station (INDLI2)"
  },
  {
   value: "Dalu (INDLU8)",
   label: "Dalu (INDLU8)"
  },
  {
   value: "Demagir (INDMR8)",
   label: "Demagir (INDMR8)"
  },
  {
   value: "Darranga (INDRG8)",
   label: "Darranga (INDRG8)"
  },
  {
   value: "Dwarka (Rupen) (INDRK1)",
   label: "Dwarka (Rupen) (INDRK1)"
  },
  {
   value: "Dhanu-shkodi (INDSK1)",
   label: "Dhanu-shkodi (INDSK1)"
  },
  {
   value: "Dantiwara (INDTW1)",
   label: "Dantiwara (INDTW1)"
  },
  {
   value: "Dawki (INDWK8)",
   label: "Dawki (INDWK8)"
  },
  {
   value: "Elphinstone Harbour (INESH1)",
   label: "Elphinstone Harbour (INESH1)"
  },
  {
   value: "Gauriphanta (INGAI8)",
   label: "Gauriphanta (INGAI8)"
  },
  {
   value: "Galgalia (INGAL8)",
   label: "Galgalia (INGAL8)"
  },
  {
   value: "Gede Railway Station (INGED2)",
   label: "Gede Railway Station (INGED2)"
  },
  {
   value: "Ghogha (INGHA1)",
   label: "Ghogha (INGHA1)"
  },
  {
   value: "Ghasuapara (INGHP8)",
   label: "Ghasuapara (INGHP8)"
  },
  {
   value: "Gauhati Steamerghat (INGHW8)",
   label: "Gauhati Steamerghat (INGHW8)"
  },
  {
   value: "Gunji (INGJI8)",
   label: "Gunji (INGJI8)"
  },
  {
   value: "Ghojadanga (INGJX8)",
   label: "Ghojadanga (INGJX8)"
  },
  {
   value: "Golakganj Railway Station (INGKJ2)",
   label: "Golakganj Railway Station (INGKJ2)"
  },
  {
   value: "Gitaldah road (INGTG8)",
   label: "Gitaldah road (INGTG8)"
  },
  {
   value: "Getandah (INGTZ8)",
   label: "Getandah (INGTZ8)"
  },
  {
   value: "Hingalganj (INHGL8)",
   label: "Hingalganj (INHGL8)"
  },
  {
   value: "Hangarkatta (INHGT1)",
   label: "Hangarkatta (INHGT1)"
  },
  {
   value: "Haldibari Railway Station (INHLD2)",
   label: "Haldibari Railway Station (INHLD2)"
  },
  {
   value: "Hilli (INHLI8)",
   label: "Hilli (INHLI8)"
  },
  {
   value: "Harnai (INHRN1)",
   label: "Harnai (INHRN1)"
  },
  {
   value: "Hatisar (INHTS8)",
   label: "Hatisar (INHTS8)"
  },
  {
   value: "Honawar (INHWR1)",
   label: "Honawar (INHWR1)"
  },
  {
   value: "Jayanagar (INJAY8)",
   label: "Jayanagar (INJAY8)"
  },
  {
   value: "Jogbani (INJBN8)",
   label: "Jogbani (INJBN8)"
  },
  {
   value: "Jaigad (INJGD1)",
   label: "Jaigad (INJGD1)"
  },
  {
   value: "Jhulaghat (Pithoragarh) (INJHO8)",
   label: "Jhulaghat (Pithoragarh) (INJHO8)"
  },
  {
   value: "Jaigaon (INJIG8)",
   label: "Jaigaon (INJIG8)"
  },
  {
   value: "Jalpaiguri (INJPG8)",
   label: "Jalpaiguri (INJPG8)"
  },
  {
   value: "Jaitapur (INJTP1)",
   label: "Jaitapur (INJTP1)"
  },
  {
   value: "Jarwa (INJWA8)",
   label: "Jarwa (INJWA8)"
  },
  {
   value: "Kallai (INKAL1)",
   label: "Kallai (INKAL1)"
  },
  {
   value: "Kadmat Island (INKDI1)",
   label: "Kadmat Island (INKDI1)"
  },
  {
   value: "Kodinar(Muldwarka) (INKDN1)",
   label: "Kodinar(Muldwarka) (INKDN1)"
  },
  {
   value: "Kondiapetnam (INKDP1)",
   label: "Kondiapetnam (INKDP1)"
  },
  {
   value: "Kel Sahar Subdivision (INKEL8)",
   label: "Kel Sahar Subdivision (INKEL8)"
  },
  {
   value: "Karimganj Steamerghat (INKGJ8)",
   label: "Karimganj Steamerghat (INKGJ8)"
  },
  {
   value: "Kelwa (INKIW1)",
   label: "Kelwa (INKIW1)"
  },
  {
   value: "Agartala (INAGT8)",
   label: "Agartala (INAGT8)"
  },
  {
   value: "Amini Island (INAMI1)",
   label: "Amini Island (INAMI1)"
  },
  {
   value: "Anijengo (INANG1)",
   label: "Anijengo (INANG1)"
  },
  {
   value: "Arnala (INANL1)",
   label: "Arnala (INANL1)"
  },
  {
   value: "Amritsar Railway Station (INASR2)",
   label: "Amritsar Railway Station (INASR2)"
  },
  {
   value: "Attari Road (INATR8)",
   label: "Attari Road (INATR8)"
  },
  {
   value: "Attari Railway Station (INATT2)",
   label: "Attari Railway Station (INATT2)"
  },
  {
   value: "Badagara (INBDG1)",
   label: "Badagara (INBDG1)"
  },
  {
   value: "Baindur (INBDR1)",
   label: "Baindur (INBDR1)"
  },
  {
   value: "Baghmara (INBGM8)",
   label: "Baghmara (INBGM8)"
  },
  {
   value: "Bairgania (INBGU8)",
   label: "Bairgania (INBGU8)"
  },
  {
   value: "Bhagwa (INBGW1)",
   label: "Bhagwa (INBGW1)"
  },
  {
   value: "Belekeri (INBKR1)",
   label: "Belekeri (INBKR1)"
  },
  {
   value: "Bankot (INBKT1)",
   label: "Bankot (INBKT1)"
  },
  {
   value: "Bilimora (INBLM1)",
   label: "Bilimora (INBLM1)"
  },
  {
   value: "Belapur (INBLP1)",
   label: "Belapur (INBLP1)"
  },
  {
   value: "Balet (INBLT8)",
   label: "Balet (INBLT8)"
  },
  {
   value: "Barmer Railway Station (INBMR2)",
   label: "Barmer Railway Station (INBMR2)"
  },
  {
   value: "Bandra (INBND1)",
   label: "Bandra (INBND1)"
  },
  {
   value: "Bheemunipatnam (INBNP1)",
   label: "Bheemunipatnam (INBNP1)"
  },
  {
   value: "Bhimnagar (INBNR8)",
   label: "Bhimnagar (INBNR8)"
  },
  {
   value: "Berhni (INBNY8)",
   label: "Berhni (INBNY8)"
  },
  {
   value: "Bolanganj (INBOL8)",
   label: "Bolanganj (INBOL8)"
  },
  {
   value: "Barsora (INBRA8)",
   label: "Barsora (INBRA8)"
  },
  {
   value: "Borlai – Mandla (INBRM1)",
   label: "Borlai – Mandla (INBRM1)"
  },
  {
   value: "Borya (INBRY1)",
   label: "Borya (INBRY1)"
  },
  {
   value: "Banbasa (INBSA8)",
   label: "Banbasa (INBSA8)"
  },
  {
   value: "Bassein (INBSN1)",
   label: "Bassein (INBSN1)"
  },
  {
   value: "Bulsar (INBSR1)",
   label: "Bulsar (INBSR1)"
  },
  {
   value: "Bhatkal (INBTK1)",
   label: "Bhatkal (INBTK1)"
  },
  {
   value: "Bhithamore(Sursnad) (INBTM8)",
   label: "Bhithamore(Sursnad) (INBTM8)"
  },
  {
   value: "Bitra Island (INBTR1)",
   label: "Bitra Island (INBTR1)"
  },
  {
   value: "Bhiwandi (INBWN1)",
   label: "Bhiwandi (INBWN1)"
  },
  {
   value: "Beyt (INBYT1)",
   label: "Beyt (INBYT1)"
  },
  {
   value: "Changrabandh (INCBD8)",
   label: "Changrabandh (INCBD8)"
  },
  {
   value: "Coondapur (Ganguly) (INCDP1)",
   label: "Coondapur (Ganguly) (INCDP1)"
  },
  {
   value: "Colachel (INCHL1)",
   label: "Colachel (INCHL1)"
  },
  {
   value: "Chamurchi (INCHM8)",
   label: "Chamurchi (INCHM8)"
  },
  {
   value: "Champai (INCHP8)",
   label: "Champai (INCHP8)"
  },
  {
   value: "Chapora (INCHR1)",
   label: "Chapora (INCHR1)"
  },
  {
   value: "Cambay (INCMB1)",
   label: "Cambay (INCMB1)"
  },
  {
   value: "Car-Nicobar (INCNB1)",
   label: "Car-Nicobar (INCNB1)"
  },
  {
   value: "Cannanore (INCNN1)",
   label: "Cannanore (INCNN1)"
  },
  {
   value: "Cornwallis (INCRN1)",
   label: "Cornwallis (INCRN1)"
  },
  {
   value: "Chetlat Island (INCTI1)",
   label: "Chetlat Island (INCTI1)"
  },
  {
   value: "Deogad (INDEG1)",
   label: "Deogad (INDEG1)"
  },
  {
   value: "Dhubri Steamerghat (INDHB8)",
   label: "Dhubri Steamerghat (INDHB8)"
  },
  {
   value: "Tadri (INTAD1)",
   label: "Tadri (INTAD1)"
  },
  {
   value: "Talaja (INTJA1)",
   label: "Talaja (INTJA1)"
  },
  {
   value: "Tellicherry (INTEL1)",
   label: "Tellicherry (INTEL1)"
  },
  {
   value: "Tezpur (INTEZ4)",
   label: "Tezpur (INTEZ4)"
  },
  {
   value: "Tezu (INTEI4)",
   label: "Tezu (INTEI4)"
  },
  {
   value: "Thanjavur (INTJV4)",
   label: "Thanjavur (INTJV4)"
  },
  {
   value: "Thiruvananthapuram (Ex Trivandrum (INTRV4)",
   label: "Thiruvananthapuram (Ex Trivandrum (INTRV4)"
  },
  {
   value: "Tiruchirapalli (INTRZ4)",
   label: "Tiruchirapalli (INTRZ4)"
  },
  {
   value: "Tirukkadayyur (INTYR1)",
   label: "Tirukkadayyur (INTYR1)"
  },
  {
   value: "Tirupati (INTIR4)",
   label: "Tirupati (INTIR4)"
  },
  {
   value: "Tirupur (INTUP6)",
   label: "Tirupur (INTUP6)"
  },
  {
   value: "Tirupur (INTUP3)",
   label: "Tirupur (INTUP3)"
  },
  {
   value: "Tiviri (INTIV1)",
   label: "Tiviri (INTIV1)"
  },
  {
   value: "Tranquebar (INTRA1)",
   label: "Tranquebar (INTRA1)"
  },
  {
   value: "Tuglakabad (INTKD2)",
   label: "Tuglakabad (INTKD2)"
  },
  {
   value: "Tuglakabad (INTKD9)",
   label: "Tuglakabad (INTKD9)"
  },
  {
   value: "Tuna (INTUN1)",
   label: "Tuna (INTUN1)"
  },
  {
   value: "Tuticorin (INTUT1)",
   label: "Tuticorin (INTUT1)"
  },
  {
   value: "Udaipur (INUDR4)",
   label: "Udaipur (INUDR4)"
  },
  {
   value: "Udaipur (INUDR6)",
   label: "Udaipur (INUDR6)"
  },
  {
   value: "Umbergoan (INUMB1)",
   label: "Umbergoan (INUMB1)"
  },
  {
   value: "Vadinar (INVAD1)",
   label: "Vadinar (INVAD1)"
  },
  {
   value: "Vadodara (INBDQ1)",
   label: "Vadodara (INBDQ1)"
  },
  {
   value: "Valinokkam (INVKM1)",
   label: "Valinokkam (INVKM1)"
  },
  {
   value: "Vansi-Borsi (INVSI1)",
   label: "Vansi-Borsi (INVSI1)"
  },
  {
   value: "Varanasi (INVNS4)",
   label: "Varanasi (INVNS4)"
  },
  {
   value: "Varanasi (INVNS6)",
   label: "Varanasi (INVNS6)"
  },
  {
   value: "Vazhinjam (INVZJ1)",
   label: "Vazhinjam (INVZJ1)"
  },
  {
   value: "Vengurla (INVEN1)",
   label: "Vengurla (INVEN1)"
  },
  {
   value: "Veppalodai (INVEP1)",
   label: "Veppalodai (INVEP1)"
  },
  {
   value: "Veraval (INVVA1)",
   label: "Veraval (INVVA1)"
  },
  {
   value: "Vijayawada (INVGA4)",
   label: "Vijayawada (INVGA4)"
  },
  {
   value: "Visakhapatnam (INVTZ1)",
   label: "Visakhapatnam (INVTZ1)"
  },
  {
   value: "Visakhapatnam (INVTZ4)",
   label: "Visakhapatnam (INVTZ4)"
  },
  {
   value: "Waluj (Aurangabad) (INWAL6)",
   label: "Waluj (Aurangabad) (INWAL6)"
  },
  {
   value: "Warrangal (INWGC4)",
   label: "Warrangal (INWGC4)"
  },
  {
   value: "Alibag (INABG1)",
   label: "Alibag (INABG1)"
  },
  {
   value: "Achra (INACH1)",
   label: "Achra (INACH1)"
  },
  {
   value: "Androth Island (INADI1)",
   label: "Androth Island (INADI1)"
  },
  {
   value: "Agatti Island (INAGI1)",
   label: "Agatti Island (INAGI1)"
  },
  {
   value: "Pulicat (INPUL1)",
   label: "Pulicat (INPUL1)"
  },
  {
   value: "Pune (INPNQ2)",
   label: "Pune (INPNQ2)"
  },
  {
   value: "Pune (INPNQ3)",
   label: "Pune (INPNQ3)"
  },
  {
   value: "Pune (INPNQ4)",
   label: "Pune (INPNQ4)"
  },
  {
   value: "Puri (INPUR1)",
   label: "Puri (INPUR1)"
  },
  {
   value: "Puttaparthi (INPUT4)",
   label: "Puttaparthi (INPUT4)"
  },
  {
   value: "Quilon (INQUI1)",
   label: "Quilon (INQUI1)"
  },
  {
   value: "Raddipalam (INRPL6)",
   label: "Raddipalam (INRPL6)"
  },
  {
   value: "Raili (INRRI1)",
   label: "Raili (INRRI1)"
  },
  {
   value: "Raipur (INRPR4)",
   label: "Raipur (INRPR4)"
  },
  {
   value: "Raipur (INRPR6)",
   label: "Raipur (INRPR6)"
  },
  {
   value: "Rajahmundry (INRJA4)",
   label: "Rajahmundry (INRJA4)"
  },
  {
   value: "Rajkot (INRAJ4)",
   label: "Rajkot (INRAJ4)"
  },
  {
   value: "Rajouri (INRJI4)",
   label: "Rajouri (INRJI4)"
  },
  {
   value: "Ramagundam (INRMD4)",
   label: "Ramagundam (INRMD4)"
  },
  {
   value: "Rameshwaram (INRAM1)",
   label: "Rameshwaram (INRAM1)"
  },
  {
   value: "Ranchi (INIXR4)",
   label: "Ranchi (INIXR4)"
  },
  {
   value: "Ranpar (INRNR1)",
   label: "Ranpar (INRNR1)"
  },
  {
   value: "Ratnagiri (INRTC1)",
   label: "Ratnagiri (INRTC1)"
  },
  {
   value: "Ratnagiri (INRTC4)",
   label: "Ratnagiri (INRTC4)"
  },
  {
   value: "Redi (INRED1)",
   label: "Redi (INRED1)"
  },
  {
   value: "Revdanda (INRVD1)",
   label: "Revdanda (INRVD1)"
  },
  {
   value: "Rewa (INREW4)",
   label: "Rewa (INREW4)"
  },
  {
   value: "Rourkela (INRRK4)",
   label: "Rourkela (INRRK4)"
  },
  {
   value: "Rupsi (INRUP4)",
   label: "Rupsi (INRUP4)"
  },
  {
   value: "Sachin (Surat) (INSAC6)",
   label: "Sachin (Surat) (INSAC6)"
  },
  {
   value: "Saharanpur (INSRE6)",
   label: "Saharanpur (INSRE6)"
  },
  {
   value: "Salaya (INSAL1)",
   label: "Salaya (INSAL1)"
  },
  {
   value: "Salem (INSXV4)",
   label: "Salem (INSXV4)"
  },
  {
   value: "Salem (INSXV6)",
   label: "Salem (INSXV6)"
  },
  {
   value: "Secunderabad (INUND3)",
   label: "Secunderabad (INUND3)"
  },
  {
   value: "Shillong (INSHL4)",
   label: "Shillong (INSHL4)"
  },
  {
   value: "Shirola (INSHI1)",
   label: "Shirola (INSHI1)"
  },
  {
   value: "Sholapur (INSSE4)",
   label: "Sholapur (INSSE4)"
  },
  {
   value: "Sikka (INSIK1)",
   label: "Sikka (INSIK1)"
  },
  {
   value: "Silchar (INIXS4)",
   label: "Silchar (INIXS4)"
  },
  {
   value: "Simla (INSLV4)",
   label: "Simla (INSLV4)"
  },
  {
   value: "Singnallur (INSIR3)",
   label: "Singnallur (INSIR3)"
  },
  {
   value: "Srinagar (INSXR4)",
   label: "Srinagar (INSXR4)"
  },
  {
   value: "Surat (INSTV1)",
   label: "Surat (INSTV1)"
  },
  {
   value: "Surat (INSTV4)",
   label: "Surat (INSTV4)"
  },
  {
   value: "Nagapattinam (INNPT1)",
   label: "Nagapattinam (INNPT1)"
  },
  {
   value: "Nagapur (INNPR3)",
   label: "Nagapur (INNPR3)"
  },
  {
   value: "Nagpur (INNAG4)",
   label: "Nagpur (INNAG4)"
  },
  {
   value: "Nagpur (INNAG6)",
   label: "Nagpur (INNAG6)"
  },
  {
   value: "Nancowrie (INNAN1)",
   label: "Nancowrie (INNAN1)"
  },
  {
   value: "Nanded (INNDC4)",
   label: "Nanded (INNDC4)"
  },
  {
   value: "Nasik (INISK4)",
   label: "Nasik (INISK4)"
  },
  {
   value: "Nasik (INISK6)",
   label: "Nasik (INISK6)"
  },
  {
   value: "Navlakhi (INNAV1)",
   label: "Navlakhi (INNAV1)"
  },
  {
   value: "Neendakara (INNEE1)",
   label: "Neendakara (INNEE1)"
  },
  {
   value: "Nellore (INNEL1)",
   label: "Nellore (INNEL1)"
  },
  {
   value: "New Mangalore (INNML1)",
   label: "New Mangalore (INNML1)"
  },
  {
   value: "Neyveli (INNVY4)",
   label: "Neyveli (INNVY4)"
  },
  {
   value: "Okha (INOKH1)",
   label: "Okha (INOKH1)"
  },
  {
   value: "Osmanabad (INOMN4)",
   label: "Osmanabad (INOMN4)"
  },
  {
   value: "Padi (INPDI3)",
   label: "Padi (INPDI3)"
  },
  {
   value: "Pakwara (Moradabad) (INMBD6)",
   label: "Pakwara (Moradabad) (INMBD6)"
  },
  {
   value: "Panaji Port (INPAN1)",
   label: "Panaji Port (INPAN1)"
  },
  {
   value: "\"Panambur (INPNM1)",
   label: "\"Panambur (INPNM1)"
  },
  {
   value: "Panipat (INPAP2)",
   label: "Panipat (INPAP2)"
  },
  {
   value: "Panipat (INPAP3)",
   label: "Panipat (INPAP3)"
  },
  {
   value: "Pantnagar (INPGH4)",
   label: "Pantnagar (INPGH4)"
  },
  {
   value: "Paradeep (INPRT1)",
   label: "Paradeep (INPRT1)"
  },
  {
   value: "Pasighat (INIXT4)",
   label: "Pasighat (INIXT4)"
  },
  {
   value: "Pathankot (INIXP4)",
   label: "Pathankot (INIXP4)"
  },
  {
   value: "Patna (INPAT4)",
   label: "Patna (INPAT4)"
  },
  {
   value: "Patparganj (INPPG3)",
   label: "Patparganj (INPPG3)"
  },
  {
   value: "Pimpri (INPMP6)",
   label: "Pimpri (INPMP6)"
  },
  {
   value: "Pindhara (INPIN1)",
   label: "Pindhara (INPIN1)"
  },
  {
   value: "Pipavav (Victor) Port (INPAV1)",
   label: "Pipavav (Victor) Port (INPAV1)"
  },
  {
   value: "Pipavav (Victor) Port (INPAV2)",
   label: "Pipavav (Victor) Port (INPAV2)"
  },
  {
   value: "Pipavav (Victor) Port (INPAV3)",
   label: "Pipavav (Victor) Port (INPAV3)"
  },
  {
   value: "Pithampur (INPIR3)",
   label: "Pithampur (INPIR3)"
  },
  {
   value: "Pondicherry (INPNY1)",
   label: "Pondicherry (INPNY1)"
  },
  {
   value: "Pondicherry (INPNY4)",
   label: "Pondicherry (INPNY4)"
  },
  {
   value: "Porbandar (INPBD1)",
   label: "Porbandar (INPBD1)"
  },
  {
   value: "Porbandar (INPBD4)",
   label: "Porbandar (INPBD4)"
  },
  {
   value: "Port Blair (INIXZ1)",
   label: "Port Blair (INIXZ1)"
  },
  {
   value: "Port Blair (INIXZ4)",
   label: "Port Blair (INIXZ4)"
  },
  {
   value: "Port Indai (INPID1)",
   label: "Port Indai (INPID1)"
  },
  {
   value: "Kozhikode (ex Calicut) (INCCJ4)",
   label: "Kozhikode (ex Calicut) (INCCJ4)"
  },
  {
   value: "Krishnapatnam (INKRI1)",
   label: "Krishnapatnam (INKRI1)"
  },
  {
   value: "Kulu (INKUU4)",
   label: "Kulu (INKUU4)"
  },
  {
   value: "Kundla (INKUN3)",
   label: "Kundla (INKUN3)"
  },
  {
   value: "Leh (INIXL4)",
   label: "Leh (INIXL4)"
  },
  {
   value: "Lilabari (INIXI4)",
   label: "Lilabari (INIXI4)"
  },
  {
   value: "Lucknow (INLKO4)",
   label: "Lucknow (INLKO4)"
  },
  {
   value: "Ludhiana (INLUH4)",
   label: "Ludhiana (INLUH4)"
  },
  {
   value: "Ludhiana (INLUH6)",
   label: "Ludhiana (INLUH6)"
  },
  {
   value: "Madurai (INIXM4)",
   label: "Madurai (INIXM4)"
  },
  {
   value: "Magdalla (INMDA1)",
   label: "Magdalla (INMDA1)"
  },
  {
   value: "Mahe (INMAH1)",
   label: "Mahe (INMAH1)"
  },
  {
   value: "Mahuva (INMHA1)",
   label: "Mahuva (INMHA1)"
  },
  {
   value: "Malanpuri (Gwalior) (INGWL6)",
   label: "Malanpuri (Gwalior) (INGWL6)"
  },
  {
   value: "Malda (INLDA4)",
   label: "Malda (INLDA4)"
  },
  {
   value: "Malpe (INMAL1)",
   label: "Malpe (INMAL1)"
  },
  {
   value: "Mandapam (INMDP1)",
   label: "Mandapam (INMDP1)"
  },
  {
   value: "Mandvi (INMDV1)",
   label: "Mandvi (INMDV1)"
  },
  {
   value: "Mangalore (INIXE1)",
   label: "Mangalore (INIXE1)"
  },
  {
   value: "Mangalore (INIXE4)",
   label: "Mangalore (INIXE4)"
  },
  {
   value: "Mangrol (INMGR1)",
   label: "Mangrol (INMGR1)"
  },
  {
   value: "Margao (INMRG4)",
   label: "Margao (INMRG4)"
  },
  {
   value: "Marmagoa (INMRM1)",
   label: "Marmagoa (INMRM1)"
  },
  {
   value: "Maroli (INMLI1)",
   label: "Maroli (INMLI1)"
  },
  {
   value: "Masulipatnam (INMAP1)",
   label: "Masulipatnam (INMAP1)"
  },
  {
   value: "Meerut (INMER3)",
   label: "Meerut (INMER3)"
  },
  {
   value: "Minicoi I (INMCI1)",
   label: "Minicoi I (INMCI1)"
  },
  {
   value: "Mohali (INMHI3)",
   label: "Mohali (INMHI3)"
  },
  {
   value: "Mohanbari (INMOH4)",
   label: "Mohanbari (INMOH4)"
  },
  {
   value: "Moradabad (INMOR2)",
   label: "Moradabad (INMOR2)"
  },
  {
   value: "Moradabad (INMOR3)",
   label: "Moradabad (INMOR3)"
  },
  {
   value: "Muldwarka (INMDK1)",
   label: "Muldwarka (INMDK1)"
  },
  {
   value: "Mulund (INMUL3)",
   label: "Mulund (INMUL3)"
  },
  {
   value: "Mumbai (Ex Bombay) (INBOM1)",
   label: "Mumbai (Ex Bombay) (INBOM1)"
  },
  {
   value: "Mumbai (Ex Bombay) (INBOM4)",
   label: "Mumbai (Ex Bombay) (INBOM4)"
  },
  {
   value: "Mumbai (Ex Bombay) (INBOM5)",
   label: "Mumbai (Ex Bombay) (INBOM5)"
  },
  {
   value: "Mundra (INMUN1)",
   label: "Mundra (INMUN1)"
  },
  {
   value: "Murad (INMUR1)",
   label: "Murad (INMUR1)"
  },
  {
   value: "Muzaffarnagar (INMZA4)",
   label: "Muzaffarnagar (INMZA4)"
  },
  {
   value: "Muzaffarpur (INMZU4)",
   label: "Muzaffarpur (INMZU4)"
  },
  {
   value: "Mysore (INMYQ4)",
   label: "Mysore (INMYQ4)"
  },
  {
   value: "Jaisalmer (INJSA4)",
   label: "Jaisalmer (INJSA4)"
  },
  {
   value: "Jakhau (INJAK1)",
   label: "Jakhau (INJAK1)"
  },
  {
   value: "Jalandhar (INJUC6)",
   label: "Jalandhar (INJUC6)"
  },
  {
   value: "Jalgaon (INJAL6)",
   label: "Jalgaon (INJAL6)"
  },
  {
   value: "Jammu (INIXJ4)",
   label: "Jammu (INIXJ4)"
  },
  {
   value: "Jamnagar (INJGA4)",
   label: "Jamnagar (INJGA4)"
  },
  {
   value: "Jamshedpur (INIXW4)",
   label: "Jamshedpur (INIXW4)"
  },
  {
   value: "Jawaharlal Nehru (Nhava Sheva) (INNSA1)",
   label: "Jawaharlal Nehru (Nhava Sheva) (INNSA1)"
  },
  {
   value: "Jeypore (INPYB4)",
   label: "Jeypore (INPYB4)"
  },
  {
   value: "Jodhpur (INJDH4)",
   label: "Jodhpur (INJDH4)"
  },
  {
   value: "Jodhpur (INJDH6)",
   label: "Jodhpur (INJDH6)"
  },
  {
   value: "Jodia (INJDA1)",
   label: "Jodia (INJDA1)"
  },
  {
   value: "Jorhat (INJRH4)",
   label: "Jorhat (INJRH4)"
  },
  {
   value: "Kailashahar (INIXH4)",
   label: "Kailashahar (INIXH4)"
  },
  {
   value: "Kakinada (INKAK1)",
   label: "Kakinada (INKAK1)"
  },
  {
   value: "Kakinada (INKAK6)",
   label: "Kakinada (INKAK6)"
  },
  {
   value: "Kamalpur (INIXQ4)",
   label: "Kamalpur (INIXQ4)"
  },
  {
   value: "Kandla (INIXY1)",
   label: "Kandla (INIXY1)"
  },
  {
   value: "Kandla (INIXY4)",
   label: "Kandla (INIXY4)"
  },
  {
   value: "Kanpur (INKNU4)",
   label: "Kanpur (INKNU4)"
  },
  {
   value: "Kanpur (INKNU6)",
   label: "Kanpur (INKNU6)"
  },
  {
   value: "Kapadra (Surat) (INKAP6)",
   label: "Kapadra (Surat) (INKAP6)"
  },
  {
   value: "Karaikal (INKRK1)",
   label: "Karaikal (INKRK1)"
  },
  {
   value: "Karedu (INKDD6)",
   label: "Karedu (INKDD6)"
  },
  {
   value: "Karwar (INKRW1)",
   label: "Karwar (INKRW1)"
  },
  {
   value: "Keshod (INIXK4)",
   label: "Keshod (INIXK4)"
  },
  {
   value: "Khajuraho (INHJR4)",
   label: "Khajuraho (INHJR4)"
  },
  {
   value: "Khambhat (INKBT1)",
   label: "Khambhat (INKBT1)"
  },
  {
   value: "Khowai (INIXN4)",
   label: "Khowai (INIXN4)"
  },
  {
   value: "Kochi (INKOC5)",
   label: "Kochi (INKOC5)"
  },
  {
   value: "Kodinar (INKOD1)",
   label: "Kodinar (INKOD1)"
  },
  {
   value: "Kohlapur (INKLH3)",
   label: "Kohlapur (INKLH3)"
  },
  {
   value: "Kohlapur (INKLH4)",
   label: "Kohlapur (INKLH4)"
  },
  {
   value: "Koilthottum (INKOI1)",
   label: "Koilthottum (INKOI1)"
  },
  {
   value: "Koka (INKOK1)",
   label: "Koka (INKOK1)"
  },
  {
   value: "Konarak (INKON1)",
   label: "Konarak (INKON1)"
  },
  {
   value: "Konarak (INKON3)",
   label: "Konarak (INKON3)"
  },
  {
   value: "Kota (INKTT6)",
   label: "Kota (INKTT6)"
  },
  {
   value: "Kota (INKTU4)",
   label: "Kota (INKTU4)"
  },
  {
   value: "Kota (INKTU6)",
   label: "Kota (INKTU6)"
  },
  {
   value: "Kozhikode (ex Calicut) (INCCJ1)",
   label: "Kozhikode (ex Calicut) (INCCJ1)"
  },
  {
   value: "Dhanbad (INDBD4)",
   label: "Dhanbad (INDBD4)"
  },
  {
   value: "Dharamsala (INDHM4)",
   label: "Dharamsala (INDHM4)"
  },
  {
   value: "Dharamtar (INDMT1)",
   label: "Dharamtar (INDMT1)"
  },
  {
   value: "Dibrugarh (INDIB4)",
   label: "Dibrugarh (INDIB4)"
  },
  {
   value: "Dighi (Pune) (INDIG6)",
   label: "Dighi (Pune) (INDIG6)"
  },
  {
   value: "Dimapur (INDMU4)",
   label: "Dimapur (INDMU4)"
  },
  {
   value: "Diu (INDIU1)",
   label: "Diu (INDIU1)"
  },
  {
   value: "Diu (INDIU4)",
   label: "Diu (INDIU4)"
  },
  {
   value: "Div (INDIV1)",
   label: "Div (INDIV1)"
  },
  {
   value: "Dwarka (INDWA1)",
   label: "Dwarka (INDWA1)"
  },
  {
   value: "Ennore (INENR1)",
   label: "Ennore (INENR1)"
  },
  {
   value: "Faridabad (INFBD3)",
   label: "Faridabad (INFBD3)"
  },
  {
   value: "Gauhati (Panidi) (INGAU1)",
   label: "Gauhati (Panidi) (INGAU1)"
  },
  {
   value: "Gauhati (Panidi) (INGAU2)",
   label: "Gauhati (Panidi) (INGAU2)"
  },
  {
   value: "Gauhati (Panidi) (INGAU3)",
   label: "Gauhati (Panidi) (INGAU3)"
  },
  {
   value: "Gauhati (Panidi) (INGAU4)",
   label: "Gauhati (Panidi) (INGAU4)"
  },
  {
   value: "Gaya (INGAY4)",
   label: "Gaya (INGAY4)"
  },
  {
   value: "Goa (INGOI4)",
   label: "Goa (INGOI4)"
  },
  {
   value: "Gogha (INGGA1)",
   label: "Gogha (INGGA1)"
  },
  {
   value: "Gopalpur (INGPR1)",
   label: "Gopalpur (INGPR1)"
  },
  {
   value: "Gorakhpur (INGOP4)",
   label: "Gorakhpur (INGOP4)"
  },
  {
   value: "Guna (INGUX4)",
   label: "Guna (INGUX4)"
  },
  {
   value: "Guntur (INGTR2)",
   label: "Guntur (INGTR2)"
  },
  {
   value: "Guntur (INGTR3)",
   label: "Guntur (INGTR3)"
  },
  {
   value: "Gurgaon (INGGN2)",
   label: "Gurgaon (INGGN2)"
  },
  {
   value: "Gurgaon (INGGN3)",
   label: "Gurgaon (INGGN3)"
  },
  {
   value: "Guwahati (INGAW2)",
   label: "Guwahati (INGAW2)"
  },
  {
   value: "Gwalior (INGWL4)",
   label: "Gwalior (INGWL4)"
  },
  {
   value: "Haldia (INHAL1)",
   label: "Haldia (INHAL1)"
  },
  {
   value: "Hissar (INHSS4)",
   label: "Hissar (INHSS4)"
  },
  {
   value: "Honavar (INHON1)",
   label: "Honavar (INHON1)"
  },
  {
   value: "Hubli (INHBX4)",
   label: "Hubli (INHBX4)"
  },
  {
   value: "Hyderabad (INHYD3)",
   label: "Hyderabad (INHYD3)"
  },
  {
   value: "Hyderabad (INHYD4)",
   label: "Hyderabad (INHYD4)"
  },
  {
   value: "Hyderabad (INHYD6)",
   label: "Hyderabad (INHYD6)"
  },
  {
   value: "Imphal (INIMF4)",
   label: "Imphal (INIMF4)"
  },
  {
   value: "Indore (INIDR4)",
   label: "Indore (INIDR4)"
  },
  {
   value: "Jabalpur (INJLR4)",
   label: "Jabalpur (INJLR4)"
  },
  {
   value: "Jafrabad (INJBD1)",
   label: "Jafrabad (INJBD1)"
  },
  {
   value: "Jagdalpur (INJGB4)",
   label: "Jagdalpur (INJGB4)"
  },
  {
   value: "Jaipur (INJAI4)",
   label: "Jaipur (INJAI4)"
  },
  {
   value: "Jaipur (INJAI6)",
   label: "Jaipur (INJAI6)"
  },
  {
   value: "Bhubaneswar (INBBI4)",
   label: "Bhubaneswar (INBBI4)"
  },
  {
   value: "Bhuj (INBHJ4)",
   label: "Bhuj (INBHJ4)"
  },
  {
   value: "Bikaner (INBKB4)",
   label: "Bikaner (INBKB4)"
  },
  {
   value: "Bilaspur (INPAB4)",
   label: "Bilaspur (INPAB4)"
  },
  {
   value: "Broach (INBRH1)",
   label: "Broach (INBRH1)"
  },
  {
   value: "Budge-Budge (INBUD1)",
   label: "Budge-Budge (INBUD1)"
  },
  {
   value: "Calcutta (INCCU1)",
   label: "Calcutta (INCCU1)"
  },
  {
   value: "Calcutta (INCCU4)",
   label: "Calcutta (INCCU4)"
  },
  {
   value: "Calcutta (INCCU5)",
   label: "Calcutta (INCCU5)"
  },
  {
   value: "Calingapatam (INCAP1)",
   label: "Calingapatam (INCAP1)"
  },
  {
   value: "Cambay (INCAM1)",
   label: "Cambay (INCAM1)"
  },
  {
   value: "Car Nicobar (INCBD4)",
   label: "Car Nicobar (INCBD4)"
  },
  {
   value: "Carijam (INCAR1)",
   label: "Carijam (INCAR1)"
  },
  {
   value: "Chandbali (INCBL1)",
   label: "Chandbali (INCBL1)"
  },
  {
   value: "Chandigarh (INIXC4)",
   label: "Chandigarh (INIXC4)"
  },
  {
   value: "Chennai (Ex Madras) (INMAA1)",
   label: "Chennai (Ex Madras) (INMAA1)"
  },
  {
   value: "KATTUPALLI (INKTP1)",
   label: "KATTUPALLI (INKTP1)"
  },
  {
   value: " ()",
   label: " ()"
  },
  {
   value: "Chirala (INCLX6)",
   label: "Chirala (INCLX6)"
  },
  {
   value: "Cochin (INCOK1)",
   label: "Cochin (INCOK1)"
  },
  {
   value: "Cochin (INCOK4)",
   label: "Cochin (INCOK4)"
  },
  {
   value: "Coimbatore (INCJB4)",
   label: "Coimbatore (INCJB4)"
  },
  {
   value: "Coimbatore (INCJB6)",
   label: "Coimbatore (INCJB6)"
  },
  {
   value: "Colochel (INCOL1)",
   label: "Colochel (INCOL1)"
  },
  {
   value: "Cooch Behar (INCOH4)",
   label: "Cooch Behar (INCOH4)"
  },
  {
   value: "Coondapur (Ganguly) (INCOO1)",
   label: "Coondapur (Ganguly) (INCOO1)"
  },
  {
   value: "Cuddalore (INCDL1)",
   label: "Cuddalore (INCDL1)"
  },
  {
   value: "Cuddapah (INCDP4)",
   label: "Cuddapah (INCDP4)"
  },
  {
   value: "Cutch Mandvi (INCUM1)",
   label: "Cutch Mandvi (INCUM1)"
  },
  {
   value: "Dabhol Port (INDHP1)",
   label: "Dabhol Port (INDHP1)"
  },
  {
   value: "Dabolim (INDRL1)",
   label: "Dabolim (INDRL1)"
  },
  {
   value: "Dahanu (INDHU1)",
   label: "Dahanu (INDHU1)"
  },
  {
   value: "Dahej (INDAH1)",
   label: "Dahej (INDAH1)"
  },
  {
   value: "Daman (INDAM1)",
   label: "Daman (INDAM1)"
  },
  {
   value: "Daman (INDAM4)",
   label: "Daman (INDAM4)"
  },
  {
   value: "Daparizo (INDAE4)",
   label: "Daparizo (INDAE4)"
  },
  {
   value: "Darjeeling (INDAI4)",
   label: "Darjeeling (INDAI4)"
  },
  {
   value: "Dehra Dun (INDED4)",
   label: "Dehra Dun (INDED4)"
  },
  {
   value: "Delhi (INDEL4)",
   label: "Delhi (INDEL4)"
  },
  {
   value: "Delhi (INDEL5)",
   label: "Delhi (INDEL5)"
  },
  {
   value: "Deparizo (INDEP4)",
   label: "Deparizo (INDEP4)"
  },
  {
   value: "Agatti Island (INAGX4)",
   label: "Agatti Island (INAGX4)"
  },
  {
   value: "Agra (INAGR4)",
   label: "Agra (INAGR4)"
  },
  {
   value: "Agra (INAGR6)",
   label: "Agra (INAGR6)"
  },
  {
   value: "Ahmedabad (INAMD4)",
   label: "Ahmedabad (INAMD4)"
  },
  {
   value: "Ahmedabad (INAMD6)",
   label: "Ahmedabad (INAMD6)"
  },
  {
   value: "Aizawl (INAJL4)",
   label: "Aizawl (INAJL4)"
  },
  {
   value: "Akola (INAKD4)",
   label: "Akola (INAKD4)"
  },
  {
   value: "Allahabad (INIXD4)",
   label: "Allahabad (INIXD4)"
  },
  {
   value: "Allepey (INALF1)",
   label: "Allepey (INALF1)"
  },
  {
   value: "Amingaon (Gauhati) (INAMG6)",
   label: "Amingaon (Gauhati) (INAMG6)"
  },
  {
   value: "Amritsar (INATQ4)",
   label: "Amritsar (INATQ4)"
  },
  {
   value: "Amritsar (INATQ6)",
   label: "Amritsar (INATQ6)"
  },
  {
   value: "Anaparti (INAPT6)",
   label: "Anaparti (INAPT6)"
  },
  {
   value: "Aroor (INARR6)",
   label: "Aroor (INARR6)"
  },
  {
   value: "Aurangabad (INIXU4)",
   label: "Aurangabad (INIXU4)"
  },
  {
   value: "Azhikkal (INAZK1)",
   label: "Azhikkal (INAZK1)"
  },
  {
   value: "Babarpur (INPNP6)",
   label: "Babarpur (INPNP6)"
  },
  {
   value: "Bagdogra (INIXB4)",
   label: "Bagdogra (INIXB4)"
  },
  {
   value: "Bahabal Pur (INBBP1)",
   label: "Bahabal Pur (INBBP1)"
  },
  {
   value: "Balurghat (INRGH4)",
   label: "Balurghat (INRGH4)"
  },
  {
   value: "Bangalore (INBLR4)",
   label: "Bangalore (INBLR4)"
  },
  {
   value: "Bangalore (INBLR6)",
   label: "Bangalore (INBLR6)"
  },
  {
   value: "Bareilly (INBEK4)",
   label: "Bareilly (INBEK4)"
  },
  {
   value: "Baroda (INBRC6)",
   label: "Baroda (INBRC6)"
  },
  {
   value: "Bedi (INBED1)",
   label: "Bedi (INBED1)"
  },
  {
   value: "Belekeri (INBLK1)",
   label: "Belekeri (INBLK1)"
  },
  {
   value: "Belgaum (INIXG4)",
   label: "Belgaum (INIXG4)"
  },
  {
   value: "Bellary (INBEP4)",
   label: "Bellary (INBEP4)"
  },
  {
   value: "Betul (INBET1)",
   label: "Betul (INBET1)"
  },
  {
   value: "Beypore (INBEY1)",
   label: "Beypore (INBEY1)"
  },
  {
   value: "Bhatinda (INBUP4)",
   label: "Bhatinda (INBUP4)"
  },
  {
   value: "Bhatinda (INBUP6)",
   label: "Bhatinda (INBUP6)"
  },
  {
   value: "Bhavanagar (INBHU1)",
   label: "Bhavanagar (INBHU1)"
  },
  {
   value: "Bhavanagar (INBHU4)",
   label: "Bhavanagar (INBHU4)"
  },
  {
   value: "Bheemunipatnam (INBHM1)",
   label: "Bheemunipatnam (INBHM1)"
  },
  {
   value: "Bhilwara (INBHL6)",
   label: "Bhilwara (INBHL6)"
  },
  {
   value: "Bhiwadi (INBWD6)",
   label: "Bhiwadi (INBWD6)"
  },
  {
   value: "Bhopal (INBHO4)",
   label: "Bhopal (INBHO4)"
  },
  {
   value: "Ballinamore (IEBAM)",
   label: "Ballinamore (IEBAM)"
  },
  {
   value: "Carlingford (IECAR)",
   label: "Carlingford (IECAR)"
  },
  {
   value: "Killiney (IEKIY)",
   label: "Killiney (IEKIY)"
  },
  {
   value: "Rathmore (IERAM)",
   label: "Rathmore (IERAM)"
  },
  {
   value: "Acre (ILACR)",
   label: "Acre (ILACR)"
  },
  {
   value: "Adam (ILADM)",
   label: "Adam (ILADM)"
  },
  {
   value: "Alenbi (ILALN)",
   label: "Alenbi (ILALN)"
  },
  {
   value: "Arava (ILARV)",
   label: "Arava (ILARV)"
  },
  {
   value: "Ashdod (ILASH)",
   label: "Ashdod (ILASH)"
  },
  {
   value: "Ashkelon (ILAKL)",
   label: "Ashkelon (ILAKL)"
  },
  {
   value: "Bat Yam (ILBAT)",
   label: "Bat Yam (ILBAT)"
  },
  {
   value: "Beer Sheba (ILBEV)",
   label: "Beer Sheba (ILBEV)"
  },
  {
   value: "Bitanit (ILBRN)",
   label: "Bitanit (ILBRN)"
  },
  {
   value: "Ein Yahav (ILEIY)",
   label: "Ein Yahav (ILEIY)"
  },
  {
   value: "Elat (Eilath) (ILETH)",
   label: "Elat (Eilath) (ILETH)"
  },
  {
   value: "Gush Katif (ILGHK)",
   label: "Gush Katif (ILGHK)"
  },
  {
   value: "Hadera (ILHAD)",
   label: "Hadera (ILHAD)"
  },
  {
   value: "Haifa (ILHFA)",
   label: "Haifa (ILHFA)"
  },
  {
   value: "Jaffa (ILJFA)",
   label: "Jaffa (ILJFA)"
  },
  {
   value: "Jordan (ILJOR)",
   label: "Jordan (ILJOR)"
  },
  {
   value: "Kiryat Shmona (ILKSW)",
   label: "Kiryat Shmona (ILKSW)"
  },
  {
   value: "Konetra (ILKNT)",
   label: "Konetra (ILKNT)"
  },
  {
   value: "Masada (ILMTZ)",
   label: "Masada (ILMTZ)"
  },
  {
   value: "Matula (ILMTL)",
   label: "Matula (ILMTL)"
  },
  {
   value: "Mitspeh Ramon (ILMIP)",
   label: "Mitspeh Ramon (ILMIP)"
  },
  {
   value: "Natanya (ILNAT)",
   label: "Natanya (ILNAT)"
  },
  {
   value: "Nizana (ILNZN)",
   label: "Nizana (ILNZN)"
  },
  {
   value: "Ovda (ILVDA)",
   label: "Ovda (ILVDA)"
  },
  {
   value: "Petah Tiqwa (ILPTQ)",
   label: "Petah Tiqwa (ILPTQ)"
  },
  {
   value: "Qiryat Shemona (ILQIS)",
   label: "Qiryat Shemona (ILQIS)"
  },
  {
   value: "Rafah (ILRAH)",
   label: "Rafah (ILRAH)"
  },
  {
   value: "Rafiach (ILRFH)",
   label: "Rafiach (ILRFH)"
  },
  {
   value: "Rishon Letsiyon (ILRLZ)",
   label: "Rishon Letsiyon (ILRLZ)"
  },
  {
   value: "Rosh Hanikra (ILRHN)",
   label: "Rosh Hanikra (ILRHN)"
  },
  {
   value: "Rosh Pina (ILRPN)",
   label: "Rosh Pina (ILRPN)"
  },
  {
   value: "Sedom (ILSED)",
   label: "Sedom (ILSED)"
  },
  {
   value: "Sukrier (ILSUK)",
   label: "Sukrier (ILSUK)"
  },
  {
   value: "Taba (ILTAB)",
   label: "Taba (ILTAB)"
  },
  {
   value: "Tel Aviv (ILTLV)",
   label: "Tel Aviv (ILTLV)"
  },
  {
   value: "Yotvata (ILYOT)",
   label: "Yotvata (ILYOT)"
  },
  {
   value: "Hod Ha'Sharon (ILHHS)",
   label: "Hod Ha'Sharon (ILHHS)"
  },
  {
   value: "Tirat Carmel (ILTCL)",
   label: "Tirat Carmel (ILTCL)"
  },
  {
   value: "Agartala (INIXA4)",
   label: "Agartala (INIXA4)"
  },
  {
   value: "New Ross (IENRS)",
   label: "New Ross (IENRS)"
  },
  {
   value: "Newcastle West (IENEW)",
   label: "Newcastle West (IENEW)"
  },
  {
   value: "Newtonabbey (IENWT)",
   label: "Newtonabbey (IENWT)"
  },
  {
   value: "Newtownmountkennedy (IENMK)",
   label: "Newtownmountkennedy (IENMK)"
  },
  {
   value: "Pandoro Terminal (IEPAT)",
   label: "Pandoro Terminal (IEPAT)"
  },
  {
   value: "Parnell Place (IEPAP)",
   label: "Parnell Place (IEPAP)"
  },
  {
   value: "Ringaskiddy (IERIN)",
   label: "Ringaskiddy (IERIN)"
  },
  {
   value: "River Moy (IERVM)",
   label: "River Moy (IERVM)"
  },
  {
   value: "Roscrea (IERSC)",
   label: "Roscrea (IERSC)"
  },
  {
   value: "Rossaveel (IERAV)",
   label: "Rossaveel (IERAV)"
  },
  {
   value: "Rosslare (IEROE)",
   label: "Rosslare (IEROE)"
  },
  {
   value: "Rosslare Harbour (IEROS)",
   label: "Rosslare Harbour (IEROS)"
  },
  {
   value: "Rushbrook (IERUS)",
   label: "Rushbrook (IERUS)"
  },
  {
   value: "Saggart (IESAG)",
   label: "Saggart (IESAG)"
  },
  {
   value: "Scariff (IESCF)",
   label: "Scariff (IESCF)"
  },
  {
   value: "Shannon (IESNN)",
   label: "Shannon (IESNN)"
  },
  {
   value: "Sligo (IESLI)",
   label: "Sligo (IESLI)"
  },
  {
   value: "Sligo Apt (IESXL)",
   label: "Sligo Apt (IESXL)"
  },
  {
   value: "Spiddal (IENNR)",
   label: "Spiddal (IENNR)"
  },
  {
   value: "Strabane (IESTR)",
   label: "Strabane (IESTR)"
  },
  {
   value: "Tarbert (IETAR)",
   label: "Tarbert (IETAR)"
  },
  {
   value: "Templemore (IETEM)",
   label: "Templemore (IETEM)"
  },
  {
   value: "Thomastown (IETHO)",
   label: "Thomastown (IETHO)"
  },
  {
   value: "Thurles (IETHR)",
   label: "Thurles (IETHR)"
  },
  {
   value: "Tipperary (IETPY)",
   label: "Tipperary (IETPY)"
  },
  {
   value: "Tivoli (IETIV)",
   label: "Tivoli (IETIV)"
  },
  {
   value: "Tralee (IETRA)",
   label: "Tralee (IETRA)"
  },
  {
   value: "Tramore (IETME)",
   label: "Tramore (IETME)"
  },
  {
   value: "Trim (IETRI)",
   label: "Trim (IETRI)"
  },
  {
   value: "Tubbercurry (IETUB)",
   label: "Tubbercurry (IETUB)"
  },
  {
   value: "Tullamore (IETUL)",
   label: "Tullamore (IETUL)"
  },
  {
   value: "Tullow (IETUW)",
   label: "Tullow (IETUW)"
  },
  {
   value: "Virginia (IEVIR)",
   label: "Virginia (IEVIR)"
  },
  {
   value: "Walkinstown (IEWAL)",
   label: "Walkinstown (IEWAL)"
  },
  {
   value: "Waterford (IEWAT)",
   label: "Waterford (IEWAT)"
  },
  {
   value: "Westport (IEWES)",
   label: "Westport (IEWES)"
  },
  {
   value: "Wexford (IEWEX)",
   label: "Wexford (IEWEX)"
  },
  {
   value: "Whitegate (IEWHI)",
   label: "Whitegate (IEWHI)"
  },
  {
   value: "Wicklow (IEWIC)",
   label: "Wicklow (IEWIC)"
  },
  {
   value: "Youghal (IEYOU)",
   label: "Youghal (IEYOU)"
  },
  {
   value: "Inisheer (IEINQ)",
   label: "Inisheer (IEINQ)"
  },
  {
   value: "Inishmaan (IEIIA)",
   label: "Inishmaan (IEIIA)"
  },
  {
   value: "Inishmore (IEIOR)",
   label: "Inishmore (IEIOR)"
  },
  {
   value: "Irish Rail Freight Depot (IEIRD)",
   label: "Irish Rail Freight Depot (IEIRD)"
  },
  {
   value: "Kanturk (IEKNT)",
   label: "Kanturk (IEKNT)"
  },
  {
   value: "Kells (IEKLL)",
   label: "Kells (IEKLL)"
  },
  {
   value: "Kenmare (IEKEN)",
   label: "Kenmare (IEKEN)"
  },
  {
   value: "Kerry County (IEKIR)",
   label: "Kerry County (IEKIR)"
  },
  {
   value: "Kilclare (IEKCL)",
   label: "Kilclare (IEKCL)"
  },
  {
   value: "Kildare (IEKIL)",
   label: "Kildare (IEKIL)"
  },
  {
   value: "Kilkenny (IEKLK)",
   label: "Kilkenny (IEKLK)"
  },
  {
   value: "Killala (IEKLA)",
   label: "Killala (IEKLA)"
  },
  {
   value: "Killarney (IEKLY)",
   label: "Killarney (IEKLY)"
  },
  {
   value: "Killybegs (IEKBS)",
   label: "Killybegs (IEKBS)"
  },
  {
   value: "Kilmokea (IEKKA)",
   label: "Kilmokea (IEKKA)"
  },
  {
   value: "Kilrush (IEKLR)",
   label: "Kilrush (IEKLR)"
  },
  {
   value: "Kingscourt (IEKCT)",
   label: "Kingscourt (IEKCT)"
  },
  {
   value: "Kinsale (IEKLN)",
   label: "Kinsale (IEKLN)"
  },
  {
   value: "Leitrim (IELEI)",
   label: "Leitrim (IELEI)"
  },
  {
   value: "Leixlip (IELEX)",
   label: "Leixlip (IELEX)"
  },
  {
   value: "Letterkenny (IELTR)",
   label: "Letterkenny (IELTR)"
  },
  {
   value: "Lifford (IELIF)",
   label: "Lifford (IELIF)"
  },
  {
   value: "Limerick (IELMK)",
   label: "Limerick (IELMK)"
  },
  {
   value: "Listowel (IELST)",
   label: "Listowel (IELST)"
  },
  {
   value: "Longford (IELON)",
   label: "Longford (IELON)"
  },
  {
   value: "Loughrea (IELOU)",
   label: "Loughrea (IELOU)"
  },
  {
   value: "Louth (IELTH)",
   label: "Louth (IELTH)"
  },
  {
   value: "Macroom (IEMCR)",
   label: "Macroom (IEMCR)"
  },
  {
   value: "Maghera (IEMAG)",
   label: "Maghera (IEMAG)"
  },
  {
   value: "Mallow (IEMAL)",
   label: "Mallow (IEMAL)"
  },
  {
   value: "Marino Point (IEMAP)",
   label: "Marino Point (IEMAP)"
  },
  {
   value: "Maynooth (IEMAY)",
   label: "Maynooth (IEMAY)"
  },
  {
   value: "Midleton (IEMID)",
   label: "Midleton (IEMID)"
  },
  {
   value: "Mitchelstown (IEMIT)",
   label: "Mitchelstown (IEMIT)"
  },
  {
   value: "Monaghan (IEMON)",
   label: "Monaghan (IEMON)"
  },
  {
   value: "Moneypoint (IEMOT)",
   label: "Moneypoint (IEMOT)"
  },
  {
   value: "Moy Bridge (IEMOB)",
   label: "Moy Bridge (IEMOB)"
  },
  {
   value: "Mulligan (IEMLL)",
   label: "Mulligan (IEMLL)"
  },
  {
   value: "Mullingar (IEMUL)",
   label: "Mullingar (IEMUL)"
  },
  {
   value: "Naas (IENAA)",
   label: "Naas (IENAA)"
  },
  {
   value: "Navan (IENVN)",
   label: "Navan (IENVN)"
  },
  {
   value: "Castlerea (IECAA)",
   label: "Castlerea (IECAA)"
  },
  {
   value: "Castletown Bere (IECTB)",
   label: "Castletown Bere (IECTB)"
  },
  {
   value: "Causeway (IECAU)",
   label: "Causeway (IECAU)"
  },
  {
   value: "Cavan (IECAV)",
   label: "Cavan (IECAV)"
  },
  {
   value: "Clara (IECLA)",
   label: "Clara (IECLA)"
  },
  {
   value: "Clifden (IECLI)",
   label: "Clifden (IECLI)"
  },
  {
   value: "Cloghore (IECLO)",
   label: "Cloghore (IECLO)"
  },
  {
   value: "Clondalkin (IECLK)",
   label: "Clondalkin (IECLK)"
  },
  {
   value: "Clonee (IECLE)",
   label: "Clonee (IECLE)"
  },
  {
   value: "Clonmel (IECLL)",
   label: "Clonmel (IECLL)"
  },
  {
   value: "Coastal Control Terminal (IECCT)",
   label: "Coastal Control Terminal (IECCT)"
  },
  {
   value: "Cobh (IECOB)",
   label: "Cobh (IECOB)"
  },
  {
   value: "Collinstown (IECOL)",
   label: "Collinstown (IECOL)"
  },
  {
   value: "Connaught Apt \/ KNOCK (IENOC)",
   label: "Connaught Apt \/ KNOCK (IENOC)"
  },
  {
   value: "Cork (IEORK)",
   label: "Cork (IEORK)"
  },
  {
   value: "Crookhaven (IECRO)",
   label: "Crookhaven (IECRO)"
  },
  {
   value: "Deansgrange (IEDEA)",
   label: "Deansgrange (IEDEA)"
  },
  {
   value: "Derryveagh (IEDER)",
   label: "Derryveagh (IEDER)"
  },
  {
   value: "Dingle (IEDIN)",
   label: "Dingle (IEDIN)"
  },
  {
   value: "Donegal (IECFN)",
   label: "Donegal (IECFN)"
  },
  {
   value: "Drogheda (IEDRO)",
   label: "Drogheda (IEDRO)"
  },
  {
   value: "Dublin (IEDUB)",
   label: "Dublin (IEDUB)"
  },
  {
   value: "Dun Laoghaire (IEDLG)",
   label: "Dun Laoghaire (IEDLG)"
  },
  {
   value: "Dunboyne (IEDNB)",
   label: "Dunboyne (IEDNB)"
  },
  {
   value: "Dundalk (IEDDK)",
   label: "Dundalk (IEDDK)"
  },
  {
   value: "Dungarvan (IEDGV)",
   label: "Dungarvan (IEDGV)"
  },
  {
   value: "Dunleer (IEDNL)",
   label: "Dunleer (IEDNL)"
  },
  {
   value: "Dunmanway (IEDNW)",
   label: "Dunmanway (IEDNW)"
  },
  {
   value: "Dunmore East (IEDNM)",
   label: "Dunmore East (IEDNM)"
  },
  {
   value: "Enniscorthy (IEENN)",
   label: "Enniscorthy (IEENN)"
  },
  {
   value: "Fenit (IEFEN)",
   label: "Fenit (IEFEN)"
  },
  {
   value: "Fermoy (IEFER)",
   label: "Fermoy (IEFER)"
  },
  {
   value: "Fiddown (IEFID)",
   label: "Fiddown (IEFID)"
  },
  {
   value: "Foynes (IEFOV)",
   label: "Foynes (IEFOV)"
  },
  {
   value: "Frank Cassin Wharf (IEFCW)",
   label: "Frank Cassin Wharf (IEFCW)"
  },
  {
   value: "Galway (IEGWY)",
   label: "Galway (IEGWY)"
  },
  {
   value: "Gorey (IEGOR)",
   label: "Gorey (IEGOR)"
  },
  {
   value: "Greenore (IEGRN)",
   label: "Greenore (IEGRN)"
  },
  {
   value: "Haulbowline (IEHAU)",
   label: "Haulbowline (IEHAU)"
  },
  {
   value: "Howth (IEHOW)",
   label: "Howth (IEHOW)"
  },
  {
   value: "Abbeyleix (IEABB)",
   label: "Abbeyleix (IEABB)"
  },
  {
   value: "Alexandra Quay (IEALQ)",
   label: "Alexandra Quay (IEALQ)"
  },
  {
   value: "Alexandra Road Oil (IEARO)",
   label: "Alexandra Road Oil (IEARO)"
  },
  {
   value: "Annagassan (IEANN)",
   label: "Annagassan (IEANN)"
  },
  {
   value: "Ardara (IEARA)",
   label: "Ardara (IEARA)"
  },
  {
   value: "Arklow (IEARK)",
   label: "Arklow (IEARK)"
  },
  {
   value: "Ashbourne (IEASH)",
   label: "Ashbourne (IEASH)"
  },
  {
   value: "Askeaton (IEASK)",
   label: "Askeaton (IEASK)"
  },
  {
   value: "Athlone (IEATH)",
   label: "Athlone (IEATH)"
  },
  {
   value: "Athy (IEATY)",
   label: "Athy (IEATY)"
  },
  {
   value: "Au Uaimh (IEAUU)",
   label: "Au Uaimh (IEAUU)"
  },
  {
   value: "Aughinish Island (IEAUG)",
   label: "Aughinish Island (IEAUG)"
  },
  {
   value: "B &amp; I Ferryport (IEBIF)",
   label: "B &amp; I Ferryport (IEBIF)"
  },
  {
   value: "B &amp; I Terminal (IEBIT)",
   label: "B &amp; I Terminal (IEBIT)"
  },
  {
   value: "Baldonnel (IEBAL)",
   label: "Baldonnel (IEBAL)"
  },
  {
   value: "Baldoyne (IEBAY)",
   label: "Baldoyne (IEBAY)"
  },
  {
   value: "Ballaghadereen (IEBGD)",
   label: "Ballaghadereen (IEBGD)"
  },
  {
   value: "Ballieboro (IEBAO)",
   label: "Ballieboro (IEBAO)"
  },
  {
   value: "Ballina (IEBLL)",
   label: "Ballina (IEBLL)"
  },
  {
   value: "Ballinasloe (IEBAE)",
   label: "Ballinasloe (IEBAE)"
  },
  {
   value: "Ballygar (IEBLG)",
   label: "Ballygar (IEBLG)"
  },
  {
   value: "Ballyhaunis (IEBHS)",
   label: "Ballyhaunis (IEBHS)"
  },
  {
   value: "Ballyshannon (IEBSN)",
   label: "Ballyshannon (IEBSN)"
  },
  {
   value: "Baltimore (IEBTM)",
   label: "Baltimore (IEBTM)"
  },
  {
   value: "Banagher (IEBGR)",
   label: "Banagher (IEBGR)"
  },
  {
   value: "Bantry \/BANTRY BAY (IEBYT)",
   label: "Bantry \/BANTRY BAY (IEBYT)"
  },
  {
   value: "Bray (IEBRA)",
   label: "Bray (IEBRA)"
  },
  {
   value: "Buncrana (IEBUC)",
   label: "Buncrana (IEBUC)"
  },
  {
   value: "Caher (IECHR)",
   label: "Caher (IECHR)"
  },
  {
   value: "Caherciveen (IECHE)",
   label: "Caherciveen (IECHE)"
  },
  {
   value: "Caihir (IECAI)",
   label: "Caihir (IECAI)"
  },
  {
   value: "Carlow (IECAW)",
   label: "Carlow (IECAW)"
  },
  {
   value: "Carrickcarnan (IECAN)",
   label: "Carrickcarnan (IECAN)"
  },
  {
   value: "Carrickmacross (IECAS)",
   label: "Carrickmacross (IECAS)"
  },
  {
   value: "Cashel (IEQSH)",
   label: "Cashel (IEQSH)"
  },
  {
   value: "Castlebar (IECLB)",
   label: "Castlebar (IECLB)"
  },
  {
   value: "Castlebellingham (IECAM)",
   label: "Castlebellingham (IECAM)"
  },
  {
   value: "Castlecomber (IECAT)",
   label: "Castlecomber (IECAT)"
  },
  {
   value: "Castleconnell (IECAL)",
   label: "Castleconnell (IECAL)"
  },
  {
   value: "\"Tanjung Bara (IDTBA)",
   label: "\"Tanjung Bara (IDTBA)"
  },
  {
   value: "\"Tanjung Pandan (IDTJQ)",
   label: "\"Tanjung Pandan (IDTJQ)"
  },
  {
   value: "\"Tanjung Pinang (IDTNJ)",
   label: "\"Tanjung Pinang (IDTNJ)"
  },
  {
   value: "Tanjung Priok (IDTPP)",
   label: "Tanjung Priok (IDTPP)"
  },
  {
   value: "Tanjung Santan (IDTSX)",
   label: "Tanjung Santan (IDTSX)"
  },
  {
   value: "\"Tanjung Sekong (IDTSE)",
   label: "\"Tanjung Sekong (IDTSE)"
  },
  {
   value: "Tanjung Selor (IDTJS)",
   label: "Tanjung Selor (IDTJS)"
  },
  {
   value: "\"Tanjung Uban (IDTAN)",
   label: "\"Tanjung Uban (IDTAN)"
  },
  {
   value: "Tanjung Warukin (IDTJG)",
   label: "Tanjung Warukin (IDTJG)"
  },
  {
   value: "\"Tapaktuan (IDTPK)",
   label: "\"Tapaktuan (IDTPK)"
  },
  {
   value: "\"Tarakan (IDTRK)",
   label: "\"Tarakan (IDTRK)"
  },
  {
   value: "Tasikmalaya (IDTSY)",
   label: "Tasikmalaya (IDTSY)"
  },
  {
   value: "\"Tegal (IDTEG)",
   label: "\"Tegal (IDTEG)"
  },
  {
   value: "\"Telok Ayer (IDTKA)",
   label: "\"Telok Ayer (IDTKA)"
  },
  {
   value: "Telok Melano (IDTMO)",
   label: "Telok Melano (IDTMO)"
  },
  {
   value: "\"Teluk Betung (IDTBG)",
   label: "\"Teluk Betung (IDTBG)"
  },
  {
   value: "Tembagapura (IDTIM)",
   label: "Tembagapura (IDTIM)"
  },
  {
   value: "Teminabuan (IDTXM)",
   label: "Teminabuan (IDTXM)"
  },
  {
   value: "\"Ternate (IDTTE)",
   label: "\"Ternate (IDTTE)"
  },
  {
   value: "Tiom (IDTMY)",
   label: "Tiom (IDTMY)"
  },
  {
   value: "\"Tjeribon (IDTHB)",
   label: "\"Tjeribon (IDTHB)"
  },
  {
   value: "\"Tjilatjap (IDTJI)",
   label: "\"Tjilatjap (IDTJI)"
  },
  {
   value: "Tobelo (IDTBO)",
   label: "Tobelo (IDTBO)"
  },
  {
   value: "Tolitoli (IDTLI)",
   label: "Tolitoli (IDTLI)"
  },
  {
   value: "\"Tuban (IDTBN)",
   label: "\"Tuban (IDTBN)"
  },
  {
   value: "Tumbang Samba (IDTBM)",
   label: "Tumbang Samba (IDTBM)"
  },
  {
   value: "Ubrub (IDUBR)",
   label: "Ubrub (IDUBR)"
  },
  {
   value: "\"Ujung Pandang (IDUPG)",
   label: "\"Ujung Pandang (IDUPG)"
  },
  {
   value: "Viqueque (IDVIQ)",
   label: "Viqueque (IDVIQ)"
  },
  {
   value: "Wagethe (IDWET)",
   label: "Wagethe (IDWET)"
  },
  {
   value: "Wahai (IDWBA)",
   label: "Wahai (IDWBA)"
  },
  {
   value: "\"Waingapu (IDWGP)",
   label: "\"Waingapu (IDWGP)"
  },
  {
   value: "Wamena (IDWMX)",
   label: "Wamena (IDWMX)"
  },
  {
   value: "Waris (IDWAR)",
   label: "Waris (IDWAR)"
  },
  {
   value: "Wasior (IDWSR)",
   label: "Wasior (IDWSR)"
  },
  {
   value: "Yogyakarta (IDJOG)",
   label: "Yogyakarta (IDJOG)"
  },
  {
   value: "Yuruf (IDRUF)",
   label: "Yuruf (IDRUF)"
  },
  {
   value: "Zugapa (IDUGU)",
   label: "Zugapa (IDUGU)"
  },
  {
   value: "Senipah Terminal (IDSPH)",
   label: "Senipah Terminal (IDSPH)"
  },
  {
   value: "\"Serui (IDZRI)",
   label: "\"Serui (IDZRI)"
  },
  {
   value: "Sevivara Point (IDSVP)",
   label: "Sevivara Point (IDSVP)"
  },
  {
   value: "\"Siak Yechil (IDSIA)",
   label: "\"Siak Yechil (IDSIA)"
  },
  {
   value: "Sibisa (IDSIW)",
   label: "Sibisa (IDSIW)"
  },
  {
   value: "\"Sibolga (IDSLG)",
   label: "\"Sibolga (IDSLG)"
  },
  {
   value: "Sinabang (IDSNG)",
   label: "Sinabang (IDSNG)"
  },
  {
   value: "Sinak (IDNKD)",
   label: "Sinak (IDNKD)"
  },
  {
   value: "\"Singkawang (IDSKW)",
   label: "\"Singkawang (IDSKW)"
  },
  {
   value: "\"Singkep (IDSIQ)",
   label: "\"Singkep (IDSIQ)"
  },
  {
   value: "Sintang (IDSQG)",
   label: "Sintang (IDSQG)"
  },
  {
   value: "Sipora (IDRKO)",
   label: "Sipora (IDRKO)"
  },
  {
   value: "Soekarno-Hatta apt\/Jakarta (IDCGK)",
   label: "Soekarno-Hatta apt\/Jakarta (IDCGK)"
  },
  {
   value: "Soengei Kolak (IDSKK)",
   label: "Soengei Kolak (IDSKK)"
  },
  {
   value: "Solo City (IDSOC)",
   label: "Solo City (IDSOC)"
  },
  {
   value: "Soroako (IDSQR)",
   label: "Soroako (IDSQR)"
  },
  {
   value: "Sorong (IDSOQ)",
   label: "Sorong (IDSOQ)"
  },
  {
   value: "Steenkool (IDZKL)",
   label: "Steenkool (IDZKL)"
  },
  {
   value: "Suai (IDUAI)",
   label: "Suai (IDUAI)"
  },
  {
   value: "Sukarnapura (Western Irian) (IDHLA)",
   label: "Sukarnapura (Western Irian) (IDHLA)"
  },
  {
   value: "Sumbawa (IDSWQ)",
   label: "Sumbawa (IDSWQ)"
  },
  {
   value: "\"Sumenep (IDSUP)",
   label: "\"Sumenep (IDSUP)"
  },
  {
   value: "\"Sungai Gerong (IDSUG)",
   label: "\"Sungai Gerong (IDSUG)"
  },
  {
   value: "\"Sungai Guntung (IDSUQ)",
   label: "\"Sungai Guntung (IDSUQ)"
  },
  {
   value: "\"Sungai Pakning (IDSEQ)",
   label: "\"Sungai Pakning (IDSEQ)"
  },
  {
   value: "\"Surabaya (IDSUB)",
   label: "\"Surabaya (IDSUB)"
  },
  {
   value: "\"Susoh (IDSUS)",
   label: "\"Susoh (IDSUS)"
  },
  {
   value: "Susu (IDSSO)",
   label: "Susu (IDSSO)"
  },
  {
   value: "\"Taliabu (IDTAX)",
   label: "\"Taliabu (IDTAX)"
  },
  {
   value: "Tambolaka (IDTMC)",
   label: "Tambolaka (IDTMC)"
  },
  {
   value: "Tana Toraja (IDTTR)",
   label: "Tana Toraja (IDTTR)"
  },
  {
   value: "Tanah Grogot (IDTNB)",
   label: "Tanah Grogot (IDTNB)"
  },
  {
   value: "\"Tanahmerah (IDTMH)",
   label: "\"Tanahmerah (IDTMH)"
  },
  {
   value: "Tandjang (IDPDJ)",
   label: "Tandjang (IDPDJ)"
  },
  {
   value: "\"Tandjung Batu (IDTBT)",
   label: "\"Tandjung Batu (IDTBT)"
  },
  {
   value: "Tandjung Uban (IDTUB)",
   label: "Tandjung Uban (IDTUB)"
  },
  {
   value: "Tanjung Balai (IDTJB)",
   label: "Tanjung Balai (IDTJB)"
  },
  {
   value: "\"Poso (IDPSJ)",
   label: "\"Poso (IDPSJ)"
  },
  {
   value: "\"Probolinggo (IDPRO)",
   label: "\"Probolinggo (IDPRO)"
  },
  {
   value: "\"Prointal (IDPNT)",
   label: "\"Prointal (IDPNT)"
  },
  {
   value: "Pulangpisau (IDPPS)",
   label: "Pulangpisau (IDPPS)"
  },
  {
   value: "Pulau Panjang (IDPPJ)",
   label: "Pulau Panjang (IDPPJ)"
  },
  {
   value: "\"Pulau Sambu (IDPSS)",
   label: "\"Pulau Sambu (IDPSS)"
  },
  {
   value: "\"Pulo Bunju (IDPBJ)",
   label: "\"Pulo Bunju (IDPBJ)"
  },
  {
   value: "Purwokerto (IDPWL)",
   label: "Purwokerto (IDPWL)"
  },
  {
   value: "Putussibau (IDPSU)",
   label: "Putussibau (IDPSU)"
  },
  {
   value: "Raha (IDRAQ)",
   label: "Raha (IDRAQ)"
  },
  {
   value: "Ransiki (IDRSK)",
   label: "Ransiki (IDRSK)"
  },
  {
   value: "Rembang (IDREM)",
   label: "Rembang (IDREM)"
  },
  {
   value: "\"Rengat (IDRGT)",
   label: "\"Rengat (IDRGT)"
  },
  {
   value: "Rokot (IDRKI)",
   label: "Rokot (IDRKI)"
  },
  {
   value: "Roti (IDRTI)",
   label: "Roti (IDRTI)"
  },
  {
   value: "\"Ruteng (IDRTG)",
   label: "\"Ruteng (IDRTG)"
  },
  {
   value: "\"Sabang (IDSBG)",
   label: "\"Sabang (IDSBG)"
  },
  {
   value: "\"Sadau (IDSAD)",
   label: "\"Sadau (IDSAD)"
  },
  {
   value: "\"Samarinda (IDSRI)",
   label: "\"Samarinda (IDSRI)"
  },
  {
   value: "\"Sambas (IDSBS)",
   label: "\"Sambas (IDSBS)"
  },
  {
   value: "\"Sampit (IDSMQ)",
   label: "\"Sampit (IDSMQ)"
  },
  {
   value: "Sanana (IDSQN)",
   label: "Sanana (IDSQN)"
  },
  {
   value: "\"Sanang (IDSAN)",
   label: "\"Sanang (IDSAN)"
  },
  {
   value: "Sanggata (IDSGQ)",
   label: "Sanggata (IDSGQ)"
  },
  {
   value: "Sangir (IDSAE)",
   label: "Sangir (IDSAE)"
  },
  {
   value: "\"Sangkulirang (IDSKI)",
   label: "\"Sangkulirang (IDSKI)"
  },
  {
   value: "\"Santan Terminal (IDSAT)",
   label: "\"Santan Terminal (IDSAT)"
  },
  {
   value: "Sasayap (IDSAS)",
   label: "Sasayap (IDSAS)"
  },
  {
   value: "Satui (IDSTU)",
   label: "Satui (IDSTU)"
  },
  {
   value: "Saumlaki (IDSXK)",
   label: "Saumlaki (IDSXK)"
  },
  {
   value: "Sawu (IDSAU)",
   label: "Sawu (IDSAU)"
  },
  {
   value: "\"Sebangan Bay (IDSEB)",
   label: "\"Sebangan Bay (IDSEB)"
  },
  {
   value: "\"Segama (IDSEG)",
   label: "\"Segama (IDSEG)"
  },
  {
   value: "\"Selat Pandjang (IDSPA)",
   label: "\"Selat Pandjang (IDSPA)"
  },
  {
   value: "\"Semangka Bay (IDSMB)",
   label: "\"Semangka Bay (IDSMB)"
  },
  {
   value: "\"Semarang (IDSRG)",
   label: "\"Semarang (IDSRG)"
  },
  {
   value: "Senggeh (IDSEH)",
   label: "Senggeh (IDSEH)"
  },
  {
   value: "Senggo (IDZEG)",
   label: "Senggo (IDZEG)"
  },
  {
   value: "\"Padang (Teluk Bajur) (IDPDG)",
   label: "\"Padang (Teluk Bajur) (IDPDG)"
  },
  {
   value: "\"Pagatan (IDPAG)",
   label: "\"Pagatan (IDPAG)"
  },
  {
   value: "Pakan Baru (IDPAK)",
   label: "Pakan Baru (IDPAK)"
  },
  {
   value: "Palangkaraya (IDPKY)",
   label: "Palangkaraya (IDPKY)"
  },
  {
   value: "\"Palapo (IDPPO)",
   label: "\"Palapo (IDPPO)"
  },
  {
   value: "Palembang (Sungei) (IDPLS)",
   label: "Palembang (Sungei) (IDPLS)"
  },
  {
   value: "\"Palembang (IDPLM)",
   label: "\"Palembang (IDPLM)"
  },
  {
   value: "Palibelo (IDPBW)",
   label: "Palibelo (IDPBW)"
  },
  {
   value: "\"Pamanukan (IDPNN)",
   label: "\"Pamanukan (IDPNN)"
  },
  {
   value: "\"Panarukan (IDPRN)",
   label: "\"Panarukan (IDPRN)"
  },
  {
   value: "Pandjung Mani (IDPJM)",
   label: "Pandjung Mani (IDPJM)"
  },
  {
   value: "\"Pangkal Balam (IDPGX)",
   label: "\"Pangkal Balam (IDPGX)"
  },
  {
   value: "\"Pangkalan Brandan (IDPKR)",
   label: "\"Pangkalan Brandan (IDPKR)"
  },
  {
   value: "\"Pangkalan Susu (IDPKS)",
   label: "\"Pangkalan Susu (IDPKS)"
  },
  {
   value: "Pangkalanbuun (IDPKN)",
   label: "Pangkalanbuun (IDPKN)"
  },
  {
   value: "\"Pangkalpinang (IDPGK)",
   label: "\"Pangkalpinang (IDPGK)"
  },
  {
   value: "Panjang (IDPNJ)",
   label: "Panjang (IDPNJ)"
  },
  {
   value: "\"Panjang (Lampung (IDPJG)",
   label: "\"Panjang (Lampung (IDPJG)"
  },
  {
   value: "\"Pantoloan (IDPTL)",
   label: "\"Pantoloan (IDPTL)"
  },
  {
   value: "Pare Pare (IDPAP)",
   label: "Pare Pare (IDPAP)"
  },
  {
   value: "\"Pasaruan (IDPAZ)",
   label: "\"Pasaruan (IDPAZ)"
  },
  {
   value: "Pasir Panjang (IDPAS)",
   label: "Pasir Panjang (IDPAS)"
  },
  {
   value: "\"Pekalongan (IDPEX)",
   label: "\"Pekalongan (IDPEX)"
  },
  {
   value: "\"Pekanbaru (IDPKU)",
   label: "\"Pekanbaru (IDPKU)"
  },
  {
   value: "\"Pemangkat (IDPEM)",
   label: "\"Pemangkat (IDPEM)"
  },
  {
   value: "Pendopo (IDPDO)",
   label: "Pendopo (IDPDO)"
  },
  {
   value: "Penuba (IDPNG)",
   label: "Penuba (IDPNG)"
  },
  {
   value: "Perawang (IDPER)",
   label: "Perawang (IDPER)"
  },
  {
   value: "\"Perawang (IDPWG)",
   label: "\"Perawang (IDPWG)"
  },
  {
   value: "\"Pladju (IDPLA)",
   label: "\"Pladju (IDPLA)"
  },
  {
   value: "\"Pomala (IDPUM)",
   label: "\"Pomala (IDPUM)"
  },
  {
   value: "Pondok Cabe (IDPCB)",
   label: "Pondok Cabe (IDPCB)"
  },
  {
   value: "\"Pontianak (IDPNK)",
   label: "\"Pontianak (IDPNK)"
  },
  {
   value: "Port Meneng (IDPMG)",
   label: "Port Meneng (IDPMG)"
  },
  {
   value: "Port Okha (IDPTO)",
   label: "Port Okha (IDPTO)"
  },
  {
   value: "\"Manokwari (IDMKW)",
   label: "\"Manokwari (IDMKW)"
  },
  {
   value: "\"Mantang (IDMNT)",
   label: "\"Mantang (IDMNT)"
  },
  {
   value: "Masalembo (IDMSI)",
   label: "Masalembo (IDMSI)"
  },
  {
   value: "Masamba (IDMXB)",
   label: "Masamba (IDMXB)"
  },
  {
   value: "Matak (IDMWK)",
   label: "Matak (IDMWK)"
  },
  {
   value: "Mataram (IDAMI)",
   label: "Mataram (IDAMI)"
  },
  {
   value: "\"Maumere (IDMOF)",
   label: "\"Maumere (IDMOF)"
  },
  {
   value: "\"Medan (IDMES)",
   label: "\"Medan (IDMES)"
  },
  {
   value: "Melangguane (IDMNA)",
   label: "Melangguane (IDMNA)"
  },
  {
   value: "\"Merak (IDMRK)",
   label: "\"Merak (IDMRK)"
  },
  {
   value: "\"Merantibunting (IDMRB)",
   label: "\"Merantibunting (IDMRB)"
  },
  {
   value: "\"Merauke (IDMKQ)",
   label: "\"Merauke (IDMKQ)"
  },
  {
   value: "Merdey (IDRDE)",
   label: "Merdey (IDRDE)"
  },
  {
   value: "\"Meulaboh (IDMEQ)",
   label: "\"Meulaboh (IDMEQ)"
  },
  {
   value: "Mindiptana (IDMDP)",
   label: "Mindiptana (IDMDP)"
  },
  {
   value: "Moanamani (IDONI)",
   label: "Moanamani (IDONI)"
  },
  {
   value: "Morotai I (IDOZI)",
   label: "Morotai I (IDOZI)"
  },
  {
   value: "Muara Berau (IDMUB)",
   label: "Muara Berau (IDMUB)"
  },
  {
   value: "Muara Djawa (IDMUD)",
   label: "Muara Djawa (IDMUD)"
  },
  {
   value: "Muara Pegah (IDMUP)",
   label: "Muara Pegah (IDMUP)"
  },
  {
   value: "Muko-Muko (IDMPC)",
   label: "Muko-Muko (IDMPC)"
  },
  {
   value: "Mulia (IDLII)",
   label: "Mulia (IDLII)"
  },
  {
   value: "\"Muntok (IDMUO)",
   label: "\"Muntok (IDMUO)"
  },
  {
   value: "\"Musi River (IDMRI)",
   label: "\"Musi River (IDMRI)"
  },
  {
   value: "Muting (IDMUF)",
   label: "Muting (IDMUF)"
  },
  {
   value: "Muturi (IDMTU)",
   label: "Muturi (IDMTU)"
  },
  {
   value: "Nabire (IDNBX)",
   label: "Nabire (IDNBX)"
  },
  {
   value: "Naha (IDNAH)",
   label: "Naha (IDNAH)"
  },
  {
   value: "Namlea (IDNAM)",
   label: "Namlea (IDNAM)"
  },
  {
   value: "Namrole (IDNRE)",
   label: "Namrole (IDNRE)"
  },
  {
   value: "Nangapinoh (IDNPO)",
   label: "Nangapinoh (IDNPO)"
  },
  {
   value: "Natuna Ranai (IDNTX)",
   label: "Natuna Ranai (IDNTX)"
  },
  {
   value: "Numfoor (IDFOO)",
   label: "Numfoor (IDFOO)"
  },
  {
   value: "Nunukan (IDNNX)",
   label: "Nunukan (IDNNX)"
  },
  {
   value: "Obano (IDOBD)",
   label: "Obano (IDOBD)"
  },
  {
   value: "Obi Island (IDOBI)",
   label: "Obi Island (IDOBI)"
  },
  {
   value: "Ocussi (IDOEC)",
   label: "Ocussi (IDOEC)"
  },
  {
   value: "\"Okaba (IDOKQ)",
   label: "\"Okaba (IDOKQ)"
  },
  {
   value: "Oksibil (IDOKL)",
   label: "Oksibil (IDOKL)"
  },
  {
   value: "Olee Lheue (IDOLO)",
   label: "Olee Lheue (IDOLO)"
  },
  {
   value: "\"Kidjang (IDKID)",
   label: "\"Kidjang (IDKID)"
  },
  {
   value: "Kimam (IDKMM)",
   label: "Kimam (IDKMM)"
  },
  {
   value: "Kokonao (IDKOX)",
   label: "Kokonao (IDKOX)"
  },
  {
   value: "Kon (IDKCI)",
   label: "Kon (IDKCI)"
  },
  {
   value: "Kotabangun (IDKOD)",
   label: "Kotabangun (IDKOD)"
  },
  {
   value: "Kotabaru (IDKBU)",
   label: "Kotabaru (IDKBU)"
  },
  {
   value: "\"Kotapinang (IDKPN)",
   label: "\"Kotapinang (IDKPN)"
  },
  {
   value: "\"Kuala Kapuas (IDKKA)",
   label: "\"Kuala Kapuas (IDKKA)"
  },
  {
   value: "\"Kuala Mandah (IDKMA)",
   label: "\"Kuala Mandah (IDKMA)"
  },
  {
   value: "\"Kunak (IDKKB)",
   label: "\"Kunak (IDKKB)"
  },
  {
   value: "\"Kupang (IDKOE)",
   label: "\"Kupang (IDKOE)"
  },
  {
   value: "\"Labuha (IDLAH)",
   label: "\"Labuha (IDLAH)"
  },
  {
   value: "\"Lalang Terminal (IDLAT)",
   label: "\"Lalang Terminal (IDLAT)"
  },
  {
   value: "Langgur (IDLUV)",
   label: "Langgur (IDLUV)"
  },
  {
   value: "\"Langsa (IDLAS)",
   label: "\"Langsa (IDLAS)"
  },
  {
   value: "Larantuka (IDLKA)",
   label: "Larantuka (IDLKA)"
  },
  {
   value: "Larat (IDLRT)",
   label: "Larat (IDLRT)"
  },
  {
   value: "\"Lawe-Lawe (IDLLA)",
   label: "\"Lawe-Lawe (IDLLA)"
  },
  {
   value: "Lereh (IDLHI)",
   label: "Lereh (IDLHI)"
  },
  {
   value: "Lewoleba (IDLWE)",
   label: "Lewoleba (IDLWE)"
  },
  {
   value: "Lhok Sukon (IDLSX)",
   label: "Lhok Sukon (IDLSX)"
  },
  {
   value: "Lhoknga (IDLHK)",
   label: "Lhoknga (IDLHK)"
  },
  {
   value: "\"Lhokseumawe (IDLKS)",
   label: "\"Lhokseumawe (IDLKS)"
  },
  {
   value: "\"Lhoksumawe (IDLSW)",
   label: "\"Lhoksumawe (IDLSW)"
  },
  {
   value: "Lifamatola (IDLIF)",
   label: "Lifamatola (IDLIF)"
  },
  {
   value: "Lombok Strait (IDLMB)",
   label: "Lombok Strait (IDLMB)"
  },
  {
   value: "Long Apung (IDLPU)",
   label: "Long Apung (IDLPU)"
  },
  {
   value: "Long Bawan (IDLBW)",
   label: "Long Bawan (IDLBW)"
  },
  {
   value: "Lunyuk (IDLYK)",
   label: "Lunyuk (IDLYK)"
  },
  {
   value: "Luwuk (IDLUW)",
   label: "Luwuk (IDLUW)"
  },
  {
   value: "\"Majene (IDMAJ)",
   label: "\"Majene (IDMAJ)"
  },
  {
   value: "Malang (IDMLG)",
   label: "Malang (IDMLG)"
  },
  {
   value: "Maliana (IDMPT)",
   label: "Maliana (IDMPT)"
  },
  {
   value: "\"Malili (IDMLI)",
   label: "\"Malili (IDMLI)"
  },
  {
   value: "Mamuju (IDMJU)",
   label: "Mamuju (IDMJU)"
  },
  {
   value: "Manado (IDMDC)",
   label: "Manado (IDMDC)"
  },
  {
   value: "Manggar (IDMAN)",
   label: "Manggar (IDMAN)"
  },
  {
   value: "Mangole (IDMAL)",
   label: "Mangole (IDMAL)"
  },
  {
   value: "Mangunjaya (IDMJY)",
   label: "Mangunjaya (IDMJY)"
  },
  {
   value: "\"Denpasar (IDDPS)",
   label: "\"Denpasar (IDDPS)"
  },
  {
   value: "Dili (IDDIL)",
   label: "Dili (IDDIL)"
  },
  {
   value: "Diviematra (IDDIV)",
   label: "Diviematra (IDDIV)"
  },
  {
   value: "Djankar (IDDJA)",
   label: "Djankar (IDDJA)"
  },
  {
   value: "\"Dumai (IDDUM)",
   label: "\"Dumai (IDDUM)"
  },
  {
   value: "Enarotali (IDEWI)",
   label: "Enarotali (IDEWI)"
  },
  {
   value: "\"Ende (IDENE)",
   label: "\"Ende (IDENE)"
  },
  {
   value: "Ewer (IDEWE)",
   label: "Ewer (IDEWE)"
  },
  {
   value: "\"Fak Fak (IDFKQ)",
   label: "\"Fak Fak (IDFKQ)"
  },
  {
   value: "Gag Island (IDGAG)",
   label: "Gag Island (IDGAG)"
  },
  {
   value: "\"Galela (IDGLX)",
   label: "\"Galela (IDGLX)"
  },
  {
   value: "Gebe (IDGEB)",
   label: "Gebe (IDGEB)"
  },
  {
   value: "\"Gilimanuk (IDGIL)",
   label: "\"Gilimanuk (IDGIL)"
  },
  {
   value: "\"Gorontalo (IDGTO)",
   label: "\"Gorontalo (IDGTO)"
  },
  {
   value: "\"Gresik (IDGRE)",
   label: "\"Gresik (IDGRE)"
  },
  {
   value: "\"Gunung Sitoli (IDGNS)",
   label: "\"Gunung Sitoli (IDGNS)"
  },
  {
   value: "Illaga (IDILA)",
   label: "Illaga (IDILA)"
  },
  {
   value: "\"Jakarta (IDJKT)",
   label: "\"Jakarta (IDJKT)"
  },
  {
   value: "\"Jambi (IDDJB)",
   label: "\"Jambi (IDDJB)"
  },
  {
   value: "\"Jayapura (IDDJJ)",
   label: "\"Jayapura (IDDJJ)"
  },
  {
   value: "Jember (IDJEM)",
   label: "Jember (IDJEM)"
  },
  {
   value: "Kahayan Bay (IDKAH)",
   label: "Kahayan Bay (IDKAH)"
  },
  {
   value: "\"Kaimana (IDKNG)",
   label: "\"Kaimana (IDKNG)"
  },
  {
   value: "Kajang (IDKJN)",
   label: "Kajang (IDKJN)"
  },
  {
   value: "Kalianget (IDKAT)",
   label: "Kalianget (IDKAT)"
  },
  {
   value: "Kaltim (IDKLT)",
   label: "Kaltim (IDKLT)"
  },
  {
   value: "\"Kambunong (IDKAM)",
   label: "\"Kambunong (IDKAM)"
  },
  {
   value: "\"Karosa (IDKAR)",
   label: "\"Karosa (IDKAR)"
  },
  {
   value: "Karubaga (IDKBF)",
   label: "Karubaga (IDKBF)"
  },
  {
   value: "\"Kasim (IDKAS)",
   label: "\"Kasim (IDKAS)"
  },
  {
   value: "Kebar (IDKEQ)",
   label: "Kebar (IDKEQ)"
  },
  {
   value: "Keisah (IDKEA)",
   label: "Keisah (IDKEA)"
  },
  {
   value: "Kelila (IDLLN)",
   label: "Kelila (IDLLN)"
  },
  {
   value: "Keluang (IDKLQ)",
   label: "Keluang (IDKLQ)"
  },
  {
   value: "\"Kempo (IDKEM)",
   label: "\"Kempo (IDKEM)"
  },
  {
   value: "\"Kendari (IDKDI)",
   label: "\"Kendari (IDKDI)"
  },
  {
   value: "Kepi (IDKEI)",
   label: "Kepi (IDKEI)"
  },
  {
   value: "Kerinci (IDKRC)",
   label: "Kerinci (IDKRC)"
  },
  {
   value: "\"Ketapang (IDKTG)",
   label: "\"Ketapang (IDKTG)"
  },
  {
   value: "Banten (IDBTN)",
   label: "Banten (IDBTN)"
  },
  {
   value: "Batam (ex Batu Besar) (IDBTH)",
   label: "Batam (ex Batu Besar) (IDBTH)"
  },
  {
   value: "Batam Island (IDBTM)",
   label: "Batam Island (IDBTM)"
  },
  {
   value: "Batu Ampal (IDBUR)",
   label: "Batu Ampal (IDBUR)"
  },
  {
   value: "Batu Kilat (IDBAK)",
   label: "Batu Kilat (IDBAK)"
  },
  {
   value: "\"Baubau (IDBUW)",
   label: "\"Baubau (IDBUW)"
  },
  {
   value: "Baucau (IDBCH)",
   label: "Baucau (IDBCH)"
  },
  {
   value: "Bekapai Terminal (IDBEK)",
   label: "Bekapai Terminal (IDBEK)"
  },
  {
   value: "\"Belawan (IDBLW)",
   label: "\"Belawan (IDBLW)"
  },
  {
   value: "Beliling (IDBLV)",
   label: "Beliling (IDBLV)"
  },
  {
   value: "\"Bengkalis (IDBKI)",
   label: "\"Bengkalis (IDBKI)"
  },
  {
   value: "\"Bengkulu (IDBKS)",
   label: "\"Bengkulu (IDBKS)"
  },
  {
   value: "\"Benoa (IDBOA)",
   label: "\"Benoa (IDBOA)"
  },
  {
   value: "Berau (IDBEJ)",
   label: "Berau (IDBEJ)"
  },
  {
   value: "\"Biak (IDBIK)",
   label: "\"Biak (IDBIK)"
  },
  {
   value: "\"Bima Terminal (IDBMT)",
   label: "\"Bima Terminal (IDBMT)"
  },
  {
   value: "\"Bima (IDBMU)",
   label: "\"Bima (IDBMU)"
  },
  {
   value: "Bintuni (IDNTI)",
   label: "Bintuni (IDNTI)"
  },
  {
   value: "\"Bitung (IDBIT)",
   label: "\"Bitung (IDBIT)"
  },
  {
   value: "\"Blang Lancang (IDBLL)",
   label: "\"Blang Lancang (IDBLL)"
  },
  {
   value: "\"Blinju (IDBLI)",
   label: "\"Blinju (IDBLI)"
  },
  {
   value: "Bokondini (IDBUI)",
   label: "Bokondini (IDBUI)"
  },
  {
   value: "Bolaang (IDBJG)",
   label: "Bolaang (IDBJG)"
  },
  {
   value: "Bonggala (IDBNG)",
   label: "Bonggala (IDBNG)"
  },
  {
   value: "\"Bontang (IDBXT)",
   label: "\"Bontang (IDBXT)"
  },
  {
   value: "Buatan (IDBUN)",
   label: "Buatan (IDBUN)"
  },
  {
   value: "Bula (IDBUA)",
   label: "Bula (IDBUA)"
  },
  {
   value: "\"Buleleng (IDBUG)",
   label: "\"Buleleng (IDBUG)"
  },
  {
   value: "\"Bunyu (IDBYQ)",
   label: "\"Bunyu (IDBYQ)"
  },
  {
   value: "Buol (IDUOL)",
   label: "Buol (IDUOL)"
  },
  {
   value: "Cape Sago (IDCSA)",
   label: "Cape Sago (IDCSA)"
  },
  {
   value: "\"Celukan Bawang (IDCEB)",
   label: "\"Celukan Bawang (IDCEB)"
  },
  {
   value: "Cigading (IDCIG)",
   label: "Cigading (IDCIG)"
  },
  {
   value: "\"Cilacap (IDCXP)",
   label: "\"Cilacap (IDCXP)"
  },
  {
   value: "\"Cinta (IDCIN)",
   label: "\"Cinta (IDCIN)"
  },
  {
   value: "\"Cirebon (IDCBN)",
   label: "\"Cirebon (IDCBN)"
  },
  {
   value: "Ciwandan (IDCIW)",
   label: "Ciwandan (IDCIW)"
  },
  {
   value: "\"Dabo (IDDAS)",
   label: "\"Dabo (IDDAS)"
  },
  {
   value: "Svarvas (HUSVS)",
   label: "Svarvas (HUSVS)"
  },
  {
   value: "Szeged (HUSZE)",
   label: "Szeged (HUSZE)"
  },
  {
   value: "Szekesfehervar (HUSZR)",
   label: "Szekesfehervar (HUSZR)"
  },
  {
   value: "Szekszard (HUSZK)",
   label: "Szekszard (HUSZK)"
  },
  {
   value: "Szentgotthard (HUSZG)",
   label: "Szentgotthard (HUSZG)"
  },
  {
   value: "Szob (HUSZO)",
   label: "Szob (HUSZO)"
  },
  {
   value: "Szolnok (HUSZL)",
   label: "Szolnok (HUSZL)"
  },
  {
   value: "Szombathely (HUSZY)",
   label: "Szombathely (HUSZY)"
  },
  {
   value: "Tompa (HUTOM)",
   label: "Tompa (HUTOM)"
  },
  {
   value: "Tornanadaska (HUTOD)",
   label: "Tornanadaska (HUTOD)"
  },
  {
   value: "Tornyosnemeti (HUTON)",
   label: "Tornyosnemeti (HUTON)"
  },
  {
   value: "Torokbalint (HUTKB)",
   label: "Torokbalint (HUTKB)"
  },
  {
   value: "Udvar (HUUDV)",
   label: "Udvar (HUUDV)"
  },
  {
   value: "Vamosszabadi (HUVAM)",
   label: "Vamosszabadi (HUVAM)"
  },
  {
   value: "Veroce (HUVER)",
   label: "Veroce (HUVER)"
  },
  {
   value: "Zahony (HUZAH)",
   label: "Zahony (HUZAH)"
  },
  {
   value: "Zerlaegerszeg (HUZER)",
   label: "Zerlaegerszeg (HUZER)"
  },
  {
   value: "Adang Bay (IDADB)",
   label: "Adang Bay (IDADB)"
  },
  {
   value: "Alor Island (IDARD)",
   label: "Alor Island (IDARD)"
  },
  {
   value: "Amahai (IDAHI)",
   label: "Amahai (IDAHI)"
  },
  {
   value: "\"Amamapare (IDAMA)",
   label: "\"Amamapare (IDAMA)"
  },
  {
   value: "\"Ambon (IDAMQ)",
   label: "\"Ambon (IDAMQ)"
  },
  {
   value: "\"Ampenan (IDAMP)",
   label: "\"Ampenan (IDAMP)"
  },
  {
   value: "Api Api (IDAPI)",
   label: "Api Api (IDAPI)"
  },
  {
   value: "\"Arjuna (IDAJN)",
   label: "\"Arjuna (IDAJN)"
  },
  {
   value: "Aroe Bay (IDARB)",
   label: "Aroe Bay (IDARB)"
  },
  {
   value: "Arun (IDAUN)",
   label: "Arun (IDAUN)"
  },
  {
   value: "Atambua (IDABU)",
   label: "Atambua (IDABU)"
  },
  {
   value: "Bade (IDBXD)",
   label: "Bade (IDBXD)"
  },
  {
   value: "Bajawa (IDBJW)",
   label: "Bajawa (IDBJW)"
  },
  {
   value: "\"Balikpapan (IDBPN)",
   label: "\"Balikpapan (IDBPN)"
  },
  {
   value: "Balongan Terminal (IDBAL)",
   label: "Balongan Terminal (IDBAL)"
  },
  {
   value: "Banaina (IDNAF)",
   label: "Banaina (IDNAF)"
  },
  {
   value: "Banda Aceh (IDBTJ)",
   label: "Banda Aceh (IDBTJ)"
  },
  {
   value: "Bandanaira (IDNDA)",
   label: "Bandanaira (IDNDA)"
  },
  {
   value: "Bandar Lampung (IDTKG)",
   label: "Bandar Lampung (IDTKG)"
  },
  {
   value: "\"Bandung (IDBDO)",
   label: "\"Bandung (IDBDO)"
  },
  {
   value: "Banggai (IDBGG)",
   label: "Banggai (IDBGG)"
  },
  {
   value: "Banjarmasin (IDBDJ)",
   label: "Banjarmasin (IDBDJ)"
  },
  {
   value: "\"Banjuwangi (IDBJU)",
   label: "\"Banjuwangi (IDBJU)"
  },
  {
   value: "Kelebia (HUKEL)",
   label: "Kelebia (HUKEL)"
  },
  {
   value: "Kiskunfelegyhaza (HUKIS)",
   label: "Kiskunfelegyhaza (HUKIS)"
  },
  {
   value: "Kiskunhalas (HUKSK)",
   label: "Kiskunhalas (HUKSK)"
  },
  {
   value: "Komarom (HUKOM)",
   label: "Komarom (HUKOM)"
  },
  {
   value: "Koszeg (HUKOS)",
   label: "Koszeg (HUKOS)"
  },
  {
   value: "Kotegyan (HUKOT)",
   label: "Kotegyan (HUKOT)"
  },
  {
   value: "Letenye (HULET)",
   label: "Letenye (HULET)"
  },
  {
   value: "Lokoshaza (HULOK)",
   label: "Lokoshaza (HULOK)"
  },
  {
   value: "Magyarboly (HUMGB)",
   label: "Magyarboly (HUMGB)"
  },
  {
   value: "Magyarfalva (HUMGF)",
   label: "Magyarfalva (HUMGF)"
  },
  {
   value: "Mezokoevesd (HUMEZ)",
   label: "Mezokoevesd (HUMEZ)"
  },
  {
   value: "Mirelite (HUMIR)",
   label: "Mirelite (HUMIR)"
  },
  {
   value: "Miskolc (HUMCQ)",
   label: "Miskolc (HUMCQ)"
  },
  {
   value: "Mohacs (HUMOH)",
   label: "Mohacs (HUMOH)"
  },
  {
   value: "Murakeresztur (HUMUR)",
   label: "Murakeresztur (HUMUR)"
  },
  {
   value: "Nagyatad (HUNGT)",
   label: "Nagyatad (HUNGT)"
  },
  {
   value: "Nagykanizsa (HUNGY)",
   label: "Nagykanizsa (HUNGY)"
  },
  {
   value: "Nagykoros (HUNKS)",
   label: "Nagykoros (HUNKS)"
  },
  {
   value: "Nagylak (HUNAG)",
   label: "Nagylak (HUNAG)"
  },
  {
   value: "Nagyreede (HUNGD)",
   label: "Nagyreede (HUNGD)"
  },
  {
   value: "Nyirabrany (HUNYI)",
   label: "Nyirabrany (HUNYI)"
  },
  {
   value: "Nyiregyhaza (HUNGH)",
   label: "Nyiregyhaza (HUNGH)"
  },
  {
   value: "Oroshaza (HUORS)",
   label: "Oroshaza (HUORS)"
  },
  {
   value: "Papa (HUPAP)",
   label: "Papa (HUPAP)"
  },
  {
   value: "Parassapuszta (HUPAR)",
   label: "Parassapuszta (HUPAR)"
  },
  {
   value: "Pecs (HUPEC)",
   label: "Pecs (HUPEC)"
  },
  {
   value: "Pillisvorosvar (HUPLL)",
   label: "Pillisvorosvar (HUPLL)"
  },
  {
   value: "Rabafuzes (HURAB)",
   label: "Rabafuzes (HURAB)"
  },
  {
   value: "Rackeve (HURAA)",
   label: "Rackeve (HURAA)"
  },
  {
   value: "Rajka (HURJK)",
   label: "Rajka (HURJK)"
  },
  {
   value: "Rajkabrany (HURJB)",
   label: "Rajkabrany (HURJB)"
  },
  {
   value: "Redics (HURED)",
   label: "Redics (HURED)"
  },
  {
   value: "Repcelek (HURPK)",
   label: "Repcelek (HURPK)"
  },
  {
   value: "Retsag (HURTG)",
   label: "Retsag (HURTG)"
  },
  {
   value: "Roszke (HUROS)",
   label: "Roszke (HUROS)"
  },
  {
   value: "Saarmelleek (HUSOB)",
   label: "Saarmelleek (HUSOB)"
  },
  {
   value: "Salgotarjan (HUSAL)",
   label: "Salgotarjan (HUSAL)"
  },
  {
   value: "Satoraljaujhely (HUSAT)",
   label: "Satoraljaujhely (HUSAT)"
  },
  {
   value: "Somoskoujfalu (HUSOM)",
   label: "Somoskoujfalu (HUSOM)"
  },
  {
   value: "Sopron (HUSOP)",
   label: "Sopron (HUSOP)"
  },
  {
   value: "Sopron Gysev (HUSPG)",
   label: "Sopron Gysev (HUSPG)"
  },
  {
   value: "St Marc (HTSMC)",
   label: "St Marc (HTSMC)"
  },
  {
   value: "Agerdomajor (HUAGE)",
   label: "Agerdomajor (HUAGE)"
  },
  {
   value: "Agfalva (HUAGF)",
   label: "Agfalva (HUAGF)"
  },
  {
   value: "Aggtelek (HUAGG)",
   label: "Aggtelek (HUAGG)"
  },
  {
   value: "Artand (HUART)",
   label: "Artand (HUART)"
  },
  {
   value: "Bajansenye (HUBAJ)",
   label: "Bajansenye (HUBAJ)"
  },
  {
   value: "Balassagyarmat (HUBAL)",
   label: "Balassagyarmat (HUBAL)"
  },
  {
   value: "Balatonboglar (HUBLT)",
   label: "Balatonboglar (HUBLT)"
  },
  {
   value: "Banreve (HUBAN)",
   label: "Banreve (HUBAN)"
  },
  {
   value: "Bekescsaba (HUBEK)",
   label: "Bekescsaba (HUBEK)"
  },
  {
   value: "Biharkersztes (HUBIH)",
   label: "Biharkersztes (HUBIH)"
  },
  {
   value: "Bonyhad (HUBON)",
   label: "Bonyhad (HUBON)"
  },
  {
   value: "Bucsu (HUBUC)",
   label: "Bucsu (HUBUC)"
  },
  {
   value: "Budapest (HUBUD)",
   label: "Budapest (HUBUD)"
  },
  {
   value: "Cegled (HUCEG)",
   label: "Cegled (HUCEG)"
  },
  {
   value: "Csengersima (HUCSE)",
   label: "Csengersima (HUCSE)"
  },
  {
   value: "Csongrad (HUCGD)",
   label: "Csongrad (HUCGD)"
  },
  {
   value: "Debrecen (HUDEB)",
   label: "Debrecen (HUDEB)"
  },
  {
   value: "Dravaszabolcs (HUDRA)",
   label: "Dravaszabolcs (HUDRA)"
  },
  {
   value: "Dunaharaszti (HUDSZ)",
   label: "Dunaharaszti (HUDSZ)"
  },
  {
   value: "Dunakeszi (HUDKZ)",
   label: "Dunakeszi (HUDKZ)"
  },
  {
   value: "Eger (HUEGR)",
   label: "Eger (HUEGR)"
  },
  {
   value: "Eperjeske (HUEPE)",
   label: "Eperjeske (HUEPE)"
  },
  {
   value: "Erdoekertes (HURDE)",
   label: "Erdoekertes (HURDE)"
  },
  {
   value: "Esztergom (HUEST)",
   label: "Esztergom (HUEST)"
  },
  {
   value: "Fertoujlak (HUFER)",
   label: "Fertoujlak (HUFER)"
  },
  {
   value: "Gödöllö (HUGDL)",
   label: "Gödöllö (HUGDL)"
  },
  {
   value: "Gyekenyes (HUGYE)",
   label: "Gyekenyes (HUGYE)"
  },
  {
   value: "Gyomaendrod (HUGYH)",
   label: "Gyomaendrod (HUGYH)"
  },
  {
   value: "Györ (HUGYO)",
   label: "Györ (HUGYO)"
  },
  {
   value: "Gyula (HUGYU)",
   label: "Gyula (HUGYU)"
  },
  {
   value: "Hajduboszoermeny (HUHAJ)",
   label: "Hajduboszoermeny (HUHAJ)"
  },
  {
   value: "Hater (HUHRY)",
   label: "Hater (HUHRY)"
  },
  {
   value: "Hatvan (HUHAT)",
   label: "Hatvan (HUHAT)"
  },
  {
   value: "Hegyeshalom (HUHEG)",
   label: "Hegyeshalom (HUHEG)"
  },
  {
   value: "Hercegszanto (HUHER)",
   label: "Hercegszanto (HUHER)"
  },
  {
   value: "Hidasnemeti (HUHIS)",
   label: "Hidasnemeti (HUHIS)"
  },
  {
   value: "Hodmezovasarhely (HUHDM)",
   label: "Hodmezovasarhely (HUHDM)"
  },
  {
   value: "Ipolytarnoc (HUIPO)",
   label: "Ipolytarnoc (HUIPO)"
  },
  {
   value: "Kaposvar (HUKPS)",
   label: "Kaposvar (HUKPS)"
  },
  {
   value: "Kapuvar (HUKVP)",
   label: "Kapuvar (HUKVP)"
  },
  {
   value: "Kecskemet (HUKCS)",
   label: "Kecskemet (HUKCS)"
  },
  {
   value: "Trujillo (HNTJI)",
   label: "Trujillo (HNTJI)"
  },
  {
   value: "Utila (HNUII)",
   label: "Utila (HNUII)"
  },
  {
   value: "Victoria (HNVTA)",
   label: "Victoria (HNVTA)"
  },
  {
   value: "Villa Nueva (HNVLN)",
   label: "Villa Nueva (HNVLN)"
  },
  {
   value: "Bakar (HRBAK)",
   label: "Bakar (HRBAK)"
  },
  {
   value: "Dubrovnik (HRDBV)",
   label: "Dubrovnik (HRDBV)"
  },
  {
   value: "Dugi Rat (HRDUR)",
   label: "Dugi Rat (HRDUR)"
  },
  {
   value: "Hvar (HRHVA)",
   label: "Hvar (HRHVA)"
  },
  {
   value: "Korcula (HRKOR)",
   label: "Korcula (HRKOR)"
  },
  {
   value: "Mali Losinj (HRLSZ)",
   label: "Mali Losinj (HRLSZ)"
  },
  {
   value: "Maslenica (HRMAS)",
   label: "Maslenica (HRMAS)"
  },
  {
   value: "Omisalj (HROMI)",
   label: "Omisalj (HROMI)"
  },
  {
   value: "Osijek (HROSI)",
   label: "Osijek (HROSI)"
  },
  {
   value: "Ploce (HRPLE)",
   label: "Ploce (HRPLE)"
  },
  {
   value: "Pula (HRPUY)",
   label: "Pula (HRPUY)"
  },
  {
   value: "Rasa (HRRAS)",
   label: "Rasa (HRRAS)"
  },
  {
   value: "Rijeka Bakar (HRRJK)",
   label: "Rijeka Bakar (HRRJK)"
  },
  {
   value: "Rijeka Susak (HRSUS)",
   label: "Rijeka Susak (HRSUS)"
  },
  {
   value: "Rovinj (HRROV)",
   label: "Rovinj (HRROV)"
  },
  {
   value: "Senj (HRSEN)",
   label: "Senj (HRSEN)"
  },
  {
   value: "Sibenik (HRSIB)",
   label: "Sibenik (HRSIB)"
  },
  {
   value: "Solin (HRSLN)",
   label: "Solin (HRSLN)"
  },
  {
   value: "Split (HRSPU)",
   label: "Split (HRSPU)"
  },
  {
   value: "Sucurac (HRSUC)",
   label: "Sucurac (HRSUC)"
  },
  {
   value: "Sveti Kajo (HRSVK)",
   label: "Sveti Kajo (HRSVK)"
  },
  {
   value: "Virovitica (HRVRC)",
   label: "Virovitica (HRVRC)"
  },
  {
   value: "Vranjic (HRVRA)",
   label: "Vranjic (HRVRA)"
  },
  {
   value: "Vrbovec (HRVRB)",
   label: "Vrbovec (HRVRB)"
  },
  {
   value: "Zadar (HRZAD)",
   label: "Zadar (HRZAD)"
  },
  {
   value: "Zagreb (HRZAG)",
   label: "Zagreb (HRZAG)"
  },
  {
   value: "Cap-Haitien (HTCAP)",
   label: "Cap-Haitien (HTCAP)"
  },
  {
   value: "Fond Mombin (HTFOM)",
   label: "Fond Mombin (HTFOM)"
  },
  {
   value: "Fort Liberte (HTFLI)",
   label: "Fort Liberte (HTFLI)"
  },
  {
   value: "Gonaïves (HTGVS)",
   label: "Gonaïves (HTGVS)"
  },
  {
   value: "Jacmel (HTJAK)",
   label: "Jacmel (HTJAK)"
  },
  {
   value: "Jérémie (HTJEE)",
   label: "Jérémie (HTJEE)"
  },
  {
   value: "Laffiteau (HTLFF)",
   label: "Laffiteau (HTLFF)"
  },
  {
   value: "Les Cayes (HTACA)",
   label: "Les Cayes (HTACA)"
  },
  {
   value: "Miragoane (HTMIR)",
   label: "Miragoane (HTMIR)"
  },
  {
   value: "Petit Goave (HTPEG)",
   label: "Petit Goave (HTPEG)"
  },
  {
   value: "Port de Paix (HTPDP)",
   label: "Port de Paix (HTPDP)"
  },
  {
   value: "Port-au-Prince (HTPAP)",
   label: "Port-au-Prince (HTPAP)"
  },
  {
   value: "Tolo Harbour (HKTOL)",
   label: "Tolo Harbour (HKTOL)"
  },
  {
   value: "Tsuen Wan (HKZTW)",
   label: "Tsuen Wan (HKZTW)"
  },
  {
   value: "Victoria (HKVIC)",
   label: "Victoria (HKVIC)"
  },
  {
   value: "Ahuas (HNAHS)",
   label: "Ahuas (HNAHS)"
  },
  {
   value: "Amapala (HNAMP)",
   label: "Amapala (HNAMP)"
  },
  {
   value: "Brus Laguna (HNBHG)",
   label: "Brus Laguna (HNBHG)"
  },
  {
   value: "Catacamas (HNCAA)",
   label: "Catacamas (HNCAA)"
  },
  {
   value: "Cauquira (HNCDD)",
   label: "Cauquira (HNCDD)"
  },
  {
   value: "Choloma (HNCHO)",
   label: "Choloma (HNCHO)"
  },
  {
   value: "Comayquella (HNCOM)",
   label: "Comayquella (HNCOM)"
  },
  {
   value: "Copan (HNRUY)",
   label: "Copan (HNRUY)"
  },
  {
   value: "Coronel E Soto Cano Ab (HNENQ)",
   label: "Coronel E Soto Cano Ab (HNENQ)"
  },
  {
   value: "Coyoles (HNCYL)",
   label: "Coyoles (HNCYL)"
  },
  {
   value: "Erandique (HNEDQ)",
   label: "Erandique (HNEDQ)"
  },
  {
   value: "Gracias (HNGAC)",
   label: "Gracias (HNGAC)"
  },
  {
   value: "Gualaco (HNGUO)",
   label: "Gualaco (HNGUO)"
  },
  {
   value: "Guanaja (HNGJA)",
   label: "Guanaja (HNGJA)"
  },
  {
   value: "Henecan (HNHNN)",
   label: "Henecan (HNHNN)"
  },
  {
   value: "Iriona (HNIRN)",
   label: "Iriona (HNIRN)"
  },
  {
   value: "Juticalpa (HNJUT)",
   label: "Juticalpa (HNJUT)"
  },
  {
   value: "La Ceiba (HNLCE)",
   label: "La Ceiba (HNLCE)"
  },
  {
   value: "La Esperanza (HNLEZ)",
   label: "La Esperanza (HNLEZ)"
  },
  {
   value: "La Union (HNLUI)",
   label: "La Union (HNLUI)"
  },
  {
   value: "Las Limas (HNLLH)",
   label: "Las Limas (HNLLH)"
  },
  {
   value: "Limon (HNLMH)",
   label: "Limon (HNLMH)"
  },
  {
   value: "Marcala (HNMRJ)",
   label: "Marcala (HNMRJ)"
  },
  {
   value: "Olanchito (HNOAN)",
   label: "Olanchito (HNOAN)"
  },
  {
   value: "Palacios (HNPCH)",
   label: "Palacios (HNPCH)"
  },
  {
   value: "Puerto Castilla (HNPCA)",
   label: "Puerto Castilla (HNPCA)"
  },
  {
   value: "Puerto Cortés (HNPCR)",
   label: "Puerto Cortés (HNPCR)"
  },
  {
   value: "Puerto Lempira (HNPEU)",
   label: "Puerto Lempira (HNPEU)"
  },
  {
   value: "Roatan (HNRTB)",
   label: "Roatan (HNRTB)"
  },
  {
   value: "Salamar (HNSLM)",
   label: "Salamar (HNSLM)"
  },
  {
   value: "San Esteban (HNSET)",
   label: "San Esteban (HNSET)"
  },
  {
   value: "San Lorenzo (HNSLO)",
   label: "San Lorenzo (HNSLO)"
  },
  {
   value: "San Pedro Sula (HNSAP)",
   label: "San Pedro Sula (HNSAP)"
  },
  {
   value: "Santa Rosa Copan (HNSDH)",
   label: "Santa Rosa Copan (HNSDH)"
  },
  {
   value: "Sulaco (HNSCD)",
   label: "Sulaco (HNSCD)"
  },
  {
   value: "Tegucigalpa (HNTGU)",
   label: "Tegucigalpa (HNTGU)"
  },
  {
   value: "Tela (HNTEA)",
   label: "Tela (HNTEA)"
  },
  {
   value: "Tocoa (HNTCF)",
   label: "Tocoa (HNTCF)"
  },
  {
   value: "Agana (GUAGA)",
   label: "Agana (GUAGA)"
  },
  {
   value: "Apra (Agana) (GUAPR)",
   label: "Apra (Agana) (GUAPR)"
  },
  {
   value: "Dededo (GUDED)",
   label: "Dededo (GUDED)"
  },
  {
   value: "Guam (GUGUM)",
   label: "Guam (GUGUM)"
  },
  {
   value: "Bissau (GWOXB)",
   label: "Bissau (GWOXB)"
  },
  {
   value: "Bolama (GWBOL)",
   label: "Bolama (GWBOL)"
  },
  {
   value: "Bubaque (GWBQE)",
   label: "Bubaque (GWBQE)"
  },
  {
   value: "Cacheu (GWCAC)",
   label: "Cacheu (GWCAC)"
  },
  {
   value: "Aishalton (GYAHL)",
   label: "Aishalton (GYAHL)"
  },
  {
   value: "Annai (GYNAI)",
   label: "Annai (GYNAI)"
  },
  {
   value: "Baramita (GYBMJ)",
   label: "Baramita (GYBMJ)"
  },
  {
   value: "Bartica (GYGFO)",
   label: "Bartica (GYGFO)"
  },
  {
   value: "Bemichi (GYBCG)",
   label: "Bemichi (GYBCG)"
  },
  {
   value: "Ekereku (GYEKE)",
   label: "Ekereku (GYEKE)"
  },
  {
   value: "Georgetown (GYGEO)",
   label: "Georgetown (GYGEO)"
  },
  {
   value: "Imbaimadai (GYIMB)",
   label: "Imbaimadai (GYIMB)"
  },
  {
   value: "Kaieteur (GYKAI)",
   label: "Kaieteur (GYKAI)"
  },
  {
   value: "Kamarang (GYKAR)",
   label: "Kamarang (GYKAR)"
  },
  {
   value: "Karanambo (GYKRM)",
   label: "Karanambo (GYKRM)"
  },
  {
   value: "Karasabai (GYKRG)",
   label: "Karasabai (GYKRG)"
  },
  {
   value: "Kato (GYKTO)",
   label: "Kato (GYKTO)"
  },
  {
   value: "Konawaruk (GYKKG)",
   label: "Konawaruk (GYKKG)"
  },
  {
   value: "Kurupung (GYKPG)",
   label: "Kurupung (GYKPG)"
  },
  {
   value: "Lethem (GYLTM)",
   label: "Lethem (GYLTM)"
  },
  {
   value: "Lumid Pau (GYLUB)",
   label: "Lumid Pau (GYLUB)"
  },
  {
   value: "Mabaruma (GYUSI)",
   label: "Mabaruma (GYUSI)"
  },
  {
   value: "Mahdia (GYMHA)",
   label: "Mahdia (GYMHA)"
  },
  {
   value: "Maikwak (GYVEG)",
   label: "Maikwak (GYVEG)"
  },
  {
   value: "Matthews Ridge (GYMWJ)",
   label: "Matthews Ridge (GYMWJ)"
  },
  {
   value: "Monkey Mountain (GYMYM)",
   label: "Monkey Mountain (GYMYM)"
  },
  {
   value: "New Amsterdam (GYNAM)",
   label: "New Amsterdam (GYNAM)"
  },
  {
   value: "Ogle (GYOGL)",
   label: "Ogle (GYOGL)"
  },
  {
   value: "Orinduik (GYORJ)",
   label: "Orinduik (GYORJ)"
  },
  {
   value: "Paramakotoi (GYPMT)",
   label: "Paramakotoi (GYPMT)"
  },
  {
   value: "Paruima (GYPRR)",
   label: "Paruima (GYPRR)"
  },
  {
   value: "Pipillipai (GYPIQ)",
   label: "Pipillipai (GYPIQ)"
  },
  {
   value: "Port Kaituma (GYPKM)",
   label: "Port Kaituma (GYPKM)"
  },
  {
   value: "Sandcreek (GYSDC)",
   label: "Sandcreek (GYSDC)"
  },
  {
   value: "Skeldon (GYSKM)",
   label: "Skeldon (GYSKM)"
  },
  {
   value: "Thimery (GYTHI)",
   label: "Thimery (GYTHI)"
  },
  {
   value: "Hong Kong (HKHKG)",
   label: "Hong Kong (HKHKG)"
  },
  {
   value: "Kowloon (HKKWN)",
   label: "Kowloon (HKKWN)"
  },
  {
   value: "Taino (HKTNO)",
   label: "Taino (HKTNO)"
  },
  {
   value: "Zea Island (GRZEA)",
   label: "Zea Island (GRZEA)"
  },
  {
   value: "Leith Harbour (GSLEH)",
   label: "Leith Harbour (GSLEH)"
  },
  {
   value: "Aduana (GTADU)",
   label: "Aduana (GTADU)"
  },
  {
   value: "Amatitlan (GTAMA)",
   label: "Amatitlan (GTAMA)"
  },
  {
   value: "Antigua (GTANT)",
   label: "Antigua (GTANT)"
  },
  {
   value: "Carmelita (GTCMM)",
   label: "Carmelita (GTCMM)"
  },
  {
   value: "Champerico (GTCHR)",
   label: "Champerico (GTCHR)"
  },
  {
   value: "Chimaltenango (GTCHI)",
   label: "Chimaltenango (GTCHI)"
  },
  {
   value: "Chiquimula (GTCIQ)",
   label: "Chiquimula (GTCIQ)"
  },
  {
   value: "Coban (GTCBV)",
   label: "Coban (GTCBV)"
  },
  {
   value: "El Naranjo (GTENJ)",
   label: "El Naranjo (GTENJ)"
  },
  {
   value: "El Rancho (GTERH)",
   label: "El Rancho (GTERH)"
  },
  {
   value: "Escuintla (GTESC)",
   label: "Escuintla (GTESC)"
  },
  {
   value: "Flores (GTFRS)",
   label: "Flores (GTFRS)"
  },
  {
   value: "Fraijanes (GTFRA)",
   label: "Fraijanes (GTFRA)"
  },
  {
   value: "Guatemala City (GTGUA)",
   label: "Guatemala City (GTGUA)"
  },
  {
   value: "Huehuetenango (GTHUG)",
   label: "Huehuetenango (GTHUG)"
  },
  {
   value: "La Fragua (GTLAF)",
   label: "La Fragua (GTLAF)"
  },
  {
   value: "Livingston (GTLIV)",
   label: "Livingston (GTLIV)"
  },
  {
   value: "Mazatenango (GTMAZ)",
   label: "Mazatenango (GTMAZ)"
  },
  {
   value: "Melchor De Menco (GTMCR)",
   label: "Melchor De Menco (GTMCR)"
  },
  {
   value: "Palin (GTPAL)",
   label: "Palin (GTPAL)"
  },
  {
   value: "Paso Caballos (GTPCG)",
   label: "Paso Caballos (GTPCG)"
  },
  {
   value: "Poptun (GTPON)",
   label: "Poptun (GTPON)"
  },
  {
   value: "Puerto Barrios (GTPBR)",
   label: "Puerto Barrios (GTPBR)"
  },
  {
   value: "Puerto Quetzal (GTPRQ)",
   label: "Puerto Quetzal (GTPRQ)"
  },
  {
   value: "Retalhuleu (GTRTE)",
   label: "Retalhuleu (GTRTE)"
  },
  {
   value: "Rio Hondo (GTRIH)",
   label: "Rio Hondo (GTRIH)"
  },
  {
   value: "Rubelsanto (GTRUV)",
   label: "Rubelsanto (GTRUV)"
  },
  {
   value: "San Jose (GTSNJ)",
   label: "San Jose (GTSNJ)"
  },
  {
   value: "San Lucas (GTSAL)",
   label: "San Lucas (GTSAL)"
  },
  {
   value: "Santo Tomas de Castilla (GTSTC)",
   label: "Santo Tomas de Castilla (GTSTC)"
  },
  {
   value: "Santo Tomas Milpas (GTSTM)",
   label: "Santo Tomas Milpas (GTSTM)"
  },
  {
   value: "Siquinala (GTSIQ)",
   label: "Siquinala (GTSIQ)"
  },
  {
   value: "Teculutan (GTTEC)",
   label: "Teculutan (GTTEC)"
  },
  {
   value: "Tiguisate (GTTIG)",
   label: "Tiguisate (GTTIG)"
  },
  {
   value: "Tikal (GTTKM)",
   label: "Tikal (GTTKM)"
  },
  {
   value: "Uaxactun (GTUAX)",
   label: "Uaxactun (GTUAX)"
  },
  {
   value: "Villa Nueva (GTVIN)",
   label: "Villa Nueva (GTVIN)"
  },
  {
   value: "Zacapa (GTZAC)",
   label: "Zacapa (GTZAC)"
  },
  {
   value: "Skiros (GRSKU)",
   label: "Skiros (GRSKU)"
  },
  {
   value: "Skopelos (GRSKO)",
   label: "Skopelos (GRSKO)"
  },
  {
   value: "Skydra (GRSKY)",
   label: "Skydra (GRSKY)"
  },
  {
   value: "Soussaki (GRSOU)",
   label: "Soussaki (GRSOU)"
  },
  {
   value: "Sparti (GRSPA)",
   label: "Sparti (GRSPA)"
  },
  {
   value: "Spetses (GRSPE)",
   label: "Spetses (GRSPE)"
  },
  {
   value: "St George (GRSGB)",
   label: "St George (GRSGB)"
  },
  {
   value: "Stavros Halkidikis (GRSHA)",
   label: "Stavros Halkidikis (GRSHA)"
  },
  {
   value: "Stavroupolis (GRSTA)",
   label: "Stavroupolis (GRSTA)"
  },
  {
   value: "Steni Evvias (GRSTE)",
   label: "Steni Evvias (GRSTE)"
  },
  {
   value: "Stratoni (GRSTI)",
   label: "Stratoni (GRSTI)"
  },
  {
   value: "Stylida \/ STYLIS (GRSYS)",
   label: "Stylida \/ STYLIS (GRSYS)"
  },
  {
   value: "Stylinda (GRSTY)",
   label: "Stylinda (GRSTY)"
  },
  {
   value: "Suda Bay (GRSUD)",
   label: "Suda Bay (GRSUD)"
  },
  {
   value: "Symi (GRSYM)",
   label: "Symi (GRSYM)"
  },
  {
   value: "Syra (Syros) (GRJSY)",
   label: "Syra (Syros) (GRJSY)"
  },
  {
   value: "Thasos (GRTSO)",
   label: "Thasos (GRTSO)"
  },
  {
   value: "Theben (GRTHE)",
   label: "Theben (GRTHE)"
  },
  {
   value: "Thessaloniki (GRSKG)",
   label: "Thessaloniki (GRSKG)"
  },
  {
   value: "Thira (GRJTR)",
   label: "Thira (GRJTR)"
  },
  {
   value: "Thirassia (GRTRS)",
   label: "Thirassia (GRTRS)"
  },
  {
   value: "Thivai (GRTVA)",
   label: "Thivai (GRTVA)"
  },
  {
   value: "Tinos (GRTIN)",
   label: "Tinos (GRTIN)"
  },
  {
   value: "Trachia Argolidas (GRTAL)",
   label: "Trachia Argolidas (GRTAL)"
  },
  {
   value: "Trachia Fafplio (GRTFP)",
   label: "Trachia Fafplio (GRTFP)"
  },
  {
   value: "Traganon (GRTGN)",
   label: "Traganon (GRTGN)"
  },
  {
   value: "Tranovalto (GRTRA)",
   label: "Tranovalto (GRTRA)"
  },
  {
   value: "Trikala (GRTRI)",
   label: "Trikala (GRTRI)"
  },
  {
   value: "Tripolis (GRTRP)",
   label: "Tripolis (GRTRP)"
  },
  {
   value: "Varibobi (GRVAR)",
   label: "Varibobi (GRVAR)"
  },
  {
   value: "Vathy Samou (GRVTH)",
   label: "Vathy Samou (GRVTH)"
  },
  {
   value: "Velo (GRVEL)",
   label: "Velo (GRVEL)"
  },
  {
   value: "Veria (GRVER)",
   label: "Veria (GRVER)"
  },
  {
   value: "Volos (GRVOL)",
   label: "Volos (GRVOL)"
  },
  {
   value: "Vorino (GRVOR)",
   label: "Vorino (GRVOR)"
  },
  {
   value: "Votanikos (GRVOT)",
   label: "Votanikos (GRVOT)"
  },
  {
   value: "Xanthi (GRXAN)",
   label: "Xanthi (GRXAN)"
  },
  {
   value: "Yali Island (GRYLI)",
   label: "Yali Island (GRYLI)"
  },
  {
   value: "Yiannitsa (GRYNN)",
   label: "Yiannitsa (GRYNN)"
  },
  {
   value: "Zakinthos Is (GRZTH)",
   label: "Zakinthos Is (GRZTH)"
  },
  {
   value: "Zante (GRZNT)",
   label: "Zante (GRZNT)"
  },
  {
   value: "Parga (GRPAR)",
   label: "Parga (GRPAR)"
  },
  {
   value: "Paros (GRPAS)",
   label: "Paros (GRPAS)"
  },
  {
   value: "Patmos (GRPMS)",
   label: "Patmos (GRPMS)"
  },
  {
   value: "Patras (GRGPA)",
   label: "Patras (GRGPA)"
  },
  {
   value: "Paxi (GRPAX)",
   label: "Paxi (GRPAX)"
  },
  {
   value: "Perama (GRPER)",
   label: "Perama (GRPER)"
  },
  {
   value: "Peristeri (GRPRI)",
   label: "Peristeri (GRPRI)"
  },
  {
   value: "Pikermi (GRPIK)",
   label: "Pikermi (GRPIK)"
  },
  {
   value: "Pilos (GRPIL)",
   label: "Pilos (GRPIL)"
  },
  {
   value: "Piraeus (GRPIR)",
   label: "Piraeus (GRPIR)"
  },
  {
   value: "Platea (GRPLT)",
   label: "Platea (GRPLT)"
  },
  {
   value: "Poligyros (GRPOL)",
   label: "Poligyros (GRPOL)"
  },
  {
   value: "Politika (GRPTK)",
   label: "Politika (GRPTK)"
  },
  {
   value: "Poros Kefallinias (GRPKE)",
   label: "Poros Kefallinias (GRPKE)"
  },
  {
   value: "Poros Trizinias (GRPTR)",
   label: "Poros Trizinias (GRPTR)"
  },
  {
   value: "Porto Heli (GRPHE)",
   label: "Porto Heli (GRPHE)"
  },
  {
   value: "Porto Kheli (GRPKH)",
   label: "Porto Kheli (GRPKH)"
  },
  {
   value: "Porto Lagos (GRPTL)",
   label: "Porto Lagos (GRPTL)"
  },
  {
   value: "Preveza\/Lefkas (GRPVK)",
   label: "Preveza\/Lefkas (GRPVK)"
  },
  {
   value: "Pyli (GRPLI)",
   label: "Pyli (GRPLI)"
  },
  {
   value: "Pylos (GRPYL)",
   label: "Pylos (GRPYL)"
  },
  {
   value: "Pyrgos (GRPYR)",
   label: "Pyrgos (GRPYR)"
  },
  {
   value: "Pythagario (GRPYT)",
   label: "Pythagario (GRPYT)"
  },
  {
   value: "Rafina (GRRAF)",
   label: "Rafina (GRRAF)"
  },
  {
   value: "Rentis (GRREN)",
   label: "Rentis (GRREN)"
  },
  {
   value: "Rethymnon (GRRET)",
   label: "Rethymnon (GRRET)"
  },
  {
   value: "Rhodes (GRRHO)",
   label: "Rhodes (GRRHO)"
  },
  {
   value: "Rio (GRRIO)",
   label: "Rio (GRRIO)"
  },
  {
   value: "Salamis (GRSAL)",
   label: "Salamis (GRSAL)"
  },
  {
   value: "Samos (GRSMI)",
   label: "Samos (GRSMI)"
  },
  {
   value: "Samothraki (GRSAM)",
   label: "Samothraki (GRSAM)"
  },
  {
   value: "Savalia (GRSVL)",
   label: "Savalia (GRSVL)"
  },
  {
   value: "Seriphos Island (GRSER)",
   label: "Seriphos Island (GRSER)"
  },
  {
   value: "Serrai (GRSRI)",
   label: "Serrai (GRSRI)"
  },
  {
   value: "Serres (GRSRS)",
   label: "Serres (GRSRS)"
  },
  {
   value: "Sidirokastro (GRSID)",
   label: "Sidirokastro (GRSID)"
  },
  {
   value: "Sifnos (GRSIF)",
   label: "Sifnos (GRSIF)"
  },
  {
   value: "Sikionia (GRSIK)",
   label: "Sikionia (GRSIK)"
  },
  {
   value: "Sitia (GRJSH)",
   label: "Sitia (GRJSH)"
  },
  {
   value: "Skala Lakonias (GRSKL)",
   label: "Skala Lakonias (GRSKL)"
  },
  {
   value: "Skaramanga (GRSKA)",
   label: "Skaramanga (GRSKA)"
  },
  {
   value: "Skiathos (GRJSI)",
   label: "Skiathos (GRJSI)"
  },
  {
   value: "Messogia (GRMES)",
   label: "Messogia (GRMES)"
  },
  {
   value: "Messolongion (GRMEL)",
   label: "Messolongion (GRMEL)"
  },
  {
   value: "Mesta Hiou (GRMHI)",
   label: "Mesta Hiou (GRMHI)"
  },
  {
   value: "Metamorfosis (GRMMS)",
   label: "Metamorfosis (GRMMS)"
  },
  {
   value: "Methoni (GRMET)",
   label: "Methoni (GRMET)"
  },
  {
   value: "Mikonos\/MYKONOS (GRJMK)",
   label: "Mikonos\/MYKONOS (GRJMK)"
  },
  {
   value: "Milos (GRMLO)",
   label: "Milos (GRMLO)"
  },
  {
   value: "Missimi (GRMIS)",
   label: "Missimi (GRMIS)"
  },
  {
   value: "Monemvassia (GRMON)",
   label: "Monemvassia (GRMON)"
  },
  {
   value: "Moschaton (GRMOS)",
   label: "Moschaton (GRMOS)"
  },
  {
   value: "Moudros (GRMDR)",
   label: "Moudros (GRMDR)"
  },
  {
   value: "Moutsonna (GRMOU)",
   label: "Moutsonna (GRMOU)"
  },
  {
   value: "Mylaki (GRMYL)",
   label: "Mylaki (GRMYL)"
  },
  {
   value: "Myrina (GRMYR)",
   label: "Myrina (GRMYR)"
  },
  {
   value: "Mytilene (GRMJT)",
   label: "Mytilene (GRMJT)"
  },
  {
   value: "Nafplion (GRNAF)",
   label: "Nafplion (GRNAF)"
  },
  {
   value: "Naoussa (GRNSA)",
   label: "Naoussa (GRNSA)"
  },
  {
   value: "Nauplia (GRNPL)",
   label: "Nauplia (GRNPL)"
  },
  {
   value: "Navarino (GRNAV)",
   label: "Navarino (GRNAV)"
  },
  {
   value: "Navpaktos (GRNPK)",
   label: "Navpaktos (GRNPK)"
  },
  {
   value: "Naxos (GRJNX)",
   label: "Naxos (GRJNX)"
  },
  {
   value: "Nea Karvali (GRNKV)",
   label: "Nea Karvali (GRNKV)"
  },
  {
   value: "Nea Moudania (GRNMA)",
   label: "Nea Moudania (GRNMA)"
  },
  {
   value: "Nea Pella (GRNPA)",
   label: "Nea Pella (GRNPA)"
  },
  {
   value: "Nea Playa (GRNPY)",
   label: "Nea Playa (GRNPY)"
  },
  {
   value: "Nea Styra (GRNST)",
   label: "Nea Styra (GRNST)"
  },
  {
   value: "Neapolis (GRNEA)",
   label: "Neapolis (GRNEA)"
  },
  {
   value: "Nemea (GRNME)",
   label: "Nemea (GRNME)"
  },
  {
   value: "Neohorion Kyllinis (GRNKL)",
   label: "Neohorion Kyllinis (GRNKL)"
  },
  {
   value: "Nidrion (GRNID)",
   label: "Nidrion (GRNID)"
  },
  {
   value: "Nissyros (GRNIS)",
   label: "Nissyros (GRNIS)"
  },
  {
   value: "Orchomenos (GRORC)",
   label: "Orchomenos (GRORC)"
  },
  {
   value: "Orei (GRORE)",
   label: "Orei (GRORE)"
  },
  {
   value: "Oropos (GRORO)",
   label: "Oropos (GRORO)"
  },
  {
   value: "Paiania (GRPAI)",
   label: "Paiania (GRPAI)"
  },
  {
   value: "Palaion Faliron (GRPAL)",
   label: "Palaion Faliron (GRPAL)"
  },
  {
   value: "Palea Epidavros (GRPEP)",
   label: "Palea Epidavros (GRPEP)"
  },
  {
   value: "Paleohora Sfakion (GRPSF)",
   label: "Paleohora Sfakion (GRPSF)"
  },
  {
   value: "Pallini (GRPPG)",
   label: "Pallini (GRPPG)"
  },
  {
   value: "Panetolion (GRPAT)",
   label: "Panetolion (GRPAT)"
  },
  {
   value: "Panoi (GRPAN)",
   label: "Panoi (GRPAN)"
  },
  {
   value: "Kifisia (GRKFS)",
   label: "Kifisia (GRKFS)"
  },
  {
   value: "Kilkis (GRKKZ)",
   label: "Kilkis (GRKKZ)"
  },
  {
   value: "Kimolos (GRKMS)",
   label: "Kimolos (GRKMS)"
  },
  {
   value: "Kithira (GRKIT)",
   label: "Kithira (GRKIT)"
  },
  {
   value: "Kolindros (GRKDO)",
   label: "Kolindros (GRKDO)"
  },
  {
   value: "Komotini (GRKOM)",
   label: "Komotini (GRKOM)"
  },
  {
   value: "Korinthos (GRKRT)",
   label: "Korinthos (GRKRT)"
  },
  {
   value: "Koropi (GRKPO)",
   label: "Koropi (GRKPO)"
  },
  {
   value: "Koropion (GRKOR)",
   label: "Koropion (GRKOR)"
  },
  {
   value: "Kos (GRKGS)",
   label: "Kos (GRKGS)"
  },
  {
   value: "Kozani (GRKZI)",
   label: "Kozani (GRKZI)"
  },
  {
   value: "Krioneri (GRKRI)",
   label: "Krioneri (GRKRI)"
  },
  {
   value: "Kylini (GRKYL)",
   label: "Kylini (GRKYL)"
  },
  {
   value: "Kymassi (GRKYM)",
   label: "Kymassi (GRKYM)"
  },
  {
   value: "Kymi (Kimi) (GRKIM)",
   label: "Kymi (Kimi) (GRKIM)"
  },
  {
   value: "Kyparissia (GRKYP)",
   label: "Kyparissia (GRKYP)"
  },
  {
   value: "Kythnos (GRKYT)",
   label: "Kythnos (GRKYT)"
  },
  {
   value: "Lamia (GRLAM)",
   label: "Lamia (GRLAM)"
  },
  {
   value: "Langadhas (GRLAN)",
   label: "Langadhas (GRLAN)"
  },
  {
   value: "Larisa (GRLRA)",
   label: "Larisa (GRLRA)"
  },
  {
   value: "Larmes (GRLRM)",
   label: "Larmes (GRLRM)"
  },
  {
   value: "Larymna (GRLRY)",
   label: "Larymna (GRLRY)"
  },
  {
   value: "Lavrion (Laurium) (GRLAV)",
   label: "Lavrion (Laurium) (GRLAV)"
  },
  {
   value: "Lefkada (GRLEV)",
   label: "Lefkada (GRLEV)"
  },
  {
   value: "Lefkandi (GRLEF)",
   label: "Lefkandi (GRLEF)"
  },
  {
   value: "Lefkimi (GRLFK)",
   label: "Lefkimi (GRLFK)"
  },
  {
   value: "Lemnos (GRLXS)",
   label: "Lemnos (GRLXS)"
  },
  {
   value: "Leonidion (GRLND)",
   label: "Leonidion (GRLND)"
  },
  {
   value: "Leros (GRLRS)",
   label: "Leros (GRLRS)"
  },
  {
   value: "Levadhia (GRLEA)",
   label: "Levadhia (GRLEA)"
  },
  {
   value: "Limni (GRLII)",
   label: "Limni (GRLII)"
  },
  {
   value: "Lixuri (GRLIX)",
   label: "Lixuri (GRLIX)"
  },
  {
   value: "Loutraki (GRLOU)",
   label: "Loutraki (GRLOU)"
  },
  {
   value: "Malaoi (GRMAL)",
   label: "Malaoi (GRMAL)"
  },
  {
   value: "Manolada (GRMAN)",
   label: "Manolada (GRMAN)"
  },
  {
   value: "Marina Zeas (GRMAZ)",
   label: "Marina Zeas (GRMAZ)"
  },
  {
   value: "Markopoulon (GRMAR)",
   label: "Markopoulon (GRMAR)"
  },
  {
   value: "Marmari (GRMRM)",
   label: "Marmari (GRMRM)"
  },
  {
   value: "Megalivadi (GRMEG)",
   label: "Megalivadi (GRMEG)"
  },
  {
   value: "Meganissi (GRMGN)",
   label: "Meganissi (GRMGN)"
  },
  {
   value: "Megara (GRMGR)",
   label: "Megara (GRMGR)"
  },
  {
   value: "Menidi (GRMEN)",
   label: "Menidi (GRMEN)"
  },
  {
   value: "Gerakini (Yerakini) (GRYER)",
   label: "Gerakini (Yerakini) (GRYER)"
  },
  {
   value: "Glossa (GRGLO)",
   label: "Glossa (GRGLO)"
  },
  {
   value: "Gythion (GRGYT)",
   label: "Gythion (GRGYT)"
  },
  {
   value: "Heraklion (Iraklion) (GRHER)",
   label: "Heraklion (Iraklion) (GRHER)"
  },
  {
   value: "Hydra (Idhra) (GRHYD)",
   label: "Hydra (Idhra) (GRHYD)"
  },
  {
   value: "Igoumenitsa (GRIGO)",
   label: "Igoumenitsa (GRIGO)"
  },
  {
   value: "Ikaria Island (GRJIK)",
   label: "Ikaria Island (GRJIK)"
  },
  {
   value: "Ikonian (GRIKN)",
   label: "Ikonian (GRIKN)"
  },
  {
   value: "Inofyta (GRINF)",
   label: "Inofyta (GRINF)"
  },
  {
   value: "Inousses (GRINO)",
   label: "Inousses (GRINO)"
  },
  {
   value: "Ioannina (GRIOA)",
   label: "Ioannina (GRIOA)"
  },
  {
   value: "Ios (GRIOS)",
   label: "Ios (GRIOS)"
  },
  {
   value: "Isthmia (GRITM)",
   label: "Isthmia (GRITM)"
  },
  {
   value: "Itea (GRITA)",
   label: "Itea (GRITA)"
  },
  {
   value: "Ithaki (Ithaca) (GRITH)",
   label: "Ithaki (Ithaca) (GRITH)"
  },
  {
   value: "Kabalia (GRKAB)",
   label: "Kabalia (GRKAB)"
  },
  {
   value: "Kalamaki (GRKLM)",
   label: "Kalamaki (GRKLM)"
  },
  {
   value: "Kalamata (GRKLX)",
   label: "Kalamata (GRKLX)"
  },
  {
   value: "Kalilimenes (GRKLL)",
   label: "Kalilimenes (GRKLL)"
  },
  {
   value: "Kalimnos Island (GRKMI)",
   label: "Kalimnos Island (GRKMI)"
  },
  {
   value: "Kalyvia (GRKLY)",
   label: "Kalyvia (GRKLY)"
  },
  {
   value: "Kantza (GRKAN)",
   label: "Kantza (GRKAN)"
  },
  {
   value: "Kapsalio (GRKAP)",
   label: "Kapsalio (GRKAP)"
  },
  {
   value: "Karlovassi (GRKAR)",
   label: "Karlovassi (GRKAR)"
  },
  {
   value: "Karpathos (GRAOK)",
   label: "Karpathos (GRAOK)"
  },
  {
   value: "Karpenissi (GRKSS)",
   label: "Karpenissi (GRKSS)"
  },
  {
   value: "Karystos (GRKST)",
   label: "Karystos (GRKST)"
  },
  {
   value: "Kassos (GRKSJ)",
   label: "Kassos (GRKSJ)"
  },
  {
   value: "Kastelli Kissamou (GRKIS)",
   label: "Kastelli Kissamou (GRKIS)"
  },
  {
   value: "Kastelorizo (GRKZS)",
   label: "Kastelorizo (GRKZS)"
  },
  {
   value: "Kastoria (GRKSO)",
   label: "Kastoria (GRKSO)"
  },
  {
   value: "Katakolon (GRKAK)",
   label: "Katakolon (GRKAK)"
  },
  {
   value: "Katerini (GRKEI)",
   label: "Katerini (GRKEI)"
  },
  {
   value: "Katohi (Katokhi) (GRKAT)",
   label: "Katohi (Katokhi) (GRKAT)"
  },
  {
   value: "Kavala (GRKVA)",
   label: "Kavala (GRKVA)"
  },
  {
   value: "Kea Island (GRKEA)",
   label: "Kea Island (GRKEA)"
  },
  {
   value: "Kefallinia (GRKFL)",
   label: "Kefallinia (GRKFL)"
  },
  {
   value: "Keramoti (GRKER)",
   label: "Keramoti (GRKER)"
  },
  {
   value: "Kerkyra (Corfu) (GRCFU)",
   label: "Kerkyra (Corfu) (GRCFU)"
  },
  {
   value: "Kiato (GRKIO)",
   label: "Kiato (GRKIO)"
  },
  {
   value: "Antikyra (GRATK)",
   label: "Antikyra (GRATK)"
  },
  {
   value: "Antiparos (GRANP)",
   label: "Antiparos (GRANP)"
  },
  {
   value: "Antirio (GRANT)",
   label: "Antirio (GRANT)"
  },
  {
   value: "Apsalos (GRAPS)",
   label: "Apsalos (GRAPS)"
  },
  {
   value: "Argos (Argolis) (GRARG)",
   label: "Argos (Argolis) (GRARG)"
  },
  {
   value: "Argostolion (GRARM)",
   label: "Argostolion (GRARM)"
  },
  {
   value: "Aridhaia (GRARI)",
   label: "Aridhaia (GRARI)"
  },
  {
   value: "Asopos (GRASO)",
   label: "Asopos (GRASO)"
  },
  {
   value: "Aspropirgos (GRASS)",
   label: "Aspropirgos (GRASS)"
  },
  {
   value: "Astakos (GRAST)",
   label: "Astakos (GRAST)"
  },
  {
   value: "Astypalea (GRJTY)",
   label: "Astypalea (GRJTY)"
  },
  {
   value: "Atalandi (GRATA)",
   label: "Atalandi (GRATA)"
  },
  {
   value: "Athinai (GRATH)",
   label: "Athinai (GRATH)"
  },
  {
   value: "Attiki (GRATT)",
   label: "Attiki (GRATT)"
  },
  {
   value: "Avlon (GRAVL)",
   label: "Avlon (GRAVL)"
  },
  {
   value: "Chalkida (GRCLK)",
   label: "Chalkida (GRCLK)"
  },
  {
   value: "Chalkis (GRQKG)",
   label: "Chalkis (GRQKG)"
  },
  {
   value: "Chania\/CANEA (GRCHQ)",
   label: "Chania\/CANEA (GRCHQ)"
  },
  {
   value: "Chios (GRJKH)",
   label: "Chios (GRJKH)"
  },
  {
   value: "Chora Sfakion (GRCSF)",
   label: "Chora Sfakion (GRCSF)"
  },
  {
   value: "Corinth (GRCRG)",
   label: "Corinth (GRCRG)"
  },
  {
   value: "Delos (GRDOS)",
   label: "Delos (GRDOS)"
  },
  {
   value: "Domokos (GRDOM)",
   label: "Domokos (GRDOM)"
  },
  {
   value: "Drama (GRDRM)",
   label: "Drama (GRDRM)"
  },
  {
   value: "Drapetzona (GRDPA)",
   label: "Drapetzona (GRDPA)"
  },
  {
   value: "Edessa (GREDE)",
   label: "Edessa (GREDE)"
  },
  {
   value: "Edipsos (GREDI)",
   label: "Edipsos (GREDI)"
  },
  {
   value: "Elatia (GRELA)",
   label: "Elatia (GRELA)"
  },
  {
   value: "Elefsis (Elevsis) (GRELE)",
   label: "Elefsis (Elevsis) (GRELE)"
  },
  {
   value: "Eleftheres (GRELT)",
   label: "Eleftheres (GRELT)"
  },
  {
   value: "Eleusis (GREEU)",
   label: "Eleusis (GREEU)"
  },
  {
   value: "Ellasona (GRELL)",
   label: "Ellasona (GRELL)"
  },
  {
   value: "Epidauro (GREPI)",
   label: "Epidauro (GREPI)"
  },
  {
   value: "Ermioni (GRERM)",
   label: "Ermioni (GRERM)"
  },
  {
   value: "Etolikon (GRETL)",
   label: "Etolikon (GRETL)"
  },
  {
   value: "Evzonoi (GREVZ)",
   label: "Evzonoi (GREVZ)"
  },
  {
   value: "Eydilos (GREYD)",
   label: "Eydilos (GREYD)"
  },
  {
   value: "Florina (GRFIA)",
   label: "Florina (GRFIA)"
  },
  {
   value: "Gastoni (GRGAS)",
   label: "Gastoni (GRGAS)"
  },
  {
   value: "Gavrion (GRGAV)",
   label: "Gavrion (GRGAV)"
  },
  {
   value: "Gefyra (GRGEF)",
   label: "Gefyra (GRGEF)"
  },
  {
   value: "St Martin (GPSFG)",
   label: "St Martin (GPSFG)"
  },
  {
   value: "Terre-de-Bas (GPHTB)",
   label: "Terre-de-Bas (GPHTB)"
  },
  {
   value: "Terre-de-Haut (GPLSS)",
   label: "Terre-de-Haut (GPLSS)"
  },
  {
   value: "Bata (GQBSG)",
   label: "Bata (GQBSG)"
  },
  {
   value: "Butuku-Luba (GQBUL)",
   label: "Butuku-Luba (GQBUL)"
  },
  {
   value: "Cogo (GQCOG)",
   label: "Cogo (GQCOG)"
  },
  {
   value: "Luba (GQLUB)",
   label: "Luba (GQLUB)"
  },
  {
   value: "Malabo (GQSSG)",
   label: "Malabo (GQSSG)"
  },
  {
   value: "Rio Muni (GQRMN)",
   label: "Rio Muni (GQRMN)"
  },
  {
   value: "Santa Isabel (GQSIS)",
   label: "Santa Isabel (GQSIS)"
  },
  {
   value: "Acharnai (GRACH)",
   label: "Acharnai (GRACH)"
  },
  {
   value: "Achladi (GRACL)",
   label: "Achladi (GRACL)"
  },
  {
   value: "Adhamas (GRAMS)",
   label: "Adhamas (GRAMS)"
  },
  {
   value: "Aegina (GRAEG)",
   label: "Aegina (GRAEG)"
  },
  {
   value: "Aegion (GRAEN)",
   label: "Aegion (GRAEN)"
  },
  {
   value: "Agia Efimia (GRAEF)",
   label: "Agia Efimia (GRAEF)"
  },
  {
   value: "Agia Marina (GRAGM)",
   label: "Agia Marina (GRAGM)"
  },
  {
   value: "Agia Pelagia (GRAPE)",
   label: "Agia Pelagia (GRAPE)"
  },
  {
   value: "Agio Theodoroi (GRAGT)",
   label: "Agio Theodoroi (GRAGT)"
  },
  {
   value: "Agios Kirikos (GRAKI)",
   label: "Agios Kirikos (GRAKI)"
  },
  {
   value: "Agios Konstantinos (GRAKO)",
   label: "Agios Konstantinos (GRAKO)"
  },
  {
   value: "Agios Nikolaos Creta (GRANI)",
   label: "Agios Nikolaos Creta (GRANI)"
  },
  {
   value: "Agios Pavlos (GRAGP)",
   label: "Agios Pavlos (GRAGP)"
  },
  {
   value: "Agios Stefanos (GRAGS)",
   label: "Agios Stefanos (GRAGS)"
  },
  {
   value: "Agrinion (GRAGQ)",
   label: "Agrinion (GRAGQ)"
  },
  {
   value: "Aiyion (GRAIY)",
   label: "Aiyion (GRAIY)"
  },
  {
   value: "Alexandroupolis (GRAXD)",
   label: "Alexandroupolis (GRAXD)"
  },
  {
   value: "Aliartos (GRALI)",
   label: "Aliartos (GRALI)"
  },
  {
   value: "Alimos (GRAIO)",
   label: "Alimos (GRAIO)"
  },
  {
   value: "Aliveri (GRALV)",
   label: "Aliveri (GRALV)"
  },
  {
   value: "Aliverio (???ß????) (GRLVR)",
   label: "Aliverio (???ß????) (GRLVR)"
  },
  {
   value: "Almiros (GRALM)",
   label: "Almiros (GRALM)"
  },
  {
   value: "Alonissos (GRALO)",
   label: "Alonissos (GRALO)"
  },
  {
   value: "Altsi (GRATS)",
   label: "Altsi (GRATS)"
  },
  {
   value: "Amalias (GRAMA)",
   label: "Amalias (GRAMA)"
  },
  {
   value: "Amfiloxia (GRAMF)",
   label: "Amfiloxia (GRAMF)"
  },
  {
   value: "Amoliani (GRAMI)",
   label: "Amoliani (GRAMI)"
  },
  {
   value: "Amorgos (GRAMO)",
   label: "Amorgos (GRAMO)"
  },
  {
   value: "Amphissa (GRAMP)",
   label: "Amphissa (GRAMP)"
  },
  {
   value: "Andros (GRAND)",
   label: "Andros (GRAND)"
  },
  {
   value: "Qasigiannguit (Christianshaab) (GLJCH)",
   label: "Qasigiannguit (Christianshaab) (GLJCH)"
  },
  {
   value: "Qeqertarsuaq (Godhavn) (GLJGO)",
   label: "Qeqertarsuaq (Godhavn) (GLJGO)"
  },
  {
   value: "Sisimiut (Holsteinsborg) (GLJHS)",
   label: "Sisimiut (Holsteinsborg) (GLJHS)"
  },
  {
   value: "Tovkusoak (GLTOV)",
   label: "Tovkusoak (GLTOV)"
  },
  {
   value: "Upernavik (GLJUV)",
   label: "Upernavik (GLJUV)"
  },
  {
   value: "Uummannaq (GLUMD)",
   label: "Uummannaq (GLUMD)"
  },
  {
   value: "Bakau (GMBAK)",
   label: "Bakau (GMBAK)"
  },
  {
   value: "Banjul (GMBJL)",
   label: "Banjul (GMBJL)"
  },
  {
   value: "Bansang (GMBAN)",
   label: "Bansang (GMBAN)"
  },
  {
   value: "Basse Santa Su (GMBSS)",
   label: "Basse Santa Su (GMBSS)"
  },
  {
   value: "Brikama Ba (GMBRB)",
   label: "Brikama Ba (GMBRB)"
  },
  {
   value: "Bwiam (GMBWI)",
   label: "Bwiam (GMBWI)"
  },
  {
   value: "Farafenni (GMFAR)",
   label: "Farafenni (GMFAR)"
  },
  {
   value: "Jangtangbureh (GMJTB)",
   label: "Jangtangbureh (GMJTB)"
  },
  {
   value: "Kau-Ur (GMKAU)",
   label: "Kau-Ur (GMKAU)"
  },
  {
   value: "Kuntair (GMKUN)",
   label: "Kuntair (GMKUN)"
  },
  {
   value: "Mansa Konko (GMMAK)",
   label: "Mansa Konko (GMMAK)"
  },
  {
   value: "Serekunda (GMSKE)",
   label: "Serekunda (GMSKE)"
  },
  {
   value: "Benty (GNBTY)",
   label: "Benty (GNBTY)"
  },
  {
   value: "Boke (GNBKJ)",
   label: "Boke (GNBKJ)"
  },
  {
   value: "Conakry (GNCKY)",
   label: "Conakry (GNCKY)"
  },
  {
   value: "Faranah (GNFAA)",
   label: "Faranah (GNFAA)"
  },
  {
   value: "Fria (GNFIG)",
   label: "Fria (GNFIG)"
  },
  {
   value: "Kankan (GNKNN)",
   label: "Kankan (GNKNN)"
  },
  {
   value: "Kissidougou (GNKSI)",
   label: "Kissidougou (GNKSI)"
  },
  {
   value: "Koundara (GNSBI)",
   label: "Koundara (GNSBI)"
  },
  {
   value: "Labe (GNLEK)",
   label: "Labe (GNLEK)"
  },
  {
   value: "Macenta (GNMCA)",
   label: "Macenta (GNMCA)"
  },
  {
   value: "Nzerekore (GNNZE)",
   label: "Nzerekore (GNNZE)"
  },
  {
   value: "Port Kamsar (GNKMR)",
   label: "Port Kamsar (GNKMR)"
  },
  {
   value: "Siguiri (GNGII)",
   label: "Siguiri (GNGII)"
  },
  {
   value: "Basse Terre (GPBBR)",
   label: "Basse Terre (GPBBR)"
  },
  {
   value: "Grand Bourg (GPGRB)",
   label: "Grand Bourg (GPGRB)"
  },
  {
   value: "Grand Case (GPCCE)",
   label: "Grand Case (GPCCE)"
  },
  {
   value: "Gustavia (GPGUS)",
   label: "Gustavia (GPGUS)"
  },
  {
   value: "Jarry (GPJAR)",
   label: "Jarry (GPJAR)"
  },
  {
   value: "La Desirade (GPDSD)",
   label: "La Desirade (GPDSD)"
  },
  {
   value: "Marie Galante (GPGBJ)",
   label: "Marie Galante (GPGBJ)"
  },
  {
   value: "Marigot (GPMSB)",
   label: "Marigot (GPMSB)"
  },
  {
   value: "Pointe-à-Pitre (GPPTP)",
   label: "Pointe-à-Pitre (GPPTP)"
  },
  {
   value: "St Barthelemy (GPSBH)",
   label: "St Barthelemy (GPSBH)"
  },
  {
   value: "Aura (GHAUR)",
   label: "Aura (GHAUR)"
  },
  {
   value: "Axim (GHAXI)",
   label: "Axim (GHAXI)"
  },
  {
   value: "Cape Coast (GHCCT)",
   label: "Cape Coast (GHCCT)"
  },
  {
   value: "Keta (GHKIT)",
   label: "Keta (GHKIT)"
  },
  {
   value: "Kotoka (GHKTP)",
   label: "Kotoka (GHKTP)"
  },
  {
   value: "Kumasi (GHKMS)",
   label: "Kumasi (GHKMS)"
  },
  {
   value: "Saltpond (GHSPD)",
   label: "Saltpond (GHSPD)"
  },
  {
   value: "Sekondi (GHSEK)",
   label: "Sekondi (GHSEK)"
  },
  {
   value: "Shama (GHSHA)",
   label: "Shama (GHSHA)"
  },
  {
   value: "Sunyani (GHNYI)",
   label: "Sunyani (GHNYI)"
  },
  {
   value: "Takoradi (GHTKD)",
   label: "Takoradi (GHTKD)"
  },
  {
   value: "Tamale (GHTML)",
   label: "Tamale (GHTML)"
  },
  {
   value: "Tema (GHTEM)",
   label: "Tema (GHTEM)"
  },
  {
   value: "Winneba (GHWEA)",
   label: "Winneba (GHWEA)"
  },
  {
   value: "Gibraltar (GIGIB)",
   label: "Gibraltar (GIGIB)"
  },
  {
   value: "Aasiaat (Egedesminde) (GLJEG)",
   label: "Aasiaat (Egedesminde) (GLJEG)"
  },
  {
   value: "Angmagssalik \/ TASIILAQ (GLAGM)",
   label: "Angmagssalik \/ TASIILAQ (GLAGM)"
  },
  {
   value: "Arsuk (GLJRK)",
   label: "Arsuk (GLJRK)"
  },
  {
   value: "Daneborg (GLDAN)",
   label: "Daneborg (GLDAN)"
  },
  {
   value: "Dundas (GLDUN)",
   label: "Dundas (GLDUN)"
  },
  {
   value: "Fæeringehavn (Kangerdluarssoru.) (GLFHN)",
   label: "Fæeringehavn (Kangerdluarssoru.) (GLFHN)"
  },
  {
   value: "Illorqortoormiut (Scoresbysund) (GLOBY)",
   label: "Illorqortoormiut (Scoresbysund) (GLOBY)"
  },
  {
   value: "Ilulissat (Jakobshavn) (GLJAV)",
   label: "Ilulissat (Jakobshavn) (GLJAV)"
  },
  {
   value: "Ivigtut (GLIUT)",
   label: "Ivigtut (GLIUT)"
  },
  {
   value: "Kangerlussuaq (Sondre Stromfjord (GLSFJ)",
   label: "Kangerlussuaq (Sondre Stromfjord (GLSFJ)"
  },
  {
   value: "Kangilinguit (Gronnedal) (GLJGR)",
   label: "Kangilinguit (Gronnedal) (GLJGR)"
  },
  {
   value: "Kulusuk (GLKUS)",
   label: "Kulusuk (GLKUS)"
  },
  {
   value: "Maniitsoq (Sukkertoppen) (GLJSU)",
   label: "Maniitsoq (Sukkertoppen) (GLJSU)"
  },
  {
   value: "Mesters Vig (GLMRG)",
   label: "Mesters Vig (GLMRG)"
  },
  {
   value: "Nanortalik (GLJNN)",
   label: "Nanortalik (GLJNN)"
  },
  {
   value: "Narsaq (GLJNS)",
   label: "Narsaq (GLJNS)"
  },
  {
   value: "Narsarsuaq (GLUAK)",
   label: "Narsarsuaq (GLUAK)"
  },
  {
   value: "Neerlerit Inaat (GLCNP)",
   label: "Neerlerit Inaat (GLCNP)"
  },
  {
   value: "Nuuk (Godthaab) (GLGOH)",
   label: "Nuuk (Godthaab) (GLGOH)"
  },
  {
   value: "Paamiut (Fredrikshaab) (GLJFR)",
   label: "Paamiut (Fredrikshaab) (GLJFR)"
  },
  {
   value: "Pituffik (GLTHU)",
   label: "Pituffik (GLTHU)"
  },
  {
   value: "Qaanaaq (GLNAQ)",
   label: "Qaanaaq (GLNAQ)"
  },
  {
   value: "Qaqortoq (Julianehaab) (GLJJU)",
   label: "Qaqortoq (Julianehaab) (GLJJU)"
  },
  {
   value: "Worthing (GBWOT)",
   label: "Worthing (GBWOT)"
  },
  {
   value: "Wotton-Under-Edge (GBWUE)",
   label: "Wotton-Under-Edge (GBWUE)"
  },
  {
   value: "Wraysbury (GBWSB)",
   label: "Wraysbury (GBWSB)"
  },
  {
   value: "Wrexham (GBWXH)",
   label: "Wrexham (GBWXH)"
  },
  {
   value: "Wrotham (GBWRO)",
   label: "Wrotham (GBWRO)"
  },
  {
   value: "Wyke (GBWKE)",
   label: "Wyke (GBWKE)"
  },
  {
   value: "Wykeham (GBWYA)",
   label: "Wykeham (GBWYA)"
  },
  {
   value: "Wylam (GBWYM)",
   label: "Wylam (GBWYM)"
  },
  {
   value: "Wymondham (GBWYD)",
   label: "Wymondham (GBWYD)"
  },
  {
   value: "Wythenshawe (GBWYH)",
   label: "Wythenshawe (GBWYH)"
  },
  {
   value: "Yalding (GBYAL)",
   label: "Yalding (GBYAL)"
  },
  {
   value: "Yardley (GBYRD)",
   label: "Yardley (GBYRD)"
  },
  {
   value: "Yate (GBYAT)",
   label: "Yate (GBYAT)"
  },
  {
   value: "Yateley (GBYTE)",
   label: "Yateley (GBYTE)"
  },
  {
   value: "Yatton (GBYTN)",
   label: "Yatton (GBYTN)"
  },
  {
   value: "Yeadon (GBYDN)",
   label: "Yeadon (GBYDN)"
  },
  {
   value: "Yelland (GBYLL)",
   label: "Yelland (GBYLL)"
  },
  {
   value: "Yeovil (GBYEO)",
   label: "Yeovil (GBYEO)"
  },
  {
   value: "York (GBYRK)",
   label: "York (GBYRK)"
  },
  {
   value: "DEESIDE (GBDSE)",
   label: "DEESIDE (GBDSE)"
  },
  {
   value: "RHONDDA (GBRHO)",
   label: "RHONDDA (GBRHO)"
  },
  {
   value: "Grenada (GDGND)",
   label: "Grenada (GDGND)"
  },
  {
   value: "Grenville (GDGRE)",
   label: "Grenville (GDGRE)"
  },
  {
   value: "\"Hillsborough (GDHIL)",
   label: "\"Hillsborough (GDHIL)"
  },
  {
   value: "Saint George's (GDSTG)",
   label: "Saint George's (GDSTG)"
  },
  {
   value: "Batumi (GEBUS)",
   label: "Batumi (GEBUS)"
  },
  {
   value: "Gurjaani (GEGUR)",
   label: "Gurjaani (GEGUR)"
  },
  {
   value: "Kutaisi (GEKUT)",
   label: "Kutaisi (GEKUT)"
  },
  {
   value: "Poti (GEPTI)",
   label: "Poti (GEPTI)"
  },
  {
   value: "Sukhumi (GESUI)",
   label: "Sukhumi (GESUI)"
  },
  {
   value: "Tbilisi (GETBS)",
   label: "Tbilisi (GETBS)"
  },
  {
   value: "Cayenne (GFCAY)",
   label: "Cayenne (GFCAY)"
  },
  {
   value: "Degrad des Cannes (GFDDC)",
   label: "Degrad des Cannes (GFDDC)"
  },
  {
   value: "Kourou (GFQKR)",
   label: "Kourou (GFQKR)"
  },
  {
   value: "Le Larivot (GFLVT)",
   label: "Le Larivot (GFLVT)"
  },
  {
   value: "Maripasoula (GFMPY)",
   label: "Maripasoula (GFMPY)"
  },
  {
   value: "Regina (GFREI)",
   label: "Regina (GFREI)"
  },
  {
   value: "Saul (GFXAU)",
   label: "Saul (GFXAU)"
  },
  {
   value: "St Georges de Loyapock (GFOYP)",
   label: "St Georges de Loyapock (GFOYP)"
  },
  {
   value: "St Laurent du Maroni (GFSLM)",
   label: "St Laurent du Maroni (GFSLM)"
  },
  {
   value: "Accra (GHACC)",
   label: "Accra (GHACC)"
  },
  {
   value: "Ada (GHADA)",
   label: "Ada (GHADA)"
  },
  {
   value: "Wirksworth (GBWIR)",
   label: "Wirksworth (GBWIR)"
  },
  {
   value: "Wisbech (GBWIS)",
   label: "Wisbech (GBWIS)"
  },
  {
   value: "Wishaw (GBWHW)",
   label: "Wishaw (GBWHW)"
  },
  {
   value: "Witham (GBWIH)",
   label: "Witham (GBWIH)"
  },
  {
   value: "Withnell (GBWTH)",
   label: "Withnell (GBWTH)"
  },
  {
   value: "Witney (GBWIN)",
   label: "Witney (GBWIN)"
  },
  {
   value: "Witton (GBWON)",
   label: "Witton (GBWON)"
  },
  {
   value: "Wivelsfield Green (GBWVF)",
   label: "Wivelsfield Green (GBWVF)"
  },
  {
   value: "Wivenhoe (GBWIV)",
   label: "Wivenhoe (GBWIV)"
  },
  {
   value: "Woburn (GBWBN)",
   label: "Woburn (GBWBN)"
  },
  {
   value: "Woburn Sands (GBWOS)",
   label: "Woburn Sands (GBWOS)"
  },
  {
   value: "Woking (GBWKG)",
   label: "Woking (GBWKG)"
  },
  {
   value: "Wokingham (GBWOK)",
   label: "Wokingham (GBWOK)"
  },
  {
   value: "Woldingham (GBWOD)",
   label: "Woldingham (GBWOD)"
  },
  {
   value: "Wolvercote (GBWVC)",
   label: "Wolvercote (GBWVC)"
  },
  {
   value: "Wolverhampton (GBWOV)",
   label: "Wolverhampton (GBWOV)"
  },
  {
   value: "Wolverton (GBWVT)",
   label: "Wolverton (GBWVT)"
  },
  {
   value: "Wombourne (GBWBC)",
   label: "Wombourne (GBWBC)"
  },
  {
   value: "Wooburn Green (GBWUG)",
   label: "Wooburn Green (GBWUG)"
  },
  {
   value: "Wood Green (GBWOG)",
   label: "Wood Green (GBWOG)"
  },
  {
   value: "Woodbridge (GBWBG)",
   label: "Woodbridge (GBWBG)"
  },
  {
   value: "Woodbury (GBWOY)",
   label: "Woodbury (GBWOY)"
  },
  {
   value: "Woodford Green (GBWRD)",
   label: "Woodford Green (GBWRD)"
  },
  {
   value: "Woodford Halse (GBWOH)",
   label: "Woodford Halse (GBWOH)"
  },
  {
   value: "Woodhall (GBWDA)",
   label: "Woodhall (GBWDA)"
  },
  {
   value: "Woodhall Spa (GBWDH)",
   label: "Woodhall Spa (GBWDH)"
  },
  {
   value: "Woodhurst (GBWHU)",
   label: "Woodhurst (GBWHU)"
  },
  {
   value: "Woodstock (GBWDS)",
   label: "Woodstock (GBWDS)"
  },
  {
   value: "Woolmer Green (GBWMG)",
   label: "Woolmer Green (GBWMG)"
  },
  {
   value: "Woolston (GBWST)",
   label: "Woolston (GBWST)"
  },
  {
   value: "Woolwich (GBWLW)",
   label: "Woolwich (GBWLW)"
  },
  {
   value: "Wootton Bassett (GBWNB)",
   label: "Wootton Bassett (GBWNB)"
  },
  {
   value: "Worcester (GBWTR)",
   label: "Worcester (GBWTR)"
  },
  {
   value: "Workington (GBWOR)",
   label: "Workington (GBWOR)"
  },
  {
   value: "Worksop (GBWRK)",
   label: "Worksop (GBWRK)"
  },
  {
   value: "Worle (GBWOE)",
   label: "Worle (GBWOE)"
  },
  {
   value: "Worlington (GBWOO)",
   label: "Worlington (GBWOO)"
  },
  {
   value: "Worsley (GBWRS)",
   label: "Worsley (GBWRS)"
  },
  {
   value: "Worth (GBWXR)",
   label: "Worth (GBWXR)"
  },
  {
   value: "Worthing (GBWOI)",
   label: "Worthing (GBWOI)"
  },
  {
   value: "Whitebooth Roads (GBWHB)",
   label: "Whitebooth Roads (GBWHB)"
  },
  {
   value: "Whitefield (GBGTF)",
   label: "Whitefield (GBGTF)"
  },
  {
   value: "Whitehaven (GBWHV)",
   label: "Whitehaven (GBWHV)"
  },
  {
   value: "Whitland (GBWHI)",
   label: "Whitland (GBWHI)"
  },
  {
   value: "Whitley Bay (GBWTL)",
   label: "Whitley Bay (GBWTL)"
  },
  {
   value: "Whitstable (GBWTS)",
   label: "Whitstable (GBWTS)"
  },
  {
   value: "Whittlesford (GBWTF)",
   label: "Whittlesford (GBWTF)"
  },
  {
   value: "Whitton (GBWHT)",
   label: "Whitton (GBWHT)"
  },
  {
   value: "Whyteleaf (GBWYL)",
   label: "Whyteleaf (GBWYL)"
  },
  {
   value: "Wick (GBWIC)",
   label: "Wick (GBWIC)"
  },
  {
   value: "Wickford (GBWID)",
   label: "Wickford (GBWID)"
  },
  {
   value: "Wickham Market (GBWMK)",
   label: "Wickham Market (GBWMK)"
  },
  {
   value: "Widnes (GBWDN)",
   label: "Widnes (GBWDN)"
  },
  {
   value: "Wigan (GBWGN)",
   label: "Wigan (GBWGN)"
  },
  {
   value: "Wigston (GBWGS)",
   label: "Wigston (GBWGS)"
  },
  {
   value: "Wigton (GBWGT)",
   label: "Wigton (GBWGT)"
  },
  {
   value: "Wigtown (GBWIG)",
   label: "Wigtown (GBWIG)"
  },
  {
   value: "Willand (GBWIL)",
   label: "Willand (GBWIL)"
  },
  {
   value: "Willaston (GBWXN)",
   label: "Willaston (GBWXN)"
  },
  {
   value: "Willen (GBWII)",
   label: "Willen (GBWII)"
  },
  {
   value: "Willenhall (GBWLL)",
   label: "Willenhall (GBWLL)"
  },
  {
   value: "Wilmslow (GBWSW)",
   label: "Wilmslow (GBWSW)"
  },
  {
   value: "Wilnecote (GBWNC)",
   label: "Wilnecote (GBWNC)"
  },
  {
   value: "Wilton (GBWLT)",
   label: "Wilton (GBWLT)"
  },
  {
   value: "Wilton (GBWIZ)",
   label: "Wilton (GBWIZ)"
  },
  {
   value: "Wimbish (GBWBH)",
   label: "Wimbish (GBWBH)"
  },
  {
   value: "Wimbledon (GBWBD)",
   label: "Wimbledon (GBWBD)"
  },
  {
   value: "Wimborne Minster (GBWIM)",
   label: "Wimborne Minster (GBWIM)"
  },
  {
   value: "Wincanton (GBWCT)",
   label: "Wincanton (GBWCT)"
  },
  {
   value: "Wincham (GBWCH)",
   label: "Wincham (GBWCH)"
  },
  {
   value: "Winchester (GBWNE)",
   label: "Winchester (GBWNE)"
  },
  {
   value: "Winchfield (GBWNF)",
   label: "Winchfield (GBWNF)"
  },
  {
   value: "Windermere (GBWDM)",
   label: "Windermere (GBWDM)"
  },
  {
   value: "Windlesham (GBWDL)",
   label: "Windlesham (GBWDL)"
  },
  {
   value: "Windsor (GBWSR)",
   label: "Windsor (GBWSR)"
  },
  {
   value: "Winfrith Newburgh (GBWNW)",
   label: "Winfrith Newburgh (GBWNW)"
  },
  {
   value: "Wingham (GBWGH)",
   label: "Wingham (GBWGH)"
  },
  {
   value: "Winkfield (GBWKF)",
   label: "Winkfield (GBWKF)"
  },
  {
   value: "Winkleigh (GBWKL)",
   label: "Winkleigh (GBWKL)"
  },
  {
   value: "Winsford (GBWIF)",
   label: "Winsford (GBWIF)"
  },
  {
   value: "Winslow (GBWSL)",
   label: "Winslow (GBWSL)"
  },
  {
   value: "West Hallam (GBWTM)",
   label: "West Hallam (GBWTM)"
  },
  {
   value: "West Hartlepool (GBWHL)",
   label: "West Hartlepool (GBWHL)"
  },
  {
   value: "West Horndon (GBWHO)",
   label: "West Horndon (GBWHO)"
  },
  {
   value: "West Kilbridge (GBWKB)",
   label: "West Kilbridge (GBWKB)"
  },
  {
   value: "West Kirby (GBWKI)",
   label: "West Kirby (GBWKI)"
  },
  {
   value: "West Malling (GBWML)",
   label: "West Malling (GBWML)"
  },
  {
   value: "West Meon (GBWMN)",
   label: "West Meon (GBWMN)"
  },
  {
   value: "West Mersea (GBWMS)",
   label: "West Mersea (GBWMS)"
  },
  {
   value: "West Stafford (GBWSF)",
   label: "West Stafford (GBWSF)"
  },
  {
   value: "West Thurrock (GBLWT)",
   label: "West Thurrock (GBLWT)"
  },
  {
   value: "Westbury (GBWSY)",
   label: "Westbury (GBWSY)"
  },
  {
   value: "Westcliffe on Sea (GBWFO)",
   label: "Westcliffe on Sea (GBWFO)"
  },
  {
   value: "Westcott (GBWEQ)",
   label: "Westcott (GBWEQ)"
  },
  {
   value: "Westerham (GBWER)",
   label: "Westerham (GBWER)"
  },
  {
   value: "Westfield (GBWFI)",
   label: "Westfield (GBWFI)"
  },
  {
   value: "Westhoughton (GBWTG)",
   label: "Westhoughton (GBWTG)"
  },
  {
   value: "Weston (GBWSN)",
   label: "Weston (GBWSN)"
  },
  {
   value: "Weston (GBWES)",
   label: "Weston (GBWES)"
  },
  {
   value: "Weston Point (GBWSP)",
   label: "Weston Point (GBWSP)"
  },
  {
   value: "Weston-Super-Mare (GBWSM)",
   label: "Weston-Super-Mare (GBWSM)"
  },
  {
   value: "Westray (GBWRY)",
   label: "Westray (GBWRY)"
  },
  {
   value: "Westwoodside (GBWWS)",
   label: "Westwoodside (GBWWS)"
  },
  {
   value: "Wetherby (GBWET)",
   label: "Wetherby (GBWET)"
  },
  {
   value: "Wetherden (GBWHM)",
   label: "Wetherden (GBWHM)"
  },
  {
   value: "Wethersfield (GBWHF)",
   label: "Wethersfield (GBWHF)"
  },
  {
   value: "Weybridge (GBWBR)",
   label: "Weybridge (GBWBR)"
  },
  {
   value: "Weymouth (GBWEY)",
   label: "Weymouth (GBWEY)"
  },
  {
   value: "Whaley Bridge (GBWYB)",
   label: "Whaley Bridge (GBWYB)"
  },
  {
   value: "Whalsay (GBWHY)",
   label: "Whalsay (GBWHY)"
  },
  {
   value: "Whatton (GBWHA)",
   label: "Whatton (GBWHA)"
  },
  {
   value: "Wheathampstead (GBWHP)",
   label: "Wheathampstead (GBWHP)"
  },
  {
   value: "Whetstone (GBWSO)",
   label: "Whetstone (GBWSO)"
  },
  {
   value: "Whimple (GBWPL)",
   label: "Whimple (GBWPL)"
  },
  {
   value: "Whitburn (GBWBU)",
   label: "Whitburn (GBWBU)"
  },
  {
   value: "Whitby (GBWTB)",
   label: "Whitby (GBWTB)"
  },
  {
   value: "Whitchurch (GBWCU)",
   label: "Whitchurch (GBWCU)"
  },
  {
   value: "Whitchurch (GBWHC)",
   label: "Whitchurch (GBWHC)"
  },
  {
   value: "Whitchurch (GBWTC)",
   label: "Whitchurch (GBWTC)"
  },
  {
   value: "White Waltham (GBWWM)",
   label: "White Waltham (GBWWM)"
  },
  {
   value: "Warton (GBWRT)",
   label: "Warton (GBWRT)"
  },
  {
   value: "Warwick (GBWAW)",
   label: "Warwick (GBWAW)"
  },
  {
   value: "Warwick (GBWWK)",
   label: "Warwick (GBWWK)"
  },
  {
   value: "Washington (GBWNN)",
   label: "Washington (GBWNN)"
  },
  {
   value: "Washington (GBWHG)",
   label: "Washington (GBWHG)"
  },
  {
   value: "Watchet (GBWAT)",
   label: "Watchet (GBWAT)"
  },
  {
   value: "Water Orten (GBWTO)",
   label: "Water Orten (GBWTO)"
  },
  {
   value: "Waterlooville (GBWLV)",
   label: "Waterlooville (GBWLV)"
  },
  {
   value: "Watford (GBWAF)",
   label: "Watford (GBWAF)"
  },
  {
   value: "Watford Village (GBWAV)",
   label: "Watford Village (GBWAV)"
  },
  {
   value: "Wath Upon Dearne (GBWUD)",
   label: "Wath Upon Dearne (GBWUD)"
  },
  {
   value: "Watlington (GBWAA)",
   label: "Watlington (GBWAA)"
  },
  {
   value: "Watton (GBWTT)",
   label: "Watton (GBWTT)"
  },
  {
   value: "Wealdstone (GBWEA)",
   label: "Wealdstone (GBWEA)"
  },
  {
   value: "Wednesbury (GBWED)",
   label: "Wednesbury (GBWED)"
  },
  {
   value: "Wednesfield (GBWEF)",
   label: "Wednesfield (GBWEF)"
  },
  {
   value: "Weedon (GBWEE)",
   label: "Weedon (GBWEE)"
  },
  {
   value: "Welbury (GBWLB)",
   label: "Welbury (GBWLB)"
  },
  {
   value: "Welford (GBWLD)",
   label: "Welford (GBWLD)"
  },
  {
   value: "Welford on Avon (GBWOA)",
   label: "Welford on Avon (GBWOA)"
  },
  {
   value: "Welham Green (GBWEM)",
   label: "Welham Green (GBWEM)"
  },
  {
   value: "Wellingborough (GBWEL)",
   label: "Wellingborough (GBWEL)"
  },
  {
   value: "Wellington (GBWLG)",
   label: "Wellington (GBWLG)"
  },
  {
   value: "Wellington (GBWQL)",
   label: "Wellington (GBWQL)"
  },
  {
   value: "Wells (GBWLS)",
   label: "Wells (GBWLS)"
  },
  {
   value: "Wells-next-the-Sea (GBWNS)",
   label: "Wells-next-the-Sea (GBWNS)"
  },
  {
   value: "Welshpool (GBWPS)",
   label: "Welshpool (GBWPS)"
  },
  {
   value: "Welton (GBWQT)",
   label: "Welton (GBWQT)"
  },
  {
   value: "Welwyn (GBWLN)",
   label: "Welwyn (GBWLN)"
  },
  {
   value: "Welwyn Garden City (GBWGC)",
   label: "Welwyn Garden City (GBWGC)"
  },
  {
   value: "Wem (GBWNR)",
   label: "Wem (GBWNR)"
  },
  {
   value: "Wembley (GBWBY)",
   label: "Wembley (GBWBY)"
  },
  {
   value: "Wemyss Bay (GBWMB)",
   label: "Wemyss Bay (GBWMB)"
  },
  {
   value: "Werrington (GBWRG)",
   label: "Werrington (GBWRG)"
  },
  {
   value: "West Bridgeford (GBWGF)",
   label: "West Bridgeford (GBWGF)"
  },
  {
   value: "West Bromwich (GBWEB)",
   label: "West Bromwich (GBWEB)"
  },
  {
   value: "West Byfleet (GBWBT)",
   label: "West Byfleet (GBWBT)"
  },
  {
   value: "West Challow (GBWCW)",
   label: "West Challow (GBWCW)"
  },
  {
   value: "West Drayton (GBWDR)",
   label: "West Drayton (GBWDR)"
  },
  {
   value: "West End (GBWEN)",
   label: "West End (GBWEN)"
  },
  {
   value: "Upton (GBUTN)",
   label: "Upton (GBUTN)"
  },
  {
   value: "Upwood (GBUPW)",
   label: "Upwood (GBUPW)"
  },
  {
   value: "Urlay Nook (GBULN)",
   label: "Urlay Nook (GBULN)"
  },
  {
   value: "Urmston (GBURS)",
   label: "Urmston (GBURS)"
  },
  {
   value: "Uttoxeter (GBUTX)",
   label: "Uttoxeter (GBUTX)"
  },
  {
   value: "Uxbridge (GBUXB)",
   label: "Uxbridge (GBUXB)"
  },
  {
   value: "Verwood (GBVER)",
   label: "Verwood (GBVER)"
  },
  {
   value: "Virginia Water (GBVGN)",
   label: "Virginia Water (GBVGN)"
  },
  {
   value: "Vobster (GBVOB)",
   label: "Vobster (GBVOB)"
  },
  {
   value: "Waddington (GBWDD)",
   label: "Waddington (GBWDD)"
  },
  {
   value: "Waddington (GBWTN)",
   label: "Waddington (GBWTN)"
  },
  {
   value: "Wadebridge (GBWAB)",
   label: "Wadebridge (GBWAB)"
  },
  {
   value: "Wakefield (GBWFD)",
   label: "Wakefield (GBWFD)"
  },
  {
   value: "Wakes Colnes (GBWAK)",
   label: "Wakes Colnes (GBWAK)"
  },
  {
   value: "Walkden (GBWKD)",
   label: "Walkden (GBWKD)"
  },
  {
   value: "Walkerburn (GBWAU)",
   label: "Walkerburn (GBWAU)"
  },
  {
   value: "Walkern (GBWKN)",
   label: "Walkern (GBWKN)"
  },
  {
   value: "Wallasea (GBWLA)",
   label: "Wallasea (GBWLA)"
  },
  {
   value: "Wallasey (GBWAY)",
   label: "Wallasey (GBWAY)"
  },
  {
   value: "Wallingford (GBWLF)",
   label: "Wallingford (GBWLF)"
  },
  {
   value: "Wallington (GBWAO)",
   label: "Wallington (GBWAO)"
  },
  {
   value: "Wallsend (GBWTW)",
   label: "Wallsend (GBWTW)"
  },
  {
   value: "Walmer (GBWMF)",
   label: "Walmer (GBWMF)"
  },
  {
   value: "Walsall (GBWAL)",
   label: "Walsall (GBWAL)"
  },
  {
   value: "Walsden (GBWSD)",
   label: "Walsden (GBWSD)"
  },
  {
   value: "Waltham Abbey (GBHHA)",
   label: "Waltham Abbey (GBHHA)"
  },
  {
   value: "Waltham Cross (GBWAC)",
   label: "Waltham Cross (GBWAC)"
  },
  {
   value: "Walthamstow (GBWHS)",
   label: "Walthamstow (GBWHS)"
  },
  {
   value: "Walton-On-Thames (GBWLE)",
   label: "Walton-On-Thames (GBWLE)"
  },
  {
   value: "Walton-on-the-Naze (GBWNZ)",
   label: "Walton-on-the-Naze (GBWNZ)"
  },
  {
   value: "Wandsworth (GBWAN)",
   label: "Wandsworth (GBWAN)"
  },
  {
   value: "Wanstead (GBWTD)",
   label: "Wanstead (GBWTD)"
  },
  {
   value: "Wantage (GBWGE)",
   label: "Wantage (GBWGE)"
  },
  {
   value: "Ware (GBWAR)",
   label: "Ware (GBWAR)"
  },
  {
   value: "Wareham (GBWRH)",
   label: "Wareham (GBWRH)"
  },
  {
   value: "Warley (GBWLY)",
   label: "Warley (GBWLY)"
  },
  {
   value: "Warlingham (GBWNH)",
   label: "Warlingham (GBWNH)"
  },
  {
   value: "Warminster (GBWAM)",
   label: "Warminster (GBWAM)"
  },
  {
   value: "Warrenpoint (GBWPT)",
   label: "Warrenpoint (GBWPT)"
  },
  {
   value: "Warrington (GBWRN)",
   label: "Warrington (GBWRN)"
  },
  {
   value: "Warsash (GBWSS)",
   label: "Warsash (GBWSS)"
  },
  {
   value: "Tow Law (GBTWW)",
   label: "Tow Law (GBTWW)"
  },
  {
   value: "Towcester (GBTOW)",
   label: "Towcester (GBTOW)"
  },
  {
   value: "Trafford Park (GBTFK)",
   label: "Trafford Park (GBTFK)"
  },
  {
   value: "Tranent (GBTNT)",
   label: "Tranent (GBTNT)"
  },
  {
   value: "Tranmere (GBTRA)",
   label: "Tranmere (GBTRA)"
  },
  {
   value: "Trawden (GBTWD)",
   label: "Trawden (GBTWD)"
  },
  {
   value: "Tredegar (GBTDR)",
   label: "Tredegar (GBTDR)"
  },
  {
   value: "Trefforest (GBTFR)",
   label: "Trefforest (GBTFR)"
  },
  {
   value: "Treherbert (GBTRH)",
   label: "Treherbert (GBTRH)"
  },
  {
   value: "Treorchy (GBTRY)",
   label: "Treorchy (GBTRY)"
  },
  {
   value: "Tresco (GBTSO)",
   label: "Tresco (GBTSO)"
  },
  {
   value: "Trimley Heath (GBTLY)",
   label: "Trimley Heath (GBTLY)"
  },
  {
   value: "Tring (GBTRI)",
   label: "Tring (GBTRI)"
  },
  {
   value: "Tronbridge (GBTRO)",
   label: "Tronbridge (GBTRO)"
  },
  {
   value: "Troon (GBTRN)",
   label: "Troon (GBTRN)"
  },
  {
   value: "Trottiscliffe (GBTFF)",
   label: "Trottiscliffe (GBTFF)"
  },
  {
   value: "Trowbridge (GBTBG)",
   label: "Trowbridge (GBTBG)"
  },
  {
   value: "Truro (GBTRU)",
   label: "Truro (GBTRU)"
  },
  {
   value: "Tullibody (GBTLB)",
   label: "Tullibody (GBTLB)"
  },
  {
   value: "Tunbridge Wells (GBTUW)",
   label: "Tunbridge Wells (GBTUW)"
  },
  {
   value: "Tunstall (GBTNL)",
   label: "Tunstall (GBTNL)"
  },
  {
   value: "Tutbury (GBTUT)",
   label: "Tutbury (GBTUT)"
  },
  {
   value: "Tuxford (GBTUX)",
   label: "Tuxford (GBTUX)"
  },
  {
   value: "Twickenham (GBTWC)",
   label: "Twickenham (GBTWC)"
  },
  {
   value: "Twyford (GBTWF)",
   label: "Twyford (GBTWF)"
  },
  {
   value: "Tyldesley (GBTYL)",
   label: "Tyldesley (GBTYL)"
  },
  {
   value: "Tylers Green (GBTLG)",
   label: "Tylers Green (GBTLG)"
  },
  {
   value: "Tyne (GBTYN)",
   label: "Tyne (GBTYN)"
  },
  {
   value: "Tynemouth (GBTYM)",
   label: "Tynemouth (GBTYM)"
  },
  {
   value: "Uckfield (GBUCK)",
   label: "Uckfield (GBUCK)"
  },
  {
   value: "Uddington (GBUDD)",
   label: "Uddington (GBUDD)"
  },
  {
   value: "Uffington (GBUFG)",
   label: "Uffington (GBUFG)"
  },
  {
   value: "Uig (GBUIG)",
   label: "Uig (GBUIG)"
  },
  {
   value: "Ullapool (GBULL)",
   label: "Ullapool (GBULL)"
  },
  {
   value: "Ulverston (GBULV)",
   label: "Ulverston (GBULV)"
  },
  {
   value: "Unst Shetland Is (GBUNT)",
   label: "Unst Shetland Is (GBUNT)"
  },
  {
   value: "Upavon (GBUPV)",
   label: "Upavon (GBUPV)"
  },
  {
   value: "Upminster (GBUPM)",
   label: "Upminster (GBUPM)"
  },
  {
   value: "Upper Dicker (GBUPD)",
   label: "Upper Dicker (GBUPD)"
  },
  {
   value: "Upper Heyford (GBUHF)",
   label: "Upper Heyford (GBUHF)"
  },
  {
   value: "Upton (GBUPT)",
   label: "Upton (GBUPT)"
  },
  {
   value: "Thorne (GBTOE)",
   label: "Thorne (GBTOE)"
  },
  {
   value: "Thornton (GBTHN)",
   label: "Thornton (GBTHN)"
  },
  {
   value: "Thornton Heath (GBTHH)",
   label: "Thornton Heath (GBTHH)"
  },
  {
   value: "Thrapston (GBTPS)",
   label: "Thrapston (GBTPS)"
  },
  {
   value: "Three Legged Cross (GBTHC)",
   label: "Three Legged Cross (GBTHC)"
  },
  {
   value: "Throcking (GBTKG)",
   label: "Throcking (GBTKG)"
  },
  {
   value: "Thrupp (GBTPP)",
   label: "Thrupp (GBTPP)"
  },
  {
   value: "Thurleigh (GBTLH)",
   label: "Thurleigh (GBTLH)"
  },
  {
   value: "Thurmaston (GBTMS)",
   label: "Thurmaston (GBTMS)"
  },
  {
   value: "Thurrock (GBTRK)",
   label: "Thurrock (GBTRK)"
  },
  {
   value: "Thurso (GBTHR)",
   label: "Thurso (GBTHR)"
  },
  {
   value: "Tibshelf (GBTBS)",
   label: "Tibshelf (GBTBS)"
  },
  {
   value: "Ticehurst (GBTCH)",
   label: "Ticehurst (GBTCH)"
  },
  {
   value: "Tickenham (GBTKM)",
   label: "Tickenham (GBTKM)"
  },
  {
   value: "Tickhill (GBTIC)",
   label: "Tickhill (GBTIC)"
  },
  {
   value: "Tilbury (GBTIL)",
   label: "Tilbury (GBTIL)"
  },
  {
   value: "Tilsworth (GBTSW)",
   label: "Tilsworth (GBTSW)"
  },
  {
   value: "Tingwall (GBTWL)",
   label: "Tingwall (GBTWL)"
  },
  {
   value: "Tipton (GBTPN)",
   label: "Tipton (GBTPN)"
  },
  {
   value: "Tiree (GBTRE)",
   label: "Tiree (GBTRE)"
  },
  {
   value: "Tiverton (GBTVN)",
   label: "Tiverton (GBTVN)"
  },
  {
   value: "Tivertshall St Margaret (GBTSM)",
   label: "Tivertshall St Margaret (GBTSM)"
  },
  {
   value: "Tobermory (GBTOB)",
   label: "Tobermory (GBTOB)"
  },
  {
   value: "Tockwith (GBTKW)",
   label: "Tockwith (GBTKW)"
  },
  {
   value: "Toddington (GBTDN)",
   label: "Toddington (GBTDN)"
  },
  {
   value: "Todmorden (GBTDM)",
   label: "Todmorden (GBTDM)"
  },
  {
   value: "Toft (GBTOF)",
   label: "Toft (GBTOF)"
  },
  {
   value: "Tollesbury (GBTOL)",
   label: "Tollesbury (GBTOL)"
  },
  {
   value: "Tolleshunt D'arcy (GBTOM)",
   label: "Tolleshunt D'arcy (GBTOM)"
  },
  {
   value: "Tolworth (GBTWT)",
   label: "Tolworth (GBTWT)"
  },
  {
   value: "Tomatin (GBTOA)",
   label: "Tomatin (GBTOA)"
  },
  {
   value: "Tomintoul (GBOUT)",
   label: "Tomintoul (GBOUT)"
  },
  {
   value: "Tonbridge (GBTNB)",
   label: "Tonbridge (GBTNB)"
  },
  {
   value: "Toomebridge (GBTOO)",
   label: "Toomebridge (GBTOO)"
  },
  {
   value: "Topsham (GBTHM)",
   label: "Topsham (GBTHM)"
  },
  {
   value: "Torquay (GBTOR)",
   label: "Torquay (GBTOR)"
  },
  {
   value: "Totnes (GBTTS)",
   label: "Totnes (GBTTS)"
  },
  {
   value: "Tottenham (GBTTT)",
   label: "Tottenham (GBTTT)"
  },
  {
   value: "Totteridge (GBTTR)",
   label: "Totteridge (GBTTR)"
  },
  {
   value: "Totton (GBTLQ)",
   label: "Totton (GBTLQ)"
  },
  {
   value: "Tovil (GBTVL)",
   label: "Tovil (GBTVL)"
  },
  {
   value: "Swanscombe (GBSWB)",
   label: "Swanscombe (GBSWB)"
  },
  {
   value: "Swansea (GBSWA)",
   label: "Swansea (GBSWA)"
  },
  {
   value: "Swanwick (GBSWK)",
   label: "Swanwick (GBSWK)"
  },
  {
   value: "Swindon (GBSNN)",
   label: "Swindon (GBSNN)"
  },
  {
   value: "Swinton (GBSWN)",
   label: "Swinton (GBSWN)"
  },
  {
   value: "Symbister (GBSYM)",
   label: "Symbister (GBSYM)"
  },
  {
   value: "Syston (GBSYS)",
   label: "Syston (GBSYS)"
  },
  {
   value: "Sywell (GBSYW)",
   label: "Sywell (GBSYW)"
  },
  {
   value: "Tadcaster (GBTDS)",
   label: "Tadcaster (GBTDS)"
  },
  {
   value: "Tadworth (GBTDW)",
   label: "Tadworth (GBTDW)"
  },
  {
   value: "Taff's Well (GBTFW)",
   label: "Taff's Well (GBTFW)"
  },
  {
   value: "Tamworth (GBTAW)",
   label: "Tamworth (GBTAW)"
  },
  {
   value: "Tandragee (GBTDG)",
   label: "Tandragee (GBTDG)"
  },
  {
   value: "Taplow (GBTLW)",
   label: "Taplow (GBTLW)"
  },
  {
   value: "Tarbert (GBTAB)",
   label: "Tarbert (GBTAB)"
  },
  {
   value: "Tarporley (GBTPL)",
   label: "Tarporley (GBTPL)"
  },
  {
   value: "Taunton (GBTAU)",
   label: "Taunton (GBTAU)"
  },
  {
   value: "Tavistock (GBTAS)",
   label: "Tavistock (GBTAS)"
  },
  {
   value: "Tayport (GBTAY)",
   label: "Tayport (GBTAY)"
  },
  {
   value: "Teddington (GBTDD)",
   label: "Teddington (GBTDD)"
  },
  {
   value: "Teesport (GBTEE)",
   label: "Teesport (GBTEE)"
  },
  {
   value: "Teesside (GBMME)",
   label: "Teesside (GBMME)"
  },
  {
   value: "Teignmouth (GBTNM)",
   label: "Teignmouth (GBTNM)"
  },
  {
   value: "Telford (GBTEF)",
   label: "Telford (GBTEF)"
  },
  {
   value: "Templecombe (GBTPC)",
   label: "Templecombe (GBTPC)"
  },
  {
   value: "Tenterden (GBTTD)",
   label: "Tenterden (GBTTD)"
  },
  {
   value: "Tetbury (GBTET)",
   label: "Tetbury (GBTET)"
  },
  {
   value: "Tetney Terminal (GBTTL)",
   label: "Tetney Terminal (GBTTL)"
  },
  {
   value: "Tewkesbury (GBTEB)",
   label: "Tewkesbury (GBTEB)"
  },
  {
   value: "Teynham (GBTYH)",
   label: "Teynham (GBTYH)"
  },
  {
   value: "Thame (GBTHE)",
   label: "Thame (GBTHE)"
  },
  {
   value: "Thames Ditton (GBTDT)",
   label: "Thames Ditton (GBTDT)"
  },
  {
   value: "Thames Haven (GBTHS)",
   label: "Thames Haven (GBTHS)"
  },
  {
   value: "Thamesport (GBTHP)",
   label: "Thamesport (GBTHP)"
  },
  {
   value: "Thatcham (GBTHA)",
   label: "Thatcham (GBTHA)"
  },
  {
   value: "Thaxted (GBTXD)",
   label: "Thaxted (GBTXD)"
  },
  {
   value: "Thetford (GBTFD)",
   label: "Thetford (GBTFD)"
  },
  {
   value: "Thirsk (GBTSK)",
   label: "Thirsk (GBTSK)"
  },
  {
   value: "Thormanby (GBTHO)",
   label: "Thormanby (GBTHO)"
  },
  {
   value: "Thornaby on Tees (GBTOT)",
   label: "Thornaby on Tees (GBTOT)"
  },
  {
   value: "Thornbridge (GBTHB)",
   label: "Thornbridge (GBTHB)"
  },
  {
   value: "Stoke On Trent (GBSOT)",
   label: "Stoke On Trent (GBSOT)"
  },
  {
   value: "Stone (GBSTX)",
   label: "Stone (GBSTX)"
  },
  {
   value: "Stonehaven (GBSVN)",
   label: "Stonehaven (GBSVN)"
  },
  {
   value: "Stonehouse (GBYVZ)",
   label: "Stonehouse (GBYVZ)"
  },
  {
   value: "Stornoway (GBSTO)",
   label: "Stornoway (GBSTO)"
  },
  {
   value: "Storrington (GBSRN)",
   label: "Storrington (GBSRN)"
  },
  {
   value: "Stourbridge (GBSDG)",
   label: "Stourbridge (GBSDG)"
  },
  {
   value: "Stourport on Severn (GBSPS)",
   label: "Stourport on Severn (GBSPS)"
  },
  {
   value: "Stowmarket (GBSTW)",
   label: "Stowmarket (GBSTW)"
  },
  {
   value: "Strabane (GBSTB)",
   label: "Strabane (GBSTB)"
  },
  {
   value: "Stramshall (GBSML)",
   label: "Stramshall (GBSML)"
  },
  {
   value: "Stranraer (GBSTR)",
   label: "Stranraer (GBSTR)"
  },
  {
   value: "Stratford (GBSTF)",
   label: "Stratford (GBSTF)"
  },
  {
   value: "Stratford upon Avon (GBSAV)",
   label: "Stratford upon Avon (GBSAV)"
  },
  {
   value: "Stratton (GBSAO)",
   label: "Stratton (GBSAO)"
  },
  {
   value: "Street (GBSTE)",
   label: "Street (GBSTE)"
  },
  {
   value: "Stretford (GBSFD)",
   label: "Stretford (GBSFD)"
  },
  {
   value: "Stromness (GBSNS)",
   label: "Stromness (GBSNS)"
  },
  {
   value: "Stronsay (GBSOY)",
   label: "Stronsay (GBSOY)"
  },
  {
   value: "Strood (GBSTD)",
   label: "Strood (GBSTD)"
  },
  {
   value: "Stroud (GBSDX)",
   label: "Stroud (GBSDX)"
  },
  {
   value: "Stubbington (GBSBT)",
   label: "Stubbington (GBSBT)"
  },
  {
   value: "Studley (GBSTU)",
   label: "Studley (GBSTU)"
  },
  {
   value: "Sudbury (GBSUD)",
   label: "Sudbury (GBSUD)"
  },
  {
   value: "Sullom Voe (GBSUL)",
   label: "Sullom Voe (GBSUL)"
  },
  {
   value: "Sumburgh (GBLSI)",
   label: "Sumburgh (GBLSI)"
  },
  {
   value: "Sunbury (GBSBY)",
   label: "Sunbury (GBSBY)"
  },
  {
   value: "Sunderland (GBSUN)",
   label: "Sunderland (GBSUN)"
  },
  {
   value: "Sundycroft (GBSDF)",
   label: "Sundycroft (GBSDF)"
  },
  {
   value: "Sunningdale (GBSGD)",
   label: "Sunningdale (GBSGD)"
  },
  {
   value: "Sunninghill (GBSGL)",
   label: "Sunninghill (GBSGL)"
  },
  {
   value: "Surbiton (GBSUR)",
   label: "Surbiton (GBSUR)"
  },
  {
   value: "Surrey Hill (GBSRH)",
   label: "Surrey Hill (GBSRH)"
  },
  {
   value: "Sutton (GBSUS)",
   label: "Sutton (GBSUS)"
  },
  {
   value: "Sutton Bonnington (GBSBO)",
   label: "Sutton Bonnington (GBSBO)"
  },
  {
   value: "Sutton Coldfield (GBSUC)",
   label: "Sutton Coldfield (GBSUC)"
  },
  {
   value: "Sutton In Ashfield (GBSUA)",
   label: "Sutton In Ashfield (GBSUA)"
  },
  {
   value: "Suttonheath (GBWOB)",
   label: "Suttonheath (GBWOB)"
  },
  {
   value: "Swadlincote (GBQWH)",
   label: "Swadlincote (GBQWH)"
  },
  {
   value: "Swanley (GBSAY)",
   label: "Swanley (GBSAY)"
  },
  {
   value: "St Clears (GBSCL)",
   label: "St Clears (GBSCL)"
  },
  {
   value: "St Helens (GBSHY)",
   label: "St Helens (GBSHY)"
  },
  {
   value: "St Helier (GBSTH)",
   label: "St Helier (GBSTH)"
  },
  {
   value: "St Ives (GBSTI)",
   label: "St Ives (GBSTI)"
  },
  {
   value: "St Leonards (GBSLA)",
   label: "St Leonards (GBSLA)"
  },
  {
   value: "St Neots (GBSNT)",
   label: "St Neots (GBSNT)"
  },
  {
   value: "St Osyth (GBSOS)",
   label: "St Osyth (GBSOS)"
  },
  {
   value: "St Peter Port (GBSPT)",
   label: "St Peter Port (GBSPT)"
  },
  {
   value: "Stafford (GBSRD)",
   label: "Stafford (GBSRD)"
  },
  {
   value: "Staines (GBSTS)",
   label: "Staines (GBSTS)"
  },
  {
   value: "Stallingborough (GBSLG)",
   label: "Stallingborough (GBSLG)"
  },
  {
   value: "Stalybridge (GBSTY)",
   label: "Stalybridge (GBSTY)"
  },
  {
   value: "Stamford (GBTAF)",
   label: "Stamford (GBTAF)"
  },
  {
   value: "Standish (GBSAH)",
   label: "Standish (GBSAH)"
  },
  {
   value: "Standon (GBSON)",
   label: "Standon (GBSON)"
  },
  {
   value: "Stanford in the Vale (GBSFV)",
   label: "Stanford in the Vale (GBSFV)"
  },
  {
   value: "Stanhope (GBSOP)",
   label: "Stanhope (GBSOP)"
  },
  {
   value: "Stanley (GBSNL)",
   label: "Stanley (GBSNL)"
  },
  {
   value: "Stanlow (GBSOW)",
   label: "Stanlow (GBSOW)"
  },
  {
   value: "Stanmore (GBSTM)",
   label: "Stanmore (GBSTM)"
  },
  {
   value: "Stanmore (GBSNM)",
   label: "Stanmore (GBSNM)"
  },
  {
   value: "Stanstead Abbots (GBSSA)",
   label: "Stanstead Abbots (GBSSA)"
  },
  {
   value: "Stansted Apt\/London (GBSTN)",
   label: "Stansted Apt\/London (GBSTN)"
  },
  {
   value: "Stanton (GBSOX)",
   label: "Stanton (GBSOX)"
  },
  {
   value: "Stanwell (GBSWL)",
   label: "Stanwell (GBSWL)"
  },
  {
   value: "Stapleford (GBSFO)",
   label: "Stapleford (GBSFO)"
  },
  {
   value: "Steeple Bumpstead (GBSPB)",
   label: "Steeple Bumpstead (GBSPB)"
  },
  {
   value: "Stevenage (GBSTV)",
   label: "Stevenage (GBSTV)"
  },
  {
   value: "Stevenston (GBSSN)",
   label: "Stevenston (GBSSN)"
  },
  {
   value: "Stirchley (GBSCY)",
   label: "Stirchley (GBSCY)"
  },
  {
   value: "Stirling (GBSIG)",
   label: "Stirling (GBSIG)"
  },
  {
   value: "Stockbridge (GBSBD)",
   label: "Stockbridge (GBSBD)"
  },
  {
   value: "Stockland (GBSLD)",
   label: "Stockland (GBSLD)"
  },
  {
   value: "Stockport (GBSTK)",
   label: "Stockport (GBSTK)"
  },
  {
   value: "Stocksbridge (GBSBG)",
   label: "Stocksbridge (GBSBG)"
  },
  {
   value: "Stockton (GBSCT)",
   label: "Stockton (GBSCT)"
  },
  {
   value: "Stockton On Tees (GBSTT)",
   label: "Stockton On Tees (GBSTT)"
  },
  {
   value: "Stoke (GBSOE)",
   label: "Stoke (GBSOE)"
  },
  {
   value: "Stoke by Nayland (GBSNY)",
   label: "Stoke by Nayland (GBSNY)"
  },
  {
   value: "Stoke Ferry (GBSFE)",
   label: "Stoke Ferry (GBSFE)"
  },
  {
   value: "Solihull (GBSOL)",
   label: "Solihull (GBSOL)"
  },
  {
   value: "Somercotes (GBSOM)",
   label: "Somercotes (GBSOM)"
  },
  {
   value: "Somerton (GBSMR)",
   label: "Somerton (GBSMR)"
  },
  {
   value: "Sonning (GBSQN)",
   label: "Sonning (GBSQN)"
  },
  {
   value: "South Benfleet (GBSBF)",
   label: "South Benfleet (GBSBF)"
  },
  {
   value: "South Cave (GBSTC)",
   label: "South Cave (GBSTC)"
  },
  {
   value: "South Darenth (GBSHD)",
   label: "South Darenth (GBSHD)"
  },
  {
   value: "South Hayling (GBSHG)",
   label: "South Hayling (GBSHG)"
  },
  {
   value: "South Heighton (GBSHQ)",
   label: "South Heighton (GBSHQ)"
  },
  {
   value: "South Kirkby (GBSOK)",
   label: "South Kirkby (GBSOK)"
  },
  {
   value: "South Lancing (GBQVY)",
   label: "South Lancing (GBQVY)"
  },
  {
   value: "South Mimms (GBSMI)",
   label: "South Mimms (GBSMI)"
  },
  {
   value: "South Norwood (GBSNR)",
   label: "South Norwood (GBSNR)"
  },
  {
   value: "South Ockendon (GBSOO)",
   label: "South Ockendon (GBSOO)"
  },
  {
   value: "South Queensferry (GBSOQ)",
   label: "South Queensferry (GBSOQ)"
  },
  {
   value: "South Shields (GBSSH)",
   label: "South Shields (GBSSH)"
  },
  {
   value: "South Weston (GBSWO)",
   label: "South Weston (GBSWO)"
  },
  {
   value: "South Woodham Ferrers (GBSWF)",
   label: "South Woodham Ferrers (GBSWF)"
  },
  {
   value: "Southall (GBSLL)",
   label: "Southall (GBSLL)"
  },
  {
   value: "Southam (GBSOH)",
   label: "Southam (GBSOH)"
  },
  {
   value: "Southampton (GBSOU)",
   label: "Southampton (GBSOU)"
  },
  {
   value: "Southend (GBSND)",
   label: "Southend (GBSND)"
  },
  {
   value: "Southport (GBSRT)",
   label: "Southport (GBSRT)"
  },
  {
   value: "Southwark (GBSWR)",
   label: "Southwark (GBSWR)"
  },
  {
   value: "Southwater (GBSTA)",
   label: "Southwater (GBSTA)"
  },
  {
   value: "Southwick (GBYKH)",
   label: "Southwick (GBYKH)"
  },
  {
   value: "Southwold (GBSWD)",
   label: "Southwold (GBSWD)"
  },
  {
   value: "Spalding (GBSPA)",
   label: "Spalding (GBSPA)"
  },
  {
   value: "Sparkford (GBSPR)",
   label: "Sparkford (GBSPR)"
  },
  {
   value: "Speke (GBSPK)",
   label: "Speke (GBSPK)"
  },
  {
   value: "Spellbrook (GBSPE)",
   label: "Spellbrook (GBSPE)"
  },
  {
   value: "Spencers Wood (GBSPW)",
   label: "Spencers Wood (GBSPW)"
  },
  {
   value: "Spennymoor (GBSPN)",
   label: "Spennymoor (GBSPN)"
  },
  {
   value: "Spondon (GBSPO)",
   label: "Spondon (GBSPO)"
  },
  {
   value: "Spurn Head (GBSUH)",
   label: "Spurn Head (GBSUH)"
  },
  {
   value: "St Albans (GBTBL)",
   label: "St Albans (GBTBL)"
  },
  {
   value: "St Andrews (GBSNW)",
   label: "St Andrews (GBSNW)"
  },
  {
   value: "St Asaph (GBSPH)",
   label: "St Asaph (GBSPH)"
  },
  {
   value: "St Austell (GBSTL)",
   label: "St Austell (GBSTL)"
  },
  {
   value: "Shepton Mallet (GBSHM)",
   label: "Shepton Mallet (GBSHM)"
  },
  {
   value: "Sherborne (GBSHR)",
   label: "Sherborne (GBSHR)"
  },
  {
   value: "Sherbourne (GBSPU)",
   label: "Sherbourne (GBSPU)"
  },
  {
   value: "Sherston (GBSRS)",
   label: "Sherston (GBSRS)"
  },
  {
   value: "Shildon (GBSDN)",
   label: "Shildon (GBSDN)"
  },
  {
   value: "Shipdham (GBSHH)",
   label: "Shipdham (GBSHH)"
  },
  {
   value: "Shipham (GBSPM)",
   label: "Shipham (GBSPM)"
  },
  {
   value: "Shiplake (GBSLK)",
   label: "Shiplake (GBSLK)"
  },
  {
   value: "Shipley (GBSHI)",
   label: "Shipley (GBSHI)"
  },
  {
   value: "Shipley (GBSXY)",
   label: "Shipley (GBSXY)"
  },
  {
   value: "Shirley (GBSIY)",
   label: "Shirley (GBSIY)"
  },
  {
   value: "Shoeburyness (GBSYN)",
   label: "Shoeburyness (GBSYN)"
  },
  {
   value: "Shoreham (GBSHO)",
   label: "Shoreham (GBSHO)"
  },
  {
   value: "Shotton (GBSHT)",
   label: "Shotton (GBSHT)"
  },
  {
   value: "Shrewsbury (GBSBR)",
   label: "Shrewsbury (GBSBR)"
  },
  {
   value: "Shrivenham (GBSHA)",
   label: "Shrivenham (GBSHA)"
  },
  {
   value: "Sidcup (GBSDC)",
   label: "Sidcup (GBSDC)"
  },
  {
   value: "Sidmouth (GBSDM)",
   label: "Sidmouth (GBSDM)"
  },
  {
   value: "Silchester (GBSLR)",
   label: "Silchester (GBSLR)"
  },
  {
   value: "Sileby (GBSLY)",
   label: "Sileby (GBSLY)"
  },
  {
   value: "Silloth (GBSIL)",
   label: "Silloth (GBSIL)"
  },
  {
   value: "Silsden (GBSSD)",
   label: "Silsden (GBSSD)"
  },
  {
   value: "Silverton (GBSVE)",
   label: "Silverton (GBSVE)"
  },
  {
   value: "Silvertown (GBSVT)",
   label: "Silvertown (GBSVT)"
  },
  {
   value: "Simonswood (GBSMW)",
   label: "Simonswood (GBSMW)"
  },
  {
   value: "Singleton (GBSIN)",
   label: "Singleton (GBSIN)"
  },
  {
   value: "Singleton (GBSNG)",
   label: "Singleton (GBSNG)"
  },
  {
   value: "Sissinghurst (GBSSG)",
   label: "Sissinghurst (GBSSG)"
  },
  {
   value: "Sittingbourne (GBSIT)",
   label: "Sittingbourne (GBSIT)"
  },
  {
   value: "Skegness (GBSKE)",
   label: "Skegness (GBSKE)"
  },
  {
   value: "Skelmersdale (GBSKD)",
   label: "Skelmersdale (GBSKD)"
  },
  {
   value: "Skelton (GBSKL)",
   label: "Skelton (GBSKL)"
  },
  {
   value: "Skipton (GBSKI)",
   label: "Skipton (GBSKI)"
  },
  {
   value: "Slawston (GBSLW)",
   label: "Slawston (GBSLW)"
  },
  {
   value: "Sleaford (GBSLE)",
   label: "Sleaford (GBSLE)"
  },
  {
   value: "Slinfold (GBSLI)",
   label: "Slinfold (GBSLI)"
  },
  {
   value: "Slough (GBSLO)",
   label: "Slough (GBSLO)"
  },
  {
   value: "Small Dole (GBSMD)",
   label: "Small Dole (GBSMD)"
  },
  {
   value: "Smethwick (GBSME)",
   label: "Smethwick (GBSME)"
  },
  {
   value: "Snodland (GBSDL)",
   label: "Snodland (GBSDL)"
  },
  {
   value: "Soham (GBSZM)",
   label: "Soham (GBSZM)"
  },
  {
   value: "Sandycroft (GBSNF)",
   label: "Sandycroft (GBSNF)"
  },
  {
   value: "Sawbridgeworth (GBSWW)",
   label: "Sawbridgeworth (GBSWW)"
  },
  {
   value: "Sawston (GBSAS)",
   label: "Sawston (GBSAS)"
  },
  {
   value: "Saxham (GBSAX)",
   label: "Saxham (GBSAX)"
  },
  {
   value: "Saxmundham (GBSXM)",
   label: "Saxmundham (GBSXM)"
  },
  {
   value: "Sayers Common (GBSYC)",
   label: "Sayers Common (GBSYC)"
  },
  {
   value: "Scalloway (GBSWY)",
   label: "Scalloway (GBSWY)"
  },
  {
   value: "Scampton (GBSQZ)",
   label: "Scampton (GBSQZ)"
  },
  {
   value: "Scapa Flow (GBSFW)",
   label: "Scapa Flow (GBSFW)"
  },
  {
   value: "Scarborough (GBSCA)",
   label: "Scarborough (GBSCA)"
  },
  {
   value: "Scarisbrick (GBSBK)",
   label: "Scarisbrick (GBSBK)"
  },
  {
   value: "Scatsta (GBSCS)",
   label: "Scatsta (GBSCS)"
  },
  {
   value: "Scrabster (GBSCR)",
   label: "Scrabster (GBSCR)"
  },
  {
   value: "Scunthorpe (GBSCP)",
   label: "Scunthorpe (GBSCP)"
  },
  {
   value: "Seaford (GBSFR)",
   label: "Seaford (GBSFR)"
  },
  {
   value: "Seaforth (GBSEF)",
   label: "Seaforth (GBSEF)"
  },
  {
   value: "Seaham (GBSEA)",
   label: "Seaham (GBSEA)"
  },
  {
   value: "Seal (GBSXX)",
   label: "Seal (GBSXX)"
  },
  {
   value: "Seascale (GBSSC)",
   label: "Seascale (GBSSC)"
  },
  {
   value: "Seaton Delaval (GBSDV)",
   label: "Seaton Delaval (GBSDV)"
  },
  {
   value: "Sedbergh (GBSEH)",
   label: "Sedbergh (GBSEH)"
  },
  {
   value: "Seething (GBSTG)",
   label: "Seething (GBSTG)"
  },
  {
   value: "Seighford (GBSGH)",
   label: "Seighford (GBSGH)"
  },
  {
   value: "Selby (GBSLB)",
   label: "Selby (GBSLB)"
  },
  {
   value: "Selsdon (GBSEO)",
   label: "Selsdon (GBSEO)"
  },
  {
   value: "Selsey (GBSSY)",
   label: "Selsey (GBSSY)"
  },
  {
   value: "Settle (GBSET)",
   label: "Settle (GBSET)"
  },
  {
   value: "Seven Kings (GBSVK)",
   label: "Seven Kings (GBSVK)"
  },
  {
   value: "Sevenoaks (GBSEV)",
   label: "Sevenoaks (GBSEV)"
  },
  {
   value: "Shaftesbury (GBSHB)",
   label: "Shaftesbury (GBSHB)"
  },
  {
   value: "Sharpness (GBSSS)",
   label: "Sharpness (GBSSS)"
  },
  {
   value: "Shaw (GBSHW)",
   label: "Shaw (GBSHW)"
  },
  {
   value: "Sheerness (GBSHS)",
   label: "Sheerness (GBSHS)"
  },
  {
   value: "Sheffield (GBSHE)",
   label: "Sheffield (GBSHE)"
  },
  {
   value: "Shefford (GBSHF)",
   label: "Shefford (GBSHF)"
  },
  {
   value: "Shelf (GBSLF)",
   label: "Shelf (GBSLF)"
  },
  {
   value: "Shell Haven (GBSHV)",
   label: "Shell Haven (GBSHV)"
  },
  {
   value: "Shenfield (GBSHL)",
   label: "Shenfield (GBSHL)"
  },
  {
   value: "Shenstone (GBSST)",
   label: "Shenstone (GBSST)"
  },
  {
   value: "Shepherds Bush (GBSHP)",
   label: "Shepherds Bush (GBSHP)"
  },
  {
   value: "Shepshed (GBSPD)",
   label: "Shepshed (GBSPD)"
  },
  {
   value: "Rochford (GBRFD)",
   label: "Rochford (GBRFD)"
  },
  {
   value: "Roecliffe (GBRFF)",
   label: "Roecliffe (GBRFF)"
  },
  {
   value: "Romford (GBRMF)",
   label: "Romford (GBRMF)"
  },
  {
   value: "Romsey (GBRMS)",
   label: "Romsey (GBRMS)"
  },
  {
   value: "Ross (GBRSS)",
   label: "Ross (GBRSS)"
  },
  {
   value: "Ross-on-wye (GBRNW)",
   label: "Ross-on-wye (GBRNW)"
  },
  {
   value: "Rosyth (GBROY)",
   label: "Rosyth (GBROY)"
  },
  {
   value: "Rotherfield (GBRTR)",
   label: "Rotherfield (GBRTR)"
  },
  {
   value: "Rotherham (GBRTH)",
   label: "Rotherham (GBRTH)"
  },
  {
   value: "Rothes (GBROT)",
   label: "Rothes (GBROT)"
  },
  {
   value: "Rothesay (GBRAY)",
   label: "Rothesay (GBRAY)"
  },
  {
   value: "Rowhedge (GBROW)",
   label: "Rowhedge (GBROW)"
  },
  {
   value: "Royston (GBROS)",
   label: "Royston (GBROS)"
  },
  {
   value: "Royton (GBRTN)",
   label: "Royton (GBRTN)"
  },
  {
   value: "Ruabon (GBRUW)",
   label: "Ruabon (GBRUW)"
  },
  {
   value: "Rugby (GBRUG)",
   label: "Rugby (GBRUG)"
  },
  {
   value: "Rugeley (GBREY)",
   label: "Rugeley (GBREY)"
  },
  {
   value: "Ruislip (GBRUI)",
   label: "Ruislip (GBRUI)"
  },
  {
   value: "Runcorn (GBRUN)",
   label: "Runcorn (GBRUN)"
  },
  {
   value: "Rushden (GBRUS)",
   label: "Rushden (GBRUS)"
  },
  {
   value: "Rushlake Green (GBRSG)",
   label: "Rushlake Green (GBRSG)"
  },
  {
   value: "Rushton (GBRSN)",
   label: "Rushton (GBRSN)"
  },
  {
   value: "Rutherglen (GBRUT)",
   label: "Rutherglen (GBRUT)"
  },
  {
   value: "Ruthin (GBRHN)",
   label: "Ruthin (GBRHN)"
  },
  {
   value: "Rye (GBRYE)",
   label: "Rye (GBRYE)"
  },
  {
   value: "Sabden (GBSAB)",
   label: "Sabden (GBSAB)"
  },
  {
   value: "Saffron Walden (GBSAW)",
   label: "Saffron Walden (GBSAW)"
  },
  {
   value: "Sale (GBSAE)",
   label: "Sale (GBSAE)"
  },
  {
   value: "Salford (GBSFY)",
   label: "Salford (GBSFY)"
  },
  {
   value: "Salisbury (GBSLS)",
   label: "Salisbury (GBSLS)"
  },
  {
   value: "Salt End (GBSED)",
   label: "Salt End (GBSED)"
  },
  {
   value: "Saltburn-By-Sea (GBSLN)",
   label: "Saltburn-By-Sea (GBSLN)"
  },
  {
   value: "Saltcoats (GBSLC)",
   label: "Saltcoats (GBSLC)"
  },
  {
   value: "Saltney (GBSLT)",
   label: "Saltney (GBSLT)"
  },
  {
   value: "Samlesbury (GBSAM)",
   label: "Samlesbury (GBSAM)"
  },
  {
   value: "Sanday (GBNDY)",
   label: "Sanday (GBNDY)"
  },
  {
   value: "Sandbach (GBSAN)",
   label: "Sandbach (GBSAN)"
  },
  {
   value: "Sanderstead (GBSDR)",
   label: "Sanderstead (GBSDR)"
  },
  {
   value: "Sandgate (GBQVG)",
   label: "Sandgate (GBQVG)"
  },
  {
   value: "Sandiacre (GBSDI)",
   label: "Sandiacre (GBSDI)"
  },
  {
   value: "Sandwich (GBSDW)",
   label: "Sandwich (GBSDW)"
  },
  {
   value: "Sandy (GBSDY)",
   label: "Sandy (GBSDY)"
  },
  {
   value: "Radlett (GBRDL)",
   label: "Radlett (GBRDL)"
  },
  {
   value: "Rainham (GBRAH)",
   label: "Rainham (GBRAH)"
  },
  {
   value: "Ramsbottom (GBRMB)",
   label: "Ramsbottom (GBRMB)"
  },
  {
   value: "Ramsey (GBRSY)",
   label: "Ramsey (GBRSY)"
  },
  {
   value: "Ramsgate (GBRMG)",
   label: "Ramsgate (GBRMG)"
  },
  {
   value: "Ranskill (GBRNS)",
   label: "Ranskill (GBRNS)"
  },
  {
   value: "Raunds (GBRUD)",
   label: "Raunds (GBRUD)"
  },
  {
   value: "Rawtenstall (GBRAW)",
   label: "Rawtenstall (GBRAW)"
  },
  {
   value: "Rayleigh (GBRLH)",
   label: "Rayleigh (GBRLH)"
  },
  {
   value: "Reading (GBRDN)",
   label: "Reading (GBRDN)"
  },
  {
   value: "Redbourn (GBRDB)",
   label: "Redbourn (GBRDB)"
  },
  {
   value: "Redcar (GBRER)",
   label: "Redcar (GBRER)"
  },
  {
   value: "Redcliff Bay (GBREB)",
   label: "Redcliff Bay (GBREB)"
  },
  {
   value: "Redditch (GBRDD)",
   label: "Redditch (GBRDD)"
  },
  {
   value: "Redford (GBRDF)",
   label: "Redford (GBRDF)"
  },
  {
   value: "Redgrave (GBRGV)",
   label: "Redgrave (GBRGV)"
  },
  {
   value: "Redhill (GBREH)",
   label: "Redhill (GBREH)"
  },
  {
   value: "Redruth (GBRRU)",
   label: "Redruth (GBRRU)"
  },
  {
   value: "Regent's Park (GBRGP)",
   label: "Regent's Park (GBRGP)"
  },
  {
   value: "Reigate (GBRGT)",
   label: "Reigate (GBRGT)"
  },
  {
   value: "Renfrew (GBREN)",
   label: "Renfrew (GBREN)"
  },
  {
   value: "Retford (GBRFO)",
   label: "Retford (GBRFO)"
  },
  {
   value: "Rhigos (GBRHG)",
   label: "Rhigos (GBRHG)"
  },
  {
   value: "Rhyl (GBRHY)",
   label: "Rhyl (GBRHY)"
  },
  {
   value: "Rhymney (GBRYY)",
   label: "Rhymney (GBRYY)"
  },
  {
   value: "Richmond (GBRCH)",
   label: "Richmond (GBRCH)"
  },
  {
   value: "Richmond upon Thames (GBRCU)",
   label: "Richmond upon Thames (GBRCU)"
  },
  {
   value: "Rickmansworth (GBRKW)",
   label: "Rickmansworth (GBRKW)"
  },
  {
   value: "Ridham Dock (GBRID)",
   label: "Ridham Dock (GBRID)"
  },
  {
   value: "Ringmer (GBRGR)",
   label: "Ringmer (GBRGR)"
  },
  {
   value: "Ringstead (GBRIN)",
   label: "Ringstead (GBRIN)"
  },
  {
   value: "Ringwood (GBRIW)",
   label: "Ringwood (GBRIW)"
  },
  {
   value: "Ripley (GBRPY)",
   label: "Ripley (GBRPY)"
  },
  {
   value: "Ripon (GBRIP)",
   label: "Ripon (GBRIP)"
  },
  {
   value: "Ripponden (GBRPP)",
   label: "Ripponden (GBRPP)"
  },
  {
   value: "Risca (GBRSC)",
   label: "Risca (GBRSC)"
  },
  {
   value: "Riverside Park Apt\/Dundee (GBDND)",
   label: "Riverside Park Apt\/Dundee (GBDND)"
  },
  {
   value: "Roade (GBROA)",
   label: "Roade (GBROA)"
  },
  {
   value: "Robertsbridge (GBRBR)",
   label: "Robertsbridge (GBRBR)"
  },
  {
   value: "Rochdale (GBROL)",
   label: "Rochdale (GBROL)"
  },
  {
   value: "Rochester (GBRCS)",
   label: "Rochester (GBRCS)"
  },
  {
   value: "Port Sunlight (GBPSU)",
   label: "Port Sunlight (GBPSU)"
  },
  {
   value: "Port Sutton Bridge (GBPSB)",
   label: "Port Sutton Bridge (GBPSB)"
  },
  {
   value: "Port Talbot (GBPTB)",
   label: "Port Talbot (GBPTB)"
  },
  {
   value: "Portadown (GBPTW)",
   label: "Portadown (GBPTW)"
  },
  {
   value: "Portbury (GBPRU)",
   label: "Portbury (GBPRU)"
  },
  {
   value: "Portchester (GBPRC)",
   label: "Portchester (GBPRC)"
  },
  {
   value: "Porthcawl (GBPCW)",
   label: "Porthcawl (GBPCW)"
  },
  {
   value: "Portishead (GBPTH)",
   label: "Portishead (GBPTH)"
  },
  {
   value: "Portland (GBPTL)",
   label: "Portland (GBPTL)"
  },
  {
   value: "Portland Harbour (GBPRH)",
   label: "Portland Harbour (GBPRH)"
  },
  {
   value: "Portmadoc (GBPMD)",
   label: "Portmadoc (GBPMD)"
  },
  {
   value: "Portree (GBPRT)",
   label: "Portree (GBPRT)"
  },
  {
   value: "Portrush (GBPTR)",
   label: "Portrush (GBPTR)"
  },
  {
   value: "Portskewett (GBPRK)",
   label: "Portskewett (GBPRK)"
  },
  {
   value: "Portslade (GBPTS)",
   label: "Portslade (GBPTS)"
  },
  {
   value: "Portsmouth (GBPME)",
   label: "Portsmouth (GBPME)"
  },
  {
   value: "Potterne (GBPON)",
   label: "Potterne (GBPON)"
  },
  {
   value: "Potters Bar (GBPOB)",
   label: "Potters Bar (GBPOB)"
  },
  {
   value: "Poyle (GBPYE)",
   label: "Poyle (GBPYE)"
  },
  {
   value: "Poynton (GBPOY)",
   label: "Poynton (GBPOY)"
  },
  {
   value: "Prescot (GBPCT)",
   label: "Prescot (GBPCT)"
  },
  {
   value: "Prestatyn (GBPRS)",
   label: "Prestatyn (GBPRS)"
  },
  {
   value: "Preston (GBPRE)",
   label: "Preston (GBPRE)"
  },
  {
   value: "Prestwich (GBPRW)",
   label: "Prestwich (GBPRW)"
  },
  {
   value: "Princes Risborough (GBPRR)",
   label: "Princes Risborough (GBPRR)"
  },
  {
   value: "Prittlewell (GBPIT)",
   label: "Prittlewell (GBPIT)"
  },
  {
   value: "Prudhoe (GBPRD)",
   label: "Prudhoe (GBPRD)"
  },
  {
   value: "Puckeridge (GBPCR)",
   label: "Puckeridge (GBPCR)"
  },
  {
   value: "Pudsey (GBPDY)",
   label: "Pudsey (GBPDY)"
  },
  {
   value: "Pulborough (GBPUL)",
   label: "Pulborough (GBPUL)"
  },
  {
   value: "Pulloxhill (GBPLX)",
   label: "Pulloxhill (GBPLX)"
  },
  {
   value: "Purfleet (GBPFT)",
   label: "Purfleet (GBPFT)"
  },
  {
   value: "Purley (GBPUR)",
   label: "Purley (GBPUR)"
  },
  {
   value: "Putney (GBPTY)",
   label: "Putney (GBPTY)"
  },
  {
   value: "Puttenham (GBPTN)",
   label: "Puttenham (GBPTN)"
  },
  {
   value: "Pyrford (GBPYR)",
   label: "Pyrford (GBPYR)"
  },
  {
   value: "Queenborough (GBQUB)",
   label: "Queenborough (GBQUB)"
  },
  {
   value: "Queensferry (GBQFR)",
   label: "Queensferry (GBQFR)"
  },
  {
   value: "Radcliffe (GBRDC)",
   label: "Radcliffe (GBRDC)"
  },
  {
   value: "Radcliffe on Trent (GBRNT)",
   label: "Radcliffe on Trent (GBRNT)"
  },
  {
   value: "Pencoed (GBPND)",
   label: "Pencoed (GBPND)"
  },
  {
   value: "Penicuik (GBPCU)",
   label: "Penicuik (GBPCU)"
  },
  {
   value: "Penistone (GBPNS)",
   label: "Penistone (GBPNS)"
  },
  {
   value: "Penmaenmawr (GBPMM)",
   label: "Penmaenmawr (GBPMM)"
  },
  {
   value: "Penn (GBPNN)",
   label: "Penn (GBPNN)"
  },
  {
   value: "Penrith (GBPNR)",
   label: "Penrith (GBPNR)"
  },
  {
   value: "Penryn (GBPRY)",
   label: "Penryn (GBPRY)"
  },
  {
   value: "Penzance (GBPEN)",
   label: "Penzance (GBPEN)"
  },
  {
   value: "Perivale (GBPRV)",
   label: "Perivale (GBPRV)"
  },
  {
   value: "Perry Barr (GBPBR)",
   label: "Perry Barr (GBPBR)"
  },
  {
   value: "Pershore (GBPSH)",
   label: "Pershore (GBPSH)"
  },
  {
   value: "Perth (GBPER)",
   label: "Perth (GBPER)"
  },
  {
   value: "Peterborough (GBPET)",
   label: "Peterborough (GBPET)"
  },
  {
   value: "Peterhead (GBPHD)",
   label: "Peterhead (GBPHD)"
  },
  {
   value: "Peterlee (GBPTE)",
   label: "Peterlee (GBPTE)"
  },
  {
   value: "Petersfield (GBPTF)",
   label: "Petersfield (GBPTF)"
  },
  {
   value: "Pewsey (GBPWS)",
   label: "Pewsey (GBPWS)"
  },
  {
   value: "Pickhill (GBPCL)",
   label: "Pickhill (GBPCL)"
  },
  {
   value: "Pinchbeck (GBPBK)",
   label: "Pinchbeck (GBPBK)"
  },
  {
   value: "Pinner (GBPIN)",
   label: "Pinner (GBPIN)"
  },
  {
   value: "Plumpton Green (GBPMG)",
   label: "Plumpton Green (GBPMG)"
  },
  {
   value: "Plymouth (GBPLY)",
   label: "Plymouth (GBPLY)"
  },
  {
   value: "Pocklington (GBPKL)",
   label: "Pocklington (GBPKL)"
  },
  {
   value: "Poddington (GBPDG)",
   label: "Poddington (GBPDG)"
  },
  {
   value: "Point of Ayre (GBPTA)",
   label: "Point of Ayre (GBPTA)"
  },
  {
   value: "Polegate (GBPGT)",
   label: "Polegate (GBPGT)"
  },
  {
   value: "Pollokshields (GBPLL)",
   label: "Pollokshields (GBPLL)"
  },
  {
   value: "Polsted (GBPLD)",
   label: "Polsted (GBPLD)"
  },
  {
   value: "Ponders End (GBPFF)",
   label: "Ponders End (GBPFF)"
  },
  {
   value: "Pontefract (GBPOF)",
   label: "Pontefract (GBPOF)"
  },
  {
   value: "Ponteland (GBPNL)",
   label: "Ponteland (GBPNL)"
  },
  {
   value: "Pontyclun (GBPNC)",
   label: "Pontyclun (GBPNC)"
  },
  {
   value: "Pontypool (GBPTP)",
   label: "Pontypool (GBPTP)"
  },
  {
   value: "Pontypridd (GBPNY)",
   label: "Pontypridd (GBPNY)"
  },
  {
   value: "Poole (GBPOO)",
   label: "Poole (GBPOO)"
  },
  {
   value: "Poplar (GBPPL)",
   label: "Poplar (GBPPL)"
  },
  {
   value: "Port Askaig (GBPAK)",
   label: "Port Askaig (GBPAK)"
  },
  {
   value: "Port Dinorwic (GBPDI)",
   label: "Port Dinorwic (GBPDI)"
  },
  {
   value: "Port Ellen (GBPLN)",
   label: "Port Ellen (GBPLN)"
  },
  {
   value: "Port Penrhyn (GBPPE)",
   label: "Port Penrhyn (GBPPE)"
  },
  {
   value: "Orchard Portman (GBORP)",
   label: "Orchard Portman (GBORP)"
  },
  {
   value: "Ormskirk (GBOMK)",
   label: "Ormskirk (GBOMK)"
  },
  {
   value: "Orpington (GBOPG)",
   label: "Orpington (GBOPG)"
  },
  {
   value: "Orsett (GBORT)",
   label: "Orsett (GBORT)"
  },
  {
   value: "Ossett (GBOSS)",
   label: "Ossett (GBOSS)"
  },
  {
   value: "Ossington (GBOSN)",
   label: "Ossington (GBOSN)"
  },
  {
   value: "Oswestry (GBOWR)",
   label: "Oswestry (GBOWR)"
  },
  {
   value: "Otham (GBOTH)",
   label: "Otham (GBOTH)"
  },
  {
   value: "Otley (GBOTL)",
   label: "Otley (GBOTL)"
  },
  {
   value: "Ottershaw (GBOTT)",
   label: "Ottershaw (GBOTT)"
  },
  {
   value: "Ottery St. Mary (GBOSM)",
   label: "Ottery St. Mary (GBOSM)"
  },
  {
   value: "Outer Skerries (GBOUK)",
   label: "Outer Skerries (GBOUK)"
  },
  {
   value: "Over (GBOVR)",
   label: "Over (GBOVR)"
  },
  {
   value: "Overton (GBOVE)",
   label: "Overton (GBOVE)"
  },
  {
   value: "Oxford (GBOXF)",
   label: "Oxford (GBOXF)"
  },
  {
   value: "Oxshott (GBOXT)",
   label: "Oxshott (GBOXT)"
  },
  {
   value: "Paddock Wood (GBPDW)",
   label: "Paddock Wood (GBPDW)"
  },
  {
   value: "Padiham (GBPDH)",
   label: "Padiham (GBPDH)"
  },
  {
   value: "Padstow (GBPAD)",
   label: "Padstow (GBPAD)"
  },
  {
   value: "Paignton (GBPGN)",
   label: "Paignton (GBPGN)"
  },
  {
   value: "Paisley (GBPAS)",
   label: "Paisley (GBPAS)"
  },
  {
   value: "Palmers Green (GBPLG)",
   label: "Palmers Green (GBPLG)"
  },
  {
   value: "Palnackie (GBPAL)",
   label: "Palnackie (GBPAL)"
  },
  {
   value: "Pamber Green (GBPGR)",
   label: "Pamber Green (GBPGR)"
  },
  {
   value: "Pangbourne (GBPAB)",
   label: "Pangbourne (GBPAB)"
  },
  {
   value: "Papa Stour (GBPSV)",
   label: "Papa Stour (GBPSV)"
  },
  {
   value: "Papa Westray (GBPPW)",
   label: "Papa Westray (GBPPW)"
  },
  {
   value: "Par (GBPAR)",
   label: "Par (GBPAR)"
  },
  {
   value: "Parbold (GBPBL)",
   label: "Parbold (GBPBL)"
  },
  {
   value: "Parkeston Quay (GBPST)",
   label: "Parkeston Quay (GBPST)"
  },
  {
   value: "Partington (GBPTT)",
   label: "Partington (GBPTT)"
  },
  {
   value: "Partridge Green (GBPRG)",
   label: "Partridge Green (GBPRG)"
  },
  {
   value: "Peckham (GBPCK)",
   label: "Peckham (GBPCK)"
  },
  {
   value: "Peebles (GBPEE)",
   label: "Peebles (GBPEE)"
  },
  {
   value: "Peel (GBPEL)",
   label: "Peel (GBPEL)"
  },
  {
   value: "Pembroke (GBPEM)",
   label: "Pembroke (GBPEM)"
  },
  {
   value: "Pembroke Dock (GBPED)",
   label: "Pembroke Dock (GBPED)"
  },
  {
   value: "Pembury (GBPMB)",
   label: "Pembury (GBPMB)"
  },
  {
   value: "Penarth (GBPNH)",
   label: "Penarth (GBPNH)"
  },
  {
   value: "Pencader (GBPCD)",
   label: "Pencader (GBPCD)"
  },
  {
   value: "Pencaitland (GBPCI)",
   label: "Pencaitland (GBPCI)"
  },
  {
   value: "Nigg (GBNGG)",
   label: "Nigg (GBNGG)"
  },
  {
   value: "Normanton (GBNOR)",
   label: "Normanton (GBNOR)"
  },
  {
   value: "North Berwick (GBNBW)",
   label: "North Berwick (GBNBW)"
  },
  {
   value: "North Cave (GBNCV)",
   label: "North Cave (GBNCV)"
  },
  {
   value: "North Cheam (GBNRC)",
   label: "North Cheam (GBNRC)"
  },
  {
   value: "North Ferriby (GBNRF)",
   label: "North Ferriby (GBNRF)"
  },
  {
   value: "North Hayling (GBNHA)",
   label: "North Hayling (GBNHA)"
  },
  {
   value: "North Lancing (GBNRL)",
   label: "North Lancing (GBNRL)"
  },
  {
   value: "North Ronaldsay Apt (GBNRS)",
   label: "North Ronaldsay Apt (GBNRS)"
  },
  {
   value: "North Shields (GBNSH)",
   label: "North Shields (GBNSH)"
  },
  {
   value: "North Walsam (GBNRM)",
   label: "North Walsam (GBNRM)"
  },
  {
   value: "North Woolwich (GBWOL)",
   label: "North Woolwich (GBWOL)"
  },
  {
   value: "Northallerton (GBNAL)",
   label: "Northallerton (GBNAL)"
  },
  {
   value: "Northam (GBNOM)",
   label: "Northam (GBNOM)"
  },
  {
   value: "Northampton (GBNHP)",
   label: "Northampton (GBNHP)"
  },
  {
   value: "Northchapel (GBNRH)",
   label: "Northchapel (GBNRH)"
  },
  {
   value: "Northfleet (GBNFT)",
   label: "Northfleet (GBNFT)"
  },
  {
   value: "Northolt Apt (GBNHT)",
   label: "Northolt Apt (GBNHT)"
  },
  {
   value: "Northwich (GBNTH)",
   label: "Northwich (GBNTH)"
  },
  {
   value: "Northwood (GBNWD)",
   label: "Northwood (GBNWD)"
  },
  {
   value: "Norwich (GBNRW)",
   label: "Norwich (GBNRW)"
  },
  {
   value: "Nottingham (GBNTG)",
   label: "Nottingham (GBNTG)"
  },
  {
   value: "Nuneaton (GBNTN)",
   label: "Nuneaton (GBNTN)"
  },
  {
   value: "Nursling (GBNUR)",
   label: "Nursling (GBNUR)"
  },
  {
   value: "Oakham (GBOKM)",
   label: "Oakham (GBOKM)"
  },
  {
   value: "Oakhamness (GBOAK)",
   label: "Oakhamness (GBOAK)"
  },
  {
   value: "Oakworth (GBOKW)",
   label: "Oakworth (GBOKW)"
  },
  {
   value: "Oban (GBOBA)",
   label: "Oban (GBOBA)"
  },
  {
   value: "Odiham (GBODM)",
   label: "Odiham (GBODM)"
  },
  {
   value: "Ogbourne Maizey (GBOBM)",
   label: "Ogbourne Maizey (GBOBM)"
  },
  {
   value: "Okehampton (GBOKH)",
   label: "Okehampton (GBOKH)"
  },
  {
   value: "Old (GBOLD)",
   label: "Old (GBOLD)"
  },
  {
   value: "Old Kilpatrick (GBOKK)",
   label: "Old Kilpatrick (GBOKK)"
  },
  {
   value: "Old Woking (GBOLW)",
   label: "Old Woking (GBOLW)"
  },
  {
   value: "Oldbury (GBOBY)",
   label: "Oldbury (GBOBY)"
  },
  {
   value: "Oldham (GBODH)",
   label: "Oldham (GBODH)"
  },
  {
   value: "Olney (GBOLN)",
   label: "Olney (GBOLN)"
  },
  {
   value: "Omagh (GBOMA)",
   label: "Omagh (GBOMA)"
  },
  {
   value: "Ongar (GBOGR)",
   label: "Ongar (GBOGR)"
  },
  {
   value: "Ongar Hill (GBONH)",
   label: "Ongar Hill (GBONH)"
  },
  {
   value: "Neston (GBNES)",
   label: "Neston (GBNES)"
  },
  {
   value: "Nether Poppleton (GBNTP)",
   label: "Nether Poppleton (GBNTP)"
  },
  {
   value: "Netherton (GBNTE)",
   label: "Netherton (GBNTE)"
  },
  {
   value: "New Alresford (GBARL)",
   label: "New Alresford (GBARL)"
  },
  {
   value: "New Duston (GBNDS)",
   label: "New Duston (GBNDS)"
  },
  {
   value: "New Holland (GBNHO)",
   label: "New Holland (GBNHO)"
  },
  {
   value: "New Malden (GBNWM)",
   label: "New Malden (GBNWM)"
  },
  {
   value: "New Maldon (GBNMA)",
   label: "New Maldon (GBNMA)"
  },
  {
   value: "New Milton (GBNMN)",
   label: "New Milton (GBNMN)"
  },
  {
   value: "New York (GBNWY)",
   label: "New York (GBNWY)"
  },
  {
   value: "Newark (GBNWK)",
   label: "Newark (GBNWK)"
  },
  {
   value: "Newark Upon Trent (GBNUT)",
   label: "Newark Upon Trent (GBNUT)"
  },
  {
   value: "Newbridge (GBNWB)",
   label: "Newbridge (GBNWB)"
  },
  {
   value: "Newbridge (GBNWR)",
   label: "Newbridge (GBNWR)"
  },
  {
   value: "Newburgh (GBNBU)",
   label: "Newburgh (GBNBU)"
  },
  {
   value: "Newbury (GBNBY)",
   label: "Newbury (GBNBY)"
  },
  {
   value: "Newcastle Upon Tyne (GBNCL)",
   label: "Newcastle Upon Tyne (GBNCL)"
  },
  {
   value: "Newcastle-Under-Lyme (GBNCE)",
   label: "Newcastle-Under-Lyme (GBNCE)"
  },
  {
   value: "Newhaven (GBNHV)",
   label: "Newhaven (GBNHV)"
  },
  {
   value: "Newhouse (GBNHE)",
   label: "Newhouse (GBNHE)"
  },
  {
   value: "Newington (GBNGO)",
   label: "Newington (GBNGO)"
  },
  {
   value: "Newlyn (GBNYL)",
   label: "Newlyn (GBNYL)"
  },
  {
   value: "Newmarket (GBNKT)",
   label: "Newmarket (GBNKT)"
  },
  {
   value: "Newmilns (GBNML)",
   label: "Newmilns (GBNML)"
  },
  {
   value: "Newport (GBNPT)",
   label: "Newport (GBNPT)"
  },
  {
   value: "Newport (GBNPR)",
   label: "Newport (GBNPR)"
  },
  {
   value: "Newport Pagnell (GBNWP)",
   label: "Newport Pagnell (GBNWP)"
  },
  {
   value: "Newquay (GBNQY)",
   label: "Newquay (GBNQY)"
  },
  {
   value: "Newry (GBNRY)",
   label: "Newry (GBNRY)"
  },
  {
   value: "Newton (GBNWO)",
   label: "Newton (GBNWO)"
  },
  {
   value: "Newton Abbot (GBNBA)",
   label: "Newton Abbot (GBNBA)"
  },
  {
   value: "Newton Aycliffe (GBNAY)",
   label: "Newton Aycliffe (GBNAY)"
  },
  {
   value: "Newton Heath (GBNNT)",
   label: "Newton Heath (GBNNT)"
  },
  {
   value: "Newton Longville (GBNLV)",
   label: "Newton Longville (GBNLV)"
  },
  {
   value: "Newton Stewart (GBNSW)",
   label: "Newton Stewart (GBNSW)"
  },
  {
   value: "Newton-Le-Willows (GBNLW)",
   label: "Newton-Le-Willows (GBNLW)"
  },
  {
   value: "Newtown (GBNWT)",
   label: "Newtown (GBNWT)"
  },
  {
   value: "Newtownabbey (GBNTA)",
   label: "Newtownabbey (GBNTA)"
  },
  {
   value: "Newtownards (GBNTS)",
   label: "Newtownards (GBNTS)"
  },
  {
   value: "Milnrow (GBMLO)",
   label: "Milnrow (GBMLO)"
  },
  {
   value: "Milton (GBMIL)",
   label: "Milton (GBMIL)"
  },
  {
   value: "Milton Keynes (GBMIK)",
   label: "Milton Keynes (GBMIK)"
  },
  {
   value: "Minehead (GBMHD)",
   label: "Minehead (GBMHD)"
  },
  {
   value: "Minworth (GBMIN)",
   label: "Minworth (GBMIN)"
  },
  {
   value: "Mirfield (GBMIR)",
   label: "Mirfield (GBMIR)"
  },
  {
   value: "Mistley (GBMIS)",
   label: "Mistley (GBMIS)"
  },
  {
   value: "Mitcham (GBMTC)",
   label: "Mitcham (GBMTC)"
  },
  {
   value: "Mitcheldean (GBMIT)",
   label: "Mitcheldean (GBMIT)"
  },
  {
   value: "Mobberley (GBMOB)",
   label: "Mobberley (GBMOB)"
  },
  {
   value: "Mochdre (GBMHE)",
   label: "Mochdre (GBMHE)"
  },
  {
   value: "Mold (GBMOL)",
   label: "Mold (GBMOL)"
  },
  {
   value: "Molesworth (GBMLS)",
   label: "Molesworth (GBMLS)"
  },
  {
   value: "Monmouth (GBMMO)",
   label: "Monmouth (GBMMO)"
  },
  {
   value: "Montrose (GBMON)",
   label: "Montrose (GBMON)"
  },
  {
   value: "Morden (GBMOD)",
   label: "Morden (GBMOD)"
  },
  {
   value: "Morecambe (GBMOC)",
   label: "Morecambe (GBMOC)"
  },
  {
   value: "Moresby (GBMOY)",
   label: "Moresby (GBMOY)"
  },
  {
   value: "Moreton (GBMOT)",
   label: "Moreton (GBMOT)"
  },
  {
   value: "Moreton (GBMRT)",
   label: "Moreton (GBMRT)"
  },
  {
   value: "Morley (GBMXK)",
   label: "Morley (GBMXK)"
  },
  {
   value: "Morpeth (GBMOR)",
   label: "Morpeth (GBMOR)"
  },
  {
   value: "Mortlake (GBMTZ)",
   label: "Mortlake (GBMTZ)"
  },
  {
   value: "Mossley (GBOSY)",
   label: "Mossley (GBOSY)"
  },
  {
   value: "Moston (GBMOS)",
   label: "Moston (GBMOS)"
  },
  {
   value: "Mostyn (GBCHE)",
   label: "Mostyn (GBCHE)"
  },
  {
   value: "Motherwell (GBMOW)",
   label: "Motherwell (GBMOW)"
  },
  {
   value: "Moulsoe (GBMOE)",
   label: "Moulsoe (GBMOE)"
  },
  {
   value: "Moulton (GBMOU)",
   label: "Moulton (GBMOU)"
  },
  {
   value: "Muckamore (GBMUK)",
   label: "Muckamore (GBMUK)"
  },
  {
   value: "Muir of Ord (GBMOO)",
   label: "Muir of Ord (GBMOO)"
  },
  {
   value: "Mull Apt (GBMUL)",
   label: "Mull Apt (GBMUL)"
  },
  {
   value: "Musselburgh (GBMUS)",
   label: "Musselburgh (GBMUS)"
  },
  {
   value: "Mytholmroyd (GBMYT)",
   label: "Mytholmroyd (GBMYT)"
  },
  {
   value: "Nailsea (GBNSE)",
   label: "Nailsea (GBNSE)"
  },
  {
   value: "Nairn (GBNAI)",
   label: "Nairn (GBNAI)"
  },
  {
   value: "Nantgawr (GBNGR)",
   label: "Nantgawr (GBNGR)"
  },
  {
   value: "Nantwich (GBNTW)",
   label: "Nantwich (GBNTW)"
  },
  {
   value: "Neap House (GBNEH)",
   label: "Neap House (GBNEH)"
  },
  {
   value: "Neath (GBNET)",
   label: "Neath (GBNET)"
  },
  {
   value: "Neath Abbey (GBNEA)",
   label: "Neath Abbey (GBNEA)"
  },
  {
   value: "Nelson (GBNLN)",
   label: "Nelson (GBNLN)"
  },
  {
   value: "Marylebone (GBMBO)",
   label: "Marylebone (GBMBO)"
  },
  {
   value: "Maryport (GBMRY)",
   label: "Maryport (GBMRY)"
  },
  {
   value: "Maryton (GBMTN)",
   label: "Maryton (GBMTN)"
  },
  {
   value: "Matching Green (GBMTG)",
   label: "Matching Green (GBMTG)"
  },
  {
   value: "Matlock (GBMTL)",
   label: "Matlock (GBMTL)"
  },
  {
   value: "Mawgan (GBMWG)",
   label: "Mawgan (GBMWG)"
  },
  {
   value: "Maybole (GBMYB)",
   label: "Maybole (GBMYB)"
  },
  {
   value: "Mayfield (GBMAY)",
   label: "Mayfield (GBMAY)"
  },
  {
   value: "Medmenham (GBMMH)",
   label: "Medmenham (GBMMH)"
  },
  {
   value: "Melbourn (GBMEL)",
   label: "Melbourn (GBMEL)"
  },
  {
   value: "Meldreth (GBMLD)",
   label: "Meldreth (GBMLD)"
  },
  {
   value: "Melksham (GBMLH)",
   label: "Melksham (GBMLH)"
  },
  {
   value: "Mellor (GBMLJ)",
   label: "Mellor (GBMLJ)"
  },
  {
   value: "Melrose (GBMLR)",
   label: "Melrose (GBMLR)"
  },
  {
   value: "Meltham (GBMLA)",
   label: "Meltham (GBMLA)"
  },
  {
   value: "Melton Mowbray (GBMBY)",
   label: "Melton Mowbray (GBMBY)"
  },
  {
   value: "Menai Bridge (GBMEB)",
   label: "Menai Bridge (GBMEB)"
  },
  {
   value: "Mendlesham (GBMEN)",
   label: "Mendlesham (GBMEN)"
  },
  {
   value: "Menstrie (GBMSR)",
   label: "Menstrie (GBMSR)"
  },
  {
   value: "Mere (GBMRE)",
   label: "Mere (GBMRE)"
  },
  {
   value: "Merthyr Tydfil (GBMET)",
   label: "Merthyr Tydfil (GBMET)"
  },
  {
   value: "Merton (GBMEO)",
   label: "Merton (GBMEO)"
  },
  {
   value: "Methil (GBMTH)",
   label: "Methil (GBMTH)"
  },
  {
   value: "Methlick (GBMTK)",
   label: "Methlick (GBMTK)"
  },
  {
   value: "Methwold (GBMWD)",
   label: "Methwold (GBMWD)"
  },
  {
   value: "Mexborough (GBMXB)",
   label: "Mexborough (GBMXB)"
  },
  {
   value: "Micheldever Station (GBMDS)",
   label: "Micheldever Station (GBMDS)"
  },
  {
   value: "Middlefield Law (GBMDD)",
   label: "Middlefield Law (GBMDD)"
  },
  {
   value: "Middlesborough (GBMID)",
   label: "Middlesborough (GBMID)"
  },
  {
   value: "Middleton (GBMDN)",
   label: "Middleton (GBMDN)"
  },
  {
   value: "Middlewich (GBMDW)",
   label: "Middlewich (GBMDW)"
  },
  {
   value: "Midsomer Norton (GBMSM)",
   label: "Midsomer Norton (GBMSM)"
  },
  {
   value: "Milden (GBMDO)",
   label: "Milden (GBMDO)"
  },
  {
   value: "Mildenhall (GBMLL)",
   label: "Mildenhall (GBMLL)"
  },
  {
   value: "Milford Haven (GBMLF)",
   label: "Milford Haven (GBMLF)"
  },
  {
   value: "Mill Hill (GBMHL)",
   label: "Mill Hill (GBMHL)"
  },
  {
   value: "Millbrook (GBMLB)",
   label: "Millbrook (GBMLB)"
  },
  {
   value: "Millom (GBMLM)",
   label: "Millom (GBMLM)"
  },
  {
   value: "Milnathort (GBMLT)",
   label: "Milnathort (GBMLT)"
  },
  {
   value: "Milngavie (GBMLV)",
   label: "Milngavie (GBMLV)"
  },
  {
   value: "Lynmouth (GBLNM)",
   label: "Lynmouth (GBLNM)"
  },
  {
   value: "Lytham St Annes (GBLYA)",
   label: "Lytham St Annes (GBLYA)"
  },
  {
   value: "Macclesfield (GBMCL)",
   label: "Macclesfield (GBMCL)"
  },
  {
   value: "Macduff (GBMCD)",
   label: "Macduff (GBMCD)"
  },
  {
   value: "Machen (GBMCN)",
   label: "Machen (GBMCN)"
  },
  {
   value: "Machrihanish (GBMAC)",
   label: "Machrihanish (GBMAC)"
  },
  {
   value: "Maesteg (GBMEE)",
   label: "Maesteg (GBMEE)"
  },
  {
   value: "Maghera (GBMGH)",
   label: "Maghera (GBMGH)"
  },
  {
   value: "Magherafelt (GBMFT)",
   label: "Magherafelt (GBMFT)"
  },
  {
   value: "Magheramorne (GBMGO)",
   label: "Magheramorne (GBMGO)"
  },
  {
   value: "Maghull (GBMGL)",
   label: "Maghull (GBMGL)"
  },
  {
   value: "Maidenhead (GBMAH)",
   label: "Maidenhead (GBMAH)"
  },
  {
   value: "Maidstone (GBMDT)",
   label: "Maidstone (GBMDT)"
  },
  {
   value: "Maldon (GBMAL)",
   label: "Maldon (GBMAL)"
  },
  {
   value: "Mallaig (GBMLG)",
   label: "Mallaig (GBMLG)"
  },
  {
   value: "Mallusk (GBMLK)",
   label: "Mallusk (GBMLK)"
  },
  {
   value: "Malmesbury (GBMMB)",
   label: "Malmesbury (GBMMB)"
  },
  {
   value: "Maltby (GBMLY)",
   label: "Maltby (GBMLY)"
  },
  {
   value: "Malton (GBMLN)",
   label: "Malton (GBMLN)"
  },
  {
   value: "Manchester (GBMNC)",
   label: "Manchester (GBMNC)"
  },
  {
   value: "Manningtree (GBMNN)",
   label: "Manningtree (GBMNN)"
  },
  {
   value: "Mansfield (GBMFD)",
   label: "Mansfield (GBMFD)"
  },
  {
   value: "Manston (GBMSE)",
   label: "Manston (GBMSE)"
  },
  {
   value: "March (GBMAR)",
   label: "March (GBMAR)"
  },
  {
   value: "Marchington (GBMRC)",
   label: "Marchington (GBMRC)"
  },
  {
   value: "Marden (GBMRD)",
   label: "Marden (GBMRD)"
  },
  {
   value: "Marfleet (GBMRF)",
   label: "Marfleet (GBMRF)"
  },
  {
   value: "Margam (GBMGM)",
   label: "Margam (GBMGM)"
  },
  {
   value: "Margate (GBMGT)",
   label: "Margate (GBMGT)"
  },
  {
   value: "Market Deeping (GBMDP)",
   label: "Market Deeping (GBMDP)"
  },
  {
   value: "Market Drayton (GBMKD)",
   label: "Market Drayton (GBMKD)"
  },
  {
   value: "Market Harborough (GBMKH)",
   label: "Market Harborough (GBMKH)"
  },
  {
   value: "Market Rasen (GBMKR)",
   label: "Market Rasen (GBMKR)"
  },
  {
   value: "Markinch (GBMRK)",
   label: "Markinch (GBMRK)"
  },
  {
   value: "Marlborough (GBMRL)",
   label: "Marlborough (GBMRL)"
  },
  {
   value: "Marlow (GBMLW)",
   label: "Marlow (GBMLW)"
  },
  {
   value: "Marple (GBMZL)",
   label: "Marple (GBMZL)"
  },
  {
   value: "Marston (GBMRN)",
   label: "Marston (GBMRN)"
  },
  {
   value: "Marston Trussell (GBMTT)",
   label: "Marston Trussell (GBMTT)"
  },
  {
   value: "Martlesham (GBMHM)",
   label: "Martlesham (GBMHM)"
  },
  {
   value: "Martock (GBZOR)",
   label: "Martock (GBZOR)"
  },
  {
   value: "London Colney (GBLCL)",
   label: "London Colney (GBLCL)"
  },
  {
   value: "Londonderry (GBLDY)",
   label: "Londonderry (GBLDY)"
  },
  {
   value: "Long Buckby (GBLBU)",
   label: "Long Buckby (GBLBU)"
  },
  {
   value: "Long Crendon (GBLOC)",
   label: "Long Crendon (GBLOC)"
  },
  {
   value: "Long Eaton (GBLEA)",
   label: "Long Eaton (GBLEA)"
  },
  {
   value: "Long Hanborough (GBLGB)",
   label: "Long Hanborough (GBLGB)"
  },
  {
   value: "Long Itchington (GBLOI)",
   label: "Long Itchington (GBLOI)"
  },
  {
   value: "Long Melford (GBLMD)",
   label: "Long Melford (GBLMD)"
  },
  {
   value: "Long Sutton (GBLSN)",
   label: "Long Sutton (GBLSN)"
  },
  {
   value: "Longbenton (GBLBN)",
   label: "Longbenton (GBLBN)"
  },
  {
   value: "Longhope (GBLHP)",
   label: "Longhope (GBLHP)"
  },
  {
   value: "Longridge (GBLRE)",
   label: "Longridge (GBLRE)"
  },
  {
   value: "Longton (GBLGT)",
   label: "Longton (GBLGT)"
  },
  {
   value: "Lossiemouth (GBLSS)",
   label: "Lossiemouth (GBLSS)"
  },
  {
   value: "Lostock Gralam (GBLOG)",
   label: "Lostock Gralam (GBLOG)"
  },
  {
   value: "Loughborough (GBLOU)",
   label: "Loughborough (GBLOU)"
  },
  {
   value: "Loughton (GBLHN)",
   label: "Loughton (GBLHN)"
  },
  {
   value: "Loughton (GBLGN)",
   label: "Loughton (GBLGN)"
  },
  {
   value: "Louth (GBLOT)",
   label: "Louth (GBLOT)"
  },
  {
   value: "Low Moor (GBLWM)",
   label: "Low Moor (GBLWM)"
  },
  {
   value: "Lower Kinnerton (GBLKT)",
   label: "Lower Kinnerton (GBLKT)"
  },
  {
   value: "Lower Stondon (GBLXW)",
   label: "Lower Stondon (GBLXW)"
  },
  {
   value: "Lowestoft (GBLOW)",
   label: "Lowestoft (GBLOW)"
  },
  {
   value: "Lowton (GBLWN)",
   label: "Lowton (GBLWN)"
  },
  {
   value: "Luddenden (GBLDE)",
   label: "Luddenden (GBLDE)"
  },
  {
   value: "Ludlow (GBLDL)",
   label: "Ludlow (GBLDL)"
  },
  {
   value: "Lurgan (GBURL)",
   label: "Lurgan (GBURL)"
  },
  {
   value: "Luton (GBLUT)",
   label: "Luton (GBLUT)"
  },
  {
   value: "Lutterworth (GBLTT)",
   label: "Lutterworth (GBLTT)"
  },
  {
   value: "Lydd (GBLYX)",
   label: "Lydd (GBLYX)"
  },
  {
   value: "Lydiate (GBLDT)",
   label: "Lydiate (GBLDT)"
  },
  {
   value: "Lydney (GBLYD)",
   label: "Lydney (GBLYD)"
  },
  {
   value: "Lye (GBLIE)",
   label: "Lye (GBLIE)"
  },
  {
   value: "Lymington (GBLYM)",
   label: "Lymington (GBLYM)"
  },
  {
   value: "Lyminster (GBLMR)",
   label: "Lyminster (GBLMR)"
  },
  {
   value: "Lymm (GBLMM)",
   label: "Lymm (GBLMM)"
  },
  {
   value: "Lympne (GBLYN)",
   label: "Lympne (GBLYN)"
  },
  {
   value: "Lyndhurst (GBLYH)",
   label: "Lyndhurst (GBLYH)"
  },
  {
   value: "Lyne (GBLNE)",
   label: "Lyne (GBLNE)"
  },
  {
   value: "Lyneham (GBLYE)",
   label: "Lyneham (GBLYE)"
  },
  {
   value: "Lyness (GBLYS)",
   label: "Lyness (GBLYS)"
  },
  {
   value: "Litchfield (GBLTC)",
   label: "Litchfield (GBLTC)"
  },
  {
   value: "Little Addington (GBLAD)",
   label: "Little Addington (GBLAD)"
  },
  {
   value: "Little Carlton (GBLLC)",
   label: "Little Carlton (GBLLC)"
  },
  {
   value: "Little Hadham (GBLLH)",
   label: "Little Hadham (GBLLH)"
  },
  {
   value: "Little Heath (GBLHH)",
   label: "Little Heath (GBLHH)"
  },
  {
   value: "Little Horsted (GBLLR)",
   label: "Little Horsted (GBLLR)"
  },
  {
   value: "Little Milton (GBLLM)",
   label: "Little Milton (GBLLM)"
  },
  {
   value: "Little Rissington (GBLIR)",
   label: "Little Rissington (GBLIR)"
  },
  {
   value: "Littleborough (GBLLB)",
   label: "Littleborough (GBLLB)"
  },
  {
   value: "Littlebrook (GBLTL)",
   label: "Littlebrook (GBLTL)"
  },
  {
   value: "Littlehampton (GBLIT)",
   label: "Littlehampton (GBLIT)"
  },
  {
   value: "Litton (GBLTO)",
   label: "Litton (GBLTO)"
  },
  {
   value: "Liverpool (GBLIV)",
   label: "Liverpool (GBLIV)"
  },
  {
   value: "Liversedge (GBLVS)",
   label: "Liversedge (GBLVS)"
  },
  {
   value: "Livingston (GBTON)",
   label: "Livingston (GBTON)"
  },
  {
   value: "Lizard (GBLZD)",
   label: "Lizard (GBLZD)"
  },
  {
   value: "Llanarmon (GBLAM)",
   label: "Llanarmon (GBLAM)"
  },
  {
   value: "Llanarmon yn Lal (GBLMY)",
   label: "Llanarmon yn Lal (GBLMY)"
  },
  {
   value: "Llanddulas (GBLLD)",
   label: "Llanddulas (GBLLD)"
  },
  {
   value: "Llandeilo (GBLLA)",
   label: "Llandeilo (GBLLA)"
  },
  {
   value: "Llandrindod Wells (GBLDW)",
   label: "Llandrindod Wells (GBLDW)"
  },
  {
   value: "Llandudno (GBLDO)",
   label: "Llandudno (GBLDO)"
  },
  {
   value: "Llanelli (GBLLN)",
   label: "Llanelli (GBLLN)"
  },
  {
   value: "Llanfairpwllgwyngyll (GBLFP)",
   label: "Llanfairpwllgwyngyll (GBLFP)"
  },
  {
   value: "Llanfyllin (GBLFY)",
   label: "Llanfyllin (GBLFY)"
  },
  {
   value: "Llantrisant (GBLLT)",
   label: "Llantrisant (GBLLT)"
  },
  {
   value: "Llantwit Major (GBLTM)",
   label: "Llantwit Major (GBLTM)"
  },
  {
   value: "Llay (GBLLY)",
   label: "Llay (GBLLY)"
  },
  {
   value: "Loadhead (GBLOA)",
   label: "Loadhead (GBLOA)"
  },
  {
   value: "Loanhead (GBLNH)",
   label: "Loanhead (GBLNH)"
  },
  {
   value: "Loch Ewe (GBLHE)",
   label: "Loch Ewe (GBLHE)"
  },
  {
   value: "Loch Gelly (GBLGY)",
   label: "Loch Gelly (GBLGY)"
  },
  {
   value: "Loch Striven (GBLHS)",
   label: "Loch Striven (GBLHS)"
  },
  {
   value: "Lochaline (GBLOL)",
   label: "Lochaline (GBLOL)"
  },
  {
   value: "Lochgilphead (GBLOH)",
   label: "Lochgilphead (GBLOH)"
  },
  {
   value: "Lochmaddy (GBLMA)",
   label: "Lochmaddy (GBLMA)"
  },
  {
   value: "Lochwinnoch (GBLCH)",
   label: "Lochwinnoch (GBLCH)"
  },
  {
   value: "Locks Heath (GBLKH)",
   label: "Locks Heath (GBLKH)"
  },
  {
   value: "London (GBLON)",
   label: "London (GBLON)"
  },
  {
   value: "Ledbury (GBLED)",
   label: "Ledbury (GBLED)"
  },
  {
   value: "Lee-on-the-Solent (GBLES)",
   label: "Lee-on-the-Solent (GBLES)"
  },
  {
   value: "Leeds (GBLBA)",
   label: "Leeds (GBLBA)"
  },
  {
   value: "Leek (GBLEK)",
   label: "Leek (GBLEK)"
  },
  {
   value: "Leicester (GBLCS)",
   label: "Leicester (GBLCS)"
  },
  {
   value: "Leigh (GBLGH)",
   label: "Leigh (GBLGH)"
  },
  {
   value: "Leigh (GBLEG)",
   label: "Leigh (GBLEG)"
  },
  {
   value: "Leigh (GBLIH)",
   label: "Leigh (GBLIH)"
  },
  {
   value: "Leigh-On-Sea (GBLOS)",
   label: "Leigh-On-Sea (GBLOS)"
  },
  {
   value: "Leighton Buzzard (GBLBZ)",
   label: "Leighton Buzzard (GBLBZ)"
  },
  {
   value: "Leiston (GBLEN)",
   label: "Leiston (GBLEN)"
  },
  {
   value: "Leith (GBLEI)",
   label: "Leith (GBLEI)"
  },
  {
   value: "Lenham (GBLEM)",
   label: "Lenham (GBLEM)"
  },
  {
   value: "Lenzie (GBLNZ)",
   label: "Lenzie (GBLNZ)"
  },
  {
   value: "Leominster (GBLEO)",
   label: "Leominster (GBLEO)"
  },
  {
   value: "Lerwick (GBLER)",
   label: "Lerwick (GBLER)"
  },
  {
   value: "Leslie (GBLSL)",
   label: "Leslie (GBLSL)"
  },
  {
   value: "Letchworth (GBLTH)",
   label: "Letchworth (GBLTH)"
  },
  {
   value: "Letham (GBLGU)",
   label: "Letham (GBLGU)"
  },
  {
   value: "Letterston (GBLET)",
   label: "Letterston (GBLET)"
  },
  {
   value: "Leven (GBLEV)",
   label: "Leven (GBLEV)"
  },
  {
   value: "Levenshulme (GBLVN)",
   label: "Levenshulme (GBLVN)"
  },
  {
   value: "Lewes (GBLWE)",
   label: "Lewes (GBLWE)"
  },
  {
   value: "Lewisham (GBLWS)",
   label: "Lewisham (GBLWS)"
  },
  {
   value: "Leyland (GBLYL)",
   label: "Leyland (GBLYL)"
  },
  {
   value: "Leyton (GBLYO)",
   label: "Leyton (GBLYO)"
  },
  {
   value: "Lichfield (GBLHF)",
   label: "Lichfield (GBLHF)"
  },
  {
   value: "Liddington (GBLDD)",
   label: "Liddington (GBLDD)"
  },
  {
   value: "Lighthorne (GBLIG)",
   label: "Lighthorne (GBLIG)"
  },
  {
   value: "Lightwater (GBLGE)",
   label: "Lightwater (GBLGE)"
  },
  {
   value: "Limavady (GBLIM)",
   label: "Limavady (GBLIM)"
  },
  {
   value: "Limpsfield (GBLFD)",
   label: "Limpsfield (GBLFD)"
  },
  {
   value: "Lincoln (GBLCN)",
   label: "Lincoln (GBLCN)"
  },
  {
   value: "Lingfield (GBLNF)",
   label: "Lingfield (GBLNF)"
  },
  {
   value: "Lingley Mill (GBLGL)",
   label: "Lingley Mill (GBLGL)"
  },
  {
   value: "Linlithgow (GBLLW)",
   label: "Linlithgow (GBLLW)"
  },
  {
   value: "Linton (GBLTN)",
   label: "Linton (GBLTN)"
  },
  {
   value: "Linwood (GBLNW)",
   label: "Linwood (GBLNW)"
  },
  {
   value: "Liphook (GBLPH)",
   label: "Liphook (GBLPH)"
  },
  {
   value: "Lisburn (GBLIS)",
   label: "Lisburn (GBLIS)"
  },
  {
   value: "Liss (GBISS)",
   label: "Liss (GBISS)"
  },
  {
   value: "Kirkcudbright (GBKBT)",
   label: "Kirkcudbright (GBKBT)"
  },
  {
   value: "Kirkham (GBKIH)",
   label: "Kirkham (GBKIH)"
  },
  {
   value: "Kirkintilloch (GBKKT)",
   label: "Kirkintilloch (GBKKT)"
  },
  {
   value: "Kirkliston (GBKKI)",
   label: "Kirkliston (GBKKI)"
  },
  {
   value: "Kirkwall (GBKWL)",
   label: "Kirkwall (GBKWL)"
  },
  {
   value: "Kirriemuir (GBKRR)",
   label: "Kirriemuir (GBKRR)"
  },
  {
   value: "Kitt Green (GBKTG)",
   label: "Kitt Green (GBKTG)"
  },
  {
   value: "Knapton (GBKPT)",
   label: "Knapton (GBKPT)"
  },
  {
   value: "Knaresborough (GBKNA)",
   label: "Knaresborough (GBKNA)"
  },
  {
   value: "Knottingley (GBKNO)",
   label: "Knottingley (GBKNO)"
  },
  {
   value: "Knowsley (GBKNW)",
   label: "Knowsley (GBKNW)"
  },
  {
   value: "Knutsford (GBKSF)",
   label: "Knutsford (GBKSF)"
  },
  {
   value: "Kyle Of Lochalsh (GBKYL)",
   label: "Kyle Of Lochalsh (GBKYL)"
  },
  {
   value: "Laindon (GBLAI)",
   label: "Laindon (GBLAI)"
  },
  {
   value: "Lakenheath (GBLAK)",
   label: "Lakenheath (GBLAK)"
  },
  {
   value: "Laleham (GBLHM)",
   label: "Laleham (GBLHM)"
  },
  {
   value: "Lamberhurst (GBLMB)",
   label: "Lamberhurst (GBLMB)"
  },
  {
   value: "Lambourn (GBLBR)",
   label: "Lambourn (GBLBR)"
  },
  {
   value: "Lamlash (GBLAH)",
   label: "Lamlash (GBLAH)"
  },
  {
   value: "Lampeter (GBLMP)",
   label: "Lampeter (GBLMP)"
  },
  {
   value: "Lanark (GBLNK)",
   label: "Lanark (GBLNK)"
  },
  {
   value: "Lancaster (GBLAN)",
   label: "Lancaster (GBLAN)"
  },
  {
   value: "Lancing (GBLAG)",
   label: "Lancing (GBLAG)"
  },
  {
   value: "Lands End (GBLEQ)",
   label: "Lands End (GBLEQ)"
  },
  {
   value: "Langdon Hills (GBLDH)",
   label: "Langdon Hills (GBLDH)"
  },
  {
   value: "Langley (GBLAL)",
   label: "Langley (GBLAL)"
  },
  {
   value: "Langport (GBLAT)",
   label: "Langport (GBLAT)"
  },
  {
   value: "Langtoft (GBLTF)",
   label: "Langtoft (GBLTF)"
  },
  {
   value: "Langton Green (GBLGG)",
   label: "Langton Green (GBLGG)"
  },
  {
   value: "Lapford (GBLPF)",
   label: "Lapford (GBLPF)"
  },
  {
   value: "Largs (GBLGS)",
   label: "Largs (GBLGS)"
  },
  {
   value: "Larkfield (GBLRK)",
   label: "Larkfield (GBLRK)"
  },
  {
   value: "Larne (GBLAR)",
   label: "Larne (GBLAR)"
  },
  {
   value: "Launceston (GBLAU)",
   label: "Launceston (GBLAU)"
  },
  {
   value: "Laxo (GBLAX)",
   label: "Laxo (GBLAX)"
  },
  {
   value: "Leamington Spa (GBLSP)",
   label: "Leamington Spa (GBLSP)"
  },
  {
   value: "Leatherhead (GBLEH)",
   label: "Leatherhead (GBLEH)"
  },
  {
   value: "Lechlade (GBLEC)",
   label: "Lechlade (GBLEC)"
  },
  {
   value: "Leckhampstead (GBLCK)",
   label: "Leckhampstead (GBLCK)"
  },
  {
   value: "Leckwith (GBLCW)",
   label: "Leckwith (GBLCW)"
  },
  {
   value: "Keynsham (GBKYS)",
   label: "Keynsham (GBKYS)"
  },
  {
   value: "Kidderminster (GBKDM)",
   label: "Kidderminster (GBKDM)"
  },
  {
   value: "Kilbarchan (GBKLB)",
   label: "Kilbarchan (GBKLB)"
  },
  {
   value: "Kilburn (GBKBN)",
   label: "Kilburn (GBKBN)"
  },
  {
   value: "Kilchoan (GBKOA)",
   label: "Kilchoan (GBKOA)"
  },
  {
   value: "Kilkeel (GBKLK)",
   label: "Kilkeel (GBKLK)"
  },
  {
   value: "Killingholme (GBKGH)",
   label: "Killingholme (GBKGH)"
  },
  {
   value: "Kilmarnock (GBKMK)",
   label: "Kilmarnock (GBKMK)"
  },
  {
   value: "Kilroot (GBKLR)",
   label: "Kilroot (GBKLR)"
  },
  {
   value: "Kilsyth (GBKLT)",
   label: "Kilsyth (GBKLT)"
  },
  {
   value: "Kilwinning (GBKWG)",
   label: "Kilwinning (GBKWG)"
  },
  {
   value: "Kineton (GBKNE)",
   label: "Kineton (GBKNE)"
  },
  {
   value: "King's Cliffe (GBKGC)",
   label: "King's Cliffe (GBKGC)"
  },
  {
   value: "King's Lynn (GBKLN)",
   label: "King's Lynn (GBKLN)"
  },
  {
   value: "Kings Heath (GBKNH)",
   label: "Kings Heath (GBKNH)"
  },
  {
   value: "Kings Langley (GBKGL)",
   label: "Kings Langley (GBKGL)"
  },
  {
   value: "Kings Lynn (GBKNF)",
   label: "Kings Lynn (GBKNF)"
  },
  {
   value: "Kingsdown (GBKDN)",
   label: "Kingsdown (GBKDN)"
  },
  {
   value: "Kingsley (GBKGS)",
   label: "Kingsley (GBKGS)"
  },
  {
   value: "Kingsnorth (GBKNK)",
   label: "Kingsnorth (GBKNK)"
  },
  {
   value: "Kingsteignton (GBKNG)",
   label: "Kingsteignton (GBKNG)"
  },
  {
   value: "Kingston (GBKNS)",
   label: "Kingston (GBKNS)"
  },
  {
   value: "Kingston Bagpuize (GBKBP)",
   label: "Kingston Bagpuize (GBKBP)"
  },
  {
   value: "Kingston Upon Hull (GBKUH)",
   label: "Kingston Upon Hull (GBKUH)"
  },
  {
   value: "Kingston upon Thames (GBKUT)",
   label: "Kingston upon Thames (GBKUT)"
  },
  {
   value: "Kingswinford (GBKGW)",
   label: "Kingswinford (GBKGW)"
  },
  {
   value: "Kingswood (GBKSW)",
   label: "Kingswood (GBKSW)"
  },
  {
   value: "Kingswood (GBKIN)",
   label: "Kingswood (GBKIN)"
  },
  {
   value: "Kington (GBKTN)",
   label: "Kington (GBKTN)"
  },
  {
   value: "Kinloss (GBKNL)",
   label: "Kinloss (GBKNL)"
  },
  {
   value: "Kinnerley (GBKNY)",
   label: "Kinnerley (GBKNY)"
  },
  {
   value: "Kinross (GBKNR)",
   label: "Kinross (GBKNR)"
  },
  {
   value: "Kirk Hammerton (GBKHM)",
   label: "Kirk Hammerton (GBKHM)"
  },
  {
   value: "Kirk Sandall (GBKKS)",
   label: "Kirk Sandall (GBKKS)"
  },
  {
   value: "Kirkby (GBKKB)",
   label: "Kirkby (GBKKB)"
  },
  {
   value: "Kirkby in Ashfield (GBKBA)",
   label: "Kirkby in Ashfield (GBKBA)"
  },
  {
   value: "Kirkby Lonsdale (GBKKL)",
   label: "Kirkby Lonsdale (GBKKL)"
  },
  {
   value: "Kirkby Stephen (GBKRK)",
   label: "Kirkby Stephen (GBKRK)"
  },
  {
   value: "Kirkcaldy (GBKKD)",
   label: "Kirkcaldy (GBKKD)"
  },
  {
   value: "Inverurie (GBIVI)",
   label: "Inverurie (GBIVI)"
  },
  {
   value: "Ipswich (GBIPS)",
   label: "Ipswich (GBIPS)"
  },
  {
   value: "Irlam (GBIRL)",
   label: "Irlam (GBIRL)"
  },
  {
   value: "Irthlingborough (GBIIB)",
   label: "Irthlingborough (GBIIB)"
  },
  {
   value: "Irvine (GBIRV)",
   label: "Irvine (GBIRV)"
  },
  {
   value: "Islay (GBIYP)",
   label: "Islay (GBIYP)"
  },
  {
   value: "Islay Apt (GBILY)",
   label: "Islay Apt (GBILY)"
  },
  {
   value: "Isle Of Grain (GBIOG)",
   label: "Isle Of Grain (GBIOG)"
  },
  {
   value: "Isle Of Man (GBIOM)",
   label: "Isle Of Man (GBIOM)"
  },
  {
   value: "Isle of Portland (GBIOP)",
   label: "Isle of Portland (GBIOP)"
  },
  {
   value: "Isle Of Skye Apt (GBSKY)",
   label: "Isle Of Skye Apt (GBSKY)"
  },
  {
   value: "Isles Of Scilly (GBISC)",
   label: "Isles Of Scilly (GBISC)"
  },
  {
   value: "Isleworth (GBISW)",
   label: "Isleworth (GBISW)"
  },
  {
   value: "Islington (GBIST)",
   label: "Islington (GBIST)"
  },
  {
   value: "Islip (GBILP)",
   label: "Islip (GBILP)"
  },
  {
   value: "Itchenor (GBITC)",
   label: "Itchenor (GBITC)"
  },
  {
   value: "Iver (GBIVE)",
   label: "Iver (GBIVE)"
  },
  {
   value: "Iver Heath (GBIVH)",
   label: "Iver Heath (GBIVH)"
  },
  {
   value: "Ivybridge (GBIVY)",
   label: "Ivybridge (GBIVY)"
  },
  {
   value: "Jarrow (GBJAR)",
   label: "Jarrow (GBJAR)"
  },
  {
   value: "Jarrow on Tyne (GBJOT)",
   label: "Jarrow on Tyne (GBJOT)"
  },
  {
   value: "Jedburgh (GBJBG)",
   label: "Jedburgh (GBJBG)"
  },
  {
   value: "Jersey (GBJER)",
   label: "Jersey (GBJER)"
  },
  {
   value: "Johnstone (GBJHT)",
   label: "Johnstone (GBJHT)"
  },
  {
   value: "Keadby (GBKEA)",
   label: "Keadby (GBKEA)"
  },
  {
   value: "Kegworth (GBKEG)",
   label: "Kegworth (GBKEG)"
  },
  {
   value: "Keighley (GBKEI)",
   label: "Keighley (GBKEI)"
  },
  {
   value: "Keith (GBKTH)",
   label: "Keith (GBKTH)"
  },
  {
   value: "Kells (GBKEL)",
   label: "Kells (GBKEL)"
  },
  {
   value: "Kemble (GBKEM)",
   label: "Kemble (GBKEM)"
  },
  {
   value: "Kempsford (GBKMP)",
   label: "Kempsford (GBKMP)"
  },
  {
   value: "Kempston Hardwick (GBKEH)",
   label: "Kempston Hardwick (GBKEH)"
  },
  {
   value: "Kendal (GBKND)",
   label: "Kendal (GBKND)"
  },
  {
   value: "Kenilworth (GBKLW)",
   label: "Kenilworth (GBKLW)"
  },
  {
   value: "Kennacraig (GBKCG)",
   label: "Kennacraig (GBKCG)"
  },
  {
   value: "Kentmere (GBKRE)",
   label: "Kentmere (GBKRE)"
  },
  {
   value: "Kenton (GBKNT)",
   label: "Kenton (GBKNT)"
  },
  {
   value: "Keswick (GBKWC)",
   label: "Keswick (GBKWC)"
  },
  {
   value: "Kettering (GBKTR)",
   label: "Kettering (GBKTR)"
  },
  {
   value: "Kettlethorpe (GBKTE)",
   label: "Kettlethorpe (GBKTE)"
  },
  {
   value: "Kew (GBKEW)",
   label: "Kew (GBKEW)"
  },
  {
   value: "Hounslow (GBHOU)",
   label: "Hounslow (GBHOU)"
  },
  {
   value: "Hove (GBHEV)",
   label: "Hove (GBHEV)"
  },
  {
   value: "How (GBHWD)",
   label: "How (GBHWD)"
  },
  {
   value: "Howdendyke (GBHDD)",
   label: "Howdendyke (GBHDD)"
  },
  {
   value: "Hoy (GBHYO)",
   label: "Hoy (GBHYO)"
  },
  {
   value: "Hoylake (GBHYL)",
   label: "Hoylake (GBHYL)"
  },
  {
   value: "Hucclecote (GBHCE)",
   label: "Hucclecote (GBHCE)"
  },
  {
   value: "Hucknall (GBHKL)",
   label: "Hucknall (GBHKL)"
  },
  {
   value: "Huddersfield (GBHDF)",
   label: "Huddersfield (GBHDF)"
  },
  {
   value: "Hull (GBHUL)",
   label: "Hull (GBHUL)"
  },
  {
   value: "Hullavington (GBHVN)",
   label: "Hullavington (GBHVN)"
  },
  {
   value: "Humber (GBHMR)",
   label: "Humber (GBHMR)"
  },
  {
   value: "Humberside Apt (GBHUY)",
   label: "Humberside Apt (GBHUY)"
  },
  {
   value: "Humbie (GBHRE)",
   label: "Humbie (GBHRE)"
  },
  {
   value: "Hungerford (GBHUF)",
   label: "Hungerford (GBHUF)"
  },
  {
   value: "Hunstanton (GBHNT)",
   label: "Hunstanton (GBHNT)"
  },
  {
   value: "Hunterston (GBHST)",
   label: "Hunterston (GBHST)"
  },
  {
   value: "Huntingdon (GBHUD)",
   label: "Huntingdon (GBHUD)"
  },
  {
   value: "Huntly (GBHTL)",
   label: "Huntly (GBHTL)"
  },
  {
   value: "Hunton (GBHUO)",
   label: "Hunton (GBHUO)"
  },
  {
   value: "Hurlford (GBHLF)",
   label: "Hurlford (GBHLF)"
  },
  {
   value: "Hursley (GBHUS)",
   label: "Hursley (GBHUS)"
  },
  {
   value: "Hurst (GBHUR)",
   label: "Hurst (GBHUR)"
  },
  {
   value: "Hurst Green (GBHGN)",
   label: "Hurst Green (GBHGN)"
  },
  {
   value: "Hurstpierpoint (GBHER)",
   label: "Hurstpierpoint (GBHER)"
  },
  {
   value: "Huyton (GBHYN)",
   label: "Huyton (GBHYN)"
  },
  {
   value: "Hyde (GBHYD)",
   label: "Hyde (GBHYD)"
  },
  {
   value: "Hythe (GBHTH)",
   label: "Hythe (GBHTH)"
  },
  {
   value: "Ilford (GBIFD)",
   label: "Ilford (GBIFD)"
  },
  {
   value: "Ilfracombe (GBILF)",
   label: "Ilfracombe (GBILF)"
  },
  {
   value: "Ilkeston (GBIKS)",
   label: "Ilkeston (GBIKS)"
  },
  {
   value: "Ilkley (GBILK)",
   label: "Ilkley (GBILK)"
  },
  {
   value: "Ilminster (GBIMR)",
   label: "Ilminster (GBIMR)"
  },
  {
   value: "Immingham (GBIMM)",
   label: "Immingham (GBIMM)"
  },
  {
   value: "Impington (GBIMP)",
   label: "Impington (GBIMP)"
  },
  {
   value: "Ince (GBINC)",
   label: "Ince (GBINC)"
  },
  {
   value: "Inchinnan (GBINH)",
   label: "Inchinnan (GBINH)"
  },
  {
   value: "Ingham (GBING)",
   label: "Ingham (GBING)"
  },
  {
   value: "Inkberrow (GBICD)",
   label: "Inkberrow (GBICD)"
  },
  {
   value: "Invergordon (GBIVG)",
   label: "Invergordon (GBIVG)"
  },
  {
   value: "Inverkeithing (GBINK)",
   label: "Inverkeithing (GBINK)"
  },
  {
   value: "Inverness (GBINV)",
   label: "Inverness (GBINV)"
  },
  {
   value: "Histon (GBHIS)",
   label: "Histon (GBHIS)"
  },
  {
   value: "Hitchin (GBHCN)",
   label: "Hitchin (GBHCN)"
  },
  {
   value: "Hixon (GBHXN)",
   label: "Hixon (GBHXN)"
  },
  {
   value: "Hockley (GBHCY)",
   label: "Hockley (GBHCY)"
  },
  {
   value: "Hoddesdon (GBHON)",
   label: "Hoddesdon (GBHON)"
  },
  {
   value: "Holbeach (GBHOL)",
   label: "Holbeach (GBHOL)"
  },
  {
   value: "Holehaven (GBHHN)",
   label: "Holehaven (GBHHN)"
  },
  {
   value: "Hollingworth (GBHLI)",
   label: "Hollingworth (GBHLI)"
  },
  {
   value: "Holme Chapel (GBHCH)",
   label: "Holme Chapel (GBHCH)"
  },
  {
   value: "Holmes Chapel (GBHLC)",
   label: "Holmes Chapel (GBHLC)"
  },
  {
   value: "Holmfirth (GBHLR)",
   label: "Holmfirth (GBHLR)"
  },
  {
   value: "Holsworthy (GBHWO)",
   label: "Holsworthy (GBHWO)"
  },
  {
   value: "Holt (GBHOW)",
   label: "Holt (GBHOW)"
  },
  {
   value: "Holy Loch (GBHLO)",
   label: "Holy Loch (GBHLO)"
  },
  {
   value: "Holyhead (GBHLY)",
   label: "Holyhead (GBHLY)"
  },
  {
   value: "Holyport (GBHYP)",
   label: "Holyport (GBHYP)"
  },
  {
   value: "Holywell (GBHWL)",
   label: "Holywell (GBHWL)"
  },
  {
   value: "Holywood (GBOLY)",
   label: "Holywood (GBOLY)"
  },
  {
   value: "Honiton (GBHIN)",
   label: "Honiton (GBHIN)"
  },
  {
   value: "Hoo (GBHOO)",
   label: "Hoo (GBHOO)"
  },
  {
   value: "Hooe (GBHOE)",
   label: "Hooe (GBHOE)"
  },
  {
   value: "Hook (GBHOK)",
   label: "Hook (GBHOK)"
  },
  {
   value: "Hoole (GBHOZ)",
   label: "Hoole (GBHOZ)"
  },
  {
   value: "Hooton (GBHOX)",
   label: "Hooton (GBHOX)"
  },
  {
   value: "Horam (GBHRA)",
   label: "Horam (GBHRA)"
  },
  {
   value: "Horbury (GBHRB)",
   label: "Horbury (GBHRB)"
  },
  {
   value: "Horley (GBHRY)",
   label: "Horley (GBHRY)"
  },
  {
   value: "Hornchurch (GBHRC)",
   label: "Hornchurch (GBHRC)"
  },
  {
   value: "Horndean (GBHOR)",
   label: "Horndean (GBHOR)"
  },
  {
   value: "Horndon On The Hill (GBHDT)",
   label: "Horndon On The Hill (GBHDT)"
  },
  {
   value: "Hornsey (GBHOY)",
   label: "Hornsey (GBHOY)"
  },
  {
   value: "Horsforth (GBHSF)",
   label: "Horsforth (GBHSF)"
  },
  {
   value: "Horsham (GBHOH)",
   label: "Horsham (GBHOH)"
  },
  {
   value: "Horsmonden (GBHRS)",
   label: "Horsmonden (GBHRS)"
  },
  {
   value: "Horton (GBHOT)",
   label: "Horton (GBHOT)"
  },
  {
   value: "Horwich (GBHIH)",
   label: "Horwich (GBHIH)"
  },
  {
   value: "Hoton (GBHXO)",
   label: "Hoton (GBHXO)"
  },
  {
   value: "Houghton (GBHOG)",
   label: "Houghton (GBHOG)"
  },
  {
   value: "Houghton Le Spring (GBHLS)",
   label: "Houghton Le Spring (GBHLS)"
  },
  {
   value: "Houghton Regis (GBHGR)",
   label: "Houghton Regis (GBHGR)"
  },
  {
   value: "Hound Point (GBHPT)",
   label: "Hound Point (GBHPT)"
  },
  {
   value: "Hebden Bridge (GBHBG)",
   label: "Hebden Bridge (GBHBG)"
  },
  {
   value: "Heckmondwike (GBHEK)",
   label: "Heckmondwike (GBHEK)"
  },
  {
   value: "Heighington (GBHEI)",
   label: "Heighington (GBHEI)"
  },
  {
   value: "Helensburgh (GBHLN)",
   label: "Helensburgh (GBHLN)"
  },
  {
   value: "Hellaby (GBHBY)",
   label: "Hellaby (GBHBY)"
  },
  {
   value: "Helmdon (GBHLM)",
   label: "Helmdon (GBHLM)"
  },
  {
   value: "Helsby (GBHSB)",
   label: "Helsby (GBHSB)"
  },
  {
   value: "Helston (GBHYJ)",
   label: "Helston (GBHYJ)"
  },
  {
   value: "Hemel Hempstead (GBHHE)",
   label: "Hemel Hempstead (GBHHE)"
  },
  {
   value: "Hempstead (GBHEM)",
   label: "Hempstead (GBHEM)"
  },
  {
   value: "Hendon (GBHDO)",
   label: "Hendon (GBHDO)"
  },
  {
   value: "Hengoed (GBHNG)",
   label: "Hengoed (GBHNG)"
  },
  {
   value: "Henley-On-Thames (GBHEN)",
   label: "Henley-On-Thames (GBHEN)"
  },
  {
   value: "Henllys (GBHYY)",
   label: "Henllys (GBHYY)"
  },
  {
   value: "Henlow (GBHEW)",
   label: "Henlow (GBHEW)"
  },
  {
   value: "Henton (GBHNO)",
   label: "Henton (GBHNO)"
  },
  {
   value: "Hereford (GBHAF)",
   label: "Hereford (GBHAF)"
  },
  {
   value: "Herne Bay (GBHRN)",
   label: "Herne Bay (GBHRN)"
  },
  {
   value: "Hertford (GBHEF)",
   label: "Hertford (GBHEF)"
  },
  {
   value: "Hessle (GBHSE)",
   label: "Hessle (GBHSE)"
  },
  {
   value: "Heston (GBHES)",
   label: "Heston (GBHES)"
  },
  {
   value: "Heswall (GBHYB)",
   label: "Heswall (GBHYB)"
  },
  {
   value: "Hetton (GBHTT)",
   label: "Hetton (GBHTT)"
  },
  {
   value: "Hevingham (GBHVG)",
   label: "Hevingham (GBHVG)"
  },
  {
   value: "Hexham (GBHXH)",
   label: "Hexham (GBHXH)"
  },
  {
   value: "Hexton (GBHXT)",
   label: "Hexton (GBHXT)"
  },
  {
   value: "Hexwood (GBHXW)",
   label: "Hexwood (GBHXW)"
  },
  {
   value: "Heysham (GBHYM)",
   label: "Heysham (GBHYM)"
  },
  {
   value: "Heywood (GBHYW)",
   label: "Heywood (GBHYW)"
  },
  {
   value: "Hibaldstow (GBDSX)",
   label: "Hibaldstow (GBDSX)"
  },
  {
   value: "High Ackworth (GBHGA)",
   label: "High Ackworth (GBHGA)"
  },
  {
   value: "High Bentham (GBHBE)",
   label: "High Bentham (GBHBE)"
  },
  {
   value: "High Wycombe (GBHWY)",
   label: "High Wycombe (GBHWY)"
  },
  {
   value: "Higham (GBHGH)",
   label: "Higham (GBHGH)"
  },
  {
   value: "Higham Ferrers (GBHGF)",
   label: "Higham Ferrers (GBHGF)"
  },
  {
   value: "Highbridge (GBHIG)",
   label: "Highbridge (GBHIG)"
  },
  {
   value: "Hightown (GBHGW)",
   label: "Hightown (GBHGW)"
  },
  {
   value: "Hillingdon (GBHLL)",
   label: "Hillingdon (GBHLL)"
  },
  {
   value: "Hillington (GBHTN)",
   label: "Hillington (GBHTN)"
  },
  {
   value: "Hinckley (GBHIL)",
   label: "Hinckley (GBHIL)"
  },
  {
   value: "Hindley (GBHIY)",
   label: "Hindley (GBHIY)"
  },
  {
   value: "Hartlebury (GBHTB)",
   label: "Hartlebury (GBHTB)"
  },
  {
   value: "Hartlepool (GBHTP)",
   label: "Hartlepool (GBHTP)"
  },
  {
   value: "Hartley Wintney (GBHWI)",
   label: "Hartley Wintney (GBHWI)"
  },
  {
   value: "Hartwell (GBHTW)",
   label: "Hartwell (GBHTW)"
  },
  {
   value: "Harwich (GBHRW)",
   label: "Harwich (GBHRW)"
  },
  {
   value: "Harworth (GBHWR)",
   label: "Harworth (GBHWR)"
  },
  {
   value: "Haseley (GBHSY)",
   label: "Haseley (GBHSY)"
  },
  {
   value: "Haslemere (GBHSL)",
   label: "Haslemere (GBHSL)"
  },
  {
   value: "Haslingden (GBHDN)",
   label: "Haslingden (GBHDN)"
  },
  {
   value: "Haslington (GBHSG)",
   label: "Haslington (GBHSG)"
  },
  {
   value: "Hassocks (GBHSK)",
   label: "Hassocks (GBHSK)"
  },
  {
   value: "Hassop (GBHSP)",
   label: "Hassop (GBHSP)"
  },
  {
   value: "Hastings (GBHTG)",
   label: "Hastings (GBHTG)"
  },
  {
   value: "Hatfield (GBHAT)",
   label: "Hatfield (GBHAT)"
  },
  {
   value: "Hatherton (GBHTR)",
   label: "Hatherton (GBHTR)"
  },
  {
   value: "Hatton (GBHTO)",
   label: "Hatton (GBHTO)"
  },
  {
   value: "Havant (GBHAV)",
   label: "Havant (GBHAV)"
  },
  {
   value: "Haverfordwest (GBHVR)",
   label: "Haverfordwest (GBHVR)"
  },
  {
   value: "Haverhill (GBHAL)",
   label: "Haverhill (GBHAL)"
  },
  {
   value: "Hawarden (GBHWN)",
   label: "Hawarden (GBHWN)"
  },
  {
   value: "Hawes (GBHWE)",
   label: "Hawes (GBHWE)"
  },
  {
   value: "Hawick (GBHWC)",
   label: "Hawick (GBHWC)"
  },
  {
   value: "Hawkhurst (GBHWK)",
   label: "Hawkhurst (GBHWK)"
  },
  {
   value: "Hawkwell (GBHWW)",
   label: "Hawkwell (GBHWW)"
  },
  {
   value: "Haworth (GBHWT)",
   label: "Haworth (GBHWT)"
  },
  {
   value: "Hawthorne Hill (GBHWH)",
   label: "Hawthorne Hill (GBHWH)"
  },
  {
   value: "Haydock (GBHDK)",
   label: "Haydock (GBHDK)"
  },
  {
   value: "Hayes (GBHMI)",
   label: "Hayes (GBHMI)"
  },
  {
   value: "Hayle (GBHAY)",
   label: "Hayle (GBHAY)"
  },
  {
   value: "Hayling Island (GBHYI)",
   label: "Hayling Island (GBHYI)"
  },
  {
   value: "Haywards Heath (GBHAH)",
   label: "Haywards Heath (GBHAH)"
  },
  {
   value: "Hazel Grove (GBHZG)",
   label: "Hazel Grove (GBHZG)"
  },
  {
   value: "Heachem (GBHEA)",
   label: "Heachem (GBHEA)"
  },
  {
   value: "Headcorn (GBHED)",
   label: "Headcorn (GBHED)"
  },
  {
   value: "Headinton (GBHDG)",
   label: "Headinton (GBHDG)"
  },
  {
   value: "Headley Down (GBHEO)",
   label: "Headley Down (GBHEO)"
  },
  {
   value: "Heanor (GBHNR)",
   label: "Heanor (GBHNR)"
  },
  {
   value: "Heathfield (GBHHF)",
   label: "Heathfield (GBHHF)"
  },
  {
   value: "Heathrow Apt\/London (GBLHR)",
   label: "Heathrow Apt\/London (GBLHR)"
  },
  {
   value: "Hebburn (GBHEB)",
   label: "Hebburn (GBHEB)"
  },
  {
   value: "Guiseley (GBGUI)",
   label: "Guiseley (GBGUI)"
  },
  {
   value: "Gunness Wharf (GBGUW)",
   label: "Gunness Wharf (GBGUW)"
  },
  {
   value: "Hackney (GBHCK)",
   label: "Hackney (GBHCK)"
  },
  {
   value: "Haddenham (GBHDH)",
   label: "Haddenham (GBHDH)"
  },
  {
   value: "Haddington (GBHAD)",
   label: "Haddington (GBHAD)"
  },
  {
   value: "Hadleigh (GBHDL)",
   label: "Hadleigh (GBHDL)"
  },
  {
   value: "Hadley (GBHDY)",
   label: "Hadley (GBHDY)"
  },
  {
   value: "Hailsham (GBHAI)",
   label: "Hailsham (GBHAI)"
  },
  {
   value: "Hainault (GBHNU)",
   label: "Hainault (GBHNU)"
  },
  {
   value: "Hale (GBHAE)",
   label: "Hale (GBHAE)"
  },
  {
   value: "Halesowen (GBHSN)",
   label: "Halesowen (GBHSN)"
  },
  {
   value: "Halesworth (GBHSW)",
   label: "Halesworth (GBHSW)"
  },
  {
   value: "Halewood (GBHLW)",
   label: "Halewood (GBHLW)"
  },
  {
   value: "Halifax (GBHFX)",
   label: "Halifax (GBHFX)"
  },
  {
   value: "Halling (GBHLG)",
   label: "Halling (GBHLG)"
  },
  {
   value: "Halstead (GBHTD)",
   label: "Halstead (GBHTD)"
  },
  {
   value: "Haltwhistle (GBHWS)",
   label: "Haltwhistle (GBHWS)"
  },
  {
   value: "Hamble (GBHAM)",
   label: "Hamble (GBHAM)"
  },
  {
   value: "Hambleden (GBHMB)",
   label: "Hambleden (GBHMB)"
  },
  {
   value: "Hambridge (GBHBR)",
   label: "Hambridge (GBHBR)"
  },
  {
   value: "Hamilton (GBHMT)",
   label: "Hamilton (GBHMT)"
  },
  {
   value: "Hampole (GBHPO)",
   label: "Hampole (GBHPO)"
  },
  {
   value: "Hampstead (GBHMS)",
   label: "Hampstead (GBHMS)"
  },
  {
   value: "Hampton (GBHMP)",
   label: "Hampton (GBHMP)"
  },
  {
   value: "Hamworthy (GBHMO)",
   label: "Hamworthy (GBHMO)"
  },
  {
   value: "Handsworth (GBHND)",
   label: "Handsworth (GBHND)"
  },
  {
   value: "Hanley (GBHNL)",
   label: "Hanley (GBHNL)"
  },
  {
   value: "Hapton (GBHAP)",
   label: "Hapton (GBHAP)"
  },
  {
   value: "Harby (GBHXY)",
   label: "Harby (GBHXY)"
  },
  {
   value: "Hardley (GBHAR)",
   label: "Hardley (GBHAR)"
  },
  {
   value: "Harefield (GBHRF)",
   label: "Harefield (GBHRF)"
  },
  {
   value: "Harlesden (GBHRD)",
   label: "Harlesden (GBHRD)"
  },
  {
   value: "Harlington (GBHGT)",
   label: "Harlington (GBHGT)"
  },
  {
   value: "Harlow (GBHRL)",
   label: "Harlow (GBHRL)"
  },
  {
   value: "Harmondsworth (GBHMW)",
   label: "Harmondsworth (GBHMW)"
  },
  {
   value: "Harold Hill (GBHHI)",
   label: "Harold Hill (GBHHI)"
  },
  {
   value: "Harold Wood (GBHLD)",
   label: "Harold Wood (GBHLD)"
  },
  {
   value: "Harpenden (GBHPD)",
   label: "Harpenden (GBHPD)"
  },
  {
   value: "Harrogate (GBHRT)",
   label: "Harrogate (GBHRT)"
  },
  {
   value: "Harrow (GBHRO)",
   label: "Harrow (GBHRO)"
  },
  {
   value: "Harrow on the Hill (GBHHL)",
   label: "Harrow on the Hill (GBHHL)"
  },
  {
   value: "Grays (GBGYS)",
   label: "Grays (GBGYS)"
  },
  {
   value: "Grazeley (GBGZY)",
   label: "Grazeley (GBGZY)"
  },
  {
   value: "Great Alne (GBGAL)",
   label: "Great Alne (GBGAL)"
  },
  {
   value: "Great Amwell (GBGAM)",
   label: "Great Amwell (GBGAM)"
  },
  {
   value: "Great Barton (GBGBT)",
   label: "Great Barton (GBGBT)"
  },
  {
   value: "Great Blakenham (GBGRB)",
   label: "Great Blakenham (GBGRB)"
  },
  {
   value: "Great Bookham (GBGBK)",
   label: "Great Bookham (GBGBK)"
  },
  {
   value: "Great Brickhill (GBGTR)",
   label: "Great Brickhill (GBGTR)"
  },
  {
   value: "Great Chishill (GBGCH)",
   label: "Great Chishill (GBGCH)"
  },
  {
   value: "Great Dunmow (GBGRD)",
   label: "Great Dunmow (GBGRD)"
  },
  {
   value: "Great Easton (GBGET)",
   label: "Great Easton (GBGET)"
  },
  {
   value: "Great Gransden (GBGRX)",
   label: "Great Gransden (GBGRX)"
  },
  {
   value: "Great Harwood (GBGRH)",
   label: "Great Harwood (GBGRH)"
  },
  {
   value: "Great Haseley (GBGHY)",
   label: "Great Haseley (GBGHY)"
  },
  {
   value: "Great Malvern (GBGML)",
   label: "Great Malvern (GBGML)"
  },
  {
   value: "Great Missenden (GBGRM)",
   label: "Great Missenden (GBGRM)"
  },
  {
   value: "Great Ryburgh (GBGRR)",
   label: "Great Ryburgh (GBGRR)"
  },
  {
   value: "Great Sankey (GBGRS)",
   label: "Great Sankey (GBGRS)"
  },
  {
   value: "Great Shelford (GBGRZ)",
   label: "Great Shelford (GBGRZ)"
  },
  {
   value: "Great Sutton (GBGSU)",
   label: "Great Sutton (GBGSU)"
  },
  {
   value: "Great Tey (GBGTT)",
   label: "Great Tey (GBGTT)"
  },
  {
   value: "Great Torrington (GBGTO)",
   label: "Great Torrington (GBGTO)"
  },
  {
   value: "Great Wyrley (GBGWY)",
   label: "Great Wyrley (GBGWY)"
  },
  {
   value: "Great Yarmouth (GBGTY)",
   label: "Great Yarmouth (GBGTY)"
  },
  {
   value: "Greatham (GBGTH)",
   label: "Greatham (GBGTH)"
  },
  {
   value: "Greenfield (GBGFD)",
   label: "Greenfield (GBGFD)"
  },
  {
   value: "Greenford (GBGFR)",
   label: "Greenford (GBGFR)"
  },
  {
   value: "Greenham Common (GBGRE)",
   label: "Greenham Common (GBGRE)"
  },
  {
   value: "Greenhithe (GBGHI)",
   label: "Greenhithe (GBGHI)"
  },
  {
   value: "Greenock (GBGRK)",
   label: "Greenock (GBGRK)"
  },
  {
   value: "Greenwich (GBGNW)",
   label: "Greenwich (GBGNW)"
  },
  {
   value: "Greetland (GBGTL)",
   label: "Greetland (GBGTL)"
  },
  {
   value: "Grimsby (GBGSY)",
   label: "Grimsby (GBGSY)"
  },
  {
   value: "Gristhorpe (GBGRP)",
   label: "Gristhorpe (GBGRP)"
  },
  {
   value: "Grove Wharves (GBGRW)",
   label: "Grove Wharves (GBGRW)"
  },
  {
   value: "Guardbridge (GBGDB)",
   label: "Guardbridge (GBGDB)"
  },
  {
   value: "Guernsey (GBGCI)",
   label: "Guernsey (GBGCI)"
  },
  {
   value: "Guildford (GBGDD)",
   label: "Guildford (GBGDD)"
  },
  {
   value: "Guisborough (GBGSB)",
   label: "Guisborough (GBGSB)"
  },
  {
   value: "Garvald (GBGRV)",
   label: "Garvald (GBGRV)"
  },
  {
   value: "Gastard (GBGST)",
   label: "Gastard (GBGST)"
  },
  {
   value: "Gateshead (GBGAT)",
   label: "Gateshead (GBGAT)"
  },
  {
   value: "Gatwick Apt\/London (GBLGW)",
   label: "Gatwick Apt\/London (GBLGW)"
  },
  {
   value: "Gerrards Cross (GBGRC)",
   label: "Gerrards Cross (GBGRC)"
  },
  {
   value: "Gidea Park (GBGDP)",
   label: "Gidea Park (GBGDP)"
  },
  {
   value: "Gildersome (GBGDR)",
   label: "Gildersome (GBGDR)"
  },
  {
   value: "Gillingham (GBGIL)",
   label: "Gillingham (GBGIL)"
  },
  {
   value: "Gillingham (GBGLL)",
   label: "Gillingham (GBGLL)"
  },
  {
   value: "Girvan (GBGIR)",
   label: "Girvan (GBGIR)"
  },
  {
   value: "Glanton (GBGLN)",
   label: "Glanton (GBGLN)"
  },
  {
   value: "Glasgow (GBGLW)",
   label: "Glasgow (GBGLW)"
  },
  {
   value: "Glasson Dock (GBGLD)",
   label: "Glasson Dock (GBGLD)"
  },
  {
   value: "Glastonbury (GBGRY)",
   label: "Glastonbury (GBGRY)"
  },
  {
   value: "Glemsford (GBGLE)",
   label: "Glemsford (GBGLE)"
  },
  {
   value: "Glenfield (GBGLF)",
   label: "Glenfield (GBGLF)"
  },
  {
   value: "Glenrothes (GBGLS)",
   label: "Glenrothes (GBGLS)"
  },
  {
   value: "Glensanda (GBGSA)",
   label: "Glensanda (GBGSA)"
  },
  {
   value: "Glossop (GBGSP)",
   label: "Glossop (GBGSP)"
  },
  {
   value: "Gloucester (GBGLO)",
   label: "Gloucester (GBGLO)"
  },
  {
   value: "Godaiming (GBGOD)",
   label: "Godaiming (GBGOD)"
  },
  {
   value: "Godmanchester (GBGDM)",
   label: "Godmanchester (GBGDM)"
  },
  {
   value: "Godstone (GBGDS)",
   label: "Godstone (GBGDS)"
  },
  {
   value: "Goff's Oak (GBGFO)",
   label: "Goff's Oak (GBGFO)"
  },
  {
   value: "Golborne (GBGOL)",
   label: "Golborne (GBGOL)"
  },
  {
   value: "Golders Green5 (GBGDG)",
   label: "Golders Green5 (GBGDG)"
  },
  {
   value: "Gomersal (GBGMS)",
   label: "Gomersal (GBGMS)"
  },
  {
   value: "Goole (GBGOO)",
   label: "Goole (GBGOO)"
  },
  {
   value: "Goring (GBGNG)",
   label: "Goring (GBGNG)"
  },
  {
   value: "Gorlston on Sea (GBGRL)",
   label: "Gorlston on Sea (GBGRL)"
  },
  {
   value: "Gorseinon (GBGOQ)",
   label: "Gorseinon (GBGOQ)"
  },
  {
   value: "Gosfield (GBGSF)",
   label: "Gosfield (GBGSF)"
  },
  {
   value: "Gosforth (GBGFT)",
   label: "Gosforth (GBGFT)"
  },
  {
   value: "Gosport (GBGOS)",
   label: "Gosport (GBGOS)"
  },
  {
   value: "Gourock (GBGUR)",
   label: "Gourock (GBGUR)"
  },
  {
   value: "Granborough (GBGBH)",
   label: "Granborough (GBGBH)"
  },
  {
   value: "Grangemouth (GBGRG)",
   label: "Grangemouth (GBGRG)"
  },
  {
   value: "Grangetown (GBGWN)",
   label: "Grangetown (GBGWN)"
  },
  {
   value: "Gransden (GBGRA)",
   label: "Gransden (GBGRA)"
  },
  {
   value: "Grantham (GBGTM)",
   label: "Grantham (GBGTM)"
  },
  {
   value: "Granton (GBGRN)",
   label: "Granton (GBGRN)"
  },
  {
   value: "Gravesend (GBGVS)",
   label: "Gravesend (GBGVS)"
  },
  {
   value: "Flixborough (GBFLW)",
   label: "Flixborough (GBFLW)"
  },
  {
   value: "Flixton (GBFLX)",
   label: "Flixton (GBFLX)"
  },
  {
   value: "Flotta (GBFLH)",
   label: "Flotta (GBFLH)"
  },
  {
   value: "Fochabers (GBFCB)",
   label: "Fochabers (GBFCB)"
  },
  {
   value: "Folkestone (GBFOL)",
   label: "Folkestone (GBFOL)"
  },
  {
   value: "Fontwell (GBFWL)",
   label: "Fontwell (GBFWL)"
  },
  {
   value: "Fordham (GBFDM)",
   label: "Fordham (GBFDM)"
  },
  {
   value: "Fordhouses (GBFDH)",
   label: "Fordhouses (GBFDH)"
  },
  {
   value: "Fordingbridge (GBFGB)",
   label: "Fordingbridge (GBFGB)"
  },
  {
   value: "Forest Gate (GBFRG)",
   label: "Forest Gate (GBFRG)"
  },
  {
   value: "Forfar (GBFOF)",
   label: "Forfar (GBFOF)"
  },
  {
   value: "Formby (GBFRM)",
   label: "Formby (GBFRM)"
  },
  {
   value: "Forres (GBFRS)",
   label: "Forres (GBFRS)"
  },
  {
   value: "Fort William (GBFWM)",
   label: "Fort William (GBFWM)"
  },
  {
   value: "Forth (GBFOR)",
   label: "Forth (GBFOR)"
  },
  {
   value: "Fosdyke (GBFDK)",
   label: "Fosdyke (GBFDK)"
  },
  {
   value: "Foula (GBFOA)",
   label: "Foula (GBFOA)"
  },
  {
   value: "Fowey (GBFOY)",
   label: "Fowey (GBFOY)"
  },
  {
   value: "Foxton (GBFXF)",
   label: "Foxton (GBFXF)"
  },
  {
   value: "Framlingham (GBFRA)",
   label: "Framlingham (GBFRA)"
  },
  {
   value: "Frant (GBFRT)",
   label: "Frant (GBFRT)"
  },
  {
   value: "Fraserburgh (GBFRB)",
   label: "Fraserburgh (GBFRB)"
  },
  {
   value: "Frisby on the Wreake (GBFOW)",
   label: "Frisby on the Wreake (GBFOW)"
  },
  {
   value: "Fritchley (GBFRL)",
   label: "Fritchley (GBFRL)"
  },
  {
   value: "Frodsham (GBFDS)",
   label: "Frodsham (GBFDS)"
  },
  {
   value: "Frome (GBFME)",
   label: "Frome (GBFME)"
  },
  {
   value: "Fulbourn (GBFBN)",
   label: "Fulbourn (GBFBN)"
  },
  {
   value: "Fulford (GBFLF)",
   label: "Fulford (GBFLF)"
  },
  {
   value: "Fulham (GBFLM)",
   label: "Fulham (GBFLM)"
  },
  {
   value: "Fulmer (GBFUL)",
   label: "Fulmer (GBFUL)"
  },
  {
   value: "Gaerwen (GBGAW)",
   label: "Gaerwen (GBGAW)"
  },
  {
   value: "Gainsborough (GBGAI)",
   label: "Gainsborough (GBGAI)"
  },
  {
   value: "Galashiels (GBGAH)",
   label: "Galashiels (GBGAH)"
  },
  {
   value: "Galston (GBGSN)",
   label: "Galston (GBGSN)"
  },
  {
   value: "Gamlingay (GBGAG)",
   label: "Gamlingay (GBGAG)"
  },
  {
   value: "Gardenstown (GBGDN)",
   label: "Gardenstown (GBGDN)"
  },
  {
   value: "Gargrave (GBGGV)",
   label: "Gargrave (GBGGV)"
  },
  {
   value: "Garlieston (GBGIS)",
   label: "Garlieston (GBGIS)"
  },
  {
   value: "Garstang (GBGTA)",
   label: "Garstang (GBGTA)"
  },
  {
   value: "Garston (GBGTN)",
   label: "Garston (GBGTN)"
  },
  {
   value: "Gartcosh (GBGTC)",
   label: "Gartcosh (GBGTC)"
  },
  {
   value: "Eynsham (GBEYH)",
   label: "Eynsham (GBEYH)"
  },
  {
   value: "Failsworth (GBFLS)",
   label: "Failsworth (GBFLS)"
  },
  {
   value: "Fair Isle (GBFIE)",
   label: "Fair Isle (GBFIE)"
  },
  {
   value: "Fairford (GBFFO)",
   label: "Fairford (GBFFO)"
  },
  {
   value: "Fakenham (GBFKM)",
   label: "Fakenham (GBFKM)"
  },
  {
   value: "Falkirk (GBFKK)",
   label: "Falkirk (GBFKK)"
  },
  {
   value: "Falmouth (GBFAL)",
   label: "Falmouth (GBFAL)"
  },
  {
   value: "Fareham (GBFHM)",
   label: "Fareham (GBFHM)"
  },
  {
   value: "Faringdon (GBFAN)",
   label: "Faringdon (GBFAN)"
  },
  {
   value: "Farnborough (GBFBO)",
   label: "Farnborough (GBFBO)"
  },
  {
   value: "Farnham (GBFAR)",
   label: "Farnham (GBFAR)"
  },
  {
   value: "Farnham Common (GBFRC)",
   label: "Farnham Common (GBFRC)"
  },
  {
   value: "Farnworth (GBFNW)",
   label: "Farnworth (GBFNW)"
  },
  {
   value: "Farringdon (GBFRR)",
   label: "Farringdon (GBFRR)"
  },
  {
   value: "Faslane (GBFAS)",
   label: "Faslane (GBFAS)"
  },
  {
   value: "Faversham (GBFAV)",
   label: "Faversham (GBFAV)"
  },
  {
   value: "Fawley (GBFAW)",
   label: "Fawley (GBFAW)"
  },
  {
   value: "Featherstone (GBFTH)",
   label: "Featherstone (GBFTH)"
  },
  {
   value: "Felixstowe (GBFXT)",
   label: "Felixstowe (GBFXT)"
  },
  {
   value: "Felling (GBFLL)",
   label: "Felling (GBFLL)"
  },
  {
   value: "Felmersham (GBFSH)",
   label: "Felmersham (GBFSH)"
  },
  {
   value: "Feltham (GBFEM)",
   label: "Feltham (GBFEM)"
  },
  {
   value: "Feltwell (GBFEL)",
   label: "Feltwell (GBFEL)"
  },
  {
   value: "Fenton (GBFEN)",
   label: "Fenton (GBFEN)"
  },
  {
   value: "Ferndale (GBFRD)",
   label: "Ferndale (GBFRD)"
  },
  {
   value: "Ferndown (GBFDN)",
   label: "Ferndown (GBFDN)"
  },
  {
   value: "Fersfield (GBFER)",
   label: "Fersfield (GBFER)"
  },
  {
   value: "Fetcham (GBFTC)",
   label: "Fetcham (GBFTC)"
  },
  {
   value: "Fetlar (GBFEA)",
   label: "Fetlar (GBFEA)"
  },
  {
   value: "Filby (GBFLB)",
   label: "Filby (GBFLB)"
  },
  {
   value: "Filey (GBFLY)",
   label: "Filey (GBFLY)"
  },
  {
   value: "Filton (GBFZO)",
   label: "Filton (GBFZO)"
  },
  {
   value: "Finchampstead (GBFNC)",
   label: "Finchampstead (GBFNC)"
  },
  {
   value: "Finedon (GBFND)",
   label: "Finedon (GBFND)"
  },
  {
   value: "Fingringhoe (GBFRH)",
   label: "Fingringhoe (GBFRH)"
  },
  {
   value: "Finnart (GBFNT)",
   label: "Finnart (GBFNT)"
  },
  {
   value: "Fishguard (GBFIS)",
   label: "Fishguard (GBFIS)"
  },
  {
   value: "Fleet (GBFET)",
   label: "Fleet (GBFET)"
  },
  {
   value: "Fleetwood (GBFLE)",
   label: "Fleetwood (GBFLE)"
  },
  {
   value: "Flint (GBFLI)",
   label: "Flint (GBFLI)"
  },
  {
   value: "Flitwick (GBFLC)",
   label: "Flitwick (GBFLC)"
  },
  {
   value: "Edenbridge (GBEDE)",
   label: "Edenbridge (GBEDE)"
  },
  {
   value: "Edgware (GBEDG)",
   label: "Edgware (GBEDG)"
  },
  {
   value: "Edinburgh (GBEDI)",
   label: "Edinburgh (GBEDI)"
  },
  {
   value: "Edmonton (GBEDM)",
   label: "Edmonton (GBEDM)"
  },
  {
   value: "Edwinstowe (GBEDW)",
   label: "Edwinstowe (GBEDW)"
  },
  {
   value: "Edzell (GBEDZ)",
   label: "Edzell (GBEDZ)"
  },
  {
   value: "Egham (GBEGH)",
   label: "Egham (GBEGH)"
  },
  {
   value: "Elgin (GBELG)",
   label: "Elgin (GBELG)"
  },
  {
   value: "Elie (GBELI)",
   label: "Elie (GBELI)"
  },
  {
   value: "Elkesley (GBELK)",
   label: "Elkesley (GBELK)"
  },
  {
   value: "Elland (GBEND)",
   label: "Elland (GBEND)"
  },
  {
   value: "Ellesmere (GBELM)",
   label: "Ellesmere (GBELM)"
  },
  {
   value: "Ellesmere Port (GBELL)",
   label: "Ellesmere Port (GBELL)"
  },
  {
   value: "Ellington (GBELT)",
   label: "Ellington (GBELT)"
  },
  {
   value: "Elmesthorpe (GBELH)",
   label: "Elmesthorpe (GBELH)"
  },
  {
   value: "Elsenham (GBELE)",
   label: "Elsenham (GBELE)"
  },
  {
   value: "Elstree (GBETR)",
   label: "Elstree (GBETR)"
  },
  {
   value: "Elvington (GBELV)",
   label: "Elvington (GBELV)"
  },
  {
   value: "Ely (GBELY)",
   label: "Ely (GBELY)"
  },
  {
   value: "Emberton (GBEMB)",
   label: "Emberton (GBEMB)"
  },
  {
   value: "Enderby (GBEDB)",
   label: "Enderby (GBEDB)"
  },
  {
   value: "Enfield (GBENF)",
   label: "Enfield (GBENF)"
  },
  {
   value: "Engelfield Green (GBENG)",
   label: "Engelfield Green (GBENG)"
  },
  {
   value: "Enniskillen (GBENK)",
   label: "Enniskillen (GBENK)"
  },
  {
   value: "Epping (GBEPP)",
   label: "Epping (GBEPP)"
  },
  {
   value: "Epsom (GBEPS)",
   label: "Epsom (GBEPS)"
  },
  {
   value: "Erdington (GBERD)",
   label: "Erdington (GBERD)"
  },
  {
   value: "Erith (GBERI)",
   label: "Erith (GBERI)"
  },
  {
   value: "Esher (GBESR)",
   label: "Esher (GBESR)"
  },
  {
   value: "Etchingham (GBETA)",
   label: "Etchingham (GBETA)"
  },
  {
   value: "Eton (GBETN)",
   label: "Eton (GBETN)"
  },
  {
   value: "Eversley (GBEVY)",
   label: "Eversley (GBEVY)"
  },
  {
   value: "Evesham (GBEVE)",
   label: "Evesham (GBEVE)"
  },
  {
   value: "Ewell (GBEWE)",
   label: "Ewell (GBEWE)"
  },
  {
   value: "Ewelme (GBEWM)",
   label: "Ewelme (GBEWM)"
  },
  {
   value: "Exeter (GBEXE)",
   label: "Exeter (GBEXE)"
  },
  {
   value: "Exmouth (GBEXM)",
   label: "Exmouth (GBEXM)"
  },
  {
   value: "Exning (GBEXN)",
   label: "Exning (GBEXN)"
  },
  {
   value: "Eyam (GBEYA)",
   label: "Eyam (GBEYA)"
  },
  {
   value: "Eye (GBEYE)",
   label: "Eye (GBEYE)"
  },
  {
   value: "Eyemouth (GBEYM)",
   label: "Eyemouth (GBEYM)"
  },
  {
   value: "Eynsford (GBENS)",
   label: "Eynsford (GBENS)"
  },
  {
   value: "Dunsford (GBDNR)",
   label: "Dunsford (GBDNR)"
  },
  {
   value: "Dunstable (GBDTE)",
   label: "Dunstable (GBDTE)"
  },
  {
   value: "Dunston (GBDTN)",
   label: "Dunston (GBDTN)"
  },
  {
   value: "Durham (GBDRH)",
   label: "Durham (GBDRH)"
  },
  {
   value: "Durness (GBDNS)",
   label: "Durness (GBDNS)"
  },
  {
   value: "Durrington (GBDRR)",
   label: "Durrington (GBDRR)"
  },
  {
   value: "Dursley (GBDUR)",
   label: "Dursley (GBDUR)"
  },
  {
   value: "Duston (GBDST)",
   label: "Duston (GBDST)"
  },
  {
   value: "Duxford (GBDXF)",
   label: "Duxford (GBDXF)"
  },
  {
   value: "Dyce (GBDYC)",
   label: "Dyce (GBDYC)"
  },
  {
   value: "Dymock (GBDMC)",
   label: "Dymock (GBDMC)"
  },
  {
   value: "Eaglescliff (GBEGL)",
   label: "Eaglescliff (GBEGL)"
  },
  {
   value: "Ealing (GBELN)",
   label: "Ealing (GBELN)"
  },
  {
   value: "Earby (GBERB)",
   label: "Earby (GBERB)"
  },
  {
   value: "Earls Barton (GBEAR)",
   label: "Earls Barton (GBEAR)"
  },
  {
   value: "East Bridgford (GBESB)",
   label: "East Bridgford (GBESB)"
  },
  {
   value: "East Dereham (GBEAD)",
   label: "East Dereham (GBEAD)"
  },
  {
   value: "East Grinstead (GBEGD)",
   label: "East Grinstead (GBEGD)"
  },
  {
   value: "East Horsley (GBESY)",
   label: "East Horsley (GBESY)"
  },
  {
   value: "East Kilbride (GBEKB)",
   label: "East Kilbride (GBEKB)"
  },
  {
   value: "East Midlands Apt (GBEMA)",
   label: "East Midlands Apt (GBEMA)"
  },
  {
   value: "East Molesey (GBEMO)",
   label: "East Molesey (GBEMO)"
  },
  {
   value: "East Peckham (GBETP)",
   label: "East Peckham (GBETP)"
  },
  {
   value: "East Retford (GBERF)",
   label: "East Retford (GBERF)"
  },
  {
   value: "East Wellow (GBESW)",
   label: "East Wellow (GBESW)"
  },
  {
   value: "Eastbourne (GBEBO)",
   label: "Eastbourne (GBEBO)"
  },
  {
   value: "Eastcote (GBESL)",
   label: "Eastcote (GBESL)"
  },
  {
   value: "Eastergate (GBESA)",
   label: "Eastergate (GBESA)"
  },
  {
   value: "Eastham (GBEAM)",
   label: "Eastham (GBEAM)"
  },
  {
   value: "Eastleigh (GBEAT)",
   label: "Eastleigh (GBEAT)"
  },
  {
   value: "Easton (GBEAO)",
   label: "Easton (GBEAO)"
  },
  {
   value: "Easton (GBEAN)",
   label: "Easton (GBEAN)"
  },
  {
   value: "Easton in Gordano (GBEIG)",
   label: "Easton in Gordano (GBEIG)"
  },
  {
   value: "Eastry (GBEAY)",
   label: "Eastry (GBEAY)"
  },
  {
   value: "Eaton Bishop (GBETB)",
   label: "Eaton Bishop (GBETB)"
  },
  {
   value: "Eaton Socon (GBESC)",
   label: "Eaton Socon (GBESC)"
  },
  {
   value: "Ebbw Vale (GBEBB)",
   label: "Ebbw Vale (GBEBB)"
  },
  {
   value: "Eccles (GBECS)",
   label: "Eccles (GBECS)"
  },
  {
   value: "Ecclesfield (GBECC)",
   label: "Ecclesfield (GBECC)"
  },
  {
   value: "Eday (GBEOI)",
   label: "Eday (GBEOI)"
  },
  {
   value: "Dewsbury (GBDWY)",
   label: "Dewsbury (GBDWY)"
  },
  {
   value: "Didcot (GBDID)",
   label: "Didcot (GBDID)"
  },
  {
   value: "Dingle (GBDIN)",
   label: "Dingle (GBDIN)"
  },
  {
   value: "Disley (GBDSL)",
   label: "Disley (GBDSL)"
  },
  {
   value: "Diss (GBDIS)",
   label: "Diss (GBDIS)"
  },
  {
   value: "Ditchingham (GBDIT)",
   label: "Ditchingham (GBDIT)"
  },
  {
   value: "Ditchling (GBDTH)",
   label: "Ditchling (GBDTH)"
  },
  {
   value: "Ditton (GBDTT)",
   label: "Ditton (GBDTT)"
  },
  {
   value: "Dolgellau (GBDLG)",
   label: "Dolgellau (GBDLG)"
  },
  {
   value: "Donaghadee (GBDHD)",
   label: "Donaghadee (GBDHD)"
  },
  {
   value: "Doncaster (GBDON)",
   label: "Doncaster (GBDON)"
  },
  {
   value: "Donnington (GBDNG)",
   label: "Donnington (GBDNG)"
  },
  {
   value: "Doonfoot (GBDNT)",
   label: "Doonfoot (GBDNT)"
  },
  {
   value: "Dorchester (GBDHR)",
   label: "Dorchester (GBDHR)"
  },
  {
   value: "Dorking (GBDKG)",
   label: "Dorking (GBDKG)"
  },
  {
   value: "Dornoch (GBDOC)",
   label: "Dornoch (GBDOC)"
  },
  {
   value: "Douglas (GBDGS)",
   label: "Douglas (GBDGS)"
  },
  {
   value: "Dover (GBDVR)",
   label: "Dover (GBDVR)"
  },
  {
   value: "Doveridge (GBDDG)",
   label: "Doveridge (GBDDG)"
  },
  {
   value: "Downham Market (GBDOW)",
   label: "Downham Market (GBDOW)"
  },
  {
   value: "Downpatrick (GBDWK)",
   label: "Downpatrick (GBDWK)"
  },
  {
   value: "Driffield (GBDRF)",
   label: "Driffield (GBDRF)"
  },
  {
   value: "Drighlington (GBDRG)",
   label: "Drighlington (GBDRG)"
  },
  {
   value: "Droitwich (GBDRO)",
   label: "Droitwich (GBDRO)"
  },
  {
   value: "Dronfield (GBDRN)",
   label: "Dronfield (GBDRN)"
  },
  {
   value: "Droylsden (GBDRY)",
   label: "Droylsden (GBDRY)"
  },
  {
   value: "Drumchapel (GBDCP)",
   label: "Drumchapel (GBDCP)"
  },
  {
   value: "Drummore (GBDRM)",
   label: "Drummore (GBDRM)"
  },
  {
   value: "Ducksford (GBDKF)",
   label: "Ducksford (GBDKF)"
  },
  {
   value: "Dudley (GBDDL)",
   label: "Dudley (GBDDL)"
  },
  {
   value: "Duffield (GBDUF)",
   label: "Duffield (GBDUF)"
  },
  {
   value: "Dukinfield (GBDQF)",
   label: "Dukinfield (GBDQF)"
  },
  {
   value: "Dumbarton (GBDBT)",
   label: "Dumbarton (GBDBT)"
  },
  {
   value: "Dumfries (GBDUM)",
   label: "Dumfries (GBDUM)"
  },
  {
   value: "Dunblane (GBDUB)",
   label: "Dunblane (GBDUB)"
  },
  {
   value: "Dundee (GBDUN)",
   label: "Dundee (GBDUN)"
  },
  {
   value: "Dundonald (GBDDD)",
   label: "Dundonald (GBDDD)"
  },
  {
   value: "Dundrennan (GBDDN)",
   label: "Dundrennan (GBDDN)"
  },
  {
   value: "Dunfermline (GBDFR)",
   label: "Dunfermline (GBDFR)"
  },
  {
   value: "Dungannon (GBDGN)",
   label: "Dungannon (GBDGN)"
  },
  {
   value: "Dunoon (GBDNU)",
   label: "Dunoon (GBDNU)"
  },
  {
   value: "Cuckfield (GBCFL)",
   label: "Cuckfield (GBCFL)"
  },
  {
   value: "Cuddington (GBCUD)",
   label: "Cuddington (GBCUD)"
  },
  {
   value: "Cullingworth (GBCGW)",
   label: "Cullingworth (GBCGW)"
  },
  {
   value: "Cullompton (GBCUL)",
   label: "Cullompton (GBCUL)"
  },
  {
   value: "Cumbernauld (GBCLD)",
   label: "Cumbernauld (GBCLD)"
  },
  {
   value: "Cumnock (GBCMY)",
   label: "Cumnock (GBCMY)"
  },
  {
   value: "Cupar (GBCUP)",
   label: "Cupar (GBCUP)"
  },
  {
   value: "Cutnall Green (GBCUT)",
   label: "Cutnall Green (GBCUT)"
  },
  {
   value: "Cwmbran (GBCWM)",
   label: "Cwmbran (GBCWM)"
  },
  {
   value: "Dagenham (GBDAG)",
   label: "Dagenham (GBDAG)"
  },
  {
   value: "Dalkeith (GBDLK)",
   label: "Dalkeith (GBDLK)"
  },
  {
   value: "Dalmuir (GBDMR)",
   label: "Dalmuir (GBDMR)"
  },
  {
   value: "Dalry (GBDLX)",
   label: "Dalry (GBDLX)"
  },
  {
   value: "Dalston (GBDLS)",
   label: "Dalston (GBDLS)"
  },
  {
   value: "Dalton in Furness (GBDAL)",
   label: "Dalton in Furness (GBDAL)"
  },
  {
   value: "Danbury (GBDNB)",
   label: "Danbury (GBDNB)"
  },
  {
   value: "Darlaston (GBDRS)",
   label: "Darlaston (GBDRS)"
  },
  {
   value: "Darlington (GBDRL)",
   label: "Darlington (GBDRL)"
  },
  {
   value: "Dartford (GBDFD)",
   label: "Dartford (GBDFD)"
  },
  {
   value: "Dartington (GBDTG)",
   label: "Dartington (GBDTG)"
  },
  {
   value: "Dartmouth (GBDTM)",
   label: "Dartmouth (GBDTM)"
  },
  {
   value: "Darwen (GBDWN)",
   label: "Darwen (GBDWN)"
  },
  {
   value: "Datchet (GBDAT)",
   label: "Datchet (GBDAT)"
  },
  {
   value: "Daventry (GBDVY)",
   label: "Daventry (GBDVY)"
  },
  {
   value: "Deal (GBDEX)",
   label: "Deal (GBDEX)"
  },
  {
   value: "Dean Quarry (GBDNQ)",
   label: "Dean Quarry (GBDNQ)"
  },
  {
   value: "Deanshanger (GBDHG)",
   label: "Deanshanger (GBDHG)"
  },
  {
   value: "Debenham (GBDBN)",
   label: "Debenham (GBDBN)"
  },
  {
   value: "Delph (GBDEL)",
   label: "Delph (GBDEL)"
  },
  {
   value: "Denbigh (GBDBI)",
   label: "Denbigh (GBDBI)"
  },
  {
   value: "Denham (GBDHM)",
   label: "Denham (GBDHM)"
  },
  {
   value: "Denholme (GBDNH)",
   label: "Denholme (GBDNH)"
  },
  {
   value: "Denny (GBDNY)",
   label: "Denny (GBDNY)"
  },
  {
   value: "Denton (GBDET)",
   label: "Denton (GBDET)"
  },
  {
   value: "Denton (GBDEN)",
   label: "Denton (GBDEN)"
  },
  {
   value: "Deptford (GBDEP)",
   label: "Deptford (GBDEP)"
  },
  {
   value: "Derby (GBDXY)",
   label: "Derby (GBDXY)"
  },
  {
   value: "Desborough (GBDSB)",
   label: "Desborough (GBDSB)"
  },
  {
   value: "Desford (GBDES)",
   label: "Desford (GBDES)"
  },
  {
   value: "Devizes (GBDVZ)",
   label: "Devizes (GBDVZ)"
  },
  {
   value: "Devonport (GBDVP)",
   label: "Devonport (GBDVP)"
  },
  {
   value: "Corsham (GBCRS)",
   label: "Corsham (GBCRS)"
  },
  {
   value: "Coryton (GBCOY)",
   label: "Coryton (GBCOY)"
  },
  {
   value: "Coseley (GBYXL)",
   label: "Coseley (GBYXL)"
  },
  {
   value: "Cosham (GBCOS)",
   label: "Cosham (GBCOS)"
  },
  {
   value: "Cotterstock (GBCTT)",
   label: "Cotterstock (GBCTT)"
  },
  {
   value: "Cottingham (GBCXT)",
   label: "Cottingham (GBCXT)"
  },
  {
   value: "Coulport (GBCOU)",
   label: "Coulport (GBCOU)"
  },
  {
   value: "Coulsdon (GBCSD)",
   label: "Coulsdon (GBCSD)"
  },
  {
   value: "Coventry (GBCVT)",
   label: "Coventry (GBCVT)"
  },
  {
   value: "Coverack (GBCOV)",
   label: "Coverack (GBCOV)"
  },
  {
   value: "Cowbridge (GBCDG)",
   label: "Cowbridge (GBCDG)"
  },
  {
   value: "Cowden (GBCWD)",
   label: "Cowden (GBCWD)"
  },
  {
   value: "Cowdenbeath (GBCOH)",
   label: "Cowdenbeath (GBCOH)"
  },
  {
   value: "Cowes (GBCOW)",
   label: "Cowes (GBCOW)"
  },
  {
   value: "Cowley (GBCEY)",
   label: "Cowley (GBCEY)"
  },
  {
   value: "Cradley (GBCDY)",
   label: "Cradley (GBCDY)"
  },
  {
   value: "Cradley Heath (GBCRH)",
   label: "Cradley Heath (GBCRH)"
  },
  {
   value: "Craigavon (GBCRG)",
   label: "Craigavon (GBCRG)"
  },
  {
   value: "Craignure (GBCNU)",
   label: "Craignure (GBCNU)"
  },
  {
   value: "Cramlington (GBCMT)",
   label: "Cramlington (GBCMT)"
  },
  {
   value: "Cranbourne (GBCRU)",
   label: "Cranbourne (GBCRU)"
  },
  {
   value: "Cranbrook (GBCBK)",
   label: "Cranbrook (GBCBK)"
  },
  {
   value: "Cranfield (GBCRF)",
   label: "Cranfield (GBCRF)"
  },
  {
   value: "Cranleigh (GBCGH)",
   label: "Cranleigh (GBCGH)"
  },
  {
   value: "Crawley (GBCWY)",
   label: "Crawley (GBCWY)"
  },
  {
   value: "Crayford (GBCRY)",
   label: "Crayford (GBCRY)"
  },
  {
   value: "Crays Hill (GBCYL)",
   label: "Crays Hill (GBCYL)"
  },
  {
   value: "Cressing (GBCSS)",
   label: "Cressing (GBCSS)"
  },
  {
   value: "Crewe (GBCRE)",
   label: "Crewe (GBCRE)"
  },
  {
   value: "Crewkerne (GBCRK)",
   label: "Crewkerne (GBCRK)"
  },
  {
   value: "Crick (GBCRI)",
   label: "Crick (GBCRI)"
  },
  {
   value: "Cricklade (GBCKE)",
   label: "Cricklade (GBCKE)"
  },
  {
   value: "Croft (GBCRL)",
   label: "Croft (GBCRL)"
  },
  {
   value: "Cromarty (GBCRN)",
   label: "Cromarty (GBCRN)"
  },
  {
   value: "Crook (GBCOK)",
   label: "Crook (GBCOK)"
  },
  {
   value: "Crosby (GBCRB)",
   label: "Crosby (GBCRB)"
  },
  {
   value: "Cross Keys (GBCSK)",
   label: "Cross Keys (GBCSK)"
  },
  {
   value: "Crowborough (GBCWB)",
   label: "Crowborough (GBCWB)"
  },
  {
   value: "Crowthorne (GBCWT)",
   label: "Crowthorne (GBCWT)"
  },
  {
   value: "Croydon (GBCRO)",
   label: "Croydon (GBCRO)"
  },
  {
   value: "Crumlin (GBCML)",
   label: "Crumlin (GBCML)"
  },
  {
   value: "Clipstone (GBCPS)",
   label: "Clipstone (GBCPS)"
  },
  {
   value: "Clitheroe (GBCLI)",
   label: "Clitheroe (GBCLI)"
  },
  {
   value: "Clydach (GBCLH)",
   label: "Clydach (GBCLH)"
  },
  {
   value: "Clydebank (GBCLY)",
   label: "Clydebank (GBCLY)"
  },
  {
   value: "Clydeport (GBCYP)",
   label: "Clydeport (GBCYP)"
  },
  {
   value: "Coalville (GBCOA)",
   label: "Coalville (GBCOA)"
  },
  {
   value: "Coatbridge (GBCOT)",
   label: "Coatbridge (GBCOT)"
  },
  {
   value: "Cobham (GBCOB)",
   label: "Cobham (GBCOB)"
  },
  {
   value: "Cobham (GBCBH)",
   label: "Cobham (GBCBH)"
  },
  {
   value: "Cockenzie (GBCNZ)",
   label: "Cockenzie (GBCNZ)"
  },
  {
   value: "Cockermouth (GBCKM)",
   label: "Cockermouth (GBCKM)"
  },
  {
   value: "Cockfosters (GBCCF)",
   label: "Cockfosters (GBCCF)"
  },
  {
   value: "Cogenhoe (GBCGN)",
   label: "Cogenhoe (GBCGN)"
  },
  {
   value: "Coggeshall (GBCOG)",
   label: "Coggeshall (GBCOG)"
  },
  {
   value: "Colborne (GBCLB)",
   label: "Colborne (GBCLB)"
  },
  {
   value: "Colchester (GBCOL)",
   label: "Colchester (GBCOL)"
  },
  {
   value: "Coleford (GBCED)",
   label: "Coleford (GBCED)"
  },
  {
   value: "Coleford (GBCOF)",
   label: "Coleford (GBCOF)"
  },
  {
   value: "Coleorton (GBOET)",
   label: "Coleorton (GBOET)"
  },
  {
   value: "Coleraine (GBCLR)",
   label: "Coleraine (GBCLR)"
  },
  {
   value: "Colerne (GBCEN)",
   label: "Colerne (GBCEN)"
  },
  {
   value: "Coleshill (GBCLL)",
   label: "Coleshill (GBCLL)"
  },
  {
   value: "Coleville (GBCLV)",
   label: "Coleville (GBCLV)"
  },
  {
   value: "Colnbrook (GBCBR)",
   label: "Colnbrook (GBCBR)"
  },
  {
   value: "Colne (GBCLN)",
   label: "Colne (GBCLN)"
  },
  {
   value: "Colonsay Is (GBCSA)",
   label: "Colonsay Is (GBCSA)"
  },
  {
   value: "Coltishall (GBCTA)",
   label: "Coltishall (GBCTA)"
  },
  {
   value: "Colwich (GBCLW)",
   label: "Colwich (GBCLW)"
  },
  {
   value: "Colwyn Bay (GBCYY)",
   label: "Colwyn Bay (GBCYY)"
  },
  {
   value: "Congleton (GBCON)",
   label: "Congleton (GBCON)"
  },
  {
   value: "Coningsby (GBCNG)",
   label: "Coningsby (GBCNG)"
  },
  {
   value: "Coniston (GBCIS)",
   label: "Coniston (GBCIS)"
  },
  {
   value: "Connah's Quay (GBCOQ)",
   label: "Connah's Quay (GBCOQ)"
  },
  {
   value: "Consett (GBCNT)",
   label: "Consett (GBCNT)"
  },
  {
   value: "Conway (GBCWA)",
   label: "Conway (GBCWA)"
  },
  {
   value: "Cookham (GBCKH)",
   label: "Cookham (GBCKH)"
  },
  {
   value: "Cookley (GBCKL)",
   label: "Cookley (GBCKL)"
  },
  {
   value: "Cookstown (GBCOO)",
   label: "Cookstown (GBCOO)"
  },
  {
   value: "Corby (GBCBY)",
   label: "Corby (GBCBY)"
  },
  {
   value: "Cornwell (GBCNW)",
   label: "Cornwell (GBCNW)"
  },
  {
   value: "Corpach (GBCOR)",
   label: "Corpach (GBCOR)"
  },
  {
   value: "Chessington (GBCGS)",
   label: "Chessington (GBCGS)"
  },
  {
   value: "Chester (GBCEG)",
   label: "Chester (GBCEG)"
  },
  {
   value: "Chester-Le-Street (GBCTE)",
   label: "Chester-Le-Street (GBCTE)"
  },
  {
   value: "Chesterfield (GBCES)",
   label: "Chesterfield (GBCES)"
  },
  {
   value: "Chesterton (GBCER)",
   label: "Chesterton (GBCER)"
  },
  {
   value: "Chichester (GBCST)",
   label: "Chichester (GBCST)"
  },
  {
   value: "Chigwell (GBCHI)",
   label: "Chigwell (GBCHI)"
  },
  {
   value: "Chilmark (GBCIL)",
   label: "Chilmark (GBCIL)"
  },
  {
   value: "Chilwell (GBCWE)",
   label: "Chilwell (GBCWE)"
  },
  {
   value: "Chinley (GBCNY)",
   label: "Chinley (GBCNY)"
  },
  {
   value: "Chippenham (GBCPN)",
   label: "Chippenham (GBCPN)"
  },
  {
   value: "Chipping Campden (GBCCN)",
   label: "Chipping Campden (GBCCN)"
  },
  {
   value: "Chipping Norton (GBCHP)",
   label: "Chipping Norton (GBCHP)"
  },
  {
   value: "Chipping Ongar (GBYET)",
   label: "Chipping Ongar (GBYET)"
  },
  {
   value: "Chirk (GBCIK)",
   label: "Chirk (GBCIK)"
  },
  {
   value: "Chirnside (GBCND)",
   label: "Chirnside (GBCND)"
  },
  {
   value: "Chislehurst (GBCSL)",
   label: "Chislehurst (GBCSL)"
  },
  {
   value: "Chiswick (GBCHK)",
   label: "Chiswick (GBCHK)"
  },
  {
   value: "Chobham (GBCHB)",
   label: "Chobham (GBCHB)"
  },
  {
   value: "Cholsey (GBCHL)",
   label: "Cholsey (GBCHL)"
  },
  {
   value: "Chorley (GBCHR)",
   label: "Chorley (GBCHR)"
  },
  {
   value: "Chorleywood (GBCHW)",
   label: "Chorleywood (GBCHW)"
  },
  {
   value: "Christchurch (GBCCH)",
   label: "Christchurch (GBCCH)"
  },
  {
   value: "Chudleigh (GBCHU)",
   label: "Chudleigh (GBCHU)"
  },
  {
   value: "Church (GBCRC)",
   label: "Church (GBCRC)"
  },
  {
   value: "Church Stretton (GBYUR)",
   label: "Church Stretton (GBYUR)"
  },
  {
   value: "Cirencester (GBCIR)",
   label: "Cirencester (GBCIR)"
  },
  {
   value: "Clackmannan (GBCLA)",
   label: "Clackmannan (GBCLA)"
  },
  {
   value: "Clacton-On-Sea (GBCLS)",
   label: "Clacton-On-Sea (GBCLS)"
  },
  {
   value: "Clapham (GBCLP)",
   label: "Clapham (GBCLP)"
  },
  {
   value: "Clay Cross (GBCLC)",
   label: "Clay Cross (GBCLC)"
  },
  {
   value: "Claygate (GBCGD)",
   label: "Claygate (GBCGD)"
  },
  {
   value: "Clayton-le-Moors (GBCEM)",
   label: "Clayton-le-Moors (GBCEM)"
  },
  {
   value: "Cleator (GBCLE)",
   label: "Cleator (GBCLE)"
  },
  {
   value: "Cleckheaton (GBCCK)",
   label: "Cleckheaton (GBCCK)"
  },
  {
   value: "Cleethorpes (GBCTH)",
   label: "Cleethorpes (GBCTH)"
  },
  {
   value: "Cleland (GBCEA)",
   label: "Cleland (GBCEA)"
  },
  {
   value: "Clevedon (GBQZL)",
   label: "Clevedon (GBQZL)"
  },
  {
   value: "Cliffe (GBCLF)",
   label: "Cliffe (GBCLF)"
  },
  {
   value: "Clipstone (GBCPT)",
   label: "Clipstone (GBCPT)"
  },
  {
   value: "Castlecary (GBCCY)",
   label: "Castlecary (GBCCY)"
  },
  {
   value: "Castleford (GBCTF)",
   label: "Castleford (GBCTF)"
  },
  {
   value: "Caterham (GBCTR)",
   label: "Caterham (GBCTR)"
  },
  {
   value: "Catfield (GBCTL)",
   label: "Catfield (GBCTL)"
  },
  {
   value: "Catrine (GBCAT)",
   label: "Catrine (GBCAT)"
  },
  {
   value: "Cawston (GBCWS)",
   label: "Cawston (GBCWS)"
  },
  {
   value: "Chadderton (GBCDD)",
   label: "Chadderton (GBCDD)"
  },
  {
   value: "Chadwell Heath (GBCDW)",
   label: "Chadwell Heath (GBCDW)"
  },
  {
   value: "Chadwell St Mary (GBCDE)",
   label: "Chadwell St Mary (GBCDE)"
  },
  {
   value: "Chale (GBCHQ)",
   label: "Chale (GBCHQ)"
  },
  {
   value: "Chalfont St Giles (GBCSG)",
   label: "Chalfont St Giles (GBCSG)"
  },
  {
   value: "Chalfont St Peter (GBCSP)",
   label: "Chalfont St Peter (GBCSP)"
  },
  {
   value: "Chalgrove (GBCGV)",
   label: "Chalgrove (GBCGV)"
  },
  {
   value: "Chandlers Ford (GBCFO)",
   label: "Chandlers Ford (GBCFO)"
  },
  {
   value: "Chapel en le Frith (GBCPL)",
   label: "Chapel en le Frith (GBCPL)"
  },
  {
   value: "Chard (GBCZT)",
   label: "Chard (GBCZT)"
  },
  {
   value: "Charing (GBCHG)",
   label: "Charing (GBCHG)"
  },
  {
   value: "Charleston (GBCHD)",
   label: "Charleston (GBCHD)"
  },
  {
   value: "Charlestown (GBCHF)",
   label: "Charlestown (GBCHF)"
  },
  {
   value: "Charlton (GBCHN)",
   label: "Charlton (GBCHN)"
  },
  {
   value: "Charnock Richard (GBCNR)",
   label: "Charnock Richard (GBCNR)"
  },
  {
   value: "Chartham (GBCHM)",
   label: "Chartham (GBCHM)"
  },
  {
   value: "Chasetown (GBCHS)",
   label: "Chasetown (GBCHS)"
  },
  {
   value: "Chatham (GBCTM)",
   label: "Chatham (GBCTM)"
  },
  {
   value: "Cheadle (GBCHA)",
   label: "Cheadle (GBCHA)"
  },
  {
   value: "Cheadle (GBCDL)",
   label: "Cheadle (GBCDL)"
  },
  {
   value: "Cheadle Hulme (GBCDH)",
   label: "Cheadle Hulme (GBCDH)"
  },
  {
   value: "Cheam (GBCME)",
   label: "Cheam (GBCME)"
  },
  {
   value: "Checkendon (GBCHC)",
   label: "Checkendon (GBCHC)"
  },
  {
   value: "Cheddar (GBCDA)",
   label: "Cheddar (GBCDA)"
  },
  {
   value: "Cheetham Hill (GBCEE)",
   label: "Cheetham Hill (GBCEE)"
  },
  {
   value: "Chelford (GBCHZ)",
   label: "Chelford (GBCHZ)"
  },
  {
   value: "Chelmsford (GBCFD)",
   label: "Chelmsford (GBCFD)"
  },
  {
   value: "Cheltenham (GBCLT)",
   label: "Cheltenham (GBCLT)"
  },
  {
   value: "Chelveston (GBCHV)",
   label: "Chelveston (GBCHV)"
  },
  {
   value: "Chepstow (GBCHT)",
   label: "Chepstow (GBCHT)"
  },
  {
   value: "Cherry Hinton (GBCYH)",
   label: "Cherry Hinton (GBCYH)"
  },
  {
   value: "Chertsey (GBHEY)",
   label: "Chertsey (GBHEY)"
  },
  {
   value: "Chesham (GBCSH)",
   label: "Chesham (GBCSH)"
  },
  {
   value: "Cheshunt (GBCHH)",
   label: "Cheshunt (GBCHH)"
  },
  {
   value: "Bury St Edmunds (GBBSE)",
   label: "Bury St Edmunds (GBBSE)"
  },
  {
   value: "Bushey Heath (GBBYE)",
   label: "Bushey Heath (GBBYE)"
  },
  {
   value: "Buxton (GBBUX)",
   label: "Buxton (GBBUX)"
  },
  {
   value: "Byfleet (GBBYF)",
   label: "Byfleet (GBBYF)"
  },
  {
   value: "Caernarvon (GBCNV)",
   label: "Caernarvon (GBCNV)"
  },
  {
   value: "Caerphilly (GBCAE)",
   label: "Caerphilly (GBCAE)"
  },
  {
   value: "Caerwent (GBCRW)",
   label: "Caerwent (GBCRW)"
  },
  {
   value: "Caerwys (GBCYS)",
   label: "Caerwys (GBCYS)"
  },
  {
   value: "Cairnryan (GBCYN)",
   label: "Cairnryan (GBCYN)"
  },
  {
   value: "Calcot (GBCCT)",
   label: "Calcot (GBCCT)"
  },
  {
   value: "Caldicot (GBCDT)",
   label: "Caldicot (GBCDT)"
  },
  {
   value: "Callington (GBCNN)",
   label: "Callington (GBCNN)"
  },
  {
   value: "Calne (GBCNE)",
   label: "Calne (GBCNE)"
  },
  {
   value: "Camberley (GBCAY)",
   label: "Camberley (GBCAY)"
  },
  {
   value: "Camborne (GBCMB)",
   label: "Camborne (GBCMB)"
  },
  {
   value: "Cambridge (GBCMG)",
   label: "Cambridge (GBCMG)"
  },
  {
   value: "Cambus (GBCAM)",
   label: "Cambus (GBCAM)"
  },
  {
   value: "Cambuslang (GBCBU)",
   label: "Cambuslang (GBCBU)"
  },
  {
   value: "Campbeltown (GBCBT)",
   label: "Campbeltown (GBCBT)"
  },
  {
   value: "Cannock (GBCNK)",
   label: "Cannock (GBCNK)"
  },
  {
   value: "Canterbury (GBCNB)",
   label: "Canterbury (GBCNB)"
  },
  {
   value: "Cantley (GBCNL)",
   label: "Cantley (GBCNL)"
  },
  {
   value: "Canvey Island (GBCAN)",
   label: "Canvey Island (GBCAN)"
  },
  {
   value: "Cardiff (GBCDF)",
   label: "Cardiff (GBCDF)"
  },
  {
   value: "Cardigan (GBCAR)",
   label: "Cardigan (GBCAR)"
  },
  {
   value: "Carlisle (GBCAX)",
   label: "Carlisle (GBCAX)"
  },
  {
   value: "Carlton (GBCAO)",
   label: "Carlton (GBCAO)"
  },
  {
   value: "Carluke (GBCAK)",
   label: "Carluke (GBCAK)"
  },
  {
   value: "Carmarthen (GBCMR)",
   label: "Carmarthen (GBCMR)"
  },
  {
   value: "Carnforth (GBCNF)",
   label: "Carnforth (GBCNF)"
  },
  {
   value: "Carnoustie (GBCNS)",
   label: "Carnoustie (GBCNS)"
  },
  {
   value: "Carrickfergus (GBCFG)",
   label: "Carrickfergus (GBCFG)"
  },
  {
   value: "Carrington (GBCRT)",
   label: "Carrington (GBCRT)"
  },
  {
   value: "Carshalton (GBCTO)",
   label: "Carshalton (GBCTO)"
  },
  {
   value: "Carston (GBCSN)",
   label: "Carston (GBCSN)"
  },
  {
   value: "Castle Bromwich (GBCSB)",
   label: "Castle Bromwich (GBCSB)"
  },
  {
   value: "Castle Cary (GBCAC)",
   label: "Castle Cary (GBCAC)"
  },
  {
   value: "Castle Donington (GBCAD)",
   label: "Castle Donington (GBCAD)"
  },
  {
   value: "Castle Douglas (GBCTD)",
   label: "Castle Douglas (GBCTD)"
  },
  {
   value: "Castlebay (GBCBA)",
   label: "Castlebay (GBCBA)"
  },
  {
   value: "Broxbourne (GBBXN)",
   label: "Broxbourne (GBBXN)"
  },
  {
   value: "Broxburn (GBBXU)",
   label: "Broxburn (GBBXU)"
  },
  {
   value: "Bruton (GBQMV)",
   label: "Bruton (GBQMV)"
  },
  {
   value: "Bryn (GBBRY)",
   label: "Bryn (GBBRY)"
  },
  {
   value: "Brynmawr (GBBRR)",
   label: "Brynmawr (GBBRR)"
  },
  {
   value: "Brynna (GBBNA)",
   label: "Brynna (GBBNA)"
  },
  {
   value: "Buckden (GBBKD)",
   label: "Buckden (GBBKD)"
  },
  {
   value: "Buckhaven (GBBHV)",
   label: "Buckhaven (GBBHV)"
  },
  {
   value: "Buckhurst Hill (GBBHH)",
   label: "Buckhurst Hill (GBBHH)"
  },
  {
   value: "Buckie (GBBUC)",
   label: "Buckie (GBBUC)"
  },
  {
   value: "Buckingham (GBBUK)",
   label: "Buckingham (GBBUK)"
  },
  {
   value: "Buckley (GBBCL)",
   label: "Buckley (GBBCL)"
  },
  {
   value: "Bude (GBBUD)",
   label: "Bude (GBBUD)"
  },
  {
   value: "Budleigh Salterton (GBBUA)",
   label: "Budleigh Salterton (GBBUA)"
  },
  {
   value: "Bugbrooke (GBBUB)",
   label: "Bugbrooke (GBBUB)"
  },
  {
   value: "Builth Wells (GBBUI)",
   label: "Builth Wells (GBBUI)"
  },
  {
   value: "Bungay (GBBUG)",
   label: "Bungay (GBBUG)"
  },
  {
   value: "Bures (GBBEU)",
   label: "Bures (GBBEU)"
  },
  {
   value: "Burgess Hill (GBBUL)",
   label: "Burgess Hill (GBBUL)"
  },
  {
   value: "Burghead (GBBUH)",
   label: "Burghead (GBBUH)"
  },
  {
   value: "Burley (GBBUZ)",
   label: "Burley (GBBUZ)"
  },
  {
   value: "Burnham (GBBUM)",
   label: "Burnham (GBBUM)"
  },
  {
   value: "Burnham Green (GBBGR)",
   label: "Burnham Green (GBBGR)"
  },
  {
   value: "Burnham On Crouch (GBBOC)",
   label: "Burnham On Crouch (GBBOC)"
  },
  {
   value: "Burnham-on-Sea (GBBMA)",
   label: "Burnham-on-Sea (GBBMA)"
  },
  {
   value: "Burnley (GBBRN)",
   label: "Burnley (GBBRN)"
  },
  {
   value: "Burntisland (GBBTL)",
   label: "Burntisland (GBBTL)"
  },
  {
   value: "Burntwood (GBBUW)",
   label: "Burntwood (GBBUW)"
  },
  {
   value: "Burpham (GBBPM)",
   label: "Burpham (GBBPM)"
  },
  {
   value: "Burrelton (GBBEO)",
   label: "Burrelton (GBBEO)"
  },
  {
   value: "Burrow (GBBWR)",
   label: "Burrow (GBBWR)"
  },
  {
   value: "Burscough (GBBGH)",
   label: "Burscough (GBBGH)"
  },
  {
   value: "Bursledon (GBBUE)",
   label: "Bursledon (GBBUE)"
  },
  {
   value: "Burslem (GBBEM)",
   label: "Burslem (GBBEM)"
  },
  {
   value: "Burton (GBBTD)",
   label: "Burton (GBBTD)"
  },
  {
   value: "Burton (GBBUN)",
   label: "Burton (GBBUN)"
  },
  {
   value: "Burton upon Stather (GBBUS)",
   label: "Burton upon Stather (GBBUS)"
  },
  {
   value: "Burton upon Trent (GBBTR)",
   label: "Burton upon Trent (GBBTR)"
  },
  {
   value: "Burtonwood (GBBNW)",
   label: "Burtonwood (GBBNW)"
  },
  {
   value: "Burwell (GBBXR)",
   label: "Burwell (GBBXR)"
  },
  {
   value: "Bury (GBBUY)",
   label: "Bury (GBBUY)"
  },
  {
   value: "Brenchley (GBBRZ)",
   label: "Brenchley (GBBRZ)"
  },
  {
   value: "Brentford (GBBFD)",
   label: "Brentford (GBBFD)"
  },
  {
   value: "Brentwood (GBBWD)",
   label: "Brentwood (GBBWD)"
  },
  {
   value: "Bridge of Allan (GBBGA)",
   label: "Bridge of Allan (GBBGA)"
  },
  {
   value: "Bridge of Weir (GBBWI)",
   label: "Bridge of Weir (GBBWI)"
  },
  {
   value: "Bridgend (GBBRG)",
   label: "Bridgend (GBBRG)"
  },
  {
   value: "Bridgend (GBBRD)",
   label: "Bridgend (GBBRD)"
  },
  {
   value: "Bridgend (GBBGD)",
   label: "Bridgend (GBBGD)"
  },
  {
   value: "Bridgnorth (GBBNT)",
   label: "Bridgnorth (GBBNT)"
  },
  {
   value: "Bridgtown (GBBIG)",
   label: "Bridgtown (GBBIG)"
  },
  {
   value: "Bridgwater (GBBRW)",
   label: "Bridgwater (GBBRW)"
  },
  {
   value: "Bridlington (GBBRT)",
   label: "Bridlington (GBBRT)"
  },
  {
   value: "Bridport (GBBRP)",
   label: "Bridport (GBBRP)"
  },
  {
   value: "Brierley Hill (GBRIH)",
   label: "Brierley Hill (GBRIH)"
  },
  {
   value: "Brigg (GBBGG)",
   label: "Brigg (GBBGG)"
  },
  {
   value: "Brighouse (GBBRH)",
   label: "Brighouse (GBBRH)"
  },
  {
   value: "Brightlingsea (GBBLS)",
   label: "Brightlingsea (GBBLS)"
  },
  {
   value: "Brighton (GBBSH)",
   label: "Brighton (GBBSH)"
  },
  {
   value: "Brinkworth (GBBWW)",
   label: "Brinkworth (GBBWW)"
  },
  {
   value: "Brislington (GBBSG)",
   label: "Brislington (GBBSG)"
  },
  {
   value: "Bristol (GBBRS)",
   label: "Bristol (GBBRS)"
  },
  {
   value: "Briton Ferry (GBBFY)",
   label: "Briton Ferry (GBBFY)"
  },
  {
   value: "Brixham (GBBRX)",
   label: "Brixham (GBBRX)"
  },
  {
   value: "Brixworth (GBBIX)",
   label: "Brixworth (GBBIX)"
  },
  {
   value: "Brize Norton (GBBZZ)",
   label: "Brize Norton (GBBZZ)"
  },
  {
   value: "Broadheath (GBBRO)",
   label: "Broadheath (GBBRO)"
  },
  {
   value: "Broadstairs (GBBDT)",
   label: "Broadstairs (GBBDT)"
  },
  {
   value: "Brockenhurst (GBBKT)",
   label: "Brockenhurst (GBBKT)"
  },
  {
   value: "Brockworth (GBBKR)",
   label: "Brockworth (GBBKR)"
  },
  {
   value: "Brodick (GBBDI)",
   label: "Brodick (GBBDI)"
  },
  {
   value: "Bromborough (GBBHK)",
   label: "Bromborough (GBBHK)"
  },
  {
   value: "Bromley (GBBEY)",
   label: "Bromley (GBBEY)"
  },
  {
   value: "Brompton (GBBMP)",
   label: "Brompton (GBBMP)"
  },
  {
   value: "Bromsgrove (GBBGV)",
   label: "Bromsgrove (GBBGV)"
  },
  {
   value: "Bromyard (GBBYD)",
   label: "Bromyard (GBBYD)"
  },
  {
   value: "Brookmans Park (GBBKP)",
   label: "Brookmans Park (GBBKP)"
  },
  {
   value: "Broseley (GBBQY)",
   label: "Broseley (GBBQY)"
  },
  {
   value: "Broughton (GBBZT)",
   label: "Broughton (GBBZT)"
  },
  {
   value: "Broughton Astley (GBBTA)",
   label: "Broughton Astley (GBBTA)"
  },
  {
   value: "Brownhills (GBBWS)",
   label: "Brownhills (GBBWS)"
  },
  {
   value: "Bonnybridge (GBBNY)",
   label: "Bonnybridge (GBBNY)"
  },
  {
   value: "Bonnyrigg (GBBOG)",
   label: "Bonnyrigg (GBBOG)"
  },
  {
   value: "Bootle (GBBOE)",
   label: "Bootle (GBBOE)"
  },
  {
   value: "Borden (GBBOR)",
   label: "Borden (GBBOR)"
  },
  {
   value: "Bordon Camp (GBBDC)",
   label: "Bordon Camp (GBBDC)"
  },
  {
   value: "Borehamwood (GBBMD)",
   label: "Borehamwood (GBBMD)"
  },
  {
   value: "Borough Green (GBBGN)",
   label: "Borough Green (GBBGN)"
  },
  {
   value: "Boroughbridge (GBBBR)",
   label: "Boroughbridge (GBBBR)"
  },
  {
   value: "Boscombe (GBBOD)",
   label: "Boscombe (GBBOD)"
  },
  {
   value: "Bosley (GBBSL)",
   label: "Bosley (GBBSL)"
  },
  {
   value: "Boston (GBBOS)",
   label: "Boston (GBBOS)"
  },
  {
   value: "Bothwell (GBBWL)",
   label: "Bothwell (GBBWL)"
  },
  {
   value: "Botley (GBBTY)",
   label: "Botley (GBBTY)"
  },
  {
   value: "Botley (GBBOY)",
   label: "Botley (GBBOY)"
  },
  {
   value: "Botley (GBBOL)",
   label: "Botley (GBBOL)"
  },
  {
   value: "Bourne (GBBUR)",
   label: "Bourne (GBBUR)"
  },
  {
   value: "Bourne End (GBYEB)",
   label: "Bourne End (GBYEB)"
  },
  {
   value: "Bournemouth (GBBOH)",
   label: "Bournemouth (GBBOH)"
  },
  {
   value: "Bourton-On-The-Water (GBBOU)",
   label: "Bourton-On-The-Water (GBBOU)"
  },
  {
   value: "Bovey Tracey (GBBVT)",
   label: "Bovey Tracey (GBBVT)"
  },
  {
   value: "Bovingdon (GBBVD)",
   label: "Bovingdon (GBBVD)"
  },
  {
   value: "Bowden (GBBWE)",
   label: "Bowden (GBBWE)"
  },
  {
   value: "Bowling (GBBOW)",
   label: "Bowling (GBBOW)"
  },
  {
   value: "Boxted (GBBXD)",
   label: "Boxted (GBBXD)"
  },
  {
   value: "Brackley (GBBCK)",
   label: "Brackley (GBBCK)"
  },
  {
   value: "Bracknell (GBBKN)",
   label: "Bracknell (GBBKN)"
  },
  {
   value: "Bradford (GBBRF)",
   label: "Bradford (GBBRF)"
  },
  {
   value: "Braefoot Bay (GBBFB)",
   label: "Braefoot Bay (GBBFB)"
  },
  {
   value: "Braehead (GBBRE)",
   label: "Braehead (GBBRE)"
  },
  {
   value: "Braintree (GBBRI)",
   label: "Braintree (GBBRI)"
  },
  {
   value: "Bramfield (GBBFH)",
   label: "Bramfield (GBBFH)"
  },
  {
   value: "Bramhall (GBBHL)",
   label: "Bramhall (GBBHL)"
  },
  {
   value: "Bramhope (GBBMH)",
   label: "Bramhope (GBBMH)"
  },
  {
   value: "Bramley (GBBMY)",
   label: "Bramley (GBBMY)"
  },
  {
   value: "Bran End (GBBNE)",
   label: "Bran End (GBBNE)"
  },
  {
   value: "Brandon (GBBRA)",
   label: "Brandon (GBBRA)"
  },
  {
   value: "Bransgore (GBBSR)",
   label: "Bransgore (GBBSR)"
  },
  {
   value: "Brantham (GBBRM)",
   label: "Brantham (GBBRM)"
  },
  {
   value: "Braunton (GBBNN)",
   label: "Braunton (GBBNN)"
  },
  {
   value: "Brawdy (GBBDY)",
   label: "Brawdy (GBBDY)"
  },
  {
   value: "Brechin (GBBRC)",
   label: "Brechin (GBBRC)"
  },
  {
   value: "Binfield (GBBFI)",
   label: "Binfield (GBBFI)"
  },
  {
   value: "Bingham (GBBAM)",
   label: "Bingham (GBBAM)"
  },
  {
   value: "Bingley (GBBGY)",
   label: "Bingley (GBBGY)"
  },
  {
   value: "Binley (GBBNL)",
   label: "Binley (GBBNL)"
  },
  {
   value: "Bircotes (GBBTS)",
   label: "Bircotes (GBBTS)"
  },
  {
   value: "Birkenhead (GBBRK)",
   label: "Birkenhead (GBBRK)"
  },
  {
   value: "Birmingham (GBBHM)",
   label: "Birmingham (GBBHM)"
  },
  {
   value: "Birstal (GBBIT)",
   label: "Birstal (GBBIT)"
  },
  {
   value: "Birtley (GBBIR)",
   label: "Birtley (GBBIR)"
  },
  {
   value: "Bishop Auckland (GBBIP)",
   label: "Bishop Auckland (GBBIP)"
  },
  {
   value: "Bishop's Stortford (GBBST)",
   label: "Bishop's Stortford (GBBST)"
  },
  {
   value: "Bishop's Waltham (GBBPW)",
   label: "Bishop's Waltham (GBBPW)"
  },
  {
   value: "Bishopbriggs (GBBSP)",
   label: "Bishopbriggs (GBBSP)"
  },
  {
   value: "Bishopsworth (GBBSW)",
   label: "Bishopsworth (GBBSW)"
  },
  {
   value: "Black Pill (GBBPL)",
   label: "Black Pill (GBBPL)"
  },
  {
   value: "Blackburn (GBBLB)",
   label: "Blackburn (GBBLB)"
  },
  {
   value: "Blackbush (GBBBS)",
   label: "Blackbush (GBBBS)"
  },
  {
   value: "Blackford (GBBLA)",
   label: "Blackford (GBBLA)"
  },
  {
   value: "Blackpool (GBBLK)",
   label: "Blackpool (GBBLK)"
  },
  {
   value: "Blackwood (GBBLW)",
   label: "Blackwood (GBBLW)"
  },
  {
   value: "Blaenavon (GBBVN)",
   label: "Blaenavon (GBBVN)"
  },
  {
   value: "Blaina (GBYKJ)",
   label: "Blaina (GBYKJ)"
  },
  {
   value: "Blairgowrie (GBZLD)",
   label: "Blairgowrie (GBZLD)"
  },
  {
   value: "Blandford Forum (GBBLF)",
   label: "Blandford Forum (GBBLF)"
  },
  {
   value: "Blantyre (GBBYR)",
   label: "Blantyre (GBBYR)"
  },
  {
   value: "Blaydon (GBBLD)",
   label: "Blaydon (GBBLD)"
  },
  {
   value: "Bletchingley (GBBLN)",
   label: "Bletchingley (GBBLN)"
  },
  {
   value: "Bletchley (GBBLE)",
   label: "Bletchley (GBBLE)"
  },
  {
   value: "Blockley (GBBKY)",
   label: "Blockley (GBBKY)"
  },
  {
   value: "Bloxwich (GBBLX)",
   label: "Bloxwich (GBBLX)"
  },
  {
   value: "Blyth (GBBLY)",
   label: "Blyth (GBBLY)"
  },
  {
   value: "Blythe Bridge (GBBYB)",
   label: "Blythe Bridge (GBBYB)"
  },
  {
   value: "Bo'ness (GBBON)",
   label: "Bo'ness (GBBON)"
  },
  {
   value: "Bodmin (GBBDM)",
   label: "Bodmin (GBBDM)"
  },
  {
   value: "Bognor Regis (GBBSI)",
   label: "Bognor Regis (GBBSI)"
  },
  {
   value: "Boldon (GBBDN)",
   label: "Boldon (GBBDN)"
  },
  {
   value: "Bollington (GBBOI)",
   label: "Bollington (GBBOI)"
  },
  {
   value: "Bolsover (GBBSO)",
   label: "Bolsover (GBBSO)"
  },
  {
   value: "Bolton (GBBLT)",
   label: "Bolton (GBBLT)"
  },
  {
   value: "Bolton Le Sands (GBBNS)",
   label: "Bolton Le Sands (GBBNS)"
  },
  {
   value: "Beckton (GBBCT)",
   label: "Beckton (GBBCT)"
  },
  {
   value: "Bedale (GBBDL)",
   label: "Bedale (GBBDL)"
  },
  {
   value: "Beddington (GBBDD)",
   label: "Beddington (GBBDD)"
  },
  {
   value: "Bedfont (GBBED)",
   label: "Bedfont (GBBED)"
  },
  {
   value: "Bedford (GBBEF)",
   label: "Bedford (GBBEF)"
  },
  {
   value: "Bedlington (GBBTN)",
   label: "Bedlington (GBBTN)"
  },
  {
   value: "Bedwas (GBBDW)",
   label: "Bedwas (GBBDW)"
  },
  {
   value: "Bedworth (GBBWO)",
   label: "Bedworth (GBBWO)"
  },
  {
   value: "Beeston (GBBEE)",
   label: "Beeston (GBBEE)"
  },
  {
   value: "Befont (GBBFT)",
   label: "Befont (GBBFT)"
  },
  {
   value: "Beith (GBBEI)",
   label: "Beith (GBBEI)"
  },
  {
   value: "Belfast (GBBEL)",
   label: "Belfast (GBBEL)"
  },
  {
   value: "Bellshill (GBBLL)",
   label: "Bellshill (GBBLL)"
  },
  {
   value: "Belper (GBBLP)",
   label: "Belper (GBBLP)"
  },
  {
   value: "Belvedere (GBBLV)",
   label: "Belvedere (GBBLV)"
  },
  {
   value: "Bembridge (GBBBP)",
   label: "Bembridge (GBBBP)"
  },
  {
   value: "Benbecula (GBBBC)",
   label: "Benbecula (GBBBC)"
  },
  {
   value: "Benfield (GBBNF)",
   label: "Benfield (GBBNF)"
  },
  {
   value: "Benson (GBBES)",
   label: "Benson (GBBES)"
  },
  {
   value: "Bentwaters (GBBEN)",
   label: "Bentwaters (GBBEN)"
  },
  {
   value: "Berkhamsted (GBBKH)",
   label: "Berkhamsted (GBBKH)"
  },
  {
   value: "Berriedale (GBERR)",
   label: "Berriedale (GBERR)"
  },
  {
   value: "Berry Head (GBBEH)",
   label: "Berry Head (GBBEH)"
  },
  {
   value: "Berwick Upon Tweed (GBBWK)",
   label: "Berwick Upon Tweed (GBBWK)"
  },
  {
   value: "Betchworth (GBBTW)",
   label: "Betchworth (GBBTW)"
  },
  {
   value: "Bethesda (GBBET)",
   label: "Bethesda (GBBET)"
  },
  {
   value: "Beverley (GBBEV)",
   label: "Beverley (GBBEV)"
  },
  {
   value: "Bexhill-On-Sea (GBBXB)",
   label: "Bexhill-On-Sea (GBBXB)"
  },
  {
   value: "Bexley (GBBEX)",
   label: "Bexley (GBBEX)"
  },
  {
   value: "Bicester (GBBIC)",
   label: "Bicester (GBBIC)"
  },
  {
   value: "Bickley (GBBKL)",
   label: "Bickley (GBBKL)"
  },
  {
   value: "Biddulph (GBBDU)",
   label: "Biddulph (GBBDU)"
  },
  {
   value: "Bideford (GBBID)",
   label: "Bideford (GBBID)"
  },
  {
   value: "Bidford (GBBAV)",
   label: "Bidford (GBBAV)"
  },
  {
   value: "Biggin Hill (GBBQH)",
   label: "Biggin Hill (GBBQH)"
  },
  {
   value: "Biggleswade (GBBIW)",
   label: "Biggleswade (GBBIW)"
  },
  {
   value: "Bilborough (GBBBH)",
   label: "Bilborough (GBBBH)"
  },
  {
   value: "Billericay (GBBIL)",
   label: "Billericay (GBBIL)"
  },
  {
   value: "Billingham (GBBHW)",
   label: "Billingham (GBBHW)"
  },
  {
   value: "Billingshurst (GBBGT)",
   label: "Billingshurst (GBBGT)"
  },
  {
   value: "Bilston (GBBIS)",
   label: "Bilston (GBBIS)"
  },
  {
   value: "Barnstaple (GBBND)",
   label: "Barnstaple (GBBND)"
  },
  {
   value: "Barra \/ BALA (GBBAA)",
   label: "Barra \/ BALA (GBBAA)"
  },
  {
   value: "Barrhead (GBBAH)",
   label: "Barrhead (GBBAH)"
  },
  {
   value: "Barrow In Furness (GBBIF)",
   label: "Barrow In Furness (GBBIF)"
  },
  {
   value: "Barrow-upon-Humber (GBBHR)",
   label: "Barrow-upon-Humber (GBBHR)"
  },
  {
   value: "Barrowford (GBBAF)",
   label: "Barrowford (GBBAF)"
  },
  {
   value: "Barry Dock (GBBAD)",
   label: "Barry Dock (GBBAD)"
  },
  {
   value: "Bartestree (GBBJT)",
   label: "Bartestree (GBBJT)"
  },
  {
   value: "Bartley (GBQRA)",
   label: "Bartley (GBQRA)"
  },
  {
   value: "Barton (GBBNM)",
   label: "Barton (GBBNM)"
  },
  {
   value: "Barton in the Clay (GBBCY)",
   label: "Barton in the Clay (GBBCY)"
  },
  {
   value: "Barton On Humber (GBBNH)",
   label: "Barton On Humber (GBBNH)"
  },
  {
   value: "Barton Stacey (GBBTC)",
   label: "Barton Stacey (GBBTC)"
  },
  {
   value: "Barwell (GBBRL)",
   label: "Barwell (GBBRL)"
  },
  {
   value: "Bascote (GBBAO)",
   label: "Bascote (GBBAO)"
  },
  {
   value: "Basildon (GBBAS)",
   label: "Basildon (GBBAS)"
  },
  {
   value: "Basingstoke (GBBGK)",
   label: "Basingstoke (GBBGK)"
  },
  {
   value: "Bassingfield (GBBSF)",
   label: "Bassingfield (GBBSF)"
  },
  {
   value: "Bath (GBBTM)",
   label: "Bath (GBBTM)"
  },
  {
   value: "Bathford (GBBTF)",
   label: "Bathford (GBBTF)"
  },
  {
   value: "Bathgate (GBBTH)",
   label: "Bathgate (GBBTH)"
  },
  {
   value: "Batley (GBBAY)",
   label: "Batley (GBBAY)"
  },
  {
   value: "Battersea (GBBTT)",
   label: "Battersea (GBBTT)"
  },
  {
   value: "Battle (GBBTE)",
   label: "Battle (GBBTE)"
  },
  {
   value: "Battlesbridge (GBBAT)",
   label: "Battlesbridge (GBBAT)"
  },
  {
   value: "Baulking (GBBAU)",
   label: "Baulking (GBBAU)"
  },
  {
   value: "Bawtry (GBBWT)",
   label: "Bawtry (GBBWT)"
  },
  {
   value: "Baxter Health (GBBXH)",
   label: "Baxter Health (GBBXH)"
  },
  {
   value: "Beaconsfield (GBBEA)",
   label: "Beaconsfield (GBBEA)"
  },
  {
   value: "Beaminster (GBBMN)",
   label: "Beaminster (GBBMN)"
  },
  {
   value: "Bearsden (GBBSD)",
   label: "Bearsden (GBBSD)"
  },
  {
   value: "Beaulieu (GBBLU)",
   label: "Beaulieu (GBBLU)"
  },
  {
   value: "Beaumaris (GBBMR)",
   label: "Beaumaris (GBBMR)"
  },
  {
   value: "Bebington (GBBEB)",
   label: "Bebington (GBBEB)"
  },
  {
   value: "Beccles (GBBCC)",
   label: "Beccles (GBBCC)"
  },
  {
   value: "Beckenfield (GBBEK)",
   label: "Beckenfield (GBBEK)"
  },
  {
   value: "Beckenham (GBBKM)",
   label: "Beckenham (GBBKM)"
  },
  {
   value: "Beckhampton (GBBHP)",
   label: "Beckhampton (GBBHP)"
  },
  {
   value: "Beckingham (GBBEC)",
   label: "Beckingham (GBBEC)"
  },
  {
   value: "Aveley (GBAVE)",
   label: "Aveley (GBAVE)"
  },
  {
   value: "Avonmouth (GBAVO)",
   label: "Avonmouth (GBAVO)"
  },
  {
   value: "Axminster (GBAXM)",
   label: "Axminster (GBAXM)"
  },
  {
   value: "Aycliffe (GBAYF)",
   label: "Aycliffe (GBAYF)"
  },
  {
   value: "Aylesbury (GBAYL)",
   label: "Aylesbury (GBAYL)"
  },
  {
   value: "Aylesford (GBAYS)",
   label: "Aylesford (GBAYS)"
  },
  {
   value: "Aylesham (GBAYE)",
   label: "Aylesham (GBAYE)"
  },
  {
   value: "Aylsham (GBAYH)",
   label: "Aylsham (GBAYH)"
  },
  {
   value: "Ayr (GBAYR)",
   label: "Ayr (GBAYR)"
  },
  {
   value: "Bacup (GBBAP)",
   label: "Bacup (GBBAP)"
  },
  {
   value: "Baginton (GBBAG)",
   label: "Baginton (GBBAG)"
  },
  {
   value: "Bagshot (GBBGS)",
   label: "Bagshot (GBBGS)"
  },
  {
   value: "Baildon (GBBAI)",
   label: "Baildon (GBBAI)"
  },
  {
   value: "Bakewell (GBBKW)",
   label: "Bakewell (GBBKW)"
  },
  {
   value: "Baldock (GBBAL)",
   label: "Baldock (GBBAL)"
  },
  {
   value: "Bally Kelly (GBBKO)",
   label: "Bally Kelly (GBBKO)"
  },
  {
   value: "Ballycastle (GBBYC)",
   label: "Ballycastle (GBBYC)"
  },
  {
   value: "Ballyclare (GBBAE)",
   label: "Ballyclare (GBBAE)"
  },
  {
   value: "Ballygowan (GBBGW)",
   label: "Ballygowan (GBBGW)"
  },
  {
   value: "Ballygown (GBBLG)",
   label: "Ballygown (GBBLG)"
  },
  {
   value: "Ballymena (GBBYM)",
   label: "Ballymena (GBBYM)"
  },
  {
   value: "Ballymoney (GBBLM)",
   label: "Ballymoney (GBBLM)"
  },
  {
   value: "Balsall Common (GBBAC)",
   label: "Balsall Common (GBBAC)"
  },
  {
   value: "Baltasound (GBBSN)",
   label: "Baltasound (GBBSN)"
  },
  {
   value: "Baltic Wharf (GBBAW)",
   label: "Baltic Wharf (GBBAW)"
  },
  {
   value: "Bamberbridge (GBBMB)",
   label: "Bamberbridge (GBBMB)"
  },
  {
   value: "Banbridge (GBBBG)",
   label: "Banbridge (GBBBG)"
  },
  {
   value: "Banbury (GBBAB)",
   label: "Banbury (GBBAB)"
  },
  {
   value: "Banchory (GBBNC)",
   label: "Banchory (GBBNC)"
  },
  {
   value: "Banchory Devenick (GBBDK)",
   label: "Banchory Devenick (GBBDK)"
  },
  {
   value: "Banff (GBBFF)",
   label: "Banff (GBBFF)"
  },
  {
   value: "Bangor (GBBNG)",
   label: "Bangor (GBBNG)"
  },
  {
   value: "Bangor (GBBAN)",
   label: "Bangor (GBBAN)"
  },
  {
   value: "Banstead (GBBSA)",
   label: "Banstead (GBBSA)"
  },
  {
   value: "Bargoed (GBBGO)",
   label: "Bargoed (GBBGO)"
  },
  {
   value: "Barking (GBBKG)",
   label: "Barking (GBBKG)"
  },
  {
   value: "Barnard Castle (GBBCA)",
   label: "Barnard Castle (GBBCA)"
  },
  {
   value: "Barnes (GBBAR)",
   label: "Barnes (GBBAR)"
  },
  {
   value: "Barnet (GBBHS)",
   label: "Barnet (GBBHS)"
  },
  {
   value: "Barnoldswick (GBBAK)",
   label: "Barnoldswick (GBBAK)"
  },
  {
   value: "Barnsley (GBBSY)",
   label: "Barnsley (GBBSY)"
  },
  {
   value: "Annan (GBANN)",
   label: "Annan (GBANN)"
  },
  {
   value: "Annesley Woodhouse (GBANW)",
   label: "Annesley Woodhouse (GBANW)"
  },
  {
   value: "Antrim (GBANT)",
   label: "Antrim (GBANT)"
  },
  {
   value: "Appledore (GBAPP)",
   label: "Appledore (GBAPP)"
  },
  {
   value: "Appleton (GBAPL)",
   label: "Appleton (GBAPL)"
  },
  {
   value: "Appley Bridge (GBABR)",
   label: "Appley Bridge (GBABR)"
  },
  {
   value: "Arbroath (GBARB)",
   label: "Arbroath (GBARB)"
  },
  {
   value: "Ardersier (GBARS)",
   label: "Ardersier (GBARS)"
  },
  {
   value: "Ardrishaig (GBASG)",
   label: "Ardrishaig (GBASG)"
  },
  {
   value: "Ardrossan (GBARD)",
   label: "Ardrossan (GBARD)"
  },
  {
   value: "Arley (GBAEY)",
   label: "Arley (GBAEY)"
  },
  {
   value: "Armadale (GBARE)",
   label: "Armadale (GBARE)"
  },
  {
   value: "Armagh (GBARM)",
   label: "Armagh (GBARM)"
  },
  {
   value: "Armitage (GBARI)",
   label: "Armitage (GBARI)"
  },
  {
   value: "Arnesby (GBARN)",
   label: "Arnesby (GBARN)"
  },
  {
   value: "Arnold (GBARO)",
   label: "Arnold (GBARO)"
  },
  {
   value: "Arrington (GBARR)",
   label: "Arrington (GBARR)"
  },
  {
   value: "Artigarvan (GBART)",
   label: "Artigarvan (GBART)"
  },
  {
   value: "Arundel (GBARU)",
   label: "Arundel (GBARU)"
  },
  {
   value: "Ascot (GBASC)",
   label: "Ascot (GBASC)"
  },
  {
   value: "Ash (GBAQO)",
   label: "Ash (GBAQO)"
  },
  {
   value: "Ashbourne (GBASH)",
   label: "Ashbourne (GBASH)"
  },
  {
   value: "Ashby-de-la-Zouch (GBADZ)",
   label: "Ashby-de-la-Zouch (GBADZ)"
  },
  {
   value: "Ashford (GBASF)",
   label: "Ashford (GBASF)"
  },
  {
   value: "Ashford (GBASD)",
   label: "Ashford (GBASD)"
  },
  {
   value: "Ashington (GBAST)",
   label: "Ashington (GBAST)"
  },
  {
   value: "Ashton In Makerfield (GBASM)",
   label: "Ashton In Makerfield (GBASM)"
  },
  {
   value: "Ashton Under Lyne (GBASL)",
   label: "Ashton Under Lyne (GBASL)"
  },
  {
   value: "Ashwell (GBASW)",
   label: "Ashwell (GBASW)"
  },
  {
   value: "Aston (GBASN)",
   label: "Aston (GBASN)"
  },
  {
   value: "Aston (GBASO)",
   label: "Aston (GBASO)"
  },
  {
   value: "Aston Clinton (GBATN)",
   label: "Aston Clinton (GBATN)"
  },
  {
   value: "Aston Somerville (GBASV)",
   label: "Aston Somerville (GBASV)"
  },
  {
   value: "Atherstone (GBATH)",
   label: "Atherstone (GBATH)"
  },
  {
   value: "Atherton (GBATR)",
   label: "Atherton (GBATR)"
  },
  {
   value: "Attenborough (GBATT)",
   label: "Attenborough (GBATT)"
  },
  {
   value: "Attleborough (GBAWL)",
   label: "Attleborough (GBAWL)"
  },
  {
   value: "Auchterarder (GBACH)",
   label: "Auchterarder (GBACH)"
  },
  {
   value: "Audenshaw (GBAUD)",
   label: "Audenshaw (GBAUD)"
  },
  {
   value: "Aughnacloy (GBAKV)",
   label: "Aughnacloy (GBAKV)"
  },
  {
   value: "Ackworth (GBACK)",
   label: "Ackworth (GBACK)"
  },
  {
   value: "Acton (GBACN)",
   label: "Acton (GBACN)"
  },
  {
   value: "Acton Grange (GBACT)",
   label: "Acton Grange (GBACT)"
  },
  {
   value: "Adderbury (GBADY)",
   label: "Adderbury (GBADY)"
  },
  {
   value: "Addingham (GBADD)",
   label: "Addingham (GBADD)"
  },
  {
   value: "Addington (GBADI)",
   label: "Addington (GBADI)"
  },
  {
   value: "Addlestone (GBADN)",
   label: "Addlestone (GBADN)"
  },
  {
   value: "Adlington (GBADL)",
   label: "Adlington (GBADL)"
  },
  {
   value: "Ailsworth (GBAWR)",
   label: "Ailsworth (GBAWR)"
  },
  {
   value: "Aintree (GBAIN)",
   label: "Aintree (GBAIN)"
  },
  {
   value: "Airdrie (GBAIR)",
   label: "Airdrie (GBAIR)"
  },
  {
   value: "Alcester (GBACS)",
   label: "Alcester (GBACS)"
  },
  {
   value: "Alconbury (GBALY)",
   label: "Alconbury (GBALY)"
  },
  {
   value: "Aldbourne (GBADB)",
   label: "Aldbourne (GBADB)"
  },
  {
   value: "Aldeburgh (GBALB)",
   label: "Aldeburgh (GBALB)"
  },
  {
   value: "Alderley Edge (GBALE)",
   label: "Alderley Edge (GBALE)"
  },
  {
   value: "Aldermaston (GBALR)",
   label: "Aldermaston (GBALR)"
  },
  {
   value: "Alderney (GBACI)",
   label: "Alderney (GBACI)"
  },
  {
   value: "Aldershot (GBALD)",
   label: "Aldershot (GBALD)"
  },
  {
   value: "Aldridge (GBADG)",
   label: "Aldridge (GBADG)"
  },
  {
   value: "Alexandria (GBALX)",
   label: "Alexandria (GBALX)"
  },
  {
   value: "Alfreton (GBALF)",
   label: "Alfreton (GBALF)"
  },
  {
   value: "Allestree (GBASE)",
   label: "Allestree (GBASE)"
  },
  {
   value: "Alloa (GBALL)",
   label: "Alloa (GBALL)"
  },
  {
   value: "Alnmouth (GBALM)",
   label: "Alnmouth (GBALM)"
  },
  {
   value: "Alnwick (GBALW)",
   label: "Alnwick (GBALW)"
  },
  {
   value: "Alsager (GBALG)",
   label: "Alsager (GBALG)"
  },
  {
   value: "Alston (GBALS)",
   label: "Alston (GBALS)"
  },
  {
   value: "Alton (GBALN)",
   label: "Alton (GBALN)"
  },
  {
   value: "Altrincham (GBACM)",
   label: "Altrincham (GBACM)"
  },
  {
   value: "Alva (GBALA)",
   label: "Alva (GBALA)"
  },
  {
   value: "Alveley (GBAVL)",
   label: "Alveley (GBAVL)"
  },
  {
   value: "Alveston (GBALV)",
   label: "Alveston (GBALV)"
  },
  {
   value: "Ambergate (GBAMG)",
   label: "Ambergate (GBAMG)"
  },
  {
   value: "Amble (GBAMB)",
   label: "Amble (GBAMB)"
  },
  {
   value: "Ambleside (GBAML)",
   label: "Ambleside (GBAML)"
  },
  {
   value: "Amersham (GBAME)",
   label: "Amersham (GBAME)"
  },
  {
   value: "Amesbury (GBAMS)",
   label: "Amesbury (GBAMS)"
  },
  {
   value: "Amlwch (GBAMW)",
   label: "Amlwch (GBAMW)"
  },
  {
   value: "Ammanford (GBAMM)",
   label: "Ammanford (GBAMM)"
  },
  {
   value: "Andover (GBAVR)",
   label: "Andover (GBAVR)"
  },
  {
   value: "Ekuata (GAEKU)",
   label: "Ekuata (GAEKU)"
  },
  {
   value: "Fougamou (GAFOU)",
   label: "Fougamou (GAFOU)"
  },
  {
   value: "Franceville (GAMVB)",
   label: "Franceville (GAMVB)"
  },
  {
   value: "Gamba (GAGAX)",
   label: "Gamba (GAGAX)"
  },
  {
   value: "Koulamoutou (GAKOU)",
   label: "Koulamoutou (GAKOU)"
  },
  {
   value: "Lambarene (GALBQ)",
   label: "Lambarene (GALBQ)"
  },
  {
   value: "Lastourville (GALTL)",
   label: "Lastourville (GALTL)"
  },
  {
   value: "Libreville (GALBV)",
   label: "Libreville (GALBV)"
  },
  {
   value: "Lucina (GALUC)",
   label: "Lucina (GALUC)"
  },
  {
   value: "M'bya Terminal (GAMBY)",
   label: "M'bya Terminal (GAMBY)"
  },
  {
   value: "Makokou (GAMKU)",
   label: "Makokou (GAMKU)"
  },
  {
   value: "Manega (GAMGO)",
   label: "Manega (GAMGO)"
  },
  {
   value: "Mayoumba (GAMYB)",
   label: "Mayoumba (GAMYB)"
  },
  {
   value: "Mbigou (GAMBC)",
   label: "Mbigou (GAMBC)"
  },
  {
   value: "Medouneu (GAMDV)",
   label: "Medouneu (GAMDV)"
  },
  {
   value: "Mekambo (GAMKB)",
   label: "Mekambo (GAMKB)"
  },
  {
   value: "Mitzic (GAMZC)",
   label: "Mitzic (GAMZC)"
  },
  {
   value: "Moanda (GAMFF)",
   label: "Moanda (GAMFF)"
  },
  {
   value: "Mouila (GAMJL)",
   label: "Mouila (GAMJL)"
  },
  {
   value: "N'djole (GAKDJ)",
   label: "N'djole (GAKDJ)"
  },
  {
   value: "Ndende (GAKDN)",
   label: "Ndende (GAKDN)"
  },
  {
   value: "Nyanga (GANYA)",
   label: "Nyanga (GANYA)"
  },
  {
   value: "Okondja (GAOKN)",
   label: "Okondja (GAOKN)"
  },
  {
   value: "Omboue (GAOMB)",
   label: "Omboue (GAOMB)"
  },
  {
   value: "Owendo (GAOWE)",
   label: "Owendo (GAOWE)"
  },
  {
   value: "Oyem (GAOYE)",
   label: "Oyem (GAOYE)"
  },
  {
   value: "Port Gentil (GAPOG)",
   label: "Port Gentil (GAPOG)"
  },
  {
   value: "Tchibanga (GATCH)",
   label: "Tchibanga (GATCH)"
  },
  {
   value: "Abbots Langley (GBABB)",
   label: "Abbots Langley (GBABB)"
  },
  {
   value: "Aberaeron (GBABA)",
   label: "Aberaeron (GBABA)"
  },
  {
   value: "Aberdare (GBABE)",
   label: "Aberdare (GBABE)"
  },
  {
   value: "Aberdeen (GBABD)",
   label: "Aberdeen (GBABD)"
  },
  {
   value: "Aberdour (GBAYD)",
   label: "Aberdour (GBAYD)"
  },
  {
   value: "Abergavenny (GBAGY)",
   label: "Abergavenny (GBAGY)"
  },
  {
   value: "Abertillery (GBABT)",
   label: "Abertillery (GBABT)"
  },
  {
   value: "Aberystwyth (GBAYW)",
   label: "Aberystwyth (GBAYW)"
  },
  {
   value: "Abingdon (GBAGN)",
   label: "Abingdon (GBAGN)"
  },
  {
   value: "Abington (GBABN)",
   label: "Abington (GBABN)"
  },
  {
   value: "Aboyne (GBABY)",
   label: "Aboyne (GBABY)"
  },
  {
   value: "Abridge (GBABG)",
   label: "Abridge (GBABG)"
  },
  {
   value: "Accrington (GBACR)",
   label: "Accrington (GBACR)"
  },
  {
   value: "Woippy (FRWOI)",
   label: "Woippy (FRWOI)"
  },
  {
   value: "Xertigny (FRXTG)",
   label: "Xertigny (FRXTG)"
  },
  {
   value: "Yenne (FRYNN)",
   label: "Yenne (FRYNN)"
  },
  {
   value: "Yerres (FRYRR)",
   label: "Yerres (FRYRR)"
  },
  {
   value: "Yffiniac (FRYFF)",
   label: "Yffiniac (FRYFF)"
  },
  {
   value: "Yutz (FRYLZ)",
   label: "Yutz (FRYLZ)"
  },
  {
   value: "Yvetot (FRYVT)",
   label: "Yvetot (FRYVT)"
  },
  {
   value: "Yzeure (FRYZR)",
   label: "Yzeure (FRYZR)"
  },
  {
   value: "Zinswiller (FRZWL)",
   label: "Zinswiller (FRZWL)"
  },
  {
   value: "Ambert (FRAMR)",
   label: "Ambert (FRAMR)"
  },
  {
   value: "Attignat (FRATT)",
   label: "Attignat (FRATT)"
  },
  {
   value: "Belley (FRBLX)",
   label: "Belley (FRBLX)"
  },
  {
   value: "Bricquebec (FRBQC)",
   label: "Bricquebec (FRBQC)"
  },
  {
   value: "Canly (FRCNL)",
   label: "Canly (FRCNL)"
  },
  {
   value: "Carrieres sous Poissy (FRCSP)",
   label: "Carrieres sous Poissy (FRCSP)"
  },
  {
   value: "Chasse-sur-Rhône (FRCRH)",
   label: "Chasse-sur-Rhône (FRCRH)"
  },
  {
   value: "Chateau Thierry (FRCTH)",
   label: "Chateau Thierry (FRCTH)"
  },
  {
   value: "Corps-Nuds (FRCND)",
   label: "Corps-Nuds (FRCND)"
  },
  {
   value: "Coulogne (FRCUL)",
   label: "Coulogne (FRCUL)"
  },
  {
   value: "Deville (FRDVL)",
   label: "Deville (FRDVL)"
  },
  {
   value: "Fléville-devant-Nancy (FRFDN)",
   label: "Fléville-devant-Nancy (FRFDN)"
  },
  {
   value: "La Ferte Bernard (FRLFB)",
   label: "La Ferte Bernard (FRLFB)"
  },
  {
   value: "La Monnerie le Montel (FRLMM)",
   label: "La Monnerie le Montel (FRLMM)"
  },
  {
   value: "La Ville-Aux-Dames (FRVAD)",
   label: "La Ville-Aux-Dames (FRVAD)"
  },
  {
   value: "Ladon (FRLDO)",
   label: "Ladon (FRLDO)"
  },
  {
   value: "Lencloitre (FRLCI)",
   label: "Lencloitre (FRLCI)"
  },
  {
   value: "Lespinasse (FRLPI)",
   label: "Lespinasse (FRLPI)"
  },
  {
   value: "Marsannay-la-Côte (FRNAY)",
   label: "Marsannay-la-Côte (FRNAY)"
  },
  {
   value: "Monnet-la-Ville (FRMVL)",
   label: "Monnet-la-Ville (FRMVL)"
  },
  {
   value: "Montigny en Gohelle (FRMGE)",
   label: "Montigny en Gohelle (FRMGE)"
  },
  {
   value: "Mortree (FRMRR)",
   label: "Mortree (FRMRR)"
  },
  {
   value: "Neufmaison (FRNFN)",
   label: "Neufmaison (FRNFN)"
  },
  {
   value: "Oissel (FROIL)",
   label: "Oissel (FROIL)"
  },
  {
   value: "Olonne-sur-Mer (FROSM)",
   label: "Olonne-sur-Mer (FROSM)"
  },
  {
   value: "Pont-du-Château (FRPCU)",
   label: "Pont-du-Château (FRPCU)"
  },
  {
   value: "Rai (FRRAX)",
   label: "Rai (FRRAX)"
  },
  {
   value: "St Germain de Lusignan (FRSGG)",
   label: "St Germain de Lusignan (FRSGG)"
  },
  {
   value: "Akieni (GAAKE)",
   label: "Akieni (GAAKE)"
  },
  {
   value: "Bitam (GABMM)",
   label: "Bitam (GABMM)"
  },
  {
   value: "Booue (GABGB)",
   label: "Booue (GABGB)"
  },
  {
   value: "Cap Lopez (GACLZ)",
   label: "Cap Lopez (GACLZ)"
  },
  {
   value: "Cocobeach (GACCB)",
   label: "Cocobeach (GACCB)"
  },
  {
   value: "Villepinte (FRVIL)",
   label: "Villepinte (FRVIL)"
  },
  {
   value: "Villers Cotterets (FRVCT)",
   label: "Villers Cotterets (FRVCT)"
  },
  {
   value: "Villers Ecalles (FRVCL)",
   label: "Villers Ecalles (FRVCL)"
  },
  {
   value: "Villerupt (FRVLP)",
   label: "Villerupt (FRVLP)"
  },
  {
   value: "Villetaneuse (FRVTE)",
   label: "Villetaneuse (FRVTE)"
  },
  {
   value: "Villeurbanne (FRVBN)",
   label: "Villeurbanne (FRVBN)"
  },
  {
   value: "Villiers (FRVLS)",
   label: "Villiers (FRVLS)"
  },
  {
   value: "Villiers St Sepulcre (FRVIS)",
   label: "Villiers St Sepulcre (FRVIS)"
  },
  {
   value: "Vinay (FRVNY)",
   label: "Vinay (FRVNY)"
  },
  {
   value: "Vincennes (FRVCN)",
   label: "Vincennes (FRVCN)"
  },
  {
   value: "Vincey (FRVIY)",
   label: "Vincey (FRVIY)"
  },
  {
   value: "Violes (FRVOS)",
   label: "Violes (FRVOS)"
  },
  {
   value: "Viotte\/Besancon (FRVIO)",
   label: "Viotte\/Besancon (FRVIO)"
  },
  {
   value: "Viré (FRVRE)",
   label: "Viré (FRVRE)"
  },
  {
   value: "Viriat (FRVRT)",
   label: "Viriat (FRVRT)"
  },
  {
   value: "Viry Chatillon (FRVYC)",
   label: "Viry Chatillon (FRVYC)"
  },
  {
   value: "Vitre (FRVIR)",
   label: "Vitre (FRVIR)"
  },
  {
   value: "Vitrolles (FRVIT)",
   label: "Vitrolles (FRVIT)"
  },
  {
   value: "Vitry le Francoise (FRVTS)",
   label: "Vitry le Francoise (FRVTS)"
  },
  {
   value: "Vitry sur Seine (FRVTY)",
   label: "Vitry sur Seine (FRVTY)"
  },
  {
   value: "Vittel (FRVTL)",
   label: "Vittel (FRVTL)"
  },
  {
   value: "Viviers (FRVIV)",
   label: "Viviers (FRVIV)"
  },
  {
   value: "Viviez (FRVVZ)",
   label: "Viviez (FRVVZ)"
  },
  {
   value: "Vivonne (FRVVF)",
   label: "Vivonne (FRVVF)"
  },
  {
   value: "Vizille (FRVIZ)",
   label: "Vizille (FRVIZ)"
  },
  {
   value: "Voiron (FRVOI)",
   label: "Voiron (FRVOI)"
  },
  {
   value: "Volvic (FRVOV)",
   label: "Volvic (FRVOV)"
  },
  {
   value: "Voreppe (FRVOR)",
   label: "Voreppe (FRVOR)"
  },
  {
   value: "Wargnies le Grand (FRWLG)",
   label: "Wargnies le Grand (FRWLG)"
  },
  {
   value: "Wasquehal (FRWSQ)",
   label: "Wasquehal (FRWSQ)"
  },
  {
   value: "Wasselonne (FRWAS)",
   label: "Wasselonne (FRWAS)"
  },
  {
   value: "Wattrelos (FRWAT)",
   label: "Wattrelos (FRWAT)"
  },
  {
   value: "Wendin Le Viel (FRWEN)",
   label: "Wendin Le Viel (FRWEN)"
  },
  {
   value: "Wervicq (FRWVQ)",
   label: "Wervicq (FRWVQ)"
  },
  {
   value: "Wimille (FRWIM)",
   label: "Wimille (FRWIM)"
  },
  {
   value: "Wisches (FRWIS)",
   label: "Wisches (FRWIS)"
  },
  {
   value: "Wissembourg (FRWMB)",
   label: "Wissembourg (FRWMB)"
  },
  {
   value: "Wissous (FRWSS)",
   label: "Wissous (FRWSS)"
  },
  {
   value: "Wizernes (FRWZN)",
   label: "Wizernes (FRWZN)"
  },
  {
   value: "Vendome (FRVND)",
   label: "Vendome (FRVND)"
  },
  {
   value: "Venelles (FRVEN)",
   label: "Venelles (FRVEN)"
  },
  {
   value: "Vénissieux (FRVES)",
   label: "Vénissieux (FRVES)"
  },
  {
   value: "Venizel (FRVZL)",
   label: "Venizel (FRVZL)"
  },
  {
   value: "Ventillon (FRVNL)",
   label: "Ventillon (FRVNL)"
  },
  {
   value: "Verberie (FRVBI)",
   label: "Verberie (FRVBI)"
  },
  {
   value: "Verdun (FRVRD)",
   label: "Verdun (FRVRD)"
  },
  {
   value: "Vergeze (FRVEZ)",
   label: "Vergeze (FRVEZ)"
  },
  {
   value: "Verneuil sur Avre (FRVSV)",
   label: "Verneuil sur Avre (FRVSV)"
  },
  {
   value: "Vernon (FRVRN)",
   label: "Vernon (FRVRN)"
  },
  {
   value: "Vernouillet (FRVET)",
   label: "Vernouillet (FRVET)"
  },
  {
   value: "Versailles (FRVER)",
   label: "Versailles (FRVER)"
  },
  {
   value: "Vesoul (FRVEL)",
   label: "Vesoul (FRVEL)"
  },
  {
   value: "Veyrines (FRVYR)",
   label: "Veyrines (FRVYR)"
  },
  {
   value: "Vic sur Aisne (FRVSU)",
   label: "Vic sur Aisne (FRVSU)"
  },
  {
   value: "Vichy (FRVHY)",
   label: "Vichy (FRVHY)"
  },
  {
   value: "Vienne (FRVIE)",
   label: "Vienne (FRVIE)"
  },
  {
   value: "Vierzon (FRVZN)",
   label: "Vierzon (FRVZN)"
  },
  {
   value: "Vif (FRVIF)",
   label: "Vif (FRVIF)"
  },
  {
   value: "Vigneux (FRVGX)",
   label: "Vigneux (FRVGX)"
  },
  {
   value: "Vigny (FRVYG)",
   label: "Vigny (FRVYG)"
  },
  {
   value: "Vigy (FRVGY)",
   label: "Vigy (FRVGY)"
  },
  {
   value: "Vilhonneur (FRVHR)",
   label: "Vilhonneur (FRVHR)"
  },
  {
   value: "Villebon sur Yvette (FRVSY)",
   label: "Villebon sur Yvette (FRVSY)"
  },
  {
   value: "Villefranche de Laurageais (FRVFE)",
   label: "Villefranche de Laurageais (FRVFE)"
  },
  {
   value: "Villefranche de Rouergue (FRVLL)",
   label: "Villefranche de Rouergue (FRVLL)"
  },
  {
   value: "Villefranche sur Saone (FRVSS)",
   label: "Villefranche sur Saone (FRVSS)"
  },
  {
   value: "Villejust (FRVJT)",
   label: "Villejust (FRVJT)"
  },
  {
   value: "Villemandeur (FRVUM)",
   label: "Villemandeur (FRVUM)"
  },
  {
   value: "Villeneuve (FRVLN)",
   label: "Villeneuve (FRVLN)"
  },
  {
   value: "Villeneuve d'Ascq (FRVVQ)",
   label: "Villeneuve d'Ascq (FRVVQ)"
  },
  {
   value: "Villeneuve la Garenne (FRVIM)",
   label: "Villeneuve la Garenne (FRVIM)"
  },
  {
   value: "Villeneuve les Maguelone (FRVVU)",
   label: "Villeneuve les Maguelone (FRVVU)"
  },
  {
   value: "Villeneuve Loubet (FRVVV)",
   label: "Villeneuve Loubet (FRVVV)"
  },
  {
   value: "Villeneuve St Georges (FRVSG)",
   label: "Villeneuve St Georges (FRVSG)"
  },
  {
   value: "Villeneuve sur Lot (FRVLX)",
   label: "Villeneuve sur Lot (FRVLX)"
  },
  {
   value: "Villeparisis (FRVPZ)",
   label: "Villeparisis (FRVPZ)"
  },
  {
   value: "Trigueres (FRTGS)",
   label: "Trigueres (FRTGS)"
  },
  {
   value: "Tronville en Barrois (FRTVB)",
   label: "Tronville en Barrois (FRTVB)"
  },
  {
   value: "Trouville (FRTJE)",
   label: "Trouville (FRTJE)"
  },
  {
   value: "Troyes (FRQYR)",
   label: "Troyes (FRQYR)"
  },
  {
   value: "Tullins (FRTUL)",
   label: "Tullins (FRTUL)"
  },
  {
   value: "Uckange (FRUCK)",
   label: "Uckange (FRUCK)"
  },
  {
   value: "Ugine (FRUGI)",
   label: "Ugine (FRUGI)"
  },
  {
   value: "Ungersheim (FRUGS)",
   label: "Ungersheim (FRUGS)"
  },
  {
   value: "Urimenil (FRURI)",
   label: "Urimenil (FRURI)"
  },
  {
   value: "Ury (FRURY)",
   label: "Ury (FRURY)"
  },
  {
   value: "Ussel (FRUSS)",
   label: "Ussel (FRUSS)"
  },
  {
   value: "Uxegney (FRUEY)",
   label: "Uxegney (FRUEY)"
  },
  {
   value: "Uzes (FRUZE)",
   label: "Uzes (FRUZE)"
  },
  {
   value: "Vaas (FRVAS)",
   label: "Vaas (FRVAS)"
  },
  {
   value: "Vaison la Romaine (FRVLR)",
   label: "Vaison la Romaine (FRVLR)"
  },
  {
   value: "Val d'Isère (FRVAZ)",
   label: "Val d'Isère (FRVAZ)"
  },
  {
   value: "Val de Saane (FRVDS)",
   label: "Val de Saane (FRVDS)"
  },
  {
   value: "Valence (FRVAF)",
   label: "Valence (FRVAF)"
  },
  {
   value: "Valenciennes (FRVAL)",
   label: "Valenciennes (FRVAL)"
  },
  {
   value: "Valflaunes (FRVLF)",
   label: "Valflaunes (FRVLF)"
  },
  {
   value: "Vallauris (FRVAU)",
   label: "Vallauris (FRVAU)"
  },
  {
   value: "Vallet (FRVLT)",
   label: "Vallet (FRVLT)"
  },
  {
   value: "Vandoeuvre les Nancy (FRVAN)",
   label: "Vandoeuvre les Nancy (FRVAN)"
  },
  {
   value: "Vannes (FRVNE)",
   label: "Vannes (FRVNE)"
  },
  {
   value: "Varages (FRVGS)",
   label: "Varages (FRVGS)"
  },
  {
   value: "Varangeville (FRVAR)",
   label: "Varangeville (FRVAR)"
  },
  {
   value: "Varces (FRVRC)",
   label: "Varces (FRVRC)"
  },
  {
   value: "Varennes sur Allier (FRVSA)",
   label: "Varennes sur Allier (FRVSA)"
  },
  {
   value: "Vatimont (FRVAT)",
   label: "Vatimont (FRVAT)"
  },
  {
   value: "Vaucresson (FRVUR)",
   label: "Vaucresson (FRVUR)"
  },
  {
   value: "Vaudreuille (FRVDL)",
   label: "Vaudreuille (FRVDL)"
  },
  {
   value: "Vaujours (FRVJR)",
   label: "Vaujours (FRVJR)"
  },
  {
   value: "Vaulx en Velin (FRVEV)",
   label: "Vaulx en Velin (FRVEV)"
  },
  {
   value: "Vayres (FRVYE)",
   label: "Vayres (FRVYE)"
  },
  {
   value: "Veauche (FRVEA)",
   label: "Veauche (FRVEA)"
  },
  {
   value: "Vecquemont (FRVEC)",
   label: "Vecquemont (FRVEC)"
  },
  {
   value: "Velaine en Haye (FRVLH)",
   label: "Velaine en Haye (FRVLH)"
  },
  {
   value: "Velines (FRVEI)",
   label: "Velines (FRVEI)"
  },
  {
   value: "Vélizy (FRVZY)",
   label: "Vélizy (FRVZY)"
  },
  {
   value: "Vendargues (FRVDA)",
   label: "Vendargues (FRVDA)"
  },
  {
   value: "Thiais (FRTHJ)",
   label: "Thiais (FRTHJ)"
  },
  {
   value: "Thiers (FRTRS)",
   label: "Thiers (FRTRS)"
  },
  {
   value: "Thionville (FRTVL)",
   label: "Thionville (FRTVL)"
  },
  {
   value: "Thoiry (FRTRY)",
   label: "Thoiry (FRTRY)"
  },
  {
   value: "Thonon (FRTHO)",
   label: "Thonon (FRTHO)"
  },
  {
   value: "Thonon-les-Vosges (FRTLV)",
   label: "Thonon-les-Vosges (FRTLV)"
  },
  {
   value: "Thouars (FRTHS)",
   label: "Thouars (FRTHS)"
  },
  {
   value: "Thourotte (FRTHE)",
   label: "Thourotte (FRTHE)"
  },
  {
   value: "Thuir (FRTHR)",
   label: "Thuir (FRTHR)"
  },
  {
   value: "Tignes (FRTGF)",
   label: "Tignes (FRTGF)"
  },
  {
   value: "Tignieu Jameyzieu (FRTGJ)",
   label: "Tignieu Jameyzieu (FRTGJ)"
  },
  {
   value: "Tille (FRTLL)",
   label: "Tille (FRTLL)"
  },
  {
   value: "Tillieres (FRTLR)",
   label: "Tillieres (FRTLR)"
  },
  {
   value: "Tillieres sur Avre (FRTLA)",
   label: "Tillieres sur Avre (FRTLA)"
  },
  {
   value: "Tonnay Charente (FRTON)",
   label: "Tonnay Charente (FRTON)"
  },
  {
   value: "Tonneins (FRTNE)",
   label: "Tonneins (FRTNE)"
  },
  {
   value: "Tonnerre (FRTNR)",
   label: "Tonnerre (FRTNR)"
  },
  {
   value: "Torcy (FRTOR)",
   label: "Torcy (FRTOR)"
  },
  {
   value: "Torigni-sur-Vire (FRTSV)",
   label: "Torigni-sur-Vire (FRTSV)"
  },
  {
   value: "Totes (FRTIL)",
   label: "Totes (FRTIL)"
  },
  {
   value: "Toul (FRTOU)",
   label: "Toul (FRTOU)"
  },
  {
   value: "Toulon (FRTLN)",
   label: "Toulon (FRTLN)"
  },
  {
   value: "Toulouges (FRTLG)",
   label: "Toulouges (FRTLG)"
  },
  {
   value: "Toulouse (FRTLS)",
   label: "Toulouse (FRTLS)"
  },
  {
   value: "Tourcoing (FRTOG)",
   label: "Tourcoing (FRTOG)"
  },
  {
   value: "Tourette sur loup (FRTSL)",
   label: "Tourette sur loup (FRTSL)"
  },
  {
   value: "Tournan-en-Brie (FRTEB)",
   label: "Tournan-en-Brie (FRTEB)"
  },
  {
   value: "Tournay (FRTOY)",
   label: "Tournay (FRTOY)"
  },
  {
   value: "Tournus (FRTRN)",
   label: "Tournus (FRTRN)"
  },
  {
   value: "Tours (FRTUF)",
   label: "Tours (FRTUF)"
  },
  {
   value: "Tours sur Marne (FRTSM)",
   label: "Tours sur Marne (FRTSM)"
  },
  {
   value: "Tourves (FRTRV)",
   label: "Tourves (FRTRV)"
  },
  {
   value: "Tourville Les Ifs (FRTLI)",
   label: "Tourville Les Ifs (FRTLI)"
  },
  {
   value: "Toussus Le Noble (FRTNF)",
   label: "Toussus Le Noble (FRTNF)"
  },
  {
   value: "Trappes (FRTRA)",
   label: "Trappes (FRTRA)"
  },
  {
   value: "Tregueux (FRTRG)",
   label: "Tregueux (FRTRG)"
  },
  {
   value: "Tréguier (FRTRE)",
   label: "Tréguier (FRTRE)"
  },
  {
   value: "Tremblay (FRTRM)",
   label: "Tremblay (FRTRM)"
  },
  {
   value: "Trept (FRTHP)",
   label: "Trept (FRTHP)"
  },
  {
   value: "Tresse (FRTES)",
   label: "Tresse (FRTES)"
  },
  {
   value: "St Sylvain d'Anjou (FRSYJ)",
   label: "St Sylvain d'Anjou (FRSYJ)"
  },
  {
   value: "St Sylvestre sur Lot (FRXZC)",
   label: "St Sylvestre sur Lot (FRXZC)"
  },
  {
   value: "St Symphorien sur Coise (FRSSU)",
   label: "St Symphorien sur Coise (FRSSU)"
  },
  {
   value: "St Tropez (FRSTP)",
   label: "St Tropez (FRSTP)"
  },
  {
   value: "St Uze (FRXUZ)",
   label: "St Uze (FRXUZ)"
  },
  {
   value: "St Valery sur Somme (FRSVS)",
   label: "St Valery sur Somme (FRSVS)"
  },
  {
   value: "St Victoret (FRSVC)",
   label: "St Victoret (FRSVC)"
  },
  {
   value: "St Vigor (FRYVV)",
   label: "St Vigor (FRYVV)"
  },
  {
   value: "St Wandrille (FRSWD)",
   label: "St Wandrille (FRSWD)"
  },
  {
   value: "St Yorre (FRSJA)",
   label: "St Yorre (FRSJA)"
  },
  {
   value: "Stains (FRZTZ)",
   label: "Stains (FRZTZ)"
  },
  {
   value: "Ste Foy la Grande (FRXFY)",
   label: "Ste Foy la Grande (FRXFY)"
  },
  {
   value: "Ste Foy les Lyon (FRZFO)",
   label: "Ste Foy les Lyon (FRZFO)"
  },
  {
   value: "Ste Livrade (FRZLX)",
   label: "Ste Livrade (FRZLX)"
  },
  {
   value: "Ste Maxime (FRZMX)",
   label: "Ste Maxime (FRZMX)"
  },
  {
   value: "Ste Sigolene (FRINH)",
   label: "Ste Sigolene (FRINH)"
  },
  {
   value: "Steenvorde (FRSTV)",
   label: "Steenvorde (FRSTV)"
  },
  {
   value: "Strasbourg (FRSXB)",
   label: "Strasbourg (FRSXB)"
  },
  {
   value: "Sucy en Brie (FRSUC)",
   label: "Sucy en Brie (FRSUC)"
  },
  {
   value: "Suippes (FRSUI)",
   label: "Suippes (FRSUI)"
  },
  {
   value: "Sully sur Loire (FRSUL)",
   label: "Sully sur Loire (FRSUL)"
  },
  {
   value: "Suresnes (FRSUN)",
   label: "Suresnes (FRSUN)"
  },
  {
   value: "Surgeres (FRSUG)",
   label: "Surgeres (FRSUG)"
  },
  {
   value: "Survilliers (FRSUR)",
   label: "Survilliers (FRSUR)"
  },
  {
   value: "Suze (FRSUZ)",
   label: "Suze (FRSUZ)"
  },
  {
   value: "Tain l'Hermitage (FRTNH)",
   label: "Tain l'Hermitage (FRTNH)"
  },
  {
   value: "Talence (FRTNC)",
   label: "Talence (FRTNC)"
  },
  {
   value: "Talloires (FRTAL)",
   label: "Talloires (FRTAL)"
  },
  {
   value: "Tarare (FRTRR)",
   label: "Tarare (FRTRR)"
  },
  {
   value: "Tarascon sur Ariege (FRTSA)",
   label: "Tarascon sur Ariege (FRTSA)"
  },
  {
   value: "Tarbes (FRTAB)",
   label: "Tarbes (FRTAB)"
  },
  {
   value: "Tarnos (FRTAR)",
   label: "Tarnos (FRTAR)"
  },
  {
   value: "Tartas (FRTTS)",
   label: "Tartas (FRTTS)"
  },
  {
   value: "Tavaux (FRTVX)",
   label: "Tavaux (FRTVX)"
  },
  {
   value: "Tenay (FRTNY)",
   label: "Tenay (FRTNY)"
  },
  {
   value: "Tergnier (FRTER)",
   label: "Tergnier (FRTER)"
  },
  {
   value: "Terrasson La Villedieu (FRTVD)",
   label: "Terrasson La Villedieu (FRTVD)"
  },
  {
   value: "Thann (FRTHA)",
   label: "Thann (FRTHA)"
  },
  {
   value: "Thaon les Vosges (FRTVO)",
   label: "Thaon les Vosges (FRTVO)"
  },
  {
   value: "St Memmie (FRSMM)",
   label: "St Memmie (FRSMM)"
  },
  {
   value: "St Menet (FRSEE)",
   label: "St Menet (FRSEE)"
  },
  {
   value: "St Menoux (FRSME)",
   label: "St Menoux (FRSME)"
  },
  {
   value: "St Michel (FRSMH)",
   label: "St Michel (FRSMH)"
  },
  {
   value: "St Mihiel (FRTML)",
   label: "St Mihiel (FRTML)"
  },
  {
   value: "St Nazaire (FRSNR)",
   label: "St Nazaire (FRSNR)"
  },
  {
   value: "St Nicolas d'Aliermont (FRSID)",
   label: "St Nicolas d'Aliermont (FRSID)"
  },
  {
   value: "St Omer (FRSTO)",
   label: "St Omer (FRSTO)"
  },
  {
   value: "St Ouen l'Aumone (FRSOL)",
   label: "St Ouen l'Aumone (FRSOL)"
  },
  {
   value: "St Ouen Marchefroy (FRSQM)",
   label: "St Ouen Marchefroy (FRSQM)"
  },
  {
   value: "St Paul De Varax (FRZPX)",
   label: "St Paul De Varax (FRZPX)"
  },
  {
   value: "St Paul Trois Chateau (FRZPU)",
   label: "St Paul Trois Chateau (FRZPU)"
  },
  {
   value: "St Pierre d'Entremont (FRSPR)",
   label: "St Pierre d'Entremont (FRSPR)"
  },
  {
   value: "St Pierre De Plesguen (FRPZP)",
   label: "St Pierre De Plesguen (FRPZP)"
  },
  {
   value: "St Pierre La Garenne (FRXPG)",
   label: "St Pierre La Garenne (FRXPG)"
  },
  {
   value: "St Pierre Les Elbeuf (FRPJB)",
   label: "St Pierre Les Elbeuf (FRPJB)"
  },
  {
   value: "St Pierre les Nemours (FRSPN)",
   label: "St Pierre les Nemours (FRSPN)"
  },
  {
   value: "St Pierre-Eglise (FRSPE)",
   label: "St Pierre-Eglise (FRSPE)"
  },
  {
   value: "St Priest (FRZRP)",
   label: "St Priest (FRZRP)"
  },
  {
   value: "St Puy (FRYPZ)",
   label: "St Puy (FRYPZ)"
  },
  {
   value: "St Quentin (FRSTQ)",
   label: "St Quentin (FRSTQ)"
  },
  {
   value: "St Quentin en Yvelines (FRSQY)",
   label: "St Quentin en Yvelines (FRSQY)"
  },
  {
   value: "St Quentin Fallavier (FRSQF)",
   label: "St Quentin Fallavier (FRSQF)"
  },
  {
   value: "St Rambert d'Albon (FRSRA)",
   label: "St Rambert d'Albon (FRSRA)"
  },
  {
   value: "St Raphaël (FRSRL)",
   label: "St Raphaël (FRSRL)"
  },
  {
   value: "St Remy de Provence (FRYEZ)",
   label: "St Remy de Provence (FRYEZ)"
  },
  {
   value: "St Romain (FRSRM)",
   label: "St Romain (FRSRM)"
  },
  {
   value: "St Romain de Colbosc (FRZQS)",
   label: "St Romain de Colbosc (FRZQS)"
  },
  {
   value: "St Romain en Gal (FRQSR)",
   label: "St Romain en Gal (FRQSR)"
  },
  {
   value: "St Romain sur Cher (FRXRO)",
   label: "St Romain sur Cher (FRXRO)"
  },
  {
   value: "St Saulve (FRZUE)",
   label: "St Saulve (FRZUE)"
  },
  {
   value: "St Sauveur (FRSSV)",
   label: "St Sauveur (FRSSV)"
  },
  {
   value: "St Sever (FRVXE)",
   label: "St Sever (FRVXE)"
  },
  {
   value: "St Simeon de Bressieux (FRSSB)",
   label: "St Simeon de Bressieux (FRSSB)"
  },
  {
   value: "St Laurent d'Agny (FRSDA)",
   label: "St Laurent d'Agny (FRSDA)"
  },
  {
   value: "St Laurent de Mure (FRSLM)",
   label: "St Laurent de Mure (FRSLM)"
  },
  {
   value: "St Laurent Du Pont (FRZDP)",
   label: "St Laurent Du Pont (FRZDP)"
  },
  {
   value: "St Laurent Du Var (FRXDV)",
   label: "St Laurent Du Var (FRXDV)"
  },
  {
   value: "St Laurent Les Tours (FRYXU)",
   label: "St Laurent Les Tours (FRYXU)"
  },
  {
   value: "St Laurent-Medoc (FRDXO)",
   label: "St Laurent-Medoc (FRDXO)"
  },
  {
   value: "St Le Noble (FRSLN)",
   label: "St Le Noble (FRSLN)"
  },
  {
   value: "St Leger sous la Bussiere (FRZLA)",
   label: "St Leger sous la Bussiere (FRZLA)"
  },
  {
   value: "St Lô (FRSLO)",
   label: "St Lô (FRSLO)"
  },
  {
   value: "St Loubes (FRXOU)",
   label: "St Loubes (FRXOU)"
  },
  {
   value: "St Louis (FRSTL)",
   label: "St Louis (FRSTL)"
  },
  {
   value: "St Louis\/Bordeaux (FRLOU)",
   label: "St Louis\/Bordeaux (FRLOU)"
  },
  {
   value: "St Macaire (FRQMZ)",
   label: "St Macaire (FRQMZ)"
  },
  {
   value: "St Maixent (FRSAX)",
   label: "St Maixent (FRSAX)"
  },
  {
   value: "St Malo (FRSML)",
   label: "St Malo (FRSML)"
  },
  {
   value: "St Marcel (FRSTM)",
   label: "St Marcel (FRSTM)"
  },
  {
   value: "St Marcellin (FRZFM)",
   label: "St Marcellin (FRZFM)"
  },
  {
   value: "St Marcellin En Forez (FRXZF)",
   label: "St Marcellin En Forez (FRXZF)"
  },
  {
   value: "St Mars La Briere (FRIYB)",
   label: "St Mars La Briere (FRIYB)"
  },
  {
   value: "St Martin Belle Roche (FROEZ)",
   label: "St Martin Belle Roche (FROEZ)"
  },
  {
   value: "St Martin D'heres (FRXHM)",
   label: "St Martin D'heres (FRXHM)"
  },
  {
   value: "St Martin de Crau (FRSMC)",
   label: "St Martin de Crau (FRSMC)"
  },
  {
   value: "St Martin de Londres (FRSMN)",
   label: "St Martin de Londres (FRSMN)"
  },
  {
   value: "St Martin des Noyers (FRIRY)",
   label: "St Martin des Noyers (FRIRY)"
  },
  {
   value: "St Martin Le Vinoux (FRZMT)",
   label: "St Martin Le Vinoux (FRZMT)"
  },
  {
   value: "St Martine du Frene (FRYXF)",
   label: "St Martine du Frene (FRYXF)"
  },
  {
   value: "St Martory (FRSMY)",
   label: "St Martory (FRSMY)"
  },
  {
   value: "St Mathieu (FRIUT)",
   label: "St Mathieu (FRIUT)"
  },
  {
   value: "St Mathieu de Treviers (FRSMT)",
   label: "St Mathieu de Treviers (FRSMT)"
  },
  {
   value: "St Maur (FRSMA)",
   label: "St Maur (FRSMA)"
  },
  {
   value: "St Maur des Fosses (FRXUA)",
   label: "St Maur des Fosses (FRXUA)"
  },
  {
   value: "St Maurice de Lignon (FRSLI)",
   label: "St Maurice de Lignon (FRSLI)"
  },
  {
   value: "St Maurice en Gourgois (FRGXZ)",
   label: "St Maurice en Gourgois (FRGXZ)"
  },
  {
   value: "St Max (FRZXM)",
   label: "St Max (FRZXM)"
  },
  {
   value: "St Maxent (FRSMX)",
   label: "St Maxent (FRSMX)"
  },
  {
   value: "St Florent sur Cher (FRSFC)",
   label: "St Florent sur Cher (FRSFC)"
  },
  {
   value: "St Florentin (FRSFT)",
   label: "St Florentin (FRSFT)"
  },
  {
   value: "St Floret (FRSFL)",
   label: "St Floret (FRSFL)"
  },
  {
   value: "St Fons (FRSSF)",
   label: "St Fons (FRSSF)"
  },
  {
   value: "St Galmier (FRZGM)",
   label: "St Galmier (FRZGM)"
  },
  {
   value: "St Genis Laval (FRYGS)",
   label: "St Genis Laval (FRYGS)"
  },
  {
   value: "St Genis Pouilly (FRZGW)",
   label: "St Genis Pouilly (FRZGW)"
  },
  {
   value: "St Georges de Reneins (FRZIJ)",
   label: "St Georges de Reneins (FRZIJ)"
  },
  {
   value: "St Georges sur Loire (FRZGF)",
   label: "St Georges sur Loire (FRZGF)"
  },
  {
   value: "St Germain au Mont d'Or (FRSGD)",
   label: "St Germain au Mont d'Or (FRSGD)"
  },
  {
   value: "St Germain de Joux (FRZGJ)",
   label: "St Germain de Joux (FRZGJ)"
  },
  {
   value: "St Germain du Plain (FRZGP)",
   label: "St Germain du Plain (FRZGP)"
  },
  {
   value: "St Germain en Laye (FRSGL)",
   label: "St Germain en Laye (FRSGL)"
  },
  {
   value: "St Germain les Arpajons (FRGJX)",
   label: "St Germain les Arpajons (FRGJX)"
  },
  {
   value: "St Gervais (FRSTG)",
   label: "St Gervais (FRSTG)"
  },
  {
   value: "St Girons (FRZXG)",
   label: "St Girons (FRZXG)"
  },
  {
   value: "St Herblain (FRSHB)",
   label: "St Herblain (FRSHB)"
  },
  {
   value: "St Hilaire du Harcouet (FRSHH)",
   label: "St Hilaire du Harcouet (FRSHH)"
  },
  {
   value: "St Hippolyte (FRSYE)",
   label: "St Hippolyte (FRSYE)"
  },
  {
   value: "St Hippolyte du Fort (FRYSY)",
   label: "St Hippolyte du Fort (FRYSY)"
  },
  {
   value: "St Jacques (FRYJQ)",
   label: "St Jacques (FRYJQ)"
  },
  {
   value: "St Jaques de la Lande (FRSJL)",
   label: "St Jaques de la Lande (FRSJL)"
  },
  {
   value: "St Jean d'Illac (FRSJI)",
   label: "St Jean d'Illac (FRSJI)"
  },
  {
   value: "St Jean de Braye (FRZJF)",
   label: "St Jean de Braye (FRZJF)"
  },
  {
   value: "St Jean De Luz (FRZJZ)",
   label: "St Jean De Luz (FRZJZ)"
  },
  {
   value: "St Jean De Maurienne (FRSJD)",
   label: "St Jean De Maurienne (FRSJD)"
  },
  {
   value: "St Jean de Vedas (FRSJV)",
   label: "St Jean de Vedas (FRSJV)"
  },
  {
   value: "St Jean Lasseille (FRJLS)",
   label: "St Jean Lasseille (FRJLS)"
  },
  {
   value: "St Jory (FRSTJ)",
   label: "St Jory (FRSTJ)"
  },
  {
   value: "St Jueres (FRSJR)",
   label: "St Jueres (FRSJR)"
  },
  {
   value: "St Julien en Genevois (FRSJG)",
   label: "St Julien en Genevois (FRSJG)"
  },
  {
   value: "St Julien Les Villas (FRZJU)",
   label: "St Julien Les Villas (FRZJU)"
  },
  {
   value: "St Julien Mont Denis (FRZJI)",
   label: "St Julien Mont Denis (FRZJI)"
  },
  {
   value: "St Laud\/Angers (FRSLA)",
   label: "St Laud\/Angers (FRSLA)"
  },
  {
   value: "St Bartelemy (FRSTB)",
   label: "St Bartelemy (FRSTB)"
  },
  {
   value: "St Bauzille-Du-Putois (FRSBZ)",
   label: "St Bauzille-Du-Putois (FRSBZ)"
  },
  {
   value: "St Berthevin (FRSSE)",
   label: "St Berthevin (FRSSE)"
  },
  {
   value: "St Bonnet le Chateau (FRSBC)",
   label: "St Bonnet le Chateau (FRSBC)"
  },
  {
   value: "St Brevin les Pins (FRSLP)",
   label: "St Brevin les Pins (FRSLP)"
  },
  {
   value: "St Brice sous Foret (FRSBF)",
   label: "St Brice sous Foret (FRSBF)"
  },
  {
   value: "St Brieuc (FRSBK)",
   label: "St Brieuc (FRSBK)"
  },
  {
   value: "St Cannat (FRSNT)",
   label: "St Cannat (FRSNT)"
  },
  {
   value: "St Caprais de Bordeaux (FRSCB)",
   label: "St Caprais de Bordeaux (FRSCB)"
  },
  {
   value: "St Caradec (FRUDE)",
   label: "St Caradec (FRUDE)"
  },
  {
   value: "St Chamond (FRSCD)",
   label: "St Chamond (FRSCD)"
  },
  {
   value: "St Chef (FRSCF)",
   label: "St Chef (FRSCF)"
  },
  {
   value: "St Clair de la Tour (FRSCT)",
   label: "St Clair de la Tour (FRSCT)"
  },
  {
   value: "St Clair du Rhone (FRSCR)",
   label: "St Clair du Rhone (FRSCR)"
  },
  {
   value: "St Claude (FRSTC)",
   label: "St Claude (FRSTC)"
  },
  {
   value: "St Come (FRSCO)",
   label: "St Come (FRSCO)"
  },
  {
   value: "St Crepin (FRSCP)",
   label: "St Crepin (FRSCP)"
  },
  {
   value: "St Cyprien\/Toulouse (FRSCY)",
   label: "St Cyprien\/Toulouse (FRSCY)"
  },
  {
   value: "St Cyr Sur Loire (FRSCC)",
   label: "St Cyr Sur Loire (FRSCC)"
  },
  {
   value: "St Cyr sur Menthon (FRSCM)",
   label: "St Cyr sur Menthon (FRSCM)"
  },
  {
   value: "St Dié (FRSDI)",
   label: "St Dié (FRSDI)"
  },
  {
   value: "St Dizan Du Gua (FRSDZ)",
   label: "St Dizan Du Gua (FRSDZ)"
  },
  {
   value: "St Dizier (FRSZR)",
   label: "St Dizier (FRSZR)"
  },
  {
   value: "St Egreve (FRSGR)",
   label: "St Egreve (FRSGR)"
  },
  {
   value: "St Eloy les Mines (FRSEM)",
   label: "St Eloy les Mines (FRSEM)"
  },
  {
   value: "St Emilion (FRSMI)",
   label: "St Emilion (FRSMI)"
  },
  {
   value: "St Estephe (FRSPH)",
   label: "St Estephe (FRSPH)"
  },
  {
   value: "St Etienne (FREBU)",
   label: "St Etienne (FREBU)"
  },
  {
   value: "St Etienne de St Geoirs (FRSES)",
   label: "St Etienne de St Geoirs (FRSES)"
  },
  {
   value: "St Etienne du Rouvray (FRZEF)",
   label: "St Etienne du Rouvray (FRZEF)"
  },
  {
   value: "St Etienne sur Loire (FRSTS)",
   label: "St Etienne sur Loire (FRSTS)"
  },
  {
   value: "St Fargeau (FRSFR)",
   label: "St Fargeau (FRSFR)"
  },
  {
   value: "St Felix de Lodez (FRZFZ)",
   label: "St Felix de Lodez (FRZFZ)"
  },
  {
   value: "St Felix Lauragais (FRSFG)",
   label: "St Felix Lauragais (FRSFG)"
  },
  {
   value: "St Florent (FRZFB)",
   label: "St Florent (FRZFB)"
  },
  {
   value: "Sèvres (FRSEV)",
   label: "Sèvres (FRSEV)"
  },
  {
   value: "Sevrey (FRSVY)",
   label: "Sevrey (FRSVY)"
  },
  {
   value: "Seyne (FRSYN)",
   label: "Seyne (FRSYN)"
  },
  {
   value: "Seyssins (FRSYS)",
   label: "Seyssins (FRSYS)"
  },
  {
   value: "Sezanne (FRSEZ)",
   label: "Sezanne (FRSEZ)"
  },
  {
   value: "Sibelin (FRSIB)",
   label: "Sibelin (FRSIB)"
  },
  {
   value: "Sierck les Bains (FRSLB)",
   label: "Sierck les Bains (FRSLB)"
  },
  {
   value: "Signes (FRSIG)",
   label: "Signes (FRSIG)"
  },
  {
   value: "Soissons (FRSOI)",
   label: "Soissons (FRSOI)"
  },
  {
   value: "Solenzara (FRSOZ)",
   label: "Solenzara (FRSOZ)"
  },
  {
   value: "Solesmes (FRSLS)",
   label: "Solesmes (FRSLS)"
  },
  {
   value: "Sons et Roncheres (FRSON)",
   label: "Sons et Roncheres (FRSON)"
  },
  {
   value: "Sophia Antipolis (FRSXD)",
   label: "Sophia Antipolis (FRSXD)"
  },
  {
   value: "Sorbiers (FRSRB)",
   label: "Sorbiers (FRSRB)"
  },
  {
   value: "Sorgues (FRSOR)",
   label: "Sorgues (FRSOR)"
  },
  {
   value: "Sotteville les Rouen (FRSOT)",
   label: "Sotteville les Rouen (FRSOT)"
  },
  {
   value: "Souffelweyersheim (FRSFF)",
   label: "Souffelweyersheim (FRSFF)"
  },
  {
   value: "Souge-le-Ganelon (FRSLG)",
   label: "Souge-le-Ganelon (FRSLG)"
  },
  {
   value: "Soultz sous Forets (FRSOF)",
   label: "Soultz sous Forets (FRSOF)"
  },
  {
   value: "St Aignan (FRSAG)",
   label: "St Aignan (FRSAG)"
  },
  {
   value: "St Alban de Roche (FRSAN)",
   label: "St Alban de Roche (FRSAN)"
  },
  {
   value: "St Amand les Eaux (FRSTX)",
   label: "St Amand les Eaux (FRSTX)"
  },
  {
   value: "St Amarin (FRSTN)",
   label: "St Amarin (FRSTN)"
  },
  {
   value: "St Ame (FRSAM)",
   label: "St Ame (FRSAM)"
  },
  {
   value: "St Amour (FRSTR)",
   label: "St Amour (FRSTR)"
  },
  {
   value: "St Andre de Boege (FRSAD)",
   label: "St Andre de Boege (FRSAD)"
  },
  {
   value: "St Andre de Cubzac (FRSQU)",
   label: "St Andre de Cubzac (FRSQU)"
  },
  {
   value: "St André de l'Eure (FRSAE)",
   label: "St André de l'Eure (FRSAE)"
  },
  {
   value: "St Andre Lez Lille (FRSTE)",
   label: "St Andre Lez Lille (FRSTE)"
  },
  {
   value: "St Apollinare (FRSAP)",
   label: "St Apollinare (FRSAP)"
  },
  {
   value: "St Auban (FRSTU)",
   label: "St Auban (FRSTU)"
  },
  {
   value: "St Aubin (FRSUB)",
   label: "St Aubin (FRSUB)"
  },
  {
   value: "St Aubin (FRSBI)",
   label: "St Aubin (FRSBI)"
  },
  {
   value: "St Aubin des Landes (FRSDL)",
   label: "St Aubin des Landes (FRSDL)"
  },
  {
   value: "St Aubin Les Elbeuf (FRSLE)",
   label: "St Aubin Les Elbeuf (FRSLE)"
  },
  {
   value: "St Avold (FRSTA)",
   label: "St Avold (FRSTA)"
  },
  {
   value: "Santes (FRYZF)",
   label: "Santes (FRYZF)"
  },
  {
   value: "Saran (FRSRN)",
   label: "Saran (FRSRN)"
  },
  {
   value: "Sarcelles (FRSRC)",
   label: "Sarcelles (FRSRC)"
  },
  {
   value: "Sarlat-la-Caneda (FRSLC)",
   label: "Sarlat-la-Caneda (FRSLC)"
  },
  {
   value: "Sarrebourg (FRSBG)",
   label: "Sarrebourg (FRSBG)"
  },
  {
   value: "Sarreguemines (FRSAR)",
   label: "Sarreguemines (FRSAR)"
  },
  {
   value: "Sarrians (FRSRS)",
   label: "Sarrians (FRSRS)"
  },
  {
   value: "Sartrouville (FRSVL)",
   label: "Sartrouville (FRSVL)"
  },
  {
   value: "Sassenage (FRSSS)",
   label: "Sassenage (FRSSS)"
  },
  {
   value: "Saujon (FRSJN)",
   label: "Saujon (FRSJN)"
  },
  {
   value: "Sault-Brenaz (FRSBR)",
   label: "Sault-Brenaz (FRSBR)"
  },
  {
   value: "Saultain (FRSLT)",
   label: "Saultain (FRSLT)"
  },
  {
   value: "Saumur (FRSAU)",
   label: "Saumur (FRSAU)"
  },
  {
   value: "Sauveterre (FRSVT)",
   label: "Sauveterre (FRSVT)"
  },
  {
   value: "Saverne (FRSAV)",
   label: "Saverne (FRSAV)"
  },
  {
   value: "Scaer (FRSCA)",
   label: "Scaer (FRSCA)"
  },
  {
   value: "Scey-sur-Saone (FRSSA)",
   label: "Scey-sur-Saone (FRSSA)"
  },
  {
   value: "Schiltigheim (FRSCH)",
   label: "Schiltigheim (FRSCH)"
  },
  {
   value: "Schirmeck (FRSMK)",
   label: "Schirmeck (FRSMK)"
  },
  {
   value: "Schweighouse sur Moder (FRSCW)",
   label: "Schweighouse sur Moder (FRSCW)"
  },
  {
   value: "Seclin (FRSCN)",
   label: "Seclin (FRSCN)"
  },
  {
   value: "Sedan (FRSED)",
   label: "Sedan (FRSED)"
  },
  {
   value: "Segoufielle (FRSEG)",
   label: "Segoufielle (FRSEG)"
  },
  {
   value: "Sélestat (FRSEL)",
   label: "Sélestat (FRSEL)"
  },
  {
   value: "Selongey (FRSEY)",
   label: "Selongey (FRSEY)"
  },
  {
   value: "Semur en Auxois (FRSEX)",
   label: "Semur en Auxois (FRSEX)"
  },
  {
   value: "Senarpont (FRSRP)",
   label: "Senarpont (FRSRP)"
  },
  {
   value: "Senas (FRSEA)",
   label: "Senas (FRSEA)"
  },
  {
   value: "Senlis (FRSEI)",
   label: "Senlis (FRSEI)"
  },
  {
   value: "Senonches (FRSEO)",
   label: "Senonches (FRSEO)"
  },
  {
   value: "Senones (FRSNN)",
   label: "Senones (FRSNN)"
  },
  {
   value: "Sens (FRSEN)",
   label: "Sens (FRSEN)"
  },
  {
   value: "Septemes-les-Vallons (FRSEP)",
   label: "Septemes-les-Vallons (FRSEP)"
  },
  {
   value: "Serifontaine (FRSER)",
   label: "Serifontaine (FRSER)"
  },
  {
   value: "Serquigny (FRSRQ)",
   label: "Serquigny (FRSRQ)"
  },
  {
   value: "Serre Chevalier (FRSEC)",
   label: "Serre Chevalier (FRSEC)"
  },
  {
   value: "Servian (FRSVN)",
   label: "Servian (FRSVN)"
  },
  {
   value: "Servon (FRSRV)",
   label: "Servon (FRSRV)"
  },
  {
   value: "Sète (FRSET)",
   label: "Sète (FRSET)"
  },
  {
   value: "Roscoff (FRROS)",
   label: "Roscoff (FRROS)"
  },
  {
   value: "Rosendael (FRROD)",
   label: "Rosendael (FRROD)"
  },
  {
   value: "Rosieres en Santerre (FRRES)",
   label: "Rosieres en Santerre (FRRES)"
  },
  {
   value: "Roubaix (FRROU)",
   label: "Roubaix (FRROU)"
  },
  {
   value: "Rouen (FRURO)",
   label: "Rouen (FRURO)"
  },
  {
   value: "Rouen-Orléans Sta (FRROO)",
   label: "Rouen-Orléans Sta (FRROO)"
  },
  {
   value: "Rouffach (FRRUF)",
   label: "Rouffach (FRRUF)"
  },
  {
   value: "Rougnac (FRRGC)",
   label: "Rougnac (FRRGC)"
  },
  {
   value: "Rouillac (FRROL)",
   label: "Rouillac (FRROL)"
  },
  {
   value: "Roullet St Estephe (FRRLT)",
   label: "Roullet St Estephe (FRRLT)"
  },
  {
   value: "Roumazieres (FRRMZ)",
   label: "Roumazieres (FRRMZ)"
  },
  {
   value: "Rousies (FRRSI)",
   label: "Rousies (FRRSI)"
  },
  {
   value: "Rousset (FRRST)",
   label: "Rousset (FRRST)"
  },
  {
   value: "Roussilon (FRRSN)",
   label: "Roussilon (FRRSN)"
  },
  {
   value: "Rouvignies (FRRVO)",
   label: "Rouvignies (FRRVO)"
  },
  {
   value: "Rouvray (FRRUY)",
   label: "Rouvray (FRRUY)"
  },
  {
   value: "Rouvroy-s-Audry (FRRVA)",
   label: "Rouvroy-s-Audry (FRRVA)"
  },
  {
   value: "Royan (FRRYN)",
   label: "Royan (FRRYN)"
  },
  {
   value: "Roye (FRRYE)",
   label: "Roye (FRRYE)"
  },
  {
   value: "Rueil Malmaison (FRRUE)",
   label: "Rueil Malmaison (FRRUE)"
  },
  {
   value: "Rugles (FRRGL)",
   label: "Rugles (FRRGL)"
  },
  {
   value: "Rully (FRRUL)",
   label: "Rully (FRRUL)"
  },
  {
   value: "Rumilly (FRRUM)",
   label: "Rumilly (FRRUM)"
  },
  {
   value: "Rungis (FRRUN)",
   label: "Rungis (FRRUN)"
  },
  {
   value: "Ruoms (FRRUO)",
   label: "Ruoms (FRRUO)"
  },
  {
   value: "Sable sur Sarthe (FRSSR)",
   label: "Sable sur Sarthe (FRSSR)"
  },
  {
   value: "Sablon\/Metz (FRSAB)",
   label: "Sablon\/Metz (FRSAB)"
  },
  {
   value: "Saillat sur Vienne (FRSVI)",
   label: "Saillat sur Vienne (FRSVI)"
  },
  {
   value: "Saintry sur Seine (FRSSN)",
   label: "Saintry sur Seine (FRSSN)"
  },
  {
   value: "Salaise (FRSAL)",
   label: "Salaise (FRSAL)"
  },
  {
   value: "Salernes (FRSAS)",
   label: "Salernes (FRSAS)"
  },
  {
   value: "Salin de Giraud (FRSDG)",
   label: "Salin de Giraud (FRSDG)"
  },
  {
   value: "Salindres (FRSAI)",
   label: "Salindres (FRSAI)"
  },
  {
   value: "Sallanches (FRSCS)",
   label: "Sallanches (FRSCS)"
  },
  {
   value: "Salses le Chateu (FRSAC)",
   label: "Salses le Chateu (FRSAC)"
  },
  {
   value: "Salsigne (FRSGN)",
   label: "Salsigne (FRSGN)"
  },
  {
   value: "Sancerre (FRSRR)",
   label: "Sancerre (FRSRR)"
  },
  {
   value: "Sandouville (FRSNV)",
   label: "Sandouville (FRSNV)"
  },
  {
   value: "Revigny (FRREV)",
   label: "Revigny (FRREV)"
  },
  {
   value: "Revin (FRRVF)",
   label: "Revin (FRRVF)"
  },
  {
   value: "Ribeauville (FRRVB)",
   label: "Ribeauville (FRRVB)"
  },
  {
   value: "Ribecourt (FRRIB)",
   label: "Ribecourt (FRRIB)"
  },
  {
   value: "Richwiller (FRRIC)",
   label: "Richwiller (FRRIC)"
  },
  {
   value: "Riedisheim (FRRID)",
   label: "Riedisheim (FRRID)"
  },
  {
   value: "Rieupeyroux (FRRPY)",
   label: "Rieupeyroux (FRRPY)"
  },
  {
   value: "Rieux (FRRIE)",
   label: "Rieux (FRRIE)"
  },
  {
   value: "Rillieux La Pape (FRRIL)",
   label: "Rillieux La Pape (FRRIL)"
  },
  {
   value: "Rinxent (FRRIN)",
   label: "Rinxent (FRRIN)"
  },
  {
   value: "Riom (FRRIO)",
   label: "Riom (FRRIO)"
  },
  {
   value: "Rion des Landes (FRRDL)",
   label: "Rion des Landes (FRRDL)"
  },
  {
   value: "Riquewihr (FRRIQ)",
   label: "Riquewihr (FRRIQ)"
  },
  {
   value: "Rive De Gier (FRRVG)",
   label: "Rive De Gier (FRRVG)"
  },
  {
   value: "Rivery (FRRRY)",
   label: "Rivery (FRRRY)"
  },
  {
   value: "Rivesaltes (FRRIV)",
   label: "Rivesaltes (FRRIV)"
  },
  {
   value: "Rixheim (FRROQ)",
   label: "Rixheim (FRROQ)"
  },
  {
   value: "Roanne (FRRNE)",
   label: "Roanne (FRRNE)"
  },
  {
   value: "Roche La Moliere (FRROC)",
   label: "Roche La Moliere (FRROC)"
  },
  {
   value: "Rochecorbon (FRRCB)",
   label: "Rochecorbon (FRRCB)"
  },
  {
   value: "Rochefort (FRRCO)",
   label: "Rochefort (FRRCO)"
  },
  {
   value: "Rochemaure (FRROM)",
   label: "Rochemaure (FRROM)"
  },
  {
   value: "Rodez (FRRDZ)",
   label: "Rodez (FRRDZ)"
  },
  {
   value: "Rognac (FRROG)",
   label: "Rognac (FRROG)"
  },
  {
   value: "Rognes (FRRGN)",
   label: "Rognes (FRRGN)"
  },
  {
   value: "Rohan (FRROH)",
   label: "Rohan (FRROH)"
  },
  {
   value: "Roissy en Brie (FRREB)",
   label: "Roissy en Brie (FRREB)"
  },
  {
   value: "Roissy en France (FRROI)",
   label: "Roissy en France (FRROI)"
  },
  {
   value: "Romainville (FRRMN)",
   label: "Romainville (FRRMN)"
  },
  {
   value: "Romaneche Thorins (FRROT)",
   label: "Romaneche Thorins (FRROT)"
  },
  {
   value: "Romilly sur Seine (FRRSS)",
   label: "Romilly sur Seine (FRRSS)"
  },
  {
   value: "Romorantin-Lanthenay (FRRRL)",
   label: "Romorantin-Lanthenay (FRRRL)"
  },
  {
   value: "Roncq (FRRON)",
   label: "Roncq (FRRON)"
  },
  {
   value: "Roppentzwiller (FRROP)",
   label: "Roppentzwiller (FRROP)"
  },
  {
   value: "Roquebrune sur Argens (FRRSA)",
   label: "Roquebrune sur Argens (FRRSA)"
  },
  {
   value: "Roquefort (FRRQF)",
   label: "Roquefort (FRRQF)"
  },
  {
   value: "Roquettes (FRRQT)",
   label: "Roquettes (FRRQT)"
  },
  {
   value: "Rorthais (FRROR)",
   label: "Rorthais (FRROR)"
  },
  {
   value: "Pouilly sur Serre (FRPSR)",
   label: "Pouilly sur Serre (FRPSR)"
  },
  {
   value: "Poullaouen (FRPOU)",
   label: "Poullaouen (FRPOU)"
  },
  {
   value: "Pouzauges (FRPOZ)",
   label: "Pouzauges (FRPOZ)"
  },
  {
   value: "Precigne (FRPCE)",
   label: "Precigne (FRPCE)"
  },
  {
   value: "Precy sur Oise (FRPSO)",
   label: "Precy sur Oise (FRPSO)"
  },
  {
   value: "Preignac (FRPRE)",
   label: "Preignac (FRPRE)"
  },
  {
   value: "Prevessin-Moens (FRPRM)",
   label: "Prevessin-Moens (FRPRM)"
  },
  {
   value: "Pringy (FRPRI)",
   label: "Pringy (FRPRI)"
  },
  {
   value: "Privas (FRPRV)",
   label: "Privas (FRPRV)"
  },
  {
   value: "Propriano (FRPRP)",
   label: "Propriano (FRPRP)"
  },
  {
   value: "Provins (FRPVP)",
   label: "Provins (FRPVP)"
  },
  {
   value: "Puicheric (FRPCH)",
   label: "Puicheric (FRPCH)"
  },
  {
   value: "Puteaux (FRPUT)",
   label: "Puteaux (FRPUT)"
  },
  {
   value: "Puy Guillaume (FRPUG)",
   label: "Puy Guillaume (FRPUG)"
  },
  {
   value: "Puy l'Eveque (FRPLE)",
   label: "Puy l'Eveque (FRPLE)"
  },
  {
   value: "Puyoo (FRPUY)",
   label: "Puyoo (FRPUY)"
  },
  {
   value: "Quesnoy (FRQNY)",
   label: "Quesnoy (FRQNY)"
  },
  {
   value: "Quiberon (FRQUI)",
   label: "Quiberon (FRQUI)"
  },
  {
   value: "Quillan (FRQLN)",
   label: "Quillan (FRQLN)"
  },
  {
   value: "Quimper (FRUIP)",
   label: "Quimper (FRUIP)"
  },
  {
   value: "Quimperle (FRQMP)",
   label: "Quimperle (FRQMP)"
  },
  {
   value: "Quincie en Beaujolais (FRQEB)",
   label: "Quincie en Beaujolais (FRQEB)"
  },
  {
   value: "Radicatel (FRRAD)",
   label: "Radicatel (FRRAD)"
  },
  {
   value: "Raismes (FRRAM)",
   label: "Raismes (FRRAM)"
  },
  {
   value: "Raival (FRRAI)",
   label: "Raival (FRRAI)"
  },
  {
   value: "Rambervillers (FRRAB)",
   label: "Rambervillers (FRRAB)"
  },
  {
   value: "Rantigny (FRRAN)",
   label: "Rantigny (FRRAN)"
  },
  {
   value: "Raucourt (FRRCT)",
   label: "Raucourt (FRRCT)"
  },
  {
   value: "Ravieres (FRRVR)",
   label: "Ravieres (FRRVR)"
  },
  {
   value: "Reau (FRREA)",
   label: "Reau (FRREA)"
  },
  {
   value: "Recquignes (FRREC)",
   label: "Recquignes (FRREC)"
  },
  {
   value: "Redon (FRRDN)",
   label: "Redon (FRRDN)"
  },
  {
   value: "Reichstett (FRREI)",
   label: "Reichstett (FRREI)"
  },
  {
   value: "Reims (FRRHE)",
   label: "Reims (FRRHE)"
  },
  {
   value: "Remalard (FRREL)",
   label: "Remalard (FRREL)"
  },
  {
   value: "Remiremont (FRRMM)",
   label: "Remiremont (FRRMM)"
  },
  {
   value: "Remoulins (FRREM)",
   label: "Remoulins (FRREM)"
  },
  {
   value: "Renaze (FRREN)",
   label: "Renaze (FRREN)"
  },
  {
   value: "Rennes (FRRNS)",
   label: "Rennes (FRRNS)"
  },
  {
   value: "Ressons sur Matz (FRRSM)",
   label: "Ressons sur Matz (FRRSM)"
  },
  {
   value: "Pont de Cheruy (FRPOC)",
   label: "Pont de Cheruy (FRPOC)"
  },
  {
   value: "Pont de Pany (FRPPY)",
   label: "Pont de Pany (FRPPY)"
  },
  {
   value: "Pont de Roide (FRPRO)",
   label: "Pont de Roide (FRPRO)"
  },
  {
   value: "Pont de Veyle (FRPDV)",
   label: "Pont de Veyle (FRPDV)"
  },
  {
   value: "Pont du Casse (FRPCA)",
   label: "Pont du Casse (FRPCA)"
  },
  {
   value: "Pont Du Rhin\/Strasbourg (FRPDR)",
   label: "Pont Du Rhin\/Strasbourg (FRPDR)"
  },
  {
   value: "Pont l'Abbé (FRPAB)",
   label: "Pont l'Abbé (FRPAB)"
  },
  {
   value: "Pont l'Eveque (FRPVQ)",
   label: "Pont l'Eveque (FRPVQ)"
  },
  {
   value: "Pont St Esprit (FRPSE)",
   label: "Pont St Esprit (FRPSE)"
  },
  {
   value: "Pont St Martin (FRPSM)",
   label: "Pont St Martin (FRPSM)"
  },
  {
   value: "Pont-de-Roide (FRDDF)",
   label: "Pont-de-Roide (FRDDF)"
  },
  {
   value: "Pont-Ste-Maxence (FRPSX)",
   label: "Pont-Ste-Maxence (FRPSX)"
  },
  {
   value: "Pontanevaux (FRPTA)",
   label: "Pontanevaux (FRPTA)"
  },
  {
   value: "Pontarlier (FRPON)",
   label: "Pontarlier (FRPON)"
  },
  {
   value: "Pontcharra (FRPNA)",
   label: "Pontcharra (FRPNA)"
  },
  {
   value: "Pontchateau (FRPNC)",
   label: "Pontchateau (FRPNC)"
  },
  {
   value: "Pontonx-sur-l'Adour (FRPNQ)",
   label: "Pontonx-sur-l'Adour (FRPNQ)"
  },
  {
   value: "Pontrieux (FRPOX)",
   label: "Pontrieux (FRPOX)"
  },
  {
   value: "Pornic (FRPRC)",
   label: "Pornic (FRPRC)"
  },
  {
   value: "Port Bail (FRPBA)",
   label: "Port Bail (FRPBA)"
  },
  {
   value: "Port d'Atelier (FRPAT)",
   label: "Port d'Atelier (FRPAT)"
  },
  {
   value: "Port de Bouc (FRPDB)",
   label: "Port de Bouc (FRPDB)"
  },
  {
   value: "Port de Piles (FRPDP)",
   label: "Port de Piles (FRPDP)"
  },
  {
   value: "Port Jérôme (FRPJE)",
   label: "Port Jérôme (FRPJE)"
  },
  {
   value: "Port Joinville (FRPRJ)",
   label: "Port Joinville (FRPRJ)"
  },
  {
   value: "Port La Nouvelle (FRNOU)",
   label: "Port La Nouvelle (FRNOU)"
  },
  {
   value: "Port St Louis du Rhone (FRPSL)",
   label: "Port St Louis du Rhone (FRPSL)"
  },
  {
   value: "Port sur Saone (FRPSA)",
   label: "Port sur Saone (FRPSA)"
  },
  {
   value: "Port Vendres (FRPOV)",
   label: "Port Vendres (FRPOV)"
  },
  {
   value: "Porte Neuve\/Dijon (FRPTN)",
   label: "Porte Neuve\/Dijon (FRPTN)"
  },
  {
   value: "Portes Lès Valence (FRPOR)",
   label: "Portes Lès Valence (FRPOR)"
  },
  {
   value: "Portet St Simon (FRPSS)",
   label: "Portet St Simon (FRPSS)"
  },
  {
   value: "Portet sur Garonne (FRPRT)",
   label: "Portet sur Garonne (FRPRT)"
  },
  {
   value: "Porto Vecchio (FRPVO)",
   label: "Porto Vecchio (FRPVO)"
  },
  {
   value: "Pouilly en Auxois (FRPEA)",
   label: "Pouilly en Auxois (FRPEA)"
  },
  {
   value: "Pouilly les Feurs (FRPLF)",
   label: "Pouilly les Feurs (FRPLF)"
  },
  {
   value: "Pèrigueux (FRPGX)",
   label: "Pèrigueux (FRPGX)"
  },
  {
   value: "Peronne (FRPEO)",
   label: "Peronne (FRPEO)"
  },
  {
   value: "Perpignan (FRPGF)",
   label: "Perpignan (FRPGF)"
  },
  {
   value: "Perrigny (FRPRY)",
   label: "Perrigny (FRPRY)"
  },
  {
   value: "Persan (FRPRS)",
   label: "Persan (FRPRS)"
  },
  {
   value: "Pertuis (FRPTU)",
   label: "Pertuis (FRPTU)"
  },
  {
   value: "Peschadoires (FRPES)",
   label: "Peschadoires (FRPES)"
  },
  {
   value: "Pessac (FRPEC)",
   label: "Pessac (FRPEC)"
  },
  {
   value: "Petersbach (FRPTB)",
   label: "Petersbach (FRPTB)"
  },
  {
   value: "Petit Couronne (FRPET)",
   label: "Petit Couronne (FRPET)"
  },
  {
   value: "Petit Quevilly (FRPTQ)",
   label: "Petit Quevilly (FRPTQ)"
  },
  {
   value: "Petit Rederching (FRPTR)",
   label: "Petit Rederching (FRPTR)"
  },
  {
   value: "Petite Foret (FRPTF)",
   label: "Petite Foret (FRPTF)"
  },
  {
   value: "Peyrehorade (FRPEY)",
   label: "Peyrehorade (FRPEY)"
  },
  {
   value: "Peyrins (FRPYR)",
   label: "Peyrins (FRPYR)"
  },
  {
   value: "Phalsbourg (FRPHL)",
   label: "Phalsbourg (FRPHL)"
  },
  {
   value: "Pierre Benite (FRPIB)",
   label: "Pierre Benite (FRPIB)"
  },
  {
   value: "Pierrefitte (FRPIE)",
   label: "Pierrefitte (FRPIE)"
  },
  {
   value: "Pierrelatte (FRPRR)",
   label: "Pierrelatte (FRPRR)"
  },
  {
   value: "Pierrepont (FRPIP)",
   label: "Pierrepont (FRPIP)"
  },
  {
   value: "Pinet (FRPNT)",
   label: "Pinet (FRPNT)"
  },
  {
   value: "Piolenc (FRPIO)",
   label: "Piolenc (FRPIO)"
  },
  {
   value: "Piriac (FRPIR)",
   label: "Piriac (FRPIR)"
  },
  {
   value: "Plailly (FRPLA)",
   label: "Plailly (FRPLA)"
  },
  {
   value: "Plan d'Orgon (FRPDO)",
   label: "Plan d'Orgon (FRPDO)"
  },
  {
   value: "Plan de Campagne (FRPDC)",
   label: "Plan de Campagne (FRPDC)"
  },
  {
   value: "Plan de Grasse (FRPDG)",
   label: "Plan de Grasse (FRPDG)"
  },
  {
   value: "Plougasnou (FRPLO)",
   label: "Plougasnou (FRPLO)"
  },
  {
   value: "Podensac (FRPOD)",
   label: "Podensac (FRPOD)"
  },
  {
   value: "Poissy (FRPOI)",
   label: "Poissy (FRPOI)"
  },
  {
   value: "Poitiers (FRPIS)",
   label: "Poitiers (FRPIS)"
  },
  {
   value: "Poligny (FRPOL)",
   label: "Poligny (FRPOL)"
  },
  {
   value: "Pons (FRPNS)",
   label: "Pons (FRPNS)"
  },
  {
   value: "Pont a Marcq (FRPMA)",
   label: "Pont a Marcq (FRPMA)"
  },
  {
   value: "Pont A Mousson (FRPAM)",
   label: "Pont A Mousson (FRPAM)"
  },
  {
   value: "Pont Audemer (FRPOA)",
   label: "Pont Audemer (FRPOA)"
  },
  {
   value: "Pont d'Ain (FRPDA)",
   label: "Pont d'Ain (FRPDA)"
  },
  {
   value: "Pont de Beauvoisin (FRPBV)",
   label: "Pont de Beauvoisin (FRPBV)"
  },
  {
   value: "Onet Le Chateau (FROLC)",
   label: "Onet Le Chateau (FROLC)"
  },
  {
   value: "Oppede (FROPP)",
   label: "Oppede (FROPP)"
  },
  {
   value: "Oradour sur Glane (FROGE)",
   label: "Oradour sur Glane (FROGE)"
  },
  {
   value: "Orange (FRORA)",
   label: "Orange (FRORA)"
  },
  {
   value: "Orchies (FRORC)",
   label: "Orchies (FRORC)"
  },
  {
   value: "Orgeval (FRORG)",
   label: "Orgeval (FRORG)"
  },
  {
   value: "Orgon (FROGN)",
   label: "Orgon (FROGN)"
  },
  {
   value: "Orléans (FRORR)",
   label: "Orléans (FRORR)"
  },
  {
   value: "ORLY\/Orly Apt\/Paris (FRORY)",
   label: "ORLY\/Orly Apt\/Paris (FRORY)"
  },
  {
   value: "Ormes (FRORM)",
   label: "Ormes (FRORM)"
  },
  {
   value: "Orthez (FRORT)",
   label: "Orthez (FRORT)"
  },
  {
   value: "Osny (FROSN)",
   label: "Osny (FROSN)"
  },
  {
   value: "Otterswiller (FROTE)",
   label: "Otterswiller (FROTE)"
  },
  {
   value: "Ottmarsheim (FROTM)",
   label: "Ottmarsheim (FROTM)"
  },
  {
   value: "Oudalle (FROUD)",
   label: "Oudalle (FROUD)"
  },
  {
   value: "Ouistreham (FROUI)",
   label: "Ouistreham (FROUI)"
  },
  {
   value: "Oullins (FROUL)",
   label: "Oullins (FROUL)"
  },
  {
   value: "Oyonnax (FROYO)",
   label: "Oyonnax (FROYO)"
  },
  {
   value: "Pacy sur Eure (FRPAC)",
   label: "Pacy sur Eure (FRPAC)"
  },
  {
   value: "Pagny sur Meuse (FRPAG)",
   label: "Pagny sur Meuse (FRPAG)"
  },
  {
   value: "Paimboeuf (FRPBF)",
   label: "Paimboeuf (FRPBF)"
  },
  {
   value: "Paimpol (FRPAI)",
   label: "Paimpol (FRPAI)"
  },
  {
   value: "Palis (FRPLS)",
   label: "Palis (FRPLS)"
  },
  {
   value: "Pamiers (FRPMS)",
   label: "Pamiers (FRPMS)"
  },
  {
   value: "Pantin (FRTIN)",
   label: "Pantin (FRTIN)"
  },
  {
   value: "Paray Le Monial (FRPLM)",
   label: "Paray Le Monial (FRPLM)"
  },
  {
   value: "Parcay Meslay (FRPME)",
   label: "Parcay Meslay (FRPME)"
  },
  {
   value: "Parempuyre (FRPMP)",
   label: "Parempuyre (FRPMP)"
  },
  {
   value: "Parentis en Born (FRPEB)",
   label: "Parentis en Born (FRPEB)"
  },
  {
   value: "Paris (FRPAR)",
   label: "Paris (FRPAR)"
  },
  {
   value: "Paris-La Defense (FRPLD)",
   label: "Paris-La Defense (FRPLD)"
  },
  {
   value: "Parnac (FRPRN)",
   label: "Parnac (FRPRN)"
  },
  {
   value: "Parthenay (FRPTY)",
   label: "Parthenay (FRPTY)"
  },
  {
   value: "Pau (FRPUF)",
   label: "Pau (FRPUF)"
  },
  {
   value: "Pauillac (FRPAP)",
   label: "Pauillac (FRPAP)"
  },
  {
   value: "Paulhaguet (FRPLH)",
   label: "Paulhaguet (FRPLH)"
  },
  {
   value: "Paulhan (FRPLN)",
   label: "Paulhan (FRPLN)"
  },
  {
   value: "Pellegrue (FRPEL)",
   label: "Pellegrue (FRPEL)"
  },
  {
   value: "Penne d'Agenais (FRPEN)",
   label: "Penne d'Agenais (FRPEN)"
  },
  {
   value: "Neuilly Plaisance (FRNEV)",
   label: "Neuilly Plaisance (FRNEV)"
  },
  {
   value: "Neuilly sur Seine (FRNSS)",
   label: "Neuilly sur Seine (FRNSS)"
  },
  {
   value: "Neussargues (FRNES)",
   label: "Neussargues (FRNES)"
  },
  {
   value: "Neuville de Poitou (FRNDP)",
   label: "Neuville de Poitou (FRNDP)"
  },
  {
   value: "Neuville en Ferrain (FRNVF)",
   label: "Neuville en Ferrain (FRNVF)"
  },
  {
   value: "Nevers (FRNVS)",
   label: "Nevers (FRNVS)"
  },
  {
   value: "Nice (FRNCE)",
   label: "Nice (FRNCE)"
  },
  {
   value: "Niederbronn-Les-Bains (FRNLB)",
   label: "Niederbronn-Les-Bains (FRNLB)"
  },
  {
   value: "Niederbruck (FRNIE)",
   label: "Niederbruck (FRNIE)"
  },
  {
   value: "Nîmes (FRFNI)",
   label: "Nîmes (FRFNI)"
  },
  {
   value: "Niort (FRNIT)",
   label: "Niort (FRNIT)"
  },
  {
   value: "Nod sur Seine (FRNSX)",
   label: "Nod sur Seine (FRNSX)"
  },
  {
   value: "Nogent-Le-Roi (FRNOG)",
   label: "Nogent-Le-Roi (FRNOG)"
  },
  {
   value: "Nogent-Le-Rotrou (FRNLR)",
   label: "Nogent-Le-Rotrou (FRNLR)"
  },
  {
   value: "Nogent-sur-Seine (FRNGS)",
   label: "Nogent-sur-Seine (FRNGS)"
  },
  {
   value: "Nogent-sur-Vernisson (FRNGV)",
   label: "Nogent-sur-Vernisson (FRNGV)"
  },
  {
   value: "Noiretable (FRNRT)",
   label: "Noiretable (FRNRT)"
  },
  {
   value: "Noirmoutier en l'Ile (FRNOI)",
   label: "Noirmoutier en l'Ile (FRNOI)"
  },
  {
   value: "Noisy Le Sec (FRNLS)",
   label: "Noisy Le Sec (FRNLS)"
  },
  {
   value: "Noisy-Le-Grand (FRNOS)",
   label: "Noisy-Le-Grand (FRNOS)"
  },
  {
   value: "Notre Dame de Briancon (FRNDB)",
   label: "Notre Dame de Briancon (FRNDB)"
  },
  {
   value: "Notre Dame de Gravenchon (FRNDG)",
   label: "Notre Dame de Gravenchon (FRNDG)"
  },
  {
   value: "Noves (FRNOV)",
   label: "Noves (FRNOV)"
  },
  {
   value: "Noyal sur Vilaine (FRNSV)",
   label: "Noyal sur Vilaine (FRNSV)"
  },
  {
   value: "Noyarey (FRNRY)",
   label: "Noyarey (FRNRY)"
  },
  {
   value: "Noyelles (FRNYL)",
   label: "Noyelles (FRNYL)"
  },
  {
   value: "Noyen sur Sarthe (FRNYN)",
   label: "Noyen sur Sarthe (FRNYN)"
  },
  {
   value: "Noyers (FRNYR)",
   label: "Noyers (FRNYR)"
  },
  {
   value: "Noyon (FRNOY)",
   label: "Noyon (FRNOY)"
  },
  {
   value: "Nuits St Georges (FRNSG)",
   label: "Nuits St Georges (FRNSG)"
  },
  {
   value: "Nurieux Volgnat (FRNUR)",
   label: "Nurieux Volgnat (FRNUR)"
  },
  {
   value: "Obernai (FROBE)",
   label: "Obernai (FROBE)"
  },
  {
   value: "Odenas (FRODE)",
   label: "Odenas (FRODE)"
  },
  {
   value: "Offanengo (FROFG)",
   label: "Offanengo (FROFG)"
  },
  {
   value: "Offranville (FROFV)",
   label: "Offranville (FROFV)"
  },
  {
   value: "Oiry (FROIR)",
   label: "Oiry (FROIR)"
  },
  {
   value: "Oloron Ste Marie (FROLO)",
   label: "Oloron Ste Marie (FROLO)"
  },
  {
   value: "Morangis (FRMGS)",
   label: "Morangis (FRMGS)"
  },
  {
   value: "Morannes (FRMNN)",
   label: "Morannes (FRMNN)"
  },
  {
   value: "Morcenx (FRMCX)",
   label: "Morcenx (FRMCX)"
  },
  {
   value: "Moreuil (FRMUL)",
   label: "Moreuil (FRMUL)"
  },
  {
   value: "Morey (FRMRY)",
   label: "Morey (FRMRY)"
  },
  {
   value: "Morlaix (FRMXN)",
   label: "Morlaix (FRMXN)"
  },
  {
   value: "Morsang-sur-Orge (FRMSO)",
   label: "Morsang-sur-Orge (FRMSO)"
  },
  {
   value: "Mortagne sur Gironde (FRMSG)",
   label: "Mortagne sur Gironde (FRMSG)"
  },
  {
   value: "Morteau (FRMOR)",
   label: "Morteau (FRMOR)"
  },
  {
   value: "Mouans Sartoux (FRMSX)",
   label: "Mouans Sartoux (FRMSX)"
  },
  {
   value: "Mougins (FRMGI)",
   label: "Mougins (FRMGI)"
  },
  {
   value: "Moulineaux (FRMLX)",
   label: "Moulineaux (FRMLX)"
  },
  {
   value: "Moulins (FRMOU)",
   label: "Moulins (FRMOU)"
  },
  {
   value: "Moulins (FRMLN)",
   label: "Moulins (FRMLN)"
  },
  {
   value: "Moulins Les Metz (FRMLZ)",
   label: "Moulins Les Metz (FRMLZ)"
  },
  {
   value: "Mourenx (FRMRX)",
   label: "Mourenx (FRMRX)"
  },
  {
   value: "Mourmelon le Grand (FRMLG)",
   label: "Mourmelon le Grand (FRMLG)"
  },
  {
   value: "Mourmelon-Le-Petit (FRMMP)",
   label: "Mourmelon-Le-Petit (FRMMP)"
  },
  {
   value: "Mouvaux (FRMVX)",
   label: "Mouvaux (FRMVX)"
  },
  {
   value: "Mouy (FRMUY)",
   label: "Mouy (FRMUY)"
  },
  {
   value: "Mouzon (FRMZN)",
   label: "Mouzon (FRMZN)"
  },
  {
   value: "Mulhouse (FRMLH)",
   label: "Mulhouse (FRMLH)"
  },
  {
   value: "Mulhouse Nord (FRMUN)",
   label: "Mulhouse Nord (FRMUN)"
  },
  {
   value: "Muret (FRMUR)",
   label: "Muret (FRMUR)"
  },
  {
   value: "Mussy-sur-Seine (FRMUS)",
   label: "Mussy-sur-Seine (FRMUS)"
  },
  {
   value: "Mutzig (FRMZG)",
   label: "Mutzig (FRMZG)"
  },
  {
   value: "Nancy (FRENC)",
   label: "Nancy (FRENC)"
  },
  {
   value: "Nanterre (FRNAN)",
   label: "Nanterre (FRNAN)"
  },
  {
   value: "Nantes (FRNTE)",
   label: "Nantes (FRNTE)"
  },
  {
   value: "Nantes Etat (FRNAE)",
   label: "Nantes Etat (FRNAE)"
  },
  {
   value: "Nantiat (FRNTT)",
   label: "Nantiat (FRNTT)"
  },
  {
   value: "Nantua (FRNNU)",
   label: "Nantua (FRNNU)"
  },
  {
   value: "Narbonne (FRNAR)",
   label: "Narbonne (FRNAR)"
  },
  {
   value: "Nemours (FRNMS)",
   label: "Nemours (FRNMS)"
  },
  {
   value: "Nerac (FRNRC)",
   label: "Nerac (FRNRC)"
  },
  {
   value: "Nersac (FRNER)",
   label: "Nersac (FRNER)"
  },
  {
   value: "Nesle (FRNEL)",
   label: "Nesle (FRNEL)"
  },
  {
   value: "Neuf Brisach (FRNEF)",
   label: "Neuf Brisach (FRNEF)"
  },
  {
   value: "Neufchâteau (FRNEU)",
   label: "Neufchâteau (FRNEU)"
  },
  {
   value: "Neuilly En Thelle (FRNET)",
   label: "Neuilly En Thelle (FRNET)"
  },
  {
   value: "Mondragon (FRMDR)",
   label: "Mondragon (FRMDR)"
  },
  {
   value: "Mont de Marsan (FRMDM)",
   label: "Mont de Marsan (FRMDM)"
  },
  {
   value: "Mont St Martin (FRMSM)",
   label: "Mont St Martin (FRMSM)"
  },
  {
   value: "Montaigu (FRMNT)",
   label: "Montaigu (FRMNT)"
  },
  {
   value: "Montalieu (FRMNL)",
   label: "Montalieu (FRMNL)"
  },
  {
   value: "Montalieu-Vercieu (FRMOV)",
   label: "Montalieu-Vercieu (FRMOV)"
  },
  {
   value: "Montargis (FRMOS)",
   label: "Montargis (FRMOS)"
  },
  {
   value: "Montataire (FRMOE)",
   label: "Montataire (FRMOE)"
  },
  {
   value: "Montauban (FRMOT)",
   label: "Montauban (FRMOT)"
  },
  {
   value: "Montbard (FRMOD)",
   label: "Montbard (FRMOD)"
  },
  {
   value: "Montbazillac (FRMOB)",
   label: "Montbazillac (FRMOB)"
  },
  {
   value: "Montbazon (FRMNZ)",
   label: "Montbazon (FRMNZ)"
  },
  {
   value: "Montbéliard (FRMTD)",
   label: "Montbéliard (FRMTD)"
  },
  {
   value: "Montbrison (FRMTB)",
   label: "Montbrison (FRMTB)"
  },
  {
   value: "Montbrun les Bains (FRMBR)",
   label: "Montbrun les Bains (FRMBR)"
  },
  {
   value: "Montcaret (FRMTC)",
   label: "Montcaret (FRMTC)"
  },
  {
   value: "Montceau-Les-Mines (FRMLM)",
   label: "Montceau-Les-Mines (FRMLM)"
  },
  {
   value: "Montchanin (FRMOC)",
   label: "Montchanin (FRMOC)"
  },
  {
   value: "Montchevrel (FRMCH)",
   label: "Montchevrel (FRMCH)"
  },
  {
   value: "Monteaux (FRMNX)",
   label: "Monteaux (FRMNX)"
  },
  {
   value: "Montélimar (FRMTM)",
   label: "Montélimar (FRMTM)"
  },
  {
   value: "Montereau (FRMTR)",
   label: "Montereau (FRMTR)"
  },
  {
   value: "Monteux (FRMOX)",
   label: "Monteux (FRMOX)"
  },
  {
   value: "Montfaucon en Velay (FRMVY)",
   label: "Montfaucon en Velay (FRMVY)"
  },
  {
   value: "Montfort Sur Risle (FRMSR)",
   label: "Montfort Sur Risle (FRMSR)"
  },
  {
   value: "Montgiscard (FRMNG)",
   label: "Montgiscard (FRMNG)"
  },
  {
   value: "Montherme (FRMTH)",
   label: "Montherme (FRMTH)"
  },
  {
   value: "Montluçon (FRMCU)",
   label: "Montluçon (FRMCU)"
  },
  {
   value: "Montluel (FRMLL)",
   label: "Montluel (FRMLL)"
  },
  {
   value: "Montmelian (FRMML)",
   label: "Montmelian (FRMML)"
  },
  {
   value: "Montmorot (FRMTF)",
   label: "Montmorot (FRMTF)"
  },
  {
   value: "Montmort Lucy (FRMZC)",
   label: "Montmort Lucy (FRMZC)"
  },
  {
   value: "Montoir de Bretagne (FRMTX)",
   label: "Montoir de Bretagne (FRMTX)"
  },
  {
   value: "Montpellier (FRMPL)",
   label: "Montpellier (FRMPL)"
  },
  {
   value: "Montrabe (FRMTA)",
   label: "Montrabe (FRMTA)"
  },
  {
   value: "Montreuil Bellay (FRMBE)",
   label: "Montreuil Bellay (FRMBE)"
  },
  {
   value: "Montreuil Juigne (FRMOJ)",
   label: "Montreuil Juigne (FRMOJ)"
  },
  {
   value: "Montrouge (FRMTG)",
   label: "Montrouge (FRMTG)"
  },
  {
   value: "Mayenne (FRMAY)",
   label: "Mayenne (FRMAY)"
  },
  {
   value: "Mazamet (FRMAZ)",
   label: "Mazamet (FRMAZ)"
  },
  {
   value: "Meaux (FRMEA)",
   label: "Meaux (FRMEA)"
  },
  {
   value: "Megève (FRMVV)",
   label: "Megève (FRMVV)"
  },
  {
   value: "Mehun-sur-Yevre (FRMEH)",
   label: "Mehun-sur-Yevre (FRMEH)"
  },
  {
   value: "Melisey (FRMLS)",
   label: "Melisey (FRMLS)"
  },
  {
   value: "Melle (FRMLE)",
   label: "Melle (FRMLE)"
  },
  {
   value: "Melun (FRMEL)",
   label: "Melun (FRMEL)"
  },
  {
   value: "Mende (FRMEN)",
   label: "Mende (FRMEN)"
  },
  {
   value: "Menerbes (FRMNR)",
   label: "Menerbes (FRMNR)"
  },
  {
   value: "Mercurey (FRMER)",
   label: "Mercurey (FRMER)"
  },
  {
   value: "Meribel (FRMFX)",
   label: "Meribel (FRMFX)"
  },
  {
   value: "Merignac (FRMEI)",
   label: "Merignac (FRMEI)"
  },
  {
   value: "Merpins (FRMEP)",
   label: "Merpins (FRMEP)"
  },
  {
   value: "Mers Les Bains (FRMLB)",
   label: "Mers Les Bains (FRMLB)"
  },
  {
   value: "Merville (FRMEV)",
   label: "Merville (FRMEV)"
  },
  {
   value: "Meslay du Maine (FRMME)",
   label: "Meslay du Maine (FRMME)"
  },
  {
   value: "Mesnil Raoul (FRMXR)",
   label: "Mesnil Raoul (FRMXR)"
  },
  {
   value: "Messac (FRMSS)",
   label: "Messac (FRMSS)"
  },
  {
   value: "Messia sur Sorne (FRMES)",
   label: "Messia sur Sorne (FRMES)"
  },
  {
   value: "Metz (FRMZM)",
   label: "Metz (FRMZM)"
  },
  {
   value: "Metz-Tessy (FRMZT)",
   label: "Metz-Tessy (FRMZT)"
  },
  {
   value: "Meuilley (FRMLY)",
   label: "Meuilley (FRMLY)"
  },
  {
   value: "Meursault (FRMEU)",
   label: "Meursault (FRMEU)"
  },
  {
   value: "Meximieux (FRMXM)",
   label: "Meximieux (FRMXM)"
  },
  {
   value: "Meyzieu (FRMEY)",
   label: "Meyzieu (FRMEY)"
  },
  {
   value: "Mézidon Canon (FRMEZ)",
   label: "Mézidon Canon (FRMEZ)"
  },
  {
   value: "Migennes (FRMIG)",
   label: "Migennes (FRMIG)"
  },
  {
   value: "Millau (FRMIL)",
   label: "Millau (FRMIL)"
  },
  {
   value: "Milly-La-Foret (FRMIF)",
   label: "Milly-La-Foret (FRMIF)"
  },
  {
   value: "Mions (FRMIO)",
   label: "Mions (FRMIO)"
  },
  {
   value: "Miramas (FRMIR)",
   label: "Miramas (FRMIR)"
  },
  {
   value: "Miribel (FRMRB)",
   label: "Miribel (FRMRB)"
  },
  {
   value: "Mitry Mory (FRMIM)",
   label: "Mitry Mory (FRMIM)"
  },
  {
   value: "Modane (FRMDN)",
   label: "Modane (FRMDN)"
  },
  {
   value: "Moirans (FRMOI)",
   label: "Moirans (FRMOI)"
  },
  {
   value: "Moissac (FRMSC)",
   label: "Moissac (FRMSC)"
  },
  {
   value: "Molsheim (FRMOL)",
   label: "Molsheim (FRMOL)"
  },
  {
   value: "Monchy (FRMNC)",
   label: "Monchy (FRMNC)"
  },
  {
   value: "Mondelange (FRMDG)",
   label: "Mondelange (FRMDG)"
  },
  {
   value: "Magny en Vexin (FRMAG)",
   label: "Magny en Vexin (FRMAG)"
  },
  {
   value: "Maignelay Montigny (FRMAI)",
   label: "Maignelay Montigny (FRMAI)"
  },
  {
   value: "Maillet (FRMIT)",
   label: "Maillet (FRMIT)"
  },
  {
   value: "Maisdon sur Sevre (FRMAS)",
   label: "Maisdon sur Sevre (FRMAS)"
  },
  {
   value: "Maisons-Alfort (FRMSA)",
   label: "Maisons-Alfort (FRMSA)"
  },
  {
   value: "Malesherbes (FRMAL)",
   label: "Malesherbes (FRMAL)"
  },
  {
   value: "Mandeure (FRMUX)",
   label: "Mandeure (FRMUX)"
  },
  {
   value: "Manduel (FRMAD)",
   label: "Manduel (FRMAD)"
  },
  {
   value: "Manosque (FRMAQ)",
   label: "Manosque (FRMAQ)"
  },
  {
   value: "Mantes la Jolie (FRMAN)",
   label: "Mantes la Jolie (FRMAN)"
  },
  {
   value: "Marans (FRMRN)",
   label: "Marans (FRMRN)"
  },
  {
   value: "Marcigny (FRMCY)",
   label: "Marcigny (FRMCY)"
  },
  {
   value: "Marcillac Vallon (FRMVN)",
   label: "Marcillac Vallon (FRMVN)"
  },
  {
   value: "Marckolsheim (FRMKM)",
   label: "Marckolsheim (FRMKM)"
  },
  {
   value: "Marguerittes (FRMRG)",
   label: "Marguerittes (FRMRG)"
  },
  {
   value: "Margut (FRMRT)",
   label: "Margut (FRMRT)"
  },
  {
   value: "Mariac (FRMAA)",
   label: "Mariac (FRMAA)"
  },
  {
   value: "Marignane (FRMGN)",
   label: "Marignane (FRMGN)"
  },
  {
   value: "Marigny (FRMNY)",
   label: "Marigny (FRMNY)"
  },
  {
   value: "Marle (FRMRE)",
   label: "Marle (FRMRE)"
  },
  {
   value: "Marly (FRMRL)",
   label: "Marly (FRMRL)"
  },
  {
   value: "Marly-La-Ville (FRMYV)",
   label: "Marly-La-Ville (FRMYV)"
  },
  {
   value: "Marmande (FRMAR)",
   label: "Marmande (FRMAR)"
  },
  {
   value: "Marne la Vallée (FRMLV)",
   label: "Marne la Vallée (FRMLV)"
  },
  {
   value: "Maroeuil (FRMRU)",
   label: "Maroeuil (FRMRU)"
  },
  {
   value: "Marquette Lez Lille (FRMQL)",
   label: "Marquette Lez Lille (FRMQL)"
  },
  {
   value: "Marquise (FRMRQ)",
   label: "Marquise (FRMRQ)"
  },
  {
   value: "Marseille (FRMRS)",
   label: "Marseille (FRMRS)"
  },
  {
   value: "Martigues (FRMTU)",
   label: "Martigues (FRMTU)"
  },
  {
   value: "Marville (FRMRV)",
   label: "Marville (FRMRV)"
  },
  {
   value: "Massy (FRMSY)",
   label: "Massy (FRMSY)"
  },
  {
   value: "Matha (FRMAT)",
   label: "Matha (FRMAT)"
  },
  {
   value: "Matour (FRMAO)",
   label: "Matour (FRMAO)"
  },
  {
   value: "Maubeuge (FRMAU)",
   label: "Maubeuge (FRMAU)"
  },
  {
   value: "Maubourguet (FRMAB)",
   label: "Maubourguet (FRMAB)"
  },
  {
   value: "Mauguio (FRMGU)",
   label: "Mauguio (FRMGU)"
  },
  {
   value: "Maumusson-Laguian (FRMMS)",
   label: "Maumusson-Laguian (FRMMS)"
  },
  {
   value: "Maurepas (FRMRP)",
   label: "Maurepas (FRMRP)"
  },
  {
   value: "Maxeville (FRMAX)",
   label: "Maxeville (FRMAX)"
  },
  {
   value: "Lisieux (FRLIX)",
   label: "Lisieux (FRLIX)"
  },
  {
   value: "Lisle sur Tarn (FRLIT)",
   label: "Lisle sur Tarn (FRLIT)"
  },
  {
   value: "Liverdun (FRLVD)",
   label: "Liverdun (FRLVD)"
  },
  {
   value: "Livron-sur-Drome (FRLSD)",
   label: "Livron-sur-Drome (FRLSD)"
  },
  {
   value: "Livry-Gargan (FRLGN)",
   label: "Livry-Gargan (FRLGN)"
  },
  {
   value: "Lizy sur Ourcq (FRLZO)",
   label: "Lizy sur Ourcq (FRLZO)"
  },
  {
   value: "Loctudy (FRLOC)",
   label: "Loctudy (FRLOC)"
  },
  {
   value: "Loges (FRLGS)",
   label: "Loges (FRLGS)"
  },
  {
   value: "Lognes (FRLOG)",
   label: "Lognes (FRLOG)"
  },
  {
   value: "Loison sous Lens (FRLOL)",
   label: "Loison sous Lens (FRLOL)"
  },
  {
   value: "Lomme (FRLOM)",
   label: "Lomme (FRLOM)"
  },
  {
   value: "Longeville (FRLNV)",
   label: "Longeville (FRLNV)"
  },
  {
   value: "Longjumeau (FRLNJ)",
   label: "Longjumeau (FRLNJ)"
  },
  {
   value: "Longueville (FRLON)",
   label: "Longueville (FRLON)"
  },
  {
   value: "Longueville sur Scie (FRLNG)",
   label: "Longueville sur Scie (FRLNG)"
  },
  {
   value: "Longvic (FRLOV)",
   label: "Longvic (FRLOV)"
  },
  {
   value: "Longwy (FRLOY)",
   label: "Longwy (FRLOY)"
  },
  {
   value: "Lons le Saunier (FRLLS)",
   label: "Lons le Saunier (FRLLS)"
  },
  {
   value: "Loon-Plage (FRLOO)",
   label: "Loon-Plage (FRLOO)"
  },
  {
   value: "Lorgues (FRLRS)",
   label: "Lorgues (FRLRS)"
  },
  {
   value: "Lorient (FRLRT)",
   label: "Lorient (FRLRT)"
  },
  {
   value: "Loriol sur Drome (FRLOR)",
   label: "Loriol sur Drome (FRLOR)"
  },
  {
   value: "Lormont (FRLMO)",
   label: "Lormont (FRLMO)"
  },
  {
   value: "Loudeac (FRLUD)",
   label: "Loudeac (FRLUD)"
  },
  {
   value: "Loudun (FRLOD)",
   label: "Loudun (FRLOD)"
  },
  {
   value: "Lourdes (FRLDE)",
   label: "Lourdes (FRLDE)"
  },
  {
   value: "Louvres (FRUVR)",
   label: "Louvres (FRUVR)"
  },
  {
   value: "Lubersac (FRLUB)",
   label: "Lubersac (FRLUB)"
  },
  {
   value: "Lugny (FRLUG)",
   label: "Lugny (FRLUG)"
  },
  {
   value: "Lumes (FRLUM)",
   label: "Lumes (FRLUM)"
  },
  {
   value: "Lunel-Viel (FRLUN)",
   label: "Lunel-Viel (FRLUN)"
  },
  {
   value: "Lury-sur-Arnon (FRLYA)",
   label: "Lury-sur-Arnon (FRLYA)"
  },
  {
   value: "Lusigny (FRLUS)",
   label: "Lusigny (FRLUS)"
  },
  {
   value: "Luzenac (FRLUZ)",
   label: "Luzenac (FRLUZ)"
  },
  {
   value: "Lyon (FRLIO)",
   label: "Lyon (FRLIO)"
  },
  {
   value: "Lyon-Bron Apt (FRLYN)",
   label: "Lyon-Bron Apt (FRLYN)"
  },
  {
   value: "Lyon-Satolas Apt (FRLYS)",
   label: "Lyon-Satolas Apt (FRLYS)"
  },
  {
   value: "Lyons la Foret (FRLYO)",
   label: "Lyons la Foret (FRLYO)"
  },
  {
   value: "Machecoul (FRMAH)",
   label: "Machecoul (FRMAH)"
  },
  {
   value: "Mâcon (FRMAC)",
   label: "Mâcon (FRMAC)"
  },
  {
   value: "Lege (FRLGE)",
   label: "Lege (FRLGE)"
  },
  {
   value: "Lembeye (FRLEM)",
   label: "Lembeye (FRLEM)"
  },
  {
   value: "Lens (FRLEN)",
   label: "Lens (FRLEN)"
  },
  {
   value: "Leognan (FRLEO)",
   label: "Leognan (FRLEO)"
  },
  {
   value: "Lery (FRLRY)",
   label: "Lery (FRLRY)"
  },
  {
   value: "Les Andelys (FRLAY)",
   label: "Les Andelys (FRLAY)"
  },
  {
   value: "Les Arcs (FRLAR)",
   label: "Les Arcs (FRLAR)"
  },
  {
   value: "Les Avenieres (FRLSA)",
   label: "Les Avenieres (FRLSA)"
  },
  {
   value: "Les Cheres (FRLSH)",
   label: "Les Cheres (FRLSH)"
  },
  {
   value: "Les Hautes-Riviers (FRLHR)",
   label: "Les Hautes-Riviers (FRLHR)"
  },
  {
   value: "Les Laumes (FRLLA)",
   label: "Les Laumes (FRLLA)"
  },
  {
   value: "Les Lucs sur Boulogne (FRLLB)",
   label: "Les Lucs sur Boulogne (FRLLB)"
  },
  {
   value: "Les Mees (FRLSM)",
   label: "Les Mees (FRLSM)"
  },
  {
   value: "Les Milles (FRLML)",
   label: "Les Milles (FRLML)"
  },
  {
   value: "Les Mureaux (FRLMX)",
   label: "Les Mureaux (FRLMX)"
  },
  {
   value: "Les Pennes Mirabeau (FRLPN)",
   label: "Les Pennes Mirabeau (FRLPN)"
  },
  {
   value: "Les Sables D'olonne (FRLSO)",
   label: "Les Sables D'olonne (FRLSO)"
  },
  {
   value: "Les Ulis (FRLUL)",
   label: "Les Ulis (FRLUL)"
  },
  {
   value: "Les Vigneres (FRLVG)",
   label: "Les Vigneres (FRLVG)"
  },
  {
   value: "Lesparre-Medoc (FRLMC)",
   label: "Lesparre-Medoc (FRLMC)"
  },
  {
   value: "Lesquin (FRLSQ)",
   label: "Lesquin (FRLSQ)"
  },
  {
   value: "Lestrem (FRLSR)",
   label: "Lestrem (FRLSR)"
  },
  {
   value: "Levallois-Perret (FRLPT)",
   label: "Levallois-Perret (FRLPT)"
  },
  {
   value: "Lexy (FRLEX)",
   label: "Lexy (FRLEX)"
  },
  {
   value: "Lézardrieux (FRLEZ)",
   label: "Lézardrieux (FRLEZ)"
  },
  {
   value: "Lezignan Corbieres (FRLZC)",
   label: "Lezignan Corbieres (FRLZC)"
  },
  {
   value: "Lezinnes (FRLZI)",
   label: "Lezinnes (FRLZI)"
  },
  {
   value: "Liancourt (FRLNR)",
   label: "Liancourt (FRLNR)"
  },
  {
   value: "Libourne (FRLIB)",
   label: "Libourne (FRLIB)"
  },
  {
   value: "Liesse Notre Dame (FRLXX)",
   label: "Liesse Notre Dame (FRLXX)"
  },
  {
   value: "Lieusaint (FRLES)",
   label: "Lieusaint (FRLES)"
  },
  {
   value: "Liffre (FRLFF)",
   label: "Liffre (FRLFF)"
  },
  {
   value: "Lille (FRLLE)",
   label: "Lille (FRLLE)"
  },
  {
   value: "Lillebonne (FRLNE)",
   label: "Lillebonne (FRLNE)"
  },
  {
   value: "Limoges (FRLIG)",
   label: "Limoges (FRLIG)"
  },
  {
   value: "Limoux (FRLIM)",
   label: "Limoux (FRLIM)"
  },
  {
   value: "Lingolsheim (FRLGH)",
   label: "Lingolsheim (FRLGH)"
  },
  {
   value: "Linselles (FRLIN)",
   label: "Linselles (FRLIN)"
  },
  {
   value: "Liomer (FRLXM)",
   label: "Liomer (FRLXM)"
  },
  {
   value: "Laveyrune (FRLVY)",
   label: "Laveyrune (FRLVY)"
  },
  {
   value: "Le Blanc Mesnil (FRLBM)",
   label: "Le Blanc Mesnil (FRLBM)"
  },
  {
   value: "Le Boucau (FRLBQ)",
   label: "Le Boucau (FRLBQ)"
  },
  {
   value: "Le Boulou (FRLEB)",
   label: "Le Boulou (FRLEB)"
  },
  {
   value: "Le Bourget Apt\/Paris (FRLBG)",
   label: "Le Bourget Apt\/Paris (FRLBG)"
  },
  {
   value: "Le Bourget du Lac (FRLDL)",
   label: "Le Bourget du Lac (FRLDL)"
  },
  {
   value: "Le Cannet (FRLEC)",
   label: "Le Cannet (FRLEC)"
  },
  {
   value: "Le Castellet (FRCTT)",
   label: "Le Castellet (FRCTT)"
  },
  {
   value: "Le Creusot (FRLCR)",
   label: "Le Creusot (FRLCR)"
  },
  {
   value: "Le Fayet (FRLEF)",
   label: "Le Fayet (FRLEF)"
  },
  {
   value: "Le Fousseret (FRLFO)",
   label: "Le Fousseret (FRLFO)"
  },
  {
   value: "Le Fret (FRLFR)",
   label: "Le Fret (FRLFR)"
  },
  {
   value: "Le Guildo\/Crehen (FRLGU)",
   label: "Le Guildo\/Crehen (FRLGU)"
  },
  {
   value: "Le Havre (FRLEH)",
   label: "Le Havre (FRLEH)"
  },
  {
   value: "Le Kremlin Bicetre (FRLKB)",
   label: "Le Kremlin Bicetre (FRLKB)"
  },
  {
   value: "Le Landreau (FRLLN)",
   label: "Le Landreau (FRLLN)"
  },
  {
   value: "Le Luc (FRLEL)",
   label: "Le Luc (FRLEL)"
  },
  {
   value: "Le Lude (FRLLU)",
   label: "Le Lude (FRLLU)"
  },
  {
   value: "Le Mans (FRLME)",
   label: "Le Mans (FRLME)"
  },
  {
   value: "Le Mele sur Sarthe (FRLMH)",
   label: "Le Mele sur Sarthe (FRLMH)"
  },
  {
   value: "Le Mesnil (FRLMS)",
   label: "Le Mesnil (FRLMS)"
  },
  {
   value: "Le Mont-Dore (FRLUA)",
   label: "Le Mont-Dore (FRLUA)"
  },
  {
   value: "Le Passage (FRLEP)",
   label: "Le Passage (FRLEP)"
  },
  {
   value: "Le Péage du Roussillon (FRPER)",
   label: "Le Péage du Roussillon (FRPER)"
  },
  {
   value: "Le Petit Queville (FRPQV)",
   label: "Le Petit Queville (FRPQV)"
  },
  {
   value: "Le Pin en Mauges (FRLPM)",
   label: "Le Pin en Mauges (FRLPM)"
  },
  {
   value: "Le Plessis Belleville (FRLPB)",
   label: "Le Plessis Belleville (FRLPB)"
  },
  {
   value: "Le Plessis-Robinson (FRLPS)",
   label: "Le Plessis-Robinson (FRLPS)"
  },
  {
   value: "Le Pont de Claix (FRPCX)",
   label: "Le Pont de Claix (FRPCX)"
  },
  {
   value: "Le Pontet (FRLPO)",
   label: "Le Pontet (FRLPO)"
  },
  {
   value: "Le Puy En Velay (FRLPY)",
   label: "Le Puy En Velay (FRLPY)"
  },
  {
   value: "Le Thillot (FRLTH)",
   label: "Le Thillot (FRLTH)"
  },
  {
   value: "Le Tholy (FRLLY)",
   label: "Le Tholy (FRLLY)"
  },
  {
   value: "Le Touquet (FRLTQ)",
   label: "Le Touquet (FRLTQ)"
  },
  {
   value: "Le Tréport (FRLTR)",
   label: "Le Tréport (FRLTR)"
  },
  {
   value: "Le Verdon (FRLVE)",
   label: "Le Verdon (FRLVE)"
  },
  {
   value: "Le Vesinet (FRLVN)",
   label: "Le Vesinet (FRLVN)"
  },
  {
   value: "Leers (FRLEE)",
   label: "Leers (FRLEE)"
  },
  {
   value: "Labatut-Riviere (FRLBT)",
   label: "Labatut-Riviere (FRLBT)"
  },
  {
   value: "Labenne (FRLBN)",
   label: "Labenne (FRLBN)"
  },
  {
   value: "Laborel (FRLBL)",
   label: "Laborel (FRLBL)"
  },
  {
   value: "Labruguiere (FRLBR)",
   label: "Labruguiere (FRLBR)"
  },
  {
   value: "Lacaune (FRLCU)",
   label: "Lacaune (FRLCU)"
  },
  {
   value: "Lacq (FRLAC)",
   label: "Lacq (FRLAC)"
  },
  {
   value: "Ladoix Serrigny (FRLXS)",
   label: "Ladoix Serrigny (FRLXS)"
  },
  {
   value: "Lafitte (FRLFT)",
   label: "Lafitte (FRLFT)"
  },
  {
   value: "Lagnieu (FRLAG)",
   label: "Lagnieu (FRLAG)"
  },
  {
   value: "Lagny sur Marne (FRLGM)",
   label: "Lagny sur Marne (FRLGM)"
  },
  {
   value: "Lalinde (FRLAL)",
   label: "Lalinde (FRLAL)"
  },
  {
   value: "Lamanon (FRLAM)",
   label: "Lamanon (FRLAM)"
  },
  {
   value: "Lamastre (FRLAE)",
   label: "Lamastre (FRLAE)"
  },
  {
   value: "Lamballe (FRLMB)",
   label: "Lamballe (FRLMB)"
  },
  {
   value: "Lancey (FRLNC)",
   label: "Lancey (FRLNC)"
  },
  {
   value: "Landerneau (FRLDN)",
   label: "Landerneau (FRLDN)"
  },
  {
   value: "Landersheim (FRLDH)",
   label: "Landersheim (FRLDH)"
  },
  {
   value: "Landiras (FRLND)",
   label: "Landiras (FRLND)"
  },
  {
   value: "Landivisiau (FRLDV)",
   label: "Landivisiau (FRLDV)"
  },
  {
   value: "Lanester (FRLNS)",
   label: "Lanester (FRLNS)"
  },
  {
   value: "Langeac (FRLGX)",
   label: "Langeac (FRLGX)"
  },
  {
   value: "Langres (FRLAN)",
   label: "Langres (FRLAN)"
  },
  {
   value: "Lannemezan (FRLZN)",
   label: "Lannemezan (FRLZN)"
  },
  {
   value: "Lannion (FRLAI)",
   label: "Lannion (FRLAI)"
  },
  {
   value: "Lansac (FRLSC)",
   label: "Lansac (FRLSC)"
  },
  {
   value: "Laon (FRLAO)",
   label: "Laon (FRLAO)"
  },
  {
   value: "Lapalisse (FRLPL)",
   label: "Lapalisse (FRLPL)"
  },
  {
   value: "Lapugnoy (FRLPU)",
   label: "Lapugnoy (FRLPU)"
  },
  {
   value: "Lassay Les Chateuax (FRLLC)",
   label: "Lassay Les Chateuax (FRLLC)"
  },
  {
   value: "Lassigny (FRLSY)",
   label: "Lassigny (FRLSY)"
  },
  {
   value: "Latour de Carol (FRLDC)",
   label: "Latour de Carol (FRLDC)"
  },
  {
   value: "Laudun (FRLUU)",
   label: "Laudun (FRLUU)"
  },
  {
   value: "Laujuzan (FRLJZ)",
   label: "Laujuzan (FRLJZ)"
  },
  {
   value: "Lauterbourg (FRLAU)",
   label: "Lauterbourg (FRLAU)"
  },
  {
   value: "Laval (FRLVA)",
   label: "Laval (FRLVA)"
  },
  {
   value: "Lavaur (FRLVR)",
   label: "Lavaur (FRLVR)"
  },
  {
   value: "Lavelanet (FRLAT)",
   label: "Lavelanet (FRLAT)"
  },
  {
   value: "Laveline devant Bruyeres (FRLDB)",
   label: "Laveline devant Bruyeres (FRLDB)"
  },
  {
   value: "Lavera (FRLAV)",
   label: "Lavera (FRLAV)"
  },
  {
   value: "Laveur (FRLVU)",
   label: "Laveur (FRLVU)"
  },
  {
   value: "La Coquille (FRLCQ)",
   label: "La Coquille (FRLCQ)"
  },
  {
   value: "La Courneuve (FRLCV)",
   label: "La Courneuve (FRLCV)"
  },
  {
   value: "La Courtine (FRLCO)",
   label: "La Courtine (FRLCO)"
  },
  {
   value: "La Ferte Gaucher (FRLFG)",
   label: "La Ferte Gaucher (FRLFG)"
  },
  {
   value: "La Fleche (FRLFL)",
   label: "La Fleche (FRLFL)"
  },
  {
   value: "La Fossette (FRLFS)",
   label: "La Fossette (FRLFS)"
  },
  {
   value: "La Fouillouse (FRLFU)",
   label: "La Fouillouse (FRLFU)"
  },
  {
   value: "La Garde Freinet (FRLGF)",
   label: "La Garde Freinet (FRLGF)"
  },
  {
   value: "La Grand Croix (FRGCR)",
   label: "La Grand Croix (FRGCR)"
  },
  {
   value: "La Haye Fouassiere (FRLHF)",
   label: "La Haye Fouassiere (FRLHF)"
  },
  {
   value: "La Longine (FRLLO)",
   label: "La Longine (FRLLO)"
  },
  {
   value: "La Longueville (FRLUV)",
   label: "La Longueville (FRLUV)"
  },
  {
   value: "La Machine (FRLMI)",
   label: "La Machine (FRLMI)"
  },
  {
   value: "La Madeleine (FRLMA)",
   label: "La Madeleine (FRLMA)"
  },
  {
   value: "La Mède (FRLMD)",
   label: "La Mède (FRLMD)"
  },
  {
   value: "La Motte (FRLMT)",
   label: "La Motte (FRLMT)"
  },
  {
   value: "La Mure (FRLMU)",
   label: "La Mure (FRLMU)"
  },
  {
   value: "La Pallice (FRLPE)",
   label: "La Pallice (FRLPE)"
  },
  {
   value: "La Penne sur Huveune (FRLPH)",
   label: "La Penne sur Huveune (FRLPH)"
  },
  {
   value: "La Plagne (FRPLG)",
   label: "La Plagne (FRPLG)"
  },
  {
   value: "La Puye (FRPUI)",
   label: "La Puye (FRPUI)"
  },
  {
   value: "La Riche (FRLRI)",
   label: "La Riche (FRLRI)"
  },
  {
   value: "La Roche de Glun (FRLRG)",
   label: "La Roche de Glun (FRLRG)"
  },
  {
   value: "La Roche sur Foron (FRLRF)",
   label: "La Roche sur Foron (FRLRF)"
  },
  {
   value: "La Roche sur Yon (FREDM)",
   label: "La Roche sur Yon (FREDM)"
  },
  {
   value: "La Roche-Bernard (FRLSZ)",
   label: "La Roche-Bernard (FRLSZ)"
  },
  {
   value: "La Rochelle (FRLRH)",
   label: "La Rochelle (FRLRH)"
  },
  {
   value: "La Romieu (FRLRM)",
   label: "La Romieu (FRLRM)"
  },
  {
   value: "La Suze sur Sarthe (FRSZS)",
   label: "La Suze sur Sarthe (FRSZS)"
  },
  {
   value: "La Talaudiere (FRLTD)",
   label: "La Talaudiere (FRLTD)"
  },
  {
   value: "La Tour d'Aigues (FRLTA)",
   label: "La Tour d'Aigues (FRLTA)"
  },
  {
   value: "La Tour Du Pin (FRLTP)",
   label: "La Tour Du Pin (FRLTP)"
  },
  {
   value: "La Tronche (FRLTN)",
   label: "La Tronche (FRLTN)"
  },
  {
   value: "La Valbonne (FRVLB)",
   label: "La Valbonne (FRVLB)"
  },
  {
   value: "La Verpilliere (FRLVP)",
   label: "La Verpilliere (FRLVP)"
  },
  {
   value: "La Veuve (FRLVV)",
   label: "La Veuve (FRLVV)"
  },
  {
   value: "La Voulte sur Rhone (FRLVO)",
   label: "La Voulte sur Rhone (FRLVO)"
  },
  {
   value: "Jarrie (FRJRR)",
   label: "Jarrie (FRJRR)"
  },
  {
   value: "Jassans-Riottier (FRJSR)",
   label: "Jassans-Riottier (FRJSR)"
  },
  {
   value: "Jaux (FRJUX)",
   label: "Jaux (FRJUX)"
  },
  {
   value: "Javron-les-Chapelles (FRJVR)",
   label: "Javron-les-Chapelles (FRJVR)"
  },
  {
   value: "Jonzac (FRJNZ)",
   label: "Jonzac (FRJNZ)"
  },
  {
   value: "Joue Les Tours (FRJTS)",
   label: "Joue Les Tours (FRJTS)"
  },
  {
   value: "Juan Les Pins (FRJLP)",
   label: "Juan Les Pins (FRJLP)"
  },
  {
   value: "Julienas (FRJLN)",
   label: "Julienas (FRJLN)"
  },
  {
   value: "Julienne (FRJNE)",
   label: "Julienne (FRJNE)"
  },
  {
   value: "Juvisy (FRJUV)",
   label: "Juvisy (FRJUV)"
  },
  {
   value: "Kilstett (FRKLS)",
   label: "Kilstett (FRKLS)"
  },
  {
   value: "Kunheim (FRKUN)",
   label: "Kunheim (FRKUN)"
  },
  {
   value: "L'Ardoise (FRLAD)",
   label: "L'Ardoise (FRLAD)"
  },
  {
   value: "L'Horme (FRLHO)",
   label: "L'Horme (FRLHO)"
  },
  {
   value: "L'Ile Rousse (FRILR)",
   label: "L'Ile Rousse (FRILR)"
  },
  {
   value: "L'Isle d'Abeau (FRLIA)",
   label: "L'Isle d'Abeau (FRLIA)"
  },
  {
   value: "L'Isle sur la Sorgue (FRLIS)",
   label: "L'Isle sur la Sorgue (FRLIS)"
  },
  {
   value: "L'Oie (FRLOI)",
   label: "L'Oie (FRLOI)"
  },
  {
   value: "La Bastide (FRLBS)",
   label: "La Bastide (FRLBS)"
  },
  {
   value: "La Bathie (FRLAB)",
   label: "La Bathie (FRLAB)"
  },
  {
   value: "La Baule (FRLBY)",
   label: "La Baule (FRLBY)"
  },
  {
   value: "La Bazoche Gouet (FRLZG)",
   label: "La Bazoche Gouet (FRLZG)"
  },
  {
   value: "La Bocca (FRLBO)",
   label: "La Bocca (FRLBO)"
  },
  {
   value: "La Bruffiere (FRLBF)",
   label: "La Bruffiere (FRLBF)"
  },
  {
   value: "La Bruguiere (FRLBU)",
   label: "La Bruguiere (FRLBU)"
  },
  {
   value: "La Chambre (FRLCB)",
   label: "La Chambre (FRLCB)"
  },
  {
   value: "La Chapelle Basse Mer (FRCBM)",
   label: "La Chapelle Basse Mer (FRCBM)"
  },
  {
   value: "La Chapelle d'Armentieres (FRLCD)",
   label: "La Chapelle d'Armentieres (FRLCD)"
  },
  {
   value: "La Chapelle de Guinchay (FRLCY)",
   label: "La Chapelle de Guinchay (FRLCY)"
  },
  {
   value: "La Chapelle Heulin (FRLHE)",
   label: "La Chapelle Heulin (FRLHE)"
  },
  {
   value: "La Chapelle St Luc (FRLSL)",
   label: "La Chapelle St Luc (FRLSL)"
  },
  {
   value: "La Chapelle St Mesmin (FRLCM)",
   label: "La Chapelle St Mesmin (FRLCM)"
  },
  {
   value: "La Chapelle\/Paris (FRLCH)",
   label: "La Chapelle\/Paris (FRLCH)"
  },
  {
   value: "La Chataigneraie (FRLCE)",
   label: "La Chataigneraie (FRLCE)"
  },
  {
   value: "La Ciotat (FRLCT)",
   label: "La Ciotat (FRLCT)"
  },
  {
   value: "La Clayette (FRLCA)",
   label: "La Clayette (FRLCA)"
  },
  {
   value: "La Colle sur Loup (FRLCL)",
   label: "La Colle sur Loup (FRLCL)"
  },
  {
   value: "Guebwiller (FRGWB)",
   label: "Guebwiller (FRGWB)"
  },
  {
   value: "Guéret (FRGUE)",
   label: "Guéret (FRGUE)"
  },
  {
   value: "Guerlesquin (FRGUQ)",
   label: "Guerlesquin (FRGUQ)"
  },
  {
   value: "Gueugnon (FRGUG)",
   label: "Gueugnon (FRGUG)"
  },
  {
   value: "Guidel (FRGUD)",
   label: "Guidel (FRGUD)"
  },
  {
   value: "Guillotière\/Lyon (FRGRE)",
   label: "Guillotière\/Lyon (FRGRE)"
  },
  {
   value: "Guimerville (FRGUM)",
   label: "Guimerville (FRGUM)"
  },
  {
   value: "Guingamp (FRGUI)",
   label: "Guingamp (FRGUI)"
  },
  {
   value: "Guipry (FRGPY)",
   label: "Guipry (FRGPY)"
  },
  {
   value: "Hagondange (FRHAE)",
   label: "Hagondange (FRHAE)"
  },
  {
   value: "Haguenau (FRHAG)",
   label: "Haguenau (FRHAG)"
  },
  {
   value: "Halluin (FRHAL)",
   label: "Halluin (FRHAL)"
  },
  {
   value: "Ham (FRHAM)",
   label: "Ham (FRHAM)"
  },
  {
   value: "Harfleur (FRHRF)",
   label: "Harfleur (FRHRF)"
  },
  {
   value: "Hasnon (FRHAS)",
   label: "Hasnon (FRHAS)"
  },
  {
   value: "Haubourdin (FRHAU)",
   label: "Haubourdin (FRHAU)"
  },
  {
   value: "Hazebrouck (FRHZB)",
   label: "Hazebrouck (FRHZB)"
  },
  {
   value: "Henansal (FRHNS)",
   label: "Henansal (FRHNS)"
  },
  {
   value: "Hendaye (FRHEN)",
   label: "Hendaye (FRHEN)"
  },
  {
   value: "Hénin Beaumont (FRHEB)",
   label: "Hénin Beaumont (FRHEB)"
  },
  {
   value: "Hennebont (FRHET)",
   label: "Hennebont (FRHET)"
  },
  {
   value: "Hesdin (FRHES)",
   label: "Hesdin (FRHES)"
  },
  {
   value: "Hoerdt (FRHOE)",
   label: "Hoerdt (FRHOE)"
  },
  {
   value: "Honfleur (FRHON)",
   label: "Honfleur (FRHON)"
  },
  {
   value: "Hourcade\/Bordeaux (FRHOU)",
   label: "Hourcade\/Bordeaux (FRHOU)"
  },
  {
   value: "Huisseau-sur-Cosson (FRHUI)",
   label: "Huisseau-sur-Cosson (FRHUI)"
  },
  {
   value: "Huninghe (FRHUN)",
   label: "Huninghe (FRHUN)"
  },
  {
   value: "Idron--Ousse-Sendets (FRIDR)",
   label: "Idron--Ousse-Sendets (FRIDR)"
  },
  {
   value: "Illfurth (FRIUH)",
   label: "Illfurth (FRIUH)"
  },
  {
   value: "Illiers-Combray (FRILC)",
   label: "Illiers-Combray (FRILC)"
  },
  {
   value: "Illzach (FRILZ)",
   label: "Illzach (FRILZ)"
  },
  {
   value: "Imphy (FRIPH)",
   label: "Imphy (FRIPH)"
  },
  {
   value: "Ingwiller (FRINW)",
   label: "Ingwiller (FRINW)"
  },
  {
   value: "Irigny (FRIRI)",
   label: "Irigny (FRIRI)"
  },
  {
   value: "Isigny sur Mere (FRISM)",
   label: "Isigny sur Mere (FRISM)"
  },
  {
   value: "Issoire (FRISS)",
   label: "Issoire (FRISS)"
  },
  {
   value: "Issy les Moulineaux (FRILM)",
   label: "Issy les Moulineaux (FRILM)"
  },
  {
   value: "Ivry sur Seine (FRIVS)",
   label: "Ivry sur Seine (FRIVS)"
  },
  {
   value: "Izon (FRIZO)",
   label: "Izon (FRIZO)"
  },
  {
   value: "Jarnac (FRJAR)",
   label: "Jarnac (FRJAR)"
  },
  {
   value: "Gerzat (FRGRZ)",
   label: "Gerzat (FRGRZ)"
  },
  {
   value: "Gevrey-Chambertin (FRGEC)",
   label: "Gevrey-Chambertin (FRGEC)"
  },
  {
   value: "Gibraltar (FRGBR)",
   label: "Gibraltar (FRGBR)"
  },
  {
   value: "Gien (FRGIE)",
   label: "Gien (FRGIE)"
  },
  {
   value: "Giens (FRGIN)",
   label: "Giens (FRGIN)"
  },
  {
   value: "Giez (FRGIZ)",
   label: "Giez (FRGIZ)"
  },
  {
   value: "Gignac (FRGGN)",
   label: "Gignac (FRGGN)"
  },
  {
   value: "Gilocourt (FRGIC)",
   label: "Gilocourt (FRGIC)"
  },
  {
   value: "Gironde sur Dropt (FRGIR)",
   label: "Gironde sur Dropt (FRGIR)"
  },
  {
   value: "Gisors (FRGSR)",
   label: "Gisors (FRGSR)"
  },
  {
   value: "Givet (FRGIV)",
   label: "Givet (FRGIV)"
  },
  {
   value: "Givors (FRGIS)",
   label: "Givors (FRGIS)"
  },
  {
   value: "Golbey (FRGOL)",
   label: "Golbey (FRGOL)"
  },
  {
   value: "Goncelin (FRGCI)",
   label: "Goncelin (FRGCI)"
  },
  {
   value: "Gond Pontouvre (FRGOP)",
   label: "Gond Pontouvre (FRGOP)"
  },
  {
   value: "Gondrecourt-le-Chateau (FRGLC)",
   label: "Gondrecourt-le-Chateau (FRGLC)"
  },
  {
   value: "Gondreville (FRGOV)",
   label: "Gondreville (FRGOV)"
  },
  {
   value: "Gonesse (FRONE)",
   label: "Gonesse (FRONE)"
  },
  {
   value: "Gonfreville l'Orcher (FRGLO)",
   label: "Gonfreville l'Orcher (FRGLO)"
  },
  {
   value: "Gonnehem (FRGOH)",
   label: "Gonnehem (FRGOH)"
  },
  {
   value: "Gorcy (FRGOR)",
   label: "Gorcy (FRGOR)"
  },
  {
   value: "Gourin (FRGOU)",
   label: "Gourin (FRGOU)"
  },
  {
   value: "Gournay-en-Bray (FRGOY)",
   label: "Gournay-en-Bray (FRGOY)"
  },
  {
   value: "Gouvieux (FRGOX)",
   label: "Gouvieux (FRGOX)"
  },
  {
   value: "Gouzeaucourt (FRGZC)",
   label: "Gouzeaucourt (FRGZC)"
  },
  {
   value: "Gradignan (FRGRG)",
   label: "Gradignan (FRGRG)"
  },
  {
   value: "Grand Synthe (FRGDS)",
   label: "Grand Synthe (FRGDS)"
  },
  {
   value: "Grand Couronne (FRGRC)",
   label: "Grand Couronne (FRGRC)"
  },
  {
   value: "Grand Pressigny (FRGRP)",
   label: "Grand Pressigny (FRGRP)"
  },
  {
   value: "Grandpuits Bailly Carrois (FRGBC)",
   label: "Grandpuits Bailly Carrois (FRGBC)"
  },
  {
   value: "Granville (FRGFR)",
   label: "Granville (FRGFR)"
  },
  {
   value: "Grasse (FRGRS)",
   label: "Grasse (FRGRS)"
  },
  {
   value: "Graulhet (FRGLH)",
   label: "Graulhet (FRGLH)"
  },
  {
   value: "Gravelines (FRGRV)",
   label: "Gravelines (FRGRV)"
  },
  {
   value: "Gravenchon (FRGRN)",
   label: "Gravenchon (FRGRN)"
  },
  {
   value: "Gray (FRGRY)",
   label: "Gray (FRGRY)"
  },
  {
   value: "Grenoble (FRGNB)",
   label: "Grenoble (FRGNB)"
  },
  {
   value: "Gretz Armainvilliers (FRGRA)",
   label: "Gretz Armainvilliers (FRGRA)"
  },
  {
   value: "Groissiat (FRGRT)",
   label: "Groissiat (FRGRT)"
  },
  {
   value: "Fontenay Le Comte (FRFOC)",
   label: "Fontenay Le Comte (FRFOC)"
  },
  {
   value: "Fontoy (FRFTY)",
   label: "Fontoy (FRFTY)"
  },
  {
   value: "Fontvielle (FRFNV)",
   label: "Fontvielle (FRFNV)"
  },
  {
   value: "Forbach (FRFOR)",
   label: "Forbach (FRFOR)"
  },
  {
   value: "Foreste (FRFRS)",
   label: "Foreste (FRFRS)"
  },
  {
   value: "Fos sur Mer (FRFOS)",
   label: "Fos sur Mer (FRFOS)"
  },
  {
   value: "Foug (FRFOG)",
   label: "Foug (FRFOG)"
  },
  {
   value: "Fougères (FRFOU)",
   label: "Fougères (FRFOU)"
  },
  {
   value: "Fourmies (FRFRM)",
   label: "Fourmies (FRFRM)"
  },
  {
   value: "Fournes-en-Weppe (FRFOW)",
   label: "Fournes-en-Weppe (FRFOW)"
  },
  {
   value: "Franqueville (FRFRA)",
   label: "Franqueville (FRFRA)"
  },
  {
   value: "Fréjus (FRFRJ)",
   label: "Fréjus (FRFRJ)"
  },
  {
   value: "Fresnoy-Le-Grand (FRFRY)",
   label: "Fresnoy-Le-Grand (FRFRY)"
  },
  {
   value: "Froges (FRFGE)",
   label: "Froges (FRFGE)"
  },
  {
   value: "Froidefontaine (FRFFI)",
   label: "Froidefontaine (FRFFI)"
  },
  {
   value: "Frontignan (FRFRO)",
   label: "Frontignan (FRFRO)"
  },
  {
   value: "Fronton (FRFNN)",
   label: "Fronton (FRFNN)"
  },
  {
   value: "Fumel (FRFUM)",
   label: "Fumel (FRFUM)"
  },
  {
   value: "Gaillac d'Aveyron (FRGAA)",
   label: "Gaillac d'Aveyron (FRGAA)"
  },
  {
   value: "Gaillard (FRGAD)",
   label: "Gaillard (FRGAD)"
  },
  {
   value: "Gaillon (FRGAI)",
   label: "Gaillon (FRGAI)"
  },
  {
   value: "Gamaches (FRGCS)",
   label: "Gamaches (FRGCS)"
  },
  {
   value: "Gambais (FRGAM)",
   label: "Gambais (FRGAM)"
  },
  {
   value: "Gannat (FRGAN)",
   label: "Gannat (FRGAN)"
  },
  {
   value: "Gap (FRGAT)",
   label: "Gap (FRGAT)"
  },
  {
   value: "Gardanne (FRGDE)",
   label: "Gardanne (FRGDE)"
  },
  {
   value: "Gargenville (FRGAR)",
   label: "Gargenville (FRGAR)"
  },
  {
   value: "Garges les Gonesses (FRGLG)",
   label: "Garges les Gonesses (FRGLG)"
  },
  {
   value: "Gassin (FRGAS)",
   label: "Gassin (FRGAS)"
  },
  {
   value: "Gastins (FRGST)",
   label: "Gastins (FRGST)"
  },
  {
   value: "Gauchy (FRGAU)",
   label: "Gauchy (FRGAU)"
  },
  {
   value: "Gaye (FRGAE)",
   label: "Gaye (FRGAE)"
  },
  {
   value: "Gemenos (FRGEM)",
   label: "Gemenos (FRGEM)"
  },
  {
   value: "Gemozac (FRGEZ)",
   label: "Gemozac (FRGEZ)"
  },
  {
   value: "Genas (FRGEN)",
   label: "Genas (FRGEN)"
  },
  {
   value: "Genlis (FRGEL)",
   label: "Genlis (FRGEL)"
  },
  {
   value: "Gennevilliers (FRGVL)",
   label: "Gennevilliers (FRGVL)"
  },
  {
   value: "Gensac (FRGNC)",
   label: "Gensac (FRGNC)"
  },
  {
   value: "Gentilly (FRGTY)",
   label: "Gentilly (FRGTY)"
  },
  {
   value: "Gerardmer (FRGER)",
   label: "Gerardmer (FRGER)"
  },
  {
   value: "Estrees-St Denis (FRESD)",
   label: "Estrees-St Denis (FRESD)"
  },
  {
   value: "Etang de Berre (FRETB)",
   label: "Etang de Berre (FRETB)"
  },
  {
   value: "Etival-Clairefontaine (FRETI)",
   label: "Etival-Clairefontaine (FRETI)"
  },
  {
   value: "Etoile sur Rhone (FRESR)",
   label: "Etoile sur Rhone (FRESR)"
  },
  {
   value: "Etrechy (FRETR)",
   label: "Etrechy (FRETR)"
  },
  {
   value: "Etrepagny (FRETY)",
   label: "Etrepagny (FRETY)"
  },
  {
   value: "Evian-les-bains (FREVI)",
   label: "Evian-les-bains (FREVI)"
  },
  {
   value: "Evreux (FREVX)",
   label: "Evreux (FREVX)"
  },
  {
   value: "Evry (FREVR)",
   label: "Evry (FREVR)"
  },
  {
   value: "Eybens (FREYN)",
   label: "Eybens (FREYN)"
  },
  {
   value: "Eygalieres (FREYG)",
   label: "Eygalieres (FREYG)"
  },
  {
   value: "Eysines (FREYS)",
   label: "Eysines (FREYS)"
  },
  {
   value: "Facture (FRFAC)",
   label: "Facture (FRFAC)"
  },
  {
   value: "Faremoutiers (FRFAR)",
   label: "Faremoutiers (FRFAR)"
  },
  {
   value: "Fargues St Hilaire (FRFGH)",
   label: "Fargues St Hilaire (FRFGH)"
  },
  {
   value: "Faulquemont (FRFQM)",
   label: "Faulquemont (FRFQM)"
  },
  {
   value: "Faverges (FRFAV)",
   label: "Faverges (FRFAV)"
  },
  {
   value: "Fécamp (FRFEC)",
   label: "Fécamp (FRFEC)"
  },
  {
   value: "Fegersheim (FRFEG)",
   label: "Fegersheim (FRFEG)"
  },
  {
   value: "Fere champenoise (FRFRC)",
   label: "Fere champenoise (FRFRC)"
  },
  {
   value: "Ferney-Voltaire (FRFEV)",
   label: "Ferney-Voltaire (FRFEV)"
  },
  {
   value: "Fervaques (FRFER)",
   label: "Fervaques (FRFER)"
  },
  {
   value: "Fesches Le Chatel (FRFLC)",
   label: "Fesches Le Chatel (FRFLC)"
  },
  {
   value: "Feuquieres en Vimeu (FRFVI)",
   label: "Feuquieres en Vimeu (FRFVI)"
  },
  {
   value: "Feyzin (FRFEY)",
   label: "Feyzin (FRFEY)"
  },
  {
   value: "Figari (FRFSC)",
   label: "Figari (FRFSC)"
  },
  {
   value: "Fismes (FRFSM)",
   label: "Fismes (FRFSM)"
  },
  {
   value: "Flers (FRFLE)",
   label: "Flers (FRFLE)"
  },
  {
   value: "Fleurance (FRFLU)",
   label: "Fleurance (FRFLU)"
  },
  {
   value: "Fleurie (FRFLR)",
   label: "Fleurie (FRFLR)"
  },
  {
   value: "Fleury-Les-Aubrais (FRFLA)",
   label: "Fleury-Les-Aubrais (FRFLA)"
  },
  {
   value: "Fleury-Sur-Andelle (FRFLY)",
   label: "Fleury-Sur-Andelle (FRFLY)"
  },
  {
   value: "Floirac (FRFLO)",
   label: "Floirac (FRFLO)"
  },
  {
   value: "Foix (FRFOI)",
   label: "Foix (FRFOI)"
  },
  {
   value: "Folschviller (FRFOL)",
   label: "Folschviller (FRFOL)"
  },
  {
   value: "Fontaine (FRFNT)",
   label: "Fontaine (FRFNT)"
  },
  {
   value: "Fontaine-les-Luxeuil (FRFON)",
   label: "Fontaine-les-Luxeuil (FRFON)"
  },
  {
   value: "Fontaines-sur-Saone (FRFSS)",
   label: "Fontaines-sur-Saone (FRFSS)"
  },
  {
   value: "Divonne les Bains (FRDIN)",
   label: "Divonne les Bains (FRDIN)"
  },
  {
   value: "Docelles (FRDOC)",
   label: "Docelles (FRDOC)"
  },
  {
   value: "Dole (FRDLE)",
   label: "Dole (FRDLE)"
  },
  {
   value: "Domene (FRDOM)",
   label: "Domene (FRDOM)"
  },
  {
   value: "Domfront (FRDOF)",
   label: "Domfront (FRDOF)"
  },
  {
   value: "Domont (FRDMN)",
   label: "Domont (FRDMN)"
  },
  {
   value: "Dompierre sur Mont (FRDMP)",
   label: "Dompierre sur Mont (FRDMP)"
  },
  {
   value: "Donchery (FRDOY)",
   label: "Donchery (FRDOY)"
  },
  {
   value: "Donges (FRDON)",
   label: "Donges (FRDON)"
  },
  {
   value: "Donzy (FRDZY)",
   label: "Donzy (FRDZY)"
  },
  {
   value: "Douai (FRDOI)",
   label: "Douai (FRDOI)"
  },
  {
   value: "Douarnenez (FRDRZ)",
   label: "Douarnenez (FRDRZ)"
  },
  {
   value: "Doue-la-Fontaine (FRDLF)",
   label: "Doue-la-Fontaine (FRDLF)"
  },
  {
   value: "Doullens (FRDUL)",
   label: "Doullens (FRDUL)"
  },
  {
   value: "Dourdan (FRDOA)",
   label: "Dourdan (FRDOA)"
  },
  {
   value: "Douvaine (FRDOU)",
   label: "Douvaine (FRDOU)"
  },
  {
   value: "Drancy (FRDCY)",
   label: "Drancy (FRDCY)"
  },
  {
   value: "Dreux (FRDRE)",
   label: "Dreux (FRDRE)"
  },
  {
   value: "Drusenheim (FRDRU)",
   label: "Drusenheim (FRDRU)"
  },
  {
   value: "Dugny (FRDUG)",
   label: "Dugny (FRDUG)"
  },
  {
   value: "Dunkerque (FRDKK)",
   label: "Dunkerque (FRDKK)"
  },
  {
   value: "Duppinheim (FRDHM)",
   label: "Duppinheim (FRDHM)"
  },
  {
   value: "Durtal (FRDUR)",
   label: "Durtal (FRDUR)"
  },
  {
   value: "Eauze (FREAZ)",
   label: "Eauze (FREAZ)"
  },
  {
   value: "Echirolles (FRECH)",
   label: "Echirolles (FRECH)"
  },
  {
   value: "Ecquevilly (FREQV)",
   label: "Ecquevilly (FREQV)"
  },
  {
   value: "Ecully (FRECY)",
   label: "Ecully (FRECY)"
  },
  {
   value: "Eguisheim (FREGU)",
   label: "Eguisheim (FREGU)"
  },
  {
   value: "Einsisheim (FREIN)",
   label: "Einsisheim (FREIN)"
  },
  {
   value: "Elbeuf (FREBF)",
   label: "Elbeuf (FREBF)"
  },
  {
   value: "Elne (FRELN)",
   label: "Elne (FRELN)"
  },
  {
   value: "Entrammes (FRENT)",
   label: "Entrammes (FRENT)"
  },
  {
   value: "Envermeu (FRENV)",
   label: "Envermeu (FRENV)"
  },
  {
   value: "Epehy (FREPE)",
   label: "Epehy (FREPE)"
  },
  {
   value: "Epernay (FREPY)",
   label: "Epernay (FREPY)"
  },
  {
   value: "Epernon (FREPN)",
   label: "Epernon (FREPN)"
  },
  {
   value: "Epierre (FREPI)",
   label: "Epierre (FREPI)"
  },
  {
   value: "Epinal (FREPL)",
   label: "Epinal (FREPL)"
  },
  {
   value: "Eragny Sur Oise (FRESO)",
   label: "Eragny Sur Oise (FRESO)"
  },
  {
   value: "Estissac (FREST)",
   label: "Estissac (FREST)"
  },
  {
   value: "Estivareilles (FRETV)",
   label: "Estivareilles (FRETV)"
  },
  {
   value: "Creteil (FRCTE)",
   label: "Creteil (FRCTE)"
  },
  {
   value: "Creutzwald (FRCRD)",
   label: "Creutzwald (FRCRD)"
  },
  {
   value: "Crevecoeur Le Grand (FRCLG)",
   label: "Crevecoeur Le Grand (FRCLG)"
  },
  {
   value: "Crezancy (FRCZA)",
   label: "Crezancy (FRCZA)"
  },
  {
   value: "Croissy-sur-Seine (FRCSY)",
   label: "Croissy-sur-Seine (FRCSY)"
  },
  {
   value: "Crolles (FRCXL)",
   label: "Crolles (FRCXL)"
  },
  {
   value: "Cronenbourg\/Strasbourg (FRCRO)",
   label: "Cronenbourg\/Strasbourg (FRCRO)"
  },
  {
   value: "Crouy-sur-Ourcq (FRRSO)",
   label: "Crouy-sur-Ourcq (FRRSO)"
  },
  {
   value: "Cuers (FRCUE)",
   label: "Cuers (FRCUE)"
  },
  {
   value: "Cugnaux (FRCUG)",
   label: "Cugnaux (FRCUG)"
  },
  {
   value: "Cuisery (FRCUI)",
   label: "Cuisery (FRCUI)"
  },
  {
   value: "Culoz (FRCUZ)",
   label: "Culoz (FRCUZ)"
  },
  {
   value: "Custines (FRCST)",
   label: "Custines (FRCST)"
  },
  {
   value: "Daglan (FRDGL)",
   label: "Daglan (FRDGL)"
  },
  {
   value: "Dagneux (FRDGX)",
   label: "Dagneux (FRDGX)"
  },
  {
   value: "Damazan (FRDZA)",
   label: "Damazan (FRDZA)"
  },
  {
   value: "Dammarie (FRDME)",
   label: "Dammarie (FRDME)"
  },
  {
   value: "Dammarie en Pisaye (FRDEP)",
   label: "Dammarie en Pisaye (FRDEP)"
  },
  {
   value: "Damparis (FRDPS)",
   label: "Damparis (FRDPS)"
  },
  {
   value: "Dampierre (FRDSS)",
   label: "Dampierre (FRDSS)"
  },
  {
   value: "Danjoutin (FRDJU)",
   label: "Danjoutin (FRDJU)"
  },
  {
   value: "Dannemarie (FRDNM)",
   label: "Dannemarie (FRDNM)"
  },
  {
   value: "Dardilly (FRDAY)",
   label: "Dardilly (FRDAY)"
  },
  {
   value: "Darney (FRDAR)",
   label: "Darney (FRDAR)"
  },
  {
   value: "Dax (FRDAX)",
   label: "Dax (FRDAX)"
  },
  {
   value: "Deauville (FRDOL)",
   label: "Deauville (FRDOL)"
  },
  {
   value: "Decazeville (FRDZV)",
   label: "Decazeville (FRDZV)"
  },
  {
   value: "Décines (FRDEC)",
   label: "Décines (FRDEC)"
  },
  {
   value: "Délivrance\/Lille (FRDLV)",
   label: "Délivrance\/Lille (FRDLV)"
  },
  {
   value: "Delle (FRDEL)",
   label: "Delle (FRDEL)"
  },
  {
   value: "Deols (FRDES)",
   label: "Deols (FRDES)"
  },
  {
   value: "\"Deux Alpes (FRDXA)",
   label: "\"Deux Alpes (FRDXA)"
  },
  {
   value: "Dieppe (FRDPE)",
   label: "Dieppe (FRDPE)"
  },
  {
   value: "Dieuze (FRDZE)",
   label: "Dieuze (FRDZE)"
  },
  {
   value: "Digne (FRDGN)",
   label: "Digne (FRDGN)"
  },
  {
   value: "Digoin (FRDGO)",
   label: "Digoin (FRDGO)"
  },
  {
   value: "Dijon (FRDIJ)",
   label: "Dijon (FRDIJ)"
  },
  {
   value: "Dinard (FRDNR)",
   label: "Dinard (FRDNR)"
  },
  {
   value: "Diors (FRDOS)",
   label: "Diors (FRDOS)"
  },
  {
   value: "Dives Sur Mer (FRDSM)",
   label: "Dives Sur Mer (FRDSM)"
  },
  {
   value: "Comblanchien (FRCOM)",
   label: "Comblanchien (FRCOM)"
  },
  {
   value: "Commentry (FRCMM)",
   label: "Commentry (FRCMM)"
  },
  {
   value: "Commercy (FRCMY)",
   label: "Commercy (FRCMY)"
  },
  {
   value: "Compiègne (FRCMP)",
   label: "Compiègne (FRCMP)"
  },
  {
   value: "Concarneau (FRCOC)",
   label: "Concarneau (FRCOC)"
  },
  {
   value: "Conde Sur Vire (FRCOV)",
   label: "Conde Sur Vire (FRCOV)"
  },
  {
   value: "Condom (FRCOD)",
   label: "Condom (FRCOD)"
  },
  {
   value: "Condrieu (FRCNU)",
   label: "Condrieu (FRCNU)"
  },
  {
   value: "Conflandey (FRCON)",
   label: "Conflandey (FRCON)"
  },
  {
   value: "Conflans en Jarnisy (FRCEJ)",
   label: "Conflans en Jarnisy (FRCEJ)"
  },
  {
   value: "Conflans Ste Honorine (FRCSH)",
   label: "Conflans Ste Honorine (FRCSH)"
  },
  {
   value: "Connerre (FRCNR)",
   label: "Connerre (FRCNR)"
  },
  {
   value: "Conques sur Orbiel (FRCSO)",
   label: "Conques sur Orbiel (FRCSO)"
  },
  {
   value: "Contrexéville (FRCRX)",
   label: "Contrexéville (FRCRX)"
  },
  {
   value: "Coquelles (FRCQS)",
   label: "Coquelles (FRCQS)"
  },
  {
   value: "Corbas (FRCBA)",
   label: "Corbas (FRCBA)"
  },
  {
   value: "Corbehem (FRCOR)",
   label: "Corbehem (FRCOR)"
  },
  {
   value: "Corbeil Essonnes (FRCOE)",
   label: "Corbeil Essonnes (FRCOE)"
  },
  {
   value: "Corbie (FRCBI)",
   label: "Corbie (FRCBI)"
  },
  {
   value: "Corcoue-sur-Logne (FRCOL)",
   label: "Corcoue-sur-Logne (FRCOL)"
  },
  {
   value: "Cormeilles-En-Parisis (FRCPO)",
   label: "Cormeilles-En-Parisis (FRCPO)"
  },
  {
   value: "Coudekerque-Branch (FRCOK)",
   label: "Coudekerque-Branch (FRCOK)"
  },
  {
   value: "Coudeville (FRCOI)",
   label: "Coudeville (FRCOI)"
  },
  {
   value: "Coulommiers (FRCLI)",
   label: "Coulommiers (FRCLI)"
  },
  {
   value: "Courbevoie (FRCRB)",
   label: "Courbevoie (FRCRB)"
  },
  {
   value: "Courchelettes (FRCUT)",
   label: "Courchelettes (FRCUT)"
  },
  {
   value: "Courchevel (FRCVF)",
   label: "Courchevel (FRCVF)"
  },
  {
   value: "Cournon d'Auvergne (FRCOA)",
   label: "Cournon d'Auvergne (FRCOA)"
  },
  {
   value: "Courpiere (FRCPE)",
   label: "Courpiere (FRCPE)"
  },
  {
   value: "Courthezon (FRCRZ)",
   label: "Courthezon (FRCRZ)"
  },
  {
   value: "Coussol\/Fos sur Mer (FRCOU)",
   label: "Coussol\/Fos sur Mer (FRCOU)"
  },
  {
   value: "Couterne (FRCUR)",
   label: "Couterne (FRCUR)"
  },
  {
   value: "Crancot (FRCRA)",
   label: "Crancot (FRCRA)"
  },
  {
   value: "Crappone-sur-Arzon (FRCSZ)",
   label: "Crappone-sur-Arzon (FRCSZ)"
  },
  {
   value: "Crecy Sur Serre (FRCYE)",
   label: "Crecy Sur Serre (FRCYE)"
  },
  {
   value: "Creil (FRCRL)",
   label: "Creil (FRCRL)"
  },
  {
   value: "Cremieu (FRCRU)",
   label: "Cremieu (FRCRU)"
  },
  {
   value: "Crépy en Valois (FRCEV)",
   label: "Crépy en Valois (FRCEV)"
  },
  {
   value: "Chaulnes (FRCHN)",
   label: "Chaulnes (FRCHN)"
  },
  {
   value: "Chaumont (FRCMT)",
   label: "Chaumont (FRCMT)"
  },
  {
   value: "Chauny (FRCHY)",
   label: "Chauny (FRCHY)"
  },
  {
   value: "Chauvigny (FRCVG)",
   label: "Chauvigny (FRCVG)"
  },
  {
   value: "Chavanod (FRCVD)",
   label: "Chavanod (FRCVD)"
  },
  {
   value: "Chavelot (FRCVT)",
   label: "Chavelot (FRCVT)"
  },
  {
   value: "Chaville (FRCVE)",
   label: "Chaville (FRCVE)"
  },
  {
   value: "Chazelles sur Lyon (FRCZL)",
   label: "Chazelles sur Lyon (FRCZL)"
  },
  {
   value: "Checy (FRCHE)",
   label: "Checy (FRCHE)"
  },
  {
   value: "Chedde (FRCDE)",
   label: "Chedde (FRCDE)"
  },
  {
   value: "Chelles (FRCLS)",
   label: "Chelles (FRCLS)"
  },
  {
   value: "Chenas (FRCNA)",
   label: "Chenas (FRCNA)"
  },
  {
   value: "Chennevieres-sur-Marne (FRHSM)",
   label: "Chennevieres-sur-Marne (FRHSM)"
  },
  {
   value: "Chenove (FRCNV)",
   label: "Chenove (FRCNV)"
  },
  {
   value: "Cherbourg (FRCER)",
   label: "Cherbourg (FRCER)"
  },
  {
   value: "Chevagnes (FRCVN)",
   label: "Chevagnes (FRCVN)"
  },
  {
   value: "Chevagny Les Chevrieres (FRCYC)",
   label: "Chevagny Les Chevrieres (FRCYC)"
  },
  {
   value: "Chevigny St Sauveur (FRCYS)",
   label: "Chevigny St Sauveur (FRCYS)"
  },
  {
   value: "Chilly Mazarin (FRCYM)",
   label: "Chilly Mazarin (FRCYM)"
  },
  {
   value: "Chocques (FRCHQ)",
   label: "Chocques (FRCHQ)"
  },
  {
   value: "Choisy le Roi (FRCHO)",
   label: "Choisy le Roi (FRCHO)"
  },
  {
   value: "Cholet (FRCET)",
   label: "Cholet (FRCET)"
  },
  {
   value: "Chouilly (FRCOY)",
   label: "Chouilly (FRCOY)"
  },
  {
   value: "Clamart (FRCLA)",
   label: "Clamart (FRCLA)"
  },
  {
   value: "Clamecy (FRCCY)",
   label: "Clamecy (FRCCY)"
  },
  {
   value: "Cléon (FRCLE)",
   label: "Cléon (FRCLE)"
  },
  {
   value: "Cleon d'Andran (FRCLN)",
   label: "Cleon d'Andran (FRCLN)"
  },
  {
   value: "Clerac (FRCLC)",
   label: "Clerac (FRCLC)"
  },
  {
   value: "Clermont Ferrand (FRCFE)",
   label: "Clermont Ferrand (FRCFE)"
  },
  {
   value: "Clermont l'Herault (FRCLH)",
   label: "Clermont l'Herault (FRCLH)"
  },
  {
   value: "Clisson (FRCLO)",
   label: "Clisson (FRCLO)"
  },
  {
   value: "Cluny (FRCUY)",
   label: "Cluny (FRCUY)"
  },
  {
   value: "Cluses (FRCLU)",
   label: "Cluses (FRCLU)"
  },
  {
   value: "Cognac (FRCNG)",
   label: "Cognac (FRCNG)"
  },
  {
   value: "Cognieres (FRCES)",
   label: "Cognieres (FRCES)"
  },
  {
   value: "Cognin (FRCOG)",
   label: "Cognin (FRCOG)"
  },
  {
   value: "Collonges au Mont d'Or (FRCLM)",
   label: "Collonges au Mont d'Or (FRCLM)"
  },
  {
   value: "Colmar (FRCMR)",
   label: "Colmar (FRCMR)"
  },
  {
   value: "Colombes (FRCLB)",
   label: "Colombes (FRCLB)"
  },
  {
   value: "Champillet (FRCPL)",
   label: "Champillet (FRCPL)"
  },
  {
   value: "Champs de Mars\/Lille (FRCDM)",
   label: "Champs de Mars\/Lille (FRCDM)"
  },
  {
   value: "Chanaz (FRCNZ)",
   label: "Chanaz (FRCNZ)"
  },
  {
   value: "Chaneins (FRCNN)",
   label: "Chaneins (FRCNN)"
  },
  {
   value: "Chanes (FRCAN)",
   label: "Chanes (FRCAN)"
  },
  {
   value: "Changy (FRCHG)",
   label: "Changy (FRCHG)"
  },
  {
   value: "Chantenay (FRCNY)",
   label: "Chantenay (FRCNY)"
  },
  {
   value: "Chantereine (FRCTR)",
   label: "Chantereine (FRCTR)"
  },
  {
   value: "Chantilly (FRCLL)",
   label: "Chantilly (FRCLL)"
  },
  {
   value: "Chappelle St Martin (FRCTM)",
   label: "Chappelle St Martin (FRCTM)"
  },
  {
   value: "Charchigne (FRCCG)",
   label: "Charchigne (FRCCG)"
  },
  {
   value: "Charles de Gaulle Apt\/Paris (FRCDG)",
   label: "Charles de Gaulle Apt\/Paris (FRCDG)"
  },
  {
   value: "Charleval (FRCHV)",
   label: "Charleval (FRCHV)"
  },
  {
   value: "Charleville Mézières (FRCHM)",
   label: "Charleville Mézières (FRCHM)"
  },
  {
   value: "Charmeil (FRCMI)",
   label: "Charmeil (FRCMI)"
  },
  {
   value: "Charnoz-sur-Ain (FRCHZ)",
   label: "Charnoz-sur-Ain (FRCHZ)"
  },
  {
   value: "Chartres (FRCHA)",
   label: "Chartres (FRCHA)"
  },
  {
   value: "Charvieu Chavagneux (FRCHC)",
   label: "Charvieu Chavagneux (FRCHC)"
  },
  {
   value: "Chassieu (FRCHI)",
   label: "Chassieu (FRCHI)"
  },
  {
   value: "Chateau (FRCHU)",
   label: "Chateau (FRCHU)"
  },
  {
   value: "Château Arnoux (FRCAR)",
   label: "Château Arnoux (FRCAR)"
  },
  {
   value: "Chateau du Loir (FRCDL)",
   label: "Chateau du Loir (FRCDL)"
  },
  {
   value: "Chateau Gontier (FRCGO)",
   label: "Chateau Gontier (FRCGO)"
  },
  {
   value: "Chateaubourg (FRCTG)",
   label: "Chateaubourg (FRCTG)"
  },
  {
   value: "Chateaubriant (FRCBD)",
   label: "Chateaubriant (FRCBD)"
  },
  {
   value: "Chateaucreux\/St Etienne (FRCHX)",
   label: "Chateaucreux\/St Etienne (FRCHX)"
  },
  {
   value: "Chateaulin (FRCTL)",
   label: "Chateaulin (FRCTL)"
  },
  {
   value: "Chateauneuf-du-Faou (FRCDF)",
   label: "Chateauneuf-du-Faou (FRCDF)"
  },
  {
   value: "Chateauneuf-du-Pape (FRCDP)",
   label: "Chateauneuf-du-Pape (FRCDP)"
  },
  {
   value: "Chateauneuf-sur-Sarthe (FRCFS)",
   label: "Chateauneuf-sur-Sarthe (FRCFS)"
  },
  {
   value: "Chateauroux (FRCHR)",
   label: "Chateauroux (FRCHR)"
  },
  {
   value: "Chatellerault (FRCHL)",
   label: "Chatellerault (FRCHL)"
  },
  {
   value: "Chatenoy le Royal (FRCLR)",
   label: "Chatenoy le Royal (FRCLR)"
  },
  {
   value: "Chatillon-sur-Chalaronne (FRCSE)",
   label: "Chatillon-sur-Chalaronne (FRCSE)"
  },
  {
   value: "Chatillon-sur-Seine (FRCNS)",
   label: "Chatillon-sur-Seine (FRCNS)"
  },
  {
   value: "Chatou (FRCTU)",
   label: "Chatou (FRCTU)"
  },
  {
   value: "Cases de Pene (FRCPN)",
   label: "Cases de Pene (FRCPN)"
  },
  {
   value: "Castelnau d'Estrestefonds (FRCDS)",
   label: "Castelnau d'Estrestefonds (FRCDS)"
  },
  {
   value: "Castelnau-de-Medoc (FRCMD)",
   label: "Castelnau-de-Medoc (FRCMD)"
  },
  {
   value: "Castelnaud-de-Gratecambe (FRCGM)",
   label: "Castelnaud-de-Gratecambe (FRCGM)"
  },
  {
   value: "Castelnaud-la-Chapelle (FRCTC)",
   label: "Castelnaud-la-Chapelle (FRCTC)"
  },
  {
   value: "Castelnaudary (FRCTY)",
   label: "Castelnaudary (FRCTY)"
  },
  {
   value: "Castelsarrasin (FRCTN)",
   label: "Castelsarrasin (FRCTN)"
  },
  {
   value: "Castillonnes (FRCTS)",
   label: "Castillonnes (FRCTS)"
  },
  {
   value: "Castres (FRCAS)",
   label: "Castres (FRCAS)"
  },
  {
   value: "Catillon-Fumechon (FRCTI)",
   label: "Catillon-Fumechon (FRCTI)"
  },
  {
   value: "Caudéran (FRCAU)",
   label: "Caudéran (FRCAU)"
  },
  {
   value: "Caudies-de-Fenouilledes (FRCAD)",
   label: "Caudies-de-Fenouilledes (FRCAD)"
  },
  {
   value: "Caudry (FRCDY)",
   label: "Caudry (FRCDY)"
  },
  {
   value: "Caussade (FRCUS)",
   label: "Caussade (FRCUS)"
  },
  {
   value: "Cavaillon (FRCAV)",
   label: "Cavaillon (FRCAV)"
  },
  {
   value: "Cayeux sur Mer (FRCAY)",
   label: "Cayeux sur Mer (FRCAY)"
  },
  {
   value: "Celles sur Belle (FRCSB)",
   label: "Celles sur Belle (FRCSB)"
  },
  {
   value: "Cerbère (FRCEB)",
   label: "Cerbère (FRCEB)"
  },
  {
   value: "Cerences (FRCRC)",
   label: "Cerences (FRCRC)"
  },
  {
   value: "Ceret (FRCXT)",
   label: "Ceret (FRCXT)"
  },
  {
   value: "Cergy Pontoise (FRCEP)",
   label: "Cergy Pontoise (FRCEP)"
  },
  {
   value: "Certines (FRCNT)",
   label: "Certines (FRCNT)"
  },
  {
   value: "Cestas (FRCEA)",
   label: "Cestas (FRCEA)"
  },
  {
   value: "Ceton (FRCTO)",
   label: "Ceton (FRCTO)"
  },
  {
   value: "Chablis (FRHAB)",
   label: "Chablis (FRHAB)"
  },
  {
   value: "Chace (FRCCE)",
   label: "Chace (FRCCE)"
  },
  {
   value: "Chalampe (FRCLP)",
   label: "Chalampe (FRCLP)"
  },
  {
   value: "Challans (FRCAA)",
   label: "Challans (FRCAA)"
  },
  {
   value: "Challette sur Loing (FRCSL)",
   label: "Challette sur Loing (FRCSL)"
  },
  {
   value: "Chalon sur Saône (FRCSS)",
   label: "Chalon sur Saône (FRCSS)"
  },
  {
   value: "Châlons sur Marne (FRCSM)",
   label: "Châlons sur Marne (FRCSM)"
  },
  {
   value: "Chambéry (FRCMF)",
   label: "Chambéry (FRCMF)"
  },
  {
   value: "Chamelet (FRCLT)",
   label: "Chamelet (FRCLT)"
  },
  {
   value: "Chamonix-Mont-Blanc (FRCXM)",
   label: "Chamonix-Mont-Blanc (FRCXM)"
  },
  {
   value: "Champagne sur Seine (FRCHP)",
   label: "Champagne sur Seine (FRCHP)"
  },
  {
   value: "Champforgeuil (FRCML)",
   label: "Champforgeuil (FRCML)"
  },
  {
   value: "Champigneulles (FRCHS)",
   label: "Champigneulles (FRCHS)"
  },
  {
   value: "Brignoud (FRBRG)",
   label: "Brignoud (FRBRG)"
  },
  {
   value: "Brionne (FRBNN)",
   label: "Brionne (FRBNN)"
  },
  {
   value: "Briouze (FRBIZ)",
   label: "Briouze (FRBIZ)"
  },
  {
   value: "Brive La Gaillarde (FRBVE)",
   label: "Brive La Gaillarde (FRBVE)"
  },
  {
   value: "Brives (FRBRV)",
   label: "Brives (FRBRV)"
  },
  {
   value: "Brumath (FRBRM)",
   label: "Brumath (FRBRM)"
  },
  {
   value: "Bruyeres (FRBRY)",
   label: "Bruyeres (FRBRY)"
  },
  {
   value: "Bruz (FRBUZ)",
   label: "Bruz (FRBUZ)"
  },
  {
   value: "Buc (FRBUC)",
   label: "Buc (FRBUC)"
  },
  {
   value: "Buire-Le-Sec (FRBUI)",
   label: "Buire-Le-Sec (FRBUI)"
  },
  {
   value: "Buis les Baronnie (FRBUB)",
   label: "Buis les Baronnie (FRBUB)"
  },
  {
   value: "Bures En Bray (FRBUR)",
   label: "Bures En Bray (FRBUR)"
  },
  {
   value: "Buxy (FRBUX)",
   label: "Buxy (FRBUX)"
  },
  {
   value: "Cabannes (FRCAB)",
   label: "Cabannes (FRCAB)"
  },
  {
   value: "Cadenet (FRCDN)",
   label: "Cadenet (FRCDN)"
  },
  {
   value: "Caen (FRCFR)",
   label: "Caen (FRCFR)"
  },
  {
   value: "Cagnes sur Mer (FRCME)",
   label: "Cagnes sur Mer (FRCME)"
  },
  {
   value: "Cahors (FRZAO)",
   label: "Cahors (FRZAO)"
  },
  {
   value: "Cahuzac sur Vere (FRCSV)",
   label: "Cahuzac sur Vere (FRCSV)"
  },
  {
   value: "Calais (FRCQF)",
   label: "Calais (FRCQF)"
  },
  {
   value: "Caluire-Et-Cuire (FRCAL)",
   label: "Caluire-Et-Cuire (FRCAL)"
  },
  {
   value: "Calvi (FRCLY)",
   label: "Calvi (FRCLY)"
  },
  {
   value: "Camaret sur Aigues (FRCSA)",
   label: "Camaret sur Aigues (FRCSA)"
  },
  {
   value: "Camaret-sur-Mer (FRCAM)",
   label: "Camaret-sur-Mer (FRCAM)"
  },
  {
   value: "Cambes (FRCMS)",
   label: "Cambes (FRCMS)"
  },
  {
   value: "Cambrai (FRCMB)",
   label: "Cambrai (FRCMB)"
  },
  {
   value: "Campsas (FRCPS)",
   label: "Campsas (FRCPS)"
  },
  {
   value: "Cannes (FRCEQ)",
   label: "Cannes (FRCEQ)"
  },
  {
   value: "Cap-d'Ail (FRCPA)",
   label: "Cap-d'Ail (FRCPA)"
  },
  {
   value: "Carbon Blanc (FRCBC)",
   label: "Carbon Blanc (FRCBC)"
  },
  {
   value: "Carcassonne (FRCCF)",
   label: "Carcassonne (FRCCF)"
  },
  {
   value: "Carentan (FRCTA)",
   label: "Carentan (FRCTA)"
  },
  {
   value: "Carentec (FRCRN)",
   label: "Carentec (FRCRN)"
  },
  {
   value: "Carignan (FRCGN)",
   label: "Carignan (FRCGN)"
  },
  {
   value: "Carmaux (FRCMX)",
   label: "Carmaux (FRCMX)"
  },
  {
   value: "Carpentras (FRCRP)",
   label: "Carpentras (FRCRP)"
  },
  {
   value: "Carrieres sur Seine (FRCSN)",
   label: "Carrieres sur Seine (FRCSN)"
  },
  {
   value: "Carros (FRCOS)",
   label: "Carros (FRCOS)"
  },
  {
   value: "Carrouges (FRCRG)",
   label: "Carrouges (FRCRG)"
  },
  {
   value: "Carteret (FRCRT)",
   label: "Carteret (FRCRT)"
  },
  {
   value: "Bonsecours (FRBSC)",
   label: "Bonsecours (FRBSC)"
  },
  {
   value: "Boos (FRBOO)",
   label: "Boos (FRBOO)"
  },
  {
   value: "Bordeaux (FRBOD)",
   label: "Bordeaux (FRBOD)"
  },
  {
   value: "Bordes (FRBRD)",
   label: "Bordes (FRBRD)"
  },
  {
   value: "Boucau (FRBAU)",
   label: "Boucau (FRBAU)"
  },
  {
   value: "Bouee (FRBUE)",
   label: "Bouee (FRBUE)"
  },
  {
   value: "Boulogne Sur Mer (FRBOL)",
   label: "Boulogne Sur Mer (FRBOL)"
  },
  {
   value: "Boulogne-sur-Gesse (FRBGE)",
   label: "Boulogne-sur-Gesse (FRBGE)"
  },
  {
   value: "Bourg de Thizy (FRBDT)",
   label: "Bourg de Thizy (FRBDT)"
  },
  {
   value: "Bourg en Bresse (FRBEB)",
   label: "Bourg en Bresse (FRBEB)"
  },
  {
   value: "Bourg St Andeol (FRBSA)",
   label: "Bourg St Andeol (FRBSA)"
  },
  {
   value: "Bourg sur Gironde (FRBSG)",
   label: "Bourg sur Gironde (FRBSG)"
  },
  {
   value: "Bourges (FRBOU)",
   label: "Bourges (FRBOU)"
  },
  {
   value: "Bourgogne (FROUR)",
   label: "Bourgogne (FROUR)"
  },
  {
   value: "Bourgoin-Jallieu (FRBGJ)",
   label: "Bourgoin-Jallieu (FRBGJ)"
  },
  {
   value: "Bourogne (FRBRO)",
   label: "Bourogne (FRBRO)"
  },
  {
   value: "Bousbecque (FRBOS)",
   label: "Bousbecque (FRBOS)"
  },
  {
   value: "Boussens (FRBNS)",
   label: "Boussens (FRBNS)"
  },
  {
   value: "Bouville (FRBUV)",
   label: "Bouville (FRBUV)"
  },
  {
   value: "Bouzonville (FRBZV)",
   label: "Bouzonville (FRBZV)"
  },
  {
   value: "Boynes (FRBYS)",
   label: "Boynes (FRBYS)"
  },
  {
   value: "Bozouls (FRBZL)",
   label: "Bozouls (FRBZL)"
  },
  {
   value: "Braitexte (FRBRX)",
   label: "Braitexte (FRBRX)"
  },
  {
   value: "Branne (FRBNE)",
   label: "Branne (FRBNE)"
  },
  {
   value: "Breal-Sous-Montfort (FRQKK)",
   label: "Breal-Sous-Montfort (FRQKK)"
  },
  {
   value: "Bree (FRBEF)",
   label: "Bree (FRBEF)"
  },
  {
   value: "Breitenbach (FRBTB)",
   label: "Breitenbach (FRBTB)"
  },
  {
   value: "Bressuire (FRRSE)",
   label: "Bressuire (FRRSE)"
  },
  {
   value: "Brest (FRBES)",
   label: "Brest (FRBES)"
  },
  {
   value: "Bretenoux (FRBTX)",
   label: "Bretenoux (FRBTX)"
  },
  {
   value: "Breteuil-sur-Noye (FRBSY)",
   label: "Breteuil-sur-Noye (FRBSY)"
  },
  {
   value: "Brétigny-sur-Orge (FRBRE)",
   label: "Brétigny-sur-Orge (FRBRE)"
  },
  {
   value: "Brezins (FRBRZ)",
   label: "Brezins (FRBRZ)"
  },
  {
   value: "Briare (FRBRR)",
   label: "Briare (FRBRR)"
  },
  {
   value: "Brignais (FRBRI)",
   label: "Brignais (FRBRI)"
  },
  {
   value: "Brignals (FRBRL)",
   label: "Brignals (FRBRL)"
  },
  {
   value: "Brignogan-Plage (FRBGG)",
   label: "Brignogan-Plage (FRBGG)"
  },
  {
   value: "Brignoles (FRBRN)",
   label: "Brignoles (FRBRN)"
  },
  {
   value: "Besse-sur-Braye (FRBBR)",
   label: "Besse-sur-Braye (FRBBR)"
  },
  {
   value: "Béthune (FRBET)",
   label: "Béthune (FRBET)"
  },
  {
   value: "Betz (FRBTZ)",
   label: "Betz (FRBTZ)"
  },
  {
   value: "Beville Le Comte (FRBVC)",
   label: "Beville Le Comte (FRBVC)"
  },
  {
   value: "Beynost (FRBEY)",
   label: "Beynost (FRBEY)"
  },
  {
   value: "Beyrede Jumet (FRBYR)",
   label: "Beyrede Jumet (FRBYR)"
  },
  {
   value: "Béziers (FRBZR)",
   label: "Béziers (FRBZR)"
  },
  {
   value: "Bezons (FRBZO)",
   label: "Bezons (FRBZO)"
  },
  {
   value: "Biache St Vaast (FRBSV)",
   label: "Biache St Vaast (FRBSV)"
  },
  {
   value: "Biarritz (FRBIQ)",
   label: "Biarritz (FRBIQ)"
  },
  {
   value: "Biars sur Cere (FRBIC)",
   label: "Biars sur Cere (FRBIC)"
  },
  {
   value: "Biesheim (FRBSH)",
   label: "Biesheim (FRBSH)"
  },
  {
   value: "Biguglia (FRBGU)",
   label: "Biguglia (FRBGU)"
  },
  {
   value: "Biot (FRBIT)",
   label: "Biot (FRBIT)"
  },
  {
   value: "Bischheim (FRBIM)",
   label: "Bischheim (FRBIM)"
  },
  {
   value: "Bischwiller (FRBCH)",
   label: "Bischwiller (FRBCH)"
  },
  {
   value: "Blagnac (FRBLG)",
   label: "Blagnac (FRBLG)"
  },
  {
   value: "Blainville sur l'Eau (FRBLA)",
   label: "Blainville sur l'Eau (FRBLA)"
  },
  {
   value: "Blainville sur Orne (FRBSO)",
   label: "Blainville sur Orne (FRBSO)"
  },
  {
   value: "Blancafort (FRBJG)",
   label: "Blancafort (FRBJG)"
  },
  {
   value: "Blanquefort (FRBLQ)",
   label: "Blanquefort (FRBLQ)"
  },
  {
   value: "Blaringhem (FRBGM)",
   label: "Blaringhem (FRBGM)"
  },
  {
   value: "Blaye (FRBYE)",
   label: "Blaye (FRBYE)"
  },
  {
   value: "Blois (FRBLO)",
   label: "Blois (FRBLO)"
  },
  {
   value: "Blotzheim (FRBLZ)",
   label: "Blotzheim (FRBLZ)"
  },
  {
   value: "Bobigny (FRBOB)",
   label: "Bobigny (FRBOB)"
  },
  {
   value: "Boen (FRBNO)",
   label: "Boen (FRBNO)"
  },
  {
   value: "Boigny sur Bionne (FRBSB)",
   label: "Boigny sur Bionne (FRBSB)"
  },
  {
   value: "Bois Colombes (FRBCL)",
   label: "Bois Colombes (FRBCL)"
  },
  {
   value: "Bois Guillaume (FRBGI)",
   label: "Bois Guillaume (FRBGI)"
  },
  {
   value: "Boissy le Chatel (FRBOC)",
   label: "Boissy le Chatel (FRBOC)"
  },
  {
   value: "Bologne (FRBOG)",
   label: "Bologne (FRBOG)"
  },
  {
   value: "Bon Encontre (FRBOE)",
   label: "Bon Encontre (FRBOE)"
  },
  {
   value: "Bonifacio (FRBON)",
   label: "Bonifacio (FRBON)"
  },
  {
   value: "Bonnetable (FRBNT)",
   label: "Bonnetable (FRBNT)"
  },
  {
   value: "Bonneuil Les Eaux (FRBNL)",
   label: "Bonneuil Les Eaux (FRBNL)"
  },
  {
   value: "Bonneuil sur Marne (FRBSM)",
   label: "Bonneuil sur Marne (FRBSM)"
  },
  {
   value: "Bonnieres sur Seine- (FRBNI)",
   label: "Bonnieres sur Seine- (FRBNI)"
  },
  {
   value: "Bastide\/Bordeaux (FRBTD)",
   label: "Bastide\/Bordeaux (FRBTD)"
  },
  {
   value: "Batilly (FRBAT)",
   label: "Batilly (FRBAT)"
  },
  {
   value: "Baudrieres (FRBUD)",
   label: "Baudrieres (FRBUD)"
  },
  {
   value: "Baume les Dames (FRBDA)",
   label: "Baume les Dames (FRBDA)"
  },
  {
   value: "Bayel (FRBYL)",
   label: "Bayel (FRBYL)"
  },
  {
   value: "Bayeux (FRBYX)",
   label: "Bayeux (FRBYX)"
  },
  {
   value: "Bayonne (FRBAY)",
   label: "Bayonne (FRBAY)"
  },
  {
   value: "Bazancourt (FRBAZ)",
   label: "Bazancourt (FRBAZ)"
  },
  {
   value: "Bazas (FRBZS)",
   label: "Bazas (FRBZS)"
  },
  {
   value: "Beaucaire (FRBCR)",
   label: "Beaucaire (FRBCR)"
  },
  {
   value: "Beauchamp (FRBCP)",
   label: "Beauchamp (FRBCP)"
  },
  {
   value: "Beauchamps (FRBCS)",
   label: "Beauchamps (FRBCS)"
  },
  {
   value: "Beaujeu (FRBEJ)",
   label: "Beaujeu (FRBEJ)"
  },
  {
   value: "Beaulieu (FRBUL)",
   label: "Beaulieu (FRBUL)"
  },
  {
   value: "Beaune (FRBEA)",
   label: "Beaune (FRBEA)"
  },
  {
   value: "Beaurains (FRBUS)",
   label: "Beaurains (FRBUS)"
  },
  {
   value: "Beaurainville (FRBUN)",
   label: "Beaurainville (FRBUN)"
  },
  {
   value: "Beausoleil (FRBUO)",
   label: "Beausoleil (FRBUO)"
  },
  {
   value: "Beauvais (FRBVA)",
   label: "Beauvais (FRBVA)"
  },
  {
   value: "Bec d'Ambès (FRBEC)",
   label: "Bec d'Ambès (FRBEC)"
  },
  {
   value: "Bedee (FRBED)",
   label: "Bedee (FRBED)"
  },
  {
   value: "Begles (FRBGL)",
   label: "Begles (FRBGL)"
  },
  {
   value: "Beinheim (FRBEH)",
   label: "Beinheim (FRBEH)"
  },
  {
   value: "Belfort (FRBOR)",
   label: "Belfort (FRBOR)"
  },
  {
   value: "Bellegarde-sur-Valserine (FRBEL)",
   label: "Bellegarde-sur-Valserine (FRBEL)"
  },
  {
   value: "Belleville sur Saone (FRBSS)",
   label: "Belleville sur Saone (FRBSS)"
  },
  {
   value: "Belleville sur Vie (FRBVI)",
   label: "Belleville sur Vie (FRBVI)"
  },
  {
   value: "Benfeld (FRBEN)",
   label: "Benfeld (FRBEN)"
  },
  {
   value: "Béning (FRBEG)",
   label: "Béning (FRBEG)"
  },
  {
   value: "Bercy Rapee\/Paris (FRBRA)",
   label: "Bercy Rapee\/Paris (FRBRA)"
  },
  {
   value: "Bergerac (FREGC)",
   label: "Bergerac (FREGC)"
  },
  {
   value: "Bergholtz (FRBHZ)",
   label: "Bergholtz (FRBHZ)"
  },
  {
   value: "Bergues (FRBRS)",
   label: "Bergues (FRBRS)"
  },
  {
   value: "Berguette (FRBEI)",
   label: "Berguette (FRBEI)"
  },
  {
   value: "Bernay (FRBER)",
   label: "Bernay (FRBER)"
  },
  {
   value: "Berre (FRBEE)",
   label: "Berre (FRBEE)"
  },
  {
   value: "Berteaucourt les Dames (FRBDS)",
   label: "Berteaucourt les Dames (FRBDS)"
  },
  {
   value: "Berville (FRBEV)",
   label: "Berville (FRBEV)"
  },
  {
   value: "Besancon (FRBSN)",
   label: "Besancon (FRBSN)"
  },
  {
   value: "Aucamville (FRAMV)",
   label: "Aucamville (FRAMV)"
  },
  {
   value: "Auch (FRAUC)",
   label: "Auch (FRAUC)"
  },
  {
   value: "Auchel (FRACL)",
   label: "Auchel (FRACL)"
  },
  {
   value: "Audierne (FRAUD)",
   label: "Audierne (FRAUD)"
  },
  {
   value: "Aulnay sous Bois (FRASB)",
   label: "Aulnay sous Bois (FRASB)"
  },
  {
   value: "Aulnoye (FRAUL)",
   label: "Aulnoye (FRAUL)"
  },
  {
   value: "Aulnoye Aymeries (FRAYX)",
   label: "Aulnoye Aymeries (FRAYX)"
  },
  {
   value: "Auneau (FRAUN)",
   label: "Auneau (FRAUN)"
  },
  {
   value: "Aurec sur Loire (FRASL)",
   label: "Aurec sur Loire (FRASL)"
  },
  {
   value: "Aurillac (FRAUR)",
   label: "Aurillac (FRAUR)"
  },
  {
   value: "Auterive (FRAVE)",
   label: "Auterive (FRAVE)"
  },
  {
   value: "Autun (FRAUT)",
   label: "Autun (FRAUT)"
  },
  {
   value: "Auxerre (FRAUF)",
   label: "Auxerre (FRAUF)"
  },
  {
   value: "Auxi Le Chateau (FRACU)",
   label: "Auxi Le Chateau (FRACU)"
  },
  {
   value: "Auzecourt (FRAUZ)",
   label: "Auzecourt (FRAUZ)"
  },
  {
   value: "Avallon (FRAVL)",
   label: "Avallon (FRAVL)"
  },
  {
   value: "Avignon (FRAVN)",
   label: "Avignon (FRAVN)"
  },
  {
   value: "Avilly St Leonard (FRALY)",
   label: "Avilly St Leonard (FRALY)"
  },
  {
   value: "Avoriaz (FRAVF)",
   label: "Avoriaz (FRAVF)"
  },
  {
   value: "Ayze (FRAYZ)",
   label: "Ayze (FRAYZ)"
  },
  {
   value: "Baccarat (FRBAC)",
   label: "Baccarat (FRBAC)"
  },
  {
   value: "Badinieres (FRBAD)",
   label: "Badinieres (FRBAD)"
  },
  {
   value: "Bagas (FRBGA)",
   label: "Bagas (FRBGA)"
  },
  {
   value: "Bage-Le-Chatel (FRBLC)",
   label: "Bage-Le-Chatel (FRBLC)"
  },
  {
   value: "Bages (FRBGS)",
   label: "Bages (FRBGS)"
  },
  {
   value: "Bagneux (FRBGN)",
   label: "Bagneux (FRBGN)"
  },
  {
   value: "Bagnolet (FRBAG)",
   label: "Bagnolet (FRBAG)"
  },
  {
   value: "Baillargues (FRBLS)",
   label: "Baillargues (FRBLS)"
  },
  {
   value: "Ballan Mire (FRBLM)",
   label: "Ballan Mire (FRBLM)"
  },
  {
   value: "Ballancourt-sur-Essonne (FRBAL)",
   label: "Ballancourt-sur-Essonne (FRBAL)"
  },
  {
   value: "Bantzenheim (FRBAN)",
   label: "Bantzenheim (FRBAN)"
  },
  {
   value: "Bapaume (FRBAP)",
   label: "Bapaume (FRBAP)"
  },
  {
   value: "Bar Le Duc (FRBLD)",
   label: "Bar Le Duc (FRBLD)"
  },
  {
   value: "Barcelonnette (FRBAE)",
   label: "Barcelonnette (FRBAE)"
  },
  {
   value: "Barentin (FRBTN)",
   label: "Barentin (FRBTN)"
  },
  {
   value: "Barjac (FRBJC)",
   label: "Barjac (FRBJC)"
  },
  {
   value: "Basse-Indre (FRBAI)",
   label: "Basse-Indre (FRBAI)"
  },
  {
   value: "Bassemberg (FRBAM)",
   label: "Bassemberg (FRBAM)"
  },
  {
   value: "Bassens (FRBAS)",
   label: "Bassens (FRBAS)"
  },
  {
   value: "Bastia (FRBIA)",
   label: "Bastia (FRBIA)"
  },
  {
   value: "Annecy (FRNCY)",
   label: "Annecy (FRNCY)"
  },
  {
   value: "Annemasse (FRANM)",
   label: "Annemasse (FRANM)"
  },
  {
   value: "Anneyron (FRANY)",
   label: "Anneyron (FRANY)"
  },
  {
   value: "Annezin (FRAZN)",
   label: "Annezin (FRAZN)"
  },
  {
   value: "Annonay (FRAOY)",
   label: "Annonay (FRAOY)"
  },
  {
   value: "Anould (FRANL)",
   label: "Anould (FRANL)"
  },
  {
   value: "Antibes (FRANT)",
   label: "Antibes (FRANT)"
  },
  {
   value: "Anzin (FRANZ)",
   label: "Anzin (FRANZ)"
  },
  {
   value: "Appoigny (FRAPP)",
   label: "Appoigny (FRAPP)"
  },
  {
   value: "Apprieu (FRAPR)",
   label: "Apprieu (FRAPR)"
  },
  {
   value: "Apt (FRAPT)",
   label: "Apt (FRAPT)"
  },
  {
   value: "Arbent (FRARB)",
   label: "Arbent (FRARB)"
  },
  {
   value: "Arbois (FRARS)",
   label: "Arbois (FRARS)"
  },
  {
   value: "Arc les Gray (FRALZ)",
   label: "Arc les Gray (FRALZ)"
  },
  {
   value: "Arcachon (FRARC)",
   label: "Arcachon (FRARC)"
  },
  {
   value: "Arches (FRACX)",
   label: "Arches (FRACX)"
  },
  {
   value: "Arcis sur Aube (FRASA)",
   label: "Arcis sur Aube (FRASA)"
  },
  {
   value: "Argenteuil (FRATL)",
   label: "Argenteuil (FRATL)"
  },
  {
   value: "Argentre du Plessis (FRADP)",
   label: "Argentre du Plessis (FRADP)"
  },
  {
   value: "Arles (FRARL)",
   label: "Arles (FRARL)"
  },
  {
   value: "Arnas (FRARN)",
   label: "Arnas (FRARN)"
  },
  {
   value: "Arpajon sur Cere (FRARP)",
   label: "Arpajon sur Cere (FRARP)"
  },
  {
   value: "Arques (FRARQ)",
   label: "Arques (FRARQ)"
  },
  {
   value: "Arras (FRARR)",
   label: "Arras (FRARR)"
  },
  {
   value: "Artix (FRART)",
   label: "Artix (FRART)"
  },
  {
   value: "Asnieres-la-Giraud (FRASR)",
   label: "Asnieres-la-Giraud (FRASR)"
  },
  {
   value: "Aspiran (FRASP)",
   label: "Aspiran (FRASP)"
  },
  {
   value: "Astaffort (FRAST)",
   label: "Astaffort (FRAST)"
  },
  {
   value: "At remy en Bouzement (FRSRZ)",
   label: "At remy en Bouzement (FRSRZ)"
  },
  {
   value: "Athis-Mons (FRATM)",
   label: "Athis-Mons (FRATM)"
  },
  {
   value: "Attichy (FRAAT)",
   label: "Attichy (FRAAT)"
  },
  {
   value: "Aubagne (FRABG)",
   label: "Aubagne (FRABG)"
  },
  {
   value: "Aube (FRAUB)",
   label: "Aube (FRAUB)"
  },
  {
   value: "Aubenas (FROBS)",
   label: "Aubenas (FROBS)"
  },
  {
   value: "Aubergenville (FRAUG)",
   label: "Aubergenville (FRAUG)"
  },
  {
   value: "Aubervilliers (FRAVS)",
   label: "Aubervilliers (FRAVS)"
  },
  {
   value: "Aubevoye (FRAVY)",
   label: "Aubevoye (FRAVY)"
  },
  {
   value: "Aubigne Racan (FRABR)",
   label: "Aubigne Racan (FRABR)"
  },
  {
   value: "Aubreville (FRABV)",
   label: "Aubreville (FRABV)"
  },
  {
   value: "Auby (FRAUS)",
   label: "Auby (FRAUS)"
  },
  {
   value: "Aigues vives (FRAGV)",
   label: "Aigues vives (FRAGV)"
  },
  {
   value: "Aiguillon (FRAGL)",
   label: "Aiguillon (FRAGL)"
  },
  {
   value: "Ailly sur Noye (FRAIL)",
   label: "Ailly sur Noye (FRAIL)"
  },
  {
   value: "Airaines (FRAIR)",
   label: "Airaines (FRAIR)"
  },
  {
   value: "Aix en Provence (FRQXB)",
   label: "Aix en Provence (FRQXB)"
  },
  {
   value: "Ajaccio (FRAJA)",
   label: "Ajaccio (FRAJA)"
  },
  {
   value: "Alban (FRABN)",
   label: "Alban (FRABN)"
  },
  {
   value: "Albertville (FRATV)",
   label: "Albertville (FRATV)"
  },
  {
   value: "Albi (FRLBI)",
   label: "Albi (FRLBI)"
  },
  {
   value: "Albias (FRALB)",
   label: "Albias (FRALB)"
  },
  {
   value: "Alby-sur-Cheran (FRASC)",
   label: "Alby-sur-Cheran (FRASC)"
  },
  {
   value: "Alencon (FRALE)",
   label: "Alencon (FRALE)"
  },
  {
   value: "Alès (FRALS)",
   label: "Alès (FRALS)"
  },
  {
   value: "Alizay (FRAAY)",
   label: "Alizay (FRAAY)"
  },
  {
   value: "Allaines Mervilliers (FRALL)",
   label: "Allaines Mervilliers (FRALL)"
  },
  {
   value: "Allex (FRALX)",
   label: "Allex (FRALX)"
  },
  {
   value: "Aloxe Corton (FRALC)",
   label: "Aloxe Corton (FRALC)"
  },
  {
   value: "Alpe D'huez (FRAHZ)",
   label: "Alpe D'huez (FRAHZ)"
  },
  {
   value: "Althen des Paluds (FRALP)",
   label: "Althen des Paluds (FRALP)"
  },
  {
   value: "Ambares-et-Lagrave (FRALG)",
   label: "Ambares-et-Lagrave (FRALG)"
  },
  {
   value: "Ambérieux (FRAMB)",
   label: "Ambérieux (FRAMB)"
  },
  {
   value: "Ambillou (FRAMO)",
   label: "Ambillou (FRAMO)"
  },
  {
   value: "Ambilly (FRAMY)",
   label: "Ambilly (FRAMY)"
  },
  {
   value: "Amboise (FRABO)",
   label: "Amboise (FRABO)"
  },
  {
   value: "Amelie-les-Bains-Palada (FRABP)",
   label: "Amelie-les-Bains-Palada (FRABP)"
  },
  {
   value: "Amfreville la Mi Voie (FRAFV)",
   label: "Amfreville la Mi Voie (FRAFV)"
  },
  {
   value: "Amiens (FRAMI)",
   label: "Amiens (FRAMI)"
  },
  {
   value: "Amphion les Bains (FRAFO)",
   label: "Amphion les Bains (FRAFO)"
  },
  {
   value: "Ampuis (FRUPA)",
   label: "Ampuis (FRUPA)"
  },
  {
   value: "Ancenis (FRANC)",
   label: "Ancenis (FRANC)"
  },
  {
   value: "Ancerville (FRACV)",
   label: "Ancerville (FRACV)"
  },
  {
   value: "Ande (FRADE)",
   label: "Ande (FRADE)"
  },
  {
   value: "Andelot-Blancheville (FRAND)",
   label: "Andelot-Blancheville (FRAND)"
  },
  {
   value: "Andreziux Boutheon (FRAZX)",
   label: "Andreziux Boutheon (FRAZX)"
  },
  {
   value: "Anet (FRAET)",
   label: "Anet (FRAET)"
  },
  {
   value: "Angers (FRANE)",
   label: "Angers (FRANE)"
  },
  {
   value: "Anglefort (FRAGT)",
   label: "Anglefort (FRAGT)"
  },
  {
   value: "Angoulême (FRANG)",
   label: "Angoulême (FRANG)"
  },
  {
   value: "Aniane (FRANN)",
   label: "Aniane (FRANN)"
  },
  {
   value: "Savusavu (FJSVU)",
   label: "Savusavu (FJSVU)"
  },
  {
   value: "Singatoka (FJSIN)",
   label: "Singatoka (FJSIN)"
  },
  {
   value: "Suva (FJSUV)",
   label: "Suva (FJSUV)"
  },
  {
   value: "Taveuni (FJTVU)",
   label: "Taveuni (FJTVU)"
  },
  {
   value: "Turtle Island (FJTTL)",
   label: "Turtle Island (FJTTL)"
  },
  {
   value: "Vanuabalavu (FJVBV)",
   label: "Vanuabalavu (FJVBV)"
  },
  {
   value: "Vatia (FJVAT)",
   label: "Vatia (FJVAT)"
  },
  {
   value: "Vatukoula (FJVAU)",
   label: "Vatukoula (FJVAU)"
  },
  {
   value: "Vatulele (FJVTF)",
   label: "Vatulele (FJVTF)"
  },
  {
   value: "Vuda (FJVUD)",
   label: "Vuda (FJVUD)"
  },
  {
   value: "Wakaya Island (FJKAY)",
   label: "Wakaya Island (FJKAY)"
  },
  {
   value: "Yasawa Island (FJYAS)",
   label: "Yasawa Island (FJYAS)"
  },
  {
   value: "Fox Bay (FKFBE)",
   label: "Fox Bay (FKFBE)"
  },
  {
   value: "Mount Pleasant (FKMPN)",
   label: "Mount Pleasant (FKMPN)"
  },
  {
   value: "Port Stanley (FKPSY)",
   label: "Port Stanley (FKPSY)"
  },
  {
   value: "Chuuk (Ex Truk) (FMTKK)",
   label: "Chuuk (Ex Truk) (FMTKK)"
  },
  {
   value: "Faisi (FMFSI)",
   label: "Faisi (FMFSI)"
  },
  {
   value: "Kosrae (Ex Kusaie) (FMKSA)",
   label: "Kosrae (Ex Kusaie) (FMKSA)"
  },
  {
   value: "Pohnpei (Ex Ponape) (FMPNI)",
   label: "Pohnpei (Ex Ponape) (FMPNI)"
  },
  {
   value: "Ulithi (FMULI)",
   label: "Ulithi (FMULI)"
  },
  {
   value: "Yap (FMYAP)",
   label: "Yap (FMYAP)"
  },
  {
   value: "Færøø Islands-Vagar Apt (FOFAE)",
   label: "Færøø Islands-Vagar Apt (FOFAE)"
  },
  {
   value: "Fuglafirdi (Fuglefjord) (FOFUG)",
   label: "Fuglafirdi (Fuglefjord) (FOFUG)"
  },
  {
   value: "Husevig (FOHUS)",
   label: "Husevig (FOHUS)"
  },
  {
   value: "Klaksvik (FOKVI)",
   label: "Klaksvik (FOKVI)"
  },
  {
   value: "Lopra (FOLOP)",
   label: "Lopra (FOLOP)"
  },
  {
   value: "Solmundefjord (FOSMJ)",
   label: "Solmundefjord (FOSMJ)"
  },
  {
   value: "Sorvagur (FOSRV)",
   label: "Sorvagur (FOSRV)"
  },
  {
   value: "Thorshavn (FOTHO)",
   label: "Thorshavn (FOTHO)"
  },
  {
   value: "Tvorøyri (FOTVO)",
   label: "Tvorøyri (FOTVO)"
  },
  {
   value: "Vadair (FOVID)",
   label: "Vadair (FOVID)"
  },
  {
   value: "Vestmanhavn (FOVES)",
   label: "Vestmanhavn (FOVES)"
  },
  {
   value: "Abbeville (FRABB)",
   label: "Abbeville (FRABB)"
  },
  {
   value: "Abidos (FRABD)",
   label: "Abidos (FRABD)"
  },
  {
   value: "Agen (FRAGF)",
   label: "Agen (FRAGF)"
  },
  {
   value: "Aigre (FRAIG)",
   label: "Aigre (FRAIG)"
  },
  {
   value: "Aigueblanche (FRAIB)",
   label: "Aigueblanche (FRAIB)"
  },
  {
   value: "Aigueperse (FRAGP)",
   label: "Aigueperse (FRAGP)"
  },
  {
   value: "Aigues Mortes (FRIAU)",
   label: "Aigues Mortes (FRIAU)"
  },
  {
   value: "Vaalimaa (FIVLA)",
   label: "Vaalimaa (FIVLA)"
  },
  {
   value: "Vaasa (Vasa) (FIVAA)",
   label: "Vaasa (Vasa) (FIVAA)"
  },
  {
   value: "Vainikkala (FIVAI)",
   label: "Vainikkala (FIVAI)"
  },
  {
   value: "Valkeakoski (FIVKK)",
   label: "Valkeakoski (FIVKK)"
  },
  {
   value: "Valko (Valkom) (FIVKO)",
   label: "Valko (Valkom) (FIVKO)"
  },
  {
   value: "Vanda (Vantaa) (FIVAT)",
   label: "Vanda (Vantaa) (FIVAT)"
  },
  {
   value: "Varkaus (FIVRK)",
   label: "Varkaus (FIVRK)"
  },
  {
   value: "Vartius (FIVRT)",
   label: "Vartius (FIVRT)"
  },
  {
   value: "Velkua (FIVEL)",
   label: "Velkua (FIVEL)"
  },
  {
   value: "Vihtavuori (FIVTV)",
   label: "Vihtavuori (FIVTV)"
  },
  {
   value: "Villmanstrand (Lappeenranta) (FILPP)",
   label: "Villmanstrand (Lappeenranta) (FILPP)"
  },
  {
   value: "Virolahti (FIVLI)",
   label: "Virolahti (FIVLI)"
  },
  {
   value: "Ylivieska (FIYLI)",
   label: "Ylivieska (FIYLI)"
  },
  {
   value: "Ba (FJBFJ)",
   label: "Ba (FJBFJ)"
  },
  {
   value: "Blue Lagoon (FJBXL)",
   label: "Blue Lagoon (FJBXL)"
  },
  {
   value: "Bua (FJBVF)",
   label: "Bua (FJBVF)"
  },
  {
   value: "Bureta (FJLEV)",
   label: "Bureta (FJLEV)"
  },
  {
   value: "Castaway (FJCST)",
   label: "Castaway (FJCST)"
  },
  {
   value: "Cicia (FJICI)",
   label: "Cicia (FJICI)"
  },
  {
   value: "Ellington (FJELL)",
   label: "Ellington (FJELL)"
  },
  {
   value: "Kandavu (FJKDV)",
   label: "Kandavu (FJKDV)"
  },
  {
   value: "Koro Island (FJKXF)",
   label: "Koro Island (FJKXF)"
  },
  {
   value: "Korolevu (FJKVU)",
   label: "Korolevu (FJKVU)"
  },
  {
   value: "Labasa (FJLBS)",
   label: "Labasa (FJLBS)"
  },
  {
   value: "Lakeba (FJLKB)",
   label: "Lakeba (FJLKB)"
  },
  {
   value: "Laucala Is (FJLUC)",
   label: "Laucala Is (FJLUC)"
  },
  {
   value: "Lautoka (FJLTK)",
   label: "Lautoka (FJLTK)"
  },
  {
   value: "Malau (Labasa) (FJMAL)",
   label: "Malau (Labasa) (FJMAL)"
  },
  {
   value: "Malololailai (FJPTF)",
   label: "Malololailai (FJPTF)"
  },
  {
   value: "Mana Island (FJMNF)",
   label: "Mana Island (FJMNF)"
  },
  {
   value: "Moala (FJMFJ)",
   label: "Moala (FJMFJ)"
  },
  {
   value: "Momi (FJMOM)",
   label: "Momi (FJMOM)"
  },
  {
   value: "Nadi (FJNAN)",
   label: "Nadi (FJNAN)"
  },
  {
   value: "Nambouwalu (FJNAM)",
   label: "Nambouwalu (FJNAM)"
  },
  {
   value: "Natadola (FJNTA)",
   label: "Natadola (FJNTA)"
  },
  {
   value: "Ngau Island (FJNGI)",
   label: "Ngau Island (FJNGI)"
  },
  {
   value: "Ono I Lau (FJONU)",
   label: "Ono I Lau (FJONU)"
  },
  {
   value: "Pacific Harbor (FJPHR)",
   label: "Pacific Harbor (FJPHR)"
  },
  {
   value: "Rabi (FJRBI)",
   label: "Rabi (FJRBI)"
  },
  {
   value: "Rotuma (FJRTA)",
   label: "Rotuma (FJRTA)"
  },
  {
   value: "Saqani (FJAQS)",
   label: "Saqani (FJAQS)"
  },
  {
   value: "Rautaruukki\/Raahe (FIRTR)",
   label: "Rautaruukki\/Raahe (FIRTR)"
  },
  {
   value: "Riihimäki (FIRIA)",
   label: "Riihimäki (FIRIA)"
  },
  {
   value: "Rimito (Rymättylä) (FIRYM)",
   label: "Rimito (Rymättylä) (FIRYM)"
  },
  {
   value: "Ristiina (FIRIS)",
   label: "Ristiina (FIRIS)"
  },
  {
   value: "Rovaniemi (FIRVN)",
   label: "Rovaniemi (FIRVN)"
  },
  {
   value: "Salla (FISLL)",
   label: "Salla (FISLL)"
  },
  {
   value: "Salo (FISAL)",
   label: "Salo (FISAL)"
  },
  {
   value: "Salpakangas (FISPK)",
   label: "Salpakangas (FISPK)"
  },
  {
   value: "Sammaljoki (FISJI)",
   label: "Sammaljoki (FISJI)"
  },
  {
   value: "Seinäjoki (FISJY)",
   label: "Seinäjoki (FISJY)"
  },
  {
   value: "Sibbo (Sipoo) (FISIP)",
   label: "Sibbo (Sipoo) (FISIP)"
  },
  {
   value: "Siilinjärvi (FISII)",
   label: "Siilinjärvi (FISII)"
  },
  {
   value: "Siuro (FISIO)",
   label: "Siuro (FISIO)"
  },
  {
   value: "Skogby (FISKB)",
   label: "Skogby (FISKB)"
  },
  {
   value: "Sodankylä (FISOT)",
   label: "Sodankylä (FISOT)"
  },
  {
   value: "Somero (FISRO)",
   label: "Somero (FISRO)"
  },
  {
   value: "St Karins (Kaarina) (FIKAA)",
   label: "St Karins (Kaarina) (FIKAA)"
  },
  {
   value: "Strömfors (Ruotsinpyhtää) (FIRUO)",
   label: "Strömfors (Ruotsinpyhtää) (FIRUO)"
  },
  {
   value: "Strömma (FISTR)",
   label: "Strömma (FISTR)"
  },
  {
   value: "Sveaborg (Suomenlinna) (FISBG)",
   label: "Sveaborg (Suomenlinna) (FISBG)"
  },
  {
   value: "Taivalkoski (FITAK)",
   label: "Taivalkoski (FITAK)"
  },
  {
   value: "Taivassalo (Tövsala) (FITVS)",
   label: "Taivassalo (Tövsala) (FITVS)"
  },
  {
   value: "Tammisaari (Ekenäs) (FITAI)",
   label: "Tammisaari (Ekenäs) (FITAI)"
  },
  {
   value: "Tampere (Tammerfors) (FITMP)",
   label: "Tampere (Tammerfors) (FITMP)"
  },
  {
   value: "Teijo (FITEI)",
   label: "Teijo (FITEI)"
  },
  {
   value: "Terjärv (Teerijärvi) (FITER)",
   label: "Terjärv (Teerijärvi) (FITER)"
  },
  {
   value: "Tervakoski (FITRK)",
   label: "Tervakoski (FITRK)"
  },
  {
   value: "Toijala (FITJA)",
   label: "Toijala (FITJA)"
  },
  {
   value: "Tolkis (Tolkkinen) (FITOK)",
   label: "Tolkis (Tolkkinen) (FITOK)"
  },
  {
   value: "Tornio (Torneå) (FITOR)",
   label: "Tornio (Torneå) (FITOR)"
  },
  {
   value: "Tupavuori (FITUP)",
   label: "Tupavuori (FITUP)"
  },
  {
   value: "Turku (Åbo) (FITKU)",
   label: "Turku (Åbo) (FITKU)"
  },
  {
   value: "Uimaharju (FIUIM)",
   label: "Uimaharju (FIUIM)"
  },
  {
   value: "Utsjoki (FIUTS)",
   label: "Utsjoki (FIUTS)"
  },
  {
   value: "Uukuniemi (FIUUK)",
   label: "Uukuniemi (FIUUK)"
  },
  {
   value: "Uusikaarlepyy (Nykarleby) (FIUKP)",
   label: "Uusikaarlepyy (Nykarleby) (FIUKP)"
  },
  {
   value: "Uusikaupunki (Nystad) (FIUKI)",
   label: "Uusikaupunki (Nystad) (FIUKI)"
  },
  {
   value: "Vaajakoski (FIVAJ)",
   label: "Vaajakoski (FIVAJ)"
  },
  {
   value: "Maaninka (FIMAA)",
   label: "Maaninka (FIMAA)"
  },
  {
   value: "Maarianhamina (Mariehamn) (FIMHQ)",
   label: "Maarianhamina (Mariehamn) (FIMHQ)"
  },
  {
   value: "Mänttä (FIMAN)",
   label: "Mänttä (FIMAN)"
  },
  {
   value: "Masku (FIMAS)",
   label: "Masku (FIMAS)"
  },
  {
   value: "Merikarvia (Sastmola) (FIMER)",
   label: "Merikarvia (Sastmola) (FIMER)"
  },
  {
   value: "Miehikkälä (FIMKA)",
   label: "Miehikkälä (FIMKA)"
  },
  {
   value: "Mikkeli (St Michel) (FIMIK)",
   label: "Mikkeli (St Michel) (FIMIK)"
  },
  {
   value: "Muonio (FIMUO)",
   label: "Muonio (FIMUO)"
  },
  {
   value: "Mustola (FIMUS)",
   label: "Mustola (FIMUS)"
  },
  {
   value: "Muurla (FIMRL)",
   label: "Muurla (FIMRL)"
  },
  {
   value: "Naantali (Nådendal) (FINLI)",
   label: "Naantali (Nådendal) (FINLI)"
  },
  {
   value: "Nagu (Nauvo) (FINAU)",
   label: "Nagu (Nauvo) (FINAU)"
  },
  {
   value: "Nakkila (FINKK)",
   label: "Nakkila (FINKK)"
  },
  {
   value: "Närpes (Närpiö) (FINRP)",
   label: "Närpes (Närpiö) (FINRP)"
  },
  {
   value: "Nastola (FINST)",
   label: "Nastola (FINST)"
  },
  {
   value: "Niirala (FINII)",
   label: "Niirala (FINII)"
  },
  {
   value: "Nokia (FINOK)",
   label: "Nokia (FINOK)"
  },
  {
   value: "Nuijamaa (FINUI)",
   label: "Nuijamaa (FINUI)"
  },
  {
   value: "Nurmes (FINUR)",
   label: "Nurmes (FINUR)"
  },
  {
   value: "Nuutajärvi (FINUU)",
   label: "Nuutajärvi (FINUU)"
  },
  {
   value: "Nyslott (Savonlinna) (FISVL)",
   label: "Nyslott (Savonlinna) (FISVL)"
  },
  {
   value: "Oitti (FIOTI)",
   label: "Oitti (FIOTI)"
  },
  {
   value: "Oripää (FIOIP)",
   label: "Oripää (FIOIP)"
  },
  {
   value: "Orivesi (FIORV)",
   label: "Orivesi (FIORV)"
  },
  {
   value: "Otanmäki (FIOTA)",
   label: "Otanmäki (FIOTA)"
  },
  {
   value: "Oulainen (FIOLA)",
   label: "Oulainen (FIOLA)"
  },
  {
   value: "Oulu (Uleåborg) (FIOUL)",
   label: "Oulu (Uleåborg) (FIOUL)"
  },
  {
   value: "Outokumpu (FIOUK)",
   label: "Outokumpu (FIOUK)"
  },
  {
   value: "Parainen (Pargas) (FIPAR)",
   label: "Parainen (Pargas) (FIPAR)"
  },
  {
   value: "Pello (FIPLL)",
   label: "Pello (FIPLL)"
  },
  {
   value: "Peltosalmi (FIPEL)",
   label: "Peltosalmi (FIPEL)"
  },
  {
   value: "Pernaja (Pernå) (FIPER)",
   label: "Pernaja (Pernå) (FIPER)"
  },
  {
   value: "Pietarsaari (Jacobstad) (FIPRS)",
   label: "Pietarsaari (Jacobstad) (FIPRS)"
  },
  {
   value: "Pirkkala (Birkala) (FIPIR)",
   label: "Pirkkala (Birkala) (FIPIR)"
  },
  {
   value: "Pohjankuru (Skuru) (FIPOH)",
   label: "Pohjankuru (Skuru) (FIPOH)"
  },
  {
   value: "Porvoo (Borgå) (FIPRV)",
   label: "Porvoo (Borgå) (FIPRV)"
  },
  {
   value: "Puumala (FIPUU)",
   label: "Puumala (FIPUU)"
  },
  {
   value: "Rajajooseppi (FIRAJ)",
   label: "Rajajooseppi (FIRAJ)"
  },
  {
   value: "Rauma (Raumo) (FIRAU)",
   label: "Rauma (Raumo) (FIRAU)"
  },
  {
   value: "Karis (Karjaa) (FIKJA)",
   label: "Karis (Karjaa) (FIKJA)"
  },
  {
   value: "Karleby\/Jakobstad(Kokkola\/Pietarsaari) (FIKOK)",
   label: "Karleby\/Jakobstad(Kokkola\/Pietarsaari) (FIKOK)"
  },
  {
   value: "Kärsämäki (FIKSK)",
   label: "Kärsämäki (FIKSK)"
  },
  {
   value: "Kaskinen (Kaskö) (FIKAS)",
   label: "Kaskinen (Kaskö) (FIKAS)"
  },
  {
   value: "Kauhajoki (FIKHJ)",
   label: "Kauhajoki (FIKHJ)"
  },
  {
   value: "Kauhava (FIKAU)",
   label: "Kauhava (FIKAU)"
  },
  {
   value: "Kausala (FIKSL)",
   label: "Kausala (FIKSL)"
  },
  {
   value: "Kemi\/Tornio (Kemi\/Torneå) (FIKEM)",
   label: "Kemi\/Tornio (Kemi\/Torneå) (FIKEM)"
  },
  {
   value: "Kemiö (Kimito) (FIKIM)",
   label: "Kemiö (Kimito) (FIKIM)"
  },
  {
   value: "Kerava (Kervo) \/ KUOREVESI (FIKEV)",
   label: "Kerava (Kervo) \/ KUOREVESI (FIKEV)"
  },
  {
   value: "Kilpilahti (Sköldvik) (FISKV)",
   label: "Kilpilahti (Sköldvik) (FISKV)"
  },
  {
   value: "Kilpisjärvi (FIKIL)",
   label: "Kilpisjärvi (FIKIL)"
  },
  {
   value: "Kitee (FIKTQ)",
   label: "Kitee (FIKTQ)"
  },
  {
   value: "Kittilä (FIKTT)",
   label: "Kittilä (FIKTT)"
  },
  {
   value: "Kivilompolo (FIKIV)",
   label: "Kivilompolo (FIKIV)"
  },
  {
   value: "Kökar (FIKKR)",
   label: "Kökar (FIKKR)"
  },
  {
   value: "Kolari (FIKLI)",
   label: "Kolari (FIKLI)"
  },
  {
   value: "Korpo (Korppoo) (FIKOR)",
   label: "Korpo (Korppoo) (FIKOR)"
  },
  {
   value: "Kotka (FIKTK)",
   label: "Kotka (FIKTK)"
  },
  {
   value: "Kouvola (FIKVO)",
   label: "Kouvola (FIKVO)"
  },
  {
   value: "Koverhaara (Koverhar) (FIKVH)",
   label: "Koverhaara (Koverhar) (FIKVH)"
  },
  {
   value: "Kristinestad (Kristiinankaupunki) (FIKRS)",
   label: "Kristinestad (Kristiinankaupunki) (FIKRS)"
  },
  {
   value: "Kronvik (FIKRO)",
   label: "Kronvik (FIKRO)"
  },
  {
   value: "Kumlinge (FIKUM)",
   label: "Kumlinge (FIKUM)"
  },
  {
   value: "Kuopio (FIKUO)",
   label: "Kuopio (FIKUO)"
  },
  {
   value: "Kuortane (FIKRT)",
   label: "Kuortane (FIKRT)"
  },
  {
   value: "Kuusamo (FIKAO)",
   label: "Kuusamo (FIKAO)"
  },
  {
   value: "Lahti (Lahtis) (FILHI)",
   label: "Lahti (Lahtis) (FILHI)"
  },
  {
   value: "Långnäs (FILAN)",
   label: "Långnäs (FILAN)"
  },
  {
   value: "Lappi (FILPI)",
   label: "Lappi (FILPI)"
  },
  {
   value: "Lappvik (Lappohja) (FILAP)",
   label: "Lappvik (Lappohja) (FILAP)"
  },
  {
   value: "Lieto (FILEO)",
   label: "Lieto (FILEO)"
  },
  {
   value: "Liljendal (FILLJ)",
   label: "Liljendal (FILLJ)"
  },
  {
   value: "Lohja (Lojo) (FILHJ)",
   label: "Lohja (Lojo) (FILHJ)"
  },
  {
   value: "Lovisa (Loviisa) (FILOV)",
   label: "Lovisa (Loviisa) (FILOV)"
  },
  {
   value: "Luhtajoki (FILHK)",
   label: "Luhtajoki (FILHK)"
  },
  {
   value: "Luvia (FILUV)",
   label: "Luvia (FILUV)"
  },
  {
   value: "Godby (FIGDB)",
   label: "Godby (FIGDB)"
  },
  {
   value: "Grankulla (Kauniainen) (FIKIN)",
   label: "Grankulla (Kauniainen) (FIKIN)"
  },
  {
   value: "Gustavs (Kustavi) (FIKUS)",
   label: "Gustavs (Kustavi) (FIKUS)"
  },
  {
   value: "Halikko (FIHLK)",
   label: "Halikko (FIHLK)"
  },
  {
   value: "Hämeenlinna (Tavastehus) (FIHMY)",
   label: "Hämeenlinna (Tavastehus) (FIHMY)"
  },
  {
   value: "Hanko (Hangö) (FIHKO)",
   label: "Hanko (Hangö) (FIHKO)"
  },
  {
   value: "Harjavalta (FIHRJ)",
   label: "Harjavalta (FIHRJ)"
  },
  {
   value: "Haukipudas (FIHAU)",
   label: "Haukipudas (FIHAU)"
  },
  {
   value: "Helsinki (Helsingfors) (FIHEL)",
   label: "Helsinki (Helsingfors) (FIHEL)"
  },
  {
   value: "Högfors (Karkkila) (FIKRK)",
   label: "Högfors (Karkkila) (FIKRK)"
  },
  {
   value: "Hollola (FIHOL)",
   label: "Hollola (FIHOL)"
  },
  {
   value: "Houtskari (Houtskär) (FIHOU)",
   label: "Houtskari (Houtskär) (FIHOU)"
  },
  {
   value: "Hyrylä (FIHYR)",
   label: "Hyrylä (FIHYR)"
  },
  {
   value: "Hyvinge (Hyvinkää) (FIHYV)",
   label: "Hyvinge (Hyvinkää) (FIHYV)"
  },
  {
   value: "Idensalmi (Iisalmi) (FIIIS)",
   label: "Idensalmi (Iisalmi) (FIIIS)"
  },
  {
   value: "Ilmajoki (FIIJK)",
   label: "Ilmajoki (FIIJK)"
  },
  {
   value: "Imatra (FIIMA)",
   label: "Imatra (FIIMA)"
  },
  {
   value: "Iniö (FIINI)",
   label: "Iniö (FIINI)"
  },
  {
   value: "Inkoo (Ingå) (FIINK)",
   label: "Inkoo (Ingå) (FIINK)"
  },
  {
   value: "Isnäs (FIISN)",
   label: "Isnäs (FIISN)"
  },
  {
   value: "Ivalo (FIIVL)",
   label: "Ivalo (FIIVL)"
  },
  {
   value: "Jämsä (FIJMS)",
   label: "Jämsä (FIJMS)"
  },
  {
   value: "Jämsänkoski (FIJSK)",
   label: "Jämsänkoski (FIJSK)"
  },
  {
   value: "Järvenpää (Träskända) (FIJVP)",
   label: "Järvenpää (Träskända) (FIJVP)"
  },
  {
   value: "Jeppo (Jepua) (FIJPA)",
   label: "Jeppo (Jepua) (FIJPA)"
  },
  {
   value: "Joensuu (FIJOE)",
   label: "Joensuu (FIJOE)"
  },
  {
   value: "Joutseno (FIJOU)",
   label: "Joutseno (FIJOU)"
  },
  {
   value: "Jurva (FIJRV)",
   label: "Jurva (FIJRV)"
  },
  {
   value: "Jyväskylä (FIJYV)",
   label: "Jyväskylä (FIJYV)"
  },
  {
   value: "Kajaani (Kajana) (FIKAJ)",
   label: "Kajaani (Kajana) (FIKAJ)"
  },
  {
   value: "Kalajoki (FIKJO)",
   label: "Kalajoki (FIKJO)"
  },
  {
   value: "Kalkkiranta (Kalkstrand) \/ KARESUVANTO (FIKAR)",
   label: "Kalkkiranta (Kalkstrand) \/ KARESUVANTO (FIKAR)"
  },
  {
   value: "Kangasala (FIKSA)",
   label: "Kangasala (FIKSA)"
  },
  {
   value: "Kankaanpää (FIKNP)",
   label: "Kankaanpää (FIKNP)"
  },
  {
   value: "Kantvik (FIKNT)",
   label: "Kantvik (FIKNT)"
  },
  {
   value: "Karhula (FIKUL)",
   label: "Karhula (FIKUL)"
  },
  {
   value: "Karigasniemi (FIKAI)",
   label: "Karigasniemi (FIKAI)"
  },
  {
   value: "Bahar Dar (ETBJR)",
   label: "Bahar Dar (ETBJR)"
  },
  {
   value: "Bulchi (ETBCY)",
   label: "Bulchi (ETBCY)"
  },
  {
   value: "Debra Marcos (ETDBM)",
   label: "Debra Marcos (ETDBM)"
  },
  {
   value: "Dembidollo (ETDEM)",
   label: "Dembidollo (ETDEM)"
  },
  {
   value: "Dessie (ETDSE)",
   label: "Dessie (ETDSE)"
  },
  {
   value: "Dire Dawa (ETDIR)",
   label: "Dire Dawa (ETDIR)"
  },
  {
   value: "Gambela (ETGMB)",
   label: "Gambela (ETGMB)"
  },
  {
   value: "Goba (ETGOB)",
   label: "Goba (ETGOB)"
  },
  {
   value: "Gondar (ETGDQ)",
   label: "Gondar (ETGDQ)"
  },
  {
   value: "Gore (ETGOR)",
   label: "Gore (ETGOR)"
  },
  {
   value: "Humera (ETHUE)",
   label: "Humera (ETHUE)"
  },
  {
   value: "Jimma (ETJIM)",
   label: "Jimma (ETJIM)"
  },
  {
   value: "Kelafo\/Callaf (ETLFO)",
   label: "Kelafo\/Callaf (ETLFO)"
  },
  {
   value: "Makale (ETMQX)",
   label: "Makale (ETMQX)"
  },
  {
   value: "Mekane Selam (ETMKS)",
   label: "Mekane Selam (ETMKS)"
  },
  {
   value: "Mena (ETMZX)",
   label: "Mena (ETMZX)"
  },
  {
   value: "Mizan Teferi (ETMTF)",
   label: "Mizan Teferi (ETMTF)"
  },
  {
   value: "Mota (ETOTA)",
   label: "Mota (ETOTA)"
  },
  {
   value: "Mui (ETMUJ)",
   label: "Mui (ETMUJ)"
  },
  {
   value: "Soddu (ETSXU)",
   label: "Soddu (ETSXU)"
  },
  {
   value: "Tippi (ETTIE)",
   label: "Tippi (ETTIE)"
  },
  {
   value: "Waca (ETWAC)",
   label: "Waca (ETWAC)"
  },
  {
   value: "Äänekoski (FIAAN)",
   label: "Äänekoski (FIAAN)"
  },
  {
   value: "Aavasaksa (FIAVS)",
   label: "Aavasaksa (FIAVS)"
  },
  {
   value: "Alavus (FIALV)",
   label: "Alavus (FIALV)"
  },
  {
   value: "Anjalankoski (FIANJ)",
   label: "Anjalankoski (FIANJ)"
  },
  {
   value: "Björneborg (Pori) (FIPOR)",
   label: "Björneborg (Pori) (FIPOR)"
  },
  {
   value: "Brahestad (Raahe) (FIRAA)",
   label: "Brahestad (Raahe) (FIRAA)"
  },
  {
   value: "Brändö (FIBRA)",
   label: "Brändö (FIBRA)"
  },
  {
   value: "Dalsbruk (Taalintehdas) (FIDLS)",
   label: "Dalsbruk (Taalintehdas) (FIDLS)"
  },
  {
   value: "Dragsfjärd (FIDRA)",
   label: "Dragsfjärd (FIDRA)"
  },
  {
   value: "Eckerö (FIECK)",
   label: "Eckerö (FIECK)"
  },
  {
   value: "Enonkoski (FIENK)",
   label: "Enonkoski (FIENK)"
  },
  {
   value: "Enontekiö (Enontekis) (FIENF)",
   label: "Enontekiö (Enontekis) (FIENF)"
  },
  {
   value: "Esbo (Espoo) (FIESP)",
   label: "Esbo (Espoo) (FIESP)"
  },
  {
   value: "Euraåminne (Eurajoki) (FIEJO)",
   label: "Euraåminne (Eurajoki) (FIEJO)"
  },
  {
   value: "Färjsund (FIFAR)",
   label: "Färjsund (FIFAR)"
  },
  {
   value: "Föglö (FIFOG)",
   label: "Föglö (FIFOG)"
  },
  {
   value: "Förby (FIFOR)",
   label: "Förby (FIFOR)"
  },
  {
   value: "Forssa (FIFSF)",
   label: "Forssa (FIFSF)"
  },
  {
   value: "Fredrikshamn (Hamina) (FIHMN)",
   label: "Fredrikshamn (Hamina) (FIHMN)"
  },
  {
   value: "Villajoyosa (ESVJY)",
   label: "Villajoyosa (ESVJY)"
  },
  {
   value: "Villalonga (ESVLN)",
   label: "Villalonga (ESVLN)"
  },
  {
   value: "Villamayor (ESVYR)",
   label: "Villamayor (ESVYR)"
  },
  {
   value: "Villanueva De Castellon (ESVVC)",
   label: "Villanueva De Castellon (ESVVC)"
  },
  {
   value: "Villanueva De La Jara (ESVLQ)",
   label: "Villanueva De La Jara (ESVLQ)"
  },
  {
   value: "Villanueva De La Serena (ESVVS)",
   label: "Villanueva De La Serena (ESVVS)"
  },
  {
   value: "Villanueva De Tapia (ESVVT)",
   label: "Villanueva De Tapia (ESVVT)"
  },
  {
   value: "Villanueva Del Aceral (ESVVA)",
   label: "Villanueva Del Aceral (ESVVA)"
  },
  {
   value: "Villanueva Del Rio (ESVDR)",
   label: "Villanueva Del Rio (ESVDR)"
  },
  {
   value: "Villanueva Del Trabuco (ESVTC)",
   label: "Villanueva Del Trabuco (ESVTC)"
  },
  {
   value: "Villar Del Rey (ESVDY)",
   label: "Villar Del Rey (ESVDY)"
  },
  {
   value: "Villareal (ESVRL)",
   label: "Villareal (ESVRL)"
  },
  {
   value: "Villarejo De Salva (ESVDS)",
   label: "Villarejo De Salva (ESVDS)"
  },
  {
   value: "Villarrobledo (ESVRF)",
   label: "Villarrobledo (ESVRF)"
  },
  {
   value: "Villaviciosa (ESVVX)",
   label: "Villaviciosa (ESVVX)"
  },
  {
   value: "Villena (ESVNA)",
   label: "Villena (ESVNA)"
  },
  {
   value: "Vilob Del Penedes (ESVDE)",
   label: "Vilob Del Penedes (ESVDE)"
  },
  {
   value: "Vilovi Del Penedes (ESVVP)",
   label: "Vilovi Del Penedes (ESVVP)"
  },
  {
   value: "Vinaroz (ESVZR)",
   label: "Vinaroz (ESVZR)"
  },
  {
   value: "Visos Del Alcor (ESVAK)",
   label: "Visos Del Alcor (ESVAK)"
  },
  {
   value: "Vitoria (ESVIT)",
   label: "Vitoria (ESVIT)"
  },
  {
   value: "Vivero (ESVIV)",
   label: "Vivero (ESVIV)"
  },
  {
   value: "Yecla (ESYEC)",
   label: "Yecla (ESYEC)"
  },
  {
   value: "Zafarraya (ESZYY)",
   label: "Zafarraya (ESZYY)"
  },
  {
   value: "Zafra (ESZAF)",
   label: "Zafra (ESZAF)"
  },
  {
   value: "Zahinos (ESZAH)",
   label: "Zahinos (ESZAH)"
  },
  {
   value: "Zaragoza (ESZAZ)",
   label: "Zaragoza (ESZAZ)"
  },
  {
   value: "Zona Franca de Cadiz (ESZFR)",
   label: "Zona Franca de Cadiz (ESZFR)"
  },
  {
   value: "Zubiri (ESZUB)",
   label: "Zubiri (ESZUB)"
  },
  {
   value: "Zumarraga (ESZRR)",
   label: "Zumarraga (ESZRR)"
  },
  {
   value: "Zumaya (ESZMY)",
   label: "Zumaya (ESZMY)"
  },
  {
   value: "HUMANES DE MADRID (ESHMS)",
   label: "HUMANES DE MADRID (ESHMS)"
  },
  {
   value: "SANTA COLOMA DE FAR (ESSCF)",
   label: "SANTA COLOMA DE FAR (ESSCF)"
  },
  {
   value: "Addis Ababa (ETADD)",
   label: "Addis Ababa (ETADD)"
  },
  {
   value: "Arba Mintch (ETAMH)",
   label: "Arba Mintch (ETAMH)"
  },
  {
   value: "Asosa (ETASO)",
   label: "Asosa (ETASO)"
  },
  {
   value: "Awassa (ETAWA)",
   label: "Awassa (ETAWA)"
  },
  {
   value: "Axum (ETAXU)",
   label: "Axum (ETAXU)"
  },
  {
   value: "Valdepenas (ESVAP)",
   label: "Valdepenas (ESVAP)"
  },
  {
   value: "Valderubio (ESVAR)",
   label: "Valderubio (ESVAR)"
  },
  {
   value: "Valencia (ESVLC)",
   label: "Valencia (ESVLC)"
  },
  {
   value: "Valencia de Alcantara (ESVDA)",
   label: "Valencia de Alcantara (ESVDA)"
  },
  {
   value: "Valencia De La Concepcion (ESVCP)",
   label: "Valencia De La Concepcion (ESVCP)"
  },
  {
   value: "Vall De Uxo (ESVDU)",
   label: "Vall De Uxo (ESVDU)"
  },
  {
   value: "Vallada (ESVLA)",
   label: "Vallada (ESVLA)"
  },
  {
   value: "Valladolid (ESVLL)",
   label: "Valladolid (ESVLL)"
  },
  {
   value: "Vallclara (ESVCA)",
   label: "Vallclara (ESVCA)"
  },
  {
   value: "Valle Gran Rey (ESVGR)",
   label: "Valle Gran Rey (ESVGR)"
  },
  {
   value: "Valls (ESVEP)",
   label: "Valls (ESVEP)"
  },
  {
   value: "Valverde De Leganes (ESVVL)",
   label: "Valverde De Leganes (ESVVL)"
  },
  {
   value: "Vara De Quart (ESVDQ)",
   label: "Vara De Quart (ESVDQ)"
  },
  {
   value: "Vega De Celin (ESVGC)",
   label: "Vega De Celin (ESVGC)"
  },
  {
   value: "Velez Malaga (ESVMG)",
   label: "Velez Malaga (ESVMG)"
  },
  {
   value: "Vergel (ESVGL)",
   label: "Vergel (ESVGL)"
  },
  {
   value: "Verges (ESVRG)",
   label: "Verges (ESVRG)"
  },
  {
   value: "Verin (ESVER)",
   label: "Verin (ESVER)"
  },
  {
   value: "Vic (ESVIC)",
   label: "Vic (ESVIC)"
  },
  {
   value: "Vicar (ESVIQ)",
   label: "Vicar (ESVIQ)"
  },
  {
   value: "Vigo (ESVGO)",
   label: "Vigo (ESVGO)"
  },
  {
   value: "Viladecaballs (ESVCD)",
   label: "Viladecaballs (ESVCD)"
  },
  {
   value: "Viladecans (ESVCN)",
   label: "Viladecans (ESVCN)"
  },
  {
   value: "Vilafranca del Penedes (ESVFR)",
   label: "Vilafranca del Penedes (ESVFR)"
  },
  {
   value: "Vilanova y la Galtru (ESVLG)",
   label: "Vilanova y la Galtru (ESVLG)"
  },
  {
   value: "Vilar del Caudillo (ESVDC)",
   label: "Vilar del Caudillo (ESVDC)"
  },
  {
   value: "Vilaseca (ESVSE)",
   label: "Vilaseca (ESVSE)"
  },
  {
   value: "Vilches (ESVCH)",
   label: "Vilches (ESVCH)"
  },
  {
   value: "Villa De Salvares (ESVSV)",
   label: "Villa De Salvares (ESVSV)"
  },
  {
   value: "Villa Del Rio (ESVIO)",
   label: "Villa Del Rio (ESVIO)"
  },
  {
   value: "Villa Presente (ESVPS)",
   label: "Villa Presente (ESVPS)"
  },
  {
   value: "Villafames (ESVFI)",
   label: "Villafames (ESVFI)"
  },
  {
   value: "Villafranca De Los Barros (ESVFB)",
   label: "Villafranca De Los Barros (ESVFB)"
  },
  {
   value: "Villafranco Del Guadalqu (ESVGQ)",
   label: "Villafranco Del Guadalqu (ESVGQ)"
  },
  {
   value: "Villafranco Del Guadiana (ESVGU)",
   label: "Villafranco Del Guadiana (ESVGU)"
  },
  {
   value: "Villagarcia (de Arosa) (ESVIL)",
   label: "Villagarcia (de Arosa) (ESVIL)"
  },
  {
   value: "Villagonzalo (ESVGZ)",
   label: "Villagonzalo (ESVGZ)"
  },
  {
   value: "Tarifa (ESTRF)",
   label: "Tarifa (ESTRF)"
  },
  {
   value: "Tarragona (ESTAR)",
   label: "Tarragona (ESTAR)"
  },
  {
   value: "Tarrasa (ESTSX)",
   label: "Tarrasa (ESTSX)"
  },
  {
   value: "Tarrega (ESTGY)",
   label: "Tarrega (ESTGY)"
  },
  {
   value: "Tenerife (ESTCI)",
   label: "Tenerife (ESTCI)"
  },
  {
   value: "Terrassa (ESTQE)",
   label: "Terrassa (ESTQE)"
  },
  {
   value: "Teruel (ESTER)",
   label: "Teruel (ESTER)"
  },
  {
   value: "Toledo (ESTOL)",
   label: "Toledo (ESTOL)"
  },
  {
   value: "Tomares (ESTMA)",
   label: "Tomares (ESTMA)"
  },
  {
   value: "Tomelloso (ESTME)",
   label: "Tomelloso (ESTME)"
  },
  {
   value: "Tora (ESTOG)",
   label: "Tora (ESTOG)"
  },
  {
   value: "Torello (ESTIO)",
   label: "Torello (ESTIO)"
  },
  {
   value: "Torre Del Campo (ESTDK)",
   label: "Torre Del Campo (ESTDK)"
  },
  {
   value: "Torre Del Mar (ESTDM)",
   label: "Torre Del Mar (ESTDM)"
  },
  {
   value: "Torreaguera (ESTGW)",
   label: "Torreaguera (ESTGW)"
  },
  {
   value: "Torreblanca (ESTBC)",
   label: "Torreblanca (ESTBC)"
  },
  {
   value: "Torrejon De Ardoz (ESTRJ)",
   label: "Torrejon De Ardoz (ESTRJ)"
  },
  {
   value: "Torrejon El Rubio (ESTJR)",
   label: "Torrejon El Rubio (ESTJR)"
  },
  {
   value: "Torrelavega (ESTVG)",
   label: "Torrelavega (ESTVG)"
  },
  {
   value: "Torrelavid (ESTOV)",
   label: "Torrelavid (ESTOV)"
  },
  {
   value: "Torremolinos (ESTLS)",
   label: "Torremolinos (ESTLS)"
  },
  {
   value: "Torrente (ESTOF)",
   label: "Torrente (ESTOF)"
  },
  {
   value: "Torrepacheco (ESTPQ)",
   label: "Torrepacheco (ESTPQ)"
  },
  {
   value: "Torrevieja (ESTOR)",
   label: "Torrevieja (ESTOR)"
  },
  {
   value: "Torroella de Montgri (ESTOO)",
   label: "Torroella de Montgri (ESTOO)"
  },
  {
   value: "Tortosa (ESTOT)",
   label: "Tortosa (ESTOT)"
  },
  {
   value: "Treto (ESTTO)",
   label: "Treto (ESTTO)"
  },
  {
   value: "Tudela de Duero (ESTDD)",
   label: "Tudela de Duero (ESTDD)"
  },
  {
   value: "Tuitar D\/Caudillo (ESTXQ)",
   label: "Tuitar D\/Caudillo (ESTXQ)"
  },
  {
   value: "Turis (ESTSS)",
   label: "Turis (ESTSS)"
  },
  {
   value: "Tuy (ESTUY)",
   label: "Tuy (ESTUY)"
  },
  {
   value: "Ubeda (ESUBD)",
   label: "Ubeda (ESUBD)"
  },
  {
   value: "Ubrique (ESUBQ)",
   label: "Ubrique (ESUBQ)"
  },
  {
   value: "Umbrete (ESUMB)",
   label: "Umbrete (ESUMB)"
  },
  {
   value: "Usurbil (ESUSU)",
   label: "Usurbil (ESUSU)"
  },
  {
   value: "Utrera (ESUTA)",
   label: "Utrera (ESUTA)"
  },
  {
   value: "Valcarlos (ESVCL)",
   label: "Valcarlos (ESVCL)"
  },
  {
   value: "Valdehornillos (ESVAH)",
   label: "Valdehornillos (ESVAH)"
  },
  {
   value: "Valdemorillo De La Sierra (ESVOI)",
   label: "Valdemorillo De La Sierra (ESVOI)"
  },
  {
   value: "Valdemoro (ESVAO)",
   label: "Valdemoro (ESVAO)"
  },
  {
   value: "Santa Cruz de Tenerife (ESSCT)",
   label: "Santa Cruz de Tenerife (ESSCT)"
  },
  {
   value: "Santa Eulalia del Rio (ESSTE)",
   label: "Santa Eulalia del Rio (ESSTE)"
  },
  {
   value: "Santa Margarita Monjos (ESSGJ)",
   label: "Santa Margarita Monjos (ESSGJ)"
  },
  {
   value: "Santa Perpetua De Moguda (ESSPM)",
   label: "Santa Perpetua De Moguda (ESSPM)"
  },
  {
   value: "Santa Pola (ESSPO)",
   label: "Santa Pola (ESSPO)"
  },
  {
   value: "Santander (ESSDR)",
   label: "Santander (ESSDR)"
  },
  {
   value: "Santiago de Compostela (ESSCQ)",
   label: "Santiago de Compostela (ESSCQ)"
  },
  {
   value: "Santiponce (ESSPN)",
   label: "Santiponce (ESSPN)"
  },
  {
   value: "Santomera (ESSTP)",
   label: "Santomera (ESSTP)"
  },
  {
   value: "Santurce (ESSNR)",
   label: "Santurce (ESSNR)"
  },
  {
   value: "Sarria De Ter (ESSRZ)",
   label: "Sarria De Ter (ESSRZ)"
  },
  {
   value: "Sax (ESSAX)",
   label: "Sax (ESSAX)"
  },
  {
   value: "Sedavi (ESSDV)",
   label: "Sedavi (ESSDV)"
  },
  {
   value: "Segorbe (ESSGR)",
   label: "Segorbe (ESSGR)"
  },
  {
   value: "Segovia (ESSEG)",
   label: "Segovia (ESSEG)"
  },
  {
   value: "Seo De Urgel (ESLEU)",
   label: "Seo De Urgel (ESLEU)"
  },
  {
   value: "Serina (ESSEA)",
   label: "Serina (ESSEA)"
  },
  {
   value: "Sevilla (ESSVQ)",
   label: "Sevilla (ESSVQ)"
  },
  {
   value: "Sierra De Yeguas (ESSYG)",
   label: "Sierra De Yeguas (ESSYG)"
  },
  {
   value: "Silla (ESSIL)",
   label: "Silla (ESSIL)"
  },
  {
   value: "Sn Esteban Sasrovirs (ESSXS)",
   label: "Sn Esteban Sasrovirs (ESSXS)"
  },
  {
   value: "Solsona (ESSSN)",
   label: "Solsona (ESSSN)"
  },
  {
   value: "Soneja (ESSON)",
   label: "Soneja (ESSON)"
  },
  {
   value: "Sonesca (ESSSC)",
   label: "Sonesca (ESSSC)"
  },
  {
   value: "Soria (ESSOR)",
   label: "Soria (ESSOR)"
  },
  {
   value: "Soses (ESSZO)",
   label: "Soses (ESSZO)"
  },
  {
   value: "Sotogrande (ESSTG)",
   label: "Sotogrande (ESSTG)"
  },
  {
   value: "Sudanell (ESSUD)",
   label: "Sudanell (ESSUD)"
  },
  {
   value: "Sueca (ESSQA)",
   label: "Sueca (ESSQA)"
  },
  {
   value: "Tabernes Blanques (ESTQB)",
   label: "Tabernes Blanques (ESTQB)"
  },
  {
   value: "Tabernes De Valldigna (ESTAB)",
   label: "Tabernes De Valldigna (ESTAB)"
  },
  {
   value: "Tafalla (ESTAF)",
   label: "Tafalla (ESTAF)"
  },
  {
   value: "Talavera De La Reina (ESTLI)",
   label: "Talavera De La Reina (ESTLI)"
  },
  {
   value: "Talavera La Real (ESTLV)",
   label: "Talavera La Real (ESTLV)"
  },
  {
   value: "Talayuela (ESTYZ)",
   label: "Talayuela (ESTYZ)"
  },
  {
   value: "Tamarite De Litera (ESTMD)",
   label: "Tamarite De Litera (ESTMD)"
  },
  {
   value: "Taradell (ESTEJ)",
   label: "Taradell (ESTEJ)"
  },
  {
   value: "Tarancon (ESTAQ)",
   label: "Tarancon (ESTAQ)"
  },
  {
   value: "San Juan De Aznalfarache (ESSJA)",
   label: "San Juan De Aznalfarache (ESSJA)"
  },
  {
   value: "San Juan De Nivea (ESSJN)",
   label: "San Juan De Nivea (ESSJN)"
  },
  {
   value: "San Juan Del Puerto (ESSJP)",
   label: "San Juan Del Puerto (ESSJP)"
  },
  {
   value: "San Juan Despi (Dupl. SJN) (ESSJD)",
   label: "San Juan Despi (Dupl. SJN) (ESSJD)"
  },
  {
   value: "San Juan Le Fonts (ESSJF)",
   label: "San Juan Le Fonts (ESSJF)"
  },
  {
   value: "San Justo Desvern (ESSJQ)",
   label: "San Justo Desvern (ESSJQ)"
  },
  {
   value: "San Lorenzo De El Escoria (ESSNL)",
   label: "San Lorenzo De El Escoria (ESSNL)"
  },
  {
   value: "San Lucar La Mayor (ESZLM)",
   label: "San Lucar La Mayor (ESZLM)"
  },
  {
   value: "San Martin Del Teso (ESSMT)",
   label: "San Martin Del Teso (ESSMT)"
  },
  {
   value: "San Martin Sarroca (ESSMS)",
   label: "San Martin Sarroca (ESSMS)"
  },
  {
   value: "San Pedro De Alcantara (ESSPA)",
   label: "San Pedro De Alcantara (ESSPA)"
  },
  {
   value: "San Pedro De Premia (ESSPD)",
   label: "San Pedro De Premia (ESSPD)"
  },
  {
   value: "San Pedro del Pinatar (ESSPP)",
   label: "San Pedro del Pinatar (ESSPP)"
  },
  {
   value: "San Pedro Riudevitlles (ESSPR)",
   label: "San Pedro Riudevitlles (ESSPR)"
  },
  {
   value: "San Quirico Del Vall (ESSQU)",
   label: "San Quirico Del Vall (ESSQU)"
  },
  {
   value: "San Roque (ESSRQ)",
   label: "San Roque (ESSRQ)"
  },
  {
   value: "San Sadurni D Noya (ESSSY)",
   label: "San Sadurni D Noya (ESSSY)"
  },
  {
   value: "San Sebastian (ESEAS)",
   label: "San Sebastian (ESEAS)"
  },
  {
   value: "San Sebastian D\/L Reyes (ESSSR)",
   label: "San Sebastian D\/L Reyes (ESSSR)"
  },
  {
   value: "San Sebastian de la Gomera (ESSSG)",
   label: "San Sebastian de la Gomera (ESSSG)"
  },
  {
   value: "San Vicente De Alcantara (ESSVA)",
   label: "San Vicente De Alcantara (ESSVA)"
  },
  {
   value: "San Vicente De Castellet (ESSXV)",
   label: "San Vicente De Castellet (ESSXV)"
  },
  {
   value: "San Vicente Dels Horts (ESSVH)",
   label: "San Vicente Dels Horts (ESSVH)"
  },
  {
   value: "Sanlucar De Barrameda (ESSBA)",
   label: "Sanlucar De Barrameda (ESSBA)"
  },
  {
   value: "Sant Andreu (ESSTA)",
   label: "Sant Andreu (ESSTA)"
  },
  {
   value: "Sant Boi de Ilobregat (ESSBL)",
   label: "Sant Boi de Ilobregat (ESSBL)"
  },
  {
   value: "Sant Feliu (ESSTF)",
   label: "Sant Feliu (ESSTF)"
  },
  {
   value: "Sant Gregori (ESSGG)",
   label: "Sant Gregori (ESSGG)"
  },
  {
   value: "Sant Sadurni d'Anoia (ESSSA)",
   label: "Sant Sadurni d'Anoia (ESSSA)"
  },
  {
   value: "Sant Vicenc De Torello (ESSVT)",
   label: "Sant Vicenc De Torello (ESSVT)"
  },
  {
   value: "Santa Andreu de la b (ESSND)",
   label: "Santa Andreu de la b (ESSND)"
  },
  {
   value: "Santa Cruz de La Palma (ESSPC)",
   label: "Santa Cruz de La Palma (ESSPC)"
  },
  {
   value: "Santa Cruz de Mudela (ESSCM)",
   label: "Santa Cruz de Mudela (ESSCM)"
  },
  {
   value: "Ribas De Jarama (ESRJA)",
   label: "Ribas De Jarama (ESRJA)"
  },
  {
   value: "Ribesalbes (ESRSB)",
   label: "Ribesalbes (ESRSB)"
  },
  {
   value: "Rincon De La Victoria (ESRCV)",
   label: "Rincon De La Victoria (ESRCV)"
  },
  {
   value: "Ripollet (ESRPP)",
   label: "Ripollet (ESRPP)"
  },
  {
   value: "Riudoms (ESRXI)",
   label: "Riudoms (ESRXI)"
  },
  {
   value: "Ronda (ESRNA)",
   label: "Ronda (ESRNA)"
  },
  {
   value: "Roquetas De Mar (ESRQM)",
   label: "Roquetas De Mar (ESRQM)"
  },
  {
   value: "Rosal De La Frontera (ESRFT)",
   label: "Rosal De La Frontera (ESRFT)"
  },
  {
   value: "Rosas (ESROS)",
   label: "Rosas (ESROS)"
  },
  {
   value: "Rota (ESROT)",
   label: "Rota (ESROT)"
  },
  {
   value: "Rubi (ESRIU)",
   label: "Rubi (ESRIU)"
  },
  {
   value: "Sabadell (ESSBP)",
   label: "Sabadell (ESSBP)"
  },
  {
   value: "Sabinanigo (ESSJJ)",
   label: "Sabinanigo (ESSJJ)"
  },
  {
   value: "Sada (ESSAD)",
   label: "Sada (ESSAD)"
  },
  {
   value: "Sagunto (ESSAG)",
   label: "Sagunto (ESSAG)"
  },
  {
   value: "Salamanca (ESSLM)",
   label: "Salamanca (ESSLM)"
  },
  {
   value: "Salinetas (ESSAT)",
   label: "Salinetas (ESSAT)"
  },
  {
   value: "Salobrena (ESSLA)",
   label: "Salobrena (ESSLA)"
  },
  {
   value: "Salteras (ESSAL)",
   label: "Salteras (ESSAL)"
  },
  {
   value: "San Adrian (ESSAN)",
   label: "San Adrian (ESSAN)"
  },
  {
   value: "San Andreas De La Barca (ESSDB)",
   label: "San Andreas De La Barca (ESSDB)"
  },
  {
   value: "San Antonio (ESSAA)",
   label: "San Antonio (ESSAA)"
  },
  {
   value: "San Bartolome D\/Grau (ESSBG)",
   label: "San Bartolome D\/Grau (ESSBG)"
  },
  {
   value: "San Carlos de la Rapita (ESSCR)",
   label: "San Carlos de la Rapita (ESSCR)"
  },
  {
   value: "San Ciprian (ESSCI)",
   label: "San Ciprian (ESSCI)"
  },
  {
   value: "San Clemente (ESSCL)",
   label: "San Clemente (ESSCL)"
  },
  {
   value: "San Cugat De Valles (ESSCU)",
   label: "San Cugat De Valles (ESSCU)"
  },
  {
   value: "San Esteban (ESSNE)",
   label: "San Esteban (ESSNE)"
  },
  {
   value: "San Esteban De Bas (ESSNB)",
   label: "San Esteban De Bas (ESSNB)"
  },
  {
   value: "San Esteban de Pravia (ESSEO)",
   label: "San Esteban de Pravia (ESSEO)"
  },
  {
   value: "San Esteve De Sesrovires (ESSES)",
   label: "San Esteve De Sesrovires (ESSES)"
  },
  {
   value: "San Feliu De Codinas (ESSFC)",
   label: "San Feliu De Codinas (ESSFC)"
  },
  {
   value: "San Feliu De Guixols (ESSFU)",
   label: "San Feliu De Guixols (ESSFU)"
  },
  {
   value: "San Fernando (ESSFO)",
   label: "San Fernando (ESSFO)"
  },
  {
   value: "San Fernando (de Henares) (ESSFH)",
   label: "San Fernando (de Henares) (ESSFH)"
  },
  {
   value: "San Hilario Sacalm (ESSXH)",
   label: "San Hilario Sacalm (ESSXH)"
  },
  {
   value: "San Juan D Moro (ESSJM)",
   label: "San Juan D Moro (ESSJM)"
  },
  {
   value: "Port Bou (ESPBO)",
   label: "Port Bou (ESPBO)"
  },
  {
   value: "Portilla (ESPLL)",
   label: "Portilla (ESPLL)"
  },
  {
   value: "Portillo De Toledo (ESPDT)",
   label: "Portillo De Toledo (ESPDT)"
  },
  {
   value: "Portugalete (ESPOR)",
   label: "Portugalete (ESPOR)"
  },
  {
   value: "Porullena (ESPOA)",
   label: "Porullena (ESPOA)"
  },
  {
   value: "Potries (ESPOV)",
   label: "Potries (ESPOV)"
  },
  {
   value: "Pozoblanco (ESPZB)",
   label: "Pozoblanco (ESPZB)"
  },
  {
   value: "Pozuelo de Alarcon (ESPZA)",
   label: "Pozuelo de Alarcon (ESPZA)"
  },
  {
   value: "Prat De Llobregat (ESPDL)",
   label: "Prat De Llobregat (ESPDL)"
  },
  {
   value: "Puebla de Alfinden (ESPDA)",
   label: "Puebla de Alfinden (ESPDA)"
  },
  {
   value: "Puebla De La Calzada (ESPBC)",
   label: "Puebla De La Calzada (ESPBC)"
  },
  {
   value: "Puebla De Mula (ESPWE)",
   label: "Puebla De Mula (ESPWE)"
  },
  {
   value: "Puebla De Tornesa (ESPUD)",
   label: "Puebla De Tornesa (ESPUD)"
  },
  {
   value: "Pueblo Nuevo Del Guadian (ESPBN)",
   label: "Pueblo Nuevo Del Guadian (ESPBN)"
  },
  {
   value: "Puente Genil (ESPGN)",
   label: "Puente Genil (ESPGN)"
  },
  {
   value: "Puerto Colom (ESPCO)",
   label: "Puerto Colom (ESPCO)"
  },
  {
   value: "Puerto De Mazarron (ESPUZ)",
   label: "Puerto De Mazarron (ESPUZ)"
  },
  {
   value: "Puerto de Santa Maria (ESPSM)",
   label: "Puerto de Santa Maria (ESPSM)"
  },
  {
   value: "Puerto Real (ESPUS)",
   label: "Puerto Real (ESPUS)"
  },
  {
   value: "Puertollano (ESPUO)",
   label: "Puertollano (ESPUO)"
  },
  {
   value: "Puigcerda (ESPUI)",
   label: "Puigcerda (ESPUI)"
  },
  {
   value: "Pulianas (ESPUL)",
   label: "Pulianas (ESPUL)"
  },
  {
   value: "Puzol (ESPZU)",
   label: "Puzol (ESPZU)"
  },
  {
   value: "Quart De Poblet (ESQUR)",
   label: "Quart De Poblet (ESQUR)"
  },
  {
   value: "Quintana De La Serena (ESQDS)",
   label: "Quintana De La Serena (ESQDS)"
  },
  {
   value: "Quintanar De La Orden (ESQTN)",
   label: "Quintanar De La Orden (ESQTN)"
  },
  {
   value: "Quintanar Del Rey (ESQDR)",
   label: "Quintanar Del Rey (ESQDR)"
  },
  {
   value: "Rafal (ESRFL)",
   label: "Rafal (ESRFL)"
  },
  {
   value: "Ragol (ESRGU)",
   label: "Ragol (ESRGU)"
  },
  {
   value: "Ramoneda (ESRMN)",
   label: "Ramoneda (ESRMN)"
  },
  {
   value: "Redovan (ESREF)",
   label: "Redovan (ESREF)"
  },
  {
   value: "Reinosa (ESRNS)",
   label: "Reinosa (ESRNS)"
  },
  {
   value: "Requena (ESRQA)",
   label: "Requena (ESRQA)"
  },
  {
   value: "Requijada (ESRQD)",
   label: "Requijada (ESRQD)"
  },
  {
   value: "Reus (ESRUS)",
   label: "Reus (ESRUS)"
  },
  {
   value: "Ribadeo (ESRIB)",
   label: "Ribadeo (ESRIB)"
  },
  {
   value: "Ribadesella (ESRBS)",
   label: "Ribadesella (ESRBS)"
  },
  {
   value: "Ribarroja (ESRAO)",
   label: "Ribarroja (ESRAO)"
  },
  {
   value: "Palamos (ESPAL)",
   label: "Palamos (ESPAL)"
  },
  {
   value: "Palau De Angleso- (ESPLU)",
   label: "Palau De Angleso- (ESPLU)"
  },
  {
   value: "Palau De Plegamans (ESPGQ)",
   label: "Palau De Plegamans (ESPGQ)"
  },
  {
   value: "Palencia (ESPAC)",
   label: "Palencia (ESPAC)"
  },
  {
   value: "Palleja (ESPLZ)",
   label: "Palleja (ESPLZ)"
  },
  {
   value: "Palma Del Condado (ESPDQ)",
   label: "Palma Del Condado (ESPDQ)"
  },
  {
   value: "Palma Del Rio (ESPFO)",
   label: "Palma Del Rio (ESPFO)"
  },
  {
   value: "Palma Mallorca (ESPMI)",
   label: "Palma Mallorca (ESPMI)"
  },
  {
   value: "Palmones Los Barr- (ESPBS)",
   label: "Palmones Los Barr- (ESPBS)"
  },
  {
   value: "Palomares Del Rio (ESPFS)",
   label: "Palomares Del Rio (ESPFS)"
  },
  {
   value: "Palos De La Frontera (ESPFT)",
   label: "Palos De La Frontera (ESPFT)"
  },
  {
   value: "Pamplona (ESPNA)",
   label: "Pamplona (ESPNA)"
  },
  {
   value: "Paracuellos (ESPUW)",
   label: "Paracuellos (ESPUW)"
  },
  {
   value: "Paradas (ESPDU)",
   label: "Paradas (ESPDU)"
  },
  {
   value: "Parets Del Valles (ESPDV)",
   label: "Parets Del Valles (ESPDV)"
  },
  {
   value: "Parla (ESPRL)",
   label: "Parla (ESPRL)"
  },
  {
   value: "Pasajes (ESPAS)",
   label: "Pasajes (ESPAS)"
  },
  {
   value: "\"Pasito Blanco (ESPBB)",
   label: "\"Pasito Blanco (ESPBB)"
  },
  {
   value: "Paterna (ESPXA)",
   label: "Paterna (ESPXA)"
  },
  {
   value: "Patino (ESPAI)",
   label: "Patino (ESPAI)"
  },
  {
   value: "Pedraneras (ESPDZ)",
   label: "Pedraneras (ESPDZ)"
  },
  {
   value: "Pedrera (ESPEF)",
   label: "Pedrera (ESPEF)"
  },
  {
   value: "Pego (ESPGJ)",
   label: "Pego (ESPGJ)"
  },
  {
   value: "Peligros (ESPGZ)",
   label: "Peligros (ESPGZ)"
  },
  {
   value: "Penarrolla (ESPNR)",
   label: "Penarrolla (ESPNR)"
  },
  {
   value: "Pesquera (ESPSQ)",
   label: "Pesquera (ESPSQ)"
  },
  {
   value: "Petrel (ESPXR)",
   label: "Petrel (ESPXR)"
  },
  {
   value: "Picana (ESPQI)",
   label: "Picana (ESPQI)"
  },
  {
   value: "Picasent (ESPQZ)",
   label: "Picasent (ESPQZ)"
  },
  {
   value: "Pilas (ESPIQ)",
   label: "Pilas (ESPIQ)"
  },
  {
   value: "Pinoso (ESPIA)",
   label: "Pinoso (ESPIA)"
  },
  {
   value: "Pinto (ESPJO)",
   label: "Pinto (ESPJO)"
  },
  {
   value: "Plasencia (ESPSC)",
   label: "Plasencia (ESPSC)"
  },
  {
   value: "Playa Blanca (ESQLY)",
   label: "Playa Blanca (ESQLY)"
  },
  {
   value: "Ponferrada (ESPON)",
   label: "Ponferrada (ESPON)"
  },
  {
   value: "Pontejos (ESPTS)",
   label: "Pontejos (ESPTS)"
  },
  {
   value: "Pontevedra (ESPEV)",
   label: "Pontevedra (ESPEV)"
  },
  {
   value: "Porcuna (ESPRC)",
   label: "Porcuna (ESPRC)"
  },
  {
   value: "Porrino (ESPRR)",
   label: "Porrino (ESPRR)"
  },
  {
   value: "Mota Del Cuervo (ESMDC)",
   label: "Mota Del Cuervo (ESMDC)"
  },
  {
   value: "Motril (ESMOT)",
   label: "Motril (ESMOT)"
  },
  {
   value: "Muelva (ESMJU)",
   label: "Muelva (ESMJU)"
  },
  {
   value: "Mula (ESMUL)",
   label: "Mula (ESMUL)"
  },
  {
   value: "Muro De Alcoy (ESMDY)",
   label: "Muro De Alcoy (ESMDY)"
  },
  {
   value: "Muros (ESMRS)",
   label: "Muros (ESMRS)"
  },
  {
   value: "Musel (ESMUS)",
   label: "Musel (ESMUS)"
  },
  {
   value: "Museros (ESMUO)",
   label: "Museros (ESMUO)"
  },
  {
   value: "Navalmoral De La Mata (ESNFO)",
   label: "Navalmoral De La Mata (ESNFO)"
  },
  {
   value: "Navarra (ESNVV)",
   label: "Navarra (ESNVV)"
  },
  {
   value: "Navarres (ESNVR)",
   label: "Navarres (ESNVR)"
  },
  {
   value: "Navia (ESNAV)",
   label: "Navia (ESNAV)"
  },
  {
   value: "Nerja (ESNJA)",
   label: "Nerja (ESNJA)"
  },
  {
   value: "Noain (ESNIN)",
   label: "Noain (ESNIN)"
  },
  {
   value: "Nonduermas (ESNON)",
   label: "Nonduermas (ESNON)"
  },
  {
   value: "Novelda (ESNVA)",
   label: "Novelda (ESNVA)"
  },
  {
   value: "Nules (ESNUL)",
   label: "Nules (ESNUL)"
  },
  {
   value: "Olesa De Montserrat (ESOLX)",
   label: "Olesa De Montserrat (ESOLX)"
  },
  {
   value: "Oliva (ESOLV)",
   label: "Oliva (ESOLV)"
  },
  {
   value: "Oliva De La Frontera (ESOVF)",
   label: "Oliva De La Frontera (ESOVF)"
  },
  {
   value: "Olivares (ESOVS)",
   label: "Olivares (ESOVS)"
  },
  {
   value: "Olivenza (ESOVZ)",
   label: "Olivenza (ESOVZ)"
  },
  {
   value: "Olla Del Campo (ESOLC)",
   label: "Olla Del Campo (ESOLC)"
  },
  {
   value: "Olleria (ESOLR)",
   label: "Olleria (ESOLR)"
  },
  {
   value: "Olot (ESOOE)",
   label: "Olot (ESOOE)"
  },
  {
   value: "Onda (ESONA)",
   label: "Onda (ESONA)"
  },
  {
   value: "Ondarroa (ESOND)",
   label: "Ondarroa (ESOND)"
  },
  {
   value: "Onil (ESONL)",
   label: "Onil (ESONL)"
  },
  {
   value: "Onteniente (ESONT)",
   label: "Onteniente (ESONT)"
  },
  {
   value: "Ordenes (ESOEJ)",
   label: "Ordenes (ESOEJ)"
  },
  {
   value: "Orena (ESOAZ)",
   label: "Orena (ESOAZ)"
  },
  {
   value: "Orense (ESORE)",
   label: "Orense (ESORE)"
  },
  {
   value: "Orihuela (ESOHL)",
   label: "Orihuela (ESOHL)"
  },
  {
   value: "Ormaiztegui (ESORM)",
   label: "Ormaiztegui (ESORM)"
  },
  {
   value: "Ororbia (ESORO)",
   label: "Ororbia (ESORO)"
  },
  {
   value: "Osuna (ESOSU)",
   label: "Osuna (ESOSU)"
  },
  {
   value: "Otura (ESOTU)",
   label: "Otura (ESOTU)"
  },
  {
   value: "Oviedo (ESOVO)",
   label: "Oviedo (ESOVO)"
  },
  {
   value: "Pacs Del Penedes (ESPPQ)",
   label: "Pacs Del Penedes (ESPPQ)"
  },
  {
   value: "Paiporta (ESPXP)",
   label: "Paiporta (ESPXP)"
  },
  {
   value: "Palafolls (ESPZX)",
   label: "Palafolls (ESPZX)"
  },
  {
   value: "Minaya (ESMXA)",
   label: "Minaya (ESMXA)"
  },
  {
   value: "Minglanilla (ESMIN)",
   label: "Minglanilla (ESMIN)"
  },
  {
   value: "Miranda De Ebro (ESMIX)",
   label: "Miranda De Ebro (ESMIX)"
  },
  {
   value: "Mislata (ESMIS)",
   label: "Mislata (ESMIS)"
  },
  {
   value: "Moana (ESMOA)",
   label: "Moana (ESMOA)"
  },
  {
   value: "Mogente (ESGMN)",
   label: "Mogente (ESGMN)"
  },
  {
   value: "Moguer (ESMZG)",
   label: "Moguer (ESMZG)"
  },
  {
   value: "Molina De Segura (ESMOL)",
   label: "Molina De Segura (ESMOL)"
  },
  {
   value: "Molins (ESMLS)",
   label: "Molins (ESMLS)"
  },
  {
   value: "Molins De Rey (ESMDX)",
   label: "Molins De Rey (ESMDX)"
  },
  {
   value: "Molla Del Penedes (ESMBM)",
   label: "Molla Del Penedes (ESMBM)"
  },
  {
   value: "Mollerusa (ESMBC)",
   label: "Mollerusa (ESMBC)"
  },
  {
   value: "Mollina (ESMXJ)",
   label: "Mollina (ESMXJ)"
  },
  {
   value: "Moncada (ESMNC)",
   label: "Moncada (ESMNC)"
  },
  {
   value: "Moncofar (ESMCF)",
   label: "Moncofar (ESMCF)"
  },
  {
   value: "Monforte Del Cid (ESMFT)",
   label: "Monforte Del Cid (ESMFT)"
  },
  {
   value: "Monistrol (ESMNY)",
   label: "Monistrol (ESMNY)"
  },
  {
   value: "Monovar (ESMVA)",
   label: "Monovar (ESMVA)"
  },
  {
   value: "Montagut (ESMGT)",
   label: "Montagut (ESMGT)"
  },
  {
   value: "Montaverner (ESMTV)",
   label: "Montaverner (ESMTV)"
  },
  {
   value: "Montcada I Reixac (ESMRM)",
   label: "Montcada I Reixac (ESMRM)"
  },
  {
   value: "Monteagudo (ESMNU)",
   label: "Monteagudo (ESMNU)"
  },
  {
   value: "Montesa (ESMES)",
   label: "Montesa (ESMES)"
  },
  {
   value: "Montgat (ESMTG)",
   label: "Montgat (ESMTG)"
  },
  {
   value: "Montijo (ESMNJ)",
   label: "Montijo (ESMNJ)"
  },
  {
   value: "Montilla (ESMVT)",
   label: "Montilla (ESMVT)"
  },
  {
   value: "Montilla Del Palancar (ESMDP)",
   label: "Montilla Del Palancar (ESMDP)"
  },
  {
   value: "Montmell (ESMML)",
   label: "Montmell (ESMML)"
  },
  {
   value: "Montornes Del Valles (ESUTO)",
   label: "Montornes Del Valles (ESUTO)"
  },
  {
   value: "Montoro (ESMQP)",
   label: "Montoro (ESMQP)"
  },
  {
   value: "Monturque (ESMFQ)",
   label: "Monturque (ESMFQ)"
  },
  {
   value: "Monzon (ESMNZ)",
   label: "Monzon (ESMNZ)"
  },
  {
   value: "Mora La Nueva (ESMWU)",
   label: "Mora La Nueva (ESMWU)"
  },
  {
   value: "Moraleja (ESMRL)",
   label: "Moraleja (ESMRL)"
  },
  {
   value: "Moratalla (ESMLA)",
   label: "Moratalla (ESMLA)"
  },
  {
   value: "Moron De Almazan (ESMDA)",
   label: "Moron De Almazan (ESMDA)"
  },
  {
   value: "Moron De La Frontera (ESMZF)",
   label: "Moron De La Frontera (ESMZF)"
  },
  {
   value: "Mostoles (ESMST)",
   label: "Mostoles (ESMST)"
  },
  {
   value: "Mostoles-Madrid (ESMSM)",
   label: "Mostoles-Madrid (ESMSM)"
  },
  {
   value: "Los Palacios Y Villafranca (ESLPV)",
   label: "Los Palacios Y Villafranca (ESLPV)"
  },
  {
   value: "Lucena (ESLXU)",
   label: "Lucena (ESLXU)"
  },
  {
   value: "Lugones (ESLUG)",
   label: "Lugones (ESLUG)"
  },
  {
   value: "Macael (ESMFK)",
   label: "Macael (ESMFK)"
  },
  {
   value: "Madrid (ESMAD)",
   label: "Madrid (ESMAD)"
  },
  {
   value: "Mairena Del Alcor (ESMQR)",
   label: "Mairena Del Alcor (ESMQR)"
  },
  {
   value: "Mairena Del Aljarafe (ESMQJ)",
   label: "Mairena Del Aljarafe (ESMQJ)"
  },
  {
   value: "Malaga (ESAGP)",
   label: "Malaga (ESAGP)"
  },
  {
   value: "Malagon (ESMLG)",
   label: "Malagon (ESMLG)"
  },
  {
   value: "Malgrat (ESMAM)",
   label: "Malgrat (ESMAM)"
  },
  {
   value: "Mallorca (ESMLL)",
   label: "Mallorca (ESMLL)"
  },
  {
   value: "Malpartida Plasencia (ESMLP)",
   label: "Malpartida Plasencia (ESMLP)"
  },
  {
   value: "Malpica (ESMJP)",
   label: "Malpica (ESMJP)"
  },
  {
   value: "Mancha Real (ESMWR)",
   label: "Mancha Real (ESMWR)"
  },
  {
   value: "Manilva (ESMQF)",
   label: "Manilva (ESMQF)"
  },
  {
   value: "Manises (ESMSY)",
   label: "Manises (ESMSY)"
  },
  {
   value: "Manlleu (ESMNL)",
   label: "Manlleu (ESMNL)"
  },
  {
   value: "Manresa (ESMNR)",
   label: "Manresa (ESMNR)"
  },
  {
   value: "Manzanares (ESMZX)",
   label: "Manzanares (ESMZX)"
  },
  {
   value: "Manzanilla (ESMZJ)",
   label: "Manzanilla (ESMZJ)"
  },
  {
   value: "Maraleda (ESMXX)",
   label: "Maraleda (ESMXX)"
  },
  {
   value: "Maraleja (ESMXH)",
   label: "Maraleja (ESMXH)"
  },
  {
   value: "Marbella (ESMQE)",
   label: "Marbella (ESMQE)"
  },
  {
   value: "Marchena (ESMQC)",
   label: "Marchena (ESMQC)"
  },
  {
   value: "\"Marin (ESMPG)",
   label: "\"Marin (ESMPG)"
  },
  {
   value: "Markina (ESMRK)",
   label: "Markina (ESMRK)"
  },
  {
   value: "Martorell (ESMTS)",
   label: "Martorell (ESMTS)"
  },
  {
   value: "Martos (ESMFS)",
   label: "Martos (ESMFS)"
  },
  {
   value: "Masies De Voltrega (ESMDB)",
   label: "Masies De Voltrega (ESMDB)"
  },
  {
   value: "Massalfassar (ESMSS)",
   label: "Massalfassar (ESMSS)"
  },
  {
   value: "Massanet De La Selva (ESMYC)",
   label: "Massanet De La Selva (ESMYC)"
  },
  {
   value: "Mataro (ESMTO)",
   label: "Mataro (ESMTO)"
  },
  {
   value: "Mazarron (ESMZO)",
   label: "Mazarron (ESMZO)"
  },
  {
   value: "Medina del Campo (ESMLC)",
   label: "Medina del Campo (ESMLC)"
  },
  {
   value: "Mejorada (ESMEJ)",
   label: "Mejorada (ESMEJ)"
  },
  {
   value: "Melilla (ESMLN)",
   label: "Melilla (ESMLN)"
  },
  {
   value: "Menjibar (ESMFH)",
   label: "Menjibar (ESMFH)"
  },
  {
   value: "Menorca (ESMAH)",
   label: "Menorca (ESMAH)"
  },
  {
   value: "Mequinenza (ESMQN)",
   label: "Mequinenza (ESMQN)"
  },
  {
   value: "Miajadas (ESMJJ)",
   label: "Miajadas (ESMJJ)"
  },
  {
   value: "La Tallada (ESLTA)",
   label: "La Tallada (ESLTA)"
  },
  {
   value: "La Tejita (ESTJI)",
   label: "La Tejita (ESTJI)"
  },
  {
   value: "La Vall d'Uxo (ESVAD)",
   label: "La Vall d'Uxo (ESVAD)"
  },
  {
   value: "La Zaida (ESLZJ)",
   label: "La Zaida (ESLZJ)"
  },
  {
   value: "Labastida (ESLDA)",
   label: "Labastida (ESLDA)"
  },
  {
   value: "Lanjaron (ESLJR)",
   label: "Lanjaron (ESLJR)"
  },
  {
   value: "Larrondo (ESLAR)",
   label: "Larrondo (ESLAR)"
  },
  {
   value: "Las Arenas (ESLRS)",
   label: "Las Arenas (ESLRS)"
  },
  {
   value: "Las Cabezas (ESLQB)",
   label: "Las Cabezas (ESLQB)"
  },
  {
   value: "Las Lomas (ESLLM)",
   label: "Las Lomas (ESLLM)"
  },
  {
   value: "Las Palmas (ESLPA)",
   label: "Las Palmas (ESLPA)"
  },
  {
   value: "Las Pedroneras (ESLPD)",
   label: "Las Pedroneras (ESLPD)"
  },
  {
   value: "Las Rozas (ESLSR)",
   label: "Las Rozas (ESLSR)"
  },
  {
   value: "Las Torres De Cotillas (ESLTD)",
   label: "Las Torres De Cotillas (ESLTD)"
  },
  {
   value: "Lasarte (ESLAS)",
   label: "Lasarte (ESLAS)"
  },
  {
   value: "Lavern (ESLAV)",
   label: "Lavern (ESLAV)"
  },
  {
   value: "Lebrija (ESLEJ)",
   label: "Lebrija (ESLEJ)"
  },
  {
   value: "Legaspia (ESLGS)",
   label: "Legaspia (ESLGS)"
  },
  {
   value: "Lekeitio (ESLEK)",
   label: "Lekeitio (ESLEK)"
  },
  {
   value: "Leon (ESLEN)",
   label: "Leon (ESLEN)"
  },
  {
   value: "Lepe (ESLEP)",
   label: "Lepe (ESLEP)"
  },
  {
   value: "Lerida (ESLJD)",
   label: "Lerida (ESLJD)"
  },
  {
   value: "Les Franquesese (ESLSF)",
   label: "Les Franquesese (ESLSF)"
  },
  {
   value: "Les Presses (ESLJQ)",
   label: "Les Presses (ESLJQ)"
  },
  {
   value: "Librilla (ESLIJ)",
   label: "Librilla (ESLIJ)"
  },
  {
   value: "Linares (ESLIZ)",
   label: "Linares (ESLIZ)"
  },
  {
   value: "Liria (ESLYJ)",
   label: "Liria (ESLYJ)"
  },
  {
   value: "Lleida (ESLLE)",
   label: "Lleida (ESLLE)"
  },
  {
   value: "Llica de Vall (ESLLV)",
   label: "Llica de Vall (ESLLV)"
  },
  {
   value: "Llinars del Valles (ESLDV)",
   label: "Llinars del Valles (ESLDV)"
  },
  {
   value: "Llodio (ESIOO)",
   label: "Llodio (ESIOO)"
  },
  {
   value: "Llombay (ESLHP)",
   label: "Llombay (ESLHP)"
  },
  {
   value: "Logrono (ESLGR)",
   label: "Logrono (ESLGR)"
  },
  {
   value: "Lora De Estepa (ESLXE)",
   label: "Lora De Estepa (ESLXE)"
  },
  {
   value: "Lora Del Rio (ESLYR)",
   label: "Lora Del Rio (ESLYR)"
  },
  {
   value: "Lorca (ESLQA)",
   label: "Lorca (ESLQA)"
  },
  {
   value: "Lorqui (ESLRQ)",
   label: "Lorqui (ESLRQ)"
  },
  {
   value: "Los Alcazares (ESLQZ)",
   label: "Los Alcazares (ESLQZ)"
  },
  {
   value: "Los Barrios (ESLOB)",
   label: "Los Barrios (ESLOB)"
  },
  {
   value: "Los Cristianos (ESLCR)",
   label: "Los Cristianos (ESLCR)"
  },
  {
   value: "Jerez De Los Caballeros (ESJDC)",
   label: "Jerez De Los Caballeros (ESJDC)"
  },
  {
   value: "Jijona (ESJJO)",
   label: "Jijona (ESJJO)"
  },
  {
   value: "Jimena De La Frontera (ESJLF)",
   label: "Jimena De La Frontera (ESJLF)"
  },
  {
   value: "Jodar (ESJDR)",
   label: "Jodar (ESJDR)"
  },
  {
   value: "Jumilla (ESJUM)",
   label: "Jumilla (ESJUM)"
  },
  {
   value: "Juraiz De La Vera (ESJZD)",
   label: "Juraiz De La Vera (ESJZD)"
  },
  {
   value: "Juzbado (ESJZB)",
   label: "Juzbado (ESJZB)"
  },
  {
   value: "L'Olleria (ESLOR)",
   label: "L'Olleria (ESLOR)"
  },
  {
   value: "La Albatalia (ESLBT)",
   label: "La Albatalia (ESLBT)"
  },
  {
   value: "La Alberca De Zancara (ESLXZ)",
   label: "La Alberca De Zancara (ESLXZ)"
  },
  {
   value: "La Ametlla Del Vall (ESLJM)",
   label: "La Ametlla Del Vall (ESLJM)"
  },
  {
   value: "La Arboleja (ESLRJ)",
   label: "La Arboleja (ESLRJ)"
  },
  {
   value: "La Bisbal (ESLAQ)",
   label: "La Bisbal (ESLAQ)"
  },
  {
   value: "La Calera (ESCER)",
   label: "La Calera (ESCER)"
  },
  {
   value: "La Canya (ESLJC)",
   label: "La Canya (ESLJC)"
  },
  {
   value: "La Carlota (ESLQL)",
   label: "La Carlota (ESLQL)"
  },
  {
   value: "La Carolina (ESLQR)",
   label: "La Carolina (ESLQR)"
  },
  {
   value: "La Copa De Bullas (ESLCD)",
   label: "La Copa De Bullas (ESLCD)"
  },
  {
   value: "La Coruna (ESLCG)",
   label: "La Coruna (ESLCG)"
  },
  {
   value: "La Eliana (ESLJN)",
   label: "La Eliana (ESLJN)"
  },
  {
   value: "La Estaca (ESLES)",
   label: "La Estaca (ESLES)"
  },
  {
   value: "La Foya (ESLXF)",
   label: "La Foya (ESLXF)"
  },
  {
   value: "La Garriga (ESLJJ)",
   label: "La Garriga (ESLJJ)"
  },
  {
   value: "La Herradura (ESHDU)",
   label: "La Herradura (ESHDU)"
  },
  {
   value: "La Linea De La Concepcion (ESLLI)",
   label: "La Linea De La Concepcion (ESLLI)"
  },
  {
   value: "La Llagosta (ESLJO)",
   label: "La Llagosta (ESLJO)"
  },
  {
   value: "La Llosa (ESLXO)",
   label: "La Llosa (ESLXO)"
  },
  {
   value: "La Luisiana (ESLLU)",
   label: "La Luisiana (ESLLU)"
  },
  {
   value: "La Maruca (ESLMC)",
   label: "La Maruca (ESLMC)"
  },
  {
   value: "La Nora (ESLOJ)",
   label: "La Nora (ESLOJ)"
  },
  {
   value: "La Palma (ESLPL)",
   label: "La Palma (ESLPL)"
  },
  {
   value: "La Palma Del Condado (ESLXC)",
   label: "La Palma Del Condado (ESLXC)"
  },
  {
   value: "La Puebla Del Caraminal (ESLPC)",
   label: "La Puebla Del Caraminal (ESLPC)"
  },
  {
   value: "La Rinconada (ESLXR)",
   label: "La Rinconada (ESLXR)"
  },
  {
   value: "La Roda D Andalucia (ESLSH)",
   label: "La Roda D Andalucia (ESLSH)"
  },
  {
   value: "La Roda De Albacete (ESLRZ)",
   label: "La Roda De Albacete (ESLRZ)"
  },
  {
   value: "La Romana (ESLRM)",
   label: "La Romana (ESLRM)"
  },
  {
   value: "La Salineta (ESSNA)",
   label: "La Salineta (ESSNA)"
  },
  {
   value: "Girona (ESGJN)",
   label: "Girona (ESGJN)"
  },
  {
   value: "Godelleta (ESGDU)",
   label: "Godelleta (ESGDU)"
  },
  {
   value: "Granada (ESGRX)",
   label: "Granada (ESGRX)"
  },
  {
   value: "Granja De San Idelfonso (ESGJI)",
   label: "Granja De San Idelfonso (ESGJI)"
  },
  {
   value: "Granollers (ESGEZ)",
   label: "Granollers (ESGEZ)"
  },
  {
   value: "Grao (ESGRY)",
   label: "Grao (ESGRY)"
  },
  {
   value: "Guadalajara (ESGUA)",
   label: "Guadalajara (ESGUA)"
  },
  {
   value: "Guadalcanal (ESGCL)",
   label: "Guadalcanal (ESGCL)"
  },
  {
   value: "Guadasuar (ESGDX)",
   label: "Guadasuar (ESGDX)"
  },
  {
   value: "Guadiana Del Caudillo (ESGCJ)",
   label: "Guadiana Del Caudillo (ESGCJ)"
  },
  {
   value: "Guantarajal (ESGTA)",
   label: "Guantarajal (ESGTA)"
  },
  {
   value: "Guillena (ESGUZ)",
   label: "Guillena (ESGUZ)"
  },
  {
   value: "Hernani (ESHKX)",
   label: "Hernani (ESHKX)"
  },
  {
   value: "Herrera (ESHHR)",
   label: "Herrera (ESHHR)"
  },
  {
   value: "Herrera De Alcantara (ESHQT)",
   label: "Herrera De Alcantara (ESHQT)"
  },
  {
   value: "Hierro (ESHIE)",
   label: "Hierro (ESHIE)"
  },
  {
   value: "Hinojos (ESHJO)",
   label: "Hinojos (ESHJO)"
  },
  {
   value: "Hocajo De Santiago (ESHJS)",
   label: "Hocajo De Santiago (ESHJS)"
  },
  {
   value: "Hospitalet De Llobregat (ESHCU)",
   label: "Hospitalet De Llobregat (ESHCU)"
  },
  {
   value: "Hoyos (ESHZS)",
   label: "Hoyos (ESHZS)"
  },
  {
   value: "Huecija (ESHWC)",
   label: "Huecija (ESHWC)"
  },
  {
   value: "Huelva (ESHUV)",
   label: "Huelva (ESHUV)"
  },
  {
   value: "Huerto (ESHWG)",
   label: "Huerto (ESHWG)"
  },
  {
   value: "Huerto-Vega (ESHWV)",
   label: "Huerto-Vega (ESHWV)"
  },
  {
   value: "Huesca (ESHUC)",
   label: "Huesca (ESHUC)"
  },
  {
   value: "Huetor Tajar (ESHTT)",
   label: "Huetor Tajar (ESHTT)"
  },
  {
   value: "Huevar (ESHVR)",
   label: "Huevar (ESHVR)"
  },
  {
   value: "Ibiza (ESIBZ)",
   label: "Ibiza (ESIBZ)"
  },
  {
   value: "Igollo De Carmago (ESIOA)",
   label: "Igollo De Carmago (ESIOA)"
  },
  {
   value: "Irun (ESIRU)",
   label: "Irun (ESIRU)"
  },
  {
   value: "Ivars D'urgelt (ESIVU)",
   label: "Ivars D'urgelt (ESIVU)"
  },
  {
   value: "Jabali Nuevo (ESJNV)",
   label: "Jabali Nuevo (ESJNV)"
  },
  {
   value: "Jaen (ESJAE)",
   label: "Jaen (ESJAE)"
  },
  {
   value: "Jaraco (ESJCO)",
   label: "Jaraco (ESJCO)"
  },
  {
   value: "Jativa (ESJTV)",
   label: "Jativa (ESJTV)"
  },
  {
   value: "Javea (ESJAV)",
   label: "Javea (ESJAV)"
  },
  {
   value: "Jedula (ESJUA)",
   label: "Jedula (ESJUA)"
  },
  {
   value: "Jeresa (ESJRE)",
   label: "Jeresa (ESJRE)"
  },
  {
   value: "Jerez De La Frontera (ESJRZ)",
   label: "Jerez De La Frontera (ESJRZ)"
  },
  {
   value: "Elgoibar (ESEOI)",
   label: "Elgoibar (ESEOI)"
  },
  {
   value: "Elizondo (ESELI)",
   label: "Elizondo (ESELI)"
  },
  {
   value: "Era Alta (ESERT)",
   label: "Era Alta (ESERT)"
  },
  {
   value: "Ermua (ESERS)",
   label: "Ermua (ESERS)"
  },
  {
   value: "Escombreras (ESESC)",
   label: "Escombreras (ESESC)"
  },
  {
   value: "Esparraguera (ESEUX)",
   label: "Esparraguera (ESEUX)"
  },
  {
   value: "Espartinas (ESESI)",
   label: "Espartinas (ESESI)"
  },
  {
   value: "Espeluy (ESESU)",
   label: "Espeluy (ESESU)"
  },
  {
   value: "Espinardo (ESESP)",
   label: "Espinardo (ESESP)"
  },
  {
   value: "Espluga De Llobregat (ESESZ)",
   label: "Espluga De Llobregat (ESESZ)"
  },
  {
   value: "Estepa (ESEPA)",
   label: "Estepa (ESEPA)"
  },
  {
   value: "Estepona (ESEPN)",
   label: "Estepona (ESEPN)"
  },
  {
   value: "Faura (ESFUA)",
   label: "Faura (ESFUA)"
  },
  {
   value: "Ferrol (ESFRO)",
   label: "Ferrol (ESFRO)"
  },
  {
   value: "Figueras (ESFGU)",
   label: "Figueras (ESFGU)"
  },
  {
   value: "Flassa (ESFAA)",
   label: "Flassa (ESFAA)"
  },
  {
   value: "Foyos (ESFYO)",
   label: "Foyos (ESFYO)"
  },
  {
   value: "Fraga (ESFAP)",
   label: "Fraga (ESFAP)"
  },
  {
   value: "Fregenal De La Sierra (ESFGN)",
   label: "Fregenal De La Sierra (ESFGN)"
  },
  {
   value: "Fuengirola (ESFGL)",
   label: "Fuengirola (ESFGL)"
  },
  {
   value: "Fuenlabrada (ESFBD)",
   label: "Fuenlabrada (ESFBD)"
  },
  {
   value: "Fuenmayor (ESFUM)",
   label: "Fuenmayor (ESFUM)"
  },
  {
   value: "Fuente De Piedra (ESFDR)",
   label: "Fuente De Piedra (ESFDR)"
  },
  {
   value: "Fuente La Higuera (ESFLH)",
   label: "Fuente La Higuera (ESFLH)"
  },
  {
   value: "Fuentes de Onoro (ESFON)",
   label: "Fuentes de Onoro (ESFON)"
  },
  {
   value: "Fuentiduena De Tajo (ESFUJ)",
   label: "Fuentiduena De Tajo (ESFUJ)"
  },
  {
   value: "Fuerteventura-Puerto del Rosario (ESFUE)",
   label: "Fuerteventura-Puerto del Rosario (ESFUE)"
  },
  {
   value: "Funes (ESFJU)",
   label: "Funes (ESFJU)"
  },
  {
   value: "Gador (ESGAO)",
   label: "Gador (ESGAO)"
  },
  {
   value: "Gandia (ESGAN)",
   label: "Gandia (ESGAN)"
  },
  {
   value: "Garrucha (ESGAR)",
   label: "Garrucha (ESGAR)"
  },
  {
   value: "Gata De Gorgos (ESGGG)",
   label: "Gata De Gorgos (ESGGG)"
  },
  {
   value: "Gava (ESGJV)",
   label: "Gava (ESGJV)"
  },
  {
   value: "Gelida (ESGDA)",
   label: "Gelida (ESGDA)"
  },
  {
   value: "Gerona (ESGRO)",
   label: "Gerona (ESGRO)"
  },
  {
   value: "Getafe (ESGTF)",
   label: "Getafe (ESGTF)"
  },
  {
   value: "Getares (ESGTS)",
   label: "Getares (ESGTS)"
  },
  {
   value: "Gijon (ESGIJ)",
   label: "Gijon (ESGIJ)"
  },
  {
   value: "Gilena (ESGIA)",
   label: "Gilena (ESGIA)"
  },
  {
   value: "Gines (ESGIN)",
   label: "Gines (ESGIN)"
  },
  {
   value: "Cordoba (ESODB)",
   label: "Cordoba (ESODB)"
  },
  {
   value: "Corella (ESCOR)",
   label: "Corella (ESCOR)"
  },
  {
   value: "Coria (ESCZQ)",
   label: "Coria (ESCZQ)"
  },
  {
   value: "Coria Del Rio (ESCZR)",
   label: "Coria Del Rio (ESCZR)"
  },
  {
   value: "Cornella (ESCLZ)",
   label: "Cornella (ESCLZ)"
  },
  {
   value: "Corralejo (ESQFU)",
   label: "Corralejo (ESQFU)"
  },
  {
   value: "Cortes (ESCOZ)",
   label: "Cortes (ESCOZ)"
  },
  {
   value: "Coslada (ESCXQ)",
   label: "Coslada (ESCXQ)"
  },
  {
   value: "Crevillente (ESCJS)",
   label: "Crevillente (ESCJS)"
  },
  {
   value: "Cuenca (ESCUE)",
   label: "Cuenca (ESCUE)"
  },
  {
   value: "Daimiel (ESDMA)",
   label: "Daimiel (ESDMA)"
  },
  {
   value: "Dalias (ESDIS)",
   label: "Dalias (ESDIS)"
  },
  {
   value: "Denia (ESDNA)",
   label: "Denia (ESDNA)"
  },
  {
   value: "Derio (ESDRI)",
   label: "Derio (ESDRI)"
  },
  {
   value: "Dolores (ESDDP)",
   label: "Dolores (ESDDP)"
  },
  {
   value: "Don Benito (ESDNB)",
   label: "Don Benito (ESDNB)"
  },
  {
   value: "Dona Mencia (ESDMC)",
   label: "Dona Mencia (ESDMC)"
  },
  {
   value: "Dos Hermanas (ESDHM)",
   label: "Dos Hermanas (ESDHM)"
  },
  {
   value: "Durcal (ESDUC)",
   label: "Durcal (ESDUC)"
  },
  {
   value: "Echevarria (ESEEV)",
   label: "Echevarria (ESEEV)"
  },
  {
   value: "Ecija (ESECJ)",
   label: "Ecija (ESECJ)"
  },
  {
   value: "El Masnou (ESMSN)",
   label: "El Masnou (ESMSN)"
  },
  {
   value: "El Arahal (ESEAH)",
   label: "El Arahal (ESEAH)"
  },
  {
   value: "El Bonillo (ESEAO)",
   label: "El Bonillo (ESEAO)"
  },
  {
   value: "El Carpio (ESECA)",
   label: "El Carpio (ESECA)"
  },
  {
   value: "El Cuervo (ESECV)",
   label: "El Cuervo (ESECV)"
  },
  {
   value: "El Ejido (ESEEJ)",
   label: "El Ejido (ESEEJ)"
  },
  {
   value: "El Farque (ESEFQ)",
   label: "El Farque (ESEFQ)"
  },
  {
   value: "El Ferrol (ESFER)",
   label: "El Ferrol (ESFER)"
  },
  {
   value: "El Gador (ESEGD)",
   label: "El Gador (ESEGD)"
  },
  {
   value: "El Gordo (ESEGI)",
   label: "El Gordo (ESEGI)"
  },
  {
   value: "El Mojon (ESEMJ)",
   label: "El Mojon (ESEMJ)"
  },
  {
   value: "El Palmar (ESEPM)",
   label: "El Palmar (ESEPM)"
  },
  {
   value: "El Palo (ESEPL)",
   label: "El Palo (ESEPL)"
  },
  {
   value: "El Perello (ESEPC)",
   label: "El Perello (ESEPC)"
  },
  {
   value: "El Prat (ESEPB)",
   label: "El Prat (ESEPB)"
  },
  {
   value: "El Provencio (ESEPV)",
   label: "El Provencio (ESEPV)"
  },
  {
   value: "El Viso Del Alcor (ESEVI)",
   label: "El Viso Del Alcor (ESEVI)"
  },
  {
   value: "Elavega (ESEAF)",
   label: "Elavega (ESEAF)"
  },
  {
   value: "Elche (ESECE)",
   label: "Elche (ESECE)"
  },
  {
   value: "Elda (ESELD)",
   label: "Elda (ESELD)"
  },
  {
   value: "Castellon De Rugat (ESCDR)",
   label: "Castellon De Rugat (ESCDR)"
  },
  {
   value: "Castellv De La Marca (Dupl.) (ESCMA)",
   label: "Castellv De La Marca (Dupl.) (ESCMA)"
  },
  {
   value: "Castilbisbal (ESCBB)",
   label: "Castilbisbal (ESCBB)"
  },
  {
   value: "Castilleja De La Cuesta (Dupl.) (ESCCu)",
   label: "Castilleja De La Cuesta (Dupl.) (ESCCu)"
  },
  {
   value: "Catadau (ESCAT)",
   label: "Catadau (ESCAT)"
  },
  {
   value: "Catarroja (ESCTJ)",
   label: "Catarroja (ESCTJ)"
  },
  {
   value: "Caudete (ESCAU)",
   label: "Caudete (ESCAU)"
  },
  {
   value: "Caudete De Las Fuentes (ESCLF)",
   label: "Caudete De Las Fuentes (ESCLF)"
  },
  {
   value: "Caudiel (ESCDL)",
   label: "Caudiel (ESCDL)"
  },
  {
   value: "Cazorla (ESCZL)",
   label: "Cazorla (ESCZL)"
  },
  {
   value: "Cehegin (ESCEH)",
   label: "Cehegin (ESCEH)"
  },
  {
   value: "Celeiro (ESCEL)",
   label: "Celeiro (ESCEL)"
  },
  {
   value: "Cerdanyola Del Vall (ESCRD)",
   label: "Cerdanyola Del Vall (ESCRD)"
  },
  {
   value: "Ceuta (ESCEU)",
   label: "Ceuta (ESCEU)"
  },
  {
   value: "Ceuti (ESCET)",
   label: "Ceuti (ESCET)"
  },
  {
   value: "Chauchina (ESCHU)",
   label: "Chauchina (ESCHU)"
  },
  {
   value: "Chiclana De La Fronterra (ESCHF)",
   label: "Chiclana De La Fronterra (ESCHF)"
  },
  {
   value: "Chilches (ESCHI)",
   label: "Chilches (ESCHI)"
  },
  {
   value: "Chinchon (ESCHN)",
   label: "Chinchon (ESCHN)"
  },
  {
   value: "Chipiona (ESCHP)",
   label: "Chipiona (ESCHP)"
  },
  {
   value: "Chiprana De Caspe (ESCHC)",
   label: "Chiprana De Caspe (ESCHC)"
  },
  {
   value: "Chirivel (ESCHV)",
   label: "Chirivel (ESCHV)"
  },
  {
   value: "Chirriana De La Vega (ESCLV)",
   label: "Chirriana De La Vega (ESCLV)"
  },
  {
   value: "Chiva (ESCVA)",
   label: "Chiva (ESCVA)"
  },
  {
   value: "Chulilla (ESCHL)",
   label: "Chulilla (ESCHL)"
  },
  {
   value: "Churra (ESCUA)",
   label: "Churra (ESCUA)"
  },
  {
   value: "Cieza (ESCZA)",
   label: "Cieza (ESCZA)"
  },
  {
   value: "Cinco Casas (ESCIC)",
   label: "Cinco Casas (ESCIC)"
  },
  {
   value: "Ciudad Real (ESCIR)",
   label: "Ciudad Real (ESCIR)"
  },
  {
   value: "Ciudadela (ESQIU)",
   label: "Ciudadela (ESQIU)"
  },
  {
   value: "Cocentaina (ESCOA)",
   label: "Cocentaina (ESCOA)"
  },
  {
   value: "Cofrentes (ESCFR)",
   label: "Cofrentes (ESCFR)"
  },
  {
   value: "Coin (ESCYQ)",
   label: "Coin (ESCYQ)"
  },
  {
   value: "Colmenar (ESCOL)",
   label: "Colmenar (ESCOL)"
  },
  {
   value: "Competa (ESCZE)",
   label: "Competa (ESCZE)"
  },
  {
   value: "Constantina (ESCZS)",
   label: "Constantina (ESCZS)"
  },
  {
   value: "Corbera (ESCRB)",
   label: "Corbera (ESCRB)"
  },
  {
   value: "Corcoya (ESCJQ)",
   label: "Corcoya (ESCJQ)"
  },
  {
   value: "Corcubion (ESCCN)",
   label: "Corcubion (ESCCN)"
  },
  {
   value: "Campillos (ESCMS)",
   label: "Campillos (ESCMS)"
  },
  {
   value: "Campos Del Rio (ESCMR)",
   label: "Campos Del Rio (ESCMR)"
  },
  {
   value: "Canada (ESCND)",
   label: "Canada (ESCND)"
  },
  {
   value: "Canals (ESCNS)",
   label: "Canals (ESCNS)"
  },
  {
   value: "Canaveral (ESCVL)",
   label: "Canaveral (ESCVL)"
  },
  {
   value: "Canete (ESCNT)",
   label: "Canete (ESCNT)"
  },
  {
   value: "Canete De Las Torres (ESCLT)",
   label: "Canete De Las Torres (ESCLT)"
  },
  {
   value: "Canfranc (ESCAN)",
   label: "Canfranc (ESCAN)"
  },
  {
   value: "Caniles (ESCNL)",
   label: "Caniles (ESCNL)"
  },
  {
   value: "Canjayar (ESCNJ)",
   label: "Canjayar (ESCNJ)"
  },
  {
   value: "Canovellas (ESCNV)",
   label: "Canovellas (ESCNV)"
  },
  {
   value: "Cantagallo (ESCGL)",
   label: "Cantagallo (ESCGL)"
  },
  {
   value: "Cantoria (ESCTA)",
   label: "Cantoria (ESCTA)"
  },
  {
   value: "Caravaca De La Cruz (ESCDC)",
   label: "Caravaca De La Cruz (ESCDC)"
  },
  {
   value: "Carboneras (ESCRS)",
   label: "Carboneras (ESCRS)"
  },
  {
   value: "Carcagente (ESCRC)",
   label: "Carcagente (ESCRC)"
  },
  {
   value: "Carcelen (ESCRL)",
   label: "Carcelen (ESCRL)"
  },
  {
   value: "Carcer (ESCRR)",
   label: "Carcer (ESCRR)"
  },
  {
   value: "Cardedeu (ESCDD)",
   label: "Cardedeu (ESCDD)"
  },
  {
   value: "Carino (ESCNO)",
   label: "Carino (ESCNO)"
  },
  {
   value: "Carlet (ESCRT)",
   label: "Carlet (ESCRT)"
  },
  {
   value: "Carrascosa Del Campo (ESCCA)",
   label: "Carrascosa Del Campo (ESCCA)"
  },
  {
   value: "Carril (ESCIL)",
   label: "Carril (ESCIL)"
  },
  {
   value: "Carrion De Los Cespede (ESCLC)",
   label: "Carrion De Los Cespede (ESCLC)"
  },
  {
   value: "Cartagena (ESCAR)",
   label: "Cartagena (ESCAR)"
  },
  {
   value: "Cartama (ESCRM)",
   label: "Cartama (ESCRM)"
  },
  {
   value: "Casares (ESCSR)",
   label: "Casares (ESCSR)"
  },
  {
   value: "Casariche (ESCCH)",
   label: "Casariche (ESCCH)"
  },
  {
   value: "Casas Del Monte (ESCLM)",
   label: "Casas Del Monte (ESCLM)"
  },
  {
   value: "Casatejada (ESCST)",
   label: "Casatejada (ESCST)"
  },
  {
   value: "Casayo De Valdeorr (ESCDV)",
   label: "Casayo De Valdeorr (ESCDV)"
  },
  {
   value: "Caseda (ESCSD)",
   label: "Caseda (ESCSD)"
  },
  {
   value: "Caspe (ESCSP)",
   label: "Caspe (ESCSP)"
  },
  {
   value: "Cassa De La Selva (ESCSV)",
   label: "Cassa De La Selva (ESCSV)"
  },
  {
   value: "Castalla (ESCAA)",
   label: "Castalla (ESCAA)"
  },
  {
   value: "Castellbisbal (ESCLL)",
   label: "Castellbisbal (ESCLL)"
  },
  {
   value: "Castelldefels (ESCDF)",
   label: "Castelldefels (ESCDF)"
  },
  {
   value: "Castellet y Gornal (ESCYG)",
   label: "Castellet y Gornal (ESCYG)"
  },
  {
   value: "Castellon de la Plana (ESCAS)",
   label: "Castellon de la Plana (ESCAS)"
  },
  {
   value: "Betera (ESBET)",
   label: "Betera (ESBET)"
  },
  {
   value: "Bigastro (ESBIG)",
   label: "Bigastro (ESBIG)"
  },
  {
   value: "Bilbao (ESBIO)",
   label: "Bilbao (ESBIO)"
  },
  {
   value: "Blanca (ESBLN)",
   label: "Blanca (ESBLN)"
  },
  {
   value: "Blanca Abaran (ESBLB)",
   label: "Blanca Abaran (ESBLB)"
  },
  {
   value: "Blanes (ESBLA)",
   label: "Blanes (ESBLA)"
  },
  {
   value: "Bocairente (ESBOI)",
   label: "Bocairente (ESBOI)"
  },
  {
   value: "Bollullos De La Mitacion (ESBDM)",
   label: "Bollullos De La Mitacion (ESBDM)"
  },
  {
   value: "Bollullos Par Del Condado (ESBDC)",
   label: "Bollullos Par Del Condado (ESBDC)"
  },
  {
   value: "Bordon (ESBOR)",
   label: "Bordon (ESBOR)"
  },
  {
   value: "Bormujos (ESBMJ)",
   label: "Bormujos (ESBMJ)"
  },
  {
   value: "Bornos (ESBRN)",
   label: "Bornos (ESBRN)"
  },
  {
   value: "Borriol (ESBOL)",
   label: "Borriol (ESBOL)"
  },
  {
   value: "Brenes (ESBRE)",
   label: "Brenes (ESBRE)"
  },
  {
   value: "Bullas (ESBUL)",
   label: "Bullas (ESBUL)"
  },
  {
   value: "Bunol (ESBUN)",
   label: "Bunol (ESBUN)"
  },
  {
   value: "Burcena (ESBUC)",
   label: "Burcena (ESBUC)"
  },
  {
   value: "Burela (ESBRL)",
   label: "Burela (ESBRL)"
  },
  {
   value: "Burgos (ESBUR)",
   label: "Burgos (ESBUR)"
  },
  {
   value: "Burjasot (ESBRJ)",
   label: "Burjasot (ESBRJ)"
  },
  {
   value: "Burriana (ESBRX)",
   label: "Burriana (ESBRX)"
  },
  {
   value: "Cabezo Cortado (ESCAC)",
   label: "Cabezo Cortado (ESCAC)"
  },
  {
   value: "Cabezo De Torres (ESCBT)",
   label: "Cabezo De Torres (ESCBT)"
  },
  {
   value: "Cabezon de la Sal (ESCEZ)",
   label: "Cabezon de la Sal (ESCEZ)"
  },
  {
   value: "Cabezuela (ESCBZ)",
   label: "Cabezuela (ESCBZ)"
  },
  {
   value: "Cabra (ESCAB)",
   label: "Cabra (ESCAB)"
  },
  {
   value: "Caceres (ESCCS)",
   label: "Caceres (ESCCS)"
  },
  {
   value: "Cadiz (ESCAD)",
   label: "Cadiz (ESCAD)"
  },
  {
   value: "Cala Sabina (ESCBS)",
   label: "Cala Sabina (ESCBS)"
  },
  {
   value: "Calahorra (ESCLH)",
   label: "Calahorra (ESCLH)"
  },
  {
   value: "Calasparra (ESCAP)",
   label: "Calasparra (ESCAP)"
  },
  {
   value: "Caldas De Malavella (ESCDM)",
   label: "Caldas De Malavella (ESCDM)"
  },
  {
   value: "Caldas De Mombuy (ESCMB)",
   label: "Caldas De Mombuy (ESCMB)"
  },
  {
   value: "Calera De Leon (ESCAL)",
   label: "Calera De Leon (ESCAL)"
  },
  {
   value: "Callosa De Ensarria (ESCDE)",
   label: "Callosa De Ensarria (ESCDE)"
  },
  {
   value: "Callosa De Segura (ESCDS)",
   label: "Callosa De Segura (ESCDS)"
  },
  {
   value: "Camas (ESCAM)",
   label: "Camas (ESCAM)"
  },
  {
   value: "Cambados (ESCBD)",
   label: "Cambados (ESCBD)"
  },
  {
   value: "Campdevanol (ESCMP)",
   label: "Campdevanol (ESCMP)"
  },
  {
   value: "Azuqueca de Henares (ESAJS)",
   label: "Azuqueca de Henares (ESAJS)"
  },
  {
   value: "Badajoz (ESBJZ)",
   label: "Badajoz (ESBJZ)"
  },
  {
   value: "Badalona (ESBAD)",
   label: "Badalona (ESBAD)"
  },
  {
   value: "Baeza (ESBZA)",
   label: "Baeza (ESBZA)"
  },
  {
   value: "Bailen (ESBAI)",
   label: "Bailen (ESBAI)"
  },
  {
   value: "Balazote (ESBLZ)",
   label: "Balazote (ESBLZ)"
  },
  {
   value: "Balmaseda (ESBLM)",
   label: "Balmaseda (ESBLM)"
  },
  {
   value: "Baneres (ESBAN)",
   label: "Baneres (ESBAN)"
  },
  {
   value: "Baonoles (ESBNL)",
   label: "Baonoles (ESBNL)"
  },
  {
   value: "Baracaldo (ESBAO)",
   label: "Baracaldo (ESBAO)"
  },
  {
   value: "Barajas (ESBJS)",
   label: "Barajas (ESBJS)"
  },
  {
   value: "Barbate de Franco (ESBDF)",
   label: "Barbate de Franco (ESBDF)"
  },
  {
   value: "Barbera del Valles (ESBDV)",
   label: "Barbera del Valles (ESBDV)"
  },
  {
   value: "Barcelona (ESBCN)",
   label: "Barcelona (ESBCN)"
  },
  {
   value: "Barco De Valdeorras (ESBAV)",
   label: "Barco De Valdeorras (ESBAV)"
  },
  {
   value: "Basauri (ESBAS)",
   label: "Basauri (ESBAS)"
  },
  {
   value: "Bazalote (ESBAZ)",
   label: "Bazalote (ESBAZ)"
  },
  {
   value: "Bechi (ESBEC)",
   label: "Bechi (ESBEC)"
  },
  {
   value: "Bellreguart (ESBLG)",
   label: "Bellreguart (ESBLG)"
  },
  {
   value: "Bellus (ESBLS)",
   label: "Bellus (ESBLS)"
  },
  {
   value: "Benacazon (ESBNC)",
   label: "Benacazon (ESBNC)"
  },
  {
   value: "Benaguacil (ESBGL)",
   label: "Benaguacil (ESBGL)"
  },
  {
   value: "Benahadux (ESBNH)",
   label: "Benahadux (ESBNH)"
  },
  {
   value: "Benalmadena (ESBMD)",
   label: "Benalmadena (ESBMD)"
  },
  {
   value: "Benalua De Guadix (ESBDG)",
   label: "Benalua De Guadix (ESBDG)"
  },
  {
   value: "Benetuser (ESBNT)",
   label: "Benetuser (ESBNT)"
  },
  {
   value: "Beniajan (ESBEJ)",
   label: "Beniajan (ESBEJ)"
  },
  {
   value: "Beniarjo (ESBNJ)",
   label: "Beniarjo (ESBNJ)"
  },
  {
   value: "Benicarlo (ESBNI)",
   label: "Benicarlo (ESBNI)"
  },
  {
   value: "Benicasim (ESBCM)",
   label: "Benicasim (ESBCM)"
  },
  {
   value: "Benidorm (ESBEM)",
   label: "Benidorm (ESBEM)"
  },
  {
   value: "Beniel (ESBEN)",
   label: "Beniel (ESBEN)"
  },
  {
   value: "Benifayo (ESBFA)",
   label: "Benifayo (ESBFA)"
  },
  {
   value: "Beniganim (ESBNG)",
   label: "Beniganim (ESBNG)"
  },
  {
   value: "Benimamet (ESBNM)",
   label: "Benimamet (ESBNM)"
  },
  {
   value: "Beniparrell (ESBNP)",
   label: "Beniparrell (ESBNP)"
  },
  {
   value: "Berja (ESBJA)",
   label: "Berja (ESBJA)"
  },
  {
   value: "Bermeo (ESBRM)",
   label: "Bermeo (ESBRM)"
  },
  {
   value: "Berrioplano (ESBRR)",
   label: "Berrioplano (ESBRR)"
  },
  {
   value: "Besalu (ESBSU)",
   label: "Besalu (ESBSU)"
  },
  {
   value: "Alsasua (ESASU)",
   label: "Alsasua (ESASU)"
  },
  {
   value: "Altea (ESAQA)",
   label: "Altea (ESAQA)"
  },
  {
   value: "Alzira (ESAZJ)",
   label: "Alzira (ESAZJ)"
  },
  {
   value: "Amposta (ESAZP)",
   label: "Amposta (ESAZP)"
  },
  {
   value: "Amurrio (ESAMU)",
   label: "Amurrio (ESAMU)"
  },
  {
   value: "Andoain (ESAOI)",
   label: "Andoain (ESAOI)"
  },
  {
   value: "Andujar (ESAJR)",
   label: "Andujar (ESAJR)"
  },
  {
   value: "Antequera (ESAQR)",
   label: "Antequera (ESAQR)"
  },
  {
   value: "Aranda de Duero (ESADD)",
   label: "Aranda de Duero (ESADD)"
  },
  {
   value: "Aranjuez (ESAAJ)",
   label: "Aranjuez (ESAAJ)"
  },
  {
   value: "Arano (ESANO)",
   label: "Arano (ESANO)"
  },
  {
   value: "Arbas (ESARB)",
   label: "Arbas (ESARB)"
  },
  {
   value: "Arbucias (ESACS)",
   label: "Arbucias (ESACS)"
  },
  {
   value: "Archena (ESARC)",
   label: "Archena (ESARC)"
  },
  {
   value: "Archidona (ESAHZ)",
   label: "Archidona (ESAHZ)"
  },
  {
   value: "Arcos De La Frontera (ESAFR)",
   label: "Arcos De La Frontera (ESAFR)"
  },
  {
   value: "Arenys de Mar (ESARN)",
   label: "Arenys de Mar (ESARN)"
  },
  {
   value: "Areta (ESART)",
   label: "Areta (ESART)"
  },
  {
   value: "Arganda (ESARG)",
   label: "Arganda (ESARG)"
  },
  {
   value: "Argentona (ESANT)",
   label: "Argentona (ESANT)"
  },
  {
   value: "Argoncillo (ESAGC)",
   label: "Argoncillo (ESAGC)"
  },
  {
   value: "Arguineguin (ESARI)",
   label: "Arguineguin (ESARI)"
  },
  {
   value: "Armuna (ESARM)",
   label: "Armuna (ESARM)"
  },
  {
   value: "Armuna de Almanzora (ESAXZ)",
   label: "Armuna de Almanzora (ESAXZ)"
  },
  {
   value: "Arrancudiaga (ESARR)",
   label: "Arrancudiaga (ESARR)"
  },
  {
   value: "Arrecife de Lanzarote (ESACE)",
   label: "Arrecife de Lanzarote (ESACE)"
  },
  {
   value: "Arrigorriaga (ESARA)",
   label: "Arrigorriaga (ESARA)"
  },
  {
   value: "Arteijo (ESARJ)",
   label: "Arteijo (ESARJ)"
  },
  {
   value: "Artes (ESATS)",
   label: "Artes (ESATS)"
  },
  {
   value: "Aspe (ESAPE)",
   label: "Aspe (ESAPE)"
  },
  {
   value: "Asturias (ESAST)",
   label: "Asturias (ESAST)"
  },
  {
   value: "Asua (ESAWI)",
   label: "Asua (ESAWI)"
  },
  {
   value: "Atarfe (ESAAF)",
   label: "Atarfe (ESAAF)"
  },
  {
   value: "Autol (ESAOL)",
   label: "Autol (ESAOL)"
  },
  {
   value: "Avila (ESAVI)",
   label: "Avila (ESAVI)"
  },
  {
   value: "Aviles (ESAVS)",
   label: "Aviles (ESAVS)"
  },
  {
   value: "Ayamonte (ESAYA)",
   label: "Ayamonte (ESAYA)"
  },
  {
   value: "Ayelo de Malferit (ESAYL)",
   label: "Ayelo de Malferit (ESAYL)"
  },
  {
   value: "Azcoitia (ESAZA)",
   label: "Azcoitia (ESAZA)"
  },
  {
   value: "Aznalcazar (ESAZC)",
   label: "Aznalcazar (ESAZC)"
  },
  {
   value: "Azpeitia (ESAPT)",
   label: "Azpeitia (ESAPT)"
  },
  {
   value: "Alfara (ESAFA)",
   label: "Alfara (ESAFA)"
  },
  {
   value: "Alfara Del Patriarca (ESAFP)",
   label: "Alfara Del Patriarca (ESAFP)"
  },
  {
   value: "Alfarras (ESAFJ)",
   label: "Alfarras (ESAFJ)"
  },
  {
   value: "Alfondeguilla (ESAGY)",
   label: "Alfondeguilla (ESAGY)"
  },
  {
   value: "Algar De Palancia (Dupl.AGP) (ESALP)",
   label: "Algar De Palancia (Dupl.AGP) (ESALP)"
  },
  {
   value: "Algeciras (ESALG)",
   label: "Algeciras (ESALG)"
  },
  {
   value: "Algemisi (ESAIJ)",
   label: "Algemisi (ESAIJ)"
  },
  {
   value: "\"Algete (ESAQG)",
   label: "\"Algete (ESAQG)"
  },
  {
   value: "Algimia De Alfara (ESAGF)",
   label: "Algimia De Alfara (ESAGF)"
  },
  {
   value: "Algimia De Almonacid (ESAGQ)",
   label: "Algimia De Almonacid (ESAGQ)"
  },
  {
   value: "Alginet (ESAGH)",
   label: "Alginet (ESAGH)"
  },
  {
   value: "Alguaire (ESALU)",
   label: "Alguaire (ESALU)"
  },
  {
   value: "Alguazas (ESAGZ)",
   label: "Alguazas (ESAGZ)"
  },
  {
   value: "Alguena (ESAGN)",
   label: "Alguena (ESAGN)"
  },
  {
   value: "Alhama (ESAHP)",
   label: "Alhama (ESAHP)"
  },
  {
   value: "Alhama De Almeria (ESAHA)",
   label: "Alhama De Almeria (ESAHA)"
  },
  {
   value: "Alhama De Granada (ESAAH)",
   label: "Alhama De Granada (ESAAH)"
  },
  {
   value: "Alhaurin De La Torre (ESAHI)",
   label: "Alhaurin De La Torre (ESAHI)"
  },
  {
   value: "Alhaurin El Grande (ESAJG)",
   label: "Alhaurin El Grande (ESAJG)"
  },
  {
   value: "Alicante (ESALC)",
   label: "Alicante (ESALC)"
  },
  {
   value: "Aljucen (ESALJ)",
   label: "Aljucen (ESALJ)"
  },
  {
   value: "Almacera (ESAOQ)",
   label: "Almacera (ESAOQ)"
  },
  {
   value: "Almachar (ESAKM)",
   label: "Almachar (ESAKM)"
  },
  {
   value: "Almaden (ESADZ)",
   label: "Almaden (ESADZ)"
  },
  {
   value: "Almansa (ESAMN)",
   label: "Almansa (ESAMN)"
  },
  {
   value: "Almaraz (ESAOZ)",
   label: "Almaraz (ESAOZ)"
  },
  {
   value: "Almazora (ESAMZ)",
   label: "Almazora (ESAMZ)"
  },
  {
   value: "Almenara (ESAWN)",
   label: "Almenara (ESAWN)"
  },
  {
   value: "Almendralejo (ESAJH)",
   label: "Almendralejo (ESAJH)"
  },
  {
   value: "Almeria (ESLEI)",
   label: "Almeria (ESLEI)"
  },
  {
   value: "Almodovar Del Pinar (ESAWV)",
   label: "Almodovar Del Pinar (ESAWV)"
  },
  {
   value: "Almodovar Del Rio (ESAEV)",
   label: "Almodovar Del Rio (ESAEV)"
  },
  {
   value: "Almoines (ESAPM)",
   label: "Almoines (ESAPM)"
  },
  {
   value: "Almonte (ESAEO)",
   label: "Almonte (ESAEO)"
  },
  {
   value: "Almunecar (ESAEQ)",
   label: "Almunecar (ESAEQ)"
  },
  {
   value: "Almusafes (ESAFE)",
   label: "Almusafes (ESAFE)"
  },
  {
   value: "Alora (ESALO)",
   label: "Alora (ESALO)"
  },
  {
   value: "Alpuente (ESAOT)",
   label: "Alpuente (ESAOT)"
  },
  {
   value: "Alquerias (ESALQ)",
   label: "Alquerias (ESALQ)"
  },
  {
   value: "Alberique (ESAJQ)",
   label: "Alberique (ESAJQ)"
  },
  {
   value: "Albocacer (ESAQC)",
   label: "Albocacer (ESAQC)"
  },
  {
   value: "Albolote (ESACB)",
   label: "Albolote (ESACB)"
  },
  {
   value: "Alborache (ESAQH)",
   label: "Alborache (ESAQH)"
  },
  {
   value: "Alboraya (ESALR)",
   label: "Alboraya (ESALR)"
  },
  {
   value: "Albudeite (ESAIU)",
   label: "Albudeite (ESAIU)"
  },
  {
   value: "Albuixech (ESAXC)",
   label: "Albuixech (ESAXC)"
  },
  {
   value: "Alcacer (ESAQE)",
   label: "Alcacer (ESAQE)"
  },
  {
   value: "Alcala De Chisvert (ESAQI)",
   label: "Alcala De Chisvert (ESAQI)"
  },
  {
   value: "Alcala De Guadaira (ESAKG)",
   label: "Alcala De Guadaira (ESAKG)"
  },
  {
   value: "Alcala De Henares (ESACL)",
   label: "Alcala De Henares (ESACL)"
  },
  {
   value: "Alcala De Jucar (ESAQU)",
   label: "Alcala De Jucar (ESAQU)"
  },
  {
   value: "Alcala La Real (ESAKA)",
   label: "Alcala La Real (ESAKA)"
  },
  {
   value: "Alcanar (ESACA)",
   label: "Alcanar (ESACA)"
  },
  {
   value: "Alcanices (ESALN)",
   label: "Alcanices (ESALN)"
  },
  {
   value: "Alcantarilla (ESAKJ)",
   label: "Alcantarilla (ESAKJ)"
  },
  {
   value: "Alcaraz (ESAQZ)",
   label: "Alcaraz (ESAQZ)"
  },
  {
   value: "Alcaudete (ESAKC)",
   label: "Alcaudete (ESAKC)"
  },
  {
   value: "Alcazar De San Juan (ESAKZ)",
   label: "Alcazar De San Juan (ESAKZ)"
  },
  {
   value: "Alcira (ESAHH)",
   label: "Alcira (ESAHH)"
  },
  {
   value: "Alcobendas (ESABZ)",
   label: "Alcobendas (ESABZ)"
  },
  {
   value: "Alcocer de Mola (Dupl.ADP) (ESADM)",
   label: "Alcocer de Mola (Dupl.ADP) (ESADM)"
  },
  {
   value: "Alcocer De Planes (ESADP)",
   label: "Alcocer De Planes (ESADP)"
  },
  {
   value: "Alcolea (ESAKQ)",
   label: "Alcolea (ESAKQ)"
  },
  {
   value: "Alcolea Del Rio (ESAKE)",
   label: "Alcolea Del Rio (ESAKE)"
  },
  {
   value: "Alcora (ESACR)",
   label: "Alcora (ESACR)"
  },
  {
   value: "Alcover (ESAWR)",
   label: "Alcover (ESAWR)"
  },
  {
   value: "Alcoy (ESAKF)",
   label: "Alcoy (ESAKF)"
  },
  {
   value: "Alcudia (ESALD)",
   label: "Alcudia (ESALD)"
  },
  {
   value: "Alcudia De Carlet (ESACW)",
   label: "Alcudia De Carlet (ESACW)"
  },
  {
   value: "Alcudia De Cresp (ESACU)",
   label: "Alcudia De Cresp (ESACU)"
  },
  {
   value: "Aldaya (ESADY)",
   label: "Aldaya (ESADY)"
  },
  {
   value: "Aldea (ESADA)",
   label: "Aldea (ESADA)"
  },
  {
   value: "Aldea de los rios (ESADL)",
   label: "Aldea de los rios (ESADL)"
  },
  {
   value: "Aldeanueva Del Campo (ESACP)",
   label: "Aldeanueva Del Campo (ESACP)"
  },
  {
   value: "Aldeaseca (ESALS)",
   label: "Aldeaseca (ESALS)"
  },
  {
   value: "Alfacar (ESAFF)",
   label: "Alfacar (ESAFF)"
  },
  {
   value: "Alfafar (ESALF)",
   label: "Alfafar (ESALF)"
  },
  {
   value: "Alfahuir (ESAFU)",
   label: "Alfahuir (ESAFU)"
  },
  {
   value: "Port Ibrahim (EGPIB)",
   label: "Port Ibrahim (EGPIB)"
  },
  {
   value: "Port Said (EGPSD)",
   label: "Port Said (EGPSD)"
  },
  {
   value: "Port Tewfik (EGPTK)",
   label: "Port Tewfik (EGPTK)"
  },
  {
   value: "Ras Gharib (EGRAG)",
   label: "Ras Gharib (EGRAG)"
  },
  {
   value: "Ras Shukheir (EGRSH)",
   label: "Ras Shukheir (EGRSH)"
  },
  {
   value: "Rashid (EGPRA)",
   label: "Rashid (EGPRA)"
  },
  {
   value: "Safaga (EGSGA)",
   label: "Safaga (EGSGA)"
  },
  {
   value: "Sharm El Sheikh (EGSSH)",
   label: "Sharm El Sheikh (EGSSH)"
  },
  {
   value: "Sidi Barrani (EGSBA)",
   label: "Sidi Barrani (EGSBA)"
  },
  {
   value: "Sidi Kerir Terminal (EGSKT)",
   label: "Sidi Kerir Terminal (EGSKT)"
  },
  {
   value: "Wadi Feiran (EGWAF)",
   label: "Wadi Feiran (EGWAF)"
  },
  {
   value: "El Aiun (EHEAI)",
   label: "El Aiun (EHEAI)"
  },
  {
   value: "Villa Cisneros (EHVIC)",
   label: "Villa Cisneros (EHVIC)"
  },
  {
   value: "Asmara (ERASM)",
   label: "Asmara (ERASM)"
  },
  {
   value: "Assab (ERASA)",
   label: "Assab (ERASA)"
  },
  {
   value: "Massawa (ERMSW)",
   label: "Massawa (ERMSW)"
  },
  {
   value: "Abanilla (ESAJA)",
   label: "Abanilla (ESAJA)"
  },
  {
   value: "Abaran (ESAEB)",
   label: "Abaran (ESAEB)"
  },
  {
   value: "Abronigal (ESABR)",
   label: "Abronigal (ESABR)"
  },
  {
   value: "Acerinox (ESANX)",
   label: "Acerinox (ESANX)"
  },
  {
   value: "Adra (ESADR)",
   label: "Adra (ESADR)"
  },
  {
   value: "Agaete (ESAGA)",
   label: "Agaete (ESAGA)"
  },
  {
   value: "Agost (ESAGO)",
   label: "Agost (ESAGO)"
  },
  {
   value: "Agramunti (ESAGR)",
   label: "Agramunti (ESAGR)"
  },
  {
   value: "Agua Amarga (ESAAG)",
   label: "Agua Amarga (ESAAG)"
  },
  {
   value: "Aguilar De La Frontera (ESADF)",
   label: "Aguilar De La Frontera (ESADF)"
  },
  {
   value: "Aguilas (ESAGU)",
   label: "Aguilas (ESAGU)"
  },
  {
   value: "Agullent (ESAGT)",
   label: "Agullent (ESAGT)"
  },
  {
   value: "Ahin (ESAHJ)",
   label: "Ahin (ESAHJ)"
  },
  {
   value: "Alacuas (ESAIP)",
   label: "Alacuas (ESAIP)"
  },
  {
   value: "Alarcon (ESAFN)",
   label: "Alarcon (ESAFN)"
  },
  {
   value: "Alava (ESALA)",
   label: "Alava (ESALA)"
  },
  {
   value: "Albacete (ESALB)",
   label: "Albacete (ESALB)"
  },
  {
   value: "Albaida (ESAHF)",
   label: "Albaida (ESAHF)"
  },
  {
   value: "Albal (ESAJB)",
   label: "Albal (ESAJB)"
  },
  {
   value: "Albalat De La Ribera (ESAEI)",
   label: "Albalat De La Ribera (ESAEI)"
  },
  {
   value: "Albalat De Segart (ESAJT)",
   label: "Albalat De Segart (ESAJT)"
  },
  {
   value: "Albalat Dels Sorells (ESAJL)",
   label: "Albalat Dels Sorells (ESAJL)"
  },
  {
   value: "Albarracin (ESACY)",
   label: "Albarracin (ESACY)"
  },
  {
   value: "Albatera (ESAJE)",
   label: "Albatera (ESAJE)"
  },
  {
   value: "Puna (ECPUN)",
   label: "Puna (ECPUN)"
  },
  {
   value: "Quito (ECUIO)",
   label: "Quito (ECUIO)"
  },
  {
   value: "Salinas (ECSNC)",
   label: "Salinas (ECSNC)"
  },
  {
   value: "San Lorenzo (ECSLR)",
   label: "San Lorenzo (ECSLR)"
  },
  {
   value: "Tepre (ECTEP)",
   label: "Tepre (ECTEP)"
  },
  {
   value: "Haabneeme (EEHNE)",
   label: "Haabneeme (EEHNE)"
  },
  {
   value: "Kärdla (EEKDL)",
   label: "Kärdla (EEKDL)"
  },
  {
   value: "Kuresaaare (EEURE)",
   label: "Kuresaaare (EEURE)"
  },
  {
   value: "Loksa (EELOK)",
   label: "Loksa (EELOK)"
  },
  {
   value: "Paldiski (EEPLA)",
   label: "Paldiski (EEPLA)"
  },
  {
   value: "Pärnu (EEPAR)",
   label: "Pärnu (EEPAR)"
  },
  {
   value: "Tallinn (EETLL)",
   label: "Tallinn (EETLL)"
  },
  {
   value: "Tartu (EETAY)",
   label: "Tartu (EETAY)"
  },
  {
   value: "Valga (EEVLG)",
   label: "Valga (EEVLG)"
  },
  {
   value: "Abu Ghosoun (EGAGN)",
   label: "Abu Ghosoun (EGAGN)"
  },
  {
   value: "Abu Kir (EGAKI)",
   label: "Abu Kir (EGAKI)"
  },
  {
   value: "Abu Rudeis (EGAUE)",
   label: "Abu Rudeis (EGAUE)"
  },
  {
   value: "Abu Simbel (EGABS)",
   label: "Abu Simbel (EGABS)"
  },
  {
   value: "Abu Zenima (EGAZA)",
   label: "Abu Zenima (EGAZA)"
  },
  {
   value: "Adabiya (EGADA)",
   label: "Adabiya (EGADA)"
  },
  {
   value: "Ain Sukhna (EGAIS)",
   label: "Ain Sukhna (EGAIS)"
  },
  {
   value: "Al Qusayr (EGAQU)",
   label: "Al Qusayr (EGAQU)"
  },
  {
   value: "Aswan (EGASW)",
   label: "Aswan (EGASW)"
  },
  {
   value: "Damanhour (EGDMN)",
   label: "Damanhour (EGDMN)"
  },
  {
   value: "Damietta (EGDAM)",
   label: "Damietta (EGDAM)"
  },
  {
   value: "El Dekheila (EGEDK)",
   label: "El Dekheila (EGEDK)"
  },
  {
   value: "El Iskandariya (= Alexandria) (EGALY)",
   label: "El Iskandariya (= Alexandria) (EGALY)"
  },
  {
   value: "El Qahira (= Cairo) (EGCAI)",
   label: "El Qahira (= Cairo) (EGCAI)"
  },
  {
   value: "El Suweis (= Suez) (EGSUZ)",
   label: "El Suweis (= Suez) (EGSUZ)"
  },
  {
   value: "El'Arish (EGAAC)",
   label: "El'Arish (EGAAC)"
  },
  {
   value: "Fanara (EGFAN)",
   label: "Fanara (EGFAN)"
  },
  {
   value: "Fayid (EGFAD)",
   label: "Fayid (EGFAD)"
  },
  {
   value: "Geisum Terminal (EGGEI)",
   label: "Geisum Terminal (EGGEI)"
  },
  {
   value: "Halaib (EGHAL)",
   label: "Halaib (EGHAL)"
  },
  {
   value: "Hamrawein (EGHAM)",
   label: "Hamrawein (EGHAM)"
  },
  {
   value: "Hurghada (EGHRG)",
   label: "Hurghada (EGHRG)"
  },
  {
   value: "Ismailia (EGISM)",
   label: "Ismailia (EGISM)"
  },
  {
   value: "Kosseir (EGKOS)",
   label: "Kosseir (EGKOS)"
  },
  {
   value: "Luxor (EGLXR)",
   label: "Luxor (EGLXR)"
  },
  {
   value: "Mersa El Hamra (EGMAH)",
   label: "Mersa El Hamra (EGMAH)"
  },
  {
   value: "New Valley (EGUVL)",
   label: "New Valley (EGUVL)"
  },
  {
   value: "Sanchez (DOSNZ)",
   label: "Sanchez (DOSNZ)"
  },
  {
   value: "Santiago de los Caballeros (DOSTI)",
   label: "Santiago de los Caballeros (DOSTI)"
  },
  {
   value: "Santo Domingo (DOSDQ)",
   label: "Santo Domingo (DOSDQ)"
  },
  {
   value: "Si Francisco Macoros (DOSFN)",
   label: "Si Francisco Macoros (DOSFN)"
  },
  {
   value: "JIMANI (DOJIM)",
   label: "JIMANI (DOJIM)"
  },
  {
   value: "Alger (DZALG)",
   label: "Alger (DZALG)"
  },
  {
   value: "Annaba (Ex Bone) (DZAAE)",
   label: "Annaba (Ex Bone) (DZAAE)"
  },
  {
   value: "Arzew (DZAZW)",
   label: "Arzew (DZAZW)"
  },
  {
   value: "Bejaia (Ex Bougie) (DZBJA)",
   label: "Bejaia (Ex Bougie) (DZBJA)"
  },
  {
   value: "Benisaf (DZBSF)",
   label: "Benisaf (DZBSF)"
  },
  {
   value: "Cherchell (DZCHE)",
   label: "Cherchell (DZCHE)"
  },
  {
   value: "Collo (DZCOL)",
   label: "Collo (DZCOL)"
  },
  {
   value: "Constantine (DZCZL)",
   label: "Constantine (DZCZL)"
  },
  {
   value: "Dellys (DZDEL)",
   label: "Dellys (DZDEL)"
  },
  {
   value: "Djidjelli (DZDJI)",
   label: "Djidjelli (DZDJI)"
  },
  {
   value: "Ghazaouet (DZGHA)",
   label: "Ghazaouet (DZGHA)"
  },
  {
   value: "La Calle (DZCLE)",
   label: "La Calle (DZCLE)"
  },
  {
   value: "Mostaganem (DZMOS)",
   label: "Mostaganem (DZMOS)"
  },
  {
   value: "Oran (DZORN)",
   label: "Oran (DZORN)"
  },
  {
   value: "Skikda (Ex Philippeville) (DZSKI)",
   label: "Skikda (Ex Philippeville) (DZSKI)"
  },
  {
   value: "Tenes (DZTEN)",
   label: "Tenes (DZTEN)"
  },
  {
   value: "Ambato (ECATF)",
   label: "Ambato (ECATF)"
  },
  {
   value: "Bahia De Caraques (ECBHA)",
   label: "Bahia De Caraques (ECBHA)"
  },
  {
   value: "Balao (ECEBL)",
   label: "Balao (ECEBL)"
  },
  {
   value: "Caleta Tagus (ECCAT)",
   label: "Caleta Tagus (ECCAT)"
  },
  {
   value: "Cuenca (ECCUE)",
   label: "Cuenca (ECCUE)"
  },
  {
   value: "Duran (ECDUN)",
   label: "Duran (ECDUN)"
  },
  {
   value: "Esmeraldas (ECESM)",
   label: "Esmeraldas (ECESM)"
  },
  {
   value: "Galapagos Islands (ECGPS)",
   label: "Galapagos Islands (ECGPS)"
  },
  {
   value: "Guayaquil (ECGYE)",
   label: "Guayaquil (ECGYE)"
  },
  {
   value: "La Libertad (ECLLD)",
   label: "La Libertad (ECLLD)"
  },
  {
   value: "Loja (ECLOH)",
   label: "Loja (ECLOH)"
  },
  {
   value: "Macara (ECMRR)",
   label: "Macara (ECMRR)"
  },
  {
   value: "Machala (ECMCH)",
   label: "Machala (ECMCH)"
  },
  {
   value: "Manta (ECMEC)",
   label: "Manta (ECMEC)"
  },
  {
   value: "Portoviejo (ECPVO)",
   label: "Portoviejo (ECPVO)"
  },
  {
   value: "\"Puerto Baquerizo Moreno (ECBAQ)",
   label: "\"Puerto Baquerizo Moreno (ECBAQ)"
  },
  {
   value: "Puerto Bolivar (ECPBO)",
   label: "Puerto Bolivar (ECPBO)"
  },
  {
   value: "\"Puerto Villamil (ECVIL)",
   label: "\"Puerto Villamil (ECVIL)"
  },
  {
   value: "Vejle (DKVEJ)",
   label: "Vejle (DKVEJ)"
  },
  {
   value: "Vemb (DKVMB)",
   label: "Vemb (DKVMB)"
  },
  {
   value: "Venø Havn (DKVEN)",
   label: "Venø Havn (DKVEN)"
  },
  {
   value: "\"Vesterø Havn (DKVES)",
   label: "\"Vesterø Havn (DKVES)"
  },
  {
   value: "Viborg (DKVIB)",
   label: "Viborg (DKVIB)"
  },
  {
   value: "Videbaek (DKVID)",
   label: "Videbaek (DKVID)"
  },
  {
   value: "Vig (DKVIG)",
   label: "Vig (DKVIG)"
  },
  {
   value: "Vigsnæs (DKVAS)",
   label: "Vigsnæs (DKVAS)"
  },
  {
   value: "Vinderup (DKVNR)",
   label: "Vinderup (DKVNR)"
  },
  {
   value: "Vipperød (DKVPP)",
   label: "Vipperød (DKVPP)"
  },
  {
   value: "Virum (DKVIR)",
   label: "Virum (DKVIR)"
  },
  {
   value: "Vodskov (DKVOK)",
   label: "Vodskov (DKVOK)"
  },
  {
   value: "Vojens (DKSKS)",
   label: "Vojens (DKSKS)"
  },
  {
   value: "Vordingborg (DKVOR)",
   label: "Vordingborg (DKVOR)"
  },
  {
   value: "Østbirk (DKOKB)",
   label: "Østbirk (DKOKB)"
  },
  {
   value: "Øster Doense (DKODD)",
   label: "Øster Doense (DKODD)"
  },
  {
   value: "Øster Snede (DKOSD)",
   label: "Øster Snede (DKOSD)"
  },
  {
   value: "HERFOLGE (DKHFE)",
   label: "HERFOLGE (DKHFE)"
  },
  {
   value: "PANDRUP (DKPAN)",
   label: "PANDRUP (DKPAN)"
  },
  {
   value: "Anse De Mai (DMADM)",
   label: "Anse De Mai (DMADM)"
  },
  {
   value: "Dominica (DMDOM)",
   label: "Dominica (DMDOM)"
  },
  {
   value: "Portsmouth (DMPOR)",
   label: "Portsmouth (DMPOR)"
  },
  {
   value: "Roseau (DMRSU)",
   label: "Roseau (DMRSU)"
  },
  {
   value: "Bani (DOBAN)",
   label: "Bani (DOBAN)"
  },
  {
   value: "Barahona (DOBRX)",
   label: "Barahona (DOBRX)"
  },
  {
   value: "Boca Chica (DOBCC)",
   label: "Boca Chica (DOBCC)"
  },
  {
   value: "Cabo Rojo (DOCBJ)",
   label: "Cabo Rojo (DOCBJ)"
  },
  {
   value: "Ciudad Trujillo (DOCIU)",
   label: "Ciudad Trujillo (DOCIU)"
  },
  {
   value: "La Romana (DOLRM)",
   label: "La Romana (DOLRM)"
  },
  {
   value: "Manzanillo (DOMAN)",
   label: "Manzanillo (DOMAN)"
  },
  {
   value: "Palenque (DOPAL)",
   label: "Palenque (DOPAL)"
  },
  {
   value: "Pedernales (DOPDR)",
   label: "Pedernales (DOPDR)"
  },
  {
   value: "Puerto Duarte (DOPUD)",
   label: "Puerto Duarte (DOPUD)"
  },
  {
   value: "Puerto Libertador (DOPUO)",
   label: "Puerto Libertador (DOPUO)"
  },
  {
   value: "Puerto Plata (DOPOP)",
   label: "Puerto Plata (DOPOP)"
  },
  {
   value: "Puerto Viejo De Azua (DOPVA)",
   label: "Puerto Viejo De Azua (DOPVA)"
  },
  {
   value: "Rio Haina (DOHAI)",
   label: "Rio Haina (DOHAI)"
  },
  {
   value: "Sabana De Mar (DOSNX)",
   label: "Sabana De Mar (DOSNX)"
  },
  {
   value: "San Cristobal (DOSCR)",
   label: "San Cristobal (DOSCR)"
  },
  {
   value: "San Pedro de Macoris (DOSPM)",
   label: "San Pedro de Macoris (DOSPM)"
  },
  {
   value: "Studstrupværkets Havn (DKSSV)",
   label: "Studstrupværkets Havn (DKSSV)"
  },
  {
   value: "Støvring (DKSTO)",
   label: "Støvring (DKSTO)"
  },
  {
   value: "Sundby (DKSBY)",
   label: "Sundby (DKSBY)"
  },
  {
   value: "Sunds (DKSUS)",
   label: "Sunds (DKSUS)"
  },
  {
   value: "Sundsøre (DKSUE)",
   label: "Sundsøre (DKSUE)"
  },
  {
   value: "Svaneke (DKSVA)",
   label: "Svaneke (DKSVA)"
  },
  {
   value: "Svendborg (DKSVE)",
   label: "Svendborg (DKSVE)"
  },
  {
   value: "Svenstrup (DKSVN)",
   label: "Svenstrup (DKSVN)"
  },
  {
   value: "Svinninge (DKSNN)",
   label: "Svinninge (DKSNN)"
  },
  {
   value: "Sydborg (DKSYD)",
   label: "Sydborg (DKSYD)"
  },
  {
   value: "Søborg (DKSBG)",
   label: "Søborg (DKSBG)"
  },
  {
   value: "Søby Havn (DKSOB)",
   label: "Søby Havn (DKSOB)"
  },
  {
   value: "Sønder (DKSND)",
   label: "Sønder (DKSND)"
  },
  {
   value: "Sønder Kongerslev (DKSOK)",
   label: "Sønder Kongerslev (DKSOK)"
  },
  {
   value: "Sønderborg (DKSGD)",
   label: "Sønderborg (DKSGD)"
  },
  {
   value: "Søndersø (DKSDS)",
   label: "Søndersø (DKSDS)"
  },
  {
   value: "Taarbæk (DKTBA)",
   label: "Taarbæk (DKTBA)"
  },
  {
   value: "Tarm (DKTRM)",
   label: "Tarm (DKTRM)"
  },
  {
   value: "Tårs (DKTRS)",
   label: "Tårs (DKTRS)"
  },
  {
   value: "Tåstrup (DKTTR)",
   label: "Tåstrup (DKTTR)"
  },
  {
   value: "Them (DKTHM)",
   label: "Them (DKTHM)"
  },
  {
   value: "Thisted (DKTED)",
   label: "Thisted (DKTED)"
  },
  {
   value: "Thurø (DKTHO)",
   label: "Thurø (DKTHO)"
  },
  {
   value: "Tinglev (DKTGV)",
   label: "Tinglev (DKTGV)"
  },
  {
   value: "Toftlund (DKTFT)",
   label: "Toftlund (DKTFT)"
  },
  {
   value: "Tommerup (DKTOM)",
   label: "Tommerup (DKTOM)"
  },
  {
   value: "Tranebjerg (DKTRN)",
   label: "Tranebjerg (DKTRN)"
  },
  {
   value: "Tuborg (DKTUB)",
   label: "Tuborg (DKTUB)"
  },
  {
   value: "Tunø (DKTNO)",
   label: "Tunø (DKTNO)"
  },
  {
   value: "Tyborøn (DKTYB)",
   label: "Tyborøn (DKTYB)"
  },
  {
   value: "Tønder (DKTON)",
   label: "Tønder (DKTON)"
  },
  {
   value: "Tørring (DKTOE)",
   label: "Tørring (DKTOE)"
  },
  {
   value: "Uldum (DKULD)",
   label: "Uldum (DKULD)"
  },
  {
   value: "Ulfborg (DKULB)",
   label: "Ulfborg (DKULB)"
  },
  {
   value: "Ullerslev (DKULL)",
   label: "Ullerslev (DKULL)"
  },
  {
   value: "Vadum (DKVAD)",
   label: "Vadum (DKVAD)"
  },
  {
   value: "Valby (DKVAL)",
   label: "Valby (DKVAL)"
  },
  {
   value: "Vamdrup (DKVDP)",
   label: "Vamdrup (DKVDP)"
  },
  {
   value: "Vang Havn (DKVNG)",
   label: "Vang Havn (DKVNG)"
  },
  {
   value: "Varde (DKVDE)",
   label: "Varde (DKVDE)"
  },
  {
   value: "Vedbaek (DKVBK)",
   label: "Vedbaek (DKVBK)"
  },
  {
   value: "Vejen (DKVJN)",
   label: "Vejen (DKVJN)"
  },
  {
   value: "Sejerø (DKSEO)",
   label: "Sejerø (DKSEO)"
  },
  {
   value: "Silkeborg (DKSLB)",
   label: "Silkeborg (DKSLB)"
  },
  {
   value: "Sjællands Odde (DKSJO)",
   label: "Sjællands Odde (DKSJO)"
  },
  {
   value: "Skælskør (DKSSK)",
   label: "Skælskør (DKSSK)"
  },
  {
   value: "Skærbæk (DKSKB)",
   label: "Skærbæk (DKSKB)"
  },
  {
   value: "Skagen (DKSKA)",
   label: "Skagen (DKSKA)"
  },
  {
   value: "Skals (DKSKL)",
   label: "Skals (DKSKL)"
  },
  {
   value: "Skamby (DKSKM)",
   label: "Skamby (DKSKM)"
  },
  {
   value: "Skarø\/Drejø (DKSDO)",
   label: "Skarø\/Drejø (DKSDO)"
  },
  {
   value: "Skejby (DKSJB)",
   label: "Skejby (DKSJB)"
  },
  {
   value: "Skibby (DKSKY)",
   label: "Skibby (DKSKY)"
  },
  {
   value: "Skive (DKSKV)",
   label: "Skive (DKSKV)"
  },
  {
   value: "Skjern (DKSKJ)",
   label: "Skjern (DKSKJ)"
  },
  {
   value: "Skodborg (DKSKO)",
   label: "Skodborg (DKSKO)"
  },
  {
   value: "Skodstrup (DKSKT)",
   label: "Skodstrup (DKSKT)"
  },
  {
   value: "Skovlund (DKSKD)",
   label: "Skovlund (DKSKD)"
  },
  {
   value: "Skrydstrup (DKSKR)",
   label: "Skrydstrup (DKSKR)"
  },
  {
   value: "Skørping (DKSKP)",
   label: "Skørping (DKSKP)"
  },
  {
   value: "Slagelse (DKSLG)",
   label: "Slagelse (DKSLG)"
  },
  {
   value: "Slangerup (DKSLA)",
   label: "Slangerup (DKSLA)"
  },
  {
   value: "Smørum (DKSMO)",
   label: "Smørum (DKSMO)"
  },
  {
   value: "Snekkersten (DKSNE)",
   label: "Snekkersten (DKSNE)"
  },
  {
   value: "Sodersø (DKSDR)",
   label: "Sodersø (DKSDR)"
  },
  {
   value: "Sorvad (DKSOV)",
   label: "Sorvad (DKSOV)"
  },
  {
   value: "Sorø (DKSRO)",
   label: "Sorø (DKSRO)"
  },
  {
   value: "Spodsbjerg Havn (DKSPB)",
   label: "Spodsbjerg Havn (DKSPB)"
  },
  {
   value: "Sporup (DKSPP)",
   label: "Sporup (DKSPP)"
  },
  {
   value: "Spottrup (DKSPO)",
   label: "Spottrup (DKSPO)"
  },
  {
   value: "Stålvalseværket (DKSVV)",
   label: "Stålvalseværket (DKSVV)"
  },
  {
   value: "Statoil-Havnen (DKSTT)",
   label: "Statoil-Havnen (DKSTT)"
  },
  {
   value: "Stauning (DKSTA)",
   label: "Stauning (DKSTA)"
  },
  {
   value: "Stege (DKSTE)",
   label: "Stege (DKSTE)"
  },
  {
   value: "Stenderup (DKSRP)",
   label: "Stenderup (DKSRP)"
  },
  {
   value: "Stenkilde (DKSKI)",
   label: "Stenkilde (DKSKI)"
  },
  {
   value: "Stenstrup (DKSNS)",
   label: "Stenstrup (DKSNS)"
  },
  {
   value: "Stignæsværkets Havn (DKSTG)",
   label: "Stignæsværkets Havn (DKSTG)"
  },
  {
   value: "Stigsnæs (DKSTN)",
   label: "Stigsnæs (DKSTN)"
  },
  {
   value: "Strib Havn (DKSTB)",
   label: "Strib Havn (DKSTB)"
  },
  {
   value: "Struer (DKSTR)",
   label: "Struer (DKSTR)"
  },
  {
   value: "Strynø (DKSNO)",
   label: "Strynø (DKSNO)"
  },
  {
   value: "Stubbekøbing Havn (DKSBK)",
   label: "Stubbekøbing Havn (DKSBK)"
  },
  {
   value: "Nyborg (DKNBG)",
   label: "Nyborg (DKNBG)"
  },
  {
   value: "Nyköbing Sjælland (DKNYS)",
   label: "Nyköbing Sjælland (DKNYS)"
  },
  {
   value: "Nykøbing (DKNYK)",
   label: "Nykøbing (DKNYK)"
  },
  {
   value: "Nykøbing Falster (DKNYF)",
   label: "Nykøbing Falster (DKNYF)"
  },
  {
   value: "Nykøbing Mors (DKNYM)",
   label: "Nykøbing Mors (DKNYM)"
  },
  {
   value: "Nysted (DKNTD)",
   label: "Nysted (DKNTD)"
  },
  {
   value: "Nørre Aaby (DKNRE)",
   label: "Nørre Aaby (DKNRE)"
  },
  {
   value: "Nørre Snede (DKNSD)",
   label: "Nørre Snede (DKNSD)"
  },
  {
   value: "Nørresundby (DKNRS)",
   label: "Nørresundby (DKNRS)"
  },
  {
   value: "Odense (DKODE)",
   label: "Odense (DKODE)"
  },
  {
   value: "Oester Tørslev (DKOTV)",
   label: "Oester Tørslev (DKOTV)"
  },
  {
   value: "Olgod (DKOLG)",
   label: "Olgod (DKOLG)"
  },
  {
   value: "Omø (DKOMO)",
   label: "Omø (DKOMO)"
  },
  {
   value: "Orbaek (DKOFQ)",
   label: "Orbaek (DKOFQ)"
  },
  {
   value: "\"Orehoved (DKORE)",
   label: "\"Orehoved (DKORE)"
  },
  {
   value: "Ornhøj (DKOHJ)",
   label: "Ornhøj (DKOHJ)"
  },
  {
   value: "Orø (DKORO)",
   label: "Orø (DKORO)"
  },
  {
   value: "Otterup (DKOTT)",
   label: "Otterup (DKOTT)"
  },
  {
   value: "Ovtrup (DKOTR)",
   label: "Ovtrup (DKOTR)"
  },
  {
   value: "Padborg (DKPAO)",
   label: "Padborg (DKPAO)"
  },
  {
   value: "Randers (DKRAN)",
   label: "Randers (DKRAN)"
  },
  {
   value: "Ranum (DKRNM)",
   label: "Ranum (DKRNM)"
  },
  {
   value: "Ribe (DKRIB)",
   label: "Ribe (DKRIB)"
  },
  {
   value: "Ringe (DKRIN)",
   label: "Ringe (DKRIN)"
  },
  {
   value: "Ringsted (DKRNG)",
   label: "Ringsted (DKRNG)"
  },
  {
   value: "Risskov (DKRSS)",
   label: "Risskov (DKRSS)"
  },
  {
   value: "Roskilde (DKRKE)",
   label: "Roskilde (DKRKE)"
  },
  {
   value: "Roslev (DKRSL)",
   label: "Roslev (DKRSL)"
  },
  {
   value: "Rudkøbing (DKRKB)",
   label: "Rudkøbing (DKRKB)"
  },
  {
   value: "Ryomgård (DKRYM)",
   label: "Ryomgård (DKRYM)"
  },
  {
   value: "Rødby (Fægehavn) (DKROF)",
   label: "Rødby (Fægehavn) (DKROF)"
  },
  {
   value: "Rødbyhavn (DKROD)",
   label: "Rødbyhavn (DKROD)"
  },
  {
   value: "Rødekro (DKRDK)",
   label: "Rødekro (DKRDK)"
  },
  {
   value: "Rønne (DKRNN)",
   label: "Rønne (DKRNN)"
  },
  {
   value: "Rørvig (DKRRV)",
   label: "Rørvig (DKRRV)"
  },
  {
   value: "Sæby (DKSAE)",
   label: "Sæby (DKSAE)"
  },
  {
   value: "Sælvig Havn (DKSLV)",
   label: "Sælvig Havn (DKSLV)"
  },
  {
   value: "Sakskøbing (DKSAX)",
   label: "Sakskøbing (DKSAX)"
  },
  {
   value: "Sandager (DKSAG)",
   label: "Sandager (DKSAG)"
  },
  {
   value: "Sandvig (DKSVG)",
   label: "Sandvig (DKSVG)"
  },
  {
   value: "Sejerslev (DKSEJ)",
   label: "Sejerslev (DKSEJ)"
  },
  {
   value: "Køge (DKKOG)",
   label: "Køge (DKKOG)"
  },
  {
   value: "Langeskov (DKLGS)",
   label: "Langeskov (DKLGS)"
  },
  {
   value: "Låsby (DKLAA)",
   label: "Låsby (DKLAA)"
  },
  {
   value: "Lemvig (DKLVG)",
   label: "Lemvig (DKLVG)"
  },
  {
   value: "Lille Skensved (DKLLS)",
   label: "Lille Skensved (DKLLS)"
  },
  {
   value: "Lindø Havn (DKLIN)",
   label: "Lindø Havn (DKLIN)"
  },
  {
   value: "Lohals (DKLOH)",
   label: "Lohals (DKLOH)"
  },
  {
   value: "Losning (DKLIG)",
   label: "Losning (DKLIG)"
  },
  {
   value: "Lunderskov (DKLND)",
   label: "Lunderskov (DKLND)"
  },
  {
   value: "Lyngby (DKLYN)",
   label: "Lyngby (DKLYN)"
  },
  {
   value: "Lynge (DKLNE)",
   label: "Lynge (DKLNE)"
  },
  {
   value: "Lyngs Odde Havn (DKLYO)",
   label: "Lyngs Odde Havn (DKLYO)"
  },
  {
   value: "Løgstrup (DKLOG)",
   label: "Løgstrup (DKLOG)"
  },
  {
   value: "Løgstør (DKLGR)",
   label: "Løgstør (DKLGR)"
  },
  {
   value: "Løgumkloster (DKLKO)",
   label: "Løgumkloster (DKLKO)"
  },
  {
   value: "Maløv (DKMLV)",
   label: "Maløv (DKMLV)"
  },
  {
   value: "Marbæk Havn (DKMRB)",
   label: "Marbæk Havn (DKMRB)"
  },
  {
   value: "Mariager (DKMRR)",
   label: "Mariager (DKMRR)"
  },
  {
   value: "Maribo (DKMRV)",
   label: "Maribo (DKMRV)"
  },
  {
   value: "Marslev (DKMAR)",
   label: "Marslev (DKMAR)"
  },
  {
   value: "Marstal (DKMRS)",
   label: "Marstal (DKMRS)"
  },
  {
   value: "Masnedsund (DKMNS)",
   label: "Masnedsund (DKMNS)"
  },
  {
   value: "Masnedsund gødningshamn (DKUNX)",
   label: "Masnedsund gødningshamn (DKUNX)"
  },
  {
   value: "Masnedø (DKMAS)",
   label: "Masnedø (DKMAS)"
  },
  {
   value: "Middelfart (DKMID)",
   label: "Middelfart (DKMID)"
  },
  {
   value: "Moerke (DKMKE)",
   label: "Moerke (DKMKE)"
  },
  {
   value: "Moldrup (DKMUP)",
   label: "Moldrup (DKMUP)"
  },
  {
   value: "Mommark (DKMOM)",
   label: "Mommark (DKMOM)"
  },
  {
   value: "Mundelstrup (DKMRU)",
   label: "Mundelstrup (DKMRU)"
  },
  {
   value: "Naerum (DKNRM)",
   label: "Naerum (DKNRM)"
  },
  {
   value: "Næssund (DKNUD)",
   label: "Næssund (DKNUD)"
  },
  {
   value: "Næstved (DKNVD)",
   label: "Næstved (DKNVD)"
  },
  {
   value: "Nakskov (DKNAK)",
   label: "Nakskov (DKNAK)"
  },
  {
   value: "Neksø (DKNEX)",
   label: "Neksø (DKNEX)"
  },
  {
   value: "Nibe (DKNIB)",
   label: "Nibe (DKNIB)"
  },
  {
   value: "Nordborg (DKNBR)",
   label: "Nordborg (DKNBR)"
  },
  {
   value: "\"Nordby Havn (DKNDB)",
   label: "\"Nordby Havn (DKNDB)"
  },
  {
   value: "Nordenskov (DKNKV)",
   label: "Nordenskov (DKNKV)"
  },
  {
   value: "Norjyllandsvarkets havn (DKVSV)",
   label: "Norjyllandsvarkets havn (DKVSV)"
  },
  {
   value: "Norre Alslev (DKNAV)",
   label: "Norre Alslev (DKNAV)"
  },
  {
   value: "Nörre Vium (DKNRV)",
   label: "Nörre Vium (DKNRV)"
  },
  {
   value: "Holeby (DKHOL)",
   label: "Holeby (DKHOL)"
  },
  {
   value: "Holstebro (DKHSB)",
   label: "Holstebro (DKHSB)"
  },
  {
   value: "Holsted (DKHST)",
   label: "Holsted (DKHST)"
  },
  {
   value: "Horsens (DKHOR)",
   label: "Horsens (DKHOR)"
  },
  {
   value: "Hou Havn (DKHOH)",
   label: "Hou Havn (DKHOH)"
  },
  {
   value: "Houborg (DKHBG)",
   label: "Houborg (DKHBG)"
  },
  {
   value: "Hundested (DKHUN)",
   label: "Hundested (DKHUN)"
  },
  {
   value: "Hurup (DKHUR)",
   label: "Hurup (DKHUR)"
  },
  {
   value: "Hvalpsund (DKHVA)",
   label: "Hvalpsund (DKHVA)"
  },
  {
   value: "Hvidovre (DKHVV)",
   label: "Hvidovre (DKHVV)"
  },
  {
   value: "Højberg (DKHJB)",
   label: "Højberg (DKHJB)"
  },
  {
   value: "Højer (DKHJE)",
   label: "Højer (DKHJE)"
  },
  {
   value: "Hørning (DKHRN)",
   label: "Hørning (DKHRN)"
  },
  {
   value: "Hørsholm (DKHHM)",
   label: "Hørsholm (DKHHM)"
  },
  {
   value: "Hørup (DKHRU)",
   label: "Hørup (DKHRU)"
  },
  {
   value: "Ikast (DKIKA)",
   label: "Ikast (DKIKA)"
  },
  {
   value: "Ishøj (DKISJ)",
   label: "Ishøj (DKISJ)"
  },
  {
   value: "Jersie strand (DKJSD)",
   label: "Jersie strand (DKJSD)"
  },
  {
   value: "Jordløse (DKJRD)",
   label: "Jordløse (DKJRD)"
  },
  {
   value: "Juelsminde Havn (DKJUE)",
   label: "Juelsminde Havn (DKJUE)"
  },
  {
   value: "Jyderup (DKJRP)",
   label: "Jyderup (DKJRP)"
  },
  {
   value: "Kalundborg (DKKAL)",
   label: "Kalundborg (DKKAL)"
  },
  {
   value: "Karup (DKKRP)",
   label: "Karup (DKKRP)"
  },
  {
   value: "Kastrup (DKKTP)",
   label: "Kastrup (DKKTP)"
  },
  {
   value: "Kerteminde (DKKTD)",
   label: "Kerteminde (DKKTD)"
  },
  {
   value: "Kibæk (DKKIB)",
   label: "Kibæk (DKKIB)"
  },
  {
   value: "Kirke-Eskilstrup (DKKEP)",
   label: "Kirke-Eskilstrup (DKKEP)"
  },
  {
   value: "Kirkeby (DKKRB)",
   label: "Kirkeby (DKKRB)"
  },
  {
   value: "Kjellerup (DKKJE)",
   label: "Kjellerup (DKKJE)"
  },
  {
   value: "Kliplev (DKKPV)",
   label: "Kliplev (DKKPV)"
  },
  {
   value: "Klovborg (DKKVB)",
   label: "Klovborg (DKKVB)"
  },
  {
   value: "Knebel (DKKNB)",
   label: "Knebel (DKKNB)"
  },
  {
   value: "Kolby Kas Havn (DKKOK)",
   label: "Kolby Kas Havn (DKKOK)"
  },
  {
   value: "Kolding (DKKOL)",
   label: "Kolding (DKKOL)"
  },
  {
   value: "Korsør (DKKRR)",
   label: "Korsør (DKKRR)"
  },
  {
   value: "Kragenæs (DKKRA)",
   label: "Kragenæs (DKKRA)"
  },
  {
   value: "Kruså (DKKRS)",
   label: "Kruså (DKKRS)"
  },
  {
   value: "Kværndrup (DKKVR)",
   label: "Kværndrup (DKKVR)"
  },
  {
   value: "Kvistgaard (DKKVG)",
   label: "Kvistgaard (DKKVG)"
  },
  {
   value: "Kyndbyvaerkets Havn (DKKBY)",
   label: "Kyndbyvaerkets Havn (DKKBY)"
  },
  {
   value: "København (DKCPH)",
   label: "København (DKCPH)"
  },
  {
   value: "Gleibjerg (DKGLB)",
   label: "Gleibjerg (DKGLB)"
  },
  {
   value: "Glostrup (DKGLS)",
   label: "Glostrup (DKGLS)"
  },
  {
   value: "Glyngøre (DKGLY)",
   label: "Glyngøre (DKGLY)"
  },
  {
   value: "Görding (DKGRG)",
   label: "Görding (DKGRG)"
  },
  {
   value: "Gråsten (DKGRA)",
   label: "Gråsten (DKGRA)"
  },
  {
   value: "Gredstedbro (DKGRD)",
   label: "Gredstedbro (DKGRD)"
  },
  {
   value: "Grenaa (DKGRE)",
   label: "Grenaa (DKGRE)"
  },
  {
   value: "Grimstrup (DKGRI)",
   label: "Grimstrup (DKGRI)"
  },
  {
   value: "Grindsted (DKGRN)",
   label: "Grindsted (DKGRN)"
  },
  {
   value: "Gudbjerg (DKGUD)",
   label: "Gudbjerg (DKGUD)"
  },
  {
   value: "Gudhjem (DKGDM)",
   label: "Gudhjem (DKGDM)"
  },
  {
   value: "Gulfhavn (DKGFH)",
   label: "Gulfhavn (DKGFH)"
  },
  {
   value: "Haarby (DKHBY)",
   label: "Haarby (DKHBY)"
  },
  {
   value: "Haderslev (DKHAD)",
   label: "Haderslev (DKHAD)"
  },
  {
   value: "Hadsten (DKHDS)",
   label: "Hadsten (DKHDS)"
  },
  {
   value: "Hadsund (DKHSU)",
   label: "Hadsund (DKHSU)"
  },
  {
   value: "Halsskov (DKHKV)",
   label: "Halsskov (DKHKV)"
  },
  {
   value: "Hammel (DKHME)",
   label: "Hammel (DKHME)"
  },
  {
   value: "Hanstholm (DKHAN)",
   label: "Hanstholm (DKHAN)"
  },
  {
   value: "Harbooere (DKHBR)",
   label: "Harbooere (DKHBR)"
  },
  {
   value: "Hardeshøj (DKHDH)",
   label: "Hardeshøj (DKHDH)"
  },
  {
   value: "Hasle (DKHSL)",
   label: "Hasle (DKHSL)"
  },
  {
   value: "Haslev (DKHSV)",
   label: "Haslev (DKHSV)"
  },
  {
   value: "Hasselager (DKHSS)",
   label: "Hasselager (DKHSS)"
  },
  {
   value: "Hatting (DKHTT)",
   label: "Hatting (DKHTT)"
  },
  {
   value: "Havneby (DKHNB)",
   label: "Havneby (DKHNB)"
  },
  {
   value: "Havnegade (DKHVG)",
   label: "Havnegade (DKHVG)"
  },
  {
   value: "Havnsø (DKHVN)",
   label: "Havnsø (DKHVN)"
  },
  {
   value: "Hedehusene (DKHHS)",
   label: "Hedehusene (DKHHS)"
  },
  {
   value: "Hedensted (DKHED)",
   label: "Hedensted (DKHED)"
  },
  {
   value: "Hellerup (DKHRP)",
   label: "Hellerup (DKHRP)"
  },
  {
   value: "Hellested (DKHLE)",
   label: "Hellested (DKHLE)"
  },
  {
   value: "Helsingør \/ HALS (DKHLS)",
   label: "Helsingør \/ HALS (DKHLS)"
  },
  {
   value: "Herlev (DKHRV)",
   label: "Herlev (DKHRV)"
  },
  {
   value: "Herning (DKHER)",
   label: "Herning (DKHER)"
  },
  {
   value: "Hinnerup (DKHNN)",
   label: "Hinnerup (DKHNN)"
  },
  {
   value: "Hirtshals (DKHIR)",
   label: "Hirtshals (DKHIR)"
  },
  {
   value: "Hjørring (DKHJG)",
   label: "Hjørring (DKHJG)"
  },
  {
   value: "Hobro (DKHBO)",
   label: "Hobro (DKHBO)"
  },
  {
   value: "Hoeng (DKHNG)",
   label: "Hoeng (DKHNG)"
  },
  {
   value: "Holbæk (DKHBK)",
   label: "Holbæk (DKHBK)"
  },
  {
   value: "Durup (DKDRP)",
   label: "Durup (DKDRP)"
  },
  {
   value: "Ebeltoft (DKEBT)",
   label: "Ebeltoft (DKEBT)"
  },
  {
   value: "Egense (DKEGN)",
   label: "Egense (DKEGN)"
  },
  {
   value: "Egernsund (DKEND)",
   label: "Egernsund (DKEND)"
  },
  {
   value: "Ejby (DKEJY)",
   label: "Ejby (DKEJY)"
  },
  {
   value: "Ejstrup (DKEJS)",
   label: "Ejstrup (DKEJS)"
  },
  {
   value: "Endelave (DKEDL)",
   label: "Endelave (DKEDL)"
  },
  {
   value: "Engesvang (DKENV)",
   label: "Engesvang (DKENV)"
  },
  {
   value: "Enstedværkets Havn (DKENS)",
   label: "Enstedværkets Havn (DKENS)"
  },
  {
   value: "Esbjerg (DKEBJ)",
   label: "Esbjerg (DKEBJ)"
  },
  {
   value: "Faaborg (DKFAA)",
   label: "Faaborg (DKFAA)"
  },
  {
   value: "Faarevejle (DKFVJ)",
   label: "Faarevejle (DKFVJ)"
  },
  {
   value: "Faarup (DKFUP)",
   label: "Faarup (DKFUP)"
  },
  {
   value: "Faarvang (DKFVG)",
   label: "Faarvang (DKFVG)"
  },
  {
   value: "Fakse Ladeplads Havn (DKFAK)",
   label: "Fakse Ladeplads Havn (DKFAK)"
  },
  {
   value: "Farsø (DKFSO)",
   label: "Farsø (DKFSO)"
  },
  {
   value: "Farum (DKFRM)",
   label: "Farum (DKFRM)"
  },
  {
   value: "Feggesund (DKFGS)",
   label: "Feggesund (DKFGS)"
  },
  {
   value: "Fejø (DKFEJ)",
   label: "Fejø (DKFEJ)"
  },
  {
   value: "Femø (DKFMO)",
   label: "Femø (DKFMO)"
  },
  {
   value: "Fjerritslev (DKFJV)",
   label: "Fjerritslev (DKFJV)"
  },
  {
   value: "Fornæs (DKFNS)",
   label: "Fornæs (DKFNS)"
  },
  {
   value: "Fraugde\/Fyn (DKFRA)",
   label: "Fraugde\/Fyn (DKFRA)"
  },
  {
   value: "Fredensborg (DKFRE)",
   label: "Fredensborg (DKFRE)"
  },
  {
   value: "Fredericia (DKFRC)",
   label: "Fredericia (DKFRC)"
  },
  {
   value: "Frederiksberg (DKFBG)",
   label: "Frederiksberg (DKFBG)"
  },
  {
   value: "Frederikshavn (DKFDH)",
   label: "Frederikshavn (DKFDH)"
  },
  {
   value: "Frederiksund (DKFDS)",
   label: "Frederiksund (DKFDS)"
  },
  {
   value: "Frederiksværk (DKFDV)",
   label: "Frederiksværk (DKFDV)"
  },
  {
   value: "Fur (DKFUH)",
   label: "Fur (DKFUH)"
  },
  {
   value: "Fynshavn (DKFYH)",
   label: "Fynshavn (DKFYH)"
  },
  {
   value: "Galten (DKGLT)",
   label: "Galten (DKGLT)"
  },
  {
   value: "Gamby (DKGBY)",
   label: "Gamby (DKGBY)"
  },
  {
   value: "Gedser (DKGED)",
   label: "Gedser (DKGED)"
  },
  {
   value: "Gedsted (DKGDS)",
   label: "Gedsted (DKGDS)"
  },
  {
   value: "Gilleleje (DKGLE)",
   label: "Gilleleje (DKGLE)"
  },
  {
   value: "Give (DKGIV)",
   label: "Give (DKGIV)"
  },
  {
   value: "Gjerlev (DKGJR)",
   label: "Gjerlev (DKGJR)"
  },
  {
   value: "Gjern (DKGJN)",
   label: "Gjern (DKGJN)"
  },
  {
   value: "Gjessing (DKGJS)",
   label: "Gjessing (DKGJS)"
  },
  {
   value: "Glamsbjerg (DKGLM)",
   label: "Glamsbjerg (DKGLM)"
  },
  {
   value: "Aulum (DKAUU)",
   label: "Aulum (DKAUU)"
  },
  {
   value: "Avedøreværkets Havn (DKAVE)",
   label: "Avedøreværkets Havn (DKAVE)"
  },
  {
   value: "Avernako (DKAVK)",
   label: "Avernako (DKAVK)"
  },
  {
   value: "Baagø (DKBGO)",
   label: "Baagø (DKBGO)"
  },
  {
   value: "Bagenkop (DKBAG)",
   label: "Bagenkop (DKBAG)"
  },
  {
   value: "Bagsværd (DKBGS)",
   label: "Bagsværd (DKBGS)"
  },
  {
   value: "Ballebro (DKBLB)",
   label: "Ballebro (DKBLB)"
  },
  {
   value: "Ballerup (DKBLP)",
   label: "Ballerup (DKBLP)"
  },
  {
   value: "Balling (DKBLG)",
   label: "Balling (DKBLG)"
  },
  {
   value: "Bandholm (DKBDX)",
   label: "Bandholm (DKBDX)"
  },
  {
   value: "Bellinge (DKBEL)",
   label: "Bellinge (DKBEL)"
  },
  {
   value: "Billund (DKBLL)",
   label: "Billund (DKBLL)"
  },
  {
   value: "Bindslev (DKBID)",
   label: "Bindslev (DKBID)"
  },
  {
   value: "Bjerringbro (DKBJB)",
   label: "Bjerringbro (DKBJB)"
  },
  {
   value: "Blans (DKBLN)",
   label: "Blans (DKBLN)"
  },
  {
   value: "Bogense (DKBGZ)",
   label: "Bogense (DKBGZ)"
  },
  {
   value: "Bogø (DKBOG)",
   label: "Bogø (DKBOG)"
  },
  {
   value: "Bording (DKBDG)",
   label: "Bording (DKBDG)"
  },
  {
   value: "Borup (DKBOR)",
   label: "Borup (DKBOR)"
  },
  {
   value: "Bostrup (DKBTP)",
   label: "Bostrup (DKBTP)"
  },
  {
   value: "Brabrand (DKBRB)",
   label: "Brabrand (DKBRB)"
  },
  {
   value: "Bramming (DKBMG)",
   label: "Bramming (DKBMG)"
  },
  {
   value: "Brande (DKBRA)",
   label: "Brande (DKBRA)"
  },
  {
   value: "Branden Havn (DKBRH)",
   label: "Branden Havn (DKBRH)"
  },
  {
   value: "Bredebro (DKBRE)",
   label: "Bredebro (DKBRE)"
  },
  {
   value: "Bredsten (DKBRD)",
   label: "Bredsten (DKBRD)"
  },
  {
   value: "Brody (DKBDY)",
   label: "Brody (DKBDY)"
  },
  {
   value: "Brovst (DKBRT)",
   label: "Brovst (DKBRT)"
  },
  {
   value: "Brøndby (DKBRY)",
   label: "Brøndby (DKBRY)"
  },
  {
   value: "Brønderslev (DKBRO)",
   label: "Brønderslev (DKBRO)"
  },
  {
   value: "Brørup (DKBRP)",
   label: "Brørup (DKBRP)"
  },
  {
   value: "Bylderup (DKBYL)",
   label: "Bylderup (DKBYL)"
  },
  {
   value: "Bøjden (DKBOS)",
   label: "Bøjden (DKBOS)"
  },
  {
   value: "Cementfabriken Dania (DKDAN)",
   label: "Cementfabriken Dania (DKDAN)"
  },
  {
   value: "Cementfabrikken Kongsdal Havn (DKKON)",
   label: "Cementfabrikken Kongsdal Havn (DKKON)"
  },
  {
   value: "Christiansfield (DKCSF)",
   label: "Christiansfield (DKCSF)"
  },
  {
   value: "Dalby (DKDLB)",
   label: "Dalby (DKDLB)"
  },
  {
   value: "Dansk Salts Havn (DKDAS)",
   label: "Dansk Salts Havn (DKDAS)"
  },
  {
   value: "Dokkedal (DKDKD)",
   label: "Dokkedal (DKDKD)"
  },
  {
   value: "Dragør (DKDRA)",
   label: "Dragør (DKDRA)"
  },
  {
   value: "Drosby (DKDRS)",
   label: "Drosby (DKDRS)"
  },
  {
   value: "HASSMERS (DEHXX)",
   label: "HASSMERS (DEHXX)"
  },
  {
   value: "HEIMERTIN (DEHTI)",
   label: "HEIMERTIN (DEHTI)"
  },
  {
   value: "Hettingen (DEHTQ)",
   label: "Hettingen (DEHTQ)"
  },
  {
   value: "Kierspe (DEKSE)",
   label: "Kierspe (DEKSE)"
  },
  {
   value: "Kobern-Gondorf (DEKGF)",
   label: "Kobern-Gondorf (DEKGF)"
  },
  {
   value: "Naumburg (DENBU)",
   label: "Naumburg (DENBU)"
  },
  {
   value: "Neubrücke (DENEE)",
   label: "Neubrücke (DENEE)"
  },
  {
   value: "Pattensen (DEPNN)",
   label: "Pattensen (DEPNN)"
  },
  {
   value: "Pätz (DEPZB)",
   label: "Pätz (DEPZB)"
  },
  {
   value: "Pullach (DEPUH)",
   label: "Pullach (DEPUH)"
  },
  {
   value: "Sarlhusen (DESRU)",
   label: "Sarlhusen (DESRU)"
  },
  {
   value: "Schöneck (DESNK)",
   label: "Schöneck (DESNK)"
  },
  {
   value: "Spaichingen (DESPA)",
   label: "Spaichingen (DESPA)"
  },
  {
   value: "Wallwitz (DEWWZ)",
   label: "Wallwitz (DEWWZ)"
  },
  {
   value: "Wittstock an der Dosse (DEWDD)",
   label: "Wittstock an der Dosse (DEWDD)"
  },
  {
   value: "Djibouti (DJJIB)",
   label: "Djibouti (DJJIB)"
  },
  {
   value: "Aabenraa (DKAAB)",
   label: "Aabenraa (DKAAB)"
  },
  {
   value: "Aalborg (DKAAL)",
   label: "Aalborg (DKAAL)"
  },
  {
   value: "Aalborg Portland Cementfabrikk (DKROR)",
   label: "Aalborg Portland Cementfabrikk (DKROR)"
  },
  {
   value: "Aalestrup (DKAEY)",
   label: "Aalestrup (DKAEY)"
  },
  {
   value: "Aaro (DKARO)",
   label: "Aaro (DKARO)"
  },
  {
   value: "Aars (DKAZS)",
   label: "Aars (DKAZS)"
  },
  {
   value: "Aarup (DKAAP)",
   label: "Aarup (DKAAP)"
  },
  {
   value: "Aarøsund (DKARD)",
   label: "Aarøsund (DKARD)"
  },
  {
   value: "Abybro (DKAYB)",
   label: "Abybro (DKAYB)"
  },
  {
   value: "Ærøskøbing (DKARK)",
   label: "Ærøskøbing (DKARK)"
  },
  {
   value: "Agerbæk\/Fyn (DKAGD)",
   label: "Agerbæk\/Fyn (DKAGD)"
  },
  {
   value: "Agersø (DKAGO)",
   label: "Agersø (DKAGO)"
  },
  {
   value: "Agger Havn (DKAGH)",
   label: "Agger Havn (DKAGH)"
  },
  {
   value: "Aggersund (DKASH)",
   label: "Aggersund (DKASH)"
  },
  {
   value: "Albertslund (DKABT)",
   label: "Albertslund (DKABT)"
  },
  {
   value: "Alleröd (DKALL)",
   label: "Alleröd (DKALL)"
  },
  {
   value: "Allingåbro (DKALN)",
   label: "Allingåbro (DKALN)"
  },
  {
   value: "Allinge (DKAGE)",
   label: "Allinge (DKAGE)"
  },
  {
   value: "Anholt (DKANH)",
   label: "Anholt (DKANH)"
  },
  {
   value: "Ans by (DKANB)",
   label: "Ans by (DKANB)"
  },
  {
   value: "Ansager (DKANS)",
   label: "Ansager (DKANS)"
  },
  {
   value: "Århus (DKAAR)",
   label: "Århus (DKAAR)"
  },
  {
   value: "Askø (DKASK)",
   label: "Askø (DKASK)"
  },
  {
   value: "Asnæsværkets Havn (DKASV)",
   label: "Asnæsværkets Havn (DKASV)"
  },
  {
   value: "Assens (DKASN)",
   label: "Assens (DKASN)"
  },
  {
   value: "Augustenborg (DKAUB)",
   label: "Augustenborg (DKAUB)"
  },
  {
   value: "Wolnzach (DEWLZ)",
   label: "Wolnzach (DEWLZ)"
  },
  {
   value: "Worms (DEWOR)",
   label: "Worms (DEWOR)"
  },
  {
   value: "Wörnitz (DEWOZ)",
   label: "Wörnitz (DEWOZ)"
  },
  {
   value: "Worpswede (DEWRP)",
   label: "Worpswede (DEWRP)"
  },
  {
   value: "Wörrstadt (DEWRR)",
   label: "Wörrstadt (DEWRR)"
  },
  {
   value: "Wörth (DEWOE)",
   label: "Wörth (DEWOE)"
  },
  {
   value: "Wülfrath (DEWLF)",
   label: "Wülfrath (DEWLF)"
  },
  {
   value: "Wulsdorf (DEWUD)",
   label: "Wulsdorf (DEWUD)"
  },
  {
   value: "Wünnenberg (DEWUG)",
   label: "Wünnenberg (DEWUG)"
  },
  {
   value: "Wunsiedel (DEWUL)",
   label: "Wunsiedel (DEWUL)"
  },
  {
   value: "Wunstorf (DEWUN)",
   label: "Wunstorf (DEWUN)"
  },
  {
   value: "Wuppertal (DEWUP)",
   label: "Wuppertal (DEWUP)"
  },
  {
   value: "Würselen (DEWRS)",
   label: "Würselen (DEWRS)"
  },
  {
   value: "Wurzbach (DEWZB)",
   label: "Wurzbach (DEWZB)"
  },
  {
   value: "Würzburg (DEWUE)",
   label: "Würzburg (DEWUE)"
  },
  {
   value: "Wurzen (DEWZN)",
   label: "Wurzen (DEWZN)"
  },
  {
   value: "Wyk auf Föhr (DEWYK)",
   label: "Wyk auf Föhr (DEWYK)"
  },
  {
   value: "Xanten (DEXTE)",
   label: "Xanten (DEXTE)"
  },
  {
   value: "Zeil am Main (DEZEI)",
   label: "Zeil am Main (DEZEI)"
  },
  {
   value: "Zell (DEZEL)",
   label: "Zell (DEZEL)"
  },
  {
   value: "Zell am Harmersbach (DEZEH)",
   label: "Zell am Harmersbach (DEZEH)"
  },
  {
   value: "Zell unter Aichelberg (DEZAG)",
   label: "Zell unter Aichelberg (DEZAG)"
  },
  {
   value: "Zell\/Wiesental (DEZEW)",
   label: "Zell\/Wiesental (DEZEW)"
  },
  {
   value: "Zellingen (DEZEN)",
   label: "Zellingen (DEZEN)"
  },
  {
   value: "Zeltingen-Rachtig (DEZLT)",
   label: "Zeltingen-Rachtig (DEZLT)"
  },
  {
   value: "Zernsdorf (DEZER)",
   label: "Zernsdorf (DEZER)"
  },
  {
   value: "Zetel (DEZET)",
   label: "Zetel (DEZET)"
  },
  {
   value: "Zeulenroda (DEZEU)",
   label: "Zeulenroda (DEZEU)"
  },
  {
   value: "Zeven (DEZEV)",
   label: "Zeven (DEZEV)"
  },
  {
   value: "Zinnwald (DEZNW)",
   label: "Zinnwald (DEZNW)"
  },
  {
   value: "Zirndorf (DEZIR)",
   label: "Zirndorf (DEZIR)"
  },
  {
   value: "Zittau (DEZIT)",
   label: "Zittau (DEZIT)"
  },
  {
   value: "Zülpich (DEZUE)",
   label: "Zülpich (DEZUE)"
  },
  {
   value: "Zweibrücken (DEZWE)",
   label: "Zweibrücken (DEZWE)"
  },
  {
   value: "Zwickau (DEZWI)",
   label: "Zwickau (DEZWI)"
  },
  {
   value: "Zwiesel (DEZWL)",
   label: "Zwiesel (DEZWL)"
  },
  {
   value: "ALLERSBERG (DEARB)",
   label: "ALLERSBERG (DEARB)"
  },
  {
   value: "ALTDORF (DEADF)",
   label: "ALTDORF (DEADF)"
  },
  {
   value: "ALTENSTEIG (DEASG)",
   label: "ALTENSTEIG (DEASG)"
  },
  {
   value: "BENDORF (DEBDF)",
   label: "BENDORF (DEBDF)"
  },
  {
   value: "EGINGAM (DEEAS)",
   label: "EGINGAM (DEEAS)"
  },
  {
   value: "GILCHING (DEGCG)",
   label: "GILCHING (DEGCG)"
  },
  {
   value: "Wildeshausen (DEWHU)",
   label: "Wildeshausen (DEWHU)"
  },
  {
   value: "Wildflecken (DEWFK)",
   label: "Wildflecken (DEWFK)"
  },
  {
   value: "Wilhelmshaven (DEWVN)",
   label: "Wilhelmshaven (DEWVN)"
  },
  {
   value: "Wilhermsdorf (DEWHF)",
   label: "Wilhermsdorf (DEWHF)"
  },
  {
   value: "Willich (DEWCH)",
   label: "Willich (DEWCH)"
  },
  {
   value: "Willingen (DEWLL)",
   label: "Willingen (DEWLL)"
  },
  {
   value: "Willstätt (DEWST)",
   label: "Willstätt (DEWST)"
  },
  {
   value: "Wilnsdorf (DEWNR)",
   label: "Wilnsdorf (DEWNR)"
  },
  {
   value: "Wilster (DEWIL)",
   label: "Wilster (DEWIL)"
  },
  {
   value: "Wimmer (DEWIM)",
   label: "Wimmer (DEWIM)"
  },
  {
   value: "Windeck (DEWNK)",
   label: "Windeck (DEWNK)"
  },
  {
   value: "Windhagen (DEWHG)",
   label: "Windhagen (DEWHG)"
  },
  {
   value: "Windischeschenbach (DEWDH)",
   label: "Windischeschenbach (DEWDH)"
  },
  {
   value: "Winnenden (DEWIX)",
   label: "Winnenden (DEWIX)"
  },
  {
   value: "Winsen\/Luhe (DEWIN)",
   label: "Winsen\/Luhe (DEWIN)"
  },
  {
   value: "Winterberg (DEWIG)",
   label: "Winterberg (DEWIG)"
  },
  {
   value: "Wipperfürth (DEWPH)",
   label: "Wipperfürth (DEWPH)"
  },
  {
   value: "Wirges (DEWIR)",
   label: "Wirges (DEWIR)"
  },
  {
   value: "Wirsberg (DEWSG)",
   label: "Wirsberg (DEWSG)"
  },
  {
   value: "Wisch (DEWIH)",
   label: "Wisch (DEWIH)"
  },
  {
   value: "Wischhafen (DEWIF)",
   label: "Wischhafen (DEWIF)"
  },
  {
   value: "Wismar (DEWIS)",
   label: "Wismar (DEWIS)"
  },
  {
   value: "Wissen (DEWSN)",
   label: "Wissen (DEWSN)"
  },
  {
   value: "Witten (DEWTT)",
   label: "Witten (DEWTT)"
  },
  {
   value: "Wittenberg (DEWTG)",
   label: "Wittenberg (DEWTG)"
  },
  {
   value: "Wittingen (DEWTN)",
   label: "Wittingen (DEWTN)"
  },
  {
   value: "Wittlaer (DEWLA)",
   label: "Wittlaer (DEWLA)"
  },
  {
   value: "Wittlage (DEWIT)",
   label: "Wittlage (DEWIT)"
  },
  {
   value: "Wittlich (DEWTH)",
   label: "Wittlich (DEWTH)"
  },
  {
   value: "Wittmund (DEWMD)",
   label: "Wittmund (DEWMD)"
  },
  {
   value: "Witzhausen (DEWHA)",
   label: "Witzhausen (DEWHA)"
  },
  {
   value: "Woerth (DEWUR)",
   label: "Woerth (DEWUR)"
  },
  {
   value: "Wolfach (DEWDL)",
   label: "Wolfach (DEWDL)"
  },
  {
   value: "Wolfegg (DEWFE)",
   label: "Wolfegg (DEWFE)"
  },
  {
   value: "Wolfenbüttel (DEWBL)",
   label: "Wolfenbüttel (DEWBL)"
  },
  {
   value: "Wolfgang (DEWOF)",
   label: "Wolfgang (DEWOF)"
  },
  {
   value: "Wolfratshausen (DEWOH)",
   label: "Wolfratshausen (DEWOH)"
  },
  {
   value: "Wolfsburg (DEWOB)",
   label: "Wolfsburg (DEWOB)"
  },
  {
   value: "Wolfstein (DEWON)",
   label: "Wolfstein (DEWON)"
  },
  {
   value: "Wolgast (DEWOL)",
   label: "Wolgast (DEWOL)"
  },
  {
   value: "Werdau (DEWDA)",
   label: "Werdau (DEWDA)"
  },
  {
   value: "Werdohl (DEWER)",
   label: "Werdohl (DEWER)"
  },
  {
   value: "Werl (DEWEL)",
   label: "Werl (DEWEL)"
  },
  {
   value: "Werl-Soennern (DEWXS)",
   label: "Werl-Soennern (DEWXS)"
  },
  {
   value: "Werlte (DEWLT)",
   label: "Werlte (DEWLT)"
  },
  {
   value: "Wermelskirchen (DEWEK)",
   label: "Wermelskirchen (DEWEK)"
  },
  {
   value: "Wernau (DEWRU)",
   label: "Wernau (DEWRU)"
  },
  {
   value: "Werne (DEWRE)",
   label: "Werne (DEWRE)"
  },
  {
   value: "Wernigerode (DEWGE)",
   label: "Wernigerode (DEWGE)"
  },
  {
   value: "Wertheim (DEWTM)",
   label: "Wertheim (DEWTM)"
  },
  {
   value: "Wertingen (DEWTE)",
   label: "Wertingen (DEWTE)"
  },
  {
   value: "Wesel (DEWES)",
   label: "Wesel (DEWES)"
  },
  {
   value: "Wesseling (DEWLG)",
   label: "Wesseling (DEWLG)"
  },
  {
   value: "Wessling (DEWSL)",
   label: "Wessling (DEWSL)"
  },
  {
   value: "Westeraccumersiel (DEWAC)",
   label: "Westeraccumersiel (DEWAC)"
  },
  {
   value: "Westerburg\/Westerwaldkreis (DEWBG)",
   label: "Westerburg\/Westerwaldkreis (DEWBG)"
  },
  {
   value: "Westerkappeln (Dupl. WKN) (DEWKP)",
   label: "Westerkappeln (Dupl. WKN) (DEWKP)"
  },
  {
   value: "\"Westerland (DEGWT)",
   label: "\"Westerland (DEGWT)"
  },
  {
   value: "Westerstede (DEWSE)",
   label: "Westerstede (DEWSE)"
  },
  {
   value: "Westhofen (DEWHN)",
   label: "Westhofen (DEWHN)"
  },
  {
   value: "Wetter (DEWTR)",
   label: "Wetter (DEWTR)"
  },
  {
   value: "Wettingen (DEWTI)",
   label: "Wettingen (DEWTI)"
  },
  {
   value: "Wetzlar (DEWET)",
   label: "Wetzlar (DEWET)"
  },
  {
   value: "Wewelsfleth (DEWEW)",
   label: "Wewelsfleth (DEWEW)"
  },
  {
   value: "Wickede (DEWCK)",
   label: "Wickede (DEWCK)"
  },
  {
   value: "Wiedemar (DEWDR)",
   label: "Wiedemar (DEWDR)"
  },
  {
   value: "Wiehl (DEWHL)",
   label: "Wiehl (DEWHL)"
  },
  {
   value: "Wiek (DEWIK)",
   label: "Wiek (DEWIK)"
  },
  {
   value: "Wielen (DEWLN)",
   label: "Wielen (DEWLN)"
  },
  {
   value: "Wieren (DEWIZ)",
   label: "Wieren (DEWIZ)"
  },
  {
   value: "Wiernsheim (DEWRM)",
   label: "Wiernsheim (DEWRM)"
  },
  {
   value: "Wiesbaden (DEWIB)",
   label: "Wiesbaden (DEWIB)"
  },
  {
   value: "Wiesens (DEWIE)",
   label: "Wiesens (DEWIE)"
  },
  {
   value: "Wiesentheid (DEWHD)",
   label: "Wiesentheid (DEWHD)"
  },
  {
   value: "Wiesloch (DEWSY)",
   label: "Wiesloch (DEWSY)"
  },
  {
   value: "Wiesmoor (DEWMO)",
   label: "Wiesmoor (DEWMO)"
  },
  {
   value: "Wietmarschen (DEWHI)",
   label: "Wietmarschen (DEWHI)"
  },
  {
   value: "Wiettinhausen (DEWHS)",
   label: "Wiettinhausen (DEWHS)"
  },
  {
   value: "Wildberg (DEWDB)",
   label: "Wildberg (DEWDB)"
  },
  {
   value: "Wildenrath (DEWID)",
   label: "Wildenrath (DEWID)"
  },
  {
   value: "Wassertrüdingen (DEWTD)",
   label: "Wassertrüdingen (DEWTD)"
  },
  {
   value: "Wattenheim (DEWHE)",
   label: "Wattenheim (DEWHE)"
  },
  {
   value: "Wedel (DEWED)",
   label: "Wedel (DEWED)"
  },
  {
   value: "Wedemark (DEWDE)",
   label: "Wedemark (DEWDE)"
  },
  {
   value: "Weener (DEWEE)",
   label: "Weener (DEWEE)"
  },
  {
   value: "Wegberg (DEWGG)",
   label: "Wegberg (DEWGG)"
  },
  {
   value: "Wehrheim (DEWRH)",
   label: "Wehrheim (DEWRH)"
  },
  {
   value: "Weiden (DEWEZ)",
   label: "Weiden (DEWEZ)"
  },
  {
   value: "Weiden in der Oberpfalz (DEWEI)",
   label: "Weiden in der Oberpfalz (DEWEI)"
  },
  {
   value: "Weidenberg (DEWIW)",
   label: "Weidenberg (DEWIW)"
  },
  {
   value: "Weiherhammer (DEWHH)",
   label: "Weiherhammer (DEWHH)"
  },
  {
   value: "Weil am Rhein (DEWLR)",
   label: "Weil am Rhein (DEWLR)"
  },
  {
   value: "Weil der Stadt (DEWDS)",
   label: "Weil der Stadt (DEWDS)"
  },
  {
   value: "Weil im Schönbuch (DEWSH)",
   label: "Weil im Schönbuch (DEWSH)"
  },
  {
   value: "Weilburg (DEWEG)",
   label: "Weilburg (DEWEG)"
  },
  {
   value: "Weilerbach (DEWRB)",
   label: "Weilerbach (DEWRB)"
  },
  {
   value: "Weilheim (DEWEM)",
   label: "Weilheim (DEWEM)"
  },
  {
   value: "Weilheim an der Teck (DEWLH)",
   label: "Weilheim an der Teck (DEWLH)"
  },
  {
   value: "Weilrod (DEWRD)",
   label: "Weilrod (DEWRD)"
  },
  {
   value: "Weimar (DEWMR)",
   label: "Weimar (DEWMR)"
  },
  {
   value: "Weimar\/Giessen (DEWMA)",
   label: "Weimar\/Giessen (DEWMA)"
  },
  {
   value: "Weingarten (DEWGA)",
   label: "Weingarten (DEWGA)"
  },
  {
   value: "Weinheim (DEWHM)",
   label: "Weinheim (DEWHM)"
  },
  {
   value: "Weinsberg (DEWSB)",
   label: "Weinsberg (DEWSB)"
  },
  {
   value: "Weisenbach (DEWEH)",
   label: "Weisenbach (DEWEH)"
  },
  {
   value: "Weiskirchen (DEWKN)",
   label: "Weiskirchen (DEWKN)"
  },
  {
   value: "Weissach (DEWSC)",
   label: "Weissach (DEWSC)"
  },
  {
   value: "Weissandt-Gölzau (DEWGU)",
   label: "Weissandt-Gölzau (DEWGU)"
  },
  {
   value: "Weissbach (DEWSA)",
   label: "Weissbach (DEWSA)"
  },
  {
   value: "Weissenborn (DEWBN)",
   label: "Weissenborn (DEWBN)"
  },
  {
   value: "Weissenburg (DEWBU)",
   label: "Weissenburg (DEWBU)"
  },
  {
   value: "Weissenfels (DEWEF)",
   label: "Weissenfels (DEWEF)"
  },
  {
   value: "Weissensee\/Berlin (DEWNB)",
   label: "Weissensee\/Berlin (DEWNB)"
  },
  {
   value: "Weisswasser (DEWWS)",
   label: "Weisswasser (DEWWS)"
  },
  {
   value: "Weiterstadt (DEWDT)",
   label: "Weiterstadt (DEWDT)"
  },
  {
   value: "Welzheim (DEWZM)",
   label: "Welzheim (DEWZM)"
  },
  {
   value: "Wembach (DEWBC)",
   label: "Wembach (DEWBC)"
  },
  {
   value: "Wendlingen (DEWNN)",
   label: "Wendlingen (DEWNN)"
  },
  {
   value: "\"Wenningstedt (DEWEN)",
   label: "\"Wenningstedt (DEWEN)"
  },
  {
   value: "Wächtersbach (DEWAE)",
   label: "Wächtersbach (DEWAE)"
  },
  {
   value: "Wackernheim (DEWNM)",
   label: "Wackernheim (DEWNM)"
  },
  {
   value: "Wackersdorf (DEWKD)",
   label: "Wackersdorf (DEWKD)"
  },
  {
   value: "Wadern (DEWND)",
   label: "Wadern (DEWND)"
  },
  {
   value: "Wadersloh (DEWLO)",
   label: "Wadersloh (DEWLO)"
  },
  {
   value: "Wagenfeld (DEWGF)",
   label: "Wagenfeld (DEWGF)"
  },
  {
   value: "Waghäusel (DEWGL)",
   label: "Waghäusel (DEWGL)"
  },
  {
   value: "Waging am See (DEWGS)",
   label: "Waging am See (DEWGS)"
  },
  {
   value: "Wahlstedt (DEWAH)",
   label: "Wahlstedt (DEWAH)"
  },
  {
   value: "Waiblingen (DEWAI)",
   label: "Waiblingen (DEWAI)"
  },
  {
   value: "Waibstadt (DEWBD)",
   label: "Waibstadt (DEWBD)"
  },
  {
   value: "Wald-Michelbach (DEWMI)",
   label: "Wald-Michelbach (DEWMI)"
  },
  {
   value: "Waldachtal (DEWTL)",
   label: "Waldachtal (DEWTL)"
  },
  {
   value: "Waldbröl (DEWAB)",
   label: "Waldbröl (DEWAB)"
  },
  {
   value: "Waldeck (DEWDK)",
   label: "Waldeck (DEWDK)"
  },
  {
   value: "Waldenbuch (DEWBH)",
   label: "Waldenbuch (DEWBH)"
  },
  {
   value: "Waldfischbach-Burgalben (dpl) (DEWFB)",
   label: "Waldfischbach-Burgalben (dpl) (DEWFB)"
  },
  {
   value: "Waldheim (DEWAM)",
   label: "Waldheim (DEWAM)"
  },
  {
   value: "Waldkraiburg (DEWKG)",
   label: "Waldkraiburg (DEWKG)"
  },
  {
   value: "Waldsassen (DEWSS)",
   label: "Waldsassen (DEWSS)"
  },
  {
   value: "Waldshut-Tiengen (DEWAT)",
   label: "Waldshut-Tiengen (DEWAT)"
  },
  {
   value: "Walkenried (DEWLD)",
   label: "Walkenried (DEWLD)"
  },
  {
   value: "Wallau (DEWAU)",
   label: "Wallau (DEWAU)"
  },
  {
   value: "Walldorf (DEWDF)",
   label: "Walldorf (DEWDF)"
  },
  {
   value: "Walldürn (DEWRN)",
   label: "Walldürn (DEWRN)"
  },
  {
   value: "Wallscheid (DEWSD)",
   label: "Wallscheid (DEWSD)"
  },
  {
   value: "Walluf (DEWUF)",
   label: "Walluf (DEWUF)"
  },
  {
   value: "Walsrode (DEWAL)",
   label: "Walsrode (DEWAL)"
  },
  {
   value: "Walsum (DEWLM)",
   label: "Walsum (DEWLM)"
  },
  {
   value: "Wangen im Allgäu (DEWGN)",
   label: "Wangen im Allgäu (DEWGN)"
  },
  {
   value: "Wangerooge (DEAGE)",
   label: "Wangerooge (DEAGE)"
  },
  {
   value: "Warburg (DEWAG)",
   label: "Warburg (DEWAG)"
  },
  {
   value: "Waren (DEWRZ)",
   label: "Waren (DEWRZ)"
  },
  {
   value: "Warendorf (DEWAD)",
   label: "Warendorf (DEWAD)"
  },
  {
   value: "Warnemünde (DEWAR)",
   label: "Warnemünde (DEWAR)"
  },
  {
   value: "Warstein (DEWAN)",
   label: "Warstein (DEWAN)"
  },
  {
   value: "Wartenberg (DEWRT)",
   label: "Wartenberg (DEWRT)"
  },
  {
   value: "Wasserburg\/Inn (DEWAS)",
   label: "Wasserburg\/Inn (DEWAS)"
  },
  {
   value: "Unterelchingen (DEUNT)",
   label: "Unterelchingen (DEUNT)"
  },
  {
   value: "Unterensingen (DEURG)",
   label: "Unterensingen (DEURG)"
  },
  {
   value: "Unterföhring (DEUAA)",
   label: "Unterföhring (DEUAA)"
  },
  {
   value: "Unterkochen (DEUNK)",
   label: "Unterkochen (DEUNK)"
  },
  {
   value: "Untermeitingen (DEUNR)",
   label: "Untermeitingen (DEUNR)"
  },
  {
   value: "Unterschleissheim (DEUSL)",
   label: "Unterschleissheim (DEUSL)"
  },
  {
   value: "Untersiemau (DEUSM)",
   label: "Untersiemau (DEUSM)"
  },
  {
   value: "Unterwellenborn (DEUBE)",
   label: "Unterwellenborn (DEUBE)"
  },
  {
   value: "Upschört (DEUPS)",
   label: "Upschört (DEUPS)"
  },
  {
   value: "Ursensollen (DEUSN)",
   label: "Ursensollen (DEUSN)"
  },
  {
   value: "Ürzig (DEUER)",
   label: "Ürzig (DEUER)"
  },
  {
   value: "Usingen (DEUSG)",
   label: "Usingen (DEUSG)"
  },
  {
   value: "Utting (DEUTG)",
   label: "Utting (DEUTG)"
  },
  {
   value: "Vacha (DEVAC)",
   label: "Vacha (DEVAC)"
  },
  {
   value: "Vaihingen an der Enz (DEVAI)",
   label: "Vaihingen an der Enz (DEVAI)"
  },
  {
   value: "Valwig (DEVAL)",
   label: "Valwig (DEVAL)"
  },
  {
   value: "Varel (DEVAR)",
   label: "Varel (DEVAR)"
  },
  {
   value: "Vechta (DEVEC)",
   label: "Vechta (DEVEC)"
  },
  {
   value: "Velbert (DEVEL)",
   label: "Velbert (DEVEL)"
  },
  {
   value: "Velden (DEVLE)",
   label: "Velden (DEVLE)"
  },
  {
   value: "Velen (DEVLN)",
   label: "Velen (DEVLN)"
  },
  {
   value: "Venne (DEVEN)",
   label: "Venne (DEVEN)"
  },
  {
   value: "Verden (DEVER)",
   label: "Verden (DEVER)"
  },
  {
   value: "Verl (DEVRL)",
   label: "Verl (DEVRL)"
  },
  {
   value: "Versmold (DEVED)",
   label: "Versmold (DEVED)"
  },
  {
   value: "Vestenbergsreuth (DEVES)",
   label: "Vestenbergsreuth (DEVES)"
  },
  {
   value: "Vielbrunn (DEVBM)",
   label: "Vielbrunn (DEVBM)"
  },
  {
   value: "Viernheim (DEVIM)",
   label: "Viernheim (DEVIM)"
  },
  {
   value: "Vierraden (DEVIR)",
   label: "Vierraden (DEVIR)"
  },
  {
   value: "Viersen (DEVIE)",
   label: "Viersen (DEVIE)"
  },
  {
   value: "Villingen-Schwenningen (DEVIS)",
   label: "Villingen-Schwenningen (DEVIS)"
  },
  {
   value: "Vilseck (DEVIL)",
   label: "Vilseck (DEVIL)"
  },
  {
   value: "Visselhövede (DEVVD)",
   label: "Visselhövede (DEVVD)"
  },
  {
   value: "Vlotho (DEVLO)",
   label: "Vlotho (DEVLO)"
  },
  {
   value: "Voerde (DEVRD)",
   label: "Voerde (DEVRD)"
  },
  {
   value: "Vöhringen (DEVON)",
   label: "Vöhringen (DEVON)"
  },
  {
   value: "Volkenschwand (DEVSW)",
   label: "Volkenschwand (DEVSW)"
  },
  {
   value: "Volkertshausen (DEVKH)",
   label: "Volkertshausen (DEVKH)"
  },
  {
   value: "Völklingen (DEVOE)",
   label: "Völklingen (DEVOE)"
  },
  {
   value: "Vreden (DEVRE)",
   label: "Vreden (DEVRE)"
  },
  {
   value: "Titting (DETTT)",
   label: "Titting (DETTT)"
  },
  {
   value: "Tittmoning (DETIT)",
   label: "Tittmoning (DETIT)"
  },
  {
   value: "Todendorf (DETDF)",
   label: "Todendorf (DETDF)"
  },
  {
   value: "Todtnau (DETOD)",
   label: "Todtnau (DETOD)"
  },
  {
   value: "Tonistvorst (DETVT)",
   label: "Tonistvorst (DETVT)"
  },
  {
   value: "Tönning (DETOE)",
   label: "Tönning (DETOE)"
  },
  {
   value: "Torfmoorholm (DETMH)",
   label: "Torfmoorholm (DETMH)"
  },
  {
   value: "Torgau (DETOU)",
   label: "Torgau (DETOU)"
  },
  {
   value: "Torgelow (DETGW)",
   label: "Torgelow (DETGW)"
  },
  {
   value: "Tossens (DETOS)",
   label: "Tossens (DETOS)"
  },
  {
   value: "Traben-Trarbach (DETRT)",
   label: "Traben-Trarbach (DETRT)"
  },
  {
   value: "Trabitz (DETRB)",
   label: "Trabitz (DETRB)"
  },
  {
   value: "Traunreut (DETRR)",
   label: "Traunreut (DETRR)"
  },
  {
   value: "Traunstein (DETRA)",
   label: "Traunstein (DETRA)"
  },
  {
   value: "Travemünde (DETRV)",
   label: "Travemünde (DETRV)"
  },
  {
   value: "Trebur (DETBR)",
   label: "Trebur (DETBR)"
  },
  {
   value: "Treuchtlingen (DETRE)",
   label: "Treuchtlingen (DETRE)"
  },
  {
   value: "Triberg (DETRG)",
   label: "Triberg (DETRG)"
  },
  {
   value: "Trier (DETRI)",
   label: "Trier (DETRI)"
  },
  {
   value: "Triptis (DETPT)",
   label: "Triptis (DETPT)"
  },
  {
   value: "Trittau (DETRU)",
   label: "Trittau (DETRU)"
  },
  {
   value: "Troisdorf (DETRO)",
   label: "Troisdorf (DETRO)"
  },
  {
   value: "Trossingen (DETRN)",
   label: "Trossingen (DETRN)"
  },
  {
   value: "Trostberg (DETBG)",
   label: "Trostberg (DETBG)"
  },
  {
   value: "Tübingen (DETUE)",
   label: "Tübingen (DETUE)"
  },
  {
   value: "Türkheim (DETUM)",
   label: "Türkheim (DETUM)"
  },
  {
   value: "Tussenhausen (DETUS)",
   label: "Tussenhausen (DETUS)"
  },
  {
   value: "Tuttlingen (DETUT)",
   label: "Tuttlingen (DETUT)"
  },
  {
   value: "Twist (DETWI)",
   label: "Twist (DETWI)"
  },
  {
   value: "Überherrn (DEUEN)",
   label: "Überherrn (DEUEN)"
  },
  {
   value: "Überlingen (DEUEB)",
   label: "Überlingen (DEUEB)"
  },
  {
   value: "Ubstadt Weiher (DEUBW)",
   label: "Ubstadt Weiher (DEUBW)"
  },
  {
   value: "Ückermünde (DEUCK)",
   label: "Ückermünde (DEUCK)"
  },
  {
   value: "Uedem (DEUED)",
   label: "Uedem (DEUED)"
  },
  {
   value: "Uelzen (DEUEL)",
   label: "Uelzen (DEUEL)"
  },
  {
   value: "Uetersen (DEUET)",
   label: "Uetersen (DEUET)"
  },
  {
   value: "Uffenheim (DEUFF)",
   label: "Uffenheim (DEUFF)"
  },
  {
   value: "Uhingen (DEUHI)",
   label: "Uhingen (DEUHI)"
  },
  {
   value: "Ulm (DEULM)",
   label: "Ulm (DEULM)"
  },
  {
   value: "Ulsar (DEULR)",
   label: "Ulsar (DEULR)"
  },
  {
   value: "Unna (DEUNN)",
   label: "Unna (DEUNN)"
  },
  {
   value: "Stürtzelberg (DESUE)",
   label: "Stürtzelberg (DESUE)"
  },
  {
   value: "Stutensee (DESSE)",
   label: "Stutensee (DESSE)"
  },
  {
   value: "Stuttgart (DESTR)",
   label: "Stuttgart (DESTR)"
  },
  {
   value: "Süderstapel (DESUD)",
   label: "Süderstapel (DESUD)"
  },
  {
   value: "Südlohn (DESDL)",
   label: "Südlohn (DESDL)"
  },
  {
   value: "Suessen (DESUS)",
   label: "Suessen (DESUS)"
  },
  {
   value: "Suhl (DESUL)",
   label: "Suhl (DESUL)"
  },
  {
   value: "Sulingen (DESUN)",
   label: "Sulingen (DESUN)"
  },
  {
   value: "Sulzach (DESUH)",
   label: "Sulzach (DESUH)"
  },
  {
   value: "Sulzbach (DESUZ)",
   label: "Sulzbach (DESUZ)"
  },
  {
   value: "Sulzbach-Rosenberg (DESRO)",
   label: "Sulzbach-Rosenberg (DESRO)"
  },
  {
   value: "Sundern (DESER)",
   label: "Sundern (DESER)"
  },
  {
   value: "Sundern\/Hochsauerlandkreis (DESNN)",
   label: "Sundern\/Hochsauerlandkreis (DESNN)"
  },
  {
   value: "Surwold (DESUR)",
   label: "Surwold (DESUR)"
  },
  {
   value: "Swisttal (DESWA)",
   label: "Swisttal (DESWA)"
  },
  {
   value: "Tacherting (DETTG)",
   label: "Tacherting (DETTG)"
  },
  {
   value: "Talheim (DETLH)",
   label: "Talheim (DETLH)"
  },
  {
   value: "Tamm (DETAM)",
   label: "Tamm (DETAM)"
  },
  {
   value: "Tangermünde (DETAE)",
   label: "Tangermünde (DETAE)"
  },
  {
   value: "Tannenbergsthal (DETAB)",
   label: "Tannenbergsthal (DETAB)"
  },
  {
   value: "Tantow (DETAN)",
   label: "Tantow (DETAN)"
  },
  {
   value: "Tauberbischofsheim (DETAU)",
   label: "Tauberbischofsheim (DETAU)"
  },
  {
   value: "Taufkirchen (DETKH)",
   label: "Taufkirchen (DETKH)"
  },
  {
   value: "Taunusstein (DETSN)",
   label: "Taunusstein (DETSN)"
  },
  {
   value: "Tegernsee (DETEG)",
   label: "Tegernsee (DETEG)"
  },
  {
   value: "Teningen (DETGN)",
   label: "Teningen (DETGN)"
  },
  {
   value: "Tettau (DETEU)",
   label: "Tettau (DETEU)"
  },
  {
   value: "Tettnang (DETET)",
   label: "Tettnang (DETET)"
  },
  {
   value: "Thal (DETHL)",
   label: "Thal (DETHL)"
  },
  {
   value: "Thale (DETHA)",
   label: "Thale (DETHA)"
  },
  {
   value: "Thaleischweiler-Fröschen (DETFR)",
   label: "Thaleischweiler-Fröschen (DETFR)"
  },
  {
   value: "Thalfang (DETHG)",
   label: "Thalfang (DETHG)"
  },
  {
   value: "Thalheim\/Erzgebirge (DETHM)",
   label: "Thalheim\/Erzgebirge (DETHM)"
  },
  {
   value: "Thüngen (DETHN)",
   label: "Thüngen (DETHN)"
  },
  {
   value: "Tiefenbach (DETCV)",
   label: "Tiefenbach (DETCV)"
  },
  {
   value: "Tiefensee (DETIE)",
   label: "Tiefensee (DETIE)"
  },
  {
   value: "Tinnum\/Sylt (DETIN)",
   label: "Tinnum\/Sylt (DETIN)"
  },
  {
   value: "Titisee-Neustadt (DETNE)",
   label: "Titisee-Neustadt (DETNE)"
  },
  {
   value: "Staffelstein (DESFF)",
   label: "Staffelstein (DESFF)"
  },
  {
   value: "Starnberg (DESTN)",
   label: "Starnberg (DESTN)"
  },
  {
   value: "Stassfurt (DESTF)",
   label: "Stassfurt (DESTF)"
  },
  {
   value: "Staufen (DESUF)",
   label: "Staufen (DESUF)"
  },
  {
   value: "Staufen im Breisgau (DESBR)",
   label: "Staufen im Breisgau (DESBR)"
  },
  {
   value: "Steenodde (DESDD)",
   label: "Steenodde (DESDD)"
  },
  {
   value: "Steigra (DESGA)",
   label: "Steigra (DESGA)"
  },
  {
   value: "Stein (DESTZ)",
   label: "Stein (DESTZ)"
  },
  {
   value: "Steinau (DESNU)",
   label: "Steinau (DESNU)"
  },
  {
   value: "Steinbach\/Hochtaunuskreis (DESTE)",
   label: "Steinbach\/Hochtaunuskreis (DESTE)"
  },
  {
   value: "Steinen (DESEI)",
   label: "Steinen (DESEI)"
  },
  {
   value: "Steinenbronn (DESBO)",
   label: "Steinenbronn (DESBO)"
  },
  {
   value: "Steinfeld (DESNF)",
   label: "Steinfeld (DESNF)"
  },
  {
   value: "Steinfurt (DESTT)",
   label: "Steinfurt (DESTT)"
  },
  {
   value: "Steinhagen (DESGN)",
   label: "Steinhagen (DESGN)"
  },
  {
   value: "Steinheid (DESHD)",
   label: "Steinheid (DESHD)"
  },
  {
   value: "Steinheim (DESTM)",
   label: "Steinheim (DESTM)"
  },
  {
   value: "Stelle (DESLL)",
   label: "Stelle (DESLL)"
  },
  {
   value: "Stemwede (DESMW)",
   label: "Stemwede (DESMW)"
  },
  {
   value: "Stephansposching (DESSP)",
   label: "Stephansposching (DESSP)"
  },
  {
   value: "Steyerberg (DESTY)",
   label: "Steyerberg (DESTY)"
  },
  {
   value: "Stockach (DESKH)",
   label: "Stockach (DESKH)"
  },
  {
   value: "Stockelsdorf (DESKF)",
   label: "Stockelsdorf (DESKF)"
  },
  {
   value: "Stockstadt (DESTC)",
   label: "Stockstadt (DESTC)"
  },
  {
   value: "Stolberg (DESTG)",
   label: "Stolberg (DESTG)"
  },
  {
   value: "Stolberg\/Harz (DESTO)",
   label: "Stolberg\/Harz (DESTO)"
  },
  {
   value: "Stolpen (DESTP)",
   label: "Stolpen (DESTP)"
  },
  {
   value: "Stolzenau (DESLJ)",
   label: "Stolzenau (DESLJ)"
  },
  {
   value: "Straelen (DESRN)",
   label: "Straelen (DESRN)"
  },
  {
   value: "Stralsund (DESTL)",
   label: "Stralsund (DESTL)"
  },
  {
   value: "Strande (DESTD)",
   label: "Strande (DESTD)"
  },
  {
   value: "Straubenhardt (DESHR)",
   label: "Straubenhardt (DESHR)"
  },
  {
   value: "Straubing (DESTB)",
   label: "Straubing (DESTB)"
  },
  {
   value: "Streithausen (DESRT)",
   label: "Streithausen (DESRT)"
  },
  {
   value: "Strullendorf (DESLF)",
   label: "Strullendorf (DESLF)"
  },
  {
   value: "Stuehlingen (DESHG)",
   label: "Stuehlingen (DESHG)"
  },
  {
   value: "Stuhr (DESTU)",
   label: "Stuhr (DESTU)"
  },
  {
   value: "Sobernheim (DESBM)",
   label: "Sobernheim (DESBM)"
  },
  {
   value: "Soest (DESOE)",
   label: "Soest (DESOE)"
  },
  {
   value: "Sögel (DESOG)",
   label: "Sögel (DESOG)"
  },
  {
   value: "Sohren (DESOH)",
   label: "Sohren (DESOH)"
  },
  {
   value: "Solingen (DESOL)",
   label: "Solingen (DESOL)"
  },
  {
   value: "Solms (DESOS)",
   label: "Solms (DESOS)"
  },
  {
   value: "Solnhofen (DESHF)",
   label: "Solnhofen (DESHF)"
  },
  {
   value: "Soltau (DESOU)",
   label: "Soltau (DESOU)"
  },
  {
   value: "Sonneberg (DESON)",
   label: "Sonneberg (DESON)"
  },
  {
   value: "Sonnenfeld (DESOD)",
   label: "Sonnenfeld (DESOD)"
  },
  {
   value: "Sonsbeck (DESOK)",
   label: "Sonsbeck (DESOK)"
  },
  {
   value: "Sontheim\/Brenz (DESNM)",
   label: "Sontheim\/Brenz (DESNM)"
  },
  {
   value: "Sonthofen (DESFN)",
   label: "Sonthofen (DESFN)"
  },
  {
   value: "Sottrum (DESGF)",
   label: "Sottrum (DESGF)"
  },
  {
   value: "Spangdahlem (DESPM)",
   label: "Spangdahlem (DESPM)"
  },
  {
   value: "Spechtsbrunn (DESPC)",
   label: "Spechtsbrunn (DESPC)"
  },
  {
   value: "Speichersdorf (DESPF)",
   label: "Speichersdorf (DESPF)"
  },
  {
   value: "Spelle (DESLE)",
   label: "Spelle (DESLE)"
  },
  {
   value: "Spenge (DESPG)",
   label: "Spenge (DESPG)"
  },
  {
   value: "Speyer (DESPE)",
   label: "Speyer (DESPE)"
  },
  {
   value: "Spieckeroog I. (DESPI)",
   label: "Spieckeroog I. (DESPI)"
  },
  {
   value: "Spiegelau (DESPU)",
   label: "Spiegelau (DESPU)"
  },
  {
   value: "Spremberg (DESMB)",
   label: "Spremberg (DESMB)"
  },
  {
   value: "Sprendlingen (DESPR)",
   label: "Sprendlingen (DESPR)"
  },
  {
   value: "Springe (DESRE)",
   label: "Springe (DESRE)"
  },
  {
   value: "Sprockhövel (DESPO)",
   label: "Sprockhövel (DESPO)"
  },
  {
   value: "St Aldegund (DESAE)",
   label: "St Aldegund (DESAE)"
  },
  {
   value: "St Ingbert (DESTI)",
   label: "St Ingbert (DESTI)"
  },
  {
   value: "St Johann (DESJO)",
   label: "St Johann (DESJO)"
  },
  {
   value: "St Katharinen (DESTK)",
   label: "St Katharinen (DESTK)"
  },
  {
   value: "St Margarethen (DESMA)",
   label: "St Margarethen (DESMA)"
  },
  {
   value: "St Michaelisdonn (DESMI)",
   label: "St Michaelisdonn (DESMI)"
  },
  {
   value: "St Peter (DEPSH)",
   label: "St Peter (DEPSH)"
  },
  {
   value: "St Wendel (DESWE)",
   label: "St Wendel (DESWE)"
  },
  {
   value: "Stade (DESTA)",
   label: "Stade (DESTA)"
  },
  {
   value: "Stadersand (DESTS)",
   label: "Stadersand (DESTS)"
  },
  {
   value: "Stadt Allendorf (DESAL)",
   label: "Stadt Allendorf (DESAL)"
  },
  {
   value: "Stadtbergen (DESDG)",
   label: "Stadtbergen (DESDG)"
  },
  {
   value: "Stadthagen (DESTH)",
   label: "Stadthagen (DESTH)"
  },
  {
   value: "Stadtlohn (DESLO)",
   label: "Stadtlohn (DESLO)"
  },
  {
   value: "Schwedt (DESDT)",
   label: "Schwedt (DESDT)"
  },
  {
   value: "Schweich (DESWH)",
   label: "Schweich (DESWH)"
  },
  {
   value: "Schweinfurt (DESCW)",
   label: "Schweinfurt (DESCW)"
  },
  {
   value: "Schwelm (DESLM)",
   label: "Schwelm (DESLM)"
  },
  {
   value: "Schwenningen (DESWN)",
   label: "Schwenningen (DESWN)"
  },
  {
   value: "Schwerin (DESWR)",
   label: "Schwerin (DESWR)"
  },
  {
   value: "Schweringen (DESRI)",
   label: "Schweringen (DESRI)"
  },
  {
   value: "Schwerte (DESCE)",
   label: "Schwerte (DESCE)"
  },
  {
   value: "Schwetzingen (DESCH)",
   label: "Schwetzingen (DESCH)"
  },
  {
   value: "Schwieberdingen (DESWI)",
   label: "Schwieberdingen (DESWI)"
  },
  {
   value: "Sedelsberg (DESBG)",
   label: "Sedelsberg (DESBG)"
  },
  {
   value: "Seeg (DESEG)",
   label: "Seeg (DESEG)"
  },
  {
   value: "Seeheim-Jugenheim (DESHE)",
   label: "Seeheim-Jugenheim (DESHE)"
  },
  {
   value: "Seelze (DESZE)",
   label: "Seelze (DESZE)"
  },
  {
   value: "Seesen (DESEE)",
   label: "Seesen (DESEE)"
  },
  {
   value: "Seevetal (DESVL)",
   label: "Seevetal (DESVL)"
  },
  {
   value: "Sehestadt\/Eider (DESEH)",
   label: "Sehestadt\/Eider (DESEH)"
  },
  {
   value: "Sehnde (DESNE)",
   label: "Sehnde (DESNE)"
  },
  {
   value: "Selingenstadt (DESIS)",
   label: "Selingenstadt (DESIS)"
  },
  {
   value: "Selm (DESEM)",
   label: "Selm (DESEM)"
  },
  {
   value: "Selters (DESEL)",
   label: "Selters (DESEL)"
  },
  {
   value: "Sembach (DESEX)",
   label: "Sembach (DESEX)"
  },
  {
   value: "Senden (DESND)",
   label: "Senden (DESND)"
  },
  {
   value: "Sendenhorst (DESEN)",
   label: "Sendenhorst (DESEN)"
  },
  {
   value: "Sessenbach (DESHB)",
   label: "Sessenbach (DESHB)"
  },
  {
   value: "Siegburg (DESIG)",
   label: "Siegburg (DESIG)"
  },
  {
   value: "Siegelbach (DESLB)",
   label: "Siegelbach (DESLB)"
  },
  {
   value: "Siegen (DESGE)",
   label: "Siegen (DESGE)"
  },
  {
   value: "Siegsdorf (DESOF)",
   label: "Siegsdorf (DESOF)"
  },
  {
   value: "Siershahn (DESHN)",
   label: "Siershahn (DESHN)"
  },
  {
   value: "Sigmaringen (DESMG)",
   label: "Sigmaringen (DESMG)"
  },
  {
   value: "Simmerath (DESRH)",
   label: "Simmerath (DESRH)"
  },
  {
   value: "Simmern (DESIM)",
   label: "Simmern (DESIM)"
  },
  {
   value: "Simmertal (DESIL)",
   label: "Simmertal (DESIL)"
  },
  {
   value: "Sindelfingen (DESDN)",
   label: "Sindelfingen (DESDN)"
  },
  {
   value: "Singen (DESNH)",
   label: "Singen (DESNH)"
  },
  {
   value: "Singen (DESIN)",
   label: "Singen (DESIN)"
  },
  {
   value: "Sinsheim (DESIH)",
   label: "Sinsheim (DESIH)"
  },
  {
   value: "Sinzig (DESZG)",
   label: "Sinzig (DESZG)"
  },
  {
   value: "Sirzenich (DESRZ)",
   label: "Sirzenich (DESRZ)"
  },
  {
   value: "Schkeuditz (DESKZ)",
   label: "Schkeuditz (DESKZ)"
  },
  {
   value: "Schkopau (DESKO)",
   label: "Schkopau (DESKO)"
  },
  {
   value: "Schlandern (DESCA)",
   label: "Schlandern (DESCA)"
  },
  {
   value: "Schleswig (DESLS)",
   label: "Schleswig (DESLS)"
  },
  {
   value: "Schloss Holte-Stukenbrock (DESHS)",
   label: "Schloss Holte-Stukenbrock (DESHS)"
  },
  {
   value: "Schlüchtern (DESLN)",
   label: "Schlüchtern (DESLN)"
  },
  {
   value: "Schmallenberg (DESLG)",
   label: "Schmallenberg (DESLG)"
  },
  {
   value: "Schmilka (DESHI)",
   label: "Schmilka (DESHI)"
  },
  {
   value: "Schneverdingen (DESVN)",
   label: "Schneverdingen (DESVN)"
  },
  {
   value: "Schoelln (DESCO)",
   label: "Schoelln (DESCO)"
  },
  {
   value: "Schöllkrippen (DESLK)",
   label: "Schöllkrippen (DESLK)"
  },
  {
   value: "Schönberg (DESCB)",
   label: "Schönberg (DESCB)"
  },
  {
   value: "Schongau (DESGU)",
   label: "Schongau (DESGU)"
  },
  {
   value: "Schopfheim (DESHM)",
   label: "Schopfheim (DESHM)"
  },
  {
   value: "Schopfloch\/Freudenstadt (DESLH)",
   label: "Schopfloch\/Freudenstadt (DESLH)"
  },
  {
   value: "Schorndorf (DESDF)",
   label: "Schorndorf (DESDF)"
  },
  {
   value: "Schotten (DESOT)",
   label: "Schotten (DESOT)"
  },
  {
   value: "Schramberg (DESCG)",
   label: "Schramberg (DESCG)"
  },
  {
   value: "Schriesheim (DESCM)",
   label: "Schriesheim (DESCM)"
  },
  {
   value: "Schrobenhausen (DESBH)",
   label: "Schrobenhausen (DESBH)"
  },
  {
   value: "Schülpersiel (DESPS)",
   label: "Schülpersiel (DESPS)"
  },
  {
   value: "Schüttorf (DESRF)",
   label: "Schüttorf (DESRF)"
  },
  {
   value: "Schwabach (DESWB)",
   label: "Schwabach (DESWB)"
  },
  {
   value: "Schwabhausen (DESBN)",
   label: "Schwabhausen (DESBN)"
  },
  {
   value: "Schwäbisch-Gmünd (DESGD)",
   label: "Schwäbisch-Gmünd (DESGD)"
  },
  {
   value: "Schwäbisch-Hall (DESHL)",
   label: "Schwäbisch-Hall (DESHL)"
  },
  {
   value: "Schwabmünchen (DESMN)",
   label: "Schwabmünchen (DESMN)"
  },
  {
   value: "Schwaig (DESWG)",
   label: "Schwaig (DESWG)"
  },
  {
   value: "Schwaikheim (DESWK)",
   label: "Schwaikheim (DESWK)"
  },
  {
   value: "Schwalbach (DESKV)",
   label: "Schwalbach (DESKV)"
  },
  {
   value: "Schwalmstadt (DESCT)",
   label: "Schwalmstadt (DESCT)"
  },
  {
   value: "Schwalmtal (DESWL)",
   label: "Schwalmtal (DESWL)"
  },
  {
   value: "Schwandorf (DESCF)",
   label: "Schwandorf (DESCF)"
  },
  {
   value: "Schwanewede (DESDA)",
   label: "Schwanewede (DESDA)"
  },
  {
   value: "Schwarzach (DESZH)",
   label: "Schwarzach (DESZH)"
  },
  {
   value: "Schwarzenbach (DESZB)",
   label: "Schwarzenbach (DESZB)"
  },
  {
   value: "Schwarzenfeld (DESWD)",
   label: "Schwarzenfeld (DESWD)"
  },
  {
   value: "Ruenderoth (DERRO)",
   label: "Ruenderoth (DERRO)"
  },
  {
   value: "Ruhpolding (DERUG)",
   label: "Ruhpolding (DERUG)"
  },
  {
   value: "Ruhrort (DEROR)",
   label: "Ruhrort (DEROR)"
  },
  {
   value: "Rümmelsheim (DERUH)",
   label: "Rümmelsheim (DERUH)"
  },
  {
   value: "Runkel (DERUN)",
   label: "Runkel (DERUN)"
  },
  {
   value: "Ruppichteroth (DERUP)",
   label: "Ruppichteroth (DERUP)"
  },
  {
   value: "Rüsselsheim (DERUM)",
   label: "Rüsselsheim (DERUM)"
  },
  {
   value: "Rutesheim (DERTM)",
   label: "Rutesheim (DERTM)"
  },
  {
   value: "Saal an der Donau (DESDO)",
   label: "Saal an der Donau (DESDO)"
  },
  {
   value: "Saal an der Saale (DESVJ)",
   label: "Saal an der Saale (DESVJ)"
  },
  {
   value: "Saalfeld (DESAD)",
   label: "Saalfeld (DESAD)"
  },
  {
   value: "Saarbrücken (DESCN)",
   label: "Saarbrücken (DESCN)"
  },
  {
   value: "Saarburg (DESAG)",
   label: "Saarburg (DESAG)"
  },
  {
   value: "Saarlouis (DESAA)",
   label: "Saarlouis (DESAA)"
  },
  {
   value: "Sachsenheim (DESSN)",
   label: "Sachsenheim (DESSN)"
  },
  {
   value: "Salzgitter (DESAR)",
   label: "Salzgitter (DESAR)"
  },
  {
   value: "Salzkotten (DESZN)",
   label: "Salzkotten (DESZN)"
  },
  {
   value: "Sandbach (DESDB)",
   label: "Sandbach (DESDB)"
  },
  {
   value: "\"Sande (DESDE)",
   label: "\"Sande (DESDE)"
  },
  {
   value: "Sandhausen (DESAN)",
   label: "Sandhausen (DESAN)"
  },
  {
   value: "Sankt Georgen im Schwarzwald (DESGS)",
   label: "Sankt Georgen im Schwarzwald (DESGS)"
  },
  {
   value: "Sarstedt (DESAT)",
   label: "Sarstedt (DESAT)"
  },
  {
   value: "Sassnitz (DESAS)",
   label: "Sassnitz (DESAS)"
  },
  {
   value: "Saterland (DESLD)",
   label: "Saterland (DESLD)"
  },
  {
   value: "Satrup (DESAP)",
   label: "Satrup (DESAP)"
  },
  {
   value: "Sauerlach (DESRL)",
   label: "Sauerlach (DESRL)"
  },
  {
   value: "Saulgau (DESLU)",
   label: "Saulgau (DESLU)"
  },
  {
   value: "Saulheim (DESAH)",
   label: "Saulheim (DESAH)"
  },
  {
   value: "Schacht Audorf (DESAU)",
   label: "Schacht Audorf (DESAU)"
  },
  {
   value: "Schalchern (DESLC)",
   label: "Schalchern (DESLC)"
  },
  {
   value: "Schalksmühle (DESME)",
   label: "Schalksmühle (DESME)"
  },
  {
   value: "Scheinfeld (DESCD)",
   label: "Scheinfeld (DESCD)"
  },
  {
   value: "Schellerfeld (DESFE)",
   label: "Schellerfeld (DESFE)"
  },
  {
   value: "Schenkenzell (DESZL)",
   label: "Schenkenzell (DESZL)"
  },
  {
   value: "Schermbeck (DESCK)",
   label: "Schermbeck (DESCK)"
  },
  {
   value: "Schieder-Schwalenberg (DESSC)",
   label: "Schieder-Schwalenberg (DESSC)"
  },
  {
   value: "Schierling (DESCR)",
   label: "Schierling (DESCR)"
  },
  {
   value: "Schifferstadt (DESFS)",
   label: "Schifferstadt (DESFS)"
  },
  {
   value: "Risenbach (DERIB)",
   label: "Risenbach (DERIB)"
  },
  {
   value: "Ritsch (DERIT)",
   label: "Ritsch (DERIT)"
  },
  {
   value: "Ritterhude (DERTE)",
   label: "Ritterhude (DERTE)"
  },
  {
   value: "Rittershausen (DERTR)",
   label: "Rittershausen (DERTR)"
  },
  {
   value: "Röblingen (DEROE)",
   label: "Röblingen (DEROE)"
  },
  {
   value: "Rockenhausen (DEROH)",
   label: "Rockenhausen (DEROH)"
  },
  {
   value: "Rodach-Redwitz (DERRZ)",
   label: "Rodach-Redwitz (DERRZ)"
  },
  {
   value: "Rodenbach (DEROB)",
   label: "Rodenbach (DEROB)"
  },
  {
   value: "Rodenkirchen (DEROD)",
   label: "Rodenkirchen (DEROD)"
  },
  {
   value: "Rödental (DERTL)",
   label: "Rödental (DERTL)"
  },
  {
   value: "Rödermark (DEROK)",
   label: "Rödermark (DEROK)"
  },
  {
   value: "Rodgau (DEROU)",
   label: "Rodgau (DEROU)"
  },
  {
   value: "Röhrsdorf (DERDR)",
   label: "Röhrsdorf (DERDR)"
  },
  {
   value: "Roigheim (DERGH)",
   label: "Roigheim (DERGH)"
  },
  {
   value: "Römerberg (DEROG)",
   label: "Römerberg (DEROG)"
  },
  {
   value: "Ronneburg (DERON)",
   label: "Ronneburg (DERON)"
  },
  {
   value: "Rosbach (DERSB)",
   label: "Rosbach (DERSB)"
  },
  {
   value: "Rosenberg\/Ostalb (DERSG)",
   label: "Rosenberg\/Ostalb (DERSG)"
  },
  {
   value: "Rosenheim (DEROS)",
   label: "Rosenheim (DEROS)"
  },
  {
   value: "Rossdorf (DERDF)",
   label: "Rossdorf (DERDF)"
  },
  {
   value: "Rossleben (DERLN)",
   label: "Rossleben (DERLN)"
  },
  {
   value: "Rostock (DERSK)",
   label: "Rostock (DERSK)"
  },
  {
   value: "Rotenburg\/Wümme (DEROW)",
   label: "Rotenburg\/Wümme (DEROW)"
  },
  {
   value: "Roth (DERTH)",
   label: "Roth (DERTH)"
  },
  {
   value: "Rothausen (DERUS)",
   label: "Rothausen (DERUS)"
  },
  {
   value: "Röthenbach (DERNB)",
   label: "Röthenbach (DERNB)"
  },
  {
   value: "Röthenbach an der Pegnitz (DEROP)",
   label: "Röthenbach an der Pegnitz (DEROP)"
  },
  {
   value: "Rothenburg (DERTG)",
   label: "Rothenburg (DERTG)"
  },
  {
   value: "Rothenburg ob der Tauber (DEROT)",
   label: "Rothenburg ob der Tauber (DEROT)"
  },
  {
   value: "Rotherbach (DERTB)",
   label: "Rotherbach (DERTB)"
  },
  {
   value: "Rothkreuz (DERTZ)",
   label: "Rothkreuz (DERTZ)"
  },
  {
   value: "Rott am Inn (DERAI)",
   label: "Rott am Inn (DERAI)"
  },
  {
   value: "Rottenbach (DERBH)",
   label: "Rottenbach (DERBH)"
  },
  {
   value: "Rottenbuch (DERTN)",
   label: "Rottenbuch (DERTN)"
  },
  {
   value: "Rottweil (DEROL)",
   label: "Rottweil (DEROL)"
  },
  {
   value: "Rudersberg (DERUD)",
   label: "Rudersberg (DERUD)"
  },
  {
   value: "Rüdesheim (DERUE)",
   label: "Rüdesheim (DERUE)"
  },
  {
   value: "Rehau (DERHU)",
   label: "Rehau (DERHU)"
  },
  {
   value: "Rehburg-Loccum (DERLO)",
   label: "Rehburg-Loccum (DERLO)"
  },
  {
   value: "Rehden (DERDN)",
   label: "Rehden (DERDN)"
  },
  {
   value: "Reichenau (DERNU)",
   label: "Reichenau (DERNU)"
  },
  {
   value: "Reinbek (DEREI)",
   label: "Reinbek (DEREI)"
  },
  {
   value: "Reinersdorf (DERSF)",
   label: "Reinersdorf (DERSF)"
  },
  {
   value: "Reinfeld (DERFD)",
   label: "Reinfeld (DERFD)"
  },
  {
   value: "Reinheim (DERHM)",
   label: "Reinheim (DERHM)"
  },
  {
   value: "Reinsdorf (DERFA)",
   label: "Reinsdorf (DERFA)"
  },
  {
   value: "Reischof (DEROF)",
   label: "Reischof (DEROF)"
  },
  {
   value: "Reken (DEREK)",
   label: "Reken (DEREK)"
  },
  {
   value: "Remagen (DEREM)",
   label: "Remagen (DEREM)"
  },
  {
   value: "Remlingen (DERLI)",
   label: "Remlingen (DERLI)"
  },
  {
   value: "Remscheid (DERED)",
   label: "Remscheid (DERED)"
  },
  {
   value: "Remshalden (DERHN)",
   label: "Remshalden (DERHN)"
  },
  {
   value: "Renchen (DERCN)",
   label: "Renchen (DERCN)"
  },
  {
   value: "Rendsburg (DEREN)",
   label: "Rendsburg (DEREN)"
  },
  {
   value: "Rengsdorf (DEREF)",
   label: "Rengsdorf (DEREF)"
  },
  {
   value: "Renningen (DERNN)",
   label: "Renningen (DERNN)"
  },
  {
   value: "Reutlingen (DEREU)",
   label: "Reutlingen (DEREU)"
  },
  {
   value: "Rheda-Wiedenbrück (DERHW)",
   label: "Rheda-Wiedenbrück (DERHW)"
  },
  {
   value: "Rheinbach (DERHH)",
   label: "Rheinbach (DERHH)"
  },
  {
   value: "Rheinberg (DERHB)",
   label: "Rheinberg (DERHB)"
  },
  {
   value: "Rheinböllen (DERBN)",
   label: "Rheinböllen (DERBN)"
  },
  {
   value: "Rheinbreitbach (DERBB)",
   label: "Rheinbreitbach (DERBB)"
  },
  {
   value: "Rheinbrohl (DERHL)",
   label: "Rheinbrohl (DERHL)"
  },
  {
   value: "Rheindahlen (DERHD)",
   label: "Rheindahlen (DERHD)"
  },
  {
   value: "Rheine (DERHE)",
   label: "Rheine (DERHE)"
  },
  {
   value: "Rheinfelden (DERFN)",
   label: "Rheinfelden (DERFN)"
  },
  {
   value: "Rheinhausen (DERNH)",
   label: "Rheinhausen (DERNH)"
  },
  {
   value: "Rheinmünster (DERHR)",
   label: "Rheinmünster (DERHR)"
  },
  {
   value: "Rhodt (DERHT)",
   label: "Rhodt (DERHT)"
  },
  {
   value: "Ried (DERID)",
   label: "Ried (DERID)"
  },
  {
   value: "Riede (DERDE)",
   label: "Riede (DERDE)"
  },
  {
   value: "Riederich (DERDZ)",
   label: "Riederich (DERDZ)"
  },
  {
   value: "Riedlingen (DERIE)",
   label: "Riedlingen (DERIE)"
  },
  {
   value: "Riesa (DERSA)",
   label: "Riesa (DERSA)"
  },
  {
   value: "Rietberg (DERIG)",
   label: "Rietberg (DERIG)"
  },
  {
   value: "Rinnthal (DERIL)",
   label: "Rinnthal (DERIL)"
  },
  {
   value: "Rinteln (DERIN)",
   label: "Rinteln (DERIN)"
  },
  {
   value: "Prien\/Chiemsee (DEPRI)",
   label: "Prien\/Chiemsee (DEPRI)"
  },
  {
   value: "Pritzwalk (DEPRK)",
   label: "Pritzwalk (DEPRK)"
  },
  {
   value: "Prüm (DEPRU)",
   label: "Prüm (DEPRU)"
  },
  {
   value: "Pulheim (DEPUL)",
   label: "Pulheim (DEPUL)"
  },
  {
   value: "Puschendorf (DEPDF)",
   label: "Puschendorf (DEPDF)"
  },
  {
   value: "Puttgarden (DEPUT)",
   label: "Puttgarden (DEPUT)"
  },
  {
   value: "Putzborn (DEPUZ)",
   label: "Putzborn (DEPUZ)"
  },
  {
   value: "Putzbrunn (DEPBN)",
   label: "Putzbrunn (DEPBN)"
  },
  {
   value: "Quakenbrück (DEQUA)",
   label: "Quakenbrück (DEQUA)"
  },
  {
   value: "Quedlinburg (DEQUE)",
   label: "Quedlinburg (DEQUE)"
  },
  {
   value: "Quickborn (DEQKB)",
   label: "Quickborn (DEQKB)"
  },
  {
   value: "Rabenau (DERAB)",
   label: "Rabenau (DERAB)"
  },
  {
   value: "Rackwitz (DERKW)",
   label: "Rackwitz (DERKW)"
  },
  {
   value: "Radeberg (DERAG)",
   label: "Radeberg (DERAG)"
  },
  {
   value: "Radebeul (DERBL)",
   label: "Radebeul (DERBL)"
  },
  {
   value: "Radevormwald (DERDV)",
   label: "Radevormwald (DERDV)"
  },
  {
   value: "Radolfzell (DERAD)",
   label: "Radolfzell (DERAD)"
  },
  {
   value: "Rahden (DERAH)",
   label: "Rahden (DERAH)"
  },
  {
   value: "Rammelsbach (DERNI)",
   label: "Rammelsbach (DERNI)"
  },
  {
   value: "Ramsloh (DERMO)",
   label: "Ramsloh (DERMO)"
  },
  {
   value: "Ramstein-Miesenbach (DERAM)",
   label: "Ramstein-Miesenbach (DERAM)"
  },
  {
   value: "Ransbach-Baumbach (DERBA)",
   label: "Ransbach-Baumbach (DERBA)"
  },
  {
   value: "\"Rantum (DERAN)",
   label: "\"Rantum (DERAN)"
  },
  {
   value: "Rastatt (DERAS)",
   label: "Rastatt (DERAS)"
  },
  {
   value: "Rastede (DERAE)",
   label: "Rastede (DERAE)"
  },
  {
   value: "Rathenow (DERNW)",
   label: "Rathenow (DERNW)"
  },
  {
   value: "Ratingen (DERAT)",
   label: "Ratingen (DERAT)"
  },
  {
   value: "Ratzeburg (DERZG)",
   label: "Ratzeburg (DERZG)"
  },
  {
   value: "Raubach (DERBC)",
   label: "Raubach (DERBC)"
  },
  {
   value: "Raubling (DERLG)",
   label: "Raubling (DERLG)"
  },
  {
   value: "Raunheim (DERAU)",
   label: "Raunheim (DERAU)"
  },
  {
   value: "Rauschenberg (DERBG)",
   label: "Rauschenberg (DERBG)"
  },
  {
   value: "Ravensburg (DERAV)",
   label: "Ravensburg (DERAV)"
  },
  {
   value: "Recklinghausen (DEREC)",
   label: "Recklinghausen (DEREC)"
  },
  {
   value: "Rednitzhembach (DEREH)",
   label: "Rednitzhembach (DEREH)"
  },
  {
   value: "Redwitz a\/d Rodach (DEREZ)",
   label: "Redwitz a\/d Rodach (DEREZ)"
  },
  {
   value: "Reepsholt (DEREE)",
   label: "Reepsholt (DEREE)"
  },
  {
   value: "Rees (DERES)",
   label: "Rees (DERES)"
  },
  {
   value: "Regen (DERGN)",
   label: "Regen (DERGN)"
  },
  {
   value: "Regensburg (DEREG)",
   label: "Regensburg (DEREG)"
  },
  {
   value: "Petersdorf (DEPTD)",
   label: "Petersdorf (DEPTD)"
  },
  {
   value: "Petershagen\/Weser (DEPSW)",
   label: "Petershagen\/Weser (DEPSW)"
  },
  {
   value: "Pfaffenhofen an der Ilm (DEPFA)",
   label: "Pfaffenhofen an der Ilm (DEPFA)"
  },
  {
   value: "Pfalzgrafenweiler (DEPGR)",
   label: "Pfalzgrafenweiler (DEPGR)"
  },
  {
   value: "Pfarrkirchen (DEPFK)",
   label: "Pfarrkirchen (DEPFK)"
  },
  {
   value: "Pforzheim (DEPFO)",
   label: "Pforzheim (DEPFO)"
  },
  {
   value: "Pfullendorf (DEPFU)",
   label: "Pfullendorf (DEPFU)"
  },
  {
   value: "Pfullingen (DEPFN)",
   label: "Pfullingen (DEPFN)"
  },
  {
   value: "Pfungstadt (DEPFT)",
   label: "Pfungstadt (DEPFT)"
  },
  {
   value: "Philippsburg (DEPHG)",
   label: "Philippsburg (DEPHG)"
  },
  {
   value: "Philippsthal (DEPHT)",
   label: "Philippsthal (DEPHT)"
  },
  {
   value: "Philippsthal (DEPHI)",
   label: "Philippsthal (DEPHI)"
  },
  {
   value: "Piesau (DEPSU)",
   label: "Piesau (DEPSU)"
  },
  {
   value: "Pinneberg (DEPIN)",
   label: "Pinneberg (DEPIN)"
  },
  {
   value: "Pirmasens (DEPIR)",
   label: "Pirmasens (DEPIR)"
  },
  {
   value: "Pirna (DEPRA)",
   label: "Pirna (DEPRA)"
  },
  {
   value: "Plaidt (DEPLT)",
   label: "Plaidt (DEPLT)"
  },
  {
   value: "Planegg (DEPLG)",
   label: "Planegg (DEPLG)"
  },
  {
   value: "Plankstsdt (DEPKS)",
   label: "Plankstsdt (DEPKS)"
  },
  {
   value: "Plattling (DEPLA)",
   label: "Plattling (DEPLA)"
  },
  {
   value: "Plauen (DEPLU)",
   label: "Plauen (DEPLU)"
  },
  {
   value: "Pleidelsheim (DEPLH)",
   label: "Pleidelsheim (DEPLH)"
  },
  {
   value: "Plettenberg (DEPLE)",
   label: "Plettenberg (DEPLE)"
  },
  {
   value: "Plochingen (DEPLO)",
   label: "Plochingen (DEPLO)"
  },
  {
   value: "Plön (DEPLN)",
   label: "Plön (DEPLN)"
  },
  {
   value: "Plüderhausen (DEPHN)",
   label: "Plüderhausen (DEPHN)"
  },
  {
   value: "Pocking (DEPOC)",
   label: "Pocking (DEPOC)"
  },
  {
   value: "Pohlheim (DEPOH)",
   label: "Pohlheim (DEPOH)"
  },
  {
   value: "Poing (DEPOG)",
   label: "Poing (DEPOG)"
  },
  {
   value: "Pomellen (DEPOM)",
   label: "Pomellen (DEPOM)"
  },
  {
   value: "Porta Westfalica (DEPOW)",
   label: "Porta Westfalica (DEPOW)"
  },
  {
   value: "Porz (DEPOR)",
   label: "Porz (DEPOR)"
  },
  {
   value: "Pössneck (DEPTV)",
   label: "Pössneck (DEPTV)"
  },
  {
   value: "Posterbauer-Heng (DEPOS)",
   label: "Posterbauer-Heng (DEPOS)"
  },
  {
   value: "Potsdam (DEPOT)",
   label: "Potsdam (DEPOT)"
  },
  {
   value: "Preetz (DEPRE)",
   label: "Preetz (DEPRE)"
  },
  {
   value: "Premnitz (DEPTZ)",
   label: "Premnitz (DEPTZ)"
  },
  {
   value: "Prerow (DEPRW)",
   label: "Prerow (DEPRW)"
  },
  {
   value: "Preussisch-Oldendorf (DEPOL)",
   label: "Preussisch-Oldendorf (DEPOL)"
  },
  {
   value: "Prichsenstadt (DEPRT)",
   label: "Prichsenstadt (DEPRT)"
  },
  {
   value: "Oppenheim (DEOPP)",
   label: "Oppenheim (DEOPP)"
  },
  {
   value: "Orsoy (DEORS)",
   label: "Orsoy (DEORS)"
  },
  {
   value: "Ortenberg (DEORB)",
   label: "Ortenberg (DEORB)"
  },
  {
   value: "Ortenburg (DEOCE)",
   label: "Ortenburg (DEOCE)"
  },
  {
   value: "Orth\/Fehmarn (DEORT)",
   label: "Orth\/Fehmarn (DEORT)"
  },
  {
   value: "Ortrand (DEOTD)",
   label: "Ortrand (DEOTD)"
  },
  {
   value: "Osnabrück (DEOSN)",
   label: "Osnabrück (DEOSN)"
  },
  {
   value: "Osterburken (DEOST)",
   label: "Osterburken (DEOST)"
  },
  {
   value: "Ostercappeln (DEOCP)",
   label: "Ostercappeln (DEOCP)"
  },
  {
   value: "Osterhausen (DEOSH)",
   label: "Osterhausen (DEOSH)"
  },
  {
   value: "Osterhofen (DEOHN)",
   label: "Osterhofen (DEOHN)"
  },
  {
   value: "Osterholz-Scharmbeck (DEOSS)",
   label: "Osterholz-Scharmbeck (DEOSS)"
  },
  {
   value: "Ostermoor (DEOSR)",
   label: "Ostermoor (DEOSR)"
  },
  {
   value: "Osterode (DEOSE)",
   label: "Osterode (DEOSE)"
  },
  {
   value: "Ostfildern (DEOSF)",
   label: "Ostfildern (DEOSF)"
  },
  {
   value: "Östringen (DEOES)",
   label: "Östringen (DEOES)"
  },
  {
   value: "Otigheim (DEOTG)",
   label: "Otigheim (DEOTG)"
  },
  {
   value: "Otterndorf (DEOTT)",
   label: "Otterndorf (DEOTT)"
  },
  {
   value: "Ottersheim (DEOTR)",
   label: "Ottersheim (DEOTR)"
  },
  {
   value: "Ottobeuren (DEOTB)",
   label: "Ottobeuren (DEOTB)"
  },
  {
   value: "Ottobrunn (DEOTN)",
   label: "Ottobrunn (DEOTN)"
  },
  {
   value: "Ovelgönne (DEOVE)",
   label: "Ovelgönne (DEOVE)"
  },
  {
   value: "Oyten (DEOYT)",
   label: "Oyten (DEOYT)"
  },
  {
   value: "Paderborn (DEPAD)",
   label: "Paderborn (DEPAD)"
  },
  {
   value: "Pahlhude (DEPAH)",
   label: "Pahlhude (DEPAH)"
  },
  {
   value: "Papenburg (DEPAP)",
   label: "Papenburg (DEPAP)"
  },
  {
   value: "Pappenheim (DEPPP)",
   label: "Pappenheim (DEPPP)"
  },
  {
   value: "Parsberg (DEPAR)",
   label: "Parsberg (DEPAR)"
  },
  {
   value: "Partenstein (DEPTS)",
   label: "Partenstein (DEPTS)"
  },
  {
   value: "Pasewalk (DEPWK)",
   label: "Pasewalk (DEPWK)"
  },
  {
   value: "Passau (DEPAS)",
   label: "Passau (DEPAS)"
  },
  {
   value: "Peenemünde (DEPEF)",
   label: "Peenemünde (DEPEF)"
  },
  {
   value: "Pegnitz (DEPEG)",
   label: "Pegnitz (DEPEG)"
  },
  {
   value: "Peine (DEPEI)",
   label: "Peine (DEPEI)"
  },
  {
   value: "Peissenberg (DEPBG)",
   label: "Peissenberg (DEPBG)"
  },
  {
   value: "Pellworm I. (DEPEL)",
   label: "Pellworm I. (DEPEL)"
  },
  {
   value: "Penig (DEPIG)",
   label: "Penig (DEPIG)"
  },
  {
   value: "Pente (DEPEN)",
   label: "Pente (DEPEN)"
  },
  {
   value: "Penzberg (DEPEZ)",
   label: "Penzberg (DEPEZ)"
  },
  {
   value: "Petersberg (DEPET)",
   label: "Petersberg (DEPET)"
  },
  {
   value: "Oberdachstetten (DEOBD)",
   label: "Oberdachstetten (DEOBD)"
  },
  {
   value: "Oberderdingen (DEODN)",
   label: "Oberderdingen (DEODN)"
  },
  {
   value: "Oberhachingen (DEOHA)",
   label: "Oberhachingen (DEOHA)"
  },
  {
   value: "Oberhausen (DEOBE)",
   label: "Oberhausen (DEOBE)"
  },
  {
   value: "Oberhoechstadt (DEOHO)",
   label: "Oberhoechstadt (DEOHO)"
  },
  {
   value: "Oberkirch (DEOKH)",
   label: "Oberkirch (DEOKH)"
  },
  {
   value: "Oberkleen (DEOKL)",
   label: "Oberkleen (DEOKL)"
  },
  {
   value: "Obernburg (DEOBG)",
   label: "Obernburg (DEOBG)"
  },
  {
   value: "Oberndorf am Neckar (DEODF)",
   label: "Oberndorf am Neckar (DEODF)"
  },
  {
   value: "Obersontheim (DEOZH)",
   label: "Obersontheim (DEOZH)"
  },
  {
   value: "Oberstdorf (DEOBF)",
   label: "Oberstdorf (DEOBF)"
  },
  {
   value: "Obersulm (DEOSM)",
   label: "Obersulm (DEOSM)"
  },
  {
   value: "Obertshausen (DEOBN)",
   label: "Obertshausen (DEOBN)"
  },
  {
   value: "Oberursel (DEOBL)",
   label: "Oberursel (DEOBL)"
  },
  {
   value: "Oberwolfach (DEOBH)",
   label: "Oberwolfach (DEOBH)"
  },
  {
   value: "Obrigheim (DEOGH)",
   label: "Obrigheim (DEOGH)"
  },
  {
   value: "Ochsenhausen (DEOCH)",
   label: "Ochsenhausen (DEOCH)"
  },
  {
   value: "Ochtrup (DEOCT)",
   label: "Ochtrup (DEOCT)"
  },
  {
   value: "Oelde (DEOEL)",
   label: "Oelde (DEOEL)"
  },
  {
   value: "Oelsa\/Freital (DEOEA)",
   label: "Oelsa\/Freital (DEOEA)"
  },
  {
   value: "Oelsnitz (DEOSZ)",
   label: "Oelsnitz (DEOSZ)"
  },
  {
   value: "Oer-Erkenschwick (DEOER)",
   label: "Oer-Erkenschwick (DEOER)"
  },
  {
   value: "Oerlingshausen (DEOEN)",
   label: "Oerlingshausen (DEOEN)"
  },
  {
   value: "Offenbach (DEOFF)",
   label: "Offenbach (DEOFF)"
  },
  {
   value: "Offenburg (DEOFG)",
   label: "Offenburg (DEOFG)"
  },
  {
   value: "Offenhausen (DEOFH)",
   label: "Offenhausen (DEOFH)"
  },
  {
   value: "Offingen (DEOFN)",
   label: "Offingen (DEOFN)"
  },
  {
   value: "Ofterschwang (DEOFT)",
   label: "Ofterschwang (DEOFT)"
  },
  {
   value: "Ohlweiler (DEOWL)",
   label: "Ohlweiler (DEOWL)"
  },
  {
   value: "Öhringen (DEOEH)",
   label: "Öhringen (DEOEH)"
  },
  {
   value: "Olching (DEOLC)",
   label: "Olching (DEOLC)"
  },
  {
   value: "Oldenburg\/Holstein (DEOLH)",
   label: "Oldenburg\/Holstein (DEOLH)"
  },
  {
   value: "Oldenburg\/Oldenburg (DEOLO)",
   label: "Oldenburg\/Oldenburg (DEOLO)"
  },
  {
   value: "Oldenbüttel (DEOLB)",
   label: "Oldenbüttel (DEOLB)"
  },
  {
   value: "Oldendorf\/Hessen (DEODH)",
   label: "Oldendorf\/Hessen (DEODH)"
  },
  {
   value: "Olpe (DEOLE)",
   label: "Olpe (DEOLE)"
  },
  {
   value: "Olpenitz (DEOLP)",
   label: "Olpenitz (DEOLP)"
  },
  {
   value: "Olsberg (DEOLS)",
   label: "Olsberg (DEOLS)"
  },
  {
   value: "Nieder-Olm (DENOL)",
   label: "Nieder-Olm (DENOL)"
  },
  {
   value: "Nieder-Werbe (DENDW)",
   label: "Nieder-Werbe (DENDW)"
  },
  {
   value: "Niederfischbach (DENFB)",
   label: "Niederfischbach (DENFB)"
  },
  {
   value: "Niederirsen (DENDR)",
   label: "Niederirsen (DENDR)"
  },
  {
   value: "Niederkassel (DENKL)",
   label: "Niederkassel (DENKL)"
  },
  {
   value: "Niederkrüchten (DENRN)",
   label: "Niederkrüchten (DENRN)"
  },
  {
   value: "Niedernberg (DENDB)",
   label: "Niedernberg (DENDB)"
  },
  {
   value: "Niederneisen (DENNS)",
   label: "Niederneisen (DENNS)"
  },
  {
   value: "Niedernhausen (DENRH)",
   label: "Niedernhausen (DENRH)"
  },
  {
   value: "Niederwalluf (DENWF)",
   label: "Niederwalluf (DENWF)"
  },
  {
   value: "Niederwerrn (DENWM)",
   label: "Niederwerrn (DENWM)"
  },
  {
   value: "Niederzier (DENIR)",
   label: "Niederzier (DENIR)"
  },
  {
   value: "Niefern (DENFN)",
   label: "Niefern (DENFN)"
  },
  {
   value: "Nienburg (DENIE)",
   label: "Nienburg (DENIE)"
  },
  {
   value: "Nierstein (DENIN)",
   label: "Nierstein (DENIN)"
  },
  {
   value: "Nohra (DENRA)",
   label: "Nohra (DENRA)"
  },
  {
   value: "Norddeich (DENOE)",
   label: "Norddeich (DENOE)"
  },
  {
   value: "Norden (DENOD)",
   label: "Norden (DENOD)"
  },
  {
   value: "Nordenham (DENHA)",
   label: "Nordenham (DENHA)"
  },
  {
   value: "Norderney (DENRD)",
   label: "Norderney (DENRD)"
  },
  {
   value: "Norderstedt (DENOT)",
   label: "Norderstedt (DENOT)"
  },
  {
   value: "Nordhalben (DENBN)",
   label: "Nordhalben (DENBN)"
  },
  {
   value: "Nordhausen (DENDH)",
   label: "Nordhausen (DENDH)"
  },
  {
   value: "Nordheim (DENDM)",
   label: "Nordheim (DENDM)"
  },
  {
   value: "Nordhorn (DENHN)",
   label: "Nordhorn (DENHN)"
  },
  {
   value: "Nördlingen (DENON)",
   label: "Nördlingen (DENON)"
  },
  {
   value: "Nordstrand I. (DENOR)",
   label: "Nordstrand I. (DENOR)"
  },
  {
   value: "Nörten-Hardenberg (DENOH)",
   label: "Nörten-Hardenberg (DENOH)"
  },
  {
   value: "Northeim (DENOM)",
   label: "Northeim (DENOM)"
  },
  {
   value: "Nortrup (DENOP)",
   label: "Nortrup (DENOP)"
  },
  {
   value: "Nottuln (DENLN)",
   label: "Nottuln (DENLN)"
  },
  {
   value: "Nümbrecht (DENUT)",
   label: "Nümbrecht (DENUT)"
  },
  {
   value: "Nunchritz (DENTZ)",
   label: "Nunchritz (DENTZ)"
  },
  {
   value: "Nürnberg (DENUE)",
   label: "Nürnberg (DENUE)"
  },
  {
   value: "Nürtingen (DENUN)",
   label: "Nürtingen (DENUN)"
  },
  {
   value: "Nussloch (DENUH)",
   label: "Nussloch (DENUH)"
  },
  {
   value: "Ober Ramstadt (DEOBR)",
   label: "Ober Ramstadt (DEOBR)"
  },
  {
   value: "Oberammergau (DEOBA)",
   label: "Oberammergau (DEOBA)"
  },
  {
   value: "Oberasbach (DEOBC)",
   label: "Oberasbach (DEOBC)"
  },
  {
   value: "Neuenkirchen\/Steinfurt (DENKT)",
   label: "Neuenkirchen\/Steinfurt (DENKT)"
  },
  {
   value: "Neuenrade (Werdhol) (DENEV)",
   label: "Neuenrade (Werdhol) (DENEV)"
  },
  {
   value: "Neuenschleuse (DENSC)",
   label: "Neuenschleuse (DENSC)"
  },
  {
   value: "Neufahrn\/Freising (DENFF)",
   label: "Neufahrn\/Freising (DENFF)"
  },
  {
   value: "Neufeld (DENEF)",
   label: "Neufeld (DENEF)"
  },
  {
   value: "Neugersdorf (DENGD)",
   label: "Neugersdorf (DENGD)"
  },
  {
   value: "Neuharlingersiel (DENHS)",
   label: "Neuharlingersiel (DENHS)"
  },
  {
   value: "Neuhaus\/Oste (DENEH)",
   label: "Neuhaus\/Oste (DENEH)"
  },
  {
   value: "Neuhausen auf den Fildern (DENHF)",
   label: "Neuhausen auf den Fildern (DENHF)"
  },
  {
   value: "Neukirchen\/Erzgebirge (DENKI)",
   label: "Neukirchen\/Erzgebirge (DENKI)"
  },
  {
   value: "Neuland\/Elbe (DENEL)",
   label: "Neuland\/Elbe (DENEL)"
  },
  {
   value: "Neumarkt (DENET)",
   label: "Neumarkt (DENET)"
  },
  {
   value: "Neumünster (DENEU)",
   label: "Neumünster (DENEU)"
  },
  {
   value: "Neunkirchen am Sand (DENKS)",
   label: "Neunkirchen am Sand (DENKS)"
  },
  {
   value: "Neunkirchen-Seelscheid (DENEN)",
   label: "Neunkirchen-Seelscheid (DENEN)"
  },
  {
   value: "Neunkirchen\/Saar (DENKN)",
   label: "Neunkirchen\/Saar (DENKN)"
  },
  {
   value: "Neunkirchen\/Siegen (DENCN)",
   label: "Neunkirchen\/Siegen (DENCN)"
  },
  {
   value: "Neuruppin (DENPP)",
   label: "Neuruppin (DENPP)"
  },
  {
   value: "Neusäss (DENUS)",
   label: "Neusäss (DENUS)"
  },
  {
   value: "Neuss (DENSS)",
   label: "Neuss (DENSS)"
  },
  {
   value: "Neustadt (DENDT)",
   label: "Neustadt (DENDT)"
  },
  {
   value: "Neustadt (Wied) (DENEW)",
   label: "Neustadt (Wied) (DENEW)"
  },
  {
   value: "Neustadt am Rübenberge (DENRB)",
   label: "Neustadt am Rübenberge (DENRB)"
  },
  {
   value: "Neustadt an der Donau (DENTD)",
   label: "Neustadt an der Donau (DENTD)"
  },
  {
   value: "Neustadt an der Waldnaab (DENSB)",
   label: "Neustadt an der Waldnaab (DENSB)"
  },
  {
   value: "Neustadt\/Aisch (DENSA)",
   label: "Neustadt\/Aisch (DENSA)"
  },
  {
   value: "Neustadt\/Coburg (DENEC)",
   label: "Neustadt\/Coburg (DENEC)"
  },
  {
   value: "Neustadt\/Holstein (DENHO)",
   label: "Neustadt\/Holstein (DENHO)"
  },
  {
   value: "Neustadt\/Weinstrasse (DENSW)",
   label: "Neustadt\/Weinstrasse (DENSW)"
  },
  {
   value: "Neustrelitz (DENER)",
   label: "Neustrelitz (DENER)"
  },
  {
   value: "Neutraubling (DENTG)",
   label: "Neutraubling (DENTG)"
  },
  {
   value: "Neuwied (DENED)",
   label: "Neuwied (DENED)"
  },
  {
   value: "Nidda (DENID)",
   label: "Nidda (DENID)"
  },
  {
   value: "Niebüll (DENIL)",
   label: "Niebüll (DENIL)"
  },
  {
   value: "Nieder Aula (DENIA)",
   label: "Nieder Aula (DENIA)"
  },
  {
   value: "Nieder Hochstadt (DENHT)",
   label: "Nieder Hochstadt (DENHT)"
  },
  {
   value: "Münchweiler (DEMUW)",
   label: "Münchweiler (DEMUW)"
  },
  {
   value: "Münsingen (DEMGN)",
   label: "Münsingen (DEMGN)"
  },
  {
   value: "Munster (DEMUN)",
   label: "Munster (DEMUN)"
  },
  {
   value: "Münster (DEMSR)",
   label: "Münster (DEMSR)"
  },
  {
   value: "Murg (DEMRG)",
   label: "Murg (DEMRG)"
  },
  {
   value: "Mürlenbach (DEMBA)",
   label: "Mürlenbach (DEMBA)"
  },
  {
   value: "Murnau (DEMUR)",
   label: "Murnau (DEMUR)"
  },
  {
   value: "Murr (DEMRW)",
   label: "Murr (DEMRW)"
  },
  {
   value: "Murrhardt (DEMHT)",
   label: "Murrhardt (DEMHT)"
  },
  {
   value: "Nabburg (DENAB)",
   label: "Nabburg (DENAB)"
  },
  {
   value: "Nachrodt (DENCH)",
   label: "Nachrodt (DENCH)"
  },
  {
   value: "Nackenheim (DENAC)",
   label: "Nackenheim (DENAC)"
  },
  {
   value: "Nagold (DENAG)",
   label: "Nagold (DENAG)"
  },
  {
   value: "Naila (DENLA)",
   label: "Naila (DENLA)"
  },
  {
   value: "Nassau\/Lahn (DENSU)",
   label: "Nassau\/Lahn (DENSU)"
  },
  {
   value: "Nastätten (DENAN)",
   label: "Nastätten (DENAN)"
  },
  {
   value: "Neckarelz (DENEZ)",
   label: "Neckarelz (DENEZ)"
  },
  {
   value: "Neckargemünd (DENMD)",
   label: "Neckargemünd (DENMD)"
  },
  {
   value: "Neckarsteinach (DENST)",
   label: "Neckarsteinach (DENST)"
  },
  {
   value: "Neckarsulm (DENEM)",
   label: "Neckarsulm (DENEM)"
  },
  {
   value: "Neidenfels (DENEI)",
   label: "Neidenfels (DENEI)"
  },
  {
   value: "Neidenstein (DENDN)",
   label: "Neidenstein (DENDN)"
  },
  {
   value: "Nellingen (DENGN)",
   label: "Nellingen (DENGN)"
  },
  {
   value: "Nessmersiel (DENES)",
   label: "Nessmersiel (DENES)"
  },
  {
   value: "Netphen (DENPN)",
   label: "Netphen (DENPN)"
  },
  {
   value: "Nettetal (DENTL)",
   label: "Nettetal (DENTL)"
  },
  {
   value: "Neu Anspach (DENUA)",
   label: "Neu Anspach (DENUA)"
  },
  {
   value: "\"Neu Bartelshagen (DENBA)",
   label: "\"Neu Bartelshagen (DENBA)"
  },
  {
   value: "Neu Isenburg (DENIS)",
   label: "Neu Isenburg (DENIS)"
  },
  {
   value: "Neu Wulmstorf (DENWU)",
   label: "Neu Wulmstorf (DENWU)"
  },
  {
   value: "Neu-Ulm (DENUL)",
   label: "Neu-Ulm (DENUL)"
  },
  {
   value: "Neubiberg (DENIB)",
   label: "Neubiberg (DENIB)"
  },
  {
   value: "Neubrandenburg (DENEB)",
   label: "Neubrandenburg (DENEB)"
  },
  {
   value: "Neuburg an der Donau (DENBG)",
   label: "Neuburg an der Donau (DENBG)"
  },
  {
   value: "Neuburg-Kammel (DENGK)",
   label: "Neuburg-Kammel (DENGK)"
  },
  {
   value: "Neuenbürg (DENEG)",
   label: "Neuenbürg (DENEG)"
  },
  {
   value: "Neuenburg am Rhein (DENBR)",
   label: "Neuenburg am Rhein (DENBR)"
  },
  {
   value: "Neuenhaus (DENAS)",
   label: "Neuenhaus (DENAS)"
  },
  {
   value: "Neuenkirchen (DENEK)",
   label: "Neuenkirchen (DENEK)"
  },
  {
   value: "Mittwitz (DEMTZ)",
   label: "Mittwitz (DEMTZ)"
  },
  {
   value: "Möckmühl (DEMML)",
   label: "Möckmühl (DEMML)"
  },
  {
   value: "Moehnesee-Guenne (DEMGU)",
   label: "Moehnesee-Guenne (DEMGU)"
  },
  {
   value: "Mogendorf (DEMOG)",
   label: "Mogendorf (DEMOG)"
  },
  {
   value: "Möglingen (DEMLN)",
   label: "Möglingen (DEMLN)"
  },
  {
   value: "Mohnesse (DEMNS)",
   label: "Mohnesse (DEMNS)"
  },
  {
   value: "Mohrendorf (DEMHF)",
   label: "Mohrendorf (DEMHF)"
  },
  {
   value: "Mölln (DEMOE)",
   label: "Mölln (DEMOE)"
  },
  {
   value: "Mönchengladbach (DEMGL)",
   label: "Mönchengladbach (DEMGL)"
  },
  {
   value: "Monheim (DEMHM)",
   label: "Monheim (DEMHM)"
  },
  {
   value: "Monschau (DEMOU)",
   label: "Monschau (DEMOU)"
  },
  {
   value: "Mönsheim (DEMOM)",
   label: "Mönsheim (DEMOM)"
  },
  {
   value: "Montabaur (DEMON)",
   label: "Montabaur (DEMON)"
  },
  {
   value: "Monzingen (DEMNZ)",
   label: "Monzingen (DEMNZ)"
  },
  {
   value: "Moorenweis (DEMOD)",
   label: "Moorenweis (DEMOD)"
  },
  {
   value: "Moosach (DEMOH)",
   label: "Moosach (DEMOH)"
  },
  {
   value: "Moosburg (DEMOO)",
   label: "Moosburg (DEMOO)"
  },
  {
   value: "Morbach (DEMRB)",
   label: "Morbach (DEMRB)"
  },
  {
   value: "Mörs (DEMOS)",
   label: "Mörs (DEMOS)"
  },
  {
   value: "Morsbach (DEMBH)",
   label: "Morsbach (DEMBH)"
  },
  {
   value: "Morsum\/Sylt (DEMOR)",
   label: "Morsum\/Sylt (DEMOR)"
  },
  {
   value: "Mosbach (DEMOB)",
   label: "Mosbach (DEMOB)"
  },
  {
   value: "Much (DEMCH)",
   label: "Much (DEMCH)"
  },
  {
   value: "Mudau (DEMUU)",
   label: "Mudau (DEMUU)"
  },
  {
   value: "Muenden (DEMUD)",
   label: "Muenden (DEMUD)"
  },
  {
   value: "Mueselwitz (DEMWZ)",
   label: "Mueselwitz (DEMWZ)"
  },
  {
   value: "Muggensturm (DEMGS)",
   label: "Muggensturm (DEMGS)"
  },
  {
   value: "Mühlacker (DEMUL)",
   label: "Mühlacker (DEMUL)"
  },
  {
   value: "Mühldorf (DEMUF)",
   label: "Mühldorf (DEMUF)"
  },
  {
   value: "Mühlenberg (DEMLG)",
   label: "Mühlenberg (DEMLG)"
  },
  {
   value: "Mühlhausen (DEMHL)",
   label: "Mühlhausen (DEMHL)"
  },
  {
   value: "Mühlheim am Main (DEMLM)",
   label: "Mühlheim am Main (DEMLM)"
  },
  {
   value: "Mühlheim an der Ruhr (DEMUH)",
   label: "Mühlheim an der Ruhr (DEMUH)"
  },
  {
   value: "Mühlheim-Kärlich (DEMKA)",
   label: "Mühlheim-Kärlich (DEMKA)"
  },
  {
   value: "Mühltal (DEMUT)",
   label: "Mühltal (DEMUT)"
  },
  {
   value: "Mukran (DEMUK)",
   label: "Mukran (DEMUK)"
  },
  {
   value: "Müllheim (DEMUE)",
   label: "Müllheim (DEMUE)"
  },
  {
   value: "Münchberg (DEMUG)",
   label: "Münchberg (DEMUG)"
  },
  {
   value: "München (DEMUC)",
   label: "München (DEMUC)"
  },
  {
   value: "Münchsmünster (DEMUM)",
   label: "Münchsmünster (DEMUM)"
  },
  {
   value: "Mechernich (DEMCI)",
   label: "Mechernich (DEMCI)"
  },
  {
   value: "Meckenheim (DEMEC)",
   label: "Meckenheim (DEMEC)"
  },
  {
   value: "Meddersheim (DEMED)",
   label: "Meddersheim (DEMED)"
  },
  {
   value: "Meerane (DEMRE)",
   label: "Meerane (DEMRE)"
  },
  {
   value: "Meerbusch (DEMRH)",
   label: "Meerbusch (DEMRH)"
  },
  {
   value: "Meersburg (DEMBG)",
   label: "Meersburg (DEMBG)"
  },
  {
   value: "Meilschnitz (DEMEZ)",
   label: "Meilschnitz (DEMEZ)"
  },
  {
   value: "Meinerzhagen (DEMZN)",
   label: "Meinerzhagen (DEMZN)"
  },
  {
   value: "Meissen (DEMEI)",
   label: "Meissen (DEMEI)"
  },
  {
   value: "Meitingen (DEMII)",
   label: "Meitingen (DEMII)"
  },
  {
   value: "Meldorf (DEMEL)",
   label: "Meldorf (DEMEL)"
  },
  {
   value: "Melle (DEMEE)",
   label: "Melle (DEMEE)"
  },
  {
   value: "Mellrichstadt (DEMST)",
   label: "Mellrichstadt (DEMST)"
  },
  {
   value: "Melsungen (DEMLS)",
   label: "Melsungen (DEMLS)"
  },
  {
   value: "Memmert I. (DEMEM)",
   label: "Memmert I. (DEMEM)"
  },
  {
   value: "Memmingen (DEMMN)",
   label: "Memmingen (DEMMN)"
  },
  {
   value: "Menden (DEMEN)",
   label: "Menden (DEMEN)"
  },
  {
   value: "Meppen (DEMEP)",
   label: "Meppen (DEMEP)"
  },
  {
   value: "Merdingen (DEMTE)",
   label: "Merdingen (DEMTE)"
  },
  {
   value: "Mertingen (DEMTG)",
   label: "Mertingen (DEMTG)"
  },
  {
   value: "Merzig (DEMER)",
   label: "Merzig (DEMER)"
  },
  {
   value: "Meschede (DEMSE)",
   label: "Meschede (DEMSE)"
  },
  {
   value: "Mescherin (DEMSH)",
   label: "Mescherin (DEMSH)"
  },
  {
   value: "Messkirch (DEMES)",
   label: "Messkirch (DEMES)"
  },
  {
   value: "Mettlach (DEMEH)",
   label: "Mettlach (DEMEH)"
  },
  {
   value: "Mettmann (DEMET)",
   label: "Mettmann (DEMET)"
  },
  {
   value: "Metzingen (DEMTN)",
   label: "Metzingen (DEMTN)"
  },
  {
   value: "Meyenburg\/Prignitz (DEMEY)",
   label: "Meyenburg\/Prignitz (DEMEY)"
  },
  {
   value: "Michelau in Oberfranken (DEMIC)",
   label: "Michelau in Oberfranken (DEMIC)"
  },
  {
   value: "Michelstadt (DEMIS)",
   label: "Michelstadt (DEMIS)"
  },
  {
   value: "Miesau (DEMEU)",
   label: "Miesau (DEMEU)"
  },
  {
   value: "Miesbach (DEMIE)",
   label: "Miesbach (DEMIE)"
  },
  {
   value: "Miltenberg (DEMIL)",
   label: "Miltenberg (DEMIL)"
  },
  {
   value: "Mindelheim (DEMIH)",
   label: "Mindelheim (DEMIH)"
  },
  {
   value: "Minden (DEMID)",
   label: "Minden (DEMID)"
  },
  {
   value: "Minsen (DEMIN)",
   label: "Minsen (DEMIN)"
  },
  {
   value: "Mintraching (DEMTR)",
   label: "Mintraching (DEMTR)"
  },
  {
   value: "Mittenwald (DEMIT)",
   label: "Mittenwald (DEMIT)"
  },
  {
   value: "Mitterteich (DEMTH)",
   label: "Mitterteich (DEMTH)"
  },
  {
   value: "Mittweida (DEMTW)",
   label: "Mittweida (DEMTW)"
  },
  {
   value: "Magstadt (DEMAS)",
   label: "Magstadt (DEMAS)"
  },
  {
   value: "Mainaschaff (DEMSF)",
   label: "Mainaschaff (DEMSF)"
  },
  {
   value: "Mainburg (DEMNB)",
   label: "Mainburg (DEMNB)"
  },
  {
   value: "Mainhausen (DEMNH)",
   label: "Mainhausen (DEMNH)"
  },
  {
   value: "Maintal (DEMTL)",
   label: "Maintal (DEMTL)"
  },
  {
   value: "Mainz (DEMAI)",
   label: "Mainz (DEMAI)"
  },
  {
   value: "Mallersdorf-Pfaffenberg (DEMPF)",
   label: "Mallersdorf-Pfaffenberg (DEMPF)"
  },
  {
   value: "Malterdingen (DEMDN)",
   label: "Malterdingen (DEMDN)"
  },
  {
   value: "Mandern (DEMRN)",
   label: "Mandern (DEMRN)"
  },
  {
   value: "Manhard Frieda (DEMFA)",
   label: "Manhard Frieda (DEMFA)"
  },
  {
   value: "Mannheim (DEMHG)",
   label: "Mannheim (DEMHG)"
  },
  {
   value: "Mannschhatz (DEMSZ)",
   label: "Mannschhatz (DEMSZ)"
  },
  {
   value: "Marburg (DEMAR)",
   label: "Marburg (DEMAR)"
  },
  {
   value: "Marcardsmoor (DEMRM)",
   label: "Marcardsmoor (DEMRM)"
  },
  {
   value: "Marienfeld (DEMFD)",
   label: "Marienfeld (DEMFD)"
  },
  {
   value: "Marienheide (DEMHD)",
   label: "Marienheide (DEMHD)"
  },
  {
   value: "Mariensiel (DEMRS)",
   label: "Mariensiel (DEMRS)"
  },
  {
   value: "Markdorf (DEMAF)",
   label: "Markdorf (DEMAF)"
  },
  {
   value: "Markgröningen (Dupl. MAR) (DEMKG)",
   label: "Markgröningen (Dupl. MAR) (DEMKG)"
  },
  {
   value: "Marklkofen (DEMRK)",
   label: "Marklkofen (DEMRK)"
  },
  {
   value: "Markneukirchen (DEMKH)",
   label: "Markneukirchen (DEMKH)"
  },
  {
   value: "Markranstädt (DEMKS)",
   label: "Markranstädt (DEMKS)"
  },
  {
   value: "Marksuhl (DEMSL)",
   label: "Marksuhl (DEMSL)"
  },
  {
   value: "Marktheidenfeld (DEMAD)",
   label: "Marktheidenfeld (DEMAD)"
  },
  {
   value: "Marktoberdorf (DEMOF)",
   label: "Marktoberdorf (DEMOF)"
  },
  {
   value: "Marktredwitz (DEMAZ)",
   label: "Marktredwitz (DEMAZ)"
  },
  {
   value: "Marktschorgast (DEMAT)",
   label: "Marktschorgast (DEMAT)"
  },
  {
   value: "Marl (DEMAL)",
   label: "Marl (DEMAL)"
  },
  {
   value: "Marne (DEMAE)",
   label: "Marne (DEMAE)"
  },
  {
   value: "Marnheim (DEMAN)",
   label: "Marnheim (DEMAN)"
  },
  {
   value: "Maroldsweisach (DEMWH)",
   label: "Maroldsweisach (DEMWH)"
  },
  {
   value: "Marsberg (DEMSG)",
   label: "Marsberg (DEMSG)"
  },
  {
   value: "Marschacht (DEMRT)",
   label: "Marschacht (DEMRT)"
  },
  {
   value: "Martinsried (DEMRR)",
   label: "Martinsried (DEMRR)"
  },
  {
   value: "Marzling (DEMRZ)",
   label: "Marzling (DEMRZ)"
  },
  {
   value: "Maschen (DEMSC)",
   label: "Maschen (DEMSC)"
  },
  {
   value: "Maulbronn (DEMBN)",
   label: "Maulbronn (DEMBN)"
  },
  {
   value: "Maulburg (DEMLB)",
   label: "Maulburg (DEMLB)"
  },
  {
   value: "Mayen (DEMAY)",
   label: "Mayen (DEMAY)"
  },
  {
   value: "Lindau (DELIU)",
   label: "Lindau (DELIU)"
  },
  {
   value: "Lindenberg\/Allgäu (DELNB)",
   label: "Lindenberg\/Allgäu (DELNB)"
  },
  {
   value: "Lindenfels (DELFE)",
   label: "Lindenfels (DELFE)"
  },
  {
   value: "Lindweiler (DELND)",
   label: "Lindweiler (DELND)"
  },
  {
   value: "Lingen (DELIG)",
   label: "Lingen (DELIG)"
  },
  {
   value: "Linken (DELKE)",
   label: "Linken (DELKE)"
  },
  {
   value: "Linkenheim (DELKH)",
   label: "Linkenheim (DELKH)"
  },
  {
   value: "Linnich (DELIH)",
   label: "Linnich (DELIH)"
  },
  {
   value: "Linsengericht (DELSG)",
   label: "Linsengericht (DELSG)"
  },
  {
   value: "Lintelermarsch (DELIN)",
   label: "Lintelermarsch (DELIN)"
  },
  {
   value: "Linz\/Rhein (DELRN)",
   label: "Linz\/Rhein (DELRN)"
  },
  {
   value: "Lippstadt (DELIP)",
   label: "Lippstadt (DELIP)"
  },
  {
   value: "List\/Sylt (DELIS)",
   label: "List\/Sylt (DELIS)"
  },
  {
   value: "Lohmar (DELOH)",
   label: "Lohmar (DELOH)"
  },
  {
   value: "Löhne (DELHE)",
   label: "Löhne (DELHE)"
  },
  {
   value: "Lohne\/Vechta (DELNE)",
   label: "Lohne\/Vechta (DELNE)"
  },
  {
   value: "Lohr (DELOR)",
   label: "Lohr (DELOR)"
  },
  {
   value: "Lollar (DELOL)",
   label: "Lollar (DELOL)"
  },
  {
   value: "Lonesch (DELHH)",
   label: "Lonesch (DELHH)"
  },
  {
   value: "Longuich (DELON)",
   label: "Longuich (DELON)"
  },
  {
   value: "Löningen (DELNI)",
   label: "Löningen (DELNI)"
  },
  {
   value: "Lörrach (DELOE)",
   label: "Lörrach (DELOE)"
  },
  {
   value: "Lorsch (DELRW)",
   label: "Lorsch (DELRW)"
  },
  {
   value: "Lossburg (DELOG)",
   label: "Lossburg (DELOG)"
  },
  {
   value: "Lotte (DELOT)",
   label: "Lotte (DELOT)"
  },
  {
   value: "Loxstedt (DELOX)",
   label: "Loxstedt (DELOX)"
  },
  {
   value: "Lübbecke (DELBE)",
   label: "Lübbecke (DELBE)"
  },
  {
   value: "Lübeck (DELBC)",
   label: "Lübeck (DELBC)"
  },
  {
   value: "Lüchow (DELUW)",
   label: "Lüchow (DELUW)"
  },
  {
   value: "Lüdenscheid (DELUD)",
   label: "Lüdenscheid (DELUD)"
  },
  {
   value: "Lüdinghausen (DELUN)",
   label: "Lüdinghausen (DELUN)"
  },
  {
   value: "Ludwigsburg (DELUG)",
   label: "Ludwigsburg (DELUG)"
  },
  {
   value: "Ludwigshafen (DELUH)",
   label: "Ludwigshafen (DELUH)"
  },
  {
   value: "Ludwigslust (DELUL)",
   label: "Ludwigslust (DELUL)"
  },
  {
   value: "Ludwigsstadt (DELUT)",
   label: "Ludwigsstadt (DELUT)"
  },
  {
   value: "Luelsdorf (DELLS)",
   label: "Luelsdorf (DELLS)"
  },
  {
   value: "Lügde (DELDE)",
   label: "Lügde (DELDE)"
  },
  {
   value: "Lülsdorf (DELLF)",
   label: "Lülsdorf (DELLF)"
  },
  {
   value: "Lüneburg (DELBG)",
   label: "Lüneburg (DELBG)"
  },
  {
   value: "Lünen (DELUE)",
   label: "Lünen (DELUE)"
  },
  {
   value: "Magdeburg (DEMAG)",
   label: "Magdeburg (DEMAG)"
  },
  {
   value: "Laufenburg (DELFG)",
   label: "Laufenburg (DELFG)"
  },
  {
   value: "Lauffen (DELFN)",
   label: "Lauffen (DELFN)"
  },
  {
   value: "Lauingen (DELGN)",
   label: "Lauingen (DELGN)"
  },
  {
   value: "Laupheim (DELPM)",
   label: "Laupheim (DELPM)"
  },
  {
   value: "Lauterbach (DELAU)",
   label: "Lauterbach (DELAU)"
  },
  {
   value: "Lauterecken (DELTN)",
   label: "Lauterecken (DELTN)"
  },
  {
   value: "Lebach (DELEB)",
   label: "Lebach (DELEB)"
  },
  {
   value: "Lebus (DELBS)",
   label: "Lebus (DELBS)"
  },
  {
   value: "Leer (DELEE)",
   label: "Leer (DELEE)"
  },
  {
   value: "Leeste (DELTE)",
   label: "Leeste (DELTE)"
  },
  {
   value: "Leezen (DELZE)",
   label: "Leezen (DELZE)"
  },
  {
   value: "Legden (DELEG)",
   label: "Legden (DELEG)"
  },
  {
   value: "Lehrte (DELEH)",
   label: "Lehrte (DELEH)"
  },
  {
   value: "Leiblfing (DELHJ)",
   label: "Leiblfing (DELHJ)"
  },
  {
   value: "Leichlingen (DELLN)",
   label: "Leichlingen (DELLN)"
  },
  {
   value: "Leimen (DELMN)",
   label: "Leimen (DELMN)"
  },
  {
   value: "Leinefelde (DELLD)",
   label: "Leinefelde (DELLD)"
  },
  {
   value: "Leinfelden-Echterdingen (DELEC)",
   label: "Leinfelden-Echterdingen (DELEC)"
  },
  {
   value: "Leipzig (DELEJ)",
   label: "Leipzig (DELEJ)"
  },
  {
   value: "Leiwen (DELWN)",
   label: "Leiwen (DELWN)"
  },
  {
   value: "Lemförde (DELME)",
   label: "Lemförde (DELME)"
  },
  {
   value: "Lemgo (DELEM)",
   label: "Lemgo (DELEM)"
  },
  {
   value: "Lemwerder (DELEW)",
   label: "Lemwerder (DELEW)"
  },
  {
   value: "Lengenwang (DELGW)",
   label: "Lengenwang (DELGW)"
  },
  {
   value: "Lengerich (DELCH)",
   label: "Lengerich (DELCH)"
  },
  {
   value: "Lenggries (DELGS)",
   label: "Lenggries (DELGS)"
  },
  {
   value: "Lennestadt (DELST)",
   label: "Lennestadt (DELST)"
  },
  {
   value: "Lenningen (DELEN)",
   label: "Lenningen (DELEN)"
  },
  {
   value: "Lensahn (DELSW)",
   label: "Lensahn (DELSW)"
  },
  {
   value: "Lenting (DELTG)",
   label: "Lenting (DELTG)"
  },
  {
   value: "Leonberg (DELEO)",
   label: "Leonberg (DELEO)"
  },
  {
   value: "Leuna (DELEA)",
   label: "Leuna (DELEA)"
  },
  {
   value: "Leutkirch (DELEU)",
   label: "Leutkirch (DELEU)"
  },
  {
   value: "Leverkusen (DELEV)",
   label: "Leverkusen (DELEV)"
  },
  {
   value: "Lichtenau (DELIT)",
   label: "Lichtenau (DELIT)"
  },
  {
   value: "Lichtenfels (DELIC)",
   label: "Lichtenfels (DELIC)"
  },
  {
   value: "Liebertwolkwitz (DELBR)",
   label: "Liebertwolkwitz (DELBR)"
  },
  {
   value: "Limbach (DELMB)",
   label: "Limbach (DELMB)"
  },
  {
   value: "Limbach-Oberfrohna (DELOF)",
   label: "Limbach-Oberfrohna (DELOF)"
  },
  {
   value: "Limburg (DELIM)",
   label: "Limburg (DELIM)"
  },
  {
   value: "Kyritz (DEKYR)",
   label: "Kyritz (DEKYR)"
  },
  {
   value: "Laashpe (Bad Laasphe) (DELAA)",
   label: "Laashpe (Bad Laasphe) (DELAA)"
  },
  {
   value: "Laboe (DELAB)",
   label: "Laboe (DELAB)"
  },
  {
   value: "Lachen Speyersdorf (DELSY)",
   label: "Lachen Speyersdorf (DELSY)"
  },
  {
   value: "Ladenburg (DELRG)",
   label: "Ladenburg (DELRG)"
  },
  {
   value: "Laer (DELAY)",
   label: "Laer (DELAY)"
  },
  {
   value: "Lage (DELGE)",
   label: "Lage (DELGE)"
  },
  {
   value: "Lägerdorf (DELAE)",
   label: "Lägerdorf (DELAE)"
  },
  {
   value: "Lahnstein (DELAH)",
   label: "Lahnstein (DELAH)"
  },
  {
   value: "Lahr (DELAR)",
   label: "Lahr (DELAR)"
  },
  {
   value: "Laichingen (DELCG)",
   label: "Laichingen (DELCG)"
  },
  {
   value: "Lambrecht (DELBT)",
   label: "Lambrecht (DELBT)"
  },
  {
   value: "Lampertheim (DELAM)",
   label: "Lampertheim (DELAM)"
  },
  {
   value: "Landau\/Bayern (DELDU)",
   label: "Landau\/Bayern (DELDU)"
  },
  {
   value: "Landau\/Pfalz (DELAD)",
   label: "Landau\/Pfalz (DELAD)"
  },
  {
   value: "Landsberg (DELAG)",
   label: "Landsberg (DELAG)"
  },
  {
   value: "Landscheid (DELSD)",
   label: "Landscheid (DELSD)"
  },
  {
   value: "Landshut (DELDH)",
   label: "Landshut (DELDH)"
  },
  {
   value: "Landstuhl (DELSL)",
   label: "Landstuhl (DELSL)"
  },
  {
   value: "Landwürden (DELAN)",
   label: "Landwürden (DELAN)"
  },
  {
   value: "Langelsheim (DELGM)",
   label: "Langelsheim (DELGM)"
  },
  {
   value: "Langen (DELNN)",
   label: "Langen (DELNN)"
  },
  {
   value: "Langen bei Bremerhaven (DELNG)",
   label: "Langen bei Bremerhaven (DELNG)"
  },
  {
   value: "Langenargen (DELIV)",
   label: "Langenargen (DELIV)"
  },
  {
   value: "Langenburg (DELBU)",
   label: "Langenburg (DELBU)"
  },
  {
   value: "Langenfeld (DELGF)",
   label: "Langenfeld (DELGF)"
  },
  {
   value: "Langenhagen (DELHN)",
   label: "Langenhagen (DELHN)"
  },
  {
   value: "Langenlonsheim (DELLM)",
   label: "Langenlonsheim (DELLM)"
  },
  {
   value: "Langenwetzendorf (DELWF)",
   label: "Langenwetzendorf (DELWF)"
  },
  {
   value: "Langenzenn (DELZN)",
   label: "Langenzenn (DELZN)"
  },
  {
   value: "Langeoog (DELGO)",
   label: "Langeoog (DELGO)"
  },
  {
   value: "Langweid (DELWD)",
   label: "Langweid (DELWD)"
  },
  {
   value: "Lathen (DELAT)",
   label: "Lathen (DELAT)"
  },
  {
   value: "Laubach (DELBH)",
   label: "Laubach (DELBH)"
  },
  {
   value: "Laubin (Oberallgäu) (DELBN)",
   label: "Laubin (Oberallgäu) (DELBN)"
  },
  {
   value: "Lauda-Königshofen (DELKN)",
   label: "Lauda-Königshofen (DELKN)"
  },
  {
   value: "Lauenau (DELNA)",
   label: "Lauenau (DELNA)"
  },
  {
   value: "Lauenburg\/Elbe (DELNU)",
   label: "Lauenburg\/Elbe (DELNU)"
  },
  {
   value: "Lauf\/Pegnitz (DELAF)",
   label: "Lauf\/Pegnitz (DELAF)"
  },
  {
   value: "Koblenz (DEKOB)",
   label: "Koblenz (DEKOB)"
  },
  {
   value: "Kollig (DEKOG)",
   label: "Kollig (DEKOG)"
  },
  {
   value: "Kollmar (DEKOL)",
   label: "Kollmar (DEKOL)"
  },
  {
   value: "Köln (DECGN)",
   label: "Köln (DECGN)"
  },
  {
   value: "Köngen (DEKNN)",
   label: "Köngen (DEKNN)"
  },
  {
   value: "Königs Wusterhausen (DEKWH)",
   label: "Königs Wusterhausen (DEKWH)"
  },
  {
   value: "Königsbrunn (DEKGN)",
   label: "Königsbrunn (DEKGN)"
  },
  {
   value: "Königstein (DEKOS)",
   label: "Königstein (DEKOS)"
  },
  {
   value: "Königswinter (DEKOW)",
   label: "Königswinter (DEKOW)"
  },
  {
   value: "Konstanz (DEKON)",
   label: "Konstanz (DEKON)"
  },
  {
   value: "Konstein (DEKST)",
   label: "Konstein (DEKST)"
  },
  {
   value: "Konz (DEKOZ)",
   label: "Konz (DEKOZ)"
  },
  {
   value: "Korbach (DEKOH)",
   label: "Korbach (DEKOH)"
  },
  {
   value: "Korntal-Münchingen (DEKMG)",
   label: "Korntal-Münchingen (DEKMG)"
  },
  {
   value: "Kornwestheim (DEKOR)",
   label: "Kornwestheim (DEKOR)"
  },
  {
   value: "Korschenbroich (DEKBH)",
   label: "Korschenbroich (DEKBH)"
  },
  {
   value: "Kötz (DEKOE)",
   label: "Kötz (DEKOE)"
  },
  {
   value: "Kraichtal (DEKIL)",
   label: "Kraichtal (DEKIL)"
  },
  {
   value: "Krauchenwies (DEKRH)",
   label: "Krauchenwies (DEKRH)"
  },
  {
   value: "Krautsand (DEKRA)",
   label: "Krautsand (DEKRA)"
  },
  {
   value: "Krefeld (DEKRE)",
   label: "Krefeld (DEKRE)"
  },
  {
   value: "Kreiensen (DEKRN)",
   label: "Kreiensen (DEKRN)"
  },
  {
   value: "Kreuzau (DEKZU)",
   label: "Kreuzau (DEKZU)"
  },
  {
   value: "Kreuztal (DEKRL)",
   label: "Kreuztal (DEKRL)"
  },
  {
   value: "Kreuzwertheim (DEKWM)",
   label: "Kreuzwertheim (DEKWM)"
  },
  {
   value: "Kriebstein (DEKRS)",
   label: "Kriebstein (DEKRS)"
  },
  {
   value: "Kriftel (DEKRI)",
   label: "Kriftel (DEKRI)"
  },
  {
   value: "Kritzow (DEKRW)",
   label: "Kritzow (DEKRW)"
  },
  {
   value: "Kronach (DEKRO)",
   label: "Kronach (DEKRO)"
  },
  {
   value: "Kronberg (DEKRG)",
   label: "Kronberg (DEKRG)"
  },
  {
   value: "Kröslin (DEKSL)",
   label: "Kröslin (DEKSL)"
  },
  {
   value: "Kröv (DEKRV)",
   label: "Kröv (DEKRV)"
  },
  {
   value: "Kruft (DEKRT)",
   label: "Kruft (DEKRT)"
  },
  {
   value: "Krumbach (DEKRU)",
   label: "Krumbach (DEKRU)"
  },
  {
   value: "Krummennaab (DEKRB)",
   label: "Krummennaab (DEKRB)"
  },
  {
   value: "Kulmbach (DEKUL)",
   label: "Kulmbach (DEKUL)"
  },
  {
   value: "Kümmersbruck (DEKUK)",
   label: "Kümmersbruck (DEKUK)"
  },
  {
   value: "Kunzell (DEKZL)",
   label: "Kunzell (DEKZL)"
  },
  {
   value: "Künzelsau (DEKUE)",
   label: "Künzelsau (DEKUE)"
  },
  {
   value: "Küps (DEKPS)",
   label: "Küps (DEKPS)"
  },
  {
   value: "Kusel (DEKUS)",
   label: "Kusel (DEKUS)"
  },
  {
   value: "Kaufbeuren (DEKAU)",
   label: "Kaufbeuren (DEKAU)"
  },
  {
   value: "Kaufering (DEKAG)",
   label: "Kaufering (DEKAG)"
  },
  {
   value: "Kehl (DEKEH)",
   label: "Kehl (DEKEH)"
  },
  {
   value: "Keitum\/Sylt (DEKEI)",
   label: "Keitum\/Sylt (DEKEI)"
  },
  {
   value: "Kelheim (DEKEM)",
   label: "Kelheim (DEKEM)"
  },
  {
   value: "Kelkheim (DEKHM)",
   label: "Kelkheim (DEKHM)"
  },
  {
   value: "Kellinghusen (DEKHN)",
   label: "Kellinghusen (DEKHN)"
  },
  {
   value: "Kellmünz (DEKEZ)",
   label: "Kellmünz (DEKEZ)"
  },
  {
   value: "Kelsterbach (DEKEB)",
   label: "Kelsterbach (DEKEB)"
  },
  {
   value: "Kemnath (DEKMH)",
   label: "Kemnath (DEKMH)"
  },
  {
   value: "Kempen (DEKMP)",
   label: "Kempen (DEKMP)"
  },
  {
   value: "Kempten (DEKEN)",
   label: "Kempten (DEKEN)"
  },
  {
   value: "Kernen (DEKNE)",
   label: "Kernen (DEKNE)"
  },
  {
   value: "Kerpen (DEKER)",
   label: "Kerpen (DEKER)"
  },
  {
   value: "Kevelaer (DEKEV)",
   label: "Kevelaer (DEKEV)"
  },
  {
   value: "Kiebitzreihe (DEKTZ)",
   label: "Kiebitzreihe (DEKTZ)"
  },
  {
   value: "Kiel (DEKEL)",
   label: "Kiel (DEKEL)"
  },
  {
   value: "Kietz (DEKIE)",
   label: "Kietz (DEKIE)"
  },
  {
   value: "Kinderbörn (DEKBR)",
   label: "Kinderbörn (DEKBR)"
  },
  {
   value: "Kindsbach (DEKDB)",
   label: "Kindsbach (DEKDB)"
  },
  {
   value: "Kippenheim (DEKIP)",
   label: "Kippenheim (DEKIP)"
  },
  {
   value: "Kirchdorf (Iller) (DEKDF)",
   label: "Kirchdorf (Iller) (DEKDF)"
  },
  {
   value: "Kirchen (DEKCN)",
   label: "Kirchen (DEKCN)"
  },
  {
   value: "Kirchhain (DEKHH)",
   label: "Kirchhain (DEKHH)"
  },
  {
   value: "Kirchheim (?) (DEKCI)",
   label: "Kirchheim (?) (DEKCI)"
  },
  {
   value: "Kirchheim (Unterf.)(?) (DEKUR)",
   label: "Kirchheim (Unterf.)(?) (DEKUR)"
  },
  {
   value: "Kirchheim\/Teck (DEKIR)",
   label: "Kirchheim\/Teck (DEKIR)"
  },
  {
   value: "Kirchheimbolanden (DEKRC)",
   label: "Kirchheimbolanden (DEKRC)"
  },
  {
   value: "Kirchlengern (DEKLG)",
   label: "Kirchlengern (DEKLG)"
  },
  {
   value: "Kirchlinteln (DEKLN)",
   label: "Kirchlinteln (DEKLN)"
  },
  {
   value: "Kirn\/Nahe (DEKIN)",
   label: "Kirn\/Nahe (DEKIN)"
  },
  {
   value: "Kirrweiler (DEKRY)",
   label: "Kirrweiler (DEKRY)"
  },
  {
   value: "Kissing (DEKSG)",
   label: "Kissing (DEKSG)"
  },
  {
   value: "Kitzingen (DEKIT)",
   label: "Kitzingen (DEKIT)"
  },
  {
   value: "Kleinaitingen (DEKTG)",
   label: "Kleinaitingen (DEKTG)"
  },
  {
   value: "Kleinheubach (DEKLH)",
   label: "Kleinheubach (DEKLH)"
  },
  {
   value: "Kleve (DEKLE)",
   label: "Kleve (DEKLE)"
  },
  {
   value: "Klingenberg (DEKLI)",
   label: "Klingenberg (DEKLI)"
  },
  {
   value: "Knautnaundorf (?) (DEKNF)",
   label: "Knautnaundorf (?) (DEKNF)"
  },
  {
   value: "Ilmenau (DEINU)",
   label: "Ilmenau (DEINU)"
  },
  {
   value: "Immenhausen (DEIHN)",
   label: "Immenhausen (DEIHN)"
  },
  {
   value: "Immenstadt (DEIMM)",
   label: "Immenstadt (DEIMM)"
  },
  {
   value: "Ingelheim (DEINM)",
   label: "Ingelheim (DEINM)"
  },
  {
   value: "Ingolstadt (DEING)",
   label: "Ingolstadt (DEING)"
  },
  {
   value: "Ingolstadt (DEINS)",
   label: "Ingolstadt (DEINS)"
  },
  {
   value: "Iserlohn (DEISE)",
   label: "Iserlohn (DEISE)"
  },
  {
   value: "Isernhagen (DEISN)",
   label: "Isernhagen (DEISN)"
  },
  {
   value: "Itzehoe (DEITZ)",
   label: "Itzehoe (DEITZ)"
  },
  {
   value: "Jagstzell (DEJAG)",
   label: "Jagstzell (DEJAG)"
  },
  {
   value: "Jandelsbrunn (DEJNB)",
   label: "Jandelsbrunn (DEJNB)"
  },
  {
   value: "Jemgum (DEJEM)",
   label: "Jemgum (DEJEM)"
  },
  {
   value: "Jena (DEJEN)",
   label: "Jena (DEJEN)"
  },
  {
   value: "Johnsdorf (DEJFD)",
   label: "Johnsdorf (DEJFD)"
  },
  {
   value: "Jork (DEJOR)",
   label: "Jork (DEJOR)"
  },
  {
   value: "Juist (DEJUI)",
   label: "Juist (DEJUI)"
  },
  {
   value: "Jülich (DEJUE)",
   label: "Jülich (DEJUE)"
  },
  {
   value: "Jünkerath (DEJUH)",
   label: "Jünkerath (DEJUH)"
  },
  {
   value: "Kaarst (DEKAA)",
   label: "Kaarst (DEKAA)"
  },
  {
   value: "Kahl am Main (DEKAM)",
   label: "Kahl am Main (DEKAM)"
  },
  {
   value: "Kaisermühle\/Eifel (DEKAI)",
   label: "Kaisermühle\/Eifel (DEKAI)"
  },
  {
   value: "Kaiserslautern (DEKLT)",
   label: "Kaiserslautern (DEKLT)"
  },
  {
   value: "Kalefeld (DEYRW)",
   label: "Kalefeld (DEYRW)"
  },
  {
   value: "Kalenborn\/Ahrweiler (DEKAN)",
   label: "Kalenborn\/Ahrweiler (DEKAN)"
  },
  {
   value: "Kalkar (DEKKR)",
   label: "Kalkar (DEKKR)"
  },
  {
   value: "Kall (DEKAL)",
   label: "Kall (DEKAL)"
  },
  {
   value: "Kalletal (DEKTL)",
   label: "Kalletal (DEKTL)"
  },
  {
   value: "Kaltenkirchen (DEKKN)",
   label: "Kaltenkirchen (DEKKN)"
  },
  {
   value: "Kamen (DEKMN)",
   label: "Kamen (DEKMN)"
  },
  {
   value: "Kamenz (DEKAZ)",
   label: "Kamenz (DEKAZ)"
  },
  {
   value: "Kampe (DEKPE)",
   label: "Kampe (DEKPE)"
  },
  {
   value: "Kappeln (DEKAP)",
   label: "Kappeln (DEKAP)"
  },
  {
   value: "Karben (DEKBN)",
   label: "Karben (DEKBN)"
  },
  {
   value: "Karlsfeld (DEKAD)",
   label: "Karlsfeld (DEKAD)"
  },
  {
   value: "Karlsruhe (DEKAE)",
   label: "Karlsruhe (DEKAE)"
  },
  {
   value: "Karlstein am Main (DEKSN)",
   label: "Karlstein am Main (DEKSN)"
  },
  {
   value: "Karnin (DEKAR)",
   label: "Karnin (DEKAR)"
  },
  {
   value: "Karpfham (DEKRF)",
   label: "Karpfham (DEKRF)"
  },
  {
   value: "Kassel (DEKAS)",
   label: "Kassel (DEKAS)"
  },
  {
   value: "Katterbach (DEKTT)",
   label: "Katterbach (DEKTT)"
  },
  {
   value: "Hollage (DEHOL)",
   label: "Hollage (DEHOL)"
  },
  {
   value: "Höllriegelskreuth (DEHLR)",
   label: "Höllriegelskreuth (DEHLR)"
  },
  {
   value: "Holm (DEHLX)",
   label: "Holm (DEHLX)"
  },
  {
   value: "Holtenau (DEHTU)",
   label: "Holtenau (DEHTU)"
  },
  {
   value: "Holtsee (DEHLS)",
   label: "Holtsee (DEHLS)"
  },
  {
   value: "Holzkirchen (DEHKN)",
   label: "Holzkirchen (DEHKN)"
  },
  {
   value: "Holzminden (DEHZN)",
   label: "Holzminden (DEHZN)"
  },
  {
   value: "Holzwickede (DEHZE)",
   label: "Holzwickede (DEHZE)"
  },
  {
   value: "Homberg (DEHBO)",
   label: "Homberg (DEHBO)"
  },
  {
   value: "Homburg (DEHOM)",
   label: "Homburg (DEHOM)"
  },
  {
   value: "Hooksiel (DEHOO)",
   label: "Hooksiel (DEHOO)"
  },
  {
   value: "Hoppstädten-Weiersbach (DEHOW)",
   label: "Hoppstädten-Weiersbach (DEHOW)"
  },
  {
   value: "Horb (DEHOB)",
   label: "Horb (DEHOB)"
  },
  {
   value: "Horka (DEHOR)",
   label: "Horka (DEHOR)"
  },
  {
   value: "Hornbach (DEHBC)",
   label: "Hornbach (DEHBC)"
  },
  {
   value: "Horneburg (DEHRB)",
   label: "Horneburg (DEHRB)"
  },
  {
   value: "Hörnum\/Sylt (DEHRM)",
   label: "Hörnum\/Sylt (DEHRM)"
  },
  {
   value: "Hörstel (DEHRL)",
   label: "Hörstel (DEHRL)"
  },
  {
   value: "Horumersiel (DEHOS)",
   label: "Horumersiel (DEHOS)"
  },
  {
   value: "Hösbach (DEHBH)",
   label: "Hösbach (DEHBH)"
  },
  {
   value: "Höxter (DEHOX)",
   label: "Höxter (DEHOX)"
  },
  {
   value: "Hoyerswerda (DEHWE)",
   label: "Hoyerswerda (DEHWE)"
  },
  {
   value: "Hückelhoven (DEHVN)",
   label: "Hückelhoven (DEHVN)"
  },
  {
   value: "Hückeswagen (DEHWG)",
   label: "Hückeswagen (DEHWG)"
  },
  {
   value: "Hüllhorst (DEHHT)",
   label: "Hüllhorst (DEHHT)"
  },
  {
   value: "Hünfeld (DEHUD)",
   label: "Hünfeld (DEHUD)"
  },
  {
   value: "Hünfelden (DEHFN)",
   label: "Hünfelden (DEHFN)"
  },
  {
   value: "Hungen (DEHUG)",
   label: "Hungen (DEHUG)"
  },
  {
   value: "Hünxe (DEHXE)",
   label: "Hünxe (DEHXE)"
  },
  {
   value: "Hüpflingen (?) (DEHPF)",
   label: "Hüpflingen (?) (DEHPF)"
  },
  {
   value: "Hürth (DEHUE)",
   label: "Hürth (DEHUE)"
  },
  {
   value: "Husum (DEHUS)",
   label: "Husum (DEHUS)"
  },
  {
   value: "Hüttisheim (DEHTM)",
   label: "Hüttisheim (DEHTM)"
  },
  {
   value: "Ibbenbüren (DEIBB)",
   label: "Ibbenbüren (DEIBB)"
  },
  {
   value: "Idar-Oberstein (DEION)",
   label: "Idar-Oberstein (DEION)"
  },
  {
   value: "Idstein (DEIDS)",
   label: "Idstein (DEIDS)"
  },
  {
   value: "Ilbesheim (DEILB)",
   label: "Ilbesheim (DEILB)"
  },
  {
   value: "Illertissen (DEILN)",
   label: "Illertissen (DEILN)"
  },
  {
   value: "Illesheim (DEILM)",
   label: "Illesheim (DEILM)"
  },
  {
   value: "Illingen (DEILL)",
   label: "Illingen (DEILL)"
  },
  {
   value: "Hersbruck (DEHEK)",
   label: "Hersbruck (DEHEK)"
  },
  {
   value: "Herscheid (DEHSD)",
   label: "Herscheid (DEHSD)"
  },
  {
   value: "Herzberg (DEHBG)",
   label: "Herzberg (DEHBG)"
  },
  {
   value: "Herzogenaurach (DEHZH)",
   label: "Herzogenaurach (DEHZH)"
  },
  {
   value: "Herzogenrath (DEHZR)",
   label: "Herzogenrath (DEHZR)"
  },
  {
   value: "Hessisch Lichtenau (DEHLI)",
   label: "Hessisch Lichtenau (DEHLI)"
  },
  {
   value: "Hetzerath (DEHTZ)",
   label: "Hetzerath (DEHTZ)"
  },
  {
   value: "Heubach (DEHEU)",
   label: "Heubach (DEHEU)"
  },
  {
   value: "Heuchelheim (DEHCH)",
   label: "Heuchelheim (DEHCH)"
  },
  {
   value: "Heusenstamm (DEHSM)",
   label: "Heusenstamm (DEHSM)"
  },
  {
   value: "Hiddenhausen (DEHIN)",
   label: "Hiddenhausen (DEHIN)"
  },
  {
   value: "Hilchenbach (DEHIH)",
   label: "Hilchenbach (DEHIH)"
  },
  {
   value: "Hilden (DEHID)",
   label: "Hilden (DEHID)"
  },
  {
   value: "Hildesheim (DEHIL)",
   label: "Hildesheim (DEHIL)"
  },
  {
   value: "Hille (DEHIE)",
   label: "Hille (DEHIE)"
  },
  {
   value: "Hilter (DEHIR)",
   label: "Hilter (DEHIR)"
  },
  {
   value: "Hindelang (DEHDL)",
   label: "Hindelang (DEHDL)"
  },
  {
   value: "Hinter Weidenthal (DEHWT)",
   label: "Hinter Weidenthal (DEHWT)"
  },
  {
   value: "Hirschau (DEHIU)",
   label: "Hirschau (DEHIU)"
  },
  {
   value: "Hirschhorn (DEHHN)",
   label: "Hirschhorn (DEHHN)"
  },
  {
   value: "Hochdonn (DEHOD)",
   label: "Hochdonn (DEHOD)"
  },
  {
   value: "Hochheim (DEHHH)",
   label: "Hochheim (DEHHH)"
  },
  {
   value: "Hochspeyer (DEHSP)",
   label: "Hochspeyer (DEHSP)"
  },
  {
   value: "Höchst im Odenwald (DEHOE)",
   label: "Höchst im Odenwald (DEHOE)"
  },
  {
   value: "Höchstadt an der Aisch (DEHOT)",
   label: "Höchstadt an der Aisch (DEHOT)"
  },
  {
   value: "Hockenheim (DEHOC)",
   label: "Hockenheim (DEHOC)"
  },
  {
   value: "Hof (DEHOQ)",
   label: "Hof (DEHOQ)"
  },
  {
   value: "Hofgeismar (DEHGM)",
   label: "Hofgeismar (DEHGM)"
  },
  {
   value: "Hofheim\/Taunus (DEHFH)",
   label: "Hofheim\/Taunus (DEHFH)"
  },
  {
   value: "Hohenbrunn (DEHGA)",
   label: "Hohenbrunn (DEHGA)"
  },
  {
   value: "Hohenburg (DEHOG)",
   label: "Hohenburg (DEHOG)"
  },
  {
   value: "Hohenfels (DEHFS)",
   label: "Hohenfels (DEHFS)"
  },
  {
   value: "Hohenhorn (DEHHS)",
   label: "Hohenhorn (DEHHS)"
  },
  {
   value: "Hohenkirchen (DEHKH)",
   label: "Hohenkirchen (DEHKH)"
  },
  {
   value: "Hohenlimburg (DEHLG)",
   label: "Hohenlimburg (DEHLG)"
  },
  {
   value: "Hohenlockstedt (DEHOH)",
   label: "Hohenlockstedt (DEHOH)"
  },
  {
   value: "Hohensaaten (DEHSA)",
   label: "Hohensaaten (DEHSA)"
  },
  {
   value: "Hohenwestedt (DEHHW)",
   label: "Hohenwestedt (DEHHW)"
  },
  {
   value: "Höhr-Grenzhausen (DEHGN)",
   label: "Höhr-Grenzhausen (DEHGN)"
  },
  {
   value: "Heidelberg (DEHEI)",
   label: "Heidelberg (DEHEI)"
  },
  {
   value: "Heiden\/Borken (DEHDN)",
   label: "Heiden\/Borken (DEHDN)"
  },
  {
   value: "Heidenheim (DEHEM)",
   label: "Heidenheim (DEHEM)"
  },
  {
   value: "Heidesheim (DEHSI)",
   label: "Heidesheim (DEHSI)"
  },
  {
   value: "Heikendorf (DEHED)",
   label: "Heikendorf (DEHED)"
  },
  {
   value: "Heilbronn (DEHEN)",
   label: "Heilbronn (DEHEN)"
  },
  {
   value: "Heiligenhafen (DEHHF)",
   label: "Heiligenhafen (DEHHF)"
  },
  {
   value: "Heiligenhaus\/Mettmann (DEHES)",
   label: "Heiligenhaus\/Mettmann (DEHES)"
  },
  {
   value: "Heiligenstadt (DEHGS)",
   label: "Heiligenstadt (DEHGS)"
  },
  {
   value: "Heimenkirch (DEHEH)",
   label: "Heimenkirch (DEHEH)"
  },
  {
   value: "Heimstetten (DEHTT)",
   label: "Heimstetten (DEHTT)"
  },
  {
   value: "Heinsberg (DEHEG)",
   label: "Heinsberg (DEHEG)"
  },
  {
   value: "Helgoland I. (DEHGL)",
   label: "Helgoland I. (DEHGL)"
  },
  {
   value: "Hellenthal (DEHTL)",
   label: "Hellenthal (DEHTL)"
  },
  {
   value: "Helmstedt (DEHEL)",
   label: "Helmstedt (DEHEL)"
  },
  {
   value: "Heltersberg (DEHTE)",
   label: "Heltersberg (DEHTE)"
  },
  {
   value: "Hemer (DEHMR)",
   label: "Hemer (DEHMR)"
  },
  {
   value: "Hemhofen (DEHMH)",
   label: "Hemhofen (DEHMH)"
  },
  {
   value: "Hemmoor (DEHMO)",
   label: "Hemmoor (DEHMO)"
  },
  {
   value: "Hengersberg (DEHGB)",
   label: "Hengersberg (DEHGB)"
  },
  {
   value: "Hennef (DEHEF)",
   label: "Hennef (DEHEF)"
  },
  {
   value: "Henstedt Ulzburg (DEHUZ)",
   label: "Henstedt Ulzburg (DEHUZ)"
  },
  {
   value: "Heppenheim (DEHEP)",
   label: "Heppenheim (DEHEP)"
  },
  {
   value: "Herborn (DEHBN)",
   label: "Herborn (DEHBN)"
  },
  {
   value: "Herbrechtingen (DEHER)",
   label: "Herbrechtingen (DEHER)"
  },
  {
   value: "Herbrum (DEHBR)",
   label: "Herbrum (DEHBR)"
  },
  {
   value: "Herdecke (DEHCK)",
   label: "Herdecke (DEHCK)"
  },
  {
   value: "Herford (DEHRD)",
   label: "Herford (DEHRD)"
  },
  {
   value: "Heringen (DEHRG)",
   label: "Heringen (DEHRG)"
  },
  {
   value: "Heringen (DEHRI)",
   label: "Heringen (DEHRI)"
  },
  {
   value: "Heringsdorf (DEHDF)",
   label: "Heringsdorf (DEHDF)"
  },
  {
   value: "Herleshausen (DEHHA)",
   label: "Herleshausen (DEHHA)"
  },
  {
   value: "Hermaringen (DEHMG)",
   label: "Hermaringen (DEHMG)"
  },
  {
   value: "Hermeskeil (DEHMK)",
   label: "Hermeskeil (DEHMK)"
  },
  {
   value: "Herne (DEHEE)",
   label: "Herne (DEHEE)"
  },
  {
   value: "Heroldstatt (DEHET)",
   label: "Heroldstatt (DEHET)"
  },
  {
   value: "Herrenberg (DEHNG)",
   label: "Herrenberg (DEHNG)"
  },
  {
   value: "Herrenhausen (DEHRR)",
   label: "Herrenhausen (DEHRR)"
  },
  {
   value: "Herringshausen (DEHRH)",
   label: "Herringshausen (DEHRH)"
  },
  {
   value: "Halle (DEHAL)",
   label: "Halle (DEHAL)"
  },
  {
   value: "Hallenberg-Hesborn (DEHHB)",
   label: "Hallenberg-Hesborn (DEHHB)"
  },
  {
   value: "Hallig-Hooge (DEHGE)",
   label: "Hallig-Hooge (DEHGE)"
  },
  {
   value: "Hallstadt (DEHLT)",
   label: "Hallstadt (DEHLT)"
  },
  {
   value: "Halstenbek (DEHAK)",
   label: "Halstenbek (DEHAK)"
  },
  {
   value: "Haltern (DEHTN)",
   label: "Haltern (DEHTN)"
  },
  {
   value: "Halver (DEHVR)",
   label: "Halver (DEHVR)"
  },
  {
   value: "Hamburg (DEHAM)",
   label: "Hamburg (DEHAM)"
  },
  {
   value: "Hamburg-Harburg (DEHBU)",
   label: "Hamburg-Harburg (DEHBU)"
  },
  {
   value: "Hameln (DEHAN)",
   label: "Hameln (DEHAN)"
  },
  {
   value: "Hamm (DEHMM)",
   label: "Hamm (DEHMM)"
  },
  {
   value: "Hamm (Sieg) (DEHXM)",
   label: "Hamm (Sieg) (DEHXM)"
  },
  {
   value: "Hamminkeln (DEHKL)",
   label: "Hamminkeln (DEHKL)"
  },
  {
   value: "Hanau (DEHAU)",
   label: "Hanau (DEHAU)"
  },
  {
   value: "Hannmünden (DEHMU)",
   label: "Hannmünden (DEHMU)"
  },
  {
   value: "Hannover (DEHAJ)",
   label: "Hannover (DEHAJ)"
  },
  {
   value: "Harbergen (DEHHZ)",
   label: "Harbergen (DEHHZ)"
  },
  {
   value: "Hardheim (DEHDH)",
   label: "Hardheim (DEHDH)"
  },
  {
   value: "Hardt-Nürtingen (DEHNT)",
   label: "Hardt-Nürtingen (DEHNT)"
  },
  {
   value: "Haren\/Ems (DEHRN)",
   label: "Haren\/Ems (DEHRN)"
  },
  {
   value: "Harlingrode (DEHGR)",
   label: "Harlingrode (DEHGR)"
  },
  {
   value: "Harrislee (DEHLE)",
   label: "Harrislee (DEHLE)"
  },
  {
   value: "Harsewinkel (DEHWL)",
   label: "Harsewinkel (DEHWL)"
  },
  {
   value: "Harsum (DEHRS)",
   label: "Harsum (DEHRS)"
  },
  {
   value: "Haselmuhle (DEHLM)",
   label: "Haselmuhle (DEHLM)"
  },
  {
   value: "Haselunne (DEHNN)",
   label: "Haselunne (DEHNN)"
  },
  {
   value: "Haslach (DEHLC)",
   label: "Haslach (DEHLC)"
  },
  {
   value: "Hassfurt (DEHAS)",
   label: "Hassfurt (DEHAS)"
  },
  {
   value: "Hattersheim (DEHHM)",
   label: "Hattersheim (DEHHM)"
  },
  {
   value: "Hattingen (DEHAT)",
   label: "Hattingen (DEHAT)"
  },
  {
   value: "Hattorf am Harz (DEHRZ)",
   label: "Hattorf am Harz (DEHRZ)"
  },
  {
   value: "Hatzfeld (DEHZF)",
   label: "Hatzfeld (DEHZF)"
  },
  {
   value: "Hauenstein (DEHUT)",
   label: "Hauenstein (DEHUT)"
  },
  {
   value: "Haupstuhl (DEHSL)",
   label: "Haupstuhl (DEHSL)"
  },
  {
   value: "Hausach (DEHSH)",
   label: "Hausach (DEHSH)"
  },
  {
   value: "Hauzenberg (DEHZB)",
   label: "Hauzenberg (DEHZB)"
  },
  {
   value: "Hawangen (DEHWA)",
   label: "Hawangen (DEHWA)"
  },
  {
   value: "Hechingen (DEHEC)",
   label: "Hechingen (DEHEC)"
  },
  {
   value: "Heddesheim (DEHDM)",
   label: "Heddesheim (DEHDM)"
  },
  {
   value: "Heide (DEHDE)",
   label: "Heide (DEHDE)"
  },
  {
   value: "Grönwohld (DEGRW)",
   label: "Grönwohld (DEGRW)"
  },
  {
   value: "Gross Glienicke (DEGGE)",
   label: "Gross Glienicke (DEGGE)"
  },
  {
   value: "Gross Krotzenburg (DEGKG)",
   label: "Gross Krotzenburg (DEGKG)"
  },
  {
   value: "Gross Steinberg (DEGSB)",
   label: "Gross Steinberg (DEGSB)"
  },
  {
   value: "Gross Ziethen (DEGZN)",
   label: "Gross Ziethen (DEGZN)"
  },
  {
   value: "Gross-Gerau (DEGRG)",
   label: "Gross-Gerau (DEGRG)"
  },
  {
   value: "Grossalmerode (DEGSM)",
   label: "Grossalmerode (DEGSM)"
  },
  {
   value: "Grossenbrode (DEGRO)",
   label: "Grossenbrode (DEGRO)"
  },
  {
   value: "Grossenhain (DEGSH)",
   label: "Grossenhain (DEGSH)"
  },
  {
   value: "Grosspostwitz (DEGWP)",
   label: "Grosspostwitz (DEGWP)"
  },
  {
   value: "Grosswallstsdt (DEGWS)",
   label: "Grosswallstsdt (DEGWS)"
  },
  {
   value: "Gruenenplan (DEGRP)",
   label: "Gruenenplan (DEGRP)"
  },
  {
   value: "Grünberg (DEGRU)",
   label: "Grünberg (DEGRU)"
  },
  {
   value: "Grünkraut (DEGKT)",
   label: "Grünkraut (DEGKT)"
  },
  {
   value: "Grünstadt (DEGRT)",
   label: "Grünstadt (DEGRT)"
  },
  {
   value: "Guben (DEGUB)",
   label: "Guben (DEGUB)"
  },
  {
   value: "Güglingen (DEGGI)",
   label: "Güglingen (DEGGI)"
  },
  {
   value: "Güldengossa (?) (DEGGS)",
   label: "Güldengossa (?) (DEGGS)"
  },
  {
   value: "Guldental (DEGUL)",
   label: "Guldental (DEGUL)"
  },
  {
   value: "Gummersbach (DEGUM)",
   label: "Gummersbach (DEGUM)"
  },
  {
   value: "Gundelsheim (DEGUN)",
   label: "Gundelsheim (DEGUN)"
  },
  {
   value: "Günzburg (DEGUG)",
   label: "Günzburg (DEGUG)"
  },
  {
   value: "Gunzenhausen (DEGUH)",
   label: "Gunzenhausen (DEGUH)"
  },
  {
   value: "Gussenstadt (DEGUS)",
   label: "Gussenstadt (DEGUS)"
  },
  {
   value: "Güstrow (DEGUW)",
   label: "Güstrow (DEGUW)"
  },
  {
   value: "Gütersloh (DEGUT)",
   label: "Gütersloh (DEGUT)"
  },
  {
   value: "Haan (DEHAA)",
   label: "Haan (DEHAA)"
  },
  {
   value: "Hachenburg (DEHAC)",
   label: "Hachenburg (DEHAC)"
  },
  {
   value: "Hafenlohr (DEHAF)",
   label: "Hafenlohr (DEHAF)"
  },
  {
   value: "Hagen (DEHAG)",
   label: "Hagen (DEHAG)"
  },
  {
   value: "Hagenow (DEHAW)",
   label: "Hagenow (DEHAW)"
  },
  {
   value: "Haibach\/Aschaffenburg (DEHAI)",
   label: "Haibach\/Aschaffenburg (DEHAI)"
  },
  {
   value: "Haiger (DEHAR)",
   label: "Haiger (DEHAR)"
  },
  {
   value: "Haimhausen (DEHHU)",
   label: "Haimhausen (DEHHU)"
  },
  {
   value: "Hainburg (DEHLU)",
   label: "Hainburg (DEHLU)"
  },
  {
   value: "Haiterbach (DEHAH)",
   label: "Haiterbach (DEHAH)"
  },
  {
   value: "Halberstadt (DEHST)",
   label: "Halberstadt (DEHST)"
  },
  {
   value: "Haldensleben (DEHLH)",
   label: "Haldensleben (DEHLH)"
  },
  {
   value: "Halle (DEHAE)",
   label: "Halle (DEHAE)"
  },
  {
   value: "Gladbeck (DEGLA)",
   label: "Gladbeck (DEGLA)"
  },
  {
   value: "Gladenbach (DEGLH)",
   label: "Gladenbach (DEGLH)"
  },
  {
   value: "Glatten (DEGLN)",
   label: "Glatten (DEGLN)"
  },
  {
   value: "Glauchau (DEGHU)",
   label: "Glauchau (DEGHU)"
  },
  {
   value: "Glinde (DEGDE)",
   label: "Glinde (DEGDE)"
  },
  {
   value: "Glückstadt (DEGLU)",
   label: "Glückstadt (DEGLU)"
  },
  {
   value: "Gmund (DEGMU)",
   label: "Gmund (DEGMU)"
  },
  {
   value: "Gnarrenburg (DEGNA)",
   label: "Gnarrenburg (DEGNA)"
  },
  {
   value: "Goch (DEGOC)",
   label: "Goch (DEGOC)"
  },
  {
   value: "Gochsheim (DEGOH)",
   label: "Gochsheim (DEGOH)"
  },
  {
   value: "Gomaringen (DEGOM)",
   label: "Gomaringen (DEGOM)"
  },
  {
   value: "Gönnersdorf (DEGNN)",
   label: "Gönnersdorf (DEGNN)"
  },
  {
   value: "Göppingen (DEGON)",
   label: "Göppingen (DEGON)"
  },
  {
   value: "Görisried (DEGRS)",
   label: "Görisried (DEGRS)"
  },
  {
   value: "Görlitz (DEGOR)",
   label: "Görlitz (DEGOR)"
  },
  {
   value: "Goslar (DEGOS)",
   label: "Goslar (DEGOS)"
  },
  {
   value: "Gotha (DEGOA)",
   label: "Gotha (DEGOA)"
  },
  {
   value: "Göttingen (DEGOE)",
   label: "Göttingen (DEGOE)"
  },
  {
   value: "Gottmadingen (DEGOT)",
   label: "Gottmadingen (DEGOT)"
  },
  {
   value: "Gotz (DEGOZ)",
   label: "Gotz (DEGOZ)"
  },
  {
   value: "Graben-Neudorf (DEGRN)",
   label: "Graben-Neudorf (DEGRN)"
  },
  {
   value: "Gräfelfing (DEGRF)",
   label: "Gräfelfing (DEGRF)"
  },
  {
   value: "Grafenau (DEGFN)",
   label: "Grafenau (DEGFN)"
  },
  {
   value: "Grafenwöhr (DEGRR)",
   label: "Grafenwöhr (DEGRR)"
  },
  {
   value: "Grambow (DEGRA)",
   label: "Grambow (DEGRA)"
  },
  {
   value: "Grasberg (DEGBG)",
   label: "Grasberg (DEGBG)"
  },
  {
   value: "Grebenhain (DEGHX)",
   label: "Grebenhain (DEGHX)"
  },
  {
   value: "Greetsiel (DEGRE)",
   label: "Greetsiel (DEGRE)"
  },
  {
   value: "Grefrath (DEGRH)",
   label: "Grefrath (DEGRH)"
  },
  {
   value: "Greifswald (DEGRD)",
   label: "Greifswald (DEGRD)"
  },
  {
   value: "Greiz (DEGRI)",
   label: "Greiz (DEGRI)"
  },
  {
   value: "Grenzach-Wyhlen (DEGWY)",
   label: "Grenzach-Wyhlen (DEGWY)"
  },
  {
   value: "Greppin (DEGPN)",
   label: "Greppin (DEGPN)"
  },
  {
   value: "Greven (DEGVN)",
   label: "Greven (DEGVN)"
  },
  {
   value: "Grevenbroich (DEGRV)",
   label: "Grevenbroich (DEGRV)"
  },
  {
   value: "Griesheim (DEGRM)",
   label: "Griesheim (DEGRM)"
  },
  {
   value: "Grimmenthal (DEGRL)",
   label: "Grimmenthal (DEGRL)"
  },
  {
   value: "Grinau (DEGIU)",
   label: "Grinau (DEGIU)"
  },
  {
   value: "Groditz (DEGTZ)",
   label: "Groditz (DEGTZ)"
  },
  {
   value: "Gronau (DEGNU)",
   label: "Gronau (DEGNU)"
  },
  {
   value: "Geilenkirchen (DEGKI)",
   label: "Geilenkirchen (DEGKI)"
  },
  {
   value: "Geinsheim (DEGIH)",
   label: "Geinsheim (DEGIH)"
  },
  {
   value: "Geisa (DEGIA)",
   label: "Geisa (DEGIA)"
  },
  {
   value: "Geisenheim (DEGEI)",
   label: "Geisenheim (DEGEI)"
  },
  {
   value: "Geislingen (DEGLI)",
   label: "Geislingen (DEGLI)"
  },
  {
   value: "Gelchsheim (DEGCH)",
   label: "Gelchsheim (DEGCH)"
  },
  {
   value: "Geldern (DEGDN)",
   label: "Geldern (DEGDN)"
  },
  {
   value: "Gelnhausen (DEGEH)",
   label: "Gelnhausen (DEGEH)"
  },
  {
   value: "Gelsenkirchen (DEGEK)",
   label: "Gelsenkirchen (DEGEK)"
  },
  {
   value: "Gelting (DEGEL)",
   label: "Gelting (DEGEL)"
  },
  {
   value: "Gemmingen (DEGMG)",
   label: "Gemmingen (DEGMG)"
  },
  {
   value: "Gemünden (DEGEM)",
   label: "Gemünden (DEGEM)"
  },
  {
   value: "Gengenbach (DEGGH)",
   label: "Gengenbach (DEGGH)"
  },
  {
   value: "Gensingen (DEGEN)",
   label: "Gensingen (DEGEN)"
  },
  {
   value: "Georgsdorf (DEGEO)",
   label: "Georgsdorf (DEGEO)"
  },
  {
   value: "Georgsmarienhütte (DEGMH)",
   label: "Georgsmarienhütte (DEGMH)"
  },
  {
   value: "Gera (DEGEA)",
   label: "Gera (DEGEA)"
  },
  {
   value: "Gerabronn (DEGBN)",
   label: "Gerabronn (DEGBN)"
  },
  {
   value: "Gerden (DEGEZ)",
   label: "Gerden (DEGEZ)"
  },
  {
   value: "Geretsried (DEGED)",
   label: "Geretsried (DEGED)"
  },
  {
   value: "Gerlingen (DEGLG)",
   label: "Gerlingen (DEGLG)"
  },
  {
   value: "Germersheim (DEGER)",
   label: "Germersheim (DEGER)"
  },
  {
   value: "Gernrode (DEGNE)",
   label: "Gernrode (DEGNE)"
  },
  {
   value: "Gernsbach (DEGBH)",
   label: "Gernsbach (DEGBH)"
  },
  {
   value: "Gernsheim (DEGHM)",
   label: "Gernsheim (DEGHM)"
  },
  {
   value: "Gerolstein (DEGES)",
   label: "Gerolstein (DEGES)"
  },
  {
   value: "Gerolzhofen (DEGZF)",
   label: "Gerolzhofen (DEGZF)"
  },
  {
   value: "Gersthofen (DEGHN)",
   label: "Gersthofen (DEGHN)"
  },
  {
   value: "Gescher (DEGSR)",
   label: "Gescher (DEGSR)"
  },
  {
   value: "Geseke (DEGEE)",
   label: "Geseke (DEGEE)"
  },
  {
   value: "Gevelsberg (DEGEB)",
   label: "Gevelsberg (DEGEB)"
  },
  {
   value: "Geversdorf (DEGEV)",
   label: "Geversdorf (DEGEV)"
  },
  {
   value: "Giebelstadt (DEGBT)",
   label: "Giebelstadt (DEGBT)"
  },
  {
   value: "Giengen (DEGGN)",
   label: "Giengen (DEGGN)"
  },
  {
   value: "Giessen (DEGIE)",
   label: "Giessen (DEGIE)"
  },
  {
   value: "Gifhorn (DEGIF)",
   label: "Gifhorn (DEGIF)"
  },
  {
   value: "Gimbsheim (DEGIM)",
   label: "Gimbsheim (DEGIM)"
  },
  {
   value: "Gingen an der Fils (DEGGF)",
   label: "Gingen an der Fils (DEGGF)"
  },
  {
   value: "Ginsheim-Gustavsburg (DEGIG)",
   label: "Ginsheim-Gustavsburg (DEGIG)"
  },
  {
   value: "Gittelde (DEGIT)",
   label: "Gittelde (DEGIT)"
  },
  {
   value: "Freiberg (DEFEG)",
   label: "Freiberg (DEFEG)"
  },
  {
   value: "Freiberg (DEFIG)",
   label: "Freiberg (DEFIG)"
  },
  {
   value: "Freiburg\/Breisgau (DEFBG)",
   label: "Freiburg\/Breisgau (DEFBG)"
  },
  {
   value: "Freigericht (DEFRT)",
   label: "Freigericht (DEFRT)"
  },
  {
   value: "Freilassing (DEFRL)",
   label: "Freilassing (DEFRL)"
  },
  {
   value: "Freising (DEFRG)",
   label: "Freising (DEFRG)"
  },
  {
   value: "Fresenburg (DEFRE)",
   label: "Fresenburg (DEFRE)"
  },
  {
   value: "Freudenstadt (DEFST)",
   label: "Freudenstadt (DEFST)"
  },
  {
   value: "Fridingen (DEFDG)",
   label: "Fridingen (DEFDG)"
  },
  {
   value: "Friedberg (DEFRB)",
   label: "Friedberg (DEFRB)"
  },
  {
   value: "Friedeburg (DEFIB)",
   label: "Friedeburg (DEFIB)"
  },
  {
   value: "Friedrichsdorf (DEFRF)",
   label: "Friedrichsdorf (DEFRF)"
  },
  {
   value: "Friedrichshafen (DEFDH)",
   label: "Friedrichshafen (DEFDH)"
  },
  {
   value: "Friedrichstadt (DEFRI)",
   label: "Friedrichstadt (DEFRI)"
  },
  {
   value: "Friesau (DEFRU)",
   label: "Friesau (DEFRU)"
  },
  {
   value: "Friesoythe (DEFYE)",
   label: "Friesoythe (DEFYE)"
  },
  {
   value: "Fritzlar (DEFRZ)",
   label: "Fritzlar (DEFRZ)"
  },
  {
   value: "Fröndenberg (DEFDB)",
   label: "Fröndenberg (DEFDB)"
  },
  {
   value: "Fulda (DEFUL)",
   label: "Fulda (DEFUL)"
  },
  {
   value: "Fuldstal (DEFUT)",
   label: "Fuldstal (DEFUT)"
  },
  {
   value: "Fürfield (DEFFD)",
   label: "Fürfield (DEFFD)"
  },
  {
   value: "Fürstenfeldbruck (DEFEL)",
   label: "Fürstenfeldbruck (DEFEL)"
  },
  {
   value: "Fürstenwalde (DEFTE)",
   label: "Fürstenwalde (DEFTE)"
  },
  {
   value: "Fürth (DEFUE)",
   label: "Fürth (DEFUE)"
  },
  {
   value: "Furth im Wald (DEFUW)",
   label: "Furth im Wald (DEFUW)"
  },
  {
   value: "Füssen (DEFSS)",
   label: "Füssen (DEFSS)"
  },
  {
   value: "Gablingen (DEGAB)",
   label: "Gablingen (DEGAB)"
  },
  {
   value: "Gaggenau (DEGAG)",
   label: "Gaggenau (DEGAG)"
  },
  {
   value: "Gaildorf (DEGAI)",
   label: "Gaildorf (DEGAI)"
  },
  {
   value: "Ganderkesee (DEGAN)",
   label: "Ganderkesee (DEGAN)"
  },
  {
   value: "Garching an der Alz (DEGAA)",
   label: "Garching an der Alz (DEGAA)"
  },
  {
   value: "Garching bei München (DEGBM)",
   label: "Garching bei München (DEGBM)"
  },
  {
   value: "Gardelegen (DEGAR)",
   label: "Gardelegen (DEGAR)"
  },
  {
   value: "Garlstedt (DEGAT)",
   label: "Garlstedt (DEGAT)"
  },
  {
   value: "Garmisch-Partenkirchen (DEGAP)",
   label: "Garmisch-Partenkirchen (DEGAP)"
  },
  {
   value: "Gartz (DEGRZ)",
   label: "Gartz (DEGRZ)"
  },
  {
   value: "Gedern (DEGNH)",
   label: "Gedern (DEGNH)"
  },
  {
   value: "Geeste (DEGST)",
   label: "Geeste (DEGST)"
  },
  {
   value: "Geesthacht (DEGET)",
   label: "Geesthacht (DEGET)"
  },
  {
   value: "Eschenlohe (DEESE)",
   label: "Eschenlohe (DEESE)"
  },
  {
   value: "Eschershausen (DEESN)",
   label: "Eschershausen (DEESN)"
  },
  {
   value: "Eschwege (DEESW)",
   label: "Eschwege (DEESW)"
  },
  {
   value: "Eschweiler (DEESR)",
   label: "Eschweiler (DEESR)"
  },
  {
   value: "Espelkamp (DEESP)",
   label: "Espelkamp (DEESP)"
  },
  {
   value: "Essen (DEESS)",
   label: "Essen (DEESS)"
  },
  {
   value: "Esslingen (DEESL)",
   label: "Esslingen (DEESL)"
  },
  {
   value: "Estorf\/Weser (DEESF)",
   label: "Estorf\/Weser (DEESF)"
  },
  {
   value: "Ettlingen (DEETT)",
   label: "Ettlingen (DEETT)"
  },
  {
   value: "Ettringen (DEETR)",
   label: "Ettringen (DEETR)"
  },
  {
   value: "Etzbach (DEETZ)",
   label: "Etzbach (DEETZ)"
  },
  {
   value: "Euskirchen (DEEUS)",
   label: "Euskirchen (DEEUS)"
  },
  {
   value: "Eutin (DEEUT)",
   label: "Eutin (DEEUT)"
  },
  {
   value: "Eutingen (DEETG)",
   label: "Eutingen (DEETG)"
  },
  {
   value: "Eystrup (DEEYP)",
   label: "Eystrup (DEEYP)"
  },
  {
   value: "Falkenhagen (DEFKN)",
   label: "Falkenhagen (DEFKN)"
  },
  {
   value: "Fallingbostel (DEFAL)",
   label: "Fallingbostel (DEFAL)"
  },
  {
   value: "Fehmarn (DEFEH)",
   label: "Fehmarn (DEFEH)"
  },
  {
   value: "Feldkirchen (DEFKR)",
   label: "Feldkirchen (DEFKR)"
  },
  {
   value: "Fellbach (DEFBH)",
   label: "Fellbach (DEFBH)"
  },
  {
   value: "Fernthal (DEFNL)",
   label: "Fernthal (DEFNL)"
  },
  {
   value: "Feucht (DEFEU)",
   label: "Feucht (DEFEU)"
  },
  {
   value: "Filderstadt (DEFIL)",
   label: "Filderstadt (DEFIL)"
  },
  {
   value: "Finkenwerder (DEXFW)",
   label: "Finkenwerder (DEXFW)"
  },
  {
   value: "Finnentrop (DEFIT)",
   label: "Finnentrop (DEFIT)"
  },
  {
   value: "Finsterwalde\/Niederlausitz (DEFIW)",
   label: "Finsterwalde\/Niederlausitz (DEFIW)"
  },
  {
   value: "Fischbach (DEFHB)",
   label: "Fischbach (DEFHB)"
  },
  {
   value: "Flensburg (DEFLF)",
   label: "Flensburg (DEFLF)"
  },
  {
   value: "Flörsheim am Main (DEFLO)",
   label: "Flörsheim am Main (DEFLO)"
  },
  {
   value: "Forchheim (DEFOH)",
   label: "Forchheim (DEFOH)"
  },
  {
   value: "Forst (DEFOR)",
   label: "Forst (DEFOR)"
  },
  {
   value: "Forsting (DEFTG)",
   label: "Forsting (DEFTG)"
  },
  {
   value: "Frankenberg (DEFKG)",
   label: "Frankenberg (DEFKG)"
  },
  {
   value: "Frankenthal (DEFTL)",
   label: "Frankenthal (DEFTL)"
  },
  {
   value: "Frankfurt\/Main (DEFRA)",
   label: "Frankfurt\/Main (DEFRA)"
  },
  {
   value: "Frankfurt\/Oder (DEFFO)",
   label: "Frankfurt\/Oder (DEFFO)"
  },
  {
   value: "Frechen (DEFRN)",
   label: "Frechen (DEFRN)"
  },
  {
   value: "Freden (DEFDN)",
   label: "Freden (DEFDN)"
  },
  {
   value: "Elztal (DEELL)",
   label: "Elztal (DEELL)"
  },
  {
   value: "Embsen (DEEMB)",
   label: "Embsen (DEEMB)"
  },
  {
   value: "Emden (DEEME)",
   label: "Emden (DEEME)"
  },
  {
   value: "Emlichheim (DEEML)",
   label: "Emlichheim (DEEML)"
  },
  {
   value: "Emmelsum (DEESU)",
   label: "Emmelsum (DEESU)"
  },
  {
   value: "Emmendingen (DEEMN)",
   label: "Emmendingen (DEEMN)"
  },
  {
   value: "Emmerich (DEEMM)",
   label: "Emmerich (DEEMM)"
  },
  {
   value: "Empfingen (DEEFG)",
   label: "Empfingen (DEEFG)"
  },
  {
   value: "Emsbüren (DEEMS)",
   label: "Emsbüren (DEEMS)"
  },
  {
   value: "Emsdetten (DEEDN)",
   label: "Emsdetten (DEEDN)"
  },
  {
   value: "Emskirchen (DEEKR)",
   label: "Emskirchen (DEEKR)"
  },
  {
   value: "Endingen (DEEND)",
   label: "Endingen (DEEND)"
  },
  {
   value: "Engelskirchen (DEEKI)",
   label: "Engelskirchen (DEEKI)"
  },
  {
   value: "Englesbrand (DEEBD)",
   label: "Englesbrand (DEEBD)"
  },
  {
   value: "Engstingen (DEEGT)",
   label: "Engstingen (DEEGT)"
  },
  {
   value: "Engter (DEENG)",
   label: "Engter (DEENG)"
  },
  {
   value: "Ennepetal (DEENN)",
   label: "Ennepetal (DEENN)"
  },
  {
   value: "Enningerloh (DEENH)",
   label: "Enningerloh (DEENH)"
  },
  {
   value: "Ensdorf (DEEDO)",
   label: "Ensdorf (DEEDO)"
  },
  {
   value: "Ense (DEENS)",
   label: "Ense (DEENS)"
  },
  {
   value: "Ense-Parsit (DEENP)",
   label: "Ense-Parsit (DEENP)"
  },
  {
   value: "Eppelheim (DEEPP)",
   label: "Eppelheim (DEEPP)"
  },
  {
   value: "Eppstein (DEEPS)",
   label: "Eppstein (DEEPS)"
  },
  {
   value: "Erbach\/Odenwald (DEERB)",
   label: "Erbach\/Odenwald (DEERB)"
  },
  {
   value: "Erbendorf (DEEDF)",
   label: "Erbendorf (DEEDF)"
  },
  {
   value: "Erding (DEERG)",
   label: "Erding (DEERG)"
  },
  {
   value: "Erdweg (DEERD)",
   label: "Erdweg (DEERD)"
  },
  {
   value: "Erftstadt (DEERT)",
   label: "Erftstadt (DEERT)"
  },
  {
   value: "Erfurt (DEERF)",
   label: "Erfurt (DEERF)"
  },
  {
   value: "Ergolding (DEEGD)",
   label: "Ergolding (DEEGD)"
  },
  {
   value: "Erkelenz (DEERK)",
   label: "Erkelenz (DEERK)"
  },
  {
   value: "Erkrath (DEERH)",
   label: "Erkrath (DEERH)"
  },
  {
   value: "Erlangen (DEERL)",
   label: "Erlangen (DEERL)"
  },
  {
   value: "Erlensee (DEERE)",
   label: "Erlensee (DEERE)"
  },
  {
   value: "Erndtebrück (DEERN)",
   label: "Erndtebrück (DEERN)"
  },
  {
   value: "Ernstthal (DEENT)",
   label: "Ernstthal (DEENT)"
  },
  {
   value: "Erwitte (DEERW)",
   label: "Erwitte (DEERW)"
  },
  {
   value: "Eschborn (DEESC)",
   label: "Eschborn (DEESC)"
  },
  {
   value: "Eschenbach (DEESH)",
   label: "Eschenbach (DEESH)"
  },
  {
   value: "Eschenburg (DEESG)",
   label: "Eschenburg (DEESG)"
  },
  {
   value: "Eberbach (DEEBB)",
   label: "Eberbach (DEEBB)"
  },
  {
   value: "Ebern (DEEBY)",
   label: "Ebern (DEEBY)"
  },
  {
   value: "Ebersbach (DEEBE)",
   label: "Ebersbach (DEEBE)"
  },
  {
   value: "Eberswalde (DEEBW)",
   label: "Eberswalde (DEEBW)"
  },
  {
   value: "Ebrach (DEEBR)",
   label: "Ebrach (DEEBR)"
  },
  {
   value: "Eching\/Freising (DEECH)",
   label: "Eching\/Freising (DEECH)"
  },
  {
   value: "Eckernförde (DEECK)",
   label: "Eckernförde (DEECK)"
  },
  {
   value: "Eckwardersiel (DEEWS)",
   label: "Eckwardersiel (DEEWS)"
  },
  {
   value: "Edenkoben (DEEKN)",
   label: "Edenkoben (DEEKN)"
  },
  {
   value: "Edersberg (DEEDB)",
   label: "Edersberg (DEEDB)"
  },
  {
   value: "Edewecht (DEEDT)",
   label: "Edewecht (DEEDT)"
  },
  {
   value: "Egelsbach (DEEGB)",
   label: "Egelsbach (DEEGB)"
  },
  {
   value: "Eggenfelden (DEEGG)",
   label: "Eggenfelden (DEEGG)"
  },
  {
   value: "Eggenstein-Leopoldshafen (DEEGL)",
   label: "Eggenstein-Leopoldshafen (DEEGL)"
  },
  {
   value: "Ehingen (DEEHI)",
   label: "Ehingen (DEEHI)"
  },
  {
   value: "Ehringshausen\/Lahn-Dill (DEEHR)",
   label: "Ehringshausen\/Lahn-Dill (DEEHR)"
  },
  {
   value: "Eichstätt (DEEIC)",
   label: "Eichstätt (DEEIC)"
  },
  {
   value: "Eichstetten (DEEST)",
   label: "Eichstetten (DEEST)"
  },
  {
   value: "Eiderdam (DEEDD)",
   label: "Eiderdam (DEEDD)"
  },
  {
   value: "Eilenburg (DEENB)",
   label: "Eilenburg (DEENB)"
  },
  {
   value: "Eimeldingen (DEEDG)",
   label: "Eimeldingen (DEEDG)"
  },
  {
   value: "Eimke (DEEIM)",
   label: "Eimke (DEEIM)"
  },
  {
   value: "Eimlichheim (DEEHH)",
   label: "Eimlichheim (DEEHH)"
  },
  {
   value: "Einbeck (DEEIB)",
   label: "Einbeck (DEEIB)"
  },
  {
   value: "Einsiedlerhof (DEEHF)",
   label: "Einsiedlerhof (DEEHF)"
  },
  {
   value: "Eisenach (DEEIS)",
   label: "Eisenach (DEEIS)"
  },
  {
   value: "Eisenberg (DEEBG)",
   label: "Eisenberg (DEEBG)"
  },
  {
   value: "Eisenhüttenstadt (DEEHS)",
   label: "Eisenhüttenstadt (DEEHS)"
  },
  {
   value: "Eisleben (DEEIN)",
   label: "Eisleben (DEEIN)"
  },
  {
   value: "Eislingen (DEELN)",
   label: "Eislingen (DEELN)"
  },
  {
   value: "Eitorf (DEEIF)",
   label: "Eitorf (DEEIF)"
  },
  {
   value: "Elchingen (DEELC)",
   label: "Elchingen (DEELC)"
  },
  {
   value: "Ellenbogen (DEEBN)",
   label: "Ellenbogen (DEEBN)"
  },
  {
   value: "Ellwangen (DEELW)",
   label: "Ellwangen (DEELW)"
  },
  {
   value: "Elmshorn (DEELM)",
   label: "Elmshorn (DEELM)"
  },
  {
   value: "Elsfleth (DEELS)",
   label: "Elsfleth (DEELS)"
  },
  {
   value: "Eltmann (DEETM)",
   label: "Eltmann (DEETM)"
  },
  {
   value: "Eltville (DEEVI)",
   label: "Eltville (DEEVI)"
  },
  {
   value: "Elze (DEELZ)",
   label: "Elze (DEELZ)"
  },
  {
   value: "Dillingen (DEDIL)",
   label: "Dillingen (DEDIL)"
  },
  {
   value: "Dingen (DEDGN)",
   label: "Dingen (DEDGN)"
  },
  {
   value: "Dingolfing (DEDFG)",
   label: "Dingolfing (DEDFG)"
  },
  {
   value: "Dinkelsbühl (DEDBL)",
   label: "Dinkelsbühl (DEDBL)"
  },
  {
   value: "Dinslaken (DEDIN)",
   label: "Dinslaken (DEDIN)"
  },
  {
   value: "Dippoldiswalde (DEDPW)",
   label: "Dippoldiswalde (DEDPW)"
  },
  {
   value: "Dissen (DEDIS)",
   label: "Dissen (DEDIS)"
  },
  {
   value: "Ditzingen (DEDTN)",
   label: "Ditzingen (DEDTN)"
  },
  {
   value: "Ditzum (DEDIT)",
   label: "Ditzum (DEDIT)"
  },
  {
   value: "Döbeln (DEDOE)",
   label: "Döbeln (DEDOE)"
  },
  {
   value: "Döberitz (DEDOZ)",
   label: "Döberitz (DEDOZ)"
  },
  {
   value: "Donaueschingen (DEDEN)",
   label: "Donaueschingen (DEDEN)"
  },
  {
   value: "Donauwörth (DEDOW)",
   label: "Donauwörth (DEDOW)"
  },
  {
   value: "Dorentrup (DEDTP)",
   label: "Dorentrup (DEDTP)"
  },
  {
   value: "Dorfen (DEDOF)",
   label: "Dorfen (DEDOF)"
  },
  {
   value: "Dormagen (DEDMG)",
   label: "Dormagen (DEDMG)"
  },
  {
   value: "Dornbusch (DEDOB)",
   label: "Dornbusch (DEDOB)"
  },
  {
   value: "Dornstetten (DEDSN)",
   label: "Dornstetten (DEDSN)"
  },
  {
   value: "Dörpen (DEDRP)",
   label: "Dörpen (DEDRP)"
  },
  {
   value: "Dorsten (DEDON)",
   label: "Dorsten (DEDON)"
  },
  {
   value: "Dortmund (DEDTM)",
   label: "Dortmund (DEDTM)"
  },
  {
   value: "Dossenheim (DEDSM)",
   label: "Dossenheim (DEDSM)"
  },
  {
   value: "Dranske (DEDRA)",
   label: "Dranske (DEDRA)"
  },
  {
   value: "Dreieich (DEDRE)",
   label: "Dreieich (DEDRE)"
  },
  {
   value: "Dreieichenhain (DEDHH)",
   label: "Dreieichenhain (DEDHH)"
  },
  {
   value: "Dresden (DEDRS)",
   label: "Dresden (DEDRS)"
  },
  {
   value: "Drochtersen (DEDRO)",
   label: "Drochtersen (DEDRO)"
  },
  {
   value: "Drolshagen (DEDRL)",
   label: "Drolshagen (DEDRL)"
  },
  {
   value: "Duderstadt (DEDUD)",
   label: "Duderstadt (DEDUD)"
  },
  {
   value: "Dudweiler (DEDWR)",
   label: "Dudweiler (DEDWR)"
  },
  {
   value: "Duisburg (DEDUI)",
   label: "Duisburg (DEDUI)"
  },
  {
   value: "Dulken (DEDKN)",
   label: "Dulken (DEDKN)"
  },
  {
   value: "Dülmen (DEDUN)",
   label: "Dülmen (DEDUN)"
  },
  {
   value: "Dünsen (DEDYN)",
   label: "Dünsen (DEDYN)"
  },
  {
   value: "Durach (DEDRC)",
   label: "Durach (DEDRC)"
  },
  {
   value: "Durbach (DEDUR)",
   label: "Durbach (DEDUR)"
  },
  {
   value: "Düren (DEDUE)",
   label: "Düren (DEDUE)"
  },
  {
   value: "Durmentingen (DEDMT)",
   label: "Durmentingen (DEDMT)"
  },
  {
   value: "Dürrlauingen (DEDLA)",
   label: "Dürrlauingen (DEDLA)"
  },
  {
   value: "Düsseldorf (DEDUS)",
   label: "Düsseldorf (DEDUS)"
  },
  {
   value: "Dyckhausen (DEDYK)",
   label: "Dyckhausen (DEDYK)"
  },
  {
   value: "Cottbus (DECOT)",
   label: "Cottbus (DECOT)"
  },
  {
   value: "Crailsheim (DECRH)",
   label: "Crailsheim (DECRH)"
  },
  {
   value: "Creglingen (DECGL)",
   label: "Creglingen (DECGL)"
  },
  {
   value: "Cuxhaven (DECUX)",
   label: "Cuxhaven (DECUX)"
  },
  {
   value: "Dachau (DEDAC)",
   label: "Dachau (DEDAC)"
  },
  {
   value: "Dagebüll (DEDAG)",
   label: "Dagebüll (DEDAG)"
  },
  {
   value: "Dahlen\/Oschatz (DEDAH)",
   label: "Dahlen\/Oschatz (DEDAH)"
  },
  {
   value: "Dahlnburg (DEDLB)",
   label: "Dahlnburg (DEDLB)"
  },
  {
   value: "Dahn (DEDHN)",
   label: "Dahn (DEDHN)"
  },
  {
   value: "Damme (DEDAM)",
   label: "Damme (DEDAM)"
  },
  {
   value: "Damp (DEDAP)",
   label: "Damp (DEDAP)"
  },
  {
   value: "Dangast (DEDAN)",
   label: "Dangast (DEDAN)"
  },
  {
   value: "Dannenberg (DEDNG)",
   label: "Dannenberg (DEDNG)"
  },
  {
   value: "Darmstadt (DEDAR)",
   label: "Darmstadt (DEDAR)"
  },
  {
   value: "Dasing (DEDSG)",
   label: "Dasing (DEDSG)"
  },
  {
   value: "Datteln (DEDAT)",
   label: "Datteln (DEDAT)"
  },
  {
   value: "Dautphetal (DEDPL)",
   label: "Dautphetal (DEDPL)"
  },
  {
   value: "Deggendorf (DEDEG)",
   label: "Deggendorf (DEDEG)"
  },
  {
   value: "Deggingen (DEDGG)",
   label: "Deggingen (DEDGG)"
  },
  {
   value: "Deisenhofen (DEDEI)",
   label: "Deisenhofen (DEDEI)"
  },
  {
   value: "Deisslingen (DEDLI)",
   label: "Deisslingen (DEDLI)"
  },
  {
   value: "Deizisau (DEDZU)",
   label: "Deizisau (DEDZU)"
  },
  {
   value: "Delbrück (DEDEK)",
   label: "Delbrück (DEDEK)"
  },
  {
   value: "Delmenhorst (DEDEL)",
   label: "Delmenhorst (DEDEL)"
  },
  {
   value: "Demmin (DEDMN)",
   label: "Demmin (DEDMN)"
  },
  {
   value: "Denzlingen (DEDZN)",
   label: "Denzlingen (DEDZN)"
  },
  {
   value: "Dernbach\/Westerwald (DEDER)",
   label: "Dernbach\/Westerwald (DEDER)"
  },
  {
   value: "Dessau (DEDES)",
   label: "Dessau (DEDES)"
  },
  {
   value: "Detmold (DEDET)",
   label: "Detmold (DEDET)"
  },
  {
   value: "Dettingen (DEDTG)",
   label: "Dettingen (DEDTG)"
  },
  {
   value: "Dexheim (DEDEH)",
   label: "Dexheim (DEDEH)"
  },
  {
   value: "Dieburg (DEDIG)",
   label: "Dieburg (DEDIG)"
  },
  {
   value: "Diefenbach (DEDIH)",
   label: "Diefenbach (DEDIH)"
  },
  {
   value: "Diepholz (DEDIZ)",
   label: "Diepholz (DEDIZ)"
  },
  {
   value: "Dietenheim (DEDNM)",
   label: "Dietenheim (DEDNM)"
  },
  {
   value: "Dietenhofen (DEDTH)",
   label: "Dietenhofen (DEDTH)"
  },
  {
   value: "Dietramszell (DEDRZ)",
   label: "Dietramszell (DEDRZ)"
  },
  {
   value: "Dietzenbach (DEDIE)",
   label: "Dietzenbach (DEDIE)"
  },
  {
   value: "Dietzhölztal (DEDHL)",
   label: "Dietzhölztal (DEDHL)"
  },
  {
   value: "Diez (DEDEZ)",
   label: "Diez (DEDEZ)"
  },
  {
   value: "Dillenburg (DEDIB)",
   label: "Dillenburg (DEDIB)"
  },
  {
   value: "Büdingen (DEBUN)",
   label: "Büdingen (DEBUN)"
  },
  {
   value: "Bühl (DEBUL)",
   label: "Bühl (DEBUL)"
  },
  {
   value: "Bühlertal (DEBLT)",
   label: "Bühlertal (DEBLT)"
  },
  {
   value: "Bünde (DEBUE)",
   label: "Bünde (DEBUE)"
  },
  {
   value: "Burbach-Wahlbach (DEBBW)",
   label: "Burbach-Wahlbach (DEBBW)"
  },
  {
   value: "Burbach\/Siegen (DEBUH)",
   label: "Burbach\/Siegen (DEBUH)"
  },
  {
   value: "Büren (DEBEU)",
   label: "Büren (DEBEU)"
  },
  {
   value: "Burg\/Dithmarschen (DEBRG)",
   label: "Burg\/Dithmarschen (DEBRG)"
  },
  {
   value: "Burg\/Magdeburg (DEBUR)",
   label: "Burg\/Magdeburg (DEBUR)"
  },
  {
   value: "Burghausen (DEBHN)",
   label: "Burghausen (DEBHN)"
  },
  {
   value: "Burgkirchen (DEBCN)",
   label: "Burgkirchen (DEBCN)"
  },
  {
   value: "Burgkunstadt (DEBKT)",
   label: "Burgkunstadt (DEBKT)"
  },
  {
   value: "Burgstaaken\/Fehmarn (DEBSK)",
   label: "Burgstaaken\/Fehmarn (DEBSK)"
  },
  {
   value: "Bürgstadt (DEBTD)",
   label: "Bürgstadt (DEBTD)"
  },
  {
   value: "Burgstetten (DEBUS)",
   label: "Burgstetten (DEBUS)"
  },
  {
   value: "Burgthann (DEBGT)",
   label: "Burgthann (DEBGT)"
  },
  {
   value: "Burgwedel (DEBWL)",
   label: "Burgwedel (DEBWL)"
  },
  {
   value: "Burkhardtsdorf (DEBUF)",
   label: "Burkhardtsdorf (DEBUF)"
  },
  {
   value: "Bürscheid (DEBCD)",
   label: "Bürscheid (DEBCD)"
  },
  {
   value: "Bürstadt (DEBDT)",
   label: "Bürstadt (DEBDT)"
  },
  {
   value: "Buschfeld (DEBFD)",
   label: "Buschfeld (DEBFD)"
  },
  {
   value: "Büsum (DEBUM)",
   label: "Büsum (DEBUM)"
  },
  {
   value: "Butjadgen (DEBUT)",
   label: "Butjadgen (DEBUT)"
  },
  {
   value: "Büttelborn (DEBLN)",
   label: "Büttelborn (DEBLN)"
  },
  {
   value: "Butzbach (DEBZH)",
   label: "Butzbach (DEBZH)"
  },
  {
   value: "Bützfleth (DEBUZ)",
   label: "Bützfleth (DEBUZ)"
  },
  {
   value: "Buxtehude (DEBUX)",
   label: "Buxtehude (DEBUX)"
  },
  {
   value: "Calden (DECAN)",
   label: "Calden (DECAN)"
  },
  {
   value: "Calw (DECAL)",
   label: "Calw (DECAL)"
  },
  {
   value: "Cappeln (DECAP)",
   label: "Cappeln (DECAP)"
  },
  {
   value: "Carolinensiel (DECAR)",
   label: "Carolinensiel (DECAR)"
  },
  {
   value: "Castrop-Rauxel (DECRL)",
   label: "Castrop-Rauxel (DECRL)"
  },
  {
   value: "Celle (DECEL)",
   label: "Celle (DECEL)"
  },
  {
   value: "Cham (DECHA)",
   label: "Cham (DECHA)"
  },
  {
   value: "Chemnitz (DECHE)",
   label: "Chemnitz (DECHE)"
  },
  {
   value: "Chiemsee (DECHI)",
   label: "Chiemsee (DECHI)"
  },
  {
   value: "Cloppenburg (DECLO)",
   label: "Cloppenburg (DECLO)"
  },
  {
   value: "Coburg (DECOB)",
   label: "Coburg (DECOB)"
  },
  {
   value: "Cochem (DECOC)",
   label: "Cochem (DECOC)"
  },
  {
   value: "Coesfeld (DECOF)",
   label: "Coesfeld (DECOF)"
  },
  {
   value: "Bovenden (DEBOV)",
   label: "Bovenden (DEBOV)"
  },
  {
   value: "Brachttal (DEBRC)",
   label: "Brachttal (DEBRC)"
  },
  {
   value: "Brake (DEBKE)",
   label: "Brake (DEBKE)"
  },
  {
   value: "Bramel (DEBRA)",
   label: "Bramel (DEBRA)"
  },
  {
   value: "Bramsche (DEBRM)",
   label: "Bramsche (DEBRM)"
  },
  {
   value: "Brand (DEBND)",
   label: "Brand (DEBND)"
  },
  {
   value: "Brand-Erbisdorf (DEBEF)",
   label: "Brand-Erbisdorf (DEBEF)"
  },
  {
   value: "Brandenburg (DEBBG)",
   label: "Brandenburg (DEBBG)"
  },
  {
   value: "Braunau (DEBUU)",
   label: "Braunau (DEBUU)"
  },
  {
   value: "Braunschweig (DEBWE)",
   label: "Braunschweig (DEBWE)"
  },
  {
   value: "Brebach-Fechingen (DEBRF)",
   label: "Brebach-Fechingen (DEBRF)"
  },
  {
   value: "Breisach (DEBSH)",
   label: "Breisach (DEBSH)"
  },
  {
   value: "Breitenberg (DEBRT)",
   label: "Breitenberg (DEBRT)"
  },
  {
   value: "Breitenbrunn (DEBTU)",
   label: "Breitenbrunn (DEBTU)"
  },
  {
   value: "Breitenstein (DEBII)",
   label: "Breitenstein (DEBII)"
  },
  {
   value: "Bremen (DEBRE)",
   label: "Bremen (DEBRE)"
  },
  {
   value: "Bremen-Blumenthal (DEBLM)",
   label: "Bremen-Blumenthal (DEBLM)"
  },
  {
   value: "Bremen-Farge (DEBFA)",
   label: "Bremen-Farge (DEBFA)"
  },
  {
   value: "Bremerhaven (DEBRV)",
   label: "Bremerhaven (DEBRV)"
  },
  {
   value: "Bremervörde (DEBMV)",
   label: "Bremervörde (DEBMV)"
  },
  {
   value: "Bretten (DEBTN)",
   label: "Bretten (DEBTN)"
  },
  {
   value: "Bretzenheim (DEBRZ)",
   label: "Bretzenheim (DEBRZ)"
  },
  {
   value: "Breuberg (DEBUG)",
   label: "Breuberg (DEBUG)"
  },
  {
   value: "Briedern (DEBRD)",
   label: "Briedern (DEBRD)"
  },
  {
   value: "Brieselang (DEBLG)",
   label: "Brieselang (DEBLG)"
  },
  {
   value: "Brilon (DEBRI)",
   label: "Brilon (DEBRI)"
  },
  {
   value: "Brohl-Lützing (DEBRO)",
   label: "Brohl-Lützing (DEBRO)"
  },
  {
   value: "Bruchhausen (DEBHH)",
   label: "Bruchhausen (DEBHH)"
  },
  {
   value: "Bruchmühlbach (DEBMH)",
   label: "Bruchmühlbach (DEBMH)"
  },
  {
   value: "Bruchsal (DEBCL)",
   label: "Bruchsal (DEBCL)"
  },
  {
   value: "Bruckmühl (DEBKM)",
   label: "Bruckmühl (DEBKM)"
  },
  {
   value: "Brühl (DEBRU)",
   label: "Brühl (DEBRU)"
  },
  {
   value: "Brunsbüttel (DEBRB)",
   label: "Brunsbüttel (DEBRB)"
  },
  {
   value: "Bubenheim (DEBNM)",
   label: "Bubenheim (DEBNM)"
  },
  {
   value: "Bubingen (DEBUB)",
   label: "Bubingen (DEBUB)"
  },
  {
   value: "Buchen (DEBUC)",
   label: "Buchen (DEBUC)"
  },
  {
   value: "Buchholz\/Nordheide (DEBHU)",
   label: "Buchholz\/Nordheide (DEBHU)"
  },
  {
   value: "Buchloe (DEBLO)",
   label: "Buchloe (DEBLO)"
  },
  {
   value: "Budenheim (DEBUD)",
   label: "Budenheim (DEBUD)"
  },
  {
   value: "Bildstock (DEBIC)",
   label: "Bildstock (DEBIC)"
  },
  {
   value: "Billerbeck (DEBIL)",
   label: "Billerbeck (DEBIL)"
  },
  {
   value: "Bindlach (DEBLH)",
   label: "Bindlach (DEBLH)"
  },
  {
   value: "Bingen (DEBIN)",
   label: "Bingen (DEBIN)"
  },
  {
   value: "Birkenfeld (DEBIR)",
   label: "Birkenfeld (DEBIR)"
  },
  {
   value: "Birstein (DEBRS)",
   label: "Birstein (DEBRS)"
  },
  {
   value: "Bischofsheim\/Grossgerau (DEBIM)",
   label: "Bischofsheim\/Grossgerau (DEBIM)"
  },
  {
   value: "Bischweier (DEBIS)",
   label: "Bischweier (DEBIS)"
  },
  {
   value: "Bismark (DEBIK)",
   label: "Bismark (DEBIK)"
  },
  {
   value: "Bitburg (DEBIT)",
   label: "Bitburg (DEBIT)"
  },
  {
   value: "Bitterfeld (DEBID)",
   label: "Bitterfeld (DEBID)"
  },
  {
   value: "Blaubeuren (DEBLE)",
   label: "Blaubeuren (DEBLE)"
  },
  {
   value: "Blaufelden (DEBLF)",
   label: "Blaufelden (DEBLF)"
  },
  {
   value: "Blaustein (DEBLS)",
   label: "Blaustein (DEBLS)"
  },
  {
   value: "Blexen (DEBXN)",
   label: "Blexen (DEBXN)"
  },
  {
   value: "Blomberg (DEBMG)",
   label: "Blomberg (DEBMG)"
  },
  {
   value: "Blumberg (DEBLU)",
   label: "Blumberg (DEBLU)"
  },
  {
   value: "Bobenheim-Roxheim (DEBHR)",
   label: "Bobenheim-Roxheim (DEBHR)"
  },
  {
   value: "Bobingen (DEBOB)",
   label: "Bobingen (DEBOB)"
  },
  {
   value: "Böblingen (DEBOE)",
   label: "Böblingen (DEBOE)"
  },
  {
   value: "Bocholt (DEBHT)",
   label: "Bocholt (DEBHT)"
  },
  {
   value: "Bochum (DEBOM)",
   label: "Bochum (DEBOM)"
  },
  {
   value: "Bockhorst (DEBOC)",
   label: "Bockhorst (DEBOC)"
  },
  {
   value: "Bodelshausen (DEBHS)",
   label: "Bodelshausen (DEBHS)"
  },
  {
   value: "Bodenwerder (DEBWR)",
   label: "Bodenwerder (DEBWR)"
  },
  {
   value: "Boechingen (DEBOG)",
   label: "Boechingen (DEBOG)"
  },
  {
   value: "Bohmte (DEBOH)",
   label: "Bohmte (DEBOH)"
  },
  {
   value: "Bokel (DEBOK)",
   label: "Bokel (DEBOK)"
  },
  {
   value: "Bondorf (DEBOO)",
   label: "Bondorf (DEBOO)"
  },
  {
   value: "Bönen (DEBNN)",
   label: "Bönen (DEBNN)"
  },
  {
   value: "Bonn (DEBON)",
   label: "Bonn (DEBON)"
  },
  {
   value: "Bopfingen (DEBOP)",
   label: "Bopfingen (DEBOP)"
  },
  {
   value: "Boppard (DEBOD)",
   label: "Boppard (DEBOD)"
  },
  {
   value: "Borken (DEBOR)",
   label: "Borken (DEBOR)"
  },
  {
   value: "Borkum (DEBMK)",
   label: "Borkum (DEBMK)"
  },
  {
   value: "Börnsen (DEBRN)",
   label: "Börnsen (DEBRN)"
  },
  {
   value: "Borsfleth (DEBFL)",
   label: "Borsfleth (DEBFL)"
  },
  {
   value: "Borstel (DEBST)",
   label: "Borstel (DEBST)"
  },
  {
   value: "Borstel\/Diepholz (DEBRL)",
   label: "Borstel\/Diepholz (DEBRL)"
  },
  {
   value: "Bottrop (DEBOT)",
   label: "Bottrop (DEBOT)"
  },
  {
   value: "Bötzingen (DEBTZ)",
   label: "Bötzingen (DEBTZ)"
  },
  {
   value: "Beidenfleth (DEBEI)",
   label: "Beidenfleth (DEBEI)"
  },
  {
   value: "Bellheim (DEBEL)",
   label: "Bellheim (DEBEL)"
  },
  {
   value: "Bempflingen (DEBMP)",
   label: "Bempflingen (DEBMP)"
  },
  {
   value: "Bendorf (DEBED)",
   label: "Bendorf (DEBED)"
  },
  {
   value: "Bensersiel (DEBEN)",
   label: "Bensersiel (DEBEN)"
  },
  {
   value: "Bensheim (DEBEH)",
   label: "Bensheim (DEBEH)"
  },
  {
   value: "Berchtesgaden (DEBEG)",
   label: "Berchtesgaden (DEBEG)"
  },
  {
   value: "Berga (DEBGA)",
   label: "Berga (DEBGA)"
  },
  {
   value: "Bergedorf (DEBGD)",
   label: "Bergedorf (DEBGD)"
  },
  {
   value: "Bergen (DEBGE)",
   label: "Bergen (DEBGE)"
  },
  {
   value: "Bergheim (DEBHM)",
   label: "Bergheim (DEBHM)"
  },
  {
   value: "Bergheim-Westfalen (DEBGH)",
   label: "Bergheim-Westfalen (DEBGH)"
  },
  {
   value: "Bergisch-Gladbach (DEBGL)",
   label: "Bergisch-Gladbach (DEBGL)"
  },
  {
   value: "Bergkamen (DEBKN)",
   label: "Bergkamen (DEBKN)"
  },
  {
   value: "Bergneustadt (DEBNT)",
   label: "Bergneustadt (DEBNT)"
  },
  {
   value: "Berkatal (DEBKL)",
   label: "Berkatal (DEBKL)"
  },
  {
   value: "Berlin (DEBER)",
   label: "Berlin (DEBER)"
  },
  {
   value: "Berlin-Schönefeld Apt (DESXF)",
   label: "Berlin-Schönefeld Apt (DESXF)"
  },
  {
   value: "Berlin-Tegel Apt (DETXL)",
   label: "Berlin-Tegel Apt (DETXL)"
  },
  {
   value: "Berlin-Tempelhof Apt (DETHF)",
   label: "Berlin-Tempelhof Apt (DETHF)"
  },
  {
   value: "Berndshof (DEBOF)",
   label: "Berndshof (DEBOF)"
  },
  {
   value: "Berneburg (DEBNB)",
   label: "Berneburg (DEBNB)"
  },
  {
   value: "Bernkastel-Kues (DEBEK)",
   label: "Bernkastel-Kues (DEBEK)"
  },
  {
   value: "Bersenbruck (DEBBK)",
   label: "Bersenbruck (DEBBK)"
  },
  {
   value: "Besigheim (DEBEM)",
   label: "Besigheim (DEBEM)"
  },
  {
   value: "Bessenbach (DEBSS)",
   label: "Bessenbach (DEBSS)"
  },
  {
   value: "Bestwig (DEBWG)",
   label: "Bestwig (DEBWG)"
  },
  {
   value: "Betzdorf (DEBET)",
   label: "Betzdorf (DEBET)"
  },
  {
   value: "Beverstedt (DEYDX)",
   label: "Beverstedt (DEYDX)"
  },
  {
   value: "Beverungen (DEBEV)",
   label: "Beverungen (DEBEV)"
  },
  {
   value: "Bexbach (DEBEX)",
   label: "Bexbach (DEBEX)"
  },
  {
   value: "Biberach (DEBIB)",
   label: "Biberach (DEBIB)"
  },
  {
   value: "Biblis (DEBBL)",
   label: "Biblis (DEBBL)"
  },
  {
   value: "Bickendorf (DEBCK)",
   label: "Bickendorf (DEBCK)"
  },
  {
   value: "Biebesheim (DEBIE)",
   label: "Biebesheim (DEBIE)"
  },
  {
   value: "Biedenkopf (DEBKF)",
   label: "Biedenkopf (DEBKF)"
  },
  {
   value: "Bielefeld (DEBFE)",
   label: "Bielefeld (DEBFE)"
  },
  {
   value: "Biessenhofen (DEBIH)",
   label: "Biessenhofen (DEBIH)"
  },
  {
   value: "Bietigheim-Bissingen (DEBBI)",
   label: "Bietigheim-Bissingen (DEBBI)"
  },
  {
   value: "Bad Soden am Taunus (DEBSO)",
   label: "Bad Soden am Taunus (DEBSO)"
  },
  {
   value: "Bad Soden-Salmünster (DEBNL)",
   label: "Bad Soden-Salmünster (DEBNL)"
  },
  {
   value: "Bad Tölz (DEBTO)",
   label: "Bad Tölz (DEBTO)"
  },
  {
   value: "Bad Vilbel (DEBVI)",
   label: "Bad Vilbel (DEBVI)"
  },
  {
   value: "Bad Wildungen (DEBWI)",
   label: "Bad Wildungen (DEBWI)"
  },
  {
   value: "Bad Wimpfen (DEBWF)",
   label: "Bad Wimpfen (DEBWF)"
  },
  {
   value: "Bad Windsheim (DEBDW)",
   label: "Bad Windsheim (DEBDW)"
  },
  {
   value: "Bad Zwischenahn (DEBAN)",
   label: "Bad Zwischenahn (DEBAN)"
  },
  {
   value: "Baddeckenstedt (DEBAD)",
   label: "Baddeckenstedt (DEBAD)"
  },
  {
   value: "Baden Baden (DEBAB)",
   label: "Baden Baden (DEBAB)"
  },
  {
   value: "Bahratal (DEBAH)",
   label: "Bahratal (DEBAH)"
  },
  {
   value: "Baienfurt (DEBFT)",
   label: "Baienfurt (DEBFT)"
  },
  {
   value: "Balingen (DEBAL)",
   label: "Balingen (DEBAL)"
  },
  {
   value: "Ballenstedt (DEBAT)",
   label: "Ballenstedt (DEBAT)"
  },
  {
   value: "\"Baltrum (DEBMR)",
   label: "\"Baltrum (DEBMR)"
  },
  {
   value: "Bamberg (DEBAM)",
   label: "Bamberg (DEBAM)"
  },
  {
   value: "Bammental (DEBTH)",
   label: "Bammental (DEBTH)"
  },
  {
   value: "Barby (DEBBY)",
   label: "Barby (DEBBY)"
  },
  {
   value: "Bargteheide (DEBAR)",
   label: "Bargteheide (DEBAR)"
  },
  {
   value: "Barmstedt (DEBMT)",
   label: "Barmstedt (DEBMT)"
  },
  {
   value: "Barnkrug (DEBRK)",
   label: "Barnkrug (DEBRK)"
  },
  {
   value: "Barnstorf (DEBAF)",
   label: "Barnstorf (DEBAF)"
  },
  {
   value: "Barntrup (DEBAP)",
   label: "Barntrup (DEBAP)"
  },
  {
   value: "Barsbüttel (DEBSB)",
   label: "Barsbüttel (DEBSB)"
  },
  {
   value: "Barsinghausen (DEBGN)",
   label: "Barsinghausen (DEBGN)"
  },
  {
   value: "Barsleben (DEBSL)",
   label: "Barsleben (DEBSL)"
  },
  {
   value: "Barth (DEBBH)",
   label: "Barth (DEBBH)"
  },
  {
   value: "Basbeck (DEBAS)",
   label: "Basbeck (DEBAS)"
  },
  {
   value: "Bassum (DEBSM)",
   label: "Bassum (DEBSM)"
  },
  {
   value: "Baumholder (DEBHD)",
   label: "Baumholder (DEBHD)"
  },
  {
   value: "Baunach (DEBUA)",
   label: "Baunach (DEBUA)"
  },
  {
   value: "Baunatal (DEBTL)",
   label: "Baunatal (DEBTL)"
  },
  {
   value: "Bautzen (DEBAU)",
   label: "Bautzen (DEBAU)"
  },
  {
   value: "Bayreuth (DEBYU)",
   label: "Bayreuth (DEBYU)"
  },
  {
   value: "Bebitz (DEBBZ)",
   label: "Bebitz (DEBBZ)"
  },
  {
   value: "Bebra (DEBEB)",
   label: "Bebra (DEBEB)"
  },
  {
   value: "Beckum (DEBEC)",
   label: "Beckum (DEBEC)"
  },
  {
   value: "Bedburg-Hau (DEBDG)",
   label: "Bedburg-Hau (DEBDG)"
  },
  {
   value: "Beddingen zu Salzgitter - (DEBZS)",
   label: "Beddingen zu Salzgitter - (DEBZS)"
  },
  {
   value: "Bad Brambach (DEBBR)",
   label: "Bad Brambach (DEBBR)"
  },
  {
   value: "Bad Brückenau (DEBBU)",
   label: "Bad Brückenau (DEBBU)"
  },
  {
   value: "Bad Camberg (DEBDC)",
   label: "Bad Camberg (DEBDC)"
  },
  {
   value: "Bad Driburg (DEBDR)",
   label: "Bad Driburg (DEBDR)"
  },
  {
   value: "Bad Dürkheim (DEBDU)",
   label: "Bad Dürkheim (DEBDU)"
  },
  {
   value: "Bad Essen (DEBES)",
   label: "Bad Essen (DEBES)"
  },
  {
   value: "Bad Friedrichshall (DEBFH)",
   label: "Bad Friedrichshall (DEBFH)"
  },
  {
   value: "Bad Gandersheim (DEBGM)",
   label: "Bad Gandersheim (DEBGM)"
  },
  {
   value: "Bad Godesberg (DEBGO)",
   label: "Bad Godesberg (DEBGO)"
  },
  {
   value: "Bad Harzburg (DEBDH)",
   label: "Bad Harzburg (DEBDH)"
  },
  {
   value: "Bad Hersfeld (DEBHE)",
   label: "Bad Hersfeld (DEBHE)"
  },
  {
   value: "Bad Homburg (DEBHO)",
   label: "Bad Homburg (DEBHO)"
  },
  {
   value: "Bad Honnef (DEBHF)",
   label: "Bad Honnef (DEBHF)"
  },
  {
   value: "Bad Hönningen (DEBHI)",
   label: "Bad Hönningen (DEBHI)"
  },
  {
   value: "Bad Kissingen (DEBKI)",
   label: "Bad Kissingen (DEBKI)"
  },
  {
   value: "Bad Kreuznach (DEBKR)",
   label: "Bad Kreuznach (DEBKR)"
  },
  {
   value: "Bad Krozingen (DEBDK)",
   label: "Bad Krozingen (DEBDK)"
  },
  {
   value: "Bad Laer (DEBLA)",
   label: "Bad Laer (DEBLA)"
  },
  {
   value: "Bad Lauterberg (DEBLB)",
   label: "Bad Lauterberg (DEBLB)"
  },
  {
   value: "Bad Mergentheim (DEBME)",
   label: "Bad Mergentheim (DEBME)"
  },
  {
   value: "Bad Münder (DEBMU)",
   label: "Bad Münder (DEBMU)"
  },
  {
   value: "Bad Münstereifel (DEBML)",
   label: "Bad Münstereifel (DEBML)"
  },
  {
   value: "Bad Nauheim (DEBNA)",
   label: "Bad Nauheim (DEBNA)"
  },
  {
   value: "Bad Neuenahr (DEBNR)",
   label: "Bad Neuenahr (DEBNR)"
  },
  {
   value: "Bad Neustadt (DEBNE)",
   label: "Bad Neustadt (DEBNE)"
  },
  {
   value: "Bad Oeynhausen (DEBOY)",
   label: "Bad Oeynhausen (DEBOY)"
  },
  {
   value: "Bad Oldesloe (DEBOL)",
   label: "Bad Oldesloe (DEBOL)"
  },
  {
   value: "Bad Peterstal-Griesbach (DEBPT)",
   label: "Bad Peterstal-Griesbach (DEBPT)"
  },
  {
   value: "Bad Pyrmont (DEBPY)",
   label: "Bad Pyrmont (DEBPY)"
  },
  {
   value: "Bad Reichenhall (DEBRH)",
   label: "Bad Reichenhall (DEBRH)"
  },
  {
   value: "Bad Sachsa (DEBSC)",
   label: "Bad Sachsa (DEBSC)"
  },
  {
   value: "Bad Säckingen (DEBSA)",
   label: "Bad Säckingen (DEBSA)"
  },
  {
   value: "Bad Salzdetfurth (DEBSF)",
   label: "Bad Salzdetfurth (DEBSF)"
  },
  {
   value: "Bad Salzuflen (DEBFN)",
   label: "Bad Salzuflen (DEBFN)"
  },
  {
   value: "Bad Schandau (DEBDS)",
   label: "Bad Schandau (DEBDS)"
  },
  {
   value: "Bad Schönborn (DEBSN)",
   label: "Bad Schönborn (DEBSN)"
  },
  {
   value: "Bad Segeberg (DEBSE)",
   label: "Bad Segeberg (DEBSE)"
  },
  {
   value: "Ammerbuch (DEAMM)",
   label: "Ammerbuch (DEAMM)"
  },
  {
   value: "Amorbach (DEAMO)",
   label: "Amorbach (DEAMO)"
  },
  {
   value: "Amperpettenbach (DEAPP)",
   label: "Amperpettenbach (DEAPP)"
  },
  {
   value: "Amrum I. (DEAMR)",
   label: "Amrum I. (DEAMR)"
  },
  {
   value: "Andernach (DEAND)",
   label: "Andernach (DEAND)"
  },
  {
   value: "Anger (DEANG)",
   label: "Anger (DEANG)"
  },
  {
   value: "Anklam (DEANK)",
   label: "Anklam (DEANK)"
  },
  {
   value: "Annweiler (DEANN)",
   label: "Annweiler (DEANN)"
  },
  {
   value: "Anröchte (DEARH)",
   label: "Anröchte (DEARH)"
  },
  {
   value: "Ansbach (DEANS)",
   label: "Ansbach (DEANS)"
  },
  {
   value: "Apen (DEAPE)",
   label: "Apen (DEAPE)"
  },
  {
   value: "Apolda (DEAPO)",
   label: "Apolda (DEAPO)"
  },
  {
   value: "Appenweier (DEAPW)",
   label: "Appenweier (DEAPW)"
  },
  {
   value: "Arnsberg (DEARN)",
   label: "Arnsberg (DEARN)"
  },
  {
   value: "Arolsen (DEAAS)",
   label: "Arolsen (DEAAS)"
  },
  {
   value: "Asbach (DEABS)",
   label: "Asbach (DEABS)"
  },
  {
   value: "Aschaffenburg (DEASC)",
   label: "Aschaffenburg (DEASC)"
  },
  {
   value: "Aschau (DEASU)",
   label: "Aschau (DEASU)"
  },
  {
   value: "Aschau am Inn (DEAXS)",
   label: "Aschau am Inn (DEAXS)"
  },
  {
   value: "Ascheberg (DEAEG)",
   label: "Ascheberg (DEAEG)"
  },
  {
   value: "Aschersleben (DEASN)",
   label: "Aschersleben (DEASN)"
  },
  {
   value: "Assel (DEASS)",
   label: "Assel (DEASS)"
  },
  {
   value: "Asslar (DEASL)",
   label: "Asslar (DEASL)"
  },
  {
   value: "Attendorn (DEATN)",
   label: "Attendorn (DEATN)"
  },
  {
   value: "Aue (DEAUZ)",
   label: "Aue (DEAUZ)"
  },
  {
   value: "Auerbach\/Vogtland (DEAUE)",
   label: "Auerbach\/Vogtland (DEAUE)"
  },
  {
   value: "Augsburg (DEAGB)",
   label: "Augsburg (DEAGB)"
  },
  {
   value: "Augustdorf (DEAGT)",
   label: "Augustdorf (DEAGT)"
  },
  {
   value: "Augustfehn (DEAUG)",
   label: "Augustfehn (DEAUG)"
  },
  {
   value: "Aulendorf (DEAUL)",
   label: "Aulendorf (DEAUL)"
  },
  {
   value: "Aumühle (DEAUM)",
   label: "Aumühle (DEAUM)"
  },
  {
   value: "Aurich (DEAUR)",
   label: "Aurich (DEAUR)"
  },
  {
   value: "Babenhausen (DEBBN)",
   label: "Babenhausen (DEBBN)"
  },
  {
   value: "Backnang (DEBAC)",
   label: "Backnang (DEBAC)"
  },
  {
   value: "Bad Aibling (DEBAI)",
   label: "Bad Aibling (DEBAI)"
  },
  {
   value: "Bad Alexandersbad (DEBAX)",
   label: "Bad Alexandersbad (DEBAX)"
  },
  {
   value: "Bad Bentheim (DEBDB)",
   label: "Bad Bentheim (DEBDB)"
  },
  {
   value: "Bad Bergzabern (DEBZN)",
   label: "Bad Bergzabern (DEBZN)"
  },
  {
   value: "Bad Berleburg (DEBBE)",
   label: "Bad Berleburg (DEBBE)"
  },
  {
   value: "Bad Bevensen (DEBBV)",
   label: "Bad Bevensen (DEBBV)"
  },
  {
   value: "Aach (DEAAC)",
   label: "Aach (DEAAC)"
  },
  {
   value: "Aachen (DEAAH)",
   label: "Aachen (DEAAH)"
  },
  {
   value: "Aalen (DEAAL)",
   label: "Aalen (DEAAL)"
  },
  {
   value: "Aarbergen (DEAAR)",
   label: "Aarbergen (DEAAR)"
  },
  {
   value: "Abbehausen (DEABH)",
   label: "Abbehausen (DEABH)"
  },
  {
   value: "Abbenfleth (DEABF)",
   label: "Abbenfleth (DEABF)"
  },
  {
   value: "Abensberg (DEABE)",
   label: "Abensberg (DEABE)"
  },
  {
   value: "Abtswind (DEABT)",
   label: "Abtswind (DEABT)"
  },
  {
   value: "Achern (DEACH)",
   label: "Achern (DEACH)"
  },
  {
   value: "Achim (DEACM)",
   label: "Achim (DEACM)"
  },
  {
   value: "Achterwehr Ringkanal (DEAWR)",
   label: "Achterwehr Ringkanal (DEAWR)"
  },
  {
   value: "Aerzen (DEAER)",
   label: "Aerzen (DEAER)"
  },
  {
   value: "Ahaus (DEAHA)",
   label: "Ahaus (DEAHA)"
  },
  {
   value: "Ahlen\/Beckum (DEAHL)",
   label: "Ahlen\/Beckum (DEAHL)"
  },
  {
   value: "Ahorn (DEAHN)",
   label: "Ahorn (DEAHN)"
  },
  {
   value: "Ahrensburg (DEAHR)",
   label: "Ahrensburg (DEAHR)"
  },
  {
   value: "Ahrenshöft (DEASH)",
   label: "Ahrenshöft (DEASH)"
  },
  {
   value: "Aich (?) (DEAIH)",
   label: "Aich (?) (DEAIH)"
  },
  {
   value: "Aichach (DEAIC)",
   label: "Aichach (DEAIC)"
  },
  {
   value: "Aichtal (DEAIL)",
   label: "Aichtal (DEAIL)"
  },
  {
   value: "Ainring (DEARG)",
   label: "Ainring (DEARG)"
  },
  {
   value: "Albbruck (DEABK)",
   label: "Albbruck (DEABK)"
  },
  {
   value: "Albersdorf (DEASD)",
   label: "Albersdorf (DEASD)"
  },
  {
   value: "Albstadt (DEALB)",
   label: "Albstadt (DEALB)"
  },
  {
   value: "Alfeld\/Leine (DEALF)",
   label: "Alfeld\/Leine (DEALF)"
  },
  {
   value: "Alfter (DEAFT)",
   label: "Alfter (DEAFT)"
  },
  {
   value: "Allershausen (DEALL)",
   label: "Allershausen (DEALL)"
  },
  {
   value: "Alsbach (DEALH)",
   label: "Alsbach (DEALH)"
  },
  {
   value: "Alsdorf\/Aachen (DEALS)",
   label: "Alsdorf\/Aachen (DEALS)"
  },
  {
   value: "Alsfeld (DEALD)",
   label: "Alsfeld (DEALD)"
  },
  {
   value: "Altbach (DEABC)",
   label: "Altbach (DEABC)"
  },
  {
   value: "Altena (DEALT)",
   label: "Altena (DEALT)"
  },
  {
   value: "Altenhain (DEANH)",
   label: "Altenhain (DEANH)"
  },
  {
   value: "Altenkirchen (DEALK)",
   label: "Altenkirchen (DEALK)"
  },
  {
   value: "Altenmarkt an der Alz (DEAMK)",
   label: "Altenmarkt an der Alz (DEAMK)"
  },
  {
   value: "Altötting (DEALG)",
   label: "Altötting (DEALG)"
  },
  {
   value: "Altusried (DEALR)",
   label: "Altusried (DEALR)"
  },
  {
   value: "Alzenau (DEALZ)",
   label: "Alzenau (DEALZ)"
  },
  {
   value: "Alzey (DEAZY)",
   label: "Alzey (DEAZY)"
  },
  {
   value: "Amberg (DEAMB)",
   label: "Amberg (DEAMB)"
  },
  {
   value: "Stary Hrozenkov (CZSHZ)",
   label: "Stary Hrozenkov (CZSHZ)"
  },
  {
   value: "Strakonice (CZSKN)",
   label: "Strakonice (CZSKN)"
  },
  {
   value: "Strani (CZSTN)",
   label: "Strani (CZSTN)"
  },
  {
   value: "Strazny (CZSZA)",
   label: "Strazny (CZSZA)"
  },
  {
   value: "Strelna (CZSRL)",
   label: "Strelna (CZSRL)"
  },
  {
   value: "Studanky (CZSTY)",
   label: "Studanky (CZSTY)"
  },
  {
   value: "Sudice (CZSDC)",
   label: "Sudice (CZSDC)"
  },
  {
   value: "Sudomerice (CZSUD)",
   label: "Sudomerice (CZSUD)"
  },
  {
   value: "Sumperk (CZSUM)",
   label: "Sumperk (CZSUM)"
  },
  {
   value: "Susice (CZSUS)",
   label: "Susice (CZSUS)"
  },
  {
   value: "Svaty Kriz (CZSVK)",
   label: "Svaty Kriz (CZSVK)"
  },
  {
   value: "Svitavy (CZSTV)",
   label: "Svitavy (CZSTV)"
  },
  {
   value: "Tabor (CZTBR)",
   label: "Tabor (CZTBR)"
  },
  {
   value: "Tachov (CZTAC)",
   label: "Tachov (CZTAC)"
  },
  {
   value: "Teplice (CZTEP)",
   label: "Teplice (CZTEP)"
  },
  {
   value: "Trebic (CZTRB)",
   label: "Trebic (CZTRB)"
  },
  {
   value: "Trinec (CZTNC)",
   label: "Trinec (CZTNC)"
  },
  {
   value: "Trutnov (CZTRU)",
   label: "Trutnov (CZTRU)"
  },
  {
   value: "Turnov (CZTUR)",
   label: "Turnov (CZTUR)"
  },
  {
   value: "Uherske Hradiste (CZUHE)",
   label: "Uherske Hradiste (CZUHE)"
  },
  {
   value: "Usov (CZUSV)",
   label: "Usov (CZUSV)"
  },
  {
   value: "Usti nad Labem (CZULN)",
   label: "Usti nad Labem (CZULN)"
  },
  {
   value: "Valasske Mezirici (CZVMZ)",
   label: "Valasske Mezirici (CZVMZ)"
  },
  {
   value: "Varnsdorf (CZVFA)",
   label: "Varnsdorf (CZVFA)"
  },
  {
   value: "Velka nad Velickou (CZVNV)",
   label: "Velka nad Velickou (CZVNV)"
  },
  {
   value: "Velke Karlovice (CZVKC)",
   label: "Velke Karlovice (CZVKC)"
  },
  {
   value: "Velke Mezirici (CZVMI)",
   label: "Velke Mezirici (CZVMI)"
  },
  {
   value: "Vimperk (CZVIM)",
   label: "Vimperk (CZVIM)"
  },
  {
   value: "Vojtanov (CZVJA)",
   label: "Vojtanov (CZVJA)"
  },
  {
   value: "Vrchlabi (CZVRC)",
   label: "Vrchlabi (CZVRC)"
  },
  {
   value: "Vseruby (CZVBY)",
   label: "Vseruby (CZVBY)"
  },
  {
   value: "Vsetin (CZVST)",
   label: "Vsetin (CZVST)"
  },
  {
   value: "Vyskov (CZVKV)",
   label: "Vyskov (CZVKV)"
  },
  {
   value: "Vysoke Myto (CZVMO)",
   label: "Vysoke Myto (CZVMO)"
  },
  {
   value: "Zacler (CZZCR)",
   label: "Zacler (CZZCR)"
  },
  {
   value: "Zamberk (CZZAM)",
   label: "Zamberk (CZZAM)"
  },
  {
   value: "Zatec (CZZAT)",
   label: "Zatec (CZZAT)"
  },
  {
   value: "Zdar nad Sazavou (CZZNS)",
   label: "Zdar nad Sazavou (CZZNS)"
  },
  {
   value: "Zelezna Ruda (CZRDA)",
   label: "Zelezna Ruda (CZRDA)"
  },
  {
   value: "Zlate Hory (CZZHR)",
   label: "Zlate Hory (CZZHR)"
  },
  {
   value: "Zlin (CZZLN)",
   label: "Zlin (CZZLN)"
  },
  {
   value: "Znojmo (CZZMO)",
   label: "Znojmo (CZZMO)"
  },
  {
   value: "Nachod (CZNAA)",
   label: "Nachod (CZNAA)"
  },
  {
   value: "Nedasova Lhota (CZNED)",
   label: "Nedasova Lhota (CZNED)"
  },
  {
   value: "Nejdek (CZNEJ)",
   label: "Nejdek (CZNEJ)"
  },
  {
   value: "Nosovice (CZNVS)",
   label: "Nosovice (CZNVS)"
  },
  {
   value: "Nova Bystrice (CZNCA)",
   label: "Nova Bystrice (CZNCA)"
  },
  {
   value: "Novy Bor (CZNOB)",
   label: "Novy Bor (CZNOB)"
  },
  {
   value: "Novy Jicin (CZNJC)",
   label: "Novy Jicin (CZNJC)"
  },
  {
   value: "Nymburk (CZNMB)",
   label: "Nymburk (CZNMB)"
  },
  {
   value: "Odry (CZODY)",
   label: "Odry (CZODY)"
  },
  {
   value: "Olomouc (CZOLO)",
   label: "Olomouc (CZOLO)"
  },
  {
   value: "Opava (CZOPA)",
   label: "Opava (CZOPA)"
  },
  {
   value: "Ostrava (CZOSR)",
   label: "Ostrava (CZOSR)"
  },
  {
   value: "Otrokovice (CZOTC)",
   label: "Otrokovice (CZOTC)"
  },
  {
   value: "Pardubice (CZPRB)",
   label: "Pardubice (CZPRB)"
  },
  {
   value: "Pelhrimov (CZPEL)",
   label: "Pelhrimov (CZPEL)"
  },
  {
   value: "Petrov (CZPTV)",
   label: "Petrov (CZPTV)"
  },
  {
   value: "Petrovice u Karvine (CZPKA)",
   label: "Petrovice u Karvine (CZPKA)"
  },
  {
   value: "Pisek (CZPSK)",
   label: "Pisek (CZPSK)"
  },
  {
   value: "Plzen (CZPLZ)",
   label: "Plzen (CZPLZ)"
  },
  {
   value: "Polerady (CZPOL)",
   label: "Polerady (CZPOL)"
  },
  {
   value: "Pomezi nad Ohri (CZOHA)",
   label: "Pomezi nad Ohri (CZOHA)"
  },
  {
   value: "Potucky-silnice (CZPOT)",
   label: "Potucky-silnice (CZPOT)"
  },
  {
   value: "Prachatice (CZPRT)",
   label: "Prachatice (CZPRT)"
  },
  {
   value: "Praha (CZPRG)",
   label: "Praha (CZPRG)"
  },
  {
   value: "Prerov (CZPRV)",
   label: "Prerov (CZPRV)"
  },
  {
   value: "Pribram (CZPRI)",
   label: "Pribram (CZPRI)"
  },
  {
   value: "Prostejov (CZPRO)",
   label: "Prostejov (CZPRO)"
  },
  {
   value: "Rakovnik (CZRAK)",
   label: "Rakovnik (CZRAK)"
  },
  {
   value: "Rohatec (CZZKQ)",
   label: "Rohatec (CZZKQ)"
  },
  {
   value: "Rokycany (CZRKC)",
   label: "Rokycany (CZRKC)"
  },
  {
   value: "Roudnice nad Labem (CZRNL)",
   label: "Roudnice nad Labem (CZRNL)"
  },
  {
   value: "Roznov pod Radhosthem (CZRPR)",
   label: "Roznov pod Radhosthem (CZRPR)"
  },
  {
   value: "Rozvadov (CZRZA)",
   label: "Rozvadov (CZRZA)"
  },
  {
   value: "Rumburk (CZRUA)",
   label: "Rumburk (CZRUA)"
  },
  {
   value: "Rychnov nad Kneznou (CZRNK)",
   label: "Rychnov nad Kneznou (CZRNK)"
  },
  {
   value: "Satov (CZSAA)",
   label: "Satov (CZSAA)"
  },
  {
   value: "Semily (CZSML)",
   label: "Semily (CZSML)"
  },
  {
   value: "Skutec (CZSKT)",
   label: "Skutec (CZSKT)"
  },
  {
   value: "Slatinany (CZSNY)",
   label: "Slatinany (CZSNY)"
  },
  {
   value: "Sokolov (CZSOK)",
   label: "Sokolov (CZSOK)"
  },
  {
   value: "Stare Hradiste (CZSHD)",
   label: "Stare Hradiste (CZSHD)"
  },
  {
   value: "Jablonec nad Nisou (CZJBC)",
   label: "Jablonec nad Nisou (CZJBC)"
  },
  {
   value: "Jablunkov (CZJBV)",
   label: "Jablunkov (CZJBV)"
  },
  {
   value: "Jaromer (Vychodolesky Jar) (CZJAR)",
   label: "Jaromer (Vychodolesky Jar) (CZJAR)"
  },
  {
   value: "Jesenik (CZJSN)",
   label: "Jesenik (CZJSN)"
  },
  {
   value: "Jicin (CZJIC)",
   label: "Jicin (CZJIC)"
  },
  {
   value: "Jihlava (CZJHV)",
   label: "Jihlava (CZJHV)"
  },
  {
   value: "Jindrichuv Hradec (CZJNH)",
   label: "Jindrichuv Hradec (CZJNH)"
  },
  {
   value: "Jirikov (CZJRA)",
   label: "Jirikov (CZJRA)"
  },
  {
   value: "Kaplice (CZKAP)",
   label: "Kaplice (CZKAP)"
  },
  {
   value: "Karlovy Vary (CZKLV)",
   label: "Karlovy Vary (CZKLV)"
  },
  {
   value: "Karvina (CZKRV)",
   label: "Karvina (CZKRV)"
  },
  {
   value: "Kladno (CZKLD)",
   label: "Kladno (CZKLD)"
  },
  {
   value: "Klatovy (CZKTV)",
   label: "Klatovy (CZKTV)"
  },
  {
   value: "Klicany (CZKLC)",
   label: "Klicany (CZKLC)"
  },
  {
   value: "Kolin (CZKLN)",
   label: "Kolin (CZKLN)"
  },
  {
   value: "Koprivnice (CZKOP)",
   label: "Koprivnice (CZKOP)"
  },
  {
   value: "Kraliky (CZKLK)",
   label: "Kraliky (CZKLK)"
  },
  {
   value: "Kralovec (CZKRL)",
   label: "Kralovec (CZKRL)"
  },
  {
   value: "Krnov (CZKRN)",
   label: "Krnov (CZKRN)"
  },
  {
   value: "Kromeriz (CZKMR)",
   label: "Kromeriz (CZKMR)"
  },
  {
   value: "Kurim (CZKUR)",
   label: "Kurim (CZKUR)"
  },
  {
   value: "Kutna Hora (CZKUH)",
   label: "Kutna Hora (CZKUH)"
  },
  {
   value: "Lanzhot (CZLZH)",
   label: "Lanzhot (CZLZH)"
  },
  {
   value: "Liberec (CZLBR)",
   label: "Liberec (CZLBR)"
  },
  {
   value: "Lichkov (CZLCH)",
   label: "Lichkov (CZLCH)"
  },
  {
   value: "Liskova u Nemanic (CZLIS)",
   label: "Liskova u Nemanic (CZLIS)"
  },
  {
   value: "Litomerice (CZLTC)",
   label: "Litomerice (CZLTC)"
  },
  {
   value: "Litomysl (CZLMS)",
   label: "Litomysl (CZLMS)"
  },
  {
   value: "Lovosice (CZLVC)",
   label: "Lovosice (CZLVC)"
  },
  {
   value: "Marianske Lazne (CZMKA)",
   label: "Marianske Lazne (CZMKA)"
  },
  {
   value: "Melnik (CZMEL)",
   label: "Melnik (CZMEL)"
  },
  {
   value: "Mezimesti (CZMZA)",
   label: "Mezimesti (CZMZA)"
  },
  {
   value: "Mikulov (CZMKL)",
   label: "Mikulov (CZMKL)"
  },
  {
   value: "Mikulovice (CZMCA)",
   label: "Mikulovice (CZMCA)"
  },
  {
   value: "Milevsko (CZMIL)",
   label: "Milevsko (CZMIL)"
  },
  {
   value: "Milin (CZMLN)",
   label: "Milin (CZMLN)"
  },
  {
   value: "Mimon (CZMMN)",
   label: "Mimon (CZMMN)"
  },
  {
   value: "Mlada Boleslav (CZMBV)",
   label: "Mlada Boleslav (CZMBV)"
  },
  {
   value: "Mohelnice (CZMHL)",
   label: "Mohelnice (CZMHL)"
  },
  {
   value: "Most (CZMST)",
   label: "Most (CZMST)"
  },
  {
   value: "Mosty u Jablunkova (CZMJB)",
   label: "Mosty u Jablunkova (CZMJB)"
  },
  {
   value: "Brezova (CZBRE)",
   label: "Brezova (CZBRE)"
  },
  {
   value: "Brno (CZBRQ)",
   label: "Brno (CZBRQ)"
  },
  {
   value: "Broumov (CZBRM)",
   label: "Broumov (CZBRM)"
  },
  {
   value: "Ceska Kubice (CZCEK)",
   label: "Ceska Kubice (CZCEK)"
  },
  {
   value: "Ceska Lipa (CZCLI)",
   label: "Ceska Lipa (CZCLI)"
  },
  {
   value: "Ceska Trebova (CZCTR)",
   label: "Ceska Trebova (CZCTR)"
  },
  {
   value: "Ceske Budejovice (CZCKB)",
   label: "Ceske Budejovice (CZCKB)"
  },
  {
   value: "Ceske Velenice (CZVEA)",
   label: "Ceske Velenice (CZVEA)"
  },
  {
   value: "Cesky Krumlov (CZCKR)",
   label: "Cesky Krumlov (CZCKR)"
  },
  {
   value: "Cesky Tesin (CZTEA)",
   label: "Cesky Tesin (CZTEA)"
  },
  {
   value: "Cheb (CZCHB)",
   label: "Cheb (CZCHB)"
  },
  {
   value: "Chomutov (CZCHM)",
   label: "Chomutov (CZCHM)"
  },
  {
   value: "Chotebuz (CZCHT)",
   label: "Chotebuz (CZCHT)"
  },
  {
   value: "Chrudim (CZCHR)",
   label: "Chrudim (CZCHR)"
  },
  {
   value: "Cinovec (CZCCA)",
   label: "Cinovec (CZCCA)"
  },
  {
   value: "Decin (CZDCB)",
   label: "Decin (CZDCB)"
  },
  {
   value: "Dobrejovice (CZDJE)",
   label: "Dobrejovice (CZDJE)"
  },
  {
   value: "Dolni Dvoriste (CZDDA)",
   label: "Dolni Dvoriste (CZDDA)"
  },
  {
   value: "Dolni Lipka (CZDLI)",
   label: "Dolni Lipka (CZDLI)"
  },
  {
   value: "Domazlice (CZDOM)",
   label: "Domazlice (CZDOM)"
  },
  {
   value: "Dubi (CZDBI)",
   label: "Dubi (CZDBI)"
  },
  {
   value: "Dvur Kralove nad Labem (CZDVK)",
   label: "Dvur Kralove nad Labem (CZDVK)"
  },
  {
   value: "Folmava (CZFOL)",
   label: "Folmava (CZFOL)"
  },
  {
   value: "Frydek Mistek (CZFRM)",
   label: "Frydek Mistek (CZFRM)"
  },
  {
   value: "Frydlant (CZFRY)",
   label: "Frydlant (CZFRY)"
  },
  {
   value: "Halamky (CZHLM)",
   label: "Halamky (CZHLM)"
  },
  {
   value: "Harrachov (CZHVA)",
   label: "Harrachov (CZHVA)"
  },
  {
   value: "Hate (CZHAT)",
   label: "Hate (CZHAT)"
  },
  {
   value: "Havlickuv Brod (CZHVB)",
   label: "Havlickuv Brod (CZHVB)"
  },
  {
   value: "Hevlin (CZHEA)",
   label: "Hevlin (CZHEA)"
  },
  {
   value: "Hlinsko (CZHLN)",
   label: "Hlinsko (CZHLN)"
  },
  {
   value: "Hodonin (CZHOD)",
   label: "Hodonin (CZHOD)"
  },
  {
   value: "Holesov (CZHOL)",
   label: "Holesov (CZHOL)"
  },
  {
   value: "Hora Sv.Sebestiana (CZHOS)",
   label: "Hora Sv.Sebestiana (CZHOS)"
  },
  {
   value: "Horni Adrspach (CZHAH)",
   label: "Horni Adrspach (CZHAH)"
  },
  {
   value: "Horni Becva (CZHBC)",
   label: "Horni Becva (CZHBC)"
  },
  {
   value: "Horni Dvoriste (CZHDA)",
   label: "Horni Dvoriste (CZHDA)"
  },
  {
   value: "Horni Lidec (CZHLD)",
   label: "Horni Lidec (CZHLD)"
  },
  {
   value: "Hradec Kralove (CZHKR)",
   label: "Hradec Kralove (CZHKR)"
  },
  {
   value: "Hrensko (CZHSA)",
   label: "Hrensko (CZHSA)"
  },
  {
   value: "Ivancice (CZICE)",
   label: "Ivancice (CZICE)"
  },
  {
   value: "Porto Preguica (CVPOP)",
   label: "Porto Preguica (CVPOP)"
  },
  {
   value: "Praia (CVRAI)",
   label: "Praia (CVRAI)"
  },
  {
   value: "Sal Island (CVSID)",
   label: "Sal Island (CVSID)"
  },
  {
   value: "Sal Rei (CVSAR)",
   label: "Sal Rei (CVSAR)"
  },
  {
   value: "Santa Maria (CVSAM)",
   label: "Santa Maria (CVSAM)"
  },
  {
   value: "Sao Filipe (CVSFL)",
   label: "Sao Filipe (CVSFL)"
  },
  {
   value: "Sao Nicolau (CVSNE)",
   label: "Sao Nicolau (CVSNE)"
  },
  {
   value: "Sao Vicente (CVVXE)",
   label: "Sao Vicente (CVVXE)"
  },
  {
   value: "Tarrafal (CVTAR)",
   label: "Tarrafal (CVTAR)"
  },
  {
   value: "Christmas Island (CXXCH)",
   label: "Christmas Island (CXXCH)"
  },
  {
   value: "Flying Fish Cove (CXFFC)",
   label: "Flying Fish Cove (CXFFC)"
  },
  {
   value: "Akrotiri (CYAKT)",
   label: "Akrotiri (CYAKT)"
  },
  {
   value: "Dhekelia (CYDHK)",
   label: "Dhekelia (CYDHK)"
  },
  {
   value: "Episkopi (CYEPK)",
   label: "Episkopi (CYEPK)"
  },
  {
   value: "Ercan (CYECN)",
   label: "Ercan (CYECN)"
  },
  {
   value: "Famagusta (CYFMG)",
   label: "Famagusta (CYFMG)"
  },
  {
   value: "Kalecik (CYKAL)",
   label: "Kalecik (CYKAL)"
  },
  {
   value: "Karavostassi (CYKAR)",
   label: "Karavostassi (CYKAR)"
  },
  {
   value: "Kyrenia (CYKYR)",
   label: "Kyrenia (CYKYR)"
  },
  {
   value: "Larnaca (CYLCA)",
   label: "Larnaca (CYLCA)"
  },
  {
   value: "Latchi (CYLAT)",
   label: "Latchi (CYLAT)"
  },
  {
   value: "Limassol (CYLMS)",
   label: "Limassol (CYLMS)"
  },
  {
   value: "Moni Anchorage (CYMOI)",
   label: "Moni Anchorage (CYMOI)"
  },
  {
   value: "Morphou Bay (CYMPB)",
   label: "Morphou Bay (CYMPB)"
  },
  {
   value: "Nicosia (CYNIC)",
   label: "Nicosia (CYNIC)"
  },
  {
   value: "Paphos (CYPFO)",
   label: "Paphos (CYPFO)"
  },
  {
   value: "Vassiliko (CYVAS)",
   label: "Vassiliko (CYVAS)"
  },
  {
   value: "Zeros (CYZER)",
   label: "Zeros (CYZER)"
  },
  {
   value: "Zyyi (CYZYY)",
   label: "Zyyi (CYZYY)"
  },
  {
   value: "As (CZASA)",
   label: "As (CZASA)"
  },
  {
   value: "Banov (CZBAN)",
   label: "Banov (CZBAN)"
  },
  {
   value: "Benesov (CZBEN)",
   label: "Benesov (CZBEN)"
  },
  {
   value: "Beroun (CZBER)",
   label: "Beroun (CZBER)"
  },
  {
   value: "Bila (CZBIL)",
   label: "Bila (CZBIL)"
  },
  {
   value: "Bily Potok (CZBIP)",
   label: "Bily Potok (CZBIP)"
  },
  {
   value: "Blansko (CZBLA)",
   label: "Blansko (CZBLA)"
  },
  {
   value: "Bohumin (CZBOH)",
   label: "Bohumin (CZBOH)"
  },
  {
   value: "Bor u Tachova (CZBOR)",
   label: "Bor u Tachova (CZBOR)"
  },
  {
   value: "Bozi Dar (CZBDA)",
   label: "Bozi Dar (CZBDA)"
  },
  {
   value: "Brandys nad Labem (CZBNL)",
   label: "Brandys nad Labem (CZBNL)"
  },
  {
   value: "Breclav (CZBVA)",
   label: "Breclav (CZBVA)"
  },
  {
   value: "Guantanamo Nas Apt (CUNBW)",
   label: "Guantanamo Nas Apt (CUNBW)"
  },
  {
   value: "Guantanamo-Los Canos Apt (CUGAO)",
   label: "Guantanamo-Los Canos Apt (CUGAO)"
  },
  {
   value: "Guayabal (CUGYB)",
   label: "Guayabal (CUGYB)"
  },
  {
   value: "Habana (CUHAV)",
   label: "Habana (CUHAV)"
  },
  {
   value: "Holguin (CUHOG)",
   label: "Holguin (CUHOG)"
  },
  {
   value: "Isabela de Sagua (CUIDS)",
   label: "Isabela de Sagua (CUIDS)"
  },
  {
   value: "Jucaro (CUJUC)",
   label: "Jucaro (CUJUC)"
  },
  {
   value: "Las Tunas (CUVTU)",
   label: "Las Tunas (CUVTU)"
  },
  {
   value: "Manati (CUMNT)",
   label: "Manati (CUMNT)"
  },
  {
   value: "Manzanillo (CUMZO)",
   label: "Manzanillo (CUMZO)"
  },
  {
   value: "Mariel (CUMAR)",
   label: "Mariel (CUMAR)"
  },
  {
   value: "Matanzas (CUQMA)",
   label: "Matanzas (CUQMA)"
  },
  {
   value: "Media Luna (CUMEL)",
   label: "Media Luna (CUMEL)"
  },
  {
   value: "Moa (CUMOA)",
   label: "Moa (CUMOA)"
  },
  {
   value: "Nicaro (CUICR)",
   label: "Nicaro (CUICR)"
  },
  {
   value: "Niquero (CUNIQ)",
   label: "Niquero (CUNIQ)"
  },
  {
   value: "Nueva Gerona (CUGER)",
   label: "Nueva Gerona (CUGER)"
  },
  {
   value: "Nuevitas (CUNVT)",
   label: "Nuevitas (CUNVT)"
  },
  {
   value: "Pastelillo (CUPAS)",
   label: "Pastelillo (CUPAS)"
  },
  {
   value: "Pilon (CUPIL)",
   label: "Pilon (CUPIL)"
  },
  {
   value: "Puerto Padre (CUPPA)",
   label: "Puerto Padre (CUPPA)"
  },
  {
   value: "Puerto Tarafa (CUPTA)",
   label: "Puerto Tarafa (CUPTA)"
  },
  {
   value: "Rio Sagua la Grande (CURSL)",
   label: "Rio Sagua la Grande (CURSL)"
  },
  {
   value: "Sagua de Tanamo (CUSDT)",
   label: "Sagua de Tanamo (CUSDT)"
  },
  {
   value: "Santa Clara (CUSNU)",
   label: "Santa Clara (CUSNU)"
  },
  {
   value: "Santa Cruz del Sur (CUSCS)",
   label: "Santa Cruz del Sur (CUSCS)"
  },
  {
   value: "Santiago de Cuba (CUSCU)",
   label: "Santiago de Cuba (CUSCU)"
  },
  {
   value: "Tanamo (CUTAN)",
   label: "Tanamo (CUTAN)"
  },
  {
   value: "Trinidad (CUTND)",
   label: "Trinidad (CUTND)"
  },
  {
   value: "Tunas de Zaza (CUTDZ)",
   label: "Tunas de Zaza (CUTDZ)"
  },
  {
   value: "Vita (CUVIT)",
   label: "Vita (CUVIT)"
  },
  {
   value: "Maio (CVMMO)",
   label: "Maio (CVMMO)"
  },
  {
   value: "Mindelo (CVMIN)",
   label: "Mindelo (CVMIN)"
  },
  {
   value: "Mosteiros (CVMTI)",
   label: "Mosteiros (CVMTI)"
  },
  {
   value: "Palmeira (CVPAL)",
   label: "Palmeira (CVPAL)"
  },
  {
   value: "Pedra de Lume (CVPLM)",
   label: "Pedra de Lume (CVPLM)"
  },
  {
   value: "Porto Grande (CVPGR)",
   label: "Porto Grande (CVPGR)"
  },
  {
   value: "Porto Ingles (CVPOI)",
   label: "Porto Ingles (CVPOI)"
  },
  {
   value: "Porto Novo (CVPON)",
   label: "Porto Novo (CVPON)"
  },
  {
   value: "Santa Marta (COSMR)",
   label: "Santa Marta (COSMR)"
  },
  {
   value: "Savanilla (COSAV)",
   label: "Savanilla (COSAV)"
  },
  {
   value: "Tolu (COTLU)",
   label: "Tolu (COTLU)"
  },
  {
   value: "Tumaco (COTCO)",
   label: "Tumaco (COTCO)"
  },
  {
   value: "Turbo (COTRB)",
   label: "Turbo (COTRB)"
  },
  {
   value: "VALLEDUPAR (COVUP)",
   label: "VALLEDUPAR (COVUP)"
  },
  {
   value: "Alajuela (CRAJU)",
   label: "Alajuela (CRAJU)"
  },
  {
   value: "Caldera (CRCAL)",
   label: "Caldera (CRCAL)"
  },
  {
   value: "Cartago (CRCAR)",
   label: "Cartago (CRCAR)"
  },
  {
   value: "Esparta (CRESP)",
   label: "Esparta (CRESP)"
  },
  {
   value: "Golfito (CRGLF)",
   label: "Golfito (CRGLF)"
  },
  {
   value: "Grecia (CRGMI)",
   label: "Grecia (CRGMI)"
  },
  {
   value: "Heredia (CRHER)",
   label: "Heredia (CRHER)"
  },
  {
   value: "Liberia (CRLIR)",
   label: "Liberia (CRLIR)"
  },
  {
   value: "Los Chiles (CRLSL)",
   label: "Los Chiles (CRLSL)"
  },
  {
   value: "Moin Bay (Puerto Limon) (CRMOB)",
   label: "Moin Bay (Puerto Limon) (CRMOB)"
  },
  {
   value: "Nicoya (CRNCT)",
   label: "Nicoya (CRNCT)"
  },
  {
   value: "Palmar (CRPMZ)",
   label: "Palmar (CRPMZ)"
  },
  {
   value: "Puerto Limon (CRLIO)",
   label: "Puerto Limon (CRLIO)"
  },
  {
   value: "Puntamorales (CRPUM)",
   label: "Puntamorales (CRPUM)"
  },
  {
   value: "Puntarenas (CRPAS)",
   label: "Puntarenas (CRPAS)"
  },
  {
   value: "Quepos (Puerto Quepos) (CRXQP)",
   label: "Quepos (Puerto Quepos) (CRXQP)"
  },
  {
   value: "San Jose (CRSJO)",
   label: "San Jose (CRSJO)"
  },
  {
   value: "San Ramon (CRSOR)",
   label: "San Ramon (CRSOR)"
  },
  {
   value: "Antilla (CUANT)",
   label: "Antilla (CUANT)"
  },
  {
   value: "Bahia Honda (CUBHO)",
   label: "Bahia Honda (CUBHO)"
  },
  {
   value: "Banes (CUBAN)",
   label: "Banes (CUBAN)"
  },
  {
   value: "Baracoa (CUBCA)",
   label: "Baracoa (CUBCA)"
  },
  {
   value: "Bayamo (CUBYM)",
   label: "Bayamo (CUBYM)"
  },
  {
   value: "Boca Grande (CUBOG)",
   label: "Boca Grande (CUBOG)"
  },
  {
   value: "Boqueron (CUBOQ)",
   label: "Boqueron (CUBOQ)"
  },
  {
   value: "Bufadero (CUBUF)",
   label: "Bufadero (CUBUF)"
  },
  {
   value: "Cabanas (CUCAB)",
   label: "Cabanas (CUCAB)"
  },
  {
   value: "Caibarien (CUCAI)",
   label: "Caibarien (CUCAI)"
  },
  {
   value: "Camaguey (CUCMW)",
   label: "Camaguey (CUCMW)"
  },
  {
   value: "Cardenas (CUCAR)",
   label: "Cardenas (CUCAR)"
  },
  {
   value: "Casilda (CUCAS)",
   label: "Casilda (CUCAS)"
  },
  {
   value: "Ceiba Hueca (CUCEI)",
   label: "Ceiba Hueca (CUCEI)"
  },
  {
   value: "Cienfuegos (CUCFG)",
   label: "Cienfuegos (CUCFG)"
  },
  {
   value: "Colon (CUQCO)",
   label: "Colon (CUQCO)"
  },
  {
   value: "Guantanamo Bay (CUGUB)",
   label: "Guantanamo Bay (CUGUB)"
  },
  {
   value: "Zhoushan (CNZOS)",
   label: "Zhoushan (CNZOS)"
  },
  {
   value: "Zhuengadabuqi (CNZEQ)",
   label: "Zhuengadabuqi (CNZEQ)"
  },
  {
   value: "Zhuhai (CNZUH)",
   label: "Zhuhai (CNZUH)"
  },
  {
   value: "Zhuozhou (CNZHZ)",
   label: "Zhuozhou (CNZHZ)"
  },
  {
   value: "Zibo (CNZIB)",
   label: "Zibo (CNZIB)"
  },
  {
   value: "Apartado (COAPO)",
   label: "Apartado (COAPO)"
  },
  {
   value: "Arauca (COAUC)",
   label: "Arauca (COAUC)"
  },
  {
   value: "Armenia (COAXM)",
   label: "Armenia (COAXM)"
  },
  {
   value: "Barrancabermeja (COEJA)",
   label: "Barrancabermeja (COEJA)"
  },
  {
   value: "Barranquilla (COBAQ)",
   label: "Barranquilla (COBAQ)"
  },
  {
   value: "Bogota (COBOG)",
   label: "Bogota (COBOG)"
  },
  {
   value: "Bucaramanga (COBGA)",
   label: "Bucaramanga (COBGA)"
  },
  {
   value: "Buenaventura (COBUN)",
   label: "Buenaventura (COBUN)"
  },
  {
   value: "Cali (COCLO)",
   label: "Cali (COCLO)"
  },
  {
   value: "Cartagena (COCTG)",
   label: "Cartagena (COCTG)"
  },
  {
   value: "Cartago (COCRC)",
   label: "Cartago (COCRC)"
  },
  {
   value: "Chigorodo (COIGO)",
   label: "Chigorodo (COIGO)"
  },
  {
   value: "Cienaga (COCIE)",
   label: "Cienaga (COCIE)"
  },
  {
   value: "Covenas (COCVE)",
   label: "Covenas (COCVE)"
  },
  {
   value: "Cucuta (COCUC)",
   label: "Cucuta (COCUC)"
  },
  {
   value: "El Bagre (COEBG)",
   label: "El Bagre (COEBG)"
  },
  {
   value: "El Bosque (COEBQ)",
   label: "El Bosque (COEBQ)"
  },
  {
   value: "Leticia (COLET)",
   label: "Leticia (COLET)"
  },
  {
   value: "Mamonal (COMAM)",
   label: "Mamonal (COMAM)"
  },
  {
   value: "Manizales (COMZL)",
   label: "Manizales (COMZL)"
  },
  {
   value: "Medellin (COMDE)",
   label: "Medellin (COMDE)"
  },
  {
   value: "Monteria (COMTR)",
   label: "Monteria (COMTR)"
  },
  {
   value: "Pasto (COPSO)",
   label: "Pasto (COPSO)"
  },
  {
   value: "Pereira (COPEI)",
   label: "Pereira (COPEI)"
  },
  {
   value: "Popayan (COPPN)",
   label: "Popayan (COPPN)"
  },
  {
   value: "Pozos Colorados (COPOC)",
   label: "Pozos Colorados (COPOC)"
  },
  {
   value: "Puerto Asis (COPUU)",
   label: "Puerto Asis (COPUU)"
  },
  {
   value: "Puerto Berrio (COPBE)",
   label: "Puerto Berrio (COPBE)"
  },
  {
   value: "Puerto Bolivar (COPBO)",
   label: "Puerto Bolivar (COPBO)"
  },
  {
   value: "Puerto Carreno (COPCR)",
   label: "Puerto Carreno (COPCR)"
  },
  {
   value: "Puerto Colombia (COPUC)",
   label: "Puerto Colombia (COPUC)"
  },
  {
   value: "Puerto Prodeco (COPPR)",
   label: "Puerto Prodeco (COPPR)"
  },
  {
   value: "Quibdo (COUIB)",
   label: "Quibdo (COUIB)"
  },
  {
   value: "Riohacha (CORCH)",
   label: "Riohacha (CORCH)"
  },
  {
   value: "San Andres Island (COADZ)",
   label: "San Andres Island (COADZ)"
  },
  {
   value: "Wenjindu (CNWJD)",
   label: "Wenjindu (CNWJD)"
  },
  {
   value: "Wenzhou (CNWNZ)",
   label: "Wenzhou (CNWNZ)"
  },
  {
   value: "Wuhan (CNWUH)",
   label: "Wuhan (CNWUH)"
  },
  {
   value: "Wuhu (CNWHI)",
   label: "Wuhu (CNWHI)"
  },
  {
   value: "Wusong (CNWUS)",
   label: "Wusong (CNWUS)"
  },
  {
   value: "Wuxi (CNWUX)",
   label: "Wuxi (CNWUX)"
  },
  {
   value: "Wuyishan (CNWYS)",
   label: "Wuyishan (CNWYS)"
  },
  {
   value: "Wuzhou (CNWUZ)",
   label: "Wuzhou (CNWUZ)"
  },
  {
   value: "Xi An (CNSIA)",
   label: "Xi An (CNSIA)"
  },
  {
   value: "Xi xiang (CNXIX)",
   label: "Xi xiang (CNXIX)"
  },
  {
   value: "Xia Hua (CNXUA)",
   label: "Xia Hua (CNXUA)"
  },
  {
   value: "Xiamen (CNXMN)",
   label: "Xiamen (CNXMN)"
  },
  {
   value: "Xiangzhou (CNXGZ)",
   label: "Xiangzhou (CNXGZ)"
  },
  {
   value: "Xiaoshan (CNXIS)",
   label: "Xiaoshan (CNXIS)"
  },
  {
   value: "Xinfeng (CNXAB)",
   label: "Xinfeng (CNXAB)"
  },
  {
   value: "Xinhui (CNXIN)",
   label: "Xinhui (CNXIN)"
  },
  {
   value: "Xining (CNXNN)",
   label: "Xining (CNXNN)"
  },
  {
   value: "Xiqiao (CNXIQ)",
   label: "Xiqiao (CNXIQ)"
  },
  {
   value: "Xixiang (CNXXN)",
   label: "Xixiang (CNXXN)"
  },
  {
   value: "Xunke (CNXUK)",
   label: "Xunke (CNXUK)"
  },
  {
   value: "Xuzhou (CNXUZ)",
   label: "Xuzhou (CNXUZ)"
  },
  {
   value: "Yangjiang (CNYJI)",
   label: "Yangjiang (CNYJI)"
  },
  {
   value: "Yangpu (CNYPG)",
   label: "Yangpu (CNYPG)"
  },
  {
   value: "Yangzhou (CNYZH)",
   label: "Yangzhou (CNYZH)"
  },
  {
   value: "Yanji (CNYNJ)",
   label: "Yanji (CNYNJ)"
  },
  {
   value: "Yantai (CNYNT)",
   label: "Yantai (CNYNT)"
  },
  {
   value: "Yantian (CNYTN)",
   label: "Yantian (CNYTN)"
  },
  {
   value: "Yinchuan (CNYIH)",
   label: "Yinchuan (CNYIH)"
  },
  {
   value: "Yingkou (CNYIK)",
   label: "Yingkou (CNYIK)"
  },
  {
   value: "Yining (CNYIN)",
   label: "Yining (CNYIN)"
  },
  {
   value: "Youyiguan (CNYYG)",
   label: "Youyiguan (CNYYG)"
  },
  {
   value: "Yuncheng (CNYUN)",
   label: "Yuncheng (CNYUN)"
  },
  {
   value: "Yunfu (CNYNF)",
   label: "Yunfu (CNYNF)"
  },
  {
   value: "Zengcheng (CNZNG)",
   label: "Zengcheng (CNZNG)"
  },
  {
   value: "Zham (CNZMU)",
   label: "Zham (CNZMU)"
  },
  {
   value: "Zhangjiagang (CNZJG)",
   label: "Zhangjiagang (CNZJG)"
  },
  {
   value: "Zhangmutou (CNZGU)",
   label: "Zhangmutou (CNZGU)"
  },
  {
   value: "Zhangzhou (CNZZU)",
   label: "Zhangzhou (CNZZU)"
  },
  {
   value: "Zhanjiang (CNZHA)",
   label: "Zhanjiang (CNZHA)"
  },
  {
   value: "Zhaoqing (CNZQG)",
   label: "Zhaoqing (CNZQG)"
  },
  {
   value: "Zhengzhou (CNCGO)",
   label: "Zhengzhou (CNCGO)"
  },
  {
   value: "Zhenjiang (CNZHE)",
   label: "Zhenjiang (CNZHE)"
  },
  {
   value: "Zhongshan (CNZSN)",
   label: "Zhongshan (CNZSN)"
  },
  {
   value: "Shekou (CNSHK)",
   label: "Shekou (CNSHK)"
  },
  {
   value: "Shenyang (CNSHE)",
   label: "Shenyang (CNSHE)"
  },
  {
   value: "Shenzhen (CNSZX)",
   label: "Shenzhen (CNSZX)"
  },
  {
   value: "Shidao (CNSHD)",
   label: "Shidao (CNSHD)"
  },
  {
   value: "Shijiazhuang (CNSJW)",
   label: "Shijiazhuang (CNSJW)"
  },
  {
   value: "Shitoubu (CNSTB)",
   label: "Shitoubu (CNSTB)"
  },
  {
   value: "Shiwei (CNSWI)",
   label: "Shiwei (CNSWI)"
  },
  {
   value: "Shiyan (CNSYN)",
   label: "Shiyan (CNSYN)"
  },
  {
   value: "Shuidong (CNSDG)",
   label: "Shuidong (CNSDG)"
  },
  {
   value: "Shuikou (CNSKO)",
   label: "Shuikou (CNSKO)"
  },
  {
   value: "Shunde (CNSUD)",
   label: "Shunde (CNSUD)"
  },
  {
   value: "Sihui (CNSIH)",
   label: "Sihui (CNSIH)"
  },
  {
   value: "Simao (CNSYM)",
   label: "Simao (CNSYM)"
  },
  {
   value: "Songjiang (CNSNG)",
   label: "Songjiang (CNSNG)"
  },
  {
   value: "Songxia (CNSON)",
   label: "Songxia (CNSON)"
  },
  {
   value: "Suifenhe (CNSFE)",
   label: "Suifenhe (CNSFE)"
  },
  {
   value: "Suijiang (CNSGG)",
   label: "Suijiang (CNSGG)"
  },
  {
   value: "Sunwu (CNSUW)",
   label: "Sunwu (CNSUW)"
  },
  {
   value: "Suzhou (CNSZH)",
   label: "Suzhou (CNSZH)"
  },
  {
   value: "Taian (CNTAI)",
   label: "Taian (CNTAI)"
  },
  {
   value: "Taiping (CNTAP)",
   label: "Taiping (CNTAP)"
  },
  {
   value: "Taishan (CNTSH)",
   label: "Taishan (CNTSH)"
  },
  {
   value: "Taiyuan (CNTYN)",
   label: "Taiyuan (CNTYN)"
  },
  {
   value: "Tanggu (CNTGU)",
   label: "Tanggu (CNTGU)"
  },
  {
   value: "Tangshan (CNTAS)",
   label: "Tangshan (CNTAS)"
  },
  {
   value: "Tangxia (CNTXA)",
   label: "Tangxia (CNTXA)"
  },
  {
   value: "Taykexkin (CNTKK)",
   label: "Taykexkin (CNTKK)"
  },
  {
   value: "Tianbao (CNTBO)",
   label: "Tianbao (CNTBO)"
  },
  {
   value: "Tianjin (CNTSN)",
   label: "Tianjin (CNTSN)"
  },
  {
   value: "Tianjinxingang (CNTXG)",
   label: "Tianjinxingang (CNTXG)"
  },
  {
   value: "Tongjiang (CNTOJ)",
   label: "Tongjiang (CNTOJ)"
  },
  {
   value: "Tongling (CNTOL)",
   label: "Tongling (CNTOL)"
  },
  {
   value: "Tumen (CNTME)",
   label: "Tumen (CNTME)"
  },
  {
   value: "Turugart (CNTRT)",
   label: "Turugart (CNTRT)"
  },
  {
   value: "Ulastai (CNULT)",
   label: "Ulastai (CNULT)"
  },
  {
   value: "Urumqi (CNURC)",
   label: "Urumqi (CNURC)"
  },
  {
   value: "Wafangdian (CNWAF)",
   label: "Wafangdian (CNWAF)"
  },
  {
   value: "Waigaoqiao (CNWGQ)",
   label: "Waigaoqiao (CNWGQ)"
  },
  {
   value: "Wanding (CNWAN)",
   label: "Wanding (CNWAN)"
  },
  {
   value: "Wanzai (CNWAZ)",
   label: "Wanzai (CNWAZ)"
  },
  {
   value: "Weifang (CNWFG)",
   label: "Weifang (CNWFG)"
  },
  {
   value: "Weihai (CNWEI)",
   label: "Weihai (CNWEI)"
  },
  {
   value: "Panyu (CNPNY)",
   label: "Panyu (CNPNY)"
  },
  {
   value: "Ping wu (CNPGW)",
   label: "Ping wu (CNPGW)"
  },
  {
   value: "Pingdi (CNPND)",
   label: "Pingdi (CNPND)"
  },
  {
   value: "Pinghu (CNPNH)",
   label: "Pinghu (CNPNH)"
  },
  {
   value: "Pingshan (CNPNS)",
   label: "Pingshan (CNPNS)"
  },
  {
   value: "Pingxiang (CNPIN)",
   label: "Pingxiang (CNPIN)"
  },
  {
   value: "Puning (CNPNG)",
   label: "Puning (CNPNG)"
  },
  {
   value: "Putian (CNPUT)",
   label: "Putian (CNPUT)"
  },
  {
   value: "Qianxi (CNQIA)",
   label: "Qianxi (CNQIA)"
  },
  {
   value: "Qingdao (CNTAO)",
   label: "Qingdao (CNTAO)"
  },
  {
   value: "Qinglan (CNQLN)",
   label: "Qinglan (CNQLN)"
  },
  {
   value: "Qingxi (CNQIN)",
   label: "Qingxi (CNQIN)"
  },
  {
   value: "Qingyuan (CNQYN)",
   label: "Qingyuan (CNQYN)"
  },
  {
   value: "Qinhuangdao (CNSHP)",
   label: "Qinhuangdao (CNSHP)"
  },
  {
   value: "Qinzhou (CNQZH)",
   label: "Qinzhou (CNQZH)"
  },
  {
   value: "Qiqihar (CNNDG)",
   label: "Qiqihar (CNNDG)"
  },
  {
   value: "Qisha (CNQSA)",
   label: "Qisha (CNQSA)"
  },
  {
   value: "Quanzhou (CNQZJ)",
   label: "Quanzhou (CNQZJ)"
  },
  {
   value: "Raohe (CNROH)",
   label: "Raohe (CNROH)"
  },
  {
   value: "Riwo (CNRIW)",
   label: "Riwo (CNRIW)"
  },
  {
   value: "Rizhao (CNRZH)",
   label: "Rizhao (CNRZH)"
  },
  {
   value: "Rongcheng (CNRNG)",
   label: "Rongcheng (CNRNG)"
  },
  {
   value: "Rongqi (CNROQ)",
   label: "Rongqi (CNROQ)"
  },
  {
   value: "Ruili (CNRUI)",
   label: "Ruili (CNRUI)"
  },
  {
   value: "San beiman (CNSBM)",
   label: "San beiman (CNSBM)"
  },
  {
   value: "Sanbu (CNSBU)",
   label: "Sanbu (CNSBU)"
  },
  {
   value: "Sanhe (CNSAH)",
   label: "Sanhe (CNSAH)"
  },
  {
   value: "Sanshan (CNSHG)",
   label: "Sanshan (CNSHG)"
  },
  {
   value: "Sanshan (Nanhai) (CNSSH)",
   label: "Sanshan (Nanhai) (CNSSH)"
  },
  {
   value: "Sanshui (CNSJQ)",
   label: "Sanshui (CNSJQ)"
  },
  {
   value: "Sanya (CNSYX)",
   label: "Sanya (CNSYX)"
  },
  {
   value: "Shajiao (CNSHO)",
   label: "Shajiao (CNSHO)"
  },
  {
   value: "Shajing (CNSHJ)",
   label: "Shajing (CNSHJ)"
  },
  {
   value: "Shanghai (CNSHA)",
   label: "Shanghai (CNSHA)"
  },
  {
   value: "Shanhaiguan (CNSHH)",
   label: "Shanhaiguan (CNSHH)"
  },
  {
   value: "Shanshan (CNSXJ)",
   label: "Shanshan (CNSXJ)"
  },
  {
   value: "Shantou (CNSWA)",
   label: "Shantou (CNSWA)"
  },
  {
   value: "Shanwei (CNSWE)",
   label: "Shanwei (CNSWE)"
  },
  {
   value: "Shaoguan (CNHSC)",
   label: "Shaoguan (CNHSC)"
  },
  {
   value: "Shaoxing (CNSXG)",
   label: "Shaoxing (CNSXG)"
  },
  {
   value: "Shatoujiao (CNSTJ)",
   label: "Shatoujiao (CNSTJ)"
  },
  {
   value: "Shawan (CNSWN)",
   label: "Shawan (CNSWN)"
  },
  {
   value: "Kunjirap (CNKJP)",
   label: "Kunjirap (CNKJP)"
  },
  {
   value: "Kunming (CNKMG)",
   label: "Kunming (CNKMG)"
  },
  {
   value: "Kunshan (CNKUS)",
   label: "Kunshan (CNKUS)"
  },
  {
   value: "Laiwu (CNLWU)",
   label: "Laiwu (CNLWU)"
  },
  {
   value: "Laizhou (CNLAI)",
   label: "Laizhou (CNLAI)"
  },
  {
   value: "Lanshan (CNLSN)",
   label: "Lanshan (CNLSN)"
  },
  {
   value: "Lanzhou (CNLHW)",
   label: "Lanzhou (CNLHW)"
  },
  {
   value: "Laoyemiao (CNLYM)",
   label: "Laoyemiao (CNLYM)"
  },
  {
   value: "Lhasa (CNLXA)",
   label: "Lhasa (CNLXA)"
  },
  {
   value: "Lianhuashan (CNLIH)",
   label: "Lianhuashan (CNLIH)"
  },
  {
   value: "Lianyungang (CNLYG)",
   label: "Lianyungang (CNLYG)"
  },
  {
   value: "Liaobu (CNLBU)",
   label: "Liaobu (CNLBU)"
  },
  {
   value: "Linjiang (CNLIN)",
   label: "Linjiang (CNLIN)"
  },
  {
   value: "Linyi (CNLYI)",
   label: "Linyi (CNLYI)"
  },
  {
   value: "Liuzhou (CNLZH)",
   label: "Liuzhou (CNLZH)"
  },
  {
   value: "Longgang (CNLGG)",
   label: "Longgang (CNLGG)"
  },
  {
   value: "Longhua (CNLGH)",
   label: "Longhua (CNLGH)"
  },
  {
   value: "Longkou (CNLKU)",
   label: "Longkou (CNLKU)"
  },
  {
   value: "Luobei (CNLUB)",
   label: "Luobei (CNLUB)"
  },
  {
   value: "Luoyang (CNLYA)",
   label: "Luoyang (CNLYA)"
  },
  {
   value: "Lushun (CNLSH)",
   label: "Lushun (CNLSH)"
  },
  {
   value: "Maanshan (CNMAA)",
   label: "Maanshan (CNMAA)"
  },
  {
   value: "Manzhouli (CNMLX)",
   label: "Manzhouli (CNMLX)"
  },
  {
   value: "Maoming (CNMMI)",
   label: "Maoming (CNMMI)"
  },
  {
   value: "Mawan (CNMWN)",
   label: "Mawan (CNMWN)"
  },
  {
   value: "Mawei (CNMAW)",
   label: "Mawei (CNMAW)"
  },
  {
   value: "Mazongshan (CNMZS)",
   label: "Mazongshan (CNMZS)"
  },
  {
   value: "Meizhou (CNMEZ)",
   label: "Meizhou (CNMEZ)"
  },
  {
   value: "Mishan (CNMIS)",
   label: "Mishan (CNMIS)"
  },
  {
   value: "Mohan (CNMHN)",
   label: "Mohan (CNMHN)"
  },
  {
   value: "Mohe (CNMOH)",
   label: "Mohe (CNMOH)"
  },
  {
   value: "Nanao (CNNAN)",
   label: "Nanao (CNNAN)"
  },
  {
   value: "Nanchang (CNKHN)",
   label: "Nanchang (CNKHN)"
  },
  {
   value: "Nangang (CNNGG)",
   label: "Nangang (CNNGG)"
  },
  {
   value: "Nanhai (CNNAH)",
   label: "Nanhai (CNNAH)"
  },
  {
   value: "Nanjing (CNNKG)",
   label: "Nanjing (CNNKG)"
  },
  {
   value: "Nanning (CNNNG)",
   label: "Nanning (CNNNG)"
  },
  {
   value: "Nanping (CNNAP)",
   label: "Nanping (CNNAP)"
  },
  {
   value: "Nansha (CNNSA)",
   label: "Nansha (CNNSA)"
  },
  {
   value: "Nantong (CNNTG)",
   label: "Nantong (CNNTG)"
  },
  {
   value: "Nantou (CNNTU)",
   label: "Nantou (CNNTU)"
  },
  {
   value: "Nanyang (CNNNY)",
   label: "Nanyang (CNNNY)"
  },
  {
   value: "Ningbo (CNNGB)",
   label: "Ningbo (CNNGB)"
  },
  {
   value: "Hengyang (CNHNY)",
   label: "Hengyang (CNHNY)"
  },
  {
   value: "Heshan (CNHSN)",
   label: "Heshan (CNHSN)"
  },
  {
   value: "Hohhot (CNHET)",
   label: "Hohhot (CNHET)"
  },
  {
   value: "Hongshanzui (CNHSZ)",
   label: "Hongshanzui (CNHSZ)"
  },
  {
   value: "Horgos (CNHRS)",
   label: "Horgos (CNHRS)"
  },
  {
   value: "Hua Du (CNHUD)",
   label: "Hua Du (CNHUD)"
  },
  {
   value: "Huachuan (CNHCN)",
   label: "Huachuan (CNHCN)"
  },
  {
   value: "Huanggang (CNHUG)",
   label: "Huanggang (CNHUG)"
  },
  {
   value: "Huangpu (CNHUA)",
   label: "Huangpu (CNHUA)"
  },
  {
   value: "Huangshan (CNHSH)",
   label: "Huangshan (CNHSH)"
  },
  {
   value: "Huangshi (CNHSI)",
   label: "Huangshi (CNHSI)"
  },
  {
   value: "Huizhou (CNHUI)",
   label: "Huizhou (CNHUI)"
  },
  {
   value: "Hulin (CNHUL)",
   label: "Hulin (CNHUL)"
  },
  {
   value: "Huma (CNHUM)",
   label: "Huma (CNHUM)"
  },
  {
   value: "Humen (CNHMN)",
   label: "Humen (CNHMN)"
  },
  {
   value: "Hunchun (CNHUC)",
   label: "Hunchun (CNHUC)"
  },
  {
   value: "Huzhou (CNHZH)",
   label: "Huzhou (CNHZH)"
  },
  {
   value: "Jeminay (CNJEM)",
   label: "Jeminay (CNJEM)"
  },
  {
   value: "Ji'an (CNKNC)",
   label: "Ji'an (CNKNC)"
  },
  {
   value: "Jiading (CNJIG)",
   label: "Jiading (CNJIG)"
  },
  {
   value: "Jiamusi (CNJMU)",
   label: "Jiamusi (CNJMU)"
  },
  {
   value: "Jiangmen (CNJMN)",
   label: "Jiangmen (CNJMN)"
  },
  {
   value: "Jiangshan (CNJIS)",
   label: "Jiangshan (CNJIS)"
  },
  {
   value: "Jiangyin (CNJIA)",
   label: "Jiangyin (CNJIA)"
  },
  {
   value: "Jiaxing (CNJIX)",
   label: "Jiaxing (CNJIX)"
  },
  {
   value: "Jiayin (CNJAY)",
   label: "Jiayin (CNJAY)"
  },
  {
   value: "Jiazi (CNJIZ)",
   label: "Jiazi (CNJIZ)"
  },
  {
   value: "Jiexi (CNJXI)",
   label: "Jiexi (CNJXI)"
  },
  {
   value: "Jieyang (CNJYG)",
   label: "Jieyang (CNJYG)"
  },
  {
   value: "Jilin (CNJIL)",
   label: "Jilin (CNJIL)"
  },
  {
   value: "Jinan (CNTNA)",
   label: "Jinan (CNTNA)"
  },
  {
   value: "Jingdezhen (CNJDZ)",
   label: "Jingdezhen (CNJDZ)"
  },
  {
   value: "Jinghong (CNJHG)",
   label: "Jinghong (CNJHG)"
  },
  {
   value: "Jinhua (CNJHA)",
   label: "Jinhua (CNJHA)"
  },
  {
   value: "Jining (CNJII)",
   label: "Jining (CNJII)"
  },
  {
   value: "Jining (CNJNG)",
   label: "Jining (CNJNG)"
  },
  {
   value: "Jinshuihe (CNJSH)",
   label: "Jinshuihe (CNJSH)"
  },
  {
   value: "Jinzhou (CNJNZ)",
   label: "Jinzhou (CNJNZ)"
  },
  {
   value: "Jiujiang (CNJIU)",
   label: "Jiujiang (CNJIU)"
  },
  {
   value: "Jiuzhou (CNJZU)",
   label: "Jiuzhou (CNJZU)"
  },
  {
   value: "Kaikou (CNKAI)",
   label: "Kaikou (CNKAI)"
  },
  {
   value: "Kaishantun (CNKST)",
   label: "Kaishantun (CNKST)"
  },
  {
   value: "Kashi (CNKHG)",
   label: "Kashi (CNKHG)"
  },
  {
   value: "Doumen (CNDOU)",
   label: "Doumen (CNDOU)"
  },
  {
   value: "Enping (CNENP)",
   label: "Enping (CNENP)"
  },
  {
   value: "Erenhot (CNRLC)",
   label: "Erenhot (CNRLC)"
  },
  {
   value: "Fangcheng (CNFAN)",
   label: "Fangcheng (CNFAN)"
  },
  {
   value: "Fenggang (CNFEN)",
   label: "Fenggang (CNFEN)"
  },
  {
   value: "Fengguang (CNFGG)",
   label: "Fengguang (CNFGG)"
  },
  {
   value: "Foshan (CNFOS)",
   label: "Foshan (CNFOS)"
  },
  {
   value: "Fujin (CNFUJ)",
   label: "Fujin (CNFUJ)"
  },
  {
   value: "Fuqing (CNFUG)",
   label: "Fuqing (CNFUG)"
  },
  {
   value: "Fushun (CNFSN)",
   label: "Fushun (CNFSN)"
  },
  {
   value: "Futian (CNFUT)",
   label: "Futian (CNFUT)"
  },
  {
   value: "Fuxin (CNFUX)",
   label: "Fuxin (CNFUX)"
  },
  {
   value: "Fuyong (CNFYG)",
   label: "Fuyong (CNFYG)"
  },
  {
   value: "Fuyuan (CNFUY)",
   label: "Fuyuan (CNFUY)"
  },
  {
   value: "Fuzhou (CNFOC)",
   label: "Fuzhou (CNFOC)"
  },
  {
   value: "Ganqmod (CNGQD)",
   label: "Ganqmod (CNGQD)"
  },
  {
   value: "Gaogang (CNGAO)",
   label: "Gaogang (CNGAO)"
  },
  {
   value: "Gaoming (CNGOM)",
   label: "Gaoming (CNGOM)"
  },
  {
   value: "Gaoyao (CNGAY)",
   label: "Gaoyao (CNGAY)"
  },
  {
   value: "Gongbei (CNGBP)",
   label: "Gongbei (CNGBP)"
  },
  {
   value: "Guan yao (CNGNY)",
   label: "Guan yao (CNGNY)"
  },
  {
   value: "Guanghai (CNGHI)",
   label: "Guanghai (CNGHI)"
  },
  {
   value: "Guangzhou (CNCAN)",
   label: "Guangzhou (CNCAN)"
  },
  {
   value: "Guanlan (CNGUN)",
   label: "Guanlan (CNGUN)"
  },
  {
   value: "Guigang (CNGUG)",
   label: "Guigang (CNGUG)"
  },
  {
   value: "Guilin (CNKWL)",
   label: "Guilin (CNKWL)"
  },
  {
   value: "Guiyang (CNKWE)",
   label: "Guiyang (CNKWE)"
  },
  {
   value: "Gyirong (CNGIR)",
   label: "Gyirong (CNGIR)"
  },
  {
   value: "Haian (CNHAI)",
   label: "Haian (CNHAI)"
  },
  {
   value: "Haicheng (CNHAG)",
   label: "Haicheng (CNHAG)"
  },
  {
   value: "Haifeng (CNHAF)",
   label: "Haifeng (CNHAF)"
  },
  {
   value: "Haikang (CNHKN)",
   label: "Haikang (CNHKN)"
  },
  {
   value: "Haikou (CNHAK)",
   label: "Haikou (CNHAK)"
  },
  {
   value: "Hailar (CNHLD)",
   label: "Hailar (CNHLD)"
  },
  {
   value: "Haimen (CNHME)",
   label: "Haimen (CNHME)"
  },
  {
   value: "Hangzhou (CNHGH)",
   label: "Hangzhou (CNHGH)"
  },
  {
   value: "Hankou (CNHNK)",
   label: "Hankou (CNHNK)"
  },
  {
   value: "Harbin (CNHRB)",
   label: "Harbin (CNHRB)"
  },
  {
   value: "Hefei (CNHFE)",
   label: "Hefei (CNHFE)"
  },
  {
   value: "Heihe (CNHEK)",
   label: "Heihe (CNHEK)"
  },
  {
   value: "Heishantou (CNHST)",
   label: "Heishantou (CNHST)"
  },
  {
   value: "Hekou (CNHKM)",
   label: "Hekou (CNHKM)"
  },
  {
   value: "Henggang (CNHNG)",
   label: "Henggang (CNHNG)"
  },
  {
   value: "Beijiao (CNYQS)",
   label: "Beijiao (CNYQS)"
  },
  {
   value: "Beijing (CNBJS)",
   label: "Beijing (CNBJS)"
  },
  {
   value: "Binzhou (CNBIN)",
   label: "Binzhou (CNBIN)"
  },
  {
   value: "Boluo (CNBOO)",
   label: "Boluo (CNBOO)"
  },
  {
   value: "Buji (CNBUJ)",
   label: "Buji (CNBUJ)"
  },
  {
   value: "Burang (CNBUR)",
   label: "Burang (CNBUR)"
  },
  {
   value: "Chang on (CNCHO)",
   label: "Chang on (CNCHO)"
  },
  {
   value: "Chang'an (CNCHN)",
   label: "Chang'an (CNCHN)"
  },
  {
   value: "Changchun (CNCGQ)",
   label: "Changchun (CNCGQ)"
  },
  {
   value: "Changping (CNCPG)",
   label: "Changping (CNCPG)"
  },
  {
   value: "Changsha (CNCSX)",
   label: "Changsha (CNCSX)"
  },
  {
   value: "Changshu (CNCGU)",
   label: "Changshu (CNCGU)"
  },
  {
   value: "Changzhou (CNCZX)",
   label: "Changzhou (CNCZX)"
  },
  {
   value: "Chaoyang (CNCYG)",
   label: "Chaoyang (CNCYG)"
  },
  {
   value: "Chaozhou (CNCOZ)",
   label: "Chaozhou (CNCOZ)"
  },
  {
   value: "Chengao (CNCHE)",
   label: "Chengao (CNCHE)"
  },
  {
   value: "Chengdu (CNCTU)",
   label: "Chengdu (CNCTU)"
  },
  {
   value: "Chenghai (CNCHG)",
   label: "Chenghai (CNCHG)"
  },
  {
   value: "Chenghai Laiwu (CNCGS)",
   label: "Chenghai Laiwu (CNCGS)"
  },
  {
   value: "Chenglingji (CNCLJ)",
   label: "Chenglingji (CNCLJ)"
  },
  {
   value: "Chiwan (CNCWN)",
   label: "Chiwan (CNCWN)"
  },
  {
   value: "Chongqing (CNCKG)",
   label: "Chongqing (CNCKG)"
  },
  {
   value: "Conghua (CNCNH)",
   label: "Conghua (CNCNH)"
  },
  {
   value: "Daan (CNDAN)",
   label: "Daan (CNDAN)"
  },
  {
   value: "Dagang (CNDAA)",
   label: "Dagang (CNDAA)"
  },
  {
   value: "Dalian (CNDLC)",
   label: "Dalian (CNDLC)"
  },
  {
   value: "Dalianxingang (CNDXG)",
   label: "Dalianxingang (CNDXG)"
  },
  {
   value: "Dandong (CNDDG)",
   label: "Dandong (CNDDG)"
  },
  {
   value: "Danshui (CNDNS)",
   label: "Danshui (CNDNS)"
  },
  {
   value: "Danzao (CNDNZ)",
   label: "Danzao (CNDNZ)"
  },
  {
   value: "Daqing (CNDQG)",
   label: "Daqing (CNDQG)"
  },
  {
   value: "Datian (CNDTG)",
   label: "Datian (CNDTG)"
  },
  {
   value: "Datong (CNDAT)",
   label: "Datong (CNDAT)"
  },
  {
   value: "Dianbai (CNDNB)",
   label: "Dianbai (CNDNB)"
  },
  {
   value: "Donggang (CNDOG)",
   label: "Donggang (CNDOG)"
  },
  {
   value: "Dongguan (CNDGG)",
   label: "Dongguan (CNDGG)"
  },
  {
   value: "Dongjiaotou (CNDJT)",
   label: "Dongjiaotou (CNDJT)"
  },
  {
   value: "Dongkeng (CNDKG)",
   label: "Dongkeng (CNDKG)"
  },
  {
   value: "Dongning (CNDON)",
   label: "Dongning (CNDON)"
  },
  {
   value: "Dongshan (CNDSN)",
   label: "Dongshan (CNDSN)"
  },
  {
   value: "Dongxing (CNDOX)",
   label: "Dongxing (CNDOX)"
  },
  {
   value: "San Vicente (CLSVE)",
   label: "San Vicente (CLSVE)"
  },
  {
   value: "Santiago (CLSCL)",
   label: "Santiago (CLSCL)"
  },
  {
   value: "Talca (CLTLX)",
   label: "Talca (CLTLX)"
  },
  {
   value: "Talcahuano (CLTAL)",
   label: "Talcahuano (CLTAL)"
  },
  {
   value: "Taltal (CLTTC)",
   label: "Taltal (CLTTC)"
  },
  {
   value: "Temuco (CLZCO)",
   label: "Temuco (CLZCO)"
  },
  {
   value: "Tocopilla (CLTOQ)",
   label: "Tocopilla (CLTOQ)"
  },
  {
   value: "Tomé (CLTOM)",
   label: "Tomé (CLTOM)"
  },
  {
   value: "Valdivia (CLZAL)",
   label: "Valdivia (CLZAL)"
  },
  {
   value: "Valparaiso (CLVAP)",
   label: "Valparaiso (CLVAP)"
  },
  {
   value: "Victoria (CLZIC)",
   label: "Victoria (CLZIC)"
  },
  {
   value: "Vina Del Mar (CLKNA)",
   label: "Vina Del Mar (CLKNA)"
  },
  {
   value: "Bafoussam (CMBFX)",
   label: "Bafoussam (CMBFX)"
  },
  {
   value: "Bali (CMBLC)",
   label: "Bali (CMBLC)"
  },
  {
   value: "Batouri (CMOUR)",
   label: "Batouri (CMOUR)"
  },
  {
   value: "Buea (CMBUA)",
   label: "Buea (CMBUA)"
  },
  {
   value: "Campo (CMCMO)",
   label: "Campo (CMCMO)"
  },
  {
   value: "Douala (CMDLA)",
   label: "Douala (CMDLA)"
  },
  {
   value: "Dschang (CMDSC)",
   label: "Dschang (CMDSC)"
  },
  {
   value: "Garoua (CMGOU)",
   label: "Garoua (CMGOU)"
  },
  {
   value: "Kole Terminal (CMKOL)",
   label: "Kole Terminal (CMKOL)"
  },
  {
   value: "Koutaba (CMKOB)",
   label: "Koutaba (CMKOB)"
  },
  {
   value: "Kribi (CMKBI)",
   label: "Kribi (CMKBI)"
  },
  {
   value: "Limbe (CMLIM)",
   label: "Limbe (CMLIM)"
  },
  {
   value: "Limboh Terminal (CMLIT)",
   label: "Limboh Terminal (CMLIT)"
  },
  {
   value: "Mamfe (CMMMF)",
   label: "Mamfe (CMMMF)"
  },
  {
   value: "Maroua (CMMVR)",
   label: "Maroua (CMMVR)"
  },
  {
   value: "Moudi Terminal (CMMOU)",
   label: "Moudi Terminal (CMMOU)"
  },
  {
   value: "Tiko (CMTKC)",
   label: "Tiko (CMTKC)"
  },
  {
   value: "Victoria (CMVCC)",
   label: "Victoria (CMVCC)"
  },
  {
   value: "Yaounde (CMYAO)",
   label: "Yaounde (CMYAO)"
  },
  {
   value: "EDEA (CMEDA)",
   label: "EDEA (CMEDA)"
  },
  {
   value: "NKONGSAMBA (CMNKS)",
   label: "NKONGSAMBA (CMNKS)"
  },
  {
   value: "Alatawshankou (CNAKL)",
   label: "Alatawshankou (CNAKL)"
  },
  {
   value: "Anqing (CNAQG)",
   label: "Anqing (CNAQG)"
  },
  {
   value: "Anshan (CNASN)",
   label: "Anshan (CNASN)"
  },
  {
   value: "Arhaxat (CNART)",
   label: "Arhaxat (CNART)"
  },
  {
   value: "Bao'an (CNBON)",
   label: "Bao'an (CNBON)"
  },
  {
   value: "Baoshanmatou (CNBAO)",
   label: "Baoshanmatou (CNBAO)"
  },
  {
   value: "Basuo (CNBAS)",
   label: "Basuo (CNBAS)"
  },
  {
   value: "Bayuquan (CNBAY)",
   label: "Bayuquan (CNBAY)"
  },
  {
   value: "Beihai (CNBHY)",
   label: "Beihai (CNBHY)"
  },
  {
   value: "Beijiao (CNBJO)",
   label: "Beijiao (CNBJO)"
  },
  {
   value: "Corral (CLCRR)",
   label: "Corral (CLCRR)"
  },
  {
   value: "Coyhaique (CLCXQ)",
   label: "Coyhaique (CLCXQ)"
  },
  {
   value: "Cruz Grande (CLCGR)",
   label: "Cruz Grande (CLCGR)"
  },
  {
   value: "El Salvador (CLESR)",
   label: "El Salvador (CLESR)"
  },
  {
   value: "Gatico (CLGIO)",
   label: "Gatico (CLGIO)"
  },
  {
   value: "Guarello (CLGUR)",
   label: "Guarello (CLGUR)"
  },
  {
   value: "Guayacan (CLGYC)",
   label: "Guayacan (CLGYC)"
  },
  {
   value: "Huasco (CLHSO)",
   label: "Huasco (CLHSO)"
  },
  {
   value: "Iquique (CLIQQ)",
   label: "Iquique (CLIQQ)"
  },
  {
   value: "Isla de Pascua (CLIPC)",
   label: "Isla de Pascua (CLIPC)"
  },
  {
   value: "Isla Guarello (CLISG)",
   label: "Isla Guarello (CLISG)"
  },
  {
   value: "La Serena (CLLSC)",
   label: "La Serena (CLLSC)"
  },
  {
   value: "Las Ventanos (CLLVS)",
   label: "Las Ventanos (CLLVS)"
  },
  {
   value: "Lebu (CLLEB)",
   label: "Lebu (CLLEB)"
  },
  {
   value: "Lirquén (CLLQN)",
   label: "Lirquén (CLLQN)"
  },
  {
   value: "Los Andes (CLLND)",
   label: "Los Andes (CLLND)"
  },
  {
   value: "Los Angeles (CLLSQ)",
   label: "Los Angeles (CLLSQ)"
  },
  {
   value: "Los Vientos (CLLVT)",
   label: "Los Vientos (CLLVT)"
  },
  {
   value: "Los Vilos (CLLOS)",
   label: "Los Vilos (CLLOS)"
  },
  {
   value: "Lota (CLLTA)",
   label: "Lota (CLLTA)"
  },
  {
   value: "Mejillones (CLMJS)",
   label: "Mejillones (CLMJS)"
  },
  {
   value: "Osorno (CLZOS)",
   label: "Osorno (CLZOS)"
  },
  {
   value: "Ovalle (CLOVL)",
   label: "Ovalle (CLOVL)"
  },
  {
   value: "Patillos (CLPTI)",
   label: "Patillos (CLPTI)"
  },
  {
   value: "Penco (CLPEO)",
   label: "Penco (CLPEO)"
  },
  {
   value: "Pisagua (CLPIS)",
   label: "Pisagua (CLPIS)"
  },
  {
   value: "Placilla (CLPLL)",
   label: "Placilla (CLPLL)"
  },
  {
   value: "Placilla Valparaiso (CLPAQ)",
   label: "Placilla Valparaiso (CLPAQ)"
  },
  {
   value: "Puerto Aisen (CLWPA)",
   label: "Puerto Aisen (CLWPA)"
  },
  {
   value: "Puerto Montt (CLPMC)",
   label: "Puerto Montt (CLPMC)"
  },
  {
   value: "Puerto Natales (CLPNT)",
   label: "Puerto Natales (CLPNT)"
  },
  {
   value: "Puerto Percy (CLPPY)",
   label: "Puerto Percy (CLPPY)"
  },
  {
   value: "Puerto Williams (CLWPU)",
   label: "Puerto Williams (CLWPU)"
  },
  {
   value: "Punta Arenas (CLPUQ)",
   label: "Punta Arenas (CLPUQ)"
  },
  {
   value: "Quemchi (CLQMC)",
   label: "Quemchi (CLQMC)"
  },
  {
   value: "Quintero (CLQTV)",
   label: "Quintero (CLQTV)"
  },
  {
   value: "Rancagua (CLQRC)",
   label: "Rancagua (CLQRC)"
  },
  {
   value: "San Antonio (CLSAI)",
   label: "San Antonio (CLSAI)"
  },
  {
   value: "San Felipe (CLSFP)",
   label: "San Felipe (CLSFP)"
  },
  {
   value: "San Gregory (CLSGR)",
   label: "San Gregory (CLSGR)"
  },
  {
   value: "Fresco (CIFRE)",
   label: "Fresco (CIFRE)"
  },
  {
   value: "Grand Basam (CIGBA)",
   label: "Grand Basam (CIGBA)"
  },
  {
   value: "Grand Lahou (CIGLU)",
   label: "Grand Lahou (CIGLU)"
  },
  {
   value: "Jabou (CIJAB)",
   label: "Jabou (CIJAB)"
  },
  {
   value: "Jacquiville (CIJAC)",
   label: "Jacquiville (CIJAC)"
  },
  {
   value: "Korhogo (CIHGO)",
   label: "Korhogo (CIHGO)"
  },
  {
   value: "Kosao (CIKOS)",
   label: "Kosao (CIKOS)"
  },
  {
   value: "Man (CIMJC)",
   label: "Man (CIMJC)"
  },
  {
   value: "Odienne (CIKEO)",
   label: "Odienne (CIKEO)"
  },
  {
   value: "Port Bouet (CIPBT)",
   label: "Port Bouet (CIPBT)"
  },
  {
   value: "San Pedro (CISPY)",
   label: "San Pedro (CISPY)"
  },
  {
   value: "Sassandra (CIZSS)",
   label: "Sassandra (CIZSS)"
  },
  {
   value: "Tabou (CITXU)",
   label: "Tabou (CITXU)"
  },
  {
   value: "Yamoussoukro (CIASK)",
   label: "Yamoussoukro (CIASK)"
  },
  {
   value: "Aitutaki (CKAIT)",
   label: "Aitutaki (CKAIT)"
  },
  {
   value: "Arutunga (CKARU)",
   label: "Arutunga (CKARU)"
  },
  {
   value: "Atiu (CKAIU)",
   label: "Atiu (CKAIU)"
  },
  {
   value: "Mangaia (CKMGS)",
   label: "Mangaia (CKMGS)"
  },
  {
   value: "Mauke Island (CKMUK)",
   label: "Mauke Island (CKMUK)"
  },
  {
   value: "Mitiaro Island (CKMOI)",
   label: "Mitiaro Island (CKMOI)"
  },
  {
   value: "Rarotonga (CKRAR)",
   label: "Rarotonga (CKRAR)"
  },
  {
   value: "Ancud (CLZUD)",
   label: "Ancud (CLZUD)"
  },
  {
   value: "Antofagasta (CLANF)",
   label: "Antofagasta (CLANF)"
  },
  {
   value: "Arica (CLARI)",
   label: "Arica (CLARI)"
  },
  {
   value: "Bahia Gregorio (CLBAG)",
   label: "Bahia Gregorio (CLBAG)"
  },
  {
   value: "Balmaceda (CLBBA)",
   label: "Balmaceda (CLBBA)"
  },
  {
   value: "Barquito (CLBAR)",
   label: "Barquito (CLBAR)"
  },
  {
   value: "Cabo Negro (CLCNX)",
   label: "Cabo Negro (CLCNX)"
  },
  {
   value: "Calama (CLCJC)",
   label: "Calama (CLCJC)"
  },
  {
   value: "Caldera (CLCLD)",
   label: "Caldera (CLCLD)"
  },
  {
   value: "Caleta Parillos (CLCAL)",
   label: "Caleta Parillos (CLCAL)"
  },
  {
   value: "Casablanca (CLCAS)",
   label: "Casablanca (CLCAS)"
  },
  {
   value: "Castro (CLWCA)",
   label: "Castro (CLWCA)"
  },
  {
   value: "Chacabuco (CLCHB)",
   label: "Chacabuco (CLCHB)"
  },
  {
   value: "Chaiten (CLWCH)",
   label: "Chaiten (CLWCH)"
  },
  {
   value: "Chañaral (CLCNR)",
   label: "Chañaral (CLCNR)"
  },
  {
   value: "Clarencia (CLCLR)",
   label: "Clarencia (CLCLR)"
  },
  {
   value: "Concepcion (CLCCP)",
   label: "Concepcion (CLCCP)"
  },
  {
   value: "Copiapo (CLCPO)",
   label: "Copiapo (CLCPO)"
  },
  {
   value: "Coquimbo (CLCQQ)",
   label: "Coquimbo (CLCQQ)"
  },
  {
   value: "Coronel (CLCNL)",
   label: "Coronel (CLCNL)"
  },
  {
   value: "Rüti BE? GL? (CHRTI)",
   label: "Rüti BE? GL? (CHRTI)"
  },
  {
   value: "Safenwil (CHSAF)",
   label: "Safenwil (CHSAF)"
  },
  {
   value: "Sarnen (CHSNN)",
   label: "Sarnen (CHSNN)"
  },
  {
   value: "Schaffhausen (CHSCH)",
   label: "Schaffhausen (CHSCH)"
  },
  {
   value: "Schlieren (CHSHR)",
   label: "Schlieren (CHSHR)"
  },
  {
   value: "Sevelen (CHSVN)",
   label: "Sevelen (CHSVN)"
  },
  {
   value: "St Gallen (CHQGL)",
   label: "St Gallen (CHQGL)"
  },
  {
   value: "St Margrethen (CHSTM)",
   label: "St Margrethen (CHSTM)"
  },
  {
   value: "Stabio (CHSBO)",
   label: "Stabio (CHSBO)"
  },
  {
   value: "Stans (CHSAN)",
   label: "Stans (CHSAN)"
  },
  {
   value: "Steffisburg (CHSBG)",
   label: "Steffisburg (CHSBG)"
  },
  {
   value: "Steinmaur (CHSMR)",
   label: "Steinmaur (CHSMR)"
  },
  {
   value: "Sulgen (CHSGE)",
   label: "Sulgen (CHSGE)"
  },
  {
   value: "Tenero (CHTEN)",
   label: "Tenero (CHTEN)"
  },
  {
   value: "Thalwil (CHTWL)",
   label: "Thalwil (CHTWL)"
  },
  {
   value: "Thayngen (CHTHA)",
   label: "Thayngen (CHTHA)"
  },
  {
   value: "Uzwil (CHUZW)",
   label: "Uzwil (CHUZW)"
  },
  {
   value: "Vallorbe (CHVAL)",
   label: "Vallorbe (CHVAL)"
  },
  {
   value: "Vauffelin (CHVFN)",
   label: "Vauffelin (CHVFN)"
  },
  {
   value: "Vendlincourt (CHVEN)",
   label: "Vendlincourt (CHVEN)"
  },
  {
   value: "Vernier (CHVER)",
   label: "Vernier (CHVER)"
  },
  {
   value: "Vevey (CHZKZ)",
   label: "Vevey (CHZKZ)"
  },
  {
   value: "Villars-sur-Glane (CHVSG)",
   label: "Villars-sur-Glane (CHVSG)"
  },
  {
   value: "Visp (CHVIS)",
   label: "Visp (CHVIS)"
  },
  {
   value: "Vouvry (CHVVY)",
   label: "Vouvry (CHVVY)"
  },
  {
   value: "Wangen BE?SO?SZ?ZH? (CHWGN)",
   label: "Wangen BE?SO?SZ?ZH? (CHWGN)"
  },
  {
   value: "Wettingen (CHWIN)",
   label: "Wettingen (CHWIN)"
  },
  {
   value: "Zug (CHZLM)",
   label: "Zug (CHZLM)"
  },
  {
   value: "Zurich (CHZRH)",
   label: "Zurich (CHZRH)"
  },
  {
   value: "GRANDSON (CHGDN)",
   label: "GRANDSON (CHGDN)"
  },
  {
   value: "OBERRIEDE (CHORN)",
   label: "OBERRIEDE (CHORN)"
  },
  {
   value: "WOHLEN (CHWHL)",
   label: "WOHLEN (CHWHL)"
  },
  {
   value: "Abengourou (CIOGO)",
   label: "Abengourou (CIOGO)"
  },
  {
   value: "Abidjan (CIABJ)",
   label: "Abidjan (CIABJ)"
  },
  {
   value: "Assinie (CIASS)",
   label: "Assinie (CIASS)"
  },
  {
   value: "Bondoukou (CIBDK)",
   label: "Bondoukou (CIBDK)"
  },
  {
   value: "Bouake (CIBYK)",
   label: "Bouake (CIBYK)"
  },
  {
   value: "Boubele (CIBBE)",
   label: "Boubele (CIBBE)"
  },
  {
   value: "Daloa (CIDJO)",
   label: "Daloa (CIDJO)"
  },
  {
   value: "Ferkessedougou (CIFEK)",
   label: "Ferkessedougou (CIFEK)"
  },
  {
   value: "Koblenz (CHLEN)",
   label: "Koblenz (CHLEN)"
  },
  {
   value: "Kreuzlingen (CHKRZ)",
   label: "Kreuzlingen (CHKRZ)"
  },
  {
   value: "Küsnacht ZH? SZ? (CHKHH)",
   label: "Küsnacht ZH? SZ? (CHKHH)"
  },
  {
   value: "Lausanne (CHLAU)",
   label: "Lausanne (CHLAU)"
  },
  {
   value: "Le Locle (CHZJA)",
   label: "Le Locle (CHZJA)"
  },
  {
   value: "Lenzburg (CHLBG)",
   label: "Lenzburg (CHLBG)"
  },
  {
   value: "Locarno (CHLON)",
   label: "Locarno (CHLON)"
  },
  {
   value: "Lugano (CHLUG)",
   label: "Lugano (CHLUG)"
  },
  {
   value: "Lyss (CHLYS)",
   label: "Lyss (CHLYS)"
  },
  {
   value: "Martigny (CHMGY)",
   label: "Martigny (CHMGY)"
  },
  {
   value: "Mettmenstetten (CHMET)",
   label: "Mettmenstetten (CHMET)"
  },
  {
   value: "Mezzovico (CHMEZ)",
   label: "Mezzovico (CHMEZ)"
  },
  {
   value: "Moehlin (CHMHL)",
   label: "Moehlin (CHMHL)"
  },
  {
   value: "Monthey (CHMON)",
   label: "Monthey (CHMON)"
  },
  {
   value: "Morges (CHMOS)",
   label: "Morges (CHMOS)"
  },
  {
   value: "Moutier (CHMTR)",
   label: "Moutier (CHMTR)"
  },
  {
   value: "Müchenstein (CHMUN)",
   label: "Müchenstein (CHMUN)"
  },
  {
   value: "Muri AG? BE? (CHMUR)",
   label: "Muri AG? BE? (CHMUR)"
  },
  {
   value: "Muttenz (CHMUT)",
   label: "Muttenz (CHMUT)"
  },
  {
   value: "Nebikon (CHNBK)",
   label: "Nebikon (CHNBK)"
  },
  {
   value: "Neuendorf (CHNEU)",
   label: "Neuendorf (CHNEU)"
  },
  {
   value: "Niederglatt SG? ZH? (CHNTT)",
   label: "Niederglatt SG? ZH? (CHNTT)"
  },
  {
   value: "Niederlenz (CHNLZ)",
   label: "Niederlenz (CHNLZ)"
  },
  {
   value: "Niederurnen (CHNUN)",
   label: "Niederurnen (CHNUN)"
  },
  {
   value: "Niederweningen (CHNWG)",
   label: "Niederweningen (CHNWG)"
  },
  {
   value: "Oberägeri (CHOGI)",
   label: "Oberägeri (CHOGI)"
  },
  {
   value: "Oberuzwil (CHOBE)",
   label: "Oberuzwil (CHOBE)"
  },
  {
   value: "Olten (CHOLT)",
   label: "Olten (CHOLT)"
  },
  {
   value: "Ostermundingen (CHOMD)",
   label: "Ostermundingen (CHOMD)"
  },
  {
   value: "Pratteln (CHATT)",
   label: "Pratteln (CHATT)"
  },
  {
   value: "Rafz (CHRFZ)",
   label: "Rafz (CHRFZ)"
  },
  {
   value: "Ramsen (CHRAM)",
   label: "Ramsen (CHRAM)"
  },
  {
   value: "Rancate (CHRCT)",
   label: "Rancate (CHRCT)"
  },
  {
   value: "Regensdorf (CHRGF)",
   label: "Regensdorf (CHRGF)"
  },
  {
   value: "Reichenburg (CHRBG)",
   label: "Reichenburg (CHRBG)"
  },
  {
   value: "Renens (CHRHW)",
   label: "Renens (CHRHW)"
  },
  {
   value: "Rheinfelden (CHRFD)",
   label: "Rheinfelden (CHRFD)"
  },
  {
   value: "Romont BE? FR? (CHROM)",
   label: "Romont BE? FR? (CHROM)"
  },
  {
   value: "Rüti (CHRUI)",
   label: "Rüti (CHRUI)"
  },
  {
   value: "Biasca (CHBIA)",
   label: "Biasca (CHBIA)"
  },
  {
   value: "Biel (CHBIE)",
   label: "Biel (CHBIE)"
  },
  {
   value: "Bisingen (CHBSG)",
   label: "Bisingen (CHBSG)"
  },
  {
   value: "Bleienbach (CHBLE)",
   label: "Bleienbach (CHBLE)"
  },
  {
   value: "Bremblens (CHBBL)",
   label: "Bremblens (CHBBL)"
  },
  {
   value: "Bremgarten AG? BE? (CHBMG)",
   label: "Bremgarten AG? BE? (CHBMG)"
  },
  {
   value: "Bubendorf (CHBUB)",
   label: "Bubendorf (CHBUB)"
  },
  {
   value: "Buchs (CHBUC)",
   label: "Buchs (CHBUC)"
  },
  {
   value: "Büchslen (CHBLN)",
   label: "Büchslen (CHBLN)"
  },
  {
   value: "Bulle (CHBUL)",
   label: "Bulle (CHBUL)"
  },
  {
   value: "Burgdorf (CHBGF)",
   label: "Burgdorf (CHBGF)"
  },
  {
   value: "Cadenazzo (CHCAD)",
   label: "Cadenazzo (CHCAD)"
  },
  {
   value: "Chiasso (CHCHI)",
   label: "Chiasso (CHCHI)"
  },
  {
   value: "Chur (CHCHR)",
   label: "Chur (CHCHR)"
  },
  {
   value: "Cortaillod (CHCRT)",
   label: "Cortaillod (CHCRT)"
  },
  {
   value: "Courtaman (CHYHM)",
   label: "Courtaman (CHYHM)"
  },
  {
   value: "Crissier (CHCRI)",
   label: "Crissier (CHCRI)"
  },
  {
   value: "Cugy (CHCUG)",
   label: "Cugy (CHCUG)"
  },
  {
   value: "Degersheim (CHDGS)",
   label: "Degersheim (CHDGS)"
  },
  {
   value: "Dietikon (CHDIE)",
   label: "Dietikon (CHDIE)"
  },
  {
   value: "Domat (CHDMT)",
   label: "Domat (CHDMT)"
  },
  {
   value: "Düdingen (CHDIG)",
   label: "Düdingen (CHDIG)"
  },
  {
   value: "Ebikon (CHEIN)",
   label: "Ebikon (CHEIN)"
  },
  {
   value: "Eschlikon (CHEKO)",
   label: "Eschlikon (CHEKO)"
  },
  {
   value: "Fahrwangen (CHFWG)",
   label: "Fahrwangen (CHFWG)"
  },
  {
   value: "Flaach (CHFAH)",
   label: "Flaach (CHFAH)"
  },
  {
   value: "Flums (CHFLU)",
   label: "Flums (CHFLU)"
  },
  {
   value: "Forch (CHFCH)",
   label: "Forch (CHFCH)"
  },
  {
   value: "Frauenfeld (CHFRN)",
   label: "Frauenfeld (CHFRN)"
  },
  {
   value: "Frenkendorf (CHFKD)",
   label: "Frenkendorf (CHFKD)"
  },
  {
   value: "Fribourg (CHFRB)",
   label: "Fribourg (CHFRB)"
  },
  {
   value: "Frutigen (CHFTN)",
   label: "Frutigen (CHFTN)"
  },
  {
   value: "Gelterkinden (CHGKR)",
   label: "Gelterkinden (CHGKR)"
  },
  {
   value: "Genestrerio (CHGSR)",
   label: "Genestrerio (CHGSR)"
  },
  {
   value: "Genève (CHGVA)",
   label: "Genève (CHGVA)"
  },
  {
   value: "Genève-Plan les Ouates (CHPLO)",
   label: "Genève-Plan les Ouates (CHPLO)"
  },
  {
   value: "Gerlafingen (CHGFG)",
   label: "Gerlafingen (CHGFG)"
  },
  {
   value: "Geroldswil (CHGDW)",
   label: "Geroldswil (CHGDW)"
  },
  {
   value: "Giubiasco (CHGBS)",
   label: "Giubiasco (CHGBS)"
  },
  {
   value: "Grafenried (CHGFR)",
   label: "Grafenried (CHGFR)"
  },
  {
   value: "Kirchleerau (CHKLR)",
   label: "Kirchleerau (CHKLR)"
  },
  {
   value: "Obo (CFOBO)",
   label: "Obo (CFOBO)"
  },
  {
   value: "Ouadda (CFODA)",
   label: "Ouadda (CFODA)"
  },
  {
   value: "Ouanda Djalle (CFODJ)",
   label: "Ouanda Djalle (CFODJ)"
  },
  {
   value: "Paoua (CFPAO)",
   label: "Paoua (CFPAO)"
  },
  {
   value: "Rafai (CFRFA)",
   label: "Rafai (CFRFA)"
  },
  {
   value: "Sibut (CFSIB)",
   label: "Sibut (CFSIB)"
  },
  {
   value: "Yalinga (CFAIG)",
   label: "Yalinga (CFAIG)"
  },
  {
   value: "Zemio (CFIMO)",
   label: "Zemio (CFIMO)"
  },
  {
   value: "Betou (CGBTB)",
   label: "Betou (CGBTB)"
  },
  {
   value: "Boundji (CGBOE)",
   label: "Boundji (CGBOE)"
  },
  {
   value: "Brazzaville (CGBZV)",
   label: "Brazzaville (CGBZV)"
  },
  {
   value: "Djambala (CGDJM)",
   label: "Djambala (CGDJM)"
  },
  {
   value: "Djeno Terminal (CGDJE)",
   label: "Djeno Terminal (CGDJE)"
  },
  {
   value: "Epena (CGEPN)",
   label: "Epena (CGEPN)"
  },
  {
   value: "Ewo (CGEWO)",
   label: "Ewo (CGEWO)"
  },
  {
   value: "Gamboma (CGGMM)",
   label: "Gamboma (CGGMM)"
  },
  {
   value: "Impfondo (CGION)",
   label: "Impfondo (CGION)"
  },
  {
   value: "Kelle (CGKEE)",
   label: "Kelle (CGKEE)"
  },
  {
   value: "Kindamba (CGKNJ)",
   label: "Kindamba (CGKNJ)"
  },
  {
   value: "Lague (CGLCO)",
   label: "Lague (CGLCO)"
  },
  {
   value: "Lekana (CGLKC)",
   label: "Lekana (CGLKC)"
  },
  {
   value: "Loubomo (CGDIS)",
   label: "Loubomo (CGDIS)"
  },
  {
   value: "Makabana (CGKMK)",
   label: "Makabana (CGKMK)"
  },
  {
   value: "Makoua (CGMKJ)",
   label: "Makoua (CGMKJ)"
  },
  {
   value: "Mbinda (CGMBI)",
   label: "Mbinda (CGMBI)"
  },
  {
   value: "Mossaka (CGMOS)",
   label: "Mossaka (CGMOS)"
  },
  {
   value: "Mossendjo (CGMSX)",
   label: "Mossendjo (CGMSX)"
  },
  {
   value: "Mouyondzi (CGMUY)",
   label: "Mouyondzi (CGMUY)"
  },
  {
   value: "Nkayi (CGNKY)",
   label: "Nkayi (CGNKY)"
  },
  {
   value: "Okoyo (CGOKG)",
   label: "Okoyo (CGOKG)"
  },
  {
   value: "Ouesso (CGOUE)",
   label: "Ouesso (CGOUE)"
  },
  {
   value: "Oyo (CGOYO)",
   label: "Oyo (CGOYO)"
  },
  {
   value: "Pointe Noire (CGPNR)",
   label: "Pointe Noire (CGPNR)"
  },
  {
   value: "Souanke (CGSOE)",
   label: "Souanke (CGSOE)"
  },
  {
   value: "Zanaga (CGANJ)",
   label: "Zanaga (CGANJ)"
  },
  {
   value: "Aarau (CHAAR)",
   label: "Aarau (CHAAR)"
  },
  {
   value: "Altdorf SH? UR? (CHARB)",
   label: "Altdorf SH? UR? (CHARB)"
  },
  {
   value: "Altstatten (CHASN)",
   label: "Altstatten (CHASN)"
  },
  {
   value: "Baar (CHBAR)",
   label: "Baar (CHBAR)"
  },
  {
   value: "Balgach (CHBAL)",
   label: "Balgach (CHBAL)"
  },
  {
   value: "Basel (CHBSL)",
   label: "Basel (CHBSL)"
  },
  {
   value: "Bern (CHBRN)",
   label: "Bern (CHBRN)"
  },
  {
   value: "Mbandaka (CDMDK)",
   label: "Mbandaka (CDMDK)"
  },
  {
   value: "Mbuji Mayi (CDMJM)",
   label: "Mbuji Mayi (CDMJM)"
  },
  {
   value: "Moanda (CDMNB)",
   label: "Moanda (CDMNB)"
  },
  {
   value: "Moba (CDBDV)",
   label: "Moba (CDBDV)"
  },
  {
   value: "Mweka (CDMEW)",
   label: "Mweka (CDMEW)"
  },
  {
   value: "N'dolo (CDNLO)",
   label: "N'dolo (CDNLO)"
  },
  {
   value: "Nioki (CDNIO)",
   label: "Nioki (CDNIO)"
  },
  {
   value: "Nkolo (CDNKL)",
   label: "Nkolo (CDNKL)"
  },
  {
   value: "Punia (CDPUN)",
   label: "Punia (CDPUN)"
  },
  {
   value: "Pweto (CDPWO)",
   label: "Pweto (CDPWO)"
  },
  {
   value: "Tshikapa (CDTSH)",
   label: "Tshikapa (CDTSH)"
  },
  {
   value: "Uvira (CDUVI)",
   label: "Uvira (CDUVI)"
  },
  {
   value: "Yangambi (CDYAN)",
   label: "Yangambi (CDYAN)"
  },
  {
   value: "Alindao (CFALI)",
   label: "Alindao (CFALI)"
  },
  {
   value: "Baboua (CFBAB)",
   label: "Baboua (CFBAB)"
  },
  {
   value: "Bakouma (CFBMF)",
   label: "Bakouma (CFBMF)"
  },
  {
   value: "Bambari (CFBBY)",
   label: "Bambari (CFBBY)"
  },
  {
   value: "Bangassou (CFBGU)",
   label: "Bangassou (CFBGU)"
  },
  {
   value: "Bangui (CFBGF)",
   label: "Bangui (CFBGF)"
  },
  {
   value: "Baoro (CFBAO)",
   label: "Baoro (CFBAO)"
  },
  {
   value: "Batangafo (CFBTG)",
   label: "Batangafo (CFBTG)"
  },
  {
   value: "Berberati (CFBBT)",
   label: "Berberati (CFBBT)"
  },
  {
   value: "Birao (CFIRO)",
   label: "Birao (CFIRO)"
  },
  {
   value: "Boda (CFBOD)",
   label: "Boda (CFBOD)"
  },
  {
   value: "Bossangoa (CFBSN)",
   label: "Bossangoa (CFBSN)"
  },
  {
   value: "Bossembele (CFBEM)",
   label: "Bossembele (CFBEM)"
  },
  {
   value: "Bouar (CFBOP)",
   label: "Bouar (CFBOP)"
  },
  {
   value: "Bouca (CFBCF)",
   label: "Bouca (CFBCF)"
  },
  {
   value: "Bozoum (CFBOZ)",
   label: "Bozoum (CFBOZ)"
  },
  {
   value: "Bria (CFBIV)",
   label: "Bria (CFBIV)"
  },
  {
   value: "Carnot (CFCRF)",
   label: "Carnot (CFCRF)"
  },
  {
   value: "Dekoa (CFDEK)",
   label: "Dekoa (CFDEK)"
  },
  {
   value: "Gordil (CFGDI)",
   label: "Gordil (CFGDI)"
  },
  {
   value: "Gounda (CFGDA)",
   label: "Gounda (CFGDA)"
  },
  {
   value: "Grimari (CFGRI)",
   label: "Grimari (CFGRI)"
  },
  {
   value: "Kaga Bandoro (CFKAB)",
   label: "Kaga Bandoro (CFKAB)"
  },
  {
   value: "Kawadjia (CFKWD)",
   label: "Kawadjia (CFKWD)"
  },
  {
   value: "Kembé (CFKEM)",
   label: "Kembé (CFKEM)"
  },
  {
   value: "Koumala (CFKOL)",
   label: "Koumala (CFKOL)"
  },
  {
   value: "M'Baiki (CFMKI)",
   label: "M'Baiki (CFMKI)"
  },
  {
   value: "Mobaye (CFMOB)",
   label: "Mobaye (CFMOB)"
  },
  {
   value: "Mongoumba (CFMON)",
   label: "Mongoumba (CFMON)"
  },
  {
   value: "Ndélé (CFNDL)",
   label: "Ndélé (CFNDL)"
  },
  {
   value: "Nola (CFNOL)",
   label: "Nola (CFNOL)"
  },
  {
   value: "Buta (CDBZU)",
   label: "Buta (CDBZU)"
  },
  {
   value: "Dili (CDDIC)",
   label: "Dili (CDDIC)"
  },
  {
   value: "Gandajika (CDGDJ)",
   label: "Gandajika (CDGDJ)"
  },
  {
   value: "Gbadolite (CDBDT)",
   label: "Gbadolite (CDBDT)"
  },
  {
   value: "Gemena (CDGMA)",
   label: "Gemena (CDGMA)"
  },
  {
   value: "Goma (CDGOM)",
   label: "Goma (CDGOM)"
  },
  {
   value: "Idiofa (CDIDF)",
   label: "Idiofa (CDIDF)"
  },
  {
   value: "Ikela (CDIKL)",
   label: "Ikela (CDIKL)"
  },
  {
   value: "Ilebo (CDPFR)",
   label: "Ilebo (CDPFR)"
  },
  {
   value: "Inongo (CDINO)",
   label: "Inongo (CDINO)"
  },
  {
   value: "Isiro (CDIRP)",
   label: "Isiro (CDIRP)"
  },
  {
   value: "Kabalo (CDKBO)",
   label: "Kabalo (CDKBO)"
  },
  {
   value: "Kabinda (CDKBN)",
   label: "Kabinda (CDKBN)"
  },
  {
   value: "Kalemie (CDFMI)",
   label: "Kalemie (CDFMI)"
  },
  {
   value: "Kalima (CDKLY)",
   label: "Kalima (CDKLY)"
  },
  {
   value: "Kamina (CDKMN)",
   label: "Kamina (CDKMN)"
  },
  {
   value: "Kananga (CDKGA)",
   label: "Kananga (CDKGA)"
  },
  {
   value: "Kaniama (CDKNM)",
   label: "Kaniama (CDKNM)"
  },
  {
   value: "Kapanga (CDKAP)",
   label: "Kapanga (CDKAP)"
  },
  {
   value: "Kasenga (CDKEC)",
   label: "Kasenga (CDKEC)"
  },
  {
   value: "Kasongo Lunda (CDKGN)",
   label: "Kasongo Lunda (CDKGN)"
  },
  {
   value: "Kikwit (CDKKW)",
   label: "Kikwit (CDKKW)"
  },
  {
   value: "Kilwa (CDKIL)",
   label: "Kilwa (CDKIL)"
  },
  {
   value: "Kindu (CDKND)",
   label: "Kindu (CDKND)"
  },
  {
   value: "Kinshasa (CDFIH)",
   label: "Kinshasa (CDFIH)"
  },
  {
   value: "Kiri (CDKRZ)",
   label: "Kiri (CDKRZ)"
  },
  {
   value: "Kisangani (CDFKI)",
   label: "Kisangani (CDFKI)"
  },
  {
   value: "Kolwezi (CDKWZ)",
   label: "Kolwezi (CDKWZ)"
  },
  {
   value: "Kongolo (CDKOO)",
   label: "Kongolo (CDKOO)"
  },
  {
   value: "Kota Koli (CDKLI)",
   label: "Kota Koli (CDKLI)"
  },
  {
   value: "Libenge (CDLIE)",
   label: "Libenge (CDLIE)"
  },
  {
   value: "Lisala (CDLIQ)",
   label: "Lisala (CDLIQ)"
  },
  {
   value: "Lodja (CDLJA)",
   label: "Lodja (CDLJA)"
  },
  {
   value: "Lubumbashi (CDFBM)",
   label: "Lubumbashi (CDFBM)"
  },
  {
   value: "Luiza (CDLZA)",
   label: "Luiza (CDLZA)"
  },
  {
   value: "Luozi (CDLZI)",
   label: "Luozi (CDLZI)"
  },
  {
   value: "Lusambo (CDLBO)",
   label: "Lusambo (CDLBO)"
  },
  {
   value: "Lusanga (CDLUS)",
   label: "Lusanga (CDLUS)"
  },
  {
   value: "Makala (CDMKL)",
   label: "Makala (CDMKL)"
  },
  {
   value: "Manono (CDMNO)",
   label: "Manono (CDMNO)"
  },
  {
   value: "Masi Manimba (CDMSM)",
   label: "Masi Manimba (CDMSM)"
  },
  {
   value: "Matadi (CDMAT)",
   label: "Matadi (CDMAT)"
  },
  {
   value: "White River (CAYWR)",
   label: "White River (CAYWR)"
  },
  {
   value: "Whitecourt (CAWTC)",
   label: "Whitecourt (CAWTC)"
  },
  {
   value: "Whitefish (CAWHF)",
   label: "Whitefish (CAWHF)"
  },
  {
   value: "Whitehorse (CAYXY)",
   label: "Whitehorse (CAYXY)"
  },
  {
   value: "Wiarton (CAYVV)",
   label: "Wiarton (CAYVV)"
  },
  {
   value: "Williams Harbour (CAYWM)",
   label: "Williams Harbour (CAYWM)"
  },
  {
   value: "Williams Lake (CAYWL)",
   label: "Williams Lake (CAYWL)"
  },
  {
   value: "Willowdale (CAWIL)",
   label: "Willowdale (CAWIL)"
  },
  {
   value: "Windsor (CAWND)",
   label: "Windsor (CAWND)"
  },
  {
   value: "Winisk (CAYWN)",
   label: "Winisk (CAYWN)"
  },
  {
   value: "Winnipeg (CAWNP)",
   label: "Winnipeg (CAWNP)"
  },
  {
   value: "Winona (CAWIN)",
   label: "Winona (CAWIN)"
  },
  {
   value: "Wollaston Lake (CAZWL)",
   label: "Wollaston Lake (CAZWL)"
  },
  {
   value: "Woodbridge (CAWDB)",
   label: "Woodbridge (CAWDB)"
  },
  {
   value: "Woodfibre (CAWOO)",
   label: "Woodfibre (CAWOO)"
  },
  {
   value: "Woodstock (CAWDS)",
   label: "Woodstock (CAWDS)"
  },
  {
   value: "Woodstock (CAWSK)",
   label: "Woodstock (CAWSK)"
  },
  {
   value: "Wrigley (CAYWY)",
   label: "Wrigley (CAYWY)"
  },
  {
   value: "Wunnummin Lake (CAWNN)",
   label: "Wunnummin Lake (CAWNN)"
  },
  {
   value: "Wynyard (CAWYN)",
   label: "Wynyard (CAWYN)"
  },
  {
   value: "Yarmouth (CAYRH)",
   label: "Yarmouth (CAYRH)"
  },
  {
   value: "Yellowknife (CAYZF)",
   label: "Yellowknife (CAYZF)"
  },
  {
   value: "York Landing (CAZAC)",
   label: "York Landing (CAZAC)"
  },
  {
   value: "Yorkton (CAYQV)",
   label: "Yorkton (CAYQV)"
  },
  {
   value: "Zeballos (CAZEB)",
   label: "Zeballos (CAZEB)"
  },
  {
   value: "BALMERTOW (CABAL)",
   label: "BALMERTOW (CABAL)"
  },
  {
   value: "DESERONTO (CADSR)",
   label: "DESERONTO (CADSR)"
  },
  {
   value: "RIDGETOWN (CARTW)",
   label: "RIDGETOWN (CARTW)"
  },
  {
   value: "RODNEY (CARDN)",
   label: "RODNEY (CARDN)"
  },
  {
   value: "VIRGIL (CAVRG)",
   label: "VIRGIL (CAVRG)"
  },
  {
   value: "Cocos Islands (CCCCK)",
   label: "Cocos Islands (CCCCK)"
  },
  {
   value: "Ango-Ango (CDANG)",
   label: "Ango-Ango (CDANG)"
  },
  {
   value: "Banana (CDBNW)",
   label: "Banana (CDBNW)"
  },
  {
   value: "Bandundu (CDFDU)",
   label: "Bandundu (CDFDU)"
  },
  {
   value: "Basankusu (CDBSU)",
   label: "Basankusu (CDBSU)"
  },
  {
   value: "Basongo (CDBAN)",
   label: "Basongo (CDBAN)"
  },
  {
   value: "Beni (CDBNC)",
   label: "Beni (CDBNC)"
  },
  {
   value: "Boende (CDBNB)",
   label: "Boende (CDBNB)"
  },
  {
   value: "Boma (CDBOA)",
   label: "Boma (CDBOA)"
  },
  {
   value: "Bukavu (CDBKY)",
   label: "Bukavu (CDBKY)"
  },
  {
   value: "Bumba (CDBMB)",
   label: "Bumba (CDBMB)"
  },
  {
   value: "Bunia (CDBUX)",
   label: "Bunia (CDBUX)"
  },
  {
   value: "Tulita\/Fort Norman (CAZFN)",
   label: "Tulita\/Fort Norman (CAZFN)"
  },
  {
   value: "Tulugak (CAYTK)",
   label: "Tulugak (CAYTK)"
  },
  {
   value: "Tumbler Ridge (CATUX)",
   label: "Tumbler Ridge (CATUX)"
  },
  {
   value: "Tungsten (CATNS)",
   label: "Tungsten (CATNS)"
  },
  {
   value: "Twillinggate (CATWI)",
   label: "Twillinggate (CATWI)"
  },
  {
   value: "Unionville (CAUNV)",
   label: "Unionville (CAUNV)"
  },
  {
   value: "Uranium City (CAYBE)",
   label: "Uranium City (CAYBE)"
  },
  {
   value: "Val d'Or (CAYVO)",
   label: "Val d'Or (CAYVO)"
  },
  {
   value: "Valcartier (CAYOY)",
   label: "Valcartier (CAYOY)"
  },
  {
   value: "Valleyfield (CAVLF)",
   label: "Valleyfield (CAVLF)"
  },
  {
   value: "Vananda (CAVND)",
   label: "Vananda (CAVND)"
  },
  {
   value: "Vancouver (CAVAN)",
   label: "Vancouver (CAVAN)"
  },
  {
   value: "Vaudreil (CAVAU)",
   label: "Vaudreil (CAVAU)"
  },
  {
   value: "Vercheres (CAVCH)",
   label: "Vercheres (CAVCH)"
  },
  {
   value: "Vermilion (CAYVG)",
   label: "Vermilion (CAYVG)"
  },
  {
   value: "Vernon (CAVER)",
   label: "Vernon (CAVER)"
  },
  {
   value: "Victoria (CAVIC)",
   label: "Victoria (CAVIC)"
  },
  {
   value: "Wabush (CAYWK)",
   label: "Wabush (CAYWK)"
  },
  {
   value: "Wallaceburg (CAWAL)",
   label: "Wallaceburg (CAWAL)"
  },
  {
   value: "Walton (CAWTN)",
   label: "Walton (CAWTN)"
  },
  {
   value: "Wanham (CAWNH)",
   label: "Wanham (CAWNH)"
  },
  {
   value: "Waskaganish (CAYKQ)",
   label: "Waskaganish (CAYKQ)"
  },
  {
   value: "Waterdown (CAWTR)",
   label: "Waterdown (CAWTR)"
  },
  {
   value: "Waterloo (CAWTL)",
   label: "Waterloo (CAWTL)"
  },
  {
   value: "Watford (CAWTF)",
   label: "Watford (CAWTF)"
  },
  {
   value: "Watson Is (CAWAI)",
   label: "Watson Is (CAWAI)"
  },
  {
   value: "Watson Lake (CAWAT)",
   label: "Watson Lake (CAWAT)"
  },
  {
   value: "Watson Lake Apt (CAYQH)",
   label: "Watson Lake Apt (CAYQH)"
  },
  {
   value: "Wawa (CAYXZ)",
   label: "Wawa (CAYXZ)"
  },
  {
   value: "Webequie (CAYWP)",
   label: "Webequie (CAYWP)"
  },
  {
   value: "Welland (CAWEL)",
   label: "Welland (CAWEL)"
  },
  {
   value: "Welshpool (CAWEP)",
   label: "Welshpool (CAWEP)"
  },
  {
   value: "Wemindji (CAYNC)",
   label: "Wemindji (CAYNC)"
  },
  {
   value: "West Lorne (CAWLO)",
   label: "West Lorne (CAWLO)"
  },
  {
   value: "Wetaskiwin (CAWET)",
   label: "Wetaskiwin (CAWET)"
  },
  {
   value: "Weymouth (CAWEY)",
   label: "Weymouth (CAWEY)"
  },
  {
   value: "Wha Ti\/Lac La Martre (CAYLE)",
   label: "Wha Ti\/Lac La Martre (CAYLE)"
  },
  {
   value: "Whale Cove (CAYXN)",
   label: "Whale Cove (CAYXN)"
  },
  {
   value: "Wheatly (CAWHE)",
   label: "Wheatly (CAWHE)"
  },
  {
   value: "Whistler (CAYWS)",
   label: "Whistler (CAYWS)"
  },
  {
   value: "Whitby (CAWHI)",
   label: "Whitby (CAWHI)"
  },
  {
   value: "Tahsis (CAPTA)",
   label: "Tahsis (CAPTA)"
  },
  {
   value: "Taloyoak (CAYYH)",
   label: "Taloyoak (CAYYH)"
  },
  {
   value: "Taltheilei Narrows (CAGSL)",
   label: "Taltheilei Narrows (CAGSL)"
  },
  {
   value: "Tasiujuaq (CAYTQ)",
   label: "Tasiujuaq (CAYTQ)"
  },
  {
   value: "Tasu (CATAS)",
   label: "Tasu (CATAS)"
  },
  {
   value: "Tavistock (CATAV)",
   label: "Tavistock (CATAV)"
  },
  {
   value: "Tecumseh (CATEC)",
   label: "Tecumseh (CATEC)"
  },
  {
   value: "Telegraph Creek (CAYTX)",
   label: "Telegraph Creek (CAYTX)"
  },
  {
   value: "Telegraph Harbour (CAYBQ)",
   label: "Telegraph Harbour (CAYBQ)"
  },
  {
   value: "Terrace (CAYXT)",
   label: "Terrace (CAYXT)"
  },
  {
   value: "Terrace Bay (CAYTJ)",
   label: "Terrace Bay (CAYTJ)"
  },
  {
   value: "Teslin (CAYZW)",
   label: "Teslin (CAYZW)"
  },
  {
   value: "Tete-a-La Baleine (CAZTB)",
   label: "Tete-a-La Baleine (CAZTB)"
  },
  {
   value: "Texada Island (CATEX)",
   label: "Texada Island (CATEX)"
  },
  {
   value: "The Pas (CAYQD)",
   label: "The Pas (CAYQD)"
  },
  {
   value: "Thetford Mines (CATHE)",
   label: "Thetford Mines (CATHE)"
  },
  {
   value: "Thicket Portage (CAYTD)",
   label: "Thicket Portage (CAYTD)"
  },
  {
   value: "Thompson (CAYTH)",
   label: "Thompson (CAYTH)"
  },
  {
   value: "Thornhill (CATHL)",
   label: "Thornhill (CATHL)"
  },
  {
   value: "Thorold (CATHD)",
   label: "Thorold (CATHD)"
  },
  {
   value: "Thunder Bay (CATHU)",
   label: "Thunder Bay (CATHU)"
  },
  {
   value: "Tilbury Is (CATLB)",
   label: "Tilbury Is (CATLB)"
  },
  {
   value: "Tilsonburg (CATBG)",
   label: "Tilsonburg (CATBG)"
  },
  {
   value: "Timmins (CAYTS)",
   label: "Timmins (CAYTS)"
  },
  {
   value: "Tisdale (CAYTT)",
   label: "Tisdale (CAYTT)"
  },
  {
   value: "Tofino (CAYAZ)",
   label: "Tofino (CAYAZ)"
  },
  {
   value: "Toquart Bay (CATOQ)",
   label: "Toquart Bay (CATOQ)"
  },
  {
   value: "Toronto (CATOR)",
   label: "Toronto (CATOR)"
  },
  {
   value: "Tottenham (CATOT)",
   label: "Tottenham (CATOT)"
  },
  {
   value: "Town Mount Royal (CATMR)",
   label: "Town Mount Royal (CATMR)"
  },
  {
   value: "Tracadie (CATRA)",
   label: "Tracadie (CATRA)"
  },
  {
   value: "Tracy (CATRC)",
   label: "Tracy (CATRC)"
  },
  {
   value: "Trenton (CATTC)",
   label: "Trenton (CATTC)"
  },
  {
   value: "Trinity Bay (CATRB)",
   label: "Trinity Bay (CATRB)"
  },
  {
   value: "Triple Island (CAYTI)",
   label: "Triple Island (CAYTI)"
  },
  {
   value: "Trois-Rivieres (Three Rivers) (CATRR)",
   label: "Trois-Rivieres (Three Rivers) (CATRR)"
  },
  {
   value: "Trout River (CATTR)",
   label: "Trout River (CATTR)"
  },
  {
   value: "Troy (CATRY)",
   label: "Troy (CATRY)"
  },
  {
   value: "Truro (CATRU)",
   label: "Truro (CATRU)"
  },
  {
   value: "Tuktoyaktuk (CATUK)",
   label: "Tuktoyaktuk (CATUK)"
  },
  {
   value: "St Prime (CASTP)",
   label: "St Prime (CASTP)"
  },
  {
   value: "St Romuald (CASRO)",
   label: "St Romuald (CASRO)"
  },
  {
   value: "St Simon D\/Bagotte (CASSB)",
   label: "St Simon D\/Bagotte (CASSB)"
  },
  {
   value: "St Stephen (CASTS)",
   label: "St Stephen (CASTS)"
  },
  {
   value: "St Therese (CASTE)",
   label: "St Therese (CASTE)"
  },
  {
   value: "St Thomas (CASTH)",
   label: "St Thomas (CASTH)"
  },
  {
   value: "St Ubald (CASUB)",
   label: "St Ubald (CASUB)"
  },
  {
   value: "Stayner (CASTY)",
   label: "Stayner (CASTY)"
  },
  {
   value: "Ste Agathe Des Monts (CASAM)",
   label: "Ste Agathe Des Monts (CASAM)"
  },
  {
   value: "Ste Claire (CASCL)",
   label: "Ste Claire (CASCL)"
  },
  {
   value: "Ste Clothilde (CASCO)",
   label: "Ste Clothilde (CASCO)"
  },
  {
   value: "Ste Foy (CASFO)",
   label: "Ste Foy (CASFO)"
  },
  {
   value: "Ste Julie (CASJU)",
   label: "Ste Julie (CASJU)"
  },
  {
   value: "Ste Madeleine (CASMA)",
   label: "Ste Madeleine (CASMA)"
  },
  {
   value: "Ste Marie (CASMB)",
   label: "Ste Marie (CASMB)"
  },
  {
   value: "Ste Therese Point (CAYST)",
   label: "Ste Therese Point (CAYST)"
  },
  {
   value: "Ste Veronique (CASVE)",
   label: "Ste Veronique (CASVE)"
  },
  {
   value: "Stephenville (CASTV)",
   label: "Stephenville (CASTV)"
  },
  {
   value: "Stewart (CASTW)",
   label: "Stewart (CASTW)"
  },
  {
   value: "Stoney Creek (CASTC)",
   label: "Stoney Creek (CASTC)"
  },
  {
   value: "Stony Rapids (CAYSF)",
   label: "Stony Rapids (CAYSF)"
  },
  {
   value: "Stratford (CASTR)",
   label: "Stratford (CASTR)"
  },
  {
   value: "Strathroy (CASTT)",
   label: "Strathroy (CASTT)"
  },
  {
   value: "Stuart Island (CAYRR)",
   label: "Stuart Island (CAYRR)"
  },
  {
   value: "Sturdee (CAYTC)",
   label: "Sturdee (CAYTC)"
  },
  {
   value: "Sudbury (CASUD)",
   label: "Sudbury (CASUD)"
  },
  {
   value: "Suffield (CAYSD)",
   label: "Suffield (CAYSD)"
  },
  {
   value: "Sullivan Bay (CAYTG)",
   label: "Sullivan Bay (CAYTG)"
  },
  {
   value: "Summer Beaver (CASUR)",
   label: "Summer Beaver (CASUR)"
  },
  {
   value: "Summerside (CASUM)",
   label: "Summerside (CASUM)"
  },
  {
   value: "Summit Lake (CAIUM)",
   label: "Summit Lake (CAIUM)"
  },
  {
   value: "Surrey (CASUY)",
   label: "Surrey (CASUY)"
  },
  {
   value: "Sussex (CASUS)",
   label: "Sussex (CASUS)"
  },
  {
   value: "Swan River (CAZJN)",
   label: "Swan River (CAZJN)"
  },
  {
   value: "Swift Current (CAYYN)",
   label: "Swift Current (CAYYN)"
  },
  {
   value: "Sydney (CASYD)",
   label: "Sydney (CASYD)"
  },
  {
   value: "Tabusintac (CATAB)",
   label: "Tabusintac (CATAB)"
  },
  {
   value: "Tadoule Lake (CAXTL)",
   label: "Tadoule Lake (CAXTL)"
  },
  {
   value: "Tadoussac (CATAD)",
   label: "Tadoussac (CATAD)"
  },
  {
   value: "Tagish (CATAH)",
   label: "Tagish (CATAH)"
  },
  {
   value: "Sooke (CASOO)",
   label: "Sooke (CASOO)"
  },
  {
   value: "Sorel (CASOR)",
   label: "Sorel (CASOR)"
  },
  {
   value: "Sorrento (CASRR)",
   label: "Sorrento (CASRR)"
  },
  {
   value: "Souris (CASOU)",
   label: "Souris (CASOU)"
  },
  {
   value: "South Indian Lake (CAXSI)",
   label: "South Indian Lake (CAXSI)"
  },
  {
   value: "South Trout Lake (CAZFL)",
   label: "South Trout Lake (CAZFL)"
  },
  {
   value: "Sparwood (CASPW)",
   label: "Sparwood (CASPW)"
  },
  {
   value: "Spragge (CASPR)",
   label: "Spragge (CASPR)"
  },
  {
   value: "Spring Island (CAYSQ)",
   label: "Spring Island (CAYSQ)"
  },
  {
   value: "Springdale (CASPD)",
   label: "Springdale (CASPD)"
  },
  {
   value: "Squamish (CASQA)",
   label: "Squamish (CASQA)"
  },
  {
   value: "Squirrel Cove (CAYSZ)",
   label: "Squirrel Cove (CAYSZ)"
  },
  {
   value: "St Abbotsford (CASTA)",
   label: "St Abbotsford (CASTA)"
  },
  {
   value: "St Andrews (CASAD)",
   label: "St Andrews (CASAD)"
  },
  {
   value: "St Anthony (CASAT)",
   label: "St Anthony (CASAT)"
  },
  {
   value: "St Apollinaire (CASAP)",
   label: "St Apollinaire (CASAP)"
  },
  {
   value: "St Augustin (CASAU)",
   label: "St Augustin (CASAU)"
  },
  {
   value: "St Bruno de Montarville (CASBO)",
   label: "St Bruno de Montarville (CASBO)"
  },
  {
   value: "St Catharines (CASCA)",
   label: "St Catharines (CASCA)"
  },
  {
   value: "St Chrysostome (CASCH)",
   label: "St Chrysostome (CASCH)"
  },
  {
   value: "St Come (CASCM)",
   label: "St Come (CASCM)"
  },
  {
   value: "St Damase (CASDA)",
   label: "St Damase (CASDA)"
  },
  {
   value: "St Eustache (CASEU)",
   label: "St Eustache (CASEU)"
  },
  {
   value: "St George (CASTG)",
   label: "St George (CASTG)"
  },
  {
   value: "St Hilaire (CASHI)",
   label: "St Hilaire (CASHI)"
  },
  {
   value: "St Hubert (CASHU)",
   label: "St Hubert (CASHU)"
  },
  {
   value: "St Hyacinthe (CASHY)",
   label: "St Hyacinthe (CASHY)"
  },
  {
   value: "St Jean Chrysotome (CASJC)",
   label: "St Jean Chrysotome (CASJC)"
  },
  {
   value: "St Jean-sur-Richelieu (CASJR)",
   label: "St Jean-sur-Richelieu (CASJR)"
  },
  {
   value: "St Jerome (CASJE)",
   label: "St Jerome (CASJE)"
  },
  {
   value: "St John (CASJB)",
   label: "St John (CASJB)"
  },
  {
   value: "St John's (CASJF)",
   label: "St John's (CASJF)"
  },
  {
   value: "St Lambert (CASLT)",
   label: "St Lambert (CASLT)"
  },
  {
   value: "St Laurent (CASLA)",
   label: "St Laurent (CASLA)"
  },
  {
   value: "St Lawrence (CASLW)",
   label: "St Lawrence (CASLW)"
  },
  {
   value: "St Leonard (CAYSL)",
   label: "St Leonard (CAYSL)"
  },
  {
   value: "St Leonard (CASLE)",
   label: "St Leonard (CASLE)"
  },
  {
   value: "St Martin (CAMRT)",
   label: "St Martin (CAMRT)"
  },
  {
   value: "St Marys (CASMS)",
   label: "St Marys (CASMS)"
  },
  {
   value: "St Paul (CAZSP)",
   label: "St Paul (CAZSP)"
  },
  {
   value: "Salford (CASAL)",
   label: "Salford (CASAL)"
  },
  {
   value: "Salluit (CAYSW)",
   label: "Salluit (CAYSW)"
  },
  {
   value: "Salmon Arm (CAYSN)",
   label: "Salmon Arm (CAYSN)"
  },
  {
   value: "Sandspit (CASSP)",
   label: "Sandspit (CASSP)"
  },
  {
   value: "Sandy Lake (CAZSJ)",
   label: "Sandy Lake (CAZSJ)"
  },
  {
   value: "Sanikiluaq (CAYSK)",
   label: "Sanikiluaq (CAYSK)"
  },
  {
   value: "Sans Souci (CAYSI)",
   label: "Sans Souci (CAYSI)"
  },
  {
   value: "Sarnia (CASNI)",
   label: "Sarnia (CASNI)"
  },
  {
   value: "Saskatoon (CASAK)",
   label: "Saskatoon (CASAK)"
  },
  {
   value: "Sault Ste Marie (CASSM)",
   label: "Sault Ste Marie (CASSM)"
  },
  {
   value: "Sayabec (CASAY)",
   label: "Sayabec (CASAY)"
  },
  {
   value: "Scarborough (CASCB)",
   label: "Scarborough (CASCB)"
  },
  {
   value: "Schefferville (CAYKL)",
   label: "Schefferville (CAYKL)"
  },
  {
   value: "Seaforth (CASFH)",
   label: "Seaforth (CASFH)"
  },
  {
   value: "Sechelt (CAYHS)",
   label: "Sechelt (CAYHS)"
  },
  {
   value: "Seldom (CASEM)",
   label: "Seldom (CASEM)"
  },
  {
   value: "Selkirk (CASEL)",
   label: "Selkirk (CASEL)"
  },
  {
   value: "Sept Iles (Seven Is.) (CASEI)",
   label: "Sept Iles (Seven Is.) (CASEI)"
  },
  {
   value: "Seven Island Bay (CASEB)",
   label: "Seven Island Bay (CASEB)"
  },
  {
   value: "Shamattawa (CAZTM)",
   label: "Shamattawa (CAZTM)"
  },
  {
   value: "Shawinigan (CASHA)",
   label: "Shawinigan (CASHA)"
  },
  {
   value: "Shearwater (CAYAW)",
   label: "Shearwater (CAYAW)"
  },
  {
   value: "Shearwater (CAYSX)",
   label: "Shearwater (CAYSX)"
  },
  {
   value: "Shediac (CASHE)",
   label: "Shediac (CASHE)"
  },
  {
   value: "Sheet Harbour (CASHH)",
   label: "Sheet Harbour (CASHH)"
  },
  {
   value: "Shelburne (CASBU)",
   label: "Shelburne (CASBU)"
  },
  {
   value: "Sherbrooke (CASBR)",
   label: "Sherbrooke (CASBR)"
  },
  {
   value: "Sherkston (CASHK)",
   label: "Sherkston (CASHK)"
  },
  {
   value: "Shippegan (CASHP)",
   label: "Shippegan (CASHP)"
  },
  {
   value: "Sidney (CASDY)",
   label: "Sidney (CASDY)"
  },
  {
   value: "Silva Bay (CASYF)",
   label: "Silva Bay (CASYF)"
  },
  {
   value: "Simcoe (CASIC)",
   label: "Simcoe (CASIC)"
  },
  {
   value: "Sioux Lookout (CAYXL)",
   label: "Sioux Lookout (CAYXL)"
  },
  {
   value: "Slate Island (CAYSS)",
   label: "Slate Island (CAYSS)"
  },
  {
   value: "Slave Lake (CAYZH)",
   label: "Slave Lake (CAYZH)"
  },
  {
   value: "Smith Falls (CAYSH)",
   label: "Smith Falls (CAYSH)"
  },
  {
   value: "Smithers (CAYYD)",
   label: "Smithers (CAYYD)"
  },
  {
   value: "Smiths Falls (CASMF)",
   label: "Smiths Falls (CASMF)"
  },
  {
   value: "Snake River (CAYXF)",
   label: "Snake River (CAYXF)"
  },
  {
   value: "Snare Lake (CAYFJ)",
   label: "Snare Lake (CAYFJ)"
  },
  {
   value: "Sombra (CASOM)",
   label: "Sombra (CASOM)"
  },
  {
   value: "Portneuf (CAPTN)",
   label: "Portneuf (CAPTN)"
  },
  {
   value: "Powell Lake (CAWPL)",
   label: "Powell Lake (CAWPL)"
  },
  {
   value: "Powell River (CAPOW)",
   label: "Powell River (CAPOW)"
  },
  {
   value: "Prescott (CAPRE)",
   label: "Prescott (CAPRE)"
  },
  {
   value: "Prince George (CAPRG)",
   label: "Prince George (CAPRG)"
  },
  {
   value: "Prince Rupert (CAPRR)",
   label: "Prince Rupert (CAPRR)"
  },
  {
   value: "Pugwash (CAPUG)",
   label: "Pugwash (CAPUG)"
  },
  {
   value: "Quatsino (CAQTS)",
   label: "Quatsino (CAQTS)"
  },
  {
   value: "Quebec (CAQUE)",
   label: "Quebec (CAQUE)"
  },
  {
   value: "Ramea (CARAM)",
   label: "Ramea (CARAM)"
  },
  {
   value: "Regina (CAREG)",
   label: "Regina (CAREG)"
  },
  {
   value: "Renfrew (CARNF)",
   label: "Renfrew (CARNF)"
  },
  {
   value: "Repentigny (CAREP)",
   label: "Repentigny (CAREP)"
  },
  {
   value: "Resolute Bay (CAREB)",
   label: "Resolute Bay (CAREB)"
  },
  {
   value: "Revelstoke (CAYRV)",
   label: "Revelstoke (CAYRV)"
  },
  {
   value: "Rexdale\/Toronto (CAREX)",
   label: "Rexdale\/Toronto (CAREX)"
  },
  {
   value: "Richelieu (CARIC)",
   label: "Richelieu (CARIC)"
  },
  {
   value: "Richmond (CARBC)",
   label: "Richmond (CARBC)"
  },
  {
   value: "Richmond Hill (CARHI)",
   label: "Richmond Hill (CARHI)"
  },
  {
   value: "Rigolet (CAYRG)",
   label: "Rigolet (CAYRG)"
  },
  {
   value: "Rimouski (CARIM)",
   label: "Rimouski (CARIM)"
  },
  {
   value: "Rivers (CAYYI)",
   label: "Rivers (CAYYI)"
  },
  {
   value: "Rivers Inlet (CAYRN)",
   label: "Rivers Inlet (CAYRN)"
  },
  {
   value: "Riviere au Tonnerre (CAYTN)",
   label: "Riviere au Tonnerre (CAYTN)"
  },
  {
   value: "Riviere du Loup (CARDL)",
   label: "Riviere du Loup (CARDL)"
  },
  {
   value: "Roberts Bank (CARBK)",
   label: "Roberts Bank (CARBK)"
  },
  {
   value: "Robertson (CARSN)",
   label: "Robertson (CARSN)"
  },
  {
   value: "Roberval (CAYRJ)",
   label: "Roberval (CAYRJ)"
  },
  {
   value: "Rockton (CARQQ)",
   label: "Rockton (CARQQ)"
  },
  {
   value: "Rocky Mountain House (CAYRM)",
   label: "Rocky Mountain House (CAYRM)"
  },
  {
   value: "Roddickton (CAROD)",
   label: "Roddickton (CAROD)"
  },
  {
   value: "Rougemont (CAROU)",
   label: "Rougemont (CAROU)"
  },
  {
   value: "Round Lake (CAZRJ)",
   label: "Round Lake (CAZRJ)"
  },
  {
   value: "Rouyn (CAYUY)",
   label: "Rouyn (CAYUY)"
  },
  {
   value: "Rupert Inlet (CARUI)",
   label: "Rupert Inlet (CARUI)"
  },
  {
   value: "Ruskin (CARUS)",
   label: "Ruskin (CARUS)"
  },
  {
   value: "Ruthven (CARUV)",
   label: "Ruthven (CARUV)"
  },
  {
   value: "Sable Island (CAYSA)",
   label: "Sable Island (CAYSA)"
  },
  {
   value: "Sachigo Lake (CAZPB)",
   label: "Sachigo Lake (CAZPB)"
  },
  {
   value: "Sachs Harbour (CAYSY)",
   label: "Sachs Harbour (CAYSY)"
  },
  {
   value: "Saglek (CAYSV)",
   label: "Saglek (CAYSV)"
  },
  {
   value: "Pictou (CAPTO)",
   label: "Pictou (CAPTO)"
  },
  {
   value: "Pikangikum (CAYPM)",
   label: "Pikangikum (CAYPM)"
  },
  {
   value: "Pikwitonei (CAPIW)",
   label: "Pikwitonei (CAPIW)"
  },
  {
   value: "Pincher Creek (CAWPC)",
   label: "Pincher Creek (CAWPC)"
  },
  {
   value: "Pine House (CAZPO)",
   label: "Pine House (CAZPO)"
  },
  {
   value: "Pine Point (CAYPP)",
   label: "Pine Point (CAYPP)"
  },
  {
   value: "Plattsville (CAPLA)",
   label: "Plattsville (CAPLA)"
  },
  {
   value: "Pointe au Pic (CAPPC)",
   label: "Pointe au Pic (CAPPC)"
  },
  {
   value: "Pointe Aux Trembles (CAPXT)",
   label: "Pointe Aux Trembles (CAPXT)"
  },
  {
   value: "Pointe Claire (CAPOI)",
   label: "Pointe Claire (CAPOI)"
  },
  {
   value: "Pointe-au-Pic (CAPOP)",
   label: "Pointe-au-Pic (CAPOP)"
  },
  {
   value: "Pointe-aux-Basques (CAPAQ)",
   label: "Pointe-aux-Basques (CAPAQ)"
  },
  {
   value: "Pond Inlet (CAPDI)",
   label: "Pond Inlet (CAPDI)"
  },
  {
   value: "Port Alberni (CAPAB)",
   label: "Port Alberni (CAPAB)"
  },
  {
   value: "Port Alfred (CAPAF)",
   label: "Port Alfred (CAPAF)"
  },
  {
   value: "Port Alice (CAPAC)",
   label: "Port Alice (CAPAC)"
  },
  {
   value: "Port Arthur (CAPOA)",
   label: "Port Arthur (CAPOA)"
  },
  {
   value: "Port aux Basques (CAPBQ)",
   label: "Port aux Basques (CAPBQ)"
  },
  {
   value: "Port Cartier (CAPCA)",
   label: "Port Cartier (CAPCA)"
  },
  {
   value: "Port Colborne (CAPCO)",
   label: "Port Colborne (CAPCO)"
  },
  {
   value: "Port Coquitlam (CAPTC)",
   label: "Port Coquitlam (CAPTC)"
  },
  {
   value: "Port Credit (CAPCR)",
   label: "Port Credit (CAPCR)"
  },
  {
   value: "Port Dover (CAPDV)",
   label: "Port Dover (CAPDV)"
  },
  {
   value: "Port Edward (CAPTE)",
   label: "Port Edward (CAPTE)"
  },
  {
   value: "Port Hardy (CAPHY)",
   label: "Port Hardy (CAPHY)"
  },
  {
   value: "Port Hawkesbury (CAPHW)",
   label: "Port Hawkesbury (CAPHW)"
  },
  {
   value: "Port Hope (CAOPE)",
   label: "Port Hope (CAOPE)"
  },
  {
   value: "Port Maitland (CAPTM)",
   label: "Port Maitland (CAPTM)"
  },
  {
   value: "Port Mcneill (CAPMA)",
   label: "Port Mcneill (CAPMA)"
  },
  {
   value: "Port Medway (CAPMW)",
   label: "Port Medway (CAPMW)"
  },
  {
   value: "Port Mellon (CAPML)",
   label: "Port Mellon (CAPML)"
  },
  {
   value: "Port Menier (CAPME)",
   label: "Port Menier (CAPME)"
  },
  {
   value: "Port Moody\/Vancouver (CAPMO)",
   label: "Port Moody\/Vancouver (CAPMO)"
  },
  {
   value: "Port Nelson (CAPNE)",
   label: "Port Nelson (CAPNE)"
  },
  {
   value: "Port Perry (CAPRP)",
   label: "Port Perry (CAPRP)"
  },
  {
   value: "Port Simpson (CAPSI)",
   label: "Port Simpson (CAPSI)"
  },
  {
   value: "Port Stanley (CAPST)",
   label: "Port Stanley (CAPST)"
  },
  {
   value: "Port Weller (CAPWE)",
   label: "Port Weller (CAPWE)"
  },
  {
   value: "Portage (CAPOR)",
   label: "Portage (CAPOR)"
  },
  {
   value: "North Spirit Lake (CAYNO)",
   label: "North Spirit Lake (CAYNO)"
  },
  {
   value: "North Sydney (CANSY)",
   label: "North Sydney (CANSY)"
  },
  {
   value: "North York (CANYK)",
   label: "North York (CANYK)"
  },
  {
   value: "Northbrook (CAORT)",
   label: "Northbrook (CAORT)"
  },
  {
   value: "Norway House (CAYNE)",
   label: "Norway House (CAYNE)"
  },
  {
   value: "Norwich (Ontario) (CANWC)",
   label: "Norwich (Ontario) (CANWC)"
  },
  {
   value: "Oakville (CAOAK)",
   label: "Oakville (CAOAK)"
  },
  {
   value: "Obre Lake (CAYDW)",
   label: "Obre Lake (CAYDW)"
  },
  {
   value: "Ocean Falls (CAOFA)",
   label: "Ocean Falls (CAOFA)"
  },
  {
   value: "Ogoki (CAYOG)",
   label: "Ogoki (CAYOG)"
  },
  {
   value: "Old Crow (CAYOC)",
   label: "Old Crow (CAYOC)"
  },
  {
   value: "Old Fort Bay (CAZFB)",
   label: "Old Fort Bay (CAZFB)"
  },
  {
   value: "Opapamiska Lake (CAYBS)",
   label: "Opapamiska Lake (CAYBS)"
  },
  {
   value: "Orangeville (CAORA)",
   label: "Orangeville (CAORA)"
  },
  {
   value: "Orillia (CAORI)",
   label: "Orillia (CAORI)"
  },
  {
   value: "Ormstown (CAORM)",
   label: "Ormstown (CAORM)"
  },
  {
   value: "Oshawa (CAOSH)",
   label: "Oshawa (CAOSH)"
  },
  {
   value: "Ottawa (CAOTT)",
   label: "Ottawa (CAOTT)"
  },
  {
   value: "Owen Sound (CAOWS)",
   label: "Owen Sound (CAOWS)"
  },
  {
   value: "Oxford (CAOXF)",
   label: "Oxford (CAOXF)"
  },
  {
   value: "Oxford House (CAYOH)",
   label: "Oxford House (CAYOH)"
  },
  {
   value: "Pakuashipi (CAYIF)",
   label: "Pakuashipi (CAYIF)"
  },
  {
   value: "Pangnirtung (CAPNT)",
   label: "Pangnirtung (CAPNT)"
  },
  {
   value: "Paradise River (CAYDE)",
   label: "Paradise River (CAYDE)"
  },
  {
   value: "Parrsboro (CAPAR)",
   label: "Parrsboro (CAPAR)"
  },
  {
   value: "Parry Sound (CAPRS)",
   label: "Parry Sound (CAPRS)"
  },
  {
   value: "Paspebiac (CAPAS)",
   label: "Paspebiac (CAPAS)"
  },
  {
   value: "Patricia Bay (CAPTB)",
   label: "Patricia Bay (CAPTB)"
  },
  {
   value: "Paulatuk (CAYPC)",
   label: "Paulatuk (CAYPC)"
  },
  {
   value: "Peace River (CAYPE)",
   label: "Peace River (CAYPE)"
  },
  {
   value: "Peawanuck (CAYPO)",
   label: "Peawanuck (CAYPO)"
  },
  {
   value: "Pelly Bay (CAYUF)",
   label: "Pelly Bay (CAYUF)"
  },
  {
   value: "Pembroke (CAPEM)",
   label: "Pembroke (CAPEM)"
  },
  {
   value: "Pender Harbour (CAPEH)",
   label: "Pender Harbour (CAPEH)"
  },
  {
   value: "Penticton (CAYYF)",
   label: "Penticton (CAYYF)"
  },
  {
   value: "Perth (CAPER)",
   label: "Perth (CAPER)"
  },
  {
   value: "Petawawa (CAYWA)",
   label: "Petawawa (CAYWA)"
  },
  {
   value: "Peterborough (CAPBH)",
   label: "Peterborough (CAPBH)"
  },
  {
   value: "Pickering (CAPCK)",
   label: "Pickering (CAPCK)"
  },
  {
   value: "Pickle Lake (CAYPL)",
   label: "Pickle Lake (CAYPL)"
  },
  {
   value: "Picton (CAPIC)",
   label: "Picton (CAPIC)"
  },
  {
   value: "Moose Lake (CAYAD)",
   label: "Moose Lake (CAYAD)"
  },
  {
   value: "Moosonee (CAMOU)",
   label: "Moosonee (CAMOU)"
  },
  {
   value: "Morden (CAMOR)",
   label: "Morden (CAMOR)"
  },
  {
   value: "Morrisburg (CAMOB)",
   label: "Morrisburg (CAMOB)"
  },
  {
   value: "Mould Bay (CAYMD)",
   label: "Mould Bay (CAYMD)"
  },
  {
   value: "Mount Pearl (CAMPE)",
   label: "Mount Pearl (CAMPE)"
  },
  {
   value: "Mulgrave (CAMUL)",
   label: "Mulgrave (CAMUL)"
  },
  {
   value: "Murray Bay (CAYML)",
   label: "Murray Bay (CAYML)"
  },
  {
   value: "Muskoka (CAYQA)",
   label: "Muskoka (CAYQA)"
  },
  {
   value: "Muskrat Dam (CAMSA)",
   label: "Muskrat Dam (CAMSA)"
  },
  {
   value: "Nain (CANAI)",
   label: "Nain (CANAI)"
  },
  {
   value: "Nakina (CAYQN)",
   label: "Nakina (CAYQN)"
  },
  {
   value: "Namu (CAZNU)",
   label: "Namu (CAZNU)"
  },
  {
   value: "Nanaimo (CANNO)",
   label: "Nanaimo (CANNO)"
  },
  {
   value: "Nanisivik (CANVK)",
   label: "Nanisivik (CANVK)"
  },
  {
   value: "Nanoose Bay (CANNE)",
   label: "Nanoose Bay (CANNE)"
  },
  {
   value: "Nanticoke (CANAN)",
   label: "Nanticoke (CANAN)"
  },
  {
   value: "Napierville (CANAP)",
   label: "Napierville (CANAP)"
  },
  {
   value: "Natashquan (CAYNA)",
   label: "Natashquan (CAYNA)"
  },
  {
   value: "Negginan (CAZNG)",
   label: "Negginan (CAZNG)"
  },
  {
   value: "Nemiscau (CAYNS)",
   label: "Nemiscau (CAYNS)"
  },
  {
   value: "Nepeau (CANPU)",
   label: "Nepeau (CANPU)"
  },
  {
   value: "Nephton (CANPH)",
   label: "Nephton (CANPH)"
  },
  {
   value: "Neptune (CANEP)",
   label: "Neptune (CANEP)"
  },
  {
   value: "New Annan (CANEA)",
   label: "New Annan (CANEA)"
  },
  {
   value: "New Denmark (CANDK)",
   label: "New Denmark (CANDK)"
  },
  {
   value: "New Germany (CANGY)",
   label: "New Germany (CANGY)"
  },
  {
   value: "New Glasgow (CANGL)",
   label: "New Glasgow (CANGL)"
  },
  {
   value: "New Richmond (CANRC)",
   label: "New Richmond (CANRC)"
  },
  {
   value: "New Westminster (CANWE)",
   label: "New Westminster (CANWE)"
  },
  {
   value: "Newcastle (CANCT)",
   label: "Newcastle (CANCT)"
  },
  {
   value: "Newmarket (CANWM)",
   label: "Newmarket (CANWM)"
  },
  {
   value: "Niagara Falls (CANIA)",
   label: "Niagara Falls (CANIA)"
  },
  {
   value: "Niagra on the Lake (CANOL)",
   label: "Niagra on the Lake (CANOL)"
  },
  {
   value: "Nitchequon (CAYNI)",
   label: "Nitchequon (CAYNI)"
  },
  {
   value: "Nootka Sound (CAYNK)",
   label: "Nootka Sound (CAYNK)"
  },
  {
   value: "Noranda (CANRN)",
   label: "Noranda (CANRN)"
  },
  {
   value: "Norman Wells (CAYVQ)",
   label: "Norman Wells (CAYVQ)"
  },
  {
   value: "North Arm Fraser (CANAF)",
   label: "North Arm Fraser (CANAF)"
  },
  {
   value: "North Battleford (CAYQW)",
   label: "North Battleford (CAYQW)"
  },
  {
   value: "North Bay (CANOR)",
   label: "North Bay (CANOR)"
  },
  {
   value: "Manitouwadge (CAYMG)",
   label: "Manitouwadge (CAYMG)"
  },
  {
   value: "Manitowaning (CAYEM)",
   label: "Manitowaning (CAYEM)"
  },
  {
   value: "Maniwaki (CAYMW)",
   label: "Maniwaki (CAYMW)"
  },
  {
   value: "Mansonville (CAMAN)",
   label: "Mansonville (CAMAN)"
  },
  {
   value: "Maple Bay (CAYAQ)",
   label: "Maple Bay (CAYAQ)"
  },
  {
   value: "Maple Ridge (CAMRI)",
   label: "Maple Ridge (CAMRI)"
  },
  {
   value: "Marathon (CAMAR)",
   label: "Marathon (CAMAR)"
  },
  {
   value: "Maricourt Airstrip (CAYMC)",
   label: "Maricourt Airstrip (CAYMC)"
  },
  {
   value: "Markham (CAMKH)",
   label: "Markham (CAMKH)"
  },
  {
   value: "Mary's Harbour (CAYMH)",
   label: "Mary's Harbour (CAYMH)"
  },
  {
   value: "Marystown (CAMTN)",
   label: "Marystown (CAMTN)"
  },
  {
   value: "Masset (CAMSS)",
   label: "Masset (CAMSS)"
  },
  {
   value: "Matagami (CAYNM)",
   label: "Matagami (CAYNM)"
  },
  {
   value: "Matane (CAMNE)",
   label: "Matane (CAMNE)"
  },
  {
   value: "Mayo (CAYMA)",
   label: "Mayo (CAYMA)"
  },
  {
   value: "Meadow Lake (CAYLJ)",
   label: "Meadow Lake (CAYLJ)"
  },
  {
   value: "Medicine Hat (CAYXH)",
   label: "Medicine Hat (CAYXH)"
  },
  {
   value: "Meldrum Bay (CAMDB)",
   label: "Meldrum Bay (CAMDB)"
  },
  {
   value: "Menzies Bay (CAMEB)",
   label: "Menzies Bay (CAMEB)"
  },
  {
   value: "Merritt (CAYMB)",
   label: "Merritt (CAYMB)"
  },
  {
   value: "Merry Island (CAYMR)",
   label: "Merry Island (CAYMR)"
  },
  {
   value: "Meteghan (CAMET)",
   label: "Meteghan (CAMET)"
  },
  {
   value: "Michipicoten (CAMIH)",
   label: "Michipicoten (CAMIH)"
  },
  {
   value: "Midland (CAMID)",
   label: "Midland (CAMID)"
  },
  {
   value: "Milton (CAMIL)",
   label: "Milton (CAMIL)"
  },
  {
   value: "Minaki (CAYMI)",
   label: "Minaki (CAYMI)"
  },
  {
   value: "Miners Bay (CAYAV)",
   label: "Miners Bay (CAYAV)"
  },
  {
   value: "Mingan (CAYLP)",
   label: "Mingan (CAYLP)"
  },
  {
   value: "Mirabel (CAMRB)",
   label: "Mirabel (CAMRB)"
  },
  {
   value: "Miramichi (CAMIR)",
   label: "Miramichi (CAMIR)"
  },
  {
   value: "Mission City (CAMIB)",
   label: "Mission City (CAMIB)"
  },
  {
   value: "Mississauga (CAMIS)",
   label: "Mississauga (CAMIS)"
  },
  {
   value: "Moncton (CAMNT)",
   label: "Moncton (CAMNT)"
  },
  {
   value: "Monkton (CAMON)",
   label: "Monkton (CAMON)"
  },
  {
   value: "Mont Joli (CAYYY)",
   label: "Mont Joli (CAYYY)"
  },
  {
   value: "Mont Laurier (CAMLA)",
   label: "Mont Laurier (CAMLA)"
  },
  {
   value: "Mont Louis (CAMOL)",
   label: "Mont Louis (CAMOL)"
  },
  {
   value: "Mont St Hilaire (CAMSH)",
   label: "Mont St Hilaire (CAMSH)"
  },
  {
   value: "Montagne Harbor (CAYMF)",
   label: "Montagne Harbor (CAYMF)"
  },
  {
   value: "Montreal (CAMTR)",
   label: "Montreal (CAMTR)"
  },
  {
   value: "Moose Jaw (CAYMJ)",
   label: "Moose Jaw (CAYMJ)"
  },
  {
   value: "Lansdowne House (CAYLH)",
   label: "Lansdowne House (CAYLH)"
  },
  {
   value: "Laprairie (CALPE)",
   label: "Laprairie (CALPE)"
  },
  {
   value: "Laurie River (CALRQ)",
   label: "Laurie River (CALRQ)"
  },
  {
   value: "Laval (CALAV)",
   label: "Laval (CALAV)"
  },
  {
   value: "Leaf Bay (CAXLF)",
   label: "Leaf Bay (CAXLF)"
  },
  {
   value: "Leaf Rapids (CALRA)",
   label: "Leaf Rapids (CALRA)"
  },
  {
   value: "Leamington (CALMN)",
   label: "Leamington (CALMN)"
  },
  {
   value: "Lebel-sur-Quevillon (CAYLS)",
   label: "Lebel-sur-Quevillon (CAYLS)"
  },
  {
   value: "Lennoxville (CALEN)",
   label: "Lennoxville (CALEN)"
  },
  {
   value: "Les Cédres (CALCI)",
   label: "Les Cédres (CALCI)"
  },
  {
   value: "Lethbridge (CALTB)",
   label: "Lethbridge (CALTB)"
  },
  {
   value: "Levis (CALEV)",
   label: "Levis (CALEV)"
  },
  {
   value: "Lewisporte (CALWP)",
   label: "Lewisporte (CALWP)"
  },
  {
   value: "Listowel (CALTW)",
   label: "Listowel (CALTW)"
  },
  {
   value: "Little Current (CALIC)",
   label: "Little Current (CALIC)"
  },
  {
   value: "Little Grand Rapids (CAZGR)",
   label: "Little Grand Rapids (CAZGR)"
  },
  {
   value: "Little Narrows (CALIN)",
   label: "Little Narrows (CALIN)"
  },
  {
   value: "Liverpool (CALIV)",
   label: "Liverpool (CALIV)"
  },
  {
   value: "Lloydminster (CAYLL)",
   label: "Lloydminster (CAYLL)"
  },
  {
   value: "Lockeport (CALCP)",
   label: "Lockeport (CALCP)"
  },
  {
   value: "Locusthill (CAOCH)",
   label: "Locusthill (CAOCH)"
  },
  {
   value: "Lomond (CALMD)",
   label: "Lomond (CALMD)"
  },
  {
   value: "London (CALOD)",
   label: "London (CALOD)"
  },
  {
   value: "Long Harbour (CALOH)",
   label: "Long Harbour (CALOH)"
  },
  {
   value: "Long Point (CAYLX)",
   label: "Long Point (CAYLX)"
  },
  {
   value: "Long Pond (CALOP)",
   label: "Long Pond (CALOP)"
  },
  {
   value: "Longueil (CALON)",
   label: "Longueil (CALON)"
  },
  {
   value: "Louisburg (CALOU)",
   label: "Louisburg (CALOU)"
  },
  {
   value: "Lunenburg (CALUN)",
   label: "Lunenburg (CALUN)"
  },
  {
   value: "Lutselke\/Snowdrift (CAYSG)",
   label: "Lutselke\/Snowdrift (CAYSG)"
  },
  {
   value: "Lyall Harbour (CAYAJ)",
   label: "Lyall Harbour (CAYAJ)"
  },
  {
   value: "Lynn Lake (CAYYL)",
   label: "Lynn Lake (CAYYL)"
  },
  {
   value: "Lytton (CAYLY)",
   label: "Lytton (CAYLY)"
  },
  {
   value: "Madoc (CAMAD)",
   label: "Madoc (CAMAD)"
  },
  {
   value: "Magdalen Is (CAMGD)",
   label: "Magdalen Is (CAMGD)"
  },
  {
   value: "Magog (CAMAG)",
   label: "Magog (CAMAG)"
  },
  {
   value: "Mahone Bay (CAMHB)",
   label: "Mahone Bay (CAMHB)"
  },
  {
   value: "Main Brook (CAMBR)",
   label: "Main Brook (CAMBR)"
  },
  {
   value: "Main Duck Island (CAYDK)",
   label: "Main Duck Island (CAYDK)"
  },
  {
   value: "Makkovik (CAYMN)",
   label: "Makkovik (CAYMN)"
  },
  {
   value: "Kimmirut\/Lake Harbour (CAYLC)",
   label: "Kimmirut\/Lake Harbour (CAYLC)"
  },
  {
   value: "Kincardine (CAKAC)",
   label: "Kincardine (CAKAC)"
  },
  {
   value: "Kindersley (CAYKY)",
   label: "Kindersley (CAYKY)"
  },
  {
   value: "King William Is (CAKWI)",
   label: "King William Is (CAKWI)"
  },
  {
   value: "Kingfisher Lake (CAKIF)",
   label: "Kingfisher Lake (CAKIF)"
  },
  {
   value: "Kingsey Falls (CAKFS)",
   label: "Kingsey Falls (CAKFS)"
  },
  {
   value: "Kingston (CAKIN)",
   label: "Kingston (CAKIN)"
  },
  {
   value: "Kingsville (CAKVL)",
   label: "Kingsville (CAKVL)"
  },
  {
   value: "Kinoosao (CAKNY)",
   label: "Kinoosao (CAKNY)"
  },
  {
   value: "Kirkland (CAKIK)",
   label: "Kirkland (CAKIK)"
  },
  {
   value: "Kirkland Lake (CAYKX)",
   label: "Kirkland Lake (CAYKX)"
  },
  {
   value: "Kitchener (CAKTC)",
   label: "Kitchener (CAKTC)"
  },
  {
   value: "Kitimat (CAKTM)",
   label: "Kitimat (CAKTM)"
  },
  {
   value: "Kitkatla (CAYKK)",
   label: "Kitkatla (CAYKK)"
  },
  {
   value: "Klemtu (CAYKT)",
   label: "Klemtu (CAYKT)"
  },
  {
   value: "Knee Lake (CAYKE)",
   label: "Knee Lake (CAYKE)"
  },
  {
   value: "Knights Inlet (CAKNV)",
   label: "Knights Inlet (CAKNV)"
  },
  {
   value: "Kovik (CAKOV)",
   label: "Kovik (CAKOV)"
  },
  {
   value: "L'Orignal (CALOR)",
   label: "L'Orignal (CALOR)"
  },
  {
   value: "La Grande (CAYGL)",
   label: "La Grande (CAYGL)"
  },
  {
   value: "La Have (CALHA)",
   label: "La Have (CALHA)"
  },
  {
   value: "La Ronge (CAYVC)",
   label: "La Ronge (CAYVC)"
  },
  {
   value: "La Salle (CALAS)",
   label: "La Salle (CALAS)"
  },
  {
   value: "La Sarre (CASSQ)",
   label: "La Sarre (CASSQ)"
  },
  {
   value: "La Tabatiere (CAZLT)",
   label: "La Tabatiere (CAZLT)"
  },
  {
   value: "La Tuque (CAYLQ)",
   label: "La Tuque (CAYLQ)"
  },
  {
   value: "Lac Biche (CAYLB)",
   label: "Lac Biche (CAYLB)"
  },
  {
   value: "Lachine\/Montreal (CALAC)",
   label: "Lachine\/Montreal (CALAC)"
  },
  {
   value: "Lachute (CALCH)",
   label: "Lachute (CALCH)"
  },
  {
   value: "Lacolle (CALCO)",
   label: "Lacolle (CALCO)"
  },
  {
   value: "Ladner (CALDN)",
   label: "Ladner (CALDN)"
  },
  {
   value: "Ladysmith (CALAD)",
   label: "Ladysmith (CALAD)"
  },
  {
   value: "Laforges (CAYLF)",
   label: "Laforges (CAYLF)"
  },
  {
   value: "Lagrande 3 (CAYAR)",
   label: "Lagrande 3 (CAYAR)"
  },
  {
   value: "Lagrande 4 (CAYAH)",
   label: "Lagrande 4 (CAYAH)"
  },
  {
   value: "Lake Harbour (CALAH)",
   label: "Lake Harbour (CALAH)"
  },
  {
   value: "Lakeview (CALAW)",
   label: "Lakeview (CALAW)"
  },
  {
   value: "Landsdown (CALDS)",
   label: "Landsdown (CALDS)"
  },
  {
   value: "Langara (CAYLA)",
   label: "Langara (CAYLA)"
  },
  {
   value: "Langley (CALNG)",
   label: "Langley (CALNG)"
  },
  {
   value: "Langton (CALGT)",
   label: "Langton (CALGT)"
  },
  {
   value: "Ignace (CAZUC)",
   label: "Ignace (CAZUC)"
  },
  {
   value: "Ile Perrot (CAIPE)",
   label: "Ile Perrot (CAIPE)"
  },
  {
   value: "Iles de la Madeleine (CAYGR)",
   label: "Iles de la Madeleine (CAYGR)"
  },
  {
   value: "Ilford (CAILF)",
   label: "Ilford (CAILF)"
  },
  {
   value: "Ingersoll (CAIGS)",
   label: "Ingersoll (CAIGS)"
  },
  {
   value: "Inukjuak (CAYPH)",
   label: "Inukjuak (CAYPH)"
  },
  {
   value: "Inuvik (CAYEV)",
   label: "Inuvik (CAYEV)"
  },
  {
   value: "Inverlake (CATIL)",
   label: "Inverlake (CATIL)"
  },
  {
   value: "Ioco (CAIOC)",
   label: "Ioco (CAIOC)"
  },
  {
   value: "Iona (CAION)",
   label: "Iona (CAION)"
  },
  {
   value: "Iqaluit (CAIQL)",
   label: "Iqaluit (CAIQL)"
  },
  {
   value: "Island Lk\/Garden Hill (CAYIV)",
   label: "Island Lk\/Garden Hill (CAYIV)"
  },
  {
   value: "Ivujivik (CAYIK)",
   label: "Ivujivik (CAYIK)"
  },
  {
   value: "Jasper (CAJPR)",
   label: "Jasper (CAJPR)"
  },
  {
   value: "Jenpeg (CAZJG)",
   label: "Jenpeg (CAZJG)"
  },
  {
   value: "Jervis Inlet (CAJEI)",
   label: "Jervis Inlet (CAJEI)"
  },
  {
   value: "Joffre (CAJOF)",
   label: "Joffre (CAJOF)"
  },
  {
   value: "Johnny Mountain (CAYJO)",
   label: "Johnny Mountain (CAYJO)"
  },
  {
   value: "Joliette (CAJOL)",
   label: "Joliette (CAJOL)"
  },
  {
   value: "Jonquiere (CAJON)",
   label: "Jonquiere (CAJON)"
  },
  {
   value: "Jordan Station (CAJST)",
   label: "Jordan Station (CAJST)"
  },
  {
   value: "Kamloops (CAKML)",
   label: "Kamloops (CAKML)"
  },
  {
   value: "Kanata (CAKAN)",
   label: "Kanata (CAKAN)"
  },
  {
   value: "Kangiqsualujjuaq (CAXGR)",
   label: "Kangiqsualujjuaq (CAXGR)"
  },
  {
   value: "Kangiqsujuaq (CAYWB)",
   label: "Kangiqsujuaq (CAYWB)"
  },
  {
   value: "Kangirsuk (CAYKG)",
   label: "Kangirsuk (CAYKG)"
  },
  {
   value: "Kapuskasing (CAYYU)",
   label: "Kapuskasing (CAYYU)"
  },
  {
   value: "Kasabonika (CAXKS)",
   label: "Kasabonika (CAXKS)"
  },
  {
   value: "Kasba Lake (CAYDU)",
   label: "Kasba Lake (CAYDU)"
  },
  {
   value: "Kaschechewan (CAZKE)",
   label: "Kaschechewan (CAZKE)"
  },
  {
   value: "Kattiniq\/Donaldson Lake (CAYAU)",
   label: "Kattiniq\/Donaldson Lake (CAYAU)"
  },
  {
   value: "Kegaska (CAZKG)",
   label: "Kegaska (CAZKG)"
  },
  {
   value: "Kelowna (CAKWL)",
   label: "Kelowna (CAKWL)"
  },
  {
   value: "Kelsey (CAKES)",
   label: "Kelsey (CAKES)"
  },
  {
   value: "Kennosao Lake (CAYKI)",
   label: "Kennosao Lake (CAYKI)"
  },
  {
   value: "Kenora (CAYQK)",
   label: "Kenora (CAYQK)"
  },
  {
   value: "Key Lake (CAYKJ)",
   label: "Key Lake (CAYKJ)"
  },
  {
   value: "Killaloe (CAYXI)",
   label: "Killaloe (CAYXI)"
  },
  {
   value: "Killarney (CAKLY)",
   label: "Killarney (CAKLY)"
  },
  {
   value: "Killineq (CAXBW)",
   label: "Killineq (CAXBW)"
  },
  {
   value: "Kimberley (CAYQE)",
   label: "Kimberley (CAYQE)"
  },
  {
   value: "Grindstone (CAGRS)",
   label: "Grindstone (CAGRS)"
  },
  {
   value: "Grise Fiord (CAYGZ)",
   label: "Grise Fiord (CAYGZ)"
  },
  {
   value: "Gros Cacouna (CAGCA)",
   label: "Gros Cacouna (CAGCA)"
  },
  {
   value: "Guelph (CAGLP)",
   label: "Guelph (CAGLP)"
  },
  {
   value: "Guildwood (CAYTO)",
   label: "Guildwood (CAYTO)"
  },
  {
   value: "Guysborough (CAGYB)",
   label: "Guysborough (CAGYB)"
  },
  {
   value: "Hagersville (CAHGS)",
   label: "Hagersville (CAHGS)"
  },
  {
   value: "Haines Junction (CAHJU)",
   label: "Haines Junction (CAHJU)"
  },
  {
   value: "Hakai Pass (CAYHC)",
   label: "Hakai Pass (CAYHC)"
  },
  {
   value: "Halifax (CAHAL)",
   label: "Halifax (CAHAL)"
  },
  {
   value: "Hall Beach (CAHAB)",
   label: "Hall Beach (CAHAB)"
  },
  {
   value: "Hamilton (CAHAM)",
   label: "Hamilton (CAHAM)"
  },
  {
   value: "Hampden (CAHMP)",
   label: "Hampden (CAHMP)"
  },
  {
   value: "Hantsport (CAHPT)",
   label: "Hantsport (CAHPT)"
  },
  {
   value: "Harbour Breton (CAHBR)",
   label: "Harbour Breton (CAHBR)"
  },
  {
   value: "Harbour Grace (CAHRE)",
   label: "Harbour Grace (CAHRE)"
  },
  {
   value: "Harriet (CAHAR)",
   label: "Harriet (CAHAR)"
  },
  {
   value: "Harriston (CAHRR)",
   label: "Harriston (CAHRR)"
  },
  {
   value: "Hartley Bay (CAYTB)",
   label: "Hartley Bay (CAYTB)"
  },
  {
   value: "Hatch Point (CAHAT)",
   label: "Hatch Point (CAHAT)"
  },
  {
   value: "Hatchet Lake (CAYDJ)",
   label: "Hatchet Lake (CAYDJ)"
  },
  {
   value: "Havre St Pierre (CAHSP)",
   label: "Havre St Pierre (CAHSP)"
  },
  {
   value: "Hawkesbury (CAHAW)",
   label: "Hawkesbury (CAHAW)"
  },
  {
   value: "Hay River (CAYHY)",
   label: "Hay River (CAYHY)"
  },
  {
   value: "Hearst (CAYHF)",
   label: "Hearst (CAYHF)"
  },
  {
   value: "Hebbville (CAHBV)",
   label: "Hebbville (CAHBV)"
  },
  {
   value: "Hibernia (CAHIB)",
   label: "Hibernia (CAHIB)"
  },
  {
   value: "High Level (CAYOJ)",
   label: "High Level (CAYOJ)"
  },
  {
   value: "High Prairie (CAZHP)",
   label: "High Prairie (CAZHP)"
  },
  {
   value: "Holman (CAYHI)",
   label: "Holman (CAYHI)"
  },
  {
   value: "Holyrood (CAHOD)",
   label: "Holyrood (CAHOD)"
  },
  {
   value: "Hope (CAYHE)",
   label: "Hope (CAYHE)"
  },
  {
   value: "Hopedale (CAHOP)",
   label: "Hopedale (CAHOP)"
  },
  {
   value: "Hornby (CAHOR)",
   label: "Hornby (CAHOR)"
  },
  {
   value: "Hornepayne (CAYHN)",
   label: "Hornepayne (CAYHN)"
  },
  {
   value: "Howe Sound (CAHWS)",
   label: "Howe Sound (CAHWS)"
  },
  {
   value: "Hudson Bay (CAYHB)",
   label: "Hudson Bay (CAYHB)"
  },
  {
   value: "Hudson Hope (CAYNH)",
   label: "Hudson Hope (CAYNH)"
  },
  {
   value: "Huntsville (CAHUN)",
   label: "Huntsville (CAHUN)"
  },
  {
   value: "Iberville (CAIBV)",
   label: "Iberville (CAIBV)"
  },
  {
   value: "Igloolik (CAIGL)",
   label: "Igloolik (CAIGL)"
  },
  {
   value: "Fredericton (CAFRE)",
   label: "Fredericton (CAFRE)"
  },
  {
   value: "Frobisher Bay (CAFBB)",
   label: "Frobisher Bay (CAFBB)"
  },
  {
   value: "Frobisher Bay Apt (CAYFB)",
   label: "Frobisher Bay Apt (CAYFB)"
  },
  {
   value: "Frontier (CAFRO)",
   label: "Frontier (CAFRO)"
  },
  {
   value: "Gagetown (CAYCX)",
   label: "Gagetown (CAYCX)"
  },
  {
   value: "Gagnon (CAYGA)",
   label: "Gagnon (CAYGA)"
  },
  {
   value: "Gander (CAGAN)",
   label: "Gander (CAGAN)"
  },
  {
   value: "Ganges (CAGGS)",
   label: "Ganges (CAGGS)"
  },
  {
   value: "Gaspe (CAGPE)",
   label: "Gaspe (CAGPE)"
  },
  {
   value: "Georgetown (CAGGW)",
   label: "Georgetown (CAGGW)"
  },
  {
   value: "Geraldton (CAYGQ)",
   label: "Geraldton (CAYGQ)"
  },
  {
   value: "Germansen (CAYGS)",
   label: "Germansen (CAYGS)"
  },
  {
   value: "Gethsemani (CAZGS)",
   label: "Gethsemani (CAZGS)"
  },
  {
   value: "Gillam (CAYGX)",
   label: "Gillam (CAYGX)"
  },
  {
   value: "Gillies Bay (CAYGB)",
   label: "Gillies Bay (CAYGB)"
  },
  {
   value: "Gimli (CAYGM)",
   label: "Gimli (CAYGM)"
  },
  {
   value: "Gjoa Haven (CAYHK)",
   label: "Gjoa Haven (CAYHK)"
  },
  {
   value: "Glace Bay (CAGLB)",
   label: "Glace Bay (CAGLB)"
  },
  {
   value: "Godbout (CAGBT)",
   label: "Godbout (CAGBT)"
  },
  {
   value: "Goderich (CAGOH)",
   label: "Goderich (CAGOH)"
  },
  {
   value: "Gods Narrows (CAYGO)",
   label: "Gods Narrows (CAYGO)"
  },
  {
   value: "Gods River (CAZGI)",
   label: "Gods River (CAZGI)"
  },
  {
   value: "Gold River (CAGOR)",
   label: "Gold River (CAGOR)"
  },
  {
   value: "Goodwood (CAGDW)",
   label: "Goodwood (CAGDW)"
  },
  {
   value: "Goose Bay (CAGOO)",
   label: "Goose Bay (CAGOO)"
  },
  {
   value: "Gore Bay (CAYZE)",
   label: "Gore Bay (CAYZE)"
  },
  {
   value: "Gorge Harbor (CAYGE)",
   label: "Gorge Harbor (CAYGE)"
  },
  {
   value: "Granby (CAGRA)",
   label: "Granby (CAGRA)"
  },
  {
   value: "Grand Bank (CAGRB)",
   label: "Grand Bank (CAGRB)"
  },
  {
   value: "Grand Bend (CAGJI)",
   label: "Grand Bend (CAGJI)"
  },
  {
   value: "Grand Falls (CAGRF)",
   label: "Grand Falls (CAGRF)"
  },
  {
   value: "Grand Forks (CAZGF)",
   label: "Grand Forks (CAZGF)"
  },
  {
   value: "Grand Manan (CAGMA)",
   label: "Grand Manan (CAGMA)"
  },
  {
   value: "Grand Toys Dorval (CAGTD)",
   label: "Grand Toys Dorval (CAGTD)"
  },
  {
   value: "Grande Cache (CAYGC)",
   label: "Grande Cache (CAYGC)"
  },
  {
   value: "Grande Prairie (CAYQU)",
   label: "Grande Prairie (CAYQU)"
  },
  {
   value: "Grandemere (CAGDE)",
   label: "Grandemere (CAGDE)"
  },
  {
   value: "Great Bear Lake (CADAS)",
   label: "Great Bear Lake (CADAS)"
  },
  {
   value: "Greenfield Park (CAGRE)",
   label: "Greenfield Park (CAGRE)"
  },
  {
   value: "Greenway Sound (CAYGN)",
   label: "Greenway Sound (CAYGN)"
  },
  {
   value: "Greenwood (CAYZX)",
   label: "Greenwood (CAYZX)"
  },
  {
   value: "Erin (CAERI)",
   label: "Erin (CAERI)"
  },
  {
   value: "Esquimalt (CAESQ)",
   label: "Esquimalt (CAESQ)"
  },
  {
   value: "Essex (CAESS)",
   label: "Essex (CAESS)"
  },
  {
   value: "Estevan (CAEST)",
   label: "Estevan (CAEST)"
  },
  {
   value: "Estevan Point (CAYEP)",
   label: "Estevan Point (CAYEP)"
  },
  {
   value: "Etobicoke (CAETC)",
   label: "Etobicoke (CAETC)"
  },
  {
   value: "Fairmount Springs (CAYCZ)",
   label: "Fairmount Springs (CAYCZ)"
  },
  {
   value: "Fairview (CAZFW)",
   label: "Fairview (CAZFW)"
  },
  {
   value: "Falher (CAYOE)",
   label: "Falher (CAYOE)"
  },
  {
   value: "Faro (CAZFA)",
   label: "Faro (CAZFA)"
  },
  {
   value: "Father Point (CAFAP)",
   label: "Father Point (CAFAP)"
  },
  {
   value: "Fenwick (CAFWC)",
   label: "Fenwick (CAFWC)"
  },
  {
   value: "Fergus (CAFGS)",
   label: "Fergus (CAFGS)"
  },
  {
   value: "Flin Flon (CAYFO)",
   label: "Flin Flon (CAYFO)"
  },
  {
   value: "Florenceville (CAFLV)",
   label: "Florenceville (CAFLV)"
  },
  {
   value: "Fogo Is (CAFOG)",
   label: "Fogo Is (CAFOG)"
  },
  {
   value: "Fond du Lac (CAZFD)",
   label: "Fond du Lac (CAZFD)"
  },
  {
   value: "Fontanges (CAYFG)",
   label: "Fontanges (CAYFG)"
  },
  {
   value: "Forestville (CAFRV)",
   label: "Forestville (CAFRV)"
  },
  {
   value: "Fort Albany (CAFAL)",
   label: "Fort Albany (CAFAL)"
  },
  {
   value: "Fort Chimo (CAFCM)",
   label: "Fort Chimo (CAFCM)"
  },
  {
   value: "Fort Chipewyan (CAYPY)",
   label: "Fort Chipewyan (CAYPY)"
  },
  {
   value: "Fort Erie (CAFER)",
   label: "Fort Erie (CAFER)"
  },
  {
   value: "Fort Frances (CAFFS)",
   label: "Fort Frances (CAFFS)"
  },
  {
   value: "Fort Good Hope (CAYGH)",
   label: "Fort Good Hope (CAYGH)"
  },
  {
   value: "Fort Hope (CAYFH)",
   label: "Fort Hope (CAYFH)"
  },
  {
   value: "Fort Liard (CAYJF)",
   label: "Fort Liard (CAYJF)"
  },
  {
   value: "Fort Mcmurray (CAYMM)",
   label: "Fort Mcmurray (CAYMM)"
  },
  {
   value: "Fort Mcpherson (CAZFM)",
   label: "Fort Mcpherson (CAZFM)"
  },
  {
   value: "Fort Nelson (CAFNE)",
   label: "Fort Nelson (CAFNE)"
  },
  {
   value: "Fort Reliance (CAYFL)",
   label: "Fort Reliance (CAYFL)"
  },
  {
   value: "Fort Resolution (CAYFR)",
   label: "Fort Resolution (CAYFR)"
  },
  {
   value: "Fort Severn (CAYER)",
   label: "Fort Severn (CAYER)"
  },
  {
   value: "Fort Simpson (CAFSI)",
   label: "Fort Simpson (CAFSI)"
  },
  {
   value: "Fort Smith (CAFSM)",
   label: "Fort Smith (CAFSM)"
  },
  {
   value: "Fort St James (CASJA)",
   label: "Fort St James (CASJA)"
  },
  {
   value: "Fort St John (CAFSJ)",
   label: "Fort St John (CAFSJ)"
  },
  {
   value: "Fortune (CAFOR)",
   label: "Fortune (CAFOR)"
  },
  {
   value: "Fox Harbour (St Lewis) (CAYFX)",
   label: "Fox Harbour (St Lewis) (CAYFX)"
  },
  {
   value: "Fraser River (CAFRR)",
   label: "Fraser River (CAFRR)"
  },
  {
   value: "Cranbrook (CAYXC)",
   label: "Cranbrook (CAYXC)"
  },
  {
   value: "Crofton (CACRO)",
   label: "Crofton (CACRO)"
  },
  {
   value: "Cross Lake (CAYCR)",
   label: "Cross Lake (CAYCR)"
  },
  {
   value: "Dalhousie (CADHS)",
   label: "Dalhousie (CADHS)"
  },
  {
   value: "Daniels Harbour (CAYDH)",
   label: "Daniels Harbour (CAYDH)"
  },
  {
   value: "Dauphin (CAYDN)",
   label: "Dauphin (CAYDN)"
  },
  {
   value: "Davis Inlet (CAYDI)",
   label: "Davis Inlet (CAYDI)"
  },
  {
   value: "Dawson City (CAYDA)",
   label: "Dawson City (CAYDA)"
  },
  {
   value: "Dawson Creek (CAYDQ)",
   label: "Dawson Creek (CAYDQ)"
  },
  {
   value: "Dean River (CAYRD)",
   label: "Dean River (CAYRD)"
  },
  {
   value: "Dease Lake (CAYDL)",
   label: "Dease Lake (CAYDL)"
  },
  {
   value: "Deception Bay (CADEB)",
   label: "Deception Bay (CADEB)"
  },
  {
   value: "Deer Lake (CAYDF)",
   label: "Deer Lake (CAYDF)"
  },
  {
   value: "Deer Lake (CAYVZ)",
   label: "Deer Lake (CAYVZ)"
  },
  {
   value: "Delhi (CADLI)",
   label: "Delhi (CADLI)"
  },
  {
   value: "Deline (CAYWJ)",
   label: "Deline (CAYWJ)"
  },
  {
   value: "Delta (CADEL)",
   label: "Delta (CADEL)"
  },
  {
   value: "Desolation Sound (CAYDS)",
   label: "Desolation Sound (CAYDS)"
  },
  {
   value: "Dieppe (CADPP)",
   label: "Dieppe (CADPP)"
  },
  {
   value: "Digby (CADIG)",
   label: "Digby (CADIG)"
  },
  {
   value: "Dildo (CADIL)",
   label: "Dildo (CADIL)"
  },
  {
   value: "Dingwall (CADWL)",
   label: "Dingwall (CADWL)"
  },
  {
   value: "Doc Creek (CAYDX)",
   label: "Doc Creek (CAYDX)"
  },
  {
   value: "Dolbeau (CAYDO)",
   label: "Dolbeau (CAYDO)"
  },
  {
   value: "Dorchester (CADHR)",
   label: "Dorchester (CADHR)"
  },
  {
   value: "Dorval (CADOR)",
   label: "Dorval (CADOR)"
  },
  {
   value: "Douglas Lake (CADGF)",
   label: "Douglas Lake (CADGF)"
  },
  {
   value: "Downsview (CADVW)",
   label: "Downsview (CADVW)"
  },
  {
   value: "Drayton Valley (CAYDC)",
   label: "Drayton Valley (CAYDC)"
  },
  {
   value: "Drummondville (CADRU)",
   label: "Drummondville (CADRU)"
  },
  {
   value: "Dryden (CADRY)",
   label: "Dryden (CADRY)"
  },
  {
   value: "Duncan\/Quam (CADUQ)",
   label: "Duncan\/Quam (CADUQ)"
  },
  {
   value: "Dundas (CADUD)",
   label: "Dundas (CADUD)"
  },
  {
   value: "Durham (CADUR)",
   label: "Durham (CADUR)"
  },
  {
   value: "Earlton (CAYXR)",
   label: "Earlton (CAYXR)"
  },
  {
   value: "East Main (CAZEM)",
   label: "East Main (CAZEM)"
  },
  {
   value: "Edmonton (CAEDM)",
   label: "Edmonton (CAEDM)"
  },
  {
   value: "Edson (CAEDS)",
   label: "Edson (CAEDS)"
  },
  {
   value: "Elliot Lake (CAYEL)",
   label: "Elliot Lake (CAYEL)"
  },
  {
   value: "Elmira (CAELM)",
   label: "Elmira (CAELM)"
  },
  {
   value: "Elmwood (CAEMD)",
   label: "Elmwood (CAEMD)"
  },
  {
   value: "Erieau (CAENE)",
   label: "Erieau (CAENE)"
  },
  {
   value: "Chisasibi (CAYKU)",
   label: "Chisasibi (CAYKU)"
  },
  {
   value: "Chomedey (CACHO)",
   label: "Chomedey (CACHO)"
  },
  {
   value: "Churchill (CACHV)",
   label: "Churchill (CACHV)"
  },
  {
   value: "Churchill Falls (CAZUM)",
   label: "Churchill Falls (CAZUM)"
  },
  {
   value: "Clam Point (CACLP)",
   label: "Clam Point (CACLP)"
  },
  {
   value: "Clarenville (CACLE)",
   label: "Clarenville (CACLE)"
  },
  {
   value: "Clark's Harbour (CACLH)",
   label: "Clark's Harbour (CACLH)"
  },
  {
   value: "Clarke City (CACLC)",
   label: "Clarke City (CACLC)"
  },
  {
   value: "Clarkson (CACSN)",
   label: "Clarkson (CACSN)"
  },
  {
   value: "Clinton (CACLI)",
   label: "Clinton (CACLI)"
  },
  {
   value: "Clinton Creek (CAYLM)",
   label: "Clinton Creek (CAYLM)"
  },
  {
   value: "Clyde River (CACLR)",
   label: "Clyde River (CACLR)"
  },
  {
   value: "Co-Op Point (CAYCP)",
   label: "Co-Op Point (CAYCP)"
  },
  {
   value: "Cochrane (CAYCN)",
   label: "Cochrane (CAYCN)"
  },
  {
   value: "Cohasset (CACHS)",
   label: "Cohasset (CACHS)"
  },
  {
   value: "Colborne (CACLB)",
   label: "Colborne (CACLB)"
  },
  {
   value: "Cold Lake (CAYOD)",
   label: "Cold Lake (CAYOD)"
  },
  {
   value: "Coley's Point (CACYP)",
   label: "Coley's Point (CACYP)"
  },
  {
   value: "Collingwood (CACOL)",
   label: "Collingwood (CACOL)"
  },
  {
   value: "Collins Bay (CAYKC)",
   label: "Collins Bay (CAYKC)"
  },
  {
   value: "Colville Lake (CAYCK)",
   label: "Colville Lake (CAYCK)"
  },
  {
   value: "Come By Chance (CACBC)",
   label: "Come By Chance (CACBC)"
  },
  {
   value: "Comox (CACOX)",
   label: "Comox (CACOX)"
  },
  {
   value: "Concord (CACNC)",
   label: "Concord (CACNC)"
  },
  {
   value: "Contrecoeur (CACOC)",
   label: "Contrecoeur (CACOC)"
  },
  {
   value: "Coppermine (CACOP)",
   label: "Coppermine (CACOP)"
  },
  {
   value: "Coquitlam (CACOQ)",
   label: "Coquitlam (CACOQ)"
  },
  {
   value: "Coral Harbour (CAYZS)",
   label: "Coral Harbour (CAYZS)"
  },
  {
   value: "Corner Brook (CACBK)",
   label: "Corner Brook (CACBK)"
  },
  {
   value: "Cornwall (CACWL)",
   label: "Cornwall (CACWL)"
  },
  {
   value: "Cornwallis Is (CACWI)",
   label: "Cornwallis Is (CACWI)"
  },
  {
   value: "Coronation (CAYCT)",
   label: "Coronation (CAYCT)"
  },
  {
   value: "Cortes Bay (CAYCF)",
   label: "Cortes Bay (CAYCF)"
  },
  {
   value: "Corunna (CACOR)",
   label: "Corunna (CACOR)"
  },
  {
   value: "Cote Ste Catherine (CACSC)",
   label: "Cote Ste Catherine (CACSC)"
  },
  {
   value: "Country Harbour (CACOH)",
   label: "Country Harbour (CACOH)"
  },
  {
   value: "Courtenay (CACOU)",
   label: "Courtenay (CACOU)"
  },
  {
   value: "Courtright (CACRR)",
   label: "Courtright (CACRR)"
  },
  {
   value: "Cowichan Bay (CACCB)",
   label: "Cowichan Bay (CACCB)"
  },
  {
   value: "Cowley (CAYYM)",
   label: "Cowley (CAYYM)"
  },
  {
   value: "Camrose (CACAE)",
   label: "Camrose (CACAE)"
  },
  {
   value: "Canaport (CACPT)",
   label: "Canaport (CACPT)"
  },
  {
   value: "Candiac (CACAN)",
   label: "Candiac (CACAN)"
  },
  {
   value: "Canso Harbour (CACAH)",
   label: "Canso Harbour (CACAH)"
  },
  {
   value: "Cap-Pele (CACAP)",
   label: "Cap-Pele (CACAP)"
  },
  {
   value: "Cape Dorset (CACDO)",
   label: "Cape Dorset (CACDO)"
  },
  {
   value: "Cape St James (CAYCJ)",
   label: "Cape St James (CAYCJ)"
  },
  {
   value: "Caraquet (CACAQ)",
   label: "Caraquet (CACAQ)"
  },
  {
   value: "Carbonear (CACRB)",
   label: "Carbonear (CACRB)"
  },
  {
   value: "Carcon City\/Toronto (CACAR)",
   label: "Carcon City\/Toronto (CACAR)"
  },
  {
   value: "Cardinal (CACDN)",
   label: "Cardinal (CACDN)"
  },
  {
   value: "Cardston (CACDS)",
   label: "Cardston (CACDS)"
  },
  {
   value: "Caribou Island (CAYCI)",
   label: "Caribou Island (CAYCI)"
  },
  {
   value: "Carleton (CACLT)",
   label: "Carleton (CACLT)"
  },
  {
   value: "Carmanville (CACMV)",
   label: "Carmanville (CACMV)"
  },
  {
   value: "Cartier (CACRT)",
   label: "Cartier (CACRT)"
  },
  {
   value: "Cartierville (CAYCV)",
   label: "Cartierville (CAYCV)"
  },
  {
   value: "Cartwright (CAYRF)",
   label: "Cartwright (CAYRF)"
  },
  {
   value: "Castlegar (CAYCG)",
   label: "Castlegar (CAYCG)"
  },
  {
   value: "Cat Lake (CAYAC)",
   label: "Cat Lake (CAYAC)"
  },
  {
   value: "Catalina (CACAT)",
   label: "Catalina (CACAT)"
  },
  {
   value: "Centralia (CAYCE)",
   label: "Centralia (CAYCE)"
  },
  {
   value: "Chambly (CACHY)",
   label: "Chambly (CACHY)"
  },
  {
   value: "Chandler (CACHR)",
   label: "Chandler (CACHR)"
  },
  {
   value: "Chapleau (CAYLD)",
   label: "Chapleau (CAYLD)"
  },
  {
   value: "Charlo (CAYCL)",
   label: "Charlo (CAYCL)"
  },
  {
   value: "Charlotte (Skidegate) (CASKI)",
   label: "Charlotte (Skidegate) (CASKI)"
  },
  {
   value: "Charlottetown (CACHA)",
   label: "Charlottetown (CACHA)"
  },
  {
   value: "Chatham (CACTM)",
   label: "Chatham (CACTM)"
  },
  {
   value: "Chatham (CACHN)",
   label: "Chatham (CACHN)"
  },
  {
   value: "Chemainus (CACHM)",
   label: "Chemainus (CACHM)"
  },
  {
   value: "Chester (CACST)",
   label: "Chester (CACST)"
  },
  {
   value: "Chesterfield Inlet (CAYCS)",
   label: "Chesterfield Inlet (CAYCS)"
  },
  {
   value: "Cheticamp (CACHT)",
   label: "Cheticamp (CACHT)"
  },
  {
   value: "Chetwynd (CAYCQ)",
   label: "Chetwynd (CAYCQ)"
  },
  {
   value: "Chevery (CAYHR)",
   label: "Chevery (CAYHR)"
  },
  {
   value: "Chibougamau (CAYMT)",
   label: "Chibougamau (CAYMT)"
  },
  {
   value: "Chicoutimi (CACHI)",
   label: "Chicoutimi (CACHI)"
  },
  {
   value: "Chilko Lake (CACJH)",
   label: "Chilko Lake (CACJH)"
  },
  {
   value: "Chilliwack (CACWK)",
   label: "Chilliwack (CACWK)"
  },
  {
   value: "Chippawa (CACHP)",
   label: "Chippawa (CACHP)"
  },
  {
   value: "Bolton (CABLT)",
   label: "Bolton (CABLT)"
  },
  {
   value: "Bonaventure (CAYVB)",
   label: "Bonaventure (CAYVB)"
  },
  {
   value: "Bonnyville (CABOE)",
   label: "Bonnyville (CABOE)"
  },
  {
   value: "Borden (CAYBN)",
   label: "Borden (CAYBN)"
  },
  {
   value: "Botwood (CABWD)",
   label: "Botwood (CABWD)"
  },
  {
   value: "Boucherville (CABOU)",
   label: "Boucherville (CABOU)"
  },
  {
   value: "Bowmanville (CABWV)",
   label: "Bowmanville (CABWV)"
  },
  {
   value: "Bradford (CABRA)",
   label: "Bradford (CABRA)"
  },
  {
   value: "Bramalea (CABRM)",
   label: "Bramalea (CABRM)"
  },
  {
   value: "Brampton (CABRP)",
   label: "Brampton (CABRP)"
  },
  {
   value: "Brandon (CAYBR)",
   label: "Brandon (CAYBR)"
  },
  {
   value: "Brantford (CABRN)",
   label: "Brantford (CABRN)"
  },
  {
   value: "Bridgewater (CABRW)",
   label: "Bridgewater (CABRW)"
  },
  {
   value: "Britannia Beach (CABRI)",
   label: "Britannia Beach (CABRI)"
  },
  {
   value: "Britt (CABTT)",
   label: "Britt (CABTT)"
  },
  {
   value: "Broadview (CAYDR)",
   label: "Broadview (CAYDR)"
  },
  {
   value: "Brochet (CAYBT)",
   label: "Brochet (CAYBT)"
  },
  {
   value: "Brockville (CABCK)",
   label: "Brockville (CABCK)"
  },
  {
   value: "Bromont (CAZBM)",
   label: "Bromont (CAZBM)"
  },
  {
   value: "Bronson Creek (CAYBM)",
   label: "Bronson Creek (CAYBM)"
  },
  {
   value: "Brooklyn (CABKN)",
   label: "Brooklyn (CABKN)"
  },
  {
   value: "Brossard (CABRO)",
   label: "Brossard (CABRO)"
  },
  {
   value: "Broughton Is (CABRT)",
   label: "Broughton Is (CABRT)"
  },
  {
   value: "Buchans (CAYZM)",
   label: "Buchans (CAYZM)"
  },
  {
   value: "Buckingham (CABUC)",
   label: "Buckingham (CABUC)"
  },
  {
   value: "Buffalo Narrows (CAYVT)",
   label: "Buffalo Narrows (CAYVT)"
  },
  {
   value: "Bull Harbour (CAYBH)",
   label: "Bull Harbour (CAYBH)"
  },
  {
   value: "Burgeo (CABUO)",
   label: "Burgeo (CABUO)"
  },
  {
   value: "Burgessville (CABUR)",
   label: "Burgessville (CABUR)"
  },
  {
   value: "Burin (CABUI)",
   label: "Burin (CABUI)"
  },
  {
   value: "Burlington (CABRL)",
   label: "Burlington (CABRL)"
  },
  {
   value: "Burns Lake (CAYPZ)",
   label: "Burns Lake (CAYPZ)"
  },
  {
   value: "Burnside (CABUS)",
   label: "Burnside (CABUS)"
  },
  {
   value: "Burwash Landings (CAYDB)",
   label: "Burwash Landings (CAYDB)"
  },
  {
   value: "Butterfly Bay (CABTF)",
   label: "Butterfly Bay (CABTF)"
  },
  {
   value: "Calgary (CACAL)",
   label: "Calgary (CACAL)"
  },
  {
   value: "Cambridge (Ex Galt) (CAGAL)",
   label: "Cambridge (Ex Galt) (CAGAL)"
  },
  {
   value: "Cambridge Bay (CAYCB)",
   label: "Cambridge Bay (CAYCB)"
  },
  {
   value: "Campbell River (CACAM)",
   label: "Campbell River (CACAM)"
  },
  {
   value: "Campbellton (CACOM)",
   label: "Campbellton (CACOM)"
  },
  {
   value: "Campobello (CACPB)",
   label: "Campobello (CACPB)"
  },
  {
   value: "Baar's Corner (CABAA)",
   label: "Baar's Corner (CABAA)"
  },
  {
   value: "Baddeck (CABAD)",
   label: "Baddeck (CABAD)"
  },
  {
   value: "Bagotville (CABGT)",
   label: "Bagotville (CABGT)"
  },
  {
   value: "Bagotville Apt (CAYBG)",
   label: "Bagotville Apt (CAYBG)"
  },
  {
   value: "Baie Comeau (CABCO)",
   label: "Baie Comeau (CABCO)"
  },
  {
   value: "Baie D'urfe (CABDU)",
   label: "Baie D'urfe (CABDU)"
  },
  {
   value: "Baie Johan Beetz (CABJO)",
   label: "Baie Johan Beetz (CABJO)"
  },
  {
   value: "Baie Verte (CABVE)",
   label: "Baie Verte (CABVE)"
  },
  {
   value: "Bamberton (CABAM)",
   label: "Bamberton (CABAM)"
  },
  {
   value: "Banff (CABAF)",
   label: "Banff (CABAF)"
  },
  {
   value: "Barrie (CABAR)",
   label: "Barrie (CABAR)"
  },
  {
   value: "Barrs Corner (CABRS)",
   label: "Barrs Corner (CABRS)"
  },
  {
   value: "Bath (CABTH)",
   label: "Bath (CABTH)"
  },
  {
   value: "Bathurst (CABAT)",
   label: "Bathurst (CABAT)"
  },
  {
   value: "Batiscan (CABSN)",
   label: "Batiscan (CABSN)"
  },
  {
   value: "Bay Bulls (CABBU)",
   label: "Bay Bulls (CABBU)"
  },
  {
   value: "Bay Roberts (CABYR)",
   label: "Bay Roberts (CABYR)"
  },
  {
   value: "Bayside (CABAS)",
   label: "Bayside (CABAS)"
  },
  {
   value: "Bayside (St Roberts) (CABAY)",
   label: "Bayside (St Roberts) (CABAY)"
  },
  {
   value: "Beale Cove (CABCV)",
   label: "Beale Cove (CABCV)"
  },
  {
   value: "Beauceville (CABEU)",
   label: "Beauceville (CABEU)"
  },
  {
   value: "Beaver Cover (CABEA)",
   label: "Beaver Cover (CABEA)"
  },
  {
   value: "Beaver Harbour (CABEH)",
   label: "Beaver Harbour (CABEH)"
  },
  {
   value: "Becancour (CABEC)",
   label: "Becancour (CABEC)"
  },
  {
   value: "Bedford (CABED)",
   label: "Bedford (CABED)"
  },
  {
   value: "Bella Coola (CABLC)",
   label: "Bella Coola (CABLC)"
  },
  {
   value: "Belledune (CABEL)",
   label: "Belledune (CABEL)"
  },
  {
   value: "Belleville (CABLV)",
   label: "Belleville (CABLV)"
  },
  {
   value: "Beloeil (CABLL)",
   label: "Beloeil (CABLL)"
  },
  {
   value: "Berthierville (CABER)",
   label: "Berthierville (CABER)"
  },
  {
   value: "Black Tickle (CAYBI)",
   label: "Black Tickle (CAYBI)"
  },
  {
   value: "Blacks Harbour (CABLH)",
   label: "Blacks Harbour (CABLH)"
  },
  {
   value: "Blainville (CABLA)",
   label: "Blainville (CABLA)"
  },
  {
   value: "Blanc Sablon (CAYBX)",
   label: "Blanc Sablon (CAYBX)"
  },
  {
   value: "Blind Bay (CABBY)",
   label: "Blind Bay (CABBY)"
  },
  {
   value: "Blind River (CABLR)",
   label: "Blind River (CABLR)"
  },
  {
   value: "Bloodvein (CAYDV)",
   label: "Bloodvein (CAYDV)"
  },
  {
   value: "Blubber Bay (CABBB)",
   label: "Blubber Bay (CABBB)"
  },
  {
   value: "Blue Mountain (CABMT)",
   label: "Blue Mountain (CABMT)"
  },
  {
   value: "Bobquinn Lake (CAYBO)",
   label: "Bobquinn Lake (CAYBO)"
  },
  {
   value: "POLOCK (BYPOK)",
   label: "POLOCK (BYPOK)"
  },
  {
   value: "Belize City (BZBZE)",
   label: "Belize City (BZBZE)"
  },
  {
   value: "Colinto (BZCOL)",
   label: "Colinto (BZCOL)"
  },
  {
   value: "Corozal (BZCZH)",
   label: "Corozal (BZCZH)"
  },
  {
   value: "Melinda (BZMDB)",
   label: "Melinda (BZMDB)"
  },
  {
   value: "Orange Walk (BZORZ)",
   label: "Orange Walk (BZORZ)"
  },
  {
   value: "Punta Gorda (BZPND)",
   label: "Punta Gorda (BZPND)"
  },
  {
   value: "San Pedro (BZSPR)",
   label: "San Pedro (BZSPR)"
  },
  {
   value: "Silver Creek (BZSVK)",
   label: "Silver Creek (BZSVK)"
  },
  {
   value: "Abbotsford (CAABB)",
   label: "Abbotsford (CAABB)"
  },
  {
   value: "Acton vale (CAACV)",
   label: "Acton vale (CAACV)"
  },
  {
   value: "Adlavik (CAALK)",
   label: "Adlavik (CAALK)"
  },
  {
   value: "Agincourt (CAAGI)",
   label: "Agincourt (CAAGI)"
  },
  {
   value: "Aguathuna (Port au Port) (CAPAP)",
   label: "Aguathuna (Port au Port) (CAPAP)"
  },
  {
   value: "Ajax (CAAJX)",
   label: "Ajax (CAAJX)"
  },
  {
   value: "Alberta (CAABT)",
   label: "Alberta (CAABT)"
  },
  {
   value: "Alert Bay (CAAAL)",
   label: "Alert Bay (CAAAL)"
  },
  {
   value: "Alliston (CAAMA)",
   label: "Alliston (CAAMA)"
  },
  {
   value: "Alma (CAYTF)",
   label: "Alma (CAYTF)"
  },
  {
   value: "Alta Lake (CAYAE)",
   label: "Alta Lake (CAYAE)"
  },
  {
   value: "Alton (CAALT)",
   label: "Alton (CAALT)"
  },
  {
   value: "Amherstburg (CAAMH)",
   label: "Amherstburg (CAAMH)"
  },
  {
   value: "Amos (CAYEY)",
   label: "Amos (CAYEY)"
  },
  {
   value: "Ancaster (CAANC)",
   label: "Ancaster (CAANC)"
  },
  {
   value: "Andys Bay (CAANB)",
   label: "Andys Bay (CAANB)"
  },
  {
   value: "Angling Lake (CAYAX)",
   label: "Angling Lake (CAYAX)"
  },
  {
   value: "Arctic Bay (CAARB)",
   label: "Arctic Bay (CAARB)"
  },
  {
   value: "Argentia (CANWP)",
   label: "Argentia (CANWP)"
  },
  {
   value: "Arichat (CAARI)",
   label: "Arichat (CAARI)"
  },
  {
   value: "Armstrong (CAARM)",
   label: "Armstrong (CAARM)"
  },
  {
   value: "Arnes (CAYNR)",
   label: "Arnes (CAYNR)"
  },
  {
   value: "Arnold's Cove (CAARC)",
   label: "Arnold's Cove (CAARC)"
  },
  {
   value: "Arthabaska (CAART)",
   label: "Arthabaska (CAART)"
  },
  {
   value: "Arviat (CAYEK)",
   label: "Arviat (CAYEK)"
  },
  {
   value: "Asbestos Hill (CAYAF)",
   label: "Asbestos Hill (CAYAF)"
  },
  {
   value: "Ashcroft (CAYZA)",
   label: "Ashcroft (CAYZA)"
  },
  {
   value: "Atikokan (CAYIB)",
   label: "Atikokan (CAYIB)"
  },
  {
   value: "Attawapiskat (CAYAT)",
   label: "Attawapiskat (CAYAT)"
  },
  {
   value: "Aupauluk (CAYPJ)",
   label: "Aupauluk (CAYPJ)"
  },
  {
   value: "Aurora (CAAUR)",
   label: "Aurora (CAAUR)"
  },
  {
   value: "Avondale (CAAVO)",
   label: "Avondale (CAAVO)"
  },
  {
   value: "Aylmer (CAAYL)",
   label: "Aylmer (CAAYL)"
  },
  {
   value: "South Andros (BSTZN)",
   label: "South Andros (BSTZN)"
  },
  {
   value: "South Riding Point (BSSRP)",
   label: "South Riding Point (BSSRP)"
  },
  {
   value: "\"Spanish Wells (BSSWL)",
   label: "\"Spanish Wells (BSSWL)"
  },
  {
   value: "Spring Point (BSAXP)",
   label: "Spring Point (BSAXP)"
  },
  {
   value: "Staniel Cay (BSTYM)",
   label: "Staniel Cay (BSTYM)"
  },
  {
   value: "\"Stella Maris (BSSML)",
   label: "\"Stella Maris (BSSML)"
  },
  {
   value: "\"The Bight (BSTBI)",
   label: "\"The Bight (BSTBI)"
  },
  {
   value: "\"Treasure Cay (BSTCB)",
   label: "\"Treasure Cay (BSTCB)"
  },
  {
   value: "Walker's Cay (BSWKR)",
   label: "Walker's Cay (BSWKR)"
  },
  {
   value: "\"West End (BSWTD)",
   label: "\"West End (BSWTD)"
  },
  {
   value: "Paro (BTPBH)",
   label: "Paro (BTPBH)"
  },
  {
   value: "Phuntsholing (BTPHU)",
   label: "Phuntsholing (BTPHU)"
  },
  {
   value: "Thimbu (BTTHI)",
   label: "Thimbu (BTTHI)"
  },
  {
   value: "Francistown (BWFRW)",
   label: "Francistown (BWFRW)"
  },
  {
   value: "Gaborone (BWGBE)",
   label: "Gaborone (BWGBE)"
  },
  {
   value: "Ghanzi (BWGNZ)",
   label: "Ghanzi (BWGNZ)"
  },
  {
   value: "Hukuntsi (BWHUK)",
   label: "Hukuntsi (BWHUK)"
  },
  {
   value: "Jwaneng (BWJWA)",
   label: "Jwaneng (BWJWA)"
  },
  {
   value: "Kasane (BWBBK)",
   label: "Kasane (BWBBK)"
  },
  {
   value: "Khwai River Lodge (BWKHW)",
   label: "Khwai River Lodge (BWKHW)"
  },
  {
   value: "Lobatse (BWLOQ)",
   label: "Lobatse (BWLOQ)"
  },
  {
   value: "Maun (BWMUB)",
   label: "Maun (BWMUB)"
  },
  {
   value: "Orapa (BWORP)",
   label: "Orapa (BWORP)"
  },
  {
   value: "Ramotswa (Ngaketse) (BWRSA)",
   label: "Ramotswa (Ngaketse) (BWRSA)"
  },
  {
   value: "Savuti (BWSVT)",
   label: "Savuti (BWSVT)"
  },
  {
   value: "Selebi-Phikwe (BWPKW)",
   label: "Selebi-Phikwe (BWPKW)"
  },
  {
   value: "Shakawe (BWSWX)",
   label: "Shakawe (BWSWX)"
  },
  {
   value: "Suapan (BWSXN)",
   label: "Suapan (BWSXN)"
  },
  {
   value: "Sunnyside (BWSUN)",
   label: "Sunnyside (BWSUN)"
  },
  {
   value: "Tsabong (BWTBY)",
   label: "Tsabong (BWTBY)"
  },
  {
   value: "Tuli Lodge (BWTLD)",
   label: "Tuli Lodge (BWTLD)"
  },
  {
   value: "Brest (BYBQT)",
   label: "Brest (BYBQT)"
  },
  {
   value: "Dzerzhinsk (BYDZK)",
   label: "Dzerzhinsk (BYDZK)"
  },
  {
   value: "Gomel (BYGME)",
   label: "Gomel (BYGME)"
  },
  {
   value: "Grodna (BYGNA)",
   label: "Grodna (BYGNA)"
  },
  {
   value: "Minsk (BYMSQ)",
   label: "Minsk (BYMSQ)"
  },
  {
   value: "Mogilev (BYMVQ)",
   label: "Mogilev (BYMVQ)"
  },
  {
   value: "Svisloch (BYSVS)",
   label: "Svisloch (BYSVS)"
  },
  {
   value: "Vitebsk (BYVTB)",
   label: "Vitebsk (BYVTB)"
  },
  {
   value: "\"Cape Eleuthera (BSCEL)",
   label: "\"Cape Eleuthera (BSCEL)"
  },
  {
   value: "Cat Cays (BSCXY)",
   label: "Cat Cays (BSCXY)"
  },
  {
   value: "Cat Island (BSCAT)",
   label: "Cat Island (BSCAT)"
  },
  {
   value: "\"Chub Cay (BSCCZ)",
   label: "\"Chub Cay (BSCCZ)"
  },
  {
   value: "Clifton Point (BSCLP)",
   label: "Clifton Point (BSCLP)"
  },
  {
   value: "\"Congo Town (BSCOX)",
   label: "\"Congo Town (BSCOX)"
  },
  {
   value: "Crooked Island (BSCRI)",
   label: "Crooked Island (BSCRI)"
  },
  {
   value: "Duncan Town (BSDCT)",
   label: "Duncan Town (BSDCT)"
  },
  {
   value: "Eleuthera Island (BSELE)",
   label: "Eleuthera Island (BSELE)"
  },
  {
   value: "Exuma Island (BSEXU)",
   label: "Exuma Island (BSEXU)"
  },
  {
   value: "\"Freeport (BSFPO)",
   label: "\"Freeport (BSFPO)"
  },
  {
   value: "\"George Town (BSGGT)",
   label: "\"George Town (BSGGT)"
  },
  {
   value: "\"Governors Harbour (BSGHB)",
   label: "\"Governors Harbour (BSGHB)"
  },
  {
   value: "Grand Bahama (BSGBI)",
   label: "Grand Bahama (BSGBI)"
  },
  {
   value: "\"Great Harbour Cay (BSGHC)",
   label: "\"Great Harbour Cay (BSGHC)"
  },
  {
   value: "\"Green Turtle Cay (BSGTC)",
   label: "\"Green Turtle Cay (BSGTC)"
  },
  {
   value: "\"Harbour Island (BSHBI)",
   label: "\"Harbour Island (BSHBI)"
  },
  {
   value: "Inagua (BSIGA)",
   label: "Inagua (BSIGA)"
  },
  {
   value: "Long Island (BSLGI)",
   label: "Long Island (BSLGI)"
  },
  {
   value: "\"Marsh Harbour (BSMHH)",
   label: "\"Marsh Harbour (BSMHH)"
  },
  {
   value: "Matthew Town (BSMAT)",
   label: "Matthew Town (BSMAT)"
  },
  {
   value: "Mayaguana Island (BSMYG)",
   label: "Mayaguana Island (BSMYG)"
  },
  {
   value: "New Bight (BSNET)",
   label: "New Bight (BSNET)"
  },
  {
   value: "Norman's Cay (BSNMC)",
   label: "Norman's Cay (BSNMC)"
  },
  {
   value: "North Eleuthera (BSELH)",
   label: "North Eleuthera (BSELH)"
  },
  {
   value: "Ocean Cay (BSOCE)",
   label: "Ocean Cay (BSOCE)"
  },
  {
   value: "Paradise Island (BSPID)",
   label: "Paradise Island (BSPID)"
  },
  {
   value: "Pitts Town (BSPWN)",
   label: "Pitts Town (BSPWN)"
  },
  {
   value: "Powell Point (BSPPO)",
   label: "Powell Point (BSPPO)"
  },
  {
   value: "\"Rock Sound (BSRSD)",
   label: "\"Rock Sound (BSRSD)"
  },
  {
   value: "Rum Cay (BSRCY)",
   label: "Rum Cay (BSRCY)"
  },
  {
   value: "\"San Andros (BSSAQ)",
   label: "\"San Andros (BSSAQ)"
  },
  {
   value: "San Salvador Island (BSZSA)",
   label: "San Salvador Island (BSZSA)"
  },
  {
   value: "Seaplane Base (BSWZY)",
   label: "Seaplane Base (BSWZY)"
  },
  {
   value: "Tefe (BRTFF)",
   label: "Tefe (BRTFF)"
  },
  {
   value: "Teixeira de Freitas (BRTXF)",
   label: "Teixeira de Freitas (BRTXF)"
  },
  {
   value: "Telemaco Borba (BRTEC)",
   label: "Telemaco Borba (BRTEC)"
  },
  {
   value: "Teofilo Otoni (BRTFL)",
   label: "Teofilo Otoni (BRTFL)"
  },
  {
   value: "Teresina (BRTHE)",
   label: "Teresina (BRTHE)"
  },
  {
   value: "Terezopolis (BRQHT)",
   label: "Terezopolis (BRQHT)"
  },
  {
   value: "Termisa Terminal (BRTET)",
   label: "Termisa Terminal (BRTET)"
  },
  {
   value: "Toledo (BRTOW)",
   label: "Toledo (BRTOW)"
  },
  {
   value: "Torres (BRTSQ)",
   label: "Torres (BRTSQ)"
  },
  {
   value: "Tramandai (BRTRM)",
   label: "Tramandai (BRTRM)"
  },
  {
   value: "Tres Coracoes (BRQID)",
   label: "Tres Coracoes (BRQID)"
  },
  {
   value: "Tres Rios (BRQIH)",
   label: "Tres Rios (BRQIH)"
  },
  {
   value: "Trombetas (BRTMT)",
   label: "Trombetas (BRTMT)"
  },
  {
   value: "Tubarão (BRTUB)",
   label: "Tubarão (BRTUB)"
  },
  {
   value: "Tucuma (BRTUZ)",
   label: "Tucuma (BRTUZ)"
  },
  {
   value: "Tucurui (BRTUR)",
   label: "Tucurui (BRTUR)"
  },
  {
   value: "Tutoia (BRTUT)",
   label: "Tutoia (BRTUT)"
  },
  {
   value: "Ubatuba (BRUBT)",
   label: "Ubatuba (BRUBT)"
  },
  {
   value: "Uberaba (BRUBA)",
   label: "Uberaba (BRUBA)"
  },
  {
   value: "Uberlandia (BRUDI)",
   label: "Uberlandia (BRUDI)"
  },
  {
   value: "Umuarama (BRUMU)",
   label: "Umuarama (BRUMU)"
  },
  {
   value: "Uniao da Vitoria (BRQVB)",
   label: "Uniao da Vitoria (BRQVB)"
  },
  {
   value: "Urubupunga (BRURB)",
   label: "Urubupunga (BRURB)"
  },
  {
   value: "Uruguaiana (BRURG)",
   label: "Uruguaiana (BRURG)"
  },
  {
   value: "Valenca (BRVAL)",
   label: "Valenca (BRVAL)"
  },
  {
   value: "Varginha (BRVAG)",
   label: "Varginha (BRVAG)"
  },
  {
   value: "Videira (BRVIA)",
   label: "Videira (BRVIA)"
  },
  {
   value: "Vila Rica (BRVLP)",
   label: "Vila Rica (BRVLP)"
  },
  {
   value: "Vilhena (BRBVH)",
   label: "Vilhena (BRBVH)"
  },
  {
   value: "Viracopos Apt\/Sao Paolo (BRVCP)",
   label: "Viracopos Apt\/Sao Paolo (BRVCP)"
  },
  {
   value: "Vitoria (BRVIX)",
   label: "Vitoria (BRVIX)"
  },
  {
   value: "Vitoria da Cnquista (BRVDC)",
   label: "Vitoria da Cnquista (BRVDC)"
  },
  {
   value: "Volta Redonda (BRQVR)",
   label: "Volta Redonda (BRQVR)"
  },
  {
   value: "Votuporanga (BRVOT)",
   label: "Votuporanga (BRVOT)"
  },
  {
   value: "Xinguara (BRXIG)",
   label: "Xinguara (BRXIG)"
  },
  {
   value: "BELEM (BRBEL)",
   label: "BELEM (BRBEL)"
  },
  {
   value: "\"Andros Town (BSASD)",
   label: "\"Andros Town (BSASD)"
  },
  {
   value: "\"Arthur's Town (BSATC)",
   label: "\"Arthur's Town (BSATC)"
  },
  {
   value: "Bimini (BSBIM)",
   label: "Bimini (BSBIM)"
  },
  {
   value: "Santarem (BRSTM)",
   label: "Santarem (BRSTM)"
  },
  {
   value: "Santo Andre (BRQSE)",
   label: "Santo Andre (BRQSE)"
  },
  {
   value: "Santo Angelo (BRGEL)",
   label: "Santo Angelo (BRGEL)"
  },
  {
   value: "Santos (BRSSZ)",
   label: "Santos (BRSSZ)"
  },
  {
   value: "Sao Bente do Sul (BRQHE)",
   label: "Sao Bente do Sul (BRQHE)"
  },
  {
   value: "Sao Bernardo do Campo (BRQSB)",
   label: "Sao Bernardo do Campo (BRQSB)"
  },
  {
   value: "Sao Caetano do Sul (BRQCX)",
   label: "Sao Caetano do Sul (BRQCX)"
  },
  {
   value: "Sao Carlos (BRQSC)",
   label: "Sao Carlos (BRQSC)"
  },
  {
   value: "Sao Felix Do Araguaia (BRSXO)",
   label: "Sao Felix Do Araguaia (BRSXO)"
  },
  {
   value: "São Francisco do Sul (BRSFS)",
   label: "São Francisco do Sul (BRSFS)"
  },
  {
   value: "Sao Gabriel (BRSJL)",
   label: "Sao Gabriel (BRSJL)"
  },
  {
   value: "Sao Goncalo (BRQSD)",
   label: "Sao Goncalo (BRQSD)"
  },
  {
   value: "Sao Joao del Rei (BRQSJ)",
   label: "Sao Joao del Rei (BRQSJ)"
  },
  {
   value: "Sao Jose do Rio Preto (BRSJP)",
   label: "Sao Jose do Rio Preto (BRSJP)"
  },
  {
   value: "Sao Jose dos Campos (BRSJK)",
   label: "Sao Jose dos Campos (BRSJK)"
  },
  {
   value: "Sao Leopoldo (BRQLL)",
   label: "Sao Leopoldo (BRQLL)"
  },
  {
   value: "Sao Lourenco do Sul (BRSQY)",
   label: "Sao Lourenco do Sul (BRSQY)"
  },
  {
   value: "Sao Mateus (BRSBJ)",
   label: "Sao Mateus (BRSBJ)"
  },
  {
   value: "Sao Miguel Araguaia (BRSQM)",
   label: "Sao Miguel Araguaia (BRSQM)"
  },
  {
   value: "Sao Paulo (BRSAO)",
   label: "Sao Paulo (BRSAO)"
  },
  {
   value: "Sao Paulo-Cogonhas Apt (BRCGH)",
   label: "Sao Paulo-Cogonhas Apt (BRCGH)"
  },
  {
   value: "São Sebastião (BRSSO)",
   label: "São Sebastião (BRSSO)"
  },
  {
   value: "Sao Sebastiao do Cai (BRQHF)",
   label: "Sao Sebastiao do Cai (BRQHF)"
  },
  {
   value: "Sena Madureira (BRZMD)",
   label: "Sena Madureira (BRZMD)"
  },
  {
   value: "Senhor do Bonfim (BRSEI)",
   label: "Senhor do Bonfim (BRSEI)"
  },
  {
   value: "\"Sepetiba (BRSPB)",
   label: "\"Sepetiba (BRSPB)"
  },
  {
   value: "Serra Norte (BRRRN)",
   label: "Serra Norte (BRRRN)"
  },
  {
   value: "Serra Pelada (BRRSG)",
   label: "Serra Pelada (BRRSG)"
  },
  {
   value: "Sete Lagoas (BRQHG)",
   label: "Sete Lagoas (BRQHG)"
  },
  {
   value: "Sinop (BROPS)",
   label: "Sinop (BROPS)"
  },
  {
   value: "Sobral (BRQBX)",
   label: "Sobral (BRQBX)"
  },
  {
   value: "Sorocaba (BRSOD)",
   label: "Sorocaba (BRSOD)"
  },
  {
   value: "Soure (BRSFK)",
   label: "Soure (BRSFK)"
  },
  {
   value: "Suape (BRSUA)",
   label: "Suape (BRSUA)"
  },
  {
   value: "Suia-Missu (BRSWM)",
   label: "Suia-Missu (BRSWM)"
  },
  {
   value: "Tabatinga (BRTBT)",
   label: "Tabatinga (BRTBT)"
  },
  {
   value: "Tarauaca (BRTRQ)",
   label: "Tarauaca (BRTRQ)"
  },
  {
   value: "Porto Alegre do Nort (BRPBX)",
   label: "Porto Alegre do Nort (BRPBX)"
  },
  {
   value: "Porto de Moz (BRPTQ)",
   label: "Porto de Moz (BRPTQ)"
  },
  {
   value: "Porto dos Gauchos (BRPBV)",
   label: "Porto dos Gauchos (BRPBV)"
  },
  {
   value: "Porto Nacional (BRPNB)",
   label: "Porto Nacional (BRPNB)"
  },
  {
   value: "Porto Seguro (BRBPS)",
   label: "Porto Seguro (BRBPS)"
  },
  {
   value: "Pôrto Velho (BRPVH)",
   label: "Pôrto Velho (BRPVH)"
  },
  {
   value: "Portocel (BRPCL)",
   label: "Portocel (BRPCL)"
  },
  {
   value: "Pouso Alegre (BRPPY)",
   label: "Pouso Alegre (BRPPY)"
  },
  {
   value: "Prado (BRPDF)",
   label: "Prado (BRPDF)"
  },
  {
   value: "Presidente Dutra (BRPDR)",
   label: "Presidente Dutra (BRPDR)"
  },
  {
   value: "Presidente Prudente (BRPPB)",
   label: "Presidente Prudente (BRPPB)"
  },
  {
   value: "Progresso (BRPGG)",
   label: "Progresso (BRPGG)"
  },
  {
   value: "Recife (BRREC)",
   label: "Recife (BRREC)"
  },
  {
   value: "Redencao (BRRDC)",
   label: "Redencao (BRRDC)"
  },
  {
   value: "Resende (BRQRZ)",
   label: "Resende (BRQRZ)"
  },
  {
   value: "Ribeirao Preto (BRRAO)",
   label: "Ribeirao Preto (BRRAO)"
  },
  {
   value: "Rio Branco (BRRBR)",
   label: "Rio Branco (BRRBR)"
  },
  {
   value: "Rio de Janeiro (BRRIO)",
   label: "Rio de Janeiro (BRRIO)"
  },
  {
   value: "Rio De Janeiro-Internacional Apt (BRGIG)",
   label: "Rio De Janeiro-Internacional Apt (BRGIG)"
  },
  {
   value: "Rio De Janeiro-Santos Dumont Apt (BRSDU)",
   label: "Rio De Janeiro-Santos Dumont Apt (BRSDU)"
  },
  {
   value: "Rio do Sul (BRQRU)",
   label: "Rio do Sul (BRQRU)"
  },
  {
   value: "Rio Grande (BRRIG)",
   label: "Rio Grande (BRRIG)"
  },
  {
   value: "Rio Negrinho (BRQNE)",
   label: "Rio Negrinho (BRQNE)"
  },
  {
   value: "Rio Verde (BRRVD)",
   label: "Rio Verde (BRRVD)"
  },
  {
   value: "Rondonopolis (BRROO)",
   label: "Rondonopolis (BRROO)"
  },
  {
   value: "Saã Luiz (BRSLZ)",
   label: "Saã Luiz (BRSLZ)"
  },
  {
   value: "Salvador (BRSSA)",
   label: "Salvador (BRSSA)"
  },
  {
   value: "Salvaterra (BRSLV)",
   label: "Salvaterra (BRSLV)"
  },
  {
   value: "Santa Cruz (BRSNZ)",
   label: "Santa Cruz (BRSNZ)"
  },
  {
   value: "Santa Fe do Sul (BRSFV)",
   label: "Santa Fe do Sul (BRSFV)"
  },
  {
   value: "Santa Isabel do Morro (BRIDO)",
   label: "Santa Isabel do Morro (BRIDO)"
  },
  {
   value: "Santa Maria (BRRIA)",
   label: "Santa Maria (BRRIA)"
  },
  {
   value: "Santa Rosa (BRSRA)",
   label: "Santa Rosa (BRSRA)"
  },
  {
   value: "Santa Terezinha (BRSTZ)",
   label: "Santa Terezinha (BRSTZ)"
  },
  {
   value: "Santa Vitoria (BRCTQ)",
   label: "Santa Vitoria (BRCTQ)"
  },
  {
   value: "Santana (BRSAN)",
   label: "Santana (BRSAN)"
  },
  {
   value: "Santana Do Araguaia (BRCMP)",
   label: "Santana Do Araguaia (BRCMP)"
  },
  {
   value: "Niquelandia (BRNQL)",
   label: "Niquelandia (BRNQL)"
  },
  {
   value: "Niteroi (BRNTR)",
   label: "Niteroi (BRNTR)"
  },
  {
   value: "Nova Xavantina (BRNOK)",
   label: "Nova Xavantina (BRNOK)"
  },
  {
   value: "Novo Aripuana (BRNVP)",
   label: "Novo Aripuana (BRNVP)"
  },
  {
   value: "Novo Hamburgo (BRQHV)",
   label: "Novo Hamburgo (BRQHV)"
  },
  {
   value: "Obidos (BROBI)",
   label: "Obidos (BROBI)"
  },
  {
   value: "Oiapoque (BROYK)",
   label: "Oiapoque (BROYK)"
  },
  {
   value: "Oriximina (BRORX)",
   label: "Oriximina (BRORX)"
  },
  {
   value: "Osasco (BRQOC)",
   label: "Osasco (BRQOC)"
  },
  {
   value: "Ourinhos (BROUS)",
   label: "Ourinhos (BROUS)"
  },
  {
   value: "Palmas (BRPMW)",
   label: "Palmas (BRPMW)"
  },
  {
   value: "Pampulha (BRPLU)",
   label: "Pampulha (BRPLU)"
  },
  {
   value: "Paranagua (BRPNG)",
   label: "Paranagua (BRPNG)"
  },
  {
   value: "Paranavai (BRPVI)",
   label: "Paranavai (BRPVI)"
  },
  {
   value: "Parintins (BRPIN)",
   label: "Parintins (BRPIN)"
  },
  {
   value: "Parnaiba (BRPHB)",
   label: "Parnaiba (BRPHB)"
  },
  {
   value: "Passo Fundo (BRPFB)",
   label: "Passo Fundo (BRPFB)"
  },
  {
   value: "Passos (BRPSW)",
   label: "Passos (BRPSW)"
  },
  {
   value: "Pato Branco (BRPTO)",
   label: "Pato Branco (BRPTO)"
  },
  {
   value: "Paulo Afonso (BRPAV)",
   label: "Paulo Afonso (BRPAV)"
  },
  {
   value: "Pelotas (BRPET)",
   label: "Pelotas (BRPET)"
  },
  {
   value: "Petrolina (BRPNZ)",
   label: "Petrolina (BRPNZ)"
  },
  {
   value: "Petropolis (BRQPE)",
   label: "Petropolis (BRQPE)"
  },
  {
   value: "Picos (BRPCS)",
   label: "Picos (BRPCS)"
  },
  {
   value: "Pimenta Bueno (BRPBQ)",
   label: "Pimenta Bueno (BRPBQ)"
  },
  {
   value: "Pimentel (BRPEL)",
   label: "Pimentel (BRPEL)"
  },
  {
   value: "Pinheiro (BRPHI)",
   label: "Pinheiro (BRPHI)"
  },
  {
   value: "Piracicaba (BRQHB)",
   label: "Piracicaba (BRQHB)"
  },
  {
   value: "Pirapora (BRPIV)",
   label: "Pirapora (BRPIV)"
  },
  {
   value: "Pirassununga (BRQPS)",
   label: "Pirassununga (BRQPS)"
  },
  {
   value: "Pitinga (BRPIG)",
   label: "Pitinga (BRPIG)"
  },
  {
   value: "Pocos de Caldas (BRPOO)",
   label: "Pocos de Caldas (BRPOO)"
  },
  {
   value: "Ponta da Madeira (BRPMA)",
   label: "Ponta da Madeira (BRPMA)"
  },
  {
   value: "Ponta do Ubu (BRPOU)",
   label: "Ponta do Ubu (BRPOU)"
  },
  {
   value: "Ponta Grossa (BRPGZ)",
   label: "Ponta Grossa (BRPGZ)"
  },
  {
   value: "Ponta Pelada (BRPLL)",
   label: "Ponta Pelada (BRPLL)"
  },
  {
   value: "Ponta Pora (BRPMG)",
   label: "Ponta Pora (BRPMG)"
  },
  {
   value: "Pontes E Lacerda (BRLCB)",
   label: "Pontes E Lacerda (BRLCB)"
  },
  {
   value: "Pôrto Alegre (BRPOA)",
   label: "Pôrto Alegre (BRPOA)"
  },
  {
   value: "Juara (BRJUA)",
   label: "Juara (BRJUA)"
  },
  {
   value: "Juazeiro do Norte (BRJDO)",
   label: "Juazeiro do Norte (BRJDO)"
  },
  {
   value: "Juina (BRJIA)",
   label: "Juina (BRJIA)"
  },
  {
   value: "Juiz de For a (BRJDF)",
   label: "Juiz de For a (BRJDF)"
  },
  {
   value: "Juruena (BRJRN)",
   label: "Juruena (BRJRN)"
  },
  {
   value: "Labrea (BRLBR)",
   label: "Labrea (BRLBR)"
  },
  {
   value: "Lages (BRLAJ)",
   label: "Lages (BRLAJ)"
  },
  {
   value: "Lajeado (BRQLB)",
   label: "Lajeado (BRQLB)"
  },
  {
   value: "Lencois Paulista (BRQGC)",
   label: "Lencois Paulista (BRQGC)"
  },
  {
   value: "Leopoldina (BRLEP)",
   label: "Leopoldina (BRLEP)"
  },
  {
   value: "Lins (BRLIP)",
   label: "Lins (BRLIP)"
  },
  {
   value: "Livramento (BRLVB)",
   label: "Livramento (BRLVB)"
  },
  {
   value: "Londrina (BRLDB)",
   label: "Londrina (BRLDB)"
  },
  {
   value: "Lontras (BRLOI)",
   label: "Lontras (BRLOI)"
  },
  {
   value: "Macae (BRMEA)",
   label: "Macae (BRMEA)"
  },
  {
   value: "Macapa (BRMCP)",
   label: "Macapa (BRMCP)"
  },
  {
   value: "Macau (BRMCU)",
   label: "Macau (BRMCU)"
  },
  {
   value: "Maceio (BRMCZ)",
   label: "Maceio (BRMCZ)"
  },
  {
   value: "Madre De Deus (BRMDD)",
   label: "Madre De Deus (BRMDD)"
  },
  {
   value: "Mafra (BRQMF)",
   label: "Mafra (BRQMF)"
  },
  {
   value: "Manaus (BRMAO)",
   label: "Manaus (BRMAO)"
  },
  {
   value: "Manicore (BRMNX)",
   label: "Manicore (BRMNX)"
  },
  {
   value: "Maraba (BRMAB)",
   label: "Maraba (BRMAB)"
  },
  {
   value: "Marilia (BRMII)",
   label: "Marilia (BRMII)"
  },
  {
   value: "Maringa (BRMGF)",
   label: "Maringa (BRMGF)"
  },
  {
   value: "Mato Grosso (BRMTG)",
   label: "Mato Grosso (BRMTG)"
  },
  {
   value: "Matupa (BRMBK)",
   label: "Matupa (BRMBK)"
  },
  {
   value: "Maues (BRMBZ)",
   label: "Maues (BRMBZ)"
  },
  {
   value: "Minacu (BRMQH)",
   label: "Minacu (BRMQH)"
  },
  {
   value: "Miracema do Norte (BRNTM)",
   label: "Miracema do Norte (BRNTM)"
  },
  {
   value: "Mogi das Cruzes (BRQMI)",
   label: "Mogi das Cruzes (BRQMI)"
  },
  {
   value: "Monte Alegre (BRMTE)",
   label: "Monte Alegre (BRMTE)"
  },
  {
   value: "Monte Dourado (BRMEU)",
   label: "Monte Dourado (BRMEU)"
  },
  {
   value: "Monte Negro (BRQGF)",
   label: "Monte Negro (BRQGF)"
  },
  {
   value: "Montes Claros (BRMOC)",
   label: "Montes Claros (BRMOC)"
  },
  {
   value: "Mossoro (BRMVF)",
   label: "Mossoro (BRMVF)"
  },
  {
   value: "Mucuri (BRMVS)",
   label: "Mucuri (BRMVS)"
  },
  {
   value: "Munguba (BRMGU)",
   label: "Munguba (BRMGU)"
  },
  {
   value: "Nanuque (BRNNU)",
   label: "Nanuque (BRNNU)"
  },
  {
   value: "Natal (BRNAT)",
   label: "Natal (BRNAT)"
  },
  {
   value: "Navegantes (BRNVT)",
   label: "Navegantes (BRNVT)"
  },
  {
   value: "Guajara Mirim (BRGJM)",
   label: "Guajara Mirim (BRGJM)"
  },
  {
   value: "Guanambi (BRGNM)",
   label: "Guanambi (BRGNM)"
  },
  {
   value: "Guarapari (BRQDL)",
   label: "Guarapari (BRQDL)"
  },
  {
   value: "Guarapuava (BRGPB)",
   label: "Guarapuava (BRGPB)"
  },
  {
   value: "Guaratingueta (BRGUJ)",
   label: "Guaratingueta (BRGUJ)"
  },
  {
   value: "Guarulhos Apt\/Sao Paolo (BRGRU)",
   label: "Guarulhos Apt\/Sao Paolo (BRGRU)"
  },
  {
   value: "Guimaraes (BRGMS)",
   label: "Guimaraes (BRGMS)"
  },
  {
   value: "Gurupi (BRGRP)",
   label: "Gurupi (BRGRP)"
  },
  {
   value: "Icoaraci (BRQDO)",
   label: "Icoaraci (BRQDO)"
  },
  {
   value: "Iguassu Falls (BRIGU)",
   label: "Iguassu Falls (BRIGU)"
  },
  {
   value: "Iguatu (BRQIG)",
   label: "Iguatu (BRQIG)"
  },
  {
   value: "Ijui (BRIJU)",
   label: "Ijui (BRIJU)"
  },
  {
   value: "Ilha Solteira (BRILB)",
   label: "Ilha Solteira (BRILB)"
  },
  {
   value: "Ilheus (BRIOS)",
   label: "Ilheus (BRIOS)"
  },
  {
   value: "Imbituba (BRIBB)",
   label: "Imbituba (BRIBB)"
  },
  {
   value: "Imperatriz (BRIMP)",
   label: "Imperatriz (BRIMP)"
  },
  {
   value: "Ipatinga (BRIPN)",
   label: "Ipatinga (BRIPN)"
  },
  {
   value: "Ipiau (BRIPU)",
   label: "Ipiau (BRIPU)"
  },
  {
   value: "Ipiranga (BRIPG)",
   label: "Ipiranga (BRIPG)"
  },
  {
   value: "Irece (BRIRE)",
   label: "Irece (BRIRE)"
  },
  {
   value: "Itabuna (BRITN)",
   label: "Itabuna (BRITN)"
  },
  {
   value: "Itacoatiara (BRITA)",
   label: "Itacoatiara (BRITA)"
  },
  {
   value: "Itaituba (BRITB)",
   label: "Itaituba (BRITB)"
  },
  {
   value: "Itajai (BRITJ)",
   label: "Itajai (BRITJ)"
  },
  {
   value: "Itambacuri (BRITI)",
   label: "Itambacuri (BRITI)"
  },
  {
   value: "Itaqui (BRITQ)",
   label: "Itaqui (BRITQ)"
  },
  {
   value: "Itatiba (BRIIA)",
   label: "Itatiba (BRIIA)"
  },
  {
   value: "Itauba (BRAUB)",
   label: "Itauba (BRAUB)"
  },
  {
   value: "Itubera (BRITE)",
   label: "Itubera (BRITE)"
  },
  {
   value: "Jacareacanga (BRJCR)",
   label: "Jacareacanga (BRJCR)"
  },
  {
   value: "Jacobina (BRJCM)",
   label: "Jacobina (BRJCM)"
  },
  {
   value: "Jales (BRJLS)",
   label: "Jales (BRJLS)"
  },
  {
   value: "Januaria (BRJNA)",
   label: "Januaria (BRJNA)"
  },
  {
   value: "Jaragua do Sul (BRQJA)",
   label: "Jaragua do Sul (BRQJA)"
  },
  {
   value: "Jatai (BRJTI)",
   label: "Jatai (BRJTI)"
  },
  {
   value: "Jequie (BRJEQ)",
   label: "Jequie (BRJEQ)"
  },
  {
   value: "Ji-Parana (BRJPR)",
   label: "Ji-Parana (BRJPR)"
  },
  {
   value: "Joacaba (BRJCB)",
   label: "Joacaba (BRJCB)"
  },
  {
   value: "Joao Pessoa (BRJPA)",
   label: "Joao Pessoa (BRJPA)"
  },
  {
   value: "Joinville (BRJOI)",
   label: "Joinville (BRJOI)"
  },
  {
   value: "Concordia (BRCCI)",
   label: "Concordia (BRCCI)"
  },
  {
   value: "Confins International (BRCNF)",
   label: "Confins International (BRCNF)"
  },
  {
   value: "Confreza (BRCFO)",
   label: "Confreza (BRCFO)"
  },
  {
   value: "Conselheiro Lafaiete (BRQDF)",
   label: "Conselheiro Lafaiete (BRQDF)"
  },
  {
   value: "Cornelio Procopio (BRCKO)",
   label: "Cornelio Procopio (BRCKO)"
  },
  {
   value: "Corumba (BRCMG)",
   label: "Corumba (BRCMG)"
  },
  {
   value: "Costa Marques (BRCQS)",
   label: "Costa Marques (BRCQS)"
  },
  {
   value: "Crisciuma (BRCCM)",
   label: "Crisciuma (BRCCM)"
  },
  {
   value: "Cruz Alta (BRCZB)",
   label: "Cruz Alta (BRCZB)"
  },
  {
   value: "Cruzeiro do Sul (BRCZS)",
   label: "Cruzeiro do Sul (BRCZS)"
  },
  {
   value: "Cuiaba (BRCGB)",
   label: "Cuiaba (BRCGB)"
  },
  {
   value: "Curitiba (BRCWB)",
   label: "Curitiba (BRCWB)"
  },
  {
   value: "Currais Novos (BRQCP)",
   label: "Currais Novos (BRQCP)"
  },
  {
   value: "Cururupu (BRCPU)",
   label: "Cururupu (BRCPU)"
  },
  {
   value: "Diamantino (BRDMT)",
   label: "Diamantino (BRDMT)"
  },
  {
   value: "Dianopolis (BRDNO)",
   label: "Dianopolis (BRDNO)"
  },
  {
   value: "Divinopolis (BRDIQ)",
   label: "Divinopolis (BRDIQ)"
  },
  {
   value: "Dom Pedrito (BRQDP)",
   label: "Dom Pedrito (BRQDP)"
  },
  {
   value: "Dourados (BRDOU)",
   label: "Dourados (BRDOU)"
  },
  {
   value: "Dracena (BRQDC)",
   label: "Dracena (BRQDC)"
  },
  {
   value: "Duque de Caxias (BRQDQ)",
   label: "Duque de Caxias (BRQDQ)"
  },
  {
   value: "Eirunepe (BRERN)",
   label: "Eirunepe (BRERN)"
  },
  {
   value: "Erechim (BRERM)",
   label: "Erechim (BRERM)"
  },
  {
   value: "Espinosa (BRESI)",
   label: "Espinosa (BRESI)"
  },
  {
   value: "Feijo (BRFEJ)",
   label: "Feijo (BRFEJ)"
  },
  {
   value: "Feira de Santana (BRFEC)",
   label: "Feira de Santana (BRFEC)"
  },
  {
   value: "Fernando de Noronha (BRFEN)",
   label: "Fernando de Noronha (BRFEN)"
  },
  {
   value: "Floriano (BRFLB)",
   label: "Floriano (BRFLB)"
  },
  {
   value: "Florianopolis (BRFLN)",
   label: "Florianopolis (BRFLN)"
  },
  {
   value: "Forno (BRFNO)",
   label: "Forno (BRFNO)"
  },
  {
   value: "Fortaleza (BRFOR)",
   label: "Fortaleza (BRFOR)"
  },
  {
   value: "Franca (BRFRC)",
   label: "Franca (BRFRC)"
  },
  {
   value: "Francisco Beltrao (BRFBE)",
   label: "Francisco Beltrao (BRFBE)"
  },
  {
   value: "Gebig (BRGEB)",
   label: "Gebig (BRGEB)"
  },
  {
   value: "Goiania (BRGYN)",
   label: "Goiania (BRGYN)"
  },
  {
   value: "Governador Valadares (BRGVR)",
   label: "Governador Valadares (BRGVR)"
  },
  {
   value: "Gramado (BRQRP)",
   label: "Gramado (BRQRP)"
  },
  {
   value: "Guadalupe (BRGDP)",
   label: "Guadalupe (BRGDP)"
  },
  {
   value: "Guaira (BRQGA)",
   label: "Guaira (BRQGA)"
  },
  {
   value: "Brusque (BRQAB)",
   label: "Brusque (BRQAB)"
  },
  {
   value: "Buzios (BRBZC)",
   label: "Buzios (BRBZC)"
  },
  {
   value: "Cabedelo (BRCDO)",
   label: "Cabedelo (BRCDO)"
  },
  {
   value: "Cabo Frio (BRQCK)",
   label: "Cabo Frio (BRQCK)"
  },
  {
   value: "Caceres (BRCCX)",
   label: "Caceres (BRCCX)"
  },
  {
   value: "Cachoeira (BRCCQ)",
   label: "Cachoeira (BRCCQ)"
  },
  {
   value: "Cachoeira do Sul (BRQDB)",
   label: "Cachoeira do Sul (BRQDB)"
  },
  {
   value: "Cacoal (BROAL)",
   label: "Cacoal (BROAL)"
  },
  {
   value: "Caldas Novas (BRCLV)",
   label: "Caldas Novas (BRCLV)"
  },
  {
   value: "Camacari (BRQCC)",
   label: "Camacari (BRQCC)"
  },
  {
   value: "Camocim (BRCMC)",
   label: "Camocim (BRCMC)"
  },
  {
   value: "Campina Grande (BRCPV)",
   label: "Campina Grande (BRCPV)"
  },
  {
   value: "Campinas (BRCPQ)",
   label: "Campinas (BRCPQ)"
  },
  {
   value: "Campo Bom (BRQCD)",
   label: "Campo Bom (BRQCD)"
  },
  {
   value: "Campo Grande (BRCGR)",
   label: "Campo Grande (BRCGR)"
  },
  {
   value: "Campo Limpo Paulista (BRCLP)",
   label: "Campo Limpo Paulista (BRCLP)"
  },
  {
   value: "Campo Mourao (BRCBW)",
   label: "Campo Mourao (BRCBW)"
  },
  {
   value: "Campos (BRCAW)",
   label: "Campos (BRCAW)"
  },
  {
   value: "Campos do Jordao (BRQJO)",
   label: "Campos do Jordao (BRQJO)"
  },
  {
   value: "Cana Brava (BRNBV)",
   label: "Cana Brava (BRNBV)"
  },
  {
   value: "Canavieiras (BRCNV)",
   label: "Canavieiras (BRCNV)"
  },
  {
   value: "Canela (BRQCN)",
   label: "Canela (BRQCN)"
  },
  {
   value: "Canoas (BRQNS)",
   label: "Canoas (BRQNS)"
  },
  {
   value: "Carajas (BRCKS)",
   label: "Carajas (BRCKS)"
  },
  {
   value: "Carauari (BRCAF)",
   label: "Carauari (BRCAF)"
  },
  {
   value: "Caravelas (BRCRQ)",
   label: "Caravelas (BRCRQ)"
  },
  {
   value: "Carolina (BRCLN)",
   label: "Carolina (BRCLN)"
  },
  {
   value: "Caruaru (BRCAU)",
   label: "Caruaru (BRCAU)"
  },
  {
   value: "Carutapera (BRCTP)",
   label: "Carutapera (BRCTP)"
  },
  {
   value: "Cascavel (BRCAC)",
   label: "Cascavel (BRCAC)"
  },
  {
   value: "Cassilandia (BRCSS)",
   label: "Cassilandia (BRCSS)"
  },
  {
   value: "Castanhal (BRQHL)",
   label: "Castanhal (BRQHL)"
  },
  {
   value: "Cataguases (BRQCG)",
   label: "Cataguases (BRQCG)"
  },
  {
   value: "Catalao (BRTLZ)",
   label: "Catalao (BRTLZ)"
  },
  {
   value: "Caxias do Sul (BRCXJ)",
   label: "Caxias do Sul (BRCXJ)"
  },
  {
   value: "Chapeco (BRXAP)",
   label: "Chapeco (BRXAP)"
  },
  {
   value: "Coari (BRCIZ)",
   label: "Coari (BRCIZ)"
  },
  {
   value: "Colorado do Oeste (BRCSW)",
   label: "Colorado do Oeste (BRCSW)"
  },
  {
   value: "Conceicao do Araguaia (BRCDJ)",
   label: "Conceicao do Araguaia (BRCDJ)"
  },
  {
   value: "Alto Parnaiba (BRAPY)",
   label: "Alto Parnaiba (BRAPY)"
  },
  {
   value: "Ananindeua (BRANA)",
   label: "Ananindeua (BRANA)"
  },
  {
   value: "Anapolis (BRAPS)",
   label: "Anapolis (BRAPS)"
  },
  {
   value: "Angra dos Reis (BRADR)",
   label: "Angra dos Reis (BRADR)"
  },
  {
   value: "Antonina (BRANT)",
   label: "Antonina (BRANT)"
  },
  {
   value: "Apucarana (BRAPU)",
   label: "Apucarana (BRAPU)"
  },
  {
   value: "Aracaju (BRAJU)",
   label: "Aracaju (BRAJU)"
  },
  {
   value: "Aractuba (BRARU)",
   label: "Aractuba (BRARU)"
  },
  {
   value: "Aragarcas (BRARS)",
   label: "Aragarcas (BRARS)"
  },
  {
   value: "Araguaina (BRAUX)",
   label: "Araguaina (BRAUX)"
  },
  {
   value: "Arapiraca (BRAPQ)",
   label: "Arapiraca (BRAPQ)"
  },
  {
   value: "Arapongas (BRAPX)",
   label: "Arapongas (BRAPX)"
  },
  {
   value: "Arapoti (BRAAG)",
   label: "Arapoti (BRAAG)"
  },
  {
   value: "Araraquara (BRAQA)",
   label: "Araraquara (BRAQA)"
  },
  {
   value: "Aratu (BRARB)",
   label: "Aratu (BRARB)"
  },
  {
   value: "Araxa (BRAAX)",
   label: "Araxa (BRAAX)"
  },
  {
   value: "Aripuana (BRAIR)",
   label: "Aripuana (BRAIR)"
  },
  {
   value: "Ariquemes (BRAQM)",
   label: "Ariquemes (BRAQM)"
  },
  {
   value: "Arraias (BRAAI)",
   label: "Arraias (BRAAI)"
  },
  {
   value: "Assis (BRAIF)",
   label: "Assis (BRAIF)"
  },
  {
   value: "Bage (BRBGX)",
   label: "Bage (BRBGX)"
  },
  {
   value: "Balsas (BRBSS)",
   label: "Balsas (BRBSS)"
  },
  {
   value: "Barbelos (BRBAZ)",
   label: "Barbelos (BRBAZ)"
  },
  {
   value: "Barra (BRBQQ)",
   label: "Barra (BRBQQ)"
  },
  {
   value: "Barra Do Garcas (BRBPG)",
   label: "Barra Do Garcas (BRBPG)"
  },
  {
   value: "Barreiras (BRBRA)",
   label: "Barreiras (BRBRA)"
  },
  {
   value: "Barretos (BRBAT)",
   label: "Barretos (BRBAT)"
  },
  {
   value: "Bauru (BRBAU)",
   label: "Bauru (BRBAU)"
  },
  {
   value: "Belo Horizonte (BRBHZ)",
   label: "Belo Horizonte (BRBHZ)"
  },
  {
   value: "Benjamin Constant (BRQAV)",
   label: "Benjamin Constant (BRQAV)"
  },
  {
   value: "Bento Goncalves (BRBGV)",
   label: "Bento Goncalves (BRBGV)"
  },
  {
   value: "Birigui (BRQCF)",
   label: "Birigui (BRQCF)"
  },
  {
   value: "Blumenau (BRBNU)",
   label: "Blumenau (BRBNU)"
  },
  {
   value: "Boa Vista (BRBVB)",
   label: "Boa Vista (BRBVB)"
  },
  {
   value: "Bom Jesus Da Lapa (BRLAZ)",
   label: "Bom Jesus Da Lapa (BRLAZ)"
  },
  {
   value: "Borba (BRRBB)",
   label: "Borba (BRRBB)"
  },
  {
   value: "Botucatu (BRQCJ)",
   label: "Botucatu (BRQCJ)"
  },
  {
   value: "Brasilia (BRBSB)",
   label: "Brasilia (BRBSB)"
  },
  {
   value: "Breves (BRBVS)",
   label: "Breves (BRBVS)"
  },
  {
   value: "Brumado (BRBMS)",
   label: "Brumado (BRBMS)"
  },
  {
   value: "Cochabamba (BOCBB)",
   label: "Cochabamba (BOCBB)"
  },
  {
   value: "Concepcion (BOCEP)",
   label: "Concepcion (BOCEP)"
  },
  {
   value: "Guaqui (BOGUQ)",
   label: "Guaqui (BOGUQ)"
  },
  {
   value: "Guayaramerin (BOGYA)",
   label: "Guayaramerin (BOGYA)"
  },
  {
   value: "Huacaraje (BOBVK)",
   label: "Huacaraje (BOBVK)"
  },
  {
   value: "La Paz (BOLPB)",
   label: "La Paz (BOLPB)"
  },
  {
   value: "Magdalena (BOMGD)",
   label: "Magdalena (BOMGD)"
  },
  {
   value: "Oruro (BOORU)",
   label: "Oruro (BOORU)"
  },
  {
   value: "Potosi (BOPOI)",
   label: "Potosi (BOPOI)"
  },
  {
   value: "Puerto Busch (BOPBU)",
   label: "Puerto Busch (BOPBU)"
  },
  {
   value: "Puerto Rico (BOPUR)",
   label: "Puerto Rico (BOPUR)"
  },
  {
   value: "Puerto Suarez (BOPSZ)",
   label: "Puerto Suarez (BOPSZ)"
  },
  {
   value: "Reyes (BOREY)",
   label: "Reyes (BOREY)"
  },
  {
   value: "Riberalta (BORIB)",
   label: "Riberalta (BORIB)"
  },
  {
   value: "Robore (BORBO)",
   label: "Robore (BORBO)"
  },
  {
   value: "Rurrenabaque (BORBQ)",
   label: "Rurrenabaque (BORBQ)"
  },
  {
   value: "San Borja (BOSRJ)",
   label: "San Borja (BOSRJ)"
  },
  {
   value: "San Ignacio de M (BOSNM)",
   label: "San Ignacio de M (BOSNM)"
  },
  {
   value: "San Ignacio de Velasco (BOSNG)",
   label: "San Ignacio de Velasco (BOSNG)"
  },
  {
   value: "San Javier (BOSJV)",
   label: "San Javier (BOSJV)"
  },
  {
   value: "San Joaquin (BOSJB)",
   label: "San Joaquin (BOSJB)"
  },
  {
   value: "San Jose (BOSJS)",
   label: "San Jose (BOSJS)"
  },
  {
   value: "San Ramon (BOSRD)",
   label: "San Ramon (BOSRD)"
  },
  {
   value: "Santa Ana (BOSBL)",
   label: "Santa Ana (BOSBL)"
  },
  {
   value: "Santa Cruz (BOSRZ)",
   label: "Santa Cruz (BOSRZ)"
  },
  {
   value: "Santa Rosa (BOSRB)",
   label: "Santa Rosa (BOSRB)"
  },
  {
   value: "Sucre (BOSRE)",
   label: "Sucre (BOSRE)"
  },
  {
   value: "Tarija (BOTJA)",
   label: "Tarija (BOTJA)"
  },
  {
   value: "Trinidad (BOTDD)",
   label: "Trinidad (BOTDD)"
  },
  {
   value: "Vallegrande (BOVAH)",
   label: "Vallegrande (BOVAH)"
  },
  {
   value: "Villamontes (BOVLM)",
   label: "Villamontes (BOVLM)"
  },
  {
   value: "Viru Viru Intl (BOVVI)",
   label: "Viru Viru Intl (BOVVI)"
  },
  {
   value: "Yacuiba (BOBYC)",
   label: "Yacuiba (BOBYC)"
  },
  {
   value: "Afua (BRAFU)",
   label: "Afua (BRAFU)"
  },
  {
   value: "Alcantara (BRQAH)",
   label: "Alcantara (BRQAH)"
  },
  {
   value: "Alegrete (BRALQ)",
   label: "Alegrete (BRALQ)"
  },
  {
   value: "Alenquer (BRALT)",
   label: "Alenquer (BRALT)"
  },
  {
   value: "Almenara (BRAMJ)",
   label: "Almenara (BRAMJ)"
  },
  {
   value: "Alta Floresta (BRAFL)",
   label: "Alta Floresta (BRAFL)"
  },
  {
   value: "Altamira (BRATM)",
   label: "Altamira (BRATM)"
  },
  {
   value: "Varna-Zapad (BGVAZ)",
   label: "Varna-Zapad (BGVAZ)"
  },
  {
   value: "Veliko Tarnovo (BGVTT)",
   label: "Veliko Tarnovo (BGVTT)"
  },
  {
   value: "Velingrad (BGVLE)",
   label: "Velingrad (BGVLE)"
  },
  {
   value: "Vidin (BGVID)",
   label: "Vidin (BGVID)"
  },
  {
   value: "Vraca (BGVRE)",
   label: "Vraca (BGVRE)"
  },
  {
   value: "Vraschka Tchuka (BGVTC)",
   label: "Vraschka Tchuka (BGVTC)"
  },
  {
   value: "Zlatarevo (BGZLA)",
   label: "Zlatarevo (BGZLA)"
  },
  {
   value: "Zlatograd (BGZLH)",
   label: "Zlatograd (BGZLH)"
  },
  {
   value: "Al Mutae (BHRAS)",
   label: "Al Mutae (BHRAS)"
  },
  {
   value: "Bahrain (BHBAH)",
   label: "Bahrain (BHBAH)"
  },
  {
   value: "Manama (BHMAN)",
   label: "Manama (BHMAN)"
  },
  {
   value: "Mina Sulman (BHMIN)",
   label: "Mina Sulman (BHMIN)"
  },
  {
   value: "Sitra (BHSIT)",
   label: "Sitra (BHSIT)"
  },
  {
   value: "Bujumbura (BIBJM)",
   label: "Bujumbura (BIBJM)"
  },
  {
   value: "Gitega (BIGID)",
   label: "Gitega (BIGID)"
  },
  {
   value: "Kirundo (BIKRE)",
   label: "Kirundo (BIKRE)"
  },
  {
   value: "Cotonou (BJCOO)",
   label: "Cotonou (BJCOO)"
  },
  {
   value: "Djougou (BJDJA)",
   label: "Djougou (BJDJA)"
  },
  {
   value: "Kandi (BJKDC)",
   label: "Kandi (BJKDC)"
  },
  {
   value: "Natitingou (BJNAE)",
   label: "Natitingou (BJNAE)"
  },
  {
   value: "Parakou (BJPKO)",
   label: "Parakou (BJPKO)"
  },
  {
   value: "Port Novo (BJPTN)",
   label: "Port Novo (BJPTN)"
  },
  {
   value: "Save (BJSVF)",
   label: "Save (BJSVF)"
  },
  {
   value: "Seme Terminal (BJSEM)",
   label: "Seme Terminal (BJSEM)"
  },
  {
   value: "Freeport (BMFPT)",
   label: "Freeport (BMFPT)"
  },
  {
   value: "Hamilton (BMBDA)",
   label: "Hamilton (BMBDA)"
  },
  {
   value: "Harbor Island (BMHBI)",
   label: "Harbor Island (BMHBI)"
  },
  {
   value: "St Georges (BMSGE)",
   label: "St Georges (BMSGE)"
  },
  {
   value: "Bandar Seri Begawan (BNBWN)",
   label: "Bandar Seri Begawan (BNBWN)"
  },
  {
   value: "Brunei Town (BNBTN)",
   label: "Brunei Town (BNBTN)"
  },
  {
   value: "Kuala Belait (BNKUB)",
   label: "Kuala Belait (BNKUB)"
  },
  {
   value: "Lumut (BNLUM)",
   label: "Lumut (BNLUM)"
  },
  {
   value: "Muara (BNMUA)",
   label: "Muara (BNMUA)"
  },
  {
   value: "Seria (BNSER)",
   label: "Seria (BNSER)"
  },
  {
   value: "Tanjong Salirong (BNTAS)",
   label: "Tanjong Salirong (BNTAS)"
  },
  {
   value: "Apolo (BOAPB)",
   label: "Apolo (BOAPB)"
  },
  {
   value: "Ascension (BOASC)",
   label: "Ascension (BOASC)"
  },
  {
   value: "Baures (BOBVL)",
   label: "Baures (BOBVL)"
  },
  {
   value: "Bermejo (BOBJO)",
   label: "Bermejo (BOBJO)"
  },
  {
   value: "Camiri (BOCAM)",
   label: "Camiri (BOCAM)"
  },
  {
   value: "Cobija (BOCIJ)",
   label: "Cobija (BOCIJ)"
  },
  {
   value: "Orehovo (BGORE)",
   label: "Orehovo (BGORE)"
  },
  {
   value: "Pavlikeni (BGPIV)",
   label: "Pavlikeni (BGPIV)"
  },
  {
   value: "Pazardzhik (BGPZA)",
   label: "Pazardzhik (BGPZA)"
  },
  {
   value: "Pernik (BGPNZ)",
   label: "Pernik (BGPNZ)"
  },
  {
   value: "Perushtitsa (BGPRS)",
   label: "Perushtitsa (BGPRS)"
  },
  {
   value: "Peshtera (BGPEC)",
   label: "Peshtera (BGPEC)"
  },
  {
   value: "Petrich (BGPEG)",
   label: "Petrich (BGPEG)"
  },
  {
   value: "Pleven (BGPVN)",
   label: "Pleven (BGPVN)"
  },
  {
   value: "Plovdiv (BGPDV)",
   label: "Plovdiv (BGPDV)"
  },
  {
   value: "Pomorie (BGPOR)",
   label: "Pomorie (BGPOR)"
  },
  {
   value: "Popovo (BGPOK)",
   label: "Popovo (BGPOK)"
  },
  {
   value: "Preslav (BGPSC)",
   label: "Preslav (BGPSC)"
  },
  {
   value: "Provadiya (BGPDA)",
   label: "Provadiya (BGPDA)"
  },
  {
   value: "Radomir (BGRDI)",
   label: "Radomir (BGRDI)"
  },
  {
   value: "Razgrad (BGRGL)",
   label: "Razgrad (BGRGL)"
  },
  {
   value: "Rousse (BGROU)",
   label: "Rousse (BGROU)"
  },
  {
   value: "Ruse (BGRDU)",
   label: "Ruse (BGRDU)"
  },
  {
   value: "Samovedene (BGOZD)",
   label: "Samovedene (BGOZD)"
  },
  {
   value: "Sandanski (BGSDM)",
   label: "Sandanski (BGSDM)"
  },
  {
   value: "Sevlievo (BGSLU)",
   label: "Sevlievo (BGSLU)"
  },
  {
   value: "Shumen (BGSUW)",
   label: "Shumen (BGSUW)"
  },
  {
   value: "Silistra (BGSLS)",
   label: "Silistra (BGSLS)"
  },
  {
   value: "Slawjanci (BGSWQ)",
   label: "Slawjanci (BGSWQ)"
  },
  {
   value: "Sliven (BGSLP)",
   label: "Sliven (BGSLP)"
  },
  {
   value: "Smolyan (BGSML)",
   label: "Smolyan (BGSML)"
  },
  {
   value: "Sofia (BGSOF)",
   label: "Sofia (BGSOF)"
  },
  {
   value: "Somovit (BGSOM)",
   label: "Somovit (BGSOM)"
  },
  {
   value: "Sopot (BGSBP)",
   label: "Sopot (BGSBP)"
  },
  {
   value: "Stanke Dimitrov (BGSDV)",
   label: "Stanke Dimitrov (BGSDV)"
  },
  {
   value: "Stanke Lisitchkovo (BGSLI)",
   label: "Stanke Lisitchkovo (BGSLI)"
  },
  {
   value: "Stara Zagora (BGSZR)",
   label: "Stara Zagora (BGSZR)"
  },
  {
   value: "Stresimirovtsi (BGSTR)",
   label: "Stresimirovtsi (BGSTR)"
  },
  {
   value: "Suhindol (BGSUZ)",
   label: "Suhindol (BGSUZ)"
  },
  {
   value: "Svilengrad (BGSWG)",
   label: "Svilengrad (BGSWG)"
  },
  {
   value: "Svistov (BGSVI)",
   label: "Svistov (BGSVI)"
  },
  {
   value: "Targovishte (BGTGV)",
   label: "Targovishte (BGTGV)"
  },
  {
   value: "Tolbuhin (BGTOL)",
   label: "Tolbuhin (BGTOL)"
  },
  {
   value: "Topolovgrad (BGTGA)",
   label: "Topolovgrad (BGTGA)"
  },
  {
   value: "Trojan (BGTJM)",
   label: "Trojan (BGTJM)"
  },
  {
   value: "Troyan (BGTRY)",
   label: "Troyan (BGTRY)"
  },
  {
   value: "Tutrakan (BGTRP)",
   label: "Tutrakan (BGTRP)"
  },
  {
   value: "Varna (BGVAR)",
   label: "Varna (BGVAR)"
  },
  {
   value: "Delchev (BGDLC)",
   label: "Delchev (BGDLC)"
  },
  {
   value: "Devnya (BGDNJ)",
   label: "Devnya (BGDNJ)"
  },
  {
   value: "Dimitrovgrad (BGDTG)",
   label: "Dimitrovgrad (BGDTG)"
  },
  {
   value: "Dobrich (BGDOD)",
   label: "Dobrich (BGDOD)"
  },
  {
   value: "Dolna Orahovica (BGDKC)",
   label: "Dolna Orahovica (BGDKC)"
  },
  {
   value: "Dospat (BGDSP)",
   label: "Dospat (BGDSP)"
  },
  {
   value: "Dragoman (BGDMN)",
   label: "Dragoman (BGDMN)"
  },
  {
   value: "Dulovo (BGDLV)",
   label: "Dulovo (BGDLV)"
  },
  {
   value: "Duran Kulak (BGDKO)",
   label: "Duran Kulak (BGDKO)"
  },
  {
   value: "Etropole (BGETS)",
   label: "Etropole (BGETS)"
  },
  {
   value: "Gabrovo (BGGAV)",
   label: "Gabrovo (BGGAV)"
  },
  {
   value: "Gjechevo (BGGJE)",
   label: "Gjechevo (BGGJE)"
  },
  {
   value: "Gorna Orechovitsa (BGGOZ)",
   label: "Gorna Orechovitsa (BGGOZ)"
  },
  {
   value: "Haskovo (BGHKV)",
   label: "Haskovo (BGHKV)"
  },
  {
   value: "Iovkovo (BGIOV)",
   label: "Iovkovo (BGIOV)"
  },
  {
   value: "Isperikh (BGIPR)",
   label: "Isperikh (BGIPR)"
  },
  {
   value: "Ithiman (BGIHT)",
   label: "Ithiman (BGIHT)"
  },
  {
   value: "Ivailovgrad (BGIVL)",
   label: "Ivailovgrad (BGIVL)"
  },
  {
   value: "Jambol (BGJAM)",
   label: "Jambol (BGJAM)"
  },
  {
   value: "Kalotina (BGKAL)",
   label: "Kalotina (BGKAL)"
  },
  {
   value: "Kapitan Andreevo (BGKAN)",
   label: "Kapitan Andreevo (BGKAN)"
  },
  {
   value: "Kardam (BGKAR)",
   label: "Kardam (BGKAR)"
  },
  {
   value: "Kardjali (BGKDG)",
   label: "Kardjali (BGKDG)"
  },
  {
   value: "Kardzalu (BGKRM)",
   label: "Kardzalu (BGKRM)"
  },
  {
   value: "Karlovo (BGKVO)",
   label: "Karlovo (BGKVO)"
  },
  {
   value: "Kaspichan (BGKPH)",
   label: "Kaspichan (BGKPH)"
  },
  {
   value: "Kazanluk (BGKZN)",
   label: "Kazanluk (BGKZN)"
  },
  {
   value: "Khankrum (BGKHK)",
   label: "Khankrum (BGKHK)"
  },
  {
   value: "Kjustendil (BGKJG)",
   label: "Kjustendil (BGKJG)"
  },
  {
   value: "Kulata (BGKOL)",
   label: "Kulata (BGKOL)"
  },
  {
   value: "Levski (BGLSD)",
   label: "Levski (BGLSD)"
  },
  {
   value: "Ljaskovec (BGLKS)",
   label: "Ljaskovec (BGLKS)"
  },
  {
   value: "Lom (BGLOM)",
   label: "Lom (BGLOM)"
  },
  {
   value: "Lovech (BGLVP)",
   label: "Lovech (BGLVP)"
  },
  {
   value: "Malko Tarnovo (BGMTI)",
   label: "Malko Tarnovo (BGMTI)"
  },
  {
   value: "Melnik (BGMEL)",
   label: "Melnik (BGMEL)"
  },
  {
   value: "Michurin (BGMIC)",
   label: "Michurin (BGMIC)"
  },
  {
   value: "Momchildgrad (BGMOT)",
   label: "Momchildgrad (BGMOT)"
  },
  {
   value: "Montana (BGOZA)",
   label: "Montana (BGOZA)"
  },
  {
   value: "Nova Zagora (BGNZG)",
   label: "Nova Zagora (BGNZG)"
  },
  {
   value: "Novi Pazar (BGNPZ)",
   label: "Novi Pazar (BGNPZ)"
  },
  {
   value: "Oltomantsi (BGOLT)",
   label: "Oltomantsi (BGOLT)"
  },
  {
   value: "LUBBEEK (BELBK)",
   label: "LUBBEEK (BELBK)"
  },
  {
   value: "NAZARETH (BENZH)",
   label: "NAZARETH (BENZH)"
  },
  {
   value: "WORTEGEM (BEWOM)",
   label: "WORTEGEM (BEWOM)"
  },
  {
   value: "Aribinda (BFABD)",
   label: "Aribinda (BFABD)"
  },
  {
   value: "Arly (BFARL)",
   label: "Arly (BFARL)"
  },
  {
   value: "Banfora (BFBNR)",
   label: "Banfora (BFBNR)"
  },
  {
   value: "Bobo Dioulasso (BFBOY)",
   label: "Bobo Dioulasso (BFBOY)"
  },
  {
   value: "Bogande (BFBOG)",
   label: "Bogande (BFBOG)"
  },
  {
   value: "Boulsa (BFBOU)",
   label: "Boulsa (BFBOU)"
  },
  {
   value: "Dedougou (BFDGU)",
   label: "Dedougou (BFDGU)"
  },
  {
   value: "Diapaga (BFDIP)",
   label: "Diapaga (BFDIP)"
  },
  {
   value: "Diebougou (BFDBG)",
   label: "Diebougou (BFDBG)"
  },
  {
   value: "Djibo (BFDJI)",
   label: "Djibo (BFDJI)"
  },
  {
   value: "Dori (BFDOR)",
   label: "Dori (BFDOR)"
  },
  {
   value: "Fada Ngourma (BFFNG)",
   label: "Fada Ngourma (BFFNG)"
  },
  {
   value: "Gaoua (BFGAO)",
   label: "Gaoua (BFGAO)"
  },
  {
   value: "Gorom-Gorom (BFGOG)",
   label: "Gorom-Gorom (BFGOG)"
  },
  {
   value: "Kantchari (BFKAN)",
   label: "Kantchari (BFKAN)"
  },
  {
   value: "Kaya (BFKAY)",
   label: "Kaya (BFKAY)"
  },
  {
   value: "Leo (BFLEO)",
   label: "Leo (BFLEO)"
  },
  {
   value: "Nouna (BFNOU)",
   label: "Nouna (BFNOU)"
  },
  {
   value: "Ouagadougou (BFOUA)",
   label: "Ouagadougou (BFOUA)"
  },
  {
   value: "Ouahigouya (BFOUG)",
   label: "Ouahigouya (BFOUG)"
  },
  {
   value: "Pama (BFPAM)",
   label: "Pama (BFPAM)"
  },
  {
   value: "Po (BFPUP)",
   label: "Po (BFPUP)"
  },
  {
   value: "Sebba (BFSEB)",
   label: "Sebba (BFSEB)"
  },
  {
   value: "Tambao (BFTMQ)",
   label: "Tambao (BFTMQ)"
  },
  {
   value: "Tenkodogo (BFTEG)",
   label: "Tenkodogo (BFTEG)"
  },
  {
   value: "Tougan (BFTUQ)",
   label: "Tougan (BFTUQ)"
  },
  {
   value: "Zabre (BFZAB)",
   label: "Zabre (BFZAB)"
  },
  {
   value: "KOUDOUGOU (BFKOU)",
   label: "KOUDOUGOU (BFKOU)"
  },
  {
   value: "Akhotopol (BGAKH)",
   label: "Akhotopol (BGAKH)"
  },
  {
   value: "Asenovgrad (BGAND)",
   label: "Asenovgrad (BGAND)"
  },
  {
   value: "Baltchik (BGBAL)",
   label: "Baltchik (BGBAL)"
  },
  {
   value: "Berkovitza (BGBRK)",
   label: "Berkovitza (BGBRK)"
  },
  {
   value: "Blageovgrad (BGBLN)",
   label: "Blageovgrad (BGBLN)"
  },
  {
   value: "Botevgrad (BGBRF)",
   label: "Botevgrad (BGBRF)"
  },
  {
   value: "Bregovo (BGBRE)",
   label: "Bregovo (BGBRE)"
  },
  {
   value: "Burgas (BGBOJ)",
   label: "Burgas (BGBOJ)"
  },
  {
   value: "Chepelare (BGCPA)",
   label: "Chepelare (BGCPA)"
  },
  {
   value: "Chirpan (BGCPW)",
   label: "Chirpan (BGCPW)"
  },
  {
   value: "Debelec (BGDBS)",
   label: "Debelec (BGDBS)"
  },
  {
   value: "Wanze (BEWAN)",
   label: "Wanze (BEWAN)"
  },
  {
   value: "Waregem (BEWAR)",
   label: "Waregem (BEWAR)"
  },
  {
   value: "Waterloo (BEWAL)",
   label: "Waterloo (BEWAL)"
  },
  {
   value: "Wauthier Braine (BEWAB)",
   label: "Wauthier Braine (BEWAB)"
  },
  {
   value: "Wavre (BEWVR)",
   label: "Wavre (BEWVR)"
  },
  {
   value: "Weklo (BEWEK)",
   label: "Weklo (BEWEK)"
  },
  {
   value: "Welkenraedt (BEWKD)",
   label: "Welkenraedt (BEWKD)"
  },
  {
   value: "Wellen (BEWEL)",
   label: "Wellen (BEWEL)"
  },
  {
   value: "Wemmel (BEWML)",
   label: "Wemmel (BEWML)"
  },
  {
   value: "Wervik (BEWER)",
   label: "Wervik (BEWER)"
  },
  {
   value: "Westerlo (BEWES)",
   label: "Westerlo (BEWES)"
  },
  {
   value: "Westrozebeke (BEWST)",
   label: "Westrozebeke (BEWST)"
  },
  {
   value: "Wetteren (BEWET)",
   label: "Wetteren (BEWET)"
  },
  {
   value: "Wevelgem (BEWEV)",
   label: "Wevelgem (BEWEV)"
  },
  {
   value: "Wiers (BEWIR)",
   label: "Wiers (BEWIR)"
  },
  {
   value: "Wieze (BEWIE)",
   label: "Wieze (BEWIE)"
  },
  {
   value: "Wijnegem (BEWJG)",
   label: "Wijnegem (BEWJG)"
  },
  {
   value: "Willebroek (BEWLB)",
   label: "Willebroek (BEWLB)"
  },
  {
   value: "Wilrijk (BEWIL)",
   label: "Wilrijk (BEWIL)"
  },
  {
   value: "Wilsele (BEWSL)",
   label: "Wilsele (BEWSL)"
  },
  {
   value: "Wingene (BEWEE)",
   label: "Wingene (BEWEE)"
  },
  {
   value: "Wondelgem (BEWDG)",
   label: "Wondelgem (BEWDG)"
  },
  {
   value: "Wuustwezel (BEWUU)",
   label: "Wuustwezel (BEWUU)"
  },
  {
   value: "Zandhoven (BEZAN)",
   label: "Zandhoven (BEZAN)"
  },
  {
   value: "Zandvoorde (BEZVD)",
   label: "Zandvoorde (BEZVD)"
  },
  {
   value: "Zaventem (BEZAV)",
   label: "Zaventem (BEZAV)"
  },
  {
   value: "Zedelgem (BEZED)",
   label: "Zedelgem (BEZED)"
  },
  {
   value: "Zeebrugge (BEZEE)",
   label: "Zeebrugge (BEZEE)"
  },
  {
   value: "Zele (BEZLE)",
   label: "Zele (BEZLE)"
  },
  {
   value: "Zellik (BEZLL)",
   label: "Zellik (BEZLL)"
  },
  {
   value: "Zelzate (BEZEL)",
   label: "Zelzate (BEZEL)"
  },
  {
   value: "Zoersel (BEOBL)",
   label: "Zoersel (BEOBL)"
  },
  {
   value: "Zolder (BEZOD)",
   label: "Zolder (BEZOD)"
  },
  {
   value: "Zonhoven (BEZHV)",
   label: "Zonhoven (BEZHV)"
  },
  {
   value: "Zottegem (BEZOT)",
   label: "Zottegem (BEZOT)"
  },
  {
   value: "Zulte (BEZUL)",
   label: "Zulte (BEZUL)"
  },
  {
   value: "Zwevegem (BEZWE)",
   label: "Zwevegem (BEZWE)"
  },
  {
   value: "Zwijnaarde (BEZWN)",
   label: "Zwijnaarde (BEZWN)"
  },
  {
   value: "Zwijndrecht (BEZWL)",
   label: "Zwijndrecht (BEZWL)"
  },
  {
   value: "BARCHON (BEBCN)",
   label: "BARCHON (BEBCN)"
  },
  {
   value: "ETALLE (BEETL)",
   label: "ETALLE (BEETL)"
  },
  {
   value: "LOBBES (BELBS)",
   label: "LOBBES (BELBS)"
  },
  {
   value: "St Amandsberg (BESFY)",
   label: "St Amandsberg (BESFY)"
  },
  {
   value: "St Baafs Vijve (BESTV)",
   label: "St Baafs Vijve (BESTV)"
  },
  {
   value: "St Eloois Vijve (BESEV)",
   label: "St Eloois Vijve (BESEV)"
  },
  {
   value: "St Genesius Rode (BESGR)",
   label: "St Genesius Rode (BESGR)"
  },
  {
   value: "St Katelijne-Waver (BESSL)",
   label: "St Katelijne-Waver (BESSL)"
  },
  {
   value: "St Lievens-Esse (BESII)",
   label: "St Lievens-Esse (BESII)"
  },
  {
   value: "St Niklaas (BESNK)",
   label: "St Niklaas (BESNK)"
  },
  {
   value: "St Pieters Kapelle (BESPK)",
   label: "St Pieters Kapelle (BESPK)"
  },
  {
   value: "St Pieters-Leeuw (BESPT)",
   label: "St Pieters-Leeuw (BESPT)"
  },
  {
   value: "St Truiden (BESTR)",
   label: "St Truiden (BESTR)"
  },
  {
   value: "Stabroek (BESTA)",
   label: "Stabroek (BESTA)"
  },
  {
   value: "Staden (BESTD)",
   label: "Staden (BESTD)"
  },
  {
   value: "Stambruges (BESBG)",
   label: "Stambruges (BESBG)"
  },
  {
   value: "Steenokkerzeel (BESKK)",
   label: "Steenokkerzeel (BESKK)"
  },
  {
   value: "Steenvoorde (BESTE)",
   label: "Steenvoorde (BESTE)"
  },
  {
   value: "Strepy (BESTB)",
   label: "Strepy (BESTB)"
  },
  {
   value: "Temse (BETSE)",
   label: "Temse (BETSE)"
  },
  {
   value: "Ternat (BETER)",
   label: "Ternat (BETER)"
  },
  {
   value: "Tertre (BETET)",
   label: "Tertre (BETET)"
  },
  {
   value: "Tessenderlo (BETES)",
   label: "Tessenderlo (BETES)"
  },
  {
   value: "Theux (BETAP)",
   label: "Theux (BETAP)"
  },
  {
   value: "Thuin (BETHU)",
   label: "Thuin (BETHU)"
  },
  {
   value: "Tielt (BETTL)",
   label: "Tielt (BETTL)"
  },
  {
   value: "Tienen (BETIE)",
   label: "Tienen (BETIE)"
  },
  {
   value: "Tongeren (BETON)",
   label: "Tongeren (BETON)"
  },
  {
   value: "Torhout (BETRT)",
   label: "Torhout (BETRT)"
  },
  {
   value: "Tournai (BETRN)",
   label: "Tournai (BETRN)"
  },
  {
   value: "Trooz (BETRO)",
   label: "Trooz (BETRO)"
  },
  {
   value: "Turnhout (BETUR)",
   label: "Turnhout (BETUR)"
  },
  {
   value: "Vaux Sous Chevremont (BEVSC)",
   label: "Vaux Sous Chevremont (BEVSC)"
  },
  {
   value: "Verviers (BEVER)",
   label: "Verviers (BEVER)"
  },
  {
   value: "Veurne (BEVEU)",
   label: "Veurne (BEVEU)"
  },
  {
   value: "Vichte (BEVIC)",
   label: "Vichte (BEVIC)"
  },
  {
   value: "Vilvoorde (BEVIL)",
   label: "Vilvoorde (BEVIL)"
  },
  {
   value: "Virton (BEVIR)",
   label: "Virton (BEVIR)"
  },
  {
   value: "Vise (BEVIS)",
   label: "Vise (BEVIS)"
  },
  {
   value: "Vollezele (BEVLL)",
   label: "Vollezele (BEVLL)"
  },
  {
   value: "Waasmunster (BEWAA)",
   label: "Waasmunster (BEWAA)"
  },
  {
   value: "Wakken (BEWAK)",
   label: "Wakken (BEWAK)"
  },
  {
   value: "Walhorn (BEWHR)",
   label: "Walhorn (BEWHR)"
  },
  {
   value: "Orhaye (BEOHE)",
   label: "Orhaye (BEOHE)"
  },
  {
   value: "Ottignies (BEOTI)",
   label: "Ottignies (BEOTI)"
  },
  {
   value: "Oudenaarde (BEOUD)",
   label: "Oudenaarde (BEOUD)"
  },
  {
   value: "Overijse (BEOVR)",
   label: "Overijse (BEOVR)"
  },
  {
   value: "Paal (BEPAL)",
   label: "Paal (BEPAL)"
  },
  {
   value: "Passendale (BEPAS)",
   label: "Passendale (BEPAS)"
  },
  {
   value: "Peizegem (BEPEI)",
   label: "Peizegem (BEPEI)"
  },
  {
   value: "Pepinster (BEPEP)",
   label: "Pepinster (BEPEP)"
  },
  {
   value: "Perk (BEPER)",
   label: "Perk (BEPER)"
  },
  {
   value: "Peruwelz (BEPWZ)",
   label: "Peruwelz (BEPWZ)"
  },
  {
   value: "Poperinge (BEPOP)",
   label: "Poperinge (BEPOP)"
  },
  {
   value: "Proven (BEPRV)",
   label: "Proven (BEPRV)"
  },
  {
   value: "Putte (BEPUT)",
   label: "Putte (BEPUT)"
  },
  {
   value: "Puurs (BEPUU)",
   label: "Puurs (BEPUU)"
  },
  {
   value: "Quenast-Rebecq (BEQUE)",
   label: "Quenast-Rebecq (BEQUE)"
  },
  {
   value: "Raeren (BERAE)",
   label: "Raeren (BERAE)"
  },
  {
   value: "Recogne (BEREC)",
   label: "Recogne (BEREC)"
  },
  {
   value: "Reetrumst (BEREE)",
   label: "Reetrumst (BEREE)"
  },
  {
   value: "Rekkem (BEREK)",
   label: "Rekkem (BEREK)"
  },
  {
   value: "Rieme (BERIE)",
   label: "Rieme (BERIE)"
  },
  {
   value: "Rixensart (BERIX)",
   label: "Rixensart (BERIX)"
  },
  {
   value: "Roeselare (BEROE)",
   label: "Roeselare (BEROE)"
  },
  {
   value: "Roeulx (BEROU)",
   label: "Roeulx (BEROU)"
  },
  {
   value: "Ronse (BERON)",
   label: "Ronse (BERON)"
  },
  {
   value: "Rotselaar (BERBA)",
   label: "Rotselaar (BERBA)"
  },
  {
   value: "Ruisbroek (BERUI)",
   label: "Ruisbroek (BERUI)"
  },
  {
   value: "Rumbeke (BERUM)",
   label: "Rumbeke (BERUM)"
  },
  {
   value: "Rumst (BERUS)",
   label: "Rumst (BERUS)"
  },
  {
   value: "Rupel (BERUP)",
   label: "Rupel (BERUP)"
  },
  {
   value: "S. Stevens-Woluwe (BESTW)",
   label: "S. Stevens-Woluwe (BESTW)"
  },
  {
   value: "Saint-Marc (BESMC)",
   label: "Saint-Marc (BESMC)"
  },
  {
   value: "Sambreville (BESAB)",
   label: "Sambreville (BESAB)"
  },
  {
   value: "Sautin (BESTN)",
   label: "Sautin (BESTN)"
  },
  {
   value: "Schelle (BESHL)",
   label: "Schelle (BESHL)"
  },
  {
   value: "Schellem (BESCH)",
   label: "Schellem (BESCH)"
  },
  {
   value: "Schilde (BESCE)",
   label: "Schilde (BESCE)"
  },
  {
   value: "Schoten (BESCT)",
   label: "Schoten (BESCT)"
  },
  {
   value: "Seneffe (BESEN)",
   label: "Seneffe (BESEN)"
  },
  {
   value: "Seraing (BEZER)",
   label: "Seraing (BEZER)"
  },
  {
   value: "Sleidinge (BESLE)",
   label: "Sleidinge (BESLE)"
  },
  {
   value: "Soignies (BESOI)",
   label: "Soignies (BESOI)"
  },
  {
   value: "Spa (BESPA)",
   label: "Spa (BESPA)"
  },
  {
   value: "Melsbroek (BEMBK)",
   label: "Melsbroek (BEMBK)"
  },
  {
   value: "Menen (BEMEN)",
   label: "Menen (BEMEN)"
  },
  {
   value: "Merchtem (BEMEC)",
   label: "Merchtem (BEMEC)"
  },
  {
   value: "Mere (BEMER)",
   label: "Mere (BEMER)"
  },
  {
   value: "Merelbeke (BEMRL)",
   label: "Merelbeke (BEMRL)"
  },
  {
   value: "Merksem (BEMRK)",
   label: "Merksem (BEMRK)"
  },
  {
   value: "Merksplas (BEMPS)",
   label: "Merksplas (BEMPS)"
  },
  {
   value: "Meslin-l'Eveque (BEMEB)",
   label: "Meslin-l'Eveque (BEMEB)"
  },
  {
   value: "Messancy (BEMES)",
   label: "Messancy (BEMES)"
  },
  {
   value: "Meulebeke (BEMEU)",
   label: "Meulebeke (BEMEU)"
  },
  {
   value: "Milmort (BEMIL)",
   label: "Milmort (BEMIL)"
  },
  {
   value: "Moerbeke-Waas (BEMEW)",
   label: "Moerbeke-Waas (BEMEW)"
  },
  {
   value: "Mollem (BEMEM)",
   label: "Mollem (BEMEM)"
  },
  {
   value: "Momignies (BEMOM)",
   label: "Momignies (BEMOM)"
  },
  {
   value: "Mons (BEMQS)",
   label: "Mons (BEMQS)"
  },
  {
   value: "Montignies-Le-Tilleul (BEMON)",
   label: "Montignies-Le-Tilleul (BEMON)"
  },
  {
   value: "Montzen (BEMOT)",
   label: "Montzen (BEMOT)"
  },
  {
   value: "Moon (BEMOO)",
   label: "Moon (BEMOO)"
  },
  {
   value: "Moorsel (BEMOL)",
   label: "Moorsel (BEMOL)"
  },
  {
   value: "Moorslede (BEMRS)",
   label: "Moorslede (BEMRS)"
  },
  {
   value: "Mortsel (BEMOR)",
   label: "Mortsel (BEMOR)"
  },
  {
   value: "Mouscron (Moeskroen) (BEMOS)",
   label: "Mouscron (Moeskroen) (BEMOS)"
  },
  {
   value: "Muno (BEMUN)",
   label: "Muno (BEMUN)"
  },
  {
   value: "Namur (BENAM)",
   label: "Namur (BENAM)"
  },
  {
   value: "Nederokkerzeel (BENED)",
   label: "Nederokkerzeel (BENED)"
  },
  {
   value: "Neufvilles (BENEU)",
   label: "Neufvilles (BENEU)"
  },
  {
   value: "Niel (BENIL)",
   label: "Niel (BENIL)"
  },
  {
   value: "Nieuwpoort (BENIE)",
   label: "Nieuwpoort (BENIE)"
  },
  {
   value: "Nimy (BENBA)",
   label: "Nimy (BENBA)"
  },
  {
   value: "Ninove (BENNV)",
   label: "Ninove (BENNV)"
  },
  {
   value: "Nivelles (Nivelles) (BENIV)",
   label: "Nivelles (Nivelles) (BENIV)"
  },
  {
   value: "Oevel (BEOEV)",
   label: "Oevel (BEOEV)"
  },
  {
   value: "Olen (BEOLN)",
   label: "Olen (BEOLN)"
  },
  {
   value: "Olsene (BEOLS)",
   label: "Olsene (BEOLS)"
  },
  {
   value: "Oostakker (BEOOS)",
   label: "Oostakker (BEOOS)"
  },
  {
   value: "Oostende (BEOST)",
   label: "Oostende (BEOST)"
  },
  {
   value: "Oostkamp (BEOKP)",
   label: "Oostkamp (BEOKP)"
  },
  {
   value: "Oostrozebeke (BEOSR)",
   label: "Oostrozebeke (BEOSR)"
  },
  {
   value: "Oostvleteren (BEOSV)",
   label: "Oostvleteren (BEOSV)"
  },
  {
   value: "Opglabbeek (BEOPG)",
   label: "Opglabbeek (BEOPG)"
  },
  {
   value: "Opwijk (BEOIJ)",
   label: "Opwijk (BEOIJ)"
  },
  {
   value: "La Hulpe (BELHL)",
   label: "La Hulpe (BELHL)"
  },
  {
   value: "La Louviere (BELLO)",
   label: "La Louviere (BELLO)"
  },
  {
   value: "Laakdal (BEYZO)",
   label: "Laakdal (BEYZO)"
  },
  {
   value: "Laarne (BELAA)",
   label: "Laarne (BELAA)"
  },
  {
   value: "Lanaken (BELAN)",
   label: "Lanaken (BELAN)"
  },
  {
   value: "Langemark (BELAK)",
   label: "Langemark (BELAK)"
  },
  {
   value: "Langre (BELAG)",
   label: "Langre (BELAG)"
  },
  {
   value: "Lanklaar (BELNK)",
   label: "Lanklaar (BELNK)"
  },
  {
   value: "Lasne (BELSN)",
   label: "Lasne (BELSN)"
  },
  {
   value: "Lebbeke (BELEB)",
   label: "Lebbeke (BELEB)"
  },
  {
   value: "Lendelede (BELND)",
   label: "Lendelede (BELND)"
  },
  {
   value: "Lessines (BELES)",
   label: "Lessines (BELES)"
  },
  {
   value: "Leuven (BELEU)",
   label: "Leuven (BELEU)"
  },
  {
   value: "Leuze En Hainaut (BELHT)",
   label: "Leuze En Hainaut (BELHT)"
  },
  {
   value: "Libin (BELBN)",
   label: "Libin (BELBN)"
  },
  {
   value: "Libramont-Chevigny (BELIB)",
   label: "Libramont-Chevigny (BELIB)"
  },
  {
   value: "Lichtervelde (BELIC)",
   label: "Lichtervelde (BELIC)"
  },
  {
   value: "Liedekerke (BELDK)",
   label: "Liedekerke (BELDK)"
  },
  {
   value: "Liege (BELGG)",
   label: "Liege (BELGG)"
  },
  {
   value: "Lier (BELIE)",
   label: "Lier (BELIE)"
  },
  {
   value: "Lochristi (BELOH)",
   label: "Lochristi (BELOH)"
  },
  {
   value: "Lodelinsart (BELOD)",
   label: "Lodelinsart (BELOD)"
  },
  {
   value: "Lokeren (BELOK)",
   label: "Lokeren (BELOK)"
  },
  {
   value: "Lommel (BELML)",
   label: "Lommel (BELML)"
  },
  {
   value: "Londerzeel (BELNZ)",
   label: "Londerzeel (BELNZ)"
  },
  {
   value: "Longueville (Manche) (BELFG)",
   label: "Longueville (Manche) (BELFG)"
  },
  {
   value: "Loppem (BELPM)",
   label: "Loppem (BELPM)"
  },
  {
   value: "Lot (BELOT)",
   label: "Lot (BELOT)"
  },
  {
   value: "Louvain-La-Neuve (BELLN)",
   label: "Louvain-La-Neuve (BELLN)"
  },
  {
   value: "Lummen (BELUM)",
   label: "Lummen (BELUM)"
  },
  {
   value: "Lynxhe (BELYN)",
   label: "Lynxhe (BELYN)"
  },
  {
   value: "Maaseik (BEMSK)",
   label: "Maaseik (BEMSK)"
  },
  {
   value: "Malle (BEMAL)",
   label: "Malle (BEMAL)"
  },
  {
   value: "Malmedy (BEMBW)",
   label: "Malmedy (BEMBW)"
  },
  {
   value: "Manage (BEMAN)",
   label: "Manage (BEMAN)"
  },
  {
   value: "March Les Dames (BEMLD)",
   label: "March Les Dames (BEMLD)"
  },
  {
   value: "Mechelen (BEECH)",
   label: "Mechelen (BEECH)"
  },
  {
   value: "Meer (BEMEE)",
   label: "Meer (BEMEE)"
  },
  {
   value: "Meerhout (BEMEH)",
   label: "Meerhout (BEMEH)"
  },
  {
   value: "Melin (BEMEI)",
   label: "Melin (BEMEI)"
  },
  {
   value: "Melle (BEMEL)",
   label: "Melle (BEMEL)"
  },
  {
   value: "Herstal (BEHRS)",
   label: "Herstal (BEHRS)"
  },
  {
   value: "Herverlee (BEHVB)",
   label: "Herverlee (BEHVB)"
  },
  {
   value: "Heule (BEHEU)",
   label: "Heule (BEHEU)"
  },
  {
   value: "Hoboken (BEHBN)",
   label: "Hoboken (BEHBN)"
  },
  {
   value: "Hoegaarden (BEHGD)",
   label: "Hoegaarden (BEHGD)"
  },
  {
   value: "Hondschoote (BEHON)",
   label: "Hondschoote (BEHON)"
  },
  {
   value: "Hooglede (BEHHG)",
   label: "Hooglede (BEHHG)"
  },
  {
   value: "Hoogstraten (BEHOO)",
   label: "Hoogstraten (BEHOO)"
  },
  {
   value: "Houdeng-Goegnies (BEHGG)",
   label: "Houdeng-Goegnies (BEHGG)"
  },
  {
   value: "Houthalen (BEHTH)",
   label: "Houthalen (BEHTH)"
  },
  {
   value: "Huizingen (BEHZI)",
   label: "Huizingen (BEHZI)"
  },
  {
   value: "Hulste (BEHUL)",
   label: "Hulste (BEHUL)"
  },
  {
   value: "Idegem (BEIDG)",
   label: "Idegem (BEIDG)"
  },
  {
   value: "Ieper (Ypres) (BEIPR)",
   label: "Ieper (Ypres) (BEIPR)"
  },
  {
   value: "Ingelmunster (BEIGE)",
   label: "Ingelmunster (BEIGE)"
  },
  {
   value: "Ingooigem (BEIGM)",
   label: "Ingooigem (BEIGM)"
  },
  {
   value: "Izegem (BEIZG)",
   label: "Izegem (BEIZG)"
  },
  {
   value: "Jupille-sur-Meuse (BEJAK)",
   label: "Jupille-sur-Meuse (BEJAK)"
  },
  {
   value: "Kallo (BEKOU)",
   label: "Kallo (BEKOU)"
  },
  {
   value: "Kalmthout (BEKTT)",
   label: "Kalmthout (BEKTT)"
  },
  {
   value: "Kampenhout (BEKMH)",
   label: "Kampenhout (BEKMH)"
  },
  {
   value: "Kapelle-Op-Den-Bos (BEKPB)",
   label: "Kapelle-Op-Den-Bos (BEKPB)"
  },
  {
   value: "Kapellen (BEKPN)",
   label: "Kapellen (BEKPN)"
  },
  {
   value: "Kaulille (BEKLE)",
   label: "Kaulille (BEKLE)"
  },
  {
   value: "Keerbergen (BEKAO)",
   label: "Keerbergen (BEKAO)"
  },
  {
   value: "Kessel (BEKES)",
   label: "Kessel (BEKES)"
  },
  {
   value: "Knokke\/Het Zoute (BEKNO)",
   label: "Knokke\/Het Zoute (BEKNO)"
  },
  {
   value: "Kobbegem (BEKBB)",
   label: "Kobbegem (BEKBB)"
  },
  {
   value: "Koksijde (BEKKS)",
   label: "Koksijde (BEKKS)"
  },
  {
   value: "Koningshooikt (BEKKT)",
   label: "Koningshooikt (BEKKT)"
  },
  {
   value: "Kontich (BEKON)",
   label: "Kontich (BEKON)"
  },
  {
   value: "Koolskamp (BEKOO)",
   label: "Koolskamp (BEKOO)"
  },
  {
   value: "Kortemark (BEKTK)",
   label: "Kortemark (BEKTK)"
  },
  {
   value: "Kortenberg (BEKTB)",
   label: "Kortenberg (BEKTB)"
  },
  {
   value: "Kortrijk (BEKJK)",
   label: "Kortrijk (BEKJK)"
  },
  {
   value: "Kruibeke (BEKEK)",
   label: "Kruibeke (BEKEK)"
  },
  {
   value: "Kruischoutem (BEKHM)",
   label: "Kruischoutem (BEKHM)"
  },
  {
   value: "Kuurne (BEKUU)",
   label: "Kuurne (BEKUU)"
  },
  {
   value: "Kwaadmechelen (BEKWA)",
   label: "Kwaadmechelen (BEKWA)"
  },
  {
   value: "La Calamine (BELAP)",
   label: "La Calamine (BELAP)"
  },
  {
   value: "Eynatten (BEEYT)",
   label: "Eynatten (BEEYT)"
  },
  {
   value: "Feluy (BEFEY)",
   label: "Feluy (BEFEY)"
  },
  {
   value: "Flemalle-Haute (BEFLH)",
   label: "Flemalle-Haute (BEFLH)"
  },
  {
   value: "Fleurus (BEFLE)",
   label: "Fleurus (BEFLE)"
  },
  {
   value: "Floreffe (BEFLO)",
   label: "Floreffe (BEFLO)"
  },
  {
   value: "Florennes (BEFLR)",
   label: "Florennes (BEFLR)"
  },
  {
   value: "Frameries (BEFES)",
   label: "Frameries (BEFES)"
  },
  {
   value: "Frasnes-Les-Couvins (BEFLC)",
   label: "Frasnes-Les-Couvins (BEFLC)"
  },
  {
   value: "Gavere (BEGVR)",
   label: "Gavere (BEGVR)"
  },
  {
   value: "Geer (BEGEE)",
   label: "Geer (BEGEE)"
  },
  {
   value: "Gembloux (BEGEM)",
   label: "Gembloux (BEGEM)"
  },
  {
   value: "Genk (BEGNK)",
   label: "Genk (BEGNK)"
  },
  {
   value: "Genval (BEGEV)",
   label: "Genval (BEGEV)"
  },
  {
   value: "Ghent (BEGNE)",
   label: "Ghent (BEGNE)"
  },
  {
   value: "Ghlin (BEGHL)",
   label: "Ghlin (BEGHL)"
  },
  {
   value: "Gistel (BEGIS)",
   label: "Gistel (BEGIS)"
  },
  {
   value: "Goe (BEGDO)",
   label: "Goe (BEGDO)"
  },
  {
   value: "Gosselies (BEGOS)",
   label: "Gosselies (BEGOS)"
  },
  {
   value: "Grembergen (BEGGM)",
   label: "Grembergen (BEGGM)"
  },
  {
   value: "Grimbergen (BEGRB)",
   label: "Grimbergen (BEGRB)"
  },
  {
   value: "Grimgergen (BEGRI)",
   label: "Grimgergen (BEGRI)"
  },
  {
   value: "Grobbendonk (BEGBB)",
   label: "Grobbendonk (BEGBB)"
  },
  {
   value: "Groot-Bijgaarden (BEGBJ)",
   label: "Groot-Bijgaarden (BEGBJ)"
  },
  {
   value: "Gullegem (BEGUG)",
   label: "Gullegem (BEGUG)"
  },
  {
   value: "Haacht (BEHAC)",
   label: "Haacht (BEHAC)"
  },
  {
   value: "Haasrode (BEHAD)",
   label: "Haasrode (BEHAD)"
  },
  {
   value: "Haine St Pierre (BEHSP)",
   label: "Haine St Pierre (BEHSP)"
  },
  {
   value: "Halle (BEHFB)",
   label: "Halle (BEHFB)"
  },
  {
   value: "Hamme (BEHMM)",
   label: "Hamme (BEHMM)"
  },
  {
   value: "Hamme O-VI (BEHME)",
   label: "Hamme O-VI (BEHME)"
  },
  {
   value: "Harelbeke (BEHEJ)",
   label: "Harelbeke (BEHEJ)"
  },
  {
   value: "Hasselt (BEHSS)",
   label: "Hasselt (BEHSS)"
  },
  {
   value: "Hatrize (BEHTZ)",
   label: "Hatrize (BEHTZ)"
  },
  {
   value: "Hautrage (BEHTJ)",
   label: "Hautrage (BEHTJ)"
  },
  {
   value: "Heist-Op-Den-Berg (BEHPG)",
   label: "Heist-Op-Den-Berg (BEHPG)"
  },
  {
   value: "Hemiksem (Hemixen) (BEHEX)",
   label: "Hemiksem (Hemixen) (BEHEX)"
  },
  {
   value: "Herdersem (BEHYB)",
   label: "Herdersem (BEHYB)"
  },
  {
   value: "Herentals (BEHER)",
   label: "Herentals (BEHER)"
  },
  {
   value: "Hermalle-Sous-Argenteau (BEHSA)",
   label: "Hermalle-Sous-Argenteau (BEHSA)"
  },
  {
   value: "Herselt (BEHES)",
   label: "Herselt (BEHES)"
  },
  {
   value: "Casteau (BECAS)",
   label: "Casteau (BECAS)"
  },
  {
   value: "Cerfontaine (BECAD)",
   label: "Cerfontaine (BECAD)"
  },
  {
   value: "Chaineux (BECNX)",
   label: "Chaineux (BECNX)"
  },
  {
   value: "Charleroi (BECRL)",
   label: "Charleroi (BECRL)"
  },
  {
   value: "Chenee (BECHE)",
   label: "Chenee (BECHE)"
  },
  {
   value: "Chievres (BECHI)",
   label: "Chievres (BECHI)"
  },
  {
   value: "Chimay (BECHM)",
   label: "Chimay (BECHM)"
  },
  {
   value: "Corbais (BECRB)",
   label: "Corbais (BECRB)"
  },
  {
   value: "Dadizele (BEDGX)",
   label: "Dadizele (BEDGX)"
  },
  {
   value: "Damme (BEDMM)",
   label: "Damme (BEDMM)"
  },
  {
   value: "Deerlijk (BEDJK)",
   label: "Deerlijk (BEDJK)"
  },
  {
   value: "Deinze (BEDEZ)",
   label: "Deinze (BEDEZ)"
  },
  {
   value: "Dendermonde (BEDDR)",
   label: "Dendermonde (BEDDR)"
  },
  {
   value: "Dessel (BEDSE)",
   label: "Dessel (BEDSE)"
  },
  {
   value: "Desselgem (BEDSL)",
   label: "Desselgem (BEDSL)"
  },
  {
   value: "Deurne (BEDEG)",
   label: "Deurne (BEDEG)"
  },
  {
   value: "Diegem (BEDGB)",
   label: "Diegem (BEDGB)"
  },
  {
   value: "Dienze (BEDZE)",
   label: "Dienze (BEDZE)"
  },
  {
   value: "Diest (BEDIE)",
   label: "Diest (BEDIE)"
  },
  {
   value: "Diksmuide (BEDIK)",
   label: "Diksmuide (BEDIK)"
  },
  {
   value: "Dilbeek (BEDBK)",
   label: "Dilbeek (BEDBK)"
  },
  {
   value: "Dinant (BEDIA)",
   label: "Dinant (BEDIA)"
  },
  {
   value: "Doel (BEDEL)",
   label: "Doel (BEDEL)"
  },
  {
   value: "Donk (BEDON)",
   label: "Donk (BEDON)"
  },
  {
   value: "Doornik (BEDOK)",
   label: "Doornik (BEDOK)"
  },
  {
   value: "Doornzelle (BEDOE)",
   label: "Doornzelle (BEDOE)"
  },
  {
   value: "Dottignies (BEDTS)",
   label: "Dottignies (BEDTS)"
  },
  {
   value: "Dour (BEDOU)",
   label: "Dour (BEDOU)"
  },
  {
   value: "Drogenbos (BEDRB)",
   label: "Drogenbos (BEDRB)"
  },
  {
   value: "Drongen (BEDGN)",
   label: "Drongen (BEDGN)"
  },
  {
   value: "Duffel (BEDUF)",
   label: "Duffel (BEDUF)"
  },
  {
   value: "Dworp (BEDWP)",
   label: "Dworp (BEDWP)"
  },
  {
   value: "Edegem (BEEGM)",
   label: "Edegem (BEEGM)"
  },
  {
   value: "Eeklo (BEEEK)",
   label: "Eeklo (BEEEK)"
  },
  {
   value: "Ekeren (BEEKE)",
   label: "Ekeren (BEEKE)"
  },
  {
   value: "Engis (BEENG)",
   label: "Engis (BEENG)"
  },
  {
   value: "Erembodegem (BEERM)",
   label: "Erembodegem (BEERM)"
  },
  {
   value: "Erpe-Mere (BEERP)",
   label: "Erpe-Mere (BEERP)"
  },
  {
   value: "Ertvelde (BEERE)",
   label: "Ertvelde (BEERE)"
  },
  {
   value: "Essen (BEESS)",
   label: "Essen (BEESS)"
  },
  {
   value: "Eupen (BEEUP)",
   label: "Eupen (BEEUP)"
  },
  {
   value: "Evergem (BEEVM)",
   label: "Evergem (BEEVM)"
  },
  {
   value: "Everlee (BEEVE)",
   label: "Everlee (BEEVE)"
  },
  {
   value: "Avelgem (BEAVL)",
   label: "Avelgem (BEAVL)"
  },
  {
   value: "Baal (BEBAL)",
   label: "Baal (BEBAL)"
  },
  {
   value: "Badourg (BEBAD)",
   label: "Badourg (BEBAD)"
  },
  {
   value: "Balen (BEBLE)",
   label: "Balen (BEBLE)"
  },
  {
   value: "Bastogne (BEBSG)",
   label: "Bastogne (BEBSG)"
  },
  {
   value: "Battice (BEBTC)",
   label: "Battice (BEBTC)"
  },
  {
   value: "Baudour (BEBDU)",
   label: "Baudour (BEBDU)"
  },
  {
   value: "Bavikhove (BEBAV)",
   label: "Bavikhove (BEBAV)"
  },
  {
   value: "Beauvechain (BEBVC)",
   label: "Beauvechain (BEBVC)"
  },
  {
   value: "Beerse (BEBER)",
   label: "Beerse (BEBER)"
  },
  {
   value: "Beersel (BEBEE)",
   label: "Beersel (BEBEE)"
  },
  {
   value: "Berchem (BEBPC)",
   label: "Berchem (BEBPC)"
  },
  {
   value: "Beringen (BERIN)",
   label: "Beringen (BERIN)"
  },
  {
   value: "Berlare (BEBRL)",
   label: "Berlare (BEBRL)"
  },
  {
   value: "Beveren (BEBEV)",
   label: "Beveren (BEBEV)"
  },
  {
   value: "Beveren Leie (BEBEL)",
   label: "Beveren Leie (BEBEL)"
  },
  {
   value: "Beyne-Heusay (BEBYE)",
   label: "Beyne-Heusay (BEBYE)"
  },
  {
   value: "Bissen (BEBIS)",
   label: "Bissen (BEBIS)"
  },
  {
   value: "Bitzen (BEBLZ)",
   label: "Bitzen (BEBLZ)"
  },
  {
   value: "Bocholt (BEBOC)",
   label: "Bocholt (BEBOC)"
  },
  {
   value: "Bohan (BEBOH)",
   label: "Bohan (BEBOH)"
  },
  {
   value: "Bois D'haine (BEBDH)",
   label: "Bois D'haine (BEBDH)"
  },
  {
   value: "Boom (BEBOM)",
   label: "Boom (BEBOM)"
  },
  {
   value: "Boorsem (BEBOO)",
   label: "Boorsem (BEBOO)"
  },
  {
   value: "Borgerhout (BEBOR)",
   label: "Borgerhout (BEBOR)"
  },
  {
   value: "Bornem (BEBON)",
   label: "Bornem (BEBON)"
  },
  {
   value: "Borsele (BEBOE)",
   label: "Borsele (BEBOE)"
  },
  {
   value: "Boussu (BEBSS)",
   label: "Boussu (BEBSS)"
  },
  {
   value: "Bousval (BEBOU)",
   label: "Bousval (BEBOU)"
  },
  {
   value: "Boverkerke (BEBHH)",
   label: "Boverkerke (BEBHH)"
  },
  {
   value: "Braine l'Alleud (BEBLA)",
   label: "Braine l'Alleud (BEBLA)"
  },
  {
   value: "Brasschaat (BEBRA)",
   label: "Brasschaat (BEBRA)"
  },
  {
   value: "Brecht (BEBRC)",
   label: "Brecht (BEBRC)"
  },
  {
   value: "Bredene (BEBIR)",
   label: "Bredene (BEBIR)"
  },
  {
   value: "Bree (BEBRE)",
   label: "Bree (BEBRE)"
  },
  {
   value: "Breendonk (BEBRN)",
   label: "Breendonk (BEBRN)"
  },
  {
   value: "Broechem (BEOBC)",
   label: "Broechem (BEOBC)"
  },
  {
   value: "Brugelette (BEBRG)",
   label: "Brugelette (BEBRG)"
  },
  {
   value: "Bruges (BEBGS)",
   label: "Bruges (BEBGS)"
  },
  {
   value: "Brussel (Bruxelles) (BEBRU)",
   label: "Brussel (Bruxelles) (BEBRU)"
  },
  {
   value: "Buggenhout (BEBHU)",
   label: "Buggenhout (BEBHU)"
  },
  {
   value: "Burcht (BEBUD)",
   label: "Burcht (BEBUD)"
  },
  {
   value: "Chittagong (BDCGP)",
   label: "Chittagong (BDCGP)"
  },
  {
   value: "Comilla (BDCLA)",
   label: "Comilla (BDCLA)"
  },
  {
   value: "Cox's Bazaar (BDCXB)",
   label: "Cox's Bazaar (BDCXB)"
  },
  {
   value: "Dhaka (BDDAC)",
   label: "Dhaka (BDDAC)"
  },
  {
   value: "Dhaka-Kamalapur (BDKAM)",
   label: "Dhaka-Kamalapur (BDKAM)"
  },
  {
   value: "Ishurdi (BDIRD)",
   label: "Ishurdi (BDIRD)"
  },
  {
   value: "Jessore (BDJSR)",
   label: "Jessore (BDJSR)"
  },
  {
   value: "Khulna (BDKHL)",
   label: "Khulna (BDKHL)"
  },
  {
   value: "Laksham (BDLAK)",
   label: "Laksham (BDLAK)"
  },
  {
   value: "Monella (BDMON)",
   label: "Monella (BDMON)"
  },
  {
   value: "Mongla (BDMGL)",
   label: "Mongla (BDMGL)"
  },
  {
   value: "Mymensingh (BDMYM)",
   label: "Mymensingh (BDMYM)"
  },
  {
   value: "Narayanganj (BDNAR)",
   label: "Narayanganj (BDNAR)"
  },
  {
   value: "Pabna (BDPAN)",
   label: "Pabna (BDPAN)"
  },
  {
   value: "Parbatipur (BDPAR)",
   label: "Parbatipur (BDPAR)"
  },
  {
   value: "Rajshahi (BDRJH)",
   label: "Rajshahi (BDRJH)"
  },
  {
   value: "Rangpur (BDRAU)",
   label: "Rangpur (BDRAU)"
  },
  {
   value: "Saidpur (BDSPD)",
   label: "Saidpur (BDSPD)"
  },
  {
   value: "Sandwip (BDSDW)",
   label: "Sandwip (BDSDW)"
  },
  {
   value: "Shamshernagar (BDZHM)",
   label: "Shamshernagar (BDZHM)"
  },
  {
   value: "Sirajganj (BDSAJ)",
   label: "Sirajganj (BDSAJ)"
  },
  {
   value: "Sylhet (BDZYL)",
   label: "Sylhet (BDZYL)"
  },
  {
   value: "Thakurgaon (BDTKR)",
   label: "Thakurgaon (BDTKR)"
  },
  {
   value: "Aalst (BEAAB)",
   label: "Aalst (BEAAB)"
  },
  {
   value: "Aalter (BEAAL)",
   label: "Aalter (BEAAL)"
  },
  {
   value: "Aarschot (BEAAS)",
   label: "Aarschot (BEAAS)"
  },
  {
   value: "Aarsele (BEARS)",
   label: "Aarsele (BEARS)"
  },
  {
   value: "Aartselaar (BEAAR)",
   label: "Aartselaar (BEAAR)"
  },
  {
   value: "Achouffe (BEACH)",
   label: "Achouffe (BEACH)"
  },
  {
   value: "Albertkanaal (BEABK)",
   label: "Albertkanaal (BEABK)"
  },
  {
   value: "Alken (BEAKN)",
   label: "Alken (BEAKN)"
  },
  {
   value: "Alleur (BEAEL)",
   label: "Alleur (BEAEL)"
  },
  {
   value: "Angleur (BEANB)",
   label: "Angleur (BEANB)"
  },
  {
   value: "Antwerpen (BEANR)",
   label: "Antwerpen (BEANR)"
  },
  {
   value: "Anzegem (BEAZM)",
   label: "Anzegem (BEAZM)"
  },
  {
   value: "Archennes (BEACS)",
   label: "Archennes (BEACS)"
  },
  {
   value: "Ardooie (BEADO)",
   label: "Ardooie (BEADO)"
  },
  {
   value: "Arendonk (BEAEJ)",
   label: "Arendonk (BEAEJ)"
  },
  {
   value: "Arlon (BEARL)",
   label: "Arlon (BEARL)"
  },
  {
   value: "Ath (BEATH)",
   label: "Ath (BEATH)"
  },
  {
   value: "Athus (BEAAT)",
   label: "Athus (BEAAT)"
  },
  {
   value: "Aubel (BEAUL)",
   label: "Aubel (BEAUL)"
  },
  {
   value: "Wodonga (AUWOD)",
   label: "Wodonga (AUWOD)"
  },
  {
   value: "Wollogorang (AUWLL)",
   label: "Wollogorang (AUWLL)"
  },
  {
   value: "Wollongong (AUWOL)",
   label: "Wollongong (AUWOL)"
  },
  {
   value: "Wondai (AUWDI)",
   label: "Wondai (AUWDI)"
  },
  {
   value: "Wondoola (AUWON)",
   label: "Wondoola (AUWON)"
  },
  {
   value: "Wonthaggi (AUWOT)",
   label: "Wonthaggi (AUWOT)"
  },
  {
   value: "Woodgreen (AUWOG)",
   label: "Woodgreen (AUWOG)"
  },
  {
   value: "Woodie Woodie (AUWWI)",
   label: "Woodie Woodie (AUWWI)"
  },
  {
   value: "Woomera (AUUMR)",
   label: "Woomera (AUUMR)"
  },
  {
   value: "Wrotham Park (AUWPK)",
   label: "Wrotham Park (AUWPK)"
  },
  {
   value: "Wudinna (AUWUD)",
   label: "Wudinna (AUWUD)"
  },
  {
   value: "Wyndham (AUWYN)",
   label: "Wyndham (AUWYN)"
  },
  {
   value: "Wynyard (AUWNY)",
   label: "Wynyard (AUWNY)"
  },
  {
   value: "Yalata Mission (AUKYI)",
   label: "Yalata Mission (AUKYI)"
  },
  {
   value: "Yalgoo (AUYLG)",
   label: "Yalgoo (AUYLG)"
  },
  {
   value: "Yam Island (AUXMY)",
   label: "Yam Island (AUXMY)"
  },
  {
   value: "Yamba (AUYBA)",
   label: "Yamba (AUYBA)"
  },
  {
   value: "Yampi (AUYAM)",
   label: "Yampi (AUYAM)"
  },
  {
   value: "Yangoonabie (AUKYB)",
   label: "Yangoonabie (AUKYB)"
  },
  {
   value: "Yeelirrie (AUKYF)",
   label: "Yeelirrie (AUKYF)"
  },
  {
   value: "Yorke Island (AUOKR)",
   label: "Yorke Island (AUOKR)"
  },
  {
   value: "Yorketown (AUORR)",
   label: "Yorketown (AUORR)"
  },
  {
   value: "Young (AUNGA)",
   label: "Young (AUNGA)"
  },
  {
   value: "Yuendumu (AUYUE)",
   label: "Yuendumu (AUYUE)"
  },
  {
   value: "BRISBANE\/SALISBURY (AUSBY)",
   label: "BRISBANE\/SALISBURY (AUSBY)"
  },
  {
   value: "Aruba (AWAUA)",
   label: "Aruba (AWAUA)"
  },
  {
   value: "Barcadera (AWBAR)",
   label: "Barcadera (AWBAR)"
  },
  {
   value: "Bushiribana (AWBUS)",
   label: "Bushiribana (AWBUS)"
  },
  {
   value: "Druif (AWDEU)",
   label: "Druif (AWDEU)"
  },
  {
   value: "Oranjestad (AWORJ)",
   label: "Oranjestad (AWORJ)"
  },
  {
   value: "Sint Nicolaas (AWSNL)",
   label: "Sint Nicolaas (AWSNL)"
  },
  {
   value: "Baku (AZBAK)",
   label: "Baku (AZBAK)"
  },
  {
   value: "Djulfa (AZDJU)",
   label: "Djulfa (AZDJU)"
  },
  {
   value: "Gyandzha (AZKVD)",
   label: "Gyandzha (AZKVD)"
  },
  {
   value: "Banja Luka (BABNX)",
   label: "Banja Luka (BABNX)"
  },
  {
   value: "Mostar (BAOMO)",
   label: "Mostar (BAOMO)"
  },
  {
   value: "Sarajevo (BASJJ)",
   label: "Sarajevo (BASJJ)"
  },
  {
   value: "Bridgetown (BBBGI)",
   label: "Bridgetown (BBBGI)"
  },
  {
   value: "Akhaura (BDAKH)",
   label: "Akhaura (BDAKH)"
  },
  {
   value: "Barisal (BDBZL)",
   label: "Barisal (BDBZL)"
  },
  {
   value: "Chalna (BDCHL)",
   label: "Chalna (BDCHL)"
  },
  {
   value: "Tumut (AUTUM)",
   label: "Tumut (AUTUM)"
  },
  {
   value: "Turkey Creek (AUTKY)",
   label: "Turkey Creek (AUTKY)"
  },
  {
   value: "Ulverstone (AUULV)",
   label: "Ulverstone (AUULV)"
  },
  {
   value: "Undarra (AUUDA)",
   label: "Undarra (AUUDA)"
  },
  {
   value: "Urangan (AUURN)",
   label: "Urangan (AUURN)"
  },
  {
   value: "Useless Loop (AUUSL)",
   label: "Useless Loop (AUUSL)"
  },
  {
   value: "Vanrook (AUVNR)",
   label: "Vanrook (AUVNR)"
  },
  {
   value: "Varanus Island (AUVAR)",
   label: "Varanus Island (AUVAR)"
  },
  {
   value: "Victoria River Downs (AUVCD)",
   label: "Victoria River Downs (AUVCD)"
  },
  {
   value: "Wacol (AUWCL)",
   label: "Wacol (AUWCL)"
  },
  {
   value: "Wagga Wagga (AUWGA)",
   label: "Wagga Wagga (AUWGA)"
  },
  {
   value: "Walcha (AUWLC)",
   label: "Walcha (AUWLC)"
  },
  {
   value: "Walgett (AUWGE)",
   label: "Walgett (AUWGE)"
  },
  {
   value: "Wallal (AUWLA)",
   label: "Wallal (AUWLA)"
  },
  {
   value: "Wallangarra (AUWLG)",
   label: "Wallangarra (AUWLG)"
  },
  {
   value: "Wallaroo (AUWAL)",
   label: "Wallaroo (AUWAL)"
  },
  {
   value: "Wallis (AUWLS)",
   label: "Wallis (AUWLS)"
  },
  {
   value: "Wangaratta (AUWGT)",
   label: "Wangaratta (AUWGT)"
  },
  {
   value: "Warracknabeal (AUWKB)",
   label: "Warracknabeal (AUWKB)"
  },
  {
   value: "Warrawagine (AUWRW)",
   label: "Warrawagine (AUWRW)"
  },
  {
   value: "Warrnambool (AUWMB)",
   label: "Warrnambool (AUWMB)"
  },
  {
   value: "Warwick (AUWAZ)",
   label: "Warwick (AUWAZ)"
  },
  {
   value: "Waterloo (AUWLO)",
   label: "Waterloo (AUWLO)"
  },
  {
   value: "Wauchope (AUWAU)",
   label: "Wauchope (AUWAU)"
  },
  {
   value: "Wave Hill (AUWAV)",
   label: "Wave Hill (AUWAV)"
  },
  {
   value: "Waverney (AUWAN)",
   label: "Waverney (AUWAN)"
  },
  {
   value: "Wee Waa (AUWEW)",
   label: "Wee Waa (AUWEW)"
  },
  {
   value: "Weipa (AUWEI)",
   label: "Weipa (AUWEI)"
  },
  {
   value: "Welshpool (AUWHL)",
   label: "Welshpool (AUWHL)"
  },
  {
   value: "West Wyalong (AUWWY)",
   label: "West Wyalong (AUWWY)"
  },
  {
   value: "Westernport (AUWEP)",
   label: "Westernport (AUWEP)"
  },
  {
   value: "Whyalla (AUWYA)",
   label: "Whyalla (AUWYA)"
  },
  {
   value: "Wilcannia (AUWIO)",
   label: "Wilcannia (AUWIO)"
  },
  {
   value: "Williamtown (AUWLM)",
   label: "Williamtown (AUWLM)"
  },
  {
   value: "Willoughby (AUWBY)",
   label: "Willoughby (AUWBY)"
  },
  {
   value: "Wiluna (AUWUN)",
   label: "Wiluna (AUWUN)"
  },
  {
   value: "Windarra (AUWND)",
   label: "Windarra (AUWND)"
  },
  {
   value: "Windorah (AUWNR)",
   label: "Windorah (AUWNR)"
  },
  {
   value: "Winton (AUWIN)",
   label: "Winton (AUWIN)"
  },
  {
   value: "Wittendom (AUWIT)",
   label: "Wittendom (AUWIT)"
  },
  {
   value: "Strahan (AUSRN)",
   label: "Strahan (AUSRN)"
  },
  {
   value: "Strathmore (AUSTH)",
   label: "Strathmore (AUSTH)"
  },
  {
   value: "Streaky Bay (AUKBY)",
   label: "Streaky Bay (AUKBY)"
  },
  {
   value: "Sturt Creek (AUSSK)",
   label: "Sturt Creek (AUSSK)"
  },
  {
   value: "Sue Island (AUSYU)",
   label: "Sue Island (AUSYU)"
  },
  {
   value: "Surfers Paradise (AUSFP)",
   label: "Surfers Paradise (AUSFP)"
  },
  {
   value: "Swan Hill (AUSWH)",
   label: "Swan Hill (AUSWH)"
  },
  {
   value: "Sydney (AUSYD)",
   label: "Sydney (AUSYD)"
  },
  {
   value: "Tableland (AUTBL)",
   label: "Tableland (AUTBL)"
  },
  {
   value: "Tamworth (AUTMW)",
   label: "Tamworth (AUTMW)"
  },
  {
   value: "Tanbar (AUTXR)",
   label: "Tanbar (AUTXR)"
  },
  {
   value: "Tangalooma (AUTAN)",
   label: "Tangalooma (AUTAN)"
  },
  {
   value: "Tara (AUXTR)",
   label: "Tara (AUXTR)"
  },
  {
   value: "Tarcoola (AUTAQ)",
   label: "Tarcoola (AUTAQ)"
  },
  {
   value: "Taree (AUTRO)",
   label: "Taree (AUTRO)"
  },
  {
   value: "Taroom (AUXTO)",
   label: "Taroom (AUXTO)"
  },
  {
   value: "Telfer (AUTEF)",
   label: "Telfer (AUTEF)"
  },
  {
   value: "Temora (AUTEM)",
   label: "Temora (AUTEM)"
  },
  {
   value: "Tennant Creek (AUTCA)",
   label: "Tennant Creek (AUTCA)"
  },
  {
   value: "Tewantin (AUTWN)",
   label: "Tewantin (AUTWN)"
  },
  {
   value: "Thangool (AUTHG)",
   label: "Thangool (AUTHG)"
  },
  {
   value: "Thargomindah (AUXTG)",
   label: "Thargomindah (AUXTG)"
  },
  {
   value: "Theodore (AUTDR)",
   label: "Theodore (AUTDR)"
  },
  {
   value: "Thevenard (AUTHE)",
   label: "Thevenard (AUTHE)"
  },
  {
   value: "Thursday Island (AUTIS)",
   label: "Thursday Island (AUTIS)"
  },
  {
   value: "Thylungra (AUTYG)",
   label: "Thylungra (AUTYG)"
  },
  {
   value: "Tibooburra (AUTYB)",
   label: "Tibooburra (AUTYB)"
  },
  {
   value: "Timber Creek (AUTBK)",
   label: "Timber Creek (AUTBK)"
  },
  {
   value: "Timber Point (AUTPT)",
   label: "Timber Point (AUTPT)"
  },
  {
   value: "Tindal (AUTIN)",
   label: "Tindal (AUTIN)"
  },
  {
   value: "Tobermorey (AUTYP)",
   label: "Tobermorey (AUTYP)"
  },
  {
   value: "Tocumwal (AUTCW)",
   label: "Tocumwal (AUTCW)"
  },
  {
   value: "Tom Price (AUTPR)",
   label: "Tom Price (AUTPR)"
  },
  {
   value: "Toowoomba (AUTWB)",
   label: "Toowoomba (AUTWB)"
  },
  {
   value: "Torwood (AUTWP)",
   label: "Torwood (AUTWP)"
  },
  {
   value: "Towford Bay (AUTOB)",
   label: "Towford Bay (AUTOB)"
  },
  {
   value: "Townsville (AUTSV)",
   label: "Townsville (AUTSV)"
  },
  {
   value: "Traralgon (AUTGN)",
   label: "Traralgon (AUTGN)"
  },
  {
   value: "Trial Bay (AUTRB)",
   label: "Trial Bay (AUTRB)"
  },
  {
   value: "Tullamarine (AUTME)",
   label: "Tullamarine (AUTME)"
  },
  {
   value: "Rottnest Island (AURTS)",
   label: "Rottnest Island (AURTS)"
  },
  {
   value: "Roy Hill (AURHL)",
   label: "Roy Hill (AURHL)"
  },
  {
   value: "Rutland Plains (AURTP)",
   label: "Rutland Plains (AURTP)"
  },
  {
   value: "Saibai Island (AUSBR)",
   label: "Saibai Island (AUSBR)"
  },
  {
   value: "Saladin Marine Terminal (AUSMT)",
   label: "Saladin Marine Terminal (AUSMT)"
  },
  {
   value: "Sale (AUSXE)",
   label: "Sale (AUSXE)"
  },
  {
   value: "Sandringham (AUSRM)",
   label: "Sandringham (AUSRM)"
  },
  {
   value: "Sandstone (AUNDS)",
   label: "Sandstone (AUNDS)"
  },
  {
   value: "Scone (AUNSO)",
   label: "Scone (AUNSO)"
  },
  {
   value: "Shark Bay (AUSHB)",
   label: "Shark Bay (AUSHB)"
  },
  {
   value: "Shaw River (AUSWB)",
   label: "Shaw River (AUSWB)"
  },
  {
   value: "Shay Gap (AUSGP)",
   label: "Shay Gap (AUSGP)"
  },
  {
   value: "Shepparton (AUSHT)",
   label: "Shepparton (AUSHT)"
  },
  {
   value: "Shute Harbour (AUJHQ)",
   label: "Shute Harbour (AUJHQ)"
  },
  {
   value: "Silver Plains (AUSSP)",
   label: "Silver Plains (AUSSP)"
  },
  {
   value: "Singleton (AUSIX)",
   label: "Singleton (AUSIX)"
  },
  {
   value: "Skua Venture (oil terminal) (AUSKV)",
   label: "Skua Venture (oil terminal) (AUSKV)"
  },
  {
   value: "Smith Point (AUSHU)",
   label: "Smith Point (AUSHU)"
  },
  {
   value: "Smithton (AUSIO)",
   label: "Smithton (AUSIO)"
  },
  {
   value: "Snake Bay (AUSNB)",
   label: "Snake Bay (AUSNB)"
  },
  {
   value: "South Galway (AUZGL)",
   label: "South Galway (AUZGL)"
  },
  {
   value: "South Molle Island (AUSOI)",
   label: "South Molle Island (AUSOI)"
  },
  {
   value: "South West Rocks (AUSWR)",
   label: "South West Rocks (AUSWR)"
  },
  {
   value: "Southern Cross (AUSQC)",
   label: "Southern Cross (AUSQC)"
  },
  {
   value: "Southport (AUSHQ)",
   label: "Southport (AUSHQ)"
  },
  {
   value: "Spring Bay (AUSPB)",
   label: "Spring Bay (AUSPB)"
  },
  {
   value: "Spring Creek (AUSCG)",
   label: "Spring Creek (AUSCG)"
  },
  {
   value: "Springvale (AUKSV)",
   label: "Springvale (AUKSV)"
  },
  {
   value: "Springvale (AUZVG)",
   label: "Springvale (AUZVG)"
  },
  {
   value: "St George (AUSGO)",
   label: "St George (AUSGO)"
  },
  {
   value: "St Helens (AUHLS)",
   label: "St Helens (AUHLS)"
  },
  {
   value: "St Paul's Mission (AUSVM)",
   label: "St Paul's Mission (AUSVM)"
  },
  {
   value: "Stanley (AUSTA)",
   label: "Stanley (AUSTA)"
  },
  {
   value: "Stanthorpe (AUSNH)",
   label: "Stanthorpe (AUSNH)"
  },
  {
   value: "Starcke (AUSQP)",
   label: "Starcke (AUSQP)"
  },
  {
   value: "Stawell (AUSWC)",
   label: "Stawell (AUSWC)"
  },
  {
   value: "Stephen Island (AUSTF)",
   label: "Stephen Island (AUSTF)"
  },
  {
   value: "Stradbroke Island (AUSRR)",
   label: "Stradbroke Island (AUSRR)"
  },
  {
   value: "Port Hunter (AUPHJ)",
   label: "Port Hunter (AUPHJ)"
  },
  {
   value: "Port Huon (AUPHU)",
   label: "Port Huon (AUPHU)"
  },
  {
   value: "Port Jackson (AUPJK)",
   label: "Port Jackson (AUPJK)"
  },
  {
   value: "Port Keats (AUPKT)",
   label: "Port Keats (AUPKT)"
  },
  {
   value: "Port Kembla (AUPKL)",
   label: "Port Kembla (AUPKL)"
  },
  {
   value: "Port Latta (AUPLA)",
   label: "Port Latta (AUPLA)"
  },
  {
   value: "Port Lincoln (AUPLO)",
   label: "Port Lincoln (AUPLO)"
  },
  {
   value: "Port Macquarie (AUPQQ)",
   label: "Port Macquarie (AUPQQ)"
  },
  {
   value: "Port Pirie (AUPPI)",
   label: "Port Pirie (AUPPI)"
  },
  {
   value: "Port Stanley (AUPSY)",
   label: "Port Stanley (AUPSY)"
  },
  {
   value: "Port Stanvac (AUPST)",
   label: "Port Stanvac (AUPST)"
  },
  {
   value: "Port Stephens (AUPTE)",
   label: "Port Stephens (AUPTE)"
  },
  {
   value: "Port Walcott (AUPWL)",
   label: "Port Walcott (AUPWL)"
  },
  {
   value: "Port Warrender (AUPWR)",
   label: "Port Warrender (AUPWR)"
  },
  {
   value: "Portland (AUPTJ)",
   label: "Portland (AUPTJ)"
  },
  {
   value: "Price (AUPRC)",
   label: "Price (AUPRC)"
  },
  {
   value: "Proper Bay (AUPRB)",
   label: "Proper Bay (AUPRB)"
  },
  {
   value: "Proserpine (AUPPP)",
   label: "Proserpine (AUPPP)"
  },
  {
   value: "Queenstown (AUUEE)",
   label: "Queenstown (AUUEE)"
  },
  {
   value: "Quilpie (AUULP)",
   label: "Quilpie (AUULP)"
  },
  {
   value: "Quirindi (AUUIR)",
   label: "Quirindi (AUUIR)"
  },
  {
   value: "Ramingining (AURAM)",
   label: "Ramingining (AURAM)"
  },
  {
   value: "Rapid Bay (AURAB)",
   label: "Rapid Bay (AURAB)"
  },
  {
   value: "Renmark (AURMK)",
   label: "Renmark (AURMK)"
  },
  {
   value: "Richmond (AURCM)",
   label: "Richmond (AURCM)"
  },
  {
   value: "Richmond (AURCH)",
   label: "Richmond (AURCH)"
  },
  {
   value: "Risdon (AURDN)",
   label: "Risdon (AURDN)"
  },
  {
   value: "Robinhood (AUROH)",
   label: "Robinhood (AUROH)"
  },
  {
   value: "Robinson River (AURRV)",
   label: "Robinson River (AURRV)"
  },
  {
   value: "Robinvale (AURBC)",
   label: "Robinvale (AURBC)"
  },
  {
   value: "Rockhampton (AUROK)",
   label: "Rockhampton (AUROK)"
  },
  {
   value: "Rockhampton Downs (AURDA)",
   label: "Rockhampton Downs (AURDA)"
  },
  {
   value: "Roebourne (AURBU)",
   label: "Roebourne (AURBU)"
  },
  {
   value: "Rokeby (AURKY)",
   label: "Rokeby (AURKY)"
  },
  {
   value: "Roma (AURMA)",
   label: "Roma (AURMA)"
  },
  {
   value: "Roper Bar (AURPB)",
   label: "Roper Bar (AURPB)"
  },
  {
   value: "Roper Valley (AURPV)",
   label: "Roper Valley (AURPV)"
  },
  {
   value: "Roseberth (AURSB)",
   label: "Roseberth (AURSB)"
  },
  {
   value: "Rosella Plains (AURLP)",
   label: "Rosella Plains (AURLP)"
  },
  {
   value: "Oakey (AUOKY)",
   label: "Oakey (AUOKY)"
  },
  {
   value: "Oban (AUOBA)",
   label: "Oban (AUOBA)"
  },
  {
   value: "Oenpelli (AUOPI)",
   label: "Oenpelli (AUOPI)"
  },
  {
   value: "Olympic Dam (AUOLP)",
   label: "Olympic Dam (AUOLP)"
  },
  {
   value: "Onslow (AUONS)",
   label: "Onslow (AUONS)"
  },
  {
   value: "Oodnadatta (AUODD)",
   label: "Oodnadatta (AUODD)"
  },
  {
   value: "Orange (AUOAG)",
   label: "Orange (AUOAG)"
  },
  {
   value: "Orbost (AURBS)",
   label: "Orbost (AURBS)"
  },
  {
   value: "Orchid Beach (AUOKB)",
   label: "Orchid Beach (AUOKB)"
  },
  {
   value: "Ord River (AUODR)",
   label: "Ord River (AUODR)"
  },
  {
   value: "Orientos (AUOXO)",
   label: "Orientos (AUOXO)"
  },
  {
   value: "Orpheus Island Resort (AUORS)",
   label: "Orpheus Island Resort (AUORS)"
  },
  {
   value: "Osborne Island (AUOSB)",
   label: "Osborne Island (AUOSB)"
  },
  {
   value: "Ouyen (AUOYN)",
   label: "Ouyen (AUOYN)"
  },
  {
   value: "Palm Island (AUPMK)",
   label: "Palm Island (AUPMK)"
  },
  {
   value: "Pandie Pandie (AUPDE)",
   label: "Pandie Pandie (AUPDE)"
  },
  {
   value: "Paraburdoo (AUPBO)",
   label: "Paraburdoo (AUPBO)"
  },
  {
   value: "Pardoo (AUPRD)",
   label: "Pardoo (AUPRD)"
  },
  {
   value: "Parkes (AUPKE)",
   label: "Parkes (AUPKE)"
  },
  {
   value: "Parndana (AUPDN)",
   label: "Parndana (AUPDN)"
  },
  {
   value: "Parramatta (AUPRM)",
   label: "Parramatta (AUPRM)"
  },
  {
   value: "Pearce (AUPCE)",
   label: "Pearce (AUPCE)"
  },
  {
   value: "Pelican Point (AUPEL)",
   label: "Pelican Point (AUPEL)"
  },
  {
   value: "Penneshaw (AUPEA)",
   label: "Penneshaw (AUPEA)"
  },
  {
   value: "Penong (AUPEY)",
   label: "Penong (AUPEY)"
  },
  {
   value: "Peppimenarti (AUPEP)",
   label: "Peppimenarti (AUPEP)"
  },
  {
   value: "Perth (AUPER)",
   label: "Perth (AUPER)"
  },
  {
   value: "Point Samson (AUPSM)",
   label: "Point Samson (AUPSM)"
  },
  {
   value: "Point Wilson (AUPWI)",
   label: "Point Wilson (AUPWI)"
  },
  {
   value: "Port Adelaide (AUPAE)",
   label: "Port Adelaide (AUPAE)"
  },
  {
   value: "Port Alma (AUPTL)",
   label: "Port Alma (AUPTL)"
  },
  {
   value: "Port Arthur (AUPAU)",
   label: "Port Arthur (AUPAU)"
  },
  {
   value: "Port Augusta (AUPUG)",
   label: "Port Augusta (AUPUG)"
  },
  {
   value: "Port Bonython (AUPBY)",
   label: "Port Bonython (AUPBY)"
  },
  {
   value: "Port Botany (AUPBT)",
   label: "Port Botany (AUPBT)"
  },
  {
   value: "Port Curtis (AUPCT)",
   label: "Port Curtis (AUPCT)"
  },
  {
   value: "Port Dalrymple (AUPTD)",
   label: "Port Dalrymple (AUPTD)"
  },
  {
   value: "Port Douglas (AUPTI)",
   label: "Port Douglas (AUPTI)"
  },
  {
   value: "Port Giles (AUPGI)",
   label: "Port Giles (AUPGI)"
  },
  {
   value: "Port Hedland (AUPHE)",
   label: "Port Hedland (AUPHE)"
  },
  {
   value: "Mt Cavenagh (AUMKV)",
   label: "Mt Cavenagh (AUMKV)"
  },
  {
   value: "Mt Sandford (AUMTD)",
   label: "Mt Sandford (AUMTD)"
  },
  {
   value: "Muccan (AUMUQ)",
   label: "Muccan (AUMUQ)"
  },
  {
   value: "Mudgee (AUDGE)",
   label: "Mudgee (AUDGE)"
  },
  {
   value: "Mulga Park (AUMUP)",
   label: "Mulga Park (AUMUP)"
  },
  {
   value: "Mulka (AUMVK)",
   label: "Mulka (AUMVK)"
  },
  {
   value: "Mullewa (AUMXU)",
   label: "Mullewa (AUMXU)"
  },
  {
   value: "Mungeranie (AUMNE)",
   label: "Mungeranie (AUMNE)"
  },
  {
   value: "Murray Island (AUMYI)",
   label: "Murray Island (AUMYI)"
  },
  {
   value: "Musgrave (AUMVU)",
   label: "Musgrave (AUMVU)"
  },
  {
   value: "Muttaburra (AUUTB)",
   label: "Muttaburra (AUUTB)"
  },
  {
   value: "Myroodah (AUMYO)",
   label: "Myroodah (AUMYO)"
  },
  {
   value: "Nambour (AUNBR)",
   label: "Nambour (AUNBR)"
  },
  {
   value: "Nambucca Heads (AUNBH)",
   label: "Nambucca Heads (AUNBH)"
  },
  {
   value: "Nappa Merry (AUNMR)",
   label: "Nappa Merry (AUNMR)"
  },
  {
   value: "Napperby (AUNPP)",
   label: "Napperby (AUNPP)"
  },
  {
   value: "Naracoorte (AUNAC)",
   label: "Naracoorte (AUNAC)"
  },
  {
   value: "Narrabri (AUNAA)",
   label: "Narrabri (AUNAA)"
  },
  {
   value: "Narracoopa (AUNAR)",
   label: "Narracoopa (AUNAR)"
  },
  {
   value: "Narrandera (AUNRA)",
   label: "Narrandera (AUNRA)"
  },
  {
   value: "Narrogin (AUNRG)",
   label: "Narrogin (AUNRG)"
  },
  {
   value: "New Moon (AUNMP)",
   label: "New Moon (AUNMP)"
  },
  {
   value: "Newcastle (AUNTL)",
   label: "Newcastle (AUNTL)"
  },
  {
   value: "Newman (AUNWM)",
   label: "Newman (AUNWM)"
  },
  {
   value: "Newry (AUNRY)",
   label: "Newry (AUNRY)"
  },
  {
   value: "Newstead (AUNSD)",
   label: "Newstead (AUNSD)"
  },
  {
   value: "Ngukurr (AURPM)",
   label: "Ngukurr (AURPM)"
  },
  {
   value: "Nicholson (AUNLS)",
   label: "Nicholson (AUNLS)"
  },
  {
   value: "Nifty (AUNIF)",
   label: "Nifty (AUNIF)"
  },
  {
   value: "Noonkanbah (AUNKB)",
   label: "Noonkanbah (AUNKB)"
  },
  {
   value: "Noosa (AUNSA)",
   label: "Noosa (AUNSA)"
  },
  {
   value: "Noosaville (AUNSV)",
   label: "Noosaville (AUNSV)"
  },
  {
   value: "Normanton (AUNTN)",
   label: "Normanton (AUNTN)"
  },
  {
   value: "Norseman (AUNSM)",
   label: "Norseman (AUNSM)"
  },
  {
   value: "Nowra (AUNOA)",
   label: "Nowra (AUNOA)"
  },
  {
   value: "Nullagine (AUNLL)",
   label: "Nullagine (AUNLL)"
  },
  {
   value: "Nullarbor (AUNUR)",
   label: "Nullarbor (AUNUR)"
  },
  {
   value: "Numbulwar (AUNUB)",
   label: "Numbulwar (AUNUB)"
  },
  {
   value: "Nuriootpa (AUNOO)",
   label: "Nuriootpa (AUNOO)"
  },
  {
   value: "Nutwood Downs (AUUTD)",
   label: "Nutwood Downs (AUUTD)"
  },
  {
   value: "Nyngan (AUNYN)",
   label: "Nyngan (AUNYN)"
  },
  {
   value: "Milingimbi (AUMGT)",
   label: "Milingimbi (AUMGT)"
  },
  {
   value: "Millicent (AUMLR)",
   label: "Millicent (AUMLR)"
  },
  {
   value: "Milner Bay (AUMIB)",
   label: "Milner Bay (AUMIB)"
  },
  {
   value: "Miners Lake (AUMRL)",
   label: "Miners Lake (AUMRL)"
  },
  {
   value: "Minlaton (AUXML)",
   label: "Minlaton (AUXML)"
  },
  {
   value: "Minnipa (AUMIN)",
   label: "Minnipa (AUMIN)"
  },
  {
   value: "Miranda Downs (AUMWY)",
   label: "Miranda Downs (AUMWY)"
  },
  {
   value: "Mitchell (AUMTQ)",
   label: "Mitchell (AUMTQ)"
  },
  {
   value: "Mitchell Plateau (AUMIH)",
   label: "Mitchell Plateau (AUMIH)"
  },
  {
   value: "Mitchell River (AUMXQ)",
   label: "Mitchell River (AUMXQ)"
  },
  {
   value: "Mittiebah (AUMIY)",
   label: "Mittiebah (AUMIY)"
  },
  {
   value: "Monkey Mia (AUMJK)",
   label: "Monkey Mia (AUMJK)"
  },
  {
   value: "Monkira (AUONR)",
   label: "Monkira (AUONR)"
  },
  {
   value: "Monto (AUMNQ)",
   label: "Monto (AUMNQ)"
  },
  {
   value: "Moolawatana (AUMWT)",
   label: "Moolawatana (AUMWT)"
  },
  {
   value: "Moomba (AUMOO)",
   label: "Moomba (AUMOO)"
  },
  {
   value: "Moorabbin (AUMBW)",
   label: "Moorabbin (AUMBW)"
  },
  {
   value: "Mooraberree (AUOOR)",
   label: "Mooraberree (AUOOR)"
  },
  {
   value: "Moranbah (AUMOV)",
   label: "Moranbah (AUMOV)"
  },
  {
   value: "Morawa (AUMWB)",
   label: "Morawa (AUMWB)"
  },
  {
   value: "Moree (AUMRZ)",
   label: "Moree (AUMRZ)"
  },
  {
   value: "Moreton (AUMET)",
   label: "Moreton (AUMET)"
  },
  {
   value: "Morney (AUOXY)",
   label: "Morney (AUOXY)"
  },
  {
   value: "Mornington (AUONG)",
   label: "Mornington (AUONG)"
  },
  {
   value: "Moroak (AUMRT)",
   label: "Moroak (AUMRT)"
  },
  {
   value: "Moruya (AUMYA)",
   label: "Moruya (AUMYA)"
  },
  {
   value: "Mount Buffalo (AUMBF)",
   label: "Mount Buffalo (AUMBF)"
  },
  {
   value: "Mount Full Stop (AUMFL)",
   label: "Mount Full Stop (AUMFL)"
  },
  {
   value: "Mount Gambier (AUMGB)",
   label: "Mount Gambier (AUMGB)"
  },
  {
   value: "Mount Gunson (AUGSN)",
   label: "Mount Gunson (AUGSN)"
  },
  {
   value: "Mount Hotham (AUMHU)",
   label: "Mount Hotham (AUMHU)"
  },
  {
   value: "Mount House (AUMHO)",
   label: "Mount House (AUMHO)"
  },
  {
   value: "Mount Isa (AUISA)",
   label: "Mount Isa (AUISA)"
  },
  {
   value: "Mount Keith (AUWME)",
   label: "Mount Keith (AUWME)"
  },
  {
   value: "Mount Magnet (AUMMG)",
   label: "Mount Magnet (AUMMG)"
  },
  {
   value: "Mount Swan (AUMSF)",
   label: "Mount Swan (AUMSF)"
  },
  {
   value: "Mountain Valley (AUMNV)",
   label: "Mountain Valley (AUMNV)"
  },
  {
   value: "Mourilyan (AUMOU)",
   label: "Mourilyan (AUMOU)"
  },
  {
   value: "Mt Barnett (AUMBN)",
   label: "Mt Barnett (AUMBN)"
  },
  {
   value: "Longreach (AULRE)",
   label: "Longreach (AULRE)"
  },
  {
   value: "Lord Howe Is (AULDH)",
   label: "Lord Howe Is (AULDH)"
  },
  {
   value: "Lorraine (AULOA)",
   label: "Lorraine (AULOA)"
  },
  {
   value: "Lotusvale (AULTV)",
   label: "Lotusvale (AULTV)"
  },
  {
   value: "Lucinda (AULUC)",
   label: "Lucinda (AULUC)"
  },
  {
   value: "Lyndhurst (AULTP)",
   label: "Lyndhurst (AULTP)"
  },
  {
   value: "Mabuiag Island (AUUBB)",
   label: "Mabuiag Island (AUUBB)"
  },
  {
   value: "Macdonald Downs (AUMNW)",
   label: "Macdonald Downs (AUMNW)"
  },
  {
   value: "Mackay (AUMKY)",
   label: "Mackay (AUMKY)"
  },
  {
   value: "Macksville (AUMVH)",
   label: "Macksville (AUMVH)"
  },
  {
   value: "Macmahon Camp 4 (AUMHC)",
   label: "Macmahon Camp 4 (AUMHC)"
  },
  {
   value: "Mainoru (AUMIZ)",
   label: "Mainoru (AUMIZ)"
  },
  {
   value: "Maitland (AUMTL)",
   label: "Maitland (AUMTL)"
  },
  {
   value: "Mallacoota (AUXMC)",
   label: "Mallacoota (AUXMC)"
  },
  {
   value: "Mandora (AUMQA)",
   label: "Mandora (AUMQA)"
  },
  {
   value: "Maningrida (AUMNG)",
   label: "Maningrida (AUMNG)"
  },
  {
   value: "Manjimup (AUMJP)",
   label: "Manjimup (AUMJP)"
  },
  {
   value: "Manners Creek (AUMFP)",
   label: "Manners Creek (AUMFP)"
  },
  {
   value: "Marble Bar (AUMBB)",
   label: "Marble Bar (AUMBB)"
  },
  {
   value: "Mareeba (AUMRG)",
   label: "Mareeba (AUMRG)"
  },
  {
   value: "Margaret River Station (AUMGV)",
   label: "Margaret River Station (AUMGV)"
  },
  {
   value: "Marion Downs (AUMXD)",
   label: "Marion Downs (AUMXD)"
  },
  {
   value: "Marla (AUMRP)",
   label: "Marla (AUMRP)"
  },
  {
   value: "Maroochydore apt\/Sunshine Coast (AUMCY)",
   label: "Maroochydore apt\/Sunshine Coast (AUMCY)"
  },
  {
   value: "Marqua (AUMQE)",
   label: "Marqua (AUMQE)"
  },
  {
   value: "Marree (AURRE)",
   label: "Marree (AURRE)"
  },
  {
   value: "Maryborough (AUMBH)",
   label: "Maryborough (AUMBH)"
  },
  {
   value: "Mayfield (AUMYF)",
   label: "Mayfield (AUMYF)"
  },
  {
   value: "Mcarthur River (AUMCV)",
   label: "Mcarthur River (AUMCV)"
  },
  {
   value: "Meekatharra (AUMKR)",
   label: "Meekatharra (AUMKR)"
  },
  {
   value: "Melbourne (AUMEL)",
   label: "Melbourne (AUMEL)"
  },
  {
   value: "Melbourne City Heliport (AUKAH)",
   label: "Melbourne City Heliport (AUKAH)"
  },
  {
   value: "Melrose (AUMRS)",
   label: "Melrose (AUMRS)"
  },
  {
   value: "Merimbula (AUMIM)",
   label: "Merimbula (AUMIM)"
  },
  {
   value: "Merinda (AUMDA)",
   label: "Merinda (AUMDA)"
  },
  {
   value: "Merluna (AUMLV)",
   label: "Merluna (AUMLV)"
  },
  {
   value: "Merty (AURTY)",
   label: "Merty (AURTY)"
  },
  {
   value: "Middlemount (AUMMM)",
   label: "Middlemount (AUMMM)"
  },
  {
   value: "Mildura (AUMQL)",
   label: "Mildura (AUMQL)"
  },
  {
   value: "Kirkimbie (AUKBB)",
   label: "Kirkimbie (AUKBB)"
  },
  {
   value: "Klein Point (AUKLP)",
   label: "Klein Point (AUKLP)"
  },
  {
   value: "Koolan Island (AUKOI)",
   label: "Koolan Island (AUKOI)"
  },
  {
   value: "Koolatah (AUKOH)",
   label: "Koolatah (AUKOH)"
  },
  {
   value: "Koolburra (AUKKP)",
   label: "Koolburra (AUKKP)"
  },
  {
   value: "Koonibba (AUKQB)",
   label: "Koonibba (AUKQB)"
  },
  {
   value: "Kowanyama (AUKWM)",
   label: "Kowanyama (AUKWM)"
  },
  {
   value: "Kubin Island (AUKUG)",
   label: "Kubin Island (AUKUG)"
  },
  {
   value: "Kulgera (AUKGR)",
   label: "Kulgera (AUKGR)"
  },
  {
   value: "Kununurra (AUKNX)",
   label: "Kununurra (AUKNX)"
  },
  {
   value: "Kurnell (AUKUR)",
   label: "Kurnell (AUKUR)"
  },
  {
   value: "Kurundi (AUKRD)",
   label: "Kurundi (AUKRD)"
  },
  {
   value: "Kwinana (AUKWI)",
   label: "Kwinana (AUKWI)"
  },
  {
   value: "Lady Barron (AULAB)",
   label: "Lady Barron (AULAB)"
  },
  {
   value: "Lady Elliot Island (AULYT)",
   label: "Lady Elliot Island (AULYT)"
  },
  {
   value: "Lake Evella (AULEL)",
   label: "Lake Evella (AULEL)"
  },
  {
   value: "Lake Nash (AULNH)",
   label: "Lake Nash (AULNH)"
  },
  {
   value: "Lakefield (AULFP)",
   label: "Lakefield (AULFP)"
  },
  {
   value: "Lakeland Downs (AULKD)",
   label: "Lakeland Downs (AULKD)"
  },
  {
   value: "Lansdowne (AULDW)",
   label: "Lansdowne (AULDW)"
  },
  {
   value: "Latrobe (AULTB)",
   label: "Latrobe (AULTB)"
  },
  {
   value: "Launceston (AULST)",
   label: "Launceston (AULST)"
  },
  {
   value: "Laura (AULUU)",
   label: "Laura (AULUU)"
  },
  {
   value: "Laura Station (AULUT)",
   label: "Laura Station (AULUT)"
  },
  {
   value: "Laverton (AULVO)",
   label: "Laverton (AULVO)"
  },
  {
   value: "Lawn Hill (AULWH)",
   label: "Lawn Hill (AULWH)"
  },
  {
   value: "Learmonth (AULEA)",
   label: "Learmonth (AULEA)"
  },
  {
   value: "Leigh Creek (AULGH)",
   label: "Leigh Creek (AULGH)"
  },
  {
   value: "Leinster (AULER)",
   label: "Leinster (AULER)"
  },
  {
   value: "Leonora (AULNO)",
   label: "Leonora (AULNO)"
  },
  {
   value: "Lightning Ridge (AULHG)",
   label: "Lightning Ridge (AULHG)"
  },
  {
   value: "Limbunya (AULIB)",
   label: "Limbunya (AULIB)"
  },
  {
   value: "Linda Downs (AULLP)",
   label: "Linda Downs (AULLP)"
  },
  {
   value: "Lindeman Island (AULDC)",
   label: "Lindeman Island (AULDC)"
  },
  {
   value: "Lismore (AULSY)",
   label: "Lismore (AULSY)"
  },
  {
   value: "Lissadell (AULLL)",
   label: "Lissadell (AULLL)"
  },
  {
   value: "Liverpool (AULIV)",
   label: "Liverpool (AULIV)"
  },
  {
   value: "Lizard Island (AULZR)",
   label: "Lizard Island (AULZR)"
  },
  {
   value: "Lock (AULOC)",
   label: "Lock (AULOC)"
  },
  {
   value: "Lockhart River (AUIRG)",
   label: "Lockhart River (AUIRG)"
  },
  {
   value: "Humbert River (AUHUB)",
   label: "Humbert River (AUHUB)"
  },
  {
   value: "Iffley (AUIFF)",
   label: "Iffley (AUIFF)"
  },
  {
   value: "Indulkana (AUIDK)",
   label: "Indulkana (AUIDK)"
  },
  {
   value: "Ingham (AUIGH)",
   label: "Ingham (AUIGH)"
  },
  {
   value: "Injune (AUINJ)",
   label: "Injune (AUINJ)"
  },
  {
   value: "Inkerman (AUIKP)",
   label: "Inkerman (AUIKP)"
  },
  {
   value: "Innamincka (AUINM)",
   label: "Innamincka (AUINM)"
  },
  {
   value: "Innisfail (AUIFL)",
   label: "Innisfail (AUIFL)"
  },
  {
   value: "Inverell (AUIVR)",
   label: "Inverell (AUIVR)"
  },
  {
   value: "Inverway (AUIVW)",
   label: "Inverway (AUIVW)"
  },
  {
   value: "Ipswich (AUIPS)",
   label: "Ipswich (AUIPS)"
  },
  {
   value: "Isisford (AUISI)",
   label: "Isisford (AUISI)"
  },
  {
   value: "Jabiru (AUJAB)",
   label: "Jabiru (AUJAB)"
  },
  {
   value: "Jabiru Venture (oil terminal) (AUJOV)",
   label: "Jabiru Venture (oil terminal) (AUJOV)"
  },
  {
   value: "Jandakot (AUJAD)",
   label: "Jandakot (AUJAD)"
  },
  {
   value: "Julia Creek (AUJCK)",
   label: "Julia Creek (AUJCK)"
  },
  {
   value: "Jundah (AUJUN)",
   label: "Jundah (AUJUN)"
  },
  {
   value: "Jurien Bay (AUJUR)",
   label: "Jurien Bay (AUJUR)"
  },
  {
   value: "Kalbarri (AUKAX)",
   label: "Kalbarri (AUKAX)"
  },
  {
   value: "Kalgoorlie (AUKGI)",
   label: "Kalgoorlie (AUKGI)"
  },
  {
   value: "Kalkurung (AUKFG)",
   label: "Kalkurung (AUKFG)"
  },
  {
   value: "Kalpowar (AUKPP)",
   label: "Kalpowar (AUKPP)"
  },
  {
   value: "Kalumburu (AUUBU)",
   label: "Kalumburu (AUUBU)"
  },
  {
   value: "Kamaran Downs (AUKDS)",
   label: "Kamaran Downs (AUKDS)"
  },
  {
   value: "Kambalda (AUKDB)",
   label: "Kambalda (AUKDB)"
  },
  {
   value: "Kamileroi (AUKML)",
   label: "Kamileroi (AUKML)"
  },
  {
   value: "Karratha (AUKTA)",
   label: "Karratha (AUKTA)"
  },
  {
   value: "Karumba (AUKRB)",
   label: "Karumba (AUKRB)"
  },
  {
   value: "Katanning (AUKNI)",
   label: "Katanning (AUKNI)"
  },
  {
   value: "Katherine (AUKTR)",
   label: "Katherine (AUKTR)"
  },
  {
   value: "Kempsey (AUKPS)",
   label: "Kempsey (AUKPS)"
  },
  {
   value: "Kerang (AUKRA)",
   label: "Kerang (AUKRA)"
  },
  {
   value: "Kimberley Downs (AUKBD)",
   label: "Kimberley Downs (AUKBD)"
  },
  {
   value: "King Bay (AUKIB)",
   label: "King Bay (AUKIB)"
  },
  {
   value: "King Is (AUKNS)",
   label: "King Is (AUKNS)"
  },
  {
   value: "Kingaroy (AUKGY)",
   label: "Kingaroy (AUKGY)"
  },
  {
   value: "Kings Canyon (AUKBJ)",
   label: "Kings Canyon (AUKBJ)"
  },
  {
   value: "Kings Creek Station (AUKCS)",
   label: "Kings Creek Station (AUKCS)"
  },
  {
   value: "Kingscote (AUKGC)",
   label: "Kingscote (AUKGC)"
  },
  {
   value: "Kingston (AUKIT)",
   label: "Kingston (AUKIT)"
  },
  {
   value: "Greenhead (AUGRH)",
   label: "Greenhead (AUGRH)"
  },
  {
   value: "Greenvale (AUGVP)",
   label: "Greenvale (AUGVP)"
  },
  {
   value: "Gregory Downs (AUGGD)",
   label: "Gregory Downs (AUGGD)"
  },
  {
   value: "Grenfell (AUGFE)",
   label: "Grenfell (AUGFE)"
  },
  {
   value: "Griffin Venture (oil terminal) (AUGRV)",
   label: "Griffin Venture (oil terminal) (AUGRV)"
  },
  {
   value: "Griffith (AUGFF)",
   label: "Griffith (AUGFF)"
  },
  {
   value: "Groote Eylandt (AUGTE)",
   label: "Groote Eylandt (AUGTE)"
  },
  {
   value: "Guildford (AUGDF)",
   label: "Guildford (AUGDF)"
  },
  {
   value: "Gunnedah (AUGUH)",
   label: "Gunnedah (AUGUH)"
  },
  {
   value: "Gympie (AUGYP)",
   label: "Gympie (AUGYP)"
  },
  {
   value: "Halls Creek (AUHCQ)",
   label: "Halls Creek (AUHCQ)"
  },
  {
   value: "Hamilton (AUHLT)",
   label: "Hamilton (AUHLT)"
  },
  {
   value: "Hamilton Island (AUHTI)",
   label: "Hamilton Island (AUHTI)"
  },
  {
   value: "Happy Bay \/ LONG ISLAND (AUHAP)",
   label: "Happy Bay \/ LONG ISLAND (AUHAP)"
  },
  {
   value: "Hardy Island (AUHYI)",
   label: "Hardy Island (AUHYI)"
  },
  {
   value: "Hawker (AUHWK)",
   label: "Hawker (AUHWK)"
  },
  {
   value: "Hay (AUHXX)",
   label: "Hay (AUHXX)"
  },
  {
   value: "Hayman Island (AUHIS)",
   label: "Hayman Island (AUHIS)"
  },
  {
   value: "Haypoint (AUHPT)",
   label: "Haypoint (AUHPT)"
  },
  {
   value: "Headingly (AUHIP)",
   label: "Headingly (AUHIP)"
  },
  {
   value: "Heathlands (AUHAT)",
   label: "Heathlands (AUHAT)"
  },
  {
   value: "Helenvale (AUHLV)",
   label: "Helenvale (AUHLV)"
  },
  {
   value: "Henbury (AUHRY)",
   label: "Henbury (AUHRY)"
  },
  {
   value: "Hermannsburg (AUHMG)",
   label: "Hermannsburg (AUHMG)"
  },
  {
   value: "Heron Island (AUHRN)",
   label: "Heron Island (AUHRN)"
  },
  {
   value: "Hervey Bay (AUHVB)",
   label: "Hervey Bay (AUHVB)"
  },
  {
   value: "Highbury (AUHIG)",
   label: "Highbury (AUHIG)"
  },
  {
   value: "Hillside (AUHLL)",
   label: "Hillside (AUHLL)"
  },
  {
   value: "Hinchinbrooke Island (AUHNK)",
   label: "Hinchinbrooke Island (AUHNK)"
  },
  {
   value: "Hobart (AUHBA)",
   label: "Hobart (AUHBA)"
  },
  {
   value: "Hook Island (AUHIH)",
   label: "Hook Island (AUHIH)"
  },
  {
   value: "Hooker Creek (AUHOK)",
   label: "Hooker Creek (AUHOK)"
  },
  {
   value: "Hope Tun (AUHOT)",
   label: "Hope Tun (AUHOT)"
  },
  {
   value: "Hope Vale (AUHPE)",
   label: "Hope Vale (AUHPE)"
  },
  {
   value: "Hopetoun (AUHTU)",
   label: "Hopetoun (AUHTU)"
  },
  {
   value: "Horn Island (AUHID)",
   label: "Horn Island (AUHID)"
  },
  {
   value: "Horsham (AUHSM)",
   label: "Horsham (AUHSM)"
  },
  {
   value: "Hughenden (AUHGD)",
   label: "Hughenden (AUHGD)"
  },
  {
   value: "Evans Head (AUEVH)",
   label: "Evans Head (AUEVH)"
  },
  {
   value: "Exmouth (AUPEX)",
   label: "Exmouth (AUPEX)"
  },
  {
   value: "Exmouth Gulf (AUEXM)",
   label: "Exmouth Gulf (AUEXM)"
  },
  {
   value: "Fairbarn (AUFBN)",
   label: "Fairbarn (AUFBN)"
  },
  {
   value: "Falls Creek (AUFLC)",
   label: "Falls Creek (AUFLC)"
  },
  {
   value: "Finke (AUFIK)",
   label: "Finke (AUFIK)"
  },
  {
   value: "Finley (AUFLY)",
   label: "Finley (AUFLY)"
  },
  {
   value: "Fisherman Islands (AUFIS)",
   label: "Fisherman Islands (AUFIS)"
  },
  {
   value: "Flinders Island (AUFLS)",
   label: "Flinders Island (AUFLS)"
  },
  {
   value: "Forbes (AUFRB)",
   label: "Forbes (AUFRB)"
  },
  {
   value: "Forrest (AUFOS)",
   label: "Forrest (AUFOS)"
  },
  {
   value: "Forster (AUFOT)",
   label: "Forster (AUFOT)"
  },
  {
   value: "Fossil Downs (AUFSL)",
   label: "Fossil Downs (AUFSL)"
  },
  {
   value: "Fremantle (AUFRE)",
   label: "Fremantle (AUFRE)"
  },
  {
   value: "Gamboola (AUGBP)",
   label: "Gamboola (AUGBP)"
  },
  {
   value: "Garden Point (AUGPN)",
   label: "Garden Point (AUGPN)"
  },
  {
   value: "Gascoyne Junction (AUGSC)",
   label: "Gascoyne Junction (AUGSC)"
  },
  {
   value: "Gayndah (AUGAH)",
   label: "Gayndah (AUGAH)"
  },
  {
   value: "Geelong (AUGEX)",
   label: "Geelong (AUGEX)"
  },
  {
   value: "George Town (AUGEE)",
   label: "George Town (AUGEE)"
  },
  {
   value: "Georgetown (AUGTT)",
   label: "Georgetown (AUGTT)"
  },
  {
   value: "Geraldton (AUGET)",
   label: "Geraldton (AUGET)"
  },
  {
   value: "Gibb River (AUGBV)",
   label: "Gibb River (AUGBV)"
  },
  {
   value: "Gladstone (AUGLT)",
   label: "Gladstone (AUGLT)"
  },
  {
   value: "Glebe Island (AUGLL)",
   label: "Glebe Island (AUGLL)"
  },
  {
   value: "Glen Innes (AUGLI)",
   label: "Glen Innes (AUGLI)"
  },
  {
   value: "Glengyle (AUGLG)",
   label: "Glengyle (AUGLG)"
  },
  {
   value: "Glenormiston (AUGLM)",
   label: "Glenormiston (AUGLM)"
  },
  {
   value: "Goldsworthy (AUGLY)",
   label: "Goldsworthy (AUGLY)"
  },
  {
   value: "Goode Is (AUGOI)",
   label: "Goode Is (AUGOI)"
  },
  {
   value: "Goondiwindi (AUGOO)",
   label: "Goondiwindi (AUGOO)"
  },
  {
   value: "Gordon Downs (AUGDD)",
   label: "Gordon Downs (AUGDD)"
  },
  {
   value: "Gosford (AUGOS)",
   label: "Gosford (AUGOS)"
  },
  {
   value: "Goulburn (AUGUL)",
   label: "Goulburn (AUGUL)"
  },
  {
   value: "Goulburn Island (AUGBL)",
   label: "Goulburn Island (AUGBL)"
  },
  {
   value: "Gove (AUGOV)",
   label: "Gove (AUGOV)"
  },
  {
   value: "Grafton (AUGFN)",
   label: "Grafton (AUGFN)"
  },
  {
   value: "Granites (AUGTS)",
   label: "Granites (AUGTS)"
  },
  {
   value: "Great Keppel Island (AUGKL)",
   label: "Great Keppel Island (AUGKL)"
  },
  {
   value: "Daydream Is (AUDDI)",
   label: "Daydream Is (AUDDI)"
  },
  {
   value: "Delissaville (AUDLV)",
   label: "Delissaville (AUDLV)"
  },
  {
   value: "Delta Downs (AUDDN)",
   label: "Delta Downs (AUDDN)"
  },
  {
   value: "Denham (AUDNM)",
   label: "Denham (AUDNM)"
  },
  {
   value: "Deniliquin (AUDNQ)",
   label: "Deniliquin (AUDNQ)"
  },
  {
   value: "Derby (AUDRB)",
   label: "Derby (AUDRB)"
  },
  {
   value: "Devonport (AUDPO)",
   label: "Devonport (AUDPO)"
  },
  {
   value: "Diamantina Lakes (AUDYM)",
   label: "Diamantina Lakes (AUDYM)"
  },
  {
   value: "Dirranbandi (AUDRN)",
   label: "Dirranbandi (AUDRN)"
  },
  {
   value: "Dixie (AUDXD)",
   label: "Dixie (AUDXD)"
  },
  {
   value: "Docker River (AUDKV)",
   label: "Docker River (AUDKV)"
  },
  {
   value: "Dongara (AUDOX)",
   label: "Dongara (AUDOX)"
  },
  {
   value: "Doomadgee (AUDMD)",
   label: "Doomadgee (AUDMD)"
  },
  {
   value: "Dorunda Station (AUDRD)",
   label: "Dorunda Station (AUDRD)"
  },
  {
   value: "Drumduff (AUDFP)",
   label: "Drumduff (AUDFP)"
  },
  {
   value: "Dubbo (AUDBO)",
   label: "Dubbo (AUDBO)"
  },
  {
   value: "Dulkaninna (AUDLK)",
   label: "Dulkaninna (AUDLK)"
  },
  {
   value: "Dunbar (AUDNB)",
   label: "Dunbar (AUDNB)"
  },
  {
   value: "Dunk Island (AUDKI)",
   label: "Dunk Island (AUDKI)"
  },
  {
   value: "Durham Downs (AUDHD)",
   label: "Durham Downs (AUDHD)"
  },
  {
   value: "Durrie (AUDRR)",
   label: "Durrie (AUDRR)"
  },
  {
   value: "Dysart (AUDYA)",
   label: "Dysart (AUDYA)"
  },
  {
   value: "Echuca (AUECH)",
   label: "Echuca (AUECH)"
  },
  {
   value: "Eden (AUQDN)",
   label: "Eden (AUQDN)"
  },
  {
   value: "Edinburgh (AUEBH)",
   label: "Edinburgh (AUEBH)"
  },
  {
   value: "Edithburgh (AUEDB)",
   label: "Edithburgh (AUEDB)"
  },
  {
   value: "Edward River (AUEDR)",
   label: "Edward River (AUEDR)"
  },
  {
   value: "Einasleigh (AUEIH)",
   label: "Einasleigh (AUEIH)"
  },
  {
   value: "Elcho Island (AUELC)",
   label: "Elcho Island (AUELC)"
  },
  {
   value: "Electrona (AUELE)",
   label: "Electrona (AUELE)"
  },
  {
   value: "Elkedra (AUEKD)",
   label: "Elkedra (AUEKD)"
  },
  {
   value: "Emerald (AUEMD)",
   label: "Emerald (AUEMD)"
  },
  {
   value: "Eneabba West (AUENB)",
   label: "Eneabba West (AUENB)"
  },
  {
   value: "Erldunda (AUEDD)",
   label: "Erldunda (AUEDD)"
  },
  {
   value: "Ernabella (AUERB)",
   label: "Ernabella (AUERB)"
  },
  {
   value: "Esperance (AUEPR)",
   label: "Esperance (AUEPR)"
  },
  {
   value: "Essendon Apt\/Melbourne (AUMEB)",
   label: "Essendon Apt\/Melbourne (AUMEB)"
  },
  {
   value: "Etadunna (AUETD)",
   label: "Etadunna (AUETD)"
  },
  {
   value: "Eucla (AUEUC)",
   label: "Eucla (AUEUC)"
  },
  {
   value: "Eva Downs (AUEVD)",
   label: "Eva Downs (AUEVD)"
  },
  {
   value: "Collinsville (AUKCE)",
   label: "Collinsville (AUKCE)"
  },
  {
   value: "Condobolin (AUCBX)",
   label: "Condobolin (AUCBX)"
  },
  {
   value: "Coober Pedy (AUCPD)",
   label: "Coober Pedy (AUCPD)"
  },
  {
   value: "Cooinda (AUCDA)",
   label: "Cooinda (AUCDA)"
  },
  {
   value: "Cooktown (AUCTN)",
   label: "Cooktown (AUCTN)"
  },
  {
   value: "Coolah (AUCLH)",
   label: "Coolah (AUCLH)"
  },
  {
   value: "Coolangatta apt\/Gold Coast (AUOOL)",
   label: "Coolangatta apt\/Gold Coast (AUOOL)"
  },
  {
   value: "Coolawanyah (AUCOY)",
   label: "Coolawanyah (AUCOY)"
  },
  {
   value: "Coolibah \/ CORIO BAY (AUCOB)",
   label: "Coolibah \/ CORIO BAY (AUCOB)"
  },
  {
   value: "Cooma (AUCOM)",
   label: "Cooma (AUCOM)"
  },
  {
   value: "Coonabarabran (AUCOJ)",
   label: "Coonabarabran (AUCOJ)"
  },
  {
   value: "Coonamble (AUCNB)",
   label: "Coonamble (AUCNB)"
  },
  {
   value: "Coopers Plains (AUCPS)",
   label: "Coopers Plains (AUCPS)"
  },
  {
   value: "Coorabie (AUCRJ)",
   label: "Coorabie (AUCRJ)"
  },
  {
   value: "Cootamundra (AUCMD)",
   label: "Cootamundra (AUCMD)"
  },
  {
   value: "Cordillo Downs (AUODL)",
   label: "Cordillo Downs (AUODL)"
  },
  {
   value: "Corowa (AUCWW)",
   label: "Corowa (AUCWW)"
  },
  {
   value: "Corryong (AUCYG)",
   label: "Corryong (AUCYG)"
  },
  {
   value: "Cossack Pioneer (oil terminal) (AUCOP)",
   label: "Cossack Pioneer (oil terminal) (AUCOP)"
  },
  {
   value: "Cowarie (AUCWR)",
   label: "Cowarie (AUCWR)"
  },
  {
   value: "Cowell (AUCCW)",
   label: "Cowell (AUCCW)"
  },
  {
   value: "Cowra (AUCWT)",
   label: "Cowra (AUCWT)"
  },
  {
   value: "Cresswell Downs (AUCSD)",
   label: "Cresswell Downs (AUCSD)"
  },
  {
   value: "Croker Island (AUCKI)",
   label: "Croker Island (AUCKI)"
  },
  {
   value: "Croydon (AUCDQ)",
   label: "Croydon (AUCDQ)"
  },
  {
   value: "Cudal (AUCUG)",
   label: "Cudal (AUCUG)"
  },
  {
   value: "Cue (AUCUY)",
   label: "Cue (AUCUY)"
  },
  {
   value: "Cunnamulla (AUCMA)",
   label: "Cunnamulla (AUCMA)"
  },
  {
   value: "Dalby (AUDBY)",
   label: "Dalby (AUDBY)"
  },
  {
   value: "Daly River (AUDVR)",
   label: "Daly River (AUDVR)"
  },
  {
   value: "Daly Waters (AUDYW)",
   label: "Daly Waters (AUDYW)"
  },
  {
   value: "Dampier (AUDAM)",
   label: "Dampier (AUDAM)"
  },
  {
   value: "Dandenong (AUDND)",
   label: "Dandenong (AUDND)"
  },
  {
   value: "Darnley Island (AUNLF)",
   label: "Darnley Island (AUNLF)"
  },
  {
   value: "Darra (AUDAA)",
   label: "Darra (AUDAA)"
  },
  {
   value: "Darwin (AUDRW)",
   label: "Darwin (AUDRW)"
  },
  {
   value: "Dauan Island (AUDAJ)",
   label: "Dauan Island (AUDAJ)"
  },
  {
   value: "Davenport Downs (AUDVP)",
   label: "Davenport Downs (AUDVP)"
  },
  {
   value: "Canobie (AUCBY)",
   label: "Canobie (AUCBY)"
  },
  {
   value: "Cape Barren Island (AUCBI)",
   label: "Cape Barren Island (AUCBI)"
  },
  {
   value: "Cape Cuvier (AUCCU)",
   label: "Cape Cuvier (AUCCU)"
  },
  {
   value: "Cape Flattery (AUCQP)",
   label: "Cape Flattery (AUCQP)"
  },
  {
   value: "Cape Lambert (AUCLT)",
   label: "Cape Lambert (AUCLT)"
  },
  {
   value: "Cape Leeuwin (AUCLN)",
   label: "Cape Leeuwin (AUCLN)"
  },
  {
   value: "Cape Preston (AUCPN)",
   label: "Cape Preston (AUCPN)"
  },
  {
   value: "Carlton Hill (AUCRY)",
   label: "Carlton Hill (AUCRY)"
  },
  {
   value: "Carnarvon (AUCVQ)",
   label: "Carnarvon (AUCVQ)"
  },
  {
   value: "Carpentaria Downs (AUCFP)",
   label: "Carpentaria Downs (AUCFP)"
  },
  {
   value: "Casino (AUCSI)",
   label: "Casino (AUCSI)"
  },
  {
   value: "Catherine Hill Bay (AUCHB)",
   label: "Catherine Hill Bay (AUCHB)"
  },
  {
   value: "Cattle Creek (AUCTR)",
   label: "Cattle Creek (AUCTR)"
  },
  {
   value: "Ceduna (AUCED)",
   label: "Ceduna (AUCED)"
  },
  {
   value: "Cessnock (AUCES)",
   label: "Cessnock (AUCES)"
  },
  {
   value: "Challis Venture (oil terminal) (AUCHV)",
   label: "Challis Venture (oil terminal) (AUCHV)"
  },
  {
   value: "Charleville (AUCTL)",
   label: "Charleville (AUCTL)"
  },
  {
   value: "Charters Towers (AUCXT)",
   label: "Charters Towers (AUCXT)"
  },
  {
   value: "Chatswood (AUCHA)",
   label: "Chatswood (AUCHA)"
  },
  {
   value: "Cherrabun (AUCBC)",
   label: "Cherrabun (AUCBC)"
  },
  {
   value: "Cherribah (AUCRH)",
   label: "Cherribah (AUCRH)"
  },
  {
   value: "Chillagoe (AULLG)",
   label: "Chillagoe (AULLG)"
  },
  {
   value: "Chinchilla (AUCCL)",
   label: "Chinchilla (AUCCL)"
  },
  {
   value: "Christmas Creek (AUCXQ)",
   label: "Christmas Creek (AUCXQ)"
  },
  {
   value: "Clarence River (AUCLR)",
   label: "Clarence River (AUCLR)"
  },
  {
   value: "Clermont (AUCMQ)",
   label: "Clermont (AUCMQ)"
  },
  {
   value: "Cleve (AUCVC)",
   label: "Cleve (AUCVC)"
  },
  {
   value: "Clifton Hills (AUCFH)",
   label: "Clifton Hills (AUCFH)"
  },
  {
   value: "Cloncurry (AUCNJ)",
   label: "Cloncurry (AUCNJ)"
  },
  {
   value: "Cluny (AUCZY)",
   label: "Cluny (AUCZY)"
  },
  {
   value: "Cobar (AUCAZ)",
   label: "Cobar (AUCAZ)"
  },
  {
   value: "Coconut Island (AUCNC)",
   label: "Coconut Island (AUCNC)"
  },
  {
   value: "Coen (AUCUQ)",
   label: "Coen (AUCUQ)"
  },
  {
   value: "Coffs Harbour (AUCFS)",
   label: "Coffs Harbour (AUCFS)"
  },
  {
   value: "Colac (AUXCO)",
   label: "Colac (AUXCO)"
  },
  {
   value: "Collan Islands (AUCLL)",
   label: "Collan Islands (AUCLL)"
  },
  {
   value: "Collarenebri (AUCRB)",
   label: "Collarenebri (AUCRB)"
  },
  {
   value: "Collie (AUCIE)",
   label: "Collie (AUCIE)"
  },
  {
   value: "Bizant (AUBZP)",
   label: "Bizant (AUBZP)"
  },
  {
   value: "Blackall (AUBKQ)",
   label: "Blackall (AUBKQ)"
  },
  {
   value: "Blackwater (AUBLT)",
   label: "Blackwater (AUBLT)"
  },
  {
   value: "Bloomfield (AUBFC)",
   label: "Bloomfield (AUBFC)"
  },
  {
   value: "Boigu Island (AUGIC)",
   label: "Boigu Island (AUGIC)"
  },
  {
   value: "Bollon (AUBLS)",
   label: "Bollon (AUBLS)"
  },
  {
   value: "Bolwarra (AUBCK)",
   label: "Bolwarra (AUBCK)"
  },
  {
   value: "Borroloola (AUBOX)",
   label: "Borroloola (AUBOX)"
  },
  {
   value: "Botany Bay (AUBTB)",
   label: "Botany Bay (AUBTB)"
  },
  {
   value: "Boulia (AUBQL)",
   label: "Boulia (AUBQL)"
  },
  {
   value: "Bourke (AUBRK)",
   label: "Bourke (AUBRK)"
  },
  {
   value: "Bowen (AUZBO)",
   label: "Bowen (AUZBO)"
  },
  {
   value: "Brampton (AUBMP)",
   label: "Brampton (AUBMP)"
  },
  {
   value: "Brewarrina (AUBWQ)",
   label: "Brewarrina (AUBWQ)"
  },
  {
   value: "Bright (AUBRJ)",
   label: "Bright (AUBRJ)"
  },
  {
   value: "Brighton Downs (AUBHT)",
   label: "Brighton Downs (AUBHT)"
  },
  {
   value: "Brisbane (AUBNE)",
   label: "Brisbane (AUBNE)"
  },
  {
   value: "Brisbane apt (AUBRA)",
   label: "Brisbane apt (AUBRA)"
  },
  {
   value: "Broadmeadows (AUBMW)",
   label: "Broadmeadows (AUBMW)"
  },
  {
   value: "Broken Hill (AUBHQ)",
   label: "Broken Hill (AUBHQ)"
  },
  {
   value: "Broome (AUBME)",
   label: "Broome (AUBME)"
  },
  {
   value: "Brunette Downs (AUBTD)",
   label: "Brunette Downs (AUBTD)"
  },
  {
   value: "Bulimba (AUBIP)",
   label: "Bulimba (AUBIP)"
  },
  {
   value: "Bunbury (AUBUY)",
   label: "Bunbury (AUBUY)"
  },
  {
   value: "Bundaberg (AUBDB)",
   label: "Bundaberg (AUBDB)"
  },
  {
   value: "Bundall (AUBND)",
   label: "Bundall (AUBND)"
  },
  {
   value: "Bungalow (AUBLW)",
   label: "Bungalow (AUBLW)"
  },
  {
   value: "Burketown (AUBUC)",
   label: "Burketown (AUBUC)"
  },
  {
   value: "Burnie (AUBWT)",
   label: "Burnie (AUBWT)"
  },
  {
   value: "Busselton (AUBUS)",
   label: "Busselton (AUBUS)"
  },
  {
   value: "Caiguna (AUCGV)",
   label: "Caiguna (AUCGV)"
  },
  {
   value: "Cairns (AUCNS)",
   label: "Cairns (AUCNS)"
  },
  {
   value: "Caloundra (AUCUD)",
   label: "Caloundra (AUCUD)"
  },
  {
   value: "Caloundra Head (AUCAL)",
   label: "Caloundra Head (AUCAL)"
  },
  {
   value: "Camden (AUCDU)",
   label: "Camden (AUCDU)"
  },
  {
   value: "Camfield (AUCFI)",
   label: "Camfield (AUCFI)"
  },
  {
   value: "Camooweal (AUCML)",
   label: "Camooweal (AUCML)"
  },
  {
   value: "Campbellfield (AUCFL)",
   label: "Campbellfield (AUCFL)"
  },
  {
   value: "Campbelltown (AUCBN)",
   label: "Campbelltown (AUCBN)"
  },
  {
   value: "Canberra (AUCBR)",
   label: "Canberra (AUCBR)"
  },
  {
   value: "Auvergne (AUAVG)",
   label: "Auvergne (AUAVG)"
  },
  {
   value: "Avalon (AUAVV)",
   label: "Avalon (AUAVV)"
  },
  {
   value: "Ayers Rock (AUAYQ)",
   label: "Ayers Rock (AUAYQ)"
  },
  {
   value: "Ayr (AUAYR)",
   label: "Ayr (AUAYR)"
  },
  {
   value: "Badu Island (AUBDD)",
   label: "Badu Island (AUBDD)"
  },
  {
   value: "Bairnsdale (AUBSJ)",
   label: "Bairnsdale (AUBSJ)"
  },
  {
   value: "Bakers Creek (AUBAK)",
   label: "Bakers Creek (AUBAK)"
  },
  {
   value: "Balcanoona (AULCN)",
   label: "Balcanoona (AULCN)"
  },
  {
   value: "Balgo Hills (AUBQW)",
   label: "Balgo Hills (AUBQW)"
  },
  {
   value: "Ballarat (AUBQA)",
   label: "Ballarat (AUBQA)"
  },
  {
   value: "Ballast Head (AUBAH)",
   label: "Ballast Head (AUBAH)"
  },
  {
   value: "Ballina (AUBNK)",
   label: "Ballina (AUBNK)"
  },
  {
   value: "Balranald (AUBZD)",
   label: "Balranald (AUBZD)"
  },
  {
   value: "Bamaga (AUABM)",
   label: "Bamaga (AUABM)"
  },
  {
   value: "Baniyala (AUBYX)",
   label: "Baniyala (AUBYX)"
  },
  {
   value: "Bankstown (AUBWU)",
   label: "Bankstown (AUBWU)"
  },
  {
   value: "Barcaldine (AUBCI)",
   label: "Barcaldine (AUBCI)"
  },
  {
   value: "Barkly Downs (AUBKP)",
   label: "Barkly Downs (AUBKP)"
  },
  {
   value: "Barrow Island (AUBWB)",
   label: "Barrow Island (AUBWB)"
  },
  {
   value: "Batavia Downs (AUBVW)",
   label: "Batavia Downs (AUBVW)"
  },
  {
   value: "Bathurst (AUBHS)",
   label: "Bathurst (AUBHS)"
  },
  {
   value: "Bathurst Island (AUBRT)",
   label: "Bathurst Island (AUBRT)"
  },
  {
   value: "Beachport (AUBCH)",
   label: "Beachport (AUBCH)"
  },
  {
   value: "Beagle Bay (AUBEE)",
   label: "Beagle Bay (AUBEE)"
  },
  {
   value: "Beaudesert (AUBDS)",
   label: "Beaudesert (AUBDS)"
  },
  {
   value: "Beauty Point (AUBYP)",
   label: "Beauty Point (AUBYP)"
  },
  {
   value: "Bedford Downs (AUBDW)",
   label: "Bedford Downs (AUBDW)"
  },
  {
   value: "Bedourie (AUBEU)",
   label: "Bedourie (AUBEU)"
  },
  {
   value: "Bell Bay (AUBEL)",
   label: "Bell Bay (AUBEL)"
  },
  {
   value: "Belmont (AUBEO)",
   label: "Belmont (AUBEO)"
  },
  {
   value: "Benalla (AUBLN)",
   label: "Benalla (AUBLN)"
  },
  {
   value: "Bendigo (AUBDG)",
   label: "Bendigo (AUBDG)"
  },
  {
   value: "Berri (AUBER)",
   label: "Berri (AUBER)"
  },
  {
   value: "Betoota (AUBTX)",
   label: "Betoota (AUBTX)"
  },
  {
   value: "Beverley Springs (AUBVZ)",
   label: "Beverley Springs (AUBVZ)"
  },
  {
   value: "Bickerton Island (AUBCZ)",
   label: "Bickerton Island (AUBCZ)"
  },
  {
   value: "Big Bell (AUBBE)",
   label: "Big Bell (AUBBE)"
  },
  {
   value: "Billiluna (AUBIW)",
   label: "Billiluna (AUBIW)"
  },
  {
   value: "Biloela (AUBLO)",
   label: "Biloela (AUBLO)"
  },
  {
   value: "Birdsville (AUBVI)",
   label: "Birdsville (AUBVI)"
  },
  {
   value: "Wolpassing (ATWOL)",
   label: "Wolpassing (ATWOL)"
  },
  {
   value: "Wulzeshofen (ATWLZ)",
   label: "Wulzeshofen (ATWLZ)"
  },
  {
   value: "Zurs\/Lech (ATZRS)",
   label: "Zurs\/Lech (ATZRS)"
  },
  {
   value: "Zwentendorf (?) (ATZWD)",
   label: "Zwentendorf (?) (ATZWD)"
  },
  {
   value: "Zwettl (ATZWT)",
   label: "Zwettl (ATZWT)"
  },
  {
   value: "MADER (ATMDR)",
   label: "MADER (ATMDR)"
  },
  {
   value: "PERSCHTOLSDORF (ATPTF)",
   label: "PERSCHTOLSDORF (ATPTF)"
  },
  {
   value: "Abbot Point (AUABP)",
   label: "Abbot Point (AUABP)"
  },
  {
   value: "Abingdon (AUABG)",
   label: "Abingdon (AUABG)"
  },
  {
   value: "Adelaide (AUADL)",
   label: "Adelaide (AUADL)"
  },
  {
   value: "Adelaide apt (AUADA)",
   label: "Adelaide apt (AUADA)"
  },
  {
   value: "Agnew (AUAGW)",
   label: "Agnew (AUAGW)"
  },
  {
   value: "Airlie Beach (AUWSY)",
   label: "Airlie Beach (AUWSY)"
  },
  {
   value: "Albany (AUALH)",
   label: "Albany (AUALH)"
  },
  {
   value: "Albury (AUABX)",
   label: "Albury (AUABX)"
  },
  {
   value: "Alexandria (AUAXL)",
   label: "Alexandria (AUAXL)"
  },
  {
   value: "Alice Springs (AUASP)",
   label: "Alice Springs (AUASP)"
  },
  {
   value: "Alpha (AUABH)",
   label: "Alpha (AUABH)"
  },
  {
   value: "Alroy Downs (AUAYD)",
   label: "Alroy Downs (AUAYD)"
  },
  {
   value: "Alton Downs (AUAWN)",
   label: "Alton Downs (AUAWN)"
  },
  {
   value: "Altona (AUALT)",
   label: "Altona (AUALT)"
  },
  {
   value: "Amata (AUAMT)",
   label: "Amata (AUAMT)"
  },
  {
   value: "Amberley (AUABL)",
   label: "Amberley (AUABL)"
  },
  {
   value: "American River (AURCN)",
   label: "American River (AURCN)"
  },
  {
   value: "Ammaroo (AUAMX)",
   label: "Ammaroo (AUAMX)"
  },
  {
   value: "Andamooka (AUADO)",
   label: "Andamooka (AUADO)"
  },
  {
   value: "Angus Downs (AUANZ)",
   label: "Angus Downs (AUANZ)"
  },
  {
   value: "Anthony Lagoon (AUAYL)",
   label: "Anthony Lagoon (AUAYL)"
  },
  {
   value: "Aramac (AUAXC)",
   label: "Aramac (AUAXC)"
  },
  {
   value: "Ararat (AUARY)",
   label: "Ararat (AUARY)"
  },
  {
   value: "Ardrossan (AUARD)",
   label: "Ardrossan (AUARD)"
  },
  {
   value: "Argyle (AUGYL)",
   label: "Argyle (AUGYL)"
  },
  {
   value: "Argyle Downs (AUAGY)",
   label: "Argyle Downs (AUAGY)"
  },
  {
   value: "Armidale (AUARM)",
   label: "Armidale (AUARM)"
  },
  {
   value: "Arrabury (AUAAB)",
   label: "Arrabury (AUAAB)"
  },
  {
   value: "Au-Rose Bay (AURSE)",
   label: "Au-Rose Bay (AURSE)"
  },
  {
   value: "Augustus Downs (AUAUD)",
   label: "Augustus Downs (AUAUD)"
  },
  {
   value: "Aurukun Mission (AUAUU)",
   label: "Aurukun Mission (AUAUU)"
  },
  {
   value: "Austral Downs (AUAWP)",
   label: "Austral Downs (AUAWP)"
  },
  {
   value: "St Jakob Breitenau (ATSJB)",
   label: "St Jakob Breitenau (ATSJB)"
  },
  {
   value: "St Michael ob Bleiburg (ATSML)",
   label: "St Michael ob Bleiburg (ATSML)"
  },
  {
   value: "St Paul (ATSVT)",
   label: "St Paul (ATSVT)"
  },
  {
   value: "St Pölten (ATSTP)",
   label: "St Pölten (ATSTP)"
  },
  {
   value: "St Stefan (ATSTS)",
   label: "St Stefan (ATSTS)"
  },
  {
   value: "St Valentin (ATSTV)",
   label: "St Valentin (ATSTV)"
  },
  {
   value: "Stainach (ATSTA)",
   label: "Stainach (ATSTA)"
  },
  {
   value: "Stainz (ATSTZ)",
   label: "Stainz (ATSTZ)"
  },
  {
   value: "Steinabrunn (ATSEN)",
   label: "Steinabrunn (ATSEN)"
  },
  {
   value: "Steyermühl (ATSYM)",
   label: "Steyermühl (ATSYM)"
  },
  {
   value: "Steyr (ATSER)",
   label: "Steyr (ATSER)"
  },
  {
   value: "Stift Ardagger (ATSAR)",
   label: "Stift Ardagger (ATSAR)"
  },
  {
   value: "Stockerau (ATSTC)",
   label: "Stockerau (ATSTC)"
  },
  {
   value: "Telfs (ATTEL)",
   label: "Telfs (ATTEL)"
  },
  {
   value: "Ternitz (ATTNZ)",
   label: "Ternitz (ATTNZ)"
  },
  {
   value: "Thoerl (ATTOL)",
   label: "Thoerl (ATTOL)"
  },
  {
   value: "Traiskirchen (ATTSK)",
   label: "Traiskirchen (ATTSK)"
  },
  {
   value: "Traun (ATTNQ)",
   label: "Traun (ATTNQ)"
  },
  {
   value: "Treibach (ATTBH)",
   label: "Treibach (ATTBH)"
  },
  {
   value: "Tribuswinkel (ATTRW)",
   label: "Tribuswinkel (ATTRW)"
  },
  {
   value: "Tulln (ATTLN)",
   label: "Tulln (ATTLN)"
  },
  {
   value: "Uher\/Wien (ATUHR)",
   label: "Uher\/Wien (ATUHR)"
  },
  {
   value: "Ulmerfeld (ATULF)",
   label: "Ulmerfeld (ATULF)"
  },
  {
   value: "Uttendorf (ATUTD)",
   label: "Uttendorf (ATUTD)"
  },
  {
   value: "Vienna Danubepier Hov (ATVDD)",
   label: "Vienna Danubepier Hov (ATVDD)"
  },
  {
   value: "Villach (ATVLH)",
   label: "Villach (ATVLH)"
  },
  {
   value: "Voitsberg (ATVTB)",
   label: "Voitsberg (ATVTB)"
  },
  {
   value: "Völs (ATVOE)",
   label: "Völs (ATVOE)"
  },
  {
   value: "Vorarlberg (ATVOR)",
   label: "Vorarlberg (ATVOR)"
  },
  {
   value: "Walchsee (ATWCE)",
   label: "Walchsee (ATWCE)"
  },
  {
   value: "Wartberg (?) (ATWRT)",
   label: "Wartberg (?) (ATWRT)"
  },
  {
   value: "Wattens (ATWTN)",
   label: "Wattens (ATWTN)"
  },
  {
   value: "Weissenstein (ATWSS)",
   label: "Weissenstein (ATWSS)"
  },
  {
   value: "Wels (ATWSL)",
   label: "Wels (ATWSL)"
  },
  {
   value: "Wien (ATVIE)",
   label: "Wien (ATVIE)"
  },
  {
   value: "Wiener Neudorf (ATWNF)",
   label: "Wiener Neudorf (ATWNF)"
  },
  {
   value: "Wiener Neustadt (ATWNR)",
   label: "Wiener Neustadt (ATWNR)"
  },
  {
   value: "Wieselburg (ATWBG)",
   label: "Wieselburg (ATWBG)"
  },
  {
   value: "Wimpassing (ATWMP)",
   label: "Wimpassing (ATWMP)"
  },
  {
   value: "Wolfurth (ATWLR)",
   label: "Wolfurth (ATWLR)"
  },
  {
   value: "Lenzing (ATLZG)",
   label: "Lenzing (ATLZG)"
  },
  {
   value: "Lienz (ATLEZ)",
   label: "Lienz (ATLEZ)"
  },
  {
   value: "Liezen (ATLZN)",
   label: "Liezen (ATLZN)"
  },
  {
   value: "Linz (ATLNZ)",
   label: "Linz (ATLNZ)"
  },
  {
   value: "Löbendorf (ATLOE)",
   label: "Löbendorf (ATLOE)"
  },
  {
   value: "Lochau (ATLCU)",
   label: "Lochau (ATLCU)"
  },
  {
   value: "Lustenau (ATLTN)",
   label: "Lustenau (ATLTN)"
  },
  {
   value: "Mattighofen (ATMTH)",
   label: "Mattighofen (ATMTH)"
  },
  {
   value: "Mauerkirchen (ATMHK)",
   label: "Mauerkirchen (ATMHK)"
  },
  {
   value: "Melk (ATMEL)",
   label: "Melk (ATMEL)"
  },
  {
   value: "Messendorf (?) Mettendorf? (ATMSD)",
   label: "Messendorf (?) Mettendorf? (ATMSD)"
  },
  {
   value: "Miklauzhof (ATMIK)",
   label: "Miklauzhof (ATMIK)"
  },
  {
   value: "Mittelberg (ATMIT)",
   label: "Mittelberg (ATMIT)"
  },
  {
   value: "Mittersill (ATMLS)",
   label: "Mittersill (ATMLS)"
  },
  {
   value: "Muerzzuschlag (ATMZZ)",
   label: "Muerzzuschlag (ATMZZ)"
  },
  {
   value: "Neudau (ATNUA)",
   label: "Neudau (ATNUA)"
  },
  {
   value: "Obdach (ATOHD)",
   label: "Obdach (ATOHD)"
  },
  {
   value: "Oberwart (ATOWT)",
   label: "Oberwart (ATOWT)"
  },
  {
   value: "Oneal (ATOAL)",
   label: "Oneal (ATOAL)"
  },
  {
   value: "Parndorf (ATPDF)",
   label: "Parndorf (ATPDF)"
  },
  {
   value: "Pasching (ATPHG)",
   label: "Pasching (ATPHG)"
  },
  {
   value: "Perg (ATPER)",
   label: "Perg (ATPER)"
  },
  {
   value: "Pernhofen (ATPRH)",
   label: "Pernhofen (ATPRH)"
  },
  {
   value: "Poeggstall (ATPOG)",
   label: "Poeggstall (ATPOG)"
  },
  {
   value: "Raab (ATRAB)",
   label: "Raab (ATRAB)"
  },
  {
   value: "Randegg (ATRXG)",
   label: "Randegg (ATRXG)"
  },
  {
   value: "Rankweil (ATRKL)",
   label: "Rankweil (ATRKL)"
  },
  {
   value: "Rekawinkel (ATRWL)",
   label: "Rekawinkel (ATRWL)"
  },
  {
   value: "Ried (ATRIE)",
   label: "Ried (ATRIE)"
  },
  {
   value: "Riezlern (ATRZL)",
   label: "Riezlern (ATRZL)"
  },
  {
   value: "Rottenmann (ATRTT)",
   label: "Rottenmann (ATRTT)"
  },
  {
   value: "Salzburg (ATSZG)",
   label: "Salzburg (ATSZG)"
  },
  {
   value: "Schwanenstadt (ATSST)",
   label: "Schwanenstadt (ATSST)"
  },
  {
   value: "Schwarzach (ATSCW)",
   label: "Schwarzach (ATSCW)"
  },
  {
   value: "Schwaz (ATSCZ)",
   label: "Schwaz (ATSCZ)"
  },
  {
   value: "Schwechat (ATSHT)",
   label: "Schwechat (ATSHT)"
  },
  {
   value: "Schwertberg (ATSCH)",
   label: "Schwertberg (ATSCH)"
  },
  {
   value: "Sollenau (ATSLL)",
   label: "Sollenau (ATSLL)"
  },
  {
   value: "Spittal\/Drau (ATSPI)",
   label: "Spittal\/Drau (ATSPI)"
  },
  {
   value: "St Anton (ATANT)",
   label: "St Anton (ATANT)"
  },
  {
   value: "Feldkirch-Tosters (ATFKT)",
   label: "Feldkirch-Tosters (ATFKT)"
  },
  {
   value: "Ferlach (ATFLH)",
   label: "Ferlach (ATFLH)"
  },
  {
   value: "Frankenmarkt (ATFRN)",
   label: "Frankenmarkt (ATFRN)"
  },
  {
   value: "Frohnleiten (ATFLT)",
   label: "Frohnleiten (ATFLT)"
  },
  {
   value: "Furnitz (ATFUR)",
   label: "Furnitz (ATFUR)"
  },
  {
   value: "Garsten (ATGAN)",
   label: "Garsten (ATGAN)"
  },
  {
   value: "Geinberg (ATGNR)",
   label: "Geinberg (ATGNR)"
  },
  {
   value: "Gleisdorf (ATGSD)",
   label: "Gleisdorf (ATGSD)"
  },
  {
   value: "Graz (ATGRZ)",
   label: "Graz (ATGRZ)"
  },
  {
   value: "Gross St Florian (ATGRU)",
   label: "Gross St Florian (ATGRU)"
  },
  {
   value: "Grosspetersdorf (ATGPF)",
   label: "Grosspetersdorf (ATGPF)"
  },
  {
   value: "Haid (ATHAD)",
   label: "Haid (ATHAD)"
  },
  {
   value: "Hall (ATHAL)",
   label: "Hall (ATHAL)"
  },
  {
   value: "Hallein (ATHLL)",
   label: "Hallein (ATHLL)"
  },
  {
   value: "Hansenhütte (ATHSN)",
   label: "Hansenhütte (ATHSN)"
  },
  {
   value: "Hard (ATHRD)",
   label: "Hard (ATHRD)"
  },
  {
   value: "Hartberg (ATHTA)",
   label: "Hartberg (ATHTA)"
  },
  {
   value: "Hermagor (ATHMG)",
   label: "Hermagor (ATHMG)"
  },
  {
   value: "Hirschegg (ATHIR)",
   label: "Hirschegg (ATHIR)"
  },
  {
   value: "Höchst (ATHST)",
   label: "Höchst (ATHST)"
  },
  {
   value: "Hohenems (ATHOH)",
   label: "Hohenems (ATHOH)"
  },
  {
   value: "Hörsching (ATHRH)",
   label: "Hörsching (ATHRH)"
  },
  {
   value: "Innsbruck (ATINN)",
   label: "Innsbruck (ATINN)"
  },
  {
   value: "Judenburg (ATJDN)",
   label: "Judenburg (ATJDN)"
  },
  {
   value: "Jungholz (ATJUN)",
   label: "Jungholz (ATJUN)"
  },
  {
   value: "Kalsdorf (ATKDF)",
   label: "Kalsdorf (ATKDF)"
  },
  {
   value: "Kapfenberg (ATKFB)",
   label: "Kapfenberg (ATKFB)"
  },
  {
   value: "Kematen Ybbs (ATKYB)",
   label: "Kematen Ybbs (ATKYB)"
  },
  {
   value: "Kemating (ATKMG)",
   label: "Kemating (ATKMG)"
  },
  {
   value: "Kennelbach (ATKNB)",
   label: "Kennelbach (ATKNB)"
  },
  {
   value: "Klagenfurt (ATKLU)",
   label: "Klagenfurt (ATKLU)"
  },
  {
   value: "Koflach (ATKEF)",
   label: "Koflach (ATKEF)"
  },
  {
   value: "Korneuburg (ATKBG)",
   label: "Korneuburg (ATKBG)"
  },
  {
   value: "Kraubath an der Mur (ATKDM)",
   label: "Kraubath an der Mur (ATKDM)"
  },
  {
   value: "Krems (ATKRE)",
   label: "Krems (ATKRE)"
  },
  {
   value: "Kremsmünster (ATKMS)",
   label: "Kremsmünster (ATKMS)"
  },
  {
   value: "Kröllendorf (ATKLD)",
   label: "Kröllendorf (ATKLD)"
  },
  {
   value: "Kufstein (ATKFS)",
   label: "Kufstein (ATKFS)"
  },
  {
   value: "Lambach (ATLMB)",
   label: "Lambach (ATLMB)"
  },
  {
   value: "Längenfeld (ATLFD)",
   label: "Längenfeld (ATLFD)"
  },
  {
   value: "Lauterach (ATLUT)",
   label: "Lauterach (ATLUT)"
  },
  {
   value: "Santa Rosa (ARRSA)",
   label: "Santa Rosa (ARRSA)"
  },
  {
   value: "Santa Teresita (ARSST)",
   label: "Santa Teresita (ARSST)"
  },
  {
   value: "Santiago del Estero (ARSDE)",
   label: "Santiago del Estero (ARSDE)"
  },
  {
   value: "Sierra Grande (ARSGV)",
   label: "Sierra Grande (ARSGV)"
  },
  {
   value: "Tandil (ARTDL)",
   label: "Tandil (ARTDL)"
  },
  {
   value: "Tartagal (ARTTG)",
   label: "Tartagal (ARTTG)"
  },
  {
   value: "Trelew (ARREL)",
   label: "Trelew (ARREL)"
  },
  {
   value: "Tres Arroyos (AROYO)",
   label: "Tres Arroyos (AROYO)"
  },
  {
   value: "Tucuman (ARTUC)",
   label: "Tucuman (ARTUC)"
  },
  {
   value: "Ushuaia (ARUSH)",
   label: "Ushuaia (ARUSH)"
  },
  {
   value: "Valcheta (ARVCF)",
   label: "Valcheta (ARVCF)"
  },
  {
   value: "Viedma (ARVDM)",
   label: "Viedma (ARVDM)"
  },
  {
   value: "Villa Constitucion (ARVCN)",
   label: "Villa Constitucion (ARVCN)"
  },
  {
   value: "Villa Dolores (ARVDR)",
   label: "Villa Dolores (ARVDR)"
  },
  {
   value: "Villa Gesell (ARVLG)",
   label: "Villa Gesell (ARVLG)"
  },
  {
   value: "Villa Mercedes (ARVME)",
   label: "Villa Mercedes (ARVME)"
  },
  {
   value: "Zapala (ARAPZ)",
   label: "Zapala (ARAPZ)"
  },
  {
   value: "Zarate (ARZAE)",
   label: "Zarate (ARZAE)"
  },
  {
   value: "La Quiaca (ARLQU)",
   label: "La Quiaca (ARLQU)"
  },
  {
   value: "POCITOS (ARPOC)",
   label: "POCITOS (ARPOC)"
  },
  {
   value: "Fitiuta (ASFTI)",
   label: "Fitiuta (ASFTI)"
  },
  {
   value: "Ofu (ASOFU)",
   label: "Ofu (ASOFU)"
  },
  {
   value: "Pago Pago (ASPPG)",
   label: "Pago Pago (ASPPG)"
  },
  {
   value: "Tau (ASTAV)",
   label: "Tau (ASTAV)"
  },
  {
   value: "Altenmarkt (ATAMK)",
   label: "Altenmarkt (ATAMK)"
  },
  {
   value: "Amstetten (ATATT)",
   label: "Amstetten (ATATT)"
  },
  {
   value: "Anif (ATANF)",
   label: "Anif (ATANF)"
  },
  {
   value: "Antiesenhofen (ATAHN)",
   label: "Antiesenhofen (ATAHN)"
  },
  {
   value: "Aspern (ATASP)",
   label: "Aspern (ATASP)"
  },
  {
   value: "Bad Gleichenberg (ATBGC)",
   label: "Bad Gleichenberg (ATBGC)"
  },
  {
   value: "Bad Kreuzen (ATBKZ)",
   label: "Bad Kreuzen (ATBKZ)"
  },
  {
   value: "Berndorf (ATBNF)",
   label: "Berndorf (ATBNF)"
  },
  {
   value: "Braunau (ATBRA)",
   label: "Braunau (ATBRA)"
  },
  {
   value: "Bregenz (ATBRZ)",
   label: "Bregenz (ATBRZ)"
  },
  {
   value: "Bruck an der Leitha (ATBKL)",
   label: "Bruck an der Leitha (ATBKL)"
  },
  {
   value: "Bruck an der Mur (ATBRU)",
   label: "Bruck an der Mur (ATBRU)"
  },
  {
   value: "Eferding (ATEFR)",
   label: "Eferding (ATEFR)"
  },
  {
   value: "Enns (ATENA)",
   label: "Enns (ATENA)"
  },
  {
   value: "Eurenhausen (ATEUH)",
   label: "Eurenhausen (ATEUH)"
  },
  {
   value: "Feistritz (ATFST)",
   label: "Feistritz (ATFST)"
  },
  {
   value: "Puerto Galvan\/Bahia Blanca (ARPGV)",
   label: "Puerto Galvan\/Bahia Blanca (ARPGV)"
  },
  {
   value: "Puerto Madryn (ARPMY)",
   label: "Puerto Madryn (ARPMY)"
  },
  {
   value: "Puerto Nacional\/Bahia Blanca (ARPNL)",
   label: "Puerto Nacional\/Bahia Blanca (ARPNL)"
  },
  {
   value: "Puerto Rosales\/Bahia Blanca (ARPRS)",
   label: "Puerto Rosales\/Bahia Blanca (ARPRS)"
  },
  {
   value: "Punta Colorada (ARPCO)",
   label: "Punta Colorada (ARPCO)"
  },
  {
   value: "Punta Loyola (ARPLO)",
   label: "Punta Loyola (ARPLO)"
  },
  {
   value: "Punta Quilla (ARPQU)",
   label: "Punta Quilla (ARPQU)"
  },
  {
   value: "Quequén (ARQQN)",
   label: "Quequén (ARQQN)"
  },
  {
   value: "Ramallo (ARRAM)",
   label: "Ramallo (ARRAM)"
  },
  {
   value: "Recalada (ARRLA)",
   label: "Recalada (ARRLA)"
  },
  {
   value: "Reconquista (ARRCQ)",
   label: "Reconquista (ARRCQ)"
  },
  {
   value: "Resistencia (ARRES)",
   label: "Resistencia (ARRES)"
  },
  {
   value: "Rincon De Los Sauces (ARRDS)",
   label: "Rincon De Los Sauces (ARRDS)"
  },
  {
   value: "Rio Cuarto (ARRCU)",
   label: "Rio Cuarto (ARRCU)"
  },
  {
   value: "Rio Gallegos (ARRGL)",
   label: "Rio Gallegos (ARRGL)"
  },
  {
   value: "Rio Grande (ARRGA)",
   label: "Rio Grande (ARRGA)"
  },
  {
   value: "Rio Hondo (ARRHD)",
   label: "Rio Hondo (ARRHD)"
  },
  {
   value: "Rio Mayo (ARROY)",
   label: "Rio Mayo (ARROY)"
  },
  {
   value: "Rio Turbio (ARRYO)",
   label: "Rio Turbio (ARRYO)"
  },
  {
   value: "Rosario (ARROS)",
   label: "Rosario (ARROS)"
  },
  {
   value: "Saenz Pena (ARSZQ)",
   label: "Saenz Pena (ARSZQ)"
  },
  {
   value: "Salta (ARSLA)",
   label: "Salta (ARSLA)"
  },
  {
   value: "San Antonio Este (ARSAE)",
   label: "San Antonio Este (ARSAE)"
  },
  {
   value: "San Antonio Oeste (AROES)",
   label: "San Antonio Oeste (AROES)"
  },
  {
   value: "San Carlos De Bariloche (ARBRC)",
   label: "San Carlos De Bariloche (ARBRC)"
  },
  {
   value: "San Fernando (ARSFE)",
   label: "San Fernando (ARSFE)"
  },
  {
   value: "San Juan (ARUAQ)",
   label: "San Juan (ARUAQ)"
  },
  {
   value: "San Julian (ARULA)",
   label: "San Julian (ARULA)"
  },
  {
   value: "San Lorenzo (ARSLO)",
   label: "San Lorenzo (ARSLO)"
  },
  {
   value: "San Luis (ARLUQ)",
   label: "San Luis (ARLUQ)"
  },
  {
   value: "San Martin DeLos Andes (ARCPC)",
   label: "San Martin DeLos Andes (ARCPC)"
  },
  {
   value: "San Nicolas de los Los Arroyos (ARSNS)",
   label: "San Nicolas de los Los Arroyos (ARSNS)"
  },
  {
   value: "San Pedro (ARXPD)",
   label: "San Pedro (ARXPD)"
  },
  {
   value: "San Rafael (ARAFA)",
   label: "San Rafael (ARAFA)"
  },
  {
   value: "San Sebastian (ARSSN)",
   label: "San Sebastian (ARSSN)"
  },
  {
   value: "Santa Cruz (ARRZA)",
   label: "Santa Cruz (ARRZA)"
  },
  {
   value: "Santa Fe (ARSFN)",
   label: "Santa Fe (ARSFN)"
  },
  {
   value: "Ingeniero Jacobacci (ARIGB)",
   label: "Ingeniero Jacobacci (ARIGB)"
  },
  {
   value: "Jose de San Martin (ARJSM)",
   label: "Jose de San Martin (ARJSM)"
  },
  {
   value: "Jujuy (ARJUJ)",
   label: "Jujuy (ARJUJ)"
  },
  {
   value: "Junin (ARJNI)",
   label: "Junin (ARJNI)"
  },
  {
   value: "La Cumbre (ARLCM)",
   label: "La Cumbre (ARLCM)"
  },
  {
   value: "La Plata (ARLPG)",
   label: "La Plata (ARLPG)"
  },
  {
   value: "La Rioja (ARIRJ)",
   label: "La Rioja (ARIRJ)"
  },
  {
   value: "Lago Argentino (ARING)",
   label: "Lago Argentino (ARING)"
  },
  {
   value: "Las Heras (ARLHS)",
   label: "Las Heras (ARLHS)"
  },
  {
   value: "Las Lomitas (ARLLS)",
   label: "Las Lomitas (ARLLS)"
  },
  {
   value: "Ledesma (ARXMX)",
   label: "Ledesma (ARXMX)"
  },
  {
   value: "Loncopue (ARLCP)",
   label: "Loncopue (ARLCP)"
  },
  {
   value: "Los Menucos (ARLMD)",
   label: "Los Menucos (ARLMD)"
  },
  {
   value: "Malargue (ARLGS)",
   label: "Malargue (ARLGS)"
  },
  {
   value: "Maquinchao (ARMQD)",
   label: "Maquinchao (ARMQD)"
  },
  {
   value: "Mar del Plata (ARMDQ)",
   label: "Mar del Plata (ARMDQ)"
  },
  {
   value: "Mendoza (ARMDZ)",
   label: "Mendoza (ARMDZ)"
  },
  {
   value: "Mercedes (ARMDX)",
   label: "Mercedes (ARMDX)"
  },
  {
   value: "Ministro Pistarini (AREZE)",
   label: "Ministro Pistarini (AREZE)"
  },
  {
   value: "Miramar (ARMJR)",
   label: "Miramar (ARMJR)"
  },
  {
   value: "Monte Caseros (ARMCS)",
   label: "Monte Caseros (ARMCS)"
  },
  {
   value: "Mosconi (ARXOS)",
   label: "Mosconi (ARXOS)"
  },
  {
   value: "Necochea (ARNEC)",
   label: "Necochea (ARNEC)"
  },
  {
   value: "Neuquen (ARNQN)",
   label: "Neuquen (ARNQN)"
  },
  {
   value: "Olivos (ARQLV)",
   label: "Olivos (ARQLV)"
  },
  {
   value: "Oran (ARORA)",
   label: "Oran (ARORA)"
  },
  {
   value: "Parana (ARPRA)",
   label: "Parana (ARPRA)"
  },
  {
   value: "Paso de los Libres (ARAOL)",
   label: "Paso de los Libres (ARAOL)"
  },
  {
   value: "Pehuajo (ARPEH)",
   label: "Pehuajo (ARPEH)"
  },
  {
   value: "Perito Moreno (ARPMQ)",
   label: "Perito Moreno (ARPMQ)"
  },
  {
   value: "Pichanal (ARXMV)",
   label: "Pichanal (ARXMV)"
  },
  {
   value: "Pilcomayo (ARPCY)",
   label: "Pilcomayo (ARPCY)"
  },
  {
   value: "Pinamar (ARQPQ)",
   label: "Pinamar (ARQPQ)"
  },
  {
   value: "Posadas (ARPSS)",
   label: "Posadas (ARPSS)"
  },
  {
   value: "Pres. Roque Saenz Pena (ARPRQ)",
   label: "Pres. Roque Saenz Pena (ARPRQ)"
  },
  {
   value: "Puerto Belgrano\/Bahia Blanca (ARPBG)",
   label: "Puerto Belgrano\/Bahia Blanca (ARPBG)"
  },
  {
   value: "Puerto Borghi (ARPUB)",
   label: "Puerto Borghi (ARPUB)"
  },
  {
   value: "Puerto Deseado (ARPUD)",
   label: "Puerto Deseado (ARPUD)"
  },
  {
   value: "Barranqueras (ARBQS)",
   label: "Barranqueras (ARBQS)"
  },
  {
   value: "Buenos Aires (ARBUE)",
   label: "Buenos Aires (ARBUE)"
  },
  {
   value: "Caleta Cordoba (ARCLC)",
   label: "Caleta Cordoba (ARCLC)"
  },
  {
   value: "Caleta Olivia (ARCVI)",
   label: "Caleta Olivia (ARCVI)"
  },
  {
   value: "Campana (ARCMP)",
   label: "Campana (ARCMP)"
  },
  {
   value: "Carmen de Patagones (ARCPG)",
   label: "Carmen de Patagones (ARCPG)"
  },
  {
   value: "Catamarca (ARCTC)",
   label: "Catamarca (ARCTC)"
  },
  {
   value: "Caviahue (ARCVH)",
   label: "Caviahue (ARCVH)"
  },
  {
   value: "Ceres (ARCRR)",
   label: "Ceres (ARCRR)"
  },
  {
   value: "Charata (ARCNT)",
   label: "Charata (ARCNT)"
  },
  {
   value: "Chos Malal (ARHOS)",
   label: "Chos Malal (ARHOS)"
  },
  {
   value: "Clorinda (ARCLX)",
   label: "Clorinda (ARCLX)"
  },
  {
   value: "Colon (ARCOL)",
   label: "Colon (ARCOL)"
  },
  {
   value: "Colonia Catriel (ARCCT)",
   label: "Colonia Catriel (ARCCT)"
  },
  {
   value: "Colonia Sarmiento (AROLN)",
   label: "Colonia Sarmiento (AROLN)"
  },
  {
   value: "Comodoro Rivadavia (ARCRD)",
   label: "Comodoro Rivadavia (ARCRD)"
  },
  {
   value: "Concepcion del Uruguay (ARCOU)",
   label: "Concepcion del Uruguay (ARCOU)"
  },
  {
   value: "Concordia (ARCOC)",
   label: "Concordia (ARCOC)"
  },
  {
   value: "Cordoba (ARCOR)",
   label: "Cordoba (ARCOR)"
  },
  {
   value: "Corrientes (ARCNQ)",
   label: "Corrientes (ARCNQ)"
  },
  {
   value: "Cuatreros\/Bahia Blanca (ARCUA)",
   label: "Cuatreros\/Bahia Blanca (ARCUA)"
  },
  {
   value: "Curuzu Cuatia (ARUZU)",
   label: "Curuzu Cuatia (ARUZU)"
  },
  {
   value: "Cutral (ARCUT)",
   label: "Cutral (ARCUT)"
  },
  {
   value: "Diamante (ARDME)",
   label: "Diamante (ARDME)"
  },
  {
   value: "El Bolson (AREHL)",
   label: "El Bolson (AREHL)"
  },
  {
   value: "El Maiten (AREMX)",
   label: "El Maiten (AREMX)"
  },
  {
   value: "Eldorado (ARELO)",
   label: "Eldorado (ARELO)"
  },
  {
   value: "Embarcacion (ARZAI)",
   label: "Embarcacion (ARZAI)"
  },
  {
   value: "Esquel (AREQS)",
   label: "Esquel (AREQS)"
  },
  {
   value: "Formosa (ARFMA)",
   label: "Formosa (ARFMA)"
  },
  {
   value: "General Pico (ARGPO)",
   label: "General Pico (ARGPO)"
  },
  {
   value: "General Roca (ARGNR)",
   label: "General Roca (ARGNR)"
  },
  {
   value: "General Villegas (ARVGS)",
   label: "General Villegas (ARVGS)"
  },
  {
   value: "Gobernador Gregores (ARGGS)",
   label: "Gobernador Gregores (ARGGS)"
  },
  {
   value: "Goya (AROYA)",
   label: "Goya (AROYA)"
  },
  {
   value: "Gualeguaychu (ARGHU)",
   label: "Gualeguaychu (ARGHU)"
  },
  {
   value: "Ibicuy (ARIBY)",
   label: "Ibicuy (ARIBY)"
  },
  {
   value: "Iguazu (ARIGR)",
   label: "Iguazu (ARIGR)"
  },
  {
   value: "Luena (AOLUO)",
   label: "Luena (AOLUO)"
  },
  {
   value: "Lukapa (AOLBZ)",
   label: "Lukapa (AOLBZ)"
  },
  {
   value: "Lumbala (AOGGC)",
   label: "Lumbala (AOGGC)"
  },
  {
   value: "Luzamba (AOLZM)",
   label: "Luzamba (AOLZM)"
  },
  {
   value: "M'banza Congo (AOSSY)",
   label: "M'banza Congo (AOSSY)"
  },
  {
   value: "Malange (AOMEG)",
   label: "Malange (AOMEG)"
  },
  {
   value: "Malembo (AOMLO)",
   label: "Malembo (AOMLO)"
  },
  {
   value: "Malongo (AOMAL)",
   label: "Malongo (AOMAL)"
  },
  {
   value: "Menongue (AOSPP)",
   label: "Menongue (AOSPP)"
  },
  {
   value: "N'Riquinha (AONRQ)",
   label: "N'Riquinha (AONRQ)"
  },
  {
   value: "N'Zeto (AOARZ)",
   label: "N'Zeto (AOARZ)"
  },
  {
   value: "Namibe (AOMSZ)",
   label: "Namibe (AOMSZ)"
  },
  {
   value: "Ndalatandos (AONDF)",
   label: "Ndalatandos (AONDF)"
  },
  {
   value: "Negage (AOGXG)",
   label: "Negage (AOGXG)"
  },
  {
   value: "Ngiva (AONGV)",
   label: "Ngiva (AONGV)"
  },
  {
   value: "Novo Redondo (AONOE)",
   label: "Novo Redondo (AONOE)"
  },
  {
   value: "Nzagi (AONZA)",
   label: "Nzagi (AONZA)"
  },
  {
   value: "Ongiva (AOVPE)",
   label: "Ongiva (AOVPE)"
  },
  {
   value: "Palanca Terminal (AOPAT)",
   label: "Palanca Terminal (AOPAT)"
  },
  {
   value: "Porto Alexandre (AOPLE)",
   label: "Porto Alexandre (AOPLE)"
  },
  {
   value: "Porto Amboim (AOPBN)",
   label: "Porto Amboim (AOPBN)"
  },
  {
   value: "San Antonio do Zaire (AOSAZ)",
   label: "San Antonio do Zaire (AOSAZ)"
  },
  {
   value: "Saurimo (AOVHC)",
   label: "Saurimo (AOVHC)"
  },
  {
   value: "Soyo (AOSZA)",
   label: "Soyo (AOSZA)"
  },
  {
   value: "Soyo-Quinfuquena Terminal (AOSOQ)",
   label: "Soyo-Quinfuquena Terminal (AOSOQ)"
  },
  {
   value: "Sumbe (AONDD)",
   label: "Sumbe (AONDD)"
  },
  {
   value: "Takula Terminal (AOTAK)",
   label: "Takula Terminal (AOTAK)"
  },
  {
   value: "Uige (AOUGO)",
   label: "Uige (AOUGO)"
  },
  {
   value: "Waco Kungo (AOCEO)",
   label: "Waco Kungo (AOCEO)"
  },
  {
   value: "Xangongo (AOXGN)",
   label: "Xangongo (AOXGN)"
  },
  {
   value: "McMurdo (AQMCM)",
   label: "McMurdo (AQMCM)"
  },
  {
   value: "Teniente R. Marsh (AQTNM)",
   label: "Teniente R. Marsh (AQTNM)"
  },
  {
   value: "Terra Nova (AQTNB)",
   label: "Terra Nova (AQTNB)"
  },
  {
   value: "Alto Rio Senguerr (ARARR)",
   label: "Alto Rio Senguerr (ARARR)"
  },
  {
   value: "Arpt. Jorge Newbery \/ BUENOS AIRES (ARAEP)",
   label: "Arpt. Jorge Newbery \/ BUENOS AIRES (ARAEP)"
  },
  {
   value: "Atucha (ARATU)",
   label: "Atucha (ARATU)"
  },
  {
   value: "Bahia Blanca (ARBHI)",
   label: "Bahia Blanca (ARBHI)"
  },
  {
   value: "Bahia Blanca-Ingeniero White (ARINW)",
   label: "Bahia Blanca-Ingeniero White (ARINW)"
  },
  {
   value: "\"Caracasbaii (ANCRB)",
   label: "\"Caracasbaii (ANCRB)"
  },
  {
   value: "Curacao (ANCUR)",
   label: "Curacao (ANCUR)"
  },
  {
   value: "Emmastad (ANEMM)",
   label: "Emmastad (ANEMM)"
  },
  {
   value: "\"Fuikbaai (ANFUI)",
   label: "\"Fuikbaai (ANFUI)"
  },
  {
   value: "\"Gustavia (ANGUS)",
   label: "\"Gustavia (ANGUS)"
  },
  {
   value: "\"Kralendijk (ANKRA)",
   label: "\"Kralendijk (ANKRA)"
  },
  {
   value: "Marigot (ANMAR)",
   label: "Marigot (ANMAR)"
  },
  {
   value: "Philipsburg (ANPHI)",
   label: "Philipsburg (ANPHI)"
  },
  {
   value: "\"Rincon (ANRIN)",
   label: "\"Rincon (ANRIN)"
  },
  {
   value: "Saba Is (ANSAB)",
   label: "Saba Is (ANSAB)"
  },
  {
   value: "St Eustatius (ANEUX)",
   label: "St Eustatius (ANEUX)"
  },
  {
   value: "St Maarten (ANSXM)",
   label: "St Maarten (ANSXM)"
  },
  {
   value: "St Michiels Bay (ANSMB)",
   label: "St Michiels Bay (ANSMB)"
  },
  {
   value: "\"Willemstad (ANWIL)",
   label: "\"Willemstad (ANWIL)"
  },
  {
   value: "Ambriz (AOAZZ)",
   label: "Ambriz (AOAZZ)"
  },
  {
   value: "Andulo (AOANL)",
   label: "Andulo (AOANL)"
  },
  {
   value: "Baia dos Tigres (AOBDT)",
   label: "Baia dos Tigres (AOBDT)"
  },
  {
   value: "Barra do Dande (AOBDD)",
   label: "Barra do Dande (AOBDD)"
  },
  {
   value: "Benguela (AOBUG)",
   label: "Benguela (AOBUG)"
  },
  {
   value: "Cabinda (AOCAB)",
   label: "Cabinda (AOCAB)"
  },
  {
   value: "Cafunfo (AOCFF)",
   label: "Cafunfo (AOCFF)"
  },
  {
   value: "Cangamba (AOCNZ)",
   label: "Cangamba (AOCNZ)"
  },
  {
   value: "Capanda (AOKNP)",
   label: "Capanda (AOKNP)"
  },
  {
   value: "Catumbela (AOCBT)",
   label: "Catumbela (AOCBT)"
  },
  {
   value: "Cazombo (AOCAV)",
   label: "Cazombo (AOCAV)"
  },
  {
   value: "Chitato (AOPGI)",
   label: "Chitato (AOPGI)"
  },
  {
   value: "Cuito Cuanavale (AOCTI)",
   label: "Cuito Cuanavale (AOCTI)"
  },
  {
   value: "Dirico (AODRC)",
   label: "Dirico (AODRC)"
  },
  {
   value: "Dombe Grande (AODGR)",
   label: "Dombe Grande (AODGR)"
  },
  {
   value: "Dundo (AODUE)",
   label: "Dundo (AODUE)"
  },
  {
   value: "Huambo (AONOV)",
   label: "Huambo (AONOV)"
  },
  {
   value: "Jamba (AOJMB)",
   label: "Jamba (AOJMB)"
  },
  {
   value: "Kuito (AOSVP)",
   label: "Kuito (AOSVP)"
  },
  {
   value: "Landana (AOLAA)",
   label: "Landana (AOLAA)"
  },
  {
   value: "Lieura (AOLIE)",
   label: "Lieura (AOLIE)"
  },
  {
   value: "Lobito (AOLOB)",
   label: "Lobito (AOLOB)"
  },
  {
   value: "Luanda (AOLAD)",
   label: "Luanda (AOLAD)"
  },
  {
   value: "Luau (AOUAL)",
   label: "Luau (AOUAL)"
  },
  {
   value: "Lubango (AOSDD)",
   label: "Lubango (AOSDD)"
  },
  {
   value: "Lucira (AOLUC)",
   label: "Lucira (AOLUC)"
  },
  {
   value: "Jalalabad (AFJAA)",
   label: "Jalalabad (AFJAA)"
  },
  {
   value: "Kabul (AFKBL)",
   label: "Kabul (AFKBL)"
  },
  {
   value: "Kandahar (AFKDH)",
   label: "Kandahar (AFKDH)"
  },
  {
   value: "Khost (AFKHT)",
   label: "Khost (AFKHT)"
  },
  {
   value: "Khwahan (AFKWH)",
   label: "Khwahan (AFKWH)"
  },
  {
   value: "Kunduz (AFUND)",
   label: "Kunduz (AFUND)"
  },
  {
   value: "Kuran-O-Munjan (AFKUR)",
   label: "Kuran-O-Munjan (AFKUR)"
  },
  {
   value: "Maimana (AFMMZ)",
   label: "Maimana (AFMMZ)"
  },
  {
   value: "Mashad (AFMAS)",
   label: "Mashad (AFMAS)"
  },
  {
   value: "Mazar-I-Sharif (AFMZR)",
   label: "Mazar-I-Sharif (AFMZR)"
  },
  {
   value: "Nimroz (AFIMZ)",
   label: "Nimroz (AFIMZ)"
  },
  {
   value: "Qala Nau (AFLQN)",
   label: "Qala Nau (AFLQN)"
  },
  {
   value: "Sardeh Band (AFSBF)",
   label: "Sardeh Band (AFSBF)"
  },
  {
   value: "Sheghnan (AFSGA)",
   label: "Sheghnan (AFSGA)"
  },
  {
   value: "Taluqan (AFTQN)",
   label: "Taluqan (AFTQN)"
  },
  {
   value: "Tirinkot (AFTII)",
   label: "Tirinkot (AFTII)"
  },
  {
   value: "Torghundi (AFTGH)",
   label: "Torghundi (AFTGH)"
  },
  {
   value: "Urgoon (AFURN)",
   label: "Urgoon (AFURN)"
  },
  {
   value: "Uruzgan (AFURZ)",
   label: "Uruzgan (AFURZ)"
  },
  {
   value: "Zaranj (AFZAJ)",
   label: "Zaranj (AFZAJ)"
  },
  {
   value: "Antigua (AGANU)",
   label: "Antigua (AGANU)"
  },
  {
   value: "Barbuda (AGBBQ)",
   label: "Barbuda (AGBBQ)"
  },
  {
   value: "St John's (AGSJO)",
   label: "St John's (AGSJO)"
  },
  {
   value: "Anguilla (AIAXA)",
   label: "Anguilla (AIAXA)"
  },
  {
   value: "Blowing Point (AIBLP)",
   label: "Blowing Point (AIBLP)"
  },
  {
   value: "Road Bay (AIRBY)",
   label: "Road Bay (AIRBY)"
  },
  {
   value: "The Forest (AIFOR)",
   label: "The Forest (AIFOR)"
  },
  {
   value: "The Road (AIROA)",
   label: "The Road (AIROA)"
  },
  {
   value: "Durrës (ALDRZ)",
   label: "Durrës (ALDRZ)"
  },
  {
   value: "Saranda (ALSAR)",
   label: "Saranda (ALSAR)"
  },
  {
   value: "Shengjin (ALSHG)",
   label: "Shengjin (ALSHG)"
  },
  {
   value: "Tenes (ALTEN)",
   label: "Tenes (ALTEN)"
  },
  {
   value: "Tirana (ALTIA)",
   label: "Tirana (ALTIA)"
  },
  {
   value: "Vlora (ALVOA)",
   label: "Vlora (ALVOA)"
  },
  {
   value: "Akhuryan (AMAHU)",
   label: "Akhuryan (AMAHU)"
  },
  {
   value: "Gyoumri (AMLWN)",
   label: "Gyoumri (AMLWN)"
  },
  {
   value: "Yerevan (AMEVN)",
   label: "Yerevan (AMEVN)"
  },
  {
   value: "Barcadera (ANBAR)",
   label: "Barcadera (ANBAR)"
  },
  {
   value: "Bonaire (ANBON)",
   label: "Bonaire (ANBON)"
  },
  {
   value: "Bullen Bay (ANBUB)",
   label: "Bullen Bay (ANBUB)"
  },
  {
   value: "Bushiribana (ANBUS)",
   label: "Bushiribana (ANBUS)"
  },
  {
   value: "Andorra La Vella (ADALV)",
   label: "Andorra La Vella (ADALV)"
  },
  {
   value: "Abu al Bukhoosh (AEABU)",
   label: "Abu al Bukhoosh (AEABU)"
  },
  {
   value: "Abu Dhabi (AEAUH)",
   label: "Abu Dhabi (AEAUH)"
  },
  {
   value: "Ajman (AEAJM)",
   label: "Ajman (AEAJM)"
  },
  {
   value: "Al Ain (AEAAN)",
   label: "Al Ain (AEAAN)"
  },
  {
   value: "Al Dhafra (AEDHF)",
   label: "Al Dhafra (AEDHF)"
  },
  {
   value: "Arzanah Island (AEARZ)",
   label: "Arzanah Island (AEARZ)"
  },
  {
   value: "Das Island (AEDAS)",
   label: "Das Island (AEDAS)"
  },
  {
   value: "Dubai (AEDXB)",
   label: "Dubai (AEDXB)"
  },
  {
   value: "Fateh Terminal (AEFAT)",
   label: "Fateh Terminal (AEFAT)"
  },
  {
   value: "Fujairah (Al-Fujairah) (AEFJR)",
   label: "Fujairah (Al-Fujairah) (AEFJR)"
  },
  {
   value: "Hamriya (AEHAM)",
   label: "Hamriya (AEHAM)"
  },
  {
   value: "Jebel Ali (AEJEA)",
   label: "Jebel Ali (AEJEA)"
  },
  {
   value: "Jebel Dhanna (AEJED)",
   label: "Jebel Dhanna (AEJED)"
  },
  {
   value: "Khor Al Fakkan (AEKLF)",
   label: "Khor Al Fakkan (AEKLF)"
  },
  {
   value: "Masfut (AEMAS)",
   label: "Masfut (AEMAS)"
  },
  {
   value: "Mina Saqr (AEMSA)",
   label: "Mina Saqr (AEMSA)"
  },
  {
   value: "Mina Zayed (AEMZD)",
   label: "Mina Zayed (AEMZD)"
  },
  {
   value: "Minhad (AENHD)",
   label: "Minhad (AENHD)"
  },
  {
   value: "Mubarek Terminal (AEMUB)",
   label: "Mubarek Terminal (AEMUB)"
  },
  {
   value: "Mubarras Island (AEMBS)",
   label: "Mubarras Island (AEMBS)"
  },
  {
   value: "Musafa (AEFMZ)",
   label: "Musafa (AEFMZ)"
  },
  {
   value: "Port Rashid (AEPRA)",
   label: "Port Rashid (AEPRA)"
  },
  {
   value: "Ras Al Khaimah (AERKT)",
   label: "Ras Al Khaimah (AERKT)"
  },
  {
   value: "Ras Zubbaya (Ras Dubayyah) (AEDUY)",
   label: "Ras Zubbaya (Ras Dubayyah) (AEDUY)"
  },
  {
   value: "Ruwais (AERUW)",
   label: "Ruwais (AERUW)"
  },
  {
   value: "Sharjah (AESHJ)",
   label: "Sharjah (AESHJ)"
  },
  {
   value: "Umm Al Qaiwain (AEQIW)",
   label: "Umm Al Qaiwain (AEQIW)"
  },
  {
   value: "Zurku Island (AEZUR)",
   label: "Zurku Island (AEZUR)"
  },
  {
   value: "Bamian (AFBIN)",
   label: "Bamian (AFBIN)"
  },
  {
   value: "Bost (AFBST)",
   label: "Bost (AFBST)"
  },
  {
   value: "Chakcharan (AFCCN)",
   label: "Chakcharan (AFCCN)"
  },
  {
   value: "Darwaz (AFDAZ)",
   label: "Darwaz (AFDAZ)"
  },
  {
   value: "Faizabad (AFFBD)",
   label: "Faizabad (AFFBD)"
  },
  {
   value: "Farah (AFFAH)",
   label: "Farah (AFFAH)"
  },
  {
   value: "Gardez (AFGRG)",
   label: "Gardez (AFGRG)"
  },
  {
   value: "Ghazni (AFGZI)",
   label: "Ghazni (AFGZI)"
  },
  {
   value: "Hairatan (AFHRT)",
   label: "Hairatan (AFHRT)"
  },
  {
   value: "Herat (AFHEA)",
   label: "Herat (AFHEA)"
  },
  {
   value: "Gaussig (DEGXS)",
   label: "Gaussig (DEGXS)"
  },
  {
   value: "Gauting (DEGNG)",
   label: "Gauting (DEGNG)"
  },
  {
   value: "Gebenbach (DEZGH)",
   label: "Gebenbach (DEZGH)"
  },
  {
   value: "Gebersbach (DEGBB)",
   label: "Gebersbach (DEGBB)"
  },
  {
   value: "Gebhardshain (DEGBA)",
   label: "Gebhardshain (DEGBA)"
  },
  {
   value: "Gebsattel (DEZGL)",
   label: "Gebsattel (DEZGL)"
  },
  {
   value: "Gefell (DEGFL)",
   label: "Gefell (DEGFL)"
  },
  {
   value: "Gefell (DEGLL)",
   label: "Gefell (DEGLL)"
  },
  {
   value: "Gefrees (DEZGS)",
   label: "Gefrees (DEZGS)"
  },
  {
   value: "Gehrden (DEGHD)",
   label: "Gehrden (DEGHD)"
  },
  {
   value: "Gehren (DEILU)",
   label: "Gehren (DEILU)"
  },
  {
   value: "Geiselbullach (DEGBL)",
   label: "Geiselbullach (DEGBL)"
  },
  {
   value: "Geisenfeld (DEGEX)",
   label: "Geisenfeld (DEGEX)"
  },
  {
   value: "Geisenhausen (DEZGN)",
   label: "Geisenhausen (DEZGN)"
  },
  {
   value: "Geising (DEGSG)",
   label: "Geising (DEGSG)"
  },
  {
   value: "Geisingen (DEZGB)",
   label: "Geisingen (DEZGB)"
  },
  {
   value: "Geisleden (DEGQL)",
   label: "Geisleden (DEGQL)"
  },
  {
   value: "Geislingen (DEGLB)",
   label: "Geislingen (DEGLB)"
  },
  {
   value: "Geismar (DEGIS)",
   label: "Geismar (DEGIS)"
  },
  {
   value: "Geithain (DEGTH)",
   label: "Geithain (DEGTH)"
  },
  {
   value: "Geltendorf (DEGLF)",
   label: "Geltendorf (DEGLF)"
  },
  {
   value: "Gemmrigheim (DEGGM)",
   label: "Gemmrigheim (DEGGM)"
  },
  {
   value: "Fürstenstein (DEFSN)",
   label: "Fürstenstein (DEFSN)"
  },
  {
   value: "Fürstenzell (DEFUZ)",
   label: "Fürstenzell (DEFUZ)"
  },
  {
   value: "Fürth (DEFUH)",
   label: "Fürth (DEFUH)"
  },
  {
   value: "Fürth (DEFUR)",
   label: "Fürth (DEFUR)"
  },
  {
   value: "Furtwangen (DEFWN)",
   label: "Furtwangen (DEFWN)"
  },
  {
   value: "Fussgönheim (DEFSG)",
   label: "Fussgönheim (DEFSG)"
  },
  {
   value: "Gailingen (DEGAE)",
   label: "Gailingen (DEGAE)"
  },
  {
   value: "Gaimersheim (DEGAM)",
   label: "Gaimersheim (DEGAM)"
  },
  {
   value: "Gallin (DEGIN)",
   label: "Gallin (DEGIN)"
  },
  {
   value: "Gallin (DELLI)",
   label: "Gallin (DELLI)"
  },
  {
   value: "Gammelby (DEGMY)",
   label: "Gammelby (DEGMY)"
  },
  {
   value: "Gammelshausen (DEGLS)",
   label: "Gammelshausen (DEGLS)"
  },
  {
   value: "Gammertingen (DEGTG)",
   label: "Gammertingen (DEGTG)"
  },
  {
   value: "Gangelt (DEGGT)",
   label: "Gangelt (DEGGT)"
  },
  {
   value: "Garbsen (DEGBS)",
   label: "Garbsen (DEGBS)"
  },
  {
   value: "Garrel (DEGAL)",
   label: "Garrel (DEGAL)"
  },
  {
   value: "Gatersleben (DENGR)",
   label: "Gatersleben (DENGR)"
  },
  {
   value: "Gau Algesheim (DEGUI)",
   label: "Gau Algesheim (DEGUI)"
  },
  {
   value: "Gau Odernheim (DEGAO)",
   label: "Gau Odernheim (DEGAO)"
  },
  {
   value: "Gauensiek (DEGAU)",
   label: "Gauensiek (DEGAU)"
  },
  {
   value: "Gäufelden (DEAEU)",
   label: "Gäufelden (DEAEU)"
  },
  {
   value: "Gaukönigshofen (DEGKH)",
   label: "Gaukönigshofen (DEGKH)"
  },
  {
   value: "Freudenburg (DEFED)",
   label: "Freudenburg (DEFED)"
  },
  {
   value: "Freudental (DEFDL)",
   label: "Freudental (DEFDL)"
  },
  {
   value: "Freyung (DEFRY)",
   label: "Freyung (DEFRY)"
  },
  {
   value: "Frickenhausen (DEFKH)",
   label: "Frickenhausen (DEFKH)"
  },
  {
   value: "Frickingen (DEZDV)",
   label: "Frickingen (DEZDV)"
  },
  {
   value: "Fridolfing (DEFDP)",
   label: "Fridolfing (DEFDP)"
  },
  {
   value: "Friedberg (DEFBE)",
   label: "Friedberg (DEFBE)"
  },
  {
   value: "Friedelsheim (DEFDM)",
   label: "Friedelsheim (DEFDM)"
  },
  {
   value: "Friedenweiler (DEFWR)",
   label: "Friedenweiler (DEFWR)"
  },
  {
   value: "Friedersdorf (DEFSO)",
   label: "Friedersdorf (DEFSO)"
  },
  {
   value: "Friedrichsfeld (DEFHL)",
   label: "Friedrichsfeld (DEFHL)"
  },
  {
   value: "Friedrichsschleuse (DEFDS)",
   label: "Friedrichsschleuse (DEFDS)"
  },
  {
   value: "Friedrichsthal (DEFRS)",
   label: "Friedrichsthal (DEFRS)"
  },
  {
   value: "Friedrich-Wilhelmshutte (DEFWH)",
   label: "Friedrich-Wilhelmshutte (DEFWH)"
  },
  {
   value: "Friesenheim (Baden) (DEFXM)",
   label: "Friesenheim (Baden) (DEFXM)"
  },
  {
   value: "Friesenried (DEFSR)",
   label: "Friesenried (DEFSR)"
  },
  {
   value: "Friolzheim (DEFIO)",
   label: "Friolzheim (DEFIO)"
  },
  {
   value: "Frittlingen (DEFTT)",
   label: "Frittlingen (DEFTT)"
  },
  {
   value: "Fronhausen (DEFRX)",
   label: "Fronhausen (DEFRX)"
  },
  {
   value: "Fuldabrück (DEFBK)",
   label: "Fuldabrück (DEFBK)"
  },
  {
   value: "Fünfstetten (DEZUN)",
   label: "Fünfstetten (DEZUN)"
  },
  {
   value: "Forst (DEFTS)",
   label: "Forst (DEFTS)"
  },
  {
   value: "Forst (Eifel) (DEFEF)",
   label: "Forst (Eifel) (DEFEF)"
  },
  {
   value: "Forstinning (DEFTI)",
   label: "Forstinning (DEFTI)"
  },
  {
   value: "Forstwald (DEFWD)",
   label: "Forstwald (DEFWD)"
  },
  {
   value: "Förtha (DEFTH)",
   label: "Förtha (DEFTH)"
  },
  {
   value: "Fraenkisch Crumbach (DEZII)",
   label: "Fraenkisch Crumbach (DEZII)"
  },
  {
   value: "Frankenbach (DEFRC)",
   label: "Frankenbach (DEFRC)"
  },
  {
   value: "Frankendorf (DEFKU)",
   label: "Frankendorf (DEFKU)"
  },
  {
   value: "Frankeneck (DEFRK)",
   label: "Frankeneck (DEFRK)"
  },
  {
   value: "Frankenheim (DEZJU)",
   label: "Frankenheim (DEZJU)"
  },
  {
   value: "Frankleben (DEFKL)",
   label: "Frankleben (DEFKL)"
  },
  {
   value: "Frauenau (DEFRR)",
   label: "Frauenau (DEFRR)"
  },
  {
   value: "Frauenneuharting (DEZFG)",
   label: "Frauenneuharting (DEZFG)"
  },
  {
   value: "Fraureuth (DEURT)",
   label: "Fraureuth (DEURT)"
  },
  {
   value: "Fredersdorf (DEFRD)",
   label: "Fredersdorf (DEFRD)"
  },
  {
   value: "Freihung (DEFHG)",
   label: "Freihung (DEFHG)"
  },
  {
   value: "Freilingen (DEFEI)",
   label: "Freilingen (DEFEI)"
  },
  {
   value: "Freisen (DEZFN)",
   label: "Freisen (DEZFN)"
  },
  {
   value: "Freital (DEFTA)",
   label: "Freital (DEFTA)"
  },
  {
   value: "Freudenberg (DEFGB)",
   label: "Freudenberg (DEFGB)"
  },
  {
   value: "Freudenberg (DEFRH)",
   label: "Freudenberg (DEFRH)"
  },
  {
   value: "Feldkirchen (DEFKM)",
   label: "Feldkirchen (DEFKM)"
  },
  {
   value: "Feldkirchen-Westerham (DEFWM)",
   label: "Feldkirchen-Westerham (DEFWM)"
  },
  {
   value: "Fellheim (DEFHM)",
   label: "Fellheim (DEFHM)"
  },
  {
   value: "Felsberg (DEFSB)",
   label: "Felsberg (DEFSB)"
  },
  {
   value: "Fernwald (DEFRW)",
   label: "Fernwald (DEFRW)"
  },
  {
   value: "Feuchtwangen (DEFEW)",
   label: "Feuchtwangen (DEFEW)"
  },
  {
   value: "Fichtelberg (DEFIC)",
   label: "Fichtelberg (DEFIC)"
  },
  {
   value: "Fichtenau (DEFIH)",
   label: "Fichtenau (DEFIH)"
  },
  {
   value: "Fichtenberg (DEFNB)",
   label: "Fichtenberg (DEFNB)"
  },
  {
   value: "Fischach (DEFIS)",
   label: "Fischach (DEFIS)"
  },
  {
   value: "Fischbachau (DEUBF)",
   label: "Fischbachau (DEUBF)"
  },
  {
   value: "Fischerhütte (DEFHU)",
   label: "Fischerhütte (DEFHU)"
  },
  {
   value: "Flachslanden (DEFLN)",
   label: "Flachslanden (DEFLN)"
  },
  {
   value: "Flecken Zechlin (DEFZI)",
   label: "Flecken Zechlin (DEFZI)"
  },
  {
   value: "Flieden (DEPHD)",
   label: "Flieden (DEPHD)"
  },
  {
   value: "Flonheim (DEFHI)",
   label: "Flonheim (DEFHI)"
  },
  {
   value: "Flörsheim-Dalsheim (DESSM)",
   label: "Flörsheim-Dalsheim (DESSM)"
  },
  {
   value: "Florstadt (DEFLS)",
   label: "Florstadt (DEFLS)"
  },
  {
   value: "Floss (DEFOS)",
   label: "Floss (DEFOS)"
  },
  {
   value: "Foerderstedt (DEZFT)",
   label: "Foerderstedt (DEZFT)"
  },
  {
   value: "Foeritz (DEFIZ)",
   label: "Foeritz (DEFIZ)"
  },
  {
   value: "Fohren (DEFHN)",
   label: "Fohren (DEFHN)"
  },
  {
   value: "Forbach (DEFBC)",
   label: "Forbach (DEFBC)"
  },
  {
   value: "Forchtenberg (DEFTB)",
   label: "Forchtenberg (DEFTB)"
  },
  {
   value: "Ettenbeuren (DEEBU)",
   label: "Ettenbeuren (DEEBU)"
  },
  {
   value: "Ettenheim (DEETI)",
   label: "Ettenheim (DEETI)"
  },
  {
   value: "Etting (Weilheim-Schongau) (DEZZZ)",
   label: "Etting (Weilheim-Schongau) (DEZZZ)"
  },
  {
   value: "Ettringen (DEETE)",
   label: "Ettringen (DEETE)"
  },
  {
   value: "Etzdorf (DEEZD)",
   label: "Etzdorf (DEEZD)"
  },
  {
   value: "Etzdorf (DETZF)",
   label: "Etzdorf (DETZF)"
  },
  {
   value: "Eurasburg (DEEUR)",
   label: "Eurasburg (DEEUR)"
  },
  {
   value: "Everswinkel (DEETS)",
   label: "Everswinkel (DEETS)"
  },
  {
   value: "Everswinkel (DEEWI)",
   label: "Everswinkel (DEEWI)"
  },
  {
   value: "Extertal (DEEXT)",
   label: "Extertal (DEEXT)"
  },
  {
   value: "Fachingen (DEFCI)",
   label: "Fachingen (DEFCI)"
  },
  {
   value: "Fahrenzhausen (DEFHZ)",
   label: "Fahrenzhausen (DEFHZ)"
  },
  {
   value: "Falkenberg (DEFBR)",
   label: "Falkenberg (DEFBR)"
  },
  {
   value: "Falkenberg (DEFKB)",
   label: "Falkenberg (DEFKB)"
  },
  {
   value: "Falkenhagen (DEFHA)",
   label: "Falkenhagen (DEFHA)"
  },
  {
   value: "Falkenhein (DEFNH)",
   label: "Falkenhein (DEFNH)"
  },
  {
   value: "Falkenrehde (DEFAR)",
   label: "Falkenrehde (DEFAR)"
  },
  {
   value: "Falkensee (DEFAK)",
   label: "Falkensee (DEFAK)"
  },
  {
   value: "Falkenstein (DEFKS)",
   label: "Falkenstein (DEFKS)"
  },
  {
   value: "Fallersleben (DEFAB)",
   label: "Fallersleben (DEFAB)"
  },
  {
   value: "Farchant (DEFAC)",
   label: "Farchant (DEFAC)"
  },
  {
   value: "Faulbach (DEFLB)",
   label: "Faulbach (DEFLB)"
  },
  {
   value: "Fechenheim (DEFEC)",
   label: "Fechenheim (DEFEC)"
  },
  {
   value: "Fehrbellin (DEZFE)",
   label: "Fehrbellin (DEZFE)"
  },
  {
   value: "Feilitzsch (DEFZC)",
   label: "Feilitzsch (DEFZC)"
  },
  {
   value: "Feldafing (DEFFI)",
   label: "Feldafing (DEFFI)"
  },
  {
   value: "Feldgeding (DEFGD)",
   label: "Feldgeding (DEFGD)"
  },
  {
   value: "Erlenbach (Heilbronn) (DEERO)",
   label: "Erlenbach (Heilbronn) (DEERO)"
  },
  {
   value: "Erlenbach am Main (DEEAM)",
   label: "Erlenbach am Main (DEEAM)"
  },
  {
   value: "Erlenbach bei Marktheidenfeld (DEERC)",
   label: "Erlenbach bei Marktheidenfeld (DEERC)"
  },
  {
   value: "Erligheim (DEEXM)",
   label: "Erligheim (DEEXM)"
  },
  {
   value: "Ermengerst (DEXEG)",
   label: "Ermengerst (DEXEG)"
  },
  {
   value: "Ertingen (DEEKB)",
   label: "Ertingen (DEEKB)"
  },
  {
   value: "Erzhausen (DEERZ)",
   label: "Erzhausen (DEERZ)"
  },
  {
   value: "Eschach (DEEHC)",
   label: "Eschach (DEEHC)"
  },
  {
   value: "Eschach (bei Schwäbisch Gmünd) (DEESA)",
   label: "Eschach (bei Schwäbisch Gmünd) (DEESA)"
  },
  {
   value: "Eschbach (DEEBA)",
   label: "Eschbach (DEEBA)"
  },
  {
   value: "Escheburg (DEHEB)",
   label: "Escheburg (DEHEB)"
  },
  {
   value: "Eschenbach (DEEHB)",
   label: "Eschenbach (DEEHB)"
  },
  {
   value: "Eschenbergen (DEETH)",
   label: "Eschenbergen (DEETH)"
  },
  {
   value: "Eselsfurth (DEEFU)",
   label: "Eselsfurth (DEEFU)"
  },
  {
   value: "Eslarn (DEEAN)",
   label: "Eslarn (DEEAN)"
  },
  {
   value: "Eslohe (DEEHE)",
   label: "Eslohe (DEEHE)"
  },
  {
   value: "Espenhain (DENHM)",
   label: "Espenhain (DENHM)"
  },
  {
   value: "Esselbach (DEFFR)",
   label: "Esselbach (DEFFR)"
  },
  {
   value: "Essen (DEEEN)",
   label: "Essen (DEEEN)"
  },
  {
   value: "Essenbach (DEEBX)",
   label: "Essenbach (DEEBX)"
  },
  {
   value: "Esseratsweiler (DEEWL)",
   label: "Esseratsweiler (DEEWL)"
  },
  {
   value: "Essingen (DEEGN)",
   label: "Essingen (DEEGN)"
  },
  {
   value: "Essingen (DESSI)",
   label: "Essingen (DESSI)"
  },
  {
   value: "Enger (DEENR)",
   label: "Enger (DEENR)"
  },
  {
   value: "Eningen unter Achalm (DEZME)",
   label: "Eningen unter Achalm (DEZME)"
  },
  {
   value: "Ensheim (DEENM)",
   label: "Ensheim (DEENM)"
  },
  {
   value: "Eppelborn (DEEPB)",
   label: "Eppelborn (DEEPB)"
  },
  {
   value: "Eppendorf (DEDXF)",
   label: "Eppendorf (DEDXF)"
  },
  {
   value: "Eppertshausen (DEEPA)",
   label: "Eppertshausen (DEEPA)"
  },
  {
   value: "Eppingen (DEEPI)",
   label: "Eppingen (DEEPI)"
  },
  {
   value: "Erbach (DEEBS)",
   label: "Erbach (DEEBS)"
  },
  {
   value: "Erdmannhausen (DEERM)",
   label: "Erdmannhausen (DEERM)"
  },
  {
   value: "Eresing (DEESI)",
   label: "Eresing (DEESI)"
  },
  {
   value: "Erfenstein (DEEFN)",
   label: "Erfenstein (DEEFN)"
  },
  {
   value: "Ergersheim (DEESM)",
   label: "Ergersheim (DEESM)"
  },
  {
   value: "Ergoldsbach (DESBA)",
   label: "Ergoldsbach (DESBA)"
  },
  {
   value: "Ering (DEERY)",
   label: "Ering (DEERY)"
  },
  {
   value: "Eriskirch (DEERI)",
   label: "Eriskirch (DEERI)"
  },
  {
   value: "Erkart (DEEKA)",
   label: "Erkart (DEEKA)"
  },
  {
   value: "Erkner (DEZAD)",
   label: "Erkner (DEZAD)"
  },
  {
   value: "Erlabrunn (DEEUN)",
   label: "Erlabrunn (DEEUN)"
  },
  {
   value: "Erlau (DEEAU)",
   label: "Erlau (DEEAU)"
  },
  {
   value: "Erlenbach (DEEBH)",
   label: "Erlenbach (DEEBH)"
  },
  {
   value: "Elsdorf (DEESD)",
   label: "Elsdorf (DEESD)"
  },
  {
   value: "Elsenfeld (DEELF)",
   label: "Elsenfeld (DEELF)"
  },
  {
   value: "Elsnigk (DEENK)",
   label: "Elsnigk (DEENK)"
  },
  {
   value: "Elsteraue (DEETA)",
   label: "Elsteraue (DEETA)"
  },
  {
   value: "Elsterberg (DEETB)",
   label: "Elsterberg (DEETB)"
  },
  {
   value: "Elsterheide (DEEHD)",
   label: "Elsterheide (DEEHD)"
  },
  {
   value: "Elsterwerda (DEEWA)",
   label: "Elsterwerda (DEEWA)"
  },
  {
   value: "Elstra (DEELH)",
   label: "Elstra (DEELH)"
  },
  {
   value: "Elten (DEETN)",
   label: "Elten (DEETN)"
  },
  {
   value: "Elterlein (DEELT)",
   label: "Elterlein (DEELT)"
  },
  {
   value: "Elxleben (DEELX)",
   label: "Elxleben (DEELX)"
  },
  {
   value: "Elz (DEEZL)",
   label: "Elz (DEEZL)"
  },
  {
   value: "Elzach (DEEZH)",
   label: "Elzach (DEEZH)"
  },
  {
   value: "Emmering (DEEMG)",
   label: "Emmering (DEEMG)"
  },
  {
   value: "Emmerthal (DEEMT)",
   label: "Emmerthal (DEEMT)"
  },
  {
   value: "Emmingen-Liptingen (DEELI)",
   label: "Emmingen-Liptingen (DEELI)"
  },
  {
   value: "Emstek (DEEXK)",
   label: "Emstek (DEEXK)"
  },
  {
   value: "Engelstadt (DEQES)",
   label: "Engelstadt (DEQES)"
  },
  {
   value: "Engen (DEENE)",
   label: "Engen (DEENE)"
  },
  {
   value: "Eigeltingen (DEZNI)",
   label: "Eigeltingen (DEZNI)"
  },
  {
   value: "Eilsbrunn (DEESB)",
   label: "Eilsbrunn (DEESB)"
  },
  {
   value: "Eilsleben (DEEIL)",
   label: "Eilsleben (DEEIL)"
  },
  {
   value: "Eimbeckhausen (DEEIH)",
   label: "Eimbeckhausen (DEEIH)"
  },
  {
   value: "Einersheim (DEMKE)",
   label: "Einersheim (DEMKE)"
  },
  {
   value: "Einhausen (DEEHA)",
   label: "Einhausen (DEEHA)"
  },
  {
   value: "Einswarden (DEEIW)",
   label: "Einswarden (DEEIW)"
  },
  {
   value: "Eisenbach (DEEHO)",
   label: "Eisenbach (DEEHO)"
  },
  {
   value: "Eisenberg (DEEEB)",
   label: "Eisenberg (DEEEB)"
  },
  {
   value: "Eisfeld (DEEID)",
   label: "Eisfeld (DEEID)"
  },
  {
   value: "Eiterfeld (DEETD)",
   label: "Eiterfeld (DEETD)"
  },
  {
   value: "Eitting (DEEIT)",
   label: "Eitting (DEEIT)"
  },
  {
   value: "Elben (DEENX)",
   label: "Elben (DEENX)"
  },
  {
   value: "Elbtal (DEETL)",
   label: "Elbtal (DEETL)"
  },
  {
   value: "Elfershausen (DEEEU)",
   label: "Elfershausen (DEEEU)"
  },
  {
   value: "Elgersweier (DEEIE)",
   label: "Elgersweier (DEEIE)"
  },
  {
   value: "Elkenroth (DEEKT)",
   label: "Elkenroth (DEEKT)"
  },
  {
   value: "Ellefeld (DELLE)",
   label: "Ellefeld (DELLE)"
  },
  {
   value: "Ellenberg (DEELA)",
   label: "Ellenberg (DEELA)"
  },
  {
   value: "Ellerau (DEELU)",
   label: "Ellerau (DEELU)"
  },
  {
   value: "Ellerbek (DEELB)",
   label: "Ellerbek (DEELB)"
  },
  {
   value: "Ellerstadt (DEERS)",
   label: "Ellerstadt (DEERS)"
  },
  {
   value: "Ellrich (DEELR)",
   label: "Ellrich (DEELR)"
  },
  {
   value: "Edesheim (DEEDE)",
   label: "Edesheim (DEEDE)"
  },
  {
   value: "Edingen (DEEDI)",
   label: "Edingen (DEEDI)"
  },
  {
   value: "Edling (DEEDL)",
   label: "Edling (DEEDL)"
  },
  {
   value: "Effelder (DEEFL)",
   label: "Effelder (DEEFL)"
  },
  {
   value: "Efringen-Kirchen (DEEFK)",
   label: "Efringen-Kirchen (DEEFK)"
  },
  {
   value: "Egenhausen (DEEHU)",
   label: "Egenhausen (DEEHU)"
  },
  {
   value: "Eggenthal (DEEGH)",
   label: "Eggenthal (DEEGH)"
  },
  {
   value: "Eggersdorf (DEEGF)",
   label: "Eggersdorf (DEEGF)"
  },
  {
   value: "Eggingen (DEEGE)",
   label: "Eggingen (DEEGE)"
  },
  {
   value: "Eggolsheim (DEEOM)",
   label: "Eggolsheim (DEEOM)"
  },
  {
   value: "Eggstätt (DEEGS)",
   label: "Eggstätt (DEEGS)"
  },
  {
   value: "Eggstedt (DEEGZ)",
   label: "Eggstedt (DEEGZ)"
  },
  {
   value: "Eglhausen (DEEGU)",
   label: "Eglhausen (DEEGU)"
  },
  {
   value: "Ehekirchen (DEZNE)",
   label: "Ehekirchen (DEZNE)"
  },
  {
   value: "Ehningen (DEEHG)",
   label: "Ehningen (DEEHG)"
  },
  {
   value: "Ehrenbreitstein (DEEBI)",
   label: "Ehrenbreitstein (DEEBI)"
  },
  {
   value: "Ehrenburg (DEZJD)",
   label: "Ehrenburg (DEZJD)"
  },
  {
   value: "Ehrenfriedersdorf (DEZEF)",
   label: "Ehrenfriedersdorf (DEZEF)"
  },
  {
   value: "Ehrenkirchen (DEEHK)",
   label: "Ehrenkirchen (DEEHK)"
  },
  {
   value: "Eibau (DEIBA)",
   label: "Eibau (DEIBA)"
  },
  {
   value: "Eibelstadt (DEEBT)",
   label: "Eibelstadt (DEEBT)"
  },
  {
   value: "Eibenstock (DEZEK)",
   label: "Eibenstock (DEZEK)"
  },
  {
   value: "Eich (DEECI)",
   label: "Eich (DEECI)"
  },
  {
   value: "Eichelhardt (DEEHT)",
   label: "Eichelhardt (DEEHT)"
  },
  {
   value: "Eichelsdorf (DEEEF)",
   label: "Eichelsdorf (DEEEF)"
  },
  {
   value: "Eichenau (DEEIU)",
   label: "Eichenau (DEEIU)"
  },
  {
   value: "Eichenzell (DEEHZ)",
   label: "Eichenzell (DEEHZ)"
  },
  {
   value: "Dürrweitzschen (Muldentalkreis) (DEDRR)",
   label: "Dürrweitzschen (Muldentalkreis) (DEDRR)"
  },
  {
   value: "Dusslingen (DEDUL)",
   label: "Dusslingen (DEDUL)"
  },
  {
   value: "Ebelsbach (DEZHE)",
   label: "Ebelsbach (DEZHE)"
  },
  {
   value: "Ebenhofen (DEEHN)",
   label: "Ebenhofen (DEEHN)"
  },
  {
   value: "Ebensfeld (DEEFD)",
   label: "Ebensfeld (DEEFD)"
  },
  {
   value: "Eberdingen (DEEBZ)",
   label: "Eberdingen (DEEBZ)"
  },
  {
   value: "Eberhardzell (DEZEB)",
   label: "Eberhardzell (DEZEB)"
  },
  {
   value: "Ebermannstadt (DEEBM)",
   label: "Ebermannstadt (DEEBM)"
  },
  {
   value: "Ebernhahn (DEEAH)",
   label: "Ebernhahn (DEEAH)"
  },
  {
   value: "Ebersberg (DEEEG)",
   label: "Ebersberg (DEEEG)"
  },
  {
   value: "Ebersburg (DEESZ)",
   label: "Ebersburg (DEESZ)"
  },
  {
   value: "Ebersdorf (DEEBO)",
   label: "Ebersdorf (DEEBO)"
  },
  {
   value: "Eberstadt (DEEER)",
   label: "Eberstadt (DEEER)"
  },
  {
   value: "Ebnath (DENAH)",
   label: "Ebnath (DENAH)"
  },
  {
   value: "Ebstorf (DEETO)",
   label: "Ebstorf (DEETO)"
  },
  {
   value: "Echem (DEECM)",
   label: "Echem (DEECM)"
  },
  {
   value: "Eching\/Landshut (DEEGC)",
   label: "Eching\/Landshut (DEEGC)"
  },
  {
   value: "Eckartshausen (DEECQ)",
   label: "Eckartshausen (DEECQ)"
  },
  {
   value: "Eckental (DEZEC)",
   label: "Eckental (DEZEC)"
  },
  {
   value: "Ecklak (DEELK)",
   label: "Ecklak (DEELK)"
  },
  {
   value: "Eckwarderhörne (DEEWH)",
   label: "Eckwarderhörne (DEEWH)"
  },
  {
   value: "Edemissen (DEEDM)",
   label: "Edemissen (DEEDM)"
  },
  {
   value: "Ederheim (DEEDH)",
   label: "Ederheim (DEEDH)"
  },
  {
   value: "Edermünde (DEUEU)",
   label: "Edermünde (DEUEU)"
  },
  {
   value: "Dötlingen (DEZDO)",
   label: "Dötlingen (DEZDO)"
  },
  {
   value: "Dotternhausen (DETNA)",
   label: "Dotternhausen (DETNA)"
  },
  {
   value: "Drackenstein (DEDKT)",
   label: "Drackenstein (DEDKT)"
  },
  {
   value: "Drage (DEDRG)",
   label: "Drage (DEDRG)"
  },
  {
   value: "Drebkau (DEBXD)",
   label: "Drebkau (DEBXD)"
  },
  {
   value: "Dreierwalde (DEDRW)",
   label: "Dreierwalde (DEDRW)"
  },
  {
   value: "Driedorf (DEDRF)",
   label: "Driedorf (DEDRF)"
  },
  {
   value: "Drochow (DEDCW)",
   label: "Drochow (DEDCW)"
  },
  {
   value: "Drossdorf (DEVVV)",
   label: "Drossdorf (DEVVV)"
  },
  {
   value: "Drübber (DEDRB)",
   label: "Drübber (DEDRB)"
  },
  {
   value: "Duben (DEDBN)",
   label: "Duben (DEDBN)"
  },
  {
   value: "Düdenbüttel (DEZDL)",
   label: "Düdenbüttel (DEZDL)"
  },
  {
   value: "Dudenhofen (DEDHF)",
   label: "Dudenhofen (DEDHF)"
  },
  {
   value: "Duingen (DENXN)",
   label: "Duingen (DENXN)"
  },
  {
   value: "Dunningen (DEUNG)",
   label: "Dunningen (DEUNG)"
  },
  {
   value: "Dürbheim (DEDBH)",
   label: "Dürbheim (DEDBH)"
  },
  {
   value: "Dürmentingen (DEDRN)",
   label: "Dürmentingen (DEDRN)"
  },
  {
   value: "Durmersheim (DEDUM)",
   label: "Durmersheim (DEDUM)"
  },
  {
   value: "Dürnau (DEDNA)",
   label: "Dürnau (DEDNA)"
  },
  {
   value: "Dürrholz (DEERR)",
   label: "Dürrholz (DEERR)"
  },
  {
   value: "Doberlug-Kirchhain (DEDOK)",
   label: "Doberlug-Kirchhain (DEDOK)"
  },
  {
   value: "Döbern (DEDBR)",
   label: "Döbern (DEDBR)"
  },
  {
   value: "Dockweiler (DEDWE)",
   label: "Dockweiler (DEDWE)"
  },
  {
   value: "Dodow (DEMDW)",
   label: "Dodow (DEMDW)"
  },
  {
   value: "Dogern (DEDOG)",
   label: "Dogern (DEDOG)"
  },
  {
   value: "Dohna (DEDHA)",
   label: "Dohna (DEDHA)"
  },
  {
   value: "Dölbau (DEDBU)",
   label: "Dölbau (DEDBU)"
  },
  {
   value: "Dombuehl (DEDOU)",
   label: "Dombuehl (DEDOU)"
  },
  {
   value: "Dömitz (DEDTZ)",
   label: "Dömitz (DEDTZ)"
  },
  {
   value: "Dommershausen (DEDMH)",
   label: "Dommershausen (DEDMH)"
  },
  {
   value: "Donaustauf (DEDOS)",
   label: "Donaustauf (DEDOS)"
  },
  {
   value: "Donautal (DEDNU)",
   label: "Donautal (DEDNU)"
  },
  {
   value: "Donnersdorf (DEZDU)",
   label: "Donnersdorf (DEZDU)"
  },
  {
   value: "Donzdorf (DEDZD)",
   label: "Donzdorf (DEDZD)"
  },
  {
   value: "Dorenthe (DEDNT)",
   label: "Dorenthe (DEDNT)"
  },
  {
   value: "Dörfles (DEDFS)",
   label: "Dörfles (DEDFS)"
  },
  {
   value: "Dörfles-Esbach (DEZAY)",
   label: "Dörfles-Esbach (DEZAY)"
  },
  {
   value: "Dorfprozelten (DEDPN)",
   label: "Dorfprozelten (DEDPN)"
  },
  {
   value: "Dörgenhausen (DEDOH)",
   label: "Dörgenhausen (DEDOH)"
  },
  {
   value: "Dormettingen (DEZND)",
   label: "Dormettingen (DEZND)"
  },
  {
   value: "Dornburg (DEDBG)",
   label: "Dornburg (DEDBG)"
  },
  {
   value: "Dornburg (DEDOR)",
   label: "Dornburg (DEDOR)"
  },
  {
   value: "Dorndorf (DEDNF)",
   label: "Dorndorf (DEDNF)"
  },
  {
   value: "Dornhan (DEDNW)",
   label: "Dornhan (DEDNW)"
  },
  {
   value: "Dornstadt (DEDST)",
   label: "Dornstadt (DEDST)"
  },
  {
   value: "Dörth (DEDRH)",
   label: "Dörth (DEDRH)"
  },
  {
   value: "Dörverden (DEDVE)",
   label: "Dörverden (DEDVE)"
  },
  {
   value: "Diedesheim\/Mosbach (DEMDD)",
   label: "Diedesheim\/Mosbach (DEMDD)"
  },
  {
   value: "Diedorf (DEFFF)",
   label: "Diedorf (DEFFF)"
  },
  {
   value: "Dielsdorf (DEDID)",
   label: "Dielsdorf (DEDID)"
  },
  {
   value: "Diemelstadt (DEDIM)",
   label: "Diemelstadt (DEDIM)"
  },
  {
   value: "Diepenau (DEDIU)",
   label: "Diepenau (DEDIU)"
  },
  {
   value: "Dierdorf (DEDIR)",
   label: "Dierdorf (DEDIR)"
  },
  {
   value: "Diesbar (DEDSB)",
   label: "Diesbar (DEDSB)"
  },
  {
   value: "Dietmannsried (DEDRI)",
   label: "Dietmannsried (DEDRI)"
  },
  {
   value: "Dill (DEDLL)",
   label: "Dill (DEDLL)"
  },
  {
   value: "Dillingen (DEDLG)",
   label: "Dillingen (DEDLG)"
  },
  {
   value: "Dillingen an der Donau (DEDLD)",
   label: "Dillingen an der Donau (DEDLD)"
  },
  {
   value: "Dingden (DEZDN)",
   label: "Dingden (DEZDN)"
  },
  {
   value: "Dingelstädt (DEDDT)",
   label: "Dingelstädt (DEDDT)"
  },
  {
   value: "Dinkelscherben (DEDSC)",
   label: "Dinkelscherben (DEDSC)"
  },
  {
   value: "Dinklage (DEDKG)",
   label: "Dinklage (DEDKG)"
  },
  {
   value: "Dirmstein (DEDXN)",
   label: "Dirmstein (DEDXN)"
  },
  {
   value: "Dischingen (DEDCG)",
   label: "Dischingen (DEDCG)"
  },
  {
   value: "Deidesheim (DEDDM)",
   label: "Deidesheim (DEDDM)"
  },
  {
   value: "Deining (DEDNE)",
   label: "Deining (DEDNE)"
  },
  {
   value: "Deisenhausen (DEDSE)",
   label: "Deisenhausen (DEDSE)"
  },
  {
   value: "Delitzsch (DEDLH)",
   label: "Delitzsch (DEDLH)"
  },
  {
   value: "Delligsen (DEDLN)",
   label: "Delligsen (DEDLN)"
  },
  {
   value: "Denkendorf (DEDKF)",
   label: "Denkendorf (DEDKF)"
  },
  {
   value: "Denkendorf (DEZDW)",
   label: "Denkendorf (DEZDW)"
  },
  {
   value: "Denklingen (DEDKE)",
   label: "Denklingen (DEDKE)"
  },
  {
   value: "Densborn (DEDNN)",
   label: "Densborn (DEDNN)"
  },
  {
   value: "Denzingen (DEDZG)",
   label: "Denzingen (DEDZG)"
  },
  {
   value: "Derching (DEDHG)",
   label: "Derching (DEDHG)"
  },
  {
   value: "Derenburg (DEDNR)",
   label: "Derenburg (DEDNR)"
  },
  {
   value: "Dernau (DEDEU)",
   label: "Dernau (DEDEU)"
  },
  {
   value: "Derschen (DERPD)",
   label: "Derschen (DERPD)"
  },
  {
   value: "Dersum (DEDSU)",
   label: "Dersum (DEDSU)"
  },
  {
   value: "Dettelbach (DEDTB)",
   label: "Dettelbach (DEDTB)"
  },
  {
   value: "Dettenhausen (DEDAE)",
   label: "Dettenhausen (DEDAE)"
  },
  {
   value: "Dettenheim (DEDNH)",
   label: "Dettenheim (DEDNH)"
  },
  {
   value: "Dettighofen (DEDFN)",
   label: "Dettighofen (DEDFN)"
  },
  {
   value: "Dettingen an der Iller (DEDTI)",
   label: "Dettingen an der Iller (DEDTI)"
  },
  {
   value: "Deuna (DEZDA)",
   label: "Deuna (DEZDA)"
  },
  {
   value: "Deutsch Evern (DEDCE)",
   label: "Deutsch Evern (DEDCE)"
  },
  {
   value: "Diebach (DEDBA)",
   label: "Diebach (DEDBA)"
  },
  {
   value: "Diedersdorf (DEDDO)",
   label: "Diedersdorf (DEDDO)"
  },
  {
   value: "Daaden (DEDAD)",
   label: "Daaden (DEDAD)"
  },
  {
   value: "Dabendorf (DEDEF)",
   label: "Dabendorf (DEDEF)"
  },
  {
   value: "Dachsbach (DEDSH)",
   label: "Dachsbach (DEDSH)"
  },
  {
   value: "Dackenheim (DEDPZ)",
   label: "Dackenheim (DEDPZ)"
  },
  {
   value: "Dageling (DEDGS)",
   label: "Dageling (DEDGS)"
  },
  {
   value: "Dahlem (DEDLM)",
   label: "Dahlem (DEDLM)"
  },
  {
   value: "Dahlenwarsleben (DEDWB)",
   label: "Dahlenwarsleben (DEDWB)"
  },
  {
   value: "Dahlewitz (DEDWZ)",
   label: "Dahlewitz (DEDWZ)"
  },
  {
   value: "Dahlwitz-Hoppegarten (DEDWH)",
   label: "Dahlwitz-Hoppegarten (DEDWH)"
  },
  {
   value: "Dahmen (DEZMD)",
   label: "Dahmen (DEZMD)"
  },
  {
   value: "Daleiden (DEDNL)",
   label: "Daleiden (DEDNL)"
  },
  {
   value: "Dallgow (DEDLW)",
   label: "Dallgow (DEDLW)"
  },
  {
   value: "Dampfach (DEDAF)",
   label: "Dampfach (DEDAF)"
  },
  {
   value: "Dannenfels (DEDFP)",
   label: "Dannenfels (DEDFP)"
  },
  {
   value: "Dannstadt-Schauernheim (DEDNS)",
   label: "Dannstadt-Schauernheim (DEDNS)"
  },
  {
   value: "Dargun (DEDGU)",
   label: "Dargun (DEDGU)"
  },
  {
   value: "Dassel (DEDSL)",
   label: "Dassel (DEDSL)"
  },
  {
   value: "Dassow (DEMVD)",
   label: "Dassow (DEMVD)"
  },
  {
   value: "Dauchingen (DEDUG)",
   label: "Dauchingen (DEDUG)"
  },
  {
   value: "Daun (DEDAU)",
   label: "Daun (DEDAU)"
  },
  {
   value: "Deckenpfronn (DEDPF)",
   label: "Deckenpfronn (DEDPF)"
  },
  {
   value: "Deggenau (DEDGA)",
   label: "Deggenau (DEDGA)"
  },
  {
   value: "Deggenhausertal (DEDBW)",
   label: "Deggenhausertal (DEDBW)"
  },
  {
   value: "Carlsberg (DEZCG)",
   label: "Carlsberg (DEZCG)"
  },
  {
   value: "Castell (DECYN)",
   label: "Castell (DECYN)"
  },
  {
   value: "Charlottenberg (DECTB)",
   label: "Charlottenberg (DECTB)"
  },
  {
   value: "Choren (DECRN)",
   label: "Choren (DECRN)"
  },
  {
   value: "Clarholz (DECHZ)",
   label: "Clarholz (DECHZ)"
  },
  {
   value: "Clausen (DEZCN)",
   label: "Clausen (DEZCN)"
  },
  {
   value: "Claussnitz (DECNZ)",
   label: "Claussnitz (DECNZ)"
  },
  {
   value: "Clausthal (DECUL)",
   label: "Clausthal (DECUL)"
  },
  {
   value: "Coerheide (DECOH)",
   label: "Coerheide (DECOH)"
  },
  {
   value: "Cölbe (DECBE)",
   label: "Cölbe (DECBE)"
  },
  {
   value: "Colmnitz (DECLM)",
   label: "Colmnitz (DECLM)"
  },
  {
   value: "Cologne = Köln (DE)",
   label: "Cologne = Köln (DE)"
  },
  {
   value: "Conow (DECON)",
   label: "Conow (DECON)"
  },
  {
   value: "Copitz (DECPZ)",
   label: "Copitz (DECPZ)"
  },
  {
   value: "Cossebaude (DECBD)",
   label: "Cossebaude (DECBD)"
  },
  {
   value: "Coswig (DECSW)",
   label: "Coswig (DECSW)"
  },
  {
   value: "Coswig (DECWG)",
   label: "Coswig (DECWG)"
  },
  {
   value: "Creussen (DECSN)",
   label: "Creussen (DECSN)"
  },
  {
   value: "Creuzburg (DECZU)",
   label: "Creuzburg (DECZU)"
  },
  {
   value: "Crimmitschau (DECMU)",
   label: "Crimmitschau (DECMU)"
  },
  {
   value: "Crock (DECRK)",
   label: "Crock (DECRK)"
  },
  {
   value: "Crossen (Zwickauer Land) (DECSS)",
   label: "Crossen (Zwickauer Land) (DECSS)"
  },
  {
   value: "Crossen an der Elster (DECRR)",
   label: "Crossen an der Elster (DECRR)"
  },
  {
   value: "Crottendorf (DECTF)",
   label: "Crottendorf (DECTF)"
  },
  {
   value: "Cunewalde (DECWE)",
   label: "Cunewalde (DECWE)"
  },
  {
   value: "Burgstadt (DEBZQ)",
   label: "Burgstadt (DEBZQ)"
  },
  {
   value: "Burgwald (DEBGW)",
   label: "Burgwald (DEBGW)"
  },
  {
   value: "Burgwindheim (DEBWH)",
   label: "Burgwindheim (DEBWH)"
  },
  {
   value: "Burladingen (DEURR)",
   label: "Burladingen (DEURR)"
  },
  {
   value: "Burrweiler (DEBPF)",
   label: "Burrweiler (DEBPF)"
  },
  {
   value: "Burscheid (DEBSD)",
   label: "Burscheid (DEBSD)"
  },
  {
   value: "Burtenbach (DEBTB)",
   label: "Burtenbach (DEBTB)"
  },
  {
   value: "Burweg (DEBWW)",
   label: "Burweg (DEBWW)"
  },
  {
   value: "Buschhausen (DEBCS)",
   label: "Buschhausen (DEBCS)"
  },
  {
   value: "Buseck (DEBSQ)",
   label: "Buseck (DEBSQ)"
  },
  {
   value: "Buttenheim (DEUTM)",
   label: "Buttenheim (DEUTM)"
  },
  {
   value: "Buttenwiesen (DEBNW)",
   label: "Buttenwiesen (DEBNW)"
  },
  {
   value: "Buttstadt (DEBUV)",
   label: "Buttstadt (DEBUV)"
  },
  {
   value: "Bützow (DEBZO)",
   label: "Bützow (DEBZO)"
  },
  {
   value: "Buxheim, Unterallgäu (DEBXE)",
   label: "Buxheim, Unterallgäu (DEBXE)"
  },
  {
   value: "Cable (DECLE)",
   label: "Cable (DECLE)"
  },
  {
   value: "Cadolzburg (DECAO)",
   label: "Cadolzburg (DECAO)"
  },
  {
   value: "Callbach (DELLB)",
   label: "Callbach (DELLB)"
  },
  {
   value: "Camburg (DECGS)",
   label: "Camburg (DECGS)"
  },
  {
   value: "Bückeburg (DEBCB)",
   label: "Bückeburg (DEBCB)"
  },
  {
   value: "Buckenhof (DEBCH)",
   label: "Buckenhof (DEBCH)"
  },
  {
   value: "Bücknitz (DEBCZ)",
   label: "Bücknitz (DEBCZ)"
  },
  {
   value: "Buckow (DEBUW)",
   label: "Buckow (DEBUW)"
  },
  {
   value: "Bückwitz (DEBKZ)",
   label: "Bückwitz (DEBKZ)"
  },
  {
   value: "Büdelsdorf (DEUSF)",
   label: "Büdelsdorf (DEUSF)"
  },
  {
   value: "Bühl (DEUHL)",
   label: "Bühl (DEUHL)"
  },
  {
   value: "Bühlertann (DEBTX)",
   label: "Bühlertann (DEBTX)"
  },
  {
   value: "Bühne (DEUHN)",
   label: "Bühne (DEUHN)"
  },
  {
   value: "Bullay (DELYY)",
   label: "Bullay (DELYY)"
  },
  {
   value: "Bülstringen (DEBYN)",
   label: "Bülstringen (DEBYN)"
  },
  {
   value: "Büren (DEBUQ)",
   label: "Büren (DEBUQ)"
  },
  {
   value: "Burg (DEBGX)",
   label: "Burg (DEBGX)"
  },
  {
   value: "Burgau (DEBGU)",
   label: "Burgau (DEBGU)"
  },
  {
   value: "Burgbernheim (DEUGE)",
   label: "Burgbernheim (DEUGE)"
  },
  {
   value: "Burgbrohl (DEBUI)",
   label: "Burgbrohl (DEBUI)"
  },
  {
   value: "Burghaslach (DEZBH)",
   label: "Burghaslach (DEZBH)"
  },
  {
   value: "Burghaun (DEBGY)",
   label: "Burghaun (DEBGY)"
  },
  {
   value: "Burgheim (DEUIM)",
   label: "Burgheim (DEUIM)"
  },
  {
   value: "Burgholz (DEUGZ)",
   label: "Burgholz (DEUGZ)"
  },
  {
   value: "Burglengenfeld (DEBLD)",
   label: "Burglengenfeld (DEBLD)"
  },
  {
   value: "Burgpreppach (DEBPE)",
   label: "Burgpreppach (DEBPE)"
  },
  {
   value: "Burgrieden (DEBUJ)",
   label: "Burgrieden (DEBUJ)"
  },
  {
   value: "Brodenbach (DEBDA)",
   label: "Brodenbach (DEBDA)"
  },
  {
   value: "Brodersby (DEBEY)",
   label: "Brodersby (DEBEY)"
  },
  {
   value: "Bromskirchen (DEBKC)",
   label: "Bromskirchen (DEBKC)"
  },
  {
   value: "Brotterode (DEBTR)",
   label: "Brotterode (DEBTR)"
  },
  {
   value: "Bruchhausen-Vilsen (DEBHV)",
   label: "Bruchhausen-Vilsen (DEBHV)"
  },
  {
   value: "Bruchköbel (DEBHK)",
   label: "Bruchköbel (DEBHK)"
  },
  {
   value: "Bruchweiler (DEBHW)",
   label: "Bruchweiler (DEBHW)"
  },
  {
   value: "Bruck (DERUC)",
   label: "Bruck (DERUC)"
  },
  {
   value: "Brück (DEBYK)",
   label: "Brück (DEBYK)"
  },
  {
   value: "Brück (DEKKD)",
   label: "Brück (DEKKD)"
  },
  {
   value: "Bruckberg (DEBKB)",
   label: "Bruckberg (DEBKB)"
  },
  {
   value: "Bruel (DEBLR)",
   label: "Bruel (DEBLR)"
  },
  {
   value: "Brüggen (DEBGQ)",
   label: "Brüggen (DEBGQ)"
  },
  {
   value: "Brünn (DEBXU)",
   label: "Brünn (DEBXU)"
  },
  {
   value: "Bubenreuth (DEBBJ)",
   label: "Bubenreuth (DEBBJ)"
  },
  {
   value: "Bubsheim (DEBSI)",
   label: "Bubsheim (DEBSI)"
  },
  {
   value: "Buch (DEHCU)",
   label: "Buch (DEHCU)"
  },
  {
   value: "Buch (DEUCH)",
   label: "Buch (DEUCH)"
  },
  {
   value: "Bucha (DEBKU)",
   label: "Bucha (DEBKU)"
  },
  {
   value: "Buchbach (DEBHB)",
   label: "Buchbach (DEBHB)"
  },
  {
   value: "Buchdorf (DEZBB)",
   label: "Buchdorf (DEZBB)"
  },
  {
   value: "Büchen (DEBCE)",
   label: "Büchen (DEBCE)"
  },
  {
   value: "Büchenbach (Roth) (DEZEJ)",
   label: "Büchenbach (Roth) (DEZEJ)"
  },
  {
   value: "Buchholz (DECUZ)",
   label: "Buchholz (DECUZ)"
  },
  {
   value: "Buchholz bei Niemegk (DEUHZ)",
   label: "Buchholz bei Niemegk (DEUHZ)"
  },
  {
   value: "Büchlberg (DEBHL)",
   label: "Büchlberg (DEBHL)"
  },
  {
   value: "Bredenbek (Rendsburg) (DESBK)",
   label: "Bredenbek (Rendsburg) (DESBK)"
  },
  {
   value: "Brehna (DEENA)",
   label: "Brehna (DEENA)"
  },
  {
   value: "Breidenbach (DEBBC)",
   label: "Breidenbach (DEBBC)"
  },
  {
   value: "Breitenau (DEBNU)",
   label: "Breitenau (DEBNU)"
  },
  {
   value: "Breitenburg (DEBTG)",
   label: "Breitenburg (DEBTG)"
  },
  {
   value: "Breitenfelde (DEBFX)",
   label: "Breitenfelde (DEBFX)"
  },
  {
   value: "Breitenheerda (DEBHX)",
   label: "Breitenheerda (DEBHX)"
  },
  {
   value: "Breitenworbis (DEBWO)",
   label: "Breitenworbis (DEBWO)"
  },
  {
   value: "Breitscheid (DEBTE)",
   label: "Breitscheid (DEBTE)"
  },
  {
   value: "Breitungen (DEBRX)",
   label: "Breitungen (DEBRX)"
  },
  {
   value: "Bremke (DEBMX)",
   label: "Bremke (DEBMX)"
  },
  {
   value: "Brensbach (DEBNF)",
   label: "Brensbach (DEBNF)"
  },
  {
   value: "Brenz (DERNZ)",
   label: "Brenz (DERNZ)"
  },
  {
   value: "Brest (DEBSY)",
   label: "Brest (DEBSY)"
  },
  {
   value: "Bresteland (DETLD)",
   label: "Bresteland (DETLD)"
  },
  {
   value: "Bretnig (DEBNG)",
   label: "Bretnig (DEBNG)"
  },
  {
   value: "Bretzfeld (DEBZF)",
   label: "Bretzfeld (DEBZF)"
  },
  {
   value: "Briest (DEIES)",
   label: "Briest (DEIES)"
  },
  {
   value: "Brietlingen (DETLG)",
   label: "Brietlingen (DETLG)"
  },
  {
   value: "Brink (DEBNK)",
   label: "Brink (DEBNK)"
  },
  {
   value: "Britz (DERIZ)",
   label: "Britz (DERIZ)"
  },
  {
   value: "Brockel (DEBYL)",
   label: "Brockel (DEBYL)"
  },
  {
   value: "Brockhagen (DEBCA)",
   label: "Brockhagen (DEBCA)"
  },
  {
   value: "Borstendorf (DEZBF)",
   label: "Borstendorf (DEZBF)"
  },
  {
   value: "Bortfeld (DEBTA)",
   label: "Bortfeld (DEBTA)"
  },
  {
   value: "Bortlingen (DEOLG)",
   label: "Bortlingen (DEOLG)"
  },
  {
   value: "Bösel (DEBOS)",
   label: "Bösel (DEBOS)"
  },
  {
   value: "Bous (DEBOU)",
   label: "Bous (DEBOU)"
  },
  {
   value: "Boxberg (DEBXB)",
   label: "Boxberg (DEBXB)"
  },
  {
   value: "Brachstedt (DEZTB)",
   label: "Brachstedt (DEZTB)"
  },
  {
   value: "Bracht (DEBRW)",
   label: "Bracht (DEBRW)"
  },
  {
   value: "Brachwitz (DEBCW)",
   label: "Brachwitz (DEBCW)"
  },
  {
   value: "Brackel (DEBAK)",
   label: "Brackel (DEBAK)"
  },
  {
   value: "Brackenheim (DEBCM)",
   label: "Brackenheim (DEBCM)"
  },
  {
   value: "Brackwede (DEBCV)",
   label: "Brackwede (DEBCV)"
  },
  {
   value: "Brahlstorf (DEBTF)",
   label: "Brahlstorf (DEBTF)"
  },
  {
   value: "Brakel (DEBKK)",
   label: "Brakel (DEBKK)"
  },
  {
   value: "Bralitz (DERLZ)",
   label: "Bralitz (DERLZ)"
  },
  {
   value: "Brandis (DEBDI)",
   label: "Brandis (DEBDI)"
  },
  {
   value: "Brattendorf (DEATO)",
   label: "Brattendorf (DEATO)"
  },
  {
   value: "Braubach (DEBHY)",
   label: "Braubach (DEBHY)"
  },
  {
   value: "Brauneberg (DEUBN)",
   label: "Brauneberg (DEUBN)"
  },
  {
   value: "Bräunlingen (DEBRY)",
   label: "Bräunlingen (DEBRY)"
  },
  {
   value: "Braunsbedra (DEBBD)",
   label: "Braunsbedra (DEBBD)"
  },
  {
   value: "Braunsdorf (DEBUO)",
   label: "Braunsdorf (DEBUO)"
  },
  {
   value: "Braunsdorf (DEUDF)",
   label: "Braunsdorf (DEUDF)"
  },
  {
   value: "Brechen (DEBCX)",
   label: "Brechen (DEBCX)"
  },
  {
   value: "Boffzen (DEBFF)",
   label: "Boffzen (DEBFF)"
  },
  {
   value: "Bogen (DEBOA)",
   label: "Bogen (DEBOA)"
  },
  {
   value: "Böhlen (DEBQL)",
   label: "Böhlen (DEBQL)"
  },
  {
   value: "Böhlitz-Ehrenberg (DEBHZ)",
   label: "Böhlitz-Ehrenberg (DEBHZ)"
  },
  {
   value: "Böhmenkirch (DEBMC)",
   label: "Böhmenkirch (DEBMC)"
  },
  {
   value: "Boitze (DEBZE)",
   label: "Boitze (DEBZE)"
  },
  {
   value: "Boizenburg (DEBOI)",
   label: "Boizenburg (DEBOI)"
  },
  {
   value: "Böklund (DEBVD)",
   label: "Böklund (DEBVD)"
  },
  {
   value: "Boll (DEOLL)",
   label: "Boll (DEOLL)"
  },
  {
   value: "Bollschweil (DEBLL)",
   label: "Bollschweil (DEBLL)"
  },
  {
   value: "Bomlitz (DEBMZ)",
   label: "Bomlitz (DEBMZ)"
  },
  {
   value: "Bonndorf im Schwarzwald (DEZBD)",
   label: "Bonndorf im Schwarzwald (DEZBD)"
  },
  {
   value: "Bönnigheim (DEOGM)",
   label: "Bönnigheim (DEOGM)"
  },
  {
   value: "Bönningstedt (DEBPS)",
   label: "Bönningstedt (DEBPS)"
  },
  {
   value: "Borchen (DERHC)",
   label: "Borchen (DERHC)"
  },
  {
   value: "Börgemoor (DEBMO)",
   label: "Börgemoor (DEBMO)"
  },
  {
   value: "Borgholzhausen (DEBHA)",
   label: "Borgholzhausen (DEBHA)"
  },
  {
   value: "Borgstedt (DEBYT)",
   label: "Borgstedt (DEBYT)"
  },
  {
   value: "Borken (DEBOJ)",
   label: "Borken (DEBOJ)"
  },
  {
   value: "Borkheide (DEBQE)",
   label: "Borkheide (DEBQE)"
  },
  {
   value: "Borna (DEBOX)",
   label: "Borna (DEBOX)"
  },
  {
   value: "Börnersdorf (DEBEO)",
   label: "Börnersdorf (DEBEO)"
  },
  {
   value: "Bornheim (DEBXH)",
   label: "Bornheim (DEBXH)"
  },
  {
   value: "Bornhöved (DEBNV)",
   label: "Bornhöved (DEBNV)"
  },
  {
   value: "Borschütz (DEBCT)",
   label: "Borschütz (DEBCT)"
  },
  {
   value: "Borsdorf (DEBFR)",
   label: "Borsdorf (DEBFR)"
  },
  {
   value: "Blankenheim (DECKH)",
   label: "Blankenheim (DECKH)"
  },
  {
   value: "Blankenheim (DEDSA)",
   label: "Blankenheim (DEDSA)"
  },
  {
   value: "Blankensee (DEAKN)",
   label: "Blankensee (DEAKN)"
  },
  {
   value: "Bleckede (DEBKD)",
   label: "Bleckede (DEBKD)"
  },
  {
   value: "Blender (DEBJR)",
   label: "Blender (DEBJR)"
  },
  {
   value: "Blossin (DEOIN)",
   label: "Blossin (DEOIN)"
  },
  {
   value: "Blumberg (DEBBM)",
   label: "Blumberg (DEBBM)"
  },
  {
   value: "Bobzin (DEBOZ)",
   label: "Bobzin (DEBOZ)"
  },
  {
   value: "Bockenau (DEXBN)",
   label: "Bockenau (DEXBN)"
  },
  {
   value: "Bockenem (DECKK)",
   label: "Bockenem (DECKK)"
  },
  {
   value: "Bockholdt (DEBCO)",
   label: "Bockholdt (DEBCO)"
  },
  {
   value: "Bockhorn (DEBCR)",
   label: "Bockhorn (DEBCR)"
  },
  {
   value: "Bockhorst (DEBKH)",
   label: "Bockhorst (DEBKH)"
  },
  {
   value: "Bockwen (DEBWN)",
   label: "Bockwen (DEBWN)"
  },
  {
   value: "Boden (DEBOQ)",
   label: "Boden (DEBOQ)"
  },
  {
   value: "Bodenheim (DEODM)",
   label: "Bodenheim (DEODM)"
  },
  {
   value: "Bodenkirchen (DEBVG)",
   label: "Bodenkirchen (DEBVG)"
  },
  {
   value: "Bodenmais (DEAIS)",
   label: "Bodenmais (DEAIS)"
  },
  {
   value: "Bodenteich (DEBTC)",
   label: "Bodenteich (DEBTC)"
  },
  {
   value: "Bodman (DEBLW)",
   label: "Bodman (DEBLW)"
  },
  {
   value: "Bodnegg (DEBDN)",
   label: "Bodnegg (DEBDN)"
  },
  {
   value: "Boehlen (DEQBN)",
   label: "Boehlen (DEQBN)"
  },
  {
   value: "Bietigheim (DEBEE)",
   label: "Bietigheim (DEBEE)"
  },
  {
   value: "Billigheim (DEBGI)",
   label: "Billigheim (DEBGI)"
  },
  {
   value: "Bilshausen (DEBHJ)",
   label: "Bilshausen (DEBHJ)"
  },
  {
   value: "Bindow (DEBIW)",
   label: "Bindow (DEBIW)"
  },
  {
   value: "Binsfeld bei Wittlich (DEBFW)",
   label: "Binsfeld bei Wittlich (DEBFW)"
  },
  {
   value: "Binswangen (DEISW)",
   label: "Binswangen (DEISW)"
  },
  {
   value: "Binz (DEBZR)",
   label: "Binz (DEBZR)"
  },
  {
   value: "Binzen (DEBIZ)",
   label: "Binzen (DEBIZ)"
  },
  {
   value: "Birach (DECHH)",
   label: "Birach (DECHH)"
  },
  {
   value: "Birenbach (DEBNC)",
   label: "Birenbach (DEBNC)"
  },
  {
   value: "Birkenau (DEBIA)",
   label: "Birkenau (DEBIA)"
  },
  {
   value: "Birken-Honigsessen (DEBHG)",
   label: "Birken-Honigsessen (DEBHG)"
  },
  {
   value: "Birkweiler (DEBWQ)",
   label: "Birkweiler (DEBWQ)"
  },
  {
   value: "Bischberg-Trosdorf (DEZFB)",
   label: "Bischberg-Trosdorf (DEZFB)"
  },
  {
   value: "Bischofsheim (DEBFS)",
   label: "Bischofsheim (DEBFS)"
  },
  {
   value: "Bischofswerda (DEBWD)",
   label: "Bischofswerda (DEBWD)"
  },
  {
   value: "Bisingen (DEBWK)",
   label: "Bisingen (DEBWK)"
  },
  {
   value: "Bispingen (DEBPN)",
   label: "Bispingen (DEBPN)"
  },
  {
   value: "Bissendorf (DENBS)",
   label: "Bissendorf (DENBS)"
  },
  {
   value: "Bissersheim (DESSH)",
   label: "Bissersheim (DESSH)"
  },
  {
   value: "Bissingen (DEBSX)",
   label: "Bissingen (DEBSX)"
  },
  {
   value: "Blankenburg (DEBKG)",
   label: "Blankenburg (DEBKG)"
  },
  {
   value: "Blankenfelde (DEAKF)",
   label: "Blankenfelde (DEAKF)"
  },
  {
   value: "Blankenhain (DEBLK)",
   label: "Blankenhain (DEBLK)"
  },
  {
   value: "Bernau (DERNA)",
   label: "Bernau (DERNA)"
  },
  {
   value: "Bernau (DERNR)",
   label: "Bernau (DERNR)"
  },
  {
   value: "Bernburg (DEBEQ)",
   label: "Bernburg (DEBEQ)"
  },
  {
   value: "Berne (DEBEA)",
   label: "Berne (DEBEA)"
  },
  {
   value: "Bernhardswald (DEBYY)",
   label: "Bernhardswald (DEBYY)"
  },
  {
   value: "Bernsdorf (DEBNS)",
   label: "Bernsdorf (DEBNS)"
  },
  {
   value: "Berod bei Wallmerod (DEBWM)",
   label: "Berod bei Wallmerod (DEBWM)"
  },
  {
   value: "Berssel (DEZBL)",
   label: "Berssel (DEZBL)"
  },
  {
   value: "Bertingen (DEBTI)",
   label: "Bertingen (DEBTI)"
  },
  {
   value: "Betzendorf (DEBZD)",
   label: "Betzendorf (DEBZD)"
  },
  {
   value: "Betzigau (DEEZI)",
   label: "Betzigau (DEEZI)"
  },
  {
   value: "Betzweiler (DEBZW)",
   label: "Betzweiler (DEBZW)"
  },
  {
   value: "Beuren (DERUX)",
   label: "Beuren (DERUX)"
  },
  {
   value: "Bevern (DEBVN)",
   label: "Bevern (DEBVN)"
  },
  {
   value: "Bickenbach (DEBCC)",
   label: "Bickenbach (DEBCC)"
  },
  {
   value: "Bidingen (DEIDG)",
   label: "Bidingen (DEIDG)"
  },
  {
   value: "Biebelnheim (DEBPZ)",
   label: "Biebelnheim (DEBPZ)"
  },
  {
   value: "Biebergemünd (DEBIG)",
   label: "Biebergemünd (DEBIG)"
  },
  {
   value: "Biene (DEIEN)",
   label: "Biene (DEIEN)"
  },
  {
   value: "Biere (DEERX)",
   label: "Biere (DEERX)"
  },
  {
   value: "Biesenthal (DEGZA)",
   label: "Biesenthal (DEGZA)"
  },
  {
   value: "Benz (DEENZ)",
   label: "Benz (DEENZ)"
  },
  {
   value: "Berching (DEBCG)",
   label: "Berching (DEBCG)"
  },
  {
   value: "Berenbusch (DEBBS)",
   label: "Berenbusch (DEBBS)"
  },
  {
   value: "Berg (Gemersheim) (DEBGP)",
   label: "Berg (Gemersheim) (DEBGP)"
  },
  {
   value: "Berg (Ravensburg) (DEBKV)",
   label: "Berg (Ravensburg) (DEBKV)"
  },
  {
   value: "Berg (Traunstein) (DEBGS)",
   label: "Berg (Traunstein) (DEBGS)"
  },
  {
   value: "Berg bei Neumarkt in der Oberpfalz (DEBNO)",
   label: "Berg bei Neumarkt in der Oberpfalz (DEBNO)"
  },
  {
   value: "Berge (DEBGZ)",
   label: "Berge (DEBGZ)"
  },
  {
   value: "Bergen (DEBYR)",
   label: "Bergen (DEBYR)"
  },
  {
   value: "Bergen auf Rügen (DEUEG)",
   label: "Bergen auf Rügen (DEUEG)"
  },
  {
   value: "Berggiesshübel (DEHUB)",
   label: "Berggiesshübel (DEHUB)"
  },
  {
   value: "Berghaupten (DEBHP)",
   label: "Berghaupten (DEBHP)"
  },
  {
   value: "Berghülen (DEBEJ)",
   label: "Berghülen (DEBEJ)"
  },
  {
   value: "Bergkirchen (DEBGC)",
   label: "Bergkirchen (DEBGC)"
  },
  {
   value: "Bergrheinfeld (DEZAA)",
   label: "Bergrheinfeld (DEZAA)"
  },
  {
   value: "Berka\/Werra (DEBEW)",
   label: "Berka\/Werra (DEBEW)"
  },
  {
   value: "Berlinchen (DEBLC)",
   label: "Berlinchen (DEBLC)"
  },
  {
   value: "Berlingerode (DEBGV)",
   label: "Berlingerode (DEBGV)"
  },
  {
   value: "Bermatingen (DEBMN)",
   label: "Bermatingen (DEBMN)"
  },
  {
   value: "Bermersheim vor der Höhe (DEBVH)",
   label: "Bermersheim vor der Höhe (DEBVH)"
  },
  {
   value: "Bebertal (DEBLX)",
   label: "Bebertal (DEBLX)"
  },
  {
   value: "Bechhofen (DEQBE)",
   label: "Bechhofen (DEQBE)"
  },
  {
   value: "Bechtheim (DEBTM)",
   label: "Bechtheim (DEBTM)"
  },
  {
   value: "Bechtolsheim (DETLS)",
   label: "Bechtolsheim (DETLS)"
  },
  {
   value: "Beckedorf (DEBDO)",
   label: "Beckedorf (DEBDO)"
  },
  {
   value: "Beckeln (DEQBC)",
   label: "Beckeln (DEQBC)"
  },
  {
   value: "Beckhausen (DEBKS)",
   label: "Beckhausen (DEBKS)"
  },
  {
   value: "Beckingen (DEEKG)",
   label: "Beckingen (DEEKG)"
  },
  {
   value: "Bedburg (DEEFT)",
   label: "Bedburg (DEEFT)"
  },
  {
   value: "Beelen (DEEEL)",
   label: "Beelen (DEEEL)"
  },
  {
   value: "Beelitz (DEBLI)",
   label: "Beelitz (DEBLI)"
  },
  {
   value: "Beerfelden (DENRE)",
   label: "Beerfelden (DENRE)"
  },
  {
   value: "Beeskow (DEBKW)",
   label: "Beeskow (DEBKW)"
  },
  {
   value: "Behringen (DERGE)",
   label: "Behringen (DERGE)"
  },
  {
   value: "Beihingen (DEIGN)",
   label: "Beihingen (DEIGN)"
  },
  {
   value: "Beilngries (DEBGR)",
   label: "Beilngries (DEBGR)"
  },
  {
   value: "Beindersheim (DEBDM)",
   label: "Beindersheim (DEBDM)"
  },
  {
   value: "Belgern (DEELG)",
   label: "Belgern (DEELG)"
  },
  {
   value: "Belgershain (DEBQN)",
   label: "Belgershain (DEBQN)"
  },
  {
   value: "Bell (DEZAO)",
   label: "Bell (DEZAO)"
  },
  {
   value: "Belm (DEBXL)",
   label: "Belm (DEBXL)"
  },
  {
   value: "Beltershausen (DEBTS)",
   label: "Beltershausen (DEBTS)"
  },
  {
   value: "Belzig (DEBZG)",
   label: "Belzig (DEBZG)"
  },
  {
   value: "Benningen Am Neckar (DEBGK)",
   label: "Benningen Am Neckar (DEBGK)"
  },
  {
   value: "Bentwisch (DEBTW)",
   label: "Bentwisch (DEBTW)"
  },
  {
   value: "Baltringen (DEQBL)",
   label: "Baltringen (DEQBL)"
  },
  {
   value: "Balve (DEBAV)",
   label: "Balve (DEBAV)"
  },
  {
   value: "Bannewitz (DEBAZ)",
   label: "Bannewitz (DEBAZ)"
  },
  {
   value: "Banteln (DEBNZ)",
   label: "Banteln (DEBNZ)"
  },
  {
   value: "Barbing (DEGBX)",
   label: "Barbing (DEGBX)"
  },
  {
   value: "Barchfeld (DEBCF)",
   label: "Barchfeld (DEBCF)"
  },
  {
   value: "Bardowick (DEBWC)",
   label: "Bardowick (DEBWC)"
  },
  {
   value: "Barendorf (DEARD)",
   label: "Barendorf (DEARD)"
  },
  {
   value: "Barenstein (DEANT)",
   label: "Barenstein (DEANT)"
  },
  {
   value: "Bärenstein (DEBAQ)",
   label: "Bärenstein (DEBAQ)"
  },
  {
   value: "Barleben (DEBAE)",
   label: "Barleben (DEBAE)"
  },
  {
   value: "Barnau (DEUAB)",
   label: "Barnau (DEUAB)"
  },
  {
   value: "Barnstädt (DEBTT)",
   label: "Barnstädt (DEBTT)"
  },
  {
   value: "Barnstedt (DEATD)",
   label: "Barnstedt (DEATD)"
  },
  {
   value: "Barum (DEARM)",
   label: "Barum (DEARM)"
  },
  {
   value: "Baruth (DEBXR)",
   label: "Baruth (DEBXR)"
  },
  {
   value: "Basel (DEBZL)",
   label: "Basel (DEBZL)"
  },
  {
   value: "Battenberg (DEZBG)",
   label: "Battenberg (DEZBG)"
  },
  {
   value: "Baumbach (DEBMB)",
   label: "Baumbach (DEBMB)"
  },
  {
   value: "Bayerbach (DEBAY)",
   label: "Bayerbach (DEBAY)"
  },
  {
   value: "Bad Teinach-Zavelstein (DEBTV)",
   label: "Bad Teinach-Zavelstein (DEBTV)"
  },
  {
   value: "Bad Überkingen (DEBUK)",
   label: "Bad Überkingen (DEBUK)"
  },
  {
   value: "Bad Urach (DEURH)",
   label: "Bad Urach (DEURH)"
  },
  {
   value: "Bad Waldsee (DEBWS)",
   label: "Bad Waldsee (DEBWS)"
  },
  {
   value: "Bad Wildbad (DEBWB)",
   label: "Bad Wildbad (DEBWB)"
  },
  {
   value: "Bad Wörishofen (DEBAW)",
   label: "Bad Wörishofen (DEBAW)"
  },
  {
   value: "Bad Wünnenberg (DEWUX)",
   label: "Bad Wünnenberg (DEWUX)"
  },
  {
   value: "Bad Wurzach (DEBWZ)",
   label: "Bad Wurzach (DEBWZ)"
  },
  {
   value: "Badbergen (DEBZZ)",
   label: "Badbergen (DEBZZ)"
  },
  {
   value: "Badem (DEDMM)",
   label: "Badem (DEDMM)"
  },
  {
   value: "Badenhausen (DEBNH)",
   label: "Badenhausen (DEBNH)"
  },
  {
   value: "Badersleben (DEDLE)",
   label: "Badersleben (DEDLE)"
  },
  {
   value: "Baechingen (DEZNB)",
   label: "Baechingen (DEZNB)"
  },
  {
   value: "Baesweiler (DEBSW)",
   label: "Baesweiler (DEBSW)"
  },
  {
   value: "Bahlingen (DEBEZ)",
   label: "Bahlingen (DEBEZ)"
  },
  {
   value: "Bahlingen Am Kaiserstuhl (DEBAO)",
   label: "Bahlingen Am Kaiserstuhl (DEBAO)"
  },
  {
   value: "Bahrenfeld (DEBHQ)",
   label: "Bahrenfeld (DEBHQ)"
  },
  {
   value: "Baiersbronn (DEBRR)",
   label: "Baiersbronn (DEBRR)"
  },
  {
   value: "Baiersdorf (DEBIO)",
   label: "Baiersdorf (DEBIO)"
  },
  {
   value: "Bakum (DEBKX)",
   label: "Bakum (DEBKX)"
  },
  {
   value: "Baldham (DEADM)",
   label: "Baldham (DEADM)"
  },
  {
   value: "Baltmannsweiler (DEBQR)",
   label: "Baltmannsweiler (DEBQR)"
  },
  {
   value: "Bad Liebenzel (DELBZ)",
   label: "Bad Liebenzel (DELBZ)"
  },
  {
   value: "Bad Lippspringe (DERWB)",
   label: "Bad Lippspringe (DERWB)"
  },
  {
   value: "Bad Marienberg (DEBMA)",
   label: "Bad Marienberg (DEBMA)"
  },
  {
   value: "Bad Munster am Stein Ebernburg (DEBMS)",
   label: "Bad Munster am Stein Ebernburg (DEBMS)"
  },
  {
   value: "Bad Rappenau (DEBPP)",
   label: "Bad Rappenau (DEBPP)"
  },
  {
   value: "Bad Rippoldsau-Schapbach (DEBRP)",
   label: "Bad Rippoldsau-Schapbach (DEBRP)"
  },
  {
   value: "Bad Saarow (DEZBW)",
   label: "Bad Saarow (DEZBW)"
  },
  {
   value: "Bad Salzungen (DEBSZ)",
   label: "Bad Salzungen (DEBSZ)"
  },
  {
   value: "Bad Saulgau (DEBSG)",
   label: "Bad Saulgau (DEBSG)"
  },
  {
   value: "Bad Schmiedeberg (DEBMD)",
   label: "Bad Schmiedeberg (DEBMD)"
  },
  {
   value: "Bad Schussenried (DEBSR)",
   label: "Bad Schussenried (DEBSR)"
  },
  {
   value: "Bad Schwalbach (DESHW)",
   label: "Bad Schwalbach (DESHW)"
  },
  {
   value: "Bad Schwartau (DEBSU)",
   label: "Bad Schwartau (DEBSU)"
  },
  {
   value: "Bad Sobernheim (DEZFL)",
   label: "Bad Sobernheim (DEZFL)"
  },
  {
   value: "Bad Ditzenbach (DEBDZ)",
   label: "Bad Ditzenbach (DEBDZ)"
  },
  {
   value: "Bad Dürrenberg (DEUBG)",
   label: "Bad Dürrenberg (DEUBG)"
  },
  {
   value: "Bad Durrheim (DERHX)",
   label: "Bad Durrheim (DERHX)"
  },
  {
   value: "Bad Elster (DEBDE)",
   label: "Bad Elster (DEBDE)"
  },
  {
   value: "Bad Endorf (DEADD)",
   label: "Bad Endorf (DEADD)"
  },
  {
   value: "Bad Fallingbostel (DEFGL)",
   label: "Bad Fallingbostel (DEFGL)"
  },
  {
   value: "Bad Füssing (DEFUU)",
   label: "Bad Füssing (DEFUU)"
  },
  {
   value: "Bad Iburg (DEBAJ)",
   label: "Bad Iburg (DEBAJ)"
  },
  {
   value: "Bad Karlshafen (DEBKA)",
   label: "Bad Karlshafen (DEBKA)"
  },
  {
   value: "Bad König (DEADK)",
   label: "Bad König (DEADK)"
  },
  {
   value: "Bad Königshofen (DEBKO)",
   label: "Bad Königshofen (DEBKO)"
  },
  {
   value: "Bad Köstritz (DEKZZ)",
   label: "Bad Köstritz (DEKZZ)"
  },
  {
   value: "Bad Kotzting (DEBYB)",
   label: "Bad Kotzting (DEBYB)"
  },
  {
   value: "Bad Langensalza (DEBLZ)",
   label: "Bad Langensalza (DEBLZ)"
  },
  {
   value: "Bad Liebenstein (DEBBT)",
   label: "Bad Liebenstein (DEBBT)"
  },
  {
   value: "Bad Liebenwerda (DEBQB)",
   label: "Bad Liebenwerda (DEBQB)"
  },
  {
   value: "Aufsess (DEAUF)",
   label: "Aufsess (DEAUF)"
  },
  {
   value: "Aukrug (DESQA)",
   label: "Aukrug (DESQA)"
  },
  {
   value: "Auma (DEAMA)",
   label: "Auma (DEAMA)"
  },
  {
   value: "Aurach (DEAUA)",
   label: "Aurach (DEAUA)"
  },
  {
   value: "Aussernzell (DEAUS)",
   label: "Aussernzell (DEAUS)"
  },
  {
   value: "Aying (DEAYI)",
   label: "Aying (DEAYI)"
  },
  {
   value: "Ayl (DEAYL)",
   label: "Ayl (DEAYL)"
  },
  {
   value: "Baalsdorf (DEBAA)",
   label: "Baalsdorf (DEBAA)"
  },
  {
   value: "Baar-Ebenhausen (DERBS)",
   label: "Baar-Ebenhausen (DERBS)"
  },
  {
   value: "Babelsberg (DEAEB)",
   label: "Babelsberg (DEAEB)"
  },
  {
   value: "Babelsberg (DEASR)",
   label: "Babelsberg (DEASR)"
  },
  {
   value: "Bacharach (DEDCH)",
   label: "Bacharach (DEDCH)"
  },
  {
   value: "Bachhagel (DEBAG)",
   label: "Bachhagel (DEBAG)"
  },
  {
   value: "Bad Bellingen (DEBBB)",
   label: "Bad Bellingen (DEBBB)"
  },
  {
   value: "Bad Berka (DEBBX)",
   label: "Bad Berka (DEBBX)"
  },
  {
   value: "Bad Berneck (DEZBK)",
   label: "Bad Berneck (DEZBK)"
  },
  {
   value: "Bad Blankenburg (DEBBA)",
   label: "Bad Blankenburg (DEBBA)"
  },
  {
   value: "Bad Boll (DEBBO)",
   label: "Bad Boll (DEBBO)"
  },
  {
   value: "Bad Bramstedt (DEQBR)",
   label: "Bad Bramstedt (DEQBR)"
  },
  {
   value: "Bad Breisig (DEISI)",
   label: "Bad Breisig (DEISI)"
  },
  {
   value: "Arendsee (DEASE)",
   label: "Arendsee (DEASE)"
  },
  {
   value: "Arensdorf (DEANO)",
   label: "Arensdorf (DEANO)"
  },
  {
   value: "Arenshausen (DEZAS)",
   label: "Arenshausen (DEZAS)"
  },
  {
   value: "Aresing (DEARI)",
   label: "Aresing (DEARI)"
  },
  {
   value: "Argenbühl (DEAQL)",
   label: "Argenbühl (DEAQL)"
  },
  {
   value: "Arnbruck (DEARU)",
   label: "Arnbruck (DEARU)"
  },
  {
   value: "Arneburg (DEARA)",
   label: "Arneburg (DEARA)"
  },
  {
   value: "Arnstadt (DEARS)",
   label: "Arnstadt (DEARS)"
  },
  {
   value: "Arnstein (DEIET)",
   label: "Arnstein (DEIET)"
  },
  {
   value: "Arnstorf (DEAOR)",
   label: "Arnstorf (DEAOR)"
  },
  {
   value: "Artern (DEARE)",
   label: "Artern (DEARE)"
  },
  {
   value: "Arzberg (DEBQA)",
   label: "Arzberg (DEBQA)"
  },
  {
   value: "Asbach-Bäumenheim (DEABM)",
   label: "Asbach-Bäumenheim (DEABM)"
  },
  {
   value: "Asch (DEASF)",
   label: "Asch (DEASF)"
  },
  {
   value: "Aschara (DEAQA)",
   label: "Aschara (DEAQA)"
  },
  {
   value: "Ascheberg (Holstein) (DEAEH)",
   label: "Ascheberg (Holstein) (DEAEH)"
  },
  {
   value: "Aschheim (DEAHM)",
   label: "Aschheim (DEAHM)"
  },
  {
   value: "Asperg (DEAPG)",
   label: "Asperg (DEAPG)"
  },
  {
   value: "Aspisheim (DEQHA)",
   label: "Aspisheim (DEQHA)"
  },
  {
   value: "Assamstadt (DEASA)",
   label: "Assamstadt (DEASA)"
  },
  {
   value: "Attenkirchen (DEAKC)",
   label: "Attenkirchen (DEAKC)"
  },
  {
   value: "Au in der Hallertau (DEHAZ)",
   label: "Au in der Hallertau (DEHAZ)"
  },
  {
   value: "Aue (DEAUU)",
   label: "Aue (DEAUU)"
  },
  {
   value: "Auenwald (DEUAD)",
   label: "Auenwald (DEUAD)"
  },
  {
   value: "Auerbach (DEAUB)",
   label: "Auerbach (DEAUB)"
  },
  {
   value: "Alveslohe (DEAVL)",
   label: "Alveslohe (DEAVL)"
  },
  {
   value: "Am Hund (DEAHU)",
   label: "Am Hund (DEAHU)"
  },
  {
   value: "Amberg (Unterallgau) (DEAMG)",
   label: "Amberg (Unterallgau) (DEAMG)"
  },
  {
   value: "Amelinghausen (DEAGH)",
   label: "Amelinghausen (DEAGH)"
  },
  {
   value: "Ameln (DEAME)",
   label: "Ameln (DEAME)"
  },
  {
   value: "Amelsbüren (DEAML)",
   label: "Amelsbüren (DEAML)"
  },
  {
   value: "Amerang (DEAMZ)",
   label: "Amerang (DEAMZ)"
  },
  {
   value: "Ammerland (DEARL)",
   label: "Ammerland (DEARL)"
  },
  {
   value: "Ammern (DEXRN)",
   label: "Ammern (DEXRN)"
  },
  {
   value: "Ammersbek (DEAMS)",
   label: "Ammersbek (DEAMS)"
  },
  {
   value: "Ampfing (DEAPF)",
   label: "Ampfing (DEAPF)"
  },
  {
   value: "Amsdorf (DEAMF)",
   label: "Amsdorf (DEAMF)"
  },
  {
   value: "Amtzell (DEATZ)",
   label: "Amtzell (DEATZ)"
  },
  {
   value: "Andechs (DEADS)",
   label: "Andechs (DEADS)"
  },
  {
   value: "Angelburg (DEAGL)",
   label: "Angelburg (DEAGL)"
  },
  {
   value: "Angermünde (DEAMU)",
   label: "Angermünde (DEAMU)"
  },
  {
   value: "Angersbach (DEANC)",
   label: "Angersbach (DEANC)"
  },
  {
   value: "Ankum (DEANU)",
   label: "Ankum (DEANU)"
  },
  {
   value: "Annaberg-Buchholz (DEANB)",
   label: "Annaberg-Buchholz (DEANB)"
  },
  {
   value: "Anzing (DEANZ)",
   label: "Anzing (DEANZ)"
  },
  {
   value: "Apenburg (DEAPB)",
   label: "Apenburg (DEAPB)"
  },
  {
   value: "Apensen (DEAPN)",
   label: "Apensen (DEAPN)"
  },
  {
   value: "Apfelstadt (DEAPT)",
   label: "Apfelstadt (DEAPT)"
  },
  {
   value: "Appen (DEAEN)",
   label: "Appen (DEAEN)"
  },
  {
   value: "Altenau (DEALU)",
   label: "Altenau (DEALU)"
  },
  {
   value: "Altenbeken (DEABN)",
   label: "Altenbeken (DEABN)"
  },
  {
   value: "Altenberg (DEATR)",
   label: "Altenberg (DEATR)"
  },
  {
   value: "Altenberge (DEATB)",
   label: "Altenberge (DEATB)"
  },
  {
   value: "Altenburg (DEALC)",
   label: "Altenburg (DEALC)"
  },
  {
   value: "Altendorf (DEDLF)",
   label: "Altendorf (DEDLF)"
  },
  {
   value: "Altenfeld (DEAQD)",
   label: "Altenfeld (DEAQD)"
  },
  {
   value: "Altenhain (DEATH)",
   label: "Altenhain (DEATH)"
  },
  {
   value: "Altenholz (DEAOZ)",
   label: "Altenholz (DEAOZ)"
  },
  {
   value: "Altenkrempe (DEATE)",
   label: "Altenkrempe (DEATE)"
  },
  {
   value: "Altenkunstadt (DEAKT)",
   label: "Altenkunstadt (DEAKT)"
  },
  {
   value: "Altenlingen (DEATL)",
   label: "Altenlingen (DEATL)"
  },
  {
   value: "Altenmuster (DEAMX)",
   label: "Altenmuster (DEAMX)"
  },
  {
   value: "Altenoythe (DEAYH)",
   label: "Altenoythe (DEAYH)"
  },
  {
   value: "Altenstadt (DEAQT)",
   label: "Altenstadt (DEAQT)"
  },
  {
   value: "Altenstadt (DEATT)",
   label: "Altenstadt (DEATT)"
  },
  {
   value: "Altentreptow (DEAQW)",
   label: "Altentreptow (DEAQW)"
  },
  {
   value: "Altenwerder (DEHHV)",
   label: "Altenwerder (DEHHV)"
  },
  {
   value: "Altfeld (DEAFD)",
   label: "Altfeld (DEAFD)"
  },
  {
   value: "Altfriedland (DEAFL)",
   label: "Altfriedland (DEAFL)"
  },
  {
   value: "Althegnenberg (DEAHB)",
   label: "Althegnenberg (DEAHB)"
  },
  {
   value: "Altheim (DEAHE)",
   label: "Altheim (DEAHE)"
  },
  {
   value: "Althengstett (DEAET)",
   label: "Althengstett (DEAET)"
  },
  {
   value: "Althuette (DEAQE)",
   label: "Althuette (DEAQE)"
  },
  {
   value: "Altlandsberg (DEADR)",
   label: "Altlandsberg (DEADR)"
  },
  {
   value: "Altleiningen (DEATG)",
   label: "Altleiningen (DEATG)"
  },
  {
   value: "Altlussheim (DEALM)",
   label: "Altlussheim (DEALM)"
  },
  {
   value: "Altmoorhausen (DEAMH)",
   label: "Altmoorhausen (DEAMH)"
  },
  {
   value: "Altomünster (DEAMN)",
   label: "Altomünster (DEAMN)"
  },
  {
   value: "Altshausen (DEATS)",
   label: "Altshausen (DEATS)"
  },
  {
   value: "Aislingen (DEALI)",
   label: "Aislingen (DEALI)"
  },
  {
   value: "Aitrach (DEAIT)",
   label: "Aitrach (DEAIT)"
  },
  {
   value: "Aitrang (DEAAG)",
   label: "Aitrang (DEAAG)"
  },
  {
   value: "Aken (DEAKE)",
   label: "Aken (DEAKE)"
  },
  {
   value: "Albershausen (DEALE)",
   label: "Albershausen (DEALE)"
  },
  {
   value: "Albertshofen (DETSH)",
   label: "Albertshofen (DETSH)"
  },
  {
   value: "Albig (DEAIG)",
   label: "Albig (DEAIG)"
  },
  {
   value: "Aldenhoven (DEANW)",
   label: "Aldenhoven (DEANW)"
  },
  {
   value: "Aldingen (DEALN)",
   label: "Aldingen (DEALN)"
  },
  {
   value: "Alf (DEAQF)",
   label: "Alf (DEAQF)"
  },
  {
   value: "Alfdorf (DEARF)",
   label: "Alfdorf (DEARF)"
  },
  {
   value: "Algermissen (DEAGM)",
   label: "Algermissen (DEAGM)"
  },
  {
   value: "Alheim (DEAIM)",
   label: "Alheim (DEAIM)"
  },
  {
   value: "Allendorf (DEADO)",
   label: "Allendorf (DEADO)"
  },
  {
   value: "Almersbach (DEZRA)",
   label: "Almersbach (DEZRA)"
  },
  {
   value: "Alpen (DEALP)",
   label: "Alpen (DEALP)"
  },
  {
   value: "Alpirsbach (DEASB)",
   label: "Alpirsbach (DEASB)"
  },
  {
   value: "Alsdorf, Altenkirchen (DEALO)",
   label: "Alsdorf, Altenkirchen (DEALO)"
  },
  {
   value: "Alsdorf, Bitburg (DEASO)",
   label: "Alsdorf, Bitburg (DEASO)"
  },
  {
   value: "Alsheim (DEASI)",
   label: "Alsheim (DEASI)"
  },
  {
   value: "Alt Bork (DEABO)",
   label: "Alt Bork (DEABO)"
  },
  {
   value: "Altdorf (DEABU)",
   label: "Altdorf (DEABU)"
  },
  {
   value: "Altdorf (DEAKB)",
   label: "Altdorf (DEAKB)"
  },
  {
   value: "Altdorf (DEATF)",
   label: "Altdorf (DEATF)"
  },
  {
   value: "Altdorf (DEATP)",
   label: "Altdorf (DEATP)"
  },
  {
   value: "Achenbach (DEACB)",
   label: "Achenbach (DEACB)"
  },
  {
   value: "Achstetten (DEACT)",
   label: "Achstetten (DEACT)"
  },
  {
   value: "Addrup (DEAHS)",
   label: "Addrup (DEAHS)"
  },
  {
   value: "Adelberg-Dorf (DEADB)",
   label: "Adelberg-Dorf (DEADB)"
  },
  {
   value: "Adelebsen (DEADE)",
   label: "Adelebsen (DEADE)"
  },
  {
   value: "Adelheidsdorf (DEAHF)",
   label: "Adelheidsdorf (DEAHF)"
  },
  {
   value: "Adelschlag (DEADL)",
   label: "Adelschlag (DEADL)"
  },
  {
   value: "Adelsdorf (DEADN)",
   label: "Adelsdorf (DEADN)"
  },
  {
   value: "Adelsheim (DEADH)",
   label: "Adelsheim (DEADH)"
  },
  {
   value: "Adelsried (DEAEE)",
   label: "Adelsried (DEAEE)"
  },
  {
   value: "Adendorf (DEANF)",
   label: "Adendorf (DEANF)"
  },
  {
   value: "Adorf (DEAOD)",
   label: "Adorf (DEAOD)"
  },
  {
   value: "Affalterbach (DEAFB)",
   label: "Affalterbach (DEAFB)"
  },
  {
   value: "Affalterbach (DEAFF)",
   label: "Affalterbach (DEAFF)"
  },
  {
   value: "Affing (DEAQG)",
   label: "Affing (DEAQG)"
  },
  {
   value: "Ahlden (DEADZ)",
   label: "Ahlden (DEADZ)"
  },
  {
   value: "Ahlefeld-Bistensee (DEAQH)",
   label: "Ahlefeld-Bistensee (DEAQH)"
  },
  {
   value: "Ahlhorn (DEAHO)",
   label: "Ahlhorn (DEAHO)"
  },
  {
   value: "Ahrensfelde (DEAFE)",
   label: "Ahrensfelde (DEAFE)"
  },
  {
   value: "Aicha vorm Wald (DEAVW)",
   label: "Aicha vorm Wald (DEAVW)"
  },
  {
   value: "Aichelberg (DEABG)",
   label: "Aichelberg (DEABG)"
  },
  {
   value: "Aichhalden (DEAHD)",
   label: "Aichhalden (DEAHD)"
  },
  {
   value: "Aichwald (DEAWD)",
   label: "Aichwald (DEAWD)"
  },
  {
   value: "Zborovice (CZZZE)",
   label: "Zborovice (CZZZE)"
  },
  {
   value: "Zbuch (CZPZH)",
   label: "Zbuch (CZPZH)"
  },
  {
   value: "Zbuzany (CZZBU)",
   label: "Zbuzany (CZZBU)"
  },
  {
   value: "Zbysov (CZJZB)",
   label: "Zbysov (CZJZB)"
  },
  {
   value: "Zdánice (CZZDA)",
   label: "Zdánice (CZZDA)"
  },
  {
   value: "Zdiby (CZZBY)",
   label: "Zdiby (CZZBY)"
  },
  {
   value: "Zdice (CZZDI)",
   label: "Zdice (CZZDI)"
  },
  {
   value: "Zdikov (CZZDK)",
   label: "Zdikov (CZZDK)"
  },
  {
   value: "Zdirec (CZLZC)",
   label: "Zdirec (CZLZC)"
  },
  {
   value: "Zdírec Nad Doubravkou (CZZND)",
   label: "Zdírec Nad Doubravkou (CZZND)"
  },
  {
   value: "Zebrák (CZZEB)",
   label: "Zebrák (CZZEB)"
  },
  {
   value: "Zelechovice nad Drevnicí (CZZCD)",
   label: "Zelechovice nad Drevnicí (CZZCD)"
  },
  {
   value: "Zelenky (CZZLK)",
   label: "Zelenky (CZZLK)"
  },
  {
   value: "Zeletava (CZZTV)",
   label: "Zeletava (CZZTV)"
  },
  {
   value: "Zelevcice (CZSZE)",
   label: "Zelevcice (CZSZE)"
  },
  {
   value: "Zelezny Brod (CZZYB)",
   label: "Zelezny Brod (CZZYB)"
  },
  {
   value: "Zidlochovice (CZZLV)",
   label: "Zidlochovice (CZZLV)"
  },
  {
   value: "Zirovnice (CZZIV)",
   label: "Zirovnice (CZZIV)"
  },
  {
   value: "Zruc nad Sázavou (CZZRS)",
   label: "Zruc nad Sázavou (CZZRS)"
  },
  {
   value: "Zulova (CZOZA)",
   label: "Zulova (CZOZA)"
  },
  {
   value: "Zverínek (CZZVE)",
   label: "Zverínek (CZZVE)"
  },
  {
   value: "Abbenrode (DEABB)",
   label: "Abbenrode (DEABB)"
  },
  {
   value: "Abbesbüttel (DEABL)",
   label: "Abbesbüttel (DEABL)"
  },
  {
   value: "Abenberg (DEABR)",
   label: "Abenberg (DEABR)"
  },
  {
   value: "Abstatt (DEABA)",
   label: "Abstatt (DEABA)"
  },
  {
   value: "Vlasim (CZVLM)",
   label: "Vlasim (CZVLM)"
  },
  {
   value: "Vojkovice (CZVJO)",
   label: "Vojkovice (CZVJO)"
  },
  {
   value: "Volary (CZVRY)",
   label: "Volary (CZVRY)"
  },
  {
   value: "Volduchy (CZVCR)",
   label: "Volduchy (CZVCR)"
  },
  {
   value: "Votice (CZVOT)",
   label: "Votice (CZVOT)"
  },
  {
   value: "Vranany (CZVNY)",
   label: "Vranany (CZVNY)"
  },
  {
   value: "Vrané nad Vltavou (CZVRN)",
   label: "Vrané nad Vltavou (CZVRN)"
  },
  {
   value: "Vratimov (CZVTM)",
   label: "Vratimov (CZVTM)"
  },
  {
   value: "Vraz (CZVRZ)",
   label: "Vraz (CZVRZ)"
  },
  {
   value: "Vresova (CZVRE)",
   label: "Vresova (CZVRE)"
  },
  {
   value: "Vsechromy (CZVHY)",
   label: "Vsechromy (CZVHY)"
  },
  {
   value: "Vselibice (CZVLB)",
   label: "Vselibice (CZVLB)"
  },
  {
   value: "Vsetaty (CZVSE)",
   label: "Vsetaty (CZVSE)"
  },
  {
   value: "Vyskytna (CZVYS)",
   label: "Vyskytna (CZVYS)"
  },
  {
   value: "Vysocany (CZVYC)",
   label: "Vysocany (CZVYC)"
  },
  {
   value: "Vysoky Chlumec (CZVCH)",
   label: "Vysoky Chlumec (CZVCH)"
  },
  {
   value: "Vysovice (CZOYE)",
   label: "Vysovice (CZOYE)"
  },
  {
   value: "Zabokrky (CZZAY)",
   label: "Zabokrky (CZZAY)"
  },
  {
   value: "Zabreh (CZZBH)",
   label: "Zabreh (CZZBH)"
  },
  {
   value: "Zábreh (CZZAB)",
   label: "Zábreh (CZZAB)"
  },
  {
   value: "Zabreh na Morave (CZZNM)",
   label: "Zabreh na Morave (CZZNM)"
  },
  {
   value: "Zadni Zborovice (CZZZB)",
   label: "Zadni Zborovice (CZZZB)"
  },
  {
   value: "Zahostice (CZZAH)",
   label: "Zahostice (CZZAH)"
  },
  {
   value: "Zajecí (CZZJI)",
   label: "Zajecí (CZZJI)"
  },
  {
   value: "Zákolany (CZZKY)",
   label: "Zákolany (CZZKY)"
  },
  {
   value: "Zakupy (CZZKP)",
   label: "Zakupy (CZZKP)"
  },
  {
   value: "Zaluzany (CZZAZ)",
   label: "Zaluzany (CZZAZ)"
  },
  {
   value: "Zasmuky (CZZAS)",
   label: "Zasmuky (CZZAS)"
  },
  {
   value: "Zastávka (CZZUB)",
   label: "Zastávka (CZZUB)"
  },
  {
   value: "Velen (CZVLN)",
   label: "Velen (CZVLN)"
  },
  {
   value: "Velesin (CZVLS)",
   label: "Velesin (CZVLS)"
  },
  {
   value: "Veletov (CZVEL)",
   label: "Veletov (CZVEL)"
  },
  {
   value: "Velika Ves (CZVES)",
   label: "Velika Ves (CZVES)"
  },
  {
   value: "Velim u Kolina (CZVUK)",
   label: "Velim u Kolina (CZVUK)"
  },
  {
   value: "Velká Bíteš (CZVEB)",
   label: "Velká Bíteš (CZVEB)"
  },
  {
   value: "Velka Dobra (CZVDA)",
   label: "Velka Dobra (CZVDA)"
  },
  {
   value: "Velké Bílovice (CZVBO)",
   label: "Velké Bílovice (CZVBO)"
  },
  {
   value: "Velké Opatovice (CZVCE)",
   label: "Velké Opatovice (CZVCE)"
  },
  {
   value: "Velké Popovice (CZVPO)",
   label: "Velké Popovice (CZVPO)"
  },
  {
   value: "Velke Porici (CZVPC)",
   label: "Velke Porici (CZVPC)"
  },
  {
   value: "Velký Cenov (CZVKS)",
   label: "Velký Cenov (CZVKS)"
  },
  {
   value: "Velký Osek (CZVOS)",
   label: "Velký Osek (CZVOS)"
  },
  {
   value: "Veltruby (CZVLT)",
   label: "Veltruby (CZVLT)"
  },
  {
   value: "Velvary (CZVVY)",
   label: "Velvary (CZVVY)"
  },
  {
   value: "Velvety (CZVLV)",
   label: "Velvety (CZVLV)"
  },
  {
   value: "Vermerovice (CZVIC)",
   label: "Vermerovice (CZVIC)"
  },
  {
   value: "Vernerice (CZVNC)",
   label: "Vernerice (CZVNC)"
  },
  {
   value: "Veseli nad Luznici (CZJVI)",
   label: "Veseli nad Luznici (CZJVI)"
  },
  {
   value: "Veselí nad Moravou (CZVNM)",
   label: "Veselí nad Moravou (CZVNM)"
  },
  {
   value: "Vestec (CZPRC)",
   label: "Vestec (CZPRC)"
  },
  {
   value: "Vestec (CZVEE)",
   label: "Vestec (CZVEE)"
  },
  {
   value: "Vetrní (CZVTI)",
   label: "Vetrní (CZVTI)"
  },
  {
   value: "Veverská Bityska (CZVAA)",
   label: "Veverská Bityska (CZVAA)"
  },
  {
   value: "Vichova nad Jizerou (CZVNJ)",
   label: "Vichova nad Jizerou (CZVNJ)"
  },
  {
   value: "Vikyrovice (CZOVE)",
   label: "Vikyrovice (CZOVE)"
  },
  {
   value: "Vinarice (CZVNI)",
   label: "Vinarice (CZVNI)"
  },
  {
   value: "Vinor (CZVNR)",
   label: "Vinor (CZVNR)"
  },
  {
   value: "Vintirov (CZVIN)",
   label: "Vintirov (CZVIN)"
  },
  {
   value: "Visnove (CZVSN)",
   label: "Visnove (CZVSN)"
  },
  {
   value: "Vitkov (CZMOV)",
   label: "Vitkov (CZMOV)"
  },
  {
   value: "Vizovice (CZVZI)",
   label: "Vizovice (CZVZI)"
  },
  {
   value: "Trhove Sviny (CZTSY)",
   label: "Trhove Sviny (CZTSY)"
  },
  {
   value: "Trhovy Stepanov (CZSTO)",
   label: "Trhovy Stepanov (CZSTO)"
  },
  {
   value: "Trmice (CZTRM)",
   label: "Trmice (CZTRM)"
  },
  {
   value: "Trnovany (CZTRO)",
   label: "Trnovany (CZTRO)"
  },
  {
   value: "Troubsko (CZTBO)",
   label: "Troubsko (CZTBO)"
  },
  {
   value: "Tuchomerice (CZTUC)",
   label: "Tuchomerice (CZTUC)"
  },
  {
   value: "Tursko (CZTSK)",
   label: "Tursko (CZTSK)"
  },
  {
   value: "Tvrdonice (CZTDI)",
   label: "Tvrdonice (CZTDI)"
  },
  {
   value: "Tyn nad Vltavou (CZTNV)",
   label: "Tyn nad Vltavou (CZTNV)"
  },
  {
   value: "Týnec nad Labem (CZTYL)",
   label: "Týnec nad Labem (CZTYL)"
  },
  {
   value: "Týnec nad Sázavou (CZTAS)",
   label: "Týnec nad Sázavou (CZTAS)"
  },
  {
   value: "Tyniste nad Orlici (CZTNO)",
   label: "Tyniste nad Orlici (CZTNO)"
  },
  {
   value: "Úhelnice (CZUHC)",
   label: "Úhelnice (CZUHC)"
  },
  {
   value: "Uherský Brod (CZUBR)",
   label: "Uherský Brod (CZUBR)"
  },
  {
   value: "Unicov (CZUCV)",
   label: "Unicov (CZUCV)"
  },
  {
   value: "Upice (CZUPI)",
   label: "Upice (CZUPI)"
  },
  {
   value: "Ústí nad Orlicí (CZUOI)",
   label: "Ústí nad Orlicí (CZUOI)"
  },
  {
   value: "Úvalno (CZUVA)",
   label: "Úvalno (CZUVA)"
  },
  {
   value: "Uvaly (CZUVY)",
   label: "Uvaly (CZUVY)"
  },
  {
   value: "Uzice (CZUZK)",
   label: "Uzice (CZUZK)"
  },
  {
   value: "Vacov (CZJVV)",
   label: "Vacov (CZJVV)"
  },
  {
   value: "Valaske Mezirici (CZVSM)",
   label: "Valaske Mezirici (CZVSM)"
  },
  {
   value: "Valasske Klobouky (CZZVY)",
   label: "Valasske Klobouky (CZZVY)"
  },
  {
   value: "Valtice (CZVTC)",
   label: "Valtice (CZVTC)"
  },
  {
   value: "Valtínov (CZSKL)",
   label: "Valtínov (CZSKL)"
  },
  {
   value: "Vamberk (CZVMB)",
   label: "Vamberk (CZVMB)"
  },
  {
   value: "Vejprnice (CZVEJ)",
   label: "Vejprnice (CZVEJ)"
  },
  {
   value: "Vejprty (CZVPT)",
   label: "Vejprty (CZVPT)"
  },
  {
   value: "Velecin (CZVLC)",
   label: "Velecin (CZVLC)"
  },
  {
   value: "Sudkov (CZSUK)",
   label: "Sudkov (CZSUK)"
  },
  {
   value: "Sulice (CZSUL)",
   label: "Sulice (CZSUL)"
  },
  {
   value: "Svatava (CZAAA)",
   label: "Svatava (CZAAA)"
  },
  {
   value: "Svetla Hora (CZMSA)",
   label: "Svetla Hora (CZMSA)"
  },
  {
   value: "Svetlá nad Sázavou (CZSNS)",
   label: "Svetlá nad Sázavou (CZSNS)"
  },
  {
   value: "Sviadnov (CZSDO)",
   label: "Sviadnov (CZSDO)"
  },
  {
   value: "Svrkyne (CZSVR)",
   label: "Svrkyne (CZSVR)"
  },
  {
   value: "Tanvald (CZTVA)",
   label: "Tanvald (CZTVA)"
  },
  {
   value: "Tehovec (CZSHC)",
   label: "Tehovec (CZSHC)"
  },
  {
   value: "Telc (CZTLC)",
   label: "Telc (CZTLC)"
  },
  {
   value: "Temelín (CZTML)",
   label: "Temelín (CZTML)"
  },
  {
   value: "Terezin (CZUTN)",
   label: "Terezin (CZUTN)"
  },
  {
   value: "Tesovice (CZTES)",
   label: "Tesovice (CZTES)"
  },
  {
   value: "Tisice (CZTSC)",
   label: "Tisice (CZTSC)"
  },
  {
   value: "Tisnov (CZTIS)",
   label: "Tisnov (CZTIS)"
  },
  {
   value: "Topolna (CZTOP)",
   label: "Topolna (CZTOP)"
  },
  {
   value: "Touzim (CZTOM)",
   label: "Touzim (CZTOM)"
  },
  {
   value: "Tovacov (CZTOV)",
   label: "Tovacov (CZTOV)"
  },
  {
   value: "Tranovice (CZMTE)",
   label: "Tranovice (CZMTE)"
  },
  {
   value: "Trebarov (CZTRV)",
   label: "Trebarov (CZTRV)"
  },
  {
   value: "Trebechovice pod Orebem (CZTPO)",
   label: "Trebechovice pod Orebem (CZTPO)"
  },
  {
   value: "Trebenice (CZTRN)",
   label: "Trebenice (CZTRN)"
  },
  {
   value: "Trebestovice (CZTSO)",
   label: "Trebestovice (CZTSO)"
  },
  {
   value: "Trebísov (CZTBV)",
   label: "Trebísov (CZTBV)"
  },
  {
   value: "Trebon (CZTBN)",
   label: "Trebon (CZTBN)"
  },
  {
   value: "Treboradice (CZTBD)",
   label: "Treboradice (CZTBD)"
  },
  {
   value: "Trebotov (CZTRE)",
   label: "Trebotov (CZTRE)"
  },
  {
   value: "Tremosnice (CZTMO)",
   label: "Tremosnice (CZTMO)"
  },
  {
   value: "Stará Boleslav (CZSBO)",
   label: "Stará Boleslav (CZSBO)"
  },
  {
   value: "Stará Role (CZSRO)",
   label: "Stará Role (CZSRO)"
  },
  {
   value: "Staré Mesto (CZSTM)",
   label: "Staré Mesto (CZSTM)"
  },
  {
   value: "Stare Mesto pod Sneznikem (CZOSM)",
   label: "Stare Mesto pod Sneznikem (CZOSM)"
  },
  {
   value: "Stare Mesto u Uherskeho Hradiste (CZZSE)",
   label: "Stare Mesto u Uherskeho Hradiste (CZZSE)"
  },
  {
   value: "Stary Plzenec (CZSPC)",
   label: "Stary Plzenec (CZSPC)"
  },
  {
   value: "Stechovice (CZSTE)",
   label: "Stechovice (CZSTE)"
  },
  {
   value: "Stepanov nad Svratkou (CZSNK)",
   label: "Stepanov nad Svratkou (CZSNK)"
  },
  {
   value: "Sternberk (CZSTB)",
   label: "Sternberk (CZSTB)"
  },
  {
   value: "Stetí (CZSTT)",
   label: "Stetí (CZSTT)"
  },
  {
   value: "Stezery (CZKSY)",
   label: "Stezery (CZKSY)"
  },
  {
   value: "Stítná nad Vlárí (CZSNV)",
   label: "Stítná nad Vlárí (CZSNV)"
  },
  {
   value: "Stochov (CZSTH)",
   label: "Stochov (CZSTH)"
  },
  {
   value: "Stod u Plzne (CZSUP)",
   label: "Stod u Plzne (CZSUP)"
  },
  {
   value: "Strancice (CZSTC)",
   label: "Strancice (CZSTC)"
  },
  {
   value: "Straskov (CZSVO)",
   label: "Straskov (CZSVO)"
  },
  {
   value: "Stráz nad Nisou (CZSNN)",
   label: "Stráz nad Nisou (CZSNN)"
  },
  {
   value: "Straz pod Ralskem (CZSZR)",
   label: "Straz pod Ralskem (CZSZR)"
  },
  {
   value: "Strazna (CZOTA)",
   label: "Strazna (CZOTA)"
  },
  {
   value: "Strázné (CZSZN)",
   label: "Strázné (CZSZN)"
  },
  {
   value: "Stráznice (CZSTR)",
   label: "Stráznice (CZSTR)"
  },
  {
   value: "Strazov (CZSTZ)",
   label: "Strazov (CZSTZ)"
  },
  {
   value: "Stredokluky (CZSEY)",
   label: "Stredokluky (CZSEY)"
  },
  {
   value: "Strelice (CZSTL)",
   label: "Strelice (CZSTL)"
  },
  {
   value: "Stribrna Skalice (CZBRA)",
   label: "Stribrna Skalice (CZBRA)"
  },
  {
   value: "Stríbro (CZSBR)",
   label: "Stríbro (CZSBR)"
  },
  {
   value: "Strítež (CZSIZ)",
   label: "Strítež (CZSIZ)"
  },
  {
   value: "Studená (CZSTU)",
   label: "Studená (CZSTU)"
  },
  {
   value: "Studenka (CZSRV)",
   label: "Studenka (CZSRV)"
  },
  {
   value: "Suchá Loz (CZSLZ)",
   label: "Suchá Loz (CZSLZ)"
  },
  {
   value: "Sedlcany (CZSED)",
   label: "Sedlcany (CZSED)"
  },
  {
   value: "Semcice (CZSEM)",
   label: "Semcice (CZSEM)"
  },
  {
   value: "Senice na Hané (CZSNH)",
   label: "Senice na Hané (CZSNH)"
  },
  {
   value: "Senov (CZSNO)",
   label: "Senov (CZSNO)"
  },
  {
   value: "Senov Ostrava Mesto (CZSEN)",
   label: "Senov Ostrava Mesto (CZSEN)"
  },
  {
   value: "Senov u Ostravy (CZMSY)",
   label: "Senov u Ostravy (CZMSY)"
  },
  {
   value: "Sezemice (CZIAE)",
   label: "Sezemice (CZIAE)"
  },
  {
   value: "Sezemice (CZSZM)",
   label: "Sezemice (CZSZM)"
  },
  {
   value: "Sezimovo Ústí (CZSEZ)",
   label: "Sezimovo Ústí (CZSEZ)"
  },
  {
   value: "Skalice u Ceske Lipy (CZSCL)",
   label: "Skalice u Ceske Lipy (CZSCL)"
  },
  {
   value: "Skalná (CZSKA)",
   label: "Skalná (CZSKA)"
  },
  {
   value: "Skuhrov nad Belou (CZSNB)",
   label: "Skuhrov nad Belou (CZSNB)"
  },
  {
   value: "Skvorec (CZSKV)",
   label: "Skvorec (CZSKV)"
  },
  {
   value: "Slaný (CZSLY)",
   label: "Slaný (CZSLY)"
  },
  {
   value: "Slapanice (CZSNE)",
   label: "Slapanice (CZSNE)"
  },
  {
   value: "Slapy (CZSLA)",
   label: "Slapy (CZSLA)"
  },
  {
   value: "Slatina (CZSTA)",
   label: "Slatina (CZSTA)"
  },
  {
   value: "Slavicin (CZSVC)",
   label: "Slavicin (CZSVC)"
  },
  {
   value: "Slavicín (CZSVN)",
   label: "Slavicín (CZSVN)"
  },
  {
   value: "Slavkov u Brna (CZSVB)",
   label: "Slavkov u Brna (CZSVB)"
  },
  {
   value: "Sluknov (CZULV)",
   label: "Sluknov (CZULV)"
  },
  {
   value: "Smíchov (CZSMO)",
   label: "Smíchov (CZSMO)"
  },
  {
   value: "Smirice (CZSMR)",
   label: "Smirice (CZSMR)"
  },
  {
   value: "Smrzovka (CZOVK)",
   label: "Smrzovka (CZOVK)"
  },
  {
   value: "Sobeslav (CZSBE)",
   label: "Sobeslav (CZSBE)"
  },
  {
   value: "Sobotín (CZSOB)",
   label: "Sobotín (CZSOB)"
  },
  {
   value: "Sobotka (CZSBA)",
   label: "Sobotka (CZSBA)"
  },
  {
   value: "Solnice (CZSOL)",
   label: "Solnice (CZSOL)"
  },
  {
   value: "Spáléne Porící (CZSPR)",
   label: "Spáléne Porící (CZSPR)"
  },
  {
   value: "Spytihnev (CZSPY)",
   label: "Spytihnev (CZSPY)"
  },
  {
   value: "Stádlec (CZSTD)",
   label: "Stádlec (CZSTD)"
  },
  {
   value: "Stankov (CZPSO)",
   label: "Stankov (CZPSO)"
  },
  {
   value: "Stankovice U Zatce (CZSUZ)",
   label: "Stankovice U Zatce (CZSUZ)"
  },
  {
   value: "Radonice (CZRDN)",
   label: "Radonice (CZRDN)"
  },
  {
   value: "Radovesnice (CZRVN)",
   label: "Radovesnice (CZRVN)"
  },
  {
   value: "Rajec-Jestrebi (CZRJS)",
   label: "Rajec-Jestrebi (CZRJS)"
  },
  {
   value: "Rajhrad (CZRAJ)",
   label: "Rajhrad (CZRAJ)"
  },
  {
   value: "Rakvice (CZRKV)",
   label: "Rakvice (CZRKV)"
  },
  {
   value: "Rapotice (CZRPO)",
   label: "Rapotice (CZRPO)"
  },
  {
   value: "Rapotín (CZRAT)",
   label: "Rapotín (CZRAT)"
  },
  {
   value: "Ratískovice (CZRKO)",
   label: "Ratískovice (CZRKO)"
  },
  {
   value: "Recice (CZCVR)",
   label: "Recice (CZCVR)"
  },
  {
   value: "Repov (CZREV)",
   label: "Repov (CZREV)"
  },
  {
   value: "Rícany (CZRCY)",
   label: "Rícany (CZRCY)"
  },
  {
   value: "Ricany u Prahy (CZRUP)",
   label: "Ricany u Prahy (CZRUP)"
  },
  {
   value: "Rohle (CZOLR)",
   label: "Rohle (CZOLR)"
  },
  {
   value: "Rokytnice nad Jizerou (CZRNJ)",
   label: "Rokytnice nad Jizerou (CZRNJ)"
  },
  {
   value: "Rokytnice v Orlickych Horach (CZKRH)",
   label: "Rokytnice v Orlickych Horach (CZKRH)"
  },
  {
   value: "Rosice (CZRUR)",
   label: "Rosice (CZRUR)"
  },
  {
   value: "Rotava (CZRTV)",
   label: "Rotava (CZRTV)"
  },
  {
   value: "Rousinov (CZRSV)",
   label: "Rousinov (CZRSV)"
  },
  {
   value: "Roztoky (CZRZT)",
   label: "Roztoky (CZRZT)"
  },
  {
   value: "Rtyne nad Bílinou (CZRNB)",
   label: "Rtyne nad Bílinou (CZRNB)"
  },
  {
   value: "Rtyne nad Bílinou (CZRTY)",
   label: "Rtyne nad Bílinou (CZRTY)"
  },
  {
   value: "Rudná (CZRUD)",
   label: "Rudná (CZRUD)"
  },
  {
   value: "Rudna u Prahy (CZRPY)",
   label: "Rudna u Prahy (CZRPY)"
  },
  {
   value: "Rychvald (CZRCV)",
   label: "Rychvald (CZRCV)"
  },
  {
   value: "Rynoltice (CZRYN)",
   label: "Rynoltice (CZRYN)"
  },
  {
   value: "Sadská (CZSAD)",
   label: "Sadská (CZSAD)"
  },
  {
   value: "Sardice (CZSDI)",
   label: "Sardice (CZSDI)"
  },
  {
   value: "Sázava (CZSAZ)",
   label: "Sázava (CZSAZ)"
  },
  {
   value: "Polevsko (CZPLO)",
   label: "Polevsko (CZPLO)"
  },
  {
   value: "Police nad Metují (CZPNJ)",
   label: "Police nad Metují (CZPNJ)"
  },
  {
   value: "Policka (CZPLK)",
   label: "Policka (CZPLK)"
  },
  {
   value: "Polna U Jihlavy (CZKPY)",
   label: "Polna U Jihlavy (CZKPY)"
  },
  {
   value: "Ponikla (CZLPA)",
   label: "Ponikla (CZLPA)"
  },
  {
   value: "Poríci nad Sázavou (CZPRS)",
   label: "Poríci nad Sázavou (CZPRS)"
  },
  {
   value: "Postoloprty (CZUPY)",
   label: "Postoloprty (CZUPY)"
  },
  {
   value: "Postorna (CZPBJ)",
   label: "Postorna (CZPBJ)"
  },
  {
   value: "Potstat (CZOPT)",
   label: "Potstat (CZOPT)"
  },
  {
   value: "Potvorov (CZPOO)",
   label: "Potvorov (CZPOO)"
  },
  {
   value: "Pouzdrany (CZPZY)",
   label: "Pouzdrany (CZPZY)"
  },
  {
   value: "Pozorice (CZPZE)",
   label: "Pozorice (CZPZE)"
  },
  {
   value: "Prague = Praha (CZ)",
   label: "Prague = Praha (CZ)"
  },
  {
   value: "Predmerice nad Jizerou (CZPRJ)",
   label: "Predmerice nad Jizerou (CZPRJ)"
  },
  {
   value: "Predmerice nad Labem (CZPNL)",
   label: "Predmerice nad Labem (CZPNL)"
  },
  {
   value: "Prelouc (CZPLC)",
   label: "Prelouc (CZPLC)"
  },
  {
   value: "Prestice (CZPST)",
   label: "Prestice (CZPST)"
  },
  {
   value: "Príbor (CZPBR)",
   label: "Príbor (CZPBR)"
  },
  {
   value: "Prisovice (CZPIC)",
   label: "Prisovice (CZPIC)"
  },
  {
   value: "Pritluky (CZPTY)",
   label: "Pritluky (CZPTY)"
  },
  {
   value: "Prosenice (CZPSE)",
   label: "Prosenice (CZPSE)"
  },
  {
   value: "Protivin (CZJPN)",
   label: "Protivin (CZJPN)"
  },
  {
   value: "Provodín (CZPVN)",
   label: "Provodín (CZPVN)"
  },
  {
   value: "Pruhonice (CZPHE)",
   label: "Pruhonice (CZPHE)"
  },
  {
   value: "Prunérov (CZPRU)",
   label: "Prunérov (CZPRU)"
  },
  {
   value: "Ptení (CZPTI)",
   label: "Ptení (CZPTI)"
  },
  {
   value: "Pysely (CZPYS)",
   label: "Pysely (CZPYS)"
  },
  {
   value: "Rácovice (CZRVC)",
   label: "Rácovice (CZRVC)"
  },
  {
   value: "Radnice u Plzne (CZVRP)",
   label: "Radnice u Plzne (CZVRP)"
  },
  {
   value: "Radonice (CZRAU)",
   label: "Radonice (CZRAU)"
  },
  {
   value: "Ostrozská Nová Ves (CZONV)",
   label: "Ostrozská Nová Ves (CZONV)"
  },
  {
   value: "Otnice (CZONC)",
   label: "Otnice (CZONC)"
  },
  {
   value: "Otovice (CZOTV)",
   label: "Otovice (CZOTV)"
  },
  {
   value: "Otvovice (CZOVC)",
   label: "Otvovice (CZOVC)"
  },
  {
   value: "Ovcáry (CZOVY)",
   label: "Ovcáry (CZOVY)"
  },
  {
   value: "Pacov (CZPAC)",
   label: "Pacov (CZPAC)"
  },
  {
   value: "Panenské Brezany (CZPNB)",
   label: "Panenské Brezany (CZPNB)"
  },
  {
   value: "Paskov (CZPSV)",
   label: "Paskov (CZPSV)"
  },
  {
   value: "Pavlov (CZPVO)",
   label: "Pavlov (CZPVO)"
  },
  {
   value: "Pavlov (CZPVV)",
   label: "Pavlov (CZPVV)"
  },
  {
   value: "Pavlovice u Prerova (CZPPO)",
   label: "Pavlovice u Prerova (CZPPO)"
  },
  {
   value: "Pecky (CZPKY)",
   label: "Pecky (CZPKY)"
  },
  {
   value: "Petrvald (CZTRL)",
   label: "Petrvald (CZTRL)"
  },
  {
   value: "Pisecna u Jeseniku (CZPPU)",
   label: "Pisecna u Jeseniku (CZPPU)"
  },
  {
   value: "Písnice (CZPSN)",
   label: "Písnice (CZPSN)"
  },
  {
   value: "Planá (CZANA)",
   label: "Planá (CZANA)"
  },
  {
   value: "Plana nad Luznici (CZPLN)",
   label: "Plana nad Luznici (CZPLN)"
  },
  {
   value: "Planá nad Luznicí (CZPXL)",
   label: "Planá nad Luznicí (CZPXL)"
  },
  {
   value: "Plana u Marianskych Lazni (CZPAU)",
   label: "Plana u Marianskych Lazni (CZPAU)"
  },
  {
   value: "Plasy (CZPSY)",
   label: "Plasy (CZPSY)"
  },
  {
   value: "Plavy (CZPVY)",
   label: "Plavy (CZPVY)"
  },
  {
   value: "Plesna (CZPLS)",
   label: "Plesna (CZPLS)"
  },
  {
   value: "Pobezovice (CZPZO)",
   label: "Pobezovice (CZPZO)"
  },
  {
   value: "Pocatky (CZPOC)",
   label: "Pocatky (CZPOC)"
  },
  {
   value: "Podborany (CZPBY)",
   label: "Podborany (CZPBY)"
  },
  {
   value: "Podebrady (CZPOD)",
   label: "Podebrady (CZPOD)"
  },
  {
   value: "Podivin (CZPDV)",
   label: "Podivin (CZPDV)"
  },
  {
   value: "Pohorelice (CZPRE)",
   label: "Pohorelice (CZPRE)"
  },
  {
   value: "Pohorelice U Brna (CZJPA)",
   label: "Pohorelice U Brna (CZJPA)"
  },
  {
   value: "Novy Bydzov (CZNBY)",
   label: "Novy Bydzov (CZNBY)"
  },
  {
   value: "Nový Hrádek (CZNHK)",
   label: "Nový Hrádek (CZNHK)"
  },
  {
   value: "Novy Hrozenkov (CZNHV)",
   label: "Novy Hrozenkov (CZNHV)"
  },
  {
   value: "Novy Rychnov (CZNYC)",
   label: "Novy Rychnov (CZNYC)"
  },
  {
   value: "Nový Vestec (CZNVV)",
   label: "Nový Vestec (CZNVV)"
  },
  {
   value: "Nucice (CZNCI)",
   label: "Nucice (CZNCI)"
  },
  {
   value: "Nupaky (CZNUP)",
   label: "Nupaky (CZNUP)"
  },
  {
   value: "Nýrany (CZNRY)",
   label: "Nýrany (CZNRY)"
  },
  {
   value: "Nyrsko (CZPNO)",
   label: "Nyrsko (CZPNO)"
  },
  {
   value: "Obríství (CZOBT)",
   label: "Obríství (CZOBT)"
  },
  {
   value: "Odolena Voda (CZODO)",
   label: "Odolena Voda (CZODO)"
  },
  {
   value: "Odolena Voda (CZODV)",
   label: "Odolena Voda (CZODV)"
  },
  {
   value: "Okrisky (CZOKY)",
   label: "Okrisky (CZOKY)"
  },
  {
   value: "Olesna (CZOSA)",
   label: "Olesna (CZOSA)"
  },
  {
   value: "Olesnice Na Morave (CZJOE)",
   label: "Olesnice Na Morave (CZJOE)"
  },
  {
   value: "Olovi (CZOLV)",
   label: "Olovi (CZOLV)"
  },
  {
   value: "Olsany (CZOLS)",
   label: "Olsany (CZOLS)"
  },
  {
   value: "Olsany u Sumperka (CZOUS)",
   label: "Olsany u Sumperka (CZOUS)"
  },
  {
   value: "Omoljica (CZOMO)",
   label: "Omoljica (CZOMO)"
  },
  {
   value: "Ondrejov (CZOND)",
   label: "Ondrejov (CZOND)"
  },
  {
   value: "Oparany (CZOPY)",
   label: "Oparany (CZOPY)"
  },
  {
   value: "Opatovice nad Labem (CZONL)",
   label: "Opatovice nad Labem (CZONL)"
  },
  {
   value: "Orechov (CZORV)",
   label: "Orechov (CZORV)"
  },
  {
   value: "Orlova (CZMOA)",
   label: "Orlova (CZMOA)"
  },
  {
   value: "Osice (CZOSI)",
   label: "Osice (CZOSI)"
  },
  {
   value: "Osik (CZPAO)",
   label: "Osik (CZPAO)"
  },
  {
   value: "Oslavany (CZOSY)",
   label: "Oslavany (CZOSY)"
  },
  {
   value: "Osoblaha (CZOBA)",
   label: "Osoblaha (CZOBA)"
  },
  {
   value: "Ostrata (CZOTT)",
   label: "Ostrata (CZOTT)"
  },
  {
   value: "Ostravice (CZORE)",
   label: "Ostravice (CZORE)"
  },
  {
   value: "Ostromer (CZOST)",
   label: "Ostromer (CZOST)"
  },
  {
   value: "Ostrov (CZONO)",
   label: "Ostrov (CZONO)"
  },
  {
   value: "Moravsky Krumlov (CZMKV)",
   label: "Moravsky Krumlov (CZMKV)"
  },
  {
   value: "Moravsky Pisek (CZMRA)",
   label: "Moravsky Pisek (CZMRA)"
  },
  {
   value: "Mosnov (CZMOS)",
   label: "Mosnov (CZMOS)"
  },
  {
   value: "Mostek (CZMTK)",
   label: "Mostek (CZMTK)"
  },
  {
   value: "Moutnice (CZMTN)",
   label: "Moutnice (CZMTN)"
  },
  {
   value: "Mseno (CZSOM)",
   label: "Mseno (CZSOM)"
  },
  {
   value: "Mutenice (CZMEE)",
   label: "Mutenice (CZMEE)"
  },
  {
   value: "Myto\/Cesky Krumlov (CZMYT)",
   label: "Myto\/Cesky Krumlov (CZMYT)"
  },
  {
   value: "Námest nad Oslavou (CZNAM)",
   label: "Námest nad Oslavou (CZNAM)"
  },
  {
   value: "Napajedla (CZNPJ)",
   label: "Napajedla (CZNPJ)"
  },
  {
   value: "Nedakonice (CZDAK)",
   label: "Nedakonice (CZDAK)"
  },
  {
   value: "Nehvizdy (CZNEH)",
   label: "Nehvizdy (CZNEH)"
  },
  {
   value: "Nelahozeves (CZNLH)",
   label: "Nelahozeves (CZNLH)"
  },
  {
   value: "Nemcicky (CZNMY)",
   label: "Nemcicky (CZNMY)"
  },
  {
   value: "Nepomuk (CZNPK)",
   label: "Nepomuk (CZNPK)"
  },
  {
   value: "Neratovice (CZNRT)",
   label: "Neratovice (CZNRT)"
  },
  {
   value: "Nestemice (CZNIC)",
   label: "Nestemice (CZNIC)"
  },
  {
   value: "Netovice (CZNVI)",
   label: "Netovice (CZNVI)"
  },
  {
   value: "Nisovice (CZNSE)",
   label: "Nisovice (CZNSE)"
  },
  {
   value: "Nivnice (CZNVC)",
   label: "Nivnice (CZNVC)"
  },
  {
   value: "Nizbor (CZNBR)",
   label: "Nizbor (CZNBR)"
  },
  {
   value: "Nová Paka (CZPAK)",
   label: "Nová Paka (CZPAK)"
  },
  {
   value: "Nová Role (CZNRL)",
   label: "Nová Role (CZNRL)"
  },
  {
   value: "Nove Dvory (CZNVY)",
   label: "Nove Dvory (CZNVY)"
  },
  {
   value: "Nove Losiny (CZNLS)",
   label: "Nove Losiny (CZNLS)"
  },
  {
   value: "Nové Mesto na Morave (CZNMO)",
   label: "Nové Mesto na Morave (CZNMO)"
  },
  {
   value: "Nové Mesto nad Metují (CZNMN)",
   label: "Nové Mesto nad Metují (CZNMN)"
  },
  {
   value: "Nové Strasecí (CZNST)",
   label: "Nové Strasecí (CZNST)"
  },
  {
   value: "Novosedly (CZNVL)",
   label: "Novosedly (CZNVL)"
  },
  {
   value: "Mchnov (CZMCH)",
   label: "Mchnov (CZMCH)"
  },
  {
   value: "Medlesic (CZMED)",
   label: "Medlesic (CZMED)"
  },
  {
   value: "Medlov (CZMLV)",
   label: "Medlov (CZMLV)"
  },
  {
   value: "Merklín (CZMKN)",
   label: "Merklín (CZMKN)"
  },
  {
   value: "Merklín (CZMLI)",
   label: "Merklín (CZMLI)"
  },
  {
   value: "Mesto Touskov (CZMTO)",
   label: "Mesto Touskov (CZMTO)"
  },
  {
   value: "Mezimesti u Broumova (CZVMA)",
   label: "Mezimesti u Broumova (CZVMA)"
  },
  {
   value: "Michnov (CZMNV)",
   label: "Michnov (CZMNV)"
  },
  {
   value: "Mikulcice (CZJME)",
   label: "Mikulcice (CZJME)"
  },
  {
   value: "Miroslav (CZSLV)",
   label: "Miroslav (CZSLV)"
  },
  {
   value: "Mirovice (CZMRC)",
   label: "Mirovice (CZMRC)"
  },
  {
   value: "Mlade Buky (CZBKY)",
   label: "Mlade Buky (CZBKY)"
  },
  {
   value: "Mnichovice (CZMHC)",
   label: "Mnichovice (CZMHC)"
  },
  {
   value: "Mnichovo Hradiste (CZMHT)",
   label: "Mnichovo Hradiste (CZMHT)"
  },
  {
   value: "Mnisek pod Brdy (CZMPB)",
   label: "Mnisek pod Brdy (CZMPB)"
  },
  {
   value: "Mochov (CZMOH)",
   label: "Mochov (CZMOH)"
  },
  {
   value: "Mocovice (CZMCV)",
   label: "Mocovice (CZMCV)"
  },
  {
   value: "Modlany (CZMDL)",
   label: "Modlany (CZMDL)"
  },
  {
   value: "Modletice (CZMOD)",
   label: "Modletice (CZMOD)"
  },
  {
   value: "Modrice (CZMDR)",
   label: "Modrice (CZMDR)"
  },
  {
   value: "Mohelnice (CZMHI)",
   label: "Mohelnice (CZMHI)"
  },
  {
   value: "Mokrá (CZMOK)",
   label: "Mokrá (CZMOK)"
  },
  {
   value: "Mokre Lazce (CZMOL)",
   label: "Mokre Lazce (CZMOL)"
  },
  {
   value: "Moravany (CZPMY)",
   label: "Moravany (CZPMY)"
  },
  {
   value: "Moravicany (CZMOR)",
   label: "Moravicany (CZMOR)"
  },
  {
   value: "Moravská Trebová (CZMVB)",
   label: "Moravská Trebová (CZMVB)"
  },
  {
   value: "Moravske Budejovice (CZVME)",
   label: "Moravske Budejovice (CZVME)"
  },
  {
   value: "Moravský Beroun (CZMYB)",
   label: "Moravský Beroun (CZMYB)"
  },
  {
   value: "Lipnik u Hrotovic (CZSLC)",
   label: "Lipnik u Hrotovic (CZSLC)"
  },
  {
   value: "Litice (CZLCE)",
   label: "Litice (CZLCE)"
  },
  {
   value: "Litovel (CZLTV)",
   label: "Litovel (CZLTV)"
  },
  {
   value: "Litvínov (CZLVV)",
   label: "Litvínov (CZLVV)"
  },
  {
   value: "Lobodice (CZLOB)",
   label: "Lobodice (CZLOB)"
  },
  {
   value: "Lochovice (CZLUK)",
   label: "Lochovice (CZLUK)"
  },
  {
   value: "Lodenice (CZLOD)",
   label: "Lodenice (CZLOD)"
  },
  {
   value: "Lomnice nad Popelkou (CZLNE)",
   label: "Lomnice nad Popelkou (CZLNE)"
  },
  {
   value: "Lomnice nad Popelkou (CZLOM)",
   label: "Lomnice nad Popelkou (CZLOM)"
  },
  {
   value: "Lostice (CZOLE)",
   label: "Lostice (CZOLE)"
  },
  {
   value: "Loucna Nad Desnou (CZOOU)",
   label: "Loucna Nad Desnou (CZOOU)"
  },
  {
   value: "Loucovice (CZJLE)",
   label: "Loucovice (CZJLE)"
  },
  {
   value: "Louka (CZLKA)",
   label: "Louka (CZLKA)"
  },
  {
   value: "Louka (CZLUT)",
   label: "Louka (CZLUT)"
  },
  {
   value: "Loukov (CZLOK)",
   label: "Loukov (CZLOK)"
  },
  {
   value: "Louny (CZLOU)",
   label: "Louny (CZLOU)"
  },
  {
   value: "Lovcice (CZLOV)",
   label: "Lovcice (CZLOV)"
  },
  {
   value: "Lubenec (CZLBC)",
   label: "Lubenec (CZLBC)"
  },
  {
   value: "Lubna (CZSUA)",
   label: "Lubna (CZSUA)"
  },
  {
   value: "Lucany nad Nisou (CZLNN)",
   label: "Lucany nad Nisou (CZLNN)"
  },
  {
   value: "Ludgerovice (CZLGV)",
   label: "Ludgerovice (CZLGV)"
  },
  {
   value: "Luhacovice (CZLUL)",
   label: "Luhacovice (CZLUL)"
  },
  {
   value: "Luka Nad Jihlavou (CZLNJ)",
   label: "Luka Nad Jihlavou (CZLNJ)"
  },
  {
   value: "Lukavice (CZLUE)",
   label: "Lukavice (CZLUE)"
  },
  {
   value: "Lulec (CZLCC)",
   label: "Lulec (CZLCC)"
  },
  {
   value: "Lustenice (CZLUS)",
   label: "Lustenice (CZLUS)"
  },
  {
   value: "Lutin (CZLUI)",
   label: "Lutin (CZLUI)"
  },
  {
   value: "Luzna (CZLUA)",
   label: "Luzna (CZLUA)"
  },
  {
   value: "Luzna (CZLUZ)",
   label: "Luzna (CZLUZ)"
  },
  {
   value: "Lysá nad Labem (CZLYL)",
   label: "Lysá nad Labem (CZLYL)"
  },
  {
   value: "Malé Svatonovice (CZMSV)",
   label: "Malé Svatonovice (CZMSV)"
  },
  {
   value: "Mankovice (CZMME)",
   label: "Mankovice (CZMME)"
  },
  {
   value: "Krusovice (CZSKE)",
   label: "Krusovice (CZSKE)"
  },
  {
   value: "Kryry (CZKRY)",
   label: "Kryry (CZKRY)"
  },
  {
   value: "Kuklov (CZKUK)",
   label: "Kuklov (CZKUK)"
  },
  {
   value: "Kuncina (CZPUA)",
   label: "Kuncina (CZPUA)"
  },
  {
   value: "Kunín (CZKNN)",
   label: "Kunín (CZKNN)"
  },
  {
   value: "Kunovice (CZKUN)",
   label: "Kunovice (CZKUN)"
  },
  {
   value: "Kunovice (CZKVC)",
   label: "Kunovice (CZKVC)"
  },
  {
   value: "Kunstat (CZKTT)",
   label: "Kunstat (CZKTT)"
  },
  {
   value: "Kunstát (CZKNT)",
   label: "Kunstát (CZKNT)"
  },
  {
   value: "Kunstat Na Morave (CZKMO)",
   label: "Kunstat Na Morave (CZKMO)"
  },
  {
   value: "Kurivody (CZLKY)",
   label: "Kurivody (CZLKY)"
  },
  {
   value: "Kvasiny (CZKVS)",
   label: "Kvasiny (CZKVS)"
  },
  {
   value: "Kyjov (CZKYJ)",
   label: "Kyjov (CZKYJ)"
  },
  {
   value: "Kyselka (CZKKA)",
   label: "Kyselka (CZKKA)"
  },
  {
   value: "Kyselka u Karlovych Varu (CZKYS)",
   label: "Kyselka u Karlovych Varu (CZKYS)"
  },
  {
   value: "Ládví (CZLDV)",
   label: "Ládví (CZLDV)"
  },
  {
   value: "Lanskroun (CZLKR)",
   label: "Lanskroun (CZLKR)"
  },
  {
   value: "Lazne Belohrad (CZLBD)",
   label: "Lazne Belohrad (CZLBD)"
  },
  {
   value: "Lechovice (CZLEC)",
   label: "Lechovice (CZLEC)"
  },
  {
   value: "Ledec nad Sázavou (CZLNS)",
   label: "Ledec nad Sázavou (CZLNS)"
  },
  {
   value: "Letohrad (CZLET)",
   label: "Letohrad (CZLET)"
  },
  {
   value: "Letovice (CZLOE)",
   label: "Letovice (CZLOE)"
  },
  {
   value: "Lhotka-nad-Becvou (CZLHO)",
   label: "Lhotka-nad-Becvou (CZLHO)"
  },
  {
   value: "Libavské Údolí (CZVSK)",
   label: "Libavské Údolí (CZVSK)"
  },
  {
   value: "Libeznice (CZLZI)",
   label: "Libeznice (CZLZI)"
  },
  {
   value: "Libice nad Cidlinou (CZKLU)",
   label: "Libice nad Cidlinou (CZKLU)"
  },
  {
   value: "Libochovany (CZLIC)",
   label: "Libochovany (CZLIC)"
  },
  {
   value: "Libosovice (CZLIB)",
   label: "Libosovice (CZLIB)"
  },
  {
   value: "Line (CZLIN)",
   label: "Line (CZLIN)"
  },
  {
   value: "Lipnik nad Becvou (CZOLU)",
   label: "Lipnik nad Becvou (CZOLU)"
  },
  {
   value: "Knezmost (CZKZM)",
   label: "Knezmost (CZKZM)"
  },
  {
   value: "Koberice (CZMKE)",
   label: "Koberice (CZMKE)"
  },
  {
   value: "Kojetice (CZKOJ)",
   label: "Kojetice (CZKOJ)"
  },
  {
   value: "Komárov (CZKMV)",
   label: "Komárov (CZKMV)"
  },
  {
   value: "Konarovice (CZKNC)",
   label: "Konarovice (CZKNC)"
  },
  {
   value: "Korycany (CZKOR)",
   label: "Korycany (CZKOR)"
  },
  {
   value: "Kosmonosy (CZKMY)",
   label: "Kosmonosy (CZKMY)"
  },
  {
   value: "Kostálov (CZKTA)",
   label: "Kostálov (CZKTA)"
  },
  {
   value: "Kostany (CZKOS)",
   label: "Kostany (CZKOS)"
  },
  {
   value: "Kostelec (CZKOL)",
   label: "Kostelec (CZKOL)"
  },
  {
   value: "Kostelec nad Cernými Lesy (CZKCL)",
   label: "Kostelec nad Cernými Lesy (CZKCL)"
  },
  {
   value: "Kostelec nad Labem (CZKSL)",
   label: "Kostelec nad Labem (CZKSL)"
  },
  {
   value: "Kostelec nad Orlicí (CZKOO)",
   label: "Kostelec nad Orlicí (CZKOO)"
  },
  {
   value: "Kostenice (CZKSN)",
   label: "Kostenice (CZKSN)"
  },
  {
   value: "Kostenice (CZKTC)",
   label: "Kostenice (CZKTC)"
  },
  {
   value: "Kostomlatky (CZKST)",
   label: "Kostomlatky (CZKST)"
  },
  {
   value: "Kotvrdovice (CZKOT)",
   label: "Kotvrdovice (CZKOT)"
  },
  {
   value: "Kounice (CZKOU)",
   label: "Kounice (CZKOU)"
  },
  {
   value: "Kourim (CZKRM)",
   label: "Kourim (CZKRM)"
  },
  {
   value: "Kout na Sumave (CZKNS)",
   label: "Kout na Sumave (CZKNS)"
  },
  {
   value: "Kozlany (CZKOZ)",
   label: "Kozlany (CZKOZ)"
  },
  {
   value: "Kozojedy (CZKZY)",
   label: "Kozojedy (CZKZY)"
  },
  {
   value: "Kozusice (CZKZU)",
   label: "Kozusice (CZKZU)"
  },
  {
   value: "Kralice na Hané (CZRNH)",
   label: "Kralice na Hané (CZRNH)"
  },
  {
   value: "Kralovice (CZKVI)",
   label: "Kralovice (CZKVI)"
  },
  {
   value: "Kralovice (CZSTK)",
   label: "Kralovice (CZSTK)"
  },
  {
   value: "Kralupy nad Vltavou (CZKNV)",
   label: "Kralupy nad Vltavou (CZKNV)"
  },
  {
   value: "Krasejovka (CZRAS)",
   label: "Krasejovka (CZRAS)"
  },
  {
   value: "Kraslice (CZKKE)",
   label: "Kraslice (CZKKE)"
  },
  {
   value: "Krásná (CZKSA)",
   label: "Krásná (CZKSA)"
  },
  {
   value: "Krasna Lipa (CZUKA)",
   label: "Krasna Lipa (CZUKA)"
  },
  {
   value: "Kresice (CZKRE)",
   label: "Kresice (CZKRE)"
  },
  {
   value: "Krinec (CZKRI)",
   label: "Krinec (CZKRI)"
  },
  {
   value: "JetYichov (CZJTV)",
   label: "JetYichov (CZJTV)"
  },
  {
   value: "Jevicko (CZJEV)",
   label: "Jevicko (CZJEV)"
  },
  {
   value: "Jevisovice (CZJIE)",
   label: "Jevisovice (CZJIE)"
  },
  {
   value: "Jilemnice (CZJIL)",
   label: "Jilemnice (CZJIL)"
  },
  {
   value: "Jilove (CZJVE)",
   label: "Jilove (CZJVE)"
  },
  {
   value: "Jílové u Prahy (CZJPR)",
   label: "Jílové u Prahy (CZJPR)"
  },
  {
   value: "Jirny (CZJRN)",
   label: "Jirny (CZJRN)"
  },
  {
   value: "Kadan (CZKAD)",
   label: "Kadan (CZKAD)"
  },
  {
   value: "Kamenice Nad Lipou (CZKNL)",
   label: "Kamenice Nad Lipou (CZKNL)"
  },
  {
   value: "Kamenický Senov (CZKSV)",
   label: "Kamenický Senov (CZKSV)"
  },
  {
   value: "Kamenná (CZKMN)",
   label: "Kamenná (CZKMN)"
  },
  {
   value: "Kamyk nad Vltavou (CZKVO)",
   label: "Kamyk nad Vltavou (CZKVO)"
  },
  {
   value: "Karany (CZSYA)",
   label: "Karany (CZSYA)"
  },
  {
   value: "Karlín (CZKAR)",
   label: "Karlín (CZKAR)"
  },
  {
   value: "Karolinka (CZKUV)",
   label: "Karolinka (CZKUV)"
  },
  {
   value: "Karvina-Doly (CZKDL)",
   label: "Karvina-Doly (CZKDL)"
  },
  {
   value: "Kasejovice (CZPKE)",
   label: "Kasejovice (CZPKE)"
  },
  {
   value: "Kaznejov (CZKJV)",
   label: "Kaznejov (CZKJV)"
  },
  {
   value: "Kdyne (CZKDY)",
   label: "Kdyne (CZKDY)"
  },
  {
   value: "Kelc (CZKEL)",
   label: "Kelc (CZKEL)"
  },
  {
   value: "Kladruby Nad Labem (CZKNM)",
   label: "Kladruby Nad Labem (CZKNM)"
  },
  {
   value: "Klásterec nad Ohrí (CZKNO)",
   label: "Klásterec nad Ohrí (CZKNO)"
  },
  {
   value: "Klásterec nad Orlicí (CZKCC)",
   label: "Klásterec nad Orlicí (CZKCC)"
  },
  {
   value: "Klecany (CZSYK)",
   label: "Klecany (CZSYK)"
  },
  {
   value: "Klimkovice (CZKMK)",
   label: "Klimkovice (CZKMK)"
  },
  {
   value: "Klobouky U Brna (CZJLA)",
   label: "Klobouky U Brna (CZJLA)"
  },
  {
   value: "Knezeves (CZKZE)",
   label: "Knezeves (CZKZE)"
  },
  {
   value: "Hradek (CZDEK)",
   label: "Hradek (CZDEK)"
  },
  {
   value: "Hrádek nad Nisou (CZHUA)",
   label: "Hrádek nad Nisou (CZHUA)"
  },
  {
   value: "Hrádek u Rokycan (CZHDR)",
   label: "Hrádek u Rokycan (CZHDR)"
  },
  {
   value: "Hradesin (CZHRN)",
   label: "Hradesin (CZHRN)"
  },
  {
   value: "Hradistko (CZHLT)",
   label: "Hradistko (CZHLT)"
  },
  {
   value: "Hranice (CZHNI)",
   label: "Hranice (CZHNI)"
  },
  {
   value: "Hranice na Morave (CZPHM)",
   label: "Hranice na Morave (CZPHM)"
  },
  {
   value: "Hronov (CZHNV)",
   label: "Hronov (CZHNV)"
  },
  {
   value: "Hrotovice (CZVHE)",
   label: "Hrotovice (CZVHE)"
  },
  {
   value: "Hroznetin (CZKHN)",
   label: "Hroznetin (CZKHN)"
  },
  {
   value: "Hruba Vrbka (CZHUV)",
   label: "Hruba Vrbka (CZHUV)"
  },
  {
   value: "Hrubcice (CZHRB)",
   label: "Hrubcice (CZHRB)"
  },
  {
   value: "Hrusky\/Breclav (CZHRU)",
   label: "Hrusky\/Breclav (CZHRU)"
  },
  {
   value: "Hrusovany u Brna (CZHUB)",
   label: "Hrusovany u Brna (CZHUB)"
  },
  {
   value: "Hudlice (CZHUD)",
   label: "Hudlice (CZHUD)"
  },
  {
   value: "Hulín (CZHUL)",
   label: "Hulín (CZHUL)"
  },
  {
   value: "Humpolec (CZHPC)",
   label: "Humpolec (CZHPC)"
  },
  {
   value: "Husinec (CZHUS)",
   label: "Husinec (CZHUS)"
  },
  {
   value: "Hustopece (CZHPE)",
   label: "Hustopece (CZHPE)"
  },
  {
   value: "Jablonec nad Jizerou (CZJNJ)",
   label: "Jablonec nad Jizerou (CZJNJ)"
  },
  {
   value: "Jablonecké Paseky (CZJPY)",
   label: "Jablonecké Paseky (CZJPY)"
  },
  {
   value: "Jablonné nad Orlicí (CZJAB)",
   label: "Jablonné nad Orlicí (CZJAB)"
  },
  {
   value: "Janovice nad Úhlavou (CZJNU)",
   label: "Janovice nad Úhlavou (CZJNU)"
  },
  {
   value: "Jazlovice (CZJZY)",
   label: "Jazlovice (CZJZY)"
  },
  {
   value: "Jemnice (CZVJE)",
   label: "Jemnice (CZVJE)"
  },
  {
   value: "Jencice (CZJEN)",
   label: "Jencice (CZJEN)"
  },
  {
   value: "Jenec (CZJNC)",
   label: "Jenec (CZJNC)"
  },
  {
   value: "Jenstejn (CZJST)",
   label: "Jenstejn (CZJST)"
  },
  {
   value: "Jesenice (CZJES)",
   label: "Jesenice (CZJES)"
  },
  {
   value: "Jesenice (CZJNE)",
   label: "Jesenice (CZJNE)"
  },
  {
   value: "Hnevice (CZHVI)",
   label: "Hnevice (CZHVI)"
  },
  {
   value: "Hnevotín (CZHNE)",
   label: "Hnevotín (CZHNE)"
  },
  {
   value: "Hnojni (CZHNO)",
   label: "Hnojni (CZHNO)"
  },
  {
   value: "Hodkovice nad Mohelkou (CZHOM)",
   label: "Hodkovice nad Mohelkou (CZHOM)"
  },
  {
   value: "Hodkovice Praha Zapad (CZHOP)",
   label: "Hodkovice Praha Zapad (CZHOP)"
  },
  {
   value: "Holice (CZHCE)",
   label: "Holice (CZHCE)"
  },
  {
   value: "Holice (CZHLC)",
   label: "Holice (CZHLC)"
  },
  {
   value: "Holoubkov (CZHOO)",
   label: "Holoubkov (CZHOO)"
  },
  {
   value: "Holubice (CZYHO)",
   label: "Holubice (CZYHO)"
  },
  {
   value: "Horice (CZHRP)",
   label: "Horice (CZHRP)"
  },
  {
   value: "Horka u Stare Paky (CZLHY)",
   label: "Horka u Stare Paky (CZLHY)"
  },
  {
   value: "Horní Benesov (CZHOB)",
   label: "Horní Benesov (CZHOB)"
  },
  {
   value: "Horní Bríza (CZHBA)",
   label: "Horní Bríza (CZHBA)"
  },
  {
   value: "Horní Cerekev (CZHCV)",
   label: "Horní Cerekev (CZHCV)"
  },
  {
   value: "Horni Jiretin (CZHJI)",
   label: "Horni Jiretin (CZHJI)"
  },
  {
   value: "Horni Pocaply (CZSHY)",
   label: "Horni Pocaply (CZSHY)"
  },
  {
   value: "Horní Slavkov (CZHSO)",
   label: "Horní Slavkov (CZHSO)"
  },
  {
   value: "Horni Stepanov (CZHSP)",
   label: "Horni Stepanov (CZHSP)"
  },
  {
   value: "Horní Suchá (CZHSU)",
   label: "Horní Suchá (CZHSU)"
  },
  {
   value: "Horni Tasovice (CZHTE)",
   label: "Horni Tasovice (CZHTE)"
  },
  {
   value: "Horni Tresnovec (CZHTV)",
   label: "Horni Tresnovec (CZHTV)"
  },
  {
   value: "Horovice (CZHRV)",
   label: "Horovice (CZHRV)"
  },
  {
   value: "Horsovsky Tyn (CZHKT)",
   label: "Horsovsky Tyn (CZHKT)"
  },
  {
   value: "Hory (CZHRY)",
   label: "Hory (CZHRY)"
  },
  {
   value: "Hostinne (CZHST)",
   label: "Hostinne (CZHST)"
  },
  {
   value: "Hostivice (CZHVE)",
   label: "Hostivice (CZHVE)"
  },
  {
   value: "Hostomice (CZHOT)",
   label: "Hostomice (CZHOT)"
  },
  {
   value: "Hradec-nad-Moravici (CZHRM)",
   label: "Hradec-nad-Moravici (CZHRM)"
  },
  {
   value: "Dubnice (CZDBN)",
   label: "Dubnice (CZDBN)"
  },
  {
   value: "Duchcov (CZDUC)",
   label: "Duchcov (CZDUC)"
  },
  {
   value: "Dukovany (CZDOV)",
   label: "Dukovany (CZDOV)"
  },
  {
   value: "Dymokury (CZDYM)",
   label: "Dymokury (CZDYM)"
  },
  {
   value: "Dysina (CZDYY)",
   label: "Dysina (CZDYY)"
  },
  {
   value: "Ejpovice (CZEJP)",
   label: "Ejpovice (CZEJP)"
  },
  {
   value: "Frantiskov nad Ploucnici (CZFNP)",
   label: "Frantiskov nad Ploucnici (CZFNP)"
  },
  {
   value: "Frantiskovy Lazne (CZFLZ)",
   label: "Frantiskovy Lazne (CZFLZ)"
  },
  {
   value: "Frenstát pod Radhostem (CZFRT)",
   label: "Frenstát pod Radhostem (CZFRT)"
  },
  {
   value: "Frydlant nad Ostravici (CZMFI)",
   label: "Frydlant nad Ostravici (CZMFI)"
  },
  {
   value: "Frystak (CZFTK)",
   label: "Frystak (CZFTK)"
  },
  {
   value: "Golcuv Jeníkov (CZGOL)",
   label: "Golcuv Jeníkov (CZGOL)"
  },
  {
   value: "Grygov (CZGGV)",
   label: "Grygov (CZGGV)"
  },
  {
   value: "Habartice (CZHTA)",
   label: "Habartice (CZHTA)"
  },
  {
   value: "Haje nad Jizerou (CZHNJ)",
   label: "Haje nad Jizerou (CZHNJ)"
  },
  {
   value: "Halenkov (CZHAL)",
   label: "Halenkov (CZHAL)"
  },
  {
   value: "Havírov (CZHAV)",
   label: "Havírov (CZHAV)"
  },
  {
   value: "Havlíckova Borová (CZHBV)",
   label: "Havlíckova Borová (CZHBV)"
  },
  {
   value: "Hejnice (CZHJC)",
   label: "Hejnice (CZHJC)"
  },
  {
   value: "Hermanova Hut (CZHER)",
   label: "Hermanova Hut (CZHER)"
  },
  {
   value: "Hermanuv Mestec (CZHMM)",
   label: "Hermanuv Mestec (CZHMM)"
  },
  {
   value: "Hlubocepy (CZHLP)",
   label: "Hlubocepy (CZHLP)"
  },
  {
   value: "Hlubocky (CZHLB)",
   label: "Hlubocky (CZHLB)"
  },
  {
   value: "Hlucin (CZHUC)",
   label: "Hlucin (CZHUC)"
  },
  {
   value: "Hluk (CZHLK)",
   label: "Hluk (CZHLK)"
  },
  {
   value: "Hluk (CZHLU)",
   label: "Hluk (CZHLU)"
  },
  {
   value: "Dacice (CZDCI)",
   label: "Dacice (CZDCI)"
  },
  {
   value: "Dalecín (CZDLC)",
   label: "Dalecín (CZDLC)"
  },
  {
   value: "Dalovice (CZDVI)",
   label: "Dalovice (CZDVI)"
  },
  {
   value: "Dasice (CZPDE)",
   label: "Dasice (CZPDE)"
  },
  {
   value: "Davle (CZDAV)",
   label: "Davle (CZDAV)"
  },
  {
   value: "Destne v Orlickych Horach (CZDOH)",
   label: "Destne v Orlickych Horach (CZDOH)"
  },
  {
   value: "Detmarovice (CZDMV)",
   label: "Detmarovice (CZDMV)"
  },
  {
   value: "Divisov (CZDIS)",
   label: "Divisov (CZDIS)"
  },
  {
   value: "Divisov (CZDIV)",
   label: "Divisov (CZDIV)"
  },
  {
   value: "Dobkovice (CZDKE)",
   label: "Dobkovice (CZDKE)"
  },
  {
   value: "Dobrany (CZDBY)",
   label: "Dobrany (CZDBY)"
  },
  {
   value: "Dobric (CZDOC)",
   label: "Dobric (CZDOC)"
  },
  {
   value: "Dobris (CZDRS)",
   label: "Dobris (CZDRS)"
  },
  {
   value: "Dobrovice (CZSDE)",
   label: "Dobrovice (CZSDE)"
  },
  {
   value: "Dobroviz (CZDDD)",
   label: "Dobroviz (CZDDD)"
  },
  {
   value: "Dobruska (CZKRB)",
   label: "Dobruska (CZKRB)"
  },
  {
   value: "Dolany (CZDLN)",
   label: "Dolany (CZDLN)"
  },
  {
   value: "Dolní Becva (CZDBV)",
   label: "Dolní Becva (CZDBV)"
  },
  {
   value: "Dolní Benesov (CZDOB)",
   label: "Dolní Benesov (CZDOB)"
  },
  {
   value: "Dolní Berkovice (CZBBE)",
   label: "Dolní Berkovice (CZBBE)"
  },
  {
   value: "Dolní Bojanovice (CZDBO)",
   label: "Dolní Bojanovice (CZDBO)"
  },
  {
   value: "Dolní Cetno (CZDCE)",
   label: "Dolní Cetno (CZDCE)"
  },
  {
   value: "Dolní Kalná (CZDKN)",
   label: "Dolní Kalná (CZDKN)"
  },
  {
   value: "Dolní Lhota (CZDOL)",
   label: "Dolní Lhota (CZDOL)"
  },
  {
   value: "Dolni Lhota u Luhacovic (CZDZL)",
   label: "Dolni Lhota u Luhacovic (CZDZL)"
  },
  {
   value: "Dolni Roven (CZPDN)",
   label: "Dolni Roven (CZPDN)"
  },
  {
   value: "Dolni Ujezd (u Prerova) (CZODD)",
   label: "Dolni Ujezd (u Prerova) (CZODD)"
  },
  {
   value: "Drahenice (CZDHE)",
   label: "Drahenice (CZDHE)"
  },
  {
   value: "Drasov (CZDRA)",
   label: "Drasov (CZDRA)"
  },
  {
   value: "Drisy (CZDSY)",
   label: "Drisy (CZDSY)"
  },
  {
   value: "Drnholec (CZDRN)",
   label: "Drnholec (CZDRN)"
  },
  {
   value: "Drzkov (CZDKV)",
   label: "Drzkov (CZDKV)"
  },
  {
   value: "Ceské Kopisty (CZCKP)",
   label: "Ceské Kopisty (CZCKP)"
  },
  {
   value: "Ceské Mezirící (CZCEM)",
   label: "Ceské Mezirící (CZCEM)"
  },
  {
   value: "Cesky Brod (CZCSB)",
   label: "Cesky Brod (CZCSB)"
  },
  {
   value: "Cestlice (CZCCE)",
   label: "Cestlice (CZCCE)"
  },
  {
   value: "Chabarovice (CZCBV)",
   label: "Chabarovice (CZCBV)"
  },
  {
   value: "Chlum (CZCLM)",
   label: "Chlum (CZCLM)"
  },
  {
   value: "Chlumec (CZKRC)",
   label: "Chlumec (CZKRC)"
  },
  {
   value: "Chlumec (CZUSC)",
   label: "Chlumec (CZUSC)"
  },
  {
   value: "Chlumec nad Cidlinou (CZCDC)",
   label: "Chlumec nad Cidlinou (CZCDC)"
  },
  {
   value: "Chocen (CZCCN)",
   label: "Chocen (CZCCN)"
  },
  {
   value: "Chocerady (CZCCD)",
   label: "Chocerady (CZCCD)"
  },
  {
   value: "Chodov (CZCHO)",
   label: "Chodov (CZCHO)"
  },
  {
   value: "Chodová Planá (CZCPL)",
   label: "Chodová Planá (CZCPL)"
  },
  {
   value: "Chornice (CZPCE)",
   label: "Chornice (CZPCE)"
  },
  {
   value: "Chotebor (CZCBO)",
   label: "Chotebor (CZCBO)"
  },
  {
   value: "Chotoviny (CZCOO)",
   label: "Chotoviny (CZCOO)"
  },
  {
   value: "Chrast (CZCHS)",
   label: "Chrast (CZCHS)"
  },
  {
   value: "Chrastava (CZCUL)",
   label: "Chrastava (CZCUL)"
  },
  {
   value: "Chropyne (CZCPY)",
   label: "Chropyne (CZCPY)"
  },
  {
   value: "Chrustenice (CZCHZ)",
   label: "Chrustenice (CZCHZ)"
  },
  {
   value: "Chudobín (CZCHU)",
   label: "Chudobín (CZCHU)"
  },
  {
   value: "Chvaletice (CZCHV)",
   label: "Chvaletice (CZCHV)"
  },
  {
   value: "Chynov (CZCHN)",
   label: "Chynov (CZCHN)"
  },
  {
   value: "Cimelice (CZMCE)",
   label: "Cimelice (CZMCE)"
  },
  {
   value: "Ckyne (CZCHY)",
   label: "Ckyne (CZCHY)"
  },
  {
   value: "Ctineves (CZCTE)",
   label: "Ctineves (CZCTE)"
  },
  {
   value: "Cvikov (CZLCV)",
   label: "Cvikov (CZLCV)"
  },
  {
   value: "Brod nad Labem (CZKBD)",
   label: "Brod nad Labem (CZKBD)"
  },
  {
   value: "Brumov-Bylnice (CZBBY)",
   label: "Brumov-Bylnice (CZBBY)"
  },
  {
   value: "Bruntál (CZBNT)",
   label: "Bruntál (CZBNT)"
  },
  {
   value: "Bubovice (CZBUB)",
   label: "Bubovice (CZBUB)"
  },
  {
   value: "Buchlovice (CZBLV)",
   label: "Buchlovice (CZBLV)"
  },
  {
   value: "Bucovice (CZBCV)",
   label: "Bucovice (CZBCV)"
  },
  {
   value: "Budinek (CZBUD)",
   label: "Budinek (CZBUD)"
  },
  {
   value: "Budisov nad Budisovkou (CZBNB)",
   label: "Budisov nad Budisovkou (CZBNB)"
  },
  {
   value: "Bustehrad (CZBUS)",
   label: "Bustehrad (CZBUS)"
  },
  {
   value: "Bynov (CZBYN)",
   label: "Bynov (CZBYN)"
  },
  {
   value: "Bysice (CZBYS)",
   label: "Bysice (CZBYS)"
  },
  {
   value: "Bystrice (CZBPH)",
   label: "Bystrice (CZBPH)"
  },
  {
   value: "Bystrice nad Pernstejnem (CZBNP)",
   label: "Bystrice nad Pernstejnem (CZBNP)"
  },
  {
   value: "Bystrice pod Hostýnem (CZBYP)",
   label: "Bystrice pod Hostýnem (CZBYP)"
  },
  {
   value: "Bystrocice (CZBYT)",
   label: "Bystrocice (CZBYT)"
  },
  {
   value: "Bzenec (CZBZC)",
   label: "Bzenec (CZBZC)"
  },
  {
   value: "Caslav (CZCSV)",
   label: "Caslav (CZCSV)"
  },
  {
   value: "Castkov (CZCST)",
   label: "Castkov (CZCST)"
  },
  {
   value: "Castolovice (CZCAS)",
   label: "Castolovice (CZCAS)"
  },
  {
   value: "Cebin (CZCBN)",
   label: "Cebin (CZCBN)"
  },
  {
   value: "Celákovice (CZCLK)",
   label: "Celákovice (CZCLK)"
  },
  {
   value: "Cepi (CZCEP)",
   label: "Cepi (CZCEP)"
  },
  {
   value: "Cerekvice nad Loucnou (CZCNL)",
   label: "Cerekvice nad Loucnou (CZCNL)"
  },
  {
   value: "Cerhovice (CZSCE)",
   label: "Cerhovice (CZSCE)"
  },
  {
   value: "Cernice (CZCNI)",
   label: "Cernice (CZCNI)"
  },
  {
   value: "Cernice (CZCRC)",
   label: "Cernice (CZCRC)"
  },
  {
   value: "Cernozice (CZCNZ)",
   label: "Cernozice (CZCNZ)"
  },
  {
   value: "Cernuc (CZCNC)",
   label: "Cernuc (CZCNC)"
  },
  {
   value: "Cervené Janovice (CZCVJ)",
   label: "Cervené Janovice (CZCVJ)"
  },
  {
   value: "Cervený Kostelec (CZCVY)",
   label: "Cervený Kostelec (CZCVY)"
  },
  {
   value: "Ceska Metuje (CZKCE)",
   label: "Ceska Metuje (CZKCE)"
  },
  {
   value: "Ceská Skalice (CZCSK)",
   label: "Ceská Skalice (CZCSK)"
  },
  {
   value: "Bilcice (CZBLC)",
   label: "Bilcice (CZBLC)"
  },
  {
   value: "Bílina (CZBLN)",
   label: "Bílina (CZBLN)"
  },
  {
   value: "Bílovec (CZBIO)",
   label: "Bílovec (CZBIO)"
  },
  {
   value: "Birkov (CZPBV)",
   label: "Birkov (CZPBV)"
  },
  {
   value: "Blatna (CZTNN)",
   label: "Blatna (CZTNN)"
  },
  {
   value: "Blatná (CZBTA)",
   label: "Blatná (CZBTA)"
  },
  {
   value: "Blovice (CZBLO)",
   label: "Blovice (CZBLO)"
  },
  {
   value: "Bohdalice (CZBDC)",
   label: "Bohdalice (CZBDC)"
  },
  {
   value: "Bohdanec (CZBHD)",
   label: "Bohdanec (CZBHD)"
  },
  {
   value: "Bohunovice (CZBVE)",
   label: "Bohunovice (CZBVE)"
  },
  {
   value: "Bohuslavice nad Metuji (CZKBI)",
   label: "Bohuslavice nad Metuji (CZKBI)"
  },
  {
   value: "Bohusovice nad Ohri (CZBSO)",
   label: "Bohusovice nad Ohri (CZBSO)"
  },
  {
   value: "Bojkovice (CZBKV)",
   label: "Bojkovice (CZBKV)"
  },
  {
   value: "Bolatice (CZBLT)",
   label: "Bolatice (CZBLT)"
  },
  {
   value: "Bolatice (CZBOL)",
   label: "Bolatice (CZBOL)"
  },
  {
   value: "Boranovice (CZBRV)",
   label: "Boranovice (CZBRV)"
  },
  {
   value: "Borek (CZPBK)",
   label: "Borek (CZPBK)"
  },
  {
   value: "Boretice (CZBTC)",
   label: "Boretice (CZBTC)"
  },
  {
   value: "Borovany (CZBOV)",
   label: "Borovany (CZBOV)"
  },
  {
   value: "Borsice (CZZBE)",
   label: "Borsice (CZZBE)"
  },
  {
   value: "Borsov nad Vltavou (CZJBU)",
   label: "Borsov nad Vltavou (CZJBU)"
  },
  {
   value: "Branka (CZBUO)",
   label: "Branka (CZBUO)"
  },
  {
   value: "Brankovice (CZBVC)",
   label: "Brankovice (CZBVC)"
  },
  {
   value: "Bremerhaven (CZBRZ)",
   label: "Bremerhaven (CZBRZ)"
  },
  {
   value: "Brezí (CZBZI)",
   label: "Brezí (CZBZI)"
  },
  {
   value: "Breznice (CZBRN)",
   label: "Breznice (CZBRN)"
  },
  {
   value: "Brezník (CZDBZ)",
   label: "Brezník (CZDBZ)"
  },
  {
   value: "Bridlicna (CZBDI)",
   label: "Bridlicna (CZBDI)"
  },
  {
   value: "Brnik (CZBRI)",
   label: "Brnik (CZBRI)"
  },
  {
   value: "Kofinou (CYKPO)",
   label: "Kofinou (CYKPO)"
  },
  {
   value: "Kokkino Trimithia (CYKOK)",
   label: "Kokkino Trimithia (CYKOK)"
  },
  {
   value: "Koloss (CYKOL)",
   label: "Koloss (CYKOL)"
  },
  {
   value: "Kyperounda (CYKYP)",
   label: "Kyperounda (CYKYP)"
  },
  {
   value: "Liopetri (CYLIO)",
   label: "Liopetri (CYLIO)"
  },
  {
   value: "Makedonitissa (CYMDS)",
   label: "Makedonitissa (CYMDS)"
  },
  {
   value: "Nicosia Free Area (CYNFA)",
   label: "Nicosia Free Area (CYNFA)"
  },
  {
   value: "Ormidia (CYORM)",
   label: "Ormidia (CYORM)"
  },
  {
   value: "Peyeia (CYPYA)",
   label: "Peyeia (CYPYA)"
  },
  {
   value: "Pyrgos Lemesou (CYPLU)",
   label: "Pyrgos Lemesou (CYPLU)"
  },
  {
   value: "Tersefanou (CYNOU)",
   label: "Tersefanou (CYNOU)"
  },
  {
   value: "Xylotymbou (CYXLT)",
   label: "Xylotymbou (CYXLT)"
  },
  {
   value: "Adamov (CZAMV)",
   label: "Adamov (CZAMV)"
  },
  {
   value: "Antoninuv Dul (CZKAL)",
   label: "Antoninuv Dul (CZKAL)"
  },
  {
   value: "Babice (CZBBC)",
   label: "Babice (CZBBC)"
  },
  {
   value: "Bakov nad Jizerou (CZBAJ)",
   label: "Bakov nad Jizerou (CZBAJ)"
  },
  {
   value: "Batelov (CZBTV)",
   label: "Batelov (CZBTV)"
  },
  {
   value: "Bechyne (CZBEE)",
   label: "Bechyne (CZBEE)"
  },
  {
   value: "Bela nad Radbuzou (CZBNR)",
   label: "Bela nad Radbuzou (CZBNR)"
  },
  {
   value: "Belá pod Bezdezem (CZBPB)",
   label: "Belá pod Bezdezem (CZBPB)"
  },
  {
   value: "Benátky nad Jizerou (CZBNJ)",
   label: "Benátky nad Jizerou (CZBNJ)"
  },
  {
   value: "Benesov nad Ploucnici (CZUBI)",
   label: "Benesov nad Ploucnici (CZUBI)"
  },
  {
   value: "Bezno (CZBZN)",
   label: "Bezno (CZBZN)"
  },
  {
   value: ".CAPE VERDE (CV)",
   label: ".CAPE VERDE (CV)"
  },
  {
   value: "Boa Vista (CVBVC)",
   label: "Boa Vista (CVBVC)"
  },
  {
   value: "Porto Grande (CVGRA)",
   label: "Porto Grande (CVGRA)"
  },
  {
   value: "Santo Antao (CVNTO)",
   label: "Santo Antao (CVNTO)"
  },
  {
   value: ".CHRISTMAS ISLAND (CX)",
   label: ".CHRISTMAS ISLAND (CX)"
  },
  {
   value: ".CYPRUS (CY)",
   label: ".CYPRUS (CY)"
  },
  {
   value: "Ayia Napa (CYAYI)",
   label: "Ayia Napa (CYAYI)"
  },
  {
   value: "Ayia Varvara (CYAVA)",
   label: "Ayia Varvara (CYAVA)"
  },
  {
   value: "Dherinia (CYDRA)",
   label: "Dherinia (CYDRA)"
  },
  {
   value: "Ergates (CYERG)",
   label: "Ergates (CYERG)"
  },
  {
   value: "Famagusta Free Area (CYFFA)",
   label: "Famagusta Free Area (CYFFA)"
  },
  {
   value: "Geroskipou (CYSKP)",
   label: "Geroskipou (CYSKP)"
  },
  {
   value: "Kapparis (CYKAP)",
   label: "Kapparis (CYKAP)"
  },
  {
   value: "Havana = La Habana (CU)",
   label: "Havana = La Habana (CU)"
  },
  {
   value: "Mayajigua (CUMJG)",
   label: "Mayajigua (CUMJG)"
  },
  {
   value: "Palo Alto (CUPAL)",
   label: "Palo Alto (CUPAL)"
  },
  {
   value: "Pinar del Rio (CUQPD)",
   label: "Pinar del Rio (CUQPD)"
  },
  {
   value: "Preston (CUPST)",
   label: "Preston (CUPST)"
  },
  {
   value: "Punta Alegre (CUUPA)",
   label: "Punta Alegre (CUUPA)"
  },
  {
   value: "San Julian (CUSNJ)",
   label: "San Julian (CUSNJ)"
  },
  {
   value: "Varadero (CUVRA)",
   label: "Varadero (CUVRA)"
  },
  {
   value: "Tamarindo (CRTAM)",
   label: "Tamarindo (CRTAM)"
  },
  {
   value: "Tambor (CRTBR)",
   label: "Tambor (CRTBR)"
  },
  {
   value: "Tejar (CRTJR)",
   label: "Tejar (CRTJR)"
  },
  {
   value: "Tres Ríos (CRTRE)",
   label: "Tres Ríos (CRTRE)"
  },
  {
   value: "Turrialba (CRTUR)",
   label: "Turrialba (CRTUR)"
  },
  {
   value: "Turrubares (CRTUA)",
   label: "Turrubares (CRTUA)"
  },
  {
   value: "Ujarrás (CRUJA)",
   label: "Ujarrás (CRUJA)"
  },
  {
   value: "Ujarrás&nbsp; (CRURS)",
   label: "Ujarrás&nbsp; (CRURS)"
  },
  {
   value: "Upala (CRUPA)",
   label: "Upala (CRUPA)"
  },
  {
   value: "Veracruz (CRPVZ)",
   label: "Veracruz (CRPVZ)"
  },
  {
   value: "Zarcero \/ Naranjo (CRZAR)",
   label: "Zarcero \/ Naranjo (CRZAR)"
  },
  {
   value: "Indjija (CSVOI)",
   label: "Indjija (CSVOI)"
  },
  {
   value: "Nova Pazova (CSNPA)",
   label: "Nova Pazova (CSNPA)"
  },
  {
   value: "Pljevlja (CSPLJ)",
   label: "Pljevlja (CSPLJ)"
  },
  {
   value: "Senta (CSSEN)",
   label: "Senta (CSSEN)"
  },
  {
   value: "Vladimirovac (CSVDR)",
   label: "Vladimirovac (CSVDR)"
  },
  {
   value: "Voganj (CSVOG)",
   label: "Voganj (CSVOG)"
  },
  {
   value: "Cayo Largo del Sur (CUCYO)",
   label: "Cayo Largo del Sur (CUCYO)"
  },
  {
   value: "Gibara (CUGIB)",
   label: "Gibara (CUGIB)"
  },
  {
   value: "Quepos (CRQPS)",
   label: "Quepos (CRQPS)"
  },
  {
   value: "Río Cuarto (CRRCD)",
   label: "Río Cuarto (CRRCD)"
  },
  {
   value: "Río Frío (CRRIO)",
   label: "Río Frío (CRRIO)"
  },
  {
   value: "Rio Jimenez (CRRJI)",
   label: "Rio Jimenez (CRRJI)"
  },
  {
   value: "Rio Segundo (CRRIS)",
   label: "Rio Segundo (CRRIS)"
  },
  {
   value: "Salinas (CRSLN)",
   label: "Salinas (CRSLN)"
  },
  {
   value: "Sámara (CRSAM)",
   label: "Sámara (CRSAM)"
  },
  {
   value: "San Carlos (CRSCS)",
   label: "San Carlos (CRSCS)"
  },
  {
   value: "San Ignacio de Acosta (CRSAN)",
   label: "San Ignacio de Acosta (CRSAN)"
  },
  {
   value: "San Isidro (CRSIS)",
   label: "San Isidro (CRSIS)"
  },
  {
   value: "San Isidro de Penas Blancas (CRSIO)",
   label: "San Isidro de Penas Blancas (CRSIO)"
  },
  {
   value: "San Isidro del General (CRSSG)",
   label: "San Isidro del General (CRSSG)"
  },
  {
   value: "San Marcos de Tarrazu (CRMTZ)",
   label: "San Marcos de Tarrazu (CRMTZ)"
  },
  {
   value: "San Pablo de Turrubares (CRSPT)",
   label: "San Pablo de Turrubares (CRSPT)"
  },
  {
   value: "San Pedro de Poas (CRSSP)",
   label: "San Pedro de Poas (CRSSP)"
  },
  {
   value: "San Rafael Guatuso (CRSRG)",
   label: "San Rafael Guatuso (CRSRG)"
  },
  {
   value: "Sandoval (CRSVL)",
   label: "Sandoval (CRSVL)"
  },
  {
   value: "Santa Ana (CRANA)",
   label: "Santa Ana (CRANA)"
  },
  {
   value: "Santa Cruz (CRSCZ)",
   label: "Santa Cruz (CRSCZ)"
  },
  {
   value: "Santa Cruz (CRSSC)",
   label: "Santa Cruz (CRSSC)"
  },
  {
   value: "Santa Maria de Dota (CRSMD)",
   label: "Santa Maria de Dota (CRSMD)"
  },
  {
   value: "Santa Maria\/Pocosol (CRSMP)",
   label: "Santa Maria\/Pocosol (CRSMP)"
  },
  {
   value: "Santa Rosa de Pocosol (CRASL)",
   label: "Santa Rosa de Pocosol (CRASL)"
  },
  {
   value: "Santa Rosa\/Pocosol (CRSRP)",
   label: "Santa Rosa\/Pocosol (CRSRP)"
  },
  {
   value: "Santiago de Puriscal (CRSPU)",
   label: "Santiago de Puriscal (CRSPU)"
  },
  {
   value: "Sarapiquí (CRSPI)",
   label: "Sarapiquí (CRSPI)"
  },
  {
   value: "Sarchí (CRSRI)",
   label: "Sarchí (CRSRI)"
  },
  {
   value: "Sardinal (CRSAR)",
   label: "Sardinal (CRSAR)"
  },
  {
   value: "Siquirres (CRSQR)",
   label: "Siquirres (CRSQR)"
  },
  {
   value: "Sixaola\/Talamanca (CRSIX)",
   label: "Sixaola\/Talamanca (CRSIX)"
  },
  {
   value: "La Tigra (CRLTA)",
   label: "La Tigra (CRLTA)"
  },
  {
   value: "La Tigra (CRTIG)",
   label: "La Tigra (CRTIG)"
  },
  {
   value: "La Uruca (CRLUC)",
   label: "La Uruca (CRLUC)"
  },
  {
   value: "Las Canas (CRLCS)",
   label: "Las Canas (CRLCS)"
  },
  {
   value: "Las Huacas (CRLHS)",
   label: "Las Huacas (CRLHS)"
  },
  {
   value: "Laurel (CRPLL)",
   label: "Laurel (CRPLL)"
  },
  {
   value: "Limon Via Turrialba (CRLLA)",
   label: "Limon Via Turrialba (CRLLA)"
  },
  {
   value: "Limonal (CRLIM)",
   label: "Limonal (CRLIM)"
  },
  {
   value: "Matina (CRMAT)",
   label: "Matina (CRMAT)"
  },
  {
   value: "Muelle de San Carlos (CRMUE)",
   label: "Muelle de San Carlos (CRMUE)"
  },
  {
   value: "Nandayure (CRNAN)",
   label: "Nandayure (CRNAN)"
  },
  {
   value: "Naranjo (CRNAR)",
   label: "Naranjo (CRNAR)"
  },
  {
   value: "Neily (CRNLY)",
   label: "Neily (CRNLY)"
  },
  {
   value: "Orotina (CRORO)",
   label: "Orotina (CRORO)"
  },
  {
   value: "Pacayas (CRCPS)",
   label: "Pacayas (CRCPS)"
  },
  {
   value: "Palmar Norte (CRPAN)",
   label: "Palmar Norte (CRPAN)"
  },
  {
   value: "Palmares (CRPAL)",
   label: "Palmares (CRPAL)"
  },
  {
   value: "Palmares (CRPAM)",
   label: "Palmares (CRPAM)"
  },
  {
   value: "Parrita (CRPAR)",
   label: "Parrita (CRPAR)"
  },
  {
   value: "Penshurst (CRPEN)",
   label: "Penshurst (CRPEN)"
  },
  {
   value: "Pilas de Canjel (CRPIL)",
   label: "Pilas de Canjel (CRPIL)"
  },
  {
   value: "Pital (CRPIT)",
   label: "Pital (CRPIT)"
  },
  {
   value: "Pital (CRPTL)",
   label: "Pital (CRPTL)"
  },
  {
   value: "Pital Con Desvio (CRAPO)",
   label: "Pital Con Desvio (CRAPO)"
  },
  {
   value: "Playa Hermosa (CRCPA)",
   label: "Playa Hermosa (CRCPA)"
  },
  {
   value: "Poas (CRPOA)",
   label: "Poas (CRPOA)"
  },
  {
   value: "Pocora (CRPOC)",
   label: "Pocora (CRPOC)"
  },
  {
   value: "Pto Caldera (CRPTC)",
   label: "Pto Caldera (CRPTC)"
  },
  {
   value: "Pto Moin (CRPMN)",
   label: "Pto Moin (CRPMN)"
  },
  {
   value: "Puerto Viejo (CRVDT)",
   label: "Puerto Viejo (CRVDT)"
  },
  {
   value: "Buenos Aires (CRBAI)",
   label: "Buenos Aires (CRBAI)"
  },
  {
   value: "Cabo Blanco (CRCAB)",
   label: "Cabo Blanco (CRCAB)"
  },
  {
   value: "Caimital (CRCAI)",
   label: "Caimital (CRCAI)"
  },
  {
   value: "Canas (CRCSC)",
   label: "Canas (CRCSC)"
  },
  {
   value: "Cañas (CRCAS)",
   label: "Cañas (CRCAS)"
  },
  {
   value: "Capulín (CRCAP)",
   label: "Capulín (CRCAP)"
  },
  {
   value: "Chachagua (CRCHA)",
   label: "Chachagua (CRCHA)"
  },
  {
   value: "Chomes (CRCOM)",
   label: "Chomes (CRCOM)"
  },
  {
   value: "Ciruelas (CRCIR)",
   label: "Ciruelas (CRCIR)"
  },
  {
   value: "Ciudad Colon (CRCCN)",
   label: "Ciudad Colon (CRCCN)"
  },
  {
   value: "Ciudad Neily (CRCDN)",
   label: "Ciudad Neily (CRCDN)"
  },
  {
   value: "Ciudad Quesada (CRCQA)",
   label: "Ciudad Quesada (CRCQA)"
  },
  {
   value: "Coronado (CRCOR)",
   label: "Coronado (CRCOR)"
  },
  {
   value: "Coyol (CRCYL)",
   label: "Coyol (CRCYL)"
  },
  {
   value: "Curridabat (CRCRR)",
   label: "Curridabat (CRCRR)"
  },
  {
   value: "Escazú (CRESC)",
   label: "Escazú (CRESC)"
  },
  {
   value: "Filadelfia (CRFIL)",
   label: "Filadelfia (CRFIL)"
  },
  {
   value: "Florencia de San Carlos (CRAFS)",
   label: "Florencia de San Carlos (CRAFS)"
  },
  {
   value: "Fraijanes (CRFPN)",
   label: "Fraijanes (CRFPN)"
  },
  {
   value: "Francia (CRFRA)",
   label: "Francia (CRFRA)"
  },
  {
   value: "Golfo de Papagayo (CRGDP)",
   label: "Golfo de Papagayo (CRGDP)"
  },
  {
   value: "Guacimo (CRGUC)",
   label: "Guacimo (CRGUC)"
  },
  {
   value: "Guápiles (CRCPL)",
   label: "Guápiles (CRCPL)"
  },
  {
   value: "Guardia (CRGDA)",
   label: "Guardia (CRGDA)"
  },
  {
   value: "Guatuso (CRGUA)",
   label: "Guatuso (CRGUA)"
  },
  {
   value: "Horluetas\/Sarapiqui (CRHSA)",
   label: "Horluetas\/Sarapiqui (CRHSA)"
  },
  {
   value: "Jacó (CRJAC)",
   label: "Jacó (CRJAC)"
  },
  {
   value: "Jicaral (CRJIC)",
   label: "Jicaral (CRJIC)"
  },
  {
   value: "Jimenez (CRJIM)",
   label: "Jimenez (CRJIM)"
  },
  {
   value: "La Cruz (CRLCZ)",
   label: "La Cruz (CRLCZ)"
  },
  {
   value: "La Fortuna (CRLAF)",
   label: "La Fortuna (CRLAF)"
  },
  {
   value: "La Lucha (CRLLC)",
   label: "La Lucha (CRLLC)"
  },
  {
   value: "Since (COSIN)",
   label: "Since (COSIN)"
  },
  {
   value: "Sogamoso (COSOX)",
   label: "Sogamoso (COSOX)"
  },
  {
   value: "Solita (COSOH)",
   label: "Solita (COSOH)"
  },
  {
   value: "Tablon de Tamara (COTTM)",
   label: "Tablon de Tamara (COTTM)"
  },
  {
   value: "Tame (COTAM)",
   label: "Tame (COTAM)"
  },
  {
   value: "Tame (COTME)",
   label: "Tame (COTME)"
  },
  {
   value: "Tauramena (COTAU)",
   label: "Tauramena (COTAU)"
  },
  {
   value: "Tres Esquinas (COTQS)",
   label: "Tres Esquinas (COTQS)"
  },
  {
   value: "Trinidad (COTDA)",
   label: "Trinidad (COTDA)"
  },
  {
   value: "Tulua (COULQ)",
   label: "Tulua (COULQ)"
  },
  {
   value: "Tunja (COTUN)",
   label: "Tunja (COTUN)"
  },
  {
   value: "Umbita (COUMB)",
   label: "Umbita (COUMB)"
  },
  {
   value: "Unguia (COUNC)",
   label: "Unguia (COUNC)"
  },
  {
   value: "Uribe (COURI)",
   label: "Uribe (COURI)"
  },
  {
   value: "Urrao (COURR)",
   label: "Urrao (COURR)"
  },
  {
   value: "Villapinzon (COVPZ)",
   label: "Villapinzon (COVPZ)"
  },
  {
   value: "Villavicencio (COVVC)",
   label: "Villavicencio (COVVC)"
  },
  {
   value: "Yumbo (COYMB)",
   label: "Yumbo (COYMB)"
  },
  {
   value: ".COSTA RICA (CR)",
   label: ".COSTA RICA (CR)"
  },
  {
   value: "Abangares (CRABG)",
   label: "Abangares (CRABG)"
  },
  {
   value: "Abangaritos (CRABA)",
   label: "Abangaritos (CRABA)"
  },
  {
   value: "Aguas Zarcas (CRAGU)",
   label: "Aguas Zarcas (CRAGU)"
  },
  {
   value: "Aguas Zarcas (CRAZA)",
   label: "Aguas Zarcas (CRAZA)"
  },
  {
   value: "Alajuelita (CRALI)",
   label: "Alajuelita (CRALI)"
  },
  {
   value: "Altamira (CRATM)",
   label: "Altamira (CRATM)"
  },
  {
   value: "Aranjuez (CRAJZ)",
   label: "Aranjuez (CRAJZ)"
  },
  {
   value: "Atenas (CRATE)",
   label: "Atenas (CRATE)"
  },
  {
   value: "Bagaces (CRBAG)",
   label: "Bagaces (CRBAG)"
  },
  {
   value: "Barbudal (CRBBD)",
   label: "Barbudal (CRBBD)"
  },
  {
   value: "Barranca (CRBAR)",
   label: "Barranca (CRBAR)"
  },
  {
   value: "Barranca (CRBNC)",
   label: "Barranca (CRBNC)"
  },
  {
   value: "Barrial (CRBRL)",
   label: "Barrial (CRBRL)"
  },
  {
   value: "Batan (CRBAT)",
   label: "Batan (CRBAT)"
  },
  {
   value: "Bri Bri (CRBRI)",
   label: "Bri Bri (CRBRI)"
  },
  {
   value: "Puerto Gaitan (COPGA)",
   label: "Puerto Gaitan (COPGA)"
  },
  {
   value: "Puerto Gaitan (COPUG)",
   label: "Puerto Gaitan (COPUG)"
  },
  {
   value: "Puerto Limón (COPNM)",
   label: "Puerto Limón (COPNM)"
  },
  {
   value: "Puerto Limón (COPUL)",
   label: "Puerto Limón (COPUL)"
  },
  {
   value: "Puerto Lleras (COPLL)",
   label: "Puerto Lleras (COPLL)"
  },
  {
   value: "Rio Cordoba (CORCO)",
   label: "Rio Cordoba (CORCO)"
  },
  {
   value: "Rionegro (CORRO)",
   label: "Rionegro (CORRO)"
  },
  {
   value: "Rondon (CORON)",
   label: "Rondon (CORON)"
  },
  {
   value: "Samaca (COSAM)",
   label: "Samaca (COSAM)"
  },
  {
   value: "San Gil (COSAG)",
   label: "San Gil (COSAG)"
  },
  {
   value: "San Jose del Gua (COSJE)",
   label: "San Jose del Gua (COSJE)"
  },
  {
   value: "San Juan de Uraba (COSJR)",
   label: "San Juan de Uraba (COSJR)"
  },
  {
   value: "San Juan del Cesar (COSJH)",
   label: "San Juan del Cesar (COSJH)"
  },
  {
   value: "San Luis de Pale (COSQE)",
   label: "San Luis de Pale (COSQE)"
  },
  {
   value: "San Marcos (COSRS)",
   label: "San Marcos (COSRS)"
  },
  {
   value: "San Pedro Jagua (COSJG)",
   label: "San Pedro Jagua (COSJG)"
  },
  {
   value: "San Pedro Uraba (CONPU)",
   label: "San Pedro Uraba (CONPU)"
  },
  {
   value: "San Vincente (COSVI)",
   label: "San Vincente (COSVI)"
  },
  {
   value: "Santa Cantalina (COSCA)",
   label: "Santa Cantalina (COSCA)"
  },
  {
   value: "Santa Fee (COSTF)",
   label: "Santa Fee (COSTF)"
  },
  {
   value: "Santa Maria (COSMC)",
   label: "Santa Maria (COSMC)"
  },
  {
   value: "Santa Rosa (COSAR)",
   label: "Santa Rosa (COSAR)"
  },
  {
   value: "Saravena (CORVE)",
   label: "Saravena (CORVE)"
  },
  {
   value: "Saravena (COSRV)",
   label: "Saravena (COSRV)"
  },
  {
   value: "Simon Bolivar (COPSB)",
   label: "Simon Bolivar (COPSB)"
  },
  {
   value: "Medina (COMND)",
   label: "Medina (COMND)"
  },
  {
   value: "Miraflores (COMFS)",
   label: "Miraflores (COMFS)"
  },
  {
   value: "Miriti (COMIX)",
   label: "Miriti (COMIX)"
  },
  {
   value: "Mitu (COMVP)",
   label: "Mitu (COMVP)"
  },
  {
   value: "Mompos (COMMP)",
   label: "Mompos (COMMP)"
  },
  {
   value: "Moniquira (COTUE)",
   label: "Moniquira (COTUE)"
  },
  {
   value: "Monte Libano (COMOL)",
   label: "Monte Libano (COMOL)"
  },
  {
   value: "Montel Libano (COMTB)",
   label: "Montel Libano (COMTB)"
  },
  {
   value: "Monterrey (COMOY)",
   label: "Monterrey (COMOY)"
  },
  {
   value: "Mosquera (COMQR)",
   label: "Mosquera (COMQR)"
  },
  {
   value: "Mulatos (COULS)",
   label: "Mulatos (COULS)"
  },
  {
   value: "Nare (CONAR)",
   label: "Nare (CONAR)"
  },
  {
   value: "Necocli (CONCI)",
   label: "Necocli (CONCI)"
  },
  {
   value: "Neiva (CONVA)",
   label: "Neiva (CONVA)"
  },
  {
   value: "Nobsa (CONOB)",
   label: "Nobsa (CONOB)"
  },
  {
   value: "Nunchia (CONUH)",
   label: "Nunchia (CONUH)"
  },
  {
   value: "Ocana (COOCV)",
   label: "Ocana (COOCV)"
  },
  {
   value: "Oiba (COOIB)",
   label: "Oiba (COOIB)"
  },
  {
   value: "Orocue (COORC)",
   label: "Orocue (COORC)"
  },
  {
   value: "Otu (COOTU)",
   label: "Otu (COOTU)"
  },
  {
   value: "Palmira (COQPI)",
   label: "Palmira (COQPI)"
  },
  {
   value: "Paratebueno (COEUO)",
   label: "Paratebueno (COEUO)"
  },
  {
   value: "Paz de Ariporo (COPZA)",
   label: "Paz de Ariporo (COPZA)"
  },
  {
   value: "Planadas (COPLA)",
   label: "Planadas (COPLA)"
  },
  {
   value: "Planeta Rica (COPLC)",
   label: "Planeta Rica (COPLC)"
  },
  {
   value: "Plato (COPLT)",
   label: "Plato (COPLT)"
  },
  {
   value: "Pore (COPRE)",
   label: "Pore (COPRE)"
  },
  {
   value: "Providencia (COPVA)",
   label: "Providencia (COPVA)"
  },
  {
   value: "Pto Inirida (COPDA)",
   label: "Pto Inirida (COPDA)"
  },
  {
   value: "Pto Leguizamo (COLQM)",
   label: "Pto Leguizamo (COLQM)"
  },
  {
   value: "Pto Rico (COPCC)",
   label: "Pto Rico (COPCC)"
  },
  {
   value: "El Charco (COECR)",
   label: "El Charco (COECR)"
  },
  {
   value: "El Espino (COEES)",
   label: "El Espino (COEES)"
  },
  {
   value: "El Yopal (COEYP)",
   label: "El Yopal (COEYP)"
  },
  {
   value: "Envigado (COENV)",
   label: "Envigado (COENV)"
  },
  {
   value: "Florencia (COFLA)",
   label: "Florencia (COFLA)"
  },
  {
   value: "Fundacion (COFUN)",
   label: "Fundacion (COFUN)"
  },
  {
   value: "Gamarra (COGAM)",
   label: "Gamarra (COGAM)"
  },
  {
   value: "Gamarra (COGRA)",
   label: "Gamarra (COGRA)"
  },
  {
   value: "Garagoa (COGAR)",
   label: "Garagoa (COGAR)"
  },
  {
   value: "Garzon (COGAZ)",
   label: "Garzon (COGAZ)"
  },
  {
   value: "Gilgal (COGGL)",
   label: "Gilgal (COGGL)"
  },
  {
   value: "Girardot (COGIR)",
   label: "Girardot (COGIR)"
  },
  {
   value: "Guacamaya (COGCA)",
   label: "Guacamaya (COGCA)"
  },
  {
   value: "Guaduas (COGUA)",
   label: "Guaduas (COGUA)"
  },
  {
   value: "Guapi (COGPI)",
   label: "Guapi (COGPI)"
  },
  {
   value: "Guapi (COGUP)",
   label: "Guapi (COGUP)"
  },
  {
   value: "Guaranao (COGST)",
   label: "Guaranao (COGST)"
  },
  {
   value: "Hato Corozal (COHTZ)",
   label: "Hato Corozal (COHTZ)"
  },
  {
   value: "Herrera (COHRR)",
   label: "Herrera (COHRR)"
  },
  {
   value: "Ibaque (COIBE)",
   label: "Ibaque (COIBE)"
  },
  {
   value: "Ipiales (COIPI)",
   label: "Ipiales (COIPI)"
  },
  {
   value: "Iscuande (COISD)",
   label: "Iscuande (COISD)"
  },
  {
   value: "La Dorada (COLAD)",
   label: "La Dorada (COLAD)"
  },
  {
   value: "La Pedrera (COLPD)",
   label: "La Pedrera (COLPD)"
  },
  {
   value: "La Uribe (COLAT)",
   label: "La Uribe (COLAT)"
  },
  {
   value: "Lamacarena (COLMC)",
   label: "Lamacarena (COLMC)"
  },
  {
   value: "Las Gaviotas (COLGT)",
   label: "Las Gaviotas (COLGT)"
  },
  {
   value: "Lejanias (COLEJ)",
   label: "Lejanias (COLEJ)"
  },
  {
   value: "Lorica (COLRI)",
   label: "Lorica (COLRI)"
  },
  {
   value: "Macedonia (COMAC)",
   label: "Macedonia (COMAC)"
  },
  {
   value: "Magangue (COMGN)",
   label: "Magangue (COMGN)"
  },
  {
   value: "Maicao (COMCJ)",
   label: "Maicao (COMCJ)"
  },
  {
   value: "Manaure (COMAU)",
   label: "Manaure (COMAU)"
  },
  {
   value: "Mariquita (COMQU)",
   label: "Mariquita (COMQU)"
  },
  {
   value: "Matanza (COMAT)",
   label: "Matanza (COMAT)"
  },
  {
   value: "Astrea (COASR)",
   label: "Astrea (COASR)"
  },
  {
   value: "Ayacucho (COAYC)",
   label: "Ayacucho (COAYC)"
  },
  {
   value: "Ayapel (COAYA)",
   label: "Ayapel (COAYA)"
  },
  {
   value: "Bahia Solano (COBSC)",
   label: "Bahia Solano (COBSC)"
  },
  {
   value: "Balboa (COBAL)",
   label: "Balboa (COBAL)"
  },
  {
   value: "Barranca de Upia (COBAC)",
   label: "Barranca de Upia (COBAC)"
  },
  {
   value: "Betania (COBET)",
   label: "Betania (COBET)"
  },
  {
   value: "Boca Chica (COBCC)",
   label: "Boca Chica (COBCC)"
  },
  {
   value: "Buga (COBUG)",
   label: "Buga (COBUG)"
  },
  {
   value: "Cachipay (COCAP)",
   label: "Cachipay (COCAP)"
  },
  {
   value: "Caruru (COCUO)",
   label: "Caruru (COCUO)"
  },
  {
   value: "Cauca (COCAU)",
   label: "Cauca (COCAU)"
  },
  {
   value: "Chaparral (COCPL)",
   label: "Chaparral (COCPL)"
  },
  {
   value: "Chivolo (COIVO)",
   label: "Chivolo (COIVO)"
  },
  {
   value: "Cimitarra (COCIM)",
   label: "Cimitarra (COCIM)"
  },
  {
   value: "Codazzi (CODZI)",
   label: "Codazzi (CODZI)"
  },
  {
   value: "Condoto (COCOG)",
   label: "Condoto (COCOG)"
  },
  {
   value: "Corozal (COCZU)",
   label: "Corozal (COCZU)"
  },
  {
   value: "Cravo Norte (CORAV)",
   label: "Cravo Norte (CORAV)"
  },
  {
   value: "Currillo (COCUI)",
   label: "Currillo (COCUI)"
  },
  {
   value: "Dabeiba (CODAB)",
   label: "Dabeiba (CODAB)"
  },
  {
   value: "Durania (CODUR)",
   label: "Durania (CODUR)"
  },
  {
   value: "El Banco (COELB)",
   label: "El Banco (COELB)"
  },
  {
   value: "Zhongxian (CNZXN)",
   label: "Zhongxian (CNZXN)"
  },
  {
   value: "Zhouqujia (CNZQJ)",
   label: "Zhouqujia (CNZQJ)"
  },
  {
   value: "Zhouzhuang (CNZZG)",
   label: "Zhouzhuang (CNZZG)"
  },
  {
   value: "Zhuanghe (CNZAH)",
   label: "Zhuanghe (CNZAH)"
  },
  {
   value: "Zhuanqiao (CNZHQ)",
   label: "Zhuanqiao (CNZHQ)"
  },
  {
   value: "Zhuao (CNZHO)",
   label: "Zhuao (CNZHO)"
  },
  {
   value: "Zhucheng (CNZCH)",
   label: "Zhucheng (CNZCH)"
  },
  {
   value: "Zhuliao (CNZLO)",
   label: "Zhuliao (CNZLO)"
  },
  {
   value: "Zhumadian (CNZHU)",
   label: "Zhumadian (CNZHU)"
  },
  {
   value: "Zhushan (CNZUS)",
   label: "Zhushan (CNZUS)"
  },
  {
   value: "Zhutan (CNZUT)",
   label: "Zhutan (CNZUT)"
  },
  {
   value: "Zhuyang (CNZUY)",
   label: "Zhuyang (CNZUY)"
  },
  {
   value: "Zhuzhou (CNZUU)",
   label: "Zhuzhou (CNZUU)"
  },
  {
   value: "Zichuan (CNZCU)",
   label: "Zichuan (CNZCU)"
  },
  {
   value: "Zigong (CNZGG)",
   label: "Zigong (CNZGG)"
  },
  {
   value: "Ziyuan Pt (CNZIY)",
   label: "Ziyuan Pt (CNZIY)"
  },
  {
   value: "Zongyang (CNZYG)",
   label: "Zongyang (CNZYG)"
  },
  {
   value: "Zoucheng (CNZOC)",
   label: "Zoucheng (CNZOC)"
  },
  {
   value: "Zouping (CNZPG)",
   label: "Zouping (CNZPG)"
  },
  {
   value: "Zouxiang (CNZXJ)",
   label: "Zouxiang (CNZXJ)"
  },
  {
   value: "Zunyi (CNZNY)",
   label: "Zunyi (CNZNY)"
  },
  {
   value: "Zunyi Apt (CNZYI)",
   label: "Zunyi Apt (CNZYI)"
  },
  {
   value: ".COLOMBIA (CO)",
   label: ".COLOMBIA (CO)"
  },
  {
   value: "Acandi (COACD)",
   label: "Acandi (COACD)"
  },
  {
   value: "Agrado (COAGD)",
   label: "Agrado (COAGD)"
  },
  {
   value: "Aguaclara (COACL)",
   label: "Aguaclara (COACL)"
  },
  {
   value: "Andalucia (COAND)",
   label: "Andalucia (COAND)"
  },
  {
   value: "Andes (COADN)",
   label: "Andes (COADN)"
  },
  {
   value: "Araracuara (COACR)",
   label: "Araracuara (COACR)"
  },
  {
   value: "Arauquita (COARQ)",
   label: "Arauquita (COARQ)"
  },
  {
   value: "Arboletas (COARO)",
   label: "Arboletas (COARO)"
  },
  {
   value: "Arica (COACM)",
   label: "Arica (COACM)"
  },
  {
   value: "Zhangcha (CNZGH)",
   label: "Zhangcha (CNZGH)"
  },
  {
   value: "Zhanghu (CNZAG)",
   label: "Zhanghu (CNZAG)"
  },
  {
   value: "Zhangjiabian (CNZJB)",
   label: "Zhangjiabian (CNZJB)"
  },
  {
   value: "Zhangjiabu (CNZJU)",
   label: "Zhangjiabu (CNZJU)"
  },
  {
   value: "Zhangjiakou (CNZJA)",
   label: "Zhangjiakou (CNZJA)"
  },
  {
   value: "Zhangjian (CNZJI)",
   label: "Zhangjian (CNZJI)"
  },
  {
   value: "Zhangqiu (CNZQH)",
   label: "Zhangqiu (CNZQH)"
  },
  {
   value: "Zhangshan (CNZGS)",
   label: "Zhangshan (CNZGS)"
  },
  {
   value: "Zhangshu (CNZHN)",
   label: "Zhangshu (CNZHN)"
  },
  {
   value: "Zhaodong (CNZDO)",
   label: "Zhaodong (CNZDO)"
  },
  {
   value: "Zhaogang (CNZHG)",
   label: "Zhaogang (CNZHG)"
  },
  {
   value: "Zhaoping (CNZPI)",
   label: "Zhaoping (CNZPI)"
  },
  {
   value: "Zhaotong Apt (CNZAT)",
   label: "Zhaotong Apt (CNZAT)"
  },
  {
   value: "Zhaoyuan (CNZHY)",
   label: "Zhaoyuan (CNZHY)"
  },
  {
   value: "Zhaoyuan (CNZYU)",
   label: "Zhaoyuan (CNZYU)"
  },
  {
   value: "Zhapoyouku (CNZPK)",
   label: "Zhapoyouku (CNZPK)"
  },
  {
   value: "Zhapu (CNZAP)",
   label: "Zhapu (CNZAP)"
  },
  {
   value: "Zhengjiatun (CNZJN)",
   label: "Zhengjiatun (CNZJN)"
  },
  {
   value: "Zhenhai (CNZHH)",
   label: "Zhenhai (CNZHH)"
  },
  {
   value: "Zhenzhou (CNZOU)",
   label: "Zhenzhou (CNZOU)"
  },
  {
   value: "Zhexiang (CNZXI)",
   label: "Zhexiang (CNZXI)"
  },
  {
   value: "Zhicheng (CNZCG)",
   label: "Zhicheng (CNZCG)"
  },
  {
   value: "Zhijiang (CNZHI)",
   label: "Zhijiang (CNZHI)"
  },
  {
   value: "Zhijiang Apt\/Huaihua (CNHJJ)",
   label: "Zhijiang Apt\/Huaihua (CNHJJ)"
  },
  {
   value: "Zhongcun (CNZHC)",
   label: "Zhongcun (CNZHC)"
  },
  {
   value: "Zhongguancun (CNZGC)",
   label: "Zhongguancun (CNZGC)"
  },
  {
   value: "Zhongluotan (CNZLN)",
   label: "Zhongluotan (CNZLN)"
  },
  {
   value: "Zhongshan (CNZGA)",
   label: "Zhongshan (CNZGA)"
  },
  {
   value: "Zhongtang (CNZGT)",
   label: "Zhongtang (CNZGT)"
  },
  {
   value: "Yongan (CNYGN)",
   label: "Yongan (CNYGN)"
  },
  {
   value: "Yongfu (CNYFU)",
   label: "Yongfu (CNYFU)"
  },
  {
   value: "Yongji (CNONG)",
   label: "Yongji (CNONG)"
  },
  {
   value: "Yongji (CNYGJ)",
   label: "Yongji (CNYGJ)"
  },
  {
   value: "Yongjia (CNYOJ)",
   label: "Yongjia (CNYOJ)"
  },
  {
   value: "Yongkang (CNYKG)",
   label: "Yongkang (CNYKG)"
  },
  {
   value: "Yonglong (CNYLO)",
   label: "Yonglong (CNYLO)"
  },
  {
   value: "Yongning (CNYNN)",
   label: "Yongning (CNYNN)"
  },
  {
   value: "Yongtai (CNYON)",
   label: "Yongtai (CNYON)"
  },
  {
   value: "Yongxiu (CNYXU)",
   label: "Yongxiu (CNYXU)"
  },
  {
   value: "Yongzhou (CNYZO)",
   label: "Yongzhou (CNYZO)"
  },
  {
   value: "Yongzhou (CNYZS)",
   label: "Yongzhou (CNYZS)"
  },
  {
   value: "Youxi (CNYXI)",
   label: "Youxi (CNYXI)"
  },
  {
   value: "Yuanmou Apt (CNYUA)",
   label: "Yuanmou Apt (CNYUA)"
  },
  {
   value: "Yuanshi (CNYSH)",
   label: "Yuanshi (CNYSH)"
  },
  {
   value: "Yuanzhou (CNYUO)",
   label: "Yuanzhou (CNYUO)"
  },
  {
   value: "Yucheng (CNYCE)",
   label: "Yucheng (CNYCE)"
  },
  {
   value: "Yuecheng (CNYHG)",
   label: "Yuecheng (CNYHG)"
  },
  {
   value: "Yuelai (CNYLA)",
   label: "Yuelai (CNYLA)"
  },
  {
   value: "Yueqing (CNYUE)",
   label: "Yueqing (CNYUE)"
  },
  {
   value: "Yuexiunan (CNYXN)",
   label: "Yuexiunan (CNYXN)"
  },
  {
   value: "Yueyang (CNYUY)",
   label: "Yueyang (CNYUY)"
  },
  {
   value: "Yuhang (CNYHN)",
   label: "Yuhang (CNYHN)"
  },
  {
   value: "Yulin (CNUYN)",
   label: "Yulin (CNUYN)"
  },
  {
   value: "Yulin (CNYUL)",
   label: "Yulin (CNYUL)"
  },
  {
   value: "Yunfu (CNYUF)",
   label: "Yunfu (CNYUF)"
  },
  {
   value: "Yunting (CNYTG)",
   label: "Yunting (CNYTG)"
  },
  {
   value: "Yunyang (CNYYA)",
   label: "Yunyang (CNYYA)"
  },
  {
   value: "Yutai (CNYUI)",
   label: "Yutai (CNYUI)"
  },
  {
   value: "Yuyao (CNYOU)",
   label: "Yuyao (CNYOU)"
  },
  {
   value: "Yuyue Pt (CNYYP)",
   label: "Yuyue Pt (CNYYP)"
  },
  {
   value: "Yuzhou (CNYUZ)",
   label: "Yuzhou (CNYUZ)"
  },
  {
   value: "Yuzhu (CNYZU)",
   label: "Yuzhu (CNYZU)"
  },
  {
   value: "Zaozhuang (CNZOH)",
   label: "Zaozhuang (CNZOH)"
  },
  {
   value: "Yangpu (CNYGP)",
   label: "Yangpu (CNYGP)"
  },
  {
   value: "Yangshan (CNYAN)",
   label: "Yangshan (CNYAN)"
  },
  {
   value: "Yangshan (CNYGS)",
   label: "Yangshan (CNYGS)"
  },
  {
   value: "Yangshan (CNYSN)",
   label: "Yangshan (CNYSN)"
  },
  {
   value: "Yangshufang (CNYSF)",
   label: "Yangshufang (CNYSF)"
  },
  {
   value: "Yangshuo (CNYSO)",
   label: "Yangshuo (CNYSO)"
  },
  {
   value: "Yangxi (CNYGX)",
   label: "Yangxi (CNYGX)"
  },
  {
   value: "Yangxi (CNYXY)",
   label: "Yangxi (CNYXY)"
  },
  {
   value: "Yangxifengtou (CNYXT)",
   label: "Yangxifengtou (CNYXT)"
  },
  {
   value: "Yangzhong (CNYNG)",
   label: "Yangzhong (CNYNG)"
  },
  {
   value: "Yangzhong (CNYZG)",
   label: "Yangzhong (CNYZG)"
  },
  {
   value: "Yanjia (CNYJA)",
   label: "Yanjia (CNYJA)"
  },
  {
   value: "Yanliang (CNYLG)",
   label: "Yanliang (CNYLG)"
  },
  {
   value: "Yantai Pt (CNYTP)",
   label: "Yantai Pt (CNYTP)"
  },
  {
   value: "Yanzhou (CNYHO)",
   label: "Yanzhou (CNYHO)"
  },
  {
   value: "Yaogou (CNYGO)",
   label: "Yaogou (CNYGO)"
  },
  {
   value: "Yaojia Pt (CNYJP)",
   label: "Yaojia Pt (CNYJP)"
  },
  {
   value: "Yibin (CNYBN)",
   label: "Yibin (CNYBN)"
  },
  {
   value: "Yichun (CNYIU)",
   label: "Yichun (CNYIU)"
  },
  {
   value: "Yierkeshi (CNYKS)",
   label: "Yierkeshi (CNYKS)"
  },
  {
   value: "Yierkeshitan (CNYKT)",
   label: "Yierkeshitan (CNYKT)"
  },
  {
   value: "Yilan Apt (CNYLN)",
   label: "Yilan Apt (CNYLN)"
  },
  {
   value: "Yingchuan (CNYCA)",
   label: "Yingchuan (CNYCA)"
  },
  {
   value: "Yingde (CNGTE)",
   label: "Yingde (CNGTE)"
  },
  {
   value: "Yingtan (CNYGT)",
   label: "Yingtan (CNYGT)"
  },
  {
   value: "Yingzi (CNYGZ)",
   label: "Yingzi (CNYGZ)"
  },
  {
   value: "Yishui (CNYHU)",
   label: "Yishui (CNYHU)"
  },
  {
   value: "Yiwu (CNYIW)",
   label: "Yiwu (CNYIW)"
  },
  {
   value: "Yixian (CNYXA)",
   label: "Yixian (CNYXA)"
  },
  {
   value: "Yixing (CNYIX)",
   label: "Yixing (CNYIX)"
  },
  {
   value: "Yizheng (CNYIZ)",
   label: "Yizheng (CNYIZ)"
  },
  {
   value: "Yizhuang (CNYZA)",
   label: "Yizhuang (CNYZA)"
  },
  {
   value: "Xinxing (CNXNI)",
   label: "Xinxing (CNXNI)"
  },
  {
   value: "Xinxing (CNXNX)",
   label: "Xinxing (CNXNX)"
  },
  {
   value: "Xinxu (CNCNX)",
   label: "Xinxu (CNCNX)"
  },
  {
   value: "Xinyi (CNNYI)",
   label: "Xinyi (CNNYI)"
  },
  {
   value: "Xinyi (CNXIY)",
   label: "Xinyi (CNXIY)"
  },
  {
   value: "Xinying (CNXYI)",
   label: "Xinying (CNXYI)"
  },
  {
   value: "Xinying (CNXYY)",
   label: "Xinying (CNXYY)"
  },
  {
   value: "Xinyu (CNSIY)",
   label: "Xinyu (CNSIY)"
  },
  {
   value: "Xinyuan (CNXNY)",
   label: "Xinyuan (CNXNY)"
  },
  {
   value: "Xinyuan (CNXUN)",
   label: "Xinyuan (CNXUN)"
  },
  {
   value: "Xinzao (CNXZO)",
   label: "Xinzao (CNXZO)"
  },
  {
   value: "Xisan (CNXIA)",
   label: "Xisan (CNXIA)"
  },
  {
   value: "Xishuangbanna (CNXSB)",
   label: "Xishuangbanna (CNXSB)"
  },
  {
   value: "Xiulin (CNXUL)",
   label: "Xiulin (CNXUL)"
  },
  {
   value: "Xiuying (CNXYG)",
   label: "Xiuying (CNXYG)"
  },
  {
   value: "Xiuyu (CNXIU)",
   label: "Xiuyu (CNXIU)"
  },
  {
   value: "Xuancheng (CNUAN)",
   label: "Xuancheng (CNUAN)"
  },
  {
   value: "Xuanmen (CNXUM)",
   label: "Xuanmen (CNXUM)"
  },
  {
   value: "Xuanwei (CNXWI)",
   label: "Xuanwei (CNXWI)"
  },
  {
   value: "Xueao (CNXEO)",
   label: "Xueao (CNXEO)"
  },
  {
   value: "Xuejiadao (CNXJD)",
   label: "Xuejiadao (CNXJD)"
  },
  {
   value: "Xuetangzhou (CNXTZ)",
   label: "Xuetangzhou (CNXTZ)"
  },
  {
   value: "Xuhuiqu (CNXUI)",
   label: "Xuhuiqu (CNXUI)"
  },
  {
   value: "Xujiaping Apt\/Enshi (CNENH)",
   label: "Xujiaping Apt\/Enshi (CNENH)"
  },
  {
   value: "Yadong (CNYDZ)",
   label: "Yadong (CNYDZ)"
  },
  {
   value: "Yanbu (CNYBU)",
   label: "Yanbu (CNYBU)"
  },
  {
   value: "Yancheng (CNYCG)",
   label: "Yancheng (CNYCG)"
  },
  {
   value: "Yangchun (CNYCN)",
   label: "Yangchun (CNYCN)"
  },
  {
   value: "Yangjiachang (CNYJC)",
   label: "Yangjiachang (CNYJC)"
  },
  {
   value: "Yangjiang (CNYGG)",
   label: "Yangjiang (CNYGG)"
  },
  {
   value: "Yangkou (CNYGK)",
   label: "Yangkou (CNYGK)"
  },
  {
   value: "Yangkou (CNYKO)",
   label: "Yangkou (CNYKO)"
  },
  {
   value: "Yangli (CNYLI)",
   label: "Yangli (CNYLI)"
  },
  {
   value: "Yangmadao (CNYMD)",
   label: "Yangmadao (CNYMD)"
  },
  {
   value: "Yangpeng (CNYPE)",
   label: "Yangpeng (CNYPE)"
  },
  {
   value: "Xiexu (CNXEX)",
   label: "Xiexu (CNXEX)"
  },
  {
   value: "Xifengzhen Apt\/Qingyang (CNIQN)",
   label: "Xifengzhen Apt\/Qingyang (CNIQN)"
  },
  {
   value: "Xiguan Apt\/Fuyang (CNFYX)",
   label: "Xiguan Apt\/Fuyang (CNFYX)"
  },
  {
   value: "Xili (CNILI)",
   label: "Xili (CNILI)"
  },
  {
   value: "Xiliangshan (CNXLS)",
   label: "Xiliangshan (CNXLS)"
  },
  {
   value: "Xiluzhen (CNXLU)",
   label: "Xiluzhen (CNXLU)"
  },
  {
   value: "Xinan (CNXAN)",
   label: "Xinan (CNXAN)"
  },
  {
   value: "Xinanjiang (CNXJG)",
   label: "Xinanjiang (CNXJG)"
  },
  {
   value: "Xinchang Xian (CNXXI)",
   label: "Xinchang Xian (CNXXI)"
  },
  {
   value: "Xincheng (CNXCH)",
   label: "Xincheng (CNXCH)"
  },
  {
   value: "Xincun (CNXCN)",
   label: "Xincun (CNXCN)"
  },
  {
   value: "Xindi (CNXID)",
   label: "Xindi (CNXID)"
  },
  {
   value: "Xindian (CNXDI)",
   label: "Xindian (CNXDI)"
  },
  {
   value: "Xindu (CNXDU)",
   label: "Xindu (CNXDU)"
  },
  {
   value: "Xingang (CNXGG)",
   label: "Xingang (CNXGG)"
  },
  {
   value: "Xingang (CNXIG)",
   label: "Xingang (CNXIG)"
  },
  {
   value: "Xingang (CNXIP)",
   label: "Xingang (CNXIP)"
  },
  {
   value: "Xingcheng (CNXCE)",
   label: "Xingcheng (CNXCE)"
  },
  {
   value: "Xingcheng (CNXEN)",
   label: "Xingcheng (CNXEN)"
  },
  {
   value: "Xingdong (CNXGD)",
   label: "Xingdong (CNXGD)"
  },
  {
   value: "Xingfeng (CNXNF)",
   label: "Xingfeng (CNXNF)"
  },
  {
   value: "Xinglin (CNXLN)",
   label: "Xinglin (CNXLN)"
  },
  {
   value: "Xingping (CNXPI)",
   label: "Xingping (CNXPI)"
  },
  {
   value: "Xingshan (CNXGS)",
   label: "Xingshan (CNXGS)"
  },
  {
   value: "Xingtai (CNXTI)",
   label: "Xingtai (CNXTI)"
  },
  {
   value: "Xingtan (CNXGT)",
   label: "Xingtan (CNXGT)"
  },
  {
   value: "Xingxiang (CNXXG)",
   label: "Xingxiang (CNXXG)"
  },
  {
   value: "Xinhekou (CNXHK)",
   label: "Xinhekou (CNXHK)"
  },
  {
   value: "Xinhua (CNXNH)",
   label: "Xinhua (CNXNH)"
  },
  {
   value: "Xiniu (CNXNU)",
   label: "Xiniu (CNXNU)"
  },
  {
   value: "Xinjiang (CNXNG)",
   label: "Xinjiang (CNXNG)"
  },
  {
   value: "Xinkai (CNXIK)",
   label: "Xinkai (CNXIK)"
  },
  {
   value: "Xinning (CNNNI)",
   label: "Xinning (CNNNI)"
  },
  {
   value: "Xinqiao (CNXNQ)",
   label: "Xinqiao (CNXNQ)"
  },
  {
   value: "Xinsha (CNXNA)",
   label: "Xinsha (CNXNA)"
  },
  {
   value: "Xinshi (CNXSH)",
   label: "Xinshi (CNXSH)"
  },
  {
   value: "Xintang (CNXIT)",
   label: "Xintang (CNXIT)"
  },
  {
   value: "Xiamen Haicang (CNXMH)",
   label: "Xiamen Haicang (CNXMH)"
  },
  {
   value: "Xiamen Pt (CNXMP)",
   label: "Xiamen Pt (CNXMP)"
  },
  {
   value: "Xiang Shui (CNXHU)",
   label: "Xiang Shui (CNXHU)"
  },
  {
   value: "Xiangang (CNXUG)",
   label: "Xiangang (CNXUG)"
  },
  {
   value: "Xiangfan (CNXFN)",
   label: "Xiangfan (CNXFN)"
  },
  {
   value: "Xianghe (CNXAG)",
   label: "Xianghe (CNXAG)"
  },
  {
   value: "Xiangkou (CNXGK)",
   label: "Xiangkou (CNXGK)"
  },
  {
   value: "Xiangqiao (CNXGQ)",
   label: "Xiangqiao (CNXGQ)"
  },
  {
   value: "Xiangshan (CNXSN)",
   label: "Xiangshan (CNXSN)"
  },
  {
   value: "Xiangshui (CNXSI)",
   label: "Xiangshui (CNXSI)"
  },
  {
   value: "Xiangtan (CNXTA)",
   label: "Xiangtan (CNXTA)"
  },
  {
   value: "Xiangyun (CNXGY)",
   label: "Xiangyun (CNXGY)"
  },
  {
   value: "Xiangzhou (CNXIZ)",
   label: "Xiangzhou (CNXIZ)"
  },
  {
   value: "Xiangzhou (CNXZU)",
   label: "Xiangzhou (CNXZU)"
  },
  {
   value: "Xianju (CNXJU)",
   label: "Xianju (CNXJU)"
  },
  {
   value: "Xianlang (CNXLA)",
   label: "Xianlang (CNXLA)"
  },
  {
   value: "Xiantan (CNXTN)",
   label: "Xiantan (CNXTN)"
  },
  {
   value: "Xiantao (CNXTO)",
   label: "Xiantao (CNXTO)"
  },
  {
   value: "Xianyang (CNXYA)",
   label: "Xianyang (CNXYA)"
  },
  {
   value: "Xianyang Apt (CNXNT)",
   label: "Xianyang Apt (CNXNT)"
  },
  {
   value: "Xianyou (CNXYU)",
   label: "Xianyou (CNXYU)"
  },
  {
   value: "Xiaochi (CNXCI)",
   label: "Xiaochi (CNXCI)"
  },
  {
   value: "Xiaocuo (CNXCU)",
   label: "Xiaocuo (CNXCU)"
  },
  {
   value: "Xiaogan (CNXGN)",
   label: "Xiaogan (CNXGN)"
  },
  {
   value: "Xiaohudao (CNXHO)",
   label: "Xiaohudao (CNXHO)"
  },
  {
   value: "Xiaojiangba (CNXJB)",
   label: "Xiaojiangba (CNXJB)"
  },
  {
   value: "Xiaolan (CNXIL)",
   label: "Xiaolan (CNXIL)"
  },
  {
   value: "Xiaolizhuang (CNXLZ)",
   label: "Xiaolizhuang (CNXLZ)"
  },
  {
   value: "Xiaotang (CNXOT)",
   label: "Xiaotang (CNXOT)"
  },
  {
   value: "Xiaotang (CNXTG)",
   label: "Xiaotang (CNXTG)"
  },
  {
   value: "Xiaoxian (CNXIO)",
   label: "Xiaoxian (CNXIO)"
  },
  {
   value: "Xiashan (CNXHA)",
   label: "Xiashan (CNXHA)"
  },
  {
   value: "Xiaying (CNXYN)",
   label: "Xiaying (CNXYN)"
  },
  {
   value: "Xichang (CNXIC)",
   label: "Xichang (CNXIC)"
  },
  {
   value: "Xichong (CNXCG)",
   label: "Xichong (CNXCG)"
  },
  {
   value: "Xiegang (CNXEG)",
   label: "Xiegang (CNXEG)"
  },
  {
   value: "Wenshan (CNWSH)",
   label: "Wenshan (CNWSH)"
  },
  {
   value: "Wenzhou Pt (CNWZP)",
   label: "Wenzhou Pt (CNWZP)"
  },
  {
   value: "Whampoa (CNWHA)",
   label: "Whampoa (CNWHA)"
  },
  {
   value: "Wu Chong Kou (CNWUC)",
   label: "Wu Chong Kou (CNWUC)"
  },
  {
   value: "Wu Xuan (CNWXN)",
   label: "Wu Xuan (CNWXN)"
  },
  {
   value: "Wuchuan (CNWHU)",
   label: "Wuchuan (CNWHU)"
  },
  {
   value: "Wuhan Pt (CNWUP)",
   label: "Wuhan Pt (CNWUP)"
  },
  {
   value: "Wuhe (CNWHE)",
   label: "Wuhe (CNWHE)"
  },
  {
   value: "Wujiang (CNWUJ)",
   label: "Wujiang (CNWUJ)"
  },
  {
   value: "Wujin (CNWJI)",
   label: "Wujin (CNWJI)"
  },
  {
   value: "Wujin (CNWJN)",
   label: "Wujin (CNWJN)"
  },
  {
   value: "Wukan (CNWUK)",
   label: "Wukan (CNWUK)"
  },
  {
   value: "Wuli (CNWLI)",
   label: "Wuli (CNWLI)"
  },
  {
   value: "Wulipu Apt\/Ankang (CNAKA)",
   label: "Wulipu Apt\/Ankang (CNAKA)"
  },
  {
   value: "Wuming (CNWMG)",
   label: "Wuming (CNWMG)"
  },
  {
   value: "Wuping (CNWPG)",
   label: "Wuping (CNWPG)"
  },
  {
   value: "Wusha (CNWSA)",
   label: "Wusha (CNWSA)"
  },
  {
   value: "Wusha (CNWUA)",
   label: "Wusha (CNWUA)"
  },
  {
   value: "Wushan (CNWSN)",
   label: "Wushan (CNWSN)"
  },
  {
   value: "Wuxian (CNWXI)",
   label: "Wuxian (CNWXI)"
  },
  {
   value: "Wuxuan (CNWXA)",
   label: "Wuxuan (CNWXA)"
  },
  {
   value: "Wuxue Pt (CNWXP)",
   label: "Wuxue Pt (CNWXP)"
  },
  {
   value: "Wuyapao (CNWYP)",
   label: "Wuyapao (CNWYP)"
  },
  {
   value: "Wuzhou (CNWUO)",
   label: "Wuzhou (CNWUO)"
  },
  {
   value: "Xiadaiji (CNXDJ)",
   label: "Xiadaiji (CNXDJ)"
  },
  {
   value: "Xiaguan (CNXGA)",
   label: "Xiaguan (CNXGA)"
  },
  {
   value: "Xiahai (CNXIH)",
   label: "Xiahai (CNXIH)"
  },
  {
   value: "Xiamao (CNXIM)",
   label: "Xiamao (CNXIM)"
  },
  {
   value: "Tuanfeng (CNTFG)",
   label: "Tuanfeng (CNTFG)"
  },
  {
   value: "Tuchengcity Apt\/Ulanhad (CNCIF)",
   label: "Tuchengcity Apt\/Ulanhad (CNCIF)"
  },
  {
   value: "Tunxi (CNTXN)",
   label: "Tunxi (CNTXN)"
  },
  {
   value: "Tuojidao (CNTJD)",
   label: "Tuojidao (CNTJD)"
  },
  {
   value: "Tuopu (CNTPU)",
   label: "Tuopu (CNTPU)"
  },
  {
   value: "Tuqiao (CNTQO)",
   label: "Tuqiao (CNTQO)"
  },
  {
   value: "Ulan Hot (CNWLH)",
   label: "Ulan Hot (CNWLH)"
  },
  {
   value: "Ulan Hot Apt (CNHLH)",
   label: "Ulan Hot Apt (CNHLH)"
  },
  {
   value: "Ulanhad (CNCFG)",
   label: "Ulanhad (CNCFG)"
  },
  {
   value: "Waihai (CNWAI)",
   label: "Waihai (CNWAI)"
  },
  {
   value: "Wangjiadun International Apt\/Wuhan (CNWAD)",
   label: "Wangjiadun International Apt\/Wuhan (CNWAD)"
  },
  {
   value: "Wangjiang (CNWJG)",
   label: "Wangjiang (CNWJG)"
  },
  {
   value: "Wangqi (CNWGI)",
   label: "Wangqi (CNWGI)"
  },
  {
   value: "Wanjiang (CNWAJ)",
   label: "Wanjiang (CNWAJ)"
  },
  {
   value: "Wanling (CNWLG)",
   label: "Wanling (CNWLG)"
  },
  {
   value: "Wanning (CNWNG)",
   label: "Wanning (CNWNG)"
  },
  {
   value: "Wanshan (CNWAS)",
   label: "Wanshan (CNWAS)"
  },
  {
   value: "Wanxian (CNWAX)",
   label: "Wanxian (CNWAX)"
  },
  {
   value: "Wanzhou (CNWAH)",
   label: "Wanzhou (CNWAH)"
  },
  {
   value: "Weifang Apt (CNWEF)",
   label: "Weifang Apt (CNWEF)"
  },
  {
   value: "Weifang Pt (CNWFP)",
   label: "Weifang Pt (CNWFP)"
  },
  {
   value: "Weihai Apt (CNWEH)",
   label: "Weihai Apt (CNWEH)"
  },
  {
   value: "Weihai Pt (CNWIH)",
   label: "Weihai Pt (CNWIH)"
  },
  {
   value: "Weinan (CNWNA)",
   label: "Weinan (CNWNA)"
  },
  {
   value: "Weitou (CNWTU)",
   label: "Weitou (CNWTU)"
  },
  {
   value: "Weiyuankou (CNWYK)",
   label: "Weiyuankou (CNWYK)"
  },
  {
   value: "Weizhou (CNWZO)",
   label: "Weizhou (CNWZO)"
  },
  {
   value: "Wenchang (CNWEC)",
   label: "Wenchang (CNWEC)"
  },
  {
   value: "Wenchengzhen (CNWNC)",
   label: "Wenchengzhen (CNWNC)"
  },
  {
   value: "Wendeng (CNWDS)",
   label: "Wendeng (CNWDS)"
  },
  {
   value: "Wengyuan (CNWYN)",
   label: "Wengyuan (CNWYN)"
  },
  {
   value: "Tangxi (CNTGX)",
   label: "Tangxi (CNTGX)"
  },
  {
   value: "Tangzha (CNTZH)",
   label: "Tangzha (CNTZH)"
  },
  {
   value: "Tanmen (CNTMN)",
   label: "Tanmen (CNTMN)"
  },
  {
   value: "Taohuayuan Apt\/Changde (CNCGD)",
   label: "Taohuayuan Apt\/Changde (CNCGD)"
  },
  {
   value: "Taokou (CNYKU)",
   label: "Taokou (CNYKU)"
  },
  {
   value: "Taoyang (CNTYG)",
   label: "Taoyang (CNTYG)"
  },
  {
   value: "Tengchong (CNTGG)",
   label: "Tengchong (CNTGG)"
  },
  {
   value: "Tengxian (CNTXI)",
   label: "Tengxian (CNTXI)"
  },
  {
   value: "Tengzhou (CNTGZ)",
   label: "Tengzhou (CNTGZ)"
  },
  {
   value: "Tiandong (CNTID)",
   label: "Tiandong (CNTID)"
  },
  {
   value: "Tiandu (CNTDU)",
   label: "Tiandu (CNTDU)"
  },
  {
   value: "Tianhe (CNTIH)",
   label: "Tianhe (CNTIH)"
  },
  {
   value: "Tianjin Pt (CNTJP)",
   label: "Tianjin Pt (CNTJP)"
  },
  {
   value: "Tianlin (CNTLN)",
   label: "Tianlin (CNTLN)"
  },
  {
   value: "Tianshui (CNTSU)",
   label: "Tianshui (CNTSU)"
  },
  {
   value: "Tiantai (CNTIA)",
   label: "Tiantai (CNTIA)"
  },
  {
   value: "Tianyang (CNTIY)",
   label: "Tianyang (CNTIY)"
  },
  {
   value: "Tianzhen (CNTZE)",
   label: "Tianzhen (CNTZE)"
  },
  {
   value: "Tieli (CNTLI)",
   label: "Tieli (CNTLI)"
  },
  {
   value: "Tieling (CNTIL)",
   label: "Tieling (CNTIL)"
  },
  {
   value: "Tieshan (CNBHT)",
   label: "Tieshan (CNBHT)"
  },
  {
   value: "Tonghe (CNTOH)",
   label: "Tonghe (CNTOH)"
  },
  {
   value: "Tonghua (CNTGH)",
   label: "Tonghua (CNTGH)"
  },
  {
   value: "Tongjia (CNTNG)",
   label: "Tongjia (CNTNG)"
  },
  {
   value: "Tongliao (CNTGL)",
   label: "Tongliao (CNTGL)"
  },
  {
   value: "Tongliao Apt (CNTGO)",
   label: "Tongliao Apt (CNTGO)"
  },
  {
   value: "Tonglu (CNTON)",
   label: "Tonglu (CNTON)"
  },
  {
   value: "Tongren (CNTEN)",
   label: "Tongren (CNTEN)"
  },
  {
   value: "Tongxiang (CNTXZ)",
   label: "Tongxiang (CNTXZ)"
  },
  {
   value: "Tongxiang (Wutong) (CNTXJ)",
   label: "Tongxiang (Wutong) (CNTXJ)"
  },
  {
   value: "Tongxing (CNTOX)",
   label: "Tongxing (CNTOX)"
  },
  {
   value: "Tongzhao (CNTOZ)",
   label: "Tongzhao (CNTOZ)"
  },
  {
   value: "Tsamkong = Zhanjiang (CN)",
   label: "Tsamkong = Zhanjiang (CN)"
  },
  {
   value: "Siping (CNSPG)",
   label: "Siping (CNSPG)"
  },
  {
   value: "Songgai (CNSOG)",
   label: "Songgai (CNSOG)"
  },
  {
   value: "Songgang (CNSAG)",
   label: "Songgang (CNSAG)"
  },
  {
   value: "Songgang (CNSGA)",
   label: "Songgang (CNSGA)"
  },
  {
   value: "Songjiang (CNSOJ)",
   label: "Songjiang (CNSOJ)"
  },
  {
   value: "Songmen (CNSMN)",
   label: "Songmen (CNSMN)"
  },
  {
   value: "Songshu (CNSGS)",
   label: "Songshu (CNSGS)"
  },
  {
   value: "Songzikou (CNSZK)",
   label: "Songzikou (CNSZK)"
  },
  {
   value: "Suibin (CNSBN)",
   label: "Suibin (CNSBN)"
  },
  {
   value: "Suichang (CNSCH)",
   label: "Suichang (CNSCH)"
  },
  {
   value: "Suidong (CNCFF)",
   label: "Suidong (CNCFF)"
  },
  {
   value: "Suigang (CNSUG)",
   label: "Suigang (CNSUG)"
  },
  {
   value: "Suigang Huangpu (CNSUI)",
   label: "Suigang Huangpu (CNSUI)"
  },
  {
   value: "Suixi (CNSUX)",
   label: "Suixi (CNSUX)"
  },
  {
   value: "Suizhong (CNSIZ)",
   label: "Suizhong (CNSIZ)"
  },
  {
   value: "Tai Po (CNTPO)",
   label: "Tai Po (CNTPO)"
  },
  {
   value: "Taicang (CNTAG)",
   label: "Taicang (CNTAG)"
  },
  {
   value: "Taicheng (Taishan) (CNTHG)",
   label: "Taicheng (Taishan) (CNTHG)"
  },
  {
   value: "Taihe (CNTHE)",
   label: "Taihe (CNTHE)"
  },
  {
   value: "Taijiang (CNTJG)",
   label: "Taijiang (CNTJG)"
  },
  {
   value: "Taipingkou (CNTPK)",
   label: "Taipingkou (CNTPK)"
  },
  {
   value: "Taishan (CNTIS)",
   label: "Taishan (CNTIS)"
  },
  {
   value: "Taishan (CNTSA)",
   label: "Taishan (CNTSA)"
  },
  {
   value: "Taixing (CNTAX)",
   label: "Taixing (CNTAX)"
  },
  {
   value: "Taiyang (CNTAY)",
   label: "Taiyang (CNTAY)"
  },
  {
   value: "Taizhou (CNTIZ)",
   label: "Taizhou (CNTIZ)"
  },
  {
   value: "Tanggou (CNTNO)",
   label: "Tanggou (CNTNO)"
  },
  {
   value: "Tangjia (CNTJA)",
   label: "Tangjia (CNTJA)"
  },
  {
   value: "Tangkou (CNTGK)",
   label: "Tangkou (CNTGK)"
  },
  {
   value: "Shihu (CNSHU)",
   label: "Shihu (CNSHU)"
  },
  {
   value: "Shijie (CNSJE)",
   label: "Shijie (CNSJE)"
  },
  {
   value: "Shijitou (CNSJO)",
   label: "Shijitou (CNSJO)"
  },
  {
   value: "Shijiu (CNSJU)",
   label: "Shijiu (CNSJU)"
  },
  {
   value: "Shilong (CNSHL)",
   label: "Shilong (CNSHL)"
  },
  {
   value: "Shilou (CNSLO)",
   label: "Shilou (CNSLO)"
  },
  {
   value: "Shilu (CNSLU)",
   label: "Shilu (CNSLU)"
  },
  {
   value: "Shipai (CNSPI)",
   label: "Shipai (CNSPI)"
  },
  {
   value: "Shipu (CNSPU)",
   label: "Shipu (CNSPU)"
  },
  {
   value: "Shiqiao (CNSQU)",
   label: "Shiqiao (CNSQU)"
  },
  {
   value: "Shiqu Pt (CNSIP)",
   label: "Shiqu Pt (CNSIP)"
  },
  {
   value: "Shishan (CNSSA)",
   label: "Shishan (CNSSA)"
  },
  {
   value: "Shishi (CNSHI)",
   label: "Shishi (CNSHI)"
  },
  {
   value: "Shitan (CNSTN)",
   label: "Shitan (CNSTN)"
  },
  {
   value: "Shiwan (CNSAN)",
   label: "Shiwan (CNSAN)"
  },
  {
   value: "Shiwan (CNSHN)",
   label: "Shiwan (CNSHN)"
  },
  {
   value: "Shiwan (CNSIW)",
   label: "Shiwan (CNSIW)"
  },
  {
   value: "Shiyang (CNSYG)",
   label: "Shiyang (CNSYG)"
  },
  {
   value: "Shizhu (CNSIU)",
   label: "Shizhu (CNSIU)"
  },
  {
   value: "Shizilu (CNSHZ)",
   label: "Shizilu (CNSHZ)"
  },
  {
   value: "Shouguang (CNSGN)",
   label: "Shouguang (CNSGN)"
  },
  {
   value: "Shuangcheng (CNSAC)",
   label: "Shuangcheng (CNSAC)"
  },
  {
   value: "Shuangshui (CNSSP)",
   label: "Shuangshui (CNSSP)"
  },
  {
   value: "Shuibu (CNSUB)",
   label: "Shuibu (CNSUB)"
  },
  {
   value: "Shunyi (CNSUN)",
   label: "Shunyi (CNSUN)"
  },
  {
   value: "Shuyang (CNSUY)",
   label: "Shuyang (CNSUY)"
  },
  {
   value: "Si Keng (CNSKG)",
   label: "Si Keng (CNSKG)"
  },
  {
   value: "Sijitun (CNSJT)",
   label: "Sijitun (CNSJT)"
  },
  {
   value: "Sikuaishi (CNSKS)",
   label: "Sikuaishi (CNSKS)"
  },
  {
   value: "Shanshui (CNSSI)",
   label: "Shanshui (CNSSI)"
  },
  {
   value: "Shantou Pt (CNSTP)",
   label: "Shantou Pt (CNSTP)"
  },
  {
   value: "Shanwai (CNSAW)",
   label: "Shanwai (CNSAW)"
  },
  {
   value: "Shaowu (CNSWU)",
   label: "Shaowu (CNSWU)"
  },
  {
   value: "Shaoyang (CNAOY)",
   label: "Shaoyang (CNAOY)"
  },
  {
   value: "Shaping (CNSAP)",
   label: "Shaping (CNSAP)"
  },
  {
   value: "Shapingba (CNSPB)",
   label: "Shapingba (CNSPB)"
  },
  {
   value: "Shashan (CNSSN)",
   label: "Shashan (CNSSN)"
  },
  {
   value: "Shashangang (CNSSG)",
   label: "Shashangang (CNSSG)"
  },
  {
   value: "Shashi (CNSHS)",
   label: "Shashi (CNSHS)"
  },
  {
   value: "Shatian (CNSIN)",
   label: "Shatian (CNSIN)"
  },
  {
   value: "Shating (CNSHT)",
   label: "Shating (CNSHT)"
  },
  {
   value: "Shatou (CNSTO)",
   label: "Shatou (CNSTO)"
  },
  {
   value: "Shatuozi (CNSTZ)",
   label: "Shatuozi (CNSTZ)"
  },
  {
   value: "Shaxi (CNSHX)",
   label: "Shaxi (CNSHX)"
  },
  {
   value: "Shaxian (CNSXN)",
   label: "Shaxian (CNSXN)"
  },
  {
   value: "Shengzhou (CNSGZ)",
   label: "Shengzhou (CNSGZ)"
  },
  {
   value: "Shenquan (CNSQN)",
   label: "Shenquan (CNSQN)"
  },
  {
   value: "Shenwan (CNSNW)",
   label: "Shenwan (CNSNW)"
  },
  {
   value: "Shenzhen Pt (CNSZP)",
   label: "Shenzhen Pt (CNSZP)"
  },
  {
   value: "Shenzhenwan (CNSZW)",
   label: "Shenzhenwan (CNSZW)"
  },
  {
   value: "Sheung Shui (CNSNS)",
   label: "Sheung Shui (CNSNS)"
  },
  {
   value: "Sheyang (CNSYA)",
   label: "Sheyang (CNSYA)"
  },
  {
   value: "Shi Xing (CNSXI)",
   label: "Shi Xing (CNSXI)"
  },
  {
   value: "Shibahe (CNSBH)",
   label: "Shibahe (CNSBH)"
  },
  {
   value: "Shihezi (CNSZI)",
   label: "Shihezi (CNSZI)"
  },
  {
   value: "Sanjiang (CNSIG)",
   label: "Sanjiang (CNSIG)"
  },
  {
   value: "Sanjiang (CNSJI)",
   label: "Sanjiang (CNSJI)"
  },
  {
   value: "Sanmenpo (CNSNP)",
   label: "Sanmenpo (CNSNP)"
  },
  {
   value: "Sanmenxian (CNSMX)",
   label: "Sanmenxian (CNSMX)"
  },
  {
   value: "Sanming \/ Shanming Shi (CNSAM)",
   label: "Sanming \/ Shanming Shi (CNSAM)"
  },
  {
   value: "Sanrong (CNSRG)",
   label: "Sanrong (CNSRG)"
  },
  {
   value: "Sanshu (CNSNU)",
   label: "Sanshu (CNSNU)"
  },
  {
   value: "Sanya Pt (CNSYP)",
   label: "Sanya Pt (CNSYP)"
  },
  {
   value: "Sanyang (CNSNA)",
   label: "Sanyang (CNSNA)"
  },
  {
   value: "Sanyuanli\/Guangzhou (CNSNL)",
   label: "Sanyuanli\/Guangzhou (CNSNL)"
  },
  {
   value: "Sanzao (CNSAO)",
   label: "Sanzao (CNSAO)"
  },
  {
   value: "Sanzao (CNSZA)",
   label: "Sanzao (CNSZA)"
  },
  {
   value: "Sanzhou (CNSNZ)",
   label: "Sanzhou (CNSNZ)"
  },
  {
   value: "Sanzhou (CNSZO)",
   label: "Sanzhou (CNSZO)"
  },
  {
   value: "Sanzhou (CNSZU)",
   label: "Sanzhou (CNSZU)"
  },
  {
   value: "Science City (CNKJC)",
   label: "Science City (CNKJC)"
  },
  {
   value: "Shacheng (CNSHC)",
   label: "Shacheng (CNSHC)"
  },
  {
   value: "Shadui (CNSDU)",
   label: "Shadui (CNSDU)"
  },
  {
   value: "Shahe (CNSAE)",
   label: "Shahe (CNSAE)"
  },
  {
   value: "Shahe (CNSEH)",
   label: "Shahe (CNSEH)"
  },
  {
   value: "Shahezi (CNSEZ)",
   label: "Shahezi (CNSEZ)"
  },
  {
   value: "Shalingzhuang (CNSAL)",
   label: "Shalingzhuang (CNSAL)"
  },
  {
   value: "Shandong (CNSAD)",
   label: "Shandong (CNSAD)"
  },
  {
   value: "Shangêlila Apt\/Diqing (CNDIG)",
   label: "Shangêlila Apt\/Diqing (CNDIG)"
  },
  {
   value: "Shanghai Pt (CNSGP)",
   label: "Shanghai Pt (CNSGP)"
  },
  {
   value: "Shanghai Pu Dong Apt (CNPVG)",
   label: "Shanghai Pu Dong Apt (CNPVG)"
  },
  {
   value: "Shanghe (CNSGH)",
   label: "Shanghe (CNSGH)"
  },
  {
   value: "Shangqiu (CNSHQ)",
   label: "Shangqiu (CNSHQ)"
  },
  {
   value: "Shangrao (CNSNR)",
   label: "Shangrao (CNSNR)"
  },
  {
   value: "Shangrao (CNSRO)",
   label: "Shangrao (CNSRO)"
  },
  {
   value: "Shangsi (CNSGI)",
   label: "Shangsi (CNSGI)"
  },
  {
   value: "Shangyu (CNSGU)",
   label: "Shangyu (CNSGU)"
  },
  {
   value: "Qufu (CNQUF)",
   label: "Qufu (CNQUF)"
  },
  {
   value: "Qukou (CNQKU)",
   label: "Qukou (CNQKU)"
  },
  {
   value: "Quxi (CNQXI)",
   label: "Quxi (CNQXI)"
  },
  {
   value: "Quyang (CNQUY)",
   label: "Quyang (CNQUY)"
  },
  {
   value: "Quzhou (CNQUZ)",
   label: "Quzhou (CNQUZ)"
  },
  {
   value: "Quzhou Apt (CNJUZ)",
   label: "Quzhou Apt (CNJUZ)"
  },
  {
   value: "Raoping (CNRPG)",
   label: "Raoping (CNRPG)"
  },
  {
   value: "Renhe (CNRNH)",
   label: "Renhe (CNRNH)"
  },
  {
   value: "Rikaze (CNRKZ)",
   label: "Rikaze (CNRKZ)"
  },
  {
   value: "Rong Xian (CNRXN)",
   label: "Rong Xian (CNRXN)"
  },
  {
   value: "Rongcheng (CNRCG)",
   label: "Rongcheng (CNRCG)"
  },
  {
   value: "Rongcheng (CNRCH)",
   label: "Rongcheng (CNRCH)"
  },
  {
   value: "Rongjiang (CNRJG)",
   label: "Rongjiang (CNRJG)"
  },
  {
   value: "Rongshui (CNRSI)",
   label: "Rongshui (CNRSI)"
  },
  {
   value: "Rudong (CNRDO)",
   label: "Rudong (CNRDO)"
  },
  {
   value: "Rudong (CNRUD)",
   label: "Rudong (CNRUD)"
  },
  {
   value: "Rugao (CNRUG)",
   label: "Rugao (CNRUG)"
  },
  {
   value: "Ruian (CNRIA)",
   label: "Ruian (CNRIA)"
  },
  {
   value: "Ruichang (CNRAG)",
   label: "Ruichang (CNRAG)"
  },
  {
   value: "Ruicheng (CNRUC)",
   label: "Ruicheng (CNRUC)"
  },
  {
   value: "Ruijin (CNRUJ)",
   label: "Ruijin (CNRUJ)"
  },
  {
   value: "Runjiang (CNRJN)",
   label: "Runjiang (CNRJN)"
  },
  {
   value: "Rushan (CNRSH)",
   label: "Rushan (CNRSH)"
  },
  {
   value: "Rushankou (CNRSN)",
   label: "Rushankou (CNRSN)"
  },
  {
   value: "Saiqi Pt (CNSQP)",
   label: "Saiqi Pt (CNSQP)"
  },
  {
   value: "Sanbu (CNSAU)",
   label: "Sanbu (CNSAU)"
  },
  {
   value: "Sandouping (CNSDP)",
   label: "Sandouping (CNSDP)"
  },
  {
   value: "Sanhe (CNANH)",
   label: "Sanhe (CNANH)"
  },
  {
   value: "Sanhua (CNSAA)",
   label: "Sanhua (CNSAA)"
  },
  {
   value: "Qiaoshe (CNQIE)",
   label: "Qiaoshe (CNQIE)"
  },
  {
   value: "Qiaotou (CNQTU)",
   label: "Qiaotou (CNQTU)"
  },
  {
   value: "Qiaoxu (CNQXU)",
   label: "Qiaoxu (CNQXU)"
  },
  {
   value: "Qidong (CNQDG)",
   label: "Qidong (CNQDG)"
  },
  {
   value: "Qiemo Apt (CNIQM)",
   label: "Qiemo Apt (CNIQM)"
  },
  {
   value: "Qihe (CNQIH)",
   label: "Qihe (CNQIH)"
  },
  {
   value: "Qike (CNQKE)",
   label: "Qike (CNQKE)"
  },
  {
   value: "Qimen (CNQMN)",
   label: "Qimen (CNQMN)"
  },
  {
   value: "Qindeli (CNQDL)",
   label: "Qindeli (CNQDL)"
  },
  {
   value: "Qingdao Pt (CNQDP)",
   label: "Qingdao Pt (CNQDP)"
  },
  {
   value: "Qingge (CNQGG)",
   label: "Qingge (CNQGG)"
  },
  {
   value: "Qingguji \/ Shangqiu (CNQIG)",
   label: "Qingguji \/ Shangqiu (CNQIG)"
  },
  {
   value: "Qinghe (CNQHE)",
   label: "Qinghe (CNQHE)"
  },
  {
   value: "Qingjiang (CNQJI)",
   label: "Qingjiang (CNQJI)"
  },
  {
   value: "Qingliu (CNQLU)",
   label: "Qingliu (CNQLU)"
  },
  {
   value: "Qingpu (CNQPU)",
   label: "Qingpu (CNQPU)"
  },
  {
   value: "Qingshuihe, Shenzhen (CNQSE)",
   label: "Qingshuihe, Shenzhen (CNQSE)"
  },
  {
   value: "Qingxian (CNQIX)",
   label: "Qingxian (CNQIX)"
  },
  {
   value: "Qingyang (CNQYA)",
   label: "Qingyang (CNQYA)"
  },
  {
   value: "Qingzhou (CNQGZ)",
   label: "Qingzhou (CNQGZ)"
  },
  {
   value: "Qingzhou (CNQOU)",
   label: "Qingzhou (CNQOU)"
  },
  {
   value: "Qinjiang (CNQJG)",
   label: "Qinjiang (CNQJG)"
  },
  {
   value: "Qinzhoumaoling (CNMLI)",
   label: "Qinzhoumaoling (CNMLI)"
  },
  {
   value: "Qinzhoushajing (CNSAJ)",
   label: "Qinzhoushajing (CNSAJ)"
  },
  {
   value: "Qionghai (CNQHA)",
   label: "Qionghai (CNQHA)"
  },
  {
   value: "Qiongzhong (CNQZG)",
   label: "Qiongzhong (CNQZG)"
  },
  {
   value: "Qixingtai (CNQXT)",
   label: "Qixingtai (CNQXT)"
  },
  {
   value: "Qizhou (CNQZO)",
   label: "Qizhou (CNQZO)"
  },
  {
   value: "Qoqek Apt (CNTCG)",
   label: "Qoqek Apt (CNTCG)"
  },
  {
   value: "Quanhe (CNQUH)",
   label: "Quanhe (CNQUH)"
  },
  {
   value: "Quanyang (CNQYG)",
   label: "Quanyang (CNQYG)"
  },
  {
   value: "Penglai (CNPLA)",
   label: "Penglai (CNPLA)"
  },
  {
   value: "Pengze (CNPZE)",
   label: "Pengze (CNPZE)"
  },
  {
   value: "Pikou (CNPKO)",
   label: "Pikou (CNPKO)"
  },
  {
   value: "Ping Hu (CNGPH)",
   label: "Ping Hu (CNGPH)"
  },
  {
   value: "Pingdingshan East (CNPDE)",
   label: "Pingdingshan East (CNPDE)"
  },
  {
   value: "Pingdu (CNPDU)",
   label: "Pingdu (CNPDU)"
  },
  {
   value: "Pinghai (CNPII)",
   label: "Pinghai (CNPII)"
  },
  {
   value: "Pinghu (CNPHU)",
   label: "Pinghu (CNPHU)"
  },
  {
   value: "Pinghu (CNPNU)",
   label: "Pinghu (CNPNU)"
  },
  {
   value: "Pingle (CNPIL)",
   label: "Pingle (CNPIL)"
  },
  {
   value: "Pingnan (CNPGN)",
   label: "Pingnan (CNPGN)"
  },
  {
   value: "Pingsha (CNPSH)",
   label: "Pingsha (CNPSH)"
  },
  {
   value: "Pingshi (CNPIS)",
   label: "Pingshi (CNPIS)"
  },
  {
   value: "Pingxiang (CNPIG)",
   label: "Pingxiang (CNPIG)"
  },
  {
   value: "Pingzhou (CNPGU)",
   label: "Pingzhou (CNPGU)"
  },
  {
   value: "Pizhou (CNPJS)",
   label: "Pizhou (CNPJS)"
  },
  {
   value: "Poji (CNPOJ)",
   label: "Poji (CNPOJ)"
  },
  {
   value: "Pojiao (CNPJO)",
   label: "Pojiao (CNPJO)"
  },
  {
   value: "Pucheng (CNPCH)",
   label: "Pucheng (CNPCH)"
  },
  {
   value: "Pudong\/Shanghai (CNPDG)",
   label: "Pudong\/Shanghai (CNPDG)"
  },
  {
   value: "Pudongxinqu Pt (CNPDX)",
   label: "Pudongxinqu Pt (CNPDX)"
  },
  {
   value: "Puqi (CNPQI)",
   label: "Puqi (CNPQI)"
  },
  {
   value: "Puqian (CNPQA)",
   label: "Puqian (CNPQA)"
  },
  {
   value: "Puxi (CNPXI)",
   label: "Puxi (CNPXI)"
  },
  {
   value: "Puyang (CNPYG)",
   label: "Puyang (CNPYG)"
  },
  {
   value: "Qiandong (CNQDO)",
   label: "Qiandong (CNQDO)"
  },
  {
   value: "Qiangjiao (CNQJO)",
   label: "Qiangjiao (CNQJO)"
  },
  {
   value: "Qianshan, Zhuhai (CNQSN)",
   label: "Qianshan, Zhuhai (CNQSN)"
  },
  {
   value: "Qianwan (CNQAW)",
   label: "Qianwan (CNQAW)"
  },
  {
   value: "Qianxian (CNQNX)",
   label: "Qianxian (CNQNX)"
  },
  {
   value: "Nanping (CNNPG)",
   label: "Nanping (CNNPG)"
  },
  {
   value: "Nanping (CNNPS)",
   label: "Nanping (CNNPS)"
  },
  {
   value: "Nanqiao (CNNQO)",
   label: "Nanqiao (CNNQO)"
  },
  {
   value: "Nansha New Pt (CNNNP)",
   label: "Nansha New Pt (CNNNP)"
  },
  {
   value: "Nansha Old Pt (CNNOP)",
   label: "Nansha Old Pt (CNNOP)"
  },
  {
   value: "Nanshan (CNNNA)",
   label: "Nanshan (CNNNA)"
  },
  {
   value: "Nanshan (CNNSH)",
   label: "Nanshan (CNNSH)"
  },
  {
   value: "Nanwei (CNNWI)",
   label: "Nanwei (CNNWI)"
  },
  {
   value: "Nanxi (CNNNX)",
   label: "Nanxi (CNNNX)"
  },
  {
   value: "Nanxiang (CNNXI)",
   label: "Nanxiang (CNNXI)"
  },
  {
   value: "Nanyang (CNNYG)",
   label: "Nanyang (CNNYG)"
  },
  {
   value: "Nanyang Apt\/Yancheng (CNYNZ)",
   label: "Nanyang Apt\/Yancheng (CNYNZ)"
  },
  {
   value: "Nanyuan (CNNAY)",
   label: "Nanyuan (CNNAY)"
  },
  {
   value: "Nanzhuang (CNNZA)",
   label: "Nanzhuang (CNNZA)"
  },
  {
   value: "Nanzhuang (CNNZU)",
   label: "Nanzhuang (CNNZU)"
  },
  {
   value: "Natong (CNNAT)",
   label: "Natong (CNNAT)"
  },
  {
   value: "Neigang (CNNEG)",
   label: "Neigang (CNNEG)"
  },
  {
   value: "Nicha (CNNCA)",
   label: "Nicha (CNNCA)"
  },
  {
   value: "Ningbo Pt (CNNBP)",
   label: "Ningbo Pt (CNNBP)"
  },
  {
   value: "Ningde (CNNDE)",
   label: "Ningde (CNNDE)"
  },
  {
   value: "Ningguo (CNNGU)",
   label: "Ningguo (CNNGU)"
  },
  {
   value: "Ninghai (CNNIN)",
   label: "Ninghai (CNNIN)"
  },
  {
   value: "Ninghe (CNNHE)",
   label: "Ninghe (CNNHE)"
  },
  {
   value: "Ningjiang (CNNJI)",
   label: "Ningjiang (CNNJI)"
  },
  {
   value: "Ningming (CNNMI)",
   label: "Ningming (CNNMI)"
  },
  {
   value: "Niutoushan (CNNTN)",
   label: "Niutoushan (CNNTN)"
  },
  {
   value: "Nyingchi Apt (CNLZY)",
   label: "Nyingchi Apt (CNLZY)"
  },
  {
   value: "Paizhou (CNPZO)",
   label: "Paizhou (CNPZO)"
  },
  {
   value: "Panjin (CNPJI)",
   label: "Panjin (CNPJI)"
  },
  {
   value: "Pantang (CNPNT)",
   label: "Pantang (CNPNT)"
  },
  {
   value: "Panyu (CNPYU)",
   label: "Panyu (CNPYU)"
  },
  {
   value: "Panzhihua (CNPZH)",
   label: "Panzhihua (CNPZH)"
  },
  {
   value: "Panzhihua Apt (CNPZI)",
   label: "Panzhihua Apt (CNPZI)"
  },
  {
   value: "Miaotou (CNMIA)",
   label: "Miaotou (CNMIA)"
  },
  {
   value: "Midu (CNMDU)",
   label: "Midu (CNMDU)"
  },
  {
   value: "Mingxi (CNMGX)",
   label: "Mingxi (CNMGX)"
  },
  {
   value: "Minhang (CNMNG)",
   label: "Minhang (CNMNG)"
  },
  {
   value: "Minxing (CNMHG)",
   label: "Minxing (CNMHG)"
  },
  {
   value: "Mishan (CNMSA)",
   label: "Mishan (CNMSA)"
  },
  {
   value: "Miyun (CNMIY)",
   label: "Miyun (CNMIY)"
  },
  {
   value: "Mouping (CNLPG)",
   label: "Mouping (CNLPG)"
  },
  {
   value: "Moupingyangmadao (CNMYM)",
   label: "Moupingyangmadao (CNMYM)"
  },
  {
   value: "Mudanjiang (CNMDG)",
   label: "Mudanjiang (CNMDG)"
  },
  {
   value: "Mudong (CNMDN)",
   label: "Mudong (CNMDN)"
  },
  {
   value: "Mugang (CNMUG)",
   label: "Mugang (CNMUG)"
  },
  {
   value: "Mulan (CNMLN)",
   label: "Mulan (CNMLN)"
  },
  {
   value: "Muzhou (CNMZU)",
   label: "Muzhou (CNMZU)"
  },
  {
   value: "Nan‘an (CNNAS)",
   label: "Nan‘an (CNNAS)"
  },
  {
   value: "Nanbian (CNNBA)",
   label: "Nanbian (CNNBA)"
  },
  {
   value: "Nanchong (CNNAO)",
   label: "Nanchong (CNNAO)"
  },
  {
   value: "Nanding (CNNDN)",
   label: "Nanding (CNNDN)"
  },
  {
   value: "Nandu (CNNAD)",
   label: "Nandu (CNNAD)"
  },
  {
   value: "Nanfeng (CNNAF)",
   label: "Nanfeng (CNNAF)"
  },
  {
   value: "Nangziguan (CNNZG)",
   label: "Nangziguan (CNNZG)"
  },
  {
   value: "Nanhui (CNNHI)",
   label: "Nanhui (CNNHI)"
  },
  {
   value: "Nanhui Pt (CNNHP)",
   label: "Nanhui Pt (CNNHP)"
  },
  {
   value: "Nanjiangkou (CNNJK)",
   label: "Nanjiangkou (CNNJK)"
  },
  {
   value: "Nanjiao Apt\/Mianyang (CNMIG)",
   label: "Nanjiao Apt\/Mianyang (CNMIG)"
  },
  {
   value: "Nanjing (CNNJG)",
   label: "Nanjing (CNNJG)"
  },
  {
   value: "Nanjing Pt (CNNJP)",
   label: "Nanjing Pt (CNNJP)"
  },
  {
   value: "Nanling (CNNLG)",
   label: "Nanling (CNNLG)"
  },
  {
   value: "Nanpi (CNANI)",
   label: "Nanpi (CNANI)"
  },
  {
   value: "Lüshun New Pt (CNLNP)",
   label: "Lüshun New Pt (CNLNP)"
  },
  {
   value: "Luwan (CNLWN)",
   label: "Luwan (CNLWN)"
  },
  {
   value: "Luxi Apt\/Dehong (CNLUM)",
   label: "Luxi Apt\/Dehong (CNLUM)"
  },
  {
   value: "Luxikou Pt (CNLXP)",
   label: "Luxikou Pt (CNLXP)"
  },
  {
   value: "Luzhai (CNLZI)",
   label: "Luzhai (CNLZI)"
  },
  {
   value: "Luzhou (CNLZU)",
   label: "Luzhou (CNLZU)"
  },
  {
   value: "Machong (CNMCH)",
   label: "Machong (CNMCH)"
  },
  {
   value: "Macun (CNMCN)",
   label: "Macun (CNMCN)"
  },
  {
   value: "Mafang (CNMFG)",
   label: "Mafang (CNMFG)"
  },
  {
   value: "Maji Shan (CNMJS)",
   label: "Maji Shan (CNMJS)"
  },
  {
   value: "Majiadian (CNMJD)",
   label: "Majiadian (CNMJD)"
  },
  {
   value: "Majistan\/Zhoushan (CNMAJ)",
   label: "Majistan\/Zhoushan (CNMAJ)"
  },
  {
   value: "Manas (CNMAN)",
   label: "Manas (CNMAN)"
  },
  {
   value: "Maoling (CNMLG)",
   label: "Maoling (CNMLG)"
  },
  {
   value: "Maoping Pt (CNMPP)",
   label: "Maoping Pt (CNMPP)"
  },
  {
   value: "Maoshan Pt (CNMSP)",
   label: "Maoshan Pt (CNMSP)"
  },
  {
   value: "Matouzhen (CNMTZ)",
   label: "Matouzhen (CNMTZ)"
  },
  {
   value: "Mayong (CNMYO)",
   label: "Mayong (CNMYO)"
  },
  {
   value: "MCID Private Terminal (CNMCI)",
   label: "MCID Private Terminal (CNMCI)"
  },
  {
   value: "Meiao (CNMIO)",
   label: "Meiao (CNMIO)"
  },
  {
   value: "Meigeng (CNMGG)",
   label: "Meigeng (CNMGG)"
  },
  {
   value: "Meilin (CNMEI)",
   label: "Meilin (CNMEI)"
  },
  {
   value: "Meisha (CNMSH)",
   label: "Meisha (CNMSH)"
  },
  {
   value: "Meishan (CNMSN)",
   label: "Meishan (CNMSN)"
  },
  {
   value: "Meixian (CNEIX)",
   label: "Meixian (CNEIX)"
  },
  {
   value: "Meixian (CNMXZ)",
   label: "Meixian (CNMXZ)"
  },
  {
   value: "Meizhouwan (CNMZW)",
   label: "Meizhouwan (CNMZW)"
  },
  {
   value: "Mengcheng (CNMCX)",
   label: "Mengcheng (CNMCX)"
  },
  {
   value: "Mengding (CNMGD)",
   label: "Mengding (CNMGD)"
  },
  {
   value: "Mianyang (CNMYG)",
   label: "Mianyang (CNMYG)"
  },
  {
   value: "Miaoshanwei (CNMSW)",
   label: "Miaoshanwei (CNMSW)"
  },
  {
   value: "Longguan (CNLGU)",
   label: "Longguan (CNLGU)"
  },
  {
   value: "Longhai (CNLGI)",
   label: "Longhai (CNLGI)"
  },
  {
   value: "Longhua (CNLHA)",
   label: "Longhua (CNLHA)"
  },
  {
   value: "Longjiang (CNLLJ)",
   label: "Longjiang (CNLLJ)"
  },
  {
   value: "Longmen (CNLMN)",
   label: "Longmen (CNLMN)"
  },
  {
   value: "Longnan (CNLOA)",
   label: "Longnan (CNLOA)"
  },
  {
   value: "Longping Pt (CNLPP)",
   label: "Longping Pt (CNLPP)"
  },
  {
   value: "Longyan (CNLGY)",
   label: "Longyan (CNLGY)"
  },
  {
   value: "Longyan (CNLON)",
   label: "Longyan (CNLON)"
  },
  {
   value: "Longyao (CNLYO)",
   label: "Longyao (CNLYO)"
  },
  {
   value: "Longzhou (CNLOZ)",
   label: "Longzhou (CNLOZ)"
  },
  {
   value: "Loudi (CNLDI)",
   label: "Loudi (CNLDI)"
  },
  {
   value: "Loushan (CNLOS)",
   label: "Loushan (CNLOS)"
  },
  {
   value: "Luanjiakou (CNLJK)",
   label: "Luanjiakou (CNLJK)"
  },
  {
   value: "Lubu (CNUBU)",
   label: "Lubu (CNUBU)"
  },
  {
   value: "Lucheng Pt (CNLCP)",
   label: "Lucheng Pt (CNLCP)"
  },
  {
   value: "Lufeng (CNLFN)",
   label: "Lufeng (CNLFN)"
  },
  {
   value: "Lü-hua Shan (CNLUH)",
   label: "Lü-hua Shan (CNLUH)"
  },
  {
   value: "Luhuadao (CNLHD)",
   label: "Luhuadao (CNLHD)"
  },
  {
   value: "Lunan (CNLNN)",
   label: "Lunan (CNLNN)"
  },
  {
   value: "Lunjiao (CNLJO)",
   label: "Lunjiao (CNLJO)"
  },
  {
   value: "Luochongwei (CNLCW)",
   label: "Luochongwei (CNLCW)"
  },
  {
   value: "Luocun (CNLCN)",
   label: "Luocun (CNLCN)"
  },
  {
   value: "Luoding (CNLUO)",
   label: "Luoding (CNLUO)"
  },
  {
   value: "Luogang (CNLUG)",
   label: "Luogang (CNLUG)"
  },
  {
   value: "Luohuang (CNLOH)",
   label: "Luohuang (CNLOH)"
  },
  {
   value: "Luojingtan (CNLJT)",
   label: "Luojingtan (CNLJT)"
  },
  {
   value: "Luoniushan (CNLHN)",
   label: "Luoniushan (CNLHN)"
  },
  {
   value: "Luoqi (CNLQI)",
   label: "Luoqi (CNLQI)"
  },
  {
   value: "Luoxi (CNLUX)",
   label: "Luoxi (CNLUX)"
  },
  {
   value: "Luquan (CNLQU)",
   label: "Luquan (CNLQU)"
  },
  {
   value: "Lushan (CNLUS)",
   label: "Lushan (CNLUS)"
  },
  {
   value: "Lushan (CNLUZ)",
   label: "Lushan (CNLUZ)"
  },
  {
   value: "Liaoyang (CNLIA)",
   label: "Liaoyang (CNLIA)"
  },
  {
   value: "Liaoyuan (CNLOY)",
   label: "Liaoyuan (CNLOY)"
  },
  {
   value: "Libo (CNLIB)",
   label: "Libo (CNLIB)"
  },
  {
   value: "Licheng (CNLIC)",
   label: "Licheng (CNLIC)"
  },
  {
   value: "Lidao (CNLID)",
   label: "Lidao (CNLID)"
  },
  {
   value: "Lihu (CNLHU)",
   label: "Lihu (CNLHU)"
  },
  {
   value: "Lijiang (CNLIJ)",
   label: "Lijiang (CNLIJ)"
  },
  {
   value: "Lijiang (CNLJG)",
   label: "Lijiang (CNLJG)"
  },
  {
   value: "Liling (CNLLI)",
   label: "Liling (CNLLI)"
  },
  {
   value: "Lin (CNACH)",
   label: "Lin (CNACH)"
  },
  {
   value: "Lincheng (CNLGE)",
   label: "Lincheng (CNLGE)"
  },
  {
   value: "Lingbao (CNLGB)",
   label: "Lingbao (CNLGB)"
  },
  {
   value: "Lingcheng (CNLGN)",
   label: "Lingcheng (CNLGN)"
  },
  {
   value: "Lingling Apt\/Yongzhou (CNLLF)",
   label: "Lingling Apt\/Yongzhou (CNLLF)"
  },
  {
   value: "Lingshan (CNLSA)",
   label: "Lingshan (CNLSA)"
  },
  {
   value: "Lingwu (CNLGW)",
   label: "Lingwu (CNLGW)"
  },
  {
   value: "Linhai (CNLNH)",
   label: "Linhai (CNLNH)"
  },
  {
   value: "Lintao County (CNTNC)",
   label: "Lintao County (CNTNC)"
  },
  {
   value: "Linzi (CNLNZ)",
   label: "Linzi (CNLNZ)"
  },
  {
   value: "Liquan (CNLQN)",
   label: "Liquan (CNLQN)"
  },
  {
   value: "Lishui (CNLIS)",
   label: "Lishui (CNLIS)"
  },
  {
   value: "Lisui (CNLUI)",
   label: "Lisui (CNLUI)"
  },
  {
   value: "Liuan (CNIUA)",
   label: "Liuan (CNIUA)"
  },
  {
   value: "Liudu (CNLUD)",
   label: "Liudu (CNLUD)"
  },
  {
   value: "Liuhe (CNLHE)",
   label: "Liuhe (CNLHE)"
  },
  {
   value: "Liujia Pt (CNLJP)",
   label: "Liujia Pt (CNLJP)"
  },
  {
   value: "Liujiadu (CNLJD)",
   label: "Liujiadu (CNLJD)"
  },
  {
   value: "Liujing (CNLJN)",
   label: "Liujing (CNLJN)"
  },
  {
   value: "Liukou Pt (CNLKP)",
   label: "Liukou Pt (CNLKP)"
  },
  {
   value: "Liupanshui (CNLPS)",
   label: "Liupanshui (CNLPS)"
  },
  {
   value: "Liuyang (CNLIU)",
   label: "Liuyang (CNLIU)"
  },
  {
   value: "Liuzuo Pt (CNLZP)",
   label: "Liuzuo Pt (CNLZP)"
  },
  {
   value: "Liyang (CNLIY)",
   label: "Liyang (CNLIY)"
  },
  {
   value: "Liying Pt (CNLYP)",
   label: "Liying Pt (CNLYP)"
  },
  {
   value: "Longbang (CNLBG)",
   label: "Longbang (CNLBG)"
  },
  {
   value: "Longdong (CNLDG)",
   label: "Longdong (CNLDG)"
  },
  {
   value: "Lai An (CNLAA)",
   label: "Lai An (CNLAA)"
  },
  {
   value: "Laibin (CNLBI)",
   label: "Laibin (CNLBI)"
  },
  {
   value: "Laixi (CNLIX)",
   label: "Laixi (CNLIX)"
  },
  {
   value: "Laiyang (CNLAY)",
   label: "Laiyang (CNLAY)"
  },
  {
   value: "Laiyang (CNLYD)",
   label: "Laiyang (CNLYD)"
  },
  {
   value: "Langfang (CNLFG)",
   label: "Langfang (CNLFG)"
  },
  {
   value: "Lanshi (CNLAN)",
   label: "Lanshi (CNLAN)"
  },
  {
   value: "Lanshi (CNLSI)",
   label: "Lanshi (CNLSI)"
  },
  {
   value: "Lantianba Apt\/Luzhou (CNLZO)",
   label: "Lantianba Apt\/Luzhou (CNLZO)"
  },
  {
   value: "Lanxi (CNLXI)",
   label: "Lanxi (CNLXI)"
  },
  {
   value: "Lanzhou East (CNLZD)",
   label: "Lanzhou East (CNLZD)"
  },
  {
   value: "Laocheng (CNLLY)",
   label: "Laocheng (CNLLY)"
  },
  {
   value: "Laodukou (CNLDK)",
   label: "Laodukou (CNLDK)"
  },
  {
   value: "Laolong (CNLAL)",
   label: "Laolong (CNLAL)"
  },
  {
   value: "Laoxiahe (CNLXH)",
   label: "Laoxiahe (CNLXH)"
  },
  {
   value: "Leiyang (CNLYN)",
   label: "Leiyang (CNLYN)"
  },
  {
   value: "Leliu (CNLUU)",
   label: "Leliu (CNLUU)"
  },
  {
   value: "Leping (CNLPI)",
   label: "Leping (CNLPI)"
  },
  {
   value: "Leshan (CNLES)",
   label: "Leshan (CNLES)"
  },
  {
   value: "Letianxi Pt (CNLTP)",
   label: "Letianxi Pt (CNLTP)"
  },
  {
   value: "Lezhu (CNLEZ)",
   label: "Lezhu (CNLEZ)"
  },
  {
   value: "Liancheng (CNLHG)",
   label: "Liancheng (CNLHG)"
  },
  {
   value: "Liancheng Apt (CNLCX)",
   label: "Liancheng Apt (CNLCX)"
  },
  {
   value: "Liangping (CNLGP)",
   label: "Liangping (CNLGP)"
  },
  {
   value: "Lianjiang (CNLNJ)",
   label: "Lianjiang (CNLNJ)"
  },
  {
   value: "Lianxia (CNLNX)",
   label: "Lianxia (CNLNX)"
  },
  {
   value: "Lianzhou (CNLIO)",
   label: "Lianzhou (CNLIO)"
  },
  {
   value: "Lianzhou (CNLIZ)",
   label: "Lianzhou (CNLIZ)"
  },
  {
   value: "Liaocheng (CNLIG)",
   label: "Liaocheng (CNLIG)"
  },
  {
   value: "Jinshan (CNJSN)",
   label: "Jinshan (CNJSN)"
  },
  {
   value: "Jinshan Pt (CNJSP)",
   label: "Jinshan Pt (CNJSP)"
  },
  {
   value: "Jintan (CNJTN)",
   label: "Jintan (CNJTN)"
  },
  {
   value: "Jinwan (CNJWN)",
   label: "Jinwan (CNJWN)"
  },
  {
   value: "Jinxi (CNIXI)",
   label: "Jinxi (CNIXI)"
  },
  {
   value: "Jinyun (CNJYN)",
   label: "Jinyun (CNJYN)"
  },
  {
   value: "Jishou (CNJSO)",
   label: "Jishou (CNJSO)"
  },
  {
   value: "Jishui (CNJUI)",
   label: "Jishui (CNJUI)"
  },
  {
   value: "Jiugang (CNGDJ)",
   label: "Jiugang (CNGDJ)"
  },
  {
   value: "Jiujiang (CNJJG)",
   label: "Jiujiang (CNJJG)"
  },
  {
   value: "Jiuli (CNJUL)",
   label: "Jiuli (CNJUL)"
  },
  {
   value: "Jiulongpo (CNJLP)",
   label: "Jiulongpo (CNJLP)"
  },
  {
   value: "Jiuquan (CNCHW)",
   label: "Jiuquan (CNCHW)"
  },
  {
   value: "Jixi (CNXII)",
   label: "Jixi (CNXII)"
  },
  {
   value: "Jixian (CNJXA)",
   label: "Jixian (CNJXA)"
  },
  {
   value: "Jiyuan (CNJYA)",
   label: "Jiyuan (CNJYA)"
  },
  {
   value: "Jurong (CNJRG)",
   label: "Jurong (CNJRG)"
  },
  {
   value: "Kaifeng (CNKFG)",
   label: "Kaifeng (CNKFG)"
  },
  {
   value: "Kaihua (CNKAH)",
   label: "Kaihua (CNKAH)"
  },
  {
   value: "Kaiping (CNKAP)",
   label: "Kaiping (CNKAP)"
  },
  {
   value: "Kaiping (CNKPN)",
   label: "Kaiping (CNKPN)"
  },
  {
   value: "Kaiyun (CNKIY)",
   label: "Kaiyun (CNKIY)"
  },
  {
   value: "Kalasu (CNKLS)",
   label: "Kalasu (CNKLS)"
  },
  {
   value: "Kangqiao (CNKQI)",
   label: "Kangqiao (CNKQI)"
  },
  {
   value: "Kanmen (CNKMN)",
   label: "Kanmen (CNKMN)"
  },
  {
   value: "Karamay (CNKRY)",
   label: "Karamay (CNKRY)"
  },
  {
   value: "Korla (CNKRL)",
   label: "Korla (CNKRL)"
  },
  {
   value: "Kuiyong (CNKYG)",
   label: "Kuiyong (CNKYG)"
  },
  {
   value: "Kuqa Apt (CNKCA)",
   label: "Kuqa Apt (CNKCA)"
  },
  {
   value: "Jiaokou (CNJIK)",
   label: "Jiaokou (CNJIK)"
  },
  {
   value: "Jiaokou (CNJOK)",
   label: "Jiaokou (CNJOK)"
  },
  {
   value: "Jiaozhou (CNJZH)",
   label: "Jiaozhou (CNJZH)"
  },
  {
   value: "Jiaozuo (CNJZO)",
   label: "Jiaozuo (CNJZO)"
  },
  {
   value: "Jiashan (CNJSA)",
   label: "Jiashan (CNJSA)"
  },
  {
   value: "Jiayuguan Apt (CNJGN)",
   label: "Jiayuguan Apt (CNJGN)"
  },
  {
   value: "Jieshi (CNJES)",
   label: "Jieshi (CNJES)"
  },
  {
   value: "Jimiya (CNJIM)",
   label: "Jimiya (CNJIM)"
  },
  {
   value: "Jimo (CNJMO)",
   label: "Jimo (CNJMO)"
  },
  {
   value: "Jingan (CNJGA)",
   label: "Jingan (CNJGA)"
  },
  {
   value: "Jinggangshan Apt (CNJGS)",
   label: "Jinggangshan Apt (CNJGS)"
  },
  {
   value: "Jingjiang (CNTSI)",
   label: "Jingjiang (CNTSI)"
  },
  {
   value: "Jingmen (CNJGM)",
   label: "Jingmen (CNJGM)"
  },
  {
   value: "Jingtang (Tangshan) (CNJIN)",
   label: "Jingtang (Tangshan) (CNJIN)"
  },
  {
   value: "Jinguzhou (CNJGU)",
   label: "Jinguzhou (CNJGU)"
  },
  {
   value: "Jingxian (CNJGX)",
   label: "Jingxian (CNJGX)"
  },
  {
   value: "Jingzhou (CNJGZ)",
   label: "Jingzhou (CNJGZ)"
  },
  {
   value: "Jinhekou (CNJHK)",
   label: "Jinhekou (CNJHK)"
  },
  {
   value: "Jining (CNJNN)",
   label: "Jining (CNJNN)"
  },
  {
   value: "Jinjiang (CNJJI)",
   label: "Jinjiang (CNJJI)"
  },
  {
   value: "Jinjiang (CNJJN)",
   label: "Jinjiang (CNJJN)"
  },
  {
   value: "Jinjiang (CNJNA)",
   label: "Jinjiang (CNJNA)"
  },
  {
   value: "Jinjing (CNJNI)",
   label: "Jinjing (CNJNI)"
  },
  {
   value: "Jinli (CNJNL)",
   label: "Jinli (CNJNL)"
  },
  {
   value: "Jinpai (CNJPI)",
   label: "Jinpai (CNJPI)"
  },
  {
   value: "Jinqiao (CNJQI)",
   label: "Jinqiao (CNJQI)"
  },
  {
   value: "Hulan Ergi (CNHLE)",
   label: "Hulan Ergi (CNHLE)"
  },
  {
   value: "Huludao (CNHLO)",
   label: "Huludao (CNHLO)"
  },
  {
   value: "Huo Pt (CNHUP)",
   label: "Huo Pt (CNHUP)"
  },
  {
   value: "Hutubi (CNXJH)",
   label: "Hutubi (CNXJH)"
  },
  {
   value: "Inner Mongolia (CNNMG)",
   label: "Inner Mongolia (CNNMG)"
  },
  {
   value: "Jianbi (CNJBI)",
   label: "Jianbi (CNJBI)"
  },
  {
   value: "Jiande (CNJDE)",
   label: "Jiande (CNJDE)"
  },
  {
   value: "Jiangchuan (CNJCN)",
   label: "Jiangchuan (CNJCN)"
  },
  {
   value: "Jiangcun (CNJIC)",
   label: "Jiangcun (CNJIC)"
  },
  {
   value: "Jiangdu (CNJND)",
   label: "Jiangdu (CNJND)"
  },
  {
   value: "Jianghai (CNJGH)",
   label: "Jianghai (CNJGH)"
  },
  {
   value: "Jiangjin (CNJGJ)",
   label: "Jiangjin (CNJGJ)"
  },
  {
   value: "Jiangkou (CNJKO)",
   label: "Jiangkou (CNJKO)"
  },
  {
   value: "Jiangkou (CNJKU)",
   label: "Jiangkou (CNJKU)"
  },
  {
   value: "Jiangle (CNJLE)",
   label: "Jiangle (CNJLE)"
  },
  {
   value: "Jiangping (CNJIP)",
   label: "Jiangping (CNJIP)"
  },
  {
   value: "Jiangpu (CNJPU)",
   label: "Jiangpu (CNJPU)"
  },
  {
   value: "Jiangshan (CNJHN)",
   label: "Jiangshan (CNJHN)"
  },
  {
   value: "Jiangsi (CNGJS)",
   label: "Jiangsi (CNGJS)"
  },
  {
   value: "Jiangsiu (CNJSU)",
   label: "Jiangsiu (CNJSU)"
  },
  {
   value: "Jiangyan (CNJYS)",
   label: "Jiangyan (CNJYS)"
  },
  {
   value: "Jiangyin (CNJGY)",
   label: "Jiangyin (CNJGY)"
  },
  {
   value: "Jianli (CNJLI)",
   label: "Jianli (CNJLI)"
  },
  {
   value: "Jiantiao (CNJTO)",
   label: "Jiantiao (CNJTO)"
  },
  {
   value: "Jianyang (CNJAG)",
   label: "Jianyang (CNJAG)"
  },
  {
   value: "Jiao Xin (CNJXN)",
   label: "Jiao Xin (CNJXN)"
  },
  {
   value: "Jiaojiang (CNJOJ)",
   label: "Jiaojiang (CNJOJ)"
  },
  {
   value: "Huaiji (CNHIJ)",
   label: "Huaiji (CNHIJ)"
  },
  {
   value: "Huaiyin (CNAIN)",
   label: "Huaiyin (CNAIN)"
  },
  {
   value: "Huangbu (CNHBU)",
   label: "Huangbu (CNHBU)"
  },
  {
   value: "Huangcun (CNHGC)",
   label: "Huangcun (CNHGC)"
  },
  {
   value: "Huangge (CNHGE)",
   label: "Huangge (CNHGE)"
  },
  {
   value: "Huanghua (CNHGU)",
   label: "Huanghua (CNHGU)"
  },
  {
   value: "Huanghua (CNHHA)",
   label: "Huanghua (CNHHA)"
  },
  {
   value: "Huanghua (CNHNH)",
   label: "Huanghua (CNHNH)"
  },
  {
   value: "Huangjiang (CNHGJ)",
   label: "Huangjiang (CNHGJ)"
  },
  {
   value: "Huangjiang Town (CNHJI)",
   label: "Huangjiang Town (CNHJI)"
  },
  {
   value: "Huangjin Apt\/Ganzhou (CNKOW)",
   label: "Huangjin Apt\/Ganzhou (CNKOW)"
  },
  {
   value: "Huangpo (CNHAP)",
   label: "Huangpo (CNHAP)"
  },
  {
   value: "Huangpu New Port (CNHUN)",
   label: "Huangpu New Port (CNHUN)"
  },
  {
   value: "Huangpu Old Port (CNHOP)",
   label: "Huangpu Old Port (CNHOP)"
  },
  {
   value: "Huangqi (CNHGQ)",
   label: "Huangqi (CNHGQ)"
  },
  {
   value: "Huangqi\/Nanhai (CNHAQ)",
   label: "Huangqi\/Nanhai (CNHAQ)"
  },
  {
   value: "Huangsangkou (CNHSK)",
   label: "Huangsangkou (CNHSK)"
  },
  {
   value: "Huangxian (CNANG)",
   label: "Huangxian (CNANG)"
  },
  {
   value: "Huangxingdao (CNHXD)",
   label: "Huangxingdao (CNHXD)"
  },
  {
   value: "Huangyan (CNHYN)",
   label: "Huangyan (CNHYN)"
  },
  {
   value: "Huangzhou (CNHZO)",
   label: "Huangzhou (CNHZO)"
  },
  {
   value: "Huanshi (CNHNS)",
   label: "Huanshi (CNHNS)"
  },
  {
   value: "Huashi (CNHUS)",
   label: "Huashi (CNHUS)"
  },
  {
   value: "Huayang (CNHUY)",
   label: "Huayang (CNHUY)"
  },
  {
   value: "Huazhou (CNHUZ)",
   label: "Huazhou (CNHUZ)"
  },
  {
   value: "Huchen (CNHUE)",
   label: "Huchen (CNHUE)"
  },
  {
   value: "Huidong (CNHUW)",
   label: "Huidong (CNHUW)"
  },
  {
   value: "Huikou (CNHIK)",
   label: "Huikou (CNHIK)"
  },
  {
   value: "Huilong (CNHLN)",
   label: "Huilong (CNHLN)"
  },
  {
   value: "Huiqiang (CNHQG)",
   label: "Huiqiang (CNHQG)"
  },
  {
   value: "Huizhou Pt (CNHZP)",
   label: "Huizhou Pt (CNHZP)"
  },
  {
   value: "Hukou (CNHKU)",
   label: "Hukou (CNHKU)"
  },
  {
   value: "Hengqin (CNHQI)",
   label: "Hengqin (CNHQI)"
  },
  {
   value: "Hengshui (CNHIS)",
   label: "Hengshui (CNHIS)"
  },
  {
   value: "Hengxian (CNHXA)",
   label: "Hengxian (CNHXA)"
  },
  {
   value: "Henshui (CNHES)",
   label: "Henshui (CNHES)"
  },
  {
   value: "Hepu (CNHEP)",
   label: "Hepu (CNHEP)"
  },
  {
   value: "Heshan (CNHAS)",
   label: "Heshan (CNHAS)"
  },
  {
   value: "Heshun (CNHHU)",
   label: "Heshun (CNHHU)"
  },
  {
   value: "Heyang (CNHYA)",
   label: "Heyang (CNHYA)"
  },
  {
   value: "Heyuan (CNHEY)",
   label: "Heyuan (CNHEY)"
  },
  {
   value: "Heze (CNHEZ)",
   label: "Heze (CNHEZ)"
  },
  {
   value: "Heze (CNHZS)",
   label: "Heze (CNHZS)"
  },
  {
   value: "Hongdu (CNHOD)",
   label: "Hongdu (CNHOD)"
  },
  {
   value: "Hongguang (CNHOG)",
   label: "Hongguang (CNHOG)"
  },
  {
   value: "Honghai (CNSHW)",
   label: "Honghai (CNSHW)"
  },
  {
   value: "Honghaihu (CNHHH)",
   label: "Honghaihu (CNHHH)"
  },
  {
   value: "Honghu (CNHOH)",
   label: "Honghu (CNHOH)"
  },
  {
   value: "Honghua (CNHGA)",
   label: "Honghua (CNHGA)"
  },
  {
   value: "Hongkou (CNHGK)",
   label: "Hongkou (CNHGK)"
  },
  {
   value: "Hongqi (CNHOQ)",
   label: "Hongqi (CNHOQ)"
  },
  {
   value: "Hongqiao (CNHGO)",
   label: "Hongqiao (CNHGO)"
  },
  {
   value: "Hongtong (CNHNT)",
   label: "Hongtong (CNHNT)"
  },
  {
   value: "Hongwan (CNHGW)",
   label: "Hongwan (CNHGW)"
  },
  {
   value: "Hongze Xian (CNHON)",
   label: "Hongze Xian (CNHON)"
  },
  {
   value: "Hotan (CNHTS)",
   label: "Hotan (CNHTS)"
  },
  {
   value: "Hotan Apt (CNHTN)",
   label: "Hotan Apt (CNHTN)"
  },
  {
   value: "Houan (CNHOA)",
   label: "Houan (CNHOA)"
  },
  {
   value: "Houjie (CNHOU)",
   label: "Houjie (CNHOU)"
  },
  {
   value: "Houzhu (CNHZU)",
   label: "Houzhu (CNHZU)"
  },
  {
   value: "Huadu (CNHDU)",
   label: "Huadu (CNHDU)"
  },
  {
   value: "Huaibei (CNHBI)",
   label: "Huaibei (CNHBI)"
  },
  {
   value: "Huaihua (CNHUH)",
   label: "Huaihua (CNHUH)"
  },
  {
   value: "Haikou New Pt (CNHNP)",
   label: "Haikou New Pt (CNHNP)"
  },
  {
   value: "Haikou Pt (CNHKP)",
   label: "Haikou Pt (CNHKP)"
  },
  {
   value: "Haimen Pt (CNHMP)",
   label: "Haimen Pt (CNHMP)"
  },
  {
   value: "Haimiao (CNHIM)",
   label: "Haimiao (CNHIM)"
  },
  {
   value: "Haining (CNHIN)",
   label: "Haining (CNHIN)"
  },
  {
   value: "Haitang\/Shekou (CNHAT)",
   label: "Haitang\/Shekou (CNHAT)"
  },
  {
   value: "Haitou (CNHTO)",
   label: "Haitou (CNHTO)"
  },
  {
   value: "Haiyang (CNHAD)",
   label: "Haiyang (CNHAD)"
  },
  {
   value: "Haiyang (CNHAY)",
   label: "Haiyang (CNHAY)"
  },
  {
   value: "Haizhu (CNHIZ)",
   label: "Haizhu (CNHIZ)"
  },
  {
   value: "Hami (CNHMI)",
   label: "Hami (CNHMI)"
  },
  {
   value: "Handan (CNHDX)",
   label: "Handan (CNHDX)"
  },
  {
   value: "Hanjiang (CNHAN)",
   label: "Hanjiang (CNHAN)"
  },
  {
   value: "Hanzhong (CNHZG)",
   label: "Hanzhong (CNHZG)"
  },
  {
   value: "Haoxue (CNHXE)",
   label: "Haoxue (CNHXE)"
  },
  {
   value: "Hebei (CNHEB)",
   label: "Hebei (CNHEB)"
  },
  {
   value: "Hecheng (CNHCG)",
   label: "Hecheng (CNHCG)"
  },
  {
   value: "Hechi (CNHCH)",
   label: "Hechi (CNHCH)"
  },
  {
   value: "Hedong Apt\/Yinchuan (CNINC)",
   label: "Hedong Apt\/Yinchuan (CNINC)"
  },
  {
   value: "Hehua Apt\/Zhangjiajie (CNDYG)",
   label: "Hehua Apt\/Zhangjiajie (CNDYG)"
  },
  {
   value: "Heishan (CNHSA)",
   label: "Heishan (CNHSA)"
  },
  {
   value: "Hengdian (CNHEN)",
   label: "Hengdian (CNHEN)"
  },
  {
   value: "Henggang (CNHGG)",
   label: "Henggang (CNHGG)"
  },
  {
   value: "Hengli (CNHNI)",
   label: "Hengli (CNHNI)"
  },
  {
   value: "Guangli (CNGLI)",
   label: "Guangli (CNGLI)"
  },
  {
   value: "Guangning (CNGNG)",
   label: "Guangning (CNGNG)"
  },
  {
   value: "Guangning (CNGNI)",
   label: "Guangning (CNGNI)"
  },
  {
   value: "Guangong Apt\/Yuncheng (CNYCU)",
   label: "Guangong Apt\/Yuncheng (CNYCU)"
  },
  {
   value: "Guangrao (CNGRO)",
   label: "Guangrao (CNGRO)"
  },
  {
   value: "Guangshui (CNGGS)",
   label: "Guangshui (CNGGS)"
  },
  {
   value: "Guangyuan (CNGYN)",
   label: "Guangyuan (CNGYN)"
  },
  {
   value: "Guangyuan Apt (CNGYS)",
   label: "Guangyuan Apt (CNGYS)"
  },
  {
   value: "Guangzhou (CNXSA)",
   label: "Guangzhou (CNXSA)"
  },
  {
   value: "Guangzhou Pt (CNGZP)",
   label: "Guangzhou Pt (CNGZP)"
  },
  {
   value: "Guanlin (CNGNL)",
   label: "Guanlin (CNGNL)"
  },
  {
   value: "Guanyao (CNGYO)",
   label: "Guanyao (CNGYO)"
  },
  {
   value: "Guchengli (CNGCL)",
   label: "Guchengli (CNGCL)"
  },
  {
   value: "Gud (CNCZH)",
   label: "Gud (CNCZH)"
  },
  {
   value: "Guicheng (CNGCE)",
   label: "Guicheng (CNGCE)"
  },
  {
   value: "Guicheng (CNGCG)",
   label: "Guicheng (CNGCG)"
  },
  {
   value: "Guilinyang (CNGYG)",
   label: "Guilinyang (CNGYG)"
  },
  {
   value: "Guiping (CNGPG)",
   label: "Guiping (CNGPG)"
  },
  {
   value: "Guishan (CNGSH)",
   label: "Guishan (CNGSH)"
  },
  {
   value: "Guitai (CNGTI)",
   label: "Guitai (CNGTI)"
  },
  {
   value: "Guixi (CNGXI)",
   label: "Guixi (CNGXI)"
  },
  {
   value: "Guizhou (CNGZU)",
   label: "Guizhou (CNGZU)"
  },
  {
   value: "Gujing (CNGJG)",
   label: "Gujing (CNGJG)"
  },
  {
   value: "Guzhen (CNGZE)",
   label: "Guzhen (CNGZE)"
  },
  {
   value: "Guzhen (CNGZH)",
   label: "Guzhen (CNGZH)"
  },
  {
   value: "Guzhu (CNGUZ)",
   label: "Guzhu (CNGUZ)"
  },
  {
   value: "Haian (CNHAA)",
   label: "Haian (CNHAA)"
  },
  {
   value: "Haidian (CNHDN)",
   label: "Haidian (CNHDN)"
  },
  {
   value: "Haigeng (CNHGN)",
   label: "Haigeng (CNHGN)"
  },
  {
   value: "Fuzhou Pt (CNFZP)",
   label: "Fuzhou Pt (CNFZP)"
  },
  {
   value: "Gaizhou (CNGAI)",
   label: "Gaizhou (CNGAI)"
  },
  {
   value: "Galolan (CNGAL)",
   label: "Galolan (CNGAL)"
  },
  {
   value: "Gangluan (CNGUL)",
   label: "Gangluan (CNGUL)"
  },
  {
   value: "Ganzhou (CNGAZ)",
   label: "Ganzhou (CNGAZ)"
  },
  {
   value: "Gaobu (CNGBU)",
   label: "Gaobu (CNGBU)"
  },
  {
   value: "Gaochun (CNGOC)",
   label: "Gaochun (CNGOC)"
  },
  {
   value: "Gaolan (CNGLN)",
   label: "Gaolan (CNGLN)"
  },
  {
   value: "Gaolan (CNGON)",
   label: "Gaolan (CNGON)"
  },
  {
   value: "Gaolan (CNZGL)",
   label: "Gaolan (CNZGL)"
  },
  {
   value: "Gaoleng (CNGLG)",
   label: "Gaoleng (CNGLG)"
  },
  {
   value: "Gaomi (CNGMI)",
   label: "Gaomi (CNGMI)"
  },
  {
   value: "Gaosha (CNGAS)",
   label: "Gaosha (CNGAS)"
  },
  {
   value: "Gaotang (CNGTG)",
   label: "Gaotang (CNGTG)"
  },
  {
   value: "Gaoyou (CNGYU)",
   label: "Gaoyou (CNGYU)"
  },
  {
   value: "Gaozhou (CNGXC)",
   label: "Gaozhou (CNGXC)"
  },
  {
   value: "Gedian (CNGDI)",
   label: "Gedian (CNGDI)"
  },
  {
   value: "Golmud (CNGOQ)",
   label: "Golmud (CNGOQ)"
  },
  {
   value: "Gongan (CNGGN)",
   label: "Gongan (CNGGN)"
  },
  {
   value: "Gongguan (CNGGU)",
   label: "Gongguan (CNGGU)"
  },
  {
   value: "Gonglu (CNGLU)",
   label: "Gonglu (CNGLU)"
  },
  {
   value: "Gongming (CNGOG)",
   label: "Gongming (CNGOG)"
  },
  {
   value: "Gongyi (CNGGY)",
   label: "Gongyi (CNGGY)"
  },
  {
   value: "Goubangzi (CNGBZ)",
   label: "Goubangzi (CNGBZ)"
  },
  {
   value: "Guan (CNGAN)",
   label: "Guan (CNGAN)"
  },
  {
   value: "Guancheng (CNGCH)",
   label: "Guancheng (CNGCH)"
  },
  {
   value: "Guandu (CNGDU)",
   label: "Guandu (CNGDU)"
  },
  {
   value: "Guangbaotong (CNGBT)",
   label: "Guangbaotong (CNGBT)"
  },
  {
   value: "Guangdong (CNGUA)",
   label: "Guangdong (CNGUA)"
  },
  {
   value: "Guangfu (CNGFU)",
   label: "Guangfu (CNGFU)"
  },
  {
   value: "Guanghan (CNGHN)",
   label: "Guanghan (CNGHN)"
  },
  {
   value: "Guanghua (CNLHK)",
   label: "Guanghua (CNLHK)"
  },
  {
   value: "Fangxianzhen (CNFAX)",
   label: "Fangxianzhen (CNFAX)"
  },
  {
   value: "Fangzheng (CNFZG)",
   label: "Fangzheng (CNFZG)"
  },
  {
   value: "Feicheng (CNFEC)",
   label: "Feicheng (CNFEC)"
  },
  {
   value: "Fengcheng (CNFCE)",
   label: "Fengcheng (CNFCE)"
  },
  {
   value: "Fengdu (CNFDU)",
   label: "Fengdu (CNFDU)"
  },
  {
   value: "Fenghuangjichang Pt (CNFHP)",
   label: "Fenghuangjichang Pt (CNFHP)"
  },
  {
   value: "Fengjie (CNFJE)",
   label: "Fengjie (CNFJE)"
  },
  {
   value: "Fengkai (CNFKI)",
   label: "Fengkai (CNFKI)"
  },
  {
   value: "Fengxian (CNFGX)",
   label: "Fengxian (CNFGX)"
  },
  {
   value: "Fengxian Pt (CNFXP)",
   label: "Fengxian Pt (CNFXP)"
  },
  {
   value: "Foshan Apt (CNFUO)",
   label: "Foshan Apt (CNFUO)"
  },
  {
   value: "Foshan new port (CNFRT)",
   label: "Foshan new port (CNFRT)"
  },
  {
   value: "Fucheng (CNFUC)",
   label: "Fucheng (CNFUC)"
  },
  {
   value: "Fuchi (CNFCH)",
   label: "Fuchi (CNFCH)"
  },
  {
   value: "Fugang (CNFAG)",
   label: "Fugang (CNFAG)"
  },
  {
   value: "Fukang (CNFKA)",
   label: "Fukang (CNFKA)"
  },
  {
   value: "Fuling (CNFLG)",
   label: "Fuling (CNFLG)"
  },
  {
   value: "Fuping (CNFPG)",
   label: "Fuping (CNFPG)"
  },
  {
   value: "Fuqing (CNFQG)",
   label: "Fuqing (CNFQG)"
  },
  {
   value: "Fushan (CNFSA)",
   label: "Fushan (CNFSA)"
  },
  {
   value: "Fusui (CNFSI)",
   label: "Fusui (CNFSI)"
  },
  {
   value: "Fuwan (CNFWN)",
   label: "Fuwan (CNFWN)"
  },
  {
   value: "Fuxing (CNFXG)",
   label: "Fuxing (CNFXG)"
  },
  {
   value: "Fuyang (CNFUN)",
   label: "Fuyang (CNFUN)"
  },
  {
   value: "Fuyang (CNFYA)",
   label: "Fuyang (CNFYA)"
  },
  {
   value: "Fuyong (CNFNG)",
   label: "Fuyong (CNFNG)"
  },
  {
   value: "Fuyun (CNFYN)",
   label: "Fuyun (CNFYN)"
  },
  {
   value: "Donghai (CNDNG)",
   label: "Donghai (CNDNG)"
  },
  {
   value: "Donghu (CNDOH)",
   label: "Donghu (CNDOH)"
  },
  {
   value: "Dongjiang (CNDJG)",
   label: "Dongjiang (CNDJG)"
  },
  {
   value: "Dongjiangkou (CNDOO)",
   label: "Dongjiangkou (CNDOO)"
  },
  {
   value: "Dongliu (CNDLI)",
   label: "Dongliu (CNDLI)"
  },
  {
   value: "Dongming (CNDOM)",
   label: "Dongming (CNDOM)"
  },
  {
   value: "Dongping (CNDPN)",
   label: "Dongping (CNDPN)"
  },
  {
   value: "Dongshi (CNDSI)",
   label: "Dongshi (CNDSI)"
  },
  {
   value: "Dongsunba (CNDSB)",
   label: "Dongsunba (CNDSB)"
  },
  {
   value: "Dongtai (CNDGT)",
   label: "Dongtai (CNDGT)"
  },
  {
   value: "Dongyang (CNDYA)",
   label: "Dongyang (CNDYA)"
  },
  {
   value: "Dongying (CNDGY)",
   label: "Dongying (CNDGY)"
  },
  {
   value: "Dongyuan (CNDGN)",
   label: "Dongyuan (CNDGN)"
  },
  {
   value: "Dongzhang (CNDOZ)",
   label: "Dongzhang (CNDOZ)"
  },
  {
   value: "Douhudi (CNDHD)",
   label: "Douhudi (CNDHD)"
  },
  {
   value: "Ducheng (CNDCG)",
   label: "Ducheng (CNDCG)"
  },
  {
   value: "Dulata (CNDLT)",
   label: "Dulata (CNDLT)"
  },
  {
   value: "Dunhuang Apt (CNDNH)",
   label: "Dunhuang Apt (CNDNH)"
  },
  {
   value: "Duruan Town (CNDUR)",
   label: "Duruan Town (CNDUR)"
  },
  {
   value: "Dushanzi (CNDSZ)",
   label: "Dushanzi (CNDSZ)"
  },
  {
   value: "Echeng (CNECG)",
   label: "Echeng (CNECG)"
  },
  {
   value: "Erba (CNEBA)",
   label: "Erba (CNEBA)"
  },
  {
   value: "Ergun (CNEGN)",
   label: "Ergun (CNEGN)"
  },
  {
   value: "Ertaokou (CNETK)",
   label: "Ertaokou (CNETK)"
  },
  {
   value: "Ezhou (CNEZH)",
   label: "Ezhou (CNEZH)"
  },
  {
   value: "Faku (CNFKU)",
   label: "Faku (CNFKU)"
  },
  {
   value: "Fangcun (CNFCN)",
   label: "Fangcun (CNFCN)"
  },
  {
   value: "Fangcun (CNFGN)",
   label: "Fangcun (CNFGN)"
  },
  {
   value: "Fangshan (CNFAS)",
   label: "Fangshan (CNFAS)"
  },
  {
   value: "Dasong (CNDSO)",
   label: "Dasong (CNDSO)"
  },
  {
   value: "Dawa (CNDAW)",
   label: "Dawa (CNDAW)"
  },
  {
   value: "Dawan (CNDWN)",
   label: "Dawan (CNDWN)"
  },
  {
   value: "Dawang (CNDWA)",
   label: "Dawang (CNDWA)"
  },
  {
   value: "Daxian (CNDAX)",
   label: "Daxian (CNDAX)"
  },
  {
   value: "Daxie (CNDXI)",
   label: "Daxie (CNDXI)"
  },
  {
   value: "Daxu (CNDXU)",
   label: "Daxu (CNDXU)"
  },
  {
   value: "Daya Wan (CNDAY)",
   label: "Daya Wan (CNDAY)"
  },
  {
   value: "Dayi (CNDYI)",
   label: "Dayi (CNDYI)"
  },
  {
   value: "Daze (CNDAZ)",
   label: "Daze (CNDAZ)"
  },
  {
   value: "Dazhaoying (CNDZY)",
   label: "Dazhaoying (CNDZY)"
  },
  {
   value: "Dazu (CNDZU)",
   label: "Dazu (CNDZU)"
  },
  {
   value: "Defeng (CNDEF)",
   label: "Defeng (CNDEF)"
  },
  {
   value: "Dehua (CNDEA)",
   label: "Dehua (CNDEA)"
  },
  {
   value: "Dehua (CNDHA)",
   label: "Dehua (CNDHA)"
  },
  {
   value: "Dehui (CNDEH)",
   label: "Dehui (CNDEH)"
  },
  {
   value: "Dengta (CNDEN)",
   label: "Dengta (CNDEN)"
  },
  {
   value: "Deqing (CNDEI)",
   label: "Deqing (CNDEI)"
  },
  {
   value: "Deqing (CNDEQ)",
   label: "Deqing (CNDEQ)"
  },
  {
   value: "Deyang (CNDEY)",
   label: "Deyang (CNDEY)"
  },
  {
   value: "Dezhou (CNDEZ)",
   label: "Dezhou (CNDEZ)"
  },
  {
   value: "Dianbai (CNDBI)",
   label: "Dianbai (CNDBI)"
  },
  {
   value: "Didou (CNDDU)",
   label: "Didou (CNDDU)"
  },
  {
   value: "Digang (CNDIA)",
   label: "Digang (CNDIA)"
  },
  {
   value: "Ding An (CNDGA)",
   label: "Ding An (CNDGA)"
  },
  {
   value: "Dingcheng (CNDCE)",
   label: "Dingcheng (CNDCE)"
  },
  {
   value: "Dinghu (CNDGH)",
   label: "Dinghu (CNDGH)"
  },
  {
   value: "Dongbang (CNDBG)",
   label: "Dongbang (CNDBG)"
  },
  {
   value: "Dongchen (CNDCN)",
   label: "Dongchen (CNDCN)"
  },
  {
   value: "Dongfang (CNDFA)",
   label: "Dongfang (CNDFA)"
  },
  {
   value: "Dongfeng (CNDFG)",
   label: "Dongfeng (CNDFG)"
  },
  {
   value: "Dongfeng (CNDFN)",
   label: "Dongfeng (CNDFN)"
  },
  {
   value: "Dongguan Apt (CNDGM)",
   label: "Dongguan Apt (CNDGM)"
  },
  {
   value: "Dongguo (CNDGO)",
   label: "Dongguo (CNDGO)"
  },
  {
   value: "Dachang (CNDCH)",
   label: "Dachang (CNDCH)"
  },
  {
   value: "Dachangshandao Apt\/Changhai (CNCNI)",
   label: "Dachangshandao Apt\/Changhai (CNCNI)"
  },
  {
   value: "Dachendao (CNDCD)",
   label: "Dachendao (CNDCD)"
  },
  {
   value: "Dadingzi (CNDIZ)",
   label: "Dadingzi (CNDIZ)"
  },
  {
   value: "Dadukou (CNDDK)",
   label: "Dadukou (CNDDK)"
  },
  {
   value: "Dafeng (CNDFE)",
   label: "Dafeng (CNDFE)"
  },
  {
   value: "Dahuangpu (CNDHP)",
   label: "Dahuangpu (CNDHP)"
  },
  {
   value: "Dai Ming (CNDAI)",
   label: "Dai Ming (CNDAI)"
  },
  {
   value: "Dajing (CNDJI)",
   label: "Dajing (CNDJI)"
  },
  {
   value: "Dalang (CNDLG)",
   label: "Dalang (CNDLG)"
  },
  {
   value: "Dali (CNALI)",
   label: "Dali (CNALI)"
  },
  {
   value: "Dali (CNDAL)",
   label: "Dali (CNDAL)"
  },
  {
   value: "Dalian Dayaowan (CNDYW)",
   label: "Dalian Dayaowan (CNDYW)"
  },
  {
   value: "Daliangang (CNDLP)",
   label: "Daliangang (CNDLP)"
  },
  {
   value: "Dalicity Apt (CNDLU)",
   label: "Dalicity Apt (CNDLU)"
  },
  {
   value: "Dalingshan (CNDLN)",
   label: "Dalingshan (CNDLN)"
  },
  {
   value: "Daluo (CNDLO)",
   label: "Daluo (CNDLO)"
  },
  {
   value: "Damaiyu (CNDMY)",
   label: "Damaiyu (CNDMY)"
  },
  {
   value: "Dandong Pt (CNDDP)",
   label: "Dandong Pt (CNDDP)"
  },
  {
   value: "Dangshan (CNDAG)",
   label: "Dangshan (CNDAG)"
  },
  {
   value: "Dantu (CNDNT)",
   label: "Dantu (CNDNT)"
  },
  {
   value: "Dantu Xian (CNDTU)",
   label: "Dantu Xian (CNDTU)"
  },
  {
   value: "Danzhou (CNDHU)",
   label: "Danzhou (CNDHU)"
  },
  {
   value: "Danzhou (CNDZO)",
   label: "Danzhou (CNDZO)"
  },
  {
   value: "Daojiao (CNDJO)",
   label: "Daojiao (CNDJO)"
  },
  {
   value: "Dapeng (CNDPG)",
   label: "Dapeng (CNDPG)"
  },
  {
   value: "Daqindao (CNDQD)",
   label: "Daqindao (CNDQD)"
  },
  {
   value: "Dasha (CNDSA)",
   label: "Dasha (CNDSA)"
  },
  {
   value: "Dashihuagang (CNDAS)",
   label: "Dashihuagang (CNDAS)"
  },
  {
   value: "Chen Barag (CNCBG)",
   label: "Chen Barag (CNCBG)"
  },
  {
   value: "Chencun (CNCUN)",
   label: "Chencun (CNCUN)"
  },
  {
   value: "Chengcheng (CNCHH)",
   label: "Chengcheng (CNCHH)"
  },
  {
   value: "Chengde (CNCNG)",
   label: "Chengde (CNCNG)"
  },
  {
   value: "Chengjiang (CNCJI)",
   label: "Chengjiang (CNCJI)"
  },
  {
   value: "Chengxi (CNCHX)",
   label: "Chengxi (CNCHX)"
  },
  {
   value: "Chenjiagang (CNCIG)",
   label: "Chenjiagang (CNCIG)"
  },
  {
   value: "Chenjian (CNCJN)",
   label: "Chenjian (CNCJN)"
  },
  {
   value: "Chenjiaping (CNCJP)",
   label: "Chenjiaping (CNCJP)"
  },
  {
   value: "Chenzhou (CNCNZ)",
   label: "Chenzhou (CNCNZ)"
  },
  {
   value: "Cheyanghe (CNCYH)",
   label: "Cheyanghe (CNCYH)"
  },
  {
   value: "Chibi (CNCBI)",
   label: "Chibi (CNCBI)"
  },
  {
   value: "Chifeng (CNCHI)",
   label: "Chifeng (CNCHI)"
  },
  {
   value: "Chikan (CNCKA)",
   label: "Chikan (CNCKA)"
  },
  {
   value: "Chongming (CNCMG)",
   label: "Chongming (CNCMG)"
  },
  {
   value: "Chongxing (CNCXN)",
   label: "Chongxing (CNCXN)"
  },
  {
   value: "Chongzuo (CNCGZ)",
   label: "Chongzuo (CNCGZ)"
  },
  {
   value: "Chuanshan (CNCHS)",
   label: "Chuanshan (CNCHS)"
  },
  {
   value: "Chumen (CNCUM)",
   label: "Chumen (CNCUM)"
  },
  {
   value: "Chunan (CNUNA)",
   label: "Chunan (CNUNA)"
  },
  {
   value: "Chuxiong (CNCXI)",
   label: "Chuxiong (CNCXI)"
  },
  {
   value: "Chuzhou (CNCHZ)",
   label: "Chuzhou (CNCHZ)"
  },
  {
   value: "Chuzhuangsi (CNCUZ)",
   label: "Chuzhuangsi (CNCUZ)"
  },
  {
   value: "Cicheng (CNCCH)",
   label: "Cicheng (CNCCH)"
  },
  {
   value: "Cixi (CNCIX)",
   label: "Cixi (CNCIX)"
  },
  {
   value: "Congjiang (CNCJA)",
   label: "Congjiang (CNCJA)"
  },
  {
   value: "Da Chan Bay (CNDCB)",
   label: "Da Chan Bay (CNDCB)"
  },
  {
   value: "Da Sha Town (CNDST)",
   label: "Da Sha Town (CNDST)"
  },
  {
   value: "Cangxi (CNCGX)",
   label: "Cangxi (CNCGX)"
  },
  {
   value: "Cangzhou (CNCZU)",
   label: "Cangzhou (CNCZU)"
  },
  {
   value: "Caofeidian (CNCFD)",
   label: "Caofeidian (CNCFD)"
  },
  {
   value: "Caojing (CNCJG)",
   label: "Caojing (CNCJG)"
  },
  {
   value: "Capital International Apt\/Beijing (CNPEK)",
   label: "Capital International Apt\/Beijing (CNPEK)"
  },
  {
   value: "Ceke (CNCKE)",
   label: "Ceke (CNCKE)"
  },
  {
   value: "Cenxi (CNCEX)",
   label: "Cenxi (CNCEX)"
  },
  {
   value: "Chaiwan (CNCAW)",
   label: "Chaiwan (CNCAW)"
  },
  {
   value: "Changbai (CNCGB)",
   label: "Changbai (CNCGB)"
  },
  {
   value: "Changdao (CNCDO)",
   label: "Changdao (CNCDO)"
  },
  {
   value: "Changde (CNCDE)",
   label: "Changde (CNCDE)"
  },
  {
   value: "Changhua (CNCAH)",
   label: "Changhua (CNCAH)"
  },
  {
   value: "Changji (CNXJC)",
   label: "Changji (CNXJC)"
  },
  {
   value: "Changjiang Lizu Zizhixian (CNCLZ)",
   label: "Changjiang Lizu Zizhixian (CNCLZ)"
  },
  {
   value: "Changjing (CNCGJ)",
   label: "Changjing (CNCGJ)"
  },
  {
   value: "Changle (CNCHA)",
   label: "Changle (CNCHA)"
  },
  {
   value: "Changliu (CNCGI)",
   label: "Changliu (CNCGI)"
  },
  {
   value: "Changsha (CNCNA)",
   label: "Changsha (CNCNA)"
  },
  {
   value: "Changshou (CNCSJ)",
   label: "Changshou (CNCSJ)"
  },
  {
   value: "Changshou (CNCSO)",
   label: "Changshou (CNCSO)"
  },
  {
   value: "Changtu (CNCNT)",
   label: "Changtu (CNCNT)"
  },
  {
   value: "Changzhi (CNCIH)",
   label: "Changzhi (CNCIH)"
  },
  {
   value: "Chaoan (CNCON)",
   label: "Chaoan (CNCON)"
  },
  {
   value: "Chaohu (CNCHU)",
   label: "Chaohu (CNCHU)"
  },
  {
   value: "Chaotianmen (CNCTM)",
   label: "Chaotianmen (CNCTM)"
  },
  {
   value: "Chaoyang (CNCHY)",
   label: "Chaoyang (CNCHY)"
  },
  {
   value: "Chaoyang (CNCYN)",
   label: "Chaoyang (CNCYN)"
  },
  {
   value: "Chashan (CNCSH)",
   label: "Chashan (CNCSH)"
  },
  {
   value: "Baxu (CNBAU)",
   label: "Baxu (CNBAU)"
  },
  {
   value: "Bayan (CNBYA)",
   label: "Bayan (CNBYA)"
  },
  {
   value: "Bayan Obo (CNBYO)",
   label: "Bayan Obo (CNBYO)"
  },
  {
   value: "Bazhou (CNBAZ)",
   label: "Bazhou (CNBAZ)"
  },
  {
   value: "Beicun (CNBCN)",
   label: "Beicun (CNBCN)"
  },
  {
   value: "Beihai Pt (CNBHP)",
   label: "Beihai Pt (CNBHP)"
  },
  {
   value: "Beilianggang (CNBLG)",
   label: "Beilianggang (CNBLG)"
  },
  {
   value: "Beiliu (CNBLU)",
   label: "Beiliu (CNBLU)"
  },
  {
   value: "Beilun (CNBEI)",
   label: "Beilun (CNBEI)"
  },
  {
   value: "Beitan (CNBIT)",
   label: "Beitan (CNBIT)"
  },
  {
   value: "Beiyao (CNBIY)",
   label: "Beiyao (CNBIY)"
  },
  {
   value: "Beizhen (CNBZN)",
   label: "Beizhen (CNBZN)"
  },
  {
   value: "Bengbu (CNBFU)",
   label: "Bengbu (CNBFU)"
  },
  {
   value: "Benxi (CNBEN)",
   label: "Benxi (CNBEN)"
  },
  {
   value: "Binchuan (CNBCA)",
   label: "Binchuan (CNBCA)"
  },
  {
   value: "Binhai (CNBIH)",
   label: "Binhai (CNBIH)"
  },
  {
   value: "Binyang (CNBYN)",
   label: "Binyang (CNBYN)"
  },
  {
   value: "Boao (CNBOA)",
   label: "Boao (CNBOA)"
  },
  {
   value: "Bobai (CNBOB)",
   label: "Bobai (CNBOB)"
  },
  {
   value: "Bohe (CNBOE)",
   label: "Bohe (CNBOE)"
  },
  {
   value: "Bose (CNBOS)",
   label: "Bose (CNBOS)"
  },
  {
   value: "Botang (CNBOT)",
   label: "Botang (CNBOT)"
  },
  {
   value: "Boxing (CNBXI)",
   label: "Boxing (CNBXI)"
  },
  {
   value: "Bozhou (CNBOZ)",
   label: "Bozhou (CNBOZ)"
  },
  {
   value: "Buhe (CNBHE)",
   label: "Buhe (CNBHE)"
  },
  {
   value: "Burqin (CNBRJ)",
   label: "Burqin (CNBRJ)"
  },
  {
   value: "Caiba Apt\/Yibin (CNYBP)",
   label: "Caiba Apt\/Yibin (CNYBP)"
  },
  {
   value: "Caiyuanba (CNCYB)",
   label: "Caiyuanba (CNCYB)"
  },
  {
   value: "Cangshan (CNGSA)",
   label: "Cangshan (CNGSA)"
  },
  {
   value: "Cangwu (CNCGW)",
   label: "Cangwu (CNCGW)"
  },
  {
   value: "Aksu (CNAKU)",
   label: "Aksu (CNAKU)"
  },
  {
   value: "Altay (CNAAT)",
   label: "Altay (CNAAT)"
  },
  {
   value: "Anning (CNANN)",
   label: "Anning (CNANN)"
  },
  {
   value: "Anping (CNANP)",
   label: "Anping (CNANP)"
  },
  {
   value: "Anpu (CNAPP)",
   label: "Anpu (CNAPP)"
  },
  {
   value: "Anqiu (CNANQ)",
   label: "Anqiu (CNANQ)"
  },
  {
   value: "Anshan Apt (CNAOG)",
   label: "Anshan Apt (CNAOG)"
  },
  {
   value: "Anshun (CNANS)",
   label: "Anshun (CNANS)"
  },
  {
   value: "Anyang (CNAYN)",
   label: "Anyang (CNAYN)"
  },
  {
   value: "Aojiang (CNAJG)",
   label: "Aojiang (CNAJG)"
  },
  {
   value: "Asjman (CNASM)",
   label: "Asjman (CNASM)"
  },
  {
   value: "Bacao (CNBCO)",
   label: "Bacao (CNBCO)"
  },
  {
   value: "Badong (CNBDG)",
   label: "Badong (CNBDG)"
  },
  {
   value: "Bagong (CNBGG)",
   label: "Bagong (CNBGG)"
  },
  {
   value: "Bahe (CNBAH)",
   label: "Bahe (CNBAH)"
  },
  {
   value: "Baiceng (CNBCG)",
   label: "Baiceng (CNBCG)"
  },
  {
   value: "Baicheng (CNBAI)",
   label: "Baicheng (CNBAI)"
  },
  {
   value: "Bailuo (CNBLO)",
   label: "Bailuo (CNBLO)"
  },
  {
   value: "Baimajing (CNBMJ)",
   label: "Baimajing (CNBMJ)"
  },
  {
   value: "Baimao (CNIMA)",
   label: "Baimao (CNIMA)"
  },
  {
   value: "Baise (CNBSE)",
   label: "Baise (CNBSE)"
  },
  {
   value: "Baishan (CNBSH)",
   label: "Baishan (CNBSH)"
  },
  {
   value: "Baishi (CNBSI)",
   label: "Baishi (CNBSI)"
  },
  {
   value: "Baiyang (CNBYG)",
   label: "Baiyang (CNBYG)"
  },
  {
   value: "Baiyun (CNBYU)",
   label: "Baiyun (CNBYU)"
  },
  {
   value: "Baketu (CNBKT)",
   label: "Baketu (CNBKT)"
  },
  {
   value: "Bali (CNBLI)",
   label: "Bali (CNBLI)"
  },
  {
   value: "Baoding (CNBAD)",
   label: "Baoding (CNBAD)"
  },
  {
   value: "Baoji (CNBJX)",
   label: "Baoji (CNBJX)"
  },
  {
   value: "Baoshan (CNBOH)",
   label: "Baoshan (CNBOH)"
  },
  {
   value: "Baoshan (CNBSD)",
   label: "Baoshan (CNBSD)"
  },
  {
   value: "Baotou (CNBAV)",
   label: "Baotou (CNBAV)"
  },
  {
   value: "Baoying (CNBYI)",
   label: "Baoying (CNBYI)"
  },
  {
   value: "Vitacura (CLVIT)",
   label: "Vitacura (CLVIT)"
  },
  {
   value: "Yerbas Buenas (CLYBU)",
   label: "Yerbas Buenas (CLYBU)"
  },
  {
   value: "Yumbel (CLYUM)",
   label: "Yumbel (CLYUM)"
  },
  {
   value: "Yungay (CLYUN)",
   label: "Yungay (CLYUN)"
  },
  {
   value: "Zapallar (CLZAP)",
   label: "Zapallar (CLZAP)"
  },
  {
   value: ".CAMEROON (CM)",
   label: ".CAMEROON (CM)"
  },
  {
   value: "Bamenda (CMBPC)",
   label: "Bamenda (CMBPC)"
  },
  {
   value: "Bélabo (CMBEL)",
   label: "Bélabo (CMBEL)"
  },
  {
   value: "Bertoua (CMBTA)",
   label: "Bertoua (CMBTA)"
  },
  {
   value: "Ebolowa (CMEBW)",
   label: "Ebolowa (CMEBW)"
  },
  {
   value: "Ebomé Terminal (CMEBT)",
   label: "Ebomé Terminal (CMEBT)"
  },
  {
   value: "Foumban (CMFOM)",
   label: "Foumban (CMFOM)"
  },
  {
   value: "Kaele (CMKLE)",
   label: "Kaele (CMKLE)"
  },
  {
   value: "Mbalmayo (CMMBA)",
   label: "Mbalmayo (CMMBA)"
  },
  {
   value: "Ngaoundéré (CMNGE)",
   label: "Ngaoundéré (CMNGE)"
  },
  {
   value: "Victoria (CMVIC)",
   label: "Victoria (CMVIC)"
  },
  {
   value: "Yagoua (CMGXX)",
   label: "Yagoua (CMGXX)"
  },
  {
   value: "Ahitubiek (CNAHK)",
   label: "Ahitubiek (CNAHK)"
  },
  {
   value: "Aidian (CNAID)",
   label: "Aidian (CNAID)"
  },
  {
   value: "Santa María (CLSMA)",
   label: "Santa María (CLSMA)"
  },
  {
   value: "Santo Domingo (CLSDO)",
   label: "Santo Domingo (CLSDO)"
  },
  {
   value: "Sierra Gorda (CLSIG)",
   label: "Sierra Gorda (CLSIG)"
  },
  {
   value: "Talagante (CLTLG)",
   label: "Talagante (CLTLG)"
  },
  {
   value: "Teno (CLTEN)",
   label: "Teno (CLTEN)"
  },
  {
   value: "Teodoro Schmidt (CLTEO)",
   label: "Teodoro Schmidt (CLTEO)"
  },
  {
   value: "Tierra Amarilla (CLTAM)",
   label: "Tierra Amarilla (CLTAM)"
  },
  {
   value: "Tiltil (CLTIL)",
   label: "Tiltil (CLTIL)"
  },
  {
   value: "Timaukel (CLTIM)",
   label: "Timaukel (CLTIM)"
  },
  {
   value: "Tirúa (CLTIR)",
   label: "Tirúa (CLTIR)"
  },
  {
   value: "Toltén (CLTOL)",
   label: "Toltén (CLTOL)"
  },
  {
   value: "Tongoy (CLTON)",
   label: "Tongoy (CLTON)"
  },
  {
   value: "Torres del Paine (CLTDP)",
   label: "Torres del Paine (CLTDP)"
  },
  {
   value: "Tortel (CLTOR)",
   label: "Tortel (CLTOR)"
  },
  {
   value: "Traiguén (CLTRA)",
   label: "Traiguén (CLTRA)"
  },
  {
   value: "Treguaco (CLTRE)",
   label: "Treguaco (CLTRE)"
  },
  {
   value: "Tres Puentes (CLTPT)",
   label: "Tres Puentes (CLTPT)"
  },
  {
   value: "Tucapel (CLTUC)",
   label: "Tucapel (CLTUC)"
  },
  {
   value: "Vallenar (CLVLR)",
   label: "Vallenar (CLVLR)"
  },
  {
   value: "Ventanas (CLVEN)",
   label: "Ventanas (CLVEN)"
  },
  {
   value: "Ventanas (CLVNT)",
   label: "Ventanas (CLVNT)"
  },
  {
   value: "Vichuquén (CLVCQ)",
   label: "Vichuquén (CLVCQ)"
  },
  {
   value: "Vicuña (CLVIC)",
   label: "Vicuña (CLVIC)"
  },
  {
   value: "Vilcún (CLVCN)",
   label: "Vilcún (CLVCN)"
  },
  {
   value: "Villa Alegre (CLVAG)",
   label: "Villa Alegre (CLVAG)"
  },
  {
   value: "Villa Alemana (CLVIA)",
   label: "Villa Alemana (CLVIA)"
  },
  {
   value: "Villarrica (CLVIL)",
   label: "Villarrica (CLVIL)"
  },
  {
   value: "Río Verde (CLRVE)",
   label: "Río Verde (CLRVE)"
  },
  {
   value: "Rocas de Santo Domingo (CLRSD)",
   label: "Rocas de Santo Domingo (CLRSD)"
  },
  {
   value: "Romeral (CLROM)",
   label: "Romeral (CLROM)"
  },
  {
   value: "Saavedra (CLSAA)",
   label: "Saavedra (CLSAA)"
  },
  {
   value: "Sagrada Familia (CLSAF)",
   label: "Sagrada Familia (CLSAF)"
  },
  {
   value: "Salamanca (CLSAL)",
   label: "Salamanca (CLSAL)"
  },
  {
   value: "San Bernardo (CLSBD)",
   label: "San Bernardo (CLSBD)"
  },
  {
   value: "San Carlos (CLSCR)",
   label: "San Carlos (CLSCR)"
  },
  {
   value: "San Clemente (CLSCT)",
   label: "San Clemente (CLSCT)"
  },
  {
   value: "San Esteban (CLSES)",
   label: "San Esteban (CLSES)"
  },
  {
   value: "San Fabián (CLSFN)",
   label: "San Fabián (CLSFN)"
  },
  {
   value: "San Fernando (CLSFD)",
   label: "San Fernando (CLSFD)"
  },
  {
   value: "San Francisco de Mostazal (CLMOS)",
   label: "San Francisco de Mostazal (CLMOS)"
  },
  {
   value: "San Ignacio (CLSIN)",
   label: "San Ignacio (CLSIN)"
  },
  {
   value: "San Javier (CLSJV)",
   label: "San Javier (CLSJV)"
  },
  {
   value: "San Joaquín (CLSJQ)",
   label: "San Joaquín (CLSJQ)"
  },
  {
   value: "San José de Maipo (CLSJM)",
   label: "San José de Maipo (CLSJM)"
  },
  {
   value: "San Juan de la Costa (CLSJC)",
   label: "San Juan de la Costa (CLSJC)"
  },
  {
   value: "San Miguel (CLSMG)",
   label: "San Miguel (CLSMG)"
  },
  {
   value: "San Nicolás (CLSNI)",
   label: "San Nicolás (CLSNI)"
  },
  {
   value: "San Pablo (CLSPB)",
   label: "San Pablo (CLSPB)"
  },
  {
   value: "San Pedro (CLSPE)",
   label: "San Pedro (CLSPE)"
  },
  {
   value: "San Pedro de Atacama (CLSPA)",
   label: "San Pedro de Atacama (CLSPA)"
  },
  {
   value: "San Pedro de la Paz (CLSPP)",
   label: "San Pedro de la Paz (CLSPP)"
  },
  {
   value: "San Rafael (CLSRA)",
   label: "San Rafael (CLSRA)"
  },
  {
   value: "San Ramón (CLSRM)",
   label: "San Ramón (CLSRM)"
  },
  {
   value: "San Rosendo (CLSRO)",
   label: "San Rosendo (CLSRO)"
  },
  {
   value: "San Vicente (CLSVT)",
   label: "San Vicente (CLSVT)"
  },
  {
   value: "Santa Bárbara (CLSBA)",
   label: "Santa Bárbara (CLSBA)"
  },
  {
   value: "Santa Cruz (CLSCZ)",
   label: "Santa Cruz (CLSCZ)"
  },
  {
   value: "Santa Juana (CLSJU)",
   label: "Santa Juana (CLSJU)"
  },
  {
   value: "Punta Chungo (CLPTC)",
   label: "Punta Chungo (CLPTC)"
  },
  {
   value: "Puqueldón (CLPQD)",
   label: "Puqueldón (CLPQD)"
  },
  {
   value: "Purén (CLPUR)",
   label: "Purén (CLPUR)"
  },
  {
   value: "Purranque (CLPRQ)",
   label: "Purranque (CLPRQ)"
  },
  {
   value: "Putaendo (CLPTO)",
   label: "Putaendo (CLPTO)"
  },
  {
   value: "Putre (CLPUT)",
   label: "Putre (CLPUT)"
  },
  {
   value: "Puyehue (CLPYH)",
   label: "Puyehue (CLPYH)"
  },
  {
   value: "Queilén (CLQLN)",
   label: "Queilén (CLQLN)"
  },
  {
   value: "Quellón (Puerto Quellón) (CLPTE)",
   label: "Quellón (Puerto Quellón) (CLPTE)"
  },
  {
   value: "Quellón Viejo (CLQUV)",
   label: "Quellón Viejo (CLQUV)"
  },
  {
   value: "Quilaco (CLQLA)",
   label: "Quilaco (CLQLA)"
  },
  {
   value: "Quilicura (CLQUI)",
   label: "Quilicura (CLQUI)"
  },
  {
   value: "Quilleco (CLQLO)",
   label: "Quilleco (CLQLO)"
  },
  {
   value: "Quillón (CLQIN)",
   label: "Quillón (CLQIN)"
  },
  {
   value: "Quillota (CLQTA)",
   label: "Quillota (CLQTA)"
  },
  {
   value: "Quilpué (CLQIL)",
   label: "Quilpué (CLQIL)"
  },
  {
   value: "Quinchao (CLQCO)",
   label: "Quinchao (CLQCO)"
  },
  {
   value: "Quinta de Tilcoco (CLQDT)",
   label: "Quinta de Tilcoco (CLQDT)"
  },
  {
   value: "Quinta Normal (CLQNO)",
   label: "Quinta Normal (CLQNO)"
  },
  {
   value: "Quirihue (CLQRH)",
   label: "Quirihue (CLQRH)"
  },
  {
   value: "Ránquil (CLRAN)",
   label: "Ránquil (CLRAN)"
  },
  {
   value: "Rauco (CLRAF)",
   label: "Rauco (CLRAF)"
  },
  {
   value: "Rauco (CLRAU)",
   label: "Rauco (CLRAU)"
  },
  {
   value: "Recoleta (CLREC)",
   label: "Recoleta (CLREC)"
  },
  {
   value: "Renaico (CLRNO)",
   label: "Renaico (CLRNO)"
  },
  {
   value: "Renca (CLREN)",
   label: "Renca (CLREN)"
  },
  {
   value: "Rengo (CLRGO)",
   label: "Rengo (CLRGO)"
  },
  {
   value: "Requínoa (CLREQ)",
   label: "Requínoa (CLREQ)"
  },
  {
   value: "Retiro (CLRET)",
   label: "Retiro (CLRET)"
  },
  {
   value: "Rinconada de Los Andes (CLRIN)",
   label: "Rinconada de Los Andes (CLRIN)"
  },
  {
   value: "Río Bueno (CLRBU)",
   label: "Río Bueno (CLRBU)"
  },
  {
   value: "Río Claro (CLRCL)",
   label: "Río Claro (CLRCL)"
  },
  {
   value: "Río Ibáñez (CLRIB)",
   label: "Río Ibáñez (CLRIB)"
  },
  {
   value: "Río Negro (CLRNE)",
   label: "Río Negro (CLRNE)"
  },
  {
   value: "Pica (CLPIC)",
   label: "Pica (CLPIC)"
  },
  {
   value: "Pichidegua (CLPDH)",
   label: "Pichidegua (CLPDH)"
  },
  {
   value: "Pichilemu (CLPLM)",
   label: "Pichilemu (CLPLM)"
  },
  {
   value: "Pinto (CLPIN)",
   label: "Pinto (CLPIN)"
  },
  {
   value: "Pirque (CLPIR)",
   label: "Pirque (CLPIR)"
  },
  {
   value: "Pitrufquén (CLPIT)",
   label: "Pitrufquén (CLPIT)"
  },
  {
   value: "Placilla (CLPLA)",
   label: "Placilla (CLPLA)"
  },
  {
   value: "Portezuelo (CLPOR)",
   label: "Portezuelo (CLPOR)"
  },
  {
   value: "Porvenir Apt (CLWPR)",
   label: "Porvenir Apt (CLWPR)"
  },
  {
   value: "Posesión (CLPOS)",
   label: "Posesión (CLPOS)"
  },
  {
   value: "Pozo Almonte (CLPOZ)",
   label: "Pozo Almonte (CLPOZ)"
  },
  {
   value: "Primavera (CLPRI)",
   label: "Primavera (CLPRI)"
  },
  {
   value: "Providencia (CLPRO)",
   label: "Providencia (CLPRO)"
  },
  {
   value: "Puchuncaví (CLPCI)",
   label: "Puchuncaví (CLPCI)"
  },
  {
   value: "Pucón (CLPUC)",
   label: "Pucón (CLPUC)"
  },
  {
   value: "Pucon Apt (CLZPC)",
   label: "Pucon Apt (CLZPC)"
  },
  {
   value: "Pudahuel (CLPUD)",
   label: "Pudahuel (CLPUD)"
  },
  {
   value: "Puente Alto (CLPTA)",
   label: "Puente Alto (CLPTA)"
  },
  {
   value: "Puente Negro (CLPNG)",
   label: "Puente Negro (CLPNG)"
  },
  {
   value: "Puerto Angamos (CLPAG)",
   label: "Puerto Angamos (CLPAG)"
  },
  {
   value: "Puerto Chacabuco (CLPCH)",
   label: "Puerto Chacabuco (CLPCH)"
  },
  {
   value: "Puerto Cisnes (CLCIS)",
   label: "Puerto Cisnes (CLCIS)"
  },
  {
   value: "Puerto Edén (CLEDE)",
   label: "Puerto Edén (CLEDE)"
  },
  {
   value: "Puerto Octay (CLPOC)",
   label: "Puerto Octay (CLPOC)"
  },
  {
   value: "Puerto Patache (CLPAT)",
   label: "Puerto Patache (CLPAT)"
  },
  {
   value: "Puerto Varas (CLPVS)",
   label: "Puerto Varas (CLPVS)"
  },
  {
   value: "Pumanque (CLPUM)",
   label: "Pumanque (CLPUM)"
  },
  {
   value: "Punitaqui (CLPUN)",
   label: "Punitaqui (CLPUN)"
  },
  {
   value: "Paillaco (CLPAO)",
   label: "Paillaco (CLPAO)"
  },
  {
   value: "Paine (CLPNE)",
   label: "Paine (CLPNE)"
  },
  {
   value: "Palena (CLPAL)",
   label: "Palena (CLPAL)"
  },
  {
   value: "Palmilla (CLPMA)",
   label: "Palmilla (CLPMA)"
  },
  {
   value: "Panguipulli (CLPAN)",
   label: "Panguipulli (CLPAN)"
  },
  {
   value: "Panquehue (CLPQH)",
   label: "Panquehue (CLPQH)"
  },
  {
   value: "Papudo (CLPAP)",
   label: "Papudo (CLPAP)"
  },
  {
   value: "Paredones (CLPAR)",
   label: "Paredones (CLPAR)"
  },
  {
   value: "Pargua (CLPGA)",
   label: "Pargua (CLPGA)"
  },
  {
   value: "Parral (CLPRL)",
   label: "Parral (CLPRL)"
  },
  {
   value: "Paso Agua Negra (CLAGN)",
   label: "Paso Agua Negra (CLAGN)"
  },
  {
   value: "Paso Cardenal Samoré (CLCSA)",
   label: "Paso Cardenal Samoré (CLCSA)"
  },
  {
   value: "Paso Futaleufú (CLFTF)",
   label: "Paso Futaleufú (CLFTF)"
  },
  {
   value: "Paso Huahum (CLHHM)",
   label: "Paso Huahum (CLHHM)"
  },
  {
   value: "Paso Huemules (CLHLS)",
   label: "Paso Huemules (CLHLS)"
  },
  {
   value: "Paso Integración Austral (CLMAY)",
   label: "Paso Integración Austral (CLMAY)"
  },
  {
   value: "Paso Los Libertadores (CLLIB)",
   label: "Paso Los Libertadores (CLLIB)"
  },
  {
   value: "Paso Pichachén (CLPIA)",
   label: "Paso Pichachén (CLPIA)"
  },
  {
   value: "Paso Río Bellavista (CLRBL)",
   label: "Paso Río Bellavista (CLRBL)"
  },
  {
   value: "Paso Río Don Guillermo (CLRDG)",
   label: "Paso Río Don Guillermo (CLRDG)"
  },
  {
   value: "Paso San Francisco (CLFCO)",
   label: "Paso San Francisco (CLFCO)"
  },
  {
   value: "Paso San Sebastián (CLSSB)",
   label: "Paso San Sebastián (CLSSB)"
  },
  {
   value: "Paso Socompa (CLSOC)",
   label: "Paso Socompa (CLSOC)"
  },
  {
   value: "Pedro Aguirre Cerda (CLPAC)",
   label: "Pedro Aguirre Cerda (CLPAC)"
  },
  {
   value: "Pelarco (CLPEL)",
   label: "Pelarco (CLPEL)"
  },
  {
   value: "Pelluhue (CLPLH)",
   label: "Pelluhue (CLPLH)"
  },
  {
   value: "Pemuco (CLPEM)",
   label: "Pemuco (CLPEM)"
  },
  {
   value: "Peñaflor (CLPFL)",
   label: "Peñaflor (CLPFL)"
  },
  {
   value: "Peñalolén (CLPLN)",
   label: "Peñalolén (CLPLN)"
  },
  {
   value: "Pencahue (CLPEN)",
   label: "Pencahue (CLPEN)"
  },
  {
   value: "Peralillo (CLPER)",
   label: "Peralillo (CLPER)"
  },
  {
   value: "Perquenco (CLPQC)",
   label: "Perquenco (CLPQC)"
  },
  {
   value: "Petorca (CLPET)",
   label: "Petorca (CLPET)"
  },
  {
   value: "Peumo (CLPEU)",
   label: "Peumo (CLPEU)"
  },
  {
   value: "Machalí (CLMCI)",
   label: "Machalí (CLMCI)"
  },
  {
   value: "Macul (CLMAC)",
   label: "Macul (CLMAC)"
  },
  {
   value: "Máfil (CLMAF)",
   label: "Máfil (CLMAF)"
  },
  {
   value: "Maipú (CLMAI)",
   label: "Maipú (CLMAI)"
  },
  {
   value: "Malloa (CLMAL)",
   label: "Malloa (CLMAL)"
  },
  {
   value: "Mamuil Malal (CLMML)",
   label: "Mamuil Malal (CLMML)"
  },
  {
   value: "Marchihue (CLMAR)",
   label: "Marchihue (CLMAR)"
  },
  {
   value: "María Elena (CLMAE)",
   label: "María Elena (CLMAE)"
  },
  {
   value: "María Pinto (CLMPI)",
   label: "María Pinto (CLMPI)"
  },
  {
   value: "Mariquina (CLMRQ)",
   label: "Mariquina (CLMRQ)"
  },
  {
   value: "Maule (CLMAU)",
   label: "Maule (CLMAU)"
  },
  {
   value: "Maullín (CLMLL)",
   label: "Maullín (CLMLL)"
  },
  {
   value: "Melinka (CLMLI)",
   label: "Melinka (CLMLI)"
  },
  {
   value: "Melipeuco (CLMLP)",
   label: "Melipeuco (CLMLP)"
  },
  {
   value: "Melipilla (CLMEL)",
   label: "Melipilla (CLMEL)"
  },
  {
   value: "Michilla (CLMIC)",
   label: "Michilla (CLMIC)"
  },
  {
   value: "Molina (CLMOL)",
   label: "Molina (CLMOL)"
  },
  {
   value: "Monte Patria (CLMTP)",
   label: "Monte Patria (CLMTP)"
  },
  {
   value: "Mulchén (CLMUL)",
   label: "Mulchén (CLMUL)"
  },
  {
   value: "Nacimiento (CLNAC)",
   label: "Nacimiento (CLNAC)"
  },
  {
   value: "Nancahua (CLNAN)",
   label: "Nancahua (CLNAN)"
  },
  {
   value: "Navidad (CLNAV)",
   label: "Navidad (CLNAV)"
  },
  {
   value: "Negrete (CLNEG)",
   label: "Negrete (CLNEG)"
  },
  {
   value: "Niebla (CLNBL)",
   label: "Niebla (CLNBL)"
  },
  {
   value: "Ninhue (CLNIN)",
   label: "Ninhue (CLNIN)"
  },
  {
   value: "Ñiquén (CLNQN)",
   label: "Ñiquén (CLNQN)"
  },
  {
   value: "Nogales (CLNOG)",
   label: "Nogales (CLNOG)"
  },
  {
   value: "Nueva Aldea (CLNAL)",
   label: "Nueva Aldea (CLNAL)"
  },
  {
   value: "Nueva Imperial (CLNIM)",
   label: "Nueva Imperial (CLNIM)"
  },
  {
   value: "Ñuñoa (CLNUN)",
   label: "Ñuñoa (CLNUN)"
  },
  {
   value: "Olivar (CLOLI)",
   label: "Olivar (CLOLI)"
  },
  {
   value: "Ollagüe (CLOLL)",
   label: "Ollagüe (CLOLL)"
  },
  {
   value: "Olmué (CLOLM)",
   label: "Olmué (CLOLM)"
  },
  {
   value: "Padre Hurtado (CLPHU)",
   label: "Padre Hurtado (CLPHU)"
  },
  {
   value: "Padre Las Casas (CLPLC)",
   label: "Padre Las Casas (CLPLC)"
  },
  {
   value: "Paiguano (CLPAI)",
   label: "Paiguano (CLPAI)"
  },
  {
   value: "La Reina (CLREI)",
   label: "La Reina (CLREI)"
  },
  {
   value: "La Unión (CLLUN)",
   label: "La Unión (CLLUN)"
  },
  {
   value: "Lago Ranco (CLRNC)",
   label: "Lago Ranco (CLRNC)"
  },
  {
   value: "Lago Verde (CLLVD)",
   label: "Lago Verde (CLLVD)"
  },
  {
   value: "Laguna Blanca (CLLBL)",
   label: "Laguna Blanca (CLLBL)"
  },
  {
   value: "Lampa (CLLAM)",
   label: "Lampa (CLLAM)"
  },
  {
   value: "Lanco (CLLAN)",
   label: "Lanco (CLLAN)"
  },
  {
   value: "Las Cabras (CLLCB)",
   label: "Las Cabras (CLLCB)"
  },
  {
   value: "Las Condes (CLLCO)",
   label: "Las Condes (CLLCO)"
  },
  {
   value: "Lautaro (CLLAU)",
   label: "Lautaro (CLLAU)"
  },
  {
   value: "Licantén (CLLIC)",
   label: "Licantén (CLLIC)"
  },
  {
   value: "Limache (CLLIM)",
   label: "Limache (CLLIM)"
  },
  {
   value: "Linares (CLLIN)",
   label: "Linares (CLLIN)"
  },
  {
   value: "Litueche (CLLIT)",
   label: "Litueche (CLLIT)"
  },
  {
   value: "Llaillay (CLLLA)",
   label: "Llaillay (CLLLA)"
  },
  {
   value: "Llanquihue (CLLIA)",
   label: "Llanquihue (CLLIA)"
  },
  {
   value: "Llico (CLLLI)",
   label: "Llico (CLLLI)"
  },
  {
   value: "Lo Barnechea (CLLBA)",
   label: "Lo Barnechea (CLLBA)"
  },
  {
   value: "Lo Espejo (CLLEJ)",
   label: "Lo Espejo (CLLEJ)"
  },
  {
   value: "Lo Prado (CLLPR)",
   label: "Lo Prado (CLLPR)"
  },
  {
   value: "Lolol (CLLOL)",
   label: "Lolol (CLLOL)"
  },
  {
   value: "Loncoche (CLLNC)",
   label: "Loncoche (CLLNC)"
  },
  {
   value: "Longaví (CLLON)",
   label: "Longaví (CLLON)"
  },
  {
   value: "Lonquimay (CLLQY)",
   label: "Lonquimay (CLLQY)"
  },
  {
   value: "Los Álamos (CLLAL)",
   label: "Los Álamos (CLLAL)"
  },
  {
   value: "Los Cerrillos Apt\/Santiago (CLULC)",
   label: "Los Cerrillos Apt\/Santiago (CLULC)"
  },
  {
   value: "Los Lagos (CLLLG)",
   label: "Los Lagos (CLLLG)"
  },
  {
   value: "Los Muermos (CLLMU)",
   label: "Los Muermos (CLLMU)"
  },
  {
   value: "Los Sauces (CLLSA)",
   label: "Los Sauces (CLLSA)"
  },
  {
   value: "Lumaco (CLLUM)",
   label: "Lumaco (CLLUM)"
  },
  {
   value: "Fresia (CLFRS)",
   label: "Fresia (CLFRS)"
  },
  {
   value: "Frutillar (CLFRT)",
   label: "Frutillar (CLFRT)"
  },
  {
   value: "Futaleufú (CLFFU)",
   label: "Futaleufú (CLFFU)"
  },
  {
   value: "Futrono (CLFUT)",
   label: "Futrono (CLFUT)"
  },
  {
   value: "Galvarino (CLGAL)",
   label: "Galvarino (CLGAL)"
  },
  {
   value: "General Lagos (CLGLG)",
   label: "General Lagos (CLGLG)"
  },
  {
   value: "Gorbea (CLGOR)",
   label: "Gorbea (CLGOR)"
  },
  {
   value: "Graneros (CLGRA)",
   label: "Graneros (CLGRA)"
  },
  {
   value: "Guaitecas (CLGUA)",
   label: "Guaitecas (CLGUA)"
  },
  {
   value: "Hijuelas (CLHIJ)",
   label: "Hijuelas (CLHIJ)"
  },
  {
   value: "Huachipato (CLHPO)",
   label: "Huachipato (CLHPO)"
  },
  {
   value: "Hualaihué (CLHUH)",
   label: "Hualaihué (CLHUH)"
  },
  {
   value: "Hualañé (CLHLE)",
   label: "Hualañé (CLHLE)"
  },
  {
   value: "Hualpén (CLHPN)",
   label: "Hualpén (CLHPN)"
  },
  {
   value: "Hualqui (CLHQI)",
   label: "Hualqui (CLHQI)"
  },
  {
   value: "Huara (CLHUA)",
   label: "Huara (CLHUA)"
  },
  {
   value: "Huechuraba (CLHUE)",
   label: "Huechuraba (CLHUE)"
  },
  {
   value: "Hurtado (CLRHU)",
   label: "Hurtado (CLRHU)"
  },
  {
   value: "Illapel (CLILL)",
   label: "Illapel (CLILL)"
  },
  {
   value: "Independencia (CLIND)",
   label: "Independencia (CLIND)"
  },
  {
   value: "Isla de Maipo (CLIDM)",
   label: "Isla de Maipo (CLIDM)"
  },
  {
   value: "Juan Fernández (CLJFZ)",
   label: "Juan Fernández (CLJFZ)"
  },
  {
   value: "La Calera (CLLCL)",
   label: "La Calera (CLLCL)"
  },
  {
   value: "La Cisterna (CLLCI)",
   label: "La Cisterna (CLLCI)"
  },
  {
   value: "La Cruz (CLLCZ)",
   label: "La Cruz (CLLCZ)"
  },
  {
   value: "La Estrella (CLLES)",
   label: "La Estrella (CLLES)"
  },
  {
   value: "La Florida (CLLFL)",
   label: "La Florida (CLLFL)"
  },
  {
   value: "La Granja (CLLGJ)",
   label: "La Granja (CLLGJ)"
  },
  {
   value: "La Higuera (CLLAH)",
   label: "La Higuera (CLLAH)"
  },
  {
   value: "La Laja (CLLAJ)",
   label: "La Laja (CLLAJ)"
  },
  {
   value: "La Ligua (CLLIG)",
   label: "La Ligua (CLLIG)"
  },
  {
   value: "La Pintana (CLLPI)",
   label: "La Pintana (CLLPI)"
  },
  {
   value: "Collipulli (CLCPI)",
   label: "Collipulli (CLCPI)"
  },
  {
   value: "Coltauco (CLCTC)",
   label: "Coltauco (CLCTC)"
  },
  {
   value: "Combarbalá (CLCBB)",
   label: "Combarbalá (CLCBB)"
  },
  {
   value: "Conchalí (CLCLI)",
   label: "Conchalí (CLCLI)"
  },
  {
   value: "Concón (CLCON)",
   label: "Concón (CLCON)"
  },
  {
   value: "Constitución (CLCST)",
   label: "Constitución (CLCST)"
  },
  {
   value: "Contulmo (CLCTM)",
   label: "Contulmo (CLCTM)"
  },
  {
   value: "Cunco (CLCUN)",
   label: "Cunco (CLCUN)"
  },
  {
   value: "Curacautín (CLCCN)",
   label: "Curacautín (CLCCN)"
  },
  {
   value: "Curacaví (CLCRV)",
   label: "Curacaví (CLCRV)"
  },
  {
   value: "Curaco de Vélez (CLCDV)",
   label: "Curaco de Vélez (CLCDV)"
  },
  {
   value: "Curanilahue (CLCRN)",
   label: "Curanilahue (CLCRN)"
  },
  {
   value: "Curarrehue (CLCRE)",
   label: "Curarrehue (CLCRE)"
  },
  {
   value: "Curepto (CLCRT)",
   label: "Curepto (CLCRT)"
  },
  {
   value: "Curicó (CLCUR)",
   label: "Curicó (CLCUR)"
  },
  {
   value: "Dalcahue (CLDCH)",
   label: "Dalcahue (CLDCH)"
  },
  {
   value: "Diego de Almagro (CLDDA)",
   label: "Diego de Almagro (CLDDA)"
  },
  {
   value: "Doñihue (CLDOH)",
   label: "Doñihue (CLDOH)"
  },
  {
   value: "Easter Island = Isla de Pascua (CL)",
   label: "Easter Island = Isla de Pascua (CL)"
  },
  {
   value: "El Bosque (CLELB)",
   label: "El Bosque (CLELB)"
  },
  {
   value: "El Carmen (CLELC)",
   label: "El Carmen (CLELC)"
  },
  {
   value: "El Monte (CLELM)",
   label: "El Monte (CLELM)"
  },
  {
   value: "El Quisco (CLELQ)",
   label: "El Quisco (CLELQ)"
  },
  {
   value: "El Tabo (CLELT)",
   label: "El Tabo (CLELT)"
  },
  {
   value: "Empedrado (CLEMP)",
   label: "Empedrado (CLEMP)"
  },
  {
   value: "Ercilla (CLERC)",
   label: "Ercilla (CLERC)"
  },
  {
   value: "Estación Central (CLECT)",
   label: "Estación Central (CLECT)"
  },
  {
   value: "Florida (CLFLO)",
   label: "Florida (CLFLO)"
  },
  {
   value: "Freire (CLFRE)",
   label: "Freire (CLFRE)"
  },
  {
   value: "Freirina (CLFRN)",
   label: "Freirina (CLFRN)"
  },
  {
   value: "Camarones (CLCAM)",
   label: "Camarones (CLCAM)"
  },
  {
   value: "Camiña (CLCMA)",
   label: "Camiña (CLCMA)"
  },
  {
   value: "Canela (CLCAN)",
   label: "Canela (CLCAN)"
  },
  {
   value: "Cañete (CLCTE)",
   label: "Cañete (CLCTE)"
  },
  {
   value: "Carahue (CLCAR)",
   label: "Carahue (CLCAR)"
  },
  {
   value: "Carahue (CLCRH)",
   label: "Carahue (CLCRH)"
  },
  {
   value: "Cartagena (CLCGN)",
   label: "Cartagena (CLCGN)"
  },
  {
   value: "Catemu (CLCAT)",
   label: "Catemu (CLCAT)"
  },
  {
   value: "Cauquenes (CLCAU)",
   label: "Cauquenes (CLCAU)"
  },
  {
   value: "Cerrillos (CLCER)",
   label: "Cerrillos (CLCER)"
  },
  {
   value: "Cerro Navia (CLCNV)",
   label: "Cerro Navia (CLCNV)"
  },
  {
   value: "Cerro Sombrero Apt (CLSMB)",
   label: "Cerro Sombrero Apt (CLSMB)"
  },
  {
   value: "Chacao (CLCCA)",
   label: "Chacao (CLCCA)"
  },
  {
   value: "Chanco (CLCHA)",
   label: "Chanco (CLCHA)"
  },
  {
   value: "Chépica (CLCHE)",
   label: "Chépica (CLCHE)"
  },
  {
   value: "Chiguayante (CLCHI)",
   label: "Chiguayante (CLCHI)"
  },
  {
   value: "Chile Chico (CLCCH)",
   label: "Chile Chico (CLCCH)"
  },
  {
   value: "Chillán (CLYAI)",
   label: "Chillán (CLYAI)"
  },
  {
   value: "Chillán Viejo (CLCHV)",
   label: "Chillán Viejo (CLCHV)"
  },
  {
   value: "Chimbarongo (CLCBG)",
   label: "Chimbarongo (CLCBG)"
  },
  {
   value: "Cholchol (CLCHL)",
   label: "Cholchol (CLCHL)"
  },
  {
   value: "Chonchi (CLCHO)",
   label: "Chonchi (CLCHO)"
  },
  {
   value: "Chuquicamata (CLCHU)",
   label: "Chuquicamata (CLCHU)"
  },
  {
   value: "Cobquecura (CLCBQ)",
   label: "Cobquecura (CLCBQ)"
  },
  {
   value: "Cochamó (CLCMO)",
   label: "Cochamó (CLCMO)"
  },
  {
   value: "Cochrane (CLCOC)",
   label: "Cochrane (CLCOC)"
  },
  {
   value: "Codegua (CLCOD)",
   label: "Codegua (CLCOD)"
  },
  {
   value: "Coelemu (CLCOE)",
   label: "Coelemu (CLCOE)"
  },
  {
   value: "Coihueco (CLCOI)",
   label: "Coihueco (CLCOI)"
  },
  {
   value: "Coinco (CLCOO)",
   label: "Coinco (CLCOO)"
  },
  {
   value: "Colbún (CLCOB)",
   label: "Colbún (CLCOB)"
  },
  {
   value: "Colchane (CLCNE)",
   label: "Colchane (CLCNE)"
  },
  {
   value: "Colina (CLCLN)",
   label: "Colina (CLCLN)"
  },
  {
   value: "Achao (CLACH)",
   label: "Achao (CLACH)"
  },
  {
   value: "Algarrobo (CLALG)",
   label: "Algarrobo (CLALG)"
  },
  {
   value: "Alhué (CLALH)",
   label: "Alhué (CLALH)"
  },
  {
   value: "Alto Bío Bío (CLABB)",
   label: "Alto Bío Bío (CLABB)"
  },
  {
   value: "Alto del Carmen (CLADC)",
   label: "Alto del Carmen (CLADC)"
  },
  {
   value: "Alto Hospicio (CLAHP)",
   label: "Alto Hospicio (CLAHP)"
  },
  {
   value: "Alto Palena Apt (CLWAP)",
   label: "Alto Palena Apt (CLWAP)"
  },
  {
   value: "Andacollo (CLAND)",
   label: "Andacollo (CLAND)"
  },
  {
   value: "Angol (CLANG)",
   label: "Angol (CLANG)"
  },
  {
   value: "Antuco (CLANT)",
   label: "Antuco (CLANT)"
  },
  {
   value: "Arauco (CLARA)",
   label: "Arauco (CLARA)"
  },
  {
   value: "Ayacara (CLAYA)",
   label: "Ayacara (CLAYA)"
  },
  {
   value: "Bahia Concepcion (CLBHC)",
   label: "Bahia Concepcion (CLBHC)"
  },
  {
   value: "Buin (CLBUI)",
   label: "Buin (CLBUI)"
  },
  {
   value: "Bulnes (CLBUL)",
   label: "Bulnes (CLBUL)"
  },
  {
   value: "Cabildo (CLCBD)",
   label: "Cabildo (CLCBD)"
  },
  {
   value: "Cabo de Hornos (CLCHR)",
   label: "Cabo de Hornos (CLCHR)"
  },
  {
   value: "Cabrero (CLCAB)",
   label: "Cabrero (CLCAB)"
  },
  {
   value: "Calbuco (CLCBC)",
   label: "Calbuco (CLCBC)"
  },
  {
   value: "Calderilla (CLCAA)",
   label: "Calderilla (CLCAA)"
  },
  {
   value: "Calera de Tango (CLCDT)",
   label: "Calera de Tango (CLCDT)"
  },
  {
   value: "Caleta Coloso (CLCOL)",
   label: "Caleta Coloso (CLCOL)"
  },
  {
   value: "Calle Larga (CLCLL)",
   label: "Calle Larga (CLCLL)"
  },
  {
   value: "Bongouanou (CIBGG)",
   label: "Bongouanou (CIBGG)"
  },
  {
   value: "Bonoua (CIBON)",
   label: "Bonoua (CIBON)"
  },
  {
   value: "Borotou (CIBRZ)",
   label: "Borotou (CIBRZ)"
  },
  {
   value: "Bouna (CIBQO)",
   label: "Bouna (CIBQO)"
  },
  {
   value: "Boundiali (CIBXI)",
   label: "Boundiali (CIBXI)"
  },
  {
   value: "Buyo (CIBUU)",
   label: "Buyo (CIBUU)"
  },
  {
   value: "Dabou (CIDAB)",
   label: "Dabou (CIDAB)"
  },
  {
   value: "Danane (CIDNC)",
   label: "Danane (CIDNC)"
  },
  {
   value: "Gagnoa (CIGGN)",
   label: "Gagnoa (CIGGN)"
  },
  {
   value: "Guiglo (CIGGO)",
   label: "Guiglo (CIGGO)"
  },
  {
   value: "Mankono (CIMOK)",
   label: "Mankono (CIMOK)"
  },
  {
   value: "Nakala (CINKL)",
   label: "Nakala (CINKL)"
  },
  {
   value: "Ouango Fitni (CIOFI)",
   label: "Ouango Fitni (CIOFI)"
  },
  {
   value: "Seguela (CISEQ)",
   label: "Seguela (CISEQ)"
  },
  {
   value: "Séguéla (CISGL)",
   label: "Séguéla (CISGL)"
  },
  {
   value: "Tiassalé (CITIA)",
   label: "Tiassalé (CITIA)"
  },
  {
   value: "Touba (CITOZ)",
   label: "Touba (CITOZ)"
  },
  {
   value: ".COOK ISLANDS (CK)",
   label: ".COOK ISLANDS (CK)"
  },
  {
   value: "Avarua (CKAVA)",
   label: "Avarua (CKAVA)"
  },
  {
   value: "Winznau (CHWZA)",
   label: "Winznau (CHWZA)"
  },
  {
   value: "Wittenbach (CHWTB)",
   label: "Wittenbach (CHWTB)"
  },
  {
   value: "Wolfhausen (CHZWN)",
   label: "Wolfhausen (CHZWN)"
  },
  {
   value: "Wolfwil (CHWFW)",
   label: "Wolfwil (CHWFW)"
  },
  {
   value: "Wolhusen (CHWHN)",
   label: "Wolhusen (CHWHN)"
  },
  {
   value: "Wollerau (CHWLU)",
   label: "Wollerau (CHWLU)"
  },
  {
   value: "Worblaufen (CHWBN)",
   label: "Worblaufen (CHWBN)"
  },
  {
   value: "Würenlos (CHWLO)",
   label: "Würenlos (CHWLO)"
  },
  {
   value: "Wynau (CHWYU)",
   label: "Wynau (CHWYU)"
  },
  {
   value: "Wyssachen (CHWSC)",
   label: "Wyssachen (CHWSC)"
  },
  {
   value: "Yens (CHYNS)",
   label: "Yens (CHYNS)"
  },
  {
   value: "Yverdon-les-Bains (CHYLB)",
   label: "Yverdon-les-Bains (CHYLB)"
  },
  {
   value: "Yvonand (CHYVD)",
   label: "Yvonand (CHYVD)"
  },
  {
   value: "Zäziwil (CHZAZ)",
   label: "Zäziwil (CHZAZ)"
  },
  {
   value: "Zeihen (CHZEI)",
   label: "Zeihen (CHZEI)"
  },
  {
   value: "Zell (CHZEL)",
   label: "Zell (CHZEL)"
  },
  {
   value: "Zell (CHZZL)",
   label: "Zell (CHZZL)"
  },
  {
   value: "Zermatt (CHZER)",
   label: "Zermatt (CHZER)"
  },
  {
   value: "Zetzwil (CHZWI)",
   label: "Zetzwil (CHZWI)"
  },
  {
   value: "Zimmerwald (CHZRD)",
   label: "Zimmerwald (CHZRD)"
  },
  {
   value: "Zofingen (CHZLL)",
   label: "Zofingen (CHZLL)"
  },
  {
   value: "Zollikofen (CHZLK)",
   label: "Zollikofen (CHZLK)"
  },
  {
   value: "Zuchwil (CHZWL)",
   label: "Zuchwil (CHZWL)"
  },
  {
   value: "Zumikon (CHZKN)",
   label: "Zumikon (CHZKN)"
  },
  {
   value: "Zurzach (CHZZH)",
   label: "Zurzach (CHZZH)"
  },
  {
   value: "Zweisimmen (CHZIM)",
   label: "Zweisimmen (CHZIM)"
  },
  {
   value: "Aboisso (CIABO)",
   label: "Aboisso (CIABO)"
  },
  {
   value: "Adzopé (CIADZ)",
   label: "Adzopé (CIADZ)"
  },
  {
   value: "Agboville (CIAGB)",
   label: "Agboville (CIAGB)"
  },
  {
   value: "Amalfi (CIAFI)",
   label: "Amalfi (CIAFI)"
  },
  {
   value: "Baobab Terminal (CIBAO)",
   label: "Baobab Terminal (CIBAO)"
  },
  {
   value: "Berenby (CIBBV)",
   label: "Berenby (CIBBV)"
  },
  {
   value: "Volketswil (CHVKI)",
   label: "Volketswil (CHVKI)"
  },
  {
   value: "Vordemwald (CHVRM)",
   label: "Vordemwald (CHVRM)"
  },
  {
   value: "Vuadens (CHVUD)",
   label: "Vuadens (CHVUD)"
  },
  {
   value: "Vucherens (CHVHS)",
   label: "Vucherens (CHVHS)"
  },
  {
   value: "Vufflens-la-Ville (CHVLV)",
   label: "Vufflens-la-Ville (CHVLV)"
  },
  {
   value: "Vullierens (CHVUS)",
   label: "Vullierens (CHVUS)"
  },
  {
   value: "Wabern (CHWBR)",
   label: "Wabern (CHWBR)"
  },
  {
   value: "Wädenswil (CHWDW)",
   label: "Wädenswil (CHWDW)"
  },
  {
   value: "Wagen (CHWAN)",
   label: "Wagen (CHWAN)"
  },
  {
   value: "Walchwil (CHWCW)",
   label: "Walchwil (CHWCW)"
  },
  {
   value: "Waldstatt (CHWAD)",
   label: "Waldstatt (CHWAD)"
  },
  {
   value: "Wallisellen (CHWLN)",
   label: "Wallisellen (CHWLN)"
  },
  {
   value: "Waltenschwil (CHWAL)",
   label: "Waltenschwil (CHWAL)"
  },
  {
   value: "Waltikon (CHWAI)",
   label: "Waltikon (CHWAI)"
  },
  {
   value: "Wangen an der Aare (CHWGA)",
   label: "Wangen an der Aare (CHWGA)"
  },
  {
   value: "Wängi (CHWGI)",
   label: "Wängi (CHWGI)"
  },
  {
   value: "Wattenwil (CHWTW)",
   label: "Wattenwil (CHWTW)"
  },
  {
   value: "Wattwil (CHWAT)",
   label: "Wattwil (CHWAT)"
  },
  {
   value: "Weggis (CHWGS)",
   label: "Weggis (CHWGS)"
  },
  {
   value: "Weinfelden (CHWFL)",
   label: "Weinfelden (CHWFL)"
  },
  {
   value: "Weissbad (CHWSB)",
   label: "Weissbad (CHWSB)"
  },
  {
   value: "Wengen (CHWNG)",
   label: "Wengen (CHWNG)"
  },
  {
   value: "Werdenberg (CHWDB)",
   label: "Werdenberg (CHWDB)"
  },
  {
   value: "Wettingen (CHWTG)",
   label: "Wettingen (CHWTG)"
  },
  {
   value: "Wettswil (CHWSI)",
   label: "Wettswil (CHWSI)"
  },
  {
   value: "Wetzikon (CHWZK)",
   label: "Wetzikon (CHWZK)"
  },
  {
   value: "Widnau (CHWNU)",
   label: "Widnau (CHWNU)"
  },
  {
   value: "Wiedlisbach (CHWBA)",
   label: "Wiedlisbach (CHWBA)"
  },
  {
   value: "Wiesendangen (CHWDG)",
   label: "Wiesendangen (CHWDG)"
  },
  {
   value: "Wikon (CHWKO)",
   label: "Wikon (CHWKO)"
  },
  {
   value: "Wil (CHWIL)",
   label: "Wil (CHWIL)"
  },
  {
   value: "Wil (CHWQL)",
   label: "Wil (CHWQL)"
  },
  {
   value: "Wiler (CHWLR)",
   label: "Wiler (CHWLR)"
  },
  {
   value: "Willisau (CHWSU)",
   label: "Willisau (CHWSU)"
  },
  {
   value: "Wimmis (CHWMM)",
   label: "Wimmis (CHWMM)"
  },
  {
   value: "Trimbach (CHTBS)",
   label: "Trimbach (CHTBS)"
  },
  {
   value: "Trimmis (CHTRS)",
   label: "Trimmis (CHTRS)"
  },
  {
   value: "Troistorrents (CHTRT)",
   label: "Troistorrents (CHTRT)"
  },
  {
   value: "Trübbach (CHTBH)",
   label: "Trübbach (CHTBH)"
  },
  {
   value: "Trubschachen (CHTSA)",
   label: "Trubschachen (CHTSA)"
  },
  {
   value: "Turgi (CHTGI)",
   label: "Turgi (CHTGI)"
  },
  {
   value: "Uesslingen (CHUGN)",
   label: "Uesslingen (CHUGN)"
  },
  {
   value: "Uetendorf (CHUTF)",
   label: "Uetendorf (CHUTF)"
  },
  {
   value: "Uetikon am See (CHUKS)",
   label: "Uetikon am See (CHUKS)"
  },
  {
   value: "Uitikon (CHUKN)",
   label: "Uitikon (CHUKN)"
  },
  {
   value: "Unterägeri (CHUTR)",
   label: "Unterägeri (CHUTR)"
  },
  {
   value: "Unterkulm (CHUTK)",
   label: "Unterkulm (CHUTK)"
  },
  {
   value: "Unterseen (CHUTS)",
   label: "Unterseen (CHUTS)"
  },
  {
   value: "Untersiggenthal (CHUGA)",
   label: "Untersiggenthal (CHUGA)"
  },
  {
   value: "Urdorf (CHURD)",
   label: "Urdorf (CHURD)"
  },
  {
   value: "Ursenbach (CHUNH)",
   label: "Ursenbach (CHUNH)"
  },
  {
   value: "Uster (CHUSR)",
   label: "Uster (CHUSR)"
  },
  {
   value: "Utzenstorf (CHTZE)",
   label: "Utzenstorf (CHTZE)"
  },
  {
   value: "Uznach (CHUZN)",
   label: "Uznach (CHUZN)"
  },
  {
   value: "Vandoeuvres (CHVDO)",
   label: "Vandoeuvres (CHVDO)"
  },
  {
   value: "Vernier (CHVNR)",
   label: "Vernier (CHVNR)"
  },
  {
   value: "Vésenaz (CHVSZ)",
   label: "Vésenaz (CHVSZ)"
  },
  {
   value: "Vétroz (CHVTZ)",
   label: "Vétroz (CHVTZ)"
  },
  {
   value: "Vilars (CHVLA)",
   label: "Vilars (CHVLA)"
  },
  {
   value: "Villars-Sainte-Croix (CHVSC)",
   label: "Villars-Sainte-Croix (CHVSC)"
  },
  {
   value: "Villars-sur-Ollon (CHVIL)",
   label: "Villars-sur-Ollon (CHVIL)"
  },
  {
   value: "Villmergen (CHVMG)",
   label: "Villmergen (CHVMG)"
  },
  {
   value: "Villorsonnens (CHVSN)",
   label: "Villorsonnens (CHVSN)"
  },
  {
   value: "Vinzel (CHVZL)",
   label: "Vinzel (CHVZL)"
  },
  {
   value: "Stein (CHSTN)",
   label: "Stein (CHSTN)"
  },
  {
   value: "Stein am Rhein (CHTGS)",
   label: "Stein am Rhein (CHTGS)"
  },
  {
   value: "Steinach (CHSTE)",
   label: "Steinach (CHSTE)"
  },
  {
   value: "Steinebrunn (CHSTB)",
   label: "Steinebrunn (CHSTB)"
  },
  {
   value: "Steinen (CHSNE)",
   label: "Steinen (CHSNE)"
  },
  {
   value: "Steinhausen (CHSTI)",
   label: "Steinhausen (CHSTI)"
  },
  {
   value: "Stetten (CHSTT)",
   label: "Stetten (CHSTT)"
  },
  {
   value: "Stoos (CHSTO)",
   label: "Stoos (CHSTO)"
  },
  {
   value: "Studen (CHSTU)",
   label: "Studen (CHSTU)"
  },
  {
   value: "St-Ursanne (CHSUN)",
   label: "St-Ursanne (CHSUN)"
  },
  {
   value: "Stüsslingen (CHSOK)",
   label: "Stüsslingen (CHSOK)"
  },
  {
   value: "Suberg (CHSBE)",
   label: "Suberg (CHSBE)"
  },
  {
   value: "Subingen (CHSBI)",
   label: "Subingen (CHSBI)"
  },
  {
   value: "Suhr (CHHSR)",
   label: "Suhr (CHHSR)"
  },
  {
   value: "Sumiswald (CHSMW)",
   label: "Sumiswald (CHSMW)"
  },
  {
   value: "Sursee (CHSUR)",
   label: "Sursee (CHSUR)"
  },
  {
   value: "Tafers (CHTAF)",
   label: "Tafers (CHTAF)"
  },
  {
   value: "Tagelswangen (CHTWG)",
   label: "Tagelswangen (CHTWG)"
  },
  {
   value: "Tägerwilen (CHTWN)",
   label: "Tägerwilen (CHTWN)"
  },
  {
   value: "Tavannes (CHTVS)",
   label: "Tavannes (CHTVS)"
  },
  {
   value: "Taverne (CHTVR)",
   label: "Taverne (CHTVR)"
  },
  {
   value: "Teufen (CHTFN)",
   label: "Teufen (CHTFN)"
  },
  {
   value: "Thal (CHTHL)",
   label: "Thal (CHTHL)"
  },
  {
   value: "Thalheim (CHTHI)",
   label: "Thalheim (CHTHI)"
  },
  {
   value: "Therwil (CHTHW)",
   label: "Therwil (CHTHW)"
  },
  {
   value: "Thörigen (CHTRG)",
   label: "Thörigen (CHTRG)"
  },
  {
   value: "Thörishaus (CHCHT)",
   label: "Thörishaus (CHCHT)"
  },
  {
   value: "Thun (CHTHU)",
   label: "Thun (CHTHU)"
  },
  {
   value: "Thürnen (CHTHR)",
   label: "Thürnen (CHTHR)"
  },
  {
   value: "Thusis (CHTHS)",
   label: "Thusis (CHTHS)"
  },
  {
   value: "Toffen (CHTOF)",
   label: "Toffen (CHTOF)"
  },
  {
   value: "Trasadingen (CHTSD)",
   label: "Trasadingen (CHTSD)"
  },
  {
   value: "Trélex (CHTRX)",
   label: "Trélex (CHTRX)"
  },
  {
   value: "Triengen (CHTNG)",
   label: "Triengen (CHTNG)"
  },
  {
   value: "Seewen (CHSWE)",
   label: "Seewen (CHSWE)"
  },
  {
   value: "Seewen (CHSWN)",
   label: "Seewen (CHSWN)"
  },
  {
   value: "Sempach (CHSPA)",
   label: "Sempach (CHSPA)"
  },
  {
   value: "Sennwald (CHSND)",
   label: "Sennwald (CHSND)"
  },
  {
   value: "Sent (CHSNT)",
   label: "Sent (CHSNT)"
  },
  {
   value: "Seon (CHSEO)",
   label: "Seon (CHSEO)"
  },
  {
   value: "Siebnen (CHSBN)",
   label: "Siebnen (CHSBN)"
  },
  {
   value: "Sierre (CHSRR)",
   label: "Sierre (CHSRR)"
  },
  {
   value: "Sihlbrugg Dorf (CHSHG)",
   label: "Sihlbrugg Dorf (CHSHG)"
  },
  {
   value: "Sins (CHSIN)",
   label: "Sins (CHSIN)"
  },
  {
   value: "Sion (CHSIR)",
   label: "Sion (CHSIR)"
  },
  {
   value: "Sirnach (CHSNH)",
   label: "Sirnach (CHSNH)"
  },
  {
   value: "Sissach (CHSSH)",
   label: "Sissach (CHSSH)"
  },
  {
   value: "Sisseln (CHSIS)",
   label: "Sisseln (CHSIS)"
  },
  {
   value: "Sisseln AG (CHSSS)",
   label: "Sisseln AG (CHSSS)"
  },
  {
   value: "Siviriez (CHFSZ)",
   label: "Siviriez (CHFSZ)"
  },
  {
   value: "Solothurn (CHSOO)",
   label: "Solothurn (CHSOO)"
  },
  {
   value: "Someo (CHSOM)",
   label: "Someo (CHSOM)"
  },
  {
   value: "Sonceboz-Sombeval (CHSZS)",
   label: "Sonceboz-Sombeval (CHSZS)"
  },
  {
   value: "Speicher (CHSCR)",
   label: "Speicher (CHSCR)"
  },
  {
   value: "Spiez (CHSPZ)",
   label: "Spiez (CHSPZ)"
  },
  {
   value: "Spreitenbach (CHSPB)",
   label: "Spreitenbach (CHSPB)"
  },
  {
   value: "St Aubin-Sauges (CHSAS)",
   label: "St Aubin-Sauges (CHSAS)"
  },
  {
   value: "St Blaise (CHSAB)",
   label: "St Blaise (CHSAB)"
  },
  {
   value: "St Légier-La Chiésaz (CHSEC)",
   label: "St Légier-La Chiésaz (CHSEC)"
  },
  {
   value: "St Maurice (CHSMA)",
   label: "St Maurice (CHSMA)"
  },
  {
   value: "St Moritz (CHSMV)",
   label: "St Moritz (CHSMV)"
  },
  {
   value: "St Niklaus (CHNKL)",
   label: "St Niklaus (CHNKL)"
  },
  {
   value: "Stäfa (CHSFA)",
   label: "Stäfa (CHSFA)"
  },
  {
   value: "Stansstad (CHSTA)",
   label: "Stansstad (CHSTA)"
  },
  {
   value: "Steckborn (CHSTC)",
   label: "Steckborn (CHSTC)"
  },
  {
   value: "Steg (CHSTG)",
   label: "Steg (CHSTG)"
  },
  {
   value: "Rüti bei Büren (CHRTB)",
   label: "Rüti bei Büren (CHRTB)"
  },
  {
   value: "Ruvigliana (CHRLA)",
   label: "Ruvigliana (CHRLA)"
  },
  {
   value: "Saanen (CHSAA)",
   label: "Saanen (CHSAA)"
  },
  {
   value: "Saas-Fee (CHSFE)",
   label: "Saas-Fee (CHSFE)"
  },
  {
   value: "Sachseln (CHOSA)",
   label: "Sachseln (CHOSA)"
  },
  {
   value: "Sainte Croix (CHSCX)",
   label: "Sainte Croix (CHSCX)"
  },
  {
   value: "Saint-Prex (CHSPR)",
   label: "Saint-Prex (CHSPR)"
  },
  {
   value: "Salavaux (CHSVX)",
   label: "Salavaux (CHSVX)"
  },
  {
   value: "Sargans (CHSAR)",
   label: "Sargans (CHSAR)"
  },
  {
   value: "Satigny (CHSAT)",
   label: "Satigny (CHSAT)"
  },
  {
   value: "Saxon (CHSXN)",
   label: "Saxon (CHSXN)"
  },
  {
   value: "Schachen (CHSHH)",
   label: "Schachen (CHSHH)"
  },
  {
   value: "Schafisheim (CHSFM)",
   label: "Schafisheim (CHSFM)"
  },
  {
   value: "Schattdorf (CHUSF)",
   label: "Schattdorf (CHUSF)"
  },
  {
   value: "Schenkon (CHSEN)",
   label: "Schenkon (CHSEN)"
  },
  {
   value: "Scherzingen (CHSCG)",
   label: "Scherzingen (CHSCG)"
  },
  {
   value: "Schindellegi (CHSGI)",
   label: "Schindellegi (CHSGI)"
  },
  {
   value: "Schmerikon (CHSMK)",
   label: "Schmerikon (CHSMK)"
  },
  {
   value: "Scholftland (CHSFL)",
   label: "Scholftland (CHSFL)"
  },
  {
   value: "Schönbühl (CHSBL)",
   label: "Schönbühl (CHSBL)"
  },
  {
   value: "Schönengrund (CHSHB)",
   label: "Schönengrund (CHSHB)"
  },
  {
   value: "Schönenwerd (CHSWD)",
   label: "Schönenwerd (CHSWD)"
  },
  {
   value: "Schübelbach (CHSBB)",
   label: "Schübelbach (CHSBB)"
  },
  {
   value: "Schüpbach (CHSBH)",
   label: "Schüpbach (CHSBH)"
  },
  {
   value: "Schüpfen (CHSFN)",
   label: "Schüpfen (CHSFN)"
  },
  {
   value: "Schüpfheim (CHSPF)",
   label: "Schüpfheim (CHSPF)"
  },
  {
   value: "Schwanden (CHSDN)",
   label: "Schwanden (CHSDN)"
  },
  {
   value: "Schwarzenburg (CHSZB)",
   label: "Schwarzenburg (CHSZB)"
  },
  {
   value: "Schweizerhalle (CHWEI)",
   label: "Schweizerhalle (CHWEI)"
  },
  {
   value: "Schwerzenbach (CHSWB)",
   label: "Schwerzenbach (CHSWB)"
  },
  {
   value: "Schwyz (CHSCZ)",
   label: "Schwyz (CHSCZ)"
  },
  {
   value: "Scuol (CHSCU)",
   label: "Scuol (CHSCU)"
  },
  {
   value: "Seegraeben (CHSEE)",
   label: "Seegraeben (CHSEE)"
  },
  {
   value: "Reichenbach (CHRNB)",
   label: "Reichenbach (CHRNB)"
  },
  {
   value: "Reiden (CHREI)",
   label: "Reiden (CHREI)"
  },
  {
   value: "Reinach (CHRCH)",
   label: "Reinach (CHRCH)"
  },
  {
   value: "Reinach (CHREN)",
   label: "Reinach (CHREN)"
  },
  {
   value: "Rekingen (CHRKG)",
   label: "Rekingen (CHRKG)"
  },
  {
   value: "Remaufens (CHRMF)",
   label: "Remaufens (CHRMF)"
  },
  {
   value: "Reussbühl (CHRBU)",
   label: "Reussbühl (CHRBU)"
  },
  {
   value: "Reussbühl (CHREU)",
   label: "Reussbühl (CHREU)"
  },
  {
   value: "Rheineck (CHRNK)",
   label: "Rheineck (CHRNK)"
  },
  {
   value: "Riazzino (CHRZO)",
   label: "Riazzino (CHRZO)"
  },
  {
   value: "Richterswil (CHRIC)",
   label: "Richterswil (CHRIC)"
  },
  {
   value: "Rickenbach (CHRBH)",
   label: "Rickenbach (CHRBH)"
  },
  {
   value: "Rickenbach (CHRHI)",
   label: "Rickenbach (CHRHI)"
  },
  {
   value: "Rickenbach-Attikon (CHRKB)",
   label: "Rickenbach-Attikon (CHRKB)"
  },
  {
   value: "Riedholz (CHRIE)",
   label: "Riedholz (CHRIE)"
  },
  {
   value: "Riehen (CHRHN)",
   label: "Riehen (CHRHN)"
  },
  {
   value: "Roggliswil (CHRWL)",
   label: "Roggliswil (CHRWL)"
  },
  {
   value: "Roggwil (CHRGW)",
   label: "Roggwil (CHRGW)"
  },
  {
   value: "Rolle (CHROL)",
   label: "Rolle (CHROL)"
  },
  {
   value: "Romanshorn (CHRMH)",
   label: "Romanshorn (CHRMH)"
  },
  {
   value: "Root (CHROO)",
   label: "Root (CHROO)"
  },
  {
   value: "Rorschach (CHRRC)",
   label: "Rorschach (CHRRC)"
  },
  {
   value: "Rossens (CHROS)",
   label: "Rossens (CHROS)"
  },
  {
   value: "Rothenburg (CHROT)",
   label: "Rothenburg (CHROT)"
  },
  {
   value: "Rothrist (CHRTR)",
   label: "Rothrist (CHRTR)"
  },
  {
   value: "Rotkreuz (CHRTZ)",
   label: "Rotkreuz (CHRTZ)"
  },
  {
   value: "Rüegsauschachen (CHRUE)",
   label: "Rüegsauschachen (CHRUE)"
  },
  {
   value: "Rümlang (CHRMA)",
   label: "Rümlang (CHRMA)"
  },
  {
   value: "Rupperswil (CHRPP)",
   label: "Rupperswil (CHRPP)"
  },
  {
   value: "Russikon (CHRSS)",
   label: "Russikon (CHRSS)"
  },
  {
   value: "Ruswil (CHRSW)",
   label: "Ruswil (CHRSW)"
  },
  {
   value: "Orbe (CHORE)",
   label: "Orbe (CHORE)"
  },
  {
   value: "Ormalingen (CHOLG)",
   label: "Ormalingen (CHOLG)"
  },
  {
   value: "Orvin (CHOVN)",
   label: "Orvin (CHOVN)"
  },
  {
   value: "Ospizio Bernina (CHOBA)",
   label: "Ospizio Bernina (CHOBA)"
  },
  {
   value: "Ossingen (CHOSG)",
   label: "Ossingen (CHOSG)"
  },
  {
   value: "Otelfingen (CHOFG)",
   label: "Otelfingen (CHOFG)"
  },
  {
   value: "Oulens-sous-Echallens (CHOEH)",
   label: "Oulens-sous-Echallens (CHOEH)"
  },
  {
   value: "Paradiso (CHPDO)",
   label: "Paradiso (CHPDO)"
  },
  {
   value: "Payerne (CHPYE)",
   label: "Payerne (CHPYE)"
  },
  {
   value: "Penthalaz (CHPHZ)",
   label: "Penthalaz (CHPHZ)"
  },
  {
   value: "Penthaz (CHPEN)",
   label: "Penthaz (CHPEN)"
  },
  {
   value: "Perlen (CHLPE)",
   label: "Perlen (CHLPE)"
  },
  {
   value: "Petit-Lancy (CHPET)",
   label: "Petit-Lancy (CHPET)"
  },
  {
   value: "Pfäffikon (CHPFA)",
   label: "Pfäffikon (CHPFA)"
  },
  {
   value: "Pfungen (CHZPN)",
   label: "Pfungen (CHZPN)"
  },
  {
   value: "Pieterlen (CHPRL)",
   label: "Pieterlen (CHPRL)"
  },
  {
   value: "Plaffeien (CHPFN)",
   label: "Plaffeien (CHPFN)"
  },
  {
   value: "Pollegio (CHPLL)",
   label: "Pollegio (CHPLL)"
  },
  {
   value: "Pompaples (CHPPA)",
   label: "Pompaples (CHPPA)"
  },
  {
   value: "Pontresina (CHPTR)",
   label: "Pontresina (CHPTR)"
  },
  {
   value: "Porrentruy (CHPRY)",
   label: "Porrentruy (CHPRY)"
  },
  {
   value: "Posieux (CHPOS)",
   label: "Posieux (CHPOS)"
  },
  {
   value: "Posieux (CHPUX)",
   label: "Posieux (CHPUX)"
  },
  {
   value: "Prangins (CHPGS)",
   label: "Prangins (CHPGS)"
  },
  {
   value: "Préverenges (CHPRS)",
   label: "Préverenges (CHPRS)"
  },
  {
   value: "Prilly (CHPRI)",
   label: "Prilly (CHPRI)"
  },
  {
   value: "Puidoux (CHPDX)",
   label: "Puidoux (CHPDX)"
  },
  {
   value: "Pully (CHPLY)",
   label: "Pully (CHPLY)"
  },
  {
   value: "Puplinge (CHPUB)",
   label: "Puplinge (CHPUB)"
  },
  {
   value: "Quartino (CHQUA)",
   label: "Quartino (CHQUA)"
  },
  {
   value: "Rapperswil (CHZJW)",
   label: "Rapperswil (CHZJW)"
  },
  {
   value: "Raron (CHRRN)",
   label: "Raron (CHRRN)"
  },
  {
   value: "Noranco (CHNOR)",
   label: "Noranco (CHNOR)"
  },
  {
   value: "Nottwil (CHNOT)",
   label: "Nottwil (CHNOT)"
  },
  {
   value: "Novazzano (CHNOZ)",
   label: "Novazzano (CHNOZ)"
  },
  {
   value: "Nunningen (CHNUG)",
   label: "Nunningen (CHNUG)"
  },
  {
   value: "Nussbaumen bei Baden (CHNBB)",
   label: "Nussbaumen bei Baden (CHNBB)"
  },
  {
   value: "Nyon (CHNYO)",
   label: "Nyon (CHNYO)"
  },
  {
   value: "Oberaach (CHORA)",
   label: "Oberaach (CHORA)"
  },
  {
   value: "Oberbipp (CHOBP)",
   label: "Oberbipp (CHOBP)"
  },
  {
   value: "Oberbuchsiten (CHOBB)",
   label: "Oberbuchsiten (CHOBB)"
  },
  {
   value: "Oberbüren (CHOBN)",
   label: "Oberbüren (CHOBN)"
  },
  {
   value: "Oberburg (CHOBU)",
   label: "Oberburg (CHOBU)"
  },
  {
   value: "Oberdiessbach (CHODI)",
   label: "Oberdiessbach (CHODI)"
  },
  {
   value: "Oberentfelden (CHOFE)",
   label: "Oberentfelden (CHOFE)"
  },
  {
   value: "Obergerlafingen (CHGEN)",
   label: "Obergerlafingen (CHGEN)"
  },
  {
   value: "Oberglatt (CHORG)",
   label: "Oberglatt (CHORG)"
  },
  {
   value: "Obergösgen (CHOGN)",
   label: "Obergösgen (CHOGN)"
  },
  {
   value: "Oberhasli (CHOHI)",
   label: "Oberhasli (CHOHI)"
  },
  {
   value: "Oberkirch (CHOBK)",
   label: "Oberkirch (CHOBK)"
  },
  {
   value: "Oberkulm (CHOBM)",
   label: "Oberkulm (CHOBM)"
  },
  {
   value: "Oberried am Brienzersee (CHODB)",
   label: "Oberried am Brienzersee (CHODB)"
  },
  {
   value: "Oberriet (CHORT)",
   label: "Oberriet (CHORT)"
  },
  {
   value: "Oberrohrdorf (CHORD)",
   label: "Oberrohrdorf (CHORD)"
  },
  {
   value: "Oberwil (CHOBL)",
   label: "Oberwil (CHOBL)"
  },
  {
   value: "Oensingen (CHOSN)",
   label: "Oensingen (CHOSN)"
  },
  {
   value: "Oetwil am See (CHOEW)",
   label: "Oetwil am See (CHOEW)"
  },
  {
   value: "Oetwil am See (CHOLS)",
   label: "Oetwil am See (CHOLS)"
  },
  {
   value: "Oetwil an der Limmat (CHOET)",
   label: "Oetwil an der Limmat (CHOET)"
  },
  {
   value: "Oftringen (CHOFT)",
   label: "Oftringen (CHOFT)"
  },
  {
   value: "Ollon (CHOLO)",
   label: "Ollon (CHOLO)"
  },
  {
   value: "Onex (CHONX)",
   label: "Onex (CHONX)"
  },
  {
   value: "Onnens (CHONN)",
   label: "Onnens (CHONN)"
  },
  {
   value: "Onnens (CHONS)",
   label: "Onnens (CHONS)"
  },
  {
   value: "Opfikon (CHOFN)",
   label: "Opfikon (CHOFN)"
  },
  {
   value: "Münchenstein (CHMUS)",
   label: "Münchenstein (CHMUS)"
  },
  {
   value: "Münchwilen (CHMWI)",
   label: "Münchwilen (CHMWI)"
  },
  {
   value: "Münsingen (CHMSN)",
   label: "Münsingen (CHMSN)"
  },
  {
   value: "Müntschemier (CHMYY)",
   label: "Müntschemier (CHMYY)"
  },
  {
   value: "Murg (CHMUG)",
   label: "Murg (CHMUG)"
  },
  {
   value: "Murgenthal (CHMRG)",
   label: "Murgenthal (CHMRG)"
  },
  {
   value: "Muri bei Bern (CHMBB)",
   label: "Muri bei Bern (CHMBB)"
  },
  {
   value: "Murten (CHMTN)",
   label: "Murten (CHMTN)"
  },
  {
   value: "Müstair (CHMSR)",
   label: "Müstair (CHMSR)"
  },
  {
   value: "Muzzano (CHMUZ)",
   label: "Muzzano (CHMUZ)"
  },
  {
   value: "Näfels (CHNEF)",
   label: "Näfels (CHNEF)"
  },
  {
   value: "Nänikon (CHNKN)",
   label: "Nänikon (CHNKN)"
  },
  {
   value: "Neerach (CHNRH)",
   label: "Neerach (CHNRH)"
  },
  {
   value: "Neftenbach (CHNFH)",
   label: "Neftenbach (CHNFH)"
  },
  {
   value: "Nendaz (CHNDZ)",
   label: "Nendaz (CHNDZ)"
  },
  {
   value: "Nesslau (CHNES)",
   label: "Nesslau (CHNES)"
  },
  {
   value: "Neuchâtel (CHQNC)",
   label: "Neuchâtel (CHQNC)"
  },
  {
   value: "Neuenegg (CHNGG)",
   label: "Neuenegg (CHNGG)"
  },
  {
   value: "Neuenhof (CHNHF)",
   label: "Neuenhof (CHNHF)"
  },
  {
   value: "Neuhausen am Rheinfall (CHNHR)",
   label: "Neuhausen am Rheinfall (CHNHR)"
  },
  {
   value: "Neunkirch (CHNKS)",
   label: "Neunkirch (CHNKS)"
  },
  {
   value: "Neyruz (CHNYZ)",
   label: "Neyruz (CHNYZ)"
  },
  {
   value: "Niederbipp (CHNDB)",
   label: "Niederbipp (CHNDB)"
  },
  {
   value: "Niederbuchsiten (CHNRN)",
   label: "Niederbuchsiten (CHNRN)"
  },
  {
   value: "Niedergösgen (CHNDG)",
   label: "Niedergösgen (CHNDG)"
  },
  {
   value: "Niederhasli (CHHAS)",
   label: "Niederhasli (CHHAS)"
  },
  {
   value: "Niederhasli (CHNHI)",
   label: "Niederhasli (CHNHI)"
  },
  {
   value: "Niederuzwil (CHNRL)",
   label: "Niederuzwil (CHNRL)"
  },
  {
   value: "Niederwichtrach (CHNWT)",
   label: "Niederwichtrach (CHNWT)"
  },
  {
   value: "Matran (CHMAT)",
   label: "Matran (CHMAT)"
  },
  {
   value: "Matzingen (CHMZI)",
   label: "Matzingen (CHMZI)"
  },
  {
   value: "Maur (CHMAU)",
   label: "Maur (CHMAU)"
  },
  {
   value: "Meggen (CHMEG)",
   label: "Meggen (CHMEG)"
  },
  {
   value: "Meilen (CHMLN)",
   label: "Meilen (CHMLN)"
  },
  {
   value: "Meiringen (CHMEI)",
   label: "Meiringen (CHMEI)"
  },
  {
   value: "Meisterschwanden (CHMSC)",
   label: "Meisterschwanden (CHMSC)"
  },
  {
   value: "Meisterschwanden (CHMWA)",
   label: "Meisterschwanden (CHMWA)"
  },
  {
   value: "Mellingen (CHMLG)",
   label: "Mellingen (CHMLG)"
  },
  {
   value: "Mels (CHSMS)",
   label: "Mels (CHSMS)"
  },
  {
   value: "Mendrisio (CHMEN)",
   label: "Mendrisio (CHMEN)"
  },
  {
   value: "Menziken (CHMZK)",
   label: "Menziken (CHMZK)"
  },
  {
   value: "Menzingen (CHMZN)",
   label: "Menzingen (CHMZN)"
  },
  {
   value: "Menznau (CHMZU)",
   label: "Menznau (CHMZU)"
  },
  {
   value: "Merenschwand (CHMSD)",
   label: "Merenschwand (CHMSD)"
  },
  {
   value: "Meyrin (CHMEY)",
   label: "Meyrin (CHMEY)"
  },
  {
   value: "Mies (CHMIS)",
   label: "Mies (CHMIS)"
  },
  {
   value: "Minusio (CHMIO)",
   label: "Minusio (CHMIO)"
  },
  {
   value: "Mitlödi (CHMIT)",
   label: "Mitlödi (CHMIT)"
  },
  {
   value: "Mollis (CHMOL)",
   label: "Mollis (CHMOL)"
  },
  {
   value: "Mönchaltorf (CHMTF)",
   label: "Mönchaltorf (CHMTF)"
  },
  {
   value: "Montlingen (CHMNG)",
   label: "Montlingen (CHMNG)"
  },
  {
   value: "Montreux (CHMNT)",
   label: "Montreux (CHMNT)"
  },
  {
   value: "Moosleerau (CHMLU)",
   label: "Moosleerau (CHMLU)"
  },
  {
   value: "Möriken (CHMKN)",
   label: "Möriken (CHMKN)"
  },
  {
   value: "Moudon (CHMOU)",
   label: "Moudon (CHMOU)"
  },
  {
   value: "Muhen (CHMUH)",
   label: "Muhen (CHMUH)"
  },
  {
   value: "Muhlruti (CHMHR)",
   label: "Muhlruti (CHMHR)"
  },
  {
   value: "Müllheim (CHMLL)",
   label: "Müllheim (CHMLL)"
  },
  {
   value: "Mümliswil (CHMLW)",
   label: "Mümliswil (CHMLW)"
  },
  {
   value: "Mumpf (CHMPF)",
   label: "Mumpf (CHMPF)"
  },
  {
   value: "Münchenbuchsee (CHMNB)",
   label: "Münchenbuchsee (CHMNB)"
  },
  {
   value: "Lengnau (CHLNU)",
   label: "Lengnau (CHLNU)"
  },
  {
   value: "Lenk (CHLNK)",
   label: "Lenk (CHLNK)"
  },
  {
   value: "Lenzerheide (CHLNZ)",
   label: "Lenzerheide (CHLNZ)"
  },
  {
   value: "Les Acacias (CHLES)",
   label: "Les Acacias (CHLES)"
  },
  {
   value: "Les Verrières (CHLVR)",
   label: "Les Verrières (CHLVR)"
  },
  {
   value: "Leuggern (CHLGE)",
   label: "Leuggern (CHLGE)"
  },
  {
   value: "Leuk (CHLEU)",
   label: "Leuk (CHLEU)"
  },
  {
   value: "Leysin (CHLYN)",
   label: "Leysin (CHLYN)"
  },
  {
   value: "Lichtensteig (CHLSG)",
   label: "Lichtensteig (CHLSG)"
  },
  {
   value: "Liebefeld (CHLFL)",
   label: "Liebefeld (CHLFL)"
  },
  {
   value: "Liestal (CHLTL)",
   label: "Liestal (CHLTL)"
  },
  {
   value: "Lindau (CHLIU)",
   label: "Lindau (CHLIU)"
  },
  {
   value: "Littau (CHLIT)",
   label: "Littau (CHLIT)"
  },
  {
   value: "Lostorf (CHLSF)",
   label: "Lostorf (CHLSF)"
  },
  {
   value: "Lotzwil (CHLOT)",
   label: "Lotzwil (CHLOT)"
  },
  {
   value: "Lucens (CHLCS)",
   label: "Lucens (CHLCS)"
  },
  {
   value: "Lungern (CHLGN)",
   label: "Lungern (CHLGN)"
  },
  {
   value: "Lupfig (CHLPG)",
   label: "Lupfig (CHLPG)"
  },
  {
   value: "Luterbach (CHLRH)",
   label: "Luterbach (CHLRH)"
  },
  {
   value: "Lutry (CHLTY)",
   label: "Lutry (CHLTY)"
  },
  {
   value: "Lützelflüh (CHBLH)",
   label: "Lützelflüh (CHBLH)"
  },
  {
   value: "Luzern (CHLZN)",
   label: "Luzern (CHLZN)"
  },
  {
   value: "Lyssach (CHLSA)",
   label: "Lyssach (CHLSA)"
  },
  {
   value: "Madetswil (CHMDL)",
   label: "Madetswil (CHMDL)"
  },
  {
   value: "Mägenwil (CHMGW)",
   label: "Mägenwil (CHMGW)"
  },
  {
   value: "Malters (CHMAL)",
   label: "Malters (CHMAL)"
  },
  {
   value: "Männedorf (CHMDF)",
   label: "Männedorf (CHMDF)"
  },
  {
   value: "Manno (CHMNN)",
   label: "Manno (CHMNN)"
  },
  {
   value: "Marin-Epagnier (CHMNE)",
   label: "Marin-Epagnier (CHMNE)"
  },
  {
   value: "Marly (CHMRL)",
   label: "Marly (CHMRL)"
  },
  {
   value: "Maroggia (CHMRO)",
   label: "Maroggia (CHMRO)"
  },
  {
   value: "Märstetten (CHMAR)",
   label: "Märstetten (CHMAR)"
  },
  {
   value: "Martigny-Ville (CHVME)",
   label: "Martigny-Ville (CHVME)"
  },
  {
   value: "Märwil (CHMAE)",
   label: "Märwil (CHMAE)"
  },
  {
   value: "Künten (CHKNN)",
   label: "Künten (CHKNN)"
  },
  {
   value: "Kussnacht (CHKSS)",
   label: "Kussnacht (CHKSS)"
  },
  {
   value: "Küssnacht am Rigi (CHKSR)",
   label: "Küssnacht am Rigi (CHKSR)"
  },
  {
   value: "La Chaux-de-Fonds (CHLCF)",
   label: "La Chaux-de-Fonds (CHLCF)"
  },
  {
   value: "La Croix-de-Rozon (CHLCR)",
   label: "La Croix-de-Rozon (CHLCR)"
  },
  {
   value: "La Plaine (CHPLN)",
   label: "La Plaine (CHPLN)"
  },
  {
   value: "La Sagne (CHSGN)",
   label: "La Sagne (CHSGN)"
  },
  {
   value: "La Sarraz (CHLSZ)",
   label: "La Sarraz (CHLSZ)"
  },
  {
   value: "Lachen (CHLAH)",
   label: "Lachen (CHLAH)"
  },
  {
   value: "Lachen (CHLHN)",
   label: "Lachen (CHLHN)"
  },
  {
   value: "Lalden (CHLAL)",
   label: "Lalden (CHLAL)"
  },
  {
   value: "Lamboing (CHLBN)",
   label: "Lamboing (CHLBN)"
  },
  {
   value: "Lamone (CHLOE)",
   label: "Lamone (CHLOE)"
  },
  {
   value: "Landquart (CHLQU)",
   label: "Landquart (CHLQU)"
  },
  {
   value: "Langenthal (CHLAN)",
   label: "Langenthal (CHLAN)"
  },
  {
   value: "Langnau (CHLGU)",
   label: "Langnau (CHLGU)"
  },
  {
   value: "Langnau im Emmental (CHLNA)",
   label: "Langnau im Emmental (CHLNA)"
  },
  {
   value: "Laufen (CHLFN)",
   label: "Laufen (CHLFN)"
  },
  {
   value: "Laufenburg (CHLAF)",
   label: "Laufenburg (CHLAF)"
  },
  {
   value: "Laupen (CHLPN)",
   label: "Laupen (CHLPN)"
  },
  {
   value: "Le Brassus (CHBRS)",
   label: "Le Brassus (CHBRS)"
  },
  {
   value: "Le Châble (CHLCA)",
   label: "Le Châble (CHLCA)"
  },
  {
   value: "Le Chalet-à-Gobet (CHCGT)",
   label: "Le Chalet-à-Gobet (CHCGT)"
  },
  {
   value: "Le Crêt (CHCRE)",
   label: "Le Crêt (CHCRE)"
  },
  {
   value: "Le Crêt-du-Locle (CHCLC)",
   label: "Le Crêt-du-Locle (CHCLC)"
  },
  {
   value: "Le Grand-Saconnex (CHLGS)",
   label: "Le Grand-Saconnex (CHLGS)"
  },
  {
   value: "Le Landeron (CHLDO)",
   label: "Le Landeron (CHLDO)"
  },
  {
   value: "Le Lieu (CHLLU)",
   label: "Le Lieu (CHLLU)"
  },
  {
   value: "Le Mont-sur-Lausanne (CHLML)",
   label: "Le Mont-sur-Lausanne (CHLML)"
  },
  {
   value: "Le Noirmont (CHNOI)",
   label: "Le Noirmont (CHNOI)"
  },
  {
   value: "Le Sépey (CHSPY)",
   label: "Le Sépey (CHSPY)"
  },
  {
   value: "Le Vaud (CHLVA)",
   label: "Le Vaud (CHLVA)"
  },
  {
   value: "Leibstadt (CHLBT)",
   label: "Leibstadt (CHLBT)"
  },
  {
   value: "Lengnau (CHLNG)",
   label: "Lengnau (CHLNG)"
  },
  {
   value: "Ipsach (CHIPS)",
   label: "Ipsach (CHIPS)"
  },
  {
   value: "Iragna (CHIRA)",
   label: "Iragna (CHIRA)"
  },
  {
   value: "Islikon (CHISL)",
   label: "Islikon (CHISL)"
  },
  {
   value: "Itingen (CHBIN)",
   label: "Itingen (CHBIN)"
  },
  {
   value: "Jegenstorf (CHJGT)",
   label: "Jegenstorf (CHJGT)"
  },
  {
   value: "Jona (CHJON)",
   label: "Jona (CHJON)"
  },
  {
   value: "Jonen (CHJNE)",
   label: "Jonen (CHJNE)"
  },
  {
   value: "Jussy (CHJSY)",
   label: "Jussy (CHJSY)"
  },
  {
   value: "Kaiseraugst (CHKGT)",
   label: "Kaiseraugst (CHKGT)"
  },
  {
   value: "Kaisten (CHKAI)",
   label: "Kaisten (CHKAI)"
  },
  {
   value: "Kandersteg (CHKAN)",
   label: "Kandersteg (CHKAN)"
  },
  {
   value: "Kaufdorf (CHKFO)",
   label: "Kaufdorf (CHKFO)"
  },
  {
   value: "Kehrsatz (CHKSZ)",
   label: "Kehrsatz (CHKSZ)"
  },
  {
   value: "Kemptthal (CHKEH)",
   label: "Kemptthal (CHKEH)"
  },
  {
   value: "Kerns (CHKER)",
   label: "Kerns (CHKER)"
  },
  {
   value: "Kerzers (CHKEZ)",
   label: "Kerzers (CHKEZ)"
  },
  {
   value: "Kestenholz (CHKSO)",
   label: "Kestenholz (CHKSO)"
  },
  {
   value: "Kiesen (CHKIE)",
   label: "Kiesen (CHKIE)"
  },
  {
   value: "Killwangen (CHKIW)",
   label: "Killwangen (CHKIW)"
  },
  {
   value: "Kirchberg (CHKHB)",
   label: "Kirchberg (CHKHB)"
  },
  {
   value: "Kirchberg (CHKRG)",
   label: "Kirchberg (CHKRG)"
  },
  {
   value: "Kirchdorf (CHKCO)",
   label: "Kirchdorf (CHKCO)"
  },
  {
   value: "Kirchlindach (CHBEK)",
   label: "Kirchlindach (CHBEK)"
  },
  {
   value: "Kleinbosingen (CHKBO)",
   label: "Kleinbosingen (CHKBO)"
  },
  {
   value: "Kleindöttingen (CHKDO)",
   label: "Kleindöttingen (CHKDO)"
  },
  {
   value: "Klingnau (CHRGU)",
   label: "Klingnau (CHRGU)"
  },
  {
   value: "Klosters (CHKLS)",
   label: "Klosters (CHKLS)"
  },
  {
   value: "Kloten (CHKTN)",
   label: "Kloten (CHKTN)"
  },
  {
   value: "Knonau (CHKNA)",
   label: "Knonau (CHKNA)"
  },
  {
   value: "Koeniz (CHKOZ)",
   label: "Koeniz (CHKOZ)"
  },
  {
   value: "Kölliken (CHKOL)",
   label: "Kölliken (CHKOL)"
  },
  {
   value: "Konolfingen (CHKON)",
   label: "Konolfingen (CHKON)"
  },
  {
   value: "Kottwil (CHKWI)",
   label: "Kottwil (CHKWI)"
  },
  {
   value: "Kriens (CHKRS)",
   label: "Kriens (CHKRS)"
  },
  {
   value: "Kriessern (CHKSN)",
   label: "Kriessern (CHKSN)"
  },
  {
   value: "Günsberg (CHGNS)",
   label: "Günsberg (CHGNS)"
  },
  {
   value: "Gunzgen (CHGZN)",
   label: "Gunzgen (CHGZN)"
  },
  {
   value: "Güttingen (CHGTT)",
   label: "Güttingen (CHGTT)"
  },
  {
   value: "Gwatt (CHGWT)",
   label: "Gwatt (CHGWT)"
  },
  {
   value: "Hägendorf (CHHGD)",
   label: "Hägendorf (CHHGD)"
  },
  {
   value: "Härkingen (CHHKN)",
   label: "Härkingen (CHHKN)"
  },
  {
   value: "Hasle-Rüegsau (CHHRU)",
   label: "Hasle-Rüegsau (CHHRU)"
  },
  {
   value: "Hausen bei Brugg (CHHAU)",
   label: "Hausen bei Brugg (CHHAU)"
  },
  {
   value: "Hauterive (CHHTE)",
   label: "Hauterive (CHHTE)"
  },
  {
   value: "Hedingen (CHHED)",
   label: "Hedingen (CHHED)"
  },
  {
   value: "Heerbrugg (CHHEE)",
   label: "Heerbrugg (CHHEE)"
  },
  {
   value: "Hegnau (CHHGA)",
   label: "Hegnau (CHHGA)"
  },
  {
   value: "Heiden (CHHEI)",
   label: "Heiden (CHHEI)"
  },
  {
   value: "Heimberg (CHHMG)",
   label: "Heimberg (CHHMG)"
  },
  {
   value: "Henau (CHHNA)",
   label: "Henau (CHHNA)"
  },
  {
   value: "Herisau (CHHSA)",
   label: "Herisau (CHHSA)"
  },
  {
   value: "Herrliberg (CHHBG)",
   label: "Herrliberg (CHHBG)"
  },
  {
   value: "Herzogenbuchsee (CHHRZ)",
   label: "Herzogenbuchsee (CHHRZ)"
  },
  {
   value: "Hilterfingen (CHBEH)",
   label: "Hilterfingen (CHBEH)"
  },
  {
   value: "Hinterforst (CHHFO)",
   label: "Hinterforst (CHHFO)"
  },
  {
   value: "Hinwil (CHHNW)",
   label: "Hinwil (CHHNW)"
  },
  {
   value: "Hirzel (CHHZL)",
   label: "Hirzel (CHHZL)"
  },
  {
   value: "Hitzkirch (CHHTK)",
   label: "Hitzkirch (CHHTK)"
  },
  {
   value: "Hochdorf (CHHOC)",
   label: "Hochdorf (CHHOC)"
  },
  {
   value: "Hohenrain (CHHOH)",
   label: "Hohenrain (CHHOH)"
  },
  {
   value: "Hölstein (CHHSN)",
   label: "Hölstein (CHHSN)"
  },
  {
   value: "Honau (CHHNU)",
   label: "Honau (CHHNU)"
  },
  {
   value: "Horgen (CHHOE)",
   label: "Horgen (CHHOE)"
  },
  {
   value: "Höri (CHHRI)",
   label: "Höri (CHHRI)"
  },
  {
   value: "Hünenberg (CHHUN)",
   label: "Hünenberg (CHHUN)"
  },
  {
   value: "Hunzenschwil (CHHZW)",
   label: "Hunzenschwil (CHHZW)"
  },
  {
   value: "Hüttikon (CHHTT)",
   label: "Hüttikon (CHHTT)"
  },
  {
   value: "Huttwil (CHHWL)",
   label: "Huttwil (CHHWL)"
  },
  {
   value: "Huttwilen (CHHWI)",
   label: "Huttwilen (CHHWI)"
  },
  {
   value: "Ilanz (CHILZ)",
   label: "Ilanz (CHILZ)"
  },
  {
   value: "Illgau (CHILG)",
   label: "Illgau (CHILG)"
  },
  {
   value: "Ins (CHINS)",
   label: "Ins (CHINS)"
  },
  {
   value: "Interlaken (CHINT)",
   label: "Interlaken (CHINT)"
  },
  {
   value: "Füllinsdorf (CHFRF)",
   label: "Füllinsdorf (CHFRF)"
  },
  {
   value: "Fully (CHFLY)",
   label: "Fully (CHFLY)"
  },
  {
   value: "Gams (CHGAM)",
   label: "Gams (CHGAM)"
  },
  {
   value: "Gansingen (CHGAN)",
   label: "Gansingen (CHGAN)"
  },
  {
   value: "Geneva = Genève (CH)",
   label: "Geneva = Genève (CH)"
  },
  {
   value: "Gilly (CHGLL)",
   label: "Gilly (CHGLL)"
  },
  {
   value: "Giornico (CHTGO)",
   label: "Giornico (CHTGO)"
  },
  {
   value: "Gipf-Oberfrick (CHGOF)",
   label: "Gipf-Oberfrick (CHGOF)"
  },
  {
   value: "Givisiez (CHGSZ)",
   label: "Givisiez (CHGSZ)"
  },
  {
   value: "Glarus (CHGLA)",
   label: "Glarus (CHGLA)"
  },
  {
   value: "Glattbrugg (CHGTG)",
   label: "Glattbrugg (CHGTG)"
  },
  {
   value: "Glattfelden (CHGFN)",
   label: "Glattfelden (CHGFN)"
  },
  {
   value: "Goldach (CHGLD)",
   label: "Goldach (CHGLD)"
  },
  {
   value: "Goldau (CHGOL)",
   label: "Goldau (CHGOL)"
  },
  {
   value: "Gondo (CHGON)",
   label: "Gondo (CHGON)"
  },
  {
   value: "Gossau (CHGOS)",
   label: "Gossau (CHGOS)"
  },
  {
   value: "Gossau (CHZHH)",
   label: "Gossau (CHZHH)"
  },
  {
   value: "Granges-près-Marnand (CHGPM)",
   label: "Granges-près-Marnand (CHGPM)"
  },
  {
   value: "Gränichen (CHGNI)",
   label: "Gränichen (CHGNI)"
  },
  {
   value: "Grellingen (CHGLN)",
   label: "Grellingen (CHGLN)"
  },
  {
   value: "Grenchen (CHGRN)",
   label: "Grenchen (CHGRN)"
  },
  {
   value: "Grindelwald (CHGRI)",
   label: "Grindelwald (CHGRI)"
  },
  {
   value: "Grône (CHGNE)",
   label: "Grône (CHGNE)"
  },
  {
   value: "Grossaffoltern (CHGRO)",
   label: "Grossaffoltern (CHGRO)"
  },
  {
   value: "Grüningen (CHGNG)",
   label: "Grüningen (CHGNG)"
  },
  {
   value: "Grüsch (CHGRS)",
   label: "Grüsch (CHGRS)"
  },
  {
   value: "Gruyeres (CHGYS)",
   label: "Gruyeres (CHGYS)"
  },
  {
   value: "Gstaad (CHGST)",
   label: "Gstaad (CHGST)"
  },
  {
   value: "Gumligen (CHGML)",
   label: "Gumligen (CHGML)"
  },
  {
   value: "Ermenswil (CHEWL)",
   label: "Ermenswil (CHEWL)"
  },
  {
   value: "Erstfeld (CHETD)",
   label: "Erstfeld (CHETD)"
  },
  {
   value: "Eschenbach (CHECB)",
   label: "Eschenbach (CHECB)"
  },
  {
   value: "Eschlikon (CHEHK)",
   label: "Eschlikon (CHEHK)"
  },
  {
   value: "Estavayer-le-Gibloux (CHELB)",
   label: "Estavayer-le-Gibloux (CHELB)"
  },
  {
   value: "Estavayer-le-Lac (CHELL)",
   label: "Estavayer-le-Lac (CHELL)"
  },
  {
   value: "Etoy (CHETO)",
   label: "Etoy (CHETO)"
  },
  {
   value: "Ettingen (CHETT)",
   label: "Ettingen (CHETT)"
  },
  {
   value: "Evionnaz (CHEVZ)",
   label: "Evionnaz (CHEVZ)"
  },
  {
   value: "Fahy (CHFHY)",
   label: "Fahy (CHFHY)"
  },
  {
   value: "Fallanden (CHFLD)",
   label: "Fallanden (CHFLD)"
  },
  {
   value: "Fehraltorf (CHFTF)",
   label: "Fehraltorf (CHFTF)"
  },
  {
   value: "Felben (CHFBA)",
   label: "Felben (CHFBA)"
  },
  {
   value: "Feldbach (CHFEH)",
   label: "Feldbach (CHFEH)"
  },
  {
   value: "Feldmeilen (CHFEM)",
   label: "Feldmeilen (CHFEM)"
  },
  {
   value: "Feusisberg (CHFSG)",
   label: "Feusisberg (CHFSG)"
  },
  {
   value: "Fey (CHFEY)",
   label: "Fey (CHFEY)"
  },
  {
   value: "Finhaut (CHFIN)",
   label: "Finhaut (CHFIN)"
  },
  {
   value: "Fischbach Goslikon (CHFGK)",
   label: "Fischbach Goslikon (CHFGK)"
  },
  {
   value: "Fläsch (CHFLA)",
   label: "Fläsch (CHFLA)"
  },
  {
   value: "Flawil (CHFLW)",
   label: "Flawil (CHFLW)"
  },
  {
   value: "Fleurier (CHFLI)",
   label: "Fleurier (CHFLI)"
  },
  {
   value: "Flüelen (CHFLN)",
   label: "Flüelen (CHFLN)"
  },
  {
   value: "Flüh (CHYFL)",
   label: "Flüh (CHYFL)"
  },
  {
   value: "Flurlingen (CHFLJ)",
   label: "Flurlingen (CHFLJ)"
  },
  {
   value: "Founex (CHFNX)",
   label: "Founex (CHFNX)"
  },
  {
   value: "Freidorf (CHFRD)",
   label: "Freidorf (CHFRD)"
  },
  {
   value: "Freidorf (CHFRE)",
   label: "Freidorf (CHFRE)"
  },
  {
   value: "Freienbach (CHFBH)",
   label: "Freienbach (CHFBH)"
  },
  {
   value: "Frick (CHFCK)",
   label: "Frick (CHFCK)"
  },
  {
   value: "Disentis\/Mustér (CHDIS)",
   label: "Disentis\/Mustér (CHDIS)"
  },
  {
   value: "Domdidier (CHDDR)",
   label: "Domdidier (CHDDR)"
  },
  {
   value: "Dornach (CHDOR)",
   label: "Dornach (CHDOR)"
  },
  {
   value: "Dottikon (CHDTO)",
   label: "Dottikon (CHDTO)"
  },
  {
   value: "Döttingen (CHDOT)",
   label: "Döttingen (CHDOT)"
  },
  {
   value: "Dotzigen (CHDTZ)",
   label: "Dotzigen (CHDTZ)"
  },
  {
   value: "Dozwil (CHDOZ)",
   label: "Dozwil (CHDOZ)"
  },
  {
   value: "Dübendorf (CHDRF)",
   label: "Dübendorf (CHDRF)"
  },
  {
   value: "Duggingen (CHDGI)",
   label: "Duggingen (CHDGI)"
  },
  {
   value: "Dulliken (CHDIN)",
   label: "Dulliken (CHDIN)"
  },
  {
   value: "Ebnat-Kappel (CHEKP)",
   label: "Ebnat-Kappel (CHEKP)"
  },
  {
   value: "Echandens (CHECH)",
   label: "Echandens (CHECH)"
  },
  {
   value: "Eclagnens (CHEGS)",
   label: "Eclagnens (CHEGS)"
  },
  {
   value: "Eclépens (CHECL)",
   label: "Eclépens (CHECL)"
  },
  {
   value: "Ecublens (CHELS)",
   label: "Ecublens (CHELS)"
  },
  {
   value: "Ecuvillens (CHEVL)",
   label: "Ecuvillens (CHEVL)"
  },
  {
   value: "Edlibach (CHEDB)",
   label: "Edlibach (CHEDB)"
  },
  {
   value: "Egg (CHZEG)",
   label: "Egg (CHZEG)"
  },
  {
   value: "Eglisau (CHGWF)",
   label: "Eglisau (CHGWF)"
  },
  {
   value: "Egliswil (CHEGL)",
   label: "Egliswil (CHEGL)"
  },
  {
   value: "Eiken (CHEIK)",
   label: "Eiken (CHEIK)"
  },
  {
   value: "Einsiedeln (CHESD)",
   label: "Einsiedeln (CHESD)"
  },
  {
   value: "Embrach (CHEBH)",
   label: "Embrach (CHEBH)"
  },
  {
   value: "Embrach-Embraport (CHZET)",
   label: "Embrach-Embraport (CHZET)"
  },
  {
   value: "Emmen (CHEMM)",
   label: "Emmen (CHEMM)"
  },
  {
   value: "Emmenbrücke (CHEBC)",
   label: "Emmenbrücke (CHEBC)"
  },
  {
   value: "Endingen (CHEDG)",
   label: "Endingen (CHEDG)"
  },
  {
   value: "Engelberg (CHENG)",
   label: "Engelberg (CHENG)"
  },
  {
   value: "Engelburg (CHELG)",
   label: "Engelburg (CHELG)"
  },
  {
   value: "Ennetaach (CHTEH)",
   label: "Ennetaach (CHTEH)"
  },
  {
   value: "Entlebuch (CHENT)",
   label: "Entlebuch (CHENT)"
  },
  {
   value: "Epesses (CHEPS)",
   label: "Epesses (CHEPS)"
  },
  {
   value: "Erlen (CHERT)",
   label: "Erlen (CHERT)"
  },
  {
   value: "Erlenbach (CHERB)",
   label: "Erlenbach (CHERB)"
  },
  {
   value: "Erlinsbach (CHERL)",
   label: "Erlinsbach (CHERL)"
  },
  {
   value: "Collex-Bossy (CHCBY)",
   label: "Collex-Bossy (CHCBY)"
  },
  {
   value: "Collombey (CHCOL)",
   label: "Collombey (CHCOL)"
  },
  {
   value: "Concise (CHCON)",
   label: "Concise (CHCON)"
  },
  {
   value: "Conthey (CHCHY)",
   label: "Conthey (CHCHY)"
  },
  {
   value: "Coppet (CHCOP)",
   label: "Coppet (CHCOP)"
  },
  {
   value: "Corbeyrier (CHCRY)",
   label: "Corbeyrier (CHCRY)"
  },
  {
   value: "Corcelles-près-Payerne (CHCOR)",
   label: "Corcelles-près-Payerne (CHCOR)"
  },
  {
   value: "Corsier-sur-Vevey (CHCOS)",
   label: "Corsier-sur-Vevey (CHCOS)"
  },
  {
   value: "Courfaivre (CHCOE)",
   label: "Courfaivre (CHCOE)"
  },
  {
   value: "Courtelary (CHCTY)",
   label: "Courtelary (CHCTY)"
  },
  {
   value: "Couvet (CHCVT)",
   label: "Couvet (CHCVT)"
  },
  {
   value: "Crans (CHCDY)",
   label: "Crans (CHCDY)"
  },
  {
   value: "Crans Montana (CHCMT)",
   label: "Crans Montana (CHCMT)"
  },
  {
   value: "Cressier (CHCRR)",
   label: "Cressier (CHCRR)"
  },
  {
   value: "Dagmersellen (CHDAE)",
   label: "Dagmersellen (CHDAE)"
  },
  {
   value: "Daillens (CHDLS)",
   label: "Daillens (CHDLS)"
  },
  {
   value: "Dällikon (CHDON)",
   label: "Dällikon (CHDON)"
  },
  {
   value: "Däniken (CHDNK)",
   label: "Däniken (CHDNK)"
  },
  {
   value: "Dättwil (CHDWL)",
   label: "Dättwil (CHDWL)"
  },
  {
   value: "Davos Platz (CHDPZ)",
   label: "Davos Platz (CHDPZ)"
  },
  {
   value: "Delémont (CHDEL)",
   label: "Delémont (CHDEL)"
  },
  {
   value: "Densbüren (CHDBU)",
   label: "Densbüren (CHDBU)"
  },
  {
   value: "Derendingen (CHDRD)",
   label: "Derendingen (CHDRD)"
  },
  {
   value: "Detligen (CHDTG)",
   label: "Detligen (CHDTG)"
  },
  {
   value: "Develier (CHDVI)",
   label: "Develier (CHDVI)"
  },
  {
   value: "Develier (CHDVR)",
   label: "Develier (CHDVR)"
  },
  {
   value: "Dielsdorf (CHDLD)",
   label: "Dielsdorf (CHDLD)"
  },
  {
   value: "Diepoldsau (CHDPS)",
   label: "Diepoldsau (CHDPS)"
  },
  {
   value: "Dierikon (CHDKN)",
   label: "Dierikon (CHDKN)"
  },
  {
   value: "Dietlikon (CHDLK)",
   label: "Dietlikon (CHDLK)"
  },
  {
   value: "Dintikon (CHDTK)",
   label: "Dintikon (CHDTK)"
  },
  {
   value: "Brunegg (CHBNG)",
   label: "Brunegg (CHBNG)"
  },
  {
   value: "Brunnen (CHBRU)",
   label: "Brunnen (CHBRU)"
  },
  {
   value: "Brüttisellen (CHBTL)",
   label: "Brüttisellen (CHBTL)"
  },
  {
   value: "Buchs (CHBCS)",
   label: "Buchs (CHBCS)"
  },
  {
   value: "Bülach (CHBUA)",
   label: "Bülach (CHBUA)"
  },
  {
   value: "Burg (CHBRG)",
   label: "Burg (CHBRG)"
  },
  {
   value: "Bursinel (CHBUR)",
   label: "Bursinel (CHBUR)"
  },
  {
   value: "Büsserach (CHBSH)",
   label: "Büsserach (CHBSH)"
  },
  {
   value: "Bussigny-près-Lausanne (CHBUS)",
   label: "Bussigny-près-Lausanne (CHBUS)"
  },
  {
   value: "Busswil (CHBSU)",
   label: "Busswil (CHBSU)"
  },
  {
   value: "Buttikon (CHBTK)",
   label: "Buttikon (CHBTK)"
  },
  {
   value: "Bützberg (CHBZG)",
   label: "Bützberg (CHBZG)"
  },
  {
   value: "Carouge (CHCRG)",
   label: "Carouge (CHCRG)"
  },
  {
   value: "Cartigny (CHCAR)",
   label: "Cartigny (CHCAR)"
  },
  {
   value: "Castasegna (CHCAS)",
   label: "Castasegna (CHCAS)"
  },
  {
   value: "Cham (CHHHM)",
   label: "Cham (CHHHM)"
  },
  {
   value: "Chambesy (CHCMY)",
   label: "Chambesy (CHCMY)"
  },
  {
   value: "Champagne (CHCPA)",
   label: "Champagne (CHCPA)"
  },
  {
   value: "Champéry (CHCHP)",
   label: "Champéry (CHCHP)"
  },
  {
   value: "Châtelaine (CHCAL)",
   label: "Châtelaine (CHCAL)"
  },
  {
   value: "Chavannes-de-Bogis (CHCDB)",
   label: "Chavannes-de-Bogis (CHCDB)"
  },
  {
   value: "Chavannes-près-Renens (CHVPR)",
   label: "Chavannes-près-Renens (CHVPR)"
  },
  {
   value: "Chavornay (CHCVY)",
   label: "Chavornay (CHCVY)"
  },
  {
   value: "Chene-Bougeries (CHCBS)",
   label: "Chene-Bougeries (CHCBS)"
  },
  {
   value: "Chernex (CHCNX)",
   label: "Chernex (CHCNX)"
  },
  {
   value: "Chevenez (CHCHE)",
   label: "Chevenez (CHCHE)"
  },
  {
   value: "Chezard-St-Martin (CHCSM)",
   label: "Chezard-St-Martin (CHCSM)"
  },
  {
   value: "Chippis (CHCPS)",
   label: "Chippis (CHCPS)"
  },
  {
   value: "Choëx (CHCHX)",
   label: "Choëx (CHCHX)"
  },
  {
   value: "Collex (CHOLL)",
   label: "Collex (CHOLL)"
  },
  {
   value: "Biberstein (CHBBN)",
   label: "Biberstein (CHBBN)"
  },
  {
   value: "Biglen (CHBBI)",
   label: "Biglen (CHBBI)"
  },
  {
   value: "Billens (CHBIL)",
   label: "Billens (CHBIL)"
  },
  {
   value: "Bilten (CHBLT)",
   label: "Bilten (CHBLT)"
  },
  {
   value: "Binz (CHBIZ)",
   label: "Binz (CHBIZ)"
  },
  {
   value: "Bioggio (CHBIO)",
   label: "Bioggio (CHBIO)"
  },
  {
   value: "Birmensdorf (CHBDF)",
   label: "Birmensdorf (CHBDF)"
  },
  {
   value: "Birmenstorf (CHBMO)",
   label: "Birmenstorf (CHBMO)"
  },
  {
   value: "Bironico (CHBTI)",
   label: "Bironico (CHBTI)"
  },
  {
   value: "Birr (CHBRR)",
   label: "Birr (CHBRR)"
  },
  {
   value: "Birrwil (CHBIR)",
   label: "Birrwil (CHBIR)"
  },
  {
   value: "Birsfelden (CHBFL)",
   label: "Birsfelden (CHBFL)"
  },
  {
   value: "Bischofszell (CHBCZ)",
   label: "Bischofszell (CHBCZ)"
  },
  {
   value: "Bissegg (CHBEG)",
   label: "Bissegg (CHBEG)"
  },
  {
   value: "Bodio (CHBOD)",
   label: "Bodio (CHBOD)"
  },
  {
   value: "Boll (CHBOL)",
   label: "Boll (CHBOL)"
  },
  {
   value: "Boncourt (CHBCU)",
   label: "Boncourt (CHBCU)"
  },
  {
   value: "Bosingen (CHBSI)",
   label: "Bosingen (CHBSI)"
  },
  {
   value: "Boswil (CHBOS)",
   label: "Boswil (CHBOS)"
  },
  {
   value: "Bottighofen (CHCGO)",
   label: "Bottighofen (CHCGO)"
  },
  {
   value: "Bottmingen (CHBTN)",
   label: "Bottmingen (CHBTN)"
  },
  {
   value: "Boudry (CHBDY)",
   label: "Boudry (CHBDY)"
  },
  {
   value: "Boussens (CHBSS)",
   label: "Boussens (CHBSS)"
  },
  {
   value: "Boveresse (CHBOV)",
   label: "Boveresse (CHBOV)"
  },
  {
   value: "Bre-Aldesago (CHBAO)",
   label: "Bre-Aldesago (CHBAO)"
  },
  {
   value: "Breganzona (CHBGZ)",
   label: "Breganzona (CHBGZ)"
  },
  {
   value: "Brenzikofen (CHBZK)",
   label: "Brenzikofen (CHBZK)"
  },
  {
   value: "Brienz (CHBEZ)",
   label: "Brienz (CHBEZ)"
  },
  {
   value: "Brig (CHBRI)",
   label: "Brig (CHBRI)"
  },
  {
   value: "Brislach (CHLBR)",
   label: "Brislach (CHLBR)"
  },
  {
   value: "Brittnau (CHBTA)",
   label: "Brittnau (CHBTA)"
  },
  {
   value: "Bronschhofen (CHBRO)",
   label: "Bronschhofen (CHBRO)"
  },
  {
   value: "Brugg (CHBGG)",
   label: "Brugg (CHBGG)"
  },
  {
   value: "Brugg (CHBUG)",
   label: "Brugg (CHBUG)"
  },
  {
   value: "Au (CHAUT)",
   label: "Au (CHAUT)"
  },
  {
   value: "Au (CHAUU)",
   label: "Au (CHAUU)"
  },
  {
   value: "Au (CHAUZ)",
   label: "Au (CHAUZ)"
  },
  {
   value: "Aubonne (CHABO)",
   label: "Aubonne (CHABO)"
  },
  {
   value: "Augst (CHAGT)",
   label: "Augst (CHAGT)"
  },
  {
   value: "Avenches (CHAVE)",
   label: "Avenches (CHAVE)"
  },
  {
   value: "Avry (CHAVR)",
   label: "Avry (CHAVR)"
  },
  {
   value: "Bachenbülach (CHBAB)",
   label: "Bachenbülach (CHBAB)"
  },
  {
   value: "Bad Ragaz (CHBRZ)",
   label: "Bad Ragaz (CHBRZ)"
  },
  {
   value: "Baden (CHBAD)",
   label: "Baden (CHBAD)"
  },
  {
   value: "Balerna (CHBLA)",
   label: "Balerna (CHBLA)"
  },
  {
   value: "Balsthal (CHBST)",
   label: "Balsthal (CHBST)"
  },
  {
   value: "Balterswil (CHBWI)",
   label: "Balterswil (CHBWI)"
  },
  {
   value: "Bannwil (CHBWL)",
   label: "Bannwil (CHBWL)"
  },
  {
   value: "Bäretswil (CHBRL)",
   label: "Bäretswil (CHBRL)"
  },
  {
   value: "Bargen (CHBGN)",
   label: "Bargen (CHBGN)"
  },
  {
   value: "Basel Schweizerhalle (CHBBS)",
   label: "Basel Schweizerhalle (CHBBS)"
  },
  {
   value: "Bassecourt (CHBAS)",
   label: "Bassecourt (CHBAS)"
  },
  {
   value: "Bassersdorf (CHBSF)",
   label: "Bassersdorf (CHBSF)"
  },
  {
   value: "Bätterkinden (CHBKD)",
   label: "Bätterkinden (CHBKD)"
  },
  {
   value: "Bauma (CHQBA)",
   label: "Bauma (CHQBA)"
  },
  {
   value: "Bazenheid (CHBZH)",
   label: "Bazenheid (CHBZH)"
  },
  {
   value: "Bellach (CHBEL)",
   label: "Bellach (CHBEL)"
  },
  {
   value: "Bellinzona (CHBZA)",
   label: "Bellinzona (CHBZA)"
  },
  {
   value: "Belp (CHBLP)",
   label: "Belp (CHBLP)"
  },
  {
   value: "Benken (CHBKN)",
   label: "Benken (CHBKN)"
  },
  {
   value: "Bergdietikon (CHBGI)",
   label: "Bergdietikon (CHBGI)"
  },
  {
   value: "Beringen (CHBER)",
   label: "Beringen (CHBER)"
  },
  {
   value: "Bernex (CHBNX)",
   label: "Bernex (CHBNX)"
  },
  {
   value: "Bertschikon (CHBHK)",
   label: "Bertschikon (CHBHK)"
  },
  {
   value: "Bettwiesen (CHTBN)",
   label: "Bettwiesen (CHTBN)"
  },
  {
   value: "Bevaix (CHBVX)",
   label: "Bevaix (CHBVX)"
  },
  {
   value: "Bex (CHBEX)",
   label: "Bex (CHBEX)"
  },
  {
   value: "Biberist (CHBIB)",
   label: "Biberist (CHBIB)"
  },
  {
   value: "Owando Apt (CGFTX)",
   label: "Owando Apt (CGFTX)"
  },
  {
   value: "Aarberg (CHABG)",
   label: "Aarberg (CHABG)"
  },
  {
   value: "Aarburg (CHAAB)",
   label: "Aarburg (CHAAB)"
  },
  {
   value: "Aclens (CHACL)",
   label: "Aclens (CHACL)"
  },
  {
   value: "Adelboden (CHADL)",
   label: "Adelboden (CHADL)"
  },
  {
   value: "Adliswil (CHADW)",
   label: "Adliswil (CHADW)"
  },
  {
   value: "Aesch (CHAES)",
   label: "Aesch (CHAES)"
  },
  {
   value: "Affeltrangen (CHAFF)",
   label: "Affeltrangen (CHAFF)"
  },
  {
   value: "Affoltern am Albis (CHAFT)",
   label: "Affoltern am Albis (CHAFT)"
  },
  {
   value: "Agno (CHAGO)",
   label: "Agno (CHAGO)"
  },
  {
   value: "Aigle (CHAIG)",
   label: "Aigle (CHAIG)"
  },
  {
   value: "Airolo (CHAIR)",
   label: "Airolo (CHAIR)"
  },
  {
   value: "Alchenflueh (CHAFH)",
   label: "Alchenflueh (CHAFH)"
  },
  {
   value: "Allschwil (CHASW)",
   label: "Allschwil (CHASW)"
  },
  {
   value: "Altendorf (CHALT)",
   label: "Altendorf (CHALT)"
  },
  {
   value: "Altenrhein (CHATR)",
   label: "Altenrhein (CHATR)"
  },
  {
   value: "Altishofen (CHAHF)",
   label: "Altishofen (CHAHF)"
  },
  {
   value: "Amriswil (CHAWL)",
   label: "Amriswil (CHAWL)"
  },
  {
   value: "Appenzell (CHAPP)",
   label: "Appenzell (CHAPP)"
  },
  {
   value: "Apples (CHAPL)",
   label: "Apples (CHAPL)"
  },
  {
   value: "Arbedo (CHABD)",
   label: "Arbedo (CHABD)"
  },
  {
   value: "Arbon (CHZDD)",
   label: "Arbon (CHZDD)"
  },
  {
   value: "Arch (CHARC)",
   label: "Arch (CHARC)"
  },
  {
   value: "Ardon (CHADO)",
   label: "Ardon (CHADO)"
  },
  {
   value: "Arlesheim (CHASH)",
   label: "Arlesheim (CHASH)"
  },
  {
   value: "Arolla (CHARL)",
   label: "Arolla (CHARL)"
  },
  {
   value: "Arosa (CHARS)",
   label: "Arosa (CHARS)"
  },
  {
   value: "Arth (CHARH)",
   label: "Arth (CHARH)"
  },
  {
   value: "Ascona (CHASC)",
   label: "Ascona (CHASC)"
  },
  {
   value: "Au (CHAUS)",
   label: "Au (CHAUS)"
  },
  {
   value: "Togo (CFTOG)",
   label: "Togo (CFTOG)"
  },
  {
   value: ".CONGO (CG)",
   label: ".CONGO (CG)"
  },
  {
   value: "Sakania (CDSKA)",
   label: "Sakania (CDSKA)"
  },
  {
   value: "Tenke (CDTNK)",
   label: "Tenke (CDTNK)"
  },
  {
   value: ".CENTRAL AFRICAN REPUBLIC (CF)",
   label: ".CENTRAL AFRICAN REPUBLIC (CF)"
  },
  {
   value: "Bocaranga (CFBOC)",
   label: "Bocaranga (CFBOC)"
  },
  {
   value: "Bogoto (CFBOG)",
   label: "Bogoto (CFBOG)"
  },
  {
   value: "Kasumbalesa (CDKAS)",
   label: "Kasumbalesa (CDKAS)"
  },
  {
   value: "Kipushi (CDKPU)",
   label: "Kipushi (CDKPU)"
  },
  {
   value: "Likasi (CDLKS)",
   label: "Likasi (CDLKS)"
  },
  {
   value: "Woodham (CAWDA)",
   label: "Woodham (CAWDA)"
  },
  {
   value: "Woodlands (CAWDL)",
   label: "Woodlands (CAWDL)"
  },
  {
   value: "Wrentham (CAWTM)",
   label: "Wrentham (CAWTM)"
  },
  {
   value: "Wyoming (CAWYO)",
   label: "Wyoming (CAWYO)"
  },
  {
   value: "Yamachiche (CAZYE)",
   label: "Yamachiche (CAZYE)"
  },
  {
   value: "Yarrow (CAYRW)",
   label: "Yarrow (CAYRW)"
  },
  {
   value: "York (CAYOK)",
   label: "York (CAYOK)"
  },
  {
   value: "York (CAYRK)",
   label: "York (CAYRK)"
  },
  {
   value: "Zenon Park (CAZPK)",
   label: "Zenon Park (CAZPK)"
  },
  {
   value: "Zurich (CAZUR)",
   label: "Zurich (CAZUR)"
  },
  {
   value: ".COCOS (KEELING) ISLANDS (CC)",
   label: ".COCOS (KEELING) ISLANDS (CC)"
  },
  {
   value: ".CONGO, THE DEMOCRATIC REPUBLIC OF THE (CD)",
   label: ".CONGO, THE DEMOCRATIC REPUBLIC OF THE (CD)"
  },
  {
   value: "Butembo (CDBUT)",
   label: "Butembo (CDBUT)"
  },
  {
   value: "Whites Lake (CAWLK)",
   label: "Whites Lake (CAWLK)"
  },
  {
   value: "Whitewood (CAWTW)",
   label: "Whitewood (CAWTW)"
  },
  {
   value: "Wickham West (CAWIC)",
   label: "Wickham West (CAWIC)"
  },
  {
   value: "Wicomico (CAWCM)",
   label: "Wicomico (CAWCM)"
  },
  {
   value: "Wilcox (CAWIX)",
   label: "Wilcox (CAWIX)"
  },
  {
   value: "Wildwood (CAWWO)",
   label: "Wildwood (CAWWO)"
  },
  {
   value: "Williamsford (CAWLF)",
   label: "Williamsford (CAWLF)"
  },
  {
   value: "Williamstown (CAWST)",
   label: "Williamstown (CAWST)"
  },
  {
   value: "Wimborne (CAWBO)",
   label: "Wimborne (CAWBO)"
  },
  {
   value: "Winchester (CAWIH)",
   label: "Winchester (CAWIH)"
  },
  {
   value: "Windham Centre (CAWHC)",
   label: "Windham Centre (CAWHC)"
  },
  {
   value: "Windsor (CAWDR)",
   label: "Windsor (CAWDR)"
  },
  {
   value: "Windsor (CAWSR)",
   label: "Windsor (CAWSR)"
  },
  {
   value: "Winfield (CAWFD)",
   label: "Winfield (CAWFD)"
  },
  {
   value: "Winfield (CAWNF)",
   label: "Winfield (CAWNF)"
  },
  {
   value: "Wingham (CAWIG)",
   label: "Wingham (CAWIG)"
  },
  {
   value: "Winkler (CAWNK)",
   label: "Winkler (CAWNK)"
  },
  {
   value: "Winnipeg Apt (CAYWG)",
   label: "Winnipeg Apt (CAYWG)"
  },
  {
   value: "Winterburn (CAWBN)",
   label: "Winterburn (CAWBN)"
  },
  {
   value: "Wolfe I. (CAWFI)",
   label: "Wolfe I. (CAWFI)"
  },
  {
   value: "Wolfville (CAWOV)",
   label: "Wolfville (CAWOV)"
  },
  {
   value: "Wolseley (CAWSY)",
   label: "Wolseley (CAWSY)"
  },
  {
   value: "Wood Island (CAWOI)",
   label: "Wood Island (CAWOI)"
  },
  {
   value: "Wawanesa (CAWAW)",
   label: "Wawanesa (CAWAW)"
  },
  {
   value: "Wedgeport (CAWED)",
   label: "Wedgeport (CAWED)"
  },
  {
   value: "Weedon (CAWDO)",
   label: "Weedon (CAWDO)"
  },
  {
   value: "Wellesley (CAWLY)",
   label: "Wellesley (CAWLY)"
  },
  {
   value: "Wellington (CAEIW)",
   label: "Wellington (CAEIW)"
  },
  {
   value: "Wellington (CAWEN)",
   label: "Wellington (CAWEN)"
  },
  {
   value: "Wesleyville (CAWYV)",
   label: "Wesleyville (CAWYV)"
  },
  {
   value: "West Hill (CAWHL)",
   label: "West Hill (CAWHL)"
  },
  {
   value: "West Pubnico (CAWPU)",
   label: "West Pubnico (CAWPU)"
  },
  {
   value: "West Saint Paul (CAESP)",
   label: "West Saint Paul (CAESP)"
  },
  {
   value: "West Vancouver (CAWVR)",
   label: "West Vancouver (CAWVR)"
  },
  {
   value: "Westbank (CAWBK)",
   label: "Westbank (CAWBK)"
  },
  {
   value: "Westerose (CAWSO)",
   label: "Westerose (CAWSO)"
  },
  {
   value: "Westlock (CAWEK)",
   label: "Westlock (CAWEK)"
  },
  {
   value: "Westmount (CAWNT)",
   label: "Westmount (CAWNT)"
  },
  {
   value: "Weston (CAWES)",
   label: "Weston (CAWES)"
  },
  {
   value: "Westport (CAWTO)",
   label: "Westport (CAWTO)"
  },
  {
   value: "Westville (CAWEV)",
   label: "Westville (CAWEV)"
  },
  {
   value: "Westwold (CAWSW)",
   label: "Westwold (CAWSW)"
  },
  {
   value: "Weyburn (CAWWB)",
   label: "Weyburn (CAWWB)"
  },
  {
   value: "Whiffen Head (CAWHH)",
   label: "Whiffen Head (CAWHH)"
  },
  {
   value: "White City (CAWCY)",
   label: "White City (CAWCY)"
  },
  {
   value: "White Rock (CAWHR)",
   label: "White Rock (CAWHR)"
  },
  {
   value: "Vimont (CAVMT)",
   label: "Vimont (CAVMT)"
  },
  {
   value: "Vineland Station (CAVIN)",
   label: "Vineland Station (CAVIN)"
  },
  {
   value: "Virden (CAVRD)",
   label: "Virden (CAVRD)"
  },
  {
   value: "Vita (CAVTA)",
   label: "Vita (CAVTA)"
  },
  {
   value: "Vonda (CAVON)",
   label: "Vonda (CAVON)"
  },
  {
   value: "Vulcan (CAVCA)",
   label: "Vulcan (CAVCA)"
  },
  {
   value: "Wainwright (CAWWI)",
   label: "Wainwright (CAWWI)"
  },
  {
   value: "Wakefield (CAWAK)",
   label: "Wakefield (CAWAK)"
  },
  {
   value: "Waldheim (CAWLH)",
   label: "Waldheim (CAWLH)"
  },
  {
   value: "Walkerton (CAWOT)",
   label: "Walkerton (CAWOT)"
  },
  {
   value: "Wallenstein (CAWLS)",
   label: "Wallenstein (CAWLS)"
  },
  {
   value: "Walsingham (CAWSG)",
   label: "Walsingham (CAWSG)"
  },
  {
   value: "Walton (CAWLN)",
   label: "Walton (CAWLN)"
  },
  {
   value: "Walton (CAWLT)",
   label: "Walton (CAWLT)"
  },
  {
   value: "Warburg&nbsp; (CAWBG)",
   label: "Warburg&nbsp; (CAWBG)"
  },
  {
   value: "Wardsville (CAWDI)",
   label: "Wardsville (CAWDI)"
  },
  {
   value: "Warman (CAWMA)",
   label: "Warman (CAWMA)"
  },
  {
   value: "Warner (CAWNR)",
   label: "Warner (CAWNR)"
  },
  {
   value: "Warren (CAWRN)",
   label: "Warren (CAWRN)"
  },
  {
   value: "Warwick (CAWWK)",
   label: "Warwick (CAWWK)"
  },
  {
   value: "Waskatenau (CAWAS)",
   label: "Waskatenau (CAWAS)"
  },
  {
   value: "Waterford (CAWFF)",
   label: "Waterford (CAWFF)"
  },
  {
   value: "Waterloo (CAWAO)",
   label: "Waterloo (CAWAO)"
  },
  {
   value: "Waterville (CAWVE)",
   label: "Waterville (CAWVE)"
  },
  {
   value: "Waterville (CAWVL)",
   label: "Waterville (CAWVL)"
  },
  {
   value: "Waverley (CAWVY)",
   label: "Waverley (CAWVY)"
  },
  {
   value: "Utterson (CAUTS)",
   label: "Utterson (CAUTS)"
  },
  {
   value: "Uxbridge (CAUXB)",
   label: "Uxbridge (CAUXB)"
  },
  {
   value: "Valcourt (CAVCT)",
   label: "Valcourt (CAVCT)"
  },
  {
   value: "Vallée-Jonction (CAVAL)",
   label: "Vallée-Jonction (CAVAL)"
  },
  {
   value: "Valleyfield (CAVYD)",
   label: "Valleyfield (CAVYD)"
  },
  {
   value: "Valleyview (CAVYV)",
   label: "Valleyview (CAVYV)"
  },
  {
   value: "Vancouver Apt (CAYVR)",
   label: "Vancouver Apt (CAYVR)"
  },
  {
   value: "Vanderhoof (CAVHO)",
   label: "Vanderhoof (CAVHO)"
  },
  {
   value: "Vanier (CAVAE)",
   label: "Vanier (CAVAE)"
  },
  {
   value: "Vanier (CAVNR)",
   label: "Vanier (CAVNR)"
  },
  {
   value: "Vankleek Hill (CAVKH)",
   label: "Vankleek Hill (CAVKH)"
  },
  {
   value: "Vanscoy (CAVSC)",
   label: "Vanscoy (CAVSC)"
  },
  {
   value: "Varennes (CAVAR)",
   label: "Varennes (CAVAR)"
  },
  {
   value: "Vars (CAVRS)",
   label: "Vars (CAVRS)"
  },
  {
   value: "Vassar (CAVSR)",
   label: "Vassar (CAVSR)"
  },
  {
   value: "Vaudreuil-Dorion (CADON)",
   label: "Vaudreuil-Dorion (CADON)"
  },
  {
   value: "Vaughan (CAVGN)",
   label: "Vaughan (CAVGN)"
  },
  {
   value: "Vauxhall (CAVXL)",
   label: "Vauxhall (CAVXL)"
  },
  {
   value: "Vegreville (CAVEG)",
   label: "Vegreville (CAVEG)"
  },
  {
   value: "Verdun (CADUN)",
   label: "Verdun (CADUN)"
  },
  {
   value: "Vernon Bridge (CAVEB)",
   label: "Vernon Bridge (CAVEB)"
  },
  {
   value: "Veteran (CAVRA)",
   label: "Veteran (CAVRA)"
  },
  {
   value: "Vibank (CAVBA)",
   label: "Vibank (CAVBA)"
  },
  {
   value: "Victoriaville (CAVVL)",
   label: "Victoriaville (CAVVL)"
  },
  {
   value: "Vienna (CAVIE)",
   label: "Vienna (CAVIE)"
  },
  {
   value: "Ville Saint Laurent (CAVST)",
   label: "Ville Saint Laurent (CAVST)"
  },
  {
   value: "Ville-Marie (CAVIJ)",
   label: "Ville-Marie (CAVIJ)"
  },
  {
   value: "Villeroy (CAVLR)",
   label: "Villeroy (CAVLR)"
  },
  {
   value: "Torbay (CATAY)",
   label: "Torbay (CATAY)"
  },
  {
   value: "Tracadie-Sheila (CATDS)",
   label: "Tracadie-Sheila (CATDS)"
  },
  {
   value: "Trail (CATRL)",
   label: "Trail (CATRL)"
  },
  {
   value: "Trenton (CATRN)",
   label: "Trenton (CATRN)"
  },
  {
   value: "Trepassey (CATPS)",
   label: "Trepassey (CATPS)"
  },
  {
   value: "Tring Jonction (CATJN)",
   label: "Tring Jonction (CATJN)"
  },
  {
   value: "Triton (CATRI)",
   label: "Triton (CATRI)"
  },
  {
   value: "Trochu (CATRO)",
   label: "Trochu (CATRO)"
  },
  {
   value: "Trois-Pistoles (CATRP)",
   label: "Trois-Pistoles (CATRP)"
  },
  {
   value: "Tucks (CATUC)",
   label: "Tucks (CATUC)"
  },
  {
   value: "Tupperville (CATPY)",
   label: "Tupperville (CATPY)"
  },
  {
   value: "Tusket (CATUS)",
   label: "Tusket (CATUS)"
  },
  {
   value: "Tweed (CATWE)",
   label: "Tweed (CATWE)"
  },
  {
   value: "Two Hills (CATHI)",
   label: "Two Hills (CATHI)"
  },
  {
   value: "Upper Musquodoboit (CAUPO)",
   label: "Upper Musquodoboit (CAUPO)"
  },
  {
   value: "Upton (CAUPT)",
   label: "Upton (CAUPT)"
  },
  {
   value: "Utopia (CAUTP)",
   label: "Utopia (CAUTP)"
  },
  {
   value: "Terrebonne (CATBN)",
   label: "Terrebonne (CATBN)"
  },
  {
   value: "Teulon (CATEU)",
   label: "Teulon (CATEU)"
  },
  {
   value: "Thamesford (CATHA)",
   label: "Thamesford (CATHA)"
  },
  {
   value: "Thamesville (CAOTE)",
   label: "Thamesville (CAOTE)"
  },
  {
   value: "Thedford (CATHF)",
   label: "Thedford (CATHF)"
  },
  {
   value: "Thetis Island (CATTL)",
   label: "Thetis Island (CATTL)"
  },
  {
   value: "Thorburn (CATBU)",
   label: "Thorburn (CATBU)"
  },
  {
   value: "Thorhild (CATRH)",
   label: "Thorhild (CATRH)"
  },
  {
   value: "Thorndale (CATND)",
   label: "Thorndale (CATND)"
  },
  {
   value: "Thorsby (CATHY)",
   label: "Thorsby (CATHY)"
  },
  {
   value: "Three Hills (CATHH)",
   label: "Three Hills (CATHH)"
  },
  {
   value: "Three Rivers = Trois-Rivières (CA)",
   label: "Three Rivers = Trois-Rivières (CA)"
  },
  {
   value: "Tigerlily (CATGY)",
   label: "Tigerlily (CATGY)"
  },
  {
   value: "Tignish (CATIG)",
   label: "Tignish (CATIG)"
  },
  {
   value: "Tilbury (CATIY)",
   label: "Tilbury (CATIY)"
  },
  {
   value: "Tilley (CATLY)",
   label: "Tilley (CATLY)"
  },
  {
   value: "Tilt Cove (CATCV)",
   label: "Tilt Cove (CATCV)"
  },
  {
   value: "Tingwick (CATNG)",
   label: "Tingwick (CATNG)"
  },
  {
   value: "Tiverton (CATIV)",
   label: "Tiverton (CATIV)"
  },
  {
   value: "Tiverton (CATVT)",
   label: "Tiverton (CATVT)"
  },
  {
   value: "Tofield (CATFI)",
   label: "Tofield (CATFI)"
  },
  {
   value: "Tolstoi (CATTI)",
   label: "Tolstoi (CATTI)"
  },
  {
   value: "Sutton (CASUT)",
   label: "Sutton (CASUT)"
  },
  {
   value: "Sutton (CAUTT)",
   label: "Sutton (CAUTT)"
  },
  {
   value: "Swan Hills (CASWH)",
   label: "Swan Hills (CASWH)"
  },
  {
   value: "Sydney Mines (CASMI)",
   label: "Sydney Mines (CASMI)"
  },
  {
   value: "Sydney River (CASRV)",
   label: "Sydney River (CASRV)"
  },
  {
   value: "Sylvan Lake (CASYL)",
   label: "Sylvan Lake (CASYL)"
  },
  {
   value: "Taber (CATBR)",
   label: "Taber (CATBR)"
  },
  {
   value: "Talbotville (CATAL)",
   label: "Talbotville (CATAL)"
  },
  {
   value: "Talbotville Royal (CATBA)",
   label: "Talbotville Royal (CATBA)"
  },
  {
   value: "Tantallon (CATTA)",
   label: "Tantallon (CATTA)"
  },
  {
   value: "Tar Island (CATIS)",
   label: "Tar Island (CATIS)"
  },
  {
   value: "Tara (CATAR)",
   label: "Tara (CATAR)"
  },
  {
   value: "Taschereau (CATCH)",
   label: "Taschereau (CATCH)"
  },
  {
   value: "Tatamagouche (CATGU)",
   label: "Tatamagouche (CATGU)"
  },
  {
   value: "Taylor (CATLO)",
   label: "Taylor (CATLO)"
  },
  {
   value: "Telkwa (CATWA)",
   label: "Telkwa (CATWA)"
  },
  {
   value: "Temagami (CATGI)",
   label: "Temagami (CATGI)"
  },
  {
   value: "Temiscaming (CATCG)",
   label: "Temiscaming (CATCG)"
  },
  {
   value: "Stouffville (CASFV)",
   label: "Stouffville (CASFV)"
  },
  {
   value: "St-Pamphile (CASPM)",
   label: "St-Pamphile (CASPM)"
  },
  {
   value: "St-Patrice-de-Beaurivage (CAPBG)",
   label: "St-Patrice-de-Beaurivage (CAPBG)"
  },
  {
   value: "St-Pie (CASTI)",
   label: "St-Pie (CASTI)"
  },
  {
   value: "St-Pierre-les-Becquets (CAPBS)",
   label: "St-Pierre-les-Becquets (CAPBS)"
  },
  {
   value: "St-Prosper (CARRR)",
   label: "St-Prosper (CARRR)"
  },
  {
   value: "Straffordville (CASFL)",
   label: "Straffordville (CASFL)"
  },
  {
   value: "Stratford (CASTF)",
   label: "Stratford (CASTF)"
  },
  {
   value: "Strathclair (CASCR)",
   label: "Strathclair (CASCR)"
  },
  {
   value: "Strathmore (CASOE)",
   label: "Strathmore (CASOE)"
  },
  {
   value: "St-Raymond (CASRD)",
   label: "St-Raymond (CASRD)"
  },
  {
   value: "Streetsville (CASVI)",
   label: "Streetsville (CASVI)"
  },
  {
   value: "St-Roch (CASRH)",
   label: "St-Roch (CASRH)"
  },
  {
   value: "Strongfield (CASFS)",
   label: "Strongfield (CASFS)"
  },
  {
   value: "St-Samuel (CASSU)",
   label: "St-Samuel (CASSU)"
  },
  {
   value: "Sts-Anges (CASIA)",
   label: "Sts-Anges (CASIA)"
  },
  {
   value: "St-Sébastien (CASFC)",
   label: "St-Sébastien (CASFC)"
  },
  {
   value: "St-Simon (CASMN)",
   label: "St-Simon (CASMN)"
  },
  {
   value: "St-Thomas (CASIT)",
   label: "St-Thomas (CASIT)"
  },
  {
   value: "St-Ubalde (CASTU)",
   label: "St-Ubalde (CASTU)"
  },
  {
   value: "St-Vincent-de-Paul (CASVP)",
   label: "St-Vincent-de-Paul (CASVP)"
  },
  {
   value: "Success (CASUC)",
   label: "Success (CASUC)"
  },
  {
   value: "Summerland (CASUZ)",
   label: "Summerland (CASUZ)"
  },
  {
   value: "Sun Peaks (CASPK)",
   label: "Sun Peaks (CASPK)"
  },
  {
   value: "Sunderland (CASDL)",
   label: "Sunderland (CASDL)"
  },
  {
   value: "Sundre (CASDR)",
   label: "Sundre (CASDR)"
  },
  {
   value: "Ste-Sabine (CASIS)",
   label: "Ste-Sabine (CASIS)"
  },
  {
   value: "Stettler (CASER)",
   label: "Stettler (CASER)"
  },
  {
   value: "St-Évariste-de-Forsyth (CASEF)",
   label: "St-Évariste-de-Forsyth (CASEF)"
  },
  {
   value: "Stevensville (CASVS)",
   label: "Stevensville (CASVS)"
  },
  {
   value: "Ste-Victoire-de-Sorel (CASVD)",
   label: "Ste-Victoire-de-Sorel (CASVD)"
  },
  {
   value: "Stewiacke (CASWE)",
   label: "Stewiacke (CASWE)"
  },
  {
   value: "St-Faustin (CAFLC)",
   label: "St-Faustin (CAFLC)"
  },
  {
   value: "St-Félix-de-Valois (CASFX)",
   label: "St-Félix-de-Valois (CASFX)"
  },
  {
   value: "St-François-du-Lac (CASFR)",
   label: "St-François-du-Lac (CASFR)"
  },
  {
   value: "St-François-du-Lac (CASUL)",
   label: "St-François-du-Lac (CASUL)"
  },
  {
   value: "St-Francois-Xavier-de-Brompton (CAFXB)",
   label: "St-Francois-Xavier-de-Brompton (CAFXB)"
  },
  {
   value: "St-Germain-de-Grantham (CASGD)",
   label: "St-Germain-de-Grantham (CASGD)"
  },
  {
   value: "Stirling (CASLG)",
   label: "Stirling (CASLG)"
  },
  {
   value: "Stittsville (CASLL)",
   label: "Stittsville (CASLL)"
  },
  {
   value: "St-Jacques (CASCQ)",
   label: "St-Jacques (CASCQ)"
  },
  {
   value: "St-Jean-Baptiste (CABAZ)",
   label: "St-Jean-Baptiste (CABAZ)"
  },
  {
   value: "St-Joachim-de-Shefford (CASMO)",
   label: "St-Joachim-de-Shefford (CASMO)"
  },
  {
   value: "St-Justin (CASJT)",
   label: "St-Justin (CASJT)"
  },
  {
   value: "St-Lambert-de-Lauzon (CALTL)",
   label: "St-Lambert-de-Lauzon (CALTL)"
  },
  {
   value: "St-Laurent (CALRN)",
   label: "St-Laurent (CALRN)"
  },
  {
   value: "St-Lucien (CASLC)",
   label: "St-Lucien (CASLC)"
  },
  {
   value: "St-Mathieu-du-Parc (CAMHP)",
   label: "St-Mathieu-du-Parc (CAMHP)"
  },
  {
   value: "St-Norbert (CASNB)",
   label: "St-Norbert (CASNB)"
  },
  {
   value: "Stonewall (CAWLL)",
   label: "Stonewall (CAWLL)"
  },
  {
   value: "Stoney Island (CASYI)",
   label: "Stoney Island (CASYI)"
  },
  {
   value: "Stoney Point, Essex (CASYT)",
   label: "Stoney Point, Essex (CASYT)"
  },
  {
   value: "Stony Mountain (CASYM)",
   label: "Stony Mountain (CASYM)"
  },
  {
   value: "Stony Plain (CASYP)",
   label: "Stony Plain (CASYP)"
  },
  {
   value: "Stormont (CASMT)",
   label: "Stormont (CASMT)"
  },
  {
   value: "St-Denis-de-Brompton (CADDB)",
   label: "St-Denis-de-Brompton (CADDB)"
  },
  {
   value: "St-Dominique (CASDQ)",
   label: "St-Dominique (CASDQ)"
  },
  {
   value: "Ste Agathe (CASAH)",
   label: "Ste Agathe (CASAH)"
  },
  {
   value: "Ste Anne des Chênes (CASAS)",
   label: "Ste Anne des Chênes (CASAS)"
  },
  {
   value: "Ste Anne-de-Bellevue (CASAB)",
   label: "Ste Anne-de-Bellevue (CASAB)"
  },
  {
   value: "Ste Anne-de-la-Perade (CAADL)",
   label: "Ste Anne-de-la-Perade (CAADL)"
  },
  {
   value: "Ste Anne-des-Monts (CASDM)",
   label: "Ste Anne-des-Monts (CASDM)"
  },
  {
   value: "Ste Anne-des-Plaines (CAADP)",
   label: "Ste Anne-des-Plaines (CAADP)"
  },
  {
   value: "Ste Croix (CASCX)",
   label: "Ste Croix (CASCX)"
  },
  {
   value: "Ste Justine-de-Newton (CASJN)",
   label: "Ste Justine-de-Newton (CASJN)"
  },
  {
   value: "Ste Marthe-sur-le-Lac (CASML)",
   label: "Ste Marthe-sur-le-Lac (CASML)"
  },
  {
   value: "Ste Martine (CASTM)",
   label: "Ste Martine (CASTM)"
  },
  {
   value: "Ste Rosalie (CASRE)",
   label: "Ste Rosalie (CASRE)"
  },
  {
   value: "Ste Thérèse (CASTQ)",
   label: "Ste Thérèse (CASTQ)"
  },
  {
   value: "Ste-Adèle (CASDE)",
   label: "Ste-Adèle (CASDE)"
  },
  {
   value: "Ste-Anne-de-la-Rochelle (CAADR)",
   label: "Ste-Anne-de-la-Rochelle (CAADR)"
  },
  {
   value: "Ste-Anne-de-la-Rochelle (CAARH)",
   label: "Ste-Anne-de-la-Rochelle (CAARH)"
  },
  {
   value: "Ste-Beatrix (CASBX)",
   label: "Ste-Beatrix (CASBX)"
  },
  {
   value: "Ste-Catherine (CASCT)",
   label: "Ste-Catherine (CASCT)"
  },
  {
   value: "Ste-Elisabeth (CASET)",
   label: "Ste-Elisabeth (CASET)"
  },
  {
   value: "Ste-Famille (CASFI)",
   label: "Ste-Famille (CASFI)"
  },
  {
   value: "Steinbach (CASTB)",
   label: "Steinbach (CASTB)"
  },
  {
   value: "Stellarton (CASTN)",
   label: "Stellarton (CASTN)"
  },
  {
   value: "Ste-Marguerite (CAMGT)",
   label: "Ste-Marguerite (CAMGT)"
  },
  {
   value: "St Michel-des-Saints (CASMQ)",
   label: "St Michel-des-Saints (CASMQ)"
  },
  {
   value: "St Paul (CASPL)",
   label: "St Paul (CASPL)"
  },
  {
   value: "St Pauls Station (CAPLO)",
   label: "St Pauls Station (CAPLO)"
  },
  {
   value: "St Perpetue (CASPP)",
   label: "St Perpetue (CASPP)"
  },
  {
   value: "St Peters (CASRS)",
   label: "St Peters (CASRS)"
  },
  {
   value: "St Rémi (CASRM)",
   label: "St Rémi (CASRM)"
  },
  {
   value: "St Sauveur-des-Monts (CASSA)",
   label: "St Sauveur-des-Monts (CASSA)"
  },
  {
   value: "St Sebastien (CASBI)",
   label: "St Sebastien (CASBI)"
  },
  {
   value: "St Sébastien\/Le Haut-Richelieu (CASSL)",
   label: "St Sébastien\/Le Haut-Richelieu (CASSL)"
  },
  {
   value: "St Shotts (CASST)",
   label: "St Shotts (CASST)"
  },
  {
   value: "St Simeon (CASSE)",
   label: "St Simeon (CASSE)"
  },
  {
   value: "St Theophile (CASNE)",
   label: "St Theophile (CASNE)"
  },
  {
   value: "St Vallier (CASVL)",
   label: "St Vallier (CASVL)"
  },
  {
   value: "Staffa (CASFA)",
   label: "Staffa (CASFA)"
  },
  {
   value: "St-Alexis-de-Montcalm (CAAXM)",
   label: "St-Alexis-de-Montcalm (CAAXM)"
  },
  {
   value: "St-Ambroise (CAAMB)",
   label: "St-Ambroise (CAAMB)"
  },
  {
   value: "Stanbridge Station (CASSN)",
   label: "Stanbridge Station (CASSN)"
  },
  {
   value: "Standard (CASNA)",
   label: "Standard (CASNA)"
  },
  {
   value: "St-André-Avellin (CASAA)",
   label: "St-André-Avellin (CASAA)"
  },
  {
   value: "Stanstead Plain (CASNP)",
   label: "Stanstead Plain (CASNP)"
  },
  {
   value: "St-Antoine-de-Tilly (CASAO)",
   label: "St-Antoine-de-Tilly (CASAO)"
  },
  {
   value: "Star City (CASRC)",
   label: "Star City (CASRC)"
  },
  {
   value: "St-Bernard (CASBD)",
   label: "St-Bernard (CASBD)"
  },
  {
   value: "St-Bruno-du-Lac-St-Jean (CABLJ)",
   label: "St-Bruno-du-Lac-St-Jean (CABLJ)"
  },
  {
   value: "St-Charles-sur-Richelieu (CAZCR)",
   label: "St-Charles-sur-Richelieu (CAZCR)"
  },
  {
   value: "St-Côme-Linière (CASCI)",
   label: "St-Côme-Linière (CASCI)"
  },
  {
   value: "St-Damien-de-Brandon (CASDN)",
   label: "St-Damien-de-Brandon (CASDN)"
  },
  {
   value: "St Michel (CASNM)",
   label: "St Michel (CASNM)"
  },
  {
   value: "St Georges\/Beauce-Sartigan (CASGB)",
   label: "St Georges\/Beauce-Sartigan (CASGB)"
  },
  {
   value: "St German (CAGER)",
   label: "St German (CAGER)"
  },
  {
   value: "St Gregor (CASGO)",
   label: "St Gregor (CASGO)"
  },
  {
   value: "St Guillaume (CAGUU)",
   label: "St Guillaume (CAGUU)"
  },
  {
   value: "St Henri (CASHN)",
   label: "St Henri (CASHN)"
  },
  {
   value: "St Honore-de-Chicoutimi (CASHC)",
   label: "St Honore-de-Chicoutimi (CASHC)"
  },
  {
   value: "St Honoré-de-Shenley (CASHS)",
   label: "St Honoré-de-Shenley (CASHS)"
  },
  {
   value: "St Isidore (CASID)",
   label: "St Isidore (CASID)"
  },
  {
   value: "St Jacques le Mineur (CASJQ)",
   label: "St Jacques le Mineur (CASJQ)"
  },
  {
   value: "St Jean (CAYJN)",
   label: "St Jean (CAYJN)"
  },
  {
   value: "St Jean-Baptiste (CASAJ)",
   label: "St Jean-Baptiste (CASAJ)"
  },
  {
   value: "St John Apt (CAYSJ)",
   label: "St John Apt (CAYSJ)"
  },
  {
   value: "St Johns Apt (CAYYT)",
   label: "St Johns Apt (CAYYT)"
  },
  {
   value: "St Joseph (CAJPH)",
   label: "St Joseph (CAJPH)"
  },
  {
   value: "St Joseph de Coleraine (CASJP)",
   label: "St Joseph de Coleraine (CASJP)"
  },
  {
   value: "St Joseph-de-Sorel (CAJDS)",
   label: "St Joseph-de-Sorel (CAJDS)"
  },
  {
   value: "St Joseph-du-Lac (CASJL)",
   label: "St Joseph-du-Lac (CASJL)"
  },
  {
   value: "St Jules (CAXTJ)",
   label: "St Jules (CAXTJ)"
  },
  {
   value: "St Julie (CASTJ)",
   label: "St Julie (CASTJ)"
  },
  {
   value: "St Lazare-de-Vaudreuil (CASLZ)",
   label: "St Lazare-de-Vaudreuil (CASLZ)"
  },
  {
   value: "St Luc (CASLU)",
   label: "St Luc (CASLU)"
  },
  {
   value: "St Marc-des-Carrières (CASMC)",
   label: "St Marc-des-Carrières (CASMC)"
  },
  {
   value: "St Marys (CASMY)",
   label: "St Marys (CASMY)"
  },
  {
   value: "St Georges (CASGG)",
   label: "St Georges (CASGG)"
  },
  {
   value: "St Augustin-de-Desmaures (CASAN)",
   label: "St Augustin-de-Desmaures (CASAN)"
  },
  {
   value: "St Augustin-Deux-Montagnes (CAADM)",
   label: "St Augustin-Deux-Montagnes (CAADM)"
  },
  {
   value: "St Basile (CASBA)",
   label: "St Basile (CASBA)"
  },
  {
   value: "St Bernard de Michaudville (CAQCS)",
   label: "St Bernard de Michaudville (CAQCS)"
  },
  {
   value: "St Boniface (CABFW)",
   label: "St Boniface (CABFW)"
  },
  {
   value: "St Bruno (CASIB)",
   label: "St Bruno (CASIB)"
  },
  {
   value: "St Césaire (CASCS)",
   label: "St Césaire (CASCS)"
  },
  {
   value: "St Charles (CANSC)",
   label: "St Charles (CANSC)"
  },
  {
   value: "St Claude (CASCU)",
   label: "St Claude (CASCU)"
  },
  {
   value: "St Clements (CASLN)",
   label: "St Clements (CASLN)"
  },
  {
   value: "St Clet (CASXC)",
   label: "St Clet (CASXC)"
  },
  {
   value: "St Constant (CASTX)",
   label: "St Constant (CASTX)"
  },
  {
   value: "St Cuthbert (CACBT)",
   label: "St Cuthbert (CACBT)"
  },
  {
   value: "St Damien-de-Buckland (CASDB)",
   label: "St Damien-de-Buckland (CASDB)"
  },
  {
   value: "St Davids (CADDS)",
   label: "St Davids (CADDS)"
  },
  {
   value: "St Denis-sur-Richelieu (CADNR)",
   label: "St Denis-sur-Richelieu (CADNR)"
  },
  {
   value: "St Elzéar\/La Nouvelle-Beau (CASEZ)",
   label: "St Elzéar\/La Nouvelle-Beau (CASEZ)"
  },
  {
   value: "St Ephrem-de-Beauce (CASEP)",
   label: "St Ephrem-de-Beauce (CASEP)"
  },
  {
   value: "St Etienne des Gres (CAQSS)",
   label: "St Etienne des Gres (CAQSS)"
  },
  {
   value: "St Félicien (CASFE)",
   label: "St Félicien (CASFE)"
  },
  {
   value: "St Francois (CAQSF)",
   label: "St Francois (CAQSF)"
  },
  {
   value: "St Francois Xavier (CAFCX)",
   label: "St Francois Xavier (CAFCX)"
  },
  {
   value: "St Frederic (CASFD)",
   label: "St Frederic (CASFD)"
  },
  {
   value: "St Gabriel (CASGA)",
   label: "St Gabriel (CASGA)"
  },
  {
   value: "St George (CASGE)",
   label: "St George (CASGE)"
  },
  {
   value: "St Armand (CASTD)",
   label: "St Armand (CASTD)"
  },
  {
   value: "South Brookfield (CASBF)",
   label: "South Brookfield (CASBF)"
  },
  {
   value: "South River (CASRT)",
   label: "South River (CASRT)"
  },
  {
   value: "Southey (CASOY)",
   label: "Southey (CASOY)"
  },
  {
   value: "Southport (CASOH)",
   label: "Southport (CASOH)"
  },
  {
   value: "Spalding (CASDG)",
   label: "Spalding (CASDG)"
  },
  {
   value: "Spaniards Bay (CASPN)",
   label: "Spaniards Bay (CASPN)"
  },
  {
   value: "Spencerville (CASPV)",
   label: "Spencerville (CASPV)"
  },
  {
   value: "Spirit River (CASIR)",
   label: "Spirit River (CASIR)"
  },
  {
   value: "Split Lake (CASLK)",
   label: "Split Lake (CASLK)"
  },
  {
   value: "Sprague (CASPE)",
   label: "Sprague (CASPE)"
  },
  {
   value: "Spring Lake (CASGL)",
   label: "Spring Lake (CASGL)"
  },
  {
   value: "Springhill (CASPO)",
   label: "Springhill (CASPO)"
  },
  {
   value: "Springside (CASGS)",
   label: "Springside (CASGS)"
  },
  {
   value: "Spruce Grove (CASPG)",
   label: "Spruce Grove (CASPG)"
  },
  {
   value: "St Agapit (CAAPT)",
   label: "St Agapit (CAAPT)"
  },
  {
   value: "St Aimé (CASAI)",
   label: "St Aimé (CASAI)"
  },
  {
   value: "St Albert (CASBT)",
   label: "St Albert (CASBT)"
  },
  {
   value: "St André-Est (CASAE)",
   label: "St André-Est (CASAE)"
  },
  {
   value: "St Anicet (CAAIT)",
   label: "St Anicet (CAAIT)"
  },
  {
   value: "St Anne de Kent (CASKE)",
   label: "St Anne de Kent (CASKE)"
  },
  {
   value: "St Antoine-des-Laurentides (CASTL)",
   label: "St Antoine-des-Laurentides (CASTL)"
  },
  {
   value: "Sheffield Mills (CASFM)",
   label: "Sheffield Mills (CASFM)"
  },
  {
   value: "Shelburne (CASLB)",
   label: "Shelburne (CASLB)"
  },
  {
   value: "Shellbrook (CASBK)",
   label: "Shellbrook (CASBK)"
  },
  {
   value: "Sherbrooke (CASBE)",
   label: "Sherbrooke (CASBE)"
  },
  {
   value: "Sherrington (CASHR)",
   label: "Sherrington (CASHR)"
  },
  {
   value: "Sherwood (CASWD)",
   label: "Sherwood (CASWD)"
  },
  {
   value: "Sherwood Park (CASWP)",
   label: "Sherwood Park (CASWP)"
  },
  {
   value: "Shilo (CAYLO)",
   label: "Shilo (CAYLO)"
  },
  {
   value: "Shoal Lake (CAHOK)",
   label: "Shoal Lake (CAHOK)"
  },
  {
   value: "Shubenacadie (CASCE)",
   label: "Shubenacadie (CASCE)"
  },
  {
   value: "Sicamous (CASIO)",
   label: "Sicamous (CASIO)"
  },
  {
   value: "Sillery (CASYQ)",
   label: "Sillery (CASYQ)"
  },
  {
   value: "Silver Water (CASWT)",
   label: "Silver Water (CASWT)"
  },
  {
   value: "Smithville (CASMV)",
   label: "Smithville (CASMV)"
  },
  {
   value: "Smoky Lake (CASYK)",
   label: "Smoky Lake (CASYK)"
  },
  {
   value: "Snow Lake (CASWL)",
   label: "Snow Lake (CASWL)"
  },
  {
   value: "Snowflake (CASFK)",
   label: "Snowflake (CASFK)"
  },
  {
   value: "Sardis (CASAR)",
   label: "Sardis (CASAR)"
  },
  {
   value: "Sarsfield (CASSF)",
   label: "Sarsfield (CASSF)"
  },
  {
   value: "Sarto (CARTO)",
   label: "Sarto (CARTO)"
  },
  {
   value: "Saulnierville (CASLV)",
   label: "Saulnierville (CASLV)"
  },
  {
   value: "Savona (CASAV)",
   label: "Savona (CASAV)"
  },
  {
   value: "Sawyerville (CASYV)",
   label: "Sawyerville (CASYV)"
  },
  {
   value: "Sayward (CASYW)",
   label: "Sayward (CASYW)"
  },
  {
   value: "Schanzenfeld (CASZF)",
   label: "Schanzenfeld (CASZF)"
  },
  {
   value: "Schreiber (CASHB)",
   label: "Schreiber (CASHB)"
  },
  {
   value: "Schumacher (CASHM)",
   label: "Schumacher (CASHM)"
  },
  {
   value: "Scoudouc (CASCC)",
   label: "Scoudouc (CASCC)"
  },
  {
   value: "Seba Beach (CASBB)",
   label: "Seba Beach (CASBB)"
  },
  {
   value: "Sebringville (CASGV)",
   label: "Sebringville (CASGV)"
  },
  {
   value: "Sedgewick (CASED)",
   label: "Sedgewick (CASED)"
  },
  {
   value: "Sedley (CASLY)",
   label: "Sedley (CASLY)"
  },
  {
   value: "Sexsmith (CASEH)",
   label: "Sexsmith (CASEH)"
  },
  {
   value: "Shag Harbour (CASGH)",
   label: "Shag Harbour (CASGH)"
  },
  {
   value: "Shakespeare Island (CASKP)",
   label: "Shakespeare Island (CASKP)"
  },
  {
   value: "Shallows Lake (CASHL)",
   label: "Shallows Lake (CASHL)"
  },
  {
   value: "Shannon (CANON)",
   label: "Shannon (CANON)"
  },
  {
   value: "Shannonville (CASHV)",
   label: "Shannonville (CASHV)"
  },
  {
   value: "Shanty Bay (CASYB)",
   label: "Shanty Bay (CASYB)"
  },
  {
   value: "Saint-Charles-Borromée (CASNT)",
   label: "Saint-Charles-Borromée (CASNT)"
  },
  {
   value: "Saint-Cyrille (CACYR)",
   label: "Saint-Cyrille (CACYR)"
  },
  {
   value: "Sainte-Brigitte-des-Saults (CASBS)",
   label: "Sainte-Brigitte-des-Saults (CASBS)"
  },
  {
   value: "Sainte-Cecile-De-Milton (CACCM)",
   label: "Sainte-Cecile-De-Milton (CACCM)"
  },
  {
   value: "Sainte-Rosalie (CASRL)",
   label: "Sainte-Rosalie (CASRL)"
  },
  {
   value: "Sainte-Rose (CARRQ)",
   label: "Sainte-Rose (CARRQ)"
  },
  {
   value: "Saint-Esprit (CASPT)",
   label: "Saint-Esprit (CASPT)"
  },
  {
   value: "Saint-Germain-de-Grantham (CASGN)",
   label: "Saint-Germain-de-Grantham (CASGN)"
  },
  {
   value: "Saint-Hippolyte (CASHO)",
   label: "Saint-Hippolyte (CASHO)"
  },
  {
   value: "Saint-Janvier (CASJV)",
   label: "Saint-Janvier (CASJV)"
  },
  {
   value: "Saint-Joseph-de-Beauce (CAXJH)",
   label: "Saint-Joseph-de-Beauce (CAXJH)"
  },
  {
   value: "Saint-Narcisse (CAINT)",
   label: "Saint-Narcisse (CAINT)"
  },
  {
   value: "Saint-Nicolas (CANOJ)",
   label: "Saint-Nicolas (CANOJ)"
  },
  {
   value: "Saint-Pascal (CASPA)",
   label: "Saint-Pascal (CASPA)"
  },
  {
   value: "Saint-Pierre (CASPI)",
   label: "Saint-Pierre (CASPI)"
  },
  {
   value: "Saint-Rémi (CARMI)",
   label: "Saint-Rémi (CARMI)"
  },
  {
   value: "Saint-Timothée (CASTO)",
   label: "Saint-Timothée (CASTO)"
  },
  {
   value: "Saint-Valérien (CASVQ)",
   label: "Saint-Valérien (CASVQ)"
  },
  {
   value: "Saint-Vallier (CASVA)",
   label: "Saint-Vallier (CASVA)"
  },
  {
   value: "Salmo (CASLM)",
   label: "Salmo (CASLM)"
  },
  {
   value: "Salt Spring Island (CASSI)",
   label: "Salt Spring Island (CASSI)"
  },
  {
   value: "Sandy Beach (CASBH)",
   label: "Sandy Beach (CASBH)"
  },
  {
   value: "Sangudo (CAGDU)",
   label: "Sangudo (CAGDU)"
  },
  {
   value: "Saint Tite (CAZTI)",
   label: "Saint Tite (CAZTI)"
  },
  {
   value: "Rolly View (CARYV)",
   label: "Rolly View (CARYV)"
  },
  {
   value: "Roosville (CAROO)",
   label: "Roosville (CAROO)"
  },
  {
   value: "Rosedale (CARSO)",
   label: "Rosedale (CARSO)"
  },
  {
   value: "Rosemère (CAROS)",
   label: "Rosemère (CAROS)"
  },
  {
   value: "Rosenort (CARNO)",
   label: "Rosenort (CARNO)"
  },
  {
   value: "Rosetown (CARSW)",
   label: "Rosetown (CARSW)"
  },
  {
   value: "Rosser (CARSR)",
   label: "Rosser (CARSR)"
  },
  {
   value: "Rossport (CARPO)",
   label: "Rossport (CARPO)"
  },
  {
   value: "Rothesay (CARSZ)",
   label: "Rothesay (CARSZ)"
  },
  {
   value: "Round Hill (CARDH)",
   label: "Round Hill (CARDH)"
  },
  {
   value: "Roxboro (CAROX)",
   label: "Roxboro (CAROX)"
  },
  {
   value: "Roxton Falls (CARXF)",
   label: "Roxton Falls (CARXF)"
  },
  {
   value: "Rush Lake (CARHL)",
   label: "Rush Lake (CARHL)"
  },
  {
   value: "Russell (CARLL)",
   label: "Russell (CARLL)"
  },
  {
   value: "Saanich (CASNH)",
   label: "Saanich (CASNH)"
  },
  {
   value: "Saanichton (CASNC)",
   label: "Saanichton (CASNC)"
  },
  {
   value: "Saanichton Bay (CASXO)",
   label: "Saanichton Bay (CASXO)"
  },
  {
   value: "Sable River (CASRI)",
   label: "Sable River (CASRI)"
  },
  {
   value: "Sackville (CASAC)",
   label: "Sackville (CASAC)"
  },
  {
   value: "Sackville (CAXKV)",
   label: "Sackville (CAXKV)"
  },
  {
   value: "Saint Brieux (CABIX)",
   label: "Saint Brieux (CABIX)"
  },
  {
   value: "Saint Jacobs (CASJS)",
   label: "Saint Jacobs (CASJS)"
  },
  {
   value: "Saint Jacques (CASJJ)",
   label: "Saint Jacques (CASJJ)"
  },
  {
   value: "Saint Quentin (CASQE)",
   label: "Saint Quentin (CASQE)"
  },
  {
   value: "Saint Sylvere (CASSV)",
   label: "Saint Sylvere (CASSV)"
  },
  {
   value: "Richibucto (CARBT)",
   label: "Richibucto (CARBT)"
  },
  {
   value: "Richmond (CARCH)",
   label: "Richmond (CARCH)"
  },
  {
   value: "Richmond (CARMD)",
   label: "Richmond (CARMD)"
  },
  {
   value: "Richmond (CARMO)",
   label: "Richmond (CARMO)"
  },
  {
   value: "Rigaud (CARGD)",
   label: "Rigaud (CARGD)"
  },
  {
   value: "Rimbey (CARIY)",
   label: "Rimbey (CARIY)"
  },
  {
   value: "Ripon (CARPN)",
   label: "Ripon (CARPN)"
  },
  {
   value: "Riverport (CARIV)",
   label: "Riverport (CARIV)"
  },
  {
   value: "Riverton (CAMBT)",
   label: "Riverton (CAMBT)"
  },
  {
   value: "Riverton (CARVO)",
   label: "Riverton (CARVO)"
  },
  {
   value: "Rivière-Beaudette (CARBD)",
   label: "Rivière-Beaudette (CARBD)"
  },
  {
   value: "Rivière-Matawin (CARRM)",
   label: "Rivière-Matawin (CARRM)"
  },
  {
   value: "Roaches Line (CAROA)",
   label: "Roaches Line (CAROA)"
  },
  {
   value: "Robertsonville (CARSV)",
   label: "Robertsonville (CARSV)"
  },
  {
   value: "Roblin (CARBI)",
   label: "Roblin (CARBI)"
  },
  {
   value: "Roblin (CAROB)",
   label: "Roblin (CAROB)"
  },
  {
   value: "Rocanville (CARVI)",
   label: "Rocanville (CARVI)"
  },
  {
   value: "Rochester (CARHS)",
   label: "Rochester (CARHS)"
  },
  {
   value: "Rock Forest (CAROF)",
   label: "Rock Forest (CAROF)"
  },
  {
   value: "Rockland (CAROK)",
   label: "Rockland (CAROK)"
  },
  {
   value: "Rockwood (CARCD)",
   label: "Rockwood (CARCD)"
  },
  {
   value: "Rocky View (CAABR)",
   label: "Rocky View (CAABR)"
  },
  {
   value: "Pubnico (CAPUB)",
   label: "Pubnico (CAPUB)"
  },
  {
   value: "Putnam (CAPUT)",
   label: "Putnam (CAPUT)"
  },
  {
   value: "Qualicum Beach (CAQUB)",
   label: "Qualicum Beach (CAQUB)"
  },
  {
   value: "Quebec Apt (CAYQB)",
   label: "Quebec Apt (CAYQB)"
  },
  {
   value: "Quesnel (CAQSN)",
   label: "Quesnel (CAQSN)"
  },
  {
   value: "Quliqura (CAQUL)",
   label: "Quliqura (CAQUL)"
  },
  {
   value: "Radisson (CARDO)",
   label: "Radisson (CARDO)"
  },
  {
   value: "Radium Hot Springs (CARHP)",
   label: "Radium Hot Springs (CARHP)"
  },
  {
   value: "Radville (CARDV)",
   label: "Radville (CARDV)"
  },
  {
   value: "Rae (CARAE)",
   label: "Rae (CARAE)"
  },
  {
   value: "Ralston (CARAJ)",
   label: "Ralston (CARAJ)"
  },
  {
   value: "Rama (CARMA)",
   label: "Rama (CARMA)"
  },
  {
   value: "Rankin Inlet (CARIT)",
   label: "Rankin Inlet (CARIT)"
  },
  {
   value: "Rapid City (CARPC)",
   label: "Rapid City (CARPC)"
  },
  {
   value: "Rawdon (CARWN)",
   label: "Rawdon (CARWN)"
  },
  {
   value: "Red Deer (CAYQF)",
   label: "Red Deer (CAYQF)"
  },
  {
   value: "Red Lake (CARLA)",
   label: "Red Lake (CARLA)"
  },
  {
   value: "Redcliff (CARCF)",
   label: "Redcliff (CARCF)"
  },
  {
   value: "Redvers (CARVS)",
   label: "Redvers (CARVS)"
  },
  {
   value: "Redwater (CARWA)",
   label: "Redwater (CARWA)"
  },
  {
   value: "Redwood Meadow (CARWM)",
   label: "Redwood Meadow (CARWM)"
  },
  {
   value: "Redwood Meadows (CARDM)",
   label: "Redwood Meadows (CARDM)"
  },
  {
   value: "Regina Apt (CAYQR)",
   label: "Regina Apt (CAYQR)"
  },
  {
   value: "Restoule (CARST)",
   label: "Restoule (CARST)"
  },
  {
   value: "Provost (CAPVT)",
   label: "Provost (CAPVT)"
  },
  {
   value: "Rexton (CARXN)",
   label: "Rexton (CARXN)"
  },
  {
   value: "Riceton (CARCT)",
   label: "Riceton (CARCT)"
  },
  {
   value: "Richardson (CARRO)",
   label: "Richardson (CARRO)"
  },
  {
   value: "Port Mouton (CAPMN)",
   label: "Port Mouton (CAPMN)"
  },
  {
   value: "Port Nelson (CAPNN)",
   label: "Port Nelson (CAPNN)"
  },
  {
   value: "Port Robinson (CAPRB)",
   label: "Port Robinson (CAPRB)"
  },
  {
   value: "Port Saxon (CAPSX)",
   label: "Port Saxon (CAPSX)"
  },
  {
   value: "Port Williams (CAPWI)",
   label: "Port Williams (CAPWI)"
  },
  {
   value: "Portage La Prairie (CAPLP)",
   label: "Portage La Prairie (CAPLP)"
  },
  {
   value: "Pouce Coupe (CAPOU)",
   label: "Pouce Coupe (CAPOU)"
  },
  {
   value: "Powassan (CAPWS)",
   label: "Powassan (CAPWS)"
  },
  {
   value: "Preeceville (CAPPR)",
   label: "Preeceville (CAPPR)"
  },
  {
   value: "Priddis (CAPRD)",
   label: "Priddis (CAPRD)"
  },
  {
   value: "Prince Albert (CAPRA)",
   label: "Prince Albert (CAPRA)"
  },
  {
   value: "Prince Edward Island (CACRL)",
   label: "Prince Edward Island (CACRL)"
  },
  {
   value: "Prince William (CAPRW)",
   label: "Prince William (CAPRW)"
  },
  {
   value: "Princeton (CAPCT)",
   label: "Princeton (CAPCT)"
  },
  {
   value: "Princeton (CAPRT)",
   label: "Princeton (CAPRT)"
  },
  {
   value: "Princeville (CAPCE)",
   label: "Princeville (CAPCE)"
  },
  {
   value: "Prospect (CAPPT)",
   label: "Prospect (CAPPT)"
  },
  {
   value: "Point Tupper (CAPTU)",
   label: "Point Tupper (CAPTU)"
  },
  {
   value: "Pointe Noire (CAPNO)",
   label: "Pointe Noire (CAPNO)"
  },
  {
   value: "Pointe-aux-Outardes (CAAUX)",
   label: "Pointe-aux-Outardes (CAAUX)"
  },
  {
   value: "Pointe-Fortune (CAPFT)",
   label: "Pointe-Fortune (CAPFT)"
  },
  {
   value: "Pointe-Sapin (CAPSA)",
   label: "Pointe-Sapin (CAPSA)"
  },
  {
   value: "Ponoka (CAPKA)",
   label: "Ponoka (CAPKA)"
  },
  {
   value: "Pont-Rouge (CAPTQ)",
   label: "Pont-Rouge (CAPTQ)"
  },
  {
   value: "Poplar Hill (CAPOH)",
   label: "Poplar Hill (CAPOH)"
  },
  {
   value: "Porcupine (CAPCP)",
   label: "Porcupine (CAPCP)"
  },
  {
   value: "Porcupine Plain (CAPPL)",
   label: "Porcupine Plain (CAPPL)"
  },
  {
   value: "Port Bickerton (CAPBI)",
   label: "Port Bickerton (CAPBI)"
  },
  {
   value: "Port Burwell (CABUZ)",
   label: "Port Burwell (CABUZ)"
  },
  {
   value: "Port Elgin (CAPEL)",
   label: "Port Elgin (CAPEL)"
  },
  {
   value: "Port George (CAPGA)",
   label: "Port George (CAPGA)"
  },
  {
   value: "Port Hastings (CAPHA)",
   label: "Port Hastings (CAPHA)"
  },
  {
   value: "Point Edward (CAPEW)",
   label: "Point Edward (CAPEW)"
  },
  {
   value: "Petersburg (CAPBR)",
   label: "Petersburg (CAPBR)"
  },
  {
   value: "Petersfield (CAPFI)",
   label: "Petersfield (CAPFI)"
  },
  {
   value: "Petit Rocher (CAPRO)",
   label: "Petit Rocher (CAPRO)"
  },
  {
   value: "Petitcodiac (CAPCD)",
   label: "Petitcodiac (CAPCD)"
  },
  {
   value: "Petit-de-Grat (CAPGR)",
   label: "Petit-de-Grat (CAPGR)"
  },
  {
   value: "Petrolia (CAPET)",
   label: "Petrolia (CAPET)"
  },
  {
   value: "Philipsburg (CAPHL)",
   label: "Philipsburg (CAPHL)"
  },
  {
   value: "Pickardville (CAPVI)",
   label: "Pickardville (CAPVI)"
  },
  {
   value: "Picture Butte (CAPCB)",
   label: "Picture Butte (CAPCB)"
  },
  {
   value: "Pierrefonds (CAPIE)",
   label: "Pierrefonds (CAPIE)"
  },
  {
   value: "Pierson (CAPSO)",
   label: "Pierson (CAPSO)"
  },
  {
   value: "Pine Falls (CAPIF)",
   label: "Pine Falls (CAPIF)"
  },
  {
   value: "Pine River (CAPIR)",
   label: "Pine River (CAPIR)"
  },
  {
   value: "Pintendre (CAPIN)",
   label: "Pintendre (CAPIN)"
  },
  {
   value: "Pipestone (CAPPO)",
   label: "Pipestone (CAPPO)"
  },
  {
   value: "Pitt Meadows (CAPIM)",
   label: "Pitt Meadows (CAPIM)"
  },
  {
   value: "Plamondon (CAPMD)",
   label: "Plamondon (CAPMD)"
  },
  {
   value: "Plantagenet (CAPLN)",
   label: "Plantagenet (CAPLN)"
  },
  {
   value: "Plaster Rock (CAPLR)",
   label: "Plaster Rock (CAPLR)"
  },
  {
   value: "Pleasantville (CAPSV)",
   label: "Pleasantville (CAPSV)"
  },
  {
   value: "Plessisville (CAPLE)",
   label: "Plessisville (CAPLE)"
  },
  {
   value: "Plum Coulee (CAPLC)",
   label: "Plum Coulee (CAPLC)"
  },
  {
   value: "Pohénégamook (CAPHM)",
   label: "Pohénégamook (CAPHM)"
  },
  {
   value: "Perth-Andover (CAPAN)",
   label: "Perth-Andover (CAPAN)"
  },
  {
   value: "Point Edward (CAPED)",
   label: "Point Edward (CAPED)"
  },
  {
   value: "Palgrave (CAPLV)",
   label: "Palgrave (CAPLV)"
  },
  {
   value: "Palmerston (CAPAL)",
   label: "Palmerston (CAPAL)"
  },
  {
   value: "Palmerston (CAPMR)",
   label: "Palmerston (CAPMR)"
  },
  {
   value: "Pangman (CAPGM)",
   label: "Pangman (CAPGM)"
  },
  {
   value: "Panorama (CAPRM)",
   label: "Panorama (CAPRM)"
  },
  {
   value: "Paradise (CAPRI)",
   label: "Paradise (CAPRI)"
  },
  {
   value: "Paris (CAPAO)",
   label: "Paris (CAPAO)"
  },
  {
   value: "Parkhill (CAPKH)",
   label: "Parkhill (CAPKH)"
  },
  {
   value: "Parkland (CAPKL)",
   label: "Parkland (CAPKL)"
  },
  {
   value: "Parksville (CAPAE)",
   label: "Parksville (CAPAE)"
  },
  {
   value: "Parson (CAPXN)",
   label: "Parson (CAPXN)"
  },
  {
   value: "Pasadena (CAPSD)",
   label: "Pasadena (CAPSD)"
  },
  {
   value: "Peachland (CAPHN)",
   label: "Peachland (CAPHN)"
  },
  {
   value: "Pemberton (CAPBN)",
   label: "Pemberton (CAPBN)"
  },
  {
   value: "Penetanguishene (CAPTH)",
   label: "Penetanguishene (CAPTH)"
  },
  {
   value: "Penhold (CAPNH)",
   label: "Penhold (CAPNH)"
  },
  {
   value: "Pennfield (CAPFD)",
   label: "Pennfield (CAPFD)"
  },
  {
   value: "Pennfield Ridge (CAPEN)",
   label: "Pennfield Ridge (CAPEN)"
  },
  {
   value: "Penobsquis (CAPNB)",
   label: "Penobsquis (CAPNB)"
  },
  {
   value: "Perdue (CAPDU)",
   label: "Perdue (CAPDU)"
  },
  {
   value: "Péribonka (CAPBK)",
   label: "Péribonka (CAPBK)"
  },
  {
   value: "Paisley (CAPLY)",
   label: "Paisley (CAPLY)"
  },
  {
   value: "Odessa (CAODE)",
   label: "Odessa (CAODE)"
  },
  {
   value: "Ohsweken (CAOWK)",
   label: "Ohsweken (CAOWK)"
  },
  {
   value: "Okanagan Falls (CAOFL)",
   label: "Okanagan Falls (CAOFL)"
  },
  {
   value: "Okotoks (CAOTS)",
   label: "Okotoks (CAOTS)"
  },
  {
   value: "Old Perlican (CAOPL)",
   label: "Old Perlican (CAOPL)"
  },
  {
   value: "Oldcastle (CAOCA)",
   label: "Oldcastle (CAOCA)"
  },
  {
   value: "Olds (CAODS)",
   label: "Olds (CAODS)"
  },
  {
   value: "Oliver (CAOVR)",
   label: "Oliver (CAOVR)"
  },
  {
   value: "Ompah (CAOPH)",
   label: "Ompah (CAOPH)"
  },
  {
   value: "Onaping (CAONP)",
   label: "Onaping (CAONP)"
  },
  {
   value: "One Hundred Mile House (CAHOS)",
   label: "One Hundred Mile House (CAHOS)"
  },
  {
   value: "Onoway (CAOWY)",
   label: "Onoway (CAOWY)"
  },
  {
   value: "Orangedale (CAOGD)",
   label: "Orangedale (CAOGD)"
  },
  {
   value: "Orléans (CAOLS)",
   label: "Orléans (CAOLS)"
  },
  {
   value: "Oromocto (CAORO)",
   label: "Oromocto (CAORO)"
  },
  {
   value: "Osgoode (CAOGO)",
   label: "Osgoode (CAOGO)"
  },
  {
   value: "Osoyoos (CAOJY)",
   label: "Osoyoos (CAOJY)"
  },
  {
   value: "Osoyoos (CAOYS)",
   label: "Osoyoos (CAOYS)"
  },
  {
   value: "Ottawa Apt (CAYOW)",
   label: "Ottawa Apt (CAYOW)"
  },
  {
   value: "Otterville (CAOTV)",
   label: "Otterville (CAOTV)"
  },
  {
   value: "Outlook (CAOOK)",
   label: "Outlook (CAOOK)"
  },
  {
   value: "Outremont (CAOTM)",
   label: "Outremont (CAOTM)"
  },
  {
   value: "Oxbow (CAOXB)",
   label: "Oxbow (CAOXB)"
  },
  {
   value: "Oyen (CAOYN)",
   label: "Oyen (CAOYN)"
  },
  {
   value: "Pain Court (CAPCU)",
   label: "Pain Court (CAPCU)"
  },
  {
   value: "Nimpkish (CANIM)",
   label: "Nimpkish (CANIM)"
  },
  {
   value: "Nimpo Lake (CANPL)",
   label: "Nimpo Lake (CANPL)"
  },
  {
   value: "Nipawin (CANPW)",
   label: "Nipawin (CANPW)"
  },
  {
   value: "Nipigon (CANPG)",
   label: "Nipigon (CANPG)"
  },
  {
   value: "Nisku (CANIU)",
   label: "Nisku (CANIU)"
  },
  {
   value: "Nisku\/Edmonton (CANSK)",
   label: "Nisku\/Edmonton (CANSK)"
  },
  {
   value: "Niverville (CANVL)",
   label: "Niverville (CANVL)"
  },
  {
   value: "Nobleford (CANBF)",
   label: "Nobleford (CANBF)"
  },
  {
   value: "Nobleton (CANOB)",
   label: "Nobleton (CANOB)"
  },
  {
   value: "Norluay (CANQA)",
   label: "Norluay (CANQA)"
  },
  {
   value: "Normandin (CANMN)",
   label: "Normandin (CANMN)"
  },
  {
   value: "North Pine (CANPI)",
   label: "North Pine (CANPI)"
  },
  {
   value: "North Portal (CANPR)",
   label: "North Portal (CANPR)"
  },
  {
   value: "North Rustico (CANRU)",
   label: "North Rustico (CANRU)"
  },
  {
   value: "North Vancouver (CAVAC)",
   label: "North Vancouver (CAVAC)"
  },
  {
   value: "Norval (CANVA)",
   label: "Norval (CANVA)"
  },
  {
   value: "Notre-Dame-du-Bon-Conseil (CANBC)",
   label: "Notre-Dame-du-Bon-Conseil (CANBC)"
  },
  {
   value: "Oak Bluff (CAKRV)",
   label: "Oak Bluff (CAKRV)"
  },
  {
   value: "Oak Lake (CAOAL)",
   label: "Oak Lake (CAOAL)"
  },
  {
   value: "Oakbank (CAOBK)",
   label: "Oakbank (CAOBK)"
  },
  {
   value: "Oakville (CAOAJ)",
   label: "Oakville (CAOAJ)"
  },
  {
   value: "Nicolet (CANLT)",
   label: "Nicolet (CANLT)"
  },
  {
   value: "Nelson (CANLS)",
   label: "Nelson (CANLS)"
  },
  {
   value: "Nelson-Miramichi (CANMI)",
   label: "Nelson-Miramichi (CANMI)"
  },
  {
   value: "Nepean (CANPN)",
   label: "Nepean (CANPN)"
  },
  {
   value: "Neudorf (CANDO)",
   label: "Neudorf (CANDO)"
  },
  {
   value: "Neudorf (CANEU)",
   label: "Neudorf (CANEU)"
  },
  {
   value: "New Bothwell (CANBM)",
   label: "New Bothwell (CANBM)"
  },
  {
   value: "New Canaan (CANCA)",
   label: "New Canaan (CANCA)"
  },
  {
   value: "New Dayton (CANDA)",
   label: "New Dayton (CANDA)"
  },
  {
   value: "New Denver (CANDV)",
   label: "New Denver (CANDV)"
  },
  {
   value: "New Dundee (CANDU)",
   label: "New Dundee (CANDU)"
  },
  {
   value: "New Hamburg (CANHM)",
   label: "New Hamburg (CANHM)"
  },
  {
   value: "New Harbour (CANHU)",
   label: "New Harbour (CANHU)"
  },
  {
   value: "New Liskeard (CANLI)",
   label: "New Liskeard (CANLI)"
  },
  {
   value: "New Minas (CANMA)",
   label: "New Minas (CANMA)"
  },
  {
   value: "New Norway (CANOY)",
   label: "New Norway (CANOY)"
  },
  {
   value: "New Ross (CANWR)",
   label: "New Ross (CANWR)"
  },
  {
   value: "New Waterford (CANWA)",
   label: "New Waterford (CANWA)"
  },
  {
   value: "Newbrook (CANWO)",
   label: "Newbrook (CANWO)"
  },
  {
   value: "Newburgh (CANBH)",
   label: "Newburgh (CANBH)"
  },
  {
   value: "Newcastle (CANWT)",
   label: "Newcastle (CANWT)"
  },
  {
   value: "Newton (CAEWT)",
   label: "Newton (CAEWT)"
  },
  {
   value: "Neerlandia (CANRA)",
   label: "Neerlandia (CANRA)"
  },
  {
   value: "Mossley (CAXSY)",
   label: "Mossley (CAXSY)"
  },
  {
   value: "Mount Brydges (CAMBY)",
   label: "Mount Brydges (CAMBY)"
  },
  {
   value: "Mount Elgin (CAMEG)",
   label: "Mount Elgin (CAMEG)"
  },
  {
   value: "Mount Forest (CAMTF)",
   label: "Mount Forest (CAMTF)"
  },
  {
   value: "Mount Hope (CAMHO)",
   label: "Mount Hope (CAMHO)"
  },
  {
   value: "Mount Pleasant (CAMPS)",
   label: "Mount Pleasant (CAMPS)"
  },
  {
   value: "Mount Stewart (CAMOS)",
   label: "Mount Stewart (CAMOS)"
  },
  {
   value: "Mount Uniacke (CAMUC)",
   label: "Mount Uniacke (CAMUC)"
  },
  {
   value: "Murdochville (CAMVE)",
   label: "Murdochville (CAMVE)"
  },
  {
   value: "Murray Harbour (CAMUH)",
   label: "Murray Harbour (CAMUH)"
  },
  {
   value: "Murray River (CAMUR)",
   label: "Murray River (CAMUR)"
  },
  {
   value: "Myrtle (CAMYR)",
   label: "Myrtle (CAMYR)"
  },
  {
   value: "Nackawic (CANAC)",
   label: "Nackawic (CANAC)"
  },
  {
   value: "Naicam (CANCM)",
   label: "Naicam (CANCM)"
  },
  {
   value: "Nakusp (CANAK)",
   label: "Nakusp (CANAK)"
  },
  {
   value: "Namao (CANMO)",
   label: "Namao (CANMO)"
  },
  {
   value: "Nampa (CANMP)",
   label: "Nampa (CANMP)"
  },
  {
   value: "Nanton (CANTO)",
   label: "Nanton (CANTO)"
  },
  {
   value: "Napadogan (CANDN)",
   label: "Napadogan (CANDN)"
  },
  {
   value: "Napanee (CANPA)",
   label: "Napanee (CANPA)"
  },
  {
   value: "Naramata (CANMT)",
   label: "Naramata (CANMT)"
  },
  {
   value: "Neepawa (CANEE)",
   label: "Neepawa (CANEE)"
  },
  {
   value: "Morse (CAMSE)",
   label: "Morse (CAMSE)"
  },
  {
   value: "Monkland (CAMNK)",
   label: "Monkland (CAMNK)"
  },
  {
   value: "Mont Rolland (CAMRO)",
   label: "Mont Rolland (CAMRO)"
  },
  {
   value: "Mont Tremblant (CAMBL)",
   label: "Mont Tremblant (CAMBL)"
  },
  {
   value: "Montague (CAMGU)",
   label: "Montague (CAMGU)"
  },
  {
   value: "Mont-Carmel (CANDM)",
   label: "Mont-Carmel (CANDM)"
  },
  {
   value: "Montebello (CAMBO)",
   label: "Montebello (CAMBO)"
  },
  {
   value: "Montmagny (CAMGN)",
   label: "Montmagny (CAMGN)"
  },
  {
   value: "Montney (CAMNY)",
   label: "Montney (CAMNY)"
  },
  {
   value: "Montreal-Dorval Apt (CAYUL)",
   label: "Montreal-Dorval Apt (CAYUL)"
  },
  {
   value: "Montréal-Est (CAMRE)",
   label: "Montréal-Est (CAMRE)"
  },
  {
   value: "Montréal-Nord (CAMRN)",
   label: "Montréal-Nord (CAMRN)"
  },
  {
   value: "Mont-Royal (CAMRL)",
   label: "Mont-Royal (CAMRL)"
  },
  {
   value: "Mont-Saint-Gregoire (CAMSG)",
   label: "Mont-Saint-Gregoire (CAMSG)"
  },
  {
   value: "Moonbeam (CAMBE)",
   label: "Moonbeam (CAMBE)"
  },
  {
   value: "Moorefield (CAMRF)",
   label: "Moorefield (CAMRF)"
  },
  {
   value: "Mooretown (CAMRW)",
   label: "Mooretown (CAMRW)"
  },
  {
   value: "Moose Creek (CAMCK)",
   label: "Moose Creek (CAMCK)"
  },
  {
   value: "Moose Factory (CAMOO)",
   label: "Moose Factory (CAMOO)"
  },
  {
   value: "Moosomin (CAMSM)",
   label: "Moosomin (CAMSM)"
  },
  {
   value: "Morell (CAMOP)",
   label: "Morell (CAMOP)"
  },
  {
   value: "Morin Heights (CAMHT)",
   label: "Morin Heights (CAMHT)"
  },
  {
   value: "Morinville (CAMRV)",
   label: "Morinville (CAMRV)"
  },
  {
   value: "Morris (CAMRS)",
   label: "Morris (CAMRS)"
  },
  {
   value: "Monarch (CAMCH)",
   label: "Monarch (CAMCH)"
  },
  {
   value: "Metis-sur-Mer (CAMMR)",
   label: "Metis-sur-Mer (CAMMR)"
  },
  {
   value: "Miami (CAMMI)",
   label: "Miami (CAMMI)"
  },
  {
   value: "Middleton (CAMDL)",
   label: "Middleton (CAMDL)"
  },
  {
   value: "Middleton (CAMDP)",
   label: "Middleton (CAMDP)"
  },
  {
   value: "Midhurst (CAMDT)",
   label: "Midhurst (CAMDT)"
  },
  {
   value: "Mill Bay (CAILB)",
   label: "Mill Bay (CAILB)"
  },
  {
   value: "Millarville (CAMLV)",
   label: "Millarville (CAMLV)"
  },
  {
   value: "Millbank (CAMLB)",
   label: "Millbank (CAMLB)"
  },
  {
   value: "Millbrook (CAMBK)",
   label: "Millbrook (CAMBK)"
  },
  {
   value: "Millet (CAMLE)",
   label: "Millet (CAMLE)"
  },
  {
   value: "Millgrove (CAMLG)",
   label: "Millgrove (CAMLG)"
  },
  {
   value: "Millville (CAMVI)",
   label: "Millville (CAMVI)"
  },
  {
   value: "Milner (CAMLR)",
   label: "Milner (CAMLR)"
  },
  {
   value: "Milner Ridge (CAMLN)",
   label: "Milner Ridge (CAMLN)"
  },
  {
   value: "Milton (CAMIO)",
   label: "Milton (CAMIO)"
  },
  {
   value: "Milverton (CAMLO)",
   label: "Milverton (CAMLO)"
  },
  {
   value: "Miminegash (CAMIM)",
   label: "Miminegash (CAMIM)"
  },
  {
   value: "Mindemoya (CAMYO)",
   label: "Mindemoya (CAMYO)"
  },
  {
   value: "Minden (CAMIN)",
   label: "Minden (CAMIN)"
  },
  {
   value: "Minesville (CAMSV)",
   label: "Minesville (CAMSV)"
  },
  {
   value: "Minnedosa (CAMDO)",
   label: "Minnedosa (CAMDO)"
  },
  {
   value: "Minto (CAMTO)",
   label: "Minto (CAMTO)"
  },
  {
   value: "Mirabel Apt\/Montreal (CAYMX)",
   label: "Mirabel Apt\/Montreal (CAYMX)"
  },
  {
   value: "Miscouche (CAMCE)",
   label: "Miscouche (CAMCE)"
  },
  {
   value: "Mistassini (CAMST)",
   label: "Mistassini (CAMST)"
  },
  {
   value: "Mitchell (CAMHL)",
   label: "Mitchell (CAMHL)"
  },
  {
   value: "Mitchell (CAMTH)",
   label: "Mitchell (CAMTH)"
  },
  {
   value: "Mascouche (CAMSC)",
   label: "Mascouche (CAMSC)"
  },
  {
   value: "Maskinonge (CAMKO)",
   label: "Maskinonge (CAMKO)"
  },
  {
   value: "Masson (CAMAS)",
   label: "Masson (CAMAS)"
  },
  {
   value: "Massueville (CASVV)",
   label: "Massueville (CASVV)"
  },
  {
   value: "Matsqui (CATSQ)",
   label: "Matsqui (CATSQ)"
  },
  {
   value: "Mattawa (CAMTW)",
   label: "Mattawa (CAMTW)"
  },
  {
   value: "Maxwell (CAOML)",
   label: "Maxwell (CAOML)"
  },
  {
   value: "Mayerthorpe (CAMAY)",
   label: "Mayerthorpe (CAMAY)"
  },
  {
   value: "Maymont (CAMYM)",
   label: "Maymont (CAMYM)"
  },
  {
   value: "Mayne (CAMYE)",
   label: "Mayne (CAMYE)"
  },
  {
   value: "Mccreary (CAMCY)",
   label: "Mccreary (CAMCY)"
  },
  {
   value: "McGregor (CAMCG)",
   label: "McGregor (CAMCG)"
  },
  {
   value: "McGregor (CAMGR)",
   label: "McGregor (CAMGR)"
  },
  {
   value: "McLean (CAMCN)",
   label: "McLean (CAMCN)"
  },
  {
   value: "Mcleod Lake (CAMCL)",
   label: "Mcleod Lake (CAMCL)"
  },
  {
   value: "McMasterville (CAMCM)",
   label: "McMasterville (CAMCM)"
  },
  {
   value: "Meaford (CAMFD)",
   label: "Meaford (CAMFD)"
  },
  {
   value: "Meductic (CAMED)",
   label: "Meductic (CAMED)"
  },
  {
   value: "Melbourne (CAMLU)",
   label: "Melbourne (CAMLU)"
  },
  {
   value: "Melfort (CAMFO)",
   label: "Melfort (CAMFO)"
  },
  {
   value: "Melita (CAMLT)",
   label: "Melita (CAMLT)"
  },
  {
   value: "Melville (CAMEV)",
   label: "Melville (CAMEV)"
  },
  {
   value: "Mercier (CAMER)",
   label: "Mercier (CAMER)"
  },
  {
   value: "Merlin (CAMLI)",
   label: "Merlin (CAMLI)"
  },
  {
   value: "Metabetchouan (CAMBN)",
   label: "Metabetchouan (CAMBN)"
  },
  {
   value: "Metabetchouan-Lac-a-la-Croix (CAMLC)",
   label: "Metabetchouan-Lac-a-la-Croix (CAMLC)"
  },
  {
   value: "Metcalfe (CAMTC)",
   label: "Metcalfe (CAMTC)"
  },
  {
   value: "Magpie (CAMGP)",
   label: "Magpie (CAMGP)"
  },
  {
   value: "Maidstone (CAMDS)",
   label: "Maidstone (CAMDS)"
  },
  {
   value: "Maisonnette Point (CAMAI)",
   label: "Maisonnette Point (CAMAI)"
  },
  {
   value: "Malakwa (CAMKW)",
   label: "Malakwa (CAMKW)"
  },
  {
   value: "Malartic (CAMTI)",
   label: "Malartic (CAMTI)"
  },
  {
   value: "Malpeque Bay (CAMQE)",
   label: "Malpeque Bay (CAMQE)"
  },
  {
   value: "Malton (CAMAL)",
   label: "Malton (CAMAL)"
  },
  {
   value: "Ma-Ma-O Beach (CAAEO)",
   label: "Ma-Ma-O Beach (CAAEO)"
  },
  {
   value: "Mamramcook (CAMAM)",
   label: "Mamramcook (CAMAM)"
  },
  {
   value: "Manilla (CAMLL)",
   label: "Manilla (CAMLL)"
  },
  {
   value: "Manitou (CAMTU)",
   label: "Manitou (CAMTU)"
  },
  {
   value: "Manotick (CAMTK)",
   label: "Manotick (CAMTK)"
  },
  {
   value: "Manseau (CAMSU)",
   label: "Manseau (CAMSU)"
  },
  {
   value: "Mansfield (CAMSF)",
   label: "Mansfield (CAMSF)"
  },
  {
   value: "Maple (CAMAP)",
   label: "Maple (CAMAP)"
  },
  {
   value: "Maple Creek (CAMCR)",
   label: "Maple Creek (CAMCR)"
  },
  {
   value: "Maple Ridge (CAMPR)",
   label: "Maple Ridge (CAMPR)"
  },
  {
   value: "Margaret (CAMRG)",
   label: "Margaret (CAMRG)"
  },
  {
   value: "Marieville (CAMVL)",
   label: "Marieville (CAMVL)"
  },
  {
   value: "Markdale (CAMKD)",
   label: "Markdale (CAMKD)"
  },
  {
   value: "Marmora (CAMMA)",
   label: "Marmora (CAMMA)"
  },
  {
   value: "Marquette (CAMQT)",
   label: "Marquette (CAMQT)"
  },
  {
   value: "Magnetawan (CAMNW)",
   label: "Magnetawan (CAMNW)"
  },
  {
   value: "Lone Butte (CALNB)",
   label: "Lone Butte (CALNB)"
  },
  {
   value: "Long Sault (CALST)",
   label: "Long Sault (CALST)"
  },
  {
   value: "Longue-Pointe (CALNP)",
   label: "Longue-Pointe (CALNP)"
  },
  {
   value: "Lorette (CALRT)",
   label: "Lorette (CALRT)"
  },
  {
   value: "Loretteville (CALVL)",
   label: "Loretteville (CALVL)"
  },
  {
   value: "Loretto (CALTO)",
   label: "Loretto (CALTO)"
  },
  {
   value: "Lorneville (CALNV)",
   label: "Lorneville (CALNV)"
  },
  {
   value: "Lotbinière (CALOT)",
   label: "Lotbinière (CALOT)"
  },
  {
   value: "Louiseville (CALSV)",
   label: "Louiseville (CALSV)"
  },
  {
   value: "Lowbanks (CALWB)",
   label: "Lowbanks (CALWB)"
  },
  {
   value: "Lower Cove (CALCV)",
   label: "Lower Cove (CALCV)"
  },
  {
   value: "Lower East Pubnico (CALEO)",
   label: "Lower East Pubnico (CALEO)"
  },
  {
   value: "Lower Sackville (CASKL)",
   label: "Lower Sackville (CASKL)"
  },
  {
   value: "Lower Woods Harbour (CALWH)",
   label: "Lower Woods Harbour (CALWH)"
  },
  {
   value: "Lucan (CALUU)",
   label: "Lucan (CALUU)"
  },
  {
   value: "Lucknow (CALKN)",
   label: "Lucknow (CALKN)"
  },
  {
   value: "Lumby (CALUY)",
   label: "Lumby (CALUY)"
  },
  {
   value: "Luskville (CALKV)",
   label: "Luskville (CALKV)"
  },
  {
   value: "Mabou (CAMAB)",
   label: "Mabou (CAMAB)"
  },
  {
   value: "Macamic (CAMCC)",
   label: "Macamic (CAMCC)"
  },
  {
   value: "Mackenzie (CAMNZ)",
   label: "Mackenzie (CAMNZ)"
  },
  {
   value: "Macoun (CAMCO)",
   label: "Macoun (CAMCO)"
  },
  {
   value: "Mactaquac (CAMTQ)",
   label: "Mactaquac (CAMTQ)"
  },
  {
   value: "Madawaska (CAMWA)",
   label: "Madawaska (CAMWA)"
  },
  {
   value: "Leduc (CALDC)",
   label: "Leduc (CALDC)"
  },
  {
   value: "Legal (CALGL)",
   label: "Legal (CALGL)"
  },
  {
   value: "Lepreau (CALEP)",
   label: "Lepreau (CALEP)"
  },
  {
   value: "Leross (CALRS)",
   label: "Leross (CALRS)"
  },
  {
   value: "Leroy (CALRO)",
   label: "Leroy (CALRO)"
  },
  {
   value: "Léry (CALRY)",
   label: "Léry (CALRY)"
  },
  {
   value: "Les Mechins (CAMHN)",
   label: "Les Mechins (CAMHN)"
  },
  {
   value: "Lester B. Pearson International\/Toronto (CAYYZ)",
   label: "Lester B. Pearson International\/Toronto (CAYYZ)"
  },
  {
   value: "Libau (CALBU)",
   label: "Libau (CALBU)"
  },
  {
   value: "Lillooet (CALOO)",
   label: "Lillooet (CALOO)"
  },
  {
   value: "Limehouse (CALHO)",
   label: "Limehouse (CALHO)"
  },
  {
   value: "Linden (CALDI)",
   label: "Linden (CALDI)"
  },
  {
   value: "Lindsay (CALND)",
   label: "Lindsay (CALND)"
  },
  {
   value: "Lingan (CALGN)",
   label: "Lingan (CALGN)"
  },
  {
   value: "Little Brook (CALBK)",
   label: "Little Brook (CALBK)"
  },
  {
   value: "Little Shemogue (CALSO)",
   label: "Little Shemogue (CALSO)"
  },
  {
   value: "Lively (CALVY)",
   label: "Lively (CALVY)"
  },
  {
   value: "Lobo (CALOB)",
   label: "Lobo (CALOB)"
  },
  {
   value: "Lockport (CALKP)",
   label: "Lockport (CALKP)"
  },
  {
   value: "Lodgepole (CALDG)",
   label: "Lodgepole (CALDG)"
  },
  {
   value: "Logan Lake (CALNL)",
   label: "Logan Lake (CALNL)"
  },
  {
   value: "Lomond (CALOM)",
   label: "Lomond (CALOM)"
  },
  {
   value: "Lake Louise (CALLI)",
   label: "Lake Louise (CALLI)"
  },
  {
   value: "Lakefield (CALKF)",
   label: "Lakefield (CALKF)"
  },
  {
   value: "Lakeshore (CALSE)",
   label: "Lakeshore (CALSE)"
  },
  {
   value: "Lakeside (CALKI)",
   label: "Lakeside (CALKI)"
  },
  {
   value: "Lambeth (CALMB)",
   label: "Lambeth (CALMB)"
  },
  {
   value: "Lamèque (CALQE)",
   label: "Lamèque (CALQE)"
  },
  {
   value: "Lancaster Park (CALRP)",
   label: "Lancaster Park (CALRP)"
  },
  {
   value: "Landmark (CALMK)",
   label: "Landmark (CALMK)"
  },
  {
   value: "Langdon (CALGD)",
   label: "Langdon (CALGD)"
  },
  {
   value: "Langenburg (CALGB)",
   label: "Langenburg (CALGB)"
  },
  {
   value: "Langham (CALGA)",
   label: "Langham (CALGA)"
  },
  {
   value: "Lanigan (CALNA)",
   label: "Lanigan (CALNA)"
  },
  {
   value: "Lanoraie (CALRI)",
   label: "Lanoraie (CALRI)"
  },
  {
   value: "Lantzville (CALZV)",
   label: "Lantzville (CALZV)"
  },
  {
   value: "Latchford (CALAT)",
   label: "Latchford (CALAT)"
  },
  {
   value: "Laurentides (CALAU)",
   label: "Laurentides (CALAU)"
  },
  {
   value: "Laurier (CALAR)",
   label: "Laurier (CALAR)"
  },
  {
   value: "Laurier-Station (CALSA)",
   label: "Laurier-Station (CALSA)"
  },
  {
   value: "Lauzon (CALZN)",
   label: "Lauzon (CALZN)"
  },
  {
   value: "Lavaltrie (CALVR)",
   label: "Lavaltrie (CALVR)"
  },
  {
   value: "Laverlochère (CALVH)",
   label: "Laverlochère (CALVH)"
  },
  {
   value: "Lazo (CALAZ)",
   label: "Lazo (CALAZ)"
  },
  {
   value: "Le Gardeur (CALEG)",
   label: "Le Gardeur (CALEG)"
  },
  {
   value: "Leask (CALSK)",
   label: "Leask (CALSK)"
  },
  {
   value: "Leaskdale (CALDE)",
   label: "Leaskdale (CALDE)"
  },
  {
   value: "La Baie (CALBA)",
   label: "La Baie (CALBA)"
  },
  {
   value: "La Broquerie (CALBQ)",
   label: "La Broquerie (CALBQ)"
  },
  {
   value: "La Crête (CALCR)",
   label: "La Crête (CALCR)"
  },
  {
   value: "La Glace (CALGC)",
   label: "La Glace (CALGC)"
  },
  {
   value: "La Guadeloupe (CALGE)",
   label: "La Guadeloupe (CALGE)"
  },
  {
   value: "La Malbaie (CALAM)",
   label: "La Malbaie (CALAM)"
  },
  {
   value: "La Patrie (CALPT)",
   label: "La Patrie (CALPT)"
  },
  {
   value: "La Pocatière (CALPO)",
   label: "La Pocatière (CALPO)"
  },
  {
   value: "La Présentation (CARIE)",
   label: "La Présentation (CARIE)"
  },
  {
   value: "La Salette (CALSL)",
   label: "La Salette (CALSL)"
  },
  {
   value: "La Salle (CALMW)",
   label: "La Salle (CALMW)"
  },
  {
   value: "Labrador City (CALBR)",
   label: "Labrador City (CALBR)"
  },
  {
   value: "Lac Brome (CALBM)",
   label: "Lac Brome (CALBM)"
  },
  {
   value: "Lac du Bonnet (CALDB)",
   label: "Lac du Bonnet (CALDB)"
  },
  {
   value: "Lac La Hache (CAHLC)",
   label: "Lac La Hache (CAHLC)"
  },
  {
   value: "Lac-Beauport (CALBP)",
   label: "Lac-Beauport (CALBP)"
  },
  {
   value: "Lac-des-Îles (CALIL)",
   label: "Lac-des-Îles (CALIL)"
  },
  {
   value: "Lachenaie (CALCA)",
   label: "Lachenaie (CALCA)"
  },
  {
   value: "Lac-Mégantic (CALME)",
   label: "Lac-Mégantic (CALME)"
  },
  {
   value: "Lacombe (CALCM)",
   label: "Lacombe (CALCM)"
  },
  {
   value: "Key Harbour (CAKHO)",
   label: "Key Harbour (CAKHO)"
  },
  {
   value: "Killarney (CAKRY)",
   label: "Killarney (CAKRY)"
  },
  {
   value: "Kinburn (CAKBU)",
   label: "Kinburn (CAKBU)"
  },
  {
   value: "Kingman (CAKGM)",
   label: "Kingman (CAKGM)"
  },
  {
   value: "Kingsgate (CAKNG)",
   label: "Kingsgate (CAKNG)"
  },
  {
   value: "Kingston (CAKGN)",
   label: "Kingston (CAKGN)"
  },
  {
   value: "Kinistino (CAKST)",
   label: "Kinistino (CAKST)"
  },
  {
   value: "Kintore (CAKTO)",
   label: "Kintore (CAKTO)"
  },
  {
   value: "Kippen (CAKIP)",
   label: "Kippen (CAKIP)"
  },
  {
   value: "Kleefeld (CAKFD)",
   label: "Kleefeld (CAKFD)"
  },
  {
   value: "Kleinburg (CAKBG)",
   label: "Kleinburg (CAKBG)"
  },
  {
   value: "Knowlton (CAKNN)",
   label: "Knowlton (CAKNN)"
  },
  {
   value: "Kola (CAKOL)",
   label: "Kola (CAKOL)"
  },
  {
   value: "Komoka (CAKMK)",
   label: "Komoka (CAKMK)"
  },
  {
   value: "Kettleby (CAKTB)",
   label: "Kettleby (CAKTB)"
  },
  {
   value: "Jenner (CAJNE)",
   label: "Jenner (CAJNE)"
  },
  {
   value: "Kamsack (CAKSA)",
   label: "Kamsack (CAKSA)"
  },
  {
   value: "Kananaskis (CAKNA)",
   label: "Kananaskis (CAKNA)"
  },
  {
   value: "Kaslo (CAKLO)",
   label: "Kaslo (CAKLO)"
  },
  {
   value: "Kedgwick (CAKGK)",
   label: "Kedgwick (CAKGK)"
  },
  {
   value: "Keewatin (CAKWN)",
   label: "Keewatin (CAKWN)"
  },
  {
   value: "Kelwood (CAKWO)",
   label: "Kelwood (CAKWO)"
  },
  {
   value: "Kenaston (CAKSO)",
   label: "Kenaston (CAKSO)"
  },
  {
   value: "Kenilworth (CAKWH)",
   label: "Kenilworth (CAKWH)"
  },
  {
   value: "Kensington (CAKSN)",
   label: "Kensington (CAKSN)"
  },
  {
   value: "Kent Bridge (CAKBD)",
   label: "Kent Bridge (CAKBD)"
  },
  {
   value: "Kentville (CAKTL)",
   label: "Kentville (CAKTL)"
  },
  {
   value: "Keoma (CAKEA)",
   label: "Keoma (CAKEA)"
  },
  {
   value: "Kerwood (CAKWD)",
   label: "Kerwood (CAKWD)"
  },
  {
   value: "Keswick (CAKWK)",
   label: "Keswick (CAKWK)"
  },
  {
   value: "Jedway (CAJED)",
   label: "Jedway (CAJED)"
  },
  {
   value: "Imperial (CASIM)",
   label: "Imperial (CASIM)"
  },
  {
   value: "Indian Arm (CAIAM)",
   label: "Indian Arm (CAIAM)"
  },
  {
   value: "Indian Head (CAIHD)",
   label: "Indian Head (CAIHD)"
  },
  {
   value: "Ingleside (CAISI)",
   label: "Ingleside (CAISI)"
  },
  {
   value: "Inglewood (CAIGE)",
   label: "Inglewood (CAIGE)"
  },
  {
   value: "Ingonish (CAING)",
   label: "Ingonish (CAING)"
  },
  {
   value: "Inkerman (CAIKM)",
   label: "Inkerman (CAIKM)"
  },
  {
   value: "Inkerman (CAKER)",
   label: "Inkerman (CAKER)"
  },
  {
   value: "Innerkip (CAIKP)",
   label: "Innerkip (CAIKP)"
  },
  {
   value: "Innisfail (CAINN)",
   label: "Innisfail (CAINN)"
  },
  {
   value: "Innisfil (CAISF)",
   label: "Innisfil (CAISF)"
  },
  {
   value: "Innisfree (CAINF)",
   label: "Innisfree (CAINF)"
  },
  {
   value: "Invermere (CAIVM)",
   label: "Invermere (CAIVM)"
  },
  {
   value: "Inverness (CAIVS)",
   label: "Inverness (CAIVS)"
  },
  {
   value: "Inwood (CAIWO)",
   label: "Inwood (CAIWO)"
  },
  {
   value: "Irma (CAIRM)",
   label: "Irma (CAIRM)"
  },
  {
   value: "Iron Springs (CAISP)",
   label: "Iron Springs (CAISP)"
  },
  {
   value: "Iroquois (CAIRQ)",
   label: "Iroquois (CAIRQ)"
  },
  {
   value: "Iroquois Falls (CAIQF)",
   label: "Iroquois Falls (CAIQF)"
  },
  {
   value: "Irricana (CAICA)",
   label: "Irricana (CAICA)"
  },
  {
   value: "Irvine (CAIVN)",
   label: "Irvine (CAIVN)"
  },
  {
   value: "Island Lake (CAISL)",
   label: "Island Lake (CAISL)"
  },
  {
   value: "Ituna (CAITA)",
   label: "Ituna (CAITA)"
  },
  {
   value: "Jackson Arm (CAJAC)",
   label: "Jackson Arm (CAJAC)"
  },
  {
   value: "Jacksonville (CAJAV)",
   label: "Jacksonville (CAJAV)"
  },
  {
   value: "Jarvis (CAJVS)",
   label: "Jarvis (CAJVS)"
  },
  {
   value: "High River (CAHRI)",
   label: "High River (CAHRI)"
  },
  {
   value: "Hilda (CAHID)",
   label: "Hilda (CAHID)"
  },
  {
   value: "Hillsborough (CAHIL)",
   label: "Hillsborough (CAHIL)"
  },
  {
   value: "Hillsburgh (CAHBG)",
   label: "Hillsburgh (CAHBG)"
  },
  {
   value: "Hinton (CAHNT)",
   label: "Hinton (CAHNT)"
  },
  {
   value: "Hodgeville (CAHGV)",
   label: "Hodgeville (CAHGV)"
  },
  {
   value: "Holland Landing (CAHLL)",
   label: "Holland Landing (CAHLL)"
  },
  {
   value: "Holstein (CAHST)",
   label: "Holstein (CAHST)"
  },
  {
   value: "Holyrood (CAHYO)",
   label: "Holyrood (CAHYO)"
  },
  {
   value: "Horsefly (CAHRF)",
   label: "Horsefly (CAHRF)"
  },
  {
   value: "Hudson (CAHUD)",
   label: "Hudson (CAHUD)"
  },
  {
   value: "Hull (CAHUL)",
   label: "Hull (CAHUL)"
  },
  {
   value: "Humboldt (CAHMO)",
   label: "Humboldt (CAHMO)"
  },
  {
   value: "Hunter River (CAHUR)",
   label: "Hunter River (CAHUR)"
  },
  {
   value: "Huntingdon (CAHDN)",
   label: "Huntingdon (CAHDN)"
  },
  {
   value: "Huron Park (CAHUP)",
   label: "Huron Park (CAHUP)"
  },
  {
   value: "Hythe (CAHYE)",
   label: "Hythe (CAHYE)"
  },
  {
   value: "Ilderton (CAIDO)",
   label: "Ilderton (CAIDO)"
  },
  {
   value: "Ile Aux Coudres (CAIXC)",
   label: "Ile Aux Coudres (CAIXC)"
  },
  {
   value: "Ile des Chenes (CAICS)",
   label: "Ile des Chenes (CAICS)"
  },
  {
   value: "Ile des Chenes (CAIDC)",
   label: "Ile des Chenes (CAIDC)"
  },
  {
   value: "Iles de Boucherville (CABRV)",
   label: "Iles de Boucherville (CABRV)"
  },
  {
   value: "Harcourt (CAHCT)",
   label: "Harcourt (CAHCT)"
  },
  {
   value: "Hardisty (CAHDY)",
   label: "Hardisty (CAHDY)"
  },
  {
   value: "Harley (CAHYY)",
   label: "Harley (CAHYY)"
  },
  {
   value: "Harmac (CAHMC)",
   label: "Harmac (CAHMC)"
  },
  {
   value: "Harrogate (CAHRG)",
   label: "Harrogate (CAHRG)"
  },
  {
   value: "Harrow (CAHRW)",
   label: "Harrow (CAHRW)"
  },
  {
   value: "Hartington (CAHGT)",
   label: "Hartington (CAHGT)"
  },
  {
   value: "Hartland (CAHTD)",
   label: "Hartland (CAHTD)"
  },
  {
   value: "Harty (CATYR)",
   label: "Harty (CATYR)"
  },
  {
   value: "Harvey Station (CAHRV)",
   label: "Harvey Station (CAHRV)"
  },
  {
   value: "Hastings (CATIN)",
   label: "Hastings (CATIN)"
  },
  {
   value: "Hatchet Lake (CAHCK)",
   label: "Hatchet Lake (CAHCK)"
  },
  {
   value: "Havelock (CAHAV)",
   label: "Havelock (CAHAV)"
  },
  {
   value: "Havre Boucher (CAHBC)",
   label: "Havre Boucher (CAHBC)"
  },
  {
   value: "Head of Jeddore (CAJEJ)",
   label: "Head of Jeddore (CAJEJ)"
  },
  {
   value: "Headingley (CAHDL)",
   label: "Headingley (CAHDL)"
  },
  {
   value: "Hébertville (CAHEB)",
   label: "Hébertville (CAHEB)"
  },
  {
   value: "Hemmingford (CAHMM)",
   label: "Hemmingford (CAHMM)"
  },
  {
   value: "Hensall (CAHEL)",
   label: "Hensall (CAHEL)"
  },
  {
   value: "Herschel I. (CAHLI)",
   label: "Herschel I. (CAHLI)"
  },
  {
   value: "Hickson (CAHKS)",
   label: "Hickson (CAHKS)"
  },
  {
   value: "High Bluff (CAHBL)",
   label: "High Bluff (CAHBL)"
  },
  {
   value: "Grenville (CAGRZ)",
   label: "Grenville (CAGRZ)"
  },
  {
   value: "Grimsby (CAXGY)",
   label: "Grimsby (CAXGY)"
  },
  {
   value: "Grimshaw (CAGSA)",
   label: "Grimshaw (CAGSA)"
  },
  {
   value: "Grindrod (CAGDO)",
   label: "Grindrod (CAGDO)"
  },
  {
   value: "Grosse Isle (CAGRI)",
   label: "Grosse Isle (CAGRI)"
  },
  {
   value: "Grouse Mountain (CAGRO)",
   label: "Grouse Mountain (CAGRO)"
  },
  {
   value: "Grunthal (CAGTH)",
   label: "Grunthal (CAGTH)"
  },
  {
   value: "Gull Lake (CAGLL)",
   label: "Gull Lake (CAGLL)"
  },
  {
   value: "Gunton (CAGTN)",
   label: "Gunton (CAGTN)"
  },
  {
   value: "Hacketts Cove (CAHCC)",
   label: "Hacketts Cove (CAHCC)"
  },
  {
   value: "Hadashville (CAHHV)",
   label: "Hadashville (CAHHV)"
  },
  {
   value: "Hague (CAHAG)",
   label: "Hague (CAHAG)"
  },
  {
   value: "Haileybury (CAEYL)",
   label: "Haileybury (CAEYL)"
  },
  {
   value: "Halbstadt (CAHBD)",
   label: "Halbstadt (CAHBD)"
  },
  {
   value: "Haley Station (CAHSN)",
   label: "Haley Station (CAHSN)"
  },
  {
   value: "Haliburton (CAHBT)",
   label: "Haliburton (CAHBT)"
  },
  {
   value: "Halifax Apt (CAYHZ)",
   label: "Halifax Apt (CAYHZ)"
  },
  {
   value: "Hamilton Apt (CAYHM)",
   label: "Hamilton Apt (CAYHM)"
  },
  {
   value: "Hamiota (CAHMA)",
   label: "Hamiota (CAHMA)"
  },
  {
   value: "Haney (CAHAN)",
   label: "Haney (CAHAN)"
  },
  {
   value: "Hanna (CAHNA)",
   label: "Hanna (CAHNA)"
  },
  {
   value: "Hanover (CAHVR)",
   label: "Hanover (CAHVR)"
  },
  {
   value: "Hants Harbour (CAHHB)",
   label: "Hants Harbour (CAHHB)"
  },
  {
   value: "Grenfell (CAGNF)",
   label: "Grenfell (CAGNF)"
  },
  {
   value: "Golden (CAGDN)",
   label: "Golden (CAGDN)"
  },
  {
   value: "Gormley (CAGMY)",
   label: "Gormley (CAGMY)"
  },
  {
   value: "Gorrie (CAGRR)",
   label: "Gorrie (CAGRR)"
  },
  {
   value: "Gowanstown (CAGWS)",
   label: "Gowanstown (CAGWS)"
  },
  {
   value: "Grand Falls-Windsor (CAGFA)",
   label: "Grand Falls-Windsor (CAGFA)"
  },
  {
   value: "Grand Mere (CAQGM)",
   label: "Grand Mere (CAQGM)"
  },
  {
   value: "Grand Valley (CAGRV)",
   label: "Grand Valley (CAGRV)"
  },
  {
   value: "Grand View (CAGVI)",
   label: "Grand View (CAGVI)"
  },
  {
   value: "Grande Anse (CAGAE)",
   label: "Grande Anse (CAGAE)"
  },
  {
   value: "Grande Pointe (CARPE)",
   label: "Grande Pointe (CARPE)"
  },
  {
   value: "Grande-Digue (CAEDI)",
   label: "Grande-Digue (CAEDI)"
  },
  {
   value: "Grand-Mere (CAGRM)",
   label: "Grand-Mere (CAGRM)"
  },
  {
   value: "Granton (CAGRN)",
   label: "Granton (CAGRN)"
  },
  {
   value: "Granum (CAGRU)",
   label: "Granum (CAGRU)"
  },
  {
   value: "Grassland (CAGRD)",
   label: "Grassland (CAGRD)"
  },
  {
   value: "Grassy Lake (CAGLK)",
   label: "Grassy Lake (CAGLK)"
  },
  {
   value: "Gravelbourg (CAGBG)",
   label: "Gravelbourg (CAGBG)"
  },
  {
   value: "Greenfield (CAGFL)",
   label: "Greenfield (CAGFL)"
  },
  {
   value: "Galt (CAGLT)",
   label: "Galt (CAGLT)"
  },
  {
   value: "Gardenville (CAGDV)",
   label: "Gardenville (CAGDV)"
  },
  {
   value: "Garson (CAGAR)",
   label: "Garson (CAGAR)"
  },
  {
   value: "Gaspereaux (CAGAX)",
   label: "Gaspereaux (CAGAX)"
  },
  {
   value: "Gatineau (CAGAT)",
   label: "Gatineau (CAGAT)"
  },
  {
   value: "Gem (CAGEM)",
   label: "Gem (CAGEM)"
  },
  {
   value: "Georgetown (CAGEO)",
   label: "Georgetown (CAGEO)"
  },
  {
   value: "Gerald (CAGLD)",
   label: "Gerald (CAGLD)"
  },
  {
   value: "Gibbons (CAGBO)",
   label: "Gibbons (CAGBO)"
  },
  {
   value: "Girouxville (CAGXI)",
   label: "Girouxville (CAGXI)"
  },
  {
   value: "Glen Huron (CAGHU)",
   label: "Glen Huron (CAGHU)"
  },
  {
   value: "Glen Morris (CAGMO)",
   label: "Glen Morris (CAGMO)"
  },
  {
   value: "Glenbush (CAGBU)",
   label: "Glenbush (CAGBU)"
  },
  {
   value: "Glencoe (CAGLE)",
   label: "Glencoe (CAGLE)"
  },
  {
   value: "Glendon (CAGNO)",
   label: "Glendon (CAGNO)"
  },
  {
   value: "Glenwood (CAGWD)",
   label: "Glenwood (CAGWD)"
  },
  {
   value: "Gloucester (CAGCR)",
   label: "Gloucester (CAGCR)"
  },
  {
   value: "Glovertown (CAGVN)",
   label: "Glovertown (CAGVN)"
  },
  {
   value: "Gold River (CAGOL)",
   label: "Gold River (CAGOL)"
  },
  {
   value: "Fort Providence (CAFPR)",
   label: "Fort Providence (CAFPR)"
  },
  {
   value: "Fort Saskatchewan (CAFSK)",
   label: "Fort Saskatchewan (CAFSK)"
  },
  {
   value: "Fort Steele (CAFST)",
   label: "Fort Steele (CAFST)"
  },
  {
   value: "Fort Vermilion (CAFVE)",
   label: "Fort Vermilion (CAFVE)"
  },
  {
   value: "Fort Ware (CAWAR)",
   label: "Fort Ware (CAWAR)"
  },
  {
   value: "Fort William (CAFWL)",
   label: "Fort William (CAFWL)"
  },
  {
   value: "Fox Creek (CAFXC)",
   label: "Fox Creek (CAFXC)"
  },
  {
   value: "Fox Lake (CAFLK)",
   label: "Fox Lake (CAFLK)"
  },
  {
   value: "Fox River (=riviere-Au-Renard) (CAQCF)",
   label: "Fox River (=riviere-Au-Renard) (CAQCF)"
  },
  {
   value: "Foxboro (CAFXO)",
   label: "Foxboro (CAFXO)"
  },
  {
   value: "Foxley River (CAFOX)",
   label: "Foxley River (CAFOX)"
  },
  {
   value: "François Lake (CAFRL)",
   label: "François Lake (CAFRL)"
  },
  {
   value: "Frankford (CAFKO)",
   label: "Frankford (CAFKO)"
  },
  {
   value: "Fraser (CAFRM)",
   label: "Fraser (CAFRM)"
  },
  {
   value: "Fraser Mills (CAFRA)",
   label: "Fraser Mills (CAFRA)"
  },
  {
   value: "Fraser Wharves (CAFWS)",
   label: "Fraser Wharves (CAFWS)"
  },
  {
   value: "Fraser-Surrey Docks (CAFSD)",
   label: "Fraser-Surrey Docks (CAFSD)"
  },
  {
   value: "Freelton (CAFRT)",
   label: "Freelton (CAFRT)"
  },
  {
   value: "Frelighsburg (CAFGH)",
   label: "Frelighsburg (CAFGH)"
  },
  {
   value: "Fort Macleod (CAFMC)",
   label: "Fort Macleod (CAFMC)"
  },
  {
   value: "Farnham (CAFAR)",
   label: "Farnham (CAFAR)"
  },
  {
   value: "Farnham (CAFRN)",
   label: "Farnham (CAFRN)"
  },
  {
   value: "Ferintosh (CAFTO)",
   label: "Ferintosh (CAFTO)"
  },
  {
   value: "Ferme-Neuve (CAFNV)",
   label: "Ferme-Neuve (CAFNV)"
  },
  {
   value: "Fermeuse (CAFME)",
   label: "Fermeuse (CAFME)"
  },
  {
   value: "Fernie (CAFNI)",
   label: "Fernie (CAFNI)"
  },
  {
   value: "Feversham (CAFFE)",
   label: "Feversham (CAFFE)"
  },
  {
   value: "Fillmore (CAFMO)",
   label: "Fillmore (CAFMO)"
  },
  {
   value: "Fingal (CAFGA)",
   label: "Fingal (CAFGA)"
  },
  {
   value: "Fisher Branch (CAFIB)",
   label: "Fisher Branch (CAFIB)"
  },
  {
   value: "Florence (CAXFL)",
   label: "Florence (CAXFL)"
  },
  {
   value: "Fordwich (CAFWI)",
   label: "Fordwich (CAFWI)"
  },
  {
   value: "Foremost (CAFOM)",
   label: "Foremost (CAFOM)"
  },
  {
   value: "Forest (CAZFT)",
   label: "Forest (CAZFT)"
  },
  {
   value: "Forestburg (CAFBG)",
   label: "Forestburg (CAFBG)"
  },
  {
   value: "Formosa (CAFMS)",
   label: "Formosa (CAFMS)"
  },
  {
   value: "Fort Coulonge (CAFCO)",
   label: "Fort Coulonge (CAFCO)"
  },
  {
   value: "Fort Franklin (CAFKN)",
   label: "Fort Franklin (CAFKN)"
  },
  {
   value: "Fort MacKay (CAFMA)",
   label: "Fort MacKay (CAFMA)"
  },
  {
   value: "Fanny Bay (CAFYB)",
   label: "Fanny Bay (CAFYB)"
  },
  {
   value: "Elora (CAELO)",
   label: "Elora (CAELO)"
  },
  {
   value: "Elrose (CAOSE)",
   label: "Elrose (CAOSE)"
  },
  {
   value: "Embro (CAEMB)",
   label: "Embro (CAEMB)"
  },
  {
   value: "Embrun (CAEBU)",
   label: "Embrun (CAEBU)"
  },
  {
   value: "Emerson (CAEME)",
   label: "Emerson (CAEME)"
  },
  {
   value: "Emeryville (CAEYV)",
   label: "Emeryville (CAEYV)"
  },
  {
   value: "Empress (CAEMP)",
   label: "Empress (CAEMP)"
  },
  {
   value: "Endako (CAEND)",
   label: "Endako (CAEND)"
  },
  {
   value: "Enderby (CAENY)",
   label: "Enderby (CAENY)"
  },
  {
   value: "Enfield (CAENF)",
   label: "Enfield (CAENF)"
  },
  {
   value: "Engelwood (CAENG)",
   label: "Engelwood (CAENG)"
  },
  {
   value: "Englefeld (CAEGF)",
   label: "Englefeld (CAEGF)"
  },
  {
   value: "English Bay (CAEBY)",
   label: "English Bay (CAEBY)"
  },
  {
   value: "Entwistle (CAENT)",
   label: "Entwistle (CAENT)"
  },
  {
   value: "Erickson (CAEKO)",
   label: "Erickson (CAEKO)"
  },
  {
   value: "Errington (CAEGT)",
   label: "Errington (CAEGT)"
  },
  {
   value: "Espanola (CAEPA)",
   label: "Espanola (CAEPA)"
  },
  {
   value: "Etang-du-Nord (CAETN)",
   label: "Etang-du-Nord (CAETN)"
  },
  {
   value: "Exeter (CAEXX)",
   label: "Exeter (CAEXX)"
  },
  {
   value: "Exshaw (CAEXS)",
   label: "Exshaw (CAEXS)"
  },
  {
   value: "Fabreville (CAFVL)",
   label: "Fabreville (CAFVL)"
  },
  {
   value: "Fairmont Hot Springs (CAFHS)",
   label: "Fairmont Hot Springs (CAFHS)"
  },
  {
   value: "Falconbridge (CAFCB)",
   label: "Falconbridge (CAFCB)"
  },
  {
   value: "Falkland (CAFLA)",
   label: "Falkland (CAFLA)"
  },
  {
   value: "Fall River (CAFLR)",
   label: "Fall River (CAFLR)"
  },
  {
   value: "Falmouth (CAFAH)",
   label: "Falmouth (CAFAH)"
  },
  {
   value: "Elmvale (CAEVV)",
   label: "Elmvale (CAEVV)"
  },
  {
   value: "Duffield (CADFL)",
   label: "Duffield (CADFL)"
  },
  {
   value: "Duncan Bay (CADCN)",
   label: "Duncan Bay (CADCN)"
  },
  {
   value: "Dundalk (CADNK)",
   label: "Dundalk (CADNK)"
  },
  {
   value: "Dundurn (CADDN)",
   label: "Dundurn (CADDN)"
  },
  {
   value: "Dunman (CADHQ)",
   label: "Dunman (CADHQ)"
  },
  {
   value: "Dunmore (CADNM)",
   label: "Dunmore (CADNM)"
  },
  {
   value: "Dunrea (CADRA)",
   label: "Dunrea (CADRA)"
  },
  {
   value: "Dutton (CADUO)",
   label: "Dutton (CADUO)"
  },
  {
   value: "East Angus (CAEAG)",
   label: "East Angus (CAEAG)"
  },
  {
   value: "East Angus (CAETA)",
   label: "East Angus (CAETA)"
  },
  {
   value: "East Gwillimbury (CAGWY)",
   label: "East Gwillimbury (CAGWY)"
  },
  {
   value: "East Kemptville (CAEKE)",
   label: "East Kemptville (CAEKE)"
  },
  {
   value: "East St Paul (CAEPL)",
   label: "East St Paul (CAEPL)"
  },
  {
   value: "East York (CAEAS)",
   label: "East York (CAEAS)"
  },
  {
   value: "Eckville (CAEKV)",
   label: "Eckville (CAEKV)"
  },
  {
   value: "Economy (CAECO)",
   label: "Economy (CAECO)"
  },
  {
   value: "Edmonton Int Apt (CAYEG)",
   label: "Edmonton Int Apt (CAYEG)"
  },
  {
   value: "Edmundston (CAEDN)",
   label: "Edmundston (CAEDN)"
  },
  {
   value: "Edwards Cove (CAEDC)",
   label: "Edwards Cove (CAEDC)"
  },
  {
   value: "Elgin (CAEGN)",
   label: "Elgin (CAEGN)"
  },
  {
   value: "Elie (CAELI)",
   label: "Elie (CAELI)"
  },
  {
   value: "Elizabethtown (CAEZT)",
   label: "Elizabethtown (CAEZT)"
  },
  {
   value: "Elkford (CAEKF)",
   label: "Elkford (CAEKF)"
  },
  {
   value: "Elkhorn (CAEHO)",
   label: "Elkhorn (CAEHO)"
  },
  {
   value: "Ellerslie (CAELS)",
   label: "Ellerslie (CAELS)"
  },
  {
   value: "Ellerslie\/Edmonton (CAELL)",
   label: "Ellerslie\/Edmonton (CAELL)"
  },
  {
   value: "Elmira (CAEMR)",
   label: "Elmira (CAEMR)"
  },
  {
   value: "Elmsdale (CAELE)",
   label: "Elmsdale (CAELE)"
  },
  {
   value: "Dublin (CADLN)",
   label: "Dublin (CADLN)"
  },
  {
   value: "Delisle (CALIS)",
   label: "Delisle (CALIS)"
  },
  {
   value: "Deloraine (CADRN)",
   label: "Deloraine (CADRN)"
  },
  {
   value: "Delson\/Quebec (CADLS)",
   label: "Delson\/Quebec (CADLS)"
  },
  {
   value: "Denfield (CADFI)",
   label: "Denfield (CADFI)"
  },
  {
   value: "Denman Island (CADSA)",
   label: "Denman Island (CADSA)"
  },
  {
   value: "Desboro (CADSO)",
   label: "Desboro (CADSO)"
  },
  {
   value: "Deschambault (CADBT)",
   label: "Deschambault (CADBT)"
  },
  {
   value: "Diamond City (CADIC)",
   label: "Diamond City (CADIC)"
  },
  {
   value: "Didsbury (CADID)",
   label: "Didsbury (CADID)"
  },
  {
   value: "Dilke (CADLK)",
   label: "Dilke (CADLK)"
  },
  {
   value: "Doaktown (CADOA)",
   label: "Doaktown (CADOA)"
  },
  {
   value: "Dobbinton (CADTO)",
   label: "Dobbinton (CADTO)"
  },
  {
   value: "Dollard-des-Ormeaux (CADDO)",
   label: "Dollard-des-Ormeaux (CADDO)"
  },
  {
   value: "Don Mills (CADOM)",
   label: "Don Mills (CADOM)"
  },
  {
   value: "Dorchester (CADCS)",
   label: "Dorchester (CADCS)"
  },
  {
   value: "Drayton (CADYT)",
   label: "Drayton (CADYT)"
  },
  {
   value: "Dresden (CADRD)",
   label: "Dresden (CADRD)"
  },
  {
   value: "Drumheller (CADRM)",
   label: "Drumheller (CADRM)"
  },
  {
   value: "Drummond (CADMO)",
   label: "Drummond (CADMO)"
  },
  {
   value: "Delaware (CADWR)",
   label: "Delaware (CADWR)"
  },
  {
   value: "Crabtree (CATRE)",
   label: "Crabtree (CATRE)"
  },
  {
   value: "Crapaud (CACRD)",
   label: "Crapaud (CACRD)"
  },
  {
   value: "Creemore (CACMO)",
   label: "Creemore (CACMO)"
  },
  {
   value: "Creemore (CACRM)",
   label: "Creemore (CACRM)"
  },
  {
   value: "Creston (CACFQ)",
   label: "Creston (CACFQ)"
  },
  {
   value: "Crossfield (CACSF)",
   label: "Crossfield (CACSF)"
  },
  {
   value: "Crysler (CACYS)",
   label: "Crysler (CACYS)"
  },
  {
   value: "Crystal Beach (CACBE)",
   label: "Crystal Beach (CACBE)"
  },
  {
   value: "Crystal City (CACCI)",
   label: "Crystal City (CACCI)"
  },
  {
   value: "Cumberland Bay (CACUM)",
   label: "Cumberland Bay (CACUM)"
  },
  {
   value: "Cupids (CACPS)",
   label: "Cupids (CACPS)"
  },
  {
   value: "Dacre (CADAC)",
   label: "Dacre (CADAC)"
  },
  {
   value: "Danville (CADVL)",
   label: "Danville (CADVL)"
  },
  {
   value: "Dartmouth (CADAR)",
   label: "Dartmouth (CADAR)"
  },
  {
   value: "Dashwood (CADWO)",
   label: "Dashwood (CADWO)"
  },
  {
   value: "Daveluyville (CADYV)",
   label: "Daveluyville (CADYV)"
  },
  {
   value: "Davidson (CADVO)",
   label: "Davidson (CADVO)"
  },
  {
   value: "Debert Station (CADET)",
   label: "Debert Station (CADET)"
  },
  {
   value: "Debolt (CADBL)",
   label: "Debolt (CADBL)"
  },
  {
   value: "Decker (CADEC)",
   label: "Decker (CADEC)"
  },
  {
   value: "Cowansville (CACOW)",
   label: "Cowansville (CACOW)"
  },
  {
   value: "Comfort Cove (CACCV)",
   label: "Comfort Cove (CACCV)"
  },
  {
   value: "Compton (CACMP)",
   label: "Compton (CACMP)"
  },
  {
   value: "Conklin (CACNN)",
   label: "Conklin (CACNN)"
  },
  {
   value: "Conquitlam (CACQT)",
   label: "Conquitlam (CACQT)"
  },
  {
   value: "Cookshire (CACKS)",
   label: "Cookshire (CACKS)"
  },
  {
   value: "Cookstown (CACSW)",
   label: "Cookstown (CACSW)"
  },
  {
   value: "Cooksville (CACVI)",
   label: "Cooksville (CACVI)"
  },
  {
   value: "Coombs (CACOO)",
   label: "Coombs (CACOO)"
  },
  {
   value: "Cooper Cliff (CACFL)",
   label: "Cooper Cliff (CACFL)"
  },
  {
   value: "Copper Cliff (CACPC)",
   label: "Copper Cliff (CACPC)"
  },
  {
   value: "Cornhill (CACNH)",
   label: "Cornhill (CACNH)"
  },
  {
   value: "Cornwallis (CACWS)",
   label: "Cornwallis (CACWS)"
  },
  {
   value: "Coteau du Lac (CACQA)",
   label: "Coteau du Lac (CACQA)"
  },
  {
   value: "Côte-St-Luc (CACSU)",
   label: "Côte-St-Luc (CACSU)"
  },
  {
   value: "Cottam (CACTA)",
   label: "Cottam (CACTA)"
  },
  {
   value: "Courtland (CACLN)",
   label: "Courtland (CACLN)"
  },
  {
   value: "Coutts (CACTS)",
   label: "Coutts (CACTS)"
  },
  {
   value: "Cow Head (CACWH)",
   label: "Cow Head (CACWH)"
  },
  {
   value: "Clandeboye (CACYE)",
   label: "Clandeboye (CACYE)"
  },
  {
   value: "Claremont (CACLM)",
   label: "Claremont (CACLM)"
  },
  {
   value: "Clarence Creek (CACCK)",
   label: "Clarence Creek (CACCK)"
  },
  {
   value: "Clarenceville (CACLA)",
   label: "Clarenceville (CACLA)"
  },
  {
   value: "Claresholm (CACSO)",
   label: "Claresholm (CACSO)"
  },
  {
   value: "Clarksburg (CACSB)",
   label: "Clarksburg (CACSB)"
  },
  {
   value: "Clearbrook (CACOK)",
   label: "Clearbrook (CACOK)"
  },
  {
   value: "Clearwater (CACWT)",
   label: "Clearwater (CACWT)"
  },
  {
   value: "Clementsport (CACSP)",
   label: "Clementsport (CACSP)"
  },
  {
   value: "Cleveland (CACVA)",
   label: "Cleveland (CACVA)"
  },
  {
   value: "Clifford (CALLF)",
   label: "Clifford (CALLF)"
  },
  {
   value: "Clinton (CACON)",
   label: "Clinton (CACON)"
  },
  {
   value: "Cloverdale (CACVD)",
   label: "Cloverdale (CACVD)"
  },
  {
   value: "Cluny (CACNY)",
   label: "Cluny (CACNY)"
  },
  {
   value: "Coal Harbour (CACAU)",
   label: "Coal Harbour (CACAU)"
  },
  {
   value: "Coaticook (CACOA)",
   label: "Coaticook (CACOA)"
  },
  {
   value: "Cobble Hill (CACHL)",
   label: "Cobble Hill (CACHL)"
  },
  {
   value: "Cobourg (CACBG)",
   label: "Cobourg (CACBG)"
  },
  {
   value: "Cocagne (CACOE)",
   label: "Cocagne (CACOE)"
  },
  {
   value: "Cochrane (CACCH)",
   label: "Cochrane (CACCH)"
  },
  {
   value: "Coldbrook (CACDB)",
   label: "Coldbrook (CACDB)"
  },
  {
   value: "Coleman (CACEM)",
   label: "Coleman (CACEM)"
  },
  {
   value: "Colonsay (CACOY)",
   label: "Colonsay (CACOY)"
  },
  {
   value: "Clairmont (CACMT)",
   label: "Clairmont (CACMT)"
  },
  {
   value: "Charing Cross (CACGS)",
   label: "Charing Cross (CACGS)"
  },
  {
   value: "Charlesbourg (CACHG)",
   label: "Charlesbourg (CACHG)"
  },
  {
   value: "Charny (CACRY)",
   label: "Charny (CACRY)"
  },
  {
   value: "Chartierville (CACTL)",
   label: "Chartierville (CACTL)"
  },
  {
   value: "Chase (CAHAS)",
   label: "Chase (CAHAS)"
  },
  {
   value: "Châteauguay (CACGY)",
   label: "Châteauguay (CACGY)"
  },
  {
   value: "Chepstow (CACPW)",
   label: "Chepstow (CACPW)"
  },
  {
   value: "Cherryville (CACHE)",
   label: "Cherryville (CACHE)"
  },
  {
   value: "Chertsey (CACTY)",
   label: "Chertsey (CACTY)"
  },
  {
   value: "Chesley (CACEY)",
   label: "Chesley (CACEY)"
  },
  {
   value: "Chesterville (CACVE)",
   label: "Chesterville (CACVE)"
  },
  {
   value: "Chesterville (CACVL)",
   label: "Chesterville (CACVL)"
  },
  {
   value: "Chipman (CACPN)",
   label: "Chipman (CACPN)"
  },
  {
   value: "Churchbridge (CACBI)",
   label: "Churchbridge (CACBI)"
  },
  {
   value: "Churchill (CACHH)",
   label: "Churchill (CACHH)"
  },
  {
   value: "Cargill (CACGL)",
   label: "Cargill (CACGL)"
  },
  {
   value: "Carignan (CACGN)",
   label: "Carignan (CACGN)"
  },
  {
   value: "Carlisle (CACLS)",
   label: "Carlisle (CACLS)"
  },
  {
   value: "Carman (CACMN)",
   label: "Carman (CACMN)"
  },
  {
   value: "Caroline (CACRN)",
   label: "Caroline (CACRN)"
  },
  {
   value: "Carp (CACRP)",
   label: "Carp (CACRP)"
  },
  {
   value: "Carseland (CACLD)",
   label: "Carseland (CACLD)"
  },
  {
   value: "Carstairs (CACTI)",
   label: "Carstairs (CACTI)"
  },
  {
   value: "Cartier (CARTE)",
   label: "Cartier (CARTE)"
  },
  {
   value: "Carvel (CACRV)",
   label: "Carvel (CACRV)"
  },
  {
   value: "Casselman (CACSS)",
   label: "Casselman (CACSS)"
  },
  {
   value: "Cassidy (CACSD)",
   label: "Cassidy (CACSD)"
  },
  {
   value: "Castleton (CACTT)",
   label: "Castleton (CACTT)"
  },
  {
   value: "Castor (CACSR)",
   label: "Castor (CACSR)"
  },
  {
   value: "Cavendish (CACAV)",
   label: "Cavendish (CACAV)"
  },
  {
   value: "Cawston (CACWO)",
   label: "Cawston (CACWO)"
  },
  {
   value: "Cayuga (CACYG)",
   label: "Cayuga (CACYG)"
  },
  {
   value: "Centre I. (CACIS)",
   label: "Centre I. (CACIS)"
  },
  {
   value: "Centreville (CACEN)",
   label: "Centreville (CACEN)"
  },
  {
   value: "Centreville (CACTV)",
   label: "Centreville (CACTV)"
  },
  {
   value: "Centreville (CANLC)",
   label: "Centreville (CANLC)"
  },
  {
   value: "Chamberlains (CACBL)",
   label: "Chamberlains (CACBL)"
  },
  {
   value: "Chambord (CACMB)",
   label: "Chambord (CACMB)"
  },
  {
   value: "Change Islands (CACIL)",
   label: "Change Islands (CACIL)"
  },
  {
   value: "Cambridge Station (CACAS)",
   label: "Cambridge Station (CACAS)"
  },
  {
   value: "Campbell Croft (CACCF)",
   label: "Campbell Croft (CACCF)"
  },
  {
   value: "Campbellford (CACBF)",
   label: "Campbellford (CACBF)"
  },
  {
   value: "Campbellville (CACBV)",
   label: "Campbellville (CACBV)"
  },
  {
   value: "Canal Flats (CAFTS)",
   label: "Canal Flats (CAFTS)"
  },
  {
   value: "Candiac (CACDC)",
   label: "Candiac (CACDC)"
  },
  {
   value: "Canfield (CACFD)",
   label: "Canfield (CACFD)"
  },
  {
   value: "Canim Lake (CACML)",
   label: "Canim Lake (CACML)"
  },
  {
   value: "Canmore (CACNM)",
   label: "Canmore (CACNM)"
  },
  {
   value: "Canning (CACAG)",
   label: "Canning (CACAG)"
  },
  {
   value: "Cannington (CACNT)",
   label: "Cannington (CACNT)"
  },
  {
   value: "Canora (CACNA)",
   label: "Canora (CACNA)"
  },
  {
   value: "Canyon Creek (CACAY)",
   label: "Canyon Creek (CACAY)"
  },
  {
   value: "Cap-aux-Meules (CACMS)",
   label: "Cap-aux-Meules (CACMS)"
  },
  {
   value: "Cap-de-la-Madeleine (CACME)",
   label: "Cap-de-la-Madeleine (CACME)"
  },
  {
   value: "Cape Ray (CACPY)",
   label: "Cape Ray (CACPY)"
  },
  {
   value: "Cape Tormentine (CACTO)",
   label: "Cape Tormentine (CACTO)"
  },
  {
   value: "Cap-St-Ignace (CACSI)",
   label: "Cap-St-Ignace (CACSI)"
  },
  {
   value: "Carberry (CACBY)",
   label: "Carberry (CACBY)"
  },
  {
   value: "Carbon (CACBN)",
   label: "Carbon (CACBN)"
  },
  {
   value: "Cardigan (CACDG)",
   label: "Cardigan (CACDG)"
  },
  {
   value: "Brownlee (CABNL)",
   label: "Brownlee (CABNL)"
  },
  {
   value: "Brownsburg (CAOWN)",
   label: "Brownsburg (CAOWN)"
  },
  {
   value: "Brownsburg-Chatham (CABRJ)",
   label: "Brownsburg-Chatham (CABRJ)"
  },
  {
   value: "Bruderheim (CABDH)",
   label: "Bruderheim (CABDH)"
  },
  {
   value: "Brunner (CABNR)",
   label: "Brunner (CABNR)"
  },
  {
   value: "Bull Arm (CABUA)",
   label: "Bull Arm (CABUA)"
  },
  {
   value: "Bull River (CABUL)",
   label: "Bull River (CABUL)"
  },
  {
   value: "Bulyea (CABYA)",
   label: "Bulyea (CABYA)"
  },
  {
   value: "Burdett (CABDT)",
   label: "Burdett (CABDT)"
  },
  {
   value: "Burford (CABUD)",
   label: "Burford (CABUD)"
  },
  {
   value: "Burks Falls (CABUK)",
   label: "Burks Falls (CABUK)"
  },
  {
   value: "Burnaby (CABUB)",
   label: "Burnaby (CABUB)"
  },
  {
   value: "Burrard Inlet (CABIN)",
   label: "Burrard Inlet (CABIN)"
  },
  {
   value: "Burton (CABON)",
   label: "Burton (CABON)"
  },
  {
   value: "Burtts Corner (CABCR)",
   label: "Burtts Corner (CABCR)"
  },
  {
   value: "Cabano (CACBO)",
   label: "Cabano (CACBO)"
  },
  {
   value: "Cacouna (CACCA)",
   label: "Cacouna (CACCA)"
  },
  {
   value: "Caistor Centre (CACCT)",
   label: "Caistor Centre (CACCT)"
  },
  {
   value: "Caledon (CACDA)",
   label: "Caledon (CACDA)"
  },
  {
   value: "Caledonia (CACAD)",
   label: "Caledonia (CACAD)"
  },
  {
   value: "Calgary Apt (CAYYC)",
   label: "Calgary Apt (CAYYC)"
  },
  {
   value: "Calmar (CACMR)",
   label: "Calmar (CACMR)"
  },
  {
   value: "Bouctouche (CABUE)",
   label: "Bouctouche (CABUE)"
  },
  {
   value: "Bow Island (CABWI)",
   label: "Bow Island (CABWI)"
  },
  {
   value: "Bowden (CABOW)",
   label: "Bowden (CABOW)"
  },
  {
   value: "Bowen I. (CABNI)",
   label: "Bowen I. (CABNI)"
  },
  {
   value: "Boyle (CABOY)",
   label: "Boyle (CABOY)"
  },
  {
   value: "Bracebridge (CABRB)",
   label: "Bracebridge (CABRB)"
  },
  {
   value: "Bragg Creek (CABCE)",
   label: "Bragg Creek (CABCE)"
  },
  {
   value: "Breadalbane (CABBA)",
   label: "Breadalbane (CABBA)"
  },
  {
   value: "Brentwood Bay (CABRD)",
   label: "Brentwood Bay (CABRD)"
  },
  {
   value: "Breslau (CABSU)",
   label: "Breslau (CABSU)"
  },
  {
   value: "Bridesville (CABIE)",
   label: "Bridesville (CABIE)"
  },
  {
   value: "Bridge Lake (CABLE)",
   label: "Bridge Lake (CABLE)"
  },
  {
   value: "Bridgetown (CABTN)",
   label: "Bridgetown (CABTN)"
  },
  {
   value: "Brighton (CABGH)",
   label: "Brighton (CABGH)"
  },
  {
   value: "Bristol (CABSL)",
   label: "Bristol (CABSL)"
  },
  {
   value: "Bristol (CABTO)",
   label: "Bristol (CABTO)"
  },
  {
   value: "Brocket (CABKA)",
   label: "Brocket (CABKA)"
  },
  {
   value: "Brodhagen (CABHG)",
   label: "Brodhagen (CABHG)"
  },
  {
   value: "Bromptonville (CABTV)",
   label: "Bromptonville (CABTV)"
  },
  {
   value: "Brookfield (CABFD)",
   label: "Brookfield (CABFD)"
  },
  {
   value: "Brooklin (CABRK)",
   label: "Brooklin (CABRK)"
  },
  {
   value: "Brooks (CABKS)",
   label: "Brooks (CABKS)"
  },
  {
   value: "Birds Hill (CABHI)",
   label: "Birds Hill (CABHI)"
  },
  {
   value: "Bishops Falls (CABHF)",
   label: "Bishops Falls (CABHF)"
  },
  {
   value: "Black Diamond (CABDM)",
   label: "Black Diamond (CABDM)"
  },
  {
   value: "Black Lake (CABKL)",
   label: "Black Lake (CABKL)"
  },
  {
   value: "Blackfalds (CABKF)",
   label: "Blackfalds (CABKF)"
  },
  {
   value: "Blackie (CABKI)",
   label: "Blackie (CABKI)"
  },
  {
   value: "Blackstock (CABSK)",
   label: "Blackstock (CABSK)"
  },
  {
   value: "Blackville (CABKV)",
   label: "Blackville (CABKV)"
  },
  {
   value: "Blenheim (CABHM)",
   label: "Blenheim (CABHM)"
  },
  {
   value: "Bloomfield (CABMI)",
   label: "Bloomfield (CABMI)"
  },
  {
   value: "Bluffton (CABFT)",
   label: "Bluffton (CABFT)"
  },
  {
   value: "Blumenort (CABMN)",
   label: "Blumenort (CABMN)"
  },
  {
   value: "Bobcaygeon (CABOB)",
   label: "Bobcaygeon (CABOB)"
  },
  {
   value: "Boiestown (CABOI)",
   label: "Boiestown (CABOI)"
  },
  {
   value: "Boisbriand (CABBD)",
   label: "Boisbriand (CABBD)"
  },
  {
   value: "Bois-des-Filion (CABFI)",
   label: "Bois-des-Filion (CABFI)"
  },
  {
   value: "Boissevain (CABSS)",
   label: "Boissevain (CABSS)"
  },
  {
   value: "Bon Accord (CABAC)",
   label: "Bon Accord (CABAC)"
  },
  {
   value: "Bon Conseil (CABCL)",
   label: "Bon Conseil (CABCL)"
  },
  {
   value: "Borden (CABOR)",
   label: "Borden (CABOR)"
  },
  {
   value: "Bornholm (CABNM)",
   label: "Bornholm (CABNM)"
  },
  {
   value: "Biggar (CABIR)",
   label: "Biggar (CABIR)"
  },
  {
   value: "Beamsville (CABMV)",
   label: "Beamsville (CABMV)"
  },
  {
   value: "Bear Island (CABEI)",
   label: "Bear Island (CABEI)"
  },
  {
   value: "Bearskin Lake (CABKK)",
   label: "Bearskin Lake (CABKK)"
  },
  {
   value: "Beauharnois (CABHA)",
   label: "Beauharnois (CABHA)"
  },
  {
   value: "Beaumont (CABET)",
   label: "Beaumont (CABET)"
  },
  {
   value: "Beauport (CABPT)",
   label: "Beauport (CABPT)"
  },
  {
   value: "Beauséjour (CABSJ)",
   label: "Beauséjour (CABSJ)"
  },
  {
   value: "Beaverlodge (CABLO)",
   label: "Beaverlodge (CABLO)"
  },
  {
   value: "Bedeque (CABEQ)",
   label: "Bedeque (CABEQ)"
  },
  {
   value: "Bedford (CABDF)",
   label: "Bedford (CABDF)"
  },
  {
   value: "Beechy (CABCY)",
   label: "Beechy (CABCY)"
  },
  {
   value: "Beeton (CABEN)",
   label: "Beeton (CABEN)"
  },
  {
   value: "Belfountain (CABTA)",
   label: "Belfountain (CABTA)"
  },
  {
   value: "Belle Plaine (CABPL)",
   label: "Belle Plaine (CABPL)"
  },
  {
   value: "Belleisle Creek (CAEEK)",
   label: "Belleisle Creek (CAEEK)"
  },
  {
   value: "Bellevue (CABVU)",
   label: "Bellevue (CABVU)"
  },
  {
   value: "Belmont (CABLM)",
   label: "Belmont (CABLM)"
  },
  {
   value: "Beresford (CABFR)",
   label: "Beresford (CABFR)"
  },
  {
   value: "Bernard (CABBN)",
   label: "Bernard (CABBN)"
  },
  {
   value: "Berry Mills (CABMS)",
   label: "Berry Mills (CABMS)"
  },
  {
   value: "Berthier-sur-Mer (CABSM)",
   label: "Berthier-sur-Mer (CABSM)"
  },
  {
   value: "Berwick (CABWK)",
   label: "Berwick (CABWK)"
  },
  {
   value: "Bethany (CABTY)",
   label: "Bethany (CABTY)"
  },
  {
   value: "Bickerton West (CABTW)",
   label: "Bickerton West (CABTW)"
  },
  {
   value: "Big Lake Ranch (CABKR)",
   label: "Big Lake Ranch (CABKR)"
  },
  {
   value: "Beaconsfield (CABCF)",
   label: "Beaconsfield (CABCF)"
  },
  {
   value: "Baie-Sainte-Anne (CABSA)",
   label: "Baie-Sainte-Anne (CABSA)"
  },
  {
   value: "Baie-St-Paul (CABSP)",
   label: "Baie-St-Paul (CABSP)"
  },
  {
   value: "Bairdsville (CABDI)",
   label: "Bairdsville (CABDI)"
  },
  {
   value: "Baker Lake (CABLK)",
   label: "Baker Lake (CABLK)"
  },
  {
   value: "Balckstock (CABLS)",
   label: "Balckstock (CABLS)"
  },
  {
   value: "Bald Rock (CABDR)",
   label: "Bald Rock (CABDR)"
  },
  {
   value: "Balzac (CABZC)",
   label: "Balzac (CABZC)"
  },
  {
   value: "Bancroft (CABCT)",
   label: "Bancroft (CABCT)"
  },
  {
   value: "Bar River (CABIV)",
   label: "Bar River (CABIV)"
  },
  {
   value: "Barrhead (CABRH)",
   label: "Barrhead (CABRH)"
  },
  {
   value: "Barrière (CABRR)",
   label: "Barrière (CABRR)"
  },
  {
   value: "Barrington (CABAN)",
   label: "Barrington (CABAN)"
  },
  {
   value: "Bashaw (CABHW)",
   label: "Bashaw (CABHW)"
  },
  {
   value: "Bassano (CABNO)",
   label: "Bassano (CABNO)"
  },
  {
   value: "Batawa (CABAW)",
   label: "Batawa (CABAW)"
  },
  {
   value: "Battleford (CABLF)",
   label: "Battleford (CABLF)"
  },
  {
   value: "Bay de Verde (CABDV)",
   label: "Bay de Verde (CABDV)"
  },
  {
   value: "Bay Tree (CABYT)",
   label: "Bay Tree (CABYT)"
  },
  {
   value: "Bayfield (CABYD)",
   label: "Bayfield (CABYD)"
  },
  {
   value: "Bayfield (CABYL)",
   label: "Bayfield (CABYL)"
  },
  {
   value: "Bayside, Charlotte (CABST)",
   label: "Bayside, Charlotte (CABST)"
  },
  {
   value: "Beach Point (CABPO)",
   label: "Beach Point (CABPO)"
  },
  {
   value: "Arnprior (CAANP)",
   label: "Arnprior (CAANP)"
  },
  {
   value: "Arthur (CAATH)",
   label: "Arthur (CAATH)"
  },
  {
   value: "Arundel (CAARU)",
   label: "Arundel (CAARU)"
  },
  {
   value: "Asbestos (CAASB)",
   label: "Asbestos (CAASB)"
  },
  {
   value: "Ashburn (CAABH)",
   label: "Ashburn (CAABH)"
  },
  {
   value: "Asquith (CAASQ)",
   label: "Asquith (CAASQ)"
  },
  {
   value: "Assiniboia (CAABO)",
   label: "Assiniboia (CAABO)"
  },
  {
   value: "Astra (CAATA)",
   label: "Astra (CAATA)"
  },
  {
   value: "Athabasca (CAATB)",
   label: "Athabasca (CAATB)"
  },
  {
   value: "Atholville (CAALV)",
   label: "Atholville (CAALV)"
  },
  {
   value: "Atlin (CAATL)",
   label: "Atlin (CAATL)"
  },
  {
   value: "Atwood (CAAWD)",
   label: "Atwood (CAAWD)"
  },
  {
   value: "Aulac (CAAUL)",
   label: "Aulac (CAAUL)"
  },
  {
   value: "Aulds Cove (CAACO)",
   label: "Aulds Cove (CAACO)"
  },
  {
   value: "Austin (CAAUQ)",
   label: "Austin (CAAUQ)"
  },
  {
   value: "Avonlea (CAAVL)",
   label: "Avonlea (CAAVL)"
  },
  {
   value: "Avonport (CAAVP)",
   label: "Avonport (CAAVP)"
  },
  {
   value: "Aylesford (CAAYD)",
   label: "Aylesford (CAAYD)"
  },
  {
   value: "Aylmer (CAAYM)",
   label: "Aylmer (CAAYM)"
  },
  {
   value: "Aylsham (CAAYH)",
   label: "Aylsham (CAAYH)"
  },
  {
   value: "Ayr (CAAYR)",
   label: "Ayr (CAAYR)"
  },
  {
   value: "Ayton (CAAYO)",
   label: "Ayton (CAAYO)"
  },
  {
   value: "Baden (CABDE)",
   label: "Baden (CABDE)"
  },
  {
   value: "Arnaud (CAAAD)",
   label: "Arnaud (CAAAD)"
  },
  {
   value: "Algonquin Park (CAALP)",
   label: "Algonquin Park (CAALP)"
  },
  {
   value: "Alhambra (CAALH)",
   label: "Alhambra (CAALH)"
  },
  {
   value: "Alix (CAALI)",
   label: "Alix (CAALI)"
  },
  {
   value: "Allan (CAALN)",
   label: "Allan (CAALN)"
  },
  {
   value: "Allanburg (CAALL)",
   label: "Allanburg (CAALL)"
  },
  {
   value: "Alma (CAALM)",
   label: "Alma (CAALM)"
  },
  {
   value: "Almonte (CAAMT)",
   label: "Almonte (CAAMT)"
  },
  {
   value: "Altona (CAAXO)",
   label: "Altona (CAAXO)"
  },
  {
   value: "Alvinston (CAASO)",
   label: "Alvinston (CAASO)"
  },
  {
   value: "Amherst (CAAMN)",
   label: "Amherst (CAAMN)"
  },
  {
   value: "Amqui (CAAMQ)",
   label: "Amqui (CAAMQ)"
  },
  {
   value: "Angusville (CAAVM)",
   label: "Angusville (CAAVM)"
  },
  {
   value: "Anjou (CAAJU)",
   label: "Anjou (CAAJU)"
  },
  {
   value: "Annacis Island (CAANI)",
   label: "Annacis Island (CAANI)"
  },
  {
   value: "Anola (CAANL)",
   label: "Anola (CAANL)"
  },
  {
   value: "Antigonish (CAANT)",
   label: "Antigonish (CAANT)"
  },
  {
   value: "Anzac (CAANZ)",
   label: "Anzac (CAANZ)"
  },
  {
   value: "Appin (CAAPI)",
   label: "Appin (CAAPI)"
  },
  {
   value: "Apple Hill (CAAHL)",
   label: "Apple Hill (CAAHL)"
  },
  {
   value: "Arborg (CAARG)",
   label: "Arborg (CAARG)"
  },
  {
   value: "Ardath (CAADH)",
   label: "Ardath (CAADH)"
  },
  {
   value: "Ardrossan (CAASS)",
   label: "Ardrossan (CAASS)"
  },
  {
   value: "Ariss (CAARX)",
   label: "Ariss (CAARX)"
  },
  {
   value: "Arkona (CAAKN)",
   label: "Arkona (CAAKN)"
  },
  {
   value: "Armena (CAAME)",
   label: "Armena (CAAME)"
  },
  {
   value: "Alfred (CAALF)",
   label: "Alfred (CAALF)"
  },
  {
   value: "Big Creek (BZBGK)",
   label: "Big Creek (BZBGK)"
  },
  {
   value: "Dangriga (BZDGA)",
   label: "Dangriga (BZDGA)"
  },
  {
   value: "Independence Apt (BZINB)",
   label: "Independence Apt (BZINB)"
  },
  {
   value: "Manatee Apt (BZMZE)",
   label: "Manatee Apt (BZMZE)"
  },
  {
   value: "150 Mile House (CAMHS)",
   label: "150 Mile House (CAMHS)"
  },
  {
   value: "Abercrombie (CAABE)",
   label: "Abercrombie (CAABE)"
  },
  {
   value: "Abram-Village (CAABV)",
   label: "Abram-Village (CAABV)"
  },
  {
   value: "Acadia Valley (CAAVY)",
   label: "Acadia Valley (CAAVY)"
  },
  {
   value: "Acheson (CAAHN)",
   label: "Acheson (CAAHN)"
  },
  {
   value: "Acton (CAACT)",
   label: "Acton (CAACT)"
  },
  {
   value: "Agassiz (CAAGZ)",
   label: "Agassiz (CAAGZ)"
  },
  {
   value: "Aguathuna (CAAGU)",
   label: "Aguathuna (CAAGU)"
  },
  {
   value: "Ailsa Craig (CAAAC)",
   label: "Ailsa Craig (CAAAC)"
  },
  {
   value: "Airdrie (CAAIR)",
   label: "Airdrie (CAAIR)"
  },
  {
   value: "Akulivik Apt (CAAKV)",
   label: "Akulivik Apt (CAAKV)"
  },
  {
   value: "Alban (CAABN)",
   label: "Alban (CAABN)"
  },
  {
   value: "Albany (CAAYY)",
   label: "Albany (CAAYY)"
  },
  {
   value: "Alberton (CAATO)",
   label: "Alberton (CAATO)"
  },
  {
   value: "Aldergrove (CAADE)",
   label: "Aldergrove (CAADE)"
  },
  {
   value: "Aldersyde (CAASY)",
   label: "Aldersyde (CAASY)"
  },
  {
   value: "Alexandria (CAXFS)",
   label: "Alexandria (CAXFS)"
  },
  {
   value: "Alexis Creek (CAASK)",
   label: "Alexis Creek (CAASK)"
  },
  {
   value: "Belmopan (BZBMP)",
   label: "Belmopan (BZBMP)"
  },
  {
   value: "Gorodok (BYGRK)",
   label: "Gorodok (BYGRK)"
  },
  {
   value: "Grodno (BYGDO)",
   label: "Grodno (BYGDO)"
  },
  {
   value: "Khoyniki (BYKHO)",
   label: "Khoyniki (BYKHO)"
  },
  {
   value: "Kletsk (BYKLK)",
   label: "Kletsk (BYKLK)"
  },
  {
   value: "Kobryn (BYKBY)",
   label: "Kobryn (BYKBY)"
  },
  {
   value: "Kokhanovo (BYKNV)",
   label: "Kokhanovo (BYKNV)"
  },
  {
   value: "Koptevka (BYKOP)",
   label: "Koptevka (BYKOP)"
  },
  {
   value: "Kostyukovichi (BYKYC)",
   label: "Kostyukovichi (BYKYC)"
  },
  {
   value: "Lida (BYLDA)",
   label: "Lida (BYLDA)"
  },
  {
   value: "Lida (BYLID)",
   label: "Lida (BYLID)"
  },
  {
   value: "Luninyets (BYLNY)",
   label: "Luninyets (BYLNY)"
  },
  {
   value: "Maladzyechna (BYMZY)",
   label: "Maladzyechna (BYMZY)"
  },
  {
   value: "Mazyr (BYMAZ)",
   label: "Mazyr (BYMAZ)"
  },
  {
   value: "Molodeczno (BYMOL)",
   label: "Molodeczno (BYMOL)"
  },
  {
   value: "Navapolatsk (BYNPK)",
   label: "Navapolatsk (BYNPK)"
  },
  {
   value: "Orsa (BYOSH)",
   label: "Orsa (BYOSH)"
  },
  {
   value: "Orsha (BYORS)",
   label: "Orsha (BYORS)"
  },
  {
   value: "Pinsk (BYPIK)",
   label: "Pinsk (BYPIK)"
  },
  {
   value: "Rechytsa (BYRYA)",
   label: "Rechytsa (BYRYA)"
  },
  {
   value: "Salihorsk (BYSHO)",
   label: "Salihorsk (BYSHO)"
  },
  {
   value: "Sklov (BYSKV)",
   label: "Sklov (BYSKV)"
  },
  {
   value: "Slonim (BYSNM)",
   label: "Slonim (BYSNM)"
  },
  {
   value: "Slutsk (BYSLU)",
   label: "Slutsk (BYSLU)"
  },
  {
   value: "Smolevichi (BYSMV)",
   label: "Smolevichi (BYSMV)"
  },
  {
   value: "Smorgon (BYSGA)",
   label: "Smorgon (BYSGA)"
  },
  {
   value: "Svetlogorsk (BYSVE)",
   label: "Svetlogorsk (BYSVE)"
  },
  {
   value: "Vawkavysk (BYVAW)",
   label: "Vawkavysk (BYVAW)"
  },
  {
   value: "Zhlobin (BYZHO)",
   label: "Zhlobin (BYZHO)"
  },
  {
   value: "Zhodino (BYMZO)",
   label: "Zhodino (BYMZO)"
  },
  {
   value: ".BELIZE (BZ)",
   label: ".BELIZE (BZ)"
  },
  {
   value: "Gatovo (BYGAT)",
   label: "Gatovo (BYGAT)"
  },
  {
   value: "Barranco (BZBAR)",
   label: "Barranco (BZBAR)"
  },
  {
   value: ".BHUTAN (BT)",
   label: ".BHUTAN (BT)"
  },
  {
   value: ".BOTSWANA (BW)",
   label: ".BOTSWANA (BW)"
  },
  {
   value: "Letlhakane (BWLET)",
   label: "Letlhakane (BWLET)"
  },
  {
   value: "Mahalapye (BWMAH)",
   label: "Mahalapye (BWMAH)"
  },
  {
   value: "Palapye (BWPAL)",
   label: "Palapye (BWPAL)"
  },
  {
   value: "Serowe (BWSER)",
   label: "Serowe (BWSER)"
  },
  {
   value: ".BELARUS (BY)",
   label: ".BELARUS (BY)"
  },
  {
   value: "Baranovichi (BYBNV)",
   label: "Baranovichi (BYBNV)"
  },
  {
   value: "Barysaw (BYBAR)",
   label: "Barysaw (BYBAR)"
  },
  {
   value: "Berëzovka (BYBZA)",
   label: "Berëzovka (BYBZA)"
  },
  {
   value: "Bobruysk (BYBOB)",
   label: "Bobruysk (BYBOB)"
  },
  {
   value: "Borisov (BYMBV)",
   label: "Borisov (BYMBV)"
  },
  {
   value: "Borovlyany (BYBOR)",
   label: "Borovlyany (BYBOR)"
  },
  {
   value: "Fanipol (BYFAN)",
   label: "Fanipol (BYFAN)"
  },
  {
   value: "Great Stirrup Cay (BSGSC)",
   label: "Great Stirrup Cay (BSGSC)"
  },
  {
   value: "Little San Salvador (BSHMC)",
   label: "Little San Salvador (BSHMC)"
  },
  {
   value: "Lucaya (BSLUC)",
   label: "Lucaya (BSLUC)"
  },
  {
   value: "Mangrove Cay Apt (BSMAY)",
   label: "Mangrove Cay Apt (BSMAY)"
  },
  {
   value: "Mastic Point Apt (BSMSK)",
   label: "Mastic Point Apt (BSMSK)"
  },
  {
   value: "Vitória de Santo Antão (BRVDS)",
   label: "Vitória de Santo Antão (BRVDS)"
  },
  {
   value: "Vitória de Santo Antão (BRVSN)",
   label: "Vitória de Santo Antão (BRVSN)"
  },
  {
   value: "Vitoria do Jari (BRVAJ)",
   label: "Vitoria do Jari (BRVAJ)"
  },
  {
   value: "Votorantim (BRVTM)",
   label: "Votorantim (BRVTM)"
  },
  {
   value: "Wenceslau Braz (BRWBZ)",
   label: "Wenceslau Braz (BRWBZ)"
  },
  {
   value: "Xangrila (BRXGA)",
   label: "Xangrila (BRXGA)"
  },
  {
   value: "Xanxere (BRAXE)",
   label: "Xanxere (BRAXE)"
  },
  {
   value: "Xaxim (BRXAX)",
   label: "Xaxim (BRXAX)"
  },
  {
   value: "Xique-Xique (BRXQI)",
   label: "Xique-Xique (BRXQI)"
  },
  {
   value: ".BAHAMAS (BS)",
   label: ".BAHAMAS (BS)"
  },
  {
   value: "Bock Cay (BSBKC)",
   label: "Bock Cay (BSBKC)"
  },
  {
   value: "Cockburn Town (BSCBT)",
   label: "Cockburn Town (BSCBT)"
  },
  {
   value: "Coco Cay (BSCOC)",
   label: "Coco Cay (BSCOC)"
  },
  {
   value: "Gorda Cay (BSGOC)",
   label: "Gorda Cay (BSGOC)"
  },
  {
   value: "Vista Alegra do Alto (BRVAA)",
   label: "Vista Alegra do Alto (BRVAA)"
  },
  {
   value: "Vargem Grande (BRVGA)",
   label: "Vargem Grande (BRVGA)"
  },
  {
   value: "Vargem Grande do Sul (BRVGS)",
   label: "Vargem Grande do Sul (BRVGS)"
  },
  {
   value: "Vargem Grande Paulista (BRVGP)",
   label: "Vargem Grande Paulista (BRVGP)"
  },
  {
   value: "Varjota (BRVJO)",
   label: "Varjota (BRVJO)"
  },
  {
   value: "Varzea da Palma (BRVPM)",
   label: "Varzea da Palma (BRVPM)"
  },
  {
   value: "Varzea Grande (BRVGR)",
   label: "Varzea Grande (BRVGR)"
  },
  {
   value: "Varzea Paulista (BRVPU)",
   label: "Varzea Paulista (BRVPU)"
  },
  {
   value: "Vassouras (BRVAS)",
   label: "Vassouras (BRVAS)"
  },
  {
   value: "Vazante (BRVZA)",
   label: "Vazante (BRVZA)"
  },
  {
   value: "Velizy (BRVZY)",
   label: "Velizy (BRVZY)"
  },
  {
   value: "Venancio Aires (BRVCE)",
   label: "Venancio Aires (BRVCE)"
  },
  {
   value: "Venda Nova do Imigrante (BRVNI)",
   label: "Venda Nova do Imigrante (BRVNI)"
  },
  {
   value: "Vera (BRVER)",
   label: "Vera (BRVER)"
  },
  {
   value: "Vera Cruz (BRVRC)",
   label: "Vera Cruz (BRVRC)"
  },
  {
   value: "Veranopolis (BRVOP)",
   label: "Veranopolis (BRVOP)"
  },
  {
   value: "Vespasiano (BRVSA)",
   label: "Vespasiano (BRVSA)"
  },
  {
   value: "Viamao (BRVMA)",
   label: "Viamao (BRVMA)"
  },
  {
   value: "Viana (BRVNA)",
   label: "Viana (BRVNA)"
  },
  {
   value: "Vianopolis (BRVPS)",
   label: "Vianopolis (BRVPS)"
  },
  {
   value: "Vicosa (BRVIS)",
   label: "Vicosa (BRVIS)"
  },
  {
   value: "Vila do Conde (BRVIC)",
   label: "Vila do Conde (BRVIC)"
  },
  {
   value: "Vila do Conde (BRVLC)",
   label: "Vila do Conde (BRVLC)"
  },
  {
   value: "Vila Livieira (BRVLI)",
   label: "Vila Livieira (BRVLI)"
  },
  {
   value: "Vila Velha (BRVVE)",
   label: "Vila Velha (BRVVE)"
  },
  {
   value: "Vilhena (BRVIH)",
   label: "Vilhena (BRVIH)"
  },
  {
   value: "Vinhedo (BRVIN)",
   label: "Vinhedo (BRVIN)"
  },
  {
   value: "Viradouro (BRVDO)",
   label: "Viradouro (BRVDO)"
  },
  {
   value: "Virgem da Lapa (BRVGL)",
   label: "Virgem da Lapa (BRVGL)"
  },
  {
   value: "Visconce de Maua (BRVMU)",
   label: "Visconce de Maua (BRVMU)"
  },
  {
   value: "Visconde do Rio Branco (BRVRB)",
   label: "Visconde do Rio Branco (BRVRB)"
  },
  {
   value: "Vargem Alta (BRRGV)",
   label: "Vargem Alta (BRRGV)"
  },
  {
   value: "Tucuruvi (BRTVU)",
   label: "Tucuruvi (BRTVU)"
  },
  {
   value: "Tupa (BRTUP)",
   label: "Tupa (BRTUP)"
  },
  {
   value: "Tupaciguara (BRTCI)",
   label: "Tupaciguara (BRTCI)"
  },
  {
   value: "Tupancireta (BRTPC)",
   label: "Tupancireta (BRTPC)"
  },
  {
   value: "Tupi Paulista (BRTIP)",
   label: "Tupi Paulista (BRTIP)"
  },
  {
   value: "Turvo (BRTVO)",
   label: "Turvo (BRTVO)"
  },
  {
   value: "Uaua (BRUAU)",
   label: "Uaua (BRUAU)"
  },
  {
   value: "Uba (BRUBQ)",
   label: "Uba (BRUBQ)"
  },
  {
   value: "Ubaitaba (BRUTA)",
   label: "Ubaitaba (BRUTA)"
  },
  {
   value: "Ubajara (BRUBJ)",
   label: "Ubajara (BRUBJ)"
  },
  {
   value: "Ubata (BRUTB)",
   label: "Ubata (BRUTB)"
  },
  {
   value: "Ubirata (BRUBI)",
   label: "Ubirata (BRUBI)"
  },
  {
   value: "Uchoa (BRUCH)",
   label: "Uchoa (BRUCH)"
  },
  {
   value: "Una (BRUNA)",
   label: "Una (BRUNA)"
  },
  {
   value: "Unai (BRUNI)",
   label: "Unai (BRUNI)"
  },
  {
   value: "Uniao dos Palmares (BRUPA)",
   label: "Uniao dos Palmares (BRUPA)"
  },
  {
   value: "Uruacu (BRURU)",
   label: "Uruacu (BRURU)"
  },
  {
   value: "Urubici (BRUBC)",
   label: "Urubici (BRUBC)"
  },
  {
   value: "Urupes (BRUPE)",
   label: "Urupes (BRUPE)"
  },
  {
   value: "Urussanga (BRUSS)",
   label: "Urussanga (BRUSS)"
  },
  {
   value: "Vacaria (BRVCA)",
   label: "Vacaria (BRVCA)"
  },
  {
   value: "Vale do Sol (BRVSO)",
   label: "Vale do Sol (BRVSO)"
  },
  {
   value: "Valenca (BRVLA)",
   label: "Valenca (BRVLA)"
  },
  {
   value: "Valinhos (BRVAH)",
   label: "Valinhos (BRVAH)"
  },
  {
   value: "Valparaiso (BRVPO)",
   label: "Valparaiso (BRVPO)"
  },
  {
   value: "Valparaiso de Goias (BRVGO)",
   label: "Valparaiso de Goias (BRVGO)"
  },
  {
   value: "Valparaizo (BRVPA)",
   label: "Valparaizo (BRVPA)"
  },
  {
   value: "Tibau do Sul (BRTBS)",
   label: "Tibau do Sul (BRTBS)"
  },
  {
   value: "Tiete (BRTIE)",
   label: "Tiete (BRTIE)"
  },
  {
   value: "Tijuca do Sul (BRTJS)",
   label: "Tijuca do Sul (BRTJS)"
  },
  {
   value: "Tijucas (BRTJA)",
   label: "Tijucas (BRTJA)"
  },
  {
   value: "Timbauba (BRTMB)",
   label: "Timbauba (BRTMB)"
  },
  {
   value: "Timbó (BRTMO)",
   label: "Timbó (BRTMO)"
  },
  {
   value: "Timon (BRTIM)",
   label: "Timon (BRTIM)"
  },
  {
   value: "Timoteo (BRTTO)",
   label: "Timoteo (BRTTO)"
  },
  {
   value: "Tiradentes (BRTDE)",
   label: "Tiradentes (BRTDE)"
  },
  {
   value: "Tocantins (BRTCT)",
   label: "Tocantins (BRTCT)"
  },
  {
   value: "Tombos (BRTMS)",
   label: "Tombos (BRTMS)"
  },
  {
   value: "Tome-Acu (BRTAC)",
   label: "Tome-Acu (BRTAC)"
  },
  {
   value: "Torrinha (BRTHA)",
   label: "Torrinha (BRTHA)"
  },
  {
   value: "Touros (BRTOS)",
   label: "Touros (BRTOS)"
  },
  {
   value: "Tracunhaem (BRTCU)",
   label: "Tracunhaem (BRTCU)"
  },
  {
   value: "Trairi (BRTRI)",
   label: "Trairi (BRTRI)"
  },
  {
   value: "Trancoso (BRTCO)",
   label: "Trancoso (BRTCO)"
  },
  {
   value: "Tremembe (BRTME)",
   label: "Tremembe (BRTME)"
  },
  {
   value: "Três Coroas (BRROA)",
   label: "Três Coroas (BRROA)"
  },
  {
   value: "Tres de Maio (BRTMI)",
   label: "Tres de Maio (BRTMI)"
  },
  {
   value: "Tres Lagoas (BRTLA)",
   label: "Tres Lagoas (BRTLA)"
  },
  {
   value: "Tres Lagoas (BRTLG)",
   label: "Tres Lagoas (BRTLG)"
  },
  {
   value: "Tres Marias (BRTMR)",
   label: "Tres Marias (BRTMR)"
  },
  {
   value: "Tres Passos (BRTPS)",
   label: "Tres Passos (BRTPS)"
  },
  {
   value: "Tres Pontas (BRTRP)",
   label: "Tres Pontas (BRTRP)"
  },
  {
   value: "Tres Ranchos (BRTRR)",
   label: "Tres Ranchos (BRTRR)"
  },
  {
   value: "Treze Tilias (BRTZT)",
   label: "Treze Tilias (BRTZT)"
  },
  {
   value: "Trindade (BRTIN)",
   label: "Trindade (BRTIN)"
  },
  {
   value: "Triunfo (BRTFO)",
   label: "Triunfo (BRTFO)"
  },
  {
   value: "Triunfo (BRTRF)",
   label: "Triunfo (BRTRF)"
  },
  {
   value: "Tibagi (BRTGI)",
   label: "Tibagi (BRTGI)"
  },
  {
   value: "Tamandare (BRTMA)",
   label: "Tamandare (BRTMA)"
  },
  {
   value: "Tambau (BRTBU)",
   label: "Tambau (BRTBU)"
  },
  {
   value: "Tamboara (BRTBO)",
   label: "Tamboara (BRTBO)"
  },
  {
   value: "Tanabi (BRTNA)",
   label: "Tanabi (BRTNA)"
  },
  {
   value: "Tancredo Neves (BRTNE)",
   label: "Tancredo Neves (BRTNE)"
  },
  {
   value: "Tangara (BRTGR)",
   label: "Tangara (BRTGR)"
  },
  {
   value: "Tangará da Serra (BRTGQ)",
   label: "Tangará da Serra (BRTGQ)"
  },
  {
   value: "Tapejara (BRTPJ)",
   label: "Tapejara (BRTPJ)"
  },
  {
   value: "Taperoá (BRTPR)",
   label: "Taperoá (BRTPR)"
  },
  {
   value: "Tapes (BRTAP)",
   label: "Tapes (BRTAP)"
  },
  {
   value: "Tapirai (BRTPA)",
   label: "Tapirai (BRTPA)"
  },
  {
   value: "Tapiratiba (BRTTA)",
   label: "Tapiratiba (BRTTA)"
  },
  {
   value: "Taquara (BRTQU)",
   label: "Taquara (BRTQU)"
  },
  {
   value: "Taquaritinga (BRTQA)",
   label: "Taquaritinga (BRTQA)"
  },
  {
   value: "Taquaritinga do Norte (BRTQN)",
   label: "Taquaritinga do Norte (BRTQN)"
  },
  {
   value: "Taquarituba (BRTQB)",
   label: "Taquarituba (BRTQB)"
  },
  {
   value: "Taruma (BRTRU)",
   label: "Taruma (BRTRU)"
  },
  {
   value: "Tatui (BRTAT)",
   label: "Tatui (BRTAT)"
  },
  {
   value: "Taua (BRTAU)",
   label: "Taua (BRTAU)"
  },
  {
   value: "Taubate (BRTBA)",
   label: "Taubate (BRTBA)"
  },
  {
   value: "Tenente Portela (BRTPO)",
   label: "Tenente Portela (BRTPO)"
  },
  {
   value: "Teodoro Sampaio (BRTSO)",
   label: "Teodoro Sampaio (BRTSO)"
  },
  {
   value: "Terenos (BRTRE)",
   label: "Terenos (BRTRE)"
  },
  {
   value: "Terra Boa (BRTRB)",
   label: "Terra Boa (BRTRB)"
  },
  {
   value: "Terra de Areia (BRTAR)",
   label: "Terra de Areia (BRTAR)"
  },
  {
   value: "Terra Roxa (BRTRX)",
   label: "Terra Roxa (BRTRX)"
  },
  {
   value: "Teutônia (BRTEU)",
   label: "Teutônia (BRTEU)"
  },
  {
   value: "Tiangua (BRTGN)",
   label: "Tiangua (BRTGN)"
  },
  {
   value: "Taiuva (BRTUV)",
   label: "Taiuva (BRTUV)"
  },
  {
   value: "Severinia (BRSVE)",
   label: "Severinia (BRSVE)"
  },
  {
   value: "Sidrolandia (BRSLD)",
   label: "Sidrolandia (BRSLD)"
  },
  {
   value: "Silves (BRSIV)",
   label: "Silves (BRSIV)"
  },
  {
   value: "Silvianopolis (BRSVL)",
   label: "Silvianopolis (BRSVL)"
  },
  {
   value: "Simao Pereira (BRSOP)",
   label: "Simao Pereira (BRSOP)"
  },
  {
   value: "Simoes Filho (BRSSF)",
   label: "Simoes Filho (BRSSF)"
  },
  {
   value: "Sinimbu (BRSBU)",
   label: "Sinimbu (BRSBU)"
  },
  {
   value: "Sirinhaem (BRSNE)",
   label: "Sirinhaem (BRSNE)"
  },
  {
   value: "Sitio do Conde (BRSTC)",
   label: "Sitio do Conde (BRSTC)"
  },
  {
   value: "Sobradinho (BRSOB)",
   label: "Sobradinho (BRSOB)"
  },
  {
   value: "Sobradinho (BRSRH)",
   label: "Sobradinho (BRSRH)"
  },
  {
   value: "Sobralia (BRSBL)",
   label: "Sobralia (BRSBL)"
  },
  {
   value: "Socorro (BRSOC)",
   label: "Socorro (BRSOC)"
  },
  {
   value: "Soledade (BRSDA)",
   label: "Soledade (BRSDA)"
  },
  {
   value: "Sombrio (BRSBI)",
   label: "Sombrio (BRSBI)"
  },
  {
   value: "Sonora (BRSOA)",
   label: "Sonora (BRSOA)"
  },
  {
   value: "Sooretama (BRSOR)",
   label: "Sooretama (BRSOR)"
  },
  {
   value: "Sorriso (BRSOO)",
   label: "Sorriso (BRSOO)"
  },
  {
   value: "Sotave (BRSTV)",
   label: "Sotave (BRSTV)"
  },
  {
   value: "Sousa (BRSOU)",
   label: "Sousa (BRSOU)"
  },
  {
   value: "Sud Mennucci (BRSMU)",
   label: "Sud Mennucci (BRSMU)"
  },
  {
   value: "Sumaré (BRSME)",
   label: "Sumaré (BRSME)"
  },
  {
   value: "Surubim (BRSRB)",
   label: "Surubim (BRSRB)"
  },
  {
   value: "Suzano (BRSZN)",
   label: "Suzano (BRSZN)"
  },
  {
   value: "Tabapua (BRTPU)",
   label: "Tabapua (BRTPU)"
  },
  {
   value: "Taboao da Serra (BRTSA)",
   label: "Taboao da Serra (BRTSA)"
  },
  {
   value: "Tabuleiro do Norte (BRTNO)",
   label: "Tabuleiro do Norte (BRTNO)"
  },
  {
   value: "Taguatinga (BRTGU)",
   label: "Taguatinga (BRTGU)"
  },
  {
   value: "Taio (BRTAI)",
   label: "Taio (BRTAI)"
  },
  {
   value: "Taiobeiras (BRTBE)",
   label: "Taiobeiras (BRTBE)"
  },
  {
   value: "Sapucaia do Sul (BRSUS)",
   label: "Sapucaia do Sul (BRSUS)"
  },
  {
   value: "Sapucaí-Mirim (BRSPM)",
   label: "Sapucaí-Mirim (BRSPM)"
  },
  {
   value: "Saquarema (BRSQR)",
   label: "Saquarema (BRSQR)"
  },
  {
   value: "Sarandi (BRSND)",
   label: "Sarandi (BRSND)"
  },
  {
   value: "Sarandi (BRSNI)",
   label: "Sarandi (BRSNI)"
  },
  {
   value: "Saranduva (BRSVA)",
   label: "Saranduva (BRSVA)"
  },
  {
   value: "Sarapuí (BRSRI)",
   label: "Sarapuí (BRSRI)"
  },
  {
   value: "Sauipe (BRSUP)",
   label: "Sauipe (BRSUP)"
  },
  {
   value: "Schroeder (BRSDE)",
   label: "Schroeder (BRSDE)"
  },
  {
   value: "Selbach (BRSBH)",
   label: "Selbach (BRSBH)"
  },
  {
   value: "Senhora de Oliveira (BRSOI)",
   label: "Senhora de Oliveira (BRSOI)"
  },
  {
   value: "Sento Sé (BRSTS)",
   label: "Sento Sé (BRSTS)"
  },
  {
   value: "Sepetiba (BRSEP)",
   label: "Sepetiba (BRSEP)"
  },
  {
   value: "Serafina Correa (BRSCE)",
   label: "Serafina Correa (BRSCE)"
  },
  {
   value: "Sergipe (BRSGI)",
   label: "Sergipe (BRSGI)"
  },
  {
   value: "Seropedica (BRSDC)",
   label: "Seropedica (BRSDC)"
  },
  {
   value: "Serra (BRSER)",
   label: "Serra (BRSER)"
  },
  {
   value: "Serra da Canastra (BRSCN)",
   label: "Serra da Canastra (BRSCN)"
  },
  {
   value: "Serra da Capivara (BRSEV)",
   label: "Serra da Capivara (BRSEV)"
  },
  {
   value: "Serra do Cipo (BRSIO)",
   label: "Serra do Cipo (BRSIO)"
  },
  {
   value: "Serra do Salitre (BRSST)",
   label: "Serra do Salitre (BRSST)"
  },
  {
   value: "Serra Negra (BRSNG)",
   label: "Serra Negra (BRSNG)"
  },
  {
   value: "Serra Talhada (BRSTD)",
   label: "Serra Talhada (BRSTD)"
  },
  {
   value: "Serrana (BRSNA)",
   label: "Serrana (BRSNA)"
  },
  {
   value: "Serrania (BRSIA)",
   label: "Serrania (BRSIA)"
  },
  {
   value: "Serranopolis (BRSNO)",
   label: "Serranopolis (BRSNO)"
  },
  {
   value: "Serrinha (BRSHA)",
   label: "Serrinha (BRSHA)"
  },
  {
   value: "Serro (BRSEO)",
   label: "Serro (BRSEO)"
  },
  {
   value: "Sertanopolis (BRSNS)",
   label: "Sertanopolis (BRSNS)"
  },
  {
   value: "Sertãozinho (BRSZO)",
   label: "Sertãozinho (BRSZO)"
  },
  {
   value: "Sete Barras (BRSBA)",
   label: "Sete Barras (BRSBA)"
  },
  {
   value: "Sapiranga (BRSAP)",
   label: "Sapiranga (BRSAP)"
  },
  {
   value: "Sao Miguel dos Campos (BRSMP)",
   label: "Sao Miguel dos Campos (BRSMP)"
  },
  {
   value: "Sao Miguel dos Touros (BRSMR)",
   label: "Sao Miguel dos Touros (BRSMR)"
  },
  {
   value: "Sao Miguel Milagres (BRSUM)",
   label: "Sao Miguel Milagres (BRSUM)"
  },
  {
   value: "Sao Miguel Paulista (BRSPT)",
   label: "Sao Miguel Paulista (BRSPT)"
  },
  {
   value: "Sao Paulo Cgh (BRSPC)",
   label: "Sao Paulo Cgh (BRSPC)"
  },
  {
   value: "Sao Paulo de Olivenca (BRSPV)",
   label: "Sao Paulo de Olivenca (BRSPV)"
  },
  {
   value: "Sao Paulo Gru (BRSPG)",
   label: "Sao Paulo Gru (BRSPG)"
  },
  {
   value: "Sao Pedro (BRSPD)",
   label: "Sao Pedro (BRSPD)"
  },
  {
   value: "Sao Pedro Alcantara (BRSPE)",
   label: "Sao Pedro Alcantara (BRSPE)"
  },
  {
   value: "Sao Pedro da Aldeia (BRSRL)",
   label: "Sao Pedro da Aldeia (BRSRL)"
  },
  {
   value: "Sao Pedro do Ivai (BRSDI)",
   label: "Sao Pedro do Ivai (BRSDI)"
  },
  {
   value: "Sao Pedro do Suacui (BRSCU)",
   label: "Sao Pedro do Suacui (BRSCU)"
  },
  {
   value: "Sao Pedro do Sul (BRSDS)",
   label: "Sao Pedro do Sul (BRSDS)"
  },
  {
   value: "Sao Pedro do Turvo (BRSDT)",
   label: "Sao Pedro do Turvo (BRSDT)"
  },
  {
   value: "Sao Raimundo Nonato (BRSRN)",
   label: "Sao Raimundo Nonato (BRSRN)"
  },
  {
   value: "Sao Roque (BRSRQ)",
   label: "Sao Roque (BRSRQ)"
  },
  {
   value: "Sao Roque de Minas (BRSQN)",
   label: "Sao Roque de Minas (BRSQN)"
  },
  {
   value: "Sao Roque do Canaa (BRSQA)",
   label: "Sao Roque do Canaa (BRSQA)"
  },
  {
   value: "Sao Sebastiao da Grama (BRSSG)",
   label: "Sao Sebastiao da Grama (BRSSG)"
  },
  {
   value: "Sao Sebastiao do Paraiso (BRSSP)",
   label: "Sao Sebastiao do Paraiso (BRSSP)"
  },
  {
   value: "Sao Sebastiao do Paraiso (BRSSR)",
   label: "Sao Sebastiao do Paraiso (BRSSR)"
  },
  {
   value: "Sao Sepe (BRSSE)",
   label: "Sao Sepe (BRSSE)"
  },
  {
   value: "Sao Simao (BRSOS)",
   label: "Sao Simao (BRSOS)"
  },
  {
   value: "Sao Simao (BRSSI)",
   label: "Sao Simao (BRSSI)"
  },
  {
   value: "Sao Tome das Letras (BRSTL)",
   label: "Sao Tome das Letras (BRSTL)"
  },
  {
   value: "São Vicente (BRSVT)",
   label: "São Vicente (BRSVT)"
  },
  {
   value: "Sap Leopoldo (BRSLE)",
   label: "Sap Leopoldo (BRSLE)"
  },
  {
   value: "Sape (BRSAE)",
   label: "Sape (BRSAE)"
  },
  {
   value: "Sapezal (BRSPZ)",
   label: "Sapezal (BRSPZ)"
  },
  {
   value: "Sao Miguel do Oeste (BRSMT)",
   label: "Sao Miguel do Oeste (BRSMT)"
  },
  {
   value: "Sao Jose da Lapa (BRSSL)",
   label: "Sao Jose da Lapa (BRSSL)"
  },
  {
   value: "Sao Jose de Mipibo (BRSSM)",
   label: "Sao Jose de Mipibo (BRSSM)"
  },
  {
   value: "Sao Jose do Barreiro (BRSJI)",
   label: "Sao Jose do Barreiro (BRSJI)"
  },
  {
   value: "Sao Jose do Cedro (BRSJD)",
   label: "Sao Jose do Cedro (BRSJD)"
  },
  {
   value: "Sao Jose do Rio Claro (BRSJR)",
   label: "Sao Jose do Rio Claro (BRSJR)"
  },
  {
   value: "Sao Jose do Rio Pardo (BRJRP)",
   label: "Sao Jose do Rio Pardo (BRJRP)"
  },
  {
   value: "Sao Jose do Vale Rio Preto (BRSRT)",
   label: "Sao Jose do Vale Rio Preto (BRSRT)"
  },
  {
   value: "Sao Jose dos Ausentes (BRSJT)",
   label: "Sao Jose dos Ausentes (BRSJT)"
  },
  {
   value: "São José dos Pinhais (BRSJS)",
   label: "São José dos Pinhais (BRSJS)"
  },
  {
   value: "Sao Jose Quatro Marcos (BRSQC)",
   label: "Sao Jose Quatro Marcos (BRSQC)"
  },
  {
   value: "Sao Lourenco (BRSLO)",
   label: "Sao Lourenco (BRSLO)"
  },
  {
   value: "Sao Lourenco da Mata (BRSLM)",
   label: "Sao Lourenco da Mata (BRSLM)"
  },
  {
   value: "Sao Lourenco da Serra (BRSLS)",
   label: "Sao Lourenco da Serra (BRSLS)"
  },
  {
   value: "Sao Lourenco do Oeste (BRSLT)",
   label: "Sao Lourenco do Oeste (BRSLT)"
  },
  {
   value: "Sao Ludgero (BRSLG)",
   label: "Sao Ludgero (BRSLG)"
  },
  {
   value: "Sao Luis de Montes Belos (BRSMB)",
   label: "Sao Luis de Montes Belos (BRSMB)"
  },
  {
   value: "Sao Luis do Paraitinga (BRSLP)",
   label: "Sao Luis do Paraitinga (BRSLP)"
  },
  {
   value: "Sao Luiz Gonzaga (BRSZG)",
   label: "Sao Luiz Gonzaga (BRSZG)"
  },
  {
   value: "Sao Manuel (BRSML)",
   label: "Sao Manuel (BRSML)"
  },
  {
   value: "Sao Marcos (BRSMC)",
   label: "Sao Marcos (BRSMC)"
  },
  {
   value: "Sao Mateus do Sul (BRSMS)",
   label: "Sao Mateus do Sul (BRSMS)"
  },
  {
   value: "Sao Miguel Arcanjo (BRSMJ)",
   label: "Sao Miguel Arcanjo (BRSMJ)"
  },
  {
   value: "Sao Miguel das Missoes (BRSMI)",
   label: "Sao Miguel das Missoes (BRSMI)"
  },
  {
   value: "Sao Miguel do Gostoso (BRSMG)",
   label: "Sao Miguel do Gostoso (BRSMG)"
  },
  {
   value: "Sao Jose (BRSJE)",
   label: "Sao Jose (BRSJE)"
  },
  {
   value: "Sao Felix (BRSFX)",
   label: "Sao Felix (BRSFX)"
  },
  {
   value: "Sao Felix do Xingu (BRSFG)",
   label: "Sao Felix do Xingu (BRSFG)"
  },
  {
   value: "Sao Fidelis (BRSFI)",
   label: "Sao Fidelis (BRSFI)"
  },
  {
   value: "Sao Francisco (BRSFO)",
   label: "Sao Francisco (BRSFO)"
  },
  {
   value: "Sao Francisco (BRSFR)",
   label: "Sao Francisco (BRSFR)"
  },
  {
   value: "Sao Francisco de Assis (BRSFA)",
   label: "Sao Francisco de Assis (BRSFA)"
  },
  {
   value: "Sao Francisco de Paula (BRSFP)",
   label: "Sao Francisco de Paula (BRSFP)"
  },
  {
   value: "Sao Francisco de Paula (BRSRP)",
   label: "Sao Francisco de Paula (BRSRP)"
  },
  {
   value: "Sao Francisco do Conde (BRSFN)",
   label: "Sao Francisco do Conde (BRSFN)"
  },
  {
   value: "Sao Francisco Xavier (BRSXV)",
   label: "Sao Francisco Xavier (BRSXV)"
  },
  {
   value: "Sao Gabriel (BRSGA)",
   label: "Sao Gabriel (BRSGA)"
  },
  {
   value: "Sao Gabriel da Palha (BRSGP)",
   label: "Sao Gabriel da Palha (BRSGP)"
  },
  {
   value: "Sao Gabriel do Oeste (BRSGS)",
   label: "Sao Gabriel do Oeste (BRSGS)"
  },
  {
   value: "Sao Geraldo (BRSGL)",
   label: "Sao Geraldo (BRSGL)"
  },
  {
   value: "Sao Goncalo do Amarante (BRSGE)",
   label: "Sao Goncalo do Amarante (BRSGE)"
  },
  {
   value: "São Gonçalo do Amarante (BRSAZ)",
   label: "São Gonçalo do Amarante (BRSAZ)"
  },
  {
   value: "Sao Goncalo dos Campos (BRSGC)",
   label: "Sao Goncalo dos Campos (BRSGC)"
  },
  {
   value: "Sao Gotardo (BRSGT)",
   label: "Sao Gotardo (BRSGT)"
  },
  {
   value: "Sao Jeronimo (BRSJO)",
   label: "Sao Jeronimo (BRSJO)"
  },
  {
   value: "Sao Joao da Alianca (BRSJA)",
   label: "Sao Joao da Alianca (BRSJA)"
  },
  {
   value: "Sao Joao da Boa Vista (BRSJV)",
   label: "Sao Joao da Boa Vista (BRSJV)"
  },
  {
   value: "Sao Joao do Caiua (BRSJC)",
   label: "Sao Joao do Caiua (BRSJC)"
  },
  {
   value: "Sao Joao do Meriti (BRSJM)",
   label: "Sao Joao do Meriti (BRSJM)"
  },
  {
   value: "Sao Joao Nepomucemo (BRSJN)",
   label: "Sao Joao Nepomucemo (BRSJN)"
  },
  {
   value: "Sao Joaquim (BRSJQ)",
   label: "Sao Joaquim (BRSJQ)"
  },
  {
   value: "Sao Joaquim da Barra (BRSJB)",
   label: "Sao Joaquim da Barra (BRSJB)"
  },
  {
   value: "Sao Cristovao (BRSCV)",
   label: "Sao Cristovao (BRSCV)"
  },
  {
   value: "Santo Amaro da Imperatriz (BRSRM)",
   label: "Santo Amaro da Imperatriz (BRSRM)"
  },
  {
   value: "Santo Anastacio (BRSUN)",
   label: "Santo Anastacio (BRSUN)"
  },
  {
   value: "Santo Andre (BRSAR)",
   label: "Santo Andre (BRSAR)"
  },
  {
   value: "Santo Antonio da Patrulha (BRSPU)",
   label: "Santo Antonio da Patrulha (BRSPU)"
  },
  {
   value: "Santo Antonio da Platina (BRSPN)",
   label: "Santo Antonio da Platina (BRSPN)"
  },
  {
   value: "Santo Antonio da Posse (BRSAS)",
   label: "Santo Antonio da Posse (BRSAS)"
  },
  {
   value: "Santo Antonio de Jesus (BRSAJ)",
   label: "Santo Antonio de Jesus (BRSAJ)"
  },
  {
   value: "Santo Antônio de Jesus (BRAJE)",
   label: "Santo Antônio de Jesus (BRAJE)"
  },
  {
   value: "Santo Antônio de Pádua (BRSTA)",
   label: "Santo Antônio de Pádua (BRSTA)"
  },
  {
   value: "Santo Antônio do Amparo (BRSTP)",
   label: "Santo Antônio do Amparo (BRSTP)"
  },
  {
   value: "Santo Antonio do Jardim (BRSTJ)",
   label: "Santo Antonio do Jardim (BRSTJ)"
  },
  {
   value: "Santo Antonio do Monte (BRSTN)",
   label: "Santo Antonio do Monte (BRSTN)"
  },
  {
   value: "Santo Antonio do Pinhal (BRSPL)",
   label: "Santo Antonio do Pinhal (BRSPL)"
  },
  {
   value: "Santo Antonio Leverger (BRSAV)",
   label: "Santo Antonio Leverger (BRSAV)"
  },
  {
   value: "Santo Cristo (BRSCO)",
   label: "Santo Cristo (BRSCO)"
  },
  {
   value: "Santo Cristo (BRSCT)",
   label: "Santo Cristo (BRSCT)"
  },
  {
   value: "Santos Dumont (BRSDO)",
   label: "Santos Dumont (BRSDO)"
  },
  {
   value: "Sao Benedito (BRSBE)",
   label: "Sao Benedito (BRSBE)"
  },
  {
   value: "Sao Bento (BRSBT)",
   label: "Sao Bento (BRSBT)"
  },
  {
   value: "Sao Bento do Sapucai (BRSBS)",
   label: "Sao Bento do Sapucai (BRSBS)"
  },
  {
   value: "Sao Borja (BRBJA)",
   label: "Sao Borja (BRBJA)"
  },
  {
   value: "Sao Borja (BRQOJ)",
   label: "Sao Borja (BRQOJ)"
  },
  {
   value: "Sao Carlos (BRSCL)",
   label: "Sao Carlos (BRSCL)"
  },
  {
   value: "Santo Amaro (BRSAM)",
   label: "Santo Amaro (BRSAM)"
  },
  {
   value: "Santa Izabel do Para (BRSIP)",
   label: "Santa Izabel do Para (BRSIP)"
  },
  {
   value: "Santa Luzia (BRSLA)",
   label: "Santa Luzia (BRSLA)"
  },
  {
   value: "Santa Maria Boa Vista (BRSMA)",
   label: "Santa Maria Boa Vista (BRSMA)"
  },
  {
   value: "Santa Maria da Vitória (BRSMV)",
   label: "Santa Maria da Vitória (BRSMV)"
  },
  {
   value: "Santa Maria Madalena (BRSMM)",
   label: "Santa Maria Madalena (BRSMM)"
  },
  {
   value: "Santa Mariana (BRSMN)",
   label: "Santa Mariana (BRSMN)"
  },
  {
   value: "Santa Rita (BRSRR)",
   label: "Santa Rita (BRSRR)"
  },
  {
   value: "Santa Rita do Araguaia (BRSRG)",
   label: "Santa Rita do Araguaia (BRSRG)"
  },
  {
   value: "Santa Rita do Oeste (BRSRO)",
   label: "Santa Rita do Oeste (BRSRO)"
  },
  {
   value: "Santa Rita do Passa Quatro (BRSRS)",
   label: "Santa Rita do Passa Quatro (BRSRS)"
  },
  {
   value: "Santa Rita do Sapucai (BRSRW)",
   label: "Santa Rita do Sapucai (BRSRW)"
  },
  {
   value: "Santa Rosa de Viterbo (BRSRV)",
   label: "Santa Rosa de Viterbo (BRSRV)"
  },
  {
   value: "Santa Rosa do Sul (BRSRU)",
   label: "Santa Rosa do Sul (BRSRU)"
  },
  {
   value: "Santa Teresa (BRSTE)",
   label: "Santa Teresa (BRSTE)"
  },
  {
   value: "Santa Terezinha de Goias (BRSTG)",
   label: "Santa Terezinha de Goias (BRSTG)"
  },
  {
   value: "Santa Vitoria (BRSVI)",
   label: "Santa Vitoria (BRSVI)"
  },
  {
   value: "Santa Vitoria do Palmar (BRSVP)",
   label: "Santa Vitoria do Palmar (BRSVP)"
  },
  {
   value: "Santana (BRSTB)",
   label: "Santana (BRSTB)"
  },
  {
   value: "Santana de Parnaíba (BRPSA)",
   label: "Santana de Parnaíba (BRPSA)"
  },
  {
   value: "Santana do Livramento (BRSLI)",
   label: "Santana do Livramento (BRSLI)"
  },
  {
   value: "Santana do Paraiso (BRSNP)",
   label: "Santana do Paraiso (BRSNP)"
  },
  {
   value: "Santana do Riacho (BRSRC)",
   label: "Santana do Riacho (BRSRC)"
  },
  {
   value: "Santiago (BRSGO)",
   label: "Santiago (BRSGO)"
  },
  {
   value: "Santo Agostinho (BRSAG)",
   label: "Santo Agostinho (BRSAG)"
  },
  {
   value: "Sales Oliveira (BRSOV)",
   label: "Sales Oliveira (BRSOV)"
  },
  {
   value: "Salesopolis (BRSPO)",
   label: "Salesopolis (BRSPO)"
  },
  {
   value: "Salgueiro (BRSGU)",
   label: "Salgueiro (BRSGU)"
  },
  {
   value: "Salinas (BRSAA)",
   label: "Salinas (BRSAA)"
  },
  {
   value: "Salto (BRSAT)",
   label: "Salto (BRSAT)"
  },
  {
   value: "Salto de Pirapora (BRSAF)",
   label: "Salto de Pirapora (BRSAF)"
  },
  {
   value: "Salto Grande (BRSAL)",
   label: "Salto Grande (BRSAL)"
  },
  {
   value: "Salvador do Sul (BRSAD)",
   label: "Salvador do Sul (BRSAD)"
  },
  {
   value: "Sana (BRSNB)",
   label: "Sana (BRSNB)"
  },
  {
   value: "Sananduva (BRSNU)",
   label: "Sananduva (BRSNU)"
  },
  {
   value: "Sanclerlandia (BRSNC)",
   label: "Sanclerlandia (BRSNC)"
  },
  {
   value: "Santa Adelia (BRSNL)",
   label: "Santa Adelia (BRSNL)"
  },
  {
   value: "Santa Barbara (BRSNR)",
   label: "Santa Barbara (BRSNR)"
  },
  {
   value: "Santa Barbara do Para (BRSNT)",
   label: "Santa Barbara do Para (BRSNT)"
  },
  {
   value: "Santa Bárbara do Pará (BRBDA)",
   label: "Santa Bárbara do Pará (BRBDA)"
  },
  {
   value: "Santa Branca (BRSBR)",
   label: "Santa Branca (BRSBR)"
  },
  {
   value: "Santa Carmem (BRSNV)",
   label: "Santa Carmem (BRSNV)"
  },
  {
   value: "Santa Clara do Sul (BRSCS)",
   label: "Santa Clara do Sul (BRSCS)"
  },
  {
   value: "Santa Cruz Cabralia (BRSNW)",
   label: "Santa Cruz Cabralia (BRSNW)"
  },
  {
   value: "Santa Cruz das Palmeiras (BRSNY)",
   label: "Santa Cruz das Palmeiras (BRSNY)"
  },
  {
   value: "Santa Cruz do Capibaribe (BRSNF)",
   label: "Santa Cruz do Capibaribe (BRSNF)"
  },
  {
   value: "Santa Cruz do Rio Pardo (BRSNQ)",
   label: "Santa Cruz do Rio Pardo (BRSNQ)"
  },
  {
   value: "Santa Cruz do Sul (BRDSU)",
   label: "Santa Cruz do Sul (BRDSU)"
  },
  {
   value: "Santa Gertrudes (BRSGR)",
   label: "Santa Gertrudes (BRSGR)"
  },
  {
   value: "Santa Helena (BRSNH)",
   label: "Santa Helena (BRSNH)"
  },
  {
   value: "Santa Helena de Goias (BRSHG)",
   label: "Santa Helena de Goias (BRSHG)"
  },
  {
   value: "Santa Ines (BRSIN)",
   label: "Santa Ines (BRSIN)"
  },
  {
   value: "Santa Isabel (BRSIB)",
   label: "Santa Isabel (BRSIB)"
  },
  {
   value: "Santa Isabel do Ivai (BRSII)",
   label: "Santa Isabel do Ivai (BRSII)"
  },
  {
   value: "Sacramento (BRSMO)",
   label: "Sacramento (BRSMO)"
  },
  {
   value: "Rio de Janeiro Gig (BRRJO)",
   label: "Rio de Janeiro Gig (BRRJO)"
  },
  {
   value: "Rio de Janeiro Sdu (BRRJS)",
   label: "Rio de Janeiro Sdu (BRRJS)"
  },
  {
   value: "Rio do Fogo (BRRFO)",
   label: "Rio do Fogo (BRRFO)"
  },
  {
   value: "Rio Grande da Serra (BRRGS)",
   label: "Rio Grande da Serra (BRRGS)"
  },
  {
   value: "Rio Grande do Sul (BRGSU)",
   label: "Rio Grande do Sul (BRGSU)"
  },
  {
   value: "Rio Largo (BRRLO)",
   label: "Rio Largo (BRRLO)"
  },
  {
   value: "Rio Maria (BRRMI)",
   label: "Rio Maria (BRRMI)"
  },
  {
   value: "Rio Negro (BRRNO)",
   label: "Rio Negro (BRRNO)"
  },
  {
   value: "Rio Paranaiba (BRRPA)",
   label: "Rio Paranaiba (BRRPA)"
  },
  {
   value: "Rio Pomba (BRRPB)",
   label: "Rio Pomba (BRRPB)"
  },
  {
   value: "Rio Quente (BRRQE)",
   label: "Rio Quente (BRRQE)"
  },
  {
   value: "Rio Verde de Mato Grosso (BRVMG)",
   label: "Rio Verde de Mato Grosso (BRVMG)"
  },
  {
   value: "Riolandia (BRRLA)",
   label: "Riolandia (BRRLA)"
  },
  {
   value: "Rolandia (BRROL)",
   label: "Rolandia (BRROL)"
  },
  {
   value: "Rolim de Moura (BRRMU)",
   label: "Rolim de Moura (BRRMU)"
  },
  {
   value: "Rondon do Para (BRRPR)",
   label: "Rondon do Para (BRRPR)"
  },
  {
   value: "Rosana (BRROS)",
   label: "Rosana (BRROS)"
  },
  {
   value: "Rosario do Ivai (BRRIV)",
   label: "Rosario do Ivai (BRRIV)"
  },
  {
   value: "Rosario do Sul (BRRSO)",
   label: "Rosario do Sul (BRRSO)"
  },
  {
   value: "Rubiataba (BRRUB)",
   label: "Rubiataba (BRRUB)"
  },
  {
   value: "Rural Paranaiba (BRRNB)",
   label: "Rural Paranaiba (BRRNB)"
  },
  {
   value: "Ruy Barbosa (BRRYB)",
   label: "Ruy Barbosa (BRRYB)"
  },
  {
   value: "S Miguel do Iguacu (BRMIG)",
   label: "S Miguel do Iguacu (BRMIG)"
  },
  {
   value: "S.Goncalo Sapucai (BRGSI)",
   label: "S.Goncalo Sapucai (BRGSI)"
  },
  {
   value: "S.Sebastiao do Passe (BRSPA)",
   label: "S.Sebastiao do Passe (BRSPA)"
  },
  {
   value: "Sabara (BRSAB)",
   label: "Sabara (BRSAB)"
  },
  {
   value: "Rio das Pedras (BRRPE)",
   label: "Rio das Pedras (BRRPE)"
  },
  {
   value: "Quixeramobim (BRQMO)",
   label: "Quixeramobim (BRQMO)"
  },
  {
   value: "Quixere (BRQUI)",
   label: "Quixere (BRQUI)"
  },
  {
   value: "Rafard (BRRFA)",
   label: "Rafard (BRRFA)"
  },
  {
   value: "Rancharia (BRRCA)",
   label: "Rancharia (BRRCA)"
  },
  {
   value: "Raposo (BRRPO)",
   label: "Raposo (BRRPO)"
  },
  {
   value: "Realeza (BRRZA)",
   label: "Realeza (BRRZA)"
  },
  {
   value: "Redenção (BRREO)",
   label: "Redenção (BRREO)"
  },
  {
   value: "Regente Feijo (BRRFJ)",
   label: "Regente Feijo (BRRFJ)"
  },
  {
   value: "Registro (BRRGI)",
   label: "Registro (BRRGI)"
  },
  {
   value: "Remanso (BRRMA)",
   label: "Remanso (BRRMA)"
  },
  {
   value: "Reserva (BRRSE)",
   label: "Reserva (BRRSE)"
  },
  {
   value: "Ribas do Rio Pardo (BRRRP)",
   label: "Ribas do Rio Pardo (BRRRP)"
  },
  {
   value: "Ribeira do Pombal (BRRPM)",
   label: "Ribeira do Pombal (BRRPM)"
  },
  {
   value: "Ribeirao Bonito (BRRBI)",
   label: "Ribeirao Bonito (BRRBI)"
  },
  {
   value: "Ribeirao Cascalheira (BRRCR)",
   label: "Ribeirao Cascalheira (BRRCR)"
  },
  {
   value: "Ribeirao das Neves (BRRNV)",
   label: "Ribeirao das Neves (BRRNV)"
  },
  {
   value: "Ribeirao do Sul (BRRSU)",
   label: "Ribeirao do Sul (BRRSU)"
  },
  {
   value: "Ribeirao Grande (BRRGA)",
   label: "Ribeirao Grande (BRRGA)"
  },
  {
   value: "Ribeirao Pires (BRRPI)",
   label: "Ribeirao Pires (BRRPI)"
  },
  {
   value: "Ribeirao Vermelho (BRRVO)",
   label: "Ribeirao Vermelho (BRRVO)"
  },
  {
   value: "Rifaina (BRRFI)",
   label: "Rifaina (BRRFI)"
  },
  {
   value: "Rincao (BRRCO)",
   label: "Rincao (BRRCO)"
  },
  {
   value: "Rinopolis (BRRPS)",
   label: "Rinopolis (BRRPS)"
  },
  {
   value: "Rio Acima (BRRAC)",
   label: "Rio Acima (BRRAC)"
  },
  {
   value: "Rio Bonito (BRRBO)",
   label: "Rio Bonito (BRRBO)"
  },
  {
   value: "Rio Brilhante (BRRBA)",
   label: "Rio Brilhante (BRRBA)"
  },
  {
   value: "Rio Casca (BRRCS)",
   label: "Rio Casca (BRRCS)"
  },
  {
   value: "Rio Claro (BRRCL)",
   label: "Rio Claro (BRRCL)"
  },
  {
   value: "Rio das Contas (BRRCN)",
   label: "Rio das Contas (BRRCN)"
  },
  {
   value: "Rio das Ostras (BRRTA)",
   label: "Rio das Ostras (BRRTA)"
  },
  {
   value: "Quixada Apt (BRQIX)",
   label: "Quixada Apt (BRQIX)"
  },
  {
   value: "Pradopolis (BRPPL)",
   label: "Pradopolis (BRPPL)"
  },
  {
   value: "Praia da Baleia (BRPBI)",
   label: "Praia da Baleia (BRPBI)"
  },
  {
   value: "Praia da Pipa (BRPPP)",
   label: "Praia da Pipa (BRPPP)"
  },
  {
   value: "Praia de Tambaba (BRPMB)",
   label: "Praia de Tambaba (BRPMB)"
  },
  {
   value: "Praia do Forte (BRPFR)",
   label: "Praia do Forte (BRPFR)"
  },
  {
   value: "Praia do Frances (BRPFC)",
   label: "Praia do Frances (BRPFC)"
  },
  {
   value: "Praia do Rosa (BRPIO)",
   label: "Praia do Rosa (BRPIO)"
  },
  {
   value: "Praia Grande (BRPGR)",
   label: "Praia Grande (BRPGR)"
  },
  {
   value: "Praia Mole (BRPRM)",
   label: "Praia Mole (BRPRM)"
  },
  {
   value: "Prata (BRPAA)",
   label: "Prata (BRPAA)"
  },
  {
   value: "Presidente Bernardes (BRPBR)",
   label: "Presidente Bernardes (BRPBR)"
  },
  {
   value: "Presidente Epitacio (BRPEO)",
   label: "Presidente Epitacio (BRPEO)"
  },
  {
   value: "Presidente Figueiredo (BRPFU)",
   label: "Presidente Figueiredo (BRPFU)"
  },
  {
   value: "Presidente Getulio (BRPGL)",
   label: "Presidente Getulio (BRPGL)"
  },
  {
   value: "Presidente Medici (BRPMC)",
   label: "Presidente Medici (BRPMC)"
  },
  {
   value: "Presidente Venceslau (BRPVE)",
   label: "Presidente Venceslau (BRPVE)"
  },
  {
   value: "Primavera (BRPMV)",
   label: "Primavera (BRPMV)"
  },
  {
   value: "Primavera do Leste (BRPIL)",
   label: "Primavera do Leste (BRPIL)"
  },
  {
   value: "Promissao (BRPMO)",
   label: "Promissao (BRPMO)"
  },
  {
   value: "Propria (BRPRP)",
   label: "Propria (BRPRP)"
  },
  {
   value: "Prudentopolis (BRPUO)",
   label: "Prudentopolis (BRPUO)"
  },
  {
   value: "Quarai (BRQRA)",
   label: "Quarai (BRQRA)"
  },
  {
   value: "Quata (BRQTA)",
   label: "Quata (BRQTA)"
  },
  {
   value: "Quatis (BRQTS)",
   label: "Quatis (BRQTS)"
  },
  {
   value: "Quatro Barras (BRQBA)",
   label: "Quatro Barras (BRQBA)"
  },
  {
   value: "Quatro Rodas (BRQRO)",
   label: "Quatro Rodas (BRQRO)"
  },
  {
   value: "Queimados (BRQMA)",
   label: "Queimados (BRQMA)"
  },
  {
   value: "Queluz (BRQLU)",
   label: "Queluz (BRQLU)"
  },
  {
   value: "Quirinopolis (BRQPO)",
   label: "Quirinopolis (BRQPO)"
  },
  {
   value: "Quixada (BRQXA)",
   label: "Quixada (BRQXA)"
  },
  {
   value: "Pouso Alto (BRPST)",
   label: "Pouso Alto (BRPST)"
  },
  {
   value: "Ponte Nova (BRPNV)",
   label: "Ponte Nova (BRPNV)"
  },
  {
   value: "Porangatu (BRRGT)",
   label: "Porangatu (BRRGT)"
  },
  {
   value: "Porciuncula (BRPNC)",
   label: "Porciuncula (BRPNC)"
  },
  {
   value: "Porecatu (BRPOT)",
   label: "Porecatu (BRPOT)"
  },
  {
   value: "Portao (BRPAO)",
   label: "Portao (BRPAO)"
  },
  {
   value: "Porteirinha (BRPTH)",
   label: "Porteirinha (BRPTH)"
  },
  {
   value: "Porto Belo (BRPBO)",
   label: "Porto Belo (BRPBO)"
  },
  {
   value: "Porto de cebedelo (BRPCB)",
   label: "Porto de cebedelo (BRPCB)"
  },
  {
   value: "Porto de Galinhas (BRPGS)",
   label: "Porto de Galinhas (BRPGS)"
  },
  {
   value: "Pôrto de Sauípe (BRCSI)",
   label: "Pôrto de Sauípe (BRCSI)"
  },
  {
   value: "Porto do Mangue (BRPTM)",
   label: "Porto do Mangue (BRPTM)"
  },
  {
   value: "Porto Feliz (BRPTZ)",
   label: "Porto Feliz (BRPTZ)"
  },
  {
   value: "Porto Ferreira (BRPTF)",
   label: "Porto Ferreira (BRPTF)"
  },
  {
   value: "Porto Franco (BRPTC)",
   label: "Porto Franco (BRPTC)"
  },
  {
   value: "Porto Murtinho (BRPMH)",
   label: "Porto Murtinho (BRPMH)"
  },
  {
   value: "Porto Real (BRPTE)",
   label: "Porto Real (BRPTE)"
  },
  {
   value: "Porto Rico (BRPTR)",
   label: "Porto Rico (BRPTR)"
  },
  {
   value: "Porto Trombetas (BRBTB)",
   label: "Porto Trombetas (BRBTB)"
  },
  {
   value: "Porto Uniao (BRPUN)",
   label: "Porto Uniao (BRPUN)"
  },
  {
   value: "Porto Xavier (BRPXI)",
   label: "Porto Xavier (BRPXI)"
  },
  {
   value: "Posse (BRPSS)",
   label: "Posse (BRPSS)"
  },
  {
   value: "Posto da Mata (BRPTD)",
   label: "Posto da Mata (BRPTD)"
  },
  {
   value: "Potirendaba (BRPOD)",
   label: "Potirendaba (BRPOD)"
  },
  {
   value: "Pontalina (BRPLI)",
   label: "Pontalina (BRPLI)"
  },
  {
   value: "Pirapora do Bom Jesus (BRPBJ)",
   label: "Pirapora do Bom Jesus (BRPBJ)"
  },
  {
   value: "Pirapozinho (BRPZO)",
   label: "Pirapozinho (BRPZO)"
  },
  {
   value: "Piraquara (BRPQA)",
   label: "Piraquara (BRPQA)"
  },
  {
   value: "Piratini (BRPIA)",
   label: "Piratini (BRPIA)"
  },
  {
   value: "Piratuba (BRPRB)",
   label: "Piratuba (BRPRB)"
  },
  {
   value: "Pirauba (BRPIB)",
   label: "Pirauba (BRPIB)"
  },
  {
   value: "Pirenopolis (BRPLS)",
   label: "Pirenopolis (BRPLS)"
  },
  {
   value: "Pires do Rio (BRPSR)",
   label: "Pires do Rio (BRPSR)"
  },
  {
   value: "Piripiri (BRPIP)",
   label: "Piripiri (BRPIP)"
  },
  {
   value: "Pirituba (BRPTB)",
   label: "Pirituba (BRPTB)"
  },
  {
   value: "Pitanga (BRTGA)",
   label: "Pitanga (BRTGA)"
  },
  {
   value: "Pitangueiras (BRPGA)",
   label: "Pitangueiras (BRPGA)"
  },
  {
   value: "Pitangui (BRPAG)",
   label: "Pitangui (BRPAG)"
  },
  {
   value: "Pitimbu (BRPMU)",
   label: "Pitimbu (BRPMU)"
  },
  {
   value: "Piuma (BRPUM)",
   label: "Piuma (BRPUM)"
  },
  {
   value: "Piumhi (BRPUH)",
   label: "Piumhi (BRPUH)"
  },
  {
   value: "Planalto (BRPLT)",
   label: "Planalto (BRPLT)"
  },
  {
   value: "Planura (BRPLN)",
   label: "Planura (BRPLN)"
  },
  {
   value: "Poa (BRPQZ)",
   label: "Poa (BRPQZ)"
  },
  {
   value: "Poco Fundo (BRPCF)",
   label: "Poco Fundo (BRPCF)"
  },
  {
   value: "Pocoes (BRPOC)",
   label: "Pocoes (BRPOC)"
  },
  {
   value: "Pocone (BRPCN)",
   label: "Pocone (BRPCN)"
  },
  {
   value: "Pojuca (BRPJC)",
   label: "Pojuca (BRPJC)"
  },
  {
   value: "Pomerode (BRPOM)",
   label: "Pomerode (BRPOM)"
  },
  {
   value: "Pompéia (BRPPA)",
   label: "Pompéia (BRPPA)"
  },
  {
   value: "Ponta do Félix\/Antonina (BRPFX)",
   label: "Ponta do Félix\/Antonina (BRPFX)"
  },
  {
   value: "Ponta Pora (BRPOP)",
   label: "Ponta Pora (BRPOP)"
  },
  {
   value: "Pontal (BRPTL)",
   label: "Pontal (BRPTL)"
  },
  {
   value: "Penha (BRPHA)",
   label: "Penha (BRPHA)"
  },
  {
   value: "Perdizes (BRPZS)",
   label: "Perdizes (BRPZS)"
  },
  {
   value: "Perdoes (BRPDS)",
   label: "Perdoes (BRPDS)"
  },
  {
   value: "Pereira Barreto (BRPBA)",
   label: "Pereira Barreto (BRPBA)"
  },
  {
   value: "Pereiras (BRPER)",
   label: "Pereiras (BRPER)"
  },
  {
   value: "Peres (BRPES)",
   label: "Peres (BRPES)"
  },
  {
   value: "Perola (BRPRL)",
   label: "Perola (BRPRL)"
  },
  {
   value: "Peruibe (BRPUB)",
   label: "Peruibe (BRPUB)"
  },
  {
   value: "Pesqueira (BRPQE)",
   label: "Pesqueira (BRPQE)"
  },
  {
   value: "Piacatu (BRPIT)",
   label: "Piacatu (BRPIT)"
  },
  {
   value: "Picarras (BRPRR)",
   label: "Picarras (BRPRR)"
  },
  {
   value: "Piedade (BRPDD)",
   label: "Piedade (BRPDD)"
  },
  {
   value: "Piedade (BRPIE)",
   label: "Piedade (BRPIE)"
  },
  {
   value: "Pilar do Sul (BRPSL)",
   label: "Pilar do Sul (BRPSL)"
  },
  {
   value: "Pimenta (BRPMT)",
   label: "Pimenta (BRPMT)"
  },
  {
   value: "Pimenteiras do Oeste (BRPSO)",
   label: "Pimenteiras do Oeste (BRPSO)"
  },
  {
   value: "Pindamonhangaba (BRPNM)",
   label: "Pindamonhangaba (BRPNM)"
  },
  {
   value: "Pindorama (BRPND)",
   label: "Pindorama (BRPND)"
  },
  {
   value: "Pinhais (BRPHS)",
   label: "Pinhais (BRPHS)"
  },
  {
   value: "Pinhais (BRPIH)",
   label: "Pinhais (BRPIH)"
  },
  {
   value: "Pinhalzinho (BRPZI)",
   label: "Pinhalzinho (BRPZI)"
  },
  {
   value: "Pinheiro Machado (BRPRC)",
   label: "Pinheiro Machado (BRPRC)"
  },
  {
   value: "Piracaia (BRPCI)",
   label: "Piracaia (BRPCI)"
  },
  {
   value: "Piracanjuba (BRPJU)",
   label: "Piracanjuba (BRPJU)"
  },
  {
   value: "Pirai (BRPIR)",
   label: "Pirai (BRPIR)"
  },
  {
   value: "Piraju (BRPJA)",
   label: "Piraju (BRPJA)"
  },
  {
   value: "Pirajui (BRPJR)",
   label: "Pirajui (BRPJR)"
  },
  {
   value: "Pirangi (BRPRG)",
   label: "Pirangi (BRPRG)"
  },
  {
   value: "Penedo (BRPNE)",
   label: "Penedo (BRPNE)"
  },
  {
   value: "Piranhas (BRPNH)",
   label: "Piranhas (BRPNH)"
  },
  {
   value: "Pirapetinga (BRPTA)",
   label: "Pirapetinga (BRPTA)"
  },
  {
   value: "Parauna (BRPRN)",
   label: "Parauna (BRPRN)"
  },
  {
   value: "Pariquera-Acu (BRPAC)",
   label: "Pariquera-Acu (BRPAC)"
  },
  {
   value: "Parnamirim (BRPMM)",
   label: "Parnamirim (BRPMM)"
  },
  {
   value: "Parobe (BRPRE)",
   label: "Parobe (BRPRE)"
  },
  {
   value: "Passa Quatro (BRPQO)",
   label: "Passa Quatro (BRPQO)"
  },
  {
   value: "Pati dos Alferes (BRPAF)",
   label: "Pati dos Alferes (BRPAF)"
  },
  {
   value: "Patolina (BRPTN)",
   label: "Patolina (BRPTN)"
  },
  {
   value: "Patos (BRPTS)",
   label: "Patos (BRPTS)"
  },
  {
   value: "Patos De Minas (BRPOJ)",
   label: "Patos De Minas (BRPOJ)"
  },
  {
   value: "Patrocinio (BRPCO)",
   label: "Patrocinio (BRPCO)"
  },
  {
   value: "Patrocinio Paulista (BRPPS)",
   label: "Patrocinio Paulista (BRPPS)"
  },
  {
   value: "Paula Freitas (BRPFT)",
   label: "Paula Freitas (BRPFT)"
  },
  {
   value: "Paulinia (BRPUI)",
   label: "Paulinia (BRPUI)"
  },
  {
   value: "Paulista (BRPAL)",
   label: "Paulista (BRPAL)"
  },
  {
   value: "Paulo de Faria (BRPFA)",
   label: "Paulo de Faria (BRPFA)"
  },
  {
   value: "Pavao (BRPVA)",
   label: "Pavao (BRPVA)"
  },
  {
   value: "Pavuna (BRPVU)",
   label: "Pavuna (BRPVU)"
  },
  {
   value: "Pecém (BRPEC)",
   label: "Pecém (BRPEC)"
  },
  {
   value: "Pederneiras (BRPNS)",
   label: "Pederneiras (BRPNS)"
  },
  {
   value: "Pedras Negras (BRPEN)",
   label: "Pedras Negras (BRPEN)"
  },
  {
   value: "Pedregulho (BRPGU)",
   label: "Pedregulho (BRPGU)"
  },
  {
   value: "Pedreira (BRPDI)",
   label: "Pedreira (BRPDI)"
  },
  {
   value: "Pedreiras (BRPDA)",
   label: "Pedreiras (BRPDA)"
  },
  {
   value: "Pedrinhas Paulista (BRPPT)",
   label: "Pedrinhas Paulista (BRPPT)"
  },
  {
   value: "Pedro Canario (BRPCA)",
   label: "Pedro Canario (BRPCA)"
  },
  {
   value: "Pedro Leopoldo (BRPLE)",
   label: "Pedro Leopoldo (BRPLE)"
  },
  {
   value: "Peixoto de Azevedo (BRPXA)",
   label: "Peixoto de Azevedo (BRPXA)"
  },
  {
   value: "Parauapebas (BRPRS)",
   label: "Parauapebas (BRPRS)"
  },
  {
   value: "Penapolis (BRPNP)",
   label: "Penapolis (BRPNP)"
  },
  {
   value: "Penedo (BRPDO)",
   label: "Penedo (BRPDO)"
  },
  {
   value: "Palmeiras (BRPMR)",
   label: "Palmeiras (BRPMR)"
  },
  {
   value: "Palmeiropolis (BRPPO)",
   label: "Palmeiropolis (BRPPO)"
  },
  {
   value: "Palmital (BRPML)",
   label: "Palmital (BRPML)"
  },
  {
   value: "Palmitos (BRPLO)",
   label: "Palmitos (BRPLO)"
  },
  {
   value: "Palotina (BRPLA)",
   label: "Palotina (BRPLA)"
  },
  {
   value: "Panambi (BRPNI)",
   label: "Panambi (BRPNI)"
  },
  {
   value: "Panorama (BRPNA)",
   label: "Panorama (BRPNA)"
  },
  {
   value: "Pantanal (BRPNL)",
   label: "Pantanal (BRPNL)"
  },
  {
   value: "Pantanal (BRPNT)",
   label: "Pantanal (BRPNT)"
  },
  {
   value: "Papagaios (BRPAP)",
   label: "Papagaios (BRPAP)"
  },
  {
   value: "Pará (BRPAR)",
   label: "Pará (BRPAR)"
  },
  {
   value: "Para de Minas (BRPMN)",
   label: "Para de Minas (BRPMN)"
  },
  {
   value: "Paracatu (BRPCT)",
   label: "Paracatu (BRPCT)"
  },
  {
   value: "Paracuru (BRPRU)",
   label: "Paracuru (BRPRU)"
  },
  {
   value: "Paragominas (BRPGO)",
   label: "Paragominas (BRPGO)"
  },
  {
   value: "Paraguacu (BRPUC)",
   label: "Paraguacu (BRPUC)"
  },
  {
   value: "Paraguacu Paulista (BRPPI)",
   label: "Paraguacu Paulista (BRPPI)"
  },
  {
   value: "Paraiba do Sul (BRPSU)",
   label: "Paraiba do Sul (BRPSU)"
  },
  {
   value: "Paraibuna (BRPBU)",
   label: "Paraibuna (BRPBU)"
  },
  {
   value: "Paraiso (BRPRI)",
   label: "Paraiso (BRPRI)"
  },
  {
   value: "Paraiso do Sul (BRPUL)",
   label: "Paraiso do Sul (BRPUL)"
  },
  {
   value: "Paraiso do Tocantins (BRPTI)",
   label: "Paraiso do Tocantins (BRPTI)"
  },
  {
   value: "Paraisopolis (BRPRO)",
   label: "Paraisopolis (BRPRO)"
  },
  {
   value: "Paranã (BRPNN)",
   label: "Paranã (BRPNN)"
  },
  {
   value: "Paranaiba (BRPBB)",
   label: "Paranaiba (BRPBB)"
  },
  {
   value: "Paranaita (BRPRT)",
   label: "Paranaita (BRPRT)"
  },
  {
   value: "Paranapanema (BRPPM)",
   label: "Paranapanema (BRPPM)"
  },
  {
   value: "Paranatinga (BRPTG)",
   label: "Paranatinga (BRPTG)"
  },
  {
   value: "Paranauna (BRPNU)",
   label: "Paranauna (BRPNU)"
  },
  {
   value: "Paranoa (BRPNO)",
   label: "Paranoa (BRPNO)"
  },
  {
   value: "Paraopeba (BRPPE)",
   label: "Paraopeba (BRPPE)"
  },
  {
   value: "Palmeira dos Indios (BRPIS)",
   label: "Palmeira dos Indios (BRPIS)"
  },
  {
   value: "Parapua (BRPPU)",
   label: "Parapua (BRPPU)"
  },
  {
   value: "Parati (BRPAT)",
   label: "Parati (BRPAT)"
  },
  {
   value: "Ocidental (BRODI)",
   label: "Ocidental (BRODI)"
  },
  {
   value: "Olimpia (BROLI)",
   label: "Olimpia (BROLI)"
  },
  {
   value: "Olinda (BROLA)",
   label: "Olinda (BROLA)"
  },
  {
   value: "Oliveira (BROVA)",
   label: "Oliveira (BROVA)"
  },
  {
   value: "Oriente (BRORI)",
   label: "Oriente (BRORI)"
  },
  {
   value: "Orlandia (BRORL)",
   label: "Orlandia (BRORL)"
  },
  {
   value: "Orleans (BROLS)",
   label: "Orleans (BROLS)"
  },
  {
   value: "Osorio (BROSO)",
   label: "Osorio (BROSO)"
  },
  {
   value: "Osvaldo Cruz (BROCZ)",
   label: "Osvaldo Cruz (BROCZ)"
  },
  {
   value: "Otacilio Costa (BROCA)",
   label: "Otacilio Costa (BROCA)"
  },
  {
   value: "Ourilandia do Norte (BRONO)",
   label: "Ourilandia do Norte (BRONO)"
  },
  {
   value: "Ouro Branco (BROBR)",
   label: "Ouro Branco (BROBR)"
  },
  {
   value: "Ouro Fino (BROFI)",
   label: "Ouro Fino (BROFI)"
  },
  {
   value: "Ouro Preto (BROPO)",
   label: "Ouro Preto (BROPO)"
  },
  {
   value: "Ouro Preto do Oeste (BROPE)",
   label: "Ouro Preto do Oeste (BROPE)"
  },
  {
   value: "Ouro Verde (BROVD)",
   label: "Ouro Verde (BROVD)"
  },
  {
   value: "Ouroeste (BRORE)",
   label: "Ouroeste (BRORE)"
  },
  {
   value: "Outeiro (BROUT)",
   label: "Outeiro (BROUT)"
  },
  {
   value: "Pacaembu (BRPCU)",
   label: "Pacaembu (BRPCU)"
  },
  {
   value: "Pacajá (BRPAJ)",
   label: "Pacajá (BRPAJ)"
  },
  {
   value: "Pacajus (BRPCJ)",
   label: "Pacajus (BRPCJ)"
  },
  {
   value: "Pacatuba (BRPTU)",
   label: "Pacatuba (BRPTU)"
  },
  {
   value: "Padre Bernardo (BRPBE)",
   label: "Padre Bernardo (BRPBE)"
  },
  {
   value: "Palestina (BRPSI)",
   label: "Palestina (BRPSI)"
  },
  {
   value: "Palhoca (BRPHO)",
   label: "Palhoca (BRPHO)"
  },
  {
   value: "Palmares (BRPMS)",
   label: "Palmares (BRPMS)"
  },
  {
   value: "Palmares Paulista (BRPAE)",
   label: "Palmares Paulista (BRPAE)"
  },
  {
   value: "Palmas Parana (BRPPR)",
   label: "Palmas Parana (BRPPR)"
  },
  {
   value: "Palmeira (BRPMI)",
   label: "Palmeira (BRPMI)"
  },
  {
   value: "Palmeira das Missoes (BRPME)",
   label: "Palmeira das Missoes (BRPME)"
  },
  {
   value: "Palmeira do Oeste (BRPOS)",
   label: "Palmeira do Oeste (BRPOS)"
  },
  {
   value: "Nortolandia (BRNTO)",
   label: "Nortolandia (BRNTO)"
  },
  {
   value: "Nossa Senhora do Socorro (BRNSS)",
   label: "Nossa Senhora do Socorro (BRNSS)"
  },
  {
   value: "Nova Almeida (BRNAI)",
   label: "Nova Almeida (BRNAI)"
  },
  {
   value: "Nova Andradina (BRNAD)",
   label: "Nova Andradina (BRNAD)"
  },
  {
   value: "Nova Apar Campinas (BRNAC)",
   label: "Nova Apar Campinas (BRNAC)"
  },
  {
   value: "Nova Aurora (BRNUR)",
   label: "Nova Aurora (BRNUR)"
  },
  {
   value: "Nova Bassano (BRNBA)",
   label: "Nova Bassano (BRNBA)"
  },
  {
   value: "Nova Caiaponia (BRNCA)",
   label: "Nova Caiaponia (BRNCA)"
  },
  {
   value: "Nova Era (BRNER)",
   label: "Nova Era (BRNER)"
  },
  {
   value: "Nova Esperanca (BRNEC)",
   label: "Nova Esperanca (BRNEC)"
  },
  {
   value: "Nova Europa (BRNEU)",
   label: "Nova Europa (BRNEU)"
  },
  {
   value: "Nova Friburgo (BRNFU)",
   label: "Nova Friburgo (BRNFU)"
  },
  {
   value: "Nova Gloria (BRNGO)",
   label: "Nova Gloria (BRNGO)"
  },
  {
   value: "Nova Granada (BRNGA)",
   label: "Nova Granada (BRNGA)"
  },
  {
   value: "Nova Hartz (BRHAR)",
   label: "Nova Hartz (BRHAR)"
  },
  {
   value: "Nova Iguacu (BRNIU)",
   label: "Nova Iguacu (BRNIU)"
  },
  {
   value: "Nova Laranjeiras (BRNVL)",
   label: "Nova Laranjeiras (BRNVL)"
  },
  {
   value: "Nova Lima (BRNLI)",
   label: "Nova Lima (BRNLI)"
  },
  {
   value: "Nova Londrina (BRNLO)",
   label: "Nova Londrina (BRNLO)"
  },
  {
   value: "Nova Mutum (BRNMU)",
   label: "Nova Mutum (BRNMU)"
  },
  {
   value: "Nova Odessa (BRNOD)",
   label: "Nova Odessa (BRNOD)"
  },
  {
   value: "Nova Petropolis (BRNPE)",
   label: "Nova Petropolis (BRNPE)"
  },
  {
   value: "Nova Ponte (BRNPT)",
   label: "Nova Ponte (BRNPT)"
  },
  {
   value: "Nova Prata (BRNPA)",
   label: "Nova Prata (BRNPA)"
  },
  {
   value: "Nova Santa Rita (BRNSR)",
   label: "Nova Santa Rita (BRNSR)"
  },
  {
   value: "Nova Serrana (BRNSA)",
   label: "Nova Serrana (BRNSA)"
  },
  {
   value: "Nova Venecia (BRNVC)",
   label: "Nova Venecia (BRNVC)"
  },
  {
   value: "Nova Vicosa (BRNVO)",
   label: "Nova Vicosa (BRNVO)"
  },
  {
   value: "Novo Horizonte (BRNHO)",
   label: "Novo Horizonte (BRNHO)"
  },
  {
   value: "Novo Progresso (BRNOV)",
   label: "Novo Progresso (BRNOV)"
  },
  {
   value: "Novo Sao Joaquim (BRNSJ)",
   label: "Novo Sao Joaquim (BRNSJ)"
  },
  {
   value: "Nobres (BRNBE)",
   label: "Nobres (BRNBE)"
  },
  {
   value: "Montes (BRMTS)",
   label: "Montes (BRMTS)"
  },
  {
   value: "Montes Claros de Goias (BRMCG)",
   label: "Montes Claros de Goias (BRMCG)"
  },
  {
   value: "Moreno (BRMRE)",
   label: "Moreno (BRMRE)"
  },
  {
   value: "Mormaco (BRMMA)",
   label: "Mormaco (BRMMA)"
  },
  {
   value: "Morretes (BRMRS)",
   label: "Morretes (BRMRS)"
  },
  {
   value: "Morrinhos (BRMHO)",
   label: "Morrinhos (BRMHO)"
  },
  {
   value: "Morro Agudo (BRMOA)",
   label: "Morro Agudo (BRMOA)"
  },
  {
   value: "Morro de Sao Paulo (BRMSP)",
   label: "Morro de Sao Paulo (BRMSP)"
  },
  {
   value: "Morungaba (BRMRG)",
   label: "Morungaba (BRMRG)"
  },
  {
   value: "Mosqueiro (BRMQR)",
   label: "Mosqueiro (BRMQR)"
  },
  {
   value: "Mostardas (BRMTD)",
   label: "Mostardas (BRMTD)"
  },
  {
   value: "Mozarlandia (BRMZA)",
   label: "Mozarlandia (BRMZA)"
  },
  {
   value: "Mundai (BRMUN)",
   label: "Mundai (BRMUN)"
  },
  {
   value: "Mundo Novo (BRMNV)",
   label: "Mundo Novo (BRMNV)"
  },
  {
   value: "Mundo Novo de Goias (BRMVG)",
   label: "Mundo Novo de Goias (BRMVG)"
  },
  {
   value: "Munhoz (BRMHZ)",
   label: "Munhoz (BRMHZ)"
  },
  {
   value: "Muriae (BRMUR)",
   label: "Muriae (BRMUR)"
  },
  {
   value: "Murucupi (BRMUC)",
   label: "Murucupi (BRMUC)"
  },
  {
   value: "Muzambinho (BRMZI)",
   label: "Muzambinho (BRMZI)"
  },
  {
   value: "Nao Me Toque (BRNTQ)",
   label: "Nao Me Toque (BRNTQ)"
  },
  {
   value: "Navirai (BRNVI)",
   label: "Navirai (BRNVI)"
  },
  {
   value: "Nazare (BRNZA)",
   label: "Nazare (BRNZA)"
  },
  {
   value: "Nazare Paulista (BRNPU)",
   label: "Nazare Paulista (BRNPU)"
  },
  {
   value: "Nhandeara (BRNHA)",
   label: "Nhandeara (BRNHA)"
  },
  {
   value: "Nilopolis (BRNPO)",
   label: "Nilopolis (BRNPO)"
  },
  {
   value: "Nizia Floresta (BRNFO)",
   label: "Nizia Floresta (BRNFO)"
  },
  {
   value: "Monteiro Lobato (BRMLO)",
   label: "Monteiro Lobato (BRMLO)"
  },
  {
   value: "Mimoso do Oeste (BRMOS)",
   label: "Mimoso do Oeste (BRMOS)"
  },
  {
   value: "Mineiros (BRMNS)",
   label: "Mineiros (BRMNS)"
  },
  {
   value: "Miracatu (BRMCT)",
   label: "Miracatu (BRMCT)"
  },
  {
   value: "Miracema (BRMCM)",
   label: "Miracema (BRMCM)"
  },
  {
   value: "Miracema do Tocantins (BRMTN)",
   label: "Miracema do Tocantins (BRMTN)"
  },
  {
   value: "Mirai (BRMIA)",
   label: "Mirai (BRMIA)"
  },
  {
   value: "Miranda (BRMRD)",
   label: "Miranda (BRMRD)"
  },
  {
   value: "Mirandopolis (BRMDO)",
   label: "Mirandopolis (BRMDO)"
  },
  {
   value: "Mirante do Paranapanema (BRMPM)",
   label: "Mirante do Paranapanema (BRMPM)"
  },
  {
   value: "Mirassol (BRMIR)",
   label: "Mirassol (BRMIR)"
  },
  {
   value: "Mirassol do Oeste (BRMSO)",
   label: "Mirassol do Oeste (BRMSO)"
  },
  {
   value: "Mococa (BRMOO)",
   label: "Mococa (BRMOO)"
  },
  {
   value: "Mogi Guacu (BRMGG)",
   label: "Mogi Guacu (BRMGG)"
  },
  {
   value: "Mogi Mirim (BRMMI)",
   label: "Mogi Mirim (BRMMI)"
  },
  {
   value: "Mombuca (BRMBU)",
   label: "Mombuca (BRMBU)"
  },
  {
   value: "Mongagua (BRMNU)",
   label: "Mongagua (BRMNU)"
  },
  {
   value: "Monsenhor Paulo (BRMPL)",
   label: "Monsenhor Paulo (BRMPL)"
  },
  {
   value: "Montanha (BRMNH)",
   label: "Montanha (BRMNH)"
  },
  {
   value: "Monte Alegre de Minas (BRMAM)",
   label: "Monte Alegre de Minas (BRMAM)"
  },
  {
   value: "Monte Alegre do Sul (BRMAS)",
   label: "Monte Alegre do Sul (BRMAS)"
  },
  {
   value: "Monte Alto (BRMTT)",
   label: "Monte Alto (BRMTT)"
  },
  {
   value: "Monte Aprazivel (BRMAZ)",
   label: "Monte Aprazivel (BRMAZ)"
  },
  {
   value: "Monte Azul Paulista (BRMAP)",
   label: "Monte Azul Paulista (BRMAP)"
  },
  {
   value: "Monte Carmelo (BRMCE)",
   label: "Monte Carmelo (BRMCE)"
  },
  {
   value: "Monte Mor (BRMTM)",
   label: "Monte Mor (BRMTM)"
  },
  {
   value: "Monte Negro (BRMNG)",
   label: "Monte Negro (BRMNG)"
  },
  {
   value: "Monte Siao (BRMSI)",
   label: "Monte Siao (BRMSI)"
  },
  {
   value: "Monte Verde (BRMVE)",
   label: "Monte Verde (BRMVE)"
  },
  {
   value: "Monteiro (BRMME)",
   label: "Monteiro (BRMME)"
  },
  {
   value: "Mimoso (BRMMO)",
   label: "Mimoso (BRMMO)"
  },
  {
   value: "Marcelandia (BRMCL)",
   label: "Marcelandia (BRMCL)"
  },
  {
   value: "Marcelino Ramos (BRMRA)",
   label: "Marcelino Ramos (BRMRA)"
  },
  {
   value: "Marechal Deodoro (BRMDE)",
   label: "Marechal Deodoro (BRMDE)"
  },
  {
   value: "Marechal Floriano (BRMFO)",
   label: "Marechal Floriano (BRMFO)"
  },
  {
   value: "Maria Farinha (BRMFA)",
   label: "Maria Farinha (BRMFA)"
  },
  {
   value: "Marialva (BRMAV)",
   label: "Marialva (BRMAV)"
  },
  {
   value: "Mariana (BRMRI)",
   label: "Mariana (BRMRI)"
  },
  {
   value: "Marica (BRMRC)",
   label: "Marica (BRMRC)"
  },
  {
   value: "Martinho Campos (BRMCO)",
   label: "Martinho Campos (BRMCO)"
  },
  {
   value: "Martinopolis (BRMPO)",
   label: "Martinopolis (BRMPO)"
  },
  {
   value: "Massaranduba (BRMSA)",
   label: "Massaranduba (BRMSA)"
  },
  {
   value: "Mata (BRMTA)",
   label: "Mata (BRMTA)"
  },
  {
   value: "Mata de Sao Joao (BRMSJ)",
   label: "Mata de Sao Joao (BRMSJ)"
  },
  {
   value: "Matao (BRMAT)",
   label: "Matao (BRMAT)"
  },
  {
   value: "Matelandia (BRMLA)",
   label: "Matelandia (BRMLA)"
  },
  {
   value: "Mateus Leme (BRMTL)",
   label: "Mateus Leme (BRMTL)"
  },
  {
   value: "Matias Barbosa (BRMBA)",
   label: "Matias Barbosa (BRMBA)"
  },
  {
   value: "Matinhos (BRMTO)",
   label: "Matinhos (BRMTO)"
  },
  {
   value: "Matozinhos (BRMZS)",
   label: "Matozinhos (BRMZS)"
  },
  {
   value: "Maua (BRMUA)",
   label: "Maua (BRMUA)"
  },
  {
   value: "Maua da Serra (BRMSR)",
   label: "Maua da Serra (BRMSR)"
  },
  {
   value: "Maximiliano de Almeida (BRMXA)",
   label: "Maximiliano de Almeida (BRMXA)"
  },
  {
   value: "Medeiros Neto (BRMNO)",
   label: "Medeiros Neto (BRMNO)"
  },
  {
   value: "Medianeira (BRMDA)",
   label: "Medianeira (BRMDA)"
  },
  {
   value: "Medina (BRMDN)",
   label: "Medina (BRMDN)"
  },
  {
   value: "Mendes (BRMDS)",
   label: "Mendes (BRMDS)"
  },
  {
   value: "Mendonca (BRMDC)",
   label: "Mendonca (BRMDC)"
  },
  {
   value: "Meruoca (BRMRU)",
   label: "Meruoca (BRMRU)"
  },
  {
   value: "Mesquita (BRMQU)",
   label: "Mesquita (BRMQU)"
  },
  {
   value: "Miguel Pereira (BRMPE)",
   label: "Miguel Pereira (BRMPE)"
  },
  {
   value: "Miguelopolis (BRMPI)",
   label: "Miguelopolis (BRMPI)"
  },
  {
   value: "Maravilhas (BRMHS)",
   label: "Maravilhas (BRMHS)"
  },
  {
   value: "Macatuba (BRMTU)",
   label: "Macatuba (BRMTU)"
  },
  {
   value: "Machado (BRMCA)",
   label: "Machado (BRMCA)"
  },
  {
   value: "Madre-de-Deus (BRMAD)",
   label: "Madre-de-Deus (BRMAD)"
  },
  {
   value: "Mae do Rio (BRMRO)",
   label: "Mae do Rio (BRMRO)"
  },
  {
   value: "Mage (BRMAG)",
   label: "Mage (BRMAG)"
  },
  {
   value: "Mairinque (BRMQE)",
   label: "Mairinque (BRMQE)"
  },
  {
   value: "Mairipora (BRQMC)",
   label: "Mairipora (BRQMC)"
  },
  {
   value: "Mal Candido Rondon (BRMCR)",
   label: "Mal Candido Rondon (BRMCR)"
  },
  {
   value: "Malhador (BRMHA)",
   label: "Malhador (BRMHA)"
  },
  {
   value: "Mallet (BRMAL)",
   label: "Mallet (BRMAL)"
  },
  {
   value: "Mamanguape (BRMPU)",
   label: "Mamanguape (BRMPU)"
  },
  {
   value: "Manacapuru (BRMPR)",
   label: "Manacapuru (BRMPR)"
  },
  {
   value: "Mandaguacu (BRMGC)",
   label: "Mandaguacu (BRMGC)"
  },
  {
   value: "Mandaguari (BRMDI)",
   label: "Mandaguari (BRMDI)"
  },
  {
   value: "Manduri (BRMNI)",
   label: "Manduri (BRMNI)"
  },
  {
   value: "Mangue Seco (BRMSE)",
   label: "Mangue Seco (BRMSE)"
  },
  {
   value: "Manhuacu (BRMHU)",
   label: "Manhuacu (BRMHU)"
  },
  {
   value: "Manhumirim (BRMHI)",
   label: "Manhumirim (BRMHI)"
  },
  {
   value: "Mantena (BRMNA)",
   label: "Mantena (BRMNA)"
  },
  {
   value: "Maquine (BRMQI)",
   label: "Maquine (BRMQI)"
  },
  {
   value: "Maracai (BRMCI)",
   label: "Maracai (BRMCI)"
  },
  {
   value: "Maracaju (BRMJU)",
   label: "Maracaju (BRMJU)"
  },
  {
   value: "Maracanau (BRMCN)",
   label: "Maracanau (BRMCN)"
  },
  {
   value: "Maragogi (BRMGO)",
   label: "Maragogi (BRMGO)"
  },
  {
   value: "Maragogipe (BRMAR)",
   label: "Maragogipe (BRMAR)"
  },
  {
   value: "Maranguape (BRMGE)",
   label: "Maranguape (BRMGE)"
  },
  {
   value: "Marataizes (BRMTZ)",
   label: "Marataizes (BRMTZ)"
  },
  {
   value: "Marau (BRMAU)",
   label: "Marau (BRMAU)"
  },
  {
   value: "Maravilha (BRMVA)",
   label: "Maravilha (BRMVA)"
  },
  {
   value: "Macaiba (BRMAI)",
   label: "Macaiba (BRMAI)"
  },
  {
   value: "Laranjeiras do Sul (BRLSU)",
   label: "Laranjeiras do Sul (BRLSU)"
  },
  {
   value: "Lauro de Freitas (BRLDF)",
   label: "Lauro de Freitas (BRLDF)"
  },
  {
   value: "Lauro Muller (BRLMU)",
   label: "Lauro Muller (BRLMU)"
  },
  {
   value: "Lavinia (BRLAV)",
   label: "Lavinia (BRLAV)"
  },
  {
   value: "Lavras (BRLAR)",
   label: "Lavras (BRLAR)"
  },
  {
   value: "Lavras do Sul (BRLAS)",
   label: "Lavras do Sul (BRLAS)"
  },
  {
   value: "Lavras Novas (BRLAW)",
   label: "Lavras Novas (BRLAW)"
  },
  {
   value: "Lavrinhas (BRLAX)",
   label: "Lavrinhas (BRLAX)"
  },
  {
   value: "Lebon Regis (BRLER)",
   label: "Lebon Regis (BRLER)"
  },
  {
   value: "Leme (BRLEM)",
   label: "Leme (BRLEM)"
  },
  {
   value: "Lencois (BRLEN)",
   label: "Lencois (BRLEN)"
  },
  {
   value: "Limeira (BRLMR)",
   label: "Limeira (BRLMR)"
  },
  {
   value: "Limoeiro (BRLIM)",
   label: "Limoeiro (BRLIM)"
  },
  {
   value: "Lindoia (BRLIN)",
   label: "Lindoia (BRLIN)"
  },
  {
   value: "Lindolfo Collor (BRLIC)",
   label: "Lindolfo Collor (BRLIC)"
  },
  {
   value: "Linhares (BRLNH)",
   label: "Linhares (BRLNH)"
  },
  {
   value: "Livramento do Brumado (BRLBO)",
   label: "Livramento do Brumado (BRLBO)"
  },
  {
   value: "Loanda (BRLOD)",
   label: "Loanda (BRLOD)"
  },
  {
   value: "Lorena (BRLOR)",
   label: "Lorena (BRLOR)"
  },
  {
   value: "Lorena (BRLRA)",
   label: "Lorena (BRLRA)"
  },
  {
   value: "Lourdes (BRLOU)",
   label: "Lourdes (BRLOU)"
  },
  {
   value: "Louveira (BRLOZ)",
   label: "Louveira (BRLOZ)"
  },
  {
   value: "Lucas do Rio Verde (BRLRV)",
   label: "Lucas do Rio Verde (BRLRV)"
  },
  {
   value: "Lucelia (BRLUC)",
   label: "Lucelia (BRLUC)"
  },
  {
   value: "Luis Antonio (BRLAN)",
   label: "Luis Antonio (BRLAN)"
  },
  {
   value: "Luis Correia (BRLCI)",
   label: "Luis Correia (BRLCI)"
  },
  {
   value: "Luis Eduardo Magalhaes (BRLDM)",
   label: "Luis Eduardo Magalhaes (BRLDM)"
  },
  {
   value: "Luiziania (BRLZI)",
   label: "Luiziania (BRLZI)"
  },
  {
   value: "Luziania (BRLZA)",
   label: "Luziania (BRLZA)"
  },
  {
   value: "Laranjeiras (BRLJS)",
   label: "Laranjeiras (BRLJS)"
  },
  {
   value: "Joao Pinheiro (BRJPH)",
   label: "Joao Pinheiro (BRJPH)"
  },
  {
   value: "Jose Bonifacio (BRJBF)",
   label: "Jose Bonifacio (BRJBF)"
  },
  {
   value: "Juatuba (BRJUT)",
   label: "Juatuba (BRJUT)"
  },
  {
   value: "Juazeiro (BRJZO)",
   label: "Juazeiro (BRJZO)"
  },
  {
   value: "Juazeiro-Pi (BRJZP)",
   label: "Juazeiro-Pi (BRJZP)"
  },
  {
   value: "Julio de Castilhos (BRJCS)",
   label: "Julio de Castilhos (BRJCS)"
  },
  {
   value: "Jundiaí (BRJUN)",
   label: "Jundiaí (BRJUN)"
  },
  {
   value: "Junqueiropolis (BRJRO)",
   label: "Junqueiropolis (BRJRO)"
  },
  {
   value: "Juquia (BRJQU)",
   label: "Juquia (BRJQU)"
  },
  {
   value: "Juquitiba (BRJQB)",
   label: "Juquitiba (BRJQB)"
  },
  {
   value: "Jurubatuba (BRJBU)",
   label: "Jurubatuba (BRJBU)"
  },
  {
   value: "Jussara (BRJSA)",
   label: "Jussara (BRJSA)"
  },
  {
   value: "Lafaete (BRLFA)",
   label: "Lafaete (BRLFA)"
  },
  {
   value: "Lagarto (BRLGO)",
   label: "Lagarto (BRLGO)"
  },
  {
   value: "Lagoa da Confusao (BRLCU)",
   label: "Lagoa da Confusao (BRLCU)"
  },
  {
   value: "Lagoa da Prata (BRLPA)",
   label: "Lagoa da Prata (BRLPA)"
  },
  {
   value: "Lagoa Grande (BRLGP)",
   label: "Lagoa Grande (BRLGP)"
  },
  {
   value: "Lagoa Santa (BRLSA)",
   label: "Lagoa Santa (BRLSA)"
  },
  {
   value: "Lagoa Santa (BRLSN)",
   label: "Lagoa Santa (BRLSN)"
  },
  {
   value: "Lagoa Santa (BRLST)",
   label: "Lagoa Santa (BRLST)"
  },
  {
   value: "Lagoa Vermelha (BRLVE)",
   label: "Lagoa Vermelha (BRLVE)"
  },
  {
   value: "Lajeado (BRLJO)",
   label: "Lajeado (BRLJO)"
  },
  {
   value: "Lambari (BRLBA)",
   label: "Lambari (BRLBA)"
  },
  {
   value: "Lapa (BRLAP)",
   label: "Lapa (BRLAP)"
  },
  {
   value: "Laranjal do Jari (BRLJI)",
   label: "Laranjal do Jari (BRLJI)"
  },
  {
   value: "Laranjal Paulista (BRLPU)",
   label: "Laranjal Paulista (BRLPU)"
  },
  {
   value: "Joao Neiva (BRJNI)",
   label: "Joao Neiva (BRJNI)"
  },
  {
   value: "Jacupiranga (BRJPI)",
   label: "Jacupiranga (BRJPI)"
  },
  {
   value: "Jacutinga (BRJTU)",
   label: "Jacutinga (BRJTU)"
  },
  {
   value: "Jaguaquara (BRJGA)",
   label: "Jaguaquara (BRJGA)"
  },
  {
   value: "Jaguarao (BRJAG)",
   label: "Jaguarao (BRJAG)"
  },
  {
   value: "Jaguarari (BRJGI)",
   label: "Jaguarari (BRJGI)"
  },
  {
   value: "Jaguarari (BRJRA)",
   label: "Jaguarari (BRJRA)"
  },
  {
   value: "Jaguare (BRJGR)",
   label: "Jaguare (BRJGR)"
  },
  {
   value: "Jaguariaíva&nbsp; (BRJRV)",
   label: "Jaguariaíva&nbsp; (BRJRV)"
  },
  {
   value: "Jaguariuna (BRJGN)",
   label: "Jaguariuna (BRJGN)"
  },
  {
   value: "Jaguaruana (BRJAA)",
   label: "Jaguaruana (BRJAA)"
  },
  {
   value: "Jalapao (BRJPO)",
   label: "Jalapao (BRJPO)"
  },
  {
   value: "Jambeiro (BRJBE)",
   label: "Jambeiro (BRJBE)"
  },
  {
   value: "Janauba (BRJNU)",
   label: "Janauba (BRJNU)"
  },
  {
   value: "Jandaia (BRJDA)",
   label: "Jandaia (BRJDA)"
  },
  {
   value: "Jandaia do Sul (BRJSU)",
   label: "Jandaia do Sul (BRJSU)"
  },
  {
   value: "Jandira (BRJDI)",
   label: "Jandira (BRJDI)"
  },
  {
   value: "Jangada (BRJGD)",
   label: "Jangada (BRJGD)"
  },
  {
   value: "Jaracupiranga (BRJPG)",
   label: "Jaracupiranga (BRJPG)"
  },
  {
   value: "Jaragua (BRJRU)",
   label: "Jaragua (BRJRU)"
  },
  {
   value: "Jardim (BRJDM)",
   label: "Jardim (BRJDM)"
  },
  {
   value: "Jardim Alegre (BRJAE)",
   label: "Jardim Alegre (BRJAE)"
  },
  {
   value: "Jardinopolis (BRJPS)",
   label: "Jardinopolis (BRJPS)"
  },
  {
   value: "Jarinu (BRJRI)",
   label: "Jarinu (BRJRI)"
  },
  {
   value: "Jaru (BRJAR)",
   label: "Jaru (BRJAR)"
  },
  {
   value: "Jau (BRJAU)",
   label: "Jau (BRJAU)"
  },
  {
   value: "Jequitinhonha (BRJQA)",
   label: "Jequitinhonha (BRJQA)"
  },
  {
   value: "Jericoacoara (BRJCO)",
   label: "Jericoacoara (BRJCO)"
  },
  {
   value: "Jiquirica (BRJQI)",
   label: "Jiquirica (BRJQI)"
  },
  {
   value: "Joanopolis (BRJOP)",
   label: "Joanopolis (BRJOP)"
  },
  {
   value: "Joao Monlevade (BRJMV)",
   label: "Joao Monlevade (BRJMV)"
  },
  {
   value: "Jacunda (BRJCD)",
   label: "Jacunda (BRJCD)"
  },
  {
   value: "Itarare (BRTRA)",
   label: "Itarare (BRTRA)"
  },
  {
   value: "Itariri (BRIII)",
   label: "Itariri (BRIII)"
  },
  {
   value: "Itatiaia (BRITT)",
   label: "Itatiaia (BRITT)"
  },
  {
   value: "Itatinga (BRIAT)",
   label: "Itatinga (BRIAT)"
  },
  {
   value: "Itau de Minas (BRIUM)",
   label: "Itau de Minas (BRIUM)"
  },
  {
   value: "Itauna (BRIAN)",
   label: "Itauna (BRIAN)"
  },
  {
   value: "Itauna Do Sul (BRISO)",
   label: "Itauna Do Sul (BRISO)"
  },
  {
   value: "Itaunas (BRINU)",
   label: "Itaunas (BRINU)"
  },
  {
   value: "Itinga do Maranhão (BRIDM)",
   label: "Itinga do Maranhão (BRIDM)"
  },
  {
   value: "Itirapina (BRIAP)",
   label: "Itirapina (BRIAP)"
  },
  {
   value: "Itororo (BRITO)",
   label: "Itororo (BRITO)"
  },
  {
   value: "Itu (BRITU)",
   label: "Itu (BRITU)"
  },
  {
   value: "Ituiutaba (BRIUB)",
   label: "Ituiutaba (BRIUB)"
  },
  {
   value: "Itumbiara (BRITR)",
   label: "Itumbiara (BRITR)"
  },
  {
   value: "Itupeva (BRIPV)",
   label: "Itupeva (BRIPV)"
  },
  {
   value: "Ituporanga (BRITD)",
   label: "Ituporanga (BRITD)"
  },
  {
   value: "Iturama (BRIRA)",
   label: "Iturama (BRIRA)"
  },
  {
   value: "Ituverava (BRIVA)",
   label: "Ituverava (BRIVA)"
  },
  {
   value: "Ivaipora (BRIOR)",
   label: "Ivaipora (BRIOR)"
  },
  {
   value: "Ivate (BRIVT)",
   label: "Ivate (BRIVT)"
  },
  {
   value: "Ivinhema (BRIHM)",
   label: "Ivinhema (BRIHM)"
  },
  {
   value: "Jaboatão (BRJAB)",
   label: "Jaboatão (BRJAB)"
  },
  {
   value: "Jaboatao dos Guararapes (BRJGU)",
   label: "Jaboatao dos Guararapes (BRJGU)"
  },
  {
   value: "Jaboticabal (BRJBC)",
   label: "Jaboticabal (BRJBC)"
  },
  {
   value: "Jacaraipe (BRJCA)",
   label: "Jacaraipe (BRJCA)"
  },
  {
   value: "Jacarei (BRJCE)",
   label: "Jacarei (BRJCE)"
  },
  {
   value: "Jacarepagua (BRJPU)",
   label: "Jacarepagua (BRJPU)"
  },
  {
   value: "Jacarezinho (BRCZH)",
   label: "Jacarezinho (BRCZH)"
  },
  {
   value: "Jaciara (BRJCI)",
   label: "Jaciara (BRJCI)"
  },
  {
   value: "Jacinto (BRJAC)",
   label: "Jacinto (BRJAC)"
  },
  {
   value: "Jacuma (BRJCU)",
   label: "Jacuma (BRJCU)"
  },
  {
   value: "Itaqui (BRIQI)",
   label: "Itaqui (BRIQI)"
  },
  {
   value: "Itajobi (BRIJB)",
   label: "Itajobi (BRIJB)"
  },
  {
   value: "Itajuba (BRIAJ)",
   label: "Itajuba (BRIAJ)"
  },
  {
   value: "Itajuipe (BRIJP)",
   label: "Itajuipe (BRIJP)"
  },
  {
   value: "Itamaraca (BRIMC)",
   label: "Itamaraca (BRIMC)"
  },
  {
   value: "Itamaraju (BRIRJ)",
   label: "Itamaraju (BRIRJ)"
  },
  {
   value: "Itamarati de Minas (BRIMN)",
   label: "Itamarati de Minas (BRIMN)"
  },
  {
   value: "Itambe (BRIAE)",
   label: "Itambe (BRIAE)"
  },
  {
   value: "Itambe de Pernambuco (BRIPB)",
   label: "Itambe de Pernambuco (BRIPB)"
  },
  {
   value: "Itamonte (BRIMT)",
   label: "Itamonte (BRIMT)"
  },
  {
   value: "Itanhaem (BRITH)",
   label: "Itanhaem (BRITH)"
  },
  {
   value: "Itanhandu (BRIHA)",
   label: "Itanhandu (BRIHA)"
  },
  {
   value: "Itaocara (BRIOC)",
   label: "Itaocara (BRIOC)"
  },
  {
   value: "Itapagipe (BRIPI)",
   label: "Itapagipe (BRIPI)"
  },
  {
   value: "Itaparica (BRIIC)",
   label: "Itaparica (BRIIC)"
  },
  {
   value: "Itapebi (BRIEB)",
   label: "Itapebi (BRIEB)"
  },
  {
   value: "Itapecerica (BRICC)",
   label: "Itapecerica (BRICC)"
  },
  {
   value: "Itapecerica da Serra (BRISR)",
   label: "Itapecerica da Serra (BRISR)"
  },
  {
   value: "Itapecuru-Mirim (BRIMM)",
   label: "Itapecuru-Mirim (BRIMM)"
  },
  {
   value: "Itapema (BRIEM)",
   label: "Itapema (BRIEM)"
  },
  {
   value: "Itapemirim (BRITZ)",
   label: "Itapemirim (BRITZ)"
  },
  {
   value: "Itaperuna (BRITP)",
   label: "Itaperuna (BRITP)"
  },
  {
   value: "Itapetinga (BRITG)",
   label: "Itapetinga (BRITG)"
  },
  {
   value: "Itapetininga (BRIIG)",
   label: "Itapetininga (BRIIG)"
  },
  {
   value: "Itapeva (BRIAV)",
   label: "Itapeva (BRIAV)"
  },
  {
   value: "Itapevi (BRIEV)",
   label: "Itapevi (BRIEV)"
  },
  {
   value: "Itapipoca (BRIIP)",
   label: "Itapipoca (BRIIP)"
  },
  {
   value: "Itapira (BRTPI)",
   label: "Itapira (BRTPI)"
  },
  {
   value: "Itapiranga (BRIRN)",
   label: "Itapiranga (BRIRN)"
  },
  {
   value: "Itapissuma (BRISM)",
   label: "Itapissuma (BRISM)"
  },
  {
   value: "Itapoa (BRIOA)",
   label: "Itapoa (BRIOA)"
  },
  {
   value: "Itapolis (BRILS)",
   label: "Itapolis (BRILS)"
  },
  {
   value: "Itapora (BRIAO)",
   label: "Itapora (BRIAO)"
  },
  {
   value: "Itaporanga (BRIOG)",
   label: "Itaporanga (BRIOG)"
  },
  {
   value: "Itapuranga (BRIUG)",
   label: "Itapuranga (BRIUG)"
  },
  {
   value: "Itaquaquecetuba (BRIQU)",
   label: "Itaquaquecetuba (BRIQU)"
  },
  {
   value: "Iperó (BRIPQ)",
   label: "Iperó (BRIPQ)"
  },
  {
   value: "Ipeúna (BRIPE)",
   label: "Ipeúna (BRIPE)"
  },
  {
   value: "Ipojuca (BRIPO)",
   label: "Ipojuca (BRIPO)"
  },
  {
   value: "Ipora (BRIPR)",
   label: "Ipora (BRIPR)"
  },
  {
   value: "Ipora do Oeste (BRIOT)",
   label: "Ipora do Oeste (BRIOT)"
  },
  {
   value: "Iporanga (BRIRG)",
   label: "Iporanga (BRIRG)"
  },
  {
   value: "Ipua (BRPUA)",
   label: "Ipua (BRPUA)"
  },
  {
   value: "Iracemapolis (BRIPS)",
   label: "Iracemapolis (BRIPS)"
  },
  {
   value: "Irai (BRRAI)",
   label: "Irai (BRRAI)"
  },
  {
   value: "Iraja (BRIAA)",
   label: "Iraja (BRIAA)"
  },
  {
   value: "Iranduba (BRBAI)",
   label: "Iranduba (BRBAI)"
  },
  {
   value: "Irapuru (BRPRA)",
   label: "Irapuru (BRPRA)"
  },
  {
   value: "Irati (BRATI)",
   label: "Irati (BRATI)"
  },
  {
   value: "Iretama (BRIAM)",
   label: "Iretama (BRIAM)"
  },
  {
   value: "Iriri (BRIRR)",
   label: "Iriri (BRIRR)"
  },
  {
   value: "Ita (BRXTA)",
   label: "Ita (BRXTA)"
  },
  {
   value: "Itabaiana (BRINX)",
   label: "Itabaiana (BRINX)"
  },
  {
   value: "Itabapoana (BRFIP)",
   label: "Itabapoana (BRFIP)"
  },
  {
   value: "Itabatan (BRIBN)",
   label: "Itabatan (BRIBN)"
  },
  {
   value: "Itabera (BRIAB)",
   label: "Itabera (BRIAB)"
  },
  {
   value: "Itaberaba (BRIBA)",
   label: "Itaberaba (BRIBA)"
  },
  {
   value: "Itaberai (BRIAR)",
   label: "Itaberai (BRIAR)"
  },
  {
   value: "Itabira (BRIIR)",
   label: "Itabira (BRIIR)"
  },
  {
   value: "Itabirito (BRIRO)",
   label: "Itabirito (BRIRO)"
  },
  {
   value: "Itaborai (BRIOI)",
   label: "Itaborai (BRIOI)"
  },
  {
   value: "Itacare (BRITC)",
   label: "Itacare (BRITC)"
  },
  {
   value: "Itacuruca (BRIRC)",
   label: "Itacuruca (BRIRC)"
  },
  {
   value: "Itaguai (BRIGI)",
   label: "Itaguai (BRIGI)"
  },
  {
   value: "Itaguara (BRIAG)",
   label: "Itaguara (BRIAG)"
  },
  {
   value: "Itai (BRIAI)",
   label: "Itai (BRIAI)"
  },
  {
   value: "Itaiopolis (BRIPL)",
   label: "Itaiopolis (BRIPL)"
  },
  {
   value: "Itaipava (BRITV)",
   label: "Itaipava (BRITV)"
  },
  {
   value: "Igaratinga (BRIGT)",
   label: "Igaratinga (BRIGT)"
  },
  {
   value: "Igrejinha (BRIGJ)",
   label: "Igrejinha (BRIGJ)"
  },
  {
   value: "Iguape (BRIGP)",
   label: "Iguape (BRIGP)"
  },
  {
   value: "Iguarapava (BRIGV)",
   label: "Iguarapava (BRIGV)"
  },
  {
   value: "Iguatama (BRITM)",
   label: "Iguatama (BRITM)"
  },
  {
   value: "Iguatemi (BRIGM)",
   label: "Iguatemi (BRIGM)"
  },
  {
   value: "Ijaci (BRIJA)",
   label: "Ijaci (BRIJA)"
  },
  {
   value: "Ilha Comprida (BRICO)",
   label: "Ilha Comprida (BRICO)"
  },
  {
   value: "Ilha de Boipeba (BRIBP)",
   label: "Ilha de Boipeba (BRIBP)"
  },
  {
   value: "Ilha de Comandatuba (BRICD)",
   label: "Ilha de Comandatuba (BRICD)"
  },
  {
   value: "Ilha de Marajo (BRIMJ)",
   label: "Ilha de Marajo (BRIMJ)"
  },
  {
   value: "Ilha do Cardoso (BRICS)",
   label: "Ilha do Cardoso (BRICS)"
  },
  {
   value: "Ilha do Governador (BRIGO)",
   label: "Ilha do Governador (BRIGO)"
  },
  {
   value: "Ilha do Governador (BRQGI)",
   label: "Ilha do Governador (BRQGI)"
  },
  {
   value: "Ilha do Mel (BRIME)",
   label: "Ilha do Mel (BRIME)"
  },
  {
   value: "Ilha do Papagaio (BRIPP)",
   label: "Ilha do Papagaio (BRIPP)"
  },
  {
   value: "Ilha Grande (BRIGE)",
   label: "Ilha Grande (BRIGE)"
  },
  {
   value: "Ilha Solteira (BRISA)",
   label: "Ilha Solteira (BRISA)"
  },
  {
   value: "Ilhabela (BRIBE)",
   label: "Ilhabela (BRIBE)"
  },
  {
   value: "Imbassai (BRISI)",
   label: "Imbassai (BRISI)"
  },
  {
   value: "Imbe (BRIMB)",
   label: "Imbe (BRIMB)"
  },
  {
   value: "Imigrante (BRIGR)",
   label: "Imigrante (BRIGR)"
  },
  {
   value: "Indaial (BRIDA)",
   label: "Indaial (BRIDA)"
  },
  {
   value: "Indaiatuba (BRIDU)",
   label: "Indaiatuba (BRIDU)"
  },
  {
   value: "Indiana (BRINA)",
   label: "Indiana (BRINA)"
  },
  {
   value: "Inhauma (BRIHU)",
   label: "Inhauma (BRIHU)"
  },
  {
   value: "Inhumas (BRIHS)",
   label: "Inhumas (BRIHS)"
  },
  {
   value: "Inocencia (BRICE)",
   label: "Inocencia (BRICE)"
  },
  {
   value: "Ipanema (BRIPM)",
   label: "Ipanema (BRIPM)"
  },
  {
   value: "Ipanguacu (BRIGC)",
   label: "Ipanguacu (BRIGC)"
  },
  {
   value: "Igarape-Acu (BRIAC)",
   label: "Igarape-Acu (BRIAC)"
  },
  {
   value: "Guiratinga (BRGTI)",
   label: "Guiratinga (BRGTI)"
  },
  {
   value: "Gurupi (BRGUU)",
   label: "Gurupi (BRGUU)"
  },
  {
   value: "Guzolandia (BRGZO)",
   label: "Guzolandia (BRGZO)"
  },
  {
   value: "Herculandia (BRHLA)",
   label: "Herculandia (BRHLA)"
  },
  {
   value: "Hidrolandia (BRHLI)",
   label: "Hidrolandia (BRHLI)"
  },
  {
   value: "Holambra (BRHLR)",
   label: "Holambra (BRHLR)"
  },
  {
   value: "Horizonte (BRHZO)",
   label: "Horizonte (BRHZO)"
  },
  {
   value: "Horizontina (BRHRZ)",
   label: "Horizontina (BRHRZ)"
  },
  {
   value: "Hortolândia (BRHTL)",
   label: "Hortolândia (BRHTL)"
  },
  {
   value: "Humaita (BRHMA)",
   label: "Humaita (BRHMA)"
  },
  {
   value: "Iaciara (BRICA)",
   label: "Iaciara (BRICA)"
  },
  {
   value: "Iacri (BRICI)",
   label: "Iacri (BRICI)"
  },
  {
   value: "Ibate (BRIBC)",
   label: "Ibate (BRIBC)"
  },
  {
   value: "Ibati (BRIBI)",
   label: "Ibati (BRIBI)"
  },
  {
   value: "Ibia (BRBIA)",
   label: "Ibia (BRBIA)"
  },
  {
   value: "Ibicarai (BRIRI)",
   label: "Ibicarai (BRIRI)"
  },
  {
   value: "Ibipora (BRIPA)",
   label: "Ibipora (BRIPA)"
  },
  {
   value: "Ibira (BRIBR)",
   label: "Ibira (BRIBR)"
  },
  {
   value: "Ibiracu (BRICU)",
   label: "Ibiracu (BRICU)"
  },
  {
   value: "Ibirama (BRIMA)",
   label: "Ibirama (BRIMA)"
  },
  {
   value: "Ibirarema (BRIRM)",
   label: "Ibirarema (BRIRM)"
  },
  {
   value: "Ibirite (BRIRT)",
   label: "Ibirite (BRIRT)"
  },
  {
   value: "Ibiruba (BRIRU)",
   label: "Ibiruba (BRIRU)"
  },
  {
   value: "Ibitinga (BRING)",
   label: "Ibitinga (BRING)"
  },
  {
   value: "Ibitiuva (BRIVU)",
   label: "Ibitiuva (BRIVU)"
  },
  {
   value: "Ibiuna (BRIBU)",
   label: "Ibiuna (BRIBU)"
  },
  {
   value: "Ibo (BRIBO)",
   label: "Ibo (BRIBO)"
  },
  {
   value: "Ibotirama (BRIBT)",
   label: "Ibotirama (BRIBT)"
  },
  {
   value: "Icara (BRICR)",
   label: "Icara (BRICR)"
  },
  {
   value: "Icaraima (BRIMI)",
   label: "Icaraima (BRIMI)"
  },
  {
   value: "Icem (BRICM)",
   label: "Icem (BRICM)"
  },
  {
   value: "Iconha (BRICN)",
   label: "Iconha (BRICN)"
  },
  {
   value: "Iepe (BRIEP)",
   label: "Iepe (BRIEP)"
  },
  {
   value: "Igaraçu (BRIGA)",
   label: "Igaraçu (BRIGA)"
  },
  {
   value: "Igarapava (BRIRP)",
   label: "Igarapava (BRIRP)"
  },
  {
   value: "Igarape (BRIGB)",
   label: "Igarape (BRIGB)"
  },
  {
   value: "Guaimbe (BRGAB)",
   label: "Guaimbe (BRGAB)"
  },
  {
   value: "Guaira (BRGIR)",
   label: "Guaira (BRGIR)"
  },
  {
   value: "Guamaré (BRGUA)",
   label: "Guamaré (BRGUA)"
  },
  {
   value: "Guanhaes (BRGHE)",
   label: "Guanhaes (BRGHE)"
  },
  {
   value: "Guape (BRGPE)",
   label: "Guape (BRGPE)"
  },
  {
   value: "Guapiacu (BRGPC)",
   label: "Guapiacu (BRGPC)"
  },
  {
   value: "Guapiara (BRGPI)",
   label: "Guapiara (BRGPI)"
  },
  {
   value: "Guapimirim (BRGPM)",
   label: "Guapimirim (BRGPM)"
  },
  {
   value: "Guapo (BRGAP)",
   label: "Guapo (BRGAP)"
  },
  {
   value: "Guapore (BRGUP)",
   label: "Guapore (BRGUP)"
  },
  {
   value: "Guara (BRGAR)",
   label: "Guara (BRGAR)"
  },
  {
   value: "Guarabira (BRGBA)",
   label: "Guarabira (BRGBA)"
  },
  {
   value: "Guaracai (BRGRI)",
   label: "Guaracai (BRGRI)"
  },
  {
   value: "Guaraci (BRGAI)",
   label: "Guaraci (BRGAI)"
  },
  {
   value: "Guaraciaba do Norte (BRGNO)",
   label: "Guaraciaba do Norte (BRGNO)"
  },
  {
   value: "Guarai (BRGRQ)",
   label: "Guarai (BRGRQ)"
  },
  {
   value: "Guarajuba (BRGJU)",
   label: "Guarajuba (BRGJU)"
  },
  {
   value: "Guaramirim (BRGRM)",
   label: "Guaramirim (BRGRM)"
  },
  {
   value: "Guaranta do Norte (BRGNR)",
   label: "Guaranta do Norte (BRGNR)"
  },
  {
   value: "Guaraquecaba (BRGQE)",
   label: "Guaraquecaba (BRGQE)"
  },
  {
   value: "Guararapes (BRGRE)",
   label: "Guararapes (BRGRE)"
  },
  {
   value: "Guararema (BRGAM)",
   label: "Guararema (BRGAM)"
  },
  {
   value: "Guaratuba (BRGTB)",
   label: "Guaratuba (BRGTB)"
  },
  {
   value: "Guarda do Embau (BRGEM)",
   label: "Guarda do Embau (BRGEM)"
  },
  {
   value: "Guarda-Mor (BRGMO)",
   label: "Guarda-Mor (BRGMO)"
  },
  {
   value: "Guariba (BRGRB)",
   label: "Guariba (BRGRB)"
  },
  {
   value: "Guarujá (BRGUR)",
   label: "Guarujá (BRGUR)"
  },
  {
   value: "Guarulhos (BRQCV)",
   label: "Guarulhos (BRQCV)"
  },
  {
   value: "Guaxupé (BRGXP)",
   label: "Guaxupé (BRGXP)"
  },
  {
   value: "Guaiba (BRGIB)",
   label: "Guaiba (BRGIB)"
  },
  {
   value: "Fundao (BRFDA)",
   label: "Fundao (BRFDA)"
  },
  {
   value: "Galia (BRGLA)",
   label: "Galia (BRGLA)"
  },
  {
   value: "Gameleira (BRGLE)",
   label: "Gameleira (BRGLE)"
  },
  {
   value: "Gandu (BRGDU)",
   label: "Gandu (BRGDU)"
  },
  {
   value: "Garanhuns (BRGHU)",
   label: "Garanhuns (BRGHU)"
  },
  {
   value: "Garca (BRGCA)",
   label: "Garca (BRGCA)"
  },
  {
   value: "Garibaldi (BRGBI)",
   label: "Garibaldi (BRGBI)"
  },
  {
   value: "Garopaba (BRGPA)",
   label: "Garopaba (BRGPA)"
  },
  {
   value: "Gaspar (BRGSA)",
   label: "Gaspar (BRGSA)"
  },
  {
   value: "General Salgado (BRGSO)",
   label: "General Salgado (BRGSO)"
  },
  {
   value: "Genipabu (BRGPU)",
   label: "Genipabu (BRGPU)"
  },
  {
   value: "Getulina (BRGTU)",
   label: "Getulina (BRGTU)"
  },
  {
   value: "Getulio Vargas (BRGVA)",
   label: "Getulio Vargas (BRGVA)"
  },
  {
   value: "Girua (BRGRA)",
   label: "Girua (BRGRA)"
  },
  {
   value: "Gloria de Dourados (BRGDO)",
   label: "Gloria de Dourados (BRGDO)"
  },
  {
   value: "Glorinha (BRGHA)",
   label: "Glorinha (BRGHA)"
  },
  {
   value: "Goianapolis (BRGPO)",
   label: "Goianapolis (BRGPO)"
  },
  {
   value: "Goianesia (BRGNI)",
   label: "Goianesia (BRGNI)"
  },
  {
   value: "Goiania (BRGIA)",
   label: "Goiania (BRGIA)"
  },
  {
   value: "Goias (BRGIS)",
   label: "Goias (BRGIS)"
  },
  {
   value: "Goiatuba (BRGTA)",
   label: "Goiatuba (BRGTA)"
  },
  {
   value: "Goioere (BRGOE)",
   label: "Goioere (BRGOE)"
  },
  {
   value: "Goncalves (BRGCS)",
   label: "Goncalves (BRGCS)"
  },
  {
   value: "Governador Celso Ramos (BRGCR)",
   label: "Governador Celso Ramos (BRGCR)"
  },
  {
   value: "Grajau (BRGJA)",
   label: "Grajau (BRGJA)"
  },
  {
   value: "Grao Para (BRGPR)",
   label: "Grao Para (BRGPR)"
  },
  {
   value: "Gravata (BRGVT)",
   label: "Gravata (BRGVT)"
  },
  {
   value: "Gravataí (BRGCV)",
   label: "Gravataí (BRGCV)"
  },
  {
   value: "Gravatal (BRGVL)",
   label: "Gravatal (BRGVL)"
  },
  {
   value: "Grossos (BRGSS)",
   label: "Grossos (BRGSS)"
  },
  {
   value: "Guabirotuba (BRGOB)",
   label: "Guabirotuba (BRGOB)"
  },
  {
   value: "Guacui (BRGCU)",
   label: "Guacui (BRGCU)"
  },
  {
   value: "Frutal (BRFRU)",
   label: "Frutal (BRFRU)"
  },
  {
   value: "Eusébio (BRESO)",
   label: "Eusébio (BRESO)"
  },
  {
   value: "Euzebio (BREZI)",
   label: "Euzebio (BREZI)"
  },
  {
   value: "Extrema (BREXA)",
   label: "Extrema (BREXA)"
  },
  {
   value: "Extremoz (BREXZ)",
   label: "Extremoz (BREXZ)"
  },
  {
   value: "Farroupilha (BRFPA)",
   label: "Farroupilha (BRFPA)"
  },
  {
   value: "Fartura (BRFTU)",
   label: "Fartura (BRFTU)"
  },
  {
   value: "Fatima do Sul (BRFSU)",
   label: "Fatima do Sul (BRFSU)"
  },
  {
   value: "Fazenda Nova (BRFNA)",
   label: "Fazenda Nova (BRFNA)"
  },
  {
   value: "Fazenda Rio Grande (BRFRG)",
   label: "Fazenda Rio Grande (BRFRG)"
  },
  {
   value: "Fernando Prestes (BRFPE)",
   label: "Fernando Prestes (BRFPE)"
  },
  {
   value: "Fernandopolis (BRFPO)",
   label: "Fernandopolis (BRFPO)"
  },
  {
   value: "Ferraz de Vasconcelos (BRFVA)",
   label: "Ferraz de Vasconcelos (BRFVA)"
  },
  {
   value: "Figueira (BRFGU)",
   label: "Figueira (BRFGU)"
  },
  {
   value: "Florai (BRFLO)",
   label: "Florai (BRFLO)"
  },
  {
   value: "Flores da Cunha (BRFCU)",
   label: "Flores da Cunha (BRFCU)"
  },
  {
   value: "Florestal (BRFSA)",
   label: "Florestal (BRFSA)"
  },
  {
   value: "Florida Paulista (BRFPS)",
   label: "Florida Paulista (BRFPS)"
  },
  {
   value: "Formiga (BRFMI)",
   label: "Formiga (BRFMI)"
  },
  {
   value: "Formosa (BRFMO)",
   label: "Formosa (BRFMO)"
  },
  {
   value: "Formoso do Araguaia (BRFAG)",
   label: "Formoso do Araguaia (BRFAG)"
  },
  {
   value: "Fortaleza de Minas (BRFMS)",
   label: "Fortaleza de Minas (BRFMS)"
  },
  {
   value: "Fraiburgo (BRFGO)",
   label: "Fraiburgo (BRFGO)"
  },
  {
   value: "Francisco Morato (BRFTO)",
   label: "Francisco Morato (BRFTO)"
  },
  {
   value: "Franco da Rocha (BRFRO)",
   label: "Franco da Rocha (BRFRO)"
  },
  {
   value: "Frederico Westphalen (BRFWP)",
   label: "Frederico Westphalen (BRFWP)"
  },
  {
   value: "Eunapolis (BREPO)",
   label: "Eunapolis (BREPO)"
  },
  {
   value: "Duartina (BRDTI)",
   label: "Duartina (BRDTI)"
  },
  {
   value: "Eldorado (BRELO)",
   label: "Eldorado (BRELO)"
  },
  {
   value: "Eldorado (BRERA)",
   label: "Eldorado (BRERA)"
  },
  {
   value: "Eldorado do Sul (BREDS)",
   label: "Eldorado do Sul (BREDS)"
  },
  {
   value: "Elias Fausto (BREFU)",
   label: "Elias Fausto (BREFU)"
  },
  {
   value: "Embauba (BREUB)",
   label: "Embauba (BREUB)"
  },
  {
   value: "Embu (BREMB)",
   label: "Embu (BREMB)"
  },
  {
   value: "Embu-Guacu (BREGU)",
   label: "Embu-Guacu (BREGU)"
  },
  {
   value: "Encantado (BRECO)",
   label: "Encantado (BRECO)"
  },
  {
   value: "Engenheiro Beltrao (BREBR)",
   label: "Engenheiro Beltrao (BREBR)"
  },
  {
   value: "Engenheiro Coelho (BRECH)",
   label: "Engenheiro Coelho (BRECH)"
  },
  {
   value: "Engenheiro Passos (BREPA)",
   label: "Engenheiro Passos (BREPA)"
  },
  {
   value: "Engenheiro Paulo de Frontin (BREPF)",
   label: "Engenheiro Paulo de Frontin (BREPF)"
  },
  {
   value: "Entre Rios (BRERS)",
   label: "Entre Rios (BRERS)"
  },
  {
   value: "Escada (BRESD)",
   label: "Escada (BRESD)"
  },
  {
   value: "Esmeraldas (BREMA)",
   label: "Esmeraldas (BREMA)"
  },
  {
   value: "Espera Feliz (BRESZ)",
   label: "Espera Feliz (BRESZ)"
  },
  {
   value: "Esperantina (BRETI)",
   label: "Esperantina (BRETI)"
  },
  {
   value: "Espigao do Oeste (BREOT)",
   label: "Espigao do Oeste (BREOT)"
  },
  {
   value: "Espirito Santo do Pinhal (BREPI)",
   label: "Espirito Santo do Pinhal (BREPI)"
  },
  {
   value: "Espumoso (BREPU)",
   label: "Espumoso (BREPU)"
  },
  {
   value: "Estância (BREST)",
   label: "Estância (BREST)"
  },
  {
   value: "Estancia Velha (BREVH)",
   label: "Estancia Velha (BREVH)"
  },
  {
   value: "Esteio (BRETO)",
   label: "Esteio (BRETO)"
  },
  {
   value: "Estiva Gerbi (BREGI)",
   label: "Estiva Gerbi (BREGI)"
  },
  {
   value: "Estreito (BRETR)",
   label: "Estreito (BRETR)"
  },
  {
   value: "Estrela (BRETA)",
   label: "Estrela (BRETA)"
  },
  {
   value: "Estrela do Oeste (BREOS)",
   label: "Estrela do Oeste (BREOS)"
  },
  {
   value: "Estrema (BRESA)",
   label: "Estrema (BRESA)"
  },
  {
   value: "Euclides da Cunha (BRECU)",
   label: "Euclides da Cunha (BRECU)"
  },
  {
   value: "Doutor Mauricio Cardoso (BRDMC)",
   label: "Doutor Mauricio Cardoso (BRDMC)"
  },
  {
   value: "Cruzilia (BRCRZ)",
   label: "Cruzilia (BRCRZ)"
  },
  {
   value: "Cubatao (BRCUO)",
   label: "Cubatao (BRCUO)"
  },
  {
   value: "Cumuruxatiba (BRCXB)",
   label: "Cumuruxatiba (BRCXB)"
  },
  {
   value: "Cunha (BRCUH)",
   label: "Cunha (BRCUH)"
  },
  {
   value: "Curaçá (BRCUA)",
   label: "Curaçá (BRCUA)"
  },
  {
   value: "Curitibanos (BRCRN)",
   label: "Curitibanos (BRCRN)"
  },
  {
   value: "Curtibanos (BRCUR)",
   label: "Curtibanos (BRCUR)"
  },
  {
   value: "Curvelo (BRCVL)",
   label: "Curvelo (BRCVL)"
  },
  {
   value: "Delfim Moreira (BRDMA)",
   label: "Delfim Moreira (BRDMA)"
  },
  {
   value: "Delfinopolis (BRDPO)",
   label: "Delfinopolis (BRDPO)"
  },
  {
   value: "Delmiro Gouveia (BRDGU)",
   label: "Delmiro Gouveia (BRDGU)"
  },
  {
   value: "Descalvado (BRDCO)",
   label: "Descalvado (BRDCO)"
  },
  {
   value: "Diadema (BRDID)",
   label: "Diadema (BRDID)"
  },
  {
   value: "Diamantina (BRDTA)",
   label: "Diamantina (BRDTA)"
  },
  {
   value: "Dionisio Cerqueira (BRDCA)",
   label: "Dionisio Cerqueira (BRDCA)"
  },
  {
   value: "Divino (BRDVO)",
   label: "Divino (BRDVO)"
  },
  {
   value: "Divino das Laranjeiras (BRDLJ)",
   label: "Divino das Laranjeiras (BRDLJ)"
  },
  {
   value: "Divinolandia (BRDVD)",
   label: "Divinolandia (BRDVD)"
  },
  {
   value: "Dois Corregos (BRDCS)",
   label: "Dois Corregos (BRDCS)"
  },
  {
   value: "Dois Irmaos (BRDIS)",
   label: "Dois Irmaos (BRDIS)"
  },
  {
   value: "Dois Vizinhos (BRDVS)",
   label: "Dois Vizinhos (BRDVS)"
  },
  {
   value: "Dolcinopolis (BRDCP)",
   label: "Dolcinopolis (BRDCP)"
  },
  {
   value: "Dom Eliseu (BRDEU)",
   label: "Dom Eliseu (BRDEU)"
  },
  {
   value: "Domingos Martins (BRDMS)",
   label: "Domingos Martins (BRDMS)"
  },
  {
   value: "Dores do Indaia (BRDDI)",
   label: "Dores do Indaia (BRDDI)"
  },
  {
   value: "Dourado (BRDUO)",
   label: "Dourado (BRDUO)"
  },
  {
   value: "Conservatoria (BRCVO)",
   label: "Conservatoria (BRCVO)"
  },
  {
   value: "Contagem (BRCGE)",
   label: "Contagem (BRCGE)"
  },
  {
   value: "Cordeiro (BRCRE)",
   label: "Cordeiro (BRCRE)"
  },
  {
   value: "Cordeirópolis (BRCRS)",
   label: "Cordeirópolis (BRCRS)"
  },
  {
   value: "Cordisburgo (BRCSO)",
   label: "Cordisburgo (BRCSO)"
  },
  {
   value: "Corinto (BRCRT)",
   label: "Corinto (BRCRT)"
  },
  {
   value: "Coromandel (BRCML)",
   label: "Coromandel (BRCML)"
  },
  {
   value: "Coronel Fabriciano (BRCFB)",
   label: "Coronel Fabriciano (BRCFB)"
  },
  {
   value: "Correio Pinto (BRCPJ)",
   label: "Correio Pinto (BRCPJ)"
  },
  {
   value: "Corrente (BRCNT)",
   label: "Corrente (BRCNT)"
  },
  {
   value: "Corumba de Goias (BRCGI)",
   label: "Corumba de Goias (BRCGI)"
  },
  {
   value: "Corupa (BRCRA)",
   label: "Corupa (BRCRA)"
  },
  {
   value: "Coruripe (BRCUP)",
   label: "Coruripe (BRCUP)"
  },
  {
   value: "Cosmopolis (BRCSP)",
   label: "Cosmopolis (BRCSP)"
  },
  {
   value: "Cosmorama (BRCMM)",
   label: "Cosmorama (BRCMM)"
  },
  {
   value: "Costa Rica (BRCSR)",
   label: "Costa Rica (BRCSR)"
  },
  {
   value: "Cotia (BRCOA)",
   label: "Cotia (BRCOA)"
  },
  {
   value: "Cotriguaçu (BRCOT)",
   label: "Cotriguaçu (BRCOT)"
  },
  {
   value: "Coxim (BRCOX)",
   label: "Coxim (BRCOX)"
  },
  {
   value: "Crateus (BRCTU)",
   label: "Crateus (BRCTU)"
  },
  {
   value: "Crato (BRCAT)",
   label: "Crato (BRCAT)"
  },
  {
   value: "Cravinhos (BRCVH)",
   label: "Cravinhos (BRCVH)"
  },
  {
   value: "Cristalina (BRCST)",
   label: "Cristalina (BRCST)"
  },
  {
   value: "Crixas (BRCRX)",
   label: "Crixas (BRCRX)"
  },
  {
   value: "Cruz das Almas (BRCZA)",
   label: "Cruz das Almas (BRCZA)"
  },
  {
   value: "Cruzeiro (BRCZI)",
   label: "Cruzeiro (BRCZI)"
  },
  {
   value: "Cruzeiro do Oeste (BRCZO)",
   label: "Cruzeiro do Oeste (BRCZO)"
  },
  {
   value: "Claudia (BRCIA)",
   label: "Claudia (BRCIA)"
  },
  {
   value: "Claudio (BRCLI)",
   label: "Claudio (BRCLI)"
  },
  {
   value: "Clementina (BRCTA)",
   label: "Clementina (BRCTA)"
  },
  {
   value: "Clevelandia (BRCVI)",
   label: "Clevelandia (BRCVI)"
  },
  {
   value: "Coaraci (BRCRC)",
   label: "Coaraci (BRCRC)"
  },
  {
   value: "Cocal do Sul (BRCLL)",
   label: "Cocal do Sul (BRCLL)"
  },
  {
   value: "Codajás (BRCDA)",
   label: "Codajás (BRCDA)"
  },
  {
   value: "Codo (BRCOO)",
   label: "Codo (BRCOO)"
  },
  {
   value: "Coelho Neto (BRCHN)",
   label: "Coelho Neto (BRCHN)"
  },
  {
   value: "Colatina (BRCTN)",
   label: "Colatina (BRCTN)"
  },
  {
   value: "Colegio (BRCGO)",
   label: "Colegio (BRCGO)"
  },
  {
   value: "Colider (BRCLD)",
   label: "Colider (BRCLD)"
  },
  {
   value: "Colina (BRCNA)",
   label: "Colina (BRCNA)"
  },
  {
   value: "Colinas de Tocantins (BRCTS)",
   label: "Colinas de Tocantins (BRCTS)"
  },
  {
   value: "Colmeia (BRCLM)",
   label: "Colmeia (BRCLM)"
  },
  {
   value: "Colombia (BRCLB)",
   label: "Colombia (BRCLB)"
  },
  {
   value: "Colombo (BRCOL)",
   label: "Colombo (BRCOL)"
  },
  {
   value: "Colorado (BRCRO)",
   label: "Colorado (BRCRO)"
  },
  {
   value: "Comodoro (BRCMO)",
   label: "Comodoro (BRCMO)"
  },
  {
   value: "Conceicao da Barra (BRCNB)",
   label: "Conceicao da Barra (BRCNB)"
  },
  {
   value: "Conceicao das Alagoas (BRCGS)",
   label: "Conceicao das Alagoas (BRCGS)"
  },
  {
   value: "Conceicao de Castelo (BRCCC)",
   label: "Conceicao de Castelo (BRCCC)"
  },
  {
   value: "Conceição de Jacuípe (BRCJC)",
   label: "Conceição de Jacuípe (BRCJC)"
  },
  {
   value: "Conceicao do Coite (BRCEC)",
   label: "Conceicao do Coite (BRCEC)"
  },
  {
   value: "Conceicao do Ibitipoca (BRCCB)",
   label: "Conceicao do Ibitipoca (BRCCB)"
  },
  {
   value: "Conceicao do Mato Dentro (BRCMD)",
   label: "Conceicao do Mato Dentro (BRCMD)"
  },
  {
   value: "Conceição do Pará (BRCDP)",
   label: "Conceição do Pará (BRCDP)"
  },
  {
   value: "Conceicao dos Ouros (BRCCR)",
   label: "Conceicao dos Ouros (BRCCR)"
  },
  {
   value: "Conchal (BRCHL)",
   label: "Conchal (BRCHL)"
  },
  {
   value: "Conchas (BRCCS)",
   label: "Conchas (BRCCS)"
  },
  {
   value: "Conde (BRVCO)",
   label: "Conde (BRVCO)"
  },
  {
   value: "Cipo (BRCIO)",
   label: "Cipo (BRCIO)"
  },
  {
   value: "Castro (BRCTR)",
   label: "Castro (BRCTR)"
  },
  {
   value: "Catanduva (BRCDV)",
   label: "Catanduva (BRCDV)"
  },
  {
   value: "Catanduvas (BRCTV)",
   label: "Catanduvas (BRCTV)"
  },
  {
   value: "Catas Altas (BRTSL)",
   label: "Catas Altas (BRTSL)"
  },
  {
   value: "Catole do Rocha (BRCCH)",
   label: "Catole do Rocha (BRCCH)"
  },
  {
   value: "Catu (BRATU)",
   label: "Catu (BRATU)"
  },
  {
   value: "Caucaia (BRCUC)",
   label: "Caucaia (BRCUC)"
  },
  {
   value: "Caxambu (BRCXU)",
   label: "Caxambu (BRCXU)"
  },
  {
   value: "Caxias (BRCXS)",
   label: "Caxias (BRCXS)"
  },
  {
   value: "Ceara Mirim (BRCEA)",
   label: "Ceara Mirim (BRCEA)"
  },
  {
   value: "Cedral (BRCED)",
   label: "Cedral (BRCED)"
  },
  {
   value: "Centralina (BRCEL)",
   label: "Centralina (BRCEL)"
  },
  {
   value: "Cerejeiras (BRCJS)",
   label: "Cerejeiras (BRCJS)"
  },
  {
   value: "Ceres (BRCES)",
   label: "Ceres (BRCES)"
  },
  {
   value: "Cerqueira Cesar (BRCQR)",
   label: "Cerqueira Cesar (BRCQR)"
  },
  {
   value: "Cerquilho (BRCQO)",
   label: "Cerquilho (BRCQO)"
  },
  {
   value: "Cerro Largo (BRCLG)",
   label: "Cerro Largo (BRCLG)"
  },
  {
   value: "Cesario Lange (BRCLE)",
   label: "Cesario Lange (BRCLE)"
  },
  {
   value: "Cezarina (BRCZR)",
   label: "Cezarina (BRCZR)"
  },
  {
   value: "Cha de Alegria (BRCAG)",
   label: "Cha de Alegria (BRCAG)"
  },
  {
   value: "Cha Grande (BRCGD)",
   label: "Cha Grande (BRCGD)"
  },
  {
   value: "Chapada (BRCPD)",
   label: "Chapada (BRCPD)"
  },
  {
   value: "Chapada dos Guimaraes (BRCGM)",
   label: "Chapada dos Guimaraes (BRCGM)"
  },
  {
   value: "Chapadao do Sul (BRCPL)",
   label: "Chapadao do Sul (BRCPL)"
  },
  {
   value: "Characas (BRCHC)",
   label: "Characas (BRCHC)"
  },
  {
   value: "Charqueada (BRCHQ)",
   label: "Charqueada (BRCHQ)"
  },
  {
   value: "Charqueada (BRQDA)",
   label: "Charqueada (BRQDA)"
  },
  {
   value: "Charqueadas (BRCQD)",
   label: "Charqueadas (BRCQD)"
  },
  {
   value: "Chavantes (BRCVA)",
   label: "Chavantes (BRCVA)"
  },
  {
   value: "Chui (BRCUI)",
   label: "Chui (BRCUI)"
  },
  {
   value: "Cianorte (BRCNO)",
   label: "Cianorte (BRCNO)"
  },
  {
   value: "Cidreira (BRCRI)",
   label: "Cidreira (BRCRI)"
  },
  {
   value: "Castilho (BRCHO)",
   label: "Castilho (BRCHO)"
  },
  {
   value: "Caratinga (BRCIG)",
   label: "Caratinga (BRCIG)"
  },
  {
   value: "Carazinho (BRZHO)",
   label: "Carazinho (BRZHO)"
  },
  {
   value: "Carbonita (BRCAN)",
   label: "Carbonita (BRCAN)"
  },
  {
   value: "Cardeal Mota (BRCMA)",
   label: "Cardeal Mota (BRCMA)"
  },
  {
   value: "Cardoso (BRCDR)",
   label: "Cardoso (BRCDR)"
  },
  {
   value: "Cardoso Moreira (BRCSM)",
   label: "Cardoso Moreira (BRCSM)"
  },
  {
   value: "Careacu (BRCEU)",
   label: "Careacu (BRCEU)"
  },
  {
   value: "Cariacica (BRCII)",
   label: "Cariacica (BRCII)"
  },
  {
   value: "Carlos Barbosa (BRCBB)",
   label: "Carlos Barbosa (BRCBB)"
  },
  {
   value: "Carlos Chagas (BRCCG)",
   label: "Carlos Chagas (BRCCG)"
  },
  {
   value: "Carmo (BRRMO)",
   label: "Carmo (BRRMO)"
  },
  {
   value: "Carmo do Paranaiba (BRCOP)",
   label: "Carmo do Paranaiba (BRCOP)"
  },
  {
   value: "Carmo do Rio Claro (BRCRD)",
   label: "Carmo do Rio Claro (BRCRD)"
  },
  {
   value: "Carmo do Rio Verde (BRCOV)",
   label: "Carmo do Rio Verde (BRCOV)"
  },
  {
   value: "Carneirinho (BRCIH)",
   label: "Carneirinho (BRCIH)"
  },
  {
   value: "Carpina (BRCIN)",
   label: "Carpina (BRCIN)"
  },
  {
   value: "Carpina (BRCPR)",
   label: "Carpina (BRCPR)"
  },
  {
   value: "Carrancas (BRCNC)",
   label: "Carrancas (BRCNC)"
  },
  {
   value: "Casa Branca (BRCSN)",
   label: "Casa Branca (BRCSN)"
  },
  {
   value: "Casa Grande (BRCSG)",
   label: "Casa Grande (BRCSG)"
  },
  {
   value: "Casa Nova (BRCAV)",
   label: "Casa Nova (BRCAV)"
  },
  {
   value: "Casca (BRSCA)",
   label: "Casca (BRSCA)"
  },
  {
   value: "Cascavel (BRCCV)",
   label: "Cascavel (BRCCV)"
  },
  {
   value: "Casimiro de Abreu (BRCSD)",
   label: "Casimiro de Abreu (BRCSD)"
  },
  {
   value: "Cassia (BRCAI)",
   label: "Cassia (BRCAI)"
  },
  {
   value: "Castanhal (BRCTH)",
   label: "Castanhal (BRCTH)"
  },
  {
   value: "Castelandia (BRCSE)",
   label: "Castelandia (BRCSE)"
  },
  {
   value: "Castelo (BRCEO)",
   label: "Castelo (BRCEO)"
  },
  {
   value: "Carapina da Serra (BRCNE)",
   label: "Carapina da Serra (BRCNE)"
  },
  {
   value: "Candido Mota (BRCMT)",
   label: "Candido Mota (BRCMT)"
  },
  {
   value: "Candido Rodrigues (BRCDU)",
   label: "Candido Rodrigues (BRCDU)"
  },
  {
   value: "Candiota (BRCDT)",
   label: "Candiota (BRCDT)"
  },
  {
   value: "Caninde (BRCAD)",
   label: "Caninde (BRCAD)"
  },
  {
   value: "Caninde do Sao Francisco (BRCFA)",
   label: "Caninde do Sao Francisco (BRCFA)"
  },
  {
   value: "Canitar (BRCNR)",
   label: "Canitar (BRCNR)"
  },
  {
   value: "Canoa Quebrada (BRCQU)",
   label: "Canoa Quebrada (BRCQU)"
  },
  {
   value: "Canoinhas (BRCHS)",
   label: "Canoinhas (BRCHS)"
  },
  {
   value: "Cansancao (BRCSC)",
   label: "Cansancao (BRCSC)"
  },
  {
   value: "Cantagalo (BRCTG)",
   label: "Cantagalo (BRCTG)"
  },
  {
   value: "Canto do Buriti (BRCRR)",
   label: "Canto do Buriti (BRCRR)"
  },
  {
   value: "Capanema (BRCPM)",
   label: "Capanema (BRCPM)"
  },
  {
   value: "Capao Bonito (BRCBN)",
   label: "Capao Bonito (BRCBN)"
  },
  {
   value: "Capao da Canoa (BRCCN)",
   label: "Capao da Canoa (BRCCN)"
  },
  {
   value: "Capao do Leao (BRCPE)",
   label: "Capao do Leao (BRCPE)"
  },
  {
   value: "Capela do Alto (BRCLT)",
   label: "Capela do Alto (BRCLT)"
  },
  {
   value: "Capelinha (BRCLH)",
   label: "Capelinha (BRCLH)"
  },
  {
   value: "Capetinga (BRCPT)",
   label: "Capetinga (BRCPT)"
  },
  {
   value: "Capinopolis (BRCPP)",
   label: "Capinopolis (BRCPP)"
  },
  {
   value: "Capinzal (BRCPZ)",
   label: "Capinzal (BRCPZ)"
  },
  {
   value: "Capitao Poco (BRCPC)",
   label: "Capitao Poco (BRCPC)"
  },
  {
   value: "Capitolio (BRCTL)",
   label: "Capitolio (BRCTL)"
  },
  {
   value: "Capivari (BRCPI)",
   label: "Capivari (BRCPI)"
  },
  {
   value: "Capivari de Baixo (BRCBX)",
   label: "Capivari de Baixo (BRCBX)"
  },
  {
   value: "Capixaba (BRCPX)",
   label: "Capixaba (BRCPX)"
  },
  {
   value: "Caponga (BRCGA)",
   label: "Caponga (BRCGA)"
  },
  {
   value: "Caraguatatuba (BRCGU)",
   label: "Caraguatatuba (BRCGU)"
  },
  {
   value: "Caraiva (BRCRV)",
   label: "Caraiva (BRCRV)"
  },
  {
   value: "Carambei (BRCAR)",
   label: "Carambei (BRCAR)"
  },
  {
   value: "Carambei (BRCRM)",
   label: "Carambei (BRCRM)"
  },
  {
   value: "Carandai (BRCND)",
   label: "Carandai (BRCND)"
  },
  {
   value: "Carangola (BRCNG)",
   label: "Carangola (BRCNG)"
  },
  {
   value: "Carapicuiba (BRCIU)",
   label: "Carapicuiba (BRCIU)"
  },
  {
   value: "Candido Mendes (BRCMN)",
   label: "Candido Mendes (BRCMN)"
  },
  {
   value: "Cambui (BRCMI)",
   label: "Cambui (BRCMI)"
  },
  {
   value: "Cambuquira (BRCBQ)",
   label: "Cambuquira (BRCBQ)"
  },
  {
   value: "Cametá Apt (BRCMR)",
   label: "Cametá Apt (BRCMR)"
  },
  {
   value: "Campanha (BRCPH)",
   label: "Campanha (BRCPH)"
  },
  {
   value: "Campina do Monte Alegre (BRCAM)",
   label: "Campina do Monte Alegre (BRCAM)"
  },
  {
   value: "Campina Verde (BRCVR)",
   label: "Campina Verde (BRCVR)"
  },
  {
   value: "Campinapolis (BRCPO)",
   label: "Campinapolis (BRCPO)"
  },
  {
   value: "Campo Belo (BRCPB)",
   label: "Campo Belo (BRCPB)"
  },
  {
   value: "Campo Formoso (BRCFM)",
   label: "Campo Formoso (BRCFM)"
  },
  {
   value: "Campo Grande (BRGCE)",
   label: "Campo Grande (BRGCE)"
  },
  {
   value: "Campo Largo (BRCLO)",
   label: "Campo Largo (BRCLO)"
  },
  {
   value: "Campo Maior (BRCOM)",
   label: "Campo Maior (BRCOM)"
  },
  {
   value: "Campo Novo do Parecis (BRCNP)",
   label: "Campo Novo do Parecis (BRCNP)"
  },
  {
   value: "Campo Verde (BRCVE)",
   label: "Campo Verde (BRCVE)"
  },
  {
   value: "Campos Belos (BRCBS)",
   label: "Campos Belos (BRCBS)"
  },
  {
   value: "Campos dos Goitacazes (BRCGZ)",
   label: "Campos dos Goitacazes (BRCGZ)"
  },
  {
   value: "Campos Novos (BRCNS)",
   label: "Campos Novos (BRCNS)"
  },
  {
   value: "Campos Novos (BRCPN)",
   label: "Campos Novos (BRCPN)"
  },
  {
   value: "Campos Verdes (BRCVD)",
   label: "Campos Verdes (BRCVD)"
  },
  {
   value: "Canabarro Teutonia (BRCTT)",
   label: "Canabarro Teutonia (BRCTT)"
  },
  {
   value: "Cananeia (BRCNI)",
   label: "Cananeia (BRCNI)"
  },
  {
   value: "Canarana (BRCNN)",
   label: "Canarana (BRCNN)"
  },
  {
   value: "Candeias (BRCIS)",
   label: "Candeias (BRCIS)"
  },
  {
   value: "Candelaria (BRCDL)",
   label: "Candelaria (BRCDL)"
  },
  {
   value: "Cambuci (BRCMB)",
   label: "Cambuci (BRCMB)"
  },
  {
   value: "Cachoeira Paulista (BRCPS)",
   label: "Cachoeira Paulista (BRCPS)"
  },
  {
   value: "Cachoeiras de Macacu (BRCDM)",
   label: "Cachoeiras de Macacu (BRCDM)"
  },
  {
   value: "Cachoeirinha (BRCHA)",
   label: "Cachoeirinha (BRCHA)"
  },
  {
   value: "Cachoeiro de Itapemirim (BRCDI)",
   label: "Cachoeiro de Itapemirim (BRCDI)"
  },
  {
   value: "Caconde (BRCCO)",
   label: "Caconde (BRCCO)"
  },
  {
   value: "Cacu (BRCCU)",
   label: "Cacu (BRCCU)"
  },
  {
   value: "Cacule (BRCCL)",
   label: "Cacule (BRCCL)"
  },
  {
   value: "Caetanopolis (BRCTO)",
   label: "Caetanopolis (BRCTO)"
  },
  {
   value: "Caete (BRCTE)",
   label: "Caete (BRCTE)"
  },
  {
   value: "Caetite (BRCTI)",
   label: "Caetite (BRCTI)"
  },
  {
   value: "Cafelandia (BRCFL)",
   label: "Cafelandia (BRCFL)"
  },
  {
   value: "Caibi (BRCBI)",
   label: "Caibi (BRCBI)"
  },
  {
   value: "Caico (BRCIC)",
   label: "Caico (BRCIC)"
  },
  {
   value: "Caieiras (BRCAS)",
   label: "Caieiras (BRCAS)"
  },
  {
   value: "Caioba (BRCBA)",
   label: "Caioba (BRCBA)"
  },
  {
   value: "Cairu (BRCIR)",
   label: "Cairu (BRCIR)"
  },
  {
   value: "Cajamar (BRCJM)",
   label: "Cajamar (BRCJM)"
  },
  {
   value: "Cajati (BRCJA)",
   label: "Cajati (BRCJA)"
  },
  {
   value: "Cajati (BRCJI)",
   label: "Cajati (BRCJI)"
  },
  {
   value: "Cajazeiras (BRCJZ)",
   label: "Cajazeiras (BRCJZ)"
  },
  {
   value: "Cajobi (BRCJO)",
   label: "Cajobi (BRCJO)"
  },
  {
   value: "Cajuru (BRCJU)",
   label: "Cajuru (BRCJU)"
  },
  {
   value: "Caldas (BRCLA)",
   label: "Caldas (BRCLA)"
  },
  {
   value: "Camacan (BRCCA)",
   label: "Camacan (BRCCA)"
  },
  {
   value: "Camanducaia (BRCMU)",
   label: "Camanducaia (BRCMU)"
  },
  {
   value: "Camapua (BRCAA)",
   label: "Camapua (BRCAA)"
  },
  {
   value: "Camaqua (BRCQA)",
   label: "Camaqua (BRCQA)"
  },
  {
   value: "Camaragibe (BRCME)",
   label: "Camaragibe (BRCME)"
  },
  {
   value: "Cambara (BRCBR)",
   label: "Cambara (BRCBR)"
  },
  {
   value: "Cambara do Sul (BRCMS)",
   label: "Cambara do Sul (BRCMS)"
  },
  {
   value: "Cambe (BRCBE)",
   label: "Cambe (BRCBE)"
  },
  {
   value: "Camboriú (BRCBU)",
   label: "Camboriú (BRCBU)"
  },
  {
   value: "Brasilia Guara (BRBGR)",
   label: "Brasilia Guara (BRBGR)"
  },
  {
   value: "Brasilia Nucleo Band (BRBNB)",
   label: "Brasilia Nucleo Band (BRBNB)"
  },
  {
   value: "Brasilia Planaltina (BRBPT)",
   label: "Brasilia Planaltina (BRBPT)"
  },
  {
   value: "Brasilia Ceilandia (BRBCL)",
   label: "Brasilia Ceilandia (BRBCL)"
  },
  {
   value: "Brasilia Sobradinho (BRBSD)",
   label: "Brasilia Sobradinho (BRBSD)"
  },
  {
   value: "Brasilia Taguatinga (BRBTT)",
   label: "Brasilia Taguatinga (BRBTT)"
  },
  {
   value: "Brauna (BRBRN)",
   label: "Brauna (BRBRN)"
  },
  {
   value: "Breu Branco (BRBBN)",
   label: "Breu Branco (BRBBN)"
  },
  {
   value: "Britania (BRBTN)",
   label: "Britania (BRBTN)"
  },
  {
   value: "Brodowski (BRBDW)",
   label: "Brodowski (BRBDW)"
  },
  {
   value: "Brotas (BRBOS)",
   label: "Brotas (BRBOS)"
  },
  {
   value: "Brumadinho (BRBHO)",
   label: "Brumadinho (BRBHO)"
  },
  {
   value: "Bueno Brandao (BRBBD)",
   label: "Bueno Brandao (BRBBD)"
  },
  {
   value: "Buerarema (BRBRM)",
   label: "Buerarema (BRBRM)"
  },
  {
   value: "Buri (BRBUR)",
   label: "Buri (BRBUR)"
  },
  {
   value: "Buritama (BRBTM)",
   label: "Buritama (BRBTM)"
  },
  {
   value: "Buritis (BRBUS)",
   label: "Buritis (BRBUS)"
  },
  {
   value: "Buritis (BRBUT)",
   label: "Buritis (BRBUT)"
  },
  {
   value: "Caapora (BRCPA)",
   label: "Caapora (BRCPA)"
  },
  {
   value: "Caarapo (BRCRP)",
   label: "Caarapo (BRCRP)"
  },
  {
   value: "Cabeceiras (BRCCE)",
   label: "Cabeceiras (BRCCE)"
  },
  {
   value: "Cabo (BRCAB)",
   label: "Cabo (BRCAB)"
  },
  {
   value: "Cabo de Santo Agostinho (BRCDS)",
   label: "Cabo de Santo Agostinho (BRCDS)"
  },
  {
   value: "Cabo de Santo Agostinho (BRCSA)",
   label: "Cabo de Santo Agostinho (BRCSA)"
  },
  {
   value: "Cabreuva (BRCRU)",
   label: "Cabreuva (BRCRU)"
  },
  {
   value: "Cacador (BRCFC)",
   label: "Cacador (BRCFC)"
  },
  {
   value: "Caçapava (BRCAP)",
   label: "Caçapava (BRCAP)"
  },
  {
   value: "Cacapava do Sul (BRCSL)",
   label: "Cacapava do Sul (BRCSL)"
  },
  {
   value: "Brasilandia de Minas (BRBMI)",
   label: "Brasilandia de Minas (BRBMI)"
  },
  {
   value: "Betim (BRBTI)",
   label: "Betim (BRBTI)"
  },
  {
   value: "Bezerros (BRBZE)",
   label: "Bezerros (BRBZE)"
  },
  {
   value: "Biguacu (BRBGC)",
   label: "Biguacu (BRBGC)"
  },
  {
   value: "Bilac (BRBLA)",
   label: "Bilac (BRBLA)"
  },
  {
   value: "Boa Esperanca (BRBSE)",
   label: "Boa Esperanca (BRBSE)"
  },
  {
   value: "Boa Esperanca do Sul (BRBSU)",
   label: "Boa Esperanca do Sul (BRBSU)"
  },
  {
   value: "Boa Viagem (BRBVG)",
   label: "Boa Viagem (BRBVG)"
  },
  {
   value: "Boa Vista (BRBST)",
   label: "Boa Vista (BRBST)"
  },
  {
   value: "Boca do Acre Apt (BRBCR)",
   label: "Boca do Acre Apt (BRBCR)"
  },
  {
   value: "Bocaina (BRBOC)",
   label: "Bocaina (BRBOC)"
  },
  {
   value: "Bocaiuva (BRBOV)",
   label: "Bocaiuva (BRBOV)"
  },
  {
   value: "Bodoquena (BRBQA)",
   label: "Bodoquena (BRBQA)"
  },
  {
   value: "Boituva (BRBTV)",
   label: "Boituva (BRBTV)"
  },
  {
   value: "Bom Despacho (BRBDP)",
   label: "Bom Despacho (BRBDP)"
  },
  {
   value: "Bom Jardim de Goias (BRBJG)",
   label: "Bom Jardim de Goias (BRBJG)"
  },
  {
   value: "Bom Jesus de Goias (BRBJS)",
   label: "Bom Jesus de Goias (BRBJS)"
  },
  {
   value: "Bom Jesus de Itabapoana (BRBJI)",
   label: "Bom Jesus de Itabapoana (BRBJI)"
  },
  {
   value: "Bom Jesus dos Perdoes (BRBJO)",
   label: "Bom Jesus dos Perdoes (BRBJO)"
  },
  {
   value: "Bom Principio (BRBPP)",
   label: "Bom Principio (BRBPP)"
  },
  {
   value: "Bom Sucesso (BRBSC)",
   label: "Bom Sucesso (BRBSC)"
  },
  {
   value: "Bombinhas (BRBBS)",
   label: "Bombinhas (BRBBS)"
  },
  {
   value: "Bonito (BRBNO)",
   label: "Bonito (BRBNO)"
  },
  {
   value: "Bonito (BRBYO)",
   label: "Bonito (BRBYO)"
  },
  {
   value: "Boquim (BRBQU)",
   label: "Boquim (BRBQU)"
  },
  {
   value: "Boraceia (BRBRE)",
   label: "Boraceia (BRBRE)"
  },
  {
   value: "Borborema (BRBBM)",
   label: "Borborema (BRBBM)"
  },
  {
   value: "Braco do Norte (BRBNT)",
   label: "Braco do Norte (BRBNT)"
  },
  {
   value: "Braganca (BRBNC)",
   label: "Braganca (BRBNC)"
  },
  {
   value: "Braganca Paulista (BRBJP)",
   label: "Braganca Paulista (BRBJP)"
  },
  {
   value: "Bertioga (BRBTG)",
   label: "Bertioga (BRBTG)"
  },
  {
   value: "Barra do Piraí (BRQBD)",
   label: "Barra do Piraí (BRQBD)"
  },
  {
   value: "Barra do Ribeiro (BRBRO)",
   label: "Barra do Ribeiro (BRBRO)"
  },
  {
   value: "Barra dos Coqueiros (BRBAR)",
   label: "Barra dos Coqueiros (BRBAR)"
  },
  {
   value: "Barra Grande (BRBGA)",
   label: "Barra Grande (BRBGA)"
  },
  {
   value: "Barra Mansa (BRQBN)",
   label: "Barra Mansa (BRQBN)"
  },
  {
   value: "Barra Velha (BRBVA)",
   label: "Barra Velha (BRBVA)"
  },
  {
   value: "Barracao (BRBRC)",
   label: "Barracao (BRBRC)"
  },
  {
   value: "Barreirinhas (BRBRB)",
   label: "Barreirinhas (BRBRB)"
  },
  {
   value: "Barreiros (BRBRS)",
   label: "Barreiros (BRBRS)"
  },
  {
   value: "Barrinha (BRBRH)",
   label: "Barrinha (BRBRH)"
  },
  {
   value: "Barroso (BRBSO)",
   label: "Barroso (BRBSO)"
  },
  {
   value: "Barueri (BRBRI)",
   label: "Barueri (BRBRI)"
  },
  {
   value: "Bastos (BRBTS)",
   label: "Bastos (BRBTS)"
  },
  {
   value: "Bataguassu (BRBGU)",
   label: "Bataguassu (BRBGU)"
  },
  {
   value: "Batatais (BRBTA)",
   label: "Batatais (BRBTA)"
  },
  {
   value: "Baturite (BRBTU)",
   label: "Baturite (BRBTU)"
  },
  {
   value: "Bayeux (BRBAY)",
   label: "Bayeux (BRBAY)"
  },
  {
   value: "Bebedouro (BRQAU)",
   label: "Bebedouro (BRQAU)"
  },
  {
   value: "Beberibe (BRBBI)",
   label: "Beberibe (BRBBI)"
  },
  {
   value: "Beija-Flor (BRBLO)",
   label: "Beija-Flor (BRBLO)"
  },
  {
   value: "Bela Vista (BRBVT)",
   label: "Bela Vista (BRBVT)"
  },
  {
   value: "Bela Vista do Paraiso (BRBVP)",
   label: "Bela Vista do Paraiso (BRBVP)"
  },
  {
   value: "Belford Roxo (BRBRX)",
   label: "Belford Roxo (BRBRX)"
  },
  {
   value: "Belmonte (BRBVM)",
   label: "Belmonte (BRBVM)"
  },
  {
   value: "Belo Jardim (BRBJB)",
   label: "Belo Jardim (BRBJB)"
  },
  {
   value: "Benedito Novo (BRBNV)",
   label: "Benedito Novo (BRBNV)"
  },
  {
   value: "Benevides (BRBVI)",
   label: "Benevides (BRBVI)"
  },
  {
   value: "Bernardino de Campos (BRBCP)",
   label: "Bernardino de Campos (BRBCP)"
  },
  {
   value: "Artur Nogueira (BRANG)",
   label: "Artur Nogueira (BRANG)"
  },
  {
   value: "Aruana (BRAUN)",
   label: "Aruana (BRAUN)"
  },
  {
   value: "Aruja (BRAUJ)",
   label: "Aruja (BRAUJ)"
  },
  {
   value: "Assai (BRASI)",
   label: "Assai (BRASI)"
  },
  {
   value: "Assis Chateaubriand (BRACD)",
   label: "Assis Chateaubriand (BRACD)"
  },
  {
   value: "Assu (BRASU)",
   label: "Assu (BRASU)"
  },
  {
   value: "Astorga (BRASG)",
   label: "Astorga (BRASG)"
  },
  {
   value: "Ataleia (BRATL)",
   label: "Ataleia (BRATL)"
  },
  {
   value: "Atibaia (BRABA)",
   label: "Atibaia (BRABA)"
  },
  {
   value: "Atílio Vivacqua (BRAVB)",
   label: "Atílio Vivacqua (BRAVB)"
  },
  {
   value: "Auriflama (BRAFM)",
   label: "Auriflama (BRAFM)"
  },
  {
   value: "Avare (BRAVA)",
   label: "Avare (BRAVA)"
  },
  {
   value: "Bacabal (BRBBA)",
   label: "Bacabal (BRBBA)"
  },
  {
   value: "Baependi (BRBPI)",
   label: "Baependi (BRBPI)"
  },
  {
   value: "Baia Formosa (BRBFO)",
   label: "Baia Formosa (BRBFO)"
  },
  {
   value: "Balneário de Camboriú (BRBCU)",
   label: "Balneário de Camboriú (BRBCU)"
  },
  {
   value: "Balneário do Rincão (BRBOR)",
   label: "Balneário do Rincão (BRBOR)"
  },
  {
   value: "Bananal (BRBNA)",
   label: "Bananal (BRBNA)"
  },
  {
   value: "Bandeirantes (BRBND)",
   label: "Bandeirantes (BRBND)"
  },
  {
   value: "Barao de Cocais (BRBCI)",
   label: "Barao de Cocais (BRBCI)"
  },
  {
   value: "Barao de Cotigipe (BRBCG)",
   label: "Barao de Cotigipe (BRBCG)"
  },
  {
   value: "Barauna (BRBUN)",
   label: "Barauna (BRBUN)"
  },
  {
   value: "Barbacena (BRBCN)",
   label: "Barbacena (BRBCN)"
  },
  {
   value: "Barbosa (BRBSA)",
   label: "Barbosa (BRBSA)"
  },
  {
   value: "Bariri (BRBIR)",
   label: "Bariri (BRBIR)"
  },
  {
   value: "Barra Bonita (BRBBO)",
   label: "Barra Bonita (BRBBO)"
  },
  {
   value: "Barra de Santo Antonio (BRBTO)",
   label: "Barra de Santo Antonio (BRBTO)"
  },
  {
   value: "Barra de Sao Miguel (BRBSM)",
   label: "Barra de Sao Miguel (BRBSM)"
  },
  {
   value: "Barra do Bugres (BRBBG)",
   label: "Barra do Bugres (BRBBG)"
  },
  {
   value: "Barra do Corda (BRBDC)",
   label: "Barra do Corda (BRBDC)"
  },
  {
   value: "Arroio do Meio (BRAMI)",
   label: "Arroio do Meio (BRAMI)"
  },
  {
   value: "Aracoiaba da Serra (BRASR)",
   label: "Aracoiaba da Serra (BRASR)"
  },
  {
   value: "Aracruz (BRACZ)",
   label: "Aracruz (BRACZ)"
  },
  {
   value: "Aracuai (BRAAA)",
   label: "Aracuai (BRAAA)"
  },
  {
   value: "Araguacu (BRARG)",
   label: "Araguacu (BRARG)"
  },
  {
   value: "Araguapaz (BRAGZ)",
   label: "Araguapaz (BRAGZ)"
  },
  {
   value: "Araguari (BRARR)",
   label: "Araguari (BRARR)"
  },
  {
   value: "Arapora (BRARP)",
   label: "Arapora (BRARP)"
  },
  {
   value: "Araputanga (BRATN)",
   label: "Araputanga (BRATN)"
  },
  {
   value: "Ararangua (BRARN)",
   label: "Ararangua (BRARN)"
  },
  {
   value: "Araras (BRARA)",
   label: "Araras (BRARA)"
  },
  {
   value: "Araripina (BRAIP)",
   label: "Araripina (BRAIP)"
  },
  {
   value: "Araruama (BRAMA)",
   label: "Araruama (BRAMA)"
  },
  {
   value: "Araucária (BRACA)",
   label: "Araucária (BRACA)"
  },
  {
   value: "Arcos (BRAOS)",
   label: "Arcos (BRAOS)"
  },
  {
   value: "Arcoverde (BRARV)",
   label: "Arcoverde (BRARV)"
  },
  {
   value: "Areado (BRADO)",
   label: "Areado (BRADO)"
  },
  {
   value: "Areal (BRARL)",
   label: "Areal (BRARL)"
  },
  {
   value: "Areia (BRAEI)",
   label: "Areia (BRAEI)"
  },
  {
   value: "Areia Branca (BRARE)",
   label: "Areia Branca (BRARE)"
  },
  {
   value: "Arembepe (BRAPE)",
   label: "Arembepe (BRAPE)"
  },
  {
   value: "Arenapolis (BRAPL)",
   label: "Arenapolis (BRAPL)"
  },
  {
   value: "Ariranha (BRARH)",
   label: "Ariranha (BRARH)"
  },
  {
   value: "Armacao de Buzios (BRABZ)",
   label: "Armacao de Buzios (BRABZ)"
  },
  {
   value: "Arraial (BRADJ)",
   label: "Arraial (BRADJ)"
  },
  {
   value: "Arraial do Cabo (BRACB)",
   label: "Arraial do Cabo (BRACB)"
  },
  {
   value: "Araçás (BRARK)",
   label: "Araçás (BRARK)"
  },
  {
   value: "Alvorada (BRAVR)",
   label: "Alvorada (BRAVR)"
  },
  {
   value: "Alvorada do Norte (BRAVN)",
   label: "Alvorada do Norte (BRAVN)"
  },
  {
   value: "Amambai (BRAMB)",
   label: "Amambai (BRAMB)"
  },
  {
   value: "Amaraji (BRARJ)",
   label: "Amaraji (BRARJ)"
  },
  {
   value: "Americana (BRAME)",
   label: "Americana (BRAME)"
  },
  {
   value: "Americo Brasiliense (BRABI)",
   label: "Americo Brasiliense (BRABI)"
  },
  {
   value: "Americo de Campos (BRACP)",
   label: "Americo de Campos (BRACP)"
  },
  {
   value: "Amparo (BRAMP)",
   label: "Amparo (BRAMP)"
  },
  {
   value: "Analandia (BRANI)",
   label: "Analandia (BRANI)"
  },
  {
   value: "Anastacio (BRATC)",
   label: "Anastacio (BRATC)"
  },
  {
   value: "Anchieta (BRAHI)",
   label: "Anchieta (BRAHI)"
  },
  {
   value: "Andarai (BRARI)",
   label: "Andarai (BRARI)"
  },
  {
   value: "Andira (BRAIA)",
   label: "Andira (BRAIA)"
  },
  {
   value: "Andorinha (BRBAA)",
   label: "Andorinha (BRBAA)"
  },
  {
   value: "Andradas (BRARD)",
   label: "Andradas (BRARD)"
  },
  {
   value: "Andradina (BRAAN)",
   label: "Andradina (BRAAN)"
  },
  {
   value: "Angatuba (BRAGT)",
   label: "Angatuba (BRAGT)"
  },
  {
   value: "Angelica (BRAIC)",
   label: "Angelica (BRAIC)"
  },
  {
   value: "Anicuns (BRANC)",
   label: "Anicuns (BRANC)"
  },
  {
   value: "Antonio Carlos (BRACS)",
   label: "Antonio Carlos (BRACS)"
  },
  {
   value: "Antonio Joao (BRAJO)",
   label: "Antonio Joao (BRAJO)"
  },
  {
   value: "Antonio Prado (BRMAY)",
   label: "Antonio Prado (BRMAY)"
  },
  {
   value: "Aparecida (BRAPI)",
   label: "Aparecida (BRAPI)"
  },
  {
   value: "Aparecida de Goiania (BRAGI)",
   label: "Aparecida de Goiania (BRAGI)"
  },
  {
   value: "Aparecida do Taboado (BRATD)",
   label: "Aparecida do Taboado (BRATD)"
  },
  {
   value: "Apiai (BRAPA)",
   label: "Apiai (BRAPA)"
  },
  {
   value: "Apiuna (BRAUA)",
   label: "Apiuna (BRAUA)"
  },
  {
   value: "Aquidauana (BRAQD)",
   label: "Aquidauana (BRAQD)"
  },
  {
   value: "Aquiraz (BRAQR)",
   label: "Aquiraz (BRAQR)"
  },
  {
   value: "Araçariguama (BRARM)",
   label: "Araçariguama (BRARM)"
  },
  {
   value: "Alvares Machado (BRAMH)",
   label: "Alvares Machado (BRAMH)"
  },
  {
   value: "Aguas de Sao Pedro (BRASO)",
   label: "Aguas de Sao Pedro (BRASO)"
  },
  {
   value: "Aguas Mornas (BRAMR)",
   label: "Aguas Mornas (BRAMR)"
  },
  {
   value: "Agudo (BRAGO)",
   label: "Agudo (BRAGO)"
  },
  {
   value: "Agudos (BRAGD)",
   label: "Agudos (BRAGD)"
  },
  {
   value: "Aimores (BRAMS)",
   label: "Aimores (BRAMS)"
  },
  {
   value: "Aiuruoca (BRARC)",
   label: "Aiuruoca (BRARC)"
  },
  {
   value: "Alagoinhas (BRAGS)",
   label: "Alagoinhas (BRAGS)"
  },
  {
   value: "Alcantara (BRACT)",
   label: "Alcantara (BRACT)"
  },
  {
   value: "Alcobaca (BRALC)",
   label: "Alcobaca (BRALC)"
  },
  {
   value: "Alegre (BRALG)",
   label: "Alegre (BRALG)"
  },
  {
   value: "Alem Paraiba (BRAPB)",
   label: "Alem Paraiba (BRAPB)"
  },
  {
   value: "Alexania (BRAXN)",
   label: "Alexania (BRAXN)"
  },
  {
   value: "Alfenas (BRALF)",
   label: "Alfenas (BRALF)"
  },
  {
   value: "Alhandra (BRALH)",
   label: "Alhandra (BRALH)"
  },
  {
   value: "Almeirim (BRAMM)",
   label: "Almeirim (BRAMM)"
  },
  {
   value: "Aloandia (BRALO)",
   label: "Aloandia (BRALO)"
  },
  {
   value: "Alpinópolis (BRALP)",
   label: "Alpinópolis (BRALP)"
  },
  {
   value: "Alta Floresta do Oeste (BRAFO)",
   label: "Alta Floresta do Oeste (BRAFO)"
  },
  {
   value: "Alterosa (BRATS)",
   label: "Alterosa (BRATS)"
  },
  {
   value: "Altinopolis (BRAPO)",
   label: "Altinopolis (BRAPO)"
  },
  {
   value: "Alto Araguaia (BRATG)",
   label: "Alto Araguaia (BRATG)"
  },
  {
   value: "Alto Garcas (BRAGR)",
   label: "Alto Garcas (BRAGR)"
  },
  {
   value: "Alto Paraiso de Goias (BRAPG)",
   label: "Alto Paraiso de Goias (BRAPG)"
  },
  {
   value: "Alto Parana (BRAPN)",
   label: "Alto Parana (BRAPN)"
  },
  {
   value: "Alto Piquiri (BRAQI)",
   label: "Alto Piquiri (BRAQI)"
  },
  {
   value: "Alto Taquari (BRATQ)",
   label: "Alto Taquari (BRATQ)"
  },
  {
   value: "Altonia (BRATO)",
   label: "Altonia (BRATO)"
  },
  {
   value: "Alumar (BRALU)",
   label: "Alumar (BRALU)"
  },
  {
   value: "Alumínio (BRAMO)",
   label: "Alumínio (BRAMO)"
  },
  {
   value: "Aguas de Santa Barbara (BRASB)",
   label: "Aguas de Santa Barbara (BRASB)"
  },
  {
   value: "Santiváñez (BOSAN)",
   label: "Santiváñez (BOSAN)"
  },
  {
   value: "Uyuni (BOUYU)",
   label: "Uyuni (BOUYU)"
  },
  {
   value: ".BRAZIL (BR)",
   label: ".BRAZIL (BR)"
  },
  {
   value: "Abaeté (BRABT)",
   label: "Abaeté (BRABT)"
  },
  {
   value: "Abaetetuba (BRATB)",
   label: "Abaetetuba (BRATB)"
  },
  {
   value: "Abelardo Luz (BRADL)",
   label: "Abelardo Luz (BRADL)"
  },
  {
   value: "Abreu e Lima (BRALM)",
   label: "Abreu e Lima (BRALM)"
  },
  {
   value: "Acailandia (BRACL)",
   label: "Acailandia (BRACL)"
  },
  {
   value: "Acailandia (BRALI)",
   label: "Acailandia (BRALI)"
  },
  {
   value: "Acarau (BRACU)",
   label: "Acarau (BRACU)"
  },
  {
   value: "Acari (BRACR)",
   label: "Acari (BRACR)"
  },
  {
   value: "Acreuna (BRACN)",
   label: "Acreuna (BRACN)"
  },
  {
   value: "Adamantina (BRAMT)",
   label: "Adamantina (BRAMT)"
  },
  {
   value: "Afogados da Ingazeira (BRADI)",
   label: "Afogados da Ingazeira (BRADI)"
  },
  {
   value: "Afonso Claudio (BRAFC)",
   label: "Afonso Claudio (BRAFC)"
  },
  {
   value: "Agrolandia (BRARO)",
   label: "Agrolandia (BRARO)"
  },
  {
   value: "Água Boa (BRABO)",
   label: "Água Boa (BRABO)"
  },
  {
   value: "Agua Clara (BRAGC)",
   label: "Agua Clara (BRAGC)"
  },
  {
   value: "Aguai (BRAGU)",
   label: "Aguai (BRAGU)"
  },
  {
   value: "Aguas da Prata (BRASP)",
   label: "Aguas da Prata (BRASP)"
  },
  {
   value: "Aguas de Lindoia (BRAGL)",
   label: "Aguas de Lindoia (BRAGL)"
  },
  {
   value: "Kings Wharf (BMKWF)",
   label: "Kings Wharf (BMKWF)"
  },
  {
   value: ".BRUNEI DARUSSALAM (BN)",
   label: ".BRUNEI DARUSSALAM (BN)"
  },
  {
   value: ".BOLIVIA (BO)",
   label: ".BOLIVIA (BO)"
  },
  {
   value: "Carrasco (BOCAR)",
   label: "Carrasco (BOCAR)"
  },
  {
   value: "Puerto Quijarro (BOQJR)",
   label: "Puerto Quijarro (BOQJR)"
  },
  {
   value: "Yakoruda (BGYAK)",
   label: "Yakoruda (BGYAK)"
  },
  {
   value: "Yambol (BGYAM)",
   label: "Yambol (BGYAM)"
  },
  {
   value: ".BAHRAIN (BH)",
   label: ".BAHRAIN (BH)"
  },
  {
   value: "Al Hidd (BHAHD)",
   label: "Al Hidd (BHAHD)"
  },
  {
   value: "Al Jufayr (BHJUF)",
   label: "Al Jufayr (BHJUF)"
  },
  {
   value: "Al Muaskar (BHMUA)",
   label: "Al Muaskar (BHMUA)"
  },
  {
   value: "Khalifa Bin Salman Pt (BHKBS)",
   label: "Khalifa Bin Salman Pt (BHKBS)"
  },
  {
   value: "Mina Sulman Pt (BHMSP)",
   label: "Mina Sulman Pt (BHMSP)"
  },
  {
   value: ".BURUNDI (BI)",
   label: ".BURUNDI (BI)"
  },
  {
   value: "Bubanza (BIBBZ)",
   label: "Bubanza (BIBBZ)"
  },
  {
   value: "Bururi (BIBRR)",
   label: "Bururi (BIBRR)"
  },
  {
   value: "Cibitoke (BICBK)",
   label: "Cibitoke (BICBK)"
  },
  {
   value: "Muyinga (BIMYG)",
   label: "Muyinga (BIMYG)"
  },
  {
   value: "Ngozi (BINGZ)",
   label: "Ngozi (BINGZ)"
  },
  {
   value: ".BENIN (BJ)",
   label: ".BENIN (BJ)"
  },
  {
   value: "Agbanta (BJAGT)",
   label: "Agbanta (BJAGT)"
  },
  {
   value: "Bohicon (BJBOH)",
   label: "Bohicon (BJBOH)"
  },
  {
   value: "Glazoué (BJGLA)",
   label: "Glazoué (BJGLA)"
  },
  {
   value: "Tanguiéta (BJTAN)",
   label: "Tanguiéta (BJTAN)"
  },
  {
   value: ".BERMUDA (BM)",
   label: ".BERMUDA (BM)"
  },
  {
   value: "Vratza (BGVRA)",
   label: "Vratza (BGVRA)"
  },
  {
   value: "Sozopol (BGSOZ)",
   label: "Sozopol (BGSOZ)"
  },
  {
   value: "Sredets (BGSDE)",
   label: "Sredets (BGSDE)"
  },
  {
   value: "Stambolijski (BGSKI)",
   label: "Stambolijski (BGSKI)"
  },
  {
   value: "Stamboliyski (BGSTA)",
   label: "Stamboliyski (BGSTA)"
  },
  {
   value: "Staro Selo (BGZSS)",
   label: "Staro Selo (BGZSS)"
  },
  {
   value: "Stryama (BGPSA)",
   label: "Stryama (BGPSA)"
  },
  {
   value: "Surnitsa (BGSNA)",
   label: "Surnitsa (BGSNA)"
  },
  {
   value: "Svoge (BGSVG)",
   label: "Svoge (BGSVG)"
  },
  {
   value: "Teteven (BGTTV)",
   label: "Teteven (BGTTV)"
  },
  {
   value: "Topoli (BGTPL)",
   label: "Topoli (BGTPL)"
  },
  {
   value: "Trastenik (BGPTK)",
   label: "Trastenik (BGPTK)"
  },
  {
   value: "Tryavna (BGTRA)",
   label: "Tryavna (BGTRA)"
  },
  {
   value: "Tsarevo (BGTRV)",
   label: "Tsarevo (BGTRV)"
  },
  {
   value: "Tvardica (BGTAD)",
   label: "Tvardica (BGTAD)"
  },
  {
   value: "Valchi Dol (BGVDL)",
   label: "Valchi Dol (BGVDL)"
  },
  {
   value: "Varshets (BGVAS)",
   label: "Varshets (BGVAS)"
  },
  {
   value: "Venets (BGVNT)",
   label: "Venets (BGVNT)"
  },
  {
   value: "Pavel (BGPVL)",
   label: "Pavel (BGPVL)"
  },
  {
   value: "Pavlikeni (BGPAV)",
   label: "Pavlikeni (BGPAV)"
  },
  {
   value: "Pirdop (BGPIR)",
   label: "Pirdop (BGPIR)"
  },
  {
   value: "Podayva (BGPOD)",
   label: "Podayva (BGPOD)"
  },
  {
   value: "Pravets (BGPRA)",
   label: "Pravets (BGPRA)"
  },
  {
   value: "Radinovo (BGPRO)",
   label: "Radinovo (BGPRO)"
  },
  {
   value: "Radnevo (BGRDV)",
   label: "Radnevo (BGRDV)"
  },
  {
   value: "Rakitovo (BGJAK)",
   label: "Rakitovo (BGJAK)"
  },
  {
   value: "Rakovski (BGRAK)",
   label: "Rakovski (BGRAK)"
  },
  {
   value: "Razlog (BGRAZ)",
   label: "Razlog (BGRAZ)"
  },
  {
   value: "Rudozem (BGRDZ)",
   label: "Rudozem (BGRDZ)"
  },
  {
   value: "Saedinenie (BGSAE)",
   label: "Saedinenie (BGSAE)"
  },
  {
   value: "Saedinenie (BGSPL)",
   label: "Saedinenie (BGSPL)"
  },
  {
   value: "Samokov (BGSAM)",
   label: "Samokov (BGSAM)"
  },
  {
   value: "Shumen (BGSMN)",
   label: "Shumen (BGSMN)"
  },
  {
   value: "Parvomai (BGPVM)",
   label: "Parvomai (BGPVM)"
  },
  {
   value: "Krushari (BGKRH)",
   label: "Krushari (BGKRH)"
  },
  {
   value: "Kubrat (BGKUB)",
   label: "Kubrat (BGKUB)"
  },
  {
   value: "Kyustendil (BGKYS)",
   label: "Kyustendil (BGKYS)"
  },
  {
   value: "Laki (BGLKI)",
   label: "Laki (BGLKI)"
  },
  {
   value: "Liaskovec (BGLIA)",
   label: "Liaskovec (BGLIA)"
  },
  {
   value: "Lokorsko (BGLOK)",
   label: "Lokorsko (BGLOK)"
  },
  {
   value: "Lomci (BGTLI)",
   label: "Lomci (BGTLI)"
  },
  {
   value: "Lyubimets (BGLMC)",
   label: "Lyubimets (BGLMC)"
  },
  {
   value: "Lyuliakovo (BGBLO)",
   label: "Lyuliakovo (BGBLO)"
  },
  {
   value: "Mednikarovo (BGMNR)",
   label: "Mednikarovo (BGMNR)"
  },
  {
   value: "Mezdra (BGMEZ)",
   label: "Mezdra (BGMEZ)"
  },
  {
   value: "Mirkovo (BGMIR)",
   label: "Mirkovo (BGMIR)"
  },
  {
   value: "Miziya (BGMIZ)",
   label: "Miziya (BGMIZ)"
  },
  {
   value: "Musachevo (BGMUC)",
   label: "Musachevo (BGMUC)"
  },
  {
   value: "Nessebar (BGNES)",
   label: "Nessebar (BGNES)"
  },
  {
   value: "Nikopol (BGNPO)",
   label: "Nikopol (BGNPO)"
  },
  {
   value: "Novi Isar (BGNIS)",
   label: "Novi Isar (BGNIS)"
  },
  {
   value: "Omurtag (BGOMU)",
   label: "Omurtag (BGOMU)"
  },
  {
   value: "Opaka (BGOPK)",
   label: "Opaka (BGOPK)"
  },
  {
   value: "Orizovo (BGORI)",
   label: "Orizovo (BGORI)"
  },
  {
   value: "Oryakhovo (BGOKH)",
   label: "Oryakhovo (BGOKH)"
  },
  {
   value: "Panagyurishte (BGPPE)",
   label: "Panagyurishte (BGPPE)"
  },
  {
   value: "Kozloduj (BGKOZ)",
   label: "Kozloduj (BGKOZ)"
  },
  {
   value: "Dupnica (BGDUP)",
   label: "Dupnica (BGDUP)"
  },
  {
   value: "Elin Pelin (BGEPE)",
   label: "Elin Pelin (BGEPE)"
  },
  {
   value: "Elkhovo (BGEHO)",
   label: "Elkhovo (BGEHO)"
  },
  {
   value: "Golyamo Chochoveni (BGGOL)",
   label: "Golyamo Chochoveni (BGGOL)"
  },
  {
   value: "Gotse Delchev (BGGDU)",
   label: "Gotse Delchev (BGGDU)"
  },
  {
   value: "Iablanitsa (BGIAB)",
   label: "Iablanitsa (BGIAB)"
  },
  {
   value: "Isperih (BGISP)",
   label: "Isperih (BGISP)"
  },
  {
   value: "Karnobat (BGKBT)",
   label: "Karnobat (BGKBT)"
  },
  {
   value: "Katunitza (BGKAT)",
   label: "Katunitza (BGKAT)"
  },
  {
   value: "Kavarna (BGKVN)",
   label: "Kavarna (BGKVN)"
  },
  {
   value: "Kazanlak (BGKZK)",
   label: "Kazanlak (BGKZK)"
  },
  {
   value: "Kharmanli (BGHMI)",
   label: "Kharmanli (BGHMI)"
  },
  {
   value: "Khaskovo (BGKHO)",
   label: "Khaskovo (BGKHO)"
  },
  {
   value: "Knezha (BGKNE)",
   label: "Knezha (BGKNE)"
  },
  {
   value: "Koprivshtitsa (BGSKA)",
   label: "Koprivshtitsa (BGSKA)"
  },
  {
   value: "Kostenets (BGKOS)",
   label: "Kostenets (BGKOS)"
  },
  {
   value: "Kostinbrod (BGKBR)",
   label: "Kostinbrod (BGKBR)"
  },
  {
   value: "Apriltsi (BGAPI)",
   label: "Apriltsi (BGAPI)"
  },
  {
   value: "Banevo (BGBVO)",
   label: "Banevo (BGBVO)"
  },
  {
   value: "Bansko (BGBAO)",
   label: "Bansko (BGBAO)"
  },
  {
   value: "Bata (BGBBA)",
   label: "Bata (BGBBA)"
  },
  {
   value: "Batak (BGBAT)",
   label: "Batak (BGBAT)"
  },
  {
   value: "Belene (BGBLE)",
   label: "Belene (BGBLE)"
  },
  {
   value: "Belitsa (BGBEL)",
   label: "Belitsa (BGBEL)"
  },
  {
   value: "Bjala Slatina (BGVBS)",
   label: "Bjala Slatina (BGVBS)"
  },
  {
   value: "Borovo (BGBRV)",
   label: "Borovo (BGBRV)"
  },
  {
   value: "Brestovets (BGBTV)",
   label: "Brestovets (BGBTV)"
  },
  {
   value: "Breznik (BGBRZ)",
   label: "Breznik (BGBRZ)"
  },
  {
   value: "Byala (BGBYL)",
   label: "Byala (BGBYL)"
  },
  {
   value: "Byala Slatina (BGBSL)",
   label: "Byala Slatina (BGBSL)"
  },
  {
   value: "Chakalarevo (BGCHR)",
   label: "Chakalarevo (BGCHR)"
  },
  {
   value: "Chepintsi (BGCHE)",
   label: "Chepintsi (BGCHE)"
  },
  {
   value: "Cherven Bryag (BGCHV)",
   label: "Cherven Bryag (BGCHV)"
  },
  {
   value: "Debelt (BGDEL)",
   label: "Debelt (BGDEL)"
  },
  {
   value: "Dolna Banya (BGDOB)",
   label: "Dolna Banya (BGDOB)"
  },
  {
   value: "Dolni Chiflik (BGDOC)",
   label: "Dolni Chiflik (BGDOC)"
  },
  {
   value: "Dryanovo (BGDNV)",
   label: "Dryanovo (BGDNV)"
  },
  {
   value: "Aksakovo (BGASA)",
   label: "Aksakovo (BGASA)"
  },
  {
   value: ".BURKINA FASO (BF)",
   label: ".BURKINA FASO (BF)"
  },
  {
   value: "Bérégadougou (BFBER)",
   label: "Bérégadougou (BFBER)"
  },
  {
   value: "Kossodo (BFKOS)",
   label: "Kossodo (BFKOS)"
  },
  {
   value: "Kourouma (BFKOR)",
   label: "Kourouma (BFKOR)"
  },
  {
   value: "Poura (BFPOU)",
   label: "Poura (BFPOU)"
  },
  {
   value: "Saponé (BFSAP)",
   label: "Saponé (BFSAP)"
  },
  {
   value: "Ziga (BFZIG)",
   label: "Ziga (BFZIG)"
  },
  {
   value: ".BULGARIA (BG)",
   label: ".BULGARIA (BG)"
  },
  {
   value: "Aitos (BGAIO)",
   label: "Aitos (BGAIO)"
  },
  {
   value: "Wulvergem (BEWUV)",
   label: "Wulvergem (BEWUV)"
  },
  {
   value: "Xhendelesse (BEXDE)",
   label: "Xhendelesse (BEXDE)"
  },
  {
   value: "Xhendremael (BEXDA)",
   label: "Xhendremael (BEXDA)"
  },
  {
   value: "Xhoris (BEXHO)",
   label: "Xhoris (BEXHO)"
  },
  {
   value: "Yvoir (BEYVO)",
   label: "Yvoir (BEYVO)"
  },
  {
   value: "Zandbergen (BEZBR)",
   label: "Zandbergen (BEZBR)"
  },
  {
   value: "Zandvliet (BEZVT)",
   label: "Zandvliet (BEZVT)"
  },
  {
   value: "Zarren (BEZRN)",
   label: "Zarren (BEZRN)"
  },
  {
   value: "Zelem (BEZEM)",
   label: "Zelem (BEZEM)"
  },
  {
   value: "Zemst (BEZET)",
   label: "Zemst (BEZET)"
  },
  {
   value: "Zichem (BEZIC)",
   label: "Zichem (BEZIC)"
  },
  {
   value: "Zillebeke (BEZIB)",
   label: "Zillebeke (BEZIB)"
  },
  {
   value: "Zingem (BEZGM)",
   label: "Zingem (BEZGM)"
  },
  {
   value: "Zomergem (BEZRM)",
   label: "Zomergem (BEZRM)"
  },
  {
   value: "Zonnebeke (BEZOB)",
   label: "Zonnebeke (BEZOB)"
  },
  {
   value: "Zoutleeuw (BEZOU)",
   label: "Zoutleeuw (BEZOU)"
  },
  {
   value: "Zuen (Zuun) (BEZUN)",
   label: "Zuen (Zuun) (BEZUN)"
  },
  {
   value: "Zuidschote (BEZSO)",
   label: "Zuidschote (BEZSO)"
  },
  {
   value: "Zuienkerke (BEZKE)",
   label: "Zuienkerke (BEZKE)"
  },
  {
   value: "Zutendaal (BEZTL)",
   label: "Zutendaal (BEZTL)"
  },
  {
   value: "Zwalm (BEZWA)",
   label: "Zwalm (BEZWA)"
  },
  {
   value: "Wulpen (BEWLP)",
   label: "Wulpen (BEWLP)"
  },
  {
   value: "Zwevezele (BEVGZ)",
   label: "Zwevezele (BEVGZ)"
  },
  {
   value: "Wezel (BEWZL)",
   label: "Wezel (BEWZL)"
  },
  {
   value: "Wezemaal (BEWZE)",
   label: "Wezemaal (BEWZE)"
  },
  {
   value: "Wezembeek-Oppem (BEWKO)",
   label: "Wezembeek-Oppem (BEWKO)"
  },
  {
   value: "Wezeren (BEWEN)",
   label: "Wezeren (BEWEN)"
  },
  {
   value: "Wibrin (BEWIB)",
   label: "Wibrin (BEWIB)"
  },
  {
   value: "Wichelen (BEWIH)",
   label: "Wichelen (BEWIH)"
  },
  {
   value: "Wiekevorst (BEWVO)",
   label: "Wiekevorst (BEWVO)"
  },
  {
   value: "Wielsbeke (BEWIK)",
   label: "Wielsbeke (BEWIK)"
  },
  {
   value: "Wierde (BEWID)",
   label: "Wierde (BEWID)"
  },
  {
   value: "Wiesme (BEWIS)",
   label: "Wiesme (BEWIS)"
  },
  {
   value: "Wihogne (BEWGH)",
   label: "Wihogne (BEWGH)"
  },
  {
   value: "Wijgmaal (BEWGL)",
   label: "Wijgmaal (BEWGL)"
  },
  {
   value: "Wijtschate (BEWYT)",
   label: "Wijtschate (BEWYT)"
  },
  {
   value: "Wilderen (BEWDN)",
   label: "Wilderen (BEWDN)"
  },
  {
   value: "Willaupuis (BEWPU)",
   label: "Willaupuis (BEWPU)"
  },
  {
   value: "Willemeau (BEWMA)",
   label: "Willemeau (BEWMA)"
  },
  {
   value: "Wimmertingen (BEWTI)",
   label: "Wimmertingen (BEWTI)"
  },
  {
   value: "Wintershoven (BEWTO)",
   label: "Wintershoven (BEWTO)"
  },
  {
   value: "Winterslag (BEWSG)",
   label: "Winterslag (BEWSG)"
  },
  {
   value: "Wintham (BEWTH)",
   label: "Wintham (BEWTH)"
  },
  {
   value: "Woluwé-Saint-Lambert (Sint-Lambrechts-Woluwe) (BESLW)",
   label: "Woluwé-Saint-Lambert (Sint-Lambrechts-Woluwe) (BESLW)"
  },
  {
   value: "Woluwé-Saint-Pierre (Sint-Pieters-Woluwe) (BESPO)",
   label: "Woluwé-Saint-Pierre (Sint-Pieters-Woluwe) (BESPO)"
  },
  {
   value: "Wolvertem (BEWOV)",
   label: "Wolvertem (BEWOV)"
  },
  {
   value: "Wommelgem (BEWMM)",
   label: "Wommelgem (BEWMM)"
  },
  {
   value: "Wortegem-Petegem (BEWPE)",
   label: "Wortegem-Petegem (BEWPE)"
  },
  {
   value: "Wortel (BEWOR)",
   label: "Wortel (BEWOR)"
  },
  {
   value: "Waremme (BEWRE)",
   label: "Waremme (BEWRE)"
  },
  {
   value: "Warnant (BEWNA)",
   label: "Warnant (BEWNA)"
  },
  {
   value: "Warneton (BEBWN)",
   label: "Warneton (BEBWN)"
  },
  {
   value: "Warsage (BEWSA)",
   label: "Warsage (BEWSA)"
  },
  {
   value: "Wasmes-Audemez-Briffoeil (BEWUB)",
   label: "Wasmes-Audemez-Briffoeil (BEWUB)"
  },
  {
   value: "Wasseiges (BEWSI)",
   label: "Wasseiges (BEWSI)"
  },
  {
   value: "Waterland-Oudeman (BEWOU)",
   label: "Waterland-Oudeman (BEWOU)"
  },
  {
   value: "Watervliet (BEWVI)",
   label: "Watervliet (BEWVI)"
  },
  {
   value: "Watou (BEWTU)",
   label: "Watou (BEWTU)"
  },
  {
   value: "Waudrez (BEWDE)",
   label: "Waudrez (BEWDE)"
  },
  {
   value: "Waulsort (BEWLT)",
   label: "Waulsort (BEWLT)"
  },
  {
   value: "Ways (BEWAY)",
   label: "Ways (BEWAY)"
  },
  {
   value: "Wechelderzande (BEWHZ)",
   label: "Wechelderzande (BEWHZ)"
  },
  {
   value: "Weelde (BEWED)",
   label: "Weelde (BEWED)"
  },
  {
   value: "Weerde (BEWRD)",
   label: "Weerde (BEWRD)"
  },
  {
   value: "Weert (BEVWT)",
   label: "Weert (BEVWT)"
  },
  {
   value: "Wegnez (BEWNZ)",
   label: "Wegnez (BEWNZ)"
  },
  {
   value: "Weillen (BEWLN)",
   label: "Weillen (BEWLN)"
  },
  {
   value: "Welle (BEWLL)",
   label: "Welle (BEWLL)"
  },
  {
   value: "Wellin (BEWIN)",
   label: "Wellin (BEWIN)"
  },
  {
   value: "Wépion (BEWIP)",
   label: "Wépion (BEWIP)"
  },
  {
   value: "Werchter (BEWCE)",
   label: "Werchter (BEWCE)"
  },
  {
   value: "Westende (BEWTE)",
   label: "Westende (BEWTE)"
  },
  {
   value: "Westmalle (BEWME)",
   label: "Westmalle (BEWME)"
  },
  {
   value: "Westmeerbeek (BEWSB)",
   label: "Westmeerbeek (BEWSB)"
  },
  {
   value: "Westouter (BEWSU)",
   label: "Westouter (BEWSU)"
  },
  {
   value: "Westrem (BEWSM)",
   label: "Westrem (BEWSM)"
  },
  {
   value: "Vorselaar (BEVOL)",
   label: "Vorselaar (BEVOL)"
  },
  {
   value: "Vorst (Forest)\/Brussel (Bruxelles) (BEVOS)",
   label: "Vorst (Forest)\/Brussel (Bruxelles) (BEVOS)"
  },
  {
   value: "Vosselaar (BEVOR)",
   label: "Vosselaar (BEVOR)"
  },
  {
   value: "Vottem (BEVTM)",
   label: "Vottem (BEVTM)"
  },
  {
   value: "Vrasene (BEVSN)",
   label: "Vrasene (BEVSN)"
  },
  {
   value: "Vremde (BEVDE)",
   label: "Vremde (BEVDE)"
  },
  {
   value: "Vresse-sur-Semois (BEVSO)",
   label: "Vresse-sur-Semois (BEVSO)"
  },
  {
   value: "Vroenhoven (BEVHN)",
   label: "Vroenhoven (BEVHN)"
  },
  {
   value: "Waanrode (BEWRO)",
   label: "Waanrode (BEWRO)"
  },
  {
   value: "Waarbeke (BEWKE)",
   label: "Waarbeke (BEWKE)"
  },
  {
   value: "Waardamme (BEWDM)",
   label: "Waardamme (BEWDM)"
  },
  {
   value: "Waarloos (BEWRL)",
   label: "Waarloos (BEWRL)"
  },
  {
   value: "Waarmaarde (BEWAM)",
   label: "Waarmaarde (BEWAM)"
  },
  {
   value: "Waarschoot (BEWSO)",
   label: "Waarschoot (BEWSO)"
  },
  {
   value: "Waasmont (BEWMO)",
   label: "Waasmont (BEWMO)"
  },
  {
   value: "Wachtebeke (BEWBE)",
   label: "Wachtebeke (BEWBE)"
  },
  {
   value: "Wadelincourt (BEWLI)",
   label: "Wadelincourt (BEWLI)"
  },
  {
   value: "Wagnelée (BEWGE)",
   label: "Wagnelée (BEWGE)"
  },
  {
   value: "Waimes (BEWIM)",
   label: "Waimes (BEWIM)"
  },
  {
   value: "Walcourt (BEWCO)",
   label: "Walcourt (BEWCO)"
  },
  {
   value: "Walem (BEWLM)",
   label: "Walem (BEWLM)"
  },
  {
   value: "Walhain (BEWHA)",
   label: "Walhain (BEWHA)"
  },
  {
   value: "Walsbets (BEWSE)",
   label: "Walsbets (BEWSE)"
  },
  {
   value: "Walshoutem (BEWHO)",
   label: "Walshoutem (BEWHO)"
  },
  {
   value: "Wambeek (BEWBK)",
   label: "Wambeek (BEWBK)"
  },
  {
   value: "Wandre (BEWND)",
   label: "Wandre (BEWND)"
  },
  {
   value: "Wanfercée-Baulet (BEWBU)",
   label: "Wanfercée-Baulet (BEWBU)"
  },
  {
   value: "Wanlin (BEWNI)",
   label: "Wanlin (BEWNI)"
  },
  {
   value: "Wannebecq (BEWBQ)",
   label: "Wannebecq (BEWBQ)"
  },
  {
   value: "Wannegem-Lede (BEWLE)",
   label: "Wannegem-Lede (BEWLE)"
  },
  {
   value: "Warchin (BEWHI)",
   label: "Warchin (BEWHI)"
  },
  {
   value: "Warcoing (BEWCG)",
   label: "Warcoing (BEWCG)"
  },
  {
   value: "Voroux-lez-Liers (BEVLI)",
   label: "Voroux-lez-Liers (BEVLI)"
  },
  {
   value: "Viersel (BEVSL)",
   label: "Viersel (BEVSL)"
  },
  {
   value: "Viesville (BEVVI)",
   label: "Viesville (BEVVI)"
  },
  {
   value: "Vieux-Genappe (BEVGA)",
   label: "Vieux-Genappe (BEVGA)"
  },
  {
   value: "Ville-Pommeroeul (BEVPO)",
   label: "Ville-Pommeroeul (BEVPO)"
  },
  {
   value: "Villerot (BEVLO)",
   label: "Villerot (BEVLO)"
  },
  {
   value: "Villers-aux-Tours (BEVAT)",
   label: "Villers-aux-Tours (BEVAT)"
  },
  {
   value: "Villers-devant-Orval (BEVVO)",
   label: "Villers-devant-Orval (BEVVO)"
  },
  {
   value: "Villers-la-Ville (BEVLV)",
   label: "Villers-la-Ville (BEVLV)"
  },
  {
   value: "Villers-le-Bouillet (BEVBO)",
   label: "Villers-le-Bouillet (BEVBO)"
  },
  {
   value: "Villers-Notre-Dame (BEVNO)",
   label: "Villers-Notre-Dame (BEVNO)"
  },
  {
   value: "Villers-Saint-Amand (BEVSA)",
   label: "Villers-Saint-Amand (BEVSA)"
  },
  {
   value: "Villers-Sainte-Gertrude (BEVSG)",
   label: "Villers-Sainte-Gertrude (BEVSG)"
  },
  {
   value: "Villers-Saint-Ghislain (BEVSI)",
   label: "Villers-Saint-Ghislain (BEVSI)"
  },
  {
   value: "Villers-Saint-Siméon (BEVSS)",
   label: "Villers-Saint-Siméon (BEVSS)"
  },
  {
   value: "Ville-sur-Haine (BEVSH)",
   label: "Ville-sur-Haine (BEVSH)"
  },
  {
   value: "Vinalmont (BEVMT)",
   label: "Vinalmont (BEVMT)"
  },
  {
   value: "Vinderhoute (BEVDO)",
   label: "Vinderhoute (BEVDO)"
  },
  {
   value: "Virelles (BEVRE)",
   label: "Virelles (BEVRE)"
  },
  {
   value: "Virginal-Samme (BEVGL)",
   label: "Virginal-Samme (BEVGL)"
  },
  {
   value: "Viroinval (BEVRO)",
   label: "Viroinval (BEVRO)"
  },
  {
   value: "Vivegnis (BEVIV)",
   label: "Vivegnis (BEVIV)"
  },
  {
   value: "Vivy (BEVIY)",
   label: "Vivy (BEVIY)"
  },
  {
   value: "Vlamertinge (BEVMI)",
   label: "Vlamertinge (BEVMI)"
  },
  {
   value: "Vleteren (BEVLE)",
   label: "Vleteren (BEVLE)"
  },
  {
   value: "Vlezenbeek (BEVZB)",
   label: "Vlezenbeek (BEVZB)"
  },
  {
   value: "Vliermaal (BEVMA)",
   label: "Vliermaal (BEVMA)"
  },
  {
   value: "Vliermaalroot (BEVMO)",
   label: "Vliermaalroot (BEVMO)"
  },
  {
   value: "Vlissegem (BEVSE)",
   label: "Vlissegem (BEVSE)"
  },
  {
   value: "Voeren (BEVOE)",
   label: "Voeren (BEVOE)"
  },
  {
   value: "Voormezele (BEVME)",
   label: "Voormezele (BEVME)"
  },
  {
   value: "Vielsalm (BEVSM)",
   label: "Vielsalm (BEVSM)"
  },
  {
   value: "Tournebride (BETBE)",
   label: "Tournebride (BETBE)"
  },
  {
   value: "Tourpes (BETUP)",
   label: "Tourpes (BETUP)"
  },
  {
   value: "Trazegnies (BETZI)",
   label: "Trazegnies (BETZI)"
  },
  {
   value: "Tremelo (BETMO)",
   label: "Tremelo (BETMO)"
  },
  {
   value: "Trois-Ponts (BETPO)",
   label: "Trois-Ponts (BETPO)"
  },
  {
   value: "Tubize (BETBZ)",
   label: "Tubize (BETBZ)"
  },
  {
   value: "Uccle (Ukkel)\/Brussel (Bruxelles) (BEUKE)",
   label: "Uccle (Ukkel)\/Brussel (Bruxelles) (BEUKE)"
  },
  {
   value: "Ucimont (BEUCI)",
   label: "Ucimont (BEUCI)"
  },
  {
   value: "Uikhoven (BEUKO)",
   label: "Uikhoven (BEUKO)"
  },
  {
   value: "Uitbergen (BEUIT)",
   label: "Uitbergen (BEUIT)"
  },
  {
   value: "Ulbeek (BEULB)",
   label: "Ulbeek (BEULB)"
  },
  {
   value: "Vaalbeek (BEVBE)",
   label: "Vaalbeek (BEVBE)"
  },
  {
   value: "Val St-Lambert (BEVSB)",
   label: "Val St-Lambert (BEVSB)"
  },
  {
   value: "Vance (BEVCE)",
   label: "Vance (BEVCE)"
  },
  {
   value: "Varendonk (BEVRD)",
   label: "Varendonk (BEVRD)"
  },
  {
   value: "Vaulx (BEVLX)",
   label: "Vaulx (BEVLX)"
  },
  {
   value: "Vaux-sur-Sure (BEVAU)",
   label: "Vaux-sur-Sure (BEVAU)"
  },
  {
   value: "Vaux-sur-Sûre (BEVSU)",
   label: "Vaux-sur-Sûre (BEVSU)"
  },
  {
   value: "Vedrin (BEVDI)",
   label: "Vedrin (BEVDI)"
  },
  {
   value: "Veerle (BEVEL)",
   label: "Veerle (BEVEL)"
  },
  {
   value: "Velaine-sur-Sambre (BEVEA)",
   label: "Velaine-sur-Sambre (BEVEA)"
  },
  {
   value: "Veldwezelt (BEVWZ)",
   label: "Veldwezelt (BEVWZ)"
  },
  {
   value: "Velm (BEVLM)",
   label: "Velm (BEVLM)"
  },
  {
   value: "Verbrande Brug (BEVBG)",
   label: "Verbrande Brug (BEVBG)"
  },
  {
   value: "Verlaine (BEVLA)",
   label: "Verlaine (BEVLA)"
  },
  {
   value: "Verrebroek (BEVBK)",
   label: "Verrebroek (BEVBK)"
  },
  {
   value: "Vezin (BEVZI)",
   label: "Vezin (BEVZI)"
  },
  {
   value: "Vezon (BEVZO)",
   label: "Vezon (BEVZO)"
  },
  {
   value: "Tourinne (BETRI)",
   label: "Tourinne (BETRI)"
  },
  {
   value: "Testelt (BETTT)",
   label: "Testelt (BETTT)"
  },
  {
   value: "Teuven (BETEU)",
   label: "Teuven (BETEU)"
  },
  {
   value: "Thieu (BETHE)",
   label: "Thieu (BETHE)"
  },
  {
   value: "Thieulain (BETLA)",
   label: "Thieulain (BETLA)"
  },
  {
   value: "Thieusies (BETSI)",
   label: "Thieusies (BETSI)"
  },
  {
   value: "Thimister (BETST)",
   label: "Thimister (BETST)"
  },
  {
   value: "Thimister-Clermont (BETCL)",
   label: "Thimister-Clermont (BETCL)"
  },
  {
   value: "Thimougies (BETUG)",
   label: "Thimougies (BETUG)"
  },
  {
   value: "Thines (BETHI)",
   label: "Thines (BETHI)"
  },
  {
   value: "Thommen (BETHO)",
   label: "Thommen (BETHO)"
  },
  {
   value: "Thon Samson (BETHS)",
   label: "Thon Samson (BETHS)"
  },
  {
   value: "Thorembais-les-Beguines (BETRG)",
   label: "Thorembais-les-Beguines (BETRG)"
  },
  {
   value: "Thuillies (BETUL)",
   label: "Thuillies (BETUL)"
  },
  {
   value: "Thulin (BETHL)",
   label: "Thulin (BETHL)"
  },
  {
   value: "Thumaide (BETMA)",
   label: "Thumaide (BETMA)"
  },
  {
   value: "Thy-le-Château (BETHY)",
   label: "Thy-le-Château (BETHY)"
  },
  {
   value: "Thynes (BETYS)",
   label: "Thynes (BETYS)"
  },
  {
   value: "Tiegem (BETIG)",
   label: "Tiegem (BETIG)"
  },
  {
   value: "Tielrode (BETIL)",
   label: "Tielrode (BETIL)"
  },
  {
   value: "Tielt (BETLT)",
   label: "Tielt (BETLT)"
  },
  {
   value: "Tielt-Winge (BETWI)",
   label: "Tielt-Winge (BETWI)"
  },
  {
   value: "Tihange (BETHG)",
   label: "Tihange (BETHG)"
  },
  {
   value: "Tildonk (BETLK)",
   label: "Tildonk (BETLK)"
  },
  {
   value: "Tilleur (BETLR)",
   label: "Tilleur (BETLR)"
  },
  {
   value: "Tilly (BETLY)",
   label: "Tilly (BETLY)"
  },
  {
   value: "Tinlot (BETLO)",
   label: "Tinlot (BETLO)"
  },
  {
   value: "Tintigny (BETTY)",
   label: "Tintigny (BETTY)"
  },
  {
   value: "Tisselt (BETIS)",
   label: "Tisselt (BETIS)"
  },
  {
   value: "Tohogne (BETOH)",
   label: "Tohogne (BETOH)"
  },
  {
   value: "Tongerlo (BETGL)",
   label: "Tongerlo (BETGL)"
  },
  {
   value: "Tongre-Notre-Dame (BETND)",
   label: "Tongre-Notre-Dame (BETND)"
  },
  {
   value: "Steenhuffel (BESHF)",
   label: "Steenhuffel (BESHF)"
  },
  {
   value: "Steenkerke (BESKE)",
   label: "Steenkerke (BESKE)"
  },
  {
   value: "Stekene (BESTK)",
   label: "Stekene (BESTK)"
  },
  {
   value: "Stembert (BESTM)",
   label: "Stembert (BESTM)"
  },
  {
   value: "Ste-Ode (BESOD)",
   label: "Ste-Ode (BESOD)"
  },
  {
   value: "Sterpenich (BESPH)",
   label: "Sterpenich (BESPH)"
  },
  {
   value: "Sterrebeek (BESRB)",
   label: "Sterrebeek (BESRB)"
  },
  {
   value: "Stevensvennen (BESVN)",
   label: "Stevensvennen (BESVN)"
  },
  {
   value: "Stevoort (BESVR)",
   label: "Stevoort (BESVR)"
  },
  {
   value: "Stokrooie (BESKR)",
   label: "Stokrooie (BESKR)"
  },
  {
   value: "Stoumont (BESTU)",
   label: "Stoumont (BESTU)"
  },
  {
   value: "Strombeek-Bever (BESOV)",
   label: "Strombeek-Bever (BESOV)"
  },
  {
   value: "Suarlée (BESUA)",
   label: "Suarlée (BESUA)"
  },
  {
   value: "Suxy (BESXY)",
   label: "Suxy (BESXY)"
  },
  {
   value: "Tailles (BETLS)",
   label: "Tailles (BETLS)"
  },
  {
   value: "Taintignies (BETTI)",
   label: "Taintignies (BETTI)"
  },
  {
   value: "Tamines (BETMS)",
   label: "Tamines (BETMS)"
  },
  {
   value: "Tarcienne (BETCI)",
   label: "Tarcienne (BETCI)"
  },
  {
   value: "Tavier (BETVI)",
   label: "Tavier (BETVI)"
  },
  {
   value: "Tavigny (BETVY)",
   label: "Tavigny (BETVY)"
  },
  {
   value: "Tellin (BETLI)",
   label: "Tellin (BETLI)"
  },
  {
   value: "Templeuve (BETPU)",
   label: "Templeuve (BETPU)"
  },
  {
   value: "Temploux (BETPX)",
   label: "Temploux (BETPX)"
  },
  {
   value: "Tenneville (BETVL)",
   label: "Tenneville (BETVL)"
  },
  {
   value: "Teralfene (BETFN)",
   label: "Teralfene (BETFN)"
  },
  {
   value: "Terdonk (BETDK)",
   label: "Terdonk (BETDK)"
  },
  {
   value: "Tergnée (BETGE)",
   label: "Tergnée (BETGE)"
  },
  {
   value: "Terhagen (BETGN)",
   label: "Terhagen (BETGN)"
  },
  {
   value: "Termes (BETRE)",
   label: "Termes (BETRE)"
  },
  {
   value: "Ternaaien (Lanaye) (BELNY)",
   label: "Ternaaien (Lanaye) (BELNY)"
  },
  {
   value: "Tervuren (BETEN)",
   label: "Tervuren (BETEN)"
  },
  {
   value: "Steendorp (BESDP)",
   label: "Steendorp (BESDP)"
  },
  {
   value: "St Katherina-Lombeek (BESKL)",
   label: "St Katherina-Lombeek (BESKL)"
  },
  {
   value: "St Kruis (BESKU)",
   label: "St Kruis (BESKU)"
  },
  {
   value: "St Kruis-Winkel (BESKW)",
   label: "St Kruis-Winkel (BESKW)"
  },
  {
   value: "St Laureins (BESLU)",
   label: "St Laureins (BESLU)"
  },
  {
   value: "St Léger (BESLG)",
   label: "St Léger (BESLG)"
  },
  {
   value: "St Lenaarts (BESLN)",
   label: "St Lenaarts (BESLN)"
  },
  {
   value: "St Lievens-Houtem (BESLH)",
   label: "St Lievens-Houtem (BESLH)"
  },
  {
   value: "St Mard (BESMA)",
   label: "St Mard (BESMA)"
  },
  {
   value: "St Margriete (BESMR)",
   label: "St Margriete (BESMR)"
  },
  {
   value: "St Martens-Latem (BESML)",
   label: "St Martens-Latem (BESML)"
  },
  {
   value: "St Martens-Lierde (BESMI)",
   label: "St Martens-Lierde (BESMI)"
  },
  {
   value: "St Michiels (BESME)",
   label: "St Michiels (BESME)"
  },
  {
   value: "St Nicolas (BESNO)",
   label: "St Nicolas (BESNO)"
  },
  {
   value: "St Nicolas (BEZSN)",
   label: "St Nicolas (BEZSN)"
  },
  {
   value: "St Pieers-Leeuw (BESPL)",
   label: "St Pieers-Leeuw (BESPL)"
  },
  {
   value: "St Remy (BESRY)",
   label: "St Remy (BESRY)"
  },
  {
   value: "St Sauveur (BESSA)",
   label: "St Sauveur (BESSA)"
  },
  {
   value: "St Servais (BESSI)",
   label: "St Servais (BESSI)"
  },
  {
   value: "St Symphorien (BESSY)",
   label: "St Symphorien (BESSY)"
  },
  {
   value: "St Vith (BESVH)",
   label: "St Vith (BESVH)"
  },
  {
   value: "Stasegem (BESGM)",
   label: "Stasegem (BESGM)"
  },
  {
   value: "Statte (BESTT)",
   label: "Statte (BESTT)"
  },
  {
   value: "Stave (BESAT)",
   label: "Stave (BESAT)"
  },
  {
   value: "Stavele (BESVE)",
   label: "Stavele (BESVE)"
  },
  {
   value: "Stavelot (BESLT)",
   label: "Stavelot (BESLT)"
  },
  {
   value: "Steenbrugge (BESBE)",
   label: "Steenbrugge (BESBE)"
  },
  {
   value: "St Jozef Olen (BESJO)",
   label: "St Jozef Olen (BESJO)"
  },
  {
   value: "Slijpe (BESYP)",
   label: "Slijpe (BESYP)"
  },
  {
   value: "Smeerebbe-Vloerzegem (BESVO)",
   label: "Smeerebbe-Vloerzegem (BESVO)"
  },
  {
   value: "Smeermaas (BESMM)",
   label: "Smeermaas (BESMM)"
  },
  {
   value: "Snaaskerke (BESSK)",
   label: "Snaaskerke (BESSK)"
  },
  {
   value: "Soiron (BESON)",
   label: "Soiron (BESON)"
  },
  {
   value: "Solre-sur-Sambre (BESSB)",
   label: "Solre-sur-Sambre (BESSB)"
  },
  {
   value: "Sombreffe (BESBF)",
   label: "Sombreffe (BESBF)"
  },
  {
   value: "Somme-Leuze (BESUZ)",
   label: "Somme-Leuze (BESUZ)"
  },
  {
   value: "Sommière (BESOM)",
   label: "Sommière (BESOM)"
  },
  {
   value: "Somzée (BESZE)",
   label: "Somzée (BESZE)"
  },
  {
   value: "Sorinne-la-Longue (BESLO)",
   label: "Sorinne-la-Longue (BESLO)"
  },
  {
   value: "Sorinnes (BESRN)",
   label: "Sorinnes (BESRN)"
  },
  {
   value: "Soudromont (BESDT)",
   label: "Soudromont (BESDT)"
  },
  {
   value: "Soumagne (BESOU)",
   label: "Soumagne (BESOU)"
  },
  {
   value: "Souvret (BESRE)",
   label: "Souvret (BESRE)"
  },
  {
   value: "Spalbeek (BESLK)",
   label: "Spalbeek (BESLK)"
  },
  {
   value: "Spiennes (BESPS)",
   label: "Spiennes (BESPS)"
  },
  {
   value: "Spiere (Espierres) (BESPI)",
   label: "Spiere (Espierres) (BESPI)"
  },
  {
   value: "Sprimont (BESMO)",
   label: "Sprimont (BESMO)"
  },
  {
   value: "St Amand (BESAM)",
   label: "St Amand (BESAM)"
  },
  {
   value: "St Amands (BESAS)",
   label: "St Amands (BESAS)"
  },
  {
   value: "St Andries (BESAN)",
   label: "St Andries (BESAN)"
  },
  {
   value: "St Denijs (BESDY)",
   label: "St Denijs (BESDY)"
  },
  {
   value: "St Denis (BESDE)",
   label: "St Denis (BESDE)"
  },
  {
   value: "St Denis (BESDI)",
   label: "St Denis (BESDI)"
  },
  {
   value: "St Georges (BESGS)",
   label: "St Georges (BESGS)"
  },
  {
   value: "St Georges-Sur-Meuse (BEGSM)",
   label: "St Georges-Sur-Meuse (BEGSM)"
  },
  {
   value: "St Ghislain (BEGHI)",
   label: "St Ghislain (BEGHI)"
  },
  {
   value: "St Gillis-Waas (BESGW)",
   label: "St Gillis-Waas (BESGW)"
  },
  {
   value: "St Hubert (BESHU)",
   label: "St Hubert (BESHU)"
  },
  {
   value: "St Huibrechts-Lille (BEHSL)",
   label: "St Huibrechts-Lille (BEHSL)"
  },
  {
   value: "St Jan-in-Eremo (BESJE)",
   label: "St Jan-in-Eremo (BESJE)"
  },
  {
   value: "St Joris (BESJR)",
   label: "St Joris (BESJR)"
  },
  {
   value: "St Joris-Weert (BESJW)",
   label: "St Joris-Weert (BESJW)"
  },
  {
   value: "Seilles (BESES)",
   label: "Seilles (BESES)"
  },
  {
   value: "Sélange (BESLA)",
   label: "Sélange (BESLA)"
  },
  {
   value: "Seloignes (BESOG)",
   label: "Seloignes (BESOG)"
  },
  {
   value: "Sensenruth (BESSU)",
   label: "Sensenruth (BESSU)"
  },
  {
   value: "Seny (BESYE)",
   label: "Seny (BESYE)"
  },
  {
   value: "Serskamp (BESKM)",
   label: "Serskamp (BESKM)"
  },
  {
   value: "Serville (BESVI)",
   label: "Serville (BESVI)"
  },
  {
   value: "Sijsele (BESJL)",
   label: "Sijsele (BESJL)"
  },
  {
   value: "Silly (BESIY)",
   label: "Silly (BESIY)"
  },
  {
   value: "Sinaai (BESNA)",
   label: "Sinaai (BESNA)"
  },
  {
   value: "Sint Amands (BEVGS)",
   label: "Sint Amands (BEVGS)"
  },
  {
   value: "Sint Katelijne Waver (BESKA)",
   label: "Sint Katelijne Waver (BESKA)"
  },
  {
   value: "Sint Pieters Leeuw (BEVGW)",
   label: "Sint Pieters Leeuw (BEVGW)"
  },
  {
   value: "Sint Stevens Woluwe (BEVGE)",
   label: "Sint Stevens Woluwe (BEVGE)"
  },
  {
   value: "Sint-Agatha-Berchem (Berchem-Sainte-Agathe) (BEBSA)",
   label: "Sint-Agatha-Berchem (Berchem-Sainte-Agathe) (BEBSA)"
  },
  {
   value: "Sint-Denijs-Westrem (BESDW)",
   label: "Sint-Denijs-Westrem (BESDW)"
  },
  {
   value: "Sint-Gillis (Saint-Gilles)\/Brussel (Bruxelles) (BESGI)",
   label: "Sint-Gillis (Saint-Gilles)\/Brussel (Bruxelles) (BESGI)"
  },
  {
   value: "Sint-Jacobs-Kapelle (BEJKP)",
   label: "Sint-Jacobs-Kapelle (BEJKP)"
  },
  {
   value: "Sint-Joost-ten-Node (Saint-Josse-ten-Noode) (BESJN)",
   label: "Sint-Joost-ten-Node (Saint-Josse-ten-Noode) (BESJN)"
  },
  {
   value: "Sint-Martens-Lierde (BELIR)",
   label: "Sint-Martens-Lierde (BELIR)"
  },
  {
   value: "Sint-Niklaas (BELLS)",
   label: "Sint-Niklaas (BELLS)"
  },
  {
   value: "Sint-Pieters-Voeren (BESPV)",
   label: "Sint-Pieters-Voeren (BESPV)"
  },
  {
   value: "Sippenaeken (BESIP)",
   label: "Sippenaeken (BESIP)"
  },
  {
   value: "Sirault (BESRA)",
   label: "Sirault (BESRA)"
  },
  {
   value: "Sivry-Rance (BESYR)",
   label: "Sivry-Rance (BESYR)"
  },
  {
   value: "Scy (BESCY)",
   label: "Scy (BESCY)"
  },
  {
   value: "Saint-Vincent (BESDZ)",
   label: "Saint-Vincent (BESDZ)"
  },
  {
   value: "Saive (BESIV)",
   label: "Saive (BESIV)"
  },
  {
   value: "Salles (BESLS)",
   label: "Salles (BESLS)"
  },
  {
   value: "Salzinnes (BESZI)",
   label: "Salzinnes (BESZI)"
  },
  {
   value: "Sambreville (BESAV)",
   label: "Sambreville (BESAV)"
  },
  {
   value: "Samrée (BESAR)",
   label: "Samrée (BESAR)"
  },
  {
   value: "Samson (BESSO)",
   label: "Samson (BESSO)"
  },
  {
   value: "Sankt Vith (BEVIT)",
   label: "Sankt Vith (BEVIT)"
  },
  {
   value: "Sars-la-Buissière (BESBU)",
   label: "Sars-la-Buissière (BESBU)"
  },
  {
   value: "Sas-Slijkens (BESLJ)",
   label: "Sas-Slijkens (BESLJ)"
  },
  {
   value: "Schaarbeek (Schaerbeek)\/Brussel (Bruxelles) (BESBK)",
   label: "Schaarbeek (Schaerbeek)\/Brussel (Bruxelles) (BESBK)"
  },
  {
   value: "Schalkhoven (BESHO)",
   label: "Schalkhoven (BESHO)"
  },
  {
   value: "Schaltin (BESTI)",
   label: "Schaltin (BESTI)"
  },
  {
   value: "Scheepsdale (BESPE)",
   label: "Scheepsdale (BESPE)"
  },
  {
   value: "Schelderode (BESHR)",
   label: "Schelderode (BESHR)"
  },
  {
   value: "Schellebelle (BESHB)",
   label: "Schellebelle (BESHB)"
  },
  {
   value: "Schendelbeke (BESHE)",
   label: "Schendelbeke (BESHE)"
  },
  {
   value: "Schepdaal (BESDA)",
   label: "Schepdaal (BESDA)"
  },
  {
   value: "Scherpenheuvel-Zichem (BESPU)",
   label: "Scherpenheuvel-Zichem (BESPU)"
  },
  {
   value: "Schoenberg (BESOB)",
   label: "Schoenberg (BESOB)"
  },
  {
   value: "Schoonaarde (BESNE)",
   label: "Schoonaarde (BESNE)"
  },
  {
   value: "Schore (BESOR)",
   label: "Schore (BESOR)"
  },
  {
   value: "Schorisse (BESRI)",
   label: "Schorisse (BESRI)"
  },
  {
   value: "Schriek (BESKI)",
   label: "Schriek (BESKI)"
  },
  {
   value: "Sclaigneaux (BESGX)",
   label: "Sclaigneaux (BESGX)"
  },
  {
   value: "Sclayn (BESLY)",
   label: "Sclayn (BESLY)"
  },
  {
   value: "Sclessin (BESSN)",
   label: "Sclessin (BESSN)"
  },
  {
   value: "Rochefort (BEROC)",
   label: "Rochefort (BEROC)"
  },
  {
   value: "Rocherath (BERRA)",
   label: "Rocherath (BERRA)"
  },
  {
   value: "Roesbrugge (BERBE)",
   label: "Roesbrugge (BERBE)"
  },
  {
   value: "Roesbrugge-Haringe (BERHA)",
   label: "Roesbrugge-Haringe (BERHA)"
  },
  {
   value: "Rognée (BEROG)",
   label: "Rognée (BEROG)"
  },
  {
   value: "Rollegem (BEROL)",
   label: "Rollegem (BEROL)"
  },
  {
   value: "Romsée (BEROM)",
   label: "Romsée (BEROM)"
  },
  {
   value: "Rongy (BERGY)",
   label: "Rongy (BERGY)"
  },
  {
   value: "Ronquières (BERQS)",
   label: "Ronquières (BERQS)"
  },
  {
   value: "Ronsele (BERLE)",
   label: "Ronsele (BERLE)"
  },
  {
   value: "Roosdaal (BERDL)",
   label: "Roosdaal (BERDL)"
  },
  {
   value: "Roselies (BEROS)",
   label: "Roselies (BEROS)"
  },
  {
   value: "Rosières (BERSI)",
   label: "Rosières (BERSI)"
  },
  {
   value: "Rotem (BEROT)",
   label: "Rotem (BEROT)"
  },
  {
   value: "Roucourt (BERCT)",
   label: "Roucourt (BERCT)"
  },
  {
   value: "Rouvroy (BERVY)",
   label: "Rouvroy (BERVY)"
  },
  {
   value: "Roux (BEROX)",
   label: "Roux (BEROX)"
  },
  {
   value: "Ruddervoorde (BERUV)",
   label: "Ruddervoorde (BERUV)"
  },
  {
   value: "Ruien (BERUE)",
   label: "Ruien (BERUE)"
  },
  {
   value: "Ruisbroek (BESVG)",
   label: "Ruisbroek (BESVG)"
  },
  {
   value: "Ruiselede (BERSL)",
   label: "Ruiselede (BERSL)"
  },
  {
   value: "Rulles (BERLS)",
   label: "Rulles (BERLS)"
  },
  {
   value: "Rumes (BERMS)",
   label: "Rumes (BERMS)"
  },
  {
   value: "Rumillies (BERML)",
   label: "Rumillies (BERML)"
  },
  {
   value: "Rummen (BERMU)",
   label: "Rummen (BERMU)"
  },
  {
   value: "Runkelen (BERKE)",
   label: "Runkelen (BERKE)"
  },
  {
   value: "Rupelmonde (BERPM)",
   label: "Rupelmonde (BERPM)"
  },
  {
   value: "Saintes (BESTS)",
   label: "Saintes (BESTS)"
  },
  {
   value: "Rivière (BERVE)",
   label: "Rivière (BERVE)"
  },
  {
   value: "Quévy (BEQVY)",
   label: "Quévy (BEQVY)"
  },
  {
   value: "Quiévrain (BEQVA)",
   label: "Quiévrain (BEQVA)"
  },
  {
   value: "Rachecourt (BERCO)",
   label: "Rachecourt (BERCO)"
  },
  {
   value: "Ragnies (BERAG)",
   label: "Ragnies (BERAG)"
  },
  {
   value: "Rahier (BERHE)",
   label: "Rahier (BERHE)"
  },
  {
   value: "Ramegnies (BERGS)",
   label: "Ramegnies (BERGS)"
  },
  {
   value: "Ramegnies-Chin (BERCI)",
   label: "Ramegnies-Chin (BERCI)"
  },
  {
   value: "Ramillies (BERMI)",
   label: "Ramillies (BERMI)"
  },
  {
   value: "Ramskapelle (BERKP)",
   label: "Ramskapelle (BERKP)"
  },
  {
   value: "Ransart (BERSA)",
   label: "Ransart (BERSA)"
  },
  {
   value: "Ranst (BERAS)",
   label: "Ranst (BERAS)"
  },
  {
   value: "Ravels (BERVS)",
   label: "Ravels (BERVS)"
  },
  {
   value: "Rebaix (BERBX)",
   label: "Rebaix (BERBX)"
  },
  {
   value: "Rebecq (BERBQ)",
   label: "Rebecq (BERBQ)"
  },
  {
   value: "Reet (BERET)",
   label: "Reet (BERET)"
  },
  {
   value: "Rekem (BEREM)",
   label: "Rekem (BEREM)"
  },
  {
   value: "Rekkem (BERKM)",
   label: "Rekkem (BERKM)"
  },
  {
   value: "Relegem (BERGM)",
   label: "Relegem (BERGM)"
  },
  {
   value: "Remersdaal (BERDA)",
   label: "Remersdaal (BERDA)"
  },
  {
   value: "Remicourt (BERCU)",
   label: "Remicourt (BERCU)"
  },
  {
   value: "Rendeux (BEREN)",
   label: "Rendeux (BEREN)"
  },
  {
   value: "Reninge (BERGE)",
   label: "Reninge (BERGE)"
  },
  {
   value: "Renory (BENRY)",
   label: "Renory (BENRY)"
  },
  {
   value: "Reppel (BEVGR)",
   label: "Reppel (BEVGR)"
  },
  {
   value: "Ressaix (BERSX)",
   label: "Ressaix (BERSX)"
  },
  {
   value: "Ressegem (BERSE)",
   label: "Ressegem (BERSE)"
  },
  {
   value: "Retie (BERTI)",
   label: "Retie (BERTI)"
  },
  {
   value: "Retinne (BERTE)",
   label: "Retinne (BERTE)"
  },
  {
   value: "Richelle (BERCL)",
   label: "Richelle (BERCL)"
  },
  {
   value: "Riemst (BERIS)",
   label: "Riemst (BERIS)"
  },
  {
   value: "Rièzes (BERZE)",
   label: "Rièzes (BERZE)"
  },
  {
   value: "Rijkevorsel (BERIJ)",
   label: "Rijkevorsel (BERIJ)"
  },
  {
   value: "Rijmenam (BERNM)",
   label: "Rijmenam (BERNM)"
  },
  {
   value: "Rillaar (BERLA)",
   label: "Rillaar (BERLA)"
  },
  {
   value: "Quevaucamps (BEQCA)",
   label: "Quevaucamps (BEQCA)"
  },
  {
   value: "Péronnes\/Binche (BEPLB)",
   label: "Péronnes\/Binche (BEPLB)"
  },
  {
   value: "Perwez (BEPRW)",
   label: "Perwez (BEPRW)"
  },
  {
   value: "Perwez (BEPWE)",
   label: "Perwez (BEPWE)"
  },
  {
   value: "Petegem (BEPGE)",
   label: "Petegem (BEPGE)"
  },
  {
   value: "Petit-Lanaye (BEPLY)",
   label: "Petit-Lanaye (BEPLY)"
  },
  {
   value: "Petit-Rechain (BEPTR)",
   label: "Petit-Rechain (BEPTR)"
  },
  {
   value: "Petit-Roeulx-lez-Nivelles (BEPRN)",
   label: "Petit-Roeulx-lez-Nivelles (BEPRN)"
  },
  {
   value: "Petit-Thier (BEPTI)",
   label: "Petit-Thier (BEPTI)"
  },
  {
   value: "Philippeville (BEPHI)",
   label: "Philippeville (BEPHI)"
  },
  {
   value: "Pijp Tabak (BEPTP)",
   label: "Pijp Tabak (BEPTP)"
  },
  {
   value: "Pipaix (BEPPX)",
   label: "Pipaix (BEPPX)"
  },
  {
   value: "Pittem (BEPTT)",
   label: "Pittem (BEPTT)"
  },
  {
   value: "Plainevaux (BEPVX)",
   label: "Plainevaux (BEPVX)"
  },
  {
   value: "Ploegsteert (BEPSE)",
   label: "Ploegsteert (BEPSE)"
  },
  {
   value: "Plombières (BEPBI)",
   label: "Plombières (BEPBI)"
  },
  {
   value: "Pollare (BEPOL)",
   label: "Pollare (BEPOL)"
  },
  {
   value: "Pollinkhove (BEPKH)",
   label: "Pollinkhove (BEPKH)"
  },
  {
   value: "Pommeroeul (BEPME)",
   label: "Pommeroeul (BEPME)"
  },
  {
   value: "Pondrôme (BEPRO)",
   label: "Pondrôme (BEPRO)"
  },
  {
   value: "Pont-à-Celles (BEPCL)",
   label: "Pont-à-Celles (BEPCL)"
  },
  {
   value: "Pont-de-Loup (BEPLO)",
   label: "Pont-de-Loup (BEPLO)"
  },
  {
   value: "Poppel (BEPPE)",
   label: "Poppel (BEPPE)"
  },
  {
   value: "Postel (BEPST)",
   label: "Postel (BEPST)"
  },
  {
   value: "Pottes (BEPTS)",
   label: "Pottes (BEPTS)"
  },
  {
   value: "Poulseur (BEPSU)",
   label: "Poulseur (BEPSU)"
  },
  {
   value: "Profondeville (BEPFE)",
   label: "Profondeville (BEPFE)"
  },
  {
   value: "Pulderbos (BEPUL)",
   label: "Pulderbos (BEPUL)"
  },
  {
   value: "Pulle (BEPLE)",
   label: "Pulle (BEPLE)"
  },
  {
   value: "Purnode (BEPUR)",
   label: "Purnode (BEPUR)"
  },
  {
   value: "Quaregnon (BEQRO)",
   label: "Quaregnon (BEQRO)"
  },
  {
   value: "Quartes (BEQAR)",
   label: "Quartes (BEQAR)"
  },
  {
   value: "Péronnes (BEPES)",
   label: "Péronnes (BEPES)"
  },
  {
   value: "Ormeignies (BEOGE)",
   label: "Ormeignies (BEOGE)"
  },
  {
   value: "Orp-Jauche (BEOJA)",
   label: "Orp-Jauche (BEOJA)"
  },
  {
   value: "Orroir (BEORR)",
   label: "Orroir (BEORR)"
  },
  {
   value: "Ortho (BEOTO)",
   label: "Ortho (BEOTO)"
  },
  {
   value: "Ostiches (BEOTS)",
   label: "Ostiches (BEOTS)"
  },
  {
   value: "Otegem (BEOTG)",
   label: "Otegem (BEOTG)"
  },
  {
   value: "Oudegem (BEODM)",
   label: "Oudegem (BEODM)"
  },
  {
   value: "Oudenburg (BEOBG)",
   label: "Oudenburg (BEOBG)"
  },
  {
   value: "Oudergem (Auderghem)\/Brussel (Bruxelles) (BEODE)",
   label: "Oudergem (Auderghem)\/Brussel (Bruxelles) (BEODE)"
  },
  {
   value: "Oud-Turnhout (BEOTH)",
   label: "Oud-Turnhout (BEOTH)"
  },
  {
   value: "Ouffet (BEOUF)",
   label: "Ouffet (BEOUF)"
  },
  {
   value: "Ougrée (BEOUG)",
   label: "Ougrée (BEOUG)"
  },
  {
   value: "Oupeye (BEOPY)",
   label: "Oupeye (BEOPY)"
  },
  {
   value: "Outer (BEOUT)",
   label: "Outer (BEOUT)"
  },
  {
   value: "Outgaarden (BEOGA)",
   label: "Outgaarden (BEOGA)"
  },
  {
   value: "Outrijve (BEOTY)",
   label: "Outrijve (BEOTY)"
  },
  {
   value: "Overboelare (BEOLE)",
   label: "Overboelare (BEOLE)"
  },
  {
   value: "Overpelt (BEOVE)",
   label: "Overpelt (BEOVE)"
  },
  {
   value: "Paifve (BEPFV)",
   label: "Paifve (BEPFV)"
  },
  {
   value: "Paliseul (BEPLI)",
   label: "Paliseul (BEPLI)"
  },
  {
   value: "Pamel (BEPML)",
   label: "Pamel (BEPML)"
  },
  {
   value: "Papignies (BEPGI)",
   label: "Papignies (BEPGI)"
  },
  {
   value: "Parike (BEPRI)",
   label: "Parike (BEPRI)"
  },
  {
   value: "Pecq (BEPCQ)",
   label: "Pecq (BEPCQ)"
  },
  {
   value: "Peer (BEPEE)",
   label: "Peer (BEPEE)"
  },
  {
   value: "Pellenberg (BEPBE)",
   label: "Pellenberg (BEPBE)"
  },
  {
   value: "Pepingen (BEPIN)",
   label: "Pepingen (BEPIN)"
  },
  {
   value: "Oreye (BEOYE)",
   label: "Oreye (BEOYE)"
  },
  {
   value: "Oeselgem (BEOSG)",
   label: "Oeselgem (BEOSG)"
  },
  {
   value: "Oeudeghien (BEOGI)",
   label: "Oeudeghien (BEOGI)"
  },
  {
   value: "Ogy (BEOGY)",
   label: "Ogy (BEOGY)"
  },
  {
   value: "Ohey (BEOHY)",
   label: "Ohey (BEOHY)"
  },
  {
   value: "Oisquercq (BEOQC)",
   label: "Oisquercq (BEOQC)"
  },
  {
   value: "Okegem (BEOKG)",
   label: "Okegem (BEOKG)"
  },
  {
   value: "Ollignies (BEOGS)",
   label: "Ollignies (BEOGS)"
  },
  {
   value: "Olmen (BEOLM)",
   label: "Olmen (BEOLM)"
  },
  {
   value: "Olne (BEONE)",
   label: "Olne (BEONE)"
  },
  {
   value: "Omal (BEOMA)",
   label: "Omal (BEOMA)"
  },
  {
   value: "Ombret-Rawsa (BEOBT)",
   label: "Ombret-Rawsa (BEOBT)"
  },
  {
   value: "Onhaye (BEOAY)",
   label: "Onhaye (BEOAY)"
  },
  {
   value: "Onkerzele (BEOZL)",
   label: "Onkerzele (BEOZL)"
  },
  {
   value: "Onze-Lieve-Vrouw-Waver (BELVW)",
   label: "Onze-Lieve-Vrouw-Waver (BELVW)"
  },
  {
   value: "Ooigem (BEOOG)",
   label: "Ooigem (BEOOG)"
  },
  {
   value: "Oosteeklo (BEOKO)",
   label: "Oosteeklo (BEOKO)"
  },
  {
   value: "Oosterlo (BEOTL)",
   label: "Oosterlo (BEOTL)"
  },
  {
   value: "Oosterzele (BEOZE)",
   label: "Oosterzele (BEOZE)"
  },
  {
   value: "Oostham (BEOSH)",
   label: "Oostham (BEOSH)"
  },
  {
   value: "Oostkerke (BEOTK)",
   label: "Oostkerke (BEOTK)"
  },
  {
   value: "Oostmalle (BEOSL)",
   label: "Oostmalle (BEOSL)"
  },
  {
   value: "Oostwinkel (BEOWI)",
   label: "Oostwinkel (BEOWI)"
  },
  {
   value: "Ophain-Bois-Seigneur-Isaac (BEOSI)",
   label: "Ophain-Bois-Seigneur-Isaac (BEOSI)"
  },
  {
   value: "Ophoven (BEOHN)",
   label: "Ophoven (BEOHN)"
  },
  {
   value: "Opitter (BEOPI)",
   label: "Opitter (BEOPI)"
  },
  {
   value: "Opont (BEOPO)",
   label: "Opont (BEOPO)"
  },
  {
   value: "Orcq (BEORQ)",
   label: "Orcq (BEORQ)"
  },
  {
   value: "Oelegem (BEOEL)",
   label: "Oelegem (BEOEL)"
  },
  {
   value: "Nederzwalm-Hermelgem (BENHR)",
   label: "Nederzwalm-Hermelgem (BENHR)"
  },
  {
   value: "Neerharen (BENHA)",
   label: "Neerharen (BENHA)"
  },
  {
   value: "Neerlanden (BENLA)",
   label: "Neerlanden (BENLA)"
  },
  {
   value: "Neeroeteren (BENRT)",
   label: "Neeroeteren (BENRT)"
  },
  {
   value: "Neerpelt (BENRP)",
   label: "Neerpelt (BENRP)"
  },
  {
   value: "Neffe (BENFE)",
   label: "Neffe (BENFE)"
  },
  {
   value: "Neigem (BENEG)",
   label: "Neigem (BENEG)"
  },
  {
   value: "Nessonvaux (BENES)",
   label: "Nessonvaux (BENES)"
  },
  {
   value: "Neufchâteau (BENCA)",
   label: "Neufchâteau (BENCA)"
  },
  {
   value: "Neufchâteau (BENCU)",
   label: "Neufchâteau (BENCU)"
  },
  {
   value: "Neufmaison (BENMA)",
   label: "Neufmaison (BENMA)"
  },
  {
   value: "Neu-Moresnet (BENMO)",
   label: "Neu-Moresnet (BENMO)"
  },
  {
   value: "Neupré (BENPE)",
   label: "Neupré (BENPE)"
  },
  {
   value: "Neuville-en-Condroz (BENCO)",
   label: "Neuville-en-Condroz (BENCO)"
  },
  {
   value: "Neuville-sous-Huy (BENHY)",
   label: "Neuville-sous-Huy (BENHY)"
  },
  {
   value: "Nevele (BENVL)",
   label: "Nevele (BENVL)"
  },
  {
   value: "Nieuwenhove (BENWO)",
   label: "Nieuwenhove (BENWO)"
  },
  {
   value: "Nieuwerkerken (BENWE)",
   label: "Nieuwerkerken (BENWE)"
  },
  {
   value: "Nieuwerkerken (BENWK)",
   label: "Nieuwerkerken (BENWK)"
  },
  {
   value: "Nieuwrode (BENRO)",
   label: "Nieuwrode (BENRO)"
  },
  {
   value: "Nijlen (BENYL)",
   label: "Nijlen (BENYL)"
  },
  {
   value: "Noeveren (BENVN)",
   label: "Noeveren (BENVN)"
  },
  {
   value: "Noirefontaine (BENFO)",
   label: "Noirefontaine (BENFO)"
  },
  {
   value: "Nokere (BENOK)",
   label: "Nokere (BENOK)"
  },
  {
   value: "Nollevaux (BENVX)",
   label: "Nollevaux (BENVX)"
  },
  {
   value: "Nossegem (BENSG)",
   label: "Nossegem (BENSG)"
  },
  {
   value: "Nouvelles (BENVE)",
   label: "Nouvelles (BENVE)"
  },
  {
   value: "Nukerke (BENUK)",
   label: "Nukerke (BENUK)"
  },
  {
   value: "Obigies (BEOBI)",
   label: "Obigies (BEOBI)"
  },
  {
   value: "Obourg (BEOBR)",
   label: "Obourg (BEOBR)"
  },
  {
   value: "Neder-Over-Heembeek (BENVH)",
   label: "Neder-Over-Heembeek (BENVH)"
  },
  {
   value: "Mont (BEMNT)",
   label: "Mont (BEMNT)"
  },
  {
   value: "Montignies-sur-Sambre (BEMGS)",
   label: "Montignies-sur-Sambre (BEMGS)"
  },
  {
   value: "Montleban (BEMOB)",
   label: "Montleban (BEMOB)"
  },
  {
   value: "Montroeul-au-Bois (BEMBI)",
   label: "Montroeul-au-Bois (BEMBI)"
  },
  {
   value: "Mont-Saint-Aubert (BEMSA)",
   label: "Mont-Saint-Aubert (BEMSA)"
  },
  {
   value: "Mont-Sainte-Aldegonde (BEMSG)",
   label: "Mont-Sainte-Aldegonde (BEMSG)"
  },
  {
   value: "Mont-Saint-Guibert (BEMSU)",
   label: "Mont-Saint-Guibert (BEMSU)"
  },
  {
   value: "Mont-sur-Marchienne (BEMMA)",
   label: "Mont-sur-Marchienne (BEMMA)"
  },
  {
   value: "Morlanwelz-Mariemont (BEMLW)",
   label: "Morlanwelz-Mariemont (BEMLW)"
  },
  {
   value: "Mornimont (BEMRO)",
   label: "Mornimont (BEMRO)"
  },
  {
   value: "Mortroux (BEMTX)",
   label: "Mortroux (BEMTX)"
  },
  {
   value: "Moulbaix (BEMLX)",
   label: "Moulbaix (BEMLX)"
  },
  {
   value: "Mourcourt (BEMCT)",
   label: "Mourcourt (BEMCT)"
  },
  {
   value: "Moustier (BEMUS)",
   label: "Moustier (BEMUS)"
  },
  {
   value: "Muizen (BEMUI)",
   label: "Muizen (BEMUI)"
  },
  {
   value: "Munsterbilzen (BEMBL)",
   label: "Munsterbilzen (BEMBL)"
  },
  {
   value: "Musson (BEMSL)",
   label: "Musson (BEMSL)"
  },
  {
   value: "Naast (BENAS)",
   label: "Naast (BENAS)"
  },
  {
   value: "Namêche (BENMC)",
   label: "Namêche (BENMC)"
  },
  {
   value: "Nandrin (BENDI)",
   label: "Nandrin (BENDI)"
  },
  {
   value: "Naninne (BENNE)",
   label: "Naninne (BENNE)"
  },
  {
   value: "Nassogne (BENSO)",
   label: "Nassogne (BENSO)"
  },
  {
   value: "Natoye (BENTE)",
   label: "Natoye (BENTE)"
  },
  {
   value: "Nederboelare (BENBL)",
   label: "Nederboelare (BENBL)"
  },
  {
   value: "Monsin (BEMSI)",
   label: "Monsin (BEMSI)"
  },
  {
   value: "Merlemont (BEMLM)",
   label: "Merlemont (BEMLM)"
  },
  {
   value: "Mesen (BEMSE)",
   label: "Mesen (BEMSE)"
  },
  {
   value: "Mespelare (BEMSP)",
   label: "Mespelare (BEMSP)"
  },
  {
   value: "Messelbroek (BEMSO)",
   label: "Messelbroek (BEMSO)"
  },
  {
   value: "Mesvin (BEMVI)",
   label: "Mesvin (BEMVI)"
  },
  {
   value: "Mettet (BEMTE)",
   label: "Mettet (BEMTE)"
  },
  {
   value: "Meux (BEMUX)",
   label: "Meux (BEMUX)"
  },
  {
   value: "Mévergnies-lez-Lens (BEMGL)",
   label: "Mévergnies-lez-Lens (BEMGL)"
  },
  {
   value: "Micheroux (BEMCX)",
   label: "Micheroux (BEMCX)"
  },
  {
   value: "Middelburg (BEMID)",
   label: "Middelburg (BEMID)"
  },
  {
   value: "Middelkerke (BEMIK)",
   label: "Middelkerke (BEMIK)"
  },
  {
   value: "Miécret (BEMCE)",
   label: "Miécret (BEMCE)"
  },
  {
   value: "Mielen-boven-Aalst (BEMBA)",
   label: "Mielen-boven-Aalst (BEMBA)"
  },
  {
   value: "Minderhout (BEMHO)",
   label: "Minderhout (BEMHO)"
  },
  {
   value: "Modave (BEMOD)",
   label: "Modave (BEMOD)"
  },
  {
   value: "Moelingen (BEMOE)",
   label: "Moelingen (BEMOE)"
  },
  {
   value: "Moen (BEMNO)",
   label: "Moen (BEMNO)"
  },
  {
   value: "Moerbrugge (BEMRB)",
   label: "Moerbrugge (BEMRB)"
  },
  {
   value: "Moerzeke (BEMZK)",
   label: "Moerzeke (BEMZK)"
  },
  {
   value: "Mohiville (BEMHI)",
   label: "Mohiville (BEMHI)"
  },
  {
   value: "Moignelée (BEMGN)",
   label: "Moignelée (BEMGN)"
  },
  {
   value: "Mol (BEMLO)",
   label: "Mol (BEMLO)"
  },
  {
   value: "Molenbeek-Wersbeek (BEMWE)",
   label: "Molenbeek-Wersbeek (BEMWE)"
  },
  {
   value: "Molenstede (BEMND)",
   label: "Molenstede (BEMND)"
  },
  {
   value: "Monceau-Imbrechies (BEMIR)",
   label: "Monceau-Imbrechies (BEMIR)"
  },
  {
   value: "Monceau-sur-Sambre (BEMSS)",
   label: "Monceau-sur-Sambre (BEMSS)"
  },
  {
   value: "Merkem (BEMRM)",
   label: "Merkem (BEMRM)"
  },
  {
   value: "Martenslinde (BEMSD)",
   label: "Martenslinde (BEMSD)"
  },
  {
   value: "Martouzin-Neuville (BEMNE)",
   label: "Martouzin-Neuville (BEMNE)"
  },
  {
   value: "Masbourg (BEMBU)",
   label: "Masbourg (BEMBU)"
  },
  {
   value: "Massenhoven (BEMHN)",
   label: "Massenhoven (BEMHN)"
  },
  {
   value: "Maubray (BEMBY)",
   label: "Maubray (BEMBY)"
  },
  {
   value: "Maulde (BEMUL)",
   label: "Maulde (BEMUL)"
  },
  {
   value: "Maurage (BEMRG)",
   label: "Maurage (BEMRG)"
  },
  {
   value: "Mazy (BEMAZ)",
   label: "Mazy (BEMAZ)"
  },
  {
   value: "Méan (BEMEA)",
   label: "Méan (BEMEA)"
  },
  {
   value: "Meensel-Kiezegem (BEMKI)",
   label: "Meensel-Kiezegem (BEMKI)"
  },
  {
   value: "Meerbeek (BEMRE)",
   label: "Meerbeek (BEMRE)"
  },
  {
   value: "Meerbeke (BEMBE)",
   label: "Meerbeke (BEMBE)"
  },
  {
   value: "Meerle (BEMLR)",
   label: "Meerle (BEMLR)"
  },
  {
   value: "Meeuwen-Gruitrode (BEMGU)",
   label: "Meeuwen-Gruitrode (BEMGU)"
  },
  {
   value: "Meigem (BEMGM)",
   label: "Meigem (BEMGM)"
  },
  {
   value: "Meilegem (BEMEG)",
   label: "Meilegem (BEMEG)"
  },
  {
   value: "Meise (BEMIS)",
   label: "Meise (BEMIS)"
  },
  {
   value: "Meix-devant-Virton (BEMDV)",
   label: "Meix-devant-Virton (BEMDV)"
  },
  {
   value: "Meldert (BEMDE)",
   label: "Meldert (BEMDE)"
  },
  {
   value: "Melen (BEMNL)",
   label: "Melen (BEMNL)"
  },
  {
   value: "Melles (BEMLS)",
   label: "Melles (BEMLS)"
  },
  {
   value: "Mellet (BEMLT)",
   label: "Mellet (BEMLT)"
  },
  {
   value: "Melsele (BEMLE)",
   label: "Melsele (BEMLE)"
  },
  {
   value: "Melsen (BEELS)",
   label: "Melsen (BEELS)"
  },
  {
   value: "Mendonk (BEMDO)",
   label: "Mendonk (BEMDO)"
  },
  {
   value: "Merbes-le-Château (BEMCA)",
   label: "Merbes-le-Château (BEMCA)"
  },
  {
   value: "Merendree (BEMRD)",
   label: "Merendree (BEMRD)"
  },
  {
   value: "Martelange (BEMTA)",
   label: "Martelange (BEMTA)"
  },
  {
   value: "Lozen (BELOZ)",
   label: "Lozen (BELOZ)"
  },
  {
   value: "Lustin (BELUI)",
   label: "Lustin (BELUI)"
  },
  {
   value: "Luttre (BELUT)",
   label: "Luttre (BELUT)"
  },
  {
   value: "Maarkedal (BEMAK)",
   label: "Maarkedal (BEMAK)"
  },
  {
   value: "Maasmechelen (BEMMN)",
   label: "Maasmechelen (BEMMN)"
  },
  {
   value: "Mabompré (BEMBO)",
   label: "Mabompré (BEMBO)"
  },
  {
   value: "Machelen (BEMAC)",
   label: "Machelen (BEMAC)"
  },
  {
   value: "Machelen (BEMCN)",
   label: "Machelen (BEMCN)"
  },
  {
   value: "Macon (BEMCO)",
   label: "Macon (BEMCO)"
  },
  {
   value: "Macquenoise (BEMCQ)",
   label: "Macquenoise (BEMCQ)"
  },
  {
   value: "Maffe (BEMAF)",
   label: "Maffe (BEMAF)"
  },
  {
   value: "Maffle (BEMFF)",
   label: "Maffle (BEMFF)"
  },
  {
   value: "Magnée (BEMGE)",
   label: "Magnée (BEMGE)"
  },
  {
   value: "Maillen (BEMLL)",
   label: "Maillen (BEMLL)"
  },
  {
   value: "Mainvault (BEMVA)",
   label: "Mainvault (BEMVA)"
  },
  {
   value: "Maisières (BEMSR)",
   label: "Maisières (BEMSR)"
  },
  {
   value: "Maissin (BEMSN)",
   label: "Maissin (BEMSN)"
  },
  {
   value: "Maizeret (BEMZT)",
   label: "Maizeret (BEMZT)"
  },
  {
   value: "Maldegem (BEMLG)",
   label: "Maldegem (BEMLG)"
  },
  {
   value: "Malonne (BEMLN)",
   label: "Malonne (BEMLN)"
  },
  {
   value: "Manhay (BEMHY)",
   label: "Manhay (BEMHY)"
  },
  {
   value: "Mannekensvere (BEMKE)",
   label: "Mannekensvere (BEMKE)"
  },
  {
   value: "Marche-en-Famenne (BEMEF)",
   label: "Marche-en-Famenne (BEMEF)"
  },
  {
   value: "Marchienne-au-Pont (BEMAP)",
   label: "Marchienne-au-Pont (BEMAP)"
  },
  {
   value: "Marchin (BEMCI)",
   label: "Marchin (BEMCI)"
  },
  {
   value: "Marcinelle (BEMCL)",
   label: "Marcinelle (BEMCL)"
  },
  {
   value: "Mariakerke (BEMRI)",
   label: "Mariakerke (BEMRI)"
  },
  {
   value: "Marke (BEMAR)",
   label: "Marke (BEMAR)"
  },
  {
   value: "Marly (BEMLY)",
   label: "Marly (BEMLY)"
  },
  {
   value: "Marquain (BEMRQ)",
   label: "Marquain (BEMRQ)"
  },
  {
   value: "Loyers (BELOY)",
   label: "Loyers (BELOY)"
  },
  {
   value: "Lille (BELLE)",
   label: "Lille (BELLE)"
  },
  {
   value: "Lillo (BELIL)",
   label: "Lillo (BELIL)"
  },
  {
   value: "Lillois-Witterzée (BELWI)",
   label: "Lillois-Witterzée (BELWI)"
  },
  {
   value: "Limbourg (BELIM)",
   label: "Limbourg (BELIM)"
  },
  {
   value: "Limelette (BELME)",
   label: "Limelette (BELME)"
  },
  {
   value: "Lincent (BELCE)",
   label: "Lincent (BELCE)"
  },
  {
   value: "Linden (BELDN)",
   label: "Linden (BELDN)"
  },
  {
   value: "Linkebeek (BELKK)",
   label: "Linkebeek (BELKK)"
  },
  {
   value: "Lint (BELNI)",
   label: "Lint (BELNI)"
  },
  {
   value: "Linter (BELIN)",
   label: "Linter (BELIN)"
  },
  {
   value: "Lisogne (BELSO)",
   label: "Lisogne (BELSO)"
  },
  {
   value: "Lissewege (BELSG)",
   label: "Lissewege (BELSG)"
  },
  {
   value: "Lives-sur-Meuse (BELVM)",
   label: "Lives-sur-Meuse (BELVM)"
  },
  {
   value: "Lixhe (BELIX)",
   label: "Lixhe (BELIX)"
  },
  {
   value: "Loenhout (BELEH)",
   label: "Loenhout (BELEH)"
  },
  {
   value: "Loker (BELKO)",
   label: "Loker (BELKO)"
  },
  {
   value: "Lombardsijde (BELSI)",
   label: "Lombardsijde (BELSI)"
  },
  {
   value: "Lommersweiler (BELWE)",
   label: "Lommersweiler (BELWE)"
  },
  {
   value: "Lompret (BELOP)",
   label: "Lompret (BELOP)"
  },
  {
   value: "Lomprez (BELPZ)",
   label: "Lomprez (BELPZ)"
  },
  {
   value: "Loncin (BELOC)",
   label: "Loncin (BELOC)"
  },
  {
   value: "Longchamps (BELGA)",
   label: "Longchamps (BELGA)"
  },
  {
   value: "Lontzen (BELTZ)",
   label: "Lontzen (BELTZ)"
  },
  {
   value: "Lo-Reninge (BELRI)",
   label: "Lo-Reninge (BELRI)"
  },
  {
   value: "Loupoigne (BELPE)",
   label: "Loupoigne (BELPE)"
  },
  {
   value: "Louveigné (BELUV)",
   label: "Louveigné (BELUV)"
  },
  {
   value: "Lovendegem (BELVO)",
   label: "Lovendegem (BELVO)"
  },
  {
   value: "Ligney (BELGY)",
   label: "Ligney (BELGY)"
  },
  {
   value: "Lede (BELED)",
   label: "Lede (BELED)"
  },
  {
   value: "Ledeberg (BELRG)",
   label: "Ledeberg (BELRG)"
  },
  {
   value: "Ledegem (BELEG)",
   label: "Ledegem (BELEG)"
  },
  {
   value: "Leefdaal (BELFA)",
   label: "Leefdaal (BELFA)"
  },
  {
   value: "Leernes (BELRE)",
   label: "Leernes (BELRE)"
  },
  {
   value: "Leest (BELST)",
   label: "Leest (BELST)"
  },
  {
   value: "Leffinge (BELFE)",
   label: "Leffinge (BELFE)"
  },
  {
   value: "Léglise (BELGI)",
   label: "Léglise (BELGI)"
  },
  {
   value: "Leisele (BELSE)",
   label: "Leisele (BELSE)"
  },
  {
   value: "Lembeek (BELBE)",
   label: "Lembeek (BELBE)"
  },
  {
   value: "Lembeke (BELKE)",
   label: "Lembeke (BELKE)"
  },
  {
   value: "Lennik (BELIK)",
   label: "Lennik (BELIK)"
  },
  {
   value: "Lens (BELNS)",
   label: "Lens (BELNS)"
  },
  {
   value: "Leopoldsburg (BELPG)",
   label: "Leopoldsburg (BELPG)"
  },
  {
   value: "Les Bulles (BELBU)",
   label: "Les Bulles (BELBU)"
  },
  {
   value: "Les-Bons-Villers (BEBOV)",
   label: "Les-Bons-Villers (BEBOV)"
  },
  {
   value: "Lesdain (BELDI)",
   label: "Lesdain (BELDI)"
  },
  {
   value: "Lesterny (BELSY)",
   label: "Lesterny (BELSY)"
  },
  {
   value: "Letterhoutem (BELHO)",
   label: "Letterhoutem (BELHO)"
  },
  {
   value: "Leval-Trahegnies (BELTA)",
   label: "Leval-Trahegnies (BELTA)"
  },
  {
   value: "Liberchies (BELCI)",
   label: "Liberchies (BELCI)"
  },
  {
   value: "Lichtaart (BELHA)",
   label: "Lichtaart (BELHA)"
  },
  {
   value: "Liefkenshoek (BELHK)",
   label: "Liefkenshoek (BELHK)"
  },
  {
   value: "Lierneux (BELNX)",
   label: "Lierneux (BELNX)"
  },
  {
   value: "Liers (BELER)",
   label: "Liers (BELER)"
  },
  {
   value: "Ligne (BELGN)",
   label: "Ligne (BELGN)"
  },
  {
   value: "Ligneuville (BELUE)",
   label: "Ligneuville (BELUE)"
  },
  {
   value: "La Glanerie (BEGLA)",
   label: "La Glanerie (BEGLA)"
  },
  {
   value: "La Plante (BELPT)",
   label: "La Plante (BELPT)"
  },
  {
   value: "La Roche-en-Ardenne (BERAR)",
   label: "La Roche-en-Ardenne (BERAR)"
  },
  {
   value: "Laakdal (BELDA)",
   label: "Laakdal (BELDA)"
  },
  {
   value: "Labuissière (BEBSI)",
   label: "Labuissière (BEBSI)"
  },
  {
   value: "Lacuisine (BELCU)",
   label: "Lacuisine (BELCU)"
  },
  {
   value: "Ladeuze (BELUZ)",
   label: "Ladeuze (BELUZ)"
  },
  {
   value: "Lamain (BELAM)",
   label: "Lamain (BELAM)"
  },
  {
   value: "Lambermont (BELBM)",
   label: "Lambermont (BELBM)"
  },
  {
   value: "Landegem (BELGM)",
   label: "Landegem (BELGM)"
  },
  {
   value: "Landelies (BELDS)",
   label: "Landelies (BELDS)"
  },
  {
   value: "Landen (BELAD)",
   label: "Landen (BELAD)"
  },
  {
   value: "Laneffe (BELNE)",
   label: "Laneffe (BELNE)"
  },
  {
   value: "Langdorp (BELDO)",
   label: "Langdorp (BELDO)"
  },
  {
   value: "Langelede (BELGL)",
   label: "Langelede (BELGL)"
  },
  {
   value: "Langemark-Poelkapelle (BELPO)",
   label: "Langemark-Poelkapelle (BELPO)"
  },
  {
   value: "Langerbrugge (BELGB)",
   label: "Langerbrugge (BELGB)"
  },
  {
   value: "Langerlo (BELGO)",
   label: "Langerlo (BELGO)"
  },
  {
   value: "Lanquesaint (BELQA)",
   label: "Lanquesaint (BELQA)"
  },
  {
   value: "Laplaigne (BELPI)",
   label: "Laplaigne (BELPI)"
  },
  {
   value: "Larum (BELRM)",
   label: "Larum (BELRM)"
  },
  {
   value: "Lasne (BELAS)",
   label: "Lasne (BELAS)"
  },
  {
   value: "Latinne (BELTI)",
   label: "Latinne (BELTI)"
  },
  {
   value: "Latour (BELTO)",
   label: "Latour (BELTO)"
  },
  {
   value: "Lauwe (BELAW)",
   label: "Lauwe (BELAW)"
  },
  {
   value: "Lavacherie (BELVA)",
   label: "Lavacherie (BELVA)"
  },
  {
   value: "Kessel-Lo (BEKSO)",
   label: "Kessel-Lo (BEKSO)"
  },
  {
   value: "Kessenich (BEKSN)",
   label: "Kessenich (BEKSN)"
  },
  {
   value: "Kester (BEKST)",
   label: "Kester (BEKST)"
  },
  {
   value: "Kettenis (BEKTE)",
   label: "Kettenis (BEKTE)"
  },
  {
   value: "Kieldrecht (BEKDE)",
   label: "Kieldrecht (BEKDE)"
  },
  {
   value: "Kinrooi (BEKRO)",
   label: "Kinrooi (BEKRO)"
  },
  {
   value: "Klein Veerle (BEKVE)",
   label: "Klein Veerle (BEKVE)"
  },
  {
   value: "Kleine-Spouwen (BEKLS)",
   label: "Kleine-Spouwen (BEKLS)"
  },
  {
   value: "Klerken (BEKRK)",
   label: "Klerken (BEKRK)"
  },
  {
   value: "Kluisbergen (BEKSR)",
   label: "Kluisbergen (BEKSR)"
  },
  {
   value: "Knesselaere (BEKNS)",
   label: "Knesselaere (BEKNS)"
  },
  {
   value: "Knokke-Heist (BEKHI)",
   label: "Knokke-Heist (BEKHI)"
  },
  {
   value: "Koekelare (BEKEE)",
   label: "Koekelare (BEKEE)"
  },
  {
   value: "Koekelberg\/Brussel (Bruxelles) (BEKOE)",
   label: "Koekelberg\/Brussel (Bruxelles) (BEKOE)"
  },
  {
   value: "Koersel (BEKOS)",
   label: "Koersel (BEKOS)"
  },
  {
   value: "Kooigem (BEKOI)",
   label: "Kooigem (BEKOI)"
  },
  {
   value: "Kortenaken (BEKNA)",
   label: "Kortenaken (BEKNA)"
  },
  {
   value: "Kortessem (BEKTM)",
   label: "Kortessem (BEKTM)"
  },
  {
   value: "Kraainem (BEKRA)",
   label: "Kraainem (BEKRA)"
  },
  {
   value: "Krombeke (BEKBE)",
   label: "Krombeke (BEKBE)"
  },
  {
   value: "Kuringen (BEKRN)",
   label: "Kuringen (BEKRN)"
  },
  {
   value: "La Bouverie (BELBO)",
   label: "La Bouverie (BELBO)"
  },
  {
   value: "La Bruyère (BELBY)",
   label: "La Bruyère (BELBY)"
  },
  {
   value: "Jabbeke (BEJBE)",
   label: "Jabbeke (BEJBE)"
  },
  {
   value: "Jalhay (BEJHY)",
   label: "Jalhay (BEJHY)"
  },
  {
   value: "Jallet (BEJLE)",
   label: "Jallet (BEJLE)"
  },
  {
   value: "Jambes (BEJAM)",
   label: "Jambes (BEJAM)"
  },
  {
   value: "Java (BEJAV)",
   label: "Java (BEJAV)"
  },
  {
   value: "Jemappes (BEJME)",
   label: "Jemappes (BEJME)"
  },
  {
   value: "Jemeppe (BEJEM)",
   label: "Jemeppe (BEJEM)"
  },
  {
   value: "Jemeppe-sur-Sambre (BEJPS)",
   label: "Jemeppe-sur-Sambre (BEJPS)"
  },
  {
   value: "Jette\/Brussel (Bruxelles) (BEJET)",
   label: "Jette\/Brussel (Bruxelles) (BEJET)"
  },
  {
   value: "Jodoigne (BEJDO)",
   label: "Jodoigne (BEJDO)"
  },
  {
   value: "Jumet (BEJUM)",
   label: "Jumet (BEJUM)"
  },
  {
   value: "Juprelle (BEJPE)",
   label: "Juprelle (BEJPE)"
  },
  {
   value: "Jurbise (BEJBI)",
   label: "Jurbise (BEJBI)"
  },
  {
   value: "Juseret (BEJSE)",
   label: "Juseret (BEJSE)"
  },
  {
   value: "Kaaskerke (BEKKR)",
   label: "Kaaskerke (BEKKR)"
  },
  {
   value: "Kachtem (BEKCT)",
   label: "Kachtem (BEKCT)"
  },
  {
   value: "Kaggevinne (BEKGV)",
   label: "Kaggevinne (BEKGV)"
  },
  {
   value: "Kain (BEKAI)",
   label: "Kain (BEKAI)"
  },
  {
   value: "Kanne (Canne) (BEKAN)",
   label: "Kanne (Canne) (BEKAN)"
  },
  {
   value: "Kaprijke (BEKRI)",
   label: "Kaprijke (BEKRI)"
  },
  {
   value: "Kaster (BEKAS)",
   label: "Kaster (BEKAS)"
  },
  {
   value: "Kasterlee (BEKSE)",
   label: "Kasterlee (BEKSE)"
  },
  {
   value: "Kemmel (BEKME)",
   label: "Kemmel (BEKME)"
  },
  {
   value: "Kemzeke (BEKMZ)",
   label: "Kemzeke (BEKMZ)"
  },
  {
   value: "Kerkhove (BEKHN)",
   label: "Kerkhove (BEKHN)"
  },
  {
   value: "Kerkhoven (BEKHO)",
   label: "Kerkhoven (BEKHO)"
  },
  {
   value: "Kerksken (BEKKE)",
   label: "Kerksken (BEKKE)"
  },
  {
   value: "Kermt (BEKET)",
   label: "Kermt (BEKET)"
  },
  {
   value: "Kersbeek-Miskom (BEKMO)",
   label: "Kersbeek-Miskom (BEKMO)"
  },
  {
   value: "Izier (BEIZI)",
   label: "Izier (BEIZI)"
  },
  {
   value: "Houtain-Saint-Siméon (BEHSM)",
   label: "Houtain-Saint-Siméon (BEHSM)"
  },
  {
   value: "Houthalen-Helchteren (BEHHE)",
   label: "Houthalen-Helchteren (BEHHE)"
  },
  {
   value: "Houthem (BEHUT)",
   label: "Houthem (BEHUT)"
  },
  {
   value: "Houthulst (BEHHU)",
   label: "Houthulst (BEHHU)"
  },
  {
   value: "Houtvenne (BEHTV)",
   label: "Houtvenne (BEHTV)"
  },
  {
   value: "Houx (BEHUX)",
   label: "Houx (BEHUX)"
  },
  {
   value: "Houyet (BEHYE)",
   label: "Houyet (BEHYE)"
  },
  {
   value: "Hove (BEHOV)",
   label: "Hove (BEHOV)"
  },
  {
   value: "Hoves (BEWAH)",
   label: "Hoves (BEWAH)"
  },
  {
   value: "Howardries (BEHWA)",
   label: "Howardries (BEHWA)"
  },
  {
   value: "Huldenberg (BEHDG)",
   label: "Huldenberg (BEHDG)"
  },
  {
   value: "Hulshout (BEHHT)",
   label: "Hulshout (BEHHT)"
  },
  {
   value: "Humbeek (BEHUM)",
   label: "Humbeek (BEHUM)"
  },
  {
   value: "Hun (BEHUN)",
   label: "Hun (BEHUN)"
  },
  {
   value: "Huy (BEHUY)",
   label: "Huy (BEHUY)"
  },
  {
   value: "Hyon (BEHYO)",
   label: "Hyon (BEHYO)"
  },
  {
   value: "Ichtegem (BEIHE)",
   label: "Ichtegem (BEIHE)"
  },
  {
   value: "Iddergem (BEIDE)",
   label: "Iddergem (BEIDE)"
  },
  {
   value: "Incourt (BEICO)",
   label: "Incourt (BEICO)"
  },
  {
   value: "Irchonwelz (BEIWE)",
   label: "Irchonwelz (BEIWE)"
  },
  {
   value: "Isières (BEISR)",
   label: "Isières (BEISR)"
  },
  {
   value: "Isnes (BEISE)",
   label: "Isnes (BEISE)"
  },
  {
   value: "Itegem (BEITE)",
   label: "Itegem (BEITE)"
  },
  {
   value: "Itter (Ittre) (BEITR)",
   label: "Itter (Ittre) (BEITR)"
  },
  {
   value: "Itterbeek (BEIBE)",
   label: "Itterbeek (BEIBE)"
  },
  {
   value: "Ivoz-Ramet (BEYRT)",
   label: "Ivoz-Ramet (BEYRT)"
  },
  {
   value: "Ixelles (Elsene)\/Brussel (Bruxelles) (BEESE)",
   label: "Ixelles (Elsene)\/Brussel (Bruxelles) (BEESE)"
  },
  {
   value: "Izenberge (BEIZE)",
   label: "Izenberge (BEIZE)"
  },
  {
   value: "Houtain-le-Val (BEHOA)",
   label: "Houtain-le-Val (BEHOA)"
  },
  {
   value: "Heusden-Zolder (BEHZO)",
   label: "Heusden-Zolder (BEHZO)"
  },
  {
   value: "Heusy (BEHSY)",
   label: "Heusy (BEHSY)"
  },
  {
   value: "Heuvelland (BEHVL)",
   label: "Heuvelland (BEHVL)"
  },
  {
   value: "Hever (BEHVE)",
   label: "Hever (BEHVE)"
  },
  {
   value: "Heyd (BEHYD)",
   label: "Heyd (BEHYD)"
  },
  {
   value: "Hingene (BEHGE)",
   label: "Hingene (BEHGE)"
  },
  {
   value: "Hives (BEHIV)",
   label: "Hives (BEHIV)"
  },
  {
   value: "Hodeige (BEHOD)",
   label: "Hodeige (BEHOD)"
  },
  {
   value: "Hody (BEHDY)",
   label: "Hody (BEHDY)"
  },
  {
   value: "Hoeilaart (BEHOI)",
   label: "Hoeilaart (BEHOI)"
  },
  {
   value: "Hoelbeek (BEHBK)",
   label: "Hoelbeek (BEHBK)"
  },
  {
   value: "Hoeleden (BEHDE)",
   label: "Hoeleden (BEHDE)"
  },
  {
   value: "Hoeselt (BEHOE)",
   label: "Hoeselt (BEHOE)"
  },
  {
   value: "Hofstade (BEHOF)",
   label: "Hofstade (BEHOF)"
  },
  {
   value: "Hofstade (BEHSD)",
   label: "Hofstade (BEHSD)"
  },
  {
   value: "Hognoul (BEHGU)",
   label: "Hognoul (BEHGU)"
  },
  {
   value: "Hollain (BEHOL)",
   label: "Hollain (BEHOL)"
  },
  {
   value: "Hollebeke (BEHOK)",
   label: "Hollebeke (BEHOK)"
  },
  {
   value: "Holsbeek (BEHSK)",
   label: "Holsbeek (BEHSK)"
  },
  {
   value: "Hombourg (BEHBU)",
   label: "Hombourg (BEHBU)"
  },
  {
   value: "Horebeke (BEHOR)",
   label: "Horebeke (BEHOR)"
  },
  {
   value: "Hornu (BEHRU)",
   label: "Hornu (BEHRU)"
  },
  {
   value: "Hotton (BEHOT)",
   label: "Hotton (BEHOT)"
  },
  {
   value: "Houdemont (BEHDO)",
   label: "Houdemont (BEHDO)"
  },
  {
   value: "Houdeng-Aimeries (BEHGA)",
   label: "Houdeng-Aimeries (BEHGA)"
  },
  {
   value: "Houffalize (BEHFA)",
   label: "Houffalize (BEHFA)"
  },
  {
   value: "Hour (BEHOU)",
   label: "Hour (BEHOU)"
  },
  {
   value: "Hourpes (BEHRP)",
   label: "Hourpes (BEHRP)"
  },
  {
   value: "Housse (BEHUS)",
   label: "Housse (BEHUS)"
  },
  {
   value: "Houtaing (BEHTN)",
   label: "Houtaing (BEHTN)"
  },
  {
   value: "Heure-le-Romain (BEHUR)",
   label: "Heure-le-Romain (BEHUR)"
  },
  {
   value: "Hekelgem (BEHKM)",
   label: "Hekelgem (BEHKM)"
  },
  {
   value: "Hélécine (BEHCI)",
   label: "Hélécine (BEHCI)"
  },
  {
   value: "Helkijn (BEHKN)",
   label: "Helkijn (BEHKN)"
  },
  {
   value: "Hemelveerdegem (BEHLE)",
   label: "Hemelveerdegem (BEHLE)"
  },
  {
   value: "Henri-Chapelle (BEHCA)",
   label: "Henri-Chapelle (BEHCA)"
  },
  {
   value: "Hensies (BEHNS)",
   label: "Hensies (BEHNS)"
  },
  {
   value: "Heppen (BEHEP)",
   label: "Heppen (BEHEP)"
  },
  {
   value: "Heppenbach (BEHPA)",
   label: "Heppenbach (BEHPA)"
  },
  {
   value: "Heppi (BEHPS)",
   label: "Heppi (BEHPS)"
  },
  {
   value: "Heppignies (BEIAE)",
   label: "Heppignies (BEIAE)"
  },
  {
   value: "Herbeumont (BEHBO)",
   label: "Herbeumont (BEHBO)"
  },
  {
   value: "Herent (BEHEB)",
   label: "Herent (BEHEB)"
  },
  {
   value: "Herent (BEHET)",
   label: "Herent (BEHET)"
  },
  {
   value: "Herenthout (BEHRO)",
   label: "Herenthout (BEHRO)"
  },
  {
   value: "Hergenrath (BEHRA)",
   label: "Hergenrath (BEHRA)"
  },
  {
   value: "Hérinnes (BEHNI)",
   label: "Hérinnes (BEHNI)"
  },
  {
   value: "Herk-de-Stad (BEHKA)",
   label: "Herk-de-Stad (BEHKA)"
  },
  {
   value: "Hermalle-sous-Huy (BEHMH)",
   label: "Hermalle-sous-Huy (BEHMH)"
  },
  {
   value: "Hermeton-sur-Meuse (BEHTM)",
   label: "Hermeton-sur-Meuse (BEHTM)"
  },
  {
   value: "Herne (BEHEN)",
   label: "Herne (BEHEN)"
  },
  {
   value: "Héron (BEHNO)",
   label: "Héron (BEHNO)"
  },
  {
   value: "Herquegies (BEHRQ)",
   label: "Herquegies (BEHRQ)"
  },
  {
   value: "Herseaux (BEHSX)",
   label: "Herseaux (BEHSX)"
  },
  {
   value: "Herstappe (BEHTP)",
   label: "Herstappe (BEHTP)"
  },
  {
   value: "Hertain (BEHTI)",
   label: "Hertain (BEHTI)"
  },
  {
   value: "Herve (BEHRV)",
   label: "Herve (BEHRV)"
  },
  {
   value: "Herzele (BEHEZ)",
   label: "Herzele (BEHEZ)"
  },
  {
   value: "Heultje (BEHUJ)",
   label: "Heultje (BEHUJ)"
  },
  {
   value: "Heultje (BETTJ)",
   label: "Heultje (BETTJ)"
  },
  {
   value: "Heist (BEHEI)",
   label: "Heist (BEHEI)"
  },
  {
   value: "Halleux (BEHLX)",
   label: "Halleux (BEHLX)"
  },
  {
   value: "Halluin (BEHLU)",
   label: "Halluin (BEHLU)"
  },
  {
   value: "Halma (BEHMA)",
   label: "Halma (BEHMA)"
  },
  {
   value: "Ham (BEHAW)",
   label: "Ham (BEHAW)"
  },
  {
   value: "Hamme (BEHAE)",
   label: "Hamme (BEHAE)"
  },
  {
   value: "Hamoir (BEHMO)",
   label: "Hamoir (BEHMO)"
  },
  {
   value: "Hamois (BEHMI)",
   label: "Hamois (BEHMI)"
  },
  {
   value: "Hamont (BEHAL)",
   label: "Hamont (BEHAL)"
  },
  {
   value: "Hamont-Achel (BEHAH)",
   label: "Hamont-Achel (BEHAH)"
  },
  {
   value: "Hamsehoeven (BEHAM)",
   label: "Hamsehoeven (BEHAM)"
  },
  {
   value: "Ham-sur-Heure-Nalinnes (BEHHN)",
   label: "Ham-sur-Heure-Nalinnes (BEHHN)"
  },
  {
   value: "Ham-sur-Sambre (BEHMB)",
   label: "Ham-sur-Sambre (BEHMB)"
  },
  {
   value: "Handzame (BEHNA)",
   label: "Handzame (BEHNA)"
  },
  {
   value: "Hannut (BEHNU)",
   label: "Hannut (BEHNU)"
  },
  {
   value: "Hansbeke (BEHBE)",
   label: "Hansbeke (BEHBE)"
  },
  {
   value: "Harchies (BEHCS)",
   label: "Harchies (BEHCS)"
  },
  {
   value: "Haren (BEHAR)",
   label: "Haren (BEHAR)"
  },
  {
   value: "Harmignies (BEHRI)",
   label: "Harmignies (BEHRI)"
  },
  {
   value: "Harveng (BEHVG)",
   label: "Harveng (BEHVG)"
  },
  {
   value: "Hastière-par-delà (BEHPD)",
   label: "Hastière-par-delà (BEHPD)"
  },
  {
   value: "Haut-Ittre (BEHIT)",
   label: "Haut-Ittre (BEHIT)"
  },
  {
   value: "Havay (BEHVY)",
   label: "Havay (BEHVY)"
  },
  {
   value: "Havelange (BEHVA)",
   label: "Havelange (BEHVA)"
  },
  {
   value: "Havenne (BEHVN)",
   label: "Havenne (BEHVN)"
  },
  {
   value: "Havinnes (BEHNE)",
   label: "Havinnes (BEHNE)"
  },
  {
   value: "Havré (BEHRE)",
   label: "Havré (BEHRE)"
  },
  {
   value: "Hechtel (BEHCL)",
   label: "Hechtel (BEHCL)"
  },
  {
   value: "Hechtel-Eksel (BEHEK)",
   label: "Hechtel-Eksel (BEHEK)"
  },
  {
   value: "Heer (BEHEE)",
   label: "Heer (BEHEE)"
  },
  {
   value: "Heers (BEHSE)",
   label: "Heers (BEHSE)"
  },
  {
   value: "Heestert (BEHTS)",
   label: "Heestert (BEHTS)"
  },
  {
   value: "Heffen (BEHFE)",
   label: "Heffen (BEHFE)"
  },
  {
   value: "Heindonk (BEHDK)",
   label: "Heindonk (BEHDK)"
  },
  {
   value: "Gottem (BEGTM)",
   label: "Gottem (BEGTM)"
  },
  {
   value: "Gourdinne (BEGUR)",
   label: "Gourdinne (BEGUR)"
  },
  {
   value: "Goutroux (BEGTX)",
   label: "Goutroux (BEGTX)"
  },
  {
   value: "Gouvy (BEGVY)",
   label: "Gouvy (BEGVY)"
  },
  {
   value: "Gouy-lez-Piéton (BEGPO)",
   label: "Gouy-lez-Piéton (BEGPO)"
  },
  {
   value: "Gozée (BEGZE)",
   label: "Gozée (BEGZE)"
  },
  {
   value: "Grâce-Hollogne (BEGHE)",
   label: "Grâce-Hollogne (BEGHE)"
  },
  {
   value: "Grandglise (BEGDI)",
   label: "Grandglise (BEGDI)"
  },
  {
   value: "Grand-Halleux (BEGHX)",
   label: "Grand-Halleux (BEGHX)"
  },
  {
   value: "Grand-Leez (BEGLE)",
   label: "Grand-Leez (BEGLE)"
  },
  {
   value: "Grez-Doiceau (BEGDU)",
   label: "Grez-Doiceau (BEGDU)"
  },
  {
   value: "Grimminge (BEGME)",
   label: "Grimminge (BEGME)"
  },
  {
   value: "Grivegnée (BEGVI)",
   label: "Grivegnée (BEGVI)"
  },
  {
   value: "Groot Bijgaarden (BEGRO)",
   label: "Groot Bijgaarden (BEGRO)"
  },
  {
   value: "Grote-Brogel (BEGBG)",
   label: "Grote-Brogel (BEGBG)"
  },
  {
   value: "Grote-Spouwen (BESWN)",
   label: "Grote-Spouwen (BESWN)"
  },
  {
   value: "Grune (BEGRU)",
   label: "Grune (BEGRU)"
  },
  {
   value: "Guigoven (BEGGO)",
   label: "Guigoven (BEGGO)"
  },
  {
   value: "Haaltert (BEHAT)",
   label: "Haaltert (BEHAT)"
  },
  {
   value: "Habay-la-Neuve (BEHLN)",
   label: "Habay-la-Neuve (BEHLN)"
  },
  {
   value: "Habay-la-Vieille (BEHYV)",
   label: "Habay-la-Vieille (BEHYV)"
  },
  {
   value: "Habergy (BEHRY)",
   label: "Habergy (BEHRY)"
  },
  {
   value: "Haccourt (BEHCT)",
   label: "Haccourt (BEHCT)"
  },
  {
   value: "Hacquegnies (BEHQI)",
   label: "Hacquegnies (BEHQI)"
  },
  {
   value: "Haillot (BEHLO)",
   label: "Haillot (BEHLO)"
  },
  {
   value: "Hal (BEHAQ)",
   label: "Hal (BEHAQ)"
  },
  {
   value: "Halanzy (BEHZY)",
   label: "Halanzy (BEHZY)"
  },
  {
   value: "Halen (BEHLA)",
   label: "Halen (BEHLA)"
  },
  {
   value: "Geel (BEGEL)",
   label: "Geel (BEGEL)"
  },
  {
   value: "Geetbets (BEGBE)",
   label: "Geetbets (BEGBE)"
  },
  {
   value: "Gelbressée (BEGSE)",
   label: "Gelbressée (BEGSE)"
  },
  {
   value: "Gellik (BEGLK)",
   label: "Gellik (BEGLK)"
  },
  {
   value: "Geluveld (BEGVD)",
   label: "Geluveld (BEGVD)"
  },
  {
   value: "Gemmenich (BEGMI)",
   label: "Gemmenich (BEGMI)"
  },
  {
   value: "Genappe (BEGNA)",
   label: "Genappe (BEGNA)"
  },
  {
   value: "Genenbos (BEGBH)",
   label: "Genenbos (BEGBH)"
  },
  {
   value: "Gentbrugge (BEGBU)",
   label: "Gentbrugge (BEGBU)"
  },
  {
   value: "Geraardsbergen (BEGEA)",
   label: "Geraardsbergen (BEGEA)"
  },
  {
   value: "Gerpinnes (BEGPI)",
   label: "Gerpinnes (BEGPI)"
  },
  {
   value: "Gesves (BEGVE)",
   label: "Gesves (BEGVE)"
  },
  {
   value: "Ghislenghien (BEGGI)",
   label: "Ghislenghien (BEGGI)"
  },
  {
   value: "Ghoy (BEGHY)",
   label: "Ghoy (BEGHY)"
  },
  {
   value: "Gibecq (BEGBQ)",
   label: "Gibecq (BEGBQ)"
  },
  {
   value: "Gierle (BEGIE)",
   label: "Gierle (BEGIE)"
  },
  {
   value: "Gijverinkhove (BEGKO)",
   label: "Gijverinkhove (BEGKO)"
  },
  {
   value: "Gijzegem (BEGZM)",
   label: "Gijzegem (BEGZM)"
  },
  {
   value: "Gilly (BEGLY)",
   label: "Gilly (BEGLY)"
  },
  {
   value: "Gingelom (BEGLO)",
   label: "Gingelom (BEGLO)"
  },
  {
   value: "Gits (BEGIT)",
   label: "Gits (BEGIT)"
  },
  {
   value: "Givry (BEGRY)",
   label: "Givry (BEGRY)"
  },
  {
   value: "Glabais (BEGBA)",
   label: "Glabais (BEGBA)"
  },
  {
   value: "Glabbeek (BEGBK)",
   label: "Glabbeek (BEGBK)"
  },
  {
   value: "Godinne (BEGDN)",
   label: "Godinne (BEGDN)"
  },
  {
   value: "Godsheide (BEGDE)",
   label: "Godsheide (BEGDE)"
  },
  {
   value: "Goesnes (BEGON)",
   label: "Goesnes (BEGON)"
  },
  {
   value: "Gooik (BEGOK)",
   label: "Gooik (BEGOK)"
  },
  {
   value: "Gorsem (BEGRE)",
   label: "Gorsem (BEGRE)"
  },
  {
   value: "Gedinne (BEGED)",
   label: "Gedinne (BEGED)"
  },
  {
   value: "Flône (BEFLN)",
   label: "Flône (BEFLN)"
  },
  {
   value: "Florée (BEFOR)",
   label: "Florée (BEFOR)"
  },
  {
   value: "Florenville (BEFRI)",
   label: "Florenville (BEFRI)"
  },
  {
   value: "Floriffoux (BEFFX)",
   label: "Floriffoux (BEFFX)"
  },
  {
   value: "Focant (BEFCA)",
   label: "Focant (BEFCA)"
  },
  {
   value: "Fontaine-Valmont (BEFVT)",
   label: "Fontaine-Valmont (BEFVT)"
  },
  {
   value: "Fontenoy (BEFNY)",
   label: "Fontenoy (BEFNY)"
  },
  {
   value: "Forchies-la-Marche (BEFMR)",
   label: "Forchies-la-Marche (BEFMR)"
  },
  {
   value: "Forge-Philippe (BEFPI)",
   label: "Forge-Philippe (BEFPI)"
  },
  {
   value: "Forges (BEFOG)",
   label: "Forges (BEFOG)"
  },
  {
   value: "Forrières (BEFIS)",
   label: "Forrières (BEFIS)"
  },
  {
   value: "Fortem (BEFRM)",
   label: "Fortem (BEFRM)"
  },
  {
   value: "Fosses-la-Ville (BEFSV)",
   label: "Fosses-la-Ville (BEFSV)"
  },
  {
   value: "Foy-Notre-Dame (BEFYD)",
   label: "Foy-Notre-Dame (BEFYD)"
  },
  {
   value: "Framont (BEFMO)",
   label: "Framont (BEFMO)"
  },
  {
   value: "Francorchamps (BEFRC)",
   label: "Francorchamps (BEFRC)"
  },
  {
   value: "Franière (BEFNR)",
   label: "Franière (BEFNR)"
  },
  {
   value: "Frasnes (BEFRS)",
   label: "Frasnes (BEFRS)"
  },
  {
   value: "Frasnes-lez-Anvaing (BEFAV)",
   label: "Frasnes-lez-Anvaing (BEFAV)"
  },
  {
   value: "Frasnes-lez-Buissenal (BEFBU)",
   label: "Frasnes-lez-Buissenal (BEFBU)"
  },
  {
   value: "Froid-Chapelle (BEFDA)",
   label: "Froid-Chapelle (BEFDA)"
  },
  {
   value: "Froidfontaine (BEFFO)",
   label: "Froidfontaine (BEFFO)"
  },
  {
   value: "Froidmont (BEFIM)",
   label: "Froidmont (BEFIM)"
  },
  {
   value: "Froyennes (BEFYE)",
   label: "Froyennes (BEFYE)"
  },
  {
   value: "Furnaux (BEFNX)",
   label: "Furnaux (BEFNX)"
  },
  {
   value: "Gages (BEGAG)",
   label: "Gages (BEGAG)"
  },
  {
   value: "Gallaix (BEGAX)",
   label: "Gallaix (BEGAX)"
  },
  {
   value: "Galmaarden (BEGMA)",
   label: "Galmaarden (BEGMA)"
  },
  {
   value: "Ganshoren (BEGHO)",
   label: "Ganshoren (BEGHO)"
  },
  {
   value: "Gaurain-Ramecroix (BEGRA)",
   label: "Gaurain-Ramecroix (BEGRA)"
  },
  {
   value: "Flobecq (BEFBQ)",
   label: "Flobecq (BEFBQ)"
  },
  {
   value: "Esneux (BEESX)",
   label: "Esneux (BEESX)"
  },
  {
   value: "Esplechin (BEEPC)",
   label: "Esplechin (BEEPC)"
  },
  {
   value: "Esquelmes (BEEQM)",
   label: "Esquelmes (BEEQM)"
  },
  {
   value: "Estaimpuis (BEEMP)",
   label: "Estaimpuis (BEEMP)"
  },
  {
   value: "Estinnes (BEETI)",
   label: "Estinnes (BEETI)"
  },
  {
   value: "Etterbeek (BEETE)",
   label: "Etterbeek (BEETE)"
  },
  {
   value: "Évegnée-Tignée (BEEVG)",
   label: "Évegnée-Tignée (BEEVG)"
  },
  {
   value: "Everberg (BEEBR)",
   label: "Everberg (BEEBR)"
  },
  {
   value: "Evere\/Brussel (Bruxelles) (BEEVR)",
   label: "Evere\/Brussel (Bruxelles) (BEEVR)"
  },
  {
   value: "Faimes (BEFME)",
   label: "Faimes (BEFME)"
  },
  {
   value: "Falaën (BEFAL)",
   label: "Falaën (BEFAL)"
  },
  {
   value: "Familleureux (BEFUX)",
   label: "Familleureux (BEFUX)"
  },
  {
   value: "Farciennes (BEFCS)",
   label: "Farciennes (BEFCS)"
  },
  {
   value: "Fauvillers (BEFVI)",
   label: "Fauvillers (BEFVI)"
  },
  {
   value: "Fays-les-Veneurs (BEFYS)",
   label: "Fays-les-Veneurs (BEFYS)"
  },
  {
   value: "Fayt-lez-Manage (BEFLM)",
   label: "Fayt-lez-Manage (BEFLM)"
  },
  {
   value: "Feneur (BEFER)",
   label: "Feneur (BEFER)"
  },
  {
   value: "Fernelmont (BEFNO)",
   label: "Fernelmont (BEFNO)"
  },
  {
   value: "Ferrières (BEFRE)",
   label: "Ferrières (BEFRE)"
  },
  {
   value: "Fexhe-le-Haut-Clocher (BEFHC)",
   label: "Fexhe-le-Haut-Clocher (BEFHC)"
  },
  {
   value: "Fexhe-Slins (BEFXI)",
   label: "Fexhe-Slins (BEFXI)"
  },
  {
   value: "Filot (BEFIL)",
   label: "Filot (BEFIL)"
  },
  {
   value: "Flamierge (BEFMI)",
   label: "Flamierge (BEFMI)"
  },
  {
   value: "Flawinne (BEFWI)",
   label: "Flawinne (BEFWI)"
  },
  {
   value: "Flémalle (BEFMA)",
   label: "Flémalle (BEFMA)"
  },
  {
   value: "Flénu (BEFLU)",
   label: "Flénu (BEFLU)"
  },
  {
   value: "Fléron (BEFRO)",
   label: "Fléron (BEFRO)"
  },
  {
   value: "Escanaffles (BEEFS)",
   label: "Escanaffles (BEEFS)"
  },
  {
   value: "Éghezée (BEEZE)",
   label: "Éghezée (BEEZE)"
  },
  {
   value: "Eigenbilzen (BEEBZ)",
   label: "Eigenbilzen (BEEBZ)"
  },
  {
   value: "Eindhout (BEEHT)",
   label: "Eindhout (BEEHT)"
  },
  {
   value: "Eine (BEEIN)",
   label: "Eine (BEEIN)"
  },
  {
   value: "Eisden (BEESD)",
   label: "Eisden (BEESD)"
  },
  {
   value: "Eke (BEEQE)",
   label: "Eke (BEEQE)"
  },
  {
   value: "Eksaarde (BEEKS)",
   label: "Eksaarde (BEEKS)"
  },
  {
   value: "Eksel (BEEKL)",
   label: "Eksel (BEEKL)"
  },
  {
   value: "Elewijt (BEEWI)",
   label: "Elewijt (BEEWI)"
  },
  {
   value: "Elingen (BEELI)",
   label: "Elingen (BEELI)"
  },
  {
   value: "Ellezelles (BEEZS)",
   label: "Ellezelles (BEEZS)"
  },
  {
   value: "Ellignies-Sainte-Anne (BEESA)",
   label: "Ellignies-Sainte-Anne (BEESA)"
  },
  {
   value: "Elsenborn (BEESB)",
   label: "Elsenborn (BEESB)"
  },
  {
   value: "Elversele (BEEEE)",
   label: "Elversele (BEEEE)"
  },
  {
   value: "Emblem (BEEBM)",
   label: "Emblem (BEEBM)"
  },
  {
   value: "Embourg (BEEBU)",
   label: "Embourg (BEEBU)"
  },
  {
   value: "Emptinne (BEEPI)",
   label: "Emptinne (BEEPI)"
  },
  {
   value: "Ename (BEEAM)",
   label: "Ename (BEEAM)"
  },
  {
   value: "Enghien (BEEGI)",
   label: "Enghien (BEEGI)"
  },
  {
   value: "Ensival (BEENS)",
   label: "Ensival (BEENS)"
  },
  {
   value: "Épinois (BEEPO)",
   label: "Épinois (BEEPO)"
  },
  {
   value: "Eppegem (BEEPG)",
   label: "Eppegem (BEEPG)"
  },
  {
   value: "Érezée (BEEEZ)",
   label: "Érezée (BEEEZ)"
  },
  {
   value: "Ermeton-sur-Biert (BEEBI)",
   label: "Ermeton-sur-Biert (BEEBI)"
  },
  {
   value: "Erneuville (BEENU)",
   label: "Erneuville (BEENU)"
  },
  {
   value: "Erpent (BEEPT)",
   label: "Erpent (BEEPT)"
  },
  {
   value: "Erpion (BEEPN)",
   label: "Erpion (BEEPN)"
  },
  {
   value: "Erps-Kwerps (BEESK)",
   label: "Erps-Kwerps (BEESK)"
  },
  {
   value: "Erquelinnes (BEREQ)",
   label: "Erquelinnes (BEREQ)"
  },
  {
   value: "Dergneau (BEDGU)",
   label: "Dergneau (BEDGU)"
  },
  {
   value: "Destelbergen (BEDES)",
   label: "Destelbergen (BEDES)"
  },
  {
   value: "Desteldonk (BEDTO)",
   label: "Desteldonk (BEDTO)"
  },
  {
   value: "Deurle (BEDEU)",
   label: "Deurle (BEDEU)"
  },
  {
   value: "Deux-Acren (BEDXN)",
   label: "Deux-Acren (BEDXN)"
  },
  {
   value: "Diepenbeek (BEDPK)",
   label: "Diepenbeek (BEDPK)"
  },
  {
   value: "Dilsen (BEDLS)",
   label: "Dilsen (BEDLS)"
  },
  {
   value: "Dilsen-Stokkem (BEDSO)",
   label: "Dilsen-Stokkem (BEDSO)"
  },
  {
   value: "Dion (BEDIO)",
   label: "Dion (BEDIO)"
  },
  {
   value: "Dison (BEDIS)",
   label: "Dison (BEDIS)"
  },
  {
   value: "Dohan (BEDOH)",
   label: "Dohan (BEDOH)"
  },
  {
   value: "Doische (BEDOI)",
   label: "Doische (BEDOI)"
  },
  {
   value: "Donceel (BEDCE)",
   label: "Donceel (BEDCE)"
  },
  {
   value: "Donstiennes (BEDSI)",
   label: "Donstiennes (BEDSI)"
  },
  {
   value: "Dranouter (BEDRA)",
   label: "Dranouter (BEDRA)"
  },
  {
   value: "Dudzele (BEDUD)",
   label: "Dudzele (BEDUD)"
  },
  {
   value: "Duras (BEDUR)",
   label: "Duras (BEDUR)"
  },
  {
   value: "Durbuy (BEDUY)",
   label: "Durbuy (BEDUY)"
  },
  {
   value: "Écaussinnes (BEECS)",
   label: "Écaussinnes (BEECS)"
  },
  {
   value: "Écaussinnes-Lalaing (BEELA)",
   label: "Écaussinnes-Lalaing (BEELA)"
  },
  {
   value: "Dentergem (BEDTE)",
   label: "Dentergem (BEDTE)"
  },
  {
   value: "Colfontaine (BECFA)",
   label: "Colfontaine (BECFA)"
  },
  {
   value: "Comblain-au-Pont (BECPN)",
   label: "Comblain-au-Pont (BECPN)"
  },
  {
   value: "Comines (BECMS)",
   label: "Comines (BECMS)"
  },
  {
   value: "Comines (BECOM)",
   label: "Comines (BECOM)"
  },
  {
   value: "Corbion (BECBI)",
   label: "Corbion (BECBI)"
  },
  {
   value: "Corroy-le-Château (BECCA)",
   label: "Corroy-le-Château (BECCA)"
  },
  {
   value: "Couillet (BECOU)",
   label: "Couillet (BECOU)"
  },
  {
   value: "Courcelles (BECCS)",
   label: "Courcelles (BECCS)"
  },
  {
   value: "Courrière (BECRE)",
   label: "Courrière (BECRE)"
  },
  {
   value: "Court-Saint-Étienne (BECET)",
   label: "Court-Saint-Étienne (BECET)"
  },
  {
   value: "Couthuin (BECOH)",
   label: "Couthuin (BECOH)"
  },
  {
   value: "Couvin (BECUV)",
   label: "Couvin (BECUV)"
  },
  {
   value: "Crisnée (BECSI)",
   label: "Crisnée (BECSI)"
  },
  {
   value: "Crombach (BECRO)",
   label: "Crombach (BECRO)"
  },
  {
   value: "Crupet (BECRU)",
   label: "Crupet (BECRU)"
  },
  {
   value: "Cuesmes (BECUS)",
   label: "Cuesmes (BECUS)"
  },
  {
   value: "Custinne (BECUT)",
   label: "Custinne (BECUT)"
  },
  {
   value: "Daknam (BEDKN)",
   label: "Daknam (BEDKN)"
  },
  {
   value: "Dalhem (BEDAL)",
   label: "Dalhem (BEDAL)"
  },
  {
   value: "Dampremy (BEDPY)",
   label: "Dampremy (BEDPY)"
  },
  {
   value: "Darion (BEDRI)",
   label: "Darion (BEDRI)"
  },
  {
   value: "Daussoulx (BEDAX)",
   label: "Daussoulx (BEDAX)"
  },
  {
   value: "Dave (BEDAV)",
   label: "Dave (BEDAV)"
  },
  {
   value: "Daverdisse (BEDVI)",
   label: "Daverdisse (BEDVI)"
  },
  {
   value: "De Haan (BEDHA)",
   label: "De Haan (BEDHA)"
  },
  {
   value: "De Klinge (BEDEK)",
   label: "De Klinge (BEDEK)"
  },
  {
   value: "De Panne (BEDPA)",
   label: "De Panne (BEDPA)"
  },
  {
   value: "De Pinte (BEDPE)",
   label: "De Pinte (BEDPE)"
  },
  {
   value: "Denderbelle (BEDNB)",
   label: "Denderbelle (BEDNB)"
  },
  {
   value: "Denderhoutem (BEIAI)",
   label: "Denderhoutem (BEIAI)"
  },
  {
   value: "Denderleeuw (BEDRW)",
   label: "Denderleeuw (BEDRW)"
  },
  {
   value: "Cognelée (BECGE)",
   label: "Cognelée (BECGE)"
  },
  {
   value: "Celles (BECEL)",
   label: "Celles (BECEL)"
  },
  {
   value: "Celles (BECLE)",
   label: "Celles (BECLE)"
  },
  {
   value: "Cerexhe-Heuseux (BECEX)",
   label: "Cerexhe-Heuseux (BECEX)"
  },
  {
   value: "Céroux-Mousty (BECRY)",
   label: "Céroux-Mousty (BECRY)"
  },
  {
   value: "Champion (BECPI)",
   label: "Champion (BECPI)"
  },
  {
   value: "Champlon (BECPO)",
   label: "Champlon (BECPO)"
  },
  {
   value: "Chanly (BECLY)",
   label: "Chanly (BECLY)"
  },
  {
   value: "Chantemelle (BECME)",
   label: "Chantemelle (BECME)"
  },
  {
   value: "Chapelle-à-Oie (BECLO)",
   label: "Chapelle-à-Oie (BECLO)"
  },
  {
   value: "Chapelle-à-Wattines (BECWA)",
   label: "Chapelle-à-Wattines (BECWA)"
  },
  {
   value: "Chapelle-lez-Herlaimont (BECHO)",
   label: "Chapelle-lez-Herlaimont (BECHO)"
  },
  {
   value: "Charneux (BECAX)",
   label: "Charneux (BECAX)"
  },
  {
   value: "Chassepierre (BECPE)",
   label: "Chassepierre (BECPE)"
  },
  {
   value: "Chastre (BECAR)",
   label: "Chastre (BECAR)"
  },
  {
   value: "Châtelet (BECHA)",
   label: "Châtelet (BECHA)"
  },
  {
   value: "Châtelineau (BECTL)",
   label: "Châtelineau (BECTL)"
  },
  {
   value: "Chaudfontaine (BECFO)",
   label: "Chaudfontaine (BECFO)"
  },
  {
   value: "Chaumont-Gistoux (BECGX)",
   label: "Chaumont-Gistoux (BECGX)"
  },
  {
   value: "Chaussée-Notre-Dame-Louvignies (BECNO)",
   label: "Chaussée-Notre-Dame-Louvignies (BECNO)"
  },
  {
   value: "Cherain (BECRI)",
   label: "Cherain (BECRI)"
  },
  {
   value: "Cheratte (BECRA)",
   label: "Cheratte (BECRA)"
  },
  {
   value: "Chercq (BECRQ)",
   label: "Chercq (BECRQ)"
  },
  {
   value: "Chertal (BECTA)",
   label: "Chertal (BECTA)"
  },
  {
   value: "Chiny (BECBF)",
   label: "Chiny (BECBF)"
  },
  {
   value: "Chokier (BECQR)",
   label: "Chokier (BECQR)"
  },
  {
   value: "Ciney (BECNY)",
   label: "Ciney (BECNY)"
  },
  {
   value: "Ciply (BECPY)",
   label: "Ciply (BECPY)"
  },
  {
   value: "Clabecq (BECBQ)",
   label: "Clabecq (BECBQ)"
  },
  {
   value: "Clavier (BECLA)",
   label: "Clavier (BECLA)"
  },
  {
   value: "Clermont (BECLM)",
   label: "Clermont (BECLM)"
  },
  {
   value: "Braine-le-Comte (BEBCO)",
   label: "Braine-le-Comte (BEBCO)"
  },
  {
   value: "Braives (BEBRS)",
   label: "Braives (BEBRS)"
  },
  {
   value: "Brakel (BEBAK)",
   label: "Brakel (BEBAK)"
  },
  {
   value: "Brasmenil (BEBMI)",
   label: "Brasmenil (BEBMI)"
  },
  {
   value: "Bressoux (BEBSX)",
   label: "Bressoux (BEBSX)"
  },
  {
   value: "Briegden (BEBGN)",
   label: "Briegden (BEBGN)"
  },
  {
   value: "Brunehault (BEBNA)",
   label: "Brunehault (BEBNA)"
  },
  {
   value: "Brunehaut (BEBHT)",
   label: "Brunehaut (BEBHT)"
  },
  {
   value: "Bruyelle (BEBRY)",
   label: "Bruyelle (BEBRY)"
  },
  {
   value: "Brye (BEBYR)",
   label: "Brye (BEBYR)"
  },
  {
   value: "Buissenal (BEBUS)",
   label: "Buissenal (BEBUS)"
  },
  {
   value: "Buizingen (BEBUZ)",
   label: "Buizingen (BEBUZ)"
  },
  {
   value: "Bullange (BEBUL)",
   label: "Bullange (BEBUL)"
  },
  {
   value: "Burdinne (BEBRD)",
   label: "Burdinne (BEBRD)"
  },
  {
   value: "Burg-Reuland (BEBGU)",
   label: "Burg-Reuland (BEBGU)"
  },
  {
   value: "Bury (BEBUY)",
   label: "Bury (BEBUY)"
  },
  {
   value: "Butgenbach (BEBGH)",
   label: "Butgenbach (BEBGH)"
  },
  {
   value: "Buvingen (BEBUV)",
   label: "Buvingen (BEBUV)"
  },
  {
   value: "Buvrinnes (BEBVU)",
   label: "Buvrinnes (BEBVU)"
  },
  {
   value: "Buzenol (BEBZO)",
   label: "Buzenol (BEBZO)"
  },
  {
   value: "Callenelle (BECAL)",
   label: "Callenelle (BECAL)"
  },
  {
   value: "Calonne (BECLN)",
   label: "Calonne (BECLN)"
  },
  {
   value: "Carnières (BECNR)",
   label: "Carnières (BECNR)"
  },
  {
   value: "Braine-le-Château (BEBLC)",
   label: "Braine-le-Château (BEBLC)"
  },
  {
   value: "Bois-de-Lessines (BESLI)",
   label: "Bois-de-Lessines (BESLI)"
  },
  {
   value: "Bolland (BEBOL)",
   label: "Bolland (BEBOL)"
  },
  {
   value: "Bomal (BEBMA)",
   label: "Bomal (BEBMA)"
  },
  {
   value: "Bombaye (BEBBY)",
   label: "Bombaye (BEBBY)"
  },
  {
   value: "Bonheiden (BEBNI)",
   label: "Bonheiden (BEBNI)"
  },
  {
   value: "Boninne (BEBNO)",
   label: "Boninne (BEBNO)"
  },
  {
   value: "Bon-Secours (BEBSO)",
   label: "Bon-Secours (BEBSO)"
  },
  {
   value: "Booischot (BEBOS)",
   label: "Booischot (BEBOS)"
  },
  {
   value: "Boortmeerbeek (BEBMB)",
   label: "Boortmeerbeek (BEBMB)"
  },
  {
   value: "Borchtlombeek (BEBTK)",
   label: "Borchtlombeek (BEBTK)"
  },
  {
   value: "Borgloon (BEBOG)",
   label: "Borgloon (BEBOG)"
  },
  {
   value: "Borlo (BEBRO)",
   label: "Borlo (BEBRO)"
  },
  {
   value: "Borlon (BEBLX)",
   label: "Borlon (BEBLX)"
  },
  {
   value: "Bornival (BEBVA)",
   label: "Bornival (BEBVA)"
  },
  {
   value: "Borsbeek (BEBSB)",
   label: "Borsbeek (BEBSB)"
  },
  {
   value: "Borsbeke (BEBRK)",
   label: "Borsbeke (BEBRK)"
  },
  {
   value: "Bossière (BEBRI)",
   label: "Bossière (BEBRI)"
  },
  {
   value: "Bossuit (BEBSU)",
   label: "Bossuit (BEBSU)"
  },
  {
   value: "Bothey (BEBTY)",
   label: "Bothey (BEBTY)"
  },
  {
   value: "Bouge (BEBUG)",
   label: "Bouge (BEBUG)"
  },
  {
   value: "Bouillon (BEBUO)",
   label: "Bouillon (BEBUO)"
  },
  {
   value: "Bourlers (BEBLS)",
   label: "Bourlers (BEBLS)"
  },
  {
   value: "Boussoit (BEBOT)",
   label: "Boussoit (BEBOT)"
  },
  {
   value: "Boutersem (BEBUM)",
   label: "Boutersem (BEBUM)"
  },
  {
   value: "Bouvignes-sur-Meuse (BEBVM)",
   label: "Bouvignes-sur-Meuse (BEBVM)"
  },
  {
   value: "Bouvignies (BEBVI)",
   label: "Bouvignies (BEBVI)"
  },
  {
   value: "Bouwel (BEBWE)",
   label: "Bouwel (BEBWE)"
  },
  {
   value: "Bovesse (BEBVS)",
   label: "Bovesse (BEBVS)"
  },
  {
   value: "Bovigny (BEBVY)",
   label: "Bovigny (BEBVY)"
  },
  {
   value: "Braffe (BEBFE)",
   label: "Braffe (BEBFE)"
  },
  {
   value: "Bertogne (BEBTO)",
   label: "Bertogne (BEBTO)"
  },
  {
   value: "Bertrix (BEBTX)",
   label: "Bertrix (BEBTX)"
  },
  {
   value: "Berzée (BEBZE)",
   label: "Berzée (BEBZE)"
  },
  {
   value: "Bettincourt (BEBET)",
   label: "Bettincourt (BEBET)"
  },
  {
   value: "Bever (BEBVE)",
   label: "Bever (BEBVE)"
  },
  {
   value: "Beveren-aan-den-Ijzer (BEBIZ)",
   label: "Beveren-aan-den-Ijzer (BEBIZ)"
  },
  {
   value: "Beveren-Waas (BEBWS)",
   label: "Beveren-Waas (BEBWS)"
  },
  {
   value: "Beverlo (BEBVO)",
   label: "Beverlo (BEBVO)"
  },
  {
   value: "Bienne-lez-Happart (BEBHA)",
   label: "Bienne-lez-Happart (BEBHA)"
  },
  {
   value: "Bierbeek (BEBKE)",
   label: "Bierbeek (BEBKE)"
  },
  {
   value: "Biercée (BEBCE)",
   label: "Biercée (BEBCE)"
  },
  {
   value: "Bierges (BEBIE)",
   label: "Bierges (BEBIE)"
  },
  {
   value: "Bierset (BEBST)",
   label: "Bierset (BEBST)"
  },
  {
   value: "Biesme-sous-Thuin (BEBUN)",
   label: "Biesme-sous-Thuin (BEBUN)"
  },
  {
   value: "Bièvre (BEBIV)",
   label: "Bièvre (BEBIV)"
  },
  {
   value: "Bilstain (BEBSN)",
   label: "Bilstain (BEBSN)"
  },
  {
   value: "Binche (BEBCI)",
   label: "Binche (BEBCI)"
  },
  {
   value: "Binkom (BEBKM)",
   label: "Binkom (BEBKM)"
  },
  {
   value: "Bissegem (BEBSE)",
   label: "Bissegem (BEBSE)"
  },
  {
   value: "Bitsingen (Bassenge) (BEBTS)",
   label: "Bitsingen (Bassenge) (BEBTS)"
  },
  {
   value: "Bizet (BEBZI)",
   label: "Bizet (BEBZI)"
  },
  {
   value: "Blaimont (BEBIM)",
   label: "Blaimont (BEBIM)"
  },
  {
   value: "Blandain (BEBDI)",
   label: "Blandain (BEBDI)"
  },
  {
   value: "Blanden (BEBLD)",
   label: "Blanden (BEBLD)"
  },
  {
   value: "Blankenberge (BEBBG)",
   label: "Blankenberge (BEBBG)"
  },
  {
   value: "Blaton (BEBLT)",
   label: "Blaton (BEBLT)"
  },
  {
   value: "Blegny (BEBNY)",
   label: "Blegny (BEBNY)"
  },
  {
   value: "Bléharies (BEBHR)",
   label: "Bléharies (BEBHR)"
  },
  {
   value: "Blicquy (BEBQY)",
   label: "Blicquy (BEBQY)"
  },
  {
   value: "Boechout (BEBCT)",
   label: "Boechout (BEBCT)"
  },
  {
   value: "Boekhoute (BEBHE)",
   label: "Boekhoute (BEBHE)"
  },
  {
   value: "Boezinge (BEBZG)",
   label: "Boezinge (BEBZG)"
  },
  {
   value: "Bertem (BEBTM)",
   label: "Bertem (BEBTM)"
  },
  {
   value: "Bazel (BEBAZ)",
   label: "Bazel (BEBAZ)"
  },
  {
   value: "Beaufays (BEBFY)",
   label: "Beaufays (BEBFY)"
  },
  {
   value: "Beaumont (BEBEA)",
   label: "Beaumont (BEBEA)"
  },
  {
   value: "Beauraing (BEBUR)",
   label: "Beauraing (BEBUR)"
  },
  {
   value: "Beauwelz (BEBWZ)",
   label: "Beauwelz (BEBWZ)"
  },
  {
   value: "Beclers (BEBCS)",
   label: "Beclers (BEBCS)"
  },
  {
   value: "Beernem (BEBRM)",
   label: "Beernem (BEBRM)"
  },
  {
   value: "Beert (BEBTE)",
   label: "Beert (BEBTE)"
  },
  {
   value: "Beervelde (BEBVD)",
   label: "Beervelde (BEBVD)"
  },
  {
   value: "Beez (BEBEZ)",
   label: "Beez (BEBEZ)"
  },
  {
   value: "Begijnendijk (BEBGY)",
   label: "Begijnendijk (BEBGY)"
  },
  {
   value: "Beho (BEBEH)",
   label: "Beho (BEBEH)"
  },
  {
   value: "Beigem (BEBEI)",
   label: "Beigem (BEBEI)"
  },
  {
   value: "Bekkevoort (BEBKO)",
   label: "Bekkevoort (BEBKO)"
  },
  {
   value: "Belgrade (BEBGA)",
   label: "Belgrade (BEBGA)"
  },
  {
   value: "Bellecourt (BEBCR)",
   label: "Bellecourt (BEBCR)"
  },
  {
   value: "Bellegem (BEBGE)",
   label: "Bellegem (BEBGE)"
  },
  {
   value: "Bellem (BEBEM)",
   label: "Bellem (BEBEM)"
  },
  {
   value: "Bellevaux (BEBVX)",
   label: "Bellevaux (BEBVX)"
  },
  {
   value: "Bellingen (BEBLI)",
   label: "Bellingen (BEBLI)"
  },
  {
   value: "Beloeil (BEBLO)",
   label: "Beloeil (BEBLO)"
  },
  {
   value: "Beloeil (BELOE)",
   label: "Beloeil (BELOE)"
  },
  {
   value: "Belsele (BEBSL)",
   label: "Belsele (BEBSL)"
  },
  {
   value: "Ben-Ahin (BEBAN)",
   label: "Ben-Ahin (BEBAN)"
  },
  {
   value: "Bende (BEBEN)",
   label: "Bende (BEBEN)"
  },
  {
   value: "Berchem (BEBCM)",
   label: "Berchem (BEBCM)"
  },
  {
   value: "Berendrecht (BEBRT)",
   label: "Berendrecht (BEBRT)"
  },
  {
   value: "Bergen (BEVBN)",
   label: "Bergen (BEVBN)"
  },
  {
   value: "Berlaar (BEBAR)",
   label: "Berlaar (BEBAR)"
  },
  {
   value: "Berloz (BELRZ)",
   label: "Berloz (BELRZ)"
  },
  {
   value: "Berneau (BEBNU)",
   label: "Berneau (BEBNU)"
  },
  {
   value: "Bernissart (BEABC)",
   label: "Bernissart (BEABC)"
  },
  {
   value: "Yarloop (AUYLO)",
   label: "Yarloop (AUYLO)"
  },
  {
   value: "Yarra Glen (AUYAR)",
   label: "Yarra Glen (AUYAR)"
  },
  {
   value: "Yarraville\/Melbourne (AUYRV)",
   label: "Yarraville\/Melbourne (AUYRV)"
  },
  {
   value: "Yarrawonga (AUYWO)",
   label: "Yarrawonga (AUYWO)"
  },
  {
   value: "Yass (AUYSS)",
   label: "Yass (AUYSS)"
  },
  {
   value: "Yatala (AUYTL)",
   label: "Yatala (AUYTL)"
  },
  {
   value: "Yenda (AUYDA)",
   label: "Yenda (AUYDA)"
  },
  {
   value: "Yennora (AUYNA)",
   label: "Yennora (AUYNA)"
  },
  {
   value: "Yeppoon (AUYEL)",
   label: "Yeppoon (AUYEL)"
  },
  {
   value: "Yering (AUYRG)",
   label: "Yering (AUYRG)"
  },
  {
   value: "York (AUYOR)",
   label: "York (AUYOR)"
  },
  {
   value: "Zillmere (AUZLM)",
   label: "Zillmere (AUZLM)"
  },
  {
   value: ".ARUBA (AW)",
   label: ".ARUBA (AW)"
  },
  {
   value: "Balgerhoek (BEBGK)",
   label: "Balgerhoek (BEBGK)"
  },
  {
   value: "Bande (BEBND)",
   label: "Bande (BEBND)"
  },
  {
   value: "Barry (BEBAY)",
   label: "Barry (BEBAY)"
  },
  {
   value: "Basècles (BEBES)",
   label: "Basècles (BEBES)"
  },
  {
   value: "Bas-Oha (BEBOA)",
   label: "Bas-Oha (BEBOA)"
  },
  {
   value: "Basse-Bodeux (BEBBX)",
   label: "Basse-Bodeux (BEBBX)"
  },
  {
   value: "Bassevelde (BEBSV)",
   label: "Bassevelde (BEBSV)"
  },
  {
   value: "Bassilly (BEBSY)",
   label: "Bassilly (BEBSY)"
  },
  {
   value: "Bas-Warneton (BEBWA)",
   label: "Bas-Warneton (BEBWA)"
  },
  {
   value: "Battel (BEBAT)",
   label: "Battel (BEBAT)"
  },
  {
   value: "Baugnies (BEBGI)",
   label: "Baugnies (BEBGI)"
  },
  {
   value: "Baulers (BEBAS)",
   label: "Baulers (BEBAS)"
  },
  {
   value: "Bavegem (BEBVG)",
   label: "Bavegem (BEBVG)"
  },
  {
   value: "Wishart (AUVIT)",
   label: "Wishart (AUVIT)"
  },
  {
   value: "Withnell Bay (AUWNB)",
   label: "Withnell Bay (AUWNB)"
  },
  {
   value: "Wivenhoe (AUHOE)",
   label: "Wivenhoe (AUHOE)"
  },
  {
   value: "Wollongbar (AUWLR)",
   label: "Wollongbar (AUWLR)"
  },
  {
   value: "Wolumla (AUWUA)",
   label: "Wolumla (AUWUA)"
  },
  {
   value: "Wondalga (AUWDG)",
   label: "Wondalga (AUWDG)"
  },
  {
   value: "Woodend (AUWDD)",
   label: "Woodend (AUWDD)"
  },
  {
   value: "Woodville (AUWDV)",
   label: "Woodville (AUWDV)"
  },
  {
   value: "Woolloongabba (AUWGB)",
   label: "Woolloongabba (AUWGB)"
  },
  {
   value: "Woollybutt (Oil facility) (AUWBT)",
   label: "Woollybutt (Oil facility) (AUWBT)"
  },
  {
   value: "Wyalkatchem (AUWKM)",
   label: "Wyalkatchem (AUWKM)"
  },
  {
   value: "Wyalong (AUWYL)",
   label: "Wyalong (AUWYL)"
  },
  {
   value: "Wyee (AUWYE)",
   label: "Wyee (AUWYE)"
  },
  {
   value: "Wyndham (AUWYD)",
   label: "Wyndham (AUWYD)"
  },
  {
   value: "Wynnum West (AUWWS)",
   label: "Wynnum West (AUWWS)"
  },
  {
   value: "Wyong (AUWYO)",
   label: "Wyong (AUWYO)"
  },
  {
   value: "Yagoona (AUYAN)",
   label: "Yagoona (AUYAN)"
  },
  {
   value: "Yallingup (AUYGU)",
   label: "Yallingup (AUYGU)"
  },
  {
   value: "Winston Hills (AUWHI)",
   label: "Winston Hills (AUWHI)"
  },
  {
   value: "Wattle Park (AUTPK)",
   label: "Wattle Park (AUTPK)"
  },
  {
   value: "Wattle Park (AUWPS)",
   label: "Wattle Park (AUWPS)"
  },
  {
   value: "Webberton (AUWTN)",
   label: "Webberton (AUWTN)"
  },
  {
   value: "Wellington (AUQEL)",
   label: "Wellington (AUQEL)"
  },
  {
   value: "Welshpool (AUWEL)",
   label: "Welshpool (AUWEL)"
  },
  {
   value: "Werribee (AUWRB)",
   label: "Werribee (AUWRB)"
  },
  {
   value: "West Footscray (AUWFO)",
   label: "West Footscray (AUWFO)"
  },
  {
   value: "West Melbourne (AUWMU)",
   label: "West Melbourne (AUWMU)"
  },
  {
   value: "Wetherhill (AUWEH)",
   label: "Wetherhill (AUWEH)"
  },
  {
   value: "Wetherill Park (AUWPA)",
   label: "Wetherill Park (AUWPA)"
  },
  {
   value: "Whitemore (AUWMO)",
   label: "Whitemore (AUWMO)"
  },
  {
   value: "Whitsunday I. (AUWSI)",
   label: "Whitsunday I. (AUWSI)"
  },
  {
   value: "Whitton (AUWTO)",
   label: "Whitton (AUWTO)"
  },
  {
   value: "Wickham (AUWAM)",
   label: "Wickham (AUWAM)"
  },
  {
   value: "Willawong (AUWIL)",
   label: "Willawong (AUWIL)"
  },
  {
   value: "Williams (AUWLI)",
   label: "Williams (AUWLI)"
  },
  {
   value: "Williamstown (AUWST)",
   label: "Williamstown (AUWST)"
  },
  {
   value: "Willowdale (AUWVA)",
   label: "Willowdale (AUWVA)"
  },
  {
   value: "Windsor (AUWSO)",
   label: "Windsor (AUWSO)"
  },
  {
   value: "Wingfield (AUWGF)",
   label: "Wingfield (AUWGF)"
  },
  {
   value: "Winnellie (AUWNN)",
   label: "Winnellie (AUWNN)"
  },
  {
   value: "Verdun (AUVDN)",
   label: "Verdun (AUVDN)"
  },
  {
   value: "Villawood\/Sydney (AUVIW)",
   label: "Villawood\/Sydney (AUVIW)"
  },
  {
   value: "Virginia (AUVGN)",
   label: "Virginia (AUVGN)"
  },
  {
   value: "Virginia (AUVRG)",
   label: "Virginia (AUVRG)"
  },
  {
   value: "Wagin (AUWGI)",
   label: "Wagin (AUWGI)"
  },
  {
   value: "Wakerley (AUWKY)",
   label: "Wakerley (AUWKY)"
  },
  {
   value: "Wallendbeen (AUWDB)",
   label: "Wallendbeen (AUWDB)"
  },
  {
   value: "Walpole (AUWPO)",
   label: "Walpole (AUWPO)"
  },
  {
   value: "Wandandian (AUWAD)",
   label: "Wandandian (AUWAD)"
  },
  {
   value: "Wandin (AUWDN)",
   label: "Wandin (AUWDN)"
  },
  {
   value: "Wandoo Terminal (AUWNT)",
   label: "Wandoo Terminal (AUWNT)"
  },
  {
   value: "Wangara (AUWGR)",
   label: "Wangara (AUWGR)"
  },
  {
   value: "Wantirna South (AUWTS)",
   label: "Wantirna South (AUWTS)"
  },
  {
   value: "Warabrook (AUWAB)",
   label: "Warabrook (AUWAB)"
  },
  {
   value: "Warners Bay (AUWSN)",
   label: "Warners Bay (AUWSN)"
  },
  {
   value: "Warragul (AUVWL)",
   label: "Warragul (AUVWL)"
  },
  {
   value: "Warrandyte South (AUWAR)",
   label: "Warrandyte South (AUWAR)"
  },
  {
   value: "Warren (AUQRR)",
   label: "Warren (AUQRR)"
  },
  {
   value: "Warrenmang (AUWRM)",
   label: "Warrenmang (AUWRM)"
  },
  {
   value: "Tomingley (AUTGY)",
   label: "Tomingley (AUTGY)"
  },
  {
   value: "Tongala (AUTOJ)",
   label: "Tongala (AUTOJ)"
  },
  {
   value: "Tooborac (AUTBR)",
   label: "Tooborac (AUTBR)"
  },
  {
   value: "Toodyay (AUTDA)",
   label: "Toodyay (AUTDA)"
  },
  {
   value: "Tooradin (AUTRD)",
   label: "Tooradin (AUTRD)"
  },
  {
   value: "Toowoomba City (AUTBC)",
   label: "Toowoomba City (AUTBC)"
  },
  {
   value: "Toronto (AUTOR)",
   label: "Toronto (AUTOR)"
  },
  {
   value: "Tottenham (AUTOT)",
   label: "Tottenham (AUTOT)"
  },
  {
   value: "Tuerong (AUTUV)",
   label: "Tuerong (AUTUV)"
  },
  {
   value: "Tullibigeal (AUTGE)",
   label: "Tullibigeal (AUTGE)"
  },
  {
   value: "Tumbarumba (AUTBB)",
   label: "Tumbarumba (AUTBB)"
  },
  {
   value: "Turramurra (AUTUR)",
   label: "Turramurra (AUTUR)"
  },
  {
   value: "Tusmore (AUSAT)",
   label: "Tusmore (AUSAT)"
  },
  {
   value: "Tweed Heads South (AUTHS)",
   label: "Tweed Heads South (AUTHS)"
  },
  {
   value: "Ulladulla (AUULA)",
   label: "Ulladulla (AUULA)"
  },
  {
   value: "Ultimo (AUULT)",
   label: "Ultimo (AUULT)"
  },
  {
   value: "Unanderra (AUUDR)",
   label: "Unanderra (AUUDR)"
  },
  {
   value: "Ungarie (AUUGI)",
   label: "Ungarie (AUUGI)"
  },
  {
   value: "Uralla (AUULL)",
   label: "Uralla (AUULL)"
  },
  {
   value: "Urana (AUUNA)",
   label: "Urana (AUUNA)"
  },
  {
   value: "Surry Hills (AUSUH)",
   label: "Surry Hills (AUSUH)"
  },
  {
   value: "Tambourine (AUTAM)",
   label: "Tambourine (AUTAM)"
  },
  {
   value: "Tanawha (AUTWH)",
   label: "Tanawha (AUTWH)"
  },
  {
   value: "Tankerton (AUTAK)",
   label: "Tankerton (AUTAK)"
  },
  {
   value: "Tarago (AUTGO)",
   label: "Tarago (AUTGO)"
  },
  {
   value: "Taren Point (AUTPO)",
   label: "Taren Point (AUTPO)"
  },
  {
   value: "Tempe (AUMPE)",
   label: "Tempe (AUMPE)"
  },
  {
   value: "Tharbogang (AUTGH)",
   label: "Tharbogang (AUTGH)"
  },
  {
   value: "The Gurdies (AUGUR)",
   label: "The Gurdies (AUGUR)"
  },
  {
   value: "The Rock (AUROC)",
   label: "The Rock (AUROC)"
  },
  {
   value: "Thebarton (AUBTN)",
   label: "Thebarton (AUBTN)"
  },
  {
   value: "Thevenard Island (AUCTH)",
   label: "Thevenard Island (AUCTH)"
  },
  {
   value: "Thomastown (AUTHO)",
   label: "Thomastown (AUTHO)"
  },
  {
   value: "Thornlands (AUTLA)",
   label: "Thornlands (AUTLA)"
  },
  {
   value: "Thornleigh (AUTHR)",
   label: "Thornleigh (AUTHR)"
  },
  {
   value: "Thredbo Village (AUQTH)",
   label: "Thredbo Village (AUQTH)"
  },
  {
   value: "South Windsor (AUSWO)",
   label: "South Windsor (AUSWO)"
  },
  {
   value: "Spearwood (AUSPE)",
   label: "Spearwood (AUSPE)"
  },
  {
   value: "Spreyton (AUSPO)",
   label: "Spreyton (AUSPO)"
  },
  {
   value: "Spring Hill (AUSHI)",
   label: "Spring Hill (AUSHI)"
  },
  {
   value: "Springvale (AUSGV)",
   label: "Springvale (AUSGV)"
  },
  {
   value: "St Peters (AUSTP)",
   label: "St Peters (AUSTP)"
  },
  {
   value: "Stafford (AUSFF)",
   label: "Stafford (AUSFF)"
  },
  {
   value: "Stage Platform (AUSTG)",
   label: "Stage Platform (AUSTG)"
  },
  {
   value: "Stapylton (AUSPY)",
   label: "Stapylton (AUSPY)"
  },
  {
   value: "Stockinbingal (AUSBI)",
   label: "Stockinbingal (AUSBI)"
  },
  {
   value: "Strathfield (AUSFI)",
   label: "Strathfield (AUSFI)"
  },
  {
   value: "Strathfieldsaye (AUTFA)",
   label: "Strathfieldsaye (AUTFA)"
  },
  {
   value: "Stybarrow Venture MV17 (AUSTY)",
   label: "Stybarrow Venture MV17 (AUSTY)"
  },
  {
   value: "Subiaco (AUSBC)",
   label: "Subiaco (AUSBC)"
  },
  {
   value: "Summertown (AUSUM)",
   label: "Summertown (AUSUM)"
  },
  {
   value: "Sunshine\/Melbourne (AUSSE)",
   label: "Sunshine\/Melbourne (AUSSE)"
  },
  {
   value: "Saint Marys (AUSTM)",
   label: "Saint Marys (AUSTM)"
  },
  {
   value: "Salisbury (AUSAL)",
   label: "Salisbury (AUSAL)"
  },
  {
   value: "Scoresby (AUSCY)",
   label: "Scoresby (AUSCY)"
  },
  {
   value: "Sellicks Hill (AUSSH)",
   label: "Sellicks Hill (AUSSH)"
  },
  {
   value: "Seven Hills (AUSVH)",
   label: "Seven Hills (AUSVH)"
  },
  {
   value: "Seventeen Mile Rocks\/Brisbane (AUSMR)",
   label: "Seventeen Mile Rocks\/Brisbane (AUSMR)"
  },
  {
   value: "Skardon River (AUSKA)",
   label: "Skardon River (AUSKA)"
  },
  {
   value: "Skye (AUSKY)",
   label: "Skye (AUSKY)"
  },
  {
   value: "Smithfield (AUSMD)",
   label: "Smithfield (AUSMD)"
  },
  {
   value: "Somersby (AUSMY)",
   label: "Somersby (AUSMY)"
  },
  {
   value: "Somerset (AUSST)",
   label: "Somerset (AUSST)"
  },
  {
   value: "Somerton (AUSOM)",
   label: "Somerton (AUSOM)"
  },
  {
   value: "South Guilford (AUSGD)",
   label: "South Guilford (AUSGD)"
  },
  {
   value: "South Trees (AUSTR)",
   label: "South Trees (AUSTR)"
  },
  {
   value: "Rydalmere (AURYM)",
   label: "Rydalmere (AURYM)"
  },
  {
   value: "Reservoir (AURES)",
   label: "Reservoir (AURES)"
  },
  {
   value: "Revesby (AUREV)",
   label: "Revesby (AUREV)"
  },
  {
   value: "Rhodes (AURDS)",
   label: "Rhodes (AURDS)"
  },
  {
   value: "Richlands (AURHA)",
   label: "Richlands (AURHA)"
  },
  {
   value: "Richmond (AURHM)",
   label: "Richmond (AURHM)"
  },
  {
   value: "Richmond (AURMD)",
   label: "Richmond (AURMD)"
  },
  {
   value: "Ridgehaven (AURID)",
   label: "Ridgehaven (AURID)"
  },
  {
   value: "Ringwood (AURWD)",
   label: "Ringwood (AURWD)"
  },
  {
   value: "Riverina (AURVV)",
   label: "Riverina (AURVV)"
  },
  {
   value: "Riverwood (AUOOD)",
   label: "Riverwood (AUOOD)"
  },
  {
   value: "Robertson (AURTO)",
   label: "Robertson (AURTO)"
  },
  {
   value: "Rockingham (AUROM)",
   label: "Rockingham (AUROM)"
  },
  {
   value: "Rocky Point (AURYP)",
   label: "Rocky Point (AURYP)"
  },
  {
   value: "Rokeby (AURKB)",
   label: "Rokeby (AURKB)"
  },
  {
   value: "Rose Hill (AUROS)",
   label: "Rose Hill (AUROS)"
  },
  {
   value: "Rosebery\/Sydney (AURBY)",
   label: "Rosebery\/Sydney (AURBY)"
  },
  {
   value: "Rowville (AURWE)",
   label: "Rowville (AURWE)"
  },
  {
   value: "Royal Park (AURPA)",
   label: "Royal Park (AURPA)"
  },
  {
   value: "Port Melbourne (AUPOR)",
   label: "Port Melbourne (AUPOR)"
  },
  {
   value: "Preston (AUPSO)",
   label: "Preston (AUPSO)"
  },
  {
   value: "Prospect (AUPRO)",
   label: "Prospect (AUPRO)"
  },
  {
   value: "Pt Kenny (AUPKY)",
   label: "Pt Kenny (AUPKY)"
  },
  {
   value: "Pullen Vale (AUPVL)",
   label: "Pullen Vale (AUPVL)"
  },
  {
   value: "Quairading (AUQDI)",
   label: "Quairading (AUQDI)"
  },
  {
   value: "Queanbeyan (AUQBY)",
   label: "Queanbeyan (AUQBY)"
  },
  {
   value: "Quoiba (AUQUA)",
   label: "Quoiba (AUQUA)"
  },
  {
   value: "Ravensthorpe (AURAV)",
   label: "Ravensthorpe (AURAV)"
  },
  {
   value: "Redcliffe (AURCE)",
   label: "Redcliffe (AURCE)"
  },
  {
   value: "Reedy Creek (AURYC)",
   label: "Reedy Creek (AURYC)"
  },
  {
   value: "Regency Park (AURYK)",
   label: "Regency Park (AURYK)"
  },
  {
   value: "Regents Park (AURGP)",
   label: "Regents Park (AURGP)"
  },
  {
   value: "Relbia (AUREL)",
   label: "Relbia (AUREL)"
  },
  {
   value: "Pascoe Vale (AUPSV)",
   label: "Pascoe Vale (AUPSV)"
  },
  {
   value: "Peak Hill (AUPHI)",
   label: "Peak Hill (AUPHI)"
  },
  {
   value: "Pemberton (AUPBE)",
   label: "Pemberton (AUPBE)"
  },
  {
   value: "Pendle Hills (AUPEN)",
   label: "Pendle Hills (AUPEN)"
  },
  {
   value: "Penrith (AUPRH)",
   label: "Penrith (AUPRH)"
  },
  {
   value: "Pialba (AUPIA)",
   label: "Pialba (AUPIA)"
  },
  {
   value: "Pimpama (AUPIM)",
   label: "Pimpama (AUPIM)"
  },
  {
   value: "Pindar (AUPDA)",
   label: "Pindar (AUPDA)"
  },
  {
   value: "Pingelly (AUPGY)",
   label: "Pingelly (AUPGY)"
  },
  {
   value: "Pinjarra (AUPJA)",
   label: "Pinjarra (AUPJA)"
  },
  {
   value: "Pinkenba (AUPNA)",
   label: "Pinkenba (AUPNA)"
  },
  {
   value: "Pipers Brook (AUPBR)",
   label: "Pipers Brook (AUPBR)"
  },
  {
   value: "Pittong (AUPTO)",
   label: "Pittong (AUPTO)"
  },
  {
   value: "Point Cook (AUPCK)",
   label: "Point Cook (AUPCK)"
  },
  {
   value: "Point Henry Pier\/Melbourne (AUPHP)",
   label: "Point Henry Pier\/Melbourne (AUPHP)"
  },
  {
   value: "Pooraka (AUPRK)",
   label: "Pooraka (AUPRK)"
  },
  {
   value: "Port Denison (AUPDI)",
   label: "Port Denison (AUPDI)"
  },
  {
   value: "Nunawading (AUNWD)",
   label: "Nunawading (AUNWD)"
  },
  {
   value: "Nundah (AUNDH)",
   label: "Nundah (AUNDH)"
  },
  {
   value: "Oakford (AUOAK)",
   label: "Oakford (AUOAK)"
  },
  {
   value: "Oakhurst (AUOKU)",
   label: "Oakhurst (AUOKU)"
  },
  {
   value: "Oakleigh (AUOLH)",
   label: "Oakleigh (AUOLH)"
  },
  {
   value: "Osborne Park (AUOSP)",
   label: "Osborne Park (AUOSP)"
  },
  {
   value: "Ottoway (AUOTO)",
   label: "Ottoway (AUOTO)"
  },
  {
   value: "Padbury (AUURY)",
   label: "Padbury (AUURY)"
  },
  {
   value: "Paddington (AUPAG)",
   label: "Paddington (AUPAG)"
  },
  {
   value: "Padstow (AUDSW)",
   label: "Padstow (AUDSW)"
  },
  {
   value: "Palm Beach (AUPBH)",
   label: "Palm Beach (AUPBH)"
  },
  {
   value: "Pambula (AUPBU)",
   label: "Pambula (AUPBU)"
  },
  {
   value: "Narrikup (AUNKU)",
   label: "Narrikup (AUNKU)"
  },
  {
   value: "Narromine (AUQRM)",
   label: "Narromine (AUQRM)"
  },
  {
   value: "Naval Base (AUNAB)",
   label: "Naval Base (AUNAB)"
  },
  {
   value: "Nerong (AUNRN)",
   label: "Nerong (AUNRN)"
  },
  {
   value: "Nganhurra (AUNGH)",
   label: "Nganhurra (AUNGH)"
  },
  {
   value: "Nhulunbuy (AUNHU)",
   label: "Nhulunbuy (AUNHU)"
  },
  {
   value: "Nimmitabel (AUNTA)",
   label: "Nimmitabel (AUNTA)"
  },
  {
   value: "Noble Park (AUNBP)",
   label: "Noble Park (AUNBP)"
  },
  {
   value: "North Balwyn (AUNBW)",
   label: "North Balwyn (AUNBW)"
  },
  {
   value: "North Curl Curl (AUNCC)",
   label: "North Curl Curl (AUNCC)"
  },
  {
   value: "North Fremantle (AUNFM)",
   label: "North Fremantle (AUNFM)"
  },
  {
   value: "North Geelong (AUGGN)",
   label: "North Geelong (AUGGN)"
  },
  {
   value: "North Ryde (AUNRE)",
   label: "North Ryde (AUNRE)"
  },
  {
   value: "Northam (AUNHA)",
   label: "Northam (AUNHA)"
  },
  {
   value: "Northern Endeavour (AUNTE)",
   label: "Northern Endeavour (AUNTE)"
  },
  {
   value: "Northgate (AUNGT)",
   label: "Northgate (AUNGT)"
  },
  {
   value: "Norwood (AUNOR)",
   label: "Norwood (AUNOR)"
  },
  {
   value: "Notting Hill (AUNTH)",
   label: "Notting Hill (AUNTH)"
  },
  {
   value: "Nulkaba (AUNUK)",
   label: "Nulkaba (AUNUK)"
  },
  {
   value: "Narembeen (AUNBE)",
   label: "Narembeen (AUNBE)"
  },
  {
   value: "Mowbray Heights (AUMOW)",
   label: "Mowbray Heights (AUMOW)"
  },
  {
   value: "Mt Barker (AUMBA)",
   label: "Mt Barker (AUMBA)"
  },
  {
   value: "Mt Magnet (AUMMA)",
   label: "Mt Magnet (AUMMA)"
  },
  {
   value: "Mt Waverly (AUMTW)",
   label: "Mt Waverly (AUMTW)"
  },
  {
   value: "Muchea (AUMHE)",
   label: "Muchea (AUMHE)"
  },
  {
   value: "Mukinbudin (AUMBU)",
   label: "Mukinbudin (AUMBU)"
  },
  {
   value: "Mulgrave (AUMUL)",
   label: "Mulgrave (AUMUL)"
  },
  {
   value: "Mulwala (AUMWA)",
   label: "Mulwala (AUMWA)"
  },
  {
   value: "Murarrie (AUMRI)",
   label: "Murarrie (AUMRI)"
  },
  {
   value: "Murchison (AUMUC)",
   label: "Murchison (AUMUC)"
  },
  {
   value: "Murrey (AURMR)",
   label: "Murrey (AURMR)"
  },
  {
   value: "Murrindindi (AUMRR)",
   label: "Murrindindi (AUMRR)"
  },
  {
   value: "Murrumbateman (AUMBM)",
   label: "Murrumbateman (AUMBM)"
  },
  {
   value: "Murwillumbah (AUMUR)",
   label: "Murwillumbah (AUMUR)"
  },
  {
   value: "Muttama (AUMTA)",
   label: "Muttama (AUMTA)"
  },
  {
   value: "Myaree (AUMBC)",
   label: "Myaree (AUMBC)"
  },
  {
   value: "Myaree (AUWAY)",
   label: "Myaree (AUWAY)"
  },
  {
   value: "Nangwarry (AUNAN)",
   label: "Nangwarry (AUNAN)"
  },
  {
   value: "Nannup (AUNNU)",
   label: "Nannup (AUNNU)"
  },
  {
   value: "Montara Field (AUMON)",
   label: "Montara Field (AUMON)"
  },
  {
   value: "Moora (AUMRA)",
   label: "Moora (AUMRA)"
  },
  {
   value: "Moorebank\/Sydney (AUMRB)",
   label: "Moorebank\/Sydney (AUMRB)"
  },
  {
   value: "Moorook (AUMOK)",
   label: "Moorook (AUMOK)"
  },
  {
   value: "Mooroopna (AUMPV)",
   label: "Mooroopna (AUMPV)"
  },
  {
   value: "Mordialloc (AUMDC)",
   label: "Mordialloc (AUMDC)"
  },
  {
   value: "Morley (AUMLY)",
   label: "Morley (AUMLY)"
  },
  {
   value: "Morwell (AUMOR)",
   label: "Morwell (AUMOR)"
  },
  {
   value: "Mosman (AUMSA)",
   label: "Mosman (AUMSA)"
  },
  {
   value: "Moss Vale (AUMVA)",
   label: "Moss Vale (AUMVA)"
  },
  {
   value: "Mount St John (AUMTS)",
   label: "Mount St John (AUMTS)"
  },
  {
   value: "Mount Waverley (AUWLY)",
   label: "Mount Waverley (AUWLY)"
  },
  {
   value: "Meadowbrook (AUMWO)",
   label: "Meadowbrook (AUMWO)"
  },
  {
   value: "Melville Island (AUMLI)",
   label: "Melville Island (AUMLI)"
  },
  {
   value: "Merredin (AUMRD)",
   label: "Merredin (AUMRD)"
  },
  {
   value: "Michelago (AUMLA)",
   label: "Michelago (AUMLA)"
  },
  {
   value: "Millmerran (AUMMN)",
   label: "Millmerran (AUMMN)"
  },
  {
   value: "Milperra (AUMIL)",
   label: "Milperra (AUMIL)"
  },
  {
   value: "Mindarie (AUMDE)",
   label: "Mindarie (AUMDE)"
  },
  {
   value: "Minto (AUMNT)",
   label: "Minto (AUMNT)"
  },
  {
   value: "Miranda (AUMND)",
   label: "Miranda (AUMND)"
  },
  {
   value: "Mitcham (AUMIT)",
   label: "Mitcham (AUMIT)"
  },
  {
   value: "Mittagong (AUMGO)",
   label: "Mittagong (AUMGO)"
  },
  {
   value: "Moama (AUMOA)",
   label: "Moama (AUMOA)"
  },
  {
   value: "Molendinar (AUMDI)",
   label: "Molendinar (AUMDI)"
  },
  {
   value: "Monarto South (AUMCN)",
   label: "Monarto South (AUMCN)"
  },
  {
   value: "Meadowbrook (AUMEA)",
   label: "Meadowbrook (AUMEA)"
  },
  {
   value: "Macquarie Island (AUMQI)",
   label: "Macquarie Island (AUMQI)"
  },
  {
   value: "Maidstone (AUMDO)",
   label: "Maidstone (AUMDO)"
  },
  {
   value: "Mandogalup (AUMDP)",
   label: "Mandogalup (AUMDP)"
  },
  {
   value: "Mandurah (AUMDU)",
   label: "Mandurah (AUMDU)"
  },
  {
   value: "Marayong (AUMAO)",
   label: "Marayong (AUMAO)"
  },
  {
   value: "Margaret River (AUMGR)",
   label: "Margaret River (AUMGR)"
  },
  {
   value: "Maribyrnong (AUMBY)",
   label: "Maribyrnong (AUMBY)"
  },
  {
   value: "Marong (AUMRN)",
   label: "Marong (AUMRN)"
  },
  {
   value: "Marrickville (AUMAR)",
   label: "Marrickville (AUMAR)"
  },
  {
   value: "Mascot (AUMAS)",
   label: "Mascot (AUMAS)"
  },
  {
   value: "Mathoura (AUMHA)",
   label: "Mathoura (AUMHA)"
  },
  {
   value: "Matong (AUMTO)",
   label: "Matong (AUMTO)"
  },
  {
   value: "Matraville (AUMAT)",
   label: "Matraville (AUMAT)"
  },
  {
   value: "Leeton (AUQLE)",
   label: "Leeton (AUQLE)"
  },
  {
   value: "Legendre Terminal (AULGT)",
   label: "Legendre Terminal (AULGT)"
  },
  {
   value: "Leongatha (AULGA)",
   label: "Leongatha (AULGA)"
  },
  {
   value: "Lidcombe (AULDB)",
   label: "Lidcombe (AULDB)"
  },
  {
   value: "Lilydale (AULYD)",
   label: "Lilydale (AULYD)"
  },
  {
   value: "Lisarow (AULOW)",
   label: "Lisarow (AULOW)"
  },
  {
   value: "Lithgow (AULTG)",
   label: "Lithgow (AULTG)"
  },
  {
   value: "Little River (AULRI)",
   label: "Little River (AULRI)"
  },
  {
   value: "Lockhart (AULKA)",
   label: "Lockhart (AULKA)"
  },
  {
   value: "Longford (AULGF)",
   label: "Longford (AULGF)"
  },
  {
   value: "Lonsdale (AULSD)",
   label: "Lonsdale (AULSD)"
  },
  {
   value: "Lurnea\/Sydney (AULUN)",
   label: "Lurnea\/Sydney (AULUN)"
  },
  {
   value: "Lyndhurst (AUVIL)",
   label: "Lyndhurst (AUVIL)"
  },
  {
   value: "Lyneham (AULHM)",
   label: "Lyneham (AULHM)"
  },
  {
   value: "Lytton (AULTT)",
   label: "Lytton (AULTT)"
  },
  {
   value: "Koolyanbobbing (AUKBG)",
   label: "Koolyanbobbing (AUKBG)"
  },
  {
   value: "Koonoomoo (AUKOM)",
   label: "Koonoomoo (AUKOM)"
  },
  {
   value: "Koorawatha (AUKWA)",
   label: "Koorawatha (AUKWA)"
  },
  {
   value: "Koo-Wee-Rup (AUKWR)",
   label: "Koo-Wee-Rup (AUKWR)"
  },
  {
   value: "Kuehnsdorf (AUKHN)",
   label: "Kuehnsdorf (AUKHN)"
  },
  {
   value: "Kulnura (AUKLU)",
   label: "Kulnura (AUKLU)"
  },
  {
   value: "Kunda Park (AUKUP)",
   label: "Kunda Park (AUKUP)"
  },
  {
   value: "Kurri Kurri (AUKKQ)",
   label: "Kurri Kurri (AUKKQ)"
  },
  {
   value: "Labrador (AULAR)",
   label: "Labrador (AULAR)"
  },
  {
   value: "Lake Cargelligo (AULCG)",
   label: "Lake Cargelligo (AULCG)"
  },
  {
   value: "Lalla (AULAA)",
   label: "Lalla (AULAA)"
  },
  {
   value: "Lamplough (AULAM)",
   label: "Lamplough (AULAM)"
  },
  {
   value: "Lane Cove (AULNC)",
   label: "Lane Cove (AULNC)"
  },
  {
   value: "Laurel Hill (AULHI)",
   label: "Laurel Hill (AULHI)"
  },
  {
   value: "Laverton (AULTO)",
   label: "Laverton (AULTO)"
  },
  {
   value: "Laverton North (AULVH)",
   label: "Laverton North (AULVH)"
  },
  {
   value: "Katoomba (AUKTB)",
   label: "Katoomba (AUKTB)"
  },
  {
   value: "Kedron (AUKED)",
   label: "Kedron (AUKED)"
  },
  {
   value: "Keilor (AUKLR)",
   label: "Keilor (AUKLR)"
  },
  {
   value: "Kellerberrin (AUKBI)",
   label: "Kellerberrin (AUKBI)"
  },
  {
   value: "Kembla (AUKGA)",
   label: "Kembla (AUKGA)"
  },
  {
   value: "Kemblawarra (AUKEM)",
   label: "Kemblawarra (AUKEM)"
  },
  {
   value: "Kendall (AUKDA)",
   label: "Kendall (AUKDA)"
  },
  {
   value: "Kensington (AUKGT)",
   label: "Kensington (AUKGT)"
  },
  {
   value: "Keon Park (AUKEN)",
   label: "Keon Park (AUKEN)"
  },
  {
   value: "Kewdale (AUKEW)",
   label: "Kewdale (AUKEW)"
  },
  {
   value: "Keysborough (AUKBO)",
   label: "Keysborough (AUKBO)"
  },
  {
   value: "Kilsyth (AUKSY)",
   label: "Kilsyth (AUKSY)"
  },
  {
   value: "Kings Park (AUKPK)",
   label: "Kings Park (AUKPK)"
  },
  {
   value: "Kings Park (AUKRK)",
   label: "Kings Park (AUKRK)"
  },
  {
   value: "Kingsgrove (AUKGG)",
   label: "Kingsgrove (AUKGG)"
  },
  {
   value: "Kirrawee (AUKRW)",
   label: "Kirrawee (AUKRW)"
  },
  {
   value: "Klemzig (AUKLZ)",
   label: "Klemzig (AUKLZ)"
  },
  {
   value: "Knowsley (AUKNY)",
   label: "Knowsley (AUKNY)"
  },
  {
   value: "Knoxfield (AUKNO)",
   label: "Knoxfield (AUKNO)"
  },
  {
   value: "Kogarah (AUARA)",
   label: "Kogarah (AUARA)"
  },
  {
   value: "Kongwak (AUVKK)",
   label: "Kongwak (AUVKK)"
  },
  {
   value: "Hurstville (AUHUR)",
   label: "Hurstville (AUHUR)"
  },
  {
   value: "Hyden (AUHYD)",
   label: "Hyden (AUHYD)"
  },
  {
   value: "Ingleburn (AUIGN)",
   label: "Ingleburn (AUIGN)"
  },
  {
   value: "Ivanhoe (AUIHO)",
   label: "Ivanhoe (AUIHO)"
  },
  {
   value: "Jerilderie (AUJDE)",
   label: "Jerilderie (AUJDE)"
  },
  {
   value: "Jervis Bay (AUJEB)",
   label: "Jervis Bay (AUJEB)"
  },
  {
   value: "Joondalup (AUJDP)",
   label: "Joondalup (AUJDP)"
  },
  {
   value: "Junee (AUJNE)",
   label: "Junee (AUJNE)"
  },
  {
   value: "Kangaroo Flat (AUKGF)",
   label: "Kangaroo Flat (AUKGF)"
  },
  {
   value: "Kangaroo Ground (AUKGO)",
   label: "Kangaroo Ground (AUKGO)"
  },
  {
   value: "Kanimbla (AUKIA)",
   label: "Kanimbla (AUKIA)"
  },
  {
   value: "Huonville (AUHVI)",
   label: "Huonville (AUHVI)"
  },
  {
   value: "Hawks Nest (AUHWN)",
   label: "Hawks Nest (AUHWN)"
  },
  {
   value: "Hawthorn (AUHTE)",
   label: "Hawthorn (AUHTE)"
  },
  {
   value: "Hectorville (AULLE)",
   label: "Hectorville (AULLE)"
  },
  {
   value: "Heidelberg (AUHEI)",
   label: "Heidelberg (AUHEI)"
  },
  {
   value: "Hemmant (AUHEM)",
   label: "Hemmant (AUHEM)"
  },
  {
   value: "Henty (AUHTY)",
   label: "Henty (AUHTY)"
  },
  {
   value: "High Wycombe (AUHWY)",
   label: "High Wycombe (AUHWY)"
  },
  {
   value: "Highett\/Melbourne (AUHHT)",
   label: "Highett\/Melbourne (AUHHT)"
  },
  {
   value: "Holden Hill (AUHOL)",
   label: "Holden Hill (AUHOL)"
  },
  {
   value: "Homebush\/Sydney (AUHBS)",
   label: "Homebush\/Sydney (AUHBS)"
  },
  {
   value: "Hornsby (AUHOY)",
   label: "Hornsby (AUHOY)"
  },
  {
   value: "Howlong (AUHWO)",
   label: "Howlong (AUHWO)"
  },
  {
   value: "Humpty Doo (AUHUD)",
   label: "Humpty Doo (AUHUD)"
  },
  {
   value: "Gracemere (AUGME)",
   label: "Gracemere (AUGME)"
  },
  {
   value: "Grass Valley (AUGVW)",
   label: "Grass Valley (AUGVW)"
  },
  {
   value: "Grassy (AUGRA)",
   label: "Grassy (AUGRA)"
  },
  {
   value: "Greenough (AUGNU)",
   label: "Greenough (AUGNU)"
  },
  {
   value: "Greenslopes (AUGSO)",
   label: "Greenslopes (AUGSO)"
  },
  {
   value: "Greystanes (AUGRE)",
   label: "Greystanes (AUGRE)"
  },
  {
   value: "Grong Grong (AUGGO)",
   label: "Grong Grong (AUGGO)"
  },
  {
   value: "Gundagai (AUGDA)",
   label: "Gundagai (AUGDA)"
  },
  {
   value: "Gunning (AUGUN)",
   label: "Gunning (AUGUN)"
  },
  {
   value: "Haberfield (AUHAB)",
   label: "Haberfield (AUHAB)"
  },
  {
   value: "Halifax (AUHAL)",
   label: "Halifax (AUHAL)"
  },
  {
   value: "Hallam (AUHLM)",
   label: "Hallam (AUHLM)"
  },
  {
   value: "Hampton (AUHPN)",
   label: "Hampton (AUHPN)"
  },
  {
   value: "Harcourt (AUHAR)",
   label: "Harcourt (AUHAR)"
  },
  {
   value: "Harden (AUHDN)",
   label: "Harden (AUHDN)"
  },
  {
   value: "Harvey (AUHVY)",
   label: "Harvey (AUHVY)"
  },
  {
   value: "Hastings (AUHAS)",
   label: "Hastings (AUHAS)"
  },
  {
   value: "Hastings Point (AUHPO)",
   label: "Hastings Point (AUHPO)"
  },
  {
   value: "Ganmain (AUGMA)",
   label: "Ganmain (AUGMA)"
  },
  {
   value: "Gapstead (AUGAP)",
   label: "Gapstead (AUGAP)"
  },
  {
   value: "Garbutt Station (AUGBT)",
   label: "Garbutt Station (AUGBT)"
  },
  {
   value: "Geebung (AUGUG)",
   label: "Geebung (AUGUG)"
  },
  {
   value: "Gillman (AUGIL)",
   label: "Gillman (AUGIL)"
  },
  {
   value: "Gingin (AUGNI)",
   label: "Gingin (AUGNI)"
  },
  {
   value: "Girraween (AUGRW)",
   label: "Girraween (AUGRW)"
  },
  {
   value: "Gisborne (AUGBN)",
   label: "Gisborne (AUGBN)"
  },
  {
   value: "Glen Forbes (AUTGF)",
   label: "Glen Forbes (AUTGF)"
  },
  {
   value: "Glendenning (AUGLN)",
   label: "Glendenning (AUGLN)"
  },
  {
   value: "Glenorchy (AUGCY)",
   label: "Glenorchy (AUGCY)"
  },
  {
   value: "Gloucester (AUGCE)",
   label: "Gloucester (AUGCE)"
  },
  {
   value: "Glynde\/Norwood Payneham St Peters (AUGDY)",
   label: "Glynde\/Norwood Payneham St Peters (AUGDY)"
  },
  {
   value: "Gnowangerup (AUGWG)",
   label: "Gnowangerup (AUGWG)"
  },
  {
   value: "Galong (AUGLO)",
   label: "Galong (AUGLO)"
  },
  {
   value: "Epsom (AUESM)",
   label: "Epsom (AUESM)"
  },
  {
   value: "Erina (AUERN)",
   label: "Erina (AUERN)"
  },
  {
   value: "Ermington (AUERM)",
   label: "Ermington (AUERM)"
  },
  {
   value: "Erskine Park (AUEPK)",
   label: "Erskine Park (AUEPK)"
  },
  {
   value: "Euabalong (AUEBO)",
   label: "Euabalong (AUEBO)"
  },
  {
   value: "Evandale (AUEVT)",
   label: "Evandale (AUEVT)"
  },
  {
   value: "Fairfield (AUFFD)",
   label: "Fairfield (AUFFD)"
  },
  {
   value: "Felixstow (AUFEL)",
   label: "Felixstow (AUFEL)"
  },
  {
   value: "Fitzroy (AUFIT)",
   label: "Fitzroy (AUFIT)"
  },
  {
   value: "Footscray (AUFCY)",
   label: "Footscray (AUFCY)"
  },
  {
   value: "Frewville (AUFRL)",
   label: "Frewville (AUFRL)"
  },
  {
   value: "Front Puffin FPSO (AUPUF)",
   label: "Front Puffin FPSO (AUPUF)"
  },
  {
   value: "Fullerton (AUFTN)",
   label: "Fullerton (AUFTN)"
  },
  {
   value: "Furnissdale (AUFUR)",
   label: "Furnissdale (AUFUR)"
  },
  {
   value: "Fyshwick (AUFYW)",
   label: "Fyshwick (AUFYW)"
  },
  {
   value: "Doodlakine (AUDDK)",
   label: "Doodlakine (AUDDK)"
  },
  {
   value: "Drummoyne\/Sydney (AUDRE)",
   label: "Drummoyne\/Sydney (AUDRE)"
  },
  {
   value: "Dulwich (AUDUL)",
   label: "Dulwich (AUDUL)"
  },
  {
   value: "Duncraig (AUDCG)",
   label: "Duncraig (AUDCG)"
  },
  {
   value: "Dunedoo (AUDDO)",
   label: "Dunedoo (AUDDO)"
  },
  {
   value: "Dungog (AUDGO)",
   label: "Dungog (AUDGO)"
  },
  {
   value: "Dunsborough (AUDSB)",
   label: "Dunsborough (AUDSB)"
  },
  {
   value: "Eagle Farm (AUELF)",
   label: "Eagle Farm (AUELF)"
  },
  {
   value: "East Devonport (AUEVP)",
   label: "East Devonport (AUEVP)"
  },
  {
   value: "East Jindabyne (AUEJB)",
   label: "East Jindabyne (AUEJB)"
  },
  {
   value: "East Maitland (AUEML)",
   label: "East Maitland (AUEML)"
  },
  {
   value: "Edwardstown (AUEDW)",
   label: "Edwardstown (AUEDW)"
  },
  {
   value: "Elizabeth (AUELZ)",
   label: "Elizabeth (AUELZ)"
  },
  {
   value: "Elsternwick (AUELW)",
   label: "Elsternwick (AUELW)"
  },
  {
   value: "Elwood (AUEWO)",
   label: "Elwood (AUEWO)"
  },
  {
   value: "Eneabba (AUEAB)",
   label: "Eneabba (AUEAB)"
  },
  {
   value: "Doncaster (AUDCR)",
   label: "Doncaster (AUDCR)"
  },
  {
   value: "Culcairn (AUCLC)",
   label: "Culcairn (AUCLC)"
  },
  {
   value: "Cullen Bullen (AUCBU)",
   label: "Cullen Bullen (AUCBU)"
  },
  {
   value: "Cunderdin (AUCDI)",
   label: "Cunderdin (AUCDI)"
  },
  {
   value: "Currumbin Waters (AUCUR)",
   label: "Currumbin Waters (AUCUR)"
  },
  {
   value: "Daisy Hill (AUDHL)",
   label: "Daisy Hill (AUDHL)"
  },
  {
   value: "Dalmore (AUDMO)",
   label: "Dalmore (AUDMO)"
  },
  {
   value: "Dalrymple Islet (AUDIT)",
   label: "Dalrymple Islet (AUDIT)"
  },
  {
   value: "Dapto (AUDTO)",
   label: "Dapto (AUDTO)"
  },
  {
   value: "Darlington Point (AUDTP)",
   label: "Darlington Point (AUDTP)"
  },
  {
   value: "Denmark (AUDMA)",
   label: "Denmark (AUDMA)"
  },
  {
   value: "Derrimut (AUDVI)",
   label: "Derrimut (AUDVI)"
  },
  {
   value: "Deviot (AUDEV)",
   label: "Deviot (AUDEV)"
  },
  {
   value: "Dingley Village (AUDGY)",
   label: "Dingley Village (AUDGY)"
  },
  {
   value: "Colbinabbin (AUCON)",
   label: "Colbinabbin (AUCON)"
  },
  {
   value: "Coolabah (AUCLB)",
   label: "Coolabah (AUCLB)"
  },
  {
   value: "Coolamon (AUCLA)",
   label: "Coolamon (AUCLA)"
  },
  {
   value: "Coolgardie (AUCGA)",
   label: "Coolgardie (AUCGA)"
  },
  {
   value: "Coomera (AUCOO)",
   label: "Coomera (AUCOO)"
  },
  {
   value: "Coominya (AUYMN)",
   label: "Coominya (AUYMN)"
  },
  {
   value: "Coral Sea (AUCRS)",
   label: "Coral Sea (AUCRS)"
  },
  {
   value: "Corio Bay (AUCBA)",
   label: "Corio Bay (AUCBA)"
  },
  {
   value: "Craigieburn (AUCVA)",
   label: "Craigieburn (AUCVA)"
  },
  {
   value: "Cavan (AUCAV)",
   label: "Cavan (AUCAV)"
  },
  {
   value: "Chadstone\/Melbourne (AUCHD)",
   label: "Chadstone\/Melbourne (AUCHD)"
  },
  {
   value: "Chatsworth Island (AUCWI)",
   label: "Chatsworth Island (AUCWI)"
  },
  {
   value: "Cheltenham\/Melbourne (AUCHL)",
   label: "Cheltenham\/Melbourne (AUCHL)"
  },
  {
   value: "Chipping Norton (AUCHN)",
   label: "Chipping Norton (AUCHN)"
  },
  {
   value: "Chullora (AUCHU)",
   label: "Chullora (AUCHU)"
  },
  {
   value: "Clayton\/Melbourne (AUCLY)",
   label: "Clayton\/Melbourne (AUCLY)"
  },
  {
   value: "Cleveland (AUCVN)",
   label: "Cleveland (AUCVN)"
  },
  {
   value: "Clontarf (AUCLO)",
   label: "Clontarf (AUCLO)"
  },
  {
   value: "Clovelly Park (AUCLP)",
   label: "Clovelly Park (AUCLP)"
  },
  {
   value: "Clunes (AUCLU)",
   label: "Clunes (AUCLU)"
  },
  {
   value: "Coburg (AUCBG)",
   label: "Coburg (AUCBG)"
  },
  {
   value: "Cockatoo I. (AUCTI)",
   label: "Cockatoo I. (AUCTI)"
  },
  {
   value: "Camberwell (AUCAM)",
   label: "Camberwell (AUCAM)"
  },
  {
   value: "Camellia (AUCIA)",
   label: "Camellia (AUCIA)"
  },
  {
   value: "Campania (AUCPA)",
   label: "Campania (AUCPA)"
  },
  {
   value: "Canning Vale\/Perth (AUCNN)",
   label: "Canning Vale\/Perth (AUCNN)"
  },
  {
   value: "Canningvale (AUCAN)",
   label: "Canningvale (AUCAN)"
  },
  {
   value: "Cannon Hill (AUCAH)",
   label: "Cannon Hill (AUCAH)"
  },
  {
   value: "Capel (AUCPL)",
   label: "Capel (AUCPL)"
  },
  {
   value: "Caringbah (AUCRG)",
   label: "Caringbah (AUCRG)"
  },
  {
   value: "Carlton (AUCRT)",
   label: "Carlton (AUCRT)"
  },
  {
   value: "Carrara (AUCRA)",
   label: "Carrara (AUCRA)"
  },
  {
   value: "Carrington (AUCRR)",
   label: "Carrington (AUCRR)"
  },
  {
   value: "Carrum Downs (AUCAD)",
   label: "Carrum Downs (AUCAD)"
  },
  {
   value: "Castle Hill (AUCHI)",
   label: "Castle Hill (AUCHI)"
  },
  {
   value: "Cataby (AUCTB)",
   label: "Cataby (AUCTB)"
  },
  {
   value: "Burringbar (AUBGB)",
   label: "Burringbar (AUBGB)"
  },
  {
   value: "Bridgetown (AUBGT)",
   label: "Bridgetown (AUBGT)"
  },
  {
   value: "Bridgewater (AUBGR)",
   label: "Bridgewater (AUBGR)"
  },
  {
   value: "Brigalow (AUBRI)",
   label: "Brigalow (AUBRI)"
  },
  {
   value: "Bringelly (AUBIY)",
   label: "Bringelly (AUBIY)"
  },
  {
   value: "Broadmeadows (AUBMD)",
   label: "Broadmeadows (AUBMD)"
  },
  {
   value: "Brooklyn (AUBKL)",
   label: "Brooklyn (AUBKL)"
  },
  {
   value: "Brookton (AUBKT)",
   label: "Brookton (AUBKT)"
  },
  {
   value: "Brookvale\/Sidney (AUBVE)",
   label: "Brookvale\/Sidney (AUBVE)"
  },
  {
   value: "Brookville (AUBVL)",
   label: "Brookville (AUBVL)"
  },
  {
   value: "Brunswich (AUBRU)",
   label: "Brunswich (AUBRU)"
  },
  {
   value: "Brunswick (AUBWK)",
   label: "Brunswick (AUBWK)"
  },
  {
   value: "Buffalo Venture (AUBUV)",
   label: "Buffalo Venture (AUBUV)"
  },
  {
   value: "Bulahdelah (AUBDA)",
   label: "Bulahdelah (AUBDA)"
  },
  {
   value: "Bulli (AUBUL)",
   label: "Bulli (AUBUL)"
  },
  {
   value: "Bulwer (AUBWI)",
   label: "Bulwer (AUBWI)"
  },
  {
   value: "Bundamba (AUBDM)",
   label: "Bundamba (AUBDM)"
  },
  {
   value: "Bungwahl (AUBGA)",
   label: "Bungwahl (AUBGA)"
  },
  {
   value: "Burleigh Heads (AUBLH)",
   label: "Burleigh Heads (AUBLH)"
  },
  {
   value: "Burnside (AUBRN)",
   label: "Burnside (AUBRN)"
  },
  {
   value: "Burren Junction (AUBJU)",
   label: "Burren Junction (AUBJU)"
  },
  {
   value: "Brendale (AUBDE)",
   label: "Brendale (AUBDE)"
  },
  {
   value: "Binalong (AUBNG)",
   label: "Binalong (AUBNG)"
  },
  {
   value: "Bing Bong (AUBBG)",
   label: "Bing Bong (AUBBG)"
  },
  {
   value: "Binna Burra (AUBBR)",
   label: "Binna Burra (AUBBR)"
  },
  {
   value: "Binya (AUBYA)",
   label: "Binya (AUBYA)"
  },
  {
   value: "Blacktown (AUBCO)",
   label: "Blacktown (AUBCO)"
  },
  {
   value: "Blayney (AUBNY)",
   label: "Blayney (AUBNY)"
  },
  {
   value: "Blighty (AUBGY)",
   label: "Blighty (AUBGY)"
  },
  {
   value: "Bombala (AUBMA)",
   label: "Bombala (AUBMA)"
  },
  {
   value: "Bondi Junction (AUBJT)",
   label: "Bondi Junction (AUBJT)"
  },
  {
   value: "Bonnie Vale (AUBEV)",
   label: "Bonnie Vale (AUBEV)"
  },
  {
   value: "Booby Island (AUBOO)",
   label: "Booby Island (AUBOO)"
  },
  {
   value: "Booragoon (AUBGO)",
   label: "Booragoon (AUBGO)"
  },
  {
   value: "Boronia (AUVIB)",
   label: "Boronia (AUVIB)"
  },
  {
   value: "Bowning (AUBWG)",
   label: "Bowning (AUBWG)"
  },
  {
   value: "Bowral (AUBWA)",
   label: "Bowral (AUBWA)"
  },
  {
   value: "Box Hill (AUBXI)",
   label: "Box Hill (AUBXI)"
  },
  {
   value: "Boyanup (AUBYU)",
   label: "Boyanup (AUBYU)"
  },
  {
   value: "Boyer (AUBOY)",
   label: "Boyer (AUBOY)"
  },
  {
   value: "Boyup Brook (AUBYB)",
   label: "Boyup Brook (AUBYB)"
  },
  {
   value: "Braeside (AUBRS)",
   label: "Braeside (AUBRS)"
  },
  {
   value: "Bremer Bay (AUBBY)",
   label: "Bremer Bay (AUBBY)"
  },
  {
   value: "Bayswater (AUBYS)",
   label: "Bayswater (AUBYS)"
  },
  {
   value: "Bayswater (AUBYW)",
   label: "Bayswater (AUBYW)"
  },
  {
   value: "Beaconsfield (AUBEA)",
   label: "Beaconsfield (AUBEA)"
  },
  {
   value: "Beaconsfield Upper (AUBPR)",
   label: "Beaconsfield Upper (AUBPR)"
  },
  {
   value: "Beckenham (AUBEC)",
   label: "Beckenham (AUBEC)"
  },
  {
   value: "Beckom (AUBKO)",
   label: "Beckom (AUBKO)"
  },
  {
   value: "Beenleigh (AUBLG)",
   label: "Beenleigh (AUBLG)"
  },
  {
   value: "Beerwah (AUBEW)",
   label: "Beerwah (AUBEW)"
  },
  {
   value: "Bega (AUQBE)",
   label: "Bega (AUQBE)"
  },
  {
   value: "Bellevue (AUBEX)",
   label: "Bellevue (AUBEX)"
  },
  {
   value: "Belmore (AUBEM)",
   label: "Belmore (AUBEM)"
  },
  {
   value: "Bemboka (AUBMK)",
   label: "Bemboka (AUBMK)"
  },
  {
   value: "Bencubbin (AUBCB)",
   label: "Bencubbin (AUBCB)"
  },
  {
   value: "Bendick Murrell (AUBMU)",
   label: "Bendick Murrell (AUBMU)"
  },
  {
   value: "Bennetts Green (AUBGN)",
   label: "Bennetts Green (AUBGN)"
  },
  {
   value: "Bentliegh Vic (AUBEN)",
   label: "Bentliegh Vic (AUBEN)"
  },
  {
   value: "Beresfield (AUBFD)",
   label: "Beresfield (AUBFD)"
  },
  {
   value: "Berridale (AUBRD)",
   label: "Berridale (AUBRD)"
  },
  {
   value: "Berrigan (AUBRG)",
   label: "Berrigan (AUBRG)"
  },
  {
   value: "Beverley (AUBVS)",
   label: "Beverley (AUBVS)"
  },
  {
   value: "Bibbenluke (AUBBU)",
   label: "Bibbenluke (AUBBU)"
  },
  {
   value: "Bibra Lake (AUBLA)",
   label: "Bibra Lake (AUBLA)"
  },
  {
   value: "Baxter (AUBXT)",
   label: "Baxter (AUBXT)"
  },
  {
   value: "Australind (AUALI)",
   label: "Australind (AUALI)"
  },
  {
   value: "Balcatta (AUBTT)",
   label: "Balcatta (AUBTT)"
  },
  {
   value: "Balgowlah (AUBWL)",
   label: "Balgowlah (AUBWL)"
  },
  {
   value: "Balmain (AUBLM)",
   label: "Balmain (AUBLM)"
  },
  {
   value: "Bangalow (AUBGW)",
   label: "Bangalow (AUBGW)"
  },
  {
   value: "Bangholme (AULME)",
   label: "Bangholme (AULME)"
  },
  {
   value: "Banksmeadow (AUBMO)",
   label: "Banksmeadow (AUBMO)"
  },
  {
   value: "Barellan (AUBRL)",
   label: "Barellan (AUBRL)"
  },
  {
   value: "Barry Beach (AUBAR)",
   label: "Barry Beach (AUBAR)"
  },
  {
   value: "Bassendean (AUBAS)",
   label: "Bassendean (AUBAS)"
  },
  {
   value: "Batemans Bay (AUQBW)",
   label: "Batemans Bay (AUQBW)"
  },
  {
   value: "Batlow (AUBTO)",
   label: "Batlow (AUBTO)"
  },
  {
   value: "Baulkham Hills (AUBKH)",
   label: "Baulkham Hills (AUBKH)"
  },
  {
   value: "Alstonville (AUAVI)",
   label: "Alstonville (AUAVI)"
  },
  {
   value: "Altona North (AUATO)",
   label: "Altona North (AUATO)"
  },
  {
   value: "Andrews (AUAND)",
   label: "Andrews (AUAND)"
  },
  {
   value: "Archerfield (AUAFL)",
   label: "Archerfield (AUAFL)"
  },
  {
   value: "Ardlethan (AUATA)",
   label: "Ardlethan (AUATA)"
  },
  {
   value: "Armadale (AUAUA)",
   label: "Armadale (AUAUA)"
  },
  {
   value: "Arncliffe (AUARC)",
   label: "Arncliffe (AUARC)"
  },
  {
   value: "Arndell Park (AUDLP)",
   label: "Arndell Park (AUDLP)"
  },
  {
   value: "Arundel (AUARL)",
   label: "Arundel (AUARL)"
  },
  {
   value: "Ascot (AUACO)",
   label: "Ascot (AUACO)"
  },
  {
   value: "Ashgrove\/Brisbane (AUASC)",
   label: "Ashgrove\/Brisbane (AUASC)"
  },
  {
   value: "Asquith (AUASQ)",
   label: "Asquith (AUASQ)"
  },
  {
   value: "Athelstone (AUATH)",
   label: "Athelstone (AUATH)"
  },
  {
   value: "Athol Park (AUAPR)",
   label: "Athol Park (AUAPR)"
  },
  {
   value: "Auburn (AUBUR)",
   label: "Auburn (AUBUR)"
  },
  {
   value: "Augusta (AUAGS)",
   label: "Augusta (AUAGS)"
  },
  {
   value: "Auldana (AUALA)",
   label: "Auldana (AUALA)"
  },
  {
   value: "Argenteau (BEAGT)",
   label: "Argenteau (BEAGT)"
  },
  {
   value: "Arquennes (BEAQE)",
   label: "Arquennes (BEAQE)"
  },
  {
   value: "As (BEASS)",
   label: "As (BEASS)"
  },
  {
   value: "Aspelare (BEASE)",
   label: "Aspelare (BEASE)"
  },
  {
   value: "Asper (BEASP)",
   label: "Asper (BEASP)"
  },
  {
   value: "Asse (BEAES)",
   label: "Asse (BEAES)"
  },
  {
   value: "Assebroek (BEABR)",
   label: "Assebroek (BEABR)"
  },
  {
   value: "Assenede (BEANE)",
   label: "Assenede (BEANE)"
  },
  {
   value: "Assesse (BEASN)",
   label: "Assesse (BEASN)"
  },
  {
   value: "Astene (BEAST)",
   label: "Astene (BEAST)"
  },
  {
   value: "Attenhoven (BEAHO)",
   label: "Attenhoven (BEAHO)"
  },
  {
   value: "Attenrode (BEARO)",
   label: "Attenrode (BEARO)"
  },
  {
   value: "Attert (BEATE)",
   label: "Attert (BEATE)"
  },
  {
   value: "Attre (BEARE)",
   label: "Attre (BEARE)"
  },
  {
   value: "Aubange (BEAUG)",
   label: "Aubange (BEAUG)"
  },
  {
   value: "Aubechies (BEAUB)",
   label: "Aubechies (BEAUB)"
  },
  {
   value: "Auby (BEAUY)",
   label: "Auby (BEAUY)"
  },
  {
   value: "Audregnies (BEADI)",
   label: "Audregnies (BEADI)"
  },
  {
   value: "Auvelais (BEAVS)",
   label: "Auvelais (BEAVS)"
  },
  {
   value: "Averbode (BEABO)",
   label: "Averbode (BEABO)"
  },
  {
   value: "Awans (BEAWS)",
   label: "Awans (BEAWS)"
  },
  {
   value: "Aywaille (BEAYW)",
   label: "Aywaille (BEAYW)"
  },
  {
   value: "Baardegem (BEBDE)",
   label: "Baardegem (BEBDE)"
  },
  {
   value: "Baarle-Hertog (BEBHO)",
   label: "Baarle-Hertog (BEBHO)"
  },
  {
   value: "Baasrode (BEBSR)",
   label: "Baasrode (BEBSR)"
  },
  {
   value: "Baelen (BEBLN)",
   label: "Baelen (BEBLN)"
  },
  {
   value: "Baileux (BEBAX)",
   label: "Baileux (BEBAX)"
  },
  {
   value: "Baisy-Thy (BEBYT)",
   label: "Baisy-Thy (BEBYT)"
  },
  {
   value: "Affligem (BEAFF)",
   label: "Affligem (BEAFF)"
  },
  {
   value: "Afsnee (BEAFN)",
   label: "Afsnee (BEAFN)"
  },
  {
   value: "Agimont (BEAGI)",
   label: "Agimont (BEAGI)"
  },
  {
   value: "Aiseau-Presles (BEAPE)",
   label: "Aiseau-Presles (BEAPE)"
  },
  {
   value: "Alsemberg (BEASB)",
   label: "Alsemberg (BEASB)"
  },
  {
   value: "Alveringem (BEAVR)",
   label: "Alveringem (BEAVR)"
  },
  {
   value: "Amay (BEAMY)",
   label: "Amay (BEAMY)"
  },
  {
   value: "Amblève (BEAME)",
   label: "Amblève (BEAME)"
  },
  {
   value: "Ambly (BEABY)",
   label: "Ambly (BEABY)"
  },
  {
   value: "Amougies (BEAOG)",
   label: "Amougies (BEAOG)"
  },
  {
   value: "Ampsin (BEAPS)",
   label: "Ampsin (BEAPS)"
  },
  {
   value: "Andenne (BEAND)",
   label: "Andenne (BEAND)"
  },
  {
   value: "Anderlecht\/Brussel (Bruxelles) (BEANL)",
   label: "Anderlecht\/Brussel (Bruxelles) (BEANL)"
  },
  {
   value: "Anderlues (BEADU)",
   label: "Anderlues (BEADU)"
  },
  {
   value: "Andrimont (BEAMO)",
   label: "Andrimont (BEAMO)"
  },
  {
   value: "Anhée (BEANH)",
   label: "Anhée (BEANH)"
  },
  {
   value: "Anlier (BEALI)",
   label: "Anlier (BEALI)"
  },
  {
   value: "Annevoie (BEAVE)",
   label: "Annevoie (BEAVE)"
  },
  {
   value: "Ans (BEANS)",
   label: "Ans (BEANS)"
  },
  {
   value: "Anseremme (BEASR)",
   label: "Anseremme (BEASR)"
  },
  {
   value: "Antheit (BEAHE)",
   label: "Antheit (BEAHE)"
  },
  {
   value: "Anthisnes (BEAIS)",
   label: "Anthisnes (BEAIS)"
  },
  {
   value: "Antoing (BEATO)",
   label: "Antoing (BEATO)"
  },
  {
   value: "Antwerp = Antwerpen (BE)",
   label: "Antwerp = Antwerpen (BE)"
  },
  {
   value: "Antwerp Churchill Terminal (BEANT)",
   label: "Antwerp Churchill Terminal (BEANT)"
  },
  {
   value: "Anvaing (BEAVG)",
   label: "Anvaing (BEAVG)"
  },
  {
   value: "Appels (BEAPL)",
   label: "Appels (BEAPL)"
  },
  {
   value: "Appelterre-Eichem (BEAPT)",
   label: "Appelterre-Eichem (BEAPT)"
  },
  {
   value: "Arbre (BEABE)",
   label: "Arbre (BEABE)"
  },
  {
   value: "Adinkerke (BEADK)",
   label: "Adinkerke (BEADK)"
  },
  {
   value: "Benapole (BDBNP)",
   label: "Benapole (BDBNP)"
  },
  {
   value: "Tejgaon (BDTEJ)",
   label: "Tejgaon (BDTEJ)"
  },
  {
   value: "Aalbeke (BEALB)",
   label: "Aalbeke (BEALB)"
  },
  {
   value: "Aartrijke (BEART)",
   label: "Aartrijke (BEART)"
  },
  {
   value: "Achel (BEAHL)",
   label: "Achel (BEAHL)"
  },
  {
   value: "Achet (BEACE)",
   label: "Achet (BEACE)"
  },
  {
   value: "Adegem (BEAGE)",
   label: "Adegem (BEAGE)"
  },
  {
   value: "Maglaj (BAMAG)",
   label: "Maglaj (BAMAG)"
  },
  {
   value: "Matuzici (BAMZI)",
   label: "Matuzici (BAMZI)"
  },
  {
   value: "Medugorje (BAMGE)",
   label: "Medugorje (BAMGE)"
  },
  {
   value: "Modrica (BAMOD)",
   label: "Modrica (BAMOD)"
  },
  {
   value: "Mravnjac (BAMRA)",
   label: "Mravnjac (BAMRA)"
  },
  {
   value: "Mrkonji Grad (BAMGR)",
   label: "Mrkonji Grad (BAMGR)"
  },
  {
   value: "Perduhovo Selo (BAPER)",
   label: "Perduhovo Selo (BAPER)"
  },
  {
   value: "Posusje (BAPSE)",
   label: "Posusje (BAPSE)"
  },
  {
   value: "Prijedor (BAPDR)",
   label: "Prijedor (BAPDR)"
  },
  {
   value: "Prnjavor (BAPJR)",
   label: "Prnjavor (BAPJR)"
  },
  {
   value: "Rajlovac (BARAJ)",
   label: "Rajlovac (BARAJ)"
  },
  {
   value: "Sekovici (BASKV)",
   label: "Sekovici (BASKV)"
  },
  {
   value: "Siroki Brijeg (BASIB)",
   label: "Siroki Brijeg (BASIB)"
  },
  {
   value: "Srebrenica (BASIC)",
   label: "Srebrenica (BASIC)"
  },
  {
   value: "Srpsko Orasje (BASOR)",
   label: "Srpsko Orasje (BASOR)"
  },
  {
   value: "Stijena (BASJA)",
   label: "Stijena (BASJA)"
  },
  {
   value: "Suha (BASUH)",
   label: "Suha (BASUH)"
  },
  {
   value: "Tesanj (BATSJ)",
   label: "Tesanj (BATSJ)"
  },
  {
   value: "Teslic (BATLC)",
   label: "Teslic (BATLC)"
  },
  {
   value: "Tihaljina (BATIH)",
   label: "Tihaljina (BATIH)"
  },
  {
   value: "Tomislavgrad (BATOM)",
   label: "Tomislavgrad (BATOM)"
  },
  {
   value: "Travnik (BATNK)",
   label: "Travnik (BATNK)"
  },
  {
   value: "Trebinje (BATBJ)",
   label: "Trebinje (BATBJ)"
  },
  {
   value: "Tuzla (BATZL)",
   label: "Tuzla (BATZL)"
  },
  {
   value: "Ugljevik (BAUJV)",
   label: "Ugljevik (BAUJV)"
  },
  {
   value: "Visoko (BAVIS)",
   label: "Visoko (BAVIS)"
  },
  {
   value: "Vitez (BAVIT)",
   label: "Vitez (BAVIT)"
  },
  {
   value: "Zavidovici (BAZAV)",
   label: "Zavidovici (BAZAV)"
  },
  {
   value: "Zenica (BAZCA)",
   label: "Zenica (BAZCA)"
  },
  {
   value: "Zepce (BAZEP)",
   label: "Zepce (BAZEP)"
  },
  {
   value: "Zvornik (BAZNK)",
   label: "Zvornik (BAZNK)"
  },
  {
   value: ".BARBADOS (BB)",
   label: ".BARBADOS (BB)"
  },
  {
   value: "Sam Lords Castle (BBSLC)",
   label: "Sam Lords Castle (BBSLC)"
  },
  {
   value: "St Michael (BBSTM)",
   label: "St Michael (BBSTM)"
  },
  {
   value: ".BANGLADESH (BD)",
   label: ".BANGLADESH (BD)"
  },
  {
   value: "Lukavac (BALKV)",
   label: "Lukavac (BALKV)"
  },
  {
   value: "Qaradag (AZQDG)",
   label: "Qaradag (AZQDG)"
  },
  {
   value: "Qazax (AZKAZ)",
   label: "Qazax (AZKAZ)"
  },
  {
   value: "Quba (AZQUB)",
   label: "Quba (AZQUB)"
  },
  {
   value: "Sangachal (AZSAN)",
   label: "Sangachal (AZSAN)"
  },
  {
   value: "Sumgait (AZSUM)",
   label: "Sumgait (AZSUM)"
  },
  {
   value: "Xirdalan (AZXIR)",
   label: "Xirdalan (AZXIR)"
  },
  {
   value: "Yalama (AZYAL)",
   label: "Yalama (AZYAL)"
  },
  {
   value: "Zaqatala (AZZAQ)",
   label: "Zaqatala (AZZAQ)"
  },
  {
   value: ".BOSNIA AND HERZEGOVINA (BA)",
   label: ".BOSNIA AND HERZEGOVINA (BA)"
  },
  {
   value: "Bihac (BABHC)",
   label: "Bihac (BABHC)"
  },
  {
   value: "Bijeljina (BABJA)",
   label: "Bijeljina (BABJA)"
  },
  {
   value: "Biracevac (BABIR)",
   label: "Biracevac (BABIR)"
  },
  {
   value: "Blazuj, Sarajevo (BABZJ)",
   label: "Blazuj, Sarajevo (BABZJ)"
  },
  {
   value: "Bosanska Krupa (BABKR)",
   label: "Bosanska Krupa (BABKR)"
  },
  {
   value: "Bosanski Brod (Srpski Brod) (BABBR)",
   label: "Bosanski Brod (Srpski Brod) (BABBR)"
  },
  {
   value: "Brcko (BABKO)",
   label: "Brcko (BABKO)"
  },
  {
   value: "Budinscina (BABUD)",
   label: "Budinscina (BABUD)"
  },
  {
   value: "Bugojno (BABUG)",
   label: "Bugojno (BABUG)"
  },
  {
   value: "Citluk (BACIT)",
   label: "Citluk (BACIT)"
  },
  {
   value: "Derventa (BADVA)",
   label: "Derventa (BADVA)"
  },
  {
   value: "Doboj (BADBJ)",
   label: "Doboj (BADBJ)"
  },
  {
   value: "Donji Vakuf (BADOV)",
   label: "Donji Vakuf (BADOV)"
  },
  {
   value: "Gorazde (BAGOZ)",
   label: "Gorazde (BAGOZ)"
  },
  {
   value: "Gradiska (BAGDA)",
   label: "Gradiska (BAGDA)"
  },
  {
   value: "Hadzici (BAHDC)",
   label: "Hadzici (BAHDC)"
  },
  {
   value: "Hresa (BAHRE)",
   label: "Hresa (BAHRE)"
  },
  {
   value: "Jajce (BAJAJ)",
   label: "Jajce (BAJAJ)"
  },
  {
   value: "Kalesija (BAKSA)",
   label: "Kalesija (BAKSA)"
  },
  {
   value: "Kiseljak (BAKJK)",
   label: "Kiseljak (BAKJK)"
  },
  {
   value: "Kljuc (BAKLJ)",
   label: "Kljuc (BAKLJ)"
  },
  {
   value: "Konjic (BAKJC)",
   label: "Konjic (BAKJC)"
  },
  {
   value: "Kresevo (BAKSO)",
   label: "Kresevo (BAKSO)"
  },
  {
   value: "Krupa na Uni (BAKNU)",
   label: "Krupa na Uni (BAKNU)"
  },
  {
   value: "Laktasi (BALTI)",
   label: "Laktasi (BALTI)"
  },
  {
   value: "Livno (BALVO)",
   label: "Livno (BALVO)"
  },
  {
   value: "Ljubuski (BALBS)",
   label: "Ljubuski (BALBS)"
  },
  {
   value: "Naxcivan (AZNAJ)",
   label: "Naxcivan (AZNAJ)"
  },
  {
   value: "Zistersdorf (ATZIS)",
   label: "Zistersdorf (ATZIS)"
  },
  {
   value: "Zobing (ATZNG)",
   label: "Zobing (ATZNG)"
  },
  {
   value: "Zwentendorf an der Donau (ATZDD)",
   label: "Zwentendorf an der Donau (ATZDD)"
  },
  {
   value: ".AUSTRALIA (AU)",
   label: ".AUSTRALIA (AU)"
  },
  {
   value: "Acacia Ridge (AUACA)",
   label: "Acacia Ridge (AUACA)"
  },
  {
   value: "Adelong (AUALO)",
   label: "Adelong (AUALO)"
  },
  {
   value: "Airlie Terminal (AUAIR)",
   label: "Airlie Terminal (AUAIR)"
  },
  {
   value: "Albion Park (AUAPK)",
   label: "Albion Park (AUAPK)"
  },
  {
   value: "Alexandria (AUALX)",
   label: "Alexandria (AUALX)"
  },
  {
   value: ".AZERBAIJAN (AZ)",
   label: ".AZERBAIJAN (AZ)"
  },
  {
   value: "Astara (AZAST)",
   label: "Astara (AZAST)"
  },
  {
   value: "Ganja (AZGAN)",
   label: "Ganja (AZGAN)"
  },
  {
   value: "Khachmaz (AZKMZ)",
   label: "Khachmaz (AZKMZ)"
  },
  {
   value: "Khanlar (AZKHA)",
   label: "Khanlar (AZKHA)"
  },
  {
   value: "Kirovabad (AZKBD)",
   label: "Kirovabad (AZKBD)"
  },
  {
   value: "Lankaran (AZLAN)",
   label: "Lankaran (AZLAN)"
  },
  {
   value: "Mingechaur (AZMGC)",
   label: "Mingechaur (AZMGC)"
  },
  {
   value: "Zirl (ATZIR)",
   label: "Zirl (ATZIR)"
  },
  {
   value: "Wildendürnbach (ATWDB)",
   label: "Wildendürnbach (ATWDB)"
  },
  {
   value: "Wildon (ATWDO)",
   label: "Wildon (ATWDO)"
  },
  {
   value: "Wildshut (ATWIH)",
   label: "Wildshut (ATWIH)"
  },
  {
   value: "Wilhelmsburg (ATWBU)",
   label: "Wilhelmsburg (ATWBU)"
  },
  {
   value: "Willendorf (ATWIF)",
   label: "Willendorf (ATWIF)"
  },
  {
   value: "Wimpassing an der Laitha (ATZAB)",
   label: "Wimpassing an der Laitha (ATZAB)"
  },
  {
   value: "Wimpassing im Schwarzatale (ATWSH)",
   label: "Wimpassing im Schwarzatale (ATWSH)"
  },
  {
   value: "Winkel (ATOCW)",
   label: "Winkel (ATOCW)"
  },
  {
   value: "Wolfern (ATWLN)",
   label: "Wolfern (ATWLN)"
  },
  {
   value: "Wolfsberg (Kärnten) (ATWOF)",
   label: "Wolfsberg (Kärnten) (ATWOF)"
  },
  {
   value: "Wolfsberg im Schwarzautal (ATWIS)",
   label: "Wolfsberg im Schwarzautal (ATWIS)"
  },
  {
   value: "Wolfurt (ATWFT)",
   label: "Wolfurt (ATWFT)"
  },
  {
   value: "Wolkersdorf (ATWWT)",
   label: "Wolkersdorf (ATWWT)"
  },
  {
   value: "Wöllersdorf (ATWSD)",
   label: "Wöllersdorf (ATWSD)"
  },
  {
   value: "Wöllersdorf-Steinabrückl (ATWLL)",
   label: "Wöllersdorf-Steinabrückl (ATWLL)"
  },
  {
   value: "Wörgl (ATQXZ)",
   label: "Wörgl (ATQXZ)"
  },
  {
   value: "Worterberg (ATWTB)",
   label: "Worterberg (ATWTB)"
  },
  {
   value: "Wösendorf (ATWOS)",
   label: "Wösendorf (ATWOS)"
  },
  {
   value: "Wultendorf (ATNRF)",
   label: "Wultendorf (ATNRF)"
  },
  {
   value: "Ybbs an der Donau (ATYBB)",
   label: "Ybbs an der Donau (ATYBB)"
  },
  {
   value: "Zams (ATZAM)",
   label: "Zams (ATZAM)"
  },
  {
   value: "Zell am Moos (ATZMO)",
   label: "Zell am Moos (ATZMO)"
  },
  {
   value: "Zell am Pettenfirst (ATZPE)",
   label: "Zell am Pettenfirst (ATZPE)"
  },
  {
   value: "Zell am See (ATZAS)",
   label: "Zell am See (ATZAS)"
  },
  {
   value: "Zell am Ziller (ATZEZ)",
   label: "Zell am Ziller (ATZEZ)"
  },
  {
   value: "Zeltweg (ATZTW)",
   label: "Zeltweg (ATZTW)"
  },
  {
   value: "Zemendorf (ATZMD)",
   label: "Zemendorf (ATZMD)"
  },
  {
   value: "Zettling (ATZTG)",
   label: "Zettling (ATZTG)"
  },
  {
   value: "Ziersdorf (ATZIE)",
   label: "Ziersdorf (ATZIE)"
  },
  {
   value: "Zipf (ATZIP)",
   label: "Zipf (ATZIP)"
  },
  {
   value: "Waidhofen an der Thaya (ATWAI)",
   label: "Waidhofen an der Thaya (ATWAI)"
  },
  {
   value: "Waidhofen an der Ybbs (ATWAF)",
   label: "Waidhofen an der Ybbs (ATWAF)"
  },
  {
   value: "Waldbach (ATWCH)",
   label: "Waldbach (ATWCH)"
  },
  {
   value: "Waldburg bei Freistadt (ATWBF)",
   label: "Waldburg bei Freistadt (ATWBF)"
  },
  {
   value: "Waldegg (ATWDG)",
   label: "Waldegg (ATWDG)"
  },
  {
   value: "Waldneukirchen (ATWKH)",
   label: "Waldneukirchen (ATWKH)"
  },
  {
   value: "Walkenstein (ATWIN)",
   label: "Walkenstein (ATWIN)"
  },
  {
   value: "Wallsee (ATWSE)",
   label: "Wallsee (ATWSE)"
  },
  {
   value: "Wals (ATWAL)",
   label: "Wals (ATWAL)"
  },
  {
   value: "Warth (ATWAR)",
   label: "Warth (ATWAR)"
  },
  {
   value: "Weer (ATTWR)",
   label: "Weer (ATTWR)"
  },
  {
   value: "Weikersdorf am Steinfelde (ATWAS)",
   label: "Weikersdorf am Steinfelde (ATWAS)"
  },
  {
   value: "Weilbach (ATWBH)",
   label: "Weilbach (ATWBH)"
  },
  {
   value: "Weinburg (ATWEU)",
   label: "Weinburg (ATWEU)"
  },
  {
   value: "Weissenbach (ATWEI)",
   label: "Weissenbach (ATWEI)"
  },
  {
   value: "Weissenbach an der Triesting (ATWEE)",
   label: "Weissenbach an der Triesting (ATWEE)"
  },
  {
   value: "Weissenkirchen im Attergau (ATWNK)",
   label: "Weissenkirchen im Attergau (ATWNK)"
  },
  {
   value: "Weissenstein ob der Drau (ATWDD)",
   label: "Weissenstein ob der Drau (ATWDD)"
  },
  {
   value: "Weisskirchen (ATWKI)",
   label: "Weisskirchen (ATWKI)"
  },
  {
   value: "Weisskirchen an der Traun (ATWSK)",
   label: "Weisskirchen an der Traun (ATWSK)"
  },
  {
   value: "Weitenegg (ATWTG)",
   label: "Weitenegg (ATWTG)"
  },
  {
   value: "Weiz (ATWEZ)",
   label: "Weiz (ATWEZ)"
  },
  {
   value: "Weng im Innkreis (ATWGI)",
   label: "Weng im Innkreis (ATWGI)"
  },
  {
   value: "Werfen (ATWFN)",
   label: "Werfen (ATWFN)"
  },
  {
   value: "Werndorf (ATWER)",
   label: "Werndorf (ATWER)"
  },
  {
   value: "Wernersdorf (ATWNO)",
   label: "Wernersdorf (ATWNO)"
  },
  {
   value: "Wesenufer (ATWUF)",
   label: "Wesenufer (ATWUF)"
  },
  {
   value: "Vosendorf Sud (ATVDS)",
   label: "Vosendorf Sud (ATVDS)"
  },
  {
   value: "Trausdorf an der Wulka (ATTDW)",
   label: "Trausdorf an der Wulka (ATTDW)"
  },
  {
   value: "Treffen (ATTFN)",
   label: "Treffen (ATTFN)"
  },
  {
   value: "Treibach Althofen (ATTPV)",
   label: "Treibach Althofen (ATTPV)"
  },
  {
   value: "Trieben (ATTBE)",
   label: "Trieben (ATTBE)"
  },
  {
   value: "Trumau (ATTRU)",
   label: "Trumau (ATTRU)"
  },
  {
   value: "Tumeltsham (ATTLH)",
   label: "Tumeltsham (ATTLH)"
  },
  {
   value: "Türnitz (ATTUE)",
   label: "Türnitz (ATTUE)"
  },
  {
   value: "Ubelbach (ATUBA)",
   label: "Ubelbach (ATUBA)"
  },
  {
   value: "Uderns (ATUDE)",
   label: "Uderns (ATUDE)"
  },
  {
   value: "Unterach (ATUNA)",
   label: "Unterach (ATUNA)"
  },
  {
   value: "Unterloiben (ATULB)",
   label: "Unterloiben (ATULB)"
  },
  {
   value: "Unternberg (ATUBG)",
   label: "Unternberg (ATUBG)"
  },
  {
   value: "Unterpremstätten (ATUPS)",
   label: "Unterpremstätten (ATUPS)"
  },
  {
   value: "Unterradlberg (ATURB)",
   label: "Unterradlberg (ATURB)"
  },
  {
   value: "Unterweitersdorf (ATUWF)",
   label: "Unterweitersdorf (ATUWF)"
  },
  {
   value: "Unzmarkt (ATUNZ)",
   label: "Unzmarkt (ATUNZ)"
  },
  {
   value: "Utzenaich (ATUTZ)",
   label: "Utzenaich (ATUTZ)"
  },
  {
   value: "Veitsch (ATVTH)",
   label: "Veitsch (ATVTH)"
  },
  {
   value: "Velden (ATVEL)",
   label: "Velden (ATVEL)"
  },
  {
   value: "Vienna = Wien (AT)",
   label: "Vienna = Wien (AT)"
  },
  {
   value: "Vöcklabruck (ATVOC)",
   label: "Vöcklabruck (ATVOC)"
  },
  {
   value: "Vöcklamarkt (ATVOK)",
   label: "Vöcklamarkt (ATVOK)"
  },
  {
   value: "Völkermarkt (ATVOT)",
   label: "Völkermarkt (ATVOT)"
  },
  {
   value: "Vomp (ATVMP)",
   label: "Vomp (ATVMP)"
  },
  {
   value: "Vorchdorf (ATVCO)",
   label: "Vorchdorf (ATVCO)"
  },
  {
   value: "Vösendorf (ATVOF)",
   label: "Vösendorf (ATVOF)"
  },
  {
   value: "Steinfeld (ATSTE)",
   label: "Steinfeld (ATSTE)"
  },
  {
   value: "Steyregg (ATSYG)",
   label: "Steyregg (ATSYG)"
  },
  {
   value: "Stixneusiedl (ATSND)",
   label: "Stixneusiedl (ATSND)"
  },
  {
   value: "Strasshof an der Nordbahn (ATSHF)",
   label: "Strasshof an der Nordbahn (ATSHF)"
  },
  {
   value: "Strasswalchen (ATSWN)",
   label: "Strasswalchen (ATSWN)"
  },
  {
   value: "Stronsdorf (ATNIS)",
   label: "Stronsdorf (ATNIS)"
  },
  {
   value: "Suben (ATSUB)",
   label: "Suben (ATSUB)"
  },
  {
   value: "Taiskirchen im Innskreis (ATTKI)",
   label: "Taiskirchen im Innskreis (ATTKI)"
  },
  {
   value: "Tamsweg (ATTAM)",
   label: "Tamsweg (ATTAM)"
  },
  {
   value: "Tattendorf (ATTAT)",
   label: "Tattendorf (ATTAT)"
  },
  {
   value: "Taufkirchen an der Pram (ATTKP)",
   label: "Taufkirchen an der Pram (ATTKP)"
  },
  {
   value: "Teesdorf (ATTEF)",
   label: "Teesdorf (ATTEF)"
  },
  {
   value: "Tenneck (ATTEC)",
   label: "Tenneck (ATTEC)"
  },
  {
   value: "Terfens (ATTFS)",
   label: "Terfens (ATTFS)"
  },
  {
   value: "Ternberg (ATTNG)",
   label: "Ternberg (ATTNG)"
  },
  {
   value: "Teufenbach (ATTEU)",
   label: "Teufenbach (ATTEU)"
  },
  {
   value: "Texing (ATTEX)",
   label: "Texing (ATTEX)"
  },
  {
   value: "Thalgau (ATTGU)",
   label: "Thalgau (ATTGU)"
  },
  {
   value: "Thalheim (ATTHM)",
   label: "Thalheim (ATTHM)"
  },
  {
   value: "Thalheim bei Wels (ATTBW)",
   label: "Thalheim bei Wels (ATTBW)"
  },
  {
   value: "Thaur (ATTHR)",
   label: "Thaur (ATTHR)"
  },
  {
   value: "Theiss (ATTHS)",
   label: "Theiss (ATTHS)"
  },
  {
   value: "Thening (ATTHG)",
   label: "Thening (ATTHG)"
  },
  {
   value: "Theresienfeld (ATTHF)",
   label: "Theresienfeld (ATTHF)"
  },
  {
   value: "Thüringen (ATTHN)",
   label: "Thüringen (ATTHN)"
  },
  {
   value: "Timelkam (ATTMA)",
   label: "Timelkam (ATTMA)"
  },
  {
   value: "Traisen (ATTIS)",
   label: "Traisen (ATTIS)"
  },
  {
   value: "Steinbrunn (ATSUP)",
   label: "Steinbrunn (ATSUP)"
  },
  {
   value: "Traismauer (ATTMR)",
   label: "Traismauer (ATTMR)"
  },
  {
   value: "Söding (ATSNG)",
   label: "Söding (ATSNG)"
  },
  {
   value: "Sölden (ATSDN)",
   label: "Sölden (ATSDN)"
  },
  {
   value: "Söll (ATSOL)",
   label: "Söll (ATSOL)"
  },
  {
   value: "Sooss (ATSOS)",
   label: "Sooss (ATSOS)"
  },
  {
   value: "Spielberg bei Knittelfeld (ATSBK)",
   label: "Spielberg bei Knittelfeld (ATSBK)"
  },
  {
   value: "Spielfeld (ATSFD)",
   label: "Spielfeld (ATSFD)"
  },
  {
   value: "Spitz (ATSPZ)",
   label: "Spitz (ATSPZ)"
  },
  {
   value: "St Aegyd am Neuwalde (ATAED)",
   label: "St Aegyd am Neuwalde (ATAED)"
  },
  {
   value: "St Johann im Pongau (ATJOA)",
   label: "St Johann im Pongau (ATJOA)"
  },
  {
   value: "St Johann in Tirol (ATJOH)",
   label: "St Johann in Tirol (ATJOH)"
  },
  {
   value: "St Martin bei Linz (ATSMN)",
   label: "St Martin bei Linz (ATSMN)"
  },
  {
   value: "St Michael in Obersteiermark (ATSMI)",
   label: "St Michael in Obersteiermark (ATSMI)"
  },
  {
   value: "St Paul im Levanttal (ATSLV)",
   label: "St Paul im Levanttal (ATSLV)"
  },
  {
   value: "St Stefan im Lavanttal (ATSFS)",
   label: "St Stefan im Lavanttal (ATSFS)"
  },
  {
   value: "St Veit an der Glan (ATSVG)",
   label: "St Veit an der Glan (ATSVG)"
  },
  {
   value: "St Veit an der Gölsen (ATSVO)",
   label: "St Veit an der Gölsen (ATSVO)"
  },
  {
   value: "Stadl Paura (ATSPU)",
   label: "Stadl Paura (ATSPU)"
  },
  {
   value: "Stams (ATSTM)",
   label: "Stams (ATSTM)"
  },
  {
   value: "Stang (ATANG)",
   label: "Stang (ATANG)"
  },
  {
   value: "Steeg (ATSTD)",
   label: "Steeg (ATSTD)"
  },
  {
   value: "Stegersbach (ATSTB)",
   label: "Stegersbach (ATSTB)"
  },
  {
   value: "Steinach (ATSTH)",
   label: "Steinach (ATSTH)"
  },
  {
   value: "Steinberg (ATSSS)",
   label: "Steinberg (ATSSS)"
  },
  {
   value: "Sittersdorf (ATSIT)",
   label: "Sittersdorf (ATSIT)"
  },
  {
   value: "Sankt Veit an der Glan (ATKSV)",
   label: "Sankt Veit an der Glan (ATKSV)"
  },
  {
   value: "Sattledt (ATSUN)",
   label: "Sattledt (ATSUN)"
  },
  {
   value: "Schärding (ATSDG)",
   label: "Schärding (ATSDG)"
  },
  {
   value: "Scharnstein (ATSSI)",
   label: "Scharnstein (ATSSI)"
  },
  {
   value: "Scheibbs (ATSBB)",
   label: "Scheibbs (ATSBB)"
  },
  {
   value: "Schneegattern (ATSGN)",
   label: "Schneegattern (ATSGN)"
  },
  {
   value: "Schönau an der Triesting (ATSAT)",
   label: "Schönau an der Triesting (ATSAT)"
  },
  {
   value: "Schönbach (ATSBH)",
   label: "Schönbach (ATSBH)"
  },
  {
   value: "Schönegg (ATSHG)",
   label: "Schönegg (ATSHG)"
  },
  {
   value: "Schorfling am Attersee (ATSFA)",
   label: "Schorfling am Attersee (ATSFA)"
  },
  {
   value: "Schrattenberg (ATSCG)",
   label: "Schrattenberg (ATSCG)"
  },
  {
   value: "Schrems (ATSRM)",
   label: "Schrems (ATSRM)"
  },
  {
   value: "Schruns (ATSHS)",
   label: "Schruns (ATSHS)"
  },
  {
   value: "Schwanberg (ATSWB)",
   label: "Schwanberg (ATSWB)"
  },
  {
   value: "Schwarzach im Pongau (ATSIP)",
   label: "Schwarzach im Pongau (ATSIP)"
  },
  {
   value: "Schwarzau im Gebirge (ATSIG)",
   label: "Schwarzau im Gebirge (ATSIG)"
  },
  {
   value: "Seeboden (ATSEB)",
   label: "Seeboden (ATSEB)"
  },
  {
   value: "Seefeld in Tirol (ATSEE)",
   label: "Seefeld in Tirol (ATSEE)"
  },
  {
   value: "Seefeld-Kadolz (ATSEF)",
   label: "Seefeld-Kadolz (ATSEF)"
  },
  {
   value: "Seekirchen (ATSIR)",
   label: "Seekirchen (ATSIR)"
  },
  {
   value: "Seibersdorf (ATSEI)",
   label: "Seibersdorf (ATSEI)"
  },
  {
   value: "Seiersberg (ATSSB)",
   label: "Seiersberg (ATSSB)"
  },
  {
   value: "Seitenstetten Markt (ATSET)",
   label: "Seitenstetten Markt (ATSET)"
  },
  {
   value: "Selzthal (ATSZA)",
   label: "Selzthal (ATSZA)"
  },
  {
   value: "Siegendorf (ATSIF)",
   label: "Siegendorf (ATSIF)"
  },
  {
   value: "Sierninghofen (ATSII)",
   label: "Sierninghofen (ATSII)"
  },
  {
   value: "Siezenheim (ATZNH)",
   label: "Siezenheim (ATZNH)"
  },
  {
   value: "Sillian (ATSIN)",
   label: "Sillian (ATSIN)"
  },
  {
   value: "Sinabelkirchen (ATSKN)",
   label: "Sinabelkirchen (ATSKN)"
  },
  {
   value: "Sankt Veit am Vogau (ATSVV)",
   label: "Sankt Veit am Vogau (ATSVV)"
  },
  {
   value: "Rosenau (ATRNA)",
   label: "Rosenau (ATRNA)"
  },
  {
   value: "Rosenbach (ATROS)",
   label: "Rosenbach (ATROS)"
  },
  {
   value: "Rosenburg (ATRSU)",
   label: "Rosenburg (ATRSU)"
  },
  {
   value: "Rotenturm an der Pinka (ATRTM)",
   label: "Rotenturm an der Pinka (ATRTM)"
  },
  {
   value: "Rum (ATRUM)",
   label: "Rum (ATRUM)"
  },
  {
   value: "Rust (ATRUS)",
   label: "Rust (ATRUS)"
  },
  {
   value: "Saalfelden am Steinernen Meer (ATSSM)",
   label: "Saalfelden am Steinernen Meer (ATSSM)"
  },
  {
   value: "Sankt Andrä (ATARV)",
   label: "Sankt Andrä (ATARV)"
  },
  {
   value: "Sankt Florian (ATSFL)",
   label: "Sankt Florian (ATSFL)"
  },
  {
   value: "Sankt Georgen (ATSGG)",
   label: "Sankt Georgen (ATSGG)"
  },
  {
   value: "Sankt Georgen am Steinfelden (ATSGF)",
   label: "Sankt Georgen am Steinfelden (ATSGF)"
  },
  {
   value: "Sankt Georgen bei Salzburg (ATSGS)",
   label: "Sankt Georgen bei Salzburg (ATSGS)"
  },
  {
   value: "Sankt Georgen im Attergau (ATSGA)",
   label: "Sankt Georgen im Attergau (ATSGA)"
  },
  {
   value: "Sankt Gertraud (ATSTG)",
   label: "Sankt Gertraud (ATSTG)"
  },
  {
   value: "Sankt Jakob (ATSJK)",
   label: "Sankt Jakob (ATSJK)"
  },
  {
   value: "Sankt Jakob in Defereggen (ATSJD)",
   label: "Sankt Jakob in Defereggen (ATSJD)"
  },
  {
   value: "Sankt Kanzian am Klopeiner See (ATSKK)",
   label: "Sankt Kanzian am Klopeiner See (ATSKK)"
  },
  {
   value: "Sankt Katharein an der Laming (ATKLG)",
   label: "Sankt Katharein an der Laming (ATKLG)"
  },
  {
   value: "Sankt Lorenzen im Mürztal (ATLMU)",
   label: "Sankt Lorenzen im Mürztal (ATLMU)"
  },
  {
   value: "Sankt Marein im Mürztal (ATMMZ)",
   label: "Sankt Marein im Mürztal (ATMMZ)"
  },
  {
   value: "Sankt Marien (ATSMA)",
   label: "Sankt Marien (ATSMA)"
  },
  {
   value: "Sankt Martin im Innkreis (ATMTI)",
   label: "Sankt Martin im Innkreis (ATMTI)"
  },
  {
   value: "Sankt Martin im Mühlkreis (ATSMM)",
   label: "Sankt Martin im Mühlkreis (ATSMM)"
  },
  {
   value: "Sankt Michael (ATSKM)",
   label: "Sankt Michael (ATSKM)"
  },
  {
   value: "Sankt Michael im Lungau (ATSEL)",
   label: "Sankt Michael im Lungau (ATSEL)"
  },
  {
   value: "Sankt Poelten (ATPLT)",
   label: "Sankt Poelten (ATPLT)"
  },
  {
   value: "Sankt Ruprecht an der Raab (ATRRA)",
   label: "Sankt Ruprecht an der Raab (ATRRA)"
  },
  {
   value: "Sankt Stefan ob Leoben (ATSSO)",
   label: "Sankt Stefan ob Leoben (ATSSO)"
  },
  {
   value: "Röschitz (ATRST)",
   label: "Röschitz (ATRST)"
  },
  {
   value: "Pregarten (ATPGN)",
   label: "Pregarten (ATPGN)"
  },
  {
   value: "Prottes (ATPOT)",
   label: "Prottes (ATPOT)"
  },
  {
   value: "Puch (ATPUC)",
   label: "Puch (ATPUC)"
  },
  {
   value: "Pucking (ATPKG)",
   label: "Pucking (ATPKG)"
  },
  {
   value: "Purgstall (ATPUR)",
   label: "Purgstall (ATPUR)"
  },
  {
   value: "Purgstall an der Erlauf (ATPLE)",
   label: "Purgstall an der Erlauf (ATPLE)"
  },
  {
   value: "Purkersdorf (ATPUF)",
   label: "Purkersdorf (ATPUF)"
  },
  {
   value: "Raaba (ATRBA)",
   label: "Raaba (ATRBA)"
  },
  {
   value: "Raasdorf (ATRAA)",
   label: "Raasdorf (ATRAA)"
  },
  {
   value: "Radenthein (ATRDN)",
   label: "Radenthein (ATRDN)"
  },
  {
   value: "Radfeld (ATRFD)",
   label: "Radfeld (ATRFD)"
  },
  {
   value: "Radstadt (ATRAD)",
   label: "Radstadt (ATRAD)"
  },
  {
   value: "Raggendorf (ATRGF)",
   label: "Raggendorf (ATRGF)"
  },
  {
   value: "Ranshofen (ATRHN)",
   label: "Ranshofen (ATRHN)"
  },
  {
   value: "Rastenfeld (ATRAS)",
   label: "Rastenfeld (ATRAS)"
  },
  {
   value: "Ratsch an der Weinstrasse (ATRDW)",
   label: "Ratsch an der Weinstrasse (ATRDW)"
  },
  {
   value: "Reichersberg (ATREI)",
   label: "Reichersberg (ATREI)"
  },
  {
   value: "Reichersdorf (ATRSD)",
   label: "Reichersdorf (ATRSD)"
  },
  {
   value: "Reinsberg (ATRSB)",
   label: "Reinsberg (ATRSB)"
  },
  {
   value: "Retz (ATRTZ)",
   label: "Retz (ATRTZ)"
  },
  {
   value: "Reuthe (ATREU)",
   label: "Reuthe (ATREU)"
  },
  {
   value: "Reutte (ATRTE)",
   label: "Reutte (ATRTE)"
  },
  {
   value: "Ried im Innkreis (ATRIK)",
   label: "Ried im Innkreis (ATRIK)"
  },
  {
   value: "Ried Im Traunkreis (ATRIT)",
   label: "Ried Im Traunkreis (ATRIT)"
  },
  {
   value: "Riedlingsdorf (ATRLD)",
   label: "Riedlingsdorf (ATRLD)"
  },
  {
   value: "Riegersburg (ATRBG)",
   label: "Riegersburg (ATRBG)"
  },
  {
   value: "Riegersdorf (ATKAT)",
   label: "Riegersdorf (ATKAT)"
  },
  {
   value: "Rohrbach bei Mattersburg (ATRBM)",
   label: "Rohrbach bei Mattersburg (ATRBM)"
  },
  {
   value: "Rohrendorf bei Krems (ATRDF)",
   label: "Rohrendorf bei Krems (ATRDF)"
  },
  {
   value: "Roitham (ATROI)",
   label: "Roitham (ATROI)"
  },
  {
   value: "Preding (ATPDG)",
   label: "Preding (ATPDG)"
  },
  {
   value: "Orth an der Donau (ATOAD)",
   label: "Orth an der Donau (ATOAD)"
  },
  {
   value: "Ortmann (ATORT)",
   label: "Ortmann (ATORT)"
  },
  {
   value: "Ottensheim (ATOSH)",
   label: "Ottensheim (ATOSH)"
  },
  {
   value: "Oyenhausen (ATOYH)",
   label: "Oyenhausen (ATOYH)"
  },
  {
   value: "Pamhagen (ATPAM)",
   label: "Pamhagen (ATPAM)"
  },
  {
   value: "Peggau (ATPEG)",
   label: "Peggau (ATPEG)"
  },
  {
   value: "Pernegg an der Mur (ATPGM)",
   label: "Pernegg an der Mur (ATPGM)"
  },
  {
   value: "Pernitz (ATPNT)",
   label: "Pernitz (ATPNT)"
  },
  {
   value: "Persenbeug (ATPBU)",
   label: "Persenbeug (ATPBU)"
  },
  {
   value: "Pettenbach (ATPEB)",
   label: "Pettenbach (ATPEB)"
  },
  {
   value: "Peuerbach (ATPRB)",
   label: "Peuerbach (ATPRB)"
  },
  {
   value: "Pfaffenhofen (ATPFF)",
   label: "Pfaffenhofen (ATPFF)"
  },
  {
   value: "Pichl bei Wels (ATPWE)",
   label: "Pichl bei Wels (ATPWE)"
  },
  {
   value: "Piesendorf (ATPND)",
   label: "Piesendorf (ATPND)"
  },
  {
   value: "Pill (ATPLL)",
   label: "Pill (ATPLL)"
  },
  {
   value: "Pinggau (ATPGG)",
   label: "Pinggau (ATPGG)"
  },
  {
   value: "Pinkafeld (ATPFD)",
   label: "Pinkafeld (ATPFD)"
  },
  {
   value: "Pinsdorf (ATPOF)",
   label: "Pinsdorf (ATPOF)"
  },
  {
   value: "Pischeldorf (ATPIS)",
   label: "Pischeldorf (ATPIS)"
  },
  {
   value: "Pischelsdorf (ATPRF)",
   label: "Pischelsdorf (ATPRF)"
  },
  {
   value: "Pistorf (ATPST)",
   label: "Pistorf (ATPST)"
  },
  {
   value: "Plainfeld (ATPID)",
   label: "Plainfeld (ATPID)"
  },
  {
   value: "Pöchlarn (ATPOE)",
   label: "Pöchlarn (ATPOE)"
  },
  {
   value: "Podersdorf am See (ATPAS)",
   label: "Podersdorf am See (ATPAS)"
  },
  {
   value: "Poggersdorf (ATPGO)",
   label: "Poggersdorf (ATPGO)"
  },
  {
   value: "Pöls (ATPLS)",
   label: "Pöls (ATPLS)"
  },
  {
   value: "Pöttelsdorf (ATPDO)",
   label: "Pöttelsdorf (ATPDO)"
  },
  {
   value: "Poysdorf (ATPOY)",
   label: "Poysdorf (ATPOY)"
  },
  {
   value: "Pram (ATPRM)",
   label: "Pram (ATPRM)"
  },
  {
   value: "Pramet (ATPRA)",
   label: "Pramet (ATPRA)"
  },
  {
   value: "Ort im Innkreis (ATOIN)",
   label: "Ort im Innkreis (ATOIN)"
  },
  {
   value: "Neumarkt am Wallersee (ATNWS)",
   label: "Neumarkt am Wallersee (ATNWS)"
  },
  {
   value: "Neumarkt im Hausruckkreis (ATNHR)",
   label: "Neumarkt im Hausruckkreis (ATNHR)"
  },
  {
   value: "Neunkirchen (ATNKN)",
   label: "Neunkirchen (ATNKN)"
  },
  {
   value: "Neusiedl (ATNES)",
   label: "Neusiedl (ATNES)"
  },
  {
   value: "Neutal (ATNTA)",
   label: "Neutal (ATNTA)"
  },
  {
   value: "Neuzeug (ATNZG)",
   label: "Neuzeug (ATNZG)"
  },
  {
   value: "Niedernsill (ATNSL)",
   label: "Niedernsill (ATNSL)"
  },
  {
   value: "Niederottnang (ATNIE)",
   label: "Niederottnang (ATNIE)"
  },
  {
   value: "Niederwaldkirchen (ATNWK)",
   label: "Niederwaldkirchen (ATNWK)"
  },
  {
   value: "Niederwölz (ATNIW)",
   label: "Niederwölz (ATNIW)"
  },
  {
   value: "Niklasdorf (ATNKD)",
   label: "Niklasdorf (ATNKD)"
  },
  {
   value: "Nussbach (ATNBA)",
   label: "Nussbach (ATNBA)"
  },
  {
   value: "Nussdorf (ATNSD)",
   label: "Nussdorf (ATNSD)"
  },
  {
   value: "Nussdorf am Haunsberg (ATNAH)",
   label: "Nussdorf am Haunsberg (ATNAH)"
  },
  {
   value: "Nussdorf an der Traisen (ATNAT)",
   label: "Nussdorf an der Traisen (ATNAT)"
  },
  {
   value: "Nüziders (ATNUZ)",
   label: "Nüziders (ATNUZ)"
  },
  {
   value: "Oberaich (ATORH)",
   label: "Oberaich (ATORH)"
  },
  {
   value: "Obergrafendorf (ATOBG)",
   label: "Obergrafendorf (ATOBG)"
  },
  {
   value: "Oberlamm (ATLAM)",
   label: "Oberlamm (ATLAM)"
  },
  {
   value: "Oberndorf bei Salzburg (ATOBR)",
   label: "Oberndorf bei Salzburg (ATOBR)"
  },
  {
   value: "Oberneukirchen (ATOBU)",
   label: "Oberneukirchen (ATOBU)"
  },
  {
   value: "Oberpullendorf (ATOBE)",
   label: "Oberpullendorf (ATOBE)"
  },
  {
   value: "Oberschützen (ATOSZ)",
   label: "Oberschützen (ATOSZ)"
  },
  {
   value: "Oberstrahlbach (ATOBH)",
   label: "Oberstrahlbach (ATOBH)"
  },
  {
   value: "Obertraun (ATOTN)",
   label: "Obertraun (ATOTN)"
  },
  {
   value: "Obertrum am See (ATVTD)",
   label: "Obertrum am See (ATVTD)"
  },
  {
   value: "Oberwaltersdorf (ATOWD)",
   label: "Oberwaltersdorf (ATOWD)"
  },
  {
   value: "Oberweis (ATOBW)",
   label: "Oberweis (ATOBW)"
  },
  {
   value: "Oed (ATOED)",
   label: "Oed (ATOED)"
  },
  {
   value: "Oftering (ATORI)",
   label: "Oftering (ATORI)"
  },
  {
   value: "Ohlsdorf (ATOLS)",
   label: "Ohlsdorf (ATOLS)"
  },
  {
   value: "Neulengbach (ATNEH)",
   label: "Neulengbach (ATNEH)"
  },
  {
   value: "Micheldorf in Kärnten (ATMIF)",
   label: "Micheldorf in Kärnten (ATMIF)"
  },
  {
   value: "Micheldorf in Oberösterreich (ATMCD)",
   label: "Micheldorf in Oberösterreich (ATMCD)"
  },
  {
   value: "Mistelbach (ATMIS)",
   label: "Mistelbach (ATMIS)"
  },
  {
   value: "Mitterkirchen (ATMKC)",
   label: "Mitterkirchen (ATMKC)"
  },
  {
   value: "Mixnitz (ATMIX)",
   label: "Mixnitz (ATMIX)"
  },
  {
   value: "Möderbrugg (ATMBG)",
   label: "Möderbrugg (ATMBG)"
  },
  {
   value: "Mödling (ATMOE)",
   label: "Mödling (ATMOE)"
  },
  {
   value: "Mollersdorf, Baden (ATMLD)",
   label: "Mollersdorf, Baden (ATMLD)"
  },
  {
   value: "Mollersdorf, Tull an der Donau (ATMDF)",
   label: "Mollersdorf, Tull an der Donau (ATMDF)"
  },
  {
   value: "Molln (ATOLL)",
   label: "Molln (ATOLL)"
  },
  {
   value: "Mönchhof (ATMHF)",
   label: "Mönchhof (ATMHF)"
  },
  {
   value: "Mondsee (ATMON)",
   label: "Mondsee (ATMON)"
  },
  {
   value: "Moosbrunn (ATMOO)",
   label: "Moosbrunn (ATMOO)"
  },
  {
   value: "Müllendorf (ATMNO)",
   label: "Müllendorf (ATMNO)"
  },
  {
   value: "Münchendorf (ATMUE)",
   label: "Münchendorf (ATMUE)"
  },
  {
   value: "Munderfing (ATMDG)",
   label: "Munderfing (ATMDG)"
  },
  {
   value: "Münichreith (ATMHE)",
   label: "Münichreith (ATMHE)"
  },
  {
   value: "Münzbach (ATMZH)",
   label: "Münzbach (ATMZH)"
  },
  {
   value: "Murau (ATMUR)",
   label: "Murau (ATMUR)"
  },
  {
   value: "Mureck (ATMUC)",
   label: "Mureck (ATMUC)"
  },
  {
   value: "Naarn (ATNAA)",
   label: "Naarn (ATNAA)"
  },
  {
   value: "Neckenmarkt (ATNEC)",
   label: "Neckenmarkt (ATNEC)"
  },
  {
   value: "Nenzing (ATNEZ)",
   label: "Nenzing (ATNEZ)"
  },
  {
   value: "Nestelbach bei Graz (ATNGZ)",
   label: "Nestelbach bei Graz (ATNGZ)"
  },
  {
   value: "Neubau (ATNEU)",
   label: "Neubau (ATNEU)"
  },
  {
   value: "Neudörfl (ATNEL)",
   label: "Neudörfl (ATNEL)"
  },
  {
   value: "Neufeld an der Leitha (ATNUF)",
   label: "Neufeld an der Leitha (ATNUF)"
  },
  {
   value: "Neufelden (ATNFN)",
   label: "Neufelden (ATNFN)"
  },
  {
   value: "Neuhofen an der Krems (ATNEK)",
   label: "Neuhofen an der Krems (ATNEK)"
  },
  {
   value: "Mettersdorf Am Sassbach (ATMSB)",
   label: "Mettersdorf Am Sassbach (ATMSB)"
  },
  {
   value: "Lochen (ATLCH)",
   label: "Lochen (ATLCH)"
  },
  {
   value: "Lohnsburg (ATLOB)",
   label: "Lohnsburg (ATLOB)"
  },
  {
   value: "Loimersdorf (ATLOI)",
   label: "Loimersdorf (ATLOI)"
  },
  {
   value: "Loipersbach (ATLPB)",
   label: "Loipersbach (ATLPB)"
  },
  {
   value: "Loosdorf (ATLSD)",
   label: "Loosdorf (ATLSD)"
  },
  {
   value: "Ludesch (ATDSH)",
   label: "Ludesch (ATDSH)"
  },
  {
   value: "Mandling (ATMNG)",
   label: "Mandling (ATMNG)"
  },
  {
   value: "Marchtrenk (ATMRC)",
   label: "Marchtrenk (ATMRC)"
  },
  {
   value: "Margarethen am Moos (ATMAM)",
   label: "Margarethen am Moos (ATMAM)"
  },
  {
   value: "Maria Laach am Jauerling (ATMLJ)",
   label: "Maria Laach am Jauerling (ATMLJ)"
  },
  {
   value: "Maria Lanzendorf (ATZEN)",
   label: "Maria Lanzendorf (ATZEN)"
  },
  {
   value: "Mariasdorf (ATMDO)",
   label: "Mariasdorf (ATMDO)"
  },
  {
   value: "Mariazell (ATMZL)",
   label: "Mariazell (ATMZL)"
  },
  {
   value: "Markgrafneusiedl (ATMGL)",
   label: "Markgrafneusiedl (ATMGL)"
  },
  {
   value: "Markt Piesting (ATMPI)",
   label: "Markt Piesting (ATMPI)"
  },
  {
   value: "Marktl (ATMAR)",
   label: "Marktl (ATMAR)"
  },
  {
   value: "Marz (ATMRZ)",
   label: "Marz (ATMRZ)"
  },
  {
   value: "Matrei am Brenner (ATMBR)",
   label: "Matrei am Brenner (ATMBR)"
  },
  {
   value: "Mattersburg (ATMAT)",
   label: "Mattersburg (ATMAT)"
  },
  {
   value: "Mattsee (ATMTS)",
   label: "Mattsee (ATMTS)"
  },
  {
   value: "Mauerbach (ATMBH)",
   label: "Mauerbach (ATMBH)"
  },
  {
   value: "Mauterndorf (ATMTF)",
   label: "Mauterndorf (ATMTF)"
  },
  {
   value: "Mauthausen (ATMAU)",
   label: "Mauthausen (ATMAU)"
  },
  {
   value: "Mayrhofen (ATMRH)",
   label: "Mayrhofen (ATMRH)"
  },
  {
   value: "Meggenhofen (ATMGN)",
   label: "Meggenhofen (ATMGN)"
  },
  {
   value: "Meiningen (ATVNG)",
   label: "Meiningen (ATVNG)"
  },
  {
   value: "Meiselding (ATMEI)",
   label: "Meiselding (ATMEI)"
  },
  {
   value: "Mellau (ATMLA)",
   label: "Mellau (ATMLA)"
  },
  {
   value: "Merchtrenk (ATMER)",
   label: "Merchtrenk (ATMER)"
  },
  {
   value: "Ladendorf (ATLDO)",
   label: "Ladendorf (ATLDO)"
  },
  {
   value: "Lambrechten (ATLAB)",
   label: "Lambrechten (ATLAB)"
  },
  {
   value: "Lamprechtshausen (ATLPS)",
   label: "Lamprechtshausen (ATLPS)"
  },
  {
   value: "Landeck (ATLAN)",
   label: "Landeck (ATLAN)"
  },
  {
   value: "Langenlebarn (ATLGE)",
   label: "Langenlebarn (ATLGE)"
  },
  {
   value: "Langenlois (ATLAG)",
   label: "Langenlois (ATLAG)"
  },
  {
   value: "Langenstein (ATLSN)",
   label: "Langenstein (ATLSN)"
  },
  {
   value: "Langenwang (ATLGW)",
   label: "Langenwang (ATLGW)"
  },
  {
   value: "Langenzersdorf (ATLZD)",
   label: "Langenzersdorf (ATLZD)"
  },
  {
   value: "Lannach (ATLNH)",
   label: "Lannach (ATLNH)"
  },
  {
   value: "Lanzenkirchen (ATNLA)",
   label: "Lanzenkirchen (ATNLA)"
  },
  {
   value: "Lassing (ATLAS)",
   label: "Lassing (ATLAS)"
  },
  {
   value: "Lavant (ATLNT)",
   label: "Lavant (ATLNT)"
  },
  {
   value: "Laxenburg (ATLXE)",
   label: "Laxenburg (ATLXE)"
  },
  {
   value: "Lebring (ATLEB)",
   label: "Lebring (ATLEB)"
  },
  {
   value: "Leiben (ATLBE)",
   label: "Leiben (ATLBE)"
  },
  {
   value: "Leibnitz (ATLEI)",
   label: "Leibnitz (ATLEI)"
  },
  {
   value: "Lend (ATLEN)",
   label: "Lend (ATLEN)"
  },
  {
   value: "Lengau (ATLGU)",
   label: "Lengau (ATLGU)"
  },
  {
   value: "Lengenfeld (ATLGN)",
   label: "Lengenfeld (ATLGN)"
  },
  {
   value: "Leoben (ATLBN)",
   label: "Leoben (ATLBN)"
  },
  {
   value: "Leobendorf (ATLEO)",
   label: "Leobendorf (ATLEO)"
  },
  {
   value: "Leobersdorf (ATLBD)",
   label: "Leobersdorf (ATLBD)"
  },
  {
   value: "Leonding (ATLDG)",
   label: "Leonding (ATLDG)"
  },
  {
   value: "Leutasch (ATLTH)",
   label: "Leutasch (ATLTH)"
  },
  {
   value: "Lichtenberg (ATLTG)",
   label: "Lichtenberg (ATLTG)"
  },
  {
   value: "Lieboch (ATLIB)",
   label: "Lieboch (ATLIB)"
  },
  {
   value: "Lilienfeld (ATLLF)",
   label: "Lilienfeld (ATLLF)"
  },
  {
   value: "Lindabrunn (ATLBU)",
   label: "Lindabrunn (ATLBU)"
  },
  {
   value: "Litschau (ATLSH)",
   label: "Litschau (ATLSH)"
  },
  {
   value: "Laakirchen (ATLKI)",
   label: "Laakirchen (ATLKI)"
  },
  {
   value: "Kleinharras (ATKHS)",
   label: "Kleinharras (ATKHS)"
  },
  {
   value: "Kleinneusiedl (ATKNS)",
   label: "Kleinneusiedl (ATKNS)"
  },
  {
   value: "Kleinraming (ATKRM)",
   label: "Kleinraming (ATKRM)"
  },
  {
   value: "Kleinzell (ATKZL)",
   label: "Kleinzell (ATKZL)"
  },
  {
   value: "Klöch (ATKCH)",
   label: "Klöch (ATKCH)"
  },
  {
   value: "Klosterneuburg (ATKTU)",
   label: "Klosterneuburg (ATKTU)"
  },
  {
   value: "Knittelfeld (ATKFD)",
   label: "Knittelfeld (ATKFD)"
  },
  {
   value: "Köflach (ATKFH)",
   label: "Köflach (ATKFH)"
  },
  {
   value: "Koglhof (ATKOG)",
   label: "Koglhof (ATKOG)"
  },
  {
   value: "Kolsass (ATKOL)",
   label: "Kolsass (ATKOL)"
  },
  {
   value: "Königsbrunn am Wagram (ATKAW)",
   label: "Königsbrunn am Wagram (ATKAW)"
  },
  {
   value: "Königstetten (ATKTN)",
   label: "Königstetten (ATKTN)"
  },
  {
   value: "Kopfing im Innkreis (ATKGI)",
   label: "Kopfing im Innkreis (ATKGI)"
  },
  {
   value: "Kössen (ATKOS)",
   label: "Kössen (ATKOS)"
  },
  {
   value: "Kötschach-Mauthen (ATKEU)",
   label: "Kötschach-Mauthen (ATKEU)"
  },
  {
   value: "Kottes (ATKOT)",
   label: "Kottes (ATKOT)"
  },
  {
   value: "Kottingbrunn (ATKNR)",
   label: "Kottingbrunn (ATKNR)"
  },
  {
   value: "Kramsach (ATKRS)",
   label: "Kramsach (ATKRS)"
  },
  {
   value: "Krenglbach (ATKGA)",
   label: "Krenglbach (ATKGA)"
  },
  {
   value: "Krieglach (ATKRI)",
   label: "Krieglach (ATKRI)"
  },
  {
   value: "Krobotek (ATKRO)",
   label: "Krobotek (ATKRO)"
  },
  {
   value: "Krottendorf (ATKTF)",
   label: "Krottendorf (ATKTF)"
  },
  {
   value: "Krumbach Markt (ATKUB)",
   label: "Krumbach Markt (ATKUB)"
  },
  {
   value: "Krummnussbaum (ATKMB)",
   label: "Krummnussbaum (ATKMB)"
  },
  {
   value: "Kuchl (ATKUC)",
   label: "Kuchl (ATKUC)"
  },
  {
   value: "Kühnsdorf (ATKUD)",
   label: "Kühnsdorf (ATKUD)"
  },
  {
   value: "Kumberg (ATKMR)",
   label: "Kumberg (ATKMR)"
  },
  {
   value: "Kundl (ATKUN)",
   label: "Kundl (ATKUN)"
  },
  {
   value: "Laa an der Thaya (ATLAA)",
   label: "Laa an der Thaya (ATLAA)"
  },
  {
   value: "Klaus (ATKLA)",
   label: "Klaus (ATKLA)"
  },
  {
   value: "Itterdörfl (ATITT)",
   label: "Itterdörfl (ATITT)"
  },
  {
   value: "Jagerberg (ATJGE)",
   label: "Jagerberg (ATJGE)"
  },
  {
   value: "Jenbach (ATJEN)",
   label: "Jenbach (ATJEN)"
  },
  {
   value: "Jennersdorf (ATJDF)",
   label: "Jennersdorf (ATJDF)"
  },
  {
   value: "Joching (ATJOC)",
   label: "Joching (ATJOC)"
  },
  {
   value: "Jois (ATJOS)",
   label: "Jois (ATJOS)"
  },
  {
   value: "Judenberg (ATJDB)",
   label: "Judenberg (ATJDB)"
  },
  {
   value: "Kaltenbach (ATKAB)",
   label: "Kaltenbach (ATKAB)"
  },
  {
   value: "Kammern im Liesingtal (ATKAM)",
   label: "Kammern im Liesingtal (ATKAM)"
  },
  {
   value: "Kapfenstein (ATSKS)",
   label: "Kapfenstein (ATSKS)"
  },
  {
   value: "Kappl (ATKPL)",
   label: "Kappl (ATKPL)"
  },
  {
   value: "Karlsdorf (ATKAR)",
   label: "Karlsdorf (ATKAR)"
  },
  {
   value: "Kefermarkt (ATKFM)",
   label: "Kefermarkt (ATKFM)"
  },
  {
   value: "Kematen an der Krems (ATKMK)",
   label: "Kematen an der Krems (ATKMK)"
  },
  {
   value: "Kematen in Tirol (ATKTT)",
   label: "Kematen in Tirol (ATKTT)"
  },
  {
   value: "Kemeten (ATKME)",
   label: "Kemeten (ATKME)"
  },
  {
   value: "Kienberg (ATKIE)",
   label: "Kienberg (ATKIE)"
  },
  {
   value: "Kindberg (ATKIN)",
   label: "Kindberg (ATKIN)"
  },
  {
   value: "Kirchberg am Wagram (ATKBW)",
   label: "Kirchberg am Wagram (ATKBW)"
  },
  {
   value: "Kirchberg am Walde (ATKIR)",
   label: "Kirchberg am Walde (ATKIR)"
  },
  {
   value: "Kirchberg an der Raab (ATKAD)",
   label: "Kirchberg an der Raab (ATKAD)"
  },
  {
   value: "Kirchbichl (ATKRL)",
   label: "Kirchbichl (ATKRL)"
  },
  {
   value: "Kirchdorf an der Krems (ATKKM)",
   label: "Kirchdorf an der Krems (ATKKM)"
  },
  {
   value: "Kirchheim im Innkreis (ATKII)",
   label: "Kirchheim im Innkreis (ATKII)"
  },
  {
   value: "Kirchstetten (ATKTE)",
   label: "Kirchstetten (ATKTE)"
  },
  {
   value: "Kittsee (ATKSE)",
   label: "Kittsee (ATKSE)"
  },
  {
   value: "Klaffer (ATKHO)",
   label: "Klaffer (ATKHO)"
  },
  {
   value: "Inzing (ATINZ)",
   label: "Inzing (ATINZ)"
  },
  {
   value: "Henndorf am Wallersee (ATHEO)",
   label: "Henndorf am Wallersee (ATHEO)"
  },
  {
   value: "Hennersdorf (ATHNN)",
   label: "Hennersdorf (ATHNN)"
  },
  {
   value: "Herzogenburg (ATHER)",
   label: "Herzogenburg (ATHER)"
  },
  {
   value: "Hetzmannsdorf (ATHMD)",
   label: "Hetzmannsdorf (ATHMD)"
  },
  {
   value: "Hieflau (ATHFL)",
   label: "Hieflau (ATHFL)"
  },
  {
   value: "Himberg (ATABG)",
   label: "Himberg (ATABG)"
  },
  {
   value: "Hirschwang (ATHIG)",
   label: "Hirschwang (ATHIG)"
  },
  {
   value: "Hirtenberg (ATHTE)",
   label: "Hirtenberg (ATHTE)"
  },
  {
   value: "Hochfilzen (ATHOC)",
   label: "Hochfilzen (ATHOC)"
  },
  {
   value: "Hofen (ATHFN)",
   label: "Hofen (ATHFN)"
  },
  {
   value: "Hofkirchen an der Trattnach (ATHDT)",
   label: "Hofkirchen an der Trattnach (ATHDT)"
  },
  {
   value: "Hofkirchen im Traunkreis (ATHNT)",
   label: "Hofkirchen im Traunkreis (ATHNT)"
  },
  {
   value: "Hohenau an der March (ATHAU)",
   label: "Hohenau an der March (ATHAU)"
  },
  {
   value: "Höhenberg (ATHBR)",
   label: "Höhenberg (ATHBR)"
  },
  {
   value: "Hohenruppersdorf (ATHON)",
   label: "Hohenruppersdorf (ATHON)"
  },
  {
   value: "Hohenzell (ATOHO)",
   label: "Hohenzell (ATOHO)"
  },
  {
   value: "Hollabrunn (ATHOL)",
   label: "Hollabrunn (ATHOL)"
  },
  {
   value: "Hollersbach (ATHLB)",
   label: "Hollersbach (ATHLB)"
  },
  {
   value: "Hönigsberg (ATHOG)",
   label: "Hönigsberg (ATHOG)"
  },
  {
   value: "Hopfgarten im Brixental (ATHOP)",
   label: "Hopfgarten im Brixental (ATHOP)"
  },
  {
   value: "Hörbranz (ATHBZ)",
   label: "Hörbranz (ATHBZ)"
  },
  {
   value: "Hörbranz (ATHOB)",
   label: "Hörbranz (ATHOB)"
  },
  {
   value: "Horitschon (ATHOT)",
   label: "Horitschon (ATHOT)"
  },
  {
   value: "Horn (ATHOR)",
   label: "Horn (ATHOR)"
  },
  {
   value: "Hornstein (ATHSE)",
   label: "Hornstein (ATHSE)"
  },
  {
   value: "Huttau (ATHUT)",
   label: "Huttau (ATHUT)"
  },
  {
   value: "Illmitz (ATILL)",
   label: "Illmitz (ATILL)"
  },
  {
   value: "Ilz (ATILZ)",
   label: "Ilz (ATILZ)"
  },
  {
   value: "Imst (ATIMS)",
   label: "Imst (ATIMS)"
  },
  {
   value: "Helfenberg (ATHEL)",
   label: "Helfenberg (ATHEL)"
  },
  {
   value: "Grunddorf (ATGND)",
   label: "Grunddorf (ATGND)"
  },
  {
   value: "Gumpoldskirchen (ATGPK)",
   label: "Gumpoldskirchen (ATGPK)"
  },
  {
   value: "Günselsdorf (ATGLO)",
   label: "Günselsdorf (ATGLO)"
  },
  {
   value: "Gunskirchen (ATGUK)",
   label: "Gunskirchen (ATGUK)"
  },
  {
   value: "Guntramsdorf (ATGUN)",
   label: "Guntramsdorf (ATGUN)"
  },
  {
   value: "Güssing (ATGSS)",
   label: "Güssing (ATGSS)"
  },
  {
   value: "Gutenstein (ATGSN)",
   label: "Gutenstein (ATGSN)"
  },
  {
   value: "Haag (ATHAG)",
   label: "Haag (ATHAG)"
  },
  {
   value: "Haag am Hausruck (ATHAH)",
   label: "Haag am Hausruck (ATHAH)"
  },
  {
   value: "Hagenbrunn (ATHGB)",
   label: "Hagenbrunn (ATHGB)"
  },
  {
   value: "Haibach (ATHAB)",
   label: "Haibach (ATHAB)"
  },
  {
   value: "Haidershofen (ATHHN)",
   label: "Haidershofen (ATHHN)"
  },
  {
   value: "Hainburg (ATHIA)",
   label: "Hainburg (ATHIA)"
  },
  {
   value: "Haitzendorf (ATHZD)",
   label: "Haitzendorf (ATHZD)"
  },
  {
   value: "Halbturn (ATALB)",
   label: "Halbturn (ATALB)"
  },
  {
   value: "Hall in Tirol (ATHIT)",
   label: "Hall in Tirol (ATHIT)"
  },
  {
   value: "Hallstatt (ATHLT)",
   label: "Hallstatt (ATHLT)"
  },
  {
   value: "Hallwang (ATHLG)",
   label: "Hallwang (ATHLG)"
  },
  {
   value: "Handenberg (ATHBG)",
   label: "Handenberg (ATHBG)"
  },
  {
   value: "Haring (ATBDH)",
   label: "Haring (ATBDH)"
  },
  {
   value: "Haringsee (ATHAE)",
   label: "Haringsee (ATHAE)"
  },
  {
   value: "Haugschlag (ATHAC)",
   label: "Haugschlag (ATHAC)"
  },
  {
   value: "Hausmenning (ATHME)",
   label: "Hausmenning (ATHME)"
  },
  {
   value: "Heidenreichstein (ATHEC)",
   label: "Heidenreichstein (ATHEC)"
  },
  {
   value: "Heiligenkreuz (ATHKR)",
   label: "Heiligenkreuz (ATHKR)"
  },
  {
   value: "Heiligenkreuz (ATHKZ)",
   label: "Heiligenkreuz (ATHKZ)"
  },
  {
   value: "Heiligenkreuz im Lafnitztal (ATHZL)",
   label: "Heiligenkreuz im Lafnitztal (ATHZL)"
  },
  {
   value: "Heinfels (ATHFS)",
   label: "Heinfels (ATHFS)"
  },
  {
   value: "Grosshöflein (ATGHF)",
   label: "Grosshöflein (ATGHF)"
  },
  {
   value: "Gerasdorf bei Wien (ATGDF)",
   label: "Gerasdorf bei Wien (ATGDF)"
  },
  {
   value: "Gerersdorf bei Güssing (ATGER)",
   label: "Gerersdorf bei Güssing (ATGER)"
  },
  {
   value: "Geretsberg (ATGTR)",
   label: "Geretsberg (ATGTR)"
  },
  {
   value: "Glanegg (ATGLA)",
   label: "Glanegg (ATGLA)"
  },
  {
   value: "Glanz (ATGLZ)",
   label: "Glanz (ATGLZ)"
  },
  {
   value: "Gleinstätten (ATGST)",
   label: "Gleinstätten (ATGST)"
  },
  {
   value: "Gmünd (ATGMU)",
   label: "Gmünd (ATGMU)"
  },
  {
   value: "Gmunden (ATGDN)",
   label: "Gmunden (ATGDN)"
  },
  {
   value: "Gnas (ATGNA)",
   label: "Gnas (ATGNA)"
  },
  {
   value: "Gödersdorf (ATORF)",
   label: "Gödersdorf (ATORF)"
  },
  {
   value: "Golling an der Erlauf (ATGAE)",
   label: "Golling an der Erlauf (ATGAE)"
  },
  {
   value: "Golling an der Salzach (ATGGS)",
   label: "Golling an der Salzach (ATGGS)"
  },
  {
   value: "Gols (ATGOL)",
   label: "Gols (ATGOL)"
  },
  {
   value: "Gosdorf (ATGRF)",
   label: "Gosdorf (ATGRF)"
  },
  {
   value: "Gösing (ATGSG)",
   label: "Gösing (ATGSG)"
  },
  {
   value: "Gössendorf (ATGOF)",
   label: "Gössendorf (ATGOF)"
  },
  {
   value: "Gottlesbrunn (ATGSB)",
   label: "Gottlesbrunn (ATGSB)"
  },
  {
   value: "Götzis (ATGOE)",
   label: "Götzis (ATGOE)"
  },
  {
   value: "Götzis (ATGTZ)",
   label: "Götzis (ATGTZ)"
  },
  {
   value: "Grafenstein (ATGRA)",
   label: "Grafenstein (ATGRA)"
  },
  {
   value: "Grafenworth (ATGFW)",
   label: "Grafenworth (ATGFW)"
  },
  {
   value: "Gramatneusiedl (ATGRL)",
   label: "Gramatneusiedl (ATGRL)"
  },
  {
   value: "Granz (ATGNZ)",
   label: "Granz (ATGNZ)"
  },
  {
   value: "Gratkorn (ATGKN)",
   label: "Gratkorn (ATGKN)"
  },
  {
   value: "Greifenstein (ATGFS)",
   label: "Greifenstein (ATGFS)"
  },
  {
   value: "Grein (ATGRN)",
   label: "Grein (ATGRN)"
  },
  {
   value: "Gresten (ATGTN)",
   label: "Gresten (ATGTN)"
  },
  {
   value: "Grieskirchen (ATGIE)",
   label: "Grieskirchen (ATGIE)"
  },
  {
   value: "Griffen (ATGRI)",
   label: "Griffen (ATGRI)"
  },
  {
   value: "Grödig (ATGRG)",
   label: "Grödig (ATGRG)"
  },
  {
   value: "Gross Gerungs (ATGZR)",
   label: "Gross Gerungs (ATGZR)"
  },
  {
   value: "Grossebersdorf (ATGBF)",
   label: "Grossebersdorf (ATGBF)"
  },
  {
   value: "Grossenzersdorf\/Wien (ATGRO)",
   label: "Grossenzersdorf\/Wien (ATGRO)"
  },
  {
   value: "Fels am Wagram (ATFWG)",
   label: "Fels am Wagram (ATFWG)"
  },
  {
   value: "Ferndorf (ATFEO)",
   label: "Ferndorf (ATFEO)"
  },
  {
   value: "Fernitz (ATFNZ)",
   label: "Fernitz (ATFNZ)"
  },
  {
   value: "Fieberbrunn (ATFBB)",
   label: "Fieberbrunn (ATFBB)"
  },
  {
   value: "Fischamend Dorf (ATFIS)",
   label: "Fischamend Dorf (ATFIS)"
  },
  {
   value: "Floridsdorf (ATFLO)",
   label: "Floridsdorf (ATFLO)"
  },
  {
   value: "Fohnsdorf (ATFOH)",
   label: "Fohnsdorf (ATFOH)"
  },
  {
   value: "Fornach (ATFOR)",
   label: "Fornach (ATFOR)"
  },
  {
   value: "Frankenburg (ATFBG)",
   label: "Frankenburg (ATFBG)"
  },
  {
   value: "Frastanz (ATFRT)",
   label: "Frastanz (ATFRT)"
  },
  {
   value: "Frauenkirchen (ATFKN)",
   label: "Frauenkirchen (ATFKN)"
  },
  {
   value: "Frauental an der Lassnitz (ATFTL)",
   label: "Frauental an der Lassnitz (ATFTL)"
  },
  {
   value: "Freistadt (ATFSD)",
   label: "Freistadt (ATFSD)"
  },
  {
   value: "Fresing (ATFRE)",
   label: "Fresing (ATFRE)"
  },
  {
   value: "Freudenau (ATFNA)",
   label: "Freudenau (ATFNA)"
  },
  {
   value: "Friedburg (ATFDG)",
   label: "Friedburg (ATFDG)"
  },
  {
   value: "Fritzens (ATFRI)",
   label: "Fritzens (ATFRI)"
  },
  {
   value: "Frojach-Katsch (ATFHK)",
   label: "Frojach-Katsch (ATFHK)"
  },
  {
   value: "Fügen (ATFGN)",
   label: "Fügen (ATFGN)"
  },
  {
   value: "Fulpmes (ATFPS)",
   label: "Fulpmes (ATFPS)"
  },
  {
   value: "Fürstenfeld (ATFNF)",
   label: "Fürstenfeld (ATFNF)"
  },
  {
   value: "Fürstenfeld (ATFUF)",
   label: "Fürstenfeld (ATFUF)"
  },
  {
   value: "Furth bei Göttweig (ATFTH)",
   label: "Furth bei Göttweig (ATFTH)"
  },
  {
   value: "Fuschl am See (ATFAS)",
   label: "Fuschl am See (ATFAS)"
  },
  {
   value: "Fussach (ATFSA)",
   label: "Fussach (ATFSA)"
  },
  {
   value: "Gaflenz (ATGFZ)",
   label: "Gaflenz (ATGFZ)"
  },
  {
   value: "Galtür (ATGAL)",
   label: "Galtür (ATGAL)"
  },
  {
   value: "Gänserndorf (ATGNF)",
   label: "Gänserndorf (ATGNF)"
  },
  {
   value: "Gaspoltshofen (ATGSF)",
   label: "Gaspoltshofen (ATGSF)"
  },
  {
   value: "Gattendorf (ATGTD)",
   label: "Gattendorf (ATGTD)"
  },
  {
   value: "Gedersdorf (ATDER)",
   label: "Gedersdorf (ATDER)"
  },
  {
   value: "Felixdorf (ATFXO)",
   label: "Felixdorf (ATFXO)"
  },
  {
   value: "Ebreichsdorf (ATEBR)",
   label: "Ebreichsdorf (ATEBR)"
  },
  {
   value: "Edelstal (ATELL)",
   label: "Edelstal (ATELL)"
  },
  {
   value: "Edlitz (ATEDZ)",
   label: "Edlitz (ATEDZ)"
  },
  {
   value: "Eggelsberg (ATEGB)",
   label: "Eggelsberg (ATEGB)"
  },
  {
   value: "Eggenburg (ATEBU)",
   label: "Eggenburg (ATEBU)"
  },
  {
   value: "Eggendorf im Traunkreis (ATEGT)",
   label: "Eggendorf im Traunkreis (ATEGT)"
  },
  {
   value: "Ehrenhausen (ATEHR)",
   label: "Ehrenhausen (ATEHR)"
  },
  {
   value: "Eisenerz (ATEEZ)",
   label: "Eisenerz (ATEEZ)"
  },
  {
   value: "Eisenstadt (ATEIT)",
   label: "Eisenstadt (ATEIT)"
  },
  {
   value: "Elsbethen Glasenbach (ATEGL)",
   label: "Elsbethen Glasenbach (ATEGL)"
  },
  {
   value: "Engelhartszell (ATAHZ)",
   label: "Engelhartszell (ATAHZ)"
  },
  {
   value: "Ennsdorf (ATENO)",
   label: "Ennsdorf (ATENO)"
  },
  {
   value: "Enzersdorf an der Fischa (ATENZ)",
   label: "Enzersdorf an der Fischa (ATENZ)"
  },
  {
   value: "Enzersdorf im Thale (ATETH)",
   label: "Enzersdorf im Thale (ATETH)"
  },
  {
   value: "Enzesfeld (ATEZF)",
   label: "Enzesfeld (ATEZF)"
  },
  {
   value: "Eppenstein (ATESN)",
   label: "Eppenstein (ATESN)"
  },
  {
   value: "Erl (ATERL)",
   label: "Erl (ATERL)"
  },
  {
   value: "Erpersdorf (ATEPD)",
   label: "Erpersdorf (ATEPD)"
  },
  {
   value: "Erpfendorf (ATERP)",
   label: "Erpfendorf (ATERP)"
  },
  {
   value: "Etsdorf am Kamp (ATEAK)",
   label: "Etsdorf am Kamp (ATEAK)"
  },
  {
   value: "Eugendorf (ATEUG)",
   label: "Eugendorf (ATEUG)"
  },
  {
   value: "Faistenau (ATFSU)",
   label: "Faistenau (ATFSU)"
  },
  {
   value: "Falkenstein (ATLKN)",
   label: "Falkenstein (ATLKN)"
  },
  {
   value: "Fehring (ATFHR)",
   label: "Fehring (ATFHR)"
  },
  {
   value: "Feistritz an der Drau (ATFDU)",
   label: "Feistritz an der Drau (ATFDU)"
  },
  {
   value: "Feistritz im Rosental (ATFIT)",
   label: "Feistritz im Rosental (ATFIT)"
  },
  {
   value: "Feldbach (ATFED)",
   label: "Feldbach (ATFED)"
  },
  {
   value: "Feldkirchen bei Graz (ATFKC)",
   label: "Feldkirchen bei Graz (ATFKC)"
  },
  {
   value: "Feldkirchen im Kärnten (ATFKI)",
   label: "Feldkirchen im Kärnten (ATFKI)"
  },
  {
   value: "Ebersdorf (ATEBD)",
   label: "Ebersdorf (ATEBD)"
  },
  {
   value: "Breitenau (ATBTU)",
   label: "Breitenau (ATBTU)"
  },
  {
   value: "Breitenau am Hochlantsch (ATZAE)",
   label: "Breitenau am Hochlantsch (ATZAE)"
  },
  {
   value: "Breitenbrunn (ATBBN)",
   label: "Breitenbrunn (ATBBN)"
  },
  {
   value: "Breitenschützing (ATBSZ)",
   label: "Breitenschützing (ATBSZ)"
  },
  {
   value: "Brixen im Thale (ATBXT)",
   label: "Brixen im Thale (ATBXT)"
  },
  {
   value: "Brixlegg (ATBXG)",
   label: "Brixlegg (ATBXG)"
  },
  {
   value: "Bruck an der Glocknerstrasse (ATBRG)",
   label: "Bruck an der Glocknerstrasse (ATBRG)"
  },
  {
   value: "Brückl (ATBRL)",
   label: "Brückl (ATBRL)"
  },
  {
   value: "Brunn (ATBRN)",
   label: "Brunn (ATBRN)"
  },
  {
   value: "Brunn am Gebirge (ATBAG)",
   label: "Brunn am Gebirge (ATBAG)"
  },
  {
   value: "Brunnenthal (ATNNE)",
   label: "Brunnenthal (ATNNE)"
  },
  {
   value: "Burgkirchen (ATBGK)",
   label: "Burgkirchen (ATBGK)"
  },
  {
   value: "Burs (ATURS)",
   label: "Burs (ATURS)"
  },
  {
   value: "Dellach im Drautal (ATDDT)",
   label: "Dellach im Drautal (ATDDT)"
  },
  {
   value: "Desselbrunn (ATDSU)",
   label: "Desselbrunn (ATDSU)"
  },
  {
   value: "Deutsch Schutzen (ATDSZ)",
   label: "Deutsch Schutzen (ATDSZ)"
  },
  {
   value: "Deutsch Wagram (ATDWA)",
   label: "Deutsch Wagram (ATDWA)"
  },
  {
   value: "Deutschlandsberg (ATDEU)",
   label: "Deutschlandsberg (ATDEU)"
  },
  {
   value: "Dietach (ATDIA)",
   label: "Dietach (ATDIA)"
  },
  {
   value: "Dietachdorf (ATDTD)",
   label: "Dietachdorf (ATDTD)"
  },
  {
   value: "Dorf (ATDRF)",
   label: "Dorf (ATDRF)"
  },
  {
   value: "Dornbirn (ATDOR)",
   label: "Dornbirn (ATDOR)"
  },
  {
   value: "Dross (ATDRO)",
   label: "Dross (ATDRO)"
  },
  {
   value: "Dürnkrut (ATDUR)",
   label: "Dürnkrut (ATDUR)"
  },
  {
   value: "Dürnstein (ATDUE)",
   label: "Dürnstein (ATDUE)"
  },
  {
   value: "Eben (ATEBN)",
   label: "Eben (ATEBN)"
  },
  {
   value: "Ebensee (ATEBS)",
   label: "Ebensee (ATEBS)"
  },
  {
   value: "Ebenthal (ATETL)",
   label: "Ebenthal (ATETL)"
  },
  {
   value: "Ebergassing (ATEBE)",
   label: "Ebergassing (ATEBE)"
  },
  {
   value: "Eberndorf (ATERF)",
   label: "Eberndorf (ATERF)"
  },
  {
   value: "Eberschwang (ATESW)",
   label: "Eberschwang (ATESW)"
  },
  {
   value: "Brand (ATBRD)",
   label: "Brand (ATBRD)"
  },
  {
   value: "Aschbach Markt (ATABM)",
   label: "Aschbach Markt (ATABM)"
  },
  {
   value: "Aspang (ATAPG)",
   label: "Aspang (ATAPG)"
  },
  {
   value: "Asten (ATATN)",
   label: "Asten (ATATN)"
  },
  {
   value: "Attnang-Puchheim (ATATP)",
   label: "Attnang-Puchheim (ATATP)"
  },
  {
   value: "Atzenbrugg (ATATZ)",
   label: "Atzenbrugg (ATATZ)"
  },
  {
   value: "Auersthal (ATUER)",
   label: "Auersthal (ATUER)"
  },
  {
   value: "Aurolzmünster (ATALZ)",
   label: "Aurolzmünster (ATALZ)"
  },
  {
   value: "Bad Aussee (ATAUE)",
   label: "Bad Aussee (ATAUE)"
  },
  {
   value: "Bad Fischau (ATBFI)",
   label: "Bad Fischau (ATBFI)"
  },
  {
   value: "Bad Hall (ATBHL)",
   label: "Bad Hall (ATBHL)"
  },
  {
   value: "Bad Ischl (ATICH)",
   label: "Bad Ischl (ATICH)"
  },
  {
   value: "Bad Leonfelden (ATBFL)",
   label: "Bad Leonfelden (ATBFL)"
  },
  {
   value: "Bad Mitterndorf (ATBMF)",
   label: "Bad Mitterndorf (ATBMF)"
  },
  {
   value: "Bad Sankt Leonhard im Lavanttal (ATBSL)",
   label: "Bad Sankt Leonhard im Lavanttal (ATBSL)"
  },
  {
   value: "Bad Vöslau (ATBVL)",
   label: "Bad Vöslau (ATBVL)"
  },
  {
   value: "Baden (ATBDN)",
   label: "Baden (ATBDN)"
  },
  {
   value: "Bärenbach (ATBRB)",
   label: "Bärenbach (ATBRB)"
  },
  {
   value: "Bärnbach (ATBBH)",
   label: "Bärnbach (ATBBH)"
  },
  {
   value: "Baumgartenberg (ATBGT)",
   label: "Baumgartenberg (ATBGT)"
  },
  {
   value: "Behamberg (ATBMB)",
   label: "Behamberg (ATBMB)"
  },
  {
   value: "Bergheim\/Salzburg (ATBES)",
   label: "Bergheim\/Salzburg (ATBES)"
  },
  {
   value: "Biedermannsdorf (ATBIE)",
   label: "Biedermannsdorf (ATBIE)"
  },
  {
   value: "Bisamberg\/Wien (ATBIS)",
   label: "Bisamberg\/Wien (ATBIS)"
  },
  {
   value: "Bischofshofen (ATBFS)",
   label: "Bischofshofen (ATBFS)"
  },
  {
   value: "Bleiburg (ATBBG)",
   label: "Bleiburg (ATBBG)"
  },
  {
   value: "Blindenmarkt (ATBNT)",
   label: "Blindenmarkt (ATBNT)"
  },
  {
   value: "Bludenz (ATBLU)",
   label: "Bludenz (ATBLU)"
  },
  {
   value: "Böheimkirchen (ATZAC)",
   label: "Böheimkirchen (ATZAC)"
  },
  {
   value: "Böhlerwenk (ATBOE)",
   label: "Böhlerwenk (ATBOE)"
  },
  {
   value: "Brand (ATBND)",
   label: "Brand (ATBND)"
  },
  {
   value: "Aschach an der Steyr (ATADS)",
   label: "Aschach an der Steyr (ATADS)"
  },
  {
   value: "Absam (ATABS)",
   label: "Absam (ATABS)"
  },
  {
   value: "Abwinden (ATAWD)",
   label: "Abwinden (ATAWD)"
  },
  {
   value: "Aderklaa (ATAND)",
   label: "Aderklaa (ATAND)"
  },
  {
   value: "Adlwang (ATAWG)",
   label: "Adlwang (ATAWG)"
  },
  {
   value: "Admont (ATADO)",
   label: "Admont (ATADO)"
  },
  {
   value: "Adnet (ATSAD)",
   label: "Adnet (ATSAD)"
  },
  {
   value: "Afritz (ATAFR)",
   label: "Afritz (ATAFR)"
  },
  {
   value: "Aich (ATACH)",
   label: "Aich (ATACH)"
  },
  {
   value: "Aigen im Mühlkreis (ATAIG)",
   label: "Aigen im Mühlkreis (ATAIG)"
  },
  {
   value: "Albersdorf (ATARO)",
   label: "Albersdorf (ATARO)"
  },
  {
   value: "Alkoven (ATAKV)",
   label: "Alkoven (ATAKV)"
  },
  {
   value: "Allentsteig (ATALE)",
   label: "Allentsteig (ATALE)"
  },
  {
   value: "Allerheiligen (ATALH)",
   label: "Allerheiligen (ATALH)"
  },
  {
   value: "Allhaming (ATALL)",
   label: "Allhaming (ATALL)"
  },
  {
   value: "Allhartsberg (ATNAL)",
   label: "Allhartsberg (ATNAL)"
  },
  {
   value: "Altach (ATATH)",
   label: "Altach (ATATH)"
  },
  {
   value: "Altaussee (ATATS)",
   label: "Altaussee (ATATS)"
  },
  {
   value: "Altenmarkt im Pongau (ATALK)",
   label: "Altenmarkt im Pongau (ATALK)"
  },
  {
   value: "Altenwörth (ATAWH)",
   label: "Altenwörth (ATAWH)"
  },
  {
   value: "Altheim (ATAHI)",
   label: "Altheim (ATAHI)"
  },
  {
   value: "Althofen (ATAHO)",
   label: "Althofen (ATAHO)"
  },
  {
   value: "Althofen (ATALT)",
   label: "Althofen (ATALT)"
  },
  {
   value: "Altlengbach (ATATG)",
   label: "Altlengbach (ATATG)"
  },
  {
   value: "Altmuenster (ATAMU)",
   label: "Altmuenster (ATAMU)"
  },
  {
   value: "Ampflwang im Hausruckwald (ATZAD)",
   label: "Ampflwang im Hausruckwald (ATZAD)"
  },
  {
   value: "Andau (ATADU)",
   label: "Andau (ATADU)"
  },
  {
   value: "Anger (ATANR)",
   label: "Anger (ATANR)"
  },
  {
   value: "Ansfelden (ATANS)",
   label: "Ansfelden (ATANS)"
  },
  {
   value: "Anthering (ATARG)",
   label: "Anthering (ATARG)"
  },
  {
   value: "Ardagger (ATADG)",
   label: "Ardagger (ATADG)"
  },
  {
   value: "Arnoldstein (ATAOT)",
   label: "Arnoldstein (ATAOT)"
  },
  {
   value: "Aschach an der Donau (ATASC)",
   label: "Aschach an der Donau (ATASC)"
  },
  {
   value: "Yucca (ASACC)",
   label: "Yucca (ASACC)"
  },
  {
   value: "San Salvador (ARSSA)",
   label: "San Salvador (ARSSA)"
  },
  {
   value: "San Salvador de Jujuy (ARSSJ)",
   label: "San Salvador de Jujuy (ARSSJ)"
  },
  {
   value: "Santa Ana (ARSAN)",
   label: "Santa Ana (ARSAN)"
  },
  {
   value: "Santa Rosa (ARSTA)",
   label: "Santa Rosa (ARSTA)"
  },
  {
   value: "Tigre (ARTGR)",
   label: "Tigre (ARTGR)"
  },
  {
   value: "Tunuyan (ARTUN)",
   label: "Tunuyan (ARTUN)"
  },
  {
   value: "Vicente López (ARVLO)",
   label: "Vicente López (ARVLO)"
  },
  {
   value: "Villa Hernandarias (ARVHE)",
   label: "Villa Hernandarias (ARVHE)"
  },
  {
   value: "Villa Regina (ARVRE)",
   label: "Villa Regina (ARVRE)"
  },
  {
   value: ".AMERICAN SAMOA (AS)",
   label: ".AMERICAN SAMOA (AS)"
  },
  {
   value: "Río Tercero (ARRTO)",
   label: "Río Tercero (ARRTO)"
  },
  {
   value: "Rivadavia (ARRIV)",
   label: "Rivadavia (ARRIV)"
  },
  {
   value: "Rosario de la Frontera (ARRFO)",
   label: "Rosario de la Frontera (ARRFO)"
  },
  {
   value: "San Andrés de Giles (ARSAG)",
   label: "San Andrés de Giles (ARSAG)"
  },
  {
   value: "San Carlos (ARSCA)",
   label: "San Carlos (ARSCA)"
  },
  {
   value: "San Francisco (ARSFO)",
   label: "San Francisco (ARSFO)"
  },
  {
   value: "San Ignacio (ARSIG)",
   label: "San Ignacio (ARSIG)"
  },
  {
   value: "San Justo (ARSJO)",
   label: "San Justo (ARSJO)"
  },
  {
   value: "San Martin (ARSMA)",
   label: "San Martin (ARSMA)"
  },
  {
   value: "San Martin (ARSMR)",
   label: "San Martin (ARSMR)"
  },
  {
   value: "San Mateo (ARSMT)",
   label: "San Mateo (ARSMT)"
  },
  {
   value: "San Miguel de Tucuman (ARSMC)",
   label: "San Miguel de Tucuman (ARSMC)"
  },
  {
   value: "San Pedro (ARSPD)",
   label: "San Pedro (ARSPD)"
  },
  {
   value: "Resinfor (ARRSF)",
   label: "Resinfor (ARRSF)"
  },
  {
   value: "Pergamino (ARPGO)",
   label: "Pergamino (ARPGO)"
  },
  {
   value: "Pilar (ARPLR)",
   label: "Pilar (ARPLR)"
  },
  {
   value: "Pto Alumbrera (ARPAL)",
   label: "Pto Alumbrera (ARPAL)"
  },
  {
   value: "Pto Eldorado (ARPEL)",
   label: "Pto Eldorado (ARPEL)"
  },
  {
   value: "Pto Lavalle (ARPLA)",
   label: "Pto Lavalle (ARPLA)"
  },
  {
   value: "Pto Wanda (ARPWA)",
   label: "Pto Wanda (ARPWA)"
  },
  {
   value: "Puerto Ingeniero M. Rocca (ARROC)",
   label: "Puerto Ingeniero M. Rocca (ARROC)"
  },
  {
   value: "Punta Medanos (ARPME)",
   label: "Punta Medanos (ARPME)"
  },
  {
   value: "Quebracho\/San Lorenzo (ARQBR)",
   label: "Quebracho\/San Lorenzo (ARQBR)"
  },
  {
   value: "Rafaela (ARRAF)",
   label: "Rafaela (ARRAF)"
  },
  {
   value: "Rawson (ARRWO)",
   label: "Rawson (ARRWO)"
  },
  {
   value: "Lanús (ARLNS)",
   label: "Lanús (ARLNS)"
  },
  {
   value: "Las Palmas (ARLPS)",
   label: "Las Palmas (ARLPS)"
  },
  {
   value: "Lavalle (ARLAV)",
   label: "Lavalle (ARLAV)"
  },
  {
   value: "Lomas de Zamora (ARLMZ)",
   label: "Lomas de Zamora (ARLMZ)"
  },
  {
   value: "Luján (ARLUJ)",
   label: "Luján (ARLUJ)"
  },
  {
   value: "Lujan de Cuyo (ARLCU)",
   label: "Lujan de Cuyo (ARLCU)"
  },
  {
   value: "Maipú (ARMPU)",
   label: "Maipú (ARMPU)"
  },
  {
   value: "Martínez (ARMAR)",
   label: "Martínez (ARMAR)"
  },
  {
   value: "Matheu (ARMTH)",
   label: "Matheu (ARMTH)"
  },
  {
   value: "Medanitos (ARMED)",
   label: "Medanitos (ARMED)"
  },
  {
   value: "Monte Quemado (ARMQO)",
   label: "Monte Quemado (ARMQO)"
  },
  {
   value: "Nogoyá (ARNOG)",
   label: "Nogoyá (ARNOG)"
  },
  {
   value: "Nueve de Julio (AREJO)",
   label: "Nueve de Julio (AREJO)"
  },
  {
   value: "Obera (AROBA)",
   label: "Obera (AROBA)"
  },
  {
   value: "Olavarría (AROVI)",
   label: "Olavarría (AROVI)"
  },
  {
   value: "Pampa del Castillo (ARPDC)",
   label: "Pampa del Castillo (ARPDC)"
  },
  {
   value: "Dock Sud (ARDSU)",
   label: "Dock Sud (ARDSU)"
  },
  {
   value: "El Bolsón (ARELB)",
   label: "El Bolsón (ARELB)"
  },
  {
   value: "Frontera (ARFRT)",
   label: "Frontera (ARFRT)"
  },
  {
   value: "General Alvear (ARGVA)",
   label: "General Alvear (ARGVA)"
  },
  {
   value: "Godoy Cruz (ARGCR)",
   label: "Godoy Cruz (ARGCR)"
  },
  {
   value: "Hickmann (ARHIC)",
   label: "Hickmann (ARHIC)"
  },
  {
   value: "Hughes (ARHUG)",
   label: "Hughes (ARHUG)"
  },
  {
   value: "Jose Leon Suarez (ARJLS)",
   label: "Jose Leon Suarez (ARJLS)"
  },
  {
   value: "Junin de Los Andes (ARJUN)",
   label: "Junin de Los Andes (ARJUN)"
  },
  {
   value: "La Falda (ARLFL)",
   label: "La Falda (ARLFL)"
  },
  {
   value: "Berazategui (ARBER)",
   label: "Berazategui (ARBER)"
  },
  {
   value: "Bernal (ARBRN)",
   label: "Bernal (ARBRN)"
  },
  {
   value: "Bragado (ARBGO)",
   label: "Bragado (ARBGO)"
  },
  {
   value: "Burzaco (ARBUR)",
   label: "Burzaco (ARBUR)"
  },
  {
   value: "Cafayate (ARCFY)",
   label: "Cafayate (ARCFY)"
  },
  {
   value: "Candelaria (ARCDL)",
   label: "Candelaria (ARCDL)"
  },
  {
   value: "Casilda (ARCSL)",
   label: "Casilda (ARCSL)"
  },
  {
   value: "Catinzaco (ARCAT)",
   label: "Catinzaco (ARCAT)"
  },
  {
   value: "Chacabuco (ARCCO)",
   label: "Chacabuco (ARCCO)"
  },
  {
   value: "Chajarí (ARCHA)",
   label: "Chajarí (ARCHA)"
  },
  {
   value: "Chivilcoy (ARCVY)",
   label: "Chivilcoy (ARCVY)"
  },
  {
   value: "Cipoletti (ARCPA)",
   label: "Cipoletti (ARCPA)"
  },
  {
   value: "City Bell (ARCYB)",
   label: "City Bell (ARCYB)"
  },
  {
   value: "Conceptión (ARCCP)",
   label: "Conceptión (ARCCP)"
  },
  {
   value: "Berazategui (ARBBI)",
   label: "Berazategui (ARBBI)"
  },
  {
   value: "Pt Foster (AQPFS)",
   label: "Pt Foster (AQPFS)"
  },
  {
   value: "Rothera (AQROT)",
   label: "Rothera (AQROT)"
  },
  {
   value: "San Martín (AQSMT)",
   label: "San Martín (AQSMT)"
  },
  {
   value: "SANAE IV (AQSNA)",
   label: "SANAE IV (AQSNA)"
  },
  {
   value: "Scott Base (AQSBA)",
   label: "Scott Base (AQSBA)"
  },
  {
   value: "Signy (AQSGN)",
   label: "Signy (AQSGN)"
  },
  {
   value: "Syowa (AQSYW)",
   label: "Syowa (AQSYW)"
  },
  {
   value: "Tor (AQTOR)",
   label: "Tor (AQTOR)"
  },
  {
   value: "Troll (AQTRL)",
   label: "Troll (AQTRL)"
  },
  {
   value: "Vernadsky (AQVKY)",
   label: "Vernadsky (AQVKY)"
  },
  {
   value: "Vostok (AQVOS)",
   label: "Vostok (AQVOS)"
  },
  {
   value: "Wasa (AQWSA)",
   label: "Wasa (AQWSA)"
  },
  {
   value: "Zhongshan (AQZGN)",
   label: "Zhongshan (AQZGN)"
  },
  {
   value: ".ARGENTINA (AR)",
   label: ".ARGENTINA (AR)"
  },
  {
   value: "Acevedo (ARAVD)",
   label: "Acevedo (ARAVD)"
  },
  {
   value: "Aimogasta (ARAIM)",
   label: "Aimogasta (ARAIM)"
  },
  {
   value: "Alberti (ARALI)",
   label: "Alberti (ARALI)"
  },
  {
   value: "Allen (ARALL)",
   label: "Allen (ARALL)"
  },
  {
   value: "Añatuya (ARANA)",
   label: "Añatuya (ARANA)"
  },
  {
   value: "Ancon (ARANC)",
   label: "Ancon (ARANC)"
  },
  {
   value: "Andalgalá (ARAND)",
   label: "Andalgalá (ARAND)"
  },
  {
   value: "Apostoles (ARAPO)",
   label: "Apostoles (ARAPO)"
  },
  {
   value: "Arrecifes (ARACF)",
   label: "Arrecifes (ARACF)"
  },
  {
   value: "Arroyo Seco (ARASO)",
   label: "Arroyo Seco (ARASO)"
  },
  {
   value: "Asturias (ARAST)",
   label: "Asturias (ARAST)"
  },
  {
   value: "Avellaneda (ARAVE)",
   label: "Avellaneda (ARAVE)"
  },
  {
   value: "Azul (ARAZU)",
   label: "Azul (ARAZU)"
  },
  {
   value: "Bajo Grande (ARBAJ)",
   label: "Bajo Grande (ARBAJ)"
  },
  {
   value: "Balcarce (ARBCA)",
   label: "Balcarce (ARBCA)"
  },
  {
   value: "Baradero (ARBAR)",
   label: "Baradero (ARBAR)"
  },
  {
   value: "Belen De Escobar (ARBDE)",
   label: "Belen De Escobar (ARBDE)"
  },
  {
   value: "Bella Vista (ARBEL)",
   label: "Bella Vista (ARBEL)"
  },
  {
   value: "Progress (AQPRO)",
   label: "Progress (AQPRO)"
  },
  {
   value: ".ANTARCTICA (AQ)",
   label: ".ANTARCTICA (AQ)"
  },
  {
   value: "Aboa (AQABA)",
   label: "Aboa (AQABA)"
  },
  {
   value: "Amundsen-Scott (AQAMS)",
   label: "Amundsen-Scott (AQAMS)"
  },
  {
   value: "Arctowski (AQARC)",
   label: "Arctowski (AQARC)"
  },
  {
   value: "Artigas (AQART)",
   label: "Artigas (AQART)"
  },
  {
   value: "Arturo Prat (AQAPT)",
   label: "Arturo Prat (AQAPT)"
  },
  {
   value: "Belgrano II (AQBEL)",
   label: "Belgrano II (AQBEL)"
  },
  {
   value: "Bellingshausen (AQBHN)",
   label: "Bellingshausen (AQBHN)"
  },
  {
   value: "Comandante Ferraz (AQCFZ)",
   label: "Comandante Ferraz (AQCFZ)"
  },
  {
   value: "Concordia (AQCON)",
   label: "Concordia (AQCON)"
  },
  {
   value: "Dome Fuji (AQDMF)",
   label: "Dome Fuji (AQDMF)"
  },
  {
   value: "Druzhnaya 4 (AQDRZ)",
   label: "Druzhnaya 4 (AQDRZ)"
  },
  {
   value: "Escudero (AQESC)",
   label: "Escudero (AQESC)"
  },
  {
   value: "Esperanza (AQESP)",
   label: "Esperanza (AQESP)"
  },
  {
   value: "Gabriel de Castilla (AQGDC)",
   label: "Gabriel de Castilla (AQGDC)"
  },
  {
   value: "Great Wall (AQGWL)",
   label: "Great Wall (AQGWL)"
  },
  {
   value: "Halley (AQHLY)",
   label: "Halley (AQHLY)"
  },
  {
   value: "Juan Carlos Primero (AQJCP)",
   label: "Juan Carlos Primero (AQJCP)"
  },
  {
   value: "Jubany (AQJUB)",
   label: "Jubany (AQJUB)"
  },
  {
   value: "King Sejong (AQKSG)",
   label: "King Sejong (AQKSG)"
  },
  {
   value: "Kohnen (AQKHN)",
   label: "Kohnen (AQKHN)"
  },
  {
   value: "Law Base (AQLAW)",
   label: "Law Base (AQLAW)"
  },
  {
   value: "Maitri (AQMTR)",
   label: "Maitri (AQMTR)"
  },
  {
   value: "Marambio (AQMRB)",
   label: "Marambio (AQMRB)"
  },
  {
   value: "Mario Zucchelli (AQMZU)",
   label: "Mario Zucchelli (AQMZU)"
  },
  {
   value: "Mirny (AQMIR)",
   label: "Mirny (AQMIR)"
  },
  {
   value: "Neumayer (AQNEU)",
   label: "Neumayer (AQNEU)"
  },
  {
   value: "Novolazarevskaya (AQNOV)",
   label: "Novolazarevskaya (AQNOV)"
  },
  {
   value: "Orcadas (AQORC)",
   label: "Orcadas (AQORC)"
  },
  {
   value: "Palmer (AQPLM)",
   label: "Palmer (AQPLM)"
  },
  {
   value: "Kuito Terminal (AOKOT)",
   label: "Kuito Terminal (AOKOT)"
  },
  {
   value: "Lombo Terminal (AOLBT)",
   label: "Lombo Terminal (AOLBT)"
  },
  {
   value: "Mocamedes (AOMOS)",
   label: "Mocamedes (AOMOS)"
  },
  {
   value: "Nóqui (AONQI)",
   label: "Nóqui (AONQI)"
  },
  {
   value: "Novo Redondo = Sumbe (AO)",
   label: "Novo Redondo = Sumbe (AO)"
  },
  {
   value: "Porto Saco (Portosalazar) (AOPSA)",
   label: "Porto Saco (Portosalazar) (AOPSA)"
  },
  {
   value: "River Sao Nicolau (AORSN)",
   label: "River Sao Nicolau (AORSN)"
  },
  {
   value: "Sazaire Terminal (AOSTL)",
   label: "Sazaire Terminal (AOSTL)"
  },
  {
   value: "Sonils (AOSON)",
   label: "Sonils (AOSON)"
  },
  {
   value: "Kiame Terminal (AOKTI)",
   label: "Kiame Terminal (AOKTI)"
  },
  {
   value: "Punda (ANPUN)",
   label: "Punda (ANPUN)"
  },
  {
   value: "Santa Rosa, Curacao (ANSTR)",
   label: "Santa Rosa, Curacao (ANSTR)"
  },
  {
   value: "The Bottom (ANBOT)",
   label: "The Bottom (ANBOT)"
  },
  {
   value: "Baba (AOBAB)",
   label: "Baba (AOBAB)"
  },
  {
   value: "Capulo (AOCPO)",
   label: "Capulo (AOCPO)"
  },
  {
   value: "Cuio (AOCUI)",
   label: "Cuio (AOCUI)"
  },
  {
   value: "Dalia (AODAL)",
   label: "Dalia (AODAL)"
  },
  {
   value: "Essungo Terminal (AOETN)",
   label: "Essungo Terminal (AOETN)"
  },
  {
   value: "Farta Bay (AOFBY)",
   label: "Farta Bay (AOFBY)"
  },
  {
   value: "Futila Terminal (AOFLT)",
   label: "Futila Terminal (AOFLT)"
  },
  {
   value: "Girassol Terminal (AOGIR)",
   label: "Girassol Terminal (AOGIR)"
  },
  {
   value: "Greater Plutonio (AOGPO)",
   label: "Greater Plutonio (AOGPO)"
  },
  {
   value: ".ANDORRA (AD)",
   label: ".ANDORRA (AD)"
  },
  {
   value: "Canillo (ADCAN)",
   label: "Canillo (ADCAN)"
  },
  {
   value: "Encamp (ADENC)",
   label: "Encamp (ADENC)"
  },
  {
   value: "Escaldes-Engordany (ADESC)",
   label: "Escaldes-Engordany (ADESC)"
  },
  {
   value: "La Farga de Moles (ADFMO)",
   label: "La Farga de Moles (ADFMO)"
  },
  {
   value: "La Massana (ADLMA)",
   label: "La Massana (ADLMA)"
  },
  {
   value: "Ordino (ADORD)",
   label: "Ordino (ADORD)"
  },
  {
   value: "Pas de la Casa (ADPAS)",
   label: "Pas de la Casa (ADPAS)"
  },
  {
   value: "Sant Julià (ADSJL)",
   label: "Sant Julià (ADSJL)"
  },
  {
   value: "Santa Coloma (ADSCO)",
   label: "Santa Coloma (ADSCO)"
  },
  {
   value: ".UNITED ARAB EMIRATES (AE)",
   label: ".UNITED ARAB EMIRATES (AE)"
  },
  {
   value: "Abu Musa (AEAMU)",
   label: "Abu Musa (AEAMU)"
  },
  {
   value: "Dibba (AEDBP)",
   label: "Dibba (AEDBP)"
  },
  {
   value: "Esnnad (AEEND)",
   label: "Esnnad (AEEND)"
  },
  {
   value: "Hulaylah Terminal (AEHTL)",
   label: "Hulaylah Terminal (AEHTL)"
  },
  {
   value: "Indooroodilly (AEIND)",
   label: "Indooroodilly (AEIND)"
  },
  {
   value: "Jumayrah (AEJYH)",
   label: "Jumayrah (AEJYH)"
  },
  {
   value: "Kalba (AEKLB)",
   label: "Kalba (AEKLB)"
  },
  {
   value: "Khalidia (AEKHA)",
   label: "Khalidia (AEKHA)"
  },
  {
   value: "Mina Khalid (AEMKH)",
   label: "Mina Khalid (AEMKH)"
  },
  {
   value: "Mussafah (AEAMF)",
   label: "Mussafah (AEAMF)"
  },
  {
   value: "Sadiyat I. (AESID)",
   label: "Sadiyat I. (AESID)"
  },
  {
   value: "Suez (AEUEZ)",
   label: "Suez (AEUEZ)"
  },
  {
   value: "The Palm Jumeirah (AEDUJ)",
   label: "The Palm Jumeirah (AEDUJ)"
  },
  {
   value: "Umm Al Nar (AEULR)",
   label: "Umm Al Nar (AEULR)"
  },
  {
   value: "Yas I. (AEYAS)",
   label: "Yas I. (AEYAS)"
  },
  {
   value: ".AFGHANISTAN (AF)",
   label: ".AFGHANISTAN (AF)"
  },
  {
   value: "Bagram (AFBAG)",
   label: "Bagram (AFBAG)"
  },
  {
   value: "Camp Bastion (AFCBN)",
   label: "Camp Bastion (AFCBN)"
  },
  {
   value: "Camp Leatherneck (AFCLN)",
   label: "Camp Leatherneck (AFCLN)"
  },
  {
   value: "Camp Salerno (AFCSO)",
   label: "Camp Salerno (AFCSO)"
  },
  {
   value: "Gardiz (AFGAR)",
   label: "Gardiz (AFGAR)"
  },
  {
   value: "Khowst (AFKHO)",
   label: "Khowst (AFKHO)"
  },
  {
   value: "Lashkar Gah (AFLAG)",
   label: "Lashkar Gah (AFLAG)"
  },
  {
   value: "Maiwand (AFMWD)",
   label: "Maiwand (AFMWD)"
  },
  {
   value: "Orgun-E Kalan (AFORG)",
   label: "Orgun-E Kalan (AFORG)"
  },
  {
   value: "Qalat (AFQLT)",
   label: "Qalat (AFQLT)"
  },
  {
   value: "Sharona (AFSRO)",
   label: "Sharona (AFSRO)"
  },
  {
   value: "Sherhan-Bandar (AFSHE)",
   label: "Sherhan-Bandar (AFSHE)"
  },
  {
   value: "Spin Buldak (AFSBK)",
   label: "Spin Buldak (AFSBK)"
  },
  {
   value: "Tarin Kowt (AFTKO)",
   label: "Tarin Kowt (AFTKO)"
  },
  {
   value: "Torkham (AFRKH)",
   label: "Torkham (AFRKH)"
  },
  {
   value: ".ANTIGUA AND BARBUDA (AG)",
   label: ".ANTIGUA AND BARBUDA (AG)"
  },
  {
   value: ".ANGUILLA (AI)",
   label: ".ANGUILLA (AI)"
  },
  {
   value: "Crocus Hill (AICRH)",
   label: "Crocus Hill (AICRH)"
  },
  {
   value: "Sombrero (AISOM)",
   label: "Sombrero (AISOM)"
  },
  {
   value: "The Valley (AIVAL)",
   label: "The Valley (AIVAL)"
  },
  {
   value: "Wall Blake (AIWLL)",
   label: "Wall Blake (AIWLL)"
  },
  {
   value: ".ALBANIA (AL)",
   label: ".ALBANIA (AL)"
  },
  {
   value: "Berat (ALBRT)",
   label: "Berat (ALBRT)"
  },
  {
   value: "Butrint (ALBUT)",
   label: "Butrint (ALBUT)"
  },
  {
   value: "Elbasan (ALNPP)",
   label: "Elbasan (ALNPP)"
  },
  {
   value: "Fier (ALFIE)",
   label: "Fier (ALFIE)"
  },
  {
   value: "Fushe Arrez (ALFUS)",
   label: "Fushe Arrez (ALFUS)"
  },
  {
   value: "Gjirokastër (ALGOK)",
   label: "Gjirokastër (ALGOK)"
  },
  {
   value: "Himare (ALHMR)",
   label: "Himare (ALHMR)"
  },
  {
   value: "Korçë (ALKRC)",
   label: "Korçë (ALKRC)"
  },
  {
   value: "Shkoder (ALSHK)",
   label: "Shkoder (ALSHK)"
  },
  {
   value: ".ARMENIA (AM)",
   label: ".ARMENIA (AM)"
  },
  {
   value: "Abovyan (AMABO)",
   label: "Abovyan (AMABO)"
  },
  {
   value: "Ararat (AMARA)",
   label: "Ararat (AMARA)"
  },
  {
   value: "Ashtarak (AMASH)",
   label: "Ashtarak (AMASH)"
  },
  {
   value: "Ecmiadzin (AMEZN)",
   label: "Ecmiadzin (AMEZN)"
  },
  {
   value: "Masis (AMARM)",
   label: "Masis (AMARM)"
  },
  {
   value: "Vanadzor (AMVZR)",
   label: "Vanadzor (AMVZR)"
  },
  {
   value: ".NETHERLANDS ANTILLES (AN)",
   label: ".NETHERLANDS ANTILLES (AN)"
  },
  {
   value: "Gallis Bay, St.Marten (ANGES)",
   label: "Gallis Bay, St.Marten (ANGES)"
  },
  {
   value: "Goto (ANGOT)",
   label: "Goto (ANGOT)"
  },
  {
   value: "Otrobanda (ANOTB)",
   label: "Otrobanda (ANOTB)"
  },
  {
   value: "Genderkingen (DEGNK)",
   label: "Genderkingen (DEGNK)"
  },
  {
   value: "Gendorf (DEZGF)",
   label: "Gendorf (DEZGF)"
  },
  {
   value: "Genshagen (DEGHG)",
   label: "Genshagen (DEGHG)"
  },
  {
   value: "Genthin (DEGNT)",
   label: "Genthin (DEGNT)"
  },
  {
   value: "Georgensgmünd (DEGGD)",
   label: "Georgensgmünd (DEGGD)"
  },
  {
   value: "Georgsheil (DEGGL)",
   label: "Georgsheil (DEGGL)"
  },
  {
   value: "Gerhardshofen (DEGOY)",
   label: "Gerhardshofen (DEGOY)"
  },
  {
   value: "Gerichshain (DEGHA)",
   label: "Gerichshain (DEGHA)"
  },
  {
   value: "Geringswalde (DEGWA)",
   label: "Geringswalde (DEGWA)"
  },
  {
   value: "Germaringen (DEGMI)",
   label: "Germaringen (DEGMI)"
  },
  {
   value: "Germering (DEGEG)",
   label: "Germering (DEGEG)"
  },
  {
   value: "Geroldsgrün (DEZGE)",
   label: "Geroldsgrün (DEZGE)"
  },
  {
   value: "Gersfeld (DEGFD)",
   label: "Gersfeld (DEGFD)"
  },
  {
   value: "Gersheim (DEGHZ)",
   label: "Gersheim (DEGHZ)"
  },
  {
   value: "Gerstetten (DEGTT)",
   label: "Gerstetten (DEGTT)"
  },
  {
   value: "Gerstungen (DEGTE)",
   label: "Gerstungen (DEGTE)"
  },
  {
   value: "Geschwenda (DEGSD)",
   label: "Geschwenda (DEGSD)"
  },
  {
   value: "Gettorf (DEGEF)",
   label: "Gettorf (DEGEF)"
  },
  {
   value: "Geyer (DEGYR)",
   label: "Geyer (DEGYR)"
  },
  {
   value: "Giesen (DENZG)",
   label: "Giesen (DENZG)"
  },
  {
   value: "Gimmeldingen (DEGXN)",
   label: "Gimmeldingen (DEGXN)"
  },
  {
   value: "Ginepp (DEGNP)",
   label: "Ginepp (DEGNP)"
  },
  {
   value: "Gingst (DEGNS)",
   label: "Gingst (DEGNS)"
  },
  {
   value: "Girod (DEGIR)",
   label: "Girod (DEGIR)"
  },
  {
   value: "Glashutte (DEGLT)",
   label: "Glashutte (DEGLT)"
  },
  {
   value: "Glashütten (DEGHT)",
   label: "Glashütten (DEGHT)"
  },
  {
   value: "Glasow (DEGLW)",
   label: "Glasow (DEGLW)"
  },
  {
   value: "Glaubitz (DEGBZ)",
   label: "Glaubitz (DEGBZ)"
  },
  {
   value: "Glauburg (DEHZG)",
   label: "Glauburg (DEHZG)"
  },
  {
   value: "Gleichamberg (DEGLE)",
   label: "Gleichamberg (DEGLE)"
  },
  {
   value: "Gleina (DEGLX)",
   label: "Gleina (DEGLX)"
  },
  {
   value: "Glienicke (DECLK)",
   label: "Glienicke (DECLK)"
  },
  {
   value: "Glindow (DEGDW)",
   label: "Glindow (DEGDW)"
  },
  {
   value: "Glöthe (DEGLO)",
   label: "Glöthe (DEGLO)"
  },
  {
   value: "Gmund am Tegernsee (DEUND)",
   label: "Gmund am Tegernsee (DEUND)"
  },
  {
   value: "Gnadau (DEGDA)",
   label: "Gnadau (DEGDA)"
  },
  {
   value: "Göbitz (DEOBI)",
   label: "Göbitz (DEOBI)"
  },
  {
   value: "Göda (DEGDR)",
   label: "Göda (DEGDR)"
  },
  {
   value: "Goddert (DEGOD)",
   label: "Goddert (DEGOD)"
  },
  {
   value: "Gödenroth (DEXRE)",
   label: "Gödenroth (DEXRE)"
  },
  {
   value: "Godorf (DEGDO)",
   label: "Godorf (DEGDO)"
  },
  {
   value: "Goeland (DEGLD)",
   label: "Goeland (DEGLD)"
  },
  {
   value: "Goldbach (DEGDH)",
   label: "Goldbach (DEGDH)"
  },
  {
   value: "Goldenstedt (DEZOD)",
   label: "Goldenstedt (DEZOD)"
  },
  {
   value: "Goldkronach (DEGKR)",
   label: "Goldkronach (DEGKR)"
  },
  {
   value: "Gollhofen (DEGHF)",
   label: "Gollhofen (DEGHF)"
  },
  {
   value: "Golssen (DEGOL)",
   label: "Golssen (DEGOL)"
  },
  {
   value: "Golzow (DEGLZ)",
   label: "Golzow (DEGLZ)"
  },
  {
   value: "Gommern (DEMMR)",
   label: "Gommern (DEMMR)"
  },
  {
   value: "Gommla (DEGMM)",
   label: "Gommla (DEGMM)"
  },
  {
   value: "Görschen (DEGSC)",
   label: "Görschen (DEGSC)"
  },
  {
   value: "Görwihl (DEGWL)",
   label: "Görwihl (DEGWL)"
  },
  {
   value: "Görzig (DEZGG)",
   label: "Görzig (DEZGG)"
  },
  {
   value: "Gorzke (DEGZK)",
   label: "Gorzke (DEGZK)"
  },
  {
   value: "Gosheim (DEGOI)",
   label: "Gosheim (DEGOI)"
  },
  {
   value: "Gössweinstein (DEGWN)",
   label: "Gössweinstein (DEGWN)"
  },
  {
   value: "Gottenheim (DENOO)",
   label: "Gottenheim (DENOO)"
  },
  {
   value: "Gottfrieding (DEGID)",
   label: "Gottfrieding (DEGID)"
  },
  {
   value: "Graach (DEGHR)",
   label: "Graach (DEGHR)"
  },
  {
   value: "Grabow (DEGBO)",
   label: "Grabow (DEGBO)"
  },
  {
   value: "Grabsleben (DEGSL)",
   label: "Grabsleben (DEGSL)"
  },
  {
   value: "Gräfelfing (DEGGZ)",
   label: "Gräfelfing (DEGGZ)"
  },
  {
   value: "Grafenberg (DEZBA)",
   label: "Grafenberg (DEZBA)"
  },
  {
   value: "Grafengehaig (DEGGA)",
   label: "Grafengehaig (DEGGA)"
  },
  {
   value: "Grafenhausen (DEGFH)",
   label: "Grafenhausen (DEGFH)"
  },
  {
   value: "Grafenrheinfeld (DEGHE)",
   label: "Grafenrheinfeld (DEGHE)"
  },
  {
   value: "Grafing (DEGFG)",
   label: "Grafing (DEGFG)"
  },
  {
   value: "Grafschaft (DEGFF)",
   label: "Grafschaft (DEGFF)"
  },
  {
   value: "Grafschaft (DEGFT)",
   label: "Grafschaft (DEGFT)"
  },
  {
   value: "Grammdorf (DEGRQ)",
   label: "Grammdorf (DEGRQ)"
  },
  {
   value: "Gransee (DEGSX)",
   label: "Gransee (DEGSX)"
  },
  {
   value: "Granzin (DEGNZ)",
   label: "Granzin (DEGNZ)"
  },
  {
   value: "Grasbrunn (DEGBU)",
   label: "Grasbrunn (DEGBU)"
  },
  {
   value: "Gras-Ellenbach (DEGSE)",
   label: "Gras-Ellenbach (DEGSE)"
  },
  {
   value: "Grassau (DEGSU)",
   label: "Grassau (DEGSU)"
  },
  {
   value: "Grävenwiesbach (DEGWH)",
   label: "Grävenwiesbach (DEGWH)"
  },
  {
   value: "Grebenau (DEZGU)",
   label: "Grebenau (DEZGU)"
  },
  {
   value: "Greding (DEGDI)",
   label: "Greding (DEGDI)"
  },
  {
   value: "Greifenberg (DEFEN)",
   label: "Greifenberg (DEFEN)"
  },
  {
   value: "Greifenstein (DEGFS)",
   label: "Greifenstein (DEGFS)"
  },
  {
   value: "Grettstadt (DETAD)",
   label: "Grettstadt (DETAD)"
  },
  {
   value: "Greussen (DEGEU)",
   label: "Greussen (DEGEU)"
  },
  {
   value: "Grimberg (DEGMR)",
   label: "Grimberg (DEGMR)"
  },
  {
   value: "Grimma (DEGMA)",
   label: "Grimma (DEGMA)"
  },
  {
   value: "Grimme (DEZGR)",
   label: "Grimme (DEZGR)"
  },
  {
   value: "Grimmen (DEGMN)",
   label: "Grimmen (DEGMN)"
  },
  {
   value: "Grobenstadt (DEGRY)",
   label: "Grobenstadt (DEGRY)"
  },
  {
   value: "Grolsheim (DEGLM)",
   label: "Grolsheim (DEGLM)"
  },
  {
   value: "Grömitz (DEGMZ)",
   label: "Grömitz (DEGMZ)"
  },
  {
   value: "Grönenbach (DEBGB)",
   label: "Grönenbach (DEBGB)"
  },
  {
   value: "Groppenbruch (DEGPR)",
   label: "Groppenbruch (DEGPR)"
  },
  {
   value: "Gross Ammersleben (DEGAS)",
   label: "Gross Ammersleben (DEGAS)"
  },
  {
   value: "Gross Ippener (DEGIP)",
   label: "Gross Ippener (DEGIP)"
  },
  {
   value: "Gross Kienitz (DEGRK)",
   label: "Gross Kienitz (DEGRK)"
  },
  {
   value: "Gross Kreutz (DEZUZ)",
   label: "Gross Kreutz (DEZUZ)"
  },
  {
   value: "Gross Machnow (DEGMW)",
   label: "Gross Machnow (DEGMW)"
  },
  {
   value: "Gross Oesingen (DEGOG)",
   label: "Gross Oesingen (DEGOG)"
  },
  {
   value: "Gross Pampau (DEGPA)",
   label: "Gross Pampau (DEGPA)"
  },
  {
   value: "Gross Rheide (DEGRX)",
   label: "Gross Rheide (DEGRX)"
  },
  {
   value: "Gross Rohrheim (DEZDX)",
   label: "Gross Rohrheim (DEZDX)"
  },
  {
   value: "Grossaitingen (DEGTI)",
   label: "Grossaitingen (DEGTI)"
  },
  {
   value: "Grossauheim (DEGSS)",
   label: "Grossauheim (DEGSS)"
  },
  {
   value: "Grossbeeren (DEGRB)",
   label: "Grossbeeren (DEGRB)"
  },
  {
   value: "Grossbettlingen (DEGOB)",
   label: "Grossbettlingen (DEGOB)"
  },
  {
   value: "Gross-Bieberau (DEGBI)",
   label: "Gross-Bieberau (DEGBI)"
  },
  {
   value: "Grossbodungem (DEGBD)",
   label: "Grossbodungem (DEGBD)"
  },
  {
   value: "Grossbottwar (DEGBW)",
   label: "Grossbottwar (DEGBW)"
  },
  {
   value: "Grossefehn (DEGOF)",
   label: "Grossefehn (DEGOF)"
  },
  {
   value: "Grosseichholzheim (DEHHO)",
   label: "Grosseichholzheim (DEHHO)"
  },
  {
   value: "Grossen Buseck (DEGBK)",
   label: "Grossen Buseck (DEGBK)"
  },
  {
   value: "Grossengottern (DEZTG)",
   label: "Grossengottern (DEZTG)"
  },
  {
   value: "Grossenkneten (DEGSK)",
   label: "Grossenkneten (DEGSK)"
  },
  {
   value: "Grossenlüder (DEENL)",
   label: "Grossenlüder (DEENL)"
  },
  {
   value: "Grossensiel (DEGSI)",
   label: "Grossensiel (DEGSI)"
  },
  {
   value: "Grossgorschen (DEGGR)",
   label: "Grossgorschen (DEGGR)"
  },
  {
   value: "Grossharthau (DEGHH)",
   label: "Grossharthau (DEGHH)"
  },
  {
   value: "Grosshelfendorf (DEGHO)",
   label: "Grosshelfendorf (DEGHO)"
  },
  {
   value: "Grosskarlbach (DEGKB)",
   label: "Grosskarlbach (DEGKB)"
  },
  {
   value: "Grosskarolinenfeld (DEZGD)",
   label: "Grosskarolinenfeld (DEZGD)"
  },
  {
   value: "Grosskayna (DEGKY)",
   label: "Grosskayna (DEGKY)"
  },
  {
   value: "Grosskitzighofen (DEGFE)",
   label: "Grosskitzighofen (DEGFE)"
  },
  {
   value: "Grosskoschen (DEGOK)",
   label: "Grosskoschen (DEGOK)"
  },
  {
   value: "Grosslehna (DEGSA)",
   label: "Grosslehna (DEGSA)"
  },
  {
   value: "Grossmachnow (DEGCW)",
   label: "Grossmachnow (DEGCW)"
  },
  {
   value: "Grossmaischeid (DEGMD)",
   label: "Grossmaischeid (DEGMD)"
  },
  {
   value: "Grossmehring (DEGME)",
   label: "Grossmehring (DEGME)"
  },
  {
   value: "Grössnitz (DEGSN)",
   label: "Grössnitz (DEGSN)"
  },
  {
   value: "Grossörner (DEGOO)",
   label: "Grossörner (DEGOO)"
  },
  {
   value: "Grossostheim (DEGHI)",
   label: "Grossostheim (DEGHI)"
  },
  {
   value: "Grosspösna (DEGOP)",
   label: "Grosspösna (DEGOP)"
  },
  {
   value: "Grossräschen (DEGRC)",
   label: "Grossräschen (DEGRC)"
  },
  {
   value: "Grossrinderfeld (DEGZD)",
   label: "Grossrinderfeld (DEGZD)"
  },
  {
   value: "Gross-Rohrheim (DEGBR)",
   label: "Gross-Rohrheim (DEGBR)"
  },
  {
   value: "Grossrosseln (DEGDK)",
   label: "Grossrosseln (DEGDK)"
  },
  {
   value: "Grossrückerswalde (DEGSW)",
   label: "Grossrückerswalde (DEGSW)"
  },
  {
   value: "Grossschirma (DEGCA)",
   label: "Grossschirma (DEGCA)"
  },
  {
   value: "Gross-Umstadt (DEGXD)",
   label: "Gross-Umstadt (DEGXD)"
  },
  {
   value: "Gross-Umstadt (DEUMS)",
   label: "Gross-Umstadt (DEUMS)"
  },
  {
   value: "Grosswechsungen (DEGWC)",
   label: "Grosswechsungen (DEGWC)"
  },
  {
   value: "Gross-Zimmern (DEGZI)",
   label: "Gross-Zimmern (DEGZI)"
  },
  {
   value: "Grosszöberitz (DEGSZ)",
   label: "Grosszöberitz (DEGSZ)"
  },
  {
   value: "Grub am Forst (DEGAF)",
   label: "Grub am Forst (DEGAF)"
  },
  {
   value: "Grubo (DEGUO)",
   label: "Grubo (DEGUO)"
  },
  {
   value: "Gruibingen (DEGBE)",
   label: "Gruibingen (DEGBE)"
  },
  {
   value: "Grumbach (DEGMB)",
   label: "Grumbach (DEGMB)"
  },
  {
   value: "Grundau (DEGND)",
   label: "Grundau (DEGND)"
  },
  {
   value: "Gründau (DEGDU)",
   label: "Gründau (DEGDU)"
  },
  {
   value: "Grünheide (DEGZB)",
   label: "Grünheide (DEGZB)"
  },
  {
   value: "Grünheide (Mark) (DEGMK)",
   label: "Grünheide (Mark) (DEGMK)"
  },
  {
   value: "Grünheinichen (DENHH)",
   label: "Grünheinichen (DENHH)"
  },
  {
   value: "Grünkraut (DEZGT)",
   label: "Grünkraut (DEZGT)"
  },
  {
   value: "Grünsfeld (DEGUU)",
   label: "Grünsfeld (DEGUU)"
  },
  {
   value: "Grünwald (DEGUD)",
   label: "Grünwald (DEGUD)"
  },
  {
   value: "Gschwend (DEGWD)",
   label: "Gschwend (DEGWD)"
  },
  {
   value: "Gudderath (DEGDZ)",
   label: "Gudderath (DEGDZ)"
  },
  {
   value: "Gudensberg (DEUGG)",
   label: "Gudensberg (DEUGG)"
  },
  {
   value: "Güdingen (DEGDG)",
   label: "Güdingen (DEGDG)"
  },
  {
   value: "Guenzach (DEZHG)",
   label: "Guenzach (DEZHG)"
  },
  {
   value: "Gundelfingen (DEFIN)",
   label: "Gundelfingen (DEFIN)"
  },
  {
   value: "Gundelfingen (DEGFI)",
   label: "Gundelfingen (DEGFI)"
  },
  {
   value: "Gungolding (DEGGG)",
   label: "Gungolding (DEGGG)"
  },
  {
   value: "Guntersblum (DERPG)",
   label: "Guntersblum (DERPG)"
  },
  {
   value: "Günthersdorf (DEGTD)",
   label: "Günthersdorf (DEGTD)"
  },
  {
   value: "Gusen (DEGUE)",
   label: "Gusen (DEGUE)"
  },
  {
   value: "Gusterath (DEGUA)",
   label: "Gusterath (DEGUA)"
  },
  {
   value: "Gutach (Schwarzwaldbahn) (DEGAH)",
   label: "Gutach (Schwarzwaldbahn) (DEGAH)"
  },
  {
   value: "Gutach im Breisgau (DEGUC)",
   label: "Gutach im Breisgau (DEGUC)"
  },
  {
   value: "Gutenstetten (DETUU)",
   label: "Gutenstetten (DETUU)"
  },
  {
   value: "Guttau (DEGTU)",
   label: "Guttau (DEGTU)"
  },
  {
   value: "Guxhagen (DEGUX)",
   label: "Guxhagen (DEGUX)"
  },
  {
   value: "Haar (DEHAQ)",
   label: "Haar (DEHAQ)"
  },
  {
   value: "Habaching (DEHBA)",
   label: "Habaching (DEHBA)"
  },
  {
   value: "Hadamar (DEHAD)",
   label: "Hadamar (DEHAD)"
  },
  {
   value: "Haeusern (DEHUU)",
   label: "Haeusern (DEHUU)"
  },
  {
   value: "Hagelstadt (DEHDT)",
   label: "Hagelstadt (DEHDT)"
  },
  {
   value: "Hagenbach (DEHNC)",
   label: "Hagenbach (DEHNC)"
  },
  {
   value: "Hagenwerder (DEHWR)",
   label: "Hagenwerder (DEHWR)"
  },
  {
   value: "Hahn (DEAHP)",
   label: "Hahn (DEAHP)"
  },
  {
   value: "Hahn Apt (DEHNH)",
   label: "Hahn Apt (DEHNH)"
  },
  {
   value: "Hahnstätten (DEHNS)",
   label: "Hahnstätten (DEHNS)"
  },
  {
   value: "Haigerloch (DERUW)",
   label: "Haigerloch (DERUW)"
  },
  {
   value: "Hainewalde (DEHIW)",
   label: "Hainewalde (DEHIW)"
  },
  {
   value: "Hain-Gründau (DEHGU)",
   label: "Hain-Gründau (DEHGU)"
  },
  {
   value: "Hainichen (DEHSQ)",
   label: "Hainichen (DEHSQ)"
  },
  {
   value: "Hainsfarth (DEHFA)",
   label: "Hainsfarth (DEHFA)"
  },
  {
   value: "Halbe (DEAGR)",
   label: "Halbe (DEAGR)"
  },
  {
   value: "Halblech (DELBL)",
   label: "Halblech (DELBL)"
  },
  {
   value: "Haldenwang (DEHDG)",
   label: "Haldenwang (DEHDG)"
  },
  {
   value: "Halfing (DEHFG)",
   label: "Halfing (DEHFG)"
  },
  {
   value: "Hallbergmoos (DEHMS)",
   label: "Hallbergmoos (DEHMS)"
  },
  {
   value: "Hallerndorf (DEZHF)",
   label: "Hallerndorf (DEZHF)"
  },
  {
   value: "Halsbrücke (DEHKK)",
   label: "Halsbrücke (DEHKK)"
  },
  {
   value: "Halsenbach (DELSE)",
   label: "Halsenbach (DELSE)"
  },
  {
   value: "Hamberge (DEZBC)",
   label: "Hamberge (DEZBC)"
  },
  {
   value: "Hambergen (DEHAB)",
   label: "Hambergen (DEHAB)"
  },
  {
   value: "Hambühren (DEHAP)",
   label: "Hambühren (DEHAP)"
  },
  {
   value: "Hamlar (DEMLR)",
   label: "Hamlar (DEMLR)"
  },
  {
   value: "Hammelburg (DEHMB)",
   label: "Hammelburg (DEHMB)"
  },
  {
   value: "Hammerau (DEHQU)",
   label: "Hammerau (DEHQU)"
  },
  {
   value: "Hammerunterwiesenthal (DEHUW)",
   label: "Hammerunterwiesenthal (DEHUW)"
  },
  {
   value: "Hankensbüttel (DEHBL)",
   label: "Hankensbüttel (DEHBL)"
  },
  {
   value: "Harbarnsen (DEZHN)",
   label: "Harbarnsen (DEZHN)"
  },
  {
   value: "Harbke (DEHKE)",
   label: "Harbke (DEHKE)"
  },
  {
   value: "Hardthausen am Kocher (DEHHK)",
   label: "Hardthausen am Kocher (DEHHK)"
  },
  {
   value: "Harlesiel (DEHSX)",
   label: "Harlesiel (DEHSX)"
  },
  {
   value: "Harpstedt (DEHZT)",
   label: "Harpstedt (DEHZT)"
  },
  {
   value: "Harschbach (DEHCA)",
   label: "Harschbach (DEHCA)"
  },
  {
   value: "Harsdorf (DEHSF)",
   label: "Harsdorf (DEHSF)"
  },
  {
   value: "Harsefeld (DEHFD)",
   label: "Harsefeld (DEHFD)"
  },
  {
   value: "Harsleben (DEHSE)",
   label: "Harsleben (DEHSE)"
  },
  {
   value: "Hartenstein (DEHTS)",
   label: "Hartenstein (DEHTS)"
  },
  {
   value: "Hartheim (DEHMT)",
   label: "Hartheim (DEHMT)"
  },
  {
   value: "Hartmannsdorf (DEHMF)",
   label: "Hartmannsdorf (DEHMF)"
  },
  {
   value: "Harzgerode (DEHGO)",
   label: "Harzgerode (DEHGO)"
  },
  {
   value: "Hasbergen (DENIH)",
   label: "Hasbergen (DENIH)"
  },
  {
   value: "Haseldorf (DEHLO)",
   label: "Haseldorf (DEHLO)"
  },
  {
   value: "Hasloch (DEHAO)",
   label: "Hasloch (DEHAO)"
  },
  {
   value: "Hasselroth (DEZAT)",
   label: "Hasselroth (DEZAT)"
  },
  {
   value: "Hassloch (DEHSC)",
   label: "Hassloch (DEHSC)"
  },
  {
   value: "Hatten (DETTE)",
   label: "Hatten (DETTE)"
  },
  {
   value: "Hattenheim (DEHME)",
   label: "Hattenheim (DEHME)"
  },
  {
   value: "Hattenhofen (DEHNO)",
   label: "Hattenhofen (DEHNO)"
  },
  {
   value: "Hattenhofen (DEHTF)",
   label: "Hattenhofen (DEHTF)"
  },
  {
   value: "Hattorf (DEHTO)",
   label: "Hattorf (DEHTO)"
  },
  {
   value: "Hatzenbühl (DEHZ2)",
   label: "Hatzenbühl (DEHZ2)"
  },
  {
   value: "Hauenstein (DEAUT)",
   label: "Hauenstein (DEAUT)"
  },
  {
   value: "Haundorf (DEHOA)",
   label: "Haundorf (DEHOA)"
  },
  {
   value: "Hausen (DEHAX)",
   label: "Hausen (DEHAX)"
  },
  {
   value: "Hausham (DEHUH)",
   label: "Hausham (DEHUH)"
  },
  {
   value: "Häuslingen (DEHSN)",
   label: "Häuslingen (DEHSN)"
  },
  {
   value: "Hauswalde (DEHSV)",
   label: "Hauswalde (DEHSV)"
  },
  {
   value: "Hebertsfelden (DEEXE)",
   label: "Hebertsfelden (DEEXE)"
  },
  {
   value: "Heckelberg (DEHKB)",
   label: "Heckelberg (DEHKB)"
  },
  {
   value: "Hedemünden (DEHEQ)",
   label: "Hedemünden (DEHEQ)"
  },
  {
   value: "Heek (DEHXQ)",
   label: "Heek (DEHXQ)"
  },
  {
   value: "Heeslingen (DEZAN)",
   label: "Heeslingen (DEZAN)"
  },
  {
   value: "Hehlen (DEHHL)",
   label: "Hehlen (DEHHL)"
  },
  {
   value: "Heidenau (DEHDA)",
   label: "Heidenau (DEHDA)"
  },
  {
   value: "Heidenrod (DEAAA)",
   label: "Heidenrod (DEAAA)"
  },
  {
   value: "Heidkaten (DEHDK)",
   label: "Heidkaten (DEHDK)"
  },
  {
   value: "Heilbad Heiligenstadt (DEHHI)",
   label: "Heilbad Heiligenstadt (DEHHI)"
  },
  {
   value: "Heiligengrabe (DEHGG)",
   label: "Heiligengrabe (DEHGG)"
  },
  {
   value: "Heiligenroth (DEHII)",
   label: "Heiligenroth (DEHII)"
  },
  {
   value: "Heimboldshausen (DEHSS)",
   label: "Heimboldshausen (DEHSS)"
  },
  {
   value: "Heimerdingen (DEHMN)",
   label: "Heimerdingen (DEHMN)"
  },
  {
   value: "Heiningen (DEHNE)",
   label: "Heiningen (DEHNE)"
  },
  {
   value: "Heinsdorfergrund (DEHDD)",
   label: "Heinsdorfergrund (DEHDD)"
  },
  {
   value: "Heising (DEHEX)",
   label: "Heising (DEHEX)"
  },
  {
   value: "Heiterbach (DEHIT)",
   label: "Heiterbach (DEHIT)"
  },
  {
   value: "Heitersheim (DEHTH)",
   label: "Heitersheim (DEHTH)"
  },
  {
   value: "Helbra (DEZAH)",
   label: "Helbra (DEZAH)"
  },
  {
   value: "Heldburg (DEHUR)",
   label: "Heldburg (DEHUR)"
  },
  {
   value: "Heldenstein (DEHDS)",
   label: "Heldenstein (DEHDS)"
  },
  {
   value: "Helmbrechts (DEMHS)",
   label: "Helmbrechts (DEMHS)"
  },
  {
   value: "Helmlingen (DEHML)",
   label: "Helmlingen (DEHML)"
  },
  {
   value: "Helmstadt-Bargen (DEHXN)",
   label: "Helmstadt-Bargen (DEHXN)"
  },
  {
   value: "Helsa (DEHLA)",
   label: "Helsa (DEHLA)"
  },
  {
   value: "Hemau (DEHMA)",
   label: "Hemau (DEHMA)"
  },
  {
   value: "Hemelingen (DEHNR)",
   label: "Hemelingen (DEHNR)"
  },
  {
   value: "Hemme (DEXHE)",
   label: "Hemme (DEXHE)"
  },
  {
   value: "Hemmingen (DEHMI)",
   label: "Hemmingen (DEHMI)"
  },
  {
   value: "Hemmingen (DEMIG)",
   label: "Hemmingen (DEMIG)"
  },
  {
   value: "Hemmingstedt (DEHMD)",
   label: "Hemmingstedt (DEHMD)"
  },
  {
   value: "Hemsloh (DEHSO)",
   label: "Hemsloh (DEHSO)"
  },
  {
   value: "Hennickendorf (DEHKD)",
   label: "Hennickendorf (DEHKD)"
  },
  {
   value: "Hennigsdorf (DEHNF)",
   label: "Hennigsdorf (DEHNF)"
  },
  {
   value: "Henschtal (DEZHO)",
   label: "Henschtal (DEZHO)"
  },
  {
   value: "Herbertingen (DEXRT)",
   label: "Herbertingen (DEXRT)"
  },
  {
   value: "Herbolzheim (DEHBM)",
   label: "Herbolzheim (DEHBM)"
  },
  {
   value: "Herbsleben (DEZRB)",
   label: "Herbsleben (DEZRB)"
  },
  {
   value: "Herbstein (DERBT)",
   label: "Herbstein (DERBT)"
  },
  {
   value: "Herdorf (DEHEO)",
   label: "Herdorf (DEHEO)"
  },
  {
   value: "Herdwangen (DEHHR)",
   label: "Herdwangen (DEHHR)"
  },
  {
   value: "Hergatz (DEHGZ)",
   label: "Hergatz (DEHGZ)"
  },
  {
   value: "Hergensweiler (DEHSR)",
   label: "Hergensweiler (DEHSR)"
  },
  {
   value: "Hergensweiler (DERWL)",
   label: "Hergensweiler (DERWL)"
  },
  {
   value: "Hergersweiler (DEHEW)",
   label: "Hergersweiler (DEHEW)"
  },
  {
   value: "Hergolding (DEZHR)",
   label: "Hergolding (DEZHR)"
  },
  {
   value: "Hermsdorf (DERRS)",
   label: "Hermsdorf (DERRS)"
  },
  {
   value: "Heroldsberg (DEHSG)",
   label: "Heroldsberg (DEHSG)"
  },
  {
   value: "Herongen (DEHGX)",
   label: "Herongen (DEHGX)"
  },
  {
   value: "Herrieden (DERRI)",
   label: "Herrieden (DERRI)"
  },
  {
   value: "Herrngiersdorf (DEHGI)",
   label: "Herrngiersdorf (DEHGI)"
  },
  {
   value: "Herrstein (DERSI)",
   label: "Herrstein (DERSI)"
  },
  {
   value: "Herten (DEHRT)",
   label: "Herten (DEHRT)"
  },
  {
   value: "Herxheim am Berg (DEXME)",
   label: "Herxheim am Berg (DEXME)"
  },
  {
   value: "Herxheim bei Landau\/Pfalz (DEHXL)",
   label: "Herxheim bei Landau\/Pfalz (DEHXL)"
  },
  {
   value: "Herzebrock (DEHZC)",
   label: "Herzebrock (DEHZC)"
  },
  {
   value: "Herzfelde (DEHZQ)",
   label: "Herzfelde (DEHZQ)"
  },
  {
   value: "Herzlake (DEHZL)",
   label: "Herzlake (DEHZL)"
  },
  {
   value: "Hesel (DEZHL)",
   label: "Hesel (DEZHL)"
  },
  {
   value: "Hessdorf (DEHDR)",
   label: "Hessdorf (DEHDR)"
  },
  {
   value: "Hesselte (DESSL)",
   label: "Hesselte (DESSL)"
  },
  {
   value: "Hessen (DESSS)",
   label: "Hessen (DESSS)"
  },
  {
   value: "Hessigheim (DEHGH)",
   label: "Hessigheim (DEHGH)"
  },
  {
   value: "Hessisch Oldendorf (DEHOF)",
   label: "Hessisch Oldendorf (DEHOF)"
  },
  {
   value: "Hettstedt (DEHTD)",
   label: "Hettstedt (DEHTD)"
  },
  {
   value: "Heuchelheim (DEHRU)",
   label: "Heuchelheim (DEHRU)"
  },
  {
   value: "Heusweiler (DEHSW)",
   label: "Heusweiler (DEHSW)"
  },
  {
   value: "Heynitz (DEHYZ)",
   label: "Heynitz (DEHYZ)"
  },
  {
   value: "Hiddingsel (DEHDI)",
   label: "Hiddingsel (DEHDI)"
  },
  {
   value: "Hildrizhausen (DEHIZ)",
   label: "Hildrizhausen (DEHIZ)"
  },
  {
   value: "Hilgert (DEHGT)",
   label: "Hilgert (DEHGT)"
  },
  {
   value: "Hilgertshausen-Tandern (DEZHI)",
   label: "Hilgertshausen-Tandern (DEZHI)"
  },
  {
   value: "Hillscheid (DEHLD)",
   label: "Hillscheid (DEHLD)"
  },
  {
   value: "Hilmersdorf (DEHDO)",
   label: "Hilmersdorf (DEHDO)"
  },
  {
   value: "Hilpoltstein (DEHPN)",
   label: "Hilpoltstein (DEHPN)"
  },
  {
   value: "Hiltrup (DEHLP)",
   label: "Hiltrup (DEHLP)"
  },
  {
   value: "Hilzingen (DEHLZ)",
   label: "Hilzingen (DEHLZ)"
  },
  {
   value: "Himmelkron (DEHIK)",
   label: "Himmelkron (DEHIK)"
  },
  {
   value: "Himmelpforten (DEZIF)",
   label: "Himmelpforten (DEZIF)"
  },
  {
   value: "Hinternah (DEZHH)",
   label: "Hinternah (DEZHH)"
  },
  {
   value: "Hirrlingen (DEHIG)",
   label: "Hirrlingen (DEHIG)"
  },
  {
   value: "Hirschaid (DEZDH)",
   label: "Hirschaid (DEZDH)"
  },
  {
   value: "Hirschberg (DEHGD)",
   label: "Hirschberg (DEHGD)"
  },
  {
   value: "Hirschfelde (DEHIF)",
   label: "Hirschfelde (DEHIF)"
  },
  {
   value: "Hirzenhein (DEHRE)",
   label: "Hirzenhein (DEHRE)"
  },
  {
   value: "Hittbergen (DEHTB)",
   label: "Hittbergen (DEHTB)"
  },
  {
   value: "Hitzacker (DENZH)",
   label: "Hitzacker (DENZH)"
  },
  {
   value: "Höchberg (DEZDF)",
   label: "Höchberg (DEZDF)"
  },
  {
   value: "Hochbruck (DEHCB)",
   label: "Hochbruck (DEHCB)"
  },
  {
   value: "Hochheim am Main (DEDCM)",
   label: "Hochheim am Main (DEDCM)"
  },
  {
   value: "Hochkirch (DESXH)",
   label: "Hochkirch (DESXH)"
  },
  {
   value: "Hochscheid (DEHHD)",
   label: "Hochscheid (DEHHD)"
  },
  {
   value: "Höchst (DEHCS)",
   label: "Höchst (DEHCS)"
  },
  {
   value: "Höchstädt (DEEET)",
   label: "Höchstädt (DEEET)"
  },
  {
   value: "Höchstädt an der Donau (DECHS)",
   label: "Höchstädt an der Donau (DECHS)"
  },
  {
   value: "Hochstetten (DEHCT)",
   label: "Hochstetten (DEHCT)"
  },
  {
   value: "Hodenhagen (DEHEA)",
   label: "Hodenhagen (DEHEA)"
  },
  {
   value: "Höfen an der Enz (DEHFE)",
   label: "Höfen an der Enz (DEHFE)"
  },
  {
   value: "Höfer (DEHFR)",
   label: "Höfer (DEHFR)"
  },
  {
   value: "Hofheim in Unterfranken (DEHFU)",
   label: "Hofheim in Unterfranken (DEHFU)"
  },
  {
   value: "Hofstetten (Landsberg) (DEHFC)",
   label: "Hofstetten (Landsberg) (DEHFC)"
  },
  {
   value: "Höhbeck (DEHOK)",
   label: "Höhbeck (DEHOK)"
  },
  {
   value: "Hohburg (DEHHG)",
   label: "Hohburg (DEHHG)"
  },
  {
   value: "Hohenbucko (DEXHB)",
   label: "Hohenbucko (DEXHB)"
  },
  {
   value: "Hohenkammer (DEZOH)",
   label: "Hohenkammer (DEZOH)"
  },
  {
   value: "Hohenlinden (DEHND)",
   label: "Hohenlinden (DEHND)"
  },
  {
   value: "Hohenölsen (DETZH)",
   label: "Hohenölsen (DETZH)"
  },
  {
   value: "Hohenpeissenberg (DEHPB)",
   label: "Hohenpeissenberg (DEHPB)"
  },
  {
   value: "Hohenstein (DEOHT)",
   label: "Hohenstein (DEOHT)"
  },
  {
   value: "Hohenstein-Ernstthal (DEHOI)",
   label: "Hohenstein-Ernstthal (DEHOI)"
  },
  {
   value: "Hohentengen (DEHHE)",
   label: "Hohentengen (DEHHE)"
  },
  {
   value: "Hohenwulsch (DEHOU)",
   label: "Hohenwulsch (DEHOU)"
  },
  {
   value: "Hohnstorf (Elbe) (DEHTR)",
   label: "Hohnstorf (Elbe) (DEHTR)"
  },
  {
   value: "Hohwald (DEHWD)",
   label: "Hohwald (DEHWD)"
  },
  {
   value: "Holdorf (DEOOR)",
   label: "Holdorf (DEOOR)"
  },
  {
   value: "Holle (DENHZ)",
   label: "Holle (DENHZ)"
  },
  {
   value: "Hollenstedt (DEHLN)",
   label: "Hollenstedt (DEHLN)"
  },
  {
   value: "Hollern (DEHLL)",
   label: "Hollern (DEHLL)"
  },
  {
   value: "Hollern (DEHON)",
   label: "Hollern (DEHON)"
  },
  {
   value: "Holm (Pinneberg) (DEHMP)",
   label: "Holm (Pinneberg) (DEHMP)"
  },
  {
   value: "Holthausen (DEHTA)",
   label: "Holthausen (DEHTA)"
  },
  {
   value: "Holzgerlingen (DEZLG)",
   label: "Holzgerlingen (DEZLG)"
  },
  {
   value: "Holzheim (DEHZM)",
   label: "Holzheim (DEHZM)"
  },
  {
   value: "Holzmühle (DEZJT)",
   label: "Holzmühle (DEZJT)"
  },
  {
   value: "Homberg (DEHBE)",
   label: "Homberg (DEHBE)"
  },
  {
   value: "Honau (DEHNA)",
   label: "Honau (DEHNA)"
  },
  {
   value: "Honhardt (DEODT)",
   label: "Honhardt (DEODT)"
  },
  {
   value: "Hönningen (DEHNI)",
   label: "Hönningen (DEHNI)"
  },
  {
   value: "Hönow (DEHNW)",
   label: "Hönow (DEHNW)"
  },
  {
   value: "Hoopte (DEHPE)",
   label: "Hoopte (DEHPE)"
  },
  {
   value: "Höpfingen (DEHPG)",
   label: "Höpfingen (DEHPG)"
  },
  {
   value: "Hopsten (DEHOP)",
   label: "Hopsten (DEHOP)"
  },
  {
   value: "Horgau (DEHXU)",
   label: "Horgau (DEHXU)"
  },
  {
   value: "Horhausen (DEXHR)",
   label: "Horhausen (DEXHR)"
  },
  {
   value: "Horn-Bad Meinberg (DEZWG)",
   label: "Horn-Bad Meinberg (DEZWG)"
  },
  {
   value: "Horrweiler (DEHRW)",
   label: "Horrweiler (DEHRW)"
  },
  {
   value: "Hörselberg (DEHLB)",
   label: "Hörselberg (DEHLB)"
  },
  {
   value: "Hörselberg (DEHSB)",
   label: "Hörselberg (DEHSB)"
  },
  {
   value: "Hörselgau (DEOEG)",
   label: "Hörselgau (DEOEG)"
  },
  {
   value: "Hörselgau (DEOGS)",
   label: "Hörselgau (DEOGS)"
  },
  {
   value: "Horst (DEHXT)",
   label: "Horst (DEHXT)"
  },
  {
   value: "Horstmar (DEHRA)",
   label: "Horstmar (DEHRA)"
  },
  {
   value: "Hoslwang (DERLS)",
   label: "Hoslwang (DERLS)"
  },
  {
   value: "Hötensleben (DEZSN)",
   label: "Hötensleben (DEZSN)"
  },
  {
   value: "Höttingen (DEZNO)",
   label: "Höttingen (DEZNO)"
  },
  {
   value: "Hövelhof (DEHVF)",
   label: "Hövelhof (DEHVF)"
  },
  {
   value: "Hoya (DEHOY)",
   label: "Hoya (DEHOY)"
  },
  {
   value: "Hübitz (DEHUJ)",
   label: "Hübitz (DEHUJ)"
  },
  {
   value: "Huckingen (DEDHU)",
   label: "Huckingen (DEDHU)"
  },
  {
   value: "Hude (DEUDE)",
   label: "Hude (DEUDE)"
  },
  {
   value: "Hude (DEUDS)",
   label: "Hude (DEUDS)"
  },
  {
   value: "Huffenhardt (DEHFF)",
   label: "Huffenhardt (DEHFF)"
  },
  {
   value: "Hüffenhardt (DEZIH)",
   label: "Hüffenhardt (DEZIH)"
  },
  {
   value: "Hüfingen (DENGE)",
   label: "Hüfingen (DENGE)"
  },
  {
   value: "Hüfingen (DEUEF)",
   label: "Hüfingen (DEUEF)"
  },
  {
   value: "Huglfing (DEHLF)",
   label: "Huglfing (DEHLF)"
  },
  {
   value: "Huisheim (DEHUI)",
   label: "Huisheim (DEHUI)"
  },
  {
   value: "Huls (DEHUL)",
   label: "Huls (DEHUL)"
  },
  {
   value: "Hulsede (DEHNL)",
   label: "Hulsede (DEHNL)"
  },
  {
   value: "Hummerntrup (DEHRP)",
   label: "Hummerntrup (DEHRP)"
  },
  {
   value: "Hunderdorf (DEHUF)",
   label: "Hunderdorf (DEHUF)"
  },
  {
   value: "Hundsangen (DEHUA)",
   label: "Hundsangen (DEHUA)"
  },
  {
   value: "Hundsmühlen (DEHSU)",
   label: "Hundsmühlen (DEHSU)"
  },
  {
   value: "Hünsborn (DEHUX)",
   label: "Hünsborn (DEHUX)"
  },
  {
   value: "Huntebrück (DEHUN)",
   label: "Huntebrück (DEHUN)"
  },
  {
   value: "Hürtgenwald (DEHGW)",
   label: "Hürtgenwald (DEHGW)"
  },
  {
   value: "Hütschenhausen (DEZRU)",
   label: "Hütschenhausen (DEZRU)"
  },
  {
   value: "Hüttenberg (DEZHT)",
   label: "Hüttenberg (DEZHT)"
  },
  {
   value: "Huttenheim (DEZHM)",
   label: "Huttenheim (DEZHM)"
  },
  {
   value: "Huttingen (DEHZZ)",
   label: "Huttingen (DEHZZ)"
  },
  {
   value: "Ichenhausen (DEIEH)",
   label: "Ichenhausen (DEIEH)"
  },
  {
   value: "Ichenheim (DECIH)",
   label: "Ichenheim (DECIH)"
  },
  {
   value: "Ichtershausen (DEICH)",
   label: "Ichtershausen (DEICH)"
  },
  {
   value: "Iffeldorf (DEIDF)",
   label: "Iffeldorf (DEIDF)"
  },
  {
   value: "Iffezheim (DEIFF)",
   label: "Iffezheim (DEIFF)"
  },
  {
   value: "Ifta (DEIFA)",
   label: "Ifta (DEIFA)"
  },
  {
   value: "Igenhausen (DEIGE)",
   label: "Igenhausen (DEIGE)"
  },
  {
   value: "Igersheim (DEIGH)",
   label: "Igersheim (DEIGH)"
  },
  {
   value: "Iggingen (DEIGG)",
   label: "Iggingen (DEIGG)"
  },
  {
   value: "Igling (DEZHW)",
   label: "Igling (DEZHW)"
  },
  {
   value: "Ihlienworth (DEIHW)",
   label: "Ihlienworth (DEIHW)"
  },
  {
   value: "Ihlow (DEIHL)",
   label: "Ihlow (DEIHL)"
  },
  {
   value: "Illerrieden (DEIDN)",
   label: "Illerrieden (DEIDN)"
  },
  {
   value: "Illingen (DEIIN)",
   label: "Illingen (DEIIN)"
  },
  {
   value: "Illingen (DEILG)",
   label: "Illingen (DEILG)"
  },
  {
   value: "Illschwang (DEILS)",
   label: "Illschwang (DEILS)"
  },
  {
   value: "Ilsede (DEIEE)",
   label: "Ilsede (DEIEE)"
  },
  {
   value: "Ilsenburg (DEIBU)",
   label: "Ilsenburg (DEIBU)"
  },
  {
   value: "Ilsfeld (DEFLD)",
   label: "Ilsfeld (DEFLD)"
  },
  {
   value: "Ilshofen (DEIZN)",
   label: "Ilshofen (DEIZN)"
  },
  {
   value: "Immelborn (DEIMB)",
   label: "Immelborn (DEIMB)"
  },
  {
   value: "Immenreuth (DEIMH)",
   label: "Immenreuth (DEIMH)"
  },
  {
   value: "Immenstaad am Bodensee (DEIMD)",
   label: "Immenstaad am Bodensee (DEIMD)"
  },
  {
   value: "Inchenhofen (DEBZI)",
   label: "Inchenhofen (DEBZI)"
  },
  {
   value: "Inden (DEIDE)",
   label: "Inden (DEIDE)"
  },
  {
   value: "Inden-Lamersdorf (DEIND)",
   label: "Inden-Lamersdorf (DEIND)"
  },
  {
   value: "Ingelfingen (DEIGF)",
   label: "Ingelfingen (DEIGF)"
  },
  {
   value: "Inning am Ammersee (DEZIE)",
   label: "Inning am Ammersee (DEZIE)"
  },
  {
   value: "Inzell (DEIZL)",
   label: "Inzell (DEIZL)"
  },
  {
   value: "Inzlingen (DEINZ)",
   label: "Inzlingen (DEINZ)"
  },
  {
   value: "Iphofen (DEIPH)",
   label: "Iphofen (DEIPH)"
  },
  {
   value: "Iptingen (DEIPT)",
   label: "Iptingen (DEIPT)"
  },
  {
   value: "Irxleben (DEZHK)",
   label: "Irxleben (DEZHK)"
  },
  {
   value: "Isenbüttel (DEIBL)",
   label: "Isenbüttel (DEIBL)"
  },
  {
   value: "Ismaning (DEIMG)",
   label: "Ismaning (DEIMG)"
  },
  {
   value: "Isny im Allgäu (DEISY)",
   label: "Isny im Allgäu (DEISY)"
  },
  {
   value: "Ispringen (DEISP)",
   label: "Ispringen (DEISP)"
  },
  {
   value: "Isselburg (DELSS)",
   label: "Isselburg (DELSS)"
  },
  {
   value: "Isseroda (DEIEA)",
   label: "Isseroda (DEIEA)"
  },
  {
   value: "Issigau (DEIGU)",
   label: "Issigau (DEIGU)"
  },
  {
   value: "Issum (DEISU)",
   label: "Issum (DEISU)"
  },
  {
   value: "Ittlingen (DEITG)",
   label: "Ittlingen (DEITG)"
  },
  {
   value: "Itzgrund (DEIZD)",
   label: "Itzgrund (DEIZD)"
  },
  {
   value: "Jabel (DEJBL)",
   label: "Jabel (DEJBL)"
  },
  {
   value: "Jacobsdorf (DEJBO)",
   label: "Jacobsdorf (DEJBO)"
  },
  {
   value: "Jahnsdorf (DEJDF)",
   label: "Jahnsdorf (DEJDF)"
  },
  {
   value: "Jänschwalde (DEJWE)",
   label: "Jänschwalde (DEJWE)"
  },
  {
   value: "Jarchau (DEJHA)",
   label: "Jarchau (DEJHA)"
  },
  {
   value: "Jersleben (DEJER)",
   label: "Jersleben (DEJER)"
  },
  {
   value: "Jeserig (DEJSG)",
   label: "Jeserig (DEJSG)"
  },
  {
   value: "Jessen (DEJSA)",
   label: "Jessen (DEJSA)"
  },
  {
   value: "Jesteburg (DEJEG)",
   label: "Jesteburg (DEJEG)"
  },
  {
   value: "Jestetten (DEJES)",
   label: "Jestetten (DEJES)"
  },
  {
   value: "Jettenbach (DEJET)",
   label: "Jettenbach (DEJET)"
  },
  {
   value: "Jettingen (DEJTN)",
   label: "Jettingen (DEJTN)"
  },
  {
   value: "Jever (DEJEV)",
   label: "Jever (DEJEV)"
  },
  {
   value: "Joachimsthal (DEJOA)",
   label: "Joachimsthal (DEJOA)"
  },
  {
   value: "Jockgrim (DEZJM)",
   label: "Jockgrim (DEZJM)"
  },
  {
   value: "Johannesberg (DEZJG)",
   label: "Johannesberg (DEZJG)"
  },
  {
   value: "Johannisberg (DEJOH)",
   label: "Johannisberg (DEJOH)"
  },
  {
   value: "Johanniskirchen (DEJON)",
   label: "Johanniskirchen (DEJON)"
  },
  {
   value: "Jössen (DEJSN)",
   label: "Jössen (DEJSN)"
  },
  {
   value: "Jübek (DEJBK)",
   label: "Jübek (DEJBK)"
  },
  {
   value: "Jüchen (DEJHN)",
   label: "Jüchen (DEJHN)"
  },
  {
   value: "Jüchen (DEZJN)",
   label: "Jüchen (DEZJN)"
  },
  {
   value: "Judenbach (DEJUB)",
   label: "Judenbach (DEJUB)"
  },
  {
   value: "jungingen (DEJUL)",
   label: "jungingen (DEJUL)"
  },
  {
   value: "Jüterbog (DEJBG)",
   label: "Jüterbog (DEJBG)"
  },
  {
   value: "Kabelsketal (DETAL)",
   label: "Kabelsketal (DETAL)"
  },
  {
   value: "Kaempfelbach (DEZKH)",
   label: "Kaempfelbach (DEZKH)"
  },
  {
   value: "Kaimt (DEKMT)",
   label: "Kaimt (DEKMT)"
  },
  {
   value: "Kaisersesch (DEHSK)",
   label: "Kaisersesch (DEHSK)"
  },
  {
   value: "Kaje Omni-Pac (DEKOP)",
   label: "Kaje Omni-Pac (DEKOP)"
  },
  {
   value: "Kalbe (Milde) (DEKLB)",
   label: "Kalbe (Milde) (DEKLB)"
  },
  {
   value: "Kaldenkirchen (DEKNK)",
   label: "Kaldenkirchen (DEKNK)"
  },
  {
   value: "Kaltennordheim (DEKND)",
   label: "Kaltennordheim (DEKND)"
  },
  {
   value: "Kaltensundheim (DEKDH)",
   label: "Kaltensundheim (DEKDH)"
  },
  {
   value: "Kamp-Lintfort (DEKLF)",
   label: "Kamp-Lintfort (DEKLF)"
  },
  {
   value: "Kandel (DEKNL)",
   label: "Kandel (DEKNL)"
  },
  {
   value: "Kanin (DEKNI)",
   label: "Kanin (DEKNI)"
  },
  {
   value: "Kanzem (DEKNM)",
   label: "Kanzem (DEKNM)"
  },
  {
   value: "Kappelrodeck (DEKRK)",
   label: "Kappelrodeck (DEKRK)"
  },
  {
   value: "Kappelwindeck (DEKWP)",
   label: "Kappelwindeck (DEKWP)"
  },
  {
   value: "Karl (DEKLR)",
   label: "Karl (DEKLR)"
  },
  {
   value: "Karlsdorf (DEKSF)",
   label: "Karlsdorf (DEKSF)"
  },
  {
   value: "Karlsdorf-Neuthard (DEKNH)",
   label: "Karlsdorf-Neuthard (DEKNH)"
  },
  {
   value: "Karlshuld (DEKAH)",
   label: "Karlshuld (DEKAH)"
  },
  {
   value: "Karlskron (DEKAK)",
   label: "Karlskron (DEKAK)"
  },
  {
   value: "Karlstadt (DEKSD)",
   label: "Karlstadt (DEKSD)"
  },
  {
   value: "Karolinenkoog (DEOLI)",
   label: "Karolinenkoog (DEOLI)"
  },
  {
   value: "Karstädt (Prignitz) (DEKSI)",
   label: "Karstädt (Prignitz) (DEKSI)"
  },
  {
   value: "Karthaus (DEKHU)",
   label: "Karthaus (DEKHU)"
  },
  {
   value: "Kartzow (DEKZO)",
   label: "Kartzow (DEKZO)"
  },
  {
   value: "Kasendorf (DEZKF)",
   label: "Kasendorf (DEZKF)"
  },
  {
   value: "Kastellaun (DEKSA)",
   label: "Kastellaun (DEKSA)"
  },
  {
   value: "Kastl (DEAST)",
   label: "Kastl (DEAST)"
  },
  {
   value: "Kastl (DEKAT)",
   label: "Kastl (DEKAT)"
  },
  {
   value: "Kästorf (DEKSR)",
   label: "Kästorf (DEKSR)"
  },
  {
   value: "Katlenburg-Duhm (DEKBD)",
   label: "Katlenburg-Duhm (DEKBD)"
  },
  {
   value: "Katzwinkel (DEKTW)",
   label: "Katzwinkel (DEKTW)"
  },
  {
   value: "Kaub (DEKUB)",
   label: "Kaub (DEKUB)"
  },
  {
   value: "Kaufbeuren-Neugablonz (DEKAF)",
   label: "Kaufbeuren-Neugablonz (DEKAF)"
  },
  {
   value: "Kaufungen (DEKUU)",
   label: "Kaufungen (DEKUU)"
  },
  {
   value: "Kefenrod (DEKEF)",
   label: "Kefenrod (DEKEF)"
  },
  {
   value: "Kelberg (DEKEG)",
   label: "Kelberg (DEKEG)"
  },
  {
   value: "Kell (DEKLL)",
   label: "Kell (DEKLL)"
  },
  {
   value: "Kempenich (DEZKE)",
   label: "Kempenich (DEZKE)"
  },
  {
   value: "Kenn (DENNP)",
   label: "Kenn (DENNP)"
  },
  {
   value: "Kerpen (DEKRP)",
   label: "Kerpen (DEKRP)"
  },
  {
   value: "Kesselsdorf (DEKES)",
   label: "Kesselsdorf (DEKES)"
  },
  {
   value: "Kesselstadt (DEKLS)",
   label: "Kesselstadt (DEKLS)"
  },
  {
   value: "Kessin (DEKSS)",
   label: "Kessin (DEKSS)"
  },
  {
   value: "Kesten (DEKTS)",
   label: "Kesten (DEKTS)"
  },
  {
   value: "Ketsch (DEKTH)",
   label: "Ketsch (DEKTH)"
  },
  {
   value: "Kettenheim (DEKET)",
   label: "Kettenheim (DEKET)"
  },
  {
   value: "Kettenkamp (DEZKP)",
   label: "Kettenkamp (DEZKP)"
  },
  {
   value: "Keulrod (DEKED)",
   label: "Keulrod (DEKED)"
  },
  {
   value: "Kiedrich (DEHKR)",
   label: "Kiedrich (DEHKR)"
  },
  {
   value: "Kiefersfelden (DEKFN)",
   label: "Kiefersfelden (DEKFN)"
  },
  {
   value: "Kieselbach (DEKBC)",
   label: "Kieselbach (DEKBC)"
  },
  {
   value: "Kieselbronn (DEKIB)",
   label: "Kieselbronn (DEKIB)"
  },
  {
   value: "Kindelbruck (DEZXN)",
   label: "Kindelbruck (DEZXN)"
  },
  {
   value: "Kinding (DEKDI)",
   label: "Kinding (DEKDI)"
  },
  {
   value: "Kipfenberg (DEKPF)",
   label: "Kipfenberg (DEKPF)"
  },
  {
   value: "Kirchanschoring (DECHN)",
   label: "Kirchanschoring (DECHN)"
  },
  {
   value: "Kirchardt (DEKRD)",
   label: "Kirchardt (DEKRD)"
  },
  {
   value: "Kirchberg (DEKBG)",
   label: "Kirchberg (DEKBG)"
  },
  {
   value: "Kirchberg (DEKHB)",
   label: "Kirchberg (DEKHB)"
  },
  {
   value: "Kirchberg an der Jagst (DEKGJ)",
   label: "Kirchberg an der Jagst (DEKGJ)"
  },
  {
   value: "Kirchberg an der Murr (DEKBM)",
   label: "Kirchberg an der Murr (DEKBM)"
  },
  {
   value: "Kirchdorf (DEKDM)",
   label: "Kirchdorf (DEKDM)"
  },
  {
   value: "Kirchdorf am Inn (DEKDO)",
   label: "Kirchdorf am Inn (DEKDO)"
  },
  {
   value: "Kirchentellinsfurt (DEZTI)",
   label: "Kirchentellinsfurt (DEZTI)"
  },
  {
   value: "Kirchgandern (DEKGD)",
   label: "Kirchgandern (DEKGD)"
  },
  {
   value: "Kirchgellersen (DEKGE)",
   label: "Kirchgellersen (DEKGE)"
  },
  {
   value: "Kirchheim (DEKIC)",
   label: "Kirchheim (DEKIC)"
  },
  {
   value: "Kirchheim am Neckar (DEKNC)",
   label: "Kirchheim am Neckar (DEKNC)"
  },
  {
   value: "Kirchhofen (DEKKH)",
   label: "Kirchhofen (DEKKH)"
  },
  {
   value: "Kirchhundem (DEKHD)",
   label: "Kirchhundem (DEKHD)"
  },
  {
   value: "Kirchmöser (DEKCO)",
   label: "Kirchmöser (DEKCO)"
  },
  {
   value: "Kirchroth (DEKHZ)",
   label: "Kirchroth (DEKHZ)"
  },
  {
   value: "Kirchseeon (DEZNK)",
   label: "Kirchseeon (DEZNK)"
  },
  {
   value: "Kirchzarten (DEKCH)",
   label: "Kirchzarten (DEKCH)"
  },
  {
   value: "Kirkel (DEKIJ)",
   label: "Kirkel (DEKIJ)"
  },
  {
   value: "Kirschau (DEKIH)",
   label: "Kirschau (DEKIH)"
  },
  {
   value: "Kirschhofen (DEKXF)",
   label: "Kirschhofen (DEKXF)"
  },
  {
   value: "Kisdorf (DEKID)",
   label: "Kisdorf (DEKID)"
  },
  {
   value: "Kisslegg (DEKIS)",
   label: "Kisslegg (DEKIS)"
  },
  {
   value: "Klein Gaglow (DEKGW)",
   label: "Klein Gaglow (DEKGW)"
  },
  {
   value: "Klein Offenseth (DEKLO)",
   label: "Klein Offenseth (DEKLO)"
  },
  {
   value: "Kleinblittersdorf (DEKBF)",
   label: "Kleinblittersdorf (DEKBF)"
  },
  {
   value: "Kleinkarlbach (DEKKB)",
   label: "Kleinkarlbach (DEKKB)"
  },
  {
   value: "Kleinmachnow (DEKLW)",
   label: "Kleinmachnow (DEKLW)"
  },
  {
   value: "Kleinostheim (DEKTM)",
   label: "Kleinostheim (DEKTM)"
  },
  {
   value: "Kleintettau (DEKTU)",
   label: "Kleintettau (DEKTU)"
  },
  {
   value: "Kleinwallstadt (DEKXT)",
   label: "Kleinwallstadt (DEKXT)"
  },
  {
   value: "Klein-Winternheim (DEKSH)",
   label: "Klein-Winternheim (DEKSH)"
  },
  {
   value: "Klettgau (DEKLU)",
   label: "Klettgau (DEKLU)"
  },
  {
   value: "Klingenberg (DEKGB)",
   label: "Klingenberg (DEKGB)"
  },
  {
   value: "Klingenthal (DEKGT)",
   label: "Klingenthal (DEKGT)"
  },
  {
   value: "Klink (DEKLK)",
   label: "Klink (DEKLK)"
  },
  {
   value: "Klipphausen (DEKHA)",
   label: "Klipphausen (DEKHA)"
  },
  {
   value: "Klöden (DEKDN)",
   label: "Klöden (DEKDN)"
  },
  {
   value: "Kloster Neuendorf (DEXKL)",
   label: "Kloster Neuendorf (DEXKL)"
  },
  {
   value: "Klusserath (DEKLX)",
   label: "Klusserath (DEKLX)"
  },
  {
   value: "Knesebeck (DEZKK)",
   label: "Knesebeck (DEZKK)"
  },
  {
   value: "Knetzgau (DEZKU)",
   label: "Knetzgau (DEZKU)"
  },
  {
   value: "Knuellwald (DEZKD)",
   label: "Knuellwald (DEZKD)"
  },
  {
   value: "Knüll (DEKWD)",
   label: "Knüll (DEKWD)"
  },
  {
   value: "Kochendorf (DEKHO)",
   label: "Kochendorf (DEKHO)"
  },
  {
   value: "Kodersdorf (DEKOD)",
   label: "Kodersdorf (DEKOD)"
  },
  {
   value: "Köditz (DEKDZ)",
   label: "Köditz (DEKDZ)"
  },
  {
   value: "Kohlberg (DEKHL)",
   label: "Kohlberg (DEKHL)"
  },
  {
   value: "Kolbermoor (DEKOM)",
   label: "Kolbermoor (DEKOM)"
  },
  {
   value: "Kolenfeld (DEKOF)",
   label: "Kolenfeld (DEKOF)"
  },
  {
   value: "Kolkwitz (DELWZ)",
   label: "Kolkwitz (DELWZ)"
  },
  {
   value: "Kölleda (DEKLD)",
   label: "Kölleda (DEKLD)"
  },
  {
   value: "Königsberg (DEKBB)",
   label: "Königsberg (DEKBB)"
  },
  {
   value: "Königsbronn (DEKSB)",
   label: "Königsbronn (DEKSB)"
  },
  {
   value: "Königsee (DEKUN)",
   label: "Königsee (DEKUN)"
  },
  {
   value: "Königsheim (DEKHE)",
   label: "Königsheim (DEKHE)"
  },
  {
   value: "Königsmoor (DEKGM)",
   label: "Königsmoor (DEKGM)"
  },
  {
   value: "Königsmoos (DEKGO)",
   label: "Königsmoos (DEKGO)"
  },
  {
   value: "Königswald (DEKNW)",
   label: "Königswald (DEKNW)"
  },
  {
   value: "Königswalde (DEKGL)",
   label: "Königswalde (DEKGL)"
  },
  {
   value: "Königswartha (DEKWA)",
   label: "Königswartha (DEKWA)"
  },
  {
   value: "Könitz (DEKNZ)",
   label: "Könitz (DEKNZ)"
  },
  {
   value: "Konken (DEKOK)",
   label: "Konken (DEKOK)"
  },
  {
   value: "Könnern (DEKNY)",
   label: "Könnern (DEKNY)"
  },
  {
   value: "Konzell (DEKZE)",
   label: "Konzell (DEKZE)"
  },
  {
   value: "Köpernitz (DEKPZ)",
   label: "Köpernitz (DEKPZ)"
  },
  {
   value: "Korb (DEKOX)",
   label: "Korb (DEKOX)"
  },
  {
   value: "Korbetha (DEKTA)",
   label: "Korbetha (DEKTA)"
  },
  {
   value: "Korbussen (DEKBU)",
   label: "Korbussen (DEKBU)"
  },
  {
   value: "Kösching (DEKHG)",
   label: "Kösching (DEKHG)"
  },
  {
   value: "Kösten (DEKTN)",
   label: "Kösten (DEKTN)"
  },
  {
   value: "Köthen (Anhalt) (DEKOA)",
   label: "Köthen (Anhalt) (DEKOA)"
  },
  {
   value: "Kottweiler-Schwanden (DEZON)",
   label: "Kottweiler-Schwanden (DEZON)"
  },
  {
   value: "Kraatz (DEKRX)",
   label: "Kraatz (DEKRX)"
  },
  {
   value: "Kraftisried (DEKFI)",
   label: "Kraftisried (DEKFI)"
  },
  {
   value: "Kraftsdorf (DEKFF)",
   label: "Kraftsdorf (DEKFF)"
  },
  {
   value: "Kraiburg am Inn (DEKRR)",
   label: "Kraiburg am Inn (DEKRR)"
  },
  {
   value: "Krailling (DEKIG)",
   label: "Krailling (DEKIG)"
  },
  {
   value: "Krampfer (DEKMF)",
   label: "Krampfer (DEKMF)"
  },
  {
   value: "Kranenburg (DEKNG)",
   label: "Kranenburg (DEKNG)"
  },
  {
   value: "Kranichfeld (DEKHF)",
   label: "Kranichfeld (DEKHF)"
  },
  {
   value: "Kranzberg (DEKZB)",
   label: "Kranzberg (DEKZB)"
  },
  {
   value: "Krauschwitz (DEKWZ)",
   label: "Krauschwitz (DEKWZ)"
  },
  {
   value: "Krauthausen (DEKRZ)",
   label: "Krauthausen (DEKRZ)"
  },
  {
   value: "Krautheim (DEKRM)",
   label: "Krautheim (DEKRM)"
  },
  {
   value: "Kreba-Neudorf (DEKNU)",
   label: "Kreba-Neudorf (DEKNU)"
  },
  {
   value: "Kreinitz (DEKNT)",
   label: "Kreinitz (DEKNT)"
  },
  {
   value: "Kreischa (DEKSC)",
   label: "Kreischa (DEKSC)"
  },
  {
   value: "Krempe (Holst) (DEKPL)",
   label: "Krempe (Holst) (DEKPL)"
  },
  {
   value: "Krems II (DEKMS)",
   label: "Krems II (DEKMS)"
  },
  {
   value: "Kressbronn am Bodensee (DEKAB)",
   label: "Kressbronn am Bodensee (DEKAB)"
  },
  {
   value: "Kreuth (DEKYN)",
   label: "Kreuth (DEKYN)"
  },
  {
   value: "Kreuzfeld (DEKZF)",
   label: "Kreuzfeld (DEKZF)"
  },
  {
   value: "Kriegenbrunn (DEKGU)",
   label: "Kriegenbrunn (DEKGU)"
  },
  {
   value: "Kromsdorf (DEKDR)",
   label: "Kromsdorf (DEKDR)"
  },
  {
   value: "Kronshagen (DEKNS)",
   label: "Kronshagen (DEKNS)"
  },
  {
   value: "Kroppach (DERPH)",
   label: "Kroppach (DERPH)"
  },
  {
   value: "Kroppenstedt (DEKPT)",
   label: "Kroppenstedt (DEKPT)"
  },
  {
   value: "Krostitz (DEKSZ)",
   label: "Krostitz (DEKSZ)"
  },
  {
   value: "Krumpa (DEKMA)",
   label: "Krumpa (DEKMA)"
  },
  {
   value: "Kuchenheim (DEKUC)",
   label: "Kuchenheim (DEKUC)"
  },
  {
   value: "Kuddewörde (DEKWE)",
   label: "Kuddewörde (DEKWE)"
  },
  {
   value: "Kühren Burkartshain (DEZKN)",
   label: "Kühren Burkartshain (DEZKN)"
  },
  {
   value: "Küllstedt (DEKUD)",
   label: "Küllstedt (DEKUD)"
  },
  {
   value: "Külsheim (DEKIM)",
   label: "Külsheim (DEKIM)"
  },
  {
   value: "Kulz (DEKLZ)",
   label: "Kulz (DEKLZ)"
  },
  {
   value: "Kummersdorf-Gut (DEKDG)",
   label: "Kummersdorf-Gut (DEKDG)"
  },
  {
   value: "Kunkemühle (DEKKU)",
   label: "Kunkemühle (DEKKU)"
  },
  {
   value: "Kupferzell (DEKUZ)",
   label: "Kupferzell (DEKUZ)"
  },
  {
   value: "Kuppenheim (DEKUP)",
   label: "Kuppenheim (DEKUP)"
  },
  {
   value: "Kurten (DEKUT)",
   label: "Kurten (DEKUT)"
  },
  {
   value: "Küssaberg (DEKUA)",
   label: "Küssaberg (DEKUA)"
  },
  {
   value: "Kusterdingen (DEKTD)",
   label: "Kusterdingen (DEKTD)"
  },
  {
   value: "Küstriner Vorland (DEKTV)",
   label: "Küstriner Vorland (DEKTV)"
  },
  {
   value: "Laage (DELGZ)",
   label: "Laage (DELGZ)"
  },
  {
   value: "Laatzen (DELAZ)",
   label: "Laatzen (DELAZ)"
  },
  {
   value: "Lachen (DELAC)",
   label: "Lachen (DELAC)"
  },
  {
   value: "Ladbergen (DELDB)",
   label: "Ladbergen (DELDB)"
  },
  {
   value: "Ladeburg (DELDG)",
   label: "Ladeburg (DELDG)"
  },
  {
   value: "Lahde (DELHD)",
   label: "Lahde (DELHD)"
  },
  {
   value: "Lahn (DELNM)",
   label: "Lahn (DELNM)"
  },
  {
   value: "Lahnau (DELHA)",
   label: "Lahnau (DELHA)"
  },
  {
   value: "Lahntal (DEZAP)",
   label: "Lahntal (DEZAP)"
  },
  {
   value: "Lahr (DELHR)",
   label: "Lahr (DELHR)"
  },
  {
   value: "Lam (DEZAE)",
   label: "Lam (DEZAE)"
  },
  {
   value: "Lambsheim (DEZAF)",
   label: "Lambsheim (DEZAF)"
  },
  {
   value: "Lampertswalde (DELPW)",
   label: "Lampertswalde (DELPW)"
  },
  {
   value: "Lampertswalde (DELRS)",
   label: "Lampertswalde (DELRS)"
  },
  {
   value: "Lamspringe (DEZHY)",
   label: "Lamspringe (DEZHY)"
  },
  {
   value: "Landesbergen (DELJN)",
   label: "Landesbergen (DELJN)"
  },
  {
   value: "Landsberg (DELSB)",
   label: "Landsberg (DELSB)"
  },
  {
   value: "Langen (Emsland) (DELED)",
   label: "Langen (Emsland) (DELED)"
  },
  {
   value: "Langenaltheim (DELNT)",
   label: "Langenaltheim (DELNT)"
  },
  {
   value: "Langenau (DELGU)",
   label: "Langenau (DELGU)"
  },
  {
   value: "Langenbach (DELGB)",
   label: "Langenbach (DELGB)"
  },
  {
   value: "Langenbach (DELHC)",
   label: "Langenbach (DELHC)"
  },
  {
   value: "Langenberg (DELBB)",
   label: "Langenberg (DELBB)"
  },
  {
   value: "Langenbeutingen (DELET)",
   label: "Langenbeutingen (DELET)"
  },
  {
   value: "Langenbrettach (DELTC)",
   label: "Langenbrettach (DELTC)"
  },
  {
   value: "Langenenslingen (DELGL)",
   label: "Langenenslingen (DELGL)"
  },
  {
   value: "Langenhain (DELII)",
   label: "Langenhain (DELII)"
  },
  {
   value: "Langenneufnach (DELNC)",
   label: "Langenneufnach (DELNC)"
  },
  {
   value: "Langenselbold (DELGD)",
   label: "Langenselbold (DELGD)"
  },
  {
   value: "Langenweddingen (DELGI)",
   label: "Langenweddingen (DELGI)"
  },
  {
   value: "Langenweissbach (DEZIC)",
   label: "Langenweissbach (DEZIC)"
  },
  {
   value: "Langerwehe (DELGH)",
   label: "Langerwehe (DELGH)"
  },
  {
   value: "Langewiesen (DELAW)",
   label: "Langewiesen (DELAW)"
  },
  {
   value: "Langgöns (DEGGO)",
   label: "Langgöns (DEGGO)"
  },
  {
   value: "Langhagen (DELGG)",
   label: "Langhagen (DELGG)"
  },
  {
   value: "Langula (DELLA)",
   label: "Langula (DELLA)"
  },
  {
   value: "Lankwitz (DELKI)",
   label: "Lankwitz (DELKI)"
  },
  {
   value: "Lanz (DELNZ)",
   label: "Lanz (DELNZ)"
  },
  {
   value: "Lanzenhain (DELJA)",
   label: "Lanzenhain (DELJA)"
  },
  {
   value: "Lassan (DELSA)",
   label: "Lassan (DELSA)"
  },
  {
   value: "Lastrup (DELTP)",
   label: "Lastrup (DELTP)"
  },
  {
   value: "Lauben (Unterallgäu) (DELAL)",
   label: "Lauben (Unterallgäu) (DELAL)"
  },
  {
   value: "Laucha an der Unstrut (DELCU)",
   label: "Laucha an der Unstrut (DELCU)"
  },
  {
   value: "Lauchhammer (DELMU)",
   label: "Lauchhammer (DELMU)"
  },
  {
   value: "Lauchheim (DELAI)",
   label: "Lauchheim (DELAI)"
  },
  {
   value: "Lauchringen (DELHG)",
   label: "Lauchringen (DELHG)"
  },
  {
   value: "Lauenbrück (DELBK)",
   label: "Lauenbrück (DELBK)"
  },
  {
   value: "Lauenförde (DELUF)",
   label: "Lauenförde (DELUF)"
  },
  {
   value: "Laufach (DELFA)",
   label: "Laufach (DELFA)"
  },
  {
   value: "Laufeld (DELFD)",
   label: "Laufeld (DELFD)"
  },
  {
   value: "Lauscha (DELSC)",
   label: "Lauscha (DELSC)"
  },
  {
   value: "Laussnitz (DELSZ)",
   label: "Laussnitz (DELSZ)"
  },
  {
   value: "Lauter (DETUR)",
   label: "Lauter (DETUR)"
  },
  {
   value: "Lauterbach (DELBY)",
   label: "Lauterbach (DELBY)"
  },
  {
   value: "Lauterhofen (DELHO)",
   label: "Lauterhofen (DELHO)"
  },
  {
   value: "Lautzenhausen (DELTZ)",
   label: "Lautzenhausen (DELTZ)"
  },
  {
   value: "Lechbruck (DELUK)",
   label: "Lechbruck (DELUK)"
  },
  {
   value: "Leegebruch (DERBR)",
   label: "Leegebruch (DERBR)"
  },
  {
   value: "Leeseringen (DELSN)",
   label: "Leeseringen (DELSN)"
  },
  {
   value: "Legau (DELLU)",
   label: "Legau (DELLU)"
  },
  {
   value: "Lehesten (DELHS)",
   label: "Lehesten (DELHS)"
  },
  {
   value: "Leidersbach (DELDA)",
   label: "Leidersbach (DELDA)"
  },
  {
   value: "Leienkaul (DELJH)",
   label: "Leienkaul (DELJH)"
  },
  {
   value: "Leimbach (DECCC)",
   label: "Leimbach (DECCC)"
  },
  {
   value: "Leimbach (DELMH)",
   label: "Leimbach (DELMH)"
  },
  {
   value: "Leimen (Pfalz) (DELPF)",
   label: "Leimen (Pfalz) (DELPF)"
  },
  {
   value: "Leimersheim (DEEEM)",
   label: "Leimersheim (DEEEM)"
  },
  {
   value: "Leina (DELIA)",
   label: "Leina (DELIA)"
  },
  {
   value: "Leinach (DELEK)",
   label: "Leinach (DELEK)"
  },
  {
   value: "Leinburg (DELEI)",
   label: "Leinburg (DELEI)"
  },
  {
   value: "Leingarten (DELGT)",
   label: "Leingarten (DELGT)"
  },
  {
   value: "Leipheim (DELPH)",
   label: "Leipheim (DELPH)"
  },
  {
   value: "Leisnig (DELQG)",
   label: "Leisnig (DELQG)"
  },
  {
   value: "Leizen (DELZI)",
   label: "Leizen (DELZI)"
  },
  {
   value: "Lembruch (DELRC)",
   label: "Lembruch (DELRC)"
  },
  {
   value: "Lengdorf (DEZAK)",
   label: "Lengdorf (DEZAK)"
  },
  {
   value: "Lengede (DELXG)",
   label: "Lengede (DELXG)"
  },
  {
   value: "Lengefeld (DELEL)",
   label: "Lengefeld (DELEL)"
  },
  {
   value: "Lengenfeld (DEMWL)",
   label: "Lengenfeld (DEMWL)"
  },
  {
   value: "Lengenfeld (DEZAJ)",
   label: "Lengenfeld (DEZAJ)"
  },
  {
   value: "Lengerich (DELGC)",
   label: "Lengerich (DELGC)"
  },
  {
   value: "Lengfeld (DELEF)",
   label: "Lengfeld (DELEF)"
  },
  {
   value: "Lenzen (DEEZN)",
   label: "Lenzen (DEEZN)"
  },
  {
   value: "Lenzen (Elbe) (DELEZ)",
   label: "Lenzen (Elbe) (DELEZ)"
  },
  {
   value: "Leonberg (DELOO)",
   label: "Leonberg (DELOO)"
  },
  {
   value: "Leopoldshöhe (DELXE)",
   label: "Leopoldshöhe (DELXE)"
  },
  {
   value: "Leppersdorf (DELEP)",
   label: "Leppersdorf (DELEP)"
  },
  {
   value: "Letmathe (DEDDD)",
   label: "Letmathe (DEDDD)"
  },
  {
   value: "Lette (DELTT)",
   label: "Lette (DELTT)"
  },
  {
   value: "Leubingen (DELXN)",
   label: "Leubingen (DELXN)"
  },
  {
   value: "Leupoldsgrün (DELGR)",
   label: "Leupoldsgrün (DELGR)"
  },
  {
   value: "Leutenbach (DEZLH)",
   label: "Leutenbach (DEZLH)"
  },
  {
   value: "Leutershausen (DELKB)",
   label: "Leutershausen (DELKB)"
  },
  {
   value: "Leutershausen (Ansbach) (DELMF)",
   label: "Leutershausen (Ansbach) (DELMF)"
  },
  {
   value: "Leutershausen (Rhon-Grabfeld) (DEURL)",
   label: "Leutershausen (Rhon-Grabfeld) (DEURL)"
  },
  {
   value: "Lich (DEILH)",
   label: "Lich (DEILH)"
  },
  {
   value: "Lichtenau (DELHT)",
   label: "Lichtenau (DELHT)"
  },
  {
   value: "Lichtenau (Baden) (DELCT)",
   label: "Lichtenau (Baden) (DELCT)"
  },
  {
   value: "Lichtenstein (DELXI)",
   label: "Lichtenstein (DELXI)"
  },
  {
   value: "Lichtenstein (Reutlingen) (DELWU)",
   label: "Lichtenstein (Reutlingen) (DELWU)"
  },
  {
   value: "Liebenau (DELIB)",
   label: "Liebenau (DELIB)"
  },
  {
   value: "Liebenburg (DEIEB)",
   label: "Liebenburg (DEIEB)"
  },
  {
   value: "Liebenwalde (DELBW)",
   label: "Liebenwalde (DELBW)"
  },
  {
   value: "Liederbach (DELBD)",
   label: "Liederbach (DELBD)"
  },
  {
   value: "Liederbach am Taunus (DELTA)",
   label: "Liederbach am Taunus (DELTA)"
  },
  {
   value: "Liegau-Augustusbad (DELGA)",
   label: "Liegau-Augustusbad (DELGA)"
  },
  {
   value: "Lienen (DELIE)",
   label: "Lienen (DELIE)"
  },
  {
   value: "Lieser (DELSR)",
   label: "Lieser (DELSR)"
  },
  {
   value: "Lilienthal (DELIL)",
   label: "Lilienthal (DELIL)"
  },
  {
   value: "Lilienthal (DEZAW)",
   label: "Lilienthal (DEZAW)"
  },
  {
   value: "Limburg an der Lahn (DELML)",
   label: "Limburg an der Lahn (DELML)"
  },
  {
   value: "Limeshain (DELSH)",
   label: "Limeshain (DELSH)"
  },
  {
   value: "Linden (DELDN)",
   label: "Linden (DELDN)"
  },
  {
   value: "Lindern (DELNR)",
   label: "Lindern (DELNR)"
  },
  {
   value: "Lindlar (DELDR)",
   label: "Lindlar (DELDR)"
  },
  {
   value: "Lingenfeld (DELIF)",
   label: "Lingenfeld (DELIF)"
  },
  {
   value: "Linow (DELNO)",
   label: "Linow (DELNO)"
  },
  {
   value: "Linthe (DELTH)",
   label: "Linthe (DELTH)"
  },
  {
   value: "Lippendorf (DELID)",
   label: "Lippendorf (DELID)"
  },
  {
   value: "Lippetal (DELPE)",
   label: "Lippetal (DELPE)"
  },
  {
   value: "Löbau (DELBA)",
   label: "Löbau (DELBA)"
  },
  {
   value: "Lobenstein (DELOS)",
   label: "Lobenstein (DELOS)"
  },
  {
   value: "Löberschütz (DEZAU)",
   label: "Löberschütz (DEZAU)"
  },
  {
   value: "Löbichau (DELOB)",
   label: "Löbichau (DELOB)"
  },
  {
   value: "Lobstädt (DELTD)",
   label: "Lobstädt (DELTD)"
  },
  {
   value: "Löchgau (DELCA)",
   label: "Löchgau (DELCA)"
  },
  {
   value: "Löffingen (DELFF)",
   label: "Löffingen (DELFF)"
  },
  {
   value: "Lohberg (DELHQ)",
   label: "Lohberg (DELHQ)"
  },
  {
   value: "Lohfelden (DELFL)",
   label: "Lohfelden (DELFL)"
  },
  {
   value: "Löhnberg (DELHB)",
   label: "Löhnberg (DELHB)"
  },
  {
   value: "Löhnerheide (DELNH)",
   label: "Löhnerheide (DELNH)"
  },
  {
   value: "Loiching (DEZAV)",
   label: "Loiching (DEZAV)"
  },
  {
   value: "Loitsche (DELOI)",
   label: "Loitsche (DELOI)"
  },
  {
   value: "Loitz (Demmin) (DELOZ)",
   label: "Loitz (Demmin) (DELOZ)"
  },
  {
   value: "Longen (DEONG)",
   label: "Longen (DEONG)"
  },
  {
   value: "Longkamp (DELKP)",
   label: "Longkamp (DELKP)"
  },
  {
   value: "Lonnerstadt (DELRT)",
   label: "Lonnerstadt (DELRT)"
  },
  {
   value: "Lonsheim (DERPL)",
   label: "Lonsheim (DERPL)"
  },
  {
   value: "Lorch (DELOC)",
   label: "Lorch (DELOC)"
  },
  {
   value: "Lorch (DELRR)",
   label: "Lorch (DELRR)"
  },
  {
   value: "Lörch (DELRH)",
   label: "Lörch (DELRH)"
  },
  {
   value: "Lorup (DELRP)",
   label: "Lorup (DELRP)"
  },
  {
   value: "Lorzweiler (DERVL)",
   label: "Lorzweiler (DERVL)"
  },
  {
   value: "Losheim (DELSM)",
   label: "Losheim (DELSM)"
  },
  {
   value: "Lottstetten (DELTS)",
   label: "Lottstetten (DELTS)"
  },
  {
   value: "Löwenberg (DELWB)",
   label: "Löwenberg (DELWB)"
  },
  {
   value: "Lübars (DELUS)",
   label: "Lübars (DELUS)"
  },
  {
   value: "Lübben (DELUB)",
   label: "Lübben (DELUB)"
  },
  {
   value: "Lübbenau (DELUA)",
   label: "Lübbenau (DELUA)"
  },
  {
   value: "Lübtheen (DELBX)",
   label: "Lübtheen (DELBX)"
  },
  {
   value: "Lucka (DELCK)",
   label: "Lucka (DELCK)"
  },
  {
   value: "Lucka (DELKA)",
   label: "Lucka (DELKA)"
  },
  {
   value: "Luckau (DELRD)",
   label: "Luckau (DELRD)"
  },
  {
   value: "Luckau (Wendland) (DELKW)",
   label: "Luckau (Wendland) (DELKW)"
  },
  {
   value: "Luckenbach (DELUC)",
   label: "Luckenbach (DELUC)"
  },
  {
   value: "Luckenwalde (DELUQ)",
   label: "Luckenwalde (DELUQ)"
  },
  {
   value: "Lüderitz (DELRZ)",
   label: "Lüderitz (DELRZ)"
  },
  {
   value: "Lüdersburg (DELDS)",
   label: "Lüdersburg (DELDS)"
  },
  {
   value: "Ludwigsau (DELSU)",
   label: "Ludwigsau (DELSU)"
  },
  {
   value: "Ludwigsburg (DELWG)",
   label: "Ludwigsburg (DELWG)"
  },
  {
   value: "Ludwigsfelde (DELWE)",
   label: "Ludwigsfelde (DELWE)"
  },
  {
   value: "Ludwigshöhe (DELGX)",
   label: "Ludwigshöhe (DELGX)"
  },
  {
   value: "Ludwigswinkel (DELWL)",
   label: "Ludwigswinkel (DELWL)"
  },
  {
   value: "Lugau (Erzgebirge) (DELUU)",
   label: "Lugau (Erzgebirge) (DELUU)"
  },
  {
   value: "Luhe-Wildenau (DELWI)",
   label: "Luhe-Wildenau (DELWI)"
  },
  {
   value: "Lunow (DELOW)",
   label: "Lunow (DELOW)"
  },
  {
   value: "Lusche (DEUSC)",
   label: "Lusche (DEUSC)"
  },
  {
   value: "Lustadt (DELUJ)",
   label: "Lustadt (DELUJ)"
  },
  {
   value: "Lutherstadt Eisleben (DELQN)",
   label: "Lutherstadt Eisleben (DELQN)"
  },
  {
   value: "Lutherstadt Wittenberg (DEZAX)",
   label: "Lutherstadt Wittenberg (DEZAX)"
  },
  {
   value: "Lutjenburg (DETJE)",
   label: "Lutjenburg (DETJE)"
  },
  {
   value: "Lütjensee (DELJE)",
   label: "Lütjensee (DELJE)"
  },
  {
   value: "Lüttow (DELTW)",
   label: "Lüttow (DELTW)"
  },
  {
   value: "Lutzerath (DELZH)",
   label: "Lutzerath (DELZH)"
  },
  {
   value: "Lychen (DELYC)",
   label: "Lychen (DELYC)"
  },
  {
   value: "Machern (DEZBQ)",
   label: "Machern (DEZBQ)"
  },
  {
   value: "Mackenbach (DEMCB)",
   label: "Mackenbach (DEMCB)"
  },
  {
   value: "Magdala (DEMGA)",
   label: "Magdala (DEMGA)"
  },
  {
   value: "Mahlberg (DEMAH)",
   label: "Mahlberg (DEMAH)"
  },
  {
   value: "Mahlow (DEMHW)",
   label: "Mahlow (DEMHW)"
  },
  {
   value: "Maikammer (DEMYK)",
   label: "Maikammer (DEMYK)"
  },
  {
   value: "Mainhardt (DEMNT)",
   label: "Mainhardt (DEMNT)"
  },
  {
   value: "Mainleus (DEMYN)",
   label: "Mainleus (DEMYN)"
  },
  {
   value: "Maisach (DEMAC)",
   label: "Maisach (DEMAC)"
  },
  {
   value: "Malbergweich (DEMAW)",
   label: "Malbergweich (DEMAW)"
  },
  {
   value: "Malchin (DEMCN)",
   label: "Malchin (DEMCN)"
  },
  {
   value: "Malchow (DEMLW)",
   label: "Malchow (DEMLW)"
  },
  {
   value: "Malente (DEMAM)",
   label: "Malente (DEMAM)"
  },
  {
   value: "Malliss (DEMDM)",
   label: "Malliss (DEMDM)"
  },
  {
   value: "Mallnow (DEMNW)",
   label: "Mallnow (DEMNW)"
  },
  {
   value: "Malsburg (DEMLU)",
   label: "Malsburg (DEMLU)"
  },
  {
   value: "Malsch (DEMLH)",
   label: "Malsch (DEMLH)"
  },
  {
   value: "Malsfeld (DEMFL)",
   label: "Malsfeld (DEMFL)"
  },
  {
   value: "Mamming (DEMMI)",
   label: "Mamming (DEMMI)"
  },
  {
   value: "Manching (DEMGB)",
   label: "Manching (DEMGB)"
  },
  {
   value: "Mandern (DEMDR)",
   label: "Mandern (DEMDR)"
  },
  {
   value: "Manschnow (DEMOW)",
   label: "Manschnow (DEMOW)"
  },
  {
   value: "Marbach am Neckar (DEMNC)",
   label: "Marbach am Neckar (DEMNC)"
  },
  {
   value: "Mariakirchen (DEMKN)",
   label: "Mariakirchen (DEMKN)"
  },
  {
   value: "Marienberg (DEMRI)",
   label: "Marienberg (DEMRI)"
  },
  {
   value: "Mariendorf (DEMDF)",
   label: "Mariendorf (DEMDF)"
  },
  {
   value: "Marienmünster (DEMMS)",
   label: "Marienmünster (DEMMS)"
  },
  {
   value: "Markersdorf (DEMDO)",
   label: "Markersdorf (DEMDO)"
  },
  {
   value: "Märkisch Linden (DEMLE)",
   label: "Märkisch Linden (DEMLE)"
  },
  {
   value: "Markkleeberg (DEMKK)",
   label: "Markkleeberg (DEMKK)"
  },
  {
   value: "Markt Bibart (DEMBI)",
   label: "Markt Bibart (DEMBI)"
  },
  {
   value: "Markt Erlbach (DEMBW)",
   label: "Markt Erlbach (DEMBW)"
  },
  {
   value: "Markt Indersdorf (DEMIF)",
   label: "Markt Indersdorf (DEMIF)"
  },
  {
   value: "Markt Schwaben (DEMSN)",
   label: "Markt Schwaben (DEMSN)"
  },
  {
   value: "Marktbergel (DEMBL)",
   label: "Marktbergel (DEMBL)"
  },
  {
   value: "Marktbreit (DEMKT)",
   label: "Marktbreit (DEMKT)"
  },
  {
   value: "Marktl (DEZCF)",
   label: "Marktl (DEZCF)"
  },
  {
   value: "Marktleugast (DEMAK)",
   label: "Marktleugast (DEMAK)"
  },
  {
   value: "Marktrodach (DEMTD)",
   label: "Marktrodach (DEMTD)"
  },
  {
   value: "Marlen (DEMRL)",
   label: "Marlen (DEMRL)"
  },
  {
   value: "Marquardt (DEMQT)",
   label: "Marquardt (DEMQT)"
  },
  {
   value: "Martinskirchen (DEMSK)",
   label: "Martinskirchen (DEMSK)"
  },
  {
   value: "Marzahne (DEMZA)",
   label: "Marzahne (DEMZA)"
  },
  {
   value: "Marzell (DEMZL)",
   label: "Marzell (DEMZL)"
  },
  {
   value: "Masburg (DESBU)",
   label: "Masburg (DESBU)"
  },
  {
   value: "Massen (DEMXX)",
   label: "Massen (DEMXX)"
  },
  {
   value: "Massing (DEMYY)",
   label: "Massing (DEMYY)"
  },
  {
   value: "Mauer (DEMUX)",
   label: "Mauer (DEMUX)"
  },
  {
   value: "Maxau (DEMXA)",
   label: "Maxau (DEMXA)"
  },
  {
   value: "Maxdorf\/Pfalz (DEMAX)",
   label: "Maxdorf\/Pfalz (DEMAX)"
  },
  {
   value: "Maxhütte-Haidhof (DEXTH)",
   label: "Maxhütte-Haidhof (DEXTH)"
  },
  {
   value: "Maximiliansau (DEMXM)",
   label: "Maximiliansau (DEMXM)"
  },
  {
   value: "Mechtersen (DEMCR)",
   label: "Mechtersen (DEMCR)"
  },
  {
   value: "Meckenbeuren (DEMBR)",
   label: "Meckenbeuren (DEMBR)"
  },
  {
   value: "Meckesheim (DECKE)",
   label: "Meckesheim (DECKE)"
  },
  {
   value: "Medebach (DEMDB)",
   label: "Medebach (DEMDB)"
  },
  {
   value: "Medewitz (DEMDZ)",
   label: "Medewitz (DEMDZ)"
  },
  {
   value: "Meeder (DEZJP)",
   label: "Meeder (DEZJP)"
  },
  {
   value: "Mehlingen (DEEHL)",
   label: "Mehlingen (DEEHL)"
  },
  {
   value: "Mehren (DEMXY)",
   label: "Mehren (DEMXY)"
  },
  {
   value: "Mehring (DEMHR)",
   label: "Mehring (DEMHR)"
  },
  {
   value: "Mehring (Altötting) (DEMKO)",
   label: "Mehring (Altötting) (DEMKO)"
  },
  {
   value: "Mehrstetten (DEZBS)",
   label: "Mehrstetten (DEZBS)"
  },
  {
   value: "Mehrum (DEMRU)",
   label: "Mehrum (DEMRU)"
  },
  {
   value: "Meiderich (DEMDI)",
   label: "Meiderich (DEMDI)"
  },
  {
   value: "Meila (DEMSQ)",
   label: "Meila (DEMSQ)"
  },
  {
   value: "Meinhard (DEMDH)",
   label: "Meinhard (DEMDH)"
  },
  {
   value: "Meinheim (DEMHI)",
   label: "Meinheim (DEMHI)"
  },
  {
   value: "Meiningen (DEMNI)",
   label: "Meiningen (DEMNI)"
  },
  {
   value: "Meisenheim (DEMIM)",
   label: "Meisenheim (DEMIM)"
  },
  {
   value: "Meiste (DEMTS)",
   label: "Meiste (DEMTS)"
  },
  {
   value: "Meitzendorf (DEMZF)",
   label: "Meitzendorf (DEMZF)"
  },
  {
   value: "Melbeck (DEMLC)",
   label: "Melbeck (DEMLC)"
  },
  {
   value: "Mellingen (DEMNG)",
   label: "Mellingen (DEMNG)"
  },
  {
   value: "Mendig (DEMDG)",
   label: "Mendig (DEMDG)"
  },
  {
   value: "Mendig (DEMND)",
   label: "Mendig (DEMND)"
  },
  {
   value: "Mengen (DEMGE)",
   label: "Mengen (DEMGE)"
  },
  {
   value: "Mengersgereuth-Hämmern (DEMHN)",
   label: "Mengersgereuth-Hämmern (DEMHN)"
  },
  {
   value: "Mengerskirchen (DEMKI)",
   label: "Mengerskirchen (DEMKI)"
  },
  {
   value: "Menteroda (DEMTA)",
   label: "Menteroda (DEMTA)"
  },
  {
   value: "Merbelsrod (DEMRD)",
   label: "Merbelsrod (DEMRD)"
  },
  {
   value: "Merenberg (DEMBB)",
   label: "Merenberg (DEMBB)"
  },
  {
   value: "Mering (DEMBY)",
   label: "Mering (DEMBY)"
  },
  {
   value: "Merkendorf (DEMKD)",
   label: "Merkendorf (DEMKD)"
  },
  {
   value: "Merkers (DEMEK)",
   label: "Merkers (DEMEK)"
  },
  {
   value: "Merklingen (DEMEJ)",
   label: "Merklingen (DEMEJ)"
  },
  {
   value: "Merseburg (DEMEG)",
   label: "Merseburg (DEMEG)"
  },
  {
   value: "Merzalben (DEMZB)",
   label: "Merzalben (DEMZB)"
  },
  {
   value: "Merzen (DEMJN)",
   label: "Merzen (DEMJN)"
  },
  {
   value: "Merzenich (DEMZH)",
   label: "Merzenich (DEMZH)"
  },
  {
   value: "Merzhausen (DEZHU)",
   label: "Merzhausen (DEZHU)"
  },
  {
   value: "Messel (DEMSS)",
   label: "Messel (DEMSS)"
  },
  {
   value: "Messingen (DEZBP)",
   label: "Messingen (DEZBP)"
  },
  {
   value: "Messstetten (DETEN)",
   label: "Messstetten (DETEN)"
  },
  {
   value: "Metelen (DETLN)",
   label: "Metelen (DETLN)"
  },
  {
   value: "Mettenheim (DEMTM)",
   label: "Mettenheim (DEMTM)"
  },
  {
   value: "Mettingen (DEMTT)",
   label: "Mettingen (DEMTT)"
  },
  {
   value: "Meuspath (DEMPH)",
   label: "Meuspath (DEMPH)"
  },
  {
   value: "Michendorf (DEORF)",
   label: "Michendorf (DEORF)"
  },
  {
   value: "Miehlen (DEZJO)",
   label: "Miehlen (DEZJO)"
  },
  {
   value: "Mielberg (DEMBE)",
   label: "Mielberg (DEMBE)"
  },
  {
   value: "Mieste (DEMEX)",
   label: "Mieste (DEMEX)"
  },
  {
   value: "Mietingen (DEMGI)",
   label: "Mietingen (DEMGI)"
  },
  {
   value: "Mihla (DEMLA)",
   label: "Mihla (DEMLA)"
  },
  {
   value: "Mildenau (DEMNU)",
   label: "Mildenau (DEMNU)"
  },
  {
   value: "Milmersdorf (DETEP)",
   label: "Milmersdorf (DETEP)"
  },
  {
   value: "Miltach (DEMIA)",
   label: "Miltach (DEMIA)"
  },
  {
   value: "Miltzow (DEMZW)",
   label: "Miltzow (DEMZW)"
  },
  {
   value: "Minheim (DEMNM)",
   label: "Minheim (DEMNM)"
  },
  {
   value: "Misburg (DEMIB)",
   label: "Misburg (DEMIB)"
  },
  {
   value: "Mittelbach (DETTB)",
   label: "Mittelbach (DETTB)"
  },
  {
   value: "Mittelherwigsdorf (DEMWF)",
   label: "Mittelherwigsdorf (DEMWF)"
  },
  {
   value: "Mittelsbüren (DEMSB)",
   label: "Mittelsbüren (DEMSB)"
  },
  {
   value: "Mittenaar (DEMAA)",
   label: "Mittenaar (DEMAA)"
  },
  {
   value: "Mochau (DEMOA)",
   label: "Mochau (DEMOA)"
  },
  {
   value: "Mochenwangen (DEMWN)",
   label: "Mochenwangen (DEMWN)"
  },
  {
   value: "Möckern (DEMKR)",
   label: "Möckern (DEMKR)"
  },
  {
   value: "Möckern (DEZBJ)",
   label: "Möckern (DEZBJ)"
  },
  {
   value: "Möckern (DEZBM)",
   label: "Möckern (DEZBM)"
  },
  {
   value: "Mockrehna (DEZCA)",
   label: "Mockrehna (DEZCA)"
  },
  {
   value: "Modautal (DEMDU)",
   label: "Modautal (DEMDU)"
  },
  {
   value: "Mögglingen (DEMGW)",
   label: "Mögglingen (DEMGW)"
  },
  {
   value: "Möglingen (DEZCB)",
   label: "Möglingen (DEZCB)"
  },
  {
   value: "Möhnesee (DEZGX)",
   label: "Möhnesee (DEZGX)"
  },
  {
   value: "Möhnsen (DEMNN)",
   label: "Möhnsen (DEMNN)"
  },
  {
   value: "Mohsdorf (DEMDS)",
   label: "Mohsdorf (DEMDS)"
  },
  {
   value: "Moltzow (DEZCK)",
   label: "Moltzow (DEZCK)"
  },
  {
   value: "Mömbris (DEMMB)",
   label: "Mömbris (DEMMB)"
  },
  {
   value: "Momlingen (DEMMG)",
   label: "Momlingen (DEMMG)"
  },
  {
   value: "Mömlingen (DEZCC)",
   label: "Mömlingen (DEZCC)"
  },
  {
   value: "Mommenheim (DEMMM)",
   label: "Mommenheim (DEMMM)"
  },
  {
   value: "Mönchenholzhausen (DEZBV)",
   label: "Mönchenholzhausen (DEZBV)"
  },
  {
   value: "Monchweiler (DEMWW)",
   label: "Monchweiler (DEMWW)"
  },
  {
   value: "Moormerland (DEMMD)",
   label: "Moormerland (DEMMD)"
  },
  {
   value: "Moos (DEMSO)",
   label: "Moos (DEMSO)"
  },
  {
   value: "Moosbach (DEOOS)",
   label: "Moosbach (DEOOS)"
  },
  {
   value: "Moosinning (DEMXG)",
   label: "Moosinning (DEMXG)"
  },
  {
   value: "Mörfelden-Walldorf (DEMWA)",
   label: "Mörfelden-Walldorf (DEMWA)"
  },
  {
   value: "Moringen (DEZBZ)",
   label: "Moringen (DEZBZ)"
  },
  {
   value: "Moritzburg (DEMIO)",
   label: "Moritzburg (DEMIO)"
  },
  {
   value: "Mörlenbach (DEMEB)",
   label: "Mörlenbach (DEMEB)"
  },
  {
   value: "Mörnsheim (DEZCI)",
   label: "Mörnsheim (DEZCI)"
  },
  {
   value: "Morschen (DEZCD)",
   label: "Morschen (DEZCD)"
  },
  {
   value: "Morschheim (DEZCE)",
   label: "Morschheim (DEZCE)"
  },
  {
   value: "Mörschied (DEIED)",
   label: "Mörschied (DEIED)"
  },
  {
   value: "Moschheim (DEMHE)",
   label: "Moschheim (DEMHE)"
  },
  {
   value: "Moser (DEMZR)",
   label: "Moser (DEMZR)"
  },
  {
   value: "Mossautal (DEMSU)",
   label: "Mossautal (DEMSU)"
  },
  {
   value: "Mössingen (DEMOI)",
   label: "Mössingen (DEMOI)"
  },
  {
   value: "Mössingen (DESSG)",
   label: "Mössingen (DESSG)"
  },
  {
   value: "Motten (DEMOT)",
   label: "Motten (DEMOT)"
  },
  {
   value: "Möttingen (DEMTI)",
   label: "Möttingen (DEMTI)"
  },
  {
   value: "Mötzingen (DETZI)",
   label: "Mötzingen (DETZI)"
  },
  {
   value: "Mücheln (DEMCL)",
   label: "Mücheln (DEMCL)"
  },
  {
   value: "Mücke (DEMCK)",
   label: "Mücke (DEMCK)"
  },
  {
   value: "Mudersbach (DEMSD)",
   label: "Mudersbach (DEMSD)"
  },
  {
   value: "Mügeln (DEMGX)",
   label: "Mügeln (DEMGX)"
  },
  {
   value: "Mühlau (DEUHU)",
   label: "Mühlau (DEUHU)"
  },
  {
   value: "Mühldorf (DEMLD)",
   label: "Mühldorf (DEMLD)"
  },
  {
   value: "Mühlhausen (DEZCJ)",
   label: "Mühlhausen (DEZCJ)"
  },
  {
   value: "Mühlheim an der Eis (DEMMX)",
   label: "Mühlheim an der Eis (DEMMX)"
  },
  {
   value: "Mühlrose (DELRO)",
   label: "Mühlrose (DELRO)"
  },
  {
   value: "Mulda (DEMDA)",
   label: "Mulda (DEMDA)"
  },
  {
   value: "Mulfingen (DEMFI)",
   label: "Mulfingen (DEMFI)"
  },
  {
   value: "Mülheim (DEMMO)",
   label: "Mülheim (DEMMO)"
  },
  {
   value: "Müllenbach (Ahrweiler) (DEMLL)",
   label: "Müllenbach (Ahrweiler) (DEMLL)"
  },
  {
   value: "Müllrose (DEMRO)",
   label: "Müllrose (DEMRO)"
  },
  {
   value: "Mulsen (DEULS)",
   label: "Mulsen (DEULS)"
  },
  {
   value: "Mülsen Sankt Jacob (DEMSJ)",
   label: "Mülsen Sankt Jacob (DEMSJ)"
  },
  {
   value: "Mülsen Sankt Micheln (DEMUI)",
   label: "Mülsen Sankt Micheln (DEMUI)"
  },
  {
   value: "Müncheberg (DEMCG)",
   label: "Müncheberg (DEMCG)"
  },
  {
   value: "Münchenbernsdorf (DEMUB)",
   label: "Münchenbernsdorf (DEMUB)"
  },
  {
   value: "Münchhausen (DEMHH)",
   label: "Münchhausen (DEMHH)"
  },
  {
   value: "Munderkingen (DEMDK)",
   label: "Munderkingen (DEMDK)"
  },
  {
   value: "Münnerstadt (DEMNR)",
   label: "Münnerstadt (DEMNR)"
  },
  {
   value: "Munsing (DEMUQ)",
   label: "Munsing (DEMUQ)"
  },
  {
   value: "Münster (DEMUS)",
   label: "Münster (DEMUS)"
  },
  {
   value: "Münster Osnabrück International Airport (DEFMO)",
   label: "Münster Osnabrück International Airport (DEFMO)"
  },
  {
   value: "Münster-Sarmsheim (DEMNQ)",
   label: "Münster-Sarmsheim (DEMNQ)"
  },
  {
   value: "Mutlangen (DEMXL)",
   label: "Mutlangen (DEMXL)"
  },
  {
   value: "Mutterstadt (DEMDT)",
   label: "Mutterstadt (DEMDT)"
  },
  {
   value: "Mutzschen (DEMUZ)",
   label: "Mutzschen (DEMUZ)"
  },
  {
   value: "Mylau (DEMAU)",
   label: "Mylau (DEMAU)"
  },
  {
   value: "Nahrendorf (DENHD)",
   label: "Nahrendorf (DENHD)"
  },
  {
   value: "Nalbach (DENBC)",
   label: "Nalbach (DENBC)"
  },
  {
   value: "Näthern (DENTH)",
   label: "Näthern (DENTH)"
  },
  {
   value: "Nattheim (DENAT)",
   label: "Nattheim (DENAT)"
  },
  {
   value: "Nauen (DENUQ)",
   label: "Nauen (DENUQ)"
  },
  {
   value: "Nauheim (DENUM)",
   label: "Nauheim (DENUM)"
  },
  {
   value: "Naundorf (DENAF)",
   label: "Naundorf (DENAF)"
  },
  {
   value: "Naunhof (DEZDC)",
   label: "Naunhof (DEZDC)"
  },
  {
   value: "Nebra (DENRU)",
   label: "Nebra (DENRU)"
  },
  {
   value: "Neckartailfingen (DENTA)",
   label: "Neckartailfingen (DENTA)"
  },
  {
   value: "Neckartenzlingen (DENKZ)",
   label: "Neckartenzlingen (DENKZ)"
  },
  {
   value: "Neckarwestheim (DENKW)",
   label: "Neckarwestheim (DENKW)"
  },
  {
   value: "Neckarzimmern (DENZE)",
   label: "Neckarzimmern (DENZE)"
  },
  {
   value: "Neef (DENFE)",
   label: "Neef (DENFE)"
  },
  {
   value: "Neetze (DEEZE)",
   label: "Neetze (DEEZE)"
  },
  {
   value: "Nehren (DENEY)",
   label: "Nehren (DENEY)"
  },
  {
   value: "Neichen (DENIC)",
   label: "Neichen (DENIC)"
  },
  {
   value: "Neitersen (DENTN)",
   label: "Neitersen (DENTN)"
  },
  {
   value: "Nempitz (DENMT)",
   label: "Nempitz (DENMT)"
  },
  {
   value: "Nemsdorf-Göhrendorf (DENGO)",
   label: "Nemsdorf-Göhrendorf (DENGO)"
  },
  {
   value: "Nentershausen (DENHU)",
   label: "Nentershausen (DENHU)"
  },
  {
   value: "Nentmannsdorf (DENMF)",
   label: "Nentmannsdorf (DENMF)"
  },
  {
   value: "Nerchau (DENCU)",
   label: "Nerchau (DENCU)"
  },
  {
   value: "Neresheim (DENSH)",
   label: "Neresheim (DENSH)"
  },
  {
   value: "Nersingen (DENSY)",
   label: "Nersingen (DENSY)"
  },
  {
   value: "Nettersheim (DENHI)",
   label: "Nettersheim (DENHI)"
  },
  {
   value: "Netzschkau (DENZK)",
   label: "Netzschkau (DENZK)"
  },
  {
   value: "Neu Büddenstedt (DEBDD)",
   label: "Neu Büddenstedt (DEBDD)"
  },
  {
   value: "Neu Kaliss (DEZCO)",
   label: "Neu Kaliss (DEZCO)"
  },
  {
   value: "Neuberg (DEZCL)",
   label: "Neuberg (DEZCL)"
  },
  {
   value: "Neubrunn (DENBO)",
   label: "Neubrunn (DENBO)"
  },
  {
   value: "Neubrunn (DENUU)",
   label: "Neubrunn (DENUU)"
  },
  {
   value: "Neubulach (DENBL)",
   label: "Neubulach (DENBL)"
  },
  {
   value: "Neuburg Am Inn (DENAI)",
   label: "Neuburg Am Inn (DENAI)"
  },
  {
   value: "Neudenau (DENDA)",
   label: "Neudenau (DENDA)"
  },
  {
   value: "Neuendorf (DENDF)",
   label: "Neuendorf (DENDF)"
  },
  {
   value: "Neuengönna-Porstendorf (DENPO)",
   label: "Neuengönna-Porstendorf (DENPO)"
  },
  {
   value: "Neuenhagen (DEEAE)",
   label: "Neuenhagen (DEEAE)"
  },
  {
   value: "Neuenhagen bei Berlin (DENGB)",
   label: "Neuenhagen bei Berlin (DENGB)"
  },
  {
   value: "Neuenkirchen (Cuxhaven) (DEZCS)",
   label: "Neuenkirchen (Cuxhaven) (DEZCS)"
  },
  {
   value: "Neuenkirchen (Lüneburger Heide) (DENLH)",
   label: "Neuenkirchen (Lüneburger Heide) (DENLH)"
  },
  {
   value: "Neuenmarkt (DEZDB)",
   label: "Neuenmarkt (DEZDB)"
  },
  {
   value: "Neuensalz (DENLZ)",
   label: "Neuensalz (DENLZ)"
  },
  {
   value: "Neuenstadt am Kocher (DENNT)",
   label: "Neuenstadt am Kocher (DENNT)"
  },
  {
   value: "Neuenstein (DENTE)",
   label: "Neuenstein (DENTE)"
  },
  {
   value: "Neuerburg (DENUG)",
   label: "Neuerburg (DENUG)"
  },
  {
   value: "Neuessen (DENSE)",
   label: "Neuessen (DENSE)"
  },
  {
   value: "Neuffen (DENXF)",
   label: "Neuffen (DENXF)"
  },
  {
   value: "Neufra (DENFA)",
   label: "Neufra (DENFA)"
  },
  {
   value: "Neuhaus (DENAU)",
   label: "Neuhaus (DENAU)"
  },
  {
   value: "Neuhaus am Inn (DENAY)",
   label: "Neuhaus am Inn (DENAY)"
  },
  {
   value: "Neuhaus am Rennweg (DENAR)",
   label: "Neuhaus am Rennweg (DENAR)"
  },
  {
   value: "Neuhaus an der Pegnitz (DENEP)",
   label: "Neuhaus an der Pegnitz (DENEP)"
  },
  {
   value: "Neuhausen (DENUX)",
   label: "Neuhausen (DENUX)"
  },
  {
   value: "Neuhof (DENUO)",
   label: "Neuhof (DENUO)"
  },
  {
   value: "Neuhofen (DEZCM)",
   label: "Neuhofen (DEZCM)"
  },
  {
   value: "Neuhof-Hildesheim (DENOF)",
   label: "Neuhof-Hildesheim (DENOF)"
  },
  {
   value: "Neukieritzsch (DEUKI)",
   label: "Neukieritzsch (DEUKI)"
  },
  {
   value: "Neukirch (DENIK)",
   label: "Neukirch (DENIK)"
  },
  {
   value: "Neukirchen (DENEJ)",
   label: "Neukirchen (DENEJ)"
  },
  {
   value: "Neukirchen (DENKV)",
   label: "Neukirchen (DENKV)"
  },
  {
   value: "Neukirchen (DENNF)",
   label: "Neukirchen (DENNF)"
  },
  {
   value: "Neukirchen\/Pleisse (DENKC)",
   label: "Neukirchen\/Pleisse (DENKC)"
  },
  {
   value: "Neukirchen-Vluyn (DENVL)",
   label: "Neukirchen-Vluyn (DENVL)"
  },
  {
   value: "Neu-Kupfer (DEFER)",
   label: "Neu-Kupfer (DEFER)"
  },
  {
   value: "Neukyhna (DENUK)",
   label: "Neukyhna (DENUK)"
  },
  {
   value: "Neulingen (DENIG)",
   label: "Neulingen (DENIG)"
  },
  {
   value: "Neulussheim (DENLM)",
   label: "Neulussheim (DENLM)"
  },
  {
   value: "Neumagen (DENMN)",
   label: "Neumagen (DENMN)"
  },
  {
   value: "Neumark (DEZCT)",
   label: "Neumark (DEZCT)"
  },
  {
   value: "Neumarkt-Sankt Veit (DENSV)",
   label: "Neumarkt-Sankt Veit (DENSV)"
  },
  {
   value: "Neunburg vorm Wald (DENBW)",
   label: "Neunburg vorm Wald (DENBW)"
  },
  {
   value: "Neunkhausen (DENKH)",
   label: "Neunkhausen (DENKH)"
  },
  {
   value: "Neunkirchen am Brand (DENBD)",
   label: "Neunkirchen am Brand (DENBD)"
  },
  {
   value: "Neureichenau (DENEA)",
   label: "Neureichenau (DENEA)"
  },
  {
   value: "Neuscharrel (DENCA)",
   label: "Neuscharrel (DENCA)"
  },
  {
   value: "Neuseddin (DENDS)",
   label: "Neuseddin (DENDS)"
  },
  {
   value: "Neusitz (DENSZ)",
   label: "Neusitz (DENSZ)"
  },
  {
   value: "Neusorg (DEYUG)",
   label: "Neusorg (DEYUG)"
  },
  {
   value: "Neustadt (DENAD)",
   label: "Neustadt (DENAD)"
  },
  {
   value: "Neustadt (DENEX)",
   label: "Neustadt (DENEX)"
  },
  {
   value: "Neustadt (DENSD)",
   label: "Neustadt (DENSD)"
  },
  {
   value: "Neustadt (DENWA)",
   label: "Neustadt (DENWA)"
  },
  {
   value: "Neustadt (DETDT)",
   label: "Neustadt (DETDT)"
  },
  {
   value: "Neustadt an der Orla (DENTO)",
   label: "Neustadt an der Orla (DENTO)"
  },
  {
   value: "Neustadt-Glewe (DENGL)",
   label: "Neustadt-Glewe (DENGL)"
  },
  {
   value: "Neutrebbin (DENTB)",
   label: "Neutrebbin (DENTB)"
  },
  {
   value: "Neuweier (DENRW)",
   label: "Neuweier (DENRW)"
  },
  {
   value: "Neuweiler (DENWR)",
   label: "Neuweiler (DENWR)"
  },
  {
   value: "Neversdorf (DENSO)",
   label: "Neversdorf (DENSO)"
  },
  {
   value: "Nideggen (DENGG)",
   label: "Nideggen (DENGG)"
  },
  {
   value: "Niederaichbach (DENBH)",
   label: "Niederaichbach (DENBH)"
  },
  {
   value: "Niederau (Meisharpen) (DENDU)",
   label: "Niederau (Meisharpen) (DENDU)"
  },
  {
   value: "Niederbergkirchen (DENBE)",
   label: "Niederbergkirchen (DENBE)"
  },
  {
   value: "Niederdollendorf (DEDFX)",
   label: "Niederdollendorf (DEDFX)"
  },
  {
   value: "Niederdorf (DENIF)",
   label: "Niederdorf (DENIF)"
  },
  {
   value: "Niederdorla (DENDO)",
   label: "Niederdorla (DENDO)"
  },
  {
   value: "Niederfüllbach (DEZCQ)",
   label: "Niederfüllbach (DEZCQ)"
  },
  {
   value: "Niederkumbd (DEZCR)",
   label: "Niederkumbd (DEZCR)"
  },
  {
   value: "Niederlangen (DENLG)",
   label: "Niederlangen (DENLG)"
  },
  {
   value: "Niederlehme (DENDL)",
   label: "Niederlehme (DENDL)"
  },
  {
   value: "Niederneuching (DENGH)",
   label: "Niederneuching (DENGH)"
  },
  {
   value: "Niedernhall (DEBNI)",
   label: "Niedernhall (DEBNI)"
  },
  {
   value: "Niederorschel (DENRS)",
   label: "Niederorschel (DENRS)"
  },
  {
   value: "Niederraunau (DERRN)",
   label: "Niederraunau (DERRN)"
  },
  {
   value: "Niederrossla (DENRL)",
   label: "Niederrossla (DENRL)"
  },
  {
   value: "Niederschmalkalden (DEZCU)",
   label: "Niederschmalkalden (DEZCU)"
  },
  {
   value: "Niederweimar (DENDE)",
   label: "Niederweimar (DENDE)"
  },
  {
   value: "Niederwerbig (DENDG)",
   label: "Niederwerbig (DENDG)"
  },
  {
   value: "Niederwiesa (DENWS)",
   label: "Niederwiesa (DENWS)"
  },
  {
   value: "Niederwinkling (DENWK)",
   label: "Niederwinkling (DENWK)"
  },
  {
   value: "Niederwörresbach (DENWO)",
   label: "Niederwörresbach (DENWO)"
  },
  {
   value: "Niederzissen (DENZS)",
   label: "Niederzissen (DENZS)"
  },
  {
   value: "Niehl\/Köln (DENHL)",
   label: "Niehl\/Köln (DENHL)"
  },
  {
   value: "Niemberg (DENMB)",
   label: "Niemberg (DENMB)"
  },
  {
   value: "Niemegk (DENMG)",
   label: "Niemegk (DENMG)"
  },
  {
   value: "Nienburg (DEZCX)",
   label: "Nienburg (DEZCX)"
  },
  {
   value: "Nienhagen (bei Celle) (DENNN)",
   label: "Nienhagen (bei Celle) (DENNN)"
  },
  {
   value: "Nienstadt (DENTT)",
   label: "Nienstadt (DENTT)"
  },
  {
   value: "Niersbach (DENIX)",
   label: "Niersbach (DENIX)"
  },
  {
   value: "Nieschütz (DENCZ)",
   label: "Nieschütz (DENCZ)"
  },
  {
   value: "Niesky (DENKY)",
   label: "Niesky (DENKY)"
  },
  {
   value: "Niestetal (DENSL)",
   label: "Niestetal (DENSL)"
  },
  {
   value: "Nister (DENTR)",
   label: "Nister (DENTR)"
  },
  {
   value: "Nisterau (DENRX)",
   label: "Nisterau (DENRX)"
  },
  {
   value: "Nisterberg (DEISS)",
   label: "Nisterberg (DEISS)"
  },
  {
   value: "Nistertal (DENRT)",
   label: "Nistertal (DENRT)"
  },
  {
   value: "Nittenau (DENIT)",
   label: "Nittenau (DENIT)"
  },
  {
   value: "Nobitz (DENBI)",
   label: "Nobitz (DENBI)"
  },
  {
   value: "Nochten (DENOC)",
   label: "Nochten (DENOC)"
  },
  {
   value: "Nohfelden (DEELD)",
   label: "Nohfelden (DEELD)"
  },
  {
   value: "Nomborn (DENOB)",
   label: "Nomborn (DENOB)"
  },
  {
   value: "Nonnweiler (DENNW)",
   label: "Nonnweiler (DENNW)"
  },
  {
   value: "Norddeich\/Dithmarschen (DENDD)",
   label: "Norddeich\/Dithmarschen (DENDD)"
  },
  {
   value: "Nordendorf (DEZCY)",
   label: "Nordendorf (DEZCY)"
  },
  {
   value: "Nordheim (DENHE)",
   label: "Nordheim (DENHE)"
  },
  {
   value: "Nordholz (DENQZ)",
   label: "Nordholz (DENQZ)"
  },
  {
   value: "Nordkirchen (DENOK)",
   label: "Nordkirchen (DENOK)"
  },
  {
   value: "Nordrach (DENRC)",
   label: "Nordrach (DENRC)"
  },
  {
   value: "Nordwalde (DENWE)",
   label: "Nordwalde (DENWE)"
  },
  {
   value: "Norheim (DENRI)",
   label: "Norheim (DENRI)"
  },
  {
   value: "Norken (DENRK)",
   label: "Norken (DENRK)"
  },
  {
   value: "Nortorf (DENTF)",
   label: "Nortorf (DENTF)"
  },
  {
   value: "Nossen (DENSN)",
   label: "Nossen (DENSN)"
  },
  {
   value: "Nufringen (DENUF)",
   label: "Nufringen (DENUF)"
  },
  {
   value: "Nunsdorf (DENSF)",
   label: "Nunsdorf (DENSF)"
  },
  {
   value: "Nürburg (DENRG)",
   label: "Nürburg (DENRG)"
  },
  {
   value: "Nussdorf (DENZF)",
   label: "Nussdorf (DENZF)"
  },
  {
   value: "Nuthe Urstromtal (DENTU)",
   label: "Nuthe Urstromtal (DENTU)"
  },
  {
   value: "Ober-Abtsteinach (DEOAB)",
   label: "Ober-Abtsteinach (DEOAB)"
  },
  {
   value: "Oberahr (DEOHR)",
   label: "Oberahr (DEOHR)"
  },
  {
   value: "Oberaula (DEORL)",
   label: "Oberaula (DEORL)"
  },
  {
   value: "Oberaurach (DEOUH)",
   label: "Oberaurach (DEOUH)"
  },
  {
   value: "Oberbettingen (DEOBB)",
   label: "Oberbettingen (DEOBB)"
  },
  {
   value: "Oberbillig (DEXOB)",
   label: "Oberbillig (DEXOB)"
  },
  {
   value: "Oberding (DEODD)",
   label: "Oberding (DEODD)"
  },
  {
   value: "Oberdorla (DEOOA)",
   label: "Oberdorla (DEOOA)"
  },
  {
   value: "Obergünzburg (DEOUG)",
   label: "Obergünzburg (DEOUG)"
  },
  {
   value: "Oberhausen (DEOHS)",
   label: "Oberhausen (DEOHS)"
  },
  {
   value: "Oberhonnefeld-Gierend (DEONH)",
   label: "Oberhonnefeld-Gierend (DEONH)"
  },
  {
   value: "Oberkochen (DEOKO)",
   label: "Oberkochen (DEOKO)"
  },
  {
   value: "Oberkotzau (DEOKY)",
   label: "Oberkotzau (DEOKY)"
  },
  {
   value: "Oberkrämer (DEOKM)",
   label: "Oberkrämer (DEOKM)"
  },
  {
   value: "Oberlahr (DEOLR)",
   label: "Oberlahr (DEOLR)"
  },
  {
   value: "Oberlichtenau (DEOLA)",
   label: "Oberlichtenau (DEOLA)"
  },
  {
   value: "Obermarschacht (DEOMH)",
   label: "Obermarschacht (DEOMH)"
  },
  {
   value: "Obermassfeld-Grimmenthal (DEOGL)",
   label: "Obermassfeld-Grimmenthal (DEOGL)"
  },
  {
   value: "Obermörlen (DEORM)",
   label: "Obermörlen (DEORM)"
  },
  {
   value: "Obernkirchen (DEOBK)",
   label: "Obernkirchen (DEOBK)"
  },
  {
   value: "Obernzell (DEZLL)",
   label: "Obernzell (DEZLL)"
  },
  {
   value: "Ober-Olm (DEOLM)",
   label: "Ober-Olm (DEOLM)"
  },
  {
   value: "Oberpframmern (DENFO)",
   label: "Oberpframmern (DENFO)"
  },
  {
   value: "Oberreute (DEORU)",
   label: "Oberreute (DEORU)"
  },
  {
   value: "Oberriexingen (DEOXG)",
   label: "Oberriexingen (DEOXG)"
  },
  {
   value: "Oberrot (DEOOT)",
   label: "Oberrot (DEOOT)"
  },
  {
   value: "Oberschleissheim (DEOBS)",
   label: "Oberschleissheim (DEOBS)"
  },
  {
   value: "Oberschöna (DEOSO)",
   label: "Oberschöna (DEOSO)"
  },
  {
   value: "Oberstenfeld (DEOFD)",
   label: "Oberstenfeld (DEOFD)"
  },
  {
   value: "Oberstetten (DEXHH)",
   label: "Oberstetten (DEXHH)"
  },
  {
   value: "Obertaufkirchen (DEZBX)",
   label: "Obertaufkirchen (DEZBX)"
  },
  {
   value: "Obertraubling (DEOBT)",
   label: "Obertraubling (DEOBT)"
  },
  {
   value: "Oberviechtach (DEOBV)",
   label: "Oberviechtach (DEOBV)"
  },
  {
   value: "Oberwerrn (DEZDY)",
   label: "Oberwerrn (DEZDY)"
  },
  {
   value: "Oberwesel (DEOEE)",
   label: "Oberwesel (DEOEE)"
  },
  {
   value: "Oberweser (DEOBW)",
   label: "Oberweser (DEOBW)"
  },
  {
   value: "Oberwinter (DEOWT)",
   label: "Oberwinter (DEOWT)"
  },
  {
   value: "Obhausen (DEOHU)",
   label: "Obhausen (DEOHU)"
  },
  {
   value: "Ochsenfurt (DEOCF)",
   label: "Ochsenfurt (DEOCF)"
  },
  {
   value: "Ochtendung (DEOCD)",
   label: "Ochtendung (DEOCD)"
  },
  {
   value: "Ockenheim (DEOCK)",
   label: "Ockenheim (DEOCK)"
  },
  {
   value: "Odelzhausen (DEZDP)",
   label: "Odelzhausen (DEZDP)"
  },
  {
   value: "Odenthal (DEODE)",
   label: "Odenthal (DEODE)"
  },
  {
   value: "Oderberg (DEORG)",
   label: "Oderberg (DEORG)"
  },
  {
   value: "Oebisfelde (DEOEF)",
   label: "Oebisfelde (DEOEF)"
  },
  {
   value: "Oederan (DEOED)",
   label: "Oederan (DEOED)"
  },
  {
   value: "Oedheim (DEOEM)",
   label: "Oedheim (DEOEM)"
  },
  {
   value: "Oeding (DEODI)",
   label: "Oeding (DEODI)"
  },
  {
   value: "Oestrich-Winkel (DEOSW)",
   label: "Oestrich-Winkel (DEOSW)"
  },
  {
   value: "Oetzen (DEOZN)",
   label: "Oetzen (DEOZN)"
  },
  {
   value: "Oetzingen (DEOEZ)",
   label: "Oetzingen (DEOEZ)"
  },
  {
   value: "Offenau (DEONA)",
   label: "Offenau (DEONA)"
  },
  {
   value: "Offenbach an der Queich (DEODQ)",
   label: "Offenbach an der Queich (DEODQ)"
  },
  {
   value: "Ofterdingen (DEODG)",
   label: "Ofterdingen (DEODG)"
  },
  {
   value: "Oftersheim (DEOFM)",
   label: "Oftersheim (DEOFM)"
  },
  {
   value: "Öhningen (DEOHG)",
   label: "Öhningen (DEOHG)"
  },
  {
   value: "Ohrdruf (DEODR)",
   label: "Ohrdruf (DEODR)"
  },
  {
   value: "Olbersdorf (DEOLF)",
   label: "Olbersdorf (DEOLF)"
  },
  {
   value: "Oldendorf (DEOLD)",
   label: "Oldendorf (DEOLD)"
  },
  {
   value: "Oldendorf (Luhe) (DEODO)",
   label: "Oldendorf (Luhe) (DEODO)"
  },
  {
   value: "Oldinghausen (DEODS)",
   label: "Oldinghausen (DEODS)"
  },
  {
   value: "Olfen (DEOLW)",
   label: "Olfen (DEOLW)"
  },
  {
   value: "Olzheim (DEOLZ)",
   label: "Olzheim (DEOLZ)"
  },
  {
   value: "Oortkaten (DEOTK)",
   label: "Oortkaten (DEOTK)"
  },
  {
   value: "Opfenbach (DEOPB)",
   label: "Opfenbach (DEOPB)"
  },
  {
   value: "Oppach (DEOPC)",
   label: "Oppach (DEOPC)"
  },
  {
   value: "Oppenau (DEOPU)",
   label: "Oppenau (DEOPU)"
  },
  {
   value: "Oppenweiler (DEOPE)",
   label: "Oppenweiler (DEOPE)"
  },
  {
   value: "Oppurg (DEOPG)",
   label: "Oppurg (DEOPG)"
  },
  {
   value: "Oranienbaum (DEONB)",
   label: "Oranienbaum (DEONB)"
  },
  {
   value: "Oranienburg (DEORA)",
   label: "Oranienburg (DEORA)"
  },
  {
   value: "Orbis (DEORC)",
   label: "Orbis (DEORC)"
  },
  {
   value: "Orsingen-Nenzingen (DEOGZ)",
   label: "Orsingen-Nenzingen (DEOGZ)"
  },
  {
   value: "Ortenberg (DEONR)",
   label: "Ortenberg (DEONR)"
  },
  {
   value: "Osann-Monzel (DEONM)",
   label: "Osann-Monzel (DEONM)"
  },
  {
   value: "Oschatz (DEOTZ)",
   label: "Oschatz (DEOTZ)"
  },
  {
   value: "Oschersleben (DEOLN)",
   label: "Oschersleben (DEOLN)"
  },
  {
   value: "Oslebshausen (DEOAS)",
   label: "Oslebshausen (DEOAS)"
  },
  {
   value: "Osloss (DEOSL)",
   label: "Osloss (DEOSL)"
  },
  {
   value: "Ossenberg (DEOSB)",
   label: "Ossenberg (DEOSB)"
  },
  {
   value: "Ostbevern (DEOTV)",
   label: "Ostbevern (DEOTV)"
  },
  {
   value: "Osterfeld (DESXO)",
   label: "Osterfeld (DESXO)"
  },
  {
   value: "Osterrönfeld (DETRD)",
   label: "Osterrönfeld (DETRD)"
  },
  {
   value: "Osterwald (DETER)",
   label: "Osterwald (DETER)"
  },
  {
   value: "Osterweddingen (DEOWD)",
   label: "Osterweddingen (DEOWD)"
  },
  {
   value: "Osterwieck (DEOWF)",
   label: "Osterwieck (DEOWF)"
  },
  {
   value: "Ostheim vor der Rhön (DEORR)",
   label: "Ostheim vor der Rhön (DEORR)"
  },
  {
   value: "Osthofen (DEOHH)",
   label: "Osthofen (DEOHH)"
  },
  {
   value: "Ostrach (DEOTH)",
   label: "Ostrach (DEOTH)"
  },
  {
   value: "Ostrau (DEOAU)",
   label: "Ostrau (DEOAU)"
  },
  {
   value: "Ostrhauderfehn (DEOHF)",
   label: "Ostrhauderfehn (DEOHF)"
  },
  {
   value: "Oststeinbek (DEOSK)",
   label: "Oststeinbek (DEOSK)"
  },
  {
   value: "Ötisheim (DEOEI)",
   label: "Ötisheim (DEOEI)"
  },
  {
   value: "Ottenbach (DEZDJ)",
   label: "Ottenbach (DEZDJ)"
  },
  {
   value: "Ottenheim (DEOHI)",
   label: "Ottenheim (DEOHI)"
  },
  {
   value: "Ottensoos (DEOOO)",
   label: "Ottensoos (DEOOO)"
  },
  {
   value: "Otterbach (DETBT)",
   label: "Otterbach (DETBT)"
  },
  {
   value: "Otterberg (DEZDK)",
   label: "Otterberg (DEZDK)"
  },
  {
   value: "Otterfing (DEOTF)",
   label: "Otterfing (DEOTF)"
  },
  {
   value: "Ottersberg (DEOSG)",
   label: "Ottersberg (DEOSG)"
  },
  {
   value: "Ottersweier (DEOTW)",
   label: "Ottersweier (DEOTW)"
  },
  {
   value: "Ottweiler (DEOWE)",
   label: "Ottweiler (DEOWE)"
  },
  {
   value: "Otzberg (DEOZG)",
   label: "Otzberg (DEOZG)"
  },
  {
   value: "Otzberg Lengfeld (DEOTL)",
   label: "Otzberg Lengfeld (DEOTL)"
  },
  {
   value: "Ötzingen (DEOTE)",
   label: "Ötzingen (DEOTE)"
  },
  {
   value: "Overath (DEOVR)",
   label: "Overath (DEOVR)"
  },
  {
   value: "Översee (DEOEV)",
   label: "Översee (DEOEV)"
  },
  {
   value: "Owen (DEOWN)",
   label: "Owen (DEOWN)"
  },
  {
   value: "Owingen (DEOWG)",
   label: "Owingen (DEOWG)"
  },
  {
   value: "Pähl (DEPAL)",
   label: "Pähl (DEPAL)"
  },
  {
   value: "Palzem (DECDE)",
   label: "Palzem (DECDE)"
  },
  {
   value: "Panketal (DEPKL)",
   label: "Panketal (DEPKL)"
  },
  {
   value: "Parchim (DEPCH)",
   label: "Parchim (DEPCH)"
  },
  {
   value: "Parey (DEPRY)",
   label: "Parey (DEPRY)"
  },
  {
   value: "Parkentin (DEPTN)",
   label: "Parkentin (DEPTN)"
  },
  {
   value: "Parkstetten (DEPTE)",
   label: "Parkstetten (DEPTE)"
  },
  {
   value: "Parsdorf (DEPDO)",
   label: "Parsdorf (DEPDO)"
  },
  {
   value: "Partenheim (DEPAE)",
   label: "Partenheim (DEPAE)"
  },
  {
   value: "Patersdorf (Regen) (DEPAT)",
   label: "Patersdorf (Regen) (DEPAT)"
  },
  {
   value: "Pausa (DEPUS)",
   label: "Pausa (DEPUS)"
  },
  {
   value: "Pautzfeld (DEPZI)",
   label: "Pautzfeld (DEPZI)"
  },
  {
   value: "Pechbrunn (DEPCN)",
   label: "Pechbrunn (DEPCN)"
  },
  {
   value: "Peiting (DEPTG)",
   label: "Peiting (DEPTG)"
  },
  {
   value: "Peitz (DEXPE)",
   label: "Peitz (DEXPE)"
  },
  {
   value: "Pelm (DEPLM)",
   label: "Pelm (DEPLM)"
  },
  {
   value: "Pensin (DEPNS)",
   label: "Pensin (DEPNS)"
  },
  {
   value: "Penzlin (DEPZN)",
   label: "Penzlin (DEPZN)"
  },
  {
   value: "Perl (DEPRL)",
   label: "Perl (DEPRL)"
  },
  {
   value: "Perleberg (DEPEB)",
   label: "Perleberg (DEPEB)"
  },
  {
   value: "Perlesreut (DEPER)",
   label: "Perlesreut (DEPER)"
  },
  {
   value: "Petersaurach (DEPJI)",
   label: "Petersaurach (DEPJI)"
  },
  {
   value: "Petersberg (DEPRP)",
   label: "Petersberg (DEPRP)"
  },
  {
   value: "Petersbuch (DEZIB)",
   label: "Petersbuch (DEZIB)"
  },
  {
   value: "Petershagen\/Eggersdorf (DEPHE)",
   label: "Petershagen\/Eggersdorf (DEPHE)"
  },
  {
   value: "Petershausen (DEPTH)",
   label: "Petershausen (DEPTH)"
  },
  {
   value: "Peterslahr (DEPLR)",
   label: "Peterslahr (DEPLR)"
  },
  {
   value: "Pettendorf (DEZDS)",
   label: "Pettendorf (DEZDS)"
  },
  {
   value: "Pettstadt (Hasharpberge) (DEPTT)",
   label: "Pettstadt (Hasharpberge) (DEPTT)"
  },
  {
   value: "Pfaffenhausen&nbsp; (DEPFF)",
   label: "Pfaffenhausen&nbsp; (DEPFF)"
  },
  {
   value: "Pfaffenhofen (DEPNH)",
   label: "Pfaffenhofen (DEPNH)"
  },
  {
   value: "Pfaffenhofen an der Glonn (DEPFJ)",
   label: "Pfaffenhofen an der Glonn (DEPFJ)"
  },
  {
   value: "Pfaffen-Schwabenheim (DEPFS)",
   label: "Pfaffen-Schwabenheim (DEPFS)"
  },
  {
   value: "Pfäffing (Altotting) (DEPFG)",
   label: "Pfäffing (Altotting) (DEPFG)"
  },
  {
   value: "Pfaffschwende (DEPAF)",
   label: "Pfaffschwende (DEPAF)"
  },
  {
   value: "Pfalzfeld (DEZED)",
   label: "Pfalzfeld (DEZED)"
  },
  {
   value: "Pfatter (DEPFE)",
   label: "Pfatter (DEPFE)"
  },
  {
   value: "Pfedlbach (DEPFZ)",
   label: "Pfedlbach (DEPFZ)"
  },
  {
   value: "Pfeffenhausen (DEPHS)",
   label: "Pfeffenhausen (DEPHS)"
  },
  {
   value: "Pforzen (DEPZY)",
   label: "Pforzen (DEPZY)"
  },
  {
   value: "Pfreimd (DEPMD)",
   label: "Pfreimd (DEPMD)"
  },
  {
   value: "Pfronten (DEPFR)",
   label: "Pfronten (DEPFR)"
  },
  {
   value: "Pichelsdorf (DEPIH)",
   label: "Pichelsdorf (DEPIH)"
  },
  {
   value: "Picher (DEPIC)",
   label: "Picher (DEPIC)"
  },
  {
   value: "Piesberger (DEPSB)",
   label: "Piesberger (DEPSB)"
  },
  {
   value: "Piesport (DEPPT)",
   label: "Piesport (DEPPT)"
  },
  {
   value: "Piesteritz (DEPSR)",
   label: "Piesteritz (DEPSR)"
  },
  {
   value: "Pinzberg (DEPZG)",
   label: "Pinzberg (DEPZG)"
  },
  {
   value: "Pirk (Neustadt an der Waldnaab) (DEPIK)",
   label: "Pirk (Neustadt an der Waldnaab) (DEPIK)"
  },
  {
   value: "Pissau (DEPSS)",
   label: "Pissau (DEPSS)"
  },
  {
   value: "Platten (DETTP)",
   label: "Platten (DETTP)"
  },
  {
   value: "Pleinfeld (DEPFD)",
   label: "Pleinfeld (DEPFD)"
  },
  {
   value: "Plessa (DEPSA)",
   label: "Plessa (DEPSA)"
  },
  {
   value: "Pliening (DEPIE)",
   label: "Pliening (DEPIE)"
  },
  {
   value: "Pliezhausen (DEPLS)",
   label: "Pliezhausen (DEPLS)"
  },
  {
   value: "Plössberg (DEPLB)",
   label: "Plössberg (DEPLB)"
  },
  {
   value: "Plötzin (DEPLZ)",
   label: "Plötzin (DEPLZ)"
  },
  {
   value: "Plummendorf (DEPLF)",
   label: "Plummendorf (DEPLF)"
  },
  {
   value: "Poesing (DEZPG)",
   label: "Poesing (DEZPG)"
  },
  {
   value: "Poessneck (DEZDR)",
   label: "Poessneck (DEZDR)"
  },
  {
   value: "Pokrent (DEPOK)",
   label: "Pokrent (DEPOK)"
  },
  {
   value: "Polch (DEPQL)",
   label: "Polch (DEPQL)"
  },
  {
   value: "Pollenfeld Wieger (DEPOE)",
   label: "Pollenfeld Wieger (DEPOE)"
  },
  {
   value: "Pollhagen (DEPLL)",
   label: "Pollhagen (DEPLL)"
  },
  {
   value: "Polling, Mühldorf am Inn (DEPON)",
   label: "Polling, Mühldorf am Inn (DEPON)"
  },
  {
   value: "Polling, Weilheim-Schongau (DEPNG)",
   label: "Polling, Weilheim-Schongau (DEPNG)"
  },
  {
   value: "Pölzig (DEPOZ)",
   label: "Pölzig (DEPOZ)"
  },
  {
   value: "Pommelsbrunn (DEPMN)",
   label: "Pommelsbrunn (DEPMN)"
  },
  {
   value: "Pommersfelden (DEPMF)",
   label: "Pommersfelden (DEPMF)"
  },
  {
   value: "Ponitz (DEPNZ)",
   label: "Ponitz (DEPNZ)"
  },
  {
   value: "Poppenhausen (DEPOP)",
   label: "Poppenhausen (DEPOP)"
  },
  {
   value: "Poppenroth (DEPPE)",
   label: "Poppenroth (DEPPE)"
  },
  {
   value: "Porschendorf (DEPSD)",
   label: "Porschendorf (DEPSD)"
  },
  {
   value: "Possendorf (DEPSF)",
   label: "Possendorf (DEPSF)"
  },
  {
   value: "Postmünster (DEPSM)",
   label: "Postmünster (DEPSM)"
  },
  {
   value: "Pottenstein (DEPSN)",
   label: "Pottenstein (DEPSN)"
  },
  {
   value: "Pöttmes (DEPQS)",
   label: "Pöttmes (DEPQS)"
  },
  {
   value: "Pracht (DEPCT)",
   label: "Pracht (DEPCT)"
  },
  {
   value: "Pragsdorf (DEPGD)",
   label: "Pragsdorf (DEPGD)"
  },
  {
   value: "Pratau (DEPTU)",
   label: "Pratau (DEPTU)"
  },
  {
   value: "Prenzlau (Uckermark) (DEBPU)",
   label: "Prenzlau (Uckermark) (DEBPU)"
  },
  {
   value: "Pretzfeld (DEPZD)",
   label: "Pretzfeld (DEPZD)"
  },
  {
   value: "Pretzier (DEPRR)",
   label: "Pretzier (DEPRR)"
  },
  {
   value: "Pretzsch (Elbe) (DEPZT)",
   label: "Pretzsch (Elbe) (DEPZT)"
  },
  {
   value: "Priessnitz (DEPSZ)",
   label: "Priessnitz (DEPSZ)"
  },
  {
   value: "Priestewitz (DEPWZ)",
   label: "Priestewitz (DEPWZ)"
  },
  {
   value: "Prisdorf (DEDEP)",
   label: "Prisdorf (DEDEP)"
  },
  {
   value: "Prittitz (DEPIZ)",
   label: "Prittitz (DEPIZ)"
  },
  {
   value: "Probstzella (DEPBZ)",
   label: "Probstzella (DEPBZ)"
  },
  {
   value: "Pronsfeld (DEPXD)",
   label: "Pronsfeld (DEPXD)"
  },
  {
   value: "Prötzel (DEPZL)",
   label: "Prötzel (DEPZL)"
  },
  {
   value: "Prutting (DEPTI)",
   label: "Prutting (DEPTI)"
  },
  {
   value: "Puchheim (DEPUC)",
   label: "Puchheim (DEPUC)"
  },
  {
   value: "Pühlheim (DEPHL)",
   label: "Pühlheim (DEPHL)"
  },
  {
   value: "Pullach im Isartal (DEPUI)",
   label: "Pullach im Isartal (DEPUI)"
  },
  {
   value: "Pullenreuth (DEPUM)",
   label: "Pullenreuth (DEPUM)"
  },
  {
   value: "Pulsnitz (DEPSI)",
   label: "Pulsnitz (DEPSI)"
  },
  {
   value: "Puschwitz, Bautzen (DEPCZ)",
   label: "Puschwitz, Bautzen (DEPCZ)"
  },
  {
   value: "Püttlingen (DEPLI)",
   label: "Püttlingen (DEPLI)"
  },
  {
   value: "Putzkau (DEPKU)",
   label: "Putzkau (DEPKU)"
  },
  {
   value: "Queis (DEQUS)",
   label: "Queis (DEQUS)"
  },
  {
   value: "Quellendorf (DEQLF)",
   label: "Quellendorf (DEQLF)"
  },
  {
   value: "Querfurt (DEQFU)",
   label: "Querfurt (DEQFU)"
  },
  {
   value: "Quitzdorf am See (DEQAS)",
   label: "Quitzdorf am See (DEQAS)"
  },
  {
   value: "Radbruch (DERBU)",
   label: "Radbruch (DERBU)"
  },
  {
   value: "Raddestorf (DERDD)",
   label: "Raddestorf (DERDD)"
  },
  {
   value: "Radeburg (DERDU)",
   label: "Radeburg (DERDU)"
  },
  {
   value: "Radefeld (DERFE)",
   label: "Radefeld (DERFE)"
  },
  {
   value: "Raesfeld (DEZFD)",
   label: "Raesfeld (DEZFD)"
  },
  {
   value: "Rain am Lech (DERAL)",
   label: "Rain am Lech (DERAL)"
  },
  {
   value: "Raisdorf (DERAF)",
   label: "Raisdorf (DERAF)"
  },
  {
   value: "Raitenbuch (DEEUH)",
   label: "Raitenbuch (DEEUH)"
  },
  {
   value: "Rammingen (DERMM)",
   label: "Rammingen (DERMM)"
  },
  {
   value: "Rampe (DERPE)",
   label: "Rampe (DERPE)"
  },
  {
   value: "Randersacker (DERDK)",
   label: "Randersacker (DERDK)"
  },
  {
   value: "Rangsdorf (DERGF)",
   label: "Rangsdorf (DERGF)"
  },
  {
   value: "Ranstadt (DERAX)",
   label: "Ranstadt (DERAX)"
  },
  {
   value: "Rastenberg (DERSR)",
   label: "Rastenberg (DERSR)"
  },
  {
   value: "Rastow (DERTW)",
   label: "Rastow (DERTW)"
  },
  {
   value: "Ratekau (DERAK)",
   label: "Ratekau (DERAK)"
  },
  {
   value: "Rathmannsdorf (DERMD)",
   label: "Rathmannsdorf (DERMD)"
  },
  {
   value: "Rauenstein (DERNS)",
   label: "Rauenstein (DERNS)"
  },
  {
   value: "Rechenberg-Bienenmühle (DEBIU)",
   label: "Rechenberg-Bienenmühle (DEBIU)"
  },
  {
   value: "Rechlin (DERCI)",
   label: "Rechlin (DERCI)"
  },
  {
   value: "Recke (DERCK)",
   label: "Recke (DERCK)"
  },
  {
   value: "Reckertshausen (DERHA)",
   label: "Reckertshausen (DERHA)"
  },
  {
   value: "Regenstauf (DERST)",
   label: "Regenstauf (DERST)"
  },
  {
   value: "Rehe (DERER)",
   label: "Rehe (DERER)"
  },
  {
   value: "Rehlingen (DERNE)",
   label: "Rehlingen (DERNE)"
  },
  {
   value: "Rehlingen-Siersburg (DERSS)",
   label: "Rehlingen-Siersburg (DERSS)"
  },
  {
   value: "Reichelsheim (DERLM)",
   label: "Reichelsheim (DERLM)"
  },
  {
   value: "Reichenbach an der Fils (DERFI)",
   label: "Reichenbach an der Fils (DERFI)"
  },
  {
   value: "Reichenbach\/Oberlausitz (DERIH)",
   label: "Reichenbach\/Oberlausitz (DERIH)"
  },
  {
   value: "Reichensachsen (DECHC)",
   label: "Reichensachsen (DECHC)"
  },
  {
   value: "Reichenschwand (DERSW)",
   label: "Reichenschwand (DERSW)"
  },
  {
   value: "Reichertshofen (DERZN)",
   label: "Reichertshofen (DERZN)"
  },
  {
   value: "Reilingen (DERII)",
   label: "Reilingen (DERII)"
  },
  {
   value: "Reinau (DERNX)",
   label: "Reinau (DERNX)"
  },
  {
   value: "Reinhardtsdorf-Schöna (DERHS)",
   label: "Reinhardtsdorf-Schöna (DERHS)"
  },
  {
   value: "Reinsdorf (DERRF)",
   label: "Reinsdorf (DERRF)"
  },
  {
   value: "Reinsfeld (DERFL)",
   label: "Reinsfeld (DERFL)"
  },
  {
   value: "Reinstorf (Luneburg) (DERTF)",
   label: "Reinstorf (Luneburg) (DERTF)"
  },
  {
   value: "Reisholz (DERHO)",
   label: "Reisholz (DERHO)"
  },
  {
   value: "Reiskirchen (DERKN)",
   label: "Reiskirchen (DERKN)"
  },
  {
   value: "Rellingen (DEREL)",
   label: "Rellingen (DEREL)"
  },
  {
   value: "Remchingen (DEEMC)",
   label: "Remchingen (DEEMC)"
  },
  {
   value: "Remda-Teichel (DERMT)",
   label: "Remda-Teichel (DERMT)"
  },
  {
   value: "Remseck am Neckar (DERNK)",
   label: "Remseck am Neckar (DERNK)"
  },
  {
   value: "Rendswühren (DERWN)",
   label: "Rendswühren (DERWN)"
  },
  {
   value: "Rennerod (DERND)",
   label: "Rennerod (DERND)"
  },
  {
   value: "Rennertshofen, Neuburg-Schrobenhausen (DERNO)",
   label: "Rennertshofen, Neuburg-Schrobenhausen (DERNO)"
  },
  {
   value: "Reppenstedt (DERPS)",
   label: "Reppenstedt (DERPS)"
  },
  {
   value: "Rethem (DERET)",
   label: "Rethem (DERET)"
  },
  {
   value: "Rettenbach \/ Gunzburg (DERZB)",
   label: "Rettenbach \/ Gunzburg (DERZB)"
  },
  {
   value: "Rettersen (DERTS)",
   label: "Rettersen (DERTS)"
  },
  {
   value: "Reutern, Augsburg (DEREJ)",
   label: "Reutern, Augsburg (DEREJ)"
  },
  {
   value: "Reuterstadt Stavenhagen (DEZRN)",
   label: "Reuterstadt Stavenhagen (DEZRN)"
  },
  {
   value: "Rhede (DEECE)",
   label: "Rhede (DEECE)"
  },
  {
   value: "Rhede (DEYRD)",
   label: "Rhede (DEYRD)"
  },
  {
   value: "Rheinau, Ortenaukreis (DERHI)",
   label: "Rheinau, Ortenaukreis (DERHI)"
  },
  {
   value: "Rheinstetten (DESHT)",
   label: "Rheinstetten (DESHT)"
  },
  {
   value: "Rheinzabern (DEZAZ)",
   label: "Rheinzabern (DEZAZ)"
  },
  {
   value: "Rhumspringe (DERHP)",
   label: "Rhumspringe (DERHP)"
  },
  {
   value: "Ribbeck (DEZEO)",
   label: "Ribbeck (DEZEO)"
  },
  {
   value: "Ribnitz-Damgarten (DERZD)",
   label: "Ribnitz-Damgarten (DERZD)"
  },
  {
   value: "Rickenbach (DERKB)",
   label: "Rickenbach (DERKB)"
  },
  {
   value: "Rieden (Amberg-Sulzbach) (DERDB)",
   label: "Rieden (Amberg-Sulzbach) (DERDB)"
  },
  {
   value: "Rieder (DERIR)",
   label: "Rieder (DERIR)"
  },
  {
   value: "Riedlhütte (DERDL)",
   label: "Riedlhütte (DERDL)"
  },
  {
   value: "Riedstadt (DERDS)",
   label: "Riedstadt (DERDS)"
  },
  {
   value: "Riegel (DERGL)",
   label: "Riegel (DERGL)"
  },
  {
   value: "Riegelsberg (DERGB)",
   label: "Riegelsberg (DERGB)"
  },
  {
   value: "Riekofen (DERKF)",
   label: "Riekofen (DERKF)"
  },
  {
   value: "Rielasingen-Worblingen (DERIA)",
   label: "Rielasingen-Worblingen (DERIA)"
  },
  {
   value: "Riemsloh (DERLH)",
   label: "Riemsloh (DERLH)"
  },
  {
   value: "Rieneck (DERIK)",
   label: "Rieneck (DERIK)"
  },
  {
   value: "Riepe (Aurich) (DEIEP)",
   label: "Riepe (Aurich) (DEIEP)"
  },
  {
   value: "Riepen (DERPN)",
   label: "Riepen (DERPN)"
  },
  {
   value: "Riesenbeck (DERBK)",
   label: "Riesenbeck (DERBK)"
  },
  {
   value: "Rieste (DERSE)",
   label: "Rieste (DERSE)"
  },
  {
   value: "Rietschen (DERIS)",
   label: "Rietschen (DERIS)"
  },
  {
   value: "Rimbach (DERIM)",
   label: "Rimbach (DERIM)"
  },
  {
   value: "Rimsting (DERMS)",
   label: "Rimsting (DERMS)"
  },
  {
   value: "Ringe (DERIX)",
   label: "Ringe (DERIX)"
  },
  {
   value: "Ringsheim (DERGI)",
   label: "Ringsheim (DERGI)"
  },
  {
   value: "Rippershausen (DERIP)",
   label: "Rippershausen (DERIP)"
  },
  {
   value: "Risum-Lindholm (DERSU)",
   label: "Risum-Lindholm (DERSU)"
  },
  {
   value: "Ritschenhausen (DERSH)",
   label: "Ritschenhausen (DERSH)"
  },
  {
   value: "Röbel\/Müritz (DERXB)",
   label: "Röbel\/Müritz (DERXB)"
  },
  {
   value: "Rochlitz (DERHZ)",
   label: "Rochlitz (DERHZ)"
  },
  {
   value: "Rockenberg (DEROC)",
   label: "Rockenberg (DEROC)"
  },
  {
   value: "Rodach (DERDH)",
   label: "Rodach (DERDH)"
  },
  {
   value: "Rodewisch (DEODW)",
   label: "Rodewisch (DEODW)"
  },
  {
   value: "Roding (DERDG)",
   label: "Roding (DERDG)"
  },
  {
   value: "Rödinghausen (DERGU)",
   label: "Rödinghausen (DERGU)"
  },
  {
   value: "Rödinghausen (Markischer Kreis) (DERGS)",
   label: "Rödinghausen (Markischer Kreis) (DERGS)"
  },
  {
   value: "Rodleben (DEZEP)",
   label: "Rodleben (DEZEP)"
  },
  {
   value: "Roetgen (DEOET)",
   label: "Roetgen (DEOET)"
  },
  {
   value: "Röfingen (DEZEA)",
   label: "Röfingen (DEZEA)"
  },
  {
   value: "Rogäsen (DERGA)",
   label: "Rogäsen (DERGA)"
  },
  {
   value: "Rogätz (DERGZ)",
   label: "Rogätz (DERGZ)"
  },
  {
   value: "Roggendorf (DERGD)",
   label: "Roggendorf (DERGD)"
  },
  {
   value: "Rohr (Roth) (DERMF)",
   label: "Rohr (Roth) (DERMF)"
  },
  {
   value: "Rohrbach (DESIR)",
   label: "Rohrbach (DESIR)"
  },
  {
   value: "Rohrdorf (DERHF)",
   label: "Rohrdorf (DERHF)"
  },
  {
   value: "Rohrdorf (Schwarzwald) (DERRC)",
   label: "Rohrdorf (Schwarzwald) (DERRC)"
  },
  {
   value: "Röhrnbach (DERCH)",
   label: "Röhrnbach (DERCH)"
  },
  {
   value: "Röhrnbach (DEZDZ)",
   label: "Röhrnbach (DEZDZ)"
  },
  {
   value: "Roitzsch (DERZS)",
   label: "Roitzsch (DERZS)"
  },
  {
   value: "Ronsberg (DERBE)",
   label: "Ronsberg (DERBE)"
  },
  {
   value: "Rosche (DEZFF)",
   label: "Rosche (DEZFF)"
  },
  {
   value: "Rosdorf (DERZF)",
   label: "Rosdorf (DERZF)"
  },
  {
   value: "Rosenberg (Baden) (DERRB)",
   label: "Rosenberg (Baden) (DERRB)"
  },
  {
   value: "Rosendahl (DEOSD)",
   label: "Rosendahl (DEOSD)"
  },
  {
   value: "Rosenfeld (DERSD)",
   label: "Rosenfeld (DERSD)"
  },
  {
   value: "Rosengarten (DEZES)",
   label: "Rosengarten (DEZES)"
  },
  {
   value: "Rosenhagen (DERHG)",
   label: "Rosenhagen (DERHG)"
  },
  {
   value: "Rositz (DERSZ)",
   label: "Rositz (DERSZ)"
  },
  {
   value: "Roskow (DERKO)",
   label: "Roskow (DERKO)"
  },
  {
   value: "Röslau (DEZFA)",
   label: "Röslau (DEZFA)"
  },
  {
   value: "Rösrath (DERRH)",
   label: "Rösrath (DERRH)"
  },
  {
   value: "Rossbach, Merseburg-Querfurt (DERAC)",
   label: "Rossbach, Merseburg-Querfurt (DERAC)"
  },
  {
   value: "Rosshaupten (DERSP)",
   label: "Rosshaupten (DERSP)"
  },
  {
   value: "Rossla (DERSL)",
   label: "Rossla (DERSL)"
  },
  {
   value: "Rosslau (DERLU)",
   label: "Rosslau (DERLU)"
  },
  {
   value: "Rot an der Rot (DERDT)",
   label: "Rot an der Rot (DERDT)"
  },
  {
   value: "Rotenburg an der Fulda (DERBF)",
   label: "Rotenburg an der Fulda (DERBF)"
  },
  {
   value: "Roth (DERTX)",
   label: "Roth (DERTX)"
  },
  {
   value: "Rötha (DERZA)",
   label: "Rötha (DERZA)"
  },
  {
   value: "Röthenbach (DEZEY)",
   label: "Röthenbach (DEZEY)"
  },
  {
   value: "Rothenberg (Odenwaldkreis) (DERBD)",
   label: "Rothenberg (Odenwaldkreis) (DERBD)"
  },
  {
   value: "Rothenburg\/Oberlausitz (DERBO)",
   label: "Rothenburg\/Oberlausitz (DERBO)"
  },
  {
   value: "Rothenkirchen (DEXKR)",
   label: "Rothenkirchen (DEXKR)"
  },
  {
   value: "Rothenschirmbach (DERCB)",
   label: "Rothenschirmbach (DERCB)"
  },
  {
   value: "Röthlein (DERTI)",
   label: "Röthlein (DERTI)"
  },
  {
   value: "Rottach-Egern (DERTC)",
   label: "Rottach-Egern (DERTC)"
  },
  {
   value: "Rottenacker (DERTA)",
   label: "Rottenacker (DERTA)"
  },
  {
   value: "Rottenbach, Erlangen-Höchstadt (DEREB)",
   label: "Rottenbach, Erlangen-Höchstadt (DEREB)"
  },
  {
   value: "Rottenbach, Roth (DEROA)",
   label: "Rottenbach, Roth (DEROA)"
  },
  {
   value: "Rottenburg (DERTO)",
   label: "Rottenburg (DERTO)"
  },
  {
   value: "Rottenburg am Neckar (DEZFI)",
   label: "Rottenburg am Neckar (DEZFI)"
  },
  {
   value: "Rottenburg an der Laaber (DERLA)",
   label: "Rottenburg an der Laaber (DERLA)"
  },
  {
   value: "Rottendorf (Wurzburg) (DERTD)",
   label: "Rottendorf (Wurzburg) (DERTD)"
  },
  {
   value: "Rottenegg (Geisenfeld) (DERNG)",
   label: "Rottenegg (Geisenfeld) (DERNG)"
  },
  {
   value: "Rotthalmünster (DERHQ)",
   label: "Rotthalmünster (DERHQ)"
  },
  {
   value: "Röttingen (DERTT)",
   label: "Röttingen (DERTT)"
  },
  {
   value: "Rottleberode (DEROO)",
   label: "Rottleberode (DEROO)"
  },
  {
   value: "Rötz (DERZZ)",
   label: "Rötz (DERZZ)"
  },
  {
   value: "Rövershagen (DERVH)",
   label: "Rövershagen (DERVH)"
  },
  {
   value: "Rowa (DERWA)",
   label: "Rowa (DERWA)"
  },
  {
   value: "Rückholz (DERKH)",
   label: "Rückholz (DERKH)"
  },
  {
   value: "Rüdenau (DEZIG)",
   label: "Rüdenau (DEZIG)"
  },
  {
   value: "Rüdersdorf (DERDO)",
   label: "Rüdersdorf (DERDO)"
  },
  {
   value: "Ruderting (DEZFJ)",
   label: "Ruderting (DEZFJ)"
  },
  {
   value: "Rudisleben (DERSN)",
   label: "Rudisleben (DERSN)"
  },
  {
   value: "Rudolstadt (DERUL)",
   label: "Rudolstadt (DERUL)"
  },
  {
   value: "Rudow (DERDW)",
   label: "Rudow (DERDW)"
  },
  {
   value: "Ruhla (DERUA)",
   label: "Ruhla (DERUA)"
  },
  {
   value: "Ruhstorf an der Rott (DERAR)",
   label: "Ruhstorf an der Rott (DERAR)"
  },
  {
   value: "Rullstorf (DERSO)",
   label: "Rullstorf (DERSO)"
  },
  {
   value: "Runding (DEUDG)",
   label: "Runding (DEUDG)"
  },
  {
   value: "Rünthe (DERNT)",
   label: "Rünthe (DERNT)"
  },
  {
   value: "Ruppach-Goldhausen (DERGO)",
   label: "Ruppach-Goldhausen (DERGO)"
  },
  {
   value: "Ruppertsberg (DERPB)",
   label: "Ruppertsberg (DERPB)"
  },
  {
   value: "Ruppertshofen, Ostalbkreis (DERPP)",
   label: "Ruppertshofen, Ostalbkreis (DERPP)"
  },
  {
   value: "Ruppertsweiler (DERWZ)",
   label: "Ruppertsweiler (DERWZ)"
  },
  {
   value: "Rusbend (DERUB)",
   label: "Rusbend (DERUB)"
  },
  {
   value: "Rüthen (DERUT)",
   label: "Rüthen (DERUT)"
  },
  {
   value: "Saal (DESAX)",
   label: "Saal (DESAX)"
  },
  {
   value: "Saalburg (DESBF)",
   label: "Saalburg (DESBF)"
  },
  {
   value: "Saarwellingen (DESRR)",
   label: "Saarwellingen (DESRR)"
  },
  {
   value: "Sachsen bei Ansbach (DESAC)",
   label: "Sachsen bei Ansbach (DESAC)"
  },
  {
   value: "Sachsenbrunn (DESSU)",
   label: "Sachsenbrunn (DESSU)"
  },
  {
   value: "Saerbeck (DESEK)",
   label: "Saerbeck (DESEK)"
  },
  {
   value: "Saffig (DESAF)",
   label: "Saffig (DESAF)"
  },
  {
   value: "Sahms (DESAM)",
   label: "Sahms (DESAM)"
  },
  {
   value: "Sailach (DESLA)",
   label: "Sailach (DESLA)"
  },
  {
   value: "Sailauf (DESIF)",
   label: "Sailauf (DESIF)"
  },
  {
   value: "Salach (DESLX)",
   label: "Salach (DESLX)"
  },
  {
   value: "Salem (DEKVV)",
   label: "Salem (DEKVV)"
  },
  {
   value: "Salmtal (DELTR)",
   label: "Salmtal (DELTR)"
  },
  {
   value: "Salz (DESAZ)",
   label: "Salz (DESAZ)"
  },
  {
   value: "Salzbergen (DEDZR)",
   label: "Salzbergen (DEDZR)"
  },
  {
   value: "Salzhausen (DESZU)",
   label: "Salzhausen (DESZU)"
  },
  {
   value: "Salzwedel (DESZW)",
   label: "Salzwedel (DESZW)"
  },
  {
   value: "Salzweg (DEZJS)",
   label: "Salzweg (DEZJS)"
  },
  {
   value: "Samtens (DESMT)",
   label: "Samtens (DESMT)"
  },
  {
   value: "Sandersdorf (DESSR)",
   label: "Sandersdorf (DESSR)"
  },
  {
   value: "Sangerhausen (DESHA)",
   label: "Sangerhausen (DESHA)"
  },
  {
   value: "Sankt Augustin (DESKA)",
   label: "Sankt Augustin (DESKA)"
  },
  {
   value: "Sankt Egidien (DEEGI)",
   label: "Sankt Egidien (DEEGI)"
  },
  {
   value: "Sankt Gangloff (DEGNO)",
   label: "Sankt Gangloff (DEGNO)"
  },
  {
   value: "Sankt Georgen (Traunreut) (DEGGC)",
   label: "Sankt Georgen (Traunreut) (DEGGC)"
  },
  {
   value: "Sankt Goarshausen (DESGO)",
   label: "Sankt Goarshausen (DESGO)"
  },
  {
   value: "Sankt Ingbert (DEIBS)",
   label: "Sankt Ingbert (DEIBS)"
  },
  {
   value: "Sankt Johann (Reutlingen) (DETTS)",
   label: "Sankt Johann (Reutlingen) (DETTS)"
  },
  {
   value: "Sankt Leon-Rot (DESNL)",
   label: "Sankt Leon-Rot (DESNL)"
  },
  {
   value: "Sasbach (DESAB)",
   label: "Sasbach (DESAB)"
  },
  {
   value: "Sassenbach (DESAK)",
   label: "Sassenbach (DESAK)"
  },
  {
   value: "Sassenberg (DEZGV)",
   label: "Sassenberg (DEZGV)"
  },
  {
   value: "Sassenburg (DESUG)",
   label: "Sassenburg (DESUG)"
  },
  {
   value: "Sauldorf (DESDC)",
   label: "Sauldorf (DESDC)"
  },
  {
   value: "Sayda (DESYD)",
   label: "Sayda (DESYD)"
  },
  {
   value: "Schaafheim (DESFM)",
   label: "Schaafheim (DESFM)"
  },
  {
   value: "Schafstädt (DESFA)",
   label: "Schafstädt (DESFA)"
  },
  {
   value: "Schalding (DESDI)",
   label: "Schalding (DESDI)"
  },
  {
   value: "Schalkau (DESKU)",
   label: "Schalkau (DESKU)"
  },
  {
   value: "Schallstadt (DESSX)",
   label: "Schallstadt (DESSX)"
  },
  {
   value: "Scharbeutz (DECUT)",
   label: "Scharbeutz (DECUT)"
  },
  {
   value: "Scharenstetten (DEARR)",
   label: "Scharenstetten (DEARR)"
  },
  {
   value: "Scharnebeck (DESRC)",
   label: "Scharnebeck (DESRC)"
  },
  {
   value: "Scheer (DESEQ)",
   label: "Scheer (DESEQ)"
  },
  {
   value: "Scheessel (DESCL)",
   label: "Scheessel (DESCL)"
  },
  {
   value: "Schefflenz (DEZFW)",
   label: "Schefflenz (DEZFW)"
  },
  {
   value: "Scheidegg (DESGG)",
   label: "Scheidegg (DESGG)"
  },
  {
   value: "Scheidt (DESET)",
   label: "Scheidt (DESET)"
  },
  {
   value: "Schelklingen (DESCI)",
   label: "Schelklingen (DESCI)"
  },
  {
   value: "Schelldorf (DESEF)",
   label: "Schelldorf (DESEF)"
  },
  {
   value: "Schellroda (DESCX)",
   label: "Schellroda (DESCX)"
  },
  {
   value: "Schemmerberg (DESMM)",
   label: "Schemmerberg (DESMM)"
  },
  {
   value: "Schenefeld (Pinneberg) (DEDEW)",
   label: "Schenefeld (Pinneberg) (DEDEW)"
  },
  {
   value: "Schernfeld (DECED)",
   label: "Schernfeld (DECED)"
  },
  {
   value: "Schesslitz (DESSZ)",
   label: "Schesslitz (DESSZ)"
  },
  {
   value: "Schierstein (DESES)",
   label: "Schierstein (DESES)"
  },
  {
   value: "Schiffweiler (DESFW)",
   label: "Schiffweiler (DESFW)"
  },
  {
   value: "Schillingsfürst (Ansbach) (DEZCH)",
   label: "Schillingsfürst (Ansbach) (DEZCH)"
  },
  {
   value: "Schiltach (DESIC)",
   label: "Schiltach (DESIC)"
  },
  {
   value: "Schirnding (DESII)",
   label: "Schirnding (DESII)"
  },
  {
   value: "Schkölen (DESNT)",
   label: "Schkölen (DESNT)"
  },
  {
   value: "Schlalach (DEMFS)",
   label: "Schlalach (DEMFS)"
  },
  {
   value: "Schlat (DESHC)",
   label: "Schlat (DESHC)"
  },
  {
   value: "Schlauroth (DESCU)",
   label: "Schlauroth (DESCU)"
  },
  {
   value: "Schleiden (DESCV)",
   label: "Schleiden (DESCV)"
  },
  {
   value: "Schleinitz (DEZSZ)",
   label: "Schleinitz (DEZSZ)"
  },
  {
   value: "Schleiz (DESCZ)",
   label: "Schleiz (DESCZ)"
  },
  {
   value: "Schlema (DESEA)",
   label: "Schlema (DESEA)"
  },
  {
   value: "Schlettau (DESUA)",
   label: "Schlettau (DESUA)"
  },
  {
   value: "Schleusingen (DEZGJ)",
   label: "Schleusingen (DEZGJ)"
  },
  {
   value: "Schliengen (DESLI)",
   label: "Schliengen (DESLI)"
  },
  {
   value: "Schlierbach (DESLR)",
   label: "Schlierbach (DESLR)"
  },
  {
   value: "Schlitz (DESIZ)",
   label: "Schlitz (DESIZ)"
  },
  {
   value: "Schlotheim (DEZSM)",
   label: "Schlotheim (DEZSM)"
  },
  {
   value: "Schluchsee (DESUC)",
   label: "Schluchsee (DESUC)"
  },
  {
   value: "Schlüchtern (DEZGK)",
   label: "Schlüchtern (DEZGK)"
  },
  {
   value: "Schlüsselfeld (DESFD)",
   label: "Schlüsselfeld (DESFD)"
  },
  {
   value: "Schlüsselfeld (DEZFY)",
   label: "Schlüsselfeld (DEZFY)"
  },
  {
   value: "Schmalkalden (DESKL)",
   label: "Schmalkalden (DESKL)"
  },
  {
   value: "Schmedehausen (DEMHA)",
   label: "Schmedehausen (DEMHA)"
  },
  {
   value: "Schmelz (DESEZ)",
   label: "Schmelz (DESEZ)"
  },
  {
   value: "Schmiechen (DEXMN)",
   label: "Schmiechen (DEXMN)"
  },
  {
   value: "Schmiedeberg (DEZBR)",
   label: "Schmiedeberg (DEZBR)"
  },
  {
   value: "Schmiedefeld (DESMF)",
   label: "Schmiedefeld (DESMF)"
  },
  {
   value: "Schmitten (DETTZ)",
   label: "Schmitten (DETTZ)"
  },
  {
   value: "Schmolde (DESMD)",
   label: "Schmolde (DESMD)"
  },
  {
   value: "Schmölln (DECML)",
   label: "Schmölln (DECML)"
  },
  {
   value: "Schnackenburg (DESNR)",
   label: "Schnackenburg (DESNR)"
  },
  {
   value: "Schnaittach (DESBY)",
   label: "Schnaittach (DESBY)"
  },
  {
   value: "Schnaittenbach (DESNA)",
   label: "Schnaittenbach (DESNA)"
  },
  {
   value: "Schneiderkrug (DESDU)",
   label: "Schneiderkrug (DESDU)"
  },
  {
   value: "Schnelldorf (DESDR)",
   label: "Schnelldorf (DESDR)"
  },
  {
   value: "Schoenaich (DEZFS)",
   label: "Schoenaich (DEZFS)"
  },
  {
   value: "Schöllkrippen (DESKR)",
   label: "Schöllkrippen (DESKR)"
  },
  {
   value: "Schömberg (DESCQ)",
   label: "Schömberg (DESCQ)"
  },
  {
   value: "Schömberg (Calw) (DESBE)",
   label: "Schömberg (Calw) (DESBE)"
  },
  {
   value: "Schonach (DESCC)",
   label: "Schonach (DESCC)"
  },
  {
   value: "Schönaich (DESNJ)",
   label: "Schönaich (DESNJ)"
  },
  {
   value: "Schönau im Schwarzwald (DESMS)",
   label: "Schönau im Schwarzwald (DESMS)"
  },
  {
   value: "Schönberg (DEEON)",
   label: "Schönberg (DEEON)"
  },
  {
   value: "Schönbrunn (Hildburghausen) (DECNR)",
   label: "Schönbrunn (Hildburghausen) (DECNR)"
  },
  {
   value: "Schondra (DECHO)",
   label: "Schondra (DECHO)"
  },
  {
   value: "Schönebeck (DEOKE)",
   label: "Schönebeck (DEOKE)"
  },
  {
   value: "Schöneck (DEZGA)",
   label: "Schöneck (DEZGA)"
  },
  {
   value: "Schöneiche (DESNI)",
   label: "Schöneiche (DESNI)"
  },
  {
   value: "Schönenberg (DESKB)",
   label: "Schönenberg (DESKB)"
  },
  {
   value: "Schönewerda (DESEW)",
   label: "Schönewerda (DESEW)"
  },
  {
   value: "Schönfeld (DESFL)",
   label: "Schönfeld (DESFL)"
  },
  {
   value: "Schöngeising (DEZFZ)",
   label: "Schöngeising (DEZFZ)"
  },
  {
   value: "Schönheide (DESOI)",
   label: "Schönheide (DESOI)"
  },
  {
   value: "Schönkirchen (DESHK)",
   label: "Schönkirchen (DESHK)"
  },
  {
   value: "Schöntal (DESAJ)",
   label: "Schöntal (DESAJ)"
  },
  {
   value: "Schonungen (DESHO)",
   label: "Schonungen (DESHO)"
  },
  {
   value: "Schönwalde (Havelland) (DECCW)",
   label: "Schönwalde (Havelland) (DECCW)"
  },
  {
   value: "Schöppenstedt (DESST)",
   label: "Schöppenstedt (DESST)"
  },
  {
   value: "Schöppingen (DEXSP)",
   label: "Schöppingen (DEXSP)"
  },
  {
   value: "Schopsdorf (DESPD)",
   label: "Schopsdorf (DESPD)"
  },
  {
   value: "Schöpstal (DEZGQ)",
   label: "Schöpstal (DEZGQ)"
  },
  {
   value: "Schortens (DESCS)",
   label: "Schortens (DESCS)"
  },
  {
   value: "Schraden (DECDN)",
   label: "Schraden (DECDN)"
  },
  {
   value: "Schrecksbach (DESRB)",
   label: "Schrecksbach (DESRB)"
  },
  {
   value: "Schrozberg (DEZFR)",
   label: "Schrozberg (DEZFR)"
  },
  {
   value: "Schulau (DECHL)",
   label: "Schulau (DECHL)"
  },
  {
   value: "Schülp (Dithmarschen) (DECHU)",
   label: "Schülp (Dithmarschen) (DECHU)"
  },
  {
   value: "Schuttertal (DEUTT)",
   label: "Schuttertal (DEUTT)"
  },
  {
   value: "Schutterwald (DESRW)",
   label: "Schutterwald (DESRW)"
  },
  {
   value: "Schutzbach (DEUTZ)",
   label: "Schutzbach (DEUTZ)"
  },
  {
   value: "Schwaigern (DESWF)",
   label: "Schwaigern (DESWF)"
  },
  {
   value: "Schwalbach (DESBS)",
   label: "Schwalbach (DESBS)"
  },
  {
   value: "Schwallungen (DESWU)",
   label: "Schwallungen (DESWU)"
  },
  {
   value: "Schwanau (DESWJ)",
   label: "Schwanau (DESWJ)"
  },
  {
   value: "Schwanenmühle (DESWM)",
   label: "Schwanenmühle (DESWM)"
  },
  {
   value: "Schwanenmühle (DEZJW)",
   label: "Schwanenmühle (DEZJW)"
  },
  {
   value: "Schwangau (DECGA)",
   label: "Schwangau (DECGA)"
  },
  {
   value: "Schwanheide (DECWH)",
   label: "Schwanheide (DECWH)"
  },
  {
   value: "Schwanstetten (DEZAC)",
   label: "Schwanstetten (DEZAC)"
  },
  {
   value: "Schwarz (DEHHC)",
   label: "Schwarz (DEHHC)"
  },
  {
   value: "Schwarzadler (DESZA)",
   label: "Schwarzadler (DESZA)"
  },
  {
   value: "Schwarze Pumpe (DEZFQ)",
   label: "Schwarze Pumpe (DEZFQ)"
  },
  {
   value: "Schwarzenbach (DESCP)",
   label: "Schwarzenbach (DESCP)"
  },
  {
   value: "Schwarzenbach am Wald (DESZD)",
   label: "Schwarzenbach am Wald (DESZD)"
  },
  {
   value: "Schwarzenbek (DEZFK)",
   label: "Schwarzenbek (DEZFK)"
  },
  {
   value: "Schwarzenberg (DESHZ)",
   label: "Schwarzenberg (DESHZ)"
  },
  {
   value: "Schwarzenbruck (DESWZ)",
   label: "Schwarzenbruck (DESWZ)"
  },
  {
   value: "Schwarzenhasel (DESHU)",
   label: "Schwarzenhasel (DESHU)"
  },
  {
   value: "Schwarzheide (DESZI)",
   label: "Schwarzheide (DESZI)"
  },
  {
   value: "Schwebheim (DEBYS)",
   label: "Schwebheim (DEBYS)"
  },
  {
   value: "Schwegenheim (DESGM)",
   label: "Schwegenheim (DESGM)"
  },
  {
   value: "Schweina (DECWA)",
   label: "Schweina (DECWA)"
  },
  {
   value: "Schweinrich (DESWC)",
   label: "Schweinrich (DESWC)"
  },
  {
   value: "Schweitenkirchen (DEWKC)",
   label: "Schweitenkirchen (DEWKC)"
  },
  {
   value: "Schwepnitz (DESPZ)",
   label: "Schwepnitz (DESPZ)"
  },
  {
   value: "Schweppenhausen (DESPP)",
   label: "Schweppenhausen (DESPP)"
  },
  {
   value: "Schwerstedt (DEZFO)",
   label: "Schwerstedt (DEZFO)"
  },
  {
   value: "Schwielowsee (DEIEW)",
   label: "Schwielowsee (DEIEW)"
  },
  {
   value: "Seck (DESEC)",
   label: "Seck (DESEC)"
  },
  {
   value: "Seckach (DESKC)",
   label: "Seckach (DESKC)"
  },
  {
   value: "Seckenhausen (DESKK)",
   label: "Seckenhausen (DESKK)"
  },
  {
   value: "Seddiner See (DESDS)",
   label: "Seddiner See (DESDS)"
  },
  {
   value: "Seebach (DEEAC)",
   label: "Seebach (DEEAC)"
  },
  {
   value: "Seebach (DESBQ)",
   label: "Seebach (DESBQ)"
  },
  {
   value: "Seeburg (DEEUG)",
   label: "Seeburg (DEEUG)"
  },
  {
   value: "Seelbach (DESXE)",
   label: "Seelbach (DESXE)"
  },
  {
   value: "Seelingstädt (DESGT)",
   label: "Seelingstädt (DESGT)"
  },
  {
   value: "Seelow (DESLW)",
   label: "Seelow (DESLW)"
  },
  {
   value: "Seifhennersdorf (DEYSF)",
   label: "Seifhennersdorf (DEYSF)"
  },
  {
   value: "Selb (DESEB)",
   label: "Selb (DESEB)"
  },
  {
   value: "Selbitz (DESIO)",
   label: "Selbitz (DESIO)"
  },
  {
   value: "Selfkant (DESKT)",
   label: "Selfkant (DESKT)"
  },
  {
   value: "Seligenstadt (DESLT)",
   label: "Seligenstadt (DESLT)"
  },
  {
   value: "Selmsdorf (DEEMD)",
   label: "Selmsdorf (DEEMD)"
  },
  {
   value: "Selters, Taunus (DEELE)",
   label: "Selters, Taunus (DEELE)"
  },
  {
   value: "Senden (DEDEE)",
   label: "Senden (DEDEE)"
  },
  {
   value: "Senftenberg (DESFT)",
   label: "Senftenberg (DESFT)"
  },
  {
   value: "Sengenthal (DESGB)",
   label: "Sengenthal (DESGB)"
  },
  {
   value: "Senheim (DEEHM)",
   label: "Senheim (DEEHM)"
  },
  {
   value: "Sennelager (DESNG)",
   label: "Sennelager (DESNG)"
  },
  {
   value: "Sennfeld (DEZFX)",
   label: "Sennfeld (DEZFX)"
  },
  {
   value: "Sereetz (DESZT)",
   label: "Sereetz (DESZT)"
  },
  {
   value: "Serrig (DESRA)",
   label: "Serrig (DESRA)"
  },
  {
   value: "Sessenhausen (DESS2)",
   label: "Sessenhausen (DESS2)"
  },
  {
   value: "Sewekow (DESWO)",
   label: "Sewekow (DESWO)"
  },
  {
   value: "Siebeldingen (DESGI)",
   label: "Siebeldingen (DESGI)"
  },
  {
   value: "Siebenbach (DESBB)",
   label: "Siebenbach (DESBB)"
  },
  {
   value: "Siebenlehn (DEXSB)",
   label: "Siebenlehn (DEXSB)"
  },
  {
   value: "Siegelsbach (DESGL)",
   label: "Siegelsbach (DESGL)"
  },
  {
   value: "Siegertsbrunn (DESIE)",
   label: "Siegertsbrunn (DESIE)"
  },
  {
   value: "Sietow (DESEO)",
   label: "Sietow (DESEO)"
  },
  {
   value: "Sietzsch (DESZC)",
   label: "Sietzsch (DESZC)"
  },
  {
   value: "Sigmaringendorf (DEXIG)",
   label: "Sigmaringendorf (DEXIG)"
  },
  {
   value: "Simbach (DEZGM)",
   label: "Simbach (DEZGM)"
  },
  {
   value: "Simbach am Inn (DESIB)",
   label: "Simbach am Inn (DESIB)"
  },
  {
   value: "Simmozheim (DESZM)",
   label: "Simmozheim (DESZM)"
  },
  {
   value: "Simonswald (DESSW)",
   label: "Simonswald (DESSW)"
  },
  {
   value: "Singhofen (DESGH)",
   label: "Singhofen (DESGH)"
  },
  {
   value: "Sinn (DESNX)",
   label: "Sinn (DESNX)"
  },
  {
   value: "Sinspelt (DESPT)",
   label: "Sinspelt (DESPT)"
  },
  {
   value: "Sinzheim (DESZZ)",
   label: "Sinzheim (DESZZ)"
  },
  {
   value: "Sittensen (DESIT)",
   label: "Sittensen (DESIT)"
  },
  {
   value: "Soderstorf (DESSO)",
   label: "Soderstorf (DESSO)"
  },
  {
   value: "Sohland an der Spree (DESOP)",
   label: "Sohland an der Spree (DESOP)"
  },
  {
   value: "Sollerup (DESLP)",
   label: "Sollerup (DESLP)"
  },
  {
   value: "Söllichau (DESXY)",
   label: "Söllichau (DESXY)"
  },
  {
   value: "Soltendieck (DESDK)",
   label: "Soltendieck (DESDK)"
  },
  {
   value: "Sommerach (DESMR)",
   label: "Sommerach (DESMR)"
  },
  {
   value: "Sömmerda (DESOM)",
   label: "Sömmerda (DESOM)"
  },
  {
   value: "Sommershausen (DEMME)",
   label: "Sommershausen (DEMME)"
  },
  {
   value: "Sondershausen (DESDH)",
   label: "Sondershausen (DESDH)"
  },
  {
   value: "Sonnefeld (DENND)",
   label: "Sonnefeld (DENND)"
  },
  {
   value: "Sonnewalde (DESED)",
   label: "Sonnewalde (DESED)"
  },
  {
   value: "Sontra (DESOA)",
   label: "Sontra (DESOA)"
  },
  {
   value: "Sörgenloch (DESGP)",
   label: "Sörgenloch (DESGP)"
  },
  {
   value: "Sornzig (DESNZ)",
   label: "Sornzig (DESNZ)"
  },
  {
   value: "Sörup (DESOR)",
   label: "Sörup (DESOR)"
  },
  {
   value: "Söstrop (DESEP)",
   label: "Söstrop (DESEP)"
  },
  {
   value: "Soyen (DESOY)",
   label: "Soyen (DESOY)"
  },
  {
   value: "Spaden (DESPN)",
   label: "Spaden (DESPN)"
  },
  {
   value: "Spalt (DESPL)",
   label: "Spalt (DESPL)"
  },
  {
   value: "Spangenberg (DEPPG)",
   label: "Spangenberg (DEPPG)"
  },
  {
   value: "Spay (DESPY)",
   label: "Spay (DESPY)"
  },
  {
   value: "Spergau (DEGGU)",
   label: "Spergau (DEGGU)"
  },
  {
   value: "Spiegelberg (DEZDQ)",
   label: "Spiegelberg (DEZDQ)"
  },
  {
   value: "Spiesen-Elversberg (DESPV)",
   label: "Spiesen-Elversberg (DESPV)"
  },
  {
   value: "Spornitz (DESOZ)",
   label: "Spornitz (DESOZ)"
  },
  {
   value: "Spraitbach (DESIP)",
   label: "Spraitbach (DESIP)"
  },
  {
   value: "Sprakensehl (DESPK)",
   label: "Sprakensehl (DESPK)"
  },
  {
   value: "Spreenhagen (DESPH)",
   label: "Spreenhagen (DESPH)"
  },
  {
   value: "Spreewitz (DESPW)",
   label: "Spreewitz (DESPW)"
  },
  {
   value: "Sprockhövel (DEZGC)",
   label: "Sprockhövel (DEZGC)"
  },
  {
   value: "Spyck (DEPYK)",
   label: "Spyck (DEPYK)"
  },
  {
   value: "St Blasien (DESBL)",
   label: "St Blasien (DESBL)"
  },
  {
   value: "Stäbelow (DESBW)",
   label: "Stäbelow (DESBW)"
  },
  {
   value: "Stadelhofen (DESAO)",
   label: "Stadelhofen (DESAO)"
  },
  {
   value: "Stadtilm (DESAI)",
   label: "Stadtilm (DESAI)"
  },
  {
   value: "Stadtlengsfeld (DESGC)",
   label: "Stadtlengsfeld (DESGC)"
  },
  {
   value: "Stadtoldendorf (DESOO)",
   label: "Stadtoldendorf (DESOO)"
  },
  {
   value: "Stadtprozelten (DESJN)",
   label: "Stadtprozelten (DESJN)"
  },
  {
   value: "Stadtsteinach (DEDTS)",
   label: "Stadtsteinach (DEDTS)"
  },
  {
   value: "Stahlhofen (DESHH)",
   label: "Stahlhofen (DESHH)"
  },
  {
   value: "Stahnsdorf (DEZGP)",
   label: "Stahnsdorf (DEZGP)"
  },
  {
   value: "Stammbach (DESBC)",
   label: "Stammbach (DESBC)"
  },
  {
   value: "Stapelfeld (DETAP)",
   label: "Stapelfeld (DETAP)"
  },
  {
   value: "Starkenberg (DESKG)",
   label: "Starkenberg (DESKG)"
  },
  {
   value: "Starsiedel (DESSD)",
   label: "Starsiedel (DESSD)"
  },
  {
   value: "Staud (DEZRT)",
   label: "Staud (DEZRT)"
  },
  {
   value: "Staufenberg (DESFB)",
   label: "Staufenberg (DESFB)"
  },
  {
   value: "Staufenberg (DESUB)",
   label: "Staufenberg (DESUB)"
  },
  {
   value: "Steffenberg (DESFG)",
   label: "Steffenberg (DESFG)"
  },
  {
   value: "Steffenshagen (DESFH)",
   label: "Steffenshagen (DESFH)"
  },
  {
   value: "Steglitz (DESGZ)",
   label: "Steglitz (DESGZ)"
  },
  {
   value: "Stein an der Traun (DEZGW)",
   label: "Stein an der Traun (DEZGW)"
  },
  {
   value: "Stein bei Nürnberg, Fürth\/Mittelfranken (DESFU)",
   label: "Stein bei Nürnberg, Fürth\/Mittelfranken (DESFU)"
  },
  {
   value: "Steinach (DESID)",
   label: "Steinach (DESID)"
  },
  {
   value: "Steinach (Ortenaukreis) (DESNO)",
   label: "Steinach (Ortenaukreis) (DESNO)"
  },
  {
   value: "Steinalben (DESIA)",
   label: "Steinalben (DESIA)"
  },
  {
   value: "Steinbach am Wald (DESAW)",
   label: "Steinbach am Wald (DESAW)"
  },
  {
   value: "Steinberg (DESNB)",
   label: "Steinberg (DESNB)"
  },
  {
   value: "Steinberg (DESRS)",
   label: "Steinberg (DESRS)"
  },
  {
   value: "Steindorf (DESDX)",
   label: "Steindorf (DESDX)"
  },
  {
   value: "Steinefrenz (DESFZ)",
   label: "Steinefrenz (DESFZ)"
  },
  {
   value: "Steinfeld (DESQD)",
   label: "Steinfeld (DESQD)"
  },
  {
   value: "Steinmauern (DESIU)",
   label: "Steinmauern (DESIU)"
  },
  {
   value: "Steinsberg (DESBX)",
   label: "Steinsberg (DESBX)"
  },
  {
   value: "Steinsfeld (DESSF)",
   label: "Steinsfeld (DESSF)"
  },
  {
   value: "Steinweiler (DESTW)",
   label: "Steinweiler (DESTW)"
  },
  {
   value: "Steinwenden (DESNW)",
   label: "Steinwenden (DESNW)"
  },
  {
   value: "Steinwiesen (DESWS)",
   label: "Steinwiesen (DESWS)"
  },
  {
   value: "Stendal (DESTQ)",
   label: "Stendal (DESTQ)"
  },
  {
   value: "Stephanskirchen (DESKN)",
   label: "Stephanskirchen (DESKN)"
  },
  {
   value: "Sternberg (DEQSB)",
   label: "Sternberg (DEQSB)"
  },
  {
   value: "Stetten (DEZHB)",
   label: "Stetten (DEZHB)"
  },
  {
   value: "Stimpfach (DESMP)",
   label: "Stimpfach (DESMP)"
  },
  {
   value: "Stockhausen-Illfurth (DESRP)",
   label: "Stockhausen-Illfurth (DESRP)"
  },
  {
   value: "Stockheim (DESKE)",
   label: "Stockheim (DESKE)"
  },
  {
   value: "Stockheim (DESKM)",
   label: "Stockheim (DESKM)"
  },
  {
   value: "Stockstadt am Main (DESYS)",
   label: "Stockstadt am Main (DESYS)"
  },
  {
   value: "Stollberg (DESOB)",
   label: "Stollberg (DESOB)"
  },
  {
   value: "Stollhofen (DESOC)",
   label: "Stollhofen (DESOC)"
  },
  {
   value: "Strackholt (DESRK)",
   label: "Strackholt (DESRK)"
  },
  {
   value: "Stralendorf (DESRD)",
   label: "Stralendorf (DESRD)"
  },
  {
   value: "Strassberg (DESQB)",
   label: "Strassberg (DESQB)"
  },
  {
   value: "Strassenhaus (DESNS)",
   label: "Strassenhaus (DESNS)"
  },
  {
   value: "Strassgräbchen (DESGR)",
   label: "Strassgräbchen (DESGR)"
  },
  {
   value: "Strasskirchen (DESKI)",
   label: "Strasskirchen (DESKI)"
  },
  {
   value: "Straussberg (DETSB)",
   label: "Straussberg (DETSB)"
  },
  {
   value: "Streckewalde (DEKWL)",
   label: "Streckewalde (DEKWL)"
  },
  {
   value: "Strehla (DESTX)",
   label: "Strehla (DESTX)"
  },
  {
   value: "Strehla\/Elbe (DETLB)",
   label: "Strehla\/Elbe (DETLB)"
  },
  {
   value: "Strückhausen (DEZJX)",
   label: "Strückhausen (DEZJX)"
  },
  {
   value: "Struth (DESUT)",
   label: "Struth (DESUT)"
  },
  {
   value: "Stulln (DEZGI)",
   label: "Stulln (DEZGI)"
  },
  {
   value: "Südergellersen (DEUGS)",
   label: "Südergellersen (DEUGS)"
  },
  {
   value: "Süderlügum (DESUW)",
   label: "Süderlügum (DESUW)"
  },
  {
   value: "Suhlendorf (DESUO)",
   label: "Suhlendorf (DESUO)"
  },
  {
   value: "Sulzbach-Laufen (DESLZ)",
   label: "Sulzbach-Laufen (DESLZ)"
  },
  {
   value: "Sulzdorf, Coburg (DESZF)",
   label: "Sulzdorf, Coburg (DESZF)"
  },
  {
   value: "Sulzfeld (DEUZD)",
   label: "Sulzfeld (DEUZD)"
  },
  {
   value: "Sülzhayn (DEZGY)",
   label: "Sülzhayn (DEZGY)"
  },
  {
   value: "Sulzheim (DESHQ)",
   label: "Sulzheim (DESHQ)"
  },
  {
   value: "Sünching (DESNC)",
   label: "Sünching (DESNC)"
  },
  {
   value: "Sünninghausen (DEXSN)",
   label: "Sünninghausen (DEXSN)"
  },
  {
   value: "Surheim (DESRM)",
   label: "Surheim (DESRM)"
  },
  {
   value: "Süsel (DESUX)",
   label: "Süsel (DESUX)"
  },
  {
   value: "Syke (DESYK)",
   label: "Syke (DESYK)"
  },
  {
   value: "Taben (DETAR)",
   label: "Taben (DETAR)"
  },
  {
   value: "Tambach-Dietharz (DEZHC)",
   label: "Tambach-Dietharz (DEZHC)"
  },
  {
   value: "Tangerhütte (DETGH)",
   label: "Tangerhütte (DETGH)"
  },
  {
   value: "Tangermünde (DEZHJ)",
   label: "Tangermünde (DEZHJ)"
  },
  {
   value: "Tann (DETNB)",
   label: "Tann (DETNB)"
  },
  {
   value: "Tapfheim (DETPF)",
   label: "Tapfheim (DETPF)"
  },
  {
   value: "Tarbek (DETBK)",
   label: "Tarbek (DETBK)"
  },
  {
   value: "Taubenheim (Meisharpen) (DETBM)",
   label: "Taubenheim (Meisharpen) (DETBM)"
  },
  {
   value: "Taufkirchen (DETKN)",
   label: "Taufkirchen (DETKN)"
  },
  {
   value: "Tawern (DETAW)",
   label: "Tawern (DETAW)"
  },
  {
   value: "Tecklenburg (DETKB)",
   label: "Tecklenburg (DETKB)"
  },
  {
   value: "Tegernheim (DEZHQ)",
   label: "Tegernheim (DEZHQ)"
  },
  {
   value: "Teichwolframsdorf (DETWD)",
   label: "Teichwolframsdorf (DETWD)"
  },
  {
   value: "Teising (DEZIO)",
   label: "Teising (DEZIO)"
  },
  {
   value: "Telgte (DETGE)",
   label: "Telgte (DETGE)"
  },
  {
   value: "Teltow (DETLT)",
   label: "Teltow (DETLT)"
  },
  {
   value: "Temmels (DETMM)",
   label: "Temmels (DETMM)"
  },
  {
   value: "Tengen (DETNN)",
   label: "Tengen (DETNN)"
  },
  {
   value: "Tennenbronn (DEZHP)",
   label: "Tennenbronn (DEZHP)"
  },
  {
   value: "Teterow (DETTW)",
   label: "Teterow (DETTW)"
  },
  {
   value: "Teublitz (DETBI)",
   label: "Teublitz (DETBI)"
  },
  {
   value: "Teugn (DETEB)",
   label: "Teugn (DETEB)"
  },
  {
   value: "Teuschnitz (DETSZ)",
   label: "Teuschnitz (DETSZ)"
  },
  {
   value: "Teutschenthal (DETEL)",
   label: "Teutschenthal (DETEL)"
  },
  {
   value: "Thalheim (DETHH)",
   label: "Thalheim (DETHH)"
  },
  {
   value: "Thallwitz (DETWZ)",
   label: "Thallwitz (DETWZ)"
  },
  {
   value: "Thalmässing (DETMG)",
   label: "Thalmässing (DETMG)"
  },
  {
   value: "Thamsbrück (DETBC)",
   label: "Thamsbrück (DETBC)"
  },
  {
   value: "Thannhausen (DEZHS)",
   label: "Thannhausen (DEZHS)"
  },
  {
   value: "Thansau (DETHS)",
   label: "Thansau (DETHS)"
  },
  {
   value: "Thedinghausen (DETHD)",
   label: "Thedinghausen (DETHD)"
  },
  {
   value: "Theley (DETLY)",
   label: "Theley (DETLY)"
  },
  {
   value: "Themar (DETMA)",
   label: "Themar (DETMA)"
  },
  {
   value: "Thermalbad Wiesenbad (DETHW)",
   label: "Thermalbad Wiesenbad (DETHW)"
  },
  {
   value: "Thiendorf (DETHI)",
   label: "Thiendorf (DETHI)"
  },
  {
   value: "Thierhaupten (DETHR)",
   label: "Thierhaupten (DETHR)"
  },
  {
   value: "Thiersheim (DETIM)",
   label: "Thiersheim (DETIM)"
  },
  {
   value: "Tholey (DETOY)",
   label: "Tholey (DETOY)"
  },
  {
   value: "Thomasburg (DETMB)",
   label: "Thomasburg (DETMB)"
  },
  {
   value: "Thörey (DETOR)",
   label: "Thörey (DETOR)"
  },
  {
   value: "Thörnich (DERRT)",
   label: "Thörnich (DERRT)"
  },
  {
   value: "Thune (DETHU)",
   label: "Thune (DETHU)"
  },
  {
   value: "Thüngersheim (DETGM)",
   label: "Thüngersheim (DETGM)"
  },
  {
   value: "Thüringen (DETUI)",
   label: "Thüringen (DETUI)"
  },
  {
   value: "Thurnau (DETYN)",
   label: "Thurnau (DETYN)"
  },
  {
   value: "Thyrnau (DETYM)",
   label: "Thyrnau (DETYM)"
  },
  {
   value: "Thyrow (DETHO)",
   label: "Thyrow (DETHO)"
  },
  {
   value: "Tiefenbach (Bei Landshut) (DETBL)",
   label: "Tiefenbach (Bei Landshut) (DETBL)"
  },
  {
   value: "Tiefenbach (Sachsen) (DETBS)",
   label: "Tiefenbach (Sachsen) (DETBS)"
  },
  {
   value: "Tiefenort (DETFO)",
   label: "Tiefenort (DETFO)"
  },
  {
   value: "Tiessau (DETSU)",
   label: "Tiessau (DETSU)"
  },
  {
   value: "Tirschenreuth (DETIR)",
   label: "Tirschenreuth (DETIR)"
  },
  {
   value: "Tittling (DETIG)",
   label: "Tittling (DETIG)"
  },
  {
   value: "Toddin (DETDN)",
   label: "Toddin (DETDN)"
  },
  {
   value: "Todtenweis (DETES)",
   label: "Todtenweis (DETES)"
  },
  {
   value: "Todtmoos (DETMO)",
   label: "Todtmoos (DETMO)"
  },
  {
   value: "Toepchin (DETCH)",
   label: "Toepchin (DETCH)"
  },
  {
   value: "Töging am Inn (DETNG)",
   label: "Töging am Inn (DETNG)"
  },
  {
   value: "Tollwitz (DETLW)",
   label: "Tollwitz (DETLW)"
  },
  {
   value: "Topchin (DETPU)",
   label: "Topchin (DETPU)"
  },
  {
   value: "Töpen (DETPN)",
   label: "Töpen (DETPN)"
  },
  {
   value: "Torfplatz Oldenburg (DETOL)",
   label: "Torfplatz Oldenburg (DETOL)"
  },
  {
   value: "Tornesch (DETNH)",
   label: "Tornesch (DETNH)"
  },
  {
   value: "Tostedt (DETST)",
   label: "Tostedt (DETST)"
  },
  {
   value: "Tosterglope (DETGP)",
   label: "Tosterglope (DETGP)"
  },
  {
   value: "Train (DETTN)",
   label: "Train (DETTN)"
  },
  {
   value: "Traisen (DETRX)",
   label: "Traisen (DETRX)"
  },
  {
   value: "Trappenkamp (DEZAQ)",
   label: "Trappenkamp (DEZAQ)"
  },
  {
   value: "Trebbin (DETBN)",
   label: "Trebbin (DETBN)"
  },
  {
   value: "Trebendorf (DETDM)",
   label: "Trebendorf (DETDM)"
  },
  {
   value: "Trechtingshausen (DETRH)",
   label: "Trechtingshausen (DETRH)"
  },
  {
   value: "Treffurt (DETFT)",
   label: "Treffurt (DETFT)"
  },
  {
   value: "Treis-Karden (DETKD)",
   label: "Treis-Karden (DETKD)"
  },
  {
   value: "Treuen (DETEE)",
   label: "Treuen (DETEE)"
  },
  {
   value: "Treuenbrietzen (DETBZ)",
   label: "Treuenbrietzen (DETBZ)"
  },
  {
   value: "Tribsees (DEZHV)",
   label: "Tribsees (DEZHV)"
  },
  {
   value: "Triefenstein (DETFS)",
   label: "Triefenstein (DETFS)"
  },
  {
   value: "Trierweiler (DETWR)",
   label: "Trierweiler (DETWR)"
  },
  {
   value: "Trippstadt (DETRL)",
   label: "Trippstadt (DETRL)"
  },
  {
   value: "Trittenheim (DETHE)",
   label: "Trittenheim (DETHE)"
  },
  {
   value: "Trochtelfingen (DETRF)",
   label: "Trochtelfingen (DETRF)"
  },
  {
   value: "Trochtelfingen (Bopfingen) (DETRC)",
   label: "Trochtelfingen (Bopfingen) (DETRC)"
  },
  {
   value: "Tröglitz (DETGZ)",
   label: "Tröglitz (DETGZ)"
  },
  {
   value: "Trollenhagen (DETLZ)",
   label: "Trollenhagen (DETLZ)"
  },
  {
   value: "Truchtlaching (DETCL)",
   label: "Truchtlaching (DETCL)"
  },
  {
   value: "Trusetal (DETTL)",
   label: "Trusetal (DETTL)"
  },
  {
   value: "Tschirn (DETSC)",
   label: "Tschirn (DETSC)"
  },
  {
   value: "Tuningen (DETUN)",
   label: "Tuningen (DETUN)"
  },
  {
   value: "Tuntenhausen (DETTH)",
   label: "Tuntenhausen (DETTH)"
  },
  {
   value: "Türkenfeld (DETKF)",
   label: "Türkenfeld (DETKF)"
  },
  {
   value: "Twistetal (DETWT)",
   label: "Twistetal (DETWT)"
  },
  {
   value: "Twistringen (DETWX)",
   label: "Twistringen (DETWX)"
  },
  {
   value: "Übach-Palenberg (DEBPA)",
   label: "Übach-Palenberg (DEBPA)"
  },
  {
   value: "Übersee (DEUBR)",
   label: "Übersee (DEUBR)"
  },
  {
   value: "Uchtspringe (DEUSP)",
   label: "Uchtspringe (DEUSP)"
  },
  {
   value: "Uehlfeld (DEBYE)",
   label: "Uehlfeld (DEBYE)"
  },
  {
   value: "Uentrop (DEUEO)",
   label: "Uentrop (DEUEO)"
  },
  {
   value: "Uesen (DEUES)",
   label: "Uesen (DEUES)"
  },
  {
   value: "Uetze (DEZHX)",
   label: "Uetze (DEZHX)"
  },
  {
   value: "Uffing (DEUAS)",
   label: "Uffing (DEUAS)"
  },
  {
   value: "Ulmen (DEUMN)",
   label: "Ulmen (DEUMN)"
  },
  {
   value: "Ulrichstein (DEUCN)",
   label: "Ulrichstein (DEUCN)"
  },
  {
   value: "Ülsen (DEULN)",
   label: "Ülsen (DEULN)"
  },
  {
   value: "Umkirch (DEUKH)",
   label: "Umkirch (DEUKH)"
  },
  {
   value: "Ummendorf (DEUMM)",
   label: "Ummendorf (DEUMM)"
  },
  {
   value: "Ummerstadt (DEUST)",
   label: "Ummerstadt (DEUST)"
  },
  {
   value: "Umpferstedt (DEUFT)",
   label: "Umpferstedt (DEUFT)"
  },
  {
   value: "Undenheim (DEUNM)",
   label: "Undenheim (DEUNM)"
  },
  {
   value: "Ungerhausen (DEURN)",
   label: "Ungerhausen (DEURN)"
  },
  {
   value: "Unkel (DEUKX)",
   label: "Unkel (DEUKX)"
  },
  {
   value: "Unnau (DEUNA)",
   label: "Unnau (DEUNA)"
  },
  {
   value: "Unter Abtsteinach (DEAIN)",
   label: "Unter Abtsteinach (DEAIN)"
  },
  {
   value: "Unterahrain (DEUAN)",
   label: "Unterahrain (DEUAN)"
  },
  {
   value: "Unterbernbach (DEXUE)",
   label: "Unterbernbach (DEXUE)"
  },
  {
   value: "Unterbreizbach (DEUBB)",
   label: "Unterbreizbach (DEUBB)"
  },
  {
   value: "Unterdolling (DEZIA)",
   label: "Unterdolling (DEZIA)"
  },
  {
   value: "Untergroningen (DEUGO)",
   label: "Untergroningen (DEUGO)"
  },
  {
   value: "Unterhaching (DEUHA)",
   label: "Unterhaching (DEUHA)"
  },
  {
   value: "Unterkaka (DEUKA)",
   label: "Unterkaka (DEUKA)"
  },
  {
   value: "Unterkirnach (DEUNE)",
   label: "Unterkirnach (DEUNE)"
  },
  {
   value: "Unterlüss (DEUTS)",
   label: "Unterlüss (DEUTS)"
  },
  {
   value: "Untermarchtal (DEZID)",
   label: "Untermarchtal (DEZID)"
  },
  {
   value: "Untermerzbach (DEZRZ)",
   label: "Untermerzbach (DEZRZ)"
  },
  {
   value: "Untermünkheim (DEUMH)",
   label: "Untermünkheim (DEUMH)"
  },
  {
   value: "Unterneukirchen (DEUUN)",
   label: "Unterneukirchen (DEUUN)"
  },
  {
   value: "Unterschneidheim (DEUSH)",
   label: "Unterschneidheim (DEUSH)"
  },
  {
   value: "Unterthingau (DEUHG)",
   label: "Unterthingau (DEUHG)"
  },
  {
   value: "Unterwattenbach (DEUWB)",
   label: "Unterwattenbach (DEUWB)"
  },
  {
   value: "Uplengen (DEUPL)",
   label: "Uplengen (DEUPL)"
  },
  {
   value: "Urbach (DEURB)",
   label: "Urbach (DEURB)"
  },
  {
   value: "Urmitz (DEGUZ)",
   label: "Urmitz (DEGUZ)"
  },
  {
   value: "Uslar (DEUSA)",
   label: "Uslar (DEUSA)"
  },
  {
   value: "Uttenweiler (DEUTW)",
   label: "Uttenweiler (DEUTW)"
  },
  {
   value: "Utzenfeld (DEUZF)",
   label: "Utzenfeld (DEUZF)"
  },
  {
   value: "Üxheim (DEUHM)",
   label: "Üxheim (DEUHM)"
  },
  {
   value: "Vadenrod (DEVDR)",
   label: "Vadenrod (DEVDR)"
  },
  {
   value: "Valluhn (DEVLL)",
   label: "Valluhn (DEVLL)"
  },
  {
   value: "Vastorf (DEVTO)",
   label: "Vastorf (DEVTO)"
  },
  {
   value: "Vaterstetten (DEVTR)",
   label: "Vaterstetten (DEVTR)"
  },
  {
   value: "Vehlitz (DEVLZ)",
   label: "Vehlitz (DEVLZ)"
  },
  {
   value: "Veilsdorf (DEVSO)",
   label: "Veilsdorf (DEVSO)"
  },
  {
   value: "Veitsbronn (DEVSN)",
   label: "Veitsbronn (DEVSN)"
  },
  {
   value: "Velden (Vils) (DEVLV)",
   label: "Velden (Vils) (DEVLV)"
  },
  {
   value: "Vellberg (DEVLB)",
   label: "Vellberg (DEVLB)"
  },
  {
   value: "Vellmar (DEVLM)",
   label: "Vellmar (DEVLM)"
  },
  {
   value: "Velten (DEVLT)",
   label: "Velten (DEVLT)"
  },
  {
   value: "Venhaus (DEVNA)",
   label: "Venhaus (DEVNA)"
  },
  {
   value: "Venningen (DEVNG)",
   label: "Venningen (DEVNG)"
  },
  {
   value: "Venusberg (DEVBG)",
   label: "Venusberg (DEVBG)"
  },
  {
   value: "Venusberg (DEVEU)",
   label: "Venusberg (DEVEU)"
  },
  {
   value: "Vetschau (DEVEJ)",
   label: "Vetschau (DEVEJ)"
  },
  {
   value: "Vettelschoss (DEVTL)",
   label: "Vettelschoss (DEVTL)"
  },
  {
   value: "Vettweiss (DENWV)",
   label: "Vettweiss (DENWV)"
  },
  {
   value: "Viechtach (DEVIT)",
   label: "Viechtach (DEVIT)"
  },
  {
   value: "Vielitz (DEVTZ)",
   label: "Vielitz (DEVTZ)"
  },
  {
   value: "Vienenburg (DEVIU)",
   label: "Vienenburg (DEVIU)"
  },
  {
   value: "Vierden (DEIRD)",
   label: "Vierden (DEIRD)"
  },
  {
   value: "Vierkirchen (DEVIK)",
   label: "Vierkirchen (DEVIK)"
  },
  {
   value: "Vierow (DEVIW)",
   label: "Vierow (DEVIW)"
  },
  {
   value: "Viewrow (DEVRW)",
   label: "Viewrow (DEVRW)"
  },
  {
   value: "Villingendorf (DEVLG)",
   label: "Villingendorf (DEVLG)"
  },
  {
   value: "Villmar (DEVMR)",
   label: "Villmar (DEVMR)"
  },
  {
   value: "Vilsbiburg (DEVBS)",
   label: "Vilsbiburg (DEVBS)"
  },
  {
   value: "Vilshofen (DEVIH)",
   label: "Vilshofen (DEVIH)"
  },
  {
   value: "Vippachedelhausen (DEVIP)",
   label: "Vippachedelhausen (DEVIP)"
  },
  {
   value: "Vipperow (DEVPP)",
   label: "Vipperow (DEVPP)"
  },
  {
   value: "Visbeck (DEVSK)",
   label: "Visbeck (DEVSK)"
  },
  {
   value: "Visbek (DEVIB)",
   label: "Visbek (DEVIB)"
  },
  {
   value: "Vitte (Hiddensee) (DEVTT)",
   label: "Vitte (Hiddensee) (DEVTT)"
  },
  {
   value: "Vockfey (DEVOC)",
   label: "Vockfey (DEVOC)"
  },
  {
   value: "Vogelsen (DEVGL)",
   label: "Vogelsen (DEVGL)"
  },
  {
   value: "Vogelweh\/Kaiserslautern (DEVGH)",
   label: "Vogelweh\/Kaiserslautern (DEVGH)"
  },
  {
   value: "Vogtsburg im Kaiserstuhl (DEVOG)",
   label: "Vogtsburg im Kaiserstuhl (DEVOG)"
  },
  {
   value: "Vohburg an der Donau (DEVOH)",
   label: "Vohburg an der Donau (DEVOH)"
  },
  {
   value: "Vohenstrauss (DEVSS)",
   label: "Vohenstrauss (DEVSS)"
  },
  {
   value: "Vöhrenbach (DEVRB)",
   label: "Vöhrenbach (DEVRB)"
  },
  {
   value: "Volkach (DEVOL)",
   label: "Volkach (DEVOL)"
  },
  {
   value: "Völkenroth (DEVBL)",
   label: "Völkenroth (DEVBL)"
  },
  {
   value: "Volkmarsen (DEVKN)",
   label: "Volkmarsen (DEVKN)"
  },
  {
   value: "Volkstorf (DEVTF)",
   label: "Volkstorf (DEVTF)"
  },
  {
   value: "Völpke (DEVPK)",
   label: "Völpke (DEVPK)"
  },
  {
   value: "Voltlage (DEVTA)",
   label: "Voltlage (DEVTA)"
  },
  {
   value: "Vorbach (DEVBH)",
   label: "Vorbach (DEVBH)"
  },
  {
   value: "Vrees (DEVRS)",
   label: "Vrees (DEVRS)"
  },
  {
   value: "Waakirchen (DEWAK)",
   label: "Waakirchen (DEWAK)"
  },
  {
   value: "Wabern (DEWAZ)",
   label: "Wabern (DEWAZ)"
  },
  {
   value: "Wachau (DEWAJ)",
   label: "Wachau (DEWAJ)"
  },
  {
   value: "Wachau (DEWCU)",
   label: "Wachau (DEWCU)"
  },
  {
   value: "Wachenroth (DEWRO)",
   label: "Wachenroth (DEWRO)"
  },
  {
   value: "Wachtberg (DEWBA)",
   label: "Wachtberg (DEWBA)"
  },
  {
   value: "Wadgassen (DEAGN)",
   label: "Wadgassen (DEAGN)"
  },
  {
   value: "Wahlwinkel (DEWAW)",
   label: "Wahlwinkel (DEWAW)"
  },
  {
   value: "Wahrstedt (DEWHR)",
   label: "Wahrstedt (DEWHR)"
  },
  {
   value: "Waidhofen (DEWWF)",
   label: "Waidhofen (DEWWF)"
  },
  {
   value: "Waigandshain (DERPW)",
   label: "Waigandshain (DERPW)"
  },
  {
   value: "Wain (DEWYI)",
   label: "Wain (DEWYI)"
  },
  {
   value: "Walbeck (DEWBB)",
   label: "Walbeck (DEWBB)"
  },
  {
   value: "Walchum (DEZJB)",
   label: "Walchum (DEZJB)"
  },
  {
   value: "Wald (DEWQD)",
   label: "Wald (DEWQD)"
  },
  {
   value: "Waldaschaff (DEWSF)",
   label: "Waldaschaff (DEWSF)"
  },
  {
   value: "Waldböckelheim (DEZWM)",
   label: "Waldböckelheim (DEZWM)"
  },
  {
   value: "Waldbronn (DEWBO)",
   label: "Waldbronn (DEWBO)"
  },
  {
   value: "Waldbrunn (DEZIQ)",
   label: "Waldbrunn (DEZIQ)"
  },
  {
   value: "Waldburg (DEWUW)",
   label: "Waldburg (DEWUW)"
  },
  {
   value: "Waldbüttelbrunn (DEWBF)",
   label: "Waldbüttelbrunn (DEWBF)"
  },
  {
   value: "Walddorf (DEAOF)",
   label: "Walddorf (DEAOF)"
  },
  {
   value: "Walddorfhäslach (DEDWO)",
   label: "Walddorfhäslach (DEDWO)"
  },
  {
   value: "Waldenburg (DEWBW)",
   label: "Waldenburg (DEWBW)"
  },
  {
   value: "Waldenburg (DEWDU)",
   label: "Waldenburg (DEWDU)"
  },
  {
   value: "Walderbach (DEAHH)",
   label: "Walderbach (DEAHH)"
  },
  {
   value: "Waldershof (DEWAF)",
   label: "Waldershof (DEWAF)"
  },
  {
   value: "Waldkirch (DEWKR)",
   label: "Waldkirch (DEWKR)"
  },
  {
   value: "Waldkirchen (DEWKX)",
   label: "Waldkirchen (DEWKX)"
  },
  {
   value: "Waldlaubersheim (DEWLU)",
   label: "Waldlaubersheim (DEWLU)"
  },
  {
   value: "Waldmohr (DEWAO)",
   label: "Waldmohr (DEWAO)"
  },
  {
   value: "Waldmünchen (DEZJE)",
   label: "Waldmünchen (DEZJE)"
  },
  {
   value: "Waldstetten (DEWXT)",
   label: "Waldstetten (DEWXT)"
  },
  {
   value: "Walheim (DEWLE)",
   label: "Walheim (DEWLE)"
  },
  {
   value: "Walkertshofen (DEWKH)",
   label: "Walkertshofen (DEWKH)"
  },
  {
   value: "Wallenborn (DEWWX)",
   label: "Wallenborn (DEWWX)"
  },
  {
   value: "Wallenfels (DEWFS)",
   label: "Wallenfels (DEWFS)"
  },
  {
   value: "Wallenhorst (DEWHO)",
   label: "Wallenhorst (DEWHO)"
  },
  {
   value: "Wallerfangen (DEWFG)",
   label: "Wallerfangen (DEWFG)"
  },
  {
   value: "Wallersdorf (DEWEO)",
   label: "Wallersdorf (DEWEO)"
  },
  {
   value: "Wallerstein (DEJAW)",
   label: "Wallerstein (DEJAW)"
  },
  {
   value: "Wallertheim (DEWMZ)",
   label: "Wallertheim (DEWMZ)"
  },
  {
   value: "Wallhausen (DEWHB)",
   label: "Wallhausen (DEWHB)"
  },
  {
   value: "Wallhausen (DEWHW)",
   label: "Wallhausen (DEWHW)"
  },
  {
   value: "Wallhausen (DEXAL)",
   label: "Wallhausen (DEXAL)"
  },
  {
   value: "Wallmenroth (DEWMH)",
   label: "Wallmenroth (DEWMH)"
  },
  {
   value: "Walow (DEWLW)",
   label: "Walow (DEWLW)"
  },
  {
   value: "Walsheim (DEWMS)",
   label: "Walsheim (DEWMS)"
  },
  {
   value: "Waltersdorf (DEWDO)",
   label: "Waltersdorf (DEWDO)"
  },
  {
   value: "Waltershausen (DEWTS)",
   label: "Waltershausen (DEWTS)"
  },
  {
   value: "Walting (DEWLI)",
   label: "Walting (DEWLI)"
  },
  {
   value: "Waltrop (DEWTP)",
   label: "Waltrop (DEWTP)"
  },
  {
   value: "Walzbachtal (DEWZT)",
   label: "Walzbachtal (DEWZT)"
  },
  {
   value: "Wandersleben (DEWNL)",
   label: "Wandersleben (DEWNL)"
  },
  {
   value: "Wangen (DEWAX)",
   label: "Wangen (DEWAX)"
  },
  {
   value: "Wangerland (DEWZG)",
   label: "Wangerland (DEWZG)"
  },
  {
   value: "Wankendorf (DEWKE)",
   label: "Wankendorf (DEWKE)"
  },
  {
   value: "Wanna (DEWAA)",
   label: "Wanna (DEWAA)"
  },
  {
   value: "Wanne-Eickel (DEANE)",
   label: "Wanne-Eickel (DEANE)"
  },
  {
   value: "Wannweil (DEZAM)",
   label: "Wannweil (DEZAM)"
  },
  {
   value: "Wardenburg (DEWBX)",
   label: "Wardenburg (DEWBX)"
  },
  {
   value: "Warmenau (DEWMN)",
   label: "Warmenau (DEWMN)"
  },
  {
   value: "Warmensteinach (DEWMC)",
   label: "Warmensteinach (DEWMC)"
  },
  {
   value: "Warngau (DEZIP)",
   label: "Warngau (DEZIP)"
  },
  {
   value: "Wartenberg (DEWTB)",
   label: "Wartenberg (DEWTB)"
  },
  {
   value: "Warthausen (DEWHX)",
   label: "Warthausen (DEWHX)"
  },
  {
   value: "Wasbek (DEWBK)",
   label: "Wasbek (DEWBK)"
  },
  {
   value: "Wäschenbeuren (DEWCB)",
   label: "Wäschenbeuren (DEWCB)"
  },
  {
   value: "Wassenberg (DEWBE)",
   label: "Wassenberg (DEWBE)"
  },
  {
   value: "Wassmannsdorf (DEWMF)",
   label: "Wassmannsdorf (DEWMF)"
  },
  {
   value: "Wattenscheid (DEDHW)",
   label: "Wattenscheid (DEDHW)"
  },
  {
   value: "Watzerath (DEERA)",
   label: "Watzerath (DEERA)"
  },
  {
   value: "Waxweiler (DEYWX)",
   label: "Waxweiler (DEYWX)"
  },
  {
   value: "Wechselburg (DEWLB)",
   label: "Wechselburg (DEWLB)"
  },
  {
   value: "Weddingstedt (DEWDV)",
   label: "Weddingstedt (DEWDV)"
  },
  {
   value: "Wedlenstedt (DEWNT)",
   label: "Wedlenstedt (DEWNT)"
  },
  {
   value: "Weede (DEWBS)",
   label: "Weede (DEWBS)"
  },
  {
   value: "Weeze (DEWZE)",
   label: "Weeze (DEWZE)"
  },
  {
   value: "Weferlingen (DEWFL)",
   label: "Weferlingen (DEWFL)"
  },
  {
   value: "Wegeleben (DEZWN)",
   label: "Wegeleben (DEZWN)"
  },
  {
   value: "Wegscheid (DEWEC)",
   label: "Wegscheid (DEWEC)"
  },
  {
   value: "Wehr (DEWQR)",
   label: "Wehr (DEWQR)"
  },
  {
   value: "Wehretal (DEWHT)",
   label: "Wehretal (DEWHT)"
  },
  {
   value: "Weichering (DEWIC)",
   label: "Weichering (DEWIC)"
  },
  {
   value: "Weida (DEWYA)",
   label: "Weida (DEWYA)"
  },
  {
   value: "Weidhausen (DEZJR)",
   label: "Weidhausen (DEZJR)"
  },
  {
   value: "Weiding (DEWDG)",
   label: "Weiding (DEWDG)"
  },
  {
   value: "Weigendorf (DEZJA)",
   label: "Weigendorf (DEZJA)"
  },
  {
   value: "Weikersheim (DEWKK)",
   label: "Weikersheim (DEWKK)"
  },
  {
   value: "Weil im Dorf (DEWYD)",
   label: "Weil im Dorf (DEWYD)"
  },
  {
   value: "Weiler bei Bingen (DEWYL)",
   label: "Weiler bei Bingen (DEWYL)"
  },
  {
   value: "Weilerswist (DEWWI)",
   label: "Weilerswist (DEWWI)"
  },
  {
   value: "Weilmünster (DEWMU)",
   label: "Weilmünster (DEWMU)"
  },
  {
   value: "Weiltingen (DEWGI)",
   label: "Weiltingen (DEWGI)"
  },
  {
   value: "Weinbergen (DEIWN)",
   label: "Weinbergen (DEIWN)"
  },
  {
   value: "Weinbohla (DEWOA)",
   label: "Weinbohla (DEWOA)"
  },
  {
   value: "Weinstadt (DEADT)",
   label: "Weinstadt (DEADT)"
  },
  {
   value: "Weira (DEWRA)",
   label: "Weira (DEWRA)"
  },
  {
   value: "Weissenberg (DEZIY)",
   label: "Weissenberg (DEZIY)"
  },
  {
   value: "Weissenborn (DEWIO)",
   label: "Weissenborn (DEWIO)"
  },
  {
   value: "Weissenborn (DEWSO)",
   label: "Weissenborn (DEWSO)"
  },
  {
   value: "Weissenborn\/Erzgeb (DEWSW)",
   label: "Weissenborn\/Erzgeb (DEWSW)"
  },
  {
   value: "Weissenbrunn (DEBYW)",
   label: "Weissenbrunn (DEBYW)"
  },
  {
   value: "Weissenburg in Bayern (DEWNG)",
   label: "Weissenburg in Bayern (DEWNG)"
  },
  {
   value: "Weissenhorn (DEWWW)",
   label: "Weissenhorn (DEWWW)"
  },
  {
   value: "Weissenohe (DEWQE)",
   label: "Weissenohe (DEWQE)"
  },
  {
   value: "Weissensee (DEWSI)",
   label: "Weissensee (DEWSI)"
  },
  {
   value: "Weissenthurm (DEWNU)",
   label: "Weissenthurm (DEWNU)"
  },
  {
   value: "Weisweil (DEWWL)",
   label: "Weisweil (DEWWL)"
  },
  {
   value: "Weitefeld (DEWFX)",
   label: "Weitefeld (DEWFX)"
  },
  {
   value: "Weitendorf (DEZDE)",
   label: "Weitendorf (DEZDE)"
  },
  {
   value: "Weitendorf bei Brüel (DEZIV)",
   label: "Weitendorf bei Brüel (DEZIV)"
  },
  {
   value: "Weitnau (DEITN)",
   label: "Weitnau (DEITN)"
  },
  {
   value: "Weitzgrund (DEWGD)",
   label: "Weitzgrund (DEWGD)"
  },
  {
   value: "Welle (DEWNC)",
   label: "Welle (DEWNC)"
  },
  {
   value: "Wellen (DEWLX)",
   label: "Wellen (DEWLX)"
  },
  {
   value: "Wellendingen (DEWDI)",
   label: "Wellendingen (DEWDI)"
  },
  {
   value: "WEMDING (DEWYN)",
   label: "WEMDING (DEWYN)"
  },
  {
   value: "Wemmetsweiler (DEWMM)",
   label: "Wemmetsweiler (DEWMM)"
  },
  {
   value: "Wendelstein (DEWDN)",
   label: "Wendelstein (DEWDN)"
  },
  {
   value: "Wenden (DEWNE)",
   label: "Wenden (DEWNE)"
  },
  {
   value: "Wendisch Evern (DEWEV)",
   label: "Wendisch Evern (DEWEV)"
  },
  {
   value: "Wenkbach (DEWKB)",
   label: "Wenkbach (DEWKB)"
  },
  {
   value: "Wennigsen (DEWEX)",
   label: "Wennigsen (DEWEX)"
  },
  {
   value: "Wentorf (DEWTO)",
   label: "Wentorf (DEWTO)"
  },
  {
   value: "Wentorf Bei Hamburg (DEWMB)",
   label: "Wentorf Bei Hamburg (DEWMB)"
  },
  {
   value: "Wenzendorf (DEWZF)",
   label: "Wenzendorf (DEWZF)"
  },
  {
   value: "Werbach (DEWCC)",
   label: "Werbach (DEWCC)"
  },
  {
   value: "Werder (DEWEB)",
   label: "Werder (DEWEB)"
  },
  {
   value: "Wernesgrün (DEWRG)",
   label: "Wernesgrün (DEWRG)"
  },
  {
   value: "Werneuchen (DEWEU)",
   label: "Werneuchen (DEWEU)"
  },
  {
   value: "Werneuchen (DEWRC)",
   label: "Werneuchen (DEWRC)"
  },
  {
   value: "Wernfeld (DEWNF)",
   label: "Wernfeld (DEWNF)"
  },
  {
   value: "Wernshausen (DEZIW)",
   label: "Wernshausen (DEZIW)"
  },
  {
   value: "Weroth B Montabaur (DEWRW)",
   label: "Weroth B Montabaur (DEWRW)"
  },
  {
   value: "Werther (DEWXR)",
   label: "Werther (DEWXR)"
  },
  {
   value: "Werther (DEWXW)",
   label: "Werther (DEWXW)"
  },
  {
   value: "Weselberg (DEWGZ)",
   label: "Weselberg (DEWGZ)"
  },
  {
   value: "Wesenberg (DEWSR)",
   label: "Wesenberg (DEWSR)"
  },
  {
   value: "Wessobrunn (DEZJJ)",
   label: "Wessobrunn (DEZJJ)"
  },
  {
   value: "Westergellersen (DEWRL)",
   label: "Westergellersen (DEWRL)"
  },
  {
   value: "Westerheim (DEWSM)",
   label: "Westerheim (DEWSM)"
  },
  {
   value: "Westerhorn (DEWHQ)",
   label: "Westerhorn (DEWHQ)"
  },
  {
   value: "Westhausen (DEWWE)",
   label: "Westhausen (DEWWE)"
  },
  {
   value: "Westheim (DETEI)",
   label: "Westheim (DETEI)"
  },
  {
   value: "Westoverledingen, Gemeinde (DEWOD)",
   label: "Westoverledingen, Gemeinde (DEWOD)"
  },
  {
   value: "Wetro (DERRR)",
   label: "Wetro (DERRR)"
  },
  {
   value: "Wettenberg (DEWBQ)",
   label: "Wettenberg (DEWBQ)"
  },
  {
   value: "Wettringen (DETTR)",
   label: "Wettringen (DETTR)"
  },
  {
   value: "Wettringen (DEZIX)",
   label: "Wettringen (DEZIX)"
  },
  {
   value: "Weyerbusch (DEWUH)",
   label: "Weyerbusch (DEWUH)"
  },
  {
   value: "Weyhe (DEWEY)",
   label: "Weyhe (DEWEY)"
  },
  {
   value: "Wickrath (DEWKZ)",
   label: "Wickrath (DEWKZ)"
  },
  {
   value: "Wiebelsheim (DEWIJ)",
   label: "Wiebelsheim (DEWIJ)"
  },
  {
   value: "Wieden (DEZJC)",
   label: "Wieden (DEZJC)"
  },
  {
   value: "Wiedenzhausen (DEWZA)",
   label: "Wiedenzhausen (DEWZA)"
  },
  {
   value: "Wiefels (DEWXI)",
   label: "Wiefels (DEWXI)"
  },
  {
   value: "Wiefelstede (DEWFD)",
   label: "Wiefelstede (DEWFD)"
  },
  {
   value: "Wiehagen (DEWIA)",
   label: "Wiehagen (DEWIA)"
  },
  {
   value: "Wiershop (DEWSP)",
   label: "Wiershop (DEWSP)"
  },
  {
   value: "Wiesa (DEZJI)",
   label: "Wiesa (DEZJI)"
  },
  {
   value: "Wiesau (DEWEA)",
   label: "Wiesau (DEWEA)"
  },
  {
   value: "Wiesbach (DEWPZ)",
   label: "Wiesbach (DEWPZ)"
  },
  {
   value: "Wiesemscheid (DECHD)",
   label: "Wiesemscheid (DECHD)"
  },
  {
   value: "Wiesensteig (DEWNA)",
   label: "Wiesensteig (DEWNA)"
  },
  {
   value: "Wiesenttal (DEWIP)",
   label: "Wiesenttal (DEWIP)"
  },
  {
   value: "Wieseth (DEWWT)",
   label: "Wieseth (DEWWT)"
  },
  {
   value: "Wiesthal (Unterfr) (DEWFR)",
   label: "Wiesthal (Unterfr) (DEWFR)"
  },
  {
   value: "Wietzen (DETZE)",
   label: "Wietzen (DETZE)"
  },
  {
   value: "Wietzendorf (DEWZU)",
   label: "Wietzendorf (DEWZU)"
  },
  {
   value: "Wiggensbach (DEWGB)",
   label: "Wiggensbach (DEWGB)"
  },
  {
   value: "Wilburgstetten (DEWBT)",
   label: "Wilburgstetten (DEWBT)"
  },
  {
   value: "Wildau (DEWQU)",
   label: "Wildau (DEWQU)"
  },
  {
   value: "Wildau (DEWWU)",
   label: "Wildau (DEWWU)"
  },
  {
   value: "Wilgartswiesen (DEZIU)",
   label: "Wilgartswiesen (DEZIU)"
  },
  {
   value: "Wilhelmshorst (DEWMT)",
   label: "Wilhelmshorst (DEWMT)"
  },
  {
   value: "Willich (DEWLC)",
   label: "Willich (DEWLC)"
  },
  {
   value: "Willroth (DELLT)",
   label: "Willroth (DELLT)"
  },
  {
   value: "Wilsum (DEWUI)",
   label: "Wilsum (DEWUI)"
  },
  {
   value: "Wilthen (DEWTX)",
   label: "Wilthen (DEWTX)"
  },
  {
   value: "Wimsheim (DEWBM)",
   label: "Wimsheim (DEWBM)"
  },
  {
   value: "Windesheim (DEWNS)",
   label: "Windesheim (DEWNS)"
  },
  {
   value: "Windheim (DEWNH)",
   label: "Windheim (DEWNH)"
  },
  {
   value: "Windsbach (DEWWH)",
   label: "Windsbach (DEWWH)"
  },
  {
   value: "Winningen (DEWWG)",
   label: "Winningen (DEWWG)"
  },
  {
   value: "Winnweiler (DEWNI)",
   label: "Winnweiler (DEWNI)"
  },
  {
   value: "Winsen (DEWII)",
   label: "Winsen (DEWII)"
  },
  {
   value: "Winterbach (DEWTC)",
   label: "Winterbach (DEWTC)"
  },
  {
   value: "Wintersdorf (DEWNO)",
   label: "Wintersdorf (DEWNO)"
  },
  {
   value: "Winzer (DEZCZ)",
   label: "Winzer (DEZCZ)"
  },
  {
   value: "Wistedt (DEWSX)",
   label: "Wistedt (DEWSX)"
  },
  {
   value: "Wittenberge (DETNR)",
   label: "Wittenberge (DETNR)"
  },
  {
   value: "Wittenburg (DEWIU)",
   label: "Wittenburg (DEWIU)"
  },
  {
   value: "Witterschlick (DEWTK)",
   label: "Witterschlick (DEWTK)"
  },
  {
   value: "Wittgensdorf (DETGD)",
   label: "Wittgensdorf (DETGD)"
  },
  {
   value: "Wittichenau (DEWTU)",
   label: "Wittichenau (DEWTU)"
  },
  {
   value: "Wittlingen (DEWYG)",
   label: "Wittlingen (DEWYG)"
  },
  {
   value: "Wittorf (DEWRF)",
   label: "Wittorf (DEWRF)"
  },
  {
   value: "Wittschau (DEWSU)",
   label: "Wittschau (DEWSU)"
  },
  {
   value: "Wittstock (DEWSK)",
   label: "Wittstock (DEWSK)"
  },
  {
   value: "Wolfen (DEWFN)",
   label: "Wolfen (DEWFN)"
  },
  {
   value: "Wölfersheim (DEWFM)",
   label: "Wölfersheim (DEWFM)"
  },
  {
   value: "Wölfersheim (DEZEX)",
   label: "Wölfersheim (DEZEX)"
  },
  {
   value: "Wolfertschwenden (DEWFT)",
   label: "Wolfertschwenden (DEWFT)"
  },
  {
   value: "Wolfhagen (DEWFH)",
   label: "Wolfhagen (DEWFH)"
  },
  {
   value: "Wolframs-Eschenbach (DEWWV)",
   label: "Wolframs-Eschenbach (DEWWV)"
  },
  {
   value: "Wolfschlugen (DEWOU)",
   label: "Wolfschlugen (DEWOU)"
  },
  {
   value: "Wolkenstein (DEOLK)",
   label: "Wolkenstein (DEOLK)"
  },
  {
   value: "Wöllstadt (DEWLS)",
   label: "Wöllstadt (DEWLS)"
  },
  {
   value: "Wöllstein (DEWOS)",
   label: "Wöllstein (DEWOS)"
  },
  {
   value: "Wolmirsleben (DEWOO)",
   label: "Wolmirsleben (DEWOO)"
  },
  {
   value: "Wolsfeld (DEWOK)",
   label: "Wolsfeld (DEWOK)"
  },
  {
   value: "Woltersdorf (DEWTF)",
   label: "Woltersdorf (DEWTF)"
  },
  {
   value: "Wonsheim (DEWHZ)",
   label: "Wonsheim (DEWHZ)"
  },
  {
   value: "Workerszell (DEZJH)",
   label: "Workerszell (DEZJH)"
  },
  {
   value: "Worringen (DEWOG)",
   label: "Worringen (DEWOG)"
  },
  {
   value: "Wört (DEWOT)",
   label: "Wört (DEWOT)"
  },
  {
   value: "Wörth an der Donau (DEWTA)",
   label: "Wörth an der Donau (DEWTA)"
  },
  {
   value: "Wörth bei Erding (DEWOI)",
   label: "Wörth bei Erding (DEWOI)"
  },
  {
   value: "Wörthsee (DEWBY)",
   label: "Wörthsee (DEWBY)"
  },
  {
   value: "Wremen (DEWRY)",
   label: "Wremen (DEWRY)"
  },
  {
   value: "Wrist (DEWRI)",
   label: "Wrist (DEWRI)"
  },
  {
   value: "Wümbach (DEZJK)",
   label: "Wümbach (DEZJK)"
  },
  {
   value: "Wunschendorf (DEWXY)",
   label: "Wunschendorf (DEWXY)"
  },
  {
   value: "Wurmannsquick (DEWRK)",
   label: "Wurmannsquick (DEWRK)"
  },
  {
   value: "Wurmberg (DEWMG)",
   label: "Wurmberg (DEWMG)"
  },
  {
   value: "Wurmlingen (DEZJF)",
   label: "Wurmlingen (DEZJF)"
  },
  {
   value: "Wurmsham (DEWUM)",
   label: "Wurmsham (DEWUM)"
  },
  {
   value: "Wüschheim (DEZIM)",
   label: "Wüschheim (DEZIM)"
  },
  {
   value: "Wüstenbrand (DEWBR)",
   label: "Wüstenbrand (DEWBR)"
  },
  {
   value: "Wüstenrot (DEWUT)",
   label: "Wüstenrot (DEWUT)"
  },
  {
   value: "Wustermark (DEWUK)",
   label: "Wustermark (DEWUK)"
  },
  {
   value: "Wusterwitz (DEWUZ)",
   label: "Wusterwitz (DEWUZ)"
  },
  {
   value: "Wüsting (DEUWT)",
   label: "Wüsting (DEUWT)"
  },
  {
   value: "Wutha (DEWUA)",
   label: "Wutha (DEWUA)"
  },
  {
   value: "Wutha-Farnroda (DEWFA)",
   label: "Wutha-Farnroda (DEWFA)"
  },
  {
   value: "Wutoeschingen (DEZJL)",
   label: "Wutoeschingen (DEZJL)"
  },
  {
   value: "Zaberfeld (DEZAB)",
   label: "Zaberfeld (DEZAB)"
  },
  {
   value: "Zachow (DEZSA)",
   label: "Zachow (DEZSA)"
  },
  {
   value: "Zahna (DEZHA)",
   label: "Zahna (DEZHA)"
  },
  {
   value: "Zaisertshofen (DEZAI)",
   label: "Zaisertshofen (DEZAI)"
  },
  {
   value: "Zandt, Ansbach (DEZDT)",
   label: "Zandt, Ansbach (DEZDT)"
  },
  {
   value: "Zapfendorf (DEZJQ)",
   label: "Zapfendorf (DEZJQ)"
  },
  {
   value: "Zarrentin (DEZAR)",
   label: "Zarrentin (DEZAR)"
  },
  {
   value: "Zauchwitz (DEZCW)",
   label: "Zauchwitz (DEZCW)"
  },
  {
   value: "Zeesen (DEZSE)",
   label: "Zeesen (DEZSE)"
  },
  {
   value: "Zehdenick (DEZHD)",
   label: "Zehdenick (DEZHD)"
  },
  {
   value: "Zehlendorf (DEZLE)",
   label: "Zehlendorf (DEZLE)"
  },
  {
   value: "Zeilarn (DEZIL)",
   label: "Zeilarn (DEZIL)"
  },
  {
   value: "Zeiskam (DEZSK)",
   label: "Zeiskam (DEZSK)"
  },
  {
   value: "Zeithain (DEZTN)",
   label: "Zeithain (DEZTN)"
  },
  {
   value: "Zeitz (DEZEZ)",
   label: "Zeitz (DEZEZ)"
  },
  {
   value: "Zella Mehlis (DEZGZ)",
   label: "Zella Mehlis (DEZGZ)"
  },
  {
   value: "Zella-Mehlis (DEZEM)",
   label: "Zella-Mehlis (DEZEM)"
  },
  {
   value: "Zerbst (DEZBT)",
   label: "Zerbst (DEZBT)"
  },
  {
   value: "Zernien (DEZNN)",
   label: "Zernien (DEZNN)"
  },
  {
   value: "Zeuthen (DEZTH)",
   label: "Zeuthen (DEZTH)"
  },
  {
   value: "Ziegelroda (DEZGO)",
   label: "Ziegelroda (DEZGO)"
  },
  {
   value: "Ziesar (DEZSR)",
   label: "Ziesar (DEZSR)"
  },
  {
   value: "Zimmern ob Rottweil (DEZMR)",
   label: "Zimmern ob Rottweil (DEZMR)"
  },
  {
   value: "Zingst (DEZIS)",
   label: "Zingst (DEZIS)"
  },
  {
   value: "Zinnowitz (DEZIN)",
   label: "Zinnowitz (DEZIN)"
  },
  {
   value: "Zolling (DEZOG)",
   label: "Zolling (DEZOG)"
  },
  {
   value: "Zöllnitz (DEZNZ)",
   label: "Zöllnitz (DEZNZ)"
  },
  {
   value: "Zorbau (DEZBU)",
   label: "Zorbau (DEZBU)"
  },
  {
   value: "Zörbig (DEZBI)",
   label: "Zörbig (DEZBI)"
  },
  {
   value: "Zorge (DEZOR)",
   label: "Zorge (DEZOR)"
  },
  {
   value: "Zorneding (DEZRD)",
   label: "Zorneding (DEZRD)"
  },
  {
   value: "Zöschen (DEZSH)",
   label: "Zöschen (DEZSH)"
  },
  {
   value: "Zossen (DEZOS)",
   label: "Zossen (DEZOS)"
  },
  {
   value: "Zschopau (DEZSP)",
   label: "Zschopau (DEZSP)"
  },
  {
   value: "Zschornewitz (DEZSC)",
   label: "Zschornewitz (DEZSC)"
  },
  {
   value: "Zusmarshausen (DEZUS)",
   label: "Zusmarshausen (DEZUS)"
  },
  {
   value: "Zützen (DEZTZ)",
   label: "Zützen (DEZTZ)"
  },
  {
   value: "Zuzenhausen (DEZZH)",
   label: "Zuzenhausen (DEZZH)"
  },
  {
   value: "Zwenkau (DEZWK)",
   label: "Zwenkau (DEZWK)"
  },
  {
   value: "Zwiefalten (DEAWI)",
   label: "Zwiefalten (DEAWI)"
  },
  {
   value: "Zwochau (DEZWO)",
   label: "Zwochau (DEZWO)"
  },
  {
   value: "Zwönitz (DEZWZ)",
   label: "Zwönitz (DEZWZ)"
  },
  {
   value: ".DJIBOUTI (DJ)",
   label: ".DJIBOUTI (DJ)"
  },
  {
   value: "Ali Sabieh (DJAII)",
   label: "Ali Sabieh (DJAII)"
  },
  {
   value: "Camp Lemonier (DJCLA)",
   label: "Camp Lemonier (DJCLA)"
  },
  {
   value: "Doraleh Container Terminal (DJDCT)",
   label: "Doraleh Container Terminal (DJDCT)"
  },
  {
   value: "Obock (DJOBC)",
   label: "Obock (DJOBC)"
  },
  {
   value: "Tadjoura (DJTDJ)",
   label: "Tadjoura (DJTDJ)"
  },
  {
   value: ".DENMARK (DK)",
   label: ".DENMARK (DK)"
  },
  {
   value: "Aalbaek (DKAAF)",
   label: "Aalbaek (DKAAF)"
  },
  {
   value: "Aarre (DKAAE)",
   label: "Aarre (DKAAE)"
  },
  {
   value: "Åbyhøj\/Århus (DKAHJ)",
   label: "Åbyhøj\/Århus (DKAHJ)"
  },
  {
   value: "Agedrup (DKAED)",
   label: "Agedrup (DKAED)"
  },
  {
   value: "Ålebæk (DKABK)",
   label: "Ålebæk (DKABK)"
  },
  {
   value: "Allestrup (DKASP)",
   label: "Allestrup (DKASP)"
  },
  {
   value: "Arden (DKADN)",
   label: "Arden (DKADN)"
  },
  {
   value: "Arre (DKARR)",
   label: "Arre (DKARR)"
  },
  {
   value: "Asaa (DKASA)",
   label: "Asaa (DKASA)"
  },
  {
   value: "Asnæs (DKASS)",
   label: "Asnæs (DKASS)"
  },
  {
   value: "Auning (DKABE)",
   label: "Auning (DKABE)"
  },
  {
   value: "Avedore (DKVRE)",
   label: "Avedore (DKVRE)"
  },
  {
   value: "Avlum (DKAVL)",
   label: "Avlum (DKAVL)"
  },
  {
   value: "Baelum (DKBLU)",
   label: "Baelum (DKBLU)"
  },
  {
   value: "Ballen (DKBAL)",
   label: "Ballen (DKBAL)"
  },
  {
   value: "Barrit (DKAAH)",
   label: "Barrit (DKAAH)"
  },
  {
   value: "Beder (DKBED)",
   label: "Beder (DKBED)"
  },
  {
   value: "Bedsted (DKBDD)",
   label: "Bedsted (DKBDD)"
  },
  {
   value: "Birkerod (DKBIR)",
   label: "Birkerod (DKBIR)"
  },
  {
   value: "Bjaeverskov (DKAAG)",
   label: "Bjaeverskov (DKAAG)"
  },
  {
   value: "Bjert Strand (DKBJE)",
   label: "Bjert Strand (DKBJE)"
  },
  {
   value: "Blavand (DKBLA)",
   label: "Blavand (DKBLA)"
  },
  {
   value: "Blokhus (DKBKH)",
   label: "Blokhus (DKBKH)"
  },
  {
   value: "Blommenslyst (DKBML)",
   label: "Blommenslyst (DKBML)"
  },
  {
   value: "Borkop (DKBKP)",
   label: "Borkop (DKBKP)"
  },
  {
   value: "Bøvlingbjerg (DKBBG)",
   label: "Bøvlingbjerg (DKBBG)"
  },
  {
   value: "Braedstrup (DKBSU)",
   label: "Braedstrup (DKBSU)"
  },
  {
   value: "Branderslev (DKBRL)",
   label: "Branderslev (DKBRL)"
  },
  {
   value: "Branderup (DKBDE)",
   label: "Branderup (DKBDE)"
  },
  {
   value: "Brenderup, Ejby (DKBRU)",
   label: "Brenderup, Ejby (DKBRU)"
  },
  {
   value: "Broby (DKBBY)",
   label: "Broby (DKBBY)"
  },
  {
   value: "Broby Overdrev (DKBOY)",
   label: "Broby Overdrev (DKBOY)"
  },
  {
   value: "Broderup (DKBUP)",
   label: "Broderup (DKBUP)"
  },
  {
   value: "Brønderslev (DKBDV)",
   label: "Brønderslev (DKBDV)"
  },
  {
   value: "Charlottenlund (DKOOT)",
   label: "Charlottenlund (DKOOT)"
  },
  {
   value: "Dalmose (DKDAL)",
   label: "Dalmose (DKDAL)"
  },
  {
   value: "Dianalund (DKDIA)",
   label: "Dianalund (DKDIA)"
  },
  {
   value: "Dronningborg (DKDRO)",
   label: "Dronningborg (DKDRO)"
  },
  {
   value: "Dronninglund (DKDLD)",
   label: "Dronninglund (DKDLD)"
  },
  {
   value: "Ebberup (DKAAJ)",
   label: "Ebberup (DKAAJ)"
  },
  {
   value: "Ebenhausen (DKENH)",
   label: "Ebenhausen (DKENH)"
  },
  {
   value: "Egå (DKEGA)",
   label: "Egå (DKEGA)"
  },
  {
   value: "Egtved (DKEGV)",
   label: "Egtved (DKEGV)"
  },
  {
   value: "Ejstrupholm (DKETH)",
   label: "Ejstrupholm (DKETH)"
  },
  {
   value: "Espergærde (DKESP)",
   label: "Espergærde (DKESP)"
  },
  {
   value: "Fakse (DKAAM)",
   label: "Fakse (DKAAM)"
  },
  {
   value: "Fanoe (DKAAK)",
   label: "Fanoe (DKAAK)"
  },
  {
   value: "Ferritslev (DKFER)",
   label: "Ferritslev (DKFER)"
  },
  {
   value: "Ferritslev (DKFTL)",
   label: "Ferritslev (DKFTL)"
  },
  {
   value: "Fuglebjerg (DKFUG)",
   label: "Fuglebjerg (DKFUG)"
  },
  {
   value: "Gadbjerg (DKGBJ)",
   label: "Gadbjerg (DKGBJ)"
  },
  {
   value: "Gadstrup (DKDGP)",
   label: "Gadstrup (DKDGP)"
  },
  {
   value: "Ganløse (DKGLO)",
   label: "Ganløse (DKGLO)"
  },
  {
   value: "Gedved (DKGDV)",
   label: "Gedved (DKGDV)"
  },
  {
   value: "Gelsted (DKGLD)",
   label: "Gelsted (DKGLD)"
  },
  {
   value: "Gentofte (DKGFE)",
   label: "Gentofte (DKGFE)"
  },
  {
   value: "Gislinge (DKGIS)",
   label: "Gislinge (DKGIS)"
  },
  {
   value: "Gistrup (DKGSP)",
   label: "Gistrup (DKGSP)"
  },
  {
   value: "Gistrup (DKGTR)",
   label: "Gistrup (DKGTR)"
  },
  {
   value: "Glatved Strand (DKGTS)",
   label: "Glatved Strand (DKGTS)"
  },
  {
   value: "Glesborg (DKAAN)",
   label: "Glesborg (DKAAN)"
  },
  {
   value: "Gorlev (DKGLV)",
   label: "Gorlev (DKGLV)"
  },
  {
   value: "Gørløse (DKGRL)",
   label: "Gørløse (DKGRL)"
  },
  {
   value: "Græsted (DKGRS)",
   label: "Græsted (DKGRS)"
  },
  {
   value: "Gram (DKGRM)",
   label: "Gram (DKGRM)"
  },
  {
   value: "Greve (DKGRV)",
   label: "Greve (DKGRV)"
  },
  {
   value: "Grevinge (DKGVE)",
   label: "Grevinge (DKGVE)"
  },
  {
   value: "Grevinge (DKGVS)",
   label: "Grevinge (DKGVS)"
  },
  {
   value: "Grønninghoved (DKGNN)",
   label: "Grønninghoved (DKGNN)"
  },
  {
   value: "H.J.Hansen Hadsund (DKHJH)",
   label: "H.J.Hansen Hadsund (DKHJH)"
  },
  {
   value: "Haderup (DKHDP)",
   label: "Haderup (DKHDP)"
  },
  {
   value: "Hals (DKHAS)",
   label: "Hals (DKHAS)"
  },
  {
   value: "Hammerhavn (DKHHV)",
   label: "Hammerhavn (DKHHV)"
  },
  {
   value: "Hampen (DKHPN)",
   label: "Hampen (DKHPN)"
  },
  {
   value: "Hårlev (DKHAA)",
   label: "Hårlev (DKHAA)"
  },
  {
   value: "Havdrup (DKHAP)",
   label: "Havdrup (DKHAP)"
  },
  {
   value: "Hejls (DKHEJ)",
   label: "Hejls (DKHEJ)"
  },
  {
   value: "Hellebaek (DKHVT)",
   label: "Hellebaek (DKHVT)"
  },
  {
   value: "Helsinge (DKHEL)",
   label: "Helsinge (DKHEL)"
  },
  {
   value: "Herskind (DKHRS)",
   label: "Herskind (DKHRS)"
  },
  {
   value: "Hillerod (DKHIL)",
   label: "Hillerod (DKHIL)"
  },
  {
   value: "Hjallerup (DKHJA)",
   label: "Hjallerup (DKHJA)"
  },
  {
   value: "Hjerm (DKHJM)",
   label: "Hjerm (DKHJM)"
  },
  {
   value: "Hjerting (DKHJT)",
   label: "Hjerting (DKHJT)"
  },
  {
   value: "Hjortshoj (DKJOK)",
   label: "Hjortshoj (DKJOK)"
  },
  {
   value: "Hogelund (DKHGL)",
   label: "Hogelund (DKHGL)"
  },
  {
   value: "Høje Tåstrup (DKHTP)",
   label: "Høje Tåstrup (DKHTP)"
  },
  {
   value: "Holmegård (DKHOM)",
   label: "Holmegård (DKHOM)"
  },
  {
   value: "Holme-Olstrup (DKHOO)",
   label: "Holme-Olstrup (DKHOO)"
  },
  {
   value: "Holte (DKHOE)",
   label: "Holte (DKHOE)"
  },
  {
   value: "Hornbæk (DKHON)",
   label: "Hornbæk (DKHON)"
  },
  {
   value: "Hornslet (DKHNS)",
   label: "Hornslet (DKHNS)"
  },
  {
   value: "Hornsyld (DKHSY)",
   label: "Hornsyld (DKHSY)"
  },
  {
   value: "Hørve (DKHRE)",
   label: "Hørve (DKHRE)"
  },
  {
   value: "Hov (DKHWO)",
   label: "Hov (DKHWO)"
  },
  {
   value: "Hovborg (DKHVB)",
   label: "Hovborg (DKHVB)"
  },
  {
   value: "Høve Strand (DKHSD)",
   label: "Høve Strand (DKHSD)"
  },
  {
   value: "Hovedgård (DKHOV)",
   label: "Hovedgård (DKHOV)"
  },
  {
   value: "Humble (DKHBL)",
   label: "Humble (DKHBL)"
  },
  {
   value: "Humlebæk (DKHBA)",
   label: "Humlebæk (DKHBA)"
  },
  {
   value: "Hunseby (DKHSE)",
   label: "Hunseby (DKHSE)"
  },
  {
   value: "Hurup Thy (DKAAO)",
   label: "Hurup Thy (DKAAO)"
  },
  {
   value: "Hvalsø (DKHVL)",
   label: "Hvalsø (DKHVL)"
  },
  {
   value: "Hvide Sande (DKHVS)",
   label: "Hvide Sande (DKHVS)"
  },
  {
   value: "Hvims (DKHVI)",
   label: "Hvims (DKHVI)"
  },
  {
   value: "Hyllinge (DKHYL)",
   label: "Hyllinge (DKHYL)"
  },
  {
   value: "Jægersborg (DKJAE)",
   label: "Jægersborg (DKJAE)"
  },
  {
   value: "Jægerspris (DKJGP)",
   label: "Jægerspris (DKJGP)"
  },
  {
   value: "Jelling (DKJEL)",
   label: "Jelling (DKJEL)"
  },
  {
   value: "Jyllinge (DKJYL)",
   label: "Jyllinge (DKJYL)"
  },
  {
   value: "Kagerup (DKKAG)",
   label: "Kagerup (DKKAG)"
  },
  {
   value: "Karlslunde (DKKAR)",
   label: "Karlslunde (DKKAR)"
  },
  {
   value: "Kirke Hyllinge (DKABJ)",
   label: "Kirke Hyllinge (DKABJ)"
  },
  {
   value: "Klampenborg (DKKLA)",
   label: "Klampenborg (DKKLA)"
  },
  {
   value: "Kleppen (DKKLP)",
   label: "Kleppen (DKKLP)"
  },
  {
   value: "Knudshoved (DKKHV)",
   label: "Knudshoved (DKKHV)"
  },
  {
   value: "Kolind (DKKLD)",
   label: "Kolind (DKKLD)"
  },
  {
   value: "Kollund Mole (DKKDM)",
   label: "Kollund Mole (DKKDM)"
  },
  {
   value: "Kongsdal Harbour (DKKGL)",
   label: "Kongsdal Harbour (DKKGL)"
  },
  {
   value: "Langå (DKLAN)",
   label: "Langå (DKLAN)"
  },
  {
   value: "Langholt (DKAAU)",
   label: "Langholt (DKAAU)"
  },
  {
   value: "Lejre (DKLEJ)",
   label: "Lejre (DKLEJ)"
  },
  {
   value: "Lem (DKLEM)",
   label: "Lem (DKLEM)"
  },
  {
   value: "Lundeborg (DKLUN)",
   label: "Lundeborg (DKLUN)"
  },
  {
   value: "Lundtofte (DKLDT)",
   label: "Lundtofte (DKLDT)"
  },
  {
   value: "Lystrup (DKAAT)",
   label: "Lystrup (DKAAT)"
  },
  {
   value: "Masnedovaerkets Havn\/Vordingborg (DKMKH)",
   label: "Masnedovaerkets Havn\/Vordingborg (DKMKH)"
  },
  {
   value: "Morud (DKMRD)",
   label: "Morud (DKMRD)"
  },
  {
   value: "Munkebo (DKMNK)",
   label: "Munkebo (DKMNK)"
  },
  {
   value: "Nagbol (DKNGB)",
   label: "Nagbol (DKNGB)"
  },
  {
   value: "Nørager (DKNAG)",
   label: "Nørager (DKNAG)"
  },
  {
   value: "Nørreballe (DKNBE)",
   label: "Nørreballe (DKNBE)"
  },
  {
   value: "Odder (DKODX)",
   label: "Odder (DKODX)"
  },
  {
   value: "Oelgod (DKAAW)",
   label: "Oelgod (DKAAW)"
  },
  {
   value: "Oelsted (DKAAI)",
   label: "Oelsted (DKAAI)"
  },
  {
   value: "Oksbol (DKOSB)",
   label: "Oksbol (DKOSB)"
  },
  {
   value: "Olstykke (DKOYK)",
   label: "Olstykke (DKOYK)"
  },
  {
   value: "Ølstykke (DKOTK)",
   label: "Ølstykke (DKOTK)"
  },
  {
   value: "Olstykke Stationsby (DKOEL)",
   label: "Olstykke Stationsby (DKOEL)"
  },
  {
   value: "Osby (DKOSX)",
   label: "Osby (DKOSX)"
  },
  {
   value: "Øster Assels (DKOAS)",
   label: "Øster Assels (DKOAS)"
  },
  {
   value: "Oure (DKAAV)",
   label: "Oure (DKAAV)"
  },
  {
   value: "Pjedsted (DKPJE)",
   label: "Pjedsted (DKPJE)"
  },
  {
   value: "Præsto (DKPRS)",
   label: "Præsto (DKPRS)"
  },
  {
   value: "Præstoe (DKABI)",
   label: "Præstoe (DKABI)"
  },
  {
   value: "Reersoe (DKAAZ)",
   label: "Reersoe (DKAAZ)"
  },
  {
   value: "Regstrup (DKRGP)",
   label: "Regstrup (DKRGP)"
  },
  {
   value: "Resenbro (DKRSN)",
   label: "Resenbro (DKRSN)"
  },
  {
   value: "Ringkøbing (DKRKG)",
   label: "Ringkøbing (DKRKG)"
  },
  {
   value: "Rødby (DKAAX)",
   label: "Rødby (DKAAX)"
  },
  {
   value: "Rødding (DKRDG)",
   label: "Rødding (DKRDG)"
  },
  {
   value: "Rødovre (DKRDR)",
   label: "Rødovre (DKRDR)"
  },
  {
   value: "Rødovre (DKRDV)",
   label: "Rødovre (DKRDV)"
  },
  {
   value: "Romo (DKRMO)",
   label: "Romo (DKRMO)"
  },
  {
   value: "Rønde (DKRND)",
   label: "Rønde (DKRND)"
  },
  {
   value: "Rønnede (DKRON)",
   label: "Rønnede (DKRON)"
  },
  {
   value: "Ruds-Vedby (DKRVY)",
   label: "Ruds-Vedby (DKRVY)"
  },
  {
   value: "Rungsted (DKRUG)",
   label: "Rungsted (DKRUG)"
  },
  {
   value: "Ry (DKREY)",
   label: "Ry (DKREY)"
  },
  {
   value: "Rynkeby (DKRYN)",
   label: "Rynkeby (DKRYN)"
  },
  {
   value: "Ryslinge (DKRYS)",
   label: "Ryslinge (DKRYS)"
  },
  {
   value: "Sabro (DKSAB)",
   label: "Sabro (DKSAB)"
  },
  {
   value: "Saltum (DKSAL)",
   label: "Saltum (DKSAL)"
  },
  {
   value: "Sindal (DKCNL)",
   label: "Sindal (DKCNL)"
  },
  {
   value: "Skævinge (DKSKE)",
   label: "Skævinge (DKSKE)"
  },
  {
   value: "Skanderborg (DKSKG)",
   label: "Skanderborg (DKSKG)"
  },
  {
   value: "Slimminge (DKSMG)",
   label: "Slimminge (DKSMG)"
  },
  {
   value: "Snedsted (DKSDD)",
   label: "Snedsted (DKSDD)"
  },
  {
   value: "Solrød Strand (DKSOL)",
   label: "Solrød Strand (DKSOL)"
  },
  {
   value: "Sønder Bjert (DKABA)",
   label: "Sønder Bjert (DKABA)"
  },
  {
   value: "Sønder Omme (DKSOM)",
   label: "Sønder Omme (DKSOM)"
  },
  {
   value: "Spjald (DKSPJ)",
   label: "Spjald (DKSPJ)"
  },
  {
   value: "St Kilian (DKKII)",
   label: "St Kilian (DKKII)"
  },
  {
   value: "Stenlille (DKSTL)",
   label: "Stenlille (DKSTL)"
  },
  {
   value: "Stenløse (DKSLE)",
   label: "Stenløse (DKSLE)"
  },
  {
   value: "Stevns Pier (DKSTP)",
   label: "Stevns Pier (DKSTP)"
  },
  {
   value: "Stilling (DKABB)",
   label: "Stilling (DKABB)"
  },
  {
   value: "Stokkemarke (DKSMA)",
   label: "Stokkemarke (DKSMA)"
  },
  {
   value: "Storevorde (DKSTV)",
   label: "Storevorde (DKSTV)"
  },
  {
   value: "Sundby, Mors (DKSNY)",
   label: "Sundby, Mors (DKSNY)"
  },
  {
   value: "Svebølle (DKSVB)",
   label: "Svebølle (DKSVB)"
  },
  {
   value: "Sydals (DKSDA)",
   label: "Sydals (DKSDA)"
  },
  {
   value: "Tappernøje (DKTPN)",
   label: "Tappernøje (DKTPN)"
  },
  {
   value: "Taulov (DKTLV)",
   label: "Taulov (DKTLV)"
  },
  {
   value: "Thorsminde (DKTMD)",
   label: "Thorsminde (DKTMD)"
  },
  {
   value: "Thorso (DKTSO)",
   label: "Thorso (DKTSO)"
  },
  {
   value: "Thyholm (DKTHY)",
   label: "Thyholm (DKTHY)"
  },
  {
   value: "Tilst (DKTIL)",
   label: "Tilst (DKTIL)"
  },
  {
   value: "Tim (DKTIM)",
   label: "Tim (DKTIM)"
  },
  {
   value: "Tistrup (DKTIS)",
   label: "Tistrup (DKTIS)"
  },
  {
   value: "Tisvilde (DKTSV)",
   label: "Tisvilde (DKTSV)"
  },
  {
   value: "Tollose (DKTLL)",
   label: "Tollose (DKTLL)"
  },
  {
   value: "Tølløse (DKTOL)",
   label: "Tølløse (DKTOL)"
  },
  {
   value: "Torup (DKTOR)",
   label: "Torup (DKTOR)"
  },
  {
   value: "Tranekaer (DKTKA)",
   label: "Tranekaer (DKTKA)"
  },
  {
   value: "Trige (DKTRI)",
   label: "Trige (DKTRI)"
  },
  {
   value: "Trustrup (DKTRU)",
   label: "Trustrup (DKTRU)"
  },
  {
   value: "Tureby (DKTUR)",
   label: "Tureby (DKTUR)"
  },
  {
   value: "Ugerløse (DKUGE)",
   label: "Ugerløse (DKUGE)"
  },
  {
   value: "Ulstrup (DKULS)",
   label: "Ulstrup (DKULS)"
  },
  {
   value: "Værløse (DKVLE)",
   label: "Værløse (DKVLE)"
  },
  {
   value: "Vallensbaek (DKVAE)",
   label: "Vallensbaek (DKVAE)"
  },
  {
   value: "Vallensbaek Strand (DKABG)",
   label: "Vallensbaek Strand (DKABG)"
  },
  {
   value: "Vallø (DKVLL)",
   label: "Vallø (DKVLL)"
  },
  {
   value: "Vanløse (DKVAN)",
   label: "Vanløse (DKVAN)"
  },
  {
   value: "Vestbjerg (DKVBJ)",
   label: "Vestbjerg (DKVBJ)"
  },
  {
   value: "Viby J (DKVIY)",
   label: "Viby J (DKVIY)"
  },
  {
   value: "Viby Jylland (DKABH)",
   label: "Viby Jylland (DKABH)"
  },
  {
   value: "Viby\/Sjælland (DKVBI)",
   label: "Viby\/Sjælland (DKVBI)"
  },
  {
   value: "Vildbjerg (DKVLD)",
   label: "Vildbjerg (DKVLD)"
  },
  {
   value: "Vissenbjerg (DKVBG)",
   label: "Vissenbjerg (DKVBG)"
  },
  {
   value: "Vium (DKNVM)",
   label: "Vium (DKNVM)"
  },
  {
   value: "Vorbasse (DKAAS)",
   label: "Vorbasse (DKAAS)"
  },
  {
   value: "Vrå (DKVRA)",
   label: "Vrå (DKVRA)"
  },
  {
   value: ".DOMINICA (DM)",
   label: ".DOMINICA (DM)"
  },
  {
   value: "Belfast (DMBEL)",
   label: "Belfast (DMBEL)"
  },
  {
   value: ".DOMINICAN REPUBLIC (DO)",
   label: ".DOMINICAN REPUBLIC (DO)"
  },
  {
   value: "Azua (DOAZU)",
   label: "Azua (DOAZU)"
  },
  {
   value: "Barcequillo (DOBQL)",
   label: "Barcequillo (DOBQL)"
  },
  {
   value: "Casa de Campo (DOCDC)",
   label: "Casa de Campo (DOCDC)"
  },
  {
   value: "Catalina I. (DOCAI)",
   label: "Catalina I. (DOCAI)"
  },
  {
   value: "Caucedo (DOCAU)",
   label: "Caucedo (DOCAU)"
  },
  {
   value: "Cayo Levantado (DOCAL)",
   label: "Cayo Levantado (DOCAL)"
  },
  {
   value: "Constanza (DOLVC)",
   label: "Constanza (DOLVC)"
  },
  {
   value: "Dajabón (DODAJ)",
   label: "Dajabón (DODAJ)"
  },
  {
   value: "Hainamosa (DOSDD)",
   label: "Hainamosa (DOSDD)"
  },
  {
   value: "Higuey (DOHIG)",
   label: "Higuey (DOHIG)"
  },
  {
   value: "La Vega (DOLAV)",
   label: "La Vega (DOLAV)"
  },
  {
   value: "Los Alcarrizos (DOLAL)",
   label: "Los Alcarrizos (DOLAL)"
  },
  {
   value: "Mao (DOMAO)",
   label: "Mao (DOMAO)"
  },
  {
   value: "Pimentel (DOPIM)",
   label: "Pimentel (DOPIM)"
  },
  {
   value: "Punta Cana Apt (DOPUJ)",
   label: "Punta Cana Apt (DOPUJ)"
  },
  {
   value: "Salcedo (DOSAL)",
   label: "Salcedo (DOSAL)"
  },
  {
   value: "San Fernando de Monte Cristi (DOMCR)",
   label: "San Fernando de Monte Cristi (DOMCR)"
  },
  {
   value: "San Ignacio Sabaneta (DOSIS)",
   label: "San Ignacio Sabaneta (DOSIS)"
  },
  {
   value: "San Juan de la Maguana (DOSJM)",
   label: "San Juan de la Maguana (DOSJM)"
  },
  {
   value: "Santa Bárbara de Samaná (DOSAM)",
   label: "Santa Bárbara de Samaná (DOSAM)"
  },
  {
   value: "Villa Altagracia (DOVAL)",
   label: "Villa Altagracia (DOVAL)"
  },
  {
   value: ".ALGERIA (DZ)",
   label: ".ALGERIA (DZ)"
  },
  {
   value: "Adrar (DZAZR)",
   label: "Adrar (DZAZR)"
  },
  {
   value: "Ain Temouchent (DZTCT)",
   label: "Ain Temouchent (DZTCT)"
  },
  {
   value: "Batna (DZBLJ)",
   label: "Batna (DZBLJ)"
  },
  {
   value: "Bechar (DZCBH)",
   label: "Bechar (DZCBH)"
  },
  {
   value: "Bethoula (DZBTA)",
   label: "Bethoula (DZBTA)"
  },
  {
   value: "Biskra (DZBSK)",
   label: "Biskra (DZBSK)"
  },
  {
   value: "Blida (DZBLD)",
   label: "Blida (DZBLD)"
  },
  {
   value: "Bordj Badj Mokthar (DZBMW)",
   label: "Bordj Badj Mokthar (DZBMW)"
  },
  {
   value: "Bordj Bou Arreridj (DZBOR)",
   label: "Bordj Bou Arreridj (DZBOR)"
  },
  {
   value: "Bordj Menaïel (DZBOM)",
   label: "Bordj Menaïel (DZBOM)"
  },
  {
   value: "Bouinan (DZBNN)",
   label: "Bouinan (DZBNN)"
  },
  {
   value: "Bouinane (DZBIU)",
   label: "Bouinane (DZBIU)"
  },
  {
   value: "Boumerdas (DZBOU)",
   label: "Boumerdas (DZBOU)"
  },
  {
   value: "Cheghoum-el-Aid (DZCEA)",
   label: "Cheghoum-el-Aid (DZCEA)"
  },
  {
   value: "Chiffa (DZCHF)",
   label: "Chiffa (DZCHF)"
  },
  {
   value: "Chlef (DZCLF)",
   label: "Chlef (DZCLF)"
  },
  {
   value: "Djanet (DZDJG)",
   label: "Djanet (DZDJG)"
  },
  {
   value: "Djen-Djen (DZDJE)",
   label: "Djen-Djen (DZDJE)"
  },
  {
   value: "Draa el Mizan (DZDEM)",
   label: "Draa el Mizan (DZDEM)"
  },
  {
   value: "El Golea (DZELG)",
   label: "El Golea (DZELG)"
  },
  {
   value: "El Qued (DZELU)",
   label: "El Qued (DZELU)"
  },
  {
   value: "Ghazaouet (DZGHZ)",
   label: "Ghazaouet (DZGHZ)"
  },
  {
   value: "Hassi Messaoud (DZHME)",
   label: "Hassi Messaoud (DZHME)"
  },
  {
   value: "In Amenas (DZIAM)",
   label: "In Amenas (DZIAM)"
  },
  {
   value: "In Salah (DZINZ)",
   label: "In Salah (DZINZ)"
  },
  {
   value: "I-N-Amenas (DZINA)",
   label: "I-N-Amenas (DZINA)"
  },
  {
   value: "Jijel (DZGJL)",
   label: "Jijel (DZGJL)"
  },
  {
   value: "Khemis Miliana (DZKHM)",
   label: "Khemis Miliana (DZKHM)"
  },
  {
   value: "Kherrata (DZKHE)",
   label: "Kherrata (DZKHE)"
  },
  {
   value: "Kouba (DZKOB)",
   label: "Kouba (DZKOB)"
  },
  {
   value: "Laghouat (DZLOO)",
   label: "Laghouat (DZLOO)"
  },
  {
   value: "Mascara (DZMUW)",
   label: "Mascara (DZMUW)"
  },
  {
   value: "Nedroma (DZNED)",
   label: "Nedroma (DZNED)"
  },
  {
   value: "Ouargla (DZOGX)",
   label: "Ouargla (DZOGX)"
  },
  {
   value: "Rouiba (DZROU)",
   label: "Rouiba (DZROU)"
  },
  {
   value: "Sétif (DZSET)",
   label: "Sétif (DZSET)"
  },
  {
   value: "Sidi Bel Abbes (DZSBA)",
   label: "Sidi Bel Abbes (DZSBA)"
  },
  {
   value: "Taher (DZTAH)",
   label: "Taher (DZTAH)"
  },
  {
   value: "Tamanrasset (DZTMR)",
   label: "Tamanrasset (DZTMR)"
  },
  {
   value: "Tbessa (DZTEE)",
   label: "Tbessa (DZTEE)"
  },
  {
   value: "Tiaret (DZTID)",
   label: "Tiaret (DZTID)"
  },
  {
   value: "Timimoun (DZTMX)",
   label: "Timimoun (DZTMX)"
  },
  {
   value: "Tindouf (DZTIN)",
   label: "Tindouf (DZTIN)"
  },
  {
   value: "Tipaza (DZAZA)",
   label: "Tipaza (DZAZA)"
  },
  {
   value: "Tizi Ouzou (DZTIZ)",
   label: "Tizi Ouzou (DZTIZ)"
  },
  {
   value: "Tlemcen (DZTLM)",
   label: "Tlemcen (DZTLM)"
  },
  {
   value: "Touggourt (DZTGR)",
   label: "Touggourt (DZTGR)"
  },
  {
   value: ".ECUADOR (EC)",
   label: ".ECUADOR (EC)"
  },
  {
   value: "Babahoyo (ECBYO)",
   label: "Babahoyo (ECBYO)"
  },
  {
   value: "Bartolome I. (ECBLI)",
   label: "Bartolome I. (ECBLI)"
  },
  {
   value: "Bucay (ECEQB)",
   label: "Bucay (ECEQB)"
  },
  {
   value: "Chanduy (ECCHA)",
   label: "Chanduy (ECCHA)"
  },
  {
   value: "Chone (ECEQC)",
   label: "Chone (ECEQC)"
  },
  {
   value: "Chongón (ECCHG)",
   label: "Chongón (ECCHG)"
  },
  {
   value: "Coca (ECOCC)",
   label: "Coca (ECOCC)"
  },
  {
   value: "El Carmen (ECELC)",
   label: "El Carmen (ECELC)"
  },
  {
   value: "El Triunfo (ECEQD)",
   label: "El Triunfo (ECEQD)"
  },
  {
   value: "Espanola I. (ECESP)",
   label: "Espanola I. (ECESP)"
  },
  {
   value: "Floreana I. (ECFLO)",
   label: "Floreana I. (ECFLO)"
  },
  {
   value: "Guayaquil (ECGYQ)",
   label: "Guayaquil (ECGYQ)"
  },
  {
   value: "Guayas (ECGUA)",
   label: "Guayas (ECGUA)"
  },
  {
   value: "Isle Baltra (ECWGL)",
   label: "Isle Baltra (ECWGL)"
  },
  {
   value: "Jipijapa (ECJIP)",
   label: "Jipijapa (ECJIP)"
  },
  {
   value: "La Puntilla (ECLPT)",
   label: "La Puntilla (ECLPT)"
  },
  {
   value: "Lago Agrio (ECLGQ)",
   label: "Lago Agrio (ECLGQ)"
  },
  {
   value: "Lasso (ECLAS)",
   label: "Lasso (ECLAS)"
  },
  {
   value: "Latacunga (ECLAT)",
   label: "Latacunga (ECLAT)"
  },
  {
   value: "Machachi (ECMAC)",
   label: "Machachi (ECMAC)"
  },
  {
   value: "Montalvo (ECMTO)",
   label: "Montalvo (ECMTO)"
  },
  {
   value: "Monteverde (ECMTV)",
   label: "Monteverde (ECMTV)"
  },
  {
   value: "Pastaza (ECPTZ)",
   label: "Pastaza (ECPTZ)"
  },
  {
   value: "Pedro Carbo (ECCAR)",
   label: "Pedro Carbo (ECCAR)"
  },
  {
   value: "Posorja (ECPSJ)",
   label: "Posorja (ECPSJ)"
  },
  {
   value: "Pto Egas (ECPEG)",
   label: "Pto Egas (ECPEG)"
  },
  {
   value: "Putumayo (ECPYO)",
   label: "Putumayo (ECPYO)"
  },
  {
   value: "Quevedo (ECQVD)",
   label: "Quevedo (ECQVD)"
  },
  {
   value: "Quinche (ECQUI)",
   label: "Quinche (ECQUI)"
  },
  {
   value: "Quininde (ECEQA)",
   label: "Quininde (ECEQA)"
  },
  {
   value: "Rabida I. (ECRAB)",
   label: "Rabida I. (ECRAB)"
  },
  {
   value: "Riobamba (ECRBA)",
   label: "Riobamba (ECRBA)"
  },
  {
   value: "Santa Cecillia (ECWSE)",
   label: "Santa Cecillia (ECWSE)"
  },
  {
   value: "Santo Domingo de los Colorados (ECSDO)",
   label: "Santo Domingo de los Colorados (ECSDO)"
  },
  {
   value: "Seymour (ECSYM)",
   label: "Seymour (ECSYM)"
  },
  {
   value: "Simón Bolívar (ECSBO)",
   label: "Simón Bolívar (ECSBO)"
  },
  {
   value: "Tarapoa (ECTPC)",
   label: "Tarapoa (ECTPC)"
  },
  {
   value: "Tulcan (ECTUA)",
   label: "Tulcan (ECTUA)"
  },
  {
   value: "Velasco Ibarra (ECVEI)",
   label: "Velasco Ibarra (ECVEI)"
  },
  {
   value: "Zapotal (ECZTL)",
   label: "Zapotal (ECZTL)"
  },
  {
   value: "Zapotal de Colonche (ECZPT)",
   label: "Zapotal de Colonche (ECZPT)"
  },
  {
   value: ".ESTONIA (EE)",
   label: ".ESTONIA (EE)"
  },
  {
   value: "Aasmäe (EEAEB)",
   label: "Aasmäe (EEAEB)"
  },
  {
   value: "Aaviku (EEAAV)",
   label: "Aaviku (EEAAV)"
  },
  {
   value: "Abja-Paluoja (EEAPL)",
   label: "Abja-Paluoja (EEAPL)"
  },
  {
   value: "Ahja (EEAHJ)",
   label: "Ahja (EEAHJ)"
  },
  {
   value: "Alatskivi (EEAEC)",
   label: "Alatskivi (EEAEC)"
  },
  {
   value: "Antsla (EEANT)",
   label: "Antsla (EEANT)"
  },
  {
   value: "Ardu (EEARD)",
   label: "Ardu (EEARD)"
  },
  {
   value: "Aruküla (EEARU)",
   label: "Aruküla (EEARU)"
  },
  {
   value: "Aseri (EEASE)",
   label: "Aseri (EEASE)"
  },
  {
   value: "Audru (EEAUD)",
   label: "Audru (EEAUD)"
  },
  {
   value: "Bekkeri (EEBEK)",
   label: "Bekkeri (EEBEK)"
  },
  {
   value: "Dirhami (EEDIR)",
   label: "Dirhami (EEDIR)"
  },
  {
   value: "Ebavere (EEEBA)",
   label: "Ebavere (EEEBA)"
  },
  {
   value: "Elva (EEELV)",
   label: "Elva (EEELV)"
  },
  {
   value: "Ervu (EEERV)",
   label: "Ervu (EEERV)"
  },
  {
   value: "Haapsalu (EEHAA)",
   label: "Haapsalu (EEHAA)"
  },
  {
   value: "Halinga (EEHLA)",
   label: "Halinga (EEHLA)"
  },
  {
   value: "Haljala (EEHJA)",
   label: "Haljala (EEHJA)"
  },
  {
   value: "Hänike (EEHAK)",
   label: "Hänike (EEHAK)"
  },
  {
   value: "Hanila (EEHAN)",
   label: "Hanila (EEHAN)"
  },
  {
   value: "Heltermaa (EEHLT)",
   label: "Heltermaa (EEHLT)"
  },
  {
   value: "Imavere (EEIMA)",
   label: "Imavere (EEIMA)"
  },
  {
   value: "Jaanikese (EEJAA)",
   label: "Jaanikese (EEJAA)"
  },
  {
   value: "Järva-Jaani (EEJJA)",
   label: "Järva-Jaani (EEJJA)"
  },
  {
   value: "Järvakandi (EEJAR)",
   label: "Järvakandi (EEJAR)"
  },
  {
   value: "Jõesuu (EEJOE)",
   label: "Jõesuu (EEJOE)"
  },
  {
   value: "Jõgeva (EEJGA)",
   label: "Jõgeva (EEJGA)"
  },
  {
   value: "Jõhvi (EEJVI)",
   label: "Jõhvi (EEJVI)"
  },
  {
   value: "Jüri (EEJUR)",
   label: "Jüri (EEJUR)"
  },
  {
   value: "Kaberneeme (EEKAB)",
   label: "Kaberneeme (EEKAB)"
  },
  {
   value: "Kadrina (EEKAD)",
   label: "Kadrina (EEKAD)"
  },
  {
   value: "Kadrina (EEKDA)",
   label: "Kadrina (EEKDA)"
  },
  {
   value: "Käina (EEKIA)",
   label: "Käina (EEKIA)"
  },
  {
   value: "Kallaste (EEKLL)",
   label: "Kallaste (EEKLL)"
  },
  {
   value: "Kalvi (EEKLV)",
   label: "Kalvi (EEKLV)"
  },
  {
   value: "Kanepi (EEKNP)",
   label: "Kanepi (EEKNP)"
  },
  {
   value: "Kavandu (EEKDU)",
   label: "Kavandu (EEKDU)"
  },
  {
   value: "Keeni (EEKEE)",
   label: "Keeni (EEKEE)"
  },
  {
   value: "Kehra (EEKEH)",
   label: "Kehra (EEKEH)"
  },
  {
   value: "Keila (EEKEI)",
   label: "Keila (EEKEI)"
  },
  {
   value: "Kiiu (EEKIU)",
   label: "Kiiu (EEKIU)"
  },
  {
   value: "Koeru (EEKRU)",
   label: "Koeru (EEKRU)"
  },
  {
   value: "Kohila (EEKHA)",
   label: "Kohila (EEKHA)"
  },
  {
   value: "Kohtla-Järve (EEKJE)",
   label: "Kohtla-Järve (EEKJE)"
  },
  {
   value: "Kolga-Jaani (EEKJI)",
   label: "Kolga-Jaani (EEKJI)"
  },
  {
   value: "Komsi (EEKOM)",
   label: "Komsi (EEKOM)"
  },
  {
   value: "Kose (EEKSE)",
   label: "Kose (EEKSE)"
  },
  {
   value: "Kuivastu (EEKUI)",
   label: "Kuivastu (EEKUI)"
  },
  {
   value: "Kulaaseme (EEKUL)",
   label: "Kulaaseme (EEKUL)"
  },
  {
   value: "Kunda (EEKND)",
   label: "Kunda (EEKND)"
  },
  {
   value: "Kurena (EEKEA)",
   label: "Kurena (EEKEA)"
  },
  {
   value: "Kuressaare port (EEKUR)",
   label: "Kuressaare port (EEKUR)"
  },
  {
   value: "Kuusalu (EEKUS)",
   label: "Kuusalu (EEKUS)"
  },
  {
   value: "Kuusalu (EEKUU)",
   label: "Kuusalu (EEKUU)"
  },
  {
   value: "Laagri (EELAA)",
   label: "Laagri (EELAA)"
  },
  {
   value: "Lehtma (EELHT)",
   label: "Lehtma (EELHT)"
  },
  {
   value: "Lihula (EELIH)",
   label: "Lihula (EELIH)"
  },
  {
   value: "Lindi (EELIN)",
   label: "Lindi (EELIN)"
  },
  {
   value: "Lohusalu (EELSL)",
   label: "Lohusalu (EELSL)"
  },
  {
   value: "Lohusuu (EELHU)",
   label: "Lohusuu (EELHU)"
  },
  {
   value: "Loksa (EELSA)",
   label: "Loksa (EELSA)"
  },
  {
   value: "Luhamaa (EELHM)",
   label: "Luhamaa (EELHM)"
  },
  {
   value: "Luunja (EELNJ)",
   label: "Luunja (EELNJ)"
  },
  {
   value: "Maardu (EEMRD)",
   label: "Maardu (EEMRD)"
  },
  {
   value: "Märjamaa (EEMAR)",
   label: "Märjamaa (EEMAR)"
  },
  {
   value: "Meeruse (EEMRS)",
   label: "Meeruse (EEMRS)"
  },
  {
   value: "Miiduranna (EEMDR)",
   label: "Miiduranna (EEMDR)"
  },
  {
   value: "Mõigu (EEMOI)",
   label: "Mõigu (EEMOI)"
  },
  {
   value: "Mõntu (EEMNT)",
   label: "Mõntu (EEMNT)"
  },
  {
   value: "Mundi (EEMDI)",
   label: "Mundi (EEMDI)"
  },
  {
   value: "Mustvee (EEMUS)",
   label: "Mustvee (EEMUS)"
  },
  {
   value: "Muuga (EEMUG)",
   label: "Muuga (EEMUG)"
  },
  {
   value: "Naissaare (EENAI)",
   label: "Naissaare (EENAI)"
  },
  {
   value: "Näpi (EENAP)",
   label: "Näpi (EENAP)"
  },
  {
   value: "Narva (EENAR)",
   label: "Narva (EENAR)"
  },
  {
   value: "Nasva (EENAS)",
   label: "Nasva (EENAS)"
  },
  {
   value: "Niibi (EENII)",
   label: "Niibi (EENII)"
  },
  {
   value: "Õisu (EEOSU)",
   label: "Õisu (EEOSU)"
  },
  {
   value: "Oomiste (EEOOS)",
   label: "Oomiste (EEOOS)"
  },
  {
   value: "Orava (EEORA)",
   label: "Orava (EEORA)"
  },
  {
   value: "Otepää (EEOTP)",
   label: "Otepää (EEOTP)"
  },
  {
   value: "Paekna (EEPAE)",
   label: "Paekna (EEPAE)"
  },
  {
   value: "Paide (EEPAI)",
   label: "Paide (EEPAI)"
  },
  {
   value: "Paikuse (EEPKS)",
   label: "Paikuse (EEPKS)"
  },
  {
   value: "Paldiski Lõunasadam (EEPLS)",
   label: "Paldiski Lõunasadam (EEPLS)"
  },
  {
   value: "Paldiski Põhjasadam (EEPLN)",
   label: "Paldiski Põhjasadam (EEPLN)"
  },
  {
   value: "Palivere (EEPVE)",
   label: "Palivere (EEPVE)"
  },
  {
   value: "Paljassaare (EEPAS)",
   label: "Paljassaare (EEPAS)"
  },
  {
   value: "Pangodi (EEPNG)",
   label: "Pangodi (EEPNG)"
  },
  {
   value: "Parksepa (EEAEF)",
   label: "Parksepa (EEAEF)"
  },
  {
   value: "Pärnu (EEPRN)",
   label: "Pärnu (EEPRN)"
  },
  {
   value: "Peetri (EEPEE)",
   label: "Peetri (EEPEE)"
  },
  {
   value: "Pikasilla (EEPSA)",
   label: "Pikasilla (EEPSA)"
  },
  {
   value: "Pirita (EEPIR)",
   label: "Pirita (EEPIR)"
  },
  {
   value: "Põdra (EEAEE)",
   label: "Põdra (EEAEE)"
  },
  {
   value: "Polli (EEPOL)",
   label: "Polli (EEPOL)"
  },
  {
   value: "Põltsamaa (EEPLT)",
   label: "Põltsamaa (EEPLT)"
  },
  {
   value: "Põlva (EEPOV)",
   label: "Põlva (EEPOV)"
  },
  {
   value: "Püssi (EEAEI)",
   label: "Püssi (EEAEI)"
  },
  {
   value: "Raasiku (EERAA)",
   label: "Raasiku (EERAA)"
  },
  {
   value: "Rakvere (EERAK)",
   label: "Rakvere (EERAK)"
  },
  {
   value: "Ramsi (EERAM)",
   label: "Ramsi (EERAM)"
  },
  {
   value: "Räpina (EERPA)",
   label: "Räpina (EERPA)"
  },
  {
   value: "Rapla (EEAEG)",
   label: "Rapla (EEAEG)"
  },
  {
   value: "Reola (EEREO)",
   label: "Reola (EEREO)"
  },
  {
   value: "Reopalu (EERPL)",
   label: "Reopalu (EERPL)"
  },
  {
   value: "Ridala (EERID)",
   label: "Ridala (EERID)"
  },
  {
   value: "Rohuküla (EERHK)",
   label: "Rohuküla (EERHK)"
  },
  {
   value: "Rohuneeme (EERON)",
   label: "Rohuneeme (EERON)"
  },
  {
   value: "Rõngu (EERGU)",
   label: "Rõngu (EERGU)"
  },
  {
   value: "Roomassaare (EERMS)",
   label: "Roomassaare (EERMS)"
  },
  {
   value: "Saaremaa port (EESMA)",
   label: "Saaremaa port (EESMA)"
  },
  {
   value: "Saku (EESKU)",
   label: "Saku (EESKU)"
  },
  {
   value: "Salme (EESAL)",
   label: "Salme (EESAL)"
  },
  {
   value: "Salutaguse, Kaiu (EESLT)",
   label: "Salutaguse, Kaiu (EESLT)"
  },
  {
   value: "Saue (EESAU)",
   label: "Saue (EESAU)"
  },
  {
   value: "Selja (EESLJ)",
   label: "Selja (EESLJ)"
  },
  {
   value: "Sillamäe (EESLM)",
   label: "Sillamäe (EESLM)"
  },
  {
   value: "Sindi (EESIN)",
   label: "Sindi (EESIN)"
  },
  {
   value: "Sipa (EESIP)",
   label: "Sipa (EESIP)"
  },
  {
   value: "Sõru (EESRU)",
   label: "Sõru (EESRU)"
  },
  {
   value: "Sviby (EESVI)",
   label: "Sviby (EESVI)"
  },
  {
   value: "Tabasalu (EEAEH)",
   label: "Tabasalu (EEAEH)"
  },
  {
   value: "Taebla (EETAE)",
   label: "Taebla (EETAE)"
  },
  {
   value: "Tamsalu (EEAEA)",
   label: "Tamsalu (EEAEA)"
  },
  {
   value: "Tapa (EETAP)",
   label: "Tapa (EETAP)"
  },
  {
   value: "Tõdva (EETDV)",
   label: "Tõdva (EETDV)"
  },
  {
   value: "Toila (EETOI)",
   label: "Toila (EETOI)"
  },
  {
   value: "Triigi (EETGI)",
   label: "Triigi (EETGI)"
  },
  {
   value: "Türi (EETUR)",
   label: "Türi (EETUR)"
  },
  {
   value: "Vaida (EEVAI)",
   label: "Vaida (EEVAI)"
  },
  {
   value: "Vaisi (EEVAS)",
   label: "Vaisi (EEVAS)"
  },
  {
   value: "Vanasadam (EEVAN)",
   label: "Vanasadam (EEVAN)"
  },
  {
   value: "Vändra (EEVDA)",
   label: "Vändra (EEVDA)"
  },
  {
   value: "Varbola (EEVBA)",
   label: "Varbola (EEVBA)"
  },
  {
   value: "Vasknarva (EEVNA)",
   label: "Vasknarva (EEVNA)"
  },
  {
   value: "Veere (EEVEE)",
   label: "Veere (EEVEE)"
  },
  {
   value: "Vene-Balti (EEVEB)",
   label: "Vene-Balti (EEVEB)"
  },
  {
   value: "Vihula (EEVIH)",
   label: "Vihula (EEVIH)"
  },
  {
   value: "Viimsi (EEVII)",
   label: "Viimsi (EEVII)"
  },
  {
   value: "Viljandi (EEVIL)",
   label: "Viljandi (EEVIL)"
  },
  {
   value: "Virtsu (EEVIR)",
   label: "Virtsu (EEVIR)"
  },
  {
   value: "Virtsu Vanasadam (EEVVS)",
   label: "Virtsu Vanasadam (EEVVS)"
  },
  {
   value: "Vooru (EEVOU)",
   label: "Vooru (EEVOU)"
  },
  {
   value: "Võru (EEVRU)",
   label: "Võru (EEVRU)"
  },
  {
   value: ".EGYPT (EG)",
   label: ".EGYPT (EG)"
  },
  {
   value: "10th of Ramadan City (EGTRC)",
   label: "10th of Ramadan City (EGTRC)"
  },
  {
   value: "6th October (EGSOC)",
   label: "6th October (EGSOC)"
  },
  {
   value: "Al Jizah (Giza) (EGAGZ)",
   label: "Al Jizah (Giza) (EGAGZ)"
  },
  {
   value: "Al Mansurah (EGALM)",
   label: "Al Mansurah (EGALM)"
  },
  {
   value: "Assiut (EGATZ)",
   label: "Assiut (EGATZ)"
  },
  {
   value: "Asyut (EGAST)",
   label: "Asyut (EGAST)"
  },
  {
   value: "Burj al Arab (EGHBE)",
   label: "Burj al Arab (EGHBE)"
  },
  {
   value: "El Obour (EGEOB)",
   label: "El Obour (EGEOB)"
  },
  {
   value: "Heliopolis (EGHEL)",
   label: "Heliopolis (EGHEL)"
  },
  {
   value: "Idku (EGIKU)",
   label: "Idku (EGIKU)"
  },
  {
   value: "Kafr El Sheikh (EGKEH)",
   label: "Kafr El Sheikh (EGKEH)"
  },
  {
   value: "Matruh (EGMUH)",
   label: "Matruh (EGMUH)"
  },
  {
   value: "Nuwaiba (EGNUW)",
   label: "Nuwaiba (EGNUW)"
  },
  {
   value: "Pt Said East (EGPSE)",
   label: "Pt Said East (EGPSE)"
  },
  {
   value: "Sadat City (EGSAD)",
   label: "Sadat City (EGSAD)"
  },
  {
   value: "Sallum (EGSAL)",
   label: "Sallum (EGSAL)"
  },
  {
   value: "Santa Katarina (EGSKV)",
   label: "Santa Katarina (EGSKV)"
  },
  {
   value: "Siwa (EGSEW)",
   label: "Siwa (EGSEW)"
  },
  {
   value: "Sohag (EGSHG)",
   label: "Sohag (EGSHG)"
  },
  {
   value: "Sokhna Port (EGSOK)",
   label: "Sokhna Port (EGSOK)"
  },
  {
   value: "Sosdi\/6th October (EGSOS)",
   label: "Sosdi\/6th October (EGSOS)"
  },
  {
   value: "Suez Canal (EGSZC)",
   label: "Suez Canal (EGSZC)"
  },
  {
   value: "Tanta (EGTAN)",
   label: "Tanta (EGTAN)"
  },
  {
   value: "Tour Sinai City (EGELT)",
   label: "Tour Sinai City (EGELT)"
  },
  {
   value: ".WESTERN SAHARA (EH)",
   label: ".WESTERN SAHARA (EH)"
  },
  {
   value: ".ERITREA (ER)",
   label: ".ERITREA (ER)"
  },
  {
   value: "Tessenei (ERTES)",
   label: "Tessenei (ERTES)"
  },
  {
   value: ".SPAIN (ES)",
   label: ".SPAIN (ES)"
  },
  {
   value: "A Baiuca (ESAXO)",
   label: "A Baiuca (ESAXO)"
  },
  {
   value: "A Pobra de Trives (ESAPR)",
   label: "A Pobra de Trives (ESAPR)"
  },
  {
   value: "A Pontenova (ESAPV)",
   label: "A Pontenova (ESAPV)"
  },
  {
   value: "A Rua Petin (ESPTI)",
   label: "A Rua Petin (ESPTI)"
  },
  {
   value: "Abadiano-Zelaieta (ESABA)",
   label: "Abadiano-Zelaieta (ESABA)"
  },
  {
   value: "Abadino (ESZNM)",
   label: "Abadino (ESZNM)"
  },
  {
   value: "Ábalos (ESABL)",
   label: "Ábalos (ESABL)"
  },
  {
   value: "Abrera (ESABE)",
   label: "Abrera (ESABE)"
  },
  {
   value: "Aceuchal (ESACH)",
   label: "Aceuchal (ESACH)"
  },
  {
   value: "Adeje (ESAEJ)",
   label: "Adeje (ESAEJ)"
  },
  {
   value: "Aduna (ESADU)",
   label: "Aduna (ESADU)"
  },
  {
   value: "Agoncillo (ESACO)",
   label: "Agoncillo (ESACO)"
  },
  {
   value: "Aguarda (ESARD)",
   label: "Aguarda (ESARD)"
  },
  {
   value: "Aguarón (ESAUR)",
   label: "Aguarón (ESAUR)"
  },
  {
   value: "Aguilar de Campóo (ESACM)",
   label: "Aguilar de Campóo (ESACM)"
  },
  {
   value: "Agüimes (ESAGS)",
   label: "Agüimes (ESAGS)"
  },
  {
   value: "Aguinaga (ESAGI)",
   label: "Aguinaga (ESAGI)"
  },
  {
   value: "Aiguafreda (ESAAR)",
   label: "Aiguafreda (ESAAR)"
  },
  {
   value: "Aiguaviva (ESAVA)",
   label: "Aiguaviva (ESAVA)"
  },
  {
   value: "Aizarnazábal (ESAZB)",
   label: "Aizarnazábal (ESAZB)"
  },
  {
   value: "Ajalvir (ESAJV)",
   label: "Ajalvir (ESAJV)"
  },
  {
   value: "Ajalvir (ESAVR)",
   label: "Ajalvir (ESAVR)"
  },
  {
   value: "Alacuás (ESAQS)",
   label: "Alacuás (ESAQS)"
  },
  {
   value: "Alagón (ESAAN)",
   label: "Alagón (ESAAN)"
  },
  {
   value: "Alameda De La Sagra (ESADS)",
   label: "Alameda De La Sagra (ESADS)"
  },
  {
   value: "Albalate de Cinca (ESACD)",
   label: "Albalate de Cinca (ESACD)"
  },
  {
   value: "Albalate del Arzobispo (ESADO)",
   label: "Albalate del Arzobispo (ESADO)"
  },
  {
   value: "Albelda de Iregua (ESZBL)",
   label: "Albelda de Iregua (ESZBL)"
  },
  {
   value: "Alberic (ESZAA)",
   label: "Alberic (ESZAA)"
  },
  {
   value: "Alberite (ESALE)",
   label: "Alberite (ESALE)"
  },
  {
   value: "Albiztur (ESAAA)",
   label: "Albiztur (ESAAA)"
  },
  {
   value: "Albox (ESZBU)",
   label: "Albox (ESZBU)"
  },
  {
   value: "Alcampell (ESZBI)",
   label: "Alcampell (ESZBI)"
  },
  {
   value: "Alcañiz (ESACZ)",
   label: "Alcañiz (ESACZ)"
  },
  {
   value: "Alcantara (ESZCF)",
   label: "Alcantara (ESZCF)"
  },
  {
   value: "Alcantera de Xuquer (ESZBM)",
   label: "Alcantera de Xuquer (ESZBM)"
  },
  {
   value: "Alcasser (ESASE)",
   label: "Alcasser (ESASE)"
  },
  {
   value: "Alcoletge (ESALL)",
   label: "Alcoletge (ESALL)"
  },
  {
   value: "Alcorcón (ESACC)",
   label: "Alcorcón (ESACC)"
  },
  {
   value: "Alcuescar (ESZCH)",
   label: "Alcuescar (ESZCH)"
  },
  {
   value: "Aldaia (ESZBR)",
   label: "Aldaia (ESZBR)"
  },
  {
   value: "Aldea del Fresno (ESAEF)",
   label: "Aldea del Fresno (ESAEF)"
  },
  {
   value: "Aldea del Obispo (ESZBW)",
   label: "Aldea del Obispo (ESZBW)"
  },
  {
   value: "Aldeamayor de San Martin (ESZCI)",
   label: "Aldeamayor de San Martin (ESZCI)"
  },
  {
   value: "Aldeanueva de Ebro (ESAUE)",
   label: "Aldeanueva de Ebro (ESAUE)"
  },
  {
   value: "Aldeatejada (ESAJD)",
   label: "Aldeatejada (ESAJD)"
  },
  {
   value: "Aldeire (ESZBJ)",
   label: "Aldeire (ESZBJ)"
  },
  {
   value: "Alegria (ESAEG)",
   label: "Alegria (ESAEG)"
  },
  {
   value: "Alegria-Dulantzi de Alava (ESAGV)",
   label: "Alegria-Dulantzi de Alava (ESAGV)"
  },
  {
   value: "Alfajarín (ESAJN)",
   label: "Alfajarín (ESAJN)"
  },
  {
   value: "Alfamen (ESZBN)",
   label: "Alfamen (ESZBN)"
  },
  {
   value: "Alfaro (ESAFO)",
   label: "Alfaro (ESAFO)"
  },
  {
   value: "Alfarrasi (ESALI)",
   label: "Alfarrasi (ESALI)"
  },
  {
   value: "Algorta (ESALT)",
   label: "Algorta (ESALT)"
  },
  {
   value: "Alhama de Aragón (ESADE)",
   label: "Alhama de Aragón (ESADE)"
  },
  {
   value: "Alhama de Murcia (ESAMR)",
   label: "Alhama de Murcia (ESAMR)"
  },
  {
   value: "Alhendin (ESZBQ)",
   label: "Alhendin (ESZBQ)"
  },
  {
   value: "Aljaraque (ESZAI)",
   label: "Aljaraque (ESZAI)"
  },
  {
   value: "Aljucer (ESZBS)",
   label: "Aljucer (ESZBS)"
  },
  {
   value: "Allaríz (ESARZ)",
   label: "Allaríz (ESARZ)"
  },
  {
   value: "Allo (ESZBT)",
   label: "Allo (ESZBT)"
  },
  {
   value: "Almaden de la Plata (ESZHH)",
   label: "Almaden de la Plata (ESZHH)"
  },
  {
   value: "Almagro (ESALM)",
   label: "Almagro (ESALM)"
  },
  {
   value: "Almanzora (ESALZ)",
   label: "Almanzora (ESALZ)"
  },
  {
   value: "Almassera (ESZGO)",
   label: "Almassera (ESZGO)"
  },
  {
   value: "Almendricos (ESALX)",
   label: "Almendricos (ESALX)"
  },
  {
   value: "Almuradiel (ESAML)",
   label: "Almuradiel (ESAML)"
  },
  {
   value: "Almussafes (ESAMS)",
   label: "Almussafes (ESAMS)"
  },
  {
   value: "Alonsotegui (ESATG)",
   label: "Alonsotegui (ESATG)"
  },
  {
   value: "Alovera (ESALV)",
   label: "Alovera (ESALV)"
  },
  {
   value: "Alozaina (ESZCN)",
   label: "Alozaina (ESZCN)"
  },
  {
   value: "Alquerías del niño perdido (ESANP)",
   label: "Alquerías del niño perdido (ESANP)"
  },
  {
   value: "Altube (ESATU)",
   label: "Altube (ESATU)"
  },
  {
   value: "Ambite (ESABT)",
   label: "Ambite (ESABT)"
  },
  {
   value: "Ambrosero (ESABS)",
   label: "Ambrosero (ESABS)"
  },
  {
   value: "Ametlla del Valles (ESZBV)",
   label: "Ametlla del Valles (ESZBV)"
  },
  {
   value: "Ametzaga (ESAZZ)",
   label: "Ametzaga (ESAZZ)"
  },
  {
   value: "Amézqueta (ESAZQ)",
   label: "Amézqueta (ESAZQ)"
  },
  {
   value: "Amoedo (ESAOD)",
   label: "Amoedo (ESAOD)"
  },
  {
   value: "Amorebieta (ESAMO)",
   label: "Amorebieta (ESAMO)"
  },
  {
   value: "Amoroto (ESAMT)",
   label: "Amoroto (ESAMT)"
  },
  {
   value: "Ampuero (ESAMP)",
   label: "Ampuero (ESAMP)"
  },
  {
   value: "Andosilla (ESASL)",
   label: "Andosilla (ESASL)"
  },
  {
   value: "Angles (ESZAK)",
   label: "Angles (ESZAK)"
  },
  {
   value: "Anguiano (ESAIN)",
   label: "Anguiano (ESAIN)"
  },
  {
   value: "Anleo (ESANL)",
   label: "Anleo (ESANL)"
  },
  {
   value: "Anna (ESZKJ)",
   label: "Anna (ESZKJ)"
  },
  {
   value: "Anoeta (ESANA)",
   label: "Anoeta (ESANA)"
  },
  {
   value: "Añorbe (ESANB)",
   label: "Añorbe (ESANB)"
  },
  {
   value: "Antas (ESZKS)",
   label: "Antas (ESZKS)"
  },
  {
   value: "Antzuola (ESANZ)",
   label: "Antzuola (ESANZ)"
  },
  {
   value: "Aracena (ESACN)",
   label: "Aracena (ESACN)"
  },
  {
   value: "Arafo (ESARF)",
   label: "Arafo (ESARF)"
  },
  {
   value: "Araia (ESAAI)",
   label: "Araia (ESAAI)"
  },
  {
   value: "Aranguren (ESANG)",
   label: "Aranguren (ESANG)"
  },
  {
   value: "Araya (ESARY)",
   label: "Araya (ESARY)"
  },
  {
   value: "Arazuri (ESAZI)",
   label: "Arazuri (ESAZI)"
  },
  {
   value: "Arceniega (ESRCE)",
   label: "Arceniega (ESRCE)"
  },
  {
   value: "Arciniega (ESACI)",
   label: "Arciniega (ESACI)"
  },
  {
   value: "Ardoncino (ESZCD)",
   label: "Ardoncino (ESZCD)"
  },
  {
   value: "Arechavaleta (ESAVL)",
   label: "Arechavaleta (ESAVL)"
  },
  {
   value: "Arechavaleta (ESAVT)",
   label: "Arechavaleta (ESAVT)"
  },
  {
   value: "Areso (ESARS)",
   label: "Areso (ESARS)"
  },
  {
   value: "Arévalo (ESARV)",
   label: "Arévalo (ESARV)"
  },
  {
   value: "Argelaguer (ESAGG)",
   label: "Argelaguer (ESAGG)"
  },
  {
   value: "Arguedas (ESZBO)",
   label: "Arguedas (ESZBO)"
  },
  {
   value: "Arico (ESAIC)",
   label: "Arico (ESAIC)"
  },
  {
   value: "Arinaga (ESRGA)",
   label: "Arinaga (ESRGA)"
  },
  {
   value: "Arizkun (ESIZK)",
   label: "Arizkun (ESIZK)"
  },
  {
   value: "Armilla (ESZNT)",
   label: "Armilla (ESZNT)"
  },
  {
   value: "Arnedo (ESARO)",
   label: "Arnedo (ESARO)"
  },
  {
   value: "Arona (ESAAO)",
   label: "Arona (ESAAO)"
  },
  {
   value: "Arrabal de Jesús (ESADJ)",
   label: "Arrabal de Jesús (ESADJ)"
  },
  {
   value: "Arrabaldo (ESABO)",
   label: "Arrabaldo (ESABO)"
  },
  {
   value: "Arrasate-Mondragon (ESAMD)",
   label: "Arrasate-Mondragon (ESAMD)"
  },
  {
   value: "Arre (ESARE)",
   label: "Arre (ESARE)"
  },
  {
   value: "Arriate (ESATE)",
   label: "Arriate (ESATE)"
  },
  {
   value: "Arroyo de la Miel (ESAMI)",
   label: "Arroyo de la Miel (ESAMI)"
  },
  {
   value: "Arrubal (La Rioja) (ESARL)",
   label: "Arrubal (La Rioja) (ESARL)"
  },
  {
   value: "Arteixo (ESZCG)",
   label: "Arteixo (ESZCG)"
  },
  {
   value: "Artica (ESATA)",
   label: "Artica (ESATA)"
  },
  {
   value: "Arucas (ESZAO)",
   label: "Arucas (ESZAO)"
  },
  {
   value: "Arzua (ESAZU)",
   label: "Arzua (ESAZU)"
  },
  {
   value: "As Pontes (ESZAB)",
   label: "As Pontes (ESZAB)"
  },
  {
   value: "Asteasu (ESZCJ)",
   label: "Asteasu (ESZCJ)"
  },
  {
   value: "Astigarraga (ESASS)",
   label: "Astigarraga (ESASS)"
  },
  {
   value: "Astorga (ESASG)",
   label: "Astorga (ESASG)"
  },
  {
   value: "Asturianos (ESASN)",
   label: "Asturianos (ESASN)"
  },
  {
   value: "Ateca (ESZCK)",
   label: "Ateca (ESZCK)"
  },
  {
   value: "Atienza (ESZBX)",
   label: "Atienza (ESZBX)"
  },
  {
   value: "Atxondo (ESAXD)",
   label: "Atxondo (ESAXD)"
  },
  {
   value: "Aurizberri Espinal (ESZCL)",
   label: "Aurizberri Espinal (ESZCL)"
  },
  {
   value: "Avia (ESZCM)",
   label: "Avia (ESZCM)"
  },
  {
   value: "Avinyo (ESUNY)",
   label: "Avinyo (ESUNY)"
  },
  {
   value: "Aya (ESAYI)",
   label: "Aya (ESAYI)"
  },
  {
   value: "Ayerbe (ESAYE)",
   label: "Ayerbe (ESAYE)"
  },
  {
   value: "Azagra (ESAZG)",
   label: "Azagra (ESAZG)"
  },
  {
   value: "Aznalcollar (ESZCO)",
   label: "Aznalcollar (ESZCO)"
  },
  {
   value: "Baena (ESZCQ)",
   label: "Baena (ESZCQ)"
  },
  {
   value: "Baiona (ESZHR)",
   label: "Baiona (ESZHR)"
  },
  {
   value: "Balaguer (ESBAL)",
   label: "Balaguer (ESBAL)"
  },
  {
   value: "Balboa (ESBBA)",
   label: "Balboa (ESBBA)"
  },
  {
   value: "Ballobar (ESBLL)",
   label: "Ballobar (ESBLL)"
  },
  {
   value: "Balsapintada (ESBPA)",
   label: "Balsapintada (ESBPA)"
  },
  {
   value: "Balsareny (ESBRY)",
   label: "Balsareny (ESBRY)"
  },
  {
   value: "Balsicas (ESBCS)",
   label: "Balsicas (ESBCS)"
  },
  {
   value: "Bandeira (ESZCT)",
   label: "Bandeira (ESZCT)"
  },
  {
   value: "Banyeres de Mariola (ESBMR)",
   label: "Banyeres de Mariola (ESBMR)"
  },
  {
   value: "Banyeres del Penedes (ESBDP)",
   label: "Banyeres del Penedes (ESBDP)"
  },
  {
   value: "Banyoles (ESBYO)",
   label: "Banyoles (ESBYO)"
  },
  {
   value: "Barasoain (ESBSA)",
   label: "Barasoain (ESBSA)"
  },
  {
   value: "Barbadillo del Mercado (ESBMC)",
   label: "Barbadillo del Mercado (ESBMC)"
  },
  {
   value: "Barbastro (ESBRB)",
   label: "Barbastro (ESBRB)"
  },
  {
   value: "Barbatain (ESZCR)",
   label: "Barbatain (ESZCR)"
  },
  {
   value: "Barbera de la Conca (ESZCS)",
   label: "Barbera de la Conca (ESZCS)"
  },
  {
   value: "Barcena de Cicero (ESBCO)",
   label: "Barcena de Cicero (ESBCO)"
  },
  {
   value: "Bargas (ESZCP)",
   label: "Bargas (ESZCP)"
  },
  {
   value: "Barrax (ESZHC)",
   label: "Barrax (ESZHC)"
  },
  {
   value: "Barreda (ESBRA)",
   label: "Barreda (ESBRA)"
  },
  {
   value: "Barro (ESBAR)",
   label: "Barro (ESBAR)"
  },
  {
   value: "Barros (ESBRS)",
   label: "Barros (ESBRS)"
  },
  {
   value: "Barxeta (ESZFX)",
   label: "Barxeta (ESZFX)"
  },
  {
   value: "Baza (ESBAA)",
   label: "Baza (ESBAA)"
  },
  {
   value: "Beasain (ESBES)",
   label: "Beasain (ESBES)"
  },
  {
   value: "Becerril De Campos (ESBCC)",
   label: "Becerril De Campos (ESBCC)"
  },
  {
   value: "Becilla de Valderaduey (ESBVA)",
   label: "Becilla de Valderaduey (ESBVA)"
  },
  {
   value: "Bedia (ESBDI)",
   label: "Bedia (ESBDI)"
  },
  {
   value: "Beguda (ESZOE)",
   label: "Beguda (ESZOE)"
  },
  {
   value: "Begur (ESBLR)",
   label: "Begur (ESBLR)"
  },
  {
   value: "Bellpuig (ESBPU)",
   label: "Bellpuig (ESBPU)"
  },
  {
   value: "Bellreguard (ESBGD)",
   label: "Bellreguard (ESBGD)"
  },
  {
   value: "Bellveí (ESBEL)",
   label: "Bellveí (ESBEL)"
  },
  {
   value: "Belmonte de Tajo (ESBMT)",
   label: "Belmonte de Tajo (ESBMT)"
  },
  {
   value: "Belorado (ESZCX)",
   label: "Belorado (ESZCX)"
  },
  {
   value: "Bembibre (ESBBB)",
   label: "Bembibre (ESBBB)"
  },
  {
   value: "Benageber (ESZLE)",
   label: "Benageber (ESZLE)"
  },
  {
   value: "Benahavis (ESBNV)",
   label: "Benahavis (ESBNV)"
  },
  {
   value: "Benalup (ESZDC)",
   label: "Benalup (ESZDC)"
  },
  {
   value: "Benamaurel (ESBML)",
   label: "Benamaurel (ESBML)"
  },
  {
   value: "Benavente (ESBEV)",
   label: "Benavente (ESBEV)"
  },
  {
   value: "Beneixama (ESBXA)",
   label: "Beneixama (ESBXA)"
  },
  {
   value: "Beneixida (ESBXD)",
   label: "Beneixida (ESBXD)"
  },
  {
   value: "Benejama (ESBJN)",
   label: "Benejama (ESBJN)"
  },
  {
   value: "Beniarrés (ESBNR)",
   label: "Beniarrés (ESBNR)"
  },
  {
   value: "Benifairó de la Valldigna (ESBNF)",
   label: "Benifairó de la Valldigna (ESBNF)"
  },
  {
   value: "Beniflá (ESBFL)",
   label: "Beniflá (ESBFL)"
  },
  {
   value: "Benimarfull (ESBMF)",
   label: "Benimarfull (ESBMF)"
  },
  {
   value: "Benimuslem (ESZDB)",
   label: "Benimuslem (ESZDB)"
  },
  {
   value: "Benirredra (ESBDR)",
   label: "Benirredra (ESBDR)"
  },
  {
   value: "Benisa (ESBNA)",
   label: "Benisa (ESBNA)"
  },
  {
   value: "Benisanó (ESBEO)",
   label: "Benisanó (ESBEO)"
  },
  {
   value: "Benisoda (ESBSO)",
   label: "Benisoda (ESBSO)"
  },
  {
   value: "Benissa (ESZBC)",
   label: "Benissa (ESZBC)"
  },
  {
   value: "Benlloch (ESBLO)",
   label: "Benlloch (ESBLO)"
  },
  {
   value: "Bera\/Vera de Bidasoa (ESVDB)",
   label: "Bera\/Vera de Bidasoa (ESVDB)"
  },
  {
   value: "Berango (ESBNO)",
   label: "Berango (ESBNO)"
  },
  {
   value: "Berantevilla (ESZCU)",
   label: "Berantevilla (ESZCU)"
  },
  {
   value: "Berastegui (ESBSI)",
   label: "Berastegui (ESBSI)"
  },
  {
   value: "Berga (ESBGA)",
   label: "Berga (ESBGA)"
  },
  {
   value: "Bergara (ESBGR)",
   label: "Bergara (ESBGR)"
  },
  {
   value: "Bergondo (ESBGO)",
   label: "Bergondo (ESBGO)"
  },
  {
   value: "Beriáin (ESBEI)",
   label: "Beriáin (ESBEI)"
  },
  {
   value: "Berriatúa (ESBEA)",
   label: "Berriatúa (ESBEA)"
  },
  {
   value: "Bérriz (ESBER)",
   label: "Bérriz (ESBER)"
  },
  {
   value: "Betanzos (ESBTS)",
   label: "Betanzos (ESBTS)"
  },
  {
   value: "Betxi (ESZDH)",
   label: "Betxi (ESZDH)"
  },
  {
   value: "Biar (ESBIR)",
   label: "Biar (ESBIR)"
  },
  {
   value: "Bigues (ESBGU)",
   label: "Bigues (ESBGU)"
  },
  {
   value: "Binaced (ESBND)",
   label: "Binaced (ESBND)"
  },
  {
   value: "Binéfar (ESBIN)",
   label: "Binéfar (ESBIN)"
  },
  {
   value: "Bisimbre (ESZCY)",
   label: "Bisimbre (ESZCY)"
  },
  {
   value: "Boadilla del Monte (ESBOA)",
   label: "Boadilla del Monte (ESBOA)"
  },
  {
   value: "Boecillo (ESZJD)",
   label: "Boecillo (ESZJD)"
  },
  {
   value: "Boiro (ESZDF)",
   label: "Boiro (ESZDF)"
  },
  {
   value: "Bonares (ESBNS)",
   label: "Bonares (ESBNS)"
  },
  {
   value: "Bonavista (ESBVT)",
   label: "Bonavista (ESBVT)"
  },
  {
   value: "Bonmatí (ESBON)",
   label: "Bonmatí (ESBON)"
  },
  {
   value: "Bonrepòs I Mirambell (ESBYM)",
   label: "Bonrepòs I Mirambell (ESBYM)"
  },
  {
   value: "Boqueixon (ESZDE)",
   label: "Boqueixon (ESZDE)"
  },
  {
   value: "Bordils (ESZDD)",
   label: "Bordils (ESZDD)"
  },
  {
   value: "Borja (ESBOJ)",
   label: "Borja (ESBOJ)"
  },
  {
   value: "Borox (ESBRO)",
   label: "Borox (ESBRO)"
  },
  {
   value: "Breda (ESBRD)",
   label: "Breda (ESBRD)"
  },
  {
   value: "Briones (ESLVV)",
   label: "Briones (ESLVV)"
  },
  {
   value: "Briviesca (ESBRV)",
   label: "Briviesca (ESBRV)"
  },
  {
   value: "Bueu (ESBUE)",
   label: "Bueu (ESBUE)"
  },
  {
   value: "Bugarra (ESBUG)",
   label: "Bugarra (ESBUG)"
  },
  {
   value: "Bunuiel (ESNNN)",
   label: "Bunuiel (ESNNN)"
  },
  {
   value: "Burgo de Osma (ESBOS)",
   label: "Burgo de Osma (ESBOS)"
  },
  {
   value: "Burguillos (ESZCV)",
   label: "Burguillos (ESZCV)"
  },
  {
   value: "Burjulu (ESBRU)",
   label: "Burjulu (ESBRU)"
  },
  {
   value: "Burlada (ESBUA)",
   label: "Burlada (ESBUA)"
  },
  {
   value: "Cabañas Raras (ESCRA)",
   label: "Cabañas Raras (ESCRA)"
  },
  {
   value: "Cabanillas del Campo (ESCDO)",
   label: "Cabanillas del Campo (ESCDO)"
  },
  {
   value: "Cabeza De Buey (ESCDB)",
   label: "Cabeza De Buey (ESCDB)"
  },
  {
   value: "Cabezuella Del Valle (ESCZV)",
   label: "Cabezuella Del Valle (ESCZV)"
  },
  {
   value: "Cabo Roig (ESCRG)",
   label: "Cabo Roig (ESCRG)"
  },
  {
   value: "Caborana (ESZED)",
   label: "Caborana (ESZED)"
  },
  {
   value: "Cabra del Santo Cristo (ESCTC)",
   label: "Cabra del Santo Cristo (ESCTC)"
  },
  {
   value: "Cabrera de Mar (ESCBM)",
   label: "Cabrera de Mar (ESCBM)"
  },
  {
   value: "Cabrianes (ESZDK)",
   label: "Cabrianes (ESZDK)"
  },
  {
   value: "Cabrils (ESCBI)",
   label: "Cabrils (ESCBI)"
  },
  {
   value: "Cacicedo (ESCID)",
   label: "Cacicedo (ESCID)"
  },
  {
   value: "Calaf (ESCAF)",
   label: "Calaf (ESCAF)"
  },
  {
   value: "Calamocha (ESCAH)",
   label: "Calamocha (ESCAH)"
  },
  {
   value: "Calatayud (ESTAY)",
   label: "Calatayud (ESTAY)"
  },
  {
   value: "Caldas de Reis (ESCSY)",
   label: "Caldas de Reis (ESCSY)"
  },
  {
   value: "Caldes de Montbui (ESCSM)",
   label: "Caldes de Montbui (ESCSM)"
  },
  {
   value: "Calera y Chozas (ESCYC)",
   label: "Calera y Chozas (ESCYC)"
  },
  {
   value: "Caleruega (ESCLG)",
   label: "Caleruega (ESCLG)"
  },
  {
   value: "Calpe (ESCLP)",
   label: "Calpe (ESCLP)"
  },
  {
   value: "Camarenilla (ESCMN)",
   label: "Camarenilla (ESCMN)"
  },
  {
   value: "Camarles (ESCLS)",
   label: "Camarles (ESCLS)"
  },
  {
   value: "Camarma de Esteruelas (ESCAE)",
   label: "Camarma de Esteruelas (ESCAE)"
  },
  {
   value: "Cambre (ESZDW)",
   label: "Cambre (ESZDW)"
  },
  {
   value: "Cambrils (ESCBL)",
   label: "Cambrils (ESCBL)"
  },
  {
   value: "Campanario (ESCPR)",
   label: "Campanario (ESCPR)"
  },
  {
   value: "Campanas (ESCPN)",
   label: "Campanas (ESCPN)"
  },
  {
   value: "Campanillas (ESCPL)",
   label: "Campanillas (ESCPL)"
  },
  {
   value: "Campillo del Altobuey (ESZDO)",
   label: "Campillo del Altobuey (ESZDO)"
  },
  {
   value: "Campllong (ESCGG)",
   label: "Campllong (ESCGG)"
  },
  {
   value: "Campllong (ESCOG)",
   label: "Campllong (ESCOG)"
  },
  {
   value: "Campo de Criptana (ESCOC)",
   label: "Campo de Criptana (ESCOC)"
  },
  {
   value: "Campo Real (ESZDX)",
   label: "Campo Real (ESZDX)"
  },
  {
   value: "Campoamor (ESCPA)",
   label: "Campoamor (ESCPA)"
  },
  {
   value: "Campotejar (ESZEJ)",
   label: "Campotejar (ESZEJ)"
  },
  {
   value: "Camprovín (ESCMV)",
   label: "Camprovín (ESCMV)"
  },
  {
   value: "Canada Rosal (ESZDY)",
   label: "Canada Rosal (ESZDY)"
  },
  {
   value: "Cañamero (ESCMO)",
   label: "Cañamero (ESCMO)"
  },
  {
   value: "Cancienes (ESCCE)",
   label: "Cancienes (ESCCE)"
  },
  {
   value: "Candeleda (ESCNA)",
   label: "Candeleda (ESCNA)"
  },
  {
   value: "Canena (ESZGR)",
   label: "Canena (ESZGR)"
  },
  {
   value: "Cangas (ESCAG)",
   label: "Cangas (ESCAG)"
  },
  {
   value: "Cangas (ESRAN)",
   label: "Cangas (ESRAN)"
  },
  {
   value: "Cangas de Narcea (ESCDN)",
   label: "Cangas de Narcea (ESCDN)"
  },
  {
   value: "Cangas de Onis (ESCON)",
   label: "Cangas de Onis (ESCON)"
  },
  {
   value: "Canovelles (ESZDL)",
   label: "Canovelles (ESZDL)"
  },
  {
   value: "Cantalapiedra (ESCTP)",
   label: "Cantalapiedra (ESCTP)"
  },
  {
   value: "Cantalpino (ESCTL)",
   label: "Cantalpino (ESCTL)"
  },
  {
   value: "Caparroso (ESCPO)",
   label: "Caparroso (ESCPO)"
  },
  {
   value: "Capcanes (ESCPC)",
   label: "Capcanes (ESCPC)"
  },
  {
   value: "Capellades (ESCES)",
   label: "Capellades (ESCES)"
  },
  {
   value: "Capmany (ESZEO)",
   label: "Capmany (ESZEO)"
  },
  {
   value: "Carballido (ESCLD)",
   label: "Carballido (ESCLD)"
  },
  {
   value: "Carballiño (ESCAJ)",
   label: "Carballiño (ESCAJ)"
  },
  {
   value: "Carballo (ESCBA)",
   label: "Carballo (ESCBA)"
  },
  {
   value: "Carballo (ESCBO)",
   label: "Carballo (ESCBO)"
  },
  {
   value: "Carcar (ESZEE)",
   label: "Carcar (ESZEE)"
  },
  {
   value: "Carcastillo (ESCCO)",
   label: "Carcastillo (ESCCO)"
  },
  {
   value: "Carchuna (ESZOB)",
   label: "Carchuna (ESZOB)"
  },
  {
   value: "Carineña (ESCNN)",
   label: "Carineña (ESCNN)"
  },
  {
   value: "Carnota (ESCRN)",
   label: "Carnota (ESCRN)"
  },
  {
   value: "Carreño (ESCAO)",
   label: "Carreño (ESCAO)"
  },
  {
   value: "Carrizal (ESCDI)",
   label: "Carrizal (ESCDI)"
  },
  {
   value: "Cartaya (ESZEL)",
   label: "Cartaya (ESZEL)"
  },
  {
   value: "Cartes (ESCTE)",
   label: "Cartes (ESCTE)"
  },
  {
   value: "Cartuja Baja (ESCBJ)",
   label: "Cartuja Baja (ESCBJ)"
  },
  {
   value: "Casa Nueva (ESCNU)",
   label: "Casa Nueva (ESCNU)"
  },
  {
   value: "Casabermeja (ESZAC)",
   label: "Casabermeja (ESZAC)"
  },
  {
   value: "Casablanca (ESCSA)",
   label: "Casablanca (ESCSA)"
  },
  {
   value: "Casarrubios del Monte (ESZEF)",
   label: "Casarrubios del Monte (ESZEF)"
  },
  {
   value: "Casarrubuelos (ESCRE)",
   label: "Casarrubuelos (ESCRE)"
  },
  {
   value: "Casaseca de Las Chanas (ESCCC)",
   label: "Casaseca de Las Chanas (ESCCC)"
  },
  {
   value: "Cascante (ESCCT)",
   label: "Cascante (ESCCT)"
  },
  {
   value: "Cascante (ESCSC)",
   label: "Cascante (ESCSC)"
  },
  {
   value: "Casetas (ESCTS)",
   label: "Casetas (ESCTS)"
  },
  {
   value: "Casinos (ESESS)",
   label: "Casinos (ESESS)"
  },
  {
   value: "Castejón (ESCSJ)",
   label: "Castejón (ESCSJ)"
  },
  {
   value: "Castejón del Puente (ESCPT)",
   label: "Castejón del Puente (ESCPT)"
  },
  {
   value: "Castellar (ESZEK)",
   label: "Castellar (ESZEK)"
  },
  {
   value: "Castellar del Vallés (ESCAV)",
   label: "Castellar del Vallés (ESCAV)"
  },
  {
   value: "Castellfollit de la Roca (ESZFD)",
   label: "Castellfollit de la Roca (ESZFD)"
  },
  {
   value: "Castellgali (ESZEH)",
   label: "Castellgali (ESZEH)"
  },
  {
   value: "Castellnou de Seana (ESZDN)",
   label: "Castellnou de Seana (ESZDN)"
  },
  {
   value: "Castellvell del Camp (ESZEN)",
   label: "Castellvell del Camp (ESZEN)"
  },
  {
   value: "Castellví de Rosanés (ESCAI)",
   label: "Castellví de Rosanés (ESCAI)"
  },
  {
   value: "Castilleja de la Cuesta (ESCCU)",
   label: "Castilleja de la Cuesta (ESCCU)"
  },
  {
   value: "Castropol (ESCSO)",
   label: "Castropol (ESCSO)"
  },
  {
   value: "Castro-Urdiales (ESCUR)",
   label: "Castro-Urdiales (ESCUR)"
  },
  {
   value: "Castuera (ESCTU)",
   label: "Castuera (ESCTU)"
  },
  {
   value: "Catoira (ESCOI)",
   label: "Catoira (ESCOI)"
  },
  {
   value: "Catral (ESCTR)",
   label: "Catral (ESCTR)"
  },
  {
   value: "Cazalegas (ESCAZ)",
   label: "Cazalegas (ESCAZ)"
  },
  {
   value: "Cedeira (ESCED)",
   label: "Cedeira (ESCED)"
  },
  {
   value: "Cedillo del Condado (ESCEC)",
   label: "Cedillo del Condado (ESCEC)"
  },
  {
   value: "Cee (ESCEE)",
   label: "Cee (ESCEE)"
  },
  {
   value: "Celrà (ESCLR)",
   label: "Celrà (ESCLR)"
  },
  {
   value: "Cenicero (ESCNI)",
   label: "Cenicero (ESCNI)"
  },
  {
   value: "Centelles (ESZEB)",
   label: "Centelles (ESZEB)"
  },
  {
   value: "Cerceda (ESCCD)",
   label: "Cerceda (ESCCD)"
  },
  {
   value: "Cervello (ESSVL)",
   label: "Cervello (ESSVL)"
  },
  {
   value: "Cervera (ESCRV)",
   label: "Cervera (ESCRV)"
  },
  {
   value: "Cervo (ESCEV)",
   label: "Cervo (ESCEV)"
  },
  {
   value: "Cestona (ESCTO)",
   label: "Cestona (ESCTO)"
  },
  {
   value: "Chantada (ESCHT)",
   label: "Chantada (ESCHT)"
  },
  {
   value: "Chapela (ESCHA)",
   label: "Chapela (ESCHA)"
  },
  {
   value: "Cheste (ESCHS)",
   label: "Cheste (ESCHS)"
  },
  {
   value: "Chiloeches (ESZDS)",
   label: "Chiloeches (ESZDS)"
  },
  {
   value: "Chinchilla de Monte Aragon (ESCMT)",
   label: "Chinchilla de Monte Aragon (ESCMT)"
  },
  {
   value: "Churriana (ESZDU)",
   label: "Churriana (ESZDU)"
  },
  {
   value: "Cicero (ESCEO)",
   label: "Cicero (ESCEO)"
  },
  {
   value: "Cierbena (ESCRI)",
   label: "Cierbena (ESCRI)"
  },
  {
   value: "Ciervana (ESCIV)",
   label: "Ciervana (ESCIV)"
  },
  {
   value: "Cintruénigo (ESCNR)",
   label: "Cintruénigo (ESCNR)"
  },
  {
   value: "Cisterniga (ESCEG)",
   label: "Cisterniga (ESCEG)"
  },
  {
   value: "Ciutadella de Menorca (ESCMC)",
   label: "Ciutadella de Menorca (ESCMC)"
  },
  {
   value: "Cobatillas (ESCTI)",
   label: "Cobatillas (ESCTI)"
  },
  {
   value: "Cobeña (ESCOB)",
   label: "Cobeña (ESCOB)"
  },
  {
   value: "Coeses (ESCSS)",
   label: "Coeses (ESCSS)"
  },
  {
   value: "Colindres (ESCOD)",
   label: "Colindres (ESCOD)"
  },
  {
   value: "Collado Villalba (ESCVB)",
   label: "Collado Villalba (ESCVB)"
  },
  {
   value: "Comunión (ESCOM)",
   label: "Comunión (ESCOM)"
  },
  {
   value: "Conil de la Frontera (ESZEA)",
   label: "Conil de la Frontera (ESZEA)"
  },
  {
   value: "Consell (ESCSL)",
   label: "Consell (ESCSL)"
  },
  {
   value: "Constantí (ESCTN)",
   label: "Constantí (ESCTN)"
  },
  {
   value: "Corbins (ESORB)",
   label: "Corbins (ESORB)"
  },
  {
   value: "Corca (ESZDQ)",
   label: "Corca (ESZDQ)"
  },
  {
   value: "Cordovin (ESZEC)",
   label: "Cordovin (ESZEC)"
  },
  {
   value: "Coreses (ESCSE)",
   label: "Coreses (ESCSE)"
  },
  {
   value: "Cornellá de Llobregat (ESCOT)",
   label: "Cornellá de Llobregat (ESCOT)"
  },
  {
   value: "Cornellà del Terri (ESCDT)",
   label: "Cornellà del Terri (ESCDT)"
  },
  {
   value: "Cornellana (ESORN)",
   label: "Cornellana (ESORN)"
  },
  {
   value: "Corral de Almaguer (ESCMG)",
   label: "Corral de Almaguer (ESCMG)"
  },
  {
   value: "Corujo (ESCRJ)",
   label: "Corujo (ESCRJ)"
  },
  {
   value: "Coruño (ESCOO)",
   label: "Coruño (ESCOO)"
  },
  {
   value: "Corvera (ESCVR)",
   label: "Corvera (ESCVR)"
  },
  {
   value: "Cotobade (ESCTB)",
   label: "Cotobade (ESCTB)"
  },
  {
   value: "Couso (ESCUO)",
   label: "Couso (ESCUO)"
  },
  {
   value: "Cox (ESZDJ)",
   label: "Cox (ESZDJ)"
  },
  {
   value: "Cuarte de Huerva (ESCUD)",
   label: "Cuarte de Huerva (ESCUD)"
  },
  {
   value: "Cudillero (ESCLO)",
   label: "Cudillero (ESCLO)"
  },
  {
   value: "Cudon (ESZDM)",
   label: "Cudon (ESZDM)"
  },
  {
   value: "Cuéllar (ESCUL)",
   label: "Cuéllar (ESCUL)"
  },
  {
   value: "Cuevas de San Marcos (ESZEG)",
   label: "Cuevas de San Marcos (ESZEG)"
  },
  {
   value: "Cuevas de Vinroma (ESCVI)",
   label: "Cuevas de Vinroma (ESCVI)"
  },
  {
   value: "Cuevas del Almanzora (ESCEA)",
   label: "Cuevas del Almanzora (ESCEA)"
  },
  {
   value: "Culleredo (ESCRO)",
   label: "Culleredo (ESCRO)"
  },
  {
   value: "Cumbres Mayores (ESZEM)",
   label: "Cumbres Mayores (ESZEM)"
  },
  {
   value: "Cuntis (ESCUS)",
   label: "Cuntis (ESCUS)"
  },
  {
   value: "Curillas (ESCRU)",
   label: "Curillas (ESCRU)"
  },
  {
   value: "Curtis (ESCIS)",
   label: "Curtis (ESCIS)"
  },
  {
   value: "Daganzo de Arriba (ESDEA)",
   label: "Daganzo de Arriba (ESDEA)"
  },
  {
   value: "Deba (ESDBA)",
   label: "Deba (ESDBA)"
  },
  {
   value: "Deva (ESDVA)",
   label: "Deva (ESDVA)"
  },
  {
   value: "Dicastillo (ESDSO)",
   label: "Dicastillo (ESDSO)"
  },
  {
   value: "Dólar (ESDOL)",
   label: "Dólar (ESDOL)"
  },
  {
   value: "Domayo (ESDOY)",
   label: "Domayo (ESDOY)"
  },
  {
   value: "Dosrius (ESZEP)",
   label: "Dosrius (ESZEP)"
  },
  {
   value: "Dueñas (ESDUN)",
   label: "Dueñas (ESDUN)"
  },
  {
   value: "Durana (ESDRA)",
   label: "Durana (ESDRA)"
  },
  {
   value: "Durango (ESDRG)",
   label: "Durango (ESDRG)"
  },
  {
   value: "Duruelo (ESDUO)",
   label: "Duruelo (ESDUO)"
  },
  {
   value: "Egues (ESEGU)",
   label: "Egues (ESEGU)"
  },
  {
   value: "Eguillor (ESZET)",
   label: "Eguillor (ESZET)"
  },
  {
   value: "Éibar (ESEBR)",
   label: "Éibar (ESEBR)"
  },
  {
   value: "Ejea de los Caballeros (ESEJC)",
   label: "Ejea de los Caballeros (ESEJC)"
  },
  {
   value: "El Astillero (ESATO)",
   label: "El Astillero (ESATO)"
  },
  {
   value: "El Barco de Ávila (ESEBA)",
   label: "El Barco de Ávila (ESEBA)"
  },
  {
   value: "El Bruc (ESELB)",
   label: "El Bruc (ESELB)"
  },
  {
   value: "El Burgo de Ebro (ESEDE)",
   label: "El Burgo de Ebro (ESEDE)"
  },
  {
   value: "El Campello (ESECP)",
   label: "El Campello (ESECP)"
  },
  {
   value: "El Campillo (ESECO)",
   label: "El Campillo (ESECO)"
  },
  {
   value: "El Chorrillo (ESZDT)",
   label: "El Chorrillo (ESZDT)"
  },
  {
   value: "El Coronil (ESZKH)",
   label: "El Coronil (ESZKH)"
  },
  {
   value: "El Corrillo (Zalla) (ESECL)",
   label: "El Corrillo (Zalla) (ESECL)"
  },
  {
   value: "El Escorial (ESEES)",
   label: "El Escorial (ESEES)"
  },
  {
   value: "El Esparragal (ESESR)",
   label: "El Esparragal (ESESR)"
  },
  {
   value: "El Goro (ESERU)",
   label: "El Goro (ESERU)"
  },
  {
   value: "El Grao (ESGCS)",
   label: "El Grao (ESGCS)"
  },
  {
   value: "El Grau de Castello (ESEGC)",
   label: "El Grau de Castello (ESEGC)"
  },
  {
   value: "El Molar (ESEML)",
   label: "El Molar (ESEML)"
  },
  {
   value: "El Morche (ESZEU)",
   label: "El Morche (ESZEU)"
  },
  {
   value: "El Puig (ESEPG)",
   label: "El Puig (ESEPG)"
  },
  {
   value: "El Raal (ESELR)",
   label: "El Raal (ESELR)"
  },
  {
   value: "El Rasillo de Camero (ESECM)",
   label: "El Rasillo de Camero (ESECM)"
  },
  {
   value: "El Rosario (ESESO)",
   label: "El Rosario (ESESO)"
  },
  {
   value: "El Sauzal (ESZMF)",
   label: "El Sauzal (ESZMF)"
  },
  {
   value: "El Tarajal (ESTAL)",
   label: "El Tarajal (ESTAL)"
  },
  {
   value: "El Tejar (ESZMH)",
   label: "El Tejar (ESZMH)"
  },
  {
   value: "El Vellón (ESEVE)",
   label: "El Vellón (ESEVE)"
  },
  {
   value: "El Villar de Arnedo (ESEVA)",
   label: "El Villar de Arnedo (ESEVA)"
  },
  {
   value: "Elcarte (ESELT)",
   label: "Elcarte (ESELT)"
  },
  {
   value: "Elciego (ESELG)",
   label: "Elciego (ESELG)"
  },
  {
   value: "Elochelerri (Lujua) (ESELC)",
   label: "Elochelerri (Lujua) (ESELC)"
  },
  {
   value: "Elorrio (ESERO)",
   label: "Elorrio (ESERO)"
  },
  {
   value: "Els Hostalets de Pierola (ESZFQ)",
   label: "Els Hostalets de Pierola (ESZFQ)"
  },
  {
   value: "Entoma (ESENT)",
   label: "Entoma (ESENT)"
  },
  {
   value: "Entrambasaguas (ESEBU)",
   label: "Entrambasaguas (ESEBU)"
  },
  {
   value: "Épila (ESEPI)",
   label: "Épila (ESEPI)"
  },
  {
   value: "Erandio (ESZEW)",
   label: "Erandio (ESZEW)"
  },
  {
   value: "Ereno (ESERE)",
   label: "Ereno (ESERE)"
  },
  {
   value: "Errezil (ESZEY)",
   label: "Errezil (ESZEY)"
  },
  {
   value: "Escalona (ESEAL)",
   label: "Escalona (ESEAL)"
  },
  {
   value: "Escalonilla (ESESN)",
   label: "Escalonilla (ESESN)"
  },
  {
   value: "Escatron (ESEST)",
   label: "Escatron (ESEST)"
  },
  {
   value: "Escoriaza (ESECZ)",
   label: "Escoriaza (ESECZ)"
  },
  {
   value: "Escuzar (ESZFA)",
   label: "Escuzar (ESZFA)"
  },
  {
   value: "Eskoriatza (ESEKZ)",
   label: "Eskoriatza (ESEKZ)"
  },
  {
   value: "Esparza De Galar (ESEZG)",
   label: "Esparza De Galar (ESEZG)"
  },
  {
   value: "Espiel (ESZEV)",
   label: "Espiel (ESZEV)"
  },
  {
   value: "Espina (ESSPL)",
   label: "Espina (ESSPL)"
  },
  {
   value: "Espinal-Auzperri (ESESA)",
   label: "Espinal-Auzperri (ESESA)"
  },
  {
   value: "Espinosa de Los Monteros (ESELM)",
   label: "Espinosa de Los Monteros (ESELM)"
  },
  {
   value: "Espluga de Francolí (ESESG)",
   label: "Espluga de Francolí (ESESG)"
  },
  {
   value: "Esquiroz (ESEQQ)",
   label: "Esquiroz (ESEQQ)"
  },
  {
   value: "Esquivias (ESESQ)",
   label: "Esquivias (ESESQ)"
  },
  {
   value: "Estella\/Lizarra (ESESL)",
   label: "Estella\/Lizarra (ESESL)"
  },
  {
   value: "Etxalar (ESEXR)",
   label: "Etxalar (ESEXR)"
  },
  {
   value: "Etxebarri (ESEXA)",
   label: "Etxebarri (ESEXA)"
  },
  {
   value: "Etxebarria (ESEXB)",
   label: "Etxebarria (ESEXB)"
  },
  {
   value: "Euba (ESEUB)",
   label: "Euba (ESEUB)"
  },
  {
   value: "Ezcaray (ESEZC)",
   label: "Ezcaray (ESEZC)"
  },
  {
   value: "Ezkio-Itsaso (ESEZI)",
   label: "Ezkio-Itsaso (ESEZI)"
  },
  {
   value: "Falces (ESZFE)",
   label: "Falces (ESZFE)"
  },
  {
   value: "Falset (ESFST)",
   label: "Falset (ESFST)"
  },
  {
   value: "Faramontanos de Tábara (ESFDT)",
   label: "Faramontanos de Tábara (ESFDT)"
  },
  {
   value: "Favara (ESFAV)",
   label: "Favara (ESFAV)"
  },
  {
   value: "Fazouro (Santiago) (ESFZO)",
   label: "Fazouro (Santiago) (ESFZO)"
  },
  {
   value: "Figaró (ESFIG)",
   label: "Figaró (ESFIG)"
  },
  {
   value: "Figueroles (ESUER)",
   label: "Figueroles (ESUER)"
  },
  {
   value: "Figueruelas (ESFRS)",
   label: "Figueruelas (ESFRS)"
  },
  {
   value: "Finana (ESFNA)",
   label: "Finana (ESFNA)"
  },
  {
   value: "Fines (ESFIN)",
   label: "Fines (ESFIN)"
  },
  {
   value: "Finestrat (ESZAQ)",
   label: "Finestrat (ESZAQ)"
  },
  {
   value: "Flaca (ESFLA)",
   label: "Flaca (ESFLA)"
  },
  {
   value: "Fogars de la Selva (ESSFA)",
   label: "Fogars de la Selva (ESSFA)"
  },
  {
   value: "Fogars De Montclus (ESFDM)",
   label: "Fogars De Montclus (ESFDM)"
  },
  {
   value: "Fogás de Tordera (ESFGS)",
   label: "Fogás de Tordera (ESFGS)"
  },
  {
   value: "Foios (ESFOS)",
   label: "Foios (ESFOS)"
  },
  {
   value: "Fonelas (ESZAD)",
   label: "Fonelas (ESZAD)"
  },
  {
   value: "Font Rubí (ESFRI)",
   label: "Font Rubí (ESFRI)"
  },
  {
   value: "Fontanar (ESFNT)",
   label: "Fontanar (ESFNT)"
  },
  {
   value: "Fontcoberta (ESZFH)",
   label: "Fontcoberta (ESZFH)"
  },
  {
   value: "Fontiveros (ESIOS)",
   label: "Fontiveros (ESIOS)"
  },
  {
   value: "Formentera (ESFNI)",
   label: "Formentera (ESFNI)"
  },
  {
   value: "Formentera I. (ESFLD)",
   label: "Formentera I. (ESFLD)"
  },
  {
   value: "Foronda (ESFRD)",
   label: "Foronda (ESFRD)"
  },
  {
   value: "Fortuna (ESFTN)",
   label: "Fortuna (ESFTN)"
  },
  {
   value: "Foz (ESZBE)",
   label: "Foz (ESZBE)"
  },
  {
   value: "Frechilla de Almazan (ESFAZ)",
   label: "Frechilla de Almazan (ESFAZ)"
  },
  {
   value: "Fuencubierta (ESZBF)",
   label: "Fuencubierta (ESZBF)"
  },
  {
   value: "Fuente Alamo de Murcia (ESFAM)",
   label: "Fuente Alamo de Murcia (ESFAM)"
  },
  {
   value: "Fuente De Pedro Naharro (ESFDP)",
   label: "Fuente De Pedro Naharro (ESFDP)"
  },
  {
   value: "Fuente del Maestre (ESZFF)",
   label: "Fuente del Maestre (ESZFF)"
  },
  {
   value: "Fuente el Saz de Jarama (ESFDJ)",
   label: "Fuente el Saz de Jarama (ESFDJ)"
  },
  {
   value: "Fuente Vaqueros (ESZFC)",
   label: "Fuente Vaqueros (ESZFC)"
  },
  {
   value: "Fuente-Álamo de Murcia (ESFAO)",
   label: "Fuente-Álamo de Murcia (ESFAO)"
  },
  {
   value: "Fuentejalon (ESFJN)",
   label: "Fuentejalon (ESFJN)"
  },
  {
   value: "Fuentepelayo (ESFUP)",
   label: "Fuentepelayo (ESFUP)"
  },
  {
   value: "Fuentes Claras (ESFCL)",
   label: "Fuentes Claras (ESFCL)"
  },
  {
   value: "Fuentes de Ebro (ESFDE)",
   label: "Fuentes de Ebro (ESFDE)"
  },
  {
   value: "Fundejalón (ESJOZ)",
   label: "Fundejalón (ESJOZ)"
  },
  {
   value: "Fustiñana (ESFUS)",
   label: "Fustiñana (ESFUS)"
  },
  {
   value: "Gajano (ESGAJ)",
   label: "Gajano (ESGAJ)"
  },
  {
   value: "Galapagar (ESGLP)",
   label: "Galapagar (ESGLP)"
  },
  {
   value: "Galdácano (ESGLD)",
   label: "Galdácano (ESGLD)"
  },
  {
   value: "Galdakao (ESGDK)",
   label: "Galdakao (ESGDK)"
  },
  {
   value: "Galdar (ESZFN)",
   label: "Galdar (ESZFN)"
  },
  {
   value: "Gallarta (ESGLT)",
   label: "Gallarta (ESGLT)"
  },
  {
   value: "Gamiz-Fika (ESGZF)",
   label: "Gamiz-Fika (ESGZF)"
  },
  {
   value: "Garidells (ESEGL)",
   label: "Garidells (ESEGL)"
  },
  {
   value: "Garray (ESGAY)",
   label: "Garray (ESGAY)"
  },
  {
   value: "Gatica (ESZBH)",
   label: "Gatica (ESZBH)"
  },
  {
   value: "Gelsa (ESGLS)",
   label: "Gelsa (ESGLS)"
  },
  {
   value: "Gelves (ESZFK)",
   label: "Gelves (ESZFK)"
  },
  {
   value: "Geneva (ESZFM)",
   label: "Geneva (ESZFM)"
  },
  {
   value: "Gerena (ESGEN)",
   label: "Gerena (ESGEN)"
  },
  {
   value: "Getaria (ESGET)",
   label: "Getaria (ESGET)"
  },
  {
   value: "Getaria (ESGTI)",
   label: "Getaria (ESGTI)"
  },
  {
   value: "Gibraleon (ESZFL)",
   label: "Gibraleon (ESZFL)"
  },
  {
   value: "Ginestar (ESGTR)",
   label: "Ginestar (ESGTR)"
  },
  {
   value: "Gironella (ESGIR)",
   label: "Gironella (ESGIR)"
  },
  {
   value: "Godella (ESGDL)",
   label: "Godella (ESGDL)"
  },
  {
   value: "Gondomar (ESZFO)",
   label: "Gondomar (ESZFO)"
  },
  {
   value: "Gordexola (ESZAL)",
   label: "Gordexola (ESZAL)"
  },
  {
   value: "Gordoncillo (ESGCO)",
   label: "Gordoncillo (ESGCO)"
  },
  {
   value: "Gornal (ESGNL)",
   label: "Gornal (ESGNL)"
  },
  {
   value: "Granadilla de Abona (ESGAB)",
   label: "Granadilla de Abona (ESGAB)"
  },
  {
   value: "Granda (ESGRD)",
   label: "Granda (ESGRD)"
  },
  {
   value: "Grandas de Salime (ESZAW)",
   label: "Grandas de Salime (ESZAW)"
  },
  {
   value: "Grañén (ESGRA)",
   label: "Grañén (ESGRA)"
  },
  {
   value: "Grao de Castellon (ESGCN)",
   label: "Grao de Castellon (ESGCN)"
  },
  {
   value: "Gratallops (ESGTP)",
   label: "Gratallops (ESGTP)"
  },
  {
   value: "Grijota (ESZNO)",
   label: "Grijota (ESZNO)"
  },
  {
   value: "Griñón (ESGRI)",
   label: "Griñón (ESGRI)"
  },
  {
   value: "Grove (ESEGR)",
   label: "Grove (ESEGR)"
  },
  {
   value: "Guadalcacin (ESZFI)",
   label: "Guadalcacin (ESZFI)"
  },
  {
   value: "Guadarrama (ESGUR)",
   label: "Guadarrama (ESGUR)"
  },
  {
   value: "Guadasequies (ESGDQ)",
   label: "Guadasequies (ESGDQ)"
  },
  {
   value: "Guadiaro (ESZAY)",
   label: "Guadiaro (ESZAY)"
  },
  {
   value: "Guadix (ESGUX)",
   label: "Guadix (ESGUX)"
  },
  {
   value: "Gualba (ESGBA)",
   label: "Gualba (ESGBA)"
  },
  {
   value: "Guardo (ESGDO)",
   label: "Guardo (ESGDO)"
  },
  {
   value: "Guarena (ESGNA)",
   label: "Guarena (ESGNA)"
  },
  {
   value: "Guarnizo (ESGUN)",
   label: "Guarnizo (ESGUN)"
  },
  {
   value: "Guarromán (ESGRN)",
   label: "Guarromán (ESGRN)"
  },
  {
   value: "Güeñes (ESGNS)",
   label: "Güeñes (ESGNS)"
  },
  {
   value: "Guernica y Luno (ESGUE)",
   label: "Guernica y Luno (ESGUE)"
  },
  {
   value: "Guia De Isora (ESZFJ)",
   label: "Guia De Isora (ESZFJ)"
  },
  {
   value: "Guijuelo (ESJUE)",
   label: "Guijuelo (ESJUE)"
  },
  {
   value: "Guillarey (ESGLR)",
   label: "Guillarey (ESGLR)"
  },
  {
   value: "Guimar (ESZFP)",
   label: "Guimar (ESZFP)"
  },
  {
   value: "Guipuzcoa (ESGUI)",
   label: "Guipuzcoa (ESGUI)"
  },
  {
   value: "Guissona (ESGSA)",
   label: "Guissona (ESGSA)"
  },
  {
   value: "Guitiriz (ESGTZ)",
   label: "Guitiriz (ESGTZ)"
  },
  {
   value: "Gurb (ESGRB)",
   label: "Gurb (ESGRB)"
  },
  {
   value: "Gustey (ESGSY)",
   label: "Gustey (ESGSY)"
  },
  {
   value: "Haro (ESHAR)",
   label: "Haro (ESHAR)"
  },
  {
   value: "Hellín (ESHEL)",
   label: "Hellín (ESHEL)"
  },
  {
   value: "Heras (ESHRS)",
   label: "Heras (ESHRS)"
  },
  {
   value: "Herencia (ESHER)",
   label: "Herencia (ESHER)"
  },
  {
   value: "Hernan Cortes (ESZGF)",
   label: "Hernan Cortes (ESZGF)"
  },
  {
   value: "Higuera La Real (ESHIG)",
   label: "Higuera La Real (ESHIG)"
  },
  {
   value: "Honrubia (ESHNR)",
   label: "Honrubia (ESHNR)"
  },
  {
   value: "Hontoria (ESHON)",
   label: "Hontoria (ESHON)"
  },
  {
   value: "Horta de Avinyo (ESHDA)",
   label: "Horta de Avinyo (ESHDA)"
  },
  {
   value: "Hospital De Orbigo (ESHDO)",
   label: "Hospital De Orbigo (ESHDO)"
  },
  {
   value: "Hostalric (ESZFT)",
   label: "Hostalric (ESZFT)"
  },
  {
   value: "Huarte (ESHRT)",
   label: "Huarte (ESHRT)"
  },
  {
   value: "Huarte (Pamplona) (ESHUT)",
   label: "Huarte (Pamplona) (ESHUT)"
  },
  {
   value: "Huércal de Almería (ESHAD)",
   label: "Huércal de Almería (ESHAD)"
  },
  {
   value: "Huercal Overa (ESZFS)",
   label: "Huercal Overa (ESZFS)"
  },
  {
   value: "Huércanos (ESHUE)",
   label: "Huércanos (ESHUE)"
  },
  {
   value: "Huescar (ESZAV)",
   label: "Huescar (ESZAV)"
  },
  {
   value: "Hueva (ESHEV)",
   label: "Hueva (ESHEV)"
  },
  {
   value: "Humanes (ESHMM)",
   label: "Humanes (ESHMM)"
  },
  {
   value: "Humanes de Mohernando (ESHDM)",
   label: "Humanes de Mohernando (ESHDM)"
  },
  {
   value: "Húmera (ESHMR)",
   label: "Húmera (ESHMR)"
  },
  {
   value: "Humilladero (ESHUR)",
   label: "Humilladero (ESHUR)"
  },
  {
   value: "Ibi (ESIBI)",
   label: "Ibi (ESIBI)"
  },
  {
   value: "Ibiricu (ESIBU)",
   label: "Ibiricu (ESIBU)"
  },
  {
   value: "Ibiricu (ESIEG)",
   label: "Ibiricu (ESIEG)"
  },
  {
   value: "Ibros (ESIBR)",
   label: "Ibros (ESIBR)"
  },
  {
   value: "Icod de los Vinos (ESIDL)",
   label: "Icod de los Vinos (ESIDL)"
  },
  {
   value: "Idiazábal (ESIZL)",
   label: "Idiazábal (ESIZL)"
  },
  {
   value: "Igea (ESIGE)",
   label: "Igea (ESIGE)"
  },
  {
   value: "Igorre (ESIGO)",
   label: "Igorre (ESIGO)"
  },
  {
   value: "Igualada (ESIGL)",
   label: "Igualada (ESIGL)"
  },
  {
   value: "Illescas (ESILS)",
   label: "Illescas (ESILS)"
  },
  {
   value: "Inca (ESNCA)",
   label: "Inca (ESNCA)"
  },
  {
   value: "Iniesta (ESIST)",
   label: "Iniesta (ESIST)"
  },
  {
   value: "Irura (ESIRR)",
   label: "Irura (ESIRR)"
  },
  {
   value: "Irurtzun (ESIRZ)",
   label: "Irurtzun (ESIRZ)"
  },
  {
   value: "Iscar (ESISC)",
   label: "Iscar (ESISC)"
  },
  {
   value: "Isla Cristina (ESZGA)",
   label: "Isla Cristina (ESZGA)"
  },
  {
   value: "Isla Mayor (ESZFY)",
   label: "Isla Mayor (ESZFY)"
  },
  {
   value: "Iturriotz (ESITR)",
   label: "Iturriotz (ESITR)"
  },
  {
   value: "Itziar (ESZFV)",
   label: "Itziar (ESZFV)"
  },
  {
   value: "Iurreta (ESIUA)",
   label: "Iurreta (ESIUA)"
  },
  {
   value: "Izarra (ESIZA)",
   label: "Izarra (ESIZA)"
  },
  {
   value: "Iznalloz (ESIZN)",
   label: "Iznalloz (ESIZN)"
  },
  {
   value: "Izurza (ESIRA)",
   label: "Izurza (ESIRA)"
  },
  {
   value: "Jabalí Viejo (ESJLN)",
   label: "Jabalí Viejo (ESJLN)"
  },
  {
   value: "Jabugo (ESZGB)",
   label: "Jabugo (ESZGB)"
  },
  {
   value: "Jaca (ESJAC)",
   label: "Jaca (ESJAC)"
  },
  {
   value: "Jalón (ESLZK)",
   label: "Jalón (ESLZK)"
  },
  {
   value: "Jamilena (ESZGC)",
   label: "Jamilena (ESZGC)"
  },
  {
   value: "Jarandilla de la Vera (ESJRN)",
   label: "Jarandilla de la Vera (ESJRN)"
  },
  {
   value: "Javali Nuevo (ESZGD)",
   label: "Javali Nuevo (ESZGD)"
  },
  {
   value: "Jimenado (ESZKB)",
   label: "Jimenado (ESZKB)"
  },
  {
   value: "Jorba (ESJRB)",
   label: "Jorba (ESJRB)"
  },
  {
   value: "Juià (ESJIA)",
   label: "Juià (ESJIA)"
  },
  {
   value: "Juneda (ESJUN)",
   label: "Juneda (ESJUN)"
  },
  {
   value: "La Alberca (ESLAC)",
   label: "La Alberca (ESLAC)"
  },
  {
   value: "La Aldeilla (ESZGS)",
   label: "La Aldeilla (ESZGS)"
  },
  {
   value: "La Aljorra (ESLAL)",
   label: "La Aljorra (ESLAL)"
  },
  {
   value: "La Almunia de Dona Godina (ESZHA)",
   label: "La Almunia de Dona Godina (ESZHA)"
  },
  {
   value: "La Ampolla (ESLAA)",
   label: "La Ampolla (ESLAA)"
  },
  {
   value: "La Aparecida (ESZKI)",
   label: "La Aparecida (ESZKI)"
  },
  {
   value: "La Barca Florida (ESZGJ)",
   label: "La Barca Florida (ESZGJ)"
  },
  {
   value: "La Batlloria (ESBAT)",
   label: "La Batlloria (ESBAT)"
  },
  {
   value: "La Bisbal del Penèdes (ESBPS)",
   label: "La Bisbal del Penèdes (ESBPS)"
  },
  {
   value: "La Campana (ESLCA)",
   label: "La Campana (ESLCA)"
  },
  {
   value: "La Cañada (ESLCN)",
   label: "La Cañada (ESLCN)"
  },
  {
   value: "La Canonja (ESZGU)",
   label: "La Canonja (ESZGU)"
  },
  {
   value: "La Chirivella (ESCVE)",
   label: "La Chirivella (ESCVE)"
  },
  {
   value: "La Cisterniga (ESCNG)",
   label: "La Cisterniga (ESCNG)"
  },
  {
   value: "La Estrada (ESETR)",
   label: "La Estrada (ESETR)"
  },
  {
   value: "La Felguera (ESLFG)",
   label: "La Felguera (ESLFG)"
  },
  {
   value: "La Galera (ESZHK)",
   label: "La Galera (ESZHK)"
  },
  {
   value: "La Granada (ESZGW)",
   label: "La Granada (ESZGW)"
  },
  {
   value: "La Guardia (ESAGD)",
   label: "La Guardia (ESAGD)"
  },
  {
   value: "La Junquera (ESLJU)",
   label: "La Junquera (ESLJU)"
  },
  {
   value: "La Matanza (ESMAT)",
   label: "La Matanza (ESMAT)"
  },
  {
   value: "La Minosa (ESLMN)",
   label: "La Minosa (ESLMN)"
  },
  {
   value: "La Mojonera (ESZKD)",
   label: "La Mojonera (ESZKD)"
  },
  {
   value: "La Muela (ESLAM)",
   label: "La Muela (ESLAM)"
  },
  {
   value: "La Nucía (ESLNC)",
   label: "La Nucía (ESLNC)"
  },
  {
   value: "La Orotava (ESZHL)",
   label: "La Orotava (ESZHL)"
  },
  {
   value: "La Palma de Cervelló (ESPDC)",
   label: "La Palma de Cervelló (ESPDC)"
  },
  {
   value: "La Penilla (ESILL)",
   label: "La Penilla (ESILL)"
  },
  {
   value: "La Penilla de Cayon (ESZHG)",
   label: "La Penilla de Cayon (ESZHG)"
  },
  {
   value: "La Pobla de Claramunt (ESLPR)",
   label: "La Pobla de Claramunt (ESLPR)"
  },
  {
   value: "La Pobla de Mafumet (ESLPM)",
   label: "La Pobla de Mafumet (ESLPM)"
  },
  {
   value: "La Pobla de Segur (ESPSU)",
   label: "La Pobla de Segur (ESPSU)"
  },
  {
   value: "La Pobla de Vallbona (ESLPO)",
   label: "La Pobla de Vallbona (ESLPO)"
  },
  {
   value: "La Puebla de Cazalla (ESLPZ)",
   label: "La Puebla de Cazalla (ESLPZ)"
  },
  {
   value: "La Puebla Del Rio (ESZHI)",
   label: "La Puebla Del Rio (ESZHI)"
  },
  {
   value: "La Rabita (ESZGN)",
   label: "La Rabita (ESZGN)"
  },
  {
   value: "La Rambla (ESLRA)",
   label: "La Rambla (ESLRA)"
  },
  {
   value: "La Robla (ESROB)",
   label: "La Robla (ESROB)"
  },
  {
   value: "La Roca del Vallès (ESRVA)",
   label: "La Roca del Vallès (ESRVA)"
  },
  {
   value: "La Roda (ESLRD)",
   label: "La Roda (ESLRD)"
  },
  {
   value: "La Selva Del Campo (ESZLF)",
   label: "La Selva Del Campo (ESZLF)"
  },
  {
   value: "La Senia (ESLSE)",
   label: "La Senia (ESLSE)"
  },
  {
   value: "La Union (ESZHM)",
   label: "La Union (ESZHM)"
  },
  {
   value: "La Victoria (ESZDV)",
   label: "La Victoria (ESZDV)"
  },
  {
   value: "Lachar (ESZGP)",
   label: "Lachar (ESZGP)"
  },
  {
   value: "Lada (ESLAD)",
   label: "Lada (ESLAD)"
  },
  {
   value: "Lagos (ESZGM)",
   label: "Lagos (ESZGM)"
  },
  {
   value: "Laguardia (ESLGA)",
   label: "Laguardia (ESLGA)"
  },
  {
   value: "Laguna de Duero (ESLGD)",
   label: "Laguna de Duero (ESLGD)"
  },
  {
   value: "Lalín (ESLLN)",
   label: "Lalín (ESLLN)"
  },
  {
   value: "Lamadrid (ESLMD)",
   label: "Lamadrid (ESLMD)"
  },
  {
   value: "Lanciego (ESLAN)",
   label: "Lanciego (ESLAN)"
  },
  {
   value: "Langreo (ESLAG)",
   label: "Langreo (ESLAG)"
  },
  {
   value: "Lantaron (ESRON)",
   label: "Lantaron (ESRON)"
  },
  {
   value: "Lapuebla de Labarca (ESLAP)",
   label: "Lapuebla de Labarca (ESLAP)"
  },
  {
   value: "Laracha (ESZJK)",
   label: "Laracha (ESZJK)"
  },
  {
   value: "Lardero (ESLRR)",
   label: "Lardero (ESLRR)"
  },
  {
   value: "Laredo (ESLDO)",
   label: "Laredo (ESLDO)"
  },
  {
   value: "Larrabetzu (ESLBZ)",
   label: "Larrabetzu (ESLBZ)"
  },
  {
   value: "Larrabezua (ESZES)",
   label: "Larrabezua (ESZES)"
  },
  {
   value: "Las Gabias (ESZGV)",
   label: "Las Gabias (ESZGV)"
  },
  {
   value: "Las Galletas (ESZBB)",
   label: "Las Galletas (ESZBB)"
  },
  {
   value: "Las Labores (ESLLS)",
   label: "Las Labores (ESLLS)"
  },
  {
   value: "Las Mesas (ESSSS)",
   label: "Las Mesas (ESSSS)"
  },
  {
   value: "Las Palas (ESZHF)",
   label: "Las Palas (ESZHF)"
  },
  {
   value: "Las Rozas de Madrid (ESLRO)",
   label: "Las Rozas de Madrid (ESLRO)"
  },
  {
   value: "Las Ventas De Retamosa (ESZHN)",
   label: "Las Ventas De Retamosa (ESZHN)"
  },
  {
   value: "Lazcano (ESZGK)",
   label: "Lazcano (ESZGK)"
  },
  {
   value: "Lazkao (ESMRT)",
   label: "Lazkao (ESMRT)"
  },
  {
   value: "Lecumberri (ESLEC)",
   label: "Lecumberri (ESLEC)"
  },
  {
   value: "Leganés (ESLEG)",
   label: "Leganés (ESLEG)"
  },
  {
   value: "Legorreta (ESLGT)",
   label: "Legorreta (ESLGT)"
  },
  {
   value: "Legutiano (ESLGU)",
   label: "Legutiano (ESLGU)"
  },
  {
   value: "Leioa (ESLEZ)",
   label: "Leioa (ESLEZ)"
  },
  {
   value: "Leiza (ESZHP)",
   label: "Leiza (ESZHP)"
  },
  {
   value: "Lekunberri (ESLKB)",
   label: "Lekunberri (ESLKB)"
  },
  {
   value: "Lemoa (ESZMS)",
   label: "Lemoa (ESZMS)"
  },
  {
   value: "Lemona (ESLMA)",
   label: "Lemona (ESLMA)"
  },
  {
   value: "Lendinez (ESZGQ)",
   label: "Lendinez (ESZGQ)"
  },
  {
   value: "Lérez (ESLER)",
   label: "Lérez (ESLER)"
  },
  {
   value: "Lerin (ESLIN)",
   label: "Lerin (ESLIN)"
  },
  {
   value: "Les (ESLEX)",
   label: "Les (ESLEX)"
  },
  {
   value: "Les Franqueses del Vallès (ESFQV)",
   label: "Les Franqueses del Vallès (ESFQV)"
  },
  {
   value: "Les Masies de Roda (ESZHB)",
   label: "Les Masies de Roda (ESZHB)"
  },
  {
   value: "Les Preses (ESZGT)",
   label: "Les Preses (ESZGT)"
  },
  {
   value: "Lezama (ESLZA)",
   label: "Lezama (ESLZA)"
  },
  {
   value: "Lezo (ESLEO)",
   label: "Lezo (ESLEO)"
  },
  {
   value: "Lizartza (ESLIT)",
   label: "Lizartza (ESLIT)"
  },
  {
   value: "Llagostera (ESLLG)",
   label: "Llagostera (ESLLG)"
  },
  {
   value: "Llambilles (ESLMS)",
   label: "Llambilles (ESLMS)"
  },
  {
   value: "Llanca (ESLLC)",
   label: "Llanca (ESLLC)"
  },
  {
   value: "Llanera (ESZOJ)",
   label: "Llanera (ESZOJ)"
  },
  {
   value: "Llers (ESLSS)",
   label: "Llers (ESLSS)"
  },
  {
   value: "Lliria (ESLLR)",
   label: "Lliria (ESLLR)"
  },
  {
   value: "Llissa de Munt (ESZGY)",
   label: "Llissa de Munt (ESZGY)"
  },
  {
   value: "Lloreda (ESLLA)",
   label: "Lloreda (ESLLA)"
  },
  {
   value: "Lloret de Mar (ESLLO)",
   label: "Lloret de Mar (ESLLO)"
  },
  {
   value: "Llosa de Ranes (ESLDR)",
   label: "Llosa de Ranes (ESLDR)"
  },
  {
   value: "Lluçà (ESLUC)",
   label: "Lluçà (ESLUC)"
  },
  {
   value: "Lobon (ESZHE)",
   label: "Lobon (ESZHE)"
  },
  {
   value: "Lobosillo (ESZHD)",
   label: "Lobosillo (ESZHD)"
  },
  {
   value: "Lobres (ESLBS)",
   label: "Lobres (ESLBS)"
  },
  {
   value: "Lodosa (ESLDS)",
   label: "Lodosa (ESLDS)"
  },
  {
   value: "Loeches (ESLCS)",
   label: "Loeches (ESLCS)"
  },
  {
   value: "Loiu (ESLOI)",
   label: "Loiu (ESLOI)"
  },
  {
   value: "Loja (ESLJA)",
   label: "Loja (ESLJA)"
  },
  {
   value: "Lominchar (ESLCH)",
   label: "Lominchar (ESLCH)"
  },
  {
   value: "Longares (ESLON)",
   label: "Longares (ESLON)"
  },
  {
   value: "Los Arcos (ESLAO)",
   label: "Los Arcos (ESLAO)"
  },
  {
   value: "Los Corrales de Buelna (ESLOC)",
   label: "Los Corrales de Buelna (ESLOC)"
  },
  {
   value: "Los Hueros (ESZGX)",
   label: "Los Hueros (ESZGX)"
  },
  {
   value: "Los Rábanos (ESLRN)",
   label: "Los Rábanos (ESLRN)"
  },
  {
   value: "Los Rodeos la Laguna (ESLRL)",
   label: "Los Rodeos la Laguna (ESLRL)"
  },
  {
   value: "Los Rosales (ESRSS)",
   label: "Los Rosales (ESRSS)"
  },
  {
   value: "Los Santos de la Humosa (ESLSD)",
   label: "Los Santos de la Humosa (ESLSD)"
  },
  {
   value: "Los Santos de Maimona (ESZNU)",
   label: "Los Santos de Maimona (ESZNU)"
  },
  {
   value: "Los Silos (ESLSI)",
   label: "Los Silos (ESLSI)"
  },
  {
   value: "Los Villares (ESZND)",
   label: "Los Villares (ESZND)"
  },
  {
   value: "Los Yébenes (ESLOY)",
   label: "Los Yébenes (ESLOY)"
  },
  {
   value: "Lourizán (ESLOU)",
   label: "Lourizán (ESLOU)"
  },
  {
   value: "Luarca (ESLUA)",
   label: "Luarca (ESLUA)"
  },
  {
   value: "Lugo (ESLGO)",
   label: "Lugo (ESLGO)"
  },
  {
   value: "Lugo de Llanera (ESLLL)",
   label: "Lugo de Llanera (ESLLL)"
  },
  {
   value: "Luque (ESLUQ)",
   label: "Luque (ESLUQ)"
  },
  {
   value: "Macanet de la Selva (ESMAC)",
   label: "Macanet de la Selva (ESMAC)"
  },
  {
   value: "Madridejos (ESMRJ)",
   label: "Madridejos (ESMRJ)"
  },
  {
   value: "Madrigueras (ESZIO)",
   label: "Madrigueras (ESZIO)"
  },
  {
   value: "Maestu (ESMAE)",
   label: "Maestu (ESMAE)"
  },
  {
   value: "Magdalena del Pulpis (ESSMP)",
   label: "Magdalena del Pulpis (ESSMP)"
  },
  {
   value: "Mairena de Aljarafe (ESZHV)",
   label: "Mairena de Aljarafe (ESZHV)"
  },
  {
   value: "Majadahonda (ESZIB)",
   label: "Majadahonda (ESZIB)"
  },
  {
   value: "Majadas (ESMJS)",
   label: "Majadas (ESMJS)"
  },
  {
   value: "Malgrat de Mar (ESMMA)",
   label: "Malgrat de Mar (ESMMA)"
  },
  {
   value: "Maliaño (ESMLO)",
   label: "Maliaño (ESMLO)"
  },
  {
   value: "Mallabia (ESMAV)",
   label: "Mallabia (ESMAV)"
  },
  {
   value: "Malpica de Tajo (ESMPT)",
   label: "Malpica de Tajo (ESMPT)"
  },
  {
   value: "Mambrilla de Castrejón (ESMCA)",
   label: "Mambrilla de Castrejón (ESMCA)"
  },
  {
   value: "Manacor (ESMAN)",
   label: "Manacor (ESMAN)"
  },
  {
   value: "Manan (ESMNN)",
   label: "Manan (ESMNN)"
  },
  {
   value: "Mansilla de las Mulas (ESMMS)",
   label: "Mansilla de las Mulas (ESMMS)"
  },
  {
   value: "Manuel (ESZNY)",
   label: "Manuel (ESZNY)"
  },
  {
   value: "Manzanares el Real (ESMZR)",
   label: "Manzanares el Real (ESMZR)"
  },
  {
   value: "Maqueda (ESMAQ)",
   label: "Maqueda (ESMAQ)"
  },
  {
   value: "Marchamalo (ESZIC)",
   label: "Marchamalo (ESZIC)"
  },
  {
   value: "Marcilla (ESMCL)",
   label: "Marcilla (ESMCL)"
  },
  {
   value: "Marcon (ESZIJ)",
   label: "Marcon (ESZIJ)"
  },
  {
   value: "María de Huerva (ESMDH)",
   label: "María de Huerva (ESMDH)"
  },
  {
   value: "Marín (ESMAR)",
   label: "Marín (ESMAR)"
  },
  {
   value: "Markina Xemein (ESZHU)",
   label: "Markina Xemein (ESZHU)"
  },
  {
   value: "Marratxi (ESMRR)",
   label: "Marratxi (ESMRR)"
  },
  {
   value: "Martorelles (ESMRO)",
   label: "Martorelles (ESMRO)"
  },
  {
   value: "Masalaves (ESZHO)",
   label: "Masalaves (ESZHO)"
  },
  {
   value: "Masamagrell (ESMAG)",
   label: "Masamagrell (ESMAG)"
  },
  {
   value: "Masllorenc (ESZIL)",
   label: "Masllorenc (ESZIL)"
  },
  {
   value: "Maspalomas (ESMPA)",
   label: "Maspalomas (ESMPA)"
  },
  {
   value: "Masquefa (ESMSQ)",
   label: "Masquefa (ESMSQ)"
  },
  {
   value: "Massanassa (ESMAS)",
   label: "Massanassa (ESMAS)"
  },
  {
   value: "Matapozuelos (ESMZL)",
   label: "Matapozuelos (ESMZL)"
  },
  {
   value: "Meano (ESMAO)",
   label: "Meano (ESMAO)"
  },
  {
   value: "Meco (ESMEC)",
   label: "Meco (ESMEC)"
  },
  {
   value: "Medina de Ríoseco (ESMDR)",
   label: "Medina de Ríoseco (ESMDR)"
  },
  {
   value: "Meis (ESZHY)",
   label: "Meis (ESZHY)"
  },
  {
   value: "Mejorada del Campo (ESMCP)",
   label: "Mejorada del Campo (ESMCP)"
  },
  {
   value: "Meliana (ESMIL)",
   label: "Meliana (ESMIL)"
  },
  {
   value: "Melide (ESMLI)",
   label: "Melide (ESMLI)"
  },
  {
   value: "Mendavia (ESMEN)",
   label: "Mendavia (ESMEN)"
  },
  {
   value: "Meres (ESMER)",
   label: "Meres (ESMER)"
  },
  {
   value: "Mérida (ESMEA)",
   label: "Mérida (ESMEA)"
  },
  {
   value: "Mieres (ESMRE)",
   label: "Mieres (ESMRE)"
  },
  {
   value: "Mijas (ESMJC)",
   label: "Mijas (ESMJC)"
  },
  {
   value: "Milagro (ESMGO)",
   label: "Milagro (ESMGO)"
  },
  {
   value: "Milagro (ESMLR)",
   label: "Milagro (ESMLR)"
  },
  {
   value: "Milagros (ESMGS)",
   label: "Milagros (ESMGS)"
  },
  {
   value: "Minano Mayor (ESZCW)",
   label: "Minano Mayor (ESZCW)"
  },
  {
   value: "Minas de Riotinto (ESZKR)",
   label: "Minas de Riotinto (ESZKR)"
  },
  {
   value: "Mirabel (ESMRB)",
   label: "Mirabel (ESMRB)"
  },
  {
   value: "Miravalles (ESMVS)",
   label: "Miravalles (ESMVS)"
  },
  {
   value: "Mogan (ESZIH)",
   label: "Mogan (ESZIH)"
  },
  {
   value: "Moia (ESZII)",
   label: "Moia (ESZII)"
  },
  {
   value: "Mojácar (ESMOJ)",
   label: "Mojácar (ESMOJ)"
  },
  {
   value: "Mojados (ESMJD)",
   label: "Mojados (ESMJD)"
  },
  {
   value: "Mollet del Valles (ESMDV)",
   label: "Mollet del Valles (ESMDV)"
  },
  {
   value: "Mollet del Vallès (ESMLV)",
   label: "Mollet del Vallès (ESMLV)"
  },
  {
   value: "Monda (ESZIE)",
   label: "Monda (ESZIE)"
  },
  {
   value: "Mondariz-Balneario (ESMBO)",
   label: "Mondariz-Balneario (ESMBO)"
  },
  {
   value: "Mondéjar (ESMDJ)",
   label: "Mondéjar (ESMDJ)"
  },
  {
   value: "Mondragón (ESMON)",
   label: "Mondragón (ESMON)"
  },
  {
   value: "Monforte de Lemos (ESMFL)",
   label: "Monforte de Lemos (ESMFL)"
  },
  {
   value: "Monfrague (ESMFG)",
   label: "Monfrague (ESMFG)"
  },
  {
   value: "Monistrol Montserrat (ESZIK)",
   label: "Monistrol Montserrat (ESZIK)"
  },
  {
   value: "Monreal del Campo (ESMRD)",
   label: "Monreal del Campo (ESMRD)"
  },
  {
   value: "Montalban de Cordoba (ESZHW)",
   label: "Montalban de Cordoba (ESZHW)"
  },
  {
   value: "Montanchez (ESZIN)",
   label: "Montanchez (ESZIN)"
  },
  {
   value: "Montblanc (ESMTC)",
   label: "Montblanc (ESMTC)"
  },
  {
   value: "Montehermoso (ESMOH)",
   label: "Montehermoso (ESMOH)"
  },
  {
   value: "Montequinto (ESZID)",
   label: "Montequinto (ESZID)"
  },
  {
   value: "Monterroso (ESMSO)",
   label: "Monterroso (ESMSO)"
  },
  {
   value: "Montesquiu (ESMTQ)",
   label: "Montesquiu (ESMTQ)"
  },
  {
   value: "Montiel (ESMOI)",
   label: "Montiel (ESMOI)"
  },
  {
   value: "Montmeló (ESMTM)",
   label: "Montmeló (ESMTM)"
  },
  {
   value: "Mont-ras (ESMTR)",
   label: "Mont-ras (ESMTR)"
  },
  {
   value: "Monzón (ESMZN)",
   label: "Monzón (ESMZN)"
  },
  {
   value: "Mora De Rubielos (ESMBL)",
   label: "Mora De Rubielos (ESMBL)"
  },
  {
   value: "Moraleja De Enmedio (ESZIG)",
   label: "Moraleja De Enmedio (ESZIG)"
  },
  {
   value: "Morales de Toro (ESMLT)",
   label: "Morales de Toro (ESMLT)"
  },
  {
   value: "Morata de Tajuña (ESMTJ)",
   label: "Morata de Tajuña (ESMTJ)"
  },
  {
   value: "Morayra (ESMRA)",
   label: "Morayra (ESMRA)"
  },
  {
   value: "Moreda (ESMAY)",
   label: "Moreda (ESMAY)"
  },
  {
   value: "Moriscos (ESZIA)",
   label: "Moriscos (ESZIA)"
  },
  {
   value: "Mos (ESMOS)",
   label: "Mos (ESMOS)"
  },
  {
   value: "Mos (ESMOX)",
   label: "Mos (ESMOX)"
  },
  {
   value: "Motrico Mutriku (ESZIM)",
   label: "Motrico Mutriku (ESZIM)"
  },
  {
   value: "Mozarbez (ESMZZ)",
   label: "Mozarbez (ESMZZ)"
  },
  {
   value: "Muchamiel (ESMCM)",
   label: "Muchamiel (ESMCM)"
  },
  {
   value: "Muel (ESMEL)",
   label: "Muel (ESMEL)"
  },
  {
   value: "Mundaca (ESDAC)",
   label: "Mundaca (ESDAC)"
  },
  {
   value: "Munguía (ESMUN)",
   label: "Munguía (ESMUN)"
  },
  {
   value: "Murchante (ESMUR)",
   label: "Murchante (ESMUR)"
  },
  {
   value: "Murcia (ESMJV)",
   label: "Murcia (ESMJV)"
  },
  {
   value: "Murga (ESZHT)",
   label: "Murga (ESZHT)"
  },
  {
   value: "Murieta (ESOAR)",
   label: "Murieta (ESOAR)"
  },
  {
   value: "Muskiz (ESMKZ)",
   label: "Muskiz (ESMKZ)"
  },
  {
   value: "Mutilva Alta (ESMUA)",
   label: "Mutilva Alta (ESMUA)"
  },
  {
   value: "Mutilva Baja (ESMTB)",
   label: "Mutilva Baja (ESMTB)"
  },
  {
   value: "Mutriku (ESMTU)",
   label: "Mutriku (ESMTU)"
  },
  {
   value: "Muxika (ESMXK)",
   label: "Muxika (ESMXK)"
  },
  {
   value: "Naharros (ESZIQ)",
   label: "Naharros (ESZIQ)"
  },
  {
   value: "Najera (ESNJE)",
   label: "Najera (ESNJE)"
  },
  {
   value: "Najera (ESNJR)",
   label: "Najera (ESNJR)"
  },
  {
   value: "Nanclares de la Oca (ESNAN)",
   label: "Nanclares de la Oca (ESNAN)"
  },
  {
   value: "Náquera (ESNAQ)",
   label: "Náquera (ESNAQ)"
  },
  {
   value: "Narón (ESNAR)",
   label: "Narón (ESNAR)"
  },
  {
   value: "Navalcarnero (ESNVC)",
   label: "Navalcarnero (ESNVC)"
  },
  {
   value: "Navalmanzano (ESNMZ)",
   label: "Navalmanzano (ESNMZ)"
  },
  {
   value: "Navalvillar de Pela (ESNDP)",
   label: "Navalvillar de Pela (ESNDP)"
  },
  {
   value: "Navarrete (ESNAJ)",
   label: "Navarrete (ESNAJ)"
  },
  {
   value: "Navarrete (ESNVT)",
   label: "Navarrete (ESNVT)"
  },
  {
   value: "Nerva (ESZIR)",
   label: "Nerva (ESZIR)"
  },
  {
   value: "Niebla (ESNIE)",
   label: "Niebla (ESNIE)"
  },
  {
   value: "Níjar (ESNIJ)",
   label: "Níjar (ESNIJ)"
  },
  {
   value: "Noia (ESNOA)",
   label: "Noia (ESNOA)"
  },
  {
   value: "Norena (ESNOR)",
   label: "Norena (ESNOR)"
  },
  {
   value: "Noves (ESNVS)",
   label: "Noves (ESNVS)"
  },
  {
   value: "Nueva Andalucia (ESZER)",
   label: "Nueva Andalucia (ESZER)"
  },
  {
   value: "Numancia de la Sagra (ESNDS)",
   label: "Numancia de la Sagra (ESNDS)"
  },
  {
   value: "O Carballino (ESOCB)",
   label: "O Carballino (ESOCB)"
  },
  {
   value: "O Covento (Poio) (ESOCV)",
   label: "O Covento (Poio) (ESOCV)"
  },
  {
   value: "O Rosal (ESZGI)",
   label: "O Rosal (ESZGI)"
  },
  {
   value: "Obanos (ESONS)",
   label: "Obanos (ESONS)"
  },
  {
   value: "Ocaña (ESOCA)",
   label: "Ocaña (ESOCA)"
  },
  {
   value: "Odena (ESODE)",
   label: "Odena (ESODE)"
  },
  {
   value: "Ogijares (ESZIV)",
   label: "Ogijares (ESZIV)"
  },
  {
   value: "Oiartzun (Elizalde) (ESOZN)",
   label: "Oiartzun (Elizalde) (ESOZN)"
  },
  {
   value: "Oion (ESZJE)",
   label: "Oion (ESZJE)"
  },
  {
   value: "Okondo (ESZIW)",
   label: "Okondo (ESZIW)"
  },
  {
   value: "Olaberría (ESOLA)",
   label: "Olaberría (ESOLA)"
  },
  {
   value: "Olazagutía (ESOLZ)",
   label: "Olazagutía (ESOLZ)"
  },
  {
   value: "Oleiros (ESORS)",
   label: "Oleiros (ESORS)"
  },
  {
   value: "Olérdola (ESOLE)",
   label: "Olérdola (ESOLE)"
  },
  {
   value: "Olesa de Bonesvalls (ESOLS)",
   label: "Olesa de Bonesvalls (ESOLS)"
  },
  {
   value: "Olite (ESOIT)",
   label: "Olite (ESOIT)"
  },
  {
   value: "Olius (ESZIX)",
   label: "Olius (ESZIX)"
  },
  {
   value: "Ollauri (ESOLU)",
   label: "Ollauri (ESOLU)"
  },
  {
   value: "Olmedo (ESOLM)",
   label: "Olmedo (ESOLM)"
  },
  {
   value: "Ólvega (ESOVA)",
   label: "Ólvega (ESOVA)"
  },
  {
   value: "Olvera (ESOVR)",
   label: "Olvera (ESOVR)"
  },
  {
   value: "Oñate (ESONI)",
   label: "Oñate (ESONI)"
  },
  {
   value: "Ondara (ESOGY)",
   label: "Ondara (ESOGY)"
  },
  {
   value: "Ontígola (ESOGA)",
   label: "Ontígola (ESOGA)"
  },
  {
   value: "Onton (ESZIY)",
   label: "Onton (ESZIY)"
  },
  {
   value: "Onzonilla (ESONZ)",
   label: "Onzonilla (ESONZ)"
  },
  {
   value: "Orcoyen (ESORY)",
   label: "Orcoyen (ESORY)"
  },
  {
   value: "Ordes (ESORD)",
   label: "Ordes (ESORD)"
  },
  {
   value: "Ordis (ESODS)",
   label: "Ordis (ESODS)"
  },
  {
   value: "Ordizia (ESZIU)",
   label: "Ordizia (ESZIU)"
  },
  {
   value: "Organyà (ESPGR)",
   label: "Organyà (ESPGR)"
  },
  {
   value: "Orgaz (ESORG)",
   label: "Orgaz (ESORG)"
  },
  {
   value: "Orio (ESORI)",
   label: "Orio (ESORI)"
  },
  {
   value: "Oronoz (ESORZ)",
   label: "Oronoz (ESORZ)"
  },
  {
   value: "Oropesa (ESOPA)",
   label: "Oropesa (ESOPA)"
  },
  {
   value: "Oroso (ESOSR)",
   label: "Oroso (ESOSR)"
  },
  {
   value: "Ortuella (ESORT)",
   label: "Ortuella (ESORT)"
  },
  {
   value: "Osso de Cinca (ESZJC)",
   label: "Osso de Cinca (ESZJC)"
  },
  {
   value: "Otero de Rey (ESODR)",
   label: "Otero de Rey (ESODR)"
  },
  {
   value: "Otxandio (ESOXD)",
   label: "Otxandio (ESOXD)"
  },
  {
   value: "Outeiro (ESZJB)",
   label: "Outeiro (ESZJB)"
  },
  {
   value: "Oyón (ESOYN)",
   label: "Oyón (ESOYN)"
  },
  {
   value: "Padrón (ESPAD)",
   label: "Padrón (ESPAD)"
  },
  {
   value: "Pajara Fuerteventura (ESPAF)",
   label: "Pajara Fuerteventura (ESPAF)"
  },
  {
   value: "Palafrugell (ESPFL)",
   label: "Palafrugell (ESPFL)"
  },
  {
   value: "Palmones (ESPMN)",
   label: "Palmones (ESPMN)"
  },
  {
   value: "Palol de Rebardit (ESPAR)",
   label: "Palol de Rebardit (ESPAR)"
  },
  {
   value: "Palomar (ESPLM)",
   label: "Palomar (ESPLM)"
  },
  {
   value: "Pals (ESPLS)",
   label: "Pals (ESPLS)"
  },
  {
   value: "Paracuellos de Jarama (ESPAU)",
   label: "Paracuellos de Jarama (ESPAU)"
  },
  {
   value: "Paradela (ESPDM)",
   label: "Paradela (ESPDM)"
  },
  {
   value: "Parque Empresarial Pereiro de Aguiar (ESPEP)",
   label: "Parque Empresarial Pereiro de Aguiar (ESPEP)"
  },
  {
   value: "Pasai San Pedro (ESZJR)",
   label: "Pasai San Pedro (ESZJR)"
  },
  {
   value: "Pastriz (ESPSZ)",
   label: "Pastriz (ESPSZ)"
  },
  {
   value: "Pazos de Borben (ESBZB)",
   label: "Pazos de Borben (ESBZB)"
  },
  {
   value: "Pedreguer (ESPLH)",
   label: "Pedreguer (ESPLH)"
  },
  {
   value: "Pedro Abad (ESZFU)",
   label: "Pedro Abad (ESZFU)"
  },
  {
   value: "Pedro Muñoz (ESPEM)",
   label: "Pedro Muñoz (ESPEM)"
  },
  {
   value: "Pedrola (ESPED)",
   label: "Pedrola (ESPED)"
  },
  {
   value: "Pedrosa de Duero (ESPDP)",
   label: "Pedrosa de Duero (ESPDP)"
  },
  {
   value: "Penafiel (ESPNF)",
   label: "Penafiel (ESPNF)"
  },
  {
   value: "Penaranda de Bracamonte (ESPBM)",
   label: "Penaranda de Bracamonte (ESPBM)"
  },
  {
   value: "Pepino (ESPPO)",
   label: "Pepino (ESPPO)"
  },
  {
   value: "Perafita (ESPFA)",
   label: "Perafita (ESPFA)"
  },
  {
   value: "Peralta (ESPAA)",
   label: "Peralta (ESPAA)"
  },
  {
   value: "Peralta de Alcofea (ESPAO)",
   label: "Peralta de Alcofea (ESPAO)"
  },
  {
   value: "Pereiro de Aguiar (ESPAG)",
   label: "Pereiro de Aguiar (ESPAG)"
  },
  {
   value: "Piedrala (ESPID)",
   label: "Piedrala (ESPID)"
  },
  {
   value: "Piedramuelle (ESOPE)",
   label: "Piedramuelle (ESOPE)"
  },
  {
   value: "Piera (ESPIR)",
   label: "Piera (ESPIR)"
  },
  {
   value: "Pilar de la Horadada (ESPAZ)",
   label: "Pilar de la Horadada (ESPAZ)"
  },
  {
   value: "Piles (ESPLE)",
   label: "Piles (ESPLE)"
  },
  {
   value: "Pina ne Ebro (ESPNE)",
   label: "Pina ne Ebro (ESPNE)"
  },
  {
   value: "Pinarejos (ESPIN)",
   label: "Pinarejos (ESPIN)"
  },
  {
   value: "Pineda de Mar (ESZJM)",
   label: "Pineda de Mar (ESZJM)"
  },
  {
   value: "Pinos Puente (ESPIP)",
   label: "Pinos Puente (ESPIP)"
  },
  {
   value: "Pinseque (ESPNQ)",
   label: "Pinseque (ESPNQ)"
  },
  {
   value: "Pitillas (ESPIT)",
   label: "Pitillas (ESPIT)"
  },
  {
   value: "Placencia Armas Soraluze (ESZGH)",
   label: "Placencia Armas Soraluze (ESZGH)"
  },
  {
   value: "Playa Honda (ESPNT)",
   label: "Playa Honda (ESPNT)"
  },
  {
   value: "Plentzia (ESZOD)",
   label: "Plentzia (ESZOD)"
  },
  {
   value: "Pobra do Caraminal (ESZJF)",
   label: "Pobra do Caraminal (ESZJF)"
  },
  {
   value: "Pola de Lena (ESPLA)",
   label: "Pola de Lena (ESPLA)"
  },
  {
   value: "Pola de Siero (ESPSO)",
   label: "Pola de Siero (ESPSO)"
  },
  {
   value: "Pola de Siero (ESPSR)",
   label: "Pola de Siero (ESPSR)"
  },
  {
   value: "Polan (ESTOP)",
   label: "Polan (ESTOP)"
  },
  {
   value: "Polanco (ESPLC)",
   label: "Polanco (ESPLC)"
  },
  {
   value: "Poligono Industrial (ESPGI)",
   label: "Poligono Industrial (ESPGI)"
  },
  {
   value: "Polinyá (ESPLY)",
   label: "Polinyá (ESPLY)"
  },
  {
   value: "Ponte Caldelas (ESPCD)",
   label: "Ponte Caldelas (ESPCD)"
  },
  {
   value: "Ponteareas (ESPTR)",
   label: "Ponteareas (ESPTR)"
  },
  {
   value: "Pontecesures (ESZJU)",
   label: "Pontecesures (ESZJU)"
  },
  {
   value: "Ponts (ESPOS)",
   label: "Ponts (ESPOS)"
  },
  {
   value: "Porceyo (ESPYO)",
   label: "Porceyo (ESPYO)"
  },
  {
   value: "Portals Nous (ESPNX)",
   label: "Portals Nous (ESPNX)"
  },
  {
   value: "Portillo (ESZJV)",
   label: "Portillo (ESZJV)"
  },
  {
   value: "Portonovo (ESZJN)",
   label: "Portonovo (ESZJN)"
  },
  {
   value: "Posada de Llanera (ESPLR)",
   label: "Posada de Llanera (ESPLR)"
  },
  {
   value: "Posadas (ESZJS)",
   label: "Posadas (ESZJS)"
  },
  {
   value: "Pozal de Gallinas (ESZJI)",
   label: "Pozal de Gallinas (ESZJI)"
  },
  {
   value: "Pozo Alcón (ESPZN)",
   label: "Pozo Alcón (ESPZN)"
  },
  {
   value: "Pradejon (ESZJL)",
   label: "Pradejon (ESZJL)"
  },
  {
   value: "Prádena del Rincón (ESPDR)",
   label: "Prádena del Rincón (ESPDR)"
  },
  {
   value: "Prado del Rey (ESZJG)",
   label: "Prado del Rey (ESZJG)"
  },
  {
   value: "Prats de Llucanes (ESZBG)",
   label: "Prats de Llucanes (ESZBG)"
  },
  {
   value: "Praves (ESPRA)",
   label: "Praves (ESPRA)"
  },
  {
   value: "Pravia (ESZKA)",
   label: "Pravia (ESZKA)"
  },
  {
   value: "Premià de Dalt (ESPDD)",
   label: "Premià de Dalt (ESPDD)"
  },
  {
   value: "Premia de Mar (ESZJP)",
   label: "Premia de Mar (ESZJP)"
  },
  {
   value: "Priego de Cordoba (ESZJH)",
   label: "Priego de Cordoba (ESZJH)"
  },
  {
   value: "Pruvia (Llanera) (ESPVU)",
   label: "Pruvia (Llanera) (ESPVU)"
  },
  {
   value: "Pto de Granadilla (ESGND)",
   label: "Pto de Granadilla (ESGND)"
  },
  {
   value: "Pto de la Cruz (ESRUZ)",
   label: "Pto de la Cruz (ESRUZ)"
  },
  {
   value: "Pto de Playa de Santiago (ESPPS)",
   label: "Pto de Playa de Santiago (ESPPS)"
  },
  {
   value: "Puçol (ESUOL)",
   label: "Puçol (ESUOL)"
  },
  {
   value: "Puebla de Farnals (ESPDF)",
   label: "Puebla de Farnals (ESPDF)"
  },
  {
   value: "Puebla de Sanabria (ESPUE)",
   label: "Puebla de Sanabria (ESPUE)"
  },
  {
   value: "Puebla de Vallbona (ESPVB)",
   label: "Puebla de Vallbona (ESPVB)"
  },
  {
   value: "Puebla Larga (ESPLV)",
   label: "Puebla Larga (ESPLV)"
  },
  {
   value: "Puebla Montalban (ESZHJ)",
   label: "Puebla Montalban (ESZHJ)"
  },
  {
   value: "Pueblo Nuevo de San Rafael (ESNSR)",
   label: "Pueblo Nuevo de San Rafael (ESNSR)"
  },
  {
   value: "Pueblonuevo (ESZJX)",
   label: "Pueblonuevo (ESZJX)"
  },
  {
   value: "Puente de Genave (ESZJJ)",
   label: "Puente de Genave (ESZJJ)"
  },
  {
   value: "Puente San Miguel (ESZJT)",
   label: "Puente San Miguel (ESZJT)"
  },
  {
   value: "Puente Tocinos (ESPTO)",
   label: "Puente Tocinos (ESPTO)"
  },
  {
   value: "Puentecesures (ESPCS)",
   label: "Puentecesures (ESPCS)"
  },
  {
   value: "Puentedeume (ESPTD)",
   label: "Puentedeume (ESPTD)"
  },
  {
   value: "Puerto de Sagunto (ESPDS)",
   label: "Puerto de Sagunto (ESPDS)"
  },
  {
   value: "Puerto Lumbreras (ESPOL)",
   label: "Puerto Lumbreras (ESPOL)"
  },
  {
   value: "Puga (ESPGG)",
   label: "Puga (ESPGG)"
  },
  {
   value: "Puig-reig (ESPRG)",
   label: "Puig-reig (ESPRG)"
  },
  {
   value: "Pujalt (ESPUJ)",
   label: "Pujalt (ESPUJ)"
  },
  {
   value: "Pulpi (ESZJQ)",
   label: "Pulpi (ESZJQ)"
  },
  {
   value: "Punta Umbria (ESZJY)",
   label: "Punta Umbria (ESZJY)"
  },
  {
   value: "Purchena (ESPUR)",
   label: "Purchena (ESPUR)"
  },
  {
   value: "Puxeiros (ESZKE)",
   label: "Puxeiros (ESZKE)"
  },
  {
   value: "Quart (ESQAT)",
   label: "Quart (ESQAT)"
  },
  {
   value: "Quero (ESQUO)",
   label: "Quero (ESQUO)"
  },
  {
   value: "Quintanilla de Arriba (ESQDA)",
   label: "Quintanilla de Arriba (ESQDA)"
  },
  {
   value: "Quintanilla Sobresierra (ESZAN)",
   label: "Quintanilla Sobresierra (ESZAN)"
  },
  {
   value: "Quinto de Ebro (ESQEB)",
   label: "Quinto de Ebro (ESQEB)"
  },
  {
   value: "Quiroga (ESQRG)",
   label: "Quiroga (ESQRG)"
  },
  {
   value: "Rabade (ESRBA)",
   label: "Rabade (ESRBA)"
  },
  {
   value: "Rabanales (ESZKK)",
   label: "Rabanales (ESZKK)"
  },
  {
   value: "Rafelbuñol (ESRAB)",
   label: "Rafelbuñol (ESRAB)"
  },
  {
   value: "Rascafria (ESRAS)",
   label: "Rascafria (ESRAS)"
  },
  {
   value: "Real de Gandía (ESRDG)",
   label: "Real de Gandía (ESRDG)"
  },
  {
   value: "Rebolledo (ESRBL)",
   label: "Rebolledo (ESRBL)"
  },
  {
   value: "Redondela (ESRED)",
   label: "Redondela (ESRED)"
  },
  {
   value: "Renedo (ESREN)",
   label: "Renedo (ESREN)"
  },
  {
   value: "Renedo de Pielago (ESRDP)",
   label: "Renedo de Pielago (ESRDP)"
  },
  {
   value: "Rentería (ESRTA)",
   label: "Rentería (ESRTA)"
  },
  {
   value: "Requena de Campos (ESRQC)",
   label: "Requena de Campos (ESRQC)"
  },
  {
   value: "Revilla de Camargo (ESZKM)",
   label: "Revilla de Camargo (ESZKM)"
  },
  {
   value: "Rianjo (ESRIA)",
   label: "Rianjo (ESRIA)"
  },
  {
   value: "Riba Roja de Turia (ESRRT)",
   label: "Riba Roja de Turia (ESRRT)"
  },
  {
   value: "Ribadavia (ESRBD)",
   label: "Ribadavia (ESRBD)"
  },
  {
   value: "Ribadumia (ESRDU)",
   label: "Ribadumia (ESRDU)"
  },
  {
   value: "Ribaforada (ESRFA)",
   label: "Ribaforada (ESRFA)"
  },
  {
   value: "Ribaseca (ESRIC)",
   label: "Ribaseca (ESRIC)"
  },
  {
   value: "Ribeira (Santa Uxia) (ESRBI)",
   label: "Ribeira (Santa Uxia) (ESRBI)"
  },
  {
   value: "Ribera del Fresno (ESZKN)",
   label: "Ribera del Fresno (ESZKN)"
  },
  {
   value: "Riells I Viabrea (ESZKU)",
   label: "Riells I Viabrea (ESZKU)"
  },
  {
   value: "Rincon de Soto (ESZKO)",
   label: "Rincon de Soto (ESZKO)"
  },
  {
   value: "Rioseco de Guriezo (ESREG)",
   label: "Rioseco de Guriezo (ESREG)"
  },
  {
   value: "Ripoll (ESRPL)",
   label: "Ripoll (ESRPL)"
  },
  {
   value: "Riudarenas (ESRDS)",
   label: "Riudarenas (ESRDS)"
  },
  {
   value: "Riudellots de la Selva (ESRLS)",
   label: "Riudellots de la Selva (ESRLS)"
  },
  {
   value: "Rivabellosa (ESRBO)",
   label: "Rivabellosa (ESRBO)"
  },
  {
   value: "Rivas-Vaciamadrid (ESRVM)",
   label: "Rivas-Vaciamadrid (ESRVM)"
  },
  {
   value: "Roa (ESRAX)",
   label: "Roa (ESRAX)"
  },
  {
   value: "Roales (ESROA)",
   label: "Roales (ESROA)"
  },
  {
   value: "Robra (ESRBR)",
   label: "Robra (ESRBR)"
  },
  {
   value: "Rodeiro (ESRDO)",
   label: "Rodeiro (ESRDO)"
  },
  {
   value: "Roldan (ESZKP)",
   label: "Roldan (ESZKP)"
  },
  {
   value: "Roquetes (ESZAG)",
   label: "Roquetes (ESZAG)"
  },
  {
   value: "Rosal (ESROL)",
   label: "Rosal (ESROL)"
  },
  {
   value: "Roselló (ESRSO)",
   label: "Roselló (ESRSO)"
  },
  {
   value: "Roses (ESZKQ)",
   label: "Roses (ESZKQ)"
  },
  {
   value: "Rossburgh (ESVEZ)",
   label: "Rossburgh (ESVEZ)"
  },
  {
   value: "Rubian (ESRBN)",
   label: "Rubian (ESRBN)"
  },
  {
   value: "Rueda (ESRUE)",
   label: "Rueda (ESRUE)"
  },
  {
   value: "Ruidarenes (ESRDR)",
   label: "Ruidarenes (ESRDR)"
  },
  {
   value: "Rute (ESZKT)",
   label: "Rute (ESZKT)"
  },
  {
   value: "Sahagún (ESSHG)",
   label: "Sahagún (ESSHG)"
  },
  {
   value: "Saldaña (ESSDA)",
   label: "Saldaña (ESSDA)"
  },
  {
   value: "Saldaña de Burgos (ESSBU)",
   label: "Saldaña de Burgos (ESSBU)"
  },
  {
   value: "Salinas (ESSLS)",
   label: "Salinas (ESSLS)"
  },
  {
   value: "Sallent (ESSLE)",
   label: "Sallent (ESSLE)"
  },
  {
   value: "Salou (ESSLO)",
   label: "Salou (ESSLO)"
  },
  {
   value: "Salt (ESSLT)",
   label: "Salt (ESSLT)"
  },
  {
   value: "Salvaleon (ESZLB)",
   label: "Salvaleon (ESZLB)"
  },
  {
   value: "Salvaterra de Mino (ESGDM)",
   label: "Salvaterra de Mino (ESGDM)"
  },
  {
   value: "Salvatierra (ESSLV)",
   label: "Salvatierra (ESSLV)"
  },
  {
   value: "Samano (ESZLY)",
   label: "Samano (ESZLY)"
  },
  {
   value: "San Adrián de Besós (ESSAB)",
   label: "San Adrián de Besós (ESSAB)"
  },
  {
   value: "San Agustín de Guadalix (ESAGX)",
   label: "San Agustín de Guadalix (ESAGX)"
  },
  {
   value: "San Agustín del Pozo (ESSDX)",
   label: "San Agustín del Pozo (ESSDX)"
  },
  {
   value: "San Andrés de Echevarría (ESETX)",
   label: "San Andrés de Echevarría (ESETX)"
  },
  {
   value: "San Antoni de Vilamajor (ESZKY)",
   label: "San Antoni de Vilamajor (ESZKY)"
  },
  {
   value: "San Antonio de Benageber (ESZBK)",
   label: "San Antonio de Benageber (ESZBK)"
  },
  {
   value: "San Antonio de Requena (ESSAQ)",
   label: "San Antonio de Requena (ESSAQ)"
  },
  {
   value: "San Asensio (ESSAS)",
   label: "San Asensio (ESSAS)"
  },
  {
   value: "San Cayetano (ESZLD)",
   label: "San Cayetano (ESZLD)"
  },
  {
   value: "San Ciprián de Viñas (ESSCV)",
   label: "San Ciprián de Viñas (ESSCV)"
  },
  {
   value: "San Cipriano de Vallalta (ESSTY)",
   label: "San Cipriano de Vallalta (ESSTY)"
  },
  {
   value: "San Clodio (ESSCD)",
   label: "San Clodio (ESSCD)"
  },
  {
   value: "San Clodio (ESSLD)",
   label: "San Clodio (ESSLD)"
  },
  {
   value: "San Esteban de Gormaz (ESEDG)",
   label: "San Esteban de Gormaz (ESEDG)"
  },
  {
   value: "San Eugenio (ESSEU)",
   label: "San Eugenio (ESSEU)"
  },
  {
   value: "San Felices de Buelna (ESSFB)",
   label: "San Felices de Buelna (ESSFB)"
  },
  {
   value: "San Fulgencio (ESSFG)",
   label: "San Fulgencio (ESSFG)"
  },
  {
   value: "San Ginés de la Jara (ESSGS)",
   label: "San Ginés de la Jara (ESSGS)"
  },
  {
   value: "San Isidro de Albatera (ESSIA)",
   label: "San Isidro de Albatera (ESSIA)"
  },
  {
   value: "San Isidro de Dueñas (ESSID)",
   label: "San Isidro de Dueñas (ESSID)"
  },
  {
   value: "San Javier (ESSJR)",
   label: "San Javier (ESSJR)"
  },
  {
   value: "San Jose del Valle (ESZHQ)",
   label: "San Jose del Valle (ESZHQ)"
  },
  {
   value: "San Juan de Alicante (ESZMA)",
   label: "San Juan de Alicante (ESZMA)"
  },
  {
   value: "San Juan de la Arena (ESJLA)",
   label: "San Juan de la Arena (ESJLA)"
  },
  {
   value: "San Juan de las Abadesas (ESSJB)",
   label: "San Juan de las Abadesas (ESSJB)"
  },
  {
   value: "San Juan de Mozarrifar (ESSDM)",
   label: "San Juan de Mozarrifar (ESSDM)"
  },
  {
   value: "San Leonardo de Yagüe (ESLDY)",
   label: "San Leonardo de Yagüe (ESLDY)"
  },
  {
   value: "San Martin de la Vega (ESSRV)",
   label: "San Martin de la Vega (ESSRV)"
  },
  {
   value: "San Martín de Valdeiglesias (ESSMV)",
   label: "San Martín de Valdeiglesias (ESSMV)"
  },
  {
   value: "San Mateo de Gállego (ESSMG)",
   label: "San Mateo de Gállego (ESSMG)"
  },
  {
   value: "San Miguel de Abona (ESSMB)",
   label: "San Miguel de Abona (ESSMB)"
  },
  {
   value: "San Pedro Pescador (ESSAP)",
   label: "San Pedro Pescador (ESSAP)"
  },
  {
   value: "San Pol de Mar (ESZME)",
   label: "San Pol de Mar (ESZME)"
  },
  {
   value: "San Quintin de Mediona (ESZKG)",
   label: "San Quintin de Mediona (ESZKG)"
  },
  {
   value: "San Quirico de Besora (ESSQB)",
   label: "San Quirico de Besora (ESSQB)"
  },
  {
   value: "San Román (ESSAR)",
   label: "San Román (ESSAR)"
  },
  {
   value: "San Salvador (ESSSV)",
   label: "San Salvador (ESSSV)"
  },
  {
   value: "San Salvador de Cantamuda (ESSTV)",
   label: "San Salvador de Cantamuda (ESSTV)"
  },
  {
   value: "San Sebastian de los Reyes (ESZLT)",
   label: "San Sebastian de los Reyes (ESZLT)"
  },
  {
   value: "San Vicent de Torello (ESZMD)",
   label: "San Vicent de Torello (ESZMD)"
  },
  {
   value: "San Vicente de Calders (ESVTS)",
   label: "San Vicente de Calders (ESVTS)"
  },
  {
   value: "San Vicente de la Barquera (ESSVB)",
   label: "San Vicente de la Barquera (ESSVB)"
  },
  {
   value: "San Vicente de la Sonsierra (ESSVS)",
   label: "San Vicente de la Sonsierra (ESSVS)"
  },
  {
   value: "San Vicente del Raspeig (ESSVR)",
   label: "San Vicente del Raspeig (ESSVR)"
  },
  {
   value: "Sanchonuño (ESSNO)",
   label: "Sanchonuño (ESSNO)"
  },
  {
   value: "Sancibrao (ESSNC)",
   label: "Sancibrao (ESSNC)"
  },
  {
   value: "Sangonera la Seca (ESSNG)",
   label: "Sangonera la Seca (ESSNG)"
  },
  {
   value: "Sangonera La Verde (ESSVD)",
   label: "Sangonera La Verde (ESSVD)"
  },
  {
   value: "Sangonera la Verde o Ermita Nuevo (ESSNV)",
   label: "Sangonera la Verde o Ermita Nuevo (ESSNV)"
  },
  {
   value: "Sanguesa (ESSUS)",
   label: "Sanguesa (ESSUS)"
  },
  {
   value: "Sant Andreu De La Barca (ESSDD)",
   label: "Sant Andreu De La Barca (ESSDD)"
  },
  {
   value: "Sant Andreu de la Barca (ESZBY)",
   label: "Sant Andreu de la Barca (ESZBY)"
  },
  {
   value: "Sant Aniol de Finestres (ESZCA)",
   label: "Sant Aniol de Finestres (ESZCA)"
  },
  {
   value: "Sant Bartolome de Tirajana (ESZKX)",
   label: "Sant Bartolome de Tirajana (ESZKX)"
  },
  {
   value: "Sant Bartomeu del Grau (ESZLU)",
   label: "Sant Bartomeu del Grau (ESZLU)"
  },
  {
   value: "Sant Celoni (ESCLI)",
   label: "Sant Celoni (ESCLI)"
  },
  {
   value: "Sant Cibrao da Sant Vinas (ESZLC)",
   label: "Sant Cibrao da Sant Vinas (ESZLC)"
  },
  {
   value: "Sant Cugat Del Valles (ESSCS)",
   label: "Sant Cugat Del Valles (ESSCS)"
  },
  {
   value: "Sant Cugat Sesgarrigues (ESCSG)",
   label: "Sant Cugat Sesgarrigues (ESCSG)"
  },
  {
   value: "Sant Esteve de la Sarga (ESSEB)",
   label: "Sant Esteve de la Sarga (ESSEB)"
  },
  {
   value: "Sant Esteve De Llemena (ESEFG)",
   label: "Sant Esteve De Llemena (ESEFG)"
  },
  {
   value: "Sant Feliu de Buixalleu (ESFBX)",
   label: "Sant Feliu de Buixalleu (ESFBX)"
  },
  {
   value: "Sant Feliu de Llobregat (ESSFL)",
   label: "Sant Feliu de Llobregat (ESSFL)"
  },
  {
   value: "Sant Fruitós de Bagés (ESSFR)",
   label: "Sant Fruitós de Bagés (ESSFR)"
  },
  {
   value: "Sant Guim de Freixenet (ESSGF)",
   label: "Sant Guim de Freixenet (ESSGF)"
  },
  {
   value: "Sant Guim de la Plana (ESSGP)",
   label: "Sant Guim de la Plana (ESSGP)"
  },
  {
   value: "Sant Jaume de Llierca (ESJLC)",
   label: "Sant Jaume de Llierca (ESJLC)"
  },
  {
   value: "Sant Jaume del Sant Domenys (ESZGE)",
   label: "Sant Jaume del Sant Domenys (ESZGE)"
  },
  {
   value: "Sant Jaume Llierca (ESZLJ)",
   label: "Sant Jaume Llierca (ESZLJ)"
  },
  {
   value: "Sant Joan de Vilatorrada (ESSJI)",
   label: "Sant Joan de Vilatorrada (ESSJI)"
  },
  {
   value: "Sant Joan Despí (ESSJO)",
   label: "Sant Joan Despí (ESSJO)"
  },
  {
   value: "Sant Josep de sa Talaia (ESSJT)",
   label: "Sant Josep de sa Talaia (ESSJT)"
  },
  {
   value: "Sant Julia de Ramis (ESZLI)",
   label: "Sant Julia de Ramis (ESZLI)"
  },
  {
   value: "Sant Julià de Vilatorta (ESSJV)",
   label: "Sant Julià de Vilatorta (ESSJV)"
  },
  {
   value: "Sant Julian de Ramis (ESJRM)",
   label: "Sant Julian de Ramis (ESJRM)"
  },
  {
   value: "Sant Llorenc Savall (ESSLC)",
   label: "Sant Llorenc Savall (ESSLC)"
  },
  {
   value: "Sant Miquel de Balenya (ESTTT)",
   label: "Sant Miquel de Balenya (ESTTT)"
  },
  {
   value: "Sant Miquel de Balenya (ESZLL)",
   label: "Sant Miquel de Balenya (ESZLL)"
  },
  {
   value: "Sant Miquel de Fluvia (ESSMD)",
   label: "Sant Miquel de Fluvia (ESSMD)"
  },
  {
   value: "Sant Pere de Sallavinera (ESZEX)",
   label: "Sant Pere de Sallavinera (ESZEX)"
  },
  {
   value: "Sant Pere Molanta (ESSPT)",
   label: "Sant Pere Molanta (ESSPT)"
  },
  {
   value: "Sant Pere Molanta (ESZLQ)",
   label: "Sant Pere Molanta (ESZLQ)"
  },
  {
   value: "Sant Quirze del Valles (ESSQV)",
   label: "Sant Quirze del Valles (ESSQV)"
  },
  {
   value: "Sant Quirze Safaja (ESSQS)",
   label: "Sant Quirze Safaja (ESSQS)"
  },
  {
   value: "Sant Quirze Valles (ESZLR)",
   label: "Sant Quirze Valles (ESZLR)"
  },
  {
   value: "Sant Salvador de Guardiola (ESGRL)",
   label: "Sant Salvador de Guardiola (ESGRL)"
  },
  {
   value: "Sant Vicenç dels Horts (ESSVC)",
   label: "Sant Vicenç dels Horts (ESSVC)"
  },
  {
   value: "Santa Agueda (ESSGD)",
   label: "Santa Agueda (ESSGD)"
  },
  {
   value: "Santa Amalia (ESAMA)",
   label: "Santa Amalia (ESAMA)"
  },
  {
   value: "Santa Barbara (ESZIP)",
   label: "Santa Barbara (ESZIP)"
  },
  {
   value: "Santa Brigida (ESZNH)",
   label: "Santa Brigida (ESZNH)"
  },
  {
   value: "Santa Coloma de Cervello (ESOMA)",
   label: "Santa Coloma de Cervello (ESOMA)"
  },
  {
   value: "Santa Coloma de Gramanet (ESSCG)",
   label: "Santa Coloma de Gramanet (ESSCG)"
  },
  {
   value: "Santa Cruz de Bezana (ESSCB)",
   label: "Santa Cruz de Bezana (ESSCB)"
  },
  {
   value: "Santa Cruz de la Zarza (ESSCZ)",
   label: "Santa Cruz de la Zarza (ESSCZ)"
  },
  {
   value: "Santa Eugenia (ESEUG)",
   label: "Santa Eugenia (ESEUG)"
  },
  {
   value: "Santa Eugenia de Berga (ESEBG)",
   label: "Santa Eugenia de Berga (ESEBG)"
  },
  {
   value: "Santa Eulàlia de Ronçana (ESULA)",
   label: "Santa Eulàlia de Ronçana (ESULA)"
  },
  {
   value: "Santa Eulalia de Ronsana (ESZOG)",
   label: "Santa Eulalia de Ronsana (ESZOG)"
  },
  {
   value: "Santa Fe (ESZLH)",
   label: "Santa Fe (ESZLH)"
  },
  {
   value: "Santa Llogaia de Alguema (ESZLK)",
   label: "Santa Llogaia de Alguema (ESZLK)"
  },
  {
   value: "Santa Lucia de Morana (ESSTC)",
   label: "Santa Lucia de Morana (ESSTC)"
  },
  {
   value: "Santa Lucia de Tirajana (ESZHS)",
   label: "Santa Lucia de Tirajana (ESZHS)"
  },
  {
   value: "Santa Margarida de Montbui (ESMRG)",
   label: "Santa Margarida de Montbui (ESMRG)"
  },
  {
   value: "Santa Margarita (ESSTM)",
   label: "Santa Margarita (ESSTM)"
  },
  {
   value: "Santa Maria de Corco (ESSMO)",
   label: "Santa Maria de Corco (ESSMO)"
  },
  {
   value: "Santa Maria de Corcó (ESSCO)",
   label: "Santa Maria de Corcó (ESSCO)"
  },
  {
   value: "Santa Maria de Guia de Gran Canaria (ESGCR)",
   label: "Santa Maria de Guia de Gran Canaria (ESGCR)"
  },
  {
   value: "Santa Maria de Martorelles (ESSMM)",
   label: "Santa Maria de Martorelles (ESSMM)"
  },
  {
   value: "Santa Maria de Palautordera (ESZLN)",
   label: "Santa Maria de Palautordera (ESZLN)"
  },
  {
   value: "Santa Marta (ESSAM)",
   label: "Santa Marta (ESSAM)"
  },
  {
   value: "Santa Oliva (ESSOA)",
   label: "Santa Oliva (ESSOA)"
  },
  {
   value: "Santa Perpetua de Bogota (ESSPB)",
   label: "Santa Perpetua de Bogota (ESSPB)"
  },
  {
   value: "Santa Úrsula (ESSUR)",
   label: "Santa Úrsula (ESSUR)"
  },
  {
   value: "Santacara (ESZNV)",
   label: "Santacara (ESZNV)"
  },
  {
   value: "Santaella (ESZLP)",
   label: "Santaella (ESZLP)"
  },
  {
   value: "Santeles (ESSTL)",
   label: "Santeles (ESSTL)"
  },
  {
   value: "Santesteban (ESSTT)",
   label: "Santesteban (ESSTT)"
  },
  {
   value: "Santiago del Teide (ESZAT)",
   label: "Santiago del Teide (ESZAT)"
  },
  {
   value: "Santibanez de Vidriales (ESSNZ)",
   label: "Santibanez de Vidriales (ESSNZ)"
  },
  {
   value: "Santisteban del Pto (ESZLX)",
   label: "Santisteban del Pto (ESZLX)"
  },
  {
   value: "Santiuste de San Juan Bautista (ESSTX)",
   label: "Santiuste de San Juan Bautista (ESSTX)"
  },
  {
   value: "Santo Domingo de la Calzada (ESDGC)",
   label: "Santo Domingo de la Calzada (ESDGC)"
  },
  {
   value: "Santona (ESZLW)",
   label: "Santona (ESZLW)"
  },
  {
   value: "Santpedor (ESSNP)",
   label: "Santpedor (ESSNP)"
  },
  {
   value: "Sardón de Duero (ESSDO)",
   label: "Sardón de Duero (ESSDO)"
  },
  {
   value: "Sariego (ESSRI)",
   label: "Sariego (ESSRI)"
  },
  {
   value: "Sarral (ESRAL)",
   label: "Sarral (ESRAL)"
  },
  {
   value: "Sarria (ESSRR)",
   label: "Sarria (ESSRR)"
  },
  {
   value: "Selas (ESELS)",
   label: "Selas (ESELS)"
  },
  {
   value: "Selas (ESSEL)",
   label: "Selas (ESSEL)"
  },
  {
   value: "Seña (ESSEW)",
   label: "Seña (ESSEW)"
  },
  {
   value: "Sentmenat (ESZLS)",
   label: "Sentmenat (ESZLS)"
  },
  {
   value: "Serinyà (ESSRY)",
   label: "Serinyà (ESSRY)"
  },
  {
   value: "Serrada (ESSRA)",
   label: "Serrada (ESSRA)"
  },
  {
   value: "Seseña Nuevo (ESSEE)",
   label: "Seseña Nuevo (ESSEE)"
  },
  {
   value: "Sestao (ESETO)",
   label: "Sestao (ESETO)"
  },
  {
   value: "Sestao\/Bilbao (ESSST)",
   label: "Sestao\/Bilbao (ESSST)"
  },
  {
   value: "Seva (ESZMC)",
   label: "Seva (ESZMC)"
  },
  {
   value: "Sidamon (ESSDN)",
   label: "Sidamon (ESSDN)"
  },
  {
   value: "Siero (ESSIE)",
   label: "Siero (ESSIE)"
  },
  {
   value: "Siero (ESSRO)",
   label: "Siero (ESSRO)"
  },
  {
   value: "Sigüenza (ESSIG)",
   label: "Sigüenza (ESSIG)"
  },
  {
   value: "Silleda (ESZMV)",
   label: "Silleda (ESZMV)"
  },
  {
   value: "Sils (ESSIS)",
   label: "Sils (ESSIS)"
  },
  {
   value: "Siruela (ESSIR)",
   label: "Siruela (ESSIR)"
  },
  {
   value: "Sitges (ESSIT)",
   label: "Sitges (ESSIT)"
  },
  {
   value: "Sobradiel (ESSOD)",
   label: "Sobradiel (ESSOD)"
  },
  {
   value: "Sobremazas (ESZAS)",
   label: "Sobremazas (ESZAS)"
  },
  {
   value: "Socuéllamos (ESSOC)",
   label: "Socuéllamos (ESSOC)"
  },
  {
   value: "Sodupe (ESSDE)",
   label: "Sodupe (ESSDE)"
  },
  {
   value: "Solares (ESSRS)",
   label: "Solares (ESSRS)"
  },
  {
   value: "Sollana (ESSOV)",
   label: "Sollana (ESSOV)"
  },
  {
   value: "Sóller (ESSOL)",
   label: "Sóller (ESSOL)"
  },
  {
   value: "Somozas (ESSMZ)",
   label: "Somozas (ESSMZ)"
  },
  {
   value: "Sondika (ESSDC)",
   label: "Sondika (ESSDC)"
  },
  {
   value: "Sopelana (ESSLN)",
   label: "Sopelana (ESSLN)"
  },
  {
   value: "Sorbas (ESSBS)",
   label: "Sorbas (ESSBS)"
  },
  {
   value: "Sotiello (ESZAP)",
   label: "Sotiello (ESZAP)"
  },
  {
   value: "Soto de la Marina (ESSMA)",
   label: "Soto de la Marina (ESSMA)"
  },
  {
   value: "Soto de la Vega (ESZLV)",
   label: "Soto de la Vega (ESZLV)"
  },
  {
   value: "Soto del Real (ESSRE)",
   label: "Soto del Real (ESSRE)"
  },
  {
   value: "Sotogrande (ESSTO)",
   label: "Sotogrande (ESSTO)"
  },
  {
   value: "St Miguel de Olerdola (ESODA)",
   label: "St Miguel de Olerdola (ESODA)"
  },
  {
   value: "Subirats (ESSTS)",
   label: "Subirats (ESSTS)"
  },
  {
   value: "Sucina (ESZLO)",
   label: "Sucina (ESZLO)"
  },
  {
   value: "Sunbilla (ESSBI)",
   label: "Sunbilla (ESSBI)"
  },
  {
   value: "Tabernas (ESTAS)",
   label: "Tabernas (ESTAS)"
  },
  {
   value: "Taboadela (ESTBD)",
   label: "Taboadela (ESTBD)"
  },
  {
   value: "Tacoronte (ESZMG)",
   label: "Tacoronte (ESZMG)"
  },
  {
   value: "Tajonar (ESTJN)",
   label: "Tajonar (ESTJN)"
  },
  {
   value: "Tamon (ESTMO)",
   label: "Tamon (ESTMO)"
  },
  {
   value: "Tamón (ESTAO)",
   label: "Tamón (ESTAO)"
  },
  {
   value: "Tarazona (ESTZO)",
   label: "Tarazona (ESTZO)"
  },
  {
   value: "Tarazona de la Mancha (ESTZA)",
   label: "Tarazona de la Mancha (ESTZA)"
  },
  {
   value: "Tardelcuende (ESSOT)",
   label: "Tardelcuende (ESSOT)"
  },
  {
   value: "Tardienta (ESTRD)",
   label: "Tardienta (ESTRD)"
  },
  {
   value: "Tauste (ESTST)",
   label: "Tauste (ESTST)"
  },
  {
   value: "Tavernes de la Valldigna (ESTAV)",
   label: "Tavernes de la Valldigna (ESTAV)"
  },
  {
   value: "Tazacorte (ESTAZ)",
   label: "Tazacorte (ESTAZ)"
  },
  {
   value: "Tejares (ESTJS)",
   label: "Tejares (ESTJS)"
  },
  {
   value: "Telde (ESTEL)",
   label: "Telde (ESTEL)"
  },
  {
   value: "Tembleque (ESTEM)",
   label: "Tembleque (ESTEM)"
  },
  {
   value: "Tenorio (ESTNO)",
   label: "Tenorio (ESTNO)"
  },
  {
   value: "Teror (ESROR)",
   label: "Teror (ESROR)"
  },
  {
   value: "Tielmes (ESZMI)",
   label: "Tielmes (ESZMI)"
  },
  {
   value: "Tierga (ESTIE)",
   label: "Tierga (ESTIE)"
  },
  {
   value: "Tolosa (ESTOA)",
   label: "Tolosa (ESTOA)"
  },
  {
   value: "Tolox (ESZNS)",
   label: "Tolox (ESZNS)"
  },
  {
   value: "Tomino (ESZMQ)",
   label: "Tomino (ESZMQ)"
  },
  {
   value: "Tona (ESTON)",
   label: "Tona (ESTON)"
  },
  {
   value: "Toral de los Vados (ESZMJ)",
   label: "Toral de los Vados (ESZMJ)"
  },
  {
   value: "Tordera (ESZIS)",
   label: "Tordera (ESZIS)"
  },
  {
   value: "Torija (ESTJA)",
   label: "Torija (ESTJA)"
  },
  {
   value: "Toro (ESTRO)",
   label: "Toro (ESTRO)"
  },
  {
   value: "Torre de Miguel Sesmero (ESTMS)",
   label: "Torre de Miguel Sesmero (ESTMS)"
  },
  {
   value: "Torre Horadada (ESTHO)",
   label: "Torre Horadada (ESTHO)"
  },
  {
   value: "Torrecaballeros (ESTCS)",
   label: "Torrecaballeros (ESTCS)"
  },
  {
   value: "Torredembarra (ESTRR)",
   label: "Torredembarra (ESTRR)"
  },
  {
   value: "Torredonjimeno (ESTJM)",
   label: "Torredonjimeno (ESTJM)"
  },
  {
   value: "Torrefarrera (ESTFA)",
   label: "Torrefarrera (ESTFA)"
  },
  {
   value: "Torrejon del Rey (ESTDR)",
   label: "Torrejon del Rey (ESTDR)"
  },
  {
   value: "Torrelaguna (ESZML)",
   label: "Torrelaguna (ESZML)"
  },
  {
   value: "Torrelameu (ESZMM)",
   label: "Torrelameu (ESZMM)"
  },
  {
   value: "Torrelavit (ESTRV)",
   label: "Torrelavit (ESTRV)"
  },
  {
   value: "Torrellano (ESTRL)",
   label: "Torrellano (ESTRL)"
  },
  {
   value: "Torrellas de Foix (ESTDF)",
   label: "Torrellas de Foix (ESTDF)"
  },
  {
   value: "Torrelles de Foix (ESZMN)",
   label: "Torrelles de Foix (ESZMN)"
  },
  {
   value: "Torrelobaton (ESZMK)",
   label: "Torrelobaton (ESZMK)"
  },
  {
   value: "Torrelodones (ESZIF)",
   label: "Torrelodones (ESZIF)"
  },
  {
   value: "Torres de la Alameda (ESTLA)",
   label: "Torres de la Alameda (ESTLA)"
  },
  {
   value: "Torres de Segre (ESTDS)",
   label: "Torres de Segre (ESTDS)"
  },
  {
   value: "Torreserona (ESTSO)",
   label: "Torreserona (ESTSO)"
  },
  {
   value: "Torrijos (ESZOI)",
   label: "Torrijos (ESZOI)"
  },
  {
   value: "Torrox (ESZDI)",
   label: "Torrox (ESZDI)"
  },
  {
   value: "Tortella (ESTLL)",
   label: "Tortella (ESTLL)"
  },
  {
   value: "Totana (ESTTA)",
   label: "Totana (ESTTA)"
  },
  {
   value: "Totanes (ESZMO)",
   label: "Totanes (ESZMO)"
  },
  {
   value: "Traiguera (ESWED)",
   label: "Traiguera (ESWED)"
  },
  {
   value: "Trapaga (ESTRA)",
   label: "Trapaga (ESTRA)"
  },
  {
   value: "Trapagaran (ESTPG)",
   label: "Trapagaran (ESTPG)"
  },
  {
   value: "Trazo (ESTRZ)",
   label: "Trazo (ESTRZ)"
  },
  {
   value: "Trebujena (ESTRE)",
   label: "Trebujena (ESTRE)"
  },
  {
   value: "Tremanes (ESZKC)",
   label: "Tremanes (ESZKC)"
  },
  {
   value: "Tres Cantos (ESTRC)",
   label: "Tres Cantos (ESTRC)"
  },
  {
   value: "Trubia (ESTRU)",
   label: "Trubia (ESTRU)"
  },
  {
   value: "Tudela (ESTUD)",
   label: "Tudela (ESTUD)"
  },
  {
   value: "Tudelilla (ESTUA)",
   label: "Tudelilla (ESTUA)"
  },
  {
   value: "Tui (ESTUI)",
   label: "Tui (ESTUI)"
  },
  {
   value: "Ugena (ESZMU)",
   label: "Ugena (ESZMU)"
  },
  {
   value: "Ulla (ESZAJ)",
   label: "Ulla (ESZAJ)"
  },
  {
   value: "Ullastrell (ESULL)",
   label: "Ullastrell (ESULL)"
  },
  {
   value: "Ulldecona (ESZMT)",
   label: "Ulldecona (ESZMT)"
  },
  {
   value: "Urdax (ESURD)",
   label: "Urdax (ESURD)"
  },
  {
   value: "Urduliz (ESZNN)",
   label: "Urduliz (ESZNN)"
  },
  {
   value: "Urnieta (ESURN)",
   label: "Urnieta (ESURN)"
  },
  {
   value: "Urroz (ESURZ)",
   label: "Urroz (ESURZ)"
  },
  {
   value: "Usansolo (ESZIT)",
   label: "Usansolo (ESZIT)"
  },
  {
   value: "Utebo (ESUTE)",
   label: "Utebo (ESUTE)"
  },
  {
   value: "Utiel (ESUTI)",
   label: "Utiel (ESUTI)"
  },
  {
   value: "Utrillas (ESUTS)",
   label: "Utrillas (ESUTS)"
  },
  {
   value: "Vacarisses (ESVRI)",
   label: "Vacarisses (ESVRI)"
  },
  {
   value: "Valbuena de Duero (ESVDD)",
   label: "Valbuena de Duero (ESVDD)"
  },
  {
   value: "Valdefresno (ESVFO)",
   label: "Valdefresno (ESVFO)"
  },
  {
   value: "Valdelafuente (ESVFU)",
   label: "Valdelafuente (ESVFU)"
  },
  {
   value: "Valdivia (ESZOH)",
   label: "Valdivia (ESZOH)"
  },
  {
   value: "Valdorros (ESZKL)",
   label: "Valdorros (ESZKL)"
  },
  {
   value: "Valdovino (ESZNJ)",
   label: "Valdovino (ESZNJ)"
  },
  {
   value: "Valencia de San Juan (ESVDJ)",
   label: "Valencia de San Juan (ESVDJ)"
  },
  {
   value: "Valencina de la Concepcion (ESZMX)",
   label: "Valencina de la Concepcion (ESZMX)"
  },
  {
   value: "Valentin (ESVTN)",
   label: "Valentin (ESVTN)"
  },
  {
   value: "Valga (ESVAL)",
   label: "Valga (ESVAL)"
  },
  {
   value: "Valladares (ESZEQ)",
   label: "Valladares (ESZEQ)"
  },
  {
   value: "Vallcarca (ESVCC)",
   label: "Vallcarca (ESVCC)"
  },
  {
   value: "Valldoreix (ESVRX)",
   label: "Valldoreix (ESVRX)"
  },
  {
   value: "Valle de Guerra (ESZMW)",
   label: "Valle de Guerra (ESZMW)"
  },
  {
   value: "Valle de Tràpaga (ESVDT)",
   label: "Valle de Tràpaga (ESVDT)"
  },
  {
   value: "Valles (ESVAS)",
   label: "Valles (ESVAS)"
  },
  {
   value: "Vallfogona de Balaguer (ESVBG)",
   label: "Vallfogona de Balaguer (ESVBG)"
  },
  {
   value: "Vallfogona de Balaguer (ESVBR)",
   label: "Vallfogona de Balaguer (ESVBR)"
  },
  {
   value: "Vallirana (ESVRR)",
   label: "Vallirana (ESVRR)"
  },
  {
   value: "Valmojado (ESVOJ)",
   label: "Valmojado (ESVOJ)"
  },
  {
   value: "Valuengo (ESZNQ)",
   label: "Valuengo (ESZNQ)"
  },
  {
   value: "Valverde (Isla del Hierro) (ESVDH)",
   label: "Valverde (Isla del Hierro) (ESVDH)"
  },
  {
   value: "Valverde del Camino (ESVEC)",
   label: "Valverde del Camino (ESVEC)"
  },
  {
   value: "Valverde del Fresno (ESVDF)",
   label: "Valverde del Fresno (ESVDF)"
  },
  {
   value: "Valverde del Majano (ESVDM)",
   label: "Valverde del Majano (ESVDM)"
  },
  {
   value: "Vargas (ESVGS)",
   label: "Vargas (ESVGS)"
  },
  {
   value: "Vecindario (ESZNF)",
   label: "Vecindario (ESZNF)"
  },
  {
   value: "Vedra (ESZAE)",
   label: "Vedra (ESZAE)"
  },
  {
   value: "Vejer de la Frontera (ESVJF)",
   label: "Vejer de la Frontera (ESVJF)"
  },
  {
   value: "Vélez de Benaudalla (ESVEB)",
   label: "Vélez de Benaudalla (ESVEB)"
  },
  {
   value: "Velilla de San Antonio (ESVIW)",
   label: "Velilla de San Antonio (ESVIW)"
  },
  {
   value: "Venta de Baños (ESVBA)",
   label: "Venta de Baños (ESVBA)"
  },
  {
   value: "Vera (ESZNB)",
   label: "Vera (ESZNB)"
  },
  {
   value: "Vespella de Gaia (ESZNC)",
   label: "Vespella de Gaia (ESZNC)"
  },
  {
   value: "Viana (ESVAA)",
   label: "Viana (ESVAA)"
  },
  {
   value: "Viator (ESVIA)",
   label: "Viator (ESVIA)"
  },
  {
   value: "Vicalvaro (ESZKV)",
   label: "Vicalvaro (ESZKV)"
  },
  {
   value: "Victoria de Acentejo (ESCVJ)",
   label: "Victoria de Acentejo (ESCVJ)"
  },
  {
   value: "Vidreres (ESVRE)",
   label: "Vidreres (ESVRE)"
  },
  {
   value: "Viella (ESVEA)",
   label: "Viella (ESVEA)"
  },
  {
   value: "Vierlas (ESVLS)",
   label: "Vierlas (ESVLS)"
  },
  {
   value: "Vila de Cruces (ESVCS)",
   label: "Vila de Cruces (ESVCS)"
  },
  {
   value: "Vila De Moros (ESZOF)",
   label: "Vila De Moros (ESZOF)"
  },
  {
   value: "Vila Sana (ESZNI)",
   label: "Vila Sana (ESZNI)"
  },
  {
   value: "Vilablareix (ESVBX)",
   label: "Vilablareix (ESVBX)"
  },
  {
   value: "Vilaboa (ESVBO)",
   label: "Vilaboa (ESVBO)"
  },
  {
   value: "Vilada (ESVLD)",
   label: "Vilada (ESVLD)"
  },
  {
   value: "Vilafant (ESZKW)",
   label: "Vilafant (ESZKW)"
  },
  {
   value: "Vilafranca del Panadés (ESVFD)",
   label: "Vilafranca del Panadés (ESVFD)"
  },
  {
   value: "Vilalba (ESLLB)",
   label: "Vilalba (ESLLB)"
  },
  {
   value: "Vilamalla (ESVMA)",
   label: "Vilamalla (ESVMA)"
  },
  {
   value: "Vilanova de la Barca (ESZFW)",
   label: "Vilanova de la Barca (ESZFW)"
  },
  {
   value: "Vilanova de Segria (ESZNP)",
   label: "Vilanova de Segria (ESZNP)"
  },
  {
   value: "Vilassar de Dalt (ESVRD)",
   label: "Vilassar de Dalt (ESVRD)"
  },
  {
   value: "Vilassar de Mar (ESZNA)",
   label: "Vilassar de Mar (ESZNA)"
  },
  {
   value: "Villa de Moros (ESVMS)",
   label: "Villa de Moros (ESVMS)"
  },
  {
   value: "Villabona (ESVBN)",
   label: "Villabona (ESVBN)"
  },
  {
   value: "Villabona (ESVOA)",
   label: "Villabona (ESVOA)"
  },
  {
   value: "Villacarrillo (ESVCO)",
   label: "Villacarrillo (ESVCO)"
  },
  {
   value: "Villacil (ESZNE)",
   label: "Villacil (ESZNE)"
  },
  {
   value: "Villada (ESVID)",
   label: "Villada (ESVID)"
  },
  {
   value: "Villafranca (ESVFA)",
   label: "Villafranca (ESVFA)"
  },
  {
   value: "Villafranca de los Caballeros (ESVLO)",
   label: "Villafranca de los Caballeros (ESVLO)"
  },
  {
   value: "Villafría de Burgos (ESVIF)",
   label: "Villafría de Burgos (ESVIF)"
  },
  {
   value: "Villagonzalo Pedernales (ESVPE)",
   label: "Villagonzalo Pedernales (ESVPE)"
  },
  {
   value: "Villalba de Duero (ESVVD)",
   label: "Villalba de Duero (ESVVD)"
  },
  {
   value: "Villalbilla (ESVBL)",
   label: "Villalbilla (ESVBL)"
  },
  {
   value: "Villalbilla de Burgos (ESVIB)",
   label: "Villalbilla de Burgos (ESVIB)"
  },
  {
   value: "Villalón de Campos (ESVCM)",
   label: "Villalón de Campos (ESVCM)"
  },
  {
   value: "Villamalea (ESVIM)",
   label: "Villamalea (ESVIM)"
  },
  {
   value: "Villamarchante (ESVTE)",
   label: "Villamarchante (ESVTE)"
  },
  {
   value: "Villamayor de Monjardin (ESVLM)",
   label: "Villamayor de Monjardin (ESVLM)"
  },
  {
   value: "Villamuriel de Cerrato (ESVDO)",
   label: "Villamuriel de Cerrato (ESVDO)"
  },
  {
   value: "Villandangos (ESDGS)",
   label: "Villandangos (ESDGS)"
  },
  {
   value: "Villanueva de Alcardete (ESVAC)",
   label: "Villanueva de Alcardete (ESVAC)"
  },
  {
   value: "Villanueva de Cordoba (ESVNC)",
   label: "Villanueva de Cordoba (ESVNC)"
  },
  {
   value: "Villanueva de Gállego (ESVDG)",
   label: "Villanueva de Gállego (ESVDG)"
  },
  {
   value: "Villanueva de la Canada (ESVAN)",
   label: "Villanueva de la Canada (ESVAN)"
  },
  {
   value: "Villanueva de los Infantes (ESVLI)",
   label: "Villanueva de los Infantes (ESVLI)"
  },
  {
   value: "Villanueva del Pardillo (ESZNR)",
   label: "Villanueva del Pardillo (ESZNR)"
  },
  {
   value: "Villanueva del Rio y Minas (ESZNG)",
   label: "Villanueva del Rio y Minas (ESZNG)"
  },
  {
   value: "Villar de Moros (ESVMO)",
   label: "Villar de Moros (ESVMO)"
  },
  {
   value: "Villar de Olalla (ESODV)",
   label: "Villar de Olalla (ESODV)"
  },
  {
   value: "Villar del Arzobispo (ESVLR)",
   label: "Villar del Arzobispo (ESVLR)"
  },
  {
   value: "Villaralbo (ESVLB)",
   label: "Villaralbo (ESVLB)"
  },
  {
   value: "Villares de la Reina (ESVDL)",
   label: "Villares de la Reina (ESVDL)"
  },
  {
   value: "Villaricos (ESVCR)",
   label: "Villaricos (ESVCR)"
  },
  {
   value: "Villariezo (ESVLZ)",
   label: "Villariezo (ESVLZ)"
  },
  {
   value: "Villarrasa (ESVRS)",
   label: "Villarrasa (ESVRS)"
  },
  {
   value: "Villarrubia (ESZNL)",
   label: "Villarrubia (ESZNL)"
  },
  {
   value: "Villarta (ESVXV)",
   label: "Villarta (ESVXV)"
  },
  {
   value: "Villarta de San Juan (ESZNK)",
   label: "Villarta de San Juan (ESZNK)"
  },
  {
   value: "Villatuerta (ESVTU)",
   label: "Villatuerta (ESVTU)"
  },
  {
   value: "Villava (ESVAV)",
   label: "Villava (ESVAV)"
  },
  {
   value: "Villaverde (ESVVE)",
   label: "Villaverde (ESVVE)"
  },
  {
   value: "Vilobí del Penedès (ESVDP)",
   label: "Vilobí del Penedès (ESVDP)"
  },
  {
   value: "Vincios (ESVNS)",
   label: "Vincios (ESVNS)"
  },
  {
   value: "Vivares (ESVVR)",
   label: "Vivares (ESVVR)"
  },
  {
   value: "Xàtiva (Xátiva) (ESXAT)",
   label: "Xàtiva (Xátiva) (ESXAT)"
  },
  {
   value: "Xeraco (ESXRO)",
   label: "Xeraco (ESXRO)"
  },
  {
   value: "Xeresa (ESZNX)",
   label: "Xeresa (ESZNX)"
  },
  {
   value: "Xinzo de Limia (ESXLM)",
   label: "Xinzo de Limia (ESXLM)"
  },
  {
   value: "Xinzo de Limia Santa Marian (ESXDL)",
   label: "Xinzo de Limia Santa Marian (ESXDL)"
  },
  {
   value: "Xirivella (ESXIR)",
   label: "Xirivella (ESXIR)"
  },
  {
   value: "Yeles (ESYLS)",
   label: "Yeles (ESYLS)"
  },
  {
   value: "Yuncos (ESYUN)",
   label: "Yuncos (ESYUN)"
  },
  {
   value: "Yunquera (ESZAX)",
   label: "Yunquera (ESZAX)"
  },
  {
   value: "Yurre (ESYUR)",
   label: "Yurre (ESYUR)"
  },
  {
   value: "Zaldibar (ESZDA)",
   label: "Zaldibar (ESZDA)"
  },
  {
   value: "Zamora (ESZMR)",
   label: "Zamora (ESZMR)"
  },
  {
   value: "Zamudio (ESZAM)",
   label: "Zamudio (ESZAM)"
  },
  {
   value: "Zarátamo (ESZAR)",
   label: "Zarátamo (ESZAR)"
  },
  {
   value: "Zaratán (ESZRT)",
   label: "Zaratán (ESZRT)"
  },
  {
   value: "Zarautz (ESZAU)",
   label: "Zarautz (ESZAU)"
  },
  {
   value: "Zarcilla de Ramos (ESZDR)",
   label: "Zarcilla de Ramos (ESZDR)"
  },
  {
   value: "Zarza de Granadilla (ESZDG)",
   label: "Zarza de Granadilla (ESZDG)"
  },
  {
   value: "Zeanuri (ESZOC)",
   label: "Zeanuri (ESZOC)"
  },
  {
   value: "Zestoa (ESZCE)",
   label: "Zestoa (ESZCE)"
  },
  {
   value: "Zierbena (ESZBA)",
   label: "Zierbena (ESZBA)"
  },
  {
   value: "Zizurquil (ESZIZ)",
   label: "Zizurquil (ESZIZ)"
  },
  {
   value: "Zubillaga (ESZLG)",
   label: "Zubillaga (ESZLG)"
  },
  {
   value: "Zuera (ESZUE)",
   label: "Zuera (ESZUE)"
  },
  {
   value: "Zurbaran (ESZJA)",
   label: "Zurbaran (ESZJA)"
  },
  {
   value: ".ETHIOPIA (ET)",
   label: ".ETHIOPIA (ET)"
  },
  {
   value: "Beica (ETBEI)",
   label: "Beica (ETBEI)"
  },
  {
   value: "Debra Tabor (ETDBT)",
   label: "Debra Tabor (ETDBT)"
  },
  {
   value: "Genda Wuha (ETETE)",
   label: "Genda Wuha (ETETE)"
  },
  {
   value: "Ghinnir (ETGNN)",
   label: "Ghinnir (ETGNN)"
  },
  {
   value: "Gode (ETGDE)",
   label: "Gode (ETGDE)"
  },
  {
   value: "Jinka (ETBCO)",
   label: "Jinka (ETBCO)"
  },
  {
   value: "Kabri Dar (ETABK)",
   label: "Kabri Dar (ETABK)"
  },
  {
   value: "Kembolcha (ETOKA)",
   label: "Kembolcha (ETOKA)"
  },
  {
   value: "Lalibela (ETLLI)",
   label: "Lalibela (ETLLI)"
  },
  {
   value: "Moyale (ETMYS)",
   label: "Moyale (ETMYS)"
  },
  {
   value: "Nazret (ETNZR)",
   label: "Nazret (ETNZR)"
  },
  {
   value: "Neghelli (ETEGL)",
   label: "Neghelli (ETEGL)"
  },
  {
   value: "Sodo (ETSOD)",
   label: "Sodo (ETSOD)"
  },
  {
   value: ".FINLAND (FI)",
   label: ".FINLAND (FI)"
  },
  {
   value: "Äetsä (FIATS)",
   label: "Äetsä (FIATS)"
  },
  {
   value: "Ähtäri (FIATI)",
   label: "Ähtäri (FIATI)"
  },
  {
   value: "Alajärvi (FIAJI)",
   label: "Alajärvi (FIAJI)"
  },
  {
   value: "Alastaro (FIFAB)",
   label: "Alastaro (FIFAB)"
  },
  {
   value: "Alholmen (FIAHL)",
   label: "Alholmen (FIAHL)"
  },
  {
   value: "Antskog (FIANT)",
   label: "Antskog (FIANT)"
  },
  {
   value: "Arrakoski (FIAOK)",
   label: "Arrakoski (FIAOK)"
  },
  {
   value: "Aura (FIAUR)",
   label: "Aura (FIAUR)"
  },
  {
   value: "Bäcksbacka (FIBAS)",
   label: "Bäcksbacka (FIBAS)"
  },
  {
   value: "Bjorkholmsund (FIBJO)",
   label: "Bjorkholmsund (FIBJO)"
  },
  {
   value: "Bromarv (FIBRO)",
   label: "Bromarv (FIBRO)"
  },
  {
   value: "Degerby (FIDEG)",
   label: "Degerby (FIDEG)"
  },
  {
   value: "Eno (FIENO)",
   label: "Eno (FIENO)"
  },
  {
   value: "Ervasto (FIERV)",
   label: "Ervasto (FIERV)"
  },
  {
   value: "Eura (FIEUA)",
   label: "Eura (FIEUA)"
  },
  {
   value: "Evijärvi (FIEVJ)",
   label: "Evijärvi (FIEVJ)"
  },
  {
   value: "Fieli (FIFLI)",
   label: "Fieli (FIFLI)"
  },
  {
   value: "Finby (Särkisalo) (FISAR)",
   label: "Finby (Särkisalo) (FISAR)"
  },
  {
   value: "Finström (FIFSO)",
   label: "Finström (FIFSO)"
  },
  {
   value: "Fiskars (FIFAD)",
   label: "Fiskars (FIFAD)"
  },
  {
   value: "Gammelby (FIGAM)",
   label: "Gammelby (FIGAM)"
  },
  {
   value: "Gullö\/Tammisaari (Ekenäs) (FIGUL)",
   label: "Gullö\/Tammisaari (Ekenäs) (FIGUL)"
  },
  {
   value: "Haapajärvi (FIHAA)",
   label: "Haapajärvi (FIHAA)"
  },
  {
   value: "Haapavesi (FIHPS)",
   label: "Haapavesi (FIHPS)"
  },
  {
   value: "Hailuoto (FIHAO)",
   label: "Hailuoto (FIHAO)"
  },
  {
   value: "Hakkola (FIHAK)",
   label: "Hakkola (FIHAK)"
  },
  {
   value: "Hällnäs (FIHLL)",
   label: "Hällnäs (FIHLL)"
  },
  {
   value: "Halosenniemi (Halonen) (FIHAL)",
   label: "Halosenniemi (Halonen) (FIHAL)"
  },
  {
   value: "Hämeenkyrö (FIHKY)",
   label: "Hämeenkyrö (FIHKY)"
  },
  {
   value: "Hankasalmi (FIHKM)",
   label: "Hankasalmi (FIHKM)"
  },
  {
   value: "Hauho (FIHHO)",
   label: "Hauho (FIHHO)"
  },
  {
   value: "David City (USDTY)",
   label: "David City (USDTY)"
  },
  {
   value: "Davidsonville (USDV2)",
   label: "Davidsonville (USDV2)"
  },
  {
   value: "Davis (USDVS)",
   label: "Davis (USDVS)"
  },
  {
   value: "Davisburg (USDBG)",
   label: "Davisburg (USDBG)"
  },
  {
   value: "Davison (USDVO)",
   label: "Davison (USDVO)"
  },
  {
   value: "Davisville, Wood (USIII)",
   label: "Davisville, Wood (USIII)"
  },
  {
   value: "Dawsonville (USDVX)",
   label: "Dawsonville (USDVX)"
  },
  {
   value: "Days Creek (USDYC)",
   label: "Days Creek (USDYC)"
  },
  {
   value: "Dayton (USDY2)",
   label: "Dayton (USDY2)"
  },
  {
   value: "Dayton (USDYD)",
   label: "Dayton (USDYD)"
  },
  {
   value: "De Beque (USDQU)",
   label: "De Beque (USDQU)"
  },
  {
   value: "De Kalb (USDKB)",
   label: "De Kalb (USDKB)"
  },
  {
   value: "De Kalb (USDKL)",
   label: "De Kalb (USDKL)"
  },
  {
   value: "De Leon (USZCQ)",
   label: "De Leon (USZCQ)"
  },
  {
   value: "De Soto (USDSQ)",
   label: "De Soto (USDSQ)"
  },
  {
   value: "De Soto (USDZO)",
   label: "De Soto (USDZO)"
  },
  {
   value: "De Soto (USZ2C)",
   label: "De Soto (USZ2C)"
  },
  {
   value: "De Tour Village (USDT4)",
   label: "De Tour Village (USDT4)"
  },
  {
   value: "De Witt (USDWJ)",
   label: "De Witt (USDWJ)"
  },
  {
   value: "De Witt (USDWN)",
   label: "De Witt (USDWN)"
  },
  {
   value: "De Witt (USDWX)",
   label: "De Witt (USDWX)"
  },
  {
   value: "Deadwood (USDDW)",
   label: "Deadwood (USDDW)"
  },
  {
   value: "Deal (USDAF)",
   label: "Deal (USDAF)"
  },
  {
   value: "Deans (USDEJ)",
   label: "Deans (USDEJ)"
  },
  {
   value: "Dearborn Heights (USDHG)",
   label: "Dearborn Heights (USDHG)"
  },
  {
   value: "Dearing (USDR4)",
   label: "Dearing (USDR4)"
  },
  {
   value: "Death Valley (USDTH)",
   label: "Death Valley (USDTH)"
  },
  {
   value: "DeBary (USDB2)",
   label: "DeBary (USDB2)"
  },
  {
   value: "Decatur (USDCR)",
   label: "Decatur (USDCR)"
  },
  {
   value: "Decatur (USDEU)",
   label: "Decatur (USDEU)"
  },
  {
   value: "Decatur (USDSU)",
   label: "Decatur (USDSU)"
  },
  {
   value: "Decatur (USDTU)",
   label: "Decatur (USDTU)"
  },
  {
   value: "Decatur City (USDT2)",
   label: "Decatur City (USDT2)"
  },
  {
   value: "Decherd (USDCH)",
   label: "Decherd (USDCH)"
  },
  {
   value: "Deep Bay (USWDB)",
   label: "Deep Bay (USWDB)"
  },
  {
   value: "Deer Grove (USDGR)",
   label: "Deer Grove (USDGR)"
  },
  {
   value: "Deer Lake, Schuylkill (USDLQ)",
   label: "Deer Lake, Schuylkill (USDLQ)"
  },
  {
   value: "Deer Lodge (USDEG)",
   label: "Deer Lodge (USDEG)"
  },
  {
   value: "Deer Lodge (USDL7)",
   label: "Deer Lodge (USDL7)"
  },
  {
   value: "Deer Park (USDPC)",
   label: "Deer Park (USDPC)"
  },
  {
   value: "Deer Park (USERP)",
   label: "Deer Park (USERP)"
  },
  {
   value: "Deer Park, Camden (USDP2)",
   label: "Deer Park, Camden (USDP2)"
  },
  {
   value: "Deer River (USDMT)",
   label: "Deer River (USDMT)"
  },
  {
   value: "Deerfield (USDDE)",
   label: "Deerfield (USDDE)"
  },
  {
   value: "Deerfield (USDFE)",
   label: "Deerfield (USDFE)"
  },
  {
   value: "Deering (USDRG)",
   label: "Deering (USDRG)"
  },
  {
   value: "Deerwood (USDWD)",
   label: "Deerwood (USDWD)"
  },
  {
   value: "Defiance (USDFA)",
   label: "Defiance (USDFA)"
  },
  {
   value: "Defiance (USDFC)",
   label: "Defiance (USDFC)"
  },
  {
   value: "DeKalb (USDCB)",
   label: "DeKalb (USDCB)"
  },
  {
   value: "Del City (USD2C)",
   label: "Del City (USD2C)"
  },
  {
   value: "Del Mar (USDMA)",
   label: "Del Mar (USDMA)"
  },
  {
   value: "Del Mar, San Diego (USDM2)",
   label: "Del Mar, San Diego (USDM2)"
  },
  {
   value: "Del Norte (USDN2)",
   label: "Del Norte (USDN2)"
  },
  {
   value: "Del Rey (USDLY)",
   label: "Del Rey (USDLY)"
  },
  {
   value: "Del Rey Oaks (USEKS)",
   label: "Del Rey Oaks (USEKS)"
  },
  {
   value: "Del Rio (USDRZ)",
   label: "Del Rio (USDRZ)"
  },
  {
   value: "Delano (USDLU)",
   label: "Delano (USDLU)"
  },
  {
   value: "Delano (USDOQ)",
   label: "Delano (USDOQ)"
  },
  {
   value: "Delanson (USD2L)",
   label: "Delanson (USD2L)"
  },
  {
   value: "Delhi (USDHI)",
   label: "Delhi (USDHI)"
  },
  {
   value: "Delhi (USDHX)",
   label: "Delhi (USDHX)"
  },
  {
   value: "Delhi (USDIJ)",
   label: "Delhi (USDIJ)"
  },
  {
   value: "Delhi (USYDP)",
   label: "Delhi (USYDP)"
  },
  {
   value: "Dell (USLLR)",
   label: "Dell (USLLR)"
  },
  {
   value: "Dellroy (USDQY)",
   label: "Dellroy (USDQY)"
  },
  {
   value: "Delmar (USDM3)",
   label: "Delmar (USDM3)"
  },
  {
   value: "Delmar (USDMM)",
   label: "Delmar (USDMM)"
  },
  {
   value: "Delmont (USDVQ)",
   label: "Delmont (USDVQ)"
  },
  {
   value: "Delphi (USDEI)",
   label: "Delphi (USDEI)"
  },
  {
   value: "Delray (USDYB)",
   label: "Delray (USDYB)"
  },
  {
   value: "Delta (USDA2)",
   label: "Delta (USDA2)"
  },
  {
   value: "Delta (USDTA)",
   label: "Delta (USDTA)"
  },
  {
   value: "Delta (USDTC)",
   label: "Delta (USDTC)"
  },
  {
   value: "Deming (USDPM)",
   label: "Deming (USDPM)"
  },
  {
   value: "Denair (USYDI)",
   label: "Denair (USYDI)"
  },
  {
   value: "Denhoff (USDHF)",
   label: "Denhoff (USDHF)"
  },
  {
   value: "Denmark (USDMK)",
   label: "Denmark (USDMK)"
  },
  {
   value: "Denmark (USDXS)",
   label: "Denmark (USDXS)"
  },
  {
   value: "Denmark (USZC2)",
   label: "Denmark (USZC2)"
  },
  {
   value: "Dennis (USDJS)",
   label: "Dennis (USDJS)"
  },
  {
   value: "Dennisville (USDJV)",
   label: "Dennisville (USDJV)"
  },
  {
   value: "Denton (USDTQ)",
   label: "Denton (USDTQ)"
  },
  {
   value: "Denton (USENT)",
   label: "Denton (USENT)"
  },
  {
   value: "Denton (USZDN)",
   label: "Denton (USZDN)"
  },
  {
   value: "Denville (USDNL)",
   label: "Denville (USDNL)"
  },
  {
   value: "Deport (USDPO)",
   label: "Deport (USDPO)"
  },
  {
   value: "DeQuincy (USQDQ)",
   label: "DeQuincy (USQDQ)"
  },
  {
   value: "Derby (USDPY)",
   label: "Derby (USDPY)"
  },
  {
   value: "Derby (USERB)",
   label: "Derby (USERB)"
  },
  {
   value: "Derby Center (USDBX)",
   label: "Derby Center (USDBX)"
  },
  {
   value: "Derry (USQDR)",
   label: "Derry (USQDR)"
  },
  {
   value: "Derwood (USDW2)",
   label: "Derwood (USDW2)"
  },
  {
   value: "Des Moines (USDSN)",
   label: "Des Moines (USDSN)"
  },
  {
   value: "Desert Hills (USDDH)",
   label: "Desert Hills (USDDH)"
  },
  {
   value: "Deshler (USDSH)",
   label: "Deshler (USDSH)"
  },
  {
   value: "Deshler (USDSR)",
   label: "Deshler (USDSR)"
  },
  {
   value: "DeSoto (USDOT)",
   label: "DeSoto (USDOT)"
  },
  {
   value: "Destin (USDSI)",
   label: "Destin (USDSI)"
  },
  {
   value: "Detroit (USDT7)",
   label: "Detroit (USDT7)"
  },
  {
   value: "Detroit (USDTT)",
   label: "Detroit (USDTT)"
  },
  {
   value: "Detroit (USZC3)",
   label: "Detroit (USZC3)"
  },
  {
   value: "Devens (USVNS)",
   label: "Devens (USVNS)"
  },
  {
   value: "Devenscrest (USQDV)",
   label: "Devenscrest (USQDV)"
  },
  {
   value: "Deweyville (USYVC)",
   label: "Deweyville (USYVC)"
  },
  {
   value: "Dewittville (USDTI)",
   label: "Dewittville (USDTI)"
  },
  {
   value: "Dexter (USDXI)",
   label: "Dexter (USDXI)"
  },
  {
   value: "Dexter (USDXT)",
   label: "Dexter (USDXT)"
  },
  {
   value: "Dexter (USXXT)",
   label: "Dexter (USXXT)"
  },
  {
   value: "Dexter (USYDX)",
   label: "Dexter (USYDX)"
  },
  {
   value: "Dexter City (USDX2)",
   label: "Dexter City (USDX2)"
  },
  {
   value: "Dickson (USZKN)",
   label: "Dickson (USZKN)"
  },
  {
   value: "Dickson City (USDSY)",
   label: "Dickson City (USDSY)"
  },
  {
   value: "Dieterich (USD2H)",
   label: "Dieterich (USD2H)"
  },
  {
   value: "Dike (USDKE)",
   label: "Dike (USDKE)"
  },
  {
   value: "Dill City (USDCY)",
   label: "Dill City (USDCY)"
  },
  {
   value: "Dilley (USDY3)",
   label: "Dilley (USDY3)"
  },
  {
   value: "Dillsburg (USDMG)",
   label: "Dillsburg (USDMG)"
  },
  {
   value: "Diomede Island (USDIO)",
   label: "Diomede Island (USDIO)"
  },
  {
   value: "Discovery Bay (USDYY)",
   label: "Discovery Bay (USDYY)"
  },
  {
   value: "District Heights (USJHO)",
   label: "District Heights (USJHO)"
  },
  {
   value: "Divide (USDV5)",
   label: "Divide (USDV5)"
  },
  {
   value: "Dixmoor (USDMR)",
   label: "Dixmoor (USDMR)"
  },
  {
   value: "Dixon (USDIQ)",
   label: "Dixon (USDIQ)"
  },
  {
   value: "Dobbs Ferry (USDBF)",
   label: "Dobbs Ferry (USDBF)"
  },
  {
   value: "Dobson (USDOB)",
   label: "Dobson (USDOB)"
  },
  {
   value: "Dodgeville (USDDV)",
   label: "Dodgeville (USDDV)"
  },
  {
   value: "Dolgeville (USQDY)",
   label: "Dolgeville (USQDY)"
  },
  {
   value: "Dolomi (USDLO)",
   label: "Dolomi (USDLO)"
  },
  {
   value: "Dolores (USZDE)",
   label: "Dolores (USZDE)"
  },
  {
   value: "Dolton (USDQN)",
   label: "Dolton (USDQN)"
  },
  {
   value: "Donald (USDXO)",
   label: "Donald (USDXO)"
  },
  {
   value: "Donalds (USDDS)",
   label: "Donalds (USDDS)"
  },
  {
   value: "Donaldson (USDD8)",
   label: "Donaldson (USDD8)"
  },
  {
   value: "Donalsonville (USDSL)",
   label: "Donalsonville (USDSL)"
  },
  {
   value: "Doniphan (USDNH)",
   label: "Doniphan (USDNH)"
  },
  {
   value: "Doniphan (USDPH)",
   label: "Doniphan (USDPH)"
  },
  {
   value: "Donnelly (USDL2)",
   label: "Donnelly (USDL2)"
  },
  {
   value: "Donovan (USZDV)",
   label: "Donovan (USZDV)"
  },
  {
   value: "Dora (USDJO)",
   label: "Dora (USDJO)"
  },
  {
   value: "Dora (USDO6)",
   label: "Dora (USDO6)"
  },
  {
   value: "Dora Bay (USDOF)",
   label: "Dora Bay (USDOF)"
  },
  {
   value: "Doral (USPDQ)",
   label: "Doral (USPDQ)"
  },
  {
   value: "Dorchester (USDZM)",
   label: "Dorchester (USDZM)"
  },
  {
   value: "Dorr (USDDD)",
   label: "Dorr (USDDD)"
  },
  {
   value: "Dorrance (USDNC)",
   label: "Dorrance (USDNC)"
  },
  {
   value: "Dorset (USDT3)",
   label: "Dorset (USDT3)"
  },
  {
   value: "Double Springs (USDMB)",
   label: "Double Springs (USDMB)"
  },
  {
   value: "Douglas, Allegan (USDOG)",
   label: "Douglas, Allegan (USDOG)"
  },
  {
   value: "Douglaston\/Queens\/New York (USDGS)",
   label: "Douglaston\/Queens\/New York (USDGS)"
  },
  {
   value: "Dover (USAOV)",
   label: "Dover (USAOV)"
  },
  {
   value: "Dover (USDR2)",
   label: "Dover (USDR2)"
  },
  {
   value: "Dover (USDZR)",
   label: "Dover (USDZR)"
  },
  {
   value: "Dover (USOER)",
   label: "Dover (USOER)"
  },
  {
   value: "Dover-Cheswold (USDOV)",
   label: "Dover-Cheswold (USDOV)"
  },
  {
   value: "Downing (USDOI)",
   label: "Downing (USDOI)"
  },
  {
   value: "Downs (USDQW)",
   label: "Downs (USDQW)"
  },
  {
   value: "Downsville (USDV8)",
   label: "Downsville (USDV8)"
  },
  {
   value: "Doyle (USDOY)",
   label: "Doyle (USDOY)"
  },
  {
   value: "Drain (USDNR)",
   label: "Drain (USDNR)"
  },
  {
   value: "Drake (USDK2)",
   label: "Drake (USDK2)"
  },
  {
   value: "Drakesboro (USDSB)",
   label: "Drakesboro (USDSB)"
  },
  {
   value: "Draper (USDRK)",
   label: "Draper (USDRK)"
  },
  {
   value: "Draper (USDRQ)",
   label: "Draper (USDRQ)"
  },
  {
   value: "Dresden (USDSD)",
   label: "Dresden (USDSD)"
  },
  {
   value: "Dresher (USDRC)",
   label: "Dresher (USDRC)"
  },
  {
   value: "Drew (USDRM)",
   label: "Drew (USDRM)"
  },
  {
   value: "Drexel (USDRL)",
   label: "Drexel (USDRL)"
  },
  {
   value: "Driftwood (USDBW)",
   label: "Driftwood (USDBW)"
  },
  {
   value: "Driggs (USDGX)",
   label: "Driggs (USDGX)"
  },
  {
   value: "Dripping Springs (USTDS)",
   label: "Dripping Springs (USTDS)"
  },
  {
   value: "Drums (USUMS)",
   label: "Drums (USUMS)"
  },
  {
   value: "Dry Fork, Pittsylvania (USDFK)",
   label: "Dry Fork, Pittsylvania (USDFK)"
  },
  {
   value: "Dryden (USDYN)",
   label: "Dryden (USDYN)"
  },
  {
   value: "Dryden (USYDA)",
   label: "Dryden (USYDA)"
  },
  {
   value: "Du Quoin (USDUU)",
   label: "Du Quoin (USDUU)"
  },
  {
   value: "Duart (USURT)",
   label: "Duart (USURT)"
  },
  {
   value: "Dublin (USDBL)",
   label: "Dublin (USDBL)"
  },
  {
   value: "Dublin (USDUI)",
   label: "Dublin (USDUI)"
  },
  {
   value: "Dublin (USDZI)",
   label: "Dublin (USDZI)"
  },
  {
   value: "Dubois (USDBV)",
   label: "Dubois (USDBV)"
  },
  {
   value: "Duck (USDUF)",
   label: "Duck (USDUF)"
  },
  {
   value: "Ducktown (USDC3)",
   label: "Ducktown (USDC3)"
  },
  {
   value: "Ducor (USDCO)",
   label: "Ducor (USDCO)"
  },
  {
   value: "Dudley (USDHU)",
   label: "Dudley (USDHU)"
  },
  {
   value: "Dudley (USDKU)",
   label: "Dudley (USDKU)"
  },
  {
   value: "Duffield (USDUD)",
   label: "Duffield (USDUD)"
  },
  {
   value: "Duke (USDUK)",
   label: "Duke (USDUK)"
  },
  {
   value: "Dulles (USLLH)",
   label: "Dulles (USLLH)"
  },
  {
   value: "Dulzura (USDZU)",
   label: "Dulzura (USDZU)"
  },
  {
   value: "Dumfries (USDFS)",
   label: "Dumfries (USDFS)"
  },
  {
   value: "Dumont (USDMJ)",
   label: "Dumont (USDMJ)"
  },
  {
   value: "Dunbar (USDBJ)",
   label: "Dunbar (USDBJ)"
  },
  {
   value: "Dunbridge (USDUE)",
   label: "Dunbridge (USDUE)"
  },
  {
   value: "Duncan Falls (USZC4)",
   label: "Duncan Falls (USZC4)"
  },
  {
   value: "Duncanville (USDV3)",
   label: "Duncanville (USDV3)"
  },
  {
   value: "Dundas (USUDS)",
   label: "Dundas (USUDS)"
  },
  {
   value: "Dundee (USDND)",
   label: "Dundee (USDND)"
  },
  {
   value: "Dundee (USDYU)",
   label: "Dundee (USDYU)"
  },
  {
   value: "Dundee (USUEZ)",
   label: "Dundee (USUEZ)"
  },
  {
   value: "Dunellen (USDUL)",
   label: "Dunellen (USDUL)"
  },
  {
   value: "Dunkirk (USDKI)",
   label: "Dunkirk (USDKI)"
  },
  {
   value: "Dunlap (USDJR)",
   label: "Dunlap (USDJR)"
  },
  {
   value: "Dunlap (USDZP)",
   label: "Dunlap (USDZP)"
  },
  {
   value: "Dunlap (USUNL)",
   label: "Dunlap (USUNL)"
  },
  {
   value: "Dunnellon (USDFU)",
   label: "Dunnellon (USDFU)"
  },
  {
   value: "Dunnigan (USDIG)",
   label: "Dunnigan (USDIG)"
  },
  {
   value: "Dunstable (USDSE)",
   label: "Dunstable (USDSE)"
  },
  {
   value: "Dupo (USDUP)",
   label: "Dupo (USDUP)"
  },
  {
   value: "Dupont (USPUD)",
   label: "Dupont (USPUD)"
  },
  {
   value: "Dupont (USPUP)",
   label: "Dupont (USPUP)"
  },
  {
   value: "Duquesne (USZDQ)",
   label: "Duquesne (USZDQ)"
  },
  {
   value: "Durand (USRUD)",
   label: "Durand (USRUD)"
  },
  {
   value: "Durant (USURA)",
   label: "Durant (USURA)"
  },
  {
   value: "Durbin (USDJB)",
   label: "Durbin (USDJB)"
  },
  {
   value: "Durham (USDUR)",
   label: "Durham (USDUR)"
  },
  {
   value: "Dutton (USDU8)",
   label: "Dutton (USDU8)"
  },
  {
   value: "Dutton (USZDU)",
   label: "Dutton (USZDU)"
  },
  {
   value: "Dutzow (USZDZ)",
   label: "Dutzow (USZDZ)"
  },
  {
   value: "Duvall (USDZA)",
   label: "Duvall (USDZA)"
  },
  {
   value: "Duxbury (USDUH)",
   label: "Duxbury (USDUH)"
  },
  {
   value: "Dyer (USDYQ)",
   label: "Dyer (USDYQ)"
  },
  {
   value: "Dyer (USYEX)",
   label: "Dyer (USYEX)"
  },
  {
   value: "Dysart (USDZY)",
   label: "Dysart (USDZY)"
  },
  {
   value: "Eagle (USEAA)",
   label: "Eagle (USEAA)"
  },
  {
   value: "Eagle (USEGL)",
   label: "Eagle (USEGL)"
  },
  {
   value: "Eagle (USXXP)",
   label: "Eagle (USXXP)"
  },
  {
   value: "Eagle Rock (USEGR)",
   label: "Eagle Rock (USEGR)"
  },
  {
   value: "Eagle Rock, Botetourt (USER3)",
   label: "Eagle Rock, Botetourt (USER3)"
  },
  {
   value: "Eagle, Ada (USYEA)",
   label: "Eagle, Ada (USYEA)"
  },
  {
   value: "Eagleville (USE2G)",
   label: "Eagleville (USE2G)"
  },
  {
   value: "Eagleville (USEAV)",
   label: "Eagleville (USEAV)"
  },
  {
   value: "Eagleville (USEGJ)",
   label: "Eagleville (USEGJ)"
  },
  {
   value: "Eakly (USQEY)",
   label: "Eakly (USQEY)"
  },
  {
   value: "Earl (USERE)",
   label: "Earl (USERE)"
  },
  {
   value: "Earl Park (USEPA)",
   label: "Earl Park (USEPA)"
  },
  {
   value: "Earle (USEAE)",
   label: "Earle (USEAE)"
  },
  {
   value: "Earlington (USQEO)",
   label: "Earlington (USQEO)"
  },
  {
   value: "Earlville (USQEV)",
   label: "Earlville (USQEV)"
  },
  {
   value: "Early Branch (USEYB)",
   label: "Early Branch (USEYB)"
  },
  {
   value: "East Alburg (USEBU)",
   label: "East Alburg (USEBU)"
  },
  {
   value: "East Bangor (USEGB)",
   label: "East Bangor (USEGB)"
  },
  {
   value: "East Bend (USEBD)",
   label: "East Bend (USEBD)"
  },
  {
   value: "East Bernard (USTBE)",
   label: "East Bernard (USTBE)"
  },
  {
   value: "East Bernstadt (USETD)",
   label: "East Bernstadt (USETD)"
  },
  {
   value: "East Bloomfield (USZTB)",
   label: "East Bloomfield (USZTB)"
  },
  {
   value: "East Canton (USECZ)",
   label: "East Canton (USECZ)"
  },
  {
   value: "East Carondelet (USTCD)",
   label: "East Carondelet (USTCD)"
  },
  {
   value: "East Chatham (USEQN)",
   label: "East Chatham (USEQN)"
  },
  {
   value: "East Clinton (USECL)",
   label: "East Clinton (USECL)"
  },
  {
   value: "East Concord (USECX)",
   label: "East Concord (USECX)"
  },
  {
   value: "East Dennis (USTDN)",
   label: "East Dennis (USTDN)"
  },
  {
   value: "East Dorset (USEJO)",
   label: "East Dorset (USEJO)"
  },
  {
   value: "East Dublin (USEDU)",
   label: "East Dublin (USEDU)"
  },
  {
   value: "East Dubuque (USEQE)",
   label: "East Dubuque (USEQE)"
  },
  {
   value: "East Earl (USEE3)",
   label: "East Earl (USEE3)"
  },
  {
   value: "East Elmhurst (USEHU)",
   label: "East Elmhurst (USEHU)"
  },
  {
   value: "East Falmouth (USZEF)",
   label: "East Falmouth (USZEF)"
  },
  {
   value: "East Fayetteville (USYEF)",
   label: "East Fayetteville (USYEF)"
  },
  {
   value: "East Fishkill (USTVK)",
   label: "East Fishkill (USTVK)"
  },
  {
   value: "East Fork (USEFO)",
   label: "East Fork (USEFO)"
  },
  {
   value: "East Freetown (USEFN)",
   label: "East Freetown (USEFN)"
  },
  {
   value: "East Glenville (USEGZ)",
   label: "East Glenville (USEGZ)"
  },
  {
   value: "East Haddam (USTDM)",
   label: "East Haddam (USTDM)"
  },
  {
   value: "East Hampton (USEAH)",
   label: "East Hampton (USEAH)"
  },
  {
   value: "East Hampton (USHTO)",
   label: "East Hampton (USHTO)"
  },
  {
   value: "East Hazel Crest (USEHC)",
   label: "East Hazel Crest (USEHC)"
  },
  {
   value: "East Keansburg (USEKB)",
   label: "East Keansburg (USEKB)"
  },
  {
   value: "East Kingston (USEK8)",
   label: "East Kingston (USEK8)"
  },
  {
   value: "East Lake (USE2A)",
   label: "East Lake (USE2A)"
  },
  {
   value: "East Leroy (USXXY)",
   label: "East Leroy (USXXY)"
  },
  {
   value: "East Liberty (USETY)",
   label: "East Liberty (USETY)"
  },
  {
   value: "East Lyme (USEAY)",
   label: "East Lyme (USEAY)"
  },
  {
   value: "East Machias (USEM7)",
   label: "East Machias (USEM7)"
  },
  {
   value: "East McKeesport (USEQP)",
   label: "East McKeesport (USEQP)"
  },
  {
   value: "East Moriches (USEXM)",
   label: "East Moriches (USEXM)"
  },
  {
   value: "East Norriton (USEIO)",
   label: "East Norriton (USEIO)"
  },
  {
   value: "East Northport (USEAP)",
   label: "East Northport (USEAP)"
  },
  {
   value: "East Orange (USEOG)",
   label: "East Orange (USEOG)"
  },
  {
   value: "East Palestine (USYEP)",
   label: "East Palestine (USYEP)"
  },
  {
   value: "East Patchogue (USEZP)",
   label: "East Patchogue (USEZP)"
  },
  {
   value: "East Penn (USEP5)",
   label: "East Penn (USEP5)"
  },
  {
   value: "East Point (USEPN)",
   label: "East Point (USEPN)"
  },
  {
   value: "East Point (USEPY)",
   label: "East Point (USEPY)"
  },
  {
   value: "East Randolph (USER8)",
   label: "East Randolph (USER8)"
  },
  {
   value: "East Rochester (USERC)",
   label: "East Rochester (USERC)"
  },
  {
   value: "East Rockaway (USEKY)",
   label: "East Rockaway (USEKY)"
  },
  {
   value: "East Setauket (USQET)",
   label: "East Setauket (USQET)"
  },
  {
   value: "East Sparta (USESA)",
   label: "East Sparta (USESA)"
  },
  {
   value: "East Stockton (USKCO)",
   label: "East Stockton (USKCO)"
  },
  {
   value: "East Swanzey (USES2)",
   label: "East Swanzey (USES2)"
  },
  {
   value: "East Taunton (USETU)",
   label: "East Taunton (USETU)"
  },
  {
   value: "East Tawas (USECA)",
   label: "East Tawas (USECA)"
  },
  {
   value: "East Troy (USTYY)",
   label: "East Troy (USTYY)"
  },
  {
   value: "East Walpole (USZEP)",
   label: "East Walpole (USZEP)"
  },
  {
   value: "East Wilton (USEW8)",
   label: "East Wilton (USEW8)"
  },
  {
   value: "East Woodstock (USEW2)",
   label: "East Woodstock (USEW2)"
  },
  {
   value: "Eastaboga (USEBG)",
   label: "Eastaboga (USEBG)"
  },
  {
   value: "Eastham (USEHQ)",
   label: "Eastham (USEHQ)"
  },
  {
   value: "Easton (USESN)",
   label: "Easton (USESN)"
  },
  {
   value: "Easton (USESW)",
   label: "Easton (USESW)"
  },
  {
   value: "Easton (USEZN)",
   label: "Easton (USEZN)"
  },
  {
   value: "Eastpoint (USVVT)",
   label: "Eastpoint (USVVT)"
  },
  {
   value: "Eastpointe (USEP6)",
   label: "Eastpointe (USEP6)"
  },
  {
   value: "Eastsound (USESD)",
   label: "Eastsound (USESD)"
  },
  {
   value: "Eaton (USEAQ)",
   label: "Eaton (USEAQ)"
  },
  {
   value: "Eaton (USETQ)",
   label: "Eaton (USETQ)"
  },
  {
   value: "Eaton Park (USEPK)",
   label: "Eaton Park (USEPK)"
  },
  {
   value: "Eatonville (USETV)",
   label: "Eatonville (USETV)"
  },
  {
   value: "Eau Claire (USEIC)",
   label: "Eau Claire (USEIC)"
  },
  {
   value: "Eclectic (USEC2)",
   label: "Eclectic (USEC2)"
  },
  {
   value: "Eddy (USEJY)",
   label: "Eddy (USEJY)"
  },
  {
   value: "Eddyville (USEDV)",
   label: "Eddyville (USEDV)"
  },
  {
   value: "Eden (USED3)",
   label: "Eden (USED3)"
  },
  {
   value: "Eden (USQED)",
   label: "Eden (USQED)"
  },
  {
   value: "Eden Valley (USZVY)",
   label: "Eden Valley (USZVY)"
  },
  {
   value: "Eden, Concho (USENX)",
   label: "Eden, Concho (USENX)"
  },
  {
   value: "Eden, Nacogdoches (USQEM)",
   label: "Eden, Nacogdoches (USQEM)"
  },
  {
   value: "Edgar (USEGA)",
   label: "Edgar (USEGA)"
  },
  {
   value: "Edgar (USEJR)",
   label: "Edgar (USEJR)"
  },
  {
   value: "Edgartown (USETW)",
   label: "Edgartown (USETW)"
  },
  {
   value: "Edgecomb (USECB)",
   label: "Edgecomb (USECB)"
  },
  {
   value: "Edgemont (USDGM)",
   label: "Edgemont (USDGM)"
  },
  {
   value: "Edgerton (USEN4)",
   label: "Edgerton (USEN4)"
  },
  {
   value: "Edgewater Beach (USEJT)",
   label: "Edgewater Beach (USEJT)"
  },
  {
   value: "Edgewood (USDGO)",
   label: "Edgewood (USDGO)"
  },
  {
   value: "Edgewood (USEDD)",
   label: "Edgewood (USEDD)"
  },
  {
   value: "Edgewood (USEW6)",
   label: "Edgewood (USEW6)"
  },
  {
   value: "Edgewood (USGHW)",
   label: "Edgewood (USGHW)"
  },
  {
   value: "Edgewood, Suffolk (USEW5)",
   label: "Edgewood, Suffolk (USEW5)"
  },
  {
   value: "Edina\/Minneapolis (USEDM)",
   label: "Edina\/Minneapolis (USEDM)"
  },
  {
   value: "Edinboro (USQEB)",
   label: "Edinboro (USQEB)"
  },
  {
   value: "Edisto I. (USDTS)",
   label: "Edisto I. (USDTS)"
  },
  {
   value: "Edmonton (USEDC)",
   label: "Edmonton (USEDC)"
  },
  {
   value: "Edmore (USEM3)",
   label: "Edmore (USEM3)"
  },
  {
   value: "Edneyville (USEVF)",
   label: "Edneyville (USEVF)"
  },
  {
   value: "Edroy (USEY2)",
   label: "Edroy (USEY2)"
  },
  {
   value: "Edson (USZYL)",
   label: "Edson (USZYL)"
  },
  {
   value: "Edwards (USEDZ)",
   label: "Edwards (USEDZ)"
  },
  {
   value: "Edwards (USEGD)",
   label: "Edwards (USEGD)"
  },
  {
   value: "Edwards (USEWA)",
   label: "Edwards (USEWA)"
  },
  {
   value: "Edwards (USEZD)",
   label: "Edwards (USEZD)"
  },
  {
   value: "Edwardsburg (USDWU)",
   label: "Edwardsburg (USDWU)"
  },
  {
   value: "Edwardsville (USDWS)",
   label: "Edwardsville (USDWS)"
  },
  {
   value: "Edwardsville (USEWV)",
   label: "Edwardsville (USEWV)"
  },
  {
   value: "Eek (USEEK)",
   label: "Eek (USEEK)"
  },
  {
   value: "Effie (USEFZ)",
   label: "Effie (USEFZ)"
  },
  {
   value: "Effingham (USEGH)",
   label: "Effingham (USEGH)"
  },
  {
   value: "Effort (USEFT)",
   label: "Effort (USEFT)"
  },
  {
   value: "Egan (USEJA)",
   label: "Egan (USEJA)"
  },
  {
   value: "Egg Harbor (USGGB)",
   label: "Egg Harbor (USGGB)"
  },
  {
   value: "Eglin Air Force Base (USEF2)",
   label: "Eglin Air Force Base (USEF2)"
  },
  {
   value: "Ehrenberg (USEH7)",
   label: "Ehrenberg (USEH7)"
  },
  {
   value: "Eight Fathom Bight (USEFB)",
   label: "Eight Fathom Bight (USEFB)"
  },
  {
   value: "Eighty Four (USEIH)",
   label: "Eighty Four (USEIH)"
  },
  {
   value: "Eitzen (USITZ)",
   label: "Eitzen (USITZ)"
  },
  {
   value: "Ekwok (USKEK)",
   label: "Ekwok (USKEK)"
  },
  {
   value: "El Campo (USECP)",
   label: "El Campo (USECP)"
  },
  {
   value: "El Centro (USECO)",
   label: "El Centro (USECO)"
  },
  {
   value: "El Dorado (USEDJ)",
   label: "El Dorado (USEDJ)"
  },
  {
   value: "El Dorado (USEDK)",
   label: "El Dorado (USEDK)"
  },
  {
   value: "El Dorado Hills (USEHI)",
   label: "El Dorado Hills (USEHI)"
  },
  {
   value: "El Mirage (USEMZ)",
   label: "El Mirage (USEMZ)"
  },
  {
   value: "El Paso (USEPX)",
   label: "El Paso (USEPX)"
  },
  {
   value: "El Prado (USEP4)",
   label: "El Prado (USEP4)"
  },
  {
   value: "El Reno (USQEL)",
   label: "El Reno (USQEL)"
  },
  {
   value: "El Sobrante (USKTK)",
   label: "El Sobrante (USKTK)"
  },
  {
   value: "El Tuma (USS2T)",
   label: "El Tuma (USS2T)"
  },
  {
   value: "Elba (USEBA)",
   label: "Elba (USEBA)"
  },
  {
   value: "Elba (USNYE)",
   label: "Elba (USNYE)"
  },
  {
   value: "Elberon (USKLB)",
   label: "Elberon (USKLB)"
  },
  {
   value: "Elbert (USJLB)",
   label: "Elbert (USJLB)"
  },
  {
   value: "Elbridge (USELG)",
   label: "Elbridge (USELG)"
  },
  {
   value: "Elburn (USEB2)",
   label: "Elburn (USEB2)"
  },
  {
   value: "Eldon (USYED)",
   label: "Eldon (USYED)"
  },
  {
   value: "Eldorado (USDDO)",
   label: "Eldorado (USDDO)"
  },
  {
   value: "Eldorado (USED2)",
   label: "Eldorado (USED2)"
  },
  {
   value: "Eldorado (USEQD)",
   label: "Eldorado (USEQD)"
  },
  {
   value: "Eldridge (USEDR)",
   label: "Eldridge (USEDR)"
  },
  {
   value: "Eldridge (USEID)",
   label: "Eldridge (USEID)"
  },
  {
   value: "Eleanor (USILW)",
   label: "Eleanor (USILW)"
  },
  {
   value: "Eleele (USKHW)",
   label: "Eleele (USKHW)"
  },
  {
   value: "Elgin (USZEG)",
   label: "Elgin (USZEG)"
  },
  {
   value: "Elida (USEI3)",
   label: "Elida (USEI3)"
  },
  {
   value: "Elida (USELX)",
   label: "Elida (USELX)"
  },
  {
   value: "Elizabeth (USEZ8)",
   label: "Elizabeth (USEZ8)"
  },
  {
   value: "Elizabeth (USEZA)",
   label: "Elizabeth (USEZA)"
  },
  {
   value: "Elizabeth (USEZH)",
   label: "Elizabeth (USEZH)"
  },
  {
   value: "Elizabethtown (USEBW)",
   label: "Elizabethtown (USEBW)"
  },
  {
   value: "Elizabethville (USEIZ)",
   label: "Elizabethville (USEIZ)"
  },
  {
   value: "Elk (USKKN)",
   label: "Elk (USKKN)"
  },
  {
   value: "Elk Grove (USEGI)",
   label: "Elk Grove (USEGI)"
  },
  {
   value: "Elk Grove Village (USEVI)",
   label: "Elk Grove Village (USEVI)"
  },
  {
   value: "Elk Point (USE2P)",
   label: "Elk Point (USE2P)"
  },
  {
   value: "Elk River (USER2)",
   label: "Elk River (USER2)"
  },
  {
   value: "Elka Park (USEP2)",
   label: "Elka Park (USEP2)"
  },
  {
   value: "Elkader (USQEK)",
   label: "Elkader (USQEK)"
  },
  {
   value: "Elkhart (USEKF)",
   label: "Elkhart (USEKF)"
  },
  {
   value: "Elkhart (USEKH)",
   label: "Elkhart (USEKH)"
  },
  {
   value: "Elkhart (USEKJ)",
   label: "Elkhart (USEKJ)"
  },
  {
   value: "Elkhart Lake (USEKK)",
   label: "Elkhart Lake (USEKK)"
  },
  {
   value: "Elkhorn (USEKR)",
   label: "Elkhorn (USEKR)"
  },
  {
   value: "Elkin (USEIN)",
   label: "Elkin (USEIN)"
  },
  {
   value: "Elkins Park (USEIK)",
   label: "Elkins Park (USEIK)"
  },
  {
   value: "Elkmont (USZEM)",
   label: "Elkmont (USZEM)"
  },
  {
   value: "Elkton (USEKM)",
   label: "Elkton (USEKM)"
  },
  {
   value: "Elkton (USEKT)",
   label: "Elkton (USEKT)"
  },
  {
   value: "Elkton (USEKZ)",
   label: "Elkton (USEKZ)"
  },
  {
   value: "Elkton (USQKO)",
   label: "Elkton (USQKO)"
  },
  {
   value: "Elkton (USYEK)",
   label: "Elkton (USYEK)"
  },
  {
   value: "Elkview (USEKE)",
   label: "Elkview (USEKE)"
  },
  {
   value: "Elkwood (USEKW)",
   label: "Elkwood (USEKW)"
  },
  {
   value: "Ellabell (USEBZ)",
   label: "Ellabell (USEBZ)"
  },
  {
   value: "Ellaville (USZEV)",
   label: "Ellaville (USZEV)"
  },
  {
   value: "Ellenboro (USYEB)",
   label: "Ellenboro (USYEB)"
  },
  {
   value: "Ellenton (USENJ)",
   label: "Ellenton (USENJ)"
  },
  {
   value: "Ellenville (USEV3)",
   label: "Ellenville (USEV3)"
  },
  {
   value: "Ellenwood (USZEW)",
   label: "Ellenwood (USZEW)"
  },
  {
   value: "Ellettsville (USZEN)",
   label: "Ellettsville (USZEN)"
  },
  {
   value: "Ellicott City (USECC)",
   label: "Ellicott City (USECC)"
  },
  {
   value: "Ellicottville (USECV)",
   label: "Ellicottville (USECV)"
  },
  {
   value: "Ellijay (USELJ)",
   label: "Ellijay (USELJ)"
  },
  {
   value: "Ellington (USEJG)",
   label: "Ellington (USEJG)"
  },
  {
   value: "Ellington (USZET)",
   label: "Ellington (USZET)"
  },
  {
   value: "Ellis (USEIJ)",
   label: "Ellis (USEIJ)"
  },
  {
   value: "Ellisdale (USESJ)",
   label: "Ellisdale (USESJ)"
  },
  {
   value: "Elliston (USEIT)",
   label: "Elliston (USEIT)"
  },
  {
   value: "Ellisville (USEVE)",
   label: "Ellisville (USEVE)"
  },
  {
   value: "Ellport (USEQZ)",
   label: "Ellport (USEQZ)"
  },
  {
   value: "Ellsworth (USESR)",
   label: "Ellsworth (USESR)"
  },
  {
   value: "Ellsworth (USEXH)",
   label: "Ellsworth (USEXH)"
  },
  {
   value: "Ellsworth (USZC6)",
   label: "Ellsworth (USZC6)"
  },
  {
   value: "Ellsworth Air Force Base (USEHB)",
   label: "Ellsworth Air Force Base (USEHB)"
  },
  {
   value: "Ellwood (USEL3)",
   label: "Ellwood (USEL3)"
  },
  {
   value: "Elm (USEM6)",
   label: "Elm (USEM6)"
  },
  {
   value: "Elm Creek (USEQC)",
   label: "Elm Creek (USEQC)"
  },
  {
   value: "Elm Grove (USEXV)",
   label: "Elm Grove (USEXV)"
  },
  {
   value: "Elm Mott (USEQM)",
   label: "Elm Mott (USEQM)"
  },
  {
   value: "Elm Springs (USESQ)",
   label: "Elm Springs (USESQ)"
  },
  {
   value: "Elma (USEAW)",
   label: "Elma (USEAW)"
  },
  {
   value: "Elma (USEFA)",
   label: "Elma (USEFA)"
  },
  {
   value: "Elma, Erie (USEL2)",
   label: "Elma, Erie (USEL2)"
  },
  {
   value: "Elmendorf Air Force Base (USZC7)",
   label: "Elmendorf Air Force Base (USZC7)"
  },
  {
   value: "Elmhurst (USEH2)",
   label: "Elmhurst (USEH2)"
  },
  {
   value: "Elmont (USQDM)",
   label: "Elmont (USQDM)"
  },
  {
   value: "Elmore (USEMJ)",
   label: "Elmore (USEMJ)"
  },
  {
   value: "Elmore (USEXO)",
   label: "Elmore (USEXO)"
  },
  {
   value: "Elmwood (USEWX)",
   label: "Elmwood (USEWX)"
  },
  {
   value: "Elmwood (USEXW)",
   label: "Elmwood (USEXW)"
  },
  {
   value: "Elmwood (USIMZ)",
   label: "Elmwood (USIMZ)"
  },
  {
   value: "Elmwood, Pierce (USEW3)",
   label: "Elmwood, Pierce (USEW3)"
  },
  {
   value: "Elon (USQEN)",
   label: "Elon (USQEN)"
  },
  {
   value: "Elora (USREU)",
   label: "Elora (USREU)"
  },
  {
   value: "Eloy (USEOY)",
   label: "Eloy (USEOY)"
  },
  {
   value: "Elroy (USERY)",
   label: "Elroy (USERY)"
  },
  {
   value: "Elsberry (USEEY)",
   label: "Elsberry (USEEY)"
  },
  {
   value: "Elsmere (USEM2)",
   label: "Elsmere (USEM2)"
  },
  {
   value: "Elton (USEJQ)",
   label: "Elton (USEJQ)"
  },
  {
   value: "Elton (USOAO)",
   label: "Elton (USOAO)"
  },
  {
   value: "Elverson (USEVO)",
   label: "Elverson (USEVO)"
  },
  {
   value: "Elwood (USEQW)",
   label: "Elwood (USEQW)"
  },
  {
   value: "Elwood (USEWQ)",
   label: "Elwood (USEWQ)"
  },
  {
   value: "Elysburg (USEYS)",
   label: "Elysburg (USEYS)"
  },
  {
   value: "Emerald Isle (USZZX)",
   label: "Emerald Isle (USZZX)"
  },
  {
   value: "Emerson (USEQS)",
   label: "Emerson (USEQS)"
  },
  {
   value: "Emerson (USIAE)",
   label: "Emerson (USIAE)"
  },
  {
   value: "Emery (USEMY)",
   label: "Emery (USEMY)"
  },
  {
   value: "Emily (USEY8)",
   label: "Emily (USEY8)"
  },
  {
   value: "Eminence (USEN2)",
   label: "Eminence (USEN2)"
  },
  {
   value: "Emlenton (USEMX)",
   label: "Emlenton (USEMX)"
  },
  {
   value: "Emmaus (USEMU)",
   label: "Emmaus (USEMU)"
  },
  {
   value: "Emmetsburg (USEMG)",
   label: "Emmetsburg (USEMG)"
  },
  {
   value: "Emmonak (USEMK)",
   label: "Emmonak (USEMK)"
  },
  {
   value: "Emory (USYEM)",
   label: "Emory (USYEM)"
  },
  {
   value: "Empire (USEP8)",
   label: "Empire (USEP8)"
  },
  {
   value: "Empire (USEPE)",
   label: "Empire (USEPE)"
  },
  {
   value: "Empire (USEPW)",
   label: "Empire (USEPW)"
  },
  {
   value: "Emporia (USERA)",
   label: "Emporia (USERA)"
  },
  {
   value: "Emsworth (USEMH)",
   label: "Emsworth (USEMH)"
  },
  {
   value: "Encino (USECF)",
   label: "Encino (USECF)"
  },
  {
   value: "Enderlin (USEEQ)",
   label: "Enderlin (USEEQ)"
  },
  {
   value: "Endicott (USENC)",
   label: "Endicott (USENC)"
  },
  {
   value: "Energy (USERG)",
   label: "Energy (USERG)"
  },
  {
   value: "Enfield (USEFL)",
   label: "Enfield (USEFL)"
  },
  {
   value: "England (USEAD)",
   label: "England (USEAD)"
  },
  {
   value: "Englevale (USNGE)",
   label: "Englevale (USNGE)"
  },
  {
   value: "Englewood (USEEW)",
   label: "Englewood (USEEW)"
  },
  {
   value: "Englewood (USEW4)",
   label: "Englewood (USEW4)"
  },
  {
   value: "Englewood (USOZ2)",
   label: "Englewood (USOZ2)"
  },
  {
   value: "Englewood (USXEW)",
   label: "Englewood (USXEW)"
  },
  {
   value: "English (USEN3)",
   label: "English (USEN3)"
  },
  {
   value: "English Bay (USKEB)",
   label: "English Bay (USKEB)"
  },
  {
   value: "Enigma (USEIM)",
   label: "Enigma (USEIM)"
  },
  {
   value: "Enochs (USEOJ)",
   label: "Enochs (USEOJ)"
  },
  {
   value: "Enon (USENM)",
   label: "Enon (USENM)"
  },
  {
   value: "Enon Valley (USOYU)",
   label: "Enon Valley (USOYU)"
  },
  {
   value: "Enosburg Falls (USEBF)",
   label: "Enosburg Falls (USEBF)"
  },
  {
   value: "Ensley (USENS)",
   label: "Ensley (USENS)"
  },
  {
   value: "Enterprise (USENP)",
   label: "Enterprise (USENP)"
  },
  {
   value: "Enterprise (USEPP)",
   label: "Enterprise (USEPP)"
  },
  {
   value: "Enterprise, Washington (USEEP)",
   label: "Enterprise, Washington (USEEP)"
  },
  {
   value: "Enumclaw (USECW)",
   label: "Enumclaw (USECW)"
  },
  {
   value: "Eolia (USEQI)",
   label: "Eolia (USEQI)"
  },
  {
   value: "Ephraim (USERM)",
   label: "Ephraim (USERM)"
  },
  {
   value: "Equality (USQIY)",
   label: "Equality (USQIY)"
  },
  {
   value: "Erial (USQRL)",
   label: "Erial (USQRL)"
  },
  {
   value: "Erie (USEE2)",
   label: "Erie (USEE2)"
  },
  {
   value: "Erin (USERJ)",
   label: "Erin (USERJ)"
  },
  {
   value: "Errol (USERR)",
   label: "Errol (USERR)"
  },
  {
   value: "Erving (USER4)",
   label: "Erving (USER4)"
  },
  {
   value: "Erwins (USQEW)",
   label: "Erwins (USQEW)"
  },
  {
   value: "Escalon (USEXC)",
   label: "Escalon (USEXC)"
  },
  {
   value: "Eskdale (USEKL)",
   label: "Eskdale (USEKL)"
  },
  {
   value: "Esko (USEKQ)",
   label: "Esko (USEKQ)"
  },
  {
   value: "Esparto (USEZO)",
   label: "Esparto (USEZO)"
  },
  {
   value: "Esperance (USEPZ)",
   label: "Esperance (USEPZ)"
  },
  {
   value: "Essex (USESE)",
   label: "Essex (USESE)"
  },
  {
   value: "Essex Fells (USEXF)",
   label: "Essex Fells (USEXF)"
  },
  {
   value: "Essexville (USEXY)",
   label: "Essexville (USEXY)"
  },
  {
   value: "Estero (USESG)",
   label: "Estero (USESG)"
  },
  {
   value: "Estill Springs (USETZ)",
   label: "Estill Springs (USETZ)"
  },
  {
   value: "Ether (USETH)",
   label: "Ether (USETH)"
  },
  {
   value: "Ethridge (USEHG)",
   label: "Ethridge (USEHG)"
  },
  {
   value: "Ethridge (USTDG)",
   label: "Ethridge (USTDG)"
  },
  {
   value: "Etna (USE2T)",
   label: "Etna (USE2T)"
  },
  {
   value: "Etna (USET2)",
   label: "Etna (USET2)"
  },
  {
   value: "Etna (USET3)",
   label: "Etna (USET3)"
  },
  {
   value: "Etna (USXTA)",
   label: "Etna (USXTA)"
  },
  {
   value: "Eton (USETG)",
   label: "Eton (USETG)"
  },
  {
   value: "Etowah (USTWP)",
   label: "Etowah (USTWP)"
  },
  {
   value: "Etter (USETT)",
   label: "Etter (USETT)"
  },
  {
   value: "Eudora (USEUD)",
   label: "Eudora (USEUD)"
  },
  {
   value: "Eugene (USEUN)",
   label: "Eugene (USEUN)"
  },
  {
   value: "Eunice (USEUJ)",
   label: "Eunice (USEUJ)"
  },
  {
   value: "Eunice (USUCE)",
   label: "Eunice (USUCE)"
  },
  {
   value: "Eupora (USEUP)",
   label: "Eupora (USEUP)"
  },
  {
   value: "Eureka (USEUE)",
   label: "Eureka (USEUE)"
  },
  {
   value: "Eureka (USUKC)",
   label: "Eureka (USUKC)"
  },
  {
   value: "Eureka, Perry (USEUK)",
   label: "Eureka, Perry (USEUK)"
  },
  {
   value: "Eureka, St Louis (USEUR)",
   label: "Eureka, St Louis (USEUR)"
  },
  {
   value: "Eustis (USEUT)",
   label: "Eustis (USEUT)"
  },
  {
   value: "Evadale (USAE2)",
   label: "Evadale (USAE2)"
  },
  {
   value: "Evansville (USESV)",
   label: "Evansville (USESV)"
  },
  {
   value: "Evansville (USEVK)",
   label: "Evansville (USEVK)"
  },
  {
   value: "Evansville (USEVN)",
   label: "Evansville (USEVN)"
  },
  {
   value: "Evansville (USVNI)",
   label: "Evansville (USVNI)"
  },
  {
   value: "Evant (USEVJ)",
   label: "Evant (USEVJ)"
  },
  {
   value: "Evart (USEV2)",
   label: "Evart (USEV2)"
  },
  {
   value: "Everett (USEV4)",
   label: "Everett (USEV4)"
  },
  {
   value: "Everett (USEVZ)",
   label: "Everett (USEVZ)"
  },
  {
   value: "Everetts (USZC8)",
   label: "Everetts (USZC8)"
  },
  {
   value: "Everglades City (USEFG)",
   label: "Everglades City (USEFG)"
  },
  {
   value: "Evergreen (USVGC)",
   label: "Evergreen (USVGC)"
  },
  {
   value: "Evergreen (USYEG)",
   label: "Evergreen (USYEG)"
  },
  {
   value: "Evergreen Park (USEP3)",
   label: "Evergreen Park (USEP3)"
  },
  {
   value: "Everson (USC9)",
   label: "Everson (USC9)"
  },
  {
   value: "Everson (USVSO)",
   label: "Everson (USVSO)"
  },
  {
   value: "Ewing (USEG2)",
   label: "Ewing (USEG2)"
  },
  {
   value: "Ewing (USQEI)",
   label: "Ewing (USQEI)"
  },
  {
   value: "Excelsior (USEXZ)",
   label: "Excelsior (USEXZ)"
  },
  {
   value: "Excelsior Springs (USZEO)",
   label: "Excelsior Springs (USZEO)"
  },
  {
   value: "Excursion Inlet (USEXI)",
   label: "Excursion Inlet (USEXI)"
  },
  {
   value: "Exeland (USEXD)",
   label: "Exeland (USEXD)"
  },
  {
   value: "Exeter (USEXR)",
   label: "Exeter (USEXR)"
  },
  {
   value: "Fair Haven (USFAA)",
   label: "Fair Haven (USFAA)"
  },
  {
   value: "Fair Haven (USFH2)",
   label: "Fair Haven (USFH2)"
  },
  {
   value: "Fair Haven (USRHV)",
   label: "Fair Haven (USRHV)"
  },
  {
   value: "Fair Oaks (USFOS)",
   label: "Fair Oaks (USFOS)"
  },
  {
   value: "Fair Oaks (USFXR)",
   label: "Fair Oaks (USFXR)"
  },
  {
   value: "Fair Oaks (USYFO)",
   label: "Fair Oaks (USYFO)"
  },
  {
   value: "Fair Play (USRPY)",
   label: "Fair Play (USRPY)"
  },
  {
   value: "Fair View (USAIW)",
   label: "Fair View (USAIW)"
  },
  {
   value: "Fairburn (USFBN)",
   label: "Fairburn (USFBN)"
  },
  {
   value: "Fairchild Air Force Base (USFBS)",
   label: "Fairchild Air Force Base (USFBS)"
  },
  {
   value: "Fairdale (USFIA)",
   label: "Fairdale (USFIA)"
  },
  {
   value: "Fairfax (USAIF)",
   label: "Fairfax (USAIF)"
  },
  {
   value: "Fairfax (USAIX)",
   label: "Fairfax (USAIX)"
  },
  {
   value: "Fairfax (USFF2)",
   label: "Fairfax (USFF2)"
  },
  {
   value: "Fairfax (USFFP)",
   label: "Fairfax (USFFP)"
  },
  {
   value: "Fairfax (USFYA)",
   label: "Fairfax (USFYA)"
  },
  {
   value: "Fairfax (USRFX)",
   label: "Fairfax (USRFX)"
  },
  {
   value: "Fairfax, Hamilton (USFXO)",
   label: "Fairfax, Hamilton (USFXO)"
  },
  {
   value: "Fairfield (USFAD)",
   label: "Fairfield (USFAD)"
  },
  {
   value: "Fairfield (USFFE)",
   label: "Fairfield (USFFE)"
  },
  {
   value: "Fairfield (USFFI)",
   label: "Fairfield (USFFI)"
  },
  {
   value: "Fairfield (USFFV)",
   label: "Fairfield (USFFV)"
  },
  {
   value: "Fairfield (USYFE)",
   label: "Fairfield (USYFE)"
  },
  {
   value: "Fairfield (USYFL)",
   label: "Fairfield (USYFL)"
  },
  {
   value: "Fairhope (USFH3)",
   label: "Fairhope (USFH3)"
  },
  {
   value: "Fairland (USFAJ)",
   label: "Fairland (USFAJ)"
  },
  {
   value: "Fairland (USFDN)",
   label: "Fairland (USFDN)"
  },
  {
   value: "Fairlawn (USFL3)",
   label: "Fairlawn (USFL3)"
  },
  {
   value: "Fairmont City (USQFC)",
   label: "Fairmont City (USQFC)"
  },
  {
   value: "Fairmont City (USQFY)",
   label: "Fairmont City (USQFY)"
  },
  {
   value: "Fairmont, Will (USFMW)",
   label: "Fairmont, Will (USFMW)"
  },
  {
   value: "Fairmount (USFIO)",
   label: "Fairmount (USFIO)"
  },
  {
   value: "Fairmount (USFQX)",
   label: "Fairmount (USFQX)"
  },
  {
   value: "Fairplay (USFPD)",
   label: "Fairplay (USFPD)"
  },
  {
   value: "Fairview (USF2R)",
   label: "Fairview (USF2R)"
  },
  {
   value: "Fairview (USFEW)",
   label: "Fairview (USFEW)"
  },
  {
   value: "Fairview (USFV8)",
   label: "Fairview (USFV8)"
  },
  {
   value: "Fairview (USFVE)",
   label: "Fairview (USFVE)"
  },
  {
   value: "Fairview (USFVK)",
   label: "Fairview (USFVK)"
  },
  {
   value: "Fairview (USIVW)",
   label: "Fairview (USIVW)"
  },
  {
   value: "Fairview Heights (USFIH)",
   label: "Fairview Heights (USFIH)"
  },
  {
   value: "Fairwater (USFW3)",
   label: "Fairwater (USFW3)"
  },
  {
   value: "Falconer (USAOR)",
   label: "Falconer (USAOR)"
  },
  {
   value: "Falfurrias (USFFH)",
   label: "Falfurrias (USFFH)"
  },
  {
   value: "Falkville (USFKV)",
   label: "Falkville (USFKV)"
  },
  {
   value: "Fall Creek (USFFK)",
   label: "Fall Creek (USFFK)"
  },
  {
   value: "Fall River (USFAV)",
   label: "Fall River (USFAV)"
  },
  {
   value: "Fall River (USFAZ)",
   label: "Fall River (USFAZ)"
  },
  {
   value: "Falling Waters (USFNW)",
   label: "Falling Waters (USFNW)"
  },
  {
   value: "Falls Bay (USFLJ)",
   label: "Falls Bay (USFLJ)"
  },
  {
   value: "Falls City (USFJI)",
   label: "Falls City (USFJI)"
  },
  {
   value: "Falls City (USFSY)",
   label: "Falls City (USFSY)"
  },
  {
   value: "Falls Creek (USFXK)",
   label: "Falls Creek (USFXK)"
  },
  {
   value: "Fallsington (USFAS)",
   label: "Fallsington (USFAS)"
  },
  {
   value: "Fallston (USFL2)",
   label: "Fallston (USFL2)"
  },
  {
   value: "Fallston (USFS2)",
   label: "Fallston (USFS2)"
  },
  {
   value: "Falmouth (USFMH)",
   label: "Falmouth (USFMH)"
  },
  {
   value: "Falmouth (USFQZ)",
   label: "Falmouth (USFQZ)"
  },
  {
   value: "Falmouth (USFUA)",
   label: "Falmouth (USFUA)"
  },
  {
   value: "False Island (USFAK)",
   label: "False Island (USFAK)"
  },
  {
   value: "False Pass (USKFP)",
   label: "False Pass (USKFP)"
  },
  {
   value: "Far Hills (USFHS)",
   label: "Far Hills (USFHS)"
  },
  {
   value: "Far Rockaway, Queens (USFR2)",
   label: "Far Rockaway, Queens (USFR2)"
  },
  {
   value: "Farewell (USFWL)",
   label: "Farewell (USFWL)"
  },
  {
   value: "Fargo (USZFG)",
   label: "Fargo (USZFG)"
  },
  {
   value: "Farley (USFY4)",
   label: "Farley (USFY4)"
  },
  {
   value: "Farmersburg (USFSB)",
   label: "Farmersburg (USFSB)"
  },
  {
   value: "Farmerville (USFVF)",
   label: "Farmerville (USFVF)"
  },
  {
   value: "Farmington (USFGJ)",
   label: "Farmington (USFGJ)"
  },
  {
   value: "Farmington (USFGT)",
   label: "Farmington (USFGT)"
  },
  {
   value: "Farmington (USFIG)",
   label: "Farmington (USFIG)"
  },
  {
   value: "Farmington (USFZM)",
   label: "Farmington (USFZM)"
  },
  {
   value: "Farmington (USZYQ)",
   label: "Farmington (USZYQ)"
  },
  {
   value: "Farmington Hill (USQFM)",
   label: "Farmington Hill (USQFM)"
  },
  {
   value: "Farmington, Fayette (USFNG)",
   label: "Farmington, Fayette (USFNG)"
  },
  {
   value: "Farnam (USFNA)",
   label: "Farnam (USFNA)"
  },
  {
   value: "Farragut (USFGU)",
   label: "Farragut (USFGU)"
  },
  {
   value: "Farragut (USFJR)",
   label: "Farragut (USFJR)"
  },
  {
   value: "Farrell (USFAP)",
   label: "Farrell (USFAP)"
  },
  {
   value: "Farwell (USFW8)",
   label: "Farwell (USFW8)"
  },
  {
   value: "Fate (USFXA)",
   label: "Fate (USFXA)"
  },
  {
   value: "Faulkton (USFKO)",
   label: "Faulkton (USFKO)"
  },
  {
   value: "Fawn Grove (USFGR)",
   label: "Fawn Grove (USFGR)"
  },
  {
   value: "Fayette (USFQT)",
   label: "Fayette (USFQT)"
  },
  {
   value: "Fayette (USFY7)",
   label: "Fayette (USFY7)"
  },
  {
   value: "Fayette (USYET)",
   label: "Fayette (USYET)"
  },
  {
   value: "Fayette (USZFY)",
   label: "Fayette (USZFY)"
  },
  {
   value: "Fayetteville (USFYE)",
   label: "Fayetteville (USFYE)"
  },
  {
   value: "Fayetteville (USFYZ)",
   label: "Fayetteville (USFYZ)"
  },
  {
   value: "Feeding Hills (USFGH)",
   label: "Feeding Hills (USFGH)"
  },
  {
   value: "Felda (USFA2)",
   label: "Felda (USFA2)"
  },
  {
   value: "Fellsmere (USFEL)",
   label: "Fellsmere (USFEL)"
  },
  {
   value: "Felt (USFEK)",
   label: "Felt (USFEK)"
  },
  {
   value: "Felton (USFEX)",
   label: "Felton (USFEX)"
  },
  {
   value: "Fennville (USFEJ)",
   label: "Fennville (USFEJ)"
  },
  {
   value: "Fenton (USFNO)",
   label: "Fenton (USFNO)"
  },
  {
   value: "Fenton (USIFN)",
   label: "Fenton (USIFN)"
  },
  {
   value: "Fentress (USFTR)",
   label: "Fentress (USFTR)"
  },
  {
   value: "Ferguson (USZGU)",
   label: "Ferguson (USZGU)"
  },
  {
   value: "Ferndale (USQFE)",
   label: "Ferndale (USQFE)"
  },
  {
   value: "Ferndale (USQFN)",
   label: "Ferndale (USQFN)"
  },
  {
   value: "Fernwood (USFIQ)",
   label: "Fernwood (USFIQ)"
  },
  {
   value: "Ferriday (USQFI)",
   label: "Ferriday (USQFI)"
  },
  {
   value: "Ferris (USFEI)",
   label: "Ferris (USFEI)"
  },
  {
   value: "Fessenden (USFNU)",
   label: "Fessenden (USFNU)"
  },
  {
   value: "Festus (USFUS)",
   label: "Festus (USFUS)"
  },
  {
   value: "Fieldale (USFIE)",
   label: "Fieldale (USFIE)"
  },
  {
   value: "Fifty Lakes (USFYL)",
   label: "Fifty Lakes (USFYL)"
  },
  {
   value: "Filer City (USFTY)",
   label: "Filer City (USFTY)"
  },
  {
   value: "Fillmore (USFIL)",
   label: "Fillmore (USFIL)"
  },
  {
   value: "Fillmore (USFIM)",
   label: "Fillmore (USFIM)"
  },
  {
   value: "Fincastle (USFJC)",
   label: "Fincastle (USFJC)"
  },
  {
   value: "Findlay (USFY8)",
   label: "Findlay (USFY8)"
  },
  {
   value: "Fink Creek (USFNK)",
   label: "Fink Creek (USFNK)"
  },
  {
   value: "Finley (USFEY)",
   label: "Finley (USFEY)"
  },
  {
   value: "Finleyville (USFYI)",
   label: "Finleyville (USFYI)"
  },
  {
   value: "Fircrest (USFZT)",
   label: "Fircrest (USFZT)"
  },
  {
   value: "Firestone (USRTC)",
   label: "Firestone (USRTC)"
  },
  {
   value: "Firth (USFHQ)",
   label: "Firth (USFHQ)"
  },
  {
   value: "Firth (USIRH)",
   label: "Firth (USIRH)"
  },
  {
   value: "Fisher (USFHR)",
   label: "Fisher (USFHR)"
  },
  {
   value: "Fisher Island, Miami (USZFI)",
   label: "Fisher Island, Miami (USZFI)"
  },
  {
   value: "Fishers (USFSH)",
   label: "Fishers (USFSH)"
  },
  {
   value: "Fishers (USOQQ)",
   label: "Fishers (USOQQ)"
  },
  {
   value: "Fishertown (USFSW)",
   label: "Fishertown (USFSW)"
  },
  {
   value: "Fishkill (USFIK)",
   label: "Fishkill (USFIK)"
  },
  {
   value: "Fiskdale (USFKD)",
   label: "Fiskdale (USFKD)"
  },
  {
   value: "Fiskeville (USKFI)",
   label: "Fiskeville (USKFI)"
  },
  {
   value: "Fithian (USIHN)",
   label: "Fithian (USIHN)"
  },
  {
   value: "Fitzwilliam (USFZW)",
   label: "Fitzwilliam (USFZW)"
  },
  {
   value: "Five Mile (USFMC)",
   label: "Five Mile (USFMC)"
  },
  {
   value: "Five Points (USFIP)",
   label: "Five Points (USFIP)"
  },
  {
   value: "Flagler Beach (USFBF)",
   label: "Flagler Beach (USFBF)"
  },
  {
   value: "Flagtown (USFTO)",
   label: "Flagtown (USFTO)"
  },
  {
   value: "Flandreau (USYFD)",
   label: "Flandreau (USYFD)"
  },
  {
   value: "Flat (USFLT)",
   label: "Flat (USFLT)"
  },
  {
   value: "Flat Rock (USLTK)",
   label: "Flat Rock (USLTK)"
  },
  {
   value: "Flat Rock (USLTR)",
   label: "Flat Rock (USLTR)"
  },
  {
   value: "Flatonia (USFTP)",
   label: "Flatonia (USFTP)"
  },
  {
   value: "Flaxman Island (USFXM)",
   label: "Flaxman Island (USFXM)"
  },
  {
   value: "Flemingsburg (USFMB)",
   label: "Flemingsburg (USFMB)"
  },
  {
   value: "Fletcher (USYFH)",
   label: "Fletcher (USYFH)"
  },
  {
   value: "Flinton (USFZN)",
   label: "Flinton (USFZN)"
  },
  {
   value: "Flintstone (USZDB)",
   label: "Flintstone (USZDB)"
  },
  {
   value: "Flippin (USFPP)",
   label: "Flippin (USFPP)"
  },
  {
   value: "Flomaton (USFMM)",
   label: "Flomaton (USFMM)"
  },
  {
   value: "Floodwood (USFW2)",
   label: "Floodwood (USFW2)"
  },
  {
   value: "Flora (USFOM)",
   label: "Flora (USFOM)"
  },
  {
   value: "Florence (USFCE)",
   label: "Florence (USFCE)"
  },
  {
   value: "Florence (USFLZ)",
   label: "Florence (USFLZ)"
  },
  {
   value: "Florence (USFNE)",
   label: "Florence (USFNE)"
  },
  {
   value: "Florence (USFQE)",
   label: "Florence (USFQE)"
  },
  {
   value: "Florence (USFR7)",
   label: "Florence (USFR7)"
  },
  {
   value: "Florence (USOEE)",
   label: "Florence (USOEE)"
  },
  {
   value: "Florence (USOEZ)",
   label: "Florence (USOEZ)"
  },
  {
   value: "Florence (USZZO)",
   label: "Florence (USZZO)"
  },
  {
   value: "Florham Park (USFP2)",
   label: "Florham Park (USFP2)"
  },
  {
   value: "Florida (USFOA)",
   label: "Florida (USFOA)"
  },
  {
   value: "Florida City (USYFA)",
   label: "Florida City (USYFA)"
  },
  {
   value: "Florien (USFMD)",
   label: "Florien (USFMD)"
  },
  {
   value: "Flossmoor (USFSX)",
   label: "Flossmoor (USFSX)"
  },
  {
   value: "Flourtown (USFOQ)",
   label: "Flourtown (USFOQ)"
  },
  {
   value: "Flower Mound (USXFG)",
   label: "Flower Mound (USXFG)"
  },
  {
   value: "Floyd (USVAF)",
   label: "Floyd (USVAF)"
  },
  {
   value: "Foley (USNHX)",
   label: "Foley (USNHX)"
  },
  {
   value: "Folkston (USFON)",
   label: "Folkston (USFON)"
  },
  {
   value: "Follett (USF2L)",
   label: "Follett (USF2L)"
  },
  {
   value: "Folly Beach (USFYB)",
   label: "Folly Beach (USFYB)"
  },
  {
   value: "Folsom (USFM3)",
   label: "Folsom (USFM3)"
  },
  {
   value: "Fombell (USOMY)",
   label: "Fombell (USOMY)"
  },
  {
   value: "Fonda (USFOY)",
   label: "Fonda (USFOY)"
  },
  {
   value: "Fontana (USFJO)",
   label: "Fontana (USFJO)"
  },
  {
   value: "Foothill Farms (USFHH)",
   label: "Foothill Farms (USFHH)"
  },
  {
   value: "Foothill Ranch (USFOH)",
   label: "Foothill Ranch (USFOH)"
  },
  {
   value: "Ford Heights (USFHG)",
   label: "Ford Heights (USFHG)"
  },
  {
   value: "Fordyce (USFDC)",
   label: "Fordyce (USFDC)"
  },
  {
   value: "Foreman (USFM8)",
   label: "Foreman (USFM8)"
  },
  {
   value: "Forest City (USFCC)",
   label: "Forest City (USFCC)"
  },
  {
   value: "Forest City (USFZC)",
   label: "Forest City (USFZC)"
  },
  {
   value: "Forest Dale (USFSQ)",
   label: "Forest Dale (USFSQ)"
  },
  {
   value: "Forest Hill (USFES)",
   label: "Forest Hill (USFES)"
  },
  {
   value: "Forest Hill (USFH8)",
   label: "Forest Hill (USFH8)"
  },
  {
   value: "Forest Hills\/Queens\/New York (USFHL)",
   label: "Forest Hills\/Queens\/New York (USFHL)"
  },
  {
   value: "Forest, Hardin (USFVO)",
   label: "Forest, Hardin (USFVO)"
  },
  {
   value: "Forestville (USFV7)",
   label: "Forestville (USFV7)"
  },
  {
   value: "Foristell (USFGE)",
   label: "Foristell (USFGE)"
  },
  {
   value: "Fork Union (USFKU)",
   label: "Fork Union (USFKU)"
  },
  {
   value: "Forked River (USFDV)",
   label: "Forked River (USFDV)"
  },
  {
   value: "Forksville (USFXZ)",
   label: "Forksville (USFXZ)"
  },
  {
   value: "Forrest (USFZE)",
   label: "Forrest (USFZE)"
  },
  {
   value: "Forsan (USFS7)",
   label: "Forsan (USFS7)"
  },
  {
   value: "Forsyth (USFYH)",
   label: "Forsyth (USFYH)"
  },
  {
   value: "Forsyth (USZYF)",
   label: "Forsyth (USZYF)"
  },
  {
   value: "Fort Ashby (USFBI)",
   label: "Fort Ashby (USFBI)"
  },
  {
   value: "Fort Atkinson (USFKS)",
   label: "Fort Atkinson (USFKS)"
  },
  {
   value: "Fort Benning (USLSF)",
   label: "Fort Benning (USLSF)"
  },
  {
   value: "Fort Benton (USFBO)",
   label: "Fort Benton (USFBO)"
  },
  {
   value: "Fort Bliss (USYFB)",
   label: "Fort Bliss (USYFB)"
  },
  {
   value: "Fort Bragg (USFBG)",
   label: "Fort Bragg (USFBG)"
  },
  {
   value: "Fort Branch (USFTH)",
   label: "Fort Branch (USFTH)"
  },
  {
   value: "Fort Bridger (USFBR)",
   label: "Fort Bridger (USFBR)"
  },
  {
   value: "Fort Calhoun (USFTC)",
   label: "Fort Calhoun (USFTC)"
  },
  {
   value: "Fort Campbell (USFCM)",
   label: "Fort Campbell (USFCM)"
  },
  {
   value: "Fort Carson (USCFZ)",
   label: "Fort Carson (USCFZ)"
  },
  {
   value: "Fort Chaffee (USCCA)",
   label: "Fort Chaffee (USCCA)"
  },
  {
   value: "Fort Davis (USQFA)",
   label: "Fort Davis (USQFA)"
  },
  {
   value: "Fort Deposit (USFUP)",
   label: "Fort Deposit (USFUP)"
  },
  {
   value: "Fort Devens (USAYE)",
   label: "Fort Devens (USAYE)"
  },
  {
   value: "Fort Drum (USFR8)",
   label: "Fort Drum (USFR8)"
  },
  {
   value: "Fort Drum (USFUW)",
   label: "Fort Drum (USFUW)"
  },
  {
   value: "Fort Fairfield (USFFF)",
   label: "Fort Fairfield (USFFF)"
  },
  {
   value: "Fort Gay (USFQG)",
   label: "Fort Gay (USFQG)"
  },
  {
   value: "Fort George G Meade (USFGA)",
   label: "Fort George G Meade (USFGA)"
  },
  {
   value: "Fort Gibson (USFTS)",
   label: "Fort Gibson (USFTS)"
  },
  {
   value: "Fort Gordon (USZDD)",
   label: "Fort Gordon (USZDD)"
  },
  {
   value: "Fort Gratiot (USYFG)",
   label: "Fort Gratiot (USYFG)"
  },
  {
   value: "Fort Hood (USFHO)",
   label: "Fort Hood (USFHO)"
  },
  {
   value: "Fort Huachuca-Sierra Vista Apt (USFHU)",
   label: "Fort Huachuca-Sierra Vista Apt (USFHU)"
  },
  {
   value: "Fort Irwin (USBYS)",
   label: "Fort Irwin (USBYS)"
  },
  {
   value: "Fort Jones, Siskiyou (USFJ2)",
   label: "Fort Jones, Siskiyou (USFJ2)"
  },
  {
   value: "Fort Knox (USFTK)",
   label: "Fort Knox (USFTK)"
  },
  {
   value: "Fort Lawn (USFWN)",
   label: "Fort Lawn (USFWN)"
  },
  {
   value: "Fort Lee (USFOL)",
   label: "Fort Lee (USFOL)"
  },
  {
   value: "Fort Leonard Wood (USTBN)",
   label: "Fort Leonard Wood (USTBN)"
  },
  {
   value: "Fort Lewis (USYLE)",
   label: "Fort Lewis (USYLE)"
  },
  {
   value: "Fort Loramie (USFJL)",
   label: "Fort Loramie (USFJL)"
  },
  {
   value: "Fort Lupton (USQFU)",
   label: "Fort Lupton (USQFU)"
  },
  {
   value: "Fort McCoy (USFMA)",
   label: "Fort McCoy (USFMA)"
  },
  {
   value: "Fort Meade (USFME)",
   label: "Fort Meade (USFME)"
  },
  {
   value: "Fort Meade (USZDF)",
   label: "Fort Meade (USZDF)"
  },
  {
   value: "Fort Mill (USFML)",
   label: "Fort Mill (USFML)"
  },
  {
   value: "Fort Monmouth (USFTM)",
   label: "Fort Monmouth (USFTM)"
  },
  {
   value: "Fort Myers Beach (USFMX)",
   label: "Fort Myers Beach (USFMX)"
  },
  {
   value: "Fort Oglethorpe (USFTT)",
   label: "Fort Oglethorpe (USFTT)"
  },
  {
   value: "Fort Pierre (USFPI)",
   label: "Fort Pierre (USFPI)"
  },
  {
   value: "Fort Recovery (USFVR)",
   label: "Fort Recovery (USFVR)"
  },
  {
   value: "Fort Richardson (USFRN)",
   label: "Fort Richardson (USFRN)"
  },
  {
   value: "Fort Ripley (USFBP)",
   label: "Fort Ripley (USFBP)"
  },
  {
   value: "Fort Rucker (USFR3)",
   label: "Fort Rucker (USFR3)"
  },
  {
   value: "Fort Sheridan (USFSN)",
   label: "Fort Sheridan (USFSN)"
  },
  {
   value: "Fort Snelling (USTSN)",
   label: "Fort Snelling (USTSN)"
  },
  {
   value: "Fort Stewart (USRWT)",
   label: "Fort Stewart (USRWT)"
  },
  {
   value: "Fort Wingate (USFWG)",
   label: "Fort Wingate (USFWG)"
  },
  {
   value: "Fortville (USYFV)",
   label: "Fortville (USYFV)"
  },
  {
   value: "Fosston (USFSS)",
   label: "Fosston (USFSS)"
  },
  {
   value: "Foster (USOSR)",
   label: "Foster (USOSR)"
  },
  {
   value: "Fountain (USFJN)",
   label: "Fountain (USFJN)"
  },
  {
   value: "Fountain (USFYN)",
   label: "Fountain (USFYN)"
  },
  {
   value: "Fountain City (USFNY)",
   label: "Fountain City (USFNY)"
  },
  {
   value: "Fountain Hills (USQWI)",
   label: "Fountain Hills (USQWI)"
  },
  {
   value: "Fowler (USFWI)",
   label: "Fowler (USFWI)"
  },
  {
   value: "Fowlerville (USZFV)",
   label: "Fowlerville (USZFV)"
  },
  {
   value: "Fox Lake (USYFX)",
   label: "Fox Lake (USYFX)"
  },
  {
   value: "Fox Point (USFXP)",
   label: "Fox Point (USFXP)"
  },
  {
   value: "Foxcroft (USFXC)",
   label: "Foxcroft (USFXC)"
  },
  {
   value: "Framingham (USFHM)",
   label: "Framingham (USFHM)"
  },
  {
   value: "Francesville (USFCV)",
   label: "Francesville (USFCV)"
  },
  {
   value: "Francisco (USYIS)",
   label: "Francisco (USYIS)"
  },
  {
   value: "Franconia (USFVA)",
   label: "Franconia (USFVA)"
  },
  {
   value: "Franconia (USZFO)",
   label: "Franconia (USZFO)"
  },
  {
   value: "Frankford (USFFD)",
   label: "Frankford (USFFD)"
  },
  {
   value: "Frankfort (USFJK)",
   label: "Frankfort (USFJK)"
  },
  {
   value: "Frankfort (USFKF)",
   label: "Frankfort (USFKF)"
  },
  {
   value: "Frankfort (USFNF)",
   label: "Frankfort (USFNF)"
  },
  {
   value: "Frankfort (USFRQ)",
   label: "Frankfort (USFRQ)"
  },
  {
   value: "Franklin (USF2K)",
   label: "Franklin (USF2K)"
  },
  {
   value: "Franklin (USFBK)",
   label: "Franklin (USFBK)"
  },
  {
   value: "Franklin (USKLF)",
   label: "Franklin (USKLF)"
  },
  {
   value: "Franklin (USNKN)",
   label: "Franklin (USNKN)"
  },
  {
   value: "Franklin (USRAK)",
   label: "Franklin (USRAK)"
  },
  {
   value: "Franklin (USRNK)",
   label: "Franklin (USRNK)"
  },
  {
   value: "Franklin Furnace (USFAU)",
   label: "Franklin Furnace (USFAU)"
  },
  {
   value: "Franklin Springs (USKYR)",
   label: "Franklin Springs (USKYR)"
  },
  {
   value: "Franklinton (USFKB)",
   label: "Franklinton (USFKB)"
  },
  {
   value: "Frankston (USFNJ)",
   label: "Frankston (USFNJ)"
  },
  {
   value: "Frazeysburg (USYFZ)",
   label: "Frazeysburg (USYFZ)"
  },
  {
   value: "Fraziers Bottom (USFBM)",
   label: "Fraziers Bottom (USFBM)"
  },
  {
   value: "Frederica (USZDH)",
   label: "Frederica (USZDH)"
  },
  {
   value: "Frederick (USFK2)",
   label: "Frederick (USFK2)"
  },
  {
   value: "Frederick (USXZD)",
   label: "Frederick (USXZD)"
  },
  {
   value: "Fredericksburg (USFRW)",
   label: "Fredericksburg (USFRW)"
  },
  {
   value: "Frederickson (USFDS)",
   label: "Frederickson (USFDS)"
  },
  {
   value: "Fredericktown (USFCW)",
   label: "Fredericktown (USFCW)"
  },
  {
   value: "Fredericktown (USFED)",
   label: "Fredericktown (USFED)"
  },
  {
   value: "Fredericktown (USFKW)",
   label: "Fredericktown (USFKW)"
  },
  {
   value: "Fredonia (USFD2)",
   label: "Fredonia (USFD2)"
  },
  {
   value: "Fredonia (USFGD)",
   label: "Fredonia (USFGD)"
  },
  {
   value: "Fredonia (USFYO)",
   label: "Fredonia (USFYO)"
  },
  {
   value: "Fredonia (USFZD)",
   label: "Fredonia (USFZD)"
  },
  {
   value: "Freeburg (USFBU)",
   label: "Freeburg (USFBU)"
  },
  {
   value: "Freedom (USFJM)",
   label: "Freedom (USFJM)"
  },
  {
   value: "Freedom (USFZZ)",
   label: "Freedom (USFZZ)"
  },
  {
   value: "Freeland (USFNB)",
   label: "Freeland (USFNB)"
  },
  {
   value: "Freeland (USFQD)",
   label: "Freeland (USFQD)"
  },
  {
   value: "Freeman (USF2E)",
   label: "Freeman (USF2E)"
  },
  {
   value: "Freeport (USFPO)",
   label: "Freeport (USFPO)"
  },
  {
   value: "Freeport (USFPQ)",
   label: "Freeport (USFPQ)"
  },
  {
   value: "Freeport (USREP)",
   label: "Freeport (USREP)"
  },
  {
   value: "Freeport (USRPO)",
   label: "Freeport (USRPO)"
  },
  {
   value: "Freeport (USUEP)",
   label: "Freeport (USUEP)"
  },
  {
   value: "Freeport (USXAS)",
   label: "Freeport (USXAS)"
  },
  {
   value: "Freer (USFQB)",
   label: "Freer (USFQB)"
  },
  {
   value: "Freestone, Sonoma (USFS3)",
   label: "Freestone, Sonoma (USFS3)"
  },
  {
   value: "Freisland (USFDP)",
   label: "Freisland (USFDP)"
  },
  {
   value: "Fremont (USEMQ)",
   label: "Fremont (USEMQ)"
  },
  {
   value: "Fremont (USFMT)",
   label: "Fremont (USFMT)"
  },
  {
   value: "Fremont (USFQM)",
   label: "Fremont (USFQM)"
  },
  {
   value: "Fremont Junction (USFPJ)",
   label: "Fremont Junction (USFPJ)"
  },
  {
   value: "French Camp (USFCP)",
   label: "French Camp (USFCP)"
  },
  {
   value: "Frenchtown (USJWY)",
   label: "Frenchtown (USJWY)"
  },
  {
   value: "Frenchville (USWFK)",
   label: "Frenchville (USWFK)"
  },
  {
   value: "Fresno (USFQN)",
   label: "Fresno (USFQN)"
  },
  {
   value: "Fresno (USFQS)",
   label: "Fresno (USFQS)"
  },
  {
   value: "Friant (USFRJ)",
   label: "Friant (USFRJ)"
  },
  {
   value: "Friend (USFD8)",
   label: "Friend (USFD8)"
  },
  {
   value: "Friendly (USFND)",
   label: "Friendly (USFND)"
  },
  {
   value: "Friendship (USZFP)",
   label: "Friendship (USZFP)"
  },
  {
   value: "Friendsville (USFEV)",
   label: "Friendsville (USFEV)"
  },
  {
   value: "Friendsville (USFNV)",
   label: "Friendsville (USFNV)"
  },
  {
   value: "Friendswood (USFIW)",
   label: "Friendswood (USFIW)"
  },
  {
   value: "Friesland (USFZA)",
   label: "Friesland (USFZA)"
  },
  {
   value: "Frisco (USFIX)",
   label: "Frisco (USFIX)"
  },
  {
   value: "Frontenac (USFEC)",
   label: "Frontenac (USFEC)"
  },
  {
   value: "Frontenac (USFEQ)",
   label: "Frontenac (USFEQ)"
  },
  {
   value: "Frontenac (USFT8)",
   label: "Frontenac (USFT8)"
  },
  {
   value: "Frost (USFSZ)",
   label: "Frost (USFSZ)"
  },
  {
   value: "Frostburg (USFZH)",
   label: "Frostburg (USFZH)"
  },
  {
   value: "Fruithurst (USFUI)",
   label: "Fruithurst (USFUI)"
  },
  {
   value: "Fruitland (USRXR)",
   label: "Fruitland (USRXR)"
  },
  {
   value: "Fruitland (USZFM)",
   label: "Fruitland (USZFM)"
  },
  {
   value: "Fruitland Park (USF2P)",
   label: "Fruitland Park (USF2P)"
  },
  {
   value: "Fulda (USFUD)",
   label: "Fulda (USFUD)"
  },
  {
   value: "Fullerton (USFUR)",
   label: "Fullerton (USFUR)"
  },
  {
   value: "Fulshear (USFHA)",
   label: "Fulshear (USFHA)"
  },
  {
   value: "Fulton (USFTB)",
   label: "Fulton (USFTB)"
  },
  {
   value: "Fulton (USFUB)",
   label: "Fulton (USFUB)"
  },
  {
   value: "Fulton (USIUL)",
   label: "Fulton (USIUL)"
  },
  {
   value: "Fulton (USUTD)",
   label: "Fulton (USUTD)"
  },
  {
   value: "Fulton (USVUL)",
   label: "Fulton (USVUL)"
  },
  {
   value: "Fulton (USZFL)",
   label: "Fulton (USZFL)"
  },
  {
   value: "Fultondale (USFTD)",
   label: "Fultondale (USFTD)"
  },
  {
   value: "Funk (USFUK)",
   label: "Funk (USFUK)"
  },
  {
   value: "Funter Bay (USFNR)",
   label: "Funter Bay (USFNR)"
  },
  {
   value: "Fuquay-Varina (USFUV)",
   label: "Fuquay-Varina (USFUV)"
  },
  {
   value: "Furlong (USYZV)",
   label: "Furlong (USYZV)"
  },
  {
   value: "Furman (USFJA)",
   label: "Furman (USFJA)"
  },
  {
   value: "Furrs (USRRF)",
   label: "Furrs (USRRF)"
  },
  {
   value: "Gabriels (USGBF)",
   label: "Gabriels (USGBF)"
  },
  {
   value: "Gage (USGAG)",
   label: "Gage (USGAG)"
  },
  {
   value: "Gahanna (USGAH)",
   label: "Gahanna (USGAH)"
  },
  {
   value: "Gainesville (USGII)",
   label: "Gainesville (USGII)"
  },
  {
   value: "Gakona (USGAK)",
   label: "Gakona (USGAK)"
  },
  {
   value: "Galbraith Lake (USGBH)",
   label: "Galbraith Lake (USGBH)"
  },
  {
   value: "Galena (USGA2)",
   label: "Galena (USGA2)"
  },
  {
   value: "Gales Ferry (USGSF)",
   label: "Gales Ferry (USGSF)"
  },
  {
   value: "Galesburg (USGSU)",
   label: "Galesburg (USGSU)"
  },
  {
   value: "Galesville (USG2L)",
   label: "Galesville (USG2L)"
  },
  {
   value: "Galesville (USVGL)",
   label: "Galesville (USVGL)"
  },
  {
   value: "Galeton (USZGQ)",
   label: "Galeton (USZGQ)"
  },
  {
   value: "Galien (USJGL)",
   label: "Galien (USJGL)"
  },
  {
   value: "Galion (USGQQ)",
   label: "Galion (USGQQ)"
  },
  {
   value: "Gallatin (USGAN)",
   label: "Gallatin (USGAN)"
  },
  {
   value: "Gallatin (USZDI)",
   label: "Gallatin (USZDI)"
  },
  {
   value: "Gallatin Gateway (USGG2)",
   label: "Gallatin Gateway (USGG2)"
  },
  {
   value: "Gallaway (USAWY)",
   label: "Gallaway (USAWY)"
  },
  {
   value: "Galliano (USEPB)",
   label: "Galliano (USEPB)"
  },
  {
   value: "Galloway (USGXW)",
   label: "Galloway (USGXW)"
  },
  {
   value: "Galva (USGVS)",
   label: "Galva (USGVS)"
  },
  {
   value: "Gambrills (USG2M)",
   label: "Gambrills (USG2M)"
  },
  {
   value: "Ganado (USGD2)",
   label: "Ganado (USGD2)"
  },
  {
   value: "Ganes Creek (USGEK)",
   label: "Ganes Creek (USGEK)"
  },
  {
   value: "Gansevoort (USGVR)",
   label: "Gansevoort (USGVR)"
  },
  {
   value: "Gap (USAGP)",
   label: "Gap (USAGP)"
  },
  {
   value: "Garberville (USGBV)",
   label: "Garberville (USGBV)"
  },
  {
   value: "Garden City (USGCM)",
   label: "Garden City (USGCM)"
  },
  {
   value: "Garden City (USGCQ)",
   label: "Garden City (USGCQ)"
  },
  {
   value: "Garden City (USGDC)",
   label: "Garden City (USGDC)"
  },
  {
   value: "Garden City (USGEC)",
   label: "Garden City (USGEC)"
  },
  {
   value: "Garden City (USGZC)",
   label: "Garden City (USGZC)"
  },
  {
   value: "Garden City (USTXU)",
   label: "Garden City (USTXU)"
  },
  {
   value: "Garden Valley (USVGG)",
   label: "Garden Valley (USVGG)"
  },
  {
   value: "Gardendale (USGQA)",
   label: "Gardendale (USGQA)"
  },
  {
   value: "Gardiner (USNXR)",
   label: "Gardiner (USNXR)"
  },
  {
   value: "Gardner (USGD7)",
   label: "Gardner (USGD7)"
  },
  {
   value: "Gardner (USGJD)",
   label: "Gardner (USGJD)"
  },
  {
   value: "Gardnerville (USGVF)",
   label: "Gardnerville (USGVF)"
  },
  {
   value: "Garfield (USGFR)",
   label: "Garfield (USGFR)"
  },
  {
   value: "Garfield (USGFX)",
   label: "Garfield (USGFX)"
  },
  {
   value: "Garfield (USGPB)",
   label: "Garfield (USGPB)"
  },
  {
   value: "Garland (USGKD)",
   label: "Garland (USGKD)"
  },
  {
   value: "Garland (USUGD)",
   label: "Garland (USUGD)"
  },
  {
   value: "Garner (USGNC)",
   label: "Garner (USGNC)"
  },
  {
   value: "Garner (USGNR)",
   label: "Garner (USGNR)"
  },
  {
   value: "Garnerville (USGV2)",
   label: "Garnerville (USGV2)"
  },
  {
   value: "Garrett (USQGT)",
   label: "Garrett (USQGT)"
  },
  {
   value: "Garrison (USGAX)",
   label: "Garrison (USGAX)"
  },
  {
   value: "Garysburg (USGYS)",
   label: "Garysburg (USGYS)"
  },
  {
   value: "Gascoyne (USGY2)",
   label: "Gascoyne (USGY2)"
  },
  {
   value: "Gaston (USGAT)",
   label: "Gaston (USGAT)"
  },
  {
   value: "Gates (USGT2)",
   label: "Gates (USGT2)"
  },
  {
   value: "Gatesville (USGJI)",
   label: "Gatesville (USGJI)"
  },
  {
   value: "Gatesville (USRJC)",
   label: "Gatesville (USRJC)"
  },
  {
   value: "Gatlinburg (USGKT)",
   label: "Gatlinburg (USGKT)"
  },
  {
   value: "Gautier (USGAU)",
   label: "Gautier (USGAU)"
  },
  {
   value: "Gaylesville (USVBV)",
   label: "Gaylesville (USVBV)"
  },
  {
   value: "Gays Mills (USGMS)",
   label: "Gays Mills (USGMS)"
  },
  {
   value: "Gayville, Yankton (USGYH)",
   label: "Gayville, Yankton (USGYH)"
  },
  {
   value: "Gem (USQGA)",
   label: "Gem (USQGA)"
  },
  {
   value: "Genesee (USYGE)",
   label: "Genesee (USYGE)"
  },
  {
   value: "Geneseo (USGES)",
   label: "Geneseo (USGES)"
  },
  {
   value: "Geneseo (USZGZ)",
   label: "Geneseo (USZGZ)"
  },
  {
   value: "Geneva (USGEV)",
   label: "Geneva (USGEV)"
  },
  {
   value: "Geneva (USGXA)",
   label: "Geneva (USGXA)"
  },
  {
   value: "Geneva (USGXN)",
   label: "Geneva (USGXN)"
  },
  {
   value: "Genoa City (USOIY)",
   label: "Genoa City (USOIY)"
  },
  {
   value: "Genoa, Ottawa (USGN2)",
   label: "Genoa, Ottawa (USGN2)"
  },
  {
   value: "Gentry (USGTR)",
   label: "Gentry (USGTR)"
  },
  {
   value: "George (USOQX)",
   label: "George (USOQX)"
  },
  {
   value: "Georges Mills (USGML)",
   label: "Georges Mills (USGML)"
  },
  {
   value: "Georgetown (USGT7)",
   label: "Georgetown (USGT7)"
  },
  {
   value: "Georgetown (USGTW)",
   label: "Georgetown (USGTW)"
  },
  {
   value: "Georgetown (USZDJ)",
   label: "Georgetown (USZDJ)"
  },
  {
   value: "Georgetown, Fairfield (USGGN)",
   label: "Georgetown, Fairfield (USGGN)"
  },
  {
   value: "Georgetown, Fayette (USGWN)",
   label: "Georgetown, Fayette (USGWN)"
  },
  {
   value: "Georgetown, Vermilion (USGNJ)",
   label: "Georgetown, Vermilion (USGNJ)"
  },
  {
   value: "Georgia (USGG3)",
   label: "Georgia (USGG3)"
  },
  {
   value: "Georgiana (USGG4)",
   label: "Georgiana (USGG4)"
  },
  {
   value: "Gerlach (USGCH)",
   label: "Gerlach (USGCH)"
  },
  {
   value: "Germantown (USGEA)",
   label: "Germantown (USGEA)"
  },
  {
   value: "Germantown (USGMN)",
   label: "Germantown (USGMN)"
  },
  {
   value: "Germantown (USGMO)",
   label: "Germantown (USGMO)"
  },
  {
   value: "Germantown (USGTN)",
   label: "Germantown (USGTN)"
  },
  {
   value: "Germantown (USXGW)",
   label: "Germantown (USXGW)"
  },
  {
   value: "Gertrude Cove (USTUV)",
   label: "Gertrude Cove (USTUV)"
  },
  {
   value: "Gettysburg (USYUR)",
   label: "Gettysburg (USYUR)"
  },
  {
   value: "Getzville (USGZE)",
   label: "Getzville (USGZE)"
  },
  {
   value: "Geyserville (USGSL)",
   label: "Geyserville (USGSL)"
  },
  {
   value: "Ghent (USGHB)",
   label: "Ghent (USGHB)"
  },
  {
   value: "Ghent (USGHE)",
   label: "Ghent (USGHE)"
  },
  {
   value: "Gibbon (USGBQ)",
   label: "Gibbon (USGBQ)"
  },
  {
   value: "Gibbstown (USGIB)",
   label: "Gibbstown (USGIB)"
  },
  {
   value: "Gibraltar (USGIT)",
   label: "Gibraltar (USGIT)"
  },
  {
   value: "Gibson (USGOB)",
   label: "Gibson (USGOB)"
  },
  {
   value: "Gibson City (USGBC)",
   label: "Gibson City (USGBC)"
  },
  {
   value: "Gibsonburg (USGIS)",
   label: "Gibsonburg (USGIS)"
  },
  {
   value: "Giddings (USGDD)",
   label: "Giddings (USGDD)"
  },
  {
   value: "Gideon (USGID)",
   label: "Gideon (USGID)"
  },
  {
   value: "Gila Bend (USGBN)",
   label: "Gila Bend (USGBN)"
  },
  {
   value: "Gilbert (USGBE)",
   label: "Gilbert (USGBE)"
  },
  {
   value: "Gilbert (USGIC)",
   label: "Gilbert (USGIC)"
  },
  {
   value: "Gilbert (USIBT)",
   label: "Gilbert (USIBT)"
  },
  {
   value: "Gilberts (USYOG)",
   label: "Gilberts (USYOG)"
  },
  {
   value: "Gilbertville (USGEZ)",
   label: "Gilbertville (USGEZ)"
  },
  {
   value: "Gilford (USGF2)",
   label: "Gilford (USGF2)"
  },
  {
   value: "Gilford (USGLF)",
   label: "Gilford (USGLF)"
  },
  {
   value: "Gill (USGJL)",
   label: "Gill (USGJL)"
  },
  {
   value: "Gillett (USGJZ)",
   label: "Gillett (USGJZ)"
  },
  {
   value: "Gillett (USGT8)",
   label: "Gillett (USGT8)"
  },
  {
   value: "Gillham (USIHM)",
   label: "Gillham (USIHM)"
  },
  {
   value: "Gillsville (USGV3)",
   label: "Gillsville (USGV3)"
  },
  {
   value: "Gilman (USGIN)",
   label: "Gilman (USGIN)"
  },
  {
   value: "Gilman (USGMA)",
   label: "Gilman (USGMA)"
  },
  {
   value: "Gilman (USGMH)",
   label: "Gilman (USGMH)"
  },
  {
   value: "Gilmanton (USGYM)",
   label: "Gilmanton (USGYM)"
  },
  {
   value: "Gilmore City (USGIO)",
   label: "Gilmore City (USGIO)"
  },
  {
   value: "Girard (USGD4)",
   label: "Girard (USGD4)"
  },
  {
   value: "Girard (USIAR)",
   label: "Girard (USIAR)"
  },
  {
   value: "Glade Spring (USGSR)",
   label: "Glade Spring (USGSR)"
  },
  {
   value: "Gladewater (USTXG)",
   label: "Gladewater (USTXG)"
  },
  {
   value: "Gladstone (USGDS)",
   label: "Gladstone (USGDS)"
  },
  {
   value: "Gladwyne (USG2P)",
   label: "Gladwyne (USG2P)"
  },
  {
   value: "Glasgow (USGKW)",
   label: "Glasgow (USGKW)"
  },
  {
   value: "Glasgow (USQZG)",
   label: "Glasgow (USQZG)"
  },
  {
   value: "Glen (USQGE)",
   label: "Glen (USQGE)"
  },
  {
   value: "Glen Arm (USENR)",
   label: "Glen Arm (USENR)"
  },
  {
   value: "Glen Dale (USNDL)",
   label: "Glen Dale (USNDL)"
  },
  {
   value: "Glen Ellyn (USGEL)",
   label: "Glen Ellyn (USGEL)"
  },
  {
   value: "Glen Flora (USZLO)",
   label: "Glen Flora (USZLO)"
  },
  {
   value: "Glen Hope (USGHP)",
   label: "Glen Hope (USGHP)"
  },
  {
   value: "Glen Raven (USNRA)",
   label: "Glen Raven (USNRA)"
  },
  {
   value: "Glen Rock (USGKS)",
   label: "Glen Rock (USGKS)"
  },
  {
   value: "Glen Rock (USGOC)",
   label: "Glen Rock (USGOC)"
  },
  {
   value: "Glencoe (USEOE)",
   label: "Glencoe (USEOE)"
  },
  {
   value: "Glencoe (USGC2)",
   label: "Glencoe (USGC2)"
  },
  {
   value: "Glencoe (USGCZ)",
   label: "Glencoe (USGCZ)"
  },
  {
   value: "Glendale (USGD3)",
   label: "Glendale (USGD3)"
  },
  {
   value: "Glendale (USGEE)",
   label: "Glendale (USGEE)"
  },
  {
   value: "Glendale (USGEJ)",
   label: "Glendale (USGEJ)"
  },
  {
   value: "Glendale (USGEP)",
   label: "Glendale (USGEP)"
  },
  {
   value: "Glendale (USQGO)",
   label: "Glendale (USQGO)"
  },
  {
   value: "Glenford (USGEF)",
   label: "Glenford (USGEF)"
  },
  {
   value: "Glenmoore (USGEM)",
   label: "Glenmoore (USGEM)"
  },
  {
   value: "Glenn (USL9)",
   label: "Glenn (USL9)"
  },
  {
   value: "Glenndale (USYNN)",
   label: "Glenndale (USYNN)"
  },
  {
   value: "Glennville (USYGL)",
   label: "Glennville (USYGL)"
  },
  {
   value: "Glenola (USGLB)",
   label: "Glenola (USGLB)"
  },
  {
   value: "Glenpool (USGPP)",
   label: "Glenpool (USGPP)"
  },
  {
   value: "Glenrock (USGQK)",
   label: "Glenrock (USGQK)"
  },
  {
   value: "Glenside (USGLI)",
   label: "Glenside (USGLI)"
  },
  {
   value: "Glenville (USGV5)",
   label: "Glenville (USGV5)"
  },
  {
   value: "Glenwillow (USGWW)",
   label: "Glenwillow (USGWW)"
  },
  {
   value: "Glenwood (USGKX)",
   label: "Glenwood (USGKX)"
  },
  {
   value: "Glenwood (USGWB)",
   label: "Glenwood (USGWB)"
  },
  {
   value: "Glenwood (USOOG)",
   label: "Glenwood (USOOG)"
  },
  {
   value: "Glenwood, McDowell (USGZW)",
   label: "Glenwood, McDowell (USGZW)"
  },
  {
   value: "Glidden (USZGE)",
   label: "Glidden (USZGE)"
  },
  {
   value: "Gloucester (USG2C)",
   label: "Gloucester (USG2C)"
  },
  {
   value: "Glouster (USGSE)",
   label: "Glouster (USGSE)"
  },
  {
   value: "Gluckstadt (USGKU)",
   label: "Gluckstadt (USGKU)"
  },
  {
   value: "Glyndon (USGYN)",
   label: "Glyndon (USGYN)"
  },
  {
   value: "Goddard (USGOA)",
   label: "Goddard (USGOA)"
  },
  {
   value: "Goffstown (USGFW)",
   label: "Goffstown (USGFW)"
  },
  {
   value: "Golconda (USGCA)",
   label: "Golconda (USGCA)"
  },
  {
   value: "Gold Bar (USDJA)",
   label: "Gold Bar (USDJA)"
  },
  {
   value: "Gold River (USGXR)",
   label: "Gold River (USGXR)"
  },
  {
   value: "Golden (USJGN)",
   label: "Golden (USJGN)"
  },
  {
   value: "Golden (USOOL)",
   label: "Golden (USOOL)"
  },
  {
   value: "Golden Meadow (USGM3)",
   label: "Golden Meadow (USGM3)"
  },
  {
   value: "Goldthwaite (USQGX)",
   label: "Goldthwaite (USQGX)"
  },
  {
   value: "Goleta (USGO2)",
   label: "Goleta (USGO2)"
  },
  {
   value: "Gonzales (USGOZ)",
   label: "Gonzales (USGOZ)"
  },
  {
   value: "Goochland (USVZZ)",
   label: "Goochland (USVZZ)"
  },
  {
   value: "Good Hope (USGOP)",
   label: "Good Hope (USGOP)"
  },
  {
   value: "Goodell (USGD8)",
   label: "Goodell (USGD8)"
  },
  {
   value: "Goodfield (USGF4)",
   label: "Goodfield (USGF4)"
  },
  {
   value: "Goodland (USGOQ)",
   label: "Goodland (USGOQ)"
  },
  {
   value: "Goodnews Bay (USGNU)",
   label: "Goodnews Bay (USGNU)"
  },
  {
   value: "Goodrich (USGIH)",
   label: "Goodrich (USGIH)"
  },
  {
   value: "Goodrich (USUSZ)",
   label: "Goodrich (USUSZ)"
  },
  {
   value: "Goodville, Lancaster (USGQI)",
   label: "Goodville, Lancaster (USGQI)"
  },
  {
   value: "Goodyear (USGYR)",
   label: "Goodyear (USGYR)"
  },
  {
   value: "Gordon (USGQR)",
   label: "Gordon (USGQR)"
  },
  {
   value: "Gordonsville (USGOV)",
   label: "Gordonsville (USGOV)"
  },
  {
   value: "Gordonville (USGVZ)",
   label: "Gordonville (USGVZ)"
  },
  {
   value: "Gordonville (USLLJ)",
   label: "Gordonville (USLLJ)"
  },
  {
   value: "Gore (USGVA)",
   label: "Gore (USGVA)"
  },
  {
   value: "Gorham (USGHA)",
   label: "Gorham (USGHA)"
  },
  {
   value: "Gorham (USORM)",
   label: "Gorham (USORM)"
  },
  {
   value: "Gorman (USGOM)",
   label: "Gorman (USGOM)"
  },
  {
   value: "Goshen (USGHS)",
   label: "Goshen (USGHS)"
  },
  {
   value: "Goshen (USGKH)",
   label: "Goshen (USGKH)"
  },
  {
   value: "Goshen (USGOG)",
   label: "Goshen (USGOG)"
  },
  {
   value: "Goshen (USGQH)",
   label: "Goshen (USGQH)"
  },
  {
   value: "Goshen (USOEN)",
   label: "Goshen (USOEN)"
  },
  {
   value: "Goshen, Scott (USGQN)",
   label: "Goshen, Scott (USGQN)"
  },
  {
   value: "Gosport (USGP2)",
   label: "Gosport (USGP2)"
  },
  {
   value: "Gothenburg (USGHG)",
   label: "Gothenburg (USGHG)"
  },
  {
   value: "Gowen City (USGYZ)",
   label: "Gowen City (USGYZ)"
  },
  {
   value: "Gower (USGWM)",
   label: "Gower (USGWM)"
  },
  {
   value: "Grabill (USGZB)",
   label: "Grabill (USGZB)"
  },
  {
   value: "Graceville (USGV7)",
   label: "Graceville (USGV7)"
  },
  {
   value: "Graettinger (USGKR)",
   label: "Graettinger (USGKR)"
  },
  {
   value: "Graford (USFVD)",
   label: "Graford (USFVD)"
  },
  {
   value: "Grafton (USGAO)",
   label: "Grafton (USGAO)"
  },
  {
   value: "Grafton (USGZO)",
   label: "Grafton (USGZO)"
  },
  {
   value: "Graham (USGAA)",
   label: "Graham (USGAA)"
  },
  {
   value: "Granbury (USGBY)",
   label: "Granbury (USGBY)"
  },
  {
   value: "Granby (USGMY)",
   label: "Granby (USGMY)"
  },
  {
   value: "Granby (USRNB)",
   label: "Granby (USRNB)"
  },
  {
   value: "Grand Bay (USGDB)",
   label: "Grand Bay (USGDB)"
  },
  {
   value: "Grand Blanc (USQGB)",
   label: "Grand Blanc (USQGB)"
  },
  {
   value: "Grand Chute (USGCU)",
   label: "Grand Chute (USGCU)"
  },
  {
   value: "Grand Coteau (USG2U)",
   label: "Grand Coteau (USG2U)"
  },
  {
   value: "Grand Coulee (USGCO)",
   label: "Grand Coulee (USGCO)"
  },
  {
   value: "Grand Gorge (USDGG)",
   label: "Grand Gorge (USDGG)"
  },
  {
   value: "Grand Island (USGDK)",
   label: "Grand Island (USGDK)"
  },
  {
   value: "Grand Junction (USGJN)",
   label: "Grand Junction (USGJN)"
  },
  {
   value: "Grand Ledge (USGDG)",
   label: "Grand Ledge (USGDG)"
  },
  {
   value: "Grand Marais (USGRM)",
   label: "Grand Marais (USGRM)"
  },
  {
   value: "Grand Meadow (USGM7)",
   label: "Grand Meadow (USGM7)"
  },
  {
   value: "Grand Rapids (USVZI)",
   label: "Grand Rapids (USVZI)"
  },
  {
   value: "Grand Saline (USGJS)",
   label: "Grand Saline (USGJS)"
  },
  {
   value: "Grand Terrace (USGTC)",
   label: "Grand Terrace (USGTC)"
  },
  {
   value: "Grand View (USGW6)",
   label: "Grand View (USGW6)"
  },
  {
   value: "Grandfalls (USNDF)",
   label: "Grandfalls (USNDF)"
  },
  {
   value: "Grandin (USGR4)",
   label: "Grandin (USGR4)"
  },
  {
   value: "Grandview (USDVW)",
   label: "Grandview (USDVW)"
  },
  {
   value: "Grandview Heights (USVGH)",
   label: "Grandview Heights (USVGH)"
  },
  {
   value: "Grandview, Dawson (USDIW)",
   label: "Grandview, Dawson (USDIW)"
  },
  {
   value: "Grandville (USGDI)",
   label: "Grandville (USGDI)"
  },
  {
   value: "Granger (USYGR)",
   label: "Granger (USYGR)"
  },
  {
   value: "Granger (USZGR)",
   label: "Granger (USZGR)"
  },
  {
   value: "Grangeville (USGGJ)",
   label: "Grangeville (USGGJ)"
  },
  {
   value: "Granite (USGKI)",
   label: "Granite (USGKI)"
  },
  {
   value: "Granite (USGTK)",
   label: "Granite (USGTK)"
  },
  {
   value: "Granite Bay (USGTB)",
   label: "Granite Bay (USGTB)"
  },
  {
   value: "Granite Falls (USGFS)",
   label: "Granite Falls (USGFS)"
  },
  {
   value: "Granite Falls (USGFZ)",
   label: "Granite Falls (USGFZ)"
  },
  {
   value: "Graniteville (USGQL)",
   label: "Graniteville (USGQL)"
  },
  {
   value: "Grant (USGTA)",
   label: "Grant (USGTA)"
  },
  {
   value: "Grant City (USGQS)",
   label: "Grant City (USGQS)"
  },
  {
   value: "Granton (USRAO)",
   label: "Granton (USRAO)"
  },
  {
   value: "Grants (USGNT)",
   label: "Grants (USGNT)"
  },
  {
   value: "Grantsville (USGTE)",
   label: "Grantsville (USGTE)"
  },
  {
   value: "Grantsville (USGV8)",
   label: "Grantsville (USGV8)"
  },
  {
   value: "Grantville (USGTI)",
   label: "Grantville (USGTI)"
  },
  {
   value: "Granville (USGKA)",
   label: "Granville (USGKA)"
  },
  {
   value: "Granville (USGVC)",
   label: "Granville (USGVC)"
  },
  {
   value: "Granville (USZVG)",
   label: "Granville (USZVG)"
  },
  {
   value: "Grapeview (USGP7)",
   label: "Grapeview (USGP7)"
  },
  {
   value: "Grasonville (USGRF)",
   label: "Grasonville (USGRF)"
  },
  {
   value: "Grass Lake (USGSK)",
   label: "Grass Lake (USGSK)"
  },
  {
   value: "Graton (USGR2)",
   label: "Graton (USGR2)"
  },
  {
   value: "Gratz (USGAZ)",
   label: "Gratz (USGAZ)"
  },
  {
   value: "Gravette (USGET)",
   label: "Gravette (USGET)"
  },
  {
   value: "Grawn (USGWG)",
   label: "Grawn (USGWG)"
  },
  {
   value: "Gray (USGY5)",
   label: "Gray (USGY5)"
  },
  {
   value: "Gray (USGYA)",
   label: "Gray (USGYA)"
  },
  {
   value: "Gray (USGYK)",
   label: "Gray (USGYK)"
  },
  {
   value: "Grayling (USQGH)",
   label: "Grayling (USQGH)"
  },
  {
   value: "Grays Harbor City (USGHC)",
   label: "Grays Harbor City (USGHC)"
  },
  {
   value: "Grayslake (USGYL)",
   label: "Grayslake (USGYL)"
  },
  {
   value: "Grayson (USGYO)",
   label: "Grayson (USGYO)"
  },
  {
   value: "Grayville (USGQE)",
   label: "Grayville (USGQE)"
  },
  {
   value: "Great Barrington (USGBR)",
   label: "Great Barrington (USGBR)"
  },
  {
   value: "Great Falls (USRTF)",
   label: "Great Falls (USRTF)"
  },
  {
   value: "Great Falls (USZGS)",
   label: "Great Falls (USZGS)"
  },
  {
   value: "Greece (USZDK)",
   label: "Greece (USZDK)"
  },
  {
   value: "Greeley (USGYP)",
   label: "Greeley (USGYP)"
  },
  {
   value: "Greeleyville (USEJL)",
   label: "Greeleyville (USEJL)"
  },
  {
   value: "Green Brae (USGNX)",
   label: "Green Brae (USGNX)"
  },
  {
   value: "Green Brook (USGBK)",
   label: "Green Brook (USGBK)"
  },
  {
   value: "Green Forest (USGFG)",
   label: "Green Forest (USGFG)"
  },
  {
   value: "Green Lane (USGLP)",
   label: "Green Lane (USGLP)"
  },
  {
   value: "Green Oaks (USZDM)",
   label: "Green Oaks (USZDM)"
  },
  {
   value: "Green Pond (USGPD)",
   label: "Green Pond (USGPD)"
  },
  {
   value: "Green Pond (USGPH)",
   label: "Green Pond (USGPH)"
  },
  {
   value: "Green Ridge (USGR3)",
   label: "Green Ridge (USGR3)"
  },
  {
   value: "Green Town (USFWZ)",
   label: "Green Town (USFWZ)"
  },
  {
   value: "Green Valley (USGV6)",
   label: "Green Valley (USGV6)"
  },
  {
   value: "Greenacres (USGCR)",
   label: "Greenacres (USGCR)"
  },
  {
   value: "Greenacres (USZDO)",
   label: "Greenacres (USZDO)"
  },
  {
   value: "Greenback (USGBX)",
   label: "Greenback (USGBX)"
  },
  {
   value: "Greenboro (USGEB)",
   label: "Greenboro (USGEB)"
  },
  {
   value: "Greenbrier (USGR8)",
   label: "Greenbrier (USGR8)"
  },
  {
   value: "Greenbrier, Robertson (USGBI)",
   label: "Greenbrier, Robertson (USGBI)"
  },
  {
   value: "Greenbush (USGBW)",
   label: "Greenbush (USGBW)"
  },
  {
   value: "Greenbush (USZGH)",
   label: "Greenbush (USZGH)"
  },
  {
   value: "Greendale (USGJA)",
   label: "Greendale (USGJA)"
  },
  {
   value: "Greene (USEEG)",
   label: "Greene (USEEG)"
  },
  {
   value: "Greene (USGEX)",
   label: "Greene (USGEX)"
  },
  {
   value: "Greene (USGPG)",
   label: "Greene (USGPG)"
  },
  {
   value: "Greenfield (USEEF)",
   label: "Greenfield (USEEF)"
  },
  {
   value: "Greenfield (USGEI)",
   label: "Greenfield (USGEI)"
  },
  {
   value: "Greenfield (USGFM)",
   label: "Greenfield (USGFM)"
  },
  {
   value: "Greenfield (USGJE)",
   label: "Greenfield (USGJE)"
  },
  {
   value: "Greenport (USGP4)",
   label: "Greenport (USGP4)"
  },
  {
   value: "Greensboro (USGBO)",
   label: "Greensboro (USGBO)"
  },
  {
   value: "Greensboro (USGBS)",
   label: "Greensboro (USGBS)"
  },
  {
   value: "Greensburg (USGB2)",
   label: "Greensburg (USGB2)"
  },
  {
   value: "Greenup (USGU2)",
   label: "Greenup (USGU2)"
  },
  {
   value: "Greenup (USZDP)",
   label: "Greenup (USZDP)"
  },
  {
   value: "Greenvale (USGVJ)",
   label: "Greenvale (USGVJ)"
  },
  {
   value: "Greenview (USUSI)",
   label: "Greenview (USUSI)"
  },
  {
   value: "Greenville (USGGV)",
   label: "Greenville (USGGV)"
  },
  {
   value: "Greenville (USGHV)",
   label: "Greenville (USGHV)"
  },
  {
   value: "Greenville (USGIE)",
   label: "Greenville (USGIE)"
  },
  {
   value: "Greenville (USGJV)",
   label: "Greenville (USGJV)"
  },
  {
   value: "Greenville (USGMI)",
   label: "Greenville (USGMI)"
  },
  {
   value: "Greenville (USGVG)",
   label: "Greenville (USGVG)"
  },
  {
   value: "Greenville (USGVM)",
   label: "Greenville (USGVM)"
  },
  {
   value: "Greenville (USGWE)",
   label: "Greenville (USGWE)"
  },
  {
   value: "Greenville (USGYE)",
   label: "Greenville (USGYE)"
  },
  {
   value: "Greenwell Springs (USGPS)",
   label: "Greenwell Springs (USGPS)"
  },
  {
   value: "Greenwich (USGW7)",
   label: "Greenwich (USGW7)"
  },
  {
   value: "Greenwood (USEEO)",
   label: "Greenwood (USEEO)"
  },
  {
   value: "Greenwood (USG2W)",
   label: "Greenwood (USG2W)"
  },
  {
   value: "Greenwood (USGKO)",
   label: "Greenwood (USGKO)"
  },
  {
   value: "Greenwood (USGQW)",
   label: "Greenwood (USGQW)"
  },
  {
   value: "Greenwood (USGW3)",
   label: "Greenwood (USGW3)"
  },
  {
   value: "Greenwood (USZDR)",
   label: "Greenwood (USZDR)"
  },
  {
   value: "Greenwood Village (USGV4)",
   label: "Greenwood Village (USGV4)"
  },
  {
   value: "Greenwood, Clark (USGWC)",
   label: "Greenwood, Clark (USGWC)"
  },
  {
   value: "Greenwood, El Dorado (USGMW)",
   label: "Greenwood, El Dorado (USGMW)"
  },
  {
   value: "Greenwood, Guernsey (USGNS)",
   label: "Greenwood, Guernsey (USGNS)"
  },
  {
   value: "Greenwood, Henry (USGW4)",
   label: "Greenwood, Henry (USGW4)"
  },
  {
   value: "Greenwood, Sebastian (USGNQ)",
   label: "Greenwood, Sebastian (USGNQ)"
  },
  {
   value: "Greer (USGXX)",
   label: "Greer (USGXX)"
  },
  {
   value: "Gregory (USGOY)",
   label: "Gregory (USGOY)"
  },
  {
   value: "Grenloch (USGL2)",
   label: "Grenloch (USGL2)"
  },
  {
   value: "Grethel (USGTH)",
   label: "Grethel (USGTH)"
  },
  {
   value: "Gretna (USGZR)",
   label: "Gretna (USGZR)"
  },
  {
   value: "Gridley (USGYB)",
   label: "Gridley (USGYB)"
  },
  {
   value: "Gridley&nbsp; (USGY3)",
   label: "Gridley&nbsp; (USGY3)"
  },
  {
   value: "Griffin (USGFF)",
   label: "Griffin (USGFF)"
  },
  {
   value: "Griffith (USGYT)",
   label: "Griffith (USGYT)"
  },
  {
   value: "Grifton (USG2F)",
   label: "Grifton (USG2F)"
  },
  {
   value: "Griggsville (USGGF)",
   label: "Griggsville (USGGF)"
  },
  {
   value: "Griswold (USGZD)",
   label: "Griswold (USGZD)"
  },
  {
   value: "Groesbeck (USGB3)",
   label: "Groesbeck (USGB3)"
  },
  {
   value: "Grosse Ile (USZGP)",
   label: "Grosse Ile (USZGP)"
  },
  {
   value: "Grosse Pointe (USGSS)",
   label: "Grosse Pointe (USGSS)"
  },
  {
   value: "Grosse Ponte Farms (USGPF)",
   label: "Grosse Ponte Farms (USGPF)"
  },
  {
   value: "Groton (USGOO)",
   label: "Groton (USGOO)"
  },
  {
   value: "Groton (USGOT)",
   label: "Groton (USGOT)"
  },
  {
   value: "Groton (USGTQ)",
   label: "Groton (USGTQ)"
  },
  {
   value: "Groton (USZGO)",
   label: "Groton (USZGO)"
  },
  {
   value: "Grottoes (USGOW)",
   label: "Grottoes (USGOW)"
  },
  {
   value: "Grove City (USJGC)",
   label: "Grove City (USJGC)"
  },
  {
   value: "Groveland (USGVO)",
   label: "Groveland (USGVO)"
  },
  {
   value: "Grover (USGOF)",
   label: "Grover (USGOF)"
  },
  {
   value: "Grover (USGQV)",
   label: "Grover (USGQV)"
  },
  {
   value: "Grover (USOVK)",
   label: "Grover (USOVK)"
  },
  {
   value: "Grover Beach (USGVB)",
   label: "Grover Beach (USGVB)"
  },
  {
   value: "Groves (USYGS)",
   label: "Groves (USYGS)"
  },
  {
   value: "Grovetown (USGTG)",
   label: "Grovetown (USGTG)"
  },
  {
   value: "Grundy (USGDU)",
   label: "Grundy (USGDU)"
  },
  {
   value: "Grundy Center (USGRU)",
   label: "Grundy Center (USGRU)"
  },
  {
   value: "Guernsey (USGUN)",
   label: "Guernsey (USGUN)"
  },
  {
   value: "Guild (USGUD)",
   label: "Guild (USGUD)"
  },
  {
   value: "Guilderland (USGL3)",
   label: "Guilderland (USGL3)"
  },
  {
   value: "Guildhall (USGDJ)",
   label: "Guildhall (USGDJ)"
  },
  {
   value: "Guilford (USGF3)",
   label: "Guilford (USGF3)"
  },
  {
   value: "Guilford (USGUL)",
   label: "Guilford (USGUL)"
  },
  {
   value: "Guion (USGUB)",
   label: "Guion (USGUB)"
  },
  {
   value: "Gulf Breeze (USGBZ)",
   label: "Gulf Breeze (USGBZ)"
  },
  {
   value: "Gulkana (USGKN)",
   label: "Gulkana (USGKN)"
  },
  {
   value: "Gulliver (USGUV)",
   label: "Gulliver (USGUV)"
  },
  {
   value: "Gunnison (USGUC)",
   label: "Gunnison (USGUC)"
  },
  {
   value: "Guntersville (USGUE)",
   label: "Guntersville (USGUE)"
  },
  {
   value: "Gurley (USGY4)",
   label: "Gurley (USGY4)"
  },
  {
   value: "Gurley (USRLY)",
   label: "Gurley (USRLY)"
  },
  {
   value: "Guthrie (USGOK)",
   label: "Guthrie (USGOK)"
  },
  {
   value: "Guttenberg (USGUG)",
   label: "Guttenberg (USGUG)"
  },
  {
   value: "Gwinner (USGWI)",
   label: "Gwinner (USGWI)"
  },
  {
   value: "Gwinnett (USGW2)",
   label: "Gwinnett (USGW2)"
  },
  {
   value: "Gypsum (USGM2)",
   label: "Gypsum (USGM2)"
  },
  {
   value: "Hackberry (USKBR)",
   label: "Hackberry (USKBR)"
  },
  {
   value: "Hackensack (USHS2)",
   label: "Hackensack (USHS2)"
  },
  {
   value: "Hackleburg (USHB2)",
   label: "Hackleburg (USHB2)"
  },
  {
   value: "Haddam (USDDM)",
   label: "Haddam (USDDM)"
  },
  {
   value: "Hadensville (USVHS)",
   label: "Hadensville (USVHS)"
  },
  {
   value: "Hadley (USHDJ)",
   label: "Hadley (USHDJ)"
  },
  {
   value: "Hagaman (USHQG)",
   label: "Hagaman (USHQG)"
  },
  {
   value: "Hagerman (USVHG)",
   label: "Hagerman (USVHG)"
  },
  {
   value: "Hagerstown (USHWN)",
   label: "Hagerstown (USHWN)"
  },
  {
   value: "Haiku (USHXK)",
   label: "Haiku (USHXK)"
  },
  {
   value: "Hailey (USIKY)",
   label: "Hailey (USIKY)"
  },
  {
   value: "Haileyville (USHLV)",
   label: "Haileyville (USHLV)"
  },
  {
   value: "Hainesport (USHNR)",
   label: "Hainesport (USHNR)"
  },
  {
   value: "Halcott Center (USTKC)",
   label: "Halcott Center (USTKC)"
  },
  {
   value: "Half Way (USZHF)",
   label: "Half Way (USZHF)"
  },
  {
   value: "Halifax (USHFX)",
   label: "Halifax (USHFX)"
  },
  {
   value: "Halifax (USHIX)",
   label: "Halifax (USHIX)"
  },
  {
   value: "Halifax (USYHX)",
   label: "Halifax (USYHX)"
  },
  {
   value: "Hallettsville (USHV8)",
   label: "Hallettsville (USHV8)"
  },
  {
   value: "Hallowell (USHWF)",
   label: "Hallowell (USHWF)"
  },
  {
   value: "Hallstead (USHS6)",
   label: "Hallstead (USHS6)"
  },
  {
   value: "Halltown (USHN4)",
   label: "Halltown (USHN4)"
  },
  {
   value: "Halstead (USAH7)",
   label: "Halstead (USAH7)"
  },
  {
   value: "Hamburg (USHMU)",
   label: "Hamburg (USHMU)"
  },
  {
   value: "Hamburg (USZDT)",
   label: "Hamburg (USZDT)"
  },
  {
   value: "Hamburg (USZH8)",
   label: "Hamburg (USZH8)"
  },
  {
   value: "Hamel (USNHE)",
   label: "Hamel (USNHE)"
  },
  {
   value: "Hamel (USQHL)",
   label: "Hamel (USQHL)"
  },
  {
   value: "Hamer (USHMK)",
   label: "Hamer (USHMK)"
  },
  {
   value: "Hamer (USHMR)",
   label: "Hamer (USHMR)"
  },
  {
   value: "Hamersville (USHVH)",
   label: "Hamersville (USHVH)"
  },
  {
   value: "Hamilton (USHHM)",
   label: "Hamilton (USHHM)"
  },
  {
   value: "Hamilton (USHJK)",
   label: "Hamilton (USHJK)"
  },
  {
   value: "Hamilton (USHM2)",
   label: "Hamilton (USHM2)"
  },
  {
   value: "Hamilton (USHM7)",
   label: "Hamilton (USHM7)"
  },
  {
   value: "Hamilton (USHT2)",
   label: "Hamilton (USHT2)"
  },
  {
   value: "Hamilton (USZDX)",
   label: "Hamilton (USZDX)"
  },
  {
   value: "Hamilton City (USHAC)",
   label: "Hamilton City (USHAC)"
  },
  {
   value: "Hamilton Square (USHMB)",
   label: "Hamilton Square (USHMB)"
  },
  {
   value: "Hamilton Square (USHSQ)",
   label: "Hamilton Square (USHSQ)"
  },
  {
   value: "Hamilton, Monmouth (USHMG)",
   label: "Hamilton, Monmouth (USHMG)"
  },
  {
   value: "Hamilton, Ocean (USHJO)",
   label: "Hamilton, Ocean (USHJO)"
  },
  {
   value: "Hamlin (USZNY)",
   label: "Hamlin (USZNY)"
  },
  {
   value: "Hammond (USHMM)",
   label: "Hammond (USHMM)"
  },
  {
   value: "Hammondsville (USHMD)",
   label: "Hammondsville (USHMD)"
  },
  {
   value: "Hampstead (USHP8)",
   label: "Hampstead (USHP8)"
  },
  {
   value: "Hampstead (USHPD)",
   label: "Hampstead (USHPD)"
  },
  {
   value: "Hampton (USAHM)",
   label: "Hampton (USAHM)"
  },
  {
   value: "Hampton (USGMP)",
   label: "Hampton (USGMP)"
  },
  {
   value: "Hampton (USHAX)",
   label: "Hampton (USHAX)"
  },
  {
   value: "Hampton (USHNV)",
   label: "Hampton (USHNV)"
  },
  {
   value: "Hampton (USHT3)",
   label: "Hampton (USHT3)"
  },
  {
   value: "Hanapepe (USPAK)",
   label: "Hanapepe (USPAK)"
  },
  {
   value: "Hancock (USCMX)",
   label: "Hancock (USCMX)"
  },
  {
   value: "Hancock (USH2N)",
   label: "Hancock (USH2N)"
  },
  {
   value: "Hancock (USHNK)",
   label: "Hancock (USHNK)"
  },
  {
   value: "Hancock (USNOK)",
   label: "Hancock (USNOK)"
  },
  {
   value: "Hancock (USQHC)",
   label: "Hancock (USQHC)"
  },
  {
   value: "Haney (USHN2)",
   label: "Haney (USHN2)"
  },
  {
   value: "Hanna (USHNX)",
   label: "Hanna (USHNX)"
  },
  {
   value: "Hannibal (USHBL)",
   label: "Hannibal (USHBL)"
  },
  {
   value: "Hannibal (USHBP)",
   label: "Hannibal (USHBP)"
  },
  {
   value: "Hanover (USH2R)",
   label: "Hanover (USH2R)"
  },
  {
   value: "Hanover (USHVX)",
   label: "Hanover (USHVX)"
  },
  {
   value: "Hanover (USOVG)",
   label: "Hanover (USOVG)"
  },
  {
   value: "Hanover (USQHV)",
   label: "Hanover (USQHV)"
  },
  {
   value: "Hanover (USZHV)",
   label: "Hanover (USZHV)"
  },
  {
   value: "Hanrahan (USYHN)",
   label: "Hanrahan (USYHN)"
  },
  {
   value: "Hanson (USHSK)",
   label: "Hanson (USHSK)"
  },
  {
   value: "Hanus Bay (USHBC)",
   label: "Hanus Bay (USHBC)"
  },
  {
   value: "Harbor Beach (USHB4)",
   label: "Harbor Beach (USHB4)"
  },
  {
   value: "Harbor Springs (USHS3)",
   label: "Harbor Springs (USHS3)"
  },
  {
   value: "Harborcreek (USRRZ)",
   label: "Harborcreek (USRRZ)"
  },
  {
   value: "Harcourt (USHC8)",
   label: "Harcourt (USHC8)"
  },
  {
   value: "Hardeeville (USHVJ)",
   label: "Hardeeville (USHVJ)"
  },
  {
   value: "Hardin (USHJX)",
   label: "Hardin (USHJX)"
  },
  {
   value: "Hardin (USHRD)",
   label: "Hardin (USHRD)"
  },
  {
   value: "Hardinsburg (USHXG)",
   label: "Hardinsburg (USHXG)"
  },
  {
   value: "Harford (USHRF)",
   label: "Harford (USHRF)"
  },
  {
   value: "Harlan (USVRL)",
   label: "Harlan (USVRL)"
  },
  {
   value: "Harleyville (USZDY)",
   label: "Harleyville (USZDY)"
  },
  {
   value: "Harlowton (USXUX)",
   label: "Harlowton (USXUX)"
  },
  {
   value: "Harmon (USHVO)",
   label: "Harmon (USHVO)"
  },
  {
   value: "Harmony (USHMY)",
   label: "Harmony (USHMY)"
  },
  {
   value: "Harper Woods (USRPW)",
   label: "Harper Woods (USRPW)"
  },
  {
   value: "Harpers Ferry (USRPF)",
   label: "Harpers Ferry (USRPF)"
  },
  {
   value: "Harpersville (USR9)",
   label: "Harpersville (USR9)"
  },
  {
   value: "Harpursville (USHP2)",
   label: "Harpursville (USHP2)"
  },
  {
   value: "Harrah (USHXH)",
   label: "Harrah (USHXH)"
  },
  {
   value: "Harrells (USH2A)",
   label: "Harrells (USH2A)"
  },
  {
   value: "Harrington (USHRG)",
   label: "Harrington (USHRG)"
  },
  {
   value: "Harris (USJHR)",
   label: "Harris (USJHR)"
  },
  {
   value: "Harris (USRZS)",
   label: "Harris (USRZS)"
  },
  {
   value: "Harrisburg (USHAU)",
   label: "Harrisburg (USHAU)"
  },
  {
   value: "Harrisburg (USHB3)",
   label: "Harrisburg (USHB3)"
  },
  {
   value: "Harrisburg (USZ2D)",
   label: "Harrisburg (USZ2D)"
  },
  {
   value: "Harrison (USHIR)",
   label: "Harrison (USHIR)"
  },
  {
   value: "Harrison (USHRN)",
   label: "Harrison (USHRN)"
  },
  {
   value: "Harrison (USZHS)",
   label: "Harrison (USZHS)"
  },
  {
   value: "Harrison (USZRN)",
   label: "Harrison (USZRN)"
  },
  {
   value: "Harrisonburg (USHAJ)",
   label: "Harrisonburg (USHAJ)"
  },
  {
   value: "Harrisville (USHVL)",
   label: "Harrisville (USHVL)"
  },
  {
   value: "Harrisville (USHVU)",
   label: "Harrisville (USHVU)"
  },
  {
   value: "Hart (USTAR)",
   label: "Hart (USTAR)"
  },
  {
   value: "Hartford (USHFO)",
   label: "Hartford (USHFO)"
  },
  {
   value: "Hartford (USHTF)",
   label: "Hartford (USHTF)"
  },
  {
   value: "Hartford (USQHD)",
   label: "Hartford (USQHD)"
  },
  {
   value: "Hartington (USTGD)",
   label: "Hartington (USTGD)"
  },
  {
   value: "Hartland (USHL2)",
   label: "Hartland (USHL2)"
  },
  {
   value: "Hartland (USHTB)",
   label: "Hartland (USHTB)"
  },
  {
   value: "Hartly (USHA8)",
   label: "Hartly (USHA8)"
  },
  {
   value: "Hartsville (USVHL)",
   label: "Hartsville (USVHL)"
  },
  {
   value: "Harvard (USHV5)",
   label: "Harvard (USHV5)"
  },
  {
   value: "Harvey (USHV4)",
   label: "Harvey (USHV4)"
  },
  {
   value: "Harvey (USVEY)",
   label: "Harvey (USVEY)"
  },
  {
   value: "Harwich (USHW3)",
   label: "Harwich (USHW3)"
  },
  {
   value: "Harwick (USICP)",
   label: "Harwick (USICP)"
  },
  {
   value: "Harwood (USAWQ)",
   label: "Harwood (USAWQ)"
  },
  {
   value: "Harwood (USZHW)",
   label: "Harwood (USZHW)"
  },
  {
   value: "Harwood Heights (USHHT)",
   label: "Harwood Heights (USHHT)"
  },
  {
   value: "Hasbrouck Heights (USZHU)",
   label: "Hasbrouck Heights (USZHU)"
  },
  {
   value: "Haskell (USHAG)",
   label: "Haskell (USHAG)"
  },
  {
   value: "Haskell (USHKU)",
   label: "Haskell (USHKU)"
  },
  {
   value: "Haskell (USQHJ)",
   label: "Haskell (USQHJ)"
  },
  {
   value: "Haskins (USHKI)",
   label: "Haskins (USHKI)"
  },
  {
   value: "Haslet (USTXH)",
   label: "Haslet (USTXH)"
  },
  {
   value: "Haslett (USHXC)",
   label: "Haslett (USHXC)"
  },
  {
   value: "Hastings (USHG2)",
   label: "Hastings (USHG2)"
  },
  {
   value: "Hastings (USTGS)",
   label: "Hastings (USTGS)"
  },
  {
   value: "Hatch (USYHH)",
   label: "Hatch (USYHH)"
  },
  {
   value: "Hatfield (USTFL)",
   label: "Hatfield (USTFL)"
  },
  {
   value: "Hatton (USQHA)",
   label: "Hatton (USQHA)"
  },
  {
   value: "Haughton (USHGO)",
   label: "Haughton (USHGO)"
  },
  {
   value: "Hauser (USZUE)",
   label: "Hauser (USZUE)"
  },
  {
   value: "Havana (USHV3)",
   label: "Havana (USHV3)"
  },
  {
   value: "Havana (USHVK)",
   label: "Havana (USHVK)"
  },
  {
   value: "Havelock (USHL5)",
   label: "Havelock (USHL5)"
  },
  {
   value: "Haven (USAE6)",
   label: "Haven (USAE6)"
  },
  {
   value: "Haviland (USYHA)",
   label: "Haviland (USYHA)"
  },
  {
   value: "Hawesville (USHZZ)",
   label: "Hawesville (USHZZ)"
  },
  {
   value: "Hawk Inlet (USHWI)",
   label: "Hawk Inlet (USHWI)"
  },
  {
   value: "Hawkins (USHWT)",
   label: "Hawkins (USHWT)"
  },
  {
   value: "Hawley (USAWL)",
   label: "Hawley (USAWL)"
  },
  {
   value: "Hawthorn (USYHW)",
   label: "Hawthorn (USYHW)"
  },
  {
   value: "Hawthorne (USXVB)",
   label: "Hawthorne (USXVB)"
  },
  {
   value: "Haycock (USHAY)",
   label: "Haycock (USHAY)"
  },
  {
   value: "Hayden (USHDN)",
   label: "Hayden (USHDN)"
  },
  {
   value: "Hayden (USHY2)",
   label: "Hayden (USHY2)"
  },
  {
   value: "Hayden (USHY6)",
   label: "Hayden (USHY6)"
  },
  {
   value: "Hayden (USYFN)",
   label: "Hayden (USYFN)"
  },
  {
   value: "Hayden Lake (USHYB)",
   label: "Hayden Lake (USHYB)"
  },
  {
   value: "Haydenville (USYDF)",
   label: "Haydenville (USYDF)"
  },
  {
   value: "Hayesville (USHYV)",
   label: "Hayesville (USHYV)"
  },
  {
   value: "Hayfield (USHZX)",
   label: "Hayfield (USHZX)"
  },
  {
   value: "Haymarket (USHY8)",
   label: "Haymarket (USHY8)"
  },
  {
   value: "Haynesville (USHYN)",
   label: "Haynesville (USHYN)"
  },
  {
   value: "Haysville (USHZY)",
   label: "Haysville (USHZY)"
  },
  {
   value: "Hayti (USYIA)",
   label: "Hayti (USYIA)"
  },
  {
   value: "Hazel (USHZ2)",
   label: "Hazel (USHZ2)"
  },
  {
   value: "Hazel Crest (USHZS)",
   label: "Hazel Crest (USHZS)"
  },
  {
   value: "Hazel Park (USHZP)",
   label: "Hazel Park (USHZP)"
  },
  {
   value: "Hazelton Mills (USZD2)",
   label: "Hazelton Mills (USZD2)"
  },
  {
   value: "Hazelwood (USHZD)",
   label: "Hazelwood (USHZD)"
  },
  {
   value: "Hazle Township (USZES)",
   label: "Hazle Township (USZES)"
  },
  {
   value: "Hazlet (USHZE)",
   label: "Hazlet (USHZE)"
  },
  {
   value: "Headland (USHLE)",
   label: "Headland (USHLE)"
  },
  {
   value: "Healdton (USHAD)",
   label: "Healdton (USHAD)"
  },
  {
   value: "Healy (USLY5)",
   label: "Healy (USLY5)"
  },
  {
   value: "Healy Lake (USHKB)",
   label: "Healy Lake (USHKB)"
  },
  {
   value: "Heaters (USHS4)",
   label: "Heaters (USHS4)"
  },
  {
   value: "Heath Springs (USTHG)",
   label: "Heath Springs (USTHG)"
  },
  {
   value: "Heathrow (USHHW)",
   label: "Heathrow (USHHW)"
  },
  {
   value: "Heathsville (USHHV)",
   label: "Heathsville (USHHV)"
  },
  {
   value: "Hebbronville (USHBJ)",
   label: "Hebbronville (USHBJ)"
  },
  {
   value: "Heber (USZD3)",
   label: "Heber (USZD3)"
  },
  {
   value: "Heber City (USHC2)",
   label: "Heber City (USHC2)"
  },
  {
   value: "Heber Springs (USHBS)",
   label: "Heber Springs (USHBS)"
  },
  {
   value: "Hebron (USHBW)",
   label: "Hebron (USHBW)"
  },
  {
   value: "Hebron (USHN3)",
   label: "Hebron (USHN3)"
  },
  {
   value: "Hebron (USHZQ)",
   label: "Hebron (USHZQ)"
  },
  {
   value: "Hebron (USKHN)",
   label: "Hebron (USKHN)"
  },
  {
   value: "Hebron (USYHR)",
   label: "Hebron (USYHR)"
  },
  {
   value: "Hegins (USHG3)",
   label: "Hegins (USHG3)"
  },
  {
   value: "Helen (USZEH)",
   label: "Helen (USZEH)"
  },
  {
   value: "Helena (USHZN)",
   label: "Helena (USHZN)"
  },
  {
   value: "Helena (USHZV)",
   label: "Helena (USHZV)"
  },
  {
   value: "Helenwood (USHWU)",
   label: "Helenwood (USHWU)"
  },
  {
   value: "Helmville (USEJV)",
   label: "Helmville (USEJV)"
  },
  {
   value: "Helotes (USHOQ)",
   label: "Helotes (USHOQ)"
  },
  {
   value: "Hempstead (USHEX)",
   label: "Hempstead (USHEX)"
  },
  {
   value: "Hemstead (USHD3)",
   label: "Hemstead (USHD3)"
  },
  {
   value: "Henagar (USHNQ)",
   label: "Henagar (USHNQ)"
  },
  {
   value: "Henderson (USNDS)",
   label: "Henderson (USNDS)"
  },
  {
   value: "Hendersonville (USHEV)",
   label: "Hendersonville (USHEV)"
  },
  {
   value: "Henefer (USUTF)",
   label: "Henefer (USUTF)"
  },
  {
   value: "Hennepin (USNNP)",
   label: "Hennepin (USNNP)"
  },
  {
   value: "Hennessey (USHY7)",
   label: "Hennessey (USHY7)"
  },
  {
   value: "Henning (USHNJ)",
   label: "Henning (USHNJ)"
  },
  {
   value: "Henrico (USIUO)",
   label: "Henrico (USIUO)"
  },
  {
   value: "Henrietta (USHT8)",
   label: "Henrietta (USHT8)"
  },
  {
   value: "Henrietta (UST9)",
   label: "Henrietta (UST9)"
  },
  {
   value: "Henry (USHEY)",
   label: "Henry (USHEY)"
  },
  {
   value: "Henry (USHR8)",
   label: "Henry (USHR8)"
  },
  {
   value: "Hephzibah (USHZI)",
   label: "Hephzibah (USHZI)"
  },
  {
   value: "Herculaneum (USHM4)",
   label: "Herculaneum (USHM4)"
  },
  {
   value: "Hercules (USHXU)",
   label: "Hercules (USHXU)"
  },
  {
   value: "Herkimer (USHKM)",
   label: "Herkimer (USHKM)"
  },
  {
   value: "Hermann (USRMA)",
   label: "Hermann (USRMA)"
  },
  {
   value: "Hermantown (USHT4)",
   label: "Hermantown (USHT4)"
  },
  {
   value: "Hermitage (USHGX)",
   label: "Hermitage (USHGX)"
  },
  {
   value: "Hermitage (USHRA)",
   label: "Hermitage (USHRA)"
  },
  {
   value: "Hermosa Beach (USHEC)",
   label: "Hermosa Beach (USHEC)"
  },
  {
   value: "Herod (USKHD)",
   label: "Herod (USKHD)"
  },
  {
   value: "Heron (USQRN)",
   label: "Heron (USQRN)"
  },
  {
   value: "Herriman (USZQQ)",
   label: "Herriman (USZQQ)"
  },
  {
   value: "Hessmer (USZD4)",
   label: "Hessmer (USZD4)"
  },
  {
   value: "Hewitt (USHXI)",
   label: "Hewitt (USHXI)"
  },
  {
   value: "Hewlett (USHWX)",
   label: "Hewlett (USHWX)"
  },
  {
   value: "Heyburn (USYHB)",
   label: "Heyburn (USYHB)"
  },
  {
   value: "Heyworth (USHYW)",
   label: "Heyworth (USHYW)"
  },
  {
   value: "Hialeah Gardens (USHGF)",
   label: "Hialeah Gardens (USHGF)"
  },
  {
   value: "Hiawatha (USHW4)",
   label: "Hiawatha (USHW4)"
  },
  {
   value: "Hiawatha (USHW5)",
   label: "Hiawatha (USHW5)"
  },
  {
   value: "Hibbing (USIBB)",
   label: "Hibbing (USIBB)"
  },
  {
   value: "Hibbs (USIBS)",
   label: "Hibbs (USIBS)"
  },
  {
   value: "Hickman (USHC7)",
   label: "Hickman (USHC7)"
  },
  {
   value: "Hickman (USHM3)",
   label: "Hickman (USHM3)"
  },
  {
   value: "Hickok (USHKK)",
   label: "Hickok (USHKK)"
  },
  {
   value: "Hickory Flat, Benton (USYHI)",
   label: "Hickory Flat, Benton (USYHI)"
  },
  {
   value: "Hickory Flat, Chicasaw (USHYF)",
   label: "Hickory Flat, Chicasaw (USHYF)"
  },
  {
   value: "Hickory Grove, York (USHKG)",
   label: "Hickory Grove, York (USHKG)"
  },
  {
   value: "Hickory Hills, Cook (USHHC)",
   label: "Hickory Hills, Cook (USHHC)"
  },
  {
   value: "Hico (USHC6)",
   label: "Hico (USHC6)"
  },
  {
   value: "Hidden Falls (USHDA)",
   label: "Hidden Falls (USHDA)"
  },
  {
   value: "Hidden Valley (USZAX)",
   label: "Hidden Valley (USZAX)"
  },
  {
   value: "High Hill (USIHH)",
   label: "High Hill (USIHH)"
  },
  {
   value: "High Point (USHPZ)",
   label: "High Point (USHPZ)"
  },
  {
   value: "High Ridge (USHRQ)",
   label: "High Ridge (USHRQ)"
  },
  {
   value: "High View (USHIW)",
   label: "High View (USHIW)"
  },
  {
   value: "Highland (USFJF)",
   label: "Highland (USFJF)"
  },
  {
   value: "Highland (USHGL)",
   label: "Highland (USHGL)"
  },
  {
   value: "Highland (USHGY)",
   label: "Highland (USHGY)"
  },
  {
   value: "Highland (USHL3)",
   label: "Highland (USHL3)"
  },
  {
   value: "Highland City (USHIC)",
   label: "Highland City (USHIC)"
  },
  {
   value: "Highland Falls (USHF2)",
   label: "Highland Falls (USHF2)"
  },
  {
   value: "Highland, Dallas (USHL7)",
   label: "Highland, Dallas (USHL7)"
  },
  {
   value: "Highlands (USHGS)",
   label: "Highlands (USHGS)"
  },
  {
   value: "Highlands (USHIN)",
   label: "Highlands (USHIN)"
  },
  {
   value: "Highlands (USZHH)",
   label: "Highlands (USZHH)"
  },
  {
   value: "Highlands Ranch (USHRZ)",
   label: "Highlands Ranch (USHRZ)"
  },
  {
   value: "Highpoint (USHIT)",
   label: "Highpoint (USHIT)"
  },
  {
   value: "Highspire (USHGI)",
   label: "Highspire (USHGI)"
  },
  {
   value: "Highwood (USHH8)",
   label: "Highwood (USHH8)"
  },
  {
   value: "Higley (USHGE)",
   label: "Higley (USHGE)"
  },
  {
   value: "Hill Air Force Base (USHIF)",
   label: "Hill Air Force Base (USHIF)"
  },
  {
   value: "Hill City (USHCI)",
   label: "Hill City (USHCI)"
  },
  {
   value: "Hill City (USHLC)",
   label: "Hill City (USHLC)"
  },
  {
   value: "Hill City (USIIY)",
   label: "Hill City (USIIY)"
  },
  {
   value: "Hillburn (USHBM)",
   label: "Hillburn (USHBM)"
  },
  {
   value: "Hillister (USIIT)",
   label: "Hillister (USIIT)"
  },
  {
   value: "Hills (USHJI)",
   label: "Hills (USHJI)"
  },
  {
   value: "Hillsboro (USHB5)",
   label: "Hillsboro (USHB5)"
  },
  {
   value: "Hillsboro (USHB7)",
   label: "Hillsboro (USHB7)"
  },
  {
   value: "Hillsboro (USQHI)",
   label: "Hillsboro (USQHI)"
  },
  {
   value: "Hillsboro (USZH3)",
   label: "Hillsboro (USZH3)"
  },
  {
   value: "Hillsboro, Lawrence (USOOH)",
   label: "Hillsboro, Lawrence (USOOH)"
  },
  {
   value: "Hillsboro, Madison (USOOB)",
   label: "Hillsboro, Madison (USOOB)"
  },
  {
   value: "Hillsboro, Ohio (USHHX)",
   label: "Hillsboro, Ohio (USHHX)"
  },
  {
   value: "Hillsborough (USHSG)",
   label: "Hillsborough (USHSG)"
  },
  {
   value: "Hillsborough (USHSU)",
   label: "Hillsborough (USHSU)"
  },
  {
   value: "Hillsdale (USIDU)",
   label: "Hillsdale (USIDU)"
  },
  {
   value: "Hillside (USHSD)",
   label: "Hillside (USHSD)"
  },
  {
   value: "Hilmar (USZHM)",
   label: "Hilmar (USZHM)"
  },
  {
   value: "Hilton Head Island (USHHH)",
   label: "Hilton Head Island (USHHH)"
  },
  {
   value: "Himrod (USOHD)",
   label: "Himrod (USOHD)"
  },
  {
   value: "Hinckley (USHIZ)",
   label: "Hinckley (USHIZ)"
  },
  {
   value: "Hinesville (USLIY)",
   label: "Hinesville (USLIY)"
  },
  {
   value: "Hingham (USHGG)",
   label: "Hingham (USHGG)"
  },
  {
   value: "Hinton (USHTA)",
   label: "Hinton (USHTA)"
  },
  {
   value: "Hiram (USHR2)",
   label: "Hiram (USHR2)"
  },
  {
   value: "Hiwassee (USHWS)",
   label: "Hiwassee (USHWS)"
  },
  {
   value: "Hixton (USIXT)",
   label: "Hixton (USIXT)"
  },
  {
   value: "Hoagland (USHL4)",
   label: "Hoagland (USHL4)"
  },
  {
   value: "Hobart (USQOB)",
   label: "Hobart (USQOB)"
  },
  {
   value: "Hobbs (USIHB)",
   label: "Hobbs (USIHB)"
  },
  {
   value: "Hobbsville (USOVQ)",
   label: "Hobbsville (USOVQ)"
  },
  {
   value: "Hoboken (USHBK)",
   label: "Hoboken (USHBK)"
  },
  {
   value: "Hoboken (USOBP)",
   label: "Hoboken (USOBP)"
  },
  {
   value: "Hodgenville (USHGQ)",
   label: "Hodgenville (USHGQ)"
  },
  {
   value: "Hodges (USHDG)",
   label: "Hodges (USHDG)"
  },
  {
   value: "Hoffman Estates (USHME)",
   label: "Hoffman Estates (USHME)"
  },
  {
   value: "Hogansburg (USHGB)",
   label: "Hogansburg (USHGB)"
  },
  {
   value: "Hogatza (USHGZ)",
   label: "Hogatza (USHGZ)"
  },
  {
   value: "Hohenwald (USHOH)",
   label: "Hohenwald (USHOH)"
  },
  {
   value: "Ho-Ho-Kus (USHHK)",
   label: "Ho-Ho-Kus (USHHK)"
  },
  {
   value: "Hoisington (USZHT)",
   label: "Hoisington (USZHT)"
  },
  {
   value: "Holbrook (USHB8)",
   label: "Holbrook (USHB8)"
  },
  {
   value: "Holbrook (USHRK)",
   label: "Holbrook (USHRK)"
  },
  {
   value: "Holbrook (USZHK)",
   label: "Holbrook (USZHK)"
  },
  {
   value: "Holcomb (USHCM)",
   label: "Holcomb (USHCM)"
  },
  {
   value: "Holcomb (USHYH)",
   label: "Holcomb (USHYH)"
  },
  {
   value: "Holden (USHQ3)",
   label: "Holden (USHQ3)"
  },
  {
   value: "Holden (USHQD)",
   label: "Holden (USHQD)"
  },
  {
   value: "Holden (USHQO)",
   label: "Holden (USHQO)"
  },
  {
   value: "Holdrege (USHDE)",
   label: "Holdrege (USHDE)"
  },
  {
   value: "Holiday City (USHDI)",
   label: "Holiday City (USHDI)"
  },
  {
   value: "Holladay (USHD2)",
   label: "Holladay (USHD2)"
  },
  {
   value: "Holland (USLQD)",
   label: "Holland (USLQD)"
  },
  {
   value: "Holland (USWOL)",
   label: "Holland (USWOL)"
  },
  {
   value: "Holland, Effingham (USHL6)",
   label: "Holland, Effingham (USHL6)"
  },
  {
   value: "Hollandale (USOAD)",
   label: "Hollandale (USOAD)"
  },
  {
   value: "Holley (USNYH)",
   label: "Holley (USNYH)"
  },
  {
   value: "Hollidaysburg (USHDB)",
   label: "Hollidaysburg (USHDB)"
  },
  {
   value: "Hollis (USHLU)",
   label: "Hollis (USHLU)"
  },
  {
   value: "Hollis (USHYL)",
   label: "Hollis (USHYL)"
  },
  {
   value: "Hollister (USHRM)",
   label: "Hollister (USHRM)"
  },
  {
   value: "Hollister (USHXX)",
   label: "Hollister (USHXX)"
  },
  {
   value: "Holloman Air Force Base (USOMN)",
   label: "Holloman Air Force Base (USOMN)"
  },
  {
   value: "Hollsopple (USZPP)",
   label: "Hollsopple (USZPP)"
  },
  {
   value: "Holly Hill (USHHL)",
   label: "Holly Hill (USHHL)"
  },
  {
   value: "Holly Ridge (USHOG)",
   label: "Holly Ridge (USHOG)"
  },
  {
   value: "Holly Ridge (USOYG)",
   label: "Holly Ridge (USOYG)"
  },
  {
   value: "Holly Ridge (USOYR)",
   label: "Holly Ridge (USOYR)"
  },
  {
   value: "Holly Springs, Carteret (USHS5)",
   label: "Holly Springs, Carteret (USHS5)"
  },
  {
   value: "Holly Springs, Marshall (USHS7)",
   label: "Holly Springs, Marshall (USHS7)"
  },
  {
   value: "Hollywood (USIHW)",
   label: "Hollywood (USIHW)"
  },
  {
   value: "Hollywood (USOYW)",
   label: "Hollywood (USOYW)"
  },
  {
   value: "Holmen (USHFM)",
   label: "Holmen (USHFM)"
  },
  {
   value: "Holmes (USYHM)",
   label: "Holmes (USYHM)"
  },
  {
   value: "Holmesville (USH2V)",
   label: "Holmesville (USH2V)"
  },
  {
   value: "Holmesville (USZHQ)",
   label: "Holmesville (USZHQ)"
  },
  {
   value: "Holt (USHT7)",
   label: "Holt (USHT7)"
  },
  {
   value: "Holt (USOT8)",
   label: "Holt (USOT8)"
  },
  {
   value: "Holton (USHQT)",
   label: "Holton (USHQT)"
  },
  {
   value: "Holton (USHTJ)",
   label: "Holton (USHTJ)"
  },
  {
   value: "Holy Cross (USHCR)",
   label: "Holy Cross (USHCR)"
  },
  {
   value: "Holy Springs (USOYP)",
   label: "Holy Springs (USOYP)"
  },
  {
   value: "Homer (USHMH)",
   label: "Homer (USHMH)"
  },
  {
   value: "Homer (USHOM)",
   label: "Homer (USHOM)"
  },
  {
   value: "Homer (USHOR)",
   label: "Homer (USHOR)"
  },
  {
   value: "Homer (USHOZ)",
   label: "Homer (USHOZ)"
  },
  {
   value: "Homer City (USQHR)",
   label: "Homer City (USQHR)"
  },
  {
   value: "Homer Glen (USAOF)",
   label: "Homer Glen (USAOF)"
  },
  {
   value: "Hometown (USHT6)",
   label: "Hometown (USHT6)"
  },
  {
   value: "Homewood (USHMW)",
   label: "Homewood (USHMW)"
  },
  {
   value: "Homewood (USHWA)",
   label: "Homewood (USHWA)"
  },
  {
   value: "Homeworth (USHWH)",
   label: "Homeworth (USHWH)"
  },
  {
   value: "Homosassa (USHMF)",
   label: "Homosassa (USHMF)"
  },
  {
   value: "Honea Path (USOEP)",
   label: "Honea Path (USOEP)"
  },
  {
   value: "Honeoye (USOYE)",
   label: "Honeoye (USOYE)"
  },
  {
   value: "Honeoye Falls (USHFA)",
   label: "Honeoye Falls (USHFA)"
  },
  {
   value: "Honey Creek (USHCE)",
   label: "Honey Creek (USHCE)"
  },
  {
   value: "Honey Grove (USYHQ)",
   label: "Honey Grove (USYHQ)"
  },
  {
   value: "Honor (USKHO)",
   label: "Honor (USKHO)"
  },
  {
   value: "Hooker (USQHE)",
   label: "Hooker (USQHE)"
  },
  {
   value: "Hooks (USHKZ)",
   label: "Hooks (USHKZ)"
  },
  {
   value: "Hooksett (USKSH)",
   label: "Hooksett (USKSH)"
  },
  {
   value: "Hooper (USHP7)",
   label: "Hooper (USHP7)"
  },
  {
   value: "Hooper Bay (USHPB)",
   label: "Hooper Bay (USHPB)"
  },
  {
   value: "Hope (USHJP)",
   label: "Hope (USHJP)"
  },
  {
   value: "Hope (USHPJ)",
   label: "Hope (USHPJ)"
  },
  {
   value: "Hope (USZHZ)",
   label: "Hope (USZHZ)"
  },
  {
   value: "Hope Hull (USHHU)",
   label: "Hope Hull (USHHU)"
  },
  {
   value: "Hope Valley (USHPV)",
   label: "Hope Valley (USHPV)"
  },
  {
   value: "Hopkins (USKNC)",
   label: "Hopkins (USKNC)"
  },
  {
   value: "Hopkins (USOPO)",
   label: "Hopkins (USOPO)"
  },
  {
   value: "Hopkinton (USHKN)",
   label: "Hopkinton (USHKN)"
  },
  {
   value: "Hopkinton (USQHK)",
   label: "Hopkinton (USQHK)"
  },
  {
   value: "Hopland (USYHD)",
   label: "Hopland (USYHD)"
  },
  {
   value: "Horace (USHJZ)",
   label: "Horace (USHJZ)"
  },
  {
   value: "Horizon City (USHXZ)",
   label: "Horizon City (USHXZ)"
  },
  {
   value: "Horseshoe (USHOS)",
   label: "Horseshoe (USHOS)"
  },
  {
   value: "Horton (USHTU)",
   label: "Horton (USHTU)"
  },
  {
   value: "Horton (USHXT)",
   label: "Horton (USHXT)"
  },
  {
   value: "Hoschton (USHSX)",
   label: "Hoschton (USHSX)"
  },
  {
   value: "Hosford (USHS8)",
   label: "Hosford (USHS8)"
  },
  {
   value: "Hospers (USHSJ)",
   label: "Hospers (USHSJ)"
  },
  {
   value: "Houghton (USHQQ)",
   label: "Houghton (USHQQ)"
  },
  {
   value: "Houghton Lake (USHLK)",
   label: "Houghton Lake (USHLK)"
  },
  {
   value: "Houlton (USOUZ)",
   label: "Houlton (USOUZ)"
  },
  {
   value: "Houston (USHKA)",
   label: "Houston (USHKA)"
  },
  {
   value: "Houston (USHUW)",
   label: "Houston (USHUW)"
  },
  {
   value: "Houston (USZD5)",
   label: "Houston (USZD5)"
  },
  {
   value: "Howard (USHXA)",
   label: "Howard (USHXA)"
  },
  {
   value: "Howard (USHXW)",
   label: "Howard (USHXW)"
  },
  {
   value: "Howard City (USZIT)",
   label: "Howard City (USZIT)"
  },
  {
   value: "Howard Lake (USZD6)",
   label: "Howard Lake (USZD6)"
  },
  {
   value: "Howe (USHOY)",
   label: "Howe (USHOY)"
  },
  {
   value: "Howe (USHWB)",
   label: "Howe (USHWB)"
  },
  {
   value: "Howe (USOWX)",
   label: "Howe (USOWX)"
  },
  {
   value: "Hoxie (USHX2)",
   label: "Hoxie (USHX2)"
  },
  {
   value: "Hoyt Lakes (USYKL)",
   label: "Hoyt Lakes (USYKL)"
  },
  {
   value: "Hubbardston (USYHS)",
   label: "Hubbardston (USYHS)"
  },
  {
   value: "Hubbell (USHBX)",
   label: "Hubbell (USHBX)"
  },
  {
   value: "Hubbell (USHVB)",
   label: "Hubbell (USHVB)"
  },
  {
   value: "Huber Heights (USQHT)",
   label: "Huber Heights (USQHT)"
  },
  {
   value: "Hudson (USHDU)",
   label: "Hudson (USHDU)"
  },
  {
   value: "Hudson (USHDW)",
   label: "Hudson (USHDW)"
  },
  {
   value: "Hudson (USHJF)",
   label: "Hudson (USHJF)"
  },
  {
   value: "Hudson (USHSF)",
   label: "Hudson (USHSF)"
  },
  {
   value: "Hueytown (USHOW)",
   label: "Hueytown (USHOW)"
  },
  {
   value: "Huffman (USHFZ)",
   label: "Huffman (USHFZ)"
  },
  {
   value: "Huger (USQHG)",
   label: "Huger (USQHG)"
  },
  {
   value: "Hughes (USHG4)",
   label: "Hughes (USHG4)"
  },
  {
   value: "Hughes (USHUS)",
   label: "Hughes (USHUS)"
  },
  {
   value: "Hughes Springs (USHPG)",
   label: "Hughes Springs (USHPG)"
  },
  {
   value: "Hughesville (USHV2)",
   label: "Hughesville (USHV2)"
  },
  {
   value: "Hughson (USHSZ)",
   label: "Hughson (USHSZ)"
  },
  {
   value: "Hugo (USU9)",
   label: "Hugo (USU9)"
  },
  {
   value: "Hugoton (USUGT)",
   label: "Hugoton (USUGT)"
  },
  {
   value: "Huguenot (USHGU)",
   label: "Huguenot (USHGU)"
  },
  {
   value: "Hulbert (USHBT)",
   label: "Hulbert (USHBT)"
  },
  {
   value: "Hull (USUKL)",
   label: "Hull (USUKL)"
  },
  {
   value: "Hull (USULL)",
   label: "Hull (USULL)"
  },
  {
   value: "Humboldt (USZD7)",
   label: "Humboldt (USZD7)"
  },
  {
   value: "Hungerford (USHXF)",
   label: "Hungerford (USHXF)"
  },
  {
   value: "Hunt (USHUU)",
   label: "Hunt (USHUU)"
  },
  {
   value: "Huntington (USHNU)",
   label: "Huntington (USHNU)"
  },
  {
   value: "Huntington (USHUH)",
   label: "Huntington (USHUH)"
  },
  {
   value: "Huntington (USUTG)",
   label: "Huntington (USUTG)"
  },
  {
   value: "Huntington (USUTT)",
   label: "Huntington (USUTT)"
  },
  {
   value: "Huntington (USUTU)",
   label: "Huntington (USUTU)"
  },
  {
   value: "Huntington Station (USZHG)",
   label: "Huntington Station (USZHG)"
  },
  {
   value: "Huntington Woods (USHGW)",
   label: "Huntington Woods (USHGW)"
  },
  {
   value: "Huntley (USUEY)",
   label: "Huntley (USUEY)"
  },
  {
   value: "Huntly (USUTY)",
   label: "Huntly (USUTY)"
  },
  {
   value: "Hunts Point\/Bronx\/New York (USHUI)",
   label: "Hunts Point\/Bronx\/New York (USHUI)"
  },
  {
   value: "Huntsville (USHVF)",
   label: "Huntsville (USHVF)"
  },
  {
   value: "Hurley (USHU2)",
   label: "Hurley (USHU2)"
  },
  {
   value: "Hurley (USHUY)",
   label: "Hurley (USHUY)"
  },
  {
   value: "Hurley (USHUZ)",
   label: "Hurley (USHUZ)"
  },
  {
   value: "Huron (USHQR)",
   label: "Huron (USHQR)"
  },
  {
   value: "Huron (USTNH)",
   label: "Huron (USTNH)"
  },
  {
   value: "Hurricane (USHRC)",
   label: "Hurricane (USHRC)"
  },
  {
   value: "Hurricane (USIAH)",
   label: "Hurricane (USIAH)"
  },
  {
   value: "Hurtsboro (USUSO)",
   label: "Hurtsboro (USUSO)"
  },
  {
   value: "Huslia (USHSL)",
   label: "Huslia (USHSL)"
  },
  {
   value: "Hustisford (USZJT)",
   label: "Hustisford (USZJT)"
  },
  {
   value: "Hutto (USHT5)",
   label: "Hutto (USHT5)"
  },
  {
   value: "Huxley (USIHY)",
   label: "Huxley (USIHY)"
  },
  {
   value: "Hyde Park (USHPA)",
   label: "Hyde Park (USHPA)"
  },
  {
   value: "Hyde Park (USPDK)",
   label: "Hyde Park (USPDK)"
  },
  {
   value: "Hyde Park (USYPK)",
   label: "Hyde Park (USYPK)"
  },
  {
   value: "Hyden (USHYJ)",
   label: "Hyden (USHYJ)"
  },
  {
   value: "Hydesville (USYDH)",
   label: "Hydesville (USYDH)"
  },
  {
   value: "Hyrum (USHYU)",
   label: "Hyrum (USHYU)"
  },
  {
   value: "Icard (USICQ)",
   label: "Icard (USICQ)"
  },
  {
   value: "Icy Bay (USICY)",
   label: "Icy Bay (USICY)"
  },
  {
   value: "Ida (USID8)",
   label: "Ida (USID8)"
  },
  {
   value: "Idabel (USQIL)",
   label: "Idabel (USQIL)"
  },
  {
   value: "Idanha (USIHA)",
   label: "Idanha (USIHA)"
  },
  {
   value: "Ider (USIXD)",
   label: "Ider (USIXD)"
  },
  {
   value: "Igiugig (USIGG)",
   label: "Igiugig (USIGG)"
  },
  {
   value: "Ignacio (USIGA)",
   label: "Ignacio (USIGA)"
  },
  {
   value: "Ijamsville (USIJA)",
   label: "Ijamsville (USIJA)"
  },
  {
   value: "Iliamna (USILI)",
   label: "Iliamna (USILI)"
  },
  {
   value: "Illinois City (USZFT)",
   label: "Illinois City (USZFT)"
  },
  {
   value: "Ilwaco (USIQL)",
   label: "Ilwaco (USIQL)"
  },
  {
   value: "Imperial (USIMR)",
   label: "Imperial (USIMR)"
  },
  {
   value: "Incline Village (USIVG)",
   label: "Incline Village (USIVG)"
  },
  {
   value: "Independence (USINE)",
   label: "Independence (USINE)"
  },
  {
   value: "Independence (USINP)",
   label: "Independence (USINP)"
  },
  {
   value: "Independence (USIPC)",
   label: "Independence (USIPC)"
  },
  {
   value: "Independence (USIPD)",
   label: "Independence (USIPD)"
  },
  {
   value: "Indiahoma (USI2D)",
   label: "Indiahoma (USI2D)"
  },
  {
   value: "Indialantic (USYIL)",
   label: "Indialantic (USYIL)"
  },
  {
   value: "Indian Harbour (USZD8)",
   label: "Indian Harbour (USZD8)"
  },
  {
   value: "Indian Head (USD9)",
   label: "Indian Head (USD9)"
  },
  {
   value: "Indian Mills (USTGB)",
   label: "Indian Mills (USTGB)"
  },
  {
   value: "Indian Orchard (USIO2)",
   label: "Indian Orchard (USIO2)"
  },
  {
   value: "Indian River City (USIR2)",
   label: "Indian River City (USIR2)"
  },
  {
   value: "Indian Springs (USINS)",
   label: "Indian Springs (USINS)"
  },
  {
   value: "Indianola (USIAA)",
   label: "Indianola (USIAA)"
  },
  {
   value: "Indianola (USID4)",
   label: "Indianola (USID4)"
  },
  {
   value: "Indio (USIOC)",
   label: "Indio (USIOC)"
  },
  {
   value: "Industry (USIUY)",
   label: "Industry (USIUY)"
  },
  {
   value: "Industry (USXZZ)",
   label: "Industry (USXZZ)"
  },
  {
   value: "Ingleside (USYIG)",
   label: "Ingleside (USYIG)"
  },
  {
   value: "Ingram (USZFW)",
   label: "Ingram (USZFW)"
  },
  {
   value: "Inkom (USZIK)",
   label: "Inkom (USZIK)"
  },
  {
   value: "Inkster (USIK2)",
   label: "Inkster (USIK2)"
  },
  {
   value: "Inola (USIO8)",
   label: "Inola (USIO8)"
  },
  {
   value: "Interlaken (USIEK)",
   label: "Interlaken (USIEK)"
  },
  {
   value: "Inverness (USIVS)",
   label: "Inverness (USIVS)"
  },
  {
   value: "Inverness (USQIS)",
   label: "Inverness (USQIS)"
  },
  {
   value: "Inverness (USVRE)",
   label: "Inverness (USVRE)"
  },
  {
   value: "Inwood (USIIN)",
   label: "Inwood (USIIN)"
  },
  {
   value: "Inyokern (USIYK)",
   label: "Inyokern (USIYK)"
  },
  {
   value: "Iola (USILF)",
   label: "Iola (USILF)"
  },
  {
   value: "Ione (USION)",
   label: "Ione (USION)"
  },
  {
   value: "Ipswich (USISC)",
   label: "Ipswich (USISC)"
  },
  {
   value: "Ira (USIAV)",
   label: "Ira (USIAV)"
  },
  {
   value: "Iraan (USIRB)",
   label: "Iraan (USIRB)"
  },
  {
   value: "Irasburg (USIBR)",
   label: "Irasburg (USIBR)"
  },
  {
   value: "Ireland (USZG6)",
   label: "Ireland (USZG6)"
  },
  {
   value: "Ireton (USITF)",
   label: "Ireton (USITF)"
  },
  {
   value: "Iron City (USIRY)",
   label: "Iron City (USIRY)"
  },
  {
   value: "Iron Junction (USIRQ)",
   label: "Iron Junction (USIRQ)"
  },
  {
   value: "Iron River (USIIV)",
   label: "Iron River (USIIV)"
  },
  {
   value: "Iron River (USIRW)",
   label: "Iron River (USIRW)"
  },
  {
   value: "Iron Station (USIS2)",
   label: "Iron Station (USIS2)"
  },
  {
   value: "Irondale (USIRO)",
   label: "Irondale (USIRO)"
  },
  {
   value: "Irondale (USZIR)",
   label: "Irondale (USZIR)"
  },
  {
   value: "Ironton (USIRX)",
   label: "Ironton (USIRX)"
  },
  {
   value: "Ironwood (USIWD)",
   label: "Ironwood (USIWD)"
  },
  {
   value: "Irrigon (USIRR)",
   label: "Irrigon (USIRR)"
  },
  {
   value: "Irvine (USIVK)",
   label: "Irvine (USIVK)"
  },
  {
   value: "Irvona (USIRF)",
   label: "Irvona (USIRF)"
  },
  {
   value: "Isabel Pass (USISL)",
   label: "Isabel Pass (USISL)"
  },
  {
   value: "Isabella (USIB7)",
   label: "Isabella (USIB7)"
  },
  {
   value: "Isanti (USISI)",
   label: "Isanti (USISI)"
  },
  {
   value: "Islamorada (USISR)",
   label: "Islamorada (USISR)"
  },
  {
   value: "Island Falls (USIFL)",
   label: "Island Falls (USIFL)"
  },
  {
   value: "Island Park (USIAP)",
   label: "Island Park (USIAP)"
  },
  {
   value: "Islandia (USYIE)",
   label: "Islandia (USYIE)"
  },
  {
   value: "Isle (USIVA)",
   label: "Isle (USIVA)"
  },
  {
   value: "Isle of Palms (USIOP)",
   label: "Isle of Palms (USIOP)"
  },
  {
   value: "Issaquah (USIQH)",
   label: "Issaquah (USIQH)"
  },
  {
   value: "Italy (USIAY)",
   label: "Italy (USIAY)"
  },
  {
   value: "Ithaca (USITA)",
   label: "Ithaca (USITA)"
  },
  {
   value: "Iuka (USIUK)",
   label: "Iuka (USIUK)"
  },
  {
   value: "Iva (USIV2)",
   label: "Iva (USIV2)"
  },
  {
   value: "Ivanof Bay (USKIB)",
   label: "Ivanof Bay (USKIB)"
  },
  {
   value: "Ivel (USIV8)",
   label: "Ivel (USIV8)"
  },
  {
   value: "Ivesdale (USVDE)",
   label: "Ivesdale (USVDE)"
  },
  {
   value: "Ivishak (USIVH)",
   label: "Ivishak (USIVH)"
  },
  {
   value: "Ivory (USIV3)",
   label: "Ivory (USIV3)"
  },
  {
   value: "Ivy (USIFY)",
   label: "Ivy (USIFY)"
  },
  {
   value: "Ivyland (USIVY)",
   label: "Ivyland (USIVY)"
  },
  {
   value: "Ixonia (USIXN)",
   label: "Ixonia (USIXN)"
  },
  {
   value: "Ixonia (USIXO)",
   label: "Ixonia (USIXO)"
  },
  {
   value: "Jackpot (USKPT)",
   label: "Jackpot (USKPT)"
  },
  {
   value: "Jacksboro (USJQK)",
   label: "Jacksboro (USJQK)"
  },
  {
   value: "Jacksboro (USJRO)",
   label: "Jacksboro (USJRO)"
  },
  {
   value: "Jackson (USJAK)",
   label: "Jackson (USJAK)"
  },
  {
   value: "Jackson (USJCS)",
   label: "Jackson (USJCS)"
  },
  {
   value: "Jackson (USJS2)",
   label: "Jackson (USJS2)"
  },
  {
   value: "Jackson (USJS3)",
   label: "Jackson (USJS3)"
  },
  {
   value: "Jackson (USNJJ)",
   label: "Jackson (USNJJ)"
  },
  {
   value: "Jackson Center (USJKC)",
   label: "Jackson Center (USJKC)"
  },
  {
   value: "Jackson, Aiken (USJS7)",
   label: "Jackson, Aiken (USJS7)"
  },
  {
   value: "Jackson, Georgetown (USJAG)",
   label: "Jackson, Georgetown (USJAG)"
  },
  {
   value: "Jacksonville (USJV2)",
   label: "Jacksonville (USJV2)"
  },
  {
   value: "Jacksonville Beach (USJVB)",
   label: "Jacksonville Beach (USJVB)"
  },
  {
   value: "Jacksonville, Telfair (USJKE)",
   label: "Jacksonville, Telfair (USJKE)"
  },
  {
   value: "James Island (USJXI)",
   label: "James Island (USJXI)"
  },
  {
   value: "Jamesburg (USJMB)",
   label: "Jamesburg (USJMB)"
  },
  {
   value: "Jamesport (USJMP)",
   label: "Jamesport (USJMP)"
  },
  {
   value: "Jamesport (USJPY)",
   label: "Jamesport (USJPY)"
  },
  {
   value: "Jamestown (USJAD)",
   label: "Jamestown (USJAD)"
  },
  {
   value: "Jamestown (USJAT)",
   label: "Jamestown (USJAT)"
  },
  {
   value: "Jamestown (USJSO)",
   label: "Jamestown (USJSO)"
  },
  {
   value: "Jamestown (USJSW)",
   label: "Jamestown (USJSW)"
  },
  {
   value: "Jamestown (USJWN)",
   label: "Jamestown (USJWN)"
  },
  {
   value: "Jamestown (USQJM)",
   label: "Jamestown (USQJM)"
  },
  {
   value: "Jamestown, Cambria (USJSN)",
   label: "Jamestown, Cambria (USJSN)"
  },
  {
   value: "Jamul (USJAL)",
   label: "Jamul (USJAL)"
  },
  {
   value: "Jane Lew (USJAE)",
   label: "Jane Lew (USJAE)"
  },
  {
   value: "Janesville (USJAV)",
   label: "Janesville (USJAV)"
  },
  {
   value: "Janesville (USJSV)",
   label: "Janesville (USJSV)"
  },
  {
   value: "Jarrell (USJRR)",
   label: "Jarrell (USJRR)"
  },
  {
   value: "Jarrettsville (USJRV)",
   label: "Jarrettsville (USJRV)"
  },
  {
   value: "Jarvisburg (USJSG)",
   label: "Jarvisburg (USJSG)"
  },
  {
   value: "Jasonville (USJSJ)",
   label: "Jasonville (USJSJ)"
  },
  {
   value: "Jasper (USAPT)",
   label: "Jasper (USAPT)"
  },
  {
   value: "Jasper (USJAB)",
   label: "Jasper (USJAB)"
  },
  {
   value: "Jasper (USJAZ)",
   label: "Jasper (USJAZ)"
  },
  {
   value: "Jasper (USJPE)",
   label: "Jasper (USJPE)"
  },
  {
   value: "Jasper (USJPR)",
   label: "Jasper (USJPR)"
  },
  {
   value: "Jasper (USJSP)",
   label: "Jasper (USJSP)"
  },
  {
   value: "Jasper (USZJP)",
   label: "Jasper (USZJP)"
  },
  {
   value: "Jay (USJAF)",
   label: "Jay (USJAF)"
  },
  {
   value: "Jay (USJAY)",
   label: "Jay (USJAY)"
  },
  {
   value: "Jay (USVJY)",
   label: "Jay (USVJY)"
  },
  {
   value: "Jean (USJGE)",
   label: "Jean (USJGE)"
  },
  {
   value: "Jeanerette (USJTE)",
   label: "Jeanerette (USJTE)"
  },
  {
   value: "Jefferson (USJEO)",
   label: "Jefferson (USJEO)"
  },
  {
   value: "Jefferson (USJFA)",
   label: "Jefferson (USJFA)"
  },
  {
   value: "Jefferson (USJFG)",
   label: "Jefferson (USJFG)"
  },
  {
   value: "Jefferson (USJFR)",
   label: "Jefferson (USJFR)"
  },
  {
   value: "Jefferson (USJFZ)",
   label: "Jefferson (USJFZ)"
  },
  {
   value: "Jefferson (USQJE)",
   label: "Jefferson (USQJE)"
  },
  {
   value: "Jefferson, Jackson (USJF2)",
   label: "Jefferson, Jackson (USJF2)"
  },
  {
   value: "Jeffersonville (USJEI)",
   label: "Jeffersonville (USJEI)"
  },
  {
   value: "Jeffersonville (USJFO)",
   label: "Jeffersonville (USJFO)"
  },
  {
   value: "Jeffersonville (USJRL)",
   label: "Jeffersonville (USJRL)"
  },
  {
   value: "Jellico (USJLC)",
   label: "Jellico (USJLC)"
  },
  {
   value: "Jemison (USJEQ)",
   label: "Jemison (USJEQ)"
  },
  {
   value: "Jena (USJNA)",
   label: "Jena (USJNA)"
  },
  {
   value: "Jenison (USJNS)",
   label: "Jenison (USJNS)"
  },
  {
   value: "Jenkins (USJNK)",
   label: "Jenkins (USJNK)"
  },
  {
   value: "Jenkinsburg (USZ2F)",
   label: "Jenkinsburg (USZ2F)"
  },
  {
   value: "Jenks (USJUK)",
   label: "Jenks (USJUK)"
  },
  {
   value: "Jennings (USJEN)",
   label: "Jennings (USJEN)"
  },
  {
   value: "Jensen Beach (USJBC)",
   label: "Jensen Beach (USJBC)"
  },
  {
   value: "Jericho (USJRH)",
   label: "Jericho (USJRH)"
  },
  {
   value: "Jersey Shore (USZJS)",
   label: "Jersey Shore (USZJS)"
  },
  {
   value: "Jerseyville (USYJY)",
   label: "Jerseyville (USYJY)"
  },
  {
   value: "Jesup (USJSU)",
   label: "Jesup (USJSU)"
  },
  {
   value: "Jetersville (USJTV)",
   label: "Jetersville (USJTV)"
  },
  {
   value: "Jewell (USJEW)",
   label: "Jewell (USJEW)"
  },
  {
   value: "Jewell (USJWL)",
   label: "Jewell (USJWL)"
  },
  {
   value: "Joanna (USJNB)",
   label: "Joanna (USJNB)"
  },
  {
   value: "Jobstown (USQJB)",
   label: "Jobstown (USQJB)"
  },
  {
   value: "John Day (USJDA)",
   label: "John Day (USJDA)"
  },
  {
   value: "John F Kennedy Space Center\/Cape Canaveral (USKDC)",
   label: "John F Kennedy Space Center\/Cape Canaveral (USKDC)"
  },
  {
   value: "Johnsburg (USJBG)",
   label: "Johnsburg (USJBG)"
  },
  {
   value: "Johnson (USJJO)",
   label: "Johnson (USJJO)"
  },
  {
   value: "Johnson City (USJCI)",
   label: "Johnson City (USJCI)"
  },
  {
   value: "Johnson City (USJOC)",
   label: "Johnson City (USJOC)"
  },
  {
   value: "Johnson City (USJOY)",
   label: "Johnson City (USJOY)"
  },
  {
   value: "Johnsonville (USJS8)",
   label: "Johnsonville (USJS8)"
  },
  {
   value: "Johnston (USJHE)",
   label: "Johnston (USJHE)"
  },
  {
   value: "Johnston (USJHS)",
   label: "Johnston (USJHS)"
  },
  {
   value: "Johnston (USJS4)",
   label: "Johnston (USJS4)"
  },
  {
   value: "Johnstown (USJOW)",
   label: "Johnstown (USJOW)"
  },
  {
   value: "Joiner (USJN8)",
   label: "Joiner (USJN8)"
  },
  {
   value: "Jolly (USJY2)",
   label: "Jolly (USJY2)"
  },
  {
   value: "Jollyville (USJV3)",
   label: "Jollyville (USJV3)"
  },
  {
   value: "Jones (USJNE)",
   label: "Jones (USJNE)"
  },
  {
   value: "Jonesboro (USJBO)",
   label: "Jonesboro (USJBO)"
  },
  {
   value: "Jonesburg (USZF5)",
   label: "Jonesburg (USZF5)"
  },
  {
   value: "Jonestown (USJNT)",
   label: "Jonestown (USJNT)"
  },
  {
   value: "Jonesville (USJEZ)",
   label: "Jonesville (USJEZ)"
  },
  {
   value: "Jonesville (USJOI)",
   label: "Jonesville (USJOI)"
  },
  {
   value: "Jonesville (USJOL)",
   label: "Jonesville (USJOL)"
  },
  {
   value: "Joppa (USJPA)",
   label: "Joppa (USJPA)"
  },
  {
   value: "Jordan (USJDN)",
   label: "Jordan (USJDN)"
  },
  {
   value: "Jordan, Scott (USJN3)",
   label: "Jordan, Scott (USJN3)"
  },
  {
   value: "Joseph City (USJPC)",
   label: "Joseph City (USJPC)"
  },
  {
   value: "Joshua (USJTX)",
   label: "Joshua (USJTX)"
  },
  {
   value: "Jourdanton (USJN2)",
   label: "Jourdanton (USJN2)"
  },
  {
   value: "Juda (USJUD)",
   label: "Juda (USJUD)"
  },
  {
   value: "Judsonia (USJSA)",
   label: "Judsonia (USJSA)"
  },
  {
   value: "Julian (USJUL)",
   label: "Julian (USJUL)"
  },
  {
   value: "Juliette (USJL2)",
   label: "Juliette (USJL2)"
  },
  {
   value: "Junction City (USJNC)",
   label: "Junction City (USJNC)"
  },
  {
   value: "Junction City (USJUN)",
   label: "Junction City (USJUN)"
  },
  {
   value: "Junction City, Perry (USJUC)",
   label: "Junction City, Perry (USJUC)"
  },
  {
   value: "Juno Beach (USJB2)",
   label: "Juno Beach (USJB2)"
  },
  {
   value: "Justice (USJTC)",
   label: "Justice (USJTC)"
  },
  {
   value: "Justin (USJSI)",
   label: "Justin (USJSI)"
  },
  {
   value: "Kaguyak (USKAG)",
   label: "Kaguyak (USKAG)"
  },
  {
   value: "Kagvik Creek (USKKF)",
   label: "Kagvik Creek (USKKF)"
  },
  {
   value: "Kahoka (USKH2)",
   label: "Kahoka (USKH2)"
  },
  {
   value: "Kaiser (USKAI)",
   label: "Kaiser (USKAI)"
  },
  {
   value: "Kaiser\/Lake Ozark (USAIZ)",
   label: "Kaiser\/Lake Ozark (USAIZ)"
  },
  {
   value: "Kakhonak (USKNK)",
   label: "Kakhonak (USKNK)"
  },
  {
   value: "Kalakaket (USKKK)",
   label: "Kalakaket (USKKK)"
  },
  {
   value: "Kalama (USKAM)",
   label: "Kalama (USKAM)"
  },
  {
   value: "Kalamazoo (USAZO)",
   label: "Kalamazoo (USAZO)"
  },
  {
   value: "Kalaupapa (USLUP)",
   label: "Kalaupapa (USLUP)"
  },
  {
   value: "Kalkaska (USKLK)",
   label: "Kalkaska (USKLK)"
  },
  {
   value: "Kalona (USKAC)",
   label: "Kalona (USKAC)"
  },
  {
   value: "Kalskag (USKLG)",
   label: "Kalskag (USKLG)"
  },
  {
   value: "Kamas (USKM7)",
   label: "Kamas (USKM7)"
  },
  {
   value: "Kamiah (USKM2)",
   label: "Kamiah (USKM2)"
  },
  {
   value: "Kanab (USKNB)",
   label: "Kanab (USKNB)"
  },
  {
   value: "Kanawha (USK2W)",
   label: "Kanawha (USK2W)"
  },
  {
   value: "Kaneohe (USKHE)",
   label: "Kaneohe (USKHE)"
  },
  {
   value: "Kanosh (USKAO)",
   label: "Kanosh (USKAO)"
  },
  {
   value: "Kansasville (USKSV)",
   label: "Kansasville (USKSV)"
  },
  {
   value: "Kapalua (USJHM)",
   label: "Kapalua (USJHM)"
  },
  {
   value: "Kapolei (USKPI)",
   label: "Kapolei (USKPI)"
  },
  {
   value: "Karlstad (USKTD)",
   label: "Karlstad (USKTD)"
  },
  {
   value: "Karluk (USKYK)",
   label: "Karluk (USKYK)"
  },
  {
   value: "Karluk Lake (USKKL)",
   label: "Karluk Lake (USKKL)"
  },
  {
   value: "Kasaan (USKXA)",
   label: "Kasaan (USKXA)"
  },
  {
   value: "Kasigluk (USKUK)",
   label: "Kasigluk (USKUK)"
  },
  {
   value: "Kasota (USKS2)",
   label: "Kasota (USKS2)"
  },
  {
   value: "Kasson (USKOS)",
   label: "Kasson (USKOS)"
  },
  {
   value: "Kathleen (USKFN)",
   label: "Kathleen (USKFN)"
  },
  {
   value: "Kaufman (USKFA)",
   label: "Kaufman (USKFA)"
  },
  {
   value: "Kaunakakai (Molokai) (USKUA)",
   label: "Kaunakakai (Molokai) (USKUA)"
  },
  {
   value: "Kayenta (USMVM)",
   label: "Kayenta (USMVM)"
  },
  {
   value: "Kaysville (USKAY)",
   label: "Kaysville (USKAY)"
  },
  {
   value: "Kealakekua (USKK2)",
   label: "Kealakekua (USKK2)"
  },
  {
   value: "Keansburg (USKUG)",
   label: "Keansburg (USKUG)"
  },
  {
   value: "Kearneysville (USKYV)",
   label: "Kearneysville (USKYV)"
  },
  {
   value: "Keego Harbor (USKHB)",
   label: "Keego Harbor (USKHB)"
  },
  {
   value: "Keene (USKN2)",
   label: "Keene (USKN2)"
  },
  {
   value: "Keenesburg (USZOZ)",
   label: "Keenesburg (USZOZ)"
  },
  {
   value: "Keithsburg (USKBU)",
   label: "Keithsburg (USKBU)"
  },
  {
   value: "Keithville (USKV2)",
   label: "Keithville (USKV2)"
  },
  {
   value: "Keizer (USKZR)",
   label: "Keizer (USKZR)"
  },
  {
   value: "Kekaha (USBKH)",
   label: "Kekaha (USBKH)"
  },
  {
   value: "Kellogg (USKEC)",
   label: "Kellogg (USKEC)"
  },
  {
   value: "Kelly (USKY7)",
   label: "Kelly (USKY7)"
  },
  {
   value: "Kelly Bar (USKEU)",
   label: "Kelly Bar (USKEU)"
  },
  {
   value: "Kelp Bay (USKLP)",
   label: "Kelp Bay (USKLP)"
  },
  {
   value: "Kelseyville (USKV3)",
   label: "Kelseyville (USKV3)"
  },
  {
   value: "Kemah (USKEM)",
   label: "Kemah (USKEM)"
  },
  {
   value: "Kemmerer (USEMM)",
   label: "Kemmerer (USEMM)"
  },
  {
   value: "Kempton (USKMP)",
   label: "Kempton (USKMP)"
  },
  {
   value: "Kendall (USKEL)",
   label: "Kendall (USKEL)"
  },
  {
   value: "Kendall (USZDL)",
   label: "Kendall (USZDL)"
  },
  {
   value: "Kenesaw (USKAW)",
   label: "Kenesaw (USKAW)"
  },
  {
   value: "Kenilworth (USKWO)",
   label: "Kenilworth (USKWO)"
  },
  {
   value: "Kenilworth (USKWR)",
   label: "Kenilworth (USKWR)"
  },
  {
   value: "Kenilworth (USKWW)",
   label: "Kenilworth (USKWW)"
  },
  {
   value: "Kenly (USKN3)",
   label: "Kenly (USKN3)"
  },
  {
   value: "Kenmore (USKMR)",
   label: "Kenmore (USKMR)"
  },
  {
   value: "Kenmore\/Seattle (USKAH)",
   label: "Kenmore\/Seattle (USKAH)"
  },
  {
   value: "Kenna (USDKA)",
   label: "Kenna (USDKA)"
  },
  {
   value: "Kennedyville (USKV4)",
   label: "Kennedyville (USKV4)"
  },
  {
   value: "Kennewick (USKWC)",
   label: "Kennewick (USKWC)"
  },
  {
   value: "Kensett (USKZT)",
   label: "Kensett (USKZT)"
  },
  {
   value: "Kensington (USKEN)",
   label: "Kensington (USKEN)"
  },
  {
   value: "Kensington (USKSG)",
   label: "Kensington (USKSG)"
  },
  {
   value: "Kensington (USKXX)",
   label: "Kensington (USKXX)"
  },
  {
   value: "Kent (USKJT)",
   label: "Kent (USKJT)"
  },
  {
   value: "Kent (USKTV)",
   label: "Kent (USKTV)"
  },
  {
   value: "Kent City (USKCT)",
   label: "Kent City (USKCT)"
  },
  {
   value: "Kenton (USKEO)",
   label: "Kenton (USKEO)"
  },
  {
   value: "Kenton (USKNO)",
   label: "Kenton (USKNO)"
  },
  {
   value: "Kenvil (USKV5)",
   label: "Kenvil (USKV5)"
  },
  {
   value: "Kenyon (USEYO)",
   label: "Kenyon (USEYO)"
  },
  {
   value: "Keota (USKTZ)",
   label: "Keota (USKTZ)"
  },
  {
   value: "Kermit (USKHM)",
   label: "Kermit (USKHM)"
  },
  {
   value: "Kersey (USKRR)",
   label: "Kersey (USKRR)"
  },
  {
   value: "Keswick (USQKK)",
   label: "Keswick (USQKK)"
  },
  {
   value: "Ketchum (USQKM)",
   label: "Ketchum (USQKM)"
  },
  {
   value: "Kettering (USNGG)",
   label: "Kettering (USNGG)"
  },
  {
   value: "Kettle Falls (USKFW)",
   label: "Kettle Falls (USKFW)"
  },
  {
   value: "Kettleman City (USKTL)",
   label: "Kettleman City (USKTL)"
  },
  {
   value: "Kettlersville (USKLV)",
   label: "Kettlersville (USKLV)"
  },
  {
   value: "Kew Gardens, Queens (USKG2)",
   label: "Kew Gardens, Queens (USKG2)"
  },
  {
   value: "Kewaunee (USKWU)",
   label: "Kewaunee (USKWU)"
  },
  {
   value: "Key Largo (USKYL)",
   label: "Key Largo (USKYL)"
  },
  {
   value: "Keyesport (USKEE)",
   label: "Keyesport (USKEE)"
  },
  {
   value: "Keymar (USKY2)",
   label: "Keymar (USKY2)"
  },
  {
   value: "Keyport (USKYP)",
   label: "Keyport (USKYP)"
  },
  {
   value: "Keyser (USKY3)",
   label: "Keyser (USKY3)"
  },
  {
   value: "Keystone (USKS4)",
   label: "Keystone (USKS4)"
  },
  {
   value: "Keystone (USKTE)",
   label: "Keystone (USKTE)"
  },
  {
   value: "Keystone (USKYS)",
   label: "Keystone (USKYS)"
  },
  {
   value: "Keysville (USKEV)",
   label: "Keysville (USKEV)"
  },
  {
   value: "Keysville (USZYK)",
   label: "Keysville (USZYK)"
  },
  {
   value: "Kiana (USIAN)",
   label: "Kiana (USIAN)"
  },
  {
   value: "Kiawah Island (USKIA)",
   label: "Kiawah Island (USKIA)"
  },
  {
   value: "Kiefer (USKFE)",
   label: "Kiefer (USKFE)"
  },
  {
   value: "Kiel (USKEI)",
   label: "Kiel (USKEI)"
  },
  {
   value: "Kihei (USKIH)",
   label: "Kihei (USKIH)"
  },
  {
   value: "Kilgore (USKGR)",
   label: "Kilgore (USKGR)"
  },
  {
   value: "Killbuck (USKIK)",
   label: "Killbuck (USKIK)"
  },
  {
   value: "Killen (USKLI)",
   label: "Killen (USKLI)"
  },
  {
   value: "Killington Village (USKLT)",
   label: "Killington Village (USKLT)"
  },
  {
   value: "Killingworth (USKNH)",
   label: "Killingworth (USKNH)"
  },
  {
   value: "Killona (USKON)",
   label: "Killona (USKON)"
  },
  {
   value: "Kilmanrock (USKR2)",
   label: "Kilmanrock (USKR2)"
  },
  {
   value: "Kimball (USKM4)",
   label: "Kimball (USKM4)"
  },
  {
   value: "Kimball (USKM8)",
   label: "Kimball (USKM8)"
  },
  {
   value: "Kimball (USKMB)",
   label: "Kimball (USKMB)"
  },
  {
   value: "Kimberling City (USQKC)",
   label: "Kimberling City (USQKC)"
  },
  {
   value: "Kincaid (USKXC)",
   label: "Kincaid (USKXC)"
  },
  {
   value: "Kincheloe (USKCH)",
   label: "Kincheloe (USKCH)"
  },
  {
   value: "Kinder (USKIJ)",
   label: "Kinder (USKIJ)"
  },
  {
   value: "Kinderhook (USKHK)",
   label: "Kinderhook (USKHK)"
  },
  {
   value: "Kindred (USKNR)",
   label: "Kindred (USKNR)"
  },
  {
   value: "King (USKG3)",
   label: "King (USKG3)"
  },
  {
   value: "King Ferry (USKGF)",
   label: "King Ferry (USKGF)"
  },
  {
   value: "King George (USKGG)",
   label: "King George (USKGG)"
  },
  {
   value: "King of Prussia (USKPD)",
   label: "King of Prussia (USKPD)"
  },
  {
   value: "King Salmon (USAKN)",
   label: "King Salmon (USAKN)"
  },
  {
   value: "King William (USKWM)",
   label: "King William (USKWM)"
  },
  {
   value: "Kingdom City (USKGE)",
   label: "Kingdom City (USKGE)"
  },
  {
   value: "Kingfield (USKDK)",
   label: "Kingfield (USKDK)"
  },
  {
   value: "Kingfisher (USKIF)",
   label: "Kingfisher (USKIF)"
  },
  {
   value: "Kingman (USKNM)",
   label: "Kingman (USKNM)"
  },
  {
   value: "Kingman (USZUD)",
   label: "Kingman (USZUD)"
  },
  {
   value: "Kings Bay (USZKB)",
   label: "Kings Bay (USZKB)"
  },
  {
   value: "Kings Mills (USKGM)",
   label: "Kings Mills (USKGM)"
  },
  {
   value: "Kings Park (USKSP)",
   label: "Kings Park (USKSP)"
  },
  {
   value: "Kingsbury (USKB2)",
   label: "Kingsbury (USKB2)"
  },
  {
   value: "Kingsford (USKFD)",
   label: "Kingsford (USKFD)"
  },
  {
   value: "Kingsland (USKGL)",
   label: "Kingsland (USKGL)"
  },
  {
   value: "Kingsland (USKNL)",
   label: "Kingsland (USKNL)"
  },
  {
   value: "Kingston (USKG8)",
   label: "Kingston (USKG8)"
  },
  {
   value: "Kingston (USKGC)",
   label: "Kingston (USKGC)"
  },
  {
   value: "Kingston (USKSO)",
   label: "Kingston (USKSO)"
  },
  {
   value: "Kingston (USKT5)",
   label: "Kingston (USKT5)"
  },
  {
   value: "Kingston Springs (USKS3)",
   label: "Kingston Springs (USKS3)"
  },
  {
   value: "Kingstown (USKGO)",
   label: "Kingstown (USKGO)"
  },
  {
   value: "Kinross (USKRO)",
   label: "Kinross (USKRO)"
  },
  {
   value: "Kinsman (USKFM)",
   label: "Kinsman (USKFM)"
  },
  {
   value: "Kinsman, Belmont (USKMN)",
   label: "Kinsman, Belmont (USKMN)"
  },
  {
   value: "Kinsman, Trumbull (USKSA)",
   label: "Kinsman, Trumbull (USKSA)"
  },
  {
   value: "Kinston (USQKL)",
   label: "Kinston (USQKL)"
  },
  {
   value: "Kiowa (USKW8)",
   label: "Kiowa (USKW8)"
  },
  {
   value: "Kiowa (USKWA)",
   label: "Kiowa (USKWA)"
  },
  {
   value: "Kipnuk (USKPN)",
   label: "Kipnuk (USKPN)"
  },
  {
   value: "Kirkland (USKKZ)",
   label: "Kirkland (USKKZ)"
  },
  {
   value: "Kirklin (USIKL)",
   label: "Kirklin (USIKL)"
  },
  {
   value: "Kirkwood (USKIR)",
   label: "Kirkwood (USKIR)"
  },
  {
   value: "Kirkwood (USKRZ)",
   label: "Kirkwood (USKRZ)"
  },
  {
   value: "Kirkwood (USXKW)",
   label: "Kirkwood (USXKW)"
  },
  {
   value: "Kirtland (USKCQ)",
   label: "Kirtland (USKCQ)"
  },
  {
   value: "Kiska Island (USKIS)",
   label: "Kiska Island (USKIS)"
  },
  {
   value: "Kitoi Bay (USKKB)",
   label: "Kitoi Bay (USKKB)"
  },
  {
   value: "Kittery (USKXK)",
   label: "Kittery (USKXK)"
  },
  {
   value: "Kitty Hawk (USKTT)",
   label: "Kitty Hawk (USKTT)"
  },
  {
   value: "Kivalina (USKVL)",
   label: "Kivalina (USKVL)"
  },
  {
   value: "Kizhuyak (USKZH)",
   label: "Kizhuyak (USKZH)"
  },
  {
   value: "Klag Bay (USKBK)",
   label: "Klag Bay (USKBK)"
  },
  {
   value: "Klondike (USKDI)",
   label: "Klondike (USKDI)"
  },
  {
   value: "Knapp (USKAP)",
   label: "Knapp (USKAP)"
  },
  {
   value: "Kneeland (USKLX)",
   label: "Kneeland (USKLX)"
  },
  {
   value: "Knightdale (USKNI)",
   label: "Knightdale (USKNI)"
  },
  {
   value: "Knights Landing (USKL7)",
   label: "Knights Landing (USKL7)"
  },
  {
   value: "Knippa (USKP2)",
   label: "Knippa (USKP2)"
  },
  {
   value: "Knobel (USKL2)",
   label: "Knobel (USKL2)"
  },
  {
   value: "Knoxville (USKXE)",
   label: "Knoxville (USKXE)"
  },
  {
   value: "Knoxville (USKXL)",
   label: "Knoxville (USKXL)"
  },
  {
   value: "Knoxville (USKXV)",
   label: "Knoxville (USKXV)"
  },
  {
   value: "Knoxville (USZF2)",
   label: "Knoxville (USZF2)"
  },
  {
   value: "Kobuk (USOBU)",
   label: "Kobuk (USOBU)"
  },
  {
   value: "Kodak (USKDA)",
   label: "Kodak (USKDA)"
  },
  {
   value: "Konawa (USKW2)",
   label: "Konawa (USKW2)"
  },
  {
   value: "Kootenai (USKO2)",
   label: "Kootenai (USKO2)"
  },
  {
   value: "Koppel (USKPP)",
   label: "Koppel (USKPP)"
  },
  {
   value: "Kotlik (USKOT)",
   label: "Kotlik (USKOT)"
  },
  {
   value: "Kotzebue (USOTZ)",
   label: "Kotzebue (USOTZ)"
  },
  {
   value: "Kountze (USKNZ)",
   label: "Kountze (USKNZ)"
  },
  {
   value: "Kouts (USZKT)",
   label: "Kouts (USZKT)"
  },
  {
   value: "Koyukuk (USKYU)",
   label: "Koyukuk (USKYU)"
  },
  {
   value: "Krakow (USKK3)",
   label: "Krakow (USKK3)"
  },
  {
   value: "Krebs (USKRE)",
   label: "Krebs (USKRE)"
  },
  {
   value: "Kremlin (USKML)",
   label: "Kremlin (USKML)"
  },
  {
   value: "Kremmling (USKM3)",
   label: "Kremmling (USKM3)"
  },
  {
   value: "Kress (USKS7)",
   label: "Kress (USKS7)"
  },
  {
   value: "Krotz Springs (USKZS)",
   label: "Krotz Springs (USKZS)"
  },
  {
   value: "Kugururok River (USKUW)",
   label: "Kugururok River (USKUW)"
  },
  {
   value: "Kulpmont (USKUL)",
   label: "Kulpmont (USKUL)"
  },
  {
   value: "Kuna (USKUN)",
   label: "Kuna (USKUN)"
  },
  {
   value: "Kunkletown (USK2T)",
   label: "Kunkletown (USK2T)"
  },
  {
   value: "Kutztown (USKUT)",
   label: "Kutztown (USKUT)"
  },
  {
   value: "Kyana (USKAZ)",
   label: "Kyana (USKAZ)"
  },
  {
   value: "Kyle (USKYZ)",
   label: "Kyle (USKYZ)"
  },
  {
   value: "Kylertown (USKYT)",
   label: "Kylertown (USKYT)"
  },
  {
   value: "La Barge (USLB8)",
   label: "La Barge (USLB8)"
  },
  {
   value: "La Center (USLZR)",
   label: "La Center (USLZR)"
  },
  {
   value: "La Crosse (USRQS)",
   label: "La Crosse (USRQS)"
  },
  {
   value: "La Crosse (USXSO)",
   label: "La Crosse (USXSO)"
  },
  {
   value: "La Fayette (USLFE)",
   label: "La Fayette (USLFE)"
  },
  {
   value: "La Fayette (USVLF)",
   label: "La Fayette (USVLF)"
  },
  {
   value: "La France (USLFH)",
   label: "La France (USLFH)"
  },
  {
   value: "La Grange (USGGL)",
   label: "La Grange (USGGL)"
  },
  {
   value: "La Grange (USLGK)",
   label: "La Grange (USLGK)"
  },
  {
   value: "La Grange (USLGR)",
   label: "La Grange (USLGR)"
  },
  {
   value: "La Grange Park (USLPG)",
   label: "La Grange Park (USLPG)"
  },
  {
   value: "La Habra, Orange (USLHA)",
   label: "La Habra, Orange (USLHA)"
  },
  {
   value: "La Jolla (USLJL)",
   label: "La Jolla (USLJL)"
  },
  {
   value: "La Mesa (USLAE)",
   label: "La Mesa (USLAE)"
  },
  {
   value: "La Paz (USLPZ)",
   label: "La Paz (USLPZ)"
  },
  {
   value: "La Pine (USLPH)",
   label: "La Pine (USLPH)"
  },
  {
   value: "La Pointe (USJPP)",
   label: "La Pointe (USJPP)"
  },
  {
   value: "La Porte (USLPE)",
   label: "La Porte (USLPE)"
  },
  {
   value: "La Quinta (USLQ8)",
   label: "La Quinta (USLQ8)"
  },
  {
   value: "La Salle (USQAA)",
   label: "La Salle (USQAA)"
  },
  {
   value: "La Vale (USKVN)",
   label: "La Vale (USKVN)"
  },
  {
   value: "La Vergne (USZUU)",
   label: "La Vergne (USZUU)"
  },
  {
   value: "La Vista (USVII)",
   label: "La Vista (USVII)"
  },
  {
   value: "Labadie (USLD2)",
   label: "Labadie (USLD2)"
  },
  {
   value: "Lacassine (USIKE)",
   label: "Lacassine (USIKE)"
  },
  {
   value: "Laceyville (USFYJ)",
   label: "Laceyville (USFYJ)"
  },
  {
   value: "Lackey (USYLC)",
   label: "Lackey (USYLC)"
  },
  {
   value: "Lackland City (USLKJ)",
   label: "Lackland City (USLKJ)"
  },
  {
   value: "Laclede (USQDE)",
   label: "Laclede (USQDE)"
  },
  {
   value: "Lacombe (USLQB)",
   label: "Lacombe (USLQB)"
  },
  {
   value: "Laconia (USLCI)",
   label: "Laconia (USLCI)"
  },
  {
   value: "Ladera Ranch (USXXL)",
   label: "Ladera Ranch (USXXL)"
  },
  {
   value: "Ladue (USLZD)",
   label: "Ladue (USLZD)"
  },
  {
   value: "Ladysmith (USULH)",
   label: "Ladysmith (USULH)"
  },
  {
   value: "Ladysmith (USZYT)",
   label: "Ladysmith (USZYT)"
  },
  {
   value: "Lafayette (USLF2)",
   label: "Lafayette (USLF2)"
  },
  {
   value: "Lafayette (USLFY)",
   label: "Lafayette (USLFY)"
  },
  {
   value: "LaFayette (USQLK)",
   label: "LaFayette (USQLK)"
  },
  {
   value: "Lafayette (USYTF)",
   label: "Lafayette (USYTF)"
  },
  {
   value: "Lafayette Hill (USLH2)",
   label: "Lafayette Hill (USLH2)"
  },
  {
   value: "Lafitte (USLJF)",
   label: "Lafitte (USLJF)"
  },
  {
   value: "Lago Vista (USLV2)",
   label: "Lago Vista (USLV2)"
  },
  {
   value: "Lagrange (USZNG)",
   label: "Lagrange (USZNG)"
  },
  {
   value: "Lagrangeville (USQLG)",
   label: "Lagrangeville (USQLG)"
  },
  {
   value: "Laguna Beach (USLAB)",
   label: "Laguna Beach (USLAB)"
  },
  {
   value: "Laguna Woods (USLSW)",
   label: "Laguna Woods (USLSW)"
  },
  {
   value: "Lahaska (USPZV)",
   label: "Lahaska (USPZV)"
  },
  {
   value: "Lahoma (USLHD)",
   label: "Lahoma (USLHD)"
  },
  {
   value: "Lake Almanor (USLKU)",
   label: "Lake Almanor (USLKU)"
  },
  {
   value: "Lake Ariel (USKJA)",
   label: "Lake Ariel (USKJA)"
  },
  {
   value: "Lake Arrowhead (USLA2)",
   label: "Lake Arrowhead (USLA2)"
  },
  {
   value: "Lake Buena Vista (USLBW)",
   label: "Lake Buena Vista (USLBW)"
  },
  {
   value: "Lake City (USJLY)",
   label: "Lake City (USJLY)"
  },
  {
   value: "Lake City (USKLC)",
   label: "Lake City (USKLC)"
  },
  {
   value: "Lake City (USLCY)",
   label: "Lake City (USLCY)"
  },
  {
   value: "Lake City (USLKE)",
   label: "Lake City (USLKE)"
  },
  {
   value: "Lake Cormorant (USKRM)",
   label: "Lake Cormorant (USKRM)"
  },
  {
   value: "Lake Dallas (USAKD)",
   label: "Lake Dallas (USAKD)"
  },
  {
   value: "Lake Delton (USKDT)",
   label: "Lake Delton (USKDT)"
  },
  {
   value: "Lake Elmo (USLE2)",
   label: "Lake Elmo (USLE2)"
  },
  {
   value: "Lake Elsinore (USLE3)",
   label: "Lake Elsinore (USLE3)"
  },
  {
   value: "Lake Garfield (USZLG)",
   label: "Lake Garfield (USZLG)"
  },
  {
   value: "Lake George (USLG2)",
   label: "Lake George (USLG2)"
  },
  {
   value: "Lake George (USULE)",
   label: "Lake George (USULE)"
  },
  {
   value: "Lake Hiawatha (USLHW)",
   label: "Lake Hiawatha (USLHW)"
  },
  {
   value: "Lake In The Hills (USLKI)",
   label: "Lake In The Hills (USLKI)"
  },
  {
   value: "Lake Jackson (USLJN)",
   label: "Lake Jackson (USLJN)"
  },
  {
   value: "Lake Katerine (USLK2)",
   label: "Lake Katerine (USLK2)"
  },
  {
   value: "Lake Katrine (USKYQ)",
   label: "Lake Katrine (USKYQ)"
  },
  {
   value: "Lake Mills (USKMI)",
   label: "Lake Mills (USKMI)"
  },
  {
   value: "Lake Minchumina (USLMA)",
   label: "Lake Minchumina (USLMA)"
  },
  {
   value: "Lake Norden (USLKO)",
   label: "Lake Norden (USLKO)"
  },
  {
   value: "Lake Orion (USLRP)",
   label: "Lake Orion (USLRP)"
  },
  {
   value: "Lake Orion Heights (USOXI)",
   label: "Lake Orion Heights (USOXI)"
  },
  {
   value: "Lake Park (USKPA)",
   label: "Lake Park (USKPA)"
  },
  {
   value: "Lake Park (USLEK)",
   label: "Lake Park (USLEK)"
  },
  {
   value: "Lake Park (USLPQ)",
   label: "Lake Park (USLPQ)"
  },
  {
   value: "Lake Providence (USYLP)",
   label: "Lake Providence (USYLP)"
  },
  {
   value: "Lake Station (USLKT)",
   label: "Lake Station (USLKT)"
  },
  {
   value: "Lake Stevens (USLS2)",
   label: "Lake Stevens (USLS2)"
  },
  {
   value: "Lake Success (USLSS)",
   label: "Lake Success (USLSS)"
  },
  {
   value: "Lake View, Erie (USKVW)",
   label: "Lake View, Erie (USKVW)"
  },
  {
   value: "Lake Waccamaw (USWCW)",
   label: "Lake Waccamaw (USWCW)"
  },
  {
   value: "Lake Worth (USULW)",
   label: "Lake Worth (USULW)"
  },
  {
   value: "Lakehead (USLB5)",
   label: "Lakehead (USLB5)"
  },
  {
   value: "Lakeland (USKEJ)",
   label: "Lakeland (USKEJ)"
  },
  {
   value: "Lakeland (USLKG)",
   label: "Lakeland (USLKG)"
  },
  {
   value: "Lakeland (USZF6)",
   label: "Lakeland (USZF6)"
  },
  {
   value: "Lakemoor (USZZS)",
   label: "Lakemoor (USZZS)"
  },
  {
   value: "Lakeport (USLPR)",
   label: "Lakeport (USLPR)"
  },
  {
   value: "Lakeside (USKSI)",
   label: "Lakeside (USKSI)"
  },
  {
   value: "Lakeside (USLS8)",
   label: "Lakeside (USLS8)"
  },
  {
   value: "Lakeside Marblehead (USKDB)",
   label: "Lakeside Marblehead (USKDB)"
  },
  {
   value: "Lakeview (USLWU)",
   label: "Lakeview (USLWU)"
  },
  {
   value: "Lakeville (USLIL)",
   label: "Lakeville (USLIL)"
  },
  {
   value: "Lakeville (USLQI)",
   label: "Lakeville (USLQI)"
  },
  {
   value: "Lakeville (USLXE)",
   label: "Lakeville (USLXE)"
  },
  {
   value: "Lakeville, Livingston (USKIE)",
   label: "Lakeville, Livingston (USKIE)"
  },
  {
   value: "Lakeway (USZEB)",
   label: "Lakeway (USZEB)"
  },
  {
   value: "Lakewood (USLKD)",
   label: "Lakewood (USLKD)"
  },
  {
   value: "Lakewood (USYLA)",
   label: "Lakewood (USYLA)"
  },
  {
   value: "Lamar (USLM8)",
   label: "Lamar (USLM8)"
  },
  {
   value: "Lamar (USLMF)",
   label: "Lamar (USLMF)"
  },
  {
   value: "Lambertville (USLML)",
   label: "Lambertville (USLML)"
  },
  {
   value: "Lamont (USLM2)",
   label: "Lamont (USLM2)"
  },
  {
   value: "Lampeter (USLMP)",
   label: "Lampeter (USLMP)"
  },
  {
   value: "Lanai City (USLNY)",
   label: "Lanai City (USLNY)"
  },
  {
   value: "Lanark (USNAR)",
   label: "Lanark (USNAR)"
  },
  {
   value: "Lancaster (USLAC)",
   label: "Lancaster (USLAC)"
  },
  {
   value: "Lancaster (USLC5)",
   label: "Lancaster (USLC5)"
  },
  {
   value: "Lancaster (USLCS)",
   label: "Lancaster (USLCS)"
  },
  {
   value: "Lancaster (USLZC)",
   label: "Lancaster (USLZC)"
  },
  {
   value: "Lancaster (USZLI)",
   label: "Lancaster (USZLI)"
  },
  {
   value: "Lance Creek (USEQK)",
   label: "Lance Creek (USEQK)"
  },
  {
   value: "Landenberg (USLDG)",
   label: "Landenberg (USLDG)"
  },
  {
   value: "Landing (USLZV)",
   label: "Landing (USLZV)"
  },
  {
   value: "Landisville (USLNL)",
   label: "Landisville (USLNL)"
  },
  {
   value: "Landrum (USLDU)",
   label: "Landrum (USLDU)"
  },
  {
   value: "Lane (USYLQ)",
   label: "Lane (USYLQ)"
  },
  {
   value: "Lanett (USYLT)",
   label: "Lanett (USYLT)"
  },
  {
   value: "Langdon (USLDO)",
   label: "Langdon (USLDO)"
  },
  {
   value: "Langley (USYGZ)",
   label: "Langley (USYGZ)"
  },
  {
   value: "Lanier (USLIR)",
   label: "Lanier (USLIR)"
  },
  {
   value: "Lansdale (USLDA)",
   label: "Lansdale (USLDA)"
  },
  {
   value: "Lansdowne (USQLD)",
   label: "Lansdowne (USQLD)"
  },
  {
   value: "Lansford (USLF7)",
   label: "Lansford (USLF7)"
  },
  {
   value: "Lansing (USAIG)",
   label: "Lansing (USAIG)"
  },
  {
   value: "Lansing (USLAG)",
   label: "Lansing (USLAG)"
  },
  {
   value: "Lansing (USLQG)",
   label: "Lansing (USLQG)"
  },
  {
   value: "Lansing (USLSG)",
   label: "Lansing (USLSG)"
  },
  {
   value: "Lansing, Tomkins (USLSZ)",
   label: "Lansing, Tomkins (USLSZ)"
  },
  {
   value: "Lapeer (USAPE)",
   label: "Lapeer (USAPE)"
  },
  {
   value: "Laporte (USZEE)",
   label: "Laporte (USZEE)"
  },
  {
   value: "Largo (USLGQ)",
   label: "Largo (USLGQ)"
  },
  {
   value: "Larimore (USLRR)",
   label: "Larimore (USLRR)"
  },
  {
   value: "Larkspur (USKSU)",
   label: "Larkspur (USKSU)"
  },
  {
   value: "Larned (USLD7)",
   label: "Larned (USLD7)"
  },
  {
   value: "Larsen Bay (USKLN)",
   label: "Larsen Bay (USKLN)"
  },
  {
   value: "Las Vegas (USLVS)",
   label: "Las Vegas (USLVS)"
  },
  {
   value: "Latham (USKLM)",
   label: "Latham (USKLM)"
  },
  {
   value: "Laton (USLJO)",
   label: "Laton (USLJO)"
  },
  {
   value: "Latonia (USLT2)",
   label: "Latonia (USLT2)"
  },
  {
   value: "Latrobe (USTRB)",
   label: "Latrobe (USTRB)"
  },
  {
   value: "Latta (USTTA)",
   label: "Latta (USTTA)"
  },
  {
   value: "Lauderdale Lakes (USZF3)",
   label: "Lauderdale Lakes (USZF3)"
  },
  {
   value: "Laughlin (USLGH)",
   label: "Laughlin (USLGH)"
  },
  {
   value: "Laughlin Air Force Base (USLFB)",
   label: "Laughlin Air Force Base (USLFB)"
  },
  {
   value: "Laurel (USLUQ)",
   label: "Laurel (USLUQ)"
  },
  {
   value: "Laurel (USURE)",
   label: "Laurel (USURE)"
  },
  {
   value: "Laurel Hill, Lincoln (USLHJ)",
   label: "Laurel Hill, Lincoln (USLHJ)"
  },
  {
   value: "Laureldale (USQLR)",
   label: "Laureldale (USQLR)"
  },
  {
   value: "Laurelville (USQLH)",
   label: "Laurelville (USQLH)"
  },
  {
   value: "Laurens (USLRX)",
   label: "Laurens (USLRX)"
  },
  {
   value: "Laurys Station (USYTI)",
   label: "Laurys Station (USYTI)"
  },
  {
   value: "Lavaca (USAC4)",
   label: "Lavaca (USAC4)"
  },
  {
   value: "Laveen (USLVH)",
   label: "Laveen (USLVH)"
  },
  {
   value: "Laverne (USVFE)",
   label: "Laverne (USVFE)"
  },
  {
   value: "Lavinia (USLV3)",
   label: "Lavinia (USLV3)"
  },
  {
   value: "Lavonia (USAOI)",
   label: "Lavonia (USAOI)"
  },
  {
   value: "Lawndale (USAWA)",
   label: "Lawndale (USAWA)"
  },
  {
   value: "Lawrence (USLWM)",
   label: "Lawrence (USLWM)"
  },
  {
   value: "Lawrenceville (USLRW)",
   label: "Lawrenceville (USLRW)"
  },
  {
   value: "Lawton (USTWW)",
   label: "Lawton (USTWW)"
  },
  {
   value: "Lawyers (USLW2)",
   label: "Lawyers (USLW2)"
  },
  {
   value: "Layton (USLTJ)",
   label: "Layton (USLTJ)"
  },
  {
   value: "Le Center (USLC3)",
   label: "Le Center (USLC3)"
  },
  {
   value: "Le Mars (USEMS)",
   label: "Le Mars (USEMS)"
  },
  {
   value: "Le Moyen (USZHL)",
   label: "Le Moyen (USZHL)"
  },
  {
   value: "Le Roy (USLQR)",
   label: "Le Roy (USLQR)"
  },
  {
   value: "Le Roy (USLRQ)",
   label: "Le Roy (USLRQ)"
  },
  {
   value: "Leachville (USLHL)",
   label: "Leachville (USLHL)"
  },
  {
   value: "Lead (USLDQ)",
   label: "Lead (USLDQ)"
  },
  {
   value: "Lead Hill (USLHZ)",
   label: "Lead Hill (USLHZ)"
  },
  {
   value: "League City (USZLT)",
   label: "League City (USZLT)"
  },
  {
   value: "Leamington (USLM7)",
   label: "Leamington (USLM7)"
  },
  {
   value: "Leavenworth (USL2V)",
   label: "Leavenworth (USL2V)"
  },
  {
   value: "Lebanon (USLVB)",
   label: "Lebanon (USLVB)"
  },
  {
   value: "Lebec (USYLB)",
   label: "Lebec (USYLB)"
  },
  {
   value: "Lecanto (USLTQ)",
   label: "Lecanto (USLTQ)"
  },
  {
   value: "Ledbetter (USDBM)",
   label: "Ledbetter (USDBM)"
  },
  {
   value: "Ledyard Center (USLDY)",
   label: "Ledyard Center (USLDY)"
  },
  {
   value: "Lee (USLJE)",
   label: "Lee (USLJE)"
  },
  {
   value: "Lee (USQLE)",
   label: "Lee (USQLE)"
  },
  {
   value: "Lee (USVNV)",
   label: "Lee (USVNV)"
  },
  {
   value: "Leesburg (USEYG)",
   label: "Leesburg (USEYG)"
  },
  {
   value: "Leesburg (USLXU)",
   label: "Leesburg (USLXU)"
  },
  {
   value: "Leesport (USLEP)",
   label: "Leesport (USLEP)"
  },
  {
   value: "Leetonia (USEET)",
   label: "Leetonia (USEET)"
  },
  {
   value: "Lehigh (USLEG)",
   label: "Lehigh (USLEG)"
  },
  {
   value: "Lehigh Acres (USLEF)",
   label: "Lehigh Acres (USLEF)"
  },
  {
   value: "Lehighton (USLHG)",
   label: "Lehighton (USLHG)"
  },
  {
   value: "Leicester (USLC6)",
   label: "Leicester (USLC6)"
  },
  {
   value: "Leipsic (USLSJ)",
   label: "Leipsic (USLSJ)"
  },
  {
   value: "Leland (USLEJ)",
   label: "Leland (USLEJ)"
  },
  {
   value: "Leland (USLLC)",
   label: "Leland (USLLC)"
  },
  {
   value: "Lemars (USLRJ)",
   label: "Lemars (USLRJ)"
  },
  {
   value: "Lemasters (USPMS)",
   label: "Lemasters (USPMS)"
  },
  {
   value: "Lemay (USLMY)",
   label: "Lemay (USLMY)"
  },
  {
   value: "Lemmon (USLMC)",
   label: "Lemmon (USLMC)"
  },
  {
   value: "Lemon Grove (USLG3)",
   label: "Lemon Grove (USLG3)"
  },
  {
   value: "Lemont Furnace (USLMU)",
   label: "Lemont Furnace (USLMU)"
  },
  {
   value: "Lemoore (USNLC)",
   label: "Lemoore (USNLC)"
  },
  {
   value: "Lena (USLNQ)",
   label: "Lena (USLNQ)"
  },
  {
   value: "Lenni (USENI)",
   label: "Lenni (USENI)"
  },
  {
   value: "Lenora (USLR7)",
   label: "Lenora (USLR7)"
  },
  {
   value: "Lenox (USYLX)",
   label: "Lenox (USYLX)"
  },
  {
   value: "Lenox Dale (USLXD)",
   label: "Lenox Dale (USLXD)"
  },
  {
   value: "Leoma (USLM3)",
   label: "Leoma (USLM3)"
  },
  {
   value: "Leominster (USLMR)",
   label: "Leominster (USLMR)"
  },
  {
   value: "Leonard (USJND)",
   label: "Leonard (USJND)"
  },
  {
   value: "Leonardtown (USLTW)",
   label: "Leonardtown (USLTW)"
  },
  {
   value: "Leonia (USQLO)",
   label: "Leonia (USQLO)"
  },
  {
   value: "Leroy (USEUY)",
   label: "Leroy (USEUY)"
  },
  {
   value: "Leroy (USLR2)",
   label: "Leroy (USLR2)"
  },
  {
   value: "Lesterville (USLZS)",
   label: "Lesterville (USLZS)"
  },
  {
   value: "Letcher (USLC8)",
   label: "Letcher (USLC8)"
  },
  {
   value: "Letohatchee (USLHT)",
   label: "Letohatchee (USLHT)"
  },
  {
   value: "Levelland (USLLZ)",
   label: "Levelland (USLLZ)"
  },
  {
   value: "Levittown (USLEO)",
   label: "Levittown (USLEO)"
  },
  {
   value: "Lewis (USL2W)",
   label: "Lewis (USL2W)"
  },
  {
   value: "Lewis Center (USLEQ)",
   label: "Lewis Center (USLEQ)"
  },
  {
   value: "Lewis Run (USIRU)",
   label: "Lewis Run (USIRU)"
  },
  {
   value: "Lewisberry (USLBR)",
   label: "Lewisberry (USLBR)"
  },
  {
   value: "Lewisburg (USLBG)",
   label: "Lewisburg (USLBG)"
  },
  {
   value: "Lewisport (USLWD)",
   label: "Lewisport (USLWD)"
  },
  {
   value: "Lewiston (USLVQ)",
   label: "Lewiston (USLVQ)"
  },
  {
   value: "Lewiston (USLVZ)",
   label: "Lewiston (USLVZ)"
  },
  {
   value: "Lewiston (USLZO)",
   label: "Lewiston (USLZO)"
  },
  {
   value: "Lewiston (USQLW)",
   label: "Lewiston (USQLW)"
  },
  {
   value: "Lewiston (USXWS)",
   label: "Lewiston (USXWS)"
  },
  {
   value: "Lewistown (USLWT)",
   label: "Lewistown (USLWT)"
  },
  {
   value: "Lewisville (USLWZ)",
   label: "Lewisville (USLWZ)"
  },
  {
   value: "Lexington (USL2G)",
   label: "Lexington (USL2G)"
  },
  {
   value: "Lexington (USLKQ)",
   label: "Lexington (USLKQ)"
  },
  {
   value: "Lexington (USLXO)",
   label: "Lexington (USLXO)"
  },
  {
   value: "Lexington (USQDU)",
   label: "Lexington (USQDU)"
  },
  {
   value: "Lexington (USXON)",
   label: "Lexington (USXON)"
  },
  {
   value: "Liberty (USIBX)",
   label: "Liberty (USIBX)"
  },
  {
   value: "Liberty (USLBK)",
   label: "Liberty (USLBK)"
  },
  {
   value: "Liberty (USLHP)",
   label: "Liberty (USLHP)"
  },
  {
   value: "Liberty (USLHR)",
   label: "Liberty (USLHR)"
  },
  {
   value: "Liberty (USLIB)",
   label: "Liberty (USLIB)"
  },
  {
   value: "Liberty (USLJY)",
   label: "Liberty (USLJY)"
  },
  {
   value: "Liberty (USLY2)",
   label: "Liberty (USLY2)"
  },
  {
   value: "Liberty (USPL5)",
   label: "Liberty (USPL5)"
  },
  {
   value: "Liberty (USZLY)",
   label: "Liberty (USZLY)"
  },
  {
   value: "Liberty Hill, Milam (USLH3)",
   label: "Liberty Hill, Milam (USLH3)"
  },
  {
   value: "Liberty, De Kalb (USIBY)",
   label: "Liberty, De Kalb (USIBY)"
  },
  {
   value: "Lido Beach (USLOB)",
   label: "Lido Beach (USLOB)"
  },
  {
   value: "Lihue (Kauai) (USLIU)",
   label: "Lihue (Kauai) (USLIU)"
  },
  {
   value: "Lilesville (USLV4)",
   label: "Lilesville (USLV4)"
  },
  {
   value: "Lima (USLJM)",
   label: "Lima (USLJM)"
  },
  {
   value: "Limerick (USLMK)",
   label: "Limerick (USLMK)"
  },
  {
   value: "Lincoln (USINC)",
   label: "Lincoln (USINC)"
  },
  {
   value: "Lincoln (USINN)",
   label: "Lincoln (USINN)"
  },
  {
   value: "Lincoln (USIQN)",
   label: "Lincoln (USIQN)"
  },
  {
   value: "Lincoln (USLC7)",
   label: "Lincoln (USLC7)"
  },
  {
   value: "Lincoln (USLCQ)",
   label: "Lincoln (USLCQ)"
  },
  {
   value: "Lincoln (USLL8)",
   label: "Lincoln (USLL8)"
  },
  {
   value: "Lincoln (USLQC)",
   label: "Lincoln (USLQC)"
  },
  {
   value: "Lincoln (USNH5)",
   label: "Lincoln (USNH5)"
  },
  {
   value: "Lincoln City (USYOC)",
   label: "Lincoln City (USYOC)"
  },
  {
   value: "Lincoln Park, Chicago (USLPD)",
   label: "Lincoln Park, Chicago (USLPD)"
  },
  {
   value: "Lincoln Rock (USLRK)",
   label: "Lincoln Rock (USLRK)"
  },
  {
   value: "Lincolnshire (USLCO)",
   label: "Lincolnshire (USLCO)"
  },
  {
   value: "Lincolnton (USZLC)",
   label: "Lincolnton (USZLC)"
  },
  {
   value: "Lincroft (USZLJ)",
   label: "Lincroft (USZLJ)"
  },
  {
   value: "Lind (USYLD)",
   label: "Lind (USYLD)"
  },
  {
   value: "Lindenhurst (USLH4)",
   label: "Lindenhurst (USLH4)"
  },
  {
   value: "Lindenwold (USLW3)",
   label: "Lindenwold (USLW3)"
  },
  {
   value: "Lindenwood (USF9)",
   label: "Lindenwood (USF9)"
  },
  {
   value: "Lindon (USZLN)",
   label: "Lindon (USZLN)"
  },
  {
   value: "Lindsay (USIDS)",
   label: "Lindsay (USIDS)"
  },
  {
   value: "Lindsay (USULU)",
   label: "Lindsay (USULU)"
  },
  {
   value: "Lindside (USLIE)",
   label: "Lindside (USLIE)"
  },
  {
   value: "Lindstrom (USDTM)",
   label: "Lindstrom (USDTM)"
  },
  {
   value: "Linesville (USLIQ)",
   label: "Linesville (USLIQ)"
  },
  {
   value: "Linfield (USZLF)",
   label: "Linfield (USZLF)"
  },
  {
   value: "Linn (USLQN)",
   label: "Linn (USLQN)"
  },
  {
   value: "Linn Creek (USQLF)",
   label: "Linn Creek (USQLF)"
  },
  {
   value: "Linndale (USLQX)",
   label: "Linndale (USLQX)"
  },
  {
   value: "Lino Lakes (USLLB)",
   label: "Lino Lakes (USLLB)"
  },
  {
   value: "Linwood (USIWC)",
   label: "Linwood (USIWC)"
  },
  {
   value: "Linwood (USYLW)",
   label: "Linwood (USYLW)"
  },
  {
   value: "Lisbon (USIBN)",
   label: "Lisbon (USIBN)"
  },
  {
   value: "Lisbon (USLXB)",
   label: "Lisbon (USLXB)"
  },
  {
   value: "Lisbon (USLZB)",
   label: "Lisbon (USLZB)"
  },
  {
   value: "Lisbon Falls (USLF3)",
   label: "Lisbon Falls (USLF3)"
  },
  {
   value: "Lisbon, Ransom (USLJI)",
   label: "Lisbon, Ransom (USLJI)"
  },
  {
   value: "Litchfield (USYCF)",
   label: "Litchfield (USYCF)"
  },
  {
   value: "Litchfield Park (USIEL)",
   label: "Litchfield Park (USIEL)"
  },
  {
   value: "Lithia Springs (USLHS)",
   label: "Lithia Springs (USLHS)"
  },
  {
   value: "Little Compton (USTMT)",
   label: "Little Compton (USTMT)"
  },
  {
   value: "Little Falls (USLFS)",
   label: "Little Falls (USLFS)"
  },
  {
   value: "Little Falls (USLLF)",
   label: "Little Falls (USLLF)"
  },
  {
   value: "Little Hocking (USLHK)",
   label: "Little Hocking (USLHK)"
  },
  {
   value: "Little Lake (USLKF)",
   label: "Little Lake (USLKF)"
  },
  {
   value: "Little Mountain (USLMX)",
   label: "Little Mountain (USLMX)"
  },
  {
   value: "Little Port Walter (USLPW)",
   label: "Little Port Walter (USLPW)"
  },
  {
   value: "Little River (USLR3)",
   label: "Little River (USLR3)"
  },
  {
   value: "Little Silver (USEIR)",
   label: "Little Silver (USEIR)"
  },
  {
   value: "Littlerock (USYLR)",
   label: "Littlerock (USYLR)"
  },
  {
   value: "Littlestown (USTLW)",
   label: "Littlestown (USTLW)"
  },
  {
   value: "Littletown (USIIL)",
   label: "Littletown (USIIL)"
  },
  {
   value: "Live Oak (USLO2)",
   label: "Live Oak (USLO2)"
  },
  {
   value: "Lively (USJLI)",
   label: "Lively (USJLI)"
  },
  {
   value: "Livermore Falls (USLVF)",
   label: "Livermore Falls (USLVF)"
  },
  {
   value: "Liverpool (USLPX)",
   label: "Liverpool (USLPX)"
  },
  {
   value: "Livingston (USLGS)",
   label: "Livingston (USLGS)"
  },
  {
   value: "Livingston (USLVM)",
   label: "Livingston (USLVM)"
  },
  {
   value: "Livingston Manor (USLM4)",
   label: "Livingston Manor (USLM4)"
  },
  {
   value: "Livonia (USLVI)",
   label: "Livonia (USLVI)"
  },
  {
   value: "Lizton (USLZT)",
   label: "Lizton (USLZT)"
  },
  {
   value: "Llano (USLL2)",
   label: "Llano (USLL2)"
  },
  {
   value: "Loan Tree (USLT4)",
   label: "Loan Tree (USLT4)"
  },
  {
   value: "Lockeford (USLF8)",
   label: "Lockeford (USLF8)"
  },
  {
   value: "Lockhart (USLQH)",
   label: "Lockhart (USLQH)"
  },
  {
   value: "Locust (USXLT)",
   label: "Locust (USXLT)"
  },
  {
   value: "Locust Grove (USLCZ)",
   label: "Locust Grove (USLCZ)"
  },
  {
   value: "Locust Hill, Middlesex (USLHY)",
   label: "Locust Hill, Middlesex (USLHY)"
  },
  {
   value: "Locustville (USLTV)",
   label: "Locustville (USLTV)"
  },
  {
   value: "Loda (USXWX)",
   label: "Loda (USXWX)"
  },
  {
   value: "Lodgepole (USDPL)",
   label: "Lodgepole (USDPL)"
  },
  {
   value: "Lodi (USILO)",
   label: "Lodi (USILO)"
  },
  {
   value: "Lodi (USLOC)",
   label: "Lodi (USLOC)"
  },
  {
   value: "Logan (USOQN)",
   label: "Logan (USOQN)"
  },
  {
   value: "Logan Township (USYLO)",
   label: "Logan Township (USYLO)"
  },
  {
   value: "Logan, Edgar (USUZQ)",
   label: "Logan, Edgar (USUZQ)"
  },
  {
   value: "Logansport (USOGP)",
   label: "Logansport (USOGP)"
  },
  {
   value: "Loganville (USLGE)",
   label: "Loganville (USLGE)"
  },
  {
   value: "Lohrville (USLHQ)",
   label: "Lohrville (USLHQ)"
  },
  {
   value: "Lolita (USOIT)",
   label: "Lolita (USOIT)"
  },
  {
   value: "Loma Linda (USLL3)",
   label: "Loma Linda (USLL3)"
  },
  {
   value: "Londonderry (USLD8)",
   label: "Londonderry (USLD8)"
  },
  {
   value: "Lone Rock (USLNR)",
   label: "Lone Rock (USLNR)"
  },
  {
   value: "Lone Tree (USLT5)",
   label: "Lone Tree (USLT5)"
  },
  {
   value: "Long Beach (USLB3)",
   label: "Long Beach (USLB3)"
  },
  {
   value: "Long Beach (USLBH)",
   label: "Long Beach (USLBH)"
  },
  {
   value: "Long Beach (USNGC)",
   label: "Long Beach (USNGC)"
  },
  {
   value: "Long Beach (USYBH)",
   label: "Long Beach (USYBH)"
  },
  {
   value: "Long Branch (USLCJ)",
   label: "Long Branch (USLCJ)"
  },
  {
   value: "Long I. (USOZD)",
   label: "Long I. (USOZD)"
  },
  {
   value: "Long Island (USLIJ)",
   label: "Long Island (USLIJ)"
  },
  {
   value: "Long Reach (USLRC)",
   label: "Long Reach (USLRC)"
  },
  {
   value: "Longmeadow (USZLW)",
   label: "Longmeadow (USZLW)"
  },
  {
   value: "Longs (USJNG)",
   label: "Longs (USJNG)"
  },
  {
   value: "Longview (USJLG)",
   label: "Longview (USJLG)"
  },
  {
   value: "Longview (USZLV)",
   label: "Longview (USZLV)"
  },
  {
   value: "Loogootee (USLT3)",
   label: "Loogootee (USLT3)"
  },
  {
   value: "Lookout Mountain (USZEJ)",
   label: "Lookout Mountain (USZEJ)"
  },
  {
   value: "Loomis (USOXZ)",
   label: "Loomis (USOXZ)"
  },
  {
   value: "Loretto (USLT8)",
   label: "Loretto (USLT8)"
  },
  {
   value: "Loretto (USQLT)",
   label: "Loretto (USQLT)"
  },
  {
   value: "Loretto (USTKY)",
   label: "Loretto (USTKY)"
  },
  {
   value: "Loris (USLRZ)",
   label: "Loris (USLRZ)"
  },
  {
   value: "Lorraine (USLR8)",
   label: "Lorraine (USLR8)"
  },
  {
   value: "Los Alamos (USXYL)",
   label: "Los Alamos (USXYL)"
  },
  {
   value: "Los Fresnos (USOFS)",
   label: "Los Fresnos (USOFS)"
  },
  {
   value: "Los Lunas (USLLU)",
   label: "Los Lunas (USLLU)"
  },
  {
   value: "Los Molinos (USIOS)",
   label: "Los Molinos (USIOS)"
  },
  {
   value: "Los Olivos (USOVS)",
   label: "Los Olivos (USOVS)"
  },
  {
   value: "Lost Hills (USTSO)",
   label: "Lost Hills (USTSO)"
  },
  {
   value: "Lost River (USLSR)",
   label: "Lost River (USLSR)"
  },
  {
   value: "Lott (USLQT)",
   label: "Lott (USLQT)"
  },
  {
   value: "Loudonville (USLUO)",
   label: "Loudonville (USLUO)"
  },
  {
   value: "Loudonville (USQYL)",
   label: "Loudonville (USQYL)"
  },
  {
   value: "Louin (USOIJ)",
   label: "Louin (USOIJ)"
  },
  {
   value: "Louisa (USKZY)",
   label: "Louisa (USKZY)"
  },
  {
   value: "Louisville (USZF8)",
   label: "Louisville (USZF8)"
  },
  {
   value: "Loup City (USLC2)",
   label: "Loup City (USLC2)"
  },
  {
   value: "Lovelady (USLLI)",
   label: "Lovelady (USLLI)"
  },
  {
   value: "Lovell (USLLV)",
   label: "Lovell (USLLV)"
  },
  {
   value: "Loves Park (USQLI)",
   label: "Loves Park (USQLI)"
  },
  {
   value: "Lowell (USLOE)",
   label: "Lowell (USLOE)"
  },
  {
   value: "Lowell (USLW6)",
   label: "Lowell (USLW6)"
  },
  {
   value: "Lowell (USLWY)",
   label: "Lowell (USLWY)"
  },
  {
   value: "Lowell (USOWE)",
   label: "Lowell (USOWE)"
  },
  {
   value: "Lower Brule (USLB7)",
   label: "Lower Brule (USLB7)"
  },
  {
   value: "Lowgap (USLXP)",
   label: "Lowgap (USLXP)"
  },
  {
   value: "Lowmansville (USLQL)",
   label: "Lowmansville (USLQL)"
  },
  {
   value: "Lowmoor (USZG5)",
   label: "Lowmoor (USZG5)"
  },
  {
   value: "Loxahatchee (USLXC)",
   label: "Loxahatchee (USLXC)"
  },
  {
   value: "Loyal (USLY7)",
   label: "Loyal (USLY7)"
  },
  {
   value: "Lubec (USLB2)",
   label: "Lubec (USLB2)"
  },
  {
   value: "Lucama (USUCM)",
   label: "Lucama (USUCM)"
  },
  {
   value: "Lucan (USVUC)",
   label: "Lucan (USVUC)"
  },
  {
   value: "Lucas (USLCC)",
   label: "Lucas (USLCC)"
  },
  {
   value: "Lucedale (USLCU)",
   label: "Lucedale (USLCU)"
  },
  {
   value: "Ludlow (USLUW)",
   label: "Ludlow (USLUW)"
  },
  {
   value: "Ludlow (USUDW)",
   label: "Ludlow (USUDW)"
  },
  {
   value: "Ludlow (USULD)",
   label: "Ludlow (USULD)"
  },
  {
   value: "Lula (USYLU)",
   label: "Lula (USYLU)"
  },
  {
   value: "Luling (USULG)",
   label: "Luling (USULG)"
  },
  {
   value: "Lumberton (USLUM)",
   label: "Lumberton (USLUM)"
  },
  {
   value: "Lunenburg (USUEB)",
   label: "Lunenburg (USUEB)"
  },
  {
   value: "Lupton City (USUPY)",
   label: "Lupton City (USUPY)"
  },
  {
   value: "Luray (USLRY)",
   label: "Luray (USLRY)"
  },
  {
   value: "Lusk (USLSK)",
   label: "Lusk (USLSK)"
  },
  {
   value: "Lutcher (USLUH)",
   label: "Lutcher (USLUH)"
  },
  {
   value: "Lutherville (USLHE)",
   label: "Lutherville (USLHE)"
  },
  {
   value: "Luttrell, Union (USLL4)",
   label: "Luttrell, Union (USLL4)"
  },
  {
   value: "Lutz (USLTZ)",
   label: "Lutz (USLTZ)"
  },
  {
   value: "Luverne (USUVN)",
   label: "Luverne (USUVN)"
  },
  {
   value: "Luzerne (USUZR)",
   label: "Luzerne (USUZR)"
  },
  {
   value: "Lyerly (USLYR)",
   label: "Lyerly (USLYR)"
  },
  {
   value: "Lyford (USYFR)",
   label: "Lyford (USYFR)"
  },
  {
   value: "Lykens (USYKE)",
   label: "Lykens (USYKE)"
  },
  {
   value: "Lyles (USQLY)",
   label: "Lyles (USQLY)"
  },
  {
   value: "Lyme (USLMQ)",
   label: "Lyme (USLMQ)"
  },
  {
   value: "Lynchburg (USLYC)",
   label: "Lynchburg (USLYC)"
  },
  {
   value: "Lyndhurst (USYHU)",
   label: "Lyndhurst (USYHU)"
  },
  {
   value: "Lyndon (USJYN)",
   label: "Lyndon (USJYN)"
  },
  {
   value: "Lyndon (USYDN)",
   label: "Lyndon (USYDN)"
  },
  {
   value: "Lyndon Station (USYND)",
   label: "Lyndon Station (USYND)"
  },
  {
   value: "Lyndonville (USLLX)",
   label: "Lyndonville (USLLX)"
  },
  {
   value: "Lyndonville (USNYK)",
   label: "Lyndonville (USNYK)"
  },
  {
   value: "Lynn (USZNN)",
   label: "Lynn (USZNN)"
  },
  {
   value: "Lynn Haven (USLYM)",
   label: "Lynn Haven (USLYM)"
  },
  {
   value: "Lynnville (USLYL)",
   label: "Lynnville (USLYL)"
  },
  {
   value: "Lyon Station (USLYQ)",
   label: "Lyon Station (USLYQ)"
  },
  {
   value: "Lyons (USLOY)",
   label: "Lyons (USLOY)"
  },
  {
   value: "Lyons (USLQS)",
   label: "Lyons (USLQS)"
  },
  {
   value: "Lyons (USLXS)",
   label: "Lyons (USLXS)"
  },
  {
   value: "Lyons (USLZY)",
   label: "Lyons (USLZY)"
  },
  {
   value: "Lyons (USYNS)",
   label: "Lyons (USYNS)"
  },
  {
   value: "Lyons (USYOI)",
   label: "Lyons (USYOI)"
  },
  {
   value: "Lyons (USYOS)",
   label: "Lyons (USYOS)"
  },
  {
   value: "Lyons (USZYO)",
   label: "Lyons (USZYO)"
  },
  {
   value: "Lyons Falls (USYSF)",
   label: "Lyons Falls (USYSF)"
  },
  {
   value: "Mabank (USMWB)",
   label: "Mabank (USMWB)"
  },
  {
   value: "Mabel (USQMB)",
   label: "Mabel (USQMB)"
  },
  {
   value: "Mabelvale (USYMB)",
   label: "Mabelvale (USYMB)"
  },
  {
   value: "Mabton (USZAN)",
   label: "Mabton (USZAN)"
  },
  {
   value: "Macatawa (USZTW)",
   label: "Macatawa (USZTW)"
  },
  {
   value: "Macdoel (USMKD)",
   label: "Macdoel (USMKD)"
  },
  {
   value: "Maceo (USMKP)",
   label: "Maceo (USMKP)"
  },
  {
   value: "Machesney Park (USMP5)",
   label: "Machesney Park (USMP5)"
  },
  {
   value: "Machias (USACI)",
   label: "Machias (USACI)"
  },
  {
   value: "Mackinaw (USKWZ)",
   label: "Mackinaw (USKWZ)"
  },
  {
   value: "Mackinaw City (USKWY)",
   label: "Mackinaw City (USKWY)"
  },
  {
   value: "Macomb (USOMB)",
   label: "Macomb (USOMB)"
  },
  {
   value: "Macon (USMO8)",
   label: "Macon (USMO8)"
  },
  {
   value: "Macungie (USMGB)",
   label: "Macungie (USMGB)"
  },
  {
   value: "Maddock (USDOC)",
   label: "Maddock (USDOC)"
  },
  {
   value: "Madeira (USME6)",
   label: "Madeira (USME6)"
  },
  {
   value: "Madison (USDIC)",
   label: "Madison (USDIC)"
  },
  {
   value: "Madison (USMA8)",
   label: "Madison (USMA8)"
  },
  {
   value: "Madison (USMO7)",
   label: "Madison (USMO7)"
  },
  {
   value: "Madison (USMS4)",
   label: "Madison (USMS4)"
  },
  {
   value: "Madison (USMSB)",
   label: "Madison (USMSB)"
  },
  {
   value: "Madison (USMZX)",
   label: "Madison (USMZX)"
  },
  {
   value: "Madison (USQMD)",
   label: "Madison (USQMD)"
  },
  {
   value: "Madison (USQMJ)",
   label: "Madison (USQMJ)"
  },
  {
   value: "Madison Heights (USMH5)",
   label: "Madison Heights (USMH5)"
  },
  {
   value: "Madison Park (USYMD)",
   label: "Madison Park (USYMD)"
  },
  {
   value: "Madisonville (USDIX)",
   label: "Madisonville (USDIX)"
  },
  {
   value: "Madisonville (USINV)",
   label: "Madisonville (USINV)"
  },
  {
   value: "Madisonville (USIOE)",
   label: "Madisonville (USIOE)"
  },
  {
   value: "Madrid (USUID)",
   label: "Madrid (USUID)"
  },
  {
   value: "Magee (USQME)",
   label: "Magee (USQME)"
  },
  {
   value: "Magma (USMG7)",
   label: "Magma (USMG7)"
  },
  {
   value: "Magness (USZG3)",
   label: "Magness (USZG3)"
  },
  {
   value: "Magnolia (USAGI)",
   label: "Magnolia (USAGI)"
  },
  {
   value: "Magnolia (USMN8)",
   label: "Magnolia (USMN8)"
  },
  {
   value: "Magnolia (USOIA)",
   label: "Magnolia (USOIA)"
  },
  {
   value: "Mahanoy City (USYLM)",
   label: "Mahanoy City (USYLM)"
  },
  {
   value: "Mahomet (USJMM)",
   label: "Mahomet (USJMM)"
  },
  {
   value: "Mahtomedi (USMM8)",
   label: "Mahtomedi (USMM8)"
  },
  {
   value: "Maidens (USMS3)",
   label: "Maidens (USMS3)"
  },
  {
   value: "Maidsville (USIBL)",
   label: "Maidsville (USIBL)"
  },
  {
   value: "Maineville (USIEI)",
   label: "Maineville (USIEI)"
  },
  {
   value: "Mainland (USML6)",
   label: "Mainland (USML6)"
  },
  {
   value: "Maitland (USML3)",
   label: "Maitland (USML3)"
  },
  {
   value: "Malabar (USUMJ)",
   label: "Malabar (USUMJ)"
  },
  {
   value: "Malaga (USMG5)",
   label: "Malaga (USMG5)"
  },
  {
   value: "Malakoff (USMKF)",
   label: "Malakoff (USMKF)"
  },
  {
   value: "Malcom (USGMM)",
   label: "Malcom (USGMM)"
  },
  {
   value: "Malone (USAOE)",
   label: "Malone (USAOE)"
  },
  {
   value: "Malone (USNYM)",
   label: "Malone (USNYM)"
  },
  {
   value: "Malta (USMLX)",
   label: "Malta (USMLX)"
  },
  {
   value: "Malta (USZGB)",
   label: "Malta (USZGB)"
  },
  {
   value: "Malvern (USMV6)",
   label: "Malvern (USMV6)"
  },
  {
   value: "Malvern (USMVR)",
   label: "Malvern (USMVR)"
  },
  {
   value: "Malvern (USMWN)",
   label: "Malvern (USMWN)"
  },
  {
   value: "Mammoth (USZMH)",
   label: "Mammoth (USZMH)"
  },
  {
   value: "Man (USVMA)",
   label: "Man (USVMA)"
  },
  {
   value: "Manahawkin (USAAW)",
   label: "Manahawkin (USAAW)"
  },
  {
   value: "Manalapan (USAPZ)",
   label: "Manalapan (USAPZ)"
  },
  {
   value: "Manasquan (USZMQ)",
   label: "Manasquan (USZMQ)"
  },
  {
   value: "Manassas Park (USKMK)",
   label: "Manassas Park (USKMK)"
  },
  {
   value: "Manayunk (USMY2)",
   label: "Manayunk (USMY2)"
  },
  {
   value: "Manchaug (USM2U)",
   label: "Manchaug (USM2U)"
  },
  {
   value: "Manchester (USAQS)",
   label: "Manchester (USAQS)"
  },
  {
   value: "Manchester (USMCX)",
   label: "Manchester (USMCX)"
  },
  {
   value: "Manchester (USMR7)",
   label: "Manchester (USMR7)"
  },
  {
   value: "Manchester (USNKR)",
   label: "Manchester (USNKR)"
  },
  {
   value: "Manchester (USNMJ)",
   label: "Manchester (USNMJ)"
  },
  {
   value: "Manchester (USNSK)",
   label: "Manchester (USNSK)"
  },
  {
   value: "Manchester (USUMZ)",
   label: "Manchester (USUMZ)"
  },
  {
   value: "Manchester (USYMC)",
   label: "Manchester (USYMC)"
  },
  {
   value: "Manchester (USZMN)",
   label: "Manchester (USZMN)"
  },
  {
   value: "Manchester (USZRM)",
   label: "Manchester (USZRM)"
  },
  {
   value: "Mandan (USNDN)",
   label: "Mandan (USNDN)"
  },
  {
   value: "Mandarin (USNDR)",
   label: "Mandarin (USNDR)"
  },
  {
   value: "Manhasset (USMH8)",
   label: "Manhasset (USMH8)"
  },
  {
   value: "Manhattan (USHM8)",
   label: "Manhattan (USHM8)"
  },
  {
   value: "Manhattan\/New York (USMNH)",
   label: "Manhattan\/New York (USMNH)"
  },
  {
   value: "Manheim Center (USZMY)",
   label: "Manheim Center (USZMY)"
  },
  {
   value: "Manito (USILT)",
   label: "Manito (USILT)"
  },
  {
   value: "Manitou Springs (USMS8)",
   label: "Manitou Springs (USMS8)"
  },
  {
   value: "Manlius (USAIU)",
   label: "Manlius (USAIU)"
  },
  {
   value: "Mannford (USYNF)",
   label: "Mannford (USYNF)"
  },
  {
   value: "Manning (USIFG)",
   label: "Manning (USIFG)"
  },
  {
   value: "Mannington (USMT7)",
   label: "Mannington (USMT7)"
  },
  {
   value: "Mannington (USQNG)",
   label: "Mannington (USQNG)"
  },
  {
   value: "Mannington Mills (USAIM)",
   label: "Mannington Mills (USAIM)"
  },
  {
   value: "Manns Choice (USOMZ)",
   label: "Manns Choice (USOMZ)"
  },
  {
   value: "Mannsville (USNSV)",
   label: "Mannsville (USNSV)"
  },
  {
   value: "Manokotak (USKMO)",
   label: "Manokotak (USKMO)"
  },
  {
   value: "Manor (USZMA)",
   label: "Manor (USZMA)"
  },
  {
   value: "Mansfield (USAFD)",
   label: "Mansfield (USAFD)"
  },
  {
   value: "Mansfield (USLFM)",
   label: "Mansfield (USLFM)"
  },
  {
   value: "Mansfield (USXMW)",
   label: "Mansfield (USXMW)"
  },
  {
   value: "Mansfield Center (USMC8)",
   label: "Mansfield Center (USMC8)"
  },
  {
   value: "Manson (USYMN)",
   label: "Manson (USYMN)"
  },
  {
   value: "Mansura (USNSU)",
   label: "Mansura (USNSU)"
  },
  {
   value: "Mantachie (USATI)",
   label: "Mantachie (USATI)"
  },
  {
   value: "Manti (USNTJ)",
   label: "Manti (USNTJ)"
  },
  {
   value: "Mantua (USQMU)",
   label: "Mantua (USQMU)"
  },
  {
   value: "Manville (USAVR)",
   label: "Manville (USAVR)"
  },
  {
   value: "Manville (USJVI)",
   label: "Manville (USJVI)"
  },
  {
   value: "Many (USNMY)",
   label: "Many (USNMY)"
  },
  {
   value: "Maple Bluff (USZPU)",
   label: "Maple Bluff (USZPU)"
  },
  {
   value: "Maple City (USMQQ)",
   label: "Maple City (USMQQ)"
  },
  {
   value: "Maple Grove (USMGZ)",
   label: "Maple Grove (USMGZ)"
  },
  {
   value: "Maple Grove (USXMG)",
   label: "Maple Grove (USXMG)"
  },
  {
   value: "Maple Lake (USYWO)",
   label: "Maple Lake (USYWO)"
  },
  {
   value: "Maple Plain (USMP4)",
   label: "Maple Plain (USMP4)"
  },
  {
   value: "Maple Valley (USMV7)",
   label: "Maple Valley (USMV7)"
  },
  {
   value: "Maplesville (USAJV)",
   label: "Maplesville (USAJV)"
  },
  {
   value: "Mapleton (USMPM)",
   label: "Mapleton (USMPM)"
  },
  {
   value: "Mapleton (USNDK)",
   label: "Mapleton (USNDK)"
  },
  {
   value: "Maplewood (USMW2)",
   label: "Maplewood (USMW2)"
  },
  {
   value: "Maplewood (USNPQ)",
   label: "Maplewood (USNPQ)"
  },
  {
   value: "Mappsville (USMEK)",
   label: "Mappsville (USMEK)"
  },
  {
   value: "Marathon (USNYA)",
   label: "Marathon (USNYA)"
  },
  {
   value: "Marblehead (USMH2)",
   label: "Marblehead (USMH2)"
  },
  {
   value: "Marblehill (USZMB)",
   label: "Marblehill (USZMB)"
  },
  {
   value: "Marcellus (USMU6)",
   label: "Marcellus (USMU6)"
  },
  {
   value: "March Air Reserve Base (USRSY)",
   label: "March Air Reserve Base (USRSY)"
  },
  {
   value: "Marcy (USZAY)",
   label: "Marcy (USZAY)"
  },
  {
   value: "Marengo (USAEG)",
   label: "Marengo (USAEG)"
  },
  {
   value: "Marengo (USM2A)",
   label: "Marengo (USM2A)"
  },
  {
   value: "Marengo (USREG)",
   label: "Marengo (USREG)"
  },
  {
   value: "Margaretville (USZEU)",
   label: "Margaretville (USZEU)"
  },
  {
   value: "Marguerite Bay (USRTE)",
   label: "Marguerite Bay (USRTE)"
  },
  {
   value: "Maria Stein (USISK)",
   label: "Maria Stein (USISK)"
  },
  {
   value: "Marianna (USRIA)",
   label: "Marianna (USRIA)"
  },
  {
   value: "Maricopa (USAIC)",
   label: "Maricopa (USAIC)"
  },
  {
   value: "Maricopa (USEPC)",
   label: "Maricopa (USEPC)"
  },
  {
   value: "Marietta (USIET)",
   label: "Marietta (USIET)"
  },
  {
   value: "Marietta (USRTA)",
   label: "Marietta (USRTA)"
  },
  {
   value: "Marietta (USRTT)",
   label: "Marietta (USRTT)"
  },
  {
   value: "Maringouin (USMGU)",
   label: "Maringouin (USMGU)"
  },
  {
   value: "Marion (USIJN)",
   label: "Marion (USIJN)"
  },
  {
   value: "Marion (USIMA)",
   label: "Marion (USIMA)"
  },
  {
   value: "Marion (USMMX)",
   label: "Marion (USMMX)"
  },
  {
   value: "Marion (USMN2)",
   label: "Marion (USMN2)"
  },
  {
   value: "Marion (USQAM)",
   label: "Marion (USQAM)"
  },
  {
   value: "Mariposa (USMP8)",
   label: "Mariposa (USMP8)"
  },
  {
   value: "Marissa (USJMA)",
   label: "Marissa (USJMA)"
  },
  {
   value: "Mark (USAWK)",
   label: "Mark (USAWK)"
  },
  {
   value: "Marked Tree (USAKT)",
   label: "Marked Tree (USAKT)"
  },
  {
   value: "Markesan (USMKQ)",
   label: "Markesan (USMKQ)"
  },
  {
   value: "Markham (USMKH)",
   label: "Markham (USMKH)"
  },
  {
   value: "Markleville (USQMK)",
   label: "Markleville (USQMK)"
  },
  {
   value: "Marksville (USZEK)",
   label: "Marksville (USZEK)"
  },
  {
   value: "Marlboro (USMBB)",
   label: "Marlboro (USMBB)"
  },
  {
   value: "Marlboro (USMBZ)",
   label: "Marlboro (USMBZ)"
  },
  {
   value: "Marlboro (Marlborough) (USMXG)",
   label: "Marlboro (Marlborough) (USMXG)"
  },
  {
   value: "Marlborough (USMGX)",
   label: "Marlborough (USMGX)"
  },
  {
   value: "Marlborough, Middlesex (USMB2)",
   label: "Marlborough, Middlesex (USMB2)"
  },
  {
   value: "Marlin (USML2)",
   label: "Marlin (USML2)"
  },
  {
   value: "Marlow (USAOW)",
   label: "Marlow (USAOW)"
  },
  {
   value: "Marmaduke (USZRU)",
   label: "Marmaduke (USZRU)"
  },
  {
   value: "Marne (USQMM)",
   label: "Marne (USQMM)"
  },
  {
   value: "Marquette (USQTT)",
   label: "Marquette (USQTT)"
  },
  {
   value: "Marrowbone (USMWZ)",
   label: "Marrowbone (USMWZ)"
  },
  {
   value: "Mars Hill (USYMH)",
   label: "Mars Hill (USYMH)"
  },
  {
   value: "Marseilles (USMR2)",
   label: "Marseilles (USMR2)"
  },
  {
   value: "Marseilles (USZEX)",
   label: "Marseilles (USZEX)"
  },
  {
   value: "Marshall (USML8)",
   label: "Marshall (USML8)"
  },
  {
   value: "Marshall (USNMA)",
   label: "Marshall (USNMA)"
  },
  {
   value: "Marshall (USQMH)",
   label: "Marshall (USQMH)"
  },
  {
   value: "Marshall (USQML)",
   label: "Marshall (USQML)"
  },
  {
   value: "Marshallton (USSL7)",
   label: "Marshallton (USSL7)"
  },
  {
   value: "Marshfield (USMF8)",
   label: "Marshfield (USMF8)"
  },
  {
   value: "Marthasville (USAHX)",
   label: "Marthasville (USAHX)"
  },
  {
   value: "Martin (USZAR)",
   label: "Martin (USZAR)"
  },
  {
   value: "Martindale (USZRT)",
   label: "Martindale (USZRT)"
  },
  {
   value: "Martinez (USRTI)",
   label: "Martinez (USRTI)"
  },
  {
   value: "Martinsburg (USAIR)",
   label: "Martinsburg (USAIR)"
  },
  {
   value: "Martinsburg (USMB7)",
   label: "Martinsburg (USMB7)"
  },
  {
   value: "Martinsville (USIIE)",
   label: "Martinsville (USIIE)"
  },
  {
   value: "Martinsville (USMV8)",
   label: "Martinsville (USMV8)"
  },
  {
   value: "Martinsville (USMXS)",
   label: "Martinsville (USMXS)"
  },
  {
   value: "Marvell (USAMV)",
   label: "Marvell (USAMV)"
  },
  {
   value: "Mary Esther (USMYT)",
   label: "Mary Esther (USMYT)"
  },
  {
   value: "Maryland City (USZJV)",
   label: "Maryland City (USZJV)"
  },
  {
   value: "Maryland Heights (USMHY)",
   label: "Maryland Heights (USMHY)"
  },
  {
   value: "Maryneal (USMY4)",
   label: "Maryneal (USMY4)"
  },
  {
   value: "Marysville (USMVV)",
   label: "Marysville (USMVV)"
  },
  {
   value: "Maryville (USMVD)",
   label: "Maryville (USMVD)"
  },
  {
   value: "Mascot (USAOT)",
   label: "Mascot (USAOT)"
  },
  {
   value: "Mascoutah (USMSK)",
   label: "Mascoutah (USMSK)"
  },
  {
   value: "Mashantucket (USUCH)",
   label: "Mashantucket (USUCH)"
  },
  {
   value: "Mashpee (USME7)",
   label: "Mashpee (USME7)"
  },
  {
   value: "Mason (USQON)",
   label: "Mason (USQON)"
  },
  {
   value: "Mason (USYAQ)",
   label: "Mason (USYAQ)"
  },
  {
   value: "Mason City (USM2C)",
   label: "Mason City (USM2C)"
  },
  {
   value: "Mason, Bayfield (USONQ)",
   label: "Mason, Bayfield (USONQ)"
  },
  {
   value: "Masontown (USQER)",
   label: "Masontown (USQER)"
  },
  {
   value: "Masontown (USVXI)",
   label: "Masontown (USVXI)"
  },
  {
   value: "Masonville (USMI5)",
   label: "Masonville (USMI5)"
  },
  {
   value: "Maspeth (USMPB)",
   label: "Maspeth (USMPB)"
  },
  {
   value: "Massapequa (USAQU)",
   label: "Massapequa (USAQU)"
  },
  {
   value: "Massey (USQMZ)",
   label: "Massey (USQMZ)"
  },
  {
   value: "Mastic (USZTC)",
   label: "Mastic (USZTC)"
  },
  {
   value: "Matador (USMD2)",
   label: "Matador (USMD2)"
  },
  {
   value: "Matawan (USTAW)",
   label: "Matawan (USTAW)"
  },
  {
   value: "Mather (USTHC)",
   label: "Mather (USTHC)"
  },
  {
   value: "Mathis (USZMI)",
   label: "Mathis (USZMI)"
  },
  {
   value: "Mathiston (USMI6)",
   label: "Mathiston (USMI6)"
  },
  {
   value: "Mattaponi (USKMJ)",
   label: "Mattaponi (USKMJ)"
  },
  {
   value: "Mattawan (USMNW)",
   label: "Mattawan (USMNW)"
  },
  {
   value: "Matteson (USAES)",
   label: "Matteson (USAES)"
  },
  {
   value: "Matthews (USW9)",
   label: "Matthews (USW9)"
  },
  {
   value: "Mattituck (USXUK)",
   label: "Mattituck (USXUK)"
  },
  {
   value: "Mattoon (USKMA)",
   label: "Mattoon (USKMA)"
  },
  {
   value: "Mauckport (USMP2)",
   label: "Mauckport (USMP2)"
  },
  {
   value: "Mauricetown (USUCW)",
   label: "Mauricetown (USUCW)"
  },
  {
   value: "Mauriceville (USNJS)",
   label: "Mauriceville (USNJS)"
  },
  {
   value: "Maury City (USYCT)",
   label: "Maury City (USYCT)"
  },
  {
   value: "Maxwell (USAXW)",
   label: "Maxwell (USAXW)"
  },
  {
   value: "Maxwell (USMWU)",
   label: "Maxwell (USMWU)"
  },
  {
   value: "Maxwell (USXWL)",
   label: "Maxwell (USXWL)"
  },
  {
   value: "Mayer (USYMM)",
   label: "Mayer (USYMM)"
  },
  {
   value: "Mayetta (USYEI)",
   label: "Mayetta (USYEI)"
  },
  {
   value: "Mayfield, Butler (USMF7)",
   label: "Mayfield, Butler (USMF7)"
  },
  {
   value: "Mayfield, Cuyahoga (USAYF)",
   label: "Mayfield, Cuyahoga (USAYF)"
  },
  {
   value: "Mayhew (USMH3)",
   label: "Mayhew (USMH3)"
  },
  {
   value: "Maynard (USMYB)",
   label: "Maynard (USMYB)"
  },
  {
   value: "Maynard (USUMY)",
   label: "Maynard (USUMY)"
  },
  {
   value: "Maynardville (USYVF)",
   label: "Maynardville (USYVF)"
  },
  {
   value: "Maypearl (USYEH)",
   label: "Maypearl (USYEH)"
  },
  {
   value: "Mayport (USNRB)",
   label: "Mayport (USNRB)"
  },
  {
   value: "Maysville (USMVU)",
   label: "Maysville (USMVU)"
  },
  {
   value: "Maysville (USYSI)",
   label: "Maysville (USYSI)"
  },
  {
   value: "Maysville (USYSL)",
   label: "Maysville (USYSL)"
  },
  {
   value: "Maywood, Albany (USMQF)",
   label: "Maywood, Albany (USMQF)"
  },
  {
   value: "Maywood\/Chicago (USMWQ)",
   label: "Maywood\/Chicago (USMWQ)"
  },
  {
   value: "Mazomanie (USMZV)",
   label: "Mazomanie (USMZV)"
  },
  {
   value: "Mazon (USMZF)",
   label: "Mazon (USMZF)"
  },
  {
   value: "McAlisterville (USMA2)",
   label: "McAlisterville (USMA2)"
  },
  {
   value: "McAllen (USTXC)",
   label: "McAllen (USTXC)"
  },
  {
   value: "McAlpin (USLPN)",
   label: "McAlpin (USLPN)"
  },
  {
   value: "McBain (USKMZ)",
   label: "McBain (USKMZ)"
  },
  {
   value: "McCalla (USMKX)",
   label: "McCalla (USMKX)"
  },
  {
   value: "McCanna (USCA5)",
   label: "McCanna (USCA5)"
  },
  {
   value: "McCarran (USNVM)",
   label: "McCarran (USNVM)"
  },
  {
   value: "McCleary (USQMW)",
   label: "McCleary (USQMW)"
  },
  {
   value: "McClellan Air Force Base (USMC2)",
   label: "McClellan Air Force Base (USMC2)"
  },
  {
   value: "McClellan Place (USMP6)",
   label: "McClellan Place (USMP6)"
  },
  {
   value: "McClure (USJMU)",
   label: "McClure (USJMU)"
  },
  {
   value: "McCombs (USXXZ)",
   label: "McCombs (USXXZ)"
  },
  {
   value: "McConnelsville (USMVZ)",
   label: "McConnelsville (USMVZ)"
  },
  {
   value: "McCormick (USOIK)",
   label: "McCormick (USOIK)"
  },
  {
   value: "McDade (USMD3)",
   label: "McDade (USMD3)"
  },
  {
   value: "McDermott (USMDT)",
   label: "McDermott (USMDT)"
  },
  {
   value: "McDonald (USDGD)",
   label: "McDonald (USDGD)"
  },
  {
   value: "McDonald, Muskingum (USDOD)",
   label: "McDonald, Muskingum (USDOD)"
  },
  {
   value: "McDonald, Trumbull (USMD8)",
   label: "McDonald, Trumbull (USMD8)"
  },
  {
   value: "McElhattan (USLHC)",
   label: "McElhattan (USLHC)"
  },
  {
   value: "McEwen (USZWM)",
   label: "McEwen (USZWM)"
  },
  {
   value: "McFarland (USMF6)",
   label: "McFarland (USMF6)"
  },
  {
   value: "McGehee (USGEH)",
   label: "McGehee (USGEH)"
  },
  {
   value: "McGrath (USMCG)",
   label: "McGrath (USMCG)"
  },
  {
   value: "McGregor (USMG2)",
   label: "McGregor (USMG2)"
  },
  {
   value: "McGregor (USMG3)",
   label: "McGregor (USMG3)"
  },
  {
   value: "McGregor (USMG4)",
   label: "McGregor (USMG4)"
  },
  {
   value: "McKees Rocks (USMKJ)",
   label: "McKees Rocks (USMKJ)"
  },
  {
   value: "McKeesport (USMKR)",
   label: "McKeesport (USMKR)"
  },
  {
   value: "McKenzie (USMK2)",
   label: "McKenzie (USMK2)"
  },
  {
   value: "McKinleyville (USKNY)",
   label: "McKinleyville (USKNY)"
  },
  {
   value: "McLean\/Washington, D.C. (USXQM)",
   label: "McLean\/Washington, D.C. (USXQM)"
  },
  {
   value: "McLeansboro (USIMQ)",
   label: "McLeansboro (USIMQ)"
  },
  {
   value: "McLeansville (USQMC)",
   label: "McLeansville (USQMC)"
  },
  {
   value: "McMechen (USEHJ)",
   label: "McMechen (USEHJ)"
  },
  {
   value: "McMinnville (USRNC)",
   label: "McMinnville (USRNC)"
  },
  {
   value: "McNeil (USJIL)",
   label: "McNeil (USJIL)"
  },
  {
   value: "McQueeney (USQNY)",
   label: "McQueeney (USQNY)"
  },
  {
   value: "McSherrystown (USHYT)",
   label: "McSherrystown (USHYT)"
  },
  {
   value: "McWilliams (USDCM)",
   label: "McWilliams (USDCM)"
  },
  {
   value: "Mead (USM2E)",
   label: "Mead (USM2E)"
  },
  {
   value: "Mead (USMD4)",
   label: "Mead (USMD4)"
  },
  {
   value: "Mead (USME8)",
   label: "Mead (USME8)"
  },
  {
   value: "Meadow Lands (USMWD)",
   label: "Meadow Lands (USMWD)"
  },
  {
   value: "Meadows Place (USEOP)",
   label: "Meadows Place (USEOP)"
  },
  {
   value: "Means (USQMS)",
   label: "Means (USQMS)"
  },
  {
   value: "Mechanicsburg (USHCG)",
   label: "Mechanicsburg (USHCG)"
  },
  {
   value: "Mechanicsburg (USMEG)",
   label: "Mechanicsburg (USMEG)"
  },
  {
   value: "Mechanicsburg, Beaver (USECI)",
   label: "Mechanicsburg, Beaver (USECI)"
  },
  {
   value: "Mechanicsville (USMEC)",
   label: "Mechanicsville (USMEC)"
  },
  {
   value: "Medford (USME4)",
   label: "Medford (USME4)"
  },
  {
   value: "Medfra (USMDR)",
   label: "Medfra (USMDR)"
  },
  {
   value: "Medicine Bow (USVMB)",
   label: "Medicine Bow (USVMB)"
  },
  {
   value: "Medicine Lodge (USJMI)",
   label: "Medicine Lodge (USJMI)"
  },
  {
   value: "Medina (USDIN)",
   label: "Medina (USDIN)"
  },
  {
   value: "Medina (USVMX)",
   label: "Medina (USVMX)"
  },
  {
   value: "Medon (USMN3)",
   label: "Medon (USMN3)"
  },
  {
   value: "Medora (USMD6)",
   label: "Medora (USMD6)"
  },
  {
   value: "Meeker (USMK3)",
   label: "Meeker (USMK3)"
  },
  {
   value: "Meigs (USQIG)",
   label: "Meigs (USQIG)"
  },
  {
   value: "Melbourne (USMQJ)",
   label: "Melbourne (USMQJ)"
  },
  {
   value: "Melbourne (USZJG)",
   label: "Melbourne (USZJG)"
  },
  {
   value: "Melissa (USVMJ)",
   label: "Melissa (USVMJ)"
  },
  {
   value: "Mellen (USZML)",
   label: "Mellen (USZML)"
  },
  {
   value: "Mellwood (USDMW)",
   label: "Mellwood (USDMW)"
  },
  {
   value: "Melrose (USMO2)",
   label: "Melrose (USMO2)"
  },
  {
   value: "Melrose Park (USEKU)",
   label: "Melrose Park (USEKU)"
  },
  {
   value: "Melvin (USZVM)",
   label: "Melvin (USZVM)"
  },
  {
   value: "Melvindale (USMGF)",
   label: "Melvindale (USMGF)"
  },
  {
   value: "Memphis (USEJS)",
   label: "Memphis (USEJS)"
  },
  {
   value: "Memphis (USOMQ)",
   label: "Memphis (USOMQ)"
  },
  {
   value: "Memphis (USZGD)",
   label: "Memphis (USZGD)"
  },
  {
   value: "Mena (USAE4)",
   label: "Mena (USAE4)"
  },
  {
   value: "Menands (USNAD)",
   label: "Menands (USNAD)"
  },
  {
   value: "Mendham (USZEY)",
   label: "Mendham (USZEY)"
  },
  {
   value: "Mendon (USENU)",
   label: "Mendon (USENU)"
  },
  {
   value: "Mendon (USJJJ)",
   label: "Mendon (USJJJ)"
  },
  {
   value: "Mendon (USNDO)",
   label: "Mendon (USNDO)"
  },
  {
   value: "Mendota (USZMC)",
   label: "Mendota (USZMC)"
  },
  {
   value: "Mendota Heights (USMDG)",
   label: "Mendota Heights (USMDG)"
  },
  {
   value: "Menemsha (USMN5)",
   label: "Menemsha (USMN5)"
  },
  {
   value: "Menifee (USEFE)",
   label: "Menifee (USEFE)"
  },
  {
   value: "Menno (USMO6)",
   label: "Menno (USMO6)"
  },
  {
   value: "Mentone (USNNE)",
   label: "Mentone (USNNE)"
  },
  {
   value: "Mentor (USMEA)",
   label: "Mentor (USMEA)"
  },
  {
   value: "Mer Rouge (USZXE)",
   label: "Mer Rouge (USZXE)"
  },
  {
   value: "Mercer (USDMC)",
   label: "Mercer (USDMC)"
  },
  {
   value: "Mercer (USEZC)",
   label: "Mercer (USEZC)"
  },
  {
   value: "Mercer (USMZ2)",
   label: "Mercer (USMZ2)"
  },
  {
   value: "Mercer (USXXW)",
   label: "Mercer (USXXW)"
  },
  {
   value: "Mercersburg (USMBP)",
   label: "Mercersburg (USMBP)"
  },
  {
   value: "Mercury (USDRA)",
   label: "Mercury (USDRA)"
  },
  {
   value: "Meredith (USMD5)",
   label: "Meredith (USMD5)"
  },
  {
   value: "Meredith (USME5)",
   label: "Meredith (USME5)"
  },
  {
   value: "Meriden (USEIQ)",
   label: "Meriden (USEIQ)"
  },
  {
   value: "Meriden (USMN7)",
   label: "Meriden (USMN7)"
  },
  {
   value: "Merino (USIJO)",
   label: "Merino (USIJO)"
  },
  {
   value: "Merriam (USMEW)",
   label: "Merriam (USMEW)"
  },
  {
   value: "Merrifield (USMZR)",
   label: "Merrifield (USMZR)"
  },
  {
   value: "Merrimac (USMM2)",
   label: "Merrimac (USMM2)"
  },
  {
   value: "Merrimac (USRM8)",
   label: "Merrimac (USRM8)"
  },
  {
   value: "Merrittstown (USIWN)",
   label: "Merrittstown (USIWN)"
  },
  {
   value: "Merry Hill (USMH7)",
   label: "Merry Hill (USMH7)"
  },
  {
   value: "Mertzon (USERT)",
   label: "Mertzon (USERT)"
  },
  {
   value: "Meshoppen (USZPN)",
   label: "Meshoppen (USZPN)"
  },
  {
   value: "Metamora (USEOA)",
   label: "Metamora (USEOA)"
  },
  {
   value: "Metamora (USMM3)",
   label: "Metamora (USMM3)"
  },
  {
   value: "Methuen (USMZN)",
   label: "Methuen (USMZN)"
  },
  {
   value: "Mettawa (USMT2)",
   label: "Mettawa (USMT2)"
  },
  {
   value: "Metter (USTTR)",
   label: "Metter (USTTR)"
  },
  {
   value: "Mexico (USXXX)",
   label: "Mexico (USXXX)"
  },
  {
   value: "Mexico Beach (USZGJ)",
   label: "Mexico Beach (USZGJ)"
  },
  {
   value: "Meyers Chuck (USWMK)",
   label: "Meyers Chuck (USWMK)"
  },
  {
   value: "Miami Beach (USIYH)",
   label: "Miami Beach (USIYH)"
  },
  {
   value: "Miami Gardens (USZMG)",
   label: "Miami Gardens (USZMG)"
  },
  {
   value: "Miamisburg (USIAM)",
   label: "Miamisburg (USIAM)"
  },
  {
   value: "Miamitown (USIMW)",
   label: "Miamitown (USIMW)"
  },
  {
   value: "Mica (USICM)",
   label: "Mica (USICM)"
  },
  {
   value: "Micanopy (USICA)",
   label: "Micanopy (USICA)"
  },
  {
   value: "Micaville (USM3V)",
   label: "Micaville (USM3V)"
  },
  {
   value: "Michael (USMI7)",
   label: "Michael (USMI7)"
  },
  {
   value: "Michigamme (USMG8)",
   label: "Michigamme (USMG8)"
  },
  {
   value: "Michigantown (USKMH)",
   label: "Michigantown (USKMH)"
  },
  {
   value: "Middle Granville (USMGL)",
   label: "Middle Granville (USMGL)"
  },
  {
   value: "Middle I. (USZIX)",
   label: "Middle I. (USZIX)"
  },
  {
   value: "Middlebranch (USXXH)",
   label: "Middlebranch (USXXH)"
  },
  {
   value: "Middleburg (USHQ4)",
   label: "Middleburg (USHQ4)"
  },
  {
   value: "Middleburg (USLRG)",
   label: "Middleburg (USLRG)"
  },
  {
   value: "Middleburg (USMB8)",
   label: "Middleburg (USMB8)"
  },
  {
   value: "Middleburg, Logan (USDBU)",
   label: "Middleburg, Logan (USDBU)"
  },
  {
   value: "Middlebury (USM2D)",
   label: "Middlebury (USM2D)"
  },
  {
   value: "Middlebury Center (USURY)",
   label: "Middlebury Center (USURY)"
  },
  {
   value: "Middlefield (USQMI)",
   label: "Middlefield (USQMI)"
  },
  {
   value: "Middlefield (USXXD)",
   label: "Middlefield (USXXD)"
  },
  {
   value: "Middlesex (USIDD)",
   label: "Middlesex (USIDD)"
  },
  {
   value: "Middleton (USDDT)",
   label: "Middleton (USDDT)"
  },
  {
   value: "Middleton (USMT3)",
   label: "Middleton (USMT3)"
  },
  {
   value: "Middleton Island (USMDO)",
   label: "Middleton Island (USMDO)"
  },
  {
   value: "Middletown (USILQ)",
   label: "Middletown (USILQ)"
  },
  {
   value: "Middletown (USYMT)",
   label: "Middletown (USYMT)"
  },
  {
   value: "Middletown, Allen (USDDN)",
   label: "Middletown, Allen (USDDN)"
  },
  {
   value: "Middletown, Frederick (USUQK)",
   label: "Middletown, Frederick (USUQK)"
  },
  {
   value: "Middletown, Shelby (USDD3)",
   label: "Middletown, Shelby (USDD3)"
  },
  {
   value: "Middleway (USDDY)",
   label: "Middleway (USDDY)"
  },
  {
   value: "Midfield (USIFE)",
   label: "Midfield (USIFE)"
  },
  {
   value: "Midfield (USXFW)",
   label: "Midfield (USXFW)"
  },
  {
   value: "Midland (USIAL)",
   label: "Midland (USIAL)"
  },
  {
   value: "Midland (USILD)",
   label: "Midland (USILD)"
  },
  {
   value: "Midland (USMJD)",
   label: "Midland (USMJD)"
  },
  {
   value: "Midland (USXAD)",
   label: "Midland (USXAD)"
  },
  {
   value: "Midland (USYML)",
   label: "Midland (USYML)"
  },
  {
   value: "Midland (USZID)",
   label: "Midland (USZID)"
  },
  {
   value: "Midland City (USIDY)",
   label: "Midland City (USIDY)"
  },
  {
   value: "Midlothian (USMED)",
   label: "Midlothian (USMED)"
  },
  {
   value: "Midvale (USIDV)",
   label: "Midvale (USIDV)"
  },
  {
   value: "Midway (USDBD)",
   label: "Midway (USDBD)"
  },
  {
   value: "Midway (USIWA)",
   label: "Midway (USIWA)"
  },
  {
   value: "Midway (USIWY)",
   label: "Midway (USIWY)"
  },
  {
   value: "Midway, Liberty (USQMY)",
   label: "Midway, Liberty (USQMY)"
  },
  {
   value: "Midwest City (USIDW)",
   label: "Midwest City (USIDW)"
  },
  {
   value: "Mifflinburg (USIFB)",
   label: "Mifflinburg (USIFB)"
  },
  {
   value: "Mifflintown (USM2I)",
   label: "Mifflintown (USM2I)"
  },
  {
   value: "Mifflinville (USMFN)",
   label: "Mifflinville (USMFN)"
  },
  {
   value: "Milaca (USML4)",
   label: "Milaca (USML4)"
  },
  {
   value: "Milan (USLIM)",
   label: "Milan (USLIM)"
  },
  {
   value: "Milan (USML7)",
   label: "Milan (USML7)"
  },
  {
   value: "Milan (USN9)",
   label: "Milan (USN9)"
  },
  {
   value: "Milan (USNMM)",
   label: "Milan (USNMM)"
  },
  {
   value: "Milan (USOML)",
   label: "Milan (USOML)"
  },
  {
   value: "Milan (USYIM)",
   label: "Milan (USYIM)"
  },
  {
   value: "Milan (USZIM)",
   label: "Milan (USZIM)"
  },
  {
   value: "Miles City (USYMI)",
   label: "Miles City (USYMI)"
  },
  {
   value: "Milford (USMF5)",
   label: "Milford (USMF5)"
  },
  {
   value: "Milford (USMFK)",
   label: "Milford (USMFK)"
  },
  {
   value: "Milford (USMFT)",
   label: "Milford (USMFT)"
  },
  {
   value: "Milford (USMFX)",
   label: "Milford (USMFX)"
  },
  {
   value: "Milford (USMRQ)",
   label: "Milford (USMRQ)"
  },
  {
   value: "Milford (USQAO)",
   label: "Milford (USQAO)"
  },
  {
   value: "Mill City (USICI)",
   label: "Mill City (USICI)"
  },
  {
   value: "Mill Creek (USMC3)",
   label: "Mill Creek (USMC3)"
  },
  {
   value: "Mill Creek (USMKW)",
   label: "Mill Creek (USMKW)"
  },
  {
   value: "Mill Creek (USZMK)",
   label: "Mill Creek (USZMK)"
  },
  {
   value: "Mill Spring (USTMJ)",
   label: "Mill Spring (USTMJ)"
  },
  {
   value: "Mill Valley (USVYV)",
   label: "Mill Valley (USVYV)"
  },
  {
   value: "Millbrook (USZOO)",
   label: "Millbrook (USZOO)"
  },
  {
   value: "Milledgeville (USQLB)",
   label: "Milledgeville (USQLB)"
  },
  {
   value: "Millersburg (USILB)",
   label: "Millersburg (USILB)"
  },
  {
   value: "Millersburg (USMUG)",
   label: "Millersburg (USMUG)"
  },
  {
   value: "Millersport (USILR)",
   label: "Millersport (USILR)"
  },
  {
   value: "Millerstown (USQJT)",
   label: "Millerstown (USQJT)"
  },
  {
   value: "Millersville (USIIF)",
   label: "Millersville (USIIF)"
  },
  {
   value: "Millersville (USISE)",
   label: "Millersville (USISE)"
  },
  {
   value: "Millersville (USMVB)",
   label: "Millersville (USMVB)"
  },
  {
   value: "Millerton (USMT4)",
   label: "Millerton (USMT4)"
  },
  {
   value: "Millheim (USOZB)",
   label: "Millheim (USOZB)"
  },
  {
   value: "Millis (USMS2)",
   label: "Millis (USMS2)"
  },
  {
   value: "Millport (USIPR)",
   label: "Millport (USIPR)"
  },
  {
   value: "Mills (USJML)",
   label: "Mills (USJML)"
  },
  {
   value: "Millstadt (USMS7)",
   label: "Millstadt (USMS7)"
  },
  {
   value: "Millston (USISZ)",
   label: "Millston (USISZ)"
  },
  {
   value: "Millstone (USIWH)",
   label: "Millstone (USIWH)"
  },
  {
   value: "Millville (USMV2)",
   label: "Millville (USMV2)"
  },
  {
   value: "Millwood (USIOO)",
   label: "Millwood (USIOO)"
  },
  {
   value: "Millwood (USMW4)",
   label: "Millwood (USMW4)"
  },
  {
   value: "Millwood (USMW7)",
   label: "Millwood (USMW7)"
  },
  {
   value: "Millwood (USZEZ)",
   label: "Millwood (USZEZ)"
  },
  {
   value: "Milner (USMN4)",
   label: "Milner (USMN4)"
  },
  {
   value: "Milroy (USYMY)",
   label: "Milroy (USYMY)"
  },
  {
   value: "Milton (USMIC)",
   label: "Milton (USMIC)"
  },
  {
   value: "Milton (USMT5)",
   label: "Milton (USMT5)"
  },
  {
   value: "Milton (USZNM)",
   label: "Milton (USZNM)"
  },
  {
   value: "Milton Mills (USM2M)",
   label: "Milton Mills (USM2M)"
  },
  {
   value: "Milwaukie (USMWX)",
   label: "Milwaukie (USMWX)"
  },
  {
   value: "Mims (USMS6)",
   label: "Mims (USMS6)"
  },
  {
   value: "Minco (USNC7)",
   label: "Minco (USNC7)"
  },
  {
   value: "Minden (USMN6)",
   label: "Minden (USMN6)"
  },
  {
   value: "Mindoro (USDHO)",
   label: "Mindoro (USDHO)"
  },
  {
   value: "Mine Hill (USMHZ)",
   label: "Mine Hill (USMHZ)"
  },
  {
   value: "Miner (USNRZ)",
   label: "Miner (USNRZ)"
  },
  {
   value: "Mineral (USEYA)",
   label: "Mineral (USEYA)"
  },
  {
   value: "Mineral (USIEA)",
   label: "Mineral (USIEA)"
  },
  {
   value: "Mineral City (USMC4)",
   label: "Mineral City (USMC4)"
  },
  {
   value: "Mineral Point, Iowa (USMP3)",
   label: "Mineral Point, Iowa (USMP3)"
  },
  {
   value: "Mineral Springs (USIPU)",
   label: "Mineral Springs (USIPU)"
  },
  {
   value: "Mineral Wells (USIWF)",
   label: "Mineral Wells (USIWF)"
  },
  {
   value: "Mineralwells (USMW5)",
   label: "Mineralwells (USMW5)"
  },
  {
   value: "Minneapolis (USIPS)",
   label: "Minneapolis (USIPS)"
  },
  {
   value: "Minneota (USIJT)",
   label: "Minneota (USIJT)"
  },
  {
   value: "Minnie (USMX8)",
   label: "Minnie (USMX8)"
  },
  {
   value: "Minong (USWMG)",
   label: "Minong (USWMG)"
  },
  {
   value: "Minooka (USIKA)",
   label: "Minooka (USIKA)"
  },
  {
   value: "Mint Hill (USTLI)",
   label: "Mint Hill (USTLI)"
  },
  {
   value: "Minto (USQMT)",
   label: "Minto (USQMT)"
  },
  {
   value: "Mio (USMI2)",
   label: "Mio (USMI2)"
  },
  {
   value: "Miramar Beach (USIBC)",
   label: "Miramar Beach (USIBC)"
  },
  {
   value: "Miranda (USNJK)",
   label: "Miranda (USNJK)"
  },
  {
   value: "Mirror Lake (USIRL)",
   label: "Mirror Lake (USIRL)"
  },
  {
   value: "Misenheimer (USNCE)",
   label: "Misenheimer (USNCE)"
  },
  {
   value: "Mission (USZMX)",
   label: "Mission (USZMX)"
  },
  {
   value: "Missouri City (USMC5)",
   label: "Missouri City (USMC5)"
  },
  {
   value: "Missouri City (USURI)",
   label: "Missouri City (USURI)"
  },
  {
   value: "Mitchellville (USIHE)",
   label: "Mitchellville (USIHE)"
  },
  {
   value: "Mitchellville (USITX)",
   label: "Mitchellville (USITX)"
  },
  {
   value: "Moapa (USOAP)",
   label: "Moapa (USOAP)"
  },
  {
   value: "Moatsville (USVIZ)",
   label: "Moatsville (USVIZ)"
  },
  {
   value: "Mocksville (USMKV)",
   label: "Mocksville (USMKV)"
  },
  {
   value: "Moffat (USMA3)",
   label: "Moffat (USMA3)"
  },
  {
   value: "Moffett Field (USMEF)",
   label: "Moffett Field (USMEF)"
  },
  {
   value: "Mohnton (USZOH)",
   label: "Mohnton (USZOH)"
  },
  {
   value: "Mohrsville (USOH7)",
   label: "Mohrsville (USOH7)"
  },
  {
   value: "Mokena (USIMK)",
   label: "Mokena (USIMK)"
  },
  {
   value: "Mondovi (USODI)",
   label: "Mondovi (USODI)"
  },
  {
   value: "Monee (USQZE)",
   label: "Monee (USQZE)"
  },
  {
   value: "Moneta (USMQG)",
   label: "Moneta (USMQG)"
  },
  {
   value: "Monett (USTTF)",
   label: "Monett (USTTF)"
  },
  {
   value: "Monette (USQTE)",
   label: "Monette (USQTE)"
  },
  {
   value: "Money (USOES)",
   label: "Money (USOES)"
  },
  {
   value: "Monmouth (USMOH)",
   label: "Monmouth (USMOH)"
  },
  {
   value: "Monmouth (USOMH)",
   label: "Monmouth (USOMH)"
  },
  {
   value: "Monon (USOON)",
   label: "Monon (USOON)"
  },
  {
   value: "Monona (USIMO)",
   label: "Monona (USIMO)"
  },
  {
   value: "Monroe (USINQ)",
   label: "Monroe (USINQ)"
  },
  {
   value: "Monroe (USNRQ)",
   label: "Monroe (USNRQ)"
  },
  {
   value: "Monroe (USNRX)",
   label: "Monroe (USNRX)"
  },
  {
   value: "Monroe (USOVN)",
   label: "Monroe (USOVN)"
  },
  {
   value: "Monroe (USOWH)",
   label: "Monroe (USOWH)"
  },
  {
   value: "Monroe (USQMX)",
   label: "Monroe (USQMX)"
  },
  {
   value: "Monroe (USYMJ)",
   label: "Monroe (USYMJ)"
  },
  {
   value: "Monroe Township (USONR)",
   label: "Monroe Township (USONR)"
  },
  {
   value: "Monroe, Tippecanoe (USOOE)",
   label: "Monroe, Tippecanoe (USOOE)"
  },
  {
   value: "Monroeville (USVML)",
   label: "Monroeville (USVML)"
  },
  {
   value: "Monrovia (USZMR)",
   label: "Monrovia (USZMR)"
  },
  {
   value: "Monsey (USMSE)",
   label: "Monsey (USMSE)"
  },
  {
   value: "Mont Belvieu (USMTG)",
   label: "Mont Belvieu (USMTG)"
  },
  {
   value: "Mont Vernon (USTV7)",
   label: "Mont Vernon (USTV7)"
  },
  {
   value: "Montana City (USJTA)",
   label: "Montana City (USJTA)"
  },
  {
   value: "Montara (USOQT)",
   label: "Montara (USOQT)"
  },
  {
   value: "Monte Vista (USVMZ)",
   label: "Monte Vista (USVMZ)"
  },
  {
   value: "Montecito (USZMO)",
   label: "Montecito (USZMO)"
  },
  {
   value: "Montello (USOLO)",
   label: "Montello (USOLO)"
  },
  {
   value: "Monterey (USMY3)",
   label: "Monterey (USMY3)"
  },
  {
   value: "Monterey (USMZY)",
   label: "Monterey (USMZY)"
  },
  {
   value: "Montezuma (USTZM)",
   label: "Montezuma (USTZM)"
  },
  {
   value: "Montezuma (USYMZ)",
   label: "Montezuma (USYMZ)"
  },
  {
   value: "Montgomery (USMG6)",
   label: "Montgomery (USMG6)"
  },
  {
   value: "Montgomery (USNGY)",
   label: "Montgomery (USNGY)"
  },
  {
   value: "Montgomery (USOGM)",
   label: "Montgomery (USOGM)"
  },
  {
   value: "Montgomery (USOTE)",
   label: "Montgomery (USOTE)"
  },
  {
   value: "Montgomery (USQMG)",
   label: "Montgomery (USQMG)"
  },
  {
   value: "Montgomery (USYGY)",
   label: "Montgomery (USYGY)"
  },
  {
   value: "Montgomery Center (USGZY)",
   label: "Montgomery Center (USGZY)"
  },
  {
   value: "Montgomery Village (USNMV)",
   label: "Montgomery Village (USNMV)"
  },
  {
   value: "Monticello (USIEO)",
   label: "Monticello (USIEO)"
  },
  {
   value: "Monticello (USMCI)",
   label: "Monticello (USMCI)"
  },
  {
   value: "Monticello (USOIO)",
   label: "Monticello (USOIO)"
  },
  {
   value: "Monticello (USOTC)",
   label: "Monticello (USOTC)"
  },
  {
   value: "Montmorenci (USZGI)",
   label: "Montmorenci (USZGI)"
  },
  {
   value: "Montpelier (USMMP)",
   label: "Montpelier (USMMP)"
  },
  {
   value: "Montpelier (USOPQ)",
   label: "Montpelier (USOPQ)"
  },
  {
   value: "Montreal (USMT8)",
   label: "Montreal (USMT8)"
  },
  {
   value: "Montrose (USME3)",
   label: "Montrose (USME3)"
  },
  {
   value: "Montrose (USQMR)",
   label: "Montrose (USQMR)"
  },
  {
   value: "Montross (USKMX)",
   label: "Montross (USKMX)"
  },
  {
   value: "Monument Valley Gldngs (USGMV)",
   label: "Monument Valley Gldngs (USGMV)"
  },
  {
   value: "Moody (USMD7)",
   label: "Moody (USMD7)"
  },
  {
   value: "Moody (USOOY)",
   label: "Moody (USOOY)"
  },
  {
   value: "Moon (USNIP)",
   label: "Moon (USNIP)"
  },
  {
   value: "Moonachie\/New Jersey (USMOO)",
   label: "Moonachie\/New Jersey (USMOO)"
  },
  {
   value: "Moonstown (USQMP)",
   label: "Moonstown (USQMP)"
  },
  {
   value: "Moore (USOOF)",
   label: "Moore (USOOF)"
  },
  {
   value: "Moore Haven (USQMF)",
   label: "Moore Haven (USQMF)"
  },
  {
   value: "Moorefield (USMF2)",
   label: "Moorefield (USMF2)"
  },
  {
   value: "Moorefield (USMF3)",
   label: "Moorefield (USMF3)"
  },
  {
   value: "Mooreland (USOED)",
   label: "Mooreland (USOED)"
  },
  {
   value: "Mooresburg (USOUB)",
   label: "Mooresburg (USOUB)"
  },
  {
   value: "Moorestown (USOOR)",
   label: "Moorestown (USOOR)"
  },
  {
   value: "Moose Pass (USMSZ)",
   label: "Moose Pass (USMSZ)"
  },
  {
   value: "Moosup (USOOU)",
   label: "Moosup (USOOU)"
  },
  {
   value: "Mora (USMMA)",
   label: "Mora (USMMA)"
  },
  {
   value: "Moraga (USQMO)",
   label: "Moraga (USQMO)"
  },
  {
   value: "Moravia (USQOR)",
   label: "Moravia (USQOR)"
  },
  {
   value: "Moravia (USVIJ)",
   label: "Moravia (USVIJ)"
  },
  {
   value: "Moravian Falls (USMF4)",
   label: "Moravian Falls (USMF4)"
  },
  {
   value: "Morehead (USMHR)",
   label: "Morehead (USMHR)"
  },
  {
   value: "Morehouse (USYRE)",
   label: "Morehouse (USYRE)"
  },
  {
   value: "Morenci (USMQR)",
   label: "Morenci (USMQR)"
  },
  {
   value: "Morenci (USONJ)",
   label: "Morenci (USONJ)"
  },
  {
   value: "Moreno Valley (USMV4)",
   label: "Moreno Valley (USMV4)"
  },
  {
   value: "Morgan (USGGM)",
   label: "Morgan (USGGM)"
  },
  {
   value: "Morgan (USNGM)",
   label: "Morgan (USNGM)"
  },
  {
   value: "Morgan City (USLMO)",
   label: "Morgan City (USLMO)"
  },
  {
   value: "Morganfield (USQGF)",
   label: "Morganfield (USQGF)"
  },
  {
   value: "Moriches (USZH6)",
   label: "Moriches (USZH6)"
  },
  {
   value: "Moro (USOYO)",
   label: "Moro (USOYO)"
  },
  {
   value: "Morocco (USOOC)",
   label: "Morocco (USOOC)"
  },
  {
   value: "Moroni (USMR6)",
   label: "Moroni (USMR6)"
  },
  {
   value: "Morrice (USXWQ)",
   label: "Morrice (USXWQ)"
  },
  {
   value: "Morris (USMR3)",
   label: "Morris (USMR3)"
  },
  {
   value: "Morris (USMR4)",
   label: "Morris (USMR4)"
  },
  {
   value: "Morris (USXRI)",
   label: "Morris (USXRI)"
  },
  {
   value: "Morristown (USMW8)",
   label: "Morristown (USMW8)"
  },
  {
   value: "Morrisville (USORS)",
   label: "Morrisville (USORS)"
  },
  {
   value: "Morrisville (USV9)",
   label: "Morrisville (USV9)"
  },
  {
   value: "Morrisville (USXZM)",
   label: "Morrisville (USXZM)"
  },
  {
   value: "Morrow (USMW6)",
   label: "Morrow (USMW6)"
  },
  {
   value: "Morse Bluff (USMB3)",
   label: "Morse Bluff (USMB3)"
  },
  {
   value: "Morton (USJMN)",
   label: "Morton (USJMN)"
  },
  {
   value: "Morton (USZMT)",
   label: "Morton (USZMT)"
  },
  {
   value: "Moscow (USMW3)",
   label: "Moscow (USMW3)"
  },
  {
   value: "Moscow (USQMA)",
   label: "Moscow (USQMA)"
  },
  {
   value: "Moscow (USZGC)",
   label: "Moscow (USZGC)"
  },
  {
   value: "Moscow Mills (USMM4)",
   label: "Moscow Mills (USMM4)"
  },
  {
   value: "Moselle (USOEL)",
   label: "Moselle (USOEL)"
  },
  {
   value: "Moser Bay (USKMY)",
   label: "Moser Bay (USKMY)"
  },
  {
   value: "Mosheim (USEIB)",
   label: "Mosheim (USEIB)"
  },
  {
   value: "Mosier (USYMR)",
   label: "Mosier (USYMR)"
  },
  {
   value: "Mosinee (USINX)",
   label: "Mosinee (USINX)"
  },
  {
   value: "Moss Beach (USZGA)",
   label: "Moss Beach (USZGA)"
  },
  {
   value: "Mottville (USMLL)",
   label: "Mottville (USMLL)"
  },
  {
   value: "Mound (USOUD)",
   label: "Mound (USOUD)"
  },
  {
   value: "Mound House (USXZS)",
   label: "Mound House (USXZS)"
  },
  {
   value: "Mounds (USOUK)",
   label: "Mounds (USOUK)"
  },
  {
   value: "Mount Airy (USNQU)",
   label: "Mount Airy (USNQU)"
  },
  {
   value: "Mount Angel (USOMO)",
   label: "Mount Angel (USOMO)"
  },
  {
   value: "Mount Arlington (USUNM)",
   label: "Mount Arlington (USUNM)"
  },
  {
   value: "Mount Ayr (USOUA)",
   label: "Mount Ayr (USOUA)"
  },
  {
   value: "Mount Braddock (USTBK)",
   label: "Mount Braddock (USTBK)"
  },
  {
   value: "Mount Carmel (USMC6)",
   label: "Mount Carmel (USMC6)"
  },
  {
   value: "Mount Carmel (USMTK)",
   label: "Mount Carmel (USMTK)"
  },
  {
   value: "Mount Clemens (USCM5)",
   label: "Mount Clemens (USCM5)"
  },
  {
   value: "Mount Crawford (USMWR)",
   label: "Mount Crawford (USMWR)"
  },
  {
   value: "Mount Eaton (USME2)",
   label: "Mount Eaton (USME2)"
  },
  {
   value: "Mount Gilead (USUGO)",
   label: "Mount Gilead (USUGO)"
  },
  {
   value: "Mount Hebron (USTBO)",
   label: "Mount Hebron (USTBO)"
  },
  {
   value: "Mount Hermon (USNHR)",
   label: "Mount Hermon (USNHR)"
  },
  {
   value: "Mount Holly (USMH6)",
   label: "Mount Holly (USMH6)"
  },
  {
   value: "Mount Holly Springs (USQHS)",
   label: "Mount Holly Springs (USQHS)"
  },
  {
   value: "Mount Hope (USH9)",
   label: "Mount Hope (USH9)"
  },
  {
   value: "Mount Hope (USUHE)",
   label: "Mount Hope (USUHE)"
  },
  {
   value: "Mount Hope (USULZ)",
   label: "Mount Hope (USULZ)"
  },
  {
   value: "Mount Horeb (USMH4)",
   label: "Mount Horeb (USMH4)"
  },
  {
   value: "Mount Ida (USUIA)",
   label: "Mount Ida (USUIA)"
  },
  {
   value: "Mount Jewett (USOJW)",
   label: "Mount Jewett (USOJW)"
  },
  {
   value: "Mount Juliet (USMJB)",
   label: "Mount Juliet (USMJB)"
  },
  {
   value: "Mount Meigs (USOUM)",
   label: "Mount Meigs (USOUM)"
  },
  {
   value: "Mount Morris (USMMB)",
   label: "Mount Morris (USMMB)"
  },
  {
   value: "Mount Morris (USNMR)",
   label: "Mount Morris (USNMR)"
  },
  {
   value: "Mount Morris (USOUO)",
   label: "Mount Morris (USOUO)"
  },
  {
   value: "Mount Nebo (USQNB)",
   label: "Mount Nebo (USQNB)"
  },
  {
   value: "Mount Pleasant (USXPA)",
   label: "Mount Pleasant (USXPA)"
  },
  {
   value: "Mount Pleasant, Cabarrus (USUPA)",
   label: "Mount Pleasant, Cabarrus (USUPA)"
  },
  {
   value: "Mount Sterling (USGTM)",
   label: "Mount Sterling (USGTM)"
  },
  {
   value: "Mount Sterling (USYMS)",
   label: "Mount Sterling (USYMS)"
  },
  {
   value: "Mount Ulla (USOUU)",
   label: "Mount Ulla (USOUU)"
  },
  {
   value: "Mount Union, Huntingdon (USONU)",
   label: "Mount Union, Huntingdon (USONU)"
  },
  {
   value: "Mount Vernon (USM2V)",
   label: "Mount Vernon (USM2V)"
  },
  {
   value: "Mount Vernon (USMV3)",
   label: "Mount Vernon (USMV3)"
  },
  {
   value: "Mount Vernon (USOUV)",
   label: "Mount Vernon (USOUV)"
  },
  {
   value: "Mount Vernon (USUEO)",
   label: "Mount Vernon (USUEO)"
  },
  {
   value: "Mount Vernon (USUVO)",
   label: "Mount Vernon (USUVO)"
  },
  {
   value: "Mount Vernon (USYMV)",
   label: "Mount Vernon (USYMV)"
  },
  {
   value: "Mount Washington (USUMX)",
   label: "Mount Washington (USUMX)"
  },
  {
   value: "Mount Zion (USUTZ)",
   label: "Mount Zion (USUTZ)"
  },
  {
   value: "Mountain Green (USTGM)",
   label: "Mountain Green (USTGM)"
  },
  {
   value: "Mountain Grove (USVMV)",
   label: "Mountain Grove (USVMV)"
  },
  {
   value: "Mountain Iron (USUII)",
   label: "Mountain Iron (USUII)"
  },
  {
   value: "Mountain Lake (USML5)",
   label: "Mountain Lake (USML5)"
  },
  {
   value: "Mountain Lake Park (USUTK)",
   label: "Mountain Lake Park (USUTK)"
  },
  {
   value: "Mountain Lakes (USULS)",
   label: "Mountain Lakes (USULS)"
  },
  {
   value: "Mountain View (USVAJ)",
   label: "Mountain View (USVAJ)"
  },
  {
   value: "Mountainville (USHHF)",
   label: "Mountainville (USHHF)"
  },
  {
   value: "Mounts Mills (USZMM)",
   label: "Mounts Mills (USZMM)"
  },
  {
   value: "Mountville (USUTV)",
   label: "Mountville (USUTV)"
  },
  {
   value: "Mouthcard (USMC7)",
   label: "Mouthcard (USMC7)"
  },
  {
   value: "Moweaqua (USYMQ)",
   label: "Moweaqua (USYMQ)"
  },
  {
   value: "Moxee City (USXXE)",
   label: "Moxee City (USXXE)"
  },
  {
   value: "Moyie Springs (USIPG)",
   label: "Moyie Springs (USIPG)"
  },
  {
   value: "Mt Airy (USMKY)",
   label: "Mt Airy (USMKY)"
  },
  {
   value: "Mt Olive (USMQV)",
   label: "Mt Olive (USMQV)"
  },
  {
   value: "Mt Shasta (USMHS)",
   label: "Mt Shasta (USMHS)"
  },
  {
   value: "Mt Vernon (USMWT)",
   label: "Mt Vernon (USMWT)"
  },
  {
   value: "Mt Vernon (USMXV)",
   label: "Mt Vernon (USMXV)"
  },
  {
   value: "Mt Vernon, Wabash (USOVO)",
   label: "Mt Vernon, Wabash (USOVO)"
  },
  {
   value: "Mt Wilson (USMWS)",
   label: "Mt Wilson (USMWS)"
  },
  {
   value: "Mukilteo (USMKI)",
   label: "Mukilteo (USMKI)"
  },
  {
   value: "Mukwonago (USMKZ)",
   label: "Mukwonago (USMKZ)"
  },
  {
   value: "Muldrow (USZMW)",
   label: "Muldrow (USZMW)"
  },
  {
   value: "Muleshoe (USMUH)",
   label: "Muleshoe (USMUH)"
  },
  {
   value: "Mulino (USMU7)",
   label: "Mulino (USMU7)"
  },
  {
   value: "Mulliken (USRMU)",
   label: "Mulliken (USRMU)"
  },
  {
   value: "Mulvane (USVNE)",
   label: "Mulvane (USVNE)"
  },
  {
   value: "Muncie (USUNE)",
   label: "Muncie (USUNE)"
  },
  {
   value: "Munfordville (USUNF)",
   label: "Munfordville (USUNF)"
  },
  {
   value: "Munger (USUEM)",
   label: "Munger (USUEM)"
  },
  {
   value: "Munising (USMGS)",
   label: "Munising (USMGS)"
  },
  {
   value: "Munnsville (USUNV)",
   label: "Munnsville (USUNV)"
  },
  {
   value: "Murdock (USMR5)",
   label: "Murdock (USMR5)"
  },
  {
   value: "Murdock (USUDK)",
   label: "Murdock (USUDK)"
  },
  {
   value: "Murdock (USYMK)",
   label: "Murdock (USYMK)"
  },
  {
   value: "Murfreesboro (USMFU)",
   label: "Murfreesboro (USMFU)"
  },
  {
   value: "Murphy (USZMU)",
   label: "Murphy (USZMU)"
  },
  {
   value: "Murphys (USMS5)",
   label: "Murphys (USMS5)"
  },
  {
   value: "Murray (USQRU)",
   label: "Murray (USQRU)"
  },
  {
   value: "Murray Hill (USMRR)",
   label: "Murray Hill (USMRR)"
  },
  {
   value: "Murrieta (USMHQ)",
   label: "Murrieta (USMHQ)"
  },
  {
   value: "Murrysville (USXYS)",
   label: "Murrysville (USXYS)"
  },
  {
   value: "Muscle Shoals (USUSH)",
   label: "Muscle Shoals (USUSH)"
  },
  {
   value: "Muskego (USUSG)",
   label: "Muskego (USUSG)"
  },
  {
   value: "Mustang (USUMU)",
   label: "Mustang (USUMU)"
  },
  {
   value: "Myakka City (USYKC)",
   label: "Myakka City (USYKC)"
  },
  {
   value: "Myerstown (USYES)",
   label: "Myerstown (USYES)"
  },
  {
   value: "Myersville (USMV5)",
   label: "Myersville (USMV5)"
  },
  {
   value: "Myrtle Creek (USYTK)",
   label: "Myrtle Creek (USYTK)"
  },
  {
   value: "Nabb (USNJB)",
   label: "Nabb (USNJB)"
  },
  {
   value: "Naches (USYNA)",
   label: "Naches (USYNA)"
  },
  {
   value: "Nahunta (USNNH)",
   label: "Nahunta (USNNH)"
  },
  {
   value: "Nakolik River (USNOL)",
   label: "Nakolik River (USNOL)"
  },
  {
   value: "Nanticoke (USNNC)",
   label: "Nanticoke (USNNC)"
  },
  {
   value: "Nanticoke (USNNO)",
   label: "Nanticoke (USNNO)"
  },
  {
   value: "Nantucket (USACK)",
   label: "Nantucket (USACK)"
  },
  {
   value: "Nanuet (USNAE)",
   label: "Nanuet (USNAE)"
  },
  {
   value: "Napaskiak (USPKA)",
   label: "Napaskiak (USPKA)"
  },
  {
   value: "Naples (USNPJ)",
   label: "Naples (USNPJ)"
  },
  {
   value: "Naples (USNPL)",
   label: "Naples (USNPL)"
  },
  {
   value: "Nappanee (USNAI)",
   label: "Nappanee (USNAI)"
  },
  {
   value: "Narrows (USNAB)",
   label: "Narrows (USNAB)"
  },
  {
   value: "Narrowsburg (USNGB)",
   label: "Narrowsburg (USNGB)"
  },
  {
   value: "Narvon (USNVO)",
   label: "Narvon (USNVO)"
  },
  {
   value: "Nas Pensacola (USP2A)",
   label: "Nas Pensacola (USP2A)"
  },
  {
   value: "Nash (USNNB)",
   label: "Nash (USNNB)"
  },
  {
   value: "Nash, Ellis (USNHC)",
   label: "Nash, Ellis (USNHC)"
  },
  {
   value: "Nashport (USN2P)",
   label: "Nashport (USN2P)"
  },
  {
   value: "Nashville (USNAS)",
   label: "Nashville (USNAS)"
  },
  {
   value: "Nashville (USNIF)",
   label: "Nashville (USNIF)"
  },
  {
   value: "Nashville (USNJH)",
   label: "Nashville (USNJH)"
  },
  {
   value: "Nashville (USZNV)",
   label: "Nashville (USZNV)"
  },
  {
   value: "Nasonville (USNS5)",
   label: "Nasonville (USNS5)"
  },
  {
   value: "Nassau (USNYU)",
   label: "Nassau (USNYU)"
  },
  {
   value: "Natchitoches (USNTH)",
   label: "Natchitoches (USNTH)"
  },
  {
   value: "Nathrop (USN2H)",
   label: "Nathrop (USN2H)"
  },
  {
   value: "Natick (USNAK)",
   label: "Natick (USNAK)"
  },
  {
   value: "Natoma (USTJA)",
   label: "Natoma (USTJA)"
  },
  {
   value: "Natrona Heights (USNAH)",
   label: "Natrona Heights (USNAH)"
  },
  {
   value: "Natural Bridge (USNLH)",
   label: "Natural Bridge (USNLH)"
  },
  {
   value: "Nauvoo (USNAV)",
   label: "Nauvoo (USNAV)"
  },
  {
   value: "Navarre (USNVA)",
   label: "Navarre (USNVA)"
  },
  {
   value: "Navarre (USNVF)",
   label: "Navarre (USNVF)"
  },
  {
   value: "Navasota (USVSA)",
   label: "Navasota (USVSA)"
  },
  {
   value: "Nawiliwili (USNIJ)",
   label: "Nawiliwili (USNIJ)"
  },
  {
   value: "Nebo, McDowell (USEBO)",
   label: "Nebo, McDowell (USEBO)"
  },
  {
   value: "Nebraska City (USNBK)",
   label: "Nebraska City (USNBK)"
  },
  {
   value: "Necedah (USNEJ)",
   label: "Necedah (USNEJ)"
  },
  {
   value: "Needham Heights (USNDM)",
   label: "Needham Heights (USNDM)"
  },
  {
   value: "Needles (USEED)",
   label: "Needles (USEED)"
  },
  {
   value: "Needmore (USNZQ)",
   label: "Needmore (USNZQ)"
  },
  {
   value: "Needville (USNVE)",
   label: "Needville (USNVE)"
  },
  {
   value: "Negley (USNEG)",
   label: "Negley (USNEG)"
  },
  {
   value: "Neillsville (USIEW)",
   label: "Neillsville (USIEW)"
  },
  {
   value: "Nekoosa (USKOE)",
   label: "Nekoosa (USKOE)"
  },
  {
   value: "Nellis Air Force Base (USNS8)",
   label: "Nellis Air Force Base (USNS8)"
  },
  {
   value: "Nelson (USNON)",
   label: "Nelson (USNON)"
  },
  {
   value: "Nelson (USNZL)",
   label: "Nelson (USNZL)"
  },
  {
   value: "Nelson (USQNL)",
   label: "Nelson (USQNL)"
  },
  {
   value: "Nelson (USQSO)",
   label: "Nelson (USQSO)"
  },
  {
   value: "Nelsonville, Portage (USNSJ)",
   label: "Nelsonville, Portage (USNSJ)"
  },
  {
   value: "Nemo (USNKM)",
   label: "Nemo (USNKM)"
  },
  {
   value: "Neodesha (USNDA)",
   label: "Neodesha (USNDA)"
  },
  {
   value: "Nephi (USNPH)",
   label: "Nephi (USNPH)"
  },
  {
   value: "Neptune Beach (USNPB)",
   label: "Neptune Beach (USNPB)"
  },
  {
   value: "Nerstrand (USOZX)",
   label: "Nerstrand (USOZX)"
  },
  {
   value: "Nesbit (USNXZ)",
   label: "Nesbit (USNXZ)"
  },
  {
   value: "Nesmith (USNZT)",
   label: "Nesmith (USNZT)"
  },
  {
   value: "Ness City (USNCJ)",
   label: "Ness City (USNCJ)"
  },
  {
   value: "Nevada (USNVN)",
   label: "Nevada (USNVN)"
  },
  {
   value: "Nevada (USNVT)",
   label: "Nevada (USNVT)"
  },
  {
   value: "New Castle (USNSX)",
   label: "New Castle (USNSX)"
  },
  {
   value: "New Albany (USNJA)",
   label: "New Albany (USNJA)"
  },
  {
   value: "New Albany (USQWB)",
   label: "New Albany (USQWB)"
  },
  {
   value: "New Augusta (USNA2)",
   label: "New Augusta (USNA2)"
  },
  {
   value: "New Baltimore (USNB8)",
   label: "New Baltimore (USNB8)"
  },
  {
   value: "New Bedford (USEFC)",
   label: "New Bedford (USEFC)"
  },
  {
   value: "New Bedford (USNBD)",
   label: "New Bedford (USNBD)"
  },
  {
   value: "New Bethlehem (USNEH)",
   label: "New Bethlehem (USNEH)"
  },
  {
   value: "New Bloomfield (USNBL)",
   label: "New Bloomfield (USNBL)"
  },
  {
   value: "New Boston (USNBW)",
   label: "New Boston (USNBW)"
  },
  {
   value: "New Britain (USNXB)",
   label: "New Britain (USNXB)"
  },
  {
   value: "New Buffalo (USNB6)",
   label: "New Buffalo (USNB6)"
  },
  {
   value: "New Caney (USNCY)",
   label: "New Caney (USNCY)"
  },
  {
   value: "New Carlisle (USNC3)",
   label: "New Carlisle (USNC3)"
  },
  {
   value: "New Carlisle (USNER)",
   label: "New Carlisle (USNER)"
  },
  {
   value: "New Carrollton (USNCA)",
   label: "New Carrollton (USNCA)"
  },
  {
   value: "New Century (USNXC)",
   label: "New Century (USNXC)"
  },
  {
   value: "New Church (USNUH)",
   label: "New Church (USNUH)"
  },
  {
   value: "New City (USNJY)",
   label: "New City (USNJY)"
  },
  {
   value: "New Columbia (USZWC)",
   label: "New Columbia (USZWC)"
  },
  {
   value: "New Concord (USONZ)",
   label: "New Concord (USONZ)"
  },
  {
   value: "New Connecticut (USCN6)",
   label: "New Connecticut (USCN6)"
  },
  {
   value: "New Cumberland (USNCU)",
   label: "New Cumberland (USNCU)"
  },
  {
   value: "New Cuyama (USNYV)",
   label: "New Cuyama (USNYV)"
  },
  {
   value: "New Ellenton (USNZC)",
   label: "New Ellenton (USNZC)"
  },
  {
   value: "New Florence (USNFO)",
   label: "New Florence (USNFO)"
  },
  {
   value: "New Florence (USNFQ)",
   label: "New Florence (USNFQ)"
  },
  {
   value: "New Franken (USNFN)",
   label: "New Franken (USNFN)"
  },
  {
   value: "New Franklin (USNFG)",
   label: "New Franklin (USNFG)"
  },
  {
   value: "New Freedom (USNFR)",
   label: "New Freedom (USNFR)"
  },
  {
   value: "New Galilee (USIWG)",
   label: "New Galilee (USIWG)"
  },
  {
   value: "New Geneva (USNG8)",
   label: "New Geneva (USNG8)"
  },
  {
   value: "New Glarus (USNXS)",
   label: "New Glarus (USNXS)"
  },
  {
   value: "New Hampshire (USEHH)",
   label: "New Hampshire (USEHH)"
  },
  {
   value: "New Harmony (USNJM)",
   label: "New Harmony (USNJM)"
  },
  {
   value: "New Hartford (USQND)",
   label: "New Hartford (USQND)"
  },
  {
   value: "New Haven (USNEV)",
   label: "New Haven (USNEV)"
  },
  {
   value: "New Haven (USNH2)",
   label: "New Haven (USNH2)"
  },
  {
   value: "New Haven (USNH3)",
   label: "New Haven (USNH3)"
  },
  {
   value: "New Haven (USYNH)",
   label: "New Haven (USYNH)"
  },
  {
   value: "New Hill (USNHJ)",
   label: "New Hill (USNHJ)"
  },
  {
   value: "New Hudson (USNHN)",
   label: "New Hudson (USNHN)"
  },
  {
   value: "New Ipswich (USQNN)",
   label: "New Ipswich (USQNN)"
  },
  {
   value: "New Kingston (USNKG)",
   label: "New Kingston (USNKG)"
  },
  {
   value: "New Koliganek (USKGK)",
   label: "New Koliganek (USKGK)"
  },
  {
   value: "New Lenox (USNOX)",
   label: "New Lenox (USNOX)"
  },
  {
   value: "New Lexington (USNLX)",
   label: "New Lexington (USNLX)"
  },
  {
   value: "New Liberty (USNLR)",
   label: "New Liberty (USNLR)"
  },
  {
   value: "New Lisbon (USNLI)",
   label: "New Lisbon (USNLI)"
  },
  {
   value: "New London (USNED)",
   label: "New London (USNED)"
  },
  {
   value: "New London (USNLO)",
   label: "New London (USNLO)"
  },
  {
   value: "New London (USNML)",
   label: "New London (USNML)"
  },
  {
   value: "New London (USNXA)",
   label: "New London (USNXA)"
  },
  {
   value: "New Londonderry (USNL2)",
   label: "New Londonderry (USNL2)"
  },
  {
   value: "New Madrid (USXNW)",
   label: "New Madrid (USXNW)"
  },
  {
   value: "New Market (USNJP)",
   label: "New Market (USNJP)"
  },
  {
   value: "New Market (USNMT)",
   label: "New Market (USNMT)"
  },
  {
   value: "New Martinsville (USNM2)",
   label: "New Martinsville (USNM2)"
  },
  {
   value: "New Melle (USNZE)",
   label: "New Melle (USNZE)"
  },
  {
   value: "New Miami (USNMI)",
   label: "New Miami (USNMI)"
  },
  {
   value: "New Middletown (USNM3)",
   label: "New Middletown (USNM3)"
  },
  {
   value: "New Milford (USNMD)",
   label: "New Milford (USNMD)"
  },
  {
   value: "New Paltz (USNEZ)",
   label: "New Paltz (USNEZ)"
  },
  {
   value: "New Paris (USNPI)",
   label: "New Paris (USNPI)"
  },
  {
   value: "New Plymouth (USZGX)",
   label: "New Plymouth (USZGX)"
  },
  {
   value: "New Point (USQZN)",
   label: "New Point (USQZN)"
  },
  {
   value: "New Preston (USNP2)",
   label: "New Preston (USNP2)"
  },
  {
   value: "New Prospect (USNPS)",
   label: "New Prospect (USNPS)"
  },
  {
   value: "New Providence (USNPG)",
   label: "New Providence (USNPG)"
  },
  {
   value: "New Providence (USNPX)",
   label: "New Providence (USNPX)"
  },
  {
   value: "New Providence (USNVC)",
   label: "New Providence (USNVC)"
  },
  {
   value: "New River (USNZR)",
   label: "New River (USNZR)"
  },
  {
   value: "New Salem (USNQY)",
   label: "New Salem (USNQY)"
  },
  {
   value: "New Salem (USNWS)",
   label: "New Salem (USNWS)"
  },
  {
   value: "New Salisbury (USNS2)",
   label: "New Salisbury (USNS2)"
  },
  {
   value: "New Sharon (USNNZ)",
   label: "New Sharon (USNNZ)"
  },
  {
   value: "New Smyrna Beach (USNSB)",
   label: "New Smyrna Beach (USNSB)"
  },
  {
   value: "New Strawn (USNRW)",
   label: "New Strawn (USNRW)"
  },
  {
   value: "New Stuyahok (USKNW)",
   label: "New Stuyahok (USKNW)"
  },
  {
   value: "New Summerfield (USNUF)",
   label: "New Summerfield (USNUF)"
  },
  {
   value: "New Vernon (USN2V)",
   label: "New Vernon (USN2V)"
  },
  {
   value: "New Vienna (USQIA)",
   label: "New Vienna (USQIA)"
  },
  {
   value: "New Virginia (USEUV)",
   label: "New Virginia (USEUV)"
  },
  {
   value: "New Washington (USNYW)",
   label: "New Washington (USNYW)"
  },
  {
   value: "New Waterford (USERF)",
   label: "New Waterford (USERF)"
  },
  {
   value: "New Weston (USNWQ)",
   label: "New Weston (USNWQ)"
  },
  {
   value: "New Wilmington (USNEU)",
   label: "New Wilmington (USNEU)"
  },
  {
   value: "New York Mills (USZ2E)",
   label: "New York Mills (USZ2E)"
  },
  {
   value: "Newark (USNRK)",
   label: "Newark (USNRK)"
  },
  {
   value: "Newark (USZNA)",
   label: "Newark (USZNA)"
  },
  {
   value: "Newaygo (USNWO)",
   label: "Newaygo (USNWO)"
  },
  {
   value: "Newburg (USNB7)",
   label: "Newburg (USNB7)"
  },
  {
   value: "Newbury (USZGK)",
   label: "Newbury (USZGK)"
  },
  {
   value: "Newburyport (USZMP)",
   label: "Newburyport (USZMP)"
  },
  {
   value: "Newcastle (USAWS)",
   label: "Newcastle (USAWS)"
  },
  {
   value: "Newcastle (USECS)",
   label: "Newcastle (USECS)"
  },
  {
   value: "Newcastle (USYNC)",
   label: "Newcastle (USYNC)"
  },
  {
   value: "Newcomb (USNCB)",
   label: "Newcomb (USNCB)"
  },
  {
   value: "Newellton (USNLT)",
   label: "Newellton (USNLT)"
  },
  {
   value: "Newfane (USNFE)",
   label: "Newfane (USNFE)"
  },
  {
   value: "Newfield (USNFD)",
   label: "Newfield (USNFD)"
  },
  {
   value: "Newfields (USNEI)",
   label: "Newfields (USNEI)"
  },
  {
   value: "Newman Grove (USNAG)",
   label: "Newman Grove (USNAG)"
  },
  {
   value: "Newman Lake (USNL7)",
   label: "Newman Lake (USNL7)"
  },
  {
   value: "Newmanstown (USUWN)",
   label: "Newmanstown (USUWN)"
  },
  {
   value: "Newport (USNEP)",
   label: "Newport (USNEP)"
  },
  {
   value: "Newport (USNOZ)",
   label: "Newport (USNOZ)"
  },
  {
   value: "Newport (USNP4)",
   label: "Newport (USNP4)"
  },
  {
   value: "Newport (USZNP)",
   label: "Newport (USZNP)"
  },
  {
   value: "Newport News (USNNS)",
   label: "Newport News (USNNS)"
  },
  {
   value: "Newport, Perry (USNRP)",
   label: "Newport, Perry (USNRP)"
  },
  {
   value: "Newportville (USQNE)",
   label: "Newportville (USQNE)"
  },
  {
   value: "Newry (USNQR)",
   label: "Newry (USNQR)"
  },
  {
   value: "Newton (USNEO)",
   label: "Newton (USNEO)"
  },
  {
   value: "Newton (USNTM)",
   label: "Newton (USNTM)"
  },
  {
   value: "Newton (USNWU)",
   label: "Newton (USNWU)"
  },
  {
   value: "Newton (USNXW)",
   label: "Newton (USNXW)"
  },
  {
   value: "Newton Falls (USNFS)",
   label: "Newton Falls (USNFS)"
  },
  {
   value: "Newton Falls (USZNF)",
   label: "Newton Falls (USZNF)"
  },
  {
   value: "Newton Grove (USNGV)",
   label: "Newton Grove (USNGV)"
  },
  {
   value: "Newton Highlands (USTGX)",
   label: "Newton Highlands (USTGX)"
  },
  {
   value: "Newtonville (USNNF)",
   label: "Newtonville (USNNF)"
  },
  {
   value: "Newtown (USUOU)",
   label: "Newtown (USUOU)"
  },
  {
   value: "Newville (USZNE)",
   label: "Newville (USZNE)"
  },
  {
   value: "Nezperce (USNZP)",
   label: "Nezperce (USNZP)"
  },
  {
   value: "Niangua (USNZU)",
   label: "Niangua (USNZU)"
  },
  {
   value: "Niantic (USNII)",
   label: "Niantic (USNII)"
  },
  {
   value: "Niblack (USNIE)",
   label: "Niblack (USNIE)"
  },
  {
   value: "Nicholls (USICH)",
   label: "Nicholls (USICH)"
  },
  {
   value: "Nichols (USIHU)",
   label: "Nichols (USIHU)"
  },
  {
   value: "Nichols, Tioga (USNS3)",
   label: "Nichols, Tioga (USNS3)"
  },
  {
   value: "Nightmute (USNME)",
   label: "Nightmute (USNME)"
  },
  {
   value: "Nikiski (USNIK)",
   label: "Nikiski (USNIK)"
  },
  {
   value: "Nikolai (USNIB)",
   label: "Nikolai (USNIB)"
  },
  {
   value: "Nikolski (USIKO)",
   label: "Nikolski (USIKO)"
  },
  {
   value: "Ninety Six (USNIY)",
   label: "Ninety Six (USNIY)"
  },
  {
   value: "Niota (USNIA)",
   label: "Niota (USNIA)"
  },
  {
   value: "Nipton (USNP5)",
   label: "Nipton (USNP5)"
  },
  {
   value: "Niwot (USN2W)",
   label: "Niwot (USN2W)"
  },
  {
   value: "Nixon (USNIX)",
   label: "Nixon (USNIX)"
  },
  {
   value: "Noble (USOBL)",
   label: "Noble (USOBL)"
  },
  {
   value: "Nokesville (USQNV)",
   label: "Nokesville (USQNV)"
  },
  {
   value: "Nolan (USNLZ)",
   label: "Nolan (USNLZ)"
  },
  {
   value: "Nolanville (USNVX)",
   label: "Nolanville (USNVX)"
  },
  {
   value: "Nooksack (USKKE)",
   label: "Nooksack (USKKE)"
  },
  {
   value: "Noorvik (USORV)",
   label: "Noorvik (USORV)"
  },
  {
   value: "Nora Springs (USOIU)",
   label: "Nora Springs (USOIU)"
  },
  {
   value: "Norcross (USNCX)",
   label: "Norcross (USNCX)"
  },
  {
   value: "Norfolk (USNFF)",
   label: "Norfolk (USNFF)"
  },
  {
   value: "Norfolk (USNFJ)",
   label: "Norfolk (USNFJ)"
  },
  {
   value: "Norfolk (USNFK)",
   label: "Norfolk (USNFK)"
  },
  {
   value: "Norfork (USOOJ)",
   label: "Norfork (USOOJ)"
  },
  {
   value: "Normal (USNOM)",
   label: "Normal (USNOM)"
  },
  {
   value: "Norman (USNMN)",
   label: "Norman (USNMN)"
  },
  {
   value: "Normangee (USNMG)",
   label: "Normangee (USNMG)"
  },
  {
   value: "Norridge (USNRF)",
   label: "Norridge (USNRF)"
  },
  {
   value: "Norridgewock (USOWK)",
   label: "Norridgewock (USOWK)"
  },
  {
   value: "Norris (USOZS)",
   label: "Norris (USOZS)"
  },
  {
   value: "North Abington (USNAA)",
   label: "North Abington (USNAA)"
  },
  {
   value: "North Anson (USNHS)",
   label: "North Anson (USNHS)"
  },
  {
   value: "North Arab (USJRB)",
   label: "North Arab (USJRB)"
  },
  {
   value: "North Augusta (USNAU)",
   label: "North Augusta (USNAU)"
  },
  {
   value: "North Aurora (USNOA)",
   label: "North Aurora (USNOA)"
  },
  {
   value: "North Baltimore (USNBH)",
   label: "North Baltimore (USNBH)"
  },
  {
   value: "North Bay Shore (USNBV)",
   label: "North Bay Shore (USNBV)"
  },
  {
   value: "North Bellmore (USNLM)",
   label: "North Bellmore (USNLM)"
  },
  {
   value: "North Bend (USNID)",
   label: "North Bend (USNID)"
  },
  {
   value: "North Bend (USNND)",
   label: "North Bend (USNND)"
  },
  {
   value: "North Bend (USNOB)",
   label: "North Bend (USNOB)"
  },
  {
   value: "North Bennington (USNTB)",
   label: "North Bennington (USNTB)"
  },
  {
   value: "North Bethesda (USTDJ)",
   label: "North Bethesda (USTDJ)"
  },
  {
   value: "North Bloomfield (USRTM)",
   label: "North Bloomfield (USRTM)"
  },
  {
   value: "North Branch (USFHB)",
   label: "North Branch (USFHB)"
  },
  {
   value: "North Brookfield (USNBP)",
   label: "North Brookfield (USNBP)"
  },
  {
   value: "North Canton (USNQN)",
   label: "North Canton (USNQN)"
  },
  {
   value: "North Charlotte (USNCH)",
   label: "North Charlotte (USNCH)"
  },
  {
   value: "North Chelmsford (USNCF)",
   label: "North Chelmsford (USNCF)"
  },
  {
   value: "North Collins (USNRN)",
   label: "North Collins (USNRN)"
  },
  {
   value: "North East (USNAP)",
   label: "North East (USNAP)"
  },
  {
   value: "North East (USNTE)",
   label: "North East (USNTE)"
  },
  {
   value: "North Falmouth (USNFH)",
   label: "North Falmouth (USNFH)"
  },
  {
   value: "North Franklin (USTFA)",
   label: "North Franklin (USTFA)"
  },
  {
   value: "North Freedom (USNFW)",
   label: "North Freedom (USNFW)"
  },
  {
   value: "North Grosvenor Dale (USZGN)",
   label: "North Grosvenor Dale (USZGN)"
  },
  {
   value: "North Hampton (USJNH)",
   label: "North Hampton (USJNH)"
  },
  {
   value: "North Hartland (USNHQ)",
   label: "North Hartland (USNHQ)"
  },
  {
   value: "North Hills (USNHH)",
   label: "North Hills (USNHH)"
  },
  {
   value: "North Jackson (USNJ2)",
   label: "North Jackson (USNJ2)"
  },
  {
   value: "North Java (USJVA)",
   label: "North Java (USJVA)"
  },
  {
   value: "North Judson (USIVJ)",
   label: "North Judson (USIVJ)"
  },
  {
   value: "North Kingsville (USNKE)",
   label: "North Kingsville (USNKE)"
  },
  {
   value: "North Las Vegas (USNVS)",
   label: "North Las Vegas (USNVS)"
  },
  {
   value: "North Lawrence (USNLB)",
   label: "North Lawrence (USNLB)"
  },
  {
   value: "North Liberty (USNRY)",
   label: "North Liberty (USNRY)"
  },
  {
   value: "North Lima (USNLA)",
   label: "North Lima (USNLA)"
  },
  {
   value: "North Logan (USNOJ)",
   label: "North Logan (USNOJ)"
  },
  {
   value: "North Long Beach (USNL3)",
   label: "North Long Beach (USNL3)"
  },
  {
   value: "North Manchester (USNOS)",
   label: "North Manchester (USNOS)"
  },
  {
   value: "North Mankato (USNKA)",
   label: "North Mankato (USNKA)"
  },
  {
   value: "North Miami (USQNM)",
   label: "North Miami (USQNM)"
  },
  {
   value: "North Miami Beach (USZGV)",
   label: "North Miami Beach (USZGV)"
  },
  {
   value: "North Myrtle Beach (USNMB)",
   label: "North Myrtle Beach (USNMB)"
  },
  {
   value: "North Oxford (USNO2)",
   label: "North Oxford (USNO2)"
  },
  {
   value: "North Palm Beach (USPBN)",
   label: "North Palm Beach (USPBN)"
  },
  {
   value: "North Palm Springs (USRTP)",
   label: "North Palm Springs (USRTP)"
  },
  {
   value: "North Pembroke (USNMP)",
   label: "North Pembroke (USNMP)"
  },
  {
   value: "North Port (USNHF)",
   label: "North Port (USNHF)"
  },
  {
   value: "North Potomac (USNPZ)",
   label: "North Potomac (USNPZ)"
  },
  {
   value: "North Powder (USNDH)",
   label: "North Powder (USNDH)"
  },
  {
   value: "North Providence (USNP3)",
   label: "North Providence (USNP3)"
  },
  {
   value: "North Randall (USXRO)",
   label: "North Randall (USXRO)"
  },
  {
   value: "North River (USOIR)",
   label: "North River (USOIR)"
  },
  {
   value: "North Riverside (USNRU)",
   label: "North Riverside (USNRU)"
  },
  {
   value: "North Rose (USNQZ)",
   label: "North Rose (USNQZ)"
  },
  {
   value: "North Royalton (USZNR)",
   label: "North Royalton (USZNR)"
  },
  {
   value: "North Santee (USNSA)",
   label: "North Santee (USNSA)"
  },
  {
   value: "North Sioux City (USNSC)",
   label: "North Sioux City (USNSC)"
  },
  {
   value: "North Springfield (USNSP)",
   label: "North Springfield (USNSP)"
  },
  {
   value: "North Stonington (USNO3)",
   label: "North Stonington (USNO3)"
  },
  {
   value: "North Tazewell (USNTZ)",
   label: "North Tazewell (USNTZ)"
  },
  {
   value: "North Truro (USM2N)",
   label: "North Truro (USM2N)"
  },
  {
   value: "North Versailles (USZJY)",
   label: "North Versailles (USZJY)"
  },
  {
   value: "North Wales (USNFT)",
   label: "North Wales (USNFT)"
  },
  {
   value: "North White Plains (USNXU)",
   label: "North White Plains (USNXU)"
  },
  {
   value: "North Wildwood (USNW2)",
   label: "North Wildwood (USNW2)"
  },
  {
   value: "North Windham (USNVJ)",
   label: "North Windham (USNVJ)"
  },
  {
   value: "North Windham (USNW3)",
   label: "North Windham (USNW3)"
  },
  {
   value: "North Woodstock (USYNO)",
   label: "North Woodstock (USYNO)"
  },
  {
   value: "Northampton (USQNH)",
   label: "Northampton (USQNH)"
  },
  {
   value: "Northern Cambria (USEJB)",
   label: "Northern Cambria (USEJB)"
  },
  {
   value: "Northfield (USNHL)",
   label: "Northfield (USNHL)"
  },
  {
   value: "Northfield (USNTF)",
   label: "Northfield (USNTF)"
  },
  {
   value: "Northford (USNT2)",
   label: "Northford (USNT2)"
  },
  {
   value: "Northport (USNHP)",
   label: "Northport (USNHP)"
  },
  {
   value: "Northport (USZZH)",
   label: "Northport (USZZH)"
  },
  {
   value: "Northville (USNTV)",
   label: "Northville (USNTV)"
  },
  {
   value: "Northway (USORT)",
   label: "Northway (USORT)"
  },
  {
   value: "Northwood (USNZD)",
   label: "Northwood (USNZD)"
  },
  {
   value: "Northwood, Logan (USNW4)",
   label: "Northwood, Logan (USNW4)"
  },
  {
   value: "Northwood, Wood (USNHW)",
   label: "Northwood, Wood (USNHW)"
  },
  {
   value: "Norton (USNOG)",
   label: "Norton (USNOG)"
  },
  {
   value: "Norton (USNT8)",
   label: "Norton (USNT8)"
  },
  {
   value: "Norton Shores (USNTR)",
   label: "Norton Shores (USNTR)"
  },
  {
   value: "Norton, Summit (USNNU)",
   label: "Norton, Summit (USNNU)"
  },
  {
   value: "Nortonville (USNV2)",
   label: "Nortonville (USNV2)"
  },
  {
   value: "Norway (USNJO)",
   label: "Norway (USNJO)"
  },
  {
   value: "Norway (USNZO)",
   label: "Norway (USNZO)"
  },
  {
   value: "Norwell (USNOW)",
   label: "Norwell (USNOW)"
  },
  {
   value: "Norwich (USNQW)",
   label: "Norwich (USNQW)"
  },
  {
   value: "Norwood (USYNW)",
   label: "Norwood (USYNW)"
  },
  {
   value: "Norwood (USZNO)",
   label: "Norwood (USZNO)"
  },
  {
   value: "Novelty (USOVV)",
   label: "Novelty (USOVV)"
  },
  {
   value: "Novelty (USZGW)",
   label: "Novelty (USZGW)"
  },
  {
   value: "Noxapater (USNXP)",
   label: "Noxapater (USNXP)"
  },
  {
   value: "Nuevo (USNUE)",
   label: "Nuevo (USNUE)"
  },
  {
   value: "Nuiqsut (USNUI)",
   label: "Nuiqsut (USNUI)"
  },
  {
   value: "Nulato (USNUL)",
   label: "Nulato (USNUL)"
  },
  {
   value: "Nunapitchuk (USNUP)",
   label: "Nunapitchuk (USNUP)"
  },
  {
   value: "Nunn (USVUN)",
   label: "Nunn (USVUN)"
  },
  {
   value: "Nunnelly (USNLL)",
   label: "Nunnelly (USNLL)"
  },
  {
   value: "Nyac (USZNC)",
   label: "Nyac (USZNC)"
  },
  {
   value: "Oak Bluffs (USOB2)",
   label: "Oak Bluffs (USOB2)"
  },
  {
   value: "Oak Grove (USOGR)",
   label: "Oak Grove (USOGR)"
  },
  {
   value: "Oak Grove (USQOG)",
   label: "Oak Grove (USQOG)"
  },
  {
   value: "Oak Hill (USOAH)",
   label: "Oak Hill (USOAH)"
  },
  {
   value: "Oak Hill, Fairfax (USOAV)",
   label: "Oak Hill, Fairfax (USOAV)"
  },
  {
   value: "Oak Hill, Pittsylvania (USOHL)",
   label: "Oak Hill, Pittsylvania (USOHL)"
  },
  {
   value: "Oak Island (USOAI)",
   label: "Oak Island (USOAI)"
  },
  {
   value: "Oak Park (USQOP)",
   label: "Oak Park (USQOP)"
  },
  {
   value: "Oak Park Heights (USOPJ)",
   label: "Oak Park Heights (USOPJ)"
  },
  {
   value: "Oak Park, Oakland (USOPC)",
   label: "Oak Park, Oakland (USOPC)"
  },
  {
   value: "Oak Point (USKOI)",
   label: "Oak Point (USKOI)"
  },
  {
   value: "Oak View (USOFW)",
   label: "Oak View (USOFW)"
  },
  {
   value: "Oakboro (USYOB)",
   label: "Oakboro (USYOB)"
  },
  {
   value: "Oakbrook Terrace (USOT2)",
   label: "Oakbrook Terrace (USOT2)"
  },
  {
   value: "Oakdale (USODH)",
   label: "Oakdale (USODH)"
  },
  {
   value: "Oakdale (USOKE)",
   label: "Oakdale (USOKE)"
  },
  {
   value: "Oakdale (USOQD)",
   label: "Oakdale (USOQD)"
  },
  {
   value: "Oakdale, Morgan (USODD)",
   label: "Oakdale, Morgan (USODD)"
  },
  {
   value: "Oakesdale (USKSE)",
   label: "Oakesdale (USKSE)"
  },
  {
   value: "Oakfield (USKFL)",
   label: "Oakfield (USKFL)"
  },
  {
   value: "Oakhurst (USOHU)",
   label: "Oakhurst (USOHU)"
  },
  {
   value: "Oakland (USKND)",
   label: "Oakland (USKND)"
  },
  {
   value: "Oakland (USOBT)",
   label: "Oakland (USOBT)"
  },
  {
   value: "Oakland (USOQA)",
   label: "Oakland (USOQA)"
  },
  {
   value: "Oakland (USOUF)",
   label: "Oakland (USOUF)"
  },
  {
   value: "Oakland (USZ2G)",
   label: "Oakland (USZ2G)"
  },
  {
   value: "Oakland City (USZOC)",
   label: "Oakland City (USZOC)"
  },
  {
   value: "Oakland Mills (USOXK)",
   label: "Oakland Mills (USOXK)"
  },
  {
   value: "Oakland Park, Broward (USOP2)",
   label: "Oakland Park, Broward (USOP2)"
  },
  {
   value: "Oakland, Fayette (USKAD)",
   label: "Oakland, Fayette (USKAD)"
  },
  {
   value: "Oakley (USKLY)",
   label: "Oakley (USKLY)"
  },
  {
   value: "Oakley (USOK8)",
   label: "Oakley (USOK8)"
  },
  {
   value: "Oaks (USOAS)",
   label: "Oaks (USOAS)"
  },
  {
   value: "Oakton (USOKU)",
   label: "Oakton (USOKU)"
  },
  {
   value: "Oaktown (USOTN)",
   label: "Oaktown (USOTN)"
  },
  {
   value: "Oakville (USOKV)",
   label: "Oakville (USOKV)"
  },
  {
   value: "Oakville (USOVY)",
   label: "Oakville (USOVY)"
  },
  {
   value: "Oakwood (USO2A)",
   label: "Oakwood (USO2A)"
  },
  {
   value: "Oakwood Village (USZOV)",
   label: "Oakwood Village (USZOV)"
  },
  {
   value: "Oakwood, Buchanan (USOAW)",
   label: "Oakwood, Buchanan (USOAW)"
  },
  {
   value: "Oakwood, Oakland (USOWU)",
   label: "Oakwood, Oakland (USOWU)"
  },
  {
   value: "Oakwood, Paulding (USOKG)",
   label: "Oakwood, Paulding (USOKG)"
  },
  {
   value: "Oberlin (USXOR)",
   label: "Oberlin (USXOR)"
  },
  {
   value: "Obion (USOBI)",
   label: "Obion (USOBI)"
  },
  {
   value: "Ocean Beach (USOB3)",
   label: "Ocean Beach (USOB3)"
  },
  {
   value: "Ocean City (USOEC)",
   label: "Ocean City (USOEC)"
  },
  {
   value: "Ocean Gate (USOAM)",
   label: "Ocean Gate (USOAM)"
  },
  {
   value: "Ocean Isle Beach (USOBH)",
   label: "Ocean Isle Beach (USOBH)"
  },
  {
   value: "Ocean Reef (USOCA)",
   label: "Ocean Reef (USOCA)"
  },
  {
   value: "Ocean Springs (USOSP)",
   label: "Ocean Springs (USOSP)"
  },
  {
   value: "Ocean View (USOIW)",
   label: "Ocean View (USOIW)"
  },
  {
   value: "Oceana (USNTU)",
   label: "Oceana (USNTU)"
  },
  {
   value: "Oceanic (USOCI)",
   label: "Oceanic (USOCI)"
  },
  {
   value: "Oceanport (USOCP)",
   label: "Oceanport (USOCP)"
  },
  {
   value: "Oceanview (USOC5)",
   label: "Oceanview (USOC5)"
  },
  {
   value: "Oceanway (USONW)",
   label: "Oceanway (USONW)"
  },
  {
   value: "Ocoee (USOCM)",
   label: "Ocoee (USOCM)"
  },
  {
   value: "Ocoee, Polk (USOZE)",
   label: "Ocoee, Polk (USOZE)"
  },
  {
   value: "Oconto (USOCQ)",
   label: "Oconto (USOCQ)"
  },
  {
   value: "Odell (USODE)",
   label: "Odell (USODE)"
  },
  {
   value: "Odem (USODM)",
   label: "Odem (USODM)"
  },
  {
   value: "Odenville (USQOD)",
   label: "Odenville (USQOD)"
  },
  {
   value: "Odessa (USODG)",
   label: "Odessa (USODG)"
  },
  {
   value: "Odessa (USODS)",
   label: "Odessa (USODS)"
  },
  {
   value: "Odessa (USZGY)",
   label: "Odessa (USZGY)"
  },
  {
   value: "Odessa (USZOA)",
   label: "Odessa (USZOA)"
  },
  {
   value: "Odon (USQVJ)",
   label: "Odon (USQVJ)"
  },
  {
   value: "Offutt (USOF8)",
   label: "Offutt (USOF8)"
  },
  {
   value: "Ogden (USOGO)",
   label: "Ogden (USOGO)"
  },
  {
   value: "Ogden (USOGZ)",
   label: "Ogden (USOGZ)"
  },
  {
   value: "Ogdensburg (USOGU)",
   label: "Ogdensburg (USOGU)"
  },
  {
   value: "Ogilvie (USOGF)",
   label: "Ogilvie (USOGF)"
  },
  {
   value: "Oglesby (USOGY)",
   label: "Oglesby (USOGY)"
  },
  {
   value: "Ogunquit (USYOQ)",
   label: "Ogunquit (USYOQ)"
  },
  {
   value: "Ohatchee (USOHH)",
   label: "Ohatchee (USOHH)"
  },
  {
   value: "Ohio (USOHB)",
   label: "Ohio (USOHB)"
  },
  {
   value: "Ohio City (USZE2)",
   label: "Ohio City (USZE2)"
  },
  {
   value: "Ohiopyle (USOHY)",
   label: "Ohiopyle (USOHY)"
  },
  {
   value: "Ohioview (USOHV)",
   label: "Ohioview (USOHV)"
  },
  {
   value: "Oil City (USOTY)",
   label: "Oil City (USOTY)"
  },
  {
   value: "Oilton (USITB)",
   label: "Oilton (USITB)"
  },
  {
   value: "Oilville (USOVB)",
   label: "Oilville (USOVB)"
  },
  {
   value: "Ojai (USOJA)",
   label: "Ojai (USOJA)"
  },
  {
   value: "Okarche (USZHE)",
   label: "Okarche (USZHE)"
  },
  {
   value: "Okeana (USOZU)",
   label: "Okeana (USOZU)"
  },
  {
   value: "Okeechobee (USOKB)",
   label: "Okeechobee (USOKB)"
  },
  {
   value: "Okemah (USOMJ)",
   label: "Okemah (USOMJ)"
  },
  {
   value: "Okemos (USOKX)",
   label: "Okemos (USOKX)"
  },
  {
   value: "Oklahoma (USOKO)",
   label: "Oklahoma (USOKO)"
  },
  {
   value: "Okolona (USOKZ)",
   label: "Okolona (USOKZ)"
  },
  {
   value: "Olancha (USZE3)",
   label: "Olancha (USZE3)"
  },
  {
   value: "Olanta (USOXT)",
   label: "Olanta (USOXT)"
  },
  {
   value: "Olathia (USOHA)",
   label: "Olathia (USOHA)"
  },
  {
   value: "Old Bethpage (USOPG)",
   label: "Old Bethpage (USOPG)"
  },
  {
   value: "Old Fort (USOFT)",
   label: "Old Fort (USOFT)"
  },
  {
   value: "Old Greenwich (USOGW)",
   label: "Old Greenwich (USOGW)"
  },
  {
   value: "Old Harbor (USOLH)",
   label: "Old Harbor (USOLH)"
  },
  {
   value: "Old Hickory (USOHI)",
   label: "Old Hickory (USOHI)"
  },
  {
   value: "Old Lyme (USOLL)",
   label: "Old Lyme (USOLL)"
  },
  {
   value: "Old Orchard Beach (USOO2)",
   label: "Old Orchard Beach (USOO2)"
  },
  {
   value: "Oldham (USOH2)",
   label: "Oldham (USOH2)"
  },
  {
   value: "Oleum (USOL2)",
   label: "Oleum (USOL2)"
  },
  {
   value: "Olga Bay (USKOY)",
   label: "Olga Bay (USKOY)"
  },
  {
   value: "Olin (USOXL)",
   label: "Olin (USOXL)"
  },
  {
   value: "Olive Branch (USOQB)",
   label: "Olive Branch (USOQB)"
  },
  {
   value: "Olive Hill (USOHF)",
   label: "Olive Hill (USOHF)"
  },
  {
   value: "Olivehurst (USOVH)",
   label: "Olivehurst (USOVH)"
  },
  {
   value: "Olivette (USZOT)",
   label: "Olivette (USZOT)"
  },
  {
   value: "Olmito (USOMG)",
   label: "Olmito (USOMG)"
  },
  {
   value: "Olmsted (USOZM)",
   label: "Olmsted (USOZM)"
  },
  {
   value: "Olmsted Falls (USYOF)",
   label: "Olmsted Falls (USYOF)"
  },
  {
   value: "Olsburg (USOFU)",
   label: "Olsburg (USOFU)"
  },
  {
   value: "Olton (USQOT)",
   label: "Olton (USQOT)"
  },
  {
   value: "Olustee (USOEJ)",
   label: "Olustee (USOEJ)"
  },
  {
   value: "Olyphant (USQOA)",
   label: "Olyphant (USQOA)"
  },
  {
   value: "Omaha (USOH8)",
   label: "Omaha (USOH8)"
  },
  {
   value: "Omro (USOM2)",
   label: "Omro (USOM2)"
  },
  {
   value: "Onalaska (USZOK)",
   label: "Onalaska (USZOK)"
  },
  {
   value: "Onamia (USZNI)",
   label: "Onamia (USZNI)"
  },
  {
   value: "Onaway (USOW2)",
   label: "Onaway (USOW2)"
  },
  {
   value: "Oneonta (USONF)",
   label: "Oneonta (USONF)"
  },
  {
   value: "Onida (USOID)",
   label: "Onida (USOID)"
  },
  {
   value: "Onion Bay (USONN)",
   label: "Onion Bay (USONN)"
  },
  {
   value: "Onset (USONS)",
   label: "Onset (USONS)"
  },
  {
   value: "Onsted (USOTD)",
   label: "Onsted (USOTD)"
  },
  {
   value: "Ontario (USOTF)",
   label: "Ontario (USOTF)"
  },
  {
   value: "Ontonagon (USONG)",
   label: "Ontonagon (USONG)"
  },
  {
   value: "Oologah (USOO3)",
   label: "Oologah (USOO3)"
  },
  {
   value: "Ooltewah (USZOW)",
   label: "Ooltewah (USZOW)"
  },
  {
   value: "Oostburg (USOSU)",
   label: "Oostburg (USOSU)"
  },
  {
   value: "Oradell (USORA)",
   label: "Oradell (USORA)"
  },
  {
   value: "Oran (USO2R)",
   label: "Oran (USO2R)"
  },
  {
   value: "Orange (USJNJ)",
   label: "Orange (USJNJ)"
  },
  {
   value: "Orange (USOAF)",
   label: "Orange (USOAF)"
  },
  {
   value: "Orange (USOGJ)",
   label: "Orange (USOGJ)"
  },
  {
   value: "Orange (USOGX)",
   label: "Orange (USOGX)"
  },
  {
   value: "Orange Beach (USOBC)",
   label: "Orange Beach (USOBC)"
  },
  {
   value: "Orange City (USOC2)",
   label: "Orange City (USOC2)"
  },
  {
   value: "Orange City (USOGC)",
   label: "Orange City (USOGC)"
  },
  {
   value: "Orangevale (USOEV)",
   label: "Orangevale (USOEV)"
  },
  {
   value: "Orangeville (USOAG)",
   label: "Orangeville (USOAG)"
  },
  {
   value: "Orangeville (USOV2)",
   label: "Orangeville (USOV2)"
  },
  {
   value: "Orchard (USOCD)",
   label: "Orchard (USOCD)"
  },
  {
   value: "Orchard Lake (USOHK)",
   label: "Orchard Lake (USOHK)"
  },
  {
   value: "Ord (USOJR)",
   label: "Ord (USOJR)"
  },
  {
   value: "Ordinary (USODY)",
   label: "Ordinary (USODY)"
  },
  {
   value: "Oregon (USOEG)",
   label: "Oregon (USOEG)"
  },
  {
   value: "Orland (USODX)",
   label: "Orland (USODX)"
  },
  {
   value: "Orland (USOLJ)",
   label: "Orland (USOLJ)"
  },
  {
   value: "Orland (USORN)",
   label: "Orland (USORN)"
  },
  {
   value: "Orleans (USOLN)",
   label: "Orleans (USOLN)"
  },
  {
   value: "Orlinda (USQOL)",
   label: "Orlinda (USQOL)"
  },
  {
   value: "Oro Grande (USOOQ)",
   label: "Oro Grande (USOOQ)"
  },
  {
   value: "Orofino (USOFG)",
   label: "Orofino (USOFG)"
  },
  {
   value: "Orogrande (USZOG)",
   label: "Orogrande (USZOG)"
  },
  {
   value: "Orondo (USYDO)",
   label: "Orondo (USYDO)"
  },
  {
   value: "Orono (USR3N)",
   label: "Orono (USR3N)"
  },
  {
   value: "Orosi (USORO)",
   label: "Orosi (USORO)"
  },
  {
   value: "Oroville (USOVE)",
   label: "Oroville (USOVE)"
  },
  {
   value: "Orrick (USIHK)",
   label: "Orrick (USIHK)"
  },
  {
   value: "Orrstown (USOWN)",
   label: "Orrstown (USOWN)"
  },
  {
   value: "Ortonville (USOOI)",
   label: "Ortonville (USOOI)"
  },
  {
   value: "Orwell (USOEQ)",
   label: "Orwell (USOEQ)"
  },
  {
   value: "Osage (USOAE)",
   label: "Osage (USOAE)"
  },
  {
   value: "Osage (USOG8)",
   label: "Osage (USOG8)"
  },
  {
   value: "Osage Beach (USOSB)",
   label: "Osage Beach (USOSB)"
  },
  {
   value: "Osborne (USOB4)",
   label: "Osborne (USOB4)"
  },
  {
   value: "Osceola (USOCL)",
   label: "Osceola (USOCL)"
  },
  {
   value: "Osceola (USOEO)",
   label: "Osceola (USOEO)"
  },
  {
   value: "Osco (USOC3)",
   label: "Osco (USOC3)"
  },
  {
   value: "Osgood (USYZD)",
   label: "Osgood (USYZD)"
  },
  {
   value: "Osmond (USODQ)",
   label: "Osmond (USODQ)"
  },
  {
   value: "Osseo (USOS2)",
   label: "Osseo (USOS2)"
  },
  {
   value: "Osseo (USOXS)",
   label: "Osseo (USOXS)"
  },
  {
   value: "Ossian (USO2S)",
   label: "Ossian (USO2S)"
  },
  {
   value: "Osterville (USOV3)",
   label: "Osterville (USOV3)"
  },
  {
   value: "Osthemo (USOEH)",
   label: "Osthemo (USOEH)"
  },
  {
   value: "Ostrander (USORX)",
   label: "Ostrander (USORX)"
  },
  {
   value: "Oswego (USOSG)",
   label: "Oswego (USOSG)"
  },
  {
   value: "Otay Mesa (USOYM)",
   label: "Otay Mesa (USOYM)"
  },
  {
   value: "Otisville (USOZV)",
   label: "Otisville (USOZV)"
  },
  {
   value: "Otisville (USTSE)",
   label: "Otisville (USTSE)"
  },
  {
   value: "Ottawa Lake (USOTL)",
   label: "Ottawa Lake (USOTL)"
  },
  {
   value: "Otterbein (USO2T)",
   label: "Otterbein (USO2T)"
  },
  {
   value: "Otterville (USOIM)",
   label: "Otterville (USOIM)"
  },
  {
   value: "Otto (USOTO)",
   label: "Otto (USOTO)"
  },
  {
   value: "Ottoville (USTOV)",
   label: "Ottoville (USTOV)"
  },
  {
   value: "Ottsville (USOSV)",
   label: "Ottsville (USOSV)"
  },
  {
   value: "Ouzinkie (USKOZ)",
   label: "Ouzinkie (USKOZ)"
  },
  {
   value: "Overbrook (USVEK)",
   label: "Overbrook (USVEK)"
  },
  {
   value: "Overland (USOVD)",
   label: "Overland (USOVD)"
  },
  {
   value: "Overton, Clark (USGHJ)",
   label: "Overton, Clark (USGHJ)"
  },
  {
   value: "Ovid (USZG4)",
   label: "Ovid (USZG4)"
  },
  {
   value: "Oviedo (USZOD)",
   label: "Oviedo (USZOD)"
  },
  {
   value: "Ovilla (USOVP)",
   label: "Ovilla (USOVP)"
  },
  {
   value: "Owasso (USOW3)",
   label: "Owasso (USOW3)"
  },
  {
   value: "Owego (USOWG)",
   label: "Owego (USOWG)"
  },
  {
   value: "Owen (USZOE)",
   label: "Owen (USZOE)"
  },
  {
   value: "Owens Cross Roads (USOQS)",
   label: "Owens Cross Roads (USOQS)"
  },
  {
   value: "Owensville (USOWJ)",
   label: "Owensville (USOWJ)"
  },
  {
   value: "Oxford (USOFC)",
   label: "Oxford (USOFC)"
  },
  {
   value: "Oxford (USOFM)",
   label: "Oxford (USOFM)"
  },
  {
   value: "Oxford (USOFQ)",
   label: "Oxford (USOFQ)"
  },
  {
   value: "Oxford (USOSF)",
   label: "Oxford (USOSF)"
  },
  {
   value: "Oxford (USOX2)",
   label: "Oxford (USOX2)"
  },
  {
   value: "Oxford (USOXU)",
   label: "Oxford (USOXU)"
  },
  {
   value: "Oxford (USZXO)",
   label: "Oxford (USZXO)"
  },
  {
   value: "Oxly (USOXY)",
   label: "Oxly (USOXY)"
  },
  {
   value: "Oxnard (USOXN)",
   label: "Oxnard (USOXN)"
  },
  {
   value: "Oxon Hill (USOXH)",
   label: "Oxon Hill (USOXH)"
  },
  {
   value: "Oyster Bay (USOYB)",
   label: "Oyster Bay (USOYB)"
  },
  {
   value: "Ozark (USORK)",
   label: "Ozark (USORK)"
  },
  {
   value: "Ozona (USOZA)",
   label: "Ozona (USOZA)"
  },
  {
   value: "Pace (USPCZ)",
   label: "Pace (USPCZ)"
  },
  {
   value: "Pacheco (USZE4)",
   label: "Pacheco (USZE4)"
  },
  {
   value: "Pachuta (USPCW)",
   label: "Pachuta (USPCW)"
  },
  {
   value: "Pacific (USAC3)",
   label: "Pacific (USAC3)"
  },
  {
   value: "Pacific (USPF8)",
   label: "Pacific (USPF8)"
  },
  {
   value: "Pacific City (USPFC)",
   label: "Pacific City (USPFC)"
  },
  {
   value: "Pacific Grove (USICG)",
   label: "Pacific Grove (USICG)"
  },
  {
   value: "Pack Creek (USPBK)",
   label: "Pack Creek (USPBK)"
  },
  {
   value: "Pacolet (USG9)",
   label: "Pacolet (USG9)"
  },
  {
   value: "Paf Warren (USPFA)",
   label: "Paf Warren (USPFA)"
  },
  {
   value: "Pagedale (USPGE)",
   label: "Pagedale (USPGE)"
  },
  {
   value: "Pageland (USPQR)",
   label: "Pageland (USPQR)"
  },
  {
   value: "Pagosa Springs (USPGO)",
   label: "Pagosa Springs (USPGO)"
  },
  {
   value: "Paimiut (USPMU)",
   label: "Paimiut (USPMU)"
  },
  {
   value: "Paintsville (USPAI)",
   label: "Paintsville (USPAI)"
  },
  {
   value: "Pajaro (USAJO)",
   label: "Pajaro (USAJO)"
  },
  {
   value: "Pala (USJPL)",
   label: "Pala (USJPL)"
  },
  {
   value: "Palacios (USPSX)",
   label: "Palacios (USPSX)"
  },
  {
   value: "Palestine (USZH4)",
   label: "Palestine (USZH4)"
  },
  {
   value: "Palisade (USPDJ)",
   label: "Palisade (USPDJ)"
  },
  {
   value: "Palisade (USPDZ)",
   label: "Palisade (USPDZ)"
  },
  {
   value: "Palisades (USIAS)",
   label: "Palisades (USIAS)"
  },
  {
   value: "Palm (USPQM)",
   label: "Palm (USPQM)"
  },
  {
   value: "Palm Bay (USPBY)",
   label: "Palm Bay (USPBY)"
  },
  {
   value: "Palm Beach Gardens (USPMG)",
   label: "Palm Beach Gardens (USPMG)"
  },
  {
   value: "Palm City (USPMI)",
   label: "Palm City (USPMI)"
  },
  {
   value: "Palm Desert (USPMD)",
   label: "Palm Desert (USPMD)"
  },
  {
   value: "Palmdale (USQPL)",
   label: "Palmdale (USQPL)"
  },
  {
   value: "Palmer (USPL2)",
   label: "Palmer (USPL2)"
  },
  {
   value: "Palmertown (USPMZ)",
   label: "Palmertown (USPMZ)"
  },
  {
   value: "Palmetto, Bossier (USPQE)",
   label: "Palmetto, Bossier (USPQE)"
  },
  {
   value: "Palmetto, St Landry (USPFM)",
   label: "Palmetto, St Landry (USPFM)"
  },
  {
   value: "Palmyra (USPMR)",
   label: "Palmyra (USPMR)"
  },
  {
   value: "Palmyra (USPYY)",
   label: "Palmyra (USPYY)"
  },
  {
   value: "Palmyra (USPZQ)",
   label: "Palmyra (USPZQ)"
  },
  {
   value: "Palmyra (USZPY)",
   label: "Palmyra (USZPY)"
  },
  {
   value: "Palos Hills (USPH5)",
   label: "Palos Hills (USPH5)"
  },
  {
   value: "Palos Park (USPP2)",
   label: "Palos Park (USPP2)"
  },
  {
   value: "Palos Verdes Estates (USPVP)",
   label: "Palos Verdes Estates (USPVP)"
  },
  {
   value: "Palouse (USPZU)",
   label: "Palouse (USPZU)"
  },
  {
   value: "Pamplico (USPPJ)",
   label: "Pamplico (USPPJ)"
  },
  {
   value: "Pamplin (USQPM)",
   label: "Pamplin (USQPM)"
  },
  {
   value: "Pana (USPN2)",
   label: "Pana (USPN2)"
  },
  {
   value: "Panguitch (USPNU)",
   label: "Panguitch (USPNU)"
  },
  {
   value: "Panhandle, Carson (USPHY)",
   label: "Panhandle, Carson (USPHY)"
  },
  {
   value: "Panhandle, Cass (USPH4)",
   label: "Panhandle, Cass (USPH4)"
  },
  {
   value: "Pantego (USTCG)",
   label: "Pantego (USTCG)"
  },
  {
   value: "Pantego (USTEG)",
   label: "Pantego (USTEG)"
  },
  {
   value: "Paoli (USAOL)",
   label: "Paoli (USAOL)"
  },
  {
   value: "Paoli (USIPO)",
   label: "Paoli (USIPO)"
  },
  {
   value: "Paoli (USVPI)",
   label: "Paoli (USVPI)"
  },
  {
   value: "Parachute (USPHU)",
   label: "Parachute (USPHU)"
  },
  {
   value: "Paradise (USVPD)",
   label: "Paradise (USVPD)"
  },
  {
   value: "Paradise Valley (USPDV)",
   label: "Paradise Valley (USPDV)"
  },
  {
   value: "Parchment (USPZM)",
   label: "Parchment (USPZM)"
  },
  {
   value: "Pardeeville (USPDF)",
   label: "Pardeeville (USPDF)"
  },
  {
   value: "Park City (USPC6)",
   label: "Park City (USPC6)"
  },
  {
   value: "Park Hill (USPH6)",
   label: "Park Hill (USPH6)"
  },
  {
   value: "Park Hills (USPKH)",
   label: "Park Hills (USPKH)"
  },
  {
   value: "Park Ridge (USPKG)",
   label: "Park Ridge (USPKG)"
  },
  {
   value: "Parker (USAAZ)",
   label: "Parker (USAAZ)"
  },
  {
   value: "Parker (USZKR)",
   label: "Parker (USZKR)"
  },
  {
   value: "Parker Ford (USPKR)",
   label: "Parker Ford (USPKR)"
  },
  {
   value: "Parks (USKPK)",
   label: "Parks (USKPK)"
  },
  {
   value: "Parkton (USPKT)",
   label: "Parkton (USPKT)"
  },
  {
   value: "Parkville (USKLE)",
   label: "Parkville (USKLE)"
  },
  {
   value: "Parma (USQPA)",
   label: "Parma (USQPA)"
  },
  {
   value: "Parma (USQRA)",
   label: "Parma (USQRA)"
  },
  {
   value: "Paron (USPXA)",
   label: "Paron (USPXA)"
  },
  {
   value: "Parrish (USRRH)",
   label: "Parrish (USRRH)"
  },
  {
   value: "Parrottsville (USZTS)",
   label: "Parrottsville (USZTS)"
  },
  {
   value: "Parsons (USPSZ)",
   label: "Parsons (USPSZ)"
  },
  {
   value: "Pasadena (USYPC)",
   label: "Pasadena (USYPC)"
  },
  {
   value: "Pascoag (USPXC)",
   label: "Pascoag (USPXC)"
  },
  {
   value: "Pataskala (USAKL)",
   label: "Pataskala (USAKL)"
  },
  {
   value: "Patchogue (USPCP)",
   label: "Patchogue (USPCP)"
  },
  {
   value: "Paterson (USPWG)",
   label: "Paterson (USPWG)"
  },
  {
   value: "Paton (USPQB)",
   label: "Paton (USPQB)"
  },
  {
   value: "Patrick (USPZK)",
   label: "Patrick (USPZK)"
  },
  {
   value: "Patten (USPQZ)",
   label: "Patten (USPQZ)"
  },
  {
   value: "Patterson (USPT2)",
   label: "Patterson (USPT2)"
  },
  {
   value: "Patterson (USZPA)",
   label: "Patterson (USZPA)"
  },
  {
   value: "Pattison (USDPS)",
   label: "Pattison (USDPS)"
  },
  {
   value: "Patuxent River (USNHK)",
   label: "Patuxent River (USNHK)"
  },
  {
   value: "Paulden (USPD6)",
   label: "Paulden (USPD6)"
  },
  {
   value: "Paulding (USPAD)",
   label: "Paulding (USPAD)"
  },
  {
   value: "Pauline (USPUE)",
   label: "Pauline (USPUE)"
  },
  {
   value: "Pauline (USZUI)",
   label: "Pauline (USZUI)"
  },
  {
   value: "Pauloff Harbor (USKPH)",
   label: "Pauloff Harbor (USKPH)"
  },
  {
   value: "Pauls Valley (USPVJ)",
   label: "Pauls Valley (USPVJ)"
  },
  {
   value: "Pauma Valley (USUVY)",
   label: "Pauma Valley (USUVY)"
  },
  {
   value: "Pawhuska (USPWH)",
   label: "Pawhuska (USPWH)"
  },
  {
   value: "Pawlet (USPJW)",
   label: "Pawlet (USPJW)"
  },
  {
   value: "Pawleys Island (USZPI)",
   label: "Pawleys Island (USZPI)"
  },
  {
   value: "Pawnee (USQAW)",
   label: "Pawnee (USQAW)"
  },
  {
   value: "Pawnee City (USPWX)",
   label: "Pawnee City (USPWX)"
  },
  {
   value: "Pax (USPX2)",
   label: "Pax (USPX2)"
  },
  {
   value: "Paxton (USPFB)",
   label: "Paxton (USPFB)"
  },
  {
   value: "Payne (USPY2)",
   label: "Payne (USPY2)"
  },
  {
   value: "Payson (USPJB)",
   label: "Payson (USPJB)"
  },
  {
   value: "Peabody (USYPA)",
   label: "Peabody (USYPA)"
  },
  {
   value: "Peach Bottom (USYL2)",
   label: "Peach Bottom (USYL2)"
  },
  {
   value: "Peach Springs (USPGS)",
   label: "Peach Springs (USPGS)"
  },
  {
   value: "Peachtree City (USPQH)",
   label: "Peachtree City (USPQH)"
  },
  {
   value: "Peapack (USEPU)",
   label: "Peapack (USEPU)"
  },
  {
   value: "Pearisburg (USEUX)",
   label: "Pearisburg (USEUX)"
  },
  {
   value: "Pearl River (USPR8)",
   label: "Pearl River (USPR8)"
  },
  {
   value: "Pearlington (USPTX)",
   label: "Pearlington (USPTX)"
  },
  {
   value: "Pearsall (USPEU)",
   label: "Pearsall (USPEU)"
  },
  {
   value: "Pebble Beach (USPBA)",
   label: "Pebble Beach (USPBA)"
  },
  {
   value: "Pecatonica (USECT)",
   label: "Pecatonica (USECT)"
  },
  {
   value: "Peckville (USPK2)",
   label: "Peckville (USPK2)"
  },
  {
   value: "Peconic (USQPN)",
   label: "Peconic (USQPN)"
  },
  {
   value: "Peculiar (USVPE)",
   label: "Peculiar (USVPE)"
  },
  {
   value: "Peekskill (USZGF)",
   label: "Peekskill (USZGF)"
  },
  {
   value: "Peetz (USEEZ)",
   label: "Peetz (USEEZ)"
  },
  {
   value: "Pekin (USPKX)",
   label: "Pekin (USPKX)"
  },
  {
   value: "Pelahatchie (USPHE)",
   label: "Pelahatchie (USPHE)"
  },
  {
   value: "Pelham (USAPM)",
   label: "Pelham (USAPM)"
  },
  {
   value: "Pelham (USEHF)",
   label: "Pelham (USEHF)"
  },
  {
   value: "Pelham (USQPE)",
   label: "Pelham (USQPE)"
  },
  {
   value: "Pelican Rapids (USIPI)",
   label: "Pelican Rapids (USIPI)"
  },
  {
   value: "Pelion (USZE5)",
   label: "Pelion (USZE5)"
  },
  {
   value: "Pellston (USPXN)",
   label: "Pellston (USPXN)"
  },
  {
   value: "Pelzer (USYPZ)",
   label: "Pelzer (USYPZ)"
  },
  {
   value: "Pembroke (USJUY)",
   label: "Pembroke (USJUY)"
  },
  {
   value: "Pembroke (USPBM)",
   label: "Pembroke (USPBM)"
  },
  {
   value: "Pembroke (USQPB)",
   label: "Pembroke (USQPB)"
  },
  {
   value: "Pembroke Park (USZPB)",
   label: "Pembroke Park (USZPB)"
  },
  {
   value: "Pembroke Pines (USP2P)",
   label: "Pembroke Pines (USP2P)"
  },
  {
   value: "Pen Argyl (USPYD)",
   label: "Pen Argyl (USPYD)"
  },
  {
   value: "Penacook (USYPJ)",
   label: "Penacook (USYPJ)"
  },
  {
   value: "Pendleton (USPDD)",
   label: "Pendleton (USPDD)"
  },
  {
   value: "Pendleton (USPDO)",
   label: "Pendleton (USPDO)"
  },
  {
   value: "Pendleton (USPJE)",
   label: "Pendleton (USPJE)"
  },
  {
   value: "Penfield (USNFI)",
   label: "Penfield (USNFI)"
  },
  {
   value: "Peninsula (USULA)",
   label: "Peninsula (USULA)"
  },
  {
   value: "Penn Yan (USPQQ)",
   label: "Penn Yan (USPQQ)"
  },
  {
   value: "Pennington (USNIG)",
   label: "Pennington (USNIG)"
  },
  {
   value: "Pennington (USNNG)",
   label: "Pennington (USNNG)"
  },
  {
   value: "Penns Grove (USPGP)",
   label: "Penns Grove (USPGP)"
  },
  {
   value: "Pennsboro (USPBZ)",
   label: "Pennsboro (USPBZ)"
  },
  {
   value: "Pennsburg (USNNJ)",
   label: "Pennsburg (USNNJ)"
  },
  {
   value: "Penrose (USPR2)",
   label: "Penrose (USPR2)"
  },
  {
   value: "Pensacola Beach (USPB4)",
   label: "Pensacola Beach (USPB4)"
  },
  {
   value: "Pentwater (USPNP)",
   label: "Pentwater (USPNP)"
  },
  {
   value: "Peoria (USJPO)",
   label: "Peoria (USJPO)"
  },
  {
   value: "Peoria Heights (USPHB)",
   label: "Peoria Heights (USPHB)"
  },
  {
   value: "Peotone (USPJN)",
   label: "Peotone (USPJN)"
  },
  {
   value: "Pequot Lakes (USPQK)",
   label: "Pequot Lakes (USPQK)"
  },
  {
   value: "Perdue Hill (USXPE)",
   label: "Perdue Hill (USXPE)"
  },
  {
   value: "Perkasie (USPKS)",
   label: "Perkasie (USPKS)"
  },
  {
   value: "Perkins (USPKQ)",
   label: "Perkins (USPKQ)"
  },
  {
   value: "Perkins (USPR3)",
   label: "Perkins (USPR3)"
  },
  {
   value: "Perkinston (USKDS)",
   label: "Perkinston (USKDS)"
  },
  {
   value: "Perkiomenville (USKMV)",
   label: "Perkiomenville (USKMV)"
  },
  {
   value: "Perry (USIPE)",
   label: "Perry (USIPE)"
  },
  {
   value: "Perry (USNYP)",
   label: "Perry (USNYP)"
  },
  {
   value: "Perry (USPRO)",
   label: "Perry (USPRO)"
  },
  {
   value: "Perry (USPY3)",
   label: "Perry (USPY3)"
  },
  {
   value: "Perry Island (USPYL)",
   label: "Perry Island (USPYL)"
  },
  {
   value: "Perryman (USPYB)",
   label: "Perryman (USPYB)"
  },
  {
   value: "Perryopolis (USPYS)",
   label: "Perryopolis (USPYS)"
  },
  {
   value: "Perryville (USKPV)",
   label: "Perryville (USKPV)"
  },
  {
   value: "Perryville (USPYI)",
   label: "Perryville (USPYI)"
  },
  {
   value: "Pescadero (USYPQ)",
   label: "Pescadero (USYPQ)"
  },
  {
   value: "Petal (USPT4)",
   label: "Petal (USPT4)"
  },
  {
   value: "Peterborough (USYPB)",
   label: "Peterborough (USYPB)"
  },
  {
   value: "Petersburg (USPB8)",
   label: "Petersburg (USPB8)"
  },
  {
   value: "Petersburg (USPBB)",
   label: "Petersburg (USPBB)"
  },
  {
   value: "Petersburg (USPBP)",
   label: "Petersburg (USPBP)"
  },
  {
   value: "Petersburg (USPGC)",
   label: "Petersburg (USPGC)"
  },
  {
   value: "Petersburg (USRUG)",
   label: "Petersburg (USRUG)"
  },
  {
   value: "Petersburg (USTSB)",
   label: "Petersburg (USTSB)"
  },
  {
   value: "Petersburg (USTSR)",
   label: "Petersburg (USTSR)"
  },
  {
   value: "Petersburg, Menard (USPB2)",
   label: "Petersburg, Menard (USPB2)"
  },
  {
   value: "Petrolia (USEJI)",
   label: "Petrolia (USEJI)"
  },
  {
   value: "Petty (USEQY)",
   label: "Petty (USEQY)"
  },
  {
   value: "Pevely (USPVB)",
   label: "Pevely (USPVB)"
  },
  {
   value: "Pewee Valley (USEYC)",
   label: "Pewee Valley (USEYC)"
  },
  {
   value: "Peyton (USYPT)",
   label: "Peyton (USYPT)"
  },
  {
   value: "Pfaftown (USPFT)",
   label: "Pfaftown (USPFT)"
  },
  {
   value: "Pflugerville (USPFV)",
   label: "Pflugerville (USPFV)"
  },
  {
   value: "Phelan (USVPH)",
   label: "Phelan (USVPH)"
  },
  {
   value: "Phelps (USPPX)",
   label: "Phelps (USPPX)"
  },
  {
   value: "Phil Campbell (USPCB)",
   label: "Phil Campbell (USPCB)"
  },
  {
   value: "Philadelphia (USPDP)",
   label: "Philadelphia (USPDP)"
  },
  {
   value: "Philipsburg (USIIP)",
   label: "Philipsburg (USIIP)"
  },
  {
   value: "Philipsburg (USZPC)",
   label: "Philipsburg (USZPC)"
  },
  {
   value: "Phillipsburg (USPHJ)",
   label: "Phillipsburg (USPHJ)"
  },
  {
   value: "Phillipsburg (USZPG)",
   label: "Phillipsburg (USZPG)"
  },
  {
   value: "Philmont (USPH3)",
   label: "Philmont (USPH3)"
  },
  {
   value: "Philo (USPJI)",
   label: "Philo (USPJI)"
  },
  {
   value: "Philomath (USYPH)",
   label: "Philomath (USYPH)"
  },
  {
   value: "Philpot (USPPP)",
   label: "Philpot (USPPP)"
  },
  {
   value: "Phoenix (USONX)",
   label: "Phoenix (USONX)"
  },
  {
   value: "Phoenix Township (USPXT)",
   label: "Phoenix Township (USPXT)"
  },
  {
   value: "Picacho (USPIC)",
   label: "Picacho (USPIC)"
  },
  {
   value: "Pickensville (USYKV)",
   label: "Pickensville (USYKV)"
  },
  {
   value: "Pickering (USJPK)",
   label: "Pickering (USJPK)"
  },
  {
   value: "Piedmont (USPNT)",
   label: "Piedmont (USPNT)"
  },
  {
   value: "Piedmont (USXPI)",
   label: "Piedmont (USXPI)"
  },
  {
   value: "Piercy (USPR4)",
   label: "Piercy (USPR4)"
  },
  {
   value: "Pierre Part (USPPQ)",
   label: "Pierre Part (USPPQ)"
  },
  {
   value: "Pierz (USRZB)",
   label: "Pierz (USRZB)"
  },
  {
   value: "Piffard (USPFY)",
   label: "Piffard (USPFY)"
  },
  {
   value: "Pigeon Forge (USYPF)",
   label: "Pigeon Forge (USYPF)"
  },
  {
   value: "Piketon (USPKU)",
   label: "Piketon (USPKU)"
  },
  {
   value: "Pillager (USPGX)",
   label: "Pillager (USPGX)"
  },
  {
   value: "Pilot Point (USPQP)",
   label: "Pilot Point (USPQP)"
  },
  {
   value: "Pimento (USIHO)",
   label: "Pimento (USIHO)"
  },
  {
   value: "Pinckard (USPXP)",
   label: "Pinckard (USPXP)"
  },
  {
   value: "Pinckneyville (USYVP)",
   label: "Pinckneyville (USYVP)"
  },
  {
   value: "Pine Apple (USPAA)",
   label: "Pine Apple (USPAA)"
  },
  {
   value: "Pine Bluffs (USQPS)",
   label: "Pine Bluffs (USQPS)"
  },
  {
   value: "Pine Bush (USYPN)",
   label: "Pine Bush (USYPN)"
  },
  {
   value: "Pine City (USPNY)",
   label: "Pine City (USPNY)"
  },
  {
   value: "Pine Grove (USVZV)",
   label: "Pine Grove (USVZV)"
  },
  {
   value: "Pine Grove, Clearfield (USPGJ)",
   label: "Pine Grove, Clearfield (USPGJ)"
  },
  {
   value: "Pine Island (USYPI)",
   label: "Pine Island (USYPI)"
  },
  {
   value: "Pine Level, Johnston (USNLV)",
   label: "Pine Level, Johnston (USNLV)"
  },
  {
   value: "Pine Mountain Valley (USPM2)",
   label: "Pine Mountain Valley (USPM2)"
  },
  {
   value: "Pine Plains (USQPY)",
   label: "Pine Plains (USQPY)"
  },
  {
   value: "Pine Ridge (USXPR)",
   label: "Pine Ridge (USXPR)"
  },
  {
   value: "Pine River (USPJR)",
   label: "Pine River (USPJR)"
  },
  {
   value: "Pine Valley (USNAY)",
   label: "Pine Valley (USNAY)"
  },
  {
   value: "Pinebluff (USPBL)",
   label: "Pinebluff (USPBL)"
  },
  {
   value: "Pinecrest (USPC2)",
   label: "Pinecrest (USPC2)"
  },
  {
   value: "Pinedale (USPNA)",
   label: "Pinedale (USPNA)"
  },
  {
   value: "Pinetops (USPTP)",
   label: "Pinetops (USPTP)"
  },
  {
   value: "Pineville (USIIU)",
   label: "Pineville (USIIU)"
  },
  {
   value: "Piney Flats (USEYF)",
   label: "Piney Flats (USEYF)"
  },
  {
   value: "Pingree (USPQG)",
   label: "Pingree (USPQG)"
  },
  {
   value: "Pingree Grove (USIEE)",
   label: "Pingree Grove (USIEE)"
  },
  {
   value: "Pinnacle (USZHA)",
   label: "Pinnacle (USZHA)"
  },
  {
   value: "Pinole (USP2C)",
   label: "Pinole (USP2C)"
  },
  {
   value: "Pioneer, Amador (USPN3)",
   label: "Pioneer, Amador (USPN3)"
  },
  {
   value: "Piper City (USPC4)",
   label: "Piper City (USPC4)"
  },
  {
   value: "Pipersville (USPEV)",
   label: "Pipersville (USPEV)"
  },
  {
   value: "Piru (USPIU)",
   label: "Piru (USPIU)"
  },
  {
   value: "Pisgah (USPAG)",
   label: "Pisgah (USPAG)"
  },
  {
   value: "Pitcairn (USPCF)",
   label: "Pitcairn (USPCF)"
  },
  {
   value: "Pitman (USPMN)",
   label: "Pitman (USPMN)"
  },
  {
   value: "Pitts (USQQQ)",
   label: "Pitts (USQQQ)"
  },
  {
   value: "Pittsboro (USPBQ)",
   label: "Pittsboro (USPBQ)"
  },
  {
   value: "Pittsboro (USQPO)",
   label: "Pittsboro (USQPO)"
  },
  {
   value: "Pittsfield (USITT)",
   label: "Pittsfield (USITT)"
  },
  {
   value: "Pittsfield (USTFE)",
   label: "Pittsfield (USTFE)"
  },
  {
   value: "Pittsgrove (USTGV)",
   label: "Pittsgrove (USTGV)"
  },
  {
   value: "Pittstown (USTSW)",
   label: "Pittstown (USTSW)"
  },
  {
   value: "Pittsville (USITV)",
   label: "Pittsville (USITV)"
  },
  {
   value: "Pittsville (USPVO)",
   label: "Pittsville (USPVO)"
  },
  {
   value: "Pittsville (USPVQ)",
   label: "Pittsville (USPVQ)"
  },
  {
   value: "Placida (USEUU)",
   label: "Placida (USEUU)"
  },
  {
   value: "Plain (USPN8)",
   label: "Plain (USPN8)"
  },
  {
   value: "Plainfield (USIFI)",
   label: "Plainfield (USIFI)"
  },
  {
   value: "Plainfield (USLNF)",
   label: "Plainfield (USLNF)"
  },
  {
   value: "Plainfield (USNLF)",
   label: "Plainfield (USNLF)"
  },
  {
   value: "Plainfield (USPAF)",
   label: "Plainfield (USPAF)"
  },
  {
   value: "Plainfield (USPF2)",
   label: "Plainfield (USPF2)"
  },
  {
   value: "Plainfield (USPFE)",
   label: "Plainfield (USPFE)"
  },
  {
   value: "Plainfield (USYPD)",
   label: "Plainfield (USYPD)"
  },
  {
   value: "Plainfield Center (USXPF)",
   label: "Plainfield Center (USXPF)"
  },
  {
   value: "Plains (USLPY)",
   label: "Plains (USLPY)"
  },
  {
   value: "Plainview (USPFW)",
   label: "Plainview (USPFW)"
  },
  {
   value: "Plainville (USIIB)",
   label: "Plainville (USIIB)"
  },
  {
   value: "Plainville (USZG7)",
   label: "Plainville (USZG7)"
  },
  {
   value: "Plano (USPLZ)",
   label: "Plano (USPLZ)"
  },
  {
   value: "Plantation (USYIT)",
   label: "Plantation (USYIT)"
  },
  {
   value: "Plantersville (USLRL)",
   label: "Plantersville (USLRL)"
  },
  {
   value: "Plato (USPL3)",
   label: "Plato (USPL3)"
  },
  {
   value: "Plato (USPZD)",
   label: "Plato (USPZD)"
  },
  {
   value: "Platte Centre (USPDC)",
   label: "Platte Centre (USPDC)"
  },
  {
   value: "Platteville (USTTZ)",
   label: "Platteville (USTTZ)"
  },
  {
   value: "Plattsburg (USPBX)",
   label: "Plattsburg (USPBX)"
  },
  {
   value: "Plaucheville (USPUU)",
   label: "Plaucheville (USPUU)"
  },
  {
   value: "Pleasant City (USPJY)",
   label: "Pleasant City (USPJY)"
  },
  {
   value: "Pleasant Gap (USPNG)",
   label: "Pleasant Gap (USPNG)"
  },
  {
   value: "Pleasant Grove (USTGO)",
   label: "Pleasant Grove (USTGO)"
  },
  {
   value: "Pleasant Grove (USYPG)",
   label: "Pleasant Grove (USYPG)"
  },
  {
   value: "Pleasant Harbour (USPTR)",
   label: "Pleasant Harbour (USPTR)"
  },
  {
   value: "Pleasant Hill (USLSH)",
   label: "Pleasant Hill (USLSH)"
  },
  {
   value: "Pleasant Hill (USPDH)",
   label: "Pleasant Hill (USPDH)"
  },
  {
   value: "Pleasant Hill (USPTI)",
   label: "Pleasant Hill (USPTI)"
  },
  {
   value: "Pleasant Hills (USPH7)",
   label: "Pleasant Hills (USPH7)"
  },
  {
   value: "Pleasant Hope (USPO3)",
   label: "Pleasant Hope (USPO3)"
  },
  {
   value: "Pleasant Plain (USPAP)",
   label: "Pleasant Plain (USPAP)"
  },
  {
   value: "Pleasant Plains (USPPL)",
   label: "Pleasant Plains (USPPL)"
  },
  {
   value: "Pleasant Prairie (USPLP)",
   label: "Pleasant Prairie (USPLP)"
  },
  {
   value: "Pleasant Prairie (USXPP)",
   label: "Pleasant Prairie (USXPP)"
  },
  {
   value: "Pleasant Unity (USPU7)",
   label: "Pleasant Unity (USPU7)"
  },
  {
   value: "Pleasant Valley (USPEY)",
   label: "Pleasant Valley (USPEY)"
  },
  {
   value: "Pleasant Valley (USZHJ)",
   label: "Pleasant Valley (USZHJ)"
  },
  {
   value: "Pleasant View (USNIW)",
   label: "Pleasant View (USNIW)"
  },
  {
   value: "Pleasant View, Cheatham (USPWZ)",
   label: "Pleasant View, Cheatham (USPWZ)"
  },
  {
   value: "Pleasant View, Weber (USXOX)",
   label: "Pleasant View, Weber (USXOX)"
  },
  {
   value: "Pleasanton (USPT5)",
   label: "Pleasanton (USPT5)"
  },
  {
   value: "Pleasantville (USVPP)",
   label: "Pleasantville (USVPP)"
  },
  {
   value: "Pleasure Ridge Park (USPGK)",
   label: "Pleasure Ridge Park (USPGK)"
  },
  {
   value: "Pleasureville (USEIU)",
   label: "Pleasureville (USEIU)"
  },
  {
   value: "Plentywood (USPWD)",
   label: "Plentywood (USPWD)"
  },
  {
   value: "Pluckemin (USPJU)",
   label: "Pluckemin (USPJU)"
  },
  {
   value: "Plumerville (USPUR)",
   label: "Plumerville (USPUR)"
  },
  {
   value: "Plumsteadville (USPUV)",
   label: "Plumsteadville (USPUV)"
  },
  {
   value: "Plymouth (USPYO)",
   label: "Plymouth (USPYO)"
  },
  {
   value: "Plymouth (USXOU)",
   label: "Plymouth (USXOU)"
  },
  {
   value: "Plymouth (USYIQ)",
   label: "Plymouth (USYIQ)"
  },
  {
   value: "Plymouth (USYMU)",
   label: "Plymouth (USYMU)"
  },
  {
   value: "Plympton (USPL4)",
   label: "Plympton (USPL4)"
  },
  {
   value: "Poca (USPOX)",
   label: "Poca (USPOX)"
  },
  {
   value: "Pocahontas (USPHH)",
   label: "Pocahontas (USPHH)"
  },
  {
   value: "Pocahontas (USPXH)",
   label: "Pocahontas (USPXH)"
  },
  {
   value: "Pocahontas (USQPH)",
   label: "Pocahontas (USQPH)"
  },
  {
   value: "Pocahontas&nbsp; (USPH2)",
   label: "Pocahontas&nbsp; (USPH2)"
  },
  {
   value: "Pocasset (USPJC)",
   label: "Pocasset (USPJC)"
  },
  {
   value: "Pocatalico (USOAT)",
   label: "Pocatalico (USOAT)"
  },
  {
   value: "Pocola (USPCL)",
   label: "Pocola (USPCL)"
  },
  {
   value: "Pocomoke City (USPKM)",
   label: "Pocomoke City (USPKM)"
  },
  {
   value: "Poestenkill (USOTK)",
   label: "Poestenkill (USOTK)"
  },
  {
   value: "Pohakuloa (USBSF)",
   label: "Pohakuloa (USBSF)"
  },
  {
   value: "Point Arena (USPA2)",
   label: "Point Arena (USPA2)"
  },
  {
   value: "Point Baker (USKPB)",
   label: "Point Baker (USKPB)"
  },
  {
   value: "Point Barrow (USTBW)",
   label: "Point Barrow (USTBW)"
  },
  {
   value: "Point Clear (USPC8)",
   label: "Point Clear (USPC8)"
  },
  {
   value: "Point Hope (USPHO)",
   label: "Point Hope (USPHO)"
  },
  {
   value: "Point Marion (USTMD)",
   label: "Point Marion (USTMD)"
  },
  {
   value: "Point Mugu Nawc (USPWC)",
   label: "Point Mugu Nawc (USPWC)"
  },
  {
   value: "Point of Rocks (USPFS)",
   label: "Point of Rocks (USPFS)"
  },
  {
   value: "Point Pleasant (USZHC)",
   label: "Point Pleasant (USZHC)"
  },
  {
   value: "Point Pleasant Beach (USPP3)",
   label: "Point Pleasant Beach (USPP3)"
  },
  {
   value: "Poland (USQPD)",
   label: "Poland (USQPD)"
  },
  {
   value: "Poland (USZE6)",
   label: "Poland (USZE6)"
  },
  {
   value: "Polk Inlet (USPOQ)",
   label: "Polk Inlet (USPOQ)"
  },
  {
   value: "Polkton (USNKK)",
   label: "Polkton (USNKK)"
  },
  {
   value: "Pollock (USP2O)",
   label: "Pollock (USP2O)"
  },
  {
   value: "Polson (USPOS)",
   label: "Polson (USPOS)"
  },
  {
   value: "Pomfret Center (USPFF)",
   label: "Pomfret Center (USPFF)"
  },
  {
   value: "Pomona (USPMO)",
   label: "Pomona (USPMO)"
  },
  {
   value: "Ponder (USPZN)",
   label: "Ponder (USPZN)"
  },
  {
   value: "Ponderay (USPYF)",
   label: "Ponderay (USPYF)"
  },
  {
   value: "Ponte Vedra (USQPV)",
   label: "Ponte Vedra (USQPV)"
  },
  {
   value: "Pontoon Beach (USPNB)",
   label: "Pontoon Beach (USPNB)"
  },
  {
   value: "Pooler (USPOZ)",
   label: "Pooler (USPOZ)"
  },
  {
   value: "Poplar (USOPZ)",
   label: "Poplar (USOPZ)"
  },
  {
   value: "Poplar Branch (USOBZ)",
   label: "Poplar Branch (USOBZ)"
  },
  {
   value: "Poplarville (USYPV)",
   label: "Poplarville (USYPV)"
  },
  {
   value: "Port Alto (USQPT)",
   label: "Port Alto (USQPT)"
  },
  {
   value: "Port Barre (USRTB)",
   label: "Port Barre (USRTB)"
  },
  {
   value: "Port Canaveral (USPCV)",
   label: "Port Canaveral (USPCV)"
  },
  {
   value: "Port Ewen (USPE2)",
   label: "Port Ewen (USPE2)"
  },
  {
   value: "Port Fourchon (USFOC)",
   label: "Port Fourchon (USFOC)"
  },
  {
   value: "Port Jervis (USPJV)",
   label: "Port Jervis (USPJV)"
  },
  {
   value: "Port MacKenzie (USPMV)",
   label: "Port MacKenzie (USPMV)"
  },
  {
   value: "Port Madison (USPDI)",
   label: "Port Madison (USPDI)"
  },
  {
   value: "Port Monmouth (USPM3)",
   label: "Port Monmouth (USPM3)"
  },
  {
   value: "Port Morris, Bronx (USPM4)",
   label: "Port Morris, Bronx (USPM4)"
  },
  {
   value: "Port Murray (USURR)",
   label: "Port Murray (USURR)"
  },
  {
   value: "Port Norris (USOTI)",
   label: "Port Norris (USOTI)"
  },
  {
   value: "Port Orford (USPO2)",
   label: "Port Orford (USPO2)"
  },
  {
   value: "Port Republic (USPUX)",
   label: "Port Republic (USPUX)"
  },
  {
   value: "Port Republic (USYPR)",
   label: "Port Republic (USYPR)"
  },
  {
   value: "Portage (USPJG)",
   label: "Portage (USPJG)"
  },
  {
   value: "Portage (USPOJ)",
   label: "Portage (USPOJ)"
  },
  {
   value: "Portage (USPTE)",
   label: "Portage (USPTE)"
  },
  {
   value: "Portageville (USPGI)",
   label: "Portageville (USPGI)"
  },
  {
   value: "Portageville (USZPT)",
   label: "Portageville (USZPT)"
  },
  {
   value: "Portal (USPQT)",
   label: "Portal (USPQT)"
  },
  {
   value: "Porter (USPXE)",
   label: "Porter (USPXE)"
  },
  {
   value: "Porterdale (USPOD)",
   label: "Porterdale (USPOD)"
  },
  {
   value: "Porthill (USPJL)",
   label: "Porthill (USPJL)"
  },
  {
   value: "Portland (USDTP)",
   label: "Portland (USDTP)"
  },
  {
   value: "Portland (USLDP)",
   label: "Portland (USLDP)"
  },
  {
   value: "Portland (USPOL)",
   label: "Portland (USPOL)"
  },
  {
   value: "Portland (USPWQ)",
   label: "Portland (USPWQ)"
  },
  {
   value: "Portland (USXPO)",
   label: "Portland (USXPO)"
  },
  {
   value: "Portola Valley (USXPT)",
   label: "Portola Valley (USXPT)"
  },
  {
   value: "Portsmouth (USPOM)",
   label: "Portsmouth (USPOM)"
  },
  {
   value: "Portville (USVTP)",
   label: "Portville (USVTP)"
  },
  {
   value: "Posen (USPS2)",
   label: "Posen (USPS2)"
  },
  {
   value: "Posen (USPZO)",
   label: "Posen (USPZO)"
  },
  {
   value: "Poskin (USPUK)",
   label: "Poskin (USPUK)"
  },
  {
   value: "Post Mills (USPM7)",
   label: "Post Mills (USPM7)"
  },
  {
   value: "Postville (USVVI)",
   label: "Postville (USVVI)"
  },
  {
   value: "Poteet (USPT8)",
   label: "Poteet (USPT8)"
  },
  {
   value: "Potomac (USPMK)",
   label: "Potomac (USPMK)"
  },
  {
   value: "Potomac Falls (USVPM)",
   label: "Potomac Falls (USVPM)"
  },
  {
   value: "Potter (USPT6)",
   label: "Potter (USPT6)"
  },
  {
   value: "Potter Valley (USPV2)",
   label: "Potter Valley (USPV2)"
  },
  {
   value: "Potterstown (USTTJ)",
   label: "Potterstown (USTTJ)"
  },
  {
   value: "Potterville (USVPL)",
   label: "Potterville (USVPL)"
  },
  {
   value: "Pottsboro (USPSR)",
   label: "Pottsboro (USPSR)"
  },
  {
   value: "Poughquag (USOGH)",
   label: "Poughquag (USOGH)"
  },
  {
   value: "Pound (USPN4)",
   label: "Pound (USPN4)"
  },
  {
   value: "Pound (USPWJ)",
   label: "Pound (USPWJ)"
  },
  {
   value: "Poway (USQPW)",
   label: "Poway (USQPW)"
  },
  {
   value: "Powell (USPRQ)",
   label: "Powell (USPRQ)"
  },
  {
   value: "Powell (USTNO)",
   label: "Powell (USTNO)"
  },
  {
   value: "Powhatan (USZPW)",
   label: "Powhatan (USZPW)"
  },
  {
   value: "Pownal (USYPW)",
   label: "Pownal (USYPW)"
  },
  {
   value: "Poy Sippi (USVPJ)",
   label: "Poy Sippi (USVPJ)"
  },
  {
   value: "Prairie (USPR6)",
   label: "Prairie (USPR6)"
  },
  {
   value: "Prairie City (USIZY)",
   label: "Prairie City (USIZY)"
  },
  {
   value: "Prairie du Sac (USPS3)",
   label: "Prairie du Sac (USPS3)"
  },
  {
   value: "Prairie Grove (USPEG)",
   label: "Prairie Grove (USPEG)"
  },
  {
   value: "Prairie Hill, Limestone (USIHI)",
   label: "Prairie Hill, Limestone (USIHI)"
  },
  {
   value: "Prairie Hill, Washington (USXPH)",
   label: "Prairie Hill, Washington (USXPH)"
  },
  {
   value: "Prairie Village (USVGP)",
   label: "Prairie Village (USVGP)"
  },
  {
   value: "Prattsville (USPV3)",
   label: "Prattsville (USPV3)"
  },
  {
   value: "Premont (USZWZ)",
   label: "Premont (USZWZ)"
  },
  {
   value: "Prescott (USPS8)",
   label: "Prescott (USPS8)"
  },
  {
   value: "Prescott (USRSC)",
   label: "Prescott (USRSC)"
  },
  {
   value: "Prescott Valley (USPV4)",
   label: "Prescott Valley (USPV4)"
  },
  {
   value: "Presque Isle (USPSS)",
   label: "Presque Isle (USPSS)"
  },
  {
   value: "Preston (USPSO)",
   label: "Preston (USPSO)"
  },
  {
   value: "Preston (USRET)",
   label: "Preston (USRET)"
  },
  {
   value: "Prestonsburg (USPB3)",
   label: "Prestonsburg (USPB3)"
  },
  {
   value: "Prewitt (USRWP)",
   label: "Prewitt (USRWP)"
  },
  {
   value: "Price (USPUC)",
   label: "Price (USPUC)"
  },
  {
   value: "Primm (USZPM)",
   label: "Primm (USZPM)"
  },
  {
   value: "Prince Frederick (USPFK)",
   label: "Prince Frederick (USPFK)"
  },
  {
   value: "Prince George (USJPG)",
   label: "Prince George (USJPG)"
  },
  {
   value: "Princess Anne (USPA8)",
   label: "Princess Anne (USPA8)"
  },
  {
   value: "Princeton (USPC3)",
   label: "Princeton (USPC3)"
  },
  {
   value: "Princeton (USPCO)",
   label: "Princeton (USPCO)"
  },
  {
   value: "Princeton (USPNK)",
   label: "Princeton (USPNK)"
  },
  {
   value: "Princeton (USPNN)",
   label: "Princeton (USPNN)"
  },
  {
   value: "Princeton Junction (USPJO)",
   label: "Princeton Junction (USPJO)"
  },
  {
   value: "Princeville (USPNZ)",
   label: "Princeville (USPNZ)"
  },
  {
   value: "Prinsburg (USPRU)",
   label: "Prinsburg (USPRU)"
  },
  {
   value: "Proberta (USPJA)",
   label: "Proberta (USPJA)"
  },
  {
   value: "Proctor (USPC7)",
   label: "Proctor (USPC7)"
  },
  {
   value: "Proctor (USPDR)",
   label: "Proctor (USPDR)"
  },
  {
   value: "Proctor (USPR5)",
   label: "Proctor (USPR5)"
  },
  {
   value: "Proctorsville (USPV6)",
   label: "Proctorsville (USPV6)"
  },
  {
   value: "Promise City (USIIX)",
   label: "Promise City (USIIX)"
  },
  {
   value: "Promontory (USPXR)",
   label: "Promontory (USPXR)"
  },
  {
   value: "Prophetstown (USPPN)",
   label: "Prophetstown (USPPN)"
  },
  {
   value: "Prospect (USPPU)",
   label: "Prospect (USPPU)"
  },
  {
   value: "Prospect (USRPC)",
   label: "Prospect (USRPC)"
  },
  {
   value: "Prospect (USYPP)",
   label: "Prospect (USYPP)"
  },
  {
   value: "Prospect Creek (USPPC)",
   label: "Prospect Creek (USPPC)"
  },
  {
   value: "Prospect Heights (USPPG)",
   label: "Prospect Heights (USPPG)"
  },
  {
   value: "Prospect Park (USPPK)",
   label: "Prospect Park (USPPK)"
  },
  {
   value: "Prospect, Butler (USPS7)",
   label: "Prospect, Butler (USPS7)"
  },
  {
   value: "Prosper (USQPX)",
   label: "Prosper (USQPX)"
  },
  {
   value: "Providence (USPV5)",
   label: "Providence (USPV5)"
  },
  {
   value: "Providence, Webster (USVDC)",
   label: "Providence, Webster (USVDC)"
  },
  {
   value: "Prudenville (USPUF)",
   label: "Prudenville (USPUF)"
  },
  {
   value: "Prunedale (USPZB)",
   label: "Prunedale (USPZB)"
  },
  {
   value: "Pt Alexander (USPTD)",
   label: "Pt Alexander (USPTD)"
  },
  {
   value: "Pt Alsworth (USPTA)",
   label: "Pt Alsworth (USPTA)"
  },
  {
   value: "Pt Aransas (USTZS)",
   label: "Pt Aransas (USTZS)"
  },
  {
   value: "Pt Arthur (USQRT)",
   label: "Pt Arthur (USQRT)"
  },
  {
   value: "Pt Clarence (USKPC)",
   label: "Pt Clarence (USKPC)"
  },
  {
   value: "Pt Clinton (USPCN)",
   label: "Pt Clinton (USPCN)"
  },
  {
   value: "Pt Deposit (USZE7)",
   label: "Pt Deposit (USZE7)"
  },
  {
   value: "Pt Elizabeth (USEZX)",
   label: "Pt Elizabeth (USEZX)"
  },
  {
   value: "Pt Laudania (USJDT)",
   label: "Pt Laudania (USJDT)"
  },
  {
   value: "Pt Lions (USORI)",
   label: "Pt Lions (USORI)"
  },
  {
   value: "Pt Moller (USPML)",
   label: "Pt Moller (USPML)"
  },
  {
   value: "Pt Protection (USPPV)",
   label: "Pt Protection (USPPV)"
  },
  {
   value: "Pt Richmond (USRI4)",
   label: "Pt Richmond (USRI4)"
  },
  {
   value: "Pt Royal (USPRJ)",
   label: "Pt Royal (USPRJ)"
  },
  {
   value: "Pt San Juan (USPJS)",
   label: "Pt San Juan (USPJS)"
  },
  {
   value: "Pt Wakefield (USPWF)",
   label: "Pt Wakefield (USPWF)"
  },
  {
   value: "Pt Washington (USRWR)",
   label: "Pt Washington (USRWR)"
  },
  {
   value: "Puckett (USKKX)",
   label: "Puckett (USKKX)"
  },
  {
   value: "Puerto Rico (USPR7)",
   label: "Puerto Rico (USPR7)"
  },
  {
   value: "Pulaski (USPYK)",
   label: "Pulaski (USPYK)"
  },
  {
   value: "Pulaski, Lawrence (USPXU)",
   label: "Pulaski, Lawrence (USPXU)"
  },
  {
   value: "Punxsutawney (USPXW)",
   label: "Punxsutawney (USPXW)"
  },
  {
   value: "Purcell (USPUZ)",
   label: "Purcell (USPUZ)"
  },
  {
   value: "Purcellville (USPUI)",
   label: "Purcellville (USPUI)"
  },
  {
   value: "Purdy (USPDU)",
   label: "Purdy (USPDU)"
  },
  {
   value: "Puryear (USUUU)",
   label: "Puryear (USUUU)"
  },
  {
   value: "Putnamville (USIUT)",
   label: "Putnamville (USIUT)"
  },
  {
   value: "Quaker City (USQAY)",
   label: "Quaker City (USQAY)"
  },
  {
   value: "Quantico (USNYG)",
   label: "Quantico (USNYG)"
  },
  {
   value: "Quapaw (USQP2)",
   label: "Quapaw (USQP2)"
  },
  {
   value: "Quarryville (USZQE)",
   label: "Quarryville (USZQE)"
  },
  {
   value: "Quartz Hill (USQUA)",
   label: "Quartz Hill (USQUA)"
  },
  {
   value: "Quartzsite (USQTZ)",
   label: "Quartzsite (USQTZ)"
  },
  {
   value: "Quechee (USQEH)",
   label: "Quechee (USQEH)"
  },
  {
   value: "Queen Anne (USQNA)",
   label: "Queen Anne (USQNA)"
  },
  {
   value: "Queen City (USZQU)",
   label: "Queen City (USZQU)"
  },
  {
   value: "Queen Creek (USQCK)",
   label: "Queen Creek (USQCK)"
  },
  {
   value: "Queens Village (USQVG)",
   label: "Queens Village (USQVG)"
  },
  {
   value: "Queensbury (USQBY)",
   label: "Queensbury (USQBY)"
  },
  {
   value: "Quicksburg (USQKS)",
   label: "Quicksburg (USQKS)"
  },
  {
   value: "Quincy (USQUI)",
   label: "Quincy (USQUI)"
  },
  {
   value: "Quinhagak (USKWN)",
   label: "Quinhagak (USKWN)"
  },
  {
   value: "Quinnesec (USQN2)",
   label: "Quinnesec (USQN2)"
  },
  {
   value: "Quinter (USQNR)",
   label: "Quinter (USQNR)"
  },
  {
   value: "Quinton (USQUN)",
   label: "Quinton (USQUN)"
  },
  {
   value: "Raceland (USRCB)",
   label: "Raceland (USRCB)"
  },
  {
   value: "Raceland (USRXA)",
   label: "Raceland (USRXA)"
  },
  {
   value: "Radium Springs (USRPS)",
   label: "Radium Springs (USRPS)"
  },
  {
   value: "Ragland (USYRG)",
   label: "Ragland (USYRG)"
  },
  {
   value: "Rahns (USRHN)",
   label: "Rahns (USRHN)"
  },
  {
   value: "Rahway (USRAY)",
   label: "Rahway (USRAY)"
  },
  {
   value: "Raiford (USRAU)",
   label: "Raiford (USRAU)"
  },
  {
   value: "Rainbow (USYRI)",
   label: "Rainbow (USYRI)"
  },
  {
   value: "Rainbow City (USXRC)",
   label: "Rainbow City (USXRC)"
  },
  {
   value: "Rainelle (USRNU)",
   label: "Rainelle (USRNU)"
  },
  {
   value: "Rainier (USQIE)",
   label: "Rainier (USQIE)"
  },
  {
   value: "Rainsville (USRNV)",
   label: "Rainsville (USRNV)"
  },
  {
   value: "Raleigh (USRAG)",
   label: "Raleigh (USRAG)"
  },
  {
   value: "Ralston (USRAX)",
   label: "Ralston (USRAX)"
  },
  {
   value: "Ralston (USRLQ)",
   label: "Ralston (USRLQ)"
  },
  {
   value: "Ramona (USRXM)",
   label: "Ramona (USRXM)"
  },
  {
   value: "Rampart (USRMP)",
   label: "Rampart (USRMP)"
  },
  {
   value: "Ramsey (USQNS)",
   label: "Ramsey (USQNS)"
  },
  {
   value: "Ramsey (USRMY)",
   label: "Ramsey (USRMY)"
  },
  {
   value: "Rancho Bernardo (USRBO)",
   label: "Rancho Bernardo (USRBO)"
  },
  {
   value: "Rancho Cucamonga (USKKG)",
   label: "Rancho Cucamonga (USKKG)"
  },
  {
   value: "Rancho Dominguez (USRDO)",
   label: "Rancho Dominguez (USRDO)"
  },
  {
   value: "Rancho Santa Margarita (USRSM)",
   label: "Rancho Santa Margarita (USRSM)"
  },
  {
   value: "Rancocas (USXRN)",
   label: "Rancocas (USXRN)"
  },
  {
   value: "Rand (USZE8)",
   label: "Rand (USZE8)"
  },
  {
   value: "Randle (USRD3)",
   label: "Randle (USRD3)"
  },
  {
   value: "Randolph (USDCP)",
   label: "Randolph (USDCP)"
  },
  {
   value: "Randolph (USRD8)",
   label: "Randolph (USRD8)"
  },
  {
   value: "Randolph (USRDP)",
   label: "Randolph (USRDP)"
  },
  {
   value: "Randolph (USRJD)",
   label: "Randolph (USRJD)"
  },
  {
   value: "Randolph (USRPH)",
   label: "Randolph (USRPH)"
  },
  {
   value: "Randolph (USRPZ)",
   label: "Randolph (USRPZ)"
  },
  {
   value: "Random Lake (USRLK)",
   label: "Random Lake (USRLK)"
  },
  {
   value: "Rangeley (USRGY)",
   label: "Rangeley (USRGY)"
  },
  {
   value: "Rangely (USRNG)",
   label: "Rangely (USRNG)"
  },
  {
   value: "Ranger (USRGR)",
   label: "Ranger (USRGR)"
  },
  {
   value: "Ransomville (USRAV)",
   label: "Ransomville (USRAV)"
  },
  {
   value: "Rantoul (USRTU)",
   label: "Rantoul (USRTU)"
  },
  {
   value: "Rapidan (USYRP)",
   label: "Rapidan (USYRP)"
  },
  {
   value: "Rathdrum (USRHU)",
   label: "Rathdrum (USRHU)"
  },
  {
   value: "Ratliff City (USRTY)",
   label: "Ratliff City (USRTY)"
  },
  {
   value: "Rattan (USRFA)",
   label: "Rattan (USRFA)"
  },
  {
   value: "Ravena (USXRA)",
   label: "Ravena (USXRA)"
  },
  {
   value: "Ravenna (USRVN)",
   label: "Ravenna (USRVN)"
  },
  {
   value: "Ravensdale (USRV8)",
   label: "Ravensdale (USRV8)"
  },
  {
   value: "Ray (USRJX)",
   label: "Ray (USRJX)"
  },
  {
   value: "Ray (USRY6)",
   label: "Ray (USRY6)"
  },
  {
   value: "Ray City (USYDT)",
   label: "Ray City (USYDT)"
  },
  {
   value: "Raymond (USAYM)",
   label: "Raymond (USAYM)"
  },
  {
   value: "Raymond (USRM2)",
   label: "Raymond (USRM2)"
  },
  {
   value: "Raymond (USRM3)",
   label: "Raymond (USRM3)"
  },
  {
   value: "Raymond (USRMB)",
   label: "Raymond (USRMB)"
  },
  {
   value: "Raymond (USRYO)",
   label: "Raymond (USRYO)"
  },
  {
   value: "Raymond (USYOD)",
   label: "Raymond (USYOD)"
  },
  {
   value: "Raymondville (USRYD)",
   label: "Raymondville (USRYD)"
  },
  {
   value: "Raytown (USYRO)",
   label: "Raytown (USYRO)"
  },
  {
   value: "Raywood (USZJL)",
   label: "Raywood (USZJL)"
  },
  {
   value: "Reading (USRDJ)",
   label: "Reading (USRDJ)"
  },
  {
   value: "Reamstown (USREK)",
   label: "Reamstown (USREK)"
  },
  {
   value: "Reasnor (USRJA)",
   label: "Reasnor (USRJA)"
  },
  {
   value: "Rebecca (USRCC)",
   label: "Rebecca (USRCC)"
  },
  {
   value: "Red Bank (USRKB)",
   label: "Red Bank (USRKB)"
  },
  {
   value: "Red Boiling Springs (USRBP)",
   label: "Red Boiling Springs (USRBP)"
  },
  {
   value: "Red Bud (USRRB)",
   label: "Red Bud (USRRB)"
  },
  {
   value: "Red Creek (USRKQ)",
   label: "Red Creek (USRKQ)"
  },
  {
   value: "Red Devil (USRDV)",
   label: "Red Devil (USRDV)"
  },
  {
   value: "Red Dog (USRDB)",
   label: "Red Dog (USRDB)"
  },
  {
   value: "Red Hill (USRHY)",
   label: "Red Hill (USRHY)"
  },
  {
   value: "Red House (USDHP)",
   label: "Red House (USDHP)"
  },
  {
   value: "Red Lodge (USRLJ)",
   label: "Red Lodge (USRLJ)"
  },
  {
   value: "Red Oak (USRDK)",
   label: "Red Oak (USRDK)"
  },
  {
   value: "Red Oak (USRQK)",
   label: "Red Oak (USRQK)"
  },
  {
   value: "Red River (USRDR)",
   label: "Red River (USRDR)"
  },
  {
   value: "Red Rock (USEOF)",
   label: "Red Rock (USEOF)"
  },
  {
   value: "Reddell (USRDZ)",
   label: "Reddell (USRDZ)"
  },
  {
   value: "Redding (USDDP)",
   label: "Redding (USDDP)"
  },
  {
   value: "Redding (USRGX)",
   label: "Redding (USRGX)"
  },
  {
   value: "Redding Ridge (USRRG)",
   label: "Redding Ridge (USRRG)"
  },
  {
   value: "Redgranite (USRJG)",
   label: "Redgranite (USRJG)"
  },
  {
   value: "Redmond (USRMD)",
   label: "Redmond (USRMD)"
  },
  {
   value: "Redmond (USRMQ)",
   label: "Redmond (USRMQ)"
  },
  {
   value: "Redwater (USRPD)",
   label: "Redwater (USRPD)"
  },
  {
   value: "Redwood (USDWR)",
   label: "Redwood (USDWR)"
  },
  {
   value: "Redwood Falls (USRWF)",
   label: "Redwood Falls (USRWF)"
  },
  {
   value: "Reeder (USRD2)",
   label: "Reeder (USRD2)"
  },
  {
   value: "Reeds (USRZE)",
   label: "Reeds (USRZE)"
  },
  {
   value: "Reeds Spring (USRS2)",
   label: "Reeds Spring (USRS2)"
  },
  {
   value: "Reedsburg (USRDS)",
   label: "Reedsburg (USRDS)"
  },
  {
   value: "Reedsville (USEIV)",
   label: "Reedsville (USEIV)"
  },
  {
   value: "Reedsville (USREI)",
   label: "Reedsville (USREI)"
  },
  {
   value: "Reedsville (USREL)",
   label: "Reedsville (USREL)"
  },
  {
   value: "Reedy (USRYY)",
   label: "Reedy (USRYY)"
  },
  {
   value: "Reelsville (USRLZ)",
   label: "Reelsville (USRLZ)"
  },
  {
   value: "Reeseville (USEEV)",
   label: "Reeseville (USEEV)"
  },
  {
   value: "Reform (USRF2)",
   label: "Reform (USRF2)"
  },
  {
   value: "Refugio (USRFG)",
   label: "Refugio (USRFG)"
  },
  {
   value: "Regent (USQRH)",
   label: "Regent (USQRH)"
  },
  {
   value: "Rego Park, Queens (USRP2)",
   label: "Rego Park, Queens (USRP2)"
  },
  {
   value: "Rehoboth (USRZX)",
   label: "Rehoboth (USRZX)"
  },
  {
   value: "Rehoboth Beach (USREH)",
   label: "Rehoboth Beach (USREH)"
  },
  {
   value: "Reidsville (USREE)",
   label: "Reidsville (USREE)"
  },
  {
   value: "Reidville (USRV2)",
   label: "Reidville (USRV2)"
  },
  {
   value: "Reinbeck (USRB2)",
   label: "Reinbeck (USRB2)"
  },
  {
   value: "Reisterstown (USRSW)",
   label: "Reisterstown (USRSW)"
  },
  {
   value: "Reliance (USIAC)",
   label: "Reliance (USIAC)"
  },
  {
   value: "Rembrandt (USRJR)",
   label: "Rembrandt (USRJR)"
  },
  {
   value: "Renick (USIZK)",
   label: "Renick (USIZK)"
  },
  {
   value: "Reno (USRNA)",
   label: "Reno (USRNA)"
  },
  {
   value: "Reno (USRNQ)",
   label: "Reno (USRNQ)"
  },
  {
   value: "Reno-Stead (USRS3)",
   label: "Reno-Stead (USRS3)"
  },
  {
   value: "Rensselaer (USRNZ)",
   label: "Rensselaer (USRNZ)"
  },
  {
   value: "Rentz (USRTZ)",
   label: "Rentz (USRTZ)"
  },
  {
   value: "Republic (USRPU)",
   label: "Republic (USRPU)"
  },
  {
   value: "Rescue (USRES)",
   label: "Rescue (USRES)"
  },
  {
   value: "Research Triangle Park (USYTP)",
   label: "Research Triangle Park (USYTP)"
  },
  {
   value: "Reseda (USRSE)",
   label: "Reseda (USRSE)"
  },
  {
   value: "Retsil (USRTJ)",
   label: "Retsil (USRTJ)"
  },
  {
   value: "Revere (USREZ)",
   label: "Revere (USREZ)"
  },
  {
   value: "Rexford (USRXF)",
   label: "Rexford (USRXF)"
  },
  {
   value: "Reynolds (USRYQ)",
   label: "Reynolds (USRYQ)"
  },
  {
   value: "Reynoldsville (USYRY)",
   label: "Reynoldsville (USYRY)"
  },
  {
   value: "Rheems (USJRA)",
   label: "Rheems (USJRA)"
  },
  {
   value: "Rhine (USRHE)",
   label: "Rhine (USRHE)"
  },
  {
   value: "Rhinebeck (USZBK)",
   label: "Rhinebeck (USZBK)"
  },
  {
   value: "Rhode Island (USRHO)",
   label: "Rhode Island (USRHO)"
  },
  {
   value: "Rhodhiss (USODP)",
   label: "Rhodhiss (USODP)"
  },
  {
   value: "Rice (USRC3)",
   label: "Rice (USRC3)"
  },
  {
   value: "Rice (USRJI)",
   label: "Rice (USRJI)"
  },
  {
   value: "Riceville (USICV)",
   label: "Riceville (USICV)"
  },
  {
   value: "Rich Creek (USRHK)",
   label: "Rich Creek (USRHK)"
  },
  {
   value: "Rich Square (USE9)",
   label: "Rich Square (USE9)"
  },
  {
   value: "Richardson (USRIN)",
   label: "Richardson (USRIN)"
  },
  {
   value: "Richboro (USRQC)",
   label: "Richboro (USRQC)"
  },
  {
   value: "Richfield (USQPC)",
   label: "Richfield (USQPC)"
  },
  {
   value: "Richfield (USRII)",
   label: "Richfield (USRII)"
  },
  {
   value: "Richfield (USYYU)",
   label: "Richfield (USYYU)"
  },
  {
   value: "Richgrove (USRG2)",
   label: "Richgrove (USRG2)"
  },
  {
   value: "Richland (USIHL)",
   label: "Richland (USIHL)"
  },
  {
   value: "Richland (USRIQ)",
   label: "Richland (USRIQ)"
  },
  {
   value: "Richland (USRRM)",
   label: "Richland (USRRM)"
  },
  {
   value: "Richmond (USHMC)",
   label: "Richmond (USHMC)"
  },
  {
   value: "Richmond (USIHD)",
   label: "Richmond (USIHD)"
  },
  {
   value: "Richmond (USRCD)",
   label: "Richmond (USRCD)"
  },
  {
   value: "Richmond (USRCN)",
   label: "Richmond (USRCN)"
  },
  {
   value: "Richmond (USRM4)",
   label: "Richmond (USRM4)"
  },
  {
   value: "Richmond (USRMF)",
   label: "Richmond (USRMF)"
  },
  {
   value: "Richmond (USRMH)",
   label: "Richmond (USRMH)"
  },
  {
   value: "Richmond (USRMN)",
   label: "Richmond (USRMN)"
  },
  {
   value: "Richmond (USRXD)",
   label: "Richmond (USRXD)"
  },
  {
   value: "Richmond Dale (USIAF)",
   label: "Richmond Dale (USIAF)"
  },
  {
   value: "Richmond Heights (USRMS)",
   label: "Richmond Heights (USRMS)"
  },
  {
   value: "Richmond Hill\/Queens\/New York (USRIX)",
   label: "Richmond Hill\/Queens\/New York (USRIX)"
  },
  {
   value: "Richvale (USZIA)",
   label: "Richvale (USZIA)"
  },
  {
   value: "Richwood (USRXI)",
   label: "Richwood (USRXI)"
  },
  {
   value: "Richwood (USRXW)",
   label: "Richwood (USRXW)"
  },
  {
   value: "Richwood (USZFA)",
   label: "Richwood (USZFA)"
  },
  {
   value: "Rickenbacker International Apt (USRIB)",
   label: "Rickenbacker International Apt (USRIB)"
  },
  {
   value: "Rickreall (USZIC)",
   label: "Rickreall (USZIC)"
  },
  {
   value: "Ridgecrest (USIGD)",
   label: "Ridgecrest (USIGD)"
  },
  {
   value: "Ridgefield (USRF3)",
   label: "Ridgefield (USRF3)"
  },
  {
   value: "Ridgefield (USRLF)",
   label: "Ridgefield (USRLF)"
  },
  {
   value: "Ridgeland (USRGE)",
   label: "Ridgeland (USRGE)"
  },
  {
   value: "Ridgeland (USRZG)",
   label: "Ridgeland (USRZG)"
  },
  {
   value: "Ridgely (USRGZ)",
   label: "Ridgely (USRGZ)"
  },
  {
   value: "Ridgeville (USRVQ)",
   label: "Ridgeville (USRVQ)"
  },
  {
   value: "Ridgeway (USXRY)",
   label: "Ridgeway (USXRY)"
  },
  {
   value: "Ridgeway (USXVX)",
   label: "Ridgeway (USXVX)"
  },
  {
   value: "Ridgeway (USZRW)",
   label: "Ridgeway (USZRW)"
  },
  {
   value: "Riesel (USRIZ)",
   label: "Riesel (USRIZ)"
  },
  {
   value: "Rigby (USRG3)",
   label: "Rigby (USRG3)"
  },
  {
   value: "Riley (USIEY)",
   label: "Riley (USIEY)"
  },
  {
   value: "Rimer (USRIM)",
   label: "Rimer (USRIM)"
  },
  {
   value: "Rimersburg (USRB3)",
   label: "Rimersburg (USRB3)"
  },
  {
   value: "Rincon (USNJN)",
   label: "Rincon (USNJN)"
  },
  {
   value: "Ringle (USRAF)",
   label: "Ringle (USRAF)"
  },
  {
   value: "Ringoes (USYGO)",
   label: "Ringoes (USYGO)"
  },
  {
   value: "Ringtown (USRGN)",
   label: "Ringtown (USRGN)"
  },
  {
   value: "Ringwood (USRIJ)",
   label: "Ringwood (USRIJ)"
  },
  {
   value: "Rio Grande (USRGF)",
   label: "Rio Grande (USRGF)"
  },
  {
   value: "Rio Oso (USRO6)",
   label: "Rio Oso (USRO6)"
  },
  {
   value: "Riparius (USIAJ)",
   label: "Riparius (USIAJ)"
  },
  {
   value: "Ripley (USRPE)",
   label: "Ripley (USRPE)"
  },
  {
   value: "Rising Fawn (USIWK)",
   label: "Rising Fawn (USIWK)"
  },
  {
   value: "River Edge (USRQQ)",
   label: "River Edge (USRQQ)"
  },
  {
   value: "River Falls (USRFL)",
   label: "River Falls (USRFL)"
  },
  {
   value: "River Forest (USRVO)",
   label: "River Forest (USRVO)"
  },
  {
   value: "River Grove\/Chicago (USRIG)",
   label: "River Grove\/Chicago (USRIG)"
  },
  {
   value: "Riverbank (USZRB)",
   label: "Riverbank (USZRB)"
  },
  {
   value: "Riverdale (USIVU)",
   label: "Riverdale (USIVU)"
  },
  {
   value: "Riverdale (USRQV)",
   label: "Riverdale (USRQV)"
  },
  {
   value: "Rivergate (USRGJ)",
   label: "Rivergate (USRGJ)"
  },
  {
   value: "Riverside (USIVD)",
   label: "Riverside (USIVD)"
  },
  {
   value: "Riverside (USVRD)",
   label: "Riverside (USVRD)"
  },
  {
   value: "Riverside (USVSD)",
   label: "Riverside (USVSD)"
  },
  {
   value: "Riverside (USVSE)",
   label: "Riverside (USVSE)"
  },
  {
   value: "Riverside (USYRS)",
   label: "Riverside (USYRS)"
  },
  {
   value: "Riverton (USRJE)",
   label: "Riverton (USRJE)"
  },
  {
   value: "Riverton (USRV6)",
   label: "Riverton (USRV6)"
  },
  {
   value: "Riverton (USYIV)",
   label: "Riverton (USYIV)"
  },
  {
   value: "Riverview (USRRW)",
   label: "Riverview (USRRW)"
  },
  {
   value: "Riverview (USRVV)",
   label: "Riverview (USRVV)"
  },
  {
   value: "Riverwoods (USVWD)",
   label: "Riverwoods (USVWD)"
  },
  {
   value: "Rives Junction (USIEJ)",
   label: "Rives Junction (USIEJ)"
  },
  {
   value: "Riviera Beach (USRBC)",
   label: "Riviera Beach (USRBC)"
  },
  {
   value: "Rixeyville (USVYX)",
   label: "Rixeyville (USVYX)"
  },
  {
   value: "Roanoke (USRN2)",
   label: "Roanoke (USRN2)"
  },
  {
   value: "Roanoke (USRNE)",
   label: "Roanoke (USRNE)"
  },
  {
   value: "Roanoke (USRQX)",
   label: "Roanoke (USRQX)"
  },
  {
   value: "Roanoke (USUOK)",
   label: "Roanoke (USUOK)"
  },
  {
   value: "Roaring River (USIIR)",
   label: "Roaring River (USIIR)"
  },
  {
   value: "Robards (USRBA)",
   label: "Robards (USRBA)"
  },
  {
   value: "Robbins (USRBS)",
   label: "Robbins (USRBS)"
  },
  {
   value: "Robbins (USRO7)",
   label: "Robbins (USRO7)"
  },
  {
   value: "Robbinsdale (USRB7)",
   label: "Robbinsdale (USRB7)"
  },
  {
   value: "Robersonville (USRRO)",
   label: "Robersonville (USRRO)"
  },
  {
   value: "Roberta (USOBA)",
   label: "Roberta (USOBA)"
  },
  {
   value: "Roberts (USR2O)",
   label: "Roberts (USR2O)"
  },
  {
   value: "Roberts (USRBT)",
   label: "Roberts (USRBT)"
  },
  {
   value: "Robertsdale (USOBS)",
   label: "Robertsdale (USOBS)"
  },
  {
   value: "Robertsville (USRVB)",
   label: "Robertsville (USRVB)"
  },
  {
   value: "Robins Air Force Base (USOBF)",
   label: "Robins Air Force Base (USOBF)"
  },
  {
   value: "Robinsonville (USNSO)",
   label: "Robinsonville (USNSO)"
  },
  {
   value: "Robinsville (USZFB)",
   label: "Robinsville (USZFB)"
  },
  {
   value: "Robstown (USRT8)",
   label: "Robstown (USRT8)"
  },
  {
   value: "Rochdale (USZRO)",
   label: "Rochdale (USZRO)"
  },
  {
   value: "Rochelle (USRCX)",
   label: "Rochelle (USRCX)"
  },
  {
   value: "Rochester (USOHX)",
   label: "Rochester (USOHX)"
  },
  {
   value: "Rochester (USROH)",
   label: "Rochester (USROH)"
  },
  {
   value: "Rochester Hills\/Detroit (USRHH)",
   label: "Rochester Hills\/Detroit (USRHH)"
  },
  {
   value: "Rock City (USRC8)",
   label: "Rock City (USRC8)"
  },
  {
   value: "Rock City Falls (USOYA)",
   label: "Rock City Falls (USOYA)"
  },
  {
   value: "Rock Rapids (USRZR)",
   label: "Rock Rapids (USRZR)"
  },
  {
   value: "Rock Springs (USVWS)",
   label: "Rock Springs (USVWS)"
  },
  {
   value: "Rock Springs (USXRS)",
   label: "Rock Springs (USXRS)"
  },
  {
   value: "Rock Tavern (USXRT)",
   label: "Rock Tavern (USXRT)"
  },
  {
   value: "Rock Valley (USRCV)",
   label: "Rock Valley (USRCV)"
  },
  {
   value: "Rockdale (USRCK)",
   label: "Rockdale (USRCK)"
  },
  {
   value: "Rockfall (USRF4)",
   label: "Rockfall (USRF4)"
  },
  {
   value: "Rockfield (USYIC)",
   label: "Rockfield (USYIC)"
  },
  {
   value: "Rockford (USKOD)",
   label: "Rockford (USKOD)"
  },
  {
   value: "Rockford (USRFO)",
   label: "Rockford (USRFO)"
  },
  {
   value: "Rockford (USROF)",
   label: "Rockford (USROF)"
  },
  {
   value: "Rockford (USZFE)",
   label: "Rockford (USZFE)"
  },
  {
   value: "Rockland (USKLA)",
   label: "Rockland (USKLA)"
  },
  {
   value: "Rockland (USRQD)",
   label: "Rockland (USRQD)"
  },
  {
   value: "Rocklin (USRKL)",
   label: "Rocklin (USRKL)"
  },
  {
   value: "Rockmart (USRKA)",
   label: "Rockmart (USRKA)"
  },
  {
   value: "Rockport (USKOB)",
   label: "Rockport (USKOB)"
  },
  {
   value: "Rockport (USRP3)",
   label: "Rockport (USRP3)"
  },
  {
   value: "Rocksprings (USRS6)",
   label: "Rocksprings (USRS6)"
  },
  {
   value: "Rockvale (USOAL)",
   label: "Rockvale (USOAL)"
  },
  {
   value: "Rockville (USOCV)",
   label: "Rockville (USOCV)"
  },
  {
   value: "Rockville (USXXN)",
   label: "Rockville (USXXN)"
  },
  {
   value: "Rockville Centre (USQRC)",
   label: "Rockville Centre (USQRC)"
  },
  {
   value: "Rockwell (USKWE)",
   label: "Rockwell (USKWE)"
  },
  {
   value: "Rockwood (USKOO)",
   label: "Rockwood (USKOO)"
  },
  {
   value: "Rockwood (USRW2)",
   label: "Rockwood (USRW2)"
  },
  {
   value: "Rockwood (USRWH)",
   label: "Rockwood (USRWH)"
  },
  {
   value: "Rockwood (USRWU)",
   label: "Rockwood (USRWU)"
  },
  {
   value: "Rocky River (USRKY)",
   label: "Rocky River (USRKY)"
  },
  {
   value: "Rodeo (USRD4)",
   label: "Rodeo (USRD4)"
  },
  {
   value: "Roderfield (USREF)",
   label: "Roderfield (USREF)"
  },
  {
   value: "Roeland Park (USREJ)",
   label: "Roeland Park (USREJ)"
  },
  {
   value: "Roff (USRFF)",
   label: "Roff (USRFF)"
  },
  {
   value: "Rogers (USRGQ)",
   label: "Rogers (USRGQ)"
  },
  {
   value: "Rogers (USRGS)",
   label: "Rogers (USRGS)"
  },
  {
   value: "Rogers Haven (USRH2)",
   label: "Rogers Haven (USRH2)"
  },
  {
   value: "Rogersville (USOEI)",
   label: "Rogersville (USOEI)"
  },
  {
   value: "Rogersville (USRGV)",
   label: "Rogersville (USRGV)"
  },
  {
   value: "Rogersville (USRVZ)",
   label: "Rogersville (USRVZ)"
  },
  {
   value: "Rogue River (USRGU)",
   label: "Rogue River (USRGU)"
  },
  {
   value: "Roland (USOLK)",
   label: "Roland (USOLK)"
  },
  {
   value: "Rolesville (USRVF)",
   label: "Rolesville (USRVF)"
  },
  {
   value: "Rolla (USRQL)",
   label: "Rolla (USRQL)"
  },
  {
   value: "Rolling Prairie (USRPA)",
   label: "Rolling Prairie (USRPA)"
  },
  {
   value: "Rome (USREO)",
   label: "Rome (USREO)"
  },
  {
   value: "Romeoville (USROI)",
   label: "Romeoville (USROI)"
  },
  {
   value: "Romeville (USZH7)",
   label: "Romeville (USZH7)"
  },
  {
   value: "Romoland (USOMD)",
   label: "Romoland (USOMD)"
  },
  {
   value: "Ronceverte (USROT)",
   label: "Ronceverte (USROT)"
  },
  {
   value: "Ronda (USQDA)",
   label: "Ronda (USQDA)"
  },
  {
   value: "Roosevelt (USRLT)",
   label: "Roosevelt (USRLT)"
  },
  {
   value: "Rooseveltown (USRVT)",
   label: "Rooseveltown (USRVT)"
  },
  {
   value: "Roper (USNCW)",
   label: "Roper (USNCW)"
  },
  {
   value: "Rosalia (USRZA)",
   label: "Rosalia (USRZA)"
  },
  {
   value: "Roscoe (USUOE)",
   label: "Roscoe (USUOE)"
  },
  {
   value: "Roscommon (USRCQ)",
   label: "Roscommon (USRCQ)"
  },
  {
   value: "Rose City (USREC)",
   label: "Rose City (USREC)"
  },
  {
   value: "Roseboro (USRSB)",
   label: "Roseboro (USRSB)"
  },
  {
   value: "Rosedale (USRAE)",
   label: "Rosedale (USRAE)"
  },
  {
   value: "Rosedale (USRDQ)",
   label: "Rosedale (USRDQ)"
  },
  {
   value: "Rosedale (USROZ)",
   label: "Rosedale (USROZ)"
  },
  {
   value: "Rosedale (USRSA)",
   label: "Rosedale (USRSA)"
  },
  {
   value: "Roseland (USXRL)",
   label: "Roseland (USXRL)"
  },
  {
   value: "Roselawn (USOEW)",
   label: "Roselawn (USOEW)"
  },
  {
   value: "Roselle Park (USZH2)",
   label: "Roselle Park (USZH2)"
  },
  {
   value: "Rosenberg (USRSG)",
   label: "Rosenberg (USRSG)"
  },
  {
   value: "Rosendale (USOJE)",
   label: "Rosendale (USOJE)"
  },
  {
   value: "Rosendale (USROD)",
   label: "Rosendale (USROD)"
  },
  {
   value: "Rosenhayn (USRON)",
   label: "Rosenhayn (USRON)"
  },
  {
   value: "Rosharon (USRHQ)",
   label: "Rosharon (USRHQ)"
  },
  {
   value: "Rosholt (USOSO)",
   label: "Rosholt (USOSO)"
  },
  {
   value: "Rosiclare (USRSK)",
   label: "Rosiclare (USRSK)"
  },
  {
   value: "Roslindale (USRZD)",
   label: "Roslindale (USRZD)"
  },
  {
   value: "Roslyn (USYL8)",
   label: "Roslyn (USYL8)"
  },
  {
   value: "Ross (USRS4)",
   label: "Ross (USRS4)"
  },
  {
   value: "Ross (USRZO)",
   label: "Ross (USRZO)"
  },
  {
   value: "Rossville (USROQ)",
   label: "Rossville (USROQ)"
  },
  {
   value: "Rossville (USRXL)",
   label: "Rossville (USRXL)"
  },
  {
   value: "Rothbury (USRJU)",
   label: "Rothbury (USRJU)"
  },
  {
   value: "Rothbury (USRYR)",
   label: "Rothbury (USRYR)"
  },
  {
   value: "Rotterdam (USRAJ)",
   label: "Rotterdam (USRAJ)"
  },
  {
   value: "Rotunda (USRTD)",
   label: "Rotunda (USRTD)"
  },
  {
   value: "Round Lake (USRL2)",
   label: "Round Lake (USRL2)"
  },
  {
   value: "Round Top (USRQT)",
   label: "Round Top (USRQT)"
  },
  {
   value: "Roundup (USRPX)",
   label: "Roundup (USRPX)"
  },
  {
   value: "Rowan Bay (USRWB)",
   label: "Rowan Bay (USRWB)"
  },
  {
   value: "Rowe (USRWV)",
   label: "Rowe (USRWV)"
  },
  {
   value: "Rowlett (USZRE)",
   label: "Rowlett (USZRE)"
  },
  {
   value: "Rowley (USRL3)",
   label: "Rowley (USRL3)"
  },
  {
   value: "Roxana (USRZM)",
   label: "Roxana (USRZM)"
  },
  {
   value: "Roy (USRY8)",
   label: "Roy (USRY8)"
  },
  {
   value: "Royal (USRYA)",
   label: "Royal (USRYA)"
  },
  {
   value: "Royalton (USYAA)",
   label: "Royalton (USYAA)"
  },
  {
   value: "Ruby (USRBY)",
   label: "Ruby (USRBY)"
  },
  {
   value: "Ruby (USRUY)",
   label: "Ruby (USRUY)"
  },
  {
   value: "Ruby Valley (USRVU)",
   label: "Ruby Valley (USRVU)"
  },
  {
   value: "Ruckersville (USRUK)",
   label: "Ruckersville (USRUK)"
  },
  {
   value: "Rudyard (USRDX)",
   label: "Rudyard (USRDX)"
  },
  {
   value: "Ruffin (USYRF)",
   label: "Ruffin (USYRF)"
  },
  {
   value: "Ruffs Dale (USRFE)",
   label: "Ruffs Dale (USRFE)"
  },
  {
   value: "Rugby (USUGG)",
   label: "Rugby (USUGG)"
  },
  {
   value: "Rumford (USRFB)",
   label: "Rumford (USRFB)"
  },
  {
   value: "Rumney (USRU8)",
   label: "Rumney (USRU8)"
  },
  {
   value: "Runnemede (USYRD)",
   label: "Runnemede (USYRD)"
  },
  {
   value: "Rupert (USRPT)",
   label: "Rupert (USRPT)"
  },
  {
   value: "Rush Center (USUEF)",
   label: "Rush Center (USUEF)"
  },
  {
   value: "Rush City (USRHZ)",
   label: "Rush City (USRHZ)"
  },
  {
   value: "Rush Springs (USRHP)",
   label: "Rush Springs (USRHP)"
  },
  {
   value: "Rushford (USRUF)",
   label: "Rushford (USRUF)"
  },
  {
   value: "Rushville (USRUH)",
   label: "Rushville (USRUH)"
  },
  {
   value: "Russell (USUED)",
   label: "Russell (USUED)"
  },
  {
   value: "Russell (USUSL)",
   label: "Russell (USUSL)"
  },
  {
   value: "Russell (USZG2)",
   label: "Russell (USZG2)"
  },
  {
   value: "Russell Springs (USRS5)",
   label: "Russell Springs (USRS5)"
  },
  {
   value: "Russell Springs (USRUP)",
   label: "Russell Springs (USRUP)"
  },
  {
   value: "Russells Point (USRUO)",
   label: "Russells Point (USRUO)"
  },
  {
   value: "Russellville (USRUE)",
   label: "Russellville (USRUE)"
  },
  {
   value: "Russellville (USRVK)",
   label: "Russellville (USRVK)"
  },
  {
   value: "Russellville (USUVI)",
   label: "Russellville (USUVI)"
  },
  {
   value: "Russia (USUSS)",
   label: "Russia (USUSS)"
  },
  {
   value: "Russiaville (USRV3)",
   label: "Russiaville (USRV3)"
  },
  {
   value: "Ruther Glen (USRVG)",
   label: "Ruther Glen (USRVG)"
  },
  {
   value: "Rutherford (USZUT)",
   label: "Rutherford (USZUT)"
  },
  {
   value: "Rutherford College (USRC2)",
   label: "Rutherford College (USRC2)"
  },
  {
   value: "Ryde (USRYB)",
   label: "Ryde (USRYB)"
  },
  {
   value: "Rye (USRYZ)",
   label: "Rye (USRYZ)"
  },
  {
   value: "Rye (USZRY)",
   label: "Rye (USZRY)"
  },
  {
   value: "Rye Brook (USRRK)",
   label: "Rye Brook (USRRK)"
  },
  {
   value: "S.Burlington (USZBR)",
   label: "S.Burlington (USZBR)"
  },
  {
   value: "Sabattus (USABT)",
   label: "Sabattus (USABT)"
  },
  {
   value: "Sabetha (USZHB)",
   label: "Sabetha (USZHB)"
  },
  {
   value: "Sabillasville (USIAI)",
   label: "Sabillasville (USIAI)"
  },
  {
   value: "Sabina (USSBB)",
   label: "Sabina (USSBB)"
  },
  {
   value: "Sabinal (USUSJ)",
   label: "Sabinal (USUSJ)"
  },
  {
   value: "Sabine Pass (USNSS)",
   label: "Sabine Pass (USNSS)"
  },
  {
   value: "Saco (USQSK)",
   label: "Saco (USQSK)"
  },
  {
   value: "Sadsburyville (USUDV)",
   label: "Sadsburyville (USUDV)"
  },
  {
   value: "Sagaponack (USSP2)",
   label: "Sagaponack (USSP2)"
  },
  {
   value: "Saginaw (USAGA)",
   label: "Saginaw (USAGA)"
  },
  {
   value: "Saginaw (USSAI)",
   label: "Saginaw (USSAI)"
  },
  {
   value: "Saginaw (USSGM)",
   label: "Saginaw (USSGM)"
  },
  {
   value: "Saginaw Bay (USSGW)",
   label: "Saginaw Bay (USSGW)"
  },
  {
   value: "Sagola (USXSG)",
   label: "Sagola (USXSG)"
  },
  {
   value: "Sahuarita (USSR6)",
   label: "Sahuarita (USSR6)"
  },
  {
   value: "Saint Charles (USAAS)",
   label: "Saint Charles (USAAS)"
  },
  {
   value: "Saint Charles (USSKC)",
   label: "Saint Charles (USSKC)"
  },
  {
   value: "Saint Clair (USSKZ)",
   label: "Saint Clair (USSKZ)"
  },
  {
   value: "Saint Henry (USHZA)",
   label: "Saint Henry (USHZA)"
  },
  {
   value: "Saint James (USAIJ)",
   label: "Saint James (USAIJ)"
  },
  {
   value: "Saint James (USSNJ)",
   label: "Saint James (USSNJ)"
  },
  {
   value: "Saint Joseph (USYSJ)",
   label: "Saint Joseph (USYSJ)"
  },
  {
   value: "Saint Marks (USAIT)",
   label: "Saint Marks (USAIT)"
  },
  {
   value: "Saint Marys (USINY)",
   label: "Saint Marys (USINY)"
  },
  {
   value: "Saint Marys (USYSR)",
   label: "Saint Marys (USYSR)"
  },
  {
   value: "Saint Marys (USYTS)",
   label: "Saint Marys (USYTS)"
  },
  {
   value: "Saint Peter (USSIP)",
   label: "Saint Peter (USSIP)"
  },
  {
   value: "Saint Rose Plantation (USAIP)",
   label: "Saint Rose Plantation (USAIP)"
  },
  {
   value: "Saint Thomas (USXTM)",
   label: "Saint Thomas (USXTM)"
  },
  {
   value: "Salamanca (USZIN)",
   label: "Salamanca (USZIN)"
  },
  {
   value: "Sale Creek (USECK)",
   label: "Sale Creek (USECK)"
  },
  {
   value: "Salem (USAAM)",
   label: "Salem (USAAM)"
  },
  {
   value: "Salem (USQLM)",
   label: "Salem (USQLM)"
  },
  {
   value: "Salem (USSXA)",
   label: "Salem (USSXA)"
  },
  {
   value: "Salem (USZLM)",
   label: "Salem (USZLM)"
  },
  {
   value: "Salem (USZSA)",
   label: "Salem (USZSA)"
  },
  {
   value: "Salida (USZIG)",
   label: "Salida (USZIG)"
  },
  {
   value: "Salisbury (USISU)",
   label: "Salisbury (USISU)"
  },
  {
   value: "Salisbury (USSY6)",
   label: "Salisbury (USSY6)"
  },
  {
   value: "Salisbury (USZYS)",
   label: "Salisbury (USZYS)"
  },
  {
   value: "Salisbury Mills (USYLS)",
   label: "Salisbury Mills (USYLS)"
  },
  {
   value: "Sallis (USSIZ)",
   label: "Sallis (USSIZ)"
  },
  {
   value: "Salt Flat (USTFP)",
   label: "Salt Flat (USTFP)"
  },
  {
   value: "Saltsburg (USZXB)",
   label: "Saltsburg (USZXB)"
  },
  {
   value: "Saltville (USSAP)",
   label: "Saltville (USSAP)"
  },
  {
   value: "Saluda (USUDA)",
   label: "Saluda (USUDA)"
  },
  {
   value: "Salyersville (USZSK)",
   label: "Salyersville (USZSK)"
  },
  {
   value: "Sammamish (USZMS)",
   label: "Sammamish (USZMS)"
  },
  {
   value: "Samoa (USIOR)",
   label: "Samoa (USIOR)"
  },
  {
   value: "San Acacio (USZSI)",
   label: "San Acacio (USZSI)"
  },
  {
   value: "San Anselmo (USDLM)",
   label: "San Anselmo (USDLM)"
  },
  {
   value: "San Antonio (USAT8)",
   label: "San Antonio (USAT8)"
  },
  {
   value: "San Augustine (USSA2)",
   label: "San Augustine (USSA2)"
  },
  {
   value: "San Benito (USSBZ)",
   label: "San Benito (USSBZ)"
  },
  {
   value: "San Carlos, Maricopa (USXSC)",
   label: "San Carlos, Maricopa (USXSC)"
  },
  {
   value: "San Diego (USSD2)",
   label: "San Diego (USSD2)"
  },
  {
   value: "San Dimas (USSDA)",
   label: "San Dimas (USSDA)"
  },
  {
   value: "San Gabriel (USSG7)",
   label: "San Gabriel (USSG7)"
  },
  {
   value: "San Jacinto (USJNO)",
   label: "San Jacinto (USJNO)"
  },
  {
   value: "San Joaquin (USJOQ)",
   label: "San Joaquin (USJOQ)"
  },
  {
   value: "San Joaquin River (USANJ)",
   label: "San Joaquin River (USANJ)"
  },
  {
   value: "San Juan Bautista (USZFX)",
   label: "San Juan Bautista (USZFX)"
  },
  {
   value: "San Juan Pueblo (USJPB)",
   label: "San Juan Pueblo (USJPB)"
  },
  {
   value: "San Lorenzo (USYSZ)",
   label: "San Lorenzo (USYSZ)"
  },
  {
   value: "San Mateo (USSXF)",
   label: "San Mateo (USSXF)"
  },
  {
   value: "San Miguel (USSYL)",
   label: "San Miguel (USSYL)"
  },
  {
   value: "San Saba (USZSS)",
   label: "San Saba (USZSS)"
  },
  {
   value: "San Ysidro (USYSO)",
   label: "San Ysidro (USYSO)"
  },
  {
   value: "Sanborn (USNBQ)",
   label: "Sanborn (USNBQ)"
  },
  {
   value: "Sanbornville (USSV2)",
   label: "Sanbornville (USSV2)"
  },
  {
   value: "Sand Coulee (USDCE)",
   label: "Sand Coulee (USDCE)"
  },
  {
   value: "Sanderson (USDSA)",
   label: "Sanderson (USDSA)"
  },
  {
   value: "Sandoval (USBMH)",
   label: "Sandoval (USBMH)"
  },
  {
   value: "Sandpoint (USNDP)",
   label: "Sandpoint (USNDP)"
  },
  {
   value: "Sands Point (USZDS)",
   label: "Sands Point (USZDS)"
  },
  {
   value: "Sandy Creek (USSY3)",
   label: "Sandy Creek (USSY3)"
  },
  {
   value: "Sandy Hook (USYHO)",
   label: "Sandy Hook (USYHO)"
  },
  {
   value: "Sandy Lake (USAYL)",
   label: "Sandy Lake (USAYL)"
  },
  {
   value: "Sandy River (USKSR)",
   label: "Sandy River (USKSR)"
  },
  {
   value: "Sandy Spring (USYZR)",
   label: "Sandy Spring (USYZR)"
  },
  {
   value: "Sandy Springs (USAYP)",
   label: "Sandy Springs (USAYP)"
  },
  {
   value: "Sandy Springs (USYSG)",
   label: "Sandy Springs (USYSG)"
  },
  {
   value: "Sandy Valley (USDV7)",
   label: "Sandy Valley (USDV7)"
  },
  {
   value: "Sanford (USSF6)",
   label: "Sanford (USSF6)"
  },
  {
   value: "Sanibel (USSBP)",
   label: "Sanibel (USSBP)"
  },
  {
   value: "Santa Clara (USSKR)",
   label: "Santa Clara (USSKR)"
  },
  {
   value: "Santa Claus (USSC6)",
   label: "Santa Claus (USSC6)"
  },
  {
   value: "Santa Elena (USTQA)",
   label: "Santa Elena (USTQA)"
  },
  {
   value: "Santa Fe (USFEZ)",
   label: "Santa Fe (USFEZ)"
  },
  {
   value: "Santa Margarita (USSMG)",
   label: "Santa Margarita (USSMG)"
  },
  {
   value: "Santa Rosa (USAOA)",
   label: "Santa Rosa (USAOA)"
  },
  {
   value: "Santa Rosa (USZRS)",
   label: "Santa Rosa (USZRS)"
  },
  {
   value: "Santa Rosa Beach (USJQJ)",
   label: "Santa Rosa Beach (USJQJ)"
  },
  {
   value: "Santa Rosa I. (USRO2)",
   label: "Santa Rosa I. (USRO2)"
  },
  {
   value: "Sapulpa (USAPU)",
   label: "Sapulpa (USAPU)"
  },
  {
   value: "Saraland (USSFQ)",
   label: "Saraland (USSFQ)"
  },
  {
   value: "Saranac (USSRN)",
   label: "Saranac (USSRN)"
  },
  {
   value: "Sarasota (USZOR)",
   label: "Sarasota (USZOR)"
  },
  {
   value: "Saratoga (USSAA)",
   label: "Saratoga (USSAA)"
  },
  {
   value: "Sardinia (USAII)",
   label: "Sardinia (USAII)"
  },
  {
   value: "Sarepta (USAEP)",
   label: "Sarepta (USAEP)"
  },
  {
   value: "Sartell (USSL4)",
   label: "Sartell (USSL4)"
  },
  {
   value: "Sasabe (USSAQ)",
   label: "Sasabe (USSAQ)"
  },
  {
   value: "Satellite Beach (USLTB)",
   label: "Satellite Beach (USLTB)"
  },
  {
   value: "Satsop (USZOP)",
   label: "Satsop (USZOP)"
  },
  {
   value: "Saucier (USS2R)",
   label: "Saucier (USS2R)"
  },
  {
   value: "Saugus (USUGU)",
   label: "Saugus (USUGU)"
  },
  {
   value: "Sauk Centre (USSC2)",
   label: "Sauk Centre (USSC2)"
  },
  {
   value: "Sauk City (USSC3)",
   label: "Sauk City (USSC3)"
  },
  {
   value: "Sauk Rapids (USSRA)",
   label: "Sauk Rapids (USSRA)"
  },
  {
   value: "Saukville (USVVV)",
   label: "Saukville (USVVV)"
  },
  {
   value: "Saunderstown (USZUN)",
   label: "Saunderstown (USZUN)"
  },
  {
   value: "Savage (USVGE)",
   label: "Savage (USVGE)"
  },
  {
   value: "Savannah (USSH8)",
   label: "Savannah (USSH8)"
  },
  {
   value: "Savannah (USTSA)",
   label: "Savannah (USTSA)"
  },
  {
   value: "Saverton (USVEJ)",
   label: "Saverton (USVEJ)"
  },
  {
   value: "Savoy (USOYT)",
   label: "Savoy (USOYT)"
  },
  {
   value: "Savoy (USSYG)",
   label: "Savoy (USSYG)"
  },
  {
   value: "Sawmills (USXYZ)",
   label: "Sawmills (USXYZ)"
  },
  {
   value: "Sawyer (USZFF)",
   label: "Sawyer (USZFF)"
  },
  {
   value: "Saxeville (USXVL)",
   label: "Saxeville (USXVL)"
  },
  {
   value: "Saxonburg (USSB2)",
   label: "Saxonburg (USSB2)"
  },
  {
   value: "Saxton (USAX2)",
   label: "Saxton (USAX2)"
  },
  {
   value: "Saybrook (USSB4)",
   label: "Saybrook (USSB4)"
  },
  {
   value: "Saylesville (USAYV)",
   label: "Saylesville (USAYV)"
  },
  {
   value: "Sayner (USYNY)",
   label: "Sayner (USYNY)"
  },
  {
   value: "Sayre (USAYJ)",
   label: "Sayre (USAYJ)"
  },
  {
   value: "Sayre (USSY2)",
   label: "Sayre (USSY2)"
  },
  {
   value: "Schaefferstown (USSFT)",
   label: "Schaefferstown (USSFT)"
  },
  {
   value: "Schaghticoke (USGHK)",
   label: "Schaghticoke (USGHK)"
  },
  {
   value: "Schaller (USSCX)",
   label: "Schaller (USSCX)"
  },
  {
   value: "Schenevus (USNVU)",
   label: "Schenevus (USNVU)"
  },
  {
   value: "Schererville (USSVL)",
   label: "Schererville (USSVL)"
  },
  {
   value: "Schodack Landing (USSKN)",
   label: "Schodack Landing (USSKN)"
  },
  {
   value: "Schoharie (USSR8)",
   label: "Schoharie (USSR8)"
  },
  {
   value: "Schoolcraft (USOLC)",
   label: "Schoolcraft (USOLC)"
  },
  {
   value: "Schulenburg (USSBW)",
   label: "Schulenburg (USSBW)"
  },
  {
   value: "Schuylerville (USSV3)",
   label: "Schuylerville (USSV3)"
  },
  {
   value: "Scott (USXOT)",
   label: "Scott (USXOT)"
  },
  {
   value: "Scott (USZKO)",
   label: "Scott (USZKO)"
  },
  {
   value: "Scott Air Force Base (USSB3)",
   label: "Scott Air Force Base (USSB3)"
  },
  {
   value: "Scott City (USZSN)",
   label: "Scott City (USZSN)"
  },
  {
   value: "Scott Depot (USDZQ)",
   label: "Scott Depot (USDZQ)"
  },
  {
   value: "Scotts (USXOS)",
   label: "Scotts (USXOS)"
  },
  {
   value: "Scotts Valley (USSV4)",
   label: "Scotts Valley (USSV4)"
  },
  {
   value: "Scottsboro (USSQB)",
   label: "Scottsboro (USSQB)"
  },
  {
   value: "Scottsburg (USOZG)",
   label: "Scottsburg (USOZG)"
  },
  {
   value: "Scottsburg (USSSZ)",
   label: "Scottsburg (USSSZ)"
  },
  {
   value: "Scottsville (USOTV)",
   label: "Scottsville (USOTV)"
  },
  {
   value: "Scottsville (USTTS)",
   label: "Scottsville (USTTS)"
  },
  {
   value: "Scranton (USRRA)",
   label: "Scranton (USRRA)"
  },
  {
   value: "Sea Island (USQSI)",
   label: "Sea Island (USQSI)"
  },
  {
   value: "Seabrook (USEBK)",
   label: "Seabrook (USEBK)"
  },
  {
   value: "Seabrook (USEQQ)",
   label: "Seabrook (USEQQ)"
  },
  {
   value: "Seaford (USQSF)",
   label: "Seaford (USQSF)"
  },
  {
   value: "Seagrove (USEOV)",
   label: "Seagrove (USEOV)"
  },
  {
   value: "Seal Bay (USSYB)",
   label: "Seal Bay (USSYB)"
  },
  {
   value: "Seal Rock (USZRK)",
   label: "Seal Rock (USZRK)"
  },
  {
   value: "Seale (USAQE)",
   label: "Seale (USAQE)"
  },
  {
   value: "Searles (USSL5)",
   label: "Searles (USSL5)"
  },
  {
   value: "Searsmont (USSM4)",
   label: "Searsmont (USSM4)"
  },
  {
   value: "Seaside (USYSE)",
   label: "Seaside (USYSE)"
  },
  {
   value: "Seaside Heights (USSH2)",
   label: "Seaside Heights (USSH2)"
  },
  {
   value: "Sebree (USYSB)",
   label: "Sebree (USYSB)"
  },
  {
   value: "Secane (USSC4)",
   label: "Secane (USSC4)"
  },
  {
   value: "Security (USZSY)",
   label: "Security (USZSY)"
  },
  {
   value: "Sedro Woolley (USSW2)",
   label: "Sedro Woolley (USSW2)"
  },
  {
   value: "Seeley (USSY4)",
   label: "Seeley (USSY4)"
  },
  {
   value: "Seffner (USEFF)",
   label: "Seffner (USEFF)"
  },
  {
   value: "Seguin (USSQU)",
   label: "Seguin (USSQU)"
  },
  {
   value: "Selah (USEHW)",
   label: "Selah (USEHW)"
  },
  {
   value: "Selbyville (USYVD)",
   label: "Selbyville (USYVD)"
  },
  {
   value: "Selkirk (USSKI)",
   label: "Selkirk (USSKI)"
  },
  {
   value: "Sellersville (USXVI)",
   label: "Sellersville (USXVI)"
  },
  {
   value: "Selma (USOSM)",
   label: "Selma (USOSM)"
  },
  {
   value: "Seminary (USEIY)",
   label: "Seminary (USEIY)"
  },
  {
   value: "Seminole (USZMD)",
   label: "Seminole (USZMD)"
  },
  {
   value: "Semmes (USEME)",
   label: "Semmes (USEME)"
  },
  {
   value: "Seneca (USEEC)",
   label: "Seneca (USEEC)"
  },
  {
   value: "Seneca Falls (USSFS)",
   label: "Seneca Falls (USSFS)"
  },
  {
   value: "Senoia (USSN2)",
   label: "Senoia (USSN2)"
  },
  {
   value: "Sequin (USTSQ)",
   label: "Sequin (USTSQ)"
  },
  {
   value: "Serena (USKSS)",
   label: "Serena (USKSS)"
  },
  {
   value: "Sergeant Bluff (USSGB)",
   label: "Sergeant Bluff (USSGB)"
  },
  {
   value: "Seven Points (USEVP)",
   label: "Seven Points (USEVP)"
  },
  {
   value: "Seville (USZVL)",
   label: "Seville (USZVL)"
  },
  {
   value: "Seward (USNSR)",
   label: "Seward (USNSR)"
  },
  {
   value: "Seward (USQSR)",
   label: "Seward (USQSR)"
  },
  {
   value: "Sewell (USYSW)",
   label: "Sewell (USYSW)"
  },
  {
   value: "Sewickley (USEWC)",
   label: "Sewickley (USEWC)"
  },
  {
   value: "Seymour (USEOU)",
   label: "Seymour (USEOU)"
  },
  {
   value: "Seymour (USEYU)",
   label: "Seymour (USEYU)"
  },
  {
   value: "Shade Gap (USDGP)",
   label: "Shade Gap (USDGP)"
  },
  {
   value: "Shadeland, Tippecanoe (USAD2)",
   label: "Shadeland, Tippecanoe (USAD2)"
  },
  {
   value: "Shady Grove (USDYG)",
   label: "Shady Grove (USDYG)"
  },
  {
   value: "Shady Spring (USRYS)",
   label: "Shady Spring (USRYS)"
  },
  {
   value: "Shafter, Kern (USSH3)",
   label: "Shafter, Kern (USSH3)"
  },
  {
   value: "Shaker Heights (USXSK)",
   label: "Shaker Heights (USXSK)"
  },
  {
   value: "Shalimar (USSR4)",
   label: "Shalimar (USSR4)"
  },
  {
   value: "Shamokin (USYSH)",
   label: "Shamokin (USYSH)"
  },
  {
   value: "Shamong (USSH4)",
   label: "Shamong (USSH4)"
  },
  {
   value: "Shamrock, Wheeler (USSR5)",
   label: "Shamrock, Wheeler (USSR5)"
  },
  {
   value: "Shandon (USDOZ)",
   label: "Shandon (USDOZ)"
  },
  {
   value: "Shannock (USAZK)",
   label: "Shannock (USAZK)"
  },
  {
   value: "Sharon (USISH)",
   label: "Sharon (USISH)"
  },
  {
   value: "Sharon (USSN3)",
   label: "Sharon (USSN3)"
  },
  {
   value: "Sharon Center (USCXZ)",
   label: "Sharon Center (USCXZ)"
  },
  {
   value: "Sharpsburg (USRPB)",
   label: "Sharpsburg (USRPB)"
  },
  {
   value: "Shartlesville (USSL8)",
   label: "Shartlesville (USSL8)"
  },
  {
   value: "Shaw Air Force Base (USZFH)",
   label: "Shaw Air Force Base (USZFH)"
  },
  {
   value: "Shawnee Mission (USSM2)",
   label: "Shawnee Mission (USSM2)"
  },
  {
   value: "Shedd (USYSD)",
   label: "Shedd (USYSD)"
  },
  {
   value: "Sheffield (USHEI)",
   label: "Sheffield (USHEI)"
  },
  {
   value: "Sheffield (USQSH)",
   label: "Sheffield (USQSH)"
  },
  {
   value: "Sheffield (USSED)",
   label: "Sheffield (USSED)"
  },
  {
   value: "Shelburne (USSB8)",
   label: "Shelburne (USSB8)"
  },
  {
   value: "Shelburne Falls (USHFS)",
   label: "Shelburne Falls (USHFS)"
  },
  {
   value: "Shelby (USINH)",
   label: "Shelby (USINH)"
  },
  {
   value: "Shelby (USISY)",
   label: "Shelby (USISY)"
  },
  {
   value: "Shelby (USSBI)",
   label: "Shelby (USSBI)"
  },
  {
   value: "Shelby (USSDL)",
   label: "Shelby (USSDL)"
  },
  {
   value: "Shelby Township (USSN8)",
   label: "Shelby Township (USSN8)"
  },
  {
   value: "Shelbyville (USIYE)",
   label: "Shelbyville (USIYE)"
  },
  {
   value: "Shell Knob (USEOB)",
   label: "Shell Knob (USEOB)"
  },
  {
   value: "Shell Lake (USHL8)",
   label: "Shell Lake (USHL8)"
  },
  {
   value: "Shell Rock (USSR2)",
   label: "Shell Rock (USSR2)"
  },
  {
   value: "Shelter Island (USXSI)",
   label: "Shelter Island (USXSI)"
  },
  {
   value: "Shelton (USJLT)",
   label: "Shelton (USJLT)"
  },
  {
   value: "Shenandoah (USSDH)",
   label: "Shenandoah (USSDH)"
  },
  {
   value: "Shepherd (USEFH)",
   label: "Shepherd (USEFH)"
  },
  {
   value: "Shepherd (USHHD)",
   label: "Shepherd (USHHD)"
  },
  {
   value: "Sheppard (USXSX)",
   label: "Sheppard (USXSX)"
  },
  {
   value: "Sherborn (USZSO)",
   label: "Sherborn (USZSO)"
  },
  {
   value: "Sheridan (USSDV)",
   label: "Sheridan (USSDV)"
  },
  {
   value: "Sherman-Denison (USPNX)",
   label: "Sherman-Denison (USPNX)"
  },
  {
   value: "Sherrill (USRRI)",
   label: "Sherrill (USRRI)"
  },
  {
   value: "Sherwood (USSR7)",
   label: "Sherwood (USSR7)"
  },
  {
   value: "Sherwood (USYRW)",
   label: "Sherwood (USYRW)"
  },
  {
   value: "Shidler (USIDK)",
   label: "Shidler (USIDK)"
  },
  {
   value: "Shiloh (USILH)",
   label: "Shiloh (USILH)"
  },
  {
   value: "Shiloh (USVVO)",
   label: "Shiloh (USVVO)"
  },
  {
   value: "Shiner (USINR)",
   label: "Shiner (USINR)"
  },
  {
   value: "Shingle Springs (USXSH)",
   label: "Shingle Springs (USXSH)"
  },
  {
   value: "Shinnston (USSKF)",
   label: "Shinnston (USSKF)"
  },
  {
   value: "Shippensburg (USSSG)",
   label: "Shippensburg (USSSG)"
  },
  {
   value: "Shippenville (USYNV)",
   label: "Shippenville (USYNV)"
  },
  {
   value: "Shipshewana (USQQS)",
   label: "Shipshewana (USQQS)"
  },
  {
   value: "Shipshewana (USS2P)",
   label: "Shipshewana (USS2P)"
  },
  {
   value: "Shirleysburg (USSB6)",
   label: "Shirleysburg (USSB6)"
  },
  {
   value: "Shively (USIVE)",
   label: "Shively (USIVE)"
  },
  {
   value: "Shoals (USYHZ)",
   label: "Shoals (USYHZ)"
  },
  {
   value: "Shokan (USXSA)",
   label: "Shokan (USXSA)"
  },
  {
   value: "Shorewood (USSW3)",
   label: "Shorewood (USSW3)"
  },
  {
   value: "Short Hills (USXSY)",
   label: "Short Hills (USXSY)"
  },
  {
   value: "Shorter (USEOH)",
   label: "Shorter (USEOH)"
  },
  {
   value: "Shorterville (USTRV)",
   label: "Shorterville (USTRV)"
  },
  {
   value: "Shortsville (USSS8)",
   label: "Shortsville (USSS8)"
  },
  {
   value: "Shreve (USOHS)",
   label: "Shreve (USOHS)"
  },
  {
   value: "Shrewsbury (USEZY)",
   label: "Shrewsbury (USEZY)"
  },
  {
   value: "Shrewsbury (USQSY)",
   label: "Shrewsbury (USQSY)"
  },
  {
   value: "Shullsburg (USHJB)",
   label: "Shullsburg (USHJB)"
  },
  {
   value: "Sibley (USZSL)",
   label: "Sibley (USZSL)"
  },
  {
   value: "Sicklerville (USSV5)",
   label: "Sicklerville (USSV5)"
  },
  {
   value: "Sidell (USSD3)",
   label: "Sidell (USSD3)"
  },
  {
   value: "Sidney (USIJY)",
   label: "Sidney (USIJY)"
  },
  {
   value: "Sidney (USSDN)",
   label: "Sidney (USSDN)"
  },
  {
   value: "Sidon (USIDM)",
   label: "Sidon (USIDM)"
  },
  {
   value: "Sierra Vista (USAZS)",
   label: "Sierra Vista (USAZS)"
  },
  {
   value: "Silver Creek (USHQ6)",
   label: "Silver Creek (USHQ6)"
  },
  {
   value: "Silver Creek (USZII)",
   label: "Silver Creek (USZII)"
  },
  {
   value: "Silver Grove (USVKY)",
   label: "Silver Grove (USVKY)"
  },
  {
   value: "Silver Lake (USILK)",
   label: "Silver Lake (USILK)"
  },
  {
   value: "Silver Lake (USIXL)",
   label: "Silver Lake (USIXL)"
  },
  {
   value: "Silver Peak (USIVP)",
   label: "Silver Peak (USIVP)"
  },
  {
   value: "Silver Springs (USSVR)",
   label: "Silver Springs (USSVR)"
  },
  {
   value: "Silver Star (USITK)",
   label: "Silver Star (USITK)"
  },
  {
   value: "Silverton (USIER)",
   label: "Silverton (USIER)"
  },
  {
   value: "Silverton (USILJ)",
   label: "Silverton (USILJ)"
  },
  {
   value: "Silverton (USVET)",
   label: "Silverton (USVET)"
  },
  {
   value: "Silverton (USXVN)",
   label: "Silverton (USXVN)"
  },
  {
   value: "Silvis (USILV)",
   label: "Silvis (USILV)"
  },
  {
   value: "Simpson (USUKJ)",
   label: "Simpson (USUKJ)"
  },
  {
   value: "Sims (USIMC)",
   label: "Sims (USIMC)"
  },
  {
   value: "Simsbury (USSZU)",
   label: "Simsbury (USSZU)"
  },
  {
   value: "Sinclair (USSC7)",
   label: "Sinclair (USSC7)"
  },
  {
   value: "Singer (USIGR)",
   label: "Singer (USIGR)"
  },
  {
   value: "Siren (USIRE)",
   label: "Siren (USIRE)"
  },
  {
   value: "Sisseton (USSS2)",
   label: "Sisseton (USSS2)"
  },
  {
   value: "Sissonville (USISV)",
   label: "Sissonville (USISV)"
  },
  {
   value: "Sisters (USYER)",
   label: "Sisters (USYER)"
  },
  {
   value: "Sistersville (USIST)",
   label: "Sistersville (USIST)"
  },
  {
   value: "Sitkinak Island (USSKJ)",
   label: "Sitkinak Island (USSKJ)"
  },
  {
   value: "Sixes (USKSX)",
   label: "Sixes (USKSX)"
  },
  {
   value: "Skaneateles (USKNE)",
   label: "Skaneateles (USKNE)"
  },
  {
   value: "Skaneateles Falls (USKAF)",
   label: "Skaneateles Falls (USKAF)"
  },
  {
   value: "Skippack (USSP3)",
   label: "Skippack (USSP3)"
  },
  {
   value: "Skippers (USSKP)",
   label: "Skippers (USSKP)"
  },
  {
   value: "Skowhegan (USSH5)",
   label: "Skowhegan (USSH5)"
  },
  {
   value: "Slater (USSQX)",
   label: "Slater (USSQX)"
  },
  {
   value: "Slaughter (USUHT)",
   label: "Slaughter (USUHT)"
  },
  {
   value: "Slayton (USSY8)",
   label: "Slayton (USSY8)"
  },
  {
   value: "Sledge Island (USSI2)",
   label: "Sledge Island (USSI2)"
  },
  {
   value: "Slinger (USIGE)",
   label: "Slinger (USIGE)"
  },
  {
   value: "Sloatsburg (USOTB)",
   label: "Sloatsburg (USOTB)"
  },
  {
   value: "Smackover (USSK4)",
   label: "Smackover (USSK4)"
  },
  {
   value: "Smarr (USRQA)",
   label: "Smarr (USRQA)"
  },
  {
   value: "Smelterville (USYSV)",
   label: "Smelterville (USYSV)"
  },
  {
   value: "Smethport (USTTH)",
   label: "Smethport (USTTH)"
  },
  {
   value: "Smithfield (USFTU)",
   label: "Smithfield (USFTU)"
  },
  {
   value: "Smithfield (USSF3)",
   label: "Smithfield (USSF3)"
  },
  {
   value: "Smiths (USZSM)",
   label: "Smiths (USZSM)"
  },
  {
   value: "Smithton (USITN)",
   label: "Smithton (USITN)"
  },
  {
   value: "Smithtown (USSTY)",
   label: "Smithtown (USSTY)"
  },
  {
   value: "Smithville (USSKH)",
   label: "Smithville (USSKH)"
  },
  {
   value: "Smithville (USXT8)",
   label: "Smithville (USXT8)"
  },
  {
   value: "Smithville (USYSM)",
   label: "Smithville (USYSM)"
  },
  {
   value: "Smithville, Bastrop (USS2V)",
   label: "Smithville, Bastrop (USS2V)"
  },
  {
   value: "Smithville, Ritchie (USQSM)",
   label: "Smithville, Ritchie (USQSM)"
  },
  {
   value: "Smithville, Wayne (USIHV)",
   label: "Smithville, Wayne (USIHV)"
  },
  {
   value: "Smock (USQSQ)",
   label: "Smock (USQSQ)"
  },
  {
   value: "Smoketown (USKTW)",
   label: "Smoketown (USKTW)"
  },
  {
   value: "Smokey Point (USYSK)",
   label: "Smokey Point (USYSK)"
  },
  {
   value: "Smyrna (USNYY)",
   label: "Smyrna (USNYY)"
  },
  {
   value: "Sneads (USQSD)",
   label: "Sneads (USQSD)"
  },
  {
   value: "Sneads Ferry (USSKD)",
   label: "Sneads Ferry (USSKD)"
  },
  {
   value: "Snellville (USSEE)",
   label: "Snellville (USSEE)"
  },
  {
   value: "Snohomish (USSNI)",
   label: "Snohomish (USSNI)"
  },
  {
   value: "Snoqualmie (USNQA)",
   label: "Snoqualmie (USNQA)"
  },
  {
   value: "Snow Hill (USXSW)",
   label: "Snow Hill (USXSW)"
  },
  {
   value: "Snowshoe (USSN5)",
   label: "Snowshoe (USSN5)"
  },
  {
   value: "Snyder (USNYD)",
   label: "Snyder (USNYD)"
  },
  {
   value: "Snyder (USNYR)",
   label: "Snyder (USNYR)"
  },
  {
   value: "Social Circle (USOCR)",
   label: "Social Circle (USOCR)"
  },
  {
   value: "Socorro (USXSR)",
   label: "Socorro (USXSR)"
  },
  {
   value: "Soda Springs (USYSS)",
   label: "Soda Springs (USYSS)"
  },
  {
   value: "Soledad (USZOL)",
   label: "Soledad (USZOL)"
  },
  {
   value: "Solomon (USSZO)",
   label: "Solomon (USSZO)"
  },
  {
   value: "Solomons (USOMU)",
   label: "Solomons (USOMU)"
  },
  {
   value: "Solvang (USOLG)",
   label: "Solvang (USOLG)"
  },
  {
   value: "Solvay (USOVA)",
   label: "Solvay (USOVA)"
  },
  {
   value: "Somers (USOJS)",
   label: "Somers (USOJS)"
  },
  {
   value: "Somers (USTSF)",
   label: "Somers (USTSF)"
  },
  {
   value: "Somerset (USOMP)",
   label: "Somerset (USOMP)"
  },
  {
   value: "Somerset (USOMT)",
   label: "Somerset (USOMT)"
  },
  {
   value: "Somerset (USSS3)",
   label: "Somerset (USSS3)"
  },
  {
   value: "Somersville (USOFV)",
   label: "Somersville (USOFV)"
  },
  {
   value: "Somerville (USILX)",
   label: "Somerville (USILX)"
  },
  {
   value: "Somerville (USOMV)",
   label: "Somerville (USOMV)"
  },
  {
   value: "Somerville (USQSV)",
   label: "Somerville (USQSV)"
  },
  {
   value: "Sonora (USKTY)",
   label: "Sonora (USKTY)"
  },
  {
   value: "Soquel (USSQQ)",
   label: "Soquel (USSQQ)"
  },
  {
   value: "Sorrento (USOET)",
   label: "Sorrento (USOET)"
  },
  {
   value: "Sorrento (USRRN)",
   label: "Sorrento (USRRN)"
  },
  {
   value: "South Amboy (USZZM)",
   label: "South Amboy (USZZM)"
  },
  {
   value: "South Barre (USSB5)",
   label: "South Barre (USSB5)"
  },
  {
   value: "South Barrington (USUHB)",
   label: "South Barrington (USUHB)"
  },
  {
   value: "South Beach (USBS6)",
   label: "South Beach (USBS6)"
  },
  {
   value: "South Boardman (USTBM)",
   label: "South Boardman (USTBM)"
  },
  {
   value: "South Charleston (USOUL)",
   label: "South Charleston (USOUL)"
  },
  {
   value: "South Chicago Heights (USOUS)",
   label: "South Chicago Heights (USOUS)"
  },
  {
   value: "South Dartmouth (USODT)",
   label: "South Dartmouth (USODT)"
  },
  {
   value: "South Deerfield (USDDF)",
   label: "South Deerfield (USDDF)"
  },
  {
   value: "South Dennis (USUHS)",
   label: "South Dennis (USUHS)"
  },
  {
   value: "South Easton (USQSN)",
   label: "South Easton (USQSN)"
  },
  {
   value: "South Elgin (USSE2)",
   label: "South Elgin (USSE2)"
  },
  {
   value: "South Gate (USOUG)",
   label: "South Gate (USOUG)"
  },
  {
   value: "South Glastonbury (USYSY)",
   label: "South Glastonbury (USYSY)"
  },
  {
   value: "South Hackensack\/New Jersey (USHKS)",
   label: "South Hackensack\/New Jersey (USHKS)"
  },
  {
   value: "South Hampton (USZJX)",
   label: "South Hampton (USZJX)"
  },
  {
   value: "South Houston (USHQU)",
   label: "South Houston (USHQU)"
  },
  {
   value: "South Jordan (USXSJ)",
   label: "South Jordan (USXSJ)"
  },
  {
   value: "South Kearny (USSK2)",
   label: "South Kearny (USSK2)"
  },
  {
   value: "South Londonderry (USTDY)",
   label: "South Londonderry (USTDY)"
  },
  {
   value: "South Milford (USMR8)",
   label: "South Milford (USMR8)"
  },
  {
   value: "South Orange (USTHX)",
   label: "South Orange (USTHX)"
  },
  {
   value: "South Padre I. (USPXD)",
   label: "South Padre I. (USPXD)"
  },
  {
   value: "South Plainfield (USSFD)",
   label: "South Plainfield (USSFD)"
  },
  {
   value: "South Rockwood (USSR3)",
   label: "South Rockwood (USSR3)"
  },
  {
   value: "South Roxana (USRXS)",
   label: "South Roxana (USRXS)"
  },
  {
   value: "South Royalton (USYLN)",
   label: "South Royalton (USYLN)"
  },
  {
   value: "South Sioux City (USSSO)",
   label: "South Sioux City (USSSO)"
  },
  {
   value: "South Union (USYSU)",
   label: "South Union (USYSU)"
  },
  {
   value: "South Vienna (USSV8)",
   label: "South Vienna (USSV8)"
  },
  {
   value: "South Walpole (USQSW)",
   label: "South Walpole (USQSW)"
  },
  {
   value: "South Webster (USWWB)",
   label: "South Webster (USWWB)"
  },
  {
   value: "South West City (USSW4)",
   label: "South West City (USSW4)"
  },
  {
   value: "South Weymouth (USNZW)",
   label: "South Weymouth (USNZW)"
  },
  {
   value: "South Willamsport (USIOH)",
   label: "South Willamsport (USIOH)"
  },
  {
   value: "South Windham (USUWH)",
   label: "South Windham (USUWH)"
  },
  {
   value: "South Yarmouth (USOUY)",
   label: "South Yarmouth (USOUY)"
  },
  {
   value: "Southampton (USZFJ)",
   label: "Southampton (USZFJ)"
  },
  {
   value: "Southbridge (USTHD)",
   label: "Southbridge (USTHD)"
  },
  {
   value: "Southfield (USSFX)",
   label: "Southfield (USSFX)"
  },
  {
   value: "Southfields (USTFS)",
   label: "Southfields (USTFS)"
  },
  {
   value: "Southgate (USOUH)",
   label: "Southgate (USOUH)"
  },
  {
   value: "Southold (USOUX)",
   label: "Southold (USOUX)"
  },
  {
   value: "Southport (USSP4)",
   label: "Southport (USSP4)"
  },
  {
   value: "Spangle (USISG)",
   label: "Spangle (USISG)"
  },
  {
   value: "Spanish Fort (USIFO)",
   label: "Spanish Fort (USIFO)"
  },
  {
   value: "Sparrow Bush (USPWU)",
   label: "Sparrow Bush (USPWU)"
  },
  {
   value: "Sparrows Point (USPPO)",
   label: "Sparrows Point (USPPO)"
  },
  {
   value: "Sparta (USAA5)",
   label: "Sparta (USAA5)"
  },
  {
   value: "Sparta (USZSR)",
   label: "Sparta (USZSR)"
  },
  {
   value: "Spearman (USOPM)",
   label: "Spearman (USOPM)"
  },
  {
   value: "Spearville (USKRI)",
   label: "Spearville (USKRI)"
  },
  {
   value: "Speed (USQSP)",
   label: "Speed (USQSP)"
  },
  {
   value: "Spencer (USECR)",
   label: "Spencer (USECR)"
  },
  {
   value: "Spencer (USRWQ)",
   label: "Spencer (USRWQ)"
  },
  {
   value: "Spencer (USSC8)",
   label: "Spencer (USSC8)"
  },
  {
   value: "Spencer (USSPR)",
   label: "Spencer (USSPR)"
  },
  {
   value: "Spencer (USWVP)",
   label: "Spencer (USWVP)"
  },
  {
   value: "Spencerport (USSP6)",
   label: "Spencerport (USSP6)"
  },
  {
   value: "Spencerville (USECE)",
   label: "Spencerville (USECE)"
  },
  {
   value: "Sperry (USEHY)",
   label: "Sperry (USEHY)"
  },
  {
   value: "Spiceland (USICE)",
   label: "Spiceland (USICE)"
  },
  {
   value: "Spicewood (USSKV)",
   label: "Spicewood (USSKV)"
  },
  {
   value: "Spirit Lake (USPL8)",
   label: "Spirit Lake (USPL8)"
  },
  {
   value: "Splendora (USSD8)",
   label: "Splendora (USSD8)"
  },
  {
   value: "Spofford (USPFZ)",
   label: "Spofford (USPFZ)"
  },
  {
   value: "Spokane Valley (USPKV)",
   label: "Spokane Valley (USPKV)"
  },
  {
   value: "Spotsylvania (USXXO)",
   label: "Spotsylvania (USXXO)"
  },
  {
   value: "Spraggs (USP9)",
   label: "Spraggs (USP9)"
  },
  {
   value: "Spring Arbor (USNGA)",
   label: "Spring Arbor (USNGA)"
  },
  {
   value: "Spring City (USSGD)",
   label: "Spring City (USSGD)"
  },
  {
   value: "Spring Creek (USIGC)",
   label: "Spring Creek (USIGC)"
  },
  {
   value: "Spring Green (USQSG)",
   label: "Spring Green (USQSG)"
  },
  {
   value: "Spring Grove (USPVM)",
   label: "Spring Grove (USPVM)"
  },
  {
   value: "Spring Grove (USSG3)",
   label: "Spring Grove (USSG3)"
  },
  {
   value: "Spring Grove (USZSG)",
   label: "Spring Grove (USZSG)"
  },
  {
   value: "Spring Hill (USIR3)",
   label: "Spring Hill (USIR3)"
  },
  {
   value: "Spring Hill (USRGI)",
   label: "Spring Hill (USRGI)"
  },
  {
   value: "Spring House (USSFH)",
   label: "Spring House (USSFH)"
  },
  {
   value: "Spring Lake (USSL3)",
   label: "Spring Lake (USSL3)"
  },
  {
   value: "Spring Lake (USZPL)",
   label: "Spring Lake (USZPL)"
  },
  {
   value: "Spring Lake Park (USRLH)",
   label: "Spring Lake Park (USRLH)"
  },
  {
   value: "Spring Valley (USJVJ)",
   label: "Spring Valley (USJVJ)"
  },
  {
   value: "Spring Valley (USVYW)",
   label: "Spring Valley (USVYW)"
  },
  {
   value: "Spring Valley, San Diego (USPGY)",
   label: "Spring Valley, San Diego (USPGY)"
  },
  {
   value: "Springerville (USAZV)",
   label: "Springerville (USAZV)"
  },
  {
   value: "Springfield (USIED)",
   label: "Springfield (USIED)"
  },
  {
   value: "Springfield (USIGI)",
   label: "Springfield (USIGI)"
  },
  {
   value: "Springfield (USIID)",
   label: "Springfield (USIID)"
  },
  {
   value: "Springfield (USNGF)",
   label: "Springfield (USNGF)"
  },
  {
   value: "Springfield (USRNF)",
   label: "Springfield (USRNF)"
  },
  {
   value: "Springfield (USSNF)",
   label: "Springfield (USSNF)"
  },
  {
   value: "Springfield Gardens (USSFG)",
   label: "Springfield Gardens (USSFG)"
  },
  {
   value: "Springfield, Calhoun (USVSJ)",
   label: "Springfield, Calhoun (USVSJ)"
  },
  {
   value: "Springhills (USRGK)",
   label: "Springhills (USRGK)"
  },
  {
   value: "Springlake (USSGP)",
   label: "Springlake (USSGP)"
  },
  {
   value: "Springport, Jackson (USSP7)",
   label: "Springport, Jackson (USSP7)"
  },
  {
   value: "Springville (USIGL)",
   label: "Springville (USIGL)"
  },
  {
   value: "Springville (USSG5)",
   label: "Springville (USSG5)"
  },
  {
   value: "Springville (USSG8)",
   label: "Springville (USSG8)"
  },
  {
   value: "Springville (USSNU)",
   label: "Springville (USSNU)"
  },
  {
   value: "Springville, Suffolk (USXPG)",
   label: "Springville, Suffolk (USXPG)"
  },
  {
   value: "Sproul (USYSP)",
   label: "Sproul (USYSP)"
  },
  {
   value: "Spruce Head (USUHD)",
   label: "Spruce Head (USUHD)"
  },
  {
   value: "Spurger (USUEC)",
   label: "Spurger (USUEC)"
  },
  {
   value: "St Charles (USTCA)",
   label: "St Charles (USTCA)"
  },
  {
   value: "St Genevieve (USTGN)",
   label: "St Genevieve (USTGN)"
  },
  {
   value: "St Albans (USSA3)",
   label: "St Albans (USSA3)"
  },
  {
   value: "St Albans (USTBA)",
   label: "St Albans (USTBA)"
  },
  {
   value: "St Albans (USTDA)",
   label: "St Albans (USTDA)"
  },
  {
   value: "St Albans (USZUY)",
   label: "St Albans (USZUY)"
  },
  {
   value: "St Ann (USSA4)",
   label: "St Ann (USSA4)"
  },
  {
   value: "St Ansgar (USJSS)",
   label: "St Ansgar (USJSS)"
  },
  {
   value: "St Anthony (USOSJ)",
   label: "St Anthony (USOSJ)"
  },
  {
   value: "St Augustine (USUST)",
   label: "St Augustine (USUST)"
  },
  {
   value: "St Bonifacius (USIFC)",
   label: "St Bonifacius (USIFC)"
  },
  {
   value: "St Charles (USXTJ)",
   label: "St Charles (USXTJ)"
  },
  {
   value: "St Charles (USZIB)",
   label: "St Charles (USZIB)"
  },
  {
   value: "St Clair (USST7)",
   label: "St Clair (USST7)"
  },
  {
   value: "St Clair Shores (USCS4)",
   label: "St Clair Shores (USCS4)"
  },
  {
   value: "St Clair Shores (USQSS)",
   label: "St Clair Shores (USQSS)"
  },
  {
   value: "St Clair, Franklin (USLIK)",
   label: "St Clair, Franklin (USLIK)"
  },
  {
   value: "St Croix (USTCX)",
   label: "St Croix (USTCX)"
  },
  {
   value: "St Croix Falls (USTCO)",
   label: "St Croix Falls (USTCO)"
  },
  {
   value: "St Francis (USSF2)",
   label: "St Francis (USSF2)"
  },
  {
   value: "St James (USSJ2)",
   label: "St James (USSJ2)"
  },
  {
   value: "St James City (USJSY)",
   label: "St James City (USJSY)"
  },
  {
   value: "St Jo (USSJ3)",
   label: "St Jo (USSJ3)"
  },
  {
   value: "St Joe (USJJE)",
   label: "St Joe (USJJE)"
  },
  {
   value: "St John (USJHH)",
   label: "St John (USJHH)"
  },
  {
   value: "St John (USSJO)",
   label: "St John (USSJO)"
  },
  {
   value: "St Johns (USSJ4)",
   label: "St Johns (USSJ4)"
  },
  {
   value: "St Johnsbury (USJBY)",
   label: "St Johnsbury (USJBY)"
  },
  {
   value: "St Johnsville (USTOU)",
   label: "St Johnsville (USTOU)"
  },
  {
   value: "St Louis (USSYT)",
   label: "St Louis (USSYT)"
  },
  {
   value: "St Louis (USUIS)",
   label: "St Louis (USUIS)"
  },
  {
   value: "St Louis (USUTS)",
   label: "St Louis (USUTS)"
  },
  {
   value: "St Louisville (USTSY)",
   label: "St Louisville (USTSY)"
  },
  {
   value: "St Lucie (USSL2)",
   label: "St Lucie (USSL2)"
  },
  {
   value: "St Martin (USSJ5)",
   label: "St Martin (USSJ5)"
  },
  {
   value: "St Martinville (USSKM)",
   label: "St Martinville (USSKM)"
  },
  {
   value: "St Marys (USJIO)",
   label: "St Marys (USJIO)"
  },
  {
   value: "St Marys (USKSM)",
   label: "St Marys (USKSM)"
  },
  {
   value: "St Marys (USSMR)",
   label: "St Marys (USSMR)"
  },
  {
   value: "St Marys (USYNM)",
   label: "St Marys (USYNM)"
  },
  {
   value: "St Marys City (USXSM)",
   label: "St Marys City (USXSM)"
  },
  {
   value: "St Michael (USTMI)",
   label: "St Michael (USTMI)"
  },
  {
   value: "St Paris (USIFS)",
   label: "St Paris (USIFS)"
  },
  {
   value: "St Paul (USNPU)",
   label: "St Paul (USNPU)"
  },
  {
   value: "St Paul (USPA3)",
   label: "St Paul (USPA3)"
  },
  {
   value: "St Paul (USPAJ)",
   label: "St Paul (USPAJ)"
  },
  {
   value: "St Paul (USSAL)",
   label: "St Paul (USSAL)"
  },
  {
   value: "St Peters (USQSZ)",
   label: "St Peters (USQSZ)"
  },
  {
   value: "St Stephen (USZSH)",
   label: "St Stephen (USZSH)"
  },
  {
   value: "St Thomas (USITQ)",
   label: "St Thomas (USITQ)"
  },
  {
   value: "Stacy (USKSY)",
   label: "Stacy (USKSY)"
  },
  {
   value: "Stafford (USJCU)",
   label: "Stafford (USJCU)"
  },
  {
   value: "Stafford (USVSZ)",
   label: "Stafford (USVSZ)"
  },
  {
   value: "Stafford (USXTF)",
   label: "Stafford (USXTF)"
  },
  {
   value: "Stallings (USTAI)",
   label: "Stallings (USTAI)"
  },
  {
   value: "Stanberry (USTNB)",
   label: "Stanberry (USTNB)"
  },
  {
   value: "Standish (USSH6)",
   label: "Standish (USSH6)"
  },
  {
   value: "Standish (USTDH)",
   label: "Standish (USTDH)"
  },
  {
   value: "Stanfield (USSF5)",
   label: "Stanfield (USSF5)"
  },
  {
   value: "Stanfield (USSF8)",
   label: "Stanfield (USSF8)"
  },
  {
   value: "Stanfield (USTFD)",
   label: "Stanfield (USTFD)"
  },
  {
   value: "Stanford (USTAN)",
   label: "Stanford (USTAN)"
  },
  {
   value: "Stanford (USTNQ)",
   label: "Stanford (USTNQ)"
  },
  {
   value: "Stanley (USNYL)",
   label: "Stanley (USNYL)"
  },
  {
   value: "Stanton (USSO7)",
   label: "Stanton (USSO7)"
  },
  {
   value: "Stanton (USZJA)",
   label: "Stanton (USZJA)"
  },
  {
   value: "Staples (USVVK)",
   label: "Staples (USVVK)"
  },
  {
   value: "Stapleton (USTAE)",
   label: "Stapleton (USTAE)"
  },
  {
   value: "Stapleton (USTPN)",
   label: "Stapleton (USTPN)"
  },
  {
   value: "Stapleton (USVSQ)",
   label: "Stapleton (USVSQ)"
  },
  {
   value: "Star (USKTA)",
   label: "Star (USKTA)"
  },
  {
   value: "Star (USYRX)",
   label: "Star (USYRX)"
  },
  {
   value: "Starkville (USSXK)",
   label: "Starkville (USSXK)"
  },
  {
   value: "Starr (USXAR)",
   label: "Starr (USXAR)"
  },
  {
   value: "Startup (USSU2)",
   label: "Startup (USSU2)"
  },
  {
   value: "Stateline (USTTI)",
   label: "Stateline (USTTI)"
  },
  {
   value: "Statesville (USZIQ)",
   label: "Statesville (USZIQ)"
  },
  {
   value: "Staunton (USUNT)",
   label: "Staunton (USUNT)"
  },
  {
   value: "Ste Genevieve (USSG2)",
   label: "Ste Genevieve (USSG2)"
  },
  {
   value: "Stearns (USTAS)",
   label: "Stearns (USTAS)"
  },
  {
   value: "Stedman (USYDM)",
   label: "Stedman (USYDM)"
  },
  {
   value: "Steele (USQTL)",
   label: "Steele (USQTL)"
  },
  {
   value: "Steele (USSXI)",
   label: "Steele (USSXI)"
  },
  {
   value: "Steeleville (USVTS)",
   label: "Steeleville (USVTS)"
  },
  {
   value: "Steelton (USQQX)",
   label: "Steelton (USQQX)"
  },
  {
   value: "Stennis Space Center (USTST)",
   label: "Stennis Space Center (USTST)"
  },
  {
   value: "Stephen (USZSP)",
   label: "Stephen (USZSP)"
  },
  {
   value: "Stephenson (USEPS)",
   label: "Stephenson (USEPS)"
  },
  {
   value: "Stephentown (USTEP)",
   label: "Stephentown (USTEP)"
  },
  {
   value: "Sterling (USSKA)",
   label: "Sterling (USSKA)"
  },
  {
   value: "Sterling City (USYTE)",
   label: "Sterling City (USYTE)"
  },
  {
   value: "Sterling-Rockfalls Apt (USSQI)",
   label: "Sterling-Rockfalls Apt (USSQI)"
  },
  {
   value: "Stevens (USSS7)",
   label: "Stevens (USSS7)"
  },
  {
   value: "Stevensburg (USZSB)",
   label: "Stevensburg (USZSB)"
  },
  {
   value: "Stevensville (USSLW)",
   label: "Stevensville (USSLW)"
  },
  {
   value: "Stevensville (USTES)",
   label: "Stevensville (USTES)"
  },
  {
   value: "Stewart (USTER)",
   label: "Stewart (USTER)"
  },
  {
   value: "Stewart (USTWT)",
   label: "Stewart (USTWT)"
  },
  {
   value: "Stewart, McLeod (USTWM)",
   label: "Stewart, McLeod (USTWM)"
  },
  {
   value: "Stewartville (USSV7)",
   label: "Stewartville (USSV7)"
  },
  {
   value: "Stickney (USSKT)",
   label: "Stickney (USSKT)"
  },
  {
   value: "Stigler (USVVR)",
   label: "Stigler (USVVR)"
  },
  {
   value: "Stillmore (USLLM)",
   label: "Stillmore (USLLM)"
  },
  {
   value: "Stillwater (USIAK)",
   label: "Stillwater (USIAK)"
  },
  {
   value: "Stillwater (USTIS)",
   label: "Stillwater (USTIS)"
  },
  {
   value: "Stillwater (USVSW)",
   label: "Stillwater (USVSW)"
  },
  {
   value: "Stilwell (USQSL)",
   label: "Stilwell (USQSL)"
  },
  {
   value: "Stirling (USTRG)",
   label: "Stirling (USTRG)"
  },
  {
   value: "Stittville (USS4T)",
   label: "Stittville (USS4T)"
  },
  {
   value: "Stockbridge (USKGB)",
   label: "Stockbridge (USKGB)"
  },
  {
   value: "Stockbridge (USSKG)",
   label: "Stockbridge (USSKG)"
  },
  {
   value: "Stockdale (USSD4)",
   label: "Stockdale (USSD4)"
  },
  {
   value: "Stockton (USTC8)",
   label: "Stockton (USTC8)"
  },
  {
   value: "Stockton (USZOS)",
   label: "Stockton (USZOS)"
  },
  {
   value: "Stokesdale (USKVE)",
   label: "Stokesdale (USKVE)"
  },
  {
   value: "Stone Mountain (USSUM)",
   label: "Stone Mountain (USSUM)"
  },
  {
   value: "Stone Park (USOEK)",
   label: "Stone Park (USOEK)"
  },
  {
   value: "Stone Ridge, Ulster (USYYR)",
   label: "Stone Ridge, Ulster (USYYR)"
  },
  {
   value: "Stoneboro (USTOF)",
   label: "Stoneboro (USTOF)"
  },
  {
   value: "Stonewood (USXVS)",
   label: "Stonewood (USXVS)"
  },
  {
   value: "Stonington (USSG4)",
   label: "Stonington (USSG4)"
  },
  {
   value: "Stonington (USSN6)",
   label: "Stonington (USSN6)"
  },
  {
   value: "Stony Brook (USZTY)",
   label: "Stony Brook (USZTY)"
  },
  {
   value: "Stony Point (USYOT)",
   label: "Stony Point (USYOT)"
  },
  {
   value: "Stony Point, Rockland (USNYI)",
   label: "Stony Point, Rockland (USNYI)"
  },
  {
   value: "Stony Ridge (USDQE)",
   label: "Stony Ridge (USDQE)"
  },
  {
   value: "Stony River (USSRV)",
   label: "Stony River (USSRV)"
  },
  {
   value: "Stormville (USZST)",
   label: "Stormville (USZST)"
  },
  {
   value: "Story City (USITY)",
   label: "Story City (USITY)"
  },
  {
   value: "Stoughton (USZTN)",
   label: "Stoughton (USZTN)"
  },
  {
   value: "Stow (USVOW)",
   label: "Stow (USVOW)"
  },
  {
   value: "Stoystown (USQST)",
   label: "Stoystown (USQST)"
  },
  {
   value: "Strang (USSNB)",
   label: "Strang (USSNB)"
  },
  {
   value: "Strasburg (USQQZ)",
   label: "Strasburg (USQQZ)"
  },
  {
   value: "Stratford (USAHG)",
   label: "Stratford (USAHG)"
  },
  {
   value: "Stratford (USTFO)",
   label: "Stratford (USTFO)"
  },
  {
   value: "Stratford (USZTT)",
   label: "Stratford (USZTT)"
  },
  {
   value: "Stratton (USST5)",
   label: "Stratton (USST5)"
  },
  {
   value: "Strawberry Point (USSP5)",
   label: "Strawberry Point (USSP5)"
  },
  {
   value: "Street (USST6)",
   label: "Street (USST6)"
  },
  {
   value: "Stringtown (USSG6)",
   label: "Stringtown (USSG6)"
  },
  {
   value: "Strong (USTAQ)",
   label: "Strong (USTAQ)"
  },
  {
   value: "Strum (USUCT)",
   label: "Strum (USUCT)"
  },
  {
   value: "Struthers (USTRS)",
   label: "Struthers (USTRS)"
  },
  {
   value: "Stryker (USKRT)",
   label: "Stryker (USKRT)"
  },
  {
   value: "Strykersville (USYKR)",
   label: "Strykersville (USYKR)"
  },
  {
   value: "Stuart (USST2)",
   label: "Stuart (USST2)"
  },
  {
   value: "Stuart (USTZT)",
   label: "Stuart (USTZT)"
  },
  {
   value: "Stuarts Draft (USTUD)",
   label: "Stuarts Draft (USTUD)"
  },
  {
   value: "Sturbridge (USTBI)",
   label: "Sturbridge (USTBI)"
  },
  {
   value: "Sturgis (USTUG)",
   label: "Sturgis (USTUG)"
  },
  {
   value: "Sturgis (USZTI)",
   label: "Sturgis (USZTI)"
  },
  {
   value: "Sudan (USSDU)",
   label: "Sudan (USSDU)"
  },
  {
   value: "Sugar Creek (USSKX)",
   label: "Sugar Creek (USSKX)"
  },
  {
   value: "Sugar Creek (USUGC)",
   label: "Sugar Creek (USUGC)"
  },
  {
   value: "Sugar Grove (USS2G)",
   label: "Sugar Grove (USS2G)"
  },
  {
   value: "Sugar Hill (USUGH)",
   label: "Sugar Hill (USUGH)"
  },
  {
   value: "Sugar Loaf (USUGL)",
   label: "Sugar Loaf (USUGL)"
  },
  {
   value: "Sugar Valley (USUGA)",
   label: "Sugar Valley (USUGA)"
  },
  {
   value: "Sugarcreek (USZSU)",
   label: "Sugarcreek (USZSU)"
  },
  {
   value: "Sugarland (USTKB)",
   label: "Sugarland (USTKB)"
  },
  {
   value: "Sullivan (USULI)",
   label: "Sullivan (USULI)"
  },
  {
   value: "Sullivan (USULV)",
   label: "Sullivan (USULV)"
  },
  {
   value: "Sullivan (USXSV)",
   label: "Sullivan (USXSV)"
  },
  {
   value: "Sullivan City (USUVT)",
   label: "Sullivan City (USUVT)"
  },
  {
   value: "Sully (USULX)",
   label: "Sully (USULX)"
  },
  {
   value: "Sulphur (USLPU)",
   label: "Sulphur (USLPU)"
  },
  {
   value: "Sulphur Springs (USUUS)",
   label: "Sulphur Springs (USUUS)"
  },
  {
   value: "Sultan (USULN)",
   label: "Sultan (USULN)"
  },
  {
   value: "Sultana (USULT)",
   label: "Sultana (USULT)"
  },
  {
   value: "Sumiton (USASZ)",
   label: "Sumiton (USASZ)"
  },
  {
   value: "Summer Shade (USSU4)",
   label: "Summer Shade (USSU4)"
  },
  {
   value: "Summerdale (USURL)",
   label: "Summerdale (USURL)"
  },
  {
   value: "Summerfield (USFSF)",
   label: "Summerfield (USFSF)"
  },
  {
   value: "Summerfield (USKSF)",
   label: "Summerfield (USKSF)"
  },
  {
   value: "Summerfield (USUME)",
   label: "Summerfield (USUME)"
  },
  {
   value: "Summerland (USUMD)",
   label: "Summerland (USUMD)"
  },
  {
   value: "Summerland Key (USSK3)",
   label: "Summerland Key (USSK3)"
  },
  {
   value: "Summerton (USUMR)",
   label: "Summerton (USUMR)"
  },
  {
   value: "Summerville (USURV)",
   label: "Summerville (USURV)"
  },
  {
   value: "Summerville (USZSE)",
   label: "Summerville (USZSE)"
  },
  {
   value: "Summit (USSZS)",
   label: "Summit (USSZS)"
  },
  {
   value: "Summit (USUMM)",
   label: "Summit (USUMM)"
  },
  {
   value: "Summit Station (USM9)",
   label: "Summit Station (USM9)"
  },
  {
   value: "Summitville (USVVL)",
   label: "Summitville (USVVL)"
  },
  {
   value: "Sumner (USSXG)",
   label: "Sumner (USSXG)"
  },
  {
   value: "Sumner (USUMN)",
   label: "Sumner (USUMN)"
  },
  {
   value: "Sumrall, Lamar (USUAL)",
   label: "Sumrall, Lamar (USUAL)"
  },
  {
   value: "Sumterville (USUMV)",
   label: "Sumterville (USUMV)"
  },
  {
   value: "Sun City (USUNY)",
   label: "Sun City (USUNY)"
  },
  {
   value: "Sun City (USXZI)",
   label: "Sun City (USXZI)"
  },
  {
   value: "Sun River (USSUO)",
   label: "Sun River (USSUO)"
  },
  {
   value: "Suncook (USSKQ)",
   label: "Suncook (USSKQ)"
  },
  {
   value: "Sunflower (USJWR)",
   label: "Sunflower (USJWR)"
  },
  {
   value: "Sunland Park (USXSP)",
   label: "Sunland Park (USXSP)"
  },
  {
   value: "Sunman (USSM3)",
   label: "Sunman (USSM3)"
  },
  {
   value: "Sunny Isles (USXSU)",
   label: "Sunny Isles (USXSU)"
  },
  {
   value: "Sunny Side (USYUY)",
   label: "Sunny Side (USYUY)"
  },
  {
   value: "Sunnyside, Queens (USSS6)",
   label: "Sunnyside, Queens (USSS6)"
  },
  {
   value: "Sunnyslope (USUNP)",
   label: "Sunnyslope (USUNP)"
  },
  {
   value: "Sunnyvale (USSNN)",
   label: "Sunnyvale (USSNN)"
  },
  {
   value: "Sunol (USUOL)",
   label: "Sunol (USUOL)"
  },
  {
   value: "Sunray (USUNR)",
   label: "Sunray (USUNR)"
  },
  {
   value: "Sunrise (USXUN)",
   label: "Sunrise (USXUN)"
  },
  {
   value: "Sunrise Beach (USZZZ)",
   label: "Sunrise Beach (USZZZ)"
  },
  {
   value: "Sunset (USSS4)",
   label: "Sunset (USSS4)"
  },
  {
   value: "Sunset Hills (USUEA)",
   label: "Sunset Hills (USUEA)"
  },
  {
   value: "Superior (USUPR)",
   label: "Superior (USUPR)"
  },
  {
   value: "Superior Township (USST8)",
   label: "Superior Township (USST8)"
  },
  {
   value: "Surf City (USSC5)",
   label: "Surf City (USSC5)"
  },
  {
   value: "Surf City (USUIY)",
   label: "Surf City (USUIY)"
  },
  {
   value: "Surfside Beach (USFBC)",
   label: "Surfside Beach (USFBC)"
  },
  {
   value: "Surgoinsville (USSGO)",
   label: "Surgoinsville (USSGO)"
  },
  {
   value: "Surprise (USURS)",
   label: "Surprise (USURS)"
  },
  {
   value: "Surrency (USRRU)",
   label: "Surrency (USRRU)"
  },
  {
   value: "Surry (USQRY)",
   label: "Surry (USQRY)"
  },
  {
   value: "Susquehanna (USSH7)",
   label: "Susquehanna (USSH7)"
  },
  {
   value: "Sussex (USUEX)",
   label: "Sussex (USUEX)"
  },
  {
   value: "Sutersville (USSV6)",
   label: "Sutersville (USSV6)"
  },
  {
   value: "Sutherland (USZSD)",
   label: "Sutherland (USZSD)"
  },
  {
   value: "Sutherlin (USZIJ)",
   label: "Sutherlin (USZIJ)"
  },
  {
   value: "Sutter Creek (USXXK)",
   label: "Sutter Creek (USXXK)"
  },
  {
   value: "Sutton (USSUP)",
   label: "Sutton (USSUP)"
  },
  {
   value: "Sutton (USSXU)",
   label: "Sutton (USSXU)"
  },
  {
   value: "Sutton (USTON)",
   label: "Sutton (USTON)"
  },
  {
   value: "Suttons Bay (USZYY)",
   label: "Suttons Bay (USZYY)"
  },
  {
   value: "Swansea (USAE5)",
   label: "Swansea (USAE5)"
  },
  {
   value: "Swansea (USSS5)",
   label: "Swansea (USSS5)"
  },
  {
   value: "Swansea (USSW6)",
   label: "Swansea (USSW6)"
  },
  {
   value: "Swanzey (USSW5)",
   label: "Swanzey (USSW5)"
  },
  {
   value: "Swarthmore\/Philadelphia (USXWR)",
   label: "Swarthmore\/Philadelphia (USXWR)"
  },
  {
   value: "Swatara (USSW7)",
   label: "Swatara (USSW7)"
  },
  {
   value: "Sweeny (USDXU)",
   label: "Sweeny (USDXU)"
  },
  {
   value: "Sweetwater (USWWE)",
   label: "Sweetwater (USWWE)"
  },
  {
   value: "Swiftwater (USIWT)",
   label: "Swiftwater (USIWT)"
  },
  {
   value: "Switzer (USZSW)",
   label: "Switzer (USZSW)"
  },
  {
   value: "Swords Creek (USDSK)",
   label: "Swords Creek (USDSK)"
  },
  {
   value: "Sycamore (USYYC)",
   label: "Sycamore (USYYC)"
  },
  {
   value: "Sycamore (USZIS)",
   label: "Sycamore (USZIS)"
  },
  {
   value: "Sydney (USYDY)",
   label: "Sydney (USYDY)"
  },
  {
   value: "Sykesville (USZJF)",
   label: "Sykesville (USZJF)"
  },
  {
   value: "Sylvan Lake (USYNL)",
   label: "Sylvan Lake (USYNL)"
  },
  {
   value: "Symsonia (USYMO)",
   label: "Symsonia (USYMO)"
  },
  {
   value: "Syosset (USSYQ)",
   label: "Syosset (USSYQ)"
  },
  {
   value: "Syracuse (USYCS)",
   label: "Syracuse (USYCS)"
  },
  {
   value: "Syracuse (USYRA)",
   label: "Syracuse (USYRA)"
  },
  {
   value: "Tabb (USTAB)",
   label: "Tabb (USTAB)"
  },
  {
   value: "Tabor City (USQTB)",
   label: "Tabor City (USQTB)"
  },
  {
   value: "Taconite Harbor (USTCH)",
   label: "Taconite Harbor (USTCH)"
  },
  {
   value: "Taft (USTF2)",
   label: "Taft (USTF2)"
  },
  {
   value: "Taftville (USTAF)",
   label: "Taftville (USTAF)"
  },
  {
   value: "Tahneta Pass Lodge (USHNE)",
   label: "Tahneta Pass Lodge (USHNE)"
  },
  {
   value: "Taintor (USZAO)",
   label: "Taintor (USZAO)"
  },
  {
   value: "Takoma Park (USZIV)",
   label: "Takoma Park (USZIV)"
  },
  {
   value: "Talbott (USTNT)",
   label: "Talbott (USTNT)"
  },
  {
   value: "Talco (USTC7)",
   label: "Talco (USTC7)"
  },
  {
   value: "Talent (USYTL)",
   label: "Talent (USYTL)"
  },
  {
   value: "Talla Bena (USTBB)",
   label: "Talla Bena (USTBB)"
  },
  {
   value: "Tallapoosa (USTAA)",
   label: "Tallapoosa (USTAA)"
  },
  {
   value: "Tallassee, Elmore (USYTA)",
   label: "Tallassee, Elmore (USYTA)"
  },
  {
   value: "Tallmadge (USTMG)",
   label: "Tallmadge (USTMG)"
  },
  {
   value: "Tallman (USTAK)",
   label: "Tallman (USTAK)"
  },
  {
   value: "Tallulah (USTAU)",
   label: "Tallulah (USTAU)"
  },
  {
   value: "Talmo (USTLO)",
   label: "Talmo (USTLO)"
  },
  {
   value: "Tama (USTAM)",
   label: "Tama (USTAM)"
  },
  {
   value: "Tamarac (USTRK)",
   label: "Tamarac (USTRK)"
  },
  {
   value: "Tamms (USTMM)",
   label: "Tamms (USTMM)"
  },
  {
   value: "Tampico (USTMK)",
   label: "Tampico (USTMK)"
  },
  {
   value: "Tams (USXTS)",
   label: "Tams (USXTS)"
  },
  {
   value: "Tamworth (USRMX)",
   label: "Tamworth (USRMX)"
  },
  {
   value: "Tanacross (USTSG)",
   label: "Tanacross (USTSG)"
  },
  {
   value: "Tangent (USZTG)",
   label: "Tangent (USZTG)"
  },
  {
   value: "Tanner (USNNR)",
   label: "Tanner (USNNR)"
  },
  {
   value: "Tannersville (USTQV)",
   label: "Tannersville (USTQV)"
  },
  {
   value: "Tar Heel (USTQH)",
   label: "Tar Heel (USTQH)"
  },
  {
   value: "Tarpon Spings (USZIU)",
   label: "Tarpon Spings (USZIU)"
  },
  {
   value: "Tarrytown (USTWZ)",
   label: "Tarrytown (USTWZ)"
  },
  {
   value: "Tarzan (USTZN)",
   label: "Tarzan (USTZN)"
  },
  {
   value: "Tatalina (USTLJ)",
   label: "Tatalina (USTLJ)"
  },
  {
   value: "Tatum (USTTU)",
   label: "Tatum (USTTU)"
  },
  {
   value: "Tatum (USTZU)",
   label: "Tatum (USTZU)"
  },
  {
   value: "Tavares (USTAV)",
   label: "Tavares (USTAV)"
  },
  {
   value: "Tavernier (USTNE)",
   label: "Tavernier (USTNE)"
  },
  {
   value: "Tawas City (USTWY)",
   label: "Tawas City (USTWY)"
  },
  {
   value: "Taylor (USHQ7)",
   label: "Taylor (USHQ7)"
  },
  {
   value: "Taylor (USTJO)",
   label: "Taylor (USTJO)"
  },
  {
   value: "Taylor (USTWE)",
   label: "Taylor (USTWE)"
  },
  {
   value: "Taylor (USTYZ)",
   label: "Taylor (USTYZ)"
  },
  {
   value: "Taylor (USYLJ)",
   label: "Taylor (USYLJ)"
  },
  {
   value: "Taylor Mill (USYLI)",
   label: "Taylor Mill (USYLI)"
  },
  {
   value: "Taylorsville (USTYC)",
   label: "Taylorsville (USTYC)"
  },
  {
   value: "Taylorsville (USXYV)",
   label: "Taylorsville (USXYV)"
  },
  {
   value: "Taylorsville (USYLV)",
   label: "Taylorsville (USYLV)"
  },
  {
   value: "Tazewell (USTZV)",
   label: "Tazewell (USTZV)"
  },
  {
   value: "Tchula (USUTA)",
   label: "Tchula (USUTA)"
  },
  {
   value: "Tea (USTIF)",
   label: "Tea (USTIF)"
  },
  {
   value: "Teays (USTS3)",
   label: "Teays (USTS3)"
  },
  {
   value: "Tecumseh (USTCE)",
   label: "Tecumseh (USTCE)"
  },
  {
   value: "Tecumseh (USTMZ)",
   label: "Tecumseh (USTMZ)"
  },
  {
   value: "Tehachapi (USTSP)",
   label: "Tehachapi (USTSP)"
  },
  {
   value: "Tekamah (USTMH)",
   label: "Tekamah (USTMH)"
  },
  {
   value: "Tekoa (USTKO)",
   label: "Tekoa (USTKO)"
  },
  {
   value: "Tekonsha (USTS2)",
   label: "Tekonsha (USTS2)"
  },
  {
   value: "Telida (USTLF)",
   label: "Telida (USTLF)"
  },
  {
   value: "Teller Mission (USKTS)",
   label: "Teller Mission (USKTS)"
  },
  {
   value: "Tellico Plains (USTPI)",
   label: "Tellico Plains (USTPI)"
  },
  {
   value: "Telluride (USQTR)",
   label: "Telluride (USQTR)"
  },
  {
   value: "Telogia (USTLG)",
   label: "Telogia (USTLG)"
  },
  {
   value: "Temple Hills (USTHH)",
   label: "Temple Hills (USTHH)"
  },
  {
   value: "Temple Terrace (USTJT)",
   label: "Temple Terrace (USTJT)"
  },
  {
   value: "Templeton (USTT4)",
   label: "Templeton (USTT4)"
  },
  {
   value: "Templeton (USTT6)",
   label: "Templeton (USTT6)"
  },
  {
   value: "Ten Sleep (USTSL)",
   label: "Ten Sleep (USTSL)"
  },
  {
   value: "Tenafly (USTNF)",
   label: "Tenafly (USTNF)"
  },
  {
   value: "Tenants Harbour (USZNH)",
   label: "Tenants Harbour (USZNH)"
  },
  {
   value: "Tennessee Colony (USTJC)",
   label: "Tennessee Colony (USTJC)"
  },
  {
   value: "Tennessee Ridge (USZFK)",
   label: "Tennessee Ridge (USZFK)"
  },
  {
   value: "Terlingua (USTL5)",
   label: "Terlingua (USTL5)"
  },
  {
   value: "Terre Hill (USTRD)",
   label: "Terre Hill (USTRD)"
  },
  {
   value: "Terrell (USTRL)",
   label: "Terrell (USTRL)"
  },
  {
   value: "Terreton (USTOM)",
   label: "Terreton (USTOM)"
  },
  {
   value: "Terry (USQTY)",
   label: "Terry (USQTY)"
  },
  {
   value: "Terrytown (USTYW)",
   label: "Terrytown (USTYW)"
  },
  {
   value: "Terryville (USTZX)",
   label: "Terryville (USTZX)"
  },
  {
   value: "Tetlin (USTEH)",
   label: "Tetlin (USTEH)"
  },
  {
   value: "Teton Village (USTET)",
   label: "Teton Village (USTET)"
  },
  {
   value: "Texarkana (USTEX)",
   label: "Texarkana (USTEX)"
  },
  {
   value: "Thackerville (USQVL)",
   label: "Thackerville (USQVL)"
  },
  {
   value: "Thatcher (USZTH)",
   label: "Thatcher (USZTH)"
  },
  {
   value: "Thayer (USTAY)",
   label: "Thayer (USTAY)"
  },
  {
   value: "Thayer (USTXY)",
   label: "Thayer (USTXY)"
  },
  {
   value: "Thayne (USTY8)",
   label: "Thayne (USTY8)"
  },
  {
   value: "The Colony (USCY2)",
   label: "The Colony (USCY2)"
  },
  {
   value: "The Rock (USRKG)",
   label: "The Rock (USRKG)"
  },
  {
   value: "The Woodlands (USTHW)",
   label: "The Woodlands (USTHW)"
  },
  {
   value: "Thedford (USTDF)",
   label: "Thedford (USTDF)"
  },
  {
   value: "Thenard (USOJL)",
   label: "Thenard (USOJL)"
  },
  {
   value: "Theresa (USTQE)",
   label: "Theresa (USTQE)"
  },
  {
   value: "Thermopolis (USTHP)",
   label: "Thermopolis (USTHP)"
  },
  {
   value: "Thiensville (USTSV)",
   label: "Thiensville (USTSV)"
  },
  {
   value: "Thomas (USTM2)",
   label: "Thomas (USTM2)"
  },
  {
   value: "Thomasville (USTMV)",
   label: "Thomasville (USTMV)"
  },
  {
   value: "Thomasville (USTVE)",
   label: "Thomasville (USTVE)"
  },
  {
   value: "Thomasville (USTVM)",
   label: "Thomasville (USTVM)"
  },
  {
   value: "Thompson (USTPS)",
   label: "Thompson (USTPS)"
  },
  {
   value: "Thompson Falls (USTHF)",
   label: "Thompson Falls (USTHF)"
  },
  {
   value: "Thompsons Station (USTVT)",
   label: "Thompsons Station (USTVT)"
  },
  {
   value: "Thompsontown (USTPW)",
   label: "Thompsontown (USTPW)"
  },
  {
   value: "Thompsonville (USTHL)",
   label: "Thompsonville (USTHL)"
  },
  {
   value: "Thonotosassa (USTOS)",
   label: "Thonotosassa (USTOS)"
  },
  {
   value: "Thorndale (USRN6)",
   label: "Thorndale (USRN6)"
  },
  {
   value: "Thorne Bay (USKTB)",
   label: "Thorne Bay (USKTB)"
  },
  {
   value: "Thornton (USTHQ)",
   label: "Thornton (USTHQ)"
  },
  {
   value: "Thornton (USTHT)",
   label: "Thornton (USTHT)"
  },
  {
   value: "Thornton (USTNN)",
   label: "Thornton (USTNN)"
  },
  {
   value: "Thornton (USTWV)",
   label: "Thornton (USTWV)"
  },
  {
   value: "Thornville (USTVH)",
   label: "Thornville (USTVH)"
  },
  {
   value: "Thornwood (USNYT)",
   label: "Thornwood (USNYT)"
  },
  {
   value: "Thorp (USTP6)",
   label: "Thorp (USTP6)"
  },
  {
   value: "Thorp (USTQP)",
   label: "Thorp (USTQP)"
  },
  {
   value: "Thorsby (USTB2)",
   label: "Thorsby (USTB2)"
  },
  {
   value: "Thousand Palms (USUNG)",
   label: "Thousand Palms (USUNG)"
  },
  {
   value: "Three Bridges (USTHE)",
   label: "Three Bridges (USTHE)"
  },
  {
   value: "Three Forks Junction (USQTF)",
   label: "Three Forks Junction (USQTF)"
  },
  {
   value: "Three Rivers (USXTV)",
   label: "Three Rivers (USXTV)"
  },
  {
   value: "Throop (USTPY)",
   label: "Throop (USTPY)"
  },
  {
   value: "Thurmont (USURM)",
   label: "Thurmont (USURM)"
  },
  {
   value: "Tiburon (USXTN)",
   label: "Tiburon (USXTN)"
  },
  {
   value: "Tierra Verde (USTDE)",
   label: "Tierra Verde (USTDE)"
  },
  {
   value: "Tigerton (USTGR)",
   label: "Tigerton (USTGR)"
  },
  {
   value: "Tijeras (USTIJ)",
   label: "Tijeras (USTIJ)"
  },
  {
   value: "Tillar (USZTR)",
   label: "Tillar (USZTR)"
  },
  {
   value: "Tillatoba (USIAT)",
   label: "Tillatoba (USIAT)"
  },
  {
   value: "Tilton (USTL2)",
   label: "Tilton (USTL2)"
  },
  {
   value: "Tilton (USTT3)",
   label: "Tilton (USTT3)"
  },
  {
   value: "Tiltonsville (USIVC)",
   label: "Tiltonsville (USIVC)"
  },
  {
   value: "Timber Lake (USTL3)",
   label: "Timber Lake (USTL3)"
  },
  {
   value: "Timberlake (USTLE)",
   label: "Timberlake (USTLE)"
  },
  {
   value: "Timmonsville (USXTE)",
   label: "Timmonsville (USXTE)"
  },
  {
   value: "Tinker Air Force Base (USYTB)",
   label: "Tinker Air Force Base (USYTB)"
  },
  {
   value: "Tioga (USTGA)",
   label: "Tioga (USTGA)"
  },
  {
   value: "Tioga (USTIG)",
   label: "Tioga (USTIG)"
  },
  {
   value: "Tippecanoe (USTPQ)",
   label: "Tippecanoe (USTPQ)"
  },
  {
   value: "Tipton (USTP5)",
   label: "Tipton (USTP5)"
  },
  {
   value: "Tipton (USTP7)",
   label: "Tipton (USTP7)"
  },
  {
   value: "Tipton (USTPT)",
   label: "Tipton (USTPT)"
  },
  {
   value: "Tipton (USTT2)",
   label: "Tipton (USTT2)"
  },
  {
   value: "Tipton (USTTP)",
   label: "Tipton (USTTP)"
  },
  {
   value: "Tishomingo (USTHJ)",
   label: "Tishomingo (USTHJ)"
  },
  {
   value: "Tishomingo (USTSI)",
   label: "Tishomingo (USTSI)"
  },
  {
   value: "Tiskilwa (USTKW)",
   label: "Tiskilwa (USTKW)"
  },
  {
   value: "Titusville (USTIX)",
   label: "Titusville (USTIX)"
  },
  {
   value: "Toddville (USTDV)",
   label: "Toddville (USTDV)"
  },
  {
   value: "Togiak (USTGK)",
   label: "Togiak (USTGK)"
  },
  {
   value: "Togiak Fish (USGFB)",
   label: "Togiak Fish (USGFB)"
  },
  {
   value: "Togiak Village (USTOG)",
   label: "Togiak Village (USTOG)"
  },
  {
   value: "Tok (USTKJ)",
   label: "Tok (USTKJ)"
  },
  {
   value: "Tokeen (USTKI)",
   label: "Tokeen (USTKI)"
  },
  {
   value: "Tokio (USKIP)",
   label: "Tokio (USKIP)"
  },
  {
   value: "Toksook Bay (USOOK)",
   label: "Toksook Bay (USOOK)"
  },
  {
   value: "Toledo (USTDX)",
   label: "Toledo (USTDX)"
  },
  {
   value: "Toluca (USTLU)",
   label: "Toluca (USTLU)"
  },
  {
   value: "Tom Bean (USTQB)",
   label: "Tom Bean (USTQB)"
  },
  {
   value: "Tomah (USQTH)",
   label: "Tomah (USQTH)"
  },
  {
   value: "Tombstone (USTBS)",
   label: "Tombstone (USTBS)"
  },
  {
   value: "Tomhicken (USYTO)",
   label: "Tomhicken (USYTO)"
  },
  {
   value: "Tonasket (USTKT)",
   label: "Tonasket (USTKT)"
  },
  {
   value: "Toney (USTN2)",
   label: "Toney (USTN2)"
  },
  {
   value: "Tonganoxie (USTN3)",
   label: "Tonganoxie (USTN3)"
  },
  {
   value: "Tonica (USQTO)",
   label: "Tonica (USQTO)"
  },
  {
   value: "Tonkawa (USTOK)",
   label: "Tonkawa (USTOK)"
  },
  {
   value: "Tonopah (USTOH)",
   label: "Tonopah (USTOH)"
  },
  {
   value: "Tontitown (USTW7)",
   label: "Tontitown (USTW7)"
  },
  {
   value: "Topanga (USTGP)",
   label: "Topanga (USTGP)"
  },
  {
   value: "Topeka (USTPK)",
   label: "Topeka (USTPK)"
  },
  {
   value: "Topsfield (USTF3)",
   label: "Topsfield (USTF3)"
  },
  {
   value: "Topsham (USTSH)",
   label: "Topsham (USTSH)"
  },
  {
   value: "Tornillo (USQTN)",
   label: "Tornillo (USQTN)"
  },
  {
   value: "Torreon (USQRR)",
   label: "Torreon (USQRR)"
  },
  {
   value: "Tottenville, Staten Island (USTTV)",
   label: "Tottenville, Staten Island (USTTV)"
  },
  {
   value: "Touchet (USTH8)",
   label: "Touchet (USTH8)"
  },
  {
   value: "Toughkenamon (USZTU)",
   label: "Toughkenamon (USZTU)"
  },
  {
   value: "Towanda (USTWK)",
   label: "Towanda (USTWK)"
  },
  {
   value: "Tower (USTW8)",
   label: "Tower (USTW8)"
  },
  {
   value: "Town Creek (USTC2)",
   label: "Town Creek (USTC2)"
  },
  {
   value: "Townsend (USTQW)",
   label: "Townsend (USTQW)"
  },
  {
   value: "Townsend (USTXW)",
   label: "Townsend (USTXW)"
  },
  {
   value: "Township of Woolwich (USWP2)",
   label: "Township of Woolwich (USWP2)"
  },
  {
   value: "Tracy (USTY2)",
   label: "Tracy (USTY2)"
  },
  {
   value: "Trafalgar (USTFG)",
   label: "Trafalgar (USTFG)"
  },
  {
   value: "Trafford (USTFF)",
   label: "Trafford (USTFF)"
  },
  {
   value: "Trainer (USTRA)",
   label: "Trainer (USTRA)"
  },
  {
   value: "Transfer (USTFR)",
   label: "Transfer (USTFR)"
  },
  {
   value: "Travis Air Force Base (USVFB)",
   label: "Travis Air Force Base (USVFB)"
  },
  {
   value: "Treasure I. (USEUA)",
   label: "Treasure I. (USEUA)"
  },
  {
   value: "Trego (USTG8)",
   label: "Trego (USTG8)"
  },
  {
   value: "Tremont (USTOX)",
   label: "Tremont (USTOX)"
  },
  {
   value: "Trempealeau (UST2R)",
   label: "Trempealeau (UST2R)"
  },
  {
   value: "Trent (USTZE)",
   label: "Trent (USTZE)"
  },
  {
   value: "Trenton (USTNX)",
   label: "Trenton (USTNX)"
  },
  {
   value: "Trenton (USTNZ)",
   label: "Trenton (USTNZ)"
  },
  {
   value: "Trenton (USTOE)",
   label: "Trenton (USTOE)"
  },
  {
   value: "Trenton (USTRN)",
   label: "Trenton (USTRN)"
  },
  {
   value: "Trenton (USXTO)",
   label: "Trenton (USXTO)"
  },
  {
   value: "Trenton (USYTR)",
   label: "Trenton (USYTR)"
  },
  {
   value: "Trenton (USZJO)",
   label: "Trenton (USZJO)"
  },
  {
   value: "Trevilians (USZJB)",
   label: "Trevilians (USZJB)"
  },
  {
   value: "Triangle (USTNV)",
   label: "Triangle (USTNV)"
  },
  {
   value: "Tri-Cities (USYTC)",
   label: "Tri-Cities (USYTC)"
  },
  {
   value: "Trinidad (USTAD)",
   label: "Trinidad (USTAD)"
  },
  {
   value: "Trinity (USQTI)",
   label: "Trinity (USQTI)"
  },
  {
   value: "Trinity (USTIR)",
   label: "Trinity (USTIR)"
  },
  {
   value: "Trinity Park (USTYK)",
   label: "Trinity Park (USTYK)"
  },
  {
   value: "Trona (USTRH)",
   label: "Trona (USTRH)"
  },
  {
   value: "Trotwood (USTRO)",
   label: "Trotwood (USTRO)"
  },
  {
   value: "Trout Creek (USTCR)",
   label: "Trout Creek (USTCR)"
  },
  {
   value: "Trout Creek (USTZQ)",
   label: "Trout Creek (USTZQ)"
  },
  {
   value: "Troy (USOYY)",
   label: "Troy (USOYY)"
  },
  {
   value: "Troy (USTCY)",
   label: "Troy (USTCY)"
  },
  {
   value: "Troy (USTGY)",
   label: "Troy (USTGY)"
  },
  {
   value: "Troy (USTOJ)",
   label: "Troy (USTOJ)"
  },
  {
   value: "Troy (USTOY)",
   label: "Troy (USTOY)"
  },
  {
   value: "Troy (USTQZ)",
   label: "Troy (USTQZ)"
  },
  {
   value: "Troy (USTYO)",
   label: "Troy (USTYO)"
  },
  {
   value: "Troy (USYTY)",
   label: "Troy (USYTY)"
  },
  {
   value: "Troy Grove (USTYG)",
   label: "Troy Grove (USTYG)"
  },
  {
   value: "Troy Mills (USTMS)",
   label: "Troy Mills (USTMS)"
  },
  {
   value: "Trumbull (USUUL)",
   label: "Trumbull (USUUL)"
  },
  {
   value: "Truro (USTXO)",
   label: "Truro (USTXO)"
  },
  {
   value: "Tryon (USZNT)",
   label: "Tryon (USZNT)"
  },
  {
   value: "Tuba City (USTBC)",
   label: "Tuba City (USTBC)"
  },
  {
   value: "Tubac (USTBZ)",
   label: "Tubac (USTBZ)"
  },
  {
   value: "Tuckahoe (USXTY)",
   label: "Tuckahoe (USXTY)"
  },
  {
   value: "Tucker (USZSQ)",
   label: "Tucker (USZSQ)"
  },
  {
   value: "Tuckerman (USDDA)",
   label: "Tuckerman (USDDA)"
  },
  {
   value: "Tulalip (USUQQ)",
   label: "Tulalip (USUQQ)"
  },
  {
   value: "Tulelake (USTLL)",
   label: "Tulelake (USTLL)"
  },
  {
   value: "Tulia (USTIA)",
   label: "Tulia (USTIA)"
  },
  {
   value: "Tully (USTLY)",
   label: "Tully (USTLY)"
  },
  {
   value: "Tullytown (USTTW)",
   label: "Tullytown (USTTW)"
  },
  {
   value: "Tulsa (USRVS)",
   label: "Tulsa (USRVS)"
  },
  {
   value: "Tunica (USTNI)",
   label: "Tunica (USTNI)"
  },
  {
   value: "Tununak (USTNK)",
   label: "Tununak (USTNK)"
  },
  {
   value: "Tuolumne (USTL4)",
   label: "Tuolumne (USTL4)"
  },
  {
   value: "Turkey (USTKR)",
   label: "Turkey (USTKR)"
  },
  {
   value: "Turner (USTNM)",
   label: "Turner (USTNM)"
  },
  {
   value: "Turner (USYTU)",
   label: "Turner (USYTU)"
  },
  {
   value: "Turners Station (USTUO)",
   label: "Turners Station (USTUO)"
  },
  {
   value: "Turnersville (USTUE)",
   label: "Turnersville (USTUE)"
  },
  {
   value: "Turtle Creek (USTLC)",
   label: "Turtle Creek (USTLC)"
  },
  {
   value: "Turtle Lake (USTL6)",
   label: "Turtle Lake (USTL6)"
  },
  {
   value: "Turtle Lake (USTTK)",
   label: "Turtle Lake (USTTK)"
  },
  {
   value: "Tuscon (USTUZ)",
   label: "Tuscon (USTUZ)"
  },
  {
   value: "Tustin (USTUN)",
   label: "Tustin (USTUN)"
  },
  {
   value: "Tuttle (USTT8)",
   label: "Tuttle (USTT8)"
  },
  {
   value: "Tuxekan Island (USWNC)",
   label: "Tuxekan Island (USWNC)"
  },
  {
   value: "Twin City (USTWN)",
   label: "Twin City (USTWN)"
  },
  {
   value: "Twin Hills (USTWA)",
   label: "Twin Hills (USTWA)"
  },
  {
   value: "Tybee Island (USZYI)",
   label: "Tybee Island (USZYI)"
  },
  {
   value: "Tye (USTQY)",
   label: "Tye (USTQY)"
  },
  {
   value: "Tyee (USTE8)",
   label: "Tyee (USTE8)"
  },
  {
   value: "Tyler (USTLX)",
   label: "Tyler (USTLX)"
  },
  {
   value: "Tylersport (USTP8)",
   label: "Tylersport (USTP8)"
  },
  {
   value: "Tylertown (USTTQ)",
   label: "Tylertown (USTTQ)"
  },
  {
   value: "Tyner (USYNR)",
   label: "Tyner (USYNR)"
  },
  {
   value: "Tyngsboro (USTG2)",
   label: "Tyngsboro (USTG2)"
  },
  {
   value: "Tyrone (USTYB)",
   label: "Tyrone (USTYB)"
  },
  {
   value: "Tyrone (USTYF)",
   label: "Tyrone (USTYF)"
  },
  {
   value: "Ulm (USUDM)",
   label: "Ulm (USUDM)"
  },
  {
   value: "Ulmer (USUER)",
   label: "Ulmer (USUER)"
  },
  {
   value: "Umatilla (USUML)",
   label: "Umatilla (USUML)"
  },
  {
   value: "Umnak Island (USUMB)",
   label: "Umnak Island (USUMB)"
  },
  {
   value: "Umpire (USUMP)",
   label: "Umpire (USUMP)"
  },
  {
   value: "Unadilla (USUNW)",
   label: "Unadilla (USUNW)"
  },
  {
   value: "Unalakleet (USUNK)",
   label: "Unalakleet (USUNK)"
  },
  {
   value: "Uncasville (USUVL)",
   label: "Uncasville (USUVL)"
  },
  {
   value: "Underwood (USUND)",
   label: "Underwood (USUND)"
  },
  {
   value: "Uneeda (USUDF)",
   label: "Uneeda (USUDF)"
  },
  {
   value: "Unicoi (USUCO)",
   label: "Unicoi (USUCO)"
  },
  {
   value: "Union (USUKO)",
   label: "Union (USUKO)"
  },
  {
   value: "Union (USUN7)",
   label: "Union (USUN7)"
  },
  {
   value: "Union (USUN8)",
   label: "Union (USUN8)"
  },
  {
   value: "Union (USUNH)",
   label: "Union (USUNH)"
  },
  {
   value: "Union (USUNZ)",
   label: "Union (USUNZ)"
  },
  {
   value: "Union (USUOM)",
   label: "Union (USUOM)"
  },
  {
   value: "Union (USYUN)",
   label: "Union (USYUN)"
  },
  {
   value: "Union Beach (USUNA)",
   label: "Union Beach (USUNA)"
  },
  {
   value: "Union Bridge (USUNB)",
   label: "Union Bridge (USUNB)"
  },
  {
   value: "Union Center (USZUC)",
   label: "Union Center (USZUC)"
  },
  {
   value: "Union City (USUNC)",
   label: "Union City (USUNC)"
  },
  {
   value: "Union Gap (USYUG)",
   label: "Union Gap (USYUG)"
  },
  {
   value: "Union Grove (USXUG)",
   label: "Union Grove (USXUG)"
  },
  {
   value: "Union Point (USQUP)",
   label: "Union Point (USQUP)"
  },
  {
   value: "Union South Carolina (USUSC)",
   label: "Union South Carolina (USUSC)"
  },
  {
   value: "Union Springs (USUSN)",
   label: "Union Springs (USUSN)"
  },
  {
   value: "Union, Franklin (USUOI)",
   label: "Union, Franklin (USUOI)"
  },
  {
   value: "Union, Monroe (USUIO)",
   label: "Union, Monroe (USUIO)"
  },
  {
   value: "Union, Neshaboa (USXUI)",
   label: "Union, Neshaboa (USXUI)"
  },
  {
   value: "Uniondale (USUOD)",
   label: "Uniondale (USUOD)"
  },
  {
   value: "Uniontown (USUOO)",
   label: "Uniontown (USUOO)"
  },
  {
   value: "Uniontown (USUT2)",
   label: "Uniontown (USUT2)"
  },
  {
   value: "Unionville (USUOV)",
   label: "Unionville (USUOV)"
  },
  {
   value: "Uniopolis (USUZP)",
   label: "Uniopolis (USUZP)"
  },
  {
   value: "Unity (USUHI)",
   label: "Unity (USUHI)"
  },
  {
   value: "Unity (USUWI)",
   label: "Unity (USUWI)"
  },
  {
   value: "Universal City (USKVY)",
   label: "Universal City (USKVY)"
  },
  {
   value: "University Park (USUKK)",
   label: "University Park (USUKK)"
  },
  {
   value: "University Park (USUP2)",
   label: "University Park (USUP2)"
  },
  {
   value: "Upland (USUPL)",
   label: "Upland (USUPL)"
  },
  {
   value: "Upolu Point (USUPP)",
   label: "Upolu Point (USUPP)"
  },
  {
   value: "Upper Brookville (USYUP)",
   label: "Upper Brookville (USYUP)"
  },
  {
   value: "Upper Jay (USUPJ)",
   label: "Upper Jay (USUPJ)"
  },
  {
   value: "Upper Saint Regis (USQUS)",
   label: "Upper Saint Regis (USQUS)"
  },
  {
   value: "Upperville (USUPV)",
   label: "Upperville (USUPV)"
  },
  {
   value: "Upton (USUPT)",
   label: "Upton (USUPT)"
  },
  {
   value: "Upton (USXUP)",
   label: "Upton (USXUP)"
  },
  {
   value: "Urbana (USIUA)",
   label: "Urbana (USIUA)"
  },
  {
   value: "Urbana (USURC)",
   label: "Urbana (USURC)"
  },
  {
   value: "Urbancrest (USUCR)",
   label: "Urbancrest (USUCR)"
  },
  {
   value: "Uriah (USURH)",
   label: "Uriah (USURH)"
  },
  {
   value: "Utica (USUC8)",
   label: "Utica (USUC8)"
  },
  {
   value: "Utica (USUCX)",
   label: "Utica (USUCX)"
  },
  {
   value: "Utica (USUIC)",
   label: "Utica (USUIC)"
  },
  {
   value: "Utica (USUTI)",
   label: "Utica (USUTI)"
  },
  {
   value: "Utopia Creek (USUTO)",
   label: "Utopia Creek (USUTO)"
  },
  {
   value: "Uwchland (USUWC)",
   label: "Uwchland (USUWC)"
  },
  {
   value: "Uxbridge (USUXX)",
   label: "Uxbridge (USUXX)"
  },
  {
   value: "Vaiden (USVDN)",
   label: "Vaiden (USVDN)"
  },
  {
   value: "Vail (USIVI)",
   label: "Vail (USIVI)"
  },
  {
   value: "Vail (USVAH)",
   label: "Vail (USVAH)"
  },
  {
   value: "Valders (USVAD)",
   label: "Valders (USVAD)"
  },
  {
   value: "Vale (USQVA)",
   label: "Vale (USQVA)"
  },
  {
   value: "Vale (USYVA)",
   label: "Vale (USYVA)"
  },
  {
   value: "Valencia (USVLC)",
   label: "Valencia (USVLC)"
  },
  {
   value: "Valentine (USVTE)",
   label: "Valentine (USVTE)"
  },
  {
   value: "Valle (USVLE)",
   label: "Valle (USVLE)"
  },
  {
   value: "Valle Crucis (USVDS)",
   label: "Valle Crucis (USVDS)"
  },
  {
   value: "Valley (USVAE)",
   label: "Valley (USVAE)"
  },
  {
   value: "Valley (USVAY)",
   label: "Valley (USVAY)"
  },
  {
   value: "Valley Center (USVCY)",
   label: "Valley Center (USVCY)"
  },
  {
   value: "Valley City (USVYY)",
   label: "Valley City (USVYY)"
  },
  {
   value: "Valley Grove (USVEF)",
   label: "Valley Grove (USVEF)"
  },
  {
   value: "Valley Park (USVPA)",
   label: "Valley Park (USVPA)"
  },
  {
   value: "Valley Park (USVY7)",
   label: "Valley Park (USVY7)"
  },
  {
   value: "Valley Springs (USVLI)",
   label: "Valley Springs (USVLI)"
  },
  {
   value: "Valley View (USVLW)",
   label: "Valley View (USVLW)"
  },
  {
   value: "Valley View (USZVV)",
   label: "Valley View (USZVV)"
  },
  {
   value: "Valmeyer (USVYR)",
   label: "Valmeyer (USVYR)"
  },
  {
   value: "Valparaiso (USVPO)",
   label: "Valparaiso (USVPO)"
  },
  {
   value: "Valparaiso (USVPS)",
   label: "Valparaiso (USVPS)"
  },
  {
   value: "Valrico (USVLQ)",
   label: "Valrico (USVLQ)"
  },
  {
   value: "Van (USZFN)",
   label: "Van (USZFN)"
  },
  {
   value: "Van Alstyne (USVLS)",
   label: "Van Alstyne (USVLS)"
  },
  {
   value: "Van Buren (USVBE)",
   label: "Van Buren (USVBE)"
  },
  {
   value: "Van Buren (USYVB)",
   label: "Van Buren (USYVB)"
  },
  {
   value: "Van Buren Township (USVBM)",
   label: "Van Buren Township (USVBM)"
  },
  {
   value: "Van Horn (USVHN)",
   label: "Van Horn (USVHN)"
  },
  {
   value: "Van Wert (USVWT)",
   label: "Van Wert (USVWT)"
  },
  {
   value: "Vanadium (USVDM)",
   label: "Vanadium (USVDM)"
  },
  {
   value: "Vanar (USVAR)",
   label: "Vanar (USVAR)"
  },
  {
   value: "Vanceboro (USVNB)",
   label: "Vanceboro (USVNB)"
  },
  {
   value: "Vanceburg (USVGS)",
   label: "Vanceburg (USVGS)"
  },
  {
   value: "Vancouver (USVAN)",
   label: "Vancouver (USVAN)"
  },
  {
   value: "Vandalia (USVDD)",
   label: "Vandalia (USVDD)"
  },
  {
   value: "Vandalia (USVLA)",
   label: "Vandalia (USVLA)"
  },
  {
   value: "Vanderbilt (USVDB)",
   label: "Vanderbilt (USVDB)"
  },
  {
   value: "Vandergrift (USVGF)",
   label: "Vandergrift (USVGF)"
  },
  {
   value: "Vansant (USVST)",
   label: "Vansant (USVST)"
  },
  {
   value: "Varnell (USYVR)",
   label: "Varnell (USYVR)"
  },
  {
   value: "Varnville (USZH5)",
   label: "Varnville (USZH5)"
  },
  {
   value: "Vashon (USVSX)",
   label: "Vashon (USVSX)"
  },
  {
   value: "Vashon Island (USYVI)",
   label: "Vashon Island (USYVI)"
  },
  {
   value: "Vassalboro (USVSB)",
   label: "Vassalboro (USVSB)"
  },
  {
   value: "Vaughn (USVN2)",
   label: "Vaughn (USVN2)"
  },
  {
   value: "Veblen (USVLN)",
   label: "Veblen (USVLN)"
  },
  {
   value: "Veedersburg (USVVG)",
   label: "Veedersburg (USVVG)"
  },
  {
   value: "Vega (USVEG)",
   label: "Vega (USVEG)"
  },
  {
   value: "Velma (USVEB)",
   label: "Velma (USVEB)"
  },
  {
   value: "Velva (USVVA)",
   label: "Velva (USVVA)"
  },
  {
   value: "Venetie (USVEE)",
   label: "Venetie (USVEE)"
  },
  {
   value: "Venice (USVN3)",
   label: "Venice (USVN3)"
  },
  {
   value: "Ventura (USVNT)",
   label: "Ventura (USVNT)"
  },
  {
   value: "Ventura (USVTU)",
   label: "Ventura (USVTU)"
  },
  {
   value: "Venus (USVE2)",
   label: "Venus (USVE2)"
  },
  {
   value: "Venus (USVS8)",
   label: "Venus (USVS8)"
  },
  {
   value: "Vermillion (USVEM)",
   label: "Vermillion (USVEM)"
  },
  {
   value: "Vermont (USVMN)",
   label: "Vermont (USVMN)"
  },
  {
   value: "Vermont (USZFQ)",
   label: "Vermont (USZFQ)"
  },
  {
   value: "Vernalis (USVRI)",
   label: "Vernalis (USVRI)"
  },
  {
   value: "Vernon (USVEN)",
   label: "Vernon (USVEN)"
  },
  {
   value: "Vernon (USVEQ)",
   label: "Vernon (USVEQ)"
  },
  {
   value: "Vernon (USVFN)",
   label: "Vernon (USVFN)"
  },
  {
   value: "Vernon (USVGO)",
   label: "Vernon (USVGO)"
  },
  {
   value: "Vernon (USVRN)",
   label: "Vernon (USVRN)"
  },
  {
   value: "Vernon, Camden (USVNO)",
   label: "Vernon, Camden (USVNO)"
  },
  {
   value: "Verona (USV2R)",
   label: "Verona (USV2R)"
  },
  {
   value: "Verona (USVRA)",
   label: "Verona (USVRA)"
  },
  {
   value: "Verona (USVRO)",
   label: "Verona (USVRO)"
  },
  {
   value: "Versailles (USVFS)",
   label: "Versailles (USVFS)"
  },
  {
   value: "Versailles (USVRS)",
   label: "Versailles (USVRS)"
  },
  {
   value: "Versailles (USXVE)",
   label: "Versailles (USXVE)"
  },
  {
   value: "Veseli (USV2L)",
   label: "Veseli (USV2L)"
  },
  {
   value: "Vesta (USVEU)",
   label: "Vesta (USVEU)"
  },
  {
   value: "Vestavia Hills (USVEH)",
   label: "Vestavia Hills (USVEH)"
  },
  {
   value: "Veyo (USVYO)",
   label: "Veyo (USVYO)"
  },
  {
   value: "Viburnum (USVRU)",
   label: "Viburnum (USVRU)"
  },
  {
   value: "Vichy (USVIH)",
   label: "Vichy (USVIH)"
  },
  {
   value: "Vici (USVJC)",
   label: "Vici (USVJC)"
  },
  {
   value: "Vickery (USVCK)",
   label: "Vickery (USVCK)"
  },
  {
   value: "Vicksburg (USVKB)",
   label: "Vicksburg (USVKB)"
  },
  {
   value: "Victor (USVIC)",
   label: "Victor (USVIC)"
  },
  {
   value: "Victor (USVIT)",
   label: "Victor (USVIT)"
  },
  {
   value: "Victor (USVOR)",
   label: "Victor (USVOR)"
  },
  {
   value: "Victoria (USXZV)",
   label: "Victoria (USXZV)"
  },
  {
   value: "Vidalia (USVDI)",
   label: "Vidalia (USVDI)"
  },
  {
   value: "Vidor (USVDO)",
   label: "Vidor (USVDO)"
  },
  {
   value: "Vienna (USVIE)",
   label: "Vienna (USVIE)"
  },
  {
   value: "Vienna (USVIG)",
   label: "Vienna (USVIG)"
  },
  {
   value: "Vienna (USVMD)",
   label: "Vienna (USVMD)"
  },
  {
   value: "Vienna (USVNM)",
   label: "Vienna (USVNM)"
  },
  {
   value: "Villa Grove (USVGV)",
   label: "Villa Grove (USVGV)"
  },
  {
   value: "Villard Junction (USVJ2)",
   label: "Villard Junction (USVJ2)"
  },
  {
   value: "Ville Platte (USVPT)",
   label: "Ville Platte (USVPT)"
  },
  {
   value: "Vincent (USVDT)",
   label: "Vincent (USVDT)"
  },
  {
   value: "Vincent (USYXV)",
   label: "Vincent (USYXV)"
  },
  {
   value: "Vincentown (USXVT)",
   label: "Vincentown (USXVT)"
  },
  {
   value: "Vine Grove (USVGR)",
   label: "Vine Grove (USVGR)"
  },
  {
   value: "Vinemont (USVMT)",
   label: "Vinemont (USVMT)"
  },
  {
   value: "Vineyard (USVED)",
   label: "Vineyard (USVED)"
  },
  {
   value: "Vinita (USVIA)",
   label: "Vinita (USVIA)"
  },
  {
   value: "Vinton (USDZN)",
   label: "Vinton (USDZN)"
  },
  {
   value: "Vinton (USVIB)",
   label: "Vinton (USVIB)"
  },
  {
   value: "Viola (USVIO)",
   label: "Viola (USVIO)"
  },
  {
   value: "Viola (USVOA)",
   label: "Viola (USVOA)"
  },
  {
   value: "Viola (USVOL)",
   label: "Viola (USVOL)"
  },
  {
   value: "Violet (USVOT)",
   label: "Violet (USVOT)"
  },
  {
   value: "Virgil (USVRG)",
   label: "Virgil (USVRG)"
  },
  {
   value: "Virgin (USIGU)",
   label: "Virgin (USIGU)"
  },
  {
   value: "Virginia (USVGA)",
   label: "Virginia (USVGA)"
  },
  {
   value: "Virginia (USVGI)",
   label: "Virginia (USVGI)"
  },
  {
   value: "Virginia City (USVGT)",
   label: "Virginia City (USVGT)"
  },
  {
   value: "Viroqua (USVIR)",
   label: "Viroqua (USVIR)"
  },
  {
   value: "Volant (USVL2)",
   label: "Volant (USVL2)"
  },
  {
   value: "Volga (USVLG)",
   label: "Volga (USVLG)"
  },
  {
   value: "Volo (USVO2)",
   label: "Volo (USVO2)"
  },
  {
   value: "Von Ormy (USZJE)",
   label: "Von Ormy (USZJE)"
  },
  {
   value: "Waco (USWC8)",
   label: "Waco (USWC8)"
  },
  {
   value: "Wadena (USWNQ)",
   label: "Wadena (USWNQ)"
  },
  {
   value: "Wadesboro (USDEB)",
   label: "Wadesboro (USDEB)"
  },
  {
   value: "Wadesville (USZWV)",
   label: "Wadesville (USZWV)"
  },
  {
   value: "Wadley (USWY2)",
   label: "Wadley (USWY2)"
  },
  {
   value: "Wadley (USWY6)",
   label: "Wadley (USWY6)"
  },
  {
   value: "Wadsworth (USWDH)",
   label: "Wadsworth (USWDH)"
  },
  {
   value: "Wadsworth (USWW6)",
   label: "Wadsworth (USWW6)"
  },
  {
   value: "Waelder (USQWD)",
   label: "Waelder (USQWD)"
  },
  {
   value: "Wagener (USQWE)",
   label: "Wagener (USQWE)"
  },
  {
   value: "Waggaman (USWG2)",
   label: "Waggaman (USWG2)"
  },
  {
   value: "Wagon Mound (USWM2)",
   label: "Wagon Mound (USWM2)"
  },
  {
   value: "Wagoner (USWGE)",
   label: "Wagoner (USWGE)"
  },
  {
   value: "Wahoo (USNAO)",
   label: "Wahoo (USNAO)"
  },
  {
   value: "Waimea (USWM3)",
   label: "Waimea (USWM3)"
  },
  {
   value: "Wainwright (USAIN)",
   label: "Wainwright (USAIN)"
  },
  {
   value: "Waite Park (USITP)",
   label: "Waite Park (USITP)"
  },
  {
   value: "Waitsburg (USIBG)",
   label: "Waitsburg (USIBG)"
  },
  {
   value: "Wake Forest (USWKR)",
   label: "Wake Forest (USWKR)"
  },
  {
   value: "Wakefield (USWFE)",
   label: "Wakefield (USWFE)"
  },
  {
   value: "Wakefield (USWKD)",
   label: "Wakefield (USWKD)"
  },
  {
   value: "Walbridge (USWBG)",
   label: "Walbridge (USWBG)"
  },
  {
   value: "Walburg (USVXS)",
   label: "Walburg (USVXS)"
  },
  {
   value: "Walcott (USOJT)",
   label: "Walcott (USOJT)"
  },
  {
   value: "Waldo (USWGA)",
   label: "Waldo (USWGA)"
  },
  {
   value: "Waldoboro (USWDJ)",
   label: "Waldoboro (USWDJ)"
  },
  {
   value: "Wales (USW3A)",
   label: "Wales (USW3A)"
  },
  {
   value: "Walford (USWFQ)",
   label: "Walford (USWFQ)"
  },
  {
   value: "Walhalla (USVLH)",
   label: "Walhalla (USVLH)"
  },
  {
   value: "Walker (USLKR)",
   label: "Walker (USLKR)"
  },
  {
   value: "Walker (USZFR)",
   label: "Walker (USZFR)"
  },
  {
   value: "Walkerton (USWKC)",
   label: "Walkerton (USWKC)"
  },
  {
   value: "Walkerton (USWKN)",
   label: "Walkerton (USWKN)"
  },
  {
   value: "Walkertown (USAKW)",
   label: "Walkertown (USAKW)"
  },
  {
   value: "Walkertown (USWUA)",
   label: "Walkertown (USWUA)"
  },
  {
   value: "Walkerville (USVLX)",
   label: "Walkerville (USVLX)"
  },
  {
   value: "Wall (USAWP)",
   label: "Wall (USAWP)"
  },
  {
   value: "Wall (USWLJ)",
   label: "Wall (USWLJ)"
  },
  {
   value: "Wall (USWZL)",
   label: "Wall (USWZL)"
  },
  {
   value: "Wall Lake (USWKP)",
   label: "Wall Lake (USWKP)"
  },
  {
   value: "Wallace (USWA2)",
   label: "Wallace (USWA2)"
  },
  {
   value: "Wallace (USWBT)",
   label: "Wallace (USWBT)"
  },
  {
   value: "Waller (USVLL)",
   label: "Waller (USVLL)"
  },
  {
   value: "Wallingford (USWGF)",
   label: "Wallingford (USWGF)"
  },
  {
   value: "Walnut Cove (USXKS)",
   label: "Walnut Cove (USXKS)"
  },
  {
   value: "Walnut Creek (USWAC)",
   label: "Walnut Creek (USWAC)"
  },
  {
   value: "Walnut Creek (USWUC)",
   label: "Walnut Creek (USWUC)"
  },
  {
   value: "Walnut Grove (USWGR)",
   label: "Walnut Grove (USWGR)"
  },
  {
   value: "Walnut Grove (USYXG)",
   label: "Walnut Grove (USYXG)"
  },
  {
   value: "Walnutport (USWNU)",
   label: "Walnutport (USWNU)"
  },
  {
   value: "Walton (USJWO)",
   label: "Walton (USJWO)"
  },
  {
   value: "Walton (USQWT)",
   label: "Walton (USQWT)"
  },
  {
   value: "Wando (USWFH)",
   label: "Wando (USWFH)"
  },
  {
   value: "Wantagh (USTWH)",
   label: "Wantagh (USTWH)"
  },
  {
   value: "Wapiti (USIIH)",
   label: "Wapiti (USIIH)"
  },
  {
   value: "Ward (USYWD)",
   label: "Ward (USYWD)"
  },
  {
   value: "Ward Cove (USWDC)",
   label: "Ward Cove (USWDC)"
  },
  {
   value: "Ware Shoals (USASS)",
   label: "Ware Shoals (USASS)"
  },
  {
   value: "Warfordsburg (USYWF)",
   label: "Warfordsburg (USYWF)"
  },
  {
   value: "Warm Springs (USRMR)",
   label: "Warm Springs (USRMR)"
  },
  {
   value: "Warminster (USWRM)",
   label: "Warminster (USWRM)"
  },
  {
   value: "Warne (USWAR)",
   label: "Warne (USWAR)"
  },
  {
   value: "Warner (USJRN)",
   label: "Warner (USJRN)"
  },
  {
   value: "Warner Springs (USWS3)",
   label: "Warner Springs (USWS3)"
  },
  {
   value: "Warren (USVRZ)",
   label: "Warren (USVRZ)"
  },
  {
   value: "Warren (USVWR)",
   label: "Warren (USVWR)"
  },
  {
   value: "Warren (USWEN)",
   label: "Warren (USWEN)"
  },
  {
   value: "Warren (USZWR)",
   label: "Warren (USZWR)"
  },
  {
   value: "Warrensburg (USWR8)",
   label: "Warrensburg (USWR8)"
  },
  {
   value: "Warrenton (USTWG)",
   label: "Warrenton (USTWG)"
  },
  {
   value: "Warrenton (USWRE)",
   label: "Warrenton (USWRE)"
  },
  {
   value: "Warrenville (USWNI)",
   label: "Warrenville (USWNI)"
  },
  {
   value: "Warrenville (USWZR)",
   label: "Warrenville (USWZR)"
  },
  {
   value: "Warrenville (USXWV)",
   label: "Warrenville (USXWV)"
  },
  {
   value: "Warrior (USRRP)",
   label: "Warrior (USRRP)"
  },
  {
   value: "Warsaw (USARW)",
   label: "Warsaw (USARW)"
  },
  {
   value: "Warsaw (USWSW)",
   label: "Warsaw (USWSW)"
  },
  {
   value: "Warsaw (USWWC)",
   label: "Warsaw (USWWC)"
  },
  {
   value: "Warsaw (USWWG)",
   label: "Warsaw (USWWG)"
  },
  {
   value: "Warsaw (USWXW)",
   label: "Warsaw (USWXW)"
  },
  {
   value: "Warsaw (USWZS)",
   label: "Warsaw (USWZS)"
  },
  {
   value: "Wartburg (USWTU)",
   label: "Wartburg (USWTU)"
  },
  {
   value: "Warwick (USWRC)",
   label: "Warwick (USWRC)"
  },
  {
   value: "Warwick (USWRK)",
   label: "Warwick (USWRK)"
  },
  {
   value: "Warwick (USWW3)",
   label: "Warwick (USWW3)"
  },
  {
   value: "Wasco (USWC7)",
   label: "Wasco (USWC7)"
  },
  {
   value: "Washburn (USHBU)",
   label: "Washburn (USHBU)"
  },
  {
   value: "Washburn (USURW)",
   label: "Washburn (USURW)"
  },
  {
   value: "Washington (USKJH)",
   label: "Washington (USKJH)"
  },
  {
   value: "Washington (USNGN)",
   label: "Washington (USNGN)"
  },
  {
   value: "Washington (USS9)",
   label: "Washington (USS9)"
  },
  {
   value: "Washington (USVTO)",
   label: "Washington (USVTO)"
  },
  {
   value: "Washington (USWAB)",
   label: "Washington (USWAB)"
  },
  {
   value: "Washington (USWGI)",
   label: "Washington (USWGI)"
  },
  {
   value: "Washington (USWGT)",
   label: "Washington (USWGT)"
  },
  {
   value: "Washington (USWT3)",
   label: "Washington (USWT3)"
  },
  {
   value: "Washington Court House (USWCQ)",
   label: "Washington Court House (USWCQ)"
  },
  {
   value: "Washington Island (USGSA)",
   label: "Washington Island (USGSA)"
  },
  {
   value: "Washington Park (USWGK)",
   label: "Washington Park (USWGK)"
  },
  {
   value: "Washingtonville (USWG8)",
   label: "Washingtonville (USWG8)"
  },
  {
   value: "Waskom (USZJN)",
   label: "Waskom (USZJN)"
  },
  {
   value: "Water Mill (USAEM)",
   label: "Water Mill (USAEM)"
  },
  {
   value: "Water Valley (USWVA)",
   label: "Water Valley (USWVA)"
  },
  {
   value: "Waterfall (USKWF)",
   label: "Waterfall (USKWF)"
  },
  {
   value: "Waterflow (USTFW)",
   label: "Waterflow (USTFW)"
  },
  {
   value: "Waterford (USTEY)",
   label: "Waterford (USTEY)"
  },
  {
   value: "Waterford (USTQF)",
   label: "Waterford (USTQF)"
  },
  {
   value: "Waterford (USWTF)",
   label: "Waterford (USWTF)"
  },
  {
   value: "Waterford (USWXX)",
   label: "Waterford (USWXX)"
  },
  {
   value: "Waterford (USXWF)",
   label: "Waterford (USXWF)"
  },
  {
   value: "Waterloo (USVTL)",
   label: "Waterloo (USVTL)"
  },
  {
   value: "Waterloo (USXWA)",
   label: "Waterloo (USXWA)"
  },
  {
   value: "Waterloo (USZTE)",
   label: "Waterloo (USZTE)"
  },
  {
   value: "Waterloo (USZWA)",
   label: "Waterloo (USZWA)"
  },
  {
   value: "Waterloo, Johnson (USWPV)",
   label: "Waterloo, Johnson (USWPV)"
  },
  {
   value: "Waterport (USWP6)",
   label: "Waterport (USWP6)"
  },
  {
   value: "Waterproof (USWPF)",
   label: "Waterproof (USWPF)"
  },
  {
   value: "Waterville (USTEI)",
   label: "Waterville (USTEI)"
  },
  {
   value: "Waterville (USTIL)",
   label: "Waterville (USTIL)"
  },
  {
   value: "Waterville (USVWL)",
   label: "Waterville (USVWL)"
  },
  {
   value: "Waterville Valley (USWZY)",
   label: "Waterville Valley (USWZY)"
  },
  {
   value: "Wathena (USWJA)",
   label: "Wathena (USWJA)"
  },
  {
   value: "Watkins (USTKS)",
   label: "Watkins (USTKS)"
  },
  {
   value: "Watkins (USUWK)",
   label: "Watkins (USUWK)"
  },
  {
   value: "Watkinsville (USVKV)",
   label: "Watkinsville (USVKV)"
  },
  {
   value: "Watonga (USYWQ)",
   label: "Watonga (USYWQ)"
  },
  {
   value: "Watson (USWTC)",
   label: "Watson (USWTC)"
  },
  {
   value: "Watsontown (USASW)",
   label: "Watsontown (USASW)"
  },
  {
   value: "Waukee (USWKE)",
   label: "Waukee (USWKE)"
  },
  {
   value: "Waukon (USUKN)",
   label: "Waukon (USUKN)"
  },
  {
   value: "Wauna (USYWN)",
   label: "Wauna (USYWN)"
  },
  {
   value: "Waupaca (USWUP)",
   label: "Waupaca (USWUP)"
  },
  {
   value: "Waupun (USWUU)",
   label: "Waupun (USWUU)"
  },
  {
   value: "Wauregan (USQWR)",
   label: "Wauregan (USQWR)"
  },
  {
   value: "Wausaukee (USUSU)",
   label: "Wausaukee (USUSU)"
  },
  {
   value: "Waveland (USVOD)",
   label: "Waveland (USVOD)"
  },
  {
   value: "Waverley (USYEY)",
   label: "Waverley (USYEY)"
  },
  {
   value: "Waverly (USVRY)",
   label: "Waverly (USVRY)"
  },
  {
   value: "Waverly (USWVH)",
   label: "Waverly (USWVH)"
  },
  {
   value: "Waverly (USWXV)",
   label: "Waverly (USWXV)"
  },
  {
   value: "Waverly (USWY8)",
   label: "Waverly (USWY8)"
  },
  {
   value: "Waverly Hall (USZAL)",
   label: "Waverly Hall (USZAL)"
  },
  {
   value: "Waxhaw (USWXH)",
   label: "Waxhaw (USWXH)"
  },
  {
   value: "Wayland (USAYN)",
   label: "Wayland (USAYN)"
  },
  {
   value: "Wayland (USWL2)",
   label: "Wayland (USWL2)"
  },
  {
   value: "Wayland (USWYF)",
   label: "Wayland (USWYF)"
  },
  {
   value: "Wayne (USWPY)",
   label: "Wayne (USWPY)"
  },
  {
   value: "Wayne (USYNE)",
   label: "Wayne (USYNE)"
  },
  {
   value: "Wayne County Apt\/Detroit (USDTW)",
   label: "Wayne County Apt\/Detroit (USDTW)"
  },
  {
   value: "Waynesburg (USWAY)",
   label: "Waynesburg (USWAY)"
  },
  {
   value: "Waynesville (USWNV)",
   label: "Waynesville (USWNV)"
  },
  {
   value: "Waynesville (USYWL)",
   label: "Waynesville (USYWL)"
  },
  {
   value: "Wayzata (USYWZ)",
   label: "Wayzata (USYWZ)"
  },
  {
   value: "Weare (USWCJ)",
   label: "Weare (USWCJ)"
  },
  {
   value: "Weaver (USWWW)",
   label: "Weaver (USWWW)"
  },
  {
   value: "Webb City (USXBW)",
   label: "Webb City (USXBW)"
  },
  {
   value: "Webberville (USWER)",
   label: "Webberville (USWER)"
  },
  {
   value: "Weber City (USWEC)",
   label: "Weber City (USWEC)"
  },
  {
   value: "Webster (USFWS)",
   label: "Webster (USFWS)"
  },
  {
   value: "Webster (USWB3)",
   label: "Webster (USWB3)"
  },
  {
   value: "Webster (USWT2)",
   label: "Webster (USWT2)"
  },
  {
   value: "Webster (USYWB)",
   label: "Webster (USYWB)"
  },
  {
   value: "Webster Groves (USWG6)",
   label: "Webster Groves (USWG6)"
  },
  {
   value: "Webster, Harris (USAFW)",
   label: "Webster, Harris (USAFW)"
  },
  {
   value: "Wedron (USWRW)",
   label: "Wedron (USWRW)"
  },
  {
   value: "Weed (USWD3)",
   label: "Weed (USWD3)"
  },
  {
   value: "Weedsport (USEES)",
   label: "Weedsport (USEES)"
  },
  {
   value: "Weeks (USWKS)",
   label: "Weeks (USWKS)"
  },
  {
   value: "Weidman (USIMN)",
   label: "Weidman (USIMN)"
  },
  {
   value: "Weiner (USWNR)",
   label: "Weiner (USWNR)"
  },
  {
   value: "Weiser (USIWI)",
   label: "Weiser (USIWI)"
  },
  {
   value: "Welch (USOWC)",
   label: "Welch (USOWC)"
  },
  {
   value: "Welcome (USEOM)",
   label: "Welcome (USEOM)"
  },
  {
   value: "Welcome (USWCO)",
   label: "Welcome (USWCO)"
  },
  {
   value: "Weldon (USKDO)",
   label: "Weldon (USKDO)"
  },
  {
   value: "Wellborn (USZF4)",
   label: "Wellborn (USZF4)"
  },
  {
   value: "Wellington (USWCZ)",
   label: "Wellington (USWCZ)"
  },
  {
   value: "Wellington (USWEX)",
   label: "Wellington (USWEX)"
  },
  {
   value: "Wellington (USWJT)",
   label: "Wellington (USWJT)"
  },
  {
   value: "Wellington (USZJJ)",
   label: "Wellington (USZJJ)"
  },
  {
   value: "Wells River (USWR6)",
   label: "Wells River (USWR6)"
  },
  {
   value: "Wellston (USOHW)",
   label: "Wellston (USOHW)"
  },
  {
   value: "Wellton (USWZD)",
   label: "Wellton (USWZD)"
  },
  {
   value: "Wendel (USYWY)",
   label: "Wendel (USYWY)"
  },
  {
   value: "Wendover (USENV)",
   label: "Wendover (USENV)"
  },
  {
   value: "Wenonah (USWZZ)",
   label: "Wenonah (USWZZ)"
  },
  {
   value: "Wentworth (USWNH)",
   label: "Wentworth (USWNH)"
  },
  {
   value: "Wentworth (USWW2)",
   label: "Wentworth (USWW2)"
  },
  {
   value: "Wentzville (USWTZ)",
   label: "Wentzville (USWTZ)"
  },
  {
   value: "Wernersville (USWVO)",
   label: "Wernersville (USWVO)"
  },
  {
   value: "Wesley Chapel (USWC3)",
   label: "Wesley Chapel (USWC3)"
  },
  {
   value: "West Alexandria (USTAX)",
   label: "West Alexandria (USTAX)"
  },
  {
   value: "West Allis (USWEQ)",
   label: "West Allis (USWEQ)"
  },
  {
   value: "West Alton (USWA8)",
   label: "West Alton (USWA8)"
  },
  {
   value: "West Babylon (USEBB)",
   label: "West Babylon (USEBB)"
  },
  {
   value: "West Bend (USETE)",
   label: "West Bend (USETE)"
  },
  {
   value: "West Boylston (USWBM)",
   label: "West Boylston (USWBM)"
  },
  {
   value: "West Branch (USIWB)",
   label: "West Branch (USIWB)"
  },
  {
   value: "West Burke (USURK)",
   label: "West Burke (USURK)"
  },
  {
   value: "West Chester (USWCT)",
   label: "West Chester (USWCT)"
  },
  {
   value: "West Chop (USWC2)",
   label: "West Chop (USWC2)"
  },
  {
   value: "West College Corner (USWGD)",
   label: "West College Corner (USWGD)"
  },
  {
   value: "West Dover (USWD2)",
   label: "West Dover (USWD2)"
  },
  {
   value: "West Dundee (USWD8)",
   label: "West Dundee (USWD8)"
  },
  {
   value: "West Fargo (USWFG)",
   label: "West Fargo (USWFG)"
  },
  {
   value: "West Fork (USWQQ)",
   label: "West Fork (USWQQ)"
  },
  {
   value: "West Frankfort (USKFT)",
   label: "West Frankfort (USKFT)"
  },
  {
   value: "West Gloucester (USWGU)",
   label: "West Gloucester (USWGU)"
  },
  {
   value: "West Halifax (USEFX)",
   label: "West Halifax (USEFX)"
  },
  {
   value: "West Harrison (USEHO)",
   label: "West Harrison (USEHO)"
  },
  {
   value: "West Harrison (USWJH)",
   label: "West Harrison (USWJH)"
  },
  {
   value: "West Harwich (USHWC)",
   label: "West Harwich (USHWC)"
  },
  {
   value: "West Hatfield (USWED)",
   label: "West Hatfield (USWED)"
  },
  {
   value: "West Hazelton (USWZN)",
   label: "West Hazelton (USWZN)"
  },
  {
   value: "West Henrietta (USWEE)",
   label: "West Henrietta (USWEE)"
  },
  {
   value: "West Hills (USTLS)",
   label: "West Hills (USTLS)"
  },
  {
   value: "West Homestead (USYWE)",
   label: "West Homestead (USYWE)"
  },
  {
   value: "West Hurley (USZHY)",
   label: "West Hurley (USZHY)"
  },
  {
   value: "West Jefferson, Madison (USWJM)",
   label: "West Jefferson, Madison (USWJM)"
  },
  {
   value: "West Jefferson, Williams (USWJW)",
   label: "West Jefferson, Williams (USWJW)"
  },
  {
   value: "West Jordan (USWEJ)",
   label: "West Jordan (USWEJ)"
  },
  {
   value: "West Kavik (USVKW)",
   label: "West Kavik (USVKW)"
  },
  {
   value: "West Kennebunk (USVWB)",
   label: "West Kennebunk (USVWB)"
  },
  {
   value: "West Kingston (USKXT)",
   label: "West Kingston (USKXT)"
  },
  {
   value: "West Kuparuk (USXPU)",
   label: "West Kuparuk (USXPU)"
  },
  {
   value: "West Lafayette (USWLY)",
   label: "West Lafayette (USWLY)"
  },
  {
   value: "West Lafayette (USWZF)",
   label: "West Lafayette (USWZF)"
  },
  {
   value: "West Liberty (USWL3)",
   label: "West Liberty (USWL3)"
  },
  {
   value: "West Long Branch (USWLQ)",
   label: "West Long Branch (USWLQ)"
  },
  {
   value: "West Melbourne (USTMU)",
   label: "West Melbourne (USTMU)"
  },
  {
   value: "West Milwaukee (USWMW)",
   label: "West Milwaukee (USWMW)"
  },
  {
   value: "West Monroe (USWMX)",
   label: "West Monroe (USWMX)"
  },
  {
   value: "West Olive (USUIV)",
   label: "West Olive (USUIV)"
  },
  {
   value: "West Orange (USXOW)",
   label: "West Orange (USXOW)"
  },
  {
   value: "West Orange\/New Jersey (USWOR)",
   label: "West Orange\/New Jersey (USWOR)"
  },
  {
   value: "West Peoria (USTPR)",
   label: "West Peoria (USTPR)"
  },
  {
   value: "West Pittsburg (USTPB)",
   label: "West Pittsburg (USTPB)"
  },
  {
   value: "West Pittston (USWQP)",
   label: "West Pittston (USWQP)"
  },
  {
   value: "West Point (USKWP)",
   label: "West Point (USKWP)"
  },
  {
   value: "West Point (USVI2)",
   label: "West Point (USVI2)"
  },
  {
   value: "West Point (USWOI)",
   label: "West Point (USWOI)"
  },
  {
   value: "West Point (USWOT)",
   label: "West Point (USWOT)"
  },
  {
   value: "West Point (USWP8)",
   label: "West Point (USWP8)"
  },
  {
   value: "West Portal (USWXP)",
   label: "West Portal (USWXP)"
  },
  {
   value: "West Reading (USZDG)",
   label: "West Reading (USZDG)"
  },
  {
   value: "West Rutland (USXTR)",
   label: "West Rutland (USXTR)"
  },
  {
   value: "West Salem (USFHK)",
   label: "West Salem (USFHK)"
  },
  {
   value: "West Salem (USWS5)",
   label: "West Salem (USWS5)"
  },
  {
   value: "West Salem (USWSS)",
   label: "West Salem (USWSS)"
  },
  {
   value: "West Sayville (USWS2)",
   label: "West Sayville (USWS2)"
  },
  {
   value: "West Sayville (USYLY)",
   label: "West Sayville (USYLY)"
  },
  {
   value: "West Sound (USWSX)",
   label: "West Sound (USWSX)"
  },
  {
   value: "West Springfield (USWPG)",
   label: "West Springfield (USWPG)"
  },
  {
   value: "West Springfield (USWSU)",
   label: "West Springfield (USWSU)"
  },
  {
   value: "West St Paul (USWPU)",
   label: "West St Paul (USWPU)"
  },
  {
   value: "West Swanzey (USNZY)",
   label: "West Swanzey (USNZY)"
  },
  {
   value: "West Terre Haute (USWZH)",
   label: "West Terre Haute (USWZH)"
  },
  {
   value: "West Tisbury (USYYT)",
   label: "West Tisbury (USYYT)"
  },
  {
   value: "West Trenton (USWT4)",
   label: "West Trenton (USWT4)"
  },
  {
   value: "West Union (USEUO)",
   label: "West Union (USEUO)"
  },
  {
   value: "West Union (USWEU)",
   label: "West Union (USWEU)"
  },
  {
   value: "West Union (USWUI)",
   label: "West Union (USWUI)"
  },
  {
   value: "West Valley City (USWVC)",
   label: "West Valley City (USWVC)"
  },
  {
   value: "West Wendover (USWW4)",
   label: "West Wendover (USWW4)"
  },
  {
   value: "West Windsor (USESI)",
   label: "West Windsor (USESI)"
  },
  {
   value: "West Winfield (USEFU)",
   label: "West Winfield (USEFU)"
  },
  {
   value: "West Winfield (USTDZ)",
   label: "West Winfield (USTDZ)"
  },
  {
   value: "West Yarmouth (USWMU)",
   label: "West Yarmouth (USWMU)"
  },
  {
   value: "West York (USWYK)",
   label: "West York (USWYK)"
  },
  {
   value: "Westampton (USWEP)",
   label: "Westampton (USWEP)"
  },
  {
   value: "Westboro (USWQB)",
   label: "Westboro (USWQB)"
  },
  {
   value: "Westborough (USWRO)",
   label: "Westborough (USWRO)"
  },
  {
   value: "Westchester (USES3)",
   label: "Westchester (USES3)"
  },
  {
   value: "Westchester (USWC6)",
   label: "Westchester (USWC6)"
  },
  {
   value: "Westcliffe (USWFF)",
   label: "Westcliffe (USWFF)"
  },
  {
   value: "Western Grove (USVGN)",
   label: "Western Grove (USVGN)"
  },
  {
   value: "Westfield (USWF2)",
   label: "Westfield (USWF2)"
  },
  {
   value: "Westfield (USWFL)",
   label: "Westfield (USWFL)"
  },
  {
   value: "Westfield (USWFU)",
   label: "Westfield (USWFU)"
  },
  {
   value: "Westhampton (USQWH)",
   label: "Westhampton (USQWH)"
  },
  {
   value: "Westlake (USWLX)",
   label: "Westlake (USWLX)"
  },
  {
   value: "Westland (USWTD)",
   label: "Westland (USWTD)"
  },
  {
   value: "Westley (USQWY)",
   label: "Westley (USQWY)"
  },
  {
   value: "Westmoreland (USTRQ)",
   label: "Westmoreland (USTRQ)"
  },
  {
   value: "Westmoreland (USW3M)",
   label: "Westmoreland (USW3M)"
  },
  {
   value: "Weston (USIWE)",
   label: "Weston (USIWE)"
  },
  {
   value: "Weston (USOHE)",
   label: "Weston (USOHE)"
  },
  {
   value: "Weston (USWNO)",
   label: "Weston (USWNO)"
  },
  {
   value: "Weston (USWZE)",
   label: "Weston (USWZE)"
  },
  {
   value: "Weston (USWZT)",
   label: "Weston (USWZT)"
  },
  {
   value: "Weston Mills (USWNM)",
   label: "Weston Mills (USWNM)"
  },
  {
   value: "Westover (USYTZ)",
   label: "Westover (USYTZ)"
  },
  {
   value: "Westport (USWP4)",
   label: "Westport (USWP4)"
  },
  {
   value: "Westport (USWP5)",
   label: "Westport (USWP5)"
  },
  {
   value: "Westport (USWPE)",
   label: "Westport (USWPE)"
  },
  {
   value: "Westport (USWPR)",
   label: "Westport (USWPR)"
  },
  {
   value: "Westside (USWJS)",
   label: "Westside (USWJS)"
  },
  {
   value: "Westville (USWVK)",
   label: "Westville (USWVK)"
  },
  {
   value: "Westville (USZIY)",
   label: "Westville (USZIY)"
  },
  {
   value: "Westwood (USVEW)",
   label: "Westwood (USVEW)"
  },
  {
   value: "Wetumpka (USWUK)",
   label: "Wetumpka (USWUK)"
  },
  {
   value: "Wewoka (USWUE)",
   label: "Wewoka (USWUE)"
  },
  {
   value: "Whale Pass (USWWP)",
   label: "Whale Pass (USWWP)"
  },
  {
   value: "Whaleysville (USAE3)",
   label: "Whaleysville (USAE3)"
  },
  {
   value: "Wharton (USWTQ)",
   label: "Wharton (USWTQ)"
  },
  {
   value: "Whately (USYWH)",
   label: "Whately (USYWH)"
  },
  {
   value: "Wheatfield (USFWH)",
   label: "Wheatfield (USFWH)"
  },
  {
   value: "Wheaton (USWFA)",
   label: "Wheaton (USWFA)"
  },
  {
   value: "Wheaton (USWHX)",
   label: "Wheaton (USWHX)"
  },
  {
   value: "Wheeler (USEEE)",
   label: "Wheeler (USEEE)"
  },
  {
   value: "Whipple (USWZX)",
   label: "Whipple (USWZX)"
  },
  {
   value: "Whistler (USHTR)",
   label: "Whistler (USHTR)"
  },
  {
   value: "Whitakers (USWKT)",
   label: "Whitakers (USWKT)"
  },
  {
   value: "White (USWUH)",
   label: "White (USWUH)"
  },
  {
   value: "White (USYWX)",
   label: "White (USYWX)"
  },
  {
   value: "White (USZWT)",
   label: "White (USZWT)"
  },
  {
   value: "White Bluff (USWHB)",
   label: "White Bluff (USWHB)"
  },
  {
   value: "White Cloud (USECU)",
   label: "White Cloud (USECU)"
  },
  {
   value: "White Cloud (USWXC)",
   label: "White Cloud (USWXC)"
  },
  {
   value: "White Hall (USWH6)",
   label: "White Hall (USWH6)"
  },
  {
   value: "White House (USWHU)",
   label: "White House (USWHU)"
  },
  {
   value: "White Lake (USKKW)",
   label: "White Lake (USKKW)"
  },
  {
   value: "White Lake (USWEK)",
   label: "White Lake (USWEK)"
  },
  {
   value: "White Lake (USXWE)",
   label: "White Lake (USXWE)"
  },
  {
   value: "White Marsh (USHIM)",
   label: "White Marsh (USHIM)"
  },
  {
   value: "White Marsh Station (USWWM)",
   label: "White Marsh Station (USWWM)"
  },
  {
   value: "White Oak (USWTX)",
   label: "White Oak (USWTX)"
  },
  {
   value: "White Pine (USZTP)",
   label: "White Pine (USZTP)"
  },
  {
   value: "White Plains (USXWP)",
   label: "White Plains (USXWP)"
  },
  {
   value: "White River (USIRI)",
   label: "White River (USIRI)"
  },
  {
   value: "White Salmon (USWEI)",
   label: "White Salmon (USWEI)"
  },
  {
   value: "White Settlement (USIYT)",
   label: "White Settlement (USIYT)"
  },
  {
   value: "White Stone (USWJE)",
   label: "White Stone (USWJE)"
  },
  {
   value: "Whiteford (USIFD)",
   label: "Whiteford (USIFD)"
  },
  {
   value: "Whitehall (USTTL)",
   label: "Whitehall (USTTL)"
  },
  {
   value: "Whitehouse (USZWH)",
   label: "Whitehouse (USZWH)"
  },
  {
   value: "Whitehouse Station (USWS6)",
   label: "Whitehouse Station (USWS6)"
  },
  {
   value: "Whiteland (USITL)",
   label: "Whiteland (USITL)"
  },
  {
   value: "Whiteriver (USIIK)",
   label: "Whiteriver (USIIK)"
  },
  {
   value: "Whites Creek (USWC5)",
   label: "Whites Creek (USWC5)"
  },
  {
   value: "Whitesboro (USWH2)",
   label: "Whitesboro (USWH2)"
  },
  {
   value: "Whitesburg (USBRG)",
   label: "Whitesburg (USBRG)"
  },
  {
   value: "Whitesburg (USXWH)",
   label: "Whitesburg (USXWH)"
  },
  {
   value: "Whitestone (USZWS)",
   label: "Whitestone (USZWS)"
  },
  {
   value: "Whitestown (USXWT)",
   label: "Whitestown (USXWT)"
  },
  {
   value: "Whitesville (USWVG)",
   label: "Whitesville (USWVG)"
  },
  {
   value: "Whitewater (USWWQ)",
   label: "Whitewater (USWWQ)"
  },
  {
   value: "Whiting (USWHG)",
   label: "Whiting (USWHG)"
  },
  {
   value: "Whitman (USWQA)",
   label: "Whitman (USWQA)"
  },
  {
   value: "Whitmire (USIWM)",
   label: "Whitmire (USIWM)"
  },
  {
   value: "Whitmore Lake (USWMP)",
   label: "Whitmore Lake (USWMP)"
  },
  {
   value: "Whitner (USWHK)",
   label: "Whitner (USWHK)"
  },
  {
   value: "Whitney (USWT5)",
   label: "Whitney (USWT5)"
  },
  {
   value: "Whitsett (USITE)",
   label: "Whitsett (USITE)"
  },
  {
   value: "Whitsett (USWT6)",
   label: "Whitsett (USWT6)"
  },
  {
   value: "Whittemore (USITM)",
   label: "Whittemore (USITM)"
  },
  {
   value: "Wichita Falls (USSPS)",
   label: "Wichita Falls (USSPS)"
  },
  {
   value: "Wicker Park (USWCP)",
   label: "Wicker Park (USWCP)"
  },
  {
   value: "Wickliffe (USWIC)",
   label: "Wickliffe (USWIC)"
  },
  {
   value: "Wicomico Church (USWC4)",
   label: "Wicomico Church (USWC4)"
  },
  {
   value: "Widener (USIDR)",
   label: "Widener (USIDR)"
  },
  {
   value: "Wiggins (USGGI)",
   label: "Wiggins (USGGI)"
  },
  {
   value: "Wilcox (USYWI)",
   label: "Wilcox (USYWI)"
  },
  {
   value: "Wilder (USVTD)",
   label: "Wilder (USVTD)"
  },
  {
   value: "Wildomar (USIOM)",
   label: "Wildomar (USIOM)"
  },
  {
   value: "Wildwood (USIOD)",
   label: "Wildwood (USIOD)"
  },
  {
   value: "Wildwood (USWQD)",
   label: "Wildwood (USWQD)"
  },
  {
   value: "Wilkes Barre (USWKB)",
   label: "Wilkes Barre (USWKB)"
  },
  {
   value: "Wilkes-Barre (USWBE)",
   label: "Wilkes-Barre (USWBE)"
  },
  {
   value: "Wilkins (USWIK)",
   label: "Wilkins (USWIK)"
  },
  {
   value: "Willacoochee (USYWA)",
   label: "Willacoochee (USYWA)"
  },
  {
   value: "Willapa (USWIH)",
   label: "Willapa (USWIH)"
  },
  {
   value: "Willard (USIWL)",
   label: "Willard (USIWL)"
  },
  {
   value: "Willard (USZWJ)",
   label: "Willard (USZWJ)"
  },
  {
   value: "Willcox (USICX)",
   label: "Willcox (USICX)"
  },
  {
   value: "Williams (USIFM)",
   label: "Williams (USIFM)"
  },
  {
   value: "Williams (USIIW)",
   label: "Williams (USIIW)"
  },
  {
   value: "Williams (USIMS)",
   label: "Williams (USIMS)"
  },
  {
   value: "Williams (USWIA)",
   label: "Williams (USWIA)"
  },
  {
   value: "Williams (USWL7)",
   label: "Williams (USWL7)"
  },
  {
   value: "Williamsburg (USIMU)",
   label: "Williamsburg (USIMU)"
  },
  {
   value: "Williamsburg (USQWZ)",
   label: "Williamsburg (USQWZ)"
  },
  {
   value: "Williamsburg (USWLG)",
   label: "Williamsburg (USWLG)"
  },
  {
   value: "Williamsburg (USWUS)",
   label: "Williamsburg (USWUS)"
  },
  {
   value: "Williamston (USIIM)",
   label: "Williamston (USIIM)"
  },
  {
   value: "Williamston (USWWL)",
   label: "Williamston (USWWL)"
  },
  {
   value: "Williamstown (USWS8)",
   label: "Williamstown (USWS8)"
  },
  {
   value: "Williamstown (USYWS)",
   label: "Williamstown (USYWS)"
  },
  {
   value: "Williamstown (USZJM)",
   label: "Williamstown (USZJM)"
  },
  {
   value: "Williamsville (USIIA)",
   label: "Williamsville (USIIA)"
  },
  {
   value: "Willianstown (USXZW)",
   label: "Willianstown (USXZW)"
  },
  {
   value: "Willimantic (USQWL)",
   label: "Willimantic (USQWL)"
  },
  {
   value: "Willington (USIGV)",
   label: "Willington (USIGV)"
  },
  {
   value: "Willington (USZFU)",
   label: "Willington (USZFU)"
  },
  {
   value: "Willis (USIIS)",
   label: "Willis (USIIS)"
  },
  {
   value: "Williston (USISN)",
   label: "Williston (USISN)"
  },
  {
   value: "Willow (USWXL)",
   label: "Willow (USWXL)"
  },
  {
   value: "Willow Brook (USWIB)",
   label: "Willow Brook (USWIB)"
  },
  {
   value: "Willow Hill (USIWW)",
   label: "Willow Hill (USIWW)"
  },
  {
   value: "Willow Run (USWRU)",
   label: "Willow Run (USWRU)"
  },
  {
   value: "Willow Run Apt\/Detroit (USYIP)",
   label: "Willow Run Apt\/Detroit (USYIP)"
  },
  {
   value: "Willow Spring (USIWS)",
   label: "Willow Spring (USIWS)"
  },
  {
   value: "Willow Springs (USZWO)",
   label: "Willow Springs (USZWO)"
  },
  {
   value: "Willowbrook, DuPage (USWOP)",
   label: "Willowbrook, DuPage (USWOP)"
  },
  {
   value: "Wills Point (USILS)",
   label: "Wills Point (USILS)"
  },
  {
   value: "Wills Point (USWPB)",
   label: "Wills Point (USWPB)"
  },
  {
   value: "Willston (USVAW)",
   label: "Willston (USVAW)"
  },
  {
   value: "Wilma (USWMA)",
   label: "Wilma (USWMA)"
  },
  {
   value: "Wilmer (USWXR)",
   label: "Wilmer (USWXR)"
  },
  {
   value: "Wilmerding (USIME)",
   label: "Wilmerding (USIME)"
  },
  {
   value: "Wilmette (USXTT)",
   label: "Wilmette (USXTT)"
  },
  {
   value: "Wilmington (USIMG)",
   label: "Wilmington (USIMG)"
  },
  {
   value: "Wilmington (USIZG)",
   label: "Wilmington (USIZG)"
  },
  {
   value: "Wilmington (USWMT)",
   label: "Wilmington (USWMT)"
  },
  {
   value: "Wilmot (USZFS)",
   label: "Wilmot (USZFS)"
  },
  {
   value: "Wilson (USIOF)",
   label: "Wilson (USIOF)"
  },
  {
   value: "Wilson (USWQI)",
   label: "Wilson (USWQI)"
  },
  {
   value: "Wilson (USWZO)",
   label: "Wilson (USWZO)"
  },
  {
   value: "Wilton (USIOV)",
   label: "Wilton (USIOV)"
  },
  {
   value: "Wilton (USUWO)",
   label: "Wilton (USUWO)"
  },
  {
   value: "Wilton (USWIM)",
   label: "Wilton (USWIM)"
  },
  {
   value: "Wilton (USWIO)",
   label: "Wilton (USWIO)"
  },
  {
   value: "Wilton (USWT8)",
   label: "Wilton (USWT8)"
  },
  {
   value: "Wimberley (USWJB)",
   label: "Wimberley (USWJB)"
  },
  {
   value: "Winchester (USIHR)",
   label: "Winchester (USIHR)"
  },
  {
   value: "Winchester (USIHS)",
   label: "Winchester (USIHS)"
  },
  {
   value: "Winchester (USIHT)",
   label: "Winchester (USIHT)"
  },
  {
   value: "Winchester (USYST)",
   label: "Winchester (USYST)"
  },
  {
   value: "Winchester Center (USWCC)",
   label: "Winchester Center (USWCC)"
  },
  {
   value: "Windfall (USWF4)",
   label: "Windfall (USWF4)"
  },
  {
   value: "Windham (USWHM)",
   label: "Windham (USWHM)"
  },
  {
   value: "Windham (USWKH)",
   label: "Windham (USWKH)"
  },
  {
   value: "Windham (USWMJ)",
   label: "Windham (USWMJ)"
  },
  {
   value: "Windham Hill (USDHM)",
   label: "Windham Hill (USDHM)"
  },
  {
   value: "Windsor (USXWN)",
   label: "Windsor (USXWN)"
  },
  {
   value: "Windsor, Bertie (USINB)",
   label: "Windsor, Bertie (USINB)"
  },
  {
   value: "Winfall (USIAU)",
   label: "Winfall (USIAU)"
  },
  {
   value: "Winfield (USINF)",
   label: "Winfield (USINF)"
  },
  {
   value: "Winfield (USNFV)",
   label: "Winfield (USNFV)"
  },
  {
   value: "Winfield (USWFV)",
   label: "Winfield (USWFV)"
  },
  {
   value: "Winfield (USWXF)",
   label: "Winfield (USWXF)"
  },
  {
   value: "Wingate (USWGX)",
   label: "Wingate (USWGX)"
  },
  {
   value: "Wingate (USXWG)",
   label: "Wingate (USXWG)"
  },
  {
   value: "Wingdale (USIGP)",
   label: "Wingdale (USIGP)"
  },
  {
   value: "Winn (USWQM)",
   label: "Winn (USWQM)"
  },
  {
   value: "Winnebago (USWNN)",
   label: "Winnebago (USWNN)"
  },
  {
   value: "Winnebago, Faribault (USWGB)",
   label: "Winnebago, Faribault (USWGB)"
  },
  {
   value: "Winneconne (USYEC)",
   label: "Winneconne (USYEC)"
  },
  {
   value: "Winner (USXWZ)",
   label: "Winner (USXWZ)"
  },
  {
   value: "Winnetka (USZTK)",
   label: "Winnetka (USZTK)"
  },
  {
   value: "Winnfield (USWFN)",
   label: "Winnfield (USWFN)"
  },
  {
   value: "Winnie (USWXE)",
   label: "Winnie (USWXE)"
  },
  {
   value: "Winnsboro (USWJJ)",
   label: "Winnsboro (USWJJ)"
  },
  {
   value: "Winona (USWN7)",
   label: "Winona (USWN7)"
  },
  {
   value: "Winooski (USWNK)",
   label: "Winooski (USWNK)"
  },
  {
   value: "Winslow (USINW)",
   label: "Winslow (USINW)"
  },
  {
   value: "Winston (USVSN)",
   label: "Winston (USVSN)"
  },
  {
   value: "Winston (USWQT)",
   label: "Winston (USWQT)"
  },
  {
   value: "Winston (USWXT)",
   label: "Winston (USWXT)"
  },
  {
   value: "Winter Harbor (USWH5)",
   label: "Winter Harbor (USWH5)"
  },
  {
   value: "Winter Springs (USZIW)",
   label: "Winter Springs (USZIW)"
  },
  {
   value: "Winterhaven (USTVA)",
   label: "Winterhaven (USTVA)"
  },
  {
   value: "Winters (USIES)",
   label: "Winters (USIES)"
  },
  {
   value: "Winterset (USWNT)",
   label: "Winterset (USWNT)"
  },
  {
   value: "Wintersville (USWQZ)",
   label: "Wintersville (USWQZ)"
  },
  {
   value: "Winterthur (USWRP)",
   label: "Winterthur (USWRP)"
  },
  {
   value: "Winterville (USTRW)",
   label: "Winterville (USTRW)"
  },
  {
   value: "Winterville (USWNL)",
   label: "Winterville (USWNL)"
  },
  {
   value: "Winthrop (USIHP)",
   label: "Winthrop (USIHP)"
  },
  {
   value: "Winthrop (USIRP)",
   label: "Winthrop (USIRP)"
  },
  {
   value: "Winthrop (USYWT)",
   label: "Winthrop (USYWT)"
  },
  {
   value: "Winton (USTWQ)",
   label: "Winton (USTWQ)"
  },
  {
   value: "Wirtz (USVWW)",
   label: "Wirtz (USVWW)"
  },
  {
   value: "Wisconsin Dells (USWNF)",
   label: "Wisconsin Dells (USWNF)"
  },
  {
   value: "Wister (USJTR)",
   label: "Wister (USJTR)"
  },
  {
   value: "Wittenberg (USWB2)",
   label: "Wittenberg (USWB2)"
  },
  {
   value: "Wolcott (USOJO)",
   label: "Wolcott (USOJO)"
  },
  {
   value: "Wolcott (USOOT)",
   label: "Wolcott (USOOT)"
  },
  {
   value: "Wolcott (USXWO)",
   label: "Wolcott (USXWO)"
  },
  {
   value: "Wolcottville (USTIE)",
   label: "Wolcottville (USTIE)"
  },
  {
   value: "Wolf Creek (USWZB)",
   label: "Wolf Creek (USWZB)"
  },
  {
   value: "Wolf Lake (USWL8)",
   label: "Wolf Lake (USWL8)"
  },
  {
   value: "Wolfeboro (USWFB)",
   label: "Wolfeboro (USWFB)"
  },
  {
   value: "Wolfforth (USWOF)",
   label: "Wolfforth (USWOF)"
  },
  {
   value: "Wonewoc (USWOG)",
   label: "Wonewoc (USWOG)"
  },
  {
   value: "Wood River (USWR7)",
   label: "Wood River (USWR7)"
  },
  {
   value: "Wood River Junction (USWJU)",
   label: "Wood River Junction (USWJU)"
  },
  {
   value: "Woodbine (USOOD)",
   label: "Woodbine (USOOD)"
  },
  {
   value: "Woodbourne (USWB6)",
   label: "Woodbourne (USWB6)"
  },
  {
   value: "Woodbridge (USWOB)",
   label: "Woodbridge (USWOB)"
  },
  {
   value: "Woodburn (USTVN)",
   label: "Woodburn (USTVN)"
  },
  {
   value: "Woodbury (USQDB)",
   label: "Woodbury (USQDB)"
  },
  {
   value: "Woodbury (USZYB)",
   label: "Woodbury (USZYB)"
  },
  {
   value: "Woodbury, Nassau (USWDU)",
   label: "Woodbury, Nassau (USWDU)"
  },
  {
   value: "Woodfin (USUO4)",
   label: "Woodfin (USUO4)"
  },
  {
   value: "Woodford (USWFC)",
   label: "Woodford (USWFC)"
  },
  {
   value: "Woodford (USWJD)",
   label: "Woodford (USWJD)"
  },
  {
   value: "Woodhaven (USDHV)",
   label: "Woodhaven (USDHV)"
  },
  {
   value: "Woodhaven (USVHW)",
   label: "Woodhaven (USVHW)"
  },
  {
   value: "Woodhull (USODU)",
   label: "Woodhull (USODU)"
  },
  {
   value: "Woodland (USZND)",
   label: "Woodland (USZND)"
  },
  {
   value: "Woodland Park (USOPR)",
   label: "Woodland Park (USOPR)"
  },
  {
   value: "Woodruff (USW2R)",
   label: "Woodruff (USW2R)"
  },
  {
   value: "Woodruff (USWOU)",
   label: "Woodruff (USWOU)"
  },
  {
   value: "Woods Cross (USDSS)",
   label: "Woods Cross (USDSS)"
  },
  {
   value: "Woodsboro (USDBK)",
   label: "Woodsboro (USDBK)"
  },
  {
   value: "Woodsboro (USQWQ)",
   label: "Woodsboro (USQWQ)"
  },
  {
   value: "Woodside (USWD5)",
   label: "Woodside (USWD5)"
  },
  {
   value: "Woodside (USWDZ)",
   label: "Woodside (USWDZ)"
  },
  {
   value: "Woodson Terrace\/St Louis (USVTR)",
   label: "Woodson Terrace\/St Louis (USVTR)"
  },
  {
   value: "Woodstock (USWD6)",
   label: "Woodstock (USWD6)"
  },
  {
   value: "Woodstock (USWOK)",
   label: "Woodstock (USWOK)"
  },
  {
   value: "Woodstock (USWQK)",
   label: "Woodstock (USWQK)"
  },
  {
   value: "Woodstown (USWDO)",
   label: "Woodstown (USWDO)"
  },
  {
   value: "Woodsville (USWOV)",
   label: "Woodsville (USWOV)"
  },
  {
   value: "Woodville (USWJV)",
   label: "Woodville (USWJV)"
  },
  {
   value: "Woodward (USUWW)",
   label: "Woodward (USUWW)"
  },
  {
   value: "Woodway (USDWY)",
   label: "Woodway (USDWY)"
  },
  {
   value: "Woolrich (USYWR)",
   label: "Woolrich (USYWR)"
  },
  {
   value: "Woonsocket (USOSK)",
   label: "Woonsocket (USOSK)"
  },
  {
   value: "Woorburn (USOEF)",
   label: "Woorburn (USOEF)"
  },
  {
   value: "Worcester (USWOC)",
   label: "Worcester (USWOC)"
  },
  {
   value: "Worden (USWI2)",
   label: "Worden (USWI2)"
  },
  {
   value: "Worth (USWRH)",
   label: "Worth (USWRH)"
  },
  {
   value: "Worthington (USVWH)",
   label: "Worthington (USVWH)"
  },
  {
   value: "Worthington (USZWG)",
   label: "Worthington (USZWG)"
  },
  {
   value: "Worthington Center (USOHT)",
   label: "Worthington Center (USOHT)"
  },
  {
   value: "Worton (USWO8)",
   label: "Worton (USWO8)"
  },
  {
   value: "Wray (USWRJ)",
   label: "Wray (USWRJ)"
  },
  {
   value: "Wren (USWN2)",
   label: "Wren (USWN2)"
  },
  {
   value: "Wright (USIGF)",
   label: "Wright (USIGF)"
  },
  {
   value: "Wright (USWGJ)",
   label: "Wright (USWGJ)"
  },
  {
   value: "Wrightstown (USWXS)",
   label: "Wrightstown (USWXS)"
  },
  {
   value: "Wrightsville (USWVF)",
   label: "Wrightsville (USWVF)"
  },
  {
   value: "Wrightsville Beach (USWGC)",
   label: "Wrightsville Beach (USWGC)"
  },
  {
   value: "Wurtland (USWUR)",
   label: "Wurtland (USWUR)"
  },
  {
   value: "Wyandanch (USXWY)",
   label: "Wyandanch (USXWY)"
  },
  {
   value: "Wyanet (USYAE)",
   label: "Wyanet (USYAE)"
  },
  {
   value: "Wyatt (USXYT)",
   label: "Wyatt (USXYT)"
  },
  {
   value: "Wyckoff (USZWK)",
   label: "Wyckoff (USZWK)"
  },
  {
   value: "Wynnewood (USQWW)",
   label: "Wynnewood (USQWW)"
  },
  {
   value: "Wyoming (USYMG)",
   label: "Wyoming (USYMG)"
  },
  {
   value: "Wyoming (USYOM)",
   label: "Wyoming (USYOM)"
  },
  {
   value: "Yale (USIYA)",
   label: "Yale (USIYA)"
  },
  {
   value: "Yale (USYAL)",
   label: "Yale (USYAL)"
  },
  {
   value: "Yalesville (USYVE)",
   label: "Yalesville (USYVE)"
  },
  {
   value: "Yanceyville (USYCY)",
   label: "Yanceyville (USYCY)"
  },
  {
   value: "Yantic (USYNI)",
   label: "Yantic (USYNI)"
  },
  {
   value: "Yardley (USYAP)",
   label: "Yardley (USYAP)"
  },
  {
   value: "Yarmouth (USYOH)",
   label: "Yarmouth (USYOH)"
  },
  {
   value: "Yarmouth Pt (USYMP)",
   label: "Yarmouth Pt (USYMP)"
  },
  {
   value: "Yatesboro (USYAT)",
   label: "Yatesboro (USYAT)"
  },
  {
   value: "Yazoo City (USYAZ)",
   label: "Yazoo City (USYAZ)"
  },
  {
   value: "Yelm (USYYE)",
   label: "Yelm (USYYE)"
  },
  {
   value: "Yemassee (USYMA)",
   label: "Yemassee (USYMA)"
  },
  {
   value: "Yoakum (USYOA)",
   label: "Yoakum (USYOA)"
  },
  {
   value: "Yoder (USYDR)",
   label: "Yoder (USYDR)"
  },
  {
   value: "Yoe (USYEO)",
   label: "Yoe (USYEO)"
  },
  {
   value: "Yoke Bay (USYOK)",
   label: "Yoke Bay (USYOK)"
  },
  {
   value: "Yolo (USYOO)",
   label: "Yolo (USYOO)"
  },
  {
   value: "York Beach (USYKB)",
   label: "York Beach (USYKB)"
  },
  {
   value: "York Harbor (USZYH)",
   label: "York Harbor (USZYH)"
  },
  {
   value: "York Haven (USYRH)",
   label: "York Haven (USYRH)"
  },
  {
   value: "York Springs (USYS8)",
   label: "York Springs (USYS8)"
  },
  {
   value: "Yorktown (USYKT)",
   label: "Yorktown (USYKT)"
  },
  {
   value: "Yorkville (USZJU)",
   label: "Yorkville (USZJU)"
  },
  {
   value: "Young America (USYAC)",
   label: "Young America (USYAC)"
  },
  {
   value: "Youngstown (USYNG)",
   label: "Youngstown (USYNG)"
  },
  {
   value: "Youngstown (USYTW)",
   label: "Youngstown (USYTW)"
  },
  {
   value: "Youngstown (USYUT)",
   label: "Youngstown (USYUT)"
  },
  {
   value: "Youngsville (USYVL)",
   label: "Youngsville (USYVL)"
  },
  {
   value: "Yucca (USYCC)",
   label: "Yucca (USYCC)"
  },
  {
   value: "Yucca Valley (USYAV)",
   label: "Yucca Valley (USYAV)"
  },
  {
   value: "Yukon (USYKO)",
   label: "Yukon (USYKO)"
  },
  {
   value: "Yuma (USUM2)",
   label: "Yuma (USUM2)"
  },
  {
   value: "Yutan (USNYN)",
   label: "Yutan (USNYN)"
  },
  {
   value: "Zapata (USZTA)",
   label: "Zapata (USZTA)"
  },
  {
   value: "Zearing (USZEA)",
   label: "Zearing (USZEA)"
  },
  {
   value: "Zeeland (USZLA)",
   label: "Zeeland (USZLA)"
  },
  {
   value: "Zenda (USZDA)",
   label: "Zenda (USZDA)"
  },
  {
   value: "Zephyrhills (USZPH)",
   label: "Zephyrhills (USZPH)"
  },
  {
   value: "Zionsville (USZZL)",
   label: "Zionsville (USZZL)"
  },
  {
   value: "Zolfo Springs (USZPS)",
   label: "Zolfo Springs (USZPS)"
  },
  {
   value: "Zumbrota (USZUM)",
   label: "Zumbrota (USZUM)"
  },
  {
   value: "Zwolle (USZWL)",
   label: "Zwolle (USZWL)"
  },
  {
   value: ".URUGUAY (UY)",
   label: ".URUGUAY (UY)"
  },
  {
   value: "Poblado Rincón de la Bolsa (UYPRB)",
   label: "Poblado Rincón de la Bolsa (UYPRB)"
  },
  {
   value: ".UZBEKISTAN (UZ)",
   label: ".UZBEKISTAN (UZ)"
  },
  {
   value: "Akaltyn (UZAKT)",
   label: "Akaltyn (UZAKT)"
  },
  {
   value: "Andizhan (UZAZN)",
   label: "Andizhan (UZAZN)"
  },
  {
   value: "Chukur-Say (UZCHU)",
   label: "Chukur-Say (UZCHU)"
  },
  {
   value: "Guliston (UZGST)",
   label: "Guliston (UZGST)"
  },
  {
   value: "Jizzakh (UZJIZ)",
   label: "Jizzakh (UZJIZ)"
  },
  {
   value: "Karakalpakiya (UZKPA)",
   label: "Karakalpakiya (UZKPA)"
  },
  {
   value: "Karaulbazar (UZKBZ)",
   label: "Karaulbazar (UZKBZ)"
  },
  {
   value: "Karshi (UZKSQ)",
   label: "Karshi (UZKSQ)"
  },
  {
   value: "Khamza (UZKHM)",
   label: "Khamza (UZKHM)"
  },
  {
   value: "Khanabad (UZKKH)",
   label: "Khanabad (UZKKH)"
  },
  {
   value: "Kokand (UZKOK)",
   label: "Kokand (UZKOK)"
  },
  {
   value: "Marghilon (UZMGN)",
   label: "Marghilon (UZMGN)"
  },
  {
   value: "Namangan (UZNMA)",
   label: "Namangan (UZNMA)"
  },
  {
   value: "Nawoiy (UZNWY)",
   label: "Nawoiy (UZNWY)"
  },
  {
   value: "Nukus (UZNCU)",
   label: "Nukus (UZNCU)"
  },
  {
   value: "Oharangon (UZAGN)",
   label: "Oharangon (UZAGN)"
  },
  {
   value: "Qarshi (UZQAR)",
   label: "Qarshi (UZQAR)"
  },
  {
   value: "Sary-Assiya (UZSYA)",
   label: "Sary-Assiya (UZSYA)"
  },
  {
   value: "Shurkhasan (UZSHU)",
   label: "Shurkhasan (UZSHU)"
  },
  {
   value: "Termez (UZTER)",
   label: "Termez (UZTER)"
  },
  {
   value: "Ulugbek (UZULU)",
   label: "Ulugbek (UZULU)"
  },
  {
   value: "Zarafshon (UZZAR)",
   label: "Zarafshon (UZZAR)"
  },
  {
   value: ".HOLY SEE (VATICAN CITY STATE) (VA)",
   label: ".HOLY SEE (VATICAN CITY STATE) (VA)"
  },
  {
   value: ".SAINT VINCENT AND THE GRENADINES (VC)",
   label: ".SAINT VINCENT AND THE GRENADINES (VC)"
  },
  {
   value: "Camden Park (VCCRP)",
   label: "Camden Park (VCCRP)"
  },
  {
   value: "Canouan I. (VCCAN)",
   label: "Canouan I. (VCCAN)"
  },
  {
   value: "Georgetown (VCGRG)",
   label: "Georgetown (VCGRG)"
  },
  {
   value: "Palm I. (VCPLI)",
   label: "Palm I. (VCPLI)"
  },
  {
   value: ".VENEZUELA (VE)",
   label: ".VENEZUELA (VE)"
  },
  {
   value: "Aragua de Barcelona (VEAGU)",
   label: "Aragua de Barcelona (VEAGU)"
  },
  {
   value: "Boca Grande (VEBOC)",
   label: "Boca Grande (VEBOC)"
  },
  {
   value: "Calabozo (VECLZ)",
   label: "Calabozo (VECLZ)"
  },
  {
   value: "Carora (VEVCR)",
   label: "Carora (VEVCR)"
  },
  {
   value: "Casigua (VECUV)",
   label: "Casigua (VECUV)"
  },
  {
   value: "Cristobal (VECRI)",
   label: "Cristobal (VECRI)"
  },
  {
   value: "El Dorado (VEEOR)",
   label: "El Dorado (VEEOR)"
  },
  {
   value: "El Jose (VEELJ)",
   label: "El Jose (VEELJ)"
  },
  {
   value: "El Tigre (VEELX)",
   label: "El Tigre (VEELX)"
  },
  {
   value: "El Vigia (VEVIG)",
   label: "El Vigia (VEVIG)"
  },
  {
   value: "Elorza (VEEOZ)",
   label: "Elorza (VEEOZ)"
  },
  {
   value: "Fila de Mariches (VEFDM)",
   label: "Fila de Mariches (VEFDM)"
  },
  {
   value: "Guacara (VEGCR)",
   label: "Guacara (VEGCR)"
  },
  {
   value: "Guaraguao (VEGGU)",
   label: "Guaraguao (VEGGU)"
  },
  {
   value: "Guaranao (VEGUA)",
   label: "Guaranao (VEGUA)"
  },
  {
   value: "Guarenas (VENAS)",
   label: "Guarenas (VENAS)"
  },
  {
   value: "Guasdualito (VEGDO)",
   label: "Guasdualito (VEGDO)"
  },
  {
   value: "Guatire (VEGTM)",
   label: "Guatire (VEGTM)"
  },
  {
   value: "Icabarú (VEICA)",
   label: "Icabarú (VEICA)"
  },
  {
   value: "Isla de Margarita (VEIDM)",
   label: "Isla de Margarita (VEIDM)"
  },
  {
   value: "Jose Terminal (VEJOT)",
   label: "Jose Terminal (VEJOT)"
  },
  {
   value: "Kamarata (VEKTV)",
   label: "Kamarata (VEKTV)"
  },
  {
   value: "Kanavayén (VEKAV)",
   label: "Kanavayén (VEKAV)"
  },
  {
   value: "La Rinconada (VERIN)",
   label: "La Rinconada (VERIN)"
  },
  {
   value: "Las Morochas (VELMA)",
   label: "Las Morochas (VELMA)"
  },
  {
   value: "Las Tejerias (VELTE)",
   label: "Las Tejerias (VELTE)"
  },
  {
   value: "Los Naranjeros (VELNA)",
   label: "Los Naranjeros (VELNA)"
  },
  {
   value: "Los Pijiguaos (VELPJ)",
   label: "Los Pijiguaos (VELPJ)"
  },
  {
   value: "Los Roques (VELRV)",
   label: "Los Roques (VELRV)"
  },
  {
   value: "Los Teques (VELTQ)",
   label: "Los Teques (VELTQ)"
  },
  {
   value: "Maracay (VEMYC)",
   label: "Maracay (VEMYC)"
  },
  {
   value: "Palmarito (VEPTM)",
   label: "Palmarito (VEPTM)"
  },
  {
   value: "Paracotos (VEPCT)",
   label: "Paracotos (VEPCT)"
  },
  {
   value: "Parai-tepuí (VEPPH)",
   label: "Parai-tepuí (VEPPH)"
  },
  {
   value: "Pedernales (VEPDZ)",
   label: "Pedernales (VEPDZ)"
  },
  {
   value: "Puerto Carenero (VEPCO)",
   label: "Puerto Carenero (VEPCO)"
  },
  {
   value: "Punta de Piedras (VEPPS)",
   label: "Punta de Piedras (VEPPS)"
  },
  {
   value: "San Antonio de Los Altos (VEANT)",
   label: "San Antonio de Los Altos (VEANT)"
  },
  {
   value: "San Antonio del Táchira (VESAT)",
   label: "San Antonio del Táchira (VESAT)"
  },
  {
   value: "San Cristobal (VESCI)",
   label: "San Cristobal (VESCI)"
  },
  {
   value: "San Joaquín (VESJQ)",
   label: "San Joaquín (VESJQ)"
  },
  {
   value: "San Juan de los Morros (VESJM)",
   label: "San Juan de los Morros (VESJM)"
  },
  {
   value: "San Salvador de Paul Apt (VESVV)",
   label: "San Salvador de Paul Apt (VESVV)"
  },
  {
   value: "Santa Barbara (VESBB)",
   label: "Santa Barbara (VESBB)"
  },
  {
   value: "Santa Elena (VESNV)",
   label: "Santa Elena (VESNV)"
  },
  {
   value: "Tucupita (VETUV)",
   label: "Tucupita (VETUV)"
  },
  {
   value: "Tumeremo (VETMO)",
   label: "Tumeremo (VETMO)"
  },
  {
   value: "Ureña (VEYUR)",
   label: "Ureña (VEYUR)"
  },
  {
   value: "Uriman (VEURM)",
   label: "Uriman (VEURM)"
  },
  {
   value: "Valencia (VEVLN)",
   label: "Valencia (VEVLN)"
  },
  {
   value: "Valle De Pascua (VEVDP)",
   label: "Valle De Pascua (VEVDP)"
  },
  {
   value: "Wonken (VEWOK)",
   label: "Wonken (VEWOK)"
  },
  {
   value: ".VIRGIN ISLANDS, BRITISH (VG)",
   label: ".VIRGIN ISLANDS, BRITISH (VG)"
  },
  {
   value: "Anegada (VGNGD)",
   label: "Anegada (VGNGD)"
  },
  {
   value: "Jost Van Dyke (VGJVD)",
   label: "Jost Van Dyke (VGJVD)"
  },
  {
   value: "N. Sound\/Virgin Gorda (VGNSX)",
   label: "N. Sound\/Virgin Gorda (VGNSX)"
  },
  {
   value: "Norman I. (VGNIS)",
   label: "Norman I. (VGNIS)"
  },
  {
   value: "Sopers Hole (VGSHO)",
   label: "Sopers Hole (VGSHO)"
  },
  {
   value: ".VIRGIN ISLANDS, U.S. (VI)",
   label: ".VIRGIN ISLANDS, U.S. (VI)"
  },
  {
   value: "Anguilla (VIAGL)",
   label: "Anguilla (VIAGL)"
  },
  {
   value: "Enighed Pond (VIENP)",
   label: "Enighed Pond (VIENP)"
  },
  {
   value: "Port Alucroix (VIPAX)",
   label: "Port Alucroix (VIPAX)"
  },
  {
   value: ".VIET NAM (VN)",
   label: ".VIET NAM (VN)"
  },
  {
   value: "An Giang (VNAGG)",
   label: "An Giang (VNAGG)"
  },
  {
   value: "B12 Oil Terminal (VNO12)",
   label: "B12 Oil Terminal (VNO12)"
  },
  {
   value: "Bac Giang (VNBGG)",
   label: "Bac Giang (VNBGG)"
  },
  {
   value: "Bac Lieu (VNBLU)",
   label: "Bac Lieu (VNBLU)"
  },
  {
   value: "Bac Ninh (VNBNH)",
   label: "Bac Ninh (VNBNH)"
  },
  {
   value: "Bach Ho (VNBHO)",
   label: "Bach Ho (VNBHO)"
  },
  {
   value: "Banmethuot (VNBMV)",
   label: "Banmethuot (VNBMV)"
  },
  {
   value: "Bao Loc (VNBAO)",
   label: "Bao Loc (VNBAO)"
  },
  {
   value: "Ben Dam Con Dao Terminals (VNBCD)",
   label: "Ben Dam Con Dao Terminals (VNBCD)"
  },
  {
   value: "Bèn Nghè (VNBNE)",
   label: "Bèn Nghè (VNBNE)"
  },
  {
   value: "Bèn Nghè (VNBNG)",
   label: "Bèn Nghè (VNBNG)"
  },
  {
   value: "Biên Hòa (VNBHA)",
   label: "Biên Hòa (VNBHA)"
  },
  {
   value: "Binh Dinh (VNBDH)",
   label: "Binh Dinh (VNBDH)"
  },
  {
   value: "Binh Duong (VNBDU)",
   label: "Binh Duong (VNBDU)"
  },
  {
   value: "Binh Duong Terminal (VNBDG)",
   label: "Binh Duong Terminal (VNBDG)"
  },
  {
   value: "Bình Hòa (VNBIH)",
   label: "Bình Hòa (VNBIH)"
  },
  {
   value: "Binh Thuan (VNBTN)",
   label: "Binh Thuan (VNBTN)"
  },
  {
   value: "Bông Sen (VNBSE)",
   label: "Bông Sen (VNBSE)"
  },
  {
   value: "Ca Mau (VNCAH)",
   label: "Ca Mau (VNCAH)"
  },
  {
   value: "Cai Cui Pt (VNCCU)",
   label: "Cai Cui Pt (VNCCU)"
  },
  {
   value: "Cai Lan (VNCLN)",
   label: "Cai Lan (VNCLN)"
  },
  {
   value: "Cam Lâm (VNBAN)",
   label: "Cam Lâm (VNBAN)"
  },
  {
   value: "Cao Bang (VNCBG)",
   label: "Cao Bang (VNCBG)"
  },
  {
   value: "Cape St Jacques (VNCSJ)",
   label: "Cape St Jacques (VNCSJ)"
  },
  {
   value: "Cát Lái (VNCLI)",
   label: "Cát Lái (VNCLI)"
  },
  {
   value: "Cat Lai Oil Pt (VNOCL)",
   label: "Cat Lai Oil Pt (VNOCL)"
  },
  {
   value: "Chan May Pt (VNCMY)",
   label: "Chan May Pt (VNCMY)"
  },
  {
   value: "Chua Ve Terminal (VNCVE)",
   label: "Chua Ve Terminal (VNCVE)"
  },
  {
   value: "Cua Cam Terminal (VNCCA)",
   label: "Cua Cam Terminal (VNCCA)"
  },
  {
   value: "Cua Viet Port (VNCUV)",
   label: "Cua Viet Port (VNCUV)"
  },
  {
   value: "Culao (VNCLO)",
   label: "Culao (VNCLO)"
  },
  {
   value: "Dalat (VNDLI)",
   label: "Dalat (VNDLI)"
  },
  {
   value: "Dam Mon (VNDMO)",
   label: "Dam Mon (VNDMO)"
  },
  {
   value: "Dinh Vu Terminal (VNDVU)",
   label: "Dinh Vu Terminal (VNDVU)"
  },
  {
   value: "Doan Xa Terminal (VNDXA)",
   label: "Doan Xa Terminal (VNDXA)"
  },
  {
   value: "Dong Nai (VNDNA)",
   label: "Dong Nai (VNDNA)"
  },
  {
   value: "Dong Thap (VNDTH)",
   label: "Dong Thap (VNDTH)"
  },
  {
   value: "Dung Quat (VNDQT)",
   label: "Dung Quat (VNDQT)"
  },
  {
   value: "Gia Lai (VNGLI)",
   label: "Gia Lai (VNGLI)"
  },
  {
   value: "Gia Lam (VNGIL)",
   label: "Gia Lam (VNGIL)"
  },
  {
   value: "Go Dau A Terminal (VNGDA)",
   label: "Go Dau A Terminal (VNGDA)"
  },
  {
   value: "Go Dau B Terminal (VNGDB)",
   label: "Go Dau B Terminal (VNGDB)"
  },
  {
   value: "Ha Long (VNHLG)",
   label: "Ha Long (VNHLG)"
  },
  {
   value: "Ha Tay (VNHTY)",
   label: "Ha Tay (VNHTY)"
  },
  {
   value: "Hai Duong (VNHDG)",
   label: "Hai Duong (VNHDG)"
  },
  {
   value: "Hai Son (VNHSN)",
   label: "Hai Son (VNHSN)"
  },
  {
   value: "Hau Giang (VNHGG)",
   label: "Hau Giang (VNHGG)"
  },
  {
   value: "Ho Chi Minh, VICT (VNVIC)",
   label: "Ho Chi Minh, VICT (VNVIC)"
  },
  {
   value: "Hung Yen (VNHYN)",
   label: "Hung Yen (VNHYN)"
  },
  {
   value: "Khanh Hoa (VNKHA)",
   label: "Khanh Hoa (VNKHA)"
  },
  {
   value: "Khánh Hôi (VNKHI)",
   label: "Khánh Hôi (VNKHI)"
  },
  {
   value: "Kon Tum (VNKON)",
   label: "Kon Tum (VNKON)"
  },
  {
   value: "Ky Ha Quang Nam Terminal (VNKYQ)",
   label: "Ky Ha Quang Nam Terminal (VNKYQ)"
  },
  {
   value: "Ky Ha Terminal (VNKYH)",
   label: "Ky Ha Terminal (VNKYH)"
  },
  {
   value: "Lam Dong (VNLDG)",
   label: "Lam Dong (VNLDG)"
  },
  {
   value: "Long An-Ben Luc (VNLAN)",
   label: "Long An-Ben Luc (VNLAN)"
  },
  {
   value: "Long Binh Tan (VNLBT)",
   label: "Long Binh Tan (VNLBT)"
  },
  {
   value: "Long Xuyen (VNXLO)",
   label: "Long Xuyen (VNXLO)"
  },
  {
   value: "My Thoi (VNMTH)",
   label: "My Thoi (VNMTH)"
  },
  {
   value: "New Pt (VNNWP)",
   label: "New Pt (VNNWP)"
  },
  {
   value: "Nghe An (VNNAN)",
   label: "Nghe An (VNNAN)"
  },
  {
   value: "Nghi Son (VNNGH)",
   label: "Nghi Son (VNNGH)"
  },
  {
   value: "Nguyen Van Troi Port (VNNVT)",
   label: "Nguyen Van Troi Port (VNNVT)"
  },
  {
   value: "Nha Be Oil Pt (VNONB)",
   label: "Nha Be Oil Pt (VNONB)"
  },
  {
   value: "Ninh Binh (VNNBH)",
   label: "Ninh Binh (VNNBH)"
  },
  {
   value: "Ninh Thuan (VNNTN)",
   label: "Ninh Thuan (VNNTN)"
  },
  {
   value: "Phu Quoc (VNPQC)",
   label: "Phu Quoc (VNPQC)"
  },
  {
   value: "Phu Yen (VNPYN)",
   label: "Phu Yen (VNPYN)"
  },
  {
   value: "Phu-bon (VNHBN)",
   label: "Phu-bon (VNHBN)"
  },
  {
   value: "Phuóc Long (VNPHG)",
   label: "Phuóc Long (VNPHG)"
  },
  {
   value: "Phuoc Long ICD (VNIPH)",
   label: "Phuoc Long ICD (VNIPH)"
  },
  {
   value: "Pleiku (VNPXU)",
   label: "Pleiku (VNPXU)"
  },
  {
   value: "Po Hang (VNPNG)",
   label: "Po Hang (VNPNG)"
  },
  {
   value: "Pt Ba Ngoi (VNBNO)",
   label: "Pt Ba Ngoi (VNBNO)"
  },
  {
   value: "Quanduc (VNHHO)",
   label: "Quanduc (VNHHO)"
  },
  {
   value: "Quäng Bình (VNQBH)",
   label: "Quäng Bình (VNQBH)"
  },
  {
   value: "Quang Nam (VNQNM)",
   label: "Quang Nam (VNQNM)"
  },
  {
   value: "Quang Ninh (VNQNH)",
   label: "Quang Ninh (VNQNH)"
  },
  {
   value: "Quê Duong (VNQUG)",
   label: "Quê Duong (VNQUG)"
  },
  {
   value: "Rach Gia (VNVKG)",
   label: "Rach Gia (VNVKG)"
  },
  {
   value: "Rang Dong (VNRDG)",
   label: "Rang Dong (VNRDG)"
  },
  {
   value: "Rao Qua (VNRQU)",
   label: "Rao Qua (VNRQU)"
  },
  {
   value: "Sa Déc (VNSAD)",
   label: "Sa Déc (VNSAD)"
  },
  {
   value: "Sai Gon Pt (VNCSG)",
   label: "Sai Gon Pt (VNCSG)"
  },
  {
   value: "Saigon Petro Oil Terminal (VNOSP)",
   label: "Saigon Petro Oil Terminal (VNOSP)"
  },
  {
   value: "Soc Trang (VNSOA)",
   label: "Soc Trang (VNSOA)"
  },
  {
   value: "Son La (VNSQH)",
   label: "Son La (VNSQH)"
  },
  {
   value: "Song Than Icd (VNSTC)",
   label: "Song Than Icd (VNSTC)"
  },
  {
   value: "Su Tu Den (VNSTD)",
   label: "Su Tu Den (VNSTD)"
  },
  {
   value: "Tamky (VNTMK)",
   label: "Tamky (VNTMK)"
  },
  {
   value: "Tan Cang (VNTCG)",
   label: "Tan Cang (VNTCG)"
  },
  {
   value: "Tan Cang Cai Mep Terminal (VNTCT)",
   label: "Tan Cang Cai Mep Terminal (VNTCT)"
  },
  {
   value: "Tan Cang Long Binh Icd (VNILB)",
   label: "Tan Cang Long Binh Icd (VNILB)"
  },
  {
   value: "Tan Canh (VNTCN)",
   label: "Tan Canh (VNTCN)"
  },
  {
   value: "Tan Son Nhat Apt (VNTSN)",
   label: "Tan Son Nhat Apt (VNTSN)"
  },
  {
   value: "Tân Thuan Dông (VNTTD)",
   label: "Tân Thuan Dông (VNTTD)"
  },
  {
   value: "Tanamexco Icd (VNTAM)",
   label: "Tanamexco Icd (VNTAM)"
  },
  {
   value: "Tay Ninh (VNTNT)",
   label: "Tay Ninh (VNTNT)"
  },
  {
   value: "Thai Binh (VNTBH)",
   label: "Thai Binh (VNTBH)"
  },
  {
   value: "Thai Hoa (VNTHA)",
   label: "Thai Hoa (VNTHA)"
  },
  {
   value: "Thái Nguyên (VNTNG)",
   label: "Thái Nguyên (VNTNG)"
  },
  {
   value: "Thi Nai Pt (VNTNA)",
   label: "Thi Nai Pt (VNTNA)"
  },
  {
   value: "Thu Dau Mot (VNTHD)",
   label: "Thu Dau Mot (VNTHD)"
  },
  {
   value: "Thu Dúc\/ICG Transimex (VNITX)",
   label: "Thu Dúc\/ICG Transimex (VNITX)"
  },
  {
   value: "Thuan An (VNTHU)",
   label: "Thuan An (VNTHU)"
  },
  {
   value: "Tien Giang (VNTGG)",
   label: "Tien Giang (VNTGG)"
  },
  {
   value: "Tien Sa Terminal (VNDTS)",
   label: "Tien Sa Terminal (VNDTS)"
  },
  {
   value: "Tong Cang (VNTNC)",
   label: "Tong Cang (VNTNC)"
  },
  {
   value: "Tra Vinh (VNTVH)",
   label: "Tra Vinh (VNTVH)"
  },
  {
   value: "Transvina Terminal (VNTVN)",
   label: "Transvina Terminal (VNTVN)"
  },
  {
   value: "Tuyen Quang (VNTQG)",
   label: "Tuyen Quang (VNTQG)"
  },
  {
   value: "Van Phong (VNVPH)",
   label: "Van Phong (VNVPH)"
  },
  {
   value: "Vinashin Shipyard (VNVSS)",
   label: "Vinashin Shipyard (VNVSS)"
  },
  {
   value: "Vinh Long (VNVLG)",
   label: "Vinh Long (VNVLG)"
  },
  {
   value: "Vinh Phuc (VNVPC)",
   label: "Vinh Phuc (VNVPC)"
  },
  {
   value: "Vinh Yen (VNVYN)",
   label: "Vinh Yen (VNVYN)"
  },
  {
   value: ".VANUATU (VU)",
   label: ".VANUATU (VU)"
  },
  {
   value: "Aniwa (VUAWD)",
   label: "Aniwa (VUAWD)"
  },
  {
   value: "Big Bay (VUGBA)",
   label: "Big Bay (VUGBA)"
  },
  {
   value: "Craig Cove (VUCCV)",
   label: "Craig Cove (VUCCV)"
  },
  {
   value: "Émae (VUEAE)",
   label: "Émae (VUEAE)"
  },
  {
   value: "Épi (VUEPI)",
   label: "Épi (VUEPI)"
  },
  {
   value: "Futuna Island (VUFTA)",
   label: "Futuna Island (VUFTA)"
  },
  {
   value: "Gaua (VUZGU)",
   label: "Gaua (VUZGU)"
  },
  {
   value: "Maéwo (VUMWF)",
   label: "Maéwo (VUMWF)"
  },
  {
   value: "Mota Lava (VUMTV)",
   label: "Mota Lava (VUMTV)"
  },
  {
   value: "Olpoi (VUOLJ)",
   label: "Olpoi (VUOLJ)"
  },
  {
   value: "Paama (VUPBJ)",
   label: "Paama (VUPBJ)"
  },
  {
   value: "Quine Hill (VUUIQ)",
   label: "Quine Hill (VUUIQ)"
  },
  {
   value: "Redcliffe (VURCL)",
   label: "Redcliffe (VURCL)"
  },
  {
   value: "Sara (VUSSR)",
   label: "Sara (VUSSR)"
  },
  {
   value: "South West Bay (VUSWJ)",
   label: "South West Bay (VUSWJ)"
  },
  {
   value: "Torres (VUTOH)",
   label: "Torres (VUTOH)"
  },
  {
   value: "Ulei (VUULB)",
   label: "Ulei (VUULB)"
  },
  {
   value: ".WALLIS AND FUTUNA (WF)",
   label: ".WALLIS AND FUTUNA (WF)"
  },
  {
   value: "Sigavé (WFSIG)",
   label: "Sigavé (WFSIG)"
  },
  {
   value: "Wallis Island Apt (WFWLS)",
   label: "Wallis Island Apt (WFWLS)"
  },
  {
   value: ".SAMOA (WS)",
   label: ".SAMOA (WS)"
  },
  {
   value: "Lalomalava (WSLAV)",
   label: "Lalomalava (WSLAV)"
  },
  {
   value: "Maota Savaii Is (WSMXS)",
   label: "Maota Savaii Is (WSMXS)"
  },
  {
   value: ".INSTALLATIONS IN INTERNATIONAL WATERS (XZ)",
   label: ".INSTALLATIONS IN INTERNATIONAL WATERS (XZ)"
  },
  {
   value: "Aasgard (XZAAD)",
   label: "Aasgard (XZAAD)"
  },
  {
   value: "Al Shaheen terminal (XZSHA)",
   label: "Al Shaheen terminal (XZSHA)"
  },
  {
   value: "Alve (XZALV)",
   label: "Alve (XZALV)"
  },
  {
   value: "Anoa Natuna (XZANU)",
   label: "Anoa Natuna (XZANU)"
  },
  {
   value: "Ardjuna (XZANT)",
   label: "Ardjuna (XZANT)"
  },
  {
   value: "Brage (XZBRA)",
   label: "Brage (XZBRA)"
  },
  {
   value: "Buffalo Venture (XZBUV)",
   label: "Buffalo Venture (XZBUV)"
  },
  {
   value: "Camar Marine Terminal (XZCMT)",
   label: "Camar Marine Terminal (XZCMT)"
  },
  {
   value: "Dai Hung (STS Load) (XZDHS)",
   label: "Dai Hung (STS Load) (XZDHS)"
  },
  {
   value: "Dai Hung (Tandem Load) (XZDHT)",
   label: "Dai Hung (Tandem Load) (XZDHT)"
  },
  {
   value: "De Ruiter (XZDRT)",
   label: "De Ruiter (XZDRT)"
  },
  {
   value: "Draugen (XZDRA)",
   label: "Draugen (XZDRA)"
  },
  {
   value: "Dulang Marine Terminal (XZDTL)",
   label: "Dulang Marine Terminal (XZDTL)"
  },
  {
   value: "Fram (XZFRM)",
   label: "Fram (XZFRM)"
  },
  {
   value: "Gjoa (XZGJO)",
   label: "Gjoa (XZGJO)"
  },
  {
   value: "Grane (XZGRA)",
   label: "Grane (XZGRA)"
  },
  {
   value: "Heidrun (XZHEI)",
   label: "Heidrun (XZHEI)"
  },
  {
   value: "Huldra (XZHUL)",
   label: "Huldra (XZHUL)"
  },
  {
   value: "Kakap Marine Terminal (XZKMT)",
   label: "Kakap Marine Terminal (XZKMT)"
  },
  {
   value: "Kristin (XZKRI)",
   label: "Kristin (XZKRI)"
  },
  {
   value: "Kvitebjorn (XZKBJ)",
   label: "Kvitebjorn (XZKBJ)"
  },
  {
   value: "Laminaria Terminal (XZLAM)",
   label: "Laminaria Terminal (XZLAM)"
  },
  {
   value: "Legendre Terminal (XZLGT)",
   label: "Legendre Terminal (XZLGT)"
  },
  {
   value: "Mikkel (XZMKL)",
   label: "Mikkel (XZMKL)"
  },
  {
   value: "Morvin (XZMVI)",
   label: "Morvin (XZMVI)"
  },
  {
   value: "Njord (XZNJO)",
   label: "Njord (XZNJO)"
  },
  {
   value: "Norne (XZNNE)",
   label: "Norne (XZNNE)"
  },
  {
   value: "Northern Endevour (XZNTE)",
   label: "Northern Endevour (XZNTE)"
  },
  {
   value: "Sibuko Bay (XZSBY)",
   label: "Sibuko Bay (XZSBY)"
  },
  {
   value: "Snohvit (XZSHV)",
   label: "Snohvit (XZSHV)"
  },
  {
   value: "Stage Platform (XZSTP)",
   label: "Stage Platform (XZSTP)"
  },
  {
   value: "Suursaq (XZSUU)",
   label: "Suursaq (XZSUU)"
  },
  {
   value: "Sygna (XZSYG)",
   label: "Sygna (XZSYG)"
  },
  {
   value: "Tandjung Gerem (XZTGR)",
   label: "Tandjung Gerem (XZTGR)"
  },
  {
   value: "Tune (XZTUN)",
   label: "Tune (XZTUN)"
  },
  {
   value: "Tyrihans (XZTHA)",
   label: "Tyrihans (XZTHA)"
  },
  {
   value: "Urd (XZURD)",
   label: "Urd (XZURD)"
  },
  {
   value: "Veslefrikk (XZVFK)",
   label: "Veslefrikk (XZVFK)"
  },
  {
   value: "Vigdis (XZVGD)",
   label: "Vigdis (XZVGD)"
  },
  {
   value: "Vilje (XZVIL)",
   label: "Vilje (XZVIL)"
  },
  {
   value: "Visund (XZVSU)",
   label: "Visund (XZVSU)"
  },
  {
   value: "Volve (XZVOV)",
   label: "Volve (XZVOV)"
  },
  {
   value: "Widuri Marine Terminal (XZWRT)",
   label: "Widuri Marine Terminal (XZWRT)"
  },
  {
   value: "Yetagun Field (XZYET)",
   label: "Yetagun Field (XZYET)"
  },
  {
   value: "Yttergryta (XZYGT)",
   label: "Yttergryta (XZYGT)"
  },
  {
   value: ".YEMEN (YE)",
   label: ".YEMEN (YE)"
  },
  {
   value: "Al Ghaydah (YEAAY)",
   label: "Al Ghaydah (YEAAY)"
  },
  {
   value: "Al Mukalla (YEZAM)",
   label: "Al Mukalla (YEZAM)"
  },
  {
   value: "Albuq (YEBUK)",
   label: "Albuq (YEBUK)"
  },
  {
   value: "Aljouf (YEAJO)",
   label: "Aljouf (YEAJO)"
  },
  {
   value: "Ataq (YEAXK)",
   label: "Ataq (YEAXK)"
  },
  {
   value: "Balhaf (YEBLH)",
   label: "Balhaf (YEBLH)"
  },
  {
   value: "Beidah (YEBYD)",
   label: "Beidah (YEBYD)"
  },
  {
   value: "Dathina (YEDAH)",
   label: "Dathina (YEDAH)"
  },
  {
   value: "Dhala (YEDHL)",
   label: "Dhala (YEDHL)"
  },
  {
   value: "Dhamar (YEDMR)",
   label: "Dhamar (YEDMR)"
  },
  {
   value: "Little Aden (YELAD)",
   label: "Little Aden (YELAD)"
  },
  {
   value: "Lodar (YELDR)",
   label: "Lodar (YELDR)"
  },
  {
   value: "Mukeiras (YEUKR)",
   label: "Mukeiras (YEUKR)"
  },
  {
   value: "Raudha (YERXA)",
   label: "Raudha (YERXA)"
  },
  {
   value: "Wadi Ain (YEWDA)",
   label: "Wadi Ain (YEWDA)"
  },
  {
   value: ".MAYOTTE (YT)",
   label: ".MAYOTTE (YT)"
  },
  {
   value: "Bandelé (YTBAN)",
   label: "Bandelé (YTBAN)"
  },
  {
   value: "Longoni (YTLON)",
   label: "Longoni (YTLON)"
  },
  {
   value: "Sada (YTSAD)",
   label: "Sada (YTSAD)"
  },
  {
   value: ".SOUTH AFRICA (ZA)",
   label: ".SOUTH AFRICA (ZA)"
  },
  {
   value: "Adelaide (ZAZAB)",
   label: "Adelaide (ZAZAB)"
  },
  {
   value: "Aggeneys (ZAAGZ)",
   label: "Aggeneys (ZAAGZ)"
  },
  {
   value: "Alberton (ZAABT)",
   label: "Alberton (ZAABT)"
  },
  {
   value: "Alexandria (ZAZBW)",
   label: "Alexandria (ZAZBW)"
  },
  {
   value: "Alldays (ZAADY)",
   label: "Alldays (ZAADY)"
  },
  {
   value: "Alrode (ZAALR)",
   label: "Alrode (ZAALR)"
  },
  {
   value: "Amalgam (ZAZFP)",
   label: "Amalgam (ZAZFP)"
  },
  {
   value: "Amalinda (ZAZAD)",
   label: "Amalinda (ZAZAD)"
  },
  {
   value: "Amanzimtoti (ZAAMZ)",
   label: "Amanzimtoti (ZAAMZ)"
  },
  {
   value: "Amsterdam (ZAZAE)",
   label: "Amsterdam (ZAZAE)"
  },
  {
   value: "Arcadia (ZATHR)",
   label: "Arcadia (ZATHR)"
  },
  {
   value: "Ashton (ZAZAF)",
   label: "Ashton (ZAZAF)"
  },
  {
   value: "Atlantis (ZAATL)",
   label: "Atlantis (ZAATL)"
  },
  {
   value: "Babelegi (ZAHBL)",
   label: "Babelegi (ZAHBL)"
  },
  {
   value: "Bapsfontein (ZAZAN)",
   label: "Bapsfontein (ZAZAN)"
  },
  {
   value: "Barrydale (ZABAR)",
   label: "Barrydale (ZABAR)"
  },
  {
   value: "Bayhead (ZABHD)",
   label: "Bayhead (ZABHD)"
  },
  {
   value: "Baynesfield (ZABNF)",
   label: "Baynesfield (ZABNF)"
  },
  {
   value: "Beacon Bay (ZAZAG)",
   label: "Beacon Bay (ZAZAG)"
  },
  {
   value: "Beaufort West (ZABEW)",
   label: "Beaufort West (ZABEW)"
  },
  {
   value: "Bedfordview (ZABFV)",
   label: "Bedfordview (ZABFV)"
  },
  {
   value: "Belfast (ZAZCD)",
   label: "Belfast (ZAZCD)"
  },
  {
   value: "Bellville (ZABEL)",
   label: "Bellville (ZABEL)"
  },
  {
   value: "Ben Schoeman Dock (ZAZAQ)",
   label: "Ben Schoeman Dock (ZAZAQ)"
  },
  {
   value: "Benoni (ZABNI)",
   label: "Benoni (ZABNI)"
  },
  {
   value: "Benrose (ZAZFO)",
   label: "Benrose (ZAZFO)"
  },
  {
   value: "Berea (ZAZFQ)",
   label: "Berea (ZAZFQ)"
  },
  {
   value: "Berlin (ZABRL)",
   label: "Berlin (ZABRL)"
  },
  {
   value: "Bethlehem (ZABTH)",
   label: "Bethlehem (ZABTH)"
  },
  {
   value: "Bisho (ZABIY)",
   label: "Bisho (ZABIY)"
  },
  {
   value: "Blackheath (ZAZAK)",
   label: "Blackheath (ZAZAK)"
  },
  {
   value: "Bloemfontein Industria (ZAZAL)",
   label: "Bloemfontein Industria (ZAZAL)"
  },
  {
   value: "Bloubergstrand (ZAZAI)",
   label: "Bloubergstrand (ZAZAI)"
  },
  {
   value: "Boksburg (ZABOK)",
   label: "Boksburg (ZABOK)"
  },
  {
   value: "Bonaero Park (ZAZAM)",
   label: "Bonaero Park (ZAZAM)"
  },
  {
   value: "Bothasig (ZAZAR)",
   label: "Bothasig (ZAZAR)"
  },
  {
   value: "Bothaville (ZABTV)",
   label: "Bothaville (ZABTV)"
  },
  {
   value: "BotrivIer (ZABOT)",
   label: "BotrivIer (ZABOT)"
  },
  {
   value: "Botswana (ZABWA)",
   label: "Botswana (ZABWA)"
  },
  {
   value: "Braamfontein (ZAZAO)",
   label: "Braamfontein (ZAZAO)"
  },
  {
   value: "Brackenfell (ZAZAJ)",
   label: "Brackenfell (ZAZAJ)"
  },
  {
   value: "Bramley View (ZAZFR)",
   label: "Bramley View (ZAZFR)"
  },
  {
   value: "Bredasdorp (ZAZCS)",
   label: "Bredasdorp (ZAZCS)"
  },
  {
   value: "Briardene (ZAZAH)",
   label: "Briardene (ZAZAH)"
  },
  {
   value: "Brits (ZABRT)",
   label: "Brits (ZABRT)"
  },
  {
   value: "Brummeria (ZAZFT)",
   label: "Brummeria (ZAZFT)"
  },
  {
   value: "Bryanston (ZABSN)",
   label: "Bryanston (ZABSN)"
  },
  {
   value: "Butterworth (ZAUTE)",
   label: "Butterworth (ZAUTE)"
  },
  {
   value: "Cambridge (ZAZAU)",
   label: "Cambridge (ZAZAU)"
  },
  {
   value: "Camperdown (ZACMN)",
   label: "Camperdown (ZACMN)"
  },
  {
   value: "Canelands (ZAZAS)",
   label: "Canelands (ZAZAS)"
  },
  {
   value: "Capital Park (ZAZAT)",
   label: "Capital Park (ZAZAT)"
  },
  {
   value: "Cato Ridge (ZACAT)",
   label: "Cato Ridge (ZACAT)"
  },
  {
   value: "Centurion (ZAZAY)",
   label: "Centurion (ZAZAY)"
  },
  {
   value: "Ceres (ZACRS)",
   label: "Ceres (ZACRS)"
  },
  {
   value: "Chamdor (ZAZFS)",
   label: "Chamdor (ZAZFS)"
  },
  {
   value: "Chiselhurst (ZAZAV)",
   label: "Chiselhurst (ZAZAV)"
  },
  {
   value: "Chloorkop (ZACHP)",
   label: "Chloorkop (ZACHP)"
  },
  {
   value: "Citrusdal (ZACIT)",
   label: "Citrusdal (ZACIT)"
  },
  {
   value: "City Centre (ZACTT)",
   label: "City Centre (ZACTT)"
  },
  {
   value: "City Centre (ZAZFU)",
   label: "City Centre (ZAZFU)"
  },
  {
   value: "Clairwood (ZAZBD)",
   label: "Clairwood (ZAZBD)"
  },
  {
   value: "Clanwilliam (ZAZCT)",
   label: "Clanwilliam (ZAZCT)"
  },
  {
   value: "Claremont (ZAZAX)",
   label: "Claremont (ZAZAX)"
  },
  {
   value: "Coega (ZAZBA)",
   label: "Coega (ZAZBA)"
  },
  {
   value: "Colleen Glen (ZAZFV)",
   label: "Colleen Glen (ZAZFV)"
  },
  {
   value: "Collondale (ZAZFX)",
   label: "Collondale (ZAZFX)"
  },
  {
   value: "Congella (ZACGN)",
   label: "Congella (ZACGN)"
  },
  {
   value: "Constantia (ZAZBC)",
   label: "Constantia (ZAZBC)"
  },
  {
   value: "Cradock (ZACDO)",
   label: "Cradock (ZACDO)"
  },
  {
   value: "Craighall (ZAZBB)",
   label: "Craighall (ZAZBB)"
  },
  {
   value: "Crown Mines (ZAZAW)",
   label: "Crown Mines (ZAZAW)"
  },
  {
   value: "Culemborg (ZAZFW)",
   label: "Culemborg (ZAZFW)"
  },
  {
   value: "Cullinan (ZACNA)",
   label: "Cullinan (ZACNA)"
  },
  {
   value: "Dainfern (ZAZGE)",
   label: "Dainfern (ZAZGE)"
  },
  {
   value: "Dalton (ZADON)",
   label: "Dalton (ZADON)"
  },
  {
   value: "Dan Pienaar (ZAZBG)",
   label: "Dan Pienaar (ZAZBG)"
  },
  {
   value: "Dawn (ZAZBI)",
   label: "Dawn (ZAZBI)"
  },
  {
   value: "Delmas (ZADLM)",
   label: "Delmas (ZADLM)"
  },
  {
   value: "Denver (ZAZBE)",
   label: "Denver (ZAZBE)"
  },
  {
   value: "Dieprivier (ZAZBH)",
   label: "Dieprivier (ZAZBH)"
  },
  {
   value: "Dimbaza (ZADIU)",
   label: "Dimbaza (ZADIU)"
  },
  {
   value: "Doornfontein (ZAZBF)",
   label: "Doornfontein (ZAZBF)"
  },
  {
   value: "Dukuduk (ZADUK)",
   label: "Dukuduk (ZADUK)"
  },
  {
   value: "Duncanville\/Vereeniging (ZADCV)",
   label: "Duncanville\/Vereeniging (ZADCV)"
  },
  {
   value: "Dunnottar (ZADNN)",
   label: "Dunnottar (ZADNN)"
  },
  {
   value: "Dunswart\/Boksburg (ZADUN)",
   label: "Dunswart\/Boksburg (ZADUN)"
  },
  {
   value: "Durbanville (ZADVI)",
   label: "Durbanville (ZADVI)"
  },
  {
   value: "East End (ZAZBK)",
   label: "East End (ZAZBK)"
  },
  {
   value: "Edenvale (ZAEDE)",
   label: "Edenvale (ZAEDE)"
  },
  {
   value: "Eikenhof (ZAZBL)",
   label: "Eikenhof (ZAZBL)"
  },
  {
   value: "Ekandustria (ZAZBJ)",
   label: "Ekandustria (ZAZBJ)"
  },
  {
   value: "Elgin (ZAELG)",
   label: "Elgin (ZAELG)"
  },
  {
   value: "Ellisras (ZAELL)",
   label: "Ellisras (ZAELL)"
  },
  {
   value: "Elsiesriver (ZAZBM)",
   label: "Elsiesriver (ZAZBM)"
  },
  {
   value: "Empangeni (ZAEMG)",
   label: "Empangeni (ZAEMG)"
  },
  {
   value: "Epping (ZAEPP)",
   label: "Epping (ZAEPP)"
  },
  {
   value: "Ermelo (ZAERM)",
   label: "Ermelo (ZAERM)"
  },
  {
   value: "Estcourt (ZAEST)",
   label: "Estcourt (ZAEST)"
  },
  {
   value: "Felixton (ZAZBR)",
   label: "Felixton (ZAZBR)"
  },
  {
   value: "Firgrove (ZAZBN)",
   label: "Firgrove (ZAZBN)"
  },
  {
   value: "Fish Hoek (ZAFHK)",
   label: "Fish Hoek (ZAFHK)"
  },
  {
   value: "Florida (ZAZBP)",
   label: "Florida (ZAZBP)"
  },
  {
   value: "Fort Beaufort (ZAFBE)",
   label: "Fort Beaufort (ZAFBE)"
  },
  {
   value: "Fort Jackson (ZAZBO)",
   label: "Fort Jackson (ZAZBO)"
  },
  {
   value: "Four Ways (ZAZBQ)",
   label: "Four Ways (ZAZBQ)"
  },
  {
   value: "Franschoek (ZAZCI)",
   label: "Franschoek (ZAZCI)"
  },
  {
   value: "Gans Bay (ZAGNB)",
   label: "Gans Bay (ZAGNB)"
  },
  {
   value: "Garankuwa (ZAZBS)",
   label: "Garankuwa (ZAZBS)"
  },
  {
   value: "Gately (ZAGTY)",
   label: "Gately (ZAGTY)"
  },
  {
   value: "Gauteng (ZAGAU)",
   label: "Gauteng (ZAGAU)"
  },
  {
   value: "Giyani (ZAGIY)",
   label: "Giyani (ZAGIY)"
  },
  {
   value: "Glenashley (ZAGAY)",
   label: "Glenashley (ZAGAY)"
  },
  {
   value: "Golela (ZAGLE)",
   label: "Golela (ZAGLE)"
  },
  {
   value: "Goodwood (ZAZBU)",
   label: "Goodwood (ZAZBU)"
  },
  {
   value: "Gouda (ZAZCJ)",
   label: "Gouda (ZAZCJ)"
  },
  {
   value: "Graaff Reinet (ZAZCB)",
   label: "Graaff Reinet (ZAZCB)"
  },
  {
   value: "Graafwater (ZAGRW)",
   label: "Graafwater (ZAGRW)"
  },
  {
   value: "Grabouw (ZAGRB)",
   label: "Grabouw (ZAGRB)"
  },
  {
   value: "Grahamstown (ZAGRH)",
   label: "Grahamstown (ZAGRH)"
  },
  {
   value: "Greytown (ZAGRY)",
   label: "Greytown (ZAGRY)"
  },
  {
   value: "Groblersdal (ZAZBT)",
   label: "Groblersdal (ZAZBT)"
  },
  {
   value: "Groenbult (ZAGBU)",
   label: "Groenbult (ZAGBU)"
  },
  {
   value: "Halfway House (ZAHAL)",
   label: "Halfway House (ZAHAL)"
  },
  {
   value: "Hamilton (ZAHAM)",
   label: "Hamilton (ZAHAM)"
  },
  {
   value: "Hammanskraal (ZAHSL)",
   label: "Hammanskraal (ZAHSL)"
  },
  {
   value: "Hammarsdale (ZAHMM)",
   label: "Hammarsdale (ZAHMM)"
  },
  {
   value: "Harrismith (ZAHRS)",
   label: "Harrismith (ZAHRS)"
  },
  {
   value: "Hartebeespoort (ZAHAR)",
   label: "Hartebeespoort (ZAHAR)"
  },
  {
   value: "Hartswater (ZAZCH)",
   label: "Hartswater (ZAZCH)"
  },
  {
   value: "Hazyview (ZAHZV)",
   label: "Hazyview (ZAHZV)"
  },
  {
   value: "Hennopspark (ZAHNP)",
   label: "Hennopspark (ZAHNP)"
  },
  {
   value: "Heriotdale\/Johannesburg (ZAHDL)",
   label: "Heriotdale\/Johannesburg (ZAHDL)"
  },
  {
   value: "Hermanstad (ZAZGF)",
   label: "Hermanstad (ZAZGF)"
  },
  {
   value: "Hermanus (ZAHMS)",
   label: "Hermanus (ZAHMS)"
  },
  {
   value: "Hex River (ZAZCR)",
   label: "Hex River (ZAZCR)"
  },
  {
   value: "Hillcrest (ZAHIL)",
   label: "Hillcrest (ZAHIL)"
  },
  {
   value: "Hluhluwe (ZAHLW)",
   label: "Hluhluwe (ZAHLW)"
  },
  {
   value: "Hoedspruit (ZAHDS)",
   label: "Hoedspruit (ZAHDS)"
  },
  {
   value: "Honeydew (ZAHDW)",
   label: "Honeydew (ZAHDW)"
  },
  {
   value: "Hout Bay (ZAZCF)",
   label: "Hout Bay (ZAZCF)"
  },
  {
   value: "Howick (ZAHOW)",
   label: "Howick (ZAHOW)"
  },
  {
   value: "Huguenot (ZAHGT)",
   label: "Huguenot (ZAHGT)"
  },
  {
   value: "Humansdorp (ZAZCG)",
   label: "Humansdorp (ZAZCG)"
  },
  {
   value: "Hyde Park (ZAHYD)",
   label: "Hyde Park (ZAHYD)"
  },
  {
   value: "Illovo (ZAILV)",
   label: "Illovo (ZAILV)"
  },
  {
   value: "Inyati (ZAINY)",
   label: "Inyati (ZAINY)"
  },
  {
   value: "Irene (ZAZCN)",
   label: "Irene (ZAZCN)"
  },
  {
   value: "Isando (ZAISD)",
   label: "Isando (ZAISD)"
  },
  {
   value: "Isipingo (ZAZCM)",
   label: "Isipingo (ZAZCM)"
  },
  {
   value: "Isipingo Beach (ZAISP)",
   label: "Isipingo Beach (ZAISP)"
  },
  {
   value: "Isithebe (ZAISB)",
   label: "Isithebe (ZAISB)"
  },
  {
   value: "Island View (ZAIVI)",
   label: "Island View (ZAIVI)"
  },
  {
   value: "Izmit (ZARSS)",
   label: "Izmit (ZARSS)"
  },
  {
   value: "Jacobs (ZAZCP)",
   label: "Jacobs (ZAZCP)"
  },
  {
   value: "Jansenville (ZAJSV)",
   label: "Jansenville (ZAJSV)"
  },
  {
   value: "Jeffreys Bay (ZAJEF)",
   label: "Jeffreys Bay (ZAJEF)"
  },
  {
   value: "Jeppestown (ZAZFY)",
   label: "Jeppestown (ZAZFY)"
  },
  {
   value: "Jet Park (ZAJTP)",
   label: "Jet Park (ZAJTP)"
  },
  {
   value: "Kaapmuiden (ZAKPM)",
   label: "Kaapmuiden (ZAKPM)"
  },
  {
   value: "Kaserne (ZAZCY)",
   label: "Kaserne (ZAZCY)"
  },
  {
   value: "Kathu (ZAKTU)",
   label: "Kathu (ZAKTU)"
  },
  {
   value: "Kayalami (ZAZAA)",
   label: "Kayalami (ZAZAA)"
  },
  {
   value: "Kelvin (ZAKLV)",
   label: "Kelvin (ZAKLV)"
  },
  {
   value: "Kensington (ZAZCU)",
   label: "Kensington (ZAZCU)"
  },
  {
   value: "Kew (ZAKEW)",
   label: "Kew (ZAKEW)"
  },
  {
   value: "Khoka Moya (ZAKHO)",
   label: "Khoka Moya (ZAKHO)"
  },
  {
   value: "Kiepersol (ZAZCV)",
   label: "Kiepersol (ZAZCV)"
  },
  {
   value: "Killarney Gardens (ZAKIL)",
   label: "Killarney Gardens (ZAKIL)"
  },
  {
   value: "Kirkwood (ZAKIR)",
   label: "Kirkwood (ZAKIR)"
  },
  {
   value: "Klaserie (ZAKSR)",
   label: "Klaserie (ZAKSR)"
  },
  {
   value: "Klawer (ZAKLA)",
   label: "Klawer (ZAKLA)"
  },
  {
   value: "Klerksdorp (ZAKXE)",
   label: "Klerksdorp (ZAKXE)"
  },
  {
   value: "Knysna (ZAKNY)",
   label: "Knysna (ZAKNY)"
  },
  {
   value: "Koeberg (ZAKOB)",
   label: "Koeberg (ZAKOB)"
  },
  {
   value: "Komkans (ZAKKN)",
   label: "Komkans (ZAKKN)"
  },
  {
   value: "Kommertjie (ZAZCX)",
   label: "Kommertjie (ZAZCX)"
  },
  {
   value: "Kommetjie (ZAKOM)",
   label: "Kommetjie (ZAKOM)"
  },
  {
   value: "Kraaifontein (ZAZCW)",
   label: "Kraaifontein (ZAZCW)"
  },
  {
   value: "Kuils River (ZAKUI)",
   label: "Kuils River (ZAKUI)"
  },
  {
   value: "Kuruman (ZAKMH)",
   label: "Kuruman (ZAKMH)"
  },
  {
   value: "Kya Sands (ZAZKS)",
   label: "Kya Sands (ZAZKS)"
  },
  {
   value: "Kyalami (ZAKYA)",
   label: "Kyalami (ZAKYA)"
  },
  {
   value: "Laaiplek (ZAZDG)",
   label: "Laaiplek (ZAZDG)"
  },
  {
   value: "Ladysmith (ZALAY)",
   label: "Ladysmith (ZALAY)"
  },
  {
   value: "Langkloof (ZAKOO)",
   label: "Langkloof (ZAKOO)"
  },
  {
   value: "Langlaagte (ZAZDE)",
   label: "Langlaagte (ZAZDE)"
  },
  {
   value: "Lansdowne (ZALDE)",
   label: "Lansdowne (ZALDE)"
  },
  {
   value: "Lenasia (ZAZDF)",
   label: "Lenasia (ZAZDF)"
  },
  {
   value: "Letsitele (ZAZDH)",
   label: "Letsitele (ZAZDH)"
  },
  {
   value: "Lime Acres (ZALMR)",
   label: "Lime Acres (ZALMR)"
  },
  {
   value: "Londolozi (ZALDZ)",
   label: "Londolozi (ZALDZ)"
  },
  {
   value: "Longmeadow East (ZAZDA)",
   label: "Longmeadow East (ZAZDA)"
  },
  {
   value: "Louis Trichardt (ZALCD)",
   label: "Louis Trichardt (ZALCD)"
  },
  {
   value: "Louterwater (ZAZCA)",
   label: "Louterwater (ZAZCA)"
  },
  {
   value: "Lusikisiki (ZALUJ)",
   label: "Lusikisiki (ZALUJ)"
  },
  {
   value: "Lyndhurst (ZAZDI)",
   label: "Lyndhurst (ZAZDI)"
  },
  {
   value: "Lynnwood (ZAZDJ)",
   label: "Lynnwood (ZAZDJ)"
  },
  {
   value: "Lyttleton (ZAZDK)",
   label: "Lyttleton (ZAZDK)"
  },
  {
   value: "Magaliesburg (ZAMGL)",
   label: "Magaliesburg (ZAMGL)"
  },
  {
   value: "Maidstone (ZAMAS)",
   label: "Maidstone (ZAMAS)"
  },
  {
   value: "Maitland (ZAMLD)",
   label: "Maitland (ZAMLD)"
  },
  {
   value: "Mala Mala (ZAAAM)",
   label: "Mala Mala (ZAAAM)"
  },
  {
   value: "Malelane (ZALLE)",
   label: "Malelane (ZALLE)"
  },
  {
   value: "Malmesbury (ZAZCO)",
   label: "Malmesbury (ZAZCO)"
  },
  {
   value: "Malvern East (ZAZDO)",
   label: "Malvern East (ZAZDO)"
  },
  {
   value: "Mandileni (ZAMND)",
   label: "Mandileni (ZAMND)"
  },
  {
   value: "Maraisburg (ZAZDN)",
   label: "Maraisburg (ZAZDN)"
  },
  {
   value: "Marble Hall (ZAMAH)",
   label: "Marble Hall (ZAMAH)"
  },
  {
   value: "Marianhill (ZAMRH)",
   label: "Marianhill (ZAMRH)"
  },
  {
   value: "Marlboro (ZALBR)",
   label: "Marlboro (ZALBR)"
  },
  {
   value: "Matshewe (ZAMHW)",
   label: "Matshewe (ZAMHW)"
  },
  {
   value: "Maydon Whart (ZAMWT)",
   label: "Maydon Whart (ZAMWT)"
  },
  {
   value: "Meadowdale (ZAMDE)",
   label: "Meadowdale (ZAMDE)"
  },
  {
   value: "Menlo Park (ZAMPA)",
   label: "Menlo Park (ZAMPA)"
  },
  {
   value: "Merebank East (ZAZDL)",
   label: "Merebank East (ZAZDL)"
  },
  {
   value: "Meyerton (ZAMEY)",
   label: "Meyerton (ZAMEY)"
  },
  {
   value: "Middelburg (ZAMDB)",
   label: "Middelburg (ZAMDB)"
  },
  {
   value: "Midrand (ZAMRD)",
   label: "Midrand (ZAMRD)"
  },
  {
   value: "Milnerton (ZAZDQ)",
   label: "Milnerton (ZAZDQ)"
  },
  {
   value: "Mkambati (ZAMBM)",
   label: "Mkambati (ZAMBM)"
  },
  {
   value: "Mkuze (ZAMZQ)",
   label: "Mkuze (ZAMZQ)"
  },
  {
   value: "Mobeni (ZAMOB)",
   label: "Mobeni (ZAMOB)"
  },
  {
   value: "Modderfontein (ZAZDM)",
   label: "Modderfontein (ZAZDM)"
  },
  {
   value: "Montagu (ZAMON)",
   label: "Montagu (ZAMON)"
  },
  {
   value: "Montague Gardens (ZAZDP)",
   label: "Montague Gardens (ZAZDP)"
  },
  {
   value: "Motswari (ZAMWR)",
   label: "Motswari (ZAMWR)"
  },
  {
   value: "Mount Edgecombe (ZAEDG)",
   label: "Mount Edgecombe (ZAEDG)"
  },
  {
   value: "Muldersdrif (ZAMUL)",
   label: "Muldersdrif (ZAMUL)"
  },
  {
   value: "Mzamba(Wild Coast Sun) (ZAMZF)",
   label: "Mzamba(Wild Coast Sun) (ZAMZF)"
  },
  {
   value: "Naboomspruit (ZAZCC)",
   label: "Naboomspruit (ZAZCC)"
  },
  {
   value: "New Brighton West (ZAZAP)",
   label: "New Brighton West (ZAZAP)"
  },
  {
   value: "New Centre (ZAZGA)",
   label: "New Centre (ZAZGA)"
  },
  {
   value: "New Germany (ZANGG)",
   label: "New Germany (ZANGG)"
  },
  {
   value: "Newcastle (ZANCS)",
   label: "Newcastle (ZANCS)"
  },
  {
   value: "Newlands (ZAZDT)",
   label: "Newlands (ZAZDT)"
  },
  {
   value: "Newton Park (ZAZDU)",
   label: "Newton Park (ZAZDU)"
  },
  {
   value: "Ngala (ZANGL)",
   label: "Ngala (ZANGL)"
  },
  {
   value: "Nigel (ZAZDS)",
   label: "Nigel (ZAZDS)"
  },
  {
   value: "North End (ZAZDR)",
   label: "North End (ZAZDR)"
  },
  {
   value: "North Riding (ZAZDV)",
   label: "North Riding (ZAZDV)"
  },
  {
   value: "Northcliff (ZANCF)",
   label: "Northcliff (ZANCF)"
  },
  {
   value: "Nuffield Springs (ZANUF)",
   label: "Nuffield Springs (ZANUF)"
  },
  {
   value: "Nylstroom (ZANYL)",
   label: "Nylstroom (ZANYL)"
  },
  {
   value: "Observatory (ZAOBS)",
   label: "Observatory (ZAOBS)"
  },
  {
   value: "Olifantsfontein (ZAOLI)",
   label: "Olifantsfontein (ZAOLI)"
  },
  {
   value: "Ongelegen (ZAZDY)",
   label: "Ongelegen (ZAZDY)"
  },
  {
   value: "Op-die-Berg (ZAZDW)",
   label: "Op-die-Berg (ZAZDW)"
  },
  {
   value: "Ophirton (ZAZGB)",
   label: "Ophirton (ZAZGB)"
  },
  {
   value: "Orange Grove (ZAZEA)",
   label: "Orange Grove (ZAZEA)"
  },
  {
   value: "Oranjezicht (ZAZDX)",
   label: "Oranjezicht (ZAZDX)"
  },
  {
   value: "Orkney (ZAORK)",
   label: "Orkney (ZAORK)"
  },
  {
   value: "Ottery (ZAZED)",
   label: "Ottery (ZAZED)"
  },
  {
   value: "Paardeneiland (ZAPNL)",
   label: "Paardeneiland (ZAPNL)"
  },
  {
   value: "Paarl (ZAPAA)",
   label: "Paarl (ZAPAA)"
  },
  {
   value: "Paarl Wpk (ZAZGC)",
   label: "Paarl Wpk (ZAZGC)"
  },
  {
   value: "Parktown (ZAZEG)",
   label: "Parktown (ZAZEG)"
  },
  {
   value: "Parow (ZAPRW)",
   label: "Parow (ZAPRW)"
  },
  {
   value: "Parys (ZAZEE)",
   label: "Parys (ZAZEE)"
  },
  {
   value: "Patensie (ZAZBV)",
   label: "Patensie (ZAZBV)"
  },
  {
   value: "Paulshof (ZAPAU)",
   label: "Paulshof (ZAPAU)"
  },
  {
   value: "Pelindaba (ZAPLD)",
   label: "Pelindaba (ZAPLD)"
  },
  {
   value: "Pelindaba East (ZAPDE)",
   label: "Pelindaba East (ZAPDE)"
  },
  {
   value: "Perseverance (ZAZEF)",
   label: "Perseverance (ZAZEF)"
  },
  {
   value: "Phoenix (ZAPHX)",
   label: "Phoenix (ZAPHX)"
  },
  {
   value: "Phuthaditjhaba (ZAPHU)",
   label: "Phuthaditjhaba (ZAPHU)"
  },
  {
   value: "Piet Retief (ZAPRF)",
   label: "Piet Retief (ZAPRF)"
  },
  {
   value: "Piketberg (ZAPIK)",
   label: "Piketberg (ZAPIK)"
  },
  {
   value: "Point (ZAPIT)",
   label: "Point (ZAPIT)"
  },
  {
   value: "Pongola (ZAPON)",
   label: "Pongola (ZAPON)"
  },
  {
   value: "Port Alfred (ZAAFD)",
   label: "Port Alfred (ZAAFD)"
  },
  {
   value: "Port Edward (ZAPED)",
   label: "Port Edward (ZAPED)"
  },
  {
   value: "Porterville (ZAPOR)",
   label: "Porterville (ZAPOR)"
  },
  {
   value: "Potchefstroom (ZAZEH)",
   label: "Potchefstroom (ZAZEH)"
  },
  {
   value: "Potgietersrus (ZAZCE)",
   label: "Potgietersrus (ZAZCE)"
  },
  {
   value: "Prieska (ZAPRK)",
   label: "Prieska (ZAPRK)"
  },
  {
   value: "Primrose (ZAZEI)",
   label: "Primrose (ZAZEI)"
  },
  {
   value: "Pt Shepstone (ZAZCK)",
   label: "Pt Shepstone (ZAZCK)"
  },
  {
   value: "Queenstown (ZAUTW)",
   label: "Queenstown (ZAUTW)"
  },
  {
   value: "Randburg (ZARDB)",
   label: "Randburg (ZARDB)"
  },
  {
   value: "Randfontein (ZARFT)",
   label: "Randfontein (ZARFT)"
  },
  {
   value: "Randvaal (ZAZEJ)",
   label: "Randvaal (ZAZEJ)"
  },
  {
   value: "Red Hill (ZAZEK)",
   label: "Red Hill (ZAZEK)"
  },
  {
   value: "Reivilo (ZARVO)",
   label: "Reivilo (ZARVO)"
  },
  {
   value: "Retreat (ZARTT)",
   label: "Retreat (ZARTT)"
  },
  {
   value: "Retreat (ZAZEM)",
   label: "Retreat (ZAZEM)"
  },
  {
   value: "Rivonia (ZARVA)",
   label: "Rivonia (ZARVA)"
  },
  {
   value: "Robertsham (ZASHM)",
   label: "Robertsham (ZASHM)"
  },
  {
   value: "Robertson (ZAROD)",
   label: "Robertson (ZAROD)"
  },
  {
   value: "Roodekop (ZARDK)",
   label: "Roodekop (ZARDK)"
  },
  {
   value: "Roodepoort (ZARDP)",
   label: "Roodepoort (ZARDP)"
  },
  {
   value: "Rooihuiskraal (ZAZEL)",
   label: "Rooihuiskraal (ZAZEL)"
  },
  {
   value: "Rosettenville (ZAZEN)",
   label: "Rosettenville (ZAZEN)"
  },
  {
   value: "Rosherville (ZAZEO)",
   label: "Rosherville (ZAZEO)"
  },
  {
   value: "Rosslyn (ZAROS)",
   label: "Rosslyn (ZAROS)"
  },
  {
   value: "Rustenburg (ZARSB)",
   label: "Rustenburg (ZARSB)"
  },
  {
   value: "Rustenburg (ZARUS)",
   label: "Rustenburg (ZARUS)"
  },
  {
   value: "Sabi Sabi (ZAGSS)",
   label: "Sabi Sabi (ZAGSS)"
  },
  {
   value: "Salt River (ZAZEP)",
   label: "Salt River (ZAZEP)"
  },
  {
   value: "Sandton (ZASDT)",
   label: "Sandton (ZASDT)"
  },
  {
   value: "Saron (ZAZCQ)",
   label: "Saron (ZAZCQ)"
  },
  {
   value: "Sasolburg (ZASAS)",
   label: "Sasolburg (ZASAS)"
  },
  {
   value: "Saxonwold (ZAZGD)",
   label: "Saxonwold (ZAZGD)"
  },
  {
   value: "Scottburgh (ZASCT)",
   label: "Scottburgh (ZASCT)"
  },
  {
   value: "Sea Point (ZAZEW)",
   label: "Sea Point (ZAZEW)"
  },
  {
   value: "Selby (ZASEL)",
   label: "Selby (ZASEL)"
  },
  {
   value: "Shakaskraal (ZASHS)",
   label: "Shakaskraal (ZASHS)"
  },
  {
   value: "Shongweni (ZASHO)",
   label: "Shongweni (ZASHO)"
  },
  {
   value: "Sidwell (ZASID)",
   label: "Sidwell (ZASID)"
  },
  {
   value: "Silverton (ZASTN)",
   label: "Silverton (ZASTN)"
  },
  {
   value: "Simondium (ZAZES)",
   label: "Simondium (ZAZES)"
  },
  {
   value: "Somerset East (ZAZBX)",
   label: "Somerset East (ZAZBX)"
  },
  {
   value: "Somerset West (ZASOM)",
   label: "Somerset West (ZASOM)"
  },
  {
   value: "Soweto (ZAZEV)",
   label: "Soweto (ZAZEV)"
  },
  {
   value: "Springfield (ZAZEQ)",
   label: "Springfield (ZAZEQ)"
  },
  {
   value: "St Albans (ZAZAC)",
   label: "St Albans (ZAZAC)"
  },
  {
   value: "St Francis Bay (ZASFB)",
   label: "St Francis Bay (ZASFB)"
  },
  {
   value: "St Helena Bay (ZAZER)",
   label: "St Helena Bay (ZAZER)"
  },
  {
   value: "Standerton (ZASTC)",
   label: "Standerton (ZASTC)"
  },
  {
   value: "Stanger (ZASGR)",
   label: "Stanger (ZASGR)"
  },
  {
   value: "Stellenbosch (ZASTH)",
   label: "Stellenbosch (ZASTH)"
  },
  {
   value: "Stikland (ZAZET)",
   label: "Stikland (ZAZET)"
  },
  {
   value: "Stompneus (ZAZEX)",
   label: "Stompneus (ZAZEX)"
  },
  {
   value: "Strand (ZASTD)",
   label: "Strand (ZASTD)"
  },
  {
   value: "Struandale (ZASTR)",
   label: "Struandale (ZASTR)"
  },
  {
   value: "Stutterheim (ZASTU)",
   label: "Stutterheim (ZASTU)"
  },
  {
   value: "Summerstrand (ZAZEU)",
   label: "Summerstrand (ZAZEU)"
  },
  {
   value: "Sun City (ZANTY)",
   label: "Sun City (ZANTY)"
  },
  {
   value: "Sun Valley (ZASUN)",
   label: "Sun Valley (ZASUN)"
  },
  {
   value: "Suurbekom (ZAZEY)",
   label: "Suurbekom (ZAZEY)"
  },
  {
   value: "Tanda Tula (ZATDT)",
   label: "Tanda Tula (ZATDT)"
  },
  {
   value: "Tarlton (ZATLT)",
   label: "Tarlton (ZATLT)"
  },
  {
   value: "Thaba Nchu (ZATCU)",
   label: "Thaba Nchu (ZATCU)"
  },
  {
   value: "Thohoyandou (ZATHY)",
   label: "Thohoyandou (ZATHY)"
  },
  {
   value: "Tokai (ZAZFA)",
   label: "Tokai (ZAZFA)"
  },
  {
   value: "Tongaat (ZATNT)",
   label: "Tongaat (ZATNT)"
  },
  {
   value: "Tshipise (ZATSD)",
   label: "Tshipise (ZATSD)"
  },
  {
   value: "Tulbagh (ZATUL)",
   label: "Tulbagh (ZATUL)"
  },
  {
   value: "Tulisa Park (ZAZFB)",
   label: "Tulisa Park (ZAZFB)"
  },
  {
   value: "Turffontein (ZAZFC)",
   label: "Turffontein (ZAZFC)"
  },
  {
   value: "Ugie Ec (ZAZFD)",
   label: "Ugie Ec (ZAZFD)"
  },
  {
   value: "Ulundi (ZAULD)",
   label: "Ulundi (ZAULD)"
  },
  {
   value: "Ulusaba (ZAULX)",
   label: "Ulusaba (ZAULX)"
  },
  {
   value: "Umbilo (ZAZFE)",
   label: "Umbilo (ZAZFE)"
  },
  {
   value: "Umbogintwini (ZAUMB)",
   label: "Umbogintwini (ZAUMB)"
  },
  {
   value: "Umgeni Dam (ZAZFF)",
   label: "Umgeni Dam (ZAZFF)"
  },
  {
   value: "Umhlanga Rocks (ZAUMR)",
   label: "Umhlanga Rocks (ZAUMR)"
  },
  {
   value: "Umkomaas (ZAUMK)",
   label: "Umkomaas (ZAUMK)"
  },
  {
   value: "Umzinto (ZAUMZ)",
   label: "Umzinto (ZAUMZ)"
  },
  {
   value: "Vaal (ZAVAL)",
   label: "Vaal (ZAVAL)"
  },
  {
   value: "Vaalcon (ZAVAC)",
   label: "Vaalcon (ZAVAC)"
  },
  {
   value: "Vanderbijlpark (ZAVDP)",
   label: "Vanderbijlpark (ZAVDP)"
  },
  {
   value: "Vereeniging (ZAVGG)",
   label: "Vereeniging (ZAVGG)"
  },
  {
   value: "Vereeniging (ZAVRG)",
   label: "Vereeniging (ZAVRG)"
  },
  {
   value: "Verulam (ZAVEU)",
   label: "Verulam (ZAVEU)"
  },
  {
   value: "Viljoensdrif (ZAVXD)",
   label: "Viljoensdrif (ZAVXD)"
  },
  {
   value: "Villiersdorp (ZAZFH)",
   label: "Villiersdorp (ZAZFH)"
  },
  {
   value: "Vyeboom (ZAZFG)",
   label: "Vyeboom (ZAZFG)"
  },
  {
   value: "Wadeville (ZAWDV)",
   label: "Wadeville (ZAWDV)"
  },
  {
   value: "Walker Bay (ZAWKB)",
   label: "Walker Bay (ZAWKB)"
  },
  {
   value: "Waltloo (ZAZFK)",
   label: "Waltloo (ZAZFK)"
  },
  {
   value: "Wartburg (ZAZCL)",
   label: "Wartburg (ZAZCL)"
  },
  {
   value: "Waterfront (ZAWAT)",
   label: "Waterfront (ZAWAT)"
  },
  {
   value: "Waterkloof (ZAZFI)",
   label: "Waterkloof (ZAZFI)"
  },
  {
   value: "Waterkloof Ridge (ZAZFM)",
   label: "Waterkloof Ridge (ZAZFM)"
  },
  {
   value: "Wellington (ZAWLT)",
   label: "Wellington (ZAWLT)"
  },
  {
   value: "Weltevredenpark (ZAZFJ)",
   label: "Weltevredenpark (ZAZFJ)"
  },
  {
   value: "Westmead (ZAWMD)",
   label: "Westmead (ZAWMD)"
  },
  {
   value: "Westonaria (ZAZFN)",
   label: "Westonaria (ZAZFN)"
  },
  {
   value: "White River (ZAWHR)",
   label: "White River (ZAWHR)"
  },
  {
   value: "Winterton (ZAWTN)",
   label: "Winterton (ZAWTN)"
  },
  {
   value: "Witbank (ZAWIT)",
   label: "Witbank (ZAWIT)"
  },
  {
   value: "Witfield (ZAWFD)",
   label: "Witfield (ZAWFD)"
  },
  {
   value: "Woodbrook (ZAWBR)",
   label: "Woodbrook (ZAWBR)"
  },
  {
   value: "Woodmead (ZAZFL)",
   label: "Woodmead (ZAZFL)"
  },
  {
   value: "Woodstock (ZAWDS)",
   label: "Woodstock (ZAWDS)"
  },
  {
   value: "Worcester (ZAWOR)",
   label: "Worcester (ZAWOR)"
  },
  {
   value: "Wynberg (ZAWNB)",
   label: "Wynberg (ZAWNB)"
  },
  {
   value: "Wynberg (ZAWYN)",
   label: "Wynberg (ZAWYN)"
  },
  {
   value: "Yzerfontein (ZAYFT)",
   label: "Yzerfontein (ZAYFT)"
  },
  {
   value: "Zebediela (ZAZEB)",
   label: "Zebediela (ZAZEB)"
  },
  {
   value: ".ZAMBIA (ZM)",
   label: ".ZAMBIA (ZM)"
  },
  {
   value: "Bwana Mkubwa (ZMBMA)",
   label: "Bwana Mkubwa (ZMBMA)"
  },
  {
   value: "Chingola (ZMCGJ)",
   label: "Chingola (ZMCGJ)"
  },
  {
   value: "Chozi (ZMCHZ)",
   label: "Chozi (ZMCHZ)"
  },
  {
   value: "Kaoma (ZMKMZ)",
   label: "Kaoma (ZMKMZ)"
  },
  {
   value: "Kapiri Mposhi (ZMKAM)",
   label: "Kapiri Mposhi (ZMKAM)"
  },
  {
   value: "Kasompe (ZMZKP)",
   label: "Kasompe (ZMZKP)"
  },
  {
   value: "Lundazi (ZMLUZ)",
   label: "Lundazi (ZMLUZ)"
  },
  {
   value: "Mbala (ZMMMQ)",
   label: "Mbala (ZMMMQ)"
  },
  {
   value: "Monze (ZMMZE)",
   label: "Monze (ZMMZE)"
  },
  {
   value: "Mpika (ZMMPK)",
   label: "Mpika (ZMMPK)"
  },
  {
   value: "Mpulungu (ZMMPU)",
   label: "Mpulungu (ZMMPU)"
  },
  {
   value: "Mutasa (ZMMUT)",
   label: "Mutasa (ZMMUT)"
  },
  {
   value: "Sinda (ZMSIN)",
   label: "Sinda (ZMSIN)"
  },
  {
   value: "Tunduma (ZMTDM)",
   label: "Tunduma (ZMTDM)"
  },
  {
   value: ".ZIMBABWE (ZW)",
   label: ".ZIMBABWE (ZW)"
  },
  {
   value: "Beitbridge (ZWBBG)",
   label: "Beitbridge (ZWBBG)"
  },
  {
   value: "Bindura (ZWBIN)",
   label: "Bindura (ZWBIN)"
  },
  {
   value: "Bumi Hills (ZWBZH)",
   label: "Bumi Hills (ZWBZH)"
  },
  {
   value: "Chimanimani (ZWCIM)",
   label: "Chimanimani (ZWCIM)"
  },
  {
   value: "Chipinge (ZWCHJ)",
   label: "Chipinge (ZWCHJ)"
  },
  {
   value: "Chiredzi (ZWCHI)",
   label: "Chiredzi (ZWCHI)"
  },
  {
   value: "Gokwe (ZWGOK)",
   label: "Gokwe (ZWGOK)"
  },
  {
   value: "Headlands (ZWHDL)",
   label: "Headlands (ZWHDL)"
  },
  {
   value: "Hwange (ZWWKI)",
   label: "Hwange (ZWWKI)"
  },
  {
   value: "Hwange National Park (ZWHWN)",
   label: "Hwange National Park (ZWHWN)"
  },
  {
   value: "Kadoma (ZWKDM)",
   label: "Kadoma (ZWKDM)"
  },
  {
   value: "Mahenye (ZWMJW)",
   label: "Mahenye (ZWMJW)"
  },
  {
   value: "Marondera (ZWMAD)",
   label: "Marondera (ZWMAD)"
  },
  {
   value: "Masvingo (ZWMVZ)",
   label: "Masvingo (ZWMVZ)"
  },
  {
   value: "Mutoko (ZWMUT)",
   label: "Mutoko (ZWMUT)"
  },
  {
   value: "Southerton (ZWSTH)",
   label: "Southerton (ZWSTH)"
  },
  {
   value: "Thompson Junction (ZWTHJ)",
   label: "Thompson Junction (ZWTHJ)"
  },
  {
   value: ".FRENCH SOUTHERN Territories (TF)",
   label: ".FRENCH SOUTHERN Territories (TF)"
  },
  {
   value: "Port-aux-Français (TFPFR)",
   label: "Port-aux-Français (TFPFR)"
  },
  {
   value: "Villers-le-Lac (FRRLA)",
   label: "Villers-le-Lac (FRRLA)"
  },
  {
   value: "Villers-le-Rond (FRIRO)",
   label: "Villers-le-Rond (FRIRO)"
  },
  {
   value: "Villers-le-Sec (FRVAI)",
   label: "Villers-le-Sec (FRVAI)"
  },
  {
   value: "Villers-le-Sec (FRVHS)",
   label: "Villers-le-Sec (FRVHS)"
  },
  {
   value: "Villers-le-Sec (FRVMA)",
   label: "Villers-le-Sec (FRVMA)"
  },
  {
   value: "Villers-le-Sec (FRVME)",
   label: "Villers-le-Sec (FRVME)"
  },
  {
   value: "Villers-les-Nancy (FRZJS)",
   label: "Villers-les-Nancy (FRZJS)"
  },
  {
   value: "Villers-lès-Nancy (FRINN)",
   label: "Villers-lès-Nancy (FRINN)"
  },
  {
   value: "Villers-les-Pots (FRVPO)",
   label: "Villers-les-Pots (FRVPO)"
  },
  {
   value: "Villers-Saint-Paul (FRVSP)",
   label: "Villers-Saint-Paul (FRVSP)"
  },
  {
   value: "Villers-sur-Mer (FRVMR)",
   label: "Villers-sur-Mer (FRVMR)"
  },
  {
   value: "Ville-sous-Anjou (FRVNJ)",
   label: "Ville-sous-Anjou (FRVNJ)"
  },
  {
   value: "Villetoureix (FRILX)",
   label: "Villetoureix (FRILX)"
  },
  {
   value: "Villette (FRILT)",
   label: "Villette (FRILT)"
  },
  {
   value: "Villette (FRITT)",
   label: "Villette (FRITT)"
  },
  {
   value: "Villette-sur-Aube (FRILU)",
   label: "Villette-sur-Aube (FRILU)"
  },
  {
   value: "Villevallier (FRLLW)",
   label: "Villevallier (FRLLW)"
  },
  {
   value: "Villevaudé (FRVVD)",
   label: "Villevaudé (FRVVD)"
  },
  {
   value: "Villeveyrac (FRVVC)",
   label: "Villeveyrac (FRVVC)"
  },
  {
   value: "Villevieille (FRVLI)",
   label: "Villevieille (FRVLI)"
  },
  {
   value: "Villey-St-Etienne (FRZJY)",
   label: "Villey-St-Etienne (FRZJY)"
  },
  {
   value: "Villiers-Charlemagne (FRVCH)",
   label: "Villiers-Charlemagne (FRVCH)"
  },
  {
   value: "Villiers-le-Bel (FRVVB)",
   label: "Villiers-le-Bel (FRVVB)"
  },
  {
   value: "Villiers-le-Sec (FRVII)",
   label: "Villiers-le-Sec (FRVII)"
  },
  {
   value: "Villiers-Saint-Frederic (FRVSF)",
   label: "Villiers-Saint-Frederic (FRVSF)"
  },
  {
   value: "Villiers-sur-Marne (FRZJT)",
   label: "Villiers-sur-Marne (FRZJT)"
  },
  {
   value: "Villieu-Loyes-Mollon (FRVYL)",
   label: "Villieu-Loyes-Mollon (FRVYL)"
  },
  {
   value: "Villons-les-Buissons (FRVUS)",
   label: "Villons-les-Buissons (FRVUS)"
  },
  {
   value: "Vimoutiers (FRVMS)",
   label: "Vimoutiers (FRVMS)"
  },
  {
   value: "Vimy (FRVMY)",
   label: "Vimy (FRVMY)"
  },
  {
   value: "Vincelles (FRVNC)",
   label: "Vincelles (FRVNC)"
  },
  {
   value: "Vinchy (FRVNH)",
   label: "Vinchy (FRVNH)"
  },
  {
   value: "Vineuil (FRVNI)",
   label: "Vineuil (FRVNI)"
  },
  {
   value: "Vineuil-Saint-Firmin (FRVFI)",
   label: "Vineuil-Saint-Firmin (FRVFI)"
  },
  {
   value: "Vinsobres (FRSOB)",
   label: "Vinsobres (FRSOB)"
  },
  {
   value: "Violaines (FRVOA)",
   label: "Violaines (FRVOA)"
  },
  {
   value: "Violay (FRVYA)",
   label: "Violay (FRVYA)"
  },
  {
   value: "Viols-le-Fort (FRVFT)",
   label: "Viols-le-Fort (FRVFT)"
  },
  {
   value: "Vion (FRVKO)",
   label: "Vion (FRVKO)"
  },
  {
   value: "Vire (FRVRS)",
   label: "Vire (FRVRS)"
  },
  {
   value: "Vire-sur-Lot (FRVSL)",
   label: "Vire-sur-Lot (FRVSL)"
  },
  {
   value: "Vireux Molhain (FRVXO)",
   label: "Vireux Molhain (FRVXO)"
  },
  {
   value: "Virieu (FRVIU)",
   label: "Virieu (FRVIU)"
  },
  {
   value: "Viroflay (FRVFY)",
   label: "Viroflay (FRVFY)"
  },
  {
   value: "Virville (FRIRV)",
   label: "Virville (FRIRV)"
  },
  {
   value: "Viry (FRVRF)",
   label: "Viry (FRVRF)"
  },
  {
   value: "Viry-Noureuil (FRVYI)",
   label: "Viry-Noureuil (FRVYI)"
  },
  {
   value: "Visan (FRVSN)",
   label: "Visan (FRVSN)"
  },
  {
   value: "Viscomtat (FRZAJ)",
   label: "Viscomtat (FRZAJ)"
  },
  {
   value: "Vis-en-Artois (FRVSR)",
   label: "Vis-en-Artois (FRVSR)"
  },
  {
   value: "Vitré (FRVSE)",
   label: "Vitré (FRVSE)"
  },
  {
   value: "Vitrey-sur-Mance (FRVYM)",
   label: "Vitrey-sur-Mance (FRVYM)"
  },
  {
   value: "Vitrolles (FRVHA)",
   label: "Vitrolles (FRVHA)"
  },
  {
   value: "Vitrolles (FRVTV)",
   label: "Vitrolles (FRVTV)"
  },
  {
   value: "Vitry-en-Artois (FRZGC)",
   label: "Vitry-en-Artois (FRZGC)"
  },
  {
   value: "Vittefleur (FRVFU)",
   label: "Vittefleur (FRVFU)"
  },
  {
   value: "Viuz-en-Sallaz (FRVUZ)",
   label: "Viuz-en-Sallaz (FRVUZ)"
  },
  {
   value: "Vivier-au-Court (FRVIC)",
   label: "Vivier-au-Court (FRVIC)"
  },
  {
   value: "Vivy (FRVVY)",
   label: "Vivy (FRVVY)"
  },
  {
   value: "Vix (FRVIX)",
   label: "Vix (FRVIX)"
  },
  {
   value: "Voellerdingen (FRVNG)",
   label: "Voellerdingen (FRVNG)"
  },
  {
   value: "Voeuil-et-Giget (FRVGG)",
   label: "Voeuil-et-Giget (FRVGG)"
  },
  {
   value: "Vogüé (FRVOG)",
   label: "Vogüé (FRVOG)"
  },
  {
   value: "Voisins-le-Bretonneux (FRVBR)",
   label: "Voisins-le-Bretonneux (FRVBR)"
  },
  {
   value: "Voivres-lès-le-Mans (FRVOM)",
   label: "Voivres-lès-le-Mans (FRVOM)"
  },
  {
   value: "Volgelsheim (FRVGL)",
   label: "Volgelsheim (FRVGL)"
  },
  {
   value: "Vonges (FRXSW)",
   label: "Vonges (FRXSW)"
  },
  {
   value: "Vonnas (FRVON)",
   label: "Vonnas (FRVON)"
  },
  {
   value: "Vosne-Romanée (FRVRM)",
   label: "Vosne-Romanée (FRVRM)"
  },
  {
   value: "Vouciennes (FRVOC)",
   label: "Vouciennes (FRVOC)"
  },
  {
   value: "Vouécourt (FRVOU)",
   label: "Vouécourt (FRVOU)"
  },
  {
   value: "Vouglans (FRVOZ)",
   label: "Vouglans (FRVOZ)"
  },
  {
   value: "Vougy (FRVOY)",
   label: "Vougy (FRVOY)"
  },
  {
   value: "Vouillé (FRUIL)",
   label: "Vouillé (FRUIL)"
  },
  {
   value: "Voujeaucourt (FRVUT)",
   label: "Voujeaucourt (FRVUT)"
  },
  {
   value: "Voulangis (FRVLA)",
   label: "Voulangis (FRVLA)"
  },
  {
   value: "Vouneuil-sous-Biard (FRVSB)",
   label: "Vouneuil-sous-Biard (FRVSB)"
  },
  {
   value: "Vourles (FRULS)",
   label: "Vourles (FRULS)"
  },
  {
   value: "Vouvray (FRVUY)",
   label: "Vouvray (FRVUY)"
  },
  {
   value: "Vouziers (FRVZS)",
   label: "Vouziers (FRVZS)"
  },
  {
   value: "Voves (FRVVE)",
   label: "Voves (FRVVE)"
  },
  {
   value: "Voyenne (FROYE)",
   label: "Voyenne (FROYE)"
  },
  {
   value: "Vrigne-aux-Bois (FRVAB)",
   label: "Vrigne-aux-Bois (FRVAB)"
  },
  {
   value: "Vulaines-sur-Seine (FRUSU)",
   label: "Vulaines-sur-Seine (FRUSU)"
  },
  {
   value: "Vulbens (FRVBS)",
   label: "Vulbens (FRVBS)"
  },
  {
   value: "Wacquemoulin (FRWQM)",
   label: "Wacquemoulin (FRWQM)"
  },
  {
   value: "Wahagnies (FRWHG)",
   label: "Wahagnies (FRWHG)"
  },
  {
   value: "Wailly-Beaucamp (FRWBP)",
   label: "Wailly-Beaucamp (FRWBP)"
  },
  {
   value: "Waldhambach (FRWHB)",
   label: "Waldhambach (FRWHB)"
  },
  {
   value: "Waldwisse (FRWWE)",
   label: "Waldwisse (FRWWE)"
  },
  {
   value: "Walheim (FRWLH)",
   label: "Walheim (FRWLH)"
  },
  {
   value: "Wallers (FRWAL)",
   label: "Wallers (FRWAL)"
  },
  {
   value: "Waltembourg (FRWBO)",
   label: "Waltembourg (FRWBO)"
  },
  {
   value: "Wambrechies (FRWBS)",
   label: "Wambrechies (FRWBS)"
  },
  {
   value: "Warhem (FRWAR)",
   label: "Warhem (FRWAR)"
  },
  {
   value: "Warluis (FRWLU)",
   label: "Warluis (FRWLU)"
  },
  {
   value: "Warneton (FRWNT)",
   label: "Warneton (FRWNT)"
  },
  {
   value: "Wassy (FRWSH)",
   label: "Wassy (FRWSH)"
  },
  {
   value: "Watten (FRWTT)",
   label: "Watten (FRWTT)"
  },
  {
   value: "Wattignies (FRWTG)",
   label: "Wattignies (FRWTG)"
  },
  {
   value: "Wattwiller (FRWWR)",
   label: "Wattwiller (FRWWR)"
  },
  {
   value: "Waziers (FRWZR)",
   label: "Waziers (FRWZR)"
  },
  {
   value: "Wegscheid (FRWSE)",
   label: "Wegscheid (FRWSE)"
  },
  {
   value: "Wettolsheim (FRWET)",
   label: "Wettolsheim (FRWET)"
  },
  {
   value: "Weyersheim (FRWYH)",
   label: "Weyersheim (FRWYH)"
  },
  {
   value: "Wihr-au-Val (FRWRV)",
   label: "Wihr-au-Val (FRWRV)"
  },
  {
   value: "Wilwisheim (FRWWM)",
   label: "Wilwisheim (FRWWM)"
  },
  {
   value: "Wimereux (FRZJD)",
   label: "Wimereux (FRZJD)"
  },
  {
   value: "Wingen-sur-Moder (FRWGM)",
   label: "Wingen-sur-Moder (FRWGM)"
  },
  {
   value: "Wingersheim (FRWHE)",
   label: "Wingersheim (FRWHE)"
  },
  {
   value: "Wingles (FRWIN)",
   label: "Wingles (FRWIN)"
  },
  {
   value: "Wintzenheim (FRWHM)",
   label: "Wintzenheim (FRWHM)"
  },
  {
   value: "Witry-lès-Reims (FRWLR)",
   label: "Witry-lès-Reims (FRWLR)"
  },
  {
   value: "Wittelsheim (FRWTM)",
   label: "Wittelsheim (FRWTM)"
  },
  {
   value: "Wittenheim (FRRXN)",
   label: "Wittenheim (FRRXN)"
  },
  {
   value: "Wolfgantzen (FRWGA)",
   label: "Wolfgantzen (FRWGA)"
  },
  {
   value: "Wolfisheim (FRWOL)",
   label: "Wolfisheim (FRWOL)"
  },
  {
   value: "Wolxheim (FRWXH)",
   label: "Wolxheim (FRWXH)"
  },
  {
   value: "Wormhout (FRWHT)",
   label: "Wormhout (FRWHT)"
  },
  {
   value: "Xermaménil (FRXRL)",
   label: "Xermaménil (FRXRL)"
  },
  {
   value: "Ydes (FRYDE)",
   label: "Ydes (FRYDE)"
  },
  {
   value: "Yèbles (FRYBE)",
   label: "Yèbles (FRYBE)"
  },
  {
   value: "Ymeray (FRYYL)",
   label: "Ymeray (FRYYL)"
  },
  {
   value: "Yssingeaux (FRYSX)",
   label: "Yssingeaux (FRYSX)"
  },
  {
   value: "Ytrac (FRYTA)",
   label: "Ytrac (FRYTA)"
  },
  {
   value: "Yvrac (FRYVR)",
   label: "Yvrac (FRYVR)"
  },
  {
   value: "Yvré-le-Pôlin (FRYVP)",
   label: "Yvré-le-Pôlin (FRYVP)"
  },
  {
   value: "Zaessingue (FRZSG)",
   label: "Zaessingue (FRZSG)"
  },
  {
   value: "Zetting (FRZTG)",
   label: "Zetting (FRZTG)"
  },
  {
   value: ".GABON (GA)",
   label: ".GABON (GA)"
  },
  {
   value: "Alowe (GAAWE)",
   label: "Alowe (GAAWE)"
  },
  {
   value: "Belleville (GABEL)",
   label: "Belleville (GABEL)"
  },
  {
   value: "Biawonque (GABWN)",
   label: "Biawonque (GABWN)"
  },
  {
   value: "Bongo (GABNG)",
   label: "Bongo (GABNG)"
  },
  {
   value: "Iguela (GAIGL)",
   label: "Iguela (GAIGL)"
  },
  {
   value: "Kongobouma (GAKGB)",
   label: "Kongobouma (GAKGB)"
  },
  {
   value: "Leconi (GALCN)",
   label: "Leconi (GALCN)"
  },
  {
   value: "Mandji (GAMDJ)",
   label: "Mandji (GAMDJ)"
  },
  {
   value: "Mayumba (GAMBA)",
   label: "Mayumba (GAMBA)"
  },
  {
   value: "Mevang (GAMVG)",
   label: "Mevang (GAMVG)"
  },
  {
   value: "Miele Mimbale (GAGIM)",
   label: "Miele Mimbale (GAGIM)"
  },
  {
   value: "Minvoul (GAMVX)",
   label: "Minvoul (GAMVX)"
  },
  {
   value: "Moabi (GAMGX)",
   label: "Moabi (GAMGX)"
  },
  {
   value: "Mvengué (GAMVE)",
   label: "Mvengué (GAMVE)"
  },
  {
   value: "Nkan (GANKA)",
   label: "Nkan (GANKA)"
  },
  {
   value: "Oguandjo Terminal (GAOGU)",
   label: "Oguandjo Terminal (GAOGU)"
  },
  {
   value: "Ouanga (GAOUU)",
   label: "Ouanga (GAOUU)"
  },
  {
   value: "Sette Cama (GAZKM)",
   label: "Sette Cama (GAZKM)"
  },
  {
   value: "Wagny (GAWGY)",
   label: "Wagny (GAWGY)"
  },
  {
   value: ".UNITED KINGDOM (GB)",
   label: ".UNITED KINGDOM (GB)"
  },
  {
   value: "Abbots Bromley (GBASB)",
   label: "Abbots Bromley (GBASB)"
  },
  {
   value: "Abbots Morton (GBAOM)",
   label: "Abbots Morton (GBAOM)"
  },
  {
   value: "Abbotsbury (GBAOT)",
   label: "Abbotsbury (GBAOT)"
  },
  {
   value: "Abbotsley (GBAOL)",
   label: "Abbotsley (GBAOL)"
  },
  {
   value: "Aber Soch (GBARH)",
   label: "Aber Soch (GBARH)"
  },
  {
   value: "Aber Sôch (Abersoch) (GBABS)",
   label: "Aber Sôch (Abersoch) (GBABS)"
  },
  {
   value: "Aberbargoed (GBAOD)",
   label: "Aberbargoed (GBAOD)"
  },
  {
   value: "Aberbeeg (GBAEG)",
   label: "Aberbeeg (GBAEG)"
  },
  {
   value: "Abercanaid (GBACD)",
   label: "Abercanaid (GBACD)"
  },
  {
   value: "Abercarn (GBABC)",
   label: "Abercarn (GBABC)"
  },
  {
   value: "Abercastle (GBARC)",
   label: "Abercastle (GBARC)"
  },
  {
   value: "Abercraf (GBACF)",
   label: "Abercraf (GBACF)"
  },
  {
   value: "Abercynon (GBACY)",
   label: "Abercynon (GBACY)"
  },
  {
   value: "Aberdaron (GBADR)",
   label: "Aberdaron (GBADR)"
  },
  {
   value: "Aberdovey (GBABV)",
   label: "Aberdovey (GBABV)"
  },
  {
   value: "Aberdyfi (Aberdovey) (GBABF)",
   label: "Aberdyfi (Aberdovey) (GBABF)"
  },
  {
   value: "Aberfeldy (GBAFY)",
   label: "Aberfeldy (GBAFY)"
  },
  {
   value: "Aberffraw (GBAFW)",
   label: "Aberffraw (GBAFW)"
  },
  {
   value: "Abergele (GBAEE)",
   label: "Abergele (GBAEE)"
  },
  {
   value: "Aberlady (GBAED)",
   label: "Aberlady (GBAED)"
  },
  {
   value: "Aberlour (GBABL)",
   label: "Aberlour (GBABL)"
  },
  {
   value: "Abermule (GBABM)",
   label: "Abermule (GBABM)"
  },
  {
   value: "Abernyte (GBATE)",
   label: "Abernyte (GBATE)"
  },
  {
   value: "Abram (GBARZ)",
   label: "Abram (GBARZ)"
  },
  {
   value: "Achiltibuie (GBACE)",
   label: "Achiltibuie (GBACE)"
  },
  {
   value: "Achnacroish (GBAHN)",
   label: "Achnacroish (GBAHN)"
  },
  {
   value: "Ackworth Moor Top (GBAMT)",
   label: "Ackworth Moor Top (GBAMT)"
  },
  {
   value: "Acle (GBACL)",
   label: "Acle (GBACL)"
  },
  {
   value: "Acocks Green\/Birmingham (GBACG)",
   label: "Acocks Green\/Birmingham (GBACG)"
  },
  {
   value: "Acton Turville (GBATL)",
   label: "Acton Turville (GBATL)"
  },
  {
   value: "Acton, Sudbury (GBATO)",
   label: "Acton, Sudbury (GBATO)"
  },
  {
   value: "Adbaston (GBADA)",
   label: "Adbaston (GBADA)"
  },
  {
   value: "Addiewell (GBADW)",
   label: "Addiewell (GBADW)"
  },
  {
   value: "Adlington (GBALO)",
   label: "Adlington (GBALO)"
  },
  {
   value: "Adwick le Street (GBAKS)",
   label: "Adwick le Street (GBAKS)"
  },
  {
   value: "Afriston (GBAFT)",
   label: "Afriston (GBAFT)"
  },
  {
   value: "Aghadowey (GBAGH)",
   label: "Aghadowey (GBAGH)"
  },
  {
   value: "Aird Ma Ruibhe (GBAMR)",
   label: "Aird Ma Ruibhe (GBAMR)"
  },
  {
   value: "Aird Mhor (Ardmhor) (GBADM)",
   label: "Aird Mhor (Ardmhor) (GBADM)"
  },
  {
   value: "Airlie (GBAII)",
   label: "Airlie (GBAII)"
  },
  {
   value: "Aith (GBAIT)",
   label: "Aith (GBAIT)"
  },
  {
   value: "Albourne (GBABO)",
   label: "Albourne (GBABO)"
  },
  {
   value: "Aldborough (GBABH)",
   label: "Aldborough (GBABH)"
  },
  {
   value: "Aldbury (GBALU)",
   label: "Aldbury (GBALU)"
  },
  {
   value: "Aldebourne (GBAOU)",
   label: "Aldebourne (GBAOU)"
  },
  {
   value: "Aldenham (GBALH)",
   label: "Aldenham (GBALH)"
  },
  {
   value: "Alderminster (GBAER)",
   label: "Alderminster (GBAER)"
  },
  {
   value: "Aldham (GBADH)",
   label: "Aldham (GBADH)"
  },
  {
   value: "Aldington (GBADT)",
   label: "Aldington (GBADT)"
  },
  {
   value: "Alford (GBABX)",
   label: "Alford (GBABX)"
  },
  {
   value: "Alford (GBAFO)",
   label: "Alford (GBAFO)"
  },
  {
   value: "Allington (GBGTG)",
   label: "Allington (GBGTG)"
  },
  {
   value: "Almondsbury (GBAOY)",
   label: "Almondsbury (GBAOY)"
  },
  {
   value: "Alness (GBASS)",
   label: "Alness (GBASS)"
  },
  {
   value: "Alperton (GBAPN)",
   label: "Alperton (GBAPN)"
  },
  {
   value: "Alphington (GBAPH)",
   label: "Alphington (GBAPH)"
  },
  {
   value: "Alrewas (GBARW)",
   label: "Alrewas (GBARW)"
  },
  {
   value: "Altham (GBAHM)",
   label: "Altham (GBAHM)"
  },
  {
   value: "Alyth (GBALT)",
   label: "Alyth (GBALT)"
  },
  {
   value: "Ampthill (GBAMP)",
   label: "Ampthill (GBAMP)"
  },
  {
   value: "Anasuria (GBANA)",
   label: "Anasuria (GBANA)"
  },
  {
   value: "Andoversford (GBADV)",
   label: "Andoversford (GBADV)"
  },
  {
   value: "Anlaby (GBANB)",
   label: "Anlaby (GBANB)"
  },
  {
   value: "Annalong (GBANG)",
   label: "Annalong (GBANG)"
  },
  {
   value: "Annesley (GBANE)",
   label: "Annesley (GBANE)"
  },
  {
   value: "Anstruther (GBANS)",
   label: "Anstruther (GBANS)"
  },
  {
   value: "Ansty (GBATY)",
   label: "Ansty (GBATY)"
  },
  {
   value: "Appin (GBAPI)",
   label: "Appin (GBAPI)"
  },
  {
   value: "Appleby (GBAZV)",
   label: "Appleby (GBAZV)"
  },
  {
   value: "Applecross (GBAPS)",
   label: "Applecross (GBAPS)"
  },
  {
   value: "Appleton Thorn (GBAPT)",
   label: "Appleton Thorn (GBAPT)"
  },
  {
   value: "Arboe (Ardboe) (GBAOE)",
   label: "Arboe (Ardboe) (GBAOE)"
  },
  {
   value: "Ardbeg (GBDBG)",
   label: "Ardbeg (GBDBG)"
  },
  {
   value: "Ardentinny (GBAET)",
   label: "Ardentinny (GBAET)"
  },
  {
   value: "Ardfern (GBADF)",
   label: "Ardfern (GBADF)"
  },
  {
   value: "Ardglass (GBAGL)",
   label: "Ardglass (GBAGL)"
  },
  {
   value: "Ardgour (GBAGU)",
   label: "Ardgour (GBAGU)"
  },
  {
   value: "Ardley (GBRDY)",
   label: "Ardley (GBRDY)"
  },
  {
   value: "Ardmaleish (GBAMH)",
   label: "Ardmaleish (GBAMH)"
  },
  {
   value: "Ardminish, Gigha Island (GBGIG)",
   label: "Ardminish, Gigha Island (GBGIG)"
  },
  {
   value: "Ardnamurchan (GBAMN)",
   label: "Ardnamurchan (GBAMN)"
  },
  {
   value: "Ardsley East = Ardsley (GBADE)",
   label: "Ardsley East = Ardsley (GBADE)"
  },
  {
   value: "Ardveenish (GBARV)",
   label: "Ardveenish (GBARV)"
  },
  {
   value: "Ardwick (GBMDI)",
   label: "Ardwick (GBMDI)"
  },
  {
   value: "Ardyne (GBDYN)",
   label: "Ardyne (GBDYN)"
  },
  {
   value: "Argyll (GBGYL)",
   label: "Argyll (GBGYL)"
  },
  {
   value: "Arinagour (GBAGO)",
   label: "Arinagour (GBAGO)"
  },
  {
   value: "Arisaig (GBARG)",
   label: "Arisaig (GBARG)"
  },
  {
   value: "Arkholme (GBAHO)",
   label: "Arkholme (GBAHO)"
  },
  {
   value: "Arlesey (GBASY)",
   label: "Arlesey (GBASY)"
  },
  {
   value: "Arlington (GBALI)",
   label: "Arlington (GBALI)"
  },
  {
   value: "Armadale, Isle of Skye (GBAMD)",
   label: "Armadale, Isle of Skye (GBAMD)"
  },
  {
   value: "Arminghall (GBANH)",
   label: "Arminghall (GBANH)"
  },
  {
   value: "Armthorpe (GBATP)",
   label: "Armthorpe (GBATP)"
  },
  {
   value: "Arnish (GBRAA)",
   label: "Arnish (GBRAA)"
  },
  {
   value: "Arran (GBNAR)",
   label: "Arran (GBNAR)"
  },
  {
   value: "Ash Vale (GBAHV)",
   label: "Ash Vale (GBAHV)"
  },
  {
   value: "Ashampstead (GBAHP)",
   label: "Ashampstead (GBAHP)"
  },
  {
   value: "Ashburton (GBABU)",
   label: "Ashburton (GBABU)"
  },
  {
   value: "Ashchurch (GBACU)",
   label: "Ashchurch (GBACU)"
  },
  {
   value: "Asheldham (GBAHL)",
   label: "Asheldham (GBAHL)"
  },
  {
   value: "Ashington (GBAHG)",
   label: "Ashington (GBAHG)"
  },
  {
   value: "Ashley (GBAGR)",
   label: "Ashley (GBAGR)"
  },
  {
   value: "Ashtead\/London (GBAHE)",
   label: "Ashtead\/London (GBAHE)"
  },
  {
   value: "Ashton (GBAHT)",
   label: "Ashton (GBAHT)"
  },
  {
   value: "Ashton Keynes (GBAKY)",
   label: "Ashton Keynes (GBAKY)"
  },
  {
   value: "Ashwater (GBAWA)",
   label: "Ashwater (GBAWA)"
  },
  {
   value: "Askern (GBARK)",
   label: "Askern (GBARK)"
  },
  {
   value: "Askham (GBASQ)",
   label: "Askham (GBASQ)"
  },
  {
   value: "Aspatria (GBAXP)",
   label: "Aspatria (GBAXP)"
  },
  {
   value: "Astley Abbotts (GBAAB)",
   label: "Astley Abbotts (GBAAB)"
  },
  {
   value: "Aston (GBAON)",
   label: "Aston (GBAON)"
  },
  {
   value: "Aston Cantlow (GBAOW)",
   label: "Aston Cantlow (GBAOW)"
  },
  {
   value: "Atcham (GBATM)",
   label: "Atcham (GBATM)"
  },
  {
   value: "Athelstaneford (GBATF)",
   label: "Athelstaneford (GBATF)"
  },
  {
   value: "Auchtermuchty (GBAMU)",
   label: "Auchtermuchty (GBAMU)"
  },
  {
   value: "Auchtermuchty (GBAUY)",
   label: "Auchtermuchty (GBAUY)"
  },
  {
   value: "Auckengill (GBAKL)",
   label: "Auckengill (GBAKL)"
  },
  {
   value: "Augher (GBZAA)",
   label: "Augher (GBZAA)"
  },
  {
   value: "Aultbea (GBAUL)",
   label: "Aultbea (GBAUL)"
  },
  {
   value: "Aviemore (GBAIE)",
   label: "Aviemore (GBAIE)"
  },
  {
   value: "Avoch (GBAVC)",
   label: "Avoch (GBAVC)"
  },
  {
   value: "Axbridge (GBAXB)",
   label: "Axbridge (GBAXB)"
  },
  {
   value: "Axmouth (GBAXO)",
   label: "Axmouth (GBAXO)"
  },
  {
   value: "Aylesbeare (GBAYA)",
   label: "Aylesbeare (GBAYA)"
  },
  {
   value: "Aymestrey (GBAYM)",
   label: "Aymestrey (GBAYM)"
  },
  {
   value: "Back (GBACB)",
   label: "Back (GBACB)"
  },
  {
   value: "Backaland, Eday (GBBKC)",
   label: "Backaland, Eday (GBBKC)"
  },
  {
   value: "Bagillt (GBBGL)",
   label: "Bagillt (GBBGL)"
  },
  {
   value: "Bagstone (GBAGE)",
   label: "Bagstone (GBAGE)"
  },
  {
   value: "Baile Mor, Iona (GBION)",
   label: "Baile Mor, Iona (GBION)"
  },
  {
   value: "Bailleston (GBBTI)",
   label: "Bailleston (GBBTI)"
  },
  {
   value: "Balcombe (GBBCM)",
   label: "Balcombe (GBBCM)"
  },
  {
   value: "Baldirton (GBBDX)",
   label: "Baldirton (GBBDX)"
  },
  {
   value: "Balerno (GBBLO)",
   label: "Balerno (GBBLO)"
  },
  {
   value: "Balfron (GBBFN)",
   label: "Balfron (GBBFN)"
  },
  {
   value: "Balintore (GBBLI)",
   label: "Balintore (GBBLI)"
  },
  {
   value: "Ballantrae (GBBNR)",
   label: "Ballantrae (GBBNR)"
  },
  {
   value: "Ballater (GBBAX)",
   label: "Ballater (GBBAX)"
  },
  {
   value: "Ballinamallard (GBBXM)",
   label: "Ballinamallard (GBBXM)"
  },
  {
   value: "Ballingry (GBBIN)",
   label: "Ballingry (GBBIN)"
  },
  {
   value: "Ballintoy (GBBYP)",
   label: "Ballintoy (GBBYP)"
  },
  {
   value: "Ballydorn (GBDOR)",
   label: "Ballydorn (GBDOR)"
  },
  {
   value: "Ballygawley (GBBYW)",
   label: "Ballygawley (GBBYW)"
  },
  {
   value: "Ballyhalbert (GBBHB)",
   label: "Ballyhalbert (GBBHB)"
  },
  {
   value: "Ballylumford (GBBLR)",
   label: "Ballylumford (GBBLR)"
  },
  {
   value: "Ballynahinch (GBBLH)",
   label: "Ballynahinch (GBBLH)"
  },
  {
   value: "Ballywalter (GBLYW)",
   label: "Ballywalter (GBLYW)"
  },
  {
   value: "Balmedie (GBMMI)",
   label: "Balmedie (GBMMI)"
  },
  {
   value: "Balsall Heath (GBBHE)",
   label: "Balsall Heath (GBBHE)"
  },
  {
   value: "Balvicar (GBBVR)",
   label: "Balvicar (GBBVR)"
  },
  {
   value: "Bampton (GBBPD)",
   label: "Bampton (GBBPD)"
  },
  {
   value: "Bangor-is-y-coed (GBWGR)",
   label: "Bangor-is-y-coed (GBWGR)"
  },
  {
   value: "Bannockburn (GBBKB)",
   label: "Bannockburn (GBBKB)"
  },
  {
   value: "Bar Hill (GBRHL)",
   label: "Bar Hill (GBRHL)"
  },
  {
   value: "Bar Light (GBRLG)",
   label: "Bar Light (GBRLG)"
  },
  {
   value: "Barcaldine (GBBCE)",
   label: "Barcaldine (GBBCE)"
  },
  {
   value: "Bardney (GBARY)",
   label: "Bardney (GBARY)"
  },
  {
   value: "Bardon Hill (GBBHI)",
   label: "Bardon Hill (GBBHI)"
  },
  {
   value: "Bardsea (GBBDZ)",
   label: "Bardsea (GBBDZ)"
  },
  {
   value: "Barking (GBLBK)",
   label: "Barking (GBLBK)"
  },
  {
   value: "Barlborough (GBBLZ)",
   label: "Barlborough (GBBLZ)"
  },
  {
   value: "Barmouth (GBBMU)",
   label: "Barmouth (GBBMU)"
  },
  {
   value: "Barmouth (Abermaw) (GBABW)",
   label: "Barmouth (Abermaw) (GBABW)"
  },
  {
   value: "Barnacle (GBANC)",
   label: "Barnacle (GBANC)"
  },
  {
   value: "Barnetby-le-Wold (GBBTB)",
   label: "Barnetby-le-Wold (GBBTB)"
  },
  {
   value: "Barnham (GBAXN)",
   label: "Barnham (GBAXN)"
  },
  {
   value: "Barns Green (GBBGE)",
   label: "Barns Green (GBBGE)"
  },
  {
   value: "Barnstone (GBBBX)",
   label: "Barnstone (GBBBX)"
  },
  {
   value: "Barrington (GBAGT)",
   label: "Barrington (GBAGT)"
  },
  {
   value: "Barrow Haven (GBBRV)",
   label: "Barrow Haven (GBBRV)"
  },
  {
   value: "Barrow On Soar (GBBUO)",
   label: "Barrow On Soar (GBBUO)"
  },
  {
   value: "Barrowstowness (GBBSS)",
   label: "Barrowstowness (GBBSS)"
  },
  {
   value: "Barry (GBBYG)",
   label: "Barry (GBBYG)"
  },
  {
   value: "Barton Bendish (GBBBD)",
   label: "Barton Bendish (GBBBD)"
  },
  {
   value: "Barton on Sea (GBBAZ)",
   label: "Barton on Sea (GBBAZ)"
  },
  {
   value: "Barton-under-Needwood (GBBNO)",
   label: "Barton-under-Needwood (GBBNO)"
  },
  {
   value: "Bassingham (GBBXF)",
   label: "Bassingham (GBBXF)"
  },
  {
   value: "Baston (GBRSR)",
   label: "Baston (GBRSR)"
  },
  {
   value: "Baxenden (GBCBX)",
   label: "Baxenden (GBCBX)"
  },
  {
   value: "Beadnell (GBBQX)",
   label: "Beadnell (GBBQX)"
  },
  {
   value: "Bearley (GBBEZ)",
   label: "Bearley (GBBEZ)"
  },
  {
   value: "Bearsted (GBBER)",
   label: "Bearsted (GBBER)"
  },
  {
   value: "Beauly (GBBBL)",
   label: "Beauly (GBBBL)"
  },
  {
   value: "Beaworthy (GBBEW)",
   label: "Beaworthy (GBBEW)"
  },
  {
   value: "Bedstone (GBBTK)",
   label: "Bedstone (GBBTK)"
  },
  {
   value: "Beenham (GBENH)",
   label: "Beenham (GBENH)"
  },
  {
   value: "Beer (GBBXX)",
   label: "Beer (GBBXX)"
  },
  {
   value: "Beesands (GBBSX)",
   label: "Beesands (GBBSX)"
  },
  {
   value: "Beeston (GBEES)",
   label: "Beeston (GBEES)"
  },
  {
   value: "Beeston (GBESN)",
   label: "Beeston (GBESN)"
  },
  {
   value: "Beetham (GBBHA)",
   label: "Beetham (GBBHA)"
  },
  {
   value: "Beighton (GBIGH)",
   label: "Beighton (GBIGH)"
  },
  {
   value: "Belford (GBBZE)",
   label: "Belford (GBBZE)"
  },
  {
   value: "Belgrave (GBVVE)",
   label: "Belgrave (GBVVE)"
  },
  {
   value: "Bellaghy (GBBHG)",
   label: "Bellaghy (GBBHG)"
  },
  {
   value: "Belleek (GBBKF)",
   label: "Belleek (GBBKF)"
  },
  {
   value: "Belleek (GBBQL)",
   label: "Belleek (GBBQL)"
  },
  {
   value: "Belmont, Unst (GBBMT)",
   label: "Belmont, Unst (GBBMT)"
  },
  {
   value: "Belton (GBBLQ)",
   label: "Belton (GBBLQ)"
  },
  {
   value: "Benenden (GBNDN)",
   label: "Benenden (GBNDN)"
  },
  {
   value: "Bentham (GBEHM)",
   label: "Bentham (GBEHM)"
  },
  {
   value: "Bentley (GBNTY)",
   label: "Bentley (GBNTY)"
  },
  {
   value: "Bere Ferrers (GBYBF)",
   label: "Bere Ferrers (GBYBF)"
  },
  {
   value: "Bere Regis (GBBGI)",
   label: "Bere Regis (GBBGI)"
  },
  {
   value: "berinsfield (GBBFL)",
   label: "berinsfield (GBBFL)"
  },
  {
   value: "Berkeley (GBBKE)",
   label: "Berkeley (GBBKE)"
  },
  {
   value: "Berkley (GBZAB)",
   label: "Berkley (GBZAB)"
  },
  {
   value: "Bermondsey\/London (GBBME)",
   label: "Bermondsey\/London (GBBME)"
  },
  {
   value: "Bernera (Lewis) (GBRNR)",
   label: "Bernera (Lewis) (GBRNR)"
  },
  {
   value: "Bernera (N Uist) (GBRNN)",
   label: "Bernera (N Uist) (GBRNN)"
  },
  {
   value: "Bethania (GBBNI)",
   label: "Bethania (GBBNI)"
  },
  {
   value: "Bethesda (GBETH)",
   label: "Bethesda (GBETH)"
  },
  {
   value: "Bethnal Green\/London (GBBTG)",
   label: "Bethnal Green\/London (GBBTG)"
  },
  {
   value: "Betley (GBETY)",
   label: "Betley (GBETY)"
  },
  {
   value: "Betws-y-Coed (GBBXC)",
   label: "Betws-y-Coed (GBBXC)"
  },
  {
   value: "Betws-yn-rhos (GBBYH)",
   label: "Betws-yn-rhos (GBBYH)"
  },
  {
   value: "Bewdley (GBEEB)",
   label: "Bewdley (GBEEB)"
  },
  {
   value: "Bexleyheath (GBBXL)",
   label: "Bexleyheath (GBBXL)"
  },
  {
   value: "Bickenhill (GBBIH)",
   label: "Bickenhill (GBBIH)"
  },
  {
   value: "Bickington (GBBQQ)",
   label: "Bickington (GBBQQ)"
  },
  {
   value: "Bicknacre (GBBIA)",
   label: "Bicknacre (GBBIA)"
  },
  {
   value: "Biddenden (GBBDE)",
   label: "Biddenden (GBBDE)"
  },
  {
   value: "Bidston (GBBDO)",
   label: "Bidston (GBBDO)"
  },
  {
   value: "Bieldside (GBBDS)",
   label: "Bieldside (GBBDS)"
  },
  {
   value: "Biggar (GBBGX)",
   label: "Biggar (GBBGX)"
  },
  {
   value: "Billingborough (GBUGH)",
   label: "Billingborough (GBUGH)"
  },
  {
   value: "Billinge (GBIGE)",
   label: "Billinge (GBIGE)"
  },
  {
   value: "Billinghay (GBBHY)",
   label: "Billinghay (GBBHY)"
  },
  {
   value: "Bilsthorpe (GBBTP)",
   label: "Bilsthorpe (GBBTP)"
  },
  {
   value: "Birch Vale (GBBCV)",
   label: "Birch Vale (GBBCV)"
  },
  {
   value: "Birchington (GBBCI)",
   label: "Birchington (GBBCI)"
  },
  {
   value: "Birchwood (GBZAC)",
   label: "Birchwood (GBZAC)"
  },
  {
   value: "Birdlip (GBBDP)",
   label: "Birdlip (GBBDP)"
  },
  {
   value: "Birkdale (GBBDA)",
   label: "Birkdale (GBBDA)"
  },
  {
   value: "Birsay (GBRSB)",
   label: "Birsay (GBRSB)"
  },
  {
   value: "Birstall (GBBZL)",
   label: "Birstall (GBBZL)"
  },
  {
   value: "Birstwith (GBBWH)",
   label: "Birstwith (GBBWH)"
  },
  {
   value: "Birtley (GBBIE)",
   label: "Birtley (GBBIE)"
  },
  {
   value: "Bishop Thornton (GBBHN)",
   label: "Bishop Thornton (GBBHN)"
  },
  {
   value: "Bishops Castle (GBQWR)",
   label: "Bishops Castle (GBQWR)"
  },
  {
   value: "Bishops Frome (GBBFM)",
   label: "Bishops Frome (GBBFM)"
  },
  {
   value: "Bishopsteignton (GBPQT)",
   label: "Bishopsteignton (GBPQT)"
  },
  {
   value: "Bishopstoke (GBBPK)",
   label: "Bishopstoke (GBBPK)"
  },
  {
   value: "Bishopton (GBBOP)",
   label: "Bishopton (GBBOP)"
  },
  {
   value: "Bisley (GBBIY)",
   label: "Bisley (GBBIY)"
  },
  {
   value: "Bisley (GBISL)",
   label: "Bisley (GBISL)"
  },
  {
   value: "Bitton (GBBIO)",
   label: "Bitton (GBBIO)"
  },
  {
   value: "Blackboys (GBBCB)",
   label: "Blackboys (GBBCB)"
  },
  {
   value: "Blackford (GBBFP)",
   label: "Blackford (GBBFP)"
  },
  {
   value: "Blackford (GBBFR)",
   label: "Blackford (GBBFR)"
  },
  {
   value: "Blackfordby (GBBCF)",
   label: "Blackfordby (GBBCF)"
  },
  {
   value: "Blackhall Colliery (GBBKI)",
   label: "Blackhall Colliery (GBBKI)"
  },
  {
   value: "Blackheath\/London (GBBHT)",
   label: "Blackheath\/London (GBBHT)"
  },
  {
   value: "Blackmore End (GBXXX)",
   label: "Blackmore End (GBXXX)"
  },
  {
   value: "Blackness (GBBKS)",
   label: "Blackness (GBBKS)"
  },
  {
   value: "Blackrod (GBBCO)",
   label: "Blackrod (GBBCO)"
  },
  {
   value: "Blackwell (GBBNX)",
   label: "Blackwell (GBBNX)"
  },
  {
   value: "Blackwood (GBBCD)",
   label: "Blackwood (GBBCD)"
  },
  {
   value: "Blackwood Hill (GBBCW)",
   label: "Blackwood Hill (GBBCW)"
  },
  {
   value: "Blairmore (GBBLJ)",
   label: "Blairmore (GBBLJ)"
  },
  {
   value: "Blakeney (GBBLC)",
   label: "Blakeney (GBBLC)"
  },
  {
   value: "Blakeney (GBLKN)",
   label: "Blakeney (GBLKN)"
  },
  {
   value: "Blandford St Mary (GBBFA)",
   label: "Blandford St Mary (GBBFA)"
  },
  {
   value: "Bletchingdon (GBBCG)",
   label: "Bletchingdon (GBBCG)"
  },
  {
   value: "Blewbury (GBWJH)",
   label: "Blewbury (GBWJH)"
  },
  {
   value: "Blidworth (GBBDH)",
   label: "Blidworth (GBBDH)"
  },
  {
   value: "Blunham (GBUNH)",
   label: "Blunham (GBUNH)"
  },
  {
   value: "Blyth (GBYTH)",
   label: "Blyth (GBYTH)"
  },
  {
   value: "Boddam (GBDMB)",
   label: "Boddam (GBDMB)"
  },
  {
   value: "Bodelwyddan (GBBWY)",
   label: "Bodelwyddan (GBBWY)"
  },
  {
   value: "Bodffordd (GBBFO)",
   label: "Bodffordd (GBBFO)"
  },
  {
   value: "Bolt Head (GBLTD)",
   label: "Bolt Head (GBLTD)"
  },
  {
   value: "Boncath (GBZAD)",
   label: "Boncath (GBZAD)"
  },
  {
   value: "Bootle (GBBOO)",
   label: "Bootle (GBBOO)"
  },
  {
   value: "Bordesley Green (GBBEG)",
   label: "Bordesley Green (GBBEG)"
  },
  {
   value: "Bordon (GBODN)",
   label: "Bordon (GBODN)"
  },
  {
   value: "Boreham (GBOAM)",
   label: "Boreham (GBOAM)"
  },
  {
   value: "Borrowstounness (GBSBS)",
   label: "Borrowstounness (GBSBS)"
  },
  {
   value: "Borth-y-Gest (GBBOT)",
   label: "Borth-y-Gest (GBBOT)"
  },
  {
   value: "Boscastle (GBBSC)",
   label: "Boscastle (GBBSC)"
  },
  {
   value: "Boughton (GBBHO)",
   label: "Boughton (GBBHO)"
  },
  {
   value: "Boughton (GBGBO)",
   label: "Boughton (GBGBO)"
  },
  {
   value: "Boulmer (GBBMX)",
   label: "Boulmer (GBBMX)"
  },
  {
   value: "Boultham (GBBOM)",
   label: "Boultham (GBBOM)"
  },
  {
   value: "Bournville\/Birmingham (GBBVE)",
   label: "Bournville\/Birmingham (GBBVE)"
  },
  {
   value: "Bourton (GBBSM)",
   label: "Bourton (GBBSM)"
  },
  {
   value: "Bovington Camp (GBBVZ)",
   label: "Bovington Camp (GBBVZ)"
  },
  {
   value: "Bow (GBBWQ)",
   label: "Bow (GBBWQ)"
  },
  {
   value: "Bow Street (GBOWS)",
   label: "Bow Street (GBOWS)"
  },
  {
   value: "Bowburn (GBBWN)",
   label: "Bowburn (GBBWN)"
  },
  {
   value: "Bowdon (GBOWD)",
   label: "Bowdon (GBOWD)"
  },
  {
   value: "Box (GBBOX)",
   label: "Box (GBBOX)"
  },
  {
   value: "Bracadale (GBRCD)",
   label: "Bracadale (GBRCD)"
  },
  {
   value: "Brackmills (GBBMI)",
   label: "Brackmills (GBBMI)"
  },
  {
   value: "Braddan (GBBZD)",
   label: "Braddan (GBBZD)"
  },
  {
   value: "Bradfield (GBZAE)",
   label: "Bradfield (GBZAE)"
  },
  {
   value: "Bradford on Avon (GBBOA)",
   label: "Bradford on Avon (GBBOA)"
  },
  {
   value: "Bradley (GBBRQ)",
   label: "Bradley (GBBRQ)"
  },
  {
   value: "Bradley (GBDLY)",
   label: "Bradley (GBDLY)"
  },
  {
   value: "Bradley Stoke (GBBSK)",
   label: "Bradley Stoke (GBBSK)"
  },
  {
   value: "Bradstone (GBSDT)",
   label: "Bradstone (GBSDT)"
  },
  {
   value: "Bradwell (GBBRB)",
   label: "Bradwell (GBBRB)"
  },
  {
   value: "Bradwell on Sea (GBAWE)",
   label: "Bradwell on Sea (GBAWE)"
  },
  {
   value: "Bradwell Waterside (GBDWL)",
   label: "Bradwell Waterside (GBDWL)"
  },
  {
   value: "Bradworthy (GBBYT)",
   label: "Bradworthy (GBBYT)"
  },
  {
   value: "Braemar (GBBEQ)",
   label: "Braemar (GBBEQ)"
  },
  {
   value: "Braiseworth (GBRWH)",
   label: "Braiseworth (GBRWH)"
  },
  {
   value: "Braishfield (GBBHF)",
   label: "Braishfield (GBBHF)"
  },
  {
   value: "Bramdean (GBMDE)",
   label: "Bramdean (GBMDE)"
  },
  {
   value: "Bramfield (GBBMF)",
   label: "Bramfield (GBBMF)"
  },
  {
   value: "Bramley (GBBML)",
   label: "Bramley (GBBML)"
  },
  {
   value: "Brampton (GBBPO)",
   label: "Brampton (GBBPO)"
  },
  {
   value: "Brampton (GBMPO)",
   label: "Brampton (GBMPO)"
  },
  {
   value: "Brampton (GBRMP)",
   label: "Brampton (GBRMP)"
  },
  {
   value: "Brampton (GBRPT)",
   label: "Brampton (GBRPT)"
  },
  {
   value: "Brancaster Staithe (GBBCS)",
   label: "Brancaster Staithe (GBBCS)"
  },
  {
   value: "Branscombe (GBBBE)",
   label: "Branscombe (GBBBE)"
  },
  {
   value: "Branston (GBBSZ)",
   label: "Branston (GBBSZ)"
  },
  {
   value: "Brassington (GBBXG)",
   label: "Brassington (GBBXG)"
  },
  {
   value: "Bray (GBBWM)",
   label: "Bray (GBBWM)"
  },
  {
   value: "Breasclete (GBRST)",
   label: "Breasclete (GBRST)"
  },
  {
   value: "Breaston (GBBBB)",
   label: "Breaston (GBBBB)"
  },
  {
   value: "Brecon (GBBCN)",
   label: "Brecon (GBBCN)"
  },
  {
   value: "Bredbury (GBBBU)",
   label: "Bredbury (GBBBU)"
  },
  {
   value: "Brent (GBENT)",
   label: "Brent (GBENT)"
  },
  {
   value: "Brettenham (GBBWX)",
   label: "Brettenham (GBBWX)"
  },
  {
   value: "Bricket Wood (GBRCK)",
   label: "Bricket Wood (GBRCK)"
  },
  {
   value: "Bridge of Don (GBBGF)",
   label: "Bridge of Don (GBBGF)"
  },
  {
   value: "Brierfield (GBBFE)",
   label: "Brierfield (GBBFE)"
  },
  {
   value: "Brighstone (GBBXS)",
   label: "Brighstone (GBBXS)"
  },
  {
   value: "Brill (GBBII)",
   label: "Brill (GBBII)"
  },
  {
   value: "Brimsdown (GBZAF)",
   label: "Brimsdown (GBZAF)"
  },
  {
   value: "Brinklow (GBBNK)",
   label: "Brinklow (GBBNK)"
  },
  {
   value: "Broadford, Isle of Skye (GBBDF)",
   label: "Broadford, Isle of Skye (GBBDF)"
  },
  {
   value: "Broadmayne (GBBYN)",
   label: "Broadmayne (GBBYN)"
  },
  {
   value: "Broadway (GBBWA)",
   label: "Broadway (GBBWA)"
  },
  {
   value: "Brockweir (GBCKW)",
   label: "Brockweir (GBCKW)"
  },
  {
   value: "Brocton (GBOCT)",
   label: "Brocton (GBOCT)"
  },
  {
   value: "Bromham (GBBMM)",
   label: "Bromham (GBBMM)"
  },
  {
   value: "Brook (GBBOK)",
   label: "Brook (GBBOK)"
  },
  {
   value: "Brookenby (GBBBY)",
   label: "Brookenby (GBBBY)"
  },
  {
   value: "Brora (GBBRJ)",
   label: "Brora (GBBRJ)"
  },
  {
   value: "Brotton (GBBXT)",
   label: "Brotton (GBBXT)"
  },
  {
   value: "Brough (GBOGH)",
   label: "Brough (GBOGH)"
  },
  {
   value: "Broughton (GBUGT)",
   label: "Broughton (GBUGT)"
  },
  {
   value: "Broughton In Furness (GBBFU)",
   label: "Broughton In Furness (GBBFU)"
  },
  {
   value: "Broughty Ferry (GBBYY)",
   label: "Broughty Ferry (GBBYY)"
  },
  {
   value: "Bruichladdich (GBBCH)",
   label: "Bruichladdich (GBBCH)"
  },
  {
   value: "Bruray, Out Skerries (GBBRU)",
   label: "Bruray, Out Skerries (GBBRU)"
  },
  {
   value: "Brynmawr (GBBMW)",
   label: "Brynmawr (GBBMW)"
  },
  {
   value: "Brynsadler (GBBDR)",
   label: "Brynsadler (GBBDR)"
  },
  {
   value: "Brynsiencyn (GBBYI)",
   label: "Brynsiencyn (GBBYI)"
  },
  {
   value: "Buchan (GBUCN)",
   label: "Buchan (GBUCN)"
  },
  {
   value: "Buckfast (GBBKA)",
   label: "Buckfast (GBBKA)"
  },
  {
   value: "Buckfastleigh (GBBFG)",
   label: "Buckfastleigh (GBBFG)"
  },
  {
   value: "Buckland Brewer (GBBBW)",
   label: "Buckland Brewer (GBBBW)"
  },
  {
   value: "Bucksburn (GBZAH)",
   label: "Bucksburn (GBZAH)"
  },
  {
   value: "Budock Water (GBBWV)",
   label: "Budock Water (GBBWV)"
  },
  {
   value: "Bugle (GBZAI)",
   label: "Bugle (GBZAI)"
  },
  {
   value: "Bulkington (GBUKO)",
   label: "Bulkington (GBUKO)"
  },
  {
   value: "Bulpham (GBBUP)",
   label: "Bulpham (GBBUP)"
  },
  {
   value: "Bulwell\/Nottingham (GBBYL)",
   label: "Bulwell\/Nottingham (GBBYL)"
  },
  {
   value: "Bunessan (GBUNS)",
   label: "Bunessan (GBUNS)"
  },
  {
   value: "Bunny (GBBXY)",
   label: "Bunny (GBBXY)"
  },
  {
   value: "Buntingford (GBBTO)",
   label: "Buntingford (GBBTO)"
  },
  {
   value: "Buntingford (GBOOR)",
   label: "Buntingford (GBOOR)"
  },
  {
   value: "Burbage (GBBBA)",
   label: "Burbage (GBBBA)"
  },
  {
   value: "Burgh (GBRGH)",
   label: "Burgh (GBRGH)"
  },
  {
   value: "Burghfield Common (GBBFC)",
   label: "Burghfield Common (GBBFC)"
  },
  {
   value: "Burnaston (GBBQN)",
   label: "Burnaston (GBBQN)"
  },
  {
   value: "Burneston (GBURO)",
   label: "Burneston (GBURO)"
  },
  {
   value: "Burnham Market (GBBMK)",
   label: "Burnham Market (GBBMK)"
  },
  {
   value: "Burnmouth (GBBMO)",
   label: "Burnmouth (GBBMO)"
  },
  {
   value: "Burnopfield (GBDUO)",
   label: "Burnopfield (GBDUO)"
  },
  {
   value: "Burravoe (GBBVO)",
   label: "Burravoe (GBBVO)"
  },
  {
   value: "Burray (GBBUF)",
   label: "Burray (GBBUF)"
  },
  {
   value: "Burrowbridge (GBBBI)",
   label: "Burrowbridge (GBBBI)"
  },
  {
   value: "Burry Port (GBBPT)",
   label: "Burry Port (GBBPT)"
  },
  {
   value: "Burstwick (GBKBK)",
   label: "Burstwick (GBKBK)"
  },
  {
   value: "Burton Bradstock (GBBBK)",
   label: "Burton Bradstock (GBBBK)"
  },
  {
   value: "Burton Joyce (GBBUJ)",
   label: "Burton Joyce (GBBUJ)"
  },
  {
   value: "Burton Latimer (GBBUT)",
   label: "Burton Latimer (GBBUT)"
  },
  {
   value: "Burwick (GBBWC)",
   label: "Burwick (GBBWC)"
  },
  {
   value: "Bushey (GBBYQ)",
   label: "Bushey (GBBYQ)"
  },
  {
   value: "Bushmills (GBBMS)",
   label: "Bushmills (GBBMS)"
  },
  {
   value: "Butterleigh (GBUTT)",
   label: "Butterleigh (GBUTT)"
  },
  {
   value: "Butterwick (GBBTZ)",
   label: "Butterwick (GBBTZ)"
  },
  {
   value: "Byley (GBYEY)",
   label: "Byley (GBYEY)"
  },
  {
   value: "Cadeby (GBCDB)",
   label: "Cadeby (GBCDB)"
  },
  {
   value: "Cadgwith (GBCGZ)",
   label: "Cadgwith (GBCGZ)"
  },
  {
   value: "Caenby (GBZAJ)",
   label: "Caenby (GBZAJ)"
  },
  {
   value: "Caersws (GBAWS)",
   label: "Caersws (GBAWS)"
  },
  {
   value: "Cairnbulg (GBCBL)",
   label: "Cairnbulg (GBCBL)"
  },
  {
   value: "Caister on Sea (GBCSC)",
   label: "Caister on Sea (GBCSC)"
  },
  {
   value: "Caistor (GBCAI)",
   label: "Caistor (GBCAI)"
  },
  {
   value: "Caldecote (GBCAA)",
   label: "Caldecote (GBCAA)"
  },
  {
   value: "Caldy (GBXCY)",
   label: "Caldy (GBXCY)"
  },
  {
   value: "Callander (GBCAL)",
   label: "Callander (GBCAL)"
  },
  {
   value: "Calverton (GBCTX)",
   label: "Calverton (GBCTX)"
  },
  {
   value: "Cam (GBCAQ)",
   label: "Cam (GBCAQ)"
  },
  {
   value: "Camber (GBCBE)",
   label: "Camber (GBCBE)"
  },
  {
   value: "Camberwell (GBCBW)",
   label: "Camberwell (GBCBW)"
  },
  {
   value: "Cambois (GBCBS)",
   label: "Cambois (GBCBS)"
  },
  {
   value: "Cambs (GBMBS)",
   label: "Cambs (GBMBS)"
  },
  {
   value: "Camelford (GBCMF)",
   label: "Camelford (GBCMF)"
  },
  {
   value: "Camusnagaul (GBCAU)",
   label: "Camusnagaul (GBCAU)"
  },
  {
   value: "Canna, Inner Hebrides (GBCNA)",
   label: "Canna, Inner Hebrides (GBCNA)"
  },
  {
   value: "Cannich (GBCNI)",
   label: "Cannich (GBCNI)"
  },
  {
   value: "Canning Town (GBZAK)",
   label: "Canning Town (GBZAK)"
  },
  {
   value: "Cannington (GBZAL)",
   label: "Cannington (GBZAL)"
  },
  {
   value: "Canonbie (GBCBI)",
   label: "Canonbie (GBCBI)"
  },
  {
   value: "Cantley (GBCTY)",
   label: "Cantley (GBCTY)"
  },
  {
   value: "Cape Cornwall (GBCCL)",
   label: "Cape Cornwall (GBCCL)"
  },
  {
   value: "Capel (GBCAP)",
   label: "Capel (GBCAP)"
  },
  {
   value: "Capenhurst (GBCPU)",
   label: "Capenhurst (GBCPU)"
  },
  {
   value: "Carbost (GBCAB)",
   label: "Carbost (GBCAB)"
  },
  {
   value: "Carcroft (GBOFT)",
   label: "Carcroft (GBOFT)"
  },
  {
   value: "Carlton Colville (GBCRV)",
   label: "Carlton Colville (GBCRV)"
  },
  {
   value: "Carlton in Lindrick (GBCOI)",
   label: "Carlton in Lindrick (GBCOI)"
  },
  {
   value: "Carnlough (GBCAH)",
   label: "Carnlough (GBCAH)"
  },
  {
   value: "Carradale (GBCRA)",
   label: "Carradale (GBCRA)"
  },
  {
   value: "Carron (GBRRO)",
   label: "Carron (GBRRO)"
  },
  {
   value: "Carryduff (GBCFF)",
   label: "Carryduff (GBCFF)"
  },
  {
   value: "Carsethorn (GBCET)",
   label: "Carsethorn (GBCET)"
  },
  {
   value: "Carterton (GBZAM)",
   label: "Carterton (GBZAM)"
  },
  {
   value: "Cassington (GBCGO)",
   label: "Cassington (GBCGO)"
  },
  {
   value: "Castle Hedingham (GBEHE)",
   label: "Castle Hedingham (GBEHE)"
  },
  {
   value: "Castle Vale (GBVCL)",
   label: "Castle Vale (GBVCL)"
  },
  {
   value: "Castledawson (GBCDN)",
   label: "Castledawson (GBCDN)"
  },
  {
   value: "Castleton (GBCAS)",
   label: "Castleton (GBCAS)"
  },
  {
   value: "Castletown (GBCSW)",
   label: "Castletown (GBCSW)"
  },
  {
   value: "Castletown (GBCTN)",
   label: "Castletown (GBCTN)"
  },
  {
   value: "Castlewellan (GBCWX)",
   label: "Castlewellan (GBCWX)"
  },
  {
   value: "Catterick (GBCCR)",
   label: "Catterick (GBCCR)"
  },
  {
   value: "Catterline (GBCCE)",
   label: "Catterline (GBCCE)"
  },
  {
   value: "Caversfield (GBCVF)",
   label: "Caversfield (GBCVF)"
  },
  {
   value: "Cawsand (GBCNX)",
   label: "Cawsand (GBCNX)"
  },
  {
   value: "Caythorpe (GBCTP)",
   label: "Caythorpe (GBCTP)"
  },
  {
   value: "Ceann a Gharaidh, Eriskay (GBCAG)",
   label: "Ceann a Gharaidh, Eriskay (GBCAG)"
  },
  {
   value: "Cefn-Mawr (GBCMA)",
   label: "Cefn-Mawr (GBCMA)"
  },
  {
   value: "Ceinewydd (New Quay) (GBCEI)",
   label: "Ceinewydd (New Quay) (GBCEI)"
  },
  {
   value: "Cellardyke (GBCEL)",
   label: "Cellardyke (GBCEL)"
  },
  {
   value: "Cemaes Bay (GBCEB)",
   label: "Cemaes Bay (GBCEB)"
  },
  {
   value: "Central Mainland (Shetland) (GBCNM)",
   label: "Central Mainland (Shetland) (GBCNM)"
  },
  {
   value: "Cerrigdrudion (GBRRI)",
   label: "Cerrigdrudion (GBRRI)"
  },
  {
   value: "Chaddesden (GBADS)",
   label: "Chaddesden (GBADS)"
  },
  {
   value: "Chailey (GBCJY)",
   label: "Chailey (GBCJY)"
  },
  {
   value: "Chalford (GBAFR)",
   label: "Chalford (GBAFR)"
  },
  {
   value: "Chapel Allerton (GBCPP)",
   label: "Chapel Allerton (GBCPP)"
  },
  {
   value: "Chapel St Leonards (GBCPD)",
   label: "Chapel St Leonards (GBCPD)"
  },
  {
   value: "Chapeltown (GBCPW)",
   label: "Chapeltown (GBCPW)"
  },
  {
   value: "Charlecote (GBCEO)",
   label: "Charlecote (GBCEO)"
  },
  {
   value: "Charlestown (GBCWN)",
   label: "Charlestown (GBCWN)"
  },
  {
   value: "Charlwood (GBCAW)",
   label: "Charlwood (GBCAW)"
  },
  {
   value: "Charmouth (GBCHJ)",
   label: "Charmouth (GBCHJ)"
  },
  {
   value: "Chartham Hatch (GBCMC)",
   label: "Chartham Hatch (GBCMC)"
  },
  {
   value: "Chathill (GBCTI)",
   label: "Chathill (GBCTI)"
  },
  {
   value: "Chatteris (GBCCS)",
   label: "Chatteris (GBCCS)"
  },
  {
   value: "Cheadle Heath (GBCEH)",
   label: "Cheadle Heath (GBCEH)"
  },
  {
   value: "Chedburgh (GBXDB)",
   label: "Chedburgh (GBXDB)"
  },
  {
   value: "Cheddington (GBCDX)",
   label: "Cheddington (GBCDX)"
  },
  {
   value: "Cheddleton (GBCTW)",
   label: "Cheddleton (GBCTW)"
  },
  {
   value: "Chellaston\/Derby (GBCHX)",
   label: "Chellaston\/Derby (GBCHX)"
  },
  {
   value: "Chelsea\/London (GBCSE)",
   label: "Chelsea\/London (GBCSE)"
  },
  {
   value: "Chelworth (GBCWR)",
   label: "Chelworth (GBCWR)"
  },
  {
   value: "Chester (GBCSR)",
   label: "Chester (GBCSR)"
  },
  {
   value: "Cheveley (GBCVY)",
   label: "Cheveley (GBCVY)"
  },
  {
   value: "Chevington (GBCVG)",
   label: "Chevington (GBCVG)"
  },
  {
   value: "Chickerell (GBCKR)",
   label: "Chickerell (GBCKR)"
  },
  {
   value: "Chiddingfold (GBZDD)",
   label: "Chiddingfold (GBZDD)"
  },
  {
   value: "Chiddingstone Causeway (GBCCU)",
   label: "Chiddingstone Causeway (GBCCU)"
  },
  {
   value: "Chideock (GBCDK)",
   label: "Chideock (GBCDK)"
  },
  {
   value: "Chidham (GBCDM)",
   label: "Chidham (GBCDM)"
  },
  {
   value: "Chilcompton (GBCOP)",
   label: "Chilcompton (GBCOP)"
  },
  {
   value: "Chillington (GBCII)",
   label: "Chillington (GBCII)"
  },
  {
   value: "Chilton (GBCHO)",
   label: "Chilton (GBCHO)"
  },
  {
   value: "Chilworth (GBCIH)",
   label: "Chilworth (GBCIH)"
  },
  {
   value: "Chineham (GBCNH)",
   label: "Chineham (GBCNH)"
  },
  {
   value: "Chingford (GBCGF)",
   label: "Chingford (GBCGF)"
  },
  {
   value: "Chinnor (GBZAN)",
   label: "Chinnor (GBZAN)"
  },
  {
   value: "Chipping Sodbury (GBCSO)",
   label: "Chipping Sodbury (GBCSO)"
  },
  {
   value: "Chipping Warden (GBCPR)",
   label: "Chipping Warden (GBCPR)"
  },
  {
   value: "Chiseldon (GBCIW)",
   label: "Chiseldon (GBCIW)"
  },
  {
   value: "Christchurch (GBCTU)",
   label: "Christchurch (GBCTU)"
  },
  {
   value: "Chulmleigh (GBCMH)",
   label: "Chulmleigh (GBCMH)"
  },
  {
   value: "Church Bay, Rathlin Island (GBCUB)",
   label: "Church Bay, Rathlin Island (GBCUB)"
  },
  {
   value: "Church Gresley (GBCCG)",
   label: "Church Gresley (GBCCG)"
  },
  {
   value: "Church Lawford (GBCFZ)",
   label: "Church Lawford (GBCFZ)"
  },
  {
   value: "Churchstow (GBCCW)",
   label: "Churchstow (GBCCW)"
  },
  {
   value: "Cinderford (GBCIN)",
   label: "Cinderford (GBCIN)"
  },
  {
   value: "Clachan, Raasay (GBRAS)",
   label: "Clachan, Raasay (GBRAS)"
  },
  {
   value: "Claonaig (GBCLJ)",
   label: "Claonaig (GBCLJ)"
  },
  {
   value: "Clapton (GBLPN)",
   label: "Clapton (GBLPN)"
  },
  {
   value: "Claughton (GBZAO)",
   label: "Claughton (GBZAO)"
  },
  {
   value: "Claydon (GBCYG)",
   label: "Claydon (GBCYG)"
  },
  {
   value: "Claythorpe (GBCYE)",
   label: "Claythorpe (GBCYE)"
  },
  {
   value: "Clayton (GBCYO)",
   label: "Clayton (GBCYO)"
  },
  {
   value: "Clayton (GBZAP)",
   label: "Clayton (GBZAP)"
  },
  {
   value: "Cleadon (GBLDN)",
   label: "Cleadon (GBLDN)"
  },
  {
   value: "Cleobury Mortimer (GBCMM)",
   label: "Cleobury Mortimer (GBCMM)"
  },
  {
   value: "Cloghan Point\/Carrickfergus (GBCGP)",
   label: "Cloghan Point\/Carrickfergus (GBCGP)"
  },
  {
   value: "Clogher (GBGHR)",
   label: "Clogher (GBGHR)"
  },
  {
   value: "Clopton (GBCPM)",
   label: "Clopton (GBCPM)"
  },
  {
   value: "Clovelly (GBCVL)",
   label: "Clovelly (GBCVL)"
  },
  {
   value: "Clowne (GBCOE)",
   label: "Clowne (GBCOE)"
  },
  {
   value: "Clydebank\/Exeter (GBCKX)",
   label: "Clydebank\/Exeter (GBCKX)"
  },
  {
   value: "Clynderwen (GBCYD)",
   label: "Clynderwen (GBCYD)"
  },
  {
   value: "Clyst St Mary (GBCYM)",
   label: "Clyst St Mary (GBCYM)"
  },
  {
   value: "Coalisland (GBCOD)",
   label: "Coalisland (GBCOD)"
  },
  {
   value: "Cockburnspath (GBCKP)",
   label: "Cockburnspath (GBCKP)"
  },
  {
   value: "Cockwood (GBCQQ)",
   label: "Cockwood (GBCQQ)"
  },
  {
   value: "Codford St Mary (GBCSM)",
   label: "Codford St Mary (GBCSM)"
  },
  {
   value: "Cold Norton (GBONT)",
   label: "Cold Norton (GBONT)"
  },
  {
   value: "Colden Common (GBCCO)",
   label: "Colden Common (GBCCO)"
  },
  {
   value: "Coldstream (GBCDS)",
   label: "Coldstream (GBCDS)"
  },
  {
   value: "Coleshill (GBZAQ)",
   label: "Coleshill (GBZAQ)"
  },
  {
   value: "Colintraive (GBCVA)",
   label: "Colintraive (GBCVA)"
  },
  {
   value: "Coll (GBOLL)",
   label: "Coll (GBOLL)"
  },
  {
   value: "Collafirth (GBCAF)",
   label: "Collafirth (GBCAF)"
  },
  {
   value: "Collieston (GBCIT)",
   label: "Collieston (GBCIT)"
  },
  {
   value: "Colney Heath (GBCOZ)",
   label: "Colney Heath (GBCOZ)"
  },
  {
   value: "Colwick (GBCLK)",
   label: "Colwick (GBCLK)"
  },
  {
   value: "Colyton (GBCLO)",
   label: "Colyton (GBCLO)"
  },
  {
   value: "Combe Martin (GBCBM)",
   label: "Combe Martin (GBCBM)"
  },
  {
   value: "Commondale (GBCMN)",
   label: "Commondale (GBCMN)"
  },
  {
   value: "Compton (GBCPO)",
   label: "Compton (GBCPO)"
  },
  {
   value: "Comrie (GBCIE)",
   label: "Comrie (GBCIE)"
  },
  {
   value: "Condicote (GBCDO)",
   label: "Condicote (GBCDO)"
  },
  {
   value: "Congresbury (GBCGY)",
   label: "Congresbury (GBCGY)"
  },
  {
   value: "Conisbrough (GBCIO)",
   label: "Conisbrough (GBCIO)"
  },
  {
   value: "Connahs Quay (GBCQY)",
   label: "Connahs Quay (GBCQY)"
  },
  {
   value: "Cononbridge (GBCGR)",
   label: "Cononbridge (GBCGR)"
  },
  {
   value: "Constantine (GBCZZ)",
   label: "Constantine (GBCZZ)"
  },
  {
   value: "Cookley (GBZAR)",
   label: "Cookley (GBZAR)"
  },
  {
   value: "Coombe Bissett (GBCBB)",
   label: "Coombe Bissett (GBCBB)"
  },
  {
   value: "Copplestone (GBOPS)",
   label: "Copplestone (GBOPS)"
  },
  {
   value: "Coppull (GBOPP)",
   label: "Coppull (GBOPP)"
  },
  {
   value: "Copthorne (GBCPH)",
   label: "Copthorne (GBCPH)"
  },
  {
   value: "Corbridge (GBCBG)",
   label: "Corbridge (GBCBG)"
  },
  {
   value: "Corley (GBCYK)",
   label: "Corley (GBCYK)"
  },
  {
   value: "Cornhill-on-Tweed (GBCRD)",
   label: "Cornhill-on-Tweed (GBCRD)"
  },
  {
   value: "Cornwood (GBRWO)",
   label: "Cornwood (GBRWO)"
  },
  {
   value: "Corran (GBORR)",
   label: "Corran (GBORR)"
  },
  {
   value: "Corwen (GBORW)",
   label: "Corwen (GBORW)"
  },
  {
   value: "Cosby (GBCXY)",
   label: "Cosby (GBCXY)"
  },
  {
   value: "Cotgrave (GBCTG)",
   label: "Cotgrave (GBCTG)"
  },
  {
   value: "Cotham (GBOTA)",
   label: "Cotham (GBOTA)"
  },
  {
   value: "Coton (GBOON)",
   label: "Coton (GBOON)"
  },
  {
   value: "Cottenham (GBKOT)",
   label: "Cottenham (GBKOT)"
  },
  {
   value: "Cousley Wood (GBCWO)",
   label: "Cousley Wood (GBCWO)"
  },
  {
   value: "Cove (GBCVE)",
   label: "Cove (GBCVE)"
  },
  {
   value: "Cove (Aberdeen) (GBACV)",
   label: "Cove (Aberdeen) (GBACV)"
  },
  {
   value: "Cove (Leith) (GBCVI)",
   label: "Cove (Leith) (GBCVI)"
  },
  {
   value: "Covent Garden (GBCGT)",
   label: "Covent Garden (GBCGT)"
  },
  {
   value: "Cowfold (GBCDU)",
   label: "Cowfold (GBCDU)"
  },
  {
   value: "Cowie (GBCWI)",
   label: "Cowie (GBCWI)"
  },
  {
   value: "Cowling (GBCWG)",
   label: "Cowling (GBCWG)"
  },
  {
   value: "Coxbench (GBCXB)",
   label: "Coxbench (GBCXB)"
  },
  {
   value: "Craigellachie (GBCGA)",
   label: "Craigellachie (GBCGA)"
  },
  {
   value: "Craighouse, Isle of Jura (GBCGJ)",
   label: "Craighouse, Isle of Jura (GBCGJ)"
  },
  {
   value: "Crail (GBCRJ)",
   label: "Crail (GBCRJ)"
  },
  {
   value: "Cramond (GBCMD)",
   label: "Cramond (GBCMD)"
  },
  {
   value: "Cranborne (GBCBO)",
   label: "Cranborne (GBCBO)"
  },
  {
   value: "Cranford (GBCXX)",
   label: "Cranford (GBCXX)"
  },
  {
   value: "Cranmore (GBZAS)",
   label: "Cranmore (GBZAS)"
  },
  {
   value: "Craster (GBCRX)",
   label: "Craster (GBCRX)"
  },
  {
   value: "Crawley (GBRWY)",
   label: "Crawley (GBRWY)"
  },
  {
   value: "Crediton (GBCDI)",
   label: "Crediton (GBCDI)"
  },
  {
   value: "Cresswell (GBSSW)",
   label: "Cresswell (GBSSW)"
  },
  {
   value: "Crianlarich (GBCIA)",
   label: "Crianlarich (GBCIA)"
  },
  {
   value: "Criccieth (GBCCC)",
   label: "Criccieth (GBCCC)"
  },
  {
   value: "Crick (GBZAT)",
   label: "Crick (GBZAT)"
  },
  {
   value: "Cricklewood\/London (GBCLG)",
   label: "Cricklewood\/London (GBCLG)"
  },
  {
   value: "Crieff (GBCFE)",
   label: "Crieff (GBCFE)"
  },
  {
   value: "Crinan (GBCNC)",
   label: "Crinan (GBCNC)"
  },
  {
   value: "Crombie (GBCMP)",
   label: "Crombie (GBCMP)"
  },
  {
   value: "Cromer (GBCRR)",
   label: "Cromer (GBCRR)"
  },
  {
   value: "Cromford (GBCXM)",
   label: "Cromford (GBCXM)"
  },
  {
   value: "Cronton (GBRNO)",
   label: "Cronton (GBRNO)"
  },
  {
   value: "Crook (GBZAU)",
   label: "Crook (GBZAU)"
  },
  {
   value: "Cropthorne (GBCRP)",
   label: "Cropthorne (GBCRP)"
  },
  {
   value: "Cross Hills (GBOHI)",
   label: "Cross Hills (GBOHI)"
  },
  {
   value: "Cross Houses (GBOHU)",
   label: "Cross Houses (GBOHU)"
  },
  {
   value: "Crosskeys (GBCKY)",
   label: "Crosskeys (GBCKY)"
  },
  {
   value: "Crosskirk (GBCKK)",
   label: "Crosskirk (GBCKK)"
  },
  {
   value: "Croughton (GBCRM)",
   label: "Croughton (GBCRM)"
  },
  {
   value: "Crowan (GBOWN)",
   label: "Crowan (GBOWN)"
  },
  {
   value: "Crown Dry-Dock (GBJHW)",
   label: "Crown Dry-Dock (GBJHW)"
  },
  {
   value: "Croy (GBCOX)",
   label: "Croy (GBCOX)"
  },
  {
   value: "Croy (GBZAV)",
   label: "Croy (GBZAV)"
  },
  {
   value: "Crudgington (GBCGI)",
   label: "Crudgington (GBCGI)"
  },
  {
   value: "Crughywel (Crickhowell) (GBCHY)",
   label: "Crughywel (Crickhowell) (GBCHY)"
  },
  {
   value: "Cuan Ferry, Seil (GBCUA)",
   label: "Cuan Ferry, Seil (GBCUA)"
  },
  {
   value: "Cuffley (GBTUF)",
   label: "Cuffley (GBTUF)"
  },
  {
   value: "Culham (GBCUH)",
   label: "Culham (GBCUH)"
  },
  {
   value: "Culkein (GBCKN)",
   label: "Culkein (GBCKN)"
  },
  {
   value: "Culkein\/Drumbeg (GBCLM)",
   label: "Culkein\/Drumbeg (GBCLM)"
  },
  {
   value: "Cullen (GBCUN)",
   label: "Cullen (GBCUN)"
  },
  {
   value: "Cullivoe, Yell (GBCUV)",
   label: "Cullivoe, Yell (GBCUV)"
  },
  {
   value: "Cullybackey (GBCYB)",
   label: "Cullybackey (GBCYB)"
  },
  {
   value: "Culross (GBZAX)",
   label: "Culross (GBZAX)"
  },
  {
   value: "Cumbrae Slip, Great Cumbrae (GBCMS)",
   label: "Cumbrae Slip, Great Cumbrae (GBCMS)"
  },
  {
   value: "Cumbraes (GBCUM)",
   label: "Cumbraes (GBCUM)"
  },
  {
   value: "Curdridge (GBCDR)",
   label: "Curdridge (GBCDR)"
  },
  {
   value: "Curlew (GBCUR)",
   label: "Curlew (GBCUR)"
  },
  {
   value: "Cushendall (GBCUS)",
   label: "Cushendall (GBCUS)"
  },
  {
   value: "Cushendun (GBCUE)",
   label: "Cushendun (GBCUE)"
  },
  {
   value: "Cwm Ffrwd-Oer (GBCWF)",
   label: "Cwm Ffrwd-Oer (GBCWF)"
  },
  {
   value: "Cynwyd (GBCYW)",
   label: "Cynwyd (GBCYW)"
  },
  {
   value: "Dairsie (GBDSI)",
   label: "Dairsie (GBDSI)"
  },
  {
   value: "Dalbeattie (GBDIG)",
   label: "Dalbeattie (GBDIG)"
  },
  {
   value: "Dale Roads (GBDOS)",
   label: "Dale Roads (GBDOS)"
  },
  {
   value: "Dalgety Bay (GBDYB)",
   label: "Dalgety Bay (GBDYB)"
  },
  {
   value: "Dalston (GBDLT)",
   label: "Dalston (GBDLT)"
  },
  {
   value: "Dalton (GBZAY)",
   label: "Dalton (GBZAY)"
  },
  {
   value: "Dalwhinnie (GBDWI)",
   label: "Dalwhinnie (GBDWI)"
  },
  {
   value: "Danderhall (GBDDH)",
   label: "Danderhall (GBDDH)"
  },
  {
   value: "Dargate (GBDGE)",
   label: "Dargate (GBDGE)"
  },
  {
   value: "Darnall (GBZBA)",
   label: "Darnall (GBZBA)"
  },
  {
   value: "Darsham (GBZBB)",
   label: "Darsham (GBZBB)"
  },
  {
   value: "Darton (GBDTO)",
   label: "Darton (GBDTO)"
  },
  {
   value: "Darvel (GBZBC)",
   label: "Darvel (GBZBC)"
  },
  {
   value: "Davenham (GBDAV)",
   label: "Davenham (GBDAV)"
  },
  {
   value: "Dawlish (GBWLH)",
   label: "Dawlish (GBWLH)"
  },
  {
   value: "Debden (GBDBD)",
   label: "Debden (GBDBD)"
  },
  {
   value: "Dechmont (GBDMT)",
   label: "Dechmont (GBDMT)"
  },
  {
   value: "Deddington (GBDDO)",
   label: "Deddington (GBDDO)"
  },
  {
   value: "Deepcut (GBDPC)",
   label: "Deepcut (GBDPC)"
  },
  {
   value: "Deeping St James (GBDGJ)",
   label: "Deeping St James (GBDGJ)"
  },
  {
   value: "Deerness (GBEER)",
   label: "Deerness (GBEER)"
  },
  {
   value: "Denby (GBDEB)",
   label: "Denby (GBDEB)"
  },
  {
   value: "Denmead (GBDME)",
   label: "Denmead (GBDME)"
  },
  {
   value: "Densole (GBDSO)",
   label: "Densole (GBDSO)"
  },
  {
   value: "Denton (GBDNN)",
   label: "Denton (GBDNN)"
  },
  {
   value: "Denver (GBDNV)",
   label: "Denver (GBDNV)"
  },
  {
   value: "Dereham (GBDER)",
   label: "Dereham (GBDER)"
  },
  {
   value: "Derry (GBRRY)",
   label: "Derry (GBRRY)"
  },
  {
   value: "Derrylin (GBDYL)",
   label: "Derrylin (GBDYL)"
  },
  {
   value: "Dersingham (GBDSA)",
   label: "Dersingham (GBDSA)"
  },
  {
   value: "Dervaig (GBDVI)",
   label: "Dervaig (GBDVI)"
  },
  {
   value: "Detling (GBDTI)",
   label: "Detling (GBDTI)"
  },
  {
   value: "Dibden (GBDIB)",
   label: "Dibden (GBDIB)"
  },
  {
   value: "Dibden Purlieu (GBDBP)",
   label: "Dibden Purlieu (GBDBP)"
  },
  {
   value: "Dingwall (GBDIW)",
   label: "Dingwall (GBDIW)"
  },
  {
   value: "Dinnington (GBDRT)",
   label: "Dinnington (GBDRT)"
  },
  {
   value: "Dinton (GBDIO)",
   label: "Dinton (GBDIO)"
  },
  {
   value: "Distington (GBUBA)",
   label: "Distington (GBUBA)"
  },
  {
   value: "Doddington (GBDOG)",
   label: "Doddington (GBDOG)"
  },
  {
   value: "Dodworth (GBDWH)",
   label: "Dodworth (GBDWH)"
  },
  {
   value: "Dolgarrog (GBDOL)",
   label: "Dolgarrog (GBDOL)"
  },
  {
   value: "Dollar (GBDLR)",
   label: "Dollar (GBDLR)"
  },
  {
   value: "Donaghcloney (GBDNO)",
   label: "Donaghcloney (GBDNO)"
  },
  {
   value: "Donaghmore (GBDGO)",
   label: "Donaghmore (GBDGO)"
  },
  {
   value: "Dorchester (GBDTR)",
   label: "Dorchester (GBDTR)"
  },
  {
   value: "Dordon (GBDRD)",
   label: "Dordon (GBDRD)"
  },
  {
   value: "Dorrington (GBDOT)",
   label: "Dorrington (GBDOT)"
  },
  {
   value: "Douglas (GBDGL)",
   label: "Douglas (GBDGL)"
  },
  {
   value: "Doune (GBDOU)",
   label: "Doune (GBDOU)"
  },
  {
   value: "Dowlais (GBDWA)",
   label: "Dowlais (GBDWA)"
  },
  {
   value: "Downend (GBDWD)",
   label: "Downend (GBDWD)"
  },
  {
   value: "Downhead (GBDHS)",
   label: "Downhead (GBDHS)"
  },
  {
   value: "Downton (GBDWT)",
   label: "Downton (GBDWT)"
  },
  {
   value: "Draperstown (GBDEC)",
   label: "Draperstown (GBDEC)"
  },
  {
   value: "Drax (GBDRX)",
   label: "Drax (GBDRX)"
  },
  {
   value: "Draycott (GBDYT)",
   label: "Draycott (GBDYT)"
  },
  {
   value: "Driffield (GBDFI)",
   label: "Driffield (GBDFI)"
  },
  {
   value: "Dromore (GBDMO)",
   label: "Dromore (GBDMO)"
  },
  {
   value: "Droxford (GBDXO)",
   label: "Droxford (GBDXO)"
  },
  {
   value: "Drumintee (GBDUT)",
   label: "Drumintee (GBDUT)"
  },
  {
   value: "Drybrook (GBRRK)",
   label: "Drybrook (GBRRK)"
  },
  {
   value: "Dulas Bay (GBDBY)",
   label: "Dulas Bay (GBDBY)"
  },
  {
   value: "Dullingham (GBDLL)",
   label: "Dullingham (GBDLL)"
  },
  {
   value: "Dulverton (GBDVO)",
   label: "Dulverton (GBDVO)"
  },
  {
   value: "Dulwich (GBDWC)",
   label: "Dulwich (GBDWC)"
  },
  {
   value: "Dunbar (GBDBR)",
   label: "Dunbar (GBDBR)"
  },
  {
   value: "Dunbeath (GBDUE)",
   label: "Dunbeath (GBDUE)"
  },
  {
   value: "Dundonald (GBDUD)",
   label: "Dundonald (GBDUD)"
  },
  {
   value: "Dundonald (GBDUL)",
   label: "Dundonald (GBDUL)"
  },
  {
   value: "Dundrum (GBDDM)",
   label: "Dundrum (GBDDM)"
  },
  {
   value: "Dungeness (GBDSS)",
   label: "Dungeness (GBDSS)"
  },
  {
   value: "Dungiven (GBDGV)",
   label: "Dungiven (GBDGV)"
  },
  {
   value: "Dunkeswell (GBDKW)",
   label: "Dunkeswell (GBDKW)"
  },
  {
   value: "Dunmurry (GBDUY)",
   label: "Dunmurry (GBDUY)"
  },
  {
   value: "Dunning (GBDGU)",
   label: "Dunning (GBDGU)"
  },
  {
   value: "Dunnington (GBDGT)",
   label: "Dunnington (GBDGT)"
  },
  {
   value: "Dunrossness and Fair Isle (GBDNF)",
   label: "Dunrossness and Fair Isle (GBDNF)"
  },
  {
   value: "Duns (GBDUS)",
   label: "Duns (GBDUS)"
  },
  {
   value: "Dunscroft (GBDCO)",
   label: "Dunscroft (GBDCO)"
  },
  {
   value: "Dunseverick (GBDSK)",
   label: "Dunseverick (GBDSK)"
  },
  {
   value: "Dunsfold (GBDSF)",
   label: "Dunsfold (GBDSF)"
  },
  {
   value: "Dunster (GBDNE)",
   label: "Dunster (GBDNE)"
  },
  {
   value: "Dunston Heath (GBDHT)",
   label: "Dunston Heath (GBDHT)"
  },
  {
   value: "Dunton Green (GBDGR)",
   label: "Dunton Green (GBDGR)"
  },
  {
   value: "Dunure (GBDRE)",
   label: "Dunure (GBDRE)"
  },
  {
   value: "Dunvegan (GBDVN)",
   label: "Dunvegan (GBDVN)"
  },
  {
   value: "Dunwich (GBDNW)",
   label: "Dunwich (GBDNW)"
  },
  {
   value: "Durley (GBDEY)",
   label: "Durley (GBDEY)"
  },
  {
   value: "Durward Dauntless (GBDDT)",
   label: "Durward Dauntless (GBDDT)"
  },
  {
   value: "Dysart (GBDYS)",
   label: "Dysart (GBDYS)"
  },
  {
   value: "Eardisley (GBEDY)",
   label: "Eardisley (GBEDY)"
  },
  {
   value: "Eardiston (GBRRR)",
   label: "Eardiston (GBRRR)"
  },
  {
   value: "Earith (GBERH)",
   label: "Earith (GBERH)"
  },
  {
   value: "Earl Soham (GBESM)",
   label: "Earl Soham (GBESM)"
  },
  {
   value: "Earlestown (GBEEW)",
   label: "Earlestown (GBEEW)"
  },
  {
   value: "Earls Colne (GBECO)",
   label: "Earls Colne (GBECO)"
  },
  {
   value: "Earls Court (GBERL)",
   label: "Earls Court (GBERL)"
  },
  {
   value: "Earlston (GBERS)",
   label: "Earlston (GBERS)"
  },
  {
   value: "Earlswood (GBERW)",
   label: "Earlswood (GBERW)"
  },
  {
   value: "Easdale, Seil (GBEAA)",
   label: "Easdale, Seil (GBEAA)"
  },
  {
   value: "Eash Dulwich (GBEDU)",
   label: "Eash Dulwich (GBEDU)"
  },
  {
   value: "Easington (GBESG)",
   label: "Easington (GBESG)"
  },
  {
   value: "Easingwold (GBENW)",
   label: "Easingwold (GBENW)"
  },
  {
   value: "East Ardsley (GBEDL)",
   label: "East Ardsley (GBEDL)"
  },
  {
   value: "East Barkwith (GBEBW)",
   label: "East Barkwith (GBEBW)"
  },
  {
   value: "East Bedfont\/London (GBEBF)",
   label: "East Bedfont\/London (GBEBF)"
  },
  {
   value: "East Boldon (GBEBL)",
   label: "East Boldon (GBEBL)"
  },
  {
   value: "East Brent (GBEBT)",
   label: "East Brent (GBEBT)"
  },
  {
   value: "East Claydon (GBECD)",
   label: "East Claydon (GBECD)"
  },
  {
   value: "East Hanningfield (GBEHF)",
   label: "East Hanningfield (GBEHF)"
  },
  {
   value: "East Harling (GBEHA)",
   label: "East Harling (GBEHA)"
  },
  {
   value: "East Hoathly (GBEHL)",
   label: "East Hoathly (GBEHL)"
  },
  {
   value: "East Hyde (GBEHY)",
   label: "East Hyde (GBEHY)"
  },
  {
   value: "East Leake (GBEKE)",
   label: "East Leake (GBEKE)"
  },
  {
   value: "East Malling (GBEAS)",
   label: "East Malling (GBEAS)"
  },
  {
   value: "East Pennard (GBEPN)",
   label: "East Pennard (GBEPN)"
  },
  {
   value: "East Wittering (GBEWT)",
   label: "East Wittering (GBEWT)"
  },
  {
   value: "Eastburn (GBEAW)",
   label: "Eastburn (GBEAW)"
  },
  {
   value: "Eastchurch (GBDED)",
   label: "Eastchurch (GBDED)"
  },
  {
   value: "Eastfield (GBEFD)",
   label: "Eastfield (GBEFD)"
  },
  {
   value: "Eastleigh (GBEAL)",
   label: "Eastleigh (GBEAL)"
  },
  {
   value: "Eastnor (GBENR)",
   label: "Eastnor (GBENR)"
  },
  {
   value: "Easton Grey (GBEGY)",
   label: "Easton Grey (GBEGY)"
  },
  {
   value: "Eastwood (GBEWD)",
   label: "Eastwood (GBEWD)"
  },
  {
   value: "Eastwood (GBEWO)",
   label: "Eastwood (GBEWO)"
  },
  {
   value: "Eaton (GBETO)",
   label: "Eaton (GBETO)"
  },
  {
   value: "Eccleshall (GBECH)",
   label: "Eccleshall (GBECH)"
  },
  {
   value: "Eccleston (GBECT)",
   label: "Eccleston (GBECT)"
  },
  {
   value: "Eckington (GBECK)",
   label: "Eckington (GBECK)"
  },
  {
   value: "Edenthorpe (GBETE)",
   label: "Edenthorpe (GBETE)"
  },
  {
   value: "Edgeware (GBLEW)",
   label: "Edgeware (GBLEW)"
  },
  {
   value: "Effingham (GBEGA)",
   label: "Effingham (GBEGA)"
  },
  {
   value: "Eggborough (GBDBE)",
   label: "Eggborough (GBDBE)"
  },
  {
   value: "Egglescliffe (GBEGG)",
   label: "Egglescliffe (GBEGG)"
  },
  {
   value: "Egilsay (GBEGI)",
   label: "Egilsay (GBEGI)"
  },
  {
   value: "Egremont (GBEGT)",
   label: "Egremont (GBEGT)"
  },
  {
   value: "Eishken (GBESK)",
   label: "Eishken (GBESK)"
  },
  {
   value: "Eisken (GBEKN)",
   label: "Eisken (GBEKN)"
  },
  {
   value: "Elgol, Isle of Skye (GBEGO)",
   label: "Elgol, Isle of Skye (GBEGO)"
  },
  {
   value: "Ellenabeich, Seil (GBELB)",
   label: "Ellenabeich, Seil (GBELB)"
  },
  {
   value: "Ellistown (GBELO)",
   label: "Ellistown (GBELO)"
  },
  {
   value: "Ellon (GBEOL)",
   label: "Ellon (GBEOL)"
  },
  {
   value: "Elm Park (GBEMP)",
   label: "Elm Park (GBEMP)"
  },
  {
   value: "Elmswell (GBEWL)",
   label: "Elmswell (GBEWL)"
  },
  {
   value: "Elsham (GBELS)",
   label: "Elsham (GBELS)"
  },
  {
   value: "Elstead (GBETD)",
   label: "Elstead (GBETD)"
  },
  {
   value: "Elton (GBQLT)",
   label: "Elton (GBQLT)"
  },
  {
   value: "Elworth (GBEWH)",
   label: "Elworth (GBEWH)"
  },
  {
   value: "Emborough (GBEBG)",
   label: "Emborough (GBEBG)"
  },
  {
   value: "Embsay (GBMSY)",
   label: "Embsay (GBMSY)"
  },
  {
   value: "Emsworth (GBEMS)",
   label: "Emsworth (GBEMS)"
  },
  {
   value: "Enstone (GBESO)",
   label: "Enstone (GBESO)"
  },
  {
   value: "Epworth (GBEPW)",
   label: "Epworth (GBEPW)"
  },
  {
   value: "Erribol (GBRBL)",
   label: "Erribol (GBRBL)"
  },
  {
   value: "Erskine (GBEKI)",
   label: "Erskine (GBEKI)"
  },
  {
   value: "Eshaness (GBESS)",
   label: "Eshaness (GBESS)"
  },
  {
   value: "Evanton (GBEVT)",
   label: "Evanton (GBEVT)"
  },
  {
   value: "Evercreech (GBEVC)",
   label: "Evercreech (GBEVC)"
  },
  {
   value: "Eversley (GBERY)",
   label: "Eversley (GBERY)"
  },
  {
   value: "Ewhurst (GBEWU)",
   label: "Ewhurst (GBEWU)"
  },
  {
   value: "Fairisle (GBFAI)",
   label: "Fairisle (GBFAI)"
  },
  {
   value: "Fairlie (GBFEE)",
   label: "Fairlie (GBFEE)"
  },
  {
   value: "Falfield (GBFFD)",
   label: "Falfield (GBFFD)"
  },
  {
   value: "Falkland (GBFKL)",
   label: "Falkland (GBFKL)"
  },
  {
   value: "Farington (GBFTN)",
   label: "Farington (GBFTN)"
  },
  {
   value: "Farlington (GBFLT)",
   label: "Farlington (GBFLT)"
  },
  {
   value: "Farnham (GBFDR)",
   label: "Farnham (GBFDR)"
  },
  {
   value: "Farnham Royal (GBFMR)",
   label: "Farnham Royal (GBFMR)"
  },
  {
   value: "Farringdon (GBFGD)",
   label: "Farringdon (GBFGD)"
  },
  {
   value: "Farthingstone (GBFNE)",
   label: "Farthingstone (GBFNE)"
  },
  {
   value: "Fawdon (GBFWO)",
   label: "Fawdon (GBFWO)"
  },
  {
   value: "Fawham Green (GBFWK)",
   label: "Fawham Green (GBFWK)"
  },
  {
   value: "Fazeley (GBFZY)",
   label: "Fazeley (GBFZY)"
  },
  {
   value: "Fearn (GBERN)",
   label: "Fearn (GBERN)"
  },
  {
   value: "Feering (GBFEG)",
   label: "Feering (GBFEG)"
  },
  {
   value: "Felbridge (GBFBG)",
   label: "Felbridge (GBFBG)"
  },
  {
   value: "Felinfach (GBFFH)",
   label: "Felinfach (GBFFH)"
  },
  {
   value: "Felinfach (GBFNF)",
   label: "Felinfach (GBFNF)"
  },
  {
   value: "Fenny Compton (GBDBF)",
   label: "Fenny Compton (GBDBF)"
  },
  {
   value: "Feolin Ferry (GBFEO)",
   label: "Feolin Ferry (GBFEO)"
  },
  {
   value: "Fernham (GBFHA)",
   label: "Fernham (GBFHA)"
  },
  {
   value: "Fernhurst (GBFNU)",
   label: "Fernhurst (GBFNU)"
  },
  {
   value: "Ferrybridge (GBFEB)",
   label: "Ferrybridge (GBFEB)"
  },
  {
   value: "Ferrybridge (GBFRX)",
   label: "Ferrybridge (GBFRX)"
  },
  {
   value: "Ferryhill (GBFRY)",
   label: "Ferryhill (GBFRY)"
  },
  {
   value: "Ferryside (GBFYD)",
   label: "Ferryside (GBFYD)"
  },
  {
   value: "Fetterangus (GBFTU)",
   label: "Fetterangus (GBFTU)"
  },
  {
   value: "Fetternear (GBFNR)",
   label: "Fetternear (GBFNR)"
  },
  {
   value: "Ffestiniog (GBFFE)",
   label: "Ffestiniog (GBFFE)"
  },
  {
   value: "Fforest-Fach (GBFTF)",
   label: "Fforest-Fach (GBFTF)"
  },
  {
   value: "Finchley (GBFCL)",
   label: "Finchley (GBFCL)"
  },
  {
   value: "Findern (GBFIR)",
   label: "Findern (GBFIR)"
  },
  {
   value: "Findhorn (GBFIN)",
   label: "Findhorn (GBFIN)"
  },
  {
   value: "Findochty (GBFID)",
   label: "Findochty (GBFID)"
  },
  {
   value: "Findon (GBFDO)",
   label: "Findon (GBFDO)"
  },
  {
   value: "Finningley (GBFNL)",
   label: "Finningley (GBFNL)"
  },
  {
   value: "Finsbury\/Greater London (GBNSF)",
   label: "Finsbury\/Greater London (GBNSF)"
  },
  {
   value: "Fionnphort, Isle of Mull (GBFIO)",
   label: "Fionnphort, Isle of Mull (GBFIO)"
  },
  {
   value: "Fishbourne (GBFBU)",
   label: "Fishbourne (GBFBU)"
  },
  {
   value: "Fisherrow\/Musselburgh (GBFIH)",
   label: "Fisherrow\/Musselburgh (GBFIH)"
  },
  {
   value: "Fishnish, Isle of Mull (GBFNH)",
   label: "Fishnish, Isle of Mull (GBFNH)"
  },
  {
   value: "Fishponds (GBFPS)",
   label: "Fishponds (GBFPS)"
  },
  {
   value: "Five Oak Green (GBFOG)",
   label: "Five Oak Green (GBFOG)"
  },
  {
   value: "Fivemiletown (GBVEM)",
   label: "Fivemiletown (GBVEM)"
  },
  {
   value: "Flackwell Heath (GBFLA)",
   label: "Flackwell Heath (GBFLA)"
  },
  {
   value: "Flamborough (GBFBH)",
   label: "Flamborough (GBFBH)"
  },
  {
   value: "Flaxby (GBFXY)",
   label: "Flaxby (GBFXY)"
  },
  {
   value: "Fleckney (GBFKY)",
   label: "Fleckney (GBFKY)"
  },
  {
   value: "Flimby (GBFBY)",
   label: "Flimby (GBFBY)"
  },
  {
   value: "Flookburgh (GBFLK)",
   label: "Flookburgh (GBFLK)"
  },
  {
   value: "Flore (GBFLR)",
   label: "Flore (GBFLR)"
  },
  {
   value: "Flushing (GBFLU)",
   label: "Flushing (GBFLU)"
  },
  {
   value: "Foinaven (GBFNV)",
   label: "Foinaven (GBFNV)"
  },
  {
   value: "Foindlemore Loch Glendhu (GBFOI)",
   label: "Foindlemore Loch Glendhu (GBFOI)"
  },
  {
   value: "Fonthill Bishop (GBFBP)",
   label: "Fonthill Bishop (GBFBP)"
  },
  {
   value: "Ford (GBFOD)",
   label: "Ford (GBFOD)"
  },
  {
   value: "Ford (GBFOH)",
   label: "Ford (GBFOH)"
  },
  {
   value: "Fordoun (GBFDU)",
   label: "Fordoun (GBFDU)"
  },
  {
   value: "Forest Town (GBFSN)",
   label: "Forest Town (GBFSN)"
  },
  {
   value: "Fortrose (GBFTR)",
   label: "Fortrose (GBFTR)"
  },
  {
   value: "Fossebridge (GBFSE)",
   label: "Fossebridge (GBFSE)"
  },
  {
   value: "Foston (GBDFN)",
   label: "Foston (GBDFN)"
  },
  {
   value: "Foston (GBFOS)",
   label: "Foston (GBFOS)"
  },
  {
   value: "Foston (GBLIF)",
   label: "Foston (GBLIF)"
  },
  {
   value: "Fotherby (GBDBH)",
   label: "Fotherby (GBDBH)"
  },
  {
   value: "Foulness I. (GBFUN)",
   label: "Foulness I. (GBFUN)"
  },
  {
   value: "Four Ashes (GBFOU)",
   label: "Four Ashes (GBFOU)"
  },
  {
   value: "Four Oaks (GBFOK)",
   label: "Four Oaks (GBFOK)"
  },
  {
   value: "Fourstones (GBFTO)",
   label: "Fourstones (GBFTO)"
  },
  {
   value: "Fowlmere (GBFRE)",
   label: "Fowlmere (GBFRE)"
  },
  {
   value: "Fradley (GBFDY)",
   label: "Fradley (GBFDY)"
  },
  {
   value: "Frampton Cotterell (GBFCT)",
   label: "Frampton Cotterell (GBFCT)"
  },
  {
   value: "Frampton on Severn (GBFRV)",
   label: "Frampton on Severn (GBFRV)"
  },
  {
   value: "Frenchay (GBFRN)",
   label: "Frenchay (GBFRN)"
  },
  {
   value: "Freshwater East (GBFWE)",
   label: "Freshwater East (GBFWE)"
  },
  {
   value: "Friden (GBNFR)",
   label: "Friden (GBNFR)"
  },
  {
   value: "Frimley (GBFMY)",
   label: "Frimley (GBFMY)"
  },
  {
   value: "Frinton-on-Sea (GBFRI)",
   label: "Frinton-on-Sea (GBFRI)"
  },
  {
   value: "Friockheim (GBFKH)",
   label: "Friockheim (GBFKH)"
  },
  {
   value: "Friskney (GBFSY)",
   label: "Friskney (GBFSY)"
  },
  {
   value: "Froghall (GBFGH)",
   label: "Froghall (GBFGH)"
  },
  {
   value: "Full Sutton (GBFST)",
   label: "Full Sutton (GBFST)"
  },
  {
   value: "Furnace (GBFUR)",
   label: "Furnace (GBFUR)"
  },
  {
   value: "Gairloch (GBGAR)",
   label: "Gairloch (GBGAR)"
  },
  {
   value: "Galgate (GBDBJ)",
   label: "Galgate (GBDBJ)"
  },
  {
   value: "Galmisdale, Eigg (GBGAS)",
   label: "Galmisdale, Eigg (GBGAS)"
  },
  {
   value: "Galston (GBGLT)",
   label: "Galston (GBGLT)"
  },
  {
   value: "Gamston (GBGMT)",
   label: "Gamston (GBGMT)"
  },
  {
   value: "Gareloch (GBGLH)",
   label: "Gareloch (GBGLH)"
  },
  {
   value: "Garelochhead (GBGAD)",
   label: "Garelochhead (GBGAD)"
  },
  {
   value: "Garrabost (GBRRB)",
   label: "Garrabost (GBRRB)"
  },
  {
   value: "Garrigill (GBGGI)",
   label: "Garrigill (GBGGI)"
  },
  {
   value: "Garth (GBGHA)",
   label: "Garth (GBGHA)"
  },
  {
   value: "Garvagh (GBDBK)",
   label: "Garvagh (GBDBK)"
  },
  {
   value: "Gaydon (GBGAY)",
   label: "Gaydon (GBGAY)"
  },
  {
   value: "Georgetown (GBDBL)",
   label: "Georgetown (GBDBL)"
  },
  {
   value: "Gilberdyke (GBGBD)",
   label: "Gilberdyke (GBGBD)"
  },
  {
   value: "Gills (GBILL)",
   label: "Gills (GBILL)"
  },
  {
   value: "Gisburn (GBGBN)",
   label: "Gisburn (GBGBN)"
  },
  {
   value: "Glenarm (GBGLA)",
   label: "Glenarm (GBGLA)"
  },
  {
   value: "Glenbervie (GBGBV)",
   label: "Glenbervie (GBGBV)"
  },
  {
   value: "Glenfarg (GBGFG)",
   label: "Glenfarg (GBGFG)"
  },
  {
   value: "Glenmavis (GBGNM)",
   label: "Glenmavis (GBGNM)"
  },
  {
   value: "Glenuig (GBGLG)",
   label: "Glenuig (GBGLG)"
  },
  {
   value: "Glespin (GBZBD)",
   label: "Glespin (GBZBD)"
  },
  {
   value: "Glyn Neath (GBGYN)",
   label: "Glyn Neath (GBGYN)"
  },
  {
   value: "Gobowen (GBGBW)",
   label: "Gobowen (GBGBW)"
  },
  {
   value: "Golspie (GBGLP)",
   label: "Golspie (GBGLP)"
  },
  {
   value: "Golspie (GBGSI)",
   label: "Golspie (GBGSI)"
  },
  {
   value: "Gorebridge (GBGBR)",
   label: "Gorebridge (GBGBR)"
  },
  {
   value: "Goring-by-Sea (GBGBS)",
   label: "Goring-by-Sea (GBGBS)"
  },
  {
   value: "Gorran Haven (GBGOR)",
   label: "Gorran Haven (GBGOR)"
  },
  {
   value: "Gosforth (GBGFH)",
   label: "Gosforth (GBGFH)"
  },
  {
   value: "Goudhurst (GBGOU)",
   label: "Goudhurst (GBGOU)"
  },
  {
   value: "Gourdon (GBGUD)",
   label: "Gourdon (GBGUD)"
  },
  {
   value: "Govan (GBGVA)",
   label: "Govan (GBGVA)"
  },
  {
   value: "Goveton (GBGVO)",
   label: "Goveton (GBGVO)"
  },
  {
   value: "Gowdall (GBWWL)",
   label: "Gowdall (GBWWL)"
  },
  {
   value: "Gowerton (GBGOW)",
   label: "Gowerton (GBGOW)"
  },
  {
   value: "Goxhill (GBGOX)",
   label: "Goxhill (GBGOX)"
  },
  {
   value: "Goxhill (GBHXL)",
   label: "Goxhill (GBHXL)"
  },
  {
   value: "Graemsay (GBGAE)",
   label: "Graemsay (GBGAE)"
  },
  {
   value: "Grange-over-Sands (GBGSD)",
   label: "Grange-over-Sands (GBGSD)"
  },
  {
   value: "Grassington (GBGZT)",
   label: "Grassington (GBGZT)"
  },
  {
   value: "Grayshott (GBGYT)",
   label: "Grayshott (GBGYT)"
  },
  {
   value: "Great Barford (GBATB)",
   label: "Great Barford (GBATB)"
  },
  {
   value: "Great Bentley (GBGBY)",
   label: "Great Bentley (GBGBY)"
  },
  {
   value: "Great Braxted (GBGBX)",
   label: "Great Braxted (GBGBX)"
  },
  {
   value: "Great Bridgeford (GBGBF)",
   label: "Great Bridgeford (GBGBF)"
  },
  {
   value: "Great Broughton (GBGBG)",
   label: "Great Broughton (GBGBG)"
  },
  {
   value: "Great Budworth (GBGBU)",
   label: "Great Budworth (GBGBU)"
  },
  {
   value: "Great Coates (GBGCS)",
   label: "Great Coates (GBGCS)"
  },
  {
   value: "Great Coates (GBGCT)",
   label: "Great Coates (GBGCT)"
  },
  {
   value: "Great Driffield (GBGDF)",
   label: "Great Driffield (GBGDF)"
  },
  {
   value: "Great Haywood (GBGHW)",
   label: "Great Haywood (GBGHW)"
  },
  {
   value: "Great Horwood (GBGEW)",
   label: "Great Horwood (GBGEW)"
  },
  {
   value: "Great Houghton (GBGHH)",
   label: "Great Houghton (GBGHH)"
  },
  {
   value: "Great Milton (GBGMN)",
   label: "Great Milton (GBGMN)"
  },
  {
   value: "Great Notley (GBGEN)",
   label: "Great Notley (GBGEN)"
  },
  {
   value: "Great Oakley (GBGOA)",
   label: "Great Oakley (GBGOA)"
  },
  {
   value: "Great Shefford (GBGTD)",
   label: "Great Shefford (GBGTD)"
  },
  {
   value: "Great Snoring (GBGTS)",
   label: "Great Snoring (GBGTS)"
  },
  {
   value: "Great Wakering (GBGWG)",
   label: "Great Wakering (GBGWG)"
  },
  {
   value: "Great Yeldham (GBGYD)",
   label: "Great Yeldham (GBGYD)"
  },
  {
   value: "Greenfield (GBGFI)",
   label: "Greenfield (GBGFI)"
  },
  {
   value: "Greetham (GBZBE)",
   label: "Greetham (GBZBE)"
  },
  {
   value: "Grendon (GBGDO)",
   label: "Grendon (GBGDO)"
  },
  {
   value: "Gretna (GBGRT)",
   label: "Gretna (GBGRT)"
  },
  {
   value: "Grimesthorpe (GBGPE)",
   label: "Grimesthorpe (GBGPE)"
  },
  {
   value: "Grimsay (GBGMY)",
   label: "Grimsay (GBGMY)"
  },
  {
   value: "Grindale (GBGDL)",
   label: "Grindale (GBGDL)"
  },
  {
   value: "Groomsport (GBGRO)",
   label: "Groomsport (GBGRO)"
  },
  {
   value: "Grovehurst Jetty\/Sittingbourne (GBGRJ)",
   label: "Grovehurst Jetty\/Sittingbourne (GBGRJ)"
  },
  {
   value: "Grutness (GBGRU)",
   label: "Grutness (GBGRU)"
  },
  {
   value: "Gullane (GBZBF)",
   label: "Gullane (GBZBF)"
  },
  {
   value: "Gulval (GBGVL)",
   label: "Gulval (GBGVL)"
  },
  {
   value: "Gunn (GBGUN)",
   label: "Gunn (GBGUN)"
  },
  {
   value: "Gunness (GBGUS)",
   label: "Gunness (GBGUS)"
  },
  {
   value: "Gunnislake (GBGUM)",
   label: "Gunnislake (GBGUM)"
  },
  {
   value: "Gutcher, Yell (GBGUT)",
   label: "Gutcher, Yell (GBGUT)"
  },
  {
   value: "Guyhirn (GBGHN)",
   label: "Guyhirn (GBGHN)"
  },
  {
   value: "Gweek (GBGWK)",
   label: "Gweek (GBGWK)"
  },
  {
   value: "Gwynedd (GBGND)",
   label: "Gwynedd (GBGND)"
  },
  {
   value: "Hackbridge (GBHKB)",
   label: "Hackbridge (GBHKB)"
  },
  {
   value: "Hackforth (GBHKO)",
   label: "Hackforth (GBHKO)"
  },
  {
   value: "Haddenham (GBZBG)",
   label: "Haddenham (GBZBG)"
  },
  {
   value: "Hadfield (GBFED)",
   label: "Hadfield (GBFED)"
  },
  {
   value: "Hadleigh (GBHDI)",
   label: "Hadleigh (GBHDI)"
  },
  {
   value: "Hadley Wood (GBHAW)",
   label: "Hadley Wood (GBHAW)"
  },
  {
   value: "Hailey (GBYEL)",
   label: "Hailey (GBYEL)"
  },
  {
   value: "Halbeath (GBHAB)",
   label: "Halbeath (GBHAB)"
  },
  {
   value: "Hale Bank (GBHLE)",
   label: "Hale Bank (GBHLE)"
  },
  {
   value: "Halkirk (GBHKI)",
   label: "Halkirk (GBHKI)"
  },
  {
   value: "Hallatrow (GBHZZ)",
   label: "Hallatrow (GBHZZ)"
  },
  {
   value: "Hallen (GBHLV)",
   label: "Hallen (GBHLV)"
  },
  {
   value: "Halliford (GBHFR)",
   label: "Halliford (GBHFR)"
  },
  {
   value: "Halstead (GBHSD)",
   label: "Halstead (GBHSD)"
  },
  {
   value: "Halton Gill (GBHAG)",
   label: "Halton Gill (GBHAG)"
  },
  {
   value: "Halton West (GBHDW)",
   label: "Halton West (GBHDW)"
  },
  {
   value: "Halwell (GBHEL)",
   label: "Halwell (GBHEL)"
  },
  {
   value: "Ham Voe, Foula (GBHVO)",
   label: "Ham Voe, Foula (GBHVO)"
  },
  {
   value: "Hamars Ness, Fetlar (GBHNS)",
   label: "Hamars Ness, Fetlar (GBHNS)"
  },
  {
   value: "Hambleton (GBHBT)",
   label: "Hambleton (GBHBT)"
  },
  {
   value: "Hambleton (GBHML)",
   label: "Hambleton (GBHML)"
  },
  {
   value: "Hamiltons Bawn (GBHIB)",
   label: "Hamiltons Bawn (GBHIB)"
  },
  {
   value: "Hammersmith (GBHMM)",
   label: "Hammersmith (GBHMM)"
  },
  {
   value: "Hamnavoe, Burra Isle (GBHMV)",
   label: "Hamnavoe, Burra Isle (GBHMV)"
  },
  {
   value: "Hampton Bishop (GBHBP)",
   label: "Hampton Bishop (GBHBP)"
  },
  {
   value: "Hampton Hill (GBHPL)",
   label: "Hampton Hill (GBHPL)"
  },
  {
   value: "Hampton Wick\/Surrey (GBESI)",
   label: "Hampton Wick\/Surrey (GBESI)"
  },
  {
   value: "Handforth (GBHFO)",
   label: "Handforth (GBHFO)"
  },
  {
   value: "Hannington (GBINN)",
   label: "Hannington (GBINN)"
  },
  {
   value: "Hanwell (GBAEW)",
   label: "Hanwell (GBAEW)"
  },
  {
   value: "Hanwell (GBHNW)",
   label: "Hanwell (GBHNW)"
  },
  {
   value: "Hanwell (GBZBH)",
   label: "Hanwell (GBZBH)"
  },
  {
   value: "Hanworth (GBHAO)",
   label: "Hanworth (GBHAO)"
  },
  {
   value: "Hanworth (GBHWX)",
   label: "Hanworth (GBHWX)"
  },
  {
   value: "Hardham (GBHHM)",
   label: "Hardham (GBHHM)"
  },
  {
   value: "Hardwick (GBHDC)",
   label: "Hardwick (GBHDC)"
  },
  {
   value: "Harewood (GBAWD)",
   label: "Harewood (GBAWD)"
  },
  {
   value: "Harle Syke (GBHAK)",
   label: "Harle Syke (GBHAK)"
  },
  {
   value: "Harleston (GBHAS)",
   label: "Harleston (GBHAS)"
  },
  {
   value: "Harraby (GBHAA)",
   label: "Harraby (GBHAA)"
  },
  {
   value: "Harrington (GBHRR)",
   label: "Harrington (GBHRR)"
  },
  {
   value: "Harrow Weald (GBZBI)",
   label: "Harrow Weald (GBZBI)"
  },
  {
   value: "Hartfield (GBHTF)",
   label: "Hartfield (GBHTF)"
  },
  {
   value: "Hartford (GBHAZ)",
   label: "Hartford (GBHAZ)"
  },
  {
   value: "Hartington (GBHIT)",
   label: "Hartington (GBHIT)"
  },
  {
   value: "Hartington (GBHRG)",
   label: "Hartington (GBHRG)"
  },
  {
   value: "Hartley (GBYLY)",
   label: "Hartley (GBYLY)"
  },
  {
   value: "Haslingfield (GBHFD)",
   label: "Haslingfield (GBHFD)"
  },
  {
   value: "Hastingwood (GBHGD)",
   label: "Hastingwood (GBHGD)"
  },
  {
   value: "Hatch Beauchamp (GBHBU)",
   label: "Hatch Beauchamp (GBHBU)"
  },
  {
   value: "Hatch End (GBHTE)",
   label: "Hatch End (GBHTE)"
  },
  {
   value: "Hatfield Peverel (GBZBJ)",
   label: "Hatfield Peverel (GBZBJ)"
  },
  {
   value: "Hatton (GBHAN)",
   label: "Hatton (GBHAN)"
  },
  {
   value: "Hauxton (GBHAX)",
   label: "Hauxton (GBHAX)"
  },
  {
   value: "Hawthorn (GBHHO)",
   label: "Hawthorn (GBHHO)"
  },
  {
   value: "Haydon (GBAYN)",
   label: "Haydon (GBAYN)"
  },
  {
   value: "Haydon Bridge (GBHBD)",
   label: "Haydon Bridge (GBHBD)"
  },
  {
   value: "Hayling Island (GBHYG)",
   label: "Hayling Island (GBHYG)"
  },
  {
   value: "Haynes (GBHYS)",
   label: "Haynes (GBHYS)"
  },
  {
   value: "Hazelwood (GBHZO)",
   label: "Hazelwood (GBHZO)"
  },
  {
   value: "Hazlemere (GBHZL)",
   label: "Hazlemere (GBHZL)"
  },
  {
   value: "Heathhall (GBHHH)",
   label: "Heathhall (GBHHH)"
  },
  {
   value: "Heaton (GBHEQ)",
   label: "Heaton (GBHEQ)"
  },
  {
   value: "Heckington (GBHKG)",
   label: "Heckington (GBHKG)"
  },
  {
   value: "Hedge End (GBHGE)",
   label: "Hedge End (GBHGE)"
  },
  {
   value: "Helford River (GBHDR)",
   label: "Helford River (GBHDR)"
  },
  {
   value: "Helmsdale (GBHMA)",
   label: "Helmsdale (GBHMA)"
  },
  {
   value: "Helmshore (GBHSO)",
   label: "Helmshore (GBHSO)"
  },
  {
   value: "Hempton (GBEMN)",
   label: "Hempton (GBEMN)"
  },
  {
   value: "Hemsby (GBHMY)",
   label: "Hemsby (GBHMY)"
  },
  {
   value: "Hemswell (GBMSL)",
   label: "Hemswell (GBMSL)"
  },
  {
   value: "Hemsworth (GBHEH)",
   label: "Hemsworth (GBHEH)"
  },
  {
   value: "Hemyock (GBHYK)",
   label: "Hemyock (GBHYK)"
  },
  {
   value: "Hendon (GBHNN)",
   label: "Hendon (GBHNN)"
  },
  {
   value: "Hendy (GBHNY)",
   label: "Hendy (GBHNY)"
  },
  {
   value: "Henfield (GBHNF)",
   label: "Henfield (GBHNF)"
  },
  {
   value: "Henley-in-Arden (GBHIA)",
   label: "Henley-in-Arden (GBHIA)"
  },
  {
   value: "Henstridge (GBRRS)",
   label: "Henstridge (GBRRS)"
  },
  {
   value: "Hersden (GBHZD)",
   label: "Hersden (GBHZD)"
  },
  {
   value: "Hersham (GBHSH)",
   label: "Hersham (GBHSH)"
  },
  {
   value: "Herstmonceux (GBHSX)",
   label: "Herstmonceux (GBHSX)"
  },
  {
   value: "Herston (GBHET)",
   label: "Herston (GBHET)"
  },
  {
   value: "Hessay (GBZBK)",
   label: "Hessay (GBZBK)"
  },
  {
   value: "Hest Bank (GBHBK)",
   label: "Hest Bank (GBHBK)"
  },
  {
   value: "Hethel (GBHEE)",
   label: "Hethel (GBHEE)"
  },
  {
   value: "Hetton le Hole (GBHLH)",
   label: "Hetton le Hole (GBHLH)"
  },
  {
   value: "Heybridge (GBHYR)",
   label: "Heybridge (GBHYR)"
  },
  {
   value: "Heytesbury (GBHTY)",
   label: "Heytesbury (GBHTY)"
  },
  {
   value: "High Ercall (GBHEC)",
   label: "High Ercall (GBHEC)"
  },
  {
   value: "High Halden (GBHGL)",
   label: "High Halden (GBHGL)"
  },
  {
   value: "High Legh (GBHHG)",
   label: "High Legh (GBHHG)"
  },
  {
   value: "High Peak (GBHPK)",
   label: "High Peak (GBHPK)"
  },
  {
   value: "Highgate\/London (GBHGG)",
   label: "Highgate\/London (GBHGG)"
  },
  {
   value: "Highpeak Junction (GBHPJ)",
   label: "Highpeak Junction (GBHPJ)"
  },
  {
   value: "Highworth (GBHGO)",
   label: "Highworth (GBHGO)"
  },
  {
   value: "Hillend (GBHID)",
   label: "Hillend (GBHID)"
  },
  {
   value: "Hillsborough (GBHBH)",
   label: "Hillsborough (GBHBH)"
  },
  {
   value: "Hillsborough (GBHLB)",
   label: "Hillsborough (GBHLB)"
  },
  {
   value: "Hilmarton (GBHMN)",
   label: "Hilmarton (GBHMN)"
  },
  {
   value: "Hilsea (GBHZA)",
   label: "Hilsea (GBHZA)"
  },
  {
   value: "Hilton (GBTNN)",
   label: "Hilton (GBTNN)"
  },
  {
   value: "Hilton (GBZBL)",
   label: "Hilton (GBZBL)"
  },
  {
   value: "Hilton\/Derby (GBHDB)",
   label: "Hilton\/Derby (GBHDB)"
  },
  {
   value: "Hindhead (GBHHD)",
   label: "Hindhead (GBHHD)"
  },
  {
   value: "Hindley Green (GBHEG)",
   label: "Hindley Green (GBHEG)"
  },
  {
   value: "Hingham (GBHGM)",
   label: "Hingham (GBHGM)"
  },
  {
   value: "Hinxworth (GBHNX)",
   label: "Hinxworth (GBHNX)"
  },
  {
   value: "Hipperholme (GBHPR)",
   label: "Hipperholme (GBHPR)"
  },
  {
   value: "Hirwaun (GBHWU)",
   label: "Hirwaun (GBHWU)"
  },
  {
   value: "Hockley (GBHKY)",
   label: "Hockley (GBHKY)"
  },
  {
   value: "Hockwold cum Wilton (GBHKW)",
   label: "Hockwold cum Wilton (GBHKW)"
  },
  {
   value: "Hogsthorpe (GBHGP)",
   label: "Hogsthorpe (GBHGP)"
  },
  {
   value: "Holborough (GBHRH)",
   label: "Holborough (GBHRH)"
  },
  {
   value: "Holbury (GBHBX)",
   label: "Holbury (GBHBX)"
  },
  {
   value: "Holford (GBHOF)",
   label: "Holford (GBHOF)"
  },
  {
   value: "Holm (GBHOM)",
   label: "Holm (GBHOM)"
  },
  {
   value: "Holme upon Spalding Moor (GBHSM)",
   label: "Holme upon Spalding Moor (GBHSM)"
  },
  {
   value: "Holmeswood (GBHOD)",
   label: "Holmeswood (GBHOD)"
  },
  {
   value: "Holmewood (GBHMD)",
   label: "Holmewood (GBHMD)"
  },
  {
   value: "Holmfield (GBHFI)",
   label: "Holmfield (GBHFI)"
  },
  {
   value: "Holt (GBHLT)",
   label: "Holt (GBHLT)"
  },
  {
   value: "Holton (GBHTX)",
   label: "Holton (GBHTX)"
  },
  {
   value: "Holton le Clay (GBHCA)",
   label: "Holton le Clay (GBHCA)"
  },
  {
   value: "Holytown (GBOYT)",
   label: "Holytown (GBOYT)"
  },
  {
   value: "Holywood (GBYLW)",
   label: "Holywood (GBYLW)"
  },
  {
   value: "Honeybourne (GBHBO)",
   label: "Honeybourne (GBHBO)"
  },
  {
   value: "Honley (GBONL)",
   label: "Honley (GBONL)"
  },
  {
   value: "Hook (GBOOK)",
   label: "Hook (GBOOK)"
  },
  {
   value: "Hook Norton (GBHKT)",
   label: "Hook Norton (GBHKT)"
  },
  {
   value: "Hooton (GBOOT)",
   label: "Hooton (GBOOT)"
  },
  {
   value: "Hope (GBHPE)",
   label: "Hope (GBHPE)"
  },
  {
   value: "Hope (GBOPE)",
   label: "Hope (GBOPE)"
  },
  {
   value: "Hope Cove (GBHPC)",
   label: "Hope Cove (GBHPC)"
  },
  {
   value: "Hopeman (GBHOP)",
   label: "Hopeman (GBHOP)"
  },
  {
   value: "Horne (GBHNE)",
   label: "Horne (GBHNE)"
  },
  {
   value: "Horningsea (GBHGS)",
   label: "Horningsea (GBHGS)"
  },
  {
   value: "Hornsea (GBHRZ)",
   label: "Hornsea (GBHRZ)"
  },
  {
   value: "Horrabridge (GBHOB)",
   label: "Horrabridge (GBHOB)"
  },
  {
   value: "Horton (GBZBM)",
   label: "Horton (GBZBM)"
  },
  {
   value: "Horton Heath (GBHHT)",
   label: "Horton Heath (GBHHT)"
  },
  {
   value: "Hoswick (GBHOS)",
   label: "Hoswick (GBHOS)"
  },
  {
   value: "Hougham (GBHGX)",
   label: "Hougham (GBHGX)"
  },
  {
   value: "Hougharry and Loch Eport (GBHGY)",
   label: "Hougharry and Loch Eport (GBHGY)"
  },
  {
   value: "Houghton (GBHUG)",
   label: "Houghton (GBHUG)"
  },
  {
   value: "Housa Voe, Papa Stour (GBHOV)",
   label: "Housa Voe, Papa Stour (GBHOV)"
  },
  {
   value: "Houton (GBHUT)",
   label: "Houton (GBHUT)"
  },
  {
   value: "Hoveringham (GBHVM)",
   label: "Hoveringham (GBHVM)"
  },
  {
   value: "Hoverton (GBNFK)",
   label: "Hoverton (GBNFK)"
  },
  {
   value: "Hoveton (GBHVT)",
   label: "Hoveton (GBHVT)"
  },
  {
   value: "Howdon (GBHOJ)",
   label: "Howdon (GBHOJ)"
  },
  {
   value: "Hugh Town (GBHWZ)",
   label: "Hugh Town (GBHWZ)"
  },
  {
   value: "Hunslet\/Leeds (GBHLU)",
   label: "Hunslet\/Leeds (GBHLU)"
  },
  {
   value: "Huntington (GBYON)",
   label: "Huntington (GBYON)"
  },
  {
   value: "Hunwick (GBHUN)",
   label: "Hunwick (GBHUN)"
  },
  {
   value: "Hurley (GBHUE)",
   label: "Hurley (GBHUE)"
  },
  {
   value: "Hurley (GBURY)",
   label: "Hurley (GBURY)"
  },
  {
   value: "Hurn (GBUUR)",
   label: "Hurn (GBUUR)"
  },
  {
   value: "Hurstburne Tarrant (GBHBN)",
   label: "Hurstburne Tarrant (GBHBN)"
  },
  {
   value: "Husborne Crawley (GBHBC)",
   label: "Husborne Crawley (GBHBC)"
  },
  {
   value: "Huthwaite (GBHHW)",
   label: "Huthwaite (GBHHW)"
  },
  {
   value: "Hutton (GBHUX)",
   label: "Hutton (GBHUX)"
  },
  {
   value: "Hutton Cranswick (GBWWW)",
   label: "Hutton Cranswick (GBWWW)"
  },
  {
   value: "Hythe (GBHYT)",
   label: "Hythe (GBHYT)"
  },
  {
   value: "Ibstock (GBTCK)",
   label: "Ibstock (GBTCK)"
  },
  {
   value: "Ickburgh (GBIBH)",
   label: "Ickburgh (GBIBH)"
  },
  {
   value: "Idlicote (GBIDC)",
   label: "Idlicote (GBIDC)"
  },
  {
   value: "Ilchester (GBICT)",
   label: "Ilchester (GBICT)"
  },
  {
   value: "Illston on the Hill (GBILH)",
   label: "Illston on the Hill (GBILH)"
  },
  {
   value: "Ilton (GBILN)",
   label: "Ilton (GBILN)"
  },
  {
   value: "Ilton (GBILO)",
   label: "Ilton (GBILO)"
  },
  {
   value: "Ingatestone (GBIGT)",
   label: "Ingatestone (GBIGT)"
  },
  {
   value: "Ingham (GBIHM)",
   label: "Ingham (GBIHM)"
  },
  {
   value: "Ingleton (GBINL)",
   label: "Ingleton (GBINL)"
  },
  {
   value: "Ingoldmells (GBIGM)",
   label: "Ingoldmells (GBIGM)"
  },
  {
   value: "Innerleithen (GBITH)",
   label: "Innerleithen (GBITH)"
  },
  {
   value: "Insch (GBISH)",
   label: "Insch (GBISH)"
  },
  {
   value: "Instow (GBINS)",
   label: "Instow (GBINS)"
  },
  {
   value: "Inverallochy (GBIAY)",
   label: "Inverallochy (GBIAY)"
  },
  {
   value: "Inveraray (GBIVR)",
   label: "Inveraray (GBIVR)"
  },
  {
   value: "Inverbervie (GBIVB)",
   label: "Inverbervie (GBIVB)"
  },
  {
   value: "Inverie (GBINR)",
   label: "Inverie (GBINR)"
  },
  {
   value: "Inverkip (GBIVK)",
   label: "Inverkip (GBIVK)"
  },
  {
   value: "Irby (GBIRB)",
   label: "Irby (GBIRB)"
  },
  {
   value: "Irchester (GBIRT)",
   label: "Irchester (GBIRT)"
  },
  {
   value: "Iron Acton (GBIAO)",
   label: "Iron Acton (GBIAO)"
  },
  {
   value: "Irvinestown (GBIVT)",
   label: "Irvinestown (GBIVT)"
  },
  {
   value: "Islandmagee (GBIMG)",
   label: "Islandmagee (GBIMG)"
  },
  {
   value: "Islay (GBISY)",
   label: "Islay (GBISY)"
  },
  {
   value: "Isle Abbotts (GBIAB)",
   label: "Isle Abbotts (GBIAB)"
  },
  {
   value: "Isle of Barra (GBIAR)",
   label: "Isle of Barra (GBIAR)"
  },
  {
   value: "Isle of Sheppey (GBIOS)",
   label: "Isle of Sheppey (GBIOS)"
  },
  {
   value: "Isle of Whithorn (GBWHH)",
   label: "Isle of Whithorn (GBWHH)"
  },
  {
   value: "Ixworth (GBIXW)",
   label: "Ixworth (GBIXW)"
  },
  {
   value: "Jamestown (GBJMS)",
   label: "Jamestown (GBJMS)"
  },
  {
   value: "Johnshaven (GBJHV)",
   label: "Johnshaven (GBJHV)"
  },
  {
   value: "Johnstonebridge (GBJTB)",
   label: "Johnstonebridge (GBJTB)"
  },
  {
   value: "Jura (GBJUR)",
   label: "Jura (GBJUR)"
  },
  {
   value: "Kallin (Ceallan), Isle of Grimsay (GBKAL)",
   label: "Kallin (Ceallan), Isle of Grimsay (GBKAL)"
  },
  {
   value: "Karcaldy (GBKAR)",
   label: "Karcaldy (GBKAR)"
  },
  {
   value: "Keady (GBKDY)",
   label: "Keady (GBKDY)"
  },
  {
   value: "Kearsley (GBKSY)",
   label: "Kearsley (GBKSY)"
  },
  {
   value: "Kegworth (GBKWO)",
   label: "Kegworth (GBKWO)"
  },
  {
   value: "Keiss (GBKES)",
   label: "Keiss (GBKES)"
  },
  {
   value: "Kellington (GBKLG)",
   label: "Kellington (GBKLG)"
  },
  {
   value: "Kelso (GBKLO)",
   label: "Kelso (GBKLO)"
  },
  {
   value: "Kelvedon (GBKVD)",
   label: "Kelvedon (GBKVD)"
  },
  {
   value: "Kemberton (GBKMB)",
   label: "Kemberton (GBKMB)"
  },
  {
   value: "Kempston (GBZBN)",
   label: "Kempston (GBZBN)"
  },
  {
   value: "Kemsing (GBKMI)",
   label: "Kemsing (GBKMI)"
  },
  {
   value: "Kencot (GBZBO)",
   label: "Kencot (GBZBO)"
  },
  {
   value: "Kenninghall (GBKNN)",
   label: "Kenninghall (GBKNN)"
  },
  {
   value: "Kennington\/London (GBKIG)",
   label: "Kennington\/London (GBKIG)"
  },
  {
   value: "Kensington\/London (GBKEN)",
   label: "Kensington\/London (GBKEN)"
  },
  {
   value: "Kensworth (GBKWT)",
   label: "Kensworth (GBKWT)"
  },
  {
   value: "Kentford (GBZBP)",
   label: "Kentford (GBZBP)"
  },
  {
   value: "Kentisbeare (GBKSB)",
   label: "Kentisbeare (GBKSB)"
  },
  {
   value: "Kentish Town West (GBKTW)",
   label: "Kentish Town West (GBKTW)"
  },
  {
   value: "Kesgrave (GBKGA)",
   label: "Kesgrave (GBKGA)"
  },
  {
   value: "Kesh (GBKSH)",
   label: "Kesh (GBKSH)"
  },
  {
   value: "Keston (GBKST)",
   label: "Keston (GBKST)"
  },
  {
   value: "Ketteringham (GBKTT)",
   label: "Ketteringham (GBKTT)"
  },
  {
   value: "Kettletoft, Sanday (GBKET)",
   label: "Kettletoft, Sanday (GBKET)"
  },
  {
   value: "Keyhaven (GBKEV)",
   label: "Keyhaven (GBKEV)"
  },
  {
   value: "Keymer (GBKEY)",
   label: "Keymer (GBKEY)"
  },
  {
   value: "Kidlington (GBKZO)",
   label: "Kidlington (GBKZO)"
  },
  {
   value: "Kilbride (GBKIL)",
   label: "Kilbride (GBKIL)"
  },
  {
   value: "Kilcreggan (GBKIC)",
   label: "Kilcreggan (GBKIC)"
  },
  {
   value: "Kilgetty (GBKLY)",
   label: "Kilgetty (GBKLY)"
  },
  {
   value: "Kilkardy (GBKRA)",
   label: "Kilkardy (GBKRA)"
  },
  {
   value: "Killinghall (GBKLL)",
   label: "Killinghall (GBKLL)"
  },
  {
   value: "Killingworth (GBKWR)",
   label: "Killingworth (GBKWR)"
  },
  {
   value: "Killough (GBKIO)",
   label: "Killough (GBKIO)"
  },
  {
   value: "Killyleagh (GBKYH)",
   label: "Killyleagh (GBKYH)"
  },
  {
   value: "Kilmacolm (GBKMN)",
   label: "Kilmacolm (GBKMN)"
  },
  {
   value: "Kilmington (GBKGO)",
   label: "Kilmington (GBKGO)"
  },
  {
   value: "Kimbolton (GBKBO)",
   label: "Kimbolton (GBKBO)"
  },
  {
   value: "Kimmeridge (GBKIM)",
   label: "Kimmeridge (GBKIM)"
  },
  {
   value: "Kimpton (GBKMT)",
   label: "Kimpton (GBKMT)"
  },
  {
   value: "Kincardine (GBKDE)",
   label: "Kincardine (GBKDE)"
  },
  {
   value: "Kinghorn (GBKHN)",
   label: "Kinghorn (GBKHN)"
  },
  {
   value: "Kings Bromley (GBREE)",
   label: "Kings Bromley (GBREE)"
  },
  {
   value: "Kings Norton (GBKGN)",
   label: "Kings Norton (GBKGN)"
  },
  {
   value: "Kingsbridge (GBKIB)",
   label: "Kingsbridge (GBKIB)"
  },
  {
   value: "Kingsbury (GBKGB)",
   label: "Kingsbury (GBKGB)"
  },
  {
   value: "Kingsbury (GBKGY)",
   label: "Kingsbury (GBKGY)"
  },
  {
   value: "Kingsley (GBXLY)",
   label: "Kingsley (GBXLY)"
  },
  {
   value: "Kingston Blount (GBZBQ)",
   label: "Kingston Blount (GBZBQ)"
  },
  {
   value: "Kingston Seymour (GBKSM)",
   label: "Kingston Seymour (GBKSM)"
  },
  {
   value: "Kingswear (GBKWE)",
   label: "Kingswear (GBKWE)"
  },
  {
   value: "Kingswells (GBKWS)",
   label: "Kingswells (GBKWS)"
  },
  {
   value: "Kingussie (GBKGU)",
   label: "Kingussie (GBKGU)"
  },
  {
   value: "Kinloch, Rum (GBKOH)",
   label: "Kinloch, Rum (GBKOH)"
  },
  {
   value: "Kinlochbervie (GBKBE)",
   label: "Kinlochbervie (GBKBE)"
  },
  {
   value: "Kinlochleven (GBKNC)",
   label: "Kinlochleven (GBKNC)"
  },
  {
   value: "Kinsley (GBKSL)",
   label: "Kinsley (GBKSL)"
  },
  {
   value: "Kinver (GBKNV)",
   label: "Kinver (GBKNV)"
  },
  {
   value: "Kippford (GBKIP)",
   label: "Kippford (GBKIP)"
  },
  {
   value: "Kirby (GBYBR)",
   label: "Kirby (GBYBR)"
  },
  {
   value: "Kirby Moorside (GBKMS)",
   label: "Kirby Moorside (GBKMS)"
  },
  {
   value: "Kirby Muxloe (GBKMO)",
   label: "Kirby Muxloe (GBKMO)"
  },
  {
   value: "Kircubbin (GBKCN)",
   label: "Kircubbin (GBKCN)"
  },
  {
   value: "Kirkby in Furness (GBKIF)",
   label: "Kirkby in Furness (GBKIF)"
  },
  {
   value: "Kirkby Misperton (GBKBM)",
   label: "Kirkby Misperton (GBKBM)"
  },
  {
   value: "Kirkconnel (GBKKN)",
   label: "Kirkconnel (GBKKN)"
  },
  {
   value: "Kirkham (GBKIK)",
   label: "Kirkham (GBKIK)"
  },
  {
   value: "Kirkheaton (GBKKH)",
   label: "Kirkheaton (GBKKH)"
  },
  {
   value: "Kirkmichael (GBKML)",
   label: "Kirkmichael (GBKML)"
  },
  {
   value: "Kirknewton (GBKIR)",
   label: "Kirknewton (GBKIR)"
  },
  {
   value: "Kirknewton (GBZBR)",
   label: "Kirknewton (GBZBR)"
  },
  {
   value: "Kirtomy (GBKRM)",
   label: "Kirtomy (GBKRM)"
  },
  {
   value: "Kirton in Lindsey (GBKRT)",
   label: "Kirton in Lindsey (GBKRT)"
  },
  {
   value: "Kishorn (GBKIS)",
   label: "Kishorn (GBKIS)"
  },
  {
   value: "Kiveton (GBVET)",
   label: "Kiveton (GBVET)"
  },
  {
   value: "Knebworth (GBKBW)",
   label: "Knebworth (GBKBW)"
  },
  {
   value: "Knighton (GBKHG)",
   label: "Knighton (GBKHG)"
  },
  {
   value: "Knighton (GBKNI)",
   label: "Knighton (GBKNI)"
  },
  {
   value: "Knighton (GBKON)",
   label: "Knighton (GBKON)"
  },
  {
   value: "Knightsbridge (GBKBG)",
   label: "Knightsbridge (GBKBG)"
  },
  {
   value: "Knockholt (GBKKO)",
   label: "Knockholt (GBKKO)"
  },
  {
   value: "Knotty Green (GBKXG)",
   label: "Knotty Green (GBKXG)"
  },
  {
   value: "Knowle (GBKOW)",
   label: "Knowle (GBKOW)"
  },
  {
   value: "Kyleakin (GBKYN)",
   label: "Kyleakin (GBKYN)"
  },
  {
   value: "Kyles of Bute (GBKYE)",
   label: "Kyles of Bute (GBKYE)"
  },
  {
   value: "Kylesku (GBKYU)",
   label: "Kylesku (GBKYU)"
  },
  {
   value: "Ladock (GBLDC)",
   label: "Ladock (GBLDC)"
  },
  {
   value: "Ladybank (GBLYK)",
   label: "Ladybank (GBLYK)"
  },
  {
   value: "Laisterdyke (GBLSY)",
   label: "Laisterdyke (GBLSY)"
  },
  {
   value: "Lamb Head (GBLBH)",
   label: "Lamb Head (GBLBH)"
  },
  {
   value: "Lambeth (GBBXE)",
   label: "Lambeth (GBBXE)"
  },
  {
   value: "Lambourn Woodlands (GBLWO)",
   label: "Lambourn Woodlands (GBLWO)"
  },
  {
   value: "Lanchester (GBXTL)",
   label: "Lanchester (GBXTL)"
  },
  {
   value: "Landford (GBLDF)",
   label: "Landford (GBLDF)"
  },
  {
   value: "Lane End (GBLEB)",
   label: "Lane End (GBLEB)"
  },
  {
   value: "Langar (GBLGR)",
   label: "Langar (GBLGR)"
  },
  {
   value: "Langley (GBLNY)",
   label: "Langley (GBLNY)"
  },
  {
   value: "Langstone (GBLSH)",
   label: "Langstone (GBLSH)"
  },
  {
   value: "Langton Matravers (GBLMS)",
   label: "Langton Matravers (GBLMS)"
  },
  {
   value: "Langwathby (GBLWY)",
   label: "Langwathby (GBLWY)"
  },
  {
   value: "Langworth (GBLOR)",
   label: "Langworth (GBLOR)"
  },
  {
   value: "Lapworth (GBLPW)",
   label: "Lapworth (GBLPW)"
  },
  {
   value: "Larbert (GBLRB)",
   label: "Larbert (GBLRB)"
  },
  {
   value: "Largo (GBLGO)",
   label: "Largo (GBLGO)"
  },
  {
   value: "Lark Hill (GBLRH)",
   label: "Lark Hill (GBLRH)"
  },
  {
   value: "Larkhall (GBLRL)",
   label: "Larkhall (GBLRL)"
  },
  {
   value: "Larkhill (GBLKL)",
   label: "Larkhill (GBLKL)"
  },
  {
   value: "Lasham (GBQLA)",
   label: "Lasham (GBQLA)"
  },
  {
   value: "Latheronwheel (GBLWL)",
   label: "Latheronwheel (GBLWL)"
  },
  {
   value: "Lauder (GBZBT)",
   label: "Lauder (GBZBT)"
  },
  {
   value: "Laurencekirk (GBLKK)",
   label: "Laurencekirk (GBLKK)"
  },
  {
   value: "Lavenham (GBLAV)",
   label: "Lavenham (GBLAV)"
  },
  {
   value: "Law (GBLAW)",
   label: "Law (GBLAW)"
  },
  {
   value: "Leadenham (GBZBU)",
   label: "Leadenham (GBZBU)"
  },
  {
   value: "Leamington (GBZBV)",
   label: "Leamington (GBZBV)"
  },
  {
   value: "Lee Moor (GBEMR)",
   label: "Lee Moor (GBEMR)"
  },
  {
   value: "Leeds (GBZBW)",
   label: "Leeds (GBZBW)"
  },
  {
   value: "Leeds ICD (GBLEE)",
   label: "Leeds ICD (GBLEE)"
  },
  {
   value: "Leeming Bar (GBMZB)",
   label: "Leeming Bar (GBMZB)"
  },
  {
   value: "Lenwade (GBZBX)",
   label: "Lenwade (GBZBX)"
  },
  {
   value: "Lepton (GBLPT)",
   label: "Lepton (GBLPT)"
  },
  {
   value: "Leven (GBLVY)",
   label: "Leven (GBLVY)"
  },
  {
   value: "Levenwick (GBLVK)",
   label: "Levenwick (GBLVK)"
  },
  {
   value: "Leverburgh, Harris (GBLVR)",
   label: "Leverburgh, Harris (GBLVR)"
  },
  {
   value: "Leyburn (GBLEY)",
   label: "Leyburn (GBLEY)"
  },
  {
   value: "Limekilns (GBLMK)",
   label: "Limekilns (GBLMK)"
  },
  {
   value: "Lindfield (GBLDI)",
   label: "Lindfield (GBLDI)"
  },
  {
   value: "Linstock (GBLSK)",
   label: "Linstock (GBLSK)"
  },
  {
   value: "Linwood (GBLIO)",
   label: "Linwood (GBLIO)"
  },
  {
   value: "Liskeard (GBLKD)",
   label: "Liskeard (GBLKD)"
  },
  {
   value: "Lisnarrick (GBLRR)",
   label: "Lisnarrick (GBLRR)"
  },
  {
   value: "Lisnaskea (GBLIN)",
   label: "Lisnaskea (GBLIN)"
  },
  {
   value: "Little Brampton (GBLBO)",
   label: "Little Brampton (GBLBO)"
  },
  {
   value: "Little Chalfont (GBBYU)",
   label: "Little Chalfont (GBBYU)"
  },
  {
   value: "Little Eaton (GBLTE)",
   label: "Little Eaton (GBLTE)"
  },
  {
   value: "Little Gransden (GBLGD)",
   label: "Little Gransden (GBLGD)"
  },
  {
   value: "Little Haven (GBLHV)",
   label: "Little Haven (GBLHV)"
  },
  {
   value: "Little Houghton (GBLHG)",
   label: "Little Houghton (GBLHG)"
  },
  {
   value: "Little Hulton (GBLHT)",
   label: "Little Hulton (GBLHT)"
  },
  {
   value: "Little Kimble (GBLKM)",
   label: "Little Kimble (GBLKM)"
  },
  {
   value: "Little Lever (GBLLV)",
   label: "Little Lever (GBLLV)"
  },
  {
   value: "Little Oakley (GBLOK)",
   label: "Little Oakley (GBLOK)"
  },
  {
   value: "Little Somborne (GBLSR)",
   label: "Little Somborne (GBLSR)"
  },
  {
   value: "Little Thurrock (GBLTK)",
   label: "Little Thurrock (GBLTK)"
  },
  {
   value: "Little Walden (GBLWD)",
   label: "Little Walden (GBLWD)"
  },
  {
   value: "Little Weighton (GBWGO)",
   label: "Little Weighton (GBWGO)"
  },
  {
   value: "Littlebourne (GBLLU)",
   label: "Littlebourne (GBLLU)"
  },
  {
   value: "Littleton (GBLJN)",
   label: "Littleton (GBLJN)"
  },
  {
   value: "Llanaber (GBLAB)",
   label: "Llanaber (GBLAB)"
  },
  {
   value: "Llanarthney (GBLTY)",
   label: "Llanarthney (GBLTY)"
  },
  {
   value: "Llanberis (GBLBI)",
   label: "Llanberis (GBLBI)"
  },
  {
   value: "Llandanwg (GBAAW)",
   label: "Llandanwg (GBAAW)"
  },
  {
   value: "Llandovery (GBLDV)",
   label: "Llandovery (GBLDV)"
  },
  {
   value: "Llandow (GBLND)",
   label: "Llandow (GBLND)"
  },
  {
   value: "Llanfairfechan (GBLFC)",
   label: "Llanfairfechan (GBLFC)"
  },
  {
   value: "Llanfrynach (GBLLF)",
   label: "Llanfrynach (GBLLF)"
  },
  {
   value: "Llanfyrnach (GBLFH)",
   label: "Llanfyrnach (GBLFH)"
  },
  {
   value: "Llangadog (GBLNG)",
   label: "Llangadog (GBLNG)"
  },
  {
   value: "Llangarron (GBLGA)",
   label: "Llangarron (GBLGA)"
  },
  {
   value: "Llangefni (GBLGI)",
   label: "Llangefni (GBLGI)"
  },
  {
   value: "Llangeinor (GBLLI)",
   label: "Llangeinor (GBLLI)"
  },
  {
   value: "Llangennech (GBLLG)",
   label: "Llangennech (GBLLG)"
  },
  {
   value: "Llangoed (GBLLE)",
   label: "Llangoed (GBLLE)"
  },
  {
   value: "Llangollen (GBLNL)",
   label: "Llangollen (GBLNL)"
  },
  {
   value: "Llanharan (GBLNR)",
   label: "Llanharan (GBLNR)"
  },
  {
   value: "Llanhilleth (GBLHI)",
   label: "Llanhilleth (GBLHI)"
  },
  {
   value: "Llanidloes (GBLLZ)",
   label: "Llanidloes (GBLLZ)"
  },
  {
   value: "Llanon (GBLLO)",
   label: "Llanon (GBLLO)"
  },
  {
   value: "Llansamlet (GBLMT)",
   label: "Llansamlet (GBLMT)"
  },
  {
   value: "Llansteffan (GBLFF)",
   label: "Llansteffan (GBLFF)"
  },
  {
   value: "Llanstephan (GBLLS)",
   label: "Llanstephan (GBLLS)"
  },
  {
   value: "Llantarnam (GBLTR)",
   label: "Llantarnam (GBLTR)"
  },
  {
   value: "Llanymynech (GBLYC)",
   label: "Llanymynech (GBLYC)"
  },
  {
   value: "Loch Buie (Mull) (GBLBE)",
   label: "Loch Buie (Mull) (GBLBE)"
  },
  {
   value: "Loch Carnan (GBLCC)",
   label: "Loch Carnan (GBLCC)"
  },
  {
   value: "Loch Long (GBLCG)",
   label: "Loch Long (GBLCG)"
  },
  {
   value: "Loch Scridain (Isle Mull) (GBLSC)",
   label: "Loch Scridain (Isle Mull) (GBLSC)"
  },
  {
   value: "Lochawe (GBLCA)",
   label: "Lochawe (GBLCA)"
  },
  {
   value: "Lochboisdale (Loch Baghasdail), South Uist (GBLBD)",
   label: "Lochboisdale (Loch Baghasdail), South Uist (GBLBD)"
  },
  {
   value: "Lochcarron (GBLCR)",
   label: "Lochcarron (GBLCR)"
  },
  {
   value: "Lochearnhead (GBLNA)",
   label: "Lochearnhead (GBLNA)"
  },
  {
   value: "Lochgelly (GBLCY)",
   label: "Lochgelly (GBLCY)"
  },
  {
   value: "Lochinver (GBLOV)",
   label: "Lochinver (GBLOV)"
  },
  {
   value: "Lochranza, Isle of Arran (GBLRZ)",
   label: "Lochranza, Isle of Arran (GBLRZ)"
  },
  {
   value: "Lochs (GBOCH)",
   label: "Lochs (GBOCH)"
  },
  {
   value: "Lockerbie (GBLKB)",
   label: "Lockerbie (GBLKB)"
  },
  {
   value: "Loddon (GBLDQ)",
   label: "Loddon (GBLDQ)"
  },
  {
   value: "Lode (GBLOZ)",
   label: "Lode (GBLOZ)"
  },
  {
   value: "Lode (GBODE)",
   label: "Lode (GBODE)"
  },
  {
   value: "Long Ditton (GBLDX)",
   label: "Long Ditton (GBLDX)"
  },
  {
   value: "Long Marston (GBLGM)",
   label: "Long Marston (GBLGM)"
  },
  {
   value: "Long Marston (GBLOM)",
   label: "Long Marston (GBLOM)"
  },
  {
   value: "Long Marston (GBLSO)",
   label: "Long Marston (GBLSO)"
  },
  {
   value: "Long Stratton (GBLRT)",
   label: "Long Stratton (GBLRT)"
  },
  {
   value: "Longborough (GBLOB)",
   label: "Longborough (GBLOB)"
  },
  {
   value: "Longbridge\/Birmingham (GBLDG)",
   label: "Longbridge\/Birmingham (GBLDG)"
  },
  {
   value: "Longcross (GBLGC)",
   label: "Longcross (GBLGC)"
  },
  {
   value: "Longfield (GBLGF)",
   label: "Longfield (GBLGF)"
  },
  {
   value: "Longford (GBLOF)",
   label: "Longford (GBLOF)"
  },
  {
   value: "Longhope, Hoy (GBLHO)",
   label: "Longhope, Hoy (GBLHO)"
  },
  {
   value: "Longtown (GBLTW)",
   label: "Longtown (GBLTW)"
  },
  {
   value: "Looe (GBLOE)",
   label: "Looe (GBLOE)"
  },
  {
   value: "Lostock Junction (GBLJU)",
   label: "Lostock Junction (GBLJU)"
  },
  {
   value: "Lostwithiel (GBLSW)",
   label: "Lostwithiel (GBLSW)"
  },
  {
   value: "Loth, Sanday (GBLTS)",
   label: "Loth, Sanday (GBLTS)"
  },
  {
   value: "Loudwater (GBLWA)",
   label: "Loudwater (GBLWA)"
  },
  {
   value: "Lound (GBLOD)",
   label: "Lound (GBLOD)"
  },
  {
   value: "Lount (GBLUN)",
   label: "Lount (GBLUN)"
  },
  {
   value: "Lower Dicker (GBLDK)",
   label: "Lower Dicker (GBLDK)"
  },
  {
   value: "Lower Farringdon (GBLFG)",
   label: "Lower Farringdon (GBLFG)"
  },
  {
   value: "Lower Weare (GBLWR)",
   label: "Lower Weare (GBLWR)"
  },
  {
   value: "Loxley (GBLXY)",
   label: "Loxley (GBLXY)"
  },
  {
   value: "Ludgershall (GBLSA)",
   label: "Ludgershall (GBLSA)"
  },
  {
   value: "Lugton (GBLUG)",
   label: "Lugton (GBLUG)"
  },
  {
   value: "Lulworth Camp (GBLUL)",
   label: "Lulworth Camp (GBLUL)"
  },
  {
   value: "Lulworth Cove (GBLWC)",
   label: "Lulworth Cove (GBLWC)"
  },
  {
   value: "Lund (GBUND)",
   label: "Lund (GBUND)"
  },
  {
   value: "Luxborough (GBLXG)",
   label: "Luxborough (GBLXG)"
  },
  {
   value: "Luxulyan (GBLUX)",
   label: "Luxulyan (GBLUX)"
  },
  {
   value: "Lybster (GBLYB)",
   label: "Lybster (GBLYB)"
  },
  {
   value: "Lyme Regis (GBLYR)",
   label: "Lyme Regis (GBLYR)"
  },
  {
   value: "Lynemouth (GBLMO)",
   label: "Lynemouth (GBLMO)"
  },
  {
   value: "Lynton (GBLYT)",
   label: "Lynton (GBLYT)"
  },
  {
   value: "Lytchett Minster (GBLCM)",
   label: "Lytchett Minster (GBLCM)"
  },
  {
   value: "Mablethorpe (GBMTP)",
   label: "Mablethorpe (GBMTP)"
  },
  {
   value: "Machynlleth (GBMNL)",
   label: "Machynlleth (GBMNL)"
  },
  {
   value: "Macmerry (GBMCM)",
   label: "Macmerry (GBMCM)"
  },
  {
   value: "Maddiston (GBMAD)",
   label: "Maddiston (GBMAD)"
  },
  {
   value: "Madeley (GBMDY)",
   label: "Madeley (GBMDY)"
  },
  {
   value: "Maerdy (GBMEY)",
   label: "Maerdy (GBMEY)"
  },
  {
   value: "Maesycwmmer (GBMYW)",
   label: "Maesycwmmer (GBMYW)"
  },
  {
   value: "Maghera (GBMHA)",
   label: "Maghera (GBMHA)"
  },
  {
   value: "Magheramason (GBMGN)",
   label: "Magheramason (GBMGN)"
  },
  {
   value: "Magherfelt (GBZBY)",
   label: "Magherfelt (GBZBY)"
  },
  {
   value: "Magilligan Point Ferry Terminal, Lough Foyle (GBMGP)",
   label: "Magilligan Point Ferry Terminal, Lough Foyle (GBMGP)"
  },
  {
   value: "Magor (GBMAG)",
   label: "Magor (GBMAG)"
  },
  {
   value: "Maida Vale\/London (GBMDV)",
   label: "Maida Vale\/London (GBMDV)"
  },
  {
   value: "Maidens (GBMAI)",
   label: "Maidens (GBMAI)"
  },
  {
   value: "Maitresse I. (GBMSD)",
   label: "Maitresse I. (GBMSD)"
  },
  {
   value: "Malborough (GBMBH)",
   label: "Malborough (GBMBH)"
  },
  {
   value: "Malvern (GBZCA)",
   label: "Malvern (GBZCA)"
  },
  {
   value: "Malvern Wells (GBMVW)",
   label: "Malvern Wells (GBMVW)"
  },
  {
   value: "Mamhilad (GBMHI)",
   label: "Mamhilad (GBMHI)"
  },
  {
   value: "Manby (GBMNY)",
   label: "Manby (GBMNY)"
  },
  {
   value: "Mancetter (GBMCR)",
   label: "Mancetter (GBMCR)"
  },
  {
   value: "Manchester Ship Canal, Salford (GBMSC)",
   label: "Manchester Ship Canal, Salford (GBMSC)"
  },
  {
   value: "Manea (GBMEA)",
   label: "Manea (GBMEA)"
  },
  {
   value: "Mansfield Woodhouse (GBMWO)",
   label: "Mansfield Woodhouse (GBMWO)"
  },
  {
   value: "Manston (GBMAN)",
   label: "Manston (GBMAN)"
  },
  {
   value: "Marchwiel (GBMWI)",
   label: "Marchwiel (GBMWI)"
  },
  {
   value: "Marchwood (GBMAW)",
   label: "Marchwood (GBMAW)"
  },
  {
   value: "Market Bosworth (GBMBT)",
   label: "Market Bosworth (GBMBT)"
  },
  {
   value: "Market Hill (GBMKL)",
   label: "Market Hill (GBMKL)"
  },
  {
   value: "Market Lavington (GBMAT)",
   label: "Market Lavington (GBMAT)"
  },
  {
   value: "Market Weighton (GBMWE)",
   label: "Market Weighton (GBMWE)"
  },
  {
   value: "Markethill (GBMRH)",
   label: "Markethill (GBMRH)"
  },
  {
   value: "Marks Tey (GBMKS)",
   label: "Marks Tey (GBMKS)"
  },
  {
   value: "Marlesford (GBMSO)",
   label: "Marlesford (GBMSO)"
  },
  {
   value: "Marrick (GBMAK)",
   label: "Marrick (GBMAK)"
  },
  {
   value: "Marsden (GBMSN)",
   label: "Marsden (GBMSN)"
  },
  {
   value: "Marshland Saint James (GBMSJ)",
   label: "Marshland Saint James (GBMSJ)"
  },
  {
   value: "Marston Magna (GBMMG)",
   label: "Marston Magna (GBMMG)"
  },
  {
   value: "Martham (GBMRM)",
   label: "Martham (GBMRM)"
  },
  {
   value: "Martlesham Heath (GBMHT)",
   label: "Martlesham Heath (GBMHT)"
  },
  {
   value: "Maryfield, Bressay (GBMRB)",
   label: "Maryfield, Bressay (GBMRB)"
  },
  {
   value: "Masham (GBMAS)",
   label: "Masham (GBMAS)"
  },
  {
   value: "Matfield (GBMAF)",
   label: "Matfield (GBMAF)"
  },
  {
   value: "Matlock Bath (GBMKB)",
   label: "Matlock Bath (GBMKB)"
  },
  {
   value: "Mattersey (GBMTY)",
   label: "Mattersey (GBMTY)"
  },
  {
   value: "Mauchline (GBEEH)",
   label: "Mauchline (GBEEH)"
  },
  {
   value: "Maulden (GBMUD)",
   label: "Maulden (GBMUD)"
  },
  {
   value: "Maylandsea (GBMYS)",
   label: "Maylandsea (GBMYS)"
  },
  {
   value: "Measham (GBMSA)",
   label: "Measham (GBMSA)"
  },
  {
   value: "Medstead (GBMES)",
   label: "Medstead (GBMES)"
  },
  {
   value: "Meikle Ferry (GBMFY)",
   label: "Meikle Ferry (GBMFY)"
  },
  {
   value: "Melbourne (GBMBE)",
   label: "Melbourne (GBMBE)"
  },
  {
   value: "Melbourne (GBMLU)",
   label: "Melbourne (GBMLU)"
  },
  {
   value: "Melmerby (GBMEM)",
   label: "Melmerby (GBMEM)"
  },
  {
   value: "Melmerby (GBMML)",
   label: "Melmerby (GBMML)"
  },
  {
   value: "Melsonby (GBZCB)",
   label: "Melsonby (GBZCB)"
  },
  {
   value: "Melton (GBMTO)",
   label: "Melton (GBMTO)"
  },
  {
   value: "Melton Constable (GBMNT)",
   label: "Melton Constable (GBMNT)"
  },
  {
   value: "Membury (GBMBU)",
   label: "Membury (GBMBU)"
  },
  {
   value: "Mereworth (GBMWH)",
   label: "Mereworth (GBMWH)"
  },
  {
   value: "Merton (GBMER)",
   label: "Merton (GBMER)"
  },
  {
   value: "Messingham (GBMSG)",
   label: "Messingham (GBMSG)"
  },
  {
   value: "Mevagissey (GBMVG)",
   label: "Mevagissey (GBMVG)"
  },
  {
   value: "Mickle Trafford (GBMKT)",
   label: "Mickle Trafford (GBMKT)"
  },
  {
   value: "Mickleton (GBMCO)",
   label: "Mickleton (GBMCO)"
  },
  {
   value: "Mid Glamorgan (GBRGN)",
   label: "Mid Glamorgan (GBRGN)"
  },
  {
   value: "Mid Yell (GBMYE)",
   label: "Mid Yell (GBMYE)"
  },
  {
   value: "Middleham (GBMDL)",
   label: "Middleham (GBMDL)"
  },
  {
   value: "Midhurst (GBMDH)",
   label: "Midhurst (GBMDH)"
  },
  {
   value: "Milford-on-Sea (GBMFS)",
   label: "Milford-on-Sea (GBMFS)"
  },
  {
   value: "Millport, Great Cumbrae (GBMLP)",
   label: "Millport, Great Cumbrae (GBMLP)"
  },
  {
   value: "Millwall (GBMWA)",
   label: "Millwall (GBMWA)"
  },
  {
   value: "Milnthorpe (GBMNP)",
   label: "Milnthorpe (GBMNP)"
  },
  {
   value: "Milton Bridge (GBZDQ)",
   label: "Milton Bridge (GBZDQ)"
  },
  {
   value: "Milton, Abingdon (GBMIO)",
   label: "Milton, Abingdon (GBMIO)"
  },
  {
   value: "Minchinhampton (GBMNA)",
   label: "Minchinhampton (GBMNA)"
  },
  {
   value: "Minster Lovell (GBMVL)",
   label: "Minster Lovell (GBMVL)"
  },
  {
   value: "Mintlaw (GBMNW)",
   label: "Mintlaw (GBMNW)"
  },
  {
   value: "Misterton (GBMIE)",
   label: "Misterton (GBMIE)"
  },
  {
   value: "Misterton (GBMST)",
   label: "Misterton (GBMST)"
  },
  {
   value: "Mitton (GBMTI)",
   label: "Mitton (GBMTI)"
  },
  {
   value: "Moaness, Hoy (GBMNS)",
   label: "Moaness, Hoy (GBMNS)"
  },
  {
   value: "Moelfre Roads (GBMRR)",
   label: "Moelfre Roads (GBMRR)"
  },
  {
   value: "Moira (GBMOA)",
   label: "Moira (GBMOA)"
  },
  {
   value: "Moira (GBMQR)",
   label: "Moira (GBMQR)"
  },
  {
   value: "Monkton (GBMKO)",
   label: "Monkton (GBMKO)"
  },
  {
   value: "Monkton (GBMNO)",
   label: "Monkton (GBMNO)"
  },
  {
   value: "Montgomery (GBMTR)",
   label: "Montgomery (GBMTR)"
  },
  {
   value: "Montgomery Trefaldwyn (GBMMY)",
   label: "Montgomery Trefaldwyn (GBMMY)"
  },
  {
   value: "Moodiesburn (GBZCC)",
   label: "Moodiesburn (GBZCC)"
  },
  {
   value: "Morden (GBZCE)",
   label: "Morden (GBZCE)"
  },
  {
   value: "Morestead (GBMTD)",
   label: "Morestead (GBMTD)"
  },
  {
   value: "Moreton on Lugg (GBMNU)",
   label: "Moreton on Lugg (GBMNU)"
  },
  {
   value: "Moreton Valence (GBMVC)",
   label: "Moreton Valence (GBMVC)"
  },
  {
   value: "Moreton-in-Marsh (GBMIM)",
   label: "Moreton-in-Marsh (GBMIM)"
  },
  {
   value: "Morfa Nefyn (GBMFN)",
   label: "Morfa Nefyn (GBMFN)"
  },
  {
   value: "Morningside (GBZEF)",
   label: "Morningside (GBZEF)"
  },
  {
   value: "Morston (GBMRS)",
   label: "Morston (GBMRS)"
  },
  {
   value: "Morton (GBMRO)",
   label: "Morton (GBMRO)"
  },
  {
   value: "Mossend (GBZCG)",
   label: "Mossend (GBZCG)"
  },
  {
   value: "Mossley Hill (GBMSS)",
   label: "Mossley Hill (GBMSS)"
  },
  {
   value: "Mossmoran (GBMMR)",
   label: "Mossmoran (GBMMR)"
  },
  {
   value: "Mottram St Andrew (GBMMA)",
   label: "Mottram St Andrew (GBMMA)"
  },
  {
   value: "Moulton (GBZCH)",
   label: "Moulton (GBZCH)"
  },
  {
   value: "Moulton (GBZGH)",
   label: "Moulton (GBZGH)"
  },
  {
   value: "Mountain Ash (Aberpennar) (GBMTA)",
   label: "Mountain Ash (Aberpennar) (GBMTA)"
  },
  {
   value: "Mousehole (GBMSH)",
   label: "Mousehole (GBMSH)"
  },
  {
   value: "Moy (GBMYO)",
   label: "Moy (GBMYO)"
  },
  {
   value: "Muasdale (GBMUA)",
   label: "Muasdale (GBMUA)"
  },
  {
   value: "Much Hadham (GBMCA)",
   label: "Much Hadham (GBMCA)"
  },
  {
   value: "Much Hoole (GBMHO)",
   label: "Much Hoole (GBMHO)"
  },
  {
   value: "Much Wenlock (GBMWK)",
   label: "Much Wenlock (GBMWK)"
  },
  {
   value: "Muirkirk (GBMKI)",
   label: "Muirkirk (GBMKI)"
  },
  {
   value: "Mullion (GBMLI)",
   label: "Mullion (GBMLI)"
  },
  {
   value: "Munlochy (GBMHY)",
   label: "Munlochy (GBMHY)"
  },
  {
   value: "Mylor (GBMYL)",
   label: "Mylor (GBMYL)"
  },
  {
   value: "Nacton (GBNCT)",
   label: "Nacton (GBNCT)"
  },
  {
   value: "Nafferton (GBNFF)",
   label: "Nafferton (GBNFF)"
  },
  {
   value: "Nailsworth (GBNWH)",
   label: "Nailsworth (GBNWH)"
  },
  {
   value: "Nanpean (GBNPA)",
   label: "Nanpean (GBNPA)"
  },
  {
   value: "Napton on the Hill (GBNNH)",
   label: "Napton on the Hill (GBNNH)"
  },
  {
   value: "Narberth (GBNBH)",
   label: "Narberth (GBNBH)"
  },
  {
   value: "Narborough (GBNBG)",
   label: "Narborough (GBNBG)"
  },
  {
   value: "Naseby (GBNSB)",
   label: "Naseby (GBNSB)"
  },
  {
   value: "Naunton (GBNNO)",
   label: "Naunton (GBNNO)"
  },
  {
   value: "Nawton (GBNAW)",
   label: "Nawton (GBNAW)"
  },
  {
   value: "Neasden (GBNDE)",
   label: "Neasden (GBNDE)"
  },
  {
   value: "Neatishead (GBNHD)",
   label: "Neatishead (GBNHD)"
  },
  {
   value: "Needham Market (GBNHM)",
   label: "Needham Market (GBNHM)"
  },
  {
   value: "Nefyn (GBNEF)",
   label: "Nefyn (GBNEF)"
  },
  {
   value: "Neilston (GBNSN)",
   label: "Neilston (GBNSN)"
  },
  {
   value: "Ness (GBNSA)",
   label: "Ness (GBNSA)"
  },
  {
   value: "Nesscliffe (GBNEC)",
   label: "Nesscliffe (GBNEC)"
  },
  {
   value: "Nether Heyford (GBNHF)",
   label: "Nether Heyford (GBNHF)"
  },
  {
   value: "Netherley (GBNLY)",
   label: "Netherley (GBNLY)"
  },
  {
   value: "Nethy Bridge (GBNBI)",
   label: "Nethy Bridge (GBNBI)"
  },
  {
   value: "New Chapel (GBNCP)",
   label: "New Chapel (GBNCP)"
  },
  {
   value: "New Hythe (GBNYH)",
   label: "New Hythe (GBNYH)"
  },
  {
   value: "New Maldon (GBZCI)",
   label: "New Maldon (GBZCI)"
  },
  {
   value: "New Mills (GBNLS)",
   label: "New Mills (GBNLS)"
  },
  {
   value: "New Mills (GBZCJ)",
   label: "New Mills (GBZCJ)"
  },
  {
   value: "New Romney (GBNRN)",
   label: "New Romney (GBNRN)"
  },
  {
   value: "Newbiggin (GBNGI)",
   label: "Newbiggin (GBNGI)"
  },
  {
   value: "Newbiggin by the Sea (GBNBC)",
   label: "Newbiggin by the Sea (GBNBC)"
  },
  {
   value: "Newcastle (GBNCS)",
   label: "Newcastle (GBNCS)"
  },
  {
   value: "Newcastle Emlyn (GBNCY)",
   label: "Newcastle Emlyn (GBNCY)"
  },
  {
   value: "Newchurch (GBNCU)",
   label: "Newchurch (GBNCU)"
  },
  {
   value: "Newent (GBNWE)",
   label: "Newent (GBNWE)"
  },
  {
   value: "Newhaven\/Edinburgh (GBNWF)",
   label: "Newhaven\/Edinburgh (GBNWF)"
  },
  {
   value: "Newick (GBNWC)",
   label: "Newick (GBNWC)"
  },
  {
   value: "Newport (GBNEP)",
   label: "Newport (GBNEP)"
  },
  {
   value: "Newport (GBNPO)",
   label: "Newport (GBNPO)"
  },
  {
   value: "Newport (GBNRT)",
   label: "Newport (GBNRT)"
  },
  {
   value: "Newton (GBNEW)",
   label: "Newton (GBNEW)"
  },
  {
   value: "Newton (GBNTO)",
   label: "Newton (GBNTO)"
  },
  {
   value: "Newton by the Sea (GBNBS)",
   label: "Newton by the Sea (GBNBS)"
  },
  {
   value: "Newton Ferrers (GBNTF)",
   label: "Newton Ferrers (GBNTF)"
  },
  {
   value: "Newtown (GBNWN)",
   label: "Newtown (GBNWN)"
  },
  {
   value: "Newtown St Boswells (GBSBW)",
   label: "Newtown St Boswells (GBSBW)"
  },
  {
   value: "Newtownstewart (GBNWW)",
   label: "Newtownstewart (GBNWW)"
  },
  {
   value: "Neyland (GBNYD)",
   label: "Neyland (GBNYD)"
  },
  {
   value: "Ninfield (GBNFI)",
   label: "Ninfield (GBNFI)"
  },
  {
   value: "Nomansland (GBNMS)",
   label: "Nomansland (GBNMS)"
  },
  {
   value: "Normandy (GBNMD)",
   label: "Normandy (GBNMD)"
  },
  {
   value: "Normanton (GBNAT)",
   label: "Normanton (GBNAT)"
  },
  {
   value: "Normanton (GBNMO)",
   label: "Normanton (GBNMO)"
  },
  {
   value: "Normanton on Soar (GBNSO)",
   label: "Normanton on Soar (GBNSO)"
  },
  {
   value: "North Baddesley (GBZCK)",
   label: "North Baddesley (GBZCK)"
  },
  {
   value: "North Cove (GBNHC)",
   label: "North Cove (GBNHC)"
  },
  {
   value: "North Finchley (GBNFC)",
   label: "North Finchley (GBNFC)"
  },
  {
   value: "North Harris (GBNHS)",
   label: "North Harris (GBNHS)"
  },
  {
   value: "North Haven, Fair Isle (GBNOH)",
   label: "North Haven, Fair Isle (GBNOH)"
  },
  {
   value: "North Hykeham (GBNHY)",
   label: "North Hykeham (GBNHY)"
  },
  {
   value: "North Killingholme (GBNKH)",
   label: "North Killingholme (GBNKH)"
  },
  {
   value: "North Lochs (GBNTL)",
   label: "North Lochs (GBNTL)"
  },
  {
   value: "North Luffenham (GBNLF)",
   label: "North Luffenham (GBNLF)"
  },
  {
   value: "North Marston (GBNMT)",
   label: "North Marston (GBNMT)"
  },
  {
   value: "North Queensferry (GBNOQ)",
   label: "North Queensferry (GBNOQ)"
  },
  {
   value: "North Roe to Hillswick (GBNRR)",
   label: "North Roe to Hillswick (GBNRR)"
  },
  {
   value: "North Ronaldsay (GBNRO)",
   label: "North Ronaldsay (GBNRO)"
  },
  {
   value: "North Scarle (GBZCL)",
   label: "North Scarle (GBZCL)"
  },
  {
   value: "North Sunderland (GBNSD)",
   label: "North Sunderland (GBNSD)"
  },
  {
   value: "North Tawton (GBNTZ)",
   label: "North Tawton (GBNTZ)"
  },
  {
   value: "North Uist (GBNUI)",
   label: "North Uist (GBNUI)"
  },
  {
   value: "North Weald Bassett\/London (GBNWL)",
   label: "North Weald Bassett\/London (GBNWL)"
  },
  {
   value: "Northbay (GBNRB)",
   label: "Northbay (GBNRB)"
  },
  {
   value: "Northiam (GBNHI)",
   label: "Northiam (GBNHI)"
  },
  {
   value: "Northleach (GBNLH)",
   label: "Northleach (GBNLH)"
  },
  {
   value: "Northmavine (GBNME)",
   label: "Northmavine (GBNME)"
  },
  {
   value: "Norton (GBNOT)",
   label: "Norton (GBNOT)"
  },
  {
   value: "Norton (GBZCM)",
   label: "Norton (GBZCM)"
  },
  {
   value: "Norton Canes (GBNCN)",
   label: "Norton Canes (GBNCN)"
  },
  {
   value: "Norton Disney (GBDSY)",
   label: "Norton Disney (GBDSY)"
  },
  {
   value: "Norwood (GBZCN)",
   label: "Norwood (GBZCN)"
  },
  {
   value: "Nutbourne (GBNBN)",
   label: "Nutbourne (GBNBN)"
  },
  {
   value: "Oare (GBOAR)",
   label: "Oare (GBOAR)"
  },
  {
   value: "Ockham (GBOHA)",
   label: "Ockham (GBOHA)"
  },
  {
   value: "Oddsta, Fetlar (GBODD)",
   label: "Oddsta, Fetlar (GBODD)"
  },
  {
   value: "Offerton (GBOTN)",
   label: "Offerton (GBOTN)"
  },
  {
   value: "Offord Cluny (GBOCY)",
   label: "Offord Cluny (GBOCY)"
  },
  {
   value: "Old Dalby (GBODL)",
   label: "Old Dalby (GBODL)"
  },
  {
   value: "Old Dornie (GBODO)",
   label: "Old Dornie (GBODO)"
  },
  {
   value: "Old Hutton (GBOHN)",
   label: "Old Hutton (GBOHN)"
  },
  {
   value: "Old Romney (GBOOY)",
   label: "Old Romney (GBOOY)"
  },
  {
   value: "Old Trafford (GBOTF)",
   label: "Old Trafford (GBOTF)"
  },
  {
   value: "Oldmeldrum (GBOMU)",
   label: "Oldmeldrum (GBOMU)"
  },
  {
   value: "Ollerton (GBOLR)",
   label: "Ollerton (GBOLR)"
  },
  {
   value: "Orford (GBORH)",
   label: "Orford (GBORH)"
  },
  {
   value: "Orkney (GBORK)",
   label: "Orkney (GBORK)"
  },
  {
   value: "Ormesby St Margaret (GBOSA)",
   label: "Ormesby St Margaret (GBOSA)"
  },
  {
   value: "Orston (GBORS)",
   label: "Orston (GBORS)"
  },
  {
   value: "Orton (GBORO)",
   label: "Orton (GBORO)"
  },
  {
   value: "Osgathorpe (GBOGP)",
   label: "Osgathorpe (GBOGP)"
  },
  {
   value: "Osmaston (GBOMT)",
   label: "Osmaston (GBOMT)"
  },
  {
   value: "Osterley Park (GBOLP)",
   label: "Osterley Park (GBOLP)"
  },
  {
   value: "Oswaldtwistle (GBOWW)",
   label: "Oswaldtwistle (GBOWW)"
  },
  {
   value: "Otterbourne (GBOBO)",
   label: "Otterbourne (GBOBO)"
  },
  {
   value: "Otternish, North Uist (GBOTR)",
   label: "Otternish, North Uist (GBOTR)"
  },
  {
   value: "Oulton Broad (GBOBR)",
   label: "Oulton Broad (GBOBR)"
  },
  {
   value: "Ower (GBOWE)",
   label: "Ower (GBOWE)"
  },
  {
   value: "Oxhill (GBOXI)",
   label: "Oxhill (GBOXI)"
  },
  {
   value: "Oxted (GBOXD)",
   label: "Oxted (GBOXD)"
  },
  {
   value: "Oxton (GBOXO)",
   label: "Oxton (GBOXO)"
  },
  {
   value: "Paddington (GBPAT)",
   label: "Paddington (GBPAT)"
  },
  {
   value: "Pagham (GBPGA)",
   label: "Pagham (GBPGA)"
  },
  {
   value: "Paglesham (GBPAG)",
   label: "Paglesham (GBPAG)"
  },
  {
   value: "Papworth Everard (GBPEV)",
   label: "Papworth Everard (GBPEV)"
  },
  {
   value: "Parham (GBPHM)",
   label: "Parham (GBPHM)"
  },
  {
   value: "Park Gate (GBPKG)",
   label: "Park Gate (GBPKG)"
  },
  {
   value: "Partney (GBZCO)",
   label: "Partney (GBZCO)"
  },
  {
   value: "Patchway (GBPWY)",
   label: "Patchway (GBPWY)"
  },
  {
   value: "Patna (GBPNA)",
   label: "Patna (GBPNA)"
  },
  {
   value: "Patricroft (GBPRF)",
   label: "Patricroft (GBPRF)"
  },
  {
   value: "Pavenham (GBDFO)",
   label: "Pavenham (GBDFO)"
  },
  {
   value: "Peacehaven (GBPHV)",
   label: "Peacehaven (GBPHV)"
  },
  {
   value: "Peapack (GBPPC)",
   label: "Peapack (GBPPC)"
  },
  {
   value: "Peasmarsh (GBPMH)",
   label: "Peasmarsh (GBPMH)"
  },
  {
   value: "Peckleton (GBPLT)",
   label: "Peckleton (GBPLT)"
  },
  {
   value: "Pembrey (GBPMY)",
   label: "Pembrey (GBPMY)"
  },
  {
   value: "Pembridge (GBPBD)",
   label: "Pembridge (GBPBD)"
  },
  {
   value: "Penberth (GBPNB)",
   label: "Penberth (GBPNB)"
  },
  {
   value: "Pen-Clawdd (GBPDD)",
   label: "Pen-Clawdd (GBPDD)"
  },
  {
   value: "Pendeen (GBPNE)",
   label: "Pendeen (GBPNE)"
  },
  {
   value: "Penderyn (GBPEY)",
   label: "Penderyn (GBPEY)"
  },
  {
   value: "Penkridge (GBPKD)",
   label: "Penkridge (GBPKD)"
  },
  {
   value: "Pennan (GBENN)",
   label: "Pennan (GBENN)"
  },
  {
   value: "Pensarn (GBPSR)",
   label: "Pensarn (GBPSR)"
  },
  {
   value: "Pentraeth (GBPAE)",
   label: "Pentraeth (GBPAE)"
  },
  {
   value: "Pentre-bâch (GBPGW)",
   label: "Pentre-bâch (GBPGW)"
  },
  {
   value: "Peterculter (GBZCP)",
   label: "Peterculter (GBZCP)"
  },
  {
   value: "Pettistree (GBPEX)",
   label: "Pettistree (GBPEX)"
  },
  {
   value: "Pettycur (GBPTC)",
   label: "Pettycur (GBPTC)"
  },
  {
   value: "Petworth (GBPTO)",
   label: "Petworth (GBPTO)"
  },
  {
   value: "Pickering (GBPKR)",
   label: "Pickering (GBPKR)"
  },
  {
   value: "Pierowall, Westray (GBPIE)",
   label: "Pierowall, Westray (GBPIE)"
  },
  {
   value: "Pinhoe (GBPHO)",
   label: "Pinhoe (GBPHO)"
  },
  {
   value: "Pipe Gate (GBPPG)",
   label: "Pipe Gate (GBPPG)"
  },
  {
   value: "Pirbright (GBPBI)",
   label: "Pirbright (GBPBI)"
  },
  {
   value: "Pitlochry (GBPLC)",
   label: "Pitlochry (GBPLC)"
  },
  {
   value: "Pittenweem (GBPWM)",
   label: "Pittenweem (GBPWM)"
  },
  {
   value: "Plaxtol (GBPXT)",
   label: "Plaxtol (GBPXT)"
  },
  {
   value: "Pleasley (GBSSE)",
   label: "Pleasley (GBSSE)"
  },
  {
   value: "Plockton (GBPLO)",
   label: "Plockton (GBPLO)"
  },
  {
   value: "Pluckley (GBPKY)",
   label: "Pluckley (GBPKY)"
  },
  {
   value: "Plympton (GBPMT)",
   label: "Plympton (GBPMT)"
  },
  {
   value: "Point, Island of Lismore (GBPOI)",
   label: "Point, Island of Lismore (GBPOI)"
  },
  {
   value: "Polebrook (GBPOL)",
   label: "Polebrook (GBPOL)"
  },
  {
   value: "Pollington (GBNGT)",
   label: "Pollington (GBNGT)"
  },
  {
   value: "Polperro (GBPLP)",
   label: "Polperro (GBPLP)"
  },
  {
   value: "Polruan (GBPLR)",
   label: "Polruan (GBPLR)"
  },
  {
   value: "Pontardulais (GBPDL)",
   label: "Pontardulais (GBPDL)"
  },
  {
   value: "Pontllanfraith (GBPNT)",
   label: "Pontllanfraith (GBPNT)"
  },
  {
   value: "Pontrilas (GBPTI)",
   label: "Pontrilas (GBPTI)"
  },
  {
   value: "Poolewe (GBPWE)",
   label: "Poolewe (GBPWE)"
  },
  {
   value: "Porlock (GBPRZ)",
   label: "Porlock (GBPRZ)"
  },
  {
   value: "Port Appin (GBPAP)",
   label: "Port Appin (GBPAP)"
  },
  {
   value: "Port Clarence (GBPOC)",
   label: "Port Clarence (GBPOC)"
  },
  {
   value: "Port Edgar (GBPEG)",
   label: "Port Edgar (GBPEG)"
  },
  {
   value: "Port Gaverne (GBPGV)",
   label: "Port Gaverne (GBPGV)"
  },
  {
   value: "Port Isaac (GBISA)",
   label: "Port Isaac (GBISA)"
  },
  {
   value: "Port Mor, Muck (GBPMR)",
   label: "Port Mor, Muck (GBPMR)"
  },
  {
   value: "Port Seton (GBPSE)",
   label: "Port Seton (GBPSE)"
  },
  {
   value: "Port William (GBPWI)",
   label: "Port William (GBPWI)"
  },
  {
   value: "Portaferry (GBPFY)",
   label: "Portaferry (GBPFY)"
  },
  {
   value: "Portavadie (GBPVD)",
   label: "Portavadie (GBPVD)"
  },
  {
   value: "Portavogie (GBPVG)",
   label: "Portavogie (GBPVG)"
  },
  {
   value: "Portballintrae (GBPBA)",
   label: "Portballintrae (GBPBA)"
  },
  {
   value: "Porth (GBPOR)",
   label: "Porth (GBPOR)"
  },
  {
   value: "Porth Colmon (GBPCO)",
   label: "Porth Colmon (GBPCO)"
  },
  {
   value: "Porthgain (GBPGI)",
   label: "Porthgain (GBPGI)"
  },
  {
   value: "Porthgwarra (GBPTG)",
   label: "Porthgwarra (GBPTG)"
  },
  {
   value: "Porthleven (GBPLV)",
   label: "Porthleven (GBPLV)"
  },
  {
   value: "Porthmadog (GBPTD)",
   label: "Porthmadog (GBPTD)"
  },
  {
   value: "Porthoustock (GBPOH)",
   label: "Porthoustock (GBPOH)"
  },
  {
   value: "Portincaple (GBPRP)",
   label: "Portincaple (GBPRP)"
  },
  {
   value: "Portknockie (GBPKN)",
   label: "Portknockie (GBPKN)"
  },
  {
   value: "Portlethen (GBPOT)",
   label: "Portlethen (GBPOT)"
  },
  {
   value: "Portloe (GBPRL)",
   label: "Portloe (GBPRL)"
  },
  {
   value: "Portmahomack (GBPMK)",
   label: "Portmahomack (GBPMK)"
  },
  {
   value: "Portmore (GBPMO)",
   label: "Portmore (GBPMO)"
  },
  {
   value: "Portnaguran and Ness (GBPRN)",
   label: "Portnaguran and Ness (GBPRN)"
  },
  {
   value: "Portnahaven (GBPNV)",
   label: "Portnahaven (GBPNV)"
  },
  {
   value: "Portnalong (GBPNG)",
   label: "Portnalong (GBPNG)"
  },
  {
   value: "Portpatrick (GBPPK)",
   label: "Portpatrick (GBPPK)"
  },
  {
   value: "Portreath (GBPRJ)",
   label: "Portreath (GBPRJ)"
  },
  {
   value: "Portscatho (GBPSC)",
   label: "Portscatho (GBPSC)"
  },
  {
   value: "Portskerra (GBPKA)",
   label: "Portskerra (GBPKA)"
  },
  {
   value: "Portsoy (GBPSY)",
   label: "Portsoy (GBPSY)"
  },
  {
   value: "Portstewart (GBPSW)",
   label: "Portstewart (GBPSW)"
  },
  {
   value: "Portwrinkle (GBPWK)",
   label: "Portwrinkle (GBPWK)"
  },
  {
   value: "Pott Shrigley (GBPSI)",
   label: "Pott Shrigley (GBPSI)"
  },
  {
   value: "Potter Heigham (GBPHG)",
   label: "Potter Heigham (GBPHG)"
  },
  {
   value: "Poulton Le Fylde (GBZCQ)",
   label: "Poulton Le Fylde (GBZCQ)"
  },
  {
   value: "Poulton-Le-Fylde (GBPLF)",
   label: "Poulton-Le-Fylde (GBPLF)"
  },
  {
   value: "Poyle (GBOYL)",
   label: "Poyle (GBOYL)"
  },
  {
   value: "Poyle (GBPLE)",
   label: "Poyle (GBPLE)"
  },
  {
   value: "Poyntington (GBPYG)",
   label: "Poyntington (GBPYG)"
  },
  {
   value: "Preesall (GBPSA)",
   label: "Preesall (GBPSA)"
  },
  {
   value: "Prenton (GBPNO)",
   label: "Prenton (GBPNO)"
  },
  {
   value: "Prenton\/Birkenhead (GBPBM)",
   label: "Prenton\/Birkenhead (GBPBM)"
  },
  {
   value: "Prestbury (GBZCR)",
   label: "Prestbury (GBZCR)"
  },
  {
   value: "Preston (GBPSO)",
   label: "Preston (GBPSO)"
  },
  {
   value: "Prestonpans (GBPPS)",
   label: "Prestonpans (GBPPS)"
  },
  {
   value: "Prestwick (GBPIK)",
   label: "Prestwick (GBPIK)"
  },
  {
   value: "Prestwood (GBPWD)",
   label: "Prestwood (GBPWD)"
  },
  {
   value: "Pt Erroll (GBRTL)",
   label: "Pt Erroll (GBRTL)"
  },
  {
   value: "Pt Glasgow (GBPGG)",
   label: "Pt Glasgow (GBPGG)"
  },
  {
   value: "Pt Gordon (GBPGD)",
   label: "Pt Gordon (GBPGD)"
  },
  {
   value: "Pt Logan (GBPOG)",
   label: "Pt Logan (GBPOG)"
  },
  {
   value: "Pt St Mary (GBPSM)",
   label: "Pt St Mary (GBPSM)"
  },
  {
   value: "Pucklechurch (GBZCS)",
   label: "Pucklechurch (GBZCS)"
  },
  {
   value: "Puddletown (GBPDN)",
   label: "Puddletown (GBPDN)"
  },
  {
   value: "Purton (GBPRO)",
   label: "Purton (GBPRO)"
  },
  {
   value: "Pwilheli (GBPHL)",
   label: "Pwilheli (GBPHL)"
  },
  {
   value: "Pwllheli (GBPWL)",
   label: "Pwllheli (GBPWL)"
  },
  {
   value: "Pye Bridge (GBPYB)",
   label: "Pye Bridge (GBPYB)"
  },
  {
   value: "Pyle (GBPYL)",
   label: "Pyle (GBPYL)"
  },
  {
   value: "Quainton (GBQTN)",
   label: "Quainton (GBQTN)"
  },
  {
   value: "Quedgeley (GBQDL)",
   label: "Quedgeley (GBQDL)"
  },
  {
   value: "Queniborough (GBQBG)",
   label: "Queniborough (GBQBG)"
  },
  {
   value: "Radley (GBRAD)",
   label: "Radley (GBRAD)"
  },
  {
   value: "Radstock (GBRSK)",
   label: "Radstock (GBRSK)"
  },
  {
   value: "Radway Green (GBRYG)",
   label: "Radway Green (GBRYG)"
  },
  {
   value: "Raglan (GBRGA)",
   label: "Raglan (GBRGA)"
  },
  {
   value: "Rainford (GBRNF)",
   label: "Rainford (GBRNF)"
  },
  {
   value: "Rainham (GBRNA)",
   label: "Rainham (GBRNA)"
  },
  {
   value: "Rainhill (GBRNH)",
   label: "Rainhill (GBRNH)"
  },
  {
   value: "Rake (GBRAK)",
   label: "Rake (GBRAK)"
  },
  {
   value: "Ramsdell (GBRML)",
   label: "Ramsdell (GBRML)"
  },
  {
   value: "Ramsden Heath (GBRDQ)",
   label: "Ramsden Heath (GBRDQ)"
  },
  {
   value: "Randalstown (GBRDT)",
   label: "Randalstown (GBRDT)"
  },
  {
   value: "Rapness, Westray (GBRAP)",
   label: "Rapness, Westray (GBRAP)"
  },
  {
   value: "Rathfriland (GBRAT)",
   label: "Rathfriland (GBRAT)"
  },
  {
   value: "Rattlesden (GBRLS)",
   label: "Rattlesden (GBRLS)"
  },
  {
   value: "Ravenglass (GBRGL)",
   label: "Ravenglass (GBRGL)"
  },
  {
   value: "Ravensthorpe (GBRVH)",
   label: "Ravensthorpe (GBRVH)"
  },
  {
   value: "Ravensthorpe Dewsbury (GBRAV)",
   label: "Ravensthorpe Dewsbury (GBRAV)"
  },
  {
   value: "Rawcliffe Bridge (GBRBD)",
   label: "Rawcliffe Bridge (GBRBD)"
  },
  {
   value: "Rawdon (GBRDW)",
   label: "Rawdon (GBRDW)"
  },
  {
   value: "Rawreth (GBRWR)",
   label: "Rawreth (GBRWR)"
  },
  {
   value: "Reay (GBREA)",
   label: "Reay (GBREA)"
  },
  {
   value: "Red Bay (GBRED)",
   label: "Red Bay (GBRED)"
  },
  {
   value: "Redbourn (GBRBN)",
   label: "Redbourn (GBRBN)"
  },
  {
   value: "Redbridge\/London (GBRBG)",
   label: "Redbridge\/London (GBRBG)"
  },
  {
   value: "Redding (GBRDI)",
   label: "Redding (GBRDI)"
  },
  {
   value: "Reddish (GBRDS)",
   label: "Reddish (GBRDS)"
  },
  {
   value: "Rednal (GBRAL)",
   label: "Rednal (GBRAL)"
  },
  {
   value: "Rednal (GBREL)",
   label: "Rednal (GBREL)"
  },
  {
   value: "Reepham (GBRPH)",
   label: "Reepham (GBRPH)"
  },
  {
   value: "Rejerrah (GBREJ)",
   label: "Rejerrah (GBREJ)"
  },
  {
   value: "Rendlesham (GBRHM)",
   label: "Rendlesham (GBRHM)"
  },
  {
   value: "Rettendon (GBRTO)",
   label: "Rettendon (GBRTO)"
  },
  {
   value: "Rhayader (GBRYA)",
   label: "Rhayader (GBRYA)"
  },
  {
   value: "Rhosneigr (GBRNE)",
   label: "Rhosneigr (GBRNE)"
  },
  {
   value: "Rhôs-on-Sea (GBRHS)",
   label: "Rhôs-on-Sea (GBRHS)"
  },
  {
   value: "Rhu (GBRHU)",
   label: "Rhu (GBRHU)"
  },
  {
   value: "Rhu Coigach Badluachrach (GBRCB)",
   label: "Rhu Coigach Badluachrach (GBRCB)"
  },
  {
   value: "Rhubodach, Isle of Bute (GBRHB)",
   label: "Rhubodach, Isle of Bute (GBRHB)"
  },
  {
   value: "Ribbleton (GBRBT)",
   label: "Ribbleton (GBRBT)"
  },
  {
   value: "Ribchester (GBIBC)",
   label: "Ribchester (GBIBC)"
  },
  {
   value: "Riccall (GBRCL)",
   label: "Riccall (GBRCL)"
  },
  {
   value: "Richborough (GBRIC)",
   label: "Richborough (GBRIC)"
  },
  {
   value: "Riddings (GBRDG)",
   label: "Riddings (GBRDG)"
  },
  {
   value: "Ridgmont (GBRDM)",
   label: "Ridgmont (GBRDM)"
  },
  {
   value: "Riding Mill (GBRGM)",
   label: "Riding Mill (GBRGM)"
  },
  {
   value: "Ripley (GBRPE)",
   label: "Ripley (GBRPE)"
  },
  {
   value: "Riseley (GBRSE)",
   label: "Riseley (GBRSE)"
  },
  {
   value: "Rishton (GBRHT)",
   label: "Rishton (GBRHT)"
  },
  {
   value: "Risley (GBRIL)",
   label: "Risley (GBRIL)"
  },
  {
   value: "Risley (GBRIS)",
   label: "Risley (GBRIS)"
  },
  {
   value: "River Dart (GBRRD)",
   label: "River Dart (GBRRD)"
  },
  {
   value: "River Fowey (GBRVF)",
   label: "River Fowey (GBRVF)"
  },
  {
   value: "Roberttown (GBRBO)",
   label: "Roberttown (GBRBO)"
  },
  {
   value: "Robin Hoods Bay (GBRBB)",
   label: "Robin Hoods Bay (GBRBB)"
  },
  {
   value: "Rocester (GBRCR)",
   label: "Rocester (GBRCR)"
  },
  {
   value: "Roche (GBROH)",
   label: "Roche (GBROH)"
  },
  {
   value: "Rock (GBROC)",
   label: "Rock (GBROC)"
  },
  {
   value: "Rock Ferry (GBRFR)",
   label: "Rock Ferry (GBRFR)"
  },
  {
   value: "Rogerstone (GBROG)",
   label: "Rogerstone (GBROG)"
  },
  {
   value: "Romney Marsh (GBROM)",
   label: "Romney Marsh (GBROM)"
  },
  {
   value: "Ropley (GBRLY)",
   label: "Ropley (GBRLY)"
  },
  {
   value: "Rosehearty (GBRTY)",
   label: "Rosehearty (GBRTY)"
  },
  {
   value: "Rosemarkie (GBRME)",
   label: "Rosemarkie (GBRME)"
  },
  {
   value: "Rosewell (GBRWL)",
   label: "Rosewell (GBRWL)"
  },
  {
   value: "Rosneath (GBRSH)",
   label: "Rosneath (GBRSH)"
  },
  {
   value: "Rossendale (GBRDA)",
   label: "Rossendale (GBRDA)"
  },
  {
   value: "Rosslea (GBRLA)",
   label: "Rosslea (GBRLA)"
  },
  {
   value: "Rostrevor (GBROR)",
   label: "Rostrevor (GBROR)"
  },
  {
   value: "Rostrevor (GBRTV)",
   label: "Rostrevor (GBRTV)"
  },
  {
   value: "Rothwell (GBRLL)",
   label: "Rothwell (GBRLL)"
  },
  {
   value: "Rousay (GBROU)",
   label: "Rousay (GBROU)"
  },
  {
   value: "Rowardennan (GBRWN)",
   label: "Rowardennan (GBRWN)"
  },
  {
   value: "Rowlands Gill (GBRGI)",
   label: "Rowlands Gill (GBRGI)"
  },
  {
   value: "Rowledge (GBRWE)",
   label: "Rowledge (GBRWE)"
  },
  {
   value: "Rowley Regis\/West Bromwich (GBRYR)",
   label: "Rowley Regis\/West Bromwich (GBRYR)"
  },
  {
   value: "Royal Tunbridge Wells (GBRTW)",
   label: "Royal Tunbridge Wells (GBRTW)"
  },
  {
   value: "Roydon (GBZCT)",
   label: "Roydon (GBZCT)"
  },
  {
   value: "Royston (GBZCU)",
   label: "Royston (GBZCU)"
  },
  {
   value: "Ruan Minor (GBRUM)",
   label: "Ruan Minor (GBRUM)"
  },
  {
   value: "Rubery (GBRBY)",
   label: "Rubery (GBRBY)"
  },
  {
   value: "Ruddington (GBRDO)",
   label: "Ruddington (GBRDO)"
  },
  {
   value: "Rudh Re Red Point (GBRDH)",
   label: "Rudh Re Red Point (GBRDH)"
  },
  {
   value: "Rudheath (GBRHE)",
   label: "Rudheath (GBRHE)"
  },
  {
   value: "Rushock (GBRUH)",
   label: "Rushock (GBRUH)"
  },
  {
   value: "Rushock (GBRUK)",
   label: "Rushock (GBRUK)"
  },
  {
   value: "Ruskington (GBRKO)",
   label: "Ruskington (GBRKO)"
  },
  {
   value: "Rustington (GBRNG)",
   label: "Rustington (GBRNG)"
  },
  {
   value: "Ryde (GBRYD)",
   label: "Ryde (GBRYD)"
  },
  {
   value: "Ryton (GBRYN)",
   label: "Ryton (GBRYN)"
  },
  {
   value: "Ryton on Dunsmore (GBRTD)",
   label: "Ryton on Dunsmore (GBRTD)"
  },
  {
   value: "Saintfield (GBSXD)",
   label: "Saintfield (GBSXD)"
  },
  {
   value: "Salcombe (GBSCB)",
   label: "Salcombe (GBSCB)"
  },
  {
   value: "Salen (GBAEN)",
   label: "Salen (GBAEN)"
  },
  {
   value: "Salford Priors (GBSDP)",
   label: "Salford Priors (GBSDP)"
  },
  {
   value: "Salfords (GBSFS)",
   label: "Salfords (GBSFS)"
  },
  {
   value: "Saltash (GBSAT)",
   label: "Saltash (GBSAT)"
  },
  {
   value: "Saltby (GBSAL)",
   label: "Saltby (GBSAL)"
  },
  {
   value: "Saltley (GBSLX)",
   label: "Saltley (GBSLX)"
  },
  {
   value: "Salwick (GBSIC)",
   label: "Salwick (GBSIC)"
  },
  {
   value: "Sampford Arundel (GBSDU)",
   label: "Sampford Arundel (GBSDU)"
  },
  {
   value: "Sand (GBSNJ)",
   label: "Sand (GBSNJ)"
  },
  {
   value: "Sandford (GBSAD)",
   label: "Sandford (GBSAD)"
  },
  {
   value: "Sandford On Thames (GBSFT)",
   label: "Sandford On Thames (GBSFT)"
  },
  {
   value: "Sandhaven and Pitullie (GBSPI)",
   label: "Sandhaven and Pitullie (GBSPI)"
  },
  {
   value: "Sandhurst (GBSUB)",
   label: "Sandhurst (GBSUB)"
  },
  {
   value: "Sandness (GBSNK)",
   label: "Sandness (GBSNK)"
  },
  {
   value: "Sandown (GBSDO)",
   label: "Sandown (GBSDO)"
  },
  {
   value: "Sandwick (GBSWC)",
   label: "Sandwick (GBSWC)"
  },
  {
   value: "Sanquhar (GBSAJ)",
   label: "Sanquhar (GBSAJ)"
  },
  {
   value: "Sark (GBSRX)",
   label: "Sark (GBSRX)"
  },
  {
   value: "Saundersfoot (GBSAU)",
   label: "Saundersfoot (GBSAU)"
  },
  {
   value: "Saxby-All-Sts (GBXAS)",
   label: "Saxby-All-Sts (GBXAS)"
  },
  {
   value: "Scalasaig, Colonsay (GBSCG)",
   label: "Scalasaig, Colonsay (GBSCG)"
  },
  {
   value: "Scalpay, Outer Hebridies (GBSCC)",
   label: "Scalpay, Outer Hebridies (GBSCC)"
  },
  {
   value: "Scapa (GBSCF)",
   label: "Scapa (GBSCF)"
  },
  {
   value: "Scarfskerry (GBSFK)",
   label: "Scarfskerry (GBSFK)"
  },
  {
   value: "Scarinish, Tiree (GBSCN)",
   label: "Scarinish, Tiree (GBSCN)"
  },
  {
   value: "Sconser, Isle of Skye (GBSCO)",
   label: "Sconser, Isle of Skye (GBSCO)"
  },
  {
   value: "Scotlandwell (GBZCV)",
   label: "Scotlandwell (GBZCV)"
  },
  {
   value: "Scourie (GBRIE)",
   label: "Scourie (GBRIE)"
  },
  {
   value: "Scrayingham (GBSYH)",
   label: "Scrayingham (GBSYH)"
  },
  {
   value: "Scropton (GBSRO)",
   label: "Scropton (GBSRO)"
  },
  {
   value: "Seacroft (GBSRF)",
   label: "Seacroft (GBSRF)"
  },
  {
   value: "Seahouses (GBSHU)",
   label: "Seahouses (GBSHU)"
  },
  {
   value: "Seal Sands (GBXSS)",
   label: "Seal Sands (GBXSS)"
  },
  {
   value: "Seamer (GBSEE)",
   label: "Seamer (GBSEE)"
  },
  {
   value: "Seaton (GBEON)",
   label: "Seaton (GBEON)"
  },
  {
   value: "Seaton Ross (GBOOS)",
   label: "Seaton Ross (GBOOS)"
  },
  {
   value: "Seaview (GBSVW)",
   label: "Seaview (GBSVW)"
  },
  {
   value: "Sedgefield (GBSGE)",
   label: "Sedgefield (GBSGE)"
  },
  {
   value: "Sefton (GBEFO)",
   label: "Sefton (GBEFO)"
  },
  {
   value: "Seghill (GBSGI)",
   label: "Seghill (GBSGI)"
  },
  {
   value: "Selborne (GBEBR)",
   label: "Selborne (GBEBR)"
  },
  {
   value: "Selkirk (GBSKK)",
   label: "Selkirk (GBSKK)"
  },
  {
   value: "Selly Oak (GBZCW)",
   label: "Selly Oak (GBZCW)"
  },
  {
   value: "Semley (GBSEY)",
   label: "Semley (GBSEY)"
  },
  {
   value: "Send (GBSEB)",
   label: "Send (GBSEB)"
  },
  {
   value: "Senghenydd (GBSDD)",
   label: "Senghenydd (GBSDD)"
  },
  {
   value: "Sennen Cove (GBSNC)",
   label: "Sennen Cove (GBSNC)"
  },
  {
   value: "Severn Beach (GBSBC)",
   label: "Severn Beach (GBSBC)"
  },
  {
   value: "Sevington (GBSVI)",
   label: "Sevington (GBSVI)"
  },
  {
   value: "Shackleford (GBSKO)",
   label: "Shackleford (GBSKO)"
  },
  {
   value: "Shandon (GBSHN)",
   label: "Shandon (GBSHN)"
  },
  {
   value: "Shanklin (GBSAI)",
   label: "Shanklin (GBSAI)"
  },
  {
   value: "Shapinsay (GBSPY)",
   label: "Shapinsay (GBSPY)"
  },
  {
   value: "Shavington (GBSVG)",
   label: "Shavington (GBSVG)"
  },
  {
   value: "Sheen (GBSEZ)",
   label: "Sheen (GBSEZ)"
  },
  {
   value: "Sheldon (GBSDQ)",
   label: "Sheldon (GBSDQ)"
  },
  {
   value: "Sheldwich (GBSEW)",
   label: "Sheldwich (GBSEW)"
  },
  {
   value: "Shelton (GBSLZ)",
   label: "Shelton (GBSLZ)"
  },
  {
   value: "Shenley Church End (GBSCE)",
   label: "Shenley Church End (GBSCE)"
  },
  {
   value: "Shepperton (GBSPP)",
   label: "Shepperton (GBSPP)"
  },
  {
   value: "Sherburn (GBSBN)",
   label: "Sherburn (GBSBN)"
  },
  {
   value: "Sherburn in Elmet (GBSBL)",
   label: "Sherburn in Elmet (GBSBL)"
  },
  {
   value: "Sherfield English (GBSEG)",
   label: "Sherfield English (GBSEG)"
  },
  {
   value: "Sheringham (GBSGM)",
   label: "Sheringham (GBSGM)"
  },
  {
   value: "Sheringham (GBSRM)",
   label: "Sheringham (GBSRM)"
  },
  {
   value: "Shetland (GBTLD)",
   label: "Shetland (GBTLD)"
  },
  {
   value: "Shieldaig (GBSHX)",
   label: "Shieldaig (GBSHX)"
  },
  {
   value: "Shieldhall (GBSEI)",
   label: "Shieldhall (GBSEI)"
  },
  {
   value: "Shifnal (GBIFN)",
   label: "Shifnal (GBIFN)"
  },
  {
   value: "Shillingford (GBSGF)",
   label: "Shillingford (GBSGF)"
  },
  {
   value: "Shillingstone (GBSIE)",
   label: "Shillingstone (GBSIE)"
  },
  {
   value: "Shilton (GBONS)",
   label: "Shilton (GBONS)"
  },
  {
   value: "Shipston on Stour (GBSSU)",
   label: "Shipston on Stour (GBSSU)"
  },
  {
   value: "Shirebrook (GBSIO)",
   label: "Shirebrook (GBSIO)"
  },
  {
   value: "Shobdon (GBEEN)",
   label: "Shobdon (GBEEN)"
  },
  {
   value: "Shoreditch (GBSRL)",
   label: "Shoreditch (GBSRL)"
  },
  {
   value: "Shoreham-by-Sea (GBESH)",
   label: "Shoreham-by-Sea (GBESH)"
  },
  {
   value: "Shotts (GBOHT)",
   label: "Shotts (GBOHT)"
  },
  {
   value: "Shotts (GBOTS)",
   label: "Shotts (GBOTS)"
  },
  {
   value: "Sible Hedingham (GBSBH)",
   label: "Sible Hedingham (GBSBH)"
  },
  {
   value: "Sibsey (GBZCX)",
   label: "Sibsey (GBZCX)"
  },
  {
   value: "Sidlesham (GBSES)",
   label: "Sidlesham (GBSES)"
  },
  {
   value: "Silverstone (GBVST)",
   label: "Silverstone (GBVST)"
  },
  {
   value: "Simonstone (GBSMO)",
   label: "Simonstone (GBSMO)"
  },
  {
   value: "Sizewell Beach (GBSZB)",
   label: "Sizewell Beach (GBSZB)"
  },
  {
   value: "Skeld (GBSKZ)",
   label: "Skeld (GBSKZ)"
  },
  {
   value: "Skerray (GBSKR)",
   label: "Skerray (GBSKR)"
  },
  {
   value: "Skewen (GBSKW)",
   label: "Skewen (GBSKW)"
  },
  {
   value: "Skinningrove (GBSGV)",
   label: "Skinningrove (GBSGV)"
  },
  {
   value: "Skipton on Swale (GBSKP)",
   label: "Skipton on Swale (GBSKP)"
  },
  {
   value: "Sleat (GBATS)",
   label: "Sleat (GBATS)"
  },
  {
   value: "Small Heath (GBSJJ)",
   label: "Small Heath (GBSJJ)"
  },
  {
   value: "Smallfield (GBSMF)",
   label: "Smallfield (GBSMF)"
  },
  {
   value: "Smarden (GBSMT)",
   label: "Smarden (GBSMT)"
  },
  {
   value: "Snailwell (GBSIW)",
   label: "Snailwell (GBSIW)"
  },
  {
   value: "Snape Bridge (GBSID)",
   label: "Snape Bridge (GBSID)"
  },
  {
   value: "Snetterton (GBSER)",
   label: "Snetterton (GBSER)"
  },
  {
   value: "Snizort (GBSZT)",
   label: "Snizort (GBSZT)"
  },
  {
   value: "Solva (Solfach) (GBSLV)",
   label: "Solva (Solfach) (GBSLV)"
  },
  {
   value: "Somerby (GBSRB)",
   label: "Somerby (GBSRB)"
  },
  {
   value: "Somersby (GBSMB)",
   label: "Somersby (GBSMB)"
  },
  {
   value: "Sompting (GBZCY)",
   label: "Sompting (GBZCY)"
  },
  {
   value: "Soulbury (GBSUU)",
   label: "Soulbury (GBSUU)"
  },
  {
   value: "South Arne (GBSUT)",
   label: "South Arne (GBSUT)"
  },
  {
   value: "South Brent (GBOUH)",
   label: "South Brent (GBOUH)"
  },
  {
   value: "South Creake (GBSUK)",
   label: "South Creake (GBSUK)"
  },
  {
   value: "South Cuan, Luing (GBLUI)",
   label: "South Cuan, Luing (GBLUI)"
  },
  {
   value: "South Gyle (GBSGY)",
   label: "South Gyle (GBSGY)"
  },
  {
   value: "South Harris (GBTRS)",
   label: "South Harris (GBTRS)"
  },
  {
   value: "South Hykeham (GBSHJ)",
   label: "South Hykeham (GBSHJ)"
  },
  {
   value: "South Killingholme (GBKSU)",
   label: "South Killingholme (GBKSU)"
  },
  {
   value: "South Lochs (GBOTC)",
   label: "South Lochs (GBOTC)"
  },
  {
   value: "South Luffenham (GBSFM)",
   label: "South Luffenham (GBSFM)"
  },
  {
   value: "South Marston (GBSMS)",
   label: "South Marston (GBSMS)"
  },
  {
   value: "South Normanton (GBSNO)",
   label: "South Normanton (GBSNO)"
  },
  {
   value: "South Petherton (GBSUP)",
   label: "South Petherton (GBSUP)"
  },
  {
   value: "South Ronaldsay (GBSRY)",
   label: "South Ronaldsay (GBSRY)"
  },
  {
   value: "South Uist and Eriskay (GBTHT)",
   label: "South Uist and Eriskay (GBTHT)"
  },
  {
   value: "South Warnborough (GBSWU)",
   label: "South Warnborough (GBSWU)"
  },
  {
   value: "Southam (GBUTH)",
   label: "Southam (GBUTH)"
  },
  {
   value: "Southborough (GBSOB)",
   label: "Southborough (GBSOB)"
  },
  {
   value: "Southend (GBSEC)",
   label: "Southend (GBSEC)"
  },
  {
   value: "Southend Municipal Apt (GBSEN)",
   label: "Southend Municipal Apt (GBSEN)"
  },
  {
   value: "Southend-on-Sea (GBSAA)",
   label: "Southend-on-Sea (GBSAA)"
  },
  {
   value: "Southfleet (GBSOF)",
   label: "Southfleet (GBSOF)"
  },
  {
   value: "Southminster (GBSSR)",
   label: "Southminster (GBSSR)"
  },
  {
   value: "Southowram (GBSUW)",
   label: "Southowram (GBSUW)"
  },
  {
   value: "Southsea (GBZDA)",
   label: "Southsea (GBZDA)"
  },
  {
   value: "Southwell (GBSUE)",
   label: "Southwell (GBSUE)"
  },
  {
   value: "Southwick (GBSHK)",
   label: "Southwick (GBSHK)"
  },
  {
   value: "Southwick (GBSIK)",
   label: "Southwick (GBSIK)"
  },
  {
   value: "Sowerby Bridge (GBSYB)",
   label: "Sowerby Bridge (GBSYB)"
  },
  {
   value: "Spilsby (GBPBY)",
   label: "Spilsby (GBPBY)"
  },
  {
   value: "St Abbs (GBABJ)",
   label: "St Abbs (GBABJ)"
  },
  {
   value: "St Agnes (GBSAG)",
   label: "St Agnes (GBSAG)"
  },
  {
   value: "St Boswells (GBSBE)",
   label: "St Boswells (GBSBE)"
  },
  {
   value: "St Brelade (GBTBR)",
   label: "St Brelade (GBTBR)"
  },
  {
   value: "St Columb Major (GBCMO)",
   label: "St Columb Major (GBCMO)"
  },
  {
   value: "St Combs and Charleston (GBSCM)",
   label: "St Combs and Charleston (GBSCM)"
  },
  {
   value: "St Dennis (GBSDE)",
   label: "St Dennis (GBSDE)"
  },
  {
   value: "St Erth (GBERT)",
   label: "St Erth (GBERT)"
  },
  {
   value: "St Harmon (GBSHZ)",
   label: "St Harmon (GBSHZ)"
  },
  {
   value: "St Helens (GBTLE)",
   label: "St Helens (GBTLE)"
  },
  {
   value: "St Ive (GBSIV)",
   label: "St Ive (GBSIV)"
  },
  {
   value: "St Ives (GBIVS)",
   label: "St Ives (GBIVS)"
  },
  {
   value: "St Just (GBSJU)",
   label: "St Just (GBSJU)"
  },
  {
   value: "St Keverne (GBSKV)",
   label: "St Keverne (GBSKV)"
  },
  {
   value: "St Martin (GBSMN)",
   label: "St Martin (GBSMN)"
  },
  {
   value: "St Marys Bay (GBSMA)",
   label: "St Marys Bay (GBSMA)"
  },
  {
   value: "St Marys Hoo (GBSMY)",
   label: "St Marys Hoo (GBSMY)"
  },
  {
   value: "St Mawes (GBSMV)",
   label: "St Mawes (GBSMV)"
  },
  {
   value: "St Minver (GBSNV)",
   label: "St Minver (GBSNV)"
  },
  {
   value: "St Monance (St Monans) (GBSMC)",
   label: "St Monance (St Monans) (GBSMC)"
  },
  {
   value: "St Neot (GBNEO)",
   label: "St Neot (GBNEO)"
  },
  {
   value: "St Nicholas at Wade (GBSCW)",
   label: "St Nicholas at Wade (GBSCW)"
  },
  {
   value: "St Ouen (GBUEN)",
   label: "St Ouen (GBUEN)"
  },
  {
   value: "St Peter Pt (GBPPO)",
   label: "St Peter Pt (GBPPO)"
  },
  {
   value: "St Peter South Elmham (GBSEM)",
   label: "St Peter South Elmham (GBSEM)"
  },
  {
   value: "St Quivox (GBSTQ)",
   label: "St Quivox (GBSTQ)"
  },
  {
   value: "St Sampson (Golant) (GBSMP)",
   label: "St Sampson (Golant) (GBSMP)"
  },
  {
   value: "St Stephen (GBSSP)",
   label: "St Stephen (GBSSP)"
  },
  {
   value: "Stackpole Quay (GBSPQ)",
   label: "Stackpole Quay (GBSPQ)"
  },
  {
   value: "Staithes (GBSTZ)",
   label: "Staithes (GBSTZ)"
  },
  {
   value: "Stalbridge (GBSRI)",
   label: "Stalbridge (GBSRI)"
  },
  {
   value: "Stamford Bridge (GBERE)",
   label: "Stamford Bridge (GBERE)"
  },
  {
   value: "Standlake (GBTND)",
   label: "Standlake (GBTND)"
  },
  {
   value: "Stanford (GBANF)",
   label: "Stanford (GBANF)"
  },
  {
   value: "Stanford-le-Hope (GBSLH)",
   label: "Stanford-le-Hope (GBSLH)"
  },
  {
   value: "Stanground (GBSGU)",
   label: "Stanground (GBSGU)"
  },
  {
   value: "Stanley (GBTNY)",
   label: "Stanley (GBTNY)"
  },
  {
   value: "Stanningley (GBZDB)",
   label: "Stanningley (GBZDB)"
  },
  {
   value: "Stanstead (GBTED)",
   label: "Stanstead (GBTED)"
  },
  {
   value: "Stanton by Dale (GBAND)",
   label: "Stanton by Dale (GBAND)"
  },
  {
   value: "Stanton Harcourt (GBSNH)",
   label: "Stanton Harcourt (GBSNH)"
  },
  {
   value: "Staple Hill (GBSTP)",
   label: "Staple Hill (GBSTP)"
  },
  {
   value: "Stapleford (GBSOD)",
   label: "Stapleford (GBSOD)"
  },
  {
   value: "Stapleford (GBSPF)",
   label: "Stapleford (GBSPF)"
  },
  {
   value: "Stapleford Abbots (GBSBA)",
   label: "Stapleford Abbots (GBSBA)"
  },
  {
   value: "Staplehurst (GBHUU)",
   label: "Staplehurst (GBHUU)"
  },
  {
   value: "Stapleton (GBSPL)",
   label: "Stapleton (GBSPL)"
  },
  {
   value: "Star (GBSAR)",
   label: "Star (GBSAR)"
  },
  {
   value: "Stathe (GBTAT)",
   label: "Stathe (GBTAT)"
  },
  {
   value: "Staunton on Wye (GBSYE)",
   label: "Staunton on Wye (GBSYE)"
  },
  {
   value: "Staveley (GBSVY)",
   label: "Staveley (GBSVY)"
  },
  {
   value: "Staverton (GBSVR)",
   label: "Staverton (GBSVR)"
  },
  {
   value: "Staxigoe (GBSXE)",
   label: "Staxigoe (GBSXE)"
  },
  {
   value: "Steeple Morden (GBSLM)",
   label: "Steeple Morden (GBSLM)"
  },
  {
   value: "Steeton (GBXST)",
   label: "Steeton (GBXST)"
  },
  {
   value: "Steventon (GBSXN)",
   label: "Steventon (GBSXN)"
  },
  {
   value: "Steventon (GBVTO)",
   label: "Steventon (GBVTO)"
  },
  {
   value: "Steyning (GBSYG)",
   label: "Steyning (GBSYG)"
  },
  {
   value: "Steynton (GBSYZ)",
   label: "Steynton (GBSYZ)"
  },
  {
   value: "Stillington (GBSGT)",
   label: "Stillington (GBSGT)"
  },
  {
   value: "Stinchcombe (GBSHC)",
   label: "Stinchcombe (GBSHC)"
  },
  {
   value: "Stockinish (GBSCH)",
   label: "Stockinish (GBSCH)"
  },
  {
   value: "Stocklake (GBSAK)",
   label: "Stocklake (GBSAK)"
  },
  {
   value: "Stockton (GBSCK)",
   label: "Stockton (GBSCK)"
  },
  {
   value: "Stoke (GBTOK)",
   label: "Stoke (GBTOK)"
  },
  {
   value: "Stoke Gifford (GBSKG)",
   label: "Stoke Gifford (GBSKG)"
  },
  {
   value: "Stoke Newington (GBSNE)",
   label: "Stoke Newington (GBSNE)"
  },
  {
   value: "Stoke Poges (GBSPG)",
   label: "Stoke Poges (GBSPG)"
  },
  {
   value: "Stokeham (GBOKE)",
   label: "Stokeham (GBOKE)"
  },
  {
   value: "Stokenchurch (GBSKH)",
   label: "Stokenchurch (GBSKH)"
  },
  {
   value: "Stokesley (GBSSL)",
   label: "Stokesley (GBSSL)"
  },
  {
   value: "Stone (GBZDC)",
   label: "Stone (GBZDC)"
  },
  {
   value: "Stoneleigh (GBSTJ)",
   label: "Stoneleigh (GBSTJ)"
  },
  {
   value: "Stoneywood (GBSYD)",
   label: "Stoneywood (GBSYD)"
  },
  {
   value: "Stony Middleton (GBSYO)",
   label: "Stony Middleton (GBSYO)"
  },
  {
   value: "Stotfold (GBSFL)",
   label: "Stotfold (GBSFL)"
  },
  {
   value: "Stourton (GBSOR)",
   label: "Stourton (GBSOR)"
  },
  {
   value: "Stourton\/Leeds (GBSYR)",
   label: "Stourton\/Leeds (GBSYR)"
  },
  {
   value: "Stow on the Wold (GBSEL)",
   label: "Stow on the Wold (GBSEL)"
  },
  {
   value: "Stowbridge (GBSBI)",
   label: "Stowbridge (GBSBI)"
  },
  {
   value: "Stradbroke (GBSDK)",
   label: "Stradbroke (GBSDK)"
  },
  {
   value: "Strangford (GBSJL)",
   label: "Strangford (GBSJL)"
  },
  {
   value: "Strathaven (GBZDE)",
   label: "Strathaven (GBZDE)"
  },
  {
   value: "Streatham (GBHTA)",
   label: "Streatham (GBHTA)"
  },
  {
   value: "Strete (GBSRZ)",
   label: "Strete (GBSRZ)"
  },
  {
   value: "Stroma (GBSOA)",
   label: "Stroma (GBSOA)"
  },
  {
   value: "Studham (GBSDA)",
   label: "Studham (GBSDA)"
  },
  {
   value: "Sturminster Newton (GBSRR)",
   label: "Sturminster Newton (GBSRR)"
  },
  {
   value: "Sturton by Stow (GBURT)",
   label: "Sturton by Stow (GBURT)"
  },
  {
   value: "Sully (GBSUY)",
   label: "Sully (GBSUY)"
  },
  {
   value: "Summercourt (GBSMU)",
   label: "Summercourt (GBSMU)"
  },
  {
   value: "Sundridge (GBSRG)",
   label: "Sundridge (GBSRG)"
  },
  {
   value: "Sutton (GBSUO)",
   label: "Sutton (GBSUO)"
  },
  {
   value: "Sutton Benger (GBSNB)",
   label: "Sutton Benger (GBSNB)"
  },
  {
   value: "Sutton on Trent (GBSRE)",
   label: "Sutton on Trent (GBSRE)"
  },
  {
   value: "Sutton St James (GBSSJ)",
   label: "Sutton St James (GBSSJ)"
  },
  {
   value: "Sutton Valence (GBSUV)",
   label: "Sutton Valence (GBSUV)"
  },
  {
   value: "Swaffham (GBSWH)",
   label: "Swaffham (GBSWH)"
  },
  {
   value: "Swallowfield (GBSFI)",
   label: "Swallowfield (GBSFI)"
  },
  {
   value: "Swalwell (GBLLL)",
   label: "Swalwell (GBLLL)"
  },
  {
   value: "Swanage (GBSWE)",
   label: "Swanage (GBSWE)"
  },
  {
   value: "Swanmore (GBSWM)",
   label: "Swanmore (GBSWM)"
  },
  {
   value: "Swaythling (GBSYT)",
   label: "Swaythling (GBSYT)"
  },
  {
   value: "Swestern (GBESE)",
   label: "Swestern (GBESE)"
  },
  {
   value: "Swillington (GBSII)",
   label: "Swillington (GBSII)"
  },
  {
   value: "Swinderby (GBSDB)",
   label: "Swinderby (GBSDB)"
  },
  {
   value: "Swineshead (GBISD)",
   label: "Swineshead (GBISD)"
  },
  {
   value: "Swinton (GBSWT)",
   label: "Swinton (GBSWT)"
  },
  {
   value: "Syde (GBYDE)",
   label: "Syde (GBYDE)"
  },
  {
   value: "Symington (GBSYX)",
   label: "Symington (GBSYX)"
  },
  {
   value: "Taddiport (GBTAD)",
   label: "Taddiport (GBTAD)"
  },
  {
   value: "Tadley (GBTDY)",
   label: "Tadley (GBTDY)"
  },
  {
   value: "Tain (GBTIN)",
   label: "Tain (GBTIN)"
  },
  {
   value: "Takeley (GBTKY)",
   label: "Takeley (GBTKY)"
  },
  {
   value: "Talbot Green (GBTEZ)",
   label: "Talbot Green (GBTEZ)"
  },
  {
   value: "Talmine (GBTLN)",
   label: "Talmine (GBTLN)"
  },
  {
   value: "Tankersley (GBTKL)",
   label: "Tankersley (GBTKL)"
  },
  {
   value: "Tarbert (GBTAR)",
   label: "Tarbert (GBTAR)"
  },
  {
   value: "Tarleton (GBTLT)",
   label: "Tarleton (GBTLT)"
  },
  {
   value: "Tarvin (GBTRV)",
   label: "Tarvin (GBTRV)"
  },
  {
   value: "Tatsfield (GBTTF)",
   label: "Tatsfield (GBTTF)"
  },
  {
   value: "Tattenhall (GBTTH)",
   label: "Tattenhall (GBTTH)"
  },
  {
   value: "Taverham (GBTAV)",
   label: "Taverham (GBTAV)"
  },
  {
   value: "Tawstock (GBTWO)",
   label: "Tawstock (GBTWO)"
  },
  {
   value: "Tayinloan (GBTAI)",
   label: "Tayinloan (GBTAI)"
  },
  {
   value: "Tayvallich (GBTLI)",
   label: "Tayvallich (GBTLI)"
  },
  {
   value: "Team Valley\/Gateshead (GBTVY)",
   label: "Team Valley\/Gateshead (GBTVY)"
  },
  {
   value: "Tebay (GBTBA)",
   label: "Tebay (GBTBA)"
  },
  {
   value: "Temple Sowerby (GBTEM)",
   label: "Temple Sowerby (GBTEM)"
  },
  {
   value: "Tenbury (GBENB)",
   label: "Tenbury (GBENB)"
  },
  {
   value: "Tenbury Wells (GBTYW)",
   label: "Tenbury Wells (GBTYW)"
  },
  {
   value: "Tenby (Dinbych-y-pysgod) (GBTEN)",
   label: "Tenby (Dinbych-y-pysgod) (GBTEN)"
  },
  {
   value: "Tendring (GBRIG)",
   label: "Tendring (GBRIG)"
  },
  {
   value: "Teversham (GBTVH)",
   label: "Teversham (GBTVH)"
  },
  {
   value: "Thakeham (GBKHA)",
   label: "Thakeham (GBKHA)"
  },
  {
   value: "Thamesmead (GBMMD)",
   label: "Thamesmead (GBMMD)"
  },
  {
   value: "Tharston (GBTST)",
   label: "Tharston (GBTST)"
  },
  {
   value: "The Forties (GBFTI)",
   label: "The Forties (GBFTI)"
  },
  {
   value: "Theale (GBTAL)",
   label: "Theale (GBTAL)"
  },
  {
   value: "Thorganby (GBZDF)",
   label: "Thorganby (GBZDF)"
  },
  {
   value: "Thorganby (GBZDG)",
   label: "Thorganby (GBZDG)"
  },
  {
   value: "Thornborough (GBTBH)",
   label: "Thornborough (GBTBH)"
  },
  {
   value: "Thornbury (GBTBB)",
   label: "Thornbury (GBTBB)"
  },
  {
   value: "Thorney (GBTHY)",
   label: "Thorney (GBTHY)"
  },
  {
   value: "Thornham (GBTRM)",
   label: "Thornham (GBTRM)"
  },
  {
   value: "Thornhill (GBTRL)",
   label: "Thornhill (GBTRL)"
  },
  {
   value: "Thornley (GBNLE)",
   label: "Thornley (GBNLE)"
  },
  {
   value: "Thornton le Dale (GBTDA)",
   label: "Thornton le Dale (GBTDA)"
  },
  {
   value: "Thornwood Common (GBTWM)",
   label: "Thornwood Common (GBTWM)"
  },
  {
   value: "Thorpe (GBTRP)",
   label: "Thorpe (GBTRP)"
  },
  {
   value: "Thorpeness (GBNSS)",
   label: "Thorpeness (GBNSS)"
  },
  {
   value: "Thorrington (GBTGN)",
   label: "Thorrington (GBTGN)"
  },
  {
   value: "Threapwood (GBTPD)",
   label: "Threapwood (GBTPD)"
  },
  {
   value: "Thundersley (GBRSL)",
   label: "Thundersley (GBRSL)"
  },
  {
   value: "Thurlby (GBTRB)",
   label: "Thurlby (GBTRB)"
  },
  {
   value: "Thurnscoe (GBFUU)",
   label: "Thurnscoe (GBFUU)"
  },
  {
   value: "Tighnabruaich (GBTIG)",
   label: "Tighnabruaich (GBTIG)"
  },
  {
   value: "Tilford (GBTFO)",
   label: "Tilford (GBTFO)"
  },
  {
   value: "Tillcoultry (GBTLR)",
   label: "Tillcoultry (GBTLR)"
  },
  {
   value: "Tillicoultry (GBTIT)",
   label: "Tillicoultry (GBTIT)"
  },
  {
   value: "Tillington (GBTTO)",
   label: "Tillington (GBTTO)"
  },
  {
   value: "Tilton on the Hill (GBTHL)",
   label: "Tilton on the Hill (GBTHL)"
  },
  {
   value: "Timsbury (GBTIM)",
   label: "Timsbury (GBTIM)"
  },
  {
   value: "Tingewick (GBTGE)",
   label: "Tingewick (GBTGE)"
  },
  {
   value: "Tingwall (GBTNG)",
   label: "Tingwall (GBTNG)"
  },
  {
   value: "Tiptree (GBTIP)",
   label: "Tiptree (GBTIP)"
  },
  {
   value: "Tirphil (GBTIR)",
   label: "Tirphil (GBTIR)"
  },
  {
   value: "Tisbury (GBTSY)",
   label: "Tisbury (GBTSY)"
  },
  {
   value: "Titchfield (GBTID)",
   label: "Titchfield (GBTID)"
  },
  {
   value: "Tividale (GBTVD)",
   label: "Tividale (GBTVD)"
  },
  {
   value: "Tobermore (GBTBE)",
   label: "Tobermore (GBTBE)"
  },
  {
   value: "Toberonochy (GBTBN)",
   label: "Toberonochy (GBTBN)"
  },
  {
   value: "Todber (GBTDB)",
   label: "Todber (GBTDB)"
  },
  {
   value: "Toft (GBTFT)",
   label: "Toft (GBTFT)"
  },
  {
   value: "Tong (GBTNO)",
   label: "Tong (GBTNO)"
  },
  {
   value: "Tonypandy (GBTPY)",
   label: "Tonypandy (GBTPY)"
  },
  {
   value: "Torbay\/Paignton (GBTBY)",
   label: "Torbay\/Paignton (GBTBY)"
  },
  {
   value: "Torphichen (GBTPH)",
   label: "Torphichen (GBTPH)"
  },
  {
   value: "Torphins (GBTPI)",
   label: "Torphins (GBTPI)"
  },
  {
   value: "Torpoint (GBTPO)",
   label: "Torpoint (GBTPO)"
  },
  {
   value: "Torridon (GBTRD)",
   label: "Torridon (GBTRD)"
  },
  {
   value: "Tostock (GBTTK)",
   label: "Tostock (GBTTK)"
  },
  {
   value: "Tottington (GBZDH)",
   label: "Tottington (GBZDH)"
  },
  {
   value: "Trearddur (GBTRR)",
   label: "Trearddur (GBTRR)"
  },
  {
   value: "Treforest (GBTFS)",
   label: "Treforest (GBTFS)"
  },
  {
   value: "Tregaron (GBTRG)",
   label: "Tregaron (GBTRG)"
  },
  {
   value: "Trelawnyd (GBTRW)",
   label: "Trelawnyd (GBTRW)"
  },
  {
   value: "Trentham (GBTTM)",
   label: "Trentham (GBTTM)"
  },
  {
   value: "Tudweiliog (GBTDI)",
   label: "Tudweiliog (GBTDI)"
  },
  {
   value: "Tunstead (GBTSE)",
   label: "Tunstead (GBTSE)"
  },
  {
   value: "Tupton (GBTPT)",
   label: "Tupton (GBTPT)"
  },
  {
   value: "Turriff (GBTRF)",
   label: "Turriff (GBTRF)"
  },
  {
   value: "Tutshill (GBTSI)",
   label: "Tutshill (GBTSI)"
  },
  {
   value: "Twyford (GBTWY)",
   label: "Twyford (GBTWY)"
  },
  {
   value: "Twyford (GBTYF)",
   label: "Twyford (GBTYF)"
  },
  {
   value: "Tyseley (GBTYY)",
   label: "Tyseley (GBTYY)"
  },
  {
   value: "Uffculme (GBUFC)",
   label: "Uffculme (GBUFC)"
  },
  {
   value: "Ulceby (GBULY)",
   label: "Ulceby (GBULY)"
  },
  {
   value: "Ulsta, Yell (GBULS)",
   label: "Ulsta, Yell (GBULS)"
  },
  {
   value: "Ulva Ferry (GBULF)",
   label: "Ulva Ferry (GBULF)"
  },
  {
   value: "Upholland (GBUPH)",
   label: "Upholland (GBUPH)"
  },
  {
   value: "Upper Dean (GBUPP)",
   label: "Upper Dean (GBUPP)"
  },
  {
   value: "Upper Froyle (GBUFY)",
   label: "Upper Froyle (GBUFY)"
  },
  {
   value: "Upper Hartfield (GBUHD)",
   label: "Upper Hartfield (GBUHD)"
  },
  {
   value: "Upper Holloway (GBUHL)",
   label: "Upper Holloway (GBUHL)"
  },
  {
   value: "Upper Poppleton (GBUPL)",
   label: "Upper Poppleton (GBUPL)"
  },
  {
   value: "Uppingham (GBUPI)",
   label: "Uppingham (GBUPI)"
  },
  {
   value: "Upshire (GBUPS)",
   label: "Upshire (GBUPS)"
  },
  {
   value: "Upton (GBUOT)",
   label: "Upton (GBUOT)"
  },
  {
   value: "Upton (GBUPN)",
   label: "Upton (GBUPN)"
  },
  {
   value: "Upton (GBUPO)",
   label: "Upton (GBUPO)"
  },
  {
   value: "Usk (GBUSK)",
   label: "Usk (GBUSK)"
  },
  {
   value: "Uyeasound, Unst (GBUYE)",
   label: "Uyeasound, Unst (GBUYE)"
  },
  {
   value: "Vale of Leven (GBVAL)",
   label: "Vale of Leven (GBVAL)"
  },
  {
   value: "Varg field (GBVGI)",
   label: "Varg field (GBVGI)"
  },
  {
   value: "Ventnor (GBVEN)",
   label: "Ventnor (GBVEN)"
  },
  {
   value: "Vidlin (GBVID)",
   label: "Vidlin (GBVID)"
  },
  {
   value: "Voe (GBVOE)",
   label: "Voe (GBVOE)"
  },
  {
   value: "Wadhurst (GBWDU)",
   label: "Wadhurst (GBWDU)"
  },
  {
   value: "Wainfleet Bank (GBWFB)",
   label: "Wainfleet Bank (GBWFB)"
  },
  {
   value: "Walberton (GBWBO)",
   label: "Walberton (GBWBO)"
  },
  {
   value: "Walgrave (GBWJV)",
   label: "Walgrave (GBWJV)"
  },
  {
   value: "Walker (GBWLK)",
   label: "Walker (GBWLK)"
  },
  {
   value: "Wallesbourne Hastings (GBQGT)",
   label: "Wallesbourne Hastings (GBQGT)"
  },
  {
   value: "Walls (GBLOY)",
   label: "Walls (GBLOY)"
  },
  {
   value: "Walls (GBWLZ)",
   label: "Walls (GBWLZ)"
  },
  {
   value: "Walsgrave on Sowe (GBWGW)",
   label: "Walsgrave on Sowe (GBWGW)"
  },
  {
   value: "Waltham Chase (GBWLC)",
   label: "Waltham Chase (GBWLC)"
  },
  {
   value: "Walton (GBWLO)",
   label: "Walton (GBWLO)"
  },
  {
   value: "Walworth\/London (GBWWH)",
   label: "Walworth\/London (GBWWH)"
  },
  {
   value: "Wardington (GBWOX)",
   label: "Wardington (GBWOX)"
  },
  {
   value: "Wardle (GBWRE)",
   label: "Wardle (GBWRE)"
  },
  {
   value: "Warfield (GBWFL)",
   label: "Warfield (GBWFL)"
  },
  {
   value: "Wargrave (GBWGV)",
   label: "Wargrave (GBWGV)"
  },
  {
   value: "Warkworth (GBWKO)",
   label: "Warkworth (GBWKO)"
  },
  {
   value: "Warmley (GBWMY)",
   label: "Warmley (GBWMY)"
  },
  {
   value: "Warndon (GBWND)",
   label: "Warndon (GBWND)"
  },
  {
   value: "Warnham (GBWRA)",
   label: "Warnham (GBWRA)"
  },
  {
   value: "Warton (GBWRL)",
   label: "Warton (GBWRL)"
  },
  {
   value: "Waterbeach (GBWBE)",
   label: "Waterbeach (GBWBE)"
  },
  {
   value: "Waterfoot (GBFUC)",
   label: "Waterfoot (GBFUC)"
  },
  {
   value: "Waterfoot (GBWFT)",
   label: "Waterfoot (GBWFT)"
  },
  {
   value: "Waterford (GBWRF)",
   label: "Waterford (GBWRF)"
  },
  {
   value: "Watlington (GBWXF)",
   label: "Watlington (GBWXF)"
  },
  {
   value: "Wear Head (GBWHD)",
   label: "Wear Head (GBWHD)"
  },
  {
   value: "Weare (GBWAE)",
   label: "Weare (GBWAE)"
  },
  {
   value: "Wedmore (GBWEO)",
   label: "Wedmore (GBWEO)"
  },
  {
   value: "Wellesbourne (GBWSU)",
   label: "Wellesbourne (GBWSU)"
  },
  {
   value: "Welling (GBWEG)",
   label: "Welling (GBWEG)"
  },
  {
   value: "Wellington (GBWNT)",
   label: "Wellington (GBWNT)"
  },
  {
   value: "Wembworthy (GBWWY)",
   label: "Wembworthy (GBWWY)"
  },
  {
   value: "Wendover (GBWDO)",
   label: "Wendover (GBWDO)"
  },
  {
   value: "Wentworth (GBWEW)",
   label: "Wentworth (GBWEW)"
  },
  {
   value: "West Auckland (GBWAX)",
   label: "West Auckland (GBWAX)"
  },
  {
   value: "West Bay (GBWYX)",
   label: "West Bay (GBWYX)"
  },
  {
   value: "West Boldon (GBEBD)",
   label: "West Boldon (GBEBD)"
  },
  {
   value: "West Burrafirth (GBWBF)",
   label: "West Burrafirth (GBWBF)"
  },
  {
   value: "West Chiltington (GBCWH)",
   label: "West Chiltington (GBCWH)"
  },
  {
   value: "West Dereham (GBWTA)",
   label: "West Dereham (GBWTA)"
  },
  {
   value: "West Grinstead (GBWGD)",
   label: "West Grinstead (GBWGD)"
  },
  {
   value: "West Hanney (GBWHN)",
   label: "West Hanney (GBWHN)"
  },
  {
   value: "West Harptree (GBARP)",
   label: "West Harptree (GBARP)"
  },
  {
   value: "West Hoathly (GBWAH)",
   label: "West Hoathly (GBWAH)"
  },
  {
   value: "West Horsley (GBTOY)",
   label: "West Horsley (GBTOY)"
  },
  {
   value: "West Kingsdown (GBWKS)",
   label: "West Kingsdown (GBWKS)"
  },
  {
   value: "West Linton (GBWLI)",
   label: "West Linton (GBWLI)"
  },
  {
   value: "West Loch Tarbert (GBWRB)",
   label: "West Loch Tarbert (GBWRB)"
  },
  {
   value: "West Mainland (GBWMD)",
   label: "West Mainland (GBWMD)"
  },
  {
   value: "West Midlands (GBWXT)",
   label: "West Midlands (GBWXT)"
  },
  {
   value: "West Molesey (GBWMO)",
   label: "West Molesey (GBWMO)"
  },
  {
   value: "West Moors (GBWMR)",
   label: "West Moors (GBWMR)"
  },
  {
   value: "West Norwood (GBWRW)",
   label: "West Norwood (GBWRW)"
  },
  {
   value: "West Runton (GBWUN)",
   label: "West Runton (GBWUN)"
  },
  {
   value: "West Wemyss (GBWWE)",
   label: "West Wemyss (GBWWE)"
  },
  {
   value: "West Wickham (GBWWC)",
   label: "West Wickham (GBWWC)"
  },
  {
   value: "Westbury on Severn (GBWYS)",
   label: "Westbury on Severn (GBWYS)"
  },
  {
   value: "Westcott (GBWCO)",
   label: "Westcott (GBWCO)"
  },
  {
   value: "Westerleigh (GBWTE)",
   label: "Westerleigh (GBWTE)"
  },
  {
   value: "Westfield (GBWTI)",
   label: "Westfield (GBWTI)"
  },
  {
   value: "Westgate (GBWXW)",
   label: "Westgate (GBWXW)"
  },
  {
   value: "Westhill (GBWSI)",
   label: "Westhill (GBWSI)"
  },
  {
   value: "Weston Favell (GBWFV)",
   label: "Weston Favell (GBWFV)"
  },
  {
   value: "Weston upon Trent (GBWUT)",
   label: "Weston upon Trent (GBWUT)"
  },
  {
   value: "Westonzoyland (GBZOY)",
   label: "Westonzoyland (GBZOY)"
  },
  {
   value: "Wetheringsett (GBRWS)",
   label: "Wetheringsett (GBRWS)"
  },
  {
   value: "Weybourne (GBWYO)",
   label: "Weybourne (GBWYO)"
  },
  {
   value: "Whinnyfold (GBWNL)",
   label: "Whinnyfold (GBWNL)"
  },
  {
   value: "Whissonsett (GBWHX)",
   label: "Whissonsett (GBWHX)"
  },
  {
   value: "Whiston (GBWIO)",
   label: "Whiston (GBWIO)"
  },
  {
   value: "Whitby (GBWYT)",
   label: "Whitby (GBWYT)"
  },
  {
   value: "Whitchurch (GBWCC)",
   label: "Whitchurch (GBWCC)"
  },
  {
   value: "Whitchurch (GBWUC)",
   label: "Whitchurch (GBWUC)"
  },
  {
   value: "Whitcombe (GBWCB)",
   label: "Whitcombe (GBWCB)"
  },
  {
   value: "White Hill Point (GBWPN)",
   label: "White Hill Point (GBWPN)"
  },
  {
   value: "White Ladies Aston (GBWAS)",
   label: "White Ladies Aston (GBWAS)"
  },
  {
   value: "Whitehead (GBWHE)",
   label: "Whitehead (GBWHE)"
  },
  {
   value: "Whitehills (GBHTS)",
   label: "Whitehills (GBHTS)"
  },
  {
   value: "Whiteinch\/Glasgow (GBWHJ)",
   label: "Whiteinch\/Glasgow (GBWHJ)"
  },
  {
   value: "Whitfield (GBWFE)",
   label: "Whitfield (GBWFE)"
  },
  {
   value: "Whitley (GBITY)",
   label: "Whitley (GBITY)"
  },
  {
   value: "Whitney (GBYNT)",
   label: "Whitney (GBYNT)"
  },
  {
   value: "Whitrigg (GBWGG)",
   label: "Whitrigg (GBWGG)"
  },
  {
   value: "Whittlesey (GBWTX)",
   label: "Whittlesey (GBWTX)"
  },
  {
   value: "Whitwell (GBZDI)",
   label: "Whitwell (GBZDI)"
  },
  {
   value: "Whitwick (GBWWI)",
   label: "Whitwick (GBWWI)"
  },
  {
   value: "Whitwood (GBWWX)",
   label: "Whitwood (GBWWX)"
  },
  {
   value: "Wick (GBWCK)",
   label: "Wick (GBWCK)"
  },
  {
   value: "Wickham (GBWKM)",
   label: "Wickham (GBWKM)"
  },
  {
   value: "Wickhamford (GBWKH)",
   label: "Wickhamford (GBWKH)"
  },
  {
   value: "Wickwar (GBWWR)",
   label: "Wickwar (GBWWR)"
  },
  {
   value: "Willersey (GBWIY)",
   label: "Willersey (GBWIY)"
  },
  {
   value: "Willesden (GBESD)",
   label: "Willesden (GBESD)"
  },
  {
   value: "Willington (GBZDJ)",
   label: "Willington (GBZDJ)"
  },
  {
   value: "Williton (GBWIT)",
   label: "Williton (GBWIT)"
  },
  {
   value: "Wilmington (GBWMT)",
   label: "Wilmington (GBWMT)"
  },
  {
   value: "Wilsden (GBLSD)",
   label: "Wilsden (GBLSD)"
  },
  {
   value: "Wilstead (GBZDK)",
   label: "Wilstead (GBZDK)"
  },
  {
   value: "Wiltshire (GBWIE)",
   label: "Wiltshire (GBWIE)"
  },
  {
   value: "Wimblington (GBWBL)",
   label: "Wimblington (GBWBL)"
  },
  {
   value: "Wimborne St Giles (GBWGI)",
   label: "Wimborne St Giles (GBWGI)"
  },
  {
   value: "Wimeborne (GBMBN)",
   label: "Wimeborne (GBMBN)"
  },
  {
   value: "Winchcombe (GBWIB)",
   label: "Winchcombe (GBWIB)"
  },
  {
   value: "Winchmore Hill (GBWEH)",
   label: "Winchmore Hill (GBWEH)"
  },
  {
   value: "Winscombe (GBWNO)",
   label: "Winscombe (GBWNO)"
  },
  {
   value: "Winsford (GBZDL)",
   label: "Winsford (GBZDL)"
  },
  {
   value: "Winterbourne (GBWTU)",
   label: "Winterbourne (GBWTU)"
  },
  {
   value: "Winterbourne Kingston (GBWEK)",
   label: "Winterbourne Kingston (GBWEK)"
  },
  {
   value: "Winterton (GBIRO)",
   label: "Winterton (GBIRO)"
  },
  {
   value: "Wintringham (GBINT)",
   label: "Wintringham (GBINT)"
  },
  {
   value: "Wirswall (GBWWA)",
   label: "Wirswall (GBWWA)"
  },
  {
   value: "Witchford (GBWCF)",
   label: "Witchford (GBWCF)"
  },
  {
   value: "Withernsea (GBWEX)",
   label: "Withernsea (GBWEX)"
  },
  {
   value: "Witley (GBWTY)",
   label: "Witley (GBWTY)"
  },
  {
   value: "Wix (GBWIX)",
   label: "Wix (GBWIX)"
  },
  {
   value: "Wollaston (GBOTO)",
   label: "Wollaston (GBOTO)"
  },
  {
   value: "Wollaston (GBWOZ)",
   label: "Wollaston (GBWOZ)"
  },
  {
   value: "Wolvey (GBWUF)",
   label: "Wolvey (GBWUF)"
  },
  {
   value: "Wolvey (GBWVY)",
   label: "Wolvey (GBWVY)"
  },
  {
   value: "Wombwell (GBWBW)",
   label: "Wombwell (GBWBW)"
  },
  {
   value: "Woodbury Salterton (GBWSA)",
   label: "Woodbury Salterton (GBWSA)"
  },
  {
   value: "Woodchester (GBWOC)",
   label: "Woodchester (GBWOC)"
  },
  {
   value: "Woodford (GBWOF)",
   label: "Woodford (GBWOF)"
  },
  {
   value: "Woodley (GBWDE)",
   label: "Woodley (GBWDE)"
  },
  {
   value: "Woodmansey (GBWNY)",
   label: "Woodmansey (GBWNY)"
  },
  {
   value: "Woodnewton (GBWDW)",
   label: "Woodnewton (GBWDW)"
  },
  {
   value: "Woolaston (GBOSO)",
   label: "Woolaston (GBOSO)"
  },
  {
   value: "Wooler (GBWLR)",
   label: "Wooler (GBWLR)"
  },
  {
   value: "Wootton (GBZDM)",
   label: "Wootton (GBZDM)"
  },
  {
   value: "Worcester Park (GBWPK)",
   label: "Worcester Park (GBWPK)"
  },
  {
   value: "Worminghall (GBWMH)",
   label: "Worminghall (GBWMH)"
  },
  {
   value: "Wormington (GBWWO)",
   label: "Wormington (GBWWO)"
  },
  {
   value: "Wormley (GBWME)",
   label: "Wormley (GBWME)"
  },
  {
   value: "Worth Matravers (GBWMV)",
   label: "Worth Matravers (GBWMV)"
  },
  {
   value: "Wrabness (GBRBS)",
   label: "Wrabness (GBRBS)"
  },
  {
   value: "Wrafton (GBDEW)",
   label: "Wrafton (GBDEW)"
  },
  {
   value: "Wrenbury (GBWUY)",
   label: "Wrenbury (GBWUY)"
  },
  {
   value: "Wrotham Heath (GBWHR)",
   label: "Wrotham Heath (GBWHR)"
  },
  {
   value: "Wroxham (GBZDN)",
   label: "Wroxham (GBZDN)"
  },
  {
   value: "Wyboston (GBQWY)",
   label: "Wyboston (GBQWY)"
  },
  {
   value: "Wybunbury (GBWYY)",
   label: "Wybunbury (GBWYY)"
  },
  {
   value: "Wychbold (GBWYC)",
   label: "Wychbold (GBWYC)"
  },
  {
   value: "Wye (GBWYE)",
   label: "Wye (GBWYE)"
  },
  {
   value: "Wyke Regis (GBWYK)",
   label: "Wyke Regis (GBWYK)"
  },
  {
   value: "Wyre (GBWYR)",
   label: "Wyre (GBWYR)"
  },
  {
   value: "Wyton (GBQUY)",
   label: "Wyton (GBQUY)"
  },
  {
   value: "Yapton (GBYAP)",
   label: "Yapton (GBYAP)"
  },
  {
   value: "Yarmouth (GBYMO)",
   label: "Yarmouth (GBYMO)"
  },
  {
   value: "Yarnton (GBZDO)",
   label: "Yarnton (GBZDO)"
  },
  {
   value: "Yaxley (GBZDP)",
   label: "Yaxley (GBZDP)"
  },
  {
   value: "Yell and Fetlar (GBYFR)",
   label: "Yell and Fetlar (GBYFR)"
  },
  {
   value: "Yelvertoft (GBYVT)",
   label: "Yelvertoft (GBYVT)"
  },
  {
   value: "Yelverton (GBYLT)",
   label: "Yelverton (GBYLT)"
  },
  {
   value: "Yeovil Marsh (GBYMA)",
   label: "Yeovil Marsh (GBYMA)"
  },
  {
   value: "Yoker (GBYKE)",
   label: "Yoker (GBYKE)"
  },
  {
   value: "Youlgreave (GBYGV)",
   label: "Youlgreave (GBYGV)"
  },
  {
   value: "Ystrad Mynach (GBYMH)",
   label: "Ystrad Mynach (GBYMH)"
  },
  {
   value: "Ystradgynlais (GBYST)",
   label: "Ystradgynlais (GBYST)"
  },
  {
   value: "Ystradowen (GBYSD)",
   label: "Ystradowen (GBYSD)"
  },
  {
   value: "Zeals (GBZLS)",
   label: "Zeals (GBZLS)"
  },
  {
   value: ".GRENADA (GD)",
   label: ".GRENADA (GD)"
  },
  {
   value: "Carriacou Apt (GDCRU)",
   label: "Carriacou Apt (GDCRU)"
  },
  {
   value: ".GEORGIA (GE)",
   label: ".GEORGIA (GE)"
  },
  {
   value: "Akhalkalaki (GEZAI)",
   label: "Akhalkalaki (GEZAI)"
  },
  {
   value: "Akhmeta (GEZAH)",
   label: "Akhmeta (GEZAH)"
  },
  {
   value: "Borjomi (GEZAL)",
   label: "Borjomi (GEZAL)"
  },
  {
   value: "Chrebalo (GEZAC)",
   label: "Chrebalo (GEZAC)"
  },
  {
   value: "Dmanisi (GEZAE)",
   label: "Dmanisi (GEZAE)"
  },
  {
   value: "Gori (GEZAF)",
   label: "Gori (GEZAF)"
  },
  {
   value: "Kaspi (GEZAG)",
   label: "Kaspi (GEZAG)"
  },
  {
   value: "Kvareli (GEZAB)",
   label: "Kvareli (GEZAB)"
  },
  {
   value: "Marneuli (GEMAR)",
   label: "Marneuli (GEMAR)"
  },
  {
   value: "Mtskheta (GEZAA)",
   label: "Mtskheta (GEZAA)"
  },
  {
   value: "Rustavi (GEZAK)",
   label: "Rustavi (GEZAK)"
  },
  {
   value: "Senaki (GEZAJ)",
   label: "Senaki (GEZAJ)"
  },
  {
   value: "Supsa Pt (GESUP)",
   label: "Supsa Pt (GESUP)"
  },
  {
   value: "Tsageri (GETSA)",
   label: "Tsageri (GETSA)"
  },
  {
   value: "Zugdidi (GEZAD)",
   label: "Zugdidi (GEZAD)"
  },
  {
   value: ".FRENCH GUIANA (GF)",
   label: ".FRENCH GUIANA (GF)"
  },
  {
   value: "Macouria (GFMCR)",
   label: "Macouria (GFMCR)"
  },
  {
   value: "Sinnamary (GFSMY)",
   label: "Sinnamary (GFSMY)"
  },
  {
   value: ".GUERNSEY (GG)",
   label: ".GUERNSEY (GG)"
  },
  {
   value: "Alderney (GGACI)",
   label: "Alderney (GGACI)"
  },
  {
   value: "Guernsey (GGGCI)",
   label: "Guernsey (GGGCI)"
  },
  {
   value: "St Peter Port (GGSPT)",
   label: "St Peter Port (GGSPT)"
  },
  {
   value: ".GHANA (GH)",
   label: ".GHANA (GH)"
  },
  {
   value: "Asamankese (GHASA)",
   label: "Asamankese (GHASA)"
  },
  {
   value: "Berekum (GHBKM)",
   label: "Berekum (GHBKM)"
  },
  {
   value: "Ejura (GHEJU)",
   label: "Ejura (GHEJU)"
  },
  {
   value: "Koforidua (GHKOF)",
   label: "Koforidua (GHKOF)"
  },
  {
   value: "Konongo (GHKGO)",
   label: "Konongo (GHKGO)"
  },
  {
   value: "Kpandu (GHKPA)",
   label: "Kpandu (GHKPA)"
  },
  {
   value: "Kpetoe (GHKPE)",
   label: "Kpetoe (GHKPE)"
  },
  {
   value: "Kumawu (GHKMU)",
   label: "Kumawu (GHKMU)"
  },
  {
   value: "Legon (GHLEG)",
   label: "Legon (GHLEG)"
  },
  {
   value: "Nsawam (GHNSA)",
   label: "Nsawam (GHNSA)"
  },
  {
   value: "Obuasi (GHOBU)",
   label: "Obuasi (GHOBU)"
  },
  {
   value: "Oda (GHODA)",
   label: "Oda (GHODA)"
  },
  {
   value: "Tarkwa (GHTWA)",
   label: "Tarkwa (GHTWA)"
  },
  {
   value: ".GIBRALTAR (GI)",
   label: ".GIBRALTAR (GI)"
  },
  {
   value: ".GREENLAND (GL)",
   label: ".GREENLAND (GL)"
  },
  {
   value: "Ikerasak (GLIKE)",
   label: "Ikerasak (GLIKE)"
  },
  {
   value: "Illorsuit (GLILL)",
   label: "Illorsuit (GLILL)"
  },
  {
   value: "Isertoq (GLITQ)",
   label: "Isertoq (GLITQ)"
  },
  {
   value: "Kangaamiut (GLQKT)",
   label: "Kangaamiut (GLQKT)"
  },
  {
   value: "Kullorsuaq (GLKUL)",
   label: "Kullorsuaq (GLKUL)"
  },
  {
   value: "Kuummiut (GLKUN)",
   label: "Kuummiut (GLKUN)"
  },
  {
   value: "Maarmorliik (GLMML)",
   label: "Maarmorliik (GLMML)"
  },
  {
   value: "Nalunaq Gold Mine (GLNAL)",
   label: "Nalunaq Gold Mine (GLNAL)"
  },
  {
   value: "Nuugaatsiaq (GLNUG)",
   label: "Nuugaatsiaq (GLNUG)"
  },
  {
   value: "Qullissat (GLQUE)",
   label: "Qullissat (GLQUE)"
  },
  {
   value: "Saattut (GLSAA)",
   label: "Saattut (GLSAA)"
  },
  {
   value: "Seqi Olivine Mine (GLSEQ)",
   label: "Seqi Olivine Mine (GLSEQ)"
  },
  {
   value: "Tasiusaq (GLTAS)",
   label: "Tasiusaq (GLTAS)"
  },
  {
   value: "Tiniteqilaaq (GLTNT)",
   label: "Tiniteqilaaq (GLTNT)"
  },
  {
   value: ".GAMBIA (GM)",
   label: ".GAMBIA (GM)"
  },
  {
   value: "Karanai (GMKAR)",
   label: "Karanai (GMKAR)"
  },
  {
   value: "Sanyang (GMSYG)",
   label: "Sanyang (GMSYG)"
  },
  {
   value: ".GUINEA (GN)",
   label: ".GUINEA (GN)"
  },
  {
   value: "Conakry Eco (GNCKA)",
   label: "Conakry Eco (GNCKA)"
  },
  {
   value: "Moresby (GNSBY)",
   label: "Moresby (GNSBY)"
  },
  {
   value: ".GUADELOUPE (GP)",
   label: ".GUADELOUPE (GP)"
  },
  {
   value: "Pointe-Noire (GPZAA)",
   label: "Pointe-Noire (GPZAA)"
  },
  {
   value: "Port-Louis (GPPTL)",
   label: "Port-Louis (GPPTL)"
  },
  {
   value: "St-François (GPSFC)",
   label: "St-François (GPSFC)"
  },
  {
   value: ".EQUATORIAL GUINEA (GQ)",
   label: ".EQUATORIAL GUINEA (GQ)"
  },
  {
   value: "Mongomo (GQMON)",
   label: "Mongomo (GQMON)"
  },
  {
   value: "San Antonio de Palé (GQABU)",
   label: "San Antonio de Palé (GQABU)"
  },
  {
   value: "Serpentina Terminal (GQSER)",
   label: "Serpentina Terminal (GQSER)"
  },
  {
   value: "Zafiro Terminal (GQZAF)",
   label: "Zafiro Terminal (GQZAF)"
  },
  {
   value: ".GREECE (GR)",
   label: ".GREECE (GR)"
  },
  {
   value: "Aegaleo (GRGAH)",
   label: "Aegaleo (GRGAH)"
  },
  {
   value: "Aegio (GRGIE)",
   label: "Aegio (GRGIE)"
  },
  {
   value: "Afídhnai (GRKIA)",
   label: "Afídhnai (GRKIA)"
  },
  {
   value: "Agathonisi (GRAGN)",
   label: "Agathonisi (GRAGN)"
  },
  {
   value: "Agia Marina Aiginas (GRAMR)",
   label: "Agia Marina Aiginas (GRAMR)"
  },
  {
   value: "Agia Marina Grammatikou Attikis (GRGMA)",
   label: "Agia Marina Grammatikou Attikis (GRGMA)"
  },
  {
   value: "Agia Roumeli (GRROU)",
   label: "Agia Roumeli (GRROU)"
  },
  {
   value: "Agía Triás (GRAGI)",
   label: "Agía Triás (GRAGI)"
  },
  {
   value: "Agiokampos Larissas (GRAGK)",
   label: "Agiokampos Larissas (GRAGK)"
  },
  {
   value: "Ágios Athanásios (GRAOS)",
   label: "Ágios Athanásios (GRAOS)"
  },
  {
   value: "Ágios Efstrátios (GRAGO)",
   label: "Ágios Efstrátios (GRAGO)"
  },
  {
   value: "Agios Georgios (GRAGE)",
   label: "Agios Georgios (GRAGE)"
  },
  {
   value: "Agios Ioannis Rentis (GRGRA)",
   label: "Agios Ioannis Rentis (GRGRA)"
  },
  {
   value: "Agios Nikolaos Fokidas (GRAGF)",
   label: "Agios Nikolaos Fokidas (GRAGF)"
  },
  {
   value: "Agistri Aiginas (GRAGG)",
   label: "Agistri Aiginas (GRAGG)"
  },
  {
   value: "Agriá (GRAGA)",
   label: "Agriá (GRAGA)"
  },
  {
   value: "Áhdendron (GRADO)",
   label: "Áhdendron (GRADO)"
  },
  {
   value: "Aidipsou (GRAID)",
   label: "Aidipsou (GRAID)"
  },
  {
   value: "Aigaleo (GRAGL)",
   label: "Aigaleo (GRAGL)"
  },
  {
   value: "Aigiali Amorgou (GRAIG)",
   label: "Aigiali Amorgou (GRAIG)"
  },
  {
   value: "Aitolikon (GRGAW)",
   label: "Aitolikon (GRGAW)"
  },
  {
   value: "Aiyaleo (GREGA)",
   label: "Aiyaleo (GREGA)"
  },
  {
   value: "Akhillion (GRAKH)",
   label: "Akhillion (GRAKH)"
  },
  {
   value: "Akra Zéfiros (GRZPI)",
   label: "Akra Zéfiros (GRZPI)"
  },
  {
   value: "Aktio Vonitsas (GRAKT)",
   label: "Aktio Vonitsas (GRAKT)"
  },
  {
   value: "Alexándria (GRALX)",
   label: "Alexándria (GRALX)"
  },
  {
   value: "Amaliápolis (GRAPL)",
   label: "Amaliápolis (GRAPL)"
  },
  {
   value: "Amaroussio (GRASI)",
   label: "Amaroussio (GRASI)"
  },
  {
   value: "Ambelókipoi (GRABO)",
   label: "Ambelókipoi (GRABO)"
  },
  {
   value: "Amigdaleonas (GRGBC)",
   label: "Amigdaleonas (GRGBC)"
  },
  {
   value: "Amíndaion (GRAMY)",
   label: "Amíndaion (GRAMY)"
  },
  {
   value: "Anáfi (GRANA)",
   label: "Anáfi (GRANA)"
  },
  {
   value: "Anargyroi (GRANG)",
   label: "Anargyroi (GRANG)"
  },
  {
   value: "Ankhíalos (GRAHS)",
   label: "Ankhíalos (GRAHS)"
  },
  {
   value: "Ano Liosia (GRGAJ)",
   label: "Ano Liosia (GRGAJ)"
  },
  {
   value: "Araxos (GRARX)",
   label: "Araxos (GRARX)"
  },
  {
   value: "Areópolis (GRARE)",
   label: "Areópolis (GRARE)"
  },
  {
   value: "Argyroupoli (GRAGY)",
   label: "Argyroupoli (GRAGY)"
  },
  {
   value: "Argyroupolis (GRGAC)",
   label: "Argyroupolis (GRGAC)"
  },
  {
   value: "Arkítsa (GRARK)",
   label: "Arkítsa (GRARK)"
  },
  {
   value: "Arnaía (GRARN)",
   label: "Arnaía (GRARN)"
  },
  {
   value: "Árta (GRART)",
   label: "Árta (GRART)"
  },
  {
   value: "Artemis (GRTEM)",
   label: "Artemis (GRTEM)"
  },
  {
   value: "Áspra Spítia (GRASP)",
   label: "Áspra Spítia (GRASP)"
  },
  {
   value: "Aspropyrgos (GRAPP)",
   label: "Aspropyrgos (GRAPP)"
  },
  {
   value: "Aspros (GRAPO)",
   label: "Aspros (GRAPO)"
  },
  {
   value: "Asproválta (GRAPV)",
   label: "Asproválta (GRAPV)"
  },
  {
   value: "Assos (GRSOS)",
   label: "Assos (GRSOS)"
  },
  {
   value: "Ástros (GRARS)",
   label: "Ástros (GRARS)"
  },
  {
   value: "Asvestochórion (GRASV)",
   label: "Asvestochórion (GRASV)"
  },
  {
   value: "Atalanti (GRATI)",
   label: "Atalanti (GRATI)"
  },
  {
   value: "Avlaí (GRAVK)",
   label: "Avlaí (GRAVK)"
  },
  {
   value: "Avlida (GRAVA)",
   label: "Avlida (GRAVA)"
  },
  {
   value: "Avlona (GRGAE)",
   label: "Avlona (GRGAE)"
  },
  {
   value: "Axioupoli (GRGAA)",
   label: "Axioupoli (GRGAA)"
  },
  {
   value: "Ayía Triás (GRATR)",
   label: "Ayía Triás (GRATR)"
  },
  {
   value: "Chaïdari, Athens (GRCHI)",
   label: "Chaïdari, Athens (GRCHI)"
  },
  {
   value: "Chalastra (GRHLS)",
   label: "Chalastra (GRHLS)"
  },
  {
   value: "Chrisoupoli (GRKAV)",
   label: "Chrisoupoli (GRKAV)"
  },
  {
   value: "Dáfni (GRDAF)",
   label: "Dáfni (GRDAF)"
  },
  {
   value: "Dágla (GRDAG)",
   label: "Dágla (GRDAG)"
  },
  {
   value: "Dheskáti (GRDKI)",
   label: "Dheskáti (GRDKI)"
  },
  {
   value: "Dhidhimótikhon (GRDHI)",
   label: "Dhidhimótikhon (GRDHI)"
  },
  {
   value: "Dhoxáton (GRDOX)",
   label: "Dhoxáton (GRDOX)"
  },
  {
   value: "Dhrimos (GRDHS)",
   label: "Dhrimos (GRDHS)"
  },
  {
   value: "Dhroserón (GRDRS)",
   label: "Dhroserón (GRDRS)"
  },
  {
   value: "Diafánion (GRDIA)",
   label: "Diafánion (GRDIA)"
  },
  {
   value: "Diakofti Kythiron (GRDIK)",
   label: "Diakofti Kythiron (GRDIK)"
  },
  {
   value: "Distomo (GRDTO)",
   label: "Distomo (GRDTO)"
  },
  {
   value: "Dombraina Boiotias (GRDMB)",
   label: "Dombraina Boiotias (GRDMB)"
  },
  {
   value: "Domvrena (GRDVA)",
   label: "Domvrena (GRDVA)"
  },
  {
   value: "Donousa Kykladon (GRDON)",
   label: "Donousa Kykladon (GRDON)"
  },
  {
   value: "Drepano Riou (GRDRE)",
   label: "Drepano Riou (GRDRE)"
  },
  {
   value: "Efkarpia (GREFK)",
   label: "Efkarpia (GREFK)"
  },
  {
   value: "Eginio Pierias (GREPS)",
   label: "Eginio Pierias (GREPS)"
  },
  {
   value: "Eginion (GREGI)",
   label: "Eginion (GREGI)"
  },
  {
   value: "Elafonissos Lakonias (GRELN)",
   label: "Elafonissos Lakonias (GRELN)"
  },
  {
   value: "Elefsina (GRIXE)",
   label: "Elefsina (GRIXE)"
  },
  {
   value: "Epanomí (GREPM)",
   label: "Epanomí (GREPM)"
  },
  {
   value: "Ereikousses Diapontioi I.s (GRERK)",
   label: "Ereikousses Diapontioi I.s (GRERK)"
  },
  {
   value: "Erétria (GRERE)",
   label: "Erétria (GRERE)"
  },
  {
   value: "Évosmon (GREVM)",
   label: "Évosmon (GREVM)"
  },
  {
   value: "Evpálion (GREVP)",
   label: "Evpálion (GREVP)"
  },
  {
   value: "Faneromeni Salaminas (GRFNR)",
   label: "Faneromeni Salaminas (GRFNR)"
  },
  {
   value: "Fársala (GRFAR)",
   label: "Fársala (GRFAR)"
  },
  {
   value: "Férai (GRFER)",
   label: "Férai (GRFER)"
  },
  {
   value: "Filiatrá (GRFIL)",
   label: "Filiatrá (GRFIL)"
  },
  {
   value: "Filippiada (GRFIP)",
   label: "Filippiada (GRFIP)"
  },
  {
   value: "Fiskárdo (GRFIS)",
   label: "Fiskárdo (GRFIS)"
  },
  {
   value: "Fokidos (GRFKD)",
   label: "Fokidos (GRFKD)"
  },
  {
   value: "Folégandros (GRFOL)",
   label: "Folégandros (GRFOL)"
  },
  {
   value: "Foúrnoi (GRFOU)",
   label: "Foúrnoi (GRFOU)"
  },
  {
   value: "Frikes Ithakis (GRSAT)",
   label: "Frikes Ithakis (GRSAT)"
  },
  {
   value: "Galatas Troizinas (GRGAL)",
   label: "Galatas Troizinas (GRGAL)"
  },
  {
   value: "Galatista (GRGTA)",
   label: "Galatista (GRGTA)"
  },
  {
   value: "Galátsion (GRGSI)",
   label: "Galátsion (GRGSI)"
  },
  {
   value: "Galaxidi (GRGLX)",
   label: "Galaxidi (GRGLX)"
  },
  {
   value: "Gavdos Chanea (GRGAD)",
   label: "Gavdos Chanea (GRGAD)"
  },
  {
   value: "Gázoros (GRGAZ)",
   label: "Gázoros (GRGAZ)"
  },
  {
   value: "Gerakarou (GRGKU)",
   label: "Gerakarou (GRGKU)"
  },
  {
   value: "Gerakas (GRGER)",
   label: "Gerakas (GRGER)"
  },
  {
   value: "Gialtra (GRGIA)",
   label: "Gialtra (GRGIA)"
  },
  {
   value: "Giannitsa (GRGAK)",
   label: "Giannitsa (GRGAK)"
  },
  {
   value: "Glyfa Fthiotidas (GRGLY)",
   label: "Glyfa Fthiotidas (GRGLY)"
  },
  {
   value: "Grevená (GRGVA)",
   label: "Grevená (GRGVA)"
  },
  {
   value: "Halandri (GRHRI)",
   label: "Halandri (GRHRI)"
  },
  {
   value: "Halki Dodekanison (GRHAL)",
   label: "Halki Dodekanison (GRHAL)"
  },
  {
   value: "Heraclion Crete (GRHEC)",
   label: "Heraclion Crete (GRHEC)"
  },
  {
   value: "Herakleia Kykladon (GRHRK)",
   label: "Herakleia Kykladon (GRHRK)"
  },
  {
   value: "Ierápetra (GRIER)",
   label: "Ierápetra (GRIER)"
  },
  {
   value: "Ierissos (GRIES)",
   label: "Ierissos (GRIES)"
  },
  {
   value: "Ilion (GRILI)",
   label: "Ilion (GRILI)"
  },
  {
   value: "Ilioúpolis (GRILO)",
   label: "Ilioúpolis (GRILO)"
  },
  {
   value: "Iráklia (GRIRA)",
   label: "Iráklia (GRIRA)"
  },
  {
   value: "Iráklion (GRNAI)",
   label: "Iráklion (GRNAI)"
  },
  {
   value: "Istiaia (GRSAA)",
   label: "Istiaia (GRSAA)"
  },
  {
   value: "Istiea (GRIEA)",
   label: "Istiea (GRIEA)"
  },
  {
   value: "Kakavia (GRKKV)",
   label: "Kakavia (GRKKV)"
  },
  {
   value: "Kalamaria (GRGAI)",
   label: "Kalamaria (GRGAI)"
  },
  {
   value: "Kalamos I. (GRKAI)",
   label: "Kalamos I. (GRKAI)"
  },
  {
   value: "Kalíves Valtsaíikes (GRKCH)",
   label: "Kalíves Valtsaíikes (GRKCH)"
  },
  {
   value: "Kallithéa\/Athínai (GRKLA)",
   label: "Kallithéa\/Athínai (GRKLA)"
  },
  {
   value: "Kalohori (GRKLH)",
   label: "Kalohori (GRKLH)"
  },
  {
   value: "Kamínia (GRKAM)",
   label: "Kamínia (GRKAM)"
  },
  {
   value: "Kapandrition (GRAPA)",
   label: "Kapandrition (GRAPA)"
  },
  {
   value: "Kardámyla (GRKDM)",
   label: "Kardámyla (GRKDM)"
  },
  {
   value: "Kardítsa (GRKRD)",
   label: "Kardítsa (GRKRD)"
  },
  {
   value: "Kastellorizou (ex Megísti) (GRKAS)",
   label: "Kastellorizou (ex Megísti) (GRKAS)"
  },
  {
   value: "Kastos I. (GRKSI)",
   label: "Kastos I. (GRKSI)"
  },
  {
   value: "Katápola (GRKTP)",
   label: "Katápola (GRKTP)"
  },
  {
   value: "Káto Acha?a (GRKAH)",
   label: "Káto Acha?a (GRKAH)"
  },
  {
   value: "Káto Akhaía (GRKAC)",
   label: "Káto Akhaía (GRKAC)"
  },
  {
   value: "Káto Nevrokópion (GRNEY)",
   label: "Káto Nevrokópion (GRNEY)"
  },
  {
   value: "Kató Vérmion (GRVEO)",
   label: "Kató Vérmion (GRVEO)"
  },
  {
   value: "Kefalos Ko (GRKEF)",
   label: "Kefalos Ko (GRKEF)"
  },
  {
   value: "Kefalóvrison (GRKFO)",
   label: "Kefalóvrison (GRKFO)"
  },
  {
   value: "Keratéa (GRKRA)",
   label: "Keratéa (GRKRA)"
  },
  {
   value: "Keratsínion (GRKTS)",
   label: "Keratsínion (GRKTS)"
  },
  {
   value: "Khrisoúpolis (GRKHR)",
   label: "Khrisoúpolis (GRKHR)"
  },
  {
   value: "Killíni (GRKIL)",
   label: "Killíni (GRKIL)"
  },
  {
   value: "Kiparissia (GRKIP)",
   label: "Kiparissia (GRKIP)"
  },
  {
   value: "Klima (GRKLI)",
   label: "Klima (GRKLI)"
  },
  {
   value: "Kolokinthoú (GRKOL)",
   label: "Kolokinthoú (GRKOL)"
  },
  {
   value: "Kónitsa (GRKOA)",
   label: "Kónitsa (GRKOA)"
  },
  {
   value: "Korydallós (GRKYD)",
   label: "Korydallós (GRKYD)"
  },
  {
   value: "Kosta Ermionidas (GRKEM)",
   label: "Kosta Ermionidas (GRKEM)"
  },
  {
   value: "Koufonissia Kykladon (GRKOF)",
   label: "Koufonissia Kykladon (GRKOF)"
  },
  {
   value: "Kounavoi (GRGAM)",
   label: "Kounavoi (GRGAM)"
  },
  {
   value: "Lagos (GRGAT)",
   label: "Lagos (GRGAT)"
  },
  {
   value: "Lakkiá (GRLAK)",
   label: "Lakkiá (GRLAK)"
  },
  {
   value: "Lakkion (GRPKK)",
   label: "Lakkion (GRPKK)"
  },
  {
   value: "Lákkoma (GRKKM)",
   label: "Lákkoma (GRKKM)"
  },
  {
   value: "Lákkoma (Khalkidhiki) (GRLKK)",
   label: "Lákkoma (Khalkidhiki) (GRLKK)"
  },
  {
   value: "Levadhia (GRGAG)",
   label: "Levadhia (GRGAG)"
  },
  {
   value: "Likóvrisi (GRLKV)",
   label: "Likóvrisi (GRLKV)"
  },
  {
   value: "Limnotopos (GRGAN)",
   label: "Limnotopos (GRGAN)"
  },
  {
   value: "Linaria (GRLIA)",
   label: "Linaria (GRLIA)"
  },
  {
   value: "Linoperamata Hrakliou (GRLIN)",
   label: "Linoperamata Hrakliou (GRLIN)"
  },
  {
   value: "Lipsoí (GRLIP)",
   label: "Lipsoí (GRLIP)"
  },
  {
   value: "Litókhoron (GRLIT)",
   label: "Litókhoron (GRLIT)"
  },
  {
   value: "Livanatai (GRLIV)",
   label: "Livanatai (GRLIV)"
  },
  {
   value: "Loutro Chanion (GRLTR)",
   label: "Loutro Chanion (GRLTR)"
  },
  {
   value: "Magiko (GRMGO)",
   label: "Magiko (GRMGO)"
  },
  {
   value: "Magoúla (GRMAG)",
   label: "Magoúla (GRMAG)"
  },
  {
   value: "Magoúla (GRMGL)",
   label: "Magoúla (GRMGL)"
  },
  {
   value: "Malakása (GRMLK)",
   label: "Malakása (GRMLK)"
  },
  {
   value: "Malessina (GRMSA)",
   label: "Malessina (GRMSA)"
  },
  {
   value: "Malia (GRGAO)",
   label: "Malia (GRGAO)"
  },
  {
   value: "Mándra (GRMAD)",
   label: "Mándra (GRMAD)"
  },
  {
   value: "Mandra Attikis (GRGAP)",
   label: "Mandra Attikis (GRGAP)"
  },
  {
   value: "Mángana (GRMNG)",
   label: "Mángana (GRMNG)"
  },
  {
   value: "Mantoúdion (GRMTI)",
   label: "Mantoúdion (GRMTI)"
  },
  {
   value: "Marathítis (GRMRT)",
   label: "Marathítis (GRMRT)"
  },
  {
   value: "Marathonas (GRMHO)",
   label: "Marathonas (GRMHO)"
  },
  {
   value: "Markopoulo (GRGAQ)",
   label: "Markopoulo (GRGAQ)"
  },
  {
   value: "Marmárion (GRMRN)",
   label: "Marmárion (GRMRN)"
  },
  {
   value: "Mathraki Diapontioi I.s (GRMTR)",
   label: "Mathraki Diapontioi I.s (GRMTR)"
  },
  {
   value: "Mavrothálassa (GRMAV)",
   label: "Mavrothálassa (GRMAV)"
  },
  {
   value: "Melía (GRMLA)",
   label: "Melía (GRMLA)"
  },
  {
   value: "Melissokhorion (GRMKN)",
   label: "Melissokhorion (GRMKN)"
  },
  {
   value: "Messíni (GRMNI)",
   label: "Messíni (GRMNI)"
  },
  {
   value: "Métsovon (GRMSV)",
   label: "Métsovon (GRMSV)"
  },
  {
   value: "Molyvos (GRMOL)",
   label: "Molyvos (GRMOL)"
  },
  {
   value: "Moschato (GRGAR)",
   label: "Moschato (GRGAR)"
  },
  {
   value: "Mouriaí (GRMRA)",
   label: "Mouriaí (GRMRA)"
  },
  {
   value: "Myrtos Beach (GRMYB)",
   label: "Myrtos Beach (GRMYB)"
  },
  {
   value: "Naoussa Parou (GRNAS)",
   label: "Naoussa Parou (GRNAS)"
  },
  {
   value: "Néa Alikarnassós (GRNAL)",
   label: "Néa Alikarnassós (GRNAL)"
  },
  {
   value: "Néa Artáki (GRNAR)",
   label: "Néa Artáki (GRNAR)"
  },
  {
   value: "Nea Epidhavros (GRNEV)",
   label: "Nea Epidhavros (GRNEV)"
  },
  {
   value: "Nea Erythrea (GRNER)",
   label: "Nea Erythrea (GRNER)"
  },
  {
   value: "Nea Filadelfia (GRNFA)",
   label: "Nea Filadelfia (GRNFA)"
  },
  {
   value: "Nea Ionia (GRNIO)",
   label: "Nea Ionia (GRNIO)"
  },
  {
   value: "Néa Kallikrátia (GRNKA)",
   label: "Néa Kallikrátia (GRNKA)"
  },
  {
   value: "Néa Khalkidhón (GRNKK)",
   label: "Néa Khalkidhón (GRNKK)"
  },
  {
   value: "Néa Kíos (GRNKS)",
   label: "Néa Kíos (GRNKS)"
  },
  {
   value: "Néa Liósia (GRLSA)",
   label: "Néa Liósia (GRLSA)"
  },
  {
   value: "Nea Makri (GRANM)",
   label: "Nea Makri (GRANM)"
  },
  {
   value: "Néa Málgara (GRNMG)",
   label: "Néa Málgara (GRNMG)"
  },
  {
   value: "Nea Mikhaniona (GRNMK)",
   label: "Nea Mikhaniona (GRNMK)"
  },
  {
   value: "Néa Raidhestós (GRNRS)",
   label: "Néa Raidhestós (GRNRS)"
  },
  {
   value: "Néa Sánda (GRGBB)",
   label: "Néa Sánda (GRGBB)"
  },
  {
   value: "Néa Sánta (GRNSN)",
   label: "Néa Sánta (GRNSN)"
  },
  {
   value: "Neokhoroúdha (GRNCO)",
   label: "Neokhoroúdha (GRNCO)"
  },
  {
   value: "Nigríta (GRNGA)",
   label: "Nigríta (GRNGA)"
  },
  {
   value: "Nikaia (GRNIK)",
   label: "Nikaia (GRNIK)"
  },
  {
   value: "Oinófita (GROIN)",
   label: "Oinófita (GROIN)"
  },
  {
   value: "Oraiókastron (GRORA)",
   label: "Oraiókastron (GRORA)"
  },
  {
   value: "Orestiás (GRORS)",
   label: "Orestiás (GRORS)"
  },
  {
   value: "Ormília (GRORM)",
   label: "Ormília (GRORM)"
  },
  {
   value: "Othonoí (GROTH)",
   label: "Othonoí (GROTH)"
  },
  {
   value: "Ouranópolis (GROUR)",
   label: "Ouranópolis (GROUR)"
  },
  {
   value: "Palaiá Fókaia (GRPFA)",
   label: "Palaiá Fókaia (GRPFA)"
  },
  {
   value: "Palaiá Psará (GRPAA)",
   label: "Palaiá Psará (GRPAA)"
  },
  {
   value: "Paleochora (GRPCH)",
   label: "Paleochora (GRPCH)"
  },
  {
   value: "Paloúkia (GRPAO)",
   label: "Paloúkia (GRPAO)"
  },
  {
   value: "Panórama (GRPNA)",
   label: "Panórama (GRPNA)"
  },
  {
   value: "Papadianika\/Asopos (GRPPK)",
   label: "Papadianika\/Asopos (GRPPK)"
  },
  {
   value: "Paramythía (GRPAM)",
   label: "Paramythía (GRPAM)"
  },
  {
   value: "Pekfi (GRPEK)",
   label: "Pekfi (GRPEK)"
  },
  {
   value: "Pella (GRPLL)",
   label: "Pella (GRPLL)"
  },
  {
   value: "Pendálofos (GRPTF)",
   label: "Pendálofos (GRPTF)"
  },
  {
   value: "Perea (GRPRR)",
   label: "Perea (GRPRR)"
  },
  {
   value: "Peristera (GRPST)",
   label: "Peristera (GRPST)"
  },
  {
   value: "Pessada Kefallinnias (GRPSK)",
   label: "Pessada Kefallinnias (GRPSK)"
  },
  {
   value: "Petani Beach (GRPEB)",
   label: "Petani Beach (GRPEB)"
  },
  {
   value: "Pétra (GRGAB)",
   label: "Pétra (GRGAB)"
  },
  {
   value: "Pétra (GRPET)",
   label: "Pétra (GRPET)"
  },
  {
   value: "Phserimos Dodekanisou (GRPSE)",
   label: "Phserimos Dodekanisou (GRPSE)"
  },
  {
   value: "Pilea (Pylaía) (GRPLA)",
   label: "Pilea (Pylaía) (GRPLA)"
  },
  {
   value: "Pissaetos Ithakis (GRPIS)",
   label: "Pissaetos Ithakis (GRPIS)"
  },
  {
   value: "Pitra (GRPIT)",
   label: "Pitra (GRPIT)"
  },
  {
   value: "Plagiárion (GRPGN)",
   label: "Plagiárion (GRPGN)"
  },
  {
   value: "Platania (GRPIA)",
   label: "Platania (GRPIA)"
  },
  {
   value: "Plátanos (GRPTN)",
   label: "Plátanos (GRPTN)"
  },
  {
   value: "Plataria (GRPTI)",
   label: "Plataria (GRPTI)"
  },
  {
   value: "Platygiali Etoloakarnanias (GRPLG)",
   label: "Platygiali Etoloakarnanias (GRPLG)"
  },
  {
   value: "Polychnitos Lesvou (GRPLC)",
   label: "Polychnitos Lesvou (GRPLC)"
  },
  {
   value: "Pórto Ráfti (Limín Mesoyaías) (GRPRA)",
   label: "Pórto Ráfti (Limín Mesoyaías) (GRPRA)"
  },
  {
   value: "Prinos Thassou (GRPPI)",
   label: "Prinos Thassou (GRPPI)"
  },
  {
   value: "Protória (GRPRT)",
   label: "Protória (GRPRT)"
  },
  {
   value: "Psakhná (GRPSA)",
   label: "Psakhná (GRPSA)"
  },
  {
   value: "Pteleos (GRPTE)",
   label: "Pteleos (GRPTE)"
  },
  {
   value: "Revithoussa (GRREV)",
   label: "Revithoussa (GRREV)"
  },
  {
   value: "Riolos (GRGAX)",
   label: "Riolos (GRGAX)"
  },
  {
   value: "Ritsóna (GRRTS)",
   label: "Ritsóna (GRRTS)"
  },
  {
   value: "Salonika (GRSNK)",
   label: "Salonika (GRSNK)"
  },
  {
   value: "Sámi (GRSAI)",
   label: "Sámi (GRSAI)"
  },
  {
   value: "Schimatarion (GRSMT)",
   label: "Schimatarion (GRSMT)"
  },
  {
   value: "Schinousa Kykladon (GRSHC)",
   label: "Schinousa Kykladon (GRSHC)"
  },
  {
   value: "Shinari Zakynthou (GRSHI)",
   label: "Shinari Zakynthou (GRSHI)"
  },
  {
   value: "Sigri Lesvou (GRSGR)",
   label: "Sigri Lesvou (GRSGR)"
  },
  {
   value: "Sigrion (GRSGI)",
   label: "Sigrion (GRSGI)"
  },
  {
   value: "Sikinos (GRSII)",
   label: "Sikinos (GRSII)"
  },
  {
   value: "Sindhos (GRSDS)",
   label: "Sindhos (GRSDS)"
  },
  {
   value: "Síndos (GRSIS)",
   label: "Síndos (GRSIS)"
  },
  {
   value: "Skáloma (GRSKM)",
   label: "Skáloma (GRSKM)"
  },
  {
   value: "Skhimatárion (GRSKH)",
   label: "Skhimatárion (GRSKH)"
  },
  {
   value: "Soúda (GRSDH)",
   label: "Soúda (GRSDH)"
  },
  {
   value: "Souda Bay (GRGAF)",
   label: "Souda Bay (GRGAF)"
  },
  {
   value: "Souflíon (GRSFN)",
   label: "Souflíon (GRSFN)"
  },
  {
   value: "Sougia Chanion (GRSOG)",
   label: "Sougia Chanion (GRSOG)"
  },
  {
   value: "Souvala (GRSLA)",
   label: "Souvala (GRSLA)"
  },
  {
   value: "Spáta (GRSPT)",
   label: "Spáta (GRSPT)"
  },
  {
   value: "St Nicolas (GRSTN)",
   label: "St Nicolas (GRSTN)"
  },
  {
   value: "Stavrochorion (GRSCR)",
   label: "Stavrochorion (GRSCR)"
  },
  {
   value: "Stavros Agias Paraskevis (GRSAP)",
   label: "Stavros Agias Paraskevis (GRSAP)"
  },
  {
   value: "Stenimahos (GRGBE)",
   label: "Stenimahos (GRGBE)"
  },
  {
   value: "Syra Island (GRSYO)",
   label: "Syra Island (GRSYO)"
  },
  {
   value: "Taktikoupolis (GRTAK)",
   label: "Taktikoupolis (GRTAK)"
  },
  {
   value: "Távros (GRTVR)",
   label: "Távros (GRTVR)"
  },
  {
   value: "Terpní (GRTER)",
   label: "Terpní (GRTER)"
  },
  {
   value: "Terpní (GRTPS)",
   label: "Terpní (GRTPS)"
  },
  {
   value: "Thérmi (GRTHR)",
   label: "Thérmi (GRTHR)"
  },
  {
   value: "Thessi Kyrillo (GRTKO)",
   label: "Thessi Kyrillo (GRTKO)"
  },
  {
   value: "Thísvi (GRTHI)",
   label: "Thísvi (GRTHI)"
  },
  {
   value: "Thrapsanon (GRGAY)",
   label: "Thrapsanon (GRGAY)"
  },
  {
   value: "Tilos (GRTIL)",
   label: "Tilos (GRTIL)"
  },
  {
   value: "Tithoréa (GRGBA)",
   label: "Tithoréa (GRGBA)"
  },
  {
   value: "Tithoréa (GRTIT)",
   label: "Tithoréa (GRTIT)"
  },
  {
   value: "Trikeri (GRTRK)",
   label: "Trikeri (GRTRK)"
  },
  {
   value: "Trílofos (GRTFS)",
   label: "Trílofos (GRTFS)"
  },
  {
   value: "Trypiti Chalkidikis (GRTRY)",
   label: "Trypiti Chalkidikis (GRTRY)"
  },
  {
   value: "Tsingéli (GRTSI)",
   label: "Tsingéli (GRTSI)"
  },
  {
   value: "Týrnavos (GRTYR)",
   label: "Týrnavos (GRTYR)"
  },
  {
   value: "Vasiliká (GRVAS)",
   label: "Vasiliká (GRVAS)"
  },
  {
   value: "Vasilikón (GRVAO)",
   label: "Vasilikón (GRVAO)"
  },
  {
   value: "Vassiliki Leykadas (GRVSS)",
   label: "Vassiliki Leykadas (GRVSS)"
  },
  {
   value: "Vassiliko Chalkida (GRSLK)",
   label: "Vassiliko Chalkida (GRSLK)"
  },
  {
   value: "Vathi (GRVAT)",
   label: "Vathi (GRVAT)"
  },
  {
   value: "Vathilakkos (GRVLK)",
   label: "Vathilakkos (GRVLK)"
  },
  {
   value: "Vatika Bay (GRVAB)",
   label: "Vatika Bay (GRVAB)"
  },
  {
   value: "Velestino (GRVLT)",
   label: "Velestino (GRVLT)"
  },
  {
   value: "Voiotia (GRVTA)",
   label: "Voiotia (GRVTA)"
  },
  {
   value: "Vólax (GRVLX)",
   label: "Vólax (GRVLX)"
  },
  {
   value: "Vónitsa (GRVOA)",
   label: "Vónitsa (GRVOA)"
  },
  {
   value: "Voreinón (GRVRN)",
   label: "Voreinón (GRVRN)"
  },
  {
   value: "Vouliagméni (GRVLM)",
   label: "Vouliagméni (GRVLM)"
  },
  {
   value: "Vrisákia (GRVRI)",
   label: "Vrisákia (GRVRI)"
  },
  {
   value: "Xylókastron (GRXYL)",
   label: "Xylókastron (GRXYL)"
  },
  {
   value: "Yaltra (GRYAL)",
   label: "Yaltra (GRYAL)"
  },
  {
   value: "Zevgolatíon (GRZEY)",
   label: "Zevgolatíon (GRZEY)"
  },
  {
   value: ".SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS (GS)",
   label: ".SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS (GS)"
  },
  {
   value: "Grytviken (GSGRV)",
   label: "Grytviken (GSGRV)"
  },
  {
   value: ".GUATEMALA (GT)",
   label: ".GUATEMALA (GT)"
  },
  {
   value: "Asunción Mita (GTAMI)",
   label: "Asunción Mita (GTAMI)"
  },
  {
   value: "Barberena (GTBAB)",
   label: "Barberena (GTBAB)"
  },
  {
   value: "Bárcenas (GTBAR)",
   label: "Bárcenas (GTBAR)"
  },
  {
   value: "Boca del Monte (GTBOC)",
   label: "Boca del Monte (GTBOC)"
  },
  {
   value: "Chicacao (GTCHC)",
   label: "Chicacao (GTCHC)"
  },
  {
   value: "Chiquimulilla (GTCHQ)",
   label: "Chiquimulilla (GTCHQ)"
  },
  {
   value: "Ciudad Tecún Umán (GTCTU)",
   label: "Ciudad Tecún Umán (GTCTU)"
  },
  {
   value: "Ciudad Vieja (GTCDV)",
   label: "Ciudad Vieja (GTCDV)"
  },
  {
   value: "Coatepeque (GTCTF)",
   label: "Coatepeque (GTCTF)"
  },
  {
   value: "Cocales (GTCLS)",
   label: "Cocales (GTCLS)"
  },
  {
   value: "Concepcion (GTCCN)",
   label: "Concepcion (GTCCN)"
  },
  {
   value: "Cuilapa (GTCUI)",
   label: "Cuilapa (GTCUI)"
  },
  {
   value: "Cuyotenango (GTCOY)",
   label: "Cuyotenango (GTCOY)"
  },
  {
   value: "Dos Lagunas (GTDON)",
   label: "Dos Lagunas (GTDON)"
  },
  {
   value: "El Estor (GTELE)",
   label: "El Estor (GTELE)"
  },
  {
   value: "El Jicaro (GTEJO)",
   label: "El Jicaro (GTEJO)"
  },
  {
   value: "El Jocotillo (GTEJC)",
   label: "El Jocotillo (GTEJC)"
  },
  {
   value: "El Pino (GTELP)",
   label: "El Pino (GTELP)"
  },
  {
   value: "El Progreso (GTPRO)",
   label: "El Progreso (GTPRO)"
  },
  {
   value: "El Rancho (GTELR)",
   label: "El Rancho (GTELR)"
  },
  {
   value: "El Tejar (GTELT)",
   label: "El Tejar (GTELT)"
  },
  {
   value: "Entre Ríos (GTERI)",
   label: "Entre Ríos (GTERI)"
  },
  {
   value: "Esquipulas (GTESQ)",
   label: "Esquipulas (GTESQ)"
  },
  {
   value: "Estanzuela (GTEST)",
   label: "Estanzuela (GTEST)"
  },
  {
   value: "Jalapa (GTJAL)",
   label: "Jalapa (GTJAL)"
  },
  {
   value: "Jutiapa (GTJUT)",
   label: "Jutiapa (GTJUT)"
  },
  {
   value: "La Aurora (GTLAA)",
   label: "La Aurora (GTLAA)"
  },
  {
   value: "La Democracia (GTLDE)",
   label: "La Democracia (GTLDE)"
  },
  {
   value: "La Gomera (GTLGA)",
   label: "La Gomera (GTLGA)"
  },
  {
   value: "Los Esclavos (GTLEC)",
   label: "Los Esclavos (GTLEC)"
  },
  {
   value: "Masagua (GTMAS)",
   label: "Masagua (GTMAS)"
  },
  {
   value: "Mixco (GTMIX)",
   label: "Mixco (GTMIX)"
  },
  {
   value: "Monjas (GTMJS)",
   label: "Monjas (GTMJS)"
  },
  {
   value: "Morales (GTMOR)",
   label: "Morales (GTMOR)"
  },
  {
   value: "Nahualate (GTNAH)",
   label: "Nahualate (GTNAH)"
  },
  {
   value: "Obero (GTOBE)",
   label: "Obero (GTOBE)"
  },
  {
   value: "Palencia (GTPLA)",
   label: "Palencia (GTPLA)"
  },
  {
   value: "Parramos (GTPAR)",
   label: "Parramos (GTPAR)"
  },
  {
   value: "Patulul (GTPAT)",
   label: "Patulul (GTPAT)"
  },
  {
   value: "Patzicía (GTPTZ)",
   label: "Patzicía (GTPTZ)"
  },
  {
   value: "Pueblo Nuevo Viñas (GTPNV)",
   label: "Pueblo Nuevo Viñas (GTPNV)"
  },
  {
   value: "Purulhá (GTPUR)",
   label: "Purulhá (GTPUR)"
  },
  {
   value: "Quetzaltenango (GTAAZ)",
   label: "Quetzaltenango (GTAAZ)"
  },
  {
   value: "Quiriguá (GTQUI)",
   label: "Quiriguá (GTQUI)"
  },
  {
   value: "Río Dulce (GTRDC)",
   label: "Río Dulce (GTRDC)"
  },
  {
   value: "Salamá (GTSLM)",
   label: "Salamá (GTSLM)"
  },
  {
   value: "San Andrés Itzapa (GTSAI)",
   label: "San Andrés Itzapa (GTSAI)"
  },
  {
   value: "San Antonio Suchitepéquez (GTSAA)",
   label: "San Antonio Suchitepéquez (GTSAA)"
  },
  {
   value: "San Bartolomé Milpas Altas (GTSAB)",
   label: "San Bartolomé Milpas Altas (GTSAB)"
  },
  {
   value: "San Cristóbal Acasaguastlán (GTSCA)",
   label: "San Cristóbal Acasaguastlán (GTSCA)"
  },
  {
   value: "San Francisco (GTSFR)",
   label: "San Francisco (GTSFR)"
  },
  {
   value: "San Ixtán (GTIXT)",
   label: "San Ixtán (GTIXT)"
  },
  {
   value: "San Jerónimo (GTSJE)",
   label: "San Jerónimo (GTSJE)"
  },
  {
   value: "San José Pinula (GTSJP)",
   label: "San José Pinula (GTSJP)"
  },
  {
   value: "San Juan Chamelco (GTSJC)",
   label: "San Juan Chamelco (GTSJC)"
  },
  {
   value: "San Juan Sacatepéquez (GTSJS)",
   label: "San Juan Sacatepéquez (GTSJS)"
  },
  {
   value: "San Lucas Tolimán (GTSLT)",
   label: "San Lucas Tolimán (GTSLT)"
  },
  {
   value: "San Marcos (GTSAM)",
   label: "San Marcos (GTSAM)"
  },
  {
   value: "San Marcos (GTSMS)",
   label: "San Marcos (GTSMS)"
  },
  {
   value: "San Miguel Petapa (GTSMI)",
   label: "San Miguel Petapa (GTSMI)"
  },
  {
   value: "San Pedro Sacatepéquez (GTSPS)",
   label: "San Pedro Sacatepéquez (GTSPS)"
  },
  {
   value: "San Rafael Pie de la Cuesta (GTSRA)",
   label: "San Rafael Pie de la Cuesta (GTSRA)"
  },
  {
   value: "San Sebastián (GTSEB)",
   label: "San Sebastián (GTSEB)"
  },
  {
   value: "Sanarate (GTSAR)",
   label: "Sanarate (GTSAR)"
  },
  {
   value: "Santa Bárbara (GTSBA)",
   label: "Santa Bárbara (GTSBA)"
  },
  {
   value: "Santa Catarina Pinula (GTSCP)",
   label: "Santa Catarina Pinula (GTSCP)"
  },
  {
   value: "Santa Elena Barillas (GTEBS)",
   label: "Santa Elena Barillas (GTEBS)"
  },
  {
   value: "Santa Lucía Cotzumalguapa (GTSLC)",
   label: "Santa Lucía Cotzumalguapa (GTSLC)"
  },
  {
   value: "Santa Lucía Milpas Altas (GTSLU)",
   label: "Santa Lucía Milpas Altas (GTSLU)"
  },
  {
   value: "Santa María Cauqué (GTSMC)",
   label: "Santa María Cauqué (GTSMC)"
  },
  {
   value: "Santiago Atitlán (GTSNT)",
   label: "Santiago Atitlán (GTSNT)"
  },
  {
   value: "Santiago Sacatepéquez (GTSAS)",
   label: "Santiago Sacatepéquez (GTSAS)"
  },
  {
   value: "Santo Domingo Suchitepéquez (GTSDS)",
   label: "Santo Domingo Suchitepéquez (GTSDS)"
  },
  {
   value: "Santo Tomas (GTSTZ)",
   label: "Santo Tomas (GTSTZ)"
  },
  {
   value: "Santo Tomás La Unión (GTSTU)",
   label: "Santo Tomás La Unión (GTSTU)"
  },
  {
   value: "Solola (GTSOL)",
   label: "Solola (GTSOL)"
  },
  {
   value: "Sumpango (GTSUM)",
   label: "Sumpango (GTSUM)"
  },
  {
   value: "Taxisco (GTTAX)",
   label: "Taxisco (GTTAX)"
  },
  {
   value: "Tecpán Guatemala (GTTCP)",
   label: "Tecpán Guatemala (GTTCP)"
  },
  {
   value: "Tecun Uman (GTTUC)",
   label: "Tecun Uman (GTTUC)"
  },
  {
   value: "Totonicapán (GTTOT)",
   label: "Totonicapán (GTTOT)"
  },
  {
   value: "Uspantán (GTUSP)",
   label: "Uspantán (GTUSP)"
  },
  {
   value: "Usumatlán (GTUSU)",
   label: "Usumatlán (GTUSU)"
  },
  {
   value: "Villa Canales (GTVLL)",
   label: "Villa Canales (GTVLL)"
  },
  {
   value: "Villalobos (GTVLO)",
   label: "Villalobos (GTVLO)"
  },
  {
   value: ".GUAM (GU)",
   label: ".GUAM (GU)"
  },
  {
   value: "Santa Rita (GUSAN)",
   label: "Santa Rita (GUSAN)"
  },
  {
   value: ".GUINEA-BISSAU (GW)",
   label: ".GUINEA-BISSAU (GW)"
  },
  {
   value: "Binta (GWBNT)",
   label: "Binta (GWBNT)"
  },
  {
   value: "Canjaja (GWCJA)",
   label: "Canjaja (GWCJA)"
  },
  {
   value: "Farim (GWFAR)",
   label: "Farim (GWFAR)"
  },
  {
   value: ".GUYANA (GY)",
   label: ".GUYANA (GY)"
  },
  {
   value: "Adventure (GYANT)",
   label: "Adventure (GYANT)"
  },
  {
   value: "Everton (GYEVR)",
   label: "Everton (GYEVR)"
  },
  {
   value: "Linden (GYLDN)",
   label: "Linden (GYLDN)"
  },
  {
   value: "Mackenzie (GYMKZ)",
   label: "Mackenzie (GYMKZ)"
  },
  {
   value: ".HONG KONG (HK)",
   label: ".HONG KONG (HK)"
  },
  {
   value: "Ap Lei Chau (HKALC)",
   label: "Ap Lei Chau (HKALC)"
  },
  {
   value: "Causeway Bay (HKCWB)",
   label: "Causeway Bay (HKCWB)"
  },
  {
   value: "Chai Wan (HKCHW)",
   label: "Chai Wan (HKCHW)"
  },
  {
   value: "Ha Kwai Chung (HKHKC)",
   label: "Ha Kwai Chung (HKHKC)"
  },
  {
   value: "Kwai Chung (HKKCO)",
   label: "Kwai Chung (HKKCO)"
  },
  {
   value: "Lai Chi Kok (HKLCK)",
   label: "Lai Chi Kok (HKLCK)"
  },
  {
   value: "Lamma I. (HKLAM)",
   label: "Lamma I. (HKLAM)"
  },
  {
   value: "Quarry Bay (HKQBY)",
   label: "Quarry Bay (HKQBY)"
  },
  {
   value: "Sha Tin (HKSTN)",
   label: "Sha Tin (HKSTN)"
  },
  {
   value: "Sham Shui Po (HKSSP)",
   label: "Sham Shui Po (HKSSP)"
  },
  {
   value: "Sheung Shui (HKSGS)",
   label: "Sheung Shui (HKSGS)"
  },
  {
   value: "Tai Kok Tsui (HKTKT)",
   label: "Tai Kok Tsui (HKTKT)"
  },
  {
   value: "Tai Lang Shui (HKTLS)",
   label: "Tai Lang Shui (HKTLS)"
  },
  {
   value: "Tuen Mun (HKMUN)",
   label: "Tuen Mun (HKMUN)"
  },
  {
   value: "Wanchai (HKWNI)",
   label: "Wanchai (HKWNI)"
  },
  {
   value: "Yuen Long (HKYUE)",
   label: "Yuen Long (HKYUE)"
  },
  {
   value: ".HEARD ISLAND AND MCDONALD ISLANDS (HM)",
   label: ".HEARD ISLAND AND MCDONALD ISLANDS (HM)"
  },
  {
   value: "Heard Island (HMHEA)",
   label: "Heard Island (HMHEA)"
  },
  {
   value: "McDonald Island (HMMCD)",
   label: "McDonald Island (HMMCD)"
  },
  {
   value: ".HONDURAS (HN)",
   label: ".HONDURAS (HN)"
  },
  {
   value: "Amarateca (HNART)",
   label: "Amarateca (HNART)"
  },
  {
   value: "Amatillo (HNHAD)",
   label: "Amatillo (HNHAD)"
  },
  {
   value: "Arizona (HNAZA)",
   label: "Arizona (HNAZA)"
  },
  {
   value: "Búfalo (HNBUF)",
   label: "Búfalo (HNBUF)"
  },
  {
   value: "Caracol (HNHAN)",
   label: "Caracol (HNHAN)"
  },
  {
   value: "Choluteca (HNCHT)",
   label: "Choluteca (HNCHT)"
  },
  {
   value: "Chumbagua (HNCHU)",
   label: "Chumbagua (HNCHU)"
  },
  {
   value: "Cofradia (HNCFR)",
   label: "Cofradia (HNCFR)"
  },
  {
   value: "Cofradía (HNCOF)",
   label: "Cofradía (HNCOF)"
  },
  {
   value: "Comayagua (HNCMY)",
   label: "Comayagua (HNCMY)"
  },
  {
   value: "Concordia (HNCOR)",
   label: "Concordia (HNCOR)"
  },
  {
   value: "Corinto (HNHAC)",
   label: "Corinto (HNHAC)"
  },
  {
   value: "Cuyamapa (HNCUY)",
   label: "Cuyamapa (HNCUY)"
  },
  {
   value: "Danlí (HNDNL)",
   label: "Danlí (HNDNL)"
  },
  {
   value: "El Calán (HNELC)",
   label: "El Calán (HNELC)"
  },
  {
   value: "El Mochito (HNEMO)",
   label: "El Mochito (HNEMO)"
  },
  {
   value: "El Paraiso (HNEPO)",
   label: "El Paraiso (HNEPO)"
  },
  {
   value: "El Poy (HNEPY)",
   label: "El Poy (HNEPY)"
  },
  {
   value: "El Progreso (HNPRO)",
   label: "El Progreso (HNPRO)"
  },
  {
   value: "El Zamorano (HNHAM)",
   label: "El Zamorano (HNHAM)"
  },
  {
   value: "Jesus de Otoro (HNJDO)",
   label: "Jesus de Otoro (HNJDO)"
  },
  {
   value: "La Flecha (HNHAA)",
   label: "La Flecha (HNHAA)"
  },
  {
   value: "La Lima (HNLLM)",
   label: "La Lima (HNLLM)"
  },
  {
   value: "La Masica (HNLMA)",
   label: "La Masica (HNLMA)"
  },
  {
   value: "La Paz (HNHAE)",
   label: "La Paz (HNHAE)"
  },
  {
   value: "Morazán (HNMZN)",
   label: "Morazán (HNMZN)"
  },
  {
   value: "Naco (HNNAC)",
   label: "Naco (HNNAC)"
  },
  {
   value: "Nueva Ocotepeque (HNNOC)",
   label: "Nueva Ocotepeque (HNNOC)"
  },
  {
   value: "Ocotepeque (HNHAF)",
   label: "Ocotepeque (HNHAF)"
  },
  {
   value: "Omoa (HNOMO)",
   label: "Omoa (HNOMO)"
  },
  {
   value: "Pimienta (HNHAB)",
   label: "Pimienta (HNHAB)"
  },
  {
   value: "Pimienta (HNPIM)",
   label: "Pimienta (HNPIM)"
  },
  {
   value: "Potrerillos (HNPTL)",
   label: "Potrerillos (HNPTL)"
  },
  {
   value: "Quimistan (HNHAG)",
   label: "Quimistan (HNHAG)"
  },
  {
   value: "Rio Blanquito (HNHAH)",
   label: "Rio Blanquito (HNHAH)"
  },
  {
   value: "Rio Lindo (HNRLD)",
   label: "Rio Lindo (HNRLD)"
  },
  {
   value: "Río Nance (HNRIO)",
   label: "Río Nance (HNRIO)"
  },
  {
   value: "Sabanagrande (HNSGD)",
   label: "Sabanagrande (HNSGD)"
  },
  {
   value: "San Francisco de Yojoa (HNSFY)",
   label: "San Francisco de Yojoa (HNSFY)"
  },
  {
   value: "San Ignacio (HNHAL)",
   label: "San Ignacio (HNHAL)"
  },
  {
   value: "San Marcos de Colón (HNSMC)",
   label: "San Marcos de Colón (HNSMC)"
  },
  {
   value: "Santa Barbara (HNSBA)",
   label: "Santa Barbara (HNSBA)"
  },
  {
   value: "Santa Cruz de Yojoa (HNHAI)",
   label: "Santa Cruz de Yojoa (HNHAI)"
  },
  {
   value: "Santa Rita (HNSAN)",
   label: "Santa Rita (HNSAN)"
  },
  {
   value: "Santa Rita (HNSRI)",
   label: "Santa Rita (HNSRI)"
  },
  {
   value: "Siguatepeque (HNSTP)",
   label: "Siguatepeque (HNSTP)"
  },
  {
   value: "Sinuapa (HNSIN)",
   label: "Sinuapa (HNSIN)"
  },
  {
   value: "Sula (HNHAJ)",
   label: "Sula (HNHAJ)"
  },
  {
   value: "Talanga (HNTGA)",
   label: "Talanga (HNTGA)"
  },
  {
   value: "Tamara (HNHAK)",
   label: "Tamara (HNHAK)"
  },
  {
   value: "Trinidad (HNHAO)",
   label: "Trinidad (HNHAO)"
  },
  {
   value: "Valle de Ángeles (HNVDA)",
   label: "Valle de Ángeles (HNVDA)"
  },
  {
   value: "Villanueva (HNVNA)",
   label: "Villanueva (HNVNA)"
  },
  {
   value: "Yoro (HNORO)",
   label: "Yoro (HNORO)"
  },
  {
   value: "Yoro (HNYOR)",
   label: "Yoro (HNYOR)"
  },
  {
   value: ".CROATIA (HR)",
   label: ".CROATIA (HR)"
  },
  {
   value: "Aljmas (HRALJ)",
   label: "Aljmas (HRALJ)"
  },
  {
   value: "Antenal (HRATL)",
   label: "Antenal (HRATL)"
  },
  {
   value: "Baska (HRBAS)",
   label: "Baska (HRBAS)"
  },
  {
   value: "Baska Voda (HRBVO)",
   label: "Baska Voda (HRBVO)"
  },
  {
   value: "Batina (HRBAT)",
   label: "Batina (HRBAT)"
  },
  {
   value: "Batina (HRBTN)",
   label: "Batina (HRBTN)"
  },
  {
   value: "Bedekovcina (HRBKC)",
   label: "Bedekovcina (HRBKC)"
  },
  {
   value: "Belisce (HRBLC)",
   label: "Belisce (HRBLC)"
  },
  {
   value: "Benkovac (HRHBC)",
   label: "Benkovac (HRHBC)"
  },
  {
   value: "Biograd na Moru (HRBNM)",
   label: "Biograd na Moru (HRBNM)"
  },
  {
   value: "Bjelovar (HRBJE)",
   label: "Bjelovar (HRBJE)"
  },
  {
   value: "Blace (HRBLE)",
   label: "Blace (HRBLE)"
  },
  {
   value: "Bol (HRBOL)",
   label: "Bol (HRBOL)"
  },
  {
   value: "Boljun (HRBJN)",
   label: "Boljun (HRBJN)"
  },
  {
   value: "Borovo (HRBOR)",
   label: "Borovo (HRBOR)"
  },
  {
   value: "Borovo Selo (HRBRV)",
   label: "Borovo Selo (HRBRV)"
  },
  {
   value: "Botovo (HRBOT)",
   label: "Botovo (HRBOT)"
  },
  {
   value: "Bozava (HRBZA)",
   label: "Bozava (HRBZA)"
  },
  {
   value: "Brbinj\/Lucina (HRBRB)",
   label: "Brbinj\/Lucina (HRBRB)"
  },
  {
   value: "Brezovica (HRBVA)",
   label: "Brezovica (HRBVA)"
  },
  {
   value: "Brinje (HRBRE)",
   label: "Brinje (HRBRE)"
  },
  {
   value: "Brioni (HRBRI)",
   label: "Brioni (HRBRI)"
  },
  {
   value: "Buzet (HRBUZ)",
   label: "Buzet (HRBUZ)"
  },
  {
   value: "Cakovec (HRCAK)",
   label: "Cakovec (HRCAK)"
  },
  {
   value: "Cavtat (HRCVT)",
   label: "Cavtat (HRCVT)"
  },
  {
   value: "Cres (HRCRS)",
   label: "Cres (HRCRS)"
  },
  {
   value: "Crikvenica (HRCRA)",
   label: "Crikvenica (HRCRA)"
  },
  {
   value: "Crnac (HRCRN)",
   label: "Crnac (HRCRN)"
  },
  {
   value: "Dalj (HRDLJ)",
   label: "Dalj (HRDLJ)"
  },
  {
   value: "Dalmacia (HRDAL)",
   label: "Dalmacia (HRDAL)"
  },
  {
   value: "Darda (HRDDA)",
   label: "Darda (HRDDA)"
  },
  {
   value: "Daruvar (HRDAR)",
   label: "Daruvar (HRDAR)"
  },
  {
   value: "Davor (HRDVR)",
   label: "Davor (HRDVR)"
  },
  {
   value: "Delnice (HRDEL)",
   label: "Delnice (HRDEL)"
  },
  {
   value: "Donja Dubrava (HRDDU)",
   label: "Donja Dubrava (HRDDU)"
  },
  {
   value: "Donje Celo (HRDNC)",
   label: "Donje Celo (HRDNC)"
  },
  {
   value: "Donji Kraljevec (HRDKC)",
   label: "Donji Kraljevec (HRDKC)"
  },
  {
   value: "Donji Miholjac (HRDMH)",
   label: "Donji Miholjac (HRDMH)"
  },
  {
   value: "Drvenik (HRDRK)",
   label: "Drvenik (HRDRK)"
  },
  {
   value: "Dubravica (HRDVA)",
   label: "Dubravica (HRDVA)"
  },
  {
   value: "Dugo Sela (HRDGS)",
   label: "Dugo Sela (HRDGS)"
  },
  {
   value: "Dugopolje (HRDUG)",
   label: "Dugopolje (HRDUG)"
  },
  {
   value: "Durmanec (HRDMC)",
   label: "Durmanec (HRDMC)"
  },
  {
   value: "Erdut (HRERD)",
   label: "Erdut (HRERD)"
  },
  {
   value: "Fazana (HRFNA)",
   label: "Fazana (HRFNA)"
  },
  {
   value: "Filipjakov (HRFIL)",
   label: "Filipjakov (HRFIL)"
  },
  {
   value: "Fizine (HRFUZ)",
   label: "Fizine (HRFUZ)"
  },
  {
   value: "Garesnica (HRGAR)",
   label: "Garesnica (HRGAR)"
  },
  {
   value: "Gazenica (HRGNA)",
   label: "Gazenica (HRGNA)"
  },
  {
   value: "Gomirje (HRGOM)",
   label: "Gomirje (HRGOM)"
  },
  {
   value: "Gorican (HRGCN)",
   label: "Gorican (HRGCN)"
  },
  {
   value: "Gospic (HRGSP)",
   label: "Gospic (HRGSP)"
  },
  {
   value: "Gracac (HRGRA)",
   label: "Gracac (HRGRA)"
  },
  {
   value: "Gunja (HRGNJ)",
   label: "Gunja (HRGNJ)"
  },
  {
   value: "Hrvatski Leskovac (HRHLE)",
   label: "Hrvatski Leskovac (HRHLE)"
  },
  {
   value: "Hum na Sutli (HRHNS)",
   label: "Hum na Sutli (HRHNS)"
  },
  {
   value: "Ilok (HRILO)",
   label: "Ilok (HRILO)"
  },
  {
   value: "Ist (HRIST)",
   label: "Ist (HRIST)"
  },
  {
   value: "Ivanec (HRHIC)",
   label: "Ivanec (HRHIC)"
  },
  {
   value: "Ivanic-Grad (HRHID)",
   label: "Ivanic-Grad (HRHID)"
  },
  {
   value: "Jablanac (HRJAB)",
   label: "Jablanac (HRJAB)"
  },
  {
   value: "Jablanovec (HRJNC)",
   label: "Jablanovec (HRJNC)"
  },
  {
   value: "Jadrija (HRJDR)",
   label: "Jadrija (HRJDR)"
  },
  {
   value: "Jasenovac (HRJAS)",
   label: "Jasenovac (HRJAS)"
  },
  {
   value: "Jastrebarsko (HRJBO)",
   label: "Jastrebarsko (HRJBO)"
  },
  {
   value: "Jelsa (HRJSA)",
   label: "Jelsa (HRJSA)"
  },
  {
   value: "Kali (HRKAL)",
   label: "Kali (HRKAL)"
  },
  {
   value: "Kalinovica (HRHKA)",
   label: "Kalinovica (HRHKA)"
  },
  {
   value: "Kanfanar (HRKFR)",
   label: "Kanfanar (HRKFR)"
  },
  {
   value: "Kaprije (HRKPR)",
   label: "Kaprije (HRKPR)"
  },
  {
   value: "Karlobag (HRKAB)",
   label: "Karlobag (HRKAB)"
  },
  {
   value: "Karlovac (HRKAR)",
   label: "Karlovac (HRKAR)"
  },
  {
   value: "Kasina (HRKAI)",
   label: "Kasina (HRKAI)"
  },
  {
   value: "Kastel Sucurac (HRKAS)",
   label: "Kastel Sucurac (HRKAS)"
  },
  {
   value: "Klana (HRKNA)",
   label: "Klana (HRKNA)"
  },
  {
   value: "Klek (HRKLK)",
   label: "Klek (HRKLK)"
  },
  {
   value: "Klimno (HRKMN)",
   label: "Klimno (HRKMN)"
  },
  {
   value: "Kneza (HRKZA)",
   label: "Kneza (HRKZA)"
  },
  {
   value: "Knin (HRKNI)",
   label: "Knin (HRKNI)"
  },
  {
   value: "Komiza (HRKMZ)",
   label: "Komiza (HRKMZ)"
  },
  {
   value: "Koprivnica (HRKOV)",
   label: "Koprivnica (HRKOV)"
  },
  {
   value: "Koprno (HRKOP)",
   label: "Koprno (HRKOP)"
  },
  {
   value: "Koromacno (HRKRM)",
   label: "Koromacno (HRKRM)"
  },
  {
   value: "Kostrena (HRKOS)",
   label: "Kostrena (HRKOS)"
  },
  {
   value: "Kraljevica (HRKRA)",
   label: "Kraljevica (HRKRA)"
  },
  {
   value: "Krapina (HRKPA)",
   label: "Krapina (HRKPA)"
  },
  {
   value: "Krasica (HRPGK)",
   label: "Krasica (HRPGK)"
  },
  {
   value: "Kriz (HRKRZ)",
   label: "Kriz (HRKRZ)"
  },
  {
   value: "Krizevci (HRKRI)",
   label: "Krizevci (HRKRI)"
  },
  {
   value: "Krk (HRKRK)",
   label: "Krk (HRKRK)"
  },
  {
   value: "Krsan (HRKRD)",
   label: "Krsan (HRKRD)"
  },
  {
   value: "Kukljica (HRKUK)",
   label: "Kukljica (HRKUK)"
  },
  {
   value: "Kutina (HRKUT)",
   label: "Kutina (HRKUT)"
  },
  {
   value: "Lamjane (HRLAM)",
   label: "Lamjane (HRLAM)"
  },
  {
   value: "Lastovo (HRLST)",
   label: "Lastovo (HRLST)"
  },
  {
   value: "Lokrum (HRLKR)",
   label: "Lokrum (HRLKR)"
  },
  {
   value: "Lokve (HRLKE)",
   label: "Lokve (HRLKE)"
  },
  {
   value: "Lopar (HRLPR)",
   label: "Lopar (HRLPR)"
  },
  {
   value: "Lopud (HRLPD)",
   label: "Lopud (HRLPD)"
  },
  {
   value: "Ludbreg (HRHLG)",
   label: "Ludbreg (HRHLG)"
  },
  {
   value: "Macinec (HRMCC)",
   label: "Macinec (HRMCC)"
  },
  {
   value: "Mackovac (HRMAC)",
   label: "Mackovac (HRMAC)"
  },
  {
   value: "Makarska (HRMAK)",
   label: "Makarska (HRMAK)"
  },
  {
   value: "Mali Iz (HRMIZ)",
   label: "Mali Iz (HRMIZ)"
  },
  {
   value: "Malinska (HRMAL)",
   label: "Malinska (HRMAL)"
  },
  {
   value: "Martinscica (HRMTA)",
   label: "Martinscica (HRMTA)"
  },
  {
   value: "Martinska Ves Desna (HRMAV)",
   label: "Martinska Ves Desna (HRMAV)"
  },
  {
   value: "Marusevec (HRMSC)",
   label: "Marusevec (HRMSC)"
  },
  {
   value: "Merag (HRMRG)",
   label: "Merag (HRMRG)"
  },
  {
   value: "Metkovic (HRMET)",
   label: "Metkovic (HRMET)"
  },
  {
   value: "Milna (HRMIL)",
   label: "Milna (HRMIL)"
  },
  {
   value: "Misnjak (HRMNK)",
   label: "Misnjak (HRMNK)"
  },
  {
   value: "Mohovo (HRMHV)",
   label: "Mohovo (HRMHV)"
  },
  {
   value: "Molve (HRMLE)",
   label: "Molve (HRMLE)"
  },
  {
   value: "Moscenicka Draga (HRMOD)",
   label: "Moscenicka Draga (HRMOD)"
  },
  {
   value: "Motovun (HRMVN)",
   label: "Motovun (HRMVN)"
  },
  {
   value: "Muna na Zirju (HRMRJ)",
   label: "Muna na Zirju (HRMRJ)"
  },
  {
   value: "Murter (HRMUR)",
   label: "Murter (HRMUR)"
  },
  {
   value: "Nadin (HRNDN)",
   label: "Nadin (HRNDN)"
  },
  {
   value: "Nedelise (HRNLE)",
   label: "Nedelise (HRNLE)"
  },
  {
   value: "Nemetin (HRNEM)",
   label: "Nemetin (HRNEM)"
  },
  {
   value: "Nerezine (HRNRZ)",
   label: "Nerezine (HRNRZ)"
  },
  {
   value: "Nova Gradiska (HRNGR)",
   label: "Nova Gradiska (HRNGR)"
  },
  {
   value: "Novaglia (HRNOV)",
   label: "Novaglia (HRNOV)"
  },
  {
   value: "Novalja (HRNVL)",
   label: "Novalja (HRNVL)"
  },
  {
   value: "Novi Marof (HRNVM)",
   label: "Novi Marof (HRNVM)"
  },
  {
   value: "Novi Vinodolski (HRNVD)",
   label: "Novi Vinodolski (HRNVD)"
  },
  {
   value: "Novigrad (HRNVG)",
   label: "Novigrad (HRNVG)"
  },
  {
   value: "Obonjan (HRONJ)",
   label: "Obonjan (HRONJ)"
  },
  {
   value: "Obrovac (HROBR)",
   label: "Obrovac (HROBR)"
  },
  {
   value: "Ogulin (HROGU)",
   label: "Ogulin (HROGU)"
  },
  {
   value: "Omis (HROMS)",
   label: "Omis (HROMS)"
  },
  {
   value: "Opatija (HROPA)",
   label: "Opatija (HROPA)"
  },
  {
   value: "Opatovac (HROPT)",
   label: "Opatovac (HROPT)"
  },
  {
   value: "Orahovica (HROVA)",
   label: "Orahovica (HROVA)"
  },
  {
   value: "Orebic (HRORB)",
   label: "Orebic (HRORB)"
  },
  {
   value: "Oriovac (HROVC)",
   label: "Oriovac (HROVC)"
  },
  {
   value: "Otocac (HROTO)",
   label: "Otocac (HROTO)"
  },
  {
   value: "Pag (HRPAG)",
   label: "Pag (HRPAG)"
  },
  {
   value: "Pasman (HRPAS)",
   label: "Pasman (HRPAS)"
  },
  {
   value: "Pazin (HRPAZ)",
   label: "Pazin (HRPAZ)"
  },
  {
   value: "Petrinja (HRPIJ)",
   label: "Petrinja (HRPIJ)"
  },
  {
   value: "Plomin (HRPLM)",
   label: "Plomin (HRPLM)"
  },
  {
   value: "Podravska Moslavina (HRMPD)",
   label: "Podravska Moslavina (HRMPD)"
  },
  {
   value: "Polace (HRPLA)",
   label: "Polace (HRPLA)"
  },
  {
   value: "Pomena (HRPMN)",
   label: "Pomena (HRPMN)"
  },
  {
   value: "Porec (HRPOR)",
   label: "Porec (HRPOR)"
  },
  {
   value: "Porozina (HRPRZ)",
   label: "Porozina (HRPRZ)"
  },
  {
   value: "Postire (HRHPC)",
   label: "Postire (HRHPC)"
  },
  {
   value: "Postire (HRPOS)",
   label: "Postire (HRPOS)"
  },
  {
   value: "Pozega (HRPZG)",
   label: "Pozega (HRPZG)"
  },
  {
   value: "Prapratno (HRPRP)",
   label: "Prapratno (HRPRP)"
  },
  {
   value: "Pregrada (HRPGA)",
   label: "Pregrada (HRPGA)"
  },
  {
   value: "Preko (HRPRE)",
   label: "Preko (HRPRE)"
  },
  {
   value: "Prelog (HRHPG)",
   label: "Prelog (HRHPG)"
  },
  {
   value: "Primosten (HRPRI)",
   label: "Primosten (HRPRI)"
  },
  {
   value: "Prizna (HRPRN)",
   label: "Prizna (HRPRN)"
  },
  {
   value: "Prvic (HRPRV)",
   label: "Prvic (HRPRV)"
  },
  {
   value: "Prvic Sepurine (HRPRS)",
   label: "Prvic Sepurine (HRPRS)"
  },
  {
   value: "Pucisca (HRPCA)",
   label: "Pucisca (HRPCA)"
  },
  {
   value: "Punat (HRPNT)",
   label: "Punat (HRPNT)"
  },
  {
   value: "Rab (HRRAB)",
   label: "Rab (HRRAB)"
  },
  {
   value: "Rabac (HRRBC)",
   label: "Rabac (HRRBC)"
  },
  {
   value: "Rasinja (HRRSA)",
   label: "Rasinja (HRRSA)"
  },
  {
   value: "Ravna Gora (HRRGO)",
   label: "Ravna Gora (HRRGO)"
  },
  {
   value: "Rogac (HRRGC)",
   label: "Rogac (HRRGC)"
  },
  {
   value: "Rogotin (HRROG)",
   label: "Rogotin (HRROG)"
  },
  {
   value: "Rogoznica (HRRGN)",
   label: "Rogoznica (HRRGN)"
  },
  {
   value: "Sali (HRSAL)",
   label: "Sali (HRSAL)"
  },
  {
   value: "Sarengrad (HRSRG)",
   label: "Sarengrad (HRSRG)"
  },
  {
   value: "Satnica Dakovaccka (HRSDA)",
   label: "Satnica Dakovaccka (HRSDA)"
  },
  {
   value: "Savski Marof (HRSVM)",
   label: "Savski Marof (HRSVM)"
  },
  {
   value: "Selce (HRSLC)",
   label: "Selce (HRSLC)"
  },
  {
   value: "Sesvete (HRSVE)",
   label: "Sesvete (HRSVE)"
  },
  {
   value: "Sesvete (HRVET)",
   label: "Sesvete (HRVET)"
  },
  {
   value: "Silba (HRSIL)",
   label: "Silba (HRSIL)"
  },
  {
   value: "Silo (HRSLO)",
   label: "Silo (HRSLO)"
  },
  {
   value: "Sinj (HRSIN)",
   label: "Sinj (HRSIN)"
  },
  {
   value: "Sisak (HRSIS)",
   label: "Sisak (HRSIS)"
  },
  {
   value: "Sisinec (HRSSN)",
   label: "Sisinec (HRSSN)"
  },
  {
   value: "Skradin (HRSRD)",
   label: "Skradin (HRSRD)"
  },
  {
   value: "Skrljevo (HRSJO)",
   label: "Skrljevo (HRSJO)"
  },
  {
   value: "Slano (HRSLA)",
   label: "Slano (HRSLA)"
  },
  {
   value: "Slatine (HRSLT)",
   label: "Slatine (HRSLT)"
  },
  {
   value: "Slavonski Brod (HRSBD)",
   label: "Slavonski Brod (HRSBD)"
  },
  {
   value: "Slavonski Kobas (HRSKB)",
   label: "Slavonski Kobas (HRSKB)"
  },
  {
   value: "Slavonski Sabac (HRSSB)",
   label: "Slavonski Sabac (HRSSB)"
  },
  {
   value: "Slum (HRSLM)",
   label: "Slum (HRSLM)"
  },
  {
   value: "Slunj (HRSLU)",
   label: "Slunj (HRSLU)"
  },
  {
   value: "Sobra (HRSBR)",
   label: "Sobra (HRSBR)"
  },
  {
   value: "Sotin (HRSOT)",
   label: "Sotin (HRSOT)"
  },
  {
   value: "Splitska (HRSPL)",
   label: "Splitska (HRSPL)"
  },
  {
   value: "Stara Gradiska (HRSGS)",
   label: "Stara Gradiska (HRSGS)"
  },
  {
   value: "Stari Grad (HRSGD)",
   label: "Stari Grad (HRSGD)"
  },
  {
   value: "Starigrad (HRSGR)",
   label: "Starigrad (HRSGR)"
  },
  {
   value: "Stobrec (HRSBC)",
   label: "Stobrec (HRSBC)"
  },
  {
   value: "Stomorska (HRSTM)",
   label: "Stomorska (HRSTM)"
  },
  {
   value: "Ston (HRSTO)",
   label: "Ston (HRSTO)"
  },
  {
   value: "Strigova (HRSGA)",
   label: "Strigova (HRSGA)"
  },
  {
   value: "Sucurac (HRSUR)",
   label: "Sucurac (HRSUR)"
  },
  {
   value: "Sudurad (HRSDR)",
   label: "Sudurad (HRSDR)"
  },
  {
   value: "Sumartin (HRSMN)",
   label: "Sumartin (HRSMN)"
  },
  {
   value: "Supetar (HRSUP)",
   label: "Supetar (HRSUP)"
  },
  {
   value: "Susak (HRSSK)",
   label: "Susak (HRSSK)"
  },
  {
   value: "Sustjepan (HRSTP)",
   label: "Sustjepan (HRSTP)"
  },
  {
   value: "Sutivan (HRSUT)",
   label: "Sutivan (HRSUT)"
  },
  {
   value: "Sveta Nedjelja (HRSVN)",
   label: "Sveta Nedjelja (HRSVN)"
  },
  {
   value: "Sveti Ivan Zelina (HRSIZ)",
   label: "Sveti Ivan Zelina (HRSIZ)"
  },
  {
   value: "Sveti Juraj (HRSVJ)",
   label: "Sveti Juraj (HRSVJ)"
  },
  {
   value: "Terezino Polje (HRTPO)",
   label: "Terezino Polje (HRTPO)"
  },
  {
   value: "Terezino Polje (HRTRP)",
   label: "Terezino Polje (HRTRP)"
  },
  {
   value: "Tinjan (HRTJN)",
   label: "Tinjan (HRTJN)"
  },
  {
   value: "Tisno (HRTNO)",
   label: "Tisno (HRTNO)"
  },
  {
   value: "Tkon (HRTKN)",
   label: "Tkon (HRTKN)"
  },
  {
   value: "Trnjani (HRTJI)",
   label: "Trnjani (HRTJI)"
  },
  {
   value: "Trnovec Bartolovecki (HRTRB)",
   label: "Trnovec Bartolovecki (HRTRB)"
  },
  {
   value: "Trogir (HRTRO)",
   label: "Trogir (HRTRO)"
  },
  {
   value: "Trpanj (HRTRJ)",
   label: "Trpanj (HRTRJ)"
  },
  {
   value: "Trstenik (HRTRK)",
   label: "Trstenik (HRTRK)"
  },
  {
   value: "Tunarica (HRTNR)",
   label: "Tunarica (HRTNR)"
  },
  {
   value: "Turanj (HRTUR)",
   label: "Turanj (HRTUR)"
  },
  {
   value: "Ubli (HRUBL)",
   label: "Ubli (HRUBL)"
  },
  {
   value: "Ugljan (HRUGL)",
   label: "Ugljan (HRUGL)"
  },
  {
   value: "Umag (HRUMG)",
   label: "Umag (HRUMG)"
  },
  {
   value: "Unije (HRUNJ)",
   label: "Unije (HRUNJ)"
  },
  {
   value: "Uvala Mir (HRUVM)",
   label: "Uvala Mir (HRUVM)"
  },
  {
   value: "Valbiska (HRVLB)",
   label: "Valbiska (HRVLB)"
  },
  {
   value: "Valpovo (HRVAL)",
   label: "Valpovo (HRVAL)"
  },
  {
   value: "Varazdin (HRVZN)",
   label: "Varazdin (HRVZN)"
  },
  {
   value: "Vela Luka (HRVLK)",
   label: "Vela Luka (HRVLK)"
  },
  {
   value: "Veli Iz (HRVIZ)",
   label: "Veli Iz (HRVIZ)"
  },
  {
   value: "Veli Losinj (HRVLN)",
   label: "Veli Losinj (HRVLN)"
  },
  {
   value: "Velika Gorica (HRVGO)",
   label: "Velika Gorica (HRVGO)"
  },
  {
   value: "Velika Kopanica (HRVKO)",
   label: "Velika Kopanica (HRVKO)"
  },
  {
   value: "Viganj (HRVGN)",
   label: "Viganj (HRVGN)"
  },
  {
   value: "Vinkovci (HRVIN)",
   label: "Vinkovci (HRVIN)"
  },
  {
   value: "Vir (HRVIR)",
   label: "Vir (HRVIR)"
  },
  {
   value: "Vis (HRVIS)",
   label: "Vis (HRVIS)"
  },
  {
   value: "Viskovo (HRVKV)",
   label: "Viskovo (HRVKV)"
  },
  {
   value: "Vodice (HRVDC)",
   label: "Vodice (HRVDC)"
  },
  {
   value: "Vranjic (HRVRN)",
   label: "Vranjic (HRVRN)"
  },
  {
   value: "Vrbnik (HRVRK)",
   label: "Vrbnik (HRVRK)"
  },
  {
   value: "Vrboska (HRVRS)",
   label: "Vrboska (HRVRS)"
  },
  {
   value: "Vrgada (HRVRG)",
   label: "Vrgada (HRVRG)"
  },
  {
   value: "Vrsar (HRVRR)",
   label: "Vrsar (HRVRR)"
  },
  {
   value: "Vukovar (HRVUK)",
   label: "Vukovar (HRVUK)"
  },
  {
   value: "Zabok (HRZBK)",
   label: "Zabok (HRZBK)"
  },
  {
   value: "Zelina (HRHZA)",
   label: "Zelina (HRHZA)"
  },
  {
   value: "Zigljen (HRZGL)",
   label: "Zigljen (HRZGL)"
  },
  {
   value: "Zlarin (HRZLR)",
   label: "Zlarin (HRZLR)"
  },
  {
   value: "Zlatar (HRZLA)",
   label: "Zlatar (HRZLA)"
  },
  {
   value: "Zminj (HRZMJ)",
   label: "Zminj (HRZMJ)"
  },
  {
   value: "Zupanja (HRZUP)",
   label: "Zupanja (HRZUP)"
  },
  {
   value: "Zut Marina (HRZUT)",
   label: "Zut Marina (HRZUT)"
  },
  {
   value: ".HAITI (HT)",
   label: ".HAITI (HT)"
  },
  {
   value: "Caracol (HTCRC)",
   label: "Caracol (HTCRC)"
  },
  {
   value: "Labadie (HTLAB)",
   label: "Labadie (HTLAB)"
  },
  {
   value: "Poty (HTPTY)",
   label: "Poty (HTPTY)"
  },
  {
   value: "Tabarre (HTTAB)",
   label: "Tabarre (HTTAB)"
  },
  {
   value: ".HUNGARY (HU)",
   label: ".HUNGARY (HU)"
  },
  {
   value: "Abaújszántó (HUHAM)",
   label: "Abaújszántó (HUHAM)"
  },
  {
   value: "Abony (HUABO)",
   label: "Abony (HUABO)"
  },
  {
   value: "Acs (HUHAY)",
   label: "Acs (HUHAY)"
  },
  {
   value: "Adony (HUADY)",
   label: "Adony (HUADY)"
  },
  {
   value: "Ajka (HUAJK)",
   label: "Ajka (HUAJK)"
  },
  {
   value: "Akasztó (HUATO)",
   label: "Akasztó (HUATO)"
  },
  {
   value: "Alattyán (HUALA)",
   label: "Alattyán (HUALA)"
  },
  {
   value: "Albertirsa (HUALB)",
   label: "Albertirsa (HUALB)"
  },
  {
   value: "Algyo (HUALG)",
   label: "Algyo (HUALG)"
  },
  {
   value: "Almásfüzitó (HUAFU)",
   label: "Almásfüzitó (HUAFU)"
  },
  {
   value: "Alsónémedi (HUAMI)",
   label: "Alsónémedi (HUAMI)"
  },
  {
   value: "Alsónémedi (HUSNM)",
   label: "Alsónémedi (HUSNM)"
  },
  {
   value: "Alsóörs (HUALS)",
   label: "Alsóörs (HUALS)"
  },
  {
   value: "Andornaktálya (HUAKT)",
   label: "Andornaktálya (HUAKT)"
  },
  {
   value: "Apostag (HUAPG)",
   label: "Apostag (HUAPG)"
  },
  {
   value: "Aszar (HUZAR)",
   label: "Aszar (HUZAR)"
  },
  {
   value: "Aszód (HUAZD)",
   label: "Aszód (HUAZD)"
  },
  {
   value: "Bábolna (HUBAB)",
   label: "Bábolna (HUBAB)"
  },
  {
   value: "Bácsbokod (HUBAC)",
   label: "Bácsbokod (HUBAC)"
  },
  {
   value: "Badacsonyörs (HUBRS)",
   label: "Badacsonyörs (HUBRS)"
  },
  {
   value: "Bagod (HUBGO)",
   label: "Bagod (HUBGO)"
  },
  {
   value: "Baj (HUKZB)",
   label: "Baj (HUKZB)"
  },
  {
   value: "Baja (HUBAA)",
   label: "Baja (HUBAA)"
  },
  {
   value: "Balatonfuzfo (HUBLA)",
   label: "Balatonfuzfo (HUBLA)"
  },
  {
   value: "Balmazújváros (HUBZS)",
   label: "Balmazújváros (HUBZS)"
  },
  {
   value: "Barand (HUHAQ)",
   label: "Barand (HUHAQ)"
  },
  {
   value: "Barcs (HUHAN)",
   label: "Barcs (HUHAN)"
  },
  {
   value: "Bárdudvarnok (HURVK)",
   label: "Bárdudvarnok (HURVK)"
  },
  {
   value: "Bataapati (HUBAI)",
   label: "Bataapati (HUBAI)"
  },
  {
   value: "Bátonyterenye (HUBTY)",
   label: "Bátonyterenye (HUBTY)"
  },
  {
   value: "Békés (HUBES)",
   label: "Békés (HUBES)"
  },
  {
   value: "Bekesszentandras (HUHAP)",
   label: "Bekesszentandras (HUHAP)"
  },
  {
   value: "Berettyóúfalu (HUBTF)",
   label: "Berettyóúfalu (HUBTF)"
  },
  {
   value: "Berhida (HUBDA)",
   label: "Berhida (HUBDA)"
  },
  {
   value: "Berzence (HUBZE)",
   label: "Berzence (HUBZE)"
  },
  {
   value: "Biatorbágy (HUBTB)",
   label: "Biatorbágy (HUBTB)"
  },
  {
   value: "Bicske (HUBIC)",
   label: "Bicske (HUBIC)"
  },
  {
   value: "Biri (HUBRI)",
   label: "Biri (HUBRI)"
  },
  {
   value: "Birjan (HUHAO)",
   label: "Birjan (HUHAO)"
  },
  {
   value: "Bodajk (HUBJK)",
   label: "Bodajk (HUBJK)"
  },
  {
   value: "Bodrogkisfalud (HURRV)",
   label: "Bodrogkisfalud (HURRV)"
  },
  {
   value: "Bokros (HUHAI)",
   label: "Bokros (HUHAI)"
  },
  {
   value: "Bóly (HUBOL)",
   label: "Bóly (HUBOL)"
  },
  {
   value: "Borsod (HUBOD)",
   label: "Borsod (HUBOD)"
  },
  {
   value: "Borsodnádasd (HUBOR)",
   label: "Borsodnádasd (HUBOR)"
  },
  {
   value: "Botykapeterd (HUBOT)",
   label: "Botykapeterd (HUBOT)"
  },
  {
   value: "Budakalász (HUBKL)",
   label: "Budakalász (HUBKL)"
  },
  {
   value: "Budaörs (HUBUA)",
   label: "Budaörs (HUBUA)"
  },
  {
   value: "Bugyi (HUHAD)",
   label: "Bugyi (HUHAD)"
  },
  {
   value: "Bük (HUBUK)",
   label: "Bük (HUBUK)"
  },
  {
   value: "Celldömölk (HUCEL)",
   label: "Celldömölk (HUCEL)"
  },
  {
   value: "Csávoly (HUCVY)",
   label: "Csávoly (HUCVY)"
  },
  {
   value: "Csemo (HUHAS)",
   label: "Csemo (HUHAS)"
  },
  {
   value: "Csenger (HUCGE)",
   label: "Csenger (HUCGE)"
  },
  {
   value: "Csepel (HUCPE)",
   label: "Csepel (HUCPE)"
  },
  {
   value: "Cserszegtomaj (HUCSD)",
   label: "Cserszegtomaj (HUCSD)"
  },
  {
   value: "Csévharaszt (HUHAR)",
   label: "Csévharaszt (HUHAR)"
  },
  {
   value: "Csömör (HUCMR)",
   label: "Csömör (HUCMR)"
  },
  {
   value: "Csorna (HUCSO)",
   label: "Csorna (HUCSO)"
  },
  {
   value: "Csorvas (HUCSV)",
   label: "Csorvas (HUCSV)"
  },
  {
   value: "Csurgo (HUCSU)",
   label: "Csurgo (HUCSU)"
  },
  {
   value: "Dabas (HUHAC)",
   label: "Dabas (HUHAC)"
  },
  {
   value: "Deszk (HUDZK)",
   label: "Deszk (HUDZK)"
  },
  {
   value: "Diósd (HUDIO)",
   label: "Diósd (HUDIO)"
  },
  {
   value: "Dombóvár (HUDOB)",
   label: "Dombóvár (HUDOB)"
  },
  {
   value: "Dorog (HUDOG)",
   label: "Dorog (HUDOG)"
  },
  {
   value: "Dorog (HUDRG)",
   label: "Dorog (HUDRG)"
  },
  {
   value: "Drégelypalánk (HUDGP)",
   label: "Drégelypalánk (HUDGP)"
  },
  {
   value: "Dudar (HUDDA)",
   label: "Dudar (HUDDA)"
  },
  {
   value: "Dunakiliti (HUDKI)",
   label: "Dunakiliti (HUDKI)"
  },
  {
   value: "Dunakiliti (HUDNI)",
   label: "Dunakiliti (HUDNI)"
  },
  {
   value: "Dunapataj (HUDPA)",
   label: "Dunapataj (HUDPA)"
  },
  {
   value: "Dunaremete (HUDRE)",
   label: "Dunaremete (HUDRE)"
  },
  {
   value: "Dunaszentmiklós (HUDUZ)",
   label: "Dunaszentmiklós (HUDUZ)"
  },
  {
   value: "Dunaújváros (HUDUU)",
   label: "Dunaújváros (HUDUU)"
  },
  {
   value: "Dunavarsány (HUDUK)",
   label: "Dunavarsány (HUDUK)"
  },
  {
   value: "Dunavecse (HUDVE)",
   label: "Dunavecse (HUDVE)"
  },
  {
   value: "Ecser (HUECR)",
   label: "Ecser (HUECR)"
  },
  {
   value: "Elek (HUELK)",
   label: "Elek (HUELK)"
  },
  {
   value: "Encs (HUENC)",
   label: "Encs (HUENC)"
  },
  {
   value: "Endrefalva (HUEDF)",
   label: "Endrefalva (HUEDF)"
  },
  {
   value: "Enying (HUENY)",
   label: "Enying (HUENY)"
  },
  {
   value: "Ercsi (HUERC)",
   label: "Ercsi (HUERC)"
  },
  {
   value: "Erd (HUHAA)",
   label: "Erd (HUHAA)"
  },
  {
   value: "Fácánkert (HUFAC)",
   label: "Fácánkert (HUFAC)"
  },
  {
   value: "Farmos (HUHAV)",
   label: "Farmos (HUHAV)"
  },
  {
   value: "Fehérgyarmat (HUFGA)",
   label: "Fehérgyarmat (HUFGA)"
  },
  {
   value: "Felcsut (HUHAU)",
   label: "Felcsut (HUHAU)"
  },
  {
   value: "Felsönyék (HUFNY)",
   label: "Felsönyék (HUFNY)"
  },
  {
   value: "Felsopakony (HUHAE)",
   label: "Felsopakony (HUHAE)"
  },
  {
   value: "Ferencvaros (HUFVS)",
   label: "Ferencvaros (HUFVS)"
  },
  {
   value: "Fertöd (HUFEO)",
   label: "Fertöd (HUFEO)"
  },
  {
   value: "Fertrszentmiklós (HUFEZ)",
   label: "Fertrszentmiklós (HUFEZ)"
  },
  {
   value: "Fót (HUFOT)",
   label: "Fót (HUFOT)"
  },
  {
   value: "Fügöd (HUFUO)",
   label: "Fügöd (HUFUO)"
  },
  {
   value: "Gárdony (HUGDY)",
   label: "Gárdony (HUGDY)"
  },
  {
   value: "Gecse (HUGCS)",
   label: "Gecse (HUGCS)"
  },
  {
   value: "Gelej (HUHAW)",
   label: "Gelej (HUHAW)"
  },
  {
   value: "Gerla (HUGRL)",
   label: "Gerla (HUGRL)"
  },
  {
   value: "Göd (HUOOD)",
   label: "Göd (HUOOD)"
  },
  {
   value: "Gógánfa (HUGOA)",
   label: "Gógánfa (HUGOA)"
  },
  {
   value: "Gónyú (HUGNY)",
   label: "Gónyú (HUGNY)"
  },
  {
   value: "Gyál (HUGYL)",
   label: "Gyál (HUGYL)"
  },
  {
   value: "Gyömrö (HUGYR)",
   label: "Gyömrö (HUGYR)"
  },
  {
   value: "Gyöngyös (HUGGY)",
   label: "Gyöngyös (HUGGY)"
  },
  {
   value: "Gyöngyöstárjan (HUGYJ)",
   label: "Gyöngyöstárjan (HUGYJ)"
  },
  {
   value: "Halásztelek (HUHAB)",
   label: "Halásztelek (HUHAB)"
  },
  {
   value: "Halásztelek (HUHAL)",
   label: "Halásztelek (HUHAL)"
  },
  {
   value: "Hejokurt (HUHAX)",
   label: "Hejokurt (HUHAX)"
  },
  {
   value: "Herceghalom (HUHGO)",
   label: "Herceghalom (HUHGO)"
  },
  {
   value: "Heves (HUHEV)",
   label: "Heves (HUHEV)"
  },
  {
   value: "Hódmezovásárhely (HUHMV)",
   label: "Hódmezovásárhely (HUHMV)"
  },
  {
   value: "Iklad (HUILD)",
   label: "Iklad (HUILD)"
  },
  {
   value: "Ipolytölgyes (HUIPS)",
   label: "Ipolytölgyes (HUIPS)"
  },
  {
   value: "Iszkaszentgyörgy (HUIZY)",
   label: "Iszkaszentgyörgy (HUIZY)"
  },
  {
   value: "Ivan (HUIVA)",
   label: "Ivan (HUIVA)"
  },
  {
   value: "Izsák (HUIZK)",
   label: "Izsák (HUIZK)"
  },
  {
   value: "Jánoshalma (HUJAO)",
   label: "Jánoshalma (HUJAO)"
  },
  {
   value: "Jánosháza (HUJHA)",
   label: "Jánosháza (HUJHA)"
  },
  {
   value: "Jánossomorja (HUJAN)",
   label: "Jánossomorja (HUJAN)"
  },
  {
   value: "Jászapáti (HUJSZ)",
   label: "Jászapáti (HUJSZ)"
  },
  {
   value: "Jászárokszállás (HUJKZ)",
   label: "Jászárokszállás (HUJKZ)"
  },
  {
   value: "Jászberény (HUJAS)",
   label: "Jászberény (HUJAS)"
  },
  {
   value: "Jászfényszaru (HUJAF)",
   label: "Jászfényszaru (HUJAF)"
  },
  {
   value: "Kaba (HUKAB)",
   label: "Kaba (HUKAB)"
  },
  {
   value: "Kalocsa (HUKCO)",
   label: "Kalocsa (HUKCO)"
  },
  {
   value: "Karcag (HUKAR)",
   label: "Karcag (HUKAR)"
  },
  {
   value: "Kaszok (HUCSK)",
   label: "Kaszok (HUCSK)"
  },
  {
   value: "Kazincbarcika (HUKAZ)",
   label: "Kazincbarcika (HUKAZ)"
  },
  {
   value: "Kekkut (HUKKU)",
   label: "Kekkut (HUKKU)"
  },
  {
   value: "Kerekegyháza (HUKGY)",
   label: "Kerekegyháza (HUKGY)"
  },
  {
   value: "Kereki (HUKRK)",
   label: "Kereki (HUKRK)"
  },
  {
   value: "Kerepestarcsa (HUKPE)",
   label: "Kerepestarcsa (HUKPE)"
  },
  {
   value: "Kernye (HUKER)",
   label: "Kernye (HUKER)"
  },
  {
   value: "Keszthely (HUKEZ)",
   label: "Keszthely (HUKEZ)"
  },
  {
   value: "Ketegyhaza (HUKET)",
   label: "Ketegyhaza (HUKET)"
  },
  {
   value: "Kéthely (HUKHY)",
   label: "Kéthely (HUKHY)"
  },
  {
   value: "Kevermes (HUKVE)",
   label: "Kevermes (HUKVE)"
  },
  {
   value: "Kiskõrös (HUKSO)",
   label: "Kiskõrös (HUKSO)"
  },
  {
   value: "Kiskorös (HUKKS)",
   label: "Kiskorös (HUKKS)"
  },
  {
   value: "Kiskunmajsa (HUKMJ)",
   label: "Kiskunmajsa (HUKMJ)"
  },
  {
   value: "Kistarcsa (HUKIT)",
   label: "Kistarcsa (HUKIT)"
  },
  {
   value: "Kistelek (HUKLK)",
   label: "Kistelek (HUKLK)"
  },
  {
   value: "Kisvárda (HUKIA)",
   label: "Kisvárda (HUKIA)"
  },
  {
   value: "Kópháza (HUKZA)",
   label: "Kópháza (HUKZA)"
  },
  {
   value: "Körmend (HUKOR)",
   label: "Körmend (HUKOR)"
  },
  {
   value: "Környe (HUHAG)",
   label: "Környe (HUHAG)"
  },
  {
   value: "Koroncó (HUKRO)",
   label: "Koroncó (HUKRO)"
  },
  {
   value: "Körösladány (HUKSD)",
   label: "Körösladány (HUKSD)"
  },
  {
   value: "Koszárhegy (HUKOZ)",
   label: "Koszárhegy (HUKOZ)"
  },
  {
   value: "Kunhegyes (HUKUN)",
   label: "Kunhegyes (HUKUN)"
  },
  {
   value: "Kunmadaras (HUKMD)",
   label: "Kunmadaras (HUKMD)"
  },
  {
   value: "Kunszallas (HUKSZ)",
   label: "Kunszallas (HUKSZ)"
  },
  {
   value: "Kunszentmiklós (HUKZM)",
   label: "Kunszentmiklós (HUKZM)"
  },
  {
   value: "Kunsziget (HUHZG)",
   label: "Kunsziget (HUHZG)"
  },
  {
   value: "Lábatlan (HULAB)",
   label: "Lábatlan (HULAB)"
  },
  {
   value: "Lágymányos (HULMY)",
   label: "Lágymányos (HULMY)"
  },
  {
   value: "Lajosmizse (HULAJ)",
   label: "Lajosmizse (HULAJ)"
  },
  {
   value: "Lakhegy (HULAK)",
   label: "Lakhegy (HULAK)"
  },
  {
   value: "Lakihegy (HULAI)",
   label: "Lakihegy (HULAI)"
  },
  {
   value: "Lakitelek (HULKK)",
   label: "Lakitelek (HULKK)"
  },
  {
   value: "Leanyvar (HULNR)",
   label: "Leanyvar (HULNR)"
  },
  {
   value: "Lebeny (HULBY)",
   label: "Lebeny (HULBY)"
  },
  {
   value: "Lörinci (HULRC)",
   label: "Lörinci (HULRC)"
  },
  {
   value: "Lukácsháza (HULUK)",
   label: "Lukácsháza (HULUK)"
  },
  {
   value: "Mad (HUMDA)",
   label: "Mad (HUMDA)"
  },
  {
   value: "Madocsa (HUMAD)",
   label: "Madocsa (HUMAD)"
  },
  {
   value: "Maglod (HUMGD)",
   label: "Maglod (HUMGD)"
  },
  {
   value: "Magyarbánhegyes (HUMYH)",
   label: "Magyarbánhegyes (HUMYH)"
  },
  {
   value: "Mako (HUMKO)",
   label: "Mako (HUMKO)"
  },
  {
   value: "Makó (HUMAK)",
   label: "Makó (HUMAK)"
  },
  {
   value: "Marcali (HUMAR)",
   label: "Marcali (HUMAR)"
  },
  {
   value: "Mártély (HUMTY)",
   label: "Mártély (HUMTY)"
  },
  {
   value: "Martfü (HUMFE)",
   label: "Martfü (HUMFE)"
  },
  {
   value: "Martonvásár (HUMNR)",
   label: "Martonvásár (HUMNR)"
  },
  {
   value: "Mátészalka (HUMAT)",
   label: "Mátészalka (HUMAT)"
  },
  {
   value: "Mecseknádasd (HUMKN)",
   label: "Mecseknádasd (HUMKN)"
  },
  {
   value: "Mezöberény (HUMZY)",
   label: "Mezöberény (HUMZY)"
  },
  {
   value: "Mezokovácsháza (HUMKS)",
   label: "Mezokovácsháza (HUMKS)"
  },
  {
   value: "Mezõtúr (HUMZO)",
   label: "Mezõtúr (HUMZO)"
  },
  {
   value: "Mezozombor (HUZZB)",
   label: "Mezozombor (HUZZB)"
  },
  {
   value: "Mihályháza (HUMYZ)",
   label: "Mihályháza (HUMYZ)"
  },
  {
   value: "Mór (HUMOR)",
   label: "Mór (HUMOR)"
  },
  {
   value: "Mórahalom (HUMHO)",
   label: "Mórahalom (HUMHO)"
  },
  {
   value: "Mosonmagyaróvár (HUMNM)",
   label: "Mosonmagyaróvár (HUMNM)"
  },
  {
   value: "Mosonszolnok (HUMOZ)",
   label: "Mosonszolnok (HUMOZ)"
  },
  {
   value: "Nádudvar (HUNAD)",
   label: "Nádudvar (HUNAD)"
  },
  {
   value: "Nagyigmánd (HUNAY)",
   label: "Nagyigmánd (HUNAY)"
  },
  {
   value: "Nagykovácsi (HUNYC)",
   label: "Nagykovácsi (HUNYC)"
  },
  {
   value: "Nemesvámos (HUNEM)",
   label: "Nemesvámos (HUNEM)"
  },
  {
   value: "Neszmély (HUNSZ)",
   label: "Neszmély (HUNSZ)"
  },
  {
   value: "Nyarlrrinc (HULNC)",
   label: "Nyarlrrinc (HULNC)"
  },
  {
   value: "Nyergesújfalu (HUNFA)",
   label: "Nyergesújfalu (HUNFA)"
  },
  {
   value: "Nyergesújfalu (HUNGU)",
   label: "Nyergesújfalu (HUNGU)"
  },
  {
   value: "Nyírbátor (HUNBR)",
   label: "Nyírbátor (HUNBR)"
  },
  {
   value: "Nyírgelse (HUNYR)",
   label: "Nyírgelse (HUNYR)"
  },
  {
   value: "Nyírmihálydi (HUNHY)",
   label: "Nyírmihálydi (HUNHY)"
  },
  {
   value: "Nyírtelek (HUNYT)",
   label: "Nyírtelek (HUNYT)"
  },
  {
   value: "Nyúl (HUNYL)",
   label: "Nyúl (HUNYL)"
  },
  {
   value: "Ócsa (HUOCS)",
   label: "Ócsa (HUOCS)"
  },
  {
   value: "Olasz (HUOLZ)",
   label: "Olasz (HUOLZ)"
  },
  {
   value: "Orbottyán (HUOTN)",
   label: "Orbottyán (HUOTN)"
  },
  {
   value: "Oroszlány (HUORO)",
   label: "Oroszlány (HUORO)"
  },
  {
   value: "Ózd (HUOZD)",
   label: "Ózd (HUOZD)"
  },
  {
   value: "Paks (HUPAK)",
   label: "Paks (HUPAK)"
  },
  {
   value: "Pálmonostora (HUPAL)",
   label: "Pálmonostora (HUPAL)"
  },
  {
   value: "Páty (HUPTY)",
   label: "Páty (HUPTY)"
  },
  {
   value: "Pécel (HUPEL)",
   label: "Pécel (HUPEL)"
  },
  {
   value: "Peremarton-Gyártelep (HUPGY)",
   label: "Peremarton-Gyártelep (HUPGY)"
  },
  {
   value: "Perkupa (HUPER)",
   label: "Perkupa (HUPER)"
  },
  {
   value: "Petofibánya (HUHAF)",
   label: "Petofibánya (HUHAF)"
  },
  {
   value: "Piliscsaba (HUPCA)",
   label: "Piliscsaba (HUPCA)"
  },
  {
   value: "Piliscsév (HUSCV)",
   label: "Piliscsév (HUSCV)"
  },
  {
   value: "Pilismarot (HUPMT)",
   label: "Pilismarot (HUPMT)"
  },
  {
   value: "Pilisszentiván (HUPZV)",
   label: "Pilisszentiván (HUPZV)"
  },
  {
   value: "Polgar (HUHBB)",
   label: "Polgar (HUHBB)"
  },
  {
   value: "Pomáz (HUPOM)",
   label: "Pomáz (HUPOM)"
  },
  {
   value: "Pusztaszabolcs (HUPSU)",
   label: "Pusztaszabolcs (HUPSU)"
  },
  {
   value: "Rácalmás (HURLS)",
   label: "Rácalmás (HURLS)"
  },
  {
   value: "Rákóczifalva (HURAK)",
   label: "Rákóczifalva (HURAK)"
  },
  {
   value: "Rétközberencs (HUHBD)",
   label: "Rétközberencs (HUHBD)"
  },
  {
   value: "Ságvár (HUSAG)",
   label: "Ságvár (HUSAG)"
  },
  {
   value: "Sajószentpéter (HUSAJ)",
   label: "Sajószentpéter (HUSAJ)"
  },
  {
   value: "Santos (HUHBG)",
   label: "Santos (HUHBG)"
  },
  {
   value: "Sárbogárd (HUSBG)",
   label: "Sárbogárd (HUSBG)"
  },
  {
   value: "Sarisap (HUHBF)",
   label: "Sarisap (HUHBF)"
  },
  {
   value: "Sarkad (HUSKD)",
   label: "Sarkad (HUSKD)"
  },
  {
   value: "Sárospatak (HURSP)",
   label: "Sárospatak (HURSP)"
  },
  {
   value: "Sárszentmihály (HUSMI)",
   label: "Sárszentmihály (HUSMI)"
  },
  {
   value: "Sárvár (HUSVR)",
   label: "Sárvár (HUSVR)"
  },
  {
   value: "Savoly (HUSVY)",
   label: "Savoly (HUSVY)"
  },
  {
   value: "Seregélyes (HUSGS)",
   label: "Seregélyes (HUSGS)"
  },
  {
   value: "Siklós (HUSIK)",
   label: "Siklós (HUSIK)"
  },
  {
   value: "Simontornya (HUSRY)",
   label: "Simontornya (HUSRY)"
  },
  {
   value: "Siófok (HUSIO)",
   label: "Siófok (HUSIO)"
  },
  {
   value: "Soltvadkert (HUSVK)",
   label: "Soltvadkert (HUSVK)"
  },
  {
   value: "Solymar (HUSLR)",
   label: "Solymar (HUSLR)"
  },
  {
   value: "Sükösd (HUSKO)",
   label: "Sükösd (HUSKO)"
  },
  {
   value: "Szabadbattyán (HUHBE)",
   label: "Szabadbattyán (HUHBE)"
  },
  {
   value: "Szabadegyháza (HUSGY)",
   label: "Szabadegyháza (HUSGY)"
  },
  {
   value: "Szada (HUSDA)",
   label: "Szada (HUSDA)"
  },
  {
   value: "Szajol (HUSZJ)",
   label: "Szajol (HUSZJ)"
  },
  {
   value: "Szálanta (HUSZA)",
   label: "Szálanta (HUSZA)"
  },
  {
   value: "Szárcsás (HUSZV)",
   label: "Szárcsás (HUSZV)"
  },
  {
   value: "Szatymaz (HUSZZ)",
   label: "Szatymaz (HUSZZ)"
  },
  {
   value: "Szazhalombatta (HUSHO)",
   label: "Szazhalombatta (HUSHO)"
  },
  {
   value: "Százhalombatta (HUSZB)",
   label: "Százhalombatta (HUSZB)"
  },
  {
   value: "Szécsény (HUSCY)",
   label: "Szécsény (HUSCY)"
  },
  {
   value: "Szeghalom (HUSHA)",
   label: "Szeghalom (HUSHA)"
  },
  {
   value: "Szendro (HUSZN)",
   label: "Szendro (HUSZN)"
  },
  {
   value: "Szentendre (HUSZD)",
   label: "Szentendre (HUSZD)"
  },
  {
   value: "Szentes (HUSZS)",
   label: "Szentes (HUSZS)"
  },
  {
   value: "Szentlorinckáta (HUSNA)",
   label: "Szentlorinckáta (HUSNA)"
  },
  {
   value: "Szerencs (HUSZC)",
   label: "Szerencs (HUSZC)"
  },
  {
   value: "Szigetcsép (HUPES)",
   label: "Szigetcsép (HUPES)"
  },
  {
   value: "Szigethalom (HUSGH)",
   label: "Szigethalom (HUSGH)"
  },
  {
   value: "Szigetszentmiklós (HUSZM)",
   label: "Szigetszentmiklós (HUSZM)"
  },
  {
   value: "Szigetvár (HUSZI)",
   label: "Szigetvár (HUSZI)"
  },
  {
   value: "Szodliget (HUHBH)",
   label: "Szodliget (HUHBH)"
  },
  {
   value: "Szomor (HUSMO)",
   label: "Szomor (HUSMO)"
  },
  {
   value: "Szorgalmatos (HUSMS)",
   label: "Szorgalmatos (HUSMS)"
  },
  {
   value: "Szügy (HUSYG)",
   label: "Szügy (HUSYG)"
  },
  {
   value: "Tab (HUTAB)",
   label: "Tab (HUTAB)"
  },
  {
   value: "Tahitotfalu (HUTHT)",
   label: "Tahitotfalu (HUTHT)"
  },
  {
   value: "Taksony (HUTSY)",
   label: "Taksony (HUTSY)"
  },
  {
   value: "Tamási (HUTMS)",
   label: "Tamási (HUTMS)"
  },
  {
   value: "Tan (HUTAN)",
   label: "Tan (HUTAN)"
  },
  {
   value: "Tapioszele (HUHBI)",
   label: "Tapioszele (HUHBI)"
  },
  {
   value: "Tapolca (HUTAP)",
   label: "Tapolca (HUTAP)"
  },
  {
   value: "Tarcal (HUTRC)",
   label: "Tarcal (HUTRC)"
  },
  {
   value: "Tarnaszadány (HUTZY)",
   label: "Tarnaszadány (HUTZY)"
  },
  {
   value: "Tárnok (HURTK)",
   label: "Tárnok (HURTK)"
  },
  {
   value: "Tata (HUTAT)",
   label: "Tata (HUTAT)"
  },
  {
   value: "Tatabánya (HUTAA)",
   label: "Tatabánya (HUTAA)"
  },
  {
   value: "Teglas (HUHBJ)",
   label: "Teglas (HUHBJ)"
  },
  {
   value: "Telekgerendás (HUTEL)",
   label: "Telekgerendás (HUTEL)"
  },
  {
   value: "Tépe (HUHBT)",
   label: "Tépe (HUHBT)"
  },
  {
   value: "Tiszafüred (HUTFD)",
   label: "Tiszafüred (HUTFD)"
  },
  {
   value: "Tiszalök (HUTZK)",
   label: "Tiszalök (HUTZK)"
  },
  {
   value: "Tiszaújváros (HUTZS)",
   label: "Tiszaújváros (HUTZS)"
  },
  {
   value: "Tiszavasvári (HUTZV)",
   label: "Tiszavasvári (HUTZV)"
  },
  {
   value: "Tofalu (HUHBC)",
   label: "Tofalu (HUHBC)"
  },
  {
   value: "Tok (HUTKO)",
   label: "Tok (HUTKO)"
  },
  {
   value: "Tokaj (HUTOJ)",
   label: "Tokaj (HUTOJ)"
  },
  {
   value: "Tokod (HUOKD)",
   label: "Tokod (HUOKD)"
  },
  {
   value: "Tolcsva (HUTOS)",
   label: "Tolcsva (HUTOS)"
  },
  {
   value: "Tolna (HUTNA)",
   label: "Tolna (HUTNA)"
  },
  {
   value: "Töltéstava (HUTSA)",
   label: "Töltéstava (HUTSA)"
  },
  {
   value: "Törökszentmiklós (HUTOK)",
   label: "Törökszentmiklós (HUTOK)"
  },
  {
   value: "Torony (HUTRY)",
   label: "Torony (HUTRY)"
  },
  {
   value: "Tószeg (HUTZG)",
   label: "Tószeg (HUTZG)"
  },
  {
   value: "Tótvázsony (HUTOT)",
   label: "Tótvázsony (HUTOT)"
  },
  {
   value: "Turkeve (HUTKV)",
   label: "Turkeve (HUTKV)"
  },
  {
   value: "Újfehértó (HUUHO)",
   label: "Újfehértó (HUUHO)"
  },
  {
   value: "Újhartyán (HUUJH)",
   label: "Újhartyán (HUUJH)"
  },
  {
   value: "Újpest (HUUPS)",
   label: "Újpest (HUUPS)"
  },
  {
   value: "Újszász (HUUZA)",
   label: "Újszász (HUUZA)"
  },
  {
   value: "Üllo (HUULL)",
   label: "Üllo (HUULL)"
  },
  {
   value: "Urom (HUHAK)",
   label: "Urom (HUHAK)"
  },
  {
   value: "Vác (HUVAC)",
   label: "Vác (HUVAC)"
  },
  {
   value: "Várpalota (HUVAR)",
   label: "Várpalota (HUVAR)"
  },
  {
   value: "Vásárosnamény (HUVSY)",
   label: "Vásárosnamény (HUVSY)"
  },
  {
   value: "Vaskeresztes (HUVKS)",
   label: "Vaskeresztes (HUVKS)"
  },
  {
   value: "Vasszécseny (HUVSZ)",
   label: "Vasszécseny (HUVSZ)"
  },
  {
   value: "Vasvár (HUVVR)",
   label: "Vasvár (HUVVR)"
  },
  {
   value: "Vecsés (HUVCS)",
   label: "Vecsés (HUVCS)"
  },
  {
   value: "Vecsés (HUVEC)",
   label: "Vecsés (HUVEC)"
  },
  {
   value: "Velence (HUVEL)",
   label: "Velence (HUVEL)"
  },
  {
   value: "Vép (HUVEP)",
   label: "Vép (HUVEP)"
  },
  {
   value: "Veresegyház (HUVGY)",
   label: "Veresegyház (HUVGY)"
  },
  {
   value: "Verpelét (HUVRP)",
   label: "Verpelét (HUVRP)"
  },
  {
   value: "Veszprém (HUVZP)",
   label: "Veszprém (HUVZP)"
  },
  {
   value: "Villány (HUVIL)",
   label: "Villány (HUVIL)"
  },
  {
   value: "Visegrád (HUVIG)",
   label: "Visegrád (HUVIG)"
  },
  {
   value: "Visonta (HUVST)",
   label: "Visonta (HUVST)"
  },
  {
   value: "Zala (HUZAL)",
   label: "Zala (HUZAL)"
  },
  {
   value: "Zalaber (HUZBR)",
   label: "Zalaber (HUZBR)"
  },
  {
   value: "Zalakomár (HUZAK)",
   label: "Zalakomár (HUZAK)"
  },
  {
   value: "Zirc (HUZRC)",
   label: "Zirc (HUZRC)"
  },
  {
   value: "Zsira (HUZSI)",
   label: "Zsira (HUZSI)"
  },
  {
   value: "Zsombo (HUHBA)",
   label: "Zsombo (HUHBA)"
  },
  {
   value: ".INDONESIA (ID)",
   label: ".INDONESIA (ID)"
  },
  {
   value: "Aekgodang (IDAEG)",
   label: "Aekgodang (IDAEG)"
  },
  {
   value: "Akeselaka (IDAKE)",
   label: "Akeselaka (IDAKE)"
  },
  {
   value: "Ampana (IDAPN)",
   label: "Ampana (IDAPN)"
  },
  {
   value: "Angar (IDANG)",
   label: "Angar (IDANG)"
  },
  {
   value: "Anggi (IDAGD)",
   label: "Anggi (IDAGD)"
  },
  {
   value: "Anyer Kidul (IDANR)",
   label: "Anyer Kidul (IDANR)"
  },
  {
   value: "Apalapsili (IDAAS)",
   label: "Apalapsili (IDAAS)"
  },
  {
   value: "Arso (IDARJ)",
   label: "Arso (IDARJ)"
  },
  {
   value: "Asam Asam (IDIAM)",
   label: "Asam Asam (IDIAM)"
  },
  {
   value: "Asike (IDASI)",
   label: "Asike (IDASI)"
  },
  {
   value: "Atauro (IDAUT)",
   label: "Atauro (IDAUT)"
  },
  {
   value: "Ayawasi (IDAYW)",
   label: "Ayawasi (IDAYW)"
  },
  {
   value: "Bantul (IDIBL)",
   label: "Bantul (IDIBL)"
  },
  {
   value: "Batulicin (IDBTW)",
   label: "Batulicin (IDBTW)"
  },
  {
   value: "Bekasi (IDBKA)",
   label: "Bekasi (IDBKA)"
  },
  {
   value: "Belanak Terminal (IDBNT)",
   label: "Belanak Terminal (IDBNT)"
  },
  {
   value: "Belida Terminal (IDBET)",
   label: "Belida Terminal (IDBET)"
  },
  {
   value: "Belitung (IDBLT)",
   label: "Belitung (IDBLT)"
  },
  {
   value: "Benete (IDBEN)",
   label: "Benete (IDBEN)"
  },
  {
   value: "Biringkassi (IDBIR)",
   label: "Biringkassi (IDBIR)"
  },
  {
   value: "Bogor (IDBOG)",
   label: "Bogor (IDBOG)"
  },
  {
   value: "Cengkareng (IDCEN)",
   label: "Cengkareng (IDCEN)"
  },
  {
   value: "Cepu (IDICU)",
   label: "Cepu (IDICU)"
  },
  {
   value: "Cereweh (IDCER)",
   label: "Cereweh (IDCER)"
  },
  {
   value: "Cikampek (IDCIK)",
   label: "Cikampek (IDCIK)"
  },
  {
   value: "Cilandak (IDCDK)",
   label: "Cilandak (IDCDK)"
  },
  {
   value: "Ciputat (IDCTT)",
   label: "Ciputat (IDCTT)"
  },
  {
   value: "Demta (IDDMA)",
   label: "Demta (IDDMA)"
  },
  {
   value: "Dobo (IDDOB)",
   label: "Dobo (IDDOB)"
  },
  {
   value: "Donggi (IDDOG)",
   label: "Donggi (IDDOG)"
  },
  {
   value: "Elat (IDELA)",
   label: "Elat (IDELA)"
  },
  {
   value: "Gee I. (IDGEE)",
   label: "Gee I. (IDGEE)"
  },
  {
   value: "Gianyar (IDIGR)",
   label: "Gianyar (IDIGR)"
  },
  {
   value: "Inanwatan (IDINA)",
   label: "Inanwatan (IDINA)"
  },
  {
   value: "Indonesia Bulk Terminal (IDIBT)",
   label: "Indonesia Bulk Terminal (IDIBT)"
  },
  {
   value: "Jabung Terminal (IDJBT)",
   label: "Jabung Terminal (IDJBT)"
  },
  {
   value: "Jakarta UTC1 (IDUTC)",
   label: "Jakarta UTC1 (IDUTC)"
  },
  {
   value: "Jakarta UTC3 (IDUTE)",
   label: "Jakarta UTC3 (IDUTE)"
  },
  {
   value: "Jatibarang (IDJBG)",
   label: "Jatibarang (IDJBG)"
  },
  {
   value: "Jatitujuh (IDJTH)",
   label: "Jatitujuh (IDJTH)"
  },
  {
   value: "Jepara (IDJEP)",
   label: "Jepara (IDJEP)"
  },
  {
   value: "Kabil (IDKAB)",
   label: "Kabil (IDKAB)"
  },
  {
   value: "Kahyangan (IDKHY)",
   label: "Kahyangan (IDKHY)"
  },
  {
   value: "Kalabahi (IDKBH)",
   label: "Kalabahi (IDKBH)"
  },
  {
   value: "Kalbut Situbondo (IDKSO)",
   label: "Kalbut Situbondo (IDKSO)"
  },
  {
   value: "Kariangau (IDKRG)",
   label: "Kariangau (IDKRG)"
  },
  {
   value: "Karimun Besar Offshore (IDOKA)",
   label: "Karimun Besar Offshore (IDOKA)"
  },
  {
   value: "Kassue (IDKSE)",
   label: "Kassue (IDKSE)"
  },
  {
   value: "Kau (IDKAU)",
   label: "Kau (IDKAU)"
  },
  {
   value: "Kendawangan (IDKDW)",
   label: "Kendawangan (IDKDW)"
  },
  {
   value: "Kijang (IDKIJ)",
   label: "Kijang (IDKIJ)"
  },
  {
   value: "Koja (IDKOJ)",
   label: "Koja (IDKOJ)"
  },
  {
   value: "Kokas (IDKOK)",
   label: "Kokas (IDKOK)"
  },
  {
   value: "Kolaka (IDKOL)",
   label: "Kolaka (IDKOL)"
  },
  {
   value: "Kolonodale (IDKNL)",
   label: "Kolonodale (IDKNL)"
  },
  {
   value: "Kuala Enok (IDENO)",
   label: "Kuala Enok (IDENO)"
  },
  {
   value: "Kualalangsa (IDKUA)",
   label: "Kualalangsa (IDKUA)"
  },
  {
   value: "Kualatanjung (IDKTJ)",
   label: "Kualatanjung (IDKTJ)"
  },
  {
   value: "Kualatungkal (IDKTK)",
   label: "Kualatungkal (IDKTK)"
  },
  {
   value: "Kumai (IDKUM)",
   label: "Kumai (IDKUM)"
  },
  {
   value: "Labuanbajo (IDLBJ)",
   label: "Labuanbajo (IDLBJ)"
  },
  {
   value: "Labuhan (IDLAJ)",
   label: "Labuhan (IDLAJ)"
  },
  {
   value: "Lobam (IDLBM)",
   label: "Lobam (IDLBM)"
  },
  {
   value: "Loki (IDLKI)",
   label: "Loki (IDLKI)"
  },
  {
   value: "Loli (IDLOL)",
   label: "Loli (IDLOL)"
  },
  {
   value: "Lombok (IDLOM)",
   label: "Lombok (IDLOM)"
  },
  {
   value: "Madura Terminal (IDMDR)",
   label: "Madura Terminal (IDMDR)"
  },
  {
   value: "Makassar (IDMAK)",
   label: "Makassar (IDMAK)"
  },
  {
   value: "Manggis (IDMGB)",
   label: "Manggis (IDMGB)"
  },
  {
   value: "Mangkajang (IDMKJ)",
   label: "Mangkajang (IDMKJ)"
  },
  {
   value: "Mapia I.s (IDMAI)",
   label: "Mapia I.s (IDMAI)"
  },
  {
   value: "Marabahan (IDMAR)",
   label: "Marabahan (IDMAR)"
  },
  {
   value: "Misool Terminal (IDMIT)",
   label: "Misool Terminal (IDMIT)"
  },
  {
   value: "Mornopo (IDMOR)",
   label: "Mornopo (IDMOR)"
  },
  {
   value: "Muara Bangkong (IDMBK)",
   label: "Muara Bangkong (IDMBK)"
  },
  {
   value: "Muara Siberut (IDMSB)",
   label: "Muara Siberut (IDMSB)"
  },
  {
   value: "North Pulau Laut (IDNPL)",
   label: "North Pulau Laut (IDNPL)"
  },
  {
   value: "Olah Jasa Andal\/Jakarta (IDOJA)",
   label: "Olah Jasa Andal\/Jakarta (IDOJA)"
  },
  {
   value: "Oransbari (IDORA)",
   label: "Oransbari (IDORA)"
  },
  {
   value: "Pagerungan (IDPGA)",
   label: "Pagerungan (IDPGA)"
  },
  {
   value: "Pagimana (IDPGM)",
   label: "Pagimana (IDPGM)"
  },
  {
   value: "Paiton (IDPAI)",
   label: "Paiton (IDPAI)"
  },
  {
   value: "Palu (IDPAL)",
   label: "Palu (IDPAL)"
  },
  {
   value: "Pasir Pangarayan (IDPPR)",
   label: "Pasir Pangarayan (IDPPR)"
  },
  {
   value: "Pelabuhan Futong Terminal (IDFTG)",
   label: "Pelabuhan Futong Terminal (IDFTG)"
  },
  {
   value: "Perbaungan (IDPBG)",
   label: "Perbaungan (IDPBG)"
  },
  {
   value: "Piru (IDPIR)",
   label: "Piru (IDPIR)"
  },
  {
   value: "Pomako (IDPMK)",
   label: "Pomako (IDPMK)"
  },
  {
   value: "Port Segoro Fajar Satryo\/Jakarta (IDSGO)",
   label: "Port Segoro Fajar Satryo\/Jakarta (IDSGO)"
  },
  {
   value: "Poto Tano (IDPOT)",
   label: "Poto Tano (IDPOT)"
  },
  {
   value: "Pulau Laut (IDPUT)",
   label: "Pulau Laut (IDPUT)"
  },
  {
   value: "Purwakarta (IDPUR)",
   label: "Purwakarta (IDPUR)"
  },
  {
   value: "Ranai (IDRNI)",
   label: "Ranai (IDRNI)"
  },
  {
   value: "Reo (IDREO)",
   label: "Reo (IDREO)"
  },
  {
   value: "Rungkut (IDRUN)",
   label: "Rungkut (IDRUN)"
  },
  {
   value: "Salatiga Semarang (IDSTG)",
   label: "Salatiga Semarang (IDSTG)"
  },
  {
   value: "Salawati Terminal (IDSWT)",
   label: "Salawati Terminal (IDSWT)"
  },
  {
   value: "Sanggau (IDSGU)",
   label: "Sanggau (IDSGU)"
  },
  {
   value: "Sarmi (IDZRM)",
   label: "Sarmi (IDZRM)"
  },
  {
   value: "Sawahlunto (IDISO)",
   label: "Sawahlunto (IDISO)"
  },
  {
   value: "Sekupang (IDSKP)",
   label: "Sekupang (IDSKP)"
  },
  {
   value: "Semarang (IDTES)",
   label: "Semarang (IDTES)"
  },
  {
   value: "Senipah (IDSZH)",
   label: "Senipah (IDSZH)"
  },
  {
   value: "Serang (IDSER)",
   label: "Serang (IDSER)"
  },
  {
   value: "Siak Sri Indrapura (IDSSI)",
   label: "Siak Sri Indrapura (IDSSI)"
  },
  {
   value: "Sidangoli (IDSID)",
   label: "Sidangoli (IDSID)"
  },
  {
   value: "Sidoarjo (IDSDJ)",
   label: "Sidoarjo (IDSDJ)"
  },
  {
   value: "Suaran (IDSUA)",
   label: "Suaran (IDSUA)"
  },
  {
   value: "Subaim (IDSBM)",
   label: "Subaim (IDSBM)"
  },
  {
   value: "Sumenep (IDSUM)",
   label: "Sumenep (IDSUM)"
  },
  {
   value: "Sunut (IDSUN)",
   label: "Sunut (IDSUN)"
  },
  {
   value: "Surakarta (IDSKT)",
   label: "Surakarta (IDSKT)"
  },
  {
   value: "Taboneo (IDTAB)",
   label: "Taboneo (IDTAB)"
  },
  {
   value: "Tanah Laut (IDTAL)",
   label: "Tanah Laut (IDTAL)"
  },
  {
   value: "Tangerang (IDTNG)",
   label: "Tangerang (IDTNG)"
  },
  {
   value: "Tangerang (IDTRG)",
   label: "Tangerang (IDTRG)"
  },
  {
   value: "Tanjung Buli (IDTBU)",
   label: "Tanjung Buli (IDTBU)"
  },
  {
   value: "Tanjung Merangas (IDTME)",
   label: "Tanjung Merangas (IDTME)"
  },
  {
   value: "Tanjung Pemancingan (IDTPN)",
   label: "Tanjung Pemancingan (IDTPN)"
  },
  {
   value: "Tanjung Uban (IDITN)",
   label: "Tanjung Uban (IDITN)"
  },
  {
   value: "Tanjungperak (IDTJP)",
   label: "Tanjungperak (IDTJP)"
  },
  {
   value: "Tarahan (IDTRH)",
   label: "Tarahan (IDTRH)"
  },
  {
   value: "Tarjun (IDTAR)",
   label: "Tarjun (IDTAR)"
  },
  {
   value: "Tebingtinggi (IDTTI)",
   label: "Tebingtinggi (IDTTI)"
  },
  {
   value: "Telukbayur (IDTBR)",
   label: "Telukbayur (IDTBR)"
  },
  {
   value: "Terempa (IDTER)",
   label: "Terempa (IDTER)"
  },
  {
   value: "Timika (IDTMK)",
   label: "Timika (IDTMK)"
  },
  {
   value: "Tual (IDTUA)",
   label: "Tual (IDTUA)"
  },
  {
   value: "Wainibe (IDWAI)",
   label: "Wainibe (IDWAI)"
  },
  {
   value: "Wamsasi (IDWSS)",
   label: "Wamsasi (IDWSS)"
  },
  {
   value: "Wanam (IDWAN)",
   label: "Wanam (IDWAN)"
  },
  {
   value: "Weda (IDWED)",
   label: "Weda (IDWED)"
  },
  {
   value: "Wonosari (IDWON)",
   label: "Wonosari (IDWON)"
  },
  {
   value: ".IRELAND (IE)",
   label: ".IRELAND (IE)"
  },
  {
   value: "Abbeyfeale (IEAYF)",
   label: "Abbeyfeale (IEAYF)"
  },
  {
   value: "Achonry (IEACN)",
   label: "Achonry (IEACN)"
  },
  {
   value: "Adare (IEADA)",
   label: "Adare (IEADA)"
  },
  {
   value: "Annacarty (IEANT)",
   label: "Annacarty (IEANT)"
  },
  {
   value: "Ardcath (IEACH)",
   label: "Ardcath (IEACH)"
  },
  {
   value: "Ardee (IEARE)",
   label: "Ardee (IEARE)"
  },
  {
   value: "Ardfert (IEART)",
   label: "Ardfert (IEART)"
  },
  {
   value: "Ardfinnan (IEARN)",
   label: "Ardfinnan (IEARN)"
  },
  {
   value: "Ardmore (IEARD)",
   label: "Ardmore (IEARD)"
  },
  {
   value: "Arklow Head (Ie009) (IEARH)",
   label: "Arklow Head (Ie009) (IEARH)"
  },
  {
   value: "Ashford (IEASD)",
   label: "Ashford (IEASD)"
  },
  {
   value: "Athboy (IEABY)",
   label: "Athboy (IEABY)"
  },
  {
   value: "Athenry (IEARY)",
   label: "Athenry (IEARY)"
  },
  {
   value: "Athleague (IEATE)",
   label: "Athleague (IEATE)"
  },
  {
   value: "Aughrim (IEAUM)",
   label: "Aughrim (IEAUM)"
  },
  {
   value: "Avoca (IEAVO)",
   label: "Avoca (IEAVO)"
  },
  {
   value: "Bagenalstown (IEBAG)",
   label: "Bagenalstown (IEBAG)"
  },
  {
   value: "Bailieborough (IEBAI)",
   label: "Bailieborough (IEBAI)"
  },
  {
   value: "Balbriggan (IEBBG)",
   label: "Balbriggan (IEBBG)"
  },
  {
   value: "Ballagh (IEBLH)",
   label: "Ballagh (IEBLH)"
  },
  {
   value: "Ballincollig (IEIBG)",
   label: "Ballincollig (IEIBG)"
  },
  {
   value: "Ballindine (IEBAD)",
   label: "Ballindine (IEBAD)"
  },
  {
   value: "Ballineen (IEBAN)",
   label: "Ballineen (IEBAN)"
  },
  {
   value: "Ballinrobe (IEBRO)",
   label: "Ballinrobe (IEBRO)"
  },
  {
   value: "Ballinskelligs (IEIBS)",
   label: "Ballinskelligs (IEIBS)"
  },
  {
   value: "Ballivor (IEBAV)",
   label: "Ballivor (IEBAV)"
  },
  {
   value: "Ballybay (IEBLB)",
   label: "Ballybay (IEBLB)"
  },
  {
   value: "Ballybofey (IEBBY)",
   label: "Ballybofey (IEBBY)"
  },
  {
   value: "Ballyboghil (Ballyboughal) (IEBGH)",
   label: "Ballyboghil (Ballyboughal) (IEBGH)"
  },
  {
   value: "Ballycollin (IEBCL)",
   label: "Ballycollin (IEBCL)"
  },
  {
   value: "Ballyconnell (IEIBL)",
   label: "Ballyconnell (IEIBL)"
  },
  {
   value: "Ballycotton (IEBLN)",
   label: "Ballycotton (IEBLN)"
  },
  {
   value: "Ballydehob (IEBYH)",
   label: "Ballydehob (IEBYH)"
  },
  {
   value: "Ballydesmond (IEBYD)",
   label: "Ballydesmond (IEBYD)"
  },
  {
   value: "Ballyfermot (IEBFT)",
   label: "Ballyfermot (IEBFT)"
  },
  {
   value: "Ballyhahil (IEBYY)",
   label: "Ballyhahil (IEBYY)"
  },
  {
   value: "Ballyhoolahan (IEBYL)",
   label: "Ballyhoolahan (IEBYL)"
  },
  {
   value: "Ballyjamesduff (IEBLF)",
   label: "Ballyjamesduff (IEBLF)"
  },
  {
   value: "Ballylanders (IEBLR)",
   label: "Ballylanders (IEBLR)"
  },
  {
   value: "Ballymacarbry (IEBYB)",
   label: "Ballymacarbry (IEBYB)"
  },
  {
   value: "Ballymahon (IEBLM)",
   label: "Ballymahon (IEBLM)"
  },
  {
   value: "Ballymount (IEBMT)",
   label: "Ballymount (IEBMT)"
  },
  {
   value: "Ballymurray (IEBRY)",
   label: "Ballymurray (IEBRY)"
  },
  {
   value: "Ballyragget (IEBRG)",
   label: "Ballyragget (IEBRG)"
  },
  {
   value: "Ballyvaughan (IEBYV)",
   label: "Ballyvaughan (IEBYV)"
  },
  {
   value: "Baltinglass (IEBLT)",
   label: "Baltinglass (IEBLT)"
  },
  {
   value: "Bandon (IEBDO)",
   label: "Bandon (IEBDO)"
  },
  {
   value: "Bangor (IEBNG)",
   label: "Bangor (IEBNG)"
  },
  {
   value: "Bantry Harbour (IEBTH)",
   label: "Bantry Harbour (IEBTH)"
  },
  {
   value: "Belturbet (IEBTB)",
   label: "Belturbet (IEBTB)"
  },
  {
   value: "Birr (IEBIR)",
   label: "Birr (IEBIR)"
  },
  {
   value: "Bishops Village (IEBVL)",
   label: "Bishops Village (IEBVL)"
  },
  {
   value: "Blackrock (IEBLA)",
   label: "Blackrock (IEBLA)"
  },
  {
   value: "Blanchardstown (IEBHT)",
   label: "Blanchardstown (IEBHT)"
  },
  {
   value: "Blessington (IEBLE)",
   label: "Blessington (IEBLE)"
  },
  {
   value: "Borris (IEZMY)",
   label: "Borris (IEZMY)"
  },
  {
   value: "Boyle (IEBOY)",
   label: "Boyle (IEBOY)"
  },
  {
   value: "Bree (IEBRE)",
   label: "Bree (IEBRE)"
  },
  {
   value: "Bridge End (IEBGE)",
   label: "Bridge End (IEBGE)"
  },
  {
   value: "Broadford (IEEBF)",
   label: "Broadford (IEEBF)"
  },
  {
   value: "Bruree (IEBRU)",
   label: "Bruree (IEBRU)"
  },
  {
   value: "Bunbeg (IEBUN)",
   label: "Bunbeg (IEBUN)"
  },
  {
   value: "Bunclody (IEBUY)",
   label: "Bunclody (IEBUY)"
  },
  {
   value: "Burnfoot (IEBFO)",
   label: "Burnfoot (IEBFO)"
  },
  {
   value: "Burtonport (IEBUR)",
   label: "Burtonport (IEBUR)"
  },
  {
   value: "Butlerstown (IEBUT)",
   label: "Butlerstown (IEBUT)"
  },
  {
   value: "Camolin (IECML)",
   label: "Camolin (IECML)"
  },
  {
   value: "Cappoquin (IECAP)",
   label: "Cappoquin (IECAP)"
  },
  {
   value: "Carn (IECRA)",
   label: "Carn (IECRA)"
  },
  {
   value: "Carrick (IEICK)",
   label: "Carrick (IEICK)"
  },
  {
   value: "Carrick on Suir (IESUU)",
   label: "Carrick on Suir (IESUU)"
  },
  {
   value: "Carrick-on-Shannon (IECOS)",
   label: "Carrick-on-Shannon (IECOS)"
  },
  {
   value: "Carrick-on-Suir (IECRS)",
   label: "Carrick-on-Suir (IECRS)"
  },
  {
   value: "Carrigaline (IECAE)",
   label: "Carrigaline (IECAE)"
  },
  {
   value: "Carrigans (IECRR)",
   label: "Carrigans (IECRR)"
  },
  {
   value: "Carrigtohill (IECGO)",
   label: "Carrigtohill (IECGO)"
  },
  {
   value: "Casteltownroche (IECTR)",
   label: "Casteltownroche (IECTR)"
  },
  {
   value: "Castleblaney (IECBY)",
   label: "Castleblaney (IECBY)"
  },
  {
   value: "Castlefinn (IECFI)",
   label: "Castlefinn (IECFI)"
  },
  {
   value: "Castleisland (IECAD)",
   label: "Castleisland (IECAD)"
  },
  {
   value: "Castlemahon (IECLM)",
   label: "Castlemahon (IECLM)"
  },
  {
   value: "Castlemaine (IECMA)",
   label: "Castlemaine (IECMA)"
  },
  {
   value: "Castlenock (IETLK)",
   label: "Castlenock (IETLK)"
  },
  {
   value: "Castlepollard (IECPD)",
   label: "Castlepollard (IECPD)"
  },
  {
   value: "Castletown (IECTN)",
   label: "Castletown (IECTN)"
  },
  {
   value: "Castletown Bearhaven (IECWB)",
   label: "Castletown Bearhaven (IECWB)"
  },
  {
   value: "Celbridge (IECEL)",
   label: "Celbridge (IECEL)"
  },
  {
   value: "Charlestown (IECHT)",
   label: "Charlestown (IECHT)"
  },
  {
   value: "Charleville (IECHA)",
   label: "Charleville (IECHA)"
  },
  {
   value: "Clane (IECNE)",
   label: "Clane (IECNE)"
  },
  {
   value: "Clarecastle (IECLC)",
   label: "Clarecastle (IECLC)"
  },
  {
   value: "Clogherhead (IECLG)",
   label: "Clogherhead (IECLG)"
  },
  {
   value: "Cloghran (IECLR)",
   label: "Cloghran (IECLR)"
  },
  {
   value: "Clonakilty (IECKY)",
   label: "Clonakilty (IECKY)"
  },
  {
   value: "Clones (IECLS)",
   label: "Clones (IECLS)"
  },
  {
   value: "Clonshaugh (IECHU)",
   label: "Clonshaugh (IECHU)"
  },
  {
   value: "Clontibret (IECTT)",
   label: "Clontibret (IECTT)"
  },
  {
   value: "Cloonlara (IECLN)",
   label: "Cloonlara (IECLN)"
  },
  {
   value: "Collooney (IECLY)",
   label: "Collooney (IECLY)"
  },
  {
   value: "Coolock (IEFGY)",
   label: "Coolock (IEFGY)"
  },
  {
   value: "Coolshannagh (IECLH)",
   label: "Coolshannagh (IECLH)"
  },
  {
   value: "Cootehill (IECOO)",
   label: "Cootehill (IECOO)"
  },
  {
   value: "Corrin (IECRN)",
   label: "Corrin (IECRN)"
  },
  {
   value: "Cratloe (IECTL)",
   label: "Cratloe (IECTL)"
  },
  {
   value: "Craughwell (IECGW)",
   label: "Craughwell (IECGW)"
  },
  {
   value: "Crookstown (IECKS)",
   label: "Crookstown (IECKS)"
  },
  {
   value: "Crosserlough (IECSG)",
   label: "Crosserlough (IECSG)"
  },
  {
   value: "Curracloe (IECUR)",
   label: "Curracloe (IECUR)"
  },
  {
   value: "Dalkey (IEDAL)",
   label: "Dalkey (IEDAL)"
  },
  {
   value: "Donabate (IEDAT)",
   label: "Donabate (IEDAT)"
  },
  {
   value: "Donoughmore (IEDNR)",
   label: "Donoughmore (IEDNR)"
  },
  {
   value: "Doolin (IEDLN)",
   label: "Doolin (IEDLN)"
  },
  {
   value: "Doonbeg (IEDBG)",
   label: "Doonbeg (IEDBG)"
  },
  {
   value: "Drogheda Maxol Facility (IEDMF)",
   label: "Drogheda Maxol Facility (IEDMF)"
  },
  {
   value: "Drogheda Premiere Periclase (IEDPP)",
   label: "Drogheda Premiere Periclase (IEDPP)"
  },
  {
   value: "Droichead Nua (IENBR)",
   label: "Droichead Nua (IENBR)"
  },
  {
   value: "Dromara (IEDRA)",
   label: "Dromara (IEDRA)"
  },
  {
   value: "Dromod (IEDRM)",
   label: "Dromod (IEDRM)"
  },
  {
   value: "Drumone (IEDMN)",
   label: "Drumone (IEDMN)"
  },
  {
   value: "Drumshanbo (IEDRU)",
   label: "Drumshanbo (IEDRU)"
  },
  {
   value: "Dublin -Dublin Ferryport Terminals (IEDFT)",
   label: "Dublin -Dublin Ferryport Terminals (IEDFT)"
  },
  {
   value: "Dublin- Ferryport Terminal 1 (IEDFA)",
   label: "Dublin- Ferryport Terminal 1 (IEDFA)"
  },
  {
   value: "Dublin- Ferryport Terminal 2 (IEDFB)",
   label: "Dublin- Ferryport Terminal 2 (IEDFB)"
  },
  {
   value: "Dublin- Ferryport Terminal 3 (IEDFC)",
   label: "Dublin- Ferryport Terminal 3 (IEDFC)"
  },
  {
   value: "Dublin-Marine Terminal Ltd. (IEMTL)",
   label: "Dublin-Marine Terminal Ltd. (IEMTL)"
  },
  {
   value: "Duleek (IEDUK)",
   label: "Duleek (IEDUK)"
  },
  {
   value: "Duncannon (IEDCN)",
   label: "Duncannon (IEDCN)"
  },
  {
   value: "Dunfanaghy (IEDFY)",
   label: "Dunfanaghy (IEDFY)"
  },
  {
   value: "Dunglow (IEDUW)",
   label: "Dunglow (IEDUW)"
  },
  {
   value: "Dunlavin (IEDLV)",
   label: "Dunlavin (IEDLV)"
  },
  {
   value: "Durrow (IEDOW)",
   label: "Durrow (IEDOW)"
  },
  {
   value: "Easky (IEEKY)",
   label: "Easky (IEEKY)"
  },
  {
   value: "Edenderry (IEEDE)",
   label: "Edenderry (IEEDE)"
  },
  {
   value: "Enfield (IEEFD)",
   label: "Enfield (IEEFD)"
  },
  {
   value: "Ennis (IEENI)",
   label: "Ennis (IEENI)"
  },
  {
   value: "Enniskean (IEENK)",
   label: "Enniskean (IEENK)"
  },
  {
   value: "Esb Poolbeg-Dublin (IEESB)",
   label: "Esb Poolbeg-Dublin (IEESB)"
  },
  {
   value: "Farranfore (IEFFO)",
   label: "Farranfore (IEFFO)"
  },
  {
   value: "Fenit Harbour (IEFHR)",
   label: "Fenit Harbour (IEFHR)"
  },
  {
   value: "Ferbane (IEFBE)",
   label: "Ferbane (IEFBE)"
  },
  {
   value: "Fethard (IEFTD)",
   label: "Fethard (IEFTD)"
  },
  {
   value: "Finglas (IEFLS)",
   label: "Finglas (IEFLS)"
  },
  {
   value: "Flogas Products Drogheda (IEFPD)",
   label: "Flogas Products Drogheda (IEFPD)"
  },
  {
   value: "Foxford (IEFXD)",
   label: "Foxford (IEFXD)"
  },
  {
   value: "Frenchpark (IECHK)",
   label: "Frenchpark (IECHK)"
  },
  {
   value: "Freshford (IEFSF)",
   label: "Freshford (IEFSF)"
  },
  {
   value: "Galmoy (IEGMY)",
   label: "Galmoy (IEGMY)"
  },
  {
   value: "Glanmire (IEGLM)",
   label: "Glanmire (IEGLM)"
  },
  {
   value: "Glasnevin (IEGNV)",
   label: "Glasnevin (IEGNV)"
  },
  {
   value: "Glenbeigh (IEGBI)",
   label: "Glenbeigh (IEGBI)"
  },
  {
   value: "Glengariff (IEGGA)",
   label: "Glengariff (IEGGA)"
  },
  {
   value: "Goresbridge (IEIGE)",
   label: "Goresbridge (IEIGE)"
  },
  {
   value: "Gormanston (IEGON)",
   label: "Gormanston (IEGON)"
  },
  {
   value: "Gort (IEGOT)",
   label: "Gort (IEGOT)"
  },
  {
   value: "Gortahork (IEGRT)",
   label: "Gortahork (IEGRT)"
  },
  {
   value: "Grannagh (IEGNA)",
   label: "Grannagh (IEGNA)"
  },
  {
   value: "Grenagh (IEGRH)",
   label: "Grenagh (IEGRH)"
  },
  {
   value: "Greystones (IEGRY)",
   label: "Greystones (IEGRY)"
  },
  {
   value: "Hollystown (IEHYS)",
   label: "Hollystown (IEHYS)"
  },
  {
   value: "Holywood (IEHOL)",
   label: "Holywood (IEHOL)"
  },
  {
   value: "Inveran (IEINV)",
   label: "Inveran (IEINV)"
  },
  {
   value: "Jamestown (IEJMT)",
   label: "Jamestown (IEJMT)"
  },
  {
   value: "Kilbeggan (IEKLB)",
   label: "Kilbeggan (IEKLB)"
  },
  {
   value: "Kilcock (IEKCK)",
   label: "Kilcock (IEKCK)"
  },
  {
   value: "Kilcoole (IEKIC)",
   label: "Kilcoole (IEKIC)"
  },
  {
   value: "Kildorrery (IERRR)",
   label: "Kildorrery (IERRR)"
  },
  {
   value: "Kilkieran (IEIKN)",
   label: "Kilkieran (IEIKN)"
  },
  {
   value: "kilkishen (IEKKS)",
   label: "kilkishen (IEKKS)"
  },
  {
   value: "Kill, Kildare (IEKIK)",
   label: "Kill, Kildare (IEKIK)"
  },
  {
   value: "Killaloe (IEKLE)",
   label: "Killaloe (IEKLE)"
  },
  {
   value: "Killeedy (IEKDY)",
   label: "Killeedy (IEKDY)"
  },
  {
   value: "Killeshandra (IEKLS)",
   label: "Killeshandra (IEKLS)"
  },
  {
   value: "Killygordon (IEKGD)",
   label: "Killygordon (IEKGD)"
  },
  {
   value: "Kilmacthomas (IEKMT)",
   label: "Kilmacthomas (IEKMT)"
  },
  {
   value: "Kilmallock (IEKMK)",
   label: "Kilmallock (IEKMK)"
  },
  {
   value: "Kilmore Quay (IEKRL)",
   label: "Kilmore Quay (IEKRL)"
  },
  {
   value: "Kilnaleck (IEKNL)",
   label: "Kilnaleck (IEKNL)"
  },
  {
   value: "Kilronan (IEKIN)",
   label: "Kilronan (IEKIN)"
  },
  {
   value: "Kilronan (IEKRN)",
   label: "Kilronan (IEKRN)"
  },
  {
   value: "Kilsheelan (IEKHE)",
   label: "Kilsheelan (IEKHE)"
  },
  {
   value: "Kiltamagh (IEIKH)",
   label: "Kiltamagh (IEIKH)"
  },
  {
   value: "Kilteel (IEKTE)",
   label: "Kilteel (IEKTE)"
  },
  {
   value: "Kilternan (IEKTA)",
   label: "Kilternan (IEKTA)"
  },
  {
   value: "Kinnegad (IEKNG)",
   label: "Kinnegad (IEKNG)"
  },
  {
   value: "Kinsealy (IEKSL)",
   label: "Kinsealy (IEKSL)"
  },
  {
   value: "Kinvarra (IEKIA)",
   label: "Kinvarra (IEKIA)"
  },
  {
   value: "Lanesborough (IELBH)",
   label: "Lanesborough (IELBH)"
  },
  {
   value: "Lisdoonvarna (IELDV)",
   label: "Lisdoonvarna (IELDV)"
  },
  {
   value: "Lisnarick (IELSK)",
   label: "Lisnarick (IELSK)"
  },
  {
   value: "Little Island\/Cork (IELIC)",
   label: "Little Island\/Cork (IELIC)"
  },
  {
   value: "Lucan (IELKY)",
   label: "Lucan (IELKY)"
  },
  {
   value: "Lurganm Armagh (IELAR)",
   label: "Lurganm Armagh (IELAR)"
  },
  {
   value: "Malahide (IEMAH)",
   label: "Malahide (IEMAH)"
  },
  {
   value: "Marshmeadows-New Ross (IEMAR)",
   label: "Marshmeadows-New Ross (IEMAR)"
  },
  {
   value: "Mayo (IEMYO)",
   label: "Mayo (IEMYO)"
  },
  {
   value: "Millstreet (IEMIL)",
   label: "Millstreet (IEMIL)"
  },
  {
   value: "Milltown Malbay (IEMNM)",
   label: "Milltown Malbay (IEMNM)"
  },
  {
   value: "Mogeely (IEMGL)",
   label: "Mogeely (IEMGL)"
  },
  {
   value: "Monesterevin (IEMNV)",
   label: "Monesterevin (IEMNV)"
  },
  {
   value: "Mount Bellew (IEMBW)",
   label: "Mount Bellew (IEMBW)"
  },
  {
   value: "Mountmellick (IEMOU)",
   label: "Mountmellick (IEMOU)"
  },
  {
   value: "Moville (IEMOV)",
   label: "Moville (IEMOV)"
  },
  {
   value: "Mulhurddart (IEMLT)",
   label: "Mulhurddart (IEMLT)"
  },
  {
   value: "Mullagh (IEMLA)",
   label: "Mullagh (IEMLA)"
  },
  {
   value: "Mullagh (IEMUG)",
   label: "Mullagh (IEMUG)"
  },
  {
   value: "Multyfarnham (IEMLM)",
   label: "Multyfarnham (IEMLM)"
  },
  {
   value: "Murroe (IEMUR)",
   label: "Murroe (IEMUR)"
  },
  {
   value: "Naul (IENUL)",
   label: "Naul (IENUL)"
  },
  {
   value: "Nenagh (IENEN)",
   label: "Nenagh (IENEN)"
  },
  {
   value: "New Ross-Raheen\/Roberscon (IENRR)",
   label: "New Ross-Raheen\/Roberscon (IENRR)"
  },
  {
   value: "Newbridge (IENWB)",
   label: "Newbridge (IENWB)"
  },
  {
   value: "Newbridge (IENWG)",
   label: "Newbridge (IENWG)"
  },
  {
   value: "Newcastle (IENWC)",
   label: "Newcastle (IENWC)"
  },
  {
   value: "Newmarket (IENMR)",
   label: "Newmarket (IENMR)"
  },
  {
   value: "Newmarket on Fergus (IENOF)",
   label: "Newmarket on Fergus (IENOF)"
  },
  {
   value: "Newport (IENET)",
   label: "Newport (IENET)"
  },
  {
   value: "Newtonabbey (IENAY)",
   label: "Newtonabbey (IENAY)"
  },
  {
   value: "Newtown (IENEX)",
   label: "Newtown (IENEX)"
  },
  {
   value: "Ocallaghansmills (IEOCA)",
   label: "Ocallaghansmills (IEOCA)"
  },
  {
   value: "Oldcastle (IENOV)",
   label: "Oldcastle (IENOV)"
  },
  {
   value: "Oranmore (IEONE)",
   label: "Oranmore (IEONE)"
  },
  {
   value: "Palmerston (IEPMS)",
   label: "Palmerston (IEPMS)"
  },
  {
   value: "Passage West (IEPAW)",
   label: "Passage West (IEPAW)"
  },
  {
   value: "Portarlington (IEPOR)",
   label: "Portarlington (IEPOR)"
  },
  {
   value: "Portglenone (IEPGN)",
   label: "Portglenone (IEPGN)"
  },
  {
   value: "Portlaoise (IEPTL)",
   label: "Portlaoise (IEPTL)"
  },
  {
   value: "Portmarnock (IEPOK)",
   label: "Portmarnock (IEPOK)"
  },
  {
   value: "Ramelton (IERTN)",
   label: "Ramelton (IERTN)"
  },
  {
   value: "Rathangan (IERNG)",
   label: "Rathangan (IERNG)"
  },
  {
   value: "Rathcoole (IERCO)",
   label: "Rathcoole (IERCO)"
  },
  {
   value: "Rathcormack (IERCC)",
   label: "Rathcormack (IERCC)"
  },
  {
   value: "Rathdowney (IERTD)",
   label: "Rathdowney (IERTD)"
  },
  {
   value: "Rathdrum (IERDM)",
   label: "Rathdrum (IERDM)"
  },
  {
   value: "Rathkeale (IERAE)",
   label: "Rathkeale (IERAE)"
  },
  {
   value: "Rathmullan (IERAT)",
   label: "Rathmullan (IERAT)"
  },
  {
   value: "Rathowen (IERTW)",
   label: "Rathowen (IERTW)"
  },
  {
   value: "Rathowen (IERWN)",
   label: "Rathowen (IERWN)"
  },
  {
   value: "Ratoath (IERTT)",
   label: "Ratoath (IERTT)"
  },
  {
   value: "Rhode (IERHO)",
   label: "Rhode (IERHO)"
  },
  {
   value: "Ringaskiddy Deepwater Terminal (IERDT)",
   label: "Ringaskiddy Deepwater Terminal (IERDT)"
  },
  {
   value: "Ringaskiddy Passenger Terminal (IERPT)",
   label: "Ringaskiddy Passenger Terminal (IERPT)"
  },
  {
   value: "Riverstown (IERVT)",
   label: "Riverstown (IERVT)"
  },
  {
   value: "Roosky (IEROO)",
   label: "Roosky (IEROO)"
  },
  {
   value: "Roscommon (IERON)",
   label: "Roscommon (IERON)"
  },
  {
   value: "Rosenallis (IERNS)",
   label: "Rosenallis (IERNS)"
  },
  {
   value: "Rosses Point (IERSS)",
   label: "Rosses Point (IERSS)"
  },
  {
   value: "Sallins (IESLS)",
   label: "Sallins (IESLS)"
  },
  {
   value: "Salt Hill (IESAL)",
   label: "Salt Hill (IESAL)"
  },
  {
   value: "Santry\/Dublin (IESAN)",
   label: "Santry\/Dublin (IESAN)"
  },
  {
   value: "Schull (IESCH)",
   label: "Schull (IESCH)"
  },
  {
   value: "Shannon Apt Jetty (IESAJ)",
   label: "Shannon Apt Jetty (IESAJ)"
  },
  {
   value: "Shercock (IESRO)",
   label: "Shercock (IESRO)"
  },
  {
   value: "Skerries (IESKE)",
   label: "Skerries (IESKE)"
  },
  {
   value: "Skibbereen (IESKB)",
   label: "Skibbereen (IESKB)"
  },
  {
   value: "Skryne (IESRY)",
   label: "Skryne (IESRY)"
  },
  {
   value: "Skull (IESKL)",
   label: "Skull (IESKL)"
  },
  {
   value: "Slane (IESLN)",
   label: "Slane (IESLN)"
  },
  {
   value: "Slieveroe (IESVE)",
   label: "Slieveroe (IESVE)"
  },
  {
   value: "Sneem (IESNE)",
   label: "Sneem (IESNE)"
  },
  {
   value: "Stokestown New Ross (IESNR)",
   label: "Stokestown New Ross (IESNR)"
  },
  {
   value: "Stradbally (IESTB)",
   label: "Stradbally (IESTB)"
  },
  {
   value: "Straffan (IESTF)",
   label: "Straffan (IESTF)"
  },
  {
   value: "Summerhill (IESUL)",
   label: "Summerhill (IESUL)"
  },
  {
   value: "Swords (IESWO)",
   label: "Swords (IESWO)"
  },
  {
   value: "Tallaght (IETAL)",
   label: "Tallaght (IETAL)"
  },
  {
   value: "Tallow (IEITW)",
   label: "Tallow (IEITW)"
  },
  {
   value: "Templeogue (IETPG)",
   label: "Templeogue (IETPG)"
  },
  {
   value: "Tober (IETOB)",
   label: "Tober (IETOB)"
  },
  {
   value: "Togher (IETOG)",
   label: "Togher (IETOG)"
  },
  {
   value: "Tom Roes Point Terminal Drogheda (IETRP)",
   label: "Tom Roes Point Terminal Drogheda (IETRP)"
  },
  {
   value: "Town Quays Drogheda (IETQY)",
   label: "Town Quays Drogheda (IETQY)"
  },
  {
   value: "Tuam (IEITM)",
   label: "Tuam (IEITM)"
  },
  {
   value: "Tulla (IETLA)",
   label: "Tulla (IETLA)"
  },
  {
   value: "Tullylease (IETYL)",
   label: "Tullylease (IETYL)"
  },
  {
   value: "Tynagh (IETYA)",
   label: "Tynagh (IETYA)"
  },
  {
   value: "Urlingford (IEUTN)",
   label: "Urlingford (IEUTN)"
  },
  {
   value: "Waterford City Quays (IEWCQ)",
   label: "Waterford City Quays (IEWCQ)"
  },
  {
   value: "Waterford Great I. (ESB) (IEWGI)",
   label: "Waterford Great I. (ESB) (IEWGI)"
  },
  {
   value: "Watergrasshill (IEWGH)",
   label: "Watergrasshill (IEWGH)"
  },
  {
   value: "Waterville (IEWVI)",
   label: "Waterville (IEWVI)"
  },
  {
   value: "Westmeath (IEMST)",
   label: "Westmeath (IEMST)"
  },
  {
   value: ".ISRAEL (IL)",
   label: ".ISRAEL (IL)"
  },
  {
   value: "Afula (ILAFU)",
   label: "Afula (ILAFU)"
  },
  {
   value: "Akko (ILAKK)",
   label: "Akko (ILAKK)"
  },
  {
   value: "Arad (ILIAD)",
   label: "Arad (ILIAD)"
  },
  {
   value: "Bazra (ILBRZ)",
   label: "Bazra (ILBRZ)"
  },
  {
   value: "Beit Hashita (ILSHI)",
   label: "Beit Hashita (ILSHI)"
  },
  {
   value: "Beit Kama (ILBEI)",
   label: "Beit Kama (ILBEI)"
  },
  {
   value: "Beit Zera (ILBTZ)",
   label: "Beit Zera (ILBTZ)"
  },
  {
   value: "Ben Gurion International Apt (ILBGA)",
   label: "Ben Gurion International Apt (ILBGA)"
  },
  {
   value: "Bene Beraq (ILBBK)",
   label: "Bene Beraq (ILBBK)"
  },
  {
   value: "Bet Shean (ILBET)",
   label: "Bet Shean (ILBET)"
  },
  {
   value: "Bet Shemesh (ILBSE)",
   label: "Bet Shemesh (ILBSE)"
  },
  {
   value: "Bet Zayit (ILBZA)",
   label: "Bet Zayit (ILBZA)"
  },
  {
   value: "Bnei Ayish (ILBNE)",
   label: "Bnei Ayish (ILBNE)"
  },
  {
   value: "Bnei Darom (ILDAR)",
   label: "Bnei Darom (ILDAR)"
  },
  {
   value: "Caesarea (ILCAE)",
   label: "Caesarea (ILCAE)"
  },
  {
   value: "Carmiel (ILCML)",
   label: "Carmiel (ILCML)"
  },
  {
   value: "Dimona (ILDIM)",
   label: "Dimona (ILDIM)"
  },
  {
   value: "Dorot (ILDOR)",
   label: "Dorot (ILDOR)"
  },
  {
   value: "Ein Tzurim (ILEIN)",
   label: "Ein Tzurim (ILEIN)"
  },
  {
   value: "Elkana (ILELK)",
   label: "Elkana (ILELK)"
  },
  {
   value: "Even Yehuda (ILEVE)",
   label: "Even Yehuda (ILEVE)"
  },
  {
   value: "Gan Shmuel (ILSHM)",
   label: "Gan Shmuel (ILSHM)"
  },
  {
   value: "Gan Yavne (ILGYV)",
   label: "Gan Yavne (ILGYV)"
  },
  {
   value: "Gannot (ILGAN)",
   label: "Gannot (ILGAN)"
  },
  {
   value: "Gedera (ILGDA)",
   label: "Gedera (ILGDA)"
  },
  {
   value: "Gefen (ILGEF)",
   label: "Gefen (ILGEF)"
  },
  {
   value: "Hatzor HaGlilit (ILHAT)",
   label: "Hatzor HaGlilit (ILHAT)"
  },
  {
   value: "Herzliya (ILIHA)",
   label: "Herzliya (ILIHA)"
  },
  {
   value: "Hod HaSharon (ILHOD)",
   label: "Hod HaSharon (ILHOD)"
  },
  {
   value: "Holon\/Tel Aviv (ILHOL)",
   label: "Holon\/Tel Aviv (ILHOL)"
  },
  {
   value: "Julis (ILJUL)",
   label: "Julis (ILJUL)"
  },
  {
   value: "Kabri (ILCAB)",
   label: "Kabri (ILCAB)"
  },
  {
   value: "Kafr Saba (ILKFS)",
   label: "Kafr Saba (ILKFS)"
  },
  {
   value: "Kannot (ILKAN)",
   label: "Kannot (ILKAN)"
  },
  {
   value: "Kefar Aza (ILAZA)",
   label: "Kefar Aza (ILAZA)"
  },
  {
   value: "Kefar HaMaccabi (ILMAC)",
   label: "Kefar HaMaccabi (ILMAC)"
  },
  {
   value: "Kefar Malal (ILKFA)",
   label: "Kefar Malal (ILKFA)"
  },
  {
   value: "Kefar Sava (ILKSV)",
   label: "Kefar Sava (ILKSV)"
  },
  {
   value: "Kefar Szold (ILSZO)",
   label: "Kefar Szold (ILSZO)"
  },
  {
   value: "Kefar Vradim (ILVRA)",
   label: "Kefar Vradim (ILVRA)"
  },
  {
   value: "Kefar Yona (ILYON)",
   label: "Kefar Yona (ILYON)"
  },
  {
   value: "Lod (ILLOD)",
   label: "Lod (ILLOD)"
  },
  {
   value: "Megiddo (ILMEG)",
   label: "Megiddo (ILMEG)"
  },
  {
   value: "Mesilot (ILMES)",
   label: "Mesilot (ILMES)"
  },
  {
   value: "Mevasseret Ziyyon (ILMZI)",
   label: "Mevasseret Ziyyon (ILMZI)"
  },
  {
   value: "Migdal HaEmek (ILMIG)",
   label: "Migdal HaEmek (ILMIG)"
  },
  {
   value: "Misgav (ILMSG)",
   label: "Misgav (ILMSG)"
  },
  {
   value: "Mishmar David (ILMIS)",
   label: "Mishmar David (ILMIS)"
  },
  {
   value: "Nahshonim (ILNAS)",
   label: "Nahshonim (ILNAS)"
  },
  {
   value: "Nazareth (ILNAZ)",
   label: "Nazareth (ILNAZ)"
  },
  {
   value: "Negba (ILNEG)",
   label: "Negba (ILNEG)"
  },
  {
   value: "Nehalim (ILNEH)",
   label: "Nehalim (ILNEH)"
  },
  {
   value: "Nes Ziyyona (ILNZY)",
   label: "Nes Ziyyona (ILNZY)"
  },
  {
   value: "Nesher (ILNHR)",
   label: "Nesher (ILNHR)"
  },
  {
   value: "Netivot (ILNET)",
   label: "Netivot (ILNET)"
  },
  {
   value: "Netzer Sereni (ILZER)",
   label: "Netzer Sereni (ILZER)"
  },
  {
   value: "Newe Ur (ILNUR)",
   label: "Newe Ur (ILNUR)"
  },
  {
   value: "Newe Yamin (ILNWY)",
   label: "Newe Yamin (ILNWY)"
  },
  {
   value: "Nir Yitzhak (ILYIT)",
   label: "Nir Yitzhak (ILYIT)"
  },
  {
   value: "Ofakim (ILOFA)",
   label: "Ofakim (ILOFA)"
  },
  {
   value: "Olesh (ILOLE)",
   label: "Olesh (ILOLE)"
  },
  {
   value: "Or Yehuda (ILOYH)",
   label: "Or Yehuda (ILOYH)"
  },
  {
   value: "Pardes Hanna (ILPHH)",
   label: "Pardes Hanna (ILPHH)"
  },
  {
   value: "Qiryat Bialik (ILQYB)",
   label: "Qiryat Bialik (ILQYB)"
  },
  {
   value: "Qiryat Gat (ILQYT)",
   label: "Qiryat Gat (ILQYT)"
  },
  {
   value: "Ramat David (ILDAV)",
   label: "Ramat David (ILDAV)"
  },
  {
   value: "Ramat Gan (ILRMG)",
   label: "Ramat Gan (ILRMG)"
  },
  {
   value: "Ramat HaKovesh (ILRHV)",
   label: "Ramat HaKovesh (ILRHV)"
  },
  {
   value: "Ramat HaSharon (ILRAM)",
   label: "Ramat HaSharon (ILRAM)"
  },
  {
   value: "Ramla (ILRML)",
   label: "Ramla (ILRML)"
  },
  {
   value: "Rehovot (ILREH)",
   label: "Rehovot (ILREH)"
  },
  {
   value: "Sde Uziyahu (ILSDE)",
   label: "Sde Uziyahu (ILSDE)"
  },
  {
   value: "Sdot Yam (ILSDO)",
   label: "Sdot Yam (ILSDO)"
  },
  {
   value: "Sederot (ILSDT)",
   label: "Sederot (ILSDT)"
  },
  {
   value: "Tel Mond (ILMON)",
   label: "Tel Mond (ILMON)"
  },
  {
   value: "Tiberias (ILTIB)",
   label: "Tiberias (ILTIB)"
  },
  {
   value: "Tzofit (ILTZO)",
   label: "Tzofit (ILTZO)"
  },
  {
   value: "Tzoran-Kadima (ILTKA)",
   label: "Tzoran-Kadima (ILTKA)"
  },
  {
   value: "Umm al-Fahm (ILUMM)",
   label: "Umm al-Fahm (ILUMM)"
  },
  {
   value: "Yavne (ILYVE)",
   label: "Yavne (ILYVE)"
  },
  {
   value: "Yiftah (ILYIF)",
   label: "Yiftah (ILYIF)"
  },
  {
   value: "Yokneam (ILYKN)",
   label: "Yokneam (ILYKN)"
  },
  {
   value: ".ISLE OF MAN (IM)",
   label: ".ISLE OF MAN (IM)"
  },
  {
   value: "Castletown (IMCTN)",
   label: "Castletown (IMCTN)"
  },
  {
   value: "Douglas (IMDGS)",
   label: "Douglas (IMDGS)"
  },
  {
   value: "Jurby (IMJBY)",
   label: "Jurby (IMJBY)"
  },
  {
   value: "Onchan (IMOHN)",
   label: "Onchan (IMOHN)"
  },
  {
   value: "Peel (IMPEL)",
   label: "Peel (IMPEL)"
  },
  {
   value: "Ramsey (IMRAM)",
   label: "Ramsey (IMRAM)"
  },
  {
   value: "Ronaldsway Apt (IMIOM)",
   label: "Ronaldsway Apt (IMIOM)"
  },
  {
   value: ".INDIA (IN)",
   label: ".INDIA (IN)"
  },
  {
   value: "Achra (INACH)",
   label: "Achra (INACH)"
  },
  {
   value: "Agartala (INIXA)",
   label: "Agartala (INIXA)"
  },
  {
   value: "Agatti Island (INAGX)",
   label: "Agatti Island (INAGX)"
  },
  {
   value: "Agra (INAGR)",
   label: "Agra (INAGR)"
  },
  {
   value: "Ahmedabad (INAMD)",
   label: "Ahmedabad (INAMD)"
  },
  {
   value: "Ahmednagar (INMUM)",
   label: "Ahmednagar (INMUM)"
  },
  {
   value: "Aizawl (INAJL)",
   label: "Aizawl (INAJL)"
  },
  {
   value: "Akola (INAKD)",
   label: "Akola (INAKD)"
  },
  {
   value: "Alang SBY (INALA)",
   label: "Alang SBY (INALA)"
  },
  {
   value: "Alangulam (INAGU)",
   label: "Alangulam (INAGU)"
  },
  {
   value: "Alibag (INABG)",
   label: "Alibag (INABG)"
  },
  {
   value: "Allahabad (INIXD)",
   label: "Allahabad (INIXD)"
  },
  {
   value: "Alleppey (INALF)",
   label: "Alleppey (INALF)"
  },
  {
   value: "Along Apt (INIXV)",
   label: "Along Apt (INIXV)"
  },
  {
   value: "Amingaon (Gauhati) (INAMG)",
   label: "Amingaon (Gauhati) (INAMG)"
  },
  {
   value: "Amini I. (INAIS)",
   label: "Amini I. (INAIS)"
  },
  {
   value: "Amritsar (INATQ)",
   label: "Amritsar (INATQ)"
  },
  {
   value: "Anaparti (INAPT)",
   label: "Anaparti (INAPT)"
  },
  {
   value: "Andorth Is (INAMI)",
   label: "Andorth Is (INAMI)"
  },
  {
   value: "Androth Is (INADI)",
   label: "Androth Is (INADI)"
  },
  {
   value: "Anijengo (INANG)",
   label: "Anijengo (INANG)"
  },
  {
   value: "Ankleshwar (INAKV)",
   label: "Ankleshwar (INAKV)"
  },
  {
   value: "Arakkonam (INARK)",
   label: "Arakkonam (INARK)"
  },
  {
   value: "Arnala (INANL)",
   label: "Arnala (INANL)"
  },
  {
   value: "Aroor (INARR)",
   label: "Aroor (INARR)"
  },
  {
   value: "Attari Rail Station (INATT)",
   label: "Attari Rail Station (INATT)"
  },
  {
   value: "Attari Road (INATR)",
   label: "Attari Road (INATR)"
  },
  {
   value: "Auraiya (INAUR)",
   label: "Auraiya (INAUR)"
  },
  {
   value: "Aurangabad (INIXU)",
   label: "Aurangabad (INIXU)"
  },
  {
   value: "Azhikkal (INAZK)",
   label: "Azhikkal (INAZK)"
  },
  {
   value: "Babarpur (INPNP)",
   label: "Babarpur (INPNP)"
  },
  {
   value: "Badagara (INBDG)",
   label: "Badagara (INBDG)"
  },
  {
   value: "Baddi (INBDI)",
   label: "Baddi (INBDI)"
  },
  {
   value: "Bagdogra (INIXB)",
   label: "Bagdogra (INIXB)"
  },
  {
   value: "Baghamara (INBGM)",
   label: "Baghamara (INBGM)"
  },
  {
   value: "Bahabal Pur (INBBP)",
   label: "Bahabal Pur (INBBP)"
  },
  {
   value: "Bahadurgarh (INBAH)",
   label: "Bahadurgarh (INBAH)"
  },
  {
   value: "Baindur (INBDR)",
   label: "Baindur (INBDR)"
  },
  {
   value: "Bairgania (INBGU)",
   label: "Bairgania (INBGU)"
  },
  {
   value: "Balet (INBLT)",
   label: "Balet (INBLT)"
  },
  {
   value: "Ballabgarh (INBGH)",
   label: "Ballabgarh (INBGH)"
  },
  {
   value: "Balurghat (INRGH)",
   label: "Balurghat (INRGH)"
  },
  {
   value: "Banbasa (INBSA)",
   label: "Banbasa (INBSA)"
  },
  {
   value: "Banddar (INBND)",
   label: "Banddar (INBND)"
  },
  {
   value: "Bandra (INBDA)",
   label: "Bandra (INBDA)"
  },
  {
   value: "Bangalore (INBLR)",
   label: "Bangalore (INBLR)"
  },
  {
   value: "Bangarapet (INBPT)",
   label: "Bangarapet (INBPT)"
  },
  {
   value: "Bankot (INBKT)",
   label: "Bankot (INBKT)"
  },
  {
   value: "Banswara (INBAN)",
   label: "Banswara (INBAN)"
  },
  {
   value: "Bareilly (INBEK)",
   label: "Bareilly (INBEK)"
  },
  {
   value: "Barmer Rail Station (INBMR)",
   label: "Barmer Rail Station (INBMR)"
  },
  {
   value: "Barnala (INBAR)",
   label: "Barnala (INBAR)"
  },
  {
   value: "Baroda (INBRC)",
   label: "Baroda (INBRC)"
  },
  {
   value: "Barsora (INBRA)",
   label: "Barsora (INBRA)"
  },
  {
   value: "Basni (INJUX)",
   label: "Basni (INJUX)"
  },
  {
   value: "Bassain (INBSN)",
   label: "Bassain (INBSN)"
  },
  {
   value: "Bedi (INBED)",
   label: "Bedi (INBED)"
  },
  {
   value: "Belapur (INBLP)",
   label: "Belapur (INBLP)"
  },
  {
   value: "Belekeri (INBLK)",
   label: "Belekeri (INBLK)"
  },
  {
   value: "Belgaum (INIXG)",
   label: "Belgaum (INIXG)"
  },
  {
   value: "Bellary (INBEP)",
   label: "Bellary (INBEP)"
  },
  {
   value: "Berhni (INBNY)",
   label: "Berhni (INBNY)"
  },
  {
   value: "Betul (INBEL)",
   label: "Betul (INBEL)"
  },
  {
   value: "Betul (INBET)",
   label: "Betul (INBET)"
  },
  {
   value: "Beypore (INBEY)",
   label: "Beypore (INBEY)"
  },
  {
   value: "Beyt (INBYT)",
   label: "Beyt (INBYT)"
  },
  {
   value: "Bhaddi (INBAD)",
   label: "Bhaddi (INBAD)"
  },
  {
   value: "Bhadohi (INBDH)",
   label: "Bhadohi (INBDH)"
  },
  {
   value: "Bhagwa (INBGW)",
   label: "Bhagwa (INBGW)"
  },
  {
   value: "Bharøch (INBRU)",
   label: "Bharøch (INBRU)"
  },
  {
   value: "Bhatinda (INBUP)",
   label: "Bhatinda (INBUP)"
  },
  {
   value: "Bhatkal (INBTK)",
   label: "Bhatkal (INBTK)"
  },
  {
   value: "Bhavnagar (INBHU)",
   label: "Bhavnagar (INBHU)"
  },
  {
   value: "Bheemunipatnam (INBHM)",
   label: "Bheemunipatnam (INBHM)"
  },
  {
   value: "Bhilai (INBHI)",
   label: "Bhilai (INBHI)"
  },
  {
   value: "Bhilwara (INBHL)",
   label: "Bhilwara (INBHL)"
  },
  {
   value: "Bhimnagar (INBNR)",
   label: "Bhimnagar (INBNR)"
  },
  {
   value: "Bhithamore (Sursnad) (INBTM)",
   label: "Bhithamore (Sursnad) (INBTM)"
  },
  {
   value: "Bhiwadi (INBWD)",
   label: "Bhiwadi (INBWD)"
  },
  {
   value: "Bhiwandi (INBWN)",
   label: "Bhiwandi (INBWN)"
  },
  {
   value: "Bhopal (INBHO)",
   label: "Bhopal (INBHO)"
  },
  {
   value: "Bhubaneswar (INBBI)",
   label: "Bhubaneswar (INBBI)"
  },
  {
   value: "Bhuj (INBHJ)",
   label: "Bhuj (INBHJ)"
  },
  {
   value: "Bhusaval (INBSL)",
   label: "Bhusaval (INBSL)"
  },
  {
   value: "Bikaner (INBKB)",
   label: "Bikaner (INBKB)"
  },
  {
   value: "Bilaspur (INPAB)",
   label: "Bilaspur (INPAB)"
  },
  {
   value: "Bilimora (INBLM)",
   label: "Bilimora (INBLM)"
  },
  {
   value: "Bitra Is (INBTR)",
   label: "Bitra Is (INBTR)"
  },
  {
   value: "Bolanganj (INBOL)",
   label: "Bolanganj (INBOL)"
  },
  {
   value: "Boranada, Jodhpur (INBRN)",
   label: "Boranada, Jodhpur (INBRN)"
  },
  {
   value: "Borliai-Mandla (INBRM)",
   label: "Borliai-Mandla (INBRM)"
  },
  {
   value: "Borya (INBRY)",
   label: "Borya (INBRY)"
  },
  {
   value: "Broach (INBRH)",
   label: "Broach (INBRH)"
  },
  {
   value: "Budge-Budge (INBUD)",
   label: "Budge-Budge (INBUD)"
  },
  {
   value: "Bulsar (INBSR)",
   label: "Bulsar (INBSR)"
  },
  {
   value: "Bundala (INBUN)",
   label: "Bundala (INBUN)"
  },
  {
   value: "Calingapatam (INCAP)",
   label: "Calingapatam (INCAP)"
  },
  {
   value: "Cambay (INCAM)",
   label: "Cambay (INCAM)"
  },
  {
   value: "Cannanore (INCNN)",
   label: "Cannanore (INCNN)"
  },
  {
   value: "Car Nicobar (INCBD)",
   label: "Car Nicobar (INCBD)"
  },
  {
   value: "Carijam (INCAR)",
   label: "Carijam (INCAR)"
  },
  {
   value: "Champai (INCHP)",
   label: "Champai (INCHP)"
  },
  {
   value: "Chamurci (INCHM)",
   label: "Chamurci (INCHM)"
  },
  {
   value: "Chandbali (INCBL)",
   label: "Chandbali (INCBL)"
  },
  {
   value: "Chandigarh (INIXC)",
   label: "Chandigarh (INIXC)"
  },
  {
   value: "Changrabandha (INCRB)",
   label: "Changrabandha (INCRB)"
  },
  {
   value: "Chapora (INCHR)",
   label: "Chapora (INCHR)"
  },
  {
   value: "Chattrapati Shivaji International Airport (INCSI)",
   label: "Chattrapati Shivaji International Airport (INCSI)"
  },
  {
   value: "Chengalpattu (INCPU)",
   label: "Chengalpattu (INCPU)"
  },
  {
   value: " ()",
   label: " ()"
  },
  {
   value: "Chetlat Is (INCTI)",
   label: "Chetlat Is (INCTI)"
  },
  {
   value: "Chhani\/Vadodora (INCHN)",
   label: "Chhani\/Vadodora (INCHN)"
  },
  {
   value: "Chidambaram (INCDM)",
   label: "Chidambaram (INCDM)"
  },
  {
   value: "Chikaballur (INCHI)",
   label: "Chikaballur (INCHI)"
  },
  {
   value: "Chikalthana (INCKH)",
   label: "Chikalthana (INCKH)"
  },
  {
   value: "Chirala (INCLX)",
   label: "Chirala (INCLX)"
  },
  {
   value: "Chittoor (INCHT)",
   label: "Chittoor (INCHT)"
  },
  {
   value: "Cholapuram (INCHS)",
   label: "Cholapuram (INCHS)"
  },
  {
   value: "Cochin (INCOK)",
   label: "Cochin (INCOK)"
  },
  {
   value: "Coimbatore (INCJB)",
   label: "Coimbatore (INCJB)"
  },
  {
   value: "Colochel (INCOL)",
   label: "Colochel (INCOL)"
  },
  {
   value: "Cooch Behar (INCOH)",
   label: "Cooch Behar (INCOH)"
  },
  {
   value: "Coondapur (Ganguly) (INCOO)",
   label: "Coondapur (Ganguly) (INCOO)"
  },
  {
   value: "Cornwallis (INCRN)",
   label: "Cornwallis (INCRN)"
  },
  {
   value: "Cossipore (INCOS)",
   label: "Cossipore (INCOS)"
  },
  {
   value: "Cuddalore (INCDL)",
   label: "Cuddalore (INCDL)"
  },
  {
   value: "Cuddapah (INCDP)",
   label: "Cuddapah (INCDP)"
  },
  {
   value: "Dabhol Port (INDHP)",
   label: "Dabhol Port (INDHP)"
  },
  {
   value: "Dabolim (INDRL)",
   label: "Dabolim (INDRL)"
  },
  {
   value: "Dadra (INDAD)",
   label: "Dadra (INDAD)"
  },
  {
   value: "Dadri (INDRI)",
   label: "Dadri (INDRI)"
  },
  {
   value: "Dadri Container Terminal (INDCT)",
   label: "Dadri Container Terminal (INDCT)"
  },
  {
   value: "Dahanu (INDHU)",
   label: "Dahanu (INDHU)"
  },
  {
   value: "Dahej (INDAH)",
   label: "Dahej (INDAH)"
  },
  {
   value: "Dalu (INDLU)",
   label: "Dalu (INDLU)"
  },
  {
   value: "Daman (INDAM)",
   label: "Daman (INDAM)"
  },
  {
   value: "Dantiwara (INDTW)",
   label: "Dantiwara (INDTW)"
  },
  {
   value: "Daparizo (INDAE)",
   label: "Daparizo (INDAE)"
  },
  {
   value: "Dapper (INDPR)",
   label: "Dapper (INDPR)"
  },
  {
   value: "Darjeeling (INDAI)",
   label: "Darjeeling (INDAI)"
  },
  {
   value: "Darranga (INDRG)",
   label: "Darranga (INDRG)"
  },
  {
   value: "Daulatabad (INDLB)",
   label: "Daulatabad (INDLB)"
  },
  {
   value: "Dawki (INDWK)",
   label: "Dawki (INDWK)"
  },
  {
   value: "Dehra Dun (INDED)",
   label: "Dehra Dun (INDED)"
  },
  {
   value: "Delhi (INDEL)",
   label: "Delhi (INDEL)"
  },
  {
   value: "Demagir (INDMR)",
   label: "Demagir (INDMR)"
  },
  {
   value: "Deogad (INDEG)",
   label: "Deogad (INDEG)"
  },
  {
   value: "Deparizo (INDEP)",
   label: "Deparizo (INDEP)"
  },
  {
   value: "Dera Bassi (INDBA)",
   label: "Dera Bassi (INDBA)"
  },
  {
   value: "Dhalaighat (INDHL)",
   label: "Dhalaighat (INDHL)"
  },
  {
   value: "Dhanbad (INDBD)",
   label: "Dhanbad (INDBD)"
  },
  {
   value: "Dhannad\/Indore (INDHA)",
   label: "Dhannad\/Indore (INDHA)"
  },
  {
   value: "Dhanu-shkodi (INDSK)",
   label: "Dhanu-shkodi (INDSK)"
  },
  {
   value: "Dharamsala (INDHM)",
   label: "Dharamsala (INDHM)"
  },
  {
   value: "Dharamtar (INDMT)",
   label: "Dharamtar (INDMT)"
  },
  {
   value: "Dharchula (INDLA)",
   label: "Dharchula (INDLA)"
  },
  {
   value: "Dharwad (INDHW)",
   label: "Dharwad (INDHW)"
  },
  {
   value: "Dholera (INDHR)",
   label: "Dholera (INDHR)"
  },
  {
   value: "Dhubri Steamerghat (INDHB)",
   label: "Dhubri Steamerghat (INDHB)"
  },
  {
   value: "Dibrugarh (INDIB)",
   label: "Dibrugarh (INDIB)"
  },
  {
   value: "Dighi (Pune) (INDIG)",
   label: "Dighi (Pune) (INDIG)"
  },
  {
   value: "Dimapur (INDMU)",
   label: "Dimapur (INDMU)"
  },
  {
   value: "Diu (INDIU)",
   label: "Diu (INDIU)"
  },
  {
   value: "Div (INDIV)",
   label: "Div (INDIV)"
  },
  {
   value: "Durgapur (INDUR)",
   label: "Durgapur (INDUR)"
  },
  {
   value: "Dwarka (INDWA)",
   label: "Dwarka (INDWA)"
  },
  {
   value: "Dwarka (Rupen) (INDRK)",
   label: "Dwarka (Rupen) (INDRK)"
  },
  {
   value: "Elphinstone Harbour (INESH)",
   label: "Elphinstone Harbour (INESH)"
  },
  {
   value: "Ennore (INENR)",
   label: "Ennore (INENR)"
  },
  {
   value: "Ernakulam (INERN)",
   label: "Ernakulam (INERN)"
  },
  {
   value: "Erode (INERO)",
   label: "Erode (INERO)"
  },
  {
   value: "Falta (INFLT)",
   label: "Falta (INFLT)"
  },
  {
   value: "Farakka (INFAR)",
   label: "Farakka (INFAR)"
  },
  {
   value: "Faridabad (INFBD)",
   label: "Faridabad (INFBD)"
  },
  {
   value: "Gajraula (INGUJ)",
   label: "Gajraula (INGUJ)"
  },
  {
   value: "Galgalia (INGAL)",
   label: "Galgalia (INGAL)"
  },
  {
   value: "Gandhar (INGAN)",
   label: "Gandhar (INGAN)"
  },
  {
   value: "Gandhidham (INGIN)",
   label: "Gandhidham (INGIN)"
  },
  {
   value: "Gangavaram (INGGV)",
   label: "Gangavaram (INGGV)"
  },
  {
   value: "Gangtok (INGAT)",
   label: "Gangtok (INGAT)"
  },
  {
   value: "Garhi Harsaru (INGHR)",
   label: "Garhi Harsaru (INGHR)"
  },
  {
   value: "Garhwa (INGWA)",
   label: "Garhwa (INGWA)"
  },
  {
   value: "Gauhati (Panidi) (INGAU)",
   label: "Gauhati (Panidi) (INGAU)"
  },
  {
   value: "Gauriphanta (INGAI)",
   label: "Gauriphanta (INGAI)"
  },
  {
   value: "Gaya (INGAY)",
   label: "Gaya (INGAY)"
  },
  {
   value: "Gede Rail Station (INGED)",
   label: "Gede Rail Station (INGED)"
  },
  {
   value: "Getandah (INGTZ)",
   label: "Getandah (INGTZ)"
  },
  {
   value: "Ghasuapara (INGHP)",
   label: "Ghasuapara (INGHP)"
  },
  {
   value: "Ghaziabad (INGZB)",
   label: "Ghaziabad (INGZB)"
  },
  {
   value: "Ghaziabad (INGZD)",
   label: "Ghaziabad (INGZD)"
  },
  {
   value: "Ghogha (INGHA)",
   label: "Ghogha (INGHA)"
  },
  {
   value: "Ghojadanga (INGJX)",
   label: "Ghojadanga (INGJX)"
  },
  {
   value: "Gitaldah Road (INGTG)",
   label: "Gitaldah Road (INGTG)"
  },
  {
   value: "Goa (INGOI)",
   label: "Goa (INGOI)"
  },
  {
   value: "Godhra (INGAH)",
   label: "Godhra (INGAH)"
  },
  {
   value: "Gogha (INGGA)",
   label: "Gogha (INGGA)"
  },
  {
   value: "Golakganj Rail Station (INGKJ)",
   label: "Golakganj Rail Station (INGKJ)"
  },
  {
   value: "Gopalpur (INGPR)",
   label: "Gopalpur (INGPR)"
  },
  {
   value: "Gorakhpur (INGOP)",
   label: "Gorakhpur (INGOP)"
  },
  {
   value: "Güdür (INGUD)",
   label: "Güdür (INGUD)"
  },
  {
   value: "Gummidipoondi (INGUM)",
   label: "Gummidipoondi (INGUM)"
  },
  {
   value: "Guna (INGUX)",
   label: "Guna (INGUX)"
  },
  {
   value: "Gunji (INGJI)",
   label: "Gunji (INGJI)"
  },
  {
   value: "Guntur (INGTR)",
   label: "Guntur (INGTR)"
  },
  {
   value: "Gurdaspur (INGDR)",
   label: "Gurdaspur (INGDR)"
  },
  {
   value: "Gurgaon (INGGN)",
   label: "Gurgaon (INGGN)"
  },
  {
   value: "Guwahati (INGAW)",
   label: "Guwahati (INGAW)"
  },
  {
   value: "Gwalior (INGWL)",
   label: "Gwalior (INGWL)"
  },
  {
   value: "Haldia (INHAL)",
   label: "Haldia (INHAL)"
  },
  {
   value: "Haldibari Rail Stat ion (INHLD)",
   label: "Haldibari Rail Stat ion (INHLD)"
  },
  {
   value: "Halol (INHLO)",
   label: "Halol (INHLO)"
  },
  {
   value: "Hangarkatta (INHGT)",
   label: "Hangarkatta (INHGT)"
  },
  {
   value: "Harnai (INHRN)",
   label: "Harnai (INHRN)"
  },
  {
   value: "Haryana (INHAR)",
   label: "Haryana (INHAR)"
  },
  {
   value: "Hassan (INHAS)",
   label: "Hassan (INHAS)"
  },
  {
   value: "Hatisar (INHTS)",
   label: "Hatisar (INHTS)"
  },
  {
   value: "Hazira (INHZR)",
   label: "Hazira (INHZR)"
  },
  {
   value: "Hilli (INHLI)",
   label: "Hilli (INHLI)"
  },
  {
   value: "Himachal Pradesh (INHIP)",
   label: "Himachal Pradesh (INHIP)"
  },
  {
   value: "Hingalganj (INHGL)",
   label: "Hingalganj (INHGL)"
  },
  {
   value: "Hissar (INHSS)",
   label: "Hissar (INHSS)"
  },
  {
   value: "Honavar (INHON)",
   label: "Honavar (INHON)"
  },
  {
   value: "Honawar (INHWR)",
   label: "Honawar (INHWR)"
  },
  {
   value: "Hosur (INHSR)",
   label: "Hosur (INHSR)"
  },
  {
   value: "Hubli (INHBX)",
   label: "Hubli (INHBX)"
  },
  {
   value: "Hyderabad (INHYD)",
   label: "Hyderabad (INHYD)"
  },
  {
   value: "Imphal (INIMF)",
   label: "Imphal (INIMF)"
  },
  {
   value: "Indore (INIDR)",
   label: "Indore (INIDR)"
  },
  {
   value: "Irungattukottai (INIRU)",
   label: "Irungattukottai (INIRU)"
  },
  {
   value: "Itanagar (INITA)",
   label: "Itanagar (INITA)"
  },
  {
   value: "Jabalpur (INJLR)",
   label: "Jabalpur (INJLR)"
  },
  {
   value: "Jafarabad (INJBD)",
   label: "Jafarabad (INJBD)"
  },
  {
   value: "Jagdalpur (INJGB)",
   label: "Jagdalpur (INJGB)"
  },
  {
   value: "Jaigad (INJGD)",
   label: "Jaigad (INJGD)"
  },
  {
   value: "Jaigaon (INJIG)",
   label: "Jaigaon (INJIG)"
  },
  {
   value: "Jaipur (INJAI)",
   label: "Jaipur (INJAI)"
  },
  {
   value: "Jaipur-Kanakpura (INKKU)",
   label: "Jaipur-Kanakpura (INKKU)"
  },
  {
   value: "Jaipur-Sitapura (INJSZ)",
   label: "Jaipur-Sitapura (INJSZ)"
  },
  {
   value: "Jaisalmer (INJSA)",
   label: "Jaisalmer (INJSA)"
  },
  {
   value: "Jaitapur (INJTP)",
   label: "Jaitapur (INJTP)"
  },
  {
   value: "Jakhau (INJAK)",
   label: "Jakhau (INJAK)"
  },
  {
   value: "Jalandhar (INJUC)",
   label: "Jalandhar (INJUC)"
  },
  {
   value: "Jalgaon (INJAL)",
   label: "Jalgaon (INJAL)"
  },
  {
   value: "Jalpaiguri (INJPG)",
   label: "Jalpaiguri (INJPG)"
  },
  {
   value: "Jammu (INIXJ)",
   label: "Jammu (INIXJ)"
  },
  {
   value: "Jamnagar (INJGA)",
   label: "Jamnagar (INJGA)"
  },
  {
   value: "Jamshedpur (INIXW)",
   label: "Jamshedpur (INIXW)"
  },
  {
   value: "Jarwa (INJWA)",
   label: "Jarwa (INJWA)"
  },
  {
   value: "Jawaharlal Nehru (Nhava Sheva) (INNSA)",
   label: "Jawaharlal Nehru (Nhava Sheva) (INNSA)"
  },
  {
   value: "Jayanagar (INJAY)",
   label: "Jayanagar (INJAY)"
  },
  {
   value: "Jeypore (INPYB)",
   label: "Jeypore (INPYB)"
  },
  {
   value: "Jhulaghat (Pithoragarh) (INJHO)",
   label: "Jhulaghat (Pithoragarh) (INJHO)"
  },
  {
   value: "Jodhpur (INJDH)",
   label: "Jodhpur (INJDH)"
  },
  {
   value: "Jodhpur-Bhagat Ki Kothi (INBGK)",
   label: "Jodhpur-Bhagat Ki Kothi (INBGK)"
  },
  {
   value: "Jodhpur-Thar (INTHA)",
   label: "Jodhpur-Thar (INTHA)"
  },
  {
   value: "Jodia (INJDA)",
   label: "Jodia (INJDA)"
  },
  {
   value: "Jogbani (INJBN)",
   label: "Jogbani (INJBN)"
  },
  {
   value: "Jorhat (INJRH)",
   label: "Jorhat (INJRH)"
  },
  {
   value: "Kadmat Is (INKDI)",
   label: "Kadmat Is (INKDI)"
  },
  {
   value: "Kailashahar (INIXH)",
   label: "Kailashahar (INIXH)"
  },
  {
   value: "Kakinada (INKAK)",
   label: "Kakinada (INKAK)"
  },
  {
   value: "Kakrala (INKRA)",
   label: "Kakrala (INKRA)"
  },
  {
   value: "Kallai (INKAL)",
   label: "Kallai (INKAL)"
  },
  {
   value: "Kalpeni I. (INKPI)",
   label: "Kalpeni I. (INKPI)"
  },
  {
   value: "Kalyan (INKLY)",
   label: "Kalyan (INKLY)"
  },
  {
   value: "Kamalpur (INIXQ)",
   label: "Kamalpur (INIXQ)"
  },
  {
   value: "Kanchipuram (INKCP)",
   label: "Kanchipuram (INKCP)"
  },
  {
   value: "Kandla (INIXY)",
   label: "Kandla (INIXY)"
  },
  {
   value: "Kankudy (INKND)",
   label: "Kankudy (INKND)"
  },
  {
   value: "Kanpur (INKNU)",
   label: "Kanpur (INKNU)"
  },
  {
   value: "Kanyakumari (INKKM)",
   label: "Kanyakumari (INKKM)"
  },
  {
   value: "Kapadra (Surat) (INKAP)",
   label: "Kapadra (Surat) (INKAP)"
  },
  {
   value: "Karaikal (INKRK)",
   label: "Karaikal (INKRK)"
  },
  {
   value: "Karanja (INKRN)",
   label: "Karanja (INKRN)"
  },
  {
   value: "Karedu (INKDD)",
   label: "Karedu (INKDD)"
  },
  {
   value: "Karimnagar (INKMR)",
   label: "Karimnagar (INKMR)"
  },
  {
   value: "Karur (INKAR)",
   label: "Karur (INKAR)"
  },
  {
   value: "Karwar (INKRW)",
   label: "Karwar (INKRW)"
  },
  {
   value: "Kasargod (INKSG)",
   label: "Kasargod (INKSG)"
  },
  {
   value: "Kashipur (INKSR)",
   label: "Kashipur (INKSR)"
  },
  {
   value: "Katarniyaghat (INKTG)",
   label: "Katarniyaghat (INKTG)"
  },
  {
   value: "Kathinhar (INKTR)",
   label: "Kathinhar (INKTR)"
  },
  {
   value: "Kavaram Is (INKVT)",
   label: "Kavaram Is (INKVT)"
  },
  {
   value: "Kavi (INKVI)",
   label: "Kavi (INKVI)"
  },
  {
   value: "Kel Sahar Subdivision (INKEL)",
   label: "Kel Sahar Subdivision (INKEL)"
  },
  {
   value: "Kelshi (INKSH)",
   label: "Kelshi (INKSH)"
  },
  {
   value: "Kelwa (INKIW)",
   label: "Kelwa (INKIW)"
  },
  {
   value: "Keonjhar (INKEO)",
   label: "Keonjhar (INKEO)"
  },
  {
   value: "Keshod (INIXK)",
   label: "Keshod (INIXK)"
  },
  {
   value: "Khajuraho (INHJR)",
   label: "Khajuraho (INHJR)"
  },
  {
   value: "Khambhat (INKBT)",
   label: "Khambhat (INKBT)"
  },
  {
   value: "Khamgaon (INKGA)",
   label: "Khamgaon (INKGA)"
  },
  {
   value: "Kheda\/Dhar (INKHD)",
   label: "Kheda\/Dhar (INKHD)"
  },
  {
   value: "Khopta (INKHP)",
   label: "Khopta (INKHP)"
  },
  {
   value: "Khowai (INIXN)",
   label: "Khowai (INIXN)"
  },
  {
   value: "Khowaighat (INKWG)",
   label: "Khowaighat (INKWG)"
  },
  {
   value: "Khunwa (INKWA)",
   label: "Khunwa (INKWA)"
  },
  {
   value: "Kilakari (INKKR)",
   label: "Kilakari (INKKR)"
  },
  {
   value: "Kiltan Is (INKTI)",
   label: "Kiltan Is (INKTI)"
  },
  {
   value: "Kiranpani (INKRP)",
   label: "Kiranpani (INKRP)"
  },
  {
   value: "Kochi (INKOC)",
   label: "Kochi (INKOC)"
  },
  {
   value: "Kodinar (INKOD)",
   label: "Kodinar (INKOD)"
  },
  {
   value: "Koheshwar (INKTW)",
   label: "Koheshwar (INKTW)"
  },
  {
   value: "Koilthottum (INKOI)",
   label: "Koilthottum (INKOI)"
  },
  {
   value: "Koka (INKOK)",
   label: "Koka (INKOK)"
  },
  {
   value: "Kolhåpur (INKLH)",
   label: "Kolhåpur (INKLH)"
  },
  {
   value: "Kolkata (ex Calcutta) (INCCU)",
   label: "Kolkata (ex Calcutta) (INCCU)"
  },
  {
   value: "Konarak (INKON)",
   label: "Konarak (INKON)"
  },
  {
   value: "Kondiapetnam (INKDP)",
   label: "Kondiapetnam (INKDP)"
  },
  {
   value: "Kota (INKTU)",
   label: "Kota (INKTU)"
  },
  {
   value: "Kotawalighat (Mohedipur) (INMHD)",
   label: "Kotawalighat (Mohedipur) (INMHD)"
  },
  {
   value: "Kotda (INKTD)",
   label: "Kotda (INKTD)"
  },
  {
   value: "Kothagudem (INKOT)",
   label: "Kothagudem (INKOT)"
  },
  {
   value: "Kovalam (INKVL)",
   label: "Kovalam (INKVL)"
  },
  {
   value: "Kozhikode (ex Calicut) (INCCJ)",
   label: "Kozhikode (ex Calicut) (INCCJ)"
  },
  {
   value: "Krishnapatnam (INKRI)",
   label: "Krishnapatnam (INKRI)"
  },
  {
   value: "Kulasekarapanam (INKSP)",
   label: "Kulasekarapanam (INKSP)"
  },
  {
   value: "Kulu (INKUU)",
   label: "Kulu (INKUU)"
  },
  {
   value: "Kumbharu (INKMB)",
   label: "Kumbharu (INKMB)"
  },
  {
   value: "Kunauli (INKNL)",
   label: "Kunauli (INKNL)"
  },
  {
   value: "Kundapur (INKUD)",
   label: "Kundapur (INKUD)"
  },
  {
   value: "Kundla (INKUN)",
   label: "Kundla (INKUN)"
  },
  {
   value: "Lalakua (INLAK)",
   label: "Lalakua (INLAK)"
  },
  {
   value: "Lalgola Town (INLGL)",
   label: "Lalgola Town (INLGL)"
  },
  {
   value: "Lalru (INLAL)",
   label: "Lalru (INLAL)"
  },
  {
   value: "Latu Bazar (INLTB)",
   label: "Latu Bazar (INLTB)"
  },
  {
   value: "Latur (INLAT)",
   label: "Latur (INLAT)"
  },
  {
   value: "Leapuram (INLPR)",
   label: "Leapuram (INLPR)"
  },
  {
   value: "Leh (INIXL)",
   label: "Leh (INIXL)"
  },
  {
   value: "Lilabari (INIXI)",
   label: "Lilabari (INIXI)"
  },
  {
   value: "Lkoyali (INKOY)",
   label: "Lkoyali (INKOY)"
  },
  {
   value: "Loni (INLNI)",
   label: "Loni (INLNI)"
  },
  {
   value: "Loni (INLON)",
   label: "Loni (INLON)"
  },
  {
   value: "Loni Kalbhor (INLKH)",
   label: "Loni Kalbhor (INLKH)"
  },
  {
   value: "Lucknow (INLKO)",
   label: "Lucknow (INLKO)"
  },
  {
   value: "Ludhiana (INLUH)",
   label: "Ludhiana (INLUH)"
  },
  {
   value: "Madgaon (INMRG)",
   label: "Madgaon (INMRG)"
  },
  {
   value: "Madhosingh\/Allahabad (INMBS)",
   label: "Madhosingh\/Allahabad (INMBS)"
  },
  {
   value: "Madurai (INIXM)",
   label: "Madurai (INIXM)"
  },
  {
   value: "Magdalla (INMDA)",
   label: "Magdalla (INMDA)"
  },
  {
   value: "Mahad (INHAD)",
   label: "Mahad (INHAD)"
  },
  {
   value: "Mahe (INMAH)",
   label: "Mahe (INMAH)"
  },
  {
   value: "Mahendraganj (INMGH)",
   label: "Mahendraganj (INMGH)"
  },
  {
   value: "Mahesana (INMSA)",
   label: "Mahesana (INMSA)"
  },
  {
   value: "Mahisashan Rail Station (INMHN)",
   label: "Mahisashan Rail Station (INMHN)"
  },
  {
   value: "Mahurighat (INMHG)",
   label: "Mahurighat (INMHG)"
  },
  {
   value: "Mahuva (INMHA)",
   label: "Mahuva (INMHA)"
  },
  {
   value: "Malanpur (INMPR)",
   label: "Malanpur (INMPR)"
  },
  {
   value: "Malappuram (INMRK)",
   label: "Malappuram (INMRK)"
  },
  {
   value: "Malda (INLDA)",
   label: "Malda (INLDA)"
  },
  {
   value: "Maliwada (INMWA)",
   label: "Maliwada (INMWA)"
  },
  {
   value: "Mallipuram (INMLP)",
   label: "Mallipuram (INMLP)"
  },
  {
   value: "Malpe (INMAL)",
   label: "Malpe (INMAL)"
  },
  {
   value: "Malwan (INMLW)",
   label: "Malwan (INMLW)"
  },
  {
   value: "Mandapam (INMDP)",
   label: "Mandapam (INMDP)"
  },
  {
   value: "Mandideep (INMNP)",
   label: "Mandideep (INMNP)"
  },
  {
   value: "Måndvi (INMDV)",
   label: "Måndvi (INMDV)"
  },
  {
   value: "Mandwa (INMNW)",
   label: "Mandwa (INMNW)"
  },
  {
   value: "Mangalore (INIXE)",
   label: "Mangalore (INIXE)"
  },
  {
   value: "Mangrol (INMGR)",
   label: "Mangrol (INMGR)"
  },
  {
   value: "Manikarchar (INMKC)",
   label: "Manikarchar (INMKC)"
  },
  {
   value: "Manori (INMNR)",
   label: "Manori (INMNR)"
  },
  {
   value: "Manu (INMNU)",
   label: "Manu (INMNU)"
  },
  {
   value: "Marmagao (Marmugao) (INMRM)",
   label: "Marmagao (Marmugao) (INMRM)"
  },
  {
   value: "Maroli (INMLI)",
   label: "Maroli (INMLI)"
  },
  {
   value: "Masulipatnam (INMAP)",
   label: "Masulipatnam (INMAP)"
  },
  {
   value: "Mathura (INMAT)",
   label: "Mathura (INMAT)"
  },
  {
   value: "Mayabandar (INMYB)",
   label: "Mayabandar (INMYB)"
  },
  {
   value: "Meadows (INMDW)",
   label: "Meadows (INMDW)"
  },
  {
   value: "Medinipur (INMED)",
   label: "Medinipur (INMED)"
  },
  {
   value: "Meerut (INMER)",
   label: "Meerut (INMER)"
  },
  {
   value: "Metwad (INMTW)",
   label: "Metwad (INMTW)"
  },
  {
   value: "Minicoi I (INMCI)",
   label: "Minicoi I (INMCI)"
  },
  {
   value: "Miraj (INMRJ)",
   label: "Miraj (INMRJ)"
  },
  {
   value: "Mithivirdi (INMRI)",
   label: "Mithivirdi (INMRI)"
  },
  {
   value: "Mohali (INMHI)",
   label: "Mohali (INMHI)"
  },
  {
   value: "Mohanbari (INMOH)",
   label: "Mohanbari (INMOH)"
  },
  {
   value: "Mora (INMRA)",
   label: "Mora (INMRA)"
  },
  {
   value: "Moradabad (INMOR)",
   label: "Moradabad (INMOR)"
  },
  {
   value: "Morbi (INMOB)",
   label: "Morbi (INMOB)"
  },
  {
   value: "Moreh (INMRE)",
   label: "Moreh (INMRE)"
  },
  {
   value: "Mul Dwårka (INMDK)",
   label: "Mul Dwårka (INMDK)"
  },
  {
   value: "Mulgund (INMUL)",
   label: "Mulgund (INMUL)"
  },
  {
   value: "Mumbai (ex Bombay) (INBOM)",
   label: "Mumbai (ex Bombay) (INBOM)"
  },
  {
   value: "Munabao Rail Station (INMNB)",
   label: "Munabao Rail Station (INMNB)"
  },
  {
   value: "Mundra (INMUN)",
   label: "Mundra (INMUN)"
  },
  {
   value: "Munger (INMUG)",
   label: "Munger (INMUG)"
  },
  {
   value: "Murad (INMUR)",
   label: "Murad (INMUR)"
  },
  {
   value: "Muzaffarnagar (INMZA)",
   label: "Muzaffarnagar (INMZA)"
  },
  {
   value: "Muzaffarpur (INMZU)",
   label: "Muzaffarpur (INMZU)"
  },
  {
   value: "Mysore (INMYQ)",
   label: "Mysore (INMYQ)"
  },
  {
   value: "Nagappattinam (INNPT)",
   label: "Nagappattinam (INNPT)"
  },
  {
   value: "Nagapur (INNPR)",
   label: "Nagapur (INNPR)"
  },
  {
   value: "Nagercoil (INNGC)",
   label: "Nagercoil (INNGC)"
  },
  {
   value: "Nagpur (INNAG)",
   label: "Nagpur (INNAG)"
  },
  {
   value: "Namkhana (INNKN)",
   label: "Namkhana (INNKN)"
  },
  {
   value: "Nampong (INNPG)",
   label: "Nampong (INNPG)"
  },
  {
   value: "Nancowrie (INNAN)",
   label: "Nancowrie (INNAN)"
  },
  {
   value: "Nanded (INNDC)",
   label: "Nanded (INNDC)"
  },
  {
   value: "Nandgaon (INNDG)",
   label: "Nandgaon (INNDG)"
  },
  {
   value: "Nasik (INISK)",
   label: "Nasik (INISK)"
  },
  {
   value: "Navabunder (INNVB)",
   label: "Navabunder (INNVB)"
  },
  {
   value: "Navaspur (INNVP)",
   label: "Navaspur (INNVP)"
  },
  {
   value: "Navi Mumbai (INNMB)",
   label: "Navi Mumbai (INNMB)"
  },
  {
   value: "Navlakhi (INNAV)",
   label: "Navlakhi (INNAV)"
  },
  {
   value: "Neamari Stemerghat (INNMT)",
   label: "Neamari Stemerghat (INNMT)"
  },
  {
   value: "Nellore (INNEL)",
   label: "Nellore (INNEL)"
  },
  {
   value: "Nepalgunj Road (INNGR)",
   label: "Nepalgunj Road (INNGR)"
  },
  {
   value: "New Delhi (INICD)",
   label: "New Delhi (INICD)"
  },
  {
   value: "New Mangalore (INNML)",
   label: "New Mangalore (INNML)"
  },
  {
   value: "New Tuticorin (INNTU)",
   label: "New Tuticorin (INNTU)"
  },
  {
   value: "Newapur (INNWP)",
   label: "Newapur (INNWP)"
  },
  {
   value: "Neyveli (INNVY)",
   label: "Neyveli (INNVY)"
  },
  {
   value: "Nhave (INNHV)",
   label: "Nhave (INNHV)"
  },
  {
   value: "Nindakara (INNEE)",
   label: "Nindakara (INNEE)"
  },
  {
   value: "Nivti (INNVT)",
   label: "Nivti (INNVT)"
  },
  {
   value: "Noida (INNDA)",
   label: "Noida (INNDA)"
  },
  {
   value: "Okha (INOKH)",
   label: "Okha (INOKH)"
  },
  {
   value: "Old Raghna Bazar (INRGB)",
   label: "Old Raghna Bazar (INRGB)"
  },
  {
   value: "Ongole (INONG)",
   label: "Ongole (INONG)"
  },
  {
   value: "Onjal (INONJ)",
   label: "Onjal (INONJ)"
  },
  {
   value: "Osmanabad (INOMN)",
   label: "Osmanabad (INOMN)"
  },
  {
   value: "Padi (INPDI)",
   label: "Padi (INPDI)"
  },
  {
   value: "Padubidri (INPDD)",
   label: "Padubidri (INPDD)"
  },
  {
   value: "Pakwara (Moradabad) (INMBD)",
   label: "Pakwara (Moradabad) (INMBD)"
  },
  {
   value: "Palghat (INPAL)",
   label: "Palghat (INPAL)"
  },
  {
   value: "Palshet (INPSH)",
   label: "Palshet (INPSH)"
  },
  {
   value: "Pamban (INPMB)",
   label: "Pamban (INPMB)"
  },
  {
   value: "Panaji Port (INPAN)",
   label: "Panaji Port (INPAN)"
  },
  {
   value: "Panambur, Va Mangalore (INPNM)",
   label: "Panambur, Va Mangalore (INPNM)"
  },
  {
   value: "Panipat (INPAP)",
   label: "Panipat (INPAP)"
  },
  {
   value: "Panitankit (Nazalbari) (INPNT)",
   label: "Panitankit (Nazalbari) (INPNT)"
  },
  {
   value: "Panjim (INPNJ)",
   label: "Panjim (INPNJ)"
  },
  {
   value: "Panoli (INNOL)",
   label: "Panoli (INNOL)"
  },
  {
   value: "Pantnagar (INPGH)",
   label: "Pantnagar (INPGH)"
  },
  {
   value: "Panvel (INPVL)",
   label: "Panvel (INPVL)"
  },
  {
   value: "Paradip Garh (INPRT)",
   label: "Paradip Garh (INPRT)"
  },
  {
   value: "Pasighat (INIXT)",
   label: "Pasighat (INIXT)"
  },
  {
   value: "Pathankot (INIXP)",
   label: "Pathankot (INIXP)"
  },
  {
   value: "Patli (INPTL)",
   label: "Patli (INPTL)"
  },
  {
   value: "Patna (INPAT)",
   label: "Patna (INPAT)"
  },
  {
   value: "Patparganj (INPPG)",
   label: "Patparganj (INPPG)"
  },
  {
   value: "Pellet Plant Jetty\/Shiroda (INPPJ)",
   label: "Pellet Plant Jetty\/Shiroda (INPPJ)"
  },
  {
   value: "Perundurai (INPER)",
   label: "Perundurai (INPER)"
  },
  {
   value: "Petrapole Road (INPTP)",
   label: "Petrapole Road (INPTP)"
  },
  {
   value: "Phulbari (INPHB)",
   label: "Phulbari (INPHB)"
  },
  {
   value: "Pimpri (INPMP)",
   label: "Pimpri (INPMP)"
  },
  {
   value: "Pindhara (INPIN)",
   label: "Pindhara (INPIN)"
  },
  {
   value: "Pipavav (Victor) Port (INPAV)",
   label: "Pipavav (Victor) Port (INPAV)"
  },
  {
   value: "Pithampur (INPIR)",
   label: "Pithampur (INPIR)"
  },
  {
   value: "Pondicherry (INPNY)",
   label: "Pondicherry (INPNY)"
  },
  {
   value: "Ponnani (INPNN)",
   label: "Ponnani (INPNN)"
  },
  {
   value: "Porbandar (INPBD)",
   label: "Porbandar (INPBD)"
  },
  {
   value: "Port Blair (INIXZ)",
   label: "Port Blair (INIXZ)"
  },
  {
   value: "Port Indai (INPID)",
   label: "Port Indai (INPID)"
  },
  {
   value: "Port Jawaharlal Nehru (INJNP)",
   label: "Port Jawaharlal Nehru (INJNP)"
  },
  {
   value: "Portonovo (INPRN)",
   label: "Portonovo (INPRN)"
  },
  {
   value: "Positra (INPST)",
   label: "Positra (INPST)"
  },
  {
   value: "Pulicat (INPUL)",
   label: "Pulicat (INPUL)"
  },
  {
   value: "Pune (INPNQ)",
   label: "Pune (INPNQ)"
  },
  {
   value: "Purangad (INPRG)",
   label: "Purangad (INPRG)"
  },
  {
   value: "Puri (INPUR)",
   label: "Puri (INPUR)"
  },
  {
   value: "Puttaparthi (INPUT)",
   label: "Puttaparthi (INPUT)"
  },
  {
   value: "Quilon (INQUI)",
   label: "Quilon (INQUI)"
  },
  {
   value: "Raddipalam (INRPL)",
   label: "Raddipalam (INRPL)"
  },
  {
   value: "Radhikapur Rail Station (INRDP)",
   label: "Radhikapur Rail Station (INRDP)"
  },
  {
   value: "Rae Bareli (INRBL)",
   label: "Rae Bareli (INRBL)"
  },
  {
   value: "Raichur (INRAR)",
   label: "Raichur (INRAR)"
  },
  {
   value: "Raigarh (INRGA)",
   label: "Raigarh (INRGA)"
  },
  {
   value: "Raili (INRRI)",
   label: "Raili (INRRI)"
  },
  {
   value: "Raipur (INRPR)",
   label: "Raipur (INRPR)"
  },
  {
   value: "Raisen (INRAI)",
   label: "Raisen (INRAI)"
  },
  {
   value: "Rajahmundry (INRJA)",
   label: "Rajahmundry (INRJA)"
  },
  {
   value: "Rajakkamangalam (INRKG)",
   label: "Rajakkamangalam (INRKG)"
  },
  {
   value: "Rajkot (INRAJ)",
   label: "Rajkot (INRAJ)"
  },
  {
   value: "Rajouri (INRJI)",
   label: "Rajouri (INRJI)"
  },
  {
   value: "Rajpara\/Navabunder (INRJP)",
   label: "Rajpara\/Navabunder (INRJP)"
  },
  {
   value: "Rajpuri (INRJR)",
   label: "Rajpuri (INRJR)"
  },
  {
   value: "Rajula (INRJU)",
   label: "Rajula (INRJU)"
  },
  {
   value: "Ramagundam (INRMD)",
   label: "Ramagundam (INRMD)"
  },
  {
   value: "Rameshwaram (INRAM)",
   label: "Rameshwaram (INRAM)"
  },
  {
   value: "Ranaghat Rail Station (INRNG)",
   label: "Ranaghat Rail Station (INRNG)"
  },
  {
   value: "Ranchi (INIXR)",
   label: "Ranchi (INIXR)"
  },
  {
   value: "Ranghat Bay (INRGT)",
   label: "Ranghat Bay (INRGT)"
  },
  {
   value: "Ranpar (INRNR)",
   label: "Ranpar (INRNR)"
  },
  {
   value: "Ratnagiri (INRTC)",
   label: "Ratnagiri (INRTC)"
  },
  {
   value: "Raxaul (INRXL)",
   label: "Raxaul (INRXL)"
  },
  {
   value: "Rayapalayam (INRAY)",
   label: "Rayapalayam (INRAY)"
  },
  {
   value: "Redi (INRED)",
   label: "Redi (INRED)"
  },
  {
   value: "Revdanda (INRVD)",
   label: "Revdanda (INRVD)"
  },
  {
   value: "Rewa (INREW)",
   label: "Rewa (INREW)"
  },
  {
   value: "Rewari (INREA)",
   label: "Rewari (INREA)"
  },
  {
   value: "Rohtak (INROH)",
   label: "Rohtak (INROH)"
  },
  {
   value: "Rourkela (INRRK)",
   label: "Rourkela (INRRK)"
  },
  {
   value: "Rudrapur (INRUD)",
   label: "Rudrapur (INRUD)"
  },
  {
   value: "Rupsi (INRUP)",
   label: "Rupsi (INRUP)"
  },
  {
   value: "Ryngku (INRGU)",
   label: "Ryngku (INRGU)"
  },
  {
   value: "Sabroom (INSAB)",
   label: "Sabroom (INSAB)"
  },
  {
   value: "Sachin (Surat) (INSAC)",
   label: "Sachin (Surat) (INSAC)"
  },
  {
   value: "Saharanpur (INSRE)",
   label: "Saharanpur (INSRE)"
  },
  {
   value: "Salaya (INSAL)",
   label: "Salaya (INSAL)"
  },
  {
   value: "Salem (INSXV)",
   label: "Salem (INSXV)"
  },
  {
   value: "Salt Lake (INSLT)",
   label: "Salt Lake (INSLT)"
  },
  {
   value: "Sanathnagar (INSAD)",
   label: "Sanathnagar (INSAD)"
  },
  {
   value: "Sangrur (INSAN)",
   label: "Sangrur (INSAN)"
  },
  {
   value: "Sardar (INSAR)",
   label: "Sardar (INSAR)"
  },
  {
   value: "Satara (INSTA)",
   label: "Satara (INSTA)"
  },
  {
   value: "Satpati (INSTP)",
   label: "Satpati (INSTP)"
  },
  {
   value: "Secunderabad (INUND)",
   label: "Secunderabad (INUND)"
  },
  {
   value: "Shella Bazar (INSBZ)",
   label: "Shella Bazar (INSBZ)"
  },
  {
   value: "Shillong (INSHL)",
   label: "Shillong (INSHL)"
  },
  {
   value: "Shirola (INSHI)",
   label: "Shirola (INSHI)"
  },
  {
   value: "Sholapur (INSSE)",
   label: "Sholapur (INSSE)"
  },
  {
   value: "Sholinghur (INSHR)",
   label: "Sholinghur (INSHR)"
  },
  {
   value: "Shriwardhan (INSWD)",
   label: "Shriwardhan (INSWD)"
  },
  {
   value: "Sika (INSIK)",
   label: "Sika (INSIK)"
  },
  {
   value: "Sikkim (INSKK)",
   label: "Sikkim (INSKK)"
  },
  {
   value: "Silchar (INIXS)",
   label: "Silchar (INIXS)"
  },
  {
   value: "Siliguri (INSIL)",
   label: "Siliguri (INSIL)"
  },
  {
   value: "Silvassa (INSIV)",
   label: "Silvassa (INSIV)"
  },
  {
   value: "Sima\/Navabunder (INSIM)",
   label: "Sima\/Navabunder (INSIM)"
  },
  {
   value: "Simbhour Port (INSHP)",
   label: "Simbhour Port (INSHP)"
  },
  {
   value: "Simla (INSLV)",
   label: "Simla (INSLV)"
  },
  {
   value: "Simor (INSMR)",
   label: "Simor (INSMR)"
  },
  {
   value: "Sinbhour (INSBH)",
   label: "Sinbhour (INSBH)"
  },
  {
   value: "Singabad Rail Station (INSNG)",
   label: "Singabad Rail Station (INSNG)"
  },
  {
   value: "Singanallur (INSIR)",
   label: "Singanallur (INSIR)"
  },
  {
   value: "Sirpur (INSPR)",
   label: "Sirpur (INSPR)"
  },
  {
   value: "Sitai (INSTI)",
   label: "Sitai (INSTI)"
  },
  {
   value: "Sonabarsa (INSNB)",
   label: "Sonabarsa (INSNB)"
  },
  {
   value: "Sonauli (INSNL)",
   label: "Sonauli (INSNL)"
  },
  {
   value: "Sonepat (INSON)",
   label: "Sonepat (INSON)"
  },
  {
   value: "Sonipat (INSOP)",
   label: "Sonipat (INSOP)"
  },
  {
   value: "Srimantapur (INSMP)",
   label: "Srimantapur (INSMP)"
  },
  {
   value: "Srinagar (INSXR)",
   label: "Srinagar (INSXR)"
  },
  {
   value: "Sukhia Pokhari (INSKP)",
   label: "Sukhia Pokhari (INSKP)"
  },
  {
   value: "Surajpur (INSJP)",
   label: "Surajpur (INSJP)"
  },
  {
   value: "Surasani-Yanam (INSRV)",
   label: "Surasani-Yanam (INSRV)"
  },
  {
   value: "Surat (INSTV)",
   label: "Surat (INSTV)"
  },
  {
   value: "Sutarkandi (INSTR)",
   label: "Sutarkandi (INSTR)"
  },
  {
   value: "T.T.Shed (INTTS)",
   label: "T.T.Shed (INTTS)"
  },
  {
   value: "Tadri (INTAD)",
   label: "Tadri (INTAD)"
  },
  {
   value: "Talaja (INTJA)",
   label: "Talaja (INTJA)"
  },
  {
   value: "Talegoan (INTLG)",
   label: "Talegoan (INTLG)"
  },
  {
   value: "Talpona (INTPN)",
   label: "Talpona (INTPN)"
  },
  {
   value: "Tamilnada (INTAM)",
   label: "Tamilnada (INTAM)"
  },
  {
   value: "Tankari (INTNK)",
   label: "Tankari (INTNK)"
  },
  {
   value: "Tarapur (INTRP)",
   label: "Tarapur (INTRP)"
  },
  {
   value: "Tellicherry (INTEL)",
   label: "Tellicherry (INTEL)"
  },
  {
   value: "Tenkasi (INTKS)",
   label: "Tenkasi (INTKS)"
  },
  {
   value: "Tezpur (INTEZ)",
   label: "Tezpur (INTEZ)"
  },
  {
   value: "Tezu (INTEI)",
   label: "Tezu (INTEI)"
  },
  {
   value: "Thal (INTHL)",
   label: "Thal (INTHL)"
  },
  {
   value: "Thana (INTNA)",
   label: "Thana (INTNA)"
  },
  {
   value: "Thane (INTHN)",
   label: "Thane (INTHN)"
  },
  {
   value: "Thanjavur (INTJV)",
   label: "Thanjavur (INTJV)"
  },
  {
   value: "Theni (INTHE)",
   label: "Theni (INTHE)"
  },
  {
   value: "Thiruvananthapuram (ex Trivandrum (INTRV)",
   label: "Thiruvananthapuram (ex Trivandrum (INTRV)"
  },
  {
   value: "Thopputhurai (INTPH)",
   label: "Thopputhurai (INTPH)"
  },
  {
   value: "Tikonia (INTKN)",
   label: "Tikonia (INTKN)"
  },
  {
   value: "Tiruchirapalli (INTRZ)",
   label: "Tiruchirapalli (INTRZ)"
  },
  {
   value: "Tirukkadayyur (INTYR)",
   label: "Tirukkadayyur (INTYR)"
  },
  {
   value: "Tirupati (INTIR)",
   label: "Tirupati (INTIR)"
  },
  {
   value: "Tiruppur (INTUP)",
   label: "Tiruppur (INTUP)"
  },
  {
   value: "Tiruvallur (INTRL)",
   label: "Tiruvallur (INTRL)"
  },
  {
   value: "Tiviri (INTIV)",
   label: "Tiviri (INTIV)"
  },
  {
   value: "Tondi (INTND)",
   label: "Tondi (INTND)"
  },
  {
   value: "Tranquebar (INTRA)",
   label: "Tranquebar (INTRA)"
  },
  {
   value: "Trombay (INTMP)",
   label: "Trombay (INTMP)"
  },
  {
   value: "Tudiyalür (INTDE)",
   label: "Tudiyalür (INTDE)"
  },
  {
   value: "Tughlakabad (INTKD)",
   label: "Tughlakabad (INTKD)"
  },
  {
   value: "Tumkur (INZUM)",
   label: "Tumkur (INZUM)"
  },
  {
   value: "Tuna (INTUN)",
   label: "Tuna (INTUN)"
  },
  {
   value: "Tungi (INTNG)",
   label: "Tungi (INTNG)"
  },
  {
   value: "Tuticorin (INTUT)",
   label: "Tuticorin (INTUT)"
  },
  {
   value: "Udaipur (INUDR)",
   label: "Udaipur (INUDR)"
  },
  {
   value: "Ultapani (INULP)",
   label: "Ultapani (INULP)"
  },
  {
   value: "Ulwa (INULW)",
   label: "Ulwa (INULW)"
  },
  {
   value: "Umarsadi (INUMR)",
   label: "Umarsadi (INUMR)"
  },
  {
   value: "Umbergaon (INUMG)",
   label: "Umbergaon (INUMG)"
  },
  {
   value: "Umbergoan (INUMB)",
   label: "Umbergoan (INUMB)"
  },
  {
   value: "Uran (INURA)",
   label: "Uran (INURA)"
  },
  {
   value: "Uttan (INUTN)",
   label: "Uttan (INUTN)"
  },
  {
   value: "Vadarevu (INVRU)",
   label: "Vadarevu (INVRU)"
  },
  {
   value: "Vadinar (INVAD)",
   label: "Vadinar (INVAD)"
  },
  {
   value: "Vadodara (INBDQ)",
   label: "Vadodara (INBDQ)"
  },
  {
   value: "Valinokkam (INVKM)",
   label: "Valinokkam (INVKM)"
  },
  {
   value: "Valsad (INVSD)",
   label: "Valsad (INVSD)"
  },
  {
   value: "Valvada (INVAL)",
   label: "Valvada (INVAL)"
  },
  {
   value: "Vansi-Borsi (INVSI)",
   label: "Vansi-Borsi (INVSI)"
  },
  {
   value: "Vapi (INVPI)",
   label: "Vapi (INVPI)"
  },
  {
   value: "Varanasi (INVNS)",
   label: "Varanasi (INVNS)"
  },
  {
   value: "Varavda (INVRD)",
   label: "Varavda (INVRD)"
  },
  {
   value: "Varsova (INVSV)",
   label: "Varsova (INVSV)"
  },
  {
   value: "Vasco da Gama (INVGM)",
   label: "Vasco da Gama (INVGM)"
  },
  {
   value: "Vazhinjam (INVZJ)",
   label: "Vazhinjam (INVZJ)"
  },
  {
   value: "Vemgira (INVNG)",
   label: "Vemgira (INVNG)"
  },
  {
   value: "Vengurla (INVEN)",
   label: "Vengurla (INVEN)"
  },
  {
   value: "Veppalodai (INVEP)",
   label: "Veppalodai (INVEP)"
  },
  {
   value: "Veraval (INVVA)",
   label: "Veraval (INVVA)"
  },
  {
   value: "Vidyanagar (INVID)",
   label: "Vidyanagar (INVID)"
  },
  {
   value: "Vijayanagar (INVIJ)",
   label: "Vijayanagar (INVIJ)"
  },
  {
   value: "Vijayawada (INVGA)",
   label: "Vijayawada (INVGA)"
  },
  {
   value: "Vijaydurg (INVYD)",
   label: "Vijaydurg (INVYD)"
  },
  {
   value: "Village Namaya Shipkila (INNGS)",
   label: "Village Namaya Shipkila (INNGS)"
  },
  {
   value: "Visakhapatnam (INVTZ)",
   label: "Visakhapatnam (INVTZ)"
  },
  {
   value: "Vizagapatanam (INVIG)",
   label: "Vizagapatanam (INVIG)"
  },
  {
   value: "Wada (INWAD)",
   label: "Wada (INWAD)"
  },
  {
   value: "Waluj (Aurangabad) (INWAL)",
   label: "Waluj (Aurangabad) (INWAL)"
  },
  {
   value: "Warora (INWAR)",
   label: "Warora (INWAR)"
  },
  {
   value: "Warrangal (INWGC)",
   label: "Warrangal (INWGC)"
  },
  {
   value: ".BRITISH INDIAN OCEAN TERRITORY (IO)",
   label: ".BRITISH INDIAN OCEAN TERRITORY (IO)"
  },
  {
   value: "Diego Garcia (IODGA)",
   label: "Diego Garcia (IODGA)"
  },
  {
   value: ".IRAQ (IQ)",
   label: ".IRAQ (IQ)"
  },
  {
   value: "Al Asad (IQASD)",
   label: "Al Asad (IQASD)"
  },
  {
   value: "Al Qayyarah (IQAQY)",
   label: "Al Qayyarah (IQAQY)"
  },
  {
   value: "Al Taqaddum (IQTQD)",
   label: "Al Taqaddum (IQTQD)"
  },
  {
   value: "An Najaf (IQANJ)",
   label: "An Najaf (IQANJ)"
  },
  {
   value: "Balad (IQBAL)",
   label: "Balad (IQBAL)"
  },
  {
   value: "Bamerny (IQBMN)",
   label: "Bamerny (IQBMN)"
  },
  {
   value: "Erbil International Apt (IQEBL)",
   label: "Erbil International Apt (IQEBL)"
  },
  {
   value: "Irbil (IQIRB)",
   label: "Irbil (IQIRB)"
  },
  {
   value: "Khan al Baghdadi (IQKAB)",
   label: "Khan al Baghdadi (IQKAB)"
  },
  {
   value: "Najaf (IQNJF)",
   label: "Najaf (IQNJF)"
  },
  {
   value: "Nasiriyah (IQNSR)",
   label: "Nasiriyah (IQNSR)"
  },
  {
   value: "Taji (IQTJI)",
   label: "Taji (IQTJI)"
  },
  {
   value: "Zakho (IQZAO)",
   label: "Zakho (IQZAO)"
  },
  {
   value: ".IRAN, ISLAMIC REPUBLIC OF (IR)",
   label: ".IRAN, ISLAMIC REPUBLIC OF (IR)"
  },
  {
   value: "Amir Abad Pt (IRAMP)",
   label: "Amir Abad Pt (IRAMP)"
  },
  {
   value: "Amirabad (IRBAM)",
   label: "Amirabad (IRBAM)"
  },
  {
   value: "Arak (IRARA)",
   label: "Arak (IRARA)"
  },
  {
   value: "Asaluyeh (IRASA)",
   label: "Asaluyeh (IRASA)"
  },
  {
   value: "Bandar Amirabad (IRAMD)",
   label: "Bandar Amirabad (IRAMD)"
  },
  {
   value: "Bandar Assaluyeh (IRBAH)",
   label: "Bandar Assaluyeh (IRBAH)"
  },
  {
   value: "Bandar Neka (IRNEK)",
   label: "Bandar Neka (IRNEK)"
  },
  {
   value: "Bandar-e-Emam Khomeyni (IRBEK)",
   label: "Bandar-e-Emam Khomeyni (IRBEK)"
  },
  {
   value: "Damavand (IRDAM)",
   label: "Damavand (IRDAM)"
  },
  {
   value: "Do Gharun (IRDOG)",
   label: "Do Gharun (IRDOG)"
  },
  {
   value: "Freidoon Kenar (IRFKR)",
   label: "Freidoon Kenar (IRFKR)"
  },
  {
   value: "Imam Khomeini Pt\/ Mahshahr City (IRBIK)",
   label: "Imam Khomeini Pt\/ Mahshahr City (IRBIK)"
  },
  {
   value: "Jiroft (IRJRT)",
   label: "Jiroft (IRJRT)"
  },
  {
   value: "Kalaleh (IRKAL)",
   label: "Kalaleh (IRKAL)"
  },
  {
   value: "Kermanshah (IRKMS)",
   label: "Kermanshah (IRKMS)"
  },
  {
   value: "Khvoy (IRKHY)",
   label: "Khvoy (IRKHY)"
  },
  {
   value: "Masjed Soleyman (IRQMJ)",
   label: "Masjed Soleyman (IRQMJ)"
  },
  {
   value: "Nakhjavån Tappeh (IRNKW)",
   label: "Nakhjavån Tappeh (IRNKW)"
  },
  {
   value: "Neka (IRNKA)",
   label: "Neka (IRNKA)"
  },
  {
   value: "Payam Apt (IRPYK)",
   label: "Payam Apt (IRPYK)"
  },
  {
   value: "Qazvin (IRQAZ)",
   label: "Qazvin (IRQAZ)"
  },
  {
   value: "Sabzevar (IRSAB)",
   label: "Sabzevar (IRSAB)"
  },
  {
   value: "Sahlan (IRSAN)",
   label: "Sahlan (IRSAN)"
  },
  {
   value: "Sarooj Anchorage (IRSRA)",
   label: "Sarooj Anchorage (IRSRA)"
  },
  {
   value: "Semnan (IRSEM)",
   label: "Semnan (IRSEM)"
  },
  {
   value: "Shahid Bahonar (IRSBR)",
   label: "Shahid Bahonar (IRSBR)"
  },
  {
   value: "Shahid Rajaee Pt\/Bandar Abbas (IRSRP)",
   label: "Shahid Rajaee Pt\/Bandar Abbas (IRSRP)"
  },
  {
   value: "Shahr-e Kord (IRSEK)",
   label: "Shahr-e Kord (IRSEK)"
  },
  {
   value: "Shahrud (IRSHA)",
   label: "Shahrud (IRSHA)"
  },
  {
   value: "Tombak (IRTMB)",
   label: "Tombak (IRTMB)"
  },
  {
   value: "Yasuj (IRYAS)",
   label: "Yasuj (IRYAS)"
  },
  {
   value: "Zanjan (IRZAN)",
   label: "Zanjan (IRZAN)"
  },
  {
   value: ".ICELAND (IS)",
   label: ".ICELAND (IS)"
  },
  {
   value: "Arskogssandur (ISASS)",
   label: "Arskogssandur (ISASS)"
  },
  {
   value: "Bolungarvirk (ISBOV)",
   label: "Bolungarvirk (ISBOV)"
  },
  {
   value: "Gardabaer (ISGRB)",
   label: "Gardabaer (ISGRB)"
  },
  {
   value: "Gardur (ISGRD)",
   label: "Gardur (ISGRD)"
  },
  {
   value: "Hafnir (ISHNR)",
   label: "Hafnir (ISHNR)"
  },
  {
   value: "Helguvik (ISHEL)",
   label: "Helguvik (ISHEL)"
  },
  {
   value: "Hvolsvöllur (ISHVO)",
   label: "Hvolsvöllur (ISHVO)"
  },
  {
   value: "Litli Sandur (ISLSA)",
   label: "Litli Sandur (ISLSA)"
  },
  {
   value: "Mjoeyrarhofn (ISMJH)",
   label: "Mjoeyrarhofn (ISMJH)"
  },
  {
   value: "Mosfellsbaer (ISMOS)",
   label: "Mosfellsbaer (ISMOS)"
  },
  {
   value: "Stokkseyri (ISSTK)",
   label: "Stokkseyri (ISSTK)"
  },
  {
   value: "Tjörneshöfn (ISTHN)",
   label: "Tjörneshöfn (ISTHN)"
  },
  {
   value: "Vogar (ISVOG)",
   label: "Vogar (ISVOG)"
  },
  {
   value: ".ITALY (IT)",
   label: ".ITALY (IT)"
  },
  {
   value: "Abbiate Guazzone (ITGBB)",
   label: "Abbiate Guazzone (ITGBB)"
  },
  {
   value: "Abbiategrasso (ITATR)",
   label: "Abbiategrasso (ITATR)"
  },
  {
   value: "Acciaroli (ITAOL)",
   label: "Acciaroli (ITAOL)"
  },
  {
   value: "Aci Castello (ITACL)",
   label: "Aci Castello (ITACL)"
  },
  {
   value: "Acilia (ITAIL)",
   label: "Acilia (ITAIL)"
  },
  {
   value: "Acitrezza (ITACT)",
   label: "Acitrezza (ITACT)"
  },
  {
   value: "Acquanegra Cremonese (ITACU)",
   label: "Acquanegra Cremonese (ITACU)"
  },
  {
   value: "Acquasparta (ITACS)",
   label: "Acquasparta (ITACS)"
  },
  {
   value: "Adrano (ITZCF)",
   label: "Adrano (ITZCF)"
  },
  {
   value: "Adrara San Martino (ITADM)",
   label: "Adrara San Martino (ITADM)"
  },
  {
   value: "Adria (ITARA)",
   label: "Adria (ITARA)"
  },
  {
   value: "Affi (ITAFF)",
   label: "Affi (ITAFF)"
  },
  {
   value: "Agazzano (ITAAZ)",
   label: "Agazzano (ITAAZ)"
  },
  {
   value: "Agira (ITAGA)",
   label: "Agira (ITAGA)"
  },
  {
   value: "Agliè (ITAGI)",
   label: "Agliè (ITAGI)"
  },
  {
   value: "Agnadello (ITAGO)",
   label: "Agnadello (ITAGO)"
  },
  {
   value: "Agrate Brianza (ITAGB)",
   label: "Agrate Brianza (ITAGB)"
  },
  {
   value: "Agrate Conturbia (ITACN)",
   label: "Agrate Conturbia (ITACN)"
  },
  {
   value: "Agropoli (ITAGP)",
   label: "Agropoli (ITAGP)"
  },
  {
   value: "Agugliaro (ITAGU)",
   label: "Agugliaro (ITAGU)"
  },
  {
   value: "Aicurzio (ITACZ)",
   label: "Aicurzio (ITACZ)"
  },
  {
   value: "Aiello del Friuli (ITAFI)",
   label: "Aiello del Friuli (ITAFI)"
  },
  {
   value: "Airola (ITZCG)",
   label: "Airola (ITZCG)"
  },
  {
   value: "Airuno (ITALR)",
   label: "Airuno (ITALR)"
  },
  {
   value: "Alanno (ITZCH)",
   label: "Alanno (ITZCH)"
  },
  {
   value: "Alano Di Piave (ITAPV)",
   label: "Alano Di Piave (ITAPV)"
  },
  {
   value: "Alassio (ITALS)",
   label: "Alassio (ITALS)"
  },
  {
   value: "Alba (ITLBA)",
   label: "Alba (ITLBA)"
  },
  {
   value: "Albairate (ITABE)",
   label: "Albairate (ITABE)"
  },
  {
   value: "Albano Laziale (ITABL)",
   label: "Albano Laziale (ITABL)"
  },
  {
   value: "Albareto (ITABO)",
   label: "Albareto (ITABO)"
  },
  {
   value: "Albettone (ITABT)",
   label: "Albettone (ITABT)"
  },
  {
   value: "Albiano (ITADT)",
   label: "Albiano (ITADT)"
  },
  {
   value: "Albiate (ITLBI)",
   label: "Albiate (ITLBI)"
  },
  {
   value: "Albignano (ITZCQ)",
   label: "Albignano (ITZCQ)"
  },
  {
   value: "Albignasego (ITABG)",
   label: "Albignasego (ITABG)"
  },
  {
   value: "Albinea (ITAJA)",
   label: "Albinea (ITAJA)"
  },
  {
   value: "Albiolo (ITABI)",
   label: "Albiolo (ITABI)"
  },
  {
   value: "Albisano (ITAMS)",
   label: "Albisano (ITAMS)"
  },
  {
   value: "Albisola Superiore (ITASU)",
   label: "Albisola Superiore (ITASU)"
  },
  {
   value: "Albosaggia (ITASG)",
   label: "Albosaggia (ITASG)"
  },
  {
   value: "Alfianello (ITZKH)",
   label: "Alfianello (ITZKH)"
  },
  {
   value: "Alfonzine (ITAFZ)",
   label: "Alfonzine (ITAFZ)"
  },
  {
   value: "Alife (ITALF)",
   label: "Alife (ITALF)"
  },
  {
   value: "Alimena (ITZCJ)",
   label: "Alimena (ITZCJ)"
  },
  {
   value: "Almenno San Bartolomeo (ITZSL)",
   label: "Almenno San Bartolomeo (ITZSL)"
  },
  {
   value: "Almisano (ITAIS)",
   label: "Almisano (ITAIS)"
  },
  {
   value: "Alonte (ITALO)",
   label: "Alonte (ITALO)"
  },
  {
   value: "Alpignano (ITNAN)",
   label: "Alpignano (ITNAN)"
  },
  {
   value: "Altavilla (ITAVL)",
   label: "Altavilla (ITAVL)"
  },
  {
   value: "Altavilla Irpina (ITZCI)",
   label: "Altavilla Irpina (ITZCI)"
  },
  {
   value: "Altavilla Monferrato (ITAVM)",
   label: "Altavilla Monferrato (ITAVM)"
  },
  {
   value: "Alte Ceccato (ITECA)",
   label: "Alte Ceccato (ITECA)"
  },
  {
   value: "Altedo (ITATO)",
   label: "Altedo (ITATO)"
  },
  {
   value: "Altivole (ITAIV)",
   label: "Altivole (ITAIV)"
  },
  {
   value: "Altopascio (ITAPO)",
   label: "Altopascio (ITAPO)"
  },
  {
   value: "Alzano Lombardo (ITABD)",
   label: "Alzano Lombardo (ITABD)"
  },
  {
   value: "Alzate Brianza (ITABR)",
   label: "Alzate Brianza (ITABR)"
  },
  {
   value: "Amantea (ITAMT)",
   label: "Amantea (ITAMT)"
  },
  {
   value: "Amato (ITZCK)",
   label: "Amato (ITZCK)"
  },
  {
   value: "Ambivere (ITAMB)",
   label: "Ambivere (ITAMB)"
  },
  {
   value: "Ambra (ITZOU)",
   label: "Ambra (ITZOU)"
  },
  {
   value: "Ancarano (ITZCL)",
   label: "Ancarano (ITZCL)"
  },
  {
   value: "Andalo Valtellino (ITHJT)",
   label: "Andalo Valtellino (ITHJT)"
  },
  {
   value: "Andezeno (ITAZO)",
   label: "Andezeno (ITAZO)"
  },
  {
   value: "Andora (ITADA)",
   label: "Andora (ITADA)"
  },
  {
   value: "Andorno Micca (ITDNA)",
   label: "Andorno Micca (ITDNA)"
  },
  {
   value: "Angera (ITAGE)",
   label: "Angera (ITAGE)"
  },
  {
   value: "Anghiari (ITHIA)",
   label: "Anghiari (ITHIA)"
  },
  {
   value: "Angiari (ITANG)",
   label: "Angiari (ITANG)"
  },
  {
   value: "Angri (ITZCN)",
   label: "Angri (ITZCN)"
  },
  {
   value: "Annicco (ITANN)",
   label: "Annicco (ITANN)"
  },
  {
   value: "Annone di Brianza (ITZCP)",
   label: "Annone di Brianza (ITZCP)"
  },
  {
   value: "Annone Veneto (ITAEV)",
   label: "Annone Veneto (ITAEV)"
  },
  {
   value: "Antegnate (ITATN)",
   label: "Antegnate (ITATN)"
  },
  {
   value: "Anzano del Parco (ITAPC)",
   label: "Anzano del Parco (ITAPC)"
  },
  {
   value: "Aprilia (ITAPA)",
   label: "Aprilia (ITAPA)"
  },
  {
   value: "Aquasparta (ITZCE)",
   label: "Aquasparta (ITZCE)"
  },
  {
   value: "Aquino (ITAQI)",
   label: "Aquino (ITAQI)"
  },
  {
   value: "Aradeo (ITZCU)",
   label: "Aradeo (ITZCU)"
  },
  {
   value: "Arbizzano (ITRBZ)",
   label: "Arbizzano (ITRBZ)"
  },
  {
   value: "Arborio (ITZCR)",
   label: "Arborio (ITZCR)"
  },
  {
   value: "Arcade (ITAAD)",
   label: "Arcade (ITAAD)"
  },
  {
   value: "Arcevia (ITAVR)",
   label: "Arcevia (ITAVR)"
  },
  {
   value: "Arcidosso (ITACD)",
   label: "Arcidosso (ITACD)"
  },
  {
   value: "Arcole (ITACE)",
   label: "Arcole (ITACE)"
  },
  {
   value: "Arconate (ITARN)",
   label: "Arconate (ITARN)"
  },
  {
   value: "Arcugnano (ITAUV)",
   label: "Arcugnano (ITAUV)"
  },
  {
   value: "Ardea (ITARD)",
   label: "Ardea (ITARD)"
  },
  {
   value: "Ardenno (ITAND)",
   label: "Ardenno (ITAND)"
  },
  {
   value: "Ardesio (ITADS)",
   label: "Ardesio (ITADS)"
  },
  {
   value: "Arena Po (ITARP)",
   label: "Arena Po (ITARP)"
  },
  {
   value: "Arenzano (ITAZA)",
   label: "Arenzano (ITAZA)"
  },
  {
   value: "Arese (ITAEE)",
   label: "Arese (ITAEE)"
  },
  {
   value: "Argelato (ITARL)",
   label: "Argelato (ITARL)"
  },
  {
   value: "Argenta (ITAGT)",
   label: "Argenta (ITAGT)"
  },
  {
   value: "Ariccia (ITACC)",
   label: "Ariccia (ITACC)"
  },
  {
   value: "Arma di Taggia (ITATA)",
   label: "Arma di Taggia (ITATA)"
  },
  {
   value: "Arona (ITANR)",
   label: "Arona (ITANR)"
  },
  {
   value: "Arosio (ITAOO)",
   label: "Arosio (ITAOO)"
  },
  {
   value: "Arrone (ITZCM)",
   label: "Arrone (ITZCM)"
  },
  {
   value: "Arsago Seprio (ITAGS)",
   label: "Arsago Seprio (ITAGS)"
  },
  {
   value: "Arsego (ITZCX)",
   label: "Arsego (ITZCX)"
  },
  {
   value: "Arsego di San Giorgio delle Pertiche (ITADG)",
   label: "Arsego di San Giorgio delle Pertiche (ITADG)"
  },
  {
   value: "Arsiè (ITARJ)",
   label: "Arsiè (ITARJ)"
  },
  {
   value: "Artegna (ITART)",
   label: "Artegna (ITART)"
  },
  {
   value: "Arzachena (ITAZC)",
   label: "Arzachena (ITAZC)"
  },
  {
   value: "Asciano (ITZVI)",
   label: "Asciano (ITZVI)"
  },
  {
   value: "Asparetto (ITAPR)",
   label: "Asparetto (ITAPR)"
  },
  {
   value: "Assemini (ITSSN)",
   label: "Assemini (ITSSN)"
  },
  {
   value: "Asso (ITAXO)",
   label: "Asso (ITAXO)"
  },
  {
   value: "Atena Lucana (ITATL)",
   label: "Atena Lucana (ITATL)"
  },
  {
   value: "Atena Scalo (ITZVU)",
   label: "Atena Scalo (ITZVU)"
  },
  {
   value: "Atessa (ITATE)",
   label: "Atessa (ITATE)"
  },
  {
   value: "Atina (ITZCY)",
   label: "Atina (ITZCY)"
  },
  {
   value: "Atri (ITZCV)",
   label: "Atri (ITZCV)"
  },
  {
   value: "Atripalda (ITDDA)",
   label: "Atripalda (ITDDA)"
  },
  {
   value: "Attigliano (ITATT)",
   label: "Attigliano (ITATT)"
  },
  {
   value: "Aulla (ITAUA)",
   label: "Aulla (ITAUA)"
  },
  {
   value: "Aurisina (ITAUS)",
   label: "Aurisina (ITAUS)"
  },
  {
   value: "Auronzo di Cadore (ITADC)",
   label: "Auronzo di Cadore (ITADC)"
  },
  {
   value: "Ausonia (ITZCW)",
   label: "Ausonia (ITZCW)"
  },
  {
   value: "Aversa (ITAEA)",
   label: "Aversa (ITAEA)"
  },
  {
   value: "Avetrana (ITAVT)",
   label: "Avetrana (ITAVT)"
  },
  {
   value: "Avigliana (ITAVG)",
   label: "Avigliana (ITAVG)"
  },
  {
   value: "Azeglio (ITZDA)",
   label: "Azeglio (ITZDA)"
  },
  {
   value: "Azzano Decimo (ITAZD)",
   label: "Azzano Decimo (ITAZD)"
  },
  {
   value: "Azzano Mella (ITAML)",
   label: "Azzano Mella (ITAML)"
  },
  {
   value: "Azzate (ITAZT)",
   label: "Azzate (ITAZT)"
  },
  {
   value: "Badalucco (ITZDE)",
   label: "Badalucco (ITZDE)"
  },
  {
   value: "Badia a Settimo (ITBIS)",
   label: "Badia a Settimo (ITBIS)"
  },
  {
   value: "Badia Al Pino (ITBAP)",
   label: "Badia Al Pino (ITBAP)"
  },
  {
   value: "Badia Polesine (ITBPS)",
   label: "Badia Polesine (ITBPS)"
  },
  {
   value: "Bagheria (ITBHA)",
   label: "Bagheria (ITBHA)"
  },
  {
   value: "Bagnacavallo (ITBGV)",
   label: "Bagnacavallo (ITBGV)"
  },
  {
   value: "Bagnara Calabra (ITBCB)",
   label: "Bagnara Calabra (ITBCB)"
  },
  {
   value: "Bagnara di Romagna (ITBDM)",
   label: "Bagnara di Romagna (ITBDM)"
  },
  {
   value: "Bagnaria Arsa (ITBAA)",
   label: "Bagnaria Arsa (ITBAA)"
  },
  {
   value: "Bagnarola (ITBZL)",
   label: "Bagnarola (ITBZL)"
  },
  {
   value: "Bagnatica (ITBNA)",
   label: "Bagnatica (ITBNA)"
  },
  {
   value: "Bagno (ITBAN)",
   label: "Bagno (ITBAN)"
  },
  {
   value: "Bagno di Romagna (ITBRM)",
   label: "Bagno di Romagna (ITBRM)"
  },
  {
   value: "Bagno Roselle (ITRSE)",
   label: "Bagno Roselle (ITRSE)"
  },
  {
   value: "Bagnolo (ITBAL)",
   label: "Bagnolo (ITBAL)"
  },
  {
   value: "Bagnolo Cremasco (ITBCR)",
   label: "Bagnolo Cremasco (ITBCR)"
  },
  {
   value: "Bagnolo Piemonte (ITBOP)",
   label: "Bagnolo Piemonte (ITBOP)"
  },
  {
   value: "Bagnolo San Vito (ITZEE)",
   label: "Bagnolo San Vito (ITZEE)"
  },
  {
   value: "Bagnoregio (ITZIM)",
   label: "Bagnoregio (ITZIM)"
  },
  {
   value: "Bagolino (ITGOL)",
   label: "Bagolino (ITGOL)"
  },
  {
   value: "Bairo (ITBIR)",
   label: "Bairo (ITBIR)"
  },
  {
   value: "Baldissero Canavese (ITBCV)",
   label: "Baldissero Canavese (ITBCV)"
  },
  {
   value: "Balestrate (ITZDD)",
   label: "Balestrate (ITZDD)"
  },
  {
   value: "Ballabio (ITLLB)",
   label: "Ballabio (ITLLB)"
  },
  {
   value: "Banyoles (ITBYS)",
   label: "Banyoles (ITBYS)"
  },
  {
   value: "Baraccola (ITBAC)",
   label: "Baraccola (ITBAC)"
  },
  {
   value: "Baranzate (ITBNZ)",
   label: "Baranzate (ITBNZ)"
  },
  {
   value: "Barbara (ITBBR)",
   label: "Barbara (ITBBR)"
  },
  {
   value: "Barbarano Vicentino (ITBBV)",
   label: "Barbarano Vicentino (ITBBV)"
  },
  {
   value: "Barbarasco (ITBRB)",
   label: "Barbarasco (ITBRB)"
  },
  {
   value: "Barbariga (ITBBG)",
   label: "Barbariga (ITBBG)"
  },
  {
   value: "Barberino di Mugello (ITBMU)",
   label: "Barberino di Mugello (ITBMU)"
  },
  {
   value: "Barbiano (ITYBB)",
   label: "Barbiano (ITYBB)"
  },
  {
   value: "Barcellona-Pozzo di Gotto (ITBPO)",
   label: "Barcellona-Pozzo di Gotto (ITBPO)"
  },
  {
   value: "Barco (ITBCQ)",
   label: "Barco (ITBCQ)"
  },
  {
   value: "Bardi (ITBDI)",
   label: "Bardi (ITBDI)"
  },
  {
   value: "Bareggio (ITBRR)",
   label: "Bareggio (ITBRR)"
  },
  {
   value: "Barga (ITZDC)",
   label: "Barga (ITZDC)"
  },
  {
   value: "Barge (ITBGE)",
   label: "Barge (ITBGE)"
  },
  {
   value: "Barlassina (ITRLA)",
   label: "Barlassina (ITRLA)"
  },
  {
   value: "Barni (ITRRR)",
   label: "Barni (ITRRR)"
  },
  {
   value: "Baruccana (ITZEH)",
   label: "Baruccana (ITZEH)"
  },
  {
   value: "Barzago (ITBZG)",
   label: "Barzago (ITBZG)"
  },
  {
   value: "Barzana (ITBZA)",
   label: "Barzana (ITBZA)"
  },
  {
   value: "Barzano (ITAZN)",
   label: "Barzano (ITAZN)"
  },
  {
   value: "Basaldella (ITBAD)",
   label: "Basaldella (ITBAD)"
  },
  {
   value: "Basaluzzo (ITBZZ)",
   label: "Basaluzzo (ITBZZ)"
  },
  {
   value: "Basiglio (ITBSI)",
   label: "Basiglio (ITBSI)"
  },
  {
   value: "Basilicagoiano (ITBCN)",
   label: "Basilicagoiano (ITBCN)"
  },
  {
   value: "Basilicanova (ITZED)",
   label: "Basilicanova (ITZED)"
  },
  {
   value: "Bassignana (ITGAN)",
   label: "Bassignana (ITGAN)"
  },
  {
   value: "Bastia (ITBTA)",
   label: "Bastia (ITBTA)"
  },
  {
   value: "Battaglia Terme (ITZBE)",
   label: "Battaglia Terme (ITZBE)"
  },
  {
   value: "Bazzano (ITBAZ)",
   label: "Bazzano (ITBAZ)"
  },
  {
   value: "Beinasco (ITBIC)",
   label: "Beinasco (ITBIC)"
  },
  {
   value: "Beinette (ITBNE)",
   label: "Beinette (ITBNE)"
  },
  {
   value: "Belfiore (ITBFE)",
   label: "Belfiore (ITBFE)"
  },
  {
   value: "Belforte Monferrato (ITBMF)",
   label: "Belforte Monferrato (ITBMF)"
  },
  {
   value: "Belgioioso (ITBGL)",
   label: "Belgioioso (ITBGL)"
  },
  {
   value: "Bellagio (ITBLB)",
   label: "Bellagio (ITBLB)"
  },
  {
   value: "Bellaria (ITBLA)",
   label: "Bellaria (ITBLA)"
  },
  {
   value: "Bellaria Igea Marina (ITBIM)",
   label: "Bellaria Igea Marina (ITBIM)"
  },
  {
   value: "Bellocchi (ITBLC)",
   label: "Bellocchi (ITBLC)"
  },
  {
   value: "Bellona (ITZDN)",
   label: "Bellona (ITZDN)"
  },
  {
   value: "Belpasso (ITBLP)",
   label: "Belpasso (ITBLP)"
  },
  {
   value: "Belvedere di Tezze (ITBDT)",
   label: "Belvedere di Tezze (ITBDT)"
  },
  {
   value: "Belvedere Marittimo (ITBMT)",
   label: "Belvedere Marittimo (ITBMT)"
  },
  {
   value: "Bene Vagienna (ITBEV)",
   label: "Bene Vagienna (ITBEV)"
  },
  {
   value: "Benna (ITBEA)",
   label: "Benna (ITBEA)"
  },
  {
   value: "Berbenno (ITBEB)",
   label: "Berbenno (ITBEB)"
  },
  {
   value: "Berbenno di Valtellina (ITBDV)",
   label: "Berbenno di Valtellina (ITBDV)"
  },
  {
   value: "Beregazzo con Figliaro (ITBZF)",
   label: "Beregazzo con Figliaro (ITBZF)"
  },
  {
   value: "Bergantino (ITZXJ)",
   label: "Bergantino (ITZXJ)"
  },
  {
   value: "Bernareggio (ITBEG)",
   label: "Bernareggio (ITBEG)"
  },
  {
   value: "Bernate Ticino (ITBTN)",
   label: "Bernate Ticino (ITBTN)"
  },
  {
   value: "Bersano (ITBSQ)",
   label: "Bersano (ITBSQ)"
  },
  {
   value: "Bertiolo (ITZEA)",
   label: "Bertiolo (ITZEA)"
  },
  {
   value: "Bertonico (ITZEL)",
   label: "Bertonico (ITZEL)"
  },
  {
   value: "Besana Brianza (ITZCD)",
   label: "Besana Brianza (ITZCD)"
  },
  {
   value: "Besana in Brianza (ITBNB)",
   label: "Besana in Brianza (ITBNB)"
  },
  {
   value: "Besnate (ITBNT)",
   label: "Besnate (ITBNT)"
  },
  {
   value: "Besozzo (ITBSZ)",
   label: "Besozzo (ITBSZ)"
  },
  {
   value: "Bessica (ITBES)",
   label: "Bessica (ITBES)"
  },
  {
   value: "Bettolino (ITZEF)",
   label: "Bettolino (ITZEF)"
  },
  {
   value: "Beura (ITBUR)",
   label: "Beura (ITBUR)"
  },
  {
   value: "Bevera (ITBVR)",
   label: "Bevera (ITBVR)"
  },
  {
   value: "Beverate (ITBTE)",
   label: "Beverate (ITBTE)"
  },
  {
   value: "Biadene (ITBDN)",
   label: "Biadene (ITBDN)"
  },
  {
   value: "Biancade (ITBCD)",
   label: "Biancade (ITBCD)"
  },
  {
   value: "Biancavilla (ITZDK)",
   label: "Biancavilla (ITZDK)"
  },
  {
   value: "Bianco (ITBNC)",
   label: "Bianco (ITBNC)"
  },
  {
   value: "Biandronno (ITBNR)",
   label: "Biandronno (ITBNR)"
  },
  {
   value: "Bibbiano (ITBIB)",
   label: "Bibbiano (ITBIB)"
  },
  {
   value: "Bienate (ITZDL)",
   label: "Bienate (ITZDL)"
  },
  {
   value: "Bientina (ITBEI)",
   label: "Bientina (ITBEI)"
  },
  {
   value: "Binago (ITBNG)",
   label: "Binago (ITBNG)"
  },
  {
   value: "Bione (ITION)",
   label: "Bione (ITION)"
  },
  {
   value: "Birago (ITZDJ)",
   label: "Birago (ITZDJ)"
  },
  {
   value: "Bisceglie (ITBCE)",
   label: "Bisceglie (ITBCE)"
  },
  {
   value: "Bisignano (ITZEC)",
   label: "Bisignano (ITZEC)"
  },
  {
   value: "Bistagno (ITZDI)",
   label: "Bistagno (ITZDI)"
  },
  {
   value: "Bizzarone (ITZDM)",
   label: "Bizzarone (ITZDM)"
  },
  {
   value: "Bobbio (ITBOB)",
   label: "Bobbio (ITBOB)"
  },
  {
   value: "Boca (ITOCA)",
   label: "Boca (ITOCA)"
  },
  {
   value: "Bodio Lomnago (ITBLM)",
   label: "Bodio Lomnago (ITBLM)"
  },
  {
   value: "Boffalora sopra Ticino (ITBTI)",
   label: "Boffalora sopra Ticino (ITBTI)"
  },
  {
   value: "Boglietto (ITBET)",
   label: "Boglietto (ITBET)"
  },
  {
   value: "Bollate (ITBOE)",
   label: "Bollate (ITBOE)"
  },
  {
   value: "Bollengo (ITBLG)",
   label: "Bollengo (ITBLG)"
  },
  {
   value: "Boltiere (ITBLE)",
   label: "Boltiere (ITBLE)"
  },
  {
   value: "Bonagia (ITOAA)",
   label: "Bonagia (ITOAA)"
  },
  {
   value: "Bonate di Sopra (ITBTP)",
   label: "Bonate di Sopra (ITBTP)"
  },
  {
   value: "Bondeno (ITZXA)",
   label: "Bondeno (ITZXA)"
  },
  {
   value: "Bonea (ITZDV)",
   label: "Bonea (ITZDV)"
  },
  {
   value: "Bonefro (ITBFO)",
   label: "Bonefro (ITBFO)"
  },
  {
   value: "Bonemerse (ITBNM)",
   label: "Bonemerse (ITBNM)"
  },
  {
   value: "Bonferraro (ITBFR)",
   label: "Bonferraro (ITBFR)"
  },
  {
   value: "Bordighera (ITBGH)",
   label: "Bordighera (ITBGH)"
  },
  {
   value: "Boretto (ITBRT)",
   label: "Boretto (ITBRT)"
  },
  {
   value: "Borgaro Torinese (ITBTR)",
   label: "Borgaro Torinese (ITBTR)"
  },
  {
   value: "Borghetto di Borbera (ITZDF)",
   label: "Borghetto di Borbera (ITZDF)"
  },
  {
   value: "Borghetto Lodigiano (ITBLO)",
   label: "Borghetto Lodigiano (ITBLO)"
  },
  {
   value: "Borgo a Buggiano (ITBBU)",
   label: "Borgo a Buggiano (ITBBU)"
  },
  {
   value: "Borgo Piave (ITZDW)",
   label: "Borgo Piave (ITZDW)"
  },
  {
   value: "Borgo Sabotino (ITBSA)",
   label: "Borgo Sabotino (ITBSA)"
  },
  {
   value: "Borgo San Donato (ITBDO)",
   label: "Borgo San Donato (ITBDO)"
  },
  {
   value: "Borgo San Giacomo (ITZDH)",
   label: "Borgo San Giacomo (ITZDH)"
  },
  {
   value: "Borgo San Giovanni (ITBRV)",
   label: "Borgo San Giovanni (ITBRV)"
  },
  {
   value: "Borgo San Michele (ITBSR)",
   label: "Borgo San Michele (ITBSR)"
  },
  {
   value: "Borgo Santa Maria (ITZDR)",
   label: "Borgo Santa Maria (ITZDR)"
  },
  {
   value: "Borgo Val di Taro (ITBVO)",
   label: "Borgo Val di Taro (ITBVO)"
  },
  {
   value: "Borgo Vercelli (ITBVE)",
   label: "Borgo Vercelli (ITBVE)"
  },
  {
   value: "Borgoforte (ITZDU)",
   label: "Borgoforte (ITZDU)"
  },
  {
   value: "Borgoricco (ITBGI)",
   label: "Borgoricco (ITBGI)"
  },
  {
   value: "Bornasco (ITBOC)",
   label: "Bornasco (ITBOC)"
  },
  {
   value: "Borriana (ITZIA)",
   label: "Borriana (ITZIA)"
  },
  {
   value: "Borsea (ITBSE)",
   label: "Borsea (ITBSE)"
  },
  {
   value: "Borso del Grappa (ITRSO)",
   label: "Borso del Grappa (ITRSO)"
  },
  {
   value: "Borzago (ITBRZ)",
   label: "Borzago (ITBRZ)"
  },
  {
   value: "Borzano di Albinea (ITBZB)",
   label: "Borzano di Albinea (ITBZB)"
  },
  {
   value: "Borzonasca (ITZBB)",
   label: "Borzonasca (ITZBB)"
  },
  {
   value: "Bosa (ITBOA)",
   label: "Bosa (ITBOA)"
  },
  {
   value: "Bosco Chiesanuova (ITBCH)",
   label: "Bosco Chiesanuova (ITBCH)"
  },
  {
   value: "Bosco Marengo (ITBSM)",
   label: "Bosco Marengo (ITBSM)"
  },
  {
   value: "Bosco Mesola (ITBME)",
   label: "Bosco Mesola (ITBME)"
  },
  {
   value: "Bosconero (ITBSC)",
   label: "Bosconero (ITBSC)"
  },
  {
   value: "Bosentino (ITBTV)",
   label: "Bosentino (ITBTV)"
  },
  {
   value: "Bosisio Parini (ITBSP)",
   label: "Bosisio Parini (ITBSP)"
  },
  {
   value: "Bosnasco (ITBSS)",
   label: "Bosnasco (ITBSS)"
  },
  {
   value: "Bossolasco (ITBOS)",
   label: "Bossolasco (ITBOS)"
  },
  {
   value: "Botricello (ITTBL)",
   label: "Botricello (ITTBL)"
  },
  {
   value: "Bottanuco (ITZDG)",
   label: "Bottanuco (ITZDG)"
  },
  {
   value: "Botticino Sera (ITBTC)",
   label: "Botticino Sera (ITBTC)"
  },
  {
   value: "Bova Marina (ITBVM)",
   label: "Bova Marina (ITBVM)"
  },
  {
   value: "Bovezzo (ITZDX)",
   label: "Bovezzo (ITZDX)"
  },
  {
   value: "Bozzolo (ITBOZ)",
   label: "Bozzolo (ITBOZ)"
  },
  {
   value: "Brandico (ITNDC)",
   label: "Brandico (ITNDC)"
  },
  {
   value: "Brandizzo (ITBDZ)",
   label: "Brandizzo (ITBDZ)"
  },
  {
   value: "Brandizzo (ITBIZ)",
   label: "Brandizzo (ITBIZ)"
  },
  {
   value: "Brembilla (ITBBI)",
   label: "Brembilla (ITBBI)"
  },
  {
   value: "Brembio (ITBBM)",
   label: "Brembio (ITBBM)"
  },
  {
   value: "Brenna (ITBBA)",
   label: "Brenna (ITBBA)"
  },
  {
   value: "Bressana Bottarone (ITBAB)",
   label: "Bressana Bottarone (ITBAB)"
  },
  {
   value: "Bressanvido (ITBSV)",
   label: "Bressanvido (ITBSV)"
  },
  {
   value: "Bresseo di Teolo (ITIDQ)",
   label: "Bresseo di Teolo (ITIDQ)"
  },
  {
   value: "Bribano (ITBBN)",
   label: "Bribano (ITBBN)"
  },
  {
   value: "Bricherasio (ITBHS)",
   label: "Bricherasio (ITBHS)"
  },
  {
   value: "Brissago Valtravaglia (ITBVV)",
   label: "Brissago Valtravaglia (ITBVV)"
  },
  {
   value: "Broccostella (ITZLD)",
   label: "Broccostella (ITZLD)"
  },
  {
   value: "Brogliano (ITZDQ)",
   label: "Brogliano (ITZDQ)"
  },
  {
   value: "Brolo (ITZDO)",
   label: "Brolo (ITZDO)"
  },
  {
   value: "Broni (ITZDY)",
   label: "Broni (ITZDY)"
  },
  {
   value: "Bronzolo (ITZDT)",
   label: "Bronzolo (ITZDT)"
  },
  {
   value: "Brugherio (ITBHR)",
   label: "Brugherio (ITBHR)"
  },
  {
   value: "Brugine (ITBRD)",
   label: "Brugine (ITBRD)"
  },
  {
   value: "Brugnetto di Ripe (ITBDR)",
   label: "Brugnetto di Ripe (ITBDR)"
  },
  {
   value: "Brunello (ITBRU)",
   label: "Brunello (ITBRU)"
  },
  {
   value: "Brunico (ITZDS)",
   label: "Brunico (ITZDS)"
  },
  {
   value: "Brusaporto (ITBPT)",
   label: "Brusaporto (ITBPT)"
  },
  {
   value: "Brusnengo (ITBNN)",
   label: "Brusnengo (ITBNN)"
  },
  {
   value: "Bubano (ITUBA)",
   label: "Bubano (ITUBA)"
  },
  {
   value: "Bubbio (ITBUB)",
   label: "Bubbio (ITBUB)"
  },
  {
   value: "Buccino (ITBCO)",
   label: "Buccino (ITBCO)"
  },
  {
   value: "Budoia (ITBOI)",
   label: "Budoia (ITBOI)"
  },
  {
   value: "Budrio (ITBUD)",
   label: "Budrio (ITBUD)"
  },
  {
   value: "Buguggiate (ITBGU)",
   label: "Buguggiate (ITBGU)"
  },
  {
   value: "Buia (ITZEG)",
   label: "Buia (ITZEG)"
  },
  {
   value: "Bulciago (ITZKJ)",
   label: "Bulciago (ITZKJ)"
  },
  {
   value: "Bulgarograsso (ITZEI)",
   label: "Bulgarograsso (ITZEI)"
  },
  {
   value: "Buonvicino (ITBUV)",
   label: "Buonvicino (ITBUV)"
  },
  {
   value: "Burago Di Molgora (ITBMG)",
   label: "Burago Di Molgora (ITBMG)"
  },
  {
   value: "Buriasco (ITBUI)",
   label: "Buriasco (ITBUI)"
  },
  {
   value: "Burolo (ITBRO)",
   label: "Burolo (ITBRO)"
  },
  {
   value: "Buronzo (ITNZO)",
   label: "Buronzo (ITNZO)"
  },
  {
   value: "Busalla (ITBSU)",
   label: "Busalla (ITBSU)"
  },
  {
   value: "Busano (ITBUO)",
   label: "Busano (ITBUO)"
  },
  {
   value: "Buscate (ITBUT)",
   label: "Buscate (ITBUT)"
  },
  {
   value: "Busche (ITZEB)",
   label: "Busche (ITZEB)"
  },
  {
   value: "Buseto Palizzolo (ITZKK)",
   label: "Buseto Palizzolo (ITZKK)"
  },
  {
   value: "Busnago (ITBGJ)",
   label: "Busnago (ITBGJ)"
  },
  {
   value: "Bussi Officine (ITBOF)",
   label: "Bussi Officine (ITBOF)"
  },
  {
   value: "Bussi sul Tirino (ITBUZ)",
   label: "Bussi sul Tirino (ITBUZ)"
  },
  {
   value: "Bussolengo (ITBUL)",
   label: "Bussolengo (ITBUL)"
  },
  {
   value: "Buttapietra (ITBPA)",
   label: "Buttapietra (ITBPA)"
  },
  {
   value: "Buttigliera Alta (ITBUE)",
   label: "Buttigliera Alta (ITBUE)"
  },
  {
   value: "Ca de Fabbri (ITCFM)",
   label: "Ca de Fabbri (ITCFM)"
  },
  {
   value: "Cadè (ITCDY)",
   label: "Cadè (ITCDY)"
  },
  {
   value: "Cadelbosco di Sotto (ITDBS)",
   label: "Cadelbosco di Sotto (ITDBS)"
  },
  {
   value: "Cadola (ITCDZ)",
   label: "Cadola (ITCDZ)"
  },
  {
   value: "Cadoneghe (ITCNH)",
   label: "Cadoneghe (ITCNH)"
  },
  {
   value: "Cadorago (ITCDR)",
   label: "Cadorago (ITCDR)"
  },
  {
   value: "Cadriano (ITZGE)",
   label: "Cadriano (ITZGE)"
  },
  {
   value: "Caerano di San Marco (ITCNM)",
   label: "Caerano di San Marco (ITCNM)"
  },
  {
   value: "Cafasse (ITCFS)",
   label: "Cafasse (ITCFS)"
  },
  {
   value: "Caianello (ITCAJ)",
   label: "Caianello (ITCAJ)"
  },
  {
   value: "Cairo Montenotte (ITCMO)",
   label: "Cairo Montenotte (ITCMO)"
  },
  {
   value: "Cala Gonone (ITNNE)",
   label: "Cala Gonone (ITNNE)"
  },
  {
   value: "Calamandrana (ITCLA)",
   label: "Calamandrana (ITCLA)"
  },
  {
   value: "Calatafimi (ITLFM)",
   label: "Calatafimi (ITLFM)"
  },
  {
   value: "Calcara (ITCLR)",
   label: "Calcara (ITCLR)"
  },
  {
   value: "Calcinaia (ITZFA)",
   label: "Calcinaia (ITZFA)"
  },
  {
   value: "Calcinate (ITCCT)",
   label: "Calcinate (ITCCT)"
  },
  {
   value: "Calcinelli (ITZGW)",
   label: "Calcinelli (ITZGW)"
  },
  {
   value: "Calcio (ITCLC)",
   label: "Calcio (ITCLC)"
  },
  {
   value: "Calco (ITCOX)",
   label: "Calco (ITCOX)"
  },
  {
   value: "Caldarola (ITCOD)",
   label: "Caldarola (ITCOD)"
  },
  {
   value: "Calderano (ITZFT)",
   label: "Calderano (ITZFT)"
  },
  {
   value: "Calderino (ITALD)",
   label: "Calderino (ITALD)"
  },
  {
   value: "Caldogno (ITLDG)",
   label: "Caldogno (ITLDG)"
  },
  {
   value: "Calendasco (ITCDS)",
   label: "Calendasco (ITCDS)"
  },
  {
   value: "Caleppio di Settala (ITPPI)",
   label: "Caleppio di Settala (ITPPI)"
  },
  {
   value: "Calerno (ITCLX)",
   label: "Calerno (ITCLX)"
  },
  {
   value: "Calitri (ITZHD)",
   label: "Calitri (ITZHD)"
  },
  {
   value: "Calizzano (ITZZA)",
   label: "Calizzano (ITZZA)"
  },
  {
   value: "Calliano (ITZFP)",
   label: "Calliano (ITZFP)"
  },
  {
   value: "Calmasino (ITCXB)",
   label: "Calmasino (ITCXB)"
  },
  {
   value: "Calolziocorte (ITCOY)",
   label: "Calolziocorte (ITCOY)"
  },
  {
   value: "Caltagirone (ITZET)",
   label: "Caltagirone (ITZET)"
  },
  {
   value: "Caltignaga (ITCXX)",
   label: "Caltignaga (ITCXX)"
  },
  {
   value: "Caltrano (ITLRN)",
   label: "Caltrano (ITLRN)"
  },
  {
   value: "Caluso (ITALU)",
   label: "Caluso (ITALU)"
  },
  {
   value: "Calvisano (ITAVS)",
   label: "Calvisano (ITAVS)"
  },
  {
   value: "Calzolaro (ITCAZ)",
   label: "Calzolaro (ITCAZ)"
  },
  {
   value: "Camaiore (ITKMR)",
   label: "Camaiore (ITKMR)"
  },
  {
   value: "Camaro (ITZBG)",
   label: "Camaro (ITZBG)"
  },
  {
   value: "Cameri (ITCXI)",
   label: "Cameri (ITCXI)"
  },
  {
   value: "Camerlata (ITZYB)",
   label: "Camerlata (ITZYB)"
  },
  {
   value: "Camignone (ITCMM)",
   label: "Camignone (ITCMM)"
  },
  {
   value: "Camin (ITAIN)",
   label: "Camin (ITAIN)"
  },
  {
   value: "Camisano Vicentino (ITCMV)",
   label: "Camisano Vicentino (ITCMV)"
  },
  {
   value: "Cammarata (ITZGC)",
   label: "Cammarata (ITZGC)"
  },
  {
   value: "Camogli (ITGLJ)",
   label: "Camogli (ITGLJ)"
  },
  {
   value: "Campagna (ITPAG)",
   label: "Campagna (ITPAG)"
  },
  {
   value: "Campagnola Emilia (ITCEH)",
   label: "Campagnola Emilia (ITCEH)"
  },
  {
   value: "Campello sul Clitunno (ITCMP)",
   label: "Campello sul Clitunno (ITCMP)"
  },
  {
   value: "Campiglia dei Berici (ITZAC)",
   label: "Campiglia dei Berici (ITZAC)"
  },
  {
   value: "Campiglione-Fenile (ITCEF)",
   label: "Campiglione-Fenile (ITCEF)"
  },
  {
   value: "Campigo (ITZFO)",
   label: "Campigo (ITZFO)"
  },
  {
   value: "Campo Calabro (ITCPB)",
   label: "Campo Calabro (ITCPB)"
  },
  {
   value: "Campo Di Trens (ITCMH)",
   label: "Campo Di Trens (ITCMH)"
  },
  {
   value: "Campo Ligure (ITZEO)",
   label: "Campo Ligure (ITZEO)"
  },
  {
   value: "Campo San Martino (ITOMT)",
   label: "Campo San Martino (ITOMT)"
  },
  {
   value: "Campo Tures (Sand in Taufers) (ITTUR)",
   label: "Campo Tures (Sand in Taufers) (ITTUR)"
  },
  {
   value: "Campobello di Mazara (ITZGQ)",
   label: "Campobello di Mazara (ITZGQ)"
  },
  {
   value: "Campochiaro (ITCMX)",
   label: "Campochiaro (ITCMX)"
  },
  {
   value: "Campodoro (ITCPD)",
   label: "Campodoro (ITCPD)"
  },
  {
   value: "Campofelice di Roccella (ITCFR)",
   label: "Campofelice di Roccella (ITCFR)"
  },
  {
   value: "Campogalliano (ITAMG)",
   label: "Campogalliano (ITAMG)"
  },
  {
   value: "Campolongo Maggiore (ITMGI)",
   label: "Campolongo Maggiore (ITMGI)"
  },
  {
   value: "Campolongo sul Brenta (ITCSB)",
   label: "Campolongo sul Brenta (ITCSB)"
  },
  {
   value: "Campomarino (ITMPR)",
   label: "Campomarino (ITMPR)"
  },
  {
   value: "Campomorone (ITCCP)",
   label: "Campomorone (ITCCP)"
  },
  {
   value: "Camporotondo Etneo (ITZFY)",
   label: "Camporotondo Etneo (ITZFY)"
  },
  {
   value: "Camposanto (ITECM)",
   label: "Camposanto (ITECM)"
  },
  {
   value: "Campoverde (ITCPV)",
   label: "Campoverde (ITCPV)"
  },
  {
   value: "Canavaccio (ITNAA)",
   label: "Canavaccio (ITNAA)"
  },
  {
   value: "Cancello Ed Arnone (ITZGF)",
   label: "Cancello Ed Arnone (ITZGF)"
  },
  {
   value: "Candelu (ITCDU)",
   label: "Candelu (ITCDU)"
  },
  {
   value: "Candiolo (ITZHL)",
   label: "Candiolo (ITZHL)"
  },
  {
   value: "Caneva (ITZGG)",
   label: "Caneva (ITZGG)"
  },
  {
   value: "Canicatti (ITZEP)",
   label: "Canicatti (ITZEP)"
  },
  {
   value: "Canneto (ITNET)",
   label: "Canneto (ITNET)"
  },
  {
   value: "Cannigione (ITNIG)",
   label: "Cannigione (ITNIG)"
  },
  {
   value: "Cannizzaro (ITCZX)",
   label: "Cannizzaro (ITCZX)"
  },
  {
   value: "Canosa di Puglia (ITBCP)",
   label: "Canosa di Puglia (ITBCP)"
  },
  {
   value: "Canove (ITCVK)",
   label: "Canove (ITCVK)"
  },
  {
   value: "Cantello (ITCTQ)",
   label: "Cantello (ITCTQ)"
  },
  {
   value: "Caorle (ITAOR)",
   label: "Caorle (ITAOR)"
  },
  {
   value: "Capaci (ITZGL)",
   label: "Capaci (ITZGL)"
  },
  {
   value: "Capalbio (ITBPI)",
   label: "Capalbio (ITBPI)"
  },
  {
   value: "Capalle (ITAPE)",
   label: "Capalle (ITAPE)"
  },
  {
   value: "Capannori (ITMAY)",
   label: "Capannori (ITMAY)"
  },
  {
   value: "Cape Carbonara (ITCCB)",
   label: "Cape Carbonara (ITCCB)"
  },
  {
   value: "Capena (ITZGM)",
   label: "Capena (ITZGM)"
  },
  {
   value: "Capezzano Pianore (ITCPZ)",
   label: "Capezzano Pianore (ITCPZ)"
  },
  {
   value: "Capistrello (ITPTL)",
   label: "Capistrello (ITPTL)"
  },
  {
   value: "Capocolle (ITCCE)",
   label: "Capocolle (ITCCE)"
  },
  {
   value: "Capodarco di Fermo (ITCPF)",
   label: "Capodarco di Fermo (ITCPF)"
  },
  {
   value: "Capodrise (ITZGP)",
   label: "Capodrise (ITZGP)"
  },
  {
   value: "Capostrada (ITOAT)",
   label: "Capostrada (ITOAT)"
  },
  {
   value: "Cappelle sul Tavo (ITCPE)",
   label: "Cappelle sul Tavo (ITCPE)"
  },
  {
   value: "Caprazzino (ITZGS)",
   label: "Caprazzino (ITZGS)"
  },
  {
   value: "Capriata di Orba (ITATC)",
   label: "Capriata di Orba (ITATC)"
  },
  {
   value: "Caprino Bergamasco (ITZAB)",
   label: "Caprino Bergamasco (ITZAB)"
  },
  {
   value: "Caprino Veronese (ITOVN)",
   label: "Caprino Veronese (ITOVN)"
  },
  {
   value: "Capriolo (ITZFQ)",
   label: "Capriolo (ITZFQ)"
  },
  {
   value: "Capurso (ITZGN)",
   label: "Capurso (ITZGN)"
  },
  {
   value: "Carate Brianza (ITCTB)",
   label: "Carate Brianza (ITCTB)"
  },
  {
   value: "Carbonara di Po (ITZGR)",
   label: "Carbonara di Po (ITZGR)"
  },
  {
   value: "Carbonara Scrivia (ITZOO)",
   label: "Carbonara Scrivia (ITZOO)"
  },
  {
   value: "Carbonate (ITMSC)",
   label: "Carbonate (ITMSC)"
  },
  {
   value: "Cardano (ITZEQ)",
   label: "Cardano (ITZEQ)"
  },
  {
   value: "Cardano al Campo (ITAAC)",
   label: "Cardano al Campo (ITAAC)"
  },
  {
   value: "Carde (ITCKA)",
   label: "Carde (ITCKA)"
  },
  {
   value: "Caresanablot (ITCBT)",
   label: "Caresanablot (ITCBT)"
  },
  {
   value: "Carimate (ITZGB)",
   label: "Carimate (ITZGB)"
  },
  {
   value: "Carini (ITRNI)",
   label: "Carini (ITRNI)"
  },
  {
   value: "Carisio (ITCRY)",
   label: "Carisio (ITCRY)"
  },
  {
   value: "Carisolo (ITCAH)",
   label: "Carisolo (ITCAH)"
  },
  {
   value: "Carobbio (ITCBB)",
   label: "Carobbio (ITCBB)"
  },
  {
   value: "Carpaneto Piacentino (ITAPP)",
   label: "Carpaneto Piacentino (ITAPP)"
  },
  {
   value: "Carpenedo (ITCXE)",
   label: "Carpenedo (ITCXE)"
  },
  {
   value: "Carpesica (ITZFC)",
   label: "Carpesica (ITZFC)"
  },
  {
   value: "Carpiano (ITCPX)",
   label: "Carpiano (ITCPX)"
  },
  {
   value: "Carraia (ITRRI)",
   label: "Carraia (ITRRI)"
  },
  {
   value: "Carre (ITZSN)",
   label: "Carre (ITZSN)"
  },
  {
   value: "Carrù (ITCRR)",
   label: "Carrù (ITCRR)"
  },
  {
   value: "Carruba (ITZHE)",
   label: "Carruba (ITZHE)"
  },
  {
   value: "Carsoli (ITZLN)",
   label: "Carsoli (ITZLN)"
  },
  {
   value: "Cartigliano (ITIGO)",
   label: "Cartigliano (ITIGO)"
  },
  {
   value: "Cartignano (ITCAT)",
   label: "Cartignano (ITCAT)"
  },
  {
   value: "Carugo (ITCXA)",
   label: "Carugo (ITCXA)"
  },
  {
   value: "Carvico (ITARV)",
   label: "Carvico (ITARV)"
  },
  {
   value: "Casagiove (ITAAG)",
   label: "Casagiove (ITAAG)"
  },
  {
   value: "Casalbellotto (ITTTO)",
   label: "Casalbellotto (ITTTO)"
  },
  {
   value: "Casalbordino (ITCBD)",
   label: "Casalbordino (ITCBD)"
  },
  {
   value: "Casalbuttano (ITCBU)",
   label: "Casalbuttano (ITCBU)"
  },
  {
   value: "Casale di Scodosia (ITCSD)",
   label: "Casale di Scodosia (ITCSD)"
  },
  {
   value: "Casale Litta (ITZFR)",
   label: "Casale Litta (ITZFR)"
  },
  {
   value: "Casale Monferrato (ITCFT)",
   label: "Casale Monferrato (ITCFT)"
  },
  {
   value: "Casalecchio (ITZFS)",
   label: "Casalecchio (ITZFS)"
  },
  {
   value: "Casaleone (ITLON)",
   label: "Casaleone (ITLON)"
  },
  {
   value: "Casaletto Ceredano (ITAAO)",
   label: "Casaletto Ceredano (ITAAO)"
  },
  {
   value: "Casaletto Lodigiano (ITLET)",
   label: "Casaletto Lodigiano (ITLET)"
  },
  {
   value: "Casaletto Vaprio (ITZHG)",
   label: "Casaletto Vaprio (ITZHG)"
  },
  {
   value: "Casalgrasso (ITCGR)",
   label: "Casalgrasso (ITCGR)"
  },
  {
   value: "Casalguidi (ITZOQ)",
   label: "Casalguidi (ITZOQ)"
  },
  {
   value: "Casallecchio di Reno (ITLLC)",
   label: "Casallecchio di Reno (ITLLC)"
  },
  {
   value: "Casalnuovo di Napoli (ITOVO)",
   label: "Casalnuovo di Napoli (ITOVO)"
  },
  {
   value: "Casalnuovo Montero (ITOVM)",
   label: "Casalnuovo Montero (ITOVM)"
  },
  {
   value: "Casaloldo (ITASD)",
   label: "Casaloldo (ITASD)"
  },
  {
   value: "Casalpusterlengo (ITCPL)",
   label: "Casalpusterlengo (ITCPL)"
  },
  {
   value: "Casalromano (ITZFU)",
   label: "Casalromano (ITZFU)"
  },
  {
   value: "Casalserugo (ITCXG)",
   label: "Casalserugo (ITCXG)"
  },
  {
   value: "Casalvieri (ITZAS)",
   label: "Casalvieri (ITZAS)"
  },
  {
   value: "Casamassima (ITCSQ)",
   label: "Casamassima (ITCSQ)"
  },
  {
   value: "Casapulla (ITCUA)",
   label: "Casapulla (ITCUA)"
  },
  {
   value: "Casarano (ITZJC)",
   label: "Casarano (ITZJC)"
  },
  {
   value: "Casarsa della Delizia (ITCRF)",
   label: "Casarsa della Delizia (ITCRF)"
  },
  {
   value: "Casarza Ligure (ITCZU)",
   label: "Casarza Ligure (ITCZU)"
  },
  {
   value: "Casatenovo (ITAOV)",
   label: "Casatenovo (ITAOV)"
  },
  {
   value: "Casazza (ITCZA)",
   label: "Casazza (ITCZA)"
  },
  {
   value: "Casciago (ITACG)",
   label: "Casciago (ITACG)"
  },
  {
   value: "Cascina della Costa (ITASC)",
   label: "Cascina della Costa (ITASC)"
  },
  {
   value: "Cascinagrossa (ITZFL)",
   label: "Cascinagrossa (ITZFL)"
  },
  {
   value: "Caselette (ITCAQ)",
   label: "Caselette (ITCAQ)"
  },
  {
   value: "Casella (ITZMC)",
   label: "Casella (ITZMC)"
  },
  {
   value: "Casella\/Genova (ITCAX)",
   label: "Casella\/Genova (ITCAX)"
  },
  {
   value: "Caselle Lurani (ITZMN)",
   label: "Caselle Lurani (ITZMN)"
  },
  {
   value: "Casina (ITSIN)",
   label: "Casina (ITSIN)"
  },
  {
   value: "Casola Valsenio (ITOVS)",
   label: "Casola Valsenio (ITOVS)"
  },
  {
   value: "Casoli (ITZFE)",
   label: "Casoli (ITZFE)"
  },
  {
   value: "Casorate Primo (ITOPM)",
   label: "Casorate Primo (ITOPM)"
  },
  {
   value: "Casorate Sempione (ITZHA)",
   label: "Casorate Sempione (ITZHA)"
  },
  {
   value: "Casorezzo (ITCRZ)",
   label: "Casorezzo (ITCRZ)"
  },
  {
   value: "Casoria (ITCXR)",
   label: "Casoria (ITCXR)"
  },
  {
   value: "Cassago Brianza (ITCBR)",
   label: "Cassago Brianza (ITCBR)"
  },
  {
   value: "Cassana (ITZGD)",
   label: "Cassana (ITZGD)"
  },
  {
   value: "Cassano Magnago (ITAGN)",
   label: "Cassano Magnago (ITAGN)"
  },
  {
   value: "Cassano Valcuvia (ITCCU)",
   label: "Cassano Valcuvia (ITCCU)"
  },
  {
   value: "Cassina de Pecchi (ITZLM)",
   label: "Cassina de Pecchi (ITZLM)"
  },
  {
   value: "Cassina Nuova (ITCNU)",
   label: "Cassina Nuova (ITCNU)"
  },
  {
   value: "Cassine (ITAIE)",
   label: "Cassine (ITAIE)"
  },
  {
   value: "Cassinetta di Lugagnano (ITCIU)",
   label: "Cassinetta di Lugagnano (ITCIU)"
  },
  {
   value: "Cassinetta Rizzone (ITCBI)",
   label: "Cassinetta Rizzone (ITCBI)"
  },
  {
   value: "Cassola (ITCSH)",
   label: "Cassola (ITCSH)"
  },
  {
   value: "Cassolnovo (ITCNV)",
   label: "Cassolnovo (ITCNV)"
  },
  {
   value: "Castagneto (ITZJT)",
   label: "Castagneto (ITZJT)"
  },
  {
   value: "Castagnole (ITZFN)",
   label: "Castagnole (ITZFN)"
  },
  {
   value: "Castel del Piano (ITTDP)",
   label: "Castel del Piano (ITTDP)"
  },
  {
   value: "Castel di Casio (ITCCS)",
   label: "Castel di Casio (ITCCS)"
  },
  {
   value: "Castel Goffredo (ITCGF)",
   label: "Castel Goffredo (ITCGF)"
  },
  {
   value: "Castel Guelfo di Bologna (ITUCG)",
   label: "Castel Guelfo di Bologna (ITUCG)"
  },
  {
   value: "Castel Mella (ITCME)",
   label: "Castel Mella (ITCME)"
  },
  {
   value: "Castel Rozzone (ITCZE)",
   label: "Castel Rozzone (ITCZE)"
  },
  {
   value: "Castel San Giorgio (ITCJZ)",
   label: "Castel San Giorgio (ITCJZ)"
  },
  {
   value: "Castel San Giovanni (ITCNG)",
   label: "Castel San Giovanni (ITCNG)"
  },
  {
   value: "Castel San Pietro Terme (ITCPT)",
   label: "Castel San Pietro Terme (ITCPT)"
  },
  {
   value: "Castel Volturno (ITAEL)",
   label: "Castel Volturno (ITAEL)"
  },
  {
   value: "Castelcovati (ITCCI)",
   label: "Castelcovati (ITCCI)"
  },
  {
   value: "Castelcucco (ITZNT)",
   label: "Castelcucco (ITZNT)"
  },
  {
   value: "Casteldaccia (ITZES)",
   label: "Casteldaccia (ITZES)"
  },
  {
   value: "Castelferretti (ITZPD)",
   label: "Castelferretti (ITZPD)"
  },
  {
   value: "Castelfiorentino (ITCFN)",
   label: "Castelfiorentino (ITCFN)"
  },
  {
   value: "Castelgrande (ITCGD)",
   label: "Castelgrande (ITCGD)"
  },
  {
   value: "Castelguelfo (ITCTL)",
   label: "Castelguelfo (ITCTL)"
  },
  {
   value: "Castellamonte (ITLLM)",
   label: "Castellamonte (ITLLM)"
  },
  {
   value: "Castellana Grotte (ITOTT)",
   label: "Castellana Grotte (ITOTT)"
  },
  {
   value: "Castelleone (ITCLE)",
   label: "Castelleone (ITCLE)"
  },
  {
   value: "Castelletto Cervo (ITLOV)",
   label: "Castelletto Cervo (ITLOV)"
  },
  {
   value: "Castelletto di Branduzzo (ITCUZ)",
   label: "Castelletto di Branduzzo (ITCUZ)"
  },
  {
   value: "Castellina Maritima (ITMTM)",
   label: "Castellina Maritima (ITMTM)"
  },
  {
   value: "Castello di Serravalle (ITZBT)",
   label: "Castello di Serravalle (ITZBT)"
  },
  {
   value: "Castello Roganzuolo (ITCRG)",
   label: "Castello Roganzuolo (ITCRG)"
  },
  {
   value: "Castellucchio (ITCLU)",
   label: "Castellucchio (ITCLU)"
  },
  {
   value: "Castelmarte (ITCMT)",
   label: "Castelmarte (ITCMT)"
  },
  {
   value: "Castelminio (ITCTM)",
   label: "Castelminio (ITCTM)"
  },
  {
   value: "Castelnovo Bariano (ITZHB)",
   label: "Castelnovo Bariano (ITZHB)"
  },
  {
   value: "Castelnovo di Sotto (ITCDX)",
   label: "Castelnovo di Sotto (ITCDX)"
  },
  {
   value: "Castelnuovo (ITSTV)",
   label: "Castelnuovo (ITSTV)"
  },
  {
   value: "Castelnuovo Calcea (ITCNC)",
   label: "Castelnuovo Calcea (ITCNC)"
  },
  {
   value: "Castelnuovo don Bosco (ITZHM)",
   label: "Castelnuovo don Bosco (ITZHM)"
  },
  {
   value: "Castelnuovo Magra (ITCTU)",
   label: "Castelnuovo Magra (ITCTU)"
  },
  {
   value: "Castelnuovo Rangone (ITASR)",
   label: "Castelnuovo Rangone (ITASR)"
  },
  {
   value: "Castelplanio (ITCTP)",
   label: "Castelplanio (ITCTP)"
  },
  {
   value: "Castelsardo (ITCTK)",
   label: "Castelsardo (ITCTK)"
  },
  {
   value: "Castelseprio (ITCXL)",
   label: "Castelseprio (ITCXL)"
  },
  {
   value: "Castelvenere (ITVNR)",
   label: "Castelvenere (ITVNR)"
  },
  {
   value: "Castelvetrano (ITCYX)",
   label: "Castelvetrano (ITCYX)"
  },
  {
   value: "Castelvetro di Modena (ITCOM)",
   label: "Castelvetro di Modena (ITCOM)"
  },
  {
   value: "Castenaso (ITVAC)",
   label: "Castenaso (ITVAC)"
  },
  {
   value: "Castenuovo Vomano (ITZYC)",
   label: "Castenuovo Vomano (ITZYC)"
  },
  {
   value: "Castiglion Fiorentino (ITTIN)",
   label: "Castiglion Fiorentino (ITTIN)"
  },
  {
   value: "Castiglioncello (ITATI)",
   label: "Castiglioncello (ITATI)"
  },
  {
   value: "Castiglione Cosentino (ITCNP)",
   label: "Castiglione Cosentino (ITCNP)"
  },
  {
   value: "Castiglione dei Pepoli (ITDEI)",
   label: "Castiglione dei Pepoli (ITDEI)"
  },
  {
   value: "Castiglione della Pescaia (ITCEQ)",
   label: "Castiglione della Pescaia (ITCEQ)"
  },
  {
   value: "Castiglione delle Stiviere (ITCDT)",
   label: "Castiglione delle Stiviere (ITCDT)"
  },
  {
   value: "Castiglione di Ravenna (ITZAT)",
   label: "Castiglione di Ravenna (ITZAT)"
  },
  {
   value: "Castiglione Falletto (ITLFO)",
   label: "Castiglione Falletto (ITLFO)"
  },
  {
   value: "Castiglione in Teverina (ITGLN)",
   label: "Castiglione in Teverina (ITGLN)"
  },
  {
   value: "Castiglione Messer Raimondo (ITZHV)",
   label: "Castiglione Messer Raimondo (ITZHV)"
  },
  {
   value: "Castiglione Olona (ITLOL)",
   label: "Castiglione Olona (ITLOL)"
  },
  {
   value: "Castiglione Tinella (ITTIG)",
   label: "Castiglione Tinella (ITTIG)"
  },
  {
   value: "Castignano (ITZEW)",
   label: "Castignano (ITZEW)"
  },
  {
   value: "Castilenti (ITZEU)",
   label: "Castilenti (ITZEU)"
  },
  {
   value: "Castione Andevenno (ITCDE)",
   label: "Castione Andevenno (ITCDE)"
  },
  {
   value: "Castiòns di Strada (ITCDQ)",
   label: "Castiòns di Strada (ITCDQ)"
  },
  {
   value: "Castrezzato (ITZTO)",
   label: "Castrezzato (ITZTO)"
  },
  {
   value: "Castro dei Volsci (ITCVC)",
   label: "Castro dei Volsci (ITCVC)"
  },
  {
   value: "Castro Marina (ITCRQ)",
   label: "Castro Marina (ITCRQ)"
  },
  {
   value: "Castrocaro Terme (ITCOT)",
   label: "Castrocaro Terme (ITCOT)"
  },
  {
   value: "Castrovillari (ITCVQ)",
   label: "Castrovillari (ITCVQ)"
  },
  {
   value: "Casumaro (ITZFV)",
   label: "Casumaro (ITZFV)"
  },
  {
   value: "Catona (ITKAT)",
   label: "Catona (ITKAT)"
  },
  {
   value: "Cattolica (ITCCL)",
   label: "Cattolica (ITCCL)"
  },
  {
   value: "Cava Manara (ITZFW)",
   label: "Cava Manara (ITZFW)"
  },
  {
   value: "Cavalicco (ITVCC)",
   label: "Cavalicco (ITVCC)"
  },
  {
   value: "Cavallina (ITCLI)",
   label: "Cavallina (ITCLI)"
  },
  {
   value: "Cavanella Po (ITNPO)",
   label: "Cavanella Po (ITNPO)"
  },
  {
   value: "Cavaria con Premezzo (ITCNF)",
   label: "Cavaria con Premezzo (ITCNF)"
  },
  {
   value: "Cavaso del Tomba (ITZFX)",
   label: "Cavaso del Tomba (ITZFX)"
  },
  {
   value: "Cavenago di Brianza (ITCGB)",
   label: "Cavenago di Brianza (ITCGB)"
  },
  {
   value: "Cavernago (ITNRE)",
   label: "Cavernago (ITNRE)"
  },
  {
   value: "Cavezzo (ITEAZ)",
   label: "Cavezzo (ITEAZ)"
  },
  {
   value: "Cavola (ITZAE)",
   label: "Cavola (ITZAE)"
  },
  {
   value: "Cavour (ITCOU)",
   label: "Cavour (ITCOU)"
  },
  {
   value: "Cavriglia (ITZGY)",
   label: "Cavriglia (ITZGY)"
  },
  {
   value: "Cazzago di Pianiga (ITCZP)",
   label: "Cazzago di Pianiga (ITCZP)"
  },
  {
   value: "Cazzago San Martino (ITCZM)",
   label: "Cazzago San Martino (ITCZM)"
  },
  {
   value: "Cazzano di Tramigna (ITZHJ)",
   label: "Cazzano di Tramigna (ITZHJ)"
  },
  {
   value: "Ceccano (ITZFJ)",
   label: "Ceccano (ITZFJ)"
  },
  {
   value: "Cefalù (ITCFU)",
   label: "Cefalù (ITCFU)"
  },
  {
   value: "Ceggia (ITEGG)",
   label: "Ceggia (ITEGG)"
  },
  {
   value: "Cella (ITCEL)",
   label: "Cella (ITCEL)"
  },
  {
   value: "Cellatica (ITCLK)",
   label: "Cellatica (ITCLK)"
  },
  {
   value: "Celle Ligure (ITLGG)",
   label: "Celle Ligure (ITLGG)"
  },
  {
   value: "Cenate Sotto (ITSOT)",
   label: "Cenate Sotto (ITSOT)"
  },
  {
   value: "Cene (ITENE)",
   label: "Cene (ITENE)"
  },
  {
   value: "Centallo (ITZHC)",
   label: "Centallo (ITZHC)"
  },
  {
   value: "Cento (ITCNZ)",
   label: "Cento (ITCNZ)"
  },
  {
   value: "Ceparana (ITZFH)",
   label: "Ceparana (ITZFH)"
  },
  {
   value: "Cerano (ITCEX)",
   label: "Cerano (ITCEX)"
  },
  {
   value: "Cerasolo (ITZFI)",
   label: "Cerasolo (ITZFI)"
  },
  {
   value: "Cerbara (ITCBA)",
   label: "Cerbara (ITCBA)"
  },
  {
   value: "Cercemaggiore (ITCCM)",
   label: "Cercemaggiore (ITCCM)"
  },
  {
   value: "Ceresara (ITESA)",
   label: "Ceresara (ITESA)"
  },
  {
   value: "Ceresole Alba (ITEOB)",
   label: "Ceresole Alba (ITEOB)"
  },
  {
   value: "Cerete (ITERT)",
   label: "Cerete (ITERT)"
  },
  {
   value: "Ceretta (ITDIC)",
   label: "Ceretta (ITDIC)"
  },
  {
   value: "Cermes (ITEMS)",
   label: "Cermes (ITEMS)"
  },
  {
   value: "Cernusco Lombardone (ITCCD)",
   label: "Cernusco Lombardone (ITCCD)"
  },
  {
   value: "Cernusco sul Naviglio (ITZHI)",
   label: "Cernusco sul Naviglio (ITZHI)"
  },
  {
   value: "Cerreto Castello (ITCC2)",
   label: "Cerreto Castello (ITCC2)"
  },
  {
   value: "Cerreto Guidi (ITZPB)",
   label: "Cerreto Guidi (ITZPB)"
  },
  {
   value: "Cerro al Lambro (ITCMB)",
   label: "Cerro al Lambro (ITCMB)"
  },
  {
   value: "Cervarese Santa Croce (ITCVE)",
   label: "Cervarese Santa Croce (ITCVE)"
  },
  {
   value: "Cervasca (ITCCX)",
   label: "Cervasca (ITCCX)"
  },
  {
   value: "Cervia (ITCEV)",
   label: "Cervia (ITCEV)"
  },
  {
   value: "Cervignano del Friuli (ITCVF)",
   label: "Cervignano del Friuli (ITCVF)"
  },
  {
   value: "Cesana Brianza (ITCEB)",
   label: "Cesana Brianza (ITCEB)"
  },
  {
   value: "Cesano Boscone (ITEBO)",
   label: "Cesano Boscone (ITEBO)"
  },
  {
   value: "Cesate (ITEAT)",
   label: "Cesate (ITEAT)"
  },
  {
   value: "Cesole (ITZFD)",
   label: "Cesole (ITZFD)"
  },
  {
   value: "Cetara (ITTAA)",
   label: "Cetara (ITTAA)"
  },
  {
   value: "Ceto (ITETO)",
   label: "Ceto (ITETO)"
  },
  {
   value: "Cetraro (ITCCQ)",
   label: "Cetraro (ITCCQ)"
  },
  {
   value: "Ceva (ITEVA)",
   label: "Ceva (ITEVA)"
  },
  {
   value: "Châtillon (ITCHN)",
   label: "Châtillon (ITCHN)"
  },
  {
   value: "Chiaramonte Gulfi (ITZVS)",
   label: "Chiaramonte Gulfi (ITZVS)"
  },
  {
   value: "Chiarano (ITIAR)",
   label: "Chiarano (ITIAR)"
  },
  {
   value: "Chiari (ITCIH)",
   label: "Chiari (ITCIH)"
  },
  {
   value: "Chiavari (ITCHX)",
   label: "Chiavari (ITCHX)"
  },
  {
   value: "Chieri (ITCIE)",
   label: "Chieri (ITCIE)"
  },
  {
   value: "Chieti Scalo (ITZSV)",
   label: "Chieti Scalo (ITZSV)"
  },
  {
   value: "Chieve (ITEVE)",
   label: "Chieve (ITEVE)"
  },
  {
   value: "Chignolo Po (ITCIP)",
   label: "Chignolo Po (ITCIP)"
  },
  {
   value: "Chiuduno (ITCHD)",
   label: "Chiuduno (ITCHD)"
  },
  {
   value: "Chiuppano (ITCHP)",
   label: "Chiuppano (ITCHP)"
  },
  {
   value: "Chiuro (ITCHU)",
   label: "Chiuro (ITCHU)"
  },
  {
   value: "Chiusavecchia (ITCVH)",
   label: "Chiusavecchia (ITCVH)"
  },
  {
   value: "Chiusi (ITUSI)",
   label: "Chiusi (ITUSI)"
  },
  {
   value: "Chivasso (ITCIV)",
   label: "Chivasso (ITCIV)"
  },
  {
   value: "Cicagna (ITZEY)",
   label: "Cicagna (ITZEY)"
  },
  {
   value: "Cigliano (ITIGN)",
   label: "Cigliano (ITIGN)"
  },
  {
   value: "Cilavegna (ITCIC)",
   label: "Cilavegna (ITCIC)"
  },
  {
   value: "Ciliverghe (ITCGH)",
   label: "Ciliverghe (ITCGH)"
  },
  {
   value: "Cimbro (ITCMC)",
   label: "Cimbro (ITCMC)"
  },
  {
   value: "Cinisi (ITISI)",
   label: "Cinisi (ITISI)"
  },
  {
   value: "Cinquefrondi (ITZGU)",
   label: "Cinquefrondi (ITZGU)"
  },
  {
   value: "Cinto Caomaggiore (ITNCG)",
   label: "Cinto Caomaggiore (ITNCG)"
  },
  {
   value: "Cirimido (ITZFF)",
   label: "Cirimido (ITZFF)"
  },
  {
   value: "Cirò Marina (ITMRM)",
   label: "Cirò Marina (ITMRM)"
  },
  {
   value: "Cisano sul Neva (ITCNY)",
   label: "Cisano sul Neva (ITCNY)"
  },
  {
   value: "Cislago (ITCIG)",
   label: "Cislago (ITCIG)"
  },
  {
   value: "Cittiglio (ITGLB)",
   label: "Cittiglio (ITGLB)"
  },
  {
   value: "Civate (ITCVU)",
   label: "Civate (ITCVU)"
  },
  {
   value: "Civezzano (ITCZO)",
   label: "Civezzano (ITCZO)"
  },
  {
   value: "Cividate al Piano (ITCLY)",
   label: "Cividate al Piano (ITCLY)"
  },
  {
   value: "Cividate Camuno (ITCCO)",
   label: "Cividate Camuno (ITCCO)"
  },
  {
   value: "Coccaglio (ITZGJ)",
   label: "Coccaglio (ITZGJ)"
  },
  {
   value: "Codevigo (ITOOG)",
   label: "Codevigo (ITOOG)"
  },
  {
   value: "Codevilla (ITODV)",
   label: "Codevilla (ITODV)"
  },
  {
   value: "Codognè (ITRVB)",
   label: "Codognè (ITRVB)"
  },
  {
   value: "Codroipo (ITZGI)",
   label: "Codroipo (ITZGI)"
  },
  {
   value: "Coenzo di Sorbolo (ITZAG)",
   label: "Coenzo di Sorbolo (ITZAG)"
  },
  {
   value: "Coggiola (ITZFM)",
   label: "Coggiola (ITZFM)"
  },
  {
   value: "Cogliate (ITCGT)",
   label: "Cogliate (ITCGT)"
  },
  {
   value: "Cogne (ITOGE)",
   label: "Cogne (ITOGE)"
  },
  {
   value: "Cogozzo (ITGCZ)",
   label: "Cogozzo (ITGCZ)"
  },
  {
   value: "Colbordolo (ITORD)",
   label: "Colbordolo (ITORD)"
  },
  {
   value: "Colle Salvetti (ITZAW)",
   label: "Colle Salvetti (ITZAW)"
  },
  {
   value: "Colle Umberto (ITCLB)",
   label: "Colle Umberto (ITCLB)"
  },
  {
   value: "Collecorvino (ITCCV)",
   label: "Collecorvino (ITCCV)"
  },
  {
   value: "Collegno (ITCEJ)",
   label: "Collegno (ITCEJ)"
  },
  {
   value: "Collevecchio (ITLLE)",
   label: "Collevecchio (ITLLE)"
  },
  {
   value: "Colli del Tronto (ITCTX)",
   label: "Colli del Tronto (ITCTX)"
  },
  {
   value: "Cologne (ITCGE)",
   label: "Cologne (ITCGE)"
  },
  {
   value: "Cologno al Serio (ITCGS)",
   label: "Cologno al Serio (ITCGS)"
  },
  {
   value: "Cologno Monzese (ITCLZ)",
   label: "Cologno Monzese (ITCLZ)"
  },
  {
   value: "Colombaro di Corte Franca (ITCCF)",
   label: "Colombaro di Corte Franca (ITCCF)"
  },
  {
   value: "Colonnella (ITCLN)",
   label: "Colonnella (ITCLN)"
  },
  {
   value: "Colorno (ITCRH)",
   label: "Colorno (ITCRH)"
  },
  {
   value: "Colorno (ITLRO)",
   label: "Colorno (ITLRO)"
  },
  {
   value: "Colzate (ITCZT)",
   label: "Colzate (ITCZT)"
  },
  {
   value: "Comacchio (ITCCJ)",
   label: "Comacchio (ITCCJ)"
  },
  {
   value: "Comun Nuovo (ITCMU)",
   label: "Comun Nuovo (ITCMU)"
  },
  {
   value: "Cona (ITGCN)",
   label: "Cona (ITGCN)"
  },
  {
   value: "Concamarise (ITCCR)",
   label: "Concamarise (ITCCR)"
  },
  {
   value: "Concesio (ITZEX)",
   label: "Concesio (ITZEX)"
  },
  {
   value: "Concorezzo (ITCCZ)",
   label: "Concorezzo (ITCCZ)"
  },
  {
   value: "Condino (ITZGK)",
   label: "Condino (ITZGK)"
  },
  {
   value: "Conetta (ITCOE)",
   label: "Conetta (ITCOE)"
  },
  {
   value: "Confienza (ITZFK)",
   label: "Confienza (ITZFK)"
  },
  {
   value: "Conialo (ITCIL)",
   label: "Conialo (ITCIL)"
  },
  {
   value: "Conselice (ITICE)",
   label: "Conselice (ITICE)"
  },
  {
   value: "Conselve (ITCLV)",
   label: "Conselve (ITCLV)"
  },
  {
   value: "Contrada (ITCNR)",
   label: "Contrada (ITCNR)"
  },
  {
   value: "Conversano (ITONV)",
   label: "Conversano (ITONV)"
  },
  {
   value: "Copiano (ITOPA)",
   label: "Copiano (ITOPA)"
  },
  {
   value: "Copparo (ITCPP)",
   label: "Copparo (ITCPP)"
  },
  {
   value: "Corbanese (ITCBN)",
   label: "Corbanese (ITCBN)"
  },
  {
   value: "Corbetta (ITCBE)",
   label: "Corbetta (ITCBE)"
  },
  {
   value: "Corciano (ITTCO)",
   label: "Corciano (ITTCO)"
  },
  {
   value: "Cordenons (ITCDN)",
   label: "Cordenons (ITCDN)"
  },
  {
   value: "Cordignano (ITODN)",
   label: "Cordignano (ITODN)"
  },
  {
   value: "Cordovado (ITCVD)",
   label: "Cordovado (ITCVD)"
  },
  {
   value: "Coreglia Antelminelli (ITZLL)",
   label: "Coreglia Antelminelli (ITZLL)"
  },
  {
   value: "Cori (ITCRJ)",
   label: "Cori (ITCRJ)"
  },
  {
   value: "Corigliano Calabro (ITCGC)",
   label: "Corigliano Calabro (ITCGC)"
  },
  {
   value: "Corinaldo (ITZVA)",
   label: "Corinaldo (ITZVA)"
  },
  {
   value: "Corio (ITCIO)",
   label: "Corio (ITCIO)"
  },
  {
   value: "Cornaredo (ITORR)",
   label: "Cornaredo (ITORR)"
  },
  {
   value: "Cornegliano Laudense (ITZKO)",
   label: "Cornegliano Laudense (ITZKO)"
  },
  {
   value: "Corno di Rosazzo (ITODR)",
   label: "Corno di Rosazzo (ITODR)"
  },
  {
   value: "Cornuda (ITCUD)",
   label: "Cornuda (ITCUD)"
  },
  {
   value: "Correzzana (ITOZA)",
   label: "Correzzana (ITOZA)"
  },
  {
   value: "Corropoli (ITORP)",
   label: "Corropoli (ITORP)"
  },
  {
   value: "Cortabbio (ITOTB)",
   label: "Cortabbio (ITOTB)"
  },
  {
   value: "Cortaccia sulla Strada del Vino (ITZPH)",
   label: "Cortaccia sulla Strada del Vino (ITZPH)"
  },
  {
   value: "Corte de Frati (ITCFI)",
   label: "Corte de Frati (ITCFI)"
  },
  {
   value: "Cortemaggiore (ITGIO)",
   label: "Cortemaggiore (ITGIO)"
  },
  {
   value: "Cortenuova (ITOUA)",
   label: "Cortenuova (ITOUA)"
  },
  {
   value: "Corteolona (ITCLP)",
   label: "Corteolona (ITCLP)"
  },
  {
   value: "Cortina sulla Strada del Vino (ITZVW)",
   label: "Cortina sulla Strada del Vino (ITZVW)"
  },
  {
   value: "Coseano (ITOSE)",
   label: "Coseano (ITOSE)"
  },
  {
   value: "Cosio Valtellino (ITCVW)",
   label: "Cosio Valtellino (ITCVW)"
  },
  {
   value: "Cossano Belbo (ITCNB)",
   label: "Cossano Belbo (ITCNB)"
  },
  {
   value: "Costa Masnaga (ITTMG)",
   label: "Costa Masnaga (ITTMG)"
  },
  {
   value: "Costa Volpino (ITZGT)",
   label: "Costa Volpino (ITZGT)"
  },
  {
   value: "Costabissara (ITCBS)",
   label: "Costabissara (ITCBS)"
  },
  {
   value: "Costanzana (ITCZN)",
   label: "Costanzana (ITCZN)"
  },
  {
   value: "Costermano (ITZGH)",
   label: "Costermano (ITZGH)"
  },
  {
   value: "Costigliole Saluzzo (ITCGU)",
   label: "Costigliole Saluzzo (ITCGU)"
  },
  {
   value: "Cravagliana (ITCVL)",
   label: "Cravagliana (ITCVL)"
  },
  {
   value: "Cremosano (ITZXI)",
   label: "Cremosano (ITZXI)"
  },
  {
   value: "Crespano del Grappa (ITCGP)",
   label: "Crespano del Grappa (ITCGP)"
  },
  {
   value: "Crespiatica (ITRPC)",
   label: "Crespiatica (ITRPC)"
  },
  {
   value: "Crespina (ITCEP)",
   label: "Crespina (ITCEP)"
  },
  {
   value: "Cressa (ITESS)",
   label: "Cressa (ITESS)"
  },
  {
   value: "Crevacuore (ITEVC)",
   label: "Crevacuore (ITEVC)"
  },
  {
   value: "Crevalcore (ITCVB)",
   label: "Crevalcore (ITCVB)"
  },
  {
   value: "Croce (ITXCR)",
   label: "Croce (ITXCR)"
  },
  {
   value: "Crone (ITCQR)",
   label: "Crone (ITCQR)"
  },
  {
   value: "Crosio della Valle (ITCOC)",
   label: "Crosio della Valle (ITCOC)"
  },
  {
   value: "Crova (ITOVA)",
   label: "Crova (ITOVA)"
  },
  {
   value: "Crusinallo (ITCUL)",
   label: "Crusinallo (ITCUL)"
  },
  {
   value: "Cuceglio (ITCCG)",
   label: "Cuceglio (ITCCG)"
  },
  {
   value: "Cuggiono (ITZHH)",
   label: "Cuggiono (ITZHH)"
  },
  {
   value: "Cupello (ITCUP)",
   label: "Cupello (ITCUP)"
  },
  {
   value: "Cupra Marittima (ITCPM)",
   label: "Cupra Marittima (ITCPM)"
  },
  {
   value: "Cura Carpignano (ITZFB)",
   label: "Cura Carpignano (ITZFB)"
  },
  {
   value: "Cureggio (ITCUG)",
   label: "Cureggio (ITCUG)"
  },
  {
   value: "Curno (ITCUR)",
   label: "Curno (ITCUR)"
  },
  {
   value: "Curtarolo (ITUTL)",
   label: "Curtarolo (ITUTL)"
  },
  {
   value: "Curtatone (ITURT)",
   label: "Curtatone (ITURT)"
  },
  {
   value: "Cusago (ITCUO)",
   label: "Cusago (ITCUO)"
  },
  {
   value: "Cusano Milanino (ITCNW)",
   label: "Cusano Milanino (ITCNW)"
  },
  {
   value: "Cusignana (ITCZG)",
   label: "Cusignana (ITCZG)"
  },
  {
   value: "Custonaci (ITZHF)",
   label: "Custonaci (ITZHF)"
  },
  {
   value: "Custoza (ITZLH)",
   label: "Custoza (ITZLH)"
  },
  {
   value: "Cutro (ITCUU)",
   label: "Cutro (ITCUU)"
  },
  {
   value: "Cuveglio (ITCUV)",
   label: "Cuveglio (ITCUV)"
  },
  {
   value: "Cuvio (ITCUI)",
   label: "Cuvio (ITCUI)"
  },
  {
   value: "Darfo (ITDFF)",
   label: "Darfo (ITDFF)"
  },
  {
   value: "Decimoputzu (ITDMP)",
   label: "Decimoputzu (ITDMP)"
  },
  {
   value: "Dego (ITDEG)",
   label: "Dego (ITDEG)"
  },
  {
   value: "Delebio (ITDBO)",
   label: "Delebio (ITDBO)"
  },
  {
   value: "Dello (ITDEL)",
   label: "Dello (ITDEL)"
  },
  {
   value: "Diamante (ITDIA)",
   label: "Diamante (ITDIA)"
  },
  {
   value: "Diegaro (ITDDC)",
   label: "Diegaro (ITDDC)"
  },
  {
   value: "Dignano (ITDIG)",
   label: "Dignano (ITDIG)"
  },
  {
   value: "Dinazzano (ITZYA)",
   label: "Dinazzano (ITZYA)"
  },
  {
   value: "Dogliola (ITDLA)",
   label: "Dogliola (ITDLA)"
  },
  {
   value: "Dolce (ITDLC)",
   label: "Dolce (ITDLC)"
  },
  {
   value: "Dolcedo (ITDCO)",
   label: "Dolcedo (ITDCO)"
  },
  {
   value: "Domusnovas (ITZHS)",
   label: "Domusnovas (ITZHS)"
  },
  {
   value: "Dongo (ITDGO)",
   label: "Dongo (ITDGO)"
  },
  {
   value: "Donoratico (ITZHO)",
   label: "Donoratico (ITZHO)"
  },
  {
   value: "Dormelletto (ITZAI)",
   label: "Dormelletto (ITZAI)"
  },
  {
   value: "Dorno (ITDRO)",
   label: "Dorno (ITDRO)"
  },
  {
   value: "Dosolo (ITDSL)",
   label: "Dosolo (ITDSL)"
  },
  {
   value: "Dosso (ITDOO)",
   label: "Dosso (ITDOO)"
  },
  {
   value: "Dossobuono (ITDSO)",
   label: "Dossobuono (ITDSO)"
  },
  {
   value: "Dosson (ITDSS)",
   label: "Dosson (ITDSS)"
  },
  {
   value: "Dresano (ITDRS)",
   label: "Dresano (ITDRS)"
  },
  {
   value: "Drizzona (ITDRZ)",
   label: "Drizzona (ITDRZ)"
  },
  {
   value: "Dro (ITZHP)",
   label: "Dro (ITZHP)"
  },
  {
   value: "Dronero (ITDNR)",
   label: "Dronero (ITDNR)"
  },
  {
   value: "Druento (ITZHQ)",
   label: "Druento (ITZHQ)"
  },
  {
   value: "Due Carrare (ITDRR)",
   label: "Due Carrare (ITDRR)"
  },
  {
   value: "Duino (ITDNO)",
   label: "Duino (ITDNO)"
  },
  {
   value: "Dusino San Michele (ITZHR)",
   label: "Dusino San Michele (ITZHR)"
  },
  {
   value: "Edolo (ITEDL)",
   label: "Edolo (ITEDL)"
  },
  {
   value: "Egna (ITEGA)",
   label: "Egna (ITEGA)"
  },
  {
   value: "Ellera di Corciano (ITECO)",
   label: "Ellera di Corciano (ITECO)"
  },
  {
   value: "Ellera Umbra (ITEUB)",
   label: "Ellera Umbra (ITEUB)"
  },
  {
   value: "Elmas (ITELM)",
   label: "Elmas (ITELM)"
  },
  {
   value: "Envie (ITZSR)",
   label: "Envie (ITZSR)"
  },
  {
   value: "Erbe (ITZHY)",
   label: "Erbe (ITZHY)"
  },
  {
   value: "Erbusco (ITESO)",
   label: "Erbusco (ITESO)"
  },
  {
   value: "Esanatoglia (ITZIB)",
   label: "Esanatoglia (ITZIB)"
  },
  {
   value: "Esine (ITESN)",
   label: "Esine (ITESN)"
  },
  {
   value: "Fabbrico (ITFBC)",
   label: "Fabbrico (ITFBC)"
  },
  {
   value: "Faedo (ITZIF)",
   label: "Faedo (ITZIF)"
  },
  {
   value: "Faggiano (ITFGG)",
   label: "Faggiano (ITFGG)"
  },
  {
   value: "Fagnano Olona (ITFAG)",
   label: "Fagnano Olona (ITFAG)"
  },
  {
   value: "Falzè di Piave (ITFZE)",
   label: "Falzè di Piave (ITFZE)"
  },
  {
   value: "Fano (ITFAO)",
   label: "Fano (ITFAO)"
  },
  {
   value: "Fara in Sabina (ITFIS)",
   label: "Fara in Sabina (ITFIS)"
  },
  {
   value: "Fara Olivana con Sola (ITFCS)",
   label: "Fara Olivana con Sola (ITFCS)"
  },
  {
   value: "Fara San Martino (ITZJB)",
   label: "Fara San Martino (ITZJB)"
  },
  {
   value: "Farra di Soligo (ITFSG)",
   label: "Farra di Soligo (ITFSG)"
  },
  {
   value: "Fasano (ITZAX)",
   label: "Fasano (ITZAX)"
  },
  {
   value: "Fatagliano (ITFRG)",
   label: "Fatagliano (ITFRG)"
  },
  {
   value: "Felegara (ITELE)",
   label: "Felegara (ITELE)"
  },
  {
   value: "Feletto Umberto (ITZIG)",
   label: "Feletto Umberto (ITZIG)"
  },
  {
   value: "Fellette (ITZIQ)",
   label: "Fellette (ITZIQ)"
  },
  {
   value: "Fenegro (ITZIH)",
   label: "Fenegro (ITZIH)"
  },
  {
   value: "Ferentillo (ITFTL)",
   label: "Ferentillo (ITFTL)"
  },
  {
   value: "Ferentino (ITFNI)",
   label: "Ferentino (ITFNI)"
  },
  {
   value: "Ferno (ITFEN)",
   label: "Ferno (ITFEN)"
  },
  {
   value: "Ferrandina (ITERR)",
   label: "Ferrandina (ITERR)"
  },
  {
   value: "Ferrera Erbognone (ITZXF)",
   label: "Ferrera Erbognone (ITZXF)"
  },
  {
   value: "Ferrere (ITAFE)",
   label: "Ferrere (ITAFE)"
  },
  {
   value: "Fiano Romano (ITFIA)",
   label: "Fiano Romano (ITFIA)"
  },
  {
   value: "Fiesco (ITFSC)",
   label: "Fiesco (ITFSC)"
  },
  {
   value: "Fiesse (ITFSE)",
   label: "Fiesse (ITFSE)"
  },
  {
   value: "Figline Vegliaturo (ITZII)",
   label: "Figline Vegliaturo (ITZII)"
  },
  {
   value: "Filago (ITFIL)",
   label: "Filago (ITFIL)"
  },
  {
   value: "Filiano (ITZIR)",
   label: "Filiano (ITZIR)"
  },
  {
   value: "Filottrano (ITZIU)",
   label: "Filottrano (ITZIU)"
  },
  {
   value: "Finale Ligure (ITFNL)",
   label: "Finale Ligure (ITFNL)"
  },
  {
   value: "Fino Mornasco (ITFIN)",
   label: "Fino Mornasco (ITFIN)"
  },
  {
   value: "Fiorentino (ITZIY)",
   label: "Fiorentino (ITZIY)"
  },
  {
   value: "Fisciano (ITFIC)",
   label: "Fisciano (ITFIC)"
  },
  {
   value: "Fiumefreddo di Sicilia (ITFDS)",
   label: "Fiumefreddo di Sicilia (ITFDS)"
  },
  {
   value: "Fivizzano (ITFVZ)",
   label: "Fivizzano (ITFVZ)"
  },
  {
   value: "Fizzonasco di Pieve Emanuele (ITFIZ)",
   label: "Fizzonasco di Pieve Emanuele (ITFIZ)"
  },
  {
   value: "Floridia (ITZIX)",
   label: "Floridia (ITZIX)"
  },
  {
   value: "Florinas (ITFLS)",
   label: "Florinas (ITFLS)"
  },
  {
   value: "Foce Varano (ITFCV)",
   label: "Foce Varano (ITFCV)"
  },
  {
   value: "Fognano (ITFOO)",
   label: "Fognano (ITFOO)"
  },
  {
   value: "Foiano di Val Fortore (ITFVF)",
   label: "Foiano di Val Fortore (ITFVF)"
  },
  {
   value: "Foligno (ITFLI)",
   label: "Foligno (ITFLI)"
  },
  {
   value: "Follina (ITFLN)",
   label: "Follina (ITFLN)"
  },
  {
   value: "Fontanellato (ITZBQ)",
   label: "Fontanellato (ITZBQ)"
  },
  {
   value: "Fontanelle (ITFTA)",
   label: "Fontanelle (ITFTA)"
  },
  {
   value: "Fontanini (ITZIK)",
   label: "Fontanini (ITZIK)"
  },
  {
   value: "Fontaniva (ITFTV)",
   label: "Fontaniva (ITFTV)"
  },
  {
   value: "Fontevivo (ITFVO)",
   label: "Fontevivo (ITFVO)"
  },
  {
   value: "Fonzaso (ITFZO)",
   label: "Fonzaso (ITFZO)"
  },
  {
   value: "Forchia (ITZIE)",
   label: "Forchia (ITZIE)"
  },
  {
   value: "Forino (ITFAI)",
   label: "Forino (ITFAI)"
  },
  {
   value: "Forio (ITFRD)",
   label: "Forio (ITFRD)"
  },
  {
   value: "Formignana (ITZIL)",
   label: "Formignana (ITZIL)"
  },
  {
   value: "Formigosa (ITFGA)",
   label: "Formigosa (ITFGA)"
  },
  {
   value: "Fornace Zarattini (ITFZI)",
   label: "Fornace Zarattini (ITFZI)"
  },
  {
   value: "Fornaci (ITFRI)",
   label: "Fornaci (ITFRI)"
  },
  {
   value: "Fornaci di Barga (ITFDB)",
   label: "Fornaci di Barga (ITFDB)"
  },
  {
   value: "Forno Canavese (ITFCE)",
   label: "Forno Canavese (ITFCE)"
  },
  {
   value: "Fornovo di Taro (ITZIT)",
   label: "Fornovo di Taro (ITZIT)"
  },
  {
   value: "Fornovo San Giovanni (ITZJA)",
   label: "Fornovo San Giovanni (ITZJA)"
  },
  {
   value: "Forte dei Marmi (ITFDM)",
   label: "Forte dei Marmi (ITFDM)"
  },
  {
   value: "Fossacesia (ITFBZ)",
   label: "Fossacesia (ITFBZ)"
  },
  {
   value: "Fossadello (ITFSD)",
   label: "Fossadello (ITFSD)"
  },
  {
   value: "Fossalta Maggiore (ITZIS)",
   label: "Fossalta Maggiore (ITZIS)"
  },
  {
   value: "Fossoli (ITFSI)",
   label: "Fossoli (ITFSI)"
  },
  {
   value: "Fossoli di Carpi (ITZIC)",
   label: "Fossoli di Carpi (ITZIC)"
  },
  {
   value: "Fossombrone (ITFOS)",
   label: "Fossombrone (ITFOS)"
  },
  {
   value: "Francavilla al Mare (ITFME)",
   label: "Francavilla al Mare (ITFME)"
  },
  {
   value: "Francavilla Angitola (ITZWV)",
   label: "Francavilla Angitola (ITZWV)"
  },
  {
   value: "Francenigo (ITFGO)",
   label: "Francenigo (ITFGO)"
  },
  {
   value: "Francofonte (ITZID)",
   label: "Francofonte (ITZID)"
  },
  {
   value: "Francolise (ITZCB)",
   label: "Francolise (ITZCB)"
  },
  {
   value: "Fratta Polesine (ITFRP)",
   label: "Fratta Polesine (ITFRP)"
  },
  {
   value: "Fratta Todina (ITFRT)",
   label: "Fratta Todina (ITFRT)"
  },
  {
   value: "Frattamaggiore (ITFTM)",
   label: "Frattamaggiore (ITFTM)"
  },
  {
   value: "Fregene (ITFGE)",
   label: "Fregene (ITFGE)"
  },
  {
   value: "Front (ITFOT)",
   label: "Front (ITFOT)"
  },
  {
   value: "Frossasco (ITTOI)",
   label: "Frossasco (ITTOI)"
  },
  {
   value: "Fumane (ITFUM)",
   label: "Fumane (ITFUM)"
  },
  {
   value: "Fuorni (ITFUO)",
   label: "Fuorni (ITFUO)"
  },
  {
   value: "Fusina (ITFSA)",
   label: "Fusina (ITFSA)"
  },
  {
   value: "Fusine in Valromana (ITZKM)",
   label: "Fusine in Valromana (ITZKM)"
  },
  {
   value: "Gabicce Mare (ITGMA)",
   label: "Gabicce Mare (ITGMA)"
  },
  {
   value: "Gadesco-Pieve Delmona (ITGPD)",
   label: "Gadesco-Pieve Delmona (ITGPD)"
  },
  {
   value: "Gaggiano (ITGGI)",
   label: "Gaggiano (ITGGI)"
  },
  {
   value: "Gaggio Montano (ITGGM)",
   label: "Gaggio Montano (ITGGM)"
  },
  {
   value: "Gaglianico (ITGAG)",
   label: "Gaglianico (ITGAG)"
  },
  {
   value: "Gagliano del Capo (ITGDX)",
   label: "Gagliano del Capo (ITGDX)"
  },
  {
   value: "Gaiarine (ITGRI)",
   label: "Gaiarine (ITGRI)"
  },
  {
   value: "Gaibanella (ITZRO)",
   label: "Gaibanella (ITZRO)"
  },
  {
   value: "Gaida (ITZJE)",
   label: "Gaida (ITZJE)"
  },
  {
   value: "Gaifana (ITZJO)",
   label: "Gaifana (ITZJO)"
  },
  {
   value: "Galatina (ITGTN)",
   label: "Galatina (ITGTN)"
  },
  {
   value: "Galazzano (ITZYE)",
   label: "Galazzano (ITZYE)"
  },
  {
   value: "Gallese (ITGLS)",
   label: "Gallese (ITGLS)"
  },
  {
   value: "Galliate (ITGIE)",
   label: "Galliate (ITGIE)"
  },
  {
   value: "Galliate (ITGLE)",
   label: "Galliate (ITGLE)"
  },
  {
   value: "Gallicano (ITZJG)",
   label: "Gallicano (ITZJG)"
  },
  {
   value: "Gallo (ITGLA)",
   label: "Gallo (ITGLA)"
  },
  {
   value: "Gallo di Grinzane (ITGGR)",
   label: "Gallo di Grinzane (ITGGR)"
  },
  {
   value: "Gallo di Petriano (ITZYJ)",
   label: "Gallo di Petriano (ITZYJ)"
  },
  {
   value: "Galtelli (ITGLI)",
   label: "Galtelli (ITGLI)"
  },
  {
   value: "Gambarare (ITGBR)",
   label: "Gambarare (ITGBR)"
  },
  {
   value: "Gambassi Terme (ITGBI)",
   label: "Gambassi Terme (ITGBI)"
  },
  {
   value: "Gambellara (ITGBL)",
   label: "Gambellara (ITGBL)"
  },
  {
   value: "Gambettola (ITGBT)",
   label: "Gambettola (ITGBT)"
  },
  {
   value: "Gambugliano (ITZAK)",
   label: "Gambugliano (ITZAK)"
  },
  {
   value: "Gandino (ITGND)",
   label: "Gandino (ITGND)"
  },
  {
   value: "Gandosso (ITGDS)",
   label: "Gandosso (ITGDS)"
  },
  {
   value: "Garbagnate Milanese (ITGRB)",
   label: "Garbagnate Milanese (ITGRB)"
  },
  {
   value: "Garbagnate Monastero (ITGMT)",
   label: "Garbagnate Monastero (ITGMT)"
  },
  {
   value: "Gardigiano (ITZKA)",
   label: "Gardigiano (ITZKA)"
  },
  {
   value: "Gardolo (ITGDO)",
   label: "Gardolo (ITGDO)"
  },
  {
   value: "Garessio (ITGAS)",
   label: "Garessio (ITGAS)"
  },
  {
   value: "Gargallo (ITGRL)",
   label: "Gargallo (ITGRL)"
  },
  {
   value: "Gargazzone (ITGZE)",
   label: "Gargazzone (ITGZE)"
  },
  {
   value: "Garlasco (ITGLC)",
   label: "Garlasco (ITGLC)"
  },
  {
   value: "Garlate (ITGAA)",
   label: "Garlate (ITGAA)"
  },
  {
   value: "Gatteo (ITGAT)",
   label: "Gatteo (ITGAT)"
  },
  {
   value: "Gattico (ITGCO)",
   label: "Gattico (ITGCO)"
  },
  {
   value: "Gavardo (ITGVO)",
   label: "Gavardo (ITGVO)"
  },
  {
   value: "Gavasseto (ITZKE)",
   label: "Gavasseto (ITZKE)"
  },
  {
   value: "Gaverina Terme (ITGVR)",
   label: "Gaverina Terme (ITGVR)"
  },
  {
   value: "Gavirate (ITGRE)",
   label: "Gavirate (ITGRE)"
  },
  {
   value: "Gazoldo degli Ippoliti (ITZKI)",
   label: "Gazoldo degli Ippoliti (ITZKI)"
  },
  {
   value: "Gazzada (ITGAZ)",
   label: "Gazzada (ITGAZ)"
  },
  {
   value: "Gazzaniga (ITGZI)",
   label: "Gazzaniga (ITGZI)"
  },
  {
   value: "Gazzo Veronese (ITGZV)",
   label: "Gazzo Veronese (ITGZV)"
  },
  {
   value: "Gazzuolo (ITGZZ)",
   label: "Gazzuolo (ITGZZ)"
  },
  {
   value: "Gello (ITGEO)",
   label: "Gello (ITGEO)"
  },
  {
   value: "Gemmano (ITZJW)",
   label: "Gemmano (ITZJW)"
  },
  {
   value: "Genga (ITZJJ)",
   label: "Genga (ITZJJ)"
  },
  {
   value: "Genola (ITGNL)",
   label: "Genola (ITGNL)"
  },
  {
   value: "Genzano di Roma (ITGDR)",
   label: "Genzano di Roma (ITGDR)"
  },
  {
   value: "Gera Lario (ITGLO)",
   label: "Gera Lario (ITGLO)"
  },
  {
   value: "Gerbido di Mortizza (ITGER)",
   label: "Gerbido di Mortizza (ITGER)"
  },
  {
   value: "Gerenzano (ITGNN)",
   label: "Gerenzano (ITGNN)"
  },
  {
   value: "Germignaga (ITGNA)",
   label: "Germignaga (ITGNA)"
  },
  {
   value: "Gessate (ITGST)",
   label: "Gessate (ITGST)"
  },
  {
   value: "Ghedi (ITGHI)",
   label: "Ghedi (ITGHI)"
  },
  {
   value: "Ghemme (ITGHM)",
   label: "Ghemme (ITGHM)"
  },
  {
   value: "Ghiaie (ITZJK)",
   label: "Ghiaie (ITZJK)"
  },
  {
   value: "Ghirano (ITZKW)",
   label: "Ghirano (ITZKW)"
  },
  {
   value: "Ghisalba (ITGSB)",
   label: "Ghisalba (ITGSB)"
  },
  {
   value: "Ghislarengo (ITGLG)",
   label: "Ghislarengo (ITGLG)"
  },
  {
   value: "Giammoro (ITZJN)",
   label: "Giammoro (ITZJN)"
  },
  {
   value: "Giardinello (ITZJU)",
   label: "Giardinello (ITZJU)"
  },
  {
   value: "Giarre (ITGIR)",
   label: "Giarre (ITGIR)"
  },
  {
   value: "Giaveno (ITGVA)",
   label: "Giaveno (ITGVA)"
  },
  {
   value: "Giavera del Montello (ITGRM)",
   label: "Giavera del Montello (ITGRM)"
  },
  {
   value: "Giglio Porto (ITGPR)",
   label: "Giglio Porto (ITGPR)"
  },
  {
   value: "Ginosa (ITGIN)",
   label: "Ginosa (ITGIN)"
  },
  {
   value: "Gioia del Colle (ITGDC)",
   label: "Gioia del Colle (ITGDC)"
  },
  {
   value: "Gioiosa Ionica (ITZJL)",
   label: "Gioiosa Ionica (ITZJL)"
  },
  {
   value: "Gioiosa Marea (ITZBU)",
   label: "Gioiosa Marea (ITZBU)"
  },
  {
   value: "Giovinazzo (ITGVZ)",
   label: "Giovinazzo (ITGVZ)"
  },
  {
   value: "Gironico (ITZIW)",
   label: "Gironico (ITZIW)"
  },
  {
   value: "Gissi (ITZJQ)",
   label: "Gissi (ITZJQ)"
  },
  {
   value: "Giulianova Lido (ITGUI)",
   label: "Giulianova Lido (ITGUI)"
  },
  {
   value: "Giussago (ITZKD)",
   label: "Giussago (ITZKD)"
  },
  {
   value: "Giussano (ITGSA)",
   label: "Giussano (ITGSA)"
  },
  {
   value: "Godo (ITZLA)",
   label: "Godo (ITZLA)"
  },
  {
   value: "Goito (ITGOI)",
   label: "Goito (ITGOI)"
  },
  {
   value: "Golasecca (ITGEC)",
   label: "Golasecca (ITGEC)"
  },
  {
   value: "Gonzaga (ITGZG)",
   label: "Gonzaga (ITGZG)"
  },
  {
   value: "Gorgo al Monticano (ITGOM)",
   label: "Gorgo al Monticano (ITGOM)"
  },
  {
   value: "Gorgoglione (ITGGE)",
   label: "Gorgoglione (ITGGE)"
  },
  {
   value: "Gorgonzola (ITGGZ)",
   label: "Gorgonzola (ITGGZ)"
  },
  {
   value: "Gorle (ITGOE)",
   label: "Gorle (ITGOE)"
  },
  {
   value: "Goro (ITGOO)",
   label: "Goro (ITGOO)"
  },
  {
   value: "Gorzano (ITZXG)",
   label: "Gorzano (ITZXG)"
  },
  {
   value: "Gossolengo (ITGSL)",
   label: "Gossolengo (ITGSL)"
  },
  {
   value: "Govone (ITGVN)",
   label: "Govone (ITGVN)"
  },
  {
   value: "Gragnano Trebbiense (ITZBJ)",
   label: "Gragnano Trebbiense (ITZBJ)"
  },
  {
   value: "Granarolo (ITZJV)",
   label: "Granarolo (ITZJV)"
  },
  {
   value: "Grancia (ITGCI)",
   label: "Grancia (ITGCI)"
  },
  {
   value: "Grandate (ITGRN)",
   label: "Grandate (ITGRN)"
  },
  {
   value: "Grandola ed Uniti (ITGEU)",
   label: "Grandola ed Uniti (ITGEU)"
  },
  {
   value: "Granozzo (ITZJX)",
   label: "Granozzo (ITZJX)"
  },
  {
   value: "Grantola (ITZJR)",
   label: "Grantola (ITZJR)"
  },
  {
   value: "Grantorto (ITGTT)",
   label: "Grantorto (ITGTT)"
  },
  {
   value: "Gratacasolo (ITGCS)",
   label: "Gratacasolo (ITGCS)"
  },
  {
   value: "Grazzano Visconti (ITZBC)",
   label: "Grazzano Visconti (ITZBC)"
  },
  {
   value: "Grignano (ITGNS)",
   label: "Grignano (ITGNS)"
  },
  {
   value: "Grigno (ITGGN)",
   label: "Grigno (ITGGN)"
  },
  {
   value: "Grisignano di Zocco (ITGZC)",
   label: "Grisignano di Zocco (ITGZC)"
  },
  {
   value: "Gropello Cairoli (ITGRC)",
   label: "Gropello Cairoli (ITGRC)"
  },
  {
   value: "Grottaglie (ITGRT)",
   label: "Grottaglie (ITGRT)"
  },
  {
   value: "Grottaminarda (ITZBW)",
   label: "Grottaminarda (ITZBW)"
  },
  {
   value: "Grumello Cremonese (ITZJH)",
   label: "Grumello Cremonese (ITZJH)"
  },
  {
   value: "Grumento Nova Potenza (ITGNP)",
   label: "Grumento Nova Potenza (ITGNP)"
  },
  {
   value: "Grumo Appula (ITGRU)",
   label: "Grumo Appula (ITGRU)"
  },
  {
   value: "Grumolo delle Abbadesse (ITGMO)",
   label: "Grumolo delle Abbadesse (ITGMO)"
  },
  {
   value: "Guanzate (ITZAY)",
   label: "Guanzate (ITZAY)"
  },
  {
   value: "Guardavalle (ITZJI)",
   label: "Guardavalle (ITZJI)"
  },
  {
   value: "Guarene (ITGUE)",
   label: "Guarene (ITGUE)"
  },
  {
   value: "Guasticce (ITGUT)",
   label: "Guasticce (ITGUT)"
  },
  {
   value: "Guglionesi (ITGUG)",
   label: "Guglionesi (ITGUG)"
  },
  {
   value: "Guidizzolo (ITGUZ)",
   label: "Guidizzolo (ITGUZ)"
  },
  {
   value: "Guidonia (ITUID)",
   label: "Guidonia (ITUID)"
  },
  {
   value: "Guspini (ITZKC)",
   label: "Guspini (ITZKC)"
  },
  {
   value: "Gussago (ITGSS)",
   label: "Gussago (ITGSS)"
  },
  {
   value: "Gussola (ITZBM)",
   label: "Gussola (ITZBM)"
  },
  {
   value: "Hone (ITHON)",
   label: "Hone (ITHON)"
  },
  {
   value: "Iano (ITZKS)",
   label: "Iano (ITZKS)"
  },
  {
   value: "Idro (ITIDO)",
   label: "Idro (ITIDO)"
  },
  {
   value: "Illasi (ITILA)",
   label: "Illasi (ITILA)"
  },
  {
   value: "Inarzo (ITIZO)",
   label: "Inarzo (ITIZO)"
  },
  {
   value: "Induno Olona (ITINO)",
   label: "Induno Olona (ITINO)"
  },
  {
   value: "Introbio (ITZKU)",
   label: "Introbio (ITZKU)"
  },
  {
   value: "Inverigo (ITIVG)",
   label: "Inverigo (ITIVG)"
  },
  {
   value: "Inveruno (ITIVO)",
   label: "Inveruno (ITIVO)"
  },
  {
   value: "Inzago (ITIZA)",
   label: "Inzago (ITIZA)"
  },
  {
   value: "Ionadi (ITZLX)",
   label: "Ionadi (ITZLX)"
  },
  {
   value: "Iseo (ITIEO)",
   label: "Iseo (ITIEO)"
  },
  {
   value: "Isernia (ITISE)",
   label: "Isernia (ITISE)"
  },
  {
   value: "Isola del Gran Sasso (ITZKT)",
   label: "Isola del Gran Sasso (ITZKT)"
  },
  {
   value: "Isola del Piano (ITZKQ)",
   label: "Isola del Piano (ITZKQ)"
  },
  {
   value: "Isola della Scala (ITIDS)",
   label: "Isola della Scala (ITIDS)"
  },
  {
   value: "Isola delle Femmine (ITIDF)",
   label: "Isola delle Femmine (ITIDF)"
  },
  {
   value: "Isola Dovarese (ITZKR)",
   label: "Isola Dovarese (ITZKR)"
  },
  {
   value: "Isola Rizza (ITIRZ)",
   label: "Isola Rizza (ITIRZ)"
  },
  {
   value: "Isola Vicentina (ITISV)",
   label: "Isola Vicentina (ITISV)"
  },
  {
   value: "Isolella (ITISL)",
   label: "Isolella (ITISL)"
  },
  {
   value: "Isorella, Brescia (ITBTS)",
   label: "Isorella, Brescia (ITBTS)"
  },
  {
   value: "Issogne (ITIOE)",
   label: "Issogne (ITIOE)"
  },
  {
   value: "Ivrea (ITIVR)",
   label: "Ivrea (ITIVR)"
  },
  {
   value: "Izano (ITIZN)",
   label: "Izano (ITIZN)"
  },
  {
   value: "Jerzu (ITJZU)",
   label: "Jerzu (ITJZU)"
  },
  {
   value: "Jesi (ITJES)",
   label: "Jesi (ITJES)"
  },
  {
   value: "L Aquila (ITZLS)",
   label: "L Aquila (ITZLS)"
  },
  {
   value: "La Cassa (ITLCS)",
   label: "La Cassa (ITLCS)"
  },
  {
   value: "La Lima (ITZMH)",
   label: "La Lima (ITZMH)"
  },
  {
   value: "La Loggia (ITLGA)",
   label: "La Loggia (ITLGA)"
  },
  {
   value: "Lacchiarella (ITLCH)",
   label: "Lacchiarella (ITLCH)"
  },
  {
   value: "Lacchiarella (ITLCR)",
   label: "Lacchiarella (ITLCR)"
  },
  {
   value: "Lacco Ameno (ITLAE)",
   label: "Lacco Ameno (ITLAE)"
  },
  {
   value: "Lacedonia (ITLAC)",
   label: "Lacedonia (ITLAC)"
  },
  {
   value: "Laces (ITZJY)",
   label: "Laces (ITZJY)"
  },
  {
   value: "Ladispoli (ITLAD)",
   label: "Ladispoli (ITLAD)"
  },
  {
   value: "Lagnasco (ITLGC)",
   label: "Lagnasco (ITLGC)"
  },
  {
   value: "Lagonegro (ITLAG)",
   label: "Lagonegro (ITLAG)"
  },
  {
   value: "Laives (ITLVE)",
   label: "Laives (ITLVE)"
  },
  {
   value: "Lallio (ITLLO)",
   label: "Lallio (ITLLO)"
  },
  {
   value: "Lambrugo (ITLBG)",
   label: "Lambrugo (ITLBG)"
  },
  {
   value: "Lammari (ITLMM)",
   label: "Lammari (ITLMM)"
  },
  {
   value: "Lana (ITZLR)",
   label: "Lana (ITZLR)"
  },
  {
   value: "Lanciano (ITLCI)",
   label: "Lanciano (ITLCI)"
  },
  {
   value: "Landiona (ITLND)",
   label: "Landiona (ITLND)"
  },
  {
   value: "Langhirano (ITGHO)",
   label: "Langhirano (ITGHO)"
  },
  {
   value: "Lanuvio (ITZLU)",
   label: "Lanuvio (ITZLU)"
  },
  {
   value: "Lanzo Torinese (ITLZT)",
   label: "Lanzo Torinese (ITLZT)"
  },
  {
   value: "Lasnigo (ITZLT)",
   label: "Lasnigo (ITZLT)"
  },
  {
   value: "Lauzacco (ITLUZ)",
   label: "Lauzacco (ITLUZ)"
  },
  {
   value: "Lavagna (ITLAW)",
   label: "Lavagna (ITLAW)"
  },
  {
   value: "Lavagno (ITLVG)",
   label: "Lavagno (ITLVG)"
  },
  {
   value: "Lavenone (ITNEV)",
   label: "Lavenone (ITNEV)"
  },
  {
   value: "Lavezzola (ITLZO)",
   label: "Lavezzola (ITLZO)"
  },
  {
   value: "Lavis (ITLAV)",
   label: "Lavis (ITLAV)"
  },
  {
   value: "Lazise (ITLZE)",
   label: "Lazise (ITLZE)"
  },
  {
   value: "Lazzate (ITZLP)",
   label: "Lazzate (ITZLP)"
  },
  {
   value: "Le Mose (ITZLJ)",
   label: "Le Mose (ITZLJ)"
  },
  {
   value: "Leca (ITZHU)",
   label: "Leca (ITZHU)"
  },
  {
   value: "Leffe (ITLFF)",
   label: "Leffe (ITLFF)"
  },
  {
   value: "Legnago (ITLAO)",
   label: "Legnago (ITLAO)"
  },
  {
   value: "Legoli (ITLLI)",
   label: "Legoli (ITLLI)"
  },
  {
   value: "Lemignano (ITZMG)",
   label: "Lemignano (ITZMG)"
  },
  {
   value: "Lendinara (ITLDN)",
   label: "Lendinara (ITLDN)"
  },
  {
   value: "Leno (ITENL)",
   label: "Leno (ITENL)"
  },
  {
   value: "Lentate sul Seveso (ITLSS)",
   label: "Lentate sul Seveso (ITLSS)"
  },
  {
   value: "Lentigione (ITLTG)",
   label: "Lentigione (ITLTG)"
  },
  {
   value: "Lerici (ITLER)",
   label: "Lerici (ITLER)"
  },
  {
   value: "Les Masies de Voltrega (ITLMV)",
   label: "Les Masies de Voltrega (ITLMV)"
  },
  {
   value: "Lesmo (ITLSM)",
   label: "Lesmo (ITLSM)"
  },
  {
   value: "Lessona (ITLEO)",
   label: "Lessona (ITLEO)"
  },
  {
   value: "Leuca (ITLEC)",
   label: "Leuca (ITLEC)"
  },
  {
   value: "Leumann (ITLEU)",
   label: "Leumann (ITLEU)"
  },
  {
   value: "Levanto (ITLEN)",
   label: "Levanto (ITLEN)"
  },
  {
   value: "Levate (ITLEE)",
   label: "Levate (ITLEE)"
  },
  {
   value: "Leverano (ITZIV)",
   label: "Leverano (ITZIV)"
  },
  {
   value: "Licodia Eubea (ITZLY)",
   label: "Licodia Eubea (ITZLY)"
  },
  {
   value: "Lignano Sabbiadoro (ITLSD)",
   label: "Lignano Sabbiadoro (ITLSD)"
  },
  {
   value: "Limana (ITLMN)",
   label: "Limana (ITLMN)"
  },
  {
   value: "Limidi Di Soliera (ITLDS)",
   label: "Limidi Di Soliera (ITLDS)"
  },
  {
   value: "Limido Comasco (ITLCM)",
   label: "Limido Comasco (ITLCM)"
  },
  {
   value: "Limiti (ITLMD)",
   label: "Limiti (ITLMD)"
  },
  {
   value: "Lippiano (ITZMJ)",
   label: "Lippiano (ITZMJ)"
  },
  {
   value: "Livorno Ferraris (ITZHT)",
   label: "Livorno Ferraris (ITZHT)"
  },
  {
   value: "Livraga (ITLVV)",
   label: "Livraga (ITLVV)"
  },
  {
   value: "Lizzano in Belvedere (ITLIB)",
   label: "Lizzano in Belvedere (ITLIB)"
  },
  {
   value: "Loano (ITLOA)",
   label: "Loano (ITLOA)"
  },
  {
   value: "Locate di Triulzi (ITLTZ)",
   label: "Locate di Triulzi (ITLTZ)"
  },
  {
   value: "Locate Varesino (ITLVO)",
   label: "Locate Varesino (ITLVO)"
  },
  {
   value: "Locorotondo (ITZRN)",
   label: "Locorotondo (ITZRN)"
  },
  {
   value: "Lodi Vecchio (ITLVC)",
   label: "Lodi Vecchio (ITLVC)"
  },
  {
   value: "Lomagna (ITLMG)",
   label: "Lomagna (ITLMG)"
  },
  {
   value: "Lomazzo (ITLMZ)",
   label: "Lomazzo (ITLMZ)"
  },
  {
   value: "Lonate Pozzolo (ITLOP)",
   label: "Lonate Pozzolo (ITLOP)"
  },
  {
   value: "Lonato (ITZMK)",
   label: "Lonato (ITZMK)"
  },
  {
   value: "Longarone (ITLGE)",
   label: "Longarone (ITLGE)"
  },
  {
   value: "Longastrino (ITZMM)",
   label: "Longastrino (ITZMM)"
  },
  {
   value: "Longhena (ITGHN)",
   label: "Longhena (ITGHN)"
  },
  {
   value: "Longiano (ITLNG)",
   label: "Longiano (ITLNG)"
  },
  {
   value: "Lonigo (ITLNI)",
   label: "Lonigo (ITLNI)"
  },
  {
   value: "Loreggia (ITLRG)",
   label: "Loreggia (ITLRG)"
  },
  {
   value: "Loreo (ITLRE)",
   label: "Loreo (ITLRE)"
  },
  {
   value: "Loreto (ITLRT)",
   label: "Loreto (ITLRT)"
  },
  {
   value: "Loreto (ITZMI)",
   label: "Loreto (ITZMI)"
  },
  {
   value: "Loria (ITLOR)",
   label: "Loria (ITLOR)"
  },
  {
   value: "Lovara (ITLRV)",
   label: "Lovara (ITLRV)"
  },
  {
   value: "Lozza (ITLOZ)",
   label: "Lozza (ITLOZ)"
  },
  {
   value: "Lucernate (ITLNA)",
   label: "Lucernate (ITLNA)"
  },
  {
   value: "Lucrezia (ITYZL)",
   label: "Lucrezia (ITYZL)"
  },
  {
   value: "Lugo (ITLUG)",
   label: "Lugo (ITLUG)"
  },
  {
   value: "Lugo di Ravenna (ITZMO)",
   label: "Lugo di Ravenna (ITZMO)"
  },
  {
   value: "Luisago (ITLUO)",
   label: "Luisago (ITLUO)"
  },
  {
   value: "Lumezzane (ITLZN)",
   label: "Lumezzane (ITLZN)"
  },
  {
   value: "Lunano (ITLNN)",
   label: "Lunano (ITLNN)"
  },
  {
   value: "Lungavilla (ITLGL)",
   label: "Lungavilla (ITLGL)"
  },
  {
   value: "Luogosano (ITLGS)",
   label: "Luogosano (ITLGS)"
  },
  {
   value: "Lurago Marinone (ITLMR)",
   label: "Lurago Marinone (ITLMR)"
  },
  {
   value: "Lurano (ITLUA)",
   label: "Lurano (ITLUA)"
  },
  {
   value: "Lurate Caccivio (ITLCA)",
   label: "Lurate Caccivio (ITLCA)"
  },
  {
   value: "Luserna San Giovanni (ITLGV)",
   label: "Luserna San Giovanni (ITLGV)"
  },
  {
   value: "Lutago (ITLGT)",
   label: "Lutago (ITLGT)"
  },
  {
   value: "Luzzara (ITLZA)",
   label: "Luzzara (ITLZA)"
  },
  {
   value: "Luzzi (ITZMP)",
   label: "Luzzi (ITZMP)"
  },
  {
   value: "Maccacari (ITMQC)",
   label: "Maccacari (ITMQC)"
  },
  {
   value: "Maccastorna (ITTSC)",
   label: "Maccastorna (ITTSC)"
  },
  {
   value: "Macellai (ITMCL)",
   label: "Macellai (ITMCL)"
  },
  {
   value: "Macereto (ITMHE)",
   label: "Macereto (ITMHE)"
  },
  {
   value: "Maclodio (ITDIO)",
   label: "Maclodio (ITDIO)"
  },
  {
   value: "Maclodio (ITMAO)",
   label: "Maclodio (ITMAO)"
  },
  {
   value: "Macomer (ITMCM)",
   label: "Macomer (ITMCM)"
  },
  {
   value: "Maddalene (ITMDL)",
   label: "Maddalene (ITMDL)"
  },
  {
   value: "Maddaloni (ITMLI)",
   label: "Maddaloni (ITMLI)"
  },
  {
   value: "Madonna (ITMDE)",
   label: "Madonna (ITMDE)"
  },
  {
   value: "Magliano Alpi (ITNOU)",
   label: "Magliano Alpi (ITNOU)"
  },
  {
   value: "Magnacavallo (ITZOM)",
   label: "Magnacavallo (ITZOM)"
  },
  {
   value: "Magnano (ITGGG)",
   label: "Magnano (ITGGG)"
  },
  {
   value: "Magnano in Riviera (ITZOW)",
   label: "Magnano in Riviera (ITZOW)"
  },
  {
   value: "Magreta (ITMGR)",
   label: "Magreta (ITMGR)"
  },
  {
   value: "Maiori (ITIOI)",
   label: "Maiori (ITIOI)"
  },
  {
   value: "Majano (ITMJO)",
   label: "Majano (ITMJO)"
  },
  {
   value: "Malagnino (ITALG)",
   label: "Malagnino (ITALG)"
  },
  {
   value: "Malcantone (ITMLT)",
   label: "Malcantone (ITMLT)"
  },
  {
   value: "Malcontenta (ITXMA)",
   label: "Malcontenta (ITXMA)"
  },
  {
   value: "Mancasale (ITMNL)",
   label: "Mancasale (ITMNL)"
  },
  {
   value: "Mandello del Lario (ITMLL)",
   label: "Mandello del Lario (ITMLL)"
  },
  {
   value: "Mandolossa (ITMDB)",
   label: "Mandolossa (ITMDB)"
  },
  {
   value: "Manduria (ITZMV)",
   label: "Manduria (ITZMV)"
  },
  {
   value: "Manerba del Garda (ITMBR)",
   label: "Manerba del Garda (ITMBR)"
  },
  {
   value: "Manesseno (ITMNN)",
   label: "Manesseno (ITMNN)"
  },
  {
   value: "Maniago (ITMIO)",
   label: "Maniago (ITMIO)"
  },
  {
   value: "Manoppello (ITMAP)",
   label: "Manoppello (ITMAP)"
  },
  {
   value: "Manziana (ITMZN)",
   label: "Manziana (ITMZN)"
  },
  {
   value: "Mapello (ITMPL)",
   label: "Mapello (ITMPL)"
  },
  {
   value: "Marano di Valpolicella (ITVDM)",
   label: "Marano di Valpolicella (ITVDM)"
  },
  {
   value: "Marano Lagunare (ITMAJ)",
   label: "Marano Lagunare (ITMAJ)"
  },
  {
   value: "Marano sul Panaro (ITZOG)",
   label: "Marano sul Panaro (ITZOG)"
  },
  {
   value: "Maratea (ITTEA)",
   label: "Maratea (ITTEA)"
  },
  {
   value: "Marcallo con Casone (ITMLV)",
   label: "Marcallo con Casone (ITMLV)"
  },
  {
   value: "Marcaria (ITZKV)",
   label: "Marcaria (ITZKV)"
  },
  {
   value: "Marcheno (ITMRH)",
   label: "Marcheno (ITMRH)"
  },
  {
   value: "Marciana Marina (ITMAM)",
   label: "Marciana Marina (ITMAM)"
  },
  {
   value: "Marcianise (ITMRC)",
   label: "Marcianise (ITMRC)"
  },
  {
   value: "Marcignago (ITPVV)",
   label: "Marcignago (ITPVV)"
  },
  {
   value: "Marcon (ITMCN)",
   label: "Marcon (ITMCN)"
  },
  {
   value: "Marene (ITZNR)",
   label: "Marene (ITZNR)"
  },
  {
   value: "Mareno di Piave (ITMIP)",
   label: "Mareno di Piave (ITMIP)"
  },
  {
   value: "Margherita di Savoia (ITMDW)",
   label: "Margherita di Savoia (ITMDW)"
  },
  {
   value: "Mariana Mantovana (ITMMV)",
   label: "Mariana Mantovana (ITMMV)"
  },
  {
   value: "Mariano del Friuli (ITZLO)",
   label: "Mariano del Friuli (ITZLO)"
  },
  {
   value: "Marina della Lobra (ITMLB)",
   label: "Marina della Lobra (ITMLB)"
  },
  {
   value: "Marina di Camerota (ITMIT)",
   label: "Marina di Camerota (ITMIT)"
  },
  {
   value: "Marina di Campo (ITMRP)",
   label: "Marina di Campo (ITMRP)"
  },
  {
   value: "Marina di Davoli (ITAAS)",
   label: "Marina di Davoli (ITAAS)"
  },
  {
   value: "Marina di Ginosa (ITMAH)",
   label: "Marina di Ginosa (ITMAH)"
  },
  {
   value: "Marina di Grosseto (ITMSD)",
   label: "Marina di Grosseto (ITMSD)"
  },
  {
   value: "Marina di Massa (ITQMM)",
   label: "Marina di Massa (ITQMM)"
  },
  {
   value: "Marina di Monasterace (ITMMN)",
   label: "Marina di Monasterace (ITMMN)"
  },
  {
   value: "Marina di Montemarciano (ITMDM)",
   label: "Marina di Montemarciano (ITMDM)"
  },
  {
   value: "Marina di Pisa (ITMPA)",
   label: "Marina di Pisa (ITMPA)"
  },
  {
   value: "Marina di Pisciotta (ITMSB)",
   label: "Marina di Pisciotta (ITMSB)"
  },
  {
   value: "Marina Grande (ITMGE)",
   label: "Marina Grande (ITMGE)"
  },
  {
   value: "Marinella di Selinunte (ITMNU)",
   label: "Marinella di Selinunte (ITMNU)"
  },
  {
   value: "Marino del Tronto (ITMDT)",
   label: "Marino del Tronto (ITMDT)"
  },
  {
   value: "Marliano (ITMRL)",
   label: "Marliano (ITMRL)"
  },
  {
   value: "Marmentino (ITMMI)",
   label: "Marmentino (ITMMI)"
  },
  {
   value: "Marnate (ITMNE)",
   label: "Marnate (ITMNE)"
  },
  {
   value: "Marone (ITANE)",
   label: "Marone (ITANE)"
  },
  {
   value: "Marostica (ITMRT)",
   label: "Marostica (ITMRT)"
  },
  {
   value: "Marotta (ITRTT)",
   label: "Marotta (ITRTT)"
  },
  {
   value: "Marsango (ITZNM)",
   label: "Marsango (ITZNM)"
  },
  {
   value: "Marta (ITRTA)",
   label: "Marta (ITRTA)"
  },
  {
   value: "Martano (ITZOD)",
   label: "Martano (ITZOD)"
  },
  {
   value: "Martina Franca (ITMTF)",
   label: "Martina Franca (ITMTF)"
  },
  {
   value: "Martinengo (ITEGO)",
   label: "Martinengo (ITEGO)"
  },
  {
   value: "Martorano (ITMRQ)",
   label: "Martorano (ITMRQ)"
  },
  {
   value: "Marudo (ITMRU)",
   label: "Marudo (ITMRU)"
  },
  {
   value: "Maruggio (ITARG)",
   label: "Maruggio (ITARG)"
  },
  {
   value: "Marzabotto (ITMRR)",
   label: "Marzabotto (ITMRR)"
  },
  {
   value: "Marzano (ITMRZ)",
   label: "Marzano (ITMRZ)"
  },
  {
   value: "Masate (ITMSE)",
   label: "Masate (ITMSE)"
  },
  {
   value: "Maser (ITASE)",
   label: "Maser (ITASE)"
  },
  {
   value: "Maserà di Padova (ITDIP)",
   label: "Maserà di Padova (ITDIP)"
  },
  {
   value: "Maserada sul Piave (ITSUP)",
   label: "Maserada sul Piave (ITSUP)"
  },
  {
   value: "Masi San Giacomo (ITMGC)",
   label: "Masi San Giacomo (ITMGC)"
  },
  {
   value: "Maso Stabbio (ITSTB)",
   label: "Maso Stabbio (ITSTB)"
  },
  {
   value: "Mason Vicentino (ITMVC)",
   label: "Mason Vicentino (ITMVC)"
  },
  {
   value: "Massa Carrara (ITZBX)",
   label: "Massa Carrara (ITZBX)"
  },
  {
   value: "Massa e Cozzile (ITMCZ)",
   label: "Massa e Cozzile (ITMCZ)"
  },
  {
   value: "Massa Lubrense (ITMLU)",
   label: "Massa Lubrense (ITMLU)"
  },
  {
   value: "Massa Martana (ITZOC)",
   label: "Massa Martana (ITZOC)"
  },
  {
   value: "Massafra (ITMFS)",
   label: "Massafra (ITMFS)"
  },
  {
   value: "Massalengo (ITMLE)",
   label: "Massalengo (ITMLE)"
  },
  {
   value: "Massanzago (ITSSZ)",
   label: "Massanzago (ITSSZ)"
  },
  {
   value: "Massazza (ITMSZ)",
   label: "Massazza (ITMSZ)"
  },
  {
   value: "Masserano (ITEAN)",
   label: "Masserano (ITEAN)"
  },
  {
   value: "Matelica (ITZBR)",
   label: "Matelica (ITZBR)"
  },
  {
   value: "Mathi (ITMHI)",
   label: "Mathi (ITMHI)"
  },
  {
   value: "Mazzano (ITZMU)",
   label: "Mazzano (ITZMU)"
  },
  {
   value: "Mazzantica (ITZAM)",
   label: "Mazzantica (ITZAM)"
  },
  {
   value: "Mazzara del Vallo (ITZMT)",
   label: "Mazzara del Vallo (ITZMT)"
  },
  {
   value: "Mazzo (ITMZM)",
   label: "Mazzo (ITMZM)"
  },
  {
   value: "Mazzo di Valtellina (ITMDV)",
   label: "Mazzo di Valtellina (ITMDV)"
  },
  {
   value: "Medesano (ITMDZ)",
   label: "Medesano (ITMDZ)"
  },
  {
   value: "Medicina (ITMDI)",
   label: "Medicina (ITMDI)"
  },
  {
   value: "Mediglia (ITMEG)",
   label: "Mediglia (ITMEG)"
  },
  {
   value: "Medolago (ITDLO)",
   label: "Medolago (ITDLO)"
  },
  {
   value: "Medolla (ITDLL)",
   label: "Medolla (ITDLL)"
  },
  {
   value: "Meduna di Livenza (ITZKG)",
   label: "Meduna di Livenza (ITZKG)"
  },
  {
   value: "Megliadino San Vitale (ITMVT)",
   label: "Megliadino San Vitale (ITMVT)"
  },
  {
   value: "Mel (ITMQL)",
   label: "Mel (ITMQL)"
  },
  {
   value: "Meldola (ITLDA)",
   label: "Meldola (ITLDA)"
  },
  {
   value: "Meledo (ITMDS)",
   label: "Meledo (ITMDS)"
  },
  {
   value: "Melegnano (ITMLG)",
   label: "Melegnano (ITMLG)"
  },
  {
   value: "Melfi (ITMEI)",
   label: "Melfi (ITMEI)"
  },
  {
   value: "Melicucco (ITZMX)",
   label: "Melicucco (ITZMX)"
  },
  {
   value: "Melito di Porto Salvo (ITMPS)",
   label: "Melito di Porto Salvo (ITMPS)"
  },
  {
   value: "Menfi (ITMFI)",
   label: "Menfi (ITMFI)"
  },
  {
   value: "Merano (ITMEN)",
   label: "Merano (ITMEN)"
  },
  {
   value: "Merate (ITERA)",
   label: "Merate (ITERA)"
  },
  {
   value: "Mercogliano (ITMGO)",
   label: "Mercogliano (ITMGO)"
  },
  {
   value: "Mergozzo (ITMGZ)",
   label: "Mergozzo (ITMGZ)"
  },
  {
   value: "Merlara (ITLRA)",
   label: "Merlara (ITLRA)"
  },
  {
   value: "Mese (ITZBV)",
   label: "Mese (ITZBV)"
  },
  {
   value: "Mesero (ITMEE)",
   label: "Mesero (ITMEE)"
  },
  {
   value: "Mestre (ITMET)",
   label: "Mestre (ITMET)"
  },
  {
   value: "Mestrino (ITZND)",
   label: "Mestrino (ITZND)"
  },
  {
   value: "Meta (ITMTH)",
   label: "Meta (ITMTH)"
  },
  {
   value: "Mezzago (ITMZG)",
   label: "Mezzago (ITMZG)"
  },
  {
   value: "Mezzana Bigli (ITMBI)",
   label: "Mezzana Bigli (ITMBI)"
  },
  {
   value: "Mezzanino (ITZXN)",
   label: "Mezzanino (ITZXN)"
  },
  {
   value: "Mezzolara (ITMZR)",
   label: "Mezzolara (ITMZR)"
  },
  {
   value: "Mezzomerico (ITZOR)",
   label: "Mezzomerico (ITZOR)"
  },
  {
   value: "Miglianico (ITGML)",
   label: "Miglianico (ITGML)"
  },
  {
   value: "Migliarina (ITZMS)",
   label: "Migliarina (ITZMS)"
  },
  {
   value: "Mignano Monte Lungo (ITZNN)",
   label: "Mignano Monte Lungo (ITZNN)"
  },
  {
   value: "Mili Marina (ITMIM)",
   label: "Mili Marina (ITMIM)"
  },
  {
   value: "Minerbe (ITMBE)",
   label: "Minerbe (ITMBE)"
  },
  {
   value: "Minturno (ITMTU)",
   label: "Minturno (ITMTU)"
  },
  {
   value: "Mirabello di Cantù (ITMCU)",
   label: "Mirabello di Cantù (ITMCU)"
  },
  {
   value: "Miradolo Terme (ITZVF)",
   label: "Miradolo Terme (ITZVF)"
  },
  {
   value: "Mirto (ITZNJ)",
   label: "Mirto (ITZNJ)"
  },
  {
   value: "Misano Adriatico (ITMIS)",
   label: "Misano Adriatico (ITMIS)"
  },
  {
   value: "Misilmeri (ITZNI)",
   label: "Misilmeri (ITZNI)"
  },
  {
   value: "Misinto (ITMII)",
   label: "Misinto (ITMII)"
  },
  {
   value: "Missaglia (ITMSG)",
   label: "Missaglia (ITMSG)"
  },
  {
   value: "Misterbianco, Catania (ITMBC)",
   label: "Misterbianco, Catania (ITMBC)"
  },
  {
   value: "Modica (ITMSQ)",
   label: "Modica (ITMSQ)"
  },
  {
   value: "Modugno (ITMUO)",
   label: "Modugno (ITMUO)"
  },
  {
   value: "Moggio Udinese (ITZNW)",
   label: "Moggio Udinese (ITZNW)"
  },
  {
   value: "Moglia (ITZNV)",
   label: "Moglia (ITZNV)"
  },
  {
   value: "Mogliano Veneto (ITMOG)",
   label: "Mogliano Veneto (ITMOG)"
  },
  {
   value: "Moie (ITMIE)",
   label: "Moie (ITMIE)"
  },
  {
   value: "Mola di Bari (ITODB)",
   label: "Mola di Bari (ITODB)"
  },
  {
   value: "Molinella (ITZME)",
   label: "Molinella (ITZME)"
  },
  {
   value: "Molinetto (ITMIB)",
   label: "Molinetto (ITMIB)"
  },
  {
   value: "Molinetto-Ciliverghe (ITMCV)",
   label: "Molinetto-Ciliverghe (ITMCV)"
  },
  {
   value: "Molino (ITZYH)",
   label: "Molino (ITZYH)"
  },
  {
   value: "Molino del Piano (ITMLD)",
   label: "Molino del Piano (ITMLD)"
  },
  {
   value: "Molvena (ITMVA)",
   label: "Molvena (ITMVA)"
  },
  {
   value: "Mombaroccio (ITZNU)",
   label: "Mombaroccio (ITZNU)"
  },
  {
   value: "Mombaruzzo (ITZNP)",
   label: "Mombaruzzo (ITZNP)"
  },
  {
   value: "Mombello Monferrato (ITMMF)",
   label: "Mombello Monferrato (ITMMF)"
  },
  {
   value: "Monasterolo di Savigliano (ITMVG)",
   label: "Monasterolo di Savigliano (ITMVG)"
  },
  {
   value: "Monastier di Treviso (ITMNS)",
   label: "Monastier di Treviso (ITMNS)"
  },
  {
   value: "Monchiero (ITMCO)",
   label: "Monchiero (ITMCO)"
  },
  {
   value: "Mondavio (ITMNV)",
   label: "Mondavio (ITMNV)"
  },
  {
   value: "Mondello, Palermo (ITMND)",
   label: "Mondello, Palermo (ITMND)"
  },
  {
   value: "Mondolfo (ITZIO)",
   label: "Mondolfo (ITZIO)"
  },
  {
   value: "Mondragone (ITODG)",
   label: "Mondragone (ITODG)"
  },
  {
   value: "Monferrato (ITSGF)",
   label: "Monferrato (ITSGF)"
  },
  {
   value: "Mongrando (ITMGD)",
   label: "Mongrando (ITMGD)"
  },
  {
   value: "Mongrassano (ITNNO)",
   label: "Mongrassano (ITNNO)"
  },
  {
   value: "Moniga del Garda (ITOGD)",
   label: "Moniga del Garda (ITOGD)"
  },
  {
   value: "Monsagrati (ITMST)",
   label: "Monsagrati (ITMST)"
  },
  {
   value: "Monsampolo del Tronto (ITZLV)",
   label: "Monsampolo del Tronto (ITZLV)"
  },
  {
   value: "Monta (ITZMQ)",
   label: "Monta (ITZMQ)"
  },
  {
   value: "Montagnana (ITONG)",
   label: "Montagnana (ITONG)"
  },
  {
   value: "Montalbano Jonico (ITZNX)",
   label: "Montalbano Jonico (ITZNX)"
  },
  {
   value: "Montaldo Scarampi (ITMSM)",
   label: "Montaldo Scarampi (ITMSM)"
  },
  {
   value: "Montalto di Castro (ITMLS)",
   label: "Montalto di Castro (ITMLS)"
  },
  {
   value: "Montalto Uffugo (ITMUF)",
   label: "Montalto Uffugo (ITMUF)"
  },
  {
   value: "Montano Lucino (ITMUC)",
   label: "Montano Lucino (ITMUC)"
  },
  {
   value: "Monte Cremasco (ITMEC)",
   label: "Monte Cremasco (ITMEC)"
  },
  {
   value: "Monte Marenzo (ITZNL)",
   label: "Monte Marenzo (ITZNL)"
  },
  {
   value: "Monte Porzio Catone (ITZOB)",
   label: "Monte Porzio Catone (ITZOB)"
  },
  {
   value: "Monte Santa Maria Tiberina (ITZOF)",
   label: "Monte Santa Maria Tiberina (ITZOF)"
  },
  {
   value: "Monte Urano (ITMOU)",
   label: "Monte Urano (ITMOU)"
  },
  {
   value: "Montebonello (ITMBL)",
   label: "Montebonello (ITMBL)"
  },
  {
   value: "Montecalvo in Foglia (ITZNH)",
   label: "Montecalvo in Foglia (ITZNH)"
  },
  {
   value: "Montecarlo (ITZKP)",
   label: "Montecarlo (ITZKP)"
  },
  {
   value: "Montecarotto (ITMEA)",
   label: "Montecarotto (ITMEA)"
  },
  {
   value: "Montecchia di Crosara (ITMCP)",
   label: "Montecchia di Crosara (ITMCP)"
  },
  {
   value: "Montecchio Emilia (ITMCC)",
   label: "Montecchio Emilia (ITMCC)"
  },
  {
   value: "Montecchio Precalcino (ITMPI)",
   label: "Montecchio Precalcino (ITMPI)"
  },
  {
   value: "Montechiarugolo (ITHRG)",
   label: "Montechiarugolo (ITHRG)"
  },
  {
   value: "Montecorvino Pugliano (ITPUG)",
   label: "Montecorvino Pugliano (ITPUG)"
  },
  {
   value: "Montegaldella (ITMGL)",
   label: "Montegaldella (ITMGL)"
  },
  {
   value: "Montegiordano (ITMGT)",
   label: "Montegiordano (ITMGT)"
  },
  {
   value: "Montegranaro (ITZNQ)",
   label: "Montegranaro (ITZNQ)"
  },
  {
   value: "Montelepre (ITMLP)",
   label: "Montelepre (ITMLP)"
  },
  {
   value: "Montello (ITOTL)",
   label: "Montello (ITOTL)"
  },
  {
   value: "Montelupo Fiorentino (ITMPO)",
   label: "Montelupo Fiorentino (ITMPO)"
  },
  {
   value: "Montemaggiore al Metauro (ITZOJ)",
   label: "Montemaggiore al Metauro (ITZOJ)"
  },
  {
   value: "Montemarciano (ITMMA)",
   label: "Montemarciano (ITMMA)"
  },
  {
   value: "Montemerano (ITMMR)",
   label: "Montemerano (ITMMR)"
  },
  {
   value: "Monteprandone (ITMPE)",
   label: "Monteprandone (ITMPE)"
  },
  {
   value: "Montepulciano (ITMPC)",
   label: "Montepulciano (ITMPC)"
  },
  {
   value: "Monterado (ITMOW)",
   label: "Monterado (ITMOW)"
  },
  {
   value: "Monterchi (ITZOH)",
   label: "Monterchi (ITZOH)"
  },
  {
   value: "Montereale Valcellina (ITZDB)",
   label: "Montereale Valcellina (ITZDB)"
  },
  {
   value: "Monteroduni (ITMDU)",
   label: "Monteroduni (ITMDU)"
  },
  {
   value: "Monterosso al Mare (ITRSM)",
   label: "Monterosso al Mare (ITRSM)"
  },
  {
   value: "Monterotondo (ITMTD)",
   label: "Monterotondo (ITMTD)"
  },
  {
   value: "Monterubbiano (ITMUB)",
   label: "Monterubbiano (ITMUB)"
  },
  {
   value: "Montesarchio (ITZNG)",
   label: "Montesarchio (ITZNG)"
  },
  {
   value: "Montesilvano (ITMTI)",
   label: "Montesilvano (ITMTI)"
  },
  {
   value: "Montespertoli (ITMSF)",
   label: "Montespertoli (ITMSF)"
  },
  {
   value: "Monteviale (ITMVE)",
   label: "Monteviale (ITMVE)"
  },
  {
   value: "Monticello Brianza (ITMBZ)",
   label: "Monticello Brianza (ITMBZ)"
  },
  {
   value: "Monticello Conte Otto (ITZMY)",
   label: "Monticello Conte Otto (ITZMY)"
  },
  {
   value: "Montignoso (ITMTN)",
   label: "Montignoso (ITMTN)"
  },
  {
   value: "Montone, Teramo (ITOTE)",
   label: "Montone, Teramo (ITOTE)"
  },
  {
   value: "Montorso Vicentino (ITMSI)",
   label: "Montorso Vicentino (ITMSI)"
  },
  {
   value: "Monvalle (ITMVL)",
   label: "Monvalle (ITMVL)"
  },
  {
   value: "Monzambano (ITMZB)",
   label: "Monzambano (ITMZB)"
  },
  {
   value: "Moraro (ITRAR)",
   label: "Moraro (ITRAR)"
  },
  {
   value: "Morazzone (ITMZE)",
   label: "Morazzone (ITMZE)"
  },
  {
   value: "Morena (ITRRN)",
   label: "Morena (ITRRN)"
  },
  {
   value: "Moretta (ITMOX)",
   label: "Moretta (ITMOX)"
  },
  {
   value: "Morgex (ITGEX)",
   label: "Morgex (ITGEX)"
  },
  {
   value: "Moriago della Battaglia (ITMGB)",
   label: "Moriago della Battaglia (ITMGB)"
  },
  {
   value: "Mornago (ITMRG)",
   label: "Mornago (ITMRG)"
  },
  {
   value: "Mornico al Serio (ITMSR)",
   label: "Mornico al Serio (ITMSR)"
  },
  {
   value: "Morsano al Tagliamento (ITZOA)",
   label: "Morsano al Tagliamento (ITZOA)"
  },
  {
   value: "Moscufo (ITMSU)",
   label: "Moscufo (ITMSU)"
  },
  {
   value: "Mosnigo (ITZNS)",
   label: "Mosnigo (ITZNS)"
  },
  {
   value: "Motta (ITEZZ)",
   label: "Motta (ITEZZ)"
  },
  {
   value: "Motta Baluffi (ITZMW)",
   label: "Motta Baluffi (ITZMW)"
  },
  {
   value: "Motta sant Anastasia (ITMAS)",
   label: "Motta sant Anastasia (ITMAS)"
  },
  {
   value: "Motta Vigana (ITZON)",
   label: "Motta Vigana (ITZON)"
  },
  {
   value: "Mottalciata (ITMCT)",
   label: "Mottalciata (ITMCT)"
  },
  {
   value: "Motteggiana (ITMTT)",
   label: "Motteggiana (ITMTT)"
  },
  {
   value: "Mozzate (ITMZT)",
   label: "Mozzate (ITMZT)"
  },
  {
   value: "Mozzo (ITMZP)",
   label: "Mozzo (ITMZP)"
  },
  {
   value: "Muggia (ITUGG)",
   label: "Muggia (ITUGG)"
  },
  {
   value: "Muggiò (ITMXG)",
   label: "Muggiò (ITMXG)"
  },
  {
   value: "Mulazzano (ITMUZ)",
   label: "Mulazzano (ITMUZ)"
  },
  {
   value: "Multedo (ITMUT)",
   label: "Multedo (ITMUT)"
  },
  {
   value: "Muravera (ITMVR)",
   label: "Muravera (ITMVR)"
  },
  {
   value: "Musile di Piave (ITMDP)",
   label: "Musile di Piave (ITMDP)"
  },
  {
   value: "Muzzano (ITMUA)",
   label: "Muzzano (ITMUA)"
  },
  {
   value: "Nanto (ITNNT)",
   label: "Nanto (ITNNT)"
  },
  {
   value: "Nardò (ITNRD)",
   label: "Nardò (ITNRD)"
  },
  {
   value: "Narni (ITNAR)",
   label: "Narni (ITNAR)"
  },
  {
   value: "Narni Scalo (ITNIS)",
   label: "Narni Scalo (ITNIS)"
  },
  {
   value: "Naturno (ITNAT)",
   label: "Naturno (ITNAT)"
  },
  {
   value: "Nave (ITNAV)",
   label: "Nave (ITNAV)"
  },
  {
   value: "Navole (ITZJD)",
   label: "Navole (ITZJD)"
  },
  {
   value: "Naz Sciaves (ITNSV)",
   label: "Naz Sciaves (ITNSV)"
  },
  {
   value: "Neive (ITNIE)",
   label: "Neive (ITNIE)"
  },
  {
   value: "Nembro (ITNEM)",
   label: "Nembro (ITNEM)"
  },
  {
   value: "Nepi (ITZOT)",
   label: "Nepi (ITZOT)"
  },
  {
   value: "Nervesa della Battaglia (ITNDB)",
   label: "Nervesa della Battaglia (ITNDB)"
  },
  {
   value: "Nettuno (ITNTT)",
   label: "Nettuno (ITNTT)"
  },
  {
   value: "Nibbiano (ITNBN)",
   label: "Nibbiano (ITNBN)"
  },
  {
   value: "Nibionno (ITNBO)",
   label: "Nibionno (ITNBO)"
  },
  {
   value: "Niella Tanaro (ITZOV)",
   label: "Niella Tanaro (ITZOV)"
  },
  {
   value: "Nigoline (ITNGN)",
   label: "Nigoline (ITNGN)"
  },
  {
   value: "Niviano (ITNIV)",
   label: "Niviano (ITNIV)"
  },
  {
   value: "Noale (ITNOA)",
   label: "Noale (ITNOA)"
  },
  {
   value: "Nocera Superiore (ITZOY)",
   label: "Nocera Superiore (ITZOY)"
  },
  {
   value: "Nocera Umbra (ITNBA)",
   label: "Nocera Umbra (ITNBA)"
  },
  {
   value: "Noceto (ITNCO)",
   label: "Noceto (ITNCO)"
  },
  {
   value: "Noci (ITNCI)",
   label: "Noci (ITNCI)"
  },
  {
   value: "Noicattaro (ITZOX)",
   label: "Noicattaro (ITZOX)"
  },
  {
   value: "Nola (ITNOL)",
   label: "Nola (ITNOL)"
  },
  {
   value: "Noli (ITNLI)",
   label: "Noli (ITNLI)"
  },
  {
   value: "None (ITOEN)",
   label: "None (ITOEN)"
  },
  {
   value: "Nosate (ITNOS)",
   label: "Nosate (ITNOS)"
  },
  {
   value: "Notaresco (ITZPA)",
   label: "Notaresco (ITZPA)"
  },
  {
   value: "Noto (ITNTO)",
   label: "Noto (ITNTO)"
  },
  {
   value: "Nova Milanese (ITNOM)",
   label: "Nova Milanese (ITNOM)"
  },
  {
   value: "Novafeltria (ITNFA)",
   label: "Novafeltria (ITNFA)"
  },
  {
   value: "Novaledo (ITNVD)",
   label: "Novaledo (ITNVD)"
  },
  {
   value: "Novegro (ITNEG)",
   label: "Novegro (ITNEG)"
  },
  {
   value: "Novellara (ITNOV)",
   label: "Novellara (ITNOV)"
  },
  {
   value: "Noventa di Piave (ITNVP)",
   label: "Noventa di Piave (ITNVP)"
  },
  {
   value: "Noventa Padovana (ITNOP)",
   label: "Noventa Padovana (ITNOP)"
  },
  {
   value: "Noventa Vicentina (ITNVC)",
   label: "Noventa Vicentina (ITNVC)"
  },
  {
   value: "Novi di Modena (ITZAQ)",
   label: "Novi di Modena (ITZAQ)"
  },
  {
   value: "Novi Ligure (ITNLG)",
   label: "Novi Ligure (ITNLG)"
  },
  {
   value: "Noviglio (ITNVG)",
   label: "Noviglio (ITNVG)"
  },
  {
   value: "Numana (ITNUM)",
   label: "Numana (ITNUM)"
  },
  {
   value: "Nuoro (ITQNU)",
   label: "Nuoro (ITQNU)"
  },
  {
   value: "Nusco (ITNUS)",
   label: "Nusco (ITNUS)"
  },
  {
   value: "Occhieppo Superiore (ITOSR)",
   label: "Occhieppo Superiore (ITOSR)"
  },
  {
   value: "Offida (ITOFF)",
   label: "Offida (ITOFF)"
  },
  {
   value: "Offlaga (ITZPG)",
   label: "Offlaga (ITZPG)"
  },
  {
   value: "Oggiona con Santo Stefano (ITOCS)",
   label: "Oggiona con Santo Stefano (ITOCS)"
  },
  {
   value: "Oglianico (ITOGC)",
   label: "Oglianico (ITOGC)"
  },
  {
   value: "Ogliastro Cilento (ITOGL)",
   label: "Ogliastro Cilento (ITOGL)"
  },
  {
   value: "Ognina (ITOGN)",
   label: "Ognina (ITOGN)"
  },
  {
   value: "Oleggio Castello (ITOGI)",
   label: "Oleggio Castello (ITOGI)"
  },
  {
   value: "Oleis (ITOLS)",
   label: "Oleis (ITOLS)"
  },
  {
   value: "Olgiate Olona (ITOLN)",
   label: "Olgiate Olona (ITOLN)"
  },
  {
   value: "Oliveri (ITOLV)",
   label: "Oliveri (ITOLV)"
  },
  {
   value: "Olmi (ITOMI)",
   label: "Olmi (ITOMI)"
  },
  {
   value: "Olmo al Brembo (ITOLM)",
   label: "Olmo al Brembo (ITOLM)"
  },
  {
   value: "Olmo di Creazzo (ITREA)",
   label: "Olmo di Creazzo (ITREA)"
  },
  {
   value: "Oltrona al Lago (ITZPC)",
   label: "Oltrona al Lago (ITZPC)"
  },
  {
   value: "Oltrona di San Mamette (ITONM)",
   label: "Oltrona di San Mamette (ITONM)"
  },
  {
   value: "Ome (ITOME)",
   label: "Ome (ITOME)"
  },
  {
   value: "Omegna (ITOMG)",
   label: "Omegna (ITOMG)"
  },
  {
   value: "Onara (ITONR)",
   label: "Onara (ITONR)"
  },
  {
   value: "Onigo (ITZPI)",
   label: "Onigo (ITZPI)"
  },
  {
   value: "Opera (ITOPR)",
   label: "Opera (ITOPR)"
  },
  {
   value: "Oppeano (ITOPP)",
   label: "Oppeano (ITOPP)"
  },
  {
   value: "Orani (ITONA)",
   label: "Orani (ITONA)"
  },
  {
   value: "Orbetello (ITOBT)",
   label: "Orbetello (ITOBT)"
  },
  {
   value: "Orciano di Pesaro (ITODP)",
   label: "Orciano di Pesaro (ITODP)"
  },
  {
   value: "Orero (ITORO)",
   label: "Orero (ITORO)"
  },
  {
   value: "Orgiano (ITZBH)",
   label: "Orgiano (ITZBH)"
  },
  {
   value: "Origgio (ITORG)",
   label: "Origgio (ITORG)"
  },
  {
   value: "Orio Al Serio (ITOAS)",
   label: "Orio Al Serio (ITOAS)"
  },
  {
   value: "Ormelle (ITORM)",
   label: "Ormelle (ITORM)"
  },
  {
   value: "Ornago (ITOGO)",
   label: "Ornago (ITOGO)"
  },
  {
   value: "Orosei (ITZPL)",
   label: "Orosei (ITZPL)"
  },
  {
   value: "Orsenigo (ITORS)",
   label: "Orsenigo (ITORS)"
  },
  {
   value: "Orta di Atella (ITZPF)",
   label: "Orta di Atella (ITZPF)"
  },
  {
   value: "Orte (ITORE)",
   label: "Orte (ITORE)"
  },
  {
   value: "Ortezzano (ITORX)",
   label: "Ortezzano (ITORX)"
  },
  {
   value: "Ortona dei Marsi (ITODM)",
   label: "Ortona dei Marsi (ITODM)"
  },
  {
   value: "Ortonovo (ITORN)",
   label: "Ortonovo (ITORN)"
  },
  {
   value: "Orvieto (ITORV)",
   label: "Orvieto (ITORV)"
  },
  {
   value: "Orzinuovi (ITORZ)",
   label: "Orzinuovi (ITORZ)"
  },
  {
   value: "Osini (ITONI)",
   label: "Osini (ITONI)"
  },
  {
   value: "Osio Sotto (ITOSS)",
   label: "Osio Sotto (ITOSS)"
  },
  {
   value: "Osnago (ITOSN)",
   label: "Osnago (ITOSN)"
  },
  {
   value: "Osoppo (ITSOP)",
   label: "Osoppo (ITSOP)"
  },
  {
   value: "Ospedaletto (ITOSO)",
   label: "Ospedaletto (ITOSO)"
  },
  {
   value: "Ospedaletto Euganeo (ITOEG)",
   label: "Ospedaletto Euganeo (ITOEG)"
  },
  {
   value: "Ospedaletto Lodigiano (ITOPL)",
   label: "Ospedaletto Lodigiano (ITOPL)"
  },
  {
   value: "Ospiate (ITZXC)",
   label: "Ospiate (ITZXC)"
  },
  {
   value: "Ossona (ITOON)",
   label: "Ossona (ITOON)"
  },
  {
   value: "Ostellato (ITOSL)",
   label: "Ostellato (ITOSL)"
  },
  {
   value: "Osteria Grande (ITOST)",
   label: "Osteria Grande (ITOST)"
  },
  {
   value: "Ostia (ITSIT)",
   label: "Ostia (ITSIT)"
  },
  {
   value: "Ostiglia (ITOGA)",
   label: "Ostiglia (ITOGA)"
  },
  {
   value: "Ostra (ITZPM)",
   label: "Ostra (ITZPM)"
  },
  {
   value: "Ostuni (ITOSU)",
   label: "Ostuni (ITOSU)"
  },
  {
   value: "Ottaviano (ITOTV)",
   label: "Ottaviano (ITOTV)"
  },
  {
   value: "Ozzano Taro (ITOTR)",
   label: "Ozzano Taro (ITOTR)"
  },
  {
   value: "Ozzero (ITOZO)",
   label: "Ozzero (ITOZO)"
  },
  {
   value: "Pace del Mela (ITZLK)",
   label: "Pace del Mela (ITZLK)"
  },
  {
   value: "Paceco (ITPEC)",
   label: "Paceco (ITPEC)"
  },
  {
   value: "Padernello (ITNEL)",
   label: "Padernello (ITNEL)"
  },
  {
   value: "Paderno Franciacorta (ITZQD)",
   label: "Paderno Franciacorta (ITZQD)"
  },
  {
   value: "Padula (ITULA)",
   label: "Padula (ITULA)"
  },
  {
   value: "Paese (ITPEE)",
   label: "Paese (ITPEE)"
  },
  {
   value: "Pagani (ITPAI)",
   label: "Pagani (ITPAI)"
  },
  {
   value: "Pagliate (ITZPS)",
   label: "Pagliate (ITZPS)"
  },
  {
   value: "Pagnacco (ITPGN)",
   label: "Pagnacco (ITPGN)"
  },
  {
   value: "Paitone (ITPTE)",
   label: "Paitone (ITPTE)"
  },
  {
   value: "Paladina (ITPAD)",
   label: "Paladina (ITPAD)"
  },
  {
   value: "Palagonia (ITZPT)",
   label: "Palagonia (ITZPT)"
  },
  {
   value: "Palazzago (ITAZG)",
   label: "Palazzago (ITAZG)"
  },
  {
   value: "Palazzo Pignano (ITZEK)",
   label: "Palazzo Pignano (ITZEK)"
  },
  {
   value: "Palazzo San Gervasio (ITPZG)",
   label: "Palazzo San Gervasio (ITPZG)"
  },
  {
   value: "Palazzolo (ITZQN)",
   label: "Palazzolo (ITZQN)"
  },
  {
   value: "Palazzolo Acreide (ITZRH)",
   label: "Palazzolo Acreide (ITZRH)"
  },
  {
   value: "Palazzolo Vercellese (ITPZV)",
   label: "Palazzolo Vercellese (ITPZV)"
  },
  {
   value: "Palestro (ITPLT)",
   label: "Palestro (ITPLT)"
  },
  {
   value: "Palinuro (ITPLN)",
   label: "Palinuro (ITPLN)"
  },
  {
   value: "Palma Campania (ITPCL)",
   label: "Palma Campania (ITPCL)"
  },
  {
   value: "Palmanova (ITPNV)",
   label: "Palmanova (ITPNV)"
  },
  {
   value: "Palmi (ITPMM)",
   label: "Palmi (ITPMM)"
  },
  {
   value: "Palo del Colle (ITZPV)",
   label: "Palo del Colle (ITZPV)"
  },
  {
   value: "Palosco (ITPLC)",
   label: "Palosco (ITPLC)"
  },
  {
   value: "Pantigliate (ITPGT)",
   label: "Pantigliate (ITPGT)"
  },
  {
   value: "Paola (ITAOA)",
   label: "Paola (ITAOA)"
  },
  {
   value: "Paolisi (ITPAS)",
   label: "Paolisi (ITPAS)"
  },
  {
   value: "Paradigna (ITPDN)",
   label: "Paradigna (ITPDN)"
  },
  {
   value: "Paratico (ITPAR)",
   label: "Paratico (ITPAR)"
  },
  {
   value: "Parola (ITOLA)",
   label: "Parola (ITOLA)"
  },
  {
   value: "Parona (ITPNA)",
   label: "Parona (ITPNA)"
  },
  {
   value: "Parona di Valpolicella (ITPOA)",
   label: "Parona di Valpolicella (ITPOA)"
  },
  {
   value: "Parre (ITZQU)",
   label: "Parre (ITZQU)"
  },
  {
   value: "Partanna (ITNNA)",
   label: "Partanna (ITNNA)"
  },
  {
   value: "Paruzzaro (ITPAA)",
   label: "Paruzzaro (ITPAA)"
  },
  {
   value: "Pasian di Prato (ITZLG)",
   label: "Pasian di Prato (ITZLG)"
  },
  {
   value: "Pasiano di Pordenone (ITPOE)",
   label: "Pasiano di Pordenone (ITPOE)"
  },
  {
   value: "Passirana (ITITP)",
   label: "Passirana (ITITP)"
  },
  {
   value: "Passirano (ITPAO)",
   label: "Passirano (ITPAO)"
  },
  {
   value: "Pasturo (ITPUR)",
   label: "Pasturo (ITPUR)"
  },
  {
   value: "Patrica (ITPIC)",
   label: "Patrica (ITPIC)"
  },
  {
   value: "Paullo (ITPUL)",
   label: "Paullo (ITPUL)"
  },
  {
   value: "Pavia di Udine (ITPDU)",
   label: "Pavia di Udine (ITPDU)"
  },
  {
   value: "Pavona (ITZAD)",
   label: "Pavona (ITZAD)"
  },
  {
   value: "Pavone del Mella (ITPEA)",
   label: "Pavone del Mella (ITPEA)"
  },
  {
   value: "Pedaso (ITPED)",
   label: "Pedaso (ITPED)"
  },
  {
   value: "Pedemonte (ITEDE)",
   label: "Pedemonte (ITEDE)"
  },
  {
   value: "Pedrengo (ITPBO)",
   label: "Pedrengo (ITPBO)"
  },
  {
   value: "Pegognaga (ITPEN)",
   label: "Pegognaga (ITPEN)"
  },
  {
   value: "Pellaro (ITPEL)",
   label: "Pellaro (ITPEL)"
  },
  {
   value: "Pennabilli (ITZQB)",
   label: "Pennabilli (ITZQB)"
  },
  {
   value: "Peregallo (ITPGO)",
   label: "Peregallo (ITPGO)"
  },
  {
   value: "Perego (ITZQC)",
   label: "Perego (ITZQC)"
  },
  {
   value: "Peretola (ITZHK)",
   label: "Peretola (ITZHK)"
  },
  {
   value: "Pergine Valsugana (ITPVL)",
   label: "Pergine Valsugana (ITPVL)"
  },
  {
   value: "Pergola (ITZPK)",
   label: "Pergola (ITZPK)"
  },
  {
   value: "Perignano (ITPNN)",
   label: "Perignano (ITPNN)"
  },
  {
   value: "Pernumia (ITPUI)",
   label: "Pernumia (ITPUI)"
  },
  {
   value: "Pero (ITERO)",
   label: "Pero (ITERO)"
  },
  {
   value: "Perosa Argentina (ITPER)",
   label: "Perosa Argentina (ITPER)"
  },
  {
   value: "Pertica Alta (ITPCT)",
   label: "Pertica Alta (ITPCT)"
  },
  {
   value: "Pescaglia (ITZPW)",
   label: "Pescaglia (ITZPW)"
  },
  {
   value: "Pescantina (ITPNC)",
   label: "Pescantina (ITPNC)"
  },
  {
   value: "Pescate (ITPSE)",
   label: "Pescate (ITPSE)"
  },
  {
   value: "Pescia (ITPCA)",
   label: "Pescia (ITPCA)"
  },
  {
   value: "Pessinetto (ITPSQ)",
   label: "Pessinetto (ITPSQ)"
  },
  {
   value: "Petriolo (ITPTQ)",
   label: "Petriolo (ITPTQ)"
  },
  {
   value: "Petrosino (ITZQY)",
   label: "Petrosino (ITZQY)"
  },
  {
   value: "Pettoranello (ITZPQ)",
   label: "Pettoranello (ITZPQ)"
  },
  {
   value: "Peveragno (ITPEV)",
   label: "Peveragno (ITPEV)"
  },
  {
   value: "Pezzan di Meluna (ITPEZ)",
   label: "Pezzan di Meluna (ITPEZ)"
  },
  {
   value: "Piadena (ITPEF)",
   label: "Piadena (ITPEF)"
  },
  {
   value: "Pian Camuno (ITPNM)",
   label: "Pian Camuno (ITPNM)"
  },
  {
   value: "Pian di Macina (ITNIC)",
   label: "Pian di Macina (ITNIC)"
  },
  {
   value: "Piancaldoli (ITPLD)",
   label: "Piancaldoli (ITPLD)"
  },
  {
   value: "Piandimeleto (ITZPY)",
   label: "Piandimeleto (ITZPY)"
  },
  {
   value: "Pianezza (ITPZC)",
   label: "Pianezza (ITPZC)"
  },
  {
   value: "Pianezze (ITPIF)",
   label: "Pianezze (ITPIF)"
  },
  {
   value: "Piangipane (ITZPE)",
   label: "Piangipane (ITZPE)"
  },
  {
   value: "Pianiga (ITPIG)",
   label: "Pianiga (ITPIG)"
  },
  {
   value: "Piano di Coreglia (ITPCG)",
   label: "Piano di Coreglia (ITPCG)"
  },
  {
   value: "Piano di Sorrento (ITPRR)",
   label: "Piano di Sorrento (ITPRR)"
  },
  {
   value: "Piano Tavola (ITPTV)",
   label: "Piano Tavola (ITPTV)"
  },
  {
   value: "Pianodardine (ITPDR)",
   label: "Pianodardine (ITPDR)"
  },
  {
   value: "Pianoro (ITPNR)",
   label: "Pianoro (ITPNR)"
  },
  {
   value: "Pianzano (ITPZN)",
   label: "Pianzano (ITPZN)"
  },
  {
   value: "Piateda (ITPID)",
   label: "Piateda (ITPID)"
  },
  {
   value: "Piazzola sul Brenta (ITZQV)",
   label: "Piazzola sul Brenta (ITZQV)"
  },
  {
   value: "Piedimonte Etneo (ITZRB)",
   label: "Piedimonte Etneo (ITZRB)"
  },
  {
   value: "Piedimulera (ITPMU)",
   label: "Piedimulera (ITPMU)"
  },
  {
   value: "Piediripa (ITPPA)",
   label: "Piediripa (ITPPA)"
  },
  {
   value: "Pieranica (ITZQO)",
   label: "Pieranica (ITZQO)"
  },
  {
   value: "Pietragalla (ITTAG)",
   label: "Pietragalla (ITTAG)"
  },
  {
   value: "Pietramurata (ITPTM)",
   label: "Pietramurata (ITPTM)"
  },
  {
   value: "Pieve (ITIEV)",
   label: "Pieve (ITIEV)"
  },
  {
   value: "Pieve a Nievole (ITZQH)",
   label: "Pieve a Nievole (ITZQH)"
  },
  {
   value: "Pieve di Cadore (ITPCD)",
   label: "Pieve di Cadore (ITPCD)"
  },
  {
   value: "Pieve di Teco (ITETC)",
   label: "Pieve di Teco (ITETC)"
  },
  {
   value: "Pieve Emanuele (ITPVM)",
   label: "Pieve Emanuele (ITPVM)"
  },
  {
   value: "Pieve Modolena (ITPMD)",
   label: "Pieve Modolena (ITPMD)"
  },
  {
   value: "Pieve San Giacomo (ITPGM)",
   label: "Pieve San Giacomo (ITPGM)"
  },
  {
   value: "Pieve Santo Stefano (ITPSF)",
   label: "Pieve Santo Stefano (ITPSF)"
  },
  {
   value: "Pieve Vergonte (ITPVR)",
   label: "Pieve Vergonte (ITPVR)"
  },
  {
   value: "Pievebelvicino (ITPLV)",
   label: "Pievebelvicino (ITPLV)"
  },
  {
   value: "Pignataro Interamna (ITPII)",
   label: "Pignataro Interamna (ITPII)"
  },
  {
   value: "Pignataro Maggiore (ITEPM)",
   label: "Pignataro Maggiore (ITEPM)"
  },
  {
   value: "Pinzano al Tagliamento (ITZRJ)",
   label: "Pinzano al Tagliamento (ITZRJ)"
  },
  {
   value: "Piobesi Torinese (ITPBT)",
   label: "Piobesi Torinese (ITPBT)"
  },
  {
   value: "Piossasco (ITZMB)",
   label: "Piossasco (ITZMB)"
  },
  {
   value: "Piovà Massaia (ITZQI)",
   label: "Piovà Massaia (ITZQI)"
  },
  {
   value: "Piove di Sacco (ITPIV)",
   label: "Piove di Sacco (ITPIV)"
  },
  {
   value: "Piovene Rocchette (ITPVN)",
   label: "Piovene Rocchette (ITPVN)"
  },
  {
   value: "Piscinas (ITZQW)",
   label: "Piscinas (ITZQW)"
  },
  {
   value: "Pisogne (ITZQJ)",
   label: "Pisogne (ITZQJ)"
  },
  {
   value: "Pisticci (ITPCI)",
   label: "Pisticci (ITPCI)"
  },
  {
   value: "Pitigliano (ITPTG)",
   label: "Pitigliano (ITPTG)"
  },
  {
   value: "Pizzighettone (ITZRI)",
   label: "Pizzighettone (ITZRI)"
  },
  {
   value: "Pizzo (ITPIZ)",
   label: "Pizzo (ITPIZ)"
  },
  {
   value: "Plesio (ITPSI)",
   label: "Plesio (ITPSI)"
  },
  {
   value: "Pocenia (ITPNI)",
   label: "Pocenia (ITPNI)"
  },
  {
   value: "Pofi (ITPOF)",
   label: "Pofi (ITPOF)"
  },
  {
   value: "Poggio Berni (ITPGB)",
   label: "Poggio Berni (ITPGB)"
  },
  {
   value: "Poggio Renatico (ITPOG)",
   label: "Poggio Renatico (ITPOG)"
  },
  {
   value: "Poggiofiorito (ITPFR)",
   label: "Poggiofiorito (ITPFR)"
  },
  {
   value: "Poggiridenti (ITPGD)",
   label: "Poggiridenti (ITPGD)"
  },
  {
   value: "Pogliano Milanese (ITPME)",
   label: "Pogliano Milanese (ITPME)"
  },
  {
   value: "Pogno (ITZAP)",
   label: "Pogno (ITZAP)"
  },
  {
   value: "Poiano (ITPOI)",
   label: "Poiano (ITPOI)"
  },
  {
   value: "Poirino (ITPIR)",
   label: "Poirino (ITPIR)"
  },
  {
   value: "Polcenigo (ITZQR)",
   label: "Polcenigo (ITZQR)"
  },
  {
   value: "Polegge (ITZQE)",
   label: "Polegge (ITZQE)"
  },
  {
   value: "Policoro (ITPCR)",
   label: "Policoro (ITPCR)"
  },
  {
   value: "Polignano a Mare (ITZQQ)",
   label: "Polignano a Mare (ITZQQ)"
  },
  {
   value: "Polinago (ITOAG)",
   label: "Polinago (ITOAG)"
  },
  {
   value: "Polistena (ITZBY)",
   label: "Polistena (ITZBY)"
  },
  {
   value: "Polla (ITPLL)",
   label: "Polla (ITPLL)"
  },
  {
   value: "Pollein (ITPOL)",
   label: "Pollein (ITPOL)"
  },
  {
   value: "Pollenza (ITZQL)",
   label: "Pollenza (ITZQL)"
  },
  {
   value: "Pollone (ITLOE)",
   label: "Pollone (ITLOE)"
  },
  {
   value: "Polonghera (ITZMA)",
   label: "Polonghera (ITZMA)"
  },
  {
   value: "Polpenazze del Garda (ITPPG)",
   label: "Polpenazze del Garda (ITPPG)"
  },
  {
   value: "Polverara (ITZRE)",
   label: "Polverara (ITZRE)"
  },
  {
   value: "Polverigi (ITPLE)",
   label: "Polverigi (ITPLE)"
  },
  {
   value: "Pombia (ITPMI)",
   label: "Pombia (ITPMI)"
  },
  {
   value: "Pompei (ITPMP)",
   label: "Pompei (ITPMP)"
  },
  {
   value: "Pomponesco (ITZQS)",
   label: "Pomponesco (ITZQS)"
  },
  {
   value: "Ponsacco (ITOAC)",
   label: "Ponsacco (ITOAC)"
  },
  {
   value: "Ponso (ITZLQ)",
   label: "Ponso (ITZLQ)"
  },
  {
   value: "Ponte a Cappiano (ITPOB)",
   label: "Ponte a Cappiano (ITPOB)"
  },
  {
   value: "Ponte a Egola (ITPCW)",
   label: "Ponte a Egola (ITPCW)"
  },
  {
   value: "Ponte a Elsa (ITZQM)",
   label: "Ponte a Elsa (ITZQM)"
  },
  {
   value: "Ponte Chiasso (ITPHS)",
   label: "Ponte Chiasso (ITPHS)"
  },
  {
   value: "Ponte della Priula (ITPOP)",
   label: "Ponte della Priula (ITPOP)"
  },
  {
   value: "Ponte di Barbarano (ITPBR)",
   label: "Ponte di Barbarano (ITPBR)"
  },
  {
   value: "Ponte di Piave (ITPPV)",
   label: "Ponte di Piave (ITPPV)"
  },
  {
   value: "Ponte Galeria (ITZQG)",
   label: "Ponte Galeria (ITZQG)"
  },
  {
   value: "Ponte nelle Alpi (ITZQP)",
   label: "Ponte nelle Alpi (ITZQP)"
  },
  {
   value: "Ponte Nossa (ITPNS)",
   label: "Ponte Nossa (ITPNS)"
  },
  {
   value: "Ponte San Giovanni (ITPSG)",
   label: "Ponte San Giovanni (ITPSG)"
  },
  {
   value: "Ponte San Marco (ITPSM)",
   label: "Ponte San Marco (ITPSM)"
  },
  {
   value: "Ponte San Nicolo (ITZRA)",
   label: "Ponte San Nicolo (ITZRA)"
  },
  {
   value: "Ponte Selva (ITPPS)",
   label: "Ponte Selva (ITPPS)"
  },
  {
   value: "Ponte Taro (ITPOT)",
   label: "Ponte Taro (ITPOT)"
  },
  {
   value: "Ponte Tresa (ITPTT)",
   label: "Ponte Tresa (ITPTT)"
  },
  {
   value: "Ponte Valleceppi (ITPLP)",
   label: "Ponte Valleceppi (ITPLP)"
  },
  {
   value: "Ponte Zanano (ITZYL)",
   label: "Ponte Zanano (ITZYL)"
  },
  {
   value: "Ponte, Benevento (ITPNE)",
   label: "Ponte, Benevento (ITPNE)"
  },
  {
   value: "Pontebba (ITPTB)",
   label: "Pontebba (ITPTB)"
  },
  {
   value: "Pontecagnano Faiano (ITZQF)",
   label: "Pontecagnano Faiano (ITZQF)"
  },
  {
   value: "Pontedera (ITPND)",
   label: "Pontedera (ITPND)"
  },
  {
   value: "Pontelongo (ITPLG)",
   label: "Pontelongo (ITPLG)"
  },
  {
   value: "Pontenure (ITPTN)",
   label: "Pontenure (ITPTN)"
  },
  {
   value: "Pontevico (ITPEO)",
   label: "Pontevico (ITPEO)"
  },
  {
   value: "Pontida (ITOTD)",
   label: "Pontida (ITOTD)"
  },
  {
   value: "Pontirolo Nuovo (ITPUO)",
   label: "Pontirolo Nuovo (ITPUO)"
  },
  {
   value: "Pontoglio (ITOTG)",
   label: "Pontoglio (ITOTG)"
  },
  {
   value: "Pontremoli (ITPML)",
   label: "Pontremoli (ITPML)"
  },
  {
   value: "Ponzano Veneto (ITPZT)",
   label: "Ponzano Veneto (ITPZT)"
  },
  {
   value: "Popoli (ITPAB)",
   label: "Popoli (ITPAB)"
  },
  {
   value: "Portacomaro (ITPCM)",
   label: "Portacomaro (ITPCM)"
  },
  {
   value: "Portacomaro Stazione (ITPSZ)",
   label: "Portacomaro Stazione (ITPSZ)"
  },
  {
   value: "Porticello (ITORL)",
   label: "Porticello (ITORL)"
  },
  {
   value: "Porto Conte (ITPCN)",
   label: "Porto Conte (ITPCN)"
  },
  {
   value: "Porto Ercole (ITPTH)",
   label: "Porto Ercole (ITPTH)"
  },
  {
   value: "Porto Levante (ITPVT)",
   label: "Porto Levante (ITPVT)"
  },
  {
   value: "Porto Mantovano (ITPMV)",
   label: "Porto Mantovano (ITPMV)"
  },
  {
   value: "Porto Marghera (ITGHE)",
   label: "Porto Marghera (ITGHE)"
  },
  {
   value: "Porto Palo (ITPPF)",
   label: "Porto Palo (ITPPF)"
  },
  {
   value: "Porto Recanati (ITPRF)",
   label: "Porto Recanati (ITPRF)"
  },
  {
   value: "Porto San Giorgio (ITSIG)",
   label: "Porto San Giorgio (ITSIG)"
  },
  {
   value: "Porto Tolle (ITPPT)",
   label: "Porto Tolle (ITPPT)"
  },
  {
   value: "Porto Viro (ITPOQ)",
   label: "Porto Viro (ITPOQ)"
  },
  {
   value: "Portobuffole (ITZPU)",
   label: "Portobuffole (ITZPU)"
  },
  {
   value: "Portomaggiore (ITPMG)",
   label: "Portomaggiore (ITPMG)"
  },
  {
   value: "Portonovo (ITRTN)",
   label: "Portonovo (ITRTN)"
  },
  {
   value: "Portopalo (ITPPL)",
   label: "Portopalo (ITPPL)"
  },
  {
   value: "Portovenere (ITPRW)",
   label: "Portovenere (ITPRW)"
  },
  {
   value: "Posina (ITINA)",
   label: "Posina (ITINA)"
  },
  {
   value: "Possagno (ITOAN)",
   label: "Possagno (ITOAN)"
  },
  {
   value: "Possagno (ITPOX)",
   label: "Possagno (ITPOX)"
  },
  {
   value: "Postalesio (ITZQK)",
   label: "Postalesio (ITZQK)"
  },
  {
   value: "Postioma di Paese (ITTIO)",
   label: "Postioma di Paese (ITTIO)"
  },
  {
   value: "Potenza (ITQPO)",
   label: "Potenza (ITQPO)"
  },
  {
   value: "Povegliano Veronese (ITPVG)",
   label: "Povegliano Veronese (ITPVG)"
  },
  {
   value: "Povolaro (ITPOV)",
   label: "Povolaro (ITPOV)"
  },
  {
   value: "Povoletto (ITZRF)",
   label: "Povoletto (ITZRF)"
  },
  {
   value: "Pozzaglio ed Uniti (ITPZI)",
   label: "Pozzaglio ed Uniti (ITPZI)"
  },
  {
   value: "Pozzilli (ITZZI)",
   label: "Pozzilli (ITZZI)"
  },
  {
   value: "Pozzillo, Catania (ITOZI)",
   label: "Pozzillo, Catania (ITOZI)"
  },
  {
   value: "Pozzolengo (ITPZZ)",
   label: "Pozzolengo (ITPZZ)"
  },
  {
   value: "Pozzonovo (ITZZV)",
   label: "Pozzonovo (ITZZV)"
  },
  {
   value: "Pozzuolo Martesana (ITPMS)",
   label: "Pozzuolo Martesana (ITPMS)"
  },
  {
   value: "Pracando (ITZPX)",
   label: "Pracando (ITZPX)"
  },
  {
   value: "Pradalunga (ITPLA)",
   label: "Pradalunga (ITPLA)"
  },
  {
   value: "Pradamano (ITPDM)",
   label: "Pradamano (ITPDM)"
  },
  {
   value: "Praia a Mare (ITPIM)",
   label: "Praia a Mare (ITPIM)"
  },
  {
   value: "Pramaggiore (ITPGE)",
   label: "Pramaggiore (ITPGE)"
  },
  {
   value: "Prata (ITRAT)",
   label: "Prata (ITRAT)"
  },
  {
   value: "Prata di Pordenone (ITPDP)",
   label: "Prata di Pordenone (ITPDP)"
  },
  {
   value: "Prato Sesia (ITPXT)",
   label: "Prato Sesia (ITPXT)"
  },
  {
   value: "Pratola Peligna (ITZQT)",
   label: "Pratola Peligna (ITZQT)"
  },
  {
   value: "Pray (ITPRY)",
   label: "Pray (ITPRY)"
  },
  {
   value: "Preganziol (ITPGZ)",
   label: "Preganziol (ITPGZ)"
  },
  {
   value: "Premosello Chiovenda (ITPCV)",
   label: "Premosello Chiovenda (ITPCV)"
  },
  {
   value: "Prepotto (ITPPO)",
   label: "Prepotto (ITPPO)"
  },
  {
   value: "Prignano sulla Secchia (ITUSS)",
   label: "Prignano sulla Secchia (ITUSS)"
  },
  {
   value: "Primaluna, Lecco (ITPMN)",
   label: "Primaluna, Lecco (ITPMN)"
  },
  {
   value: "Priverno (ITPRV)",
   label: "Priverno (ITPRV)"
  },
  {
   value: "Prossedi (ITZHN)",
   label: "Prossedi (ITZHN)"
  },
  {
   value: "Provazzano (ITZRG)",
   label: "Provazzano (ITZRG)"
  },
  {
   value: "Puegnago sul Garda (ITPUE)",
   label: "Puegnago sul Garda (ITPUE)"
  },
  {
   value: "Puia (ITZQA)",
   label: "Puia (ITZQA)"
  },
  {
   value: "Pula (ITZRD)",
   label: "Pula (ITZRD)"
  },
  {
   value: "Pumenengo (ITZXE)",
   label: "Pumenengo (ITZXE)"
  },
  {
   value: "Putignano (ITPUT)",
   label: "Putignano (ITPUT)"
  },
  {
   value: "Quaderni (ITQDR)",
   label: "Quaderni (ITQDR)"
  },
  {
   value: "Qualiano (ITQLO)",
   label: "Qualiano (ITQLO)"
  },
  {
   value: "Quarrata (ITQUA)",
   label: "Quarrata (ITQUA)"
  },
  {
   value: "Quattordio (ITQTT)",
   label: "Quattordio (ITQTT)"
  },
  {
   value: "Quattro Castella (ITQCL)",
   label: "Quattro Castella (ITQCL)"
  },
  {
   value: "Quero (ITQOY)",
   label: "Quero (ITQOY)"
  },
  {
   value: "Quinto de Stampi (ITZRK)",
   label: "Quinto de Stampi (ITZRK)"
  },
  {
   value: "Quinto Vicentino (ITZRP)",
   label: "Quinto Vicentino (ITZRP)"
  },
  {
   value: "Quinzano (ITNQZ)",
   label: "Quinzano (ITNQZ)"
  },
  {
   value: "Quistello (ITQUO)",
   label: "Quistello (ITQUO)"
  },
  {
   value: "Racalmuto (ITRCM)",
   label: "Racalmuto (ITRCM)"
  },
  {
   value: "Radicofani (ITZRR)",
   label: "Radicofani (ITZRR)"
  },
  {
   value: "Ragogna (ITRGB)",
   label: "Ragogna (ITRGB)"
  },
  {
   value: "Ragoli (ITZRY)",
   label: "Ragoli (ITZRY)"
  },
  {
   value: "Ramon (ITRMN)",
   label: "Ramon (ITRMN)"
  },
  {
   value: "Rancio Valcuvia (ITZSD)",
   label: "Rancio Valcuvia (ITZSD)"
  },
  {
   value: "Rapallo (ITRPO)",
   label: "Rapallo (ITRPO)"
  },
  {
   value: "Rastignano (ITRSI)",
   label: "Rastignano (ITRSI)"
  },
  {
   value: "Rauscedo (ITZSJ)",
   label: "Rauscedo (ITZSJ)"
  },
  {
   value: "Ravadese (ITRDD)",
   label: "Ravadese (ITRDD)"
  },
  {
   value: "Ravarino (ITRAV)",
   label: "Ravarino (ITRAV)"
  },
  {
   value: "Ravina (ITRVI)",
   label: "Ravina (ITRVI)"
  },
  {
   value: "Reana del Roiale (ITZRU)",
   label: "Reana del Roiale (ITZRU)"
  },
  {
   value: "Recco (ITREC)",
   label: "Recco (ITREC)"
  },
  {
   value: "Redecesio (ITRDC)",
   label: "Redecesio (ITRDC)"
  },
  {
   value: "Reggello (ITZRX)",
   label: "Reggello (ITZRX)"
  },
  {
   value: "Remanzacco (ITREZ)",
   label: "Remanzacco (ITREZ)"
  },
  {
   value: "Remedello (ITRMD)",
   label: "Remedello (ITRMD)"
  },
  {
   value: "Remedello Sopra (ITRLO)",
   label: "Remedello Sopra (ITRLO)"
  },
  {
   value: "Renate (ITRTE)",
   label: "Renate (ITRTE)"
  },
  {
   value: "Renazzo (ITZKY)",
   label: "Renazzo (ITZKY)"
  },
  {
   value: "Rende (ITZNA)",
   label: "Rende (ITZNA)"
  },
  {
   value: "Rende Cosenza (ITRCA)",
   label: "Rende Cosenza (ITRCA)"
  },
  {
   value: "Reschigliano di Capodarsego (ITRHI)",
   label: "Reschigliano di Capodarsego (ITRHI)"
  },
  {
   value: "Retorbido (ITRBO)",
   label: "Retorbido (ITRBO)"
  },
  {
   value: "Revello (ITRVE)",
   label: "Revello (ITRVE)"
  },
  {
   value: "Revigliasco (ITRGL)",
   label: "Revigliasco (ITRGL)"
  },
  {
   value: "Revo (ITZSO)",
   label: "Revo (ITZSO)"
  },
  {
   value: "Riano (ITRIA)",
   label: "Riano (ITRIA)"
  },
  {
   value: "Ribera (ITZSA)",
   label: "Ribera (ITZSA)"
  },
  {
   value: "Riccio (ITRCO)",
   label: "Riccio (ITRCO)"
  },
  {
   value: "Riccione (ITRCE)",
   label: "Riccione (ITRCE)"
  },
  {
   value: "Riccò del Golfo di Spezia (ITRGS)",
   label: "Riccò del Golfo di Spezia (ITRGS)"
  },
  {
   value: "Ricengo (ITZRS)",
   label: "Ricengo (ITZRS)"
  },
  {
   value: "Rignano Flaminio (ITZRV)",
   label: "Rignano Flaminio (ITZRV)"
  },
  {
   value: "Rinella (ITRIN)",
   label: "Rinella (ITRIN)"
  },
  {
   value: "Riola (ITRIL)",
   label: "Riola (ITRIL)"
  },
  {
   value: "Riomaggiore (ITRMG)",
   label: "Riomaggiore (ITRMG)"
  },
  {
   value: "Ripalimosani (ITZSF)",
   label: "Ripalimosani (ITZSF)"
  },
  {
   value: "Ripalta Cremasca (ITRPL)",
   label: "Ripalta Cremasca (ITRPL)"
  },
  {
   value: "Ripe (ITRIP)",
   label: "Ripe (ITRIP)"
  },
  {
   value: "Riva Trigoso (ITRTS)",
   label: "Riva Trigoso (ITRTS)"
  },
  {
   value: "Rivalta Bormida (ITRIB)",
   label: "Rivalta Bormida (ITRIB)"
  },
  {
   value: "Rivalta di Torino (ITRDT)",
   label: "Rivalta di Torino (ITRDT)"
  },
  {
   value: "Rivanazzano (ITRZA)",
   label: "Rivanazzano (ITRZA)"
  },
  {
   value: "Rivara (ITZSQ)",
   label: "Rivara (ITZSQ)"
  },
  {
   value: "Rivarolo Mantovano (ITRMV)",
   label: "Rivarolo Mantovano (ITRMV)"
  },
  {
   value: "Rivarotta (ITRIR)",
   label: "Rivarotta (ITRIR)"
  },
  {
   value: "Roana (ITRAA)",
   label: "Roana (ITRAA)"
  },
  {
   value: "Roasio (ITZKN)",
   label: "Roasio (ITZKN)"
  },
  {
   value: "Robbio (ITROO)",
   label: "Robbio (ITROO)"
  },
  {
   value: "Robecchetto con Induno (ITRBD)",
   label: "Robecchetto con Induno (ITRBD)"
  },
  {
   value: "Robecco sul Naviglio (ITROB)",
   label: "Robecco sul Naviglio (ITROB)"
  },
  {
   value: "Rocca Canavese (ITROE)",
   label: "Rocca Canavese (ITROE)"
  },
  {
   value: "Rocca di Capri Leone (ITZPR)",
   label: "Rocca di Capri Leone (ITZPR)"
  },
  {
   value: "Rocca di Neto (ITOEC)",
   label: "Rocca di Neto (ITOEC)"
  },
  {
   value: "Rocca Grimalda (ITRGI)",
   label: "Rocca Grimalda (ITRGI)"
  },
  {
   value: "Rocca San Giovanni (ITRSG)",
   label: "Rocca San Giovanni (ITRSG)"
  },
  {
   value: "Roccabianca (ITRCN)",
   label: "Roccabianca (ITRCN)"
  },
  {
   value: "Roccafranca (ITZRT)",
   label: "Roccafranca (ITZRT)"
  },
  {
   value: "Roccamorice (ITRCR)",
   label: "Roccamorice (ITRCR)"
  },
  {
   value: "Roccapietra (ITRCP)",
   label: "Roccapietra (ITRCP)"
  },
  {
   value: "Roccarainola (ITRRA)",
   label: "Roccarainola (ITRRA)"
  },
  {
   value: "Roccasecca (ITRCC)",
   label: "Roccasecca (ITRCC)"
  },
  {
   value: "Roccastrada (ITZBI)",
   label: "Roccastrada (ITZBI)"
  },
  {
   value: "Roccella Ionica (ITROC)",
   label: "Roccella Ionica (ITROC)"
  },
  {
   value: "Rodano (ITRDN)",
   label: "Rodano (ITRDN)"
  },
  {
   value: "Rodengo (ITRDO)",
   label: "Rodengo (ITRDO)"
  },
  {
   value: "Rodengo Saiano (ITROA)",
   label: "Rodengo Saiano (ITROA)"
  },
  {
   value: "Roè Volcanico (ITRVC)",
   label: "Roè Volcanico (ITRVC)"
  },
  {
   value: "Rogolo (ITZRW)",
   label: "Rogolo (ITZRW)"
  },
  {
   value: "Rolo (ITZMR)",
   label: "Rolo (ITZMR)"
  },
  {
   value: "Romagnano Sesia (ITRMS)",
   label: "Romagnano Sesia (ITRMS)"
  },
  {
   value: "Romano Canavese (ITRMC)",
   label: "Romano Canavese (ITRMC)"
  },
  {
   value: "Romano di Lombardia (ITROL)",
   label: "Romano di Lombardia (ITROL)"
  },
  {
   value: "Romeno (ITZSC)",
   label: "Romeno (ITZSC)"
  },
  {
   value: "Romentino (ITRMT)",
   label: "Romentino (ITRMT)"
  },
  {
   value: "Rometta Marea (ITZSM)",
   label: "Rometta Marea (ITZSM)"
  },
  {
   value: "Ronago (ITRNO)",
   label: "Ronago (ITRNO)"
  },
  {
   value: "Ronca (ITONC)",
   label: "Ronca (ITONC)"
  },
  {
   value: "Roncello (ITRCL)",
   label: "Roncello (ITRCL)"
  },
  {
   value: "Ronchi dei Legionari (ITRDL)",
   label: "Ronchi dei Legionari (ITRDL)"
  },
  {
   value: "Ronchi di Cuneo (ITNEO)",
   label: "Ronchi di Cuneo (ITNEO)"
  },
  {
   value: "Ronco Briantino (ITRCB)",
   label: "Ronco Briantino (ITRCB)"
  },
  {
   value: "Ronco Scrivia (ITRSV)",
   label: "Ronco Scrivia (ITRSV)"
  },
  {
   value: "Roncoferraro (ITROF)",
   label: "Roncoferraro (ITROF)"
  },
  {
   value: "Roreto (ITRET)",
   label: "Roreto (ITRET)"
  },
  {
   value: "Roreto (ITROR)",
   label: "Roreto (ITROR)"
  },
  {
   value: "Roreto Chisone (ITRRE)",
   label: "Roreto Chisone (ITRRE)"
  },
  {
   value: "Rosali (ITZSI)",
   label: "Rosali (ITZSI)"
  },
  {
   value: "Rosarno (ITZSE)",
   label: "Rosarno (ITZSE)"
  },
  {
   value: "Rosignano Marittimo (ITRMO)",
   label: "Rosignano Marittimo (ITRMO)"
  },
  {
   value: "Rosignano Solvay (ITGSV)",
   label: "Rosignano Solvay (ITGSV)"
  },
  {
   value: "Rosolini (ITZSK)",
   label: "Rosolini (ITZSK)"
  },
  {
   value: "Rossana (ITZKF)",
   label: "Rossana (ITZKF)"
  },
  {
   value: "Rossano Veneto (ITRVT)",
   label: "Rossano Veneto (ITRVT)"
  },
  {
   value: "Rosta (ITRQT)",
   label: "Rosta (ITRQT)"
  },
  {
   value: "Rottofreno (ITRFO)",
   label: "Rottofreno (ITRFO)"
  },
  {
   value: "Rovagnate (ITRVG)",
   label: "Rovagnate (ITRVG)"
  },
  {
   value: "Rovasenda (ITRVS)",
   label: "Rovasenda (ITRVS)"
  },
  {
   value: "Rovato (ITROQ)",
   label: "Rovato (ITROQ)"
  },
  {
   value: "Rovellasca (ITRLS)",
   label: "Rovellasca (ITRLS)"
  },
  {
   value: "Rovello Porro (ITZBK)",
   label: "Rovello Porro (ITZBK)"
  },
  {
   value: "Roverbella (ITRBB)",
   label: "Roverbella (ITRBB)"
  },
  {
   value: "Rovere Veronese (ITZSP)",
   label: "Rovere Veronese (ITZSP)"
  },
  {
   value: "Roveredo in Piano (ITRPN)",
   label: "Roveredo in Piano (ITRPN)"
  },
  {
   value: "Rovereto sulla Secchia (ITRUS)",
   label: "Rovereto sulla Secchia (ITRUS)"
  },
  {
   value: "Rovigo (ITRVO)",
   label: "Rovigo (ITRVO)"
  },
  {
   value: "Rovolon (ITRVN)",
   label: "Rovolon (ITRVN)"
  },
  {
   value: "Rubano (ITRBA)",
   label: "Rubano (ITRBA)"
  },
  {
   value: "Rudiano (ITRUD)",
   label: "Rudiano (ITRUD)"
  },
  {
   value: "Russi (ITRSS)",
   label: "Russi (ITRSS)"
  },
  {
   value: "Ruvo del Monte (ITRDM)",
   label: "Ruvo del Monte (ITRDM)"
  },
  {
   value: "Ruvo di Puglia (ITZSB)",
   label: "Ruvo di Puglia (ITZSB)"
  },
  {
   value: "Sabbio Bergamasco (ITSBB)",
   label: "Sabbio Bergamasco (ITSBB)"
  },
  {
   value: "Sabbio Chiese (ITSBH)",
   label: "Sabbio Chiese (ITSBH)"
  },
  {
   value: "Saccolongo (ITSCQ)",
   label: "Saccolongo (ITSCQ)"
  },
  {
   value: "Sagliano Micca (ITSIM)",
   label: "Sagliano Micca (ITSIM)"
  },
  {
   value: "Saint Christophe (ITSCT)",
   label: "Saint Christophe (ITSCT)"
  },
  {
   value: "Sala Baganza (ITSBR)",
   label: "Sala Baganza (ITSBR)"
  },
  {
   value: "Sala Bolognese (ITSBE)",
   label: "Sala Bolognese (ITSBE)"
  },
  {
   value: "Sala Consilina (ITZSW)",
   label: "Sala Consilina (ITZSW)"
  },
  {
   value: "Salandra (ITZLI)",
   label: "Salandra (ITZLI)"
  },
  {
   value: "Sale Marasino (ITZTN)",
   label: "Sale Marasino (ITZTN)"
  },
  {
   value: "Salerano sul Lambro (ITSLM)",
   label: "Salerano sul Lambro (ITSLM)"
  },
  {
   value: "Saletto, Bologna (ITSTL)",
   label: "Saletto, Bologna (ITSTL)"
  },
  {
   value: "Saline di Volterra (ITSDI)",
   label: "Saline di Volterra (ITSDI)"
  },
  {
   value: "Saline, Reggio Calabria (ITSLC)",
   label: "Saline, Reggio Calabria (ITSLC)"
  },
  {
   value: "Salizzole (ITSLZ)",
   label: "Salizzole (ITSLZ)"
  },
  {
   value: "Salorno (ITSLN)",
   label: "Salorno (ITSLN)"
  },
  {
   value: "Salt (ITTTE)",
   label: "Salt (ITTTE)"
  },
  {
   value: "Saluggia (ITSIX)",
   label: "Saluggia (ITSIX)"
  },
  {
   value: "Saluzzo (ITZTM)",
   label: "Saluzzo (ITZTM)"
  },
  {
   value: "Salzano (ITSZO)",
   label: "Salzano (ITSZO)"
  },
  {
   value: "Samarate (ITSZE)",
   label: "Samarate (ITSZE)"
  },
  {
   value: "Samassi (ITAAI)",
   label: "Samassi (ITAAI)"
  },
  {
   value: "San Antonino (ITZBS)",
   label: "San Antonino (ITZBS)"
  },
  {
   value: "San Benedetto Po (ITZSU)",
   label: "San Benedetto Po (ITZSU)"
  },
  {
   value: "San Benedetto Val di Sambro (ITSBS)",
   label: "San Benedetto Val di Sambro (ITSBS)"
  },
  {
   value: "San Bernardino Verbano (ITSBV)",
   label: "San Bernardino Verbano (ITSBV)"
  },
  {
   value: "San Bernardo di Ivrea (ITZYM)",
   label: "San Bernardo di Ivrea (ITZYM)"
  },
  {
   value: "San Biagio di Callalta (ITBCL)",
   label: "San Biagio di Callalta (ITBCL)"
  },
  {
   value: "San Casciano dei Bagni (ITACB)",
   label: "San Casciano dei Bagni (ITACB)"
  },
  {
   value: "San Cataldo (ITNCT)",
   label: "San Cataldo (ITNCT)"
  },
  {
   value: "San Cesario di Lecce (ITSNC)",
   label: "San Cesario di Lecce (ITSNC)"
  },
  {
   value: "San Cesario sul Panaro (ITSCS)",
   label: "San Cesario sul Panaro (ITSCS)"
  },
  {
   value: "San Cipriano Po (ITSCN)",
   label: "San Cipriano Po (ITSCN)"
  },
  {
   value: "San Croce di Magliano (ITDIM)",
   label: "San Croce di Magliano (ITDIM)"
  },
  {
   value: "San Damaso (ITSDS)",
   label: "San Damaso (ITSDS)"
  },
  {
   value: "San Daniele del Friuli (ITSDF)",
   label: "San Daniele del Friuli (ITSDF)"
  },
  {
   value: "San Daniele Po (ITZSX)",
   label: "San Daniele Po (ITZSX)"
  },
  {
   value: "San Defendente (ITSDN)",
   label: "San Defendente (ITSDN)"
  },
  {
   value: "San Donato Milanese (ITSDE)",
   label: "San Donato Milanese (ITSDE)"
  },
  {
   value: "San Donnino (ITZYK)",
   label: "San Donnino (ITZYK)"
  },
  {
   value: "San Donnino di Liguria (ITZYP)",
   label: "San Donnino di Liguria (ITZYP)"
  },
  {
   value: "San Dorligo della Valle (ITZWT)",
   label: "San Dorligo della Valle (ITZWT)"
  },
  {
   value: "San Felice Circeo (ITSFE)",
   label: "San Felice Circeo (ITSFE)"
  },
  {
   value: "San Ferdinando (ITFDN)",
   label: "San Ferdinando (ITFDN)"
  },
  {
   value: "San Floriano (ITZEJ)",
   label: "San Floriano (ITZEJ)"
  },
  {
   value: "San Genesio (ITSGS)",
   label: "San Genesio (ITSGS)"
  },
  {
   value: "San Gennaro Vesuviano (ITGOV)",
   label: "San Gennaro Vesuviano (ITGOV)"
  },
  {
   value: "San Germano dei Berici (ITZJF)",
   label: "San Germano dei Berici (ITZJF)"
  },
  {
   value: "San Giacomo di Veglia (ITZYO)",
   label: "San Giacomo di Veglia (ITZYO)"
  },
  {
   value: "San Gillio (ITIIO)",
   label: "San Gillio (ITIIO)"
  },
  {
   value: "San Gimignano (ITZSS)",
   label: "San Gimignano (ITZSS)"
  },
  {
   value: "San Giorgio (ITSXG)",
   label: "San Giorgio (ITSXG)"
  },
  {
   value: "San Giorgio a Colonica (ITZTE)",
   label: "San Giorgio a Colonica (ITZTE)"
  },
  {
   value: "San Giorgio Canavese (ITEON)",
   label: "San Giorgio Canavese (ITEON)"
  },
  {
   value: "San Giorgio Canavese (ITGCV)",
   label: "San Giorgio Canavese (ITGCV)"
  },
  {
   value: "San Giorgio del Sannio (ITSNG)",
   label: "San Giorgio del Sannio (ITSNG)"
  },
  {
   value: "San Giorgio della Richinvelda (ITZKB)",
   label: "San Giorgio della Richinvelda (ITZKB)"
  },
  {
   value: "San Giorgio delle Pertiche (ITSLX)",
   label: "San Giorgio delle Pertiche (ITSLX)"
  },
  {
   value: "San Giorgio di Mantova (ITSAA)",
   label: "San Giorgio di Mantova (ITSAA)"
  },
  {
   value: "San Giorgio in Bosco (ITSIB)",
   label: "San Giorgio in Bosco (ITSIB)"
  },
  {
   value: "San Giorgio La Molara (ITSGQ)",
   label: "San Giorgio La Molara (ITSGQ)"
  },
  {
   value: "San Giorgio Monferrato (ITGMR)",
   label: "San Giorgio Monferrato (ITGMR)"
  },
  {
   value: "San Giorgio Piacentino (ITZJP)",
   label: "San Giorgio Piacentino (ITZJP)"
  },
  {
   value: "San Giorgio su Legnano (ITSSE)",
   label: "San Giorgio su Legnano (ITSSE)"
  },
  {
   value: "San Giovanni (ITSAQ)",
   label: "San Giovanni (ITSAQ)"
  },
  {
   value: "San Giovanni (ITSGC)",
   label: "San Giovanni (ITSGC)"
  },
  {
   value: "San Giovanni di Ostellato (ITZLE)",
   label: "San Giovanni di Ostellato (ITZLE)"
  },
  {
   value: "San Giovanni in Croce (ITGVC)",
   label: "San Giovanni in Croce (ITGVC)"
  },
  {
   value: "San Giovanni in Marignano (ITSGM)",
   label: "San Giovanni in Marignano (ITSGM)"
  },
  {
   value: "San Giovanni la Punta (ITLPT)",
   label: "San Giovanni la Punta (ITLPT)"
  },
  {
   value: "San Giovanni Reatino (ITSGA)",
   label: "San Giovanni Reatino (ITSGA)"
  },
  {
   value: "San Giovanni Teatino (ITVVI)",
   label: "San Giovanni Teatino (ITVVI)"
  },
  {
   value: "San Giuliano Terme (ITSGT)",
   label: "San Giuliano Terme (ITSGT)"
  },
  {
   value: "San Giuseppe di Cairo (ITZTF)",
   label: "San Giuseppe di Cairo (ITZTF)"
  },
  {
   value: "San Giuseppe Vesuviano (ITZUU)",
   label: "San Giuseppe Vesuviano (ITZUU)"
  },
  {
   value: "San Giustina in Colle (ITIUS)",
   label: "San Giustina in Colle (ITIUS)"
  },
  {
   value: "San Leo (ITZUX)",
   label: "San Leo (ITZUX)"
  },
  {
   value: "San Leo di Pellaro (ITZYQ)",
   label: "San Leo di Pellaro (ITZYQ)"
  },
  {
   value: "San Lorenzo di Sebato (ITRZT)",
   label: "San Lorenzo di Sebato (ITRZT)"
  },
  {
   value: "San Macario (ITANM)",
   label: "San Macario (ITANM)"
  },
  {
   value: "San Marcel (ITCLM)",
   label: "San Marcel (ITCLM)"
  },
  {
   value: "San Marco dei Cavoti (ITSMH)",
   label: "San Marco dei Cavoti (ITSMH)"
  },
  {
   value: "San Marco Evangelista (ITZTT)",
   label: "San Marco Evangelista (ITZTT)"
  },
  {
   value: "San Marco in Lamis (ITLMS)",
   label: "San Marco in Lamis (ITLMS)"
  },
  {
   value: "San Marino (ITSNN)",
   label: "San Marino (ITSNN)"
  },
  {
   value: "San Martino (ITNMO)",
   label: "San Martino (ITNMO)"
  },
  {
   value: "San Martino Alfieri (ITSMF)",
   label: "San Martino Alfieri (ITSMF)"
  },
  {
   value: "San Martino Buon Albergo (ITMBA)",
   label: "San Martino Buon Albergo (ITMBA)"
  },
  {
   value: "San Martino della Battaglia (ITSOD)",
   label: "San Martino della Battaglia (ITSOD)"
  },
  {
   value: "San Martino di Trecate (ITAMD)",
   label: "San Martino di Trecate (ITAMD)"
  },
  {
   value: "San Martino in Rio (ITSRM)",
   label: "San Martino in Rio (ITSRM)"
  },
  {
   value: "San Martino in Strada (ITSSD)",
   label: "San Martino in Strada (ITSSD)"
  },
  {
   value: "San Martino Siccomario (ITZTQ)",
   label: "San Martino Siccomario (ITZTQ)"
  },
  {
   value: "San Martino sulla Marruccina (ITSXM)",
   label: "San Martino sulla Marruccina (ITSXM)"
  },
  {
   value: "San Marzano di San Giuseppe (ITZOE)",
   label: "San Marzano di San Giuseppe (ITZOE)"
  },
  {
   value: "San Marzano Oliveto (ITMOV)",
   label: "San Marzano Oliveto (ITMOV)"
  },
  {
   value: "San Matteo della Decima (ITSDD)",
   label: "San Matteo della Decima (ITSDD)"
  },
  {
   value: "San Maurizio Canavese (ITSMV)",
   label: "San Maurizio Canavese (ITSMV)"
  },
  {
   value: "San Mauro Pascoli (ITZTS)",
   label: "San Mauro Pascoli (ITZTS)"
  },
  {
   value: "San Mauro Torinese (ITSMO)",
   label: "San Mauro Torinese (ITSMO)"
  },
  {
   value: "San Michele di Serino (ITZAH)",
   label: "San Michele di Serino (ITZAH)"
  },
  {
   value: "San Michele, Alessandria (ITSNM)",
   label: "San Michele, Alessandria (ITSNM)"
  },
  {
   value: "San Nazario (ITZOS)",
   label: "San Nazario (ITZOS)"
  },
  {
   value: "San Nicola (ITMLF)",
   label: "San Nicola (ITMLF)"
  },
  {
   value: "San Nicola Manfredi (ITSNI)",
   label: "San Nicola Manfredi (ITSNI)"
  },
  {
   value: "San Nicolo a Trebbia (ITSNT)",
   label: "San Nicolo a Trebbia (ITSNT)"
  },
  {
   value: "San Nicolo Tordino (ITZTW)",
   label: "San Nicolo Tordino (ITZTW)"
  },
  {
   value: "San Paolo (ITSPX)",
   label: "San Paolo (ITSPX)"
  },
  {
   value: "San Paolo Solbrito (ITSPU)",
   label: "San Paolo Solbrito (ITSPU)"
  },
  {
   value: "San Pellegrino Terme (ITSPT)",
   label: "San Pellegrino Terme (ITSPT)"
  },
  {
   value: "San Piero in Bagno (ITSPB)",
   label: "San Piero in Bagno (ITSPB)"
  },
  {
   value: "San Pietro a Sieve (ITSSV)",
   label: "San Pietro a Sieve (ITSSV)"
  },
  {
   value: "San Pietro al Natione (ITPIQ)",
   label: "San Pietro al Natione (ITPIQ)"
  },
  {
   value: "San Pietro Clarenza (ITZPP)",
   label: "San Pietro Clarenza (ITZPP)"
  },
  {
   value: "San Pietro di Feletto (ITSVP)",
   label: "San Pietro di Feletto (ITSVP)"
  },
  {
   value: "San Pietro di Legnago (ITSAP)",
   label: "San Pietro di Legnago (ITSAP)"
  },
  {
   value: "San Pietro di Morubio (ITSRB)",
   label: "San Pietro di Morubio (ITSRB)"
  },
  {
   value: "San Pietro in Cariano (ITIOC)",
   label: "San Pietro in Cariano (ITIOC)"
  },
  {
   value: "San Pietro in Gù (ITZUE)",
   label: "San Pietro in Gù (ITZUE)"
  },
  {
   value: "San Pietro in Vincoli (ITZUJ)",
   label: "San Pietro in Vincoli (ITZUJ)"
  },
  {
   value: "San Pietro Mosezzo (ITSOM)",
   label: "San Pietro Mosezzo (ITSOM)"
  },
  {
   value: "San Pietro Viminario (ITSPV)",
   label: "San Pietro Viminario (ITSPV)"
  },
  {
   value: "San Polo Matese (ITPMT)",
   label: "San Polo Matese (ITPMT)"
  },
  {
   value: "San Prospero (ITSPQ)",
   label: "San Prospero (ITSPQ)"
  },
  {
   value: "San Prospero Parmense (ITPPM)",
   label: "San Prospero Parmense (ITPPM)"
  },
  {
   value: "San Quirino (ITSQN)",
   label: "San Quirino (ITSQN)"
  },
  {
   value: "San Rocco Castagnaretta (ITSRA)",
   label: "San Rocco Castagnaretta (ITSRA)"
  },
  {
   value: "San Rocco di Piegara (ITSRP)",
   label: "San Rocco di Piegara (ITSRP)"
  },
  {
   value: "San Salvatore Monferrato (ITZUO)",
   label: "San Salvatore Monferrato (ITZUO)"
  },
  {
   value: "San Sebastiano al Vesuvio (ITZBL)",
   label: "San Sebastiano al Vesuvio (ITZBL)"
  },
  {
   value: "San Secondo di Pinerolo (ITSAD)",
   label: "San Secondo di Pinerolo (ITSAD)"
  },
  {
   value: "San Secondo Parmense (ITSRS)",
   label: "San Secondo Parmense (ITSRS)"
  },
  {
   value: "San Severino Marche (ITZTU)",
   label: "San Severino Marche (ITZTU)"
  },
  {
   value: "San Tomio di Malo (ITSTD)",
   label: "San Tomio di Malo (ITSTD)"
  },
  {
   value: "San Valentino Torio (ITSVR)",
   label: "San Valentino Torio (ITSVR)"
  },
  {
   value: "San Vigilio (ITSVG)",
   label: "San Vigilio (ITSVG)"
  },
  {
   value: "San Vincenzo di Galliera (ITZYS)",
   label: "San Vincenzo di Galliera (ITZYS)"
  },
  {
   value: "San Vito (ITNVI)",
   label: "San Vito (ITNVI)"
  },
  {
   value: "San Vito (ITSVX)",
   label: "San Vito (ITSVX)"
  },
  {
   value: "San Vito al Torre (ITVTL)",
   label: "San Vito al Torre (ITVTL)"
  },
  {
   value: "San Vittore del Lazio (ITSVF)",
   label: "San Vittore del Lazio (ITSVF)"
  },
  {
   value: "San Vittore Olona (ITVRO)",
   label: "San Vittore Olona (ITVRO)"
  },
  {
   value: "San Zeno (ITSXO)",
   label: "San Zeno (ITSXO)"
  },
  {
   value: "San Zenone al Lambro (ITZXK)",
   label: "San Zenone al Lambro (ITZXK)"
  },
  {
   value: "San Zenone degli Ezzelini (ITSDZ)",
   label: "San Zenone degli Ezzelini (ITSDZ)"
  },
  {
   value: "San Zenone di Ezzelin (ITZBD)",
   label: "San Zenone di Ezzelin (ITZBD)"
  },
  {
   value: "Sanguinetto (ITSNU)",
   label: "Sanguinetto (ITSNU)"
  },
  {
   value: "Sannicandro di Bari (ITZTV)",
   label: "Sannicandro di Bari (ITZTV)"
  },
  {
   value: "Sansan Giovanni Gemini (ITSGX)",
   label: "Sansan Giovanni Gemini (ITSGX)"
  },
  {
   value: "Sansepolcro (ITSSC)",
   label: "Sansepolcro (ITSSC)"
  },
  {
   value: "Sant Angelo dei Lombardi (ITZTB)",
   label: "Sant Angelo dei Lombardi (ITZTB)"
  },
  {
   value: "Sant Antonio di Pontecagnano (ITADP)",
   label: "Sant Antonio di Pontecagnano (ITADP)"
  },
  {
   value: "Sant Ippolito (ITZUI)",
   label: "Sant Ippolito (ITZUI)"
  },
  {
   value: "Sant Omero (ITZJM)",
   label: "Sant Omero (ITZJM)"
  },
  {
   value: "Santa Cristina e Bissone (ITSCB)",
   label: "Santa Cristina e Bissone (ITSCB)"
  },
  {
   value: "Santa Croce Del Sannio (ITSCX)",
   label: "Santa Croce Del Sannio (ITSCX)"
  },
  {
   value: "Santa Domenica Talao (ITZXD)",
   label: "Santa Domenica Talao (ITZXD)"
  },
  {
   value: "Santa Flavia (ITSFL)",
   label: "Santa Flavia (ITSFL)"
  },
  {
   value: "Santa Foca di Melendugno (ITSFM)",
   label: "Santa Foca di Melendugno (ITSFM)"
  },
  {
   value: "Santa Giuletta (ITGIL)",
   label: "Santa Giuletta (ITGIL)"
  },
  {
   value: "Santa Giusta (ITZTG)",
   label: "Santa Giusta (ITZTG)"
  },
  {
   value: "Santa Giustina (ITZWX)",
   label: "Santa Giustina (ITZWX)"
  },
  {
   value: "Santa Giustina Bellunese (ITSBU)",
   label: "Santa Giustina Bellunese (ITSBU)"
  },
  {
   value: "Santa Giustina in Colle (ITTUT)",
   label: "Santa Giustina in Colle (ITTUT)"
  },
  {
   value: "Santa Lucia di Piave (ITSLD)",
   label: "Santa Lucia di Piave (ITSLD)"
  },
  {
   value: "Santa Margherita di Belice (ITSMQ)",
   label: "Santa Margherita di Belice (ITSMQ)"
  },
  {
   value: "Santa Maria a Monte (ITSAH)",
   label: "Santa Maria a Monte (ITSAH)"
  },
  {
   value: "Santa Maria Codifiume (ITSMZ)",
   label: "Santa Maria Codifiume (ITSMZ)"
  },
  {
   value: "Santa Maria degli Angeli (ITSME)",
   label: "Santa Maria degli Angeli (ITSME)"
  },
  {
   value: "Santa Maria della Versa (ITSVS)",
   label: "Santa Maria della Versa (ITSVS)"
  },
  {
   value: "Santa Maria di Castellabate (ITSMK)",
   label: "Santa Maria di Castellabate (ITSMK)"
  },
  {
   value: "Santa Maria in Fabriago (ITSFB)",
   label: "Santa Maria in Fabriago (ITSFB)"
  },
  {
   value: "Santa Maria Maddalena (ITMDN)",
   label: "Santa Maria Maddalena (ITMDN)"
  },
  {
   value: "Santa Maria Navarrese (ITAMN)",
   label: "Santa Maria Navarrese (ITAMN)"
  },
  {
   value: "Santa Palomba (ITPBA)",
   label: "Santa Palomba (ITPBA)"
  },
  {
   value: "Santa Venerina (ITZAU)",
   label: "Santa Venerina (ITZAU)"
  },
  {
   value: "Santa Vittoria (ITITT)",
   label: "Santa Vittoria (ITITT)"
  },
  {
   value: "Santadi (ITZTH)",
   label: "Santadi (ITZTH)"
  },
  {
   value: "Santena (ITSNE)",
   label: "Santena (ITSNE)"
  },
  {
   value: "Santhià (ITSHA)",
   label: "Santhià (ITSHA)"
  },
  {
   value: "Santi Cosma e Damiano (ITDAM)",
   label: "Santi Cosma e Damiano (ITDAM)"
  },
  {
   value: "Santo Stefano al Mare (ITSSF)",
   label: "Santo Stefano al Mare (ITSSF)"
  },
  {
   value: "Santo Stefano di Camastra (ITTEF)",
   label: "Santo Stefano di Camastra (ITTEF)"
  },
  {
   value: "Santo Stefano di Zimella (ITZYN)",
   label: "Santo Stefano di Zimella (ITZYN)"
  },
  {
   value: "Santo Stefano Ticino (ITSFC)",
   label: "Santo Stefano Ticino (ITSFC)"
  },
  {
   value: "Santo Stino di Livenza (ITSXD)",
   label: "Santo Stino di Livenza (ITSXD)"
  },
  {
   value: "Santorso (ITSQO)",
   label: "Santorso (ITSQO)"
  },
  {
   value: "Saonara (ITAON)",
   label: "Saonara (ITAON)"
  },
  {
   value: "Sapri (ITPRH)",
   label: "Sapri (ITPRH)"
  },
  {
   value: "Sarezzo (ITEZO)",
   label: "Sarezzo (ITEZO)"
  },
  {
   value: "Sarmato (ITARM)",
   label: "Sarmato (ITARM)"
  },
  {
   value: "Sarnano (ITRNN)",
   label: "Sarnano (ITRNN)"
  },
  {
   value: "Sarnico (ITSRI)",
   label: "Sarnico (ITSRI)"
  },
  {
   value: "Sarno (ITSRO)",
   label: "Sarno (ITSRO)"
  },
  {
   value: "Sarzana (ITSAZ)",
   label: "Sarzana (ITSAZ)"
  },
  {
   value: "Sassocorvaro (ITASV)",
   label: "Sassocorvaro (ITASV)"
  },
  {
   value: "Sassoferrato (ITSFO)",
   label: "Sassoferrato (ITSFO)"
  },
  {
   value: "Sava (ITTAS)",
   label: "Sava (ITTAS)"
  },
  {
   value: "Savelletri (ITLLT)",
   label: "Savelletri (ITLLT)"
  },
  {
   value: "Savigliano (ITIGL)",
   label: "Savigliano (ITIGL)"
  },
  {
   value: "Savignano sul Rubicone (ITSSR)",
   label: "Savignano sul Rubicone (ITSSR)"
  },
  {
   value: "Scafati (ITSCF)",
   label: "Scafati (ITSCF)"
  },
  {
   value: "Scalea (ITLEA)",
   label: "Scalea (ITLEA)"
  },
  {
   value: "Scalenghe (ITSLH)",
   label: "Scalenghe (ITSLH)"
  },
  {
   value: "Scandicci (ITSCC)",
   label: "Scandicci (ITSCC)"
  },
  {
   value: "Scandolara Ravara (ITSCV)",
   label: "Scandolara Ravara (ITSCV)"
  },
  {
   value: "Scanzorosciate (ITSZT)",
   label: "Scanzorosciate (ITSZT)"
  },
  {
   value: "Scario (ITSRH)",
   label: "Scario (ITSRH)"
  },
  {
   value: "Scarlino (ITSRL)",
   label: "Scarlino (ITSRL)"
  },
  {
   value: "Scarmagno (ITRAG)",
   label: "Scarmagno (ITRAG)"
  },
  {
   value: "Scarperia (ITSIC)",
   label: "Scarperia (ITSIC)"
  },
  {
   value: "Scarzara (ITSCU)",
   label: "Scarzara (ITSCU)"
  },
  {
   value: "Scauri (ITURI)",
   label: "Scauri (ITURI)"
  },
  {
   value: "Scauri Alto (ITURC)",
   label: "Scauri Alto (ITURC)"
  },
  {
   value: "Scerne di Pineto (ITSIP)",
   label: "Scerne di Pineto (ITSIP)"
  },
  {
   value: "Schianno (ITSHO)",
   label: "Schianno (ITSHO)"
  },
  {
   value: "Schieti (ITSHI)",
   label: "Schieti (ITSHI)"
  },
  {
   value: "Sciacca (ITSCK)",
   label: "Sciacca (ITSCK)"
  },
  {
   value: "Scoppito (ITZUD)",
   label: "Scoppito (ITZUD)"
  },
  {
   value: "Scordia (ITZTA)",
   label: "Scordia (ITZTA)"
  },
  {
   value: "Scorzè (ITSCZ)",
   label: "Scorzè (ITSCZ)"
  },
  {
   value: "Scurelle (ITTNS)",
   label: "Scurelle (ITTNS)"
  },
  {
   value: "Sedegliano (ITUDS)",
   label: "Sedegliano (ITUDS)"
  },
  {
   value: "Sedico (ITSDO)",
   label: "Sedico (ITSDO)"
  },
  {
   value: "Sedriano (ITSED)",
   label: "Sedriano (ITSED)"
  },
  {
   value: "Sega di Cavajon (ITZYR)",
   label: "Sega di Cavajon (ITZYR)"
  },
  {
   value: "Selargius (ITZTD)",
   label: "Selargius (ITZTD)"
  },
  {
   value: "Sellero (ITSLE)",
   label: "Sellero (ITSLE)"
  },
  {
   value: "Selvatelle (ITSVY)",
   label: "Selvatelle (ITSVY)"
  },
  {
   value: "Selvazzano Dentro (ITSZZ)",
   label: "Selvazzano Dentro (ITSZZ)"
  },
  {
   value: "Senago (ITSEN)",
   label: "Senago (ITSEN)"
  },
  {
   value: "Seniga (ITZHW)",
   label: "Seniga (ITZHW)"
  },
  {
   value: "Senigallia (ITSEG)",
   label: "Senigallia (ITSEG)"
  },
  {
   value: "Senna Comasco (ITZPJ)",
   label: "Senna Comasco (ITZPJ)"
  },
  {
   value: "Sepino (ITSEO)",
   label: "Sepino (ITSEO)"
  },
  {
   value: "Seravezza (ITSVZ)",
   label: "Seravezza (ITSVZ)"
  },
  {
   value: "Sermide (ITSYD)",
   label: "Sermide (ITSYD)"
  },
  {
   value: "Sermoneta (ITETA)",
   label: "Sermoneta (ITETA)"
  },
  {
   value: "Sernaglia della Battaglia (ITVSD)",
   label: "Sernaglia della Battaglia (ITVSD)"
  },
  {
   value: "Serra Riccò (ITRRC)",
   label: "Serra Riccò (ITRRC)"
  },
  {
   value: "Serra San Quirico (ITZUQ)",
   label: "Serra San Quirico (ITZUQ)"
  },
  {
   value: "Serramanna (ITSEM)",
   label: "Serramanna (ITSEM)"
  },
  {
   value: "Serramazzoni (ITZUY)",
   label: "Serramazzoni (ITZUY)"
  },
  {
   value: "Serrano (ITRES)",
   label: "Serrano (ITRES)"
  },
  {
   value: "Serravalle (ITSVA)",
   label: "Serravalle (ITSVA)"
  },
  {
   value: "Serravalle Pistoiese (ITSEI)",
   label: "Serravalle Pistoiese (ITSEI)"
  },
  {
   value: "Serravalle Sesia (ITZTC)",
   label: "Serravalle Sesia (ITZTC)"
  },
  {
   value: "Serre di Rapolano (ITZTK)",
   label: "Serre di Rapolano (ITZTK)"
  },
  {
   value: "Sesso (ITSSS)",
   label: "Sesso (ITSSS)"
  },
  {
   value: "Sesto Imolese (ITSIE)",
   label: "Sesto Imolese (ITSIE)"
  },
  {
   value: "Sesto Ulteriano (ITSUL)",
   label: "Sesto Ulteriano (ITSUL)"
  },
  {
   value: "Sestri Levante (ITNTE)",
   label: "Sestri Levante (ITNTE)"
  },
  {
   value: "Settala (ITTLA)",
   label: "Settala (ITTLA)"
  },
  {
   value: "Settimo (ITSTM)",
   label: "Settimo (ITSTM)"
  },
  {
   value: "Settimo di Pescantina (ITSEP)",
   label: "Settimo di Pescantina (ITSEP)"
  },
  {
   value: "Sezzadio (ITSZD)",
   label: "Sezzadio (ITSZD)"
  },
  {
   value: "Sezze (ITSEZ)",
   label: "Sezze (ITSEZ)"
  },
  {
   value: "Sferracavallo (ITRRV)",
   label: "Sferracavallo (ITRRV)"
  },
  {
   value: "Siano (ITSIO)",
   label: "Siano (ITSIO)"
  },
  {
   value: "Sibari (ITZBF)",
   label: "Sibari (ITZBF)"
  },
  {
   value: "Sieci (ITSII)",
   label: "Sieci (ITSII)"
  },
  {
   value: "Signa (ITZTX)",
   label: "Signa (ITZTX)"
  },
  {
   value: "Signoressa (ITEVI)",
   label: "Signoressa (ITEVI)"
  },
  {
   value: "Silea (ITSEA)",
   label: "Silea (ITSEA)"
  },
  {
   value: "Siliqua (ITZUK)",
   label: "Siliqua (ITZUK)"
  },
  {
   value: "Silvi Marina (ITSLV)",
   label: "Silvi Marina (ITSLV)"
  },
  {
   value: "Sinalunga (ITSNL)",
   label: "Sinalunga (ITSNL)"
  },
  {
   value: "Siniscola (ITSIA)",
   label: "Siniscola (ITSIA)"
  },
  {
   value: "Sirmione (ITZTI)",
   label: "Sirmione (ITZTI)"
  },
  {
   value: "Sirone (ITIRO)",
   label: "Sirone (ITIRO)"
  },
  {
   value: "Sirtori (ITSRT)",
   label: "Sirtori (ITSRT)"
  },
  {
   value: "Sìsini (ITSSI)",
   label: "Sìsini (ITSSI)"
  },
  {
   value: "Sissa (ITSIS)",
   label: "Sissa (ITSIS)"
  },
  {
   value: "Siziano (ITSZI)",
   label: "Siziano (ITSZI)"
  },
  {
   value: "Sizzano (ITZZO)",
   label: "Sizzano (ITZZO)"
  },
  {
   value: "Soave (ITSOV)",
   label: "Soave (ITSOV)"
  },
  {
   value: "Soci (ITSQI)",
   label: "Soci (ITSQI)"
  },
  {
   value: "Solagna (ITZTY)",
   label: "Solagna (ITZTY)"
  },
  {
   value: "Solarolo (ITZTL)",
   label: "Solarolo (ITZTL)"
  },
  {
   value: "Solesino (ITSOI)",
   label: "Solesino (ITSOI)"
  },
  {
   value: "Soleto (ITSOE)",
   label: "Soleto (ITSOE)"
  },
  {
   value: "Solferino (ITZUB)",
   label: "Solferino (ITZUB)"
  },
  {
   value: "Soliera (ITOLR)",
   label: "Soliera (ITOLR)"
  },
  {
   value: "Solza (ITSOZ)",
   label: "Solza (ITSOZ)"
  },
  {
   value: "Somaglia (ITSOG)",
   label: "Somaglia (ITSOG)"
  },
  {
   value: "Somma Lombardo (ITSMB)",
   label: "Somma Lombardo (ITSMB)"
  },
  {
   value: "Somma Vesuviana (ITSVV)",
   label: "Somma Vesuviana (ITSVV)"
  },
  {
   value: "Sommariva del Bosco (ITSIV)",
   label: "Sommariva del Bosco (ITSIV)"
  },
  {
   value: "Sommatino (ITZTJ)",
   label: "Sommatino (ITZTJ)"
  },
  {
   value: "Sona (ITSNY)",
   label: "Sona (ITSNY)"
  },
  {
   value: "Songavazzo (ITSNW)",
   label: "Songavazzo (ITSNW)"
  },
  {
   value: "Sora (ITRAO)",
   label: "Sora (ITRAO)"
  },
  {
   value: "Soragna (ITSOX)",
   label: "Soragna (ITSOX)"
  },
  {
   value: "Sorbara (ITZUL)",
   label: "Sorbara (ITZUL)"
  },
  {
   value: "Soriano nel Cimino (ITSOC)",
   label: "Soriano nel Cimino (ITSOC)"
  },
  {
   value: "Sospiro (ITSPO)",
   label: "Sospiro (ITSPO)"
  },
  {
   value: "Sospirolo (ITZUC)",
   label: "Sospirolo (ITZUC)"
  },
  {
   value: "Sovere (ITOVR)",
   label: "Sovere (ITOVR)"
  },
  {
   value: "Sovico (ITSVB)",
   label: "Sovico (ITSVB)"
  },
  {
   value: "Sovigliana (ITOVG)",
   label: "Sovigliana (ITOVG)"
  },
  {
   value: "Sovizzo (ITOVZ)",
   label: "Sovizzo (ITOVZ)"
  },
  {
   value: "Sparanise (ITZUN)",
   label: "Sparanise (ITZUN)"
  },
  {
   value: "Specchia (ITSPH)",
   label: "Specchia (ITSPH)"
  },
  {
   value: "Sperlonga (ITNGA)",
   label: "Sperlonga (ITNGA)"
  },
  {
   value: "Spezzano (ITZPZ)",
   label: "Spezzano (ITZPZ)"
  },
  {
   value: "Spigno Monferrato (ITSMT)",
   label: "Spigno Monferrato (ITSMT)"
  },
  {
   value: "Spinazzola (ITSNZ)",
   label: "Spinazzola (ITSNZ)"
  },
  {
   value: "Spinea (ITZUF)",
   label: "Spinea (ITZUF)"
  },
  {
   value: "Spineto (ITSP2)",
   label: "Spineto (ITSP2)"
  },
  {
   value: "Spinetoli (ITTLI)",
   label: "Spinetoli (ITTLI)"
  },
  {
   value: "Spinetta Marengo (ITETT)",
   label: "Spinetta Marengo (ITETT)"
  },
  {
   value: "Spirano (ITESP)",
   label: "Spirano (ITESP)"
  },
  {
   value: "Spoltore (ITSPR)",
   label: "Spoltore (ITSPR)"
  },
  {
   value: "Spotorno (ITRNS)",
   label: "Spotorno (ITRNS)"
  },
  {
   value: "Spresiano (ITZUH)",
   label: "Spresiano (ITZUH)"
  },
  {
   value: "Squinzano (ITSQZ)",
   label: "Squinzano (ITSQZ)"
  },
  {
   value: "Stallavena (ITSVE)",
   label: "Stallavena (ITSVE)"
  },
  {
   value: "Stanghella (ITSHL)",
   label: "Stanghella (ITSHL)"
  },
  {
   value: "Stella (ITZRC)",
   label: "Stella (ITZRC)"
  },
  {
   value: "Stenico (ITSTP)",
   label: "Stenico (ITSTP)"
  },
  {
   value: "Stezzano (ITSTZ)",
   label: "Stezzano (ITSTZ)"
  },
  {
   value: "Stintino (ITTTN)",
   label: "Stintino (ITTTN)"
  },
  {
   value: "Stornarella (ITZUR)",
   label: "Stornarella (ITZUR)"
  },
  {
   value: "Storo (ITZUT)",
   label: "Storo (ITZUT)"
  },
  {
   value: "Stradella (ITZUS)",
   label: "Stradella (ITZUS)"
  },
  {
   value: "Stresa (ITSTS)",
   label: "Stresa (ITSTS)"
  },
  {
   value: "Strona (ITRNA)",
   label: "Strona (ITRNA)"
  },
  {
   value: "Strozza (ITSRZ)",
   label: "Strozza (ITSRZ)"
  },
  {
   value: "Subbiano (ITZSY)",
   label: "Subbiano (ITZSY)"
  },
  {
   value: "Succivo (ITUCC)",
   label: "Succivo (ITUCC)"
  },
  {
   value: "Suisio (ITSUI)",
   label: "Suisio (ITSUI)"
  },
  {
   value: "Suisio (ITUSO)",
   label: "Suisio (ITUSO)"
  },
  {
   value: "Sulmona (ITSLP)",
   label: "Sulmona (ITSLP)"
  },
  {
   value: "Sumirago (ITSUR)",
   label: "Sumirago (ITSUR)"
  },
  {
   value: "Summaga (ITZRL)",
   label: "Summaga (ITZRL)"
  },
  {
   value: "Susa (ITSUA)",
   label: "Susa (ITSUA)"
  },
  {
   value: "Sustinente (ITSUT)",
   label: "Sustinente (ITSUT)"
  },
  {
   value: "Sustinenza (ITASN)",
   label: "Sustinenza (ITASN)"
  },
  {
   value: "Suvereto (ITZUW)",
   label: "Suvereto (ITZUW)"
  },
  {
   value: "Tabina (ITTBN)",
   label: "Tabina (ITTBN)"
  },
  {
   value: "Taggia (ITTGA)",
   label: "Taggia (ITTGA)"
  },
  {
   value: "Taino (ITTXN)",
   label: "Taino (ITTXN)"
  },
  {
   value: "Talacchio (ITZVE)",
   label: "Talacchio (ITZVE)"
  },
  {
   value: "Talamona (ITTMA)",
   label: "Talamona (ITTMA)"
  },
  {
   value: "Tamai (ITZAV)",
   label: "Tamai (ITZAV)"
  },
  {
   value: "Taormina (ITTAO)",
   label: "Taormina (ITTAO)"
  },
  {
   value: "Tarcento (ITTCT)",
   label: "Tarcento (ITTCT)"
  },
  {
   value: "Tarquinia (ITTRQ)",
   label: "Tarquinia (ITTRQ)"
  },
  {
   value: "Tarvisio (ITTVS)",
   label: "Tarvisio (ITTVS)"
  },
  {
   value: "Tarzo (ITTZO)",
   label: "Tarzo (ITTZO)"
  },
  {
   value: "Tauriano (ITAUT)",
   label: "Tauriano (ITAUT)"
  },
  {
   value: "Taurianova (ITTUV)",
   label: "Taurianova (ITTUV)"
  },
  {
   value: "Tavagnacco (ITTGC)",
   label: "Tavagnacco (ITTGC)"
  },
  {
   value: "Tavarnelle val di Pesa (ITTVD)",
   label: "Tavarnelle val di Pesa (ITTVD)"
  },
  {
   value: "Tavazzano (ITZVR)",
   label: "Tavazzano (ITZVR)"
  },
  {
   value: "Taverna (ITZVB)",
   label: "Taverna (ITZVB)"
  },
  {
   value: "Tavernelle Vicentina-Altavilla Vicentina (ITTEV)",
   label: "Tavernelle Vicentina-Altavilla Vicentina (ITTEV)"
  },
  {
   value: "Tavernerio (ITTVR)",
   label: "Tavernerio (ITTVR)"
  },
  {
   value: "Tavullia (ITTVU)",
   label: "Tavullia (ITTVU)"
  },
  {
   value: "Telese (ITTLS)",
   label: "Telese (ITTLS)"
  },
  {
   value: "Tempio Pausania (ITZVH)",
   label: "Tempio Pausania (ITZVH)"
  },
  {
   value: "Terlano (ITZKL)",
   label: "Terlano (ITZKL)"
  },
  {
   value: "Terlizzi (ITZIP)",
   label: "Terlizzi (ITZIP)"
  },
  {
   value: "Terme Vigliatore (ITZVP)",
   label: "Terme Vigliatore (ITZVP)"
  },
  {
   value: "Termeno (ITENM)",
   label: "Termeno (ITENM)"
  },
  {
   value: "Ternate (ITTNT)",
   label: "Ternate (ITTNT)"
  },
  {
   value: "Terontola (ITTNA)",
   label: "Terontola (ITTNA)"
  },
  {
   value: "Terranova dei Passerini (ITTPR)",
   label: "Terranova dei Passerini (ITTPR)"
  },
  {
   value: "Terranuova Bracciolini (ITTEB)",
   label: "Terranuova Bracciolini (ITTEB)"
  },
  {
   value: "Terrasini (ITSNR)",
   label: "Terrasini (ITSNR)"
  },
  {
   value: "Terzo (ITTEZ)",
   label: "Terzo (ITTEZ)"
  },
  {
   value: "Tesero (ITTSO)",
   label: "Tesero (ITTSO)"
  },
  {
   value: "Tessera (ITTES)",
   label: "Tessera (ITTES)"
  },
  {
   value: "Tezze (ITTZE)",
   label: "Tezze (ITTZE)"
  },
  {
   value: "Tezze sul Brenta (ITTSB)",
   label: "Tezze sul Brenta (ITTSB)"
  },
  {
   value: "Tiarno Di Sopra (ITTDR)",
   label: "Tiarno Di Sopra (ITTDR)"
  },
  {
   value: "Ticineto (ITZVD)",
   label: "Ticineto (ITZVD)"
  },
  {
   value: "Tione di Trento (ITTDT)",
   label: "Tione di Trento (ITTDT)"
  },
  {
   value: "Tito (ITTIT)",
   label: "Tito (ITTIT)"
  },
  {
   value: "Todi (ITTDI)",
   label: "Todi (ITTDI)"
  },
  {
   value: "Tolentino (ITTOL)",
   label: "Tolentino (ITTOL)"
  },
  {
   value: "Tollegno (ITTLG)",
   label: "Tollegno (ITTLG)"
  },
  {
   value: "Tollo (ITZBA)",
   label: "Tollo (ITZBA)"
  },
  {
   value: "Tolmezzo (ITTMO)",
   label: "Tolmezzo (ITTMO)"
  },
  {
   value: "Tombelle (ITTDV)",
   label: "Tombelle (ITTDV)"
  },
  {
   value: "Tor Tre Ponti (ITTTP)",
   label: "Tor Tre Ponti (ITTTP)"
  },
  {
   value: "Tor Vajanica (ITICA)",
   label: "Tor Vajanica (ITICA)"
  },
  {
   value: "Torba (ITOAB)",
   label: "Torba (ITOAB)"
  },
  {
   value: "Torbiato (ITTBO)",
   label: "Torbiato (ITTBO)"
  },
  {
   value: "Torbole (ITTRB)",
   label: "Torbole (ITTRB)"
  },
  {
   value: "Tornata (ITCRK)",
   label: "Tornata (ITCRK)"
  },
  {
   value: "Torre Boldone (ITTBD)",
   label: "Torre Boldone (ITTBD)"
  },
  {
   value: "Torre Cesarea (ITTCS)",
   label: "Torre Cesarea (ITTCS)"
  },
  {
   value: "Torre di Mosto (ITTMS)",
   label: "Torre di Mosto (ITTMS)"
  },
  {
   value: "Torre Faro (ITTRH)",
   label: "Torre Faro (ITTRH)"
  },
  {
   value: "Torre Gaveta (ITTGV)",
   label: "Torre Gaveta (ITTGV)"
  },
  {
   value: "Torre Maina (ITTMN)",
   label: "Torre Maina (ITTMN)"
  },
  {
   value: "Torre San Giorgio (ITTSG)",
   label: "Torre San Giorgio (ITTSG)"
  },
  {
   value: "Torre San Giovanni (ITTRU)",
   label: "Torre San Giovanni (ITTRU)"
  },
  {
   value: "Torrebelvicino (ITTVI)",
   label: "Torrebelvicino (ITTVI)"
  },
  {
   value: "Torrecuso (ITTCU)",
   label: "Torrecuso (ITTCU)"
  },
  {
   value: "Torreglia (ITTOG)",
   label: "Torreglia (ITTOG)"
  },
  {
   value: "Torrenova (ITZAL)",
   label: "Torrenova (ITZAL)"
  },
  {
   value: "Torrevecchia Pia (ITTCP)",
   label: "Torrevecchia Pia (ITTCP)"
  },
  {
   value: "Torri di Quartesolo (ITTDQ)",
   label: "Torri di Quartesolo (ITTDQ)"
  },
  {
   value: "Torriana (ITTON)",
   label: "Torriana (ITTON)"
  },
  {
   value: "Torrile (ITTIL)",
   label: "Torrile (ITTIL)"
  },
  {
   value: "Torrita di Siena (ITTSN)",
   label: "Torrita di Siena (ITTSN)"
  },
  {
   value: "Tortoreto (ITTTL)",
   label: "Tortoreto (ITTTL)"
  },
  {
   value: "Toscolano (ITTOS)",
   label: "Toscolano (ITTOS)"
  },
  {
   value: "Trambileno (ITTRL)",
   label: "Trambileno (ITTRL)"
  },
  {
   value: "Trana (ITTAN)",
   label: "Trana (ITTAN)"
  },
  {
   value: "Trappeto (ITZEM)",
   label: "Trappeto (ITZEM)"
  },
  {
   value: "Trasaghis (ITTFV)",
   label: "Trasaghis (ITTFV)"
  },
  {
   value: "Travagliato (ITTGL)",
   label: "Travagliato (ITTGL)"
  },
  {
   value: "Traversetolo (ITZVQ)",
   label: "Traversetolo (ITZVQ)"
  },
  {
   value: "Travesio (ITTVO)",
   label: "Travesio (ITTVO)"
  },
  {
   value: "Travettore di Rosa (ITZYT)",
   label: "Travettore di Rosa (ITZYT)"
  },
  {
   value: "Trebbo di Reno (ITTBR)",
   label: "Trebbo di Reno (ITTBR)"
  },
  {
   value: "Trebisacce (ITTCC)",
   label: "Trebisacce (ITTCC)"
  },
  {
   value: "Treglio (ITTRG)",
   label: "Treglio (ITTRG)"
  },
  {
   value: "Treia (ITTIA)",
   label: "Treia (ITTIA)"
  },
  {
   value: "Treiso (ITTRF)",
   label: "Treiso (ITTRF)"
  },
  {
   value: "Tremestieri (ITZVK)",
   label: "Tremestieri (ITZVK)"
  },
  {
   value: "Treppo Grande (ITZVG)",
   label: "Treppo Grande (ITZVG)"
  },
  {
   value: "Trepuzzi (ITPUZ)",
   label: "Trepuzzi (ITPUZ)"
  },
  {
   value: "Trequanda (ITTQU)",
   label: "Trequanda (ITTQU)"
  },
  {
   value: "Trescore Balneario (ITZVJ)",
   label: "Trescore Balneario (ITZVJ)"
  },
  {
   value: "Trescore Cremasco (ITTCR)",
   label: "Trescore Cremasco (ITTCR)"
  },
  {
   value: "Trevenzuolo (ITZAO)",
   label: "Trevenzuolo (ITZAO)"
  },
  {
   value: "Trevi (ITREV)",
   label: "Trevi (ITREV)"
  },
  {
   value: "Treviolo (ITTVL)",
   label: "Treviolo (ITTVL)"
  },
  {
   value: "Trezzano Rosa (ITTZR)",
   label: "Trezzano Rosa (ITTZR)"
  },
  {
   value: "Trezzano sul Naviglio (ITTZV)",
   label: "Trezzano sul Naviglio (ITTZV)"
  },
  {
   value: "Tribano (ITBOD)",
   label: "Tribano (ITBOD)"
  },
  {
   value: "Tribiano (ITTBA)",
   label: "Tribiano (ITTBA)"
  },
  {
   value: "Tricase (ITTSE)",
   label: "Tricase (ITTSE)"
  },
  {
   value: "Tricesimo (ITTCM)",
   label: "Tricesimo (ITTCM)"
  },
  {
   value: "Trichiana (ITTHA)",
   label: "Trichiana (ITTHA)"
  },
  {
   value: "Trigolo (ITTGI)",
   label: "Trigolo (ITTGI)"
  },
  {
   value: "Triuggio (ITTGG)",
   label: "Triuggio (ITTGG)"
  },
  {
   value: "Trofarello (ITTFR)",
   label: "Trofarello (ITTFR)"
  },
  {
   value: "Tromello (ITZTP)",
   label: "Tromello (ITZTP)"
  },
  {
   value: "Tropea (ITTRP)",
   label: "Tropea (ITTRP)"
  },
  {
   value: "Truccazzano (ITTCZ)",
   label: "Truccazzano (ITTCZ)"
  },
  {
   value: "Tuenno (ITZVM)",
   label: "Tuenno (ITZVM)"
  },
  {
   value: "Turi (ITZVN)",
   label: "Turi (ITZVN)"
  },
  {
   value: "Turriaco (ITZVL)",
   label: "Turriaco (ITZVL)"
  },
  {
   value: "Ubersetto (ITUBE)",
   label: "Ubersetto (ITUBE)"
  },
  {
   value: "Uboldo (ITUBD)",
   label: "Uboldo (ITUBD)"
  },
  {
   value: "Ugento (ITZVT)",
   label: "Ugento (ITZVT)"
  },
  {
   value: "Uggiate-Trevano (ITUTV)",
   label: "Uggiate-Trevano (ITUTV)"
  },
  {
   value: "Ugozzolo (ITUGO)",
   label: "Ugozzolo (ITUGO)"
  },
  {
   value: "Umbertide (ITUBT)",
   label: "Umbertide (ITUBT)"
  },
  {
   value: "Urbe (ITRBE)",
   label: "Urbe (ITRBE)"
  },
  {
   value: "Urbino (ITURB)",
   label: "Urbino (ITURB)"
  },
  {
   value: "Usmate Velate (ITUVL)",
   label: "Usmate Velate (ITUVL)"
  },
  {
   value: "Uta (ITZVV)",
   label: "Uta (ITZVV)"
  },
  {
   value: "Vacil (ITZXB)",
   label: "Vacil (ITZXB)"
  },
  {
   value: "Vaiano (ITZLF)",
   label: "Vaiano (ITZLF)"
  },
  {
   value: "Vaiano Cremasco (ITVAI)",
   label: "Vaiano Cremasco (ITVAI)"
  },
  {
   value: "Vaie (ITVEI)",
   label: "Vaie (ITVEI)"
  },
  {
   value: "Vailate (ITIAE)",
   label: "Vailate (ITIAE)"
  },
  {
   value: "Valbrembo (ITVBM)",
   label: "Valbrembo (ITVBM)"
  },
  {
   value: "Valdengo (ITVLE)",
   label: "Valdengo (ITVLE)"
  },
  {
   value: "Valderice (ITDVA)",
   label: "Valderice (ITDVA)"
  },
  {
   value: "Valdobbiadene (ITVLV)",
   label: "Valdobbiadene (ITVLV)"
  },
  {
   value: "Valdottavo (ITVDT)",
   label: "Valdottavo (ITVDT)"
  },
  {
   value: "Valduggia (ITVGA)",
   label: "Valduggia (ITVGA)"
  },
  {
   value: "Valeggio sul Mincio (ITVSM)",
   label: "Valeggio sul Mincio (ITVSM)"
  },
  {
   value: "Valenza (ITVZA)",
   label: "Valenza (ITVZA)"
  },
  {
   value: "Valfenera (ITVAA)",
   label: "Valfenera (ITVAA)"
  },
  {
   value: "Valgatara (ITZVX)",
   label: "Valgatara (ITZVX)"
  },
  {
   value: "Valla (ITTVV)",
   label: "Valla (ITTVV)"
  },
  {
   value: "Valle di Cadore (ITVIV)",
   label: "Valle di Cadore (ITVIV)"
  },
  {
   value: "Valle Lomellina (ITZIJ)",
   label: "Valle Lomellina (ITZIJ)"
  },
  {
   value: "Valle Mosso (ITVOS)",
   label: "Valle Mosso (ITVOS)"
  },
  {
   value: "Valle Salimbene (ITVSB)",
   label: "Valle Salimbene (ITVSB)"
  },
  {
   value: "Vallese (ITVAE)",
   label: "Vallese (ITVAE)"
  },
  {
   value: "Valli del Pasubio (ITVDE)",
   label: "Valli del Pasubio (ITVDE)"
  },
  {
   value: "Vallo della Lucania (ITVDU)",
   label: "Vallo della Lucania (ITVDU)"
  },
  {
   value: "Vallone (ITVNE)",
   label: "Vallone (ITVNE)"
  },
  {
   value: "Valmadonna (ITVMN)",
   label: "Valmadonna (ITVMN)"
  },
  {
   value: "Valperga (ITVPA)",
   label: "Valperga (ITVPA)"
  },
  {
   value: "Vanzaghello (ITVZH)",
   label: "Vanzaghello (ITVZH)"
  },
  {
   value: "Varallo Pombia (ITVPM)",
   label: "Varallo Pombia (ITVPM)"
  },
  {
   value: "Varano Borghi (ITVBH)",
   label: "Varano Borghi (ITVBH)"
  },
  {
   value: "Varazze (ITVRZ)",
   label: "Varazze (ITVRZ)"
  },
  {
   value: "Varedo (ITVAO)",
   label: "Varedo (ITVAO)"
  },
  {
   value: "Varna (ITZWK)",
   label: "Varna (ITZWK)"
  },
  {
   value: "Vazia (ITZWS)",
   label: "Vazia (ITZWS)"
  },
  {
   value: "Vazzola (ITVAZ)",
   label: "Vazzola (ITVAZ)"
  },
  {
   value: "Vedano Olona (ITVDB)",
   label: "Vedano Olona (ITVDB)"
  },
  {
   value: "Vedelago (ITVEL)",
   label: "Vedelago (ITVEL)"
  },
  {
   value: "Veduggio con Colzano (ITVIO)",
   label: "Veduggio con Colzano (ITVIO)"
  },
  {
   value: "Veggia (ITVGG)",
   label: "Veggia (ITVGG)"
  },
  {
   value: "Velezzo Lomellina (ITZLC)",
   label: "Velezzo Lomellina (ITZLC)"
  },
  {
   value: "Velletri (ITVVT)",
   label: "Velletri (ITVVT)"
  },
  {
   value: "Velturno\/Feldthurns (ITVEM)",
   label: "Velturno\/Feldthurns (ITVEM)"
  },
  {
   value: "Venafro (ITVNF)",
   label: "Venafro (ITVNF)"
  },
  {
   value: "Venasca (ITVNS)",
   label: "Venasca (ITVNS)"
  },
  {
   value: "Venegono Superiore (ITVGS)",
   label: "Venegono Superiore (ITVGS)"
  },
  {
   value: "Verano Brianza (ITZVY)",
   label: "Verano Brianza (ITZVY)"
  },
  {
   value: "Verbania (ITVEA)",
   label: "Verbania (ITVEA)"
  },
  {
   value: "Verdellino (ITVLI)",
   label: "Verdellino (ITVLI)"
  },
  {
   value: "Verderio Inferiore (ITZWL)",
   label: "Verderio Inferiore (ITZWL)"
  },
  {
   value: "Verderio Superiore (ITVSR)",
   label: "Verderio Superiore (ITVSR)"
  },
  {
   value: "Verduno (ITVRU)",
   label: "Verduno (ITVRU)"
  },
  {
   value: "Vergiate (ITVGT)",
   label: "Vergiate (ITVGT)"
  },
  {
   value: "Vernate (ITVTE)",
   label: "Vernate (ITVTE)"
  },
  {
   value: "Vernazza (ITVZN)",
   label: "Vernazza (ITVZN)"
  },
  {
   value: "Veroli (ITVRI)",
   label: "Veroli (ITVRI)"
  },
  {
   value: "Veronella (ITVNL)",
   label: "Veronella (ITVNL)"
  },
  {
   value: "Verrès (ITVRR)",
   label: "Verrès (ITVRR)"
  },
  {
   value: "Verrone (ITVEO)",
   label: "Verrone (ITVEO)"
  },
  {
   value: "Vertemate con Minoprio (ITZWQ)",
   label: "Vertemate con Minoprio (ITZWQ)"
  },
  {
   value: "Verzuolo (ITVZU)",
   label: "Verzuolo (ITVZU)"
  },
  {
   value: "Vescovato (ITVES)",
   label: "Vescovato (ITVES)"
  },
  {
   value: "Vestenanova (ITZWF)",
   label: "Vestenanova (ITZWF)"
  },
  {
   value: "Vestone (ITVTN)",
   label: "Vestone (ITVTN)"
  },
  {
   value: "Vetrella (ITVET)",
   label: "Vetrella (ITVET)"
  },
  {
   value: "Vezzano Ligure (ITVZL)",
   label: "Vezzano Ligure (ITVZL)"
  },
  {
   value: "Vezzano sul Crostolo (ITVSC)",
   label: "Vezzano sul Crostolo (ITVSC)"
  },
  {
   value: "Viadana (ITVDN)",
   label: "Viadana (ITVDN)"
  },
  {
   value: "Viadanica (ITVII)",
   label: "Viadanica (ITVII)"
  },
  {
   value: "Viagrande (ITVGE)",
   label: "Viagrande (ITVGE)"
  },
  {
   value: "Viano (ITVVN)",
   label: "Viano (ITVVN)"
  },
  {
   value: "Viarolo (ITZWP)",
   label: "Viarolo (ITZWP)"
  },
  {
   value: "Vicchio (ITVHO)",
   label: "Vicchio (ITVHO)"
  },
  {
   value: "Vicolungo (ITVLU)",
   label: "Vicolungo (ITVLU)"
  },
  {
   value: "Vicopisano (ITOPI)",
   label: "Vicopisano (ITOPI)"
  },
  {
   value: "Vidigulfo (ITVGU)",
   label: "Vidigulfo (ITVGU)"
  },
  {
   value: "Vidor (ITVDP)",
   label: "Vidor (ITVDP)"
  },
  {
   value: "Vidor (ITZWH)",
   label: "Vidor (ITZWH)"
  },
  {
   value: "Vidracco (ITZWC)",
   label: "Vidracco (ITZWC)"
  },
  {
   value: "Vigano (ITVAN)",
   label: "Vigano (ITVAN)"
  },
  {
   value: "Vigarano Mainarda (ITVGM)",
   label: "Vigarano Mainarda (ITVGM)"
  },
  {
   value: "Vigasio (ITVIS)",
   label: "Vigasio (ITVIS)"
  },
  {
   value: "Viggiano (ITVAG)",
   label: "Viggiano (ITVAG)"
  },
  {
   value: "Vigliano Biellese (ITBLS)",
   label: "Vigliano Biellese (ITBLS)"
  },
  {
   value: "Vignale Monferrato (ITVGN)",
   label: "Vignale Monferrato (ITVGN)"
  },
  {
   value: "Vignate (ITVNT)",
   label: "Vignate (ITVNT)"
  },
  {
   value: "Vignola (ITVIN)",
   label: "Vignola (ITVIN)"
  },
  {
   value: "Vigodarzere (ITVDZ)",
   label: "Vigodarzere (ITVDZ)"
  },
  {
   value: "Vigolo (ITVOO)",
   label: "Vigolo (ITVOO)"
  },
  {
   value: "Vigonovo (ITZWM)",
   label: "Vigonovo (ITZWM)"
  },
  {
   value: "Viguzzolo (ITVZO)",
   label: "Viguzzolo (ITVZO)"
  },
  {
   value: "Villa Bartolomea (ITVBR)",
   label: "Villa Bartolomea (ITVBR)"
  },
  {
   value: "Villa Carcina (ITVCN)",
   label: "Villa Carcina (ITVCN)"
  },
  {
   value: "Villa del Conte (ITDSF)",
   label: "Villa del Conte (ITDSF)"
  },
  {
   value: "Villa di Briano (ITVDF)",
   label: "Villa di Briano (ITVDF)"
  },
  {
   value: "Villa Fastiggi (ITZWI)",
   label: "Villa Fastiggi (ITZWI)"
  },
  {
   value: "Villa Ganzerla (ITVGR)",
   label: "Villa Ganzerla (ITVGR)"
  },
  {
   value: "Villa Guardia (ITZPO)",
   label: "Villa Guardia (ITZPO)"
  },
  {
   value: "Villa Raspa (ITVIR)",
   label: "Villa Raspa (ITVIR)"
  },
  {
   value: "Villa Rosa (ITLRS)",
   label: "Villa Rosa (ITLRS)"
  },
  {
   value: "Villa San Giovanni, Calabria (ITVSG)",
   label: "Villa San Giovanni, Calabria (ITVSG)"
  },
  {
   value: "Villa Santa Lucia (ITVSL)",
   label: "Villa Santa Lucia (ITVSL)"
  },
  {
   value: "Villa Santina (ITNTI)",
   label: "Villa Santina (ITNTI)"
  },
  {
   value: "Villabate (ITZWG)",
   label: "Villabate (ITZWG)"
  },
  {
   value: "Villacidro (ITVCD)",
   label: "Villacidro (ITVCD)"
  },
  {
   value: "Villadose (ITVOD)",
   label: "Villadose (ITVOD)"
  },
  {
   value: "Villadossola (ITVLS)",
   label: "Villadossola (ITVLS)"
  },
  {
   value: "Villafalletto (ITVFA)",
   label: "Villafalletto (ITVFA)"
  },
  {
   value: "Villafontana (ITVFO)",
   label: "Villafontana (ITVFO)"
  },
  {
   value: "Villafranca di Verona (ITVDV)",
   label: "Villafranca di Verona (ITVDV)"
  },
  {
   value: "Villafranca Padovana (ITVPV)",
   label: "Villafranca Padovana (ITVPV)"
  },
  {
   value: "Villaggio Sereno (ITGGS)",
   label: "Villaggio Sereno (ITGGS)"
  },
  {
   value: "Villalvernia (ITVVR)",
   label: "Villalvernia (ITVVR)"
  },
  {
   value: "Villamarzana (ITVLZ)",
   label: "Villamarzana (ITVLZ)"
  },
  {
   value: "Villanova (ITVCS)",
   label: "Villanova (ITVCS)"
  },
  {
   value: "Villanova di Prata (ITZYF)",
   label: "Villanova di Prata (ITZYF)"
  },
  {
   value: "Villanova di Reggiolo (ITZYV)",
   label: "Villanova di Reggiolo (ITZYV)"
  },
  {
   value: "Villanova Mondovì (ITVMO)",
   label: "Villanova Mondovì (ITVMO)"
  },
  {
   value: "Villanuova sul Clisi (ITZWR)",
   label: "Villanuova sul Clisi (ITZWR)"
  },
  {
   value: "Villar Perosa (ITVPS)",
   label: "Villar Perosa (ITVPS)"
  },
  {
   value: "Villarbasse (ITVBS)",
   label: "Villarbasse (ITVBS)"
  },
  {
   value: "Villaricca (ITVLR)",
   label: "Villaricca (ITVLR)"
  },
  {
   value: "Villarotta (ITZWO)",
   label: "Villarotta (ITZWO)"
  },
  {
   value: "Villasimius (ITVSU)",
   label: "Villasimius (ITVSU)"
  },
  {
   value: "Villaspeciosa (ITZWJ)",
   label: "Villaspeciosa (ITZWJ)"
  },
  {
   value: "Villastanza (ITVTZ)",
   label: "Villastanza (ITVTZ)"
  },
  {
   value: "Villastanza di Parabiago (ITVLP)",
   label: "Villastanza di Parabiago (ITVLP)"
  },
  {
   value: "Villatora di Saonara (ITVIX)",
   label: "Villatora di Saonara (ITVIX)"
  },
  {
   value: "Villesse (ITVLL)",
   label: "Villesse (ITVLL)"
  },
  {
   value: "Villimpenta (ITVPT)",
   label: "Villimpenta (ITVPT)"
  },
  {
   value: "Villorba (ITVOR)",
   label: "Villorba (ITVOR)"
  },
  {
   value: "Vimercate (ITVIM)",
   label: "Vimercate (ITVIM)"
  },
  {
   value: "Vinchiaturo (ITZKX)",
   label: "Vinchiaturo (ITZKX)"
  },
  {
   value: "Vinci (ITVCI)",
   label: "Vinci (ITVCI)"
  },
  {
   value: "Vipiteno (ITVPP)",
   label: "Vipiteno (ITVPP)"
  },
  {
   value: "Virle (ITVTP)",
   label: "Virle (ITVTP)"
  },
  {
   value: "Virle Piemonte (ITVIP)",
   label: "Virle Piemonte (ITVIP)"
  },
  {
   value: "Visano (ITUIS)",
   label: "Visano (ITUIS)"
  },
  {
   value: "Visna (ITZWW)",
   label: "Visna (ITZWW)"
  },
  {
   value: "Visone (ITVSE)",
   label: "Visone (ITVSE)"
  },
  {
   value: "Vitulazio (ITVLO)",
   label: "Vitulazio (ITVLO)"
  },
  {
   value: "Vizzola Ticino (ITVTC)",
   label: "Vizzola Ticino (ITVTC)"
  },
  {
   value: "Vo (ITVOP)",
   label: "Vo (ITVOP)"
  },
  {
   value: "Vobarno (ITVBN)",
   label: "Vobarno (ITVBN)"
  },
  {
   value: "Volla (ITVLA)",
   label: "Volla (ITVLA)"
  },
  {
   value: "Volongo (ITZWN)",
   label: "Volongo (ITZWN)"
  },
  {
   value: "Volpago del Montello (ITZWD)",
   label: "Volpago del Montello (ITZWD)"
  },
  {
   value: "Volta Mantovana (ITVMA)",
   label: "Volta Mantovana (ITVMA)"
  },
  {
   value: "Voltana (ITVLT)",
   label: "Voltana (ITVLT)"
  },
  {
   value: "Zaffaria (ITZAF)",
   label: "Zaffaria (ITZAF)"
  },
  {
   value: "Zelbio (ITZLB)",
   label: "Zelbio (ITZLB)"
  },
  {
   value: "Zenson di Piave (ITZDP)",
   label: "Zenson di Piave (ITZDP)"
  },
  {
   value: "Zerbolo (ITZXM)",
   label: "Zerbolo (ITZXM)"
  },
  {
   value: "Ziano di Fiemme (ITZXL)",
   label: "Ziano di Fiemme (ITZXL)"
  },
  {
   value: "Zibello (ITZXO)",
   label: "Zibello (ITZXO)"
  },
  {
   value: "Zibido San Giacomo (ITZSG)",
   label: "Zibido San Giacomo (ITZSG)"
  },
  {
   value: "Zinasco (ITZXP)",
   label: "Zinasco (ITZXP)"
  },
  {
   value: "Zocca (ITZXQ)",
   label: "Zocca (ITZXQ)"
  },
  {
   value: "Zocca, Modena (ITZCA)",
   label: "Zocca, Modena (ITZCA)"
  },
  {
   value: "Zoppe (ITZXR)",
   label: "Zoppe (ITZXR)"
  },
  {
   value: "Zoppola (ITZOP)",
   label: "Zoppola (ITZOP)"
  },
  {
   value: ".JERSEY (JE)",
   label: ".JERSEY (JE)"
  },
  {
   value: "St Helier (JESTH)",
   label: "St Helier (JESTH)"
  },
  {
   value: "States Apt, Jersey (JEJER)",
   label: "States Apt, Jersey (JEJER)"
  },
  {
   value: "Trinity (JETTY)",
   label: "Trinity (JETTY)"
  },
  {
   value: ".JAMAICA (JM)",
   label: ".JAMAICA (JM)"
  },
  {
   value: "Charles Town (JMCST)",
   label: "Charles Town (JMCST)"
  },
  {
   value: "Clarendon Park (JMCLA)",
   label: "Clarendon Park (JMCLA)"
  },
  {
   value: "Nain (JMNAI)",
   label: "Nain (JMNAI)"
  },
  {
   value: ".JORDAN (JO)",
   label: ".JORDAN (JO)"
  },
  {
   value: "Abu Alandah (JODAH)",
   label: "Abu Alandah (JODAH)"
  },
  {
   value: "Al Azraq (JOAAQ)",
   label: "Al Azraq (JOAAQ)"
  },
  {
   value: "Al Fuhays (JOFUH)",
   label: "Al Fuhays (JOFUH)"
  },
  {
   value: "Madaba (JOQMD)",
   label: "Madaba (JOQMD)"
  },
  {
   value: "Zarka Free Zone (JOZFZ)",
   label: "Zarka Free Zone (JOZFZ)"
  },
  {
   value: ".JAPAN (JP)",
   label: ".JAPAN (JP)"
  },
  {
   value: "Ageo-Shi, Saitama (JPAGE)",
   label: "Ageo-Shi, Saitama (JPAGE)"
  },
  {
   value: "Asahimachi (JPASI)",
   label: "Asahimachi (JPASI)"
  },
  {
   value: "Asaka, Saitama (JPSKA)",
   label: "Asaka, Saitama (JPSKA)"
  },
  {
   value: "Ataka (JPATA)",
   label: "Ataka (JPATA)"
  },
  {
   value: "Ayase-Shi (JPAYS)",
   label: "Ayase-Shi (JPAYS)"
  },
  {
   value: "Chigasaki (JPCHG)",
   label: "Chigasaki (JPCHG)"
  },
  {
   value: "Chiyoda (JPCHY)",
   label: "Chiyoda (JPCHY)"
  },
  {
   value: "Chiyoda-ku (JPCAU)",
   label: "Chiyoda-ku (JPCAU)"
  },
  {
   value: "Daikoku Island (JPDKI)",
   label: "Daikoku Island (JPDKI)"
  },
  {
   value: "Dejima (JPZAH)",
   label: "Dejima (JPZAH)"
  },
  {
   value: "Fuchu-shi (JPFCH)",
   label: "Fuchu-shi (JPFCH)"
  },
  {
   value: "Fujieda, Shizuoka (JPFJD)",
   label: "Fujieda, Shizuoka (JPFJD)"
  },
  {
   value: "Fujinomiya, Shizuoka (JPFJM)",
   label: "Fujinomiya, Shizuoka (JPFJM)"
  },
  {
   value: "Fujioka (JPFJK)",
   label: "Fujioka (JPFJK)"
  },
  {
   value: "Fukuroi (JPFKO)",
   label: "Fukuroi (JPFKO)"
  },
  {
   value: "Fukushima (JPFKF)",
   label: "Fukushima (JPFKF)"
  },
  {
   value: "Fukushima, Hokkaido (JPFKU)",
   label: "Fukushima, Hokkaido (JPFKU)"
  },
  {
   value: "Futtsu, Chiba (JPFTS)",
   label: "Futtsu, Chiba (JPFTS)"
  },
  {
   value: "Gushikawa (JPGKA)",
   label: "Gushikawa (JPGKA)"
  },
  {
   value: "Hachioji (JPHAO)",
   label: "Hachioji (JPHAO)"
  },
  {
   value: "Hakata (JPHTD)",
   label: "Hakata (JPHTD)"
  },
  {
   value: "Hirakata (JPHKA)",
   label: "Hirakata (JPHKA)"
  },
  {
   value: "Hiratsuka (JPHIU)",
   label: "Hiratsuka (JPHIU)"
  },
  {
   value: "Hofu (JPHOF)",
   label: "Hofu (JPHOF)"
  },
  {
   value: "Hyuga (JPHYU)",
   label: "Hyuga (JPHYU)"
  },
  {
   value: "Ibaraki (JPIAK)",
   label: "Ibaraki (JPIAK)"
  },
  {
   value: "Ibiwaga (JPIBI)",
   label: "Ibiwaga (JPIBI)"
  },
  {
   value: "Ichinomiya (JPIHN)",
   label: "Ichinomiya (JPIHN)"
  },
  {
   value: "Inazawa (JPIZW)",
   label: "Inazawa (JPIZW)"
  },
  {
   value: "Inuyama (JPINY)",
   label: "Inuyama (JPINY)"
  },
  {
   value: "Ishikawa (JPIKW)",
   label: "Ishikawa (JPIKW)"
  },
  {
   value: "Itami\/Hyogo (JPITA)",
   label: "Itami\/Hyogo (JPITA)"
  },
  {
   value: "Joetsu (JPJTS)",
   label: "Joetsu (JPJTS)"
  },
  {
   value: "Kakegawa (JPKGW)",
   label: "Kakegawa (JPKGW)"
  },
  {
   value: "Kamisu, Ibaraki (JPKIU)",
   label: "Kamisu, Ibaraki (JPKIU)"
  },
  {
   value: "Kani (JPANI)",
   label: "Kani (JPANI)"
  },
  {
   value: "Kasukabe (JPKAK)",
   label: "Kasukabe (JPKAK)"
  },
  {
   value: "Kasumigaura (JPKAU)",
   label: "Kasumigaura (JPKAU)"
  },
  {
   value: "Kawachi Nagano (JPKWO)",
   label: "Kawachi Nagano (JPKWO)"
  },
  {
   value: "Kawagoe (JPKWE)",
   label: "Kawagoe (JPKWE)"
  },
  {
   value: "Kawaguchi, Saitama (JPKWU)",
   label: "Kawaguchi, Saitama (JPKWU)"
  },
  {
   value: "Kazo (JPKZO)",
   label: "Kazo (JPKZO)"
  },
  {
   value: "Kitakami (JPKTN)",
   label: "Kitakami (JPKTN)"
  },
  {
   value: "Kobe, Kyota (JPZAI)",
   label: "Kobe, Kyota (JPZAI)"
  },
  {
   value: "Kofu (JPKUF)",
   label: "Kofu (JPKUF)"
  },
  {
   value: "Konohana-Ku, Osaka (JPZAC)",
   label: "Konohana-Ku, Osaka (JPZAC)"
  },
  {
   value: "Koriyama (JPKIY)",
   label: "Koriyama (JPKIY)"
  },
  {
   value: "Koshigaya (JPKOA)",
   label: "Koshigaya (JPKOA)"
  },
  {
   value: "Kurashiki (JPKUA)",
   label: "Kurashiki (JPKUA)"
  },
  {
   value: "Marcus I. (JPMUS)",
   label: "Marcus I. (JPMUS)"
  },
  {
   value: "Matsudo (JPMTD)",
   label: "Matsudo (JPMTD)"
  },
  {
   value: "Miiyoshi, Aichi (JPMIA)",
   label: "Miiyoshi, Aichi (JPMIA)"
  },
  {
   value: "Minachi (JPMHI)",
   label: "Minachi (JPMHI)"
  },
  {
   value: "Minato-Ku, Osaka (JPZAB)",
   label: "Minato-Ku, Osaka (JPZAB)"
  },
  {
   value: "Minato-Ku, Tokyo (JPZAE)",
   label: "Minato-Ku, Tokyo (JPZAE)"
  },
  {
   value: "Miyagi (JPMYI)",
   label: "Miyagi (JPMYI)"
  },
  {
   value: "Nada-Ku, Hyogo (JPZAG)",
   label: "Nada-Ku, Hyogo (JPZAG)"
  },
  {
   value: "Naka-Ku, Kanagawa (JPZAF)",
   label: "Naka-Ku, Kanagawa (JPZAF)"
  },
  {
   value: "Nakamichi (JPNMC)",
   label: "Nakamichi (JPNMC)"
  },
  {
   value: "Narashino (JPNAI)",
   label: "Narashino (JPNAI)"
  },
  {
   value: "Narita, Chiba (JPNRI)",
   label: "Narita, Chiba (JPNRI)"
  },
  {
   value: "Nishio (JPNHO)",
   label: "Nishio (JPNHO)"
  },
  {
   value: "Noda (JPNOD)",
   label: "Noda (JPNOD)"
  },
  {
   value: "Odaiba (JPODT)",
   label: "Odaiba (JPODT)"
  },
  {
   value: "Okaya (JPOKY)",
   label: "Okaya (JPOKY)"
  },
  {
   value: "Okazaki (JPOKZ)",
   label: "Okazaki (JPOKZ)"
  },
  {
   value: "Omi (JPAOM)",
   label: "Omi (JPAOM)"
  },
  {
   value: "Onnebetsu (JPONB)",
   label: "Onnebetsu (JPONB)"
  },
  {
   value: "Oppama (JPOPA)",
   label: "Oppama (JPOPA)"
  },
  {
   value: "Ota, Gunma (JPOTG)",
   label: "Ota, Gunma (JPOTG)"
  },
  {
   value: "Ota-Ku (JPZAD)",
   label: "Ota-Ku (JPZAD)"
  },
  {
   value: "Oyama (JPOAM)",
   label: "Oyama (JPOAM)"
  },
  {
   value: "Saga (JPHSG)",
   label: "Saga (JPHSG)"
  },
  {
   value: "Saitama (JPSTM)",
   label: "Saitama (JPSTM)"
  },
  {
   value: "Satsuma (JPSUA)",
   label: "Satsuma (JPSUA)"
  },
  {
   value: "Satsumasendai (JPSTS)",
   label: "Satsumasendai (JPSTS)"
  },
  {
   value: "Sawara (JPSWR)",
   label: "Sawara (JPSWR)"
  },
  {
   value: "Seibu (JPSEB)",
   label: "Seibu (JPSEB)"
  },
  {
   value: "Setagaya-ku\/Tokyo (JPSEA)",
   label: "Setagaya-ku\/Tokyo (JPSEA)"
  },
  {
   value: "Shinjuku-ku (JPSXO)",
   label: "Shinjuku-ku (JPSXO)"
  },
  {
   value: "Shinko (JPSHJ)",
   label: "Shinko (JPSHJ)"
  },
  {
   value: "Shinshiro (JPIRO)",
   label: "Shinshiro (JPIRO)"
  },
  {
   value: "Shizuoka (JPSHO)",
   label: "Shizuoka (JPSHO)"
  },
  {
   value: "Shizuoka Apt (JPFSZ)",
   label: "Shizuoka Apt (JPFSZ)"
  },
  {
   value: "Suzuka (JPKUK)",
   label: "Suzuka (JPKUK)"
  },
  {
   value: "Takasaki (JPTSA)",
   label: "Takasaki (JPTSA)"
  },
  {
   value: "Tamashima (JPZAJ)",
   label: "Tamashima (JPZAJ)"
  },
  {
   value: "Tendo (JPTEN)",
   label: "Tendo (JPTEN)"
  },
  {
   value: "Tobishima-Mura (JPTBM)",
   label: "Tobishima-Mura (JPTBM)"
  },
  {
   value: "Tochigi, Tochigi (JPTGI)",
   label: "Tochigi, Tochigi (JPTGI)"
  },
  {
   value: "Toyohira-ku (JPTHA)",
   label: "Toyohira-ku (JPTHA)"
  },
  {
   value: "Toyota (JPTYA)",
   label: "Toyota (JPTYA)"
  },
  {
   value: "Tsukuba (JPTSB)",
   label: "Tsukuba (JPTSB)"
  },
  {
   value: "Tsurumi-Ku (JPZAA)",
   label: "Tsurumi-Ku (JPZAA)"
  },
  {
   value: "Urasoe (JPZAK)",
   label: "Urasoe (JPZAK)"
  },
  {
   value: "Urayasu (JPUYA)",
   label: "Urayasu (JPUYA)"
  },
  {
   value: "Utsunomiya (JPUTO)",
   label: "Utsunomiya (JPUTO)"
  },
  {
   value: "Washimiya (JPWAH)",
   label: "Washimiya (JPWAH)"
  },
  {
   value: "Yachiyo (JPYCH)",
   label: "Yachiyo (JPYCH)"
  },
  {
   value: "Yaeyama Island (JPYAE)",
   label: "Yaeyama Island (JPYAE)"
  },
  {
   value: "Yamanashi (JPYNS)",
   label: "Yamanashi (JPYNS)"
  },
  {
   value: "Yatomi, Aichi (JPYTM)",
   label: "Yatomi, Aichi (JPYTM)"
  },
  {
   value: "Yokohama, Aomori (JPZAL)",
   label: "Yokohama, Aomori (JPZAL)"
  },
  {
   value: "Yuki (JPYKI)",
   label: "Yuki (JPYKI)"
  },
  {
   value: "Yuza (JPYUZ)",
   label: "Yuza (JPYUZ)"
  },
  {
   value: "Zama (JPZAM)",
   label: "Zama (JPZAM)"
  },
  {
   value: ".KENYA (KE)",
   label: ".KENYA (KE)"
  },
  {
   value: "Kajiado (KEKAJ)",
   label: "Kajiado (KEKAJ)"
  },
  {
   value: "Kakamega (KEKAK)",
   label: "Kakamega (KEKAK)"
  },
  {
   value: "Malaba (KEMAL)",
   label: "Malaba (KEMAL)"
  },
  {
   value: "Naivasha (KERNA)",
   label: "Naivasha (KERNA)"
  },
  {
   value: "Narok (KENAR)",
   label: "Narok (KENAR)"
  },
  {
   value: "Sotik (KESOT)",
   label: "Sotik (KESOT)"
  },
  {
   value: "Thika (KETHK)",
   label: "Thika (KETHK)"
  },
  {
   value: ".KYRGYZSTAN (KG)",
   label: ".KYRGYZSTAN (KG)"
  },
  {
   value: "Alamedin (KGALA)",
   label: "Alamedin (KGALA)"
  },
  {
   value: "Balykchy (KGBYK)",
   label: "Balykchy (KGBYK)"
  },
  {
   value: "Jalal-Abad (KGJLD)",
   label: "Jalal-Abad (KGJLD)"
  },
  {
   value: "Manas International Apt (KGMAN)",
   label: "Manas International Apt (KGMAN)"
  },
  {
   value: "Rybacje (KGRBC)",
   label: "Rybacje (KGRBC)"
  },
  {
   value: ".CAMBODIA (KH)",
   label: ".CAMBODIA (KH)"
  },
  {
   value: "Paôy Pêt (Poipet) (KHPPT)",
   label: "Paôy Pêt (Poipet) (KHPPT)"
  },
  {
   value: ".KIRIBATI (KI)",
   label: ".KIRIBATI (KI)"
  },
  {
   value: "Birnie I. (KIBIR)",
   label: "Birnie I. (KIBIR)"
  },
  {
   value: "Enderbury I. (KIEBI)",
   label: "Enderbury I. (KIEBI)"
  },
  {
   value: "Hull I. (KIHUL)",
   label: "Hull I. (KIHUL)"
  },
  {
   value: "Mckean I. (KIMCK)",
   label: "Mckean I. (KIMCK)"
  },
  {
   value: "Nikumaroro (KINIK)",
   label: "Nikumaroro (KINIK)"
  },
  {
   value: "Sydney I. (KISYI)",
   label: "Sydney I. (KISYI)"
  },
  {
   value: ".COMOROS (KM)",
   label: ".COMOROS (KM)"
  },
  {
   value: "Longoni (KMLOG)",
   label: "Longoni (KMLOG)"
  },
  {
   value: ".SAINT KITTS AND NEVIS (KN)",
   label: ".SAINT KITTS AND NEVIS (KN)"
  },
  {
   value: "Odaejin (KPODA)",
   label: "Odaejin (KPODA)"
  },
  {
   value: "Panjang (KPPNG)",
   label: "Panjang (KPPNG)"
  },
  {
   value: "Riwon (KPRIW)",
   label: "Riwon (KPRIW)"
  },
  {
   value: "Samcha do (KPSAM)",
   label: "Samcha do (KPSAM)"
  },
  {
   value: "Sinpo (KPSIN)",
   label: "Sinpo (KPSIN)"
  },
  {
   value: ".KOREA, REPUBLIC OF (KR)",
   label: ".KOREA, REPUBLIC OF (KR)"
  },
  {
   value: "Andong (KRADG)",
   label: "Andong (KRADG)"
  },
  {
   value: "Ansan (KRASN)",
   label: "Ansan (KRASN)"
  },
  {
   value: "Anseong (KRASG)",
   label: "Anseong (KRASG)"
  },
  {
   value: "Asan (KRASA)",
   label: "Asan (KRASA)"
  },
  {
   value: "BALAN\/Hwaseoung (KRBAA)",
   label: "BALAN\/Hwaseoung (KRBAA)"
  },
  {
   value: "Boeun-gun (KRBEN)",
   label: "Boeun-gun (KRBEN)"
  },
  {
   value: "Bongdong-eup\/Wanju-gun (KRBDE)",
   label: "Bongdong-eup\/Wanju-gun (KRBDE)"
  },
  {
   value: "Bonghwa-gun (KRBHA)",
   label: "Bonghwa-gun (KRBHA)"
  },
  {
   value: "Boseong-gun (KRBSG)",
   label: "Boseong-gun (KRBSG)"
  },
  {
   value: "Buan-gun (KRBAN)",
   label: "Buan-gun (KRBAN)"
  },
  {
   value: "Bucheon (KRBCN)",
   label: "Bucheon (KRBCN)"
  },
  {
   value: "Bukjeju-gun (KRBJJ)",
   label: "Bukjeju-gun (KRBJJ)"
  },
  {
   value: "Bupyong\/Incheon (KRBUK)",
   label: "Bupyong\/Incheon (KRBUK)"
  },
  {
   value: "Buyeo-gun (KRBYO)",
   label: "Buyeo-gun (KRBYO)"
  },
  {
   value: "Changnyeong-gun (KRCNG)",
   label: "Changnyeong-gun (KRCNG)"
  },
  {
   value: "Changwon (KRCHW)",
   label: "Changwon (KRCHW)"
  },
  {
   value: "Cheongdo-gun (KRCDO)",
   label: "Cheongdo-gun (KRCDO)"
  },
  {
   value: "Cheongsong-gun (KRCSG)",
   label: "Cheongsong-gun (KRCSG)"
  },
  {
   value: "Cheongwon-gun (KRCWO)",
   label: "Cheongwon-gun (KRCWO)"
  },
  {
   value: "Cheongyang-gun (KRCYG)",
   label: "Cheongyang-gun (KRCYG)"
  },
  {
   value: "Cheorwon-gun (KRCWN)",
   label: "Cheorwon-gun (KRCWN)"
  },
  {
   value: "Chilgok-gun (KRCGK)",
   label: "Chilgok-gun (KRCGK)"
  },
  {
   value: "Chonan (KRCUC)",
   label: "Chonan (KRCUC)"
  },
  {
   value: "Chongju (KRCOJ)",
   label: "Chongju (KRCOJ)"
  },
  {
   value: "Chonui\/Yeongi-gun (KRCHI)",
   label: "Chonui\/Yeongi-gun (KRCHI)"
  },
  {
   value: "Chuncheon (KRCHC)",
   label: "Chuncheon (KRCHC)"
  },
  {
   value: "Chungyang (KRCGY)",
   label: "Chungyang (KRCGY)"
  },
  {
   value: "Dalseong-gun\/Daegu (KRDSG)",
   label: "Dalseong-gun\/Daegu (KRDSG)"
  },
  {
   value: "Damyang-gun (KRDYA)",
   label: "Damyang-gun (KRDYA)"
  },
  {
   value: "Danyang-gun (KRDYG)",
   label: "Danyang-gun (KRDYG)"
  },
  {
   value: "Dokdo (KRDDO)",
   label: "Dokdo (KRDDO)"
  },
  {
   value: "Dongducheon (KRDDC)",
   label: "Dongducheon (KRDDC)"
  },
  {
   value: "Dorasan\/Paju (KRDRS)",
   label: "Dorasan\/Paju (KRDRS)"
  },
  {
   value: "Eumseong-gun (KRESG)",
   label: "Eumseong-gun (KRESG)"
  },
  {
   value: "Ganghwa-gun\/Incheon (KRGHA)",
   label: "Ganghwa-gun\/Incheon (KRGHA)"
  },
  {
   value: "Gangjin-gun (KRGJN)",
   label: "Gangjin-gun (KRGJN)"
  },
  {
   value: "Gangseo (KRGNO)",
   label: "Gangseo (KRGNO)"
  },
  {
   value: "Gapyeong-gun (KRGPG)",
   label: "Gapyeong-gun (KRGPG)"
  },
  {
   value: "Geochang-gun (KRGCH)",
   label: "Geochang-gun (KRGCH)"
  },
  {
   value: "Geumsan-gun (KRGSA)",
   label: "Geumsan-gun (KRGSA)"
  },
  {
   value: "Gijang-gun\/Busan (KRGJG)",
   label: "Gijang-gun\/Busan (KRGJG)"
  },
  {
   value: "Gimcheon (KRKMC)",
   label: "Gimcheon (KRKMC)"
  },
  {
   value: "Gimje (KRGJE)",
   label: "Gimje (KRGJE)"
  },
  {
   value: "Gimpo (KRGMP)",
   label: "Gimpo (KRGMP)"
  },
  {
   value: "Gochang-gun (KRGCG)",
   label: "Gochang-gun (KRGCG)"
  },
  {
   value: "Goesan-gun (KRGSN)",
   label: "Goesan-gun (KRGSN)"
  },
  {
   value: "Goheung-gun (KRGHG)",
   label: "Goheung-gun (KRGHG)"
  },
  {
   value: "Gokseong-gun (KRGSE)",
   label: "Gokseong-gun (KRGSE)"
  },
  {
   value: "Gongju (KRGOJ)",
   label: "Gongju (KRGOJ)"
  },
  {
   value: "Goryeong-gun (KRGRG)",
   label: "Goryeong-gun (KRGRG)"
  },
  {
   value: "Goseong-gun (KRGSG)",
   label: "Goseong-gun (KRGSG)"
  },
  {
   value: "Goseong-gun (KRGSO)",
   label: "Goseong-gun (KRGSO)"
  },
  {
   value: "Goyang (KRGYG)",
   label: "Goyang (KRGYG)"
  },
  {
   value: "Gumi (KRKUM)",
   label: "Gumi (KRKUM)"
  },
  {
   value: "Gunpo (KRGUN)",
   label: "Gunpo (KRGUN)"
  },
  {
   value: "Gunwi-gun (KRGWI)",
   label: "Gunwi-gun (KRGWI)"
  },
  {
   value: "Guri (KRGRI)",
   label: "Guri (KRGRI)"
  },
  {
   value: "Gurye-gun (KRGRE)",
   label: "Gurye-gun (KRGRE)"
  },
  {
   value: "Gwacheon (KRGCN)",
   label: "Gwacheon (KRGCN)"
  },
  {
   value: "Gwangju (KRKWU)",
   label: "Gwangju (KRKWU)"
  },
  {
   value: "Gwangmyeong (KRGMG)",
   label: "Gwangmyeong (KRGMG)"
  },
  {
   value: "Gyeongju (KRGJU)",
   label: "Gyeongju (KRGJU)"
  },
  {
   value: "Gyeongsan (KRGYS)",
   label: "Gyeongsan (KRGYS)"
  },
  {
   value: "Hadong-gun (KRHDG)",
   label: "Hadong-gun (KRHDG)"
  },
  {
   value: "Haman-gun (KRHAN)",
   label: "Haman-gun (KRHAN)"
  },
  {
   value: "Hampyeong-gun (KRHPG)",
   label: "Hampyeong-gun (KRHPG)"
  },
  {
   value: "Hamyang-gun (KRHYG)",
   label: "Hamyang-gun (KRHYG)"
  },
  {
   value: "Hanam (KRHNM)",
   label: "Hanam (KRHNM)"
  },
  {
   value: "Hapcheon-gun (KRHCE)",
   label: "Hapcheon-gun (KRHCE)"
  },
  {
   value: "Haryana (KRHAR)",
   label: "Haryana (KRHAR)"
  },
  {
   value: "Hoengseong-gun (KRHSG)",
   label: "Hoengseong-gun (KRHSG)"
  },
  {
   value: "Hongcheon-gun (KRHCN)",
   label: "Hongcheon-gun (KRHCN)"
  },
  {
   value: "Hongseong-gun (KRHSE)",
   label: "Hongseong-gun (KRHSE)"
  },
  {
   value: "Hwacheon-gun (KRHCH)",
   label: "Hwacheon-gun (KRHCH)"
  },
  {
   value: "Hwaseong (KRHWS)",
   label: "Hwaseong (KRHWS)"
  },
  {
   value: "Hwasong (KRHSO)",
   label: "Hwasong (KRHSO)"
  },
  {
   value: "Hwasun (KRZAD)",
   label: "Hwasun (KRZAD)"
  },
  {
   value: "Hwasun-gun (KRHSN)",
   label: "Hwasun-gun (KRHSN)"
  },
  {
   value: "Hyeondo-myeon\/Cheongwon-gun (KRHDM)",
   label: "Hyeondo-myeon\/Cheongwon-gun (KRHDM)"
  },
  {
   value: "Icheon (KRICE)",
   label: "Icheon (KRICE)"
  },
  {
   value: "Iksan (KRIKS)",
   label: "Iksan (KRIKS)"
  },
  {
   value: "Imsil-gun (KRISL)",
   label: "Imsil-gun (KRISL)"
  },
  {
   value: "Incheon (KRICH)",
   label: "Incheon (KRICH)"
  },
  {
   value: "Incheon Intl Apt\/Seoul (KRICN)",
   label: "Incheon Intl Apt\/Seoul (KRICN)"
  },
  {
   value: "Inje-gun (KRIJE)",
   label: "Inje-gun (KRIJE)"
  },
  {
   value: "Jangheung-gun (KRJHG)",
   label: "Jangheung-gun (KRJHG)"
  },
  {
   value: "Jangsu-gun (KRJSU)",
   label: "Jangsu-gun (KRJSU)"
  },
  {
   value: "Jecheon (KRJCH)",
   label: "Jecheon (KRJCH)"
  },
  {
   value: "Jeongeup (KRJEO)",
   label: "Jeongeup (KRJEO)"
  },
  {
   value: "Jeongseon-gun (KRJSE)",
   label: "Jeongseon-gun (KRJSE)"
  },
  {
   value: "Jeonju (KRJNJ)",
   label: "Jeonju (KRJNJ)"
  },
  {
   value: "Jeungpyeung (KRJYG)",
   label: "Jeungpyeung (KRJYG)"
  },
  {
   value: "Jinan-gun (KRJAN)",
   label: "Jinan-gun (KRJAN)"
  },
  {
   value: "Jincheon-gun (KRJCN)",
   label: "Jincheon-gun (KRJCN)"
  },
  {
   value: "Jindo-gun (KRJDO)",
   label: "Jindo-gun (KRJDO)"
  },
  {
   value: "Jochiwon-eup\/Yeongi-gun (KRJCW)",
   label: "Jochiwon-eup\/Yeongi-gun (KRJCW)"
  },
  {
   value: "Koje (KRZAF)",
   label: "Koje (KRZAF)"
  },
  {
   value: "Koryong (KRZAE)",
   label: "Koryong (KRZAE)"
  },
  {
   value: "Kosong (KRKSO)",
   label: "Kosong (KRKSO)"
  },
  {
   value: "Kunpo (KRZAA)",
   label: "Kunpo (KRZAA)"
  },
  {
   value: "Kunsan (KRKSN)",
   label: "Kunsan (KRKSN)"
  },
  {
   value: "Kwachon (KRKHO)",
   label: "Kwachon (KRKHO)"
  },
  {
   value: "Kwangyang (KRKWA)",
   label: "Kwangyang (KRKWA)"
  },
  {
   value: "Muan-gun (KRMAN)",
   label: "Muan-gun (KRMAN)"
  },
  {
   value: "Muju-gun (KRMJU)",
   label: "Muju-gun (KRMJU)"
  },
  {
   value: "Mungyeong (KRMGG)",
   label: "Mungyeong (KRMGG)"
  },
  {
   value: "Munmak (KRMKW)",
   label: "Munmak (KRMKW)"
  },
  {
   value: "Munsan\/Paju (KRMSN)",
   label: "Munsan\/Paju (KRMSN)"
  },
  {
   value: "Naju (KRNJU)",
   label: "Naju (KRNJU)"
  },
  {
   value: "Namhae-gun (KRNHE)",
   label: "Namhae-gun (KRNHE)"
  },
  {
   value: "Namwon (KRNWN)",
   label: "Namwon (KRNWN)"
  },
  {
   value: "Namyang\/Goheung-gun (KRNYJ)",
   label: "Namyang\/Goheung-gun (KRNYJ)"
  },
  {
   value: "Namyangju (KRNYU)",
   label: "Namyangju (KRNYU)"
  },
  {
   value: "Nonsan (KRNSN)",
   label: "Nonsan (KRNSN)"
  },
  {
   value: "Ochang (KROCH)",
   label: "Ochang (KROCH)"
  },
  {
   value: "Okcheon-gun (KROCN)",
   label: "Okcheon-gun (KROCN)"
  },
  {
   value: "Paju (KRPJU)",
   label: "Paju (KRPJU)"
  },
  {
   value: "Pocheon (KRPOC)",
   label: "Pocheon (KRPOC)"
  },
  {
   value: "Pry (KRPRY)",
   label: "Pry (KRPRY)"
  },
  {
   value: "Pusan (KRPNC)",
   label: "Pusan (KRPNC)"
  },
  {
   value: "Pyeongchang-gun (KRPCG)",
   label: "Pyeongchang-gun (KRPCG)"
  },
  {
   value: "Pyongtaek (KRPYK)",
   label: "Pyongtaek (KRPYK)"
  },
  {
   value: "Sacheon (KRSAH)",
   label: "Sacheon (KRSAH)"
  },
  {
   value: "Sancheong-gun (KRSCH)",
   label: "Sancheong-gun (KRSCH)"
  },
  {
   value: "Sangju (KRSJU)",
   label: "Sangju (KRSJU)"
  },
  {
   value: "Seocheon-gun (KRSCE)",
   label: "Seocheon-gun (KRSCE)"
  },
  {
   value: "Seocheon-gun (KRSCN)",
   label: "Seocheon-gun (KRSCN)"
  },
  {
   value: "Seongju-gun (KRSEJ)",
   label: "Seongju-gun (KRSEJ)"
  },
  {
   value: "Seongsan-po\/Namjeju-gun (KRSSP)",
   label: "Seongsan-po\/Namjeju-gun (KRSSP)"
  },
  {
   value: "Seosan (KRSSA)",
   label: "Seosan (KRSSA)"
  },
  {
   value: "Siheung (KRSHE)",
   label: "Siheung (KRSHE)"
  },
  {
   value: "Siheung-dong\/Seoul (KRSIG)",
   label: "Siheung-dong\/Seoul (KRSIG)"
  },
  {
   value: "Sinan-gun (KRSAN)",
   label: "Sinan-gun (KRSAN)"
  },
  {
   value: "Songnam (KRSGM)",
   label: "Songnam (KRSGM)"
  },
  {
   value: "Songtan (KRZAH)",
   label: "Songtan (KRZAH)"
  },
  {
   value: "Sunchang-gun (KRSCG)",
   label: "Sunchang-gun (KRSCG)"
  },
  {
   value: "Taebaek (KRTBK)",
   label: "Taebaek (KRTBK)"
  },
  {
   value: "Uijeongbu (KRUIJ)",
   label: "Uijeongbu (KRUIJ)"
  },
  {
   value: "Uiryeong-gun (KRURG)",
   label: "Uiryeong-gun (KRURG)"
  },
  {
   value: "Uiseong-gun (KRUSG)",
   label: "Uiseong-gun (KRUSG)"
  },
  {
   value: "Uljin-gun (KRUJN)",
   label: "Uljin-gun (KRUJN)"
  },
  {
   value: "Ulju-gun\/Ulsan (KRUJU)",
   label: "Ulju-gun\/Ulsan (KRUJU)"
  },
  {
   value: "Ulleung-gun (KRULG)",
   label: "Ulleung-gun (KRULG)"
  },
  {
   value: "Waegwan (KRZAB)",
   label: "Waegwan (KRZAB)"
  },
  {
   value: "Wanju-gun (KRWAJ)",
   label: "Wanju-gun (KRWAJ)"
  },
  {
   value: "Yanggu-gun (KRYGU)",
   label: "Yanggu-gun (KRYGU)"
  },
  {
   value: "Yangju (KRYAJ)",
   label: "Yangju (KRYAJ)"
  },
  {
   value: "Yangju-gun (KRYYU)",
   label: "Yangju-gun (KRYYU)"
  },
  {
   value: "Yangpyeong-gun (KRYPG)",
   label: "Yangpyeong-gun (KRYPG)"
  },
  {
   value: "Yangyang-gun (KRYNY)",
   label: "Yangyang-gun (KRYNY)"
  },
  {
   value: "Yeoju-gun (KRYJU)",
   label: "Yeoju-gun (KRYJU)"
  },
  {
   value: "Yeoncheon-gun (KRYCN)",
   label: "Yeoncheon-gun (KRYCN)"
  },
  {
   value: "Yeongam-gun (KRYAM)",
   label: "Yeongam-gun (KRYAM)"
  },
  {
   value: "Yeongcheon (KRYCH)",
   label: "Yeongcheon (KRYCH)"
  },
  {
   value: "Yeongdeok-gun (KRYDK)",
   label: "Yeongdeok-gun (KRYDK)"
  },
  {
   value: "Yeongdong-gun (KRYDG)",
   label: "Yeongdong-gun (KRYDG)"
  },
  {
   value: "Yeonggwang-gun (KRYGG)",
   label: "Yeonggwang-gun (KRYGG)"
  },
  {
   value: "Yeongi-gun (KRYGI)",
   label: "Yeongi-gun (KRYGI)"
  },
  {
   value: "Yeongju (KRYEJ)",
   label: "Yeongju (KRYEJ)"
  },
  {
   value: "Yeongwol-gun (KRYWL)",
   label: "Yeongwol-gun (KRYWL)"
  },
  {
   value: "Yeongyang-gun (KRYYG)",
   label: "Yeongyang-gun (KRYYG)"
  },
  {
   value: "Yesan (KRYES)",
   label: "Yesan (KRYES)"
  },
  {
   value: "Yoju (KRZAI)",
   label: "Yoju (KRZAI)"
  },
  {
   value: "Yongi (KRYON)",
   label: "Yongi (KRYON)"
  },
  {
   value: "Yongin (KRYNG)",
   label: "Yongin (KRYNG)"
  },
  {
   value: "Yongsan (KRZAC)",
   label: "Yongsan (KRZAC)"
  },
  {
   value: ".KUWAIT (KW)",
   label: ".KUWAIT (KW)"
  },
  {
   value: "Ahmed Al Jaber (KWAHJ)",
   label: "Ahmed Al Jaber (KWAHJ)"
  },
  {
   value: "Al Wafrah (KWWAF)",
   label: "Al Wafrah (KWWAF)"
  },
  {
   value: "Ali al Salem AB (KWAIS)",
   label: "Ali al Salem AB (KWAIS)"
  },
  {
   value: "As Sabahiyah (KWSYA)",
   label: "As Sabahiyah (KWSYA)"
  },
  {
   value: "As Salimiyah (KWSAL)",
   label: "As Salimiyah (KWSAL)"
  },
  {
   value: "As Sulaybikhat (KWKHT)",
   label: "As Sulaybikhat (KWKHT)"
  },
  {
   value: "Camp Arifjan (KWCAJ)",
   label: "Camp Arifjan (KWCAJ)"
  },
  {
   value: "Camp Doha (KWCDH)",
   label: "Camp Doha (KWCDH)"
  },
  {
   value: ".CAYMAN ISLANDS (KY)",
   label: ".CAYMAN ISLANDS (KY)"
  },
  {
   value: ".KAZAKHSTAN (KZ)",
   label: ".KAZAKHSTAN (KZ)"
  },
  {
   value: "Aksay (KZAKS)",
   label: "Aksay (KZAKS)"
  },
  {
   value: "Aktobe (KZABE)",
   label: "Aktobe (KZABE)"
  },
  {
   value: "Alashankou (KZALS)",
   label: "Alashankou (KZALS)"
  },
  {
   value: "Baikonur (KZBKZ)",
   label: "Baikonur (KZBKZ)"
  },
  {
   value: "Bautino (KZBTN)",
   label: "Bautino (KZBTN)"
  },
  {
   value: "Chimkent (KZZAA)",
   label: "Chimkent (KZZAA)"
  },
  {
   value: "Dzhambul (KZDZH)",
   label: "Dzhambul (KZDZH)"
  },
  {
   value: "Kandyagash (KZKYH)",
   label: "Kandyagash (KZKYH)"
  },
  {
   value: "Kokchetav (KZZAC)",
   label: "Kokchetav (KZZAC)"
  },
  {
   value: "Kuryk (KZKUR)",
   label: "Kuryk (KZKUR)"
  },
  {
   value: "Kustanai (KZZAB)",
   label: "Kustanai (KZZAB)"
  },
  {
   value: "Pavlodar (KZPWQ)",
   label: "Pavlodar (KZPWQ)"
  },
  {
   value: "Petropavlovsk (KZPPK)",
   label: "Petropavlovsk (KZPPK)"
  },
  {
   value: "Saryagach (KZSRY)",
   label: "Saryagach (KZSRY)"
  },
  {
   value: "Semey (Semipalatinsk) (KZPLX)",
   label: "Semey (Semipalatinsk) (KZPLX)"
  },
  {
   value: "Shchuchinsk (KZSCK)",
   label: "Shchuchinsk (KZSCK)"
  },
  {
   value: "Shubarkuduk (KZSHU)",
   label: "Shubarkuduk (KZSHU)"
  },
  {
   value: "Temirtau (KZTAU)",
   label: "Temirtau (KZTAU)"
  },
  {
   value: "Tengiz (KZTGZ)",
   label: "Tengiz (KZTGZ)"
  },
  {
   value: "Uzen (KZUZE)",
   label: "Uzen (KZUZE)"
  },
  {
   value: "Zyryanovsk (KZZYR)",
   label: "Zyryanovsk (KZZYR)"
  },
  {
   value: "Thanaleng (LATHG)",
   label: "Thanaleng (LATHG)"
  },
  {
   value: "Thanalouang (LATLE)",
   label: "Thanalouang (LATLE)"
  },
  {
   value: ".LEBANON (LB)",
   label: ".LEBANON (LB)"
  },
  {
   value: "Ad Dubayyah (LBDBA)",
   label: "Ad Dubayyah (LBDBA)"
  },
  {
   value: "Beirut Free Zone (LBBFZ)",
   label: "Beirut Free Zone (LBBFZ)"
  },
  {
   value: "En Nâqoûra (LBNAQ)",
   label: "En Nâqoûra (LBNAQ)"
  },
  {
   value: ".SAINT LUCIA (LC)",
   label: ".SAINT LUCIA (LC)"
  },
  {
   value: "Castries (LCCAS)",
   label: "Castries (LCCAS)"
  },
  {
   value: ".LIECHTENSTEIN (LI)",
   label: ".LIECHTENSTEIN (LI)"
  },
  {
   value: "Balzers (LIBAZ)",
   label: "Balzers (LIBAZ)"
  },
  {
   value: "Eschen (LIESC)",
   label: "Eschen (LIESC)"
  },
  {
   value: "Ruggell (LIRGL)",
   label: "Ruggell (LIRGL)"
  },
  {
   value: "Schaan (LISCN)",
   label: "Schaan (LISCN)"
  },
  {
   value: "Schaanwald (LISCH)",
   label: "Schaanwald (LISCH)"
  },
  {
   value: "Vaduz (LIVDZ)",
   label: "Vaduz (LIVDZ)"
  },
  {
   value: ".SRI LANKA (LK)",
   label: ".SRI LANKA (LK)"
  },
  {
   value: "Dekantana (LKDEK)",
   label: "Dekantana (LKDEK)"
  },
  {
   value: "Hatton (LKHAT)",
   label: "Hatton (LKHAT)"
  },
  {
   value: "Jaya Container Terminal (LKJCT)",
   label: "Jaya Container Terminal (LKJCT)"
  },
  {
   value: "Katukurunda (LKKTK)",
   label: "Katukurunda (LKKTK)"
  },
  {
   value: "Kilinochchi (LKKIL)",
   label: "Kilinochchi (LKKIL)"
  },
  {
   value: "Koggala (LKKCT)",
   label: "Koggala (LKKCT)"
  },
  {
   value: "Kondavattavan (LKKON)",
   label: "Kondavattavan (LKKON)"
  },
  {
   value: "Konwelana (LKKNW)",
   label: "Konwelana (LKKNW)"
  },
  {
   value: "Kuliyapitiya (LKKUL)",
   label: "Kuliyapitiya (LKKUL)"
  },
  {
   value: "Mawella (LKMAW)",
   label: "Mawella (LKMAW)"
  },
  {
   value: "Nittambuwa (LKNBW)",
   label: "Nittambuwa (LKNBW)"
  },
  {
   value: "Pannala (LKPAN)",
   label: "Pannala (LKPAN)"
  },
  {
   value: "Ratmalana (LKRAT)",
   label: "Ratmalana (LKRAT)"
  },
  {
   value: "Ratnapura (LKRPU)",
   label: "Ratnapura (LKRPU)"
  },
  {
   value: "Sigiriya (LKSIG)",
   label: "Sigiriya (LKSIG)"
  },
  {
   value: "South Asia Gateway Terminal (LKSGT)",
   label: "South Asia Gateway Terminal (LKSGT)"
  },
  {
   value: "Sri Jayawardenapura (LKSRJ)",
   label: "Sri Jayawardenapura (LKSRJ)"
  },
  {
   value: "Uhana (LKUHA)",
   label: "Uhana (LKUHA)"
  },
  {
   value: "Unity Container Terminal (LKUCT)",
   label: "Unity Container Terminal (LKUCT)"
  },
  {
   value: ".LIBERIA (LR)",
   label: ".LIBERIA (LR)"
  },
  {
   value: ".LESOTHO (LS)",
   label: ".LESOTHO (LS)"
  },
  {
   value: "Maputsoe (LSMPS)",
   label: "Maputsoe (LSMPS)"
  },
  {
   value: ".LITHUANIA (LT)",
   label: ".LITHUANIA (LT)"
  },
  {
   value: "Alytus (LTAYS)",
   label: "Alytus (LTAYS)"
  },
  {
   value: "Anyksciai (LTZAB)",
   label: "Anyksciai (LTZAB)"
  },
  {
   value: "Avizieniai (LTAZI)",
   label: "Avizieniai (LTAZI)"
  },
  {
   value: "Betygala (LTBET)",
   label: "Betygala (LTBET)"
  },
  {
   value: "Birstonas (LTBIR)",
   label: "Birstonas (LTBIR)"
  },
  {
   value: "Botingé (LTBOT)",
   label: "Botingé (LTBOT)"
  },
  {
   value: "Buikiske (LTBUI)",
   label: "Buikiske (LTBUI)"
  },
  {
   value: "Didzioji Reise (LTDID)",
   label: "Didzioji Reise (LTDID)"
  },
  {
   value: "Druskininkai (LTDKI)",
   label: "Druskininkai (LTDKI)"
  },
  {
   value: "Elektrenai (LTETI)",
   label: "Elektrenai (LTETI)"
  },
  {
   value: "Gargzdai (LTGGZ)",
   label: "Gargzdai (LTGGZ)"
  },
  {
   value: "Gargzdai (LTGZD)",
   label: "Gargzdai (LTGZD)"
  },
  {
   value: "Glitiskes (LTGLI)",
   label: "Glitiskes (LTGLI)"
  },
  {
   value: "Grinkiskis (LTGKS)",
   label: "Grinkiskis (LTGKS)"
  },
  {
   value: "Gustonys (LTGTY)",
   label: "Gustonys (LTGTY)"
  },
  {
   value: "Jasiunai (LTOND)",
   label: "Jasiunai (LTOND)"
  },
  {
   value: "Jonava (LTJNA)",
   label: "Jonava (LTJNA)"
  },
  {
   value: "Joniskis (LTJON)",
   label: "Joniskis (LTJON)"
  },
  {
   value: "Jurbarkas (LTJUR)",
   label: "Jurbarkas (LTJUR)"
  },
  {
   value: "Kaisiadorio (LTKDO)",
   label: "Kaisiadorio (LTKDO)"
  },
  {
   value: "Kaisiadorys (LTZAA)",
   label: "Kaisiadorys (LTZAA)"
  },
  {
   value: "Kalote (LTKTE)",
   label: "Kalote (LTKTE)"
  },
  {
   value: "Kazlu Ruda (LTKRA)",
   label: "Kazlu Ruda (LTKRA)"
  },
  {
   value: "Kedainiai (LTKDN)",
   label: "Kedainiai (LTKDN)"
  },
  {
   value: "Kelme (LTKEL)",
   label: "Kelme (LTKEL)"
  },
  {
   value: "Klovainiai (LTKLO)",
   label: "Klovainiai (LTKLO)"
  },
  {
   value: "Kretinga (LTKRE)",
   label: "Kretinga (LTKRE)"
  },
  {
   value: "Kretingsodis (LTKET)",
   label: "Kretingsodis (LTKET)"
  },
  {
   value: "Kupiskis (LTKUP)",
   label: "Kupiskis (LTKUP)"
  },
  {
   value: "Kursénai (LTKUR)",
   label: "Kursénai (LTKUR)"
  },
  {
   value: "Laukesa (LTLUA)",
   label: "Laukesa (LTLUA)"
  },
  {
   value: "Lazdijai (LTLAZ)",
   label: "Lazdijai (LTLAZ)"
  },
  {
   value: "Lentvaris (LTLEN)",
   label: "Lentvaris (LTLEN)"
  },
  {
   value: "Liudyne (LTLDY)",
   label: "Liudyne (LTLDY)"
  },
  {
   value: "Maisiagala&nbsp; (LTMAI)",
   label: "Maisiagala&nbsp; (LTMAI)"
  },
  {
   value: "Mazeikiai (LTMZK)",
   label: "Mazeikiai (LTMZK)"
  },
  {
   value: "Mockava (LTMOC)",
   label: "Mockava (LTMOC)"
  },
  {
   value: "Moletai (LTMLI)",
   label: "Moletai (LTMLI)"
  },
  {
   value: "Mosedis (LTMOS)",
   label: "Mosedis (LTMOS)"
  },
  {
   value: "Musninkai (LTMNK)",
   label: "Musninkai (LTMNK)"
  },
  {
   value: "Naujoji Akmene (LTNAK)",
   label: "Naujoji Akmene (LTNAK)"
  },
  {
   value: "Nemaksciai (LTNMS)",
   label: "Nemaksciai (LTNMS)"
  },
  {
   value: "Nida (LTNID)",
   label: "Nida (LTNID)"
  },
  {
   value: "Pabrade (LTPAB)",
   label: "Pabrade (LTPAB)"
  },
  {
   value: "Pagegiai (LTPGI)",
   label: "Pagegiai (LTPGI)"
  },
  {
   value: "Pakruojis (LTPKJ)",
   label: "Pakruojis (LTPKJ)"
  },
  {
   value: "Pasvalys (LTPVS)",
   label: "Pasvalys (LTPVS)"
  },
  {
   value: "Pelednagiai (LTPNA)",
   label: "Pelednagiai (LTPNA)"
  },
  {
   value: "Petrasiunai (LTPET)",
   label: "Petrasiunai (LTPET)"
  },
  {
   value: "Plunges (LTPLG)",
   label: "Plunges (LTPLG)"
  },
  {
   value: "Prienai (LTPRI)",
   label: "Prienai (LTPRI)"
  },
  {
   value: "Pusalotas (LTPLS)",
   label: "Pusalotas (LTPLS)"
  },
  {
   value: "Radviliskis (LTRVS)",
   label: "Radviliskis (LTRVS)"
  },
  {
   value: "Raseiniai (LTRAS)",
   label: "Raseiniai (LTRAS)"
  },
  {
   value: "Rietavas (LTRTS)",
   label: "Rietavas (LTRTS)"
  },
  {
   value: "Rokiskis (LTRKS)",
   label: "Rokiskis (LTRKS)"
  },
  {
   value: "Salcininkai (LTSNI)",
   label: "Salcininkai (LTSNI)"
  },
  {
   value: "Senieji Trakai (LTSTR)",
   label: "Senieji Trakai (LTSTR)"
  },
  {
   value: "Sestokai (LTSSK)",
   label: "Sestokai (LTSSK)"
  },
  {
   value: "Silale (LTSLE)",
   label: "Silale (LTSLE)"
  },
  {
   value: "Silute (LTSIL)",
   label: "Silute (LTSIL)"
  },
  {
   value: "Sirvintos (LTSRV)",
   label: "Sirvintos (LTSRV)"
  },
  {
   value: "Skuodas (LTSKU)",
   label: "Skuodas (LTSKU)"
  },
  {
   value: "Svencoinys (LTSVE)",
   label: "Svencoinys (LTSVE)"
  },
  {
   value: "Tauragé (LTTAU)",
   label: "Tauragé (LTTAU)"
  },
  {
   value: "Telsiai (LTTEL)",
   label: "Telsiai (LTTEL)"
  },
  {
   value: "Trakai (LTTKI)",
   label: "Trakai (LTTKI)"
  },
  {
   value: "Traksedis (LTTKS)",
   label: "Traksedis (LTTKS)"
  },
  {
   value: "Tytuvenai (LTTVI)",
   label: "Tytuvenai (LTTVI)"
  },
  {
   value: "Ukmerge (LTUKE)",
   label: "Ukmerge (LTUKE)"
  },
  {
   value: "Utena (LTUTA)",
   label: "Utena (LTUTA)"
  },
  {
   value: "Vandziogala (LTVAN)",
   label: "Vandziogala (LTVAN)"
  },
  {
   value: "Varena (LTVRN)",
   label: "Varena (LTVRN)"
  },
  {
   value: "Vievis (LTVEV)",
   label: "Vievis (LTVEV)"
  },
  {
   value: "Vilkaviskis (LTVKV)",
   label: "Vilkaviskis (LTVKV)"
  },
  {
   value: "Visaginas (LTVIS)",
   label: "Visaginas (LTVIS)"
  },
  {
   value: "Zapishkis (LTZAP)",
   label: "Zapishkis (LTZAP)"
  },
  {
   value: "Zarasai (LTZAR)",
   label: "Zarasai (LTZAR)"
  },
  {
   value: "Ziezmariai (LTZZM)",
   label: "Ziezmariai (LTZZM)"
  },
  {
   value: ".LUXEMBOURG (LU)",
   label: ".LUXEMBOURG (LU)"
  },
  {
   value: "Alzingen (LUAZN)",
   label: "Alzingen (LUAZN)"
  },
  {
   value: "Asselborn (LUDEH)",
   label: "Asselborn (LUDEH)"
  },
  {
   value: "Bascharage (LUBSC)",
   label: "Bascharage (LUBSC)"
  },
  {
   value: "Bech-Kleinmacher (LUBKM)",
   label: "Bech-Kleinmacher (LUBKM)"
  },
  {
   value: "Beckerich (LUBKE)",
   label: "Beckerich (LUBKE)"
  },
  {
   value: "Béreldange (LUBDG)",
   label: "Béreldange (LUBDG)"
  },
  {
   value: "Berg-sur-Syre (LUBRG)",
   label: "Berg-sur-Syre (LUBRG)"
  },
  {
   value: "Bertrange (LUBRE)",
   label: "Bertrange (LUBRE)"
  },
  {
   value: "Bigonville (LUBGL)",
   label: "Bigonville (LUBGL)"
  },
  {
   value: "Bockholtz (LUBOC)",
   label: "Bockholtz (LUBOC)"
  },
  {
   value: "Boudler (LUBDB)",
   label: "Boudler (LUBDB)"
  },
  {
   value: "Bridel (LUBDL)",
   label: "Bridel (LUBDL)"
  },
  {
   value: "Clemency (LUCMY)",
   label: "Clemency (LUCMY)"
  },
  {
   value: "Differdange (LUDDE)",
   label: "Differdange (LUDDE)"
  },
  {
   value: "Ehlerange (LUEHL)",
   label: "Ehlerange (LUEHL)"
  },
  {
   value: "Ellange (LUELL)",
   label: "Ellange (LUELL)"
  },
  {
   value: "Ernster (LUESR)",
   label: "Ernster (LUESR)"
  },
  {
   value: "Esch-sur-Alzette (LUEZT)",
   label: "Esch-sur-Alzette (LUEZT)"
  },
  {
   value: "Eselborn (LUEBN)",
   label: "Eselborn (LUEBN)"
  },
  {
   value: "Fentange (LUFEN)",
   label: "Fentange (LUFEN)"
  },
  {
   value: "Findel (LUFDL)",
   label: "Findel (LUFDL)"
  },
  {
   value: "Foetz (LUFOZ)",
   label: "Foetz (LUFOZ)"
  },
  {
   value: "Grevenmacher (LUGVC)",
   label: "Grevenmacher (LUGVC)"
  },
  {
   value: "Hesperange (LUHES)",
   label: "Hesperange (LUHES)"
  },
  {
   value: "Holzem (LUHLZ)",
   label: "Holzem (LUHLZ)"
  },
  {
   value: "Hünsdorf (LUHDF)",
   label: "Hünsdorf (LUHDF)"
  },
  {
   value: "Itzig (LUIZG)",
   label: "Itzig (LUIZG)"
  },
  {
   value: "Kayl (LUKAY)",
   label: "Kayl (LUKAY)"
  },
  {
   value: "Kehlen (LUKHL)",
   label: "Kehlen (LUKHL)"
  },
  {
   value: "Kockelscheuer (LUKKR)",
   label: "Kockelscheuer (LUKKR)"
  },
  {
   value: "Koetschette (LUKOE)",
   label: "Koetschette (LUKOE)"
  },
  {
   value: "Lentzweiler (LULTZ)",
   label: "Lentzweiler (LULTZ)"
  },
  {
   value: "Livange (LULVG)",
   label: "Livange (LULVG)"
  },
  {
   value: "Lorentzweiler (LULWR)",
   label: "Lorentzweiler (LULWR)"
  },
  {
   value: "Mamer (LUMME)",
   label: "Mamer (LUMME)"
  },
  {
   value: "Mersch (LUJEU)",
   label: "Mersch (LUJEU)"
  },
  {
   value: "Mertert (LUMRT)",
   label: "Mertert (LUMRT)"
  },
  {
   value: "Mondorf-les-Bains (LUMBS)",
   label: "Mondorf-les-Bains (LUMBS)"
  },
  {
   value: "Moutfort (LUMFT)",
   label: "Moutfort (LUMFT)"
  },
  {
   value: "Münsbach (LUMUN)",
   label: "Münsbach (LUMUN)"
  },
  {
   value: "Niederanven (LUNAN)",
   label: "Niederanven (LUNAN)"
  },
  {
   value: "Oberanven (LUOBR)",
   label: "Oberanven (LUOBR)"
  },
  {
   value: "Olm (LUOLM)",
   label: "Olm (LUOLM)"
  },
  {
   value: "Ospern (LUOSP)",
   label: "Ospern (LUOSP)"
  },
  {
   value: "Pétange (LUPTN)",
   label: "Pétange (LUPTN)"
  },
  {
   value: "Pontpierre (LUPPR)",
   label: "Pontpierre (LUPPR)"
  },
  {
   value: "Pratz (LUPTZ)",
   label: "Pratz (LUPTZ)"
  },
  {
   value: "Redange (LURDN)",
   label: "Redange (LURDN)"
  },
  {
   value: "Remich (LUREM)",
   label: "Remich (LUREM)"
  },
  {
   value: "Roost (LUROS)",
   label: "Roost (LUROS)"
  },
  {
   value: "Rost (LURST)",
   label: "Rost (LURST)"
  },
  {
   value: "Rumelange (LURUM)",
   label: "Rumelange (LURUM)"
  },
  {
   value: "Sandweiler (LUSWL)",
   label: "Sandweiler (LUSWL)"
  },
  {
   value: "Schifflange (LUSFG)",
   label: "Schifflange (LUSFG)"
  },
  {
   value: "Senningen (LUSGB)",
   label: "Senningen (LUSGB)"
  },
  {
   value: "Soleuvre (LUSOL)",
   label: "Soleuvre (LUSOL)"
  },
  {
   value: "Strassen (LUSTN)",
   label: "Strassen (LUSTN)"
  },
  {
   value: "Wecker (LUWEK)",
   label: "Wecker (LUWEK)"
  },
  {
   value: ".LATVIA (LV)",
   label: ".LATVIA (LV)"
  },
  {
   value: "Adazi (LVZRA)",
   label: "Adazi (LVZRA)"
  },
  {
   value: "Ainazi (LVAIN)",
   label: "Ainazi (LVAIN)"
  },
  {
   value: "Aizkraukle (LVAIZ)",
   label: "Aizkraukle (LVAIZ)"
  },
  {
   value: "Aizpute (LVAPE)",
   label: "Aizpute (LVAPE)"
  },
  {
   value: "Akniste (LVAKI)",
   label: "Akniste (LVAKI)"
  },
  {
   value: "Aluksne (LVASE)",
   label: "Aluksne (LVASE)"
  },
  {
   value: "Auce (LVAUC)",
   label: "Auce (LVAUC)"
  },
  {
   value: "Baltmarine Terminal, Riga (LVBMT)",
   label: "Baltmarine Terminal, Riga (LVBMT)"
  },
  {
   value: "Bauska (LVBAU)",
   label: "Bauska (LVBAU)"
  },
  {
   value: "Briezuciems (LVBZC)",
   label: "Briezuciems (LVBZC)"
  },
  {
   value: "Broceni (LVBRC)",
   label: "Broceni (LVBRC)"
  },
  {
   value: "Cesis (LVCES)",
   label: "Cesis (LVCES)"
  },
  {
   value: "Dobele (LVDOB)",
   label: "Dobele (LVDOB)"
  },
  {
   value: "Garkalne (LVGKE)",
   label: "Garkalne (LVGKE)"
  },
  {
   value: "Grebneva (LVGRE)",
   label: "Grebneva (LVGRE)"
  },
  {
   value: "Grobina (LVGBA)",
   label: "Grobina (LVGBA)"
  },
  {
   value: "Gulbene (LVGUL)",
   label: "Gulbene (LVGUL)"
  },
  {
   value: "Incukalns (LVICK)",
   label: "Incukalns (LVICK)"
  },
  {
   value: "Jaunauce (LVJAU)",
   label: "Jaunauce (LVJAU)"
  },
  {
   value: "Jaunpagasts (LVJAP)",
   label: "Jaunpagasts (LVJAP)"
  },
  {
   value: "Jekabpils (LVJPS)",
   label: "Jekabpils (LVJPS)"
  },
  {
   value: "Jelgava (LVJGA)",
   label: "Jelgava (LVJGA)"
  },
  {
   value: "Jurmala (LVZJA)",
   label: "Jurmala (LVZJA)"
  },
  {
   value: "Koknese (LVZKE)",
   label: "Koknese (LVZKE)"
  },
  {
   value: "Kraslava (LVKRA)",
   label: "Kraslava (LVKRA)"
  },
  {
   value: "Kuldiga (LVKDA)",
   label: "Kuldiga (LVKDA)"
  },
  {
   value: "Lapmezciems (LVLMS)",
   label: "Lapmezciems (LVLMS)"
  },
  {
   value: "Launkalne (LVLAU)",
   label: "Launkalne (LVLAU)"
  },
  {
   value: "Limbazi (LVLBZ)",
   label: "Limbazi (LVLBZ)"
  },
  {
   value: "Livani (LVLVI)",
   label: "Livani (LVLVI)"
  },
  {
   value: "Lizums (LVLZS)",
   label: "Lizums (LVLZS)"
  },
  {
   value: "Madona (LVMAD)",
   label: "Madona (LVMAD)"
  },
  {
   value: "Malta (LVMAL)",
   label: "Malta (LVMAL)"
  },
  {
   value: "Mangali (LVMGI)",
   label: "Mangali (LVMGI)"
  },
  {
   value: "Mersrags (LVMRX)",
   label: "Mersrags (LVMRX)"
  },
  {
   value: "Ogre (LVORE)",
   label: "Ogre (LVORE)"
  },
  {
   value: "Olaine (LVOLA)",
   label: "Olaine (LVOLA)"
  },
  {
   value: "Pabazi (LVPBZ)",
   label: "Pabazi (LVPBZ)"
  },
  {
   value: "Pace (LVPAC)",
   label: "Pace (LVPAC)"
  },
  {
   value: "Paternieki (LVPAT)",
   label: "Paternieki (LVPAT)"
  },
  {
   value: "Pinki (LVPIN)",
   label: "Pinki (LVPIN)"
  },
  {
   value: "Ploce (LVPLC)",
   label: "Ploce (LVPLC)"
  },
  {
   value: "Preli (Preili) (LVPRE)",
   label: "Preli (Preili) (LVPRE)"
  },
  {
   value: "Rauna (LVRNA)",
   label: "Rauna (LVRNA)"
  },
  {
   value: "Rezekne (LVREZ)",
   label: "Rezekne (LVREZ)"
  },
  {
   value: "Roja (LVROJ)",
   label: "Roja (LVROJ)"
  },
  {
   value: "Rucava (LVZRU)",
   label: "Rucava (LVZRU)"
  },
  {
   value: "Salacgriva (LVSAL)",
   label: "Salacgriva (LVSAL)"
  },
  {
   value: "Salaspils (LVSPS)",
   label: "Salaspils (LVSPS)"
  },
  {
   value: "Saldus (LVSDS)",
   label: "Saldus (LVSDS)"
  },
  {
   value: "Sarkani (LVSAR)",
   label: "Sarkani (LVSAR)"
  },
  {
   value: "Seda (LVZSA)",
   label: "Seda (LVZSA)"
  },
  {
   value: "Skulte (LVSKU)",
   label: "Skulte (LVSKU)"
  },
  {
   value: "Smiltene (LVSTE)",
   label: "Smiltene (LVSTE)"
  },
  {
   value: "Talsi (LVTSI)",
   label: "Talsi (LVTSI)"
  },
  {
   value: "Terehova (LVTER)",
   label: "Terehova (LVTER)"
  },
  {
   value: "Tukums (LVTKM)",
   label: "Tukums (LVTKM)"
  },
  {
   value: "Valdgale (LVVGE)",
   label: "Valdgale (LVVGE)"
  },
  {
   value: "Valka (LVVAL)",
   label: "Valka (LVVAL)"
  },
  {
   value: "Valle (LVVLL)",
   label: "Valle (LVVLL)"
  },
  {
   value: "Valmiera (LVVIA)",
   label: "Valmiera (LVVIA)"
  },
  {
   value: "Vangazi (LVVGI)",
   label: "Vangazi (LVVGI)"
  },
  {
   value: "Zakumuiza (LVZAK)",
   label: "Zakumuiza (LVZAK)"
  },
  {
   value: "Zilaiskalns (LVZIL)",
   label: "Zilaiskalns (LVZIL)"
  },
  {
   value: ".LIBYAN ARAB JAMAHIRIYA (LY)",
   label: ".LIBYAN ARAB JAMAHIRIYA (LY)"
  },
  {
   value: "El Choms (LYELK)",
   label: "El Choms (LYELK)"
  },
  {
   value: "Houn (LYHUQ)",
   label: "Houn (LYHUQ)"
  },
  {
   value: "Marsá Al Burayqah (LYMBR)",
   label: "Marsá Al Burayqah (LYMBR)"
  },
  {
   value: "Melittah (LYMTH)",
   label: "Melittah (LYMTH)"
  },
  {
   value: "Mellitah (Qasr Ahmed) (LYMEL)",
   label: "Mellitah (Qasr Ahmed) (LYMEL)"
  },
  {
   value: ".MOROCCO (MA)",
   label: ".MOROCCO (MA)"
  },
  {
   value: "Ain Beni Mathar (MAMTH)",
   label: "Ain Beni Mathar (MAMTH)"
  },
  {
   value: "Aïn Sebaa (MAASE)",
   label: "Aïn Sebaa (MAASE)"
  },
  {
   value: "Ait Baha (MABAH)",
   label: "Ait Baha (MABAH)"
  },
  {
   value: "Ait Melloul (MAZAL)",
   label: "Ait Melloul (MAZAL)"
  },
  {
   value: "Bouskoura (MABOS)",
   label: "Bouskoura (MABOS)"
  },
  {
   value: "Imi-n-Tanoute (MAZIE)",
   label: "Imi-n-Tanoute (MAZIE)"
  },
  {
   value: "Ksar Majaz (MAKMA)",
   label: "Ksar Majaz (MAKMA)"
  },
  {
   value: "Saidia (MAZSA)",
   label: "Saidia (MAZSA)"
  },
  {
   value: "Skhirat (MAZSB)",
   label: "Skhirat (MAZSB)"
  },
  {
   value: "Tanger Med (MAPTM)",
   label: "Tanger Med (MAPTM)"
  },
  {
   value: "Temara (MATEM)",
   label: "Temara (MATEM)"
  },
  {
   value: "Tinerhir (MATHI)",
   label: "Tinerhir (MATHI)"
  },
  {
   value: "Tiznit (MATZI)",
   label: "Tiznit (MATZI)"
  },
  {
   value: ".MONACO (MC)",
   label: ".MONACO (MC)"
  },
  {
   value: ".MOLDOVA, REPUBLIC OF (MD)",
   label: ".MOLDOVA, REPUBLIC OF (MD)"
  },
  {
   value: "Bendery (MDTBY)",
   label: "Bendery (MDTBY)"
  },
  {
   value: "Cantemir (MDCAN)",
   label: "Cantemir (MDCAN)"
  },
  {
   value: "Ialoven (MDMJN)",
   label: "Ialoven (MDMJN)"
  },
  {
   value: "Kupchino (MDMKO)",
   label: "Kupchino (MDMKO)"
  },
  {
   value: "Leusheny (MDLEU)",
   label: "Leusheny (MDLEU)"
  },
  {
   value: "Ribnita (MDRIB)",
   label: "Ribnita (MDRIB)"
  },
  {
   value: "Tiraspol (MDTIR)",
   label: "Tiraspol (MDTIR)"
  },
  {
   value: "Vulcanesti (MDVUL)",
   label: "Vulcanesti (MDVUL)"
  },
  {
   value: ".MONTENEGRO (ME)",
   label: ".MONTENEGRO (ME)"
  },
  {
   value: "Bar (MEBAR)",
   label: "Bar (MEBAR)"
  },
  {
   value: "Berane (Yvangrad) (MEIVG)",
   label: "Berane (Yvangrad) (MEIVG)"
  },
  {
   value: "Bijela (MEBIJ)",
   label: "Bijela (MEBIJ)"
  },
  {
   value: "Bijelo Polje (MEBOP)",
   label: "Bijelo Polje (MEBOP)"
  },
  {
   value: "Budva (MEBUD)",
   label: "Budva (MEBUD)"
  },
  {
   value: "Hercegnovi (MEHNO)",
   label: "Hercegnovi (MEHNO)"
  },
  {
   value: "Igalo (MEIGL)",
   label: "Igalo (MEIGL)"
  },
  {
   value: "Kotor (MEKOT)",
   label: "Kotor (MEKOT)"
  },
  {
   value: "Niksic (MENIK)",
   label: "Niksic (MENIK)"
  },
  {
   value: "Petrovac (MEPVC)",
   label: "Petrovac (MEPVC)"
  },
  {
   value: "Podgorica (METGD)",
   label: "Podgorica (METGD)"
  },
  {
   value: "Risan (Risano) (MERSN)",
   label: "Risan (Risano) (MERSN)"
  },
  {
   value: "Tivat (METIV)",
   label: "Tivat (METIV)"
  },
  {
   value: "Ulcinj (MEULC)",
   label: "Ulcinj (MEULC)"
  },
  {
   value: "Zabljak (MEZBK)",
   label: "Zabljak (MEZBK)"
  },
  {
   value: "Zelenika (MEZEL)",
   label: "Zelenika (MEZEL)"
  },
  {
   value: ".MADAGASCAR (MG)",
   label: ".MADAGASCAR (MG)"
  },
  {
   value: "Taolagnaro (MGTLN)",
   label: "Taolagnaro (MGTLN)"
  },
  {
   value: ".MARSHALL ISLANDS (MH)",
   label: ".MARSHALL ISLANDS (MH)"
  },
  {
   value: "Ailuk I. (MHAIM)",
   label: "Ailuk I. (MHAIM)"
  },
  {
   value: "Airok (MHAIC)",
   label: "Airok (MHAIC)"
  },
  {
   value: "Enyu Airfield, Bikini (MHBII)",
   label: "Enyu Airfield, Bikini (MHBII)"
  },
  {
   value: ".MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF (MK)",
   label: ".MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF (MK)"
  },
  {
   value: "Bogdanci (MKBDA)",
   label: "Bogdanci (MKBDA)"
  },
  {
   value: "Debar (MKDEB)",
   label: "Debar (MKDEB)"
  },
  {
   value: "Demir Kapija (MKDKJ)",
   label: "Demir Kapija (MKDKJ)"
  },
  {
   value: "Karbinci (MKKBI)",
   label: "Karbinci (MKKBI)"
  },
  {
   value: "Kocani (MKKCI)",
   label: "Kocani (MKKCI)"
  },
  {
   value: "Kosovo (MKKOS)",
   label: "Kosovo (MKKOS)"
  },
  {
   value: "Lozovo (MKLOZ)",
   label: "Lozovo (MKLOZ)"
  },
  {
   value: "Miravci (MKMIR)",
   label: "Miravci (MKMIR)"
  },
  {
   value: "Novi Dojran (MKNOD)",
   label: "Novi Dojran (MKNOD)"
  },
  {
   value: "Oblesevo (MKOBL)",
   label: "Oblesevo (MKOBL)"
  },
  {
   value: "Probistip (MKPRO)",
   label: "Probistip (MKPRO)"
  },
  {
   value: "Sveti Nikole (MKSNI)",
   label: "Sveti Nikole (MKSNI)"
  },
  {
   value: "Titov Veles (MKMTS)",
   label: "Titov Veles (MKMTS)"
  },
  {
   value: "Valandovo (MKVAL)",
   label: "Valandovo (MKVAL)"
  },
  {
   value: "Veles (MKTTV)",
   label: "Veles (MKTTV)"
  },
  {
   value: "Vinica (MKVIN)",
   label: "Vinica (MKVIN)"
  },
  {
   value: ".MALI (ML)",
   label: ".MALI (ML)"
  },
  {
   value: "Ambidédi (MLAMB)",
   label: "Ambidédi (MLAMB)"
  },
  {
   value: "Goundam (MLGUD)",
   label: "Goundam (MLGUD)"
  },
  {
   value: "Kenieba (MLKNZ)",
   label: "Kenieba (MLKNZ)"
  },
  {
   value: "Korouma (MLKOR)",
   label: "Korouma (MLKOR)"
  },
  {
   value: "Mahina (MLMAI)",
   label: "Mahina (MLMAI)"
  },
  {
   value: "Morila (MLMOR)",
   label: "Morila (MLMOR)"
  },
  {
   value: "Ndébougou (MLNDE)",
   label: "Ndébougou (MLNDE)"
  },
  {
   value: "Négala (MLNEG)",
   label: "Négala (MLNEG)"
  },
  {
   value: "Niono (MLNIO)",
   label: "Niono (MLNIO)"
  },
  {
   value: "Sadiola (MLSLA)",
   label: "Sadiola (MLSLA)"
  },
  {
   value: "San (MLSAN)",
   label: "San (MLSAN)"
  },
  {
   value: "Sévaré (MLSEV)",
   label: "Sévaré (MLSEV)"
  },
  {
   value: "Sikasso (MLSIK)",
   label: "Sikasso (MLSIK)"
  },
  {
   value: "Tombouctou (MLTOM)",
   label: "Tombouctou (MLTOM)"
  },
  {
   value: "Touana (MLTOU)",
   label: "Touana (MLTOU)"
  },
  {
   value: "Yatéla (MLYAT)",
   label: "Yatéla (MLYAT)"
  },
  {
   value: ".MYANMAR (MM)",
   label: ".MYANMAR (MM)"
  },
  {
   value: "Male (MMMXE)",
   label: "Male (MMMXE)"
  },
  {
   value: "Prome (MMPRU)",
   label: "Prome (MMPRU)"
  },
  {
   value: ".MONGOLIA (MN)",
   label: ".MONGOLIA (MN)"
  },
  {
   value: "Dzamïn Üüd (MNDZU)",
   label: "Dzamïn Üüd (MNDZU)"
  },
  {
   value: "Hatgal (MNHAT)",
   label: "Hatgal (MNHAT)"
  },
  {
   value: "Tosontsengel (MNTOS)",
   label: "Tosontsengel (MNTOS)"
  },
  {
   value: ".MACAO (MO)",
   label: ".MACAO (MO)"
  },
  {
   value: "Macau (MOMFM)",
   label: "Macau (MOMFM)"
  },
  {
   value: ".NORTHERN MARIANA ISLANDS (MP)",
   label: ".NORTHERN MARIANA ISLANDS (MP)"
  },
  {
   value: ".MARTINIQUE (MQ)",
   label: ".MARTINIQUE (MQ)"
  },
  {
   value: "Ducos (MQDUC)",
   label: "Ducos (MQDUC)"
  },
  {
   value: "Le François (MQLFR)",
   label: "Le François (MQLFR)"
  },
  {
   value: "Le Lamentin (MQLMT)",
   label: "Le Lamentin (MQLMT)"
  },
  {
   value: "Schœlcher (MQSHL)",
   label: "Schœlcher (MQSHL)"
  },
  {
   value: ".MAURITANIA (MR)",
   label: ".MAURITANIA (MR)"
  },
  {
   value: "Rosso (MRROS)",
   label: "Rosso (MRROS)"
  },
  {
   value: ".MONTSERRAT (MS)",
   label: ".MONTSERRAT (MS)"
  },
  {
   value: ".MALTA (MT)",
   label: ".MALTA (MT)"
  },
  {
   value: "Attard (MTATT)",
   label: "Attard (MTATT)"
  },
  {
   value: "Balzan (MTBAL)",
   label: "Balzan (MTBAL)"
  },
  {
   value: "Birkirkara (MTBIR)",
   label: "Birkirkara (MTBIR)"
  },
  {
   value: "Birzebbugia (MTBZE)",
   label: "Birzebbugia (MTBZE)"
  },
  {
   value: "Bugibba (MTBUG)",
   label: "Bugibba (MTBUG)"
  },
  {
   value: "Bur Marrad (MTBRU)",
   label: "Bur Marrad (MTBRU)"
  },
  {
   value: "Cirkewwa (MTCKW)",
   label: "Cirkewwa (MTCKW)"
  },
  {
   value: "Cospicua (MTCOS)",
   label: "Cospicua (MTCOS)"
  },
  {
   value: "Fgura (MTFGU)",
   label: "Fgura (MTFGU)"
  },
  {
   value: "Floriana (MTFLO)",
   label: "Floriana (MTFLO)"
  },
  {
   value: "Ghargur (MTGHA)",
   label: "Ghargur (MTGHA)"
  },
  {
   value: "Ghazaq (MTGZA)",
   label: "Ghazaq (MTGZA)"
  },
  {
   value: "Kalkara (MTKAL)",
   label: "Kalkara (MTKAL)"
  },
  {
   value: "Kirkop (MTKIR)",
   label: "Kirkop (MTKIR)"
  },
  {
   value: "Lija (MTLIJ)",
   label: "Lija (MTLIJ)"
  },
  {
   value: "Luqa (MTLUQ)",
   label: "Luqa (MTLUQ)"
  },
  {
   value: "Malta Freeport Distripark (MTDIS)",
   label: "Malta Freeport Distripark (MTDIS)"
  },
  {
   value: "Marsa (MTMSA)",
   label: "Marsa (MTMSA)"
  },
  {
   value: "Marsamxett (MTMSX)",
   label: "Marsamxett (MTMSX)"
  },
  {
   value: "Mellieha (MTMEL)",
   label: "Mellieha (MTMEL)"
  },
  {
   value: "Mgarr, Gozo (MTMGZ)",
   label: "Mgarr, Gozo (MTMGZ)"
  },
  {
   value: "Mosta (MTMOA)",
   label: "Mosta (MTMOA)"
  },
  {
   value: "Mriehel (MTMRI)",
   label: "Mriehel (MTMRI)"
  },
  {
   value: "Naxxar (MTNXR)",
   label: "Naxxar (MTNXR)"
  },
  {
   value: "Rabat (MTRAB)",
   label: "Rabat (MTRAB)"
  },
  {
   value: "San Giljan (St Julian) (MTSJN)",
   label: "San Giljan (St Julian) (MTSJN)"
  },
  {
   value: "San Gwann, Valletta (MTSGW)",
   label: "San Gwann, Valletta (MTSGW)"
  },
  {
   value: "Sliema (MTSLM)",
   label: "Sliema (MTSLM)"
  },
  {
   value: "Swieqi (MTSWI)",
   label: "Swieqi (MTSWI)"
  },
  {
   value: "Tarxien (MTTAR)",
   label: "Tarxien (MTTAR)"
  },
  {
   value: "Victoria (MTVTR)",
   label: "Victoria (MTVTR)"
  },
  {
   value: "Xewkija (MTXWK)",
   label: "Xewkija (MTXWK)"
  },
  {
   value: "Zebbub (MTZEB)",
   label: "Zebbub (MTZEB)"
  },
  {
   value: "Zebbug (MTZEG)",
   label: "Zebbug (MTZEG)"
  },
  {
   value: "Zurrieq (MTZUR)",
   label: "Zurrieq (MTZUR)"
  },
  {
   value: ".MAURITIUS (MU)",
   label: ".MAURITIUS (MU)"
  },
  {
   value: "Bambous (MUBAM)",
   label: "Bambous (MUBAM)"
  },
  {
   value: "Mahébourg (MUMAH)",
   label: "Mahébourg (MUMAH)"
  },
  {
   value: "Plaine Magnien (MUPMG)",
   label: "Plaine Magnien (MUPMG)"
  },
  {
   value: "Port Mathurin (MUPMA)",
   label: "Port Mathurin (MUPMA)"
  },
  {
   value: "Sir Seewoosagur Ramgoolam Int Apt (MUMRU)",
   label: "Sir Seewoosagur Ramgoolam Int Apt (MUMRU)"
  },
  {
   value: ".MALDIVES (MV)",
   label: ".MALDIVES (MV)"
  },
  {
   value: "Addu (MVADU)",
   label: "Addu (MVADU)"
  },
  {
   value: "Hithadhoo (MVHDO)",
   label: "Hithadhoo (MVHDO)"
  },
  {
   value: "Viligili (MVVGI)",
   label: "Viligili (MVVGI)"
  },
  {
   value: ".MALAWI (MW)",
   label: ".MALAWI (MW)"
  },
  {
   value: "Mangochi (MWMAI)",
   label: "Mangochi (MWMAI)"
  },
  {
   value: "Monkey Bay (MWMYZ)",
   label: "Monkey Bay (MWMYZ)"
  },
  {
   value: ".MEXICO (MX)",
   label: ".MEXICO (MX)"
  },
  {
   value: "Abasolo (MXASO)",
   label: "Abasolo (MXASO)"
  },
  {
   value: "Acambaro (MXACB)",
   label: "Acambaro (MXACB)"
  },
  {
   value: "Acanceh (MXANH)",
   label: "Acanceh (MXANH)"
  },
  {
   value: "Acaponeta (MXACP)",
   label: "Acaponeta (MXACP)"
  },
  {
   value: "Acaxochitlán (MXACX)",
   label: "Acaxochitlán (MXACX)"
  },
  {
   value: "Agua Dulce (MXAGD)",
   label: "Agua Dulce (MXAGD)"
  },
  {
   value: "Agua Prieta (MXAPR)",
   label: "Agua Prieta (MXAPR)"
  },
  {
   value: "Akil (MXAKI)",
   label: "Akil (MXAKI)"
  },
  {
   value: "Álamo (MXALO)",
   label: "Álamo (MXALO)"
  },
  {
   value: "Aldama (MXALD)",
   label: "Aldama (MXALD)"
  },
  {
   value: "Amatitan (MXATN)",
   label: "Amatitan (MXATN)"
  },
  {
   value: "Antunez (MXATZ)",
   label: "Antunez (MXATZ)"
  },
  {
   value: "Apaseo el Grande (MXAPA)",
   label: "Apaseo el Grande (MXAPA)"
  },
  {
   value: "Apaxco de Ocampo (MXAPX)",
   label: "Apaxco de Ocampo (MXAPX)"
  },
  {
   value: "Apizaco (MXAPI)",
   label: "Apizaco (MXAPI)"
  },
  {
   value: "Arandas (MXARA)",
   label: "Arandas (MXARA)"
  },
  {
   value: "Arcelia (MXARC)",
   label: "Arcelia (MXARC)"
  },
  {
   value: "Arizpe (MXARZ)",
   label: "Arizpe (MXARZ)"
  },
  {
   value: "Arteaga (MXAHO)",
   label: "Arteaga (MXAHO)"
  },
  {
   value: "Ascencion (MXACC)",
   label: "Ascencion (MXACC)"
  },
  {
   value: "Atequiza (MXATE)",
   label: "Atequiza (MXATE)"
  },
  {
   value: "Atitalaquia (MXATI)",
   label: "Atitalaquia (MXATI)"
  },
  {
   value: "Atlacomulco (MXALC)",
   label: "Atlacomulco (MXALC)"
  },
  {
   value: "Atlixco (MXATL)",
   label: "Atlixco (MXATL)"
  },
  {
   value: "Atotonilco (MXATT)",
   label: "Atotonilco (MXATT)"
  },
  {
   value: "Atotonilco el Alto (MXATO)",
   label: "Atotonilco el Alto (MXATO)"
  },
  {
   value: "Atotonilquillo (MXAQL)",
   label: "Atotonilquillo (MXAQL)"
  },
  {
   value: "Autlan (MXAUT)",
   label: "Autlan (MXAUT)"
  },
  {
   value: "Ayala (MXAYA)",
   label: "Ayala (MXAYA)"
  },
  {
   value: "Ayotlan (MXAYO)",
   label: "Ayotlan (MXAYO)"
  },
  {
   value: "Ayutla (MXAYU)",
   label: "Ayutla (MXAYU)"
  },
  {
   value: "Ayutla de los Libres (MXAYL)",
   label: "Ayutla de los Libres (MXAYL)"
  },
  {
   value: "Azcapotzalco (MXAPZ)",
   label: "Azcapotzalco (MXAPZ)"
  },
  {
   value: "Bahia de los Angeles (MXBAA)",
   label: "Bahia de los Angeles (MXBAA)"
  },
  {
   value: "Bahia Kino (MXBAK)",
   label: "Bahia Kino (MXBAK)"
  },
  {
   value: "Balancan (MXBAL)",
   label: "Balancan (MXBAL)"
  },
  {
   value: "Banamichi (MXBAN)",
   label: "Banamichi (MXBAN)"
  },
  {
   value: "Barra de Navidad (MXBDN)",
   label: "Barra de Navidad (MXBDN)"
  },
  {
   value: "Benito Juarez (MXBEJ)",
   label: "Benito Juarez (MXBEJ)"
  },
  {
   value: "Boca del Río (MXBDR)",
   label: "Boca del Río (MXBDR)"
  },
  {
   value: "Buenaventura (MXBUE)",
   label: "Buenaventura (MXBUE)"
  },
  {
   value: "Caborca Viejo (MXCBV)",
   label: "Caborca Viejo (MXCBV)"
  },
  {
   value: "Cadereyta Jiménez (MXZCA)",
   label: "Cadereyta Jiménez (MXZCA)"
  },
  {
   value: "Calera Victor Rosales (MXCVR)",
   label: "Calera Victor Rosales (MXCVR)"
  },
  {
   value: "Calkini (MXCLK)",
   label: "Calkini (MXCLK)"
  },
  {
   value: "Calpulalpan (MXCAL)",
   label: "Calpulalpan (MXCAL)"
  },
  {
   value: "Cananea (MXCNA)",
   label: "Cananea (MXCNA)"
  },
  {
   value: "Canatlan (MXCAN)",
   label: "Canatlan (MXCAN)"
  },
  {
   value: "Caobas (MXCAO)",
   label: "Caobas (MXCAO)"
  },
  {
   value: "Capilla de Guadalupe (MXCDG)",
   label: "Capilla de Guadalupe (MXCDG)"
  },
  {
   value: "Cartazar (MXCTZ)",
   label: "Cartazar (MXCTZ)"
  },
  {
   value: "Casimiro Castillo (MXCAS)",
   label: "Casimiro Castillo (MXCAS)"
  },
  {
   value: "Cedros (MXCED)",
   label: "Cedros (MXCED)"
  },
  {
   value: "Celaya (MXCLY)",
   label: "Celaya (MXCLY)"
  },
  {
   value: "Celestun (MXCET)",
   label: "Celestun (MXCET)"
  },
  {
   value: "Cerro de Ortega (MXCOO)",
   label: "Cerro de Ortega (MXCOO)"
  },
  {
   value: "Chahuites (MXCHH)",
   label: "Chahuites (MXCHH)"
  },
  {
   value: "Chalco (MXZMB)",
   label: "Chalco (MXZMB)"
  },
  {
   value: "Chamela (MXCHM)",
   label: "Chamela (MXCHM)"
  },
  {
   value: "Charcas (MXCCS)",
   label: "Charcas (MXCCS)"
  },
  {
   value: "Chiconcuac (MXZMC)",
   label: "Chiconcuac (MXZMC)"
  },
  {
   value: "Chimalapa (MXCML)",
   label: "Chimalapa (MXCML)"
  },
  {
   value: "China (MXCHN)",
   label: "China (MXCHN)"
  },
  {
   value: "Chipilio de Francisco Javier Mina (MXCFJ)",
   label: "Chipilio de Francisco Javier Mina (MXCFJ)"
  },
  {
   value: "Choix (MXCHO)",
   label: "Choix (MXCHO)"
  },
  {
   value: "Cholula (MXCHA)",
   label: "Cholula (MXCHA)"
  },
  {
   value: "Cholula (MXCLA)",
   label: "Cholula (MXCLA)"
  },
  {
   value: "Cienega de Flores (MXCDF)",
   label: "Cienega de Flores (MXCDF)"
  },
  {
   value: "Ciudad Altamirano (MXCIA)",
   label: "Ciudad Altamirano (MXCIA)"
  },
  {
   value: "Ciudad Cuauthemoc (MXCCU)",
   label: "Ciudad Cuauthemoc (MXCCU)"
  },
  {
   value: "Ciudad Guzmán (MXGUZ)",
   label: "Ciudad Guzmán (MXGUZ)"
  },
  {
   value: "Ciudad Hidalgo (MXZMF)",
   label: "Ciudad Hidalgo (MXZMF)"
  },
  {
   value: "Ciudad Madero (MXCDD)",
   label: "Ciudad Madero (MXCDD)"
  },
  {
   value: "Ciudad Mante (MXMMC)",
   label: "Ciudad Mante (MXMMC)"
  },
  {
   value: "Ciudad Miguel Aleman (MXCMA)",
   label: "Ciudad Miguel Aleman (MXCMA)"
  },
  {
   value: "Ciudad Río Bravo (MXRBV)",
   label: "Ciudad Río Bravo (MXRBV)"
  },
  {
   value: "Ciudad Sahagún (MXCSG)",
   label: "Ciudad Sahagún (MXCSG)"
  },
  {
   value: "Ciudad Valles (MXCDV)",
   label: "Ciudad Valles (MXCDV)"
  },
  {
   value: "Coahuila (MXCHL)",
   label: "Coahuila (MXCHL)"
  },
  {
   value: "Coalcoman (MXCCN)",
   label: "Coalcoman (MXCCN)"
  },
  {
   value: "Coatepac (MXCTP)",
   label: "Coatepac (MXCTP)"
  },
  {
   value: "Coatepec Harinas (MXCPA)",
   label: "Coatepec Harinas (MXCPA)"
  },
  {
   value: "Concepcion del Oro (MXCDO)",
   label: "Concepcion del Oro (MXCDO)"
  },
  {
   value: "Copainala (MXCOP)",
   label: "Copainala (MXCOP)"
  },
  {
   value: "Córdoba (MXCDU)",
   label: "Córdoba (MXCDU)"
  },
  {
   value: "Cortazar (MXCZR)",
   label: "Cortazar (MXCZR)"
  },
  {
   value: "Cosoleacaque (MXCOS)",
   label: "Cosoleacaque (MXCOS)"
  },
  {
   value: "Cotaxtla (MXCTX)",
   label: "Cotaxtla (MXCTX)"
  },
  {
   value: "Cotija (MXCOT)",
   label: "Cotija (MXCOT)"
  },
  {
   value: "Coyoacán (MXCYA)",
   label: "Coyoacán (MXCYA)"
  },
  {
   value: "Cuajimalpa (MXCUJ)",
   label: "Cuajimalpa (MXCUJ)"
  },
  {
   value: "Cuajinicuilapa (MXCJI)",
   label: "Cuajinicuilapa (MXCJI)"
  },
  {
   value: "Cuatrocienegas de Carranza (MXCTG)",
   label: "Cuatrocienegas de Carranza (MXCTG)"
  },
  {
   value: "Cuautitlan (MXCTN)",
   label: "Cuautitlan (MXCTN)"
  },
  {
   value: "Cuautla (MXCTL)",
   label: "Cuautla (MXCTL)"
  },
  {
   value: "Cuautla Morelos (MXCUM)",
   label: "Cuautla Morelos (MXCUM)"
  },
  {
   value: "Cuautlancingo (MXCAU)",
   label: "Cuautlancingo (MXCAU)"
  },
  {
   value: "Cuencame (MXCUE)",
   label: "Cuencame (MXCUE)"
  },
  {
   value: "Cumpas (MXCMP)",
   label: "Cumpas (MXCMP)"
  },
  {
   value: "Cuquio (MXCQO)",
   label: "Cuquio (MXCQO)"
  },
  {
   value: "Cutzio (MXCIO)",
   label: "Cutzio (MXCIO)"
  },
  {
   value: "Delicias (MXDCS)",
   label: "Delicias (MXDCS)"
  },
  {
   value: "Doctor Arroyo (MXDOC)",
   label: "Doctor Arroyo (MXDOC)"
  },
  {
   value: "Dolores Hidalgo (MXDHD)",
   label: "Dolores Hidalgo (MXDHD)"
  },
  {
   value: "Ecatepec (MXEPC)",
   label: "Ecatepec (MXEPC)"
  },
  {
   value: "Ecatepec (MXETP)",
   label: "Ecatepec (MXETP)"
  },
  {
   value: "El Carmen (MXECA)",
   label: "El Carmen (MXECA)"
  },
  {
   value: "El Coacoyul (MXELC)",
   label: "El Coacoyul (MXELC)"
  },
  {
   value: "El Fuerte (MXELF)",
   label: "El Fuerte (MXELF)"
  },
  {
   value: "El Marques (MXEMQ)",
   label: "El Marques (MXEMQ)"
  },
  {
   value: "El Naranjillo (MXELN)",
   label: "El Naranjillo (MXELN)"
  },
  {
   value: "El Paso (MXELP)",
   label: "El Paso (MXELP)"
  },
  {
   value: "El Ranchito (MXELR)",
   label: "El Ranchito (MXELR)"
  },
  {
   value: "El Salto (MXESO)",
   label: "El Salto (MXESO)"
  },
  {
   value: "El Sauzal (MXESZ)",
   label: "El Sauzal (MXESZ)"
  },
  {
   value: "El Vizcaino (MXEVI)",
   label: "El Vizcaino (MXEVI)"
  },
  {
   value: "Empalme (MXEPM)",
   label: "Empalme (MXEPM)"
  },
  {
   value: "Escarcega (MXECC)",
   label: "Escarcega (MXECC)"
  },
  {
   value: "Escobedo (MXECB)",
   label: "Escobedo (MXECB)"
  },
  {
   value: "Escobedo (MXESC)",
   label: "Escobedo (MXESC)"
  },
  {
   value: "Escuinapa de Hidalgo (MXEHG)",
   label: "Escuinapa de Hidalgo (MXEHG)"
  },
  {
   value: "Estado de Mexico (MXEDM)",
   label: "Estado de Mexico (MXEDM)"
  },
  {
   value: "Felipe Carrillo Puerto (MXFCP)",
   label: "Felipe Carrillo Puerto (MXFCP)"
  },
  {
   value: "Fortin de las Flores (MXFLF)",
   label: "Fortin de las Flores (MXFLF)"
  },
  {
   value: "Fresnillo de González Echeverría (MXFGE)",
   label: "Fresnillo de González Echeverría (MXFGE)"
  },
  {
   value: "Frontera (MXFTR)",
   label: "Frontera (MXFTR)"
  },
  {
   value: "Frontera Comalapa (MXFRC)",
   label: "Frontera Comalapa (MXFRC)"
  },
  {
   value: "Fronteras (MXFTZ)",
   label: "Fronteras (MXFTZ)"
  },
  {
   value: "Garza García (MXGGA)",
   label: "Garza García (MXGGA)"
  },
  {
   value: "General Terán (MXGET)",
   label: "General Terán (MXGET)"
  },
  {
   value: "Golfo de Santa Clara (MXGSC)",
   label: "Golfo de Santa Clara (MXGSC)"
  },
  {
   value: "Granjas (MXGRA)",
   label: "Granjas (MXGRA)"
  },
  {
   value: "Guadalupe (MXGLP)",
   label: "Guadalupe (MXGLP)"
  },
  {
   value: "Guanacevi (MXGUV)",
   label: "Guanacevi (MXGUV)"
  },
  {
   value: "Guasave (MXGSV)",
   label: "Guasave (MXGSV)"
  },
  {
   value: "Hidalgo (MXHDG)",
   label: "Hidalgo (MXHDG)"
  },
  {
   value: "Hidalgo del Parral (MXHDP)",
   label: "Hidalgo del Parral (MXHDP)"
  },
  {
   value: "Hopelchen (MXHOP)",
   label: "Hopelchen (MXHOP)"
  },
  {
   value: "Huajuapan (MXHJP)",
   label: "Huajuapan (MXHJP)"
  },
  {
   value: "Huamantla (MXHAU)",
   label: "Huamantla (MXHAU)"
  },
  {
   value: "Huayacocotla (MXHYC)",
   label: "Huayacocotla (MXHYC)"
  },
  {
   value: "Huehuetlan (MXHHL)",
   label: "Huehuetlan (MXHHL)"
  },
  {
   value: "Huehuetoca (MXHUE)",
   label: "Huehuetoca (MXHUE)"
  },
  {
   value: "Huejotzingo (MXHJZ)",
   label: "Huejotzingo (MXHJZ)"
  },
  {
   value: "Huejutla de Reyes (MXHUJ)",
   label: "Huejutla de Reyes (MXHUJ)"
  },
  {
   value: "Huetamo (MXHUT)",
   label: "Huetamo (MXHUT)"
  },
  {
   value: "Huichihuayan (MXHHY)",
   label: "Huichihuayan (MXHHY)"
  },
  {
   value: "Huimanguillo (MXHUI)",
   label: "Huimanguillo (MXHUI)"
  },
  {
   value: "Huixquilucan de Degollado (MXHXD)",
   label: "Huixquilucan de Degollado (MXHXD)"
  },
  {
   value: "Iguala (MXIGU)",
   label: "Iguala (MXIGU)"
  },
  {
   value: "Imuris (MXIMU)",
   label: "Imuris (MXIMU)"
  },
  {
   value: "Irapuato (MXIRP)",
   label: "Irapuato (MXIRP)"
  },
  {
   value: "Isla (MXISL)",
   label: "Isla (MXISL)"
  },
  {
   value: "Isla Cedros (MXISD)",
   label: "Isla Cedros (MXISD)"
  },
  {
   value: "Ixmiquilpan (MXIXM)",
   label: "Ixmiquilpan (MXIXM)"
  },
  {
   value: "Ixtapalapa (MXIXP)",
   label: "Ixtapalapa (MXIXP)"
  },
  {
   value: "Ixtapaluca (MXZIP)",
   label: "Ixtapaluca (MXZIP)"
  },
  {
   value: "Iztacalco (MXLCO)",
   label: "Iztacalco (MXLCO)"
  },
  {
   value: "Iztapalapa (MXIPP)",
   label: "Iztapalapa (MXIPP)"
  },
  {
   value: "Iztapalapa (MXIZP)",
   label: "Iztapalapa (MXIZP)"
  },
  {
   value: "Jacona de Plancarte (MXJPR)",
   label: "Jacona de Plancarte (MXJPR)"
  },
  {
   value: "Jalacingo (MXJAA)",
   label: "Jalacingo (MXJAA)"
  },
  {
   value: "Jalisco (MXJLC)",
   label: "Jalisco (MXJLC)"
  },
  {
   value: "Jalostotitlan (MXJAO)",
   label: "Jalostotitlan (MXJAO)"
  },
  {
   value: "Jaral del Progreso (MXJDP)",
   label: "Jaral del Progreso (MXJDP)"
  },
  {
   value: "Jerez (MXJZA)",
   label: "Jerez (MXJZA)"
  },
  {
   value: "Jilotepec (MXJPC)",
   label: "Jilotepec (MXJPC)"
  },
  {
   value: "Jilotepec (MXJTP)",
   label: "Jilotepec (MXJTP)"
  },
  {
   value: "Jiutepec (Temixco) (MXJIU)",
   label: "Jiutepec (Temixco) (MXJIU)"
  },
  {
   value: "Jolalpan (MXJOL)",
   label: "Jolalpan (MXJOL)"
  },
  {
   value: "Juan Rodriguez Clara (MXJRC)",
   label: "Juan Rodriguez Clara (MXJRC)"
  },
  {
   value: "Juarez (MXJUZ)",
   label: "Juarez (MXJUZ)"
  },
  {
   value: "Juchipila (MXJUP)",
   label: "Juchipila (MXJUP)"
  },
  {
   value: "La Cruz (MXLCZ)",
   label: "La Cruz (MXLCZ)"
  },
  {
   value: "La Estancia (MXLAE)",
   label: "La Estancia (MXLAE)"
  },
  {
   value: "La Piedad de Cabadas (MXLPC)",
   label: "La Piedad de Cabadas (MXLPC)"
  },
  {
   value: "Lampazos de Naranjo (MXLDN)",
   label: "Lampazos de Naranjo (MXLDN)"
  },
  {
   value: "Libres (MXLIB)",
   label: "Libres (MXLIB)"
  },
  {
   value: "Linares (MXLIN)",
   label: "Linares (MXLIN)"
  },
  {
   value: "Llera de Canales (MXLDC)",
   label: "Llera de Canales (MXLDC)"
  },
  {
   value: "Loma Bonita (MXLOB)",
   label: "Loma Bonita (MXLOB)"
  },
  {
   value: "Lopez Mateos (MXLOP)",
   label: "Lopez Mateos (MXLOP)"
  },
  {
   value: "Loreto (MXLRO)",
   label: "Loreto (MXLRO)"
  },
  {
   value: "Los Cabos (MXLCB)",
   label: "Los Cabos (MXLCB)"
  },
  {
   value: "Los Reyes (MXLRE)",
   label: "Los Reyes (MXLRE)"
  },
  {
   value: "Luis Moya (MXLUM)",
   label: "Luis Moya (MXLUM)"
  },
  {
   value: "Magdalena (MXMDA)",
   label: "Magdalena (MXMDA)"
  },
  {
   value: "Magdalena de Kino (MXMDK)",
   label: "Magdalena de Kino (MXMDK)"
  },
  {
   value: "Magdalena\/Hostotipaquillo (MXMHT)",
   label: "Magdalena\/Hostotipaquillo (MXMHT)"
  },
  {
   value: "Mapastepec (MXMPP)",
   label: "Mapastepec (MXMPP)"
  },
  {
   value: "Maravatio (MXMAV)",
   label: "Maravatio (MXMAV)"
  },
  {
   value: "Mariscala (MXMSC)",
   label: "Mariscala (MXMSC)"
  },
  {
   value: "Martínez de La Torre (MXMLT)",
   label: "Martínez de La Torre (MXMLT)"
  },
  {
   value: "Mascota (MXMCA)",
   label: "Mascota (MXMCA)"
  },
  {
   value: "Matehuala (MXMTE)",
   label: "Matehuala (MXMTE)"
  },
  {
   value: "Matias Romero (MXMTR)",
   label: "Matias Romero (MXMTR)"
  },
  {
   value: "Melchor Muzquiz (MXMEM)",
   label: "Melchor Muzquiz (MXMEM)"
  },
  {
   value: "Metepec (MXMPC)",
   label: "Metepec (MXMPC)"
  },
  {
   value: "Mezquital (MXMEZ)",
   label: "Mezquital (MXMEZ)"
  },
  {
   value: "Michacan (MXMCN)",
   label: "Michacan (MXMCN)"
  },
  {
   value: "Michoacán (MXMIC)",
   label: "Michoacán (MXMIC)"
  },
  {
   value: "Miramar (MXMIR)",
   label: "Miramar (MXMIR)"
  },
  {
   value: "Molango (MXMOL)",
   label: "Molango (MXMOL)"
  },
  {
   value: "Montemorelos (MXMTM)",
   label: "Montemorelos (MXMTM)"
  },
  {
   value: "Moroleón (MXMOR)",
   label: "Moroleón (MXMOR)"
  },
  {
   value: "Motul de Felipe Carrillo Puerto (MXMDF)",
   label: "Motul de Felipe Carrillo Puerto (MXMDF)"
  },
  {
   value: "Nacozari de Garcia (MXNDG)",
   label: "Nacozari de Garcia (MXNDG)"
  },
  {
   value: "Navolato (MXNVO)",
   label: "Navolato (MXNVO)"
  },
  {
   value: "Nextlalpan (MXSAN)",
   label: "Nextlalpan (MXSAN)"
  },
  {
   value: "Nezahualcóyotl (MXNHY)",
   label: "Nezahualcóyotl (MXNHY)"
  },
  {
   value: "Nopala (MXNOP)",
   label: "Nopala (MXNOP)"
  },
  {
   value: "Nueva Italia de Ruiz (MXNIR)",
   label: "Nueva Italia de Ruiz (MXNIR)"
  },
  {
   value: "Nueva Rosita (MXNUR)",
   label: "Nueva Rosita (MXNUR)"
  },
  {
   value: "Nuevo Urecho (MXNUO)",
   label: "Nuevo Urecho (MXNUO)"
  },
  {
   value: "Obregón (MXOBR)",
   label: "Obregón (MXOBR)"
  },
  {
   value: "Ocosingo (MXOCS)",
   label: "Ocosingo (MXOCS)"
  },
  {
   value: "Ocotlan (MXOCO)",
   label: "Ocotlan (MXOCO)"
  },
  {
   value: "Ocoyoacac (MXOYO)",
   label: "Ocoyoacac (MXOYO)"
  },
  {
   value: "Ojuelos (MXOJU)",
   label: "Ojuelos (MXOJU)"
  },
  {
   value: "Ometepec (MXOME)",
   label: "Ometepec (MXOME)"
  },
  {
   value: "Oxkutzcab (MXOXK)",
   label: "Oxkutzcab (MXOXK)"
  },
  {
   value: "Pajaritos (MXPAJ)",
   label: "Pajaritos (MXPAJ)"
  },
  {
   value: "Panotla (MXPNT)",
   label: "Panotla (MXPNT)"
  },
  {
   value: "Paraiso (MXPRO)",
   label: "Paraiso (MXPRO)"
  },
  {
   value: "Paso de Ovejas (MXPSO)",
   label: "Paso de Ovejas (MXPSO)"
  },
  {
   value: "Patzcuaro (MXPZO)",
   label: "Patzcuaro (MXPZO)"
  },
  {
   value: "Penjamo (MXPJM)",
   label: "Penjamo (MXPJM)"
  },
  {
   value: "Periban (MXZPN)",
   label: "Periban (MXZPN)"
  },
  {
   value: "Perula (MXPER)",
   label: "Perula (MXPER)"
  },
  {
   value: "Pichilingue (MXPIC)",
   label: "Pichilingue (MXPIC)"
  },
  {
   value: "Pijijiapan (MXPIJ)",
   label: "Pijijiapan (MXPIJ)"
  },
  {
   value: "Platon Sanchez (MXPLS)",
   label: "Platon Sanchez (MXPLS)"
  },
  {
   value: "Plomosas (MXPLM)",
   label: "Plomosas (MXPLM)"
  },
  {
   value: "Plomosas (MXPLO)",
   label: "Plomosas (MXPLO)"
  },
  {
   value: "Pochutla (MXPCA)",
   label: "Pochutla (MXPCA)"
  },
  {
   value: "Polanco (MXPOO)",
   label: "Polanco (MXPOO)"
  },
  {
   value: "Pomoca (MXPOM)",
   label: "Pomoca (MXPOM)"
  },
  {
   value: "Poncitlan (MXPTN)",
   label: "Poncitlan (MXPTN)"
  },
  {
   value: "Pto Escondido (MXPES)",
   label: "Pto Escondido (MXPES)"
  },
  {
   value: "Pto Rico (MXPRC)",
   label: "Pto Rico (MXPRC)"
  },
  {
   value: "Puerta (MXPTA)",
   label: "Puerta (MXPTA)"
  },
  {
   value: "Puerto Ángel (MXPNG)",
   label: "Puerto Ángel (MXPNG)"
  },
  {
   value: "Punta Baja (MXPBJ)",
   label: "Punta Baja (MXPBJ)"
  },
  {
   value: "Punta Colonet (MXPUC)",
   label: "Punta Colonet (MXPUC)"
  },
  {
   value: "Punta de Mita (MXZPA)",
   label: "Punta de Mita (MXZPA)"
  },
  {
   value: "Punta Venado (MXPVN)",
   label: "Punta Venado (MXPVN)"
  },
  {
   value: "Purisima de Bustos (MXPDB)",
   label: "Purisima de Bustos (MXPDB)"
  },
  {
   value: "Purisima del Rincon (MXPDR)",
   label: "Purisima del Rincon (MXPDR)"
  },
  {
   value: "Putla de Guerrero (MXPUT)",
   label: "Putla de Guerrero (MXPUT)"
  },
  {
   value: "Quecholac (MXQUP)",
   label: "Quecholac (MXQUP)"
  },
  {
   value: "Rabon Grande\/Coatzacoalcos (MXRBG)",
   label: "Rabon Grande\/Coatzacoalcos (MXRBG)"
  },
  {
   value: "Rayon (MXRAY)",
   label: "Rayon (MXRAY)"
  },
  {
   value: "Rincon de Romos (MXRDR)",
   label: "Rincon de Romos (MXRDR)"
  },
  {
   value: "Rio de Ocampo (MXRDO)",
   label: "Rio de Ocampo (MXRDO)"
  },
  {
   value: "Rio Verde (MXRIV)",
   label: "Rio Verde (MXRIV)"
  },
  {
   value: "Rodeo (MXROD)",
   label: "Rodeo (MXROD)"
  },
  {
   value: "Romita (MXRMT)",
   label: "Romita (MXRMT)"
  },
  {
   value: "Rosario (MXRSR)",
   label: "Rosario (MXRSR)"
  },
  {
   value: "Rosarito (MXZRO)",
   label: "Rosarito (MXZRO)"
  },
  {
   value: "Sabinas (MXSBN)",
   label: "Sabinas (MXSBN)"
  },
  {
   value: "Sabinas Hidalgo (MXSHO)",
   label: "Sabinas Hidalgo (MXSHO)"
  },
  {
   value: "Salamanca (MXSMC)",
   label: "Salamanca (MXSMC)"
  },
  {
   value: "Salvatierra (MXSAL)",
   label: "Salvatierra (MXSAL)"
  },
  {
   value: "San Andres Huaxpaltepec (MXSAH)",
   label: "San Andres Huaxpaltepec (MXSAH)"
  },
  {
   value: "San Andres Tuxtla (MXSAX)",
   label: "San Andres Tuxtla (MXSAX)"
  },
  {
   value: "San Angel (MXSAA)",
   label: "San Angel (MXSAA)"
  },
  {
   value: "San Antonio la Isla (MXZMK)",
   label: "San Antonio la Isla (MXZMK)"
  },
  {
   value: "San Cosme (MXSCM)",
   label: "San Cosme (MXSCM)"
  },
  {
   value: "San Cosme Xalostoc (MXCXC)",
   label: "San Cosme Xalostoc (MXCXC)"
  },
  {
   value: "San Cristobal de la Barranca (MXSCB)",
   label: "San Cristobal de la Barranca (MXSCB)"
  },
  {
   value: "San Felipe Orizatlan (MXSFO)",
   label: "San Felipe Orizatlan (MXSFO)"
  },
  {
   value: "San Fernando (MXSFD)",
   label: "San Fernando (MXSFD)"
  },
  {
   value: "San Francisco de Asis (MXSFA)",
   label: "San Francisco de Asis (MXSFA)"
  },
  {
   value: "San Francisco de los Romos (MXSFS)",
   label: "San Francisco de los Romos (MXSFS)"
  },
  {
   value: "San Francisco del Rincon (MXSFR)",
   label: "San Francisco del Rincon (MXSFR)"
  },
  {
   value: "San Francisco Javier (MXSFJ)",
   label: "San Francisco Javier (MXSFJ)"
  },
  {
   value: "San Gabriel (MXSGL)",
   label: "San Gabriel (MXSGL)"
  },
  {
   value: "San Ignacio (MXSIO)",
   label: "San Ignacio (MXSIO)"
  },
  {
   value: "San Jose Chipila (MXZMD)",
   label: "San Jose Chipila (MXZMD)"
  },
  {
   value: "San Jose del Cabo (MXZMI)",
   label: "San Jose del Cabo (MXZMI)"
  },
  {
   value: "San José Iturbide (MXSJI)",
   label: "San José Iturbide (MXSJI)"
  },
  {
   value: "San Juan Bautista Tuxtepec (MXSJT)",
   label: "San Juan Bautista Tuxtepec (MXSJT)"
  },
  {
   value: "San Juan de los Lagos (MXSJL)",
   label: "San Juan de los Lagos (MXSJL)"
  },
  {
   value: "San Juan de Sabinas (MXDSS)",
   label: "San Juan de Sabinas (MXDSS)"
  },
  {
   value: "San Juan Del Rio (MXSJO)",
   label: "San Juan Del Rio (MXSJO)"
  },
  {
   value: "San Juan del Rio (MXSJR)",
   label: "San Juan del Rio (MXSJR)"
  },
  {
   value: "San Juan Tuxtepec (MXTXP)",
   label: "San Juan Tuxtepec (MXTXP)"
  },
  {
   value: "San Luis de la Paz (MXSLU)",
   label: "San Luis de la Paz (MXSLU)"
  },
  {
   value: "San Martin Texmelucan (MXSMT)",
   label: "San Martin Texmelucan (MXSMT)"
  },
  {
   value: "San Mateo Atenco (MXSMA)",
   label: "San Mateo Atenco (MXSMA)"
  },
  {
   value: "San Miguel de Allende (MXSMG)",
   label: "San Miguel de Allende (MXSMG)"
  },
  {
   value: "San Nicolás Tolentino (MXSNT)",
   label: "San Nicolás Tolentino (MXSNT)"
  },
  {
   value: "San Pedro (MXSPD)",
   label: "San Pedro (MXSPD)"
  },
  {
   value: "San Pedro (MXZML)",
   label: "San Pedro (MXZML)"
  },
  {
   value: "San Pedro Tapanatepec (MXSTP)",
   label: "San Pedro Tapanatepec (MXSTP)"
  },
  {
   value: "San Rafael (MXSRF)",
   label: "San Rafael (MXSRF)"
  },
  {
   value: "San Sebastian (MXSSB)",
   label: "San Sebastian (MXSSB)"
  },
  {
   value: "San Tiburcio (MXSUN)",
   label: "San Tiburcio (MXSUN)"
  },
  {
   value: "Santa Catarina (MXSTC)",
   label: "Santa Catarina (MXSTC)"
  },
  {
   value: "Santa Clara (MXSCA)",
   label: "Santa Clara (MXSCA)"
  },
  {
   value: "Santa Clara (MXSCL)",
   label: "Santa Clara (MXSCL)"
  },
  {
   value: "Santa Clara del Cobre (MXSCC)",
   label: "Santa Clara del Cobre (MXSCC)"
  },
  {
   value: "Santa Cruz Itundujia (MXSAC)",
   label: "Santa Cruz Itundujia (MXSAC)"
  },
  {
   value: "Santa Cruz Tecamac (MXSCT)",
   label: "Santa Cruz Tecamac (MXSCT)"
  },
  {
   value: "Santa Cruz Tepexpan (MXTPX)",
   label: "Santa Cruz Tepexpan (MXTPX)"
  },
  {
   value: "Santa Fe (MXSAF)",
   label: "Santa Fe (MXSAF)"
  },
  {
   value: "Santa Maria Ixtulco (MXSMX)",
   label: "Santa Maria Ixtulco (MXSMX)"
  },
  {
   value: "Santa Rosa de Jauregui (MXSRJ)",
   label: "Santa Rosa de Jauregui (MXSRJ)"
  },
  {
   value: "Santa Teresa (MXSTT)",
   label: "Santa Teresa (MXSTT)"
  },
  {
   value: "Santiago Papasquiaro (MXSAP)",
   label: "Santiago Papasquiaro (MXSAP)"
  },
  {
   value: "Santiago Tuxtla (MXSTX)",
   label: "Santiago Tuxtla (MXSTX)"
  },
  {
   value: "Santo Tomas (MXZMA)",
   label: "Santo Tomas (MXZMA)"
  },
  {
   value: "Saucillo (MXZSO)",
   label: "Saucillo (MXZSO)"
  },
  {
   value: "Sierra Mojada (MXSIE)",
   label: "Sierra Mojada (MXSIE)"
  },
  {
   value: "Silao (MXSIL)",
   label: "Silao (MXSIL)"
  },
  {
   value: "Simojovel De Allende (MXSIJ)",
   label: "Simojovel De Allende (MXSIJ)"
  },
  {
   value: "Sombrerete (MXSOM)",
   label: "Sombrerete (MXSOM)"
  },
  {
   value: "Soto la Marina (MXSOT)",
   label: "Soto la Marina (MXSOT)"
  },
  {
   value: "Tabasco (MXTSC)",
   label: "Tabasco (MXTSC)"
  },
  {
   value: "Tacambaro (MXTAC)",
   label: "Tacambaro (MXTAC)"
  },
  {
   value: "Tamaulipas (MXTMP)",
   label: "Tamaulipas (MXTMP)"
  },
  {
   value: "Tamazula (MXTMZ)",
   label: "Tamazula (MXTMZ)"
  },
  {
   value: "Teapa (MXTPA)",
   label: "Teapa (MXTPA)"
  },
  {
   value: "Tecamac (MXTCA)",
   label: "Tecamac (MXTCA)"
  },
  {
   value: "Tecamachalco (MXTEM)",
   label: "Tecamachalco (MXTEM)"
  },
  {
   value: "Tecate (MXTCT)",
   label: "Tecate (MXTCT)"
  },
  {
   value: "Tecolotlan (MXTEC)",
   label: "Tecolotlan (MXTEC)"
  },
  {
   value: "Tecomán (MXTCM)",
   label: "Tecomán (MXTCM)"
  },
  {
   value: "Tecpan de Geleana (MXTDG)",
   label: "Tecpan de Geleana (MXTDG)"
  },
  {
   value: "Telixtlahuaca (MXTXH)",
   label: "Telixtlahuaca (MXTXH)"
  },
  {
   value: "Teloloapan (MXTEL)",
   label: "Teloloapan (MXTEL)"
  },
  {
   value: "Temapache (MXTPH)",
   label: "Temapache (MXTPH)"
  },
  {
   value: "Tenenexpan (MXTNP)",
   label: "Tenenexpan (MXTNP)"
  },
  {
   value: "Tenosique de Pino Suarez (MXTSQ)",
   label: "Tenosique de Pino Suarez (MXTSQ)"
  },
  {
   value: "Teolocholco (MXSLT)",
   label: "Teolocholco (MXSLT)"
  },
  {
   value: "Teoloyucan (MXTEO)",
   label: "Teoloyucan (MXTEO)"
  },
  {
   value: "Tepanco de López (MXTDL)",
   label: "Tepanco de López (MXTDL)"
  },
  {
   value: "Tepatitlán de Morelos (MXTEP)",
   label: "Tepatitlán de Morelos (MXTEP)"
  },
  {
   value: "Tepetlalco (MXTPT)",
   label: "Tepetlalco (MXTPT)"
  },
  {
   value: "Tepeyahualco (MXZMG)",
   label: "Tepeyahualco (MXZMG)"
  },
  {
   value: "Tepotzotlán (MXTPZ)",
   label: "Tepotzotlán (MXTPZ)"
  },
  {
   value: "Tequila (MXTEQ)",
   label: "Tequila (MXTEQ)"
  },
  {
   value: "Tequisquiapan (MXTQQ)",
   label: "Tequisquiapan (MXTQQ)"
  },
  {
   value: "Tequixquitla (MXCAR)",
   label: "Tequixquitla (MXCAR)"
  },
  {
   value: "Tesistan (MXTST)",
   label: "Tesistan (MXTST)"
  },
  {
   value: "Tetla (MXTTL)",
   label: "Tetla (MXTTL)"
  },
  {
   value: "Teul de Gonzalez Ortega (MXTGO)",
   label: "Teul de Gonzalez Ortega (MXTGO)"
  },
  {
   value: "Texcoco de Mora (MXTXM)",
   label: "Texcoco de Mora (MXTXM)"
  },
  {
   value: "Teziutlan (MXTEZ)",
   label: "Teziutlan (MXTEZ)"
  },
  {
   value: "Tiaxcala (MXTXC)",
   label: "Tiaxcala (MXTXC)"
  },
  {
   value: "Tilzapotla (MXTLZ)",
   label: "Tilzapotla (MXTLZ)"
  },
  {
   value: "Tinguindín (MXGUI)",
   label: "Tinguindín (MXGUI)"
  },
  {
   value: "Tingüindín (MXTIN)",
   label: "Tingüindín (MXTIN)"
  },
  {
   value: "Tixkokob (MXZTB)",
   label: "Tixkokob (MXZTB)"
  },
  {
   value: "Tixtla (MXTIX)",
   label: "Tixtla (MXTIX)"
  },
  {
   value: "Tizayuca (MXTIZ)",
   label: "Tizayuca (MXTIZ)"
  },
  {
   value: "Tlajomulco de Zuniga (MXTLJ)",
   label: "Tlajomulco de Zuniga (MXTLJ)"
  },
  {
   value: "Tlajomulco de Zúñiga (MXTMO)",
   label: "Tlajomulco de Zúñiga (MXTMO)"
  },
  {
   value: "Tlalnepantla (MXTLA)",
   label: "Tlalnepantla (MXTLA)"
  },
  {
   value: "Tlalneplantla de Baz (MXTLP)",
   label: "Tlalneplantla de Baz (MXTLP)"
  },
  {
   value: "Tlapacoyan (MXTPN)",
   label: "Tlapacoyan (MXTPN)"
  },
  {
   value: "Tlaxiaco (MXTAX)",
   label: "Tlaxiaco (MXTAX)"
  },
  {
   value: "Tlaxmalac (MXTLX)",
   label: "Tlaxmalac (MXTLX)"
  },
  {
   value: "Tolcayuca (MXTLY)",
   label: "Tolcayuca (MXTLY)"
  },
  {
   value: "Tomatlan (MXTOM)",
   label: "Tomatlan (MXTOM)"
  },
  {
   value: "Tonala (MXTNL)",
   label: "Tonala (MXTNL)"
  },
  {
   value: "Tonala (MXTON)",
   label: "Tonala (MXTON)"
  },
  {
   value: "Tonatico (MXTCO)",
   label: "Tonatico (MXTCO)"
  },
  {
   value: "Tula (MXTUA)",
   label: "Tula (MXTUA)"
  },
  {
   value: "Tula de Allende (MXTUL)",
   label: "Tula de Allende (MXTUL)"
  },
  {
   value: "Tulancingo (MXTLI)",
   label: "Tulancingo (MXTLI)"
  },
  {
   value: "Tultilan (MXTTN)",
   label: "Tultilan (MXTTN)"
  },
  {
   value: "Tultitan (MXTLT)",
   label: "Tultitan (MXTLT)"
  },
  {
   value: "Tultitlán (MXTLN)",
   label: "Tultitlán (MXTLN)"
  },
  {
   value: "Tuxcacuesco (MXTXS)",
   label: "Tuxcacuesco (MXTXS)"
  },
  {
   value: "Uman (MXUMN)",
   label: "Uman (MXUMN)"
  },
  {
   value: "Uriangato (MXURI)",
   label: "Uriangato (MXURI)"
  },
  {
   value: "Valladolid (MXVAD)",
   label: "Valladolid (MXVAD)"
  },
  {
   value: "Valle de Bravo (MXVDB)",
   label: "Valle de Bravo (MXVDB)"
  },
  {
   value: "Valle de Santiago (MXVDS)",
   label: "Valle de Santiago (MXVDS)"
  },
  {
   value: "Valle Hermoso (MXVHM)",
   label: "Valle Hermoso (MXVHM)"
  },
  {
   value: "Venustiano Carranza (MXVOC)",
   label: "Venustiano Carranza (MXVOC)"
  },
  {
   value: "Villa de García (MXVDG)",
   label: "Villa de García (MXVDG)"
  },
  {
   value: "Villa Flores (MXVIF)",
   label: "Villa Flores (MXVIF)"
  },
  {
   value: "Villa Guerrero (MXVGO)",
   label: "Villa Guerrero (MXVGO)"
  },
  {
   value: "Villa Guerrero (MXVGR)",
   label: "Villa Guerrero (MXVGR)"
  },
  {
   value: "Villa Nicolás Romero (MXVNR)",
   label: "Villa Nicolás Romero (MXVNR)"
  },
  {
   value: "Villagran (MXVGN)",
   label: "Villagran (MXVGN)"
  },
  {
   value: "Xalostoc (MXXAL)",
   label: "Xalostoc (MXXAL)"
  },
  {
   value: "Xicohtzinco (MXXZC)",
   label: "Xicohtzinco (MXXZC)"
  },
  {
   value: "Xochimilco (MXXMO)",
   label: "Xochimilco (MXXMO)"
  },
  {
   value: "Xochitepec (MXZMH)",
   label: "Xochitepec (MXZMH)"
  },
  {
   value: "Xpichil (MXXPI)",
   label: "Xpichil (MXXPI)"
  },
  {
   value: "Yavaros (MXYAV)",
   label: "Yavaros (MXYAV)"
  },
  {
   value: "Yecapixtla (MXYZX)",
   label: "Yecapixtla (MXYZX)"
  },
  {
   value: "Zacapu (MXZCP)",
   label: "Zacapu (MXZCP)"
  },
  {
   value: "Zacatlan (MXZAC)",
   label: "Zacatlan (MXZAC)"
  },
  {
   value: "Zacoalco de Torres (MXZDT)",
   label: "Zacoalco de Torres (MXZDT)"
  },
  {
   value: "Zacualtipan (MXZTN)",
   label: "Zacualtipan (MXZTN)"
  },
  {
   value: "Zakapu (MXZKP)",
   label: "Zakapu (MXZKP)"
  },
  {
   value: "Zapotlan del Rey (MXZLR)",
   label: "Zapotlan del Rey (MXZLR)"
  },
  {
   value: "Zapotlanejo (MXLFD)",
   label: "Zapotlanejo (MXLFD)"
  },
  {
   value: "Zaragoza (MXZRZ)",
   label: "Zaragoza (MXZRZ)"
  },
  {
   value: "Zinacantepec (MXZMJ)",
   label: "Zinacantepec (MXZMJ)"
  },
  {
   value: "Zumpahuacán (MXZPU)",
   label: "Zumpahuacán (MXZPU)"
  },
  {
   value: "Zumpango de Ocampo (MXZUM)",
   label: "Zumpango de Ocampo (MXZUM)"
  },
  {
   value: "Zumpango del Rio (MXZDR)",
   label: "Zumpango del Rio (MXZDR)"
  },
  {
   value: ".MALAYSIA (MY)",
   label: ".MALAYSIA (MY)"
  },
  {
   value: "Bahau (MYBAH)",
   label: "Bahau (MYBAH)"
  },
  {
   value: "Balakong (MYBAL)",
   label: "Balakong (MYBAL)"
  },
  {
   value: "Bangi (MYBAI)",
   label: "Bangi (MYBAI)"
  },
  {
   value: "Banting (MYBAN)",
   label: "Banting (MYBAN)"
  },
  {
   value: "Batu Caves (MYBCA)",
   label: "Batu Caves (MYBCA)"
  },
  {
   value: "Batu Gajah (MYTJH)",
   label: "Batu Gajah (MYTJH)"
  },
  {
   value: "Bayan Lepas (MYBLE)",
   label: "Bayan Lepas (MYBLE)"
  },
  {
   value: "Beaufort (MYBEA)",
   label: "Beaufort (MYBEA)"
  },
  {
   value: "Bentong (MYBEN)",
   label: "Bentong (MYBEN)"
  },
  {
   value: "Beranang (MYBRN)",
   label: "Beranang (MYBRN)"
  },
  {
   value: "Bukit Beruntung (MYBBE)",
   label: "Bukit Beruntung (MYBBE)"
  },
  {
   value: "Bukit Keteri (MYBKR)",
   label: "Bukit Keteri (MYBKR)"
  },
  {
   value: "Bukit Mertajam (MYBMT)",
   label: "Bukit Mertajam (MYBMT)"
  },
  {
   value: "Bukit Raja (MYBRJ)",
   label: "Bukit Raja (MYBRJ)"
  },
  {
   value: "Cameron Highlands (MYCHI)",
   label: "Cameron Highlands (MYCHI)"
  },
  {
   value: "Cyberjaya (MYZCA)",
   label: "Cyberjaya (MYZCA)"
  },
  {
   value: "Gebeng (MYGEB)",
   label: "Gebeng (MYGEB)"
  },
  {
   value: "Gua Musang (MYGMU)",
   label: "Gua Musang (MYGMU)"
  },
  {
   value: "Jelapang (MYJEP)",
   label: "Jelapang (MYJEP)"
  },
  {
   value: "Jeram (MYJER)",
   label: "Jeram (MYJER)"
  },
  {
   value: "Jertih (MYJRH)",
   label: "Jertih (MYJRH)"
  },
  {
   value: "Kampong Tasek (MYTAE)",
   label: "Kampong Tasek (MYTAE)"
  },
  {
   value: "Kampong Ulu Redang (MYKUR)",
   label: "Kampong Ulu Redang (MYKUR)"
  },
  {
   value: "Kampung Tikam Batu (MYTIB)",
   label: "Kampung Tikam Batu (MYTIB)"
  },
  {
   value: "Kamunting (MYKAM)",
   label: "Kamunting (MYKAM)"
  },
  {
   value: "Kangar (MYKGR)",
   label: "Kangar (MYKGR)"
  },
  {
   value: "Kapar (MYKAP)",
   label: "Kapar (MYKAP)"
  },
  {
   value: "Kelang (MYKEL)",
   label: "Kelang (MYKEL)"
  },
  {
   value: "Keluang (MYKLU)",
   label: "Keluang (MYKLU)"
  },
  {
   value: "Keningau (MYKGU)",
   label: "Keningau (MYKGU)"
  },
  {
   value: "Kepong Cubitt Forest Village (MYKEP)",
   label: "Kepong Cubitt Forest Village (MYKEP)"
  },
  {
   value: "Kerteh (MYKTE)",
   label: "Kerteh (MYKTE)"
  },
  {
   value: "Klang (MYKLA)",
   label: "Klang (MYKLA)"
  },
  {
   value: "Kota Sarang Semut (MYKSS)",
   label: "Kota Sarang Semut (MYKSS)"
  },
  {
   value: "Kuala Kangsar (MYKAR)",
   label: "Kuala Kangsar (MYKAR)"
  },
  {
   value: "Kuala Ketil (MYKAL)",
   label: "Kuala Ketil (MYKAL)"
  },
  {
   value: "Kuala Langat (MYKLG)",
   label: "Kuala Langat (MYKLG)"
  },
  {
   value: "Kulai (MYKLI)",
   label: "Kulai (MYKLI)"
  },
  {
   value: "Kulim (MYKLM)",
   label: "Kulim (MYKLM)"
  },
  {
   value: "Lahat (MYLAH)",
   label: "Lahat (MYLAH)"
  },
  {
   value: "Langkap (MYLAP)",
   label: "Langkap (MYLAP)"
  },
  {
   value: "Long Akah (MYAKA)",
   label: "Long Akah (MYAKA)"
  },
  {
   value: "Long Lama (MYLLM)",
   label: "Long Lama (MYLLM)"
  },
  {
   value: "Long Lellang (MYLGL)",
   label: "Long Lellang (MYLGL)"
  },
  {
   value: "Long Pasia (MYGSA)",
   label: "Long Pasia (MYGSA)"
  },
  {
   value: "Mak Mandin (MYMAM)",
   label: "Mak Mandin (MYMAM)"
  },
  {
   value: "Manjung (MYMAN)",
   label: "Manjung (MYMAN)"
  },
  {
   value: "Masai (MYMSI)",
   label: "Masai (MYMSI)"
  },
  {
   value: "Melaka (MYMEA)",
   label: "Melaka (MYMEA)"
  },
  {
   value: "Menglembu (MYMEL)",
   label: "Menglembu (MYMEL)"
  },
  {
   value: "Mentakab (MYMTK)",
   label: "Mentakab (MYMTK)"
  },
  {
   value: "Meru (MYMEU)",
   label: "Meru (MYMEU)"
  },
  {
   value: "Mostyn (MYMZS)",
   label: "Mostyn (MYMZS)"
  },
  {
   value: "Nilai (MYNII)",
   label: "Nilai (MYNII)"
  },
  {
   value: "Nilai (MYNIL)",
   label: "Nilai (MYNIL)"
  },
  {
   value: "North Pt (MYSNP)",
   label: "North Pt (MYSNP)"
  },
  {
   value: "Northport\/Pt Klang (MYLPK)",
   label: "Northport\/Pt Klang (MYLPK)"
  },
  {
   value: "Padang Besar (MYPGB)",
   label: "Padang Besar (MYPGB)"
  },
  {
   value: "Pangkur (MYPGK)",
   label: "Pangkur (MYPGK)"
  },
  {
   value: "Pelabuhan Kelang (MYPBK)",
   label: "Pelabuhan Kelang (MYPBK)"
  },
  {
   value: "Penara Marine Terminal (MYPMT)",
   label: "Penara Marine Terminal (MYPMT)"
  },
  {
   value: "Perai (MYRAI)",
   label: "Perai (MYRAI)"
  },
  {
   value: "Petaling Jaya (MYPJA)",
   label: "Petaling Jaya (MYPJA)"
  },
  {
   value: "Puchong (MYPUC)",
   label: "Puchong (MYPUC)"
  },
  {
   value: "Pulau Bruit (MYBRU)",
   label: "Pulau Bruit (MYBRU)"
  },
  {
   value: "Pulau Indah (MYLAU)",
   label: "Pulau Indah (MYLAU)"
  },
  {
   value: "Pulau Lang Lang (MYLAC)",
   label: "Pulau Lang Lang (MYLAC)"
  },
  {
   value: "Pusing (MYPSG)",
   label: "Pusing (MYPSG)"
  },
  {
   value: "Rawang (MYRAW)",
   label: "Rawang (MYRAW)"
  },
  {
   value: "Sabahat (MYSBT)",
   label: "Sabahat (MYSBT)"
  },
  {
   value: "Sebuyau (MYZSU)",
   label: "Sebuyau (MYZSU)"
  },
  {
   value: "Segamat (MYSGM)",
   label: "Segamat (MYSGM)"
  },
  {
   value: "Selangkor (MYSEK)",
   label: "Selangkor (MYSEK)"
  },
  {
   value: "Senai (MYSEI)",
   label: "Senai (MYSEI)"
  },
  {
   value: "Senawang (MYSEW)",
   label: "Senawang (MYSEW)"
  },
  {
   value: "Seremban (MYSRB)",
   label: "Seremban (MYSRB)"
  },
  {
   value: "Seri Kembangan (MYSKB)",
   label: "Seri Kembangan (MYSKB)"
  },
  {
   value: "Simpang Ampat (MYSAP)",
   label: "Simpang Ampat (MYSAP)"
  },
  {
   value: "Sitiawan (MYSWY)",
   label: "Sitiawan (MYSWY)"
  },
  {
   value: "Sobak Bernam (MYSAB)",
   label: "Sobak Bernam (MYSAB)"
  },
  {
   value: "Subang Jaya (MYSUB)",
   label: "Subang Jaya (MYSUB)"
  },
  {
   value: "Subang Kuala Lumpur Airport (MYSZB)",
   label: "Subang Kuala Lumpur Airport (MYSZB)"
  },
  {
   value: "Sungai Buluh (MYSBL)",
   label: "Sungai Buluh (MYSBL)"
  },
  {
   value: "Sungai Merah (MYSUM)",
   label: "Sungai Merah (MYSUM)"
  },
  {
   value: "Sungai Petani (MYPET)",
   label: "Sungai Petani (MYPET)"
  },
  {
   value: "Sungei Tekai (MYGTK)",
   label: "Sungei Tekai (MYGTK)"
  },
  {
   value: "Taiping (MYTPG)",
   label: "Taiping (MYTPG)"
  },
  {
   value: "Taman Negara (MYSXT)",
   label: "Taman Negara (MYSXT)"
  },
  {
   value: "Tampoi (MYTAI)",
   label: "Tampoi (MYTAI)"
  },
  {
   value: "Tanah Merah (MYTMR)",
   label: "Tanah Merah (MYTMR)"
  },
  {
   value: "Tangkak (MYTKK)",
   label: "Tangkak (MYTKK)"
  },
  {
   value: "Tanjong Bin (MYTBI)",
   label: "Tanjong Bin (MYTBI)"
  },
  {
   value: "Tanjung Gelang (MYTGE)",
   label: "Tanjung Gelang (MYTGE)"
  },
  {
   value: "Tanjung Malim (MYTAM)",
   label: "Tanjung Malim (MYTAM)"
  },
  {
   value: "Tanjung Manis (MYTMP)",
   label: "Tanjung Manis (MYTMP)"
  },
  {
   value: "Telupid (MYTEL)",
   label: "Telupid (MYTEL)"
  },
  {
   value: "Temerloh (MYTEM)",
   label: "Temerloh (MYTEM)"
  },
  {
   value: "Ulu Tiram (MYUTI)",
   label: "Ulu Tiram (MYUTI)"
  },
  {
   value: "Westport\/Port Klang (MYWSP)",
   label: "Westport\/Port Klang (MYWSP)"
  },
  {
   value: "Yong Peng (MYYPG)",
   label: "Yong Peng (MYYPG)"
  },
  {
   value: ".MOZAMBIQUE (MZ)",
   label: ".MOZAMBIQUE (MZ)"
  },
  {
   value: "Chokwé (MZCHO)",
   label: "Chokwé (MZCHO)"
  },
  {
   value: "Cuamba (MZFXO)",
   label: "Cuamba (MZFXO)"
  },
  {
   value: "Maxixe (MZMAX)",
   label: "Maxixe (MZMAX)"
  },
  {
   value: "Vilanculos (MZVNX)",
   label: "Vilanculos (MZVNX)"
  },
  {
   value: ".NAMIBIA (NA)",
   label: ".NAMIBIA (NA)"
  },
  {
   value: "Ai-Ais (NAAIW)",
   label: "Ai-Ais (NAAIW)"
  },
  {
   value: "Arandis (NAADI)",
   label: "Arandis (NAADI)"
  },
  {
   value: "Aussenkehr (NAZAR)",
   label: "Aussenkehr (NAZAR)"
  },
  {
   value: "Bagani (NABQI)",
   label: "Bagani (NABQI)"
  },
  {
   value: "Gobabis (NAGOG)",
   label: "Gobabis (NAGOG)"
  },
  {
   value: "Halali (NAHAL)",
   label: "Halali (NAHAL)"
  },
  {
   value: "Karibib (NAKRB)",
   label: "Karibib (NAKRB)"
  },
  {
   value: "Midgard (NAMQG)",
   label: "Midgard (NAMQG)"
  },
  {
   value: "Mokuti Lodge (NAOKU)",
   label: "Mokuti Lodge (NAOKU)"
  },
  {
   value: "Mount Etjo Lodge (NAMJO)",
   label: "Mount Etjo Lodge (NAMJO)"
  },
  {
   value: "Mpacha (NAMPA)",
   label: "Mpacha (NAMPA)"
  },
  {
   value: "Namutoni (NANNI)",
   label: "Namutoni (NANNI)"
  },
  {
   value: "Okaukuejo (NAOKF)",
   label: "Okaukuejo (NAOKF)"
  },
  {
   value: "Omaruru (NAOMA)",
   label: "Omaruru (NAOMA)"
  },
  {
   value: "Omega (NAOMG)",
   label: "Omega (NAOMG)"
  },
  {
   value: "Ondangwa (NAOND)",
   label: "Ondangwa (NAOND)"
  },
  {
   value: "Ongava Game Reserve (NAOGV)",
   label: "Ongava Game Reserve (NAOGV)"
  },
  {
   value: "Opuwa (NAOPW)",
   label: "Opuwa (NAOPW)"
  },
  {
   value: "Rundu (NANDU)",
   label: "Rundu (NANDU)"
  },
  {
   value: "Sesriem (NASZM)",
   label: "Sesriem (NASZM)"
  },
  {
   value: "Terrace Bay (NATCY)",
   label: "Terrace Bay (NATCY)"
  },
  {
   value: ".NEW CALEDONIA (NC)",
   label: ".NEW CALEDONIA (NC)"
  },
  {
   value: "Baie de Prony (NCBDB)",
   label: "Baie de Prony (NCBDB)"
  },
  {
   value: "Doniambo\/Nouméa (NCDNB)",
   label: "Doniambo\/Nouméa (NCDNB)"
  },
  {
   value: "Hienghene (NCHNG)",
   label: "Hienghene (NCHNG)"
  },
  {
   value: "Ile Quen (NCIOU)",
   label: "Ile Quen (NCIOU)"
  },
  {
   value: "Lifou (NCLIF)",
   label: "Lifou (NCLIF)"
  },
  {
   value: "Prony (NCPNY)",
   label: "Prony (NCPNY)"
  },
  {
   value: "Tiga (NCTGJ)",
   label: "Tiga (NCTGJ)"
  },
  {
   value: "Wala (NCWAL)",
   label: "Wala (NCWAL)"
  },
  {
   value: ".NIGER (NE)",
   label: ".NIGER (NE)"
  },
  {
   value: "Birni Nkoni (NEBKN)",
   label: "Birni Nkoni (NEBKN)"
  },
  {
   value: "Dogodountchi (NEDOG)",
   label: "Dogodountchi (NEDOG)"
  },
  {
   value: "Dosso (NEDSS)",
   label: "Dosso (NEDSS)"
  },
  {
   value: "Gaya (NEZGA)",
   label: "Gaya (NEZGA)"
  },
  {
   value: "Madaoua (NEMAD)",
   label: "Madaoua (NEMAD)"
  },
  {
   value: "Malbaza (NEMAL)",
   label: "Malbaza (NEMAL)"
  },
  {
   value: "Ouna (NEOUN)",
   label: "Ouna (NEOUN)"
  },
  {
   value: ".NORFOLK ISLAND (NF)",
   label: ".NORFOLK ISLAND (NF)"
  },
  {
   value: ".NIGERIA (NG)",
   label: ".NIGERIA (NG)"
  },
  {
   value: "Abeokuta (NGAKA)",
   label: "Abeokuta (NGAKA)"
  },
  {
   value: "Abuja (NGABV)",
   label: "Abuja (NGABV)"
  },
  {
   value: "Akpo (NGAKP)",
   label: "Akpo (NGAKP)"
  },
  {
   value: "Akure (NGAKR)",
   label: "Akure (NGAKR)"
  },
  {
   value: "Amaruru Ikeduru (NGAMI)",
   label: "Amaruru Ikeduru (NGAMI)"
  },
  {
   value: "Antan (NGANA)",
   label: "Antan (NGANA)"
  },
  {
   value: "Bauchi (NGQBU)",
   label: "Bauchi (NGQBU)"
  },
  {
   value: "Erha Terminal (NGERT)",
   label: "Erha Terminal (NGERT)"
  },
  {
   value: "Ikeja (NGIKE)",
   label: "Ikeja (NGIKE)"
  },
  {
   value: "Ikorodu (NGIKO)",
   label: "Ikorodu (NGIKO)"
  },
  {
   value: "Ilesha (NGILA)",
   label: "Ilesha (NGILA)"
  },
  {
   value: "Ilorin (NGILR)",
   label: "Ilorin (NGILR)"
  },
  {
   value: "Ima (NGIMA)",
   label: "Ima (NGIMA)"
  },
  {
   value: "Kaltungo (NGKAL)",
   label: "Kaltungo (NGKAL)"
  },
  {
   value: "Kirikakiri (NGKIR)",
   label: "Kirikakiri (NGKIR)"
  },
  {
   value: "Lagos Murtala Muhammed Apt (NGLOA)",
   label: "Lagos Murtala Muhammed Apt (NGLOA)"
  },
  {
   value: "Makurdi (NGMDI)",
   label: "Makurdi (NGMDI)"
  },
  {
   value: "Minna (NGMXJ)",
   label: "Minna (NGMXJ)"
  },
  {
   value: "Nsukka (NGNSU)",
   label: "Nsukka (NGNSU)"
  },
  {
   value: "Ogbomosho (NGOGB)",
   label: "Ogbomosho (NGOGB)"
  },
  {
   value: "Onitsha (NGONI)",
   label: "Onitsha (NGONI)"
  },
  {
   value: "Onitsha (NGQNI)",
   label: "Onitsha (NGQNI)"
  },
  {
   value: "Owerri (NGOWE)",
   label: "Owerri (NGOWE)"
  },
  {
   value: "Umuahia (NGUMU)",
   label: "Umuahia (NGUMU)"
  },
  {
   value: "Zaria (NGZAR)",
   label: "Zaria (NGZAR)"
  },
  {
   value: ".NICARAGUA (NI)",
   label: ".NICARAGUA (NI)"
  },
  {
   value: "Boaco (NIBOA)",
   label: "Boaco (NIBOA)"
  },
  {
   value: "Camoapa (NICAP)",
   label: "Camoapa (NICAP)"
  },
  {
   value: "Chichigalpa (NICCG)",
   label: "Chichigalpa (NICCG)"
  },
  {
   value: "Condega (NICDG)",
   label: "Condega (NICDG)"
  },
  {
   value: "Diriamba (NIDIR)",
   label: "Diriamba (NIDIR)"
  },
  {
   value: "El Tuma (NIETU)",
   label: "El Tuma (NIETU)"
  },
  {
   value: "El Viejo (NIZEO)",
   label: "El Viejo (NIZEO)"
  },
  {
   value: "Estelí (NIEST)",
   label: "Estelí (NIEST)"
  },
  {
   value: "Granada (NIGRA)",
   label: "Granada (NIGRA)"
  },
  {
   value: "Jalapa (NIJPA)",
   label: "Jalapa (NIJPA)"
  },
  {
   value: "Jinotega (NIJNO)",
   label: "Jinotega (NIJNO)"
  },
  {
   value: "Jinotepe (NIJIN)",
   label: "Jinotepe (NIJIN)"
  },
  {
   value: "Juigalpa (NIJGP)",
   label: "Juigalpa (NIJGP)"
  },
  {
   value: "La Paz Centro (NILPC)",
   label: "La Paz Centro (NILPC)"
  },
  {
   value: "Libertad-Chontales (NIZLI)",
   label: "Libertad-Chontales (NIZLI)"
  },
  {
   value: "Los Brasiles (NIZLS)",
   label: "Los Brasiles (NIZLS)"
  },
  {
   value: "Malacatoya (NIMAL)",
   label: "Malacatoya (NIMAL)"
  },
  {
   value: "Matagalpa (NIMTG)",
   label: "Matagalpa (NIMTG)"
  },
  {
   value: "Matiguás (NIMAT)",
   label: "Matiguás (NIMAT)"
  },
  {
   value: "Mina el Limon (NIZMN)",
   label: "Mina el Limon (NIZMN)"
  },
  {
   value: "Nandaime (NINAN)",
   label: "Nandaime (NINAN)"
  },
  {
   value: "Niquinohomo (NINQO)",
   label: "Niquinohomo (NINQO)"
  },
  {
   value: "Nueva Guinea (NINUG)",
   label: "Nueva Guinea (NINUG)"
  },
  {
   value: "Ocotal (NIOCO)",
   label: "Ocotal (NIOCO)"
  },
  {
   value: "Palacagüina (NIPAL)",
   label: "Palacagüina (NIPAL)"
  },
  {
   value: "Puerto Isabel (NIPIB)",
   label: "Puerto Isabel (NIPIB)"
  },
  {
   value: "Quilali (NIQUI)",
   label: "Quilali (NIQUI)"
  },
  {
   value: "Rama (NIRAM)",
   label: "Rama (NIRAM)"
  },
  {
   value: "Rivas (NIRVV)",
   label: "Rivas (NIRVV)"
  },
  {
   value: "Rosita (NIRFS)",
   label: "Rosita (NIRFS)"
  },
  {
   value: "San Carlos (NINCR)",
   label: "San Carlos (NINCR)"
  },
  {
   value: "San Francisco Libre (NISFL)",
   label: "San Francisco Libre (NISFL)"
  },
  {
   value: "San Lorenzo (NISLO)",
   label: "San Lorenzo (NISLO)"
  },
  {
   value: "San Rafael del Norte (NISRN)",
   label: "San Rafael del Norte (NISRN)"
  },
  {
   value: "Sébaco (NISEB)",
   label: "Sébaco (NISEB)"
  },
  {
   value: "Somoto (NISOM)",
   label: "Somoto (NISOM)"
  },
  {
   value: "Teustepe (NITEU)",
   label: "Teustepe (NITEU)"
  },
  {
   value: "Tipitapa (NITPA)",
   label: "Tipitapa (NITPA)"
  },
  {
   value: "Waslala (NIWAS)",
   label: "Waslala (NIWAS)"
  },
  {
   value: ".NETHERLANDS (NL)",
   label: ".NETHERLANDS (NL)"
  },
  {
   value: "Aalsmeerderbrug (NLAMB)",
   label: "Aalsmeerderbrug (NLAMB)"
  },
  {
   value: "Aan de Zuwe (NLAZU)",
   label: "Aan de Zuwe (NLAZU)"
  },
  {
   value: "Aarlanderveen (NLADV)",
   label: "Aarlanderveen (NLADV)"
  },
  {
   value: "Abbegaasterketting (NLAGT)",
   label: "Abbegaasterketting (NLAGT)"
  },
  {
   value: "Abbenes (NLABE)",
   label: "Abbenes (NLABE)"
  },
  {
   value: "Achthoven (NLAHO)",
   label: "Achthoven (NLAHO)"
  },
  {
   value: "Achthuizen (NLAHZ)",
   label: "Achthuizen (NLAHZ)"
  },
  {
   value: "Aduard (NLADU)",
   label: "Aduard (NLADU)"
  },
  {
   value: "Albergen (NLABN)",
   label: "Albergen (NLABN)"
  },
  {
   value: "Albrandswaard (NLAWD)",
   label: "Albrandswaard (NLAWD)"
  },
  {
   value: "Allingawier (NLALW)",
   label: "Allingawier (NLALW)"
  },
  {
   value: "Almen (NLAMN)",
   label: "Almen (NLAMN)"
  },
  {
   value: "Alphen (NLAPH)",
   label: "Alphen (NLAPH)"
  },
  {
   value: "Ameide (NLAED)",
   label: "Ameide (NLAED)"
  },
  {
   value: "America (NLZAI)",
   label: "America (NLZAI)"
  },
  {
   value: "Amstelhoek (NLALH)",
   label: "Amstelhoek (NLALH)"
  },
  {
   value: "Angeren (NLREN)",
   label: "Angeren (NLREN)"
  },
  {
   value: "Appelscha (NLAPS)",
   label: "Appelscha (NLAPS)"
  },
  {
   value: "Augustinusga (NLZAC)",
   label: "Augustinusga (NLZAC)"
  },
  {
   value: "Axel (NLAXL)",
   label: "Axel (NLAXL)"
  },
  {
   value: "Baambrugge (NLBGE)",
   label: "Baambrugge (NLBGE)"
  },
  {
   value: "Baard (NLARD)",
   label: "Baard (NLARD)"
  },
  {
   value: "Baarland (NLBRA)",
   label: "Baarland (NLBRA)"
  },
  {
   value: "Bakel (NLBAK)",
   label: "Bakel (NLBAK)"
  },
  {
   value: "Bant (NLBAN)",
   label: "Bant (NLBAN)"
  },
  {
   value: "Barsingerhorn (NLBGO)",
   label: "Barsingerhorn (NLBGO)"
  },
  {
   value: "Bartlehiem (NLBHM)",
   label: "Bartlehiem (NLBHM)"
  },
  {
   value: "Beek (NLZAK)",
   label: "Beek (NLZAK)"
  },
  {
   value: "Beers (NLBBB)",
   label: "Beers (NLBBB)"
  },
  {
   value: "Beetgum (NLBGM)",
   label: "Beetgum (NLBGM)"
  },
  {
   value: "Beets (NLBTS)",
   label: "Beets (NLBTS)"
  },
  {
   value: "Beinsdorp (NLBSP)",
   label: "Beinsdorp (NLBSP)"
  },
  {
   value: "Belfeld (NLBFD)",
   label: "Belfeld (NLBFD)"
  },
  {
   value: "Bemmel (NLBEM)",
   label: "Bemmel (NLBEM)"
  },
  {
   value: "Berg (NLBRG)",
   label: "Berg (NLBRG)"
  },
  {
   value: "Bergentheim (NLBGH)",
   label: "Bergentheim (NLBGH)"
  },
  {
   value: "Bergerheide (NLBGI)",
   label: "Bergerheide (NLBGI)"
  },
  {
   value: "Beringe (NLBEJ)",
   label: "Beringe (NLBEJ)"
  },
  {
   value: "Berkhout (NLBKT)",
   label: "Berkhout (NLBKT)"
  },
  {
   value: "Berlicum (NLBLU)",
   label: "Berlicum (NLBLU)"
  },
  {
   value: "Biddinghuizen (NLBNZ)",
   label: "Biddinghuizen (NLBNZ)"
  },
  {
   value: "Biervliet (NLBRV)",
   label: "Biervliet (NLBRV)"
  },
  {
   value: "Biest (NLBIT)",
   label: "Biest (NLBIT)"
  },
  {
   value: "Biezenmortel (NLBZO)",
   label: "Biezenmortel (NLBZO)"
  },
  {
   value: "Bilderdam (NLBDR)",
   label: "Bilderdam (NLBDR)"
  },
  {
   value: "Birdaard (NLBDA)",
   label: "Birdaard (NLBDA)"
  },
  {
   value: "Blerick (NLBLE)",
   label: "Blerick (NLBLE)"
  },
  {
   value: "Blokzijl (NLBZL)",
   label: "Blokzijl (NLBZL)"
  },
  {
   value: "Boarnsterhim (NLBNH)",
   label: "Boarnsterhim (NLBNH)"
  },
  {
   value: "Boekel (NLBEL)",
   label: "Boekel (NLBEL)"
  },
  {
   value: "Boekel (NLBOE)",
   label: "Boekel (NLBOE)"
  },
  {
   value: "Bontebok (NLBOK)",
   label: "Bontebok (NLBOK)"
  },
  {
   value: "Boornzwaag (NLBZW)",
   label: "Boornzwaag (NLBZW)"
  },
  {
   value: "Boornzwaag over de Wielen (NLBWW)",
   label: "Boornzwaag over de Wielen (NLBWW)"
  },
  {
   value: "Borger (NLBGR)",
   label: "Borger (NLBGR)"
  },
  {
   value: "Borgsweer (NLBGW)",
   label: "Borgsweer (NLBGW)"
  },
  {
   value: "Borne (NLBRE)",
   label: "Borne (NLBRE)"
  },
  {
   value: "Bosch (NLBXC)",
   label: "Bosch (NLBXC)"
  },
  {
   value: "Bosscherheide (NLBSH)",
   label: "Bosscherheide (NLBSH)"
  },
  {
   value: "Bourtange (NLBTA)",
   label: "Bourtange (NLBTA)"
  },
  {
   value: "Bovenkarspel (NLBOV)",
   label: "Bovenkarspel (NLBOV)"
  },
  {
   value: "Bovensmilde (NLBVI)",
   label: "Bovensmilde (NLBVI)"
  },
  {
   value: "Budel-Dorplain (NLBDD)",
   label: "Budel-Dorplain (NLBDD)"
  },
  {
   value: "Buggenum (NLBNU)",
   label: "Buggenum (NLBNU)"
  },
  {
   value: "Buitenpost (NLBUI)",
   label: "Buitenpost (NLBUI)"
  },
  {
   value: "Bunde (NLBNE)",
   label: "Bunde (NLBNE)"
  },
  {
   value: "Burgervlotbrug (NLBVG)",
   label: "Burgervlotbrug (NLBVG)"
  },
  {
   value: "Burgwerd (NLBWE)",
   label: "Burgwerd (NLBWE)"
  },
  {
   value: "Cadzand (NLCZD)",
   label: "Cadzand (NLCZD)"
  },
  {
   value: "Chaam (NLCAA)",
   label: "Chaam (NLCAA)"
  },
  {
   value: "Colijnsplaat (NLCOL)",
   label: "Colijnsplaat (NLCOL)"
  },
  {
   value: "Creil (NLCRI)",
   label: "Creil (NLCRI)"
  },
  {
   value: "De Glind (NLZAM)",
   label: "De Glind (NLZAM)"
  },
  {
   value: "De Goorn (NLOOR)",
   label: "De Goorn (NLOOR)"
  },
  {
   value: "De Hare (NLDHA)",
   label: "De Hare (NLDHA)"
  },
  {
   value: "De Haukes (NLDHK)",
   label: "De Haukes (NLDHK)"
  },
  {
   value: "De Heen (NLDHE)",
   label: "De Heen (NLDHE)"
  },
  {
   value: "De Kooy (NLDKO)",
   label: "De Kooy (NLDKO)"
  },
  {
   value: "De Pol (NLDPO)",
   label: "De Pol (NLDPO)"
  },
  {
   value: "De Rijp (NLDRP)",
   label: "De Rijp (NLDRP)"
  },
  {
   value: "De Steeg (NLDSG)",
   label: "De Steeg (NLDSG)"
  },
  {
   value: "De Strook (NLDSO)",
   label: "De Strook (NLDSO)"
  },
  {
   value: "De Wijk (NLDWK)",
   label: "De Wijk (NLDWK)"
  },
  {
   value: "Deest (NLDST)",
   label: "Deest (NLDST)"
  },
  {
   value: "Delden (NLDEL)",
   label: "Delden (NLDEL)"
  },
  {
   value: "Demmerik (NLDMK)",
   label: "Demmerik (NLDMK)"
  },
  {
   value: "Den Bommel (NLDBM)",
   label: "Den Bommel (NLDBM)"
  },
  {
   value: "Den Burg (NLDBG)",
   label: "Den Burg (NLDBG)"
  },
  {
   value: "Den Hool (NLDHO)",
   label: "Den Hool (NLDHO)"
  },
  {
   value: "Diepenheim (NLDPH)",
   label: "Diepenheim (NLDPH)"
  },
  {
   value: "Diessen (NLDSE)",
   label: "Diessen (NLDSE)"
  },
  {
   value: "Dieverbrug (NLDVB)",
   label: "Dieverbrug (NLDVB)"
  },
  {
   value: "Dijkshorne (NLDKS)",
   label: "Dijkshorne (NLDKS)"
  },
  {
   value: "Dirkshorn (NLDIK)",
   label: "Dirkshorn (NLDIK)"
  },
  {
   value: "Dodewaard (NLDWA)",
   label: "Dodewaard (NLDWA)"
  },
  {
   value: "Doenrade (NLDRE)",
   label: "Doenrade (NLDRE)"
  },
  {
   value: "Dongjum (NLDNU)",
   label: "Dongjum (NLDNU)"
  },
  {
   value: "Donkerbroek (NLDNO)",
   label: "Donkerbroek (NLDNO)"
  },
  {
   value: "Doodstil (NLDSI)",
   label: "Doodstil (NLDSI)"
  },
  {
   value: "Doorwerth (NLDOW)",
   label: "Doorwerth (NLDOW)"
  },
  {
   value: "Dorst (NLDRS)",
   label: "Dorst (NLDRS)"
  },
  {
   value: "Drempt (NLDPT)",
   label: "Drempt (NLDPT)"
  },
  {
   value: "Dreumel (NLDUM)",
   label: "Dreumel (NLDUM)"
  },
  {
   value: "Driebruggen (NLDBU)",
   label: "Driebruggen (NLDBU)"
  },
  {
   value: "Driel (NLDRL)",
   label: "Driel (NLDRL)"
  },
  {
   value: "Driesum (NLDSM)",
   label: "Driesum (NLDSM)"
  },
  {
   value: "Drimmelen (NLDRM)",
   label: "Drimmelen (NLDRM)"
  },
  {
   value: "Dronrijp (NLDNR)",
   label: "Dronrijp (NLDNR)"
  },
  {
   value: "Duivendrecht (NLDVT)",
   label: "Duivendrecht (NLDVT)"
  },
  {
   value: "Dukenburg (NLDUG)",
   label: "Dukenburg (NLDUG)"
  },
  {
   value: "Dussen (NLDUS)",
   label: "Dussen (NLDUS)"
  },
  {
   value: "Dwingeloo (NLDWI)",
   label: "Dwingeloo (NLDWI)"
  },
  {
   value: "Echten (NLETN)",
   label: "Echten (NLETN)"
  },
  {
   value: "Echtenerbrug (NLEHU)",
   label: "Echtenerbrug (NLEHU)"
  },
  {
   value: "Eck en Wiel (NLEWI)",
   label: "Eck en Wiel (NLEWI)"
  },
  {
   value: "Eckelrade (NLECK)",
   label: "Eckelrade (NLECK)"
  },
  {
   value: "Ederveen (NLEVN)",
   label: "Ederveen (NLEVN)"
  },
  {
   value: "Eefde (NLEFE)",
   label: "Eefde (NLEFE)"
  },
  {
   value: "Eelde (NLLDE)",
   label: "Eelde (NLLDE)"
  },
  {
   value: "Eelde-Paterswolde (NLEEL)",
   label: "Eelde-Paterswolde (NLEEL)"
  },
  {
   value: "Eemnes (NLEES)",
   label: "Eemnes (NLEES)"
  },
  {
   value: "Eernewoude (NLEWO)",
   label: "Eernewoude (NLEWO)"
  },
  {
   value: "Ekkersrijt (NLEKK)",
   label: "Ekkersrijt (NLEKK)"
  },
  {
   value: "Ell (NLELX)",
   label: "Ell (NLELX)"
  },
  {
   value: "Ellerhuizen (NLELZ)",
   label: "Ellerhuizen (NLELZ)"
  },
  {
   value: "Elsendorp (NLELS)",
   label: "Elsendorp (NLELS)"
  },
  {
   value: "Elsloo (NLELO)",
   label: "Elsloo (NLELO)"
  },
  {
   value: "Empe (NLEMP)",
   label: "Empe (NLEMP)"
  },
  {
   value: "Empel (NLEPL)",
   label: "Empel (NLEPL)"
  },
  {
   value: "Emst (NLZAO)",
   label: "Emst (NLZAO)"
  },
  {
   value: "Enter (NLENT)",
   label: "Enter (NLENT)"
  },
  {
   value: "Erica (NLERA)",
   label: "Erica (NLERA)"
  },
  {
   value: "Europoort (NLEUR)",
   label: "Europoort (NLEUR)"
  },
  {
   value: "Everingen (NLEVG)",
   label: "Everingen (NLEVG)"
  },
  {
   value: "Ewijk (NLEWK)",
   label: "Ewijk (NLEWK)"
  },
  {
   value: "Exmorrazijl (NLEXZ)",
   label: "Exmorrazijl (NLEXZ)"
  },
  {
   value: "Eygelshaven (NLEYL)",
   label: "Eygelshaven (NLEYL)"
  },
  {
   value: "Ferwerd (NLFWR)",
   label: "Ferwerd (NLFWR)"
  },
  {
   value: "Fleringen (NLFLE)",
   label: "Fleringen (NLFLE)"
  },
  {
   value: "Fonejacht (NLFJA)",
   label: "Fonejacht (NLFJA)"
  },
  {
   value: "Fraamklap (NLFKP)",
   label: "Fraamklap (NLFKP)"
  },
  {
   value: "Gaanderen (NLAAN)",
   label: "Gaanderen (NLAAN)"
  },
  {
   value: "Gaarkeuken (NLGKN)",
   label: "Gaarkeuken (NLGKN)"
  },
  {
   value: "Gaastmeer (NLGME)",
   label: "Gaastmeer (NLGME)"
  },
  {
   value: "Garmerwolde (NLGWO)",
   label: "Garmerwolde (NLGWO)"
  },
  {
   value: "Geeuwenbrug (NLGWU)",
   label: "Geeuwenbrug (NLGWU)"
  },
  {
   value: "Geffen (NLGFN)",
   label: "Geffen (NLGFN)"
  },
  {
   value: "Gendt (NLGET)",
   label: "Gendt (NLGET)"
  },
  {
   value: "Geulle (NLGLL)",
   label: "Geulle (NLGLL)"
  },
  {
   value: "Gieten (NLGTN)",
   label: "Gieten (NLGTN)"
  },
  {
   value: "Giethoorn (NLGHO)",
   label: "Giethoorn (NLGHO)"
  },
  {
   value: "Goingarijp (NLGOJ)",
   label: "Goingarijp (NLGOJ)"
  },
  {
   value: "Gorredijk (NLDJJ)",
   label: "Gorredijk (NLDJJ)"
  },
  {
   value: "Goudriaan (NLGUN)",
   label: "Goudriaan (NLGUN)"
  },
  {
   value: "Gramsbergen (NLGBG)",
   label: "Gramsbergen (NLGBG)"
  },
  {
   value: "Groede (NLGRD)",
   label: "Groede (NLGRD)"
  },
  {
   value: "Groenekan (NLGNK)",
   label: "Groenekan (NLGNK)"
  },
  {
   value: "Groeneweg (NLGRW)",
   label: "Groeneweg (NLGRW)"
  },
  {
   value: "Groenewoud (NLGWD)",
   label: "Groenewoud (NLGWD)"
  },
  {
   value: "Groesbeek (NLZAT)",
   label: "Groesbeek (NLZAT)"
  },
  {
   value: "Gronsveld (NLELD)",
   label: "Gronsveld (NLELD)"
  },
  {
   value: "Groot Dochteren (NLGDO)",
   label: "Groot Dochteren (NLGDO)"
  },
  {
   value: "Grootebroek (NLGOK)",
   label: "Grootebroek (NLGOK)"
  },
  {
   value: "Grootegast (NLGTG)",
   label: "Grootegast (NLGTG)"
  },
  {
   value: "Haaften (NLHFN)",
   label: "Haaften (NLHFN)"
  },
  {
   value: "Haaldersbroek (NLHBK)",
   label: "Haaldersbroek (NLHBK)"
  },
  {
   value: "Haaren (NLHRA)",
   label: "Haaren (NLHRA)"
  },
  {
   value: "Haarlemmerliede (NLHLR)",
   label: "Haarlemmerliede (NLHLR)"
  },
  {
   value: "Hagestein (NLHSN)",
   label: "Hagestein (NLHSN)"
  },
  {
   value: "Haghorst (NLHST)",
   label: "Haghorst (NLHST)"
  },
  {
   value: "Hakkelaarsbrug (NLHKG)",
   label: "Hakkelaarsbrug (NLHKG)"
  },
  {
   value: "Halle (NLALE)",
   label: "Halle (NLALE)"
  },
  {
   value: "Haps (NLHPS)",
   label: "Haps (NLHPS)"
  },
  {
   value: "Hardinxveld (NLHGS)",
   label: "Hardinxveld (NLHGS)"
  },
  {
   value: "Haren (NLHRE)",
   label: "Haren (NLHRE)"
  },
  {
   value: "Harkema-Opeinde (NLHKA)",
   label: "Harkema-Opeinde (NLHKA)"
  },
  {
   value: "Harreveld (NLHVL)",
   label: "Harreveld (NLHVL)"
  },
  {
   value: "Haskerdijken (NLHKD)",
   label: "Haskerdijken (NLHKD)"
  },
  {
   value: "Hattem (NLHTM)",
   label: "Hattem (NLHTM)"
  },
  {
   value: "Havelte (NLHVE)",
   label: "Havelte (NLHVE)"
  },
  {
   value: "Hazeldonck (NLHZK)",
   label: "Hazeldonck (NLHZK)"
  },
  {
   value: "Hedikhuizen (NLHHU)",
   label: "Hedikhuizen (NLHHU)"
  },
  {
   value: "Heeg (NLHEG)",
   label: "Heeg (NLHEG)"
  },
  {
   value: "Heerle (NLHLE)",
   label: "Heerle (NLHLE)"
  },
  {
   value: "Heerlen (NLHEN)",
   label: "Heerlen (NLHEN)"
  },
  {
   value: "Heeswijk (NLHSW)",
   label: "Heeswijk (NLHSW)"
  },
  {
   value: "Heijningen (NLHJY)",
   label: "Heijningen (NLHJY)"
  },
  {
   value: "Heikant (NLHKT)",
   label: "Heikant (NLHKT)"
  },
  {
   value: "Hekendorp (NLHKO)",
   label: "Hekendorp (NLHKO)"
  },
  {
   value: "Hempens (NLHPE)",
   label: "Hempens (NLHPE)"
  },
  {
   value: "Hengevelde (NLHEV)",
   label: "Hengevelde (NLHEV)"
  },
  {
   value: "Herpen (NLHPN)",
   label: "Herpen (NLHPN)"
  },
  {
   value: "Herten (NLZAY)",
   label: "Herten (NLZAY)"
  },
  {
   value: "Herven (NLHER)",
   label: "Herven (NLHER)"
  },
  {
   value: "Herwijnen (NLHWJ)",
   label: "Herwijnen (NLHWJ)"
  },
  {
   value: "Heumen (NLHUM)",
   label: "Heumen (NLHUM)"
  },
  {
   value: "Heusden (NLHES)",
   label: "Heusden (NLHES)"
  },
  {
   value: "Hijkersmilde (NLHKM)",
   label: "Hijkersmilde (NLHKM)"
  },
  {
   value: "Hilvarenbeek (NLHVK)",
   label: "Hilvarenbeek (NLHVK)"
  },
  {
   value: "Hindeloopen (NLHLP)",
   label: "Hindeloopen (NLHLP)"
  },
  {
   value: "Hoek (NLZAX)",
   label: "Hoek (NLZAX)"
  },
  {
   value: "Hogebrug (NLHBU)",
   label: "Hogebrug (NLHBU)"
  },
  {
   value: "Holsloot (NLHSO)",
   label: "Holsloot (NLHSO)"
  },
  {
   value: "Holt (NLHOT)",
   label: "Holt (NLHOT)"
  },
  {
   value: "Holtheme (NLHME)",
   label: "Holtheme (NLHME)"
  },
  {
   value: "Hoofdplaat (NLHPL)",
   label: "Hoofdplaat (NLHPL)"
  },
  {
   value: "Hooge Mierde (NLHMD)",
   label: "Hooge Mierde (NLHMD)"
  },
  {
   value: "Hooge-Hexel (NLHGX)",
   label: "Hooge-Hexel (NLHGX)"
  },
  {
   value: "Hoogersmilde (NLHMI)",
   label: "Hoogersmilde (NLHMI)"
  },
  {
   value: "Hoogkerk (NLHKK)",
   label: "Hoogkerk (NLHKK)"
  },
  {
   value: "Hoogmade (NLHGM)",
   label: "Hoogmade (NLHGM)"
  },
  {
   value: "Hoogwoud (NLHOO)",
   label: "Hoogwoud (NLHOO)"
  },
  {
   value: "Hoptille (NLHPT)",
   label: "Hoptille (NLHPT)"
  },
  {
   value: "Horn (NLHOX)",
   label: "Horn (NLHOX)"
  },
  {
   value: "Huissen (NLHUS)",
   label: "Huissen (NLHUS)"
  },
  {
   value: "Hunsel (NLHUN)",
   label: "Hunsel (NLHUN)"
  },
  {
   value: "IJsselmuiden (NLISM)",
   label: "IJsselmuiden (NLISM)"
  },
  {
   value: "IJzendijke (NLIZD)",
   label: "IJzendijke (NLIZD)"
  },
  {
   value: "Illikhoven (NLILO)",
   label: "Illikhoven (NLILO)"
  },
  {
   value: "Itteren (NLITR)",
   label: "Itteren (NLITR)"
  },
  {
   value: "Jisp (NLJSP)",
   label: "Jisp (NLJSP)"
  },
  {
   value: "Junne (NLJNE)",
   label: "Junne (NLJNE)"
  },
  {
   value: "Kakeshoek (NLKKO)",
   label: "Kakeshoek (NLKKO)"
  },
  {
   value: "Kamperland (NLKAD)",
   label: "Kamperland (NLKAD)"
  },
  {
   value: "Kantens (NLKTN)",
   label: "Kantens (NLKTN)"
  },
  {
   value: "Kapel-Avezaath (NLKAV)",
   label: "Kapel-Avezaath (NLKAV)"
  },
  {
   value: "Kapelle (NLKPL)",
   label: "Kapelle (NLKPL)"
  },
  {
   value: "Katerveer (NLKTV)",
   label: "Katerveer (NLKTV)"
  },
  {
   value: "Katlijk (NLKTJ)",
   label: "Katlijk (NLKTJ)"
  },
  {
   value: "Kats (NLKAT)",
   label: "Kats (NLKAT)"
  },
  {
   value: "Katwijk (NLKWK)",
   label: "Katwijk (NLKWK)"
  },
  {
   value: "Katwijk aan den Rijn (NLKWR)",
   label: "Katwijk aan den Rijn (NLKWR)"
  },
  {
   value: "Keizersveer (NLKZV)",
   label: "Keizersveer (NLKZV)"
  },
  {
   value: "Kekerdom (NLKEK)",
   label: "Kekerdom (NLKEK)"
  },
  {
   value: "Kelpen (NLKPE)",
   label: "Kelpen (NLKPE)"
  },
  {
   value: "Kerkdriel (NLKRD)",
   label: "Kerkdriel (NLKRD)"
  },
  {
   value: "Ketelhaven (NLKHV)",
   label: "Ketelhaven (NLKHV)"
  },
  {
   value: "Klarenbeek (NLKBK)",
   label: "Klarenbeek (NLKBK)"
  },
  {
   value: "Kloosterveen (NLKLV)",
   label: "Kloosterveen (NLKLV)"
  },
  {
   value: "Klundert (NLKLU)",
   label: "Klundert (NLKLU)"
  },
  {
   value: "Kolham (NLKHA)",
   label: "Kolham (NLKHA)"
  },
  {
   value: "Kolhorn (NLKHR)",
   label: "Kolhorn (NLKHR)"
  },
  {
   value: "Kollum (NLKLM)",
   label: "Kollum (NLKLM)"
  },
  {
   value: "Kommerzijl (NLKML)",
   label: "Kommerzijl (NLKML)"
  },
  {
   value: "Konigsbosch (NLKGH)",
   label: "Konigsbosch (NLKGH)"
  },
  {
   value: "Kootstertille (NLZBB)",
   label: "Kootstertille (NLZBB)"
  },
  {
   value: "Kornhorn (NLZAN)",
   label: "Kornhorn (NLZAN)"
  },
  {
   value: "Kornwerderzand (NLKWZ)",
   label: "Kornwerderzand (NLKWZ)"
  },
  {
   value: "Kortehemmen (NLKHM)",
   label: "Kortehemmen (NLKHM)"
  },
  {
   value: "Koudekerk aan den Rijn (NLKOR)",
   label: "Koudekerk aan den Rijn (NLKOR)"
  },
  {
   value: "Koudum (NLKDM)",
   label: "Koudum (NLKDM)"
  },
  {
   value: "Krabbendijke (NLIJK)",
   label: "Krabbendijke (NLIJK)"
  },
  {
   value: "Krammersluizen (NLKMS)",
   label: "Krammersluizen (NLKMS)"
  },
  {
   value: "Kreil (NLKRE)",
   label: "Kreil (NLKRE)"
  },
  {
   value: "Krimpen aan den IJssel (NLKAI)",
   label: "Krimpen aan den IJssel (NLKAI)"
  },
  {
   value: "Kring van Dorth (NLKDO)",
   label: "Kring van Dorth (NLKDO)"
  },
  {
   value: "Kronenberg (NLKNG)",
   label: "Kronenberg (NLKNG)"
  },
  {
   value: "Kuikhorne (NLKHO)",
   label: "Kuikhorne (NLKHO)"
  },
  {
   value: "Laag-Keppel (NLLGK)",
   label: "Laag-Keppel (NLLGK)"
  },
  {
   value: "Laatste Stuiver (NLLTS)",
   label: "Laatste Stuiver (NLLTS)"
  },
  {
   value: "Lage Mierde (NLLMI)",
   label: "Lage Mierde (NLLMI)"
  },
  {
   value: "Lage Zwaluwe (NLLZA)",
   label: "Lage Zwaluwe (NLLZA)"
  },
  {
   value: "Lageland (NLLGD)",
   label: "Lageland (NLLGD)"
  },
  {
   value: "Lalleweer (NLLWE)",
   label: "Lalleweer (NLLWE)"
  },
  {
   value: "Landgoed Baest (NLLGB)",
   label: "Landgoed Baest (NLLGB)"
  },
  {
   value: "Langbroek (NLLAK)",
   label: "Langbroek (NLLAK)"
  },
  {
   value: "Langelille (NLLGI)",
   label: "Langelille (NLLGI)"
  },
  {
   value: "Langeweg (NLLWG)",
   label: "Langeweg (NLLWG)"
  },
  {
   value: "Langweer (NLLGW)",
   label: "Langweer (NLLGW)"
  },
  {
   value: "Lathum (NLLTU)",
   label: "Lathum (NLLTU)"
  },
  {
   value: "Lauwerzijl (NLLWI)",
   label: "Lauwerzijl (NLLWI)"
  },
  {
   value: "Leens (NLLES)",
   label: "Leens (NLLES)"
  },
  {
   value: "Leimuiderbrug (NLLRU)",
   label: "Leimuiderbrug (NLLRU)"
  },
  {
   value: "Leons (NLLEO)",
   label: "Leons (NLLEO)"
  },
  {
   value: "Lettele (NLTTE)",
   label: "Lettele (NLTTE)"
  },
  {
   value: "Leuvenheim (NLGEL)",
   label: "Leuvenheim (NLGEL)"
  },
  {
   value: "Lieshout (NLLSH)",
   label: "Lieshout (NLLSH)"
  },
  {
   value: "Lijnden (NLLIJ)",
   label: "Lijnden (NLLIJ)"
  },
  {
   value: "Limmel (NLLME)",
   label: "Limmel (NLLME)"
  },
  {
   value: "Linne (NLLIN)",
   label: "Linne (NLLIN)"
  },
  {
   value: "Lippenwoude (NLLWO)",
   label: "Lippenwoude (NLLWO)"
  },
  {
   value: "Lisserbroek (NLLBK)",
   label: "Lisserbroek (NLLBK)"
  },
  {
   value: "Lithoijen (NLLTO)",
   label: "Lithoijen (NLLTO)"
  },
  {
   value: "Loenersloot (NLLNO)",
   label: "Loenersloot (NLLNO)"
  },
  {
   value: "Loosdrecht (NLZAQ)",
   label: "Loosdrecht (NLZAQ)"
  },
  {
   value: "Lopikerkapel (NLLKL)",
   label: "Lopikerkapel (NLLKL)"
  },
  {
   value: "Loppersum (NLLPM)",
   label: "Loppersum (NLLPM)"
  },
  {
   value: "Lunteren (NLLTN)",
   label: "Lunteren (NLLTN)"
  },
  {
   value: "Lutjebroek (NLLJB)",
   label: "Lutjebroek (NLLJB)"
  },
  {
   value: "Lutjewinkel (NLLWK)",
   label: "Lutjewinkel (NLLWK)"
  },
  {
   value: "Luttelgeest (NLLGE)",
   label: "Luttelgeest (NLLGE)"
  },
  {
   value: "Luyksgestel (NLLYG)",
   label: "Luyksgestel (NLLYG)"
  },
  {
   value: "Maarhuizen (NLMHU)",
   label: "Maarhuizen (NLMHU)"
  },
  {
   value: "Maarn (NLMAV)",
   label: "Maarn (NLMAV)"
  },
  {
   value: "Maasbree (NLZBC)",
   label: "Maasbree (NLZBC)"
  },
  {
   value: "Maasdijk (NLMDK)",
   label: "Maasdijk (NLMDK)"
  },
  {
   value: "Makkum (NLMAK)",
   label: "Makkum (NLMAK)"
  },
  {
   value: "Mandjeswaard (NLMJA)",
   label: "Mandjeswaard (NLMJA)"
  },
  {
   value: "Maren-Kessel (NLMRK)",
   label: "Maren-Kessel (NLMRK)"
  },
  {
   value: "Margraten (NLZBF)",
   label: "Margraten (NLZBF)"
  },
  {
   value: "Mariahout (NLMHO)",
   label: "Mariahout (NLMHO)"
  },
  {
   value: "Marken (NLMKN)",
   label: "Marken (NLMKN)"
  },
  {
   value: "Marrum (NLMRR)",
   label: "Marrum (NLMRR)"
  },
  {
   value: "Marssum (NLMRU)",
   label: "Marssum (NLMRU)"
  },
  {
   value: "Marum (NLMRM)",
   label: "Marum (NLMRM)"
  },
  {
   value: "Meerkerk (NLMKK)",
   label: "Meerkerk (NLMKK)"
  },
  {
   value: "Meerssen (NLMRN)",
   label: "Meerssen (NLMRN)"
  },
  {
   value: "Meeuwen (NLMWE)",
   label: "Meeuwen (NLMWE)"
  },
  {
   value: "Melderslo (NLMDO)",
   label: "Melderslo (NLMDO)"
  },
  {
   value: "Melissant (NLMSA)",
   label: "Melissant (NLMSA)"
  },
  {
   value: "Menaldum (NLMNU)",
   label: "Menaldum (NLMNU)"
  },
  {
   value: "Mensingeweer (NLMSW)",
   label: "Mensingeweer (NLMSW)"
  },
  {
   value: "Mesch (NLMEH)",
   label: "Mesch (NLMEH)"
  },
  {
   value: "Middelaar (NLMLA)",
   label: "Middelaar (NLMLA)"
  },
  {
   value: "Middelburg (NLMDL)",
   label: "Middelburg (NLMDL)"
  },
  {
   value: "Middelstum (NLMDU)",
   label: "Middelstum (NLMDU)"
  },
  {
   value: "Middenmeer (NLZBD)",
   label: "Middenmeer (NLZBD)"
  },
  {
   value: "Mildert (NLMDT)",
   label: "Mildert (NLMDT)"
  },
  {
   value: "Milheeze (NLMZE)",
   label: "Milheeze (NLMZE)"
  },
  {
   value: "Millingen aan de Rijn (NLMLR)",
   label: "Millingen aan de Rijn (NLMLR)"
  },
  {
   value: "Milsbeek (NLMBK)",
   label: "Milsbeek (NLMBK)"
  },
  {
   value: "Molengat (NLMGT)",
   label: "Molengat (NLMGT)"
  },
  {
   value: "Molenhoek (NLMOL)",
   label: "Molenhoek (NLMOL)"
  },
  {
   value: "Molenschot (NLMOT)",
   label: "Molenschot (NLMOT)"
  },
  {
   value: "Molkwerum (NLMWU)",
   label: "Molkwerum (NLMWU)"
  },
  {
   value: "Mook (NLMOK)",
   label: "Mook (NLMOK)"
  },
  {
   value: "Mookhoek (NLMHK)",
   label: "Mookhoek (NLMHK)"
  },
  {
   value: "Muiden (NLMUD)",
   label: "Muiden (NLMUD)"
  },
  {
   value: "Muiderberg (NLMDG)",
   label: "Muiderberg (NLMDG)"
  },
  {
   value: "Munnekeburen (NLMKE)",
   label: "Munnekeburen (NLMKE)"
  },
  {
   value: "Munnekezijl (NLMKZ)",
   label: "Munnekezijl (NLMKZ)"
  },
  {
   value: "Neck (NLNEC)",
   label: "Neck (NLNEC)"
  },
  {
   value: "Nederasselt (NLNST)",
   label: "Nederasselt (NLNST)"
  },
  {
   value: "Neder-Betuwe (NLNBW)",
   label: "Neder-Betuwe (NLNBW)"
  },
  {
   value: "Nederhemert (NLZBA)",
   label: "Nederhemert (NLZBA)"
  },
  {
   value: "Neede (NLNEE)",
   label: "Neede (NLNEE)"
  },
  {
   value: "Nes (NLNES)",
   label: "Nes (NLNES)"
  },
  {
   value: "Nes aan de Amstel (NLNSA)",
   label: "Nes aan de Amstel (NLNSA)"
  },
  {
   value: "Nessersluis (NLNSU)",
   label: "Nessersluis (NLNSU)"
  },
  {
   value: "Nibbixwoud (NLNXO)",
   label: "Nibbixwoud (NLNXO)"
  },
  {
   value: "Nieuw-Amsterdam (NLNAM)",
   label: "Nieuw-Amsterdam (NLNAM)"
  },
  {
   value: "Nieuwdorp (NLNIU)",
   label: "Nieuwdorp (NLNIU)"
  },
  {
   value: "Nieuwe Brug (NLNBU)",
   label: "Nieuwe Brug (NLNBU)"
  },
  {
   value: "Nieuwe Pekela (NLNPK)",
   label: "Nieuwe Pekela (NLNPK)"
  },
  {
   value: "Nieuwe Statenzijl (NLNSZ)",
   label: "Nieuwe Statenzijl (NLNSZ)"
  },
  {
   value: "Nieuwehorne (NLNHM)",
   label: "Nieuwehorne (NLNHM)"
  },
  {
   value: "Nieuwerbrug (NLNBG)",
   label: "Nieuwerbrug (NLNBG)"
  },
  {
   value: "Nieuwkuijk (NLNKU)",
   label: "Nieuwkuijk (NLNKU)"
  },
  {
   value: "Nieuwland (NLNUW)",
   label: "Nieuwland (NLNUW)"
  },
  {
   value: "Nieuwleusen (NLNWL)",
   label: "Nieuwleusen (NLNWL)"
  },
  {
   value: "Nieuwolda (NLNWO)",
   label: "Nieuwolda (NLNWO)"
  },
  {
   value: "Nieuw-Scheemda (NLNSD)",
   label: "Nieuw-Scheemda (NLNSD)"
  },
  {
   value: "Nieuw-Vossemeer (NLNVO)",
   label: "Nieuw-Vossemeer (NLNVO)"
  },
  {
   value: "Niezijl (NLNZI)",
   label: "Niezijl (NLNZI)"
  },
  {
   value: "Nigtevecht (NLNGV)",
   label: "Nigtevecht (NLNGV)"
  },
  {
   value: "Nijega (NLNGA)",
   label: "Nijega (NLNGA)"
  },
  {
   value: "Nijehaske (NLNHE)",
   label: "Nijehaske (NLNHE)"
  },
  {
   value: "Nijemirdum (NLNMD)",
   label: "Nijemirdum (NLNMD)"
  },
  {
   value: "Nijezijl (NLNZJ)",
   label: "Nijezijl (NLNZJ)"
  },
  {
   value: "Nijnsel (NLZBG)",
   label: "Nijnsel (NLZBG)"
  },
  {
   value: "Nistelrode (NLNTR)",
   label: "Nistelrode (NLNTR)"
  },
  {
   value: "Noorden (NLNDN)",
   label: "Noorden (NLNDN)"
  },
  {
   value: "Noordgouwe (NLNWE)",
   label: "Noordgouwe (NLNWE)"
  },
  {
   value: "Noordwolde (NLNWD)",
   label: "Noordwolde (NLNWD)"
  },
  {
   value: "Odoorn (NLODN)",
   label: "Odoorn (NLODN)"
  },
  {
   value: "Oirlo (NLOIL)",
   label: "Oirlo (NLOIL)"
  },
  {
   value: "Oldebroek (NLOLB)",
   label: "Oldebroek (NLOLB)"
  },
  {
   value: "Oldehove (NLOLE)",
   label: "Oldehove (NLOLE)"
  },
  {
   value: "Olst (NLOSI)",
   label: "Olst (NLOSI)"
  },
  {
   value: "Ommel (NLOML)",
   label: "Ommel (NLOML)"
  },
  {
   value: "Ooltgensplaat (NLOGP)",
   label: "Ooltgensplaat (NLOGP)"
  },
  {
   value: "Oostburg (NLOBG)",
   label: "Oostburg (NLOBG)"
  },
  {
   value: "Oosterhesselen (NLOHN)",
   label: "Oosterhesselen (NLOHN)"
  },
  {
   value: "Oosterhout (NLOTH)",
   label: "Oosterhout (NLOTH)"
  },
  {
   value: "Oosterland (NLOTL)",
   label: "Oosterland (NLOTL)"
  },
  {
   value: "Oosterlittens (NLOLS)",
   label: "Oosterlittens (NLOLS)"
  },
  {
   value: "Oostermeer (NLOME)",
   label: "Oostermeer (NLOME)"
  },
  {
   value: "Oosterwolde (NLOSW)",
   label: "Oosterwolde (NLOSW)"
  },
  {
   value: "Oosthem (NLOHM)",
   label: "Oosthem (NLOHM)"
  },
  {
   value: "Oosthuizen (NLOHZ)",
   label: "Oosthuizen (NLOHZ)"
  },
  {
   value: "Oostmahorn (NLOMH)",
   label: "Oostmahorn (NLOMH)"
  },
  {
   value: "Oostzaan (NLOSZ)",
   label: "Oostzaan (NLOSZ)"
  },
  {
   value: "Ooy (NLZBI)",
   label: "Ooy (NLZBI)"
  },
  {
   value: "Opeinde (NLOPE)",
   label: "Opeinde (NLOPE)"
  },
  {
   value: "Opmeer (NLZBQ)",
   label: "Opmeer (NLZBQ)"
  },
  {
   value: "Ossendrecht (NLOSH)",
   label: "Ossendrecht (NLOSH)"
  },
  {
   value: "Ossenzijl (NLOZL)",
   label: "Ossenzijl (NLOZL)"
  },
  {
   value: "Oterleek (NLORL)",
   label: "Oterleek (NLORL)"
  },
  {
   value: "Oud Gein (NLOGN)",
   label: "Oud Gein (NLOGN)"
  },
  {
   value: "Oude Leye (NLZBH)",
   label: "Oude Leye (NLZBH)"
  },
  {
   value: "Oude Meer (NLOUM)",
   label: "Oude Meer (NLOUM)"
  },
  {
   value: "Oude Schouw (NLOHW)",
   label: "Oude Schouw (NLOHW)"
  },
  {
   value: "Oudega (NLOGA)",
   label: "Oudega (NLOGA)"
  },
  {
   value: "Oudehaske (NLOHE)",
   label: "Oudehaske (NLOHE)"
  },
  {
   value: "Oudemirdum (NLOMR)",
   label: "Oudemirdum (NLOMR)"
  },
  {
   value: "Oudenrijn (NLORJ)",
   label: "Oudenrijn (NLORJ)"
  },
  {
   value: "Ouderkerk aan de Amstel (NLODR)",
   label: "Ouderkerk aan de Amstel (NLODR)"
  },
  {
   value: "Oudeschild (NLOHI)",
   label: "Oudeschild (NLOHI)"
  },
  {
   value: "Oudesluis (NLOSL)",
   label: "Oudesluis (NLOSL)"
  },
  {
   value: "Oudkarspel (NLOKP)",
   label: "Oudkarspel (NLOKP)"
  },
  {
   value: "Oud-Loosdrecht (NLOLO)",
   label: "Oud-Loosdrecht (NLOLO)"
  },
  {
   value: "Oud-Sabbinge (NLOSG)",
   label: "Oud-Sabbinge (NLOSG)"
  },
  {
   value: "Oud-Zuilen (NLOZU)",
   label: "Oud-Zuilen (NLOZU)"
  },
  {
   value: "Overloon (NLOVL)",
   label: "Overloon (NLOVL)"
  },
  {
   value: "Overschild (NLOSK)",
   label: "Overschild (NLOSK)"
  },
  {
   value: "Panheel (NLPHL)",
   label: "Panheel (NLPHL)"
  },
  {
   value: "Pannerden (NLPNN)",
   label: "Pannerden (NLPNN)"
  },
  {
   value: "Philippine (NLZBM)",
   label: "Philippine (NLZBM)"
  },
  {
   value: "Piershil (NLPSI)",
   label: "Piershil (NLPSI)"
  },
  {
   value: "Pieterzijl (NLPZI)",
   label: "Pieterzijl (NLPZI)"
  },
  {
   value: "Pingjum (NLZBN)",
   label: "Pingjum (NLZBN)"
  },
  {
   value: "Poederoijen (NLPDJ)",
   label: "Poederoijen (NLPDJ)"
  },
  {
   value: "Poortugaal (NLPTG)",
   label: "Poortugaal (NLPTG)"
  },
  {
   value: "Putten (NLPTN)",
   label: "Putten (NLPTN)"
  },
  {
   value: "Puttershoek (NLPTK)",
   label: "Puttershoek (NLPTK)"
  },
  {
   value: "Raamsdonkveer (NLZBP)",
   label: "Raamsdonkveer (NLZBP)"
  },
  {
   value: "Ramspol (NLRPL)",
   label: "Ramspol (NLRPL)"
  },
  {
   value: "Reid (NLREI)",
   label: "Reid (NLREI)"
  },
  {
   value: "Renswoude (NLRWD)",
   label: "Renswoude (NLRWD)"
  },
  {
   value: "Ressen (NLNLD)",
   label: "Ressen (NLNLD)"
  },
  {
   value: "Ried (NLRED)",
   label: "Ried (NLRED)"
  },
  {
   value: "Riethoven (NLRTH)",
   label: "Riethoven (NLRTH)"
  },
  {
   value: "Rijpwetering (NLRWI)",
   label: "Rijpwetering (NLRWI)"
  },
  {
   value: "Rijs (NLRIJ)",
   label: "Rijs (NLRIJ)"
  },
  {
   value: "Rijsenhout (NLRSH)",
   label: "Rijsenhout (NLRSH)"
  },
  {
   value: "Rilland (NLRLA)",
   label: "Rilland (NLRLA)"
  },
  {
   value: "Rinsumageest (NLRGT)",
   label: "Rinsumageest (NLRGT)"
  },
  {
   value: "Ritthem (NLRTT)",
   label: "Ritthem (NLRTT)"
  },
  {
   value: "Robbenoord (NLRBO)",
   label: "Robbenoord (NLRBO)"
  },
  {
   value: "Rockanje (NLROC)",
   label: "Rockanje (NLROC)"
  },
  {
   value: "Roosteren (NLRST)",
   label: "Roosteren (NLRST)"
  },
  {
   value: "Rottum (NLRTU)",
   label: "Rottum (NLRTU)"
  },
  {
   value: "Ruinen (NLRUI)",
   label: "Ruinen (NLRUI)"
  },
  {
   value: "Rustenburg (NLRTG)",
   label: "Rustenburg (NLRTG)"
  },
  {
   value: "Rutten (NLRUT)",
   label: "Rutten (NLRUT)"
  },
  {
   value: "Ruurlo (NLRRO)",
   label: "Ruurlo (NLRRO)"
  },
  {
   value: "Saasveld (NLSVE)",
   label: "Saasveld (NLSVE)"
  },
  {
   value: "Sambeek (NLSMB)",
   label: "Sambeek (NLSMB)"
  },
  {
   value: "Schagen (NLSCH)",
   label: "Schagen (NLSCH)"
  },
  {
   value: "Schagerbrug (NLSBU)",
   label: "Schagerbrug (NLSBU)"
  },
  {
   value: "Schalkwijk (NLSKW)",
   label: "Schalkwijk (NLSKW)"
  },
  {
   value: "Scharsterbrug (NLSBG)",
   label: "Scharsterbrug (NLSBG)"
  },
  {
   value: "Scheemderzwaag (NLSMZ)",
   label: "Scheemderzwaag (NLSMZ)"
  },
  {
   value: "Schermerhorn (NLSHO)",
   label: "Schermerhorn (NLSHO)"
  },
  {
   value: "Schildwolde (NLSDW)",
   label: "Schildwolde (NLSDW)"
  },
  {
   value: "Schiphol-Rijk (NLSRK)",
   label: "Schiphol-Rijk (NLSRK)"
  },
  {
   value: "Schipluiden (NLSCP)",
   label: "Schipluiden (NLSCP)"
  },
  {
   value: "Schoor (NLSOR)",
   label: "Schoor (NLSOR)"
  },
  {
   value: "Schoterzijl (NLSZL)",
   label: "Schoterzijl (NLSZL)"
  },
  {
   value: "Schouwerzijl (NLSWL)",
   label: "Schouwerzijl (NLSWL)"
  },
  {
   value: "Sevenum (NLSVM)",
   label: "Sevenum (NLSVM)"
  },
  {
   value: "Sijbrandahuis (NLSBS)",
   label: "Sijbrandahuis (NLSBS)"
  },
  {
   value: "Simpelveld (NLSIM)",
   label: "Simpelveld (NLSIM)"
  },
  {
   value: "Sint Annaparochie (NLSAN)",
   label: "Sint Annaparochie (NLSAN)"
  },
  {
   value: "Sint Jacobiparochie (NLSJP)",
   label: "Sint Jacobiparochie (NLSJP)"
  },
  {
   value: "Sint Maartensbrug (NLZBE)",
   label: "Sint Maartensbrug (NLZBE)"
  },
  {
   value: "Sint Maartensdijk (NLSMK)",
   label: "Sint Maartensdijk (NLSMK)"
  },
  {
   value: "Sint Maartensvlotbrug (NLSMV)",
   label: "Sint Maartensvlotbrug (NLSMV)"
  },
  {
   value: "Sint Nicolaasga (NLSNG)",
   label: "Sint Nicolaasga (NLSNG)"
  },
  {
   value: "Sint Pancras (NLANC)",
   label: "Sint Pancras (NLANC)"
  },
  {
   value: "Sint Philipsland (NLPLP)",
   label: "Sint Philipsland (NLPLP)"
  },
  {
   value: "Sintjohannesga (NLSJO)",
   label: "Sintjohannesga (NLSJO)"
  },
  {
   value: "Sleeuwijk (NLSWK)",
   label: "Sleeuwijk (NLSWK)"
  },
  {
   value: "Slijkenburg (NLSKG)",
   label: "Slijkenburg (NLSKG)"
  },
  {
   value: "Slikkendam (NLSKM)",
   label: "Slikkendam (NLSKM)"
  },
  {
   value: "Slochteren (NLSLO)",
   label: "Slochteren (NLSLO)"
  },
  {
   value: "Slootdorp (NLSDP)",
   label: "Slootdorp (NLSDP)"
  },
  {
   value: "Sloten (NLSLT)",
   label: "Sloten (NLSLT)"
  },
  {
   value: "Smilde (NLSMI)",
   label: "Smilde (NLSMI)"
  },
  {
   value: "Sondel (NLSOD)",
   label: "Sondel (NLSOD)"
  },
  {
   value: "Sprundel (NLSPR)",
   label: "Sprundel (NLSPR)"
  },
  {
   value: "St Andries (NLSAR)",
   label: "St Andries (NLSAR)"
  },
  {
   value: "Stadsdam (NLSDM)",
   label: "Stadsdam (NLSDM)"
  },
  {
   value: "Stampersgat (NLSPG)",
   label: "Stampersgat (NLSPG)"
  },
  {
   value: "Standdaarbuiten (NLSDB)",
   label: "Standdaarbuiten (NLSDB)"
  },
  {
   value: "Stavenisse (NLSVN)",
   label: "Stavenisse (NLSVN)"
  },
  {
   value: "Steenderen (NLSDN)",
   label: "Steenderen (NLSDN)"
  },
  {
   value: "Steggerda (NLSTG)",
   label: "Steggerda (NLSTG)"
  },
  {
   value: "Stevensweert (NLSVW)",
   label: "Stevensweert (NLSVW)"
  },
  {
   value: "Stieltjeskanaal (NLSKL)",
   label: "Stieltjeskanaal (NLSKL)"
  },
  {
   value: "Stokkelaarsbrug (NLSLG)",
   label: "Stokkelaarsbrug (NLSLG)"
  },
  {
   value: "Stolpen (NLSOP)",
   label: "Stolpen (NLSOP)"
  },
  {
   value: "Stolpervlotbrug (NLSPV)",
   label: "Stolpervlotbrug (NLSPV)"
  },
  {
   value: "Stolwijk (NLSWJ)",
   label: "Stolwijk (NLSWJ)"
  },
  {
   value: "Stompetoren (NLSPT)",
   label: "Stompetoren (NLSPT)"
  },
  {
   value: "Stompwijk (NLZBU)",
   label: "Stompwijk (NLZBU)"
  },
  {
   value: "Streefkerk (NLSRE)",
   label: "Streefkerk (NLSRE)"
  },
  {
   value: "Susteren (NLZAJ)",
   label: "Susteren (NLZAJ)"
  },
  {
   value: "Swifterbant (NLSWI)",
   label: "Swifterbant (NLSWI)"
  },
  {
   value: "Ten Boer (NLNTO)",
   label: "Ten Boer (NLNTO)"
  },
  {
   value: "Ten Post (NLTPT)",
   label: "Ten Post (NLTPT)"
  },
  {
   value: "Terhorne (NLTRO)",
   label: "Terhorne (NLTRO)"
  },
  {
   value: "Ternaard (NLTND)",
   label: "Ternaard (NLTND)"
  },
  {
   value: "Tjerkwerd (NLTKW)",
   label: "Tjerkwerd (NLTKW)"
  },
  {
   value: "Tolbert (NLTOL)",
   label: "Tolbert (NLTOL)"
  },
  {
   value: "Tolkamer (NLTKM)",
   label: "Tolkamer (NLTKM)"
  },
  {
   value: "Tollebeek (NLTOK)",
   label: "Tollebeek (NLTOK)"
  },
  {
   value: "Torontostraat (NLTOR)",
   label: "Torontostraat (NLTOR)"
  },
  {
   value: "Tricht (NLTRC)",
   label: "Tricht (NLTRC)"
  },
  {
   value: "Tuil (NLTUL)",
   label: "Tuil (NLTUL)"
  },
  {
   value: "Tynaarlo (NLTNO)",
   label: "Tynaarlo (NLTNO)"
  },
  {
   value: "Uddel (NLUDL)",
   label: "Uddel (NLUDL)"
  },
  {
   value: "Uffelte (NLUFE)",
   label: "Uffelte (NLUFE)"
  },
  {
   value: "Uitermeer (NLUTR)",
   label: "Uitermeer (NLUTR)"
  },
  {
   value: "Uitgeest (NLUTG)",
   label: "Uitgeest (NLUTG)"
  },
  {
   value: "Ulicoten (NLUCT)",
   label: "Ulicoten (NLUCT)"
  },
  {
   value: "Urmond (NLUMO)",
   label: "Urmond (NLUMO)"
  },
  {
   value: "Valkenisse (NLVKS)",
   label: "Valkenisse (NLVKS)"
  },
  {
   value: "Varsen (NLVAR)",
   label: "Varsen (NLVAR)"
  },
  {
   value: "Veen (NLNEV)",
   label: "Veen (NLNEV)"
  },
  {
   value: "Veendijk (NLVNK)",
   label: "Veendijk (NLVNK)"
  },
  {
   value: "Veenoord (NLVNO)",
   label: "Veenoord (NLVNO)"
  },
  {
   value: "Velden (NLVDE)",
   label: "Velden (NLVDE)"
  },
  {
   value: "Velden (NLVED)",
   label: "Velden (NLVED)"
  },
  {
   value: "Ven-Zelderheide (NLVZH)",
   label: "Ven-Zelderheide (NLVZH)"
  },
  {
   value: "Vierverlaten (NLVVL)",
   label: "Vierverlaten (NLVVL)"
  },
  {
   value: "Visvliet (NLVSI)",
   label: "Visvliet (NLVSI)"
  },
  {
   value: "Voetangelbrug (NLVGB)",
   label: "Voetangelbrug (NLVGB)"
  },
  {
   value: "Vogelwaarde (NLVLW)",
   label: "Vogelwaarde (NLVLW)"
  },
  {
   value: "Volkel (NLVLE)",
   label: "Volkel (NLVLE)"
  },
  {
   value: "Volkerak (NLVKR)",
   label: "Volkerak (NLVKR)"
  },
  {
   value: "Vollenhove (NLVHV)",
   label: "Vollenhove (NLVHV)"
  },
  {
   value: "Vondelingenplaat (NLZBW)",
   label: "Vondelingenplaat (NLZBW)"
  },
  {
   value: "Vorden (NLVFR)",
   label: "Vorden (NLVFR)"
  },
  {
   value: "Vredepeel (NLVPL)",
   label: "Vredepeel (NLVPL)"
  },
  {
   value: "Vrouwenakker (NLVRA)",
   label: "Vrouwenakker (NLVRA)"
  },
  {
   value: "Waarde (NLWDE)",
   label: "Waarde (NLWDE)"
  },
  {
   value: "Waardenburg (NLWDN)",
   label: "Waardenburg (NLWDN)"
  },
  {
   value: "Waarder (NLWDR)",
   label: "Waarder (NLWDR)"
  },
  {
   value: "Walsoorden (NLWSO)",
   label: "Walsoorden (NLWSO)"
  },
  {
   value: "Wanssum (NLWAS)",
   label: "Wanssum (NLWAS)"
  },
  {
   value: "Warfhuizen (NLWHU)",
   label: "Warfhuizen (NLWHU)"
  },
  {
   value: "Warga (NLWRA)",
   label: "Warga (NLWRA)"
  },
  {
   value: "Warten (NLWTN)",
   label: "Warten (NLWTN)"
  },
  {
   value: "Weakens (NLWKS)",
   label: "Weakens (NLWKS)"
  },
  {
   value: "Wehe-den Hoorn (NLWHO)",
   label: "Wehe-den Hoorn (NLWHO)"
  },
  {
   value: "Wekerom (NLWKO)",
   label: "Wekerom (NLWKO)"
  },
  {
   value: "Well (NLWEL)",
   label: "Well (NLWEL)"
  },
  {
   value: "Welsrijp (NLWRP)",
   label: "Welsrijp (NLWRP)"
  },
  {
   value: "Wenum (NLWWL)",
   label: "Wenum (NLWWL)"
  },
  {
   value: "Westbeemster (NLWBS)",
   label: "Westbeemster (NLWBS)"
  },
  {
   value: "Westerbork (NLWBK)",
   label: "Westerbork (NLWBK)"
  },
  {
   value: "Westerbroek (NLWBR)",
   label: "Westerbroek (NLWBR)"
  },
  {
   value: "Westergeest (NLWGE)",
   label: "Westergeest (NLWGE)"
  },
  {
   value: "Westerhoven (NLWHN)",
   label: "Westerhoven (NLWHN)"
  },
  {
   value: "West-Graftdijk (NLWGD)",
   label: "West-Graftdijk (NLWGD)"
  },
  {
   value: "Westhoek (NLWHK)",
   label: "Westhoek (NLWHK)"
  },
  {
   value: "Westkapelle (NLWKP)",
   label: "Westkapelle (NLWKP)"
  },
  {
   value: "Weurt (NLWEU)",
   label: "Weurt (NLWEU)"
  },
  {
   value: "Wier (NLWIE)",
   label: "Wier (NLWIE)"
  },
  {
   value: "Wieringen (NLWRG)",
   label: "Wieringen (NLWRG)"
  },
  {
   value: "Wieringermeer (NLWGR)",
   label: "Wieringermeer (NLWGR)"
  },
  {
   value: "Wieringewaard (NLWWD)",
   label: "Wieringewaard (NLWWD)"
  },
  {
   value: "Wierum (NLWRU)",
   label: "Wierum (NLWRU)"
  },
  {
   value: "Wijdewormer (NLWWO)",
   label: "Wijdewormer (NLWWO)"
  },
  {
   value: "Wijgeest (NLWGT)",
   label: "Wijgeest (NLWGT)"
  },
  {
   value: "Wijk (NLWKA)",
   label: "Wijk (NLWKA)"
  },
  {
   value: "Wijk en Aalburg (NLWEA)",
   label: "Wijk en Aalburg (NLWEA)"
  },
  {
   value: "Wijnjewoude (NLWJW)",
   label: "Wijnjewoude (NLWJW)"
  },
  {
   value: "Wilhelminadorp (NLWHD)",
   label: "Wilhelminadorp (NLWHD)"
  },
  {
   value: "Winssen (NLWSN)",
   label: "Winssen (NLWSN)"
  },
  {
   value: "Winsum (NLWNS)",
   label: "Winsum (NLWNS)"
  },
  {
   value: "Wittelte (NLWIT)",
   label: "Wittelte (NLWIT)"
  },
  {
   value: "Wolfheze (NLWOL)",
   label: "Wolfheze (NLWOL)"
  },
  {
   value: "Wolsumerketting (NLWKG)",
   label: "Wolsumerketting (NLWKG)"
  },
  {
   value: "Wommels (NLWMS)",
   label: "Wommels (NLWMS)"
  },
  {
   value: "Workum (NLWKU)",
   label: "Workum (NLWKU)"
  },
  {
   value: "Woudsend (NLWSD)",
   label: "Woudsend (NLWSD)"
  },
  {
   value: "Zaamslag (NLZAH)",
   label: "Zaamslag (NLZAH)"
  },
  {
   value: "Zaanstad (NLZST)",
   label: "Zaanstad (NLZST)"
  },
  {
   value: "Zandpol (NLZPO)",
   label: "Zandpol (NLZPO)"
  },
  {
   value: "Zeeland (NLZLA)",
   label: "Zeeland (NLZLA)"
  },
  {
   value: "Zeewolde (NLZEW)",
   label: "Zeewolde (NLZEW)"
  },
  {
   value: "Zegge (NLZEG)",
   label: "Zegge (NLZEG)"
  },
  {
   value: "Zeist (NLZIT)",
   label: "Zeist (NLZIT)"
  },
  {
   value: "Zelhem (NLZEM)",
   label: "Zelhem (NLZEM)"
  },
  {
   value: "Zevenbergschen Hoek (NLZBK)",
   label: "Zevenbergschen Hoek (NLZBK)"
  },
  {
   value: "Zijpersluis (NLZPS)",
   label: "Zijpersluis (NLZPS)"
  },
  {
   value: "Zoeterwoude (NLZOU)",
   label: "Zoeterwoude (NLZOU)"
  },
  {
   value: "Zoutelande (NLZLD)",
   label: "Zoutelande (NLZLD)"
  },
  {
   value: "Zuid-Beijerland (NLZBJ)",
   label: "Zuid-Beijerland (NLZBJ)"
  },
  {
   value: "Zuidbroek (NLZBO)",
   label: "Zuidbroek (NLZBO)"
  },
  {
   value: "Zuiddorpe (NLZBY)",
   label: "Zuiddorpe (NLZBY)"
  },
  {
   value: "Zuideinde (NLZEI)",
   label: "Zuideinde (NLZEI)"
  },
  {
   value: "Zuidlaren (NLZDL)",
   label: "Zuidlaren (NLZDL)"
  },
  {
   value: "Zuidwolde (NLZWL)",
   label: "Zuidwolde (NLZWL)"
  },
  {
   value: "Zuna (NLZUN)",
   label: "Zuna (NLZUN)"
  },
  {
   value: "Zurich (NLZUR)",
   label: "Zurich (NLZUR)"
  },
  {
   value: "Zwaanshoek (NLZHO)",
   label: "Zwaanshoek (NLZHO)"
  },
  {
   value: "Zwartebroek (NLZBR)",
   label: "Zwartebroek (NLZBR)"
  },
  {
   value: "Zwartenberg (NLZWB)",
   label: "Zwartenberg (NLZWB)"
  },
  {
   value: "Zwiggelte (NLZGE)",
   label: "Zwiggelte (NLZGE)"
  },
  {
   value: "Zwinderen (NLZWN)",
   label: "Zwinderen (NLZWN)"
  },
  {
   value: ".NORWAY (NO)",
   label: ".NORWAY (NO)"
  },
  {
   value: "Akland (NOAKL)",
   label: "Akland (NOAKL)"
  },
  {
   value: "Ål (NOAAL)",
   label: "Ål (NOAAL)"
  },
  {
   value: "Ålgård (NOALG)",
   label: "Ålgård (NOALG)"
  },
  {
   value: "Alvdal (NOADL)",
   label: "Alvdal (NOADL)"
  },
  {
   value: "Åna-Sira (NOASR)",
   label: "Åna-Sira (NOASR)"
  },
  {
   value: "Arhus (NOAHS)",
   label: "Arhus (NOAHS)"
  },
  {
   value: "Arneberg (NOANB)",
   label: "Arneberg (NOANB)"
  },
  {
   value: "Åros (NOROS)",
   label: "Åros (NOROS)"
  },
  {
   value: "Bergneset (NOBGN)",
   label: "Bergneset (NOBGN)"
  },
  {
   value: "Bergunnhaugen (NOBGU)",
   label: "Bergunnhaugen (NOBGU)"
  },
  {
   value: "Berrvik (Bergvik) (NOBNG)",
   label: "Berrvik (Bergvik) (NOBNG)"
  },
  {
   value: "Billingstad (NOBSA)",
   label: "Billingstad (NOBSA)"
  },
  {
   value: "Birkeland (NOBLD)",
   label: "Birkeland (NOBLD)"
  },
  {
   value: "Bjerka (NOBJE)",
   label: "Bjerka (NOBJE)"
  },
  {
   value: "Bjerkreim (NOBXK)",
   label: "Bjerkreim (NOBXK)"
  },
  {
   value: "Bjerkvik (NOBKV)",
   label: "Bjerkvik (NOBKV)"
  },
  {
   value: "Bjoa (Innbjoa) (NOBJA)",
   label: "Bjoa (Innbjoa) (NOBJA)"
  },
  {
   value: "Blomsterdalen (NOBDN)",
   label: "Blomsterdalen (NOBDN)"
  },
  {
   value: "Bogen (NOBOG)",
   label: "Bogen (NOBOG)"
  },
  {
   value: "Bolsøya (NOBLY)",
   label: "Bolsøya (NOBLY)"
  },
  {
   value: "Borkenes (NOBOS)",
   label: "Borkenes (NOBOS)"
  },
  {
   value: "Bosberg (NOBBG)",
   label: "Bosberg (NOBBG)"
  },
  {
   value: "Botnaneset (NOBTN)",
   label: "Botnaneset (NOBTN)"
  },
  {
   value: "Botnhamn (NOBTH)",
   label: "Botnhamn (NOBTH)"
  },
  {
   value: "Bøvågen (NOBOV)",
   label: "Bøvågen (NOBOV)"
  },
  {
   value: "Brandval (NOBVL)",
   label: "Brandval (NOBVL)"
  },
  {
   value: "Brattholmen (NONZG)",
   label: "Brattholmen (NONZG)"
  },
  {
   value: "Breivikbotn (NOBVB)",
   label: "Breivikbotn (NOBVB)"
  },
  {
   value: "Brekke (NONZF)",
   label: "Brekke (NONZF)"
  },
  {
   value: "Brekstad (NOBKS)",
   label: "Brekstad (NOBKS)"
  },
  {
   value: "Bremnes (NONZD)",
   label: "Bremnes (NONZD)"
  },
  {
   value: "Brumunddal (NOBRU)",
   label: "Brumunddal (NOBRU)"
  },
  {
   value: "Bryggja (NOBRA)",
   label: "Bryggja (NOBRA)"
  },
  {
   value: "Bugøynes (NOBUG)",
   label: "Bugøynes (NOBUG)"
  },
  {
   value: "Bygland (NOBYG)",
   label: "Bygland (NOBYG)"
  },
  {
   value: "Dal (NODAL)",
   label: "Dal (NODAL)"
  },
  {
   value: "Damsgård (NODMG)",
   label: "Damsgård (NODMG)"
  },
  {
   value: "Deknepollen (NONZI)",
   label: "Deknepollen (NONZI)"
  },
  {
   value: "Digernes (NODGR)",
   label: "Digernes (NODGR)"
  },
  {
   value: "Dimmelsvik (NODIM)",
   label: "Dimmelsvik (NODIM)"
  },
  {
   value: "Dirdal (NODIR)",
   label: "Dirdal (NODIR)"
  },
  {
   value: "Djupvik (NODJU)",
   label: "Djupvik (NODJU)"
  },
  {
   value: "Dokka (NODOK)",
   label: "Dokka (NODOK)"
  },
  {
   value: "Dragedal (NODDL)",
   label: "Dragedal (NODDL)"
  },
  {
   value: "Dusavik (NODUS)",
   label: "Dusavik (NODUS)"
  },
  {
   value: "Dyrstad (NODYD)",
   label: "Dyrstad (NODYD)"
  },
  {
   value: "Egersund (NOEGE)",
   label: "Egersund (NOEGE)"
  },
  {
   value: "Eggesbones (NOEGG)",
   label: "Eggesbones (NOEGG)"
  },
  {
   value: "Eidslandet (NOEIL)",
   label: "Eidslandet (NOEIL)"
  },
  {
   value: "Eidsnes (NOESE)",
   label: "Eidsnes (NOESE)"
  },
  {
   value: "Eidsvåg (NOEIV)",
   label: "Eidsvåg (NOEIV)"
  },
  {
   value: "Eikefjord (NOEIK)",
   label: "Eikefjord (NOEIK)"
  },
  {
   value: "Eikelandsosen (NOELO)",
   label: "Eikelandsosen (NOELO)"
  },
  {
   value: "Eivindvik (NOEVV)",
   label: "Eivindvik (NOEVV)"
  },
  {
   value: "Ellingsoy (NOELL)",
   label: "Ellingsoy (NOELL)"
  },
  {
   value: "Elnesvågen (NOELN)",
   label: "Elnesvågen (NOELN)"
  },
  {
   value: "Enebakk (NONZK)",
   label: "Enebakk (NONZK)"
  },
  {
   value: "Engelsviken (NOEGV)",
   label: "Engelsviken (NOEGV)"
  },
  {
   value: "Engene (NOENG)",
   label: "Engene (NOENG)"
  },
  {
   value: "Ervik (NOHDV)",
   label: "Ervik (NOHDV)"
  },
  {
   value: "Espa (NOEPA)",
   label: "Espa (NOEPA)"
  },
  {
   value: "Espevik (NOESP)",
   label: "Espevik (NOESP)"
  },
  {
   value: "Fetsund (NOFSU)",
   label: "Fetsund (NOFSU)"
  },
  {
   value: "Fetsund (NOFTU)",
   label: "Fetsund (NOFTU)"
  },
  {
   value: "Fevik (NOFEV)",
   label: "Fevik (NOFEV)"
  },
  {
   value: "Finnfjordbotn (NOFFB)",
   label: "Finnfjordbotn (NOFFB)"
  },
  {
   value: "Fiskarstranda (NOFSA)",
   label: "Fiskarstranda (NOFSA)"
  },
  {
   value: "Fjellstrand (NOFSD)",
   label: "Fjellstrand (NOFSD)"
  },
  {
   value: "Flåm (NOFLA)",
   label: "Flåm (NOFLA)"
  },
  {
   value: "Flatdal (NOFDL)",
   label: "Flatdal (NOFDL)"
  },
  {
   value: "Flekkerøy (NOFLE)",
   label: "Flekkerøy (NOFLE)"
  },
  {
   value: "Flisa (NOFLS)",
   label: "Flisa (NOFLS)"
  },
  {
   value: "Florvåg (NOFLO)",
   label: "Florvåg (NOFLO)"
  },
  {
   value: "Fornebu (NONZB)",
   label: "Fornebu (NONZB)"
  },
  {
   value: "Fosser (NOFSR)",
   label: "Fosser (NOFSR)"
  },
  {
   value: "Frafjord (NOOLT)",
   label: "Frafjord (NOOLT)"
  },
  {
   value: "Frogner (NONZJ)",
   label: "Frogner (NONZJ)"
  },
  {
   value: "Fyresdal (NOFYR)",
   label: "Fyresdal (NOFYR)"
  },
  {
   value: "Gardermoen (NOGEN)",
   label: "Gardermoen (NOGEN)"
  },
  {
   value: "Gaupen (NOGPE)",
   label: "Gaupen (NOGPE)"
  },
  {
   value: "Gaupne (NOGPN)",
   label: "Gaupne (NOGPN)"
  },
  {
   value: "Gjerdrum (NOGDM)",
   label: "Gjerdrum (NOGDM)"
  },
  {
   value: "Gjerstad (NOGSD)",
   label: "Gjerstad (NOGSD)"
  },
  {
   value: "Glesvær (NONZL)",
   label: "Glesvær (NONZL)"
  },
  {
   value: "Godvik (NOGOD)",
   label: "Godvik (NOGOD)"
  },
  {
   value: "Gressvik (NOGVI)",
   label: "Gressvik (NOGVI)"
  },
  {
   value: "Gryllefjord (NOGRY)",
   label: "Gryllefjord (NOGRY)"
  },
  {
   value: "Gudvangen (NOGUD)",
   label: "Gudvangen (NOGUD)"
  },
  {
   value: "Gullsmedvika\/Mo i Rana (NOGUS)",
   label: "Gullsmedvika\/Mo i Rana (NOGUS)"
  },
  {
   value: "Gursken (NOGUR)",
   label: "Gursken (NOGUR)"
  },
  {
   value: "Haakonsvern (NOHVN)",
   label: "Haakonsvern (NOHVN)"
  },
  {
   value: "Hafslundsoy (NOHLY)",
   label: "Hafslundsoy (NOHLY)"
  },
  {
   value: "Hagan (NOHGN)",
   label: "Hagan (NOHGN)"
  },
  {
   value: "Hågån (NOHGA)",
   label: "Hågån (NOHGA)"
  },
  {
   value: "Halsvik (NOHLV)",
   label: "Halsvik (NOHLV)"
  },
  {
   value: "Hamnbukt (NOHBT)",
   label: "Hamnbukt (NOHBT)"
  },
  {
   value: "Hanestad (NOHNS)",
   label: "Hanestad (NOHNS)"
  },
  {
   value: "Harøy (NOHAY)",
   label: "Harøy (NOHAY)"
  },
  {
   value: "Harøysundet (NOHRS)",
   label: "Harøysundet (NOHRS)"
  },
  {
   value: "Haslemoen (NOHMN)",
   label: "Haslemoen (NOHMN)"
  },
  {
   value: "Havøysund (NOHAV)",
   label: "Havøysund (NOHAV)"
  },
  {
   value: "Heggedal (NOHGL)",
   label: "Heggedal (NOHGL)"
  },
  {
   value: "Hegreneset (NOHGR)",
   label: "Hegreneset (NOHGR)"
  },
  {
   value: "Heimdal (NOHDL)",
   label: "Heimdal (NOHDL)"
  },
  {
   value: "Heimdal (NOHEI)",
   label: "Heimdal (NOHEI)"
  },
  {
   value: "Hell (NOEHL)",
   label: "Hell (NOEHL)"
  },
  {
   value: "Hellesylt (NOHSY)",
   label: "Hellesylt (NOHSY)"
  },
  {
   value: "Hellvik (NOHEL)",
   label: "Hellvik (NOHEL)"
  },
  {
   value: "Hemsedal (NOHSD)",
   label: "Hemsedal (NOHSD)"
  },
  {
   value: "Henningsvær (NOHEN)",
   label: "Henningsvær (NOHEN)"
  },
  {
   value: "Herdla (NOHED)",
   label: "Herdla (NOHED)"
  },
  {
   value: "Herøy (NOHRO)",
   label: "Herøy (NOHRO)"
  },
  {
   value: "Hillevåg\/Stavanger (NOHIL)",
   label: "Hillevåg\/Stavanger (NOHIL)"
  },
  {
   value: "Hjørungavåg (NOHJO)",
   label: "Hjørungavåg (NOHJO)"
  },
  {
   value: "Høgset (NOHOG)",
   label: "Høgset (NOHOG)"
  },
  {
   value: "Hokksund (NOHOD)",
   label: "Hokksund (NOHOD)"
  },
  {
   value: "Høllen (NOHLL)",
   label: "Høllen (NOHLL)"
  },
  {
   value: "Holmefjord (NOHMF)",
   label: "Holmefjord (NOHMF)"
  },
  {
   value: "Hornnes (NOHON)",
   label: "Hornnes (NOHON)"
  },
  {
   value: "Hov (NOHOS)",
   label: "Hov (NOHOS)"
  },
  {
   value: "Hovdenakken (NOHNN)",
   label: "Hovdenakken (NOHNN)"
  },
  {
   value: "Høvringen (NOVDD)",
   label: "Høvringen (NOVDD)"
  },
  {
   value: "Høylandsbygda (NOHLB)",
   label: "Høylandsbygda (NOHLB)"
  },
  {
   value: "Husøy (NOHOY)",
   label: "Husøy (NOHOY)"
  },
  {
   value: "Husøy (NOHSS)",
   label: "Husøy (NOHSS)"
  },
  {
   value: "Hyen (NOHYE)",
   label: "Hyen (NOHYE)"
  },
  {
   value: "Innvik (NOINV)",
   label: "Innvik (NOINV)"
  },
  {
   value: "Isdalstø (NOISD)",
   label: "Isdalstø (NOISD)"
  },
  {
   value: "Isfjorden (NOIFN)",
   label: "Isfjorden (NOIFN)"
  },
  {
   value: "Jelsa (NOJEL)",
   label: "Jelsa (NOJEL)"
  },
  {
   value: "Kalandseidet (NOKDT)",
   label: "Kalandseidet (NOKDT)"
  },
  {
   value: "Kamøyvær (NOKMV)",
   label: "Kamøyvær (NOKMV)"
  },
  {
   value: "Karvikhamn (NOKKM)",
   label: "Karvikhamn (NOKKM)"
  },
  {
   value: "Kinn (NOKIN)",
   label: "Kinn (NOKIN)"
  },
  {
   value: "Kirkenær (NOKKR)",
   label: "Kirkenær (NOKKR)"
  },
  {
   value: "Kjeller (NOKLR)",
   label: "Kjeller (NOKLR)"
  },
  {
   value: "Kjøllefjord (NOKJF)",
   label: "Kjøllefjord (NOKJF)"
  },
  {
   value: "Kjøpmannskjær (NOKMS)",
   label: "Kjøpmannskjær (NOKMS)"
  },
  {
   value: "Klepp Stasjon (NONZN)",
   label: "Klepp Stasjon (NONZN)"
  },
  {
   value: "Kleppe (NONZM)",
   label: "Kleppe (NONZM)"
  },
  {
   value: "Kleppestø (NOKLE)",
   label: "Kleppestø (NOKLE)"
  },
  {
   value: "Kodal (NOKOD)",
   label: "Kodal (NOKOD)"
  },
  {
   value: "Kokstad (NONZO)",
   label: "Kokstad (NONZO)"
  },
  {
   value: "Kollsnes (NOKON)",
   label: "Kollsnes (NOKON)"
  },
  {
   value: "Kolvereid (NOHVR)",
   label: "Kolvereid (NOHVR)"
  },
  {
   value: "Kongsmoen (NOKGM)",
   label: "Kongsmoen (NOKGM)"
  },
  {
   value: "Kopperå (NONZS)",
   label: "Kopperå (NONZS)"
  },
  {
   value: "Kuvika (NOKUV)",
   label: "Kuvika (NOKUV)"
  },
  {
   value: "Kvaleberg (NOKVB)",
   label: "Kvaleberg (NOKVB)"
  },
  {
   value: "Kvalneset (NOKAL)",
   label: "Kvalneset (NOKAL)"
  },
  {
   value: "Kvanndal (NOKDL)",
   label: "Kvanndal (NOKDL)"
  },
  {
   value: "Laksevåg (NOLVG)",
   label: "Laksevåg (NOLVG)"
  },
  {
   value: "Langevåg (NOLAN)",
   label: "Langevåg (NOLAN)"
  },
  {
   value: "Langhus (NOLHS)",
   label: "Langhus (NOLHS)"
  },
  {
   value: "Larsnes (NONZC)",
   label: "Larsnes (NONZC)"
  },
  {
   value: "Leinstrand (NOTRR)",
   label: "Leinstrand (NOTRR)"
  },
  {
   value: "Leira (NOLEI)",
   label: "Leira (NOLEI)"
  },
  {
   value: "Leirpollen (NOLEP)",
   label: "Leirpollen (NOLEP)"
  },
  {
   value: "Leknes (NOLKN)",
   label: "Leknes (NOLKN)"
  },
  {
   value: "Lepsøy (NONYB)",
   label: "Lepsøy (NONYB)"
  },
  {
   value: "Liavåg (NONZP)",
   label: "Liavåg (NONZP)"
  },
  {
   value: "Lierstranda (NOLIS)",
   label: "Lierstranda (NOLIS)"
  },
  {
   value: "Loen (NOLOE)",
   label: "Loen (NOLOE)"
  },
  {
   value: "Löken (NOLKE)",
   label: "Löken (NOLKE)"
  },
  {
   value: "Løkken Verk (NOLVE)",
   label: "Løkken Verk (NOLVE)"
  },
  {
   value: "Longyearbyen (NOLYR)",
   label: "Longyearbyen (NOLYR)"
  },
  {
   value: "Lørenskog (NOLSG)",
   label: "Lørenskog (NOLSG)"
  },
  {
   value: "Løten (NOLOT)",
   label: "Løten (NOLOT)"
  },
  {
   value: "Lovund (NOLOV)",
   label: "Lovund (NOLOV)"
  },
  {
   value: "Lura (NOLRA)",
   label: "Lura (NOLRA)"
  },
  {
   value: "Lyngstad (NOLNS)",
   label: "Lyngstad (NOLNS)"
  },
  {
   value: "Lysebotn (NOLYF)",
   label: "Lysebotn (NOLYF)"
  },
  {
   value: "Lysefjorden (NOSNT)",
   label: "Lysefjorden (NOSNT)"
  },
  {
   value: "Lysøysund (NOLSU)",
   label: "Lysøysund (NOLSU)"
  },
  {
   value: "Marnardal (NOMRN)",
   label: "Marnardal (NOMRN)"
  },
  {
   value: "Matre (NOMAT)",
   label: "Matre (NOMAT)"
  },
  {
   value: "Meisingset (NOMST)",
   label: "Meisingset (NOMST)"
  },
  {
   value: "Melkøya (NOMLK)",
   label: "Melkøya (NOMLK)"
  },
  {
   value: "Melsomvik (NOMEV)",
   label: "Melsomvik (NOMEV)"
  },
  {
   value: "Meraker (NOMER)",
   label: "Meraker (NOMER)"
  },
  {
   value: "Moi (NOMOI)",
   label: "Moi (NOMOI)"
  },
  {
   value: "Moldtustranda (NOMLT)",
   label: "Moldtustranda (NOMLT)"
  },
  {
   value: "Mosby (NOMSB)",
   label: "Mosby (NOMSB)"
  },
  {
   value: "Myre (NOMYR)",
   label: "Myre (NOMYR)"
  },
  {
   value: "Nannestad (NODSN)",
   label: "Nannestad (NODSN)"
  },
  {
   value: "Nedre Vats (NONVS)",
   label: "Nedre Vats (NONVS)"
  },
  {
   value: "Nesbyen (NONSY)",
   label: "Nesbyen (NONSY)"
  },
  {
   value: "Nesna (NONSN)",
   label: "Nesna (NONSN)"
  },
  {
   value: "Nesøya (NONEY)",
   label: "Nesøya (NONEY)"
  },
  {
   value: "Nesttun (NONTN)",
   label: "Nesttun (NONTN)"
  },
  {
   value: "Nittedal (NONIT)",
   label: "Nittedal (NONIT)"
  },
  {
   value: "Nodeland (NONLD)",
   label: "Nodeland (NONLD)"
  },
  {
   value: "Nordkisa (NONKS)",
   label: "Nordkisa (NONKS)"
  },
  {
   value: "Noresund (NONRS)",
   label: "Noresund (NONRS)"
  },
  {
   value: "Nybergsund (NONSD)",
   label: "Nybergsund (NONSD)"
  },
  {
   value: "Nyhamna (NONYH)",
   label: "Nyhamna (NONYH)"
  },
  {
   value: "Øksfjord (NOOKF)",
   label: "Øksfjord (NOOKF)"
  },
  {
   value: "Oltedal (NOLYB)",
   label: "Oltedal (NOLYB)"
  },
  {
   value: "Opakermoen (NOOPA)",
   label: "Opakermoen (NOOPA)"
  },
  {
   value: "Ørnes (NOSVI)",
   label: "Ørnes (NOSVI)"
  },
  {
   value: "Ortnevik (NOORV)",
   label: "Ortnevik (NOORV)"
  },
  {
   value: "Os (NOOSZ)",
   label: "Os (NOOSZ)"
  },
  {
   value: "Osa (NOOSA)",
   label: "Osa (NOOSA)"
  },
  {
   value: "Østerås (NOOAS)",
   label: "Østerås (NOOAS)"
  },
  {
   value: "Ottersøya (NOOTA)",
   label: "Ottersøya (NOOTA)"
  },
  {
   value: "Øvrebø (NOOVO)",
   label: "Øvrebø (NOOVO)"
  },
  {
   value: "Øye (NOOEY)",
   label: "Øye (NOOEY)"
  },
  {
   value: "Øyjord (NOOJD)",
   label: "Øyjord (NOOJD)"
  },
  {
   value: "Prestfoss (NOPFS)",
   label: "Prestfoss (NOPFS)"
  },
  {
   value: "Raelingen (NORLN)",
   label: "Raelingen (NORLN)"
  },
  {
   value: "Råholt (NORHT)",
   label: "Råholt (NORHT)"
  },
  {
   value: "Ramsvika (NORMV)",
   label: "Ramsvika (NORMV)"
  },
  {
   value: "Ranheim (NORAN)",
   label: "Ranheim (NORAN)"
  },
  {
   value: "Raubergvika (NORBV)",
   label: "Raubergvika (NORBV)"
  },
  {
   value: "Rausand (NORSD)",
   label: "Rausand (NORSD)"
  },
  {
   value: "Reine (NOREI)",
   label: "Reine (NOREI)"
  },
  {
   value: "Repvåg (NORPV)",
   label: "Repvåg (NORPV)"
  },
  {
   value: "Rindal (NORND)",
   label: "Rindal (NORND)"
  },
  {
   value: "Risøyhamn (NORSH)",
   label: "Risøyhamn (NORSH)"
  },
  {
   value: "Rissa (NORSS)",
   label: "Rissa (NORSS)"
  },
  {
   value: "Roa (NORAO)",
   label: "Roa (NORAO)"
  },
  {
   value: "Rødberg (NORBG)",
   label: "Rødberg (NORBG)"
  },
  {
   value: "Rognan (NOROG)",
   label: "Rognan (NOROG)"
  },
  {
   value: "Rømskog (NORSG)",
   label: "Rømskog (NORSG)"
  },
  {
   value: "Rønningen (NORON)",
   label: "Rønningen (NORON)"
  },
  {
   value: "Rosendal (NORSE)",
   label: "Rosendal (NORSE)"
  },
  {
   value: "Rubbestadneset (NORUB)",
   label: "Rubbestadneset (NORUB)"
  },
  {
   value: "Rud (NORUD)",
   label: "Rud (NORUD)"
  },
  {
   value: "Rudshøgda (NORUS)",
   label: "Rudshøgda (NORUS)"
  },
  {
   value: "Rykene (NONZU)",
   label: "Rykene (NONZU)"
  },
  {
   value: "Rypefjord (NORYF)",
   label: "Rypefjord (NORYF)"
  },
  {
   value: "Sagstua (NOSGU)",
   label: "Sagstua (NOSGU)"
  },
  {
   value: "Salten (NOSAT)",
   label: "Salten (NOSAT)"
  },
  {
   value: "Salthella (NOSLH)",
   label: "Salthella (NOSLH)"
  },
  {
   value: "Sande i Vestfold (NOSVF)",
   label: "Sande i Vestfold (NOSVF)"
  },
  {
   value: "Sannidal (NOANN)",
   label: "Sannidal (NOANN)"
  },
  {
   value: "Seljelvnes (NOSJN)",
   label: "Seljelvnes (NOSJN)"
  },
  {
   value: "Sem (NOSEM)",
   label: "Sem (NOSEM)"
  },
  {
   value: "Senja (NOKLV)",
   label: "Senja (NOKLV)"
  },
  {
   value: "Senjehopen (NOSJH)",
   label: "Senjehopen (NOSJH)"
  },
  {
   value: "Sigerfjord (NOSRD)",
   label: "Sigerfjord (NOSRD)"
  },
  {
   value: "Siggerud (NOSIG)",
   label: "Siggerud (NOSIG)"
  },
  {
   value: "Sirevaag (NOSRV)",
   label: "Sirevaag (NOSRV)"
  },
  {
   value: "Siri (NOSIR)",
   label: "Siri (NOSIR)"
  },
  {
   value: "Sjursøja\/Oslo (NOSJU)",
   label: "Sjursøja\/Oslo (NOSJU)"
  },
  {
   value: "Skålevik (NOSKV)",
   label: "Skålevik (NOSKV)"
  },
  {
   value: "Skalle (NOSKM)",
   label: "Skalle (NOSKM)"
  },
  {
   value: "Skjetten (NOSJT)",
   label: "Skjetten (NOSJT)"
  },
  {
   value: "Skjolden (NOSLN)",
   label: "Skjolden (NOSLN)"
  },
  {
   value: "Skogsvåg (NOSKG)",
   label: "Skogsvåg (NOSKG)"
  },
  {
   value: "Skoppum (NOSKP)",
   label: "Skoppum (NOSKP)"
  },
  {
   value: "Skrova (NOSRO)",
   label: "Skrova (NOSRO)"
  },
  {
   value: "Skutvik (NOORN)",
   label: "Skutvik (NOORN)"
  },
  {
   value: "Sløvåg (NOSLV)",
   label: "Sløvåg (NOSLV)"
  },
  {
   value: "Snarøya (NOROY)",
   label: "Snarøya (NOROY)"
  },
  {
   value: "Sofiemyr (NOSMR)",
   label: "Sofiemyr (NOSMR)"
  },
  {
   value: "Søfteland (NOSFT)",
   label: "Søfteland (NOSFT)"
  },
  {
   value: "Sokna (NOSNA)",
   label: "Sokna (NOSNA)"
  },
  {
   value: "Solbergelva (NOSBE)",
   label: "Solbergelva (NOSBE)"
  },
  {
   value: "Sommarøy (NOSOM)",
   label: "Sommarøy (NOSOM)"
  },
  {
   value: "Son (NOSON)",
   label: "Son (NOSON)"
  },
  {
   value: "Sørkjosen (NOSOJ)",
   label: "Sørkjosen (NOSOJ)"
  },
  {
   value: "Sørvær (NOSVR)",
   label: "Sørvær (NOSVR)"
  },
  {
   value: "Sövik (NOSOV)",
   label: "Sövik (NOSOV)"
  },
  {
   value: "Spikkestad (NOSPI)",
   label: "Spikkestad (NOSPI)"
  },
  {
   value: "Spillåm (NOSPM)",
   label: "Spillåm (NOSPM)"
  },
  {
   value: "Spongdal (NOSPD)",
   label: "Spongdal (NOSPD)"
  },
  {
   value: "Spydeberg (NOSPY)",
   label: "Spydeberg (NOSPY)"
  },
  {
   value: "Staubø (NOSAB)",
   label: "Staubø (NOSAB)"
  },
  {
   value: "Stavneset (NOVEA)",
   label: "Stavneset (NOVEA)"
  },
  {
   value: "Steinberg (NOSNB)",
   label: "Steinberg (NOSNB)"
  },
  {
   value: "Steinesjøen (NOSNS)",
   label: "Steinesjøen (NOSNS)"
  },
  {
   value: "Steinkjer (NOSJR)",
   label: "Steinkjer (NOSJR)"
  },
  {
   value: "Steinshamn (NOSTH)",
   label: "Steinshamn (NOSTH)"
  },
  {
   value: "Stjernøya (NOSTY)",
   label: "Stjernøya (NOSTY)"
  },
  {
   value: "Stokksund (NOSKK)",
   label: "Stokksund (NOSKK)"
  },
  {
   value: "Stokkvaagan (NOSTO)",
   label: "Stokkvaagan (NOSTO)"
  },
  {
   value: "Storabo (NOSTB)",
   label: "Storabo (NOSTB)"
  },
  {
   value: "Storøya (NOSOY)",
   label: "Storøya (NOSOY)"
  },
  {
   value: "Storsteinnes (NOSSN)",
   label: "Storsteinnes (NOSSN)"
  },
  {
   value: "Straume (NOUME)",
   label: "Straume (NOUME)"
  },
  {
   value: "Straumen (NOSTM)",
   label: "Straumen (NOSTM)"
  },
  {
   value: "Straumsnes (NOSRM)",
   label: "Straumsnes (NOSRM)"
  },
  {
   value: "Strømmen (NOSMM)",
   label: "Strømmen (NOSMM)"
  },
  {
   value: "Sunde (NOSIS)",
   label: "Sunde (NOSIS)"
  },
  {
   value: "Tafjord (NOTAF)",
   label: "Tafjord (NOTAF)"
  },
  {
   value: "Tennfjord (NOTEJ)",
   label: "Tennfjord (NOTEJ)"
  },
  {
   value: "Thorøya (NOTOY)",
   label: "Thorøya (NOTOY)"
  },
  {
   value: "Tjeldbergodden (NOTBO)",
   label: "Tjeldbergodden (NOTBO)"
  },
  {
   value: "Tjodalyng (NOTLG)",
   label: "Tjodalyng (NOTLG)"
  },
  {
   value: "Toböl (NOTBL)",
   label: "Toböl (NOTBL)"
  },
  {
   value: "Tofte (NONZH)",
   label: "Tofte (NONZH)"
  },
  {
   value: "Tolga (NOTGA)",
   label: "Tolga (NOTGA)"
  },
  {
   value: "Torangsvåg (NOTAV)",
   label: "Torangsvåg (NOTAV)"
  },
  {
   value: "Torp (NOTRP)",
   label: "Torp (NOTRP)"
  },
  {
   value: "Tovik (NOTOV)",
   label: "Tovik (NOTOV)"
  },
  {
   value: "Træna (NOTRN)",
   label: "Træna (NOTRN)"
  },
  {
   value: "Tranby (NOTNB)",
   label: "Tranby (NOTNB)"
  },
  {
   value: "Trollåsen (NOTRO)",
   label: "Trollåsen (NOTRO)"
  },
  {
   value: "Tromsdalen (NONZY)",
   label: "Tromsdalen (NONZY)"
  },
  {
   value: "Tromvik (NOTMV)",
   label: "Tromvik (NOTMV)"
  },
  {
   value: "Trysil (NOTRL)",
   label: "Trysil (NOTRL)"
  },
  {
   value: "Uggdal (NOUGD)",
   label: "Uggdal (NOUGD)"
  },
  {
   value: "Ulsvåg (NOUVG)",
   label: "Ulsvåg (NOUVG)"
  },
  {
   value: "Uskedal (NOUSD)",
   label: "Uskedal (NOUSD)"
  },
  {
   value: "Uthaug (NOUTH)",
   label: "Uthaug (NOUTH)"
  },
  {
   value: "Utne (NOUTN)",
   label: "Utne (NOUTN)"
  },
  {
   value: "Uvdal (NOUVD)",
   label: "Uvdal (NOUVD)"
  },
  {
   value: "Vågå (NOVGA)",
   label: "Vågå (NOVGA)"
  },
  {
   value: "Vågsvåg (NOVVG)",
   label: "Vågsvåg (NOVVG)"
  },
  {
   value: "Valderøy (NONZA)",
   label: "Valderøy (NONZA)"
  },
  {
   value: "Våler (NOVAS)",
   label: "Våler (NOVAS)"
  },
  {
   value: "Våler (NOVLR)",
   label: "Våler (NOVLR)"
  },
  {
   value: "Valestrandsfossen (NOVDO)",
   label: "Valestrandsfossen (NOVDO)"
  },
  {
   value: "Valevåg (NOVAG)",
   label: "Valevåg (NOVAG)"
  },
  {
   value: "Vannvåg (NOVNV)",
   label: "Vannvåg (NOVNV)"
  },
  {
   value: "Varhaug (NONYA)",
   label: "Varhaug (NONYA)"
  },
  {
   value: "Vedavågen (NOVMD)",
   label: "Vedavågen (NOVMD)"
  },
  {
   value: "Vedde (NOSKT)",
   label: "Vedde (NOSKT)"
  },
  {
   value: "Vegårshei (NOVSH)",
   label: "Vegårshei (NOVSH)"
  },
  {
   value: "Vesterålen (NOFRF)",
   label: "Vesterålen (NOFRF)"
  },
  {
   value: "Vestfossen (NOVSS)",
   label: "Vestfossen (NOVSS)"
  },
  {
   value: "Vevang (NOVNG)",
   label: "Vevang (NOVNG)"
  },
  {
   value: "Vigra (NOVIG)",
   label: "Vigra (NOVIG)"
  },
  {
   value: "Vikan (NOVSM)",
   label: "Vikan (NOVSM)"
  },
  {
   value: "Vikersund (NOVKS)",
   label: "Vikersund (NOVKS)"
  },
  {
   value: "Vinstra (NOVIN)",
   label: "Vinstra (NOVIN)"
  },
  {
   value: "Voldafjorden (NOVOL)",
   label: "Voldafjorden (NOVOL)"
  },
  {
   value: "Voll (NOVLL)",
   label: "Voll (NOVLL)"
  },
  {
   value: "Vormedal (NOSAG)",
   label: "Vormedal (NOSAG)"
  },
  {
   value: "Vormsund (NOVSD)",
   label: "Vormsund (NOVSD)"
  },
  {
   value: "Voyenenga (NOVYG)",
   label: "Voyenenga (NOVYG)"
  },
  {
   value: "Vrengen (NOVRE)",
   label: "Vrengen (NOVRE)"
  },
  {
   value: "Ytre Enebakk (NOYTR)",
   label: "Ytre Enebakk (NOYTR)"
  },
  {
   value: ".NEPAL (NP)",
   label: ".NEPAL (NP)"
  },
  {
   value: "Baglung (NPBGL)",
   label: "Baglung (NPBGL)"
  },
  {
   value: "Baitadi (NPBIT)",
   label: "Baitadi (NPBIT)"
  },
  {
   value: "Bajhang (NPBJH)",
   label: "Bajhang (NPBJH)"
  },
  {
   value: "Bajura (NPBJU)",
   label: "Bajura (NPBJU)"
  },
  {
   value: "Bhadrapur (NPBDP)",
   label: "Bhadrapur (NPBDP)"
  },
  {
   value: "Bhairawa (NPBWA)",
   label: "Bhairawa (NPBWA)"
  },
  {
   value: "Bharatpur (NPBHR)",
   label: "Bharatpur (NPBHR)"
  },
  {
   value: "Bhojpur (NPBHP)",
   label: "Bhojpur (NPBHP)"
  },
  {
   value: "Chaurjhari (NPHRJ)",
   label: "Chaurjhari (NPHRJ)"
  },
  {
   value: "Dang (NPDNP)",
   label: "Dang (NPDNP)"
  },
  {
   value: "Darchula (NPDAP)",
   label: "Darchula (NPDAP)"
  },
  {
   value: "Dhangarhi (NPDHI)",
   label: "Dhangarhi (NPDHI)"
  },
  {
   value: "Dolpa (NPDOP)",
   label: "Dolpa (NPDOP)"
  },
  {
   value: "Gorkha (NPGKH)",
   label: "Gorkha (NPGKH)"
  },
  {
   value: "Janakpur (NPJKR)",
   label: "Janakpur (NPJKR)"
  },
  {
   value: "Jiri (NPJIR)",
   label: "Jiri (NPJIR)"
  },
  {
   value: "Jomsom (NPJMO)",
   label: "Jomsom (NPJMO)"
  },
  {
   value: "Jumla (NPJUM)",
   label: "Jumla (NPJUM)"
  },
  {
   value: "Kanchenjunga (NPKGJ)",
   label: "Kanchenjunga (NPKGJ)"
  },
  {
   value: "Lamidanda (NPLDN)",
   label: "Lamidanda (NPLDN)"
  },
  {
   value: "Langtang (NPLTG)",
   label: "Langtang (NPLTG)"
  },
  {
   value: "Lukla (NPLUA)",
   label: "Lukla (NPLUA)"
  },
  {
   value: "Manang (NPNGX)",
   label: "Manang (NPNGX)"
  },
  {
   value: "Meghauli (NPMEY)",
   label: "Meghauli (NPMEY)"
  },
  {
   value: "Mountain (NPMWP)",
   label: "Mountain (NPMWP)"
  },
  {
   value: "Nepalganj (NPKEP)",
   label: "Nepalganj (NPKEP)"
  },
  {
   value: "Phaplu (NPPPL)",
   label: "Phaplu (NPPPL)"
  },
  {
   value: "Rajbiraj (NPRJB)",
   label: "Rajbiraj (NPRJB)"
  },
  {
   value: "Ramechhap (NPRHP)",
   label: "Ramechhap (NPRHP)"
  },
  {
   value: "Rolpa (NPRPA)",
   label: "Rolpa (NPRPA)"
  },
  {
   value: "Rukumkot (NPRUK)",
   label: "Rukumkot (NPRUK)"
  },
  {
   value: "Rumjatar (NPRUM)",
   label: "Rumjatar (NPRUM)"
  },
  {
   value: "Sanfebagar (NPFEB)",
   label: "Sanfebagar (NPFEB)"
  },
  {
   value: "Silgarhi-Doti (NPSIH)",
   label: "Silgarhi-Doti (NPSIH)"
  },
  {
   value: "Simikot (NPIMK)",
   label: "Simikot (NPIMK)"
  },
  {
   value: "Surkhet (NPSKH)",
   label: "Surkhet (NPSKH)"
  },
  {
   value: "Syangboche (NPSYH)",
   label: "Syangboche (NPSYH)"
  },
  {
   value: "Taplejung (NPTPJ)",
   label: "Taplejung (NPTPJ)"
  },
  {
   value: "Tikapur (NPTPU)",
   label: "Tikapur (NPTPU)"
  },
  {
   value: "Tumlingtar (NPTMI)",
   label: "Tumlingtar (NPTMI)"
  },
  {
   value: ".NAURU (NR)",
   label: ".NAURU (NR)"
  },
  {
   value: ".NIUE (NU)",
   label: ".NIUE (NU)"
  },
  {
   value: "Alofi (NUALO)",
   label: "Alofi (NUALO)"
  },
  {
   value: ".NEW ZEALAND (NZ)",
   label: ".NEW ZEALAND (NZ)"
  },
  {
   value: "Albany (NZABY)",
   label: "Albany (NZABY)"
  },
  {
   value: "Avondale (NZAVD)",
   label: "Avondale (NZAVD)"
  },
  {
   value: "Awatoto (NZAWT)",
   label: "Awatoto (NZAWT)"
  },
  {
   value: "Balclutha (NZBAL)",
   label: "Balclutha (NZBAL)"
  },
  {
   value: "Belfast (NZBEL)",
   label: "Belfast (NZBEL)"
  },
  {
   value: "Bulls (NZBUL)",
   label: "Bulls (NZBUL)"
  },
  {
   value: "Carterton (NZCTN)",
   label: "Carterton (NZCTN)"
  },
  {
   value: "Clyde (NZCLY)",
   label: "Clyde (NZCLY)"
  },
  {
   value: "Coromandel (NZCMV)",
   label: "Coromandel (NZCMV)"
  },
  {
   value: "Cromwell (NZCRO)",
   label: "Cromwell (NZCRO)"
  },
  {
   value: "Dannevirke (NZDAN)",
   label: "Dannevirke (NZDAN)"
  },
  {
   value: "Dusky Sound (NZDUS)",
   label: "Dusky Sound (NZDUS)"
  },
  {
   value: "East Tamaki (NZETM)",
   label: "East Tamaki (NZETM)"
  },
  {
   value: "Edendale (NZERH)",
   label: "Edendale (NZERH)"
  },
  {
   value: "Edgecumbe (NZEDC)",
   label: "Edgecumbe (NZEDC)"
  },
  {
   value: "Eltham (NZELM)",
   label: "Eltham (NZELM)"
  },
  {
   value: "Feilding (NZFLD)",
   label: "Feilding (NZFLD)"
  },
  {
   value: "Fox Glacier (NZFGL)",
   label: "Fox Glacier (NZFGL)"
  },
  {
   value: "Frankton (NZFKT)",
   label: "Frankton (NZFKT)"
  },
  {
   value: "Franz Josef (NZWHO)",
   label: "Franz Josef (NZWHO)"
  },
  {
   value: "Gore (NZGOR)",
   label: "Gore (NZGOR)"
  },
  {
   value: "Greerton (NZGTO)",
   label: "Greerton (NZGTO)"
  },
  {
   value: "Hastings (NZHAS)",
   label: "Hastings (NZHAS)"
  },
  {
   value: "Hawera (NZHAW)",
   label: "Hawera (NZHAW)"
  },
  {
   value: "Henderson (NZHDS)",
   label: "Henderson (NZHDS)"
  },
  {
   value: "Huntly (NZHLY)",
   label: "Huntly (NZHLY)"
  },
  {
   value: "Inglewood (NZING)",
   label: "Inglewood (NZING)"
  },
  {
   value: "Kakariki (NZKAK)",
   label: "Kakariki (NZKAK)"
  },
  {
   value: "Katikati (NZKTK)",
   label: "Katikati (NZKTK)"
  },
  {
   value: "Kawau Island (NZKUI)",
   label: "Kawau Island (NZKUI)"
  },
  {
   value: "Kawerau (NZKAW)",
   label: "Kawerau (NZKAW)"
  },
  {
   value: "Kerikeri (NZKKE)",
   label: "Kerikeri (NZKKE)"
  },
  {
   value: "Kokiri (NZKOK)",
   label: "Kokiri (NZKOK)"
  },
  {
   value: "Kopu (NZKOP)",
   label: "Kopu (NZKOP)"
  },
  {
   value: "Longburn (NZLGB)",
   label: "Longburn (NZLGB)"
  },
  {
   value: "Maari Terminal (NZMAR)",
   label: "Maari Terminal (NZMAR)"
  },
  {
   value: "Makarewa (NZMKW)",
   label: "Makarewa (NZMKW)"
  },
  {
   value: "Manakau (NZMNK)",
   label: "Manakau (NZMNK)"
  },
  {
   value: "Mangere (NZMAE)",
   label: "Mangere (NZMAE)"
  },
  {
   value: "Mansion House (NZKWU)",
   label: "Mansion House (NZKWU)"
  },
  {
   value: "Manukau City (NZMCY)",
   label: "Manukau City (NZMCY)"
  },
  {
   value: "Martinborough (NZMRB)",
   label: "Martinborough (NZMRB)"
  },
  {
   value: "Marton (NZMRT)",
   label: "Marton (NZMRT)"
  },
  {
   value: "Masterton (NZMRO)",
   label: "Masterton (NZMRO)"
  },
  {
   value: "Matangi (NZMTG)",
   label: "Matangi (NZMTG)"
  },
  {
   value: "Metroport\/Auckland (NZMKL)",
   label: "Metroport\/Auckland (NZMKL)"
  },
  {
   value: "Middleton\/Christchurch (NZMNR)",
   label: "Middleton\/Christchurch (NZMNR)"
  },
  {
   value: "Milford Sound (NZMFN)",
   label: "Milford Sound (NZMFN)"
  },
  {
   value: "Milton (NZMTN)",
   label: "Milton (NZMTN)"
  },
  {
   value: "Morrinsville (NZMOR)",
   label: "Morrinsville (NZMOR)"
  },
  {
   value: "Mosgiel (NZMGL)",
   label: "Mosgiel (NZMGL)"
  },
  {
   value: "Mount Wellington (NZMWL)",
   label: "Mount Wellington (NZMWL)"
  },
  {
   value: "New Lyn (NZNLN)",
   label: "New Lyn (NZNLN)"
  },
  {
   value: "Ohakune (NZOHK)",
   label: "Ohakune (NZOHK)"
  },
  {
   value: "Okarito (NZOKA)",
   label: "Okarito (NZOKA)"
  },
  {
   value: "Otahuhu (NZOHU)",
   label: "Otahuhu (NZOHU)"
  },
  {
   value: "Otaki (NZOTA)",
   label: "Otaki (NZOTA)"
  },
  {
   value: "Otorohanga (NZORH)",
   label: "Otorohanga (NZORH)"
  },
  {
   value: "Paekakariki (NZPKI)",
   label: "Paekakariki (NZPKI)"
  },
  {
   value: "Paeroa (NZPAE)",
   label: "Paeroa (NZPAE)"
  },
  {
   value: "Paihia (NZPAI)",
   label: "Paihia (NZPAI)"
  },
  {
   value: "Pakatoa Island (NZPKL)",
   label: "Pakatoa Island (NZPKL)"
  },
  {
   value: "Paraparaumu (NZPPQ)",
   label: "Paraparaumu (NZPPQ)"
  },
  {
   value: "Pareora (NZPAR)",
   label: "Pareora (NZPAR)"
  },
  {
   value: "Pokeno (NZPOK)",
   label: "Pokeno (NZPOK)"
  },
  {
   value: "Porirua (NZPRR)",
   label: "Porirua (NZPRR)"
  },
  {
   value: "Porirua (NZPRU)",
   label: "Porirua (NZPRU)"
  },
  {
   value: "Port Fitzroy (NZGBS)",
   label: "Port Fitzroy (NZGBS)"
  },
  {
   value: "Pukeuri Junction (NZPKR)",
   label: "Pukeuri Junction (NZPKR)"
  },
  {
   value: "Putaruru (NZPTR)",
   label: "Putaruru (NZPTR)"
  },
  {
   value: "Rangiora (NZRGO)",
   label: "Rangiora (NZRGO)"
  },
  {
   value: "Ravensbourne (NZRAV)",
   label: "Ravensbourne (NZRAV)"
  },
  {
   value: "Renwick (NZRNW)",
   label: "Renwick (NZRNW)"
  },
  {
   value: "Richmond (NZRMD)",
   label: "Richmond (NZRMD)"
  },
  {
   value: "Riverton (NZRIV)",
   label: "Riverton (NZRIV)"
  },
  {
   value: "Roxburgh (NZRXB)",
   label: "Roxburgh (NZRXB)"
  },
  {
   value: "Russel (NZRUS)",
   label: "Russel (NZRUS)"
  },
  {
   value: "Seaview (NZSEA)",
   label: "Seaview (NZSEA)"
  },
  {
   value: "Shannon (NZSHN)",
   label: "Shannon (NZSHN)"
  },
  {
   value: "Silverdale (NZSDL)",
   label: "Silverdale (NZSDL)"
  },
  {
   value: "Smithfield (NZSMF)",
   label: "Smithfield (NZSMF)"
  },
  {
   value: "Sockburn (NZSBN)",
   label: "Sockburn (NZSBN)"
  },
  {
   value: "Spring Creek (NZYGC)",
   label: "Spring Creek (NZYGC)"
  },
  {
   value: "Stewart Island (NZSZS)",
   label: "Stewart Island (NZSZS)"
  },
  {
   value: "Stoke (NZSTK)",
   label: "Stoke (NZSTK)"
  },
  {
   value: "Stratford (NZSTR)",
   label: "Stratford (NZSTR)"
  },
  {
   value: "Surfdale (NZWIK)",
   label: "Surfdale (NZWIK)"
  },
  {
   value: "Taihape (NZTHP)",
   label: "Taihape (NZTHP)"
  },
  {
   value: "Taradale (NZTDA)",
   label: "Taradale (NZTDA)"
  },
  {
   value: "Taumarunui (NZTAU)",
   label: "Taumarunui (NZTAU)"
  },
  {
   value: "Te Aroha (NZTAR)",
   label: "Te Aroha (NZTAR)"
  },
  {
   value: "Te Awamutu (NZTAW)",
   label: "Te Awamutu (NZTAW)"
  },
  {
   value: "Te Kauwhata (NZTEK)",
   label: "Te Kauwhata (NZTEK)"
  },
  {
   value: "Te Kuiti (NZTKI)",
   label: "Te Kuiti (NZTKI)"
  },
  {
   value: "Te Puke (NZTPK)",
   label: "Te Puke (NZTPK)"
  },
  {
   value: "Te Puna (NZTPN)",
   label: "Te Puna (NZTPN)"
  },
  {
   value: "Tiwai Point\/Bluff Port (NZTWI)",
   label: "Tiwai Point\/Bluff Port (NZTWI)"
  },
  {
   value: "Tokoroa (NZTKZ)",
   label: "Tokoroa (NZTKZ)"
  },
  {
   value: "Tomoana (NZTOA)",
   label: "Tomoana (NZTOA)"
  },
  {
   value: "Trentham (NZTTH)",
   label: "Trentham (NZTTH)"
  },
  {
   value: "Waihi (NZWHI)",
   label: "Waihi (NZWHI)"
  },
  {
   value: "Waiouru (NZWAO)",
   label: "Waiouru (NZWAO)"
  },
  {
   value: "Waitara (NZWTA)",
   label: "Waitara (NZWTA)"
  },
  {
   value: "Waitotara (NZWAI)",
   label: "Waitotara (NZWAI)"
  },
  {
   value: "Waiuku (NZWUK)",
   label: "Waiuku (NZWUK)"
  },
  {
   value: "Wanaka (NZWKA)",
   label: "Wanaka (NZWKA)"
  },
  {
   value: "Washdyke (NZWDY)",
   label: "Washdyke (NZWDY)"
  },
  {
   value: "Wellsford (NZWLF)",
   label: "Wellsford (NZWLF)"
  },
  {
   value: "Weymouth (NZWYM)",
   label: "Weymouth (NZWYM)"
  },
  {
   value: "Whakatu (NZWHA)",
   label: "Whakatu (NZWHA)"
  },
  {
   value: "White I. (NZWHT)",
   label: "White I. (NZWHT)"
  },
  {
   value: "Whitianga (NZWTZ)",
   label: "Whitianga (NZWTZ)"
  },
  {
   value: "Winton (NZWNT)",
   label: "Winton (NZWNT)"
  },
  {
   value: "Wyndham (NZWYH)",
   label: "Wyndham (NZWYH)"
  },
  {
   value: ".OMAN (OM)",
   label: ".OMAN (OM)"
  },
  {
   value: "Buraimi (OMRMB)",
   label: "Buraimi (OMRMB)"
  },
  {
   value: "Dibaa (OMBYB)",
   label: "Dibaa (OMBYB)"
  },
  {
   value: "Khasab (OMKHS)",
   label: "Khasab (OMKHS)"
  },
  {
   value: "Marmul (OMOMM)",
   label: "Marmul (OMOMM)"
  },
  {
   value: "Mina Sultan Qaboos, Muscat (OMSTQ)",
   label: "Mina Sultan Qaboos, Muscat (OMSTQ)"
  },
  {
   value: "Port Sultan (OMSUL)",
   label: "Port Sultan (OMSUL)"
  },
  {
   value: "Qalhat (OMQAL)",
   label: "Qalhat (OMQAL)"
  },
  {
   value: "Rusail (OMRUS)",
   label: "Rusail (OMRUS)"
  },
  {
   value: "Seeb (OMSEE)",
   label: "Seeb (OMSEE)"
  },
  {
   value: "Sur (OMSUH)",
   label: "Sur (OMSUH)"
  },
  {
   value: ".PANAMA (PA)",
   label: ".PANAMA (PA)"
  },
  {
   value: "Agua Buena (PAABA)",
   label: "Agua Buena (PAABA)"
  },
  {
   value: "Agua Buena, Tonosi (PAABN)",
   label: "Agua Buena, Tonosi (PAABN)"
  },
  {
   value: "Ailigandi (PAAIL)",
   label: "Ailigandi (PAAIL)"
  },
  {
   value: "Alanje (PAALA)",
   label: "Alanje (PAALA)"
  },
  {
   value: "Ancon (PAACO)",
   label: "Ancon (PAACO)"
  },
  {
   value: "Atalaya (PAATA)",
   label: "Atalaya (PAATA)"
  },
  {
   value: "Bágala (PABAG)",
   label: "Bágala (PABAG)"
  },
  {
   value: "Bahía Piña (PABFQ)",
   label: "Bahía Piña (PABFQ)"
  },
  {
   value: "Bayano (PABAY)",
   label: "Bayano (PABAY)"
  },
  {
   value: "Bella Vista (PABEL)",
   label: "Bella Vista (PABEL)"
  },
  {
   value: "Bocas del Toro (PABOC)",
   label: "Bocas del Toro (PABOC)"
  },
  {
   value: "Boquerón (PABOQ)",
   label: "Boquerón (PABOQ)"
  },
  {
   value: "Boquete (PABQT)",
   label: "Boquete (PABQT)"
  },
  {
   value: "Bugaba (PAPZA)",
   label: "Bugaba (PAPZA)"
  },
  {
   value: "Caimito (PACAM)",
   label: "Caimito (PACAM)"
  },
  {
   value: "Calobre (PACLB)",
   label: "Calobre (PACLB)"
  },
  {
   value: "Cañazas (PACZZ)",
   label: "Cañazas (PACZZ)"
  },
  {
   value: "Capira (PACAP)",
   label: "Capira (PACAP)"
  },
  {
   value: "Cerro Punta (PACPA)",
   label: "Cerro Punta (PACPA)"
  },
  {
   value: "Chame (PACHM)",
   label: "Chame (PACHM)"
  },
  {
   value: "Chepo (PACHE)",
   label: "Chepo (PACHE)"
  },
  {
   value: "Chilibre (PACHB)",
   label: "Chilibre (PACHB)"
  },
  {
   value: "Chiriquí (PACHQ)",
   label: "Chiriquí (PACHQ)"
  },
  {
   value: "Ciruelito (PACRT)",
   label: "Ciruelito (PACRT)"
  },
  {
   value: "Contadora (PAOTD)",
   label: "Contadora (PAOTD)"
  },
  {
   value: "Corozal (PACZO)",
   label: "Corozal (PACZO)"
  },
  {
   value: "Cruce Canal de Panama (PACAN)",
   label: "Cruce Canal de Panama (PACAN)"
  },
  {
   value: "Divalá (PADIV)",
   label: "Divalá (PADIV)"
  },
  {
   value: "Divisa (PADVA)",
   label: "Divisa (PADVA)"
  },
  {
   value: "El Dorado (PADOR)",
   label: "El Dorado (PADOR)"
  },
  {
   value: "El Ejido (PAEJO)",
   label: "El Ejido (PAEJO)"
  },
  {
   value: "El Guayabal (PAEGL)",
   label: "El Guayabal (PAEGL)"
  },
  {
   value: "El Higo (PAELH)",
   label: "El Higo (PAELH)"
  },
  {
   value: "Finca Santa Mónica (PAFSM)",
   label: "Finca Santa Mónica (PAFSM)"
  },
  {
   value: "Flores (PAFLZ)",
   label: "Flores (PAFLZ)"
  },
  {
   value: "Fort Kobbe (PAHOW)",
   label: "Fort Kobbe (PAHOW)"
  },
  {
   value: "La Arena (PALRN)",
   label: "La Arena (PALRN)"
  },
  {
   value: "La Arenosa (PALAA)",
   label: "La Arenosa (PALAA)"
  },
  {
   value: "La Carrasquilla (PACAR)",
   label: "La Carrasquilla (PACAR)"
  },
  {
   value: "La Chorrera (PACRR)",
   label: "La Chorrera (PACRR)"
  },
  {
   value: "La Zanguenga (PALZA)",
   label: "La Zanguenga (PALZA)"
  },
  {
   value: "Las Lomas (PALAS)",
   label: "Las Lomas (PALAS)"
  },
  {
   value: "Las Tablas (PALTB)",
   label: "Las Tablas (PALTB)"
  },
  {
   value: "Los Santos (PAPZB)",
   label: "Los Santos (PAPZB)"
  },
  {
   value: "Ocú (PAOCU)",
   label: "Ocú (PAOCU)"
  },
  {
   value: "Pacora (PAPCO)",
   label: "Pacora (PAPCO)"
  },
  {
   value: "Parita (PAPAR)",
   label: "Parita (PAPAR)"
  },
  {
   value: "Pedasí (PAPDS)",
   label: "Pedasí (PAPDS)"
  },
  {
   value: "Playa Coronado (PACOR)",
   label: "Playa Coronado (PACOR)"
  },
  {
   value: "Potrerillos (PAPRS)",
   label: "Potrerillos (PAPRS)"
  },
  {
   value: "Progreso (PAPZC)",
   label: "Progreso (PAPZC)"
  },
  {
   value: "Puerto Caimito (PAPCA)",
   label: "Puerto Caimito (PAPCA)"
  },
  {
   value: "Puerto Mariato (PAMAZ)",
   label: "Puerto Mariato (PAMAZ)"
  },
  {
   value: "Río Grande (PAGDE)",
   label: "Río Grande (PAGDE)"
  },
  {
   value: "Río Grande (PAPGR)",
   label: "Río Grande (PAPGR)"
  },
  {
   value: "Río Hato (PARHA)",
   label: "Río Hato (PARHA)"
  },
  {
   value: "Río Viejo de los Valdés (PARIO)",
   label: "Río Viejo de los Valdés (PARIO)"
  },
  {
   value: "Sajalices (PASJL)",
   label: "Sajalices (PASJL)"
  },
  {
   value: "San Lorenzo (PANZO)",
   label: "San Lorenzo (PANZO)"
  },
  {
   value: "San Miguel (PANMG)",
   label: "San Miguel (PANMG)"
  },
  {
   value: "Santa Clara (PASCL)",
   label: "Santa Clara (PASCL)"
  },
  {
   value: "Santiago (PASYP)",
   label: "Santiago (PASYP)"
  },
  {
   value: "Taboguilla (PATBG)",
   label: "Taboguilla (PATBG)"
  },
  {
   value: "Ticantiquí (PATJC)",
   label: "Ticantiquí (PATJC)"
  },
  {
   value: "Tonosí (PATNS)",
   label: "Tonosí (PATNS)"
  },
  {
   value: "Tonosí (PATON)",
   label: "Tonosí (PATON)"
  },
  {
   value: "Torti (PATOR)",
   label: "Torti (PATOR)"
  },
  {
   value: "Veracruz (PAVCZ)",
   label: "Veracruz (PAVCZ)"
  },
  {
   value: "Zanguenga (PAZAN)",
   label: "Zanguenga (PAZAN)"
  },
  {
   value: ".PERU (PE)",
   label: ".PERU (PE)"
  },
  {
   value: "Alerta (PEALD)",
   label: "Alerta (PEALD)"
  },
  {
   value: "Arica (PEARI)",
   label: "Arica (PEARI)"
  },
  {
   value: "Bellavista (PEBLP)",
   label: "Bellavista (PEBLP)"
  },
  {
   value: "Casma (PECAS)",
   label: "Casma (PECAS)"
  },
  {
   value: "Cerro Azul (PECRZ)",
   label: "Cerro Azul (PECRZ)"
  },
  {
   value: "Chachapoyas (PECHH)",
   label: "Chachapoyas (PECHH)"
  },
  {
   value: "Chancán (PECHN)",
   label: "Chancán (PECHN)"
  },
  {
   value: "Chincha (PECHI)",
   label: "Chincha (PECHI)"
  },
  {
   value: "Conchán (PECON)",
   label: "Conchán (PECON)"
  },
  {
   value: "Cuzco (PECUZ)",
   label: "Cuzco (PECUZ)"
  },
  {
   value: "Huancavelica (PEHUN)",
   label: "Huancavelica (PEHUN)"
  },
  {
   value: "Huaral (PEHUA)",
   label: "Huaral (PEHUA)"
  },
  {
   value: "Huaraz (PEHUZ)",
   label: "Huaraz (PEHUZ)"
  },
  {
   value: "Iberia (PEIBP)",
   label: "Iberia (PEIBP)"
  },
  {
   value: "Ica (PEICA)",
   label: "Ica (PEICA)"
  },
  {
   value: "Jaén (PEJAE)",
   label: "Jaén (PEJAE)"
  },
  {
   value: "Jauja (PEJAU)",
   label: "Jauja (PEJAU)"
  },
  {
   value: "Juliaca (PEJUL)",
   label: "Juliaca (PEJUL)"
  },
  {
   value: "Machu Picchu (PEMFT)",
   label: "Machu Picchu (PEMFT)"
  },
  {
   value: "Mala (PEMAL)",
   label: "Mala (PEMAL)"
  },
  {
   value: "Moquegua (PEMOQ)",
   label: "Moquegua (PEMOQ)"
  },
  {
   value: "Moyobamba (PEMBP)",
   label: "Moyobamba (PEMBP)"
  },
  {
   value: "Oquendo (PEOQU)",
   label: "Oquendo (PEOQU)"
  },
  {
   value: "Punta Lobitos (PEPLO)",
   label: "Punta Lobitos (PEPLO)"
  },
  {
   value: "Quince Mil (PEUMI)",
   label: "Quince Mil (PEUMI)"
  },
  {
   value: "Quinches (PEQUI)",
   label: "Quinches (PEQUI)"
  },
  {
   value: "Rodríguez de Mendoza (PERIM)",
   label: "Rodríguez de Mendoza (PERIM)"
  },
  {
   value: "San Bartolo (PEBAR)",
   label: "San Bartolo (PEBAR)"
  },
  {
   value: "San Borja\/Lima (PELSB)",
   label: "San Borja\/Lima (PELSB)"
  },
  {
   value: "San Juan Aposento (PEAPE)",
   label: "San Juan Aposento (PEAPE)"
  },
  {
   value: "Santa Maria (PESMG)",
   label: "Santa Maria (PESMG)"
  },
  {
   value: "Saposoa (PESQU)",
   label: "Saposoa (PESQU)"
  },
  {
   value: "Shiringayoc (PESYC)",
   label: "Shiringayoc (PESYC)"
  },
  {
   value: "Sullana (PESUL)",
   label: "Sullana (PESUL)"
  },
  {
   value: "Tambo Grande (PETAG)",
   label: "Tambo Grande (PETAG)"
  },
  {
   value: ".FRENCH POLYNESIA (PF)",
   label: ".FRENCH POLYNESIA (PF)"
  },
  {
   value: "Ahe (PFAHE)",
   label: "Ahe (PFAHE)"
  },
  {
   value: "Arutua (PFAXR)",
   label: "Arutua (PFAXR)"
  },
  {
   value: "Atoll Hereheretue (PFHHT)",
   label: "Atoll Hereheretue (PFHHT)"
  },
  {
   value: "Atoll Pukapuka (PFPKP)",
   label: "Atoll Pukapuka (PFPKP)"
  },
  {
   value: "Auti (PFAUT)",
   label: "Auti (PFAUT)"
  },
  {
   value: "Faaite (PFFAC)",
   label: "Faaite (PFFAC)"
  },
  {
   value: "Fakahina (PFFHZ)",
   label: "Fakahina (PFFHZ)"
  },
  {
   value: "Fangatau (PFFGU)",
   label: "Fangatau (PFFGU)"
  },
  {
   value: "Fatu Hiva (PFFAT)",
   label: "Fatu Hiva (PFFAT)"
  },
  {
   value: "Hatiheu (PFHEU)",
   label: "Hatiheu (PFHEU)"
  },
  {
   value: "Hikueru (PFHHZ)",
   label: "Hikueru (PFHHZ)"
  },
  {
   value: "Hiva Oa (PFHIX)",
   label: "Hiva Oa (PFHIX)"
  },
  {
   value: "Ikitake (PFIKI)",
   label: "Ikitake (PFIKI)"
  },
  {
   value: "Maroe (PFMEE)",
   label: "Maroe (PFMEE)"
  },
  {
   value: "Moerai (PFMOE)",
   label: "Moerai (PFMOE)"
  },
  {
   value: "Napuka Island (PFNAU)",
   label: "Napuka Island (PFNAU)"
  },
  {
   value: "Nukutavake (PFNUK)",
   label: "Nukutavake (PFNUK)"
  },
  {
   value: "Otepa (PFOTP)",
   label: "Otepa (PFOTP)"
  },
  {
   value: "Pukarua (PFPUK)",
   label: "Pukarua (PFPUK)"
  },
  {
   value: "Raivavae (PFRVV)",
   label: "Raivavae (PFRVV)"
  },
  {
   value: "Reao (PFREA)",
   label: "Reao (PFREA)"
  },
  {
   value: "Takaroa (PFTKX)",
   label: "Takaroa (PFTKX)"
  },
  {
   value: "Takume (PFTJN)",
   label: "Takume (PFTJN)"
  },
  {
   value: "Tatakoto (PFTKV)",
   label: "Tatakoto (PFTKV)"
  },
  {
   value: "Tetiaroa Is (PFTTI)",
   label: "Tetiaroa Is (PFTTI)"
  },
  {
   value: "Tupana (PFTUP)",
   label: "Tupana (PFTUP)"
  },
  {
   value: "Tureia (PFZTA)",
   label: "Tureia (PFZTA)"
  },
  {
   value: "Vahitahi (PFVHZ)",
   label: "Vahitahi (PFVHZ)"
  },
  {
   value: ".PAPUA NEW GUINEA (PG)",
   label: ".PAPUA NEW GUINEA (PG)"
  },
  {
   value: "Afore (PGAFR)",
   label: "Afore (PGAFR)"
  },
  {
   value: "Agaun (PGAUP)",
   label: "Agaun (PGAUP)"
  },
  {
   value: "Aiambak (PGAIA)",
   label: "Aiambak (PGAIA)"
  },
  {
   value: "Alcester I. (PGALC)",
   label: "Alcester I. (PGALC)"
  },
  {
   value: "Amboin (PGAMG)",
   label: "Amboin (PGAMG)"
  },
  {
   value: "Amio (PGAMI)",
   label: "Amio (PGAMI)"
  },
  {
   value: "Anguganak (PGAKG)",
   label: "Anguganak (PGAKG)"
  },
  {
   value: "Annanberg (PGAOB)",
   label: "Annanberg (PGAOB)"
  },
  {
   value: "April River (PGAPR)",
   label: "April River (PGAPR)"
  },
  {
   value: "Arawa (PGRAW)",
   label: "Arawa (PGRAW)"
  },
  {
   value: "Aroa (PGAOA)",
   label: "Aroa (PGAOA)"
  },
  {
   value: "Arona (PGAON)",
   label: "Arona (PGAON)"
  },
  {
   value: "Asapa (PGAPP)",
   label: "Asapa (PGAPP)"
  },
  {
   value: "Asirim (PGASZ)",
   label: "Asirim (PGASZ)"
  },
  {
   value: "Atkamba (PGABP)",
   label: "Atkamba (PGABP)"
  },
  {
   value: "Aua Island (PGAUI)",
   label: "Aua Island (PGAUI)"
  },
  {
   value: "Aumo (PGAUV)",
   label: "Aumo (PGAUV)"
  },
  {
   value: "Awaba (PGAWB)",
   label: "Awaba (PGAWB)"
  },
  {
   value: "Awar (PGAWR)",
   label: "Awar (PGAWR)"
  },
  {
   value: "Baindoung (PGBDZ)",
   label: "Baindoung (PGBDZ)"
  },
  {
   value: "Bambu (PGBCP)",
   label: "Bambu (PGBCP)"
  },
  {
   value: "Bapi (PGBPD)",
   label: "Bapi (PGBPD)"
  },
  {
   value: "Bawan (PGBWJ)",
   label: "Bawan (PGBWJ)"
  },
  {
   value: "Bensbach (PGBSP)",
   label: "Bensbach (PGBSP)"
  },
  {
   value: "Biaru (PGBRP)",
   label: "Biaru (PGBRP)"
  },
  {
   value: "Biliau (PGBIJ)",
   label: "Biliau (PGBIJ)"
  },
  {
   value: "Bimin (PGBIZ)",
   label: "Bimin (PGBIZ)"
  },
  {
   value: "Boana (PGBNV)",
   label: "Boana (PGBNV)"
  },
  {
   value: "Boigu I. (PGBOI)",
   label: "Boigu I. (PGBOI)"
  },
  {
   value: "Boku (PGBOQ)",
   label: "Boku (PGBOQ)"
  },
  {
   value: "Bolovip (PGBVP)",
   label: "Bolovip (PGBVP)"
  },
  {
   value: "Bomai (PGBMH)",
   label: "Bomai (PGBMH)"
  },
  {
   value: "Boridi (PGBPB)",
   label: "Boridi (PGBPB)"
  },
  {
   value: "Boset (PGBOT)",
   label: "Boset (PGBOT)"
  },
  {
   value: "Brahman (PGBRH)",
   label: "Brahman (PGBRH)"
  },
  {
   value: "Bunsil (PGBXZ)",
   label: "Bunsil (PGBXZ)"
  },
  {
   value: "Cape Orford (PGCPI)",
   label: "Cape Orford (PGCPI)"
  },
  {
   value: "Chungribu (PGCVB)",
   label: "Chungribu (PGCVB)"
  },
  {
   value: "Conflict Group (PGCFG)",
   label: "Conflict Group (PGCFG)"
  },
  {
   value: "Dalbertis (PGDLB)",
   label: "Dalbertis (PGDLB)"
  },
  {
   value: "Daugo (PGDGG)",
   label: "Daugo (PGDGG)"
  },
  {
   value: "Daup (PGDAF)",
   label: "Daup (PGDAF)"
  },
  {
   value: "Debepare (PGDBP)",
   label: "Debepare (PGDBP)"
  },
  {
   value: "Deboyne Lagoon (PGDBL)",
   label: "Deboyne Lagoon (PGDBL)"
  },
  {
   value: "Derim (PGDER)",
   label: "Derim (PGDER)"
  },
  {
   value: "Dinangat (PGDNU)",
   label: "Dinangat (PGDNU)"
  },
  {
   value: "Dios (PGDOS)",
   label: "Dios (PGDOS)"
  },
  {
   value: "Dodoima (PGDDM)",
   label: "Dodoima (PGDDM)"
  },
  {
   value: "Doini (PGDOI)",
   label: "Doini (PGDOI)"
  },
  {
   value: "Dumpu (PGDPU)",
   label: "Dumpu (PGDPU)"
  },
  {
   value: "Eia (PGEIA)",
   label: "Eia (PGEIA)"
  },
  {
   value: "Eliptamin (PGEPT)",
   label: "Eliptamin (PGEPT)"
  },
  {
   value: "Emo (PGEMO)",
   label: "Emo (PGEMO)"
  },
  {
   value: "Engati (PGEGA)",
   label: "Engati (PGEGA)"
  },
  {
   value: "Erume (PGERU)",
   label: "Erume (PGERU)"
  },
  {
   value: "Feramin (PGFRQ)",
   label: "Feramin (PGFRQ)"
  },
  {
   value: "Freida River (PGFAQ)",
   label: "Freida River (PGFAQ)"
  },
  {
   value: "Fuma (PGFUM)",
   label: "Fuma (PGFUM)"
  },
  {
   value: "Garasa (PGGRL)",
   label: "Garasa (PGGRL)"
  },
  {
   value: "Gasuke (PGGBC)",
   label: "Gasuke (PGGBC)"
  },
  {
   value: "Gawa I. (PGGAW)",
   label: "Gawa I. (PGGAW)"
  },
  {
   value: "Gewoia (PGGEW)",
   label: "Gewoia (PGGEW)"
  },
  {
   value: "Gnarowein (PGGWN)",
   label: "Gnarowein (PGGWN)"
  },
  {
   value: "Gonalia (PGGOE)",
   label: "Gonalia (PGGOE)"
  },
  {
   value: "Gora (PGGOC)",
   label: "Gora (PGGOC)"
  },
  {
   value: "Green River (PGGVI)",
   label: "Green River (PGGVI)"
  },
  {
   value: "Guasopa (PGGAZ)",
   label: "Guasopa (PGGAZ)"
  },
  {
   value: "Gulgubip (PGGLP)",
   label: "Gulgubip (PGGLP)"
  },
  {
   value: "Guriaso (PGGUE)",
   label: "Guriaso (PGGUE)"
  },
  {
   value: "Haelogo (PGHEO)",
   label: "Haelogo (PGHEO)"
  },
  {
   value: "Hatzfeldthaven (PGHAZ)",
   label: "Hatzfeldthaven (PGHAZ)"
  },
  {
   value: "Hawabango (PGHWA)",
   label: "Hawabango (PGHWA)"
  },
  {
   value: "Heiweni (PGHNI)",
   label: "Heiweni (PGHNI)"
  },
  {
   value: "Hivaro (PGHIT)",
   label: "Hivaro (PGHIT)"
  },
  {
   value: "Honinabi (PGHNN)",
   label: "Honinabi (PGHNN)"
  },
  {
   value: "Iaura (PGIAU)",
   label: "Iaura (PGIAU)"
  },
  {
   value: "Iboki (PGIBI)",
   label: "Iboki (PGIBI)"
  },
  {
   value: "Ileg (PGILX)",
   label: "Ileg (PGILX)"
  },
  {
   value: "Imane (PGIMN)",
   label: "Imane (PGIMN)"
  },
  {
   value: "Indagen (PGIDN)",
   label: "Indagen (PGIDN)"
  },
  {
   value: "Kabwum (PGKBM)",
   label: "Kabwum (PGKBM)"
  },
  {
   value: "Kagua (PGAGK)",
   label: "Kagua (PGAGK)"
  },
  {
   value: "Kaiapit (PGKIA)",
   label: "Kaiapit (PGKIA)"
  },
  {
   value: "Kaibola (PGKAI)",
   label: "Kaibola (PGKAI)"
  },
  {
   value: "Kamberatoro (PGKDQ)",
   label: "Kamberatoro (PGKDQ)"
  },
  {
   value: "Kamina (PGKMF)",
   label: "Kamina (PGKMF)"
  },
  {
   value: "Kamulai (PGKAQ)",
   label: "Kamulai (PGKAQ)"
  },
  {
   value: "Kamusi (PGKUY)",
   label: "Kamusi (PGKUY)"
  },
  {
   value: "Kanainj (PGKNE)",
   label: "Kanainj (PGKNE)"
  },
  {
   value: "Kanua (PGKTK)",
   label: "Kanua (PGKTK)"
  },
  {
   value: "Kar (PGKAK)",
   label: "Kar (PGKAK)"
  },
  {
   value: "Karato (PGKAF)",
   label: "Karato (PGKAF)"
  },
  {
   value: "Karawari (PGKRJ)",
   label: "Karawari (PGKRJ)"
  },
  {
   value: "Karoola (PGKXR)",
   label: "Karoola (PGKXR)"
  },
  {
   value: "Kasanombe (PGKSB)",
   label: "Kasanombe (PGKSB)"
  },
  {
   value: "Kawito (PGKWO)",
   label: "Kawito (PGKWO)"
  },
  {
   value: "Keglsugl (PGKEG)",
   label: "Keglsugl (PGKEG)"
  },
  {
   value: "Kelanoa (PGKNL)",
   label: "Kelanoa (PGKNL)"
  },
  {
   value: "Kerau (PGKRU)",
   label: "Kerau (PGKRU)"
  },
  {
   value: "Kikinonda (PGKIZ)",
   label: "Kikinonda (PGKIZ)"
  },
  {
   value: "Kira (PGKIQ)",
   label: "Kira (PGKIQ)"
  },
  {
   value: "Kisengan (PGKSG)",
   label: "Kisengan (PGKSG)"
  },
  {
   value: "Kitava (PGKVE)",
   label: "Kitava (PGKVE)"
  },
  {
   value: "Kiwai Island (PGKWX)",
   label: "Kiwai Island (PGKWX)"
  },
  {
   value: "Koinambe (PGKMB)",
   label: "Koinambe (PGKMB)"
  },
  {
   value: "Komaio (PGKCJ)",
   label: "Komaio (PGKCJ)"
  },
  {
   value: "Komako (PGHOC)",
   label: "Komako (PGHOC)"
  },
  {
   value: "Kompiam (PGKPM)",
   label: "Kompiam (PGKPM)"
  },
  {
   value: "Konge (PGKGB)",
   label: "Konge (PGKGB)"
  },
  {
   value: "Kopi (PGKOP)",
   label: "Kopi (PGKOP)"
  },
  {
   value: "Kosipe (PGKSP)",
   label: "Kosipe (PGKSP)"
  },
  {
   value: "Kumul (PGKUL)",
   label: "Kumul (PGKUL)"
  },
  {
   value: "Kungum (PGKGM)",
   label: "Kungum (PGKGM)"
  },
  {
   value: "Kuri (PGKUQ)",
   label: "Kuri (PGKUQ)"
  },
  {
   value: "Kurwina (PGKWV)",
   label: "Kurwina (PGKWV)"
  },
  {
   value: "Laiagam (PGLGM)",
   label: "Laiagam (PGLGM)"
  },
  {
   value: "Lake Murray (PGLMY)",
   label: "Lake Murray (PGLMY)"
  },
  {
   value: "Lakuramau (PGLAK)",
   label: "Lakuramau (PGLAK)"
  },
  {
   value: "Lamassa (PGLMG)",
   label: "Lamassa (PGLMG)"
  },
  {
   value: "Lambom I. (PGLAM)",
   label: "Lambom I. (PGLAM)"
  },
  {
   value: "Laughlan Atoll (PGLLA)",
   label: "Laughlan Atoll (PGLLA)"
  },
  {
   value: "Lehu (PGLHP)",
   label: "Lehu (PGLHP)"
  },
  {
   value: "Leitre (PGLTF)",
   label: "Leitre (PGLTF)"
  },
  {
   value: "Lengbati (PGLNC)",
   label: "Lengbati (PGLNC)"
  },
  {
   value: "Leron Plains (PGLPN)",
   label: "Leron Plains (PGLPN)"
  },
  {
   value: "Linga Linga (PGLGN)",
   label: "Linga Linga (PGLGN)"
  },
  {
   value: "Loani (PGLNQ)",
   label: "Loani (PGLNQ)"
  },
  {
   value: "Lombrum (PGLOM)",
   label: "Lombrum (PGLOM)"
  },
  {
   value: "Londolovit (PGLDT)",
   label: "Londolovit (PGLDT)"
  },
  {
   value: "Long Island (PGLSJ)",
   label: "Long Island (PGLSJ)"
  },
  {
   value: "Lowai (PGLWI)",
   label: "Lowai (PGLWI)"
  },
  {
   value: "Makini (PGMPG)",
   label: "Makini (PGMPG)"
  },
  {
   value: "Mal (PGMMV)",
   label: "Mal (PGMMV)"
  },
  {
   value: "Manda (PGMAN)",
   label: "Manda (PGMAN)"
  },
  {
   value: "Manetai (PGMVI)",
   label: "Manetai (PGMVI)"
  },
  {
   value: "Manguna (PGMFO)",
   label: "Manguna (PGMFO)"
  },
  {
   value: "Mapoda (PGMPF)",
   label: "Mapoda (PGMPF)"
  },
  {
   value: "Maramuni (PGMWI)",
   label: "Maramuni (PGMWI)"
  },
  {
   value: "Marawaka (PGMWG)",
   label: "Marawaka (PGMWG)"
  },
  {
   value: "Maron (PGMNP)",
   label: "Maron (PGMNP)"
  },
  {
   value: "Masa (PGMBV)",
   label: "Masa (PGMBV)"
  },
  {
   value: "May River (PGMRH)",
   label: "May River (PGMRH)"
  },
  {
   value: "Mesalia (PGMFZ)",
   label: "Mesalia (PGMFZ)"
  },
  {
   value: "Mindik (PGMXK)",
   label: "Mindik (PGMXK)"
  },
  {
   value: "Minj (PGMZN)",
   label: "Minj (PGMZN)"
  },
  {
   value: "Miyanmin (PGMPX)",
   label: "Miyanmin (PGMPX)"
  },
  {
   value: "Moki (PGMJJ)",
   label: "Moki (PGMJJ)"
  },
  {
   value: "Moro (PGMXH)",
   label: "Moro (PGMXH)"
  },
  {
   value: "Morobe (PGOBM)",
   label: "Morobe (PGOBM)"
  },
  {
   value: "Mougulu (PGGUV)",
   label: "Mougulu (PGGUV)"
  },
  {
   value: "Mount Aue (PGUAE)",
   label: "Mount Aue (PGUAE)"
  },
  {
   value: "Munbil (PGLNF)",
   label: "Munbil (PGLNF)"
  },
  {
   value: "Nadunumu (PGNDN)",
   label: "Nadunumu (PGNDN)"
  },
  {
   value: "Nambaiyufa (PGNBA)",
   label: "Nambaiyufa (PGNBA)"
  },
  {
   value: "Nankina (PGNKN)",
   label: "Nankina (PGNKN)"
  },
  {
   value: "Naoro (PGNOO)",
   label: "Naoro (PGNOO)"
  },
  {
   value: "Napa Napa (PGNAP)",
   label: "Napa Napa (PGNAP)"
  },
  {
   value: "Negarbo (PGGBF)",
   label: "Negarbo (PGGBF)"
  },
  {
   value: "Ningerum (PGNGR)",
   label: "Ningerum (PGNGR)"
  },
  {
   value: "Nipa (PGNPG)",
   label: "Nipa (PGNPG)"
  },
  {
   value: "Nomad River (PGNOM)",
   label: "Nomad River (PGNOM)"
  },
  {
   value: "Nomane (PGNMN)",
   label: "Nomane (PGNMN)"
  },
  {
   value: "Nuguria (PGNUG)",
   label: "Nuguria (PGNUG)"
  },
  {
   value: "Nutuve (PGNUT)",
   label: "Nutuve (PGNUT)"
  },
  {
   value: "Obo (PGOBX)",
   label: "Obo (PGOBX)"
  },
  {
   value: "Ogeranang (PGOGE)",
   label: "Ogeranang (PGOGE)"
  },
  {
   value: "Oksapmin (PGOKP)",
   label: "Oksapmin (PGOKP)"
  },
  {
   value: "Olsobip (PGOLQ)",
   label: "Olsobip (PGOLQ)"
  },
  {
   value: "Omkalai (PGOML)",
   label: "Omkalai (PGOML)"
  },
  {
   value: "Omora (PGOSE)",
   label: "Omora (PGOSE)"
  },
  {
   value: "Ononge (PGONB)",
   label: "Ononge (PGONB)"
  },
  {
   value: "Oram (PGRAX)",
   label: "Oram (PGRAX)"
  },
  {
   value: "Oria (PGOTY)",
   label: "Oria (PGOTY)"
  },
  {
   value: "Ossima (PGOSG)",
   label: "Ossima (PGOSG)"
  },
  {
   value: "Paiela (PGPLE)",
   label: "Paiela (PGPLE)"
  },
  {
   value: "Pangia (PGPGN)",
   label: "Pangia (PGPGN)"
  },
  {
   value: "Pangoa (PGPGB)",
   label: "Pangoa (PGPGB)"
  },
  {
   value: "Param (PGPPX)",
   label: "Param (PGPPX)"
  },
  {
   value: "Pindiu (PGPDI)",
   label: "Pindiu (PGPDI)"
  },
  {
   value: "Pondo Harbour (PGPDO)",
   label: "Pondo Harbour (PGPDO)"
  },
  {
   value: "Pureni (PGPUI)",
   label: "Pureni (PGPUI)"
  },
  {
   value: "Rumginae (PGRMN)",
   label: "Rumginae (PGRMN)"
  },
  {
   value: "Ruti (PGRUU)",
   label: "Ruti (PGRUU)"
  },
  {
   value: "Saibai (PGSAI)",
   label: "Saibai (PGSAI)"
  },
  {
   value: "Sangapi (PGSGK)",
   label: "Sangapi (PGSGK)"
  },
  {
   value: "Sapmanga (PGSMH)",
   label: "Sapmanga (PGSMH)"
  },
  {
   value: "Satwag (PGSWG)",
   label: "Satwag (PGSWG)"
  },
  {
   value: "Sauren (PGSXW)",
   label: "Sauren (PGSXW)"
  },
  {
   value: "Selbang (PGSBC)",
   label: "Selbang (PGSBC)"
  },
  {
   value: "Sepik Plains (PGSPV)",
   label: "Sepik Plains (PGSPV)"
  },
  {
   value: "Sialum (PGSXA)",
   label: "Sialum (PGSXA)"
  },
  {
   value: "Silur (PGSWR)",
   label: "Silur (PGSWR)"
  },
  {
   value: "Sim (PGSMJ)",
   label: "Sim (PGSMJ)"
  },
  {
   value: "Simberi Island (PGNIS)",
   label: "Simberi Island (PGNIS)"
  },
  {
   value: "Singaua (PGSGB)",
   label: "Singaua (PGSGB)"
  },
  {
   value: "Sissano (PGSIZ)",
   label: "Sissano (PGSIZ)"
  },
  {
   value: "Siwea (PGSWE)",
   label: "Siwea (PGSWE)"
  },
  {
   value: "Sopu (PGSPH)",
   label: "Sopu (PGSPH)"
  },
  {
   value: "Suabi (PGSBE)",
   label: "Suabi (PGSBE)"
  },
  {
   value: "Suki (PGSKC)",
   label: "Suki (PGSKC)"
  },
  {
   value: "Sule (PGULE)",
   label: "Sule (PGULE)"
  },
  {
   value: "Suria (PGSUZ)",
   label: "Suria (PGSUZ)"
  },
  {
   value: "Tambanum (PGTAM)",
   label: "Tambanum (PGTAM)"
  },
  {
   value: "Tami I.s (PGTMI)",
   label: "Tami I.s (PGTMI)"
  },
  {
   value: "Tarabo (PGTBQ)",
   label: "Tarabo (PGTBQ)"
  },
  {
   value: "Tarakbits (PGTRJ)",
   label: "Tarakbits (PGTRJ)"
  },
  {
   value: "Tauta (PGTUT)",
   label: "Tauta (PGTUT)"
  },
  {
   value: "Tawa (PGTWY)",
   label: "Tawa (PGTWY)"
  },
  {
   value: "Tekadu (PGTKB)",
   label: "Tekadu (PGTKB)"
  },
  {
   value: "Tekin (PGTKW)",
   label: "Tekin (PGTKW)"
  },
  {
   value: "Tilfalmin (PGTFA)",
   label: "Tilfalmin (PGTFA)"
  },
  {
   value: "Timbunke (PGTBE)",
   label: "Timbunke (PGTBE)"
  },
  {
   value: "Tinboli (PGTCK)",
   label: "Tinboli (PGTCK)"
  },
  {
   value: "Tonu (PGTON)",
   label: "Tonu (PGTON)"
  },
  {
   value: "Torembi (PGTCJ)",
   label: "Torembi (PGTCJ)"
  },
  {
   value: "Tsewi (PGTSW)",
   label: "Tsewi (PGTSW)"
  },
  {
   value: "Tsili Tsili (PGTSI)",
   label: "Tsili Tsili (PGTSI)"
  },
  {
   value: "Tumolbil (PGTLP)",
   label: "Tumolbil (PGTLP)"
  },
  {
   value: "Ulamona (PGULA)",
   label: "Ulamona (PGULA)"
  },
  {
   value: "Umba (PGUMC)",
   label: "Umba (PGUMC)"
  },
  {
   value: "Upiara (PGUPR)",
   label: "Upiara (PGUPR)"
  },
  {
   value: "Uroubi (PGURU)",
   label: "Uroubi (PGURU)"
  },
  {
   value: "Usino (PGUSO)",
   label: "Usino (PGUSO)"
  },
  {
   value: "Vailala (PGVLA)",
   label: "Vailala (PGVLA)"
  },
  {
   value: "Vivigani (PGVIV)",
   label: "Vivigani (PGVIV)"
  },
  {
   value: "Wabag (PGWAB)",
   label: "Wabag (PGWAB)"
  },
  {
   value: "Wagau (PGWGU)",
   label: "Wagau (PGWGU)"
  },
  {
   value: "Wantoat (PGWTT)",
   label: "Wantoat (PGWTT)"
  },
  {
   value: "Wanuma (PGWNU)",
   label: "Wanuma (PGWNU)"
  },
  {
   value: "Wapolu (PGWBC)",
   label: "Wapolu (PGWBC)"
  },
  {
   value: "Wasu (PGWSU)",
   label: "Wasu (PGWSU)"
  },
  {
   value: "Wasua (PGWSA)",
   label: "Wasua (PGWSA)"
  },
  {
   value: "Wasum (PGWUM)",
   label: "Wasum (PGWUM)"
  },
  {
   value: "Watabung (PGWAT)",
   label: "Watabung (PGWAT)"
  },
  {
   value: "Wawoi Falls (PGWAJ)",
   label: "Wawoi Falls (PGWAJ)"
  },
  {
   value: "Wipim (PGWPM)",
   label: "Wipim (PGWPM)"
  },
  {
   value: "Wonenara (PGWOA)",
   label: "Wonenara (PGWOA)"
  },
  {
   value: "Yalumet (PGKYX)",
   label: "Yalumet (PGKYX)"
  },
  {
   value: "Yapsiei (PGKPE)",
   label: "Yapsiei (PGKPE)"
  },
  {
   value: "Yasuru (PGKSX)",
   label: "Yasuru (PGKSX)"
  },
  {
   value: "Yegepa (PGPGE)",
   label: "Yegepa (PGPGE)"
  },
  {
   value: "Yellow River (PGXYR)",
   label: "Yellow River (PGXYR)"
  },
  {
   value: "Yenkis (PGYEQ)",
   label: "Yenkis (PGYEQ)"
  },
  {
   value: "Yentchan (PGYEN)",
   label: "Yentchan (PGYEN)"
  },
  {
   value: "Yeva (PGYVD)",
   label: "Yeva (PGYVD)"
  },
  {
   value: "Yongai (PGKGH)",
   label: "Yongai (PGKGH)"
  },
  {
   value: "Zenag (PGZEN)",
   label: "Zenag (PGZEN)"
  },
  {
   value: ".PHILIPPINES (PH)",
   label: ".PHILIPPINES (PH)"
  },
  {
   value: "Ajuy (PHAJU)",
   label: "Ajuy (PHAJU)"
  },
  {
   value: "Alah (PHAAV)",
   label: "Alah (PHAAV)"
  },
  {
   value: "Albuera (PHALB)",
   label: "Albuera (PHALB)"
  },
  {
   value: "Antipolo (PHANT)",
   label: "Antipolo (PHANT)"
  },
  {
   value: "Astorga (PHAST)",
   label: "Astorga (PHAST)"
  },
  {
   value: "Bacong (PHBAC)",
   label: "Bacong (PHBAC)"
  },
  {
   value: "Batonbaton (PHBAT)",
   label: "Batonbaton (PHBAT)"
  },
  {
   value: "Bauang (PHBNG)",
   label: "Bauang (PHBNG)"
  },
  {
   value: "Biñan (PHBIN)",
   label: "Biñan (PHBIN)"
  },
  {
   value: "Boracay (PHBOR)",
   label: "Boracay (PHBOR)"
  },
  {
   value: "Busan Bay (PHPPB)",
   label: "Busan Bay (PHPPB)"
  },
  {
   value: "Busuanga (PHUSU)",
   label: "Busuanga (PHUSU)"
  },
  {
   value: "Cagayan De Sulu (PHCDY)",
   label: "Cagayan De Sulu (PHCDY)"
  },
  {
   value: "Cagdianao (PHCDN)",
   label: "Cagdianao (PHCDN)"
  },
  {
   value: "Canlubang (PHCLB)",
   label: "Canlubang (PHCLB)"
  },
  {
   value: "Carigara (PHCRA)",
   label: "Carigara (PHCRA)"
  },
  {
   value: "Catarman (PHCRM)",
   label: "Catarman (PHCRM)"
  },
  {
   value: "Caticlan (PHMPH)",
   label: "Caticlan (PHMPH)"
  },
  {
   value: "Clark Field (Angeles) (PHKLR)",
   label: "Clark Field (Angeles) (PHKLR)"
  },
  {
   value: "Coron (PHXCN)",
   label: "Coron (PHXCN)"
  },
  {
   value: "Corregidor I. (PHCGI)",
   label: "Corregidor I. (PHCGI)"
  },
  {
   value: "Culasi (PHCSI)",
   label: "Culasi (PHCSI)"
  },
  {
   value: "Cuyo (PHCYU)",
   label: "Cuyo (PHCYU)"
  },
  {
   value: "Daet (PHDTE)",
   label: "Daet (PHDTE)"
  },
  {
   value: "Danao (PHDNO)",
   label: "Danao (PHDNO)"
  },
  {
   value: "Dilasag (PHDSG)",
   label: "Dilasag (PHDSG)"
  },
  {
   value: "Dulag (PHDUL)",
   label: "Dulag (PHDUL)"
  },
  {
   value: "Garcia Hernandez (PHGHE)",
   label: "Garcia Hernandez (PHGHE)"
  },
  {
   value: "Guihulngan (PHGHG)",
   label: "Guihulngan (PHGHG)"
  },
  {
   value: "Guiuan (PHGUN)",
   label: "Guiuan (PHGUN)"
  },
  {
   value: "Hamtic (PHAQE)",
   label: "Hamtic (PHAQE)"
  },
  {
   value: "Hilongos (PHHIL)",
   label: "Hilongos (PHHIL)"
  },
  {
   value: "Kalamansig (PHKLM)",
   label: "Kalamansig (PHKLM)"
  },
  {
   value: "Larena (PHLNA)",
   label: "Larena (PHLNA)"
  },
  {
   value: "Lazi (PHLZB)",
   label: "Lazi (PHLZB)"
  },
  {
   value: "Legaspi (PHLIC)",
   label: "Legaspi (PHLIC)"
  },
  {
   value: "Lubang (PHLBX)",
   label: "Lubang (PHLBX)"
  },
  {
   value: "Lwbak (PHLWA)",
   label: "Lwbak (PHLWA)"
  },
  {
   value: "Makati (PHMTI)",
   label: "Makati (PHMTI)"
  },
  {
   value: "Malatapay (PHMTP)",
   label: "Malatapay (PHMTP)"
  },
  {
   value: "Mandaluyong (PHMDL)",
   label: "Mandaluyong (PHMDL)"
  },
  {
   value: "Mandaue, Cebu (PHMAN)",
   label: "Mandaue, Cebu (PHMAN)"
  },
  {
   value: "Manicani (PHMNI)",
   label: "Manicani (PHMNI)"
  },
  {
   value: "Manila North Harbour (PHMNN)",
   label: "Manila North Harbour (PHMNN)"
  },
  {
   value: "Maramag (PHXMA)",
   label: "Maramag (PHXMA)"
  },
  {
   value: "Naga, Luzon (PHNAG)",
   label: "Naga, Luzon (PHNAG)"
  },
  {
   value: "Nido Terminal (PHNID)",
   label: "Nido Terminal (PHNID)"
  },
  {
   value: "Odiongan (PHODI)",
   label: "Odiongan (PHODI)"
  },
  {
   value: "Oroquieta (PHORL)",
   label: "Oroquieta (PHORL)"
  },
  {
   value: "Palompon (PHPPN)",
   label: "Palompon (PHPPN)"
  },
  {
   value: "Parañaque (PHPPA)",
   label: "Parañaque (PHPPA)"
  },
  {
   value: "Pasig\/Manila (PHPSG)",
   label: "Pasig\/Manila (PHPSG)"
  },
  {
   value: "Pto Galera (PHPGA)",
   label: "Pto Galera (PHPGA)"
  },
  {
   value: "Rio Tuba (PHRTB)",
   label: "Rio Tuba (PHRTB)"
  },
  {
   value: "Rizal, Luzon (PHRIZ)",
   label: "Rizal, Luzon (PHRIZ)"
  },
  {
   value: "Romblon (PHROM)",
   label: "Romblon (PHROM)"
  },
  {
   value: "Salomague (PHSLM)",
   label: "Salomague (PHSLM)"
  },
  {
   value: "San Antonio Este (PHSAE)",
   label: "San Antonio Este (PHSAE)"
  },
  {
   value: "Sanga Sanga (PHSGS)",
   label: "Sanga Sanga (PHSGS)"
  },
  {
   value: "Sangley Point (PHNSP)",
   label: "Sangley Point (PHNSP)"
  },
  {
   value: "Santo Tomas (PHSTS)",
   label: "Santo Tomas (PHSTS)"
  },
  {
   value: "Semirara (PHSMR)",
   label: "Semirara (PHSMR)"
  },
  {
   value: "Siasi (PHSSV)",
   label: "Siasi (PHSSV)"
  },
  {
   value: "Sicogon Island (PHICO)",
   label: "Sicogon Island (PHICO)"
  },
  {
   value: "Tabango, Leyte (PHTAB)",
   label: "Tabango, Leyte (PHTAB)"
  },
  {
   value: "Taganito (PHTTO)",
   label: "Taganito (PHTTO)"
  },
  {
   value: "Tagbita (PHTGB)",
   label: "Tagbita (PHTGB)"
  },
  {
   value: "Taguig (PHTAU)",
   label: "Taguig (PHTAU)"
  },
  {
   value: "Talibon (PHTAL)",
   label: "Talibon (PHTAL)"
  },
  {
   value: "Tandayag (PHTAN)",
   label: "Tandayag (PHTAN)"
  },
  {
   value: "Tarlac, Luzon (PHTAR)",
   label: "Tarlac, Luzon (PHTAR)"
  },
  {
   value: "Tawitawi (PHTWT)",
   label: "Tawitawi (PHTWT)"
  },
  {
   value: "Trece Martires (PHTMA)",
   label: "Trece Martires (PHTMA)"
  },
  {
   value: "Tubigon (PHTON)",
   label: "Tubigon (PHTON)"
  },
  {
   value: ".PAKISTAN (PK)",
   label: ".PAKISTAN (PK)"
  },
  {
   value: "Abbottabad (PKAAW)",
   label: "Abbottabad (PKAAW)"
  },
  {
   value: "Ahmadpur (PKADP)",
   label: "Ahmadpur (PKADP)"
  },
  {
   value: "Arifwala (PKARF)",
   label: "Arifwala (PKARF)"
  },
  {
   value: "Attock (PKATG)",
   label: "Attock (PKATG)"
  },
  {
   value: "Attock City (PKATY)",
   label: "Attock City (PKATY)"
  },
  {
   value: "Badin (PKBDN)",
   label: "Badin (PKBDN)"
  },
  {
   value: "Bagh\/AJK (PKBAG)",
   label: "Bagh\/AJK (PKBAG)"
  },
  {
   value: "Bahawalnagar (PKWGB)",
   label: "Bahawalnagar (PKWGB)"
  },
  {
   value: "Bhai Pheru (PKBPR)",
   label: "Bhai Pheru (PKBPR)"
  },
  {
   value: "Bhakkar (PKBKR)",
   label: "Bhakkar (PKBKR)"
  },
  {
   value: "Bhurban (PKBHC)",
   label: "Bhurban (PKBHC)"
  },
  {
   value: "Burewala (PKBRW)",
   label: "Burewala (PKBRW)"
  },
  {
   value: "Campbellpore (PKCWP)",
   label: "Campbellpore (PKCWP)"
  },
  {
   value: "Chakwal (PKCKW)",
   label: "Chakwal (PKCKW)"
  },
  {
   value: "Changa Manga (PKCGM)",
   label: "Changa Manga (PKCGM)"
  },
  {
   value: "Charsadda (PKCSD)",
   label: "Charsadda (PKCSD)"
  },
  {
   value: "Chichawatni (PKCCE)",
   label: "Chichawatni (PKCCE)"
  },
  {
   value: "Chichoki Mallian (PKCCM)",
   label: "Chichoki Mallian (PKCCM)"
  },
  {
   value: "Chilas (PKCHB)",
   label: "Chilas (PKCHB)"
  },
  {
   value: "Chishtian (PKCSI)",
   label: "Chishtian (PKCSI)"
  },
  {
   value: "Daharki (PKDRK)",
   label: "Daharki (PKDRK)"
  },
  {
   value: "Daska (PKDKA)",
   label: "Daska (PKDKA)"
  },
  {
   value: "Dir (PKDIR)",
   label: "Dir (PKDIR)"
  },
  {
   value: "Gadoon (PKGAD)",
   label: "Gadoon (PKGAD)"
  },
  {
   value: "Garhi Habibullah Khan (PKGHB)",
   label: "Garhi Habibullah Khan (PKGHB)"
  },
  {
   value: "Ghakhar (PKGHK)",
   label: "Ghakhar (PKGHK)"
  },
  {
   value: "Gujar Khan (PKGKN)",
   label: "Gujar Khan (PKGKN)"
  },
  {
   value: "Gujranwala (PKGRW)",
   label: "Gujranwala (PKGRW)"
  },
  {
   value: "Hafizabad (PKHFD)",
   label: "Hafizabad (PKHFD)"
  },
  {
   value: "Haripur (PKHPR)",
   label: "Haripur (PKHPR)"
  },
  {
   value: "Haripur Hazara (PKHRU)",
   label: "Haripur Hazara (PKHRU)"
  },
  {
   value: "Hassanabdal (PKHSN)",
   label: "Hassanabdal (PKHSN)"
  },
  {
   value: "Havelian (PKHVN)",
   label: "Havelian (PKHVN)"
  },
  {
   value: "Hub (PKHUB)",
   label: "Hub (PKHUB)"
  },
  {
   value: "Jalalpur (PKJLP)",
   label: "Jalalpur (PKJLP)"
  },
  {
   value: "Jamrud (PKJRD)",
   label: "Jamrud (PKJRD)"
  },
  {
   value: "Jaranwala (PKJNW)",
   label: "Jaranwala (PKJNW)"
  },
  {
   value: "Jhal Magsi (PKJLM)",
   label: "Jhal Magsi (PKJLM)"
  },
  {
   value: "Jhang (PKJNG)",
   label: "Jhang (PKJNG)"
  },
  {
   value: "Jhang City (PKJHC)",
   label: "Jhang City (PKJHC)"
  },
  {
   value: "Jhelum (PKJMR)",
   label: "Jhelum (PKJMR)"
  },
  {
   value: "Jungshahi (PKJGS)",
   label: "Jungshahi (PKJGS)"
  },
  {
   value: "Kabirwala (PKKBW)",
   label: "Kabirwala (PKKBW)"
  },
  {
   value: "Kadanwari (PKKCF)",
   label: "Kadanwari (PKKCF)"
  },
  {
   value: "Kalat (PKKBH)",
   label: "Kalat (PKKBH)"
  },
  {
   value: "Kamalia (PKKML)",
   label: "Kamalia (PKKML)"
  },
  {
   value: "Kambar (PKKMB)",
   label: "Kambar (PKKMB)"
  },
  {
   value: "Karachi City (PKKYC)",
   label: "Karachi City (PKKYC)"
  },
  {
   value: "Karachi Container Terminal (PKKCT)",
   label: "Karachi Container Terminal (PKKCT)"
  },
  {
   value: "Karachi Freight Terminal (PKPZK)",
   label: "Karachi Freight Terminal (PKPZK)"
  },
  {
   value: "Kashmor (PKKZL)",
   label: "Kashmor (PKKZL)"
  },
  {
   value: "Kasur (PKKUS)",
   label: "Kasur (PKKUS)"
  },
  {
   value: "Khairpur (PKKHP)",
   label: "Khairpur (PKKHP)"
  },
  {
   value: "Khanewal (PKKWL)",
   label: "Khanewal (PKKWL)"
  },
  {
   value: "Khanpur (PKKPR)",
   label: "Khanpur (PKKPR)"
  },
  {
   value: "Kharian (PKQKH)",
   label: "Kharian (PKQKH)"
  },
  {
   value: "Khewra (PKKWA)",
   label: "Khewra (PKKWA)"
  },
  {
   value: "Khushab (PKKHB)",
   label: "Khushab (PKKHB)"
  },
  {
   value: "Kiamari (PKKIA)",
   label: "Kiamari (PKKIA)"
  },
  {
   value: "Kohat Cantt (PKKHC)",
   label: "Kohat Cantt (PKKHC)"
  },
  {
   value: "Kohlu (PKKLU)",
   label: "Kohlu (PKKLU)"
  },
  {
   value: "Kot Addu (PKADK)",
   label: "Kot Addu (PKADK)"
  },
  {
   value: "Kot Lakhpat (PKLPK)",
   label: "Kot Lakhpat (PKLPK)"
  },
  {
   value: "Kotli\/AJK (PKKOL)",
   label: "Kotli\/AJK (PKKOL)"
  },
  {
   value: "Kotri (PKKOT)",
   label: "Kotri (PKKOT)"
  },
  {
   value: "Lahore Cantt (PKLRC)",
   label: "Lahore Cantt (PKLRC)"
  },
  {
   value: "Lakki Marwat (PKLKM)",
   label: "Lakki Marwat (PKLKM)"
  },
  {
   value: "Lala Mosa (PKLLM)",
   label: "Lala Mosa (PKLLM)"
  },
  {
   value: "Landhi (PKLND)",
   label: "Landhi (PKLND)"
  },
  {
   value: "Larkana (PKLRK)",
   label: "Larkana (PKLRK)"
  },
  {
   value: "Lasbela (PKLSB)",
   label: "Lasbela (PKLSB)"
  },
  {
   value: "Lodhran (PKLON)",
   label: "Lodhran (PKLON)"
  },
  {
   value: "Lora Lai (PKLRG)",
   label: "Lora Lai (PKLRG)"
  },
  {
   value: "Malakand (PKMKD)",
   label: "Malakand (PKMKD)"
  },
  {
   value: "Mandi Bahauddin (PKMBD)",
   label: "Mandi Bahauddin (PKMBD)"
  },
  {
   value: "Mandi Burewala (PKMBW)",
   label: "Mandi Burewala (PKMBW)"
  },
  {
   value: "Mangla (PKMAN)",
   label: "Mangla (PKMAN)"
  },
  {
   value: "Mansehra (PKHRA)",
   label: "Mansehra (PKHRA)"
  },
  {
   value: "Mardan (PKMDX)",
   label: "Mardan (PKMDX)"
  },
  {
   value: "Matli (PKMLI)",
   label: "Matli (PKMLI)"
  },
  {
   value: "Mehrabpur (PKMHR)",
   label: "Mehrabpur (PKMHR)"
  },
  {
   value: "Mian Channu (PKMYH)",
   label: "Mian Channu (PKMYH)"
  },
  {
   value: "Mingaora (PKMNG)",
   label: "Mingaora (PKMNG)"
  },
  {
   value: "Mirpur Mathelo (PKMRP)",
   label: "Mirpur Mathelo (PKMRP)"
  },
  {
   value: "Mirpur\/AJK (PKMPR)",
   label: "Mirpur\/AJK (PKMPR)"
  },
  {
   value: "Moro (PKMOR)",
   label: "Moro (PKMOR)"
  },
  {
   value: "Multan Cantt (PKMUL)",
   label: "Multan Cantt (PKMUL)"
  },
  {
   value: "Multan City (PKMXC)",
   label: "Multan City (PKMXC)"
  },
  {
   value: "Muridke (PKMDK)",
   label: "Muridke (PKMDK)"
  },
  {
   value: "Nankana Sahib (PKNNS)",
   label: "Nankana Sahib (PKNNS)"
  },
  {
   value: "Narowal (PKNRW)",
   label: "Narowal (PKNRW)"
  },
  {
   value: "Nowshera (PKNSR)",
   label: "Nowshera (PKNSR)"
  },
  {
   value: "Nushki (PKNHS)",
   label: "Nushki (PKNHS)"
  },
  {
   value: "Okara (PKOKR)",
   label: "Okara (PKOKR)"
  },
  {
   value: "Okara Cantt (PKOKC)",
   label: "Okara Cantt (PKOKC)"
  },
  {
   value: "Pabbi (PKPBI)",
   label: "Pabbi (PKPBI)"
  },
  {
   value: "Pano Aqil (PKPNL)",
   label: "Pano Aqil (PKPNL)"
  },
  {
   value: "Para Chinar (PKPAJ)",
   label: "Para Chinar (PKPAJ)"
  },
  {
   value: "Pattoki (PKPTO)",
   label: "Pattoki (PKPTO)"
  },
  {
   value: "Peshawar Cantt (PKPSC)",
   label: "Peshawar Cantt (PKPSC)"
  },
  {
   value: "Peshawar City (PKPSH)",
   label: "Peshawar City (PKPSH)"
  },
  {
   value: "Poonch\/AJK (PKPON)",
   label: "Poonch\/AJK (PKPON)"
  },
  {
   value: "Qila Sheikhupura (PKQSP)",
   label: "Qila Sheikhupura (PKQSP)"
  },
  {
   value: "Raiwind (PKRND)",
   label: "Raiwind (PKRND)"
  },
  {
   value: "Rajanpur (PKRJP)",
   label: "Rajanpur (PKRJP)"
  },
  {
   value: "Risalpur Cantt (PKRCS)",
   label: "Risalpur Cantt (PKRCS)"
  },
  {
   value: "Rohri (PKROH)",
   label: "Rohri (PKROH)"
  },
  {
   value: "Sadikabad (PKSDK)",
   label: "Sadikabad (PKSDK)"
  },
  {
   value: "Sahiwal (PKSWN)",
   label: "Sahiwal (PKSWN)"
  },
  {
   value: "Samasata (PKSMA)",
   label: "Samasata (PKSMA)"
  },
  {
   value: "Sambrial (PKSMB)",
   label: "Sambrial (PKSMB)"
  },
  {
   value: "Sammundri (PKSMD)",
   label: "Sammundri (PKSMD)"
  },
  {
   value: "Sanghar (PKSNG)",
   label: "Sanghar (PKSNG)"
  },
  {
   value: "Sangla Hill (PKSLL)",
   label: "Sangla Hill (PKSLL)"
  },
  {
   value: "Sargodha (PKSGI)",
   label: "Sargodha (PKSGI)"
  },
  {
   value: "Savi Ragha (PKZEO)",
   label: "Savi Ragha (PKZEO)"
  },
  {
   value: "Sawan (PKSAW)",
   label: "Sawan (PKSAW)"
  },
  {
   value: "Sehwen Sharif (PKSYW)",
   label: "Sehwen Sharif (PKSYW)"
  },
  {
   value: "Serai Alamgir (PKSXG)",
   label: "Serai Alamgir (PKSXG)"
  },
  {
   value: "Shabqadar (PKSQR)",
   label: "Shabqadar (PKSQR)"
  },
  {
   value: "Shahdadkot (PKSHK)",
   label: "Shahdadkot (PKSHK)"
  },
  {
   value: "Shahdadpur (PKSDU)",
   label: "Shahdadpur (PKSDU)"
  },
  {
   value: "Shahdara Bagh (PKSDR)",
   label: "Shahdara Bagh (PKSDR)"
  },
  {
   value: "Sheikhupura (PKSKP)",
   label: "Sheikhupura (PKSKP)"
  },
  {
   value: "Shikarpur (PKSWV)",
   label: "Shikarpur (PKSWV)"
  },
  {
   value: "Shorkot (PKSRK)",
   label: "Shorkot (PKSRK)"
  },
  {
   value: "Shorkot Cantt (PKSKO)",
   label: "Shorkot Cantt (PKSKO)"
  },
  {
   value: "Sibi (PKSBQ)",
   label: "Sibi (PKSBQ)"
  },
  {
   value: "Swabi (PKSWB)",
   label: "Swabi (PKSWB)"
  },
  {
   value: "Tando Adam (PKTNA)",
   label: "Tando Adam (PKTNA)"
  },
  {
   value: "Tando Allahyar (PKTDA)",
   label: "Tando Allahyar (PKTDA)"
  },
  {
   value: "Taxilla (PKTXA)",
   label: "Taxilla (PKTXA)"
  },
  {
   value: "Thatta (PKTHT)",
   label: "Thatta (PKTHT)"
  },
  {
   value: "Timargara (PKTMG)",
   label: "Timargara (PKTMG)"
  },
  {
   value: "Toba Tek Singh (PKTTS)",
   label: "Toba Tek Singh (PKTTS)"
  },
  {
   value: "Vehari (PKVHR)",
   label: "Vehari (PKVHR)"
  },
  {
   value: "Wah (PKWAH)",
   label: "Wah (PKWAH)"
  },
  {
   value: "Wana (PKWAF)",
   label: "Wana (PKWAF)"
  },
  {
   value: "Wazirabad (PKWZA)",
   label: "Wazirabad (PKWZA)"
  },
  {
   value: "Ziarat (PKZRT)",
   label: "Ziarat (PKZRT)"
  },
  {
   value: ".POLAND (PL)",
   label: ".POLAND (PL)"
  },
  {
   value: "Adamów (PLADJ)",
   label: "Adamów (PLADJ)"
  },
  {
   value: "Aleksandrów Kujawski (PLALK)",
   label: "Aleksandrów Kujawski (PLALK)"
  },
  {
   value: "Aleksandrów Lodzki (PLAWL)",
   label: "Aleksandrów Lodzki (PLAWL)"
  },
  {
   value: "Alwernia (PLAWN)",
   label: "Alwernia (PLAWN)"
  },
  {
   value: "Andrychów (PLADC)",
   label: "Andrychów (PLADC)"
  },
  {
   value: "Augustów (PLAUG)",
   label: "Augustów (PLAUG)"
  },
  {
   value: "Babimost (PLBMS)",
   label: "Babimost (PLBMS)"
  },
  {
   value: "Backowice (PLBWE)",
   label: "Backowice (PLBWE)"
  },
  {
   value: "Balice (PLBLI)",
   label: "Balice (PLBLI)"
  },
  {
   value: "Banino (PLBNO)",
   label: "Banino (PLBNO)"
  },
  {
   value: "Baniocha (PLBNH)",
   label: "Baniocha (PLBNH)"
  },
  {
   value: "Baranowo (PLBAO)",
   label: "Baranowo (PLBAO)"
  },
  {
   value: "Barcin (PLBRC)",
   label: "Barcin (PLBRC)"
  },
  {
   value: "Barczewo (PLBCO)",
   label: "Barczewo (PLBCO)"
  },
  {
   value: "Barlinek (PLBLK)",
   label: "Barlinek (PLBLK)"
  },
  {
   value: "Bedzin (PLPBD)",
   label: "Bedzin (PLPBD)"
  },
  {
   value: "Bedzino (PLBED)",
   label: "Bedzino (PLBED)"
  },
  {
   value: "Belchatów (PLBTW)",
   label: "Belchatów (PLBTW)"
  },
  {
   value: "Belsk Duzy (PLBDZ)",
   label: "Belsk Duzy (PLBDZ)"
  },
  {
   value: "Belzyce (PLBEL)",
   label: "Belzyce (PLBEL)"
  },
  {
   value: "Bestwina (PLBET)",
   label: "Bestwina (PLBET)"
  },
  {
   value: "Bezledy (PLBEZ)",
   label: "Bezledy (PLBEZ)"
  },
  {
   value: "Biadoliny (PLBID)",
   label: "Biadoliny (PLBID)"
  },
  {
   value: "Biala Podlaska (PLBAP)",
   label: "Biala Podlaska (PLBAP)"
  },
  {
   value: "Bialaczów (PLBZO)",
   label: "Bialaczów (PLBZO)"
  },
  {
   value: "Biale Blota (PLBAB)",
   label: "Biale Blota (PLBAB)"
  },
  {
   value: "Bialka Tatrzanska (PLBTS)",
   label: "Bialka Tatrzanska (PLBTS)"
  },
  {
   value: "Bialogard (PLBOG)",
   label: "Bialogard (PLBOG)"
  },
  {
   value: "Bialosliwie (PLBII)",
   label: "Bialosliwie (PLBII)"
  },
  {
   value: "Bidziny (PLBZY)",
   label: "Bidziny (PLBZY)"
  },
  {
   value: "Bielany Wroclawskie (PLBYW)",
   label: "Bielany Wroclawskie (PLBYW)"
  },
  {
   value: "Bielawa (PLBLW)",
   label: "Bielawa (PLBLW)"
  },
  {
   value: "Bierun Stary (PLBST)",
   label: "Bierun Stary (PLBST)"
  },
  {
   value: "Bierutów (PLBRT)",
   label: "Bierutów (PLBRT)"
  },
  {
   value: "Bilgoraj (PLBOJ)",
   label: "Bilgoraj (PLBOJ)"
  },
  {
   value: "Biskupice (PLBKW)",
   label: "Biskupice (PLBKW)"
  },
  {
   value: "Biskupiec (PLBIK)",
   label: "Biskupiec (PLBIK)"
  },
  {
   value: "Blachownia (PLBHW)",
   label: "Blachownia (PLBHW)"
  },
  {
   value: "Blaszki (PLBLA)",
   label: "Blaszki (PLBLA)"
  },
  {
   value: "Bledów (PLBLE)",
   label: "Bledów (PLBLE)"
  },
  {
   value: "Blonie (PLBLO)",
   label: "Blonie (PLBLO)"
  },
  {
   value: "Bobolice (PLBLC)",
   label: "Bobolice (PLBLC)"
  },
  {
   value: "Bobrowo (PLBWO)",
   label: "Bobrowo (PLBWO)"
  },
  {
   value: "Bogatynia (PLBGY)",
   label: "Bogatynia (PLBGY)"
  },
  {
   value: "BoguchwaBa (PLBGW)",
   label: "BoguchwaBa (PLBGW)"
  },
  {
   value: "Boguchwala (PLBGA)",
   label: "Boguchwala (PLBGA)"
  },
  {
   value: "Boguszów-Gorce (PLBWG)",
   label: "Boguszów-Gorce (PLBWG)"
  },
  {
   value: "Bojanowo (PLBJW)",
   label: "Bojanowo (PLBJW)"
  },
  {
   value: "Boleslaw (PLBSW)",
   label: "Boleslaw (PLBSW)"
  },
  {
   value: "Boleslawiec (PLBOL)",
   label: "Boleslawiec (PLBOL)"
  },
  {
   value: "Bolimów (PLBOW)",
   label: "Bolimów (PLBOW)"
  },
  {
   value: "Bolszewo (PLBSZ)",
   label: "Bolszewo (PLBSZ)"
  },
  {
   value: "Borek Wielkopolski (PLBOK)",
   label: "Borek Wielkopolski (PLBOK)"
  },
  {
   value: "Borne (PLBSU)",
   label: "Borne (PLBSU)"
  },
  {
   value: "Borzeciczki (PLBZK)",
   label: "Borzeciczki (PLBZK)"
  },
  {
   value: "Borzytuchom (PLOZH)",
   label: "Borzytuchom (PLOZH)"
  },
  {
   value: "Bralin (PLBLN)",
   label: "Bralin (PLBLN)"
  },
  {
   value: "Braniewo (PLBRN)",
   label: "Braniewo (PLBRN)"
  },
  {
   value: "Bransk (PLBNS)",
   label: "Bransk (PLBNS)"
  },
  {
   value: "Brodnica (PLBNA)",
   label: "Brodnica (PLBNA)"
  },
  {
   value: "Brodnica (PLBRA)",
   label: "Brodnica (PLBRA)"
  },
  {
   value: "Brójce (PLBRL)",
   label: "Brójce (PLBRL)"
  },
  {
   value: "Brwinów (PLBRI)",
   label: "Brwinów (PLBRI)"
  },
  {
   value: "Brynica (PLBRY)",
   label: "Brynica (PLBRY)"
  },
  {
   value: "Brzeg (PLBRG)",
   label: "Brzeg (PLBRG)"
  },
  {
   value: "Brzeg Dolny (PLBZD)",
   label: "Brzeg Dolny (PLBZD)"
  },
  {
   value: "Brzesc Kujawski (PLBKI)",
   label: "Brzesc Kujawski (PLBKI)"
  },
  {
   value: "Brzesko (PLBRZ)",
   label: "Brzesko (PLBRZ)"
  },
  {
   value: "Brzezie (PLBRE)",
   label: "Brzezie (PLBRE)"
  },
  {
   value: "Brzeziny (PLOZA)",
   label: "Brzeziny (PLOZA)"
  },
  {
   value: "Brzeznio (PLBRO)",
   label: "Brzeznio (PLBRO)"
  },
  {
   value: "Brzoza (PLBZR)",
   label: "Brzoza (PLBZR)"
  },
  {
   value: "Brzozów (PLBZZ)",
   label: "Brzozów (PLBZZ)"
  },
  {
   value: "Buczkowice (PLBWC)",
   label: "Buczkowice (PLBWC)"
  },
  {
   value: "Buk (PLBUK)",
   label: "Buk (PLBUK)"
  },
  {
   value: "Bukowno (PLBUW)",
   label: "Bukowno (PLBUW)"
  },
  {
   value: "Burzenin (PLBZI)",
   label: "Burzenin (PLBZI)"
  },
  {
   value: "Busko Zdroj (PLOZG)",
   label: "Busko Zdroj (PLOZG)"
  },
  {
   value: "Busko-Zdrój (PLBUS)",
   label: "Busko-Zdrój (PLBUS)"
  },
  {
   value: "Byczyna (PLBYC)",
   label: "Byczyna (PLBYC)"
  },
  {
   value: "Bystrzyca Klodzka (PLBTZ)",
   label: "Bystrzyca Klodzka (PLBTZ)"
  },
  {
   value: "Bystrzyca Klodzka (PLBYK)",
   label: "Bystrzyca Klodzka (PLBYK)"
  },
  {
   value: "Bytow (PLBYO)",
   label: "Bytow (PLBYO)"
  },
  {
   value: "Cekcyn (PLCEK)",
   label: "Cekcyn (PLCEK)"
  },
  {
   value: "Celestynow (PLCEL)",
   label: "Celestynow (PLCEL)"
  },
  {
   value: "Chabowka (PLCHA)",
   label: "Chabowka (PLCHA)"
  },
  {
   value: "Chalupy (PLCHL)",
   label: "Chalupy (PLCHL)"
  },
  {
   value: "Chelmek (PLCMK)",
   label: "Chelmek (PLCMK)"
  },
  {
   value: "Chelmno (PLCHO)",
   label: "Chelmno (PLCHO)"
  },
  {
   value: "Chelmza (PLCLM)",
   label: "Chelmza (PLCLM)"
  },
  {
   value: "Chmielnik (PLCHM)",
   label: "Chmielnik (PLCHM)"
  },
  {
   value: "Chocianów (PLCHZ)",
   label: "Chocianów (PLCHZ)"
  },
  {
   value: "Chociwel (PLCWL)",
   label: "Chociwel (PLCWL)"
  },
  {
   value: "Chodel (PLCDL)",
   label: "Chodel (PLCDL)"
  },
  {
   value: "Chojnice (PLCHE)",
   label: "Chojnice (PLCHE)"
  },
  {
   value: "Chojnów (PLCJO)",
   label: "Chojnów (PLCJO)"
  },
  {
   value: "Chorzow (PLCRW)",
   label: "Chorzow (PLCRW)"
  },
  {
   value: "Choszczno (PLCHS)",
   label: "Choszczno (PLCHS)"
  },
  {
   value: "Chrzanow (PLCNW)",
   label: "Chrzanow (PLCNW)"
  },
  {
   value: "Chwaszczyno (PLCZO)",
   label: "Chwaszczyno (PLCZO)"
  },
  {
   value: "Chybie (PLCHY)",
   label: "Chybie (PLCHY)"
  },
  {
   value: "Ciasna (PLCIS)",
   label: "Ciasna (PLCIS)"
  },
  {
   value: "Ciazen (PLCAZ)",
   label: "Ciazen (PLCAZ)"
  },
  {
   value: "Ciche (PLCIC)",
   label: "Ciche (PLCIC)"
  },
  {
   value: "Ciechanów (PLCIE)",
   label: "Ciechanów (PLCIE)"
  },
  {
   value: "Ciechocinek (PLCIK)",
   label: "Ciechocinek (PLCIK)"
  },
  {
   value: "Cieplowody (PLCWY)",
   label: "Cieplowody (PLCWY)"
  },
  {
   value: "Cierpice (PLCPC)",
   label: "Cierpice (PLCPC)"
  },
  {
   value: "Cieszyn (PLCZY)",
   label: "Cieszyn (PLCZY)"
  },
  {
   value: "Cigacice (PLCGA)",
   label: "Cigacice (PLCGA)"
  },
  {
   value: "Cmolas (PLCLA)",
   label: "Cmolas (PLCLA)"
  },
  {
   value: "Czaplinek (PLCZK)",
   label: "Czaplinek (PLCZK)"
  },
  {
   value: "Czarna (PLZAA)",
   label: "Czarna (PLZAA)"
  },
  {
   value: "Czarna Woda (PLCAR)",
   label: "Czarna Woda (PLCAR)"
  },
  {
   value: "Czarnków (PLCZA)",
   label: "Czarnków (PLCZA)"
  },
  {
   value: "Czchow (PLCHW)",
   label: "Czchow (PLCHW)"
  },
  {
   value: "Czechowice-Dziedzice (PLCZD)",
   label: "Czechowice-Dziedzice (PLCZD)"
  },
  {
   value: "Czeladz (PLCLZ)",
   label: "Czeladz (PLCLZ)"
  },
  {
   value: "Czernica (PLCZE)",
   label: "Czernica (PLCZE)"
  },
  {
   value: "Czerniewice (PLOZK)",
   label: "Czerniewice (PLOZK)"
  },
  {
   value: "Czersk Pomorski (PLCZR)",
   label: "Czersk Pomorski (PLCZR)"
  },
  {
   value: "Czerwiénsk (PLCWA)",
   label: "Czerwiénsk (PLCWA)"
  },
  {
   value: "Czerwionka (PLCKL)",
   label: "Czerwionka (PLCKL)"
  },
  {
   value: "Czerwonak (PLCWO)",
   label: "Czerwonak (PLCWO)"
  },
  {
   value: "Czestkow B (PLCZB)",
   label: "Czestkow B (PLCZB)"
  },
  {
   value: "Czlopa (PLOZJ)",
   label: "Czlopa (PLOZJ)"
  },
  {
   value: "Czluchow (PLCLH)",
   label: "Czluchow (PLCLH)"
  },
  {
   value: "Czosnów (PLCSN)",
   label: "Czosnów (PLCSN)"
  },
  {
   value: "Czyzew (PLCZZ)",
   label: "Czyzew (PLCZZ)"
  },
  {
   value: "Dabie (PLDBE)",
   label: "Dabie (PLDBE)"
  },
  {
   value: "Dabrowa Bialostocka (PLDBA)",
   label: "Dabrowa Bialostocka (PLDBA)"
  },
  {
   value: "Dabrowa Górnicza (PLDAB)",
   label: "Dabrowa Górnicza (PLDAB)"
  },
  {
   value: "Dabrowa Rusiecka (PLDBW)",
   label: "Dabrowa Rusiecka (PLDBW)"
  },
  {
   value: "Dabrowa Tarnowska (PLDAT)",
   label: "Dabrowa Tarnowska (PLDAT)"
  },
  {
   value: "Dabrówka (PLDBK)",
   label: "Dabrówka (PLDBK)"
  },
  {
   value: "Dabrowno (PLDBN)",
   label: "Dabrowno (PLDBN)"
  },
  {
   value: "Daleszyce (PLDAL)",
   label: "Daleszyce (PLDAL)"
  },
  {
   value: "Damnica (PLDMC)",
   label: "Damnica (PLDMC)"
  },
  {
   value: "Daszyna (PLDAS)",
   label: "Daszyna (PLDAS)"
  },
  {
   value: "Deblin (PLDBL)",
   label: "Deblin (PLDBL)"
  },
  {
   value: "Debnica Kaszubska (PLDKA)",
   label: "Debnica Kaszubska (PLDKA)"
  },
  {
   value: "Debno (PLDDN)",
   label: "Debno (PLDDN)"
  },
  {
   value: "Dobiegniew (PLDBG)",
   label: "Dobiegniew (PLDBG)"
  },
  {
   value: "Dobieszowice (PLDZC)",
   label: "Dobieszowice (PLDZC)"
  },
  {
   value: "Dobrodzien (PLDBZ)",
   label: "Dobrodzien (PLDBZ)"
  },
  {
   value: "Dobrzyca (PLOZL)",
   label: "Dobrzyca (PLOZL)"
  },
  {
   value: "Dobrzyn nad Wisla (PLDNW)",
   label: "Dobrzyn nad Wisla (PLDNW)"
  },
  {
   value: "Dobrzyniewo Koscielne (PLDOK)",
   label: "Dobrzyniewo Koscielne (PLDOK)"
  },
  {
   value: "Dolsk (PLDSK)",
   label: "Dolsk (PLDSK)"
  },
  {
   value: "Doluje (PLDLN)",
   label: "Doluje (PLDLN)"
  },
  {
   value: "Doluje Mierzyn (PLDOL)",
   label: "Doluje Mierzyn (PLDOL)"
  },
  {
   value: "Dopiewo (PLDPW)",
   label: "Dopiewo (PLDPW)"
  },
  {
   value: "Dorohusk (PLDOR)",
   label: "Dorohusk (PLDOR)"
  },
  {
   value: "Drawsko Pomorskie (PLDRP)",
   label: "Drawsko Pomorskie (PLDRP)"
  },
  {
   value: "Drezdenko-Chyze (PLDZK)",
   label: "Drezdenko-Chyze (PLDZK)"
  },
  {
   value: "Drygaly (PLDRY)",
   label: "Drygaly (PLDRY)"
  },
  {
   value: "Duchnice (PLOZN)",
   label: "Duchnice (PLOZN)"
  },
  {
   value: "Duszniki Zdrój (PLDUS)",
   label: "Duszniki Zdrój (PLDUS)"
  },
  {
   value: "Dywity (PLDYW)",
   label: "Dywity (PLDYW)"
  },
  {
   value: "Dzialdowo (PLDZI)",
   label: "Dzialdowo (PLDZI)"
  },
  {
   value: "Dzialoszyn (PLDZA)",
   label: "Dzialoszyn (PLDZA)"
  },
  {
   value: "Dziekanów Lesny (PLDZL)",
   label: "Dziekanów Lesny (PLDZL)"
  },
  {
   value: "Dzierzoniów (PLDZO)",
   label: "Dzierzoniów (PLDZO)"
  },
  {
   value: "Elk (PLQKD)",
   label: "Elk (PLQKD)"
  },
  {
   value: "Fabianki (PLFBI)",
   label: "Fabianki (PLFBI)"
  },
  {
   value: "Fabianów (PLFAB)",
   label: "Fabianów (PLFAB)"
  },
  {
   value: "Fajslawice (PLFJC)",
   label: "Fajslawice (PLFJC)"
  },
  {
   value: "Frombork (PLFBK)",
   label: "Frombork (PLFBK)"
  },
  {
   value: "Gadki (PLGDK)",
   label: "Gadki (PLGDK)"
  },
  {
   value: "Galewice (PLGAL)",
   label: "Galewice (PLGAL)"
  },
  {
   value: "Garbatka-Letnisko (PLGLE)",
   label: "Garbatka-Letnisko (PLGLE)"
  },
  {
   value: "Garbów (PLGAR)",
   label: "Garbów (PLGAR)"
  },
  {
   value: "Garwolin (PLGWI)",
   label: "Garwolin (PLGWI)"
  },
  {
   value: "Gdów (PLGDW)",
   label: "Gdów (PLGDW)"
  },
  {
   value: "Gieralcice (PLGRC)",
   label: "Gieralcice (PLGRC)"
  },
  {
   value: "Gieraltowiec (PLGTW)",
   label: "Gieraltowiec (PLGTW)"
  },
  {
   value: "Gizycko (PLGIZ)",
   label: "Gizycko (PLGIZ)"
  },
  {
   value: "Gliwice (PLGWC)",
   label: "Gliwice (PLGWC)"
  },
  {
   value: "Gliwice (PLQLC)",
   label: "Gliwice (PLQLC)"
  },
  {
   value: "Glogoczów (PLGGO)",
   label: "Glogoczów (PLGGO)"
  },
  {
   value: "Glogow (PLGLW)",
   label: "Glogow (PLGLW)"
  },
  {
   value: "Glowno (PLGWO)",
   label: "Glowno (PLGWO)"
  },
  {
   value: "Gluchowo (PLGLO)",
   label: "Gluchowo (PLGLO)"
  },
  {
   value: "Gluszyca (PLGZA)",
   label: "Gluszyca (PLGZA)"
  },
  {
   value: "Gnatowice (PLMZG)",
   label: "Gnatowice (PLMZG)"
  },
  {
   value: "Gniew (PLGRW)",
   label: "Gniew (PLGRW)"
  },
  {
   value: "Gniewino (PLGNI)",
   label: "Gniewino (PLGNI)"
  },
  {
   value: "Gniezno (PLGNZ)",
   label: "Gniezno (PLGNZ)"
  },
  {
   value: "Goczalków (PLGOC)",
   label: "Goczalków (PLGOC)"
  },
  {
   value: "Godziesze Male (PLGOM)",
   label: "Godziesze Male (PLGOM)"
  },
  {
   value: "Godzikowice (PLGKW)",
   label: "Godzikowice (PLGKW)"
  },
  {
   value: "Gogolin (PLGOG)",
   label: "Gogolin (PLGOG)"
  },
  {
   value: "Goldap (PLGDP)",
   label: "Goldap (PLGDP)"
  },
  {
   value: "Goleniów (PLGOL)",
   label: "Goleniów (PLGOL)"
  },
  {
   value: "Goleszów (PLGOE)",
   label: "Goleszów (PLGOE)"
  },
  {
   value: "Golina (PLGNA)",
   label: "Golina (PLGNA)"
  },
  {
   value: "Golków (PLGLK)",
   label: "Golków (PLGLK)"
  },
  {
   value: "Golub-Dobrzyn (PLGOD)",
   label: "Golub-Dobrzyn (PLGOD)"
  },
  {
   value: "Goluchów (PLGUW)",
   label: "Goluchów (PLGUW)"
  },
  {
   value: "Goniadz (PLGON)",
   label: "Goniadz (PLGON)"
  },
  {
   value: "Gora (PLGRA)",
   label: "Gora (PLGRA)"
  },
  {
   value: "Góra Kalwaria (PLGOK)",
   label: "Góra Kalwaria (PLGOK)"
  },
  {
   value: "Góra Pulawska (PLGRP)",
   label: "Góra Pulawska (PLGRP)"
  },
  {
   value: "Gora Slaska (PLGSL)",
   label: "Gora Slaska (PLGSL)"
  },
  {
   value: "Górazdze (PLGZD)",
   label: "Górazdze (PLGZD)"
  },
  {
   value: "Gorlice (PLGLC)",
   label: "Gorlice (PLGLC)"
  },
  {
   value: "Gorzno (PLGZO)",
   label: "Gorzno (PLGZO)"
  },
  {
   value: "Gorzow (PLGZW)",
   label: "Gorzow (PLGZW)"
  },
  {
   value: "Gorzów Wielkopolski (PLGOW)",
   label: "Gorzów Wielkopolski (PLGOW)"
  },
  {
   value: "Gorzuchowo (PLGOR)",
   label: "Gorzuchowo (PLGOR)"
  },
  {
   value: "Gorzyce (Tarnobrzeg) (PLGZE)",
   label: "Gorzyce (Tarnobrzeg) (PLGZE)"
  },
  {
   value: "Goscicino (PLGOO)",
   label: "Goscicino (PLGOO)"
  },
  {
   value: "Goscino (PLGCO)",
   label: "Goscino (PLGCO)"
  },
  {
   value: "Gostków (PLLDG)",
   label: "Gostków (PLLDG)"
  },
  {
   value: "Gostynin (PLGYN)",
   label: "Gostynin (PLGYN)"
  },
  {
   value: "Goszczyn (PLGZZ)",
   label: "Goszczyn (PLGZZ)"
  },
  {
   value: "Grabica (PLGIC)",
   label: "Grabica (PLGIC)"
  },
  {
   value: "Grabow (PLGBW)",
   label: "Grabow (PLGBW)"
  },
  {
   value: "Grabów nad Prosna (PLGNP)",
   label: "Grabów nad Prosna (PLGNP)"
  },
  {
   value: "Grabowo Koscierskie (PLGKK)",
   label: "Grabowo Koscierskie (PLGKK)"
  },
  {
   value: "Grajewo (PLGJW)",
   label: "Grajewo (PLGJW)"
  },
  {
   value: "Grebocin (PLGBN)",
   label: "Grebocin (PLGBN)"
  },
  {
   value: "Grodzisk (PLGPS)",
   label: "Grodzisk (PLGPS)"
  },
  {
   value: "Grodzisk Mazowiecki (PLGRK)",
   label: "Grodzisk Mazowiecki (PLGRK)"
  },
  {
   value: "Grodzisk Wielkopolski (PLGZK)",
   label: "Grodzisk Wielkopolski (PLGZK)"
  },
  {
   value: "Grojec (PLGRO)",
   label: "Grojec (PLGRO)"
  },
  {
   value: "Gryfice (PLGRY)",
   label: "Gryfice (PLGRY)"
  },
  {
   value: "Gryfino (PLGRN)",
   label: "Gryfino (PLGRN)"
  },
  {
   value: "Grzybowo (PLGRB)",
   label: "Grzybowo (PLGRB)"
  },
  {
   value: "Guzów (PLGUZ)",
   label: "Guzów (PLGUZ)"
  },
  {
   value: "Hajnówka (PLHJK)",
   label: "Hajnówka (PLHJK)"
  },
  {
   value: "Halinów (PLHAL)",
   label: "Halinów (PLHAL)"
  },
  {
   value: "Harklowa (PLHKW)",
   label: "Harklowa (PLHKW)"
  },
  {
   value: "Hrebenne (PLHRE)",
   label: "Hrebenne (PLHRE)"
  },
  {
   value: "Hrubieszów (PLHBZ)",
   label: "Hrubieszów (PLHBZ)"
  },
  {
   value: "Ilawa (PLILA)",
   label: "Ilawa (PLILA)"
  },
  {
   value: "Ilowa (PLILW)",
   label: "Ilowa (PLILW)"
  },
  {
   value: "Ilowo (PLOZP)",
   label: "Ilowo (PLOZP)"
  },
  {
   value: "Ilza (PLILZ)",
   label: "Ilza (PLILZ)"
  },
  {
   value: "Inowroclaw (PLINO)",
   label: "Inowroclaw (PLINO)"
  },
  {
   value: "Insko (PLOYI)",
   label: "Insko (PLOYI)"
  },
  {
   value: "Istebna (PLIST)",
   label: "Istebna (PLIST)"
  },
  {
   value: "Iwaniska (PLIWA)",
   label: "Iwaniska (PLIWA)"
  },
  {
   value: "Iwierzyce (PLIYC)",
   label: "Iwierzyce (PLIYC)"
  },
  {
   value: "Izabelin (PLIBN)",
   label: "Izabelin (PLIBN)"
  },
  {
   value: "Jablonna (PLJLA)",
   label: "Jablonna (PLJLA)"
  },
  {
   value: "Jablonna Lacka (PLOZQ)",
   label: "Jablonna Lacka (PLOZQ)"
  },
  {
   value: "Jablonowo Pomorskie (PLJBL)",
   label: "Jablonowo Pomorskie (PLJBL)"
  },
  {
   value: "Jaktorów (PLJKR)",
   label: "Jaktorów (PLJKR)"
  },
  {
   value: "Janikowo (PLJAO)",
   label: "Janikowo (PLJAO)"
  },
  {
   value: "Janki (PLJKI)",
   label: "Janki (PLJKI)"
  },
  {
   value: "Janów (PLJNW)",
   label: "Janów (PLJNW)"
  },
  {
   value: "Janów Lubelski (PLJWL)",
   label: "Janów Lubelski (PLJWL)"
  },
  {
   value: "Janów Podlaski (PLJWP)",
   label: "Janów Podlaski (PLJWP)"
  },
  {
   value: "Janów, Katowice (PLJNO)",
   label: "Janów, Katowice (PLJNO)"
  },
  {
   value: "Jarocin (PLJON)",
   label: "Jarocin (PLJON)"
  },
  {
   value: "Jarosty (PLIKE)",
   label: "Jarosty (PLIKE)"
  },
  {
   value: "Jasienica (PLJAA)",
   label: "Jasienica (PLJAA)"
  },
  {
   value: "Jasieniec, Grojec (PLJAI)",
   label: "Jasieniec, Grojec (PLJAI)"
  },
  {
   value: "Jasionka (PLJSK)",
   label: "Jasionka (PLJSK)"
  },
  {
   value: "Jaslo (PLJAS)",
   label: "Jaslo (PLJAS)"
  },
  {
   value: "Jastarnia (PLJAT)",
   label: "Jastarnia (PLJAT)"
  },
  {
   value: "Jastków (PLJTW)",
   label: "Jastków (PLJTW)"
  },
  {
   value: "Jawor (PLJWR)",
   label: "Jawor (PLJWR)"
  },
  {
   value: "Jaworze (PLJWE)",
   label: "Jaworze (PLJWE)"
  },
  {
   value: "Jaworzno (PLJAW)",
   label: "Jaworzno (PLJAW)"
  },
  {
   value: "Jaworzno (PLJWO)",
   label: "Jaworzno (PLJWO)"
  },
  {
   value: "Jaworzyna Slaska (PLJWS)",
   label: "Jaworzyna Slaska (PLJWS)"
  },
  {
   value: "Jedlinsk (PLJDL)",
   label: "Jedlinsk (PLJDL)"
  },
  {
   value: "Jedlno (PLOZT)",
   label: "Jedlno (PLOZT)"
  },
  {
   value: "Jednorozec (PLOZS)",
   label: "Jednorozec (PLOZS)"
  },
  {
   value: "Jedrzejow (PLJZW)",
   label: "Jedrzejow (PLJZW)"
  },
  {
   value: "Jelcz-Laskowice (PLJLE)",
   label: "Jelcz-Laskowice (PLJLE)"
  },
  {
   value: "Jelenia Góra (PLJEG)",
   label: "Jelenia Góra (PLJEG)"
  },
  {
   value: "Jelonek (PLJNK)",
   label: "Jelonek (PLJNK)"
  },
  {
   value: "Jerka (PLJKA)",
   label: "Jerka (PLJKA)"
  },
  {
   value: "Jezewo (PLJEZ)",
   label: "Jezewo (PLJEZ)"
  },
  {
   value: "Jeziorzany (PLJZY)",
   label: "Jeziorzany (PLJZY)"
  },
  {
   value: "Jezów Sudecki (PLJZS)",
   label: "Jezów Sudecki (PLJZS)"
  },
  {
   value: "Jordanów (PLJDO)",
   label: "Jordanów (PLJDO)"
  },
  {
   value: "Józefoslaw\/Piaseczno (PLJOE)",
   label: "Józefoslaw\/Piaseczno (PLJOE)"
  },
  {
   value: "Józefów (PLJOZ)",
   label: "Józefów (PLJOZ)"
  },
  {
   value: "Jurata (PLJRT)",
   label: "Jurata (PLJRT)"
  },
  {
   value: "Jutrosin (PLJTO)",
   label: "Jutrosin (PLJTO)"
  },
  {
   value: "Kalwaria Zebrzydowska (PLKZD)",
   label: "Kalwaria Zebrzydowska (PLKZD)"
  },
  {
   value: "Kamien Pomorski (PLKPI)",
   label: "Kamien Pomorski (PLKPI)"
  },
  {
   value: "Kamienica Królewska (PLKKW)",
   label: "Kamienica Królewska (PLKKW)"
  },
  {
   value: "Kamieniec (PLKMC)",
   label: "Kamieniec (PLKMC)"
  },
  {
   value: "Kamieniec Wroclawski (PLKAW)",
   label: "Kamieniec Wroclawski (PLKAW)"
  },
  {
   value: "Kampinos (PLKPS)",
   label: "Kampinos (PLKPS)"
  },
  {
   value: "Kanczuga (PLKCZ)",
   label: "Kanczuga (PLKCZ)"
  },
  {
   value: "Kanie (PLKNM)",
   label: "Kanie (PLKNM)"
  },
  {
   value: "Kapino (PLKAP)",
   label: "Kapino (PLKAP)"
  },
  {
   value: "Karczew (PLOZU)",
   label: "Karczew (PLOZU)"
  },
  {
   value: "Kargowa (PLOZF)",
   label: "Kargowa (PLOZF)"
  },
  {
   value: "Karlikowo (PLKAJ)",
   label: "Karlikowo (PLKAJ)"
  },
  {
   value: "Karlino (PLKNQ)",
   label: "Karlino (PLKNQ)"
  },
  {
   value: "Karlowice (PLKWE)",
   label: "Karlowice (PLKWE)"
  },
  {
   value: "Kartuzy (PLKTZ)",
   label: "Kartuzy (PLKTZ)"
  },
  {
   value: "Katy Wroclawskie (PLKYW)",
   label: "Katy Wroclawskie (PLKYW)"
  },
  {
   value: "Kawcze (PLKWC)",
   label: "Kawcze (PLKWC)"
  },
  {
   value: "Kazimierz (PLKAZ)",
   label: "Kazimierz (PLKAZ)"
  },
  {
   value: "Kedrzyno (PLOZX)",
   label: "Kedrzyno (PLOZX)"
  },
  {
   value: "Kedzierzyn Kozle (PLKDK)",
   label: "Kedzierzyn Kozle (PLKDK)"
  },
  {
   value: "Kedzierzyn-Kozle (PLKEK)",
   label: "Kedzierzyn-Kozle (PLKEK)"
  },
  {
   value: "Kepno (PLKEP)",
   label: "Kepno (PLKEP)"
  },
  {
   value: "Kety (PLKTY)",
   label: "Kety (PLKTY)"
  },
  {
   value: "Kiekrz (PLKKR)",
   label: "Kiekrz (PLKKR)"
  },
  {
   value: "Kielcze Stare (PLKSW)",
   label: "Kielcze Stare (PLKSW)"
  },
  {
   value: "Kielczów (PLKIL)",
   label: "Kielczów (PLKIL)"
  },
  {
   value: "Kijow (PLKIJ)",
   label: "Kijow (PLKIJ)"
  },
  {
   value: "Kiszkowo (PLKIS)",
   label: "Kiszkowo (PLKIS)"
  },
  {
   value: "Kleszczewo (PLKZO)",
   label: "Kleszczewo (PLKZO)"
  },
  {
   value: "Kleszczów (PLKLE)",
   label: "Kleszczów (PLKLE)"
  },
  {
   value: "Klimontów (PLKLW)",
   label: "Klimontów (PLKLW)"
  },
  {
   value: "Klobuck (PLKBU)",
   label: "Klobuck (PLKBU)"
  },
  {
   value: "Kloczew (PLOXF)",
   label: "Kloczew (PLOXF)"
  },
  {
   value: "Knurow (PLKNU)",
   label: "Knurow (PLKNU)"
  },
  {
   value: "Kobierno (PLOZV)",
   label: "Kobierno (PLOZV)"
  },
  {
   value: "Kobierzyce (PLKYE)",
   label: "Kobierzyce (PLKYE)"
  },
  {
   value: "Kobylanka (PLKLA)",
   label: "Kobylanka (PLKLA)"
  },
  {
   value: "Kobylany (PLKBL)",
   label: "Kobylany (PLKBL)"
  },
  {
   value: "Kobylin (PLKBY)",
   label: "Kobylin (PLKBY)"
  },
  {
   value: "Kobylka (PLKOA)",
   label: "Kobylka (PLKOA)"
  },
  {
   value: "Kobylnica (PLKBN)",
   label: "Kobylnica (PLKBN)"
  },
  {
   value: "Kolbudy Dolne (PLOYA)",
   label: "Kolbudy Dolne (PLOYA)"
  },
  {
   value: "Kolbuszowa (PLKZA)",
   label: "Kolbuszowa (PLKZA)"
  },
  {
   value: "Kolczyglowy (PLKLG)",
   label: "Kolczyglowy (PLKLG)"
  },
  {
   value: "Koleczkowo (PLKOE)",
   label: "Koleczkowo (PLKOE)"
  },
  {
   value: "Kolno (PLKLN)",
   label: "Kolno (PLKLN)"
  },
  {
   value: "Kolno (PLKNO)",
   label: "Kolno (PLKNO)"
  },
  {
   value: "Koluszki (PLKLS)",
   label: "Koluszki (PLKLS)"
  },
  {
   value: "Komorniki (PLWPK)",
   label: "Komorniki (PLWPK)"
  },
  {
   value: "Komorowice (PLKOM)",
   label: "Komorowice (PLKOM)"
  },
  {
   value: "Koneck (PLKNK)",
   label: "Koneck (PLKNK)"
  },
  {
   value: "Konin (PLKON)",
   label: "Konin (PLKON)"
  },
  {
   value: "Konopiska (PLKOI)",
   label: "Konopiska (PLKOI)"
  },
  {
   value: "Konskie (PLKSE)",
   label: "Konskie (PLKSE)"
  },
  {
   value: "Konstancin-Jeziorna (PLOYU)",
   label: "Konstancin-Jeziorna (PLOYU)"
  },
  {
   value: "Konstantcin (PLKNS)",
   label: "Konstantcin (PLKNS)"
  },
  {
   value: "Konstantynów Lódzki (PLKWL)",
   label: "Konstantynów Lódzki (PLKWL)"
  },
  {
   value: "Kopytów (PLKOP)",
   label: "Kopytów (PLKOP)"
  },
  {
   value: "Kórnik (PLKRI)",
   label: "Kórnik (PLKRI)"
  },
  {
   value: "Koronowo (PLKOO)",
   label: "Koronowo (PLKOO)"
  },
  {
   value: "Koroszczyn (PLKOR)",
   label: "Koroszczyn (PLKOR)"
  },
  {
   value: "Korsze (PLKSZ)",
   label: "Korsze (PLKSZ)"
  },
  {
   value: "Korycin (PLKYC)",
   label: "Korycin (PLKYC)"
  },
  {
   value: "Korzybie (PLKZB)",
   label: "Korzybie (PLKZB)"
  },
  {
   value: "Kosakowo (PLKKO)",
   label: "Kosakowo (PLKKO)"
  },
  {
   value: "Koscian (PLKSC)",
   label: "Koscian (PLKSC)"
  },
  {
   value: "Kostrzyn (PLKZY)",
   label: "Kostrzyn (PLKZY)"
  },
  {
   value: "Kowal (PLOYE)",
   label: "Kowal (PLOYE)"
  },
  {
   value: "Kowala Stepocina (PLKAA)",
   label: "Kowala Stepocina (PLKAA)"
  },
  {
   value: "Kowalewo Pomorskie (PLKPM)",
   label: "Kowalewo Pomorskie (PLKPM)"
  },
  {
   value: "Kozieglowy (PLKGY)",
   label: "Kozieglowy (PLKGY)"
  },
  {
   value: "Kozienice (PLKZE)",
   label: "Kozienice (PLKZE)"
  },
  {
   value: "Kozmin, Krotoszyn (PLKZN)",
   label: "Kozmin, Krotoszyn (PLKZN)"
  },
  {
   value: "Kozminiec (PLKZM)",
   label: "Kozminiec (PLKZM)"
  },
  {
   value: "Kozuchów (PLKZU)",
   label: "Kozuchów (PLKZU)"
  },
  {
   value: "Kozy (PLKOZ)",
   label: "Kozy (PLKOZ)"
  },
  {
   value: "Krapkowice (PLKKE)",
   label: "Krapkowice (PLKKE)"
  },
  {
   value: "Krasnik (PLKRS)",
   label: "Krasnik (PLKRS)"
  },
  {
   value: "Krasocin (PLKCN)",
   label: "Krasocin (PLKCN)"
  },
  {
   value: "Krerowo (PLKRW)",
   label: "Krerowo (PLKRW)"
  },
  {
   value: "Krobia (PLRIA)",
   label: "Krobia (PLRIA)"
  },
  {
   value: "Krokowa (PLKOK)",
   label: "Krokowa (PLKOK)"
  },
  {
   value: "Kroscienko (PLKRC)",
   label: "Kroscienko (PLKRC)"
  },
  {
   value: "Krosniewice (PLLRK)",
   label: "Krosniewice (PLLRK)"
  },
  {
   value: "Krosno Odrzanskie (PLKOD)",
   label: "Krosno Odrzanskie (PLKOD)"
  },
  {
   value: "Kruszow (PLOYF)",
   label: "Kruszow (PLOYF)"
  },
  {
   value: "Kruszwica (PLKZI)",
   label: "Kruszwica (PLKZI)"
  },
  {
   value: "Krynica (PLKRY)",
   label: "Krynica (PLKRY)"
  },
  {
   value: "Krynica Morska (PLKMR)",
   label: "Krynica Morska (PLKMR)"
  },
  {
   value: "Krynica Morska (PLKRM)",
   label: "Krynica Morska (PLKRM)"
  },
  {
   value: "Krzeszów (PLKZW)",
   label: "Krzeszów (PLKZW)"
  },
  {
   value: "Krzeszowice (PLKZC)",
   label: "Krzeszowice (PLKZC)"
  },
  {
   value: "Krzewie (PLKRE)",
   label: "Krzewie (PLKRE)"
  },
  {
   value: "Krzy| (PLKYZ)",
   label: "Krzy| (PLKYZ)"
  },
  {
   value: "Krzymów (PLKYM)",
   label: "Krzymów (PLKYM)"
  },
  {
   value: "Krzyszkowice (PLKZK)",
   label: "Krzyszkowice (PLKZK)"
  },
  {
   value: "Krzywin (PLKYN)",
   label: "Krzywin (PLKYN)"
  },
  {
   value: "Krzyz (PLKRZ)",
   label: "Krzyz (PLKRZ)"
  },
  {
   value: "Krzyz (PLKZZ)",
   label: "Krzyz (PLKZZ)"
  },
  {
   value: "Ksawerów (PLKWO)",
   label: "Ksawerów (PLKWO)"
  },
  {
   value: "Ksiaz Wielkopolsk (PLOYC)",
   label: "Ksiaz Wielkopolsk (PLOYC)"
  },
  {
   value: "Kudowa-Zdrój (PLKDZ)",
   label: "Kudowa-Zdrój (PLKDZ)"
  },
  {
   value: "Kukinia (PLOZY)",
   label: "Kukinia (PLOZY)"
  },
  {
   value: "Kulesze Koscielne (PLOYD)",
   label: "Kulesze Koscielne (PLOYD)"
  },
  {
   value: "Kupienino (PLKPN)",
   label: "Kupienino (PLKPN)"
  },
  {
   value: "Kurow (PLKOW)",
   label: "Kurow (PLKOW)"
  },
  {
   value: "Kurznie (PLKUE)",
   label: "Kurznie (PLKUE)"
  },
  {
   value: "Ladna (PLLDN)",
   label: "Ladna (PLLDN)"
  },
  {
   value: "Lancut (PLLAN)",
   label: "Lancut (PLLAN)"
  },
  {
   value: "Lapy (PLLPY)",
   label: "Lapy (PLLPY)"
  },
  {
   value: "Lask (PLLSK)",
   label: "Lask (PLLSK)"
  },
  {
   value: "Laskarzew (PLLZW)",
   label: "Laskarzew (PLLZW)"
  },
  {
   value: "Laskowice (PLLAS)",
   label: "Laskowice (PLLAS)"
  },
  {
   value: "Laszczów (PLLSO)",
   label: "Laszczów (PLLSO)"
  },
  {
   value: "Latowice (PLLAT)",
   label: "Latowice (PLLAT)"
  },
  {
   value: "Laziska (PLLAZ)",
   label: "Laziska (PLLAZ)"
  },
  {
   value: "Leba (PLLEA)",
   label: "Leba (PLLEA)"
  },
  {
   value: "Lebork (PLLEB)",
   label: "Lebork (PLLEB)"
  },
  {
   value: "Leczyca (PLLZY)",
   label: "Leczyca (PLLZY)"
  },
  {
   value: "Ledowo (PLLED)",
   label: "Ledowo (PLLED)"
  },
  {
   value: "Legionowo (PLLGO)",
   label: "Legionowo (PLLGO)"
  },
  {
   value: "Legowo (PLLGW)",
   label: "Legowo (PLLGW)"
  },
  {
   value: "Leka (PLLKA)",
   label: "Leka (PLLKA)"
  },
  {
   value: "Lekawica (PLLEJ)",
   label: "Lekawica (PLLEJ)"
  },
  {
   value: "Lesko (PLLEO)",
   label: "Lesko (PLLEO)"
  },
  {
   value: "Leszno (PLLEZ)",
   label: "Leszno (PLLEZ)"
  },
  {
   value: "Leszno (PLLZN)",
   label: "Leszno (PLLZN)"
  },
  {
   value: "Lezajsk (PLLEK)",
   label: "Lezajsk (PLLEK)"
  },
  {
   value: "Lidzbark Warminski (PLLIW)",
   label: "Lidzbark Warminski (PLLIW)"
  },
  {
   value: "Limanowa (PLLMA)",
   label: "Limanowa (PLLMA)"
  },
  {
   value: "Lipiany (PLLPN)",
   label: "Lipiany (PLLPN)"
  },
  {
   value: "Lipinki Luzyckie (PLLKK)",
   label: "Lipinki Luzyckie (PLLKK)"
  },
  {
   value: "Lipnik (PLOYG)",
   label: "Lipnik (PLOYG)"
  },
  {
   value: "Lipno (PLLIP)",
   label: "Lipno (PLLIP)"
  },
  {
   value: "Lipsko (PLLAP)",
   label: "Lipsko (PLLAP)"
  },
  {
   value: "Lisewo (PLLWO)",
   label: "Lisewo (PLLWO)"
  },
  {
   value: "Lobez (PLLOB)",
   label: "Lobez (PLLOB)"
  },
  {
   value: "Lochów (PLLOC)",
   label: "Lochów (PLLOC)"
  },
  {
   value: "Lomianki (PLLOK)",
   label: "Lomianki (PLLOK)"
  },
  {
   value: "Lomza (PLQOY)",
   label: "Lomza (PLQOY)"
  },
  {
   value: "Losice (PLLOS)",
   label: "Losice (PLLOS)"
  },
  {
   value: "Lowiczek (PLLWZ)",
   label: "Lowiczek (PLLWZ)"
  },
  {
   value: "Lowyn (PLLWY)",
   label: "Lowyn (PLLWY)"
  },
  {
   value: "Loza (PLLZA)",
   label: "Loza (PLLZA)"
  },
  {
   value: "Loziska (PLOXT)",
   label: "Loziska (PLOXT)"
  },
  {
   value: "Luban (PLLBN)",
   label: "Luban (PLLBN)"
  },
  {
   value: "Lubasz (PLLBA)",
   label: "Lubasz (PLLBA)"
  },
  {
   value: "Lubenia (PLLNA)",
   label: "Lubenia (PLLNA)"
  },
  {
   value: "Lubicz (PLLBC)",
   label: "Lubicz (PLLBC)"
  },
  {
   value: "Lubin (PLLUN)",
   label: "Lubin (PLLUN)"
  },
  {
   value: "Lubiszewo (PLLBS)",
   label: "Lubiszewo (PLLBS)"
  },
  {
   value: "Lubiszewo (PLLBZ)",
   label: "Lubiszewo (PLLBZ)"
  },
  {
   value: "Lubliniec (PLLUC)",
   label: "Lubliniec (PLLUC)"
  },
  {
   value: "Lubomino (PLWNL)",
   label: "Lubomino (PLWNL)"
  },
  {
   value: "Lubsko (PLLBK)",
   label: "Lubsko (PLLBK)"
  },
  {
   value: "Lubycza Królewska (PLLBW)",
   label: "Lubycza Królewska (PLLBW)"
  },
  {
   value: "Ludwikowice Klodzkie (PLLUK)",
   label: "Ludwikowice Klodzkie (PLLUK)"
  },
  {
   value: "Ludwin (PLLDW)",
   label: "Ludwin (PLLDW)"
  },
  {
   value: "Luków (PLLKW)",
   label: "Luków (PLLKW)"
  },
  {
   value: "Lulemino (PLLUM)",
   label: "Lulemino (PLLUM)"
  },
  {
   value: "Lutomiersk (PLLTK)",
   label: "Lutomiersk (PLLTK)"
  },
  {
   value: "Lutynia (PLLTY)",
   label: "Lutynia (PLLTY)"
  },
  {
   value: "Luzino (PLLZO)",
   label: "Luzino (PLLZO)"
  },
  {
   value: "Lyski (PLOZD)",
   label: "Lyski (PLOZD)"
  },
  {
   value: "Lysomice (PLLYS)",
   label: "Lysomice (PLLYS)"
  },
  {
   value: "Lyszkowice (PLLKO)",
   label: "Lyszkowice (PLLKO)"
  },
  {
   value: "Maków Podhalanski (PLMPM)",
   label: "Maków Podhalanski (PLMPM)"
  },
  {
   value: "Malankowo (PLMLK)",
   label: "Malankowo (PLMLK)"
  },
  {
   value: "Malanów (PLMAW)",
   label: "Malanów (PLMAW)"
  },
  {
   value: "Malaszewicze (PLMAA)",
   label: "Malaszewicze (PLMAA)"
  },
  {
   value: "Malechowo (PLMAL)",
   label: "Malechowo (PLMAL)"
  },
  {
   value: "Malinie (PLMAI)",
   label: "Malinie (PLMAI)"
  },
  {
   value: "Malkinia Górna (PLMAG)",
   label: "Malkinia Górna (PLMAG)"
  },
  {
   value: "Marki (PLMKI)",
   label: "Marki (PLMKI)"
  },
  {
   value: "Markuszów (PLMAR)",
   label: "Markuszów (PLMAR)"
  },
  {
   value: "Marynki (PLMRY)",
   label: "Marynki (PLMRY)"
  },
  {
   value: "Medyka (PLMED)",
   label: "Medyka (PLMED)"
  },
  {
   value: "Miasteczko Slaskie (PLMSS)",
   label: "Miasteczko Slaskie (PLMSS)"
  },
  {
   value: "Miastko (PLMKO)",
   label: "Miastko (PLMKO)"
  },
  {
   value: "Michalów (PLMIH)",
   label: "Michalów (PLMIH)"
  },
  {
   value: "Michalowice (PLMIE)",
   label: "Michalowice (PLMIE)"
  },
  {
   value: "Miechów (PLMIC)",
   label: "Miechów (PLMIC)"
  },
  {
   value: "Miedzybórz (PLMDZ)",
   label: "Miedzybórz (PLMDZ)"
  },
  {
   value: "Miedzychód (PLMZD)",
   label: "Miedzychód (PLMZD)"
  },
  {
   value: "Miedzylesie (PLMZY)",
   label: "Miedzylesie (PLMZY)"
  },
  {
   value: "Miedzyrzec Podlaski (PLMPA)",
   label: "Miedzyrzec Podlaski (PLMPA)"
  },
  {
   value: "Miedzyzdroje (PLMID)",
   label: "Miedzyzdroje (PLMID)"
  },
  {
   value: "Miejska Gorka (PLOYH)",
   label: "Miejska Gorka (PLOYH)"
  },
  {
   value: "Mielec (PLMLC)",
   label: "Mielec (PLMLC)"
  },
  {
   value: "Mieslaczkowo (PLOZB)",
   label: "Mieslaczkowo (PLOZB)"
  },
  {
   value: "Mietków (PLMKW)",
   label: "Mietków (PLMKW)"
  },
  {
   value: "Mikolów (PLMIK)",
   label: "Mikolów (PLMIK)"
  },
  {
   value: "Mikstat (PLMKA)",
   label: "Mikstat (PLMKA)"
  },
  {
   value: "Milanowek (PLMLW)",
   label: "Milanowek (PLMLW)"
  },
  {
   value: "Milki (PLMKN)",
   label: "Milki (PLMKN)"
  },
  {
   value: "Milobadz (PLMBZ)",
   label: "Milobadz (PLMBZ)"
  },
  {
   value: "Miloszyce (PLMZE)",
   label: "Miloszyce (PLMZE)"
  },
  {
   value: "Minsk Mazowiecki (PLMIN)",
   label: "Minsk Mazowiecki (PLMIN)"
  },
  {
   value: "Mirków (PLMIR)",
   label: "Mirków (PLMIR)"
  },
  {
   value: "Miroslawiec (PLOYJ)",
   label: "Miroslawiec (PLOYJ)"
  },
  {
   value: "Mlochów (PLMHW)",
   label: "Mlochów (PLMHW)"
  },
  {
   value: "Mniszek (PLMNZ)",
   label: "Mniszek (PLMNZ)"
  },
  {
   value: "Modlinica (PLMIA)",
   label: "Modlinica (PLMIA)"
  },
  {
   value: "Mogielnica (PLMGC)",
   label: "Mogielnica (PLMGC)"
  },
  {
   value: "Mogilno (PLMOG)",
   label: "Mogilno (PLMOG)"
  },
  {
   value: "Monki (PLMNI)",
   label: "Monki (PLMNI)"
  },
  {
   value: "Morawica (PLMWI)",
   label: "Morawica (PLMWI)"
  },
  {
   value: "Morzeszczyn (PLMZN)",
   label: "Morzeszczyn (PLMZN)"
  },
  {
   value: "Mosciska (PLMCA)",
   label: "Mosciska (PLMCA)"
  },
  {
   value: "Mosina (PLMOS)",
   label: "Mosina (PLMOS)"
  },
  {
   value: "Moszczenica (PLMSZ)",
   label: "Moszczenica (PLMSZ)"
  },
  {
   value: "Motycz (PLMTZ)",
   label: "Motycz (PLMTZ)"
  },
  {
   value: "Mragowo (PLMRA)",
   label: "Mragowo (PLMRA)"
  },
  {
   value: "Mroczen (PLMRC)",
   label: "Mroczen (PLMRC)"
  },
  {
   value: "Mroków (PLMRO)",
   label: "Mroków (PLMRO)"
  },
  {
   value: "Mrowla (PLMWA)",
   label: "Mrowla (PLMWA)"
  },
  {
   value: "Mrozy (PLMRZ)",
   label: "Mrozy (PLMRZ)"
  },
  {
   value: "Mszana Dolna (PLMSD)",
   label: "Mszana Dolna (PLMSD)"
  },
  {
   value: "Mszczonów (PLMSW)",
   label: "Mszczonów (PLMSW)"
  },
  {
   value: "Murow (PLOJK)",
   label: "Murow (PLOJK)"
  },
  {
   value: "Muszyna (PLMYA)",
   label: "Muszyna (PLMYA)"
  },
  {
   value: "Mykanów (PLMNO)",
   label: "Mykanów (PLMNO)"
  },
  {
   value: "Myslenice (PLMYC)",
   label: "Myslenice (PLMYC)"
  },
  {
   value: "Mysliborz (PLMYZ)",
   label: "Mysliborz (PLMYZ)"
  },
  {
   value: "Myszków (PLMZW)",
   label: "Myszków (PLMZW)"
  },
  {
   value: "Nadarzyn (PLNDZ)",
   label: "Nadarzyn (PLNDZ)"
  },
  {
   value: "Nadolice Wielkie (PLNAW)",
   label: "Nadolice Wielkie (PLNAW)"
  },
  {
   value: "Naleczow (PLNZW)",
   label: "Naleczow (PLNZW)"
  },
  {
   value: "Namyslow (PLNAM)",
   label: "Namyslow (PLNAM)"
  },
  {
   value: "Namyslów (PLNSW)",
   label: "Namyslów (PLNSW)"
  },
  {
   value: "Narew (PLOYK)",
   label: "Narew (PLOYK)"
  },
  {
   value: "Narzym (PLOYP)",
   label: "Narzym (PLOYP)"
  },
  {
   value: "Nasielsk (PLNLL)",
   label: "Nasielsk (PLNLL)"
  },
  {
   value: "Nekla (PLNEK)",
   label: "Nekla (PLNEK)"
  },
  {
   value: "Nidzica (PLNID)",
   label: "Nidzica (PLNID)"
  },
  {
   value: "Niechlow (PLOYL)",
   label: "Niechlow (PLOYL)"
  },
  {
   value: "Niedomice (PLNIE)",
   label: "Niedomice (PLNIE)"
  },
  {
   value: "Nieledew (PLNLD)",
   label: "Nieledew (PLNLD)"
  },
  {
   value: "Niemce (PLNMC)",
   label: "Niemce (PLNMC)"
  },
  {
   value: "Niemodlin (PLNMN)",
   label: "Niemodlin (PLNMN)"
  },
  {
   value: "Nowa Brzeznica (PLNWB)",
   label: "Nowa Brzeznica (PLNWB)"
  },
  {
   value: "Nowa Sarzyna (PLNSZ)",
   label: "Nowa Sarzyna (PLNSZ)"
  },
  {
   value: "Nowa Sól (PLNOS)",
   label: "Nowa Sól (PLNOS)"
  },
  {
   value: "Nowa Wies (PLNWI)",
   label: "Nowa Wies (PLNWI)"
  },
  {
   value: "Nowa Wies Wielka (PLOYO)",
   label: "Nowa Wies Wielka (PLOYO)"
  },
  {
   value: "Nowa Wies Wroclawska (PLNWW)",
   label: "Nowa Wies Wroclawska (PLNWW)"
  },
  {
   value: "Nowe (PLNOE)",
   label: "Nowe (PLNOE)"
  },
  {
   value: "Nowe Marzy (PLNMA)",
   label: "Nowe Marzy (PLNMA)"
  },
  {
   value: "Nowe Miasto nad Warta (PLOYN)",
   label: "Nowe Miasto nad Warta (PLOYN)"
  },
  {
   value: "Nowe Skalmierzyce (PLNSY)",
   label: "Nowe Skalmierzyce (PLNSY)"
  },
  {
   value: "Nowe Warpno (PLNWA)",
   label: "Nowe Warpno (PLNWA)"
  },
  {
   value: "Nowogard (PLNGD)",
   label: "Nowogard (PLNGD)"
  },
  {
   value: "Nowogrod Bobrzanski (PLNOB)",
   label: "Nowogrod Bobrzanski (PLNOB)"
  },
  {
   value: "Nowy Dwór Mazowiecki (PLNWY)",
   label: "Nowy Dwór Mazowiecki (PLNWY)"
  },
  {
   value: "Nowy Sacz (PLNWS)",
   label: "Nowy Sacz (PLNWS)"
  },
  {
   value: "Nowy Targ (PLNTG)",
   label: "Nowy Targ (PLNTG)"
  },
  {
   value: "Nowy Targ (PLNWG)",
   label: "Nowy Targ (PLNWG)"
  },
  {
   value: "Nowy Tomysl (PLNYT)",
   label: "Nowy Tomysl (PLNYT)"
  },
  {
   value: "Nysa (PLNYS)",
   label: "Nysa (PLNYS)"
  },
  {
   value: "Oborniki (PLOBN)",
   label: "Oborniki (PLOBN)"
  },
  {
   value: "Oborniki Slaskie (PLOBS)",
   label: "Oborniki Slaskie (PLOBS)"
  },
  {
   value: "Obrzycko (PLOBR)",
   label: "Obrzycko (PLOBR)"
  },
  {
   value: "Ochotnica Dolna (PLODN)",
   label: "Ochotnica Dolna (PLODN)"
  },
  {
   value: "Ociaz (PLOYQ)",
   label: "Ociaz (PLOYQ)"
  },
  {
   value: "Odolanów (PLODO)",
   label: "Odolanów (PLODO)"
  },
  {
   value: "Ogorzeliny (PLOGO)",
   label: "Ogorzeliny (PLOGO)"
  },
  {
   value: "Oklesna (PLOKL)",
   label: "Oklesna (PLOKL)"
  },
  {
   value: "Okocim (PLOKO)",
   label: "Okocim (PLOKO)"
  },
  {
   value: "Okonek (PLOKN)",
   label: "Okonek (PLOKN)"
  },
  {
   value: "Oksa (PLOKS)",
   label: "Oksa (PLOKS)"
  },
  {
   value: "Olawa (PLOLA)",
   label: "Olawa (PLOLA)"
  },
  {
   value: "Olesnica (PLOLE)",
   label: "Olesnica (PLOLE)"
  },
  {
   value: "Olesno (PLOLN)",
   label: "Olesno (PLOLN)"
  },
  {
   value: "Olkusz (PLOKZ)",
   label: "Olkusz (PLOKZ)"
  },
  {
   value: "Olsztynek (PLZTY)",
   label: "Olsztynek (PLZTY)"
  },
  {
   value: "Oltarzew (PLOLR)",
   label: "Oltarzew (PLOLR)"
  },
  {
   value: "Opalenica (PLOPL)",
   label: "Opalenica (PLOPL)"
  },
  {
   value: "Opatówek (PLOPT)",
   label: "Opatówek (PLOPT)"
  },
  {
   value: "Opoczno (PLOPZ)",
   label: "Opoczno (PLOPZ)"
  },
  {
   value: "Orle (PLORL)",
   label: "Orle (PLORL)"
  },
  {
   value: "Orzechowo (PLORZ)",
   label: "Orzechowo (PLORZ)"
  },
  {
   value: "Orzesze (PLOZE)",
   label: "Orzesze (PLOZE)"
  },
  {
   value: "Osielsko (PLOLO)",
   label: "Osielsko (PLOLO)"
  },
  {
   value: "Osno Lubuskie (PLOLB)",
   label: "Osno Lubuskie (PLOLB)"
  },
  {
   value: "Ostroleka (PLOSS)",
   label: "Ostroleka (PLOSS)"
  },
  {
   value: "Ostromecko (PLOSM)",
   label: "Ostromecko (PLOSM)"
  },
  {
   value: "Ostrów Mazowiecka (PLOSJ)",
   label: "Ostrów Mazowiecka (PLOSJ)"
  },
  {
   value: "Ostrowiec Swietokrzyski (PLOSR)",
   label: "Ostrowiec Swietokrzyski (PLOSR)"
  },
  {
   value: "Ostrzeszów (PLOZW)",
   label: "Ostrzeszów (PLOZW)"
  },
  {
   value: "Oswiecim (PLOSW)",
   label: "Oswiecim (PLOSW)"
  },
  {
   value: "Otmuchów (PLOMW)",
   label: "Otmuchów (PLOMW)"
  },
  {
   value: "Otowice (PLOTO)",
   label: "Otowice (PLOTO)"
  },
  {
   value: "Otwock (PLOTW)",
   label: "Otwock (PLOTW)"
  },
  {
   value: "Owinska (PLOWA)",
   label: "Owinska (PLOWA)"
  },
  {
   value: "Ozarów Mazowiecki (PLOZM)",
   label: "Ozarów Mazowiecki (PLOZM)"
  },
  {
   value: "Ozarowice (PLOZR)",
   label: "Ozarowice (PLOZR)"
  },
  {
   value: "Ozimek (PLOZI)",
   label: "Ozimek (PLOZI)"
  },
  {
   value: "Ozorków (PLOKW)",
   label: "Ozorków (PLOKW)"
  },
  {
   value: "Pabianice (PLPAI)",
   label: "Pabianice (PLPAI)"
  },
  {
   value: "Paczkowo (PLPAC)",
   label: "Paczkowo (PLPAC)"
  },
  {
   value: "Pakosc (PLPAK)",
   label: "Pakosc (PLPAK)"
  },
  {
   value: "Paledzie (PLPAD)",
   label: "Paledzie (PLPAD)"
  },
  {
   value: "Panki, Janów (PLPNI)",
   label: "Panki, Janów (PLPNI)"
  },
  {
   value: "Parowa (PLPAR)",
   label: "Parowa (PLPAR)"
  },
  {
   value: "Parszów (PLPAW)",
   label: "Parszów (PLPAW)"
  },
  {
   value: "Partynia (PLOYR)",
   label: "Partynia (PLOYR)"
  },
  {
   value: "Paslek (PLPSK)",
   label: "Paslek (PLPSK)"
  },
  {
   value: "Pawlów (PLPAL)",
   label: "Pawlów (PLPAL)"
  },
  {
   value: "Pawlowice (PLPWI)",
   label: "Pawlowice (PLPWI)"
  },
  {
   value: "Pcim (PLPCM)",
   label: "Pcim (PLPCM)"
  },
  {
   value: "Pecice (PLPEC)",
   label: "Pecice (PLPEC)"
  },
  {
   value: "Pelczyce (PLPCZ)",
   label: "Pelczyce (PLPCZ)"
  },
  {
   value: "Piaseczno (PLPIA)",
   label: "Piaseczno (PLPIA)"
  },
  {
   value: "Piastów (PLPSS)",
   label: "Piastów (PLPSS)"
  },
  {
   value: "Piatek Maly (PLPIM)",
   label: "Piatek Maly (PLPIM)"
  },
  {
   value: "Piekary Slaskie (PLPIS)",
   label: "Piekary Slaskie (PLPIS)"
  },
  {
   value: "Pieszyce (PLPZE)",
   label: "Pieszyce (PLPZE)"
  },
  {
   value: "Pilawa (PLPWA)",
   label: "Pilawa (PLPWA)"
  },
  {
   value: "Pilawa Górna (PLPIG)",
   label: "Pilawa Górna (PLPIG)"
  },
  {
   value: "Pilica (PLPLI)",
   label: "Pilica (PLPLI)"
  },
  {
   value: "Pilzno (PLPZO)",
   label: "Pilzno (PLPZO)"
  },
  {
   value: "Pionki (PLPKI)",
   label: "Pionki (PLPKI)"
  },
  {
   value: "Piotrków Kujawski (PLPIK)",
   label: "Piotrków Kujawski (PLPIK)"
  },
  {
   value: "Piotrków Trybunalski (PLPIT)",
   label: "Piotrków Trybunalski (PLPIT)"
  },
  {
   value: "Pisarzowice (PLPIW)",
   label: "Pisarzowice (PLPIW)"
  },
  {
   value: "Pisz (PLPIZ)",
   label: "Pisz (PLPIZ)"
  },
  {
   value: "Piwniczna (PLPIN)",
   label: "Piwniczna (PLPIN)"
  },
  {
   value: "Pleszew (PLPZW)",
   label: "Pleszew (PLPZW)"
  },
  {
   value: "Plewiska (PLPLE)",
   label: "Plewiska (PLPLE)"
  },
  {
   value: "Plizin (PLPZI)",
   label: "Plizin (PLPZI)"
  },
  {
   value: "Plonsk (PLPLK)",
   label: "Plonsk (PLPLK)"
  },
  {
   value: "Ploxo (PLOXO)",
   label: "Ploxo (PLOXO)"
  },
  {
   value: "Pniewy (PLPNY)",
   label: "Pniewy (PLPNY)"
  },
  {
   value: "PoBaniec (PLPOC)",
   label: "PoBaniec (PLPOC)"
  },
  {
   value: "Pobiedziska (PLPBA)",
   label: "Pobiedziska (PLPBA)"
  },
  {
   value: "Poczesna (PLPOE)",
   label: "Poczesna (PLPOE)"
  },
  {
   value: "Podanin (PLPOD)",
   label: "Podanin (PLPOD)"
  },
  {
   value: "Poddebice (PLPBI)",
   label: "Poddebice (PLPBI)"
  },
  {
   value: "Podrózna (PLPDZ)",
   label: "Podrózna (PLPDZ)"
  },
  {
   value: "Pogódki (PLPGK)",
   label: "Pogódki (PLPGK)"
  },
  {
   value: "Pokój (PLPKJ)",
   label: "Pokój (PLPKJ)"
  },
  {
   value: "Polanica-Zdrój (PLPOL)",
   label: "Polanica-Zdrój (PLPOL)"
  },
  {
   value: "Polaniec (PLPNC)",
   label: "Polaniec (PLPNC)"
  },
  {
   value: "Polchowo (PLPCH)",
   label: "Polchowo (PLPCH)"
  },
  {
   value: "Polczyn Zdroj (PLOXN)",
   label: "Polczyn Zdroj (PLOXN)"
  },
  {
   value: "Polczyn-Zdrój (PLPZJ)",
   label: "Polczyn-Zdrój (PLPZJ)"
  },
  {
   value: "Policzna (PLOYB)",
   label: "Policzna (PLOYB)"
  },
  {
   value: "Pomiechówek (PLPOM)",
   label: "Pomiechówek (PLPOM)"
  },
  {
   value: "Poniatowa (PLPTA)",
   label: "Poniatowa (PLPTA)"
  },
  {
   value: "Poniec (PLWSK)",
   label: "Poniec (PLWSK)"
  },
  {
   value: "Poraj (PLPOR)",
   label: "Poraj (PLPOR)"
  },
  {
   value: "Poreba (PLPRB)",
   label: "Poreba (PLPRB)"
  },
  {
   value: "Poronin (PLPON)",
   label: "Poronin (PLPON)"
  },
  {
   value: "Postoliska (PLPST)",
   label: "Postoliska (PLPST)"
  },
  {
   value: "Poswietne (PLPOS)",
   label: "Poswietne (PLPOS)"
  },
  {
   value: "Powidz (PLPWD)",
   label: "Powidz (PLPWD)"
  },
  {
   value: "Prabuty (PLPRA)",
   label: "Prabuty (PLPRA)"
  },
  {
   value: "Proboszczewice (PLPRO)",
   label: "Proboszczewice (PLPRO)"
  },
  {
   value: "Prószków (PLPKW)",
   label: "Prószków (PLPKW)"
  },
  {
   value: "Pruszcz Gdanski (PLPZG)",
   label: "Pruszcz Gdanski (PLPZG)"
  },
  {
   value: "Pruszkow (PLPZK)",
   label: "Pruszkow (PLPZK)"
  },
  {
   value: "Przasnysz (PLPSY)",
   label: "Przasnysz (PLPSY)"
  },
  {
   value: "Przechlewo (PLPWO)",
   label: "Przechlewo (PLPWO)"
  },
  {
   value: "Przeworsk (PLPWK)",
   label: "Przeworsk (PLPWK)"
  },
  {
   value: "Przezmierowo (PLPEO)",
   label: "Przezmierowo (PLPEO)"
  },
  {
   value: "Przezmierowo (PLPZZ)",
   label: "Przezmierowo (PLPZZ)"
  },
  {
   value: "Przyjazn (PLOYT)",
   label: "Przyjazn (PLOYT)"
  },
  {
   value: "Przykona (PLOYS)",
   label: "Przykona (PLOYS)"
  },
  {
   value: "Psary (PLPSA)",
   label: "Psary (PLPSA)"
  },
  {
   value: "Pszczolki (PLPCI)",
   label: "Pszczolki (PLPCI)"
  },
  {
   value: "Pszczyna (PLPSZ)",
   label: "Pszczyna (PLPSZ)"
  },
  {
   value: "Puck (PLPUC)",
   label: "Puck (PLPUC)"
  },
  {
   value: "Pudliszki (PLZKI)",
   label: "Pudliszki (PLZKI)"
  },
  {
   value: "Pulawy (PLPUL)",
   label: "Pulawy (PLPUL)"
  },
  {
   value: "Pultusk (PLPUT)",
   label: "Pultusk (PLPUT)"
  },
  {
   value: "Pustków (PLPSO)",
   label: "Pustków (PLPSO)"
  },
  {
   value: "Puszczykowo (PLPUS)",
   label: "Puszczykowo (PLPUS)"
  },
  {
   value: "Pyrzowice (PLPYR)",
   label: "Pyrzowice (PLPYR)"
  },
  {
   value: "Pyrzyce (PLRZY)",
   label: "Pyrzyce (PLRZY)"
  },
  {
   value: "Pyzdry (PLPZD)",
   label: "Pyzdry (PLPZD)"
  },
  {
   value: "Raba Nizna (PLRBN)",
   label: "Raba Nizna (PLRBN)"
  },
  {
   value: "Rabka (PLRAB)",
   label: "Rabka (PLRAB)"
  },
  {
   value: "Raciaz (PLRAC)",
   label: "Raciaz (PLRAC)"
  },
  {
   value: "Racula (PLRCA)",
   label: "Racula (PLRCA)"
  },
  {
   value: "Radlin (PLRAL)",
   label: "Radlin (PLRAL)"
  },
  {
   value: "Radomysl Wielki (PLRWK)",
   label: "Radomysl Wielki (PLRWK)"
  },
  {
   value: "Radostowice (PLRAO)",
   label: "Radostowice (PLRAO)"
  },
  {
   value: "Radwanice (PLRDW)",
   label: "Radwanice (PLRDW)"
  },
  {
   value: "Radziejów (PLRZJ)",
   label: "Radziejów (PLRZJ)"
  },
  {
   value: "Radzionków (PLRDZ)",
   label: "Radzionków (PLRDZ)"
  },
  {
   value: "Radzymin (PLRZM)",
   label: "Radzymin (PLRZM)"
  },
  {
   value: "Radzyn Podlaski (PLRAP)",
   label: "Radzyn Podlaski (PLRAP)"
  },
  {
   value: "Rakoniewice (PLRNW)",
   label: "Rakoniewice (PLRNW)"
  },
  {
   value: "Rakszawa (PLOYW)",
   label: "Rakszawa (PLOYW)"
  },
  {
   value: "Raszyn\/Warszawa (PLRYZ)",
   label: "Raszyn\/Warszawa (PLRYZ)"
  },
  {
   value: "Reda (PLRED)",
   label: "Reda (PLRED)"
  },
  {
   value: "Redziny (PLREZ)",
   label: "Redziny (PLREZ)"
  },
  {
   value: "Resko (PLRES)",
   label: "Resko (PLRES)"
  },
  {
   value: "Rogi (PLRGI)",
   label: "Rogi (PLRGI)"
  },
  {
   value: "Rogówiec (PLRGW)",
   label: "Rogówiec (PLRGW)"
  },
  {
   value: "Rogozno (PLROG)",
   label: "Rogozno (PLROG)"
  },
  {
   value: "Rokietnica (PLROI)",
   label: "Rokietnica (PLROI)"
  },
  {
   value: "Rokiskis (PLROK)",
   label: "Rokiskis (PLROK)"
  },
  {
   value: "Ropczyce (PLROP)",
   label: "Ropczyce (PLROP)"
  },
  {
   value: "Rotmanka (PLROT)",
   label: "Rotmanka (PLROT)"
  },
  {
   value: "Rozdrazew (PLROZ)",
   label: "Rozdrazew (PLROZ)"
  },
  {
   value: "Ruchocice (PLRUC)",
   label: "Ruchocice (PLRUC)"
  },
  {
   value: "Rudniki (PLRDN)",
   label: "Rudniki (PLRDN)"
  },
  {
   value: "Rumia (PLRUI)",
   label: "Rumia (PLRUI)"
  },
  {
   value: "Rusiec (PLRUS)",
   label: "Rusiec (PLRUS)"
  },
  {
   value: "Rybie (PLOYV)",
   label: "Rybie (PLOYV)"
  },
  {
   value: "Rybnik (PLRYB)",
   label: "Rybnik (PLRYB)"
  },
  {
   value: "Rydzyna (PLRYD)",
   label: "Rydzyna (PLRYD)"
  },
  {
   value: "Ryki (PLRYK)",
   label: "Ryki (PLRYK)"
  },
  {
   value: "Rymanów (PLRYW)",
   label: "Rymanów (PLRYW)"
  },
  {
   value: "Rypin (PLRYP)",
   label: "Rypin (PLRYP)"
  },
  {
   value: "Rytel (PLRTL)",
   label: "Rytel (PLRTL)"
  },
  {
   value: "Rytro (PLRYT)",
   label: "Rytro (PLRYT)"
  },
  {
   value: "Rzepin (PLRZP)",
   label: "Rzepin (PLRZP)"
  },
  {
   value: "Rzgów (PLRZW)",
   label: "Rzgów (PLRZW)"
  },
  {
   value: "Sadowie (PLSAO)",
   label: "Sadowie (PLSAO)"
  },
  {
   value: "Sandomierz (PLSMA)",
   label: "Sandomierz (PLSMA)"
  },
  {
   value: "Sedziszów Malopolski (PLSED)",
   label: "Sedziszów Malopolski (PLSED)"
  },
  {
   value: "Sekocin Nowy (PLSEO)",
   label: "Sekocin Nowy (PLSEO)"
  },
  {
   value: "Sepólno Krajenskie (PLSEK)",
   label: "Sepólno Krajenskie (PLSEK)"
  },
  {
   value: "Sianów (PLSIW)",
   label: "Sianów (PLSIW)"
  },
  {
   value: "Siechnice (PLSIC)",
   label: "Siechnice (PLSIC)"
  },
  {
   value: "Siedlce (PLSDC)",
   label: "Siedlce (PLSDC)"
  },
  {
   value: "Siekierczyn (PLSKY)",
   label: "Siekierczyn (PLSKY)"
  },
  {
   value: "Siemianowice (PLSOW)",
   label: "Siemianowice (PLSOW)"
  },
  {
   value: "Siemianowice Slaskie (PLOYX)",
   label: "Siemianowice Slaskie (PLOYX)"
  },
  {
   value: "Siemiatycze (PLSZE)",
   label: "Siemiatycze (PLSZE)"
  },
  {
   value: "Sieniawa Zarska (PLSIA)",
   label: "Sieniawa Zarska (PLSIA)"
  },
  {
   value: "Sierpc (PLSPC)",
   label: "Sierpc (PLSPC)"
  },
  {
   value: "Siewierz (PLSIZ)",
   label: "Siewierz (PLSIZ)"
  },
  {
   value: "Sitkówka-Nowiny (PLSIN)",
   label: "Sitkówka-Nowiny (PLSIN)"
  },
  {
   value: "Skalmierzyce (PLSKZ)",
   label: "Skalmierzyce (PLSKZ)"
  },
  {
   value: "Skarbimierz (PLSBM)",
   label: "Skarbimierz (PLSBM)"
  },
  {
   value: "Skarszewy (PLSSY)",
   label: "Skarszewy (PLSSY)"
  },
  {
   value: "Skaryszew (PLOYY)",
   label: "Skaryszew (PLOYY)"
  },
  {
   value: "Skarzysko-Kamienna (PLSKK)",
   label: "Skarzysko-Kamienna (PLSKK)"
  },
  {
   value: "Skawina (PLSKA)",
   label: "Skawina (PLSKA)"
  },
  {
   value: "Skepe (PLSKE)",
   label: "Skepe (PLSKE)"
  },
  {
   value: "Skierbieszów (PLSBS)",
   label: "Skierbieszów (PLSBS)"
  },
  {
   value: "Skierdy (PLSDY)",
   label: "Skierdy (PLSDY)"
  },
  {
   value: "Skopanie (PLSKP)",
   label: "Skopanie (PLSKP)"
  },
  {
   value: "Skorzewo (PLSOR)",
   label: "Skorzewo (PLSOR)"
  },
  {
   value: "Skrzynno (PLSKR)",
   label: "Skrzynno (PLSKR)"
  },
  {
   value: "Skrzyszow (PLSZW)",
   label: "Skrzyszow (PLSZW)"
  },
  {
   value: "Slawikow (PLSLO)",
   label: "Slawikow (PLSLO)"
  },
  {
   value: "Slawko (PLSKO)",
   label: "Slawko (PLSKO)"
  },
  {
   value: "Slawków (PLSAW)",
   label: "Slawków (PLSAW)"
  },
  {
   value: "Slawno (PLSLA)",
   label: "Slawno (PLSLA)"
  },
  {
   value: "Sliwice (PLOXB)",
   label: "Sliwice (PLOXB)"
  },
  {
   value: "Slomniki (PLSMI)",
   label: "Slomniki (PLSMI)"
  },
  {
   value: "Slubice, Lubuskie (PLSLU)",
   label: "Slubice, Lubuskie (PLSLU)"
  },
  {
   value: "Slubice, Mazowieckie (PLSLE)",
   label: "Slubice, Mazowieckie (PLSLE)"
  },
  {
   value: "Slupca (PLSLC)",
   label: "Slupca (PLSLC)"
  },
  {
   value: "Slupy (PLSUP)",
   label: "Slupy (PLSUP)"
  },
  {
   value: "Smardzew (PLDZW)",
   label: "Smardzew (PLDZW)"
  },
  {
   value: "Smolec (PLSMO)",
   label: "Smolec (PLSMO)"
  },
  {
   value: "Sobienie Jeziory (PLOZC)",
   label: "Sobienie Jeziory (PLOZC)"
  },
  {
   value: "Sochaczew (PLSOC)",
   label: "Sochaczew (PLSOC)"
  },
  {
   value: "Solec Kujawski (PLSOI)",
   label: "Solec Kujawski (PLSOI)"
  },
  {
   value: "Solec-Zdrój (PLSZO)",
   label: "Solec-Zdrój (PLSZO)"
  },
  {
   value: "Sonsk (PLSON)",
   label: "Sonsk (PLSON)"
  },
  {
   value: "Spiczyn (PLSPY)",
   label: "Spiczyn (PLSPY)"
  },
  {
   value: "Spytkowice (PLSPT)",
   label: "Spytkowice (PLSPT)"
  },
  {
   value: "Srem (PLSRE)",
   label: "Srem (PLSRE)"
  },
  {
   value: "Sroda Slaska (PLSSA)",
   label: "Sroda Slaska (PLSSA)"
  },
  {
   value: "Sroda Wielkopolska (PLSWK)",
   label: "Sroda Wielkopolska (PLSWK)"
  },
  {
   value: "Stalowa Wola (PLQXQ)",
   label: "Stalowa Wola (PLQXQ)"
  },
  {
   value: "Stanislawice (PLSLW)",
   label: "Stanislawice (PLSLW)"
  },
  {
   value: "Stanowice (PLSTA)",
   label: "Stanowice (PLSTA)"
  },
  {
   value: "Stara Wies (PLSRT)",
   label: "Stara Wies (PLSRT)"
  },
  {
   value: "Starachowice (PLSTE)",
   label: "Starachowice (PLSTE)"
  },
  {
   value: "Stare Babice (PLSTB)",
   label: "Stare Babice (PLSTB)"
  },
  {
   value: "Stare Czarnowo (PLSCZ)",
   label: "Stare Czarnowo (PLSCZ)"
  },
  {
   value: "Stare Jablonki (PLSJB)",
   label: "Stare Jablonki (PLSJB)"
  },
  {
   value: "Stare Jezewo (PLSTJ)",
   label: "Stare Jezewo (PLSTJ)"
  },
  {
   value: "Stare Miasto (PLSTM)",
   label: "Stare Miasto (PLSTM)"
  },
  {
   value: "Stare Pole (PLSTP)",
   label: "Stare Pole (PLSTP)"
  },
  {
   value: "Stargard Szczecinski (PLSTS)",
   label: "Stargard Szczecinski (PLSTS)"
  },
  {
   value: "Starogard (PLSTD)",
   label: "Starogard (PLSTD)"
  },
  {
   value: "Starogard Gdanski (PLSTG)",
   label: "Starogard Gdanski (PLSTG)"
  },
  {
   value: "Staszów (PLSSW)",
   label: "Staszów (PLSSW)"
  },
  {
   value: "Staszów (PLSSZ)",
   label: "Staszów (PLSSZ)"
  },
  {
   value: "Stawiszyn (PLSWZ)",
   label: "Stawiszyn (PLSWZ)"
  },
  {
   value: "Steszew (PLSTW)",
   label: "Steszew (PLSTW)"
  },
  {
   value: "Straszyn (PLSTN)",
   label: "Straszyn (PLSTN)"
  },
  {
   value: "Stroze (PLSTU)",
   label: "Stroze (PLSTU)"
  },
  {
   value: "Strumien (PLSMN)",
   label: "Strumien (PLSMN)"
  },
  {
   value: "Stryków (PLSTR)",
   label: "Stryków (PLSTR)"
  },
  {
   value: "Stryszawa (PLSYZ)",
   label: "Stryszawa (PLSYZ)"
  },
  {
   value: "Strzebielino (PLSZB)",
   label: "Strzebielino (PLSZB)"
  },
  {
   value: "Strzegom (PLSGM)",
   label: "Strzegom (PLSGM)"
  },
  {
   value: "Strzelce Krajenskie (PLSTK)",
   label: "Strzelce Krajenskie (PLSTK)"
  },
  {
   value: "Strzelce Opolskie (PLSTO)",
   label: "Strzelce Opolskie (PLSTO)"
  },
  {
   value: "Strzelce Wielkie (PLSCK)",
   label: "Strzelce Wielkie (PLSCK)"
  },
  {
   value: "Strzelin (PLSTZ)",
   label: "Strzelin (PLSTZ)"
  },
  {
   value: "Strzelno (PLOXC)",
   label: "Strzelno (PLOXC)"
  },
  {
   value: "Strzyzow (PLOXA)",
   label: "Strzyzow (PLOXA)"
  },
  {
   value: "Stupiec (PLSTC)",
   label: "Stupiec (PLSTC)"
  },
  {
   value: "Suchedniów (PLSUH)",
   label: "Suchedniów (PLSUH)"
  },
  {
   value: "Suchy Las (PLSUC)",
   label: "Suchy Las (PLSUC)"
  },
  {
   value: "Sulaszewo (PLSWO)",
   label: "Sulaszewo (PLSWO)"
  },
  {
   value: "Sulecin, Gorzow (PLSCN)",
   label: "Sulecin, Gorzow (PLSCN)"
  },
  {
   value: "Sulejówek (PLSUL)",
   label: "Sulejówek (PLSUL)"
  },
  {
   value: "Sulkowice (PLKIE)",
   label: "Sulkowice (PLKIE)"
  },
  {
   value: "Sulkowice (PLSLI)",
   label: "Sulkowice (PLSLI)"
  },
  {
   value: "Susz (PLSZX)",
   label: "Susz (PLSZX)"
  },
  {
   value: "Swadzim (PLSWA)",
   label: "Swadzim (PLSWA)"
  },
  {
   value: "Swarozyn (PLSZN)",
   label: "Swarozyn (PLSZN)"
  },
  {
   value: "Swarzedz (PLSRZ)",
   label: "Swarzedz (PLSRZ)"
  },
  {
   value: "Swarzewo (PLSWR)",
   label: "Swarzewo (PLSWR)"
  },
  {
   value: "Swidnica (PLSWN)",
   label: "Swidnica (PLSWN)"
  },
  {
   value: "Swidnik (PLSDK)",
   label: "Swidnik (PLSDK)"
  },
  {
   value: "Swidwin (PLSWD)",
   label: "Swidwin (PLSWD)"
  },
  {
   value: "Swiebodzice (PLSWE)",
   label: "Swiebodzice (PLSWE)"
  },
  {
   value: "Swiebodzin (PLSWB)",
   label: "Swiebodzin (PLSWB)"
  },
  {
   value: "Swiecie (PLSCE)",
   label: "Swiecie (PLSCE)"
  },
  {
   value: "Swieradów-Zdrój (PLSWW)",
   label: "Swieradów-Zdrój (PLSWW)"
  },
  {
   value: "Swietajno (PLSWJ)",
   label: "Swietajno (PLSWJ)"
  },
  {
   value: "Swiete (PLETE)",
   label: "Swiete (PLETE)"
  },
  {
   value: "Swietochlowice (PLSWT)",
   label: "Swietochlowice (PLSWT)"
  },
  {
   value: "Sycewice (PLSYC)",
   label: "Sycewice (PLSYC)"
  },
  {
   value: "Sycow (PLSCW)",
   label: "Sycow (PLSCW)"
  },
  {
   value: "Szamotuly (PLSMY)",
   label: "Szamotuly (PLSMY)"
  },
  {
   value: "Szczerców (PLSER)",
   label: "Szczerców (PLSER)"
  },
  {
   value: "Szczyrk (PLZYK)",
   label: "Szczyrk (PLZYK)"
  },
  {
   value: "Szczytna (PLSZA)",
   label: "Szczytna (PLSZA)"
  },
  {
   value: "Szczytno (PLSZT)",
   label: "Szczytno (PLSZT)"
  },
  {
   value: "Szklarska Poreba (PLSKL)",
   label: "Szklarska Poreba (PLSKL)"
  },
  {
   value: "Szkodna (PLSZK)",
   label: "Szkodna (PLSZK)"
  },
  {
   value: "Szprotawa (PLSRA)",
   label: "Szprotawa (PLSRA)"
  },
  {
   value: "Sztynwag (PLZWG)",
   label: "Sztynwag (PLZWG)"
  },
  {
   value: "Szubin (PLSZU)",
   label: "Szubin (PLSZU)"
  },
  {
   value: "Szydlowiec (PLSZD)",
   label: "Szydlowiec (PLSZD)"
  },
  {
   value: "Szymany (PLSZY)",
   label: "Szymany (PLSZY)"
  },
  {
   value: "Tarczyn (PLOYM)",
   label: "Tarczyn (PLOYM)"
  },
  {
   value: "Tarnobrzeg (PLQEP)",
   label: "Tarnobrzeg (PLQEP)"
  },
  {
   value: "Tarnowa (PLTRW)",
   label: "Tarnowa (PLTRW)"
  },
  {
   value: "Tarnowiec (PLTAN)",
   label: "Tarnowiec (PLTAN)"
  },
  {
   value: "Tarnowo Podgórne (PLTPO)",
   label: "Tarnowo Podgórne (PLTPO)"
  },
  {
   value: "Tenczynek (PLTEN)",
   label: "Tenczynek (PLTEN)"
  },
  {
   value: "Teresin (PLTRN)",
   label: "Teresin (PLTRN)"
  },
  {
   value: "Teresin&nbsp; (PLTES)",
   label: "Teresin&nbsp; (PLTES)"
  },
  {
   value: "Terespol (PLTER)",
   label: "Terespol (PLTER)"
  },
  {
   value: "Tluszcz (PLTLU)",
   label: "Tluszcz (PLTLU)"
  },
  {
   value: "Tolkmicko (PLTMO)",
   label: "Tolkmicko (PLTMO)"
  },
  {
   value: "Tomaszów Lubelski (PLTOL)",
   label: "Tomaszów Lubelski (PLTOL)"
  },
  {
   value: "Tomaszów Mazowiecki (PLTMW)",
   label: "Tomaszów Mazowiecki (PLTMW)"
  },
  {
   value: "Torzym (PLTOM)",
   label: "Torzym (PLTOM)"
  },
  {
   value: "Trakiszki (PLTKI)",
   label: "Trakiszki (PLTKI)"
  },
  {
   value: "Trzciana (PLTRC)",
   label: "Trzciana (PLTRC)"
  },
  {
   value: "Trzcianka (PLTZA)",
   label: "Trzcianka (PLTZA)"
  },
  {
   value: "Trzebielino (PLTZB)",
   label: "Trzebielino (PLTZB)"
  },
  {
   value: "Trzebiez (PLTBZ)",
   label: "Trzebiez (PLTBZ)"
  },
  {
   value: "Trzebinia (PLTRB)",
   label: "Trzebinia (PLTRB)"
  },
  {
   value: "Trzebownisko (PLTRZ)",
   label: "Trzebownisko (PLTRZ)"
  },
  {
   value: "Trzydnik Duzy (PLTRD)",
   label: "Trzydnik Duzy (PLTRD)"
  },
  {
   value: "Tubadzin (PLTDZ)",
   label: "Tubadzin (PLTDZ)"
  },
  {
   value: "Tuchow (PLTCO)",
   label: "Tuchow (PLTCO)"
  },
  {
   value: "Tuczno (PLOXE)",
   label: "Tuczno (PLOXE)"
  },
  {
   value: "Turek (PLTRK)",
   label: "Turek (PLTRK)"
  },
  {
   value: "Turobin (PLTRO)",
   label: "Turobin (PLTRO)"
  },
  {
   value: "Turosn Koscielna (PLOXD)",
   label: "Turosn Koscielna (PLOXD)"
  },
  {
   value: "Tuszów Narodowy (PLTWN)",
   label: "Tuszów Narodowy (PLTWN)"
  },
  {
   value: "Tuszyn (PLTZY)",
   label: "Tuszyn (PLTZY)"
  },
  {
   value: "Twardogóra (PLTWA)",
   label: "Twardogóra (PLTWA)"
  },
  {
   value: "Tychowo (PLTYO)",
   label: "Tychowo (PLTYO)"
  },
  {
   value: "Tyczyn (PLTZN)",
   label: "Tyczyn (PLTZN)"
  },
  {
   value: "Tykocin (PLTYK)",
   label: "Tykocin (PLTYK)"
  },
  {
   value: "Tyrawa Woloska (PLTWL)",
   label: "Tyrawa Woloska (PLTWL)"
  },
  {
   value: "Ujazd (PLUJA)",
   label: "Ujazd (PLUJA)"
  },
  {
   value: "Ujscie (PLUJS)",
   label: "Ujscie (PLUJS)"
  },
  {
   value: "Ulkowy (PLULK)",
   label: "Ulkowy (PLULK)"
  },
  {
   value: "Unislaw Slaski (PLUNS)",
   label: "Unislaw Slaski (PLUNS)"
  },
  {
   value: "Urad (PLURD)",
   label: "Urad (PLURD)"
  },
  {
   value: "Urzedow (PLURZ)",
   label: "Urzedow (PLURZ)"
  },
  {
   value: "Ustron (PLUSR)",
   label: "Ustron (PLUSR)"
  },
  {
   value: "Ustronie Morskie (PLUMS)",
   label: "Ustronie Morskie (PLUMS)"
  },
  {
   value: "Ustrzyki Dolne (PLUSD)",
   label: "Ustrzyki Dolne (PLUSD)"
  },
  {
   value: "Wabrzezno (PLWBZ)",
   label: "Wabrzezno (PLWBZ)"
  },
  {
   value: "Wachock (PLWAC)",
   label: "Wachock (PLWAC)"
  },
  {
   value: "Wadowice (PLWAD)",
   label: "Wadowice (PLWAD)"
  },
  {
   value: "Wadowice (PLWDW)",
   label: "Wadowice (PLWDW)"
  },
  {
   value: "Wagrowiec (PLWAG)",
   label: "Wagrowiec (PLWAG)"
  },
  {
   value: "Walce (PLWAL)",
   label: "Walce (PLWAL)"
  },
  {
   value: "Walcz (PLWAZ)",
   label: "Walcz (PLWAZ)"
  },
  {
   value: "Walichnowy (PLOXH)",
   label: "Walichnowy (PLOXH)"
  },
  {
   value: "Warka (PLWKA)",
   label: "Warka (PLWKA)"
  },
  {
   value: "Warlubie (PLWLB)",
   label: "Warlubie (PLWLB)"
  },
  {
   value: "Warta (PLWAR)",
   label: "Warta (PLWAR)"
  },
  {
   value: "Wartkowice (PLWTW)",
   label: "Wartkowice (PLWTW)"
  },
  {
   value: "Wawolnica (PLWOC)",
   label: "Wawolnica (PLWOC)"
  },
  {
   value: "Wegorzyno (PLWZO)",
   label: "Wegorzyno (PLWZO)"
  },
  {
   value: "Wegrow (PLOXI)",
   label: "Wegrow (PLOXI)"
  },
  {
   value: "Wegrzce, Zielonki (PLWGC)",
   label: "Wegrzce, Zielonki (PLWGC)"
  },
  {
   value: "Wejherowo (PLWEJ)",
   label: "Wejherowo (PLWEJ)"
  },
  {
   value: "Wiazowna (PLWZN)",
   label: "Wiazowna (PLWZN)"
  },
  {
   value: "Wiecbork (PLWBK)",
   label: "Wiecbork (PLWBK)"
  },
  {
   value: "Wielen (PLWNC)",
   label: "Wielen (PLWNC)"
  },
  {
   value: "Wielichowo (PLWCW)",
   label: "Wielichowo (PLWCW)"
  },
  {
   value: "Wieliczka (PLWIL)",
   label: "Wieliczka (PLWIL)"
  },
  {
   value: "Wieloglowy (PLWLG)",
   label: "Wieloglowy (PLWLG)"
  },
  {
   value: "Wielopole Skrzynskie (PLWPZ)",
   label: "Wielopole Skrzynskie (PLWPZ)"
  },
  {
   value: "Wielun (PLWLN)",
   label: "Wielun (PLWLN)"
  },
  {
   value: "Wieruszów (PLWSO)",
   label: "Wieruszów (PLWSO)"
  },
  {
   value: "Wierzbica (PLWIZ)",
   label: "Wierzbica (PLWIZ)"
  },
  {
   value: "Wierzchoslawice (PLWIE)",
   label: "Wierzchoslawice (PLWIE)"
  },
  {
   value: "Wiskitki (PLWIK)",
   label: "Wiskitki (PLWIK)"
  },
  {
   value: "Wisla (PLWIS)",
   label: "Wisla (PLWIS)"
  },
  {
   value: "Wislica (PLWSA)",
   label: "Wislica (PLWSA)"
  },
  {
   value: "Wisznia Mala (PLWIA)",
   label: "Wisznia Mala (PLWIA)"
  },
  {
   value: "Witkowo (PLOXJ)",
   label: "Witkowo (PLOXJ)"
  },
  {
   value: "Wloszczowa (PLWLS)",
   label: "Wloszczowa (PLWLS)"
  },
  {
   value: "Wodzislaw Slaski (PLWZL)",
   label: "Wodzislaw Slaski (PLWZL)"
  },
  {
   value: "Wojnicz (PLOXK)",
   label: "Wojnicz (PLOXK)"
  },
  {
   value: "Wola Krzysztoporska (PLOXL)",
   label: "Wola Krzysztoporska (PLOXL)"
  },
  {
   value: "Wolanów (PLWOA)",
   label: "Wolanów (PLWOA)"
  },
  {
   value: "Wolbórz (PLWOL)",
   label: "Wolbórz (PLWOL)"
  },
  {
   value: "Wolbrom (PLWBM)",
   label: "Wolbrom (PLWBM)"
  },
  {
   value: "Wolin (PLWLI)",
   label: "Wolin (PLWLI)"
  },
  {
   value: "Wolka Kosowska (PLOXG)",
   label: "Wolka Kosowska (PLOXG)"
  },
  {
   value: "Wolkowo (PLWKO)",
   label: "Wolkowo (PLWKO)"
  },
  {
   value: "Wolsztyn (PLWZT)",
   label: "Wolsztyn (PLWZT)"
  },
  {
   value: "Wroblew (PLWBW)",
   label: "Wroblew (PLWBW)"
  },
  {
   value: "Wronki (PLWRN)",
   label: "Wronki (PLWRN)"
  },
  {
   value: "Wrzesnia (PLWZA)",
   label: "Wrzesnia (PLWZA)"
  },
  {
   value: "Wschowa (PLWSC)",
   label: "Wschowa (PLWSC)"
  },
  {
   value: "Wyrzysk (PLWZY)",
   label: "Wyrzysk (PLWZY)"
  },
  {
   value: "Wysogotowo (PLWYS)",
   label: "Wysogotowo (PLWYS)"
  },
  {
   value: "Wysoka (PLOXM)",
   label: "Wysoka (PLOXM)"
  },
  {
   value: "Wysokie Mazowieckie (PLWYM)",
   label: "Wysokie Mazowieckie (PLWYM)"
  },
  {
   value: "Wyszków (PLWYZ)",
   label: "Wyszków (PLWYZ)"
  },
  {
   value: "Zabierzow (PLZBZ)",
   label: "Zabierzow (PLZBZ)"
  },
  {
   value: "Zabkowice Slaskie (PLZAS)",
   label: "Zabkowice Slaskie (PLZAS)"
  },
  {
   value: "Zabno (PLZAN)",
   label: "Zabno (PLZAN)"
  },
  {
   value: "Zaborów (PLZAO)",
   label: "Zaborów (PLZAO)"
  },
  {
   value: "Zaczernie (PLZZI)",
   label: "Zaczernie (PLZZI)"
  },
  {
   value: "Zagnansk (PLZAK)",
   label: "Zagnansk (PLZAK)"
  },
  {
   value: "Zagórz (PLZGZ)",
   label: "Zagórz (PLZGZ)"
  },
  {
   value: "Zakliczyn (PLZCY)",
   label: "Zakliczyn (PLZCY)"
  },
  {
   value: "Zakopane (PLQAZ)",
   label: "Zakopane (PLQAZ)"
  },
  {
   value: "Zakrzewo (PLZZO)",
   label: "Zakrzewo (PLZZO)"
  },
  {
   value: "Zalesie Górne (PLZAL)",
   label: "Zalesie Górne (PLZAL)"
  },
  {
   value: "Zambrów (PLZAW)",
   label: "Zambrów (PLZAW)"
  },
  {
   value: "Zamostne (PLZMO)",
   label: "Zamostne (PLZMO)"
  },
  {
   value: "Zarów (PLZAR)",
   label: "Zarów (PLZAR)"
  },
  {
   value: "Zary (PLZRY)",
   label: "Zary (PLZRY)"
  },
  {
   value: "Zator (PLOXQ)",
   label: "Zator (PLOXQ)"
  },
  {
   value: "Zawadzkie (PLZWZ)",
   label: "Zawadzkie (PLZWZ)"
  },
  {
   value: "Zbaszyn (PLZBN)",
   label: "Zbaszyn (PLZBN)"
  },
  {
   value: "Zbaszynek (PLZBK)",
   label: "Zbaszynek (PLZBK)"
  },
  {
   value: "Zbylitowska Gora (PLOXP)",
   label: "Zbylitowska Gora (PLOXP)"
  },
  {
   value: "Zduny (PLZDY)",
   label: "Zduny (PLZDY)"
  },
  {
   value: "Zdzary (PLZZY)",
   label: "Zdzary (PLZZY)"
  },
  {
   value: "Zdzieszowice (PLZDZ)",
   label: "Zdzieszowice (PLZDZ)"
  },
  {
   value: "Zebrzydowice (PLZEB)",
   label: "Zebrzydowice (PLZEB)"
  },
  {
   value: "Zelazków (PLZZW)",
   label: "Zelazków (PLZZW)"
  },
  {
   value: "Zgierz (PLZGI)",
   label: "Zgierz (PLZGI)"
  },
  {
   value: "Zglobice (PLZBC)",
   label: "Zglobice (PLZBC)"
  },
  {
   value: "Ziebice (PLZIE)",
   label: "Ziebice (PLZIE)"
  },
  {
   value: "Zielona Gora (PLIEG)",
   label: "Zielona Gora (PLIEG)"
  },
  {
   value: "Zielonka (PLZIL)",
   label: "Zielonka (PLZIL)"
  },
  {
   value: "Zielonki (PLZIO)",
   label: "Zielonki (PLZIO)"
  },
  {
   value: "Zlotków (PLZLW)",
   label: "Zlotków (PLZLW)"
  },
  {
   value: "Zlotniki Kujawskie (PLZLK)",
   label: "Zlotniki Kujawskie (PLZLK)"
  },
  {
   value: "Zlotoryja (PLZTO)",
   label: "Zlotoryja (PLZTO)"
  },
  {
   value: "Zlotów (PLZLO)",
   label: "Zlotów (PLZLO)"
  },
  {
   value: "Znin (PLZNI)",
   label: "Znin (PLZNI)"
  },
  {
   value: "Zolynia (PLZLA)",
   label: "Zolynia (PLZLA)"
  },
  {
   value: "Zorawina (PLZOR)",
   label: "Zorawina (PLZOR)"
  },
  {
   value: "Zory (PLZOY)",
   label: "Zory (PLZOY)"
  },
  {
   value: "Zukowice (PLOXR)",
   label: "Zukowice (PLOXR)"
  },
  {
   value: "Zukowo (PLZUK)",
   label: "Zukowo (PLZUK)"
  },
  {
   value: "Zurawica (PLZUR)",
   label: "Zurawica (PLZUR)"
  },
  {
   value: "Zwolen (PLZWL)",
   label: "Zwolen (PLZWL)"
  },
  {
   value: "Zychlin (PLZYN)",
   label: "Zychlin (PLZYN)"
  },
  {
   value: "Zyraków (PLZKW)",
   label: "Zyraków (PLZKW)"
  },
  {
   value: "Zywiec (PLZYW)",
   label: "Zywiec (PLZYW)"
  },
  {
   value: ".SAINT PIERRE AND MIQUELON (PM)",
   label: ".SAINT PIERRE AND MIQUELON (PM)"
  },
  {
   value: "Miquelon (PMMQC)",
   label: "Miquelon (PMMQC)"
  },
  {
   value: ".PITCAIRN (PN)",
   label: ".PITCAIRN (PN)"
  },
  {
   value: ".PUERTO RICO (PR)",
   label: ".PUERTO RICO (PR)"
  },
  {
   value: "Cabo Rojo (PRCBJ)",
   label: "Cabo Rojo (PRCBJ)"
  },
  {
   value: "Ciales (PRCLE)",
   label: "Ciales (PRCLE)"
  },
  {
   value: "Las Piedras (PRLPS)",
   label: "Las Piedras (PRLPS)"
  },
  {
   value: "Manati (PRMAN)",
   label: "Manati (PRMAN)"
  },
  {
   value: "Moca (PRMOC)",
   label: "Moca (PRMOC)"
  },
  {
   value: "Patillas (PRPTL)",
   label: "Patillas (PRPTL)"
  },
  {
   value: "Rincon (PRRIN)",
   label: "Rincon (PRRIN)"
  },
  {
   value: "Río Grande (PRRGD)",
   label: "Río Grande (PRRGD)"
  },
  {
   value: "Roosevelt Roads (PRNRR)",
   label: "Roosevelt Roads (PRNRR)"
  },
  {
   value: "San Germán (PRSGM)",
   label: "San Germán (PRSGM)"
  },
  {
   value: "Santa Isabel (PRSIS)",
   label: "Santa Isabel (PRSIS)"
  },
  {
   value: "Toa Alta (PRTAA)",
   label: "Toa Alta (PRTAA)"
  },
  {
   value: "Trujillo Alto (PRTRJ)",
   label: "Trujillo Alto (PRTRJ)"
  },
  {
   value: "Trujillo Bajo, Carolina (PRTRU)",
   label: "Trujillo Bajo, Carolina (PRTRU)"
  },
  {
   value: ".PORTUGAL (PT)",
   label: ".PORTUGAL (PT)"
  },
  {
   value: "A dos Cunhados (PTTZA)",
   label: "A dos Cunhados (PTTZA)"
  },
  {
   value: "Abade de Vermoim (PTAVM)",
   label: "Abade de Vermoim (PTAVM)"
  },
  {
   value: "Aboboda (PTABO)",
   label: "Aboboda (PTABO)"
  },
  {
   value: "Abrantes (PTABT)",
   label: "Abrantes (PTABT)"
  },
  {
   value: "Abrigada (PTABG)",
   label: "Abrigada (PTABG)"
  },
  {
   value: "Adães (PTASD)",
   label: "Adães (PTASD)"
  },
  {
   value: "Agrela (PTAGE)",
   label: "Agrela (PTAGE)"
  },
  {
   value: "Aguada de Cima (PTAGA)",
   label: "Aguada de Cima (PTAGA)"
  },
  {
   value: "Agualva (PTAGV)",
   label: "Agualva (PTAGV)"
  },
  {
   value: "Águas de Moura (PTAGM)",
   label: "Águas de Moura (PTAGM)"
  },
  {
   value: "Aguiar da Beira (PTAGB)",
   label: "Aguiar da Beira (PTAGB)"
  },
  {
   value: "Aião (PTAIO)",
   label: "Aião (PTAIO)"
  },
  {
   value: "Alandroal (PTAOD)",
   label: "Alandroal (PTAOD)"
  },
  {
   value: "Albarraque (PTABQ)",
   label: "Albarraque (PTABQ)"
  },
  {
   value: "Albergaria-a-Velha (PTABV)",
   label: "Albergaria-a-Velha (PTABV)"
  },
  {
   value: "Alcabideche (PTACB)",
   label: "Alcabideche (PTACB)"
  },
  {
   value: "Alcains (PTALS)",
   label: "Alcains (PTALS)"
  },
  {
   value: "Alcanede (PTACD)",
   label: "Alcanede (PTACD)"
  },
  {
   value: "Alcoentre (PTACR)",
   label: "Alcoentre (PTACR)"
  },
  {
   value: "Alcoutim (PTACT)",
   label: "Alcoutim (PTACT)"
  },
  {
   value: "Além da Ribeira (PTAER)",
   label: "Além da Ribeira (PTAER)"
  },
  {
   value: "Alfândega da Fé (PTAFE)",
   label: "Alfândega da Fé (PTAFE)"
  },
  {
   value: "Alfena (PTAFA)",
   label: "Alfena (PTAFA)"
  },
  {
   value: "Algés (PTAGS)",
   label: "Algés (PTAGS)"
  },
  {
   value: "Alhandra (PTAHD)",
   label: "Alhandra (PTAHD)"
  },
  {
   value: "Alijo (PTALJ)",
   label: "Alijo (PTALJ)"
  },
  {
   value: "Aljezur (PTAJZ)",
   label: "Aljezur (PTAJZ)"
  },
  {
   value: "Aljubarrota (PTAJB)",
   label: "Aljubarrota (PTAJB)"
  },
  {
   value: "Aljustrel (PTAJT)",
   label: "Aljustrel (PTAJT)"
  },
  {
   value: "Almagreira (PTAMG)",
   label: "Almagreira (PTAMG)"
  },
  {
   value: "Almancil (PTAML)",
   label: "Almancil (PTAML)"
  },
  {
   value: "Almargem (PTAMP)",
   label: "Almargem (PTAMP)"
  },
  {
   value: "Almeida (PTALD)",
   label: "Almeida (PTALD)"
  },
  {
   value: "Almeirim (PTALR)",
   label: "Almeirim (PTALR)"
  },
  {
   value: "Almodôvar (PTADV)",
   label: "Almodôvar (PTADV)"
  },
  {
   value: "Alpiarça (PTAPC)",
   label: "Alpiarça (PTAPC)"
  },
  {
   value: "Alter do Chão (PTALT)",
   label: "Alter do Chão (PTALT)"
  },
  {
   value: "Alvaiázere (PTAVZ)",
   label: "Alvaiázere (PTAVZ)"
  },
  {
   value: "Alvarelhos (PTAVL)",
   label: "Alvarelhos (PTAVL)"
  },
  {
   value: "Alverca do Ribatejo (PTARJ)",
   label: "Alverca do Ribatejo (PTARJ)"
  },
  {
   value: "Alvito (PTAVT)",
   label: "Alvito (PTAVT)"
  },
  {
   value: "Amarante (PTAMT)",
   label: "Amarante (PTAMT)"
  },
  {
   value: "Amareleja (PTAMJ)",
   label: "Amareleja (PTAMJ)"
  },
  {
   value: "Amares (PTAMR)",
   label: "Amares (PTAMR)"
  },
  {
   value: "Amiães de Cima (PTAMC)",
   label: "Amiães de Cima (PTAMC)"
  },
  {
   value: "Amora (PTAMO)",
   label: "Amora (PTAMO)"
  },
  {
   value: "Amorim (PTAMI)",
   label: "Amorim (PTAMI)"
  },
  {
   value: "Anais (PTANI)",
   label: "Anais (PTANI)"
  },
  {
   value: "Ancora (PTANC)",
   label: "Ancora (PTANC)"
  },
  {
   value: "Ansião (PTANS)",
   label: "Ansião (PTANS)"
  },
  {
   value: "Arcos de Valdevez (PTAVV)",
   label: "Arcos de Valdevez (PTAVV)"
  },
  {
   value: "Arcozelo (PTACZ)",
   label: "Arcozelo (PTACZ)"
  },
  {
   value: "Ardido (PTARD)",
   label: "Ardido (PTARD)"
  },
  {
   value: "Areosa (PTARA)",
   label: "Areosa (PTARA)"
  },
  {
   value: "Arganil (PTAGN)",
   label: "Arganil (PTAGN)"
  },
  {
   value: "Argoncilhe (PTAGL)",
   label: "Argoncilhe (PTAGL)"
  },
  {
   value: "Argozelo (PTAGZ)",
   label: "Argozelo (PTAGZ)"
  },
  {
   value: "Ariz (PTARZ)",
   label: "Ariz (PTARZ)"
  },
  {
   value: "Armação de Pêra (PTARP)",
   label: "Armação de Pêra (PTARP)"
  },
  {
   value: "Armamar (PTARM)",
   label: "Armamar (PTARM)"
  },
  {
   value: "Arouca (PTARC)",
   label: "Arouca (PTARC)"
  },
  {
   value: "Arraiolos (PTARL)",
   label: "Arraiolos (PTARL)"
  },
  {
   value: "Arreigada (PTARG)",
   label: "Arreigada (PTARG)"
  },
  {
   value: "Arrifana (PTARF)",
   label: "Arrifana (PTARF)"
  },
  {
   value: "Arronches (PTARR)",
   label: "Arronches (PTARR)"
  },
  {
   value: "Arruda dos Vinhos (PTARV)",
   label: "Arruda dos Vinhos (PTARV)"
  },
  {
   value: "Atouguia da Baleia (PTATB)",
   label: "Atouguia da Baleia (PTATB)"
  },
  {
   value: "Aveleda (PTAVD)",
   label: "Aveleda (PTAVD)"
  },
  {
   value: "Aves (PTAES)",
   label: "Aves (PTAES)"
  },
  {
   value: "Avintes (PTAVI)",
   label: "Avintes (PTAVI)"
  },
  {
   value: "Avis (PTAVS)",
   label: "Avis (PTAVS)"
  },
  {
   value: "Azambujeira (PTABA)",
   label: "Azambujeira (PTABA)"
  },
  {
   value: "Azaruja (PTAZJ)",
   label: "Azaruja (PTAZJ)"
  },
  {
   value: "Azeitão (PTAZT)",
   label: "Azeitão (PTAZT)"
  },
  {
   value: "Baião (PTBAA)",
   label: "Baião (PTBAA)"
  },
  {
   value: "Baixa da Banheira (PTBBN)",
   label: "Baixa da Banheira (PTBBN)"
  },
  {
   value: "Balazar (PTBLZ)",
   label: "Balazar (PTBLZ)"
  },
  {
   value: "Banho e Carvalhosa (PTBHC)",
   label: "Banho e Carvalhosa (PTBHC)"
  },
  {
   value: "Barcarena (PTBEA)",
   label: "Barcarena (PTBEA)"
  },
  {
   value: "Barrancos (PTBRR)",
   label: "Barrancos (PTBRR)"
  },
  {
   value: "Barro (PTBAO)",
   label: "Barro (PTBAO)"
  },
  {
   value: "Barroselas (PTBRS)",
   label: "Barroselas (PTBRS)"
  },
  {
   value: "Beijos (PTBEI)",
   label: "Beijos (PTBEI)"
  },
  {
   value: "Beja (PTBEJ)",
   label: "Beja (PTBEJ)"
  },
  {
   value: "Belas (PTBLS)",
   label: "Belas (PTBLS)"
  },
  {
   value: "Belmonte (PTBMT)",
   label: "Belmonte (PTBMT)"
  },
  {
   value: "Benavente (PTBNV)",
   label: "Benavente (PTBNV)"
  },
  {
   value: "Benedita (PTBNT)",
   label: "Benedita (PTBNT)"
  },
  {
   value: "Bobadela (PTBBL)",
   label: "Bobadela (PTBBL)"
  },
  {
   value: "Borba (PTBBA)",
   label: "Borba (PTBBA)"
  },
  {
   value: "Boticas (PTBTS)",
   label: "Boticas (PTBTS)"
  },
  {
   value: "Bragança (PTBGC)",
   label: "Bragança (PTBGC)"
  },
  {
   value: "Branca (PTBCA)",
   label: "Branca (PTBCA)"
  },
  {
   value: "Bucelas (PTBUC)",
   label: "Bucelas (PTBUC)"
  },
  {
   value: "Cabeceiras de Basto (PTCBS)",
   label: "Cabeceiras de Basto (PTCBS)"
  },
  {
   value: "Cabrela (PTCBL)",
   label: "Cabrela (PTCBL)"
  },
  {
   value: "Cacia (PTCAA)",
   label: "Cacia (PTCAA)"
  },
  {
   value: "Cadaval (PTCDV)",
   label: "Cadaval (PTCDV)"
  },
  {
   value: "Caldas das Taipas (PTCTP)",
   label: "Caldas das Taipas (PTCTP)"
  },
  {
   value: "Caldas de Vizela (PTCVZ)",
   label: "Caldas de Vizela (PTCVZ)"
  },
  {
   value: "Calheta, I. Madeira (PTCLH)",
   label: "Calheta, I. Madeira (PTCLH)"
  },
  {
   value: "Camacha (PTCMH)",
   label: "Camacha (PTCMH)"
  },
  {
   value: "Câmara de Lobos (PTCML)",
   label: "Câmara de Lobos (PTCML)"
  },
  {
   value: "Caminha (PTCAM)",
   label: "Caminha (PTCAM)"
  },
  {
   value: "Campelos (PTCMO)",
   label: "Campelos (PTCMO)"
  },
  {
   value: "Campo de Besteiros (PTCPB)",
   label: "Campo de Besteiros (PTCPB)"
  },
  {
   value: "Campo Maior (PTCMR)",
   label: "Campo Maior (PTCMR)"
  },
  {
   value: "Canas de Santa Maria (PTSCM)",
   label: "Canas de Santa Maria (PTSCM)"
  },
  {
   value: "Canas de Senhorim (PTCNI)",
   label: "Canas de Senhorim (PTCNI)"
  },
  {
   value: "Caneças (PTCNC)",
   label: "Caneças (PTCNC)"
  },
  {
   value: "Canedo (PTCEO)",
   label: "Canedo (PTCEO)"
  },
  {
   value: "Canelas (PTCNS)",
   label: "Canelas (PTCNS)"
  },
  {
   value: "Canha (PTCHA)",
   label: "Canha (PTCHA)"
  },
  {
   value: "Caniçal (PTCNL)",
   label: "Caniçal (PTCNL)"
  },
  {
   value: "Caniço (PTCNO)",
   label: "Caniço (PTCNO)"
  },
  {
   value: "Cantanhede (PTCTH)",
   label: "Cantanhede (PTCTH)"
  },
  {
   value: "Caparica (PTCPC)",
   label: "Caparica (PTCPC)"
  },
  {
   value: "Capelo (PTCPL)",
   label: "Capelo (PTCPL)"
  },
  {
   value: "Caramulo (PTCRO)",
   label: "Caramulo (PTCRO)"
  },
  {
   value: "Carcavelos (PTCCS)",
   label: "Carcavelos (PTCCS)"
  },
  {
   value: "Carnaxide (PTCNX)",
   label: "Carnaxide (PTCNX)"
  },
  {
   value: "Carrazeda de Anciães (PTCZZ)",
   label: "Carrazeda de Anciães (PTCZZ)"
  },
  {
   value: "Carrazedo de Montenegro (PTCRG)",
   label: "Carrazedo de Montenegro (PTCRG)"
  },
  {
   value: "Carregal do Sal (PTCRA)",
   label: "Carregal do Sal (PTCRA)"
  },
  {
   value: "Carvalhais (PTTZE)",
   label: "Carvalhais (PTTZE)"
  },
  {
   value: "Casal de Loivos (PTCLV)",
   label: "Casal de Loivos (PTCLV)"
  },
  {
   value: "Casal do Marco (PTCSM)",
   label: "Casal do Marco (PTCSM)"
  },
  {
   value: "Casal dos Bernardos (PTCBN)",
   label: "Casal dos Bernardos (PTCBN)"
  },
  {
   value: "Castanheira de Pêra (PTCPR)",
   label: "Castanheira de Pêra (PTCPR)"
  },
  {
   value: "Castanheira do Ribatejo (PTCRI)",
   label: "Castanheira do Ribatejo (PTCRI)"
  },
  {
   value: "Castelo de Paiva (PTCPV)",
   label: "Castelo de Paiva (PTCPV)"
  },
  {
   value: "Castelo de Vide (PTCVD)",
   label: "Castelo de Vide (PTCVD)"
  },
  {
   value: "Castro Daire (PTCTD)",
   label: "Castro Daire (PTCTD)"
  },
  {
   value: "Castro Marim (PTCMM)",
   label: "Castro Marim (PTCMM)"
  },
  {
   value: "Castro Verde (PTCVR)",
   label: "Castro Verde (PTCVR)"
  },
  {
   value: "Caxias (PTCAX)",
   label: "Caxias (PTCAX)"
  },
  {
   value: "Cedovim (PTCDM)",
   label: "Cedovim (PTCDM)"
  },
  {
   value: "Celorico da Beira (PTCLB)",
   label: "Celorico da Beira (PTCLB)"
  },
  {
   value: "Celorico de Basto (PTCBT)",
   label: "Celorico de Basto (PTCBT)"
  },
  {
   value: "Cercal do Alentejo (PTCLJ)",
   label: "Cercal do Alentejo (PTCLJ)"
  },
  {
   value: "Cernache (PTCER)",
   label: "Cernache (PTCER)"
  },
  {
   value: "Chamusca (PTCHM)",
   label: "Chamusca (PTCHM)"
  },
  {
   value: "Charneca da Caparica (PTCXP)",
   label: "Charneca da Caparica (PTCXP)"
  },
  {
   value: "Chaves (PTCHV)",
   label: "Chaves (PTCHV)"
  },
  {
   value: "Cinfães (PTCNF)",
   label: "Cinfães (PTCNF)"
  },
  {
   value: "Coimbra (PTCBP)",
   label: "Coimbra (PTCBP)"
  },
  {
   value: "Coimbra CDP (PTCDC)",
   label: "Coimbra CDP (PTCDC)"
  },
  {
   value: "Coina (PTCNA)",
   label: "Coina (PTCNA)"
  },
  {
   value: "Coja (PTCOJ)",
   label: "Coja (PTCOJ)"
  },
  {
   value: "Colares (PTCLR)",
   label: "Colares (PTCLR)"
  },
  {
   value: "Coronado-Sao Mamede (PTCOR)",
   label: "Coronado-Sao Mamede (PTCOR)"
  },
  {
   value: "Corroios (PTCRS)",
   label: "Corroios (PTCRS)"
  },
  {
   value: "Cortegaca (PTTZD)",
   label: "Cortegaca (PTTZD)"
  },
  {
   value: "Cortegaca (PTZGA)",
   label: "Cortegaca (PTZGA)"
  },
  {
   value: "Coruche (PTCRE)",
   label: "Coruche (PTCRE)"
  },
  {
   value: "Corvo Island Apt (PTCVU)",
   label: "Corvo Island Apt (PTCVU)"
  },
  {
   value: "Cova da Piedade (PTCVP)",
   label: "Cova da Piedade (PTCVP)"
  },
  {
   value: "Covelo (PTCVO)",
   label: "Covelo (PTCVO)"
  },
  {
   value: "Crato (PTCRT)",
   label: "Crato (PTCRT)"
  },
  {
   value: "Crestuma (PTCST)",
   label: "Crestuma (PTCST)"
  },
  {
   value: "Cuba (PTCUB)",
   label: "Cuba (PTCUB)"
  },
  {
   value: "Cucujães (PTCUC)",
   label: "Cucujães (PTCUC)"
  },
  {
   value: "Elvas (PTELV)",
   label: "Elvas (PTELV)"
  },
  {
   value: "Entre-os-Rios (PTEOR)",
   label: "Entre-os-Rios (PTEOR)"
  },
  {
   value: "Entroncamento (PTENT)",
   label: "Entroncamento (PTENT)"
  },
  {
   value: "Ericeira (PTERC)",
   label: "Ericeira (PTERC)"
  },
  {
   value: "Ermezinde (PTERM)",
   label: "Ermezinde (PTERM)"
  },
  {
   value: "Ermidas (PTERS)",
   label: "Ermidas (PTERS)"
  },
  {
   value: "Escandarao (PTESC)",
   label: "Escandarao (PTESC)"
  },
  {
   value: "Esmoriz (PTEMZ)",
   label: "Esmoriz (PTEMZ)"
  },
  {
   value: "Espinho (PTESN)",
   label: "Espinho (PTESN)"
  },
  {
   value: "Esposende (PTEPS)",
   label: "Esposende (PTEPS)"
  },
  {
   value: "Estarreja (PTETR)",
   label: "Estarreja (PTETR)"
  },
  {
   value: "Estreito de Câmara de Lobos (PTECL)",
   label: "Estreito de Câmara de Lobos (PTECL)"
  },
  {
   value: "Fafe (PTFFE)",
   label: "Fafe (PTFFE)"
  },
  {
   value: "Fajozes (PTFAJ)",
   label: "Fajozes (PTFAJ)"
  },
  {
   value: "Fânzeres (PTFNZ)",
   label: "Fânzeres (PTFNZ)"
  },
  {
   value: "Feira (PTFVD)",
   label: "Feira (PTFVD)"
  },
  {
   value: "Fernão Ferro (PTFNF)",
   label: "Fernão Ferro (PTFNF)"
  },
  {
   value: "Ferreira do Alentejo (PTFAL)",
   label: "Ferreira do Alentejo (PTFAL)"
  },
  {
   value: "Ferreira do Zêzere (PTFZZ)",
   label: "Ferreira do Zêzere (PTFZZ)"
  },
  {
   value: "Fiaes (PTFIA)",
   label: "Fiaes (PTFIA)"
  },
  {
   value: "Figueira de Castelo Rodrigo (PTFCR)",
   label: "Figueira de Castelo Rodrigo (PTFCR)"
  },
  {
   value: "Figueiró dos Vinhos (PTFGV)",
   label: "Figueiró dos Vinhos (PTFGV)"
  },
  {
   value: "Folgosa (PTFOL)",
   label: "Folgosa (PTFOL)"
  },
  {
   value: "Fornos de Algodres (PTFAG)",
   label: "Fornos de Algodres (PTFAG)"
  },
  {
   value: "Fradelos (PTFRD)",
   label: "Fradelos (PTFRD)"
  },
  {
   value: "Freixeira (PTTZF)",
   label: "Freixeira (PTTZF)"
  },
  {
   value: "Freixo de Espada à Cinta (PTFEC)",
   label: "Freixo de Espada à Cinta (PTFEC)"
  },
  {
   value: "Frielas (PTFRL)",
   label: "Frielas (PTFRL)"
  },
  {
   value: "Fronteira (PTFTR)",
   label: "Fronteira (PTFTR)"
  },
  {
   value: "Fundão (PTFUA)",
   label: "Fundão (PTFUA)"
  },
  {
   value: "Furnas (PTFRS)",
   label: "Furnas (PTFRS)"
  },
  {
   value: "Gafanha da Encarnaçao (PTGHE)",
   label: "Gafanha da Encarnaçao (PTGHE)"
  },
  {
   value: "Gafanha da Nazaré (PTGDN)",
   label: "Gafanha da Nazaré (PTGDN)"
  },
  {
   value: "Gavião (PTGAV)",
   label: "Gavião (PTGAV)"
  },
  {
   value: "Gemunde (PTTZH)",
   label: "Gemunde (PTTZH)"
  },
  {
   value: "Gerês (PTGRS)",
   label: "Gerês (PTGRS)"
  },
  {
   value: "Ginetes (PTGIN)",
   label: "Ginetes (PTGIN)"
  },
  {
   value: "Góis (PTGOI)",
   label: "Góis (PTGOI)"
  },
  {
   value: "Golegã (PTGLG)",
   label: "Golegã (PTGLG)"
  },
  {
   value: "Gouveia (PTGVI)",
   label: "Gouveia (PTGVI)"
  },
  {
   value: "Graciosa (PTGCS)",
   label: "Graciosa (PTGCS)"
  },
  {
   value: "Graciosa Island Apt (PTGRW)",
   label: "Graciosa Island Apt (PTGRW)"
  },
  {
   value: "Grândola (PTGDL)",
   label: "Grândola (PTGDL)"
  },
  {
   value: "Guardizela (PTGUA)",
   label: "Guardizela (PTGUA)"
  },
  {
   value: "Guia (PTGIA)",
   label: "Guia (PTGIA)"
  },
  {
   value: "Guifões (PTGIF)",
   label: "Guifões (PTGIF)"
  },
  {
   value: "Idanha-a-Nova (PTIDN)",
   label: "Idanha-a-Nova (PTIDN)"
  },
  {
   value: "Joane (PTBRA)",
   label: "Joane (PTBRA)"
  },
  {
   value: "Lagoa, I. São Miguel (PTLGP)",
   label: "Lagoa, I. São Miguel (PTLGP)"
  },
  {
   value: "Lamego (PTLMG)",
   label: "Lamego (PTLMG)"
  },
  {
   value: "Lanheses (PTLNS)",
   label: "Lanheses (PTLNS)"
  },
  {
   value: "Lavra (PTLVR)",
   label: "Lavra (PTLVR)"
  },
  {
   value: "Leça da Palmeira (PTLEP)",
   label: "Leça da Palmeira (PTLEP)"
  },
  {
   value: "Leça do Bailio (PTLDB)",
   label: "Leça do Bailio (PTLDB)"
  },
  {
   value: "Leirosa (PTTZJ)",
   label: "Leirosa (PTTZJ)"
  },
  {
   value: "Lisboa CDP (PTCDL)",
   label: "Lisboa CDP (PTCDL)"
  },
  {
   value: "Lisboa-EXPO (PTEXP)",
   label: "Lisboa-EXPO (PTEXP)"
  },
  {
   value: "Lixa (PTLXA)",
   label: "Lixa (PTLXA)"
  },
  {
   value: "Lordelo (PTLDR)",
   label: "Lordelo (PTLDR)"
  },
  {
   value: "Loulé (PTLUL)",
   label: "Loulé (PTLUL)"
  },
  {
   value: "Loures-MARL (PTMRL)",
   label: "Loures-MARL (PTMRL)"
  },
  {
   value: "Louriçal (PTLRC)",
   label: "Louriçal (PTLRC)"
  },
  {
   value: "Lourinhã (PTLNH)",
   label: "Lourinhã (PTLNH)"
  },
  {
   value: "Lousã (PTLSA)",
   label: "Lousã (PTLSA)"
  },
  {
   value: "Lousado (PTLSD)",
   label: "Lousado (PTLSD)"
  },
  {
   value: "Luso (PTLSO)",
   label: "Luso (PTLSO)"
  },
  {
   value: "Macedo de Cavaleiros (PTMCD)",
   label: "Macedo de Cavaleiros (PTMCD)"
  },
  {
   value: "Maceira Lis (PTMAL)",
   label: "Maceira Lis (PTMAL)"
  },
  {
   value: "Machico (PTMCH)",
   label: "Machico (PTMCH)"
  },
  {
   value: "Maia, I. São Miguel (PTMAS)",
   label: "Maia, I. São Miguel (PTMAS)"
  },
  {
   value: "Malhou (PTMHU)",
   label: "Malhou (PTMHU)"
  },
  {
   value: "Malveira (PTMLV)",
   label: "Malveira (PTMLV)"
  },
  {
   value: "Mangualde (PTMGL)",
   label: "Mangualde (PTMGL)"
  },
  {
   value: "Manteigas (PTMNG)",
   label: "Manteigas (PTMNG)"
  },
  {
   value: "Marinhais (PTMRN)",
   label: "Marinhais (PTMRN)"
  },
  {
   value: "Marvão (PTMRV)",
   label: "Marvão (PTMRV)"
  },
  {
   value: "Mealhada (PTMLD)",
   label: "Mealhada (PTMLD)"
  },
  {
   value: "Meda (PTMDA)",
   label: "Meda (PTMDA)"
  },
  {
   value: "Meirinhas (PTMRH)",
   label: "Meirinhas (PTMRH)"
  },
  {
   value: "Melgaço (PTMLG)",
   label: "Melgaço (PTMLG)"
  },
  {
   value: "Mértola (PTMTL)",
   label: "Mértola (PTMTL)"
  },
  {
   value: "Mesão Frio (PTMSF)",
   label: "Mesão Frio (PTMSF)"
  },
  {
   value: "Milharado (PTMLR)",
   label: "Milharado (PTMLR)"
  },
  {
   value: "Mindelo (PTMID)",
   label: "Mindelo (PTMID)"
  },
  {
   value: "Mira (PTMIR)",
   label: "Mira (PTMIR)"
  },
  {
   value: "Miranda do Corvo (PTMCV)",
   label: "Miranda do Corvo (PTMCV)"
  },
  {
   value: "Miranda do Douro (PTMDR)",
   label: "Miranda do Douro (PTMDR)"
  },
  {
   value: "Mirandela (PTMDL)",
   label: "Mirandela (PTMDL)"
  },
  {
   value: "Mogadouro (PTMGD)",
   label: "Mogadouro (PTMGD)"
  },
  {
   value: "Moimenta da Beira (PTMBR)",
   label: "Moimenta da Beira (PTMBR)"
  },
  {
   value: "Moita (PTMTA)",
   label: "Moita (PTMTA)"
  },
  {
   value: "Monção (PTMNO)",
   label: "Monção (PTMNO)"
  },
  {
   value: "Monchique (PTMCQ)",
   label: "Monchique (PTMCQ)"
  },
  {
   value: "Mondim de Basto (PTMDB)",
   label: "Mondim de Basto (PTMDB)"
  },
  {
   value: "Monforte (PTMFT)",
   label: "Monforte (PTMFT)"
  },
  {
   value: "Montalegre (PTMTR)",
   label: "Montalegre (PTMTR)"
  },
  {
   value: "Montalvão (PTMTV)",
   label: "Montalvão (PTMTV)"
  },
  {
   value: "Montargil (PTMTG)",
   label: "Montargil (PTMTG)"
  },
  {
   value: "Monte da Caparica (PTMTC)",
   label: "Monte da Caparica (PTMTC)"
  },
  {
   value: "Monte Real (PTMRE)",
   label: "Monte Real (PTMRE)"
  },
  {
   value: "Monte Trigo (PTTGO)",
   label: "Monte Trigo (PTTGO)"
  },
  {
   value: "Montemor-o-Novo (PTMMN)",
   label: "Montemor-o-Novo (PTMMN)"
  },
  {
   value: "Montemor-o-Velho (PTMMV)",
   label: "Montemor-o-Velho (PTMMV)"
  },
  {
   value: "Mora (PTMOA)",
   label: "Mora (PTMOA)"
  },
  {
   value: "Moreira (PTMRR)",
   label: "Moreira (PTMRR)"
  },
  {
   value: "Mortágua (PTMRT)",
   label: "Mortágua (PTMRT)"
  },
  {
   value: "Moscavide (PTMSV)",
   label: "Moscavide (PTMSV)"
  },
  {
   value: "Moura (PTMOC)",
   label: "Moura (PTMOC)"
  },
  {
   value: "Moura (PTMRA)",
   label: "Moura (PTMRA)"
  },
  {
   value: "Mourão (PTMOU)",
   label: "Mourão (PTMOU)"
  },
  {
   value: "Muge (PTTZI)",
   label: "Muge (PTTZI)"
  },
  {
   value: "Murches (PTMUS)",
   label: "Murches (PTMUS)"
  },
  {
   value: "Murtede (PTMTE)",
   label: "Murtede (PTMTE)"
  },
  {
   value: "Murtosa (PTMSA)",
   label: "Murtosa (PTMSA)"
  },
  {
   value: "Nazaré (PTNZR)",
   label: "Nazaré (PTNZR)"
  },
  {
   value: "Nine (PTNNE)",
   label: "Nine (PTNNE)"
  },
  {
   value: "Nisa (PTNIS)",
   label: "Nisa (PTNIS)"
  },
  {
   value: "Nogueira do Cravo (PTNDC)",
   label: "Nogueira do Cravo (PTNDC)"
  },
  {
   value: "Nordeste (PTNRD)",
   label: "Nordeste (PTNRD)"
  },
  {
   value: "Óbidos (PTOBD)",
   label: "Óbidos (PTOBD)"
  },
  {
   value: "Odemira (PTODE)",
   label: "Odemira (PTODE)"
  },
  {
   value: "Oleiros (PTOLR)",
   label: "Oleiros (PTOLR)"
  },
  {
   value: "Olival do Basto (PTOLB)",
   label: "Olival do Basto (PTOLB)"
  },
  {
   value: "Oliveira de Frades (PTOFR)",
   label: "Oliveira de Frades (PTOFR)"
  },
  {
   value: "Oliveira do Douro (PTODO)",
   label: "Oliveira do Douro (PTODO)"
  },
  {
   value: "Oliveira do Hospital (PTOHP)",
   label: "Oliveira do Hospital (PTOHP)"
  },
  {
   value: "Orvalho (PTORV)",
   label: "Orvalho (PTORV)"
  },
  {
   value: "Ourém (PTOUR)",
   label: "Ourém (PTOUR)"
  },
  {
   value: "Ourique (PTORQ)",
   label: "Ourique (PTORQ)"
  },
  {
   value: "Paço de Arcos (PTPCS)",
   label: "Paço de Arcos (PTPCS)"
  },
  {
   value: "Pacos de Brandado (PTPDB)",
   label: "Pacos de Brandado (PTPDB)"
  },
  {
   value: "Paços de Brandão (PTPAC)",
   label: "Paços de Brandão (PTPAC)"
  },
  {
   value: "Paços de Ferreira (PTPFR)",
   label: "Paços de Ferreira (PTPFR)"
  },
  {
   value: "Pampilhosa da Serra (PTPPS)",
   label: "Pampilhosa da Serra (PTPPS)"
  },
  {
   value: "Panasqueira (PTMPQ)",
   label: "Panasqueira (PTMPQ)"
  },
  {
   value: "Parede (PTPRE)",
   label: "Parede (PTPRE)"
  },
  {
   value: "Paredes (PTPRS)",
   label: "Paredes (PTPRS)"
  },
  {
   value: "Paredes de Coura (PTPER)",
   label: "Paredes de Coura (PTPER)"
  },
  {
   value: "Pataias (PTPTS)",
   label: "Pataias (PTPTS)"
  },
  {
   value: "Pedreiras (PTPED)",
   label: "Pedreiras (PTPED)"
  },
  {
   value: "Pedrógão Grande (PTPGR)",
   label: "Pedrógão Grande (PTPGR)"
  },
  {
   value: "Pedroso (PTPRO)",
   label: "Pedroso (PTPRO)"
  },
  {
   value: "Pegões (PTPEG)",
   label: "Pegões (PTPEG)"
  },
  {
   value: "Penacova (PTPCV)",
   label: "Penacova (PTPCV)"
  },
  {
   value: "Penafiel (PTPFL)",
   label: "Penafiel (PTPFL)"
  },
  {
   value: "Penalva do Castelo (PTPCT)",
   label: "Penalva do Castelo (PTPCT)"
  },
  {
   value: "Penamacor (PTPNC)",
   label: "Penamacor (PTPNC)"
  },
  {
   value: "Penamaior (PTIOR)",
   label: "Penamaior (PTIOR)"
  },
  {
   value: "Penedono (PTPND)",
   label: "Penedono (PTPND)"
  },
  {
   value: "Penela (PTPNL)",
   label: "Penela (PTPNL)"
  },
  {
   value: "Perafita (PTPFT)",
   label: "Perafita (PTPFT)"
  },
  {
   value: "Peso da Régua (PTPGA)",
   label: "Peso da Régua (PTPGA)"
  },
  {
   value: "Pico (PTPIC)",
   label: "Pico (PTPIC)"
  },
  {
   value: "Pindelo (PTAVP)",
   label: "Pindelo (PTAVP)"
  },
  {
   value: "Pinhal Novo (PTPNV)",
   label: "Pinhal Novo (PTPNV)"
  },
  {
   value: "Pinhão (PTPNO)",
   label: "Pinhão (PTPNO)"
  },
  {
   value: "Pinhel (PTPIN)",
   label: "Pinhel (PTPIN)"
  },
  {
   value: "Ponta do Pargo (PTPTG)",
   label: "Ponta do Pargo (PTPTG)"
  },
  {
   value: "Ponta do Sol (PTPSL)",
   label: "Ponta do Sol (PTPSL)"
  },
  {
   value: "Ponte da Barca (PTPTB)",
   label: "Ponte da Barca (PTPTB)"
  },
  {
   value: "Ponte do Lima (PTPLM)",
   label: "Ponte do Lima (PTPLM)"
  },
  {
   value: "Ponte do Rol (PTPDR)",
   label: "Ponte do Rol (PTPDR)"
  },
  {
   value: "Pontinha (PTPNT)",
   label: "Pontinha (PTPNT)"
  },
  {
   value: "Portel (PTPRL)",
   label: "Portel (PTPRL)"
  },
  {
   value: "Porto Alto (PTPOA)",
   label: "Porto Alto (PTPOA)"
  },
  {
   value: "Porto CDP (PTCDO)",
   label: "Porto CDP (PTCDO)"
  },
  {
   value: "Porto da Cruz (PTPCZ)",
   label: "Porto da Cruz (PTPCZ)"
  },
  {
   value: "Porto Moniz (PTPMZ)",
   label: "Porto Moniz (PTPMZ)"
  },
  {
   value: "Porto Salvo (PTPSV)",
   label: "Porto Salvo (PTPSV)"
  },
  {
   value: "Póvoa de Lanhoso (PTPVL)",
   label: "Póvoa de Lanhoso (PTPVL)"
  },
  {
   value: "Povoação (PTPVC)",
   label: "Povoação (PTPVC)"
  },
  {
   value: "Proença-a-Nova (PTPRA)",
   label: "Proença-a-Nova (PTPRA)"
  },
  {
   value: "Quarteira (PTQRT)",
   label: "Quarteira (PTQRT)"
  },
  {
   value: "Queluz de Baixo (PTTZK)",
   label: "Queluz de Baixo (PTTZK)"
  },
  {
   value: "Quinta do Anjo \/ Palmela (PTQDA)",
   label: "Quinta do Anjo \/ Palmela (PTQDA)"
  },
  {
   value: "Quinta do Conde (PTQCD)",
   label: "Quinta do Conde (PTQCD)"
  },
  {
   value: "Rabo de Peixe (PTRPX)",
   label: "Rabo de Peixe (PTRPX)"
  },
  {
   value: "Rebordelo (PTRBD)",
   label: "Rebordelo (PTRBD)"
  },
  {
   value: "Rebordosa (PTREB)",
   label: "Rebordosa (PTREB)"
  },
  {
   value: "Recarei (PTREC)",
   label: "Recarei (PTREC)"
  },
  {
   value: "Redondo (PTRDD)",
   label: "Redondo (PTRDD)"
  },
  {
   value: "Reguengos de Monsaraz (PTRMZ)",
   label: "Reguengos de Monsaraz (PTRMZ)"
  },
  {
   value: "Resende (PTRSD)",
   label: "Resende (PTRSD)"
  },
  {
   value: "Riachos (PTRIA)",
   label: "Riachos (PTRIA)"
  },
  {
   value: "Riba de Ave (PTRDV)",
   label: "Riba de Ave (PTRDV)"
  },
  {
   value: "Ribeira Brava (PTRBR)",
   label: "Ribeira Brava (PTRBR)"
  },
  {
   value: "Ribeira de Frades (PTRIB)",
   label: "Ribeira de Frades (PTRIB)"
  },
  {
   value: "Ribeira de Pena (PTRPN)",
   label: "Ribeira de Pena (PTRPN)"
  },
  {
   value: "Ribeira Grande (PTQEG)",
   label: "Ribeira Grande (PTQEG)"
  },
  {
   value: "Rio Frio (PTRFB)",
   label: "Rio Frio (PTRFB)"
  },
  {
   value: "Romariz (PTRIZ)",
   label: "Romariz (PTRIZ)"
  },
  {
   value: "Sabrosa (PTSBR)",
   label: "Sabrosa (PTSBR)"
  },
  {
   value: "Sabugal (PTSBL)",
   label: "Sabugal (PTSBL)"
  },
  {
   value: "Sabugo (PTTZN)",
   label: "Sabugo (PTTZN)"
  },
  {
   value: "Safara (PTSFR)",
   label: "Safara (PTSFR)"
  },
  {
   value: "Salvaterra de Magos (PTSMG)",
   label: "Salvaterra de Magos (PTSMG)"
  },
  {
   value: "Samora Correia (PTSMR)",
   label: "Samora Correia (PTSMR)"
  },
  {
   value: "Santa Clara-a-Velha (PTSRV)",
   label: "Santa Clara-a-Velha (PTSRV)"
  },
  {
   value: "Santa Comba Dão (PTSCD)",
   label: "Santa Comba Dão (PTSCD)"
  },
  {
   value: "Santa Cruz (PTSCZ)",
   label: "Santa Cruz (PTSCZ)"
  },
  {
   value: "Santa Eulalia de Arnoso (PTEAS)",
   label: "Santa Eulalia de Arnoso (PTEAS)"
  },
  {
   value: "Santa Iria de Azoia (PTSIA)",
   label: "Santa Iria de Azoia (PTSIA)"
  },
  {
   value: "Santa Maria da Feira (PTSMF)",
   label: "Santa Maria da Feira (PTSMF)"
  },
  {
   value: "Santa Maria de Sardoura (PTSMS)",
   label: "Santa Maria de Sardoura (PTSMS)"
  },
  {
   value: "Santa Marta de Penaguião (PTSMP)",
   label: "Santa Marta de Penaguião (PTSMP)"
  },
  {
   value: "Santana (PTSTN)",
   label: "Santana (PTSTN)"
  },
  {
   value: "Santiago de Riba-Ul (PTSRU)",
   label: "Santiago de Riba-Ul (PTSRU)"
  },
  {
   value: "Santiago do Cacém (PTSTC)",
   label: "Santiago do Cacém (PTSTC)"
  },
  {
   value: "Santo Antão do Tojal (PTDTO)",
   label: "Santo Antão do Tojal (PTDTO)"
  },
  {
   value: "São Bartolomeu de Messines (PTSBM)",
   label: "São Bartolomeu de Messines (PTSBM)"
  },
  {
   value: "São Brás de Alportel (PTSBA)",
   label: "São Brás de Alportel (PTSBA)"
  },
  {
   value: "São Domingos de Rana (PTSDR)",
   label: "São Domingos de Rana (PTSDR)"
  },
  {
   value: "São João da Pesqueira (PTSJP)",
   label: "São João da Pesqueira (PTSJP)"
  },
  {
   value: "São João da Talha (PTSJT)",
   label: "São João da Talha (PTSJT)"
  },
  {
   value: "São João de Areias (PTSJA)",
   label: "São João de Areias (PTSJA)"
  },
  {
   value: "São João de Ver (PTSJV)",
   label: "São João de Ver (PTSJV)"
  },
  {
   value: "São Jorge Island Apt (PTSJZ)",
   label: "São Jorge Island Apt (PTSJZ)"
  },
  {
   value: "Sao Juliao do Tojal (PTTZG)",
   label: "Sao Juliao do Tojal (PTTZG)"
  },
  {
   value: "São Mamede de Infesta (PTSMD)",
   label: "São Mamede de Infesta (PTSMD)"
  },
  {
   value: "Sao Paio de Oleiros (PTTZC)",
   label: "Sao Paio de Oleiros (PTTZC)"
  },
  {
   value: "São Pedro do Sul (PTSPS)",
   label: "São Pedro do Sul (PTSPS)"
  },
  {
   value: "São Roque do Pico (PTSRP)",
   label: "São Roque do Pico (PTSRP)"
  },
  {
   value: "São Vicente (PTSVC)",
   label: "São Vicente (PTSVC)"
  },
  {
   value: "São Vicente da Beira (PTSVB)",
   label: "São Vicente da Beira (PTSVB)"
  },
  {
   value: "Sardoal (PTSRD)",
   label: "Sardoal (PTSRD)"
  },
  {
   value: "Sátão (PTSAT)",
   label: "Sátão (PTSAT)"
  },
  {
   value: "Seia (PTSEE)",
   label: "Seia (PTSEE)"
  },
  {
   value: "Seixezelo (PTSXZ)",
   label: "Seixezelo (PTSXZ)"
  },
  {
   value: "Sendim (PTSND)",
   label: "Sendim (PTSND)"
  },
  {
   value: "Senhora da Hora (PTSHA)",
   label: "Senhora da Hora (PTSHA)"
  },
  {
   value: "Sequeira (PTSEQ)",
   label: "Sequeira (PTSEQ)"
  },
  {
   value: "Sernancelhe (PTSRL)",
   label: "Sernancelhe (PTSRL)"
  },
  {
   value: "Serpa (PTSPA)",
   label: "Serpa (PTSPA)"
  },
  {
   value: "Sertã (PTSRT)",
   label: "Sertã (PTSRT)"
  },
  {
   value: "Serzedo (PTSER)",
   label: "Serzedo (PTSER)"
  },
  {
   value: "Sesimbra (PTSSB)",
   label: "Sesimbra (PTSSB)"
  },
  {
   value: "Sever do Vouga (PTSVV)",
   label: "Sever do Vouga (PTSVV)"
  },
  {
   value: "Silveira (PTTZM)",
   label: "Silveira (PTTZM)"
  },
  {
   value: "Silves (PTSLV)",
   label: "Silves (PTSLV)"
  },
  {
   value: "Sintra (PTSTA)",
   label: "Sintra (PTSTA)"
  },
  {
   value: "Soalheira (PTSLH)",
   label: "Soalheira (PTSLH)"
  },
  {
   value: "Sobradelo da Goma (PTSOG)",
   label: "Sobradelo da Goma (PTSOG)"
  },
  {
   value: "Sobral de Monte Agraço (PTSBG)",
   label: "Sobral de Monte Agraço (PTSBG)"
  },
  {
   value: "Sobralinho (PTSOB)",
   label: "Sobralinho (PTSOB)"
  },
  {
   value: "Souzel (PTSSL)",
   label: "Souzel (PTSSL)"
  },
  {
   value: "Souzelas (PTSZL)",
   label: "Souzelas (PTSZL)"
  },
  {
   value: "Tábua (PTTAB)",
   label: "Tábua (PTTAB)"
  },
  {
   value: "Tabuaço (PTTBC)",
   label: "Tabuaço (PTTBC)"
  },
  {
   value: "Tarouca (PTTRC)",
   label: "Tarouca (PTTRC)"
  },
  {
   value: "Tavira (PTTVR)",
   label: "Tavira (PTTVR)"
  },
  {
   value: "Terras de Bouro (PTTBR)",
   label: "Terras de Bouro (PTTBR)"
  },
  {
   value: "Terrugem (PTTRR)",
   label: "Terrugem (PTTRR)"
  },
  {
   value: "Tondela (PTTON)",
   label: "Tondela (PTTON)"
  },
  {
   value: "Topo (PTTPO)",
   label: "Topo (PTTPO)"
  },
  {
   value: "Torrão (PTTOR)",
   label: "Torrão (PTTOR)"
  },
  {
   value: "Torre de Dona Chama (PTTDH)",
   label: "Torre de Dona Chama (PTTDH)"
  },
  {
   value: "Torre de Moncorvo (PTTMC)",
   label: "Torre de Moncorvo (PTTMC)"
  },
  {
   value: "Tortosendo (PTTSO)",
   label: "Tortosendo (PTTSO)"
  },
  {
   value: "Trancoso (PTTCS)",
   label: "Trancoso (PTTCS)"
  },
  {
   value: "Tunes (PTTUN)",
   label: "Tunes (PTTUN)"
  },
  {
   value: "Unhais da Serra (PTCVL)",
   label: "Unhais da Serra (PTCVL)"
  },
  {
   value: "Vagos (PTVGS)",
   label: "Vagos (PTVGS)"
  },
  {
   value: "Valada (PTTZP)",
   label: "Valada (PTTZP)"
  },
  {
   value: "Valadares (PTVDR)",
   label: "Valadares (PTVDR)"
  },
  {
   value: "Vale de Cambra (PTVCA)",
   label: "Vale de Cambra (PTVCA)"
  },
  {
   value: "Valença (PTVLN)",
   label: "Valença (PTVLN)"
  },
  {
   value: "Valpaços (PTVLP)",
   label: "Valpaços (PTVLP)"
  },
  {
   value: "Venda do Pinheiro (PTVDV)",
   label: "Venda do Pinheiro (PTVDV)"
  },
  {
   value: "Vendas Novas (PTVDN)",
   label: "Vendas Novas (PTVDN)"
  },
  {
   value: "Viana do Alentejo (PTVNT)",
   label: "Viana do Alentejo (PTVNT)"
  },
  {
   value: "Viatodos (PTVTD)",
   label: "Viatodos (PTVTD)"
  },
  {
   value: "Vidago (PTVDG)",
   label: "Vidago (PTVDG)"
  },
  {
   value: "Vide (PTVDE)",
   label: "Vide (PTVDE)"
  },
  {
   value: "Vidigueira (PTVGA)",
   label: "Vidigueira (PTVGA)"
  },
  {
   value: "Vieira do Minho (PTVRM)",
   label: "Vieira do Minho (PTVRM)"
  },
  {
   value: "Vila de Rei (PTVLR)",
   label: "Vila de Rei (PTVLR)"
  },
  {
   value: "Vila do Bispo (PTVBP)",
   label: "Vila do Bispo (PTVBP)"
  },
  {
   value: "Vila do Conde (PTVIC)",
   label: "Vila do Conde (PTVIC)"
  },
  {
   value: "Vila Flor (PTVFL)",
   label: "Vila Flor (PTVFL)"
  },
  {
   value: "Vila Franca do Campo (PTVFC)",
   label: "Vila Franca do Campo (PTVFC)"
  },
  {
   value: "Vila Meã (PTVMA)",
   label: "Vila Meã (PTVMA)"
  },
  {
   value: "Vila Moura (PTVIF)",
   label: "Vila Moura (PTVIF)"
  },
  {
   value: "Vila Nogueira de Azeitao (PTTZO)",
   label: "Vila Nogueira de Azeitao (PTTZO)"
  },
  {
   value: "Vila Nova da Barquinha (PTVNB)",
   label: "Vila Nova da Barquinha (PTVNB)"
  },
  {
   value: "Vila Nova da Cerveira (PTVNA)",
   label: "Vila Nova da Cerveira (PTVNA)"
  },
  {
   value: "Vila Nova da Rainha (PTVNR)",
   label: "Vila Nova da Rainha (PTVNR)"
  },
  {
   value: "Vila Nova da Telha (PTVNE)",
   label: "Vila Nova da Telha (PTVNE)"
  },
  {
   value: "Vila Nova de Fozcoa (PTVNZ)",
   label: "Vila Nova de Fozcoa (PTVNZ)"
  },
  {
   value: "Vila Nova de Milfontes (PTVNM)",
   label: "Vila Nova de Milfontes (PTVNM)"
  },
  {
   value: "Vila Nova de Ourém (PTVNO)",
   label: "Vila Nova de Ourém (PTVNO)"
  },
  {
   value: "Vila Nova de Paiva (PTVOP)",
   label: "Vila Nova de Paiva (PTVOP)"
  },
  {
   value: "Vila Nova de Poiares (PTVNP)",
   label: "Vila Nova de Poiares (PTVNP)"
  },
  {
   value: "Vila Nova de Santo André (PTVSA)",
   label: "Vila Nova de Santo André (PTVSA)"
  },
  {
   value: "Vila Pouca de Aguiar (PTVPA)",
   label: "Vila Pouca de Aguiar (PTVPA)"
  },
  {
   value: "Vila Praia de Ancora (PTTZB)",
   label: "Vila Praia de Ancora (PTTZB)"
  },
  {
   value: "Vila Real de Santo António (PTVRE)",
   label: "Vila Real de Santo António (PTVRE)"
  },
  {
   value: "Vila Ruiva (PTVRU)",
   label: "Vila Ruiva (PTVRU)"
  },
  {
   value: "Vila Velha de Ródão (PTVVR)",
   label: "Vila Velha de Ródão (PTVVR)"
  },
  {
   value: "Vila Verde (PTVVD)",
   label: "Vila Verde (PTVVD)"
  },
  {
   value: "Vila Viçosa (PTVIV)",
   label: "Vila Viçosa (PTVIV)"
  },
  {
   value: "Vilar do Pinheiro (PTVPO)",
   label: "Vilar do Pinheiro (PTVPO)"
  },
  {
   value: "Vilar Formoso (PTVLF)",
   label: "Vilar Formoso (PTVLF)"
  },
  {
   value: "Vilarinho (PTVLH)",
   label: "Vilarinho (PTVLH)"
  },
  {
   value: "Vimioso (PTVMS)",
   label: "Vimioso (PTVMS)"
  },
  {
   value: "Vinhais (PTVNH)",
   label: "Vinhais (PTVNH)"
  },
  {
   value: "Vizela (PTZVI)",
   label: "Vizela (PTZVI)"
  },
  {
   value: "Vouzela (PTVZL)",
   label: "Vouzela (PTVZL)"
  },
  {
   value: "Zibreira (PTZIB)",
   label: "Zibreira (PTZIB)"
  },
  {
   value: ".PALAU (PW)",
   label: ".PALAU (PW)"
  },
  {
   value: ".PARAGUAY (PY)",
   label: ".PARAGUAY (PY)"
  },
  {
   value: "Ayolas (PYAYO)",
   label: "Ayolas (PYAYO)"
  },
  {
   value: "Barrio Caacupé Mí (PYBCM)",
   label: "Barrio Caacupé Mí (PYBCM)"
  },
  {
   value: "Caacupé (PYCAA)",
   label: "Caacupé (PYCAA)"
  },
  {
   value: "Colonia Mariano Roque Alonso (PYMRA)",
   label: "Colonia Mariano Roque Alonso (PYMRA)"
  },
  {
   value: "Fenix (PYFNX)",
   label: "Fenix (PYFNX)"
  },
  {
   value: "Filadelfia (PYFLM)",
   label: "Filadelfia (PYFLM)"
  },
  {
   value: "Fuerte Olimpo (PYFUO)",
   label: "Fuerte Olimpo (PYFUO)"
  },
  {
   value: "Mariscal Estigarribia (PYESG)",
   label: "Mariscal Estigarribia (PYESG)"
  },
  {
   value: "Pedro Juan Caballero (PYPJC)",
   label: "Pedro Juan Caballero (PYPJC)"
  },
  {
   value: "Puerto la Victoria (PYPCJ)",
   label: "Puerto la Victoria (PYPCJ)"
  },
  {
   value: "San Ygnacio (PYSYG)",
   label: "San Ygnacio (PYSYG)"
  },
  {
   value: "Terport (San Antonio) (PYTER)",
   label: "Terport (San Antonio) (PYTER)"
  },
  {
   value: "Vallemi (PYVMI)",
   label: "Vallemi (PYVMI)"
  },
  {
   value: "Villa Elisa (PYVEL)",
   label: "Villa Elisa (PYVEL)"
  },
  {
   value: ".QATAR (QA)",
   label: ".QATAR (QA)"
  },
  {
   value: "Al Shaheen (QAASN)",
   label: "Al Shaheen (QAASN)"
  },
  {
   value: "Al Udeid (QAALU)",
   label: "Al Udeid (QAALU)"
  },
  {
   value: "Qapco (QAQAP)",
   label: "Qapco (QAQAP)"
  },
  {
   value: "Qchem (QAQCH)",
   label: "Qchem (QAQCH)"
  },
  {
   value: "Ras Laffan (QARLF)",
   label: "Ras Laffan (QARLF)"
  },
  {
   value: ".RÉUNION (RE)",
   label: ".RÉUNION (RE)"
  },
  {
   value: "Etang Sale les Hauts (REESH)",
   label: "Etang Sale les Hauts (REESH)"
  },
  {
   value: "La Saline les Hauts (RESLH)",
   label: "La Saline les Hauts (RESLH)"
  },
  {
   value: "Le Tampon (RELTM)",
   label: "Le Tampon (RELTM)"
  },
  {
   value: "Plaine des Cafres (RECAF)",
   label: "Plaine des Cafres (RECAF)"
  },
  {
   value: "Plaine des Palmistes (REPAL)",
   label: "Plaine des Palmistes (REPAL)"
  },
  {
   value: "Possession (REPOS)",
   label: "Possession (REPOS)"
  },
  {
   value: "Réunion (REREU)",
   label: "Réunion (REREU)"
  },
  {
   value: "Saint-André (RESDR)",
   label: "Saint-André (RESDR)"
  },
  {
   value: "Saint-Gilles-les Bains (RESGL)",
   label: "Saint-Gilles-les Bains (RESGL)"
  },
  {
   value: "Saint-Joseph (RESJH)",
   label: "Saint-Joseph (RESJH)"
  },
  {
   value: "Saint-Paul (RESPL)",
   label: "Saint-Paul (RESPL)"
  },
  {
   value: "Saint-Philippe (RESPH)",
   label: "Saint-Philippe (RESPH)"
  },
  {
   value: "Sat Louis (RESLO)",
   label: "Sat Louis (RESLO)"
  },
  {
   value: "St Benoit (REBNT)",
   label: "St Benoit (REBNT)"
  },
  {
   value: "St Leu (RELEU)",
   label: "St Leu (RELEU)"
  },
  {
   value: "St Pierre de la Reunion (REZSE)",
   label: "St Pierre de la Reunion (REZSE)"
  },
  {
   value: "Ste Anne (REANN)",
   label: "Ste Anne (REANN)"
  },
  {
   value: "Ste Marie (RESMA)",
   label: "Ste Marie (RESMA)"
  },
  {
   value: "Ste Suzanne (RESSZ)",
   label: "Ste Suzanne (RESSZ)"
  },
  {
   value: ".ROMANIA (RO)",
   label: ".ROMANIA (RO)"
  },
  {
   value: "Abram (ROABM)",
   label: "Abram (ROABM)"
  },
  {
   value: "Acatari (ROATI)",
   label: "Acatari (ROATI)"
  },
  {
   value: "Adunatii-Copaceni (ROADC)",
   label: "Adunatii-Copaceni (ROADC)"
  },
  {
   value: "Afumati (ROAMI)",
   label: "Afumati (ROAMI)"
  },
  {
   value: "Alba Iulia (ROALI)",
   label: "Alba Iulia (ROALI)"
  },
  {
   value: "Albesti (ROALB)",
   label: "Albesti (ROALB)"
  },
  {
   value: "Alesd (ROALD)",
   label: "Alesd (ROALD)"
  },
  {
   value: "Alexandria (ROALX)",
   label: "Alexandria (ROALX)"
  },
  {
   value: "Alexandru cel Bun (ROACB)",
   label: "Alexandru cel Bun (ROACB)"
  },
  {
   value: "Apahida (ROAPA)",
   label: "Apahida (ROAPA)"
  },
  {
   value: "Avrig (ROAVG)",
   label: "Avrig (ROAVG)"
  },
  {
   value: "Avrig (ROAVR)",
   label: "Avrig (ROAVR)"
  },
  {
   value: "Baciu, Cluj (ROBCU)",
   label: "Baciu, Cluj (ROBCU)"
  },
  {
   value: "Bacova (ROBCO)",
   label: "Bacova (ROBCO)"
  },
  {
   value: "Baile Tusnad (ROBTD)",
   label: "Baile Tusnad (ROBTD)"
  },
  {
   value: "Balesti (ROBAI)",
   label: "Balesti (ROBAI)"
  },
  {
   value: "Balotesti (RORRM)",
   label: "Balotesti (RORRM)"
  },
  {
   value: "Bals (ROBAL)",
   label: "Bals (ROBAL)"
  },
  {
   value: "Bârcea-Mare (ROBMA)",
   label: "Bârcea-Mare (ROBMA)"
  },
  {
   value: "Bârlad (ROBRL)",
   label: "Bârlad (ROBRL)"
  },
  {
   value: "Barticesti (ROBAR)",
   label: "Barticesti (ROBAR)"
  },
  {
   value: "Bascov (ROBAS)",
   label: "Bascov (ROBAS)"
  },
  {
   value: "Bazias (ROBZI)",
   label: "Bazias (ROBZI)"
  },
  {
   value: "Bechet&nbsp; (ROBCT)",
   label: "Bechet&nbsp; (ROBCT)"
  },
  {
   value: "Becicherecu Mic (ROBUM)",
   label: "Becicherecu Mic (ROBUM)"
  },
  {
   value: "Beclean (ROBCN)",
   label: "Beclean (ROBCN)"
  },
  {
   value: "Berca (ROBEC)",
   label: "Berca (ROBEC)"
  },
  {
   value: "Berca (ROBRC)",
   label: "Berca (ROBRC)"
  },
  {
   value: "Blaj (ROBLA)",
   label: "Blaj (ROBLA)"
  },
  {
   value: "Blejesti (ROBJE)",
   label: "Blejesti (ROBJE)"
  },
  {
   value: "Blejoi (ROBLJ)",
   label: "Blejoi (ROBLJ)"
  },
  {
   value: "Bobota (ROBOB)",
   label: "Bobota (ROBOB)"
  },
  {
   value: "Bocsa (ROBOC)",
   label: "Bocsa (ROBOC)"
  },
  {
   value: "Bodesti (ROBDI)",
   label: "Bodesti (ROBDI)"
  },
  {
   value: "Boldesti-Scaeni (ROBLT)",
   label: "Boldesti-Scaeni (ROBLT)"
  },
  {
   value: "Bolintin Vale (ROBOV)",
   label: "Bolintin Vale (ROBOV)"
  },
  {
   value: "Borca (ROBCA)",
   label: "Borca (ROBCA)"
  },
  {
   value: "Borsa (ROBOA)",
   label: "Borsa (ROBOA)"
  },
  {
   value: "Borsec (ROBSC)",
   label: "Borsec (ROBSC)"
  },
  {
   value: "Bozovici (ROBOZ)",
   label: "Bozovici (ROBOZ)"
  },
  {
   value: "Brad, Hunedoara (ROBRD)",
   label: "Brad, Hunedoara (ROBRD)"
  },
  {
   value: "Bragadiru, Ilfov (ROBDU)",
   label: "Bragadiru, Ilfov (ROBDU)"
  },
  {
   value: "Branesti (ROBTS)",
   label: "Branesti (ROBTS)"
  },
  {
   value: "Bratca (ROBRT)",
   label: "Bratca (ROBRT)"
  },
  {
   value: "Brazii (ROBII)",
   label: "Brazii (ROBII)"
  },
  {
   value: "Breaza, Prahova (ROBZA)",
   label: "Breaza, Prahova (ROBZA)"
  },
  {
   value: "Brebu (ROBRE)",
   label: "Brebu (ROBRE)"
  },
  {
   value: "Buces (ROBUC)",
   label: "Buces (ROBUC)"
  },
  {
   value: "Budesti, Calarasi (ROBUD)",
   label: "Budesti, Calarasi (ROBUD)"
  },
  {
   value: "Buftea (ROBUF)",
   label: "Buftea (ROBUF)"
  },
  {
   value: "Buzias (ROBZS)",
   label: "Buzias (ROBZS)"
  },
  {
   value: "Calarasi (ROCRS)",
   label: "Calarasi (ROCRS)"
  },
  {
   value: "Campeni (ROCPI)",
   label: "Campeni (ROCPI)"
  },
  {
   value: "Campia Turzii (ROCTI)",
   label: "Campia Turzii (ROCTI)"
  },
  {
   value: "Câmpina (ROCAM)",
   label: "Câmpina (ROCAM)"
  },
  {
   value: "Campulung Muscel (RORZD)",
   label: "Campulung Muscel (RORZD)"
  },
  {
   value: "Caracal (ROCCL)",
   label: "Caracal (ROCCL)"
  },
  {
   value: "Carcea (ROCCA)",
   label: "Carcea (ROCCA)"
  },
  {
   value: "Ceptura (ROPTR)",
   label: "Ceptura (ROPTR)"
  },
  {
   value: "Cerasu (ROCRU)",
   label: "Cerasu (ROCRU)"
  },
  {
   value: "Cernica (ROCER)",
   label: "Cernica (ROCER)"
  },
  {
   value: "Chiajna (ROCJA)",
   label: "Chiajna (ROCJA)"
  },
  {
   value: "Chimindia (ROCHM)",
   label: "Chimindia (ROCHM)"
  },
  {
   value: "Chirnogi (ROCNO)",
   label: "Chirnogi (ROCNO)"
  },
  {
   value: "Chiselet (ROCHI)",
   label: "Chiselet (ROCHI)"
  },
  {
   value: "Chisoda (ROCSO)",
   label: "Chisoda (ROCSO)"
  },
  {
   value: "Chitila (ROCTA)",
   label: "Chitila (ROCTA)"
  },
  {
   value: "Cîlnic, Gorj (ROCNC)",
   label: "Cîlnic, Gorj (ROCNC)"
  },
  {
   value: "Cîmpulung (ROCLG)",
   label: "Cîmpulung (ROCLG)"
  },
  {
   value: "Cîmpulung la Tisa (ROCPG)",
   label: "Cîmpulung la Tisa (ROCPG)"
  },
  {
   value: "Clinceni (ROCCI)",
   label: "Clinceni (ROCCI)"
  },
  {
   value: "Codlea (ROCLA)",
   label: "Codlea (ROCLA)"
  },
  {
   value: "Colibasi (ROCBI)",
   label: "Colibasi (ROCBI)"
  },
  {
   value: "Comanesti (ROCOM)",
   label: "Comanesti (ROCOM)"
  },
  {
   value: "Comuna Cincu (ROCOA)",
   label: "Comuna Cincu (ROCOA)"
  },
  {
   value: "Comuna Voineasa (ROCVO)",
   label: "Comuna Voineasa (ROCVO)"
  },
  {
   value: "Corbeanca (ROCRB)",
   label: "Corbeanca (ROCRB)"
  },
  {
   value: "Cornetu, Ilfov (ROCNU)",
   label: "Cornetu, Ilfov (ROCNU)"
  },
  {
   value: "Cornu Luncii (ROCLU)",
   label: "Cornu Luncii (ROCLU)"
  },
  {
   value: "Corunca (ROCOR)",
   label: "Corunca (ROCOR)"
  },
  {
   value: "Costisa (ROCSS)",
   label: "Costisa (ROCSS)"
  },
  {
   value: "Covasna (ROCOV)",
   label: "Covasna (ROCOV)"
  },
  {
   value: "Craiova (ROCRV)",
   label: "Craiova (ROCRV)"
  },
  {
   value: "Criseni (ROCRI)",
   label: "Criseni (ROCRI)"
  },
  {
   value: "Cristian (ROCRT)",
   label: "Cristian (ROCRT)"
  },
  {
   value: "Curtea de Arges (ROCDA)",
   label: "Curtea de Arges (ROCDA)"
  },
  {
   value: "Darasti (RODRS)",
   label: "Darasti (RODRS)"
  },
  {
   value: "Dascalu (RODCU)",
   label: "Dascalu (RODCU)"
  },
  {
   value: "Dealu Floreni (ROFLO)",
   label: "Dealu Floreni (ROFLO)"
  },
  {
   value: "Dej (RODEJ)",
   label: "Dej (RODEJ)"
  },
  {
   value: "Deva (RODVA)",
   label: "Deva (RODVA)"
  },
  {
   value: "Dîmbovita (RODIM)",
   label: "Dîmbovita (RODIM)"
  },
  {
   value: "Dinkelsbühl (RODIN)",
   label: "Dinkelsbühl (RODIN)"
  },
  {
   value: "Dobrana (RODBA)",
   label: "Dobrana (RODBA)"
  },
  {
   value: "Doicesti (RODOI)",
   label: "Doicesti (RODOI)"
  },
  {
   value: "Domnesti (ROBDM)",
   label: "Domnesti (ROBDM)"
  },
  {
   value: "Dorna Cândrenilor (RODCD)",
   label: "Dorna Cândrenilor (RODCD)"
  },
  {
   value: "Dorohoi (RODHO)",
   label: "Dorohoi (RODHO)"
  },
  {
   value: "Draganesti-Vlasca (RODGV)",
   label: "Draganesti-Vlasca (RODGV)"
  },
  {
   value: "Dragasani (RODSI)",
   label: "Dragasani (RODSI)"
  },
  {
   value: "Drajna de Jos (RORZZ)",
   label: "Drajna de Jos (RORZZ)"
  },
  {
   value: "Dulcesti, Neamt (RODCI)",
   label: "Dulcesti, Neamt (RODCI)"
  },
  {
   value: "Dumbraveni, Sibiu (RODBR)",
   label: "Dumbraveni, Sibiu (RODBR)"
  },
  {
   value: "Dumbravita, Timis (RODVI)",
   label: "Dumbravita, Timis (RODVI)"
  },
  {
   value: "Fagaras (ROFGA)",
   label: "Fagaras (ROFGA)"
  },
  {
   value: "Falticeni (ROFAL)",
   label: "Falticeni (ROFAL)"
  },
  {
   value: "Fieni (ROFEI)",
   label: "Fieni (ROFEI)"
  },
  {
   value: "Filipestii de Padure (ROFDP)",
   label: "Filipestii de Padure (ROFDP)"
  },
  {
   value: "Floresti (ROFRT)",
   label: "Floresti (ROFRT)"
  },
  {
   value: "Frumusani (ROFMU)",
   label: "Frumusani (ROFMU)"
  },
  {
   value: "Fundulea (RORZE)",
   label: "Fundulea (RORZE)"
  },
  {
   value: "Gaesti (ROGAE)",
   label: "Gaesti (ROGAE)"
  },
  {
   value: "Ganesti (ROGNI)",
   label: "Ganesti (ROGNI)"
  },
  {
   value: "Gârla-Mare (ROGMA)",
   label: "Gârla-Mare (ROGMA)"
  },
  {
   value: "Gavojdia (ROGAV)",
   label: "Gavojdia (ROGAV)"
  },
  {
   value: "Geoagiu (ROGDS)",
   label: "Geoagiu (ROGDS)"
  },
  {
   value: "Gheorgheni (ROGGH)",
   label: "Gheorgheni (ROGGH)"
  },
  {
   value: "Gheraesti (ROGEI)",
   label: "Gheraesti (ROGEI)"
  },
  {
   value: "Gherla (ROGHL)",
   label: "Gherla (ROGHL)"
  },
  {
   value: "Gherta Mare (ROGHM)",
   label: "Gherta Mare (ROGHM)"
  },
  {
   value: "Ghimbav (ROGHV)",
   label: "Ghimbav (ROGHV)"
  },
  {
   value: "Ghiroda (ROGRD)",
   label: "Ghiroda (ROGRD)"
  },
  {
   value: "Gilau (ROGIL)",
   label: "Gilau (ROGIL)"
  },
  {
   value: "Giubega (ROGIU)",
   label: "Giubega (ROGIU)"
  },
  {
   value: "Giulesti (ROGLE)",
   label: "Giulesti (ROGLE)"
  },
  {
   value: "Gruia (ROGRA)",
   label: "Gruia (ROGRA)"
  },
  {
   value: "Grumazesti (ROGMZ)",
   label: "Grumazesti (ROGMZ)"
  },
  {
   value: "Gura Vadului (ROGVD)",
   label: "Gura Vadului (ROGVD)"
  },
  {
   value: "Hangu (ROHGU)",
   label: "Hangu (ROHGU)"
  },
  {
   value: "Hârsova (RORVA)",
   label: "Hârsova (RORVA)"
  },
  {
   value: "Hateg, Hunedoara (ROHTG)",
   label: "Hateg, Hunedoara (ROHTG)"
  },
  {
   value: "Hida (ROHID)",
   label: "Hida (ROHID)"
  },
  {
   value: "Hintesti (ROHTI)",
   label: "Hintesti (ROHTI)"
  },
  {
   value: "Hodosa (RORZF)",
   label: "Hodosa (RORZF)"
  },
  {
   value: "Huedin (RORZG)",
   label: "Huedin (RORZG)"
  },
  {
   value: "Hunedoara (ROHUN)",
   label: "Hunedoara (ROHUN)"
  },
  {
   value: "Husi (RORZH)",
   label: "Husi (RORZH)"
  },
  {
   value: "Ialomica, Judecul (ROIMA)",
   label: "Ialomica, Judecul (ROIMA)"
  },
  {
   value: "Ianca (RORZI)",
   label: "Ianca (RORZI)"
  },
  {
   value: "Ilfoveni (ROILF)",
   label: "Ilfoveni (ROILF)"
  },
  {
   value: "Ivesti, Galati (ROIVE)",
   label: "Ivesti, Galati (ROIVE)"
  },
  {
   value: "Izbiceni (ROIZB)",
   label: "Izbiceni (ROIZB)"
  },
  {
   value: "Jilava (ROJVA)",
   label: "Jilava (ROJVA)"
  },
  {
   value: "Jucu-Herghelia (RORZK)",
   label: "Jucu-Herghelia (RORZK)"
  },
  {
   value: "Jud. Maramures (ROJUD)",
   label: "Jud. Maramures (ROJUD)"
  },
  {
   value: "Lancram (ROLRM)",
   label: "Lancram (ROLRM)"
  },
  {
   value: "Lasi (ROLAS)",
   label: "Lasi (ROLAS)"
  },
  {
   value: "Lemnia (ROLMN)",
   label: "Lemnia (ROLMN)"
  },
  {
   value: "Ludus (RORZL)",
   label: "Ludus (RORZL)"
  },
  {
   value: "Lugoj (ROLUG)",
   label: "Lugoj (ROLUG)"
  },
  {
   value: "Lumina (ROLMA)",
   label: "Lumina (ROLMA)"
  },
  {
   value: "Lunca Muresului, Alba (ROLMU)",
   label: "Lunca Muresului, Alba (ROLMU)"
  },
  {
   value: "Lunguletu (ROLGU)",
   label: "Lunguletu (ROLGU)"
  },
  {
   value: "Magheru (ROMGH)",
   label: "Magheru (ROMGH)"
  },
  {
   value: "Malini (RORZJ)",
   label: "Malini (RORZJ)"
  },
  {
   value: "Margineni (RORZM)",
   label: "Margineni (RORZM)"
  },
  {
   value: "Mateesti (ROMTI)",
   label: "Mateesti (ROMTI)"
  },
  {
   value: "Medias (ROMES)",
   label: "Medias (ROMES)"
  },
  {
   value: "Mediesu Aurit (ROMAU)",
   label: "Mediesu Aurit (ROMAU)"
  },
  {
   value: "Mehadia (ROMDA)",
   label: "Mehadia (ROMDA)"
  },
  {
   value: "Miercurea Sibiului (RORZP)",
   label: "Miercurea Sibiului (RORZP)"
  },
  {
   value: "Miercurea-Ciuc (ROMCA)",
   label: "Miercurea-Ciuc (ROMCA)"
  },
  {
   value: "Mihai Viteazu (ROMVU)",
   label: "Mihai Viteazu (ROMVU)"
  },
  {
   value: "Mihail Kogalniceanu (ROMKO)",
   label: "Mihail Kogalniceanu (ROMKO)"
  },
  {
   value: "Mihailesti (ROMHE)",
   label: "Mihailesti (ROMHE)"
  },
  {
   value: "Mintia (RORZN)",
   label: "Mintia (RORZN)"
  },
  {
   value: "Mioveni (ROENI)",
   label: "Mioveni (ROENI)"
  },
  {
   value: "Mizil (RORZA)",
   label: "Mizil (RORZA)"
  },
  {
   value: "Mogosoaia (ROMSA)",
   label: "Mogosoaia (ROMSA)"
  },
  {
   value: "Moinesti (ROMNI)",
   label: "Moinesti (ROMNI)"
  },
  {
   value: "Moisei (ROMSI)",
   label: "Moisei (ROMSI)"
  },
  {
   value: "Moiseni (ROMOI)",
   label: "Moiseni (ROMOI)"
  },
  {
   value: "Moldova Noua (RORZY)",
   label: "Moldova Noua (RORZY)"
  },
  {
   value: "Moreni, Dimbovita (ROMRI)",
   label: "Moreni, Dimbovita (ROMRI)"
  },
  {
   value: "Mosnita Noua (ROMON)",
   label: "Mosnita Noua (ROMON)"
  },
  {
   value: "Murfatlar (ROMUR)",
   label: "Murfatlar (ROMUR)"
  },
  {
   value: "Nadab (RONDB)",
   label: "Nadab (RONDB)"
  },
  {
   value: "Navodari (RONDI)",
   label: "Navodari (RONDI)"
  },
  {
   value: "Nazna (RONAZ)",
   label: "Nazna (RONAZ)"
  },
  {
   value: "Nehoiu (RORZW)",
   label: "Nehoiu (RORZW)"
  },
  {
   value: "Novacu (RONVA)",
   label: "Novacu (RONVA)"
  },
  {
   value: "Oarda de Sus (ROOAR)",
   label: "Oarda de Sus (ROOAR)"
  },
  {
   value: "Ocna Mures (ROOCM)",
   label: "Ocna Mures (ROOCM)"
  },
  {
   value: "Odorheiu Secuiesc (ROOSE)",
   label: "Odorheiu Secuiesc (ROOSE)"
  },
  {
   value: "Oglinzi (ROOGI)",
   label: "Oglinzi (ROOGI)"
  },
  {
   value: "Oituz, Bacau (ROOTZ)",
   label: "Oituz, Bacau (ROOTZ)"
  },
  {
   value: "Onesti, Bacau (ROOSI)",
   label: "Onesti, Bacau (ROOSI)"
  },
  {
   value: "Oprisor (ROOPR)",
   label: "Oprisor (ROOPR)"
  },
  {
   value: "Oravita (ROOVA)",
   label: "Oravita (ROOVA)"
  },
  {
   value: "Orodelu (ROODL)",
   label: "Orodelu (ROODL)"
  },
  {
   value: "Otopeni (ROOTI)",
   label: "Otopeni (ROOTI)"
  },
  {
   value: "Panciu (ROPNC)",
   label: "Panciu (ROPNC)"
  },
  {
   value: "Panic (ROPAN)",
   label: "Panic (ROPAN)"
  },
  {
   value: "Pantelimon (ROPNT)",
   label: "Pantelimon (ROPNT)"
  },
  {
   value: "Pascani (ROPAS)",
   label: "Pascani (ROPAS)"
  },
  {
   value: "Pascani (ROPCI)",
   label: "Pascani (ROPCI)"
  },
  {
   value: "Pecica (ROPCA)",
   label: "Pecica (ROPCA)"
  },
  {
   value: "Peris, Ilfov (ROPRS)",
   label: "Peris, Ilfov (ROPRS)"
  },
  {
   value: "Petresti (ROPET)",
   label: "Petresti (ROPET)"
  },
  {
   value: "Petrila, Hunedoara (ROPRA)",
   label: "Petrila, Hunedoara (ROPRA)"
  },
  {
   value: "Petrosani (ROPEI)",
   label: "Petrosani (ROPEI)"
  },
  {
   value: "Piatra Olt (ROPIA)",
   label: "Piatra Olt (ROPIA)"
  },
  {
   value: "Pietrari, Valcea (ROPTI)",
   label: "Pietrari, Valcea (ROPTI)"
  },
  {
   value: "Pietroasa (ROPOA)",
   label: "Pietroasa (ROPOA)"
  },
  {
   value: "Plopeni (ROPLO)",
   label: "Plopeni (ROPLO)"
  },
  {
   value: "Podari (ROPDR)",
   label: "Podari (ROPDR)"
  },
  {
   value: "Poiana Negrii (ROPNG)",
   label: "Poiana Negrii (ROPNG)"
  },
  {
   value: "Poiana Sibiului (ROPSI)",
   label: "Poiana Sibiului (ROPSI)"
  },
  {
   value: "Poienarii de Muscel (ROPDM)",
   label: "Poienarii de Muscel (ROPDM)"
  },
  {
   value: "Polovragi (ROPRI)",
   label: "Polovragi (ROPRI)"
  },
  {
   value: "Popesti-Leordeni (ROPLE)",
   label: "Popesti-Leordeni (ROPLE)"
  },
  {
   value: "Pucioasa (ROPUA)",
   label: "Pucioasa (ROPUA)"
  },
  {
   value: "Rachitova (RORAC)",
   label: "Rachitova (RORAC)"
  },
  {
   value: "Radauti (RORDU)",
   label: "Radauti (RORDU)"
  },
  {
   value: "Rasnov (RORNV)",
   label: "Rasnov (RORNV)"
  },
  {
   value: "Razboieni (RORBI)",
   label: "Razboieni (RORBI)"
  },
  {
   value: "Recas (ROREC)",
   label: "Recas (ROREC)"
  },
  {
   value: "Reghin (RORHN)",
   label: "Reghin (RORHN)"
  },
  {
   value: "Remetea, Harghita (RORMA)",
   label: "Remetea, Harghita (RORMA)"
  },
  {
   value: "Resita (ROREA)",
   label: "Resita (ROREA)"
  },
  {
   value: "Rimnicu Vilcea (RORZQ)",
   label: "Rimnicu Vilcea (RORZQ)"
  },
  {
   value: "Roman (RORMN)",
   label: "Roman (RORMN)"
  },
  {
   value: "Romuli (RORMI)",
   label: "Romuli (RORMI)"
  },
  {
   value: "Rona de Sus (RORDS)",
   label: "Rona de Sus (RORDS)"
  },
  {
   value: "Rovinari (ROROV)",
   label: "Rovinari (ROROV)"
  },
  {
   value: "Rucar (RORCR)",
   label: "Rucar (RORCR)"
  },
  {
   value: "Rupea (RORUP)",
   label: "Rupea (RORUP)"
  },
  {
   value: "Sabaoani (ROSOI)",
   label: "Sabaoani (ROSOI)"
  },
  {
   value: "Sacalaz (RORZR)",
   label: "Sacalaz (RORZR)"
  },
  {
   value: "Sacele (RORZS)",
   label: "Sacele (RORZS)"
  },
  {
   value: "Salciua de Jos (ROSDJ)",
   label: "Salciua de Jos (ROSDJ)"
  },
  {
   value: "Saliste (ROSLE)",
   label: "Saliste (ROSLE)"
  },
  {
   value: "Sascut (ROSAS)",
   label: "Sascut (ROSAS)"
  },
  {
   value: "Sat Valea Draganului (ROSVD)",
   label: "Sat Valea Draganului (ROSVD)"
  },
  {
   value: "Saulia (ROSAU)",
   label: "Saulia (ROSAU)"
  },
  {
   value: "Saveni (ROSAV)",
   label: "Saveni (ROSAV)"
  },
  {
   value: "Savinesti (ROVST)",
   label: "Savinesti (ROVST)"
  },
  {
   value: "Sebes, Alba (ROSBS)",
   label: "Sebes, Alba (ROSBS)"
  },
  {
   value: "Secueni (ROSEC)",
   label: "Secueni (ROSEC)"
  },
  {
   value: "Seini (ROSNI)",
   label: "Seini (ROSNI)"
  },
  {
   value: "Seitin (ROSEI)",
   label: "Seitin (ROSEI)"
  },
  {
   value: "Sfantul-Gheorghe (ROSFG)",
   label: "Sfantul-Gheorghe (ROSFG)"
  },
  {
   value: "Sighisoara (ROSSA)",
   label: "Sighisoara (ROSSA)"
  },
  {
   value: "Simleu Silvaniei (ROSJS)",
   label: "Simleu Silvaniei (ROSJS)"
  },
  {
   value: "Sinaia (RORZT)",
   label: "Sinaia (RORZT)"
  },
  {
   value: "Sincraieni (ROSCI)",
   label: "Sincraieni (ROSCI)"
  },
  {
   value: "Sîncraiu de Mures (ROSDM)",
   label: "Sîncraiu de Mures (ROSDM)"
  },
  {
   value: "Sîntana de Mures (ROSMU)",
   label: "Sîntana de Mures (ROSMU)"
  },
  {
   value: "Sintereag (ROSTG)",
   label: "Sintereag (ROSTG)"
  },
  {
   value: "Slatina (ROSLA)",
   label: "Slatina (ROSLA)"
  },
  {
   value: "Slobozia (ROSBA)",
   label: "Slobozia (ROSBA)"
  },
  {
   value: "Slobozia Sucevei (ROSLS)",
   label: "Slobozia Sucevei (ROSLS)"
  },
  {
   value: "Slobozia, Arges (ROSLO)",
   label: "Slobozia, Arges (ROSLO)"
  },
  {
   value: "Smârdan (ROSDN)",
   label: "Smârdan (ROSDN)"
  },
  {
   value: "Snagov (ROSGV)",
   label: "Snagov (ROSGV)"
  },
  {
   value: "Socetu (ROSOC)",
   label: "Socetu (ROSOC)"
  },
  {
   value: "Sovata (RORZU)",
   label: "Sovata (RORZU)"
  },
  {
   value: "Soveja (ROSOV)",
   label: "Soveja (ROSOV)"
  },
  {
   value: "Stalpeni (RORZC)",
   label: "Stalpeni (RORZC)"
  },
  {
   value: "Stefanesti, Arges (ROSTI)",
   label: "Stefanesti, Arges (ROSTI)"
  },
  {
   value: "Suncuius (ROSCS)",
   label: "Suncuius (ROSCS)"
  },
  {
   value: "Târgoviste (ROTAR)",
   label: "Târgoviste (ROTAR)"
  },
  {
   value: "Targu Neamt (RORZO)",
   label: "Targu Neamt (RORZO)"
  },
  {
   value: "Târgu Ocna (ROTAO)",
   label: "Târgu Ocna (ROTAO)"
  },
  {
   value: "Târgu Secuiesc (ROTSC)",
   label: "Târgu Secuiesc (ROTSC)"
  },
  {
   value: "Tarju Jiu (ROTJI)",
   label: "Tarju Jiu (ROTJI)"
  },
  {
   value: "Tarnaveni (ROTVI)",
   label: "Tarnaveni (ROTVI)"
  },
  {
   value: "Teleorman (ROTON)",
   label: "Teleorman (ROTON)"
  },
  {
   value: "Teregova (ROTGA)",
   label: "Teregova (ROTGA)"
  },
  {
   value: "Tetchea (ROTET)",
   label: "Tetchea (ROTET)"
  },
  {
   value: "Ticleni (ROTIC)",
   label: "Ticleni (ROTIC)"
  },
  {
   value: "Tiganesti (ROTIG)",
   label: "Tiganesti (ROTIG)"
  },
  {
   value: "Tileagd (ROTAD)",
   label: "Tileagd (ROTAD)"
  },
  {
   value: "Tîrgu Jiu (ROTJU)",
   label: "Tîrgu Jiu (ROTJU)"
  },
  {
   value: "Tohani (ROTOH)",
   label: "Tohani (ROTOH)"
  },
  {
   value: "Tonesti, Olt (ROTNI)",
   label: "Tonesti, Olt (ROTNI)"
  },
  {
   value: "Turda (ROTDA)",
   label: "Turda (ROTDA)"
  },
  {
   value: "Turnu (ROTUR)",
   label: "Turnu (ROTUR)"
  },
  {
   value: "Turnu Rosu (ROTRO)",
   label: "Turnu Rosu (ROTRO)"
  },
  {
   value: "Unirea (ROURA)",
   label: "Unirea (ROURA)"
  },
  {
   value: "Urziceni (ROURZ)",
   label: "Urziceni (ROURZ)"
  },
  {
   value: "Vacaresti, Dimbovita (ROVRI)",
   label: "Vacaresti, Dimbovita (ROVRI)"
  },
  {
   value: "Vadu Izei (ROVIZ)",
   label: "Vadu Izei (ROVIZ)"
  },
  {
   value: "Vaduri (RORZX)",
   label: "Vaduri (RORZX)"
  },
  {
   value: "Valea Lunga (ROVAL)",
   label: "Valea Lunga (ROVAL)"
  },
  {
   value: "Valenii de Munte (ROVDM)",
   label: "Valenii de Munte (ROVDM)"
  },
  {
   value: "Vanatori (ROTRI)",
   label: "Vanatori (ROTRI)"
  },
  {
   value: "Vanatorii-Mari (ROVMA)",
   label: "Vanatorii-Mari (ROVMA)"
  },
  {
   value: "Vaslui (ROVLI)",
   label: "Vaslui (ROVLI)"
  },
  {
   value: "Vatra Dornei (ROVDO)",
   label: "Vatra Dornei (ROVDO)"
  },
  {
   value: "Vernesti (ROVER)",
   label: "Vernesti (ROVER)"
  },
  {
   value: "Victoria (RORZB)",
   label: "Victoria (RORZB)"
  },
  {
   value: "Videle (ROVDE)",
   label: "Videle (ROVDE)"
  },
  {
   value: "Vidra, Vrancea (ROVDR)",
   label: "Vidra, Vrancea (ROVDR)"
  },
  {
   value: "Viseu de Sus (ROVDS)",
   label: "Viseu de Sus (ROVDS)"
  },
  {
   value: "Vladesti (ROVDI)",
   label: "Vladesti (ROVDI)"
  },
  {
   value: "Vladimirescu (ROVEU)",
   label: "Vladimirescu (ROVEU)"
  },
  {
   value: "Vlahita (ROVLA)",
   label: "Vlahita (ROVLA)"
  },
  {
   value: "Voine_ti (ROVNI)",
   label: "Voine_ti (ROVNI)"
  },
  {
   value: "Voiteg (ROVTG)",
   label: "Voiteg (ROVTG)"
  },
  {
   value: "Voluntari (ROVOL)",
   label: "Voluntari (ROVOL)"
  },
  {
   value: "Zalau (ROZAU)",
   label: "Zalau (ROZAU)"
  },
  {
   value: "Zarnesti (ROZAR)",
   label: "Zarnesti (ROZAR)"
  },
  {
   value: "Zlatna (ROZTA)",
   label: "Zlatna (ROZTA)"
  },
  {
   value: ".SERBIA (RS)",
   label: ".SERBIA (RS)"
  },
  {
   value: "Ada (RSADA)",
   label: "Ada (RSADA)"
  },
  {
   value: "Apatin (RSAPT)",
   label: "Apatin (RSAPT)"
  },
  {
   value: "Arandjelovac (RSALC)",
   label: "Arandjelovac (RSALC)"
  },
  {
   value: "Arilje (RSARJ)",
   label: "Arilje (RSARJ)"
  },
  {
   value: "Backa Palanka (RSBPA)",
   label: "Backa Palanka (RSBPA)"
  },
  {
   value: "Backa Topola (RSBTO)",
   label: "Backa Topola (RSBTO)"
  },
  {
   value: "Banatski Karlovac (RSSZB)",
   label: "Banatski Karlovac (RSSZB)"
  },
  {
   value: "Banatsko Karadjordjevo (RSBKJ)",
   label: "Banatsko Karadjordjevo (RSBKJ)"
  },
  {
   value: "Baracka (RSBSA)",
   label: "Baracka (RSBSA)"
  },
  {
   value: "Baric (RSBRC)",
   label: "Baric (RSBRC)"
  },
  {
   value: "Becej (RSBEC)",
   label: "Becej (RSBEC)"
  },
  {
   value: "Belgrade (Beograd) (RSBEG)",
   label: "Belgrade (Beograd) (RSBEG)"
  },
  {
   value: "Beocin (RSBCN)",
   label: "Beocin (RSBCN)"
  },
  {
   value: "Bezdam (RSBZD)",
   label: "Bezdam (RSBZD)"
  },
  {
   value: "Bogojevo (RSBVO)",
   label: "Bogojevo (RSBVO)"
  },
  {
   value: "Boljevac (RSBVC)",
   label: "Boljevac (RSBVC)"
  },
  {
   value: "Bor (RSBOR)",
   label: "Bor (RSBOR)"
  },
  {
   value: "Bujanovac (RSBUJ)",
   label: "Bujanovac (RSBUJ)"
  },
  {
   value: "Cacak (RSCAC)",
   label: "Cacak (RSCAC)"
  },
  {
   value: "Camp Bondsteel (RSCBO)",
   label: "Camp Bondsteel (RSCBO)"
  },
  {
   value: "Camp Montieth (RSCMI)",
   label: "Camp Montieth (RSCMI)"
  },
  {
   value: "Cerevic (RSCVC)",
   label: "Cerevic (RSCVC)"
  },
  {
   value: "Crvenka (RSSZF)",
   label: "Crvenka (RSSZF)"
  },
  {
   value: "Cuprija (RSCUP)",
   label: "Cuprija (RSCUP)"
  },
  {
   value: "Curug (RSCRG)",
   label: "Curug (RSCRG)"
  },
  {
   value: "Dimitrovgrad (RSDIM)",
   label: "Dimitrovgrad (RSDIM)"
  },
  {
   value: "Doljevac (RSDVC)",
   label: "Doljevac (RSDVC)"
  },
  {
   value: "Donji Milanovac (RSDMC)",
   label: "Donji Milanovac (RSDMC)"
  },
  {
   value: "Drazevac (RSDZC)",
   label: "Drazevac (RSDZC)"
  },
  {
   value: "Gornji Milanovac (RSGMI)",
   label: "Gornji Milanovac (RSGMI)"
  },
  {
   value: "Gruza (RSGRU)",
   label: "Gruza (RSGRU)"
  },
  {
   value: "Hrtkovci (RSHRT)",
   label: "Hrtkovci (RSHRT)"
  },
  {
   value: "Indija (RSIND)",
   label: "Indija (RSIND)"
  },
  {
   value: "Ivanjica (RSIVA)",
   label: "Ivanjica (RSIVA)"
  },
  {
   value: "Jagodina (RSJAG)",
   label: "Jagodina (RSJAG)"
  },
  {
   value: "Kanjiza (RSKJA)",
   label: "Kanjiza (RSKJA)"
  },
  {
   value: "Kikinda (RSKAY)",
   label: "Kikinda (RSKAY)"
  },
  {
   value: "Kladovo (RSKDV)",
   label: "Kladovo (RSKDV)"
  },
  {
   value: "Knic (RSKNC)",
   label: "Knic (RSKNC)"
  },
  {
   value: "Knjazevac (RSKVC)",
   label: "Knjazevac (RSKVC)"
  },
  {
   value: "Kosovo Polje (Fushë Kosove) (RSKPJ)",
   label: "Kosovo Polje (Fushë Kosove) (RSKPJ)"
  },
  {
   value: "Kostolac (RSKTC)",
   label: "Kostolac (RSKTC)"
  },
  {
   value: "Kovin (RSKOV)",
   label: "Kovin (RSKOV)"
  },
  {
   value: "Kragujevac (RSKGV)",
   label: "Kragujevac (RSKGV)"
  },
  {
   value: "Kraljevo (RSKRA)",
   label: "Kraljevo (RSKRA)"
  },
  {
   value: "Krnjevo (RSKRJ)",
   label: "Krnjevo (RSKRJ)"
  },
  {
   value: "Krusevac (RSKRU)",
   label: "Krusevac (RSKRU)"
  },
  {
   value: "Kursumlija (RSKMA)",
   label: "Kursumlija (RSKMA)"
  },
  {
   value: "Lacarak (RSLAC)",
   label: "Lacarak (RSLAC)"
  },
  {
   value: "Lapovo (RSLPO)",
   label: "Lapovo (RSLPO)"
  },
  {
   value: "Lebane (RSLBE)",
   label: "Lebane (RSLBE)"
  },
  {
   value: "Leskovac (RSLVC)",
   label: "Leskovac (RSLVC)"
  },
  {
   value: "Lestane (RSLTE)",
   label: "Lestane (RSLTE)"
  },
  {
   value: "Ljig (RSLJG)",
   label: "Ljig (RSLJG)"
  },
  {
   value: "Loznica (RSLOZ)",
   label: "Loznica (RSLOZ)"
  },
  {
   value: "Lozovik (RSLZO)",
   label: "Lozovik (RSLZO)"
  },
  {
   value: "Mali Zvornik (RSSZC)",
   label: "Mali Zvornik (RSSZC)"
  },
  {
   value: "Melenci (RSMLI)",
   label: "Melenci (RSMLI)"
  },
  {
   value: "Merosina (RSMSA)",
   label: "Merosina (RSMSA)"
  },
  {
   value: "Mladenovac (RSMNC)",
   label: "Mladenovac (RSMNC)"
  },
  {
   value: "Mrcajevci (RSMJI)",
   label: "Mrcajevci (RSMJI)"
  },
  {
   value: "Negotin (RSNEG)",
   label: "Negotin (RSNEG)"
  },
  {
   value: "Nis (RSINI)",
   label: "Nis (RSINI)"
  },
  {
   value: "Nova Pazova (RSNPA)",
   label: "Nova Pazova (RSNPA)"
  },
  {
   value: "Novi Pazar (RSNVP)",
   label: "Novi Pazar (RSNVP)"
  },
  {
   value: "Novi Sad (RSNVS)",
   label: "Novi Sad (RSNVS)"
  },
  {
   value: "Novi Slankamen (RSNSL)",
   label: "Novi Slankamen (RSNSL)"
  },
  {
   value: "Novo Selo (RSNOS)",
   label: "Novo Selo (RSNOS)"
  },
  {
   value: "Obrenovac (RSONC)",
   label: "Obrenovac (RSONC)"
  },
  {
   value: "Orahovac (RSSZA)",
   label: "Orahovac (RSSZA)"
  },
  {
   value: "Palic (RSPLC)",
   label: "Palic (RSPLC)"
  },
  {
   value: "Pancevo (RSPYJ)",
   label: "Pancevo (RSPYJ)"
  },
  {
   value: "Paracin (RSSZH)",
   label: "Paracin (RSSZH)"
  },
  {
   value: "Parain (RSPCN)",
   label: "Parain (RSPCN)"
  },
  {
   value: "Pirot (RSPIR)",
   label: "Pirot (RSPIR)"
  },
  {
   value: "Pozarevac (RSZZP)",
   label: "Pozarevac (RSZZP)"
  },
  {
   value: "Pozega (RSPOZ)",
   label: "Pozega (RSPOZ)"
  },
  {
   value: "Prahovo (RSPHO)",
   label: "Prahovo (RSPHO)"
  },
  {
   value: "Prijepolje (RSPRI)",
   label: "Prijepolje (RSPRI)"
  },
  {
   value: "Pristina (RSPRN)",
   label: "Pristina (RSPRN)"
  },
  {
   value: "Prizren (RSPRZ)",
   label: "Prizren (RSPRZ)"
  },
  {
   value: "Prokuplje (RSPRO)",
   label: "Prokuplje (RSPRO)"
  },
  {
   value: "Raska (RSRAS)",
   label: "Raska (RSRAS)"
  },
  {
   value: "Ripanj (RSRPJ)",
   label: "Ripanj (RSRPJ)"
  },
  {
   value: "Ruma (RSRUM)",
   label: "Ruma (RSRUM)"
  },
  {
   value: "Sabac (RSSAB)",
   label: "Sabac (RSSAB)"
  },
  {
   value: "Sevojno (RSSEV)",
   label: "Sevojno (RSSEV)"
  },
  {
   value: "Sid (RSSID)",
   label: "Sid (RSSID)"
  },
  {
   value: "Sirig (RSSRG)",
   label: "Sirig (RSSRG)"
  },
  {
   value: "Smederevo (RSSMO)",
   label: "Smederevo (RSSMO)"
  },
  {
   value: "Smederevska Palanka (RSSZE)",
   label: "Smederevska Palanka (RSSZE)"
  },
  {
   value: "Sombor (RSSOM)",
   label: "Sombor (RSSOM)"
  },
  {
   value: "Sremcica (RSSCA)",
   label: "Sremcica (RSSCA)"
  },
  {
   value: "Sremska Mitrovica (RSSRM)",
   label: "Sremska Mitrovica (RSSRM)"
  },
  {
   value: "Sremski Karlovci (RSSKA)",
   label: "Sremski Karlovci (RSSKA)"
  },
  {
   value: "Stara Pazova (RSSPA)",
   label: "Stara Pazova (RSSPA)"
  },
  {
   value: "Strezimirovci (RSSTZ)",
   label: "Strezimirovci (RSSTZ)"
  },
  {
   value: "Subotica (RSSUB)",
   label: "Subotica (RSSUB)"
  },
  {
   value: "Svilajnac (RSSNC)",
   label: "Svilajnac (RSSNC)"
  },
  {
   value: "Svrljig (RSSVR)",
   label: "Svrljig (RSSVR)"
  },
  {
   value: "Tresnjevac (RSTJV)",
   label: "Tresnjevac (RSTJV)"
  },
  {
   value: "Urosevac (RSSZD)",
   label: "Urosevac (RSSZD)"
  },
  {
   value: "Uzice (RSUZC)",
   label: "Uzice (RSUZC)"
  },
  {
   value: "Valjevo (RSVLJ)",
   label: "Valjevo (RSVLJ)"
  },
  {
   value: "Veliko Gradiste (RSVGS)",
   label: "Veliko Gradiste (RSVGS)"
  },
  {
   value: "Vladimirovac (RSSZG)",
   label: "Vladimirovac (RSSZG)"
  },
  {
   value: "Vlasotince (RSVLA)",
   label: "Vlasotince (RSVLA)"
  },
  {
   value: "Voganj (RSVOG)",
   label: "Voganj (RSVOG)"
  },
  {
   value: "Vranje (RSVRA)",
   label: "Vranje (RSVRA)"
  },
  {
   value: "Vrbas (RSVRB)",
   label: "Vrbas (RSVRB)"
  },
  {
   value: "Vrsac (RSVRS)",
   label: "Vrsac (RSVRS)"
  },
  {
   value: "Zajecar (RSZAJ)",
   label: "Zajecar (RSZAJ)"
  },
  {
   value: "Zatonje (RSZAT)",
   label: "Zatonje (RSZAT)"
  },
  {
   value: "Zemun (RSZEM)",
   label: "Zemun (RSZEM)"
  },
  {
   value: "Zitiste (RSSZI)",
   label: "Zitiste (RSSZI)"
  },
  {
   value: "Zmajevo (RSZMA)",
   label: "Zmajevo (RSZMA)"
  },
  {
   value: "Zrenjanin (RSZRN)",
   label: "Zrenjanin (RSZRN)"
  },
  {
   value: ".RUSSIAN FEDERATION (RU)",
   label: ".RUSSIAN FEDERATION (RU)"
  },
  {
   value: "Abakan (RUABA)",
   label: "Abakan (RUABA)"
  },
  {
   value: "Achinsk (RUACS)",
   label: "Achinsk (RUACS)"
  },
  {
   value: "Aginskoye (RUAGI)",
   label: "Aginskoye (RUAGI)"
  },
  {
   value: "Aksay (RUAKS)",
   label: "Aksay (RUAKS)"
  },
  {
   value: "Aldan (RUADH)",
   label: "Aldan (RUADH)"
  },
  {
   value: "Aleksandrov (RUALV)",
   label: "Aleksandrov (RUALV)"
  },
  {
   value: "Aleksandrov (Alexandrov) (RUAAD)",
   label: "Aleksandrov (Alexandrov) (RUAAD)"
  },
  {
   value: "Aleksandrovsk-Sakhalinskiy (RUSAK)",
   label: "Aleksandrovsk-Sakhalinskiy (RUSAK)"
  },
  {
   value: "Aleysk (RUALE)",
   label: "Aleysk (RUALE)"
  },
  {
   value: "Ambarchik (RUABC)",
   label: "Ambarchik (RUABC)"
  },
  {
   value: "Amderma (RUAMD)",
   label: "Amderma (RUAMD)"
  },
  {
   value: "Amderma (RUAMV)",
   label: "Amderma (RUAMV)"
  },
  {
   value: "Amursk (RUAMU)",
   label: "Amursk (RUAMU)"
  },
  {
   value: "Angarsk (RUAGK)",
   label: "Angarsk (RUAGK)"
  },
  {
   value: "Angarsk (RURSK)",
   label: "Angarsk (RURSK)"
  },
  {
   value: "Apsheronsk (RUAPS)",
   label: "Apsheronsk (RUAPS)"
  },
  {
   value: "Ardatov (RUADT)",
   label: "Ardatov (RUADT)"
  },
  {
   value: "Armavir (RUAVR)",
   label: "Armavir (RUAVR)"
  },
  {
   value: "Arsenyev (RUARS)",
   label: "Arsenyev (RUARS)"
  },
  {
   value: "Asbest (RUASB)",
   label: "Asbest (RUASB)"
  },
  {
   value: "Baksan (RUBAK)",
   label: "Baksan (RUBAK)"
  },
  {
   value: "Balakhnya (RUBLN)",
   label: "Balakhnya (RUBLN)"
  },
  {
   value: "Balakirevo (RUBKV)",
   label: "Balakirevo (RUBKV)"
  },
  {
   value: "Balashikha (RUBLA)",
   label: "Balashikha (RUBLA)"
  },
  {
   value: "Balobanovo (RUBAL)",
   label: "Balobanovo (RUBAL)"
  },
  {
   value: "Barnaul (RUBAX)",
   label: "Barnaul (RUBAX)"
  },
  {
   value: "Belgorod (RUEGO)",
   label: "Belgorod (RUEGO)"
  },
  {
   value: "Belorechensk (RUBEK)",
   label: "Belorechensk (RUBEK)"
  },
  {
   value: "Beloreck (RUBCX)",
   label: "Beloreck (RUBCX)"
  },
  {
   value: "Belousovo (RUOVO)",
   label: "Belousovo (RUOVO)"
  },
  {
   value: "Berdsk (RUBRD)",
   label: "Berdsk (RUBRD)"
  },
  {
   value: "Berezniki (RUBRZ)",
   label: "Berezniki (RUBRZ)"
  },
  {
   value: "Boksitogorsk (RUBGK)",
   label: "Boksitogorsk (RUBGK)"
  },
  {
   value: "Bolshaya Vishera (RUBOV)",
   label: "Bolshaya Vishera (RUBOV)"
  },
  {
   value: "Bolshoy Kamen (RUBKN)",
   label: "Bolshoy Kamen (RUBKN)"
  },
  {
   value: "Bor (RUBRN)",
   label: "Bor (RUBRN)"
  },
  {
   value: "Borisova (RUBOR)",
   label: "Borisova (RUBOR)"
  },
  {
   value: "Borovichi (RUBRV)",
   label: "Borovichi (RUBRV)"
  },
  {
   value: "Borovichi (RUBVC)",
   label: "Borovichi (RUBVC)"
  },
  {
   value: "Boshnyakovo (RUBOS)",
   label: "Boshnyakovo (RUBOS)"
  },
  {
   value: "Bronnitsy (RUBRO)",
   label: "Bronnitsy (RUBRO)"
  },
  {
   value: "Bryansk (RUBRY)",
   label: "Bryansk (RUBRY)"
  },
  {
   value: "Bugulma (RUUUA)",
   label: "Bugulma (RUUUA)"
  },
  {
   value: "Buzuluk (RUBUZ)",
   label: "Buzuluk (RUBUZ)"
  },
  {
   value: "Chamgu (RUCHA)",
   label: "Chamgu (RUCHA)"
  },
  {
   value: "Chamzinka (RUCHZ)",
   label: "Chamzinka (RUCHZ)"
  },
  {
   value: "Chaykovskiy (RUCAI)",
   label: "Chaykovskiy (RUCAI)"
  },
  {
   value: "Cheboksary (RUCSY)",
   label: "Cheboksary (RUCSY)"
  },
  {
   value: "Chekhov (RUCKV)",
   label: "Chekhov (RUCKV)"
  },
  {
   value: "Chelyabinsk (RUCEK)",
   label: "Chelyabinsk (RUCEK)"
  },
  {
   value: "Chemashi (RUCHM)",
   label: "Chemashi (RUCHM)"
  },
  {
   value: "Cherkessk (RUCKK)",
   label: "Cherkessk (RUCKK)"
  },
  {
   value: "Chernogolovka (RUHGO)",
   label: "Chernogolovka (RUHGO)"
  },
  {
   value: "Chernyakhovsk (RUCHK)",
   label: "Chernyakhovsk (RUCHK)"
  },
  {
   value: "Chërnyy Otrog (RUCYO)",
   label: "Chërnyy Otrog (RUCYO)"
  },
  {
   value: "Cherskiy (RUCYX)",
   label: "Cherskiy (RUCYX)"
  },
  {
   value: "Chita (RUCTA)",
   label: "Chita (RUCTA)"
  },
  {
   value: "Chita (RUHTA)",
   label: "Chita (RUHTA)"
  },
  {
   value: "Chkalovsky (RUCKL)",
   label: "Chkalovsky (RUCKL)"
  },
  {
   value: "Chokurdah (RUCKH)",
   label: "Chokurdah (RUCKH)"
  },
  {
   value: "Chudovo (RUCHD)",
   label: "Chudovo (RUCHD)"
  },
  {
   value: "Chulman (RUCNN)",
   label: "Chulman (RUCNN)"
  },
  {
   value: "Chuya (RUCHU)",
   label: "Chuya (RUCHU)"
  },
  {
   value: "Davidovo (RUDVO)",
   label: "Davidovo (RUDVO)"
  },
  {
   value: "Derbeshkinskiy (RUDHA)",
   label: "Derbeshkinskiy (RUDHA)"
  },
  {
   value: "Dikson (RUDKS)",
   label: "Dikson (RUDKS)"
  },
  {
   value: "Dimitrovgrad (RUDMT)",
   label: "Dimitrovgrad (RUDMT)"
  },
  {
   value: "Dmitrov (RUDTV)",
   label: "Dmitrov (RUDTV)"
  },
  {
   value: "Dolgoprudniy (RUDOL)",
   label: "Dolgoprudniy (RUDOL)"
  },
  {
   value: "Dondukovskaya (RUDDK)",
   label: "Dondukovskaya (RUDDK)"
  },
  {
   value: "Donetsk (RURZA)",
   label: "Donetsk (RURZA)"
  },
  {
   value: "Druzhniy (RUDRU)",
   label: "Druzhniy (RUDRU)"
  },
  {
   value: "Dubna (RUDUB)",
   label: "Dubna (RUDUB)"
  },
  {
   value: "Dubrovo (RUDBO)",
   label: "Dubrovo (RUDBO)"
  },
  {
   value: "Ekaterinburg (RUEKA)",
   label: "Ekaterinburg (RUEKA)"
  },
  {
   value: "Ekonomiya (RUEKO)",
   label: "Ekonomiya (RUEKO)"
  },
  {
   value: "Elektrogorsk (RUELG)",
   label: "Elektrogorsk (RUELG)"
  },
  {
   value: "Elista (RUESL)",
   label: "Elista (RUESL)"
  },
  {
   value: "Eniseysk (RUEIE)",
   label: "Eniseysk (RUEIE)"
  },
  {
   value: "Esipovo (RUESI)",
   label: "Esipovo (RUESI)"
  },
  {
   value: "Fokino (RUFKN)",
   label: "Fokino (RUFKN)"
  },
  {
   value: "Furmanov (RUFUR)",
   label: "Furmanov (RUFUR)"
  },
  {
   value: "Gatchina (RUGAT)",
   label: "Gatchina (RUGAT)"
  },
  {
   value: "Gavrilov-Yam (RUGVY)",
   label: "Gavrilov-Yam (RUGVY)"
  },
  {
   value: "Gelendzik (RUGDZ)",
   label: "Gelendzik (RUGDZ)"
  },
  {
   value: "Georgievsk (RURZB)",
   label: "Georgievsk (RURZB)"
  },
  {
   value: "Glazov (RUGZV)",
   label: "Glazov (RUGZV)"
  },
  {
   value: "Gorkino (RUGOR)",
   label: "Gorkino (RUGOR)"
  },
  {
   value: "Gorno Altaisk (RUGOA)",
   label: "Gorno Altaisk (RUGOA)"
  },
  {
   value: "Gorskaya (RUGSA)",
   label: "Gorskaya (RUGSA)"
  },
  {
   value: "Groznyj (RUGRV)",
   label: "Groznyj (RUGRV)"
  },
  {
   value: "Gubkin (RUGUB)",
   label: "Gubkin (RUGUB)"
  },
  {
   value: "Gus Khrustalny (RUGKY)",
   label: "Gus Khrustalny (RUGKY)"
  },
  {
   value: "Gusevskiy (RUGVS)",
   label: "Gusevskiy (RUGVS)"
  },
  {
   value: "Hatanga (RUHTG)",
   label: "Hatanga (RUHTG)"
  },
  {
   value: "Horlovo (RUHOR)",
   label: "Horlovo (RUHOR)"
  },
  {
   value: "Ikryanoye (RUIOY)",
   label: "Ikryanoye (RUIOY)"
  },
  {
   value: "Indiga (RUIDG)",
   label: "Indiga (RUIDG)"
  },
  {
   value: "Inta (RUINA)",
   label: "Inta (RUINA)"
  },
  {
   value: "Irbit (RUIRB)",
   label: "Irbit (RUIRB)"
  },
  {
   value: "Isayevskoje (RUIKJ)",
   label: "Isayevskoje (RUIKJ)"
  },
  {
   value: "Ishim (RUISM)",
   label: "Ishim (RUISM)"
  },
  {
   value: "Ivanova (RUIWA)",
   label: "Ivanova (RUIWA)"
  },
  {
   value: "Ivanovo (RUIVO)",
   label: "Ivanovo (RUIVO)"
  },
  {
   value: "Izhevsk (RUIJK)",
   label: "Izhevsk (RUIJK)"
  },
  {
   value: "Kaluga (RUKLF)",
   label: "Kaluga (RUKLF)"
  },
  {
   value: "Kalyazin (RUKLY)",
   label: "Kalyazin (RUKLY)"
  },
  {
   value: "Kamensk-Shahtinskiy (RUKSH)",
   label: "Kamensk-Shahtinskiy (RUKSH)"
  },
  {
   value: "Kamensk-Uralskiy (RUKSU)",
   label: "Kamensk-Uralskiy (RUKSU)"
  },
  {
   value: "Kamyshin (RUKAM)",
   label: "Kamyshin (RUKAM)"
  },
  {
   value: "Karpinsk (RUKAR)",
   label: "Karpinsk (RUKAR)"
  },
  {
   value: "Kashira (RUKAS)",
   label: "Kashira (RUKAS)"
  },
  {
   value: "Kasimov (RUKSI)",
   label: "Kasimov (RUKSI)"
  },
  {
   value: "Kavalerovo (RUKAV)",
   label: "Kavalerovo (RUKAV)"
  },
  {
   value: "Kemerovo (RUKEJ)",
   label: "Kemerovo (RUKEJ)"
  },
  {
   value: "Khanty-Mansiysk (RUKHM)",
   label: "Khanty-Mansiysk (RUKHM)"
  },
  {
   value: "Kharasavey (RUKSA)",
   label: "Kharasavey (RUKSA)"
  },
  {
   value: "Kharovsk (RUKHA)",
   label: "Kharovsk (RUKHA)"
  },
  {
   value: "Khatyrka (RUKTY)",
   label: "Khatyrka (RUKTY)"
  },
  {
   value: "Khropunovo (RUHRA)",
   label: "Khropunovo (RUHRA)"
  },
  {
   value: "Khvalynsk (RUKNY)",
   label: "Khvalynsk (RUKNY)"
  },
  {
   value: "Kimry (RUKIM)",
   label: "Kimry (RUKIM)"
  },
  {
   value: "Kingisepp (RUKGS)",
   label: "Kingisepp (RUKGS)"
  },
  {
   value: "Kirensk (RUKIK)",
   label: "Kirensk (RUKIK)"
  },
  {
   value: "Kireyevskoye (RUKYK)",
   label: "Kireyevskoye (RUKYK)"
  },
  {
   value: "Kirishi (RUKIR)",
   label: "Kirishi (RUKIR)"
  },
  {
   value: "Kirovo-Chepetsk (RUKCP)",
   label: "Kirovo-Chepetsk (RUKCP)"
  },
  {
   value: "Kirovsk (RUKVK)",
   label: "Kirovsk (RUKVK)"
  },
  {
   value: "Kirovskiy (RUKIY)",
   label: "Kirovskiy (RUKIY)"
  },
  {
   value: "Klimovsk (RURZC)",
   label: "Klimovsk (RURZC)"
  },
  {
   value: "Klin (RUKLI)",
   label: "Klin (RUKLI)"
  },
  {
   value: "Klin (RUKLN)",
   label: "Klin (RUKLN)"
  },
  {
   value: "Klinsky Rayon (RUKLR)",
   label: "Klinsky Rayon (RUKLR)"
  },
  {
   value: "Kodinsk (RUKDK)",
   label: "Kodinsk (RUKDK)"
  },
  {
   value: "Kogalym (RUKGP)",
   label: "Kogalym (RUKGP)"
  },
  {
   value: "Kokhma (RUKOH)",
   label: "Kokhma (RUKOH)"
  },
  {
   value: "Kolguyev I. (RUKYI)",
   label: "Kolguyev I. (RUKYI)"
  },
  {
   value: "Kolomna (RUKLM)",
   label: "Kolomna (RUKLM)"
  },
  {
   value: "Kolpashevo (RUKVO)",
   label: "Kolpashevo (RUKVO)"
  },
  {
   value: "Koltogorskiye (RUKLT)",
   label: "Koltogorskiye (RUKLT)"
  },
  {
   value: "Kommunar (RUKMR)",
   label: "Kommunar (RUKMR)"
  },
  {
   value: "Komsomolsk Na Amure (RUKXK)",
   label: "Komsomolsk Na Amure (RUKXK)"
  },
  {
   value: "Konakovo (RUKOK)",
   label: "Konakovo (RUKOK)"
  },
  {
   value: "Konakovo (RUKON)",
   label: "Konakovo (RUKON)"
  },
  {
   value: "Kondopoga (RUKPA)",
   label: "Kondopoga (RUKPA)"
  },
  {
   value: "Konets Lug (RUKNL)",
   label: "Konets Lug (RUKNL)"
  },
  {
   value: "Kostarikha (RUKST)",
   label: "Kostarikha (RUKST)"
  },
  {
   value: "Kostomuksha (RUKMA)",
   label: "Kostomuksha (RUKMA)"
  },
  {
   value: "Kostroma (RUKMW)",
   label: "Kostroma (RUKMW)"
  },
  {
   value: "Kotlas (RUKSZ)",
   label: "Kotlas (RUKSZ)"
  },
  {
   value: "Kovrov (RUKOV)",
   label: "Kovrov (RUKOV)"
  },
  {
   value: "Kozelsk (RUKOZ)",
   label: "Kozelsk (RUKOZ)"
  },
  {
   value: "Kozhevnikovo (RUKZH)",
   label: "Kozhevnikovo (RUKZH)"
  },
  {
   value: "Krasnaya Polyana (RUKRP)",
   label: "Krasnaya Polyana (RUKRP)"
  },
  {
   value: "Krasnoarmeysk (RUKMK)",
   label: "Krasnoarmeysk (RUKMK)"
  },
  {
   value: "Krasnogorsk (RUKRS)",
   label: "Krasnogorsk (RUKRS)"
  },
  {
   value: "Krasnokamsk (RUKNK)",
   label: "Krasnokamsk (RUKNK)"
  },
  {
   value: "Krasnoturansk (RURYK)",
   label: "Krasnoturansk (RURYK)"
  },
  {
   value: "Krasnoyarsk (RUKRA)",
   label: "Krasnoyarsk (RUKRA)"
  },
  {
   value: "Krasnyy Yar (RUKRY)",
   label: "Krasnyy Yar (RUKRY)"
  },
  {
   value: "Krasnyye Barrikady (RUKYB)",
   label: "Krasnyye Barrikady (RUKYB)"
  },
  {
   value: "Krivosheino (RUKRI)",
   label: "Krivosheino (RUKRI)"
  },
  {
   value: "Krugloye Pole (RUKRU)",
   label: "Krugloye Pole (RUKRU)"
  },
  {
   value: "Kubekovo (RUKUB)",
   label: "Kubekovo (RUKUB)"
  },
  {
   value: "Kulakovo (RUKLK)",
   label: "Kulakovo (RUKLK)"
  },
  {
   value: "Kureysk (RUKUR)",
   label: "Kureysk (RUKUR)"
  },
  {
   value: "Kurgan (RUKRO)",
   label: "Kurgan (RUKRO)"
  },
  {
   value: "Kurganinsk (RURZF)",
   label: "Kurganinsk (RURZF)"
  },
  {
   value: "Kuznetsk (RUKUZ)",
   label: "Kuznetsk (RUKUZ)"
  },
  {
   value: "Kyzyl (RUKYZ)",
   label: "Kyzyl (RUKYZ)"
  },
  {
   value: "Lavrentiya (RULVR)",
   label: "Lavrentiya (RULVR)"
  },
  {
   value: "Leningradskaya (RULEK)",
   label: "Leningradskaya (RULEK)"
  },
  {
   value: "Lensk (RULNK)",
   label: "Lensk (RULNK)"
  },
  {
   value: "Leonova (RULEO)",
   label: "Leonova (RULEO)"
  },
  {
   value: "Lesogorsk (RULES)",
   label: "Lesogorsk (RULES)"
  },
  {
   value: "Leushinskiye (RULEU)",
   label: "Leushinskiye (RULEU)"
  },
  {
   value: "Liski (RULSI)",
   label: "Liski (RULSI)"
  },
  {
   value: "Lobnya (RULBA)",
   label: "Lobnya (RULBA)"
  },
  {
   value: "Lugovoye (RULUG)",
   label: "Lugovoye (RULUG)"
  },
  {
   value: "Lyubim (RULBU)",
   label: "Lyubim (RULBU)"
  },
  {
   value: "Lyubuchany (RULYU)",
   label: "Lyubuchany (RULYU)"
  },
  {
   value: "Magadan (RUGDX)",
   label: "Magadan (RUGDX)"
  },
  {
   value: "Magdagachi (RUGDG)",
   label: "Magdagachi (RUGDG)"
  },
  {
   value: "Magnitogorsk (RUMQF)",
   label: "Magnitogorsk (RUMQF)"
  },
  {
   value: "Makarovo (RUMKR)",
   label: "Makarovo (RUMKR)"
  },
  {
   value: "Malyye Bazy (RUMYB)",
   label: "Malyye Bazy (RUMYB)"
  },
  {
   value: "Mamadysh (RUMDY)",
   label: "Mamadysh (RUMDY)"
  },
  {
   value: "Mamonovo (RURZD)",
   label: "Mamonovo (RURZD)"
  },
  {
   value: "Maykop (RUMKP)",
   label: "Maykop (RUMKP)"
  },
  {
   value: "Mezhevoy (RUMZV)",
   label: "Mezhevoy (RUMZV)"
  },
  {
   value: "Miass (RUMAS)",
   label: "Miass (RUMAS)"
  },
  {
   value: "Mikhnëvo (RUMIK)",
   label: "Mikhnëvo (RUMIK)"
  },
  {
   value: "Mirnyj (RUMJZ)",
   label: "Mirnyj (RUMJZ)"
  },
  {
   value: "Mishkino (RUMSK)",
   label: "Mishkino (RUMSK)"
  },
  {
   value: "Mogochin (RUMOG)",
   label: "Mogochin (RUMOG)"
  },
  {
   value: "Molchanovo (RUMON)",
   label: "Molchanovo (RUMON)"
  },
  {
   value: "Molot (RUMOL)",
   label: "Molot (RUMOL)"
  },
  {
   value: "Monchegorsk (RUMCG)",
   label: "Monchegorsk (RUMCG)"
  },
  {
   value: "Mys Shmidta (RUMSH)",
   label: "Mys Shmidta (RUMSH)"
  },
  {
   value: "Nadym (RUNYM)",
   label: "Nadym (RUNYM)"
  },
  {
   value: "Nalchik (RUNAL)",
   label: "Nalchik (RUNAL)"
  },
  {
   value: "Narym (RUNAR)",
   label: "Narym (RUNAR)"
  },
  {
   value: "Neftekamsk (RUNEF)",
   label: "Neftekamsk (RUNEF)"
  },
  {
   value: "Neftekumsk (RUNFK)",
   label: "Neftekumsk (RUNFK)"
  },
  {
   value: "Neftelensk (RUNLK)",
   label: "Neftelensk (RUNLK)"
  },
  {
   value: "Nefteyugansk (RUNFG)",
   label: "Nefteyugansk (RUNFG)"
  },
  {
   value: "Neman (RUNEM)",
   label: "Neman (RUNEM)"
  },
  {
   value: "Neryungri (RUNER)",
   label: "Neryungri (RUNER)"
  },
  {
   value: "Nevinnomyssk (RUNEK)",
   label: "Nevinnomyssk (RUNEK)"
  },
  {
   value: "Nizhnekamsk (RUNZK)",
   label: "Nizhnekamsk (RUNZK)"
  },
  {
   value: "Nizhnevartovsk (RUNJC)",
   label: "Nizhnevartovsk (RUNJC)"
  },
  {
   value: "Nizhnevartovsk (RUNNT)",
   label: "Nizhnevartovsk (RUNNT)"
  },
  {
   value: "Nizhniy Lomov (RUNZL)",
   label: "Nizhniy Lomov (RUNZL)"
  },
  {
   value: "Nizhniy Tagil (RUNIT)",
   label: "Nizhniy Tagil (RUNIT)"
  },
  {
   value: "Nizhnyaya Pesha (RUNPE)",
   label: "Nizhnyaya Pesha (RUNPE)"
  },
  {
   value: "Noginsk (RUNGI)",
   label: "Noginsk (RUNGI)"
  },
  {
   value: "Nogliki (RUNOG)",
   label: "Nogliki (RUNOG)"
  },
  {
   value: "Nojabrxsk (RUNOJ)",
   label: "Nojabrxsk (RUNOJ)"
  },
  {
   value: "Novgorod (RUNVR)",
   label: "Novgorod (RUNVR)"
  },
  {
   value: "Novocherkassk (RUNVK)",
   label: "Novocherkassk (RUNVK)"
  },
  {
   value: "Novodvinsk (RUNDK)",
   label: "Novodvinsk (RUNDK)"
  },
  {
   value: "Novomoskovsk (RUNMK)",
   label: "Novomoskovsk (RUNMK)"
  },
  {
   value: "Novoshakhtinsk (RURZE)",
   label: "Novoshakhtinsk (RURZE)"
  },
  {
   value: "Novozybkov (RUNZV)",
   label: "Novozybkov (RUNZV)"
  },
  {
   value: "Novy Urengoy (RUNUX)",
   label: "Novy Urengoy (RUNUX)"
  },
  {
   value: "Novyy (RUNVY)",
   label: "Novyy (RUNVY)"
  },
  {
   value: "Obninsk (RUOBK)",
   label: "Obninsk (RUOBK)"
  },
  {
   value: "Obninsk (RUONK)",
   label: "Obninsk (RUONK)"
  },
  {
   value: "Odintsovo (RUOSO)",
   label: "Odintsovo (RUOSO)"
  },
  {
   value: "Okha, Sakhalin (RUOKA)",
   label: "Okha, Sakhalin (RUOKA)"
  },
  {
   value: "Okruzhnoe (RUOKZ)",
   label: "Okruzhnoe (RUOKZ)"
  },
  {
   value: "Oktyabrskoye (RUOYE)",
   label: "Oktyabrskoye (RUOYE)"
  },
  {
   value: "Olekminsk (RUOMK)",
   label: "Olekminsk (RUOMK)"
  },
  {
   value: "Olya (RUOYA)",
   label: "Olya (RUOYA)"
  },
  {
   value: "Oranzherei (RUOZE)",
   label: "Oranzherei (RUOZE)"
  },
  {
   value: "Orekhovo-Zuevo (RUHZO)",
   label: "Orekhovo-Zuevo (RUHZO)"
  },
  {
   value: "Orenburg (RUREN)",
   label: "Orenburg (RUREN)"
  },
  {
   value: "Orenburgskiy (RUOSK)",
   label: "Orenburgskiy (RUOSK)"
  },
  {
   value: "Orsk (RUOSW)",
   label: "Orsk (RUOSW)"
  },
  {
   value: "Otradnoye (RUONE)",
   label: "Otradnoye (RUONE)"
  },
  {
   value: "Otradnyy (RUOTR)",
   label: "Otradnyy (RUOTR)"
  },
  {
   value: "Ozëry (RUOZY)",
   label: "Ozëry (RUOZY)"
  },
  {
   value: "Parfino (RUPFO)",
   label: "Parfino (RUPFO)"
  },
  {
   value: "Pargolovo (RUPGO)",
   label: "Pargolovo (RUPGO)"
  },
  {
   value: "Penza (RUPEZ)",
   label: "Penza (RUPEZ)"
  },
  {
   value: "Peregrebnoye (RUPGE)",
   label: "Peregrebnoye (RUPGE)"
  },
  {
   value: "Peresvet (RUPVE)",
   label: "Peresvet (RUPVE)"
  },
  {
   value: "Perm (RUPEE)",
   label: "Perm (RUPEE)"
  },
  {
   value: "Pestovo (RUPET)",
   label: "Pestovo (RUPET)"
  },
  {
   value: "Petushki (RUPHK)",
   label: "Petushki (RUPHK)"
  },
  {
   value: "Pionerskiy (RUPNY)",
   label: "Pionerskiy (RUPNY)"
  },
  {
   value: "Pitkyaranta (RUPKR)",
   label: "Pitkyaranta (RUPKR)"
  },
  {
   value: "Pochinki (RUPKI)",
   label: "Pochinki (RUPKI)"
  },
  {
   value: "Podolsk (RUPDK)",
   label: "Podolsk (RUPDK)"
  },
  {
   value: "Pokrov (RUPKO)",
   label: "Pokrov (RUPKO)"
  },
  {
   value: "Pokrovsk (RUPOK)",
   label: "Pokrovsk (RUPOK)"
  },
  {
   value: "Polnovat (RUPNV)",
   label: "Polnovat (RUPNV)"
  },
  {
   value: "Polyarnyj (RUPYJ)",
   label: "Polyarnyj (RUPYJ)"
  },
  {
   value: "Potapova (RUPTP)",
   label: "Potapova (RUPTP)"
  },
  {
   value: "Poyarkovo (RUPYO)",
   label: "Poyarkovo (RUPYO)"
  },
  {
   value: "Pravdinskiy (RUPDY)",
   label: "Pravdinskiy (RUPDY)"
  },
  {
   value: "Preobrazheniye (RUPRY)",
   label: "Preobrazheniye (RUPRY)"
  },
  {
   value: "Prigorodnoye (RUPGN)",
   label: "Prigorodnoye (RUPGN)"
  },
  {
   value: "Priozërsk (RUPZK)",
   label: "Priozërsk (RUPZK)"
  },
  {
   value: "Privolzhsk (RUPSK)",
   label: "Privolzhsk (RUPSK)"
  },
  {
   value: "Prokhorovskiy (RUPHS)",
   label: "Prokhorovskiy (RUPHS)"
  },
  {
   value: "Protvino (RUPRO)",
   label: "Protvino (RUPRO)"
  },
  {
   value: "Provedenia (RUPVX)",
   label: "Provedenia (RUPVX)"
  },
  {
   value: "Pushkin (RUPUK)",
   label: "Pushkin (RUPUK)"
  },
  {
   value: "Pushkino (RUPSH)",
   label: "Pushkino (RUPSH)"
  },
  {
   value: "Pyatigorsk (RUPYA)",
   label: "Pyatigorsk (RUPYA)"
  },
  {
   value: "Raduzhnyi (RURAT)",
   label: "Raduzhnyi (RURAT)"
  },
  {
   value: "Ramenskoye (RURAM)",
   label: "Ramenskoye (RURAM)"
  },
  {
   value: "Reutov (RURTV)",
   label: "Reutov (RURTV)"
  },
  {
   value: "Rostov-na-Donu (RURND)",
   label: "Rostov-na-Donu (RURND)"
  },
  {
   value: "Rubnoye (RURUB)",
   label: "Rubnoye (RURUB)"
  },
  {
   value: "Rudnya (RURNA)",
   label: "Rudnya (RURNA)"
  },
  {
   value: "Ruza (RURUZ)",
   label: "Ruza (RURUZ)"
  },
  {
   value: "Ryazan (RURZN)",
   label: "Ryazan (RURZN)"
  },
  {
   value: "Ryshkovo (RURYS)",
   label: "Ryshkovo (RURYS)"
  },
  {
   value: "Rzhev (RURZV)",
   label: "Rzhev (RURZV)"
  },
  {
   value: "Salavat (RUSAL)",
   label: "Salavat (RUSAL)"
  },
  {
   value: "Salehard (RUSLY)",
   label: "Salehard (RUSLY)"
  },
  {
   value: "Saperniy (RUSPY)",
   label: "Saperniy (RUSPY)"
  },
  {
   value: "Saransk (RUSKX)",
   label: "Saransk (RUSKX)"
  },
  {
   value: "Sarapul (RUSRP)",
   label: "Sarapul (RUSRP)"
  },
  {
   value: "Sarova (RUSAR)",
   label: "Sarova (RUSAR)"
  },
  {
   value: "Sayanogorsk (RUSAY)",
   label: "Sayanogorsk (RUSAY)"
  },
  {
   value: "Selyatino (RURZH)",
   label: "Selyatino (RURZH)"
  },
  {
   value: "Serafimovich (RUSER)",
   label: "Serafimovich (RUSER)"
  },
  {
   value: "Sergiev (RUSIV)",
   label: "Sergiev (RUSIV)"
  },
  {
   value: "Serov (RUSRV)",
   label: "Serov (RUSRV)"
  },
  {
   value: "Sertolovo (RUSLO)",
   label: "Sertolovo (RUSLO)"
  },
  {
   value: "Sestroretsk (RUSZZ)",
   label: "Sestroretsk (RUSZZ)"
  },
  {
   value: "Severskaya (RURZG)",
   label: "Severskaya (RURZG)"
  },
  {
   value: "Shala (RUSLA)",
   label: "Shala (RUSLA)"
  },
  {
   value: "Shatura (RUSTA)",
   label: "Shatura (RUSTA)"
  },
  {
   value: "Shchelkovo (RUSHC)",
   label: "Shchelkovo (RUSHC)"
  },
  {
   value: "Shelanger (RUMSL)",
   label: "Shelanger (RUMSL)"
  },
  {
   value: "Shumikha (RUSKH)",
   label: "Shumikha (RUSKH)"
  },
  {
   value: "Shushary (RUSHY)",
   label: "Shushary (RUSHY)"
  },
  {
   value: "Shushenskoye (RUSHU)",
   label: "Shushenskoye (RUSHU)"
  },
  {
   value: "Siziman (RUSIZ)",
   label: "Siziman (RUSIZ)"
  },
  {
   value: "Skhodnya (RUSKD)",
   label: "Skhodnya (RUSKD)"
  },
  {
   value: "Skopin (RUSKO)",
   label: "Skopin (RUSKO)"
  },
  {
   value: "Slantsy (RUSNY)",
   label: "Slantsy (RUSNY)"
  },
  {
   value: "Smolensk (RULNX)",
   label: "Smolensk (RULNX)"
  },
  {
   value: "Sobinka (RUSIN)",
   label: "Sobinka (RUSIN)"
  },
  {
   value: "Sokol (RUSOL)",
   label: "Sokol (RUSOL)"
  },
  {
   value: "Solikamsk (RUSOK)",
   label: "Solikamsk (RUSOK)"
  },
  {
   value: "Solnechnogorsk (RUSNG)",
   label: "Solnechnogorsk (RUSNG)"
  },
  {
   value: "Sosenskiy (RUSSY)",
   label: "Sosenskiy (RUSSY)"
  },
  {
   value: "Sosnogorsk (RUSGK)",
   label: "Sosnogorsk (RUSGK)"
  },
  {
   value: "Sosnogorsk (RUSOS)",
   label: "Sosnogorsk (RUSOS)"
  },
  {
   value: "Sosnovyy Bor (RUSOB)",
   label: "Sosnovyy Bor (RUSOB)"
  },
  {
   value: "Sovetsk (RUSSK)",
   label: "Sovetsk (RUSSK)"
  },
  {
   value: "Sovetskiy (RUSOV)",
   label: "Sovetskiy (RUSOV)"
  },
  {
   value: "Staraya Kupavna (RUSKV)",
   label: "Staraya Kupavna (RUSKV)"
  },
  {
   value: "Staraya Russa (RUSYR)",
   label: "Staraya Russa (RUSYR)"
  },
  {
   value: "Staryy Oskol (RUSTO)",
   label: "Staryy Oskol (RUSTO)"
  },
  {
   value: "Streika (RUSTR)",
   label: "Streika (RUSTR)"
  },
  {
   value: "Strzhewoi (RUSWT)",
   label: "Strzhewoi (RUSWT)"
  },
  {
   value: "Stupino (RUSPO)",
   label: "Stupino (RUSPO)"
  },
  {
   value: "Suponevo (RUSUP)",
   label: "Suponevo (RUSUP)"
  },
  {
   value: "Surgut (RUSGC)",
   label: "Surgut (RUSGC)"
  },
  {
   value: "Syktyvkar (RUSCW)",
   label: "Syktyvkar (RUSCW)"
  },
  {
   value: "Talakan (RUTAL)",
   label: "Talakan (RUTAL)"
  },
  {
   value: "Tambov (RUTBW)",
   label: "Tambov (RUTBW)"
  },
  {
   value: "Tatishchevo (RUTAT)",
   label: "Tatishchevo (RUTAT)"
  },
  {
   value: "Tayura (RUTAY)",
   label: "Tayura (RUTAY)"
  },
  {
   value: "Tazovskiy (RUTAZ)",
   label: "Tazovskiy (RUTAZ)"
  },
  {
   value: "Temirtau (RUTEM)",
   label: "Temirtau (RUTEM)"
  },
  {
   value: "Temryuk (RUTMR)",
   label: "Temryuk (RUTMR)"
  },
  {
   value: "Tihvin (RURZJ)",
   label: "Tihvin (RURZJ)"
  },
  {
   value: "Tikhvin (RUTIK)",
   label: "Tikhvin (RUTIK)"
  },
  {
   value: "Timashevsk (RUTVK)",
   label: "Timashevsk (RUTVK)"
  },
  {
   value: "Tobolsk (RUTOX)",
   label: "Tobolsk (RUTOX)"
  },
  {
   value: "Tomsk (RUTOF)",
   label: "Tomsk (RUTOF)"
  },
  {
   value: "Torzhok (RUTHK)",
   label: "Torzhok (RUTHK)"
  },
  {
   value: "Tosno (RUTSO)",
   label: "Tosno (RUTSO)"
  },
  {
   value: "Troitsk (RUTRK)",
   label: "Troitsk (RUTRK)"
  },
  {
   value: "Troitsk, Mordovia (RUTRO)",
   label: "Troitsk, Mordovia (RUTRO)"
  },
  {
   value: "Trudfront (RUTDO)",
   label: "Trudfront (RUTDO)"
  },
  {
   value: "Tsimlyansk (RURZI)",
   label: "Tsimlyansk (RURZI)"
  },
  {
   value: "Tula (RUTYA)",
   label: "Tula (RUTYA)"
  },
  {
   value: "Tverskoye (RUTVE)",
   label: "Tverskoye (RUTVE)"
  },
  {
   value: "Tynda (RUTYD)",
   label: "Tynda (RUTYD)"
  },
  {
   value: "Tyulkino (RUTYL)",
   label: "Tyulkino (RUTYL)"
  },
  {
   value: "Tyumen (RUTJM)",
   label: "Tyumen (RUTJM)"
  },
  {
   value: "Uelen (RUUEL)",
   label: "Uelen (RUUEL)"
  },
  {
   value: "Uglich (RUUGC)",
   label: "Uglich (RUUGC)"
  },
  {
   value: "Ukhta (RUUCT)",
   label: "Ukhta (RUUCT)"
  },
  {
   value: "Ulan-Ude (RUUUD)",
   label: "Ulan-Ude (RUUUD)"
  },
  {
   value: "Uraj (RUURJ)",
   label: "Uraj (RUURJ)"
  },
  {
   value: "Usad (RUUSA)",
   label: "Usad (RUUSA)"
  },
  {
   value: "Ussuriysk (RUUSS)",
   label: "Ussuriysk (RUUSS)"
  },
  {
   value: "Ust Chaun (RUUCH)",
   label: "Ust Chaun (RUUCH)"
  },
  {
   value: "Ust-Ilimsk (RUUIK)",
   label: "Ust-Ilimsk (RUUIK)"
  },
  {
   value: "Ust-Kamchatsk (RUUKK)",
   label: "Ust-Kamchatsk (RUUKK)"
  },
  {
   value: "Ust-Kut (RUUKX)",
   label: "Ust-Kut (RUUKX)"
  },
  {
   value: "Uzlovaya (RUUZL)",
   label: "Uzlovaya (RUUZL)"
  },
  {
   value: "Uzlovoy (RUVOY)",
   label: "Uzlovoy (RUVOY)"
  },
  {
   value: "Valuyki (RUVLY)",
   label: "Valuyki (RUVLY)"
  },
  {
   value: "Vankarem (RUVKR)",
   label: "Vankarem (RUVKR)"
  },
  {
   value: "Varandey (RUVAR)",
   label: "Varandey (RUVAR)"
  },
  {
   value: "Vassilevsky Ostrov\/St Petersburg (RUVAO)",
   label: "Vassilevsky Ostrov\/St Petersburg (RUVAO)"
  },
  {
   value: "Vaygach (RUVAY)",
   label: "Vaygach (RUVAY)"
  },
  {
   value: "Velikiy Novgorod (RUVND)",
   label: "Velikiy Novgorod (RUVND)"
  },
  {
   value: "Velikiye Luki (RUVLU)",
   label: "Velikiye Luki (RUVLU)"
  },
  {
   value: "Verkhnedneprovskiy (RUVNP)",
   label: "Verkhnedneprovskiy (RUVNP)"
  },
  {
   value: "Verkhnyaya Pyshma (RUVPY)",
   label: "Verkhnyaya Pyshma (RUVPY)"
  },
  {
   value: "Verkhove (RUVRH)",
   label: "Verkhove (RUVRH)"
  },
  {
   value: "Vertikoye (RUVYE)",
   label: "Vertikoye (RUVYE)"
  },
  {
   value: "Vetluzhskiy (RUVLZ)",
   label: "Vetluzhskiy (RUVLZ)"
  },
  {
   value: "Vichuga (RUVCG)",
   label: "Vichuga (RUVCG)"
  },
  {
   value: "Vitim (RUVTM)",
   label: "Vitim (RUVTM)"
  },
  {
   value: "Vitino (RUVIT)",
   label: "Vitino (RUVIT)"
  },
  {
   value: "Vityaz (RUVTZ)",
   label: "Vityaz (RUVTZ)"
  },
  {
   value: "Vladimir, Vladimirskaya (RUVMR)",
   label: "Vladimir, Vladimirskaya (RUVMR)"
  },
  {
   value: "Voinovka (RUVOI)",
   label: "Voinovka (RUVOI)"
  },
  {
   value: "Volga (RUVLG)",
   label: "Volga (RUVLG)"
  },
  {
   value: "Volgodonsk (RUVLK)",
   label: "Volgodonsk (RUVLK)"
  },
  {
   value: "Vologda (RUVGD)",
   label: "Vologda (RUVGD)"
  },
  {
   value: "Volzhsk (RUVZH)",
   label: "Volzhsk (RUVZH)"
  },
  {
   value: "Vorkuta (RUVKT)",
   label: "Vorkuta (RUVKT)"
  },
  {
   value: "Voronezh (RUVOZ)",
   label: "Voronezh (RUVOZ)"
  },
  {
   value: "Voskresensk (RUVKS)",
   label: "Voskresensk (RUVKS)"
  },
  {
   value: "Voskresensk (RUVOS)",
   label: "Voskresensk (RUVOS)"
  },
  {
   value: "Votkinsk (RUVOT)",
   label: "Votkinsk (RUVOT)"
  },
  {
   value: "Vsevolozhsk (RUVSE)",
   label: "Vsevolozhsk (RUVSE)"
  },
  {
   value: "Vyatskiye Polyany (RUVPO)",
   label: "Vyatskiye Polyany (RUVPO)"
  },
  {
   value: "Vyksa (RUVYK)",
   label: "Vyksa (RUVYK)"
  },
  {
   value: "Vyshniy Volocheck (RUVIC)",
   label: "Vyshniy Volocheck (RUVIC)"
  },
  {
   value: "Vysotsk (RUVYS)",
   label: "Vysotsk (RUVYS)"
  },
  {
   value: "Yakutsk (RUYKS)",
   label: "Yakutsk (RUYKS)"
  },
  {
   value: "Yamburg (RUYAM)",
   label: "Yamburg (RUYAM)"
  },
  {
   value: "Yefremov (Efremov) (RUYEF)",
   label: "Yefremov (Efremov) (RUYEF)"
  },
  {
   value: "Yekaterinburg (Ekaterinburg) (RUYEK)",
   label: "Yekaterinburg (Ekaterinburg) (RUYEK)"
  },
  {
   value: "Yelabuga (RUYBE)",
   label: "Yelabuga (RUYBE)"
  },
  {
   value: "Yelets (RUYLT)",
   label: "Yelets (RUYLT)"
  },
  {
   value: "Yessentuki (Essentuki) (RUESS)",
   label: "Yessentuki (Essentuki) (RUESS)"
  },
  {
   value: "Yuzhno-Sakhalinsk (RUUUS)",
   label: "Yuzhno-Sakhalinsk (RUUUS)"
  },
  {
   value: "Zapolyarnyy (RUZPY)",
   label: "Zapolyarnyy (RUZPY)"
  },
  {
   value: "Zaraysk (RUZYK)",
   label: "Zaraysk (RUZYK)"
  },
  {
   value: "Zarubino (RUZAR)",
   label: "Zarubino (RUZAR)"
  },
  {
   value: "Zelenograd (RUZEL)",
   label: "Zelenograd (RUZEL)"
  },
  {
   value: "Zhirnovsk (RUZHI)",
   label: "Zhirnovsk (RUZHI)"
  },
  {
   value: "Zhukovka, Bryansk (RUZKA)",
   label: "Zhukovka, Bryansk (RUZKA)"
  },
  {
   value: "Zhukovskiy (RUZSY)",
   label: "Zhukovskiy (RUZSY)"
  },
  {
   value: "Zlatoust (RUZTT)",
   label: "Zlatoust (RUZTT)"
  },
  {
   value: "Zlynka (RUZLY)",
   label: "Zlynka (RUZLY)"
  },
  {
   value: "Zmiyëvka (RUZVK)",
   label: "Zmiyëvka (RUZVK)"
  },
  {
   value: "Znamenskoye Gubailovo (RUGUO)",
   label: "Znamenskoye Gubailovo (RUGUO)"
  },
  {
   value: ".RWANDA (RW)",
   label: ".RWANDA (RW)"
  },
  {
   value: "Butare (RWBTQ)",
   label: "Butare (RWBTQ)"
  },
  {
   value: "Gisenyi (RWGYI)",
   label: "Gisenyi (RWGYI)"
  },
  {
   value: "Kamembe (RWKME)",
   label: "Kamembe (RWKME)"
  },
  {
   value: "Ruhengeri (RWRHG)",
   label: "Ruhengeri (RWRHG)"
  },
  {
   value: ".SAUDI ARABIA (SA)",
   label: ".SAUDI ARABIA (SA)"
  },
  {
   value: "Abha (SAAHB)",
   label: "Abha (SAAHB)"
  },
  {
   value: "Ad Dammam (SADMM)",
   label: "Ad Dammam (SADMM)"
  },
  {
   value: "Ad Dawadami (SADAW)",
   label: "Ad Dawadami (SADAW)"
  },
  {
   value: "Al Jubayl Industrial City (SAJBI)",
   label: "Al Jubayl Industrial City (SAJBI)"
  },
  {
   value: "Al Khuraibah (SAKHU)",
   label: "Al Khuraibah (SAKHU)"
  },
  {
   value: "Al Qahmah (SAQAH)",
   label: "Al Qahmah (SAQAH)"
  },
  {
   value: "Al Qunfudah (SAQUN)",
   label: "Al Qunfudah (SAQUN)"
  },
  {
   value: "Al-Baha (SAABT)",
   label: "Al-Baha (SAABT)"
  },
  {
   value: "Arar (SARAE)",
   label: "Arar (SARAE)"
  },
  {
   value: "Badanah (SABDN)",
   label: "Badanah (SABDN)"
  },
  {
   value: "Hazm Al Jalamid (SAHZM)",
   label: "Hazm Al Jalamid (SAHZM)"
  },
  {
   value: "Majma (SAMJH)",
   label: "Majma (SAMJH)"
  },
  {
   value: "Qaisumah (SAAQI)",
   label: "Qaisumah (SAAQI)"
  },
  {
   value: "Qatif (SAQTF)",
   label: "Qatif (SAQTF)"
  },
  {
   value: "Ras Al Zour (SARAZ)",
   label: "Ras Al Zour (SARAZ)"
  },
  {
   value: "Riyadh Dry Port (SARYP)",
   label: "Riyadh Dry Port (SARYP)"
  },
  {
   value: "Sayhat (SASAY)",
   label: "Sayhat (SASAY)"
  },
  {
   value: "Sulayel (SASLF)",
   label: "Sulayel (SASLF)"
  },
  {
   value: "Yanbu Industrial City (SAYBI)",
   label: "Yanbu Industrial City (SAYBI)"
  },
  {
   value: "Zilfi (SAZUL)",
   label: "Zilfi (SAZUL)"
  },
  {
   value: ".SOLOMON ISLANDS (SB)",
   label: ".SOLOMON ISLANDS (SB)"
  },
  {
   value: "Afutara (SBAFT)",
   label: "Afutara (SBAFT)"
  },
  {
   value: "Anuha Island (SBANH)",
   label: "Anuha Island (SBANH)"
  },
  {
   value: "Barakoma (SBVEV)",
   label: "Barakoma (SBVEV)"
  },
  {
   value: "Barora Ite Island (SBRRI)",
   label: "Barora Ite Island (SBRRI)"
  },
  {
   value: "Batuna (SBBPF)",
   label: "Batuna (SBBPF)"
  },
  {
   value: "Filuo (SBSSG)",
   label: "Filuo (SBSSG)"
  },
  {
   value: "Geva (SBGEF)",
   label: "Geva (SBGEF)"
  },
  {
   value: "Guadalcanal (SBGSI)",
   label: "Guadalcanal (SBGSI)"
  },
  {
   value: "Kaghau Island (SBKGE)",
   label: "Kaghau Island (SBKGE)"
  },
  {
   value: "Kukundu (SBKUE)",
   label: "Kukundu (SBKUE)"
  },
  {
   value: "Kwai Harbour (SBKWR)",
   label: "Kwai Harbour (SBKWR)"
  },
  {
   value: "Kwailabesi (SBKWS)",
   label: "Kwailabesi (SBKWS)"
  },
  {
   value: "Mono (SBMNY)",
   label: "Mono (SBMNY)"
  },
  {
   value: "Nemba (SBNEM)",
   label: "Nemba (SBNEM)"
  },
  {
   value: "Nggatokae Island (SBGTA)",
   label: "Nggatokae Island (SBGTA)"
  },
  {
   value: "Ontong Java (SBOTV)",
   label: "Ontong Java (SBOTV)"
  },
  {
   value: "Pulisingau (SBPSG)",
   label: "Pulisingau (SBPSG)"
  },
  {
   value: "Ramata (SBRBV)",
   label: "Ramata (SBRBV)"
  },
  {
   value: "Santa Ana (SBNNB)",
   label: "Santa Ana (SBNNB)"
  },
  {
   value: "Savo (SBSVY)",
   label: "Savo (SBSVY)"
  },
  {
   value: "Suavanao (SBVAO)",
   label: "Suavanao (SBVAO)"
  },
  {
   value: "Tarapaina (SBTAA)",
   label: "Tarapaina (SBTAA)"
  },
  {
   value: ".SEYCHELLES (SC)",
   label: ".SEYCHELLES (SC)"
  },
  {
   value: "Denis Island (SCDEI)",
   label: "Denis Island (SCDEI)"
  },
  {
   value: "Frégate (SCFRK)",
   label: "Frégate (SCFRK)"
  },
  {
   value: "Ile Desroches (SCDES)",
   label: "Ile Desroches (SCDES)"
  },
  {
   value: "Victoria (SCVIC)",
   label: "Victoria (SCVIC)"
  },
  {
   value: ".SUDAN (SD)",
   label: ".SUDAN (SD)"
  },
  {
   value: "Ad Dabbah (SDAAD)",
   label: "Ad Dabbah (SDAAD)"
  },
  {
   value: "Dinder (SDDNX)",
   label: "Dinder (SDDNX)"
  },
  {
   value: "Eldebba (SDEDB)",
   label: "Eldebba (SDEDB)"
  },
  {
   value: "En Nahud (SDNUD)",
   label: "En Nahud (SDNUD)"
  },
  {
   value: "Gedaref (SDGSU)",
   label: "Gedaref (SDGSU)"
  },
  {
   value: "Khashm El Girba (SDGBU)",
   label: "Khashm El Girba (SDGBU)"
  },
  {
   value: "Kosti (SDKST)",
   label: "Kosti (SDKST)"
  },
  {
   value: "Marsa Bashayer (SDMBH)",
   label: "Marsa Bashayer (SDMBH)"
  },
  {
   value: "Nyala (SDUYL)",
   label: "Nyala (SDUYL)"
  },
  {
   value: "Rumbek (SDRBK)",
   label: "Rumbek (SDRBK)"
  },
  {
   value: "Wad Medani (SDDNI)",
   label: "Wad Medani (SDDNI)"
  },
  {
   value: "Wadi Halfa (SDWHF)",
   label: "Wadi Halfa (SDWHF)"
  },
  {
   value: "Yei (SDYEI)",
   label: "Yei (SDYEI)"
  },
  {
   value: ".SWEDEN (SE)",
   label: ".SWEDEN (SE)"
  },
  {
   value: "Abisko (SEABS)",
   label: "Abisko (SEABS)"
  },
  {
   value: "Agunnaryd (SEAGU)",
   label: "Agunnaryd (SEAGU)"
  },
  {
   value: "Aha (SEAHR)",
   label: "Aha (SEAHR)"
  },
  {
   value: "Åkarp (SEAKP)",
   label: "Åkarp (SEAKP)"
  },
  {
   value: "Alby (SEALB)",
   label: "Alby (SEALB)"
  },
  {
   value: "Alfta (SESZB)",
   label: "Alfta (SESZB)"
  },
  {
   value: "Älgarås, Töreboda (SELGR)",
   label: "Älgarås, Töreboda (SELGR)"
  },
  {
   value: "Älvdalen (SEAEN)",
   label: "Älvdalen (SEAEN)"
  },
  {
   value: "Älvkarleby (SESZC)",
   label: "Älvkarleby (SESZC)"
  },
  {
   value: "Älvsbyn (SEABN)",
   label: "Älvsbyn (SEABN)"
  },
  {
   value: "Älvsjö\/Stockholm (SEALS)",
   label: "Älvsjö\/Stockholm (SEALS)"
  },
  {
   value: "Anderslöv (SEASL)",
   label: "Anderslöv (SEASL)"
  },
  {
   value: "Ånge (SEAGE)",
   label: "Ånge (SEAGE)"
  },
  {
   value: "Angered (SEAGD)",
   label: "Angered (SEAGD)"
  },
  {
   value: "Ankarsrum (SEAKR)",
   label: "Ankarsrum (SEAKR)"
  },
  {
   value: "Ånn (SEANN)",
   label: "Ånn (SEANN)"
  },
  {
   value: "Äppelbo (SEAPL)",
   label: "Äppelbo (SEAPL)"
  },
  {
   value: "Åre (SEARE)",
   label: "Åre (SEARE)"
  },
  {
   value: "Årsunda (SEAUD)",
   label: "Årsunda (SEAUD)"
  },
  {
   value: "Åsbro (SEASB)",
   label: "Åsbro (SEASB)"
  },
  {
   value: "Åseda (SEADA)",
   label: "Åseda (SEADA)"
  },
  {
   value: "Åsele (SEALE)",
   label: "Åsele (SEALE)"
  },
  {
   value: "Åshammar (SEASH)",
   label: "Åshammar (SEASH)"
  },
  {
   value: "Askim (SEAKM)",
   label: "Askim (SEAKM)"
  },
  {
   value: "Åtorp (SESZA)",
   label: "Åtorp (SESZA)"
  },
  {
   value: "Båberg (SEBBE)",
   label: "Båberg (SEBBE)"
  },
  {
   value: "Bäckefors (SEBKS)",
   label: "Bäckefors (SEBKS)"
  },
  {
   value: "Bagarmossen\/Stockholm (SEBGO)",
   label: "Bagarmossen\/Stockholm (SEBGO)"
  },
  {
   value: "Bandhagen\/Stockholm (SEBNG)",
   label: "Bandhagen\/Stockholm (SEBNG)"
  },
  {
   value: "Bellö (SESEF)",
   label: "Bellö (SESEF)"
  },
  {
   value: "Berga Örlogsskolor (SEBGA)",
   label: "Berga Örlogsskolor (SEBGA)"
  },
  {
   value: "Bergsjö (SEBRG)",
   label: "Bergsjö (SEBRG)"
  },
  {
   value: "Bettna (SEBNA)",
   label: "Bettna (SEBNA)"
  },
  {
   value: "Billdal (SEBID)",
   label: "Billdal (SEBID)"
  },
  {
   value: "Billeberga (SEBLB)",
   label: "Billeberga (SEBLB)"
  },
  {
   value: "Bjärred (SEBJR)",
   label: "Bjärred (SEBJR)"
  },
  {
   value: "Bjurholm (SEBJM)",
   label: "Bjurholm (SEBJM)"
  },
  {
   value: "Bjuv (SEBJU)",
   label: "Bjuv (SEBJU)"
  },
  {
   value: "Blattnicksele (SEBCS)",
   label: "Blattnicksele (SEBCS)"
  },
  {
   value: "Blomstermåla (SEBLO)",
   label: "Blomstermåla (SEBLO)"
  },
  {
   value: "Bor (SEBOR)",
   label: "Bor (SEBOR)"
  },
  {
   value: "Borrby (SESZD)",
   label: "Borrby (SESZD)"
  },
  {
   value: "Botkyrka (SEBKY)",
   label: "Botkyrka (SEBKY)"
  },
  {
   value: "Bräcke (SEBCK)",
   label: "Bräcke (SEBCK)"
  },
  {
   value: "Brämhult (SEBMH)",
   label: "Brämhult (SEBMH)"
  },
  {
   value: "Brastad (SEBTA)",
   label: "Brastad (SEBTA)"
  },
  {
   value: "Bro (SEBRX)",
   label: "Bro (SEBRX)"
  },
  {
   value: "Broakulla (SEBKU)",
   label: "Broakulla (SEBKU)"
  },
  {
   value: "Broby (SEBRY)",
   label: "Broby (SEBRY)"
  },
  {
   value: "Bromma (SEBMM)",
   label: "Bromma (SEBMM)"
  },
  {
   value: "Brösarp (SEBSP)",
   label: "Brösarp (SEBSP)"
  },
  {
   value: "Brunflo (SEBRU)",
   label: "Brunflo (SEBRU)"
  },
  {
   value: "Bunkeflostrand (SEBSI)",
   label: "Bunkeflostrand (SEBSI)"
  },
  {
   value: "Burträsk (SEBUK)",
   label: "Burträsk (SEBUK)"
  },
  {
   value: "Bygdsiljum (SEBYU)",
   label: "Bygdsiljum (SEBYU)"
  },
  {
   value: "Dannike (SEDNK)",
   label: "Dannike (SEDNK)"
  },
  {
   value: "Deje (SEDEJ)",
   label: "Deje (SEDEJ)"
  },
  {
   value: "Delsbo (SEDEL)",
   label: "Delsbo (SEDEL)"
  },
  {
   value: "Dingle (SEDNG)",
   label: "Dingle (SEDNG)"
  },
  {
   value: "Diö (SEDIO)",
   label: "Diö (SEDIO)"
  },
  {
   value: "Djurhamn (SEDHN)",
   label: "Djurhamn (SEDHN)"
  },
  {
   value: "Djursholm (SEDSM)",
   label: "Djursholm (SEDSM)"
  },
  {
   value: "Drottningholm (SEDRT)",
   label: "Drottningholm (SEDRT)"
  },
  {
   value: "Dvaersaett (SEDSE)",
   label: "Dvaersaett (SEDSE)"
  },
  {
   value: "Eda (SEEDA)",
   label: "Eda (SEEDA)"
  },
  {
   value: "Ekshärad (SEEKH)",
   label: "Ekshärad (SEEKH)"
  },
  {
   value: "Ellös (SEELO)",
   label: "Ellös (SEELO)"
  },
  {
   value: "Enhörna (SEEHR)",
   label: "Enhörna (SEEHR)"
  },
  {
   value: "Enstaberga (SEEBG)",
   label: "Enstaberga (SEEBG)"
  },
  {
   value: "Erikslund (SEERI)",
   label: "Erikslund (SEERI)"
  },
  {
   value: "Ervalla (SEEVL)",
   label: "Ervalla (SEEVL)"
  },
  {
   value: "Fårbo (SEFBO)",
   label: "Fårbo (SEFBO)"
  },
  {
   value: "Färgelanda (SEFAE)",
   label: "Färgelanda (SEFAE)"
  },
  {
   value: "Fegen (SEFEN)",
   label: "Fegen (SEFEN)"
  },
  {
   value: "Finja (SEFNA)",
   label: "Finja (SEFNA)"
  },
  {
   value: "Fiskeby (SEFIK)",
   label: "Fiskeby (SEFIK)"
  },
  {
   value: "Fjälkinge (SEFLG)",
   label: "Fjälkinge (SEFLG)"
  },
  {
   value: "Fjärås (SEFJC)",
   label: "Fjärås (SEFJC)"
  },
  {
   value: "Flisby (SESZG)",
   label: "Flisby (SESZG)"
  },
  {
   value: "Floda (SESZW)",
   label: "Floda (SESZW)"
  },
  {
   value: "Forsa (SEORA)",
   label: "Forsa (SEORA)"
  },
  {
   value: "Forsbacka (SEFOA)",
   label: "Forsbacka (SEFOA)"
  },
  {
   value: "Frillesås (SEFSA)",
   label: "Frillesås (SEFSA)"
  },
  {
   value: "Frövi (SEFRO)",
   label: "Frövi (SEFRO)"
  },
  {
   value: "Furulund (SEFLD)",
   label: "Furulund (SEFLD)"
  },
  {
   value: "Gällö (SEGAL)",
   label: "Gällö (SEGAL)"
  },
  {
   value: "Garpenberg (SEGPB)",
   label: "Garpenberg (SEGPB)"
  },
  {
   value: "Gemla (SEGML)",
   label: "Gemla (SEGML)"
  },
  {
   value: "Gimo (SEGMO)",
   label: "Gimo (SEGMO)"
  },
  {
   value: "Glava (SEGVA)",
   label: "Glava (SEGVA)"
  },
  {
   value: "Gnesta (SEGNE)",
   label: "Gnesta (SEGNE)"
  },
  {
   value: "Gorsingeholm (SEGOR)",
   label: "Gorsingeholm (SEGOR)"
  },
  {
   value: "Gräfsnäs (SEGRS)",
   label: "Gräfsnäs (SEGRS)"
  },
  {
   value: "Grangärde (SEGGE)",
   label: "Grangärde (SEGGE)"
  },
  {
   value: "Gränna (SEGAA)",
   label: "Gränna (SEGAA)"
  },
  {
   value: "Granudden (SEGND)",
   label: "Granudden (SEGND)"
  },
  {
   value: "Grästorp (SEGRP)",
   label: "Grästorp (SEGRP)"
  },
  {
   value: "Grimsaas (SEGSA)",
   label: "Grimsaas (SEGSA)"
  },
  {
   value: "Grythyttan (SEGYT)",
   label: "Grythyttan (SEGYT)"
  },
  {
   value: "Gunnilse (SELSE)",
   label: "Gunnilse (SELSE)"
  },
  {
   value: "Gustafs (SEGTS)",
   label: "Gustafs (SEGTS)"
  },
  {
   value: "Gusum (SEGUM)",
   label: "Gusum (SEGUM)"
  },
  {
   value: "Gyttorp (SESZH)",
   label: "Gyttorp (SESZH)"
  },
  {
   value: "Hackås (SEHAC)",
   label: "Hackås (SEHAC)"
  },
  {
   value: "Hälleforsnäs (SEHRS)",
   label: "Hälleforsnäs (SEHRS)"
  },
  {
   value: "Hallsberg (SEHSG)",
   label: "Hallsberg (SEHSG)"
  },
  {
   value: "Hammar (SEHMR)",
   label: "Hammar (SEHMR)"
  },
  {
   value: "Hammar (SESZT)",
   label: "Hammar (SESZT)"
  },
  {
   value: "Hammerdal (SEHMD)",
   label: "Hammerdal (SEHMD)"
  },
  {
   value: "Haninge (SEHNI)",
   label: "Haninge (SEHNI)"
  },
  {
   value: "Harestad (SEHRD)",
   label: "Harestad (SEHRD)"
  },
  {
   value: "Harryda (SEHRY)",
   label: "Harryda (SEHRY)"
  },
  {
   value: "Hasslarp (SEHSP)",
   label: "Hasslarp (SEHSP)"
  },
  {
   value: "Heberg (SEHEG)",
   label: "Heberg (SEHEG)"
  },
  {
   value: "Hede (SEHEE)",
   label: "Hede (SEHEE)"
  },
  {
   value: "Heestrand (SEHST)",
   label: "Heestrand (SEHST)"
  },
  {
   value: "Hemavan (SEHMV)",
   label: "Hemavan (SEHMV)"
  },
  {
   value: "Hemse (SEHEM)",
   label: "Hemse (SEHEM)"
  },
  {
   value: "Hestra (SEHES)",
   label: "Hestra (SEHES)"
  },
  {
   value: "Hindås (SEHDA)",
   label: "Hindås (SEHDA)"
  },
  {
   value: "Hisings Kärra\/Göteborg (SEHRR)",
   label: "Hisings Kärra\/Göteborg (SEHRR)"
  },
  {
   value: "Hjältevad (SESZQ)",
   label: "Hjältevad (SESZQ)"
  },
  {
   value: "Hjärtum (SEHTM)",
   label: "Hjärtum (SEHTM)"
  },
  {
   value: "Hollviken (SESZI)",
   label: "Hollviken (SESZI)"
  },
  {
   value: "Hölö (SEHLO)",
   label: "Hölö (SEHLO)"
  },
  {
   value: "Hönö (SEHNO)",
   label: "Hönö (SEHNO)"
  },
  {
   value: "Höör (SEHOO)",
   label: "Höör (SEHOO)"
  },
  {
   value: "Hörby (SEHOE)",
   label: "Hörby (SEHOE)"
  },
  {
   value: "Horred (SEHOD)",
   label: "Horred (SEHOD)"
  },
  {
   value: "Hovas (SEHOA)",
   label: "Hovas (SEHOA)"
  },
  {
   value: "Hovmantorp (SEHOV)",
   label: "Hovmantorp (SEHOV)"
  },
  {
   value: "Hyllinge (SEHYG)",
   label: "Hyllinge (SEHYG)"
  },
  {
   value: "Idre (SEIDB)",
   label: "Idre (SEIDB)"
  },
  {
   value: "Igelstorp (SEIGP)",
   label: "Igelstorp (SEIGP)"
  },
  {
   value: "Insjön (SEINS)",
   label: "Insjön (SEINS)"
  },
  {
   value: "Järbo (SEJAO)",
   label: "Järbo (SEJAO)"
  },
  {
   value: "Jokkmokk (SEJOK)",
   label: "Jokkmokk (SEJOK)"
  },
  {
   value: "Jörlanda (SEJNA)",
   label: "Jörlanda (SEJNA)"
  },
  {
   value: "Jukkasjärvi (SEJUK)",
   label: "Jukkasjärvi (SEJUK)"
  },
  {
   value: "Junsele (SEJUN)",
   label: "Junsele (SEJUN)"
  },
  {
   value: "Kågeröd (SEKRD)",
   label: "Kågeröd (SEKRD)"
  },
  {
   value: "Kagghamra (SEKGG)",
   label: "Kagghamra (SEKGG)"
  },
  {
   value: "Kälarne (SEKLE)",
   label: "Kälarne (SEKLE)"
  },
  {
   value: "Kållandsö (SEKLO)",
   label: "Kållandsö (SEKLO)"
  },
  {
   value: "Kållered (SEKAD)",
   label: "Kållered (SEKAD)"
  },
  {
   value: "Kallinge (SESZJ)",
   label: "Kallinge (SESZJ)"
  },
  {
   value: "Kalmarsand (SEKAL)",
   label: "Kalmarsand (SEKAL)"
  },
  {
   value: "Kareby (SEYBY)",
   label: "Kareby (SEYBY)"
  },
  {
   value: "Karlsborg (SEKBG)",
   label: "Karlsborg (SEKBG)"
  },
  {
   value: "Karö (SEKAO)",
   label: "Karö (SEKAO)"
  },
  {
   value: "Katrineholm (SEKAM)",
   label: "Katrineholm (SEKAM)"
  },
  {
   value: "Kaxholmen (SEKXH)",
   label: "Kaxholmen (SEKXH)"
  },
  {
   value: "Kil (SEKIL)",
   label: "Kil (SEKIL)"
  },
  {
   value: "Kilsmo (SEKIM)",
   label: "Kilsmo (SEKIM)"
  },
  {
   value: "Kimstad (SESZK)",
   label: "Kimstad (SESZK)"
  },
  {
   value: "Kinnarp (SEKIN)",
   label: "Kinnarp (SEKIN)"
  },
  {
   value: "Kisa (SEKSA)",
   label: "Kisa (SEKSA)"
  },
  {
   value: "Klädesholmen (SEKLD)",
   label: "Klädesholmen (SEKLD)"
  },
  {
   value: "Klagshamn (SEKGM)",
   label: "Klagshamn (SEKGM)"
  },
  {
   value: "Klagstorp (SEKSP)",
   label: "Klagstorp (SEKSP)"
  },
  {
   value: "Klavreström (SEKLA)",
   label: "Klavreström (SEKLA)"
  },
  {
   value: "Kolbäck (SEKOL)",
   label: "Kolbäck (SEKOL)"
  },
  {
   value: "Köpingebro (SEKOP)",
   label: "Köpingebro (SEKOP)"
  },
  {
   value: "Krokek (SEKRK)",
   label: "Krokek (SEKRK)"
  },
  {
   value: "Krokom (SEKKO)",
   label: "Krokom (SEKKO)"
  },
  {
   value: "Krokvåg (SEKRO)",
   label: "Krokvåg (SEKRO)"
  },
  {
   value: "Kullavik (SEKLV)",
   label: "Kullavik (SEKLV)"
  },
  {
   value: "Kvarnsveden (SEKVN)",
   label: "Kvarnsveden (SEKVN)"
  },
  {
   value: "Kvarntorp, Örebro (SEKTP)",
   label: "Kvarntorp, Örebro (SEKTP)"
  },
  {
   value: "Kvissleby (SEKVY)",
   label: "Kvissleby (SEKVY)"
  },
  {
   value: "Kyrkås (SEKYK)",
   label: "Kyrkås (SEKYK)"
  },
  {
   value: "Kyrkesund (SEKKS)",
   label: "Kyrkesund (SEKKS)"
  },
  {
   value: "Läckeby (SEECK)",
   label: "Läckeby (SEECK)"
  },
  {
   value: "Lagan (SELGN)",
   label: "Lagan (SELGN)"
  },
  {
   value: "Laholm (SELAH)",
   label: "Laholm (SELAH)"
  },
  {
   value: "Landvetter (SELAV)",
   label: "Landvetter (SELAV)"
  },
  {
   value: "Långaryd (SELAY)",
   label: "Långaryd (SELAY)"
  },
  {
   value: "Länna (SELNA)",
   label: "Länna (SELNA)"
  },
  {
   value: "Leksand (SELEK)",
   label: "Leksand (SELEK)"
  },
  {
   value: "Lessebo (SELEO)",
   label: "Lessebo (SELEO)"
  },
  {
   value: "Lindome (SELIN)",
   label: "Lindome (SELIN)"
  },
  {
   value: "Ljungaverk (SELJG)",
   label: "Ljungaverk (SELJG)"
  },
  {
   value: "Ljungsbro (SELJB)",
   label: "Ljungsbro (SELJB)"
  },
  {
   value: "Ljusdal (SELJL)",
   label: "Ljusdal (SELJL)"
  },
  {
   value: "Ljusfallshammar (SELHM)",
   label: "Ljusfallshammar (SELHM)"
  },
  {
   value: "Ljusterö (SELJO)",
   label: "Ljusterö (SELJO)"
  },
  {
   value: "Löddeköpinge (SELOD)",
   label: "Löddeköpinge (SELOD)"
  },
  {
   value: "Loftahammar (SELOF)",
   label: "Loftahammar (SELOF)"
  },
  {
   value: "Lönsboda (SELON)",
   label: "Lönsboda (SELON)"
  },
  {
   value: "Löten (SELOT)",
   label: "Löten (SELOT)"
  },
  {
   value: "Lycksele (SELYC)",
   label: "Lycksele (SELYC)"
  },
  {
   value: "Målilla (SESZL)",
   label: "Målilla (SESZL)"
  },
  {
   value: "Malmback (SEMBA)",
   label: "Malmback (SEMBA)"
  },
  {
   value: "Malmberget (SEMBT)",
   label: "Malmberget (SEMBT)"
  },
  {
   value: "Malmby (SEMAL)",
   label: "Malmby (SEMAL)"
  },
  {
   value: "Mellansel (SEMLS)",
   label: "Mellansel (SEMLS)"
  },
  {
   value: "Mockfjärd (SEMOC)",
   label: "Mockfjärd (SEMOC)"
  },
  {
   value: "Moheda (SEMHA)",
   label: "Moheda (SEMHA)"
  },
  {
   value: "Moholm (SEMHM)",
   label: "Moholm (SEMHM)"
  },
  {
   value: "Möklinta (SESZM)",
   label: "Möklinta (SESZM)"
  },
  {
   value: "Molkom (SEMOL)",
   label: "Molkom (SEMOL)"
  },
  {
   value: "Mölle (SEMLE)",
   label: "Mölle (SEMLE)"
  },
  {
   value: "Mölltorp (SEMTP)",
   label: "Mölltorp (SEMTP)"
  },
  {
   value: "Morgongåva (SEMGG)",
   label: "Morgongåva (SEMGG)"
  },
  {
   value: "Mörrum (SEMOM)",
   label: "Mörrum (SEMOM)"
  },
  {
   value: "Mörtfors (SEMOF)",
   label: "Mörtfors (SEMOF)"
  },
  {
   value: "Mullhyttan (SESZN)",
   label: "Mullhyttan (SESZN)"
  },
  {
   value: "Munka-Ljungby (SEMLJ)",
   label: "Munka-Ljungby (SEMLJ)"
  },
  {
   value: "Muskö (SEMSK)",
   label: "Muskö (SEMSK)"
  },
  {
   value: "Näsum (SENSM)",
   label: "Näsum (SENSM)"
  },
  {
   value: "Nättraby (SENTY)",
   label: "Nättraby (SENTY)"
  },
  {
   value: "Nödinge (SENDE)",
   label: "Nödinge (SENDE)"
  },
  {
   value: "Nora (SENOA)",
   label: "Nora (SENOA)"
  },
  {
   value: "Norrhult (SENRH)",
   label: "Norrhult (SENRH)"
  },
  {
   value: "Norsborg (SENSG)",
   label: "Norsborg (SENSG)"
  },
  {
   value: "Norsjö (SENOJ)",
   label: "Norsjö (SENOJ)"
  },
  {
   value: "Nygård (SENYG)",
   label: "Nygård (SENYG)"
  },
  {
   value: "Nykvarn (SENGV)",
   label: "Nykvarn (SENGV)"
  },
  {
   value: "Nymåla (SENML)",
   label: "Nymåla (SENML)"
  },
  {
   value: "Nyvång (SENYV)",
   label: "Nyvång (SENYV)"
  },
  {
   value: "Ödåkra (SEODA)",
   label: "Ödåkra (SEODA)"
  },
  {
   value: "Odensbacken (SEODB)",
   label: "Odensbacken (SEODB)"
  },
  {
   value: "Öjebyn (SEOJY)",
   label: "Öjebyn (SEOJY)"
  },
  {
   value: "Öjersjö (SEOJS)",
   label: "Öjersjö (SEOJS)"
  },
  {
   value: "Ön (SEOEN)",
   label: "Ön (SEOEN)"
  },
  {
   value: "Örby (SEOBY)",
   label: "Örby (SEOBY)"
  },
  {
   value: "Orbyhus (SEOYS)",
   label: "Orbyhus (SEOYS)"
  },
  {
   value: "Orsundsbro (SEODO)",
   label: "Orsundsbro (SEODO)"
  },
  {
   value: "Ösmo (SEOSO)",
   label: "Ösmo (SEOSO)"
  },
  {
   value: "Osterbybruk (SEOYB)",
   label: "Osterbybruk (SEOYB)"
  },
  {
   value: "Östervåla (SEOTV)",
   label: "Östervåla (SEOTV)"
  },
  {
   value: "Östhammar (SEOSH)",
   label: "Östhammar (SEOSH)"
  },
  {
   value: "Östra Sönnarslöv (SEOSV)",
   label: "Östra Sönnarslöv (SEOSV)"
  },
  {
   value: "Överkalix (SEOEV)",
   label: "Överkalix (SEOEV)"
  },
  {
   value: "Övertorneå (SEOVE)",
   label: "Övertorneå (SEOVE)"
  },
  {
   value: "Överum (SEOEM)",
   label: "Överum (SEOEM)"
  },
  {
   value: "Oviken (SEOVN)",
   label: "Oviken (SEOVN)"
  },
  {
   value: "Pålsboda (SEPSO)",
   label: "Pålsboda (SEPSO)"
  },
  {
   value: "Pataholm (SEPHM)",
   label: "Pataholm (SEPHM)"
  },
  {
   value: "Pixbo, Harryda (SEPIX)",
   label: "Pixbo, Harryda (SEPIX)"
  },
  {
   value: "Ragunda (SERAG)",
   label: "Ragunda (SERAG)"
  },
  {
   value: "Rimbo (SERIM)",
   label: "Rimbo (SERIM)"
  },
  {
   value: "Rörvik (SESZP)",
   label: "Rörvik (SESZP)"
  },
  {
   value: "Rottneros (SERNS)",
   label: "Rottneros (SERNS)"
  },
  {
   value: "Ruda, Högsby (SERUD)",
   label: "Ruda, Högsby (SERUD)"
  },
  {
   value: "Rumskulla (SESZO)",
   label: "Rumskulla (SESZO)"
  },
  {
   value: "Runmarö (SERUR)",
   label: "Runmarö (SERUR)"
  },
  {
   value: "Rydaholm (SERYM)",
   label: "Rydaholm (SERYM)"
  },
  {
   value: "Sandhult (SESHT)",
   label: "Sandhult (SESHT)"
  },
  {
   value: "Såtenäs (SESAS)",
   label: "Såtenäs (SESAS)"
  },
  {
   value: "Säter (SESAR)",
   label: "Säter (SESAR)"
  },
  {
   value: "Sätila (SESZS)",
   label: "Sätila (SESZS)"
  },
  {
   value: "Sävar (SESVR)",
   label: "Sävar (SESVR)"
  },
  {
   value: "Sävedalen (SESDA)",
   label: "Sävedalen (SESDA)"
  },
  {
   value: "Skagshamn (SESGM)",
   label: "Skagshamn (SESGM)"
  },
  {
   value: "Skanör (SESNR)",
   label: "Skanör (SESNR)"
  },
  {
   value: "Skara (SESRA)",
   label: "Skara (SESRA)"
  },
  {
   value: "Skärplinge (SESPG)",
   label: "Skärplinge (SESPG)"
  },
  {
   value: "Skarpnäck (SESPK)",
   label: "Skarpnäck (SESPK)"
  },
  {
   value: "Skepplanda (SESPL)",
   label: "Skepplanda (SESPL)"
  },
  {
   value: "Skeppshult (SESZR)",
   label: "Skeppshult (SESZR)"
  },
  {
   value: "Skillingaryd (SESKI)",
   label: "Skillingaryd (SESKI)"
  },
  {
   value: "Skinnskatteberg (SESSG)",
   label: "Skinnskatteberg (SESSG)"
  },
  {
   value: "Skogstorp, Vingåker (SESGP)",
   label: "Skogstorp, Vingåker (SESGP)"
  },
  {
   value: "Slöinge (SESLG)",
   label: "Slöinge (SESLG)"
  },
  {
   value: "Slutarp (SESUP)",
   label: "Slutarp (SESUP)"
  },
  {
   value: "Söderkulla (SECSA)",
   label: "Söderkulla (SECSA)"
  },
  {
   value: "Södra Vika (SESOD)",
   label: "Södra Vika (SESOD)"
  },
  {
   value: "Sollebrunn (SESBU)",
   label: "Sollebrunn (SESBU)"
  },
  {
   value: "Sorunda (SESRU)",
   label: "Sorunda (SESRU)"
  },
  {
   value: "Sparreholm (SESPH)",
   label: "Sparreholm (SESPH)"
  },
  {
   value: "Stenkullen (SESNU)",
   label: "Stenkullen (SESNU)"
  },
  {
   value: "Stigtomta (SESTG)",
   label: "Stigtomta (SESTG)"
  },
  {
   value: "Stjärnsund (SESJD)",
   label: "Stjärnsund (SESJD)"
  },
  {
   value: "Stockaryd (SESRY)",
   label: "Stockaryd (SESRY)"
  },
  {
   value: "Stöde (SESDE)",
   label: "Stöde (SESDE)"
  },
  {
   value: "Storfors (SESFS)",
   label: "Storfors (SESFS)"
  },
  {
   value: "Storuman (SESMN)",
   label: "Storuman (SESMN)"
  },
  {
   value: "Strömsbruk (SESBK)",
   label: "Strömsbruk (SESBK)"
  },
  {
   value: "Strömsund (SESSD)",
   label: "Strömsund (SESSD)"
  },
  {
   value: "Styrsö (SESTR)",
   label: "Styrsö (SESTR)"
  },
  {
   value: "Sundby (SESNY)",
   label: "Sundby (SESNY)"
  },
  {
   value: "Sundsbruk (SESDK)",
   label: "Sundsbruk (SESDK)"
  },
  {
   value: "Sunne (SESUE)",
   label: "Sunne (SESUE)"
  },
  {
   value: "Svalöv (SESVA)",
   label: "Svalöv (SESVA)"
  },
  {
   value: "Svanesund (SESND)",
   label: "Svanesund (SESND)"
  },
  {
   value: "Svanesund (SESSU)",
   label: "Svanesund (SESSU)"
  },
  {
   value: "Svängsta (SESNA)",
   label: "Svängsta (SESNA)"
  },
  {
   value: "Svenljunga (SESJA)",
   label: "Svenljunga (SESJA)"
  },
  {
   value: "Svensbyn (SESBY)",
   label: "Svensbyn (SESBY)"
  },
  {
   value: "Svenstavik (SESVE)",
   label: "Svenstavik (SESVE)"
  },
  {
   value: "Svinesund (SESVI)",
   label: "Svinesund (SESVI)"
  },
  {
   value: "Sysslebäck (SESYS)",
   label: "Sysslebäck (SESYS)"
  },
  {
   value: "Taberg (SETEG)",
   label: "Taberg (SETEG)"
  },
  {
   value: "Tågsjöberg (SETSB)",
   label: "Tågsjöberg (SETSB)"
  },
  {
   value: "Tångaberg (SETAG)",
   label: "Tångaberg (SETAG)"
  },
  {
   value: "Tärnaby (SETAE)",
   label: "Tärnaby (SETAE)"
  },
  {
   value: "Tierp (SETIE)",
   label: "Tierp (SETIE)"
  },
  {
   value: "Timmele (SESZY)",
   label: "Timmele (SESZY)"
  },
  {
   value: "Tobo (SETBO)",
   label: "Tobo (SETBO)"
  },
  {
   value: "Töfta, Gotland (SESZX)",
   label: "Töfta, Gotland (SESZX)"
  },
  {
   value: "Tomtbod (SETTD)",
   label: "Tomtbod (SETTD)"
  },
  {
   value: "Tomteboda\/Solna (SETBA)",
   label: "Tomteboda\/Solna (SETBA)"
  },
  {
   value: "Torpshammar (SETHR)",
   label: "Torpshammar (SETHR)"
  },
  {
   value: "Torsaker (SETSR)",
   label: "Torsaker (SETSR)"
  },
  {
   value: "Torsö (SETSO)",
   label: "Torsö (SETSO)"
  },
  {
   value: "Torup (SETOP)",
   label: "Torup (SETOP)"
  },
  {
   value: "Totebo (SETOT)",
   label: "Totebo (SETOT)"
  },
  {
   value: "Trekanten (SESZU)",
   label: "Trekanten (SESZU)"
  },
  {
   value: "Tullinge (SETUG)",
   label: "Tullinge (SETUG)"
  },
  {
   value: "Tvååker (SETVA)",
   label: "Tvååker (SETVA)"
  },
  {
   value: "Tyringe (SETYR)",
   label: "Tyringe (SETYR)"
  },
  {
   value: "Ucklum (SEUKM)",
   label: "Ucklum (SEUKM)"
  },
  {
   value: "Underås (SEUND)",
   label: "Underås (SEUND)"
  },
  {
   value: "Urshult (SESZV)",
   label: "Urshult (SESZV)"
  },
  {
   value: "Vadstena (SEVAD)",
   label: "Vadstena (SEVAD)"
  },
  {
   value: "Vagnhärad (SEVHD)",
   label: "Vagnhärad (SEVHD)"
  },
  {
   value: "Vallentuna (SEVTA)",
   label: "Vallentuna (SEVTA)"
  },
  {
   value: "Vällingby (SEVAY)",
   label: "Vällingby (SEVAY)"
  },
  {
   value: "Vännäs (SEVNS)",
   label: "Vännäs (SEVNS)"
  },
  {
   value: "Vansbro (SEVAO)",
   label: "Vansbro (SEVAO)"
  },
  {
   value: "Vårby (SEVRB)",
   label: "Vårby (SEVRB)"
  },
  {
   value: "Värmdö (SEVRM)",
   label: "Värmdö (SEVRM)"
  },
  {
   value: "Väröbacka (SEVBC)",
   label: "Väröbacka (SEVBC)"
  },
  {
   value: "Västerhaninge (SEVHE)",
   label: "Västerhaninge (SEVHE)"
  },
  {
   value: "Västerlanda (SEVLA)",
   label: "Västerlanda (SEVLA)"
  },
  {
   value: "Vaxholm (SEVXH)",
   label: "Vaxholm (SEVXH)"
  },
  {
   value: "Vellinge (SEVEL)",
   label: "Vellinge (SEVEL)"
  },
  {
   value: "Vikmanshyttan (SEVIK)",
   label: "Vikmanshyttan (SEVIK)"
  },
  {
   value: "Vingåker (SEVIA)",
   label: "Vingåker (SEVIA)"
  },
  {
   value: "Vintrie (SEVII)",
   label: "Vintrie (SEVII)"
  },
  {
   value: "Virsbo Bruk (SEVIO)",
   label: "Virsbo Bruk (SEVIO)"
  },
  {
   value: "Virserum (SEVIR)",
   label: "Virserum (SEVIR)"
  },
  {
   value: "Vistträsk (SEVTK)",
   label: "Vistträsk (SEVTK)"
  },
  {
   value: "Vrångö (SEVGO)",
   label: "Vrångö (SEVGO)"
  },
  {
   value: "Vretstorp (SEVSP)",
   label: "Vretstorp (SEVSP)"
  },
  {
   value: "Yngsjö (SEYNG)",
   label: "Yngsjö (SEYNG)"
  },
  {
   value: "Ytterfälle, Härnösand (SEYTT)",
   label: "Ytterfälle, Härnösand (SEYTT)"
  },
  {
   value: "Zinkgruvan (SEZGV)",
   label: "Zinkgruvan (SEZGV)"
  },
  {
   value: ".SINGAPORE (SG)",
   label: ".SINGAPORE (SG)"
  },
  {
   value: "Changi (SGCHG)",
   label: "Changi (SGCHG)"
  },
  {
   value: "Tengah (SGTGA)",
   label: "Tengah (SGTGA)"
  },
  {
   value: ".SAINT HELENA (SH)",
   label: ".SAINT HELENA (SH)"
  },
  {
   value: ".SLOVENIA (SI)",
   label: ".SLOVENIA (SI)"
  },
  {
   value: "Ajdovscina (SIAJD)",
   label: "Ajdovscina (SIAJD)"
  },
  {
   value: "Begunje na Gorenjskem (SIBNG)",
   label: "Begunje na Gorenjskem (SIBNG)"
  },
  {
   value: "Begunje pri Cerknici (SILZA)",
   label: "Begunje pri Cerknici (SILZA)"
  },
  {
   value: "Bled (SIBLE)",
   label: "Bled (SIBLE)"
  },
  {
   value: "Brnik (SIBRN)",
   label: "Brnik (SIBRN)"
  },
  {
   value: "Celje (SICJE)",
   label: "Celje (SICJE)"
  },
  {
   value: "Cerknica (SICKC)",
   label: "Cerknica (SICKC)"
  },
  {
   value: "Cerkno (SICER)",
   label: "Cerkno (SICER)"
  },
  {
   value: "Crnice (SICRE)",
   label: "Crnice (SICRE)"
  },
  {
   value: "Crnomelj (SILZL)",
   label: "Crnomelj (SILZL)"
  },
  {
   value: "Dobova (SIDOB)",
   label: "Dobova (SIDOB)"
  },
  {
   value: "Dobrovo (SIDBO)",
   label: "Dobrovo (SIDBO)"
  },
  {
   value: "Dol pri Hrastniku (SILZE)",
   label: "Dol pri Hrastniku (SILZE)"
  },
  {
   value: "Fram (SIFRA)",
   label: "Fram (SIFRA)"
  },
  {
   value: "Gemerská Horka (SIGSH)",
   label: "Gemerská Horka (SIGSH)"
  },
  {
   value: "Gorenja Straza (SIGSZ)",
   label: "Gorenja Straza (SIGSZ)"
  },
  {
   value: "Grosuplje (SIGJS)",
   label: "Grosuplje (SIGJS)"
  },
  {
   value: "Hrastnik (SILZH)",
   label: "Hrastnik (SILZH)"
  },
  {
   value: "Idrija (SILZI)",
   label: "Idrija (SILZI)"
  },
  {
   value: "Ilirska Bistrica (SIIBS)",
   label: "Ilirska Bistrica (SIIBS)"
  },
  {
   value: "Jarenina (SIJAR)",
   label: "Jarenina (SIJAR)"
  },
  {
   value: "Jesenice (SIJCE)",
   label: "Jesenice (SIJCE)"
  },
  {
   value: "Kapele (SIAEE)",
   label: "Kapele (SIAEE)"
  },
  {
   value: "Kidricevo (SIKID)",
   label: "Kidricevo (SIKID)"
  },
  {
   value: "Kostanjevica na Krki (SIKST)",
   label: "Kostanjevica na Krki (SIKST)"
  },
  {
   value: "Kozina (SIKOZ)",
   label: "Kozina (SIKOZ)"
  },
  {
   value: "Krsko (SIKRK)",
   label: "Krsko (SIKRK)"
  },
  {
   value: "Lasko (SILAS)",
   label: "Lasko (SILAS)"
  },
  {
   value: "Lenart v Slovenskih Goricah (SILVS)",
   label: "Lenart v Slovenskih Goricah (SILVS)"
  },
  {
   value: "Lendava (SIDAV)",
   label: "Lendava (SIDAV)"
  },
  {
   value: "Litija (SILZJ)",
   label: "Litija (SILZJ)"
  },
  {
   value: "Logatec (SILOG)",
   label: "Logatec (SILOG)"
  },
  {
   value: "Markovci (SIVCI)",
   label: "Markovci (SIVCI)"
  },
  {
   value: "Medvode (SIMDE)",
   label: "Medvode (SIMDE)"
  },
  {
   value: "Menges (SIMGS)",
   label: "Menges (SIMGS)"
  },
  {
   value: "Mezica (SIMZA)",
   label: "Mezica (SIMZA)"
  },
  {
   value: "Miren (SILZK)",
   label: "Miren (SILZK)"
  },
  {
   value: "Murska Sobota (SIMUS)",
   label: "Murska Sobota (SIMUS)"
  },
  {
   value: "Naklo (SINKO)",
   label: "Naklo (SINKO)"
  },
  {
   value: "Nova Gorica (SINOG)",
   label: "Nova Gorica (SINOG)"
  },
  {
   value: "Novo Mesto (SINMO)",
   label: "Novo Mesto (SINMO)"
  },
  {
   value: "Obrezje (SIOBR)",
   label: "Obrezje (SIOBR)"
  },
  {
   value: "Ormoz (SIORZ)",
   label: "Ormoz (SIORZ)"
  },
  {
   value: "Petrovce (SIPTV)",
   label: "Petrovce (SIPTV)"
  },
  {
   value: "Pivka (SILZG)",
   label: "Pivka (SILZG)"
  },
  {
   value: "Podnanos (SIPOV)",
   label: "Podnanos (SIPOV)"
  },
  {
   value: "Poljcane (SILZM)",
   label: "Poljcane (SILZM)"
  },
  {
   value: "Postojna (SIPOS)",
   label: "Postojna (SIPOS)"
  },
  {
   value: "Pragersko (SIPRA)",
   label: "Pragersko (SIPRA)"
  },
  {
   value: "Ptuj (SIPTU)",
   label: "Ptuj (SIPTU)"
  },
  {
   value: "Radece (SILZO)",
   label: "Radece (SILZO)"
  },
  {
   value: "Radomlje (SILZN)",
   label: "Radomlje (SILZN)"
  },
  {
   value: "Ravne na Koroskem (SIRNK)",
   label: "Ravne na Koroskem (SIRNK)"
  },
  {
   value: "Rence (SIRNC)",
   label: "Rence (SIRNC)"
  },
  {
   value: "Ribnica (SIRNA)",
   label: "Ribnica (SIRNA)"
  },
  {
   value: "Rogasovci (SIROG)",
   label: "Rogasovci (SIROG)"
  },
  {
   value: "Ruse (SILZF)",
   label: "Ruse (SILZF)"
  },
  {
   value: "Secovlje (SISEC)",
   label: "Secovlje (SISEC)"
  },
  {
   value: "Semic (SILZB)",
   label: "Semic (SILZB)"
  },
  {
   value: "Sempeter pri Gorici (SISEM)",
   label: "Sempeter pri Gorici (SISEM)"
  },
  {
   value: "Sempeter v Savinjski Dolini (SISPR)",
   label: "Sempeter v Savinjski Dolini (SISPR)"
  },
  {
   value: "Sentjanz pri Dravogradu (SILZQ)",
   label: "Sentjanz pri Dravogradu (SILZQ)"
  },
  {
   value: "Sevnica (SISVC)",
   label: "Sevnica (SISVC)"
  },
  {
   value: "Sezana (SISZA)",
   label: "Sezana (SISZA)"
  },
  {
   value: "Skofja Loka (SILZP)",
   label: "Skofja Loka (SILZP)"
  },
  {
   value: "Sladki Vrh (SIVTT)",
   label: "Sladki Vrh (SIVTT)"
  },
  {
   value: "Slovenj Gradec (SISLG)",
   label: "Slovenj Gradec (SISLG)"
  },
  {
   value: "Slovenska Bistrica (SISBA)",
   label: "Slovenska Bistrica (SISBA)"
  },
  {
   value: "Slovenske Konjice (SISLK)",
   label: "Slovenske Konjice (SISLK)"
  },
  {
   value: "Smarje pri Jelsah (SISMA)",
   label: "Smarje pri Jelsah (SISMA)"
  },
  {
   value: "Sostanj (SISTJ)",
   label: "Sostanj (SISTJ)"
  },
  {
   value: "Srpenica (SISRP)",
   label: "Srpenica (SISRP)"
  },
  {
   value: "Stahovica (SIKMK)",
   label: "Stahovica (SIKMK)"
  },
  {
   value: "Stari Trg pri Lozu (SILZD)",
   label: "Stari Trg pri Lozu (SILZD)"
  },
  {
   value: "Straza (SILZR)",
   label: "Straza (SILZR)"
  },
  {
   value: "Tolmin (SITOL)",
   label: "Tolmin (SITOL)"
  },
  {
   value: "Trzic (SITZI)",
   label: "Trzic (SITZI)"
  },
  {
   value: "Trzin (SITRZ)",
   label: "Trzin (SITRZ)"
  },
  {
   value: "Vas (SIVAS)",
   label: "Vas (SIVAS)"
  },
  {
   value: "Velike Brusnice (SIBRE)",
   label: "Velike Brusnice (SIBRE)"
  },
  {
   value: "Vrhnika (SIVRH)",
   label: "Vrhnika (SIVRH)"
  },
  {
   value: "Vuzenica (SIVUZ)",
   label: "Vuzenica (SIVUZ)"
  },
  {
   value: "Zelezniki (SIZEL)",
   label: "Zelezniki (SIZEL)"
  },
  {
   value: "Zgornja Kungota (SIZGO)",
   label: "Zgornja Kungota (SIZGO)"
  },
  {
   value: "Ziri (SILZC)",
   label: "Ziri (SILZC)"
  },
  {
   value: "Zrece (SIZRE)",
   label: "Zrece (SIZRE)"
  },
  {
   value: ".SVALBARD AND JAN MAYEN (SJ)",
   label: ".SVALBARD AND JAN MAYEN (SJ)"
  },
  {
   value: ".SLOVAKIA (SK)",
   label: ".SLOVAKIA (SK)"
  },
  {
   value: "Bánovce Nad Bebravou (SKBAN)",
   label: "Bánovce Nad Bebravou (SKBAN)"
  },
  {
   value: "Bánovce nad Bebravou (SKBNB)",
   label: "Bánovce nad Bebravou (SKBNB)"
  },
  {
   value: "Banska Stiavnica (SKSZN)",
   label: "Banska Stiavnica (SKSZN)"
  },
  {
   value: "Bardejov (SKBDV)",
   label: "Bardejov (SKBDV)"
  },
  {
   value: "Beckov (SKBCK)",
   label: "Beckov (SKBCK)"
  },
  {
   value: "Belusa (SKBEL)",
   label: "Belusa (SKBEL)"
  },
  {
   value: "Bernolákovo (SKBLO)",
   label: "Bernolákovo (SKBLO)"
  },
  {
   value: "Bojnice (SKBOJ)",
   label: "Bojnice (SKBOJ)"
  },
  {
   value: "Boleráz (SKNOL)",
   label: "Boleráz (SKNOL)"
  },
  {
   value: "Bosany (SKBOS)",
   label: "Bosany (SKBOS)"
  },
  {
   value: "Branovo (SKBVO)",
   label: "Branovo (SKBVO)"
  },
  {
   value: "Brezno (SKBZO)",
   label: "Brezno (SKBZO)"
  },
  {
   value: "Budmerice (SKBDM)",
   label: "Budmerice (SKBDM)"
  },
  {
   value: "Buzica (SKSZF)",
   label: "Buzica (SKSZF)"
  },
  {
   value: "Bytca (SKBCA)",
   label: "Bytca (SKBCA)"
  },
  {
   value: "Celadice (SKCEL)",
   label: "Celadice (SKCEL)"
  },
  {
   value: "Chorvátsky Grob (SKCVG)",
   label: "Chorvátsky Grob (SKCVG)"
  },
  {
   value: "Chotín (SKCHO)",
   label: "Chotín (SKCHO)"
  },
  {
   value: "Cífer (SKCFR)",
   label: "Cífer (SKCFR)"
  },
  {
   value: "Detva (SKDTA)",
   label: "Detva (SKDTA)"
  },
  {
   value: "Dobrá (SKDBR)",
   label: "Dobrá (SKDBR)"
  },
  {
   value: "Dojc (SKDOJ)",
   label: "Dojc (SKDOJ)"
  },
  {
   value: "Dolné Vestenice (SKDOV)",
   label: "Dolné Vestenice (SKDOV)"
  },
  {
   value: "Dolny Kubín (SKDOK)",
   label: "Dolny Kubín (SKDOK)"
  },
  {
   value: "Dolný Lieskov (SKDLV)",
   label: "Dolný Lieskov (SKDLV)"
  },
  {
   value: "Dubnica (SKSZH)",
   label: "Dubnica (SKSZH)"
  },
  {
   value: "Dubnica nad Váhom (SKDNV)",
   label: "Dubnica nad Váhom (SKDNV)"
  },
  {
   value: "Dulovce (SKSZI)",
   label: "Dulovce (SKSZI)"
  },
  {
   value: "Dvorniky (SKDVO)",
   label: "Dvorniky (SKDVO)"
  },
  {
   value: "Dvory nad Zitavou (SKDZI)",
   label: "Dvory nad Zitavou (SKDZI)"
  },
  {
   value: "Galanta (SKGLT)",
   label: "Galanta (SKGLT)"
  },
  {
   value: "Gbelany (SKGBY)",
   label: "Gbelany (SKGBY)"
  },
  {
   value: "Gelnica (SKGLA)",
   label: "Gelnica (SKGLA)"
  },
  {
   value: "Gemerska Horka (SKGEM)",
   label: "Gemerska Horka (SKGEM)"
  },
  {
   value: "Handlova (SKHLA)",
   label: "Handlova (SKHLA)"
  },
  {
   value: "Handlová (SKHDL)",
   label: "Handlová (SKHDL)"
  },
  {
   value: "Haniska pri Kosiciach (SKHKS)",
   label: "Haniska pri Kosiciach (SKHKS)"
  },
  {
   value: "Harichovce (SKHAR)",
   label: "Harichovce (SKHAR)"
  },
  {
   value: "Harmanec (SKNEC)",
   label: "Harmanec (SKNEC)"
  },
  {
   value: "Hlohovec (SKHLO)",
   label: "Hlohovec (SKHLO)"
  },
  {
   value: "Hnústa (SKSZK)",
   label: "Hnústa (SKSZK)"
  },
  {
   value: "Hodrusa (SKHRS)",
   label: "Hodrusa (SKHRS)"
  },
  {
   value: "Horné Srnie (SKHSM)",
   label: "Horné Srnie (SKHSM)"
  },
  {
   value: "Horný Hricov (SKSZL)",
   label: "Horný Hricov (SKSZL)"
  },
  {
   value: "Hrinová (SKHNA)",
   label: "Hrinová (SKHNA)"
  },
  {
   value: "Hrnciarovce nad Parnou (SKHRN)",
   label: "Hrnciarovce nad Parnou (SKHRN)"
  },
  {
   value: "Humenné (SKHNE)",
   label: "Humenné (SKHNE)"
  },
  {
   value: "Humenné (SKHUM)",
   label: "Humenné (SKHUM)"
  },
  {
   value: "Hurbanova Ves (SKHBV)",
   label: "Hurbanova Ves (SKHBV)"
  },
  {
   value: "Hurbanovo (SKHBO)",
   label: "Hurbanovo (SKHBO)"
  },
  {
   value: "Ilava (SKILV)",
   label: "Ilava (SKILV)"
  },
  {
   value: "Istebné (SKSZC)",
   label: "Istebné (SKSZC)"
  },
  {
   value: "Ivanka pri Dunaji (SKIVA)",
   label: "Ivanka pri Dunaji (SKIVA)"
  },
  {
   value: "Jablonica (SKSZP)",
   label: "Jablonica (SKSZP)"
  },
  {
   value: "Jablonov nad Turnou (SKJNT)",
   label: "Jablonov nad Turnou (SKJNT)"
  },
  {
   value: "Jablonové (SKJLO)",
   label: "Jablonové (SKJLO)"
  },
  {
   value: "Jahodna (SKSZO)",
   label: "Jahodna (SKSZO)"
  },
  {
   value: "Jasenica (SKJAS)",
   label: "Jasenica (SKJAS)"
  },
  {
   value: "Jelsava (SKJJJ)",
   label: "Jelsava (SKJJJ)"
  },
  {
   value: "Jesenské (SKJSK)",
   label: "Jesenské (SKJSK)"
  },
  {
   value: "Kapusany (SKKSY)",
   label: "Kapusany (SKKSY)"
  },
  {
   value: "Katarinska Huta (SKKHU)",
   label: "Katarinska Huta (SKKHU)"
  },
  {
   value: "Kechnec (SKKHC)",
   label: "Kechnec (SKKHC)"
  },
  {
   value: "Kezmarok (SKKZK)",
   label: "Kezmarok (SKKZK)"
  },
  {
   value: "Kocovce (SKKOC)",
   label: "Kocovce (SKKOC)"
  },
  {
   value: "Kolárovo (SKKAO)",
   label: "Kolárovo (SKKAO)"
  },
  {
   value: "Koromla (SKKRM)",
   label: "Koromla (SKKRM)"
  },
  {
   value: "Kostany nad Turcom (SKKNT)",
   label: "Kostany nad Turcom (SKKNT)"
  },
  {
   value: "Kralovsky Chlmec (SKSZQ)",
   label: "Kralovsky Chlmec (SKSZQ)"
  },
  {
   value: "Kremnica (SKSZR)",
   label: "Kremnica (SKSZR)"
  },
  {
   value: "Kriván (SKKRV)",
   label: "Kriván (SKKRV)"
  },
  {
   value: "Krízovany (SKKRY)",
   label: "Krízovany (SKKRY)"
  },
  {
   value: "Krízovany nad Dudváhom (SKKDV)",
   label: "Krízovany nad Dudváhom (SKKDV)"
  },
  {
   value: "Krompachy (SKKPY)",
   label: "Krompachy (SKKPY)"
  },
  {
   value: "Krupina (SKKRU)",
   label: "Krupina (SKKRU)"
  },
  {
   value: "Kysucké Nové Mesto (SKKNM)",
   label: "Kysucké Nové Mesto (SKKNM)"
  },
  {
   value: "Lednické Rovné (SKLNR)",
   label: "Lednické Rovné (SKLNR)"
  },
  {
   value: "Levice (SKLVE)",
   label: "Levice (SKLVE)"
  },
  {
   value: "Likavka (SKLIA)",
   label: "Likavka (SKLIA)"
  },
  {
   value: "Liptovsky Hradok (SKSZS)",
   label: "Liptovsky Hradok (SKSZS)"
  },
  {
   value: "Lozorno (SKLZO)",
   label: "Lozorno (SKLZO)"
  },
  {
   value: "Lubeník (SKLUB)",
   label: "Lubeník (SKLUB)"
  },
  {
   value: "Lúcky (SKLCY)",
   label: "Lúcky (SKLCY)"
  },
  {
   value: "Luzianky (SKLUZ)",
   label: "Luzianky (SKLUZ)"
  },
  {
   value: "Macov (SKMAO)",
   label: "Macov (SKMAO)"
  },
  {
   value: "Majcichov (SKMJH)",
   label: "Majcichov (SKMJH)"
  },
  {
   value: "Mala Domasa (SKMDM)",
   label: "Mala Domasa (SKMDM)"
  },
  {
   value: "Malacky (SKMAC)",
   label: "Malacky (SKMAC)"
  },
  {
   value: "Male Bielice (SKSZT)",
   label: "Male Bielice (SKSZT)"
  },
  {
   value: "Male Uherce (SKMUH)",
   label: "Male Uherce (SKMUH)"
  },
  {
   value: "Maly Krtis (SKMKS)",
   label: "Maly Krtis (SKMKS)"
  },
  {
   value: "Martovce (SKMAT)",
   label: "Martovce (SKMAT)"
  },
  {
   value: "Michalovce (SKMHC)",
   label: "Michalovce (SKMHC)"
  },
  {
   value: "Miloslavov (SKMLV)",
   label: "Miloslavov (SKMLV)"
  },
  {
   value: "Námestovo (SKNSO)",
   label: "Námestovo (SKNSO)"
  },
  {
   value: "Nesvady (SKSVA)",
   label: "Nesvady (SKSVA)"
  },
  {
   value: "Nitrianske Hrnciarovce (SKSZU)",
   label: "Nitrianske Hrnciarovce (SKSZU)"
  },
  {
   value: "Nitrianske Pravno (SKSZV)",
   label: "Nitrianske Pravno (SKSZV)"
  },
  {
   value: "Nizná (SKNZA)",
   label: "Nizná (SKNZA)"
  },
  {
   value: "Nova Dubnica (SKNDN)",
   label: "Nova Dubnica (SKNDN)"
  },
  {
   value: "Nova Straz (SKSYC)",
   label: "Nova Straz (SKSYC)"
  },
  {
   value: "Nové Mesto nad Váhom (SKNMV)",
   label: "Nové Mesto nad Váhom (SKNMV)"
  },
  {
   value: "Nové Sady (SKNSA)",
   label: "Nové Sady (SKNSA)"
  },
  {
   value: "Orlov (SKOLV)",
   label: "Orlov (SKOLV)"
  },
  {
   value: "Oslany (SKSZW)",
   label: "Oslany (SKSZW)"
  },
  {
   value: "Ostrov (SKOST)",
   label: "Ostrov (SKOST)"
  },
  {
   value: "Partizánske (SKPAR)",
   label: "Partizánske (SKPAR)"
  },
  {
   value: "Pezinok (SKPZK)",
   label: "Pezinok (SKPZK)"
  },
  {
   value: "Plave Vozokany (SKSYB)",
   label: "Plave Vozokany (SKSYB)"
  },
  {
   value: "Plesivec (SKPLE)",
   label: "Plesivec (SKPLE)"
  },
  {
   value: "Podbrezová (SKPOB)",
   label: "Podbrezová (SKPOB)"
  },
  {
   value: "Podhajska (SKPHJ)",
   label: "Podhajska (SKPHJ)"
  },
  {
   value: "Pohronska Polhora (SKPPH)",
   label: "Pohronska Polhora (SKPPH)"
  },
  {
   value: "Pohronsky Ruskov (SKPRV)",
   label: "Pohronsky Ruskov (SKPRV)"
  },
  {
   value: "Poltár (SKPLT)",
   label: "Poltár (SKPLT)"
  },
  {
   value: "Povazany (SKPVZ)",
   label: "Povazany (SKPVZ)"
  },
  {
   value: "Povazská Bystrica (SKPBY)",
   label: "Povazská Bystrica (SKPBY)"
  },
  {
   value: "Pravenec (SKSZX)",
   label: "Pravenec (SKSZX)"
  },
  {
   value: "Presov (SKPOV)",
   label: "Presov (SKPOV)"
  },
  {
   value: "Pribenik (SKSYA)",
   label: "Pribenik (SKSYA)"
  },
  {
   value: "Pribeta (SKPRI)",
   label: "Pribeta (SKPRI)"
  },
  {
   value: "Prievidza (SKPZA)",
   label: "Prievidza (SKPZA)"
  },
  {
   value: "Pruské (SKPRS)",
   label: "Pruské (SKPRS)"
  },
  {
   value: "Radzovce (SKRAD)",
   label: "Radzovce (SKRAD)"
  },
  {
   value: "Rajec (SKRRK)",
   label: "Rajec (SKRRK)"
  },
  {
   value: "Rakova (SKRKA)",
   label: "Rakova (SKRKA)"
  },
  {
   value: "Rimavska Sobota (SKRST)",
   label: "Rimavska Sobota (SKRST)"
  },
  {
   value: "Rimavske Zaluzany (SKRZY)",
   label: "Rimavske Zaluzany (SKRZY)"
  },
  {
   value: "Risnovce (SKRCE)",
   label: "Risnovce (SKRCE)"
  },
  {
   value: "Rovinka (SKRVK)",
   label: "Rovinka (SKRVK)"
  },
  {
   value: "Rovne (SKRVN)",
   label: "Rovne (SKRVN)"
  },
  {
   value: "Roznava (SKROZ)",
   label: "Roznava (SKROZ)"
  },
  {
   value: "Rudná (SKRDN)",
   label: "Rudná (SKRDN)"
  },
  {
   value: "Ruzomberok (SKRZK)",
   label: "Ruzomberok (SKRZK)"
  },
  {
   value: "Sabinov (SKSAB)",
   label: "Sabinov (SKSAB)"
  },
  {
   value: "Sala (SKSAA)",
   label: "Sala (SKSAA)"
  },
  {
   value: "Sala (SKSLA)",
   label: "Sala (SKSLA)"
  },
  {
   value: "Samorin (SKSZG)",
   label: "Samorin (SKSZG)"
  },
  {
   value: "Sankovce (SKSEN)",
   label: "Sankovce (SKSEN)"
  },
  {
   value: "Sarovce (SKSAR)",
   label: "Sarovce (SKSAR)"
  },
  {
   value: "Secovce (SKSVC)",
   label: "Secovce (SKSVC)"
  },
  {
   value: "Selpice (SKSLP)",
   label: "Selpice (SKSLP)"
  },
  {
   value: "Senec (SKSNE)",
   label: "Senec (SKSNE)"
  },
  {
   value: "Senica (SKSNI)",
   label: "Senica (SKSNI)"
  },
  {
   value: "Senica, Okres (SKSNC)",
   label: "Senica, Okres (SKSNC)"
  },
  {
   value: "Senkvice (SKSKV)",
   label: "Senkvice (SKSKV)"
  },
  {
   value: "Sered (SKSER)",
   label: "Sered (SKSER)"
  },
  {
   value: "Sládkovicovo (SKSLV)",
   label: "Sládkovicovo (SKSLV)"
  },
  {
   value: "Slavec (SKVEC)",
   label: "Slavec (SKVEC)"
  },
  {
   value: "Slovenská Lupca (SKSLO)",
   label: "Slovenská Lupca (SKSLO)"
  },
  {
   value: "Smizany (SKSZY)",
   label: "Smizany (SKSZY)"
  },
  {
   value: "Smolenice (SKSML)",
   label: "Smolenice (SKSML)"
  },
  {
   value: "Snina (SKSNA)",
   label: "Snina (SKSNA)"
  },
  {
   value: "Sobrance (SKSOB)",
   label: "Sobrance (SKSOB)"
  },
  {
   value: "Sokolovce (SKSKC)",
   label: "Sokolovce (SKSKC)"
  },
  {
   value: "Soporna (SKSOP)",
   label: "Soporna (SKSOP)"
  },
  {
   value: "Spisske Podhradie (SKSPR)",
   label: "Spisske Podhradie (SKSPR)"
  },
  {
   value: "Stará Lubovna (SKSLB)",
   label: "Stará Lubovna (SKSLB)"
  },
  {
   value: "Stará Turá (SKSTA)",
   label: "Stará Turá (SKSTA)"
  },
  {
   value: "Strázske (SKZSK)",
   label: "Strázske (SKZSK)"
  },
  {
   value: "Strba (SKSTR)",
   label: "Strba (SKSTR)"
  },
  {
   value: "Stupava (SKSPA)",
   label: "Stupava (SKSPA)"
  },
  {
   value: "Sucany (SKSCY)",
   label: "Sucany (SKSCY)"
  },
  {
   value: "Sumiac (SKSUC)",
   label: "Sumiac (SKSUC)"
  },
  {
   value: "Surany (SKSUR)",
   label: "Surany (SKSUR)"
  },
  {
   value: "Svidník (SKSVK)",
   label: "Svidník (SKSVK)"
  },
  {
   value: "Svinna (SKSVI)",
   label: "Svinna (SKSVI)"
  },
  {
   value: "Svodin (SKSZM)",
   label: "Svodin (SKSZM)"
  },
  {
   value: "Teplicka nad Vahom (SKTEP)",
   label: "Teplicka nad Vahom (SKTEP)"
  },
  {
   value: "Tisovec (SKTIS)",
   label: "Tisovec (SKTIS)"
  },
  {
   value: "Tlmace (SKTLM)",
   label: "Tlmace (SKTLM)"
  },
  {
   value: "Tomásov (SKTOM)",
   label: "Tomásov (SKTOM)"
  },
  {
   value: "Ton (SKTON)",
   label: "Ton (SKTON)"
  },
  {
   value: "Topolcianky (SKSZD)",
   label: "Topolcianky (SKSZD)"
  },
  {
   value: "Trebatice (SKTBC)",
   label: "Trebatice (SKTBC)"
  },
  {
   value: "Trebiaov (SKTRB)",
   label: "Trebiaov (SKTRB)"
  },
  {
   value: "Trencianske Bohuslavice (SKTBE)",
   label: "Trencianske Bohuslavice (SKTBE)"
  },
  {
   value: "Trencianske Teplice (SKTST)",
   label: "Trencianske Teplice (SKTST)"
  },
  {
   value: "Trencín (SKTRE)",
   label: "Trencín (SKTRE)"
  },
  {
   value: "Trhoviste (SKTRH)",
   label: "Trhoviste (SKTRH)"
  },
  {
   value: "Trnava (SKTNA)",
   label: "Trnava (SKTNA)"
  },
  {
   value: "Trstín (SKTRS)",
   label: "Trstín (SKTRS)"
  },
  {
   value: "Tupa (SKSZB)",
   label: "Tupa (SKSZB)"
  },
  {
   value: "Turany (SKTNY)",
   label: "Turany (SKTNY)"
  },
  {
   value: "Turna Nad Bodvou (SKTNB)",
   label: "Turna Nad Bodvou (SKTNB)"
  },
  {
   value: "Varín (SKVRN)",
   label: "Varín (SKVRN)"
  },
  {
   value: "Velicná (SKVLA)",
   label: "Velicná (SKVLA)"
  },
  {
   value: "Velká Lomnica (SKVLN)",
   label: "Velká Lomnica (SKVLN)"
  },
  {
   value: "Velká Paka (SKVEP)",
   label: "Velká Paka (SKVEP)"
  },
  {
   value: "Velké Kapusany (SKVKP)",
   label: "Velké Kapusany (SKVKP)"
  },
  {
   value: "Velké Leváre (SKVKL)",
   label: "Velké Leváre (SKVKL)"
  },
  {
   value: "Velké Slemence (SKVSC)",
   label: "Velké Slemence (SKVSC)"
  },
  {
   value: "Velký Krtís (SKVKS)",
   label: "Velký Krtís (SKVKS)"
  },
  {
   value: "Velky Meder (SKVMD)",
   label: "Velky Meder (SKVMD)"
  },
  {
   value: "Vinosady (SKVIN)",
   label: "Vinosady (SKVIN)"
  },
  {
   value: "Vlckovce (SKVVC)",
   label: "Vlckovce (SKVVC)"
  },
  {
   value: "Vlkanová (SKVNA)",
   label: "Vlkanová (SKVNA)"
  },
  {
   value: "Voderady (SKVRD)",
   label: "Voderady (SKVRD)"
  },
  {
   value: "Vrakun (SKVKN)",
   label: "Vrakun (SKVKN)"
  },
  {
   value: "Vranov nad Toplou (SKVRA)",
   label: "Vranov nad Toplou (SKVRA)"
  },
  {
   value: "Vrbové (SKVBO)",
   label: "Vrbové (SKVBO)"
  },
  {
   value: "Vydrany (SKVDY)",
   label: "Vydrany (SKVDY)"
  },
  {
   value: "Vysná Jablonka (SKVJB)",
   label: "Vysná Jablonka (SKVJB)"
  },
  {
   value: "Vysoká pri Morave (SKVPM)",
   label: "Vysoká pri Morave (SKVPM)"
  },
  {
   value: "Zarnovica (SKZAR)",
   label: "Zarnovica (SKZAR)"
  },
  {
   value: "Zavazna Poruba (SKSZA)",
   label: "Zavazna Poruba (SKSZA)"
  },
  {
   value: "Zeliezovce (SKZEL)",
   label: "Zeliezovce (SKZEL)"
  },
  {
   value: "Ziar nad Hronom (SKZIA)",
   label: "Ziar nad Hronom (SKZIA)"
  },
  {
   value: "Zlaté Moravce (SKZLM)",
   label: "Zlaté Moravce (SKZLM)"
  },
  {
   value: "Zohor (SKZHR)",
   label: "Zohor (SKZHR)"
  },
  {
   value: "Zuberec (SKZRC)",
   label: "Zuberec (SKZRC)"
  },
  {
   value: "Zvolen (SKZVN)",
   label: "Zvolen (SKZVN)"
  },
  {
   value: "Zvolenská Slatina (SKZSL)",
   label: "Zvolenská Slatina (SKZSL)"
  },
  {
   value: ".SIERRA LEONE (SL)",
   label: ".SIERRA LEONE (SL)"
  },
  {
   value: "Daru (SLDSL)",
   label: "Daru (SLDSL)"
  },
  {
   value: "Kabala (SLKBA)",
   label: "Kabala (SLKBA)"
  },
  {
   value: "Sierra Leone Apt (SLSRK)",
   label: "Sierra Leone Apt (SLSRK)"
  },
  {
   value: "Yengema Apt (SLWYE)",
   label: "Yengema Apt (SLWYE)"
  },
  {
   value: ".SAN MARINO (SM)",
   label: ".SAN MARINO (SM)"
  },
  {
   value: "Acquaviva (SMZAC)",
   label: "Acquaviva (SMZAC)"
  },
  {
   value: "Falciano (SMFCO)",
   label: "Falciano (SMFCO)"
  },
  {
   value: "Galazzano (SMGAL)",
   label: "Galazzano (SMGAL)"
  },
  {
   value: ".SENEGAL (SN)",
   label: ".SENEGAL (SN)"
  },
  {
   value: "Dagana (SNDAG)",
   label: "Dagana (SNDAG)"
  },
  {
   value: "Kahone (SNKAH)",
   label: "Kahone (SNKAH)"
  },
  {
   value: "Kolda (SNKDA)",
   label: "Kolda (SNKDA)"
  },
  {
   value: "Louga (SNLOU)",
   label: "Louga (SNLOU)"
  },
  {
   value: "Mbour (SNMBO)",
   label: "Mbour (SNMBO)"
  },
  {
   value: "Niokolo Koba (SNNIK)",
   label: "Niokolo Koba (SNNIK)"
  },
  {
   value: "Podor (SNPOD)",
   label: "Podor (SNPOD)"
  },
  {
   value: "Thiès (SNTHI)",
   label: "Thiès (SNTHI)"
  },
  {
   value: "Touba (SNTOU)",
   label: "Touba (SNTOU)"
  },
  {
   value: ".SOMALIA (SO)",
   label: ".SOMALIA (SO)"
  },
  {
   value: "Baidoa (SOBIB)",
   label: "Baidoa (SOBIB)"
  },
  {
   value: "Bardera (SOBSY)",
   label: "Bardera (SOBSY)"
  },
  {
   value: "Borama (SOBXX)",
   label: "Borama (SOBXX)"
  },
  {
   value: "Candala (SOCXN)",
   label: "Candala (SOCXN)"
  },
  {
   value: "Eil (SOHCM)",
   label: "Eil (SOHCM)"
  },
  {
   value: "El Maan (SOELM)",
   label: "El Maan (SOELM)"
  },
  {
   value: "Erigavo (SOERA)",
   label: "Erigavo (SOERA)"
  },
  {
   value: "Galcaio (SOGLK)",
   label: "Galcaio (SOGLK)"
  },
  {
   value: "Garbaharey (SOGBM)",
   label: "Garbaharey (SOGBM)"
  },
  {
   value: "Garoe (SOGGR)",
   label: "Garoe (SOGGR)"
  },
  {
   value: "Giohar (SOGHR)",
   label: "Giohar (SOGHR)"
  },
  {
   value: "Las Khoreh (SOLKR)",
   label: "Las Khoreh (SOLKR)"
  },
  {
   value: "Lugh Ganane (SOLGX)",
   label: "Lugh Ganane (SOLGX)"
  },
  {
   value: "Obbia (SOCMO)",
   label: "Obbia (SOCMO)"
  },
  {
   value: "Scusciuban (SOCMS)",
   label: "Scusciuban (SOCMS)"
  },
  {
   value: ".SURINAME (SR)",
   label: ".SURINAME (SR)"
  },
  {
   value: "Awaradam (SRAAJ)",
   label: "Awaradam (SRAAJ)"
  },
  {
   value: "Botopasie (SRBTO)",
   label: "Botopasie (SRBTO)"
  },
  {
   value: "Djoemoe (SRDOE)",
   label: "Djoemoe (SRDOE)"
  },
  {
   value: "Drietabbetje (SRDRJ)",
   label: "Drietabbetje (SRDRJ)"
  },
  {
   value: "Kasikasima (SRKCB)",
   label: "Kasikasima (SRKCB)"
  },
  {
   value: "Ladouanie (SRLDO)",
   label: "Ladouanie (SRLDO)"
  },
  {
   value: "Paloemeu (SROEM)",
   label: "Paloemeu (SROEM)"
  },
  {
   value: "Totness (SRTOT)",
   label: "Totness (SRTOT)"
  },
  {
   value: "Washabo (SRWSO)",
   label: "Washabo (SRWSO)"
  },
  {
   value: "Zanderij (SRZDJ)",
   label: "Zanderij (SRZDJ)"
  },
  {
   value: ".SAO TOME AND PRINCIPE (ST)",
   label: ".SAO TOME AND PRINCIPE (ST)"
  },
  {
   value: "Porto Alegre (STPGP)",
   label: "Porto Alegre (STPGP)"
  },
  {
   value: ".EL SALVADOR (SV)",
   label: ".EL SALVADOR (SV)"
  },
  {
   value: "Aguilares (SVEZA)",
   label: "Aguilares (SVEZA)"
  },
  {
   value: "Ahuachapán (SVACN)",
   label: "Ahuachapán (SVACN)"
  },
  {
   value: "Antiguo Cuscatlán (SVCUS)",
   label: "Antiguo Cuscatlán (SVCUS)"
  },
  {
   value: "Berlin (SVBER)",
   label: "Berlin (SVBER)"
  },
  {
   value: "Cara Sucia (SVCSC)",
   label: "Cara Sucia (SVCSC)"
  },
  {
   value: "Chalatenango (SVCNG)",
   label: "Chalatenango (SVCNG)"
  },
  {
   value: "Chalchuapa (SVCHA)",
   label: "Chalchuapa (SVCHA)"
  },
  {
   value: "Ciudad Barrios (SVCIB)",
   label: "Ciudad Barrios (SVCIB)"
  },
  {
   value: "Comalapa (SVCPL)",
   label: "Comalapa (SVCPL)"
  },
  {
   value: "Cutuco (SVEZB)",
   label: "Cutuco (SVEZB)"
  },
  {
   value: "El Pedregal (SVEPL)",
   label: "El Pedregal (SVEPL)"
  },
  {
   value: "El Poy (SVEPY)",
   label: "El Poy (SVEPY)"
  },
  {
   value: "El Rosario (SVROS)",
   label: "El Rosario (SVROS)"
  },
  {
   value: "Ilopango (SVEZC)",
   label: "Ilopango (SVEZC)"
  },
  {
   value: "La Paz (SVLAP)",
   label: "La Paz (SVLAP)"
  },
  {
   value: "Lourdes (SVEZD)",
   label: "Lourdes (SVEZD)"
  },
  {
   value: "Miramar (SVMIR)",
   label: "Miramar (SVMIR)"
  },
  {
   value: "Moncagua (SVTUE)",
   label: "Moncagua (SVTUE)"
  },
  {
   value: "Nahuizalco (SVNHZ)",
   label: "Nahuizalco (SVNHZ)"
  },
  {
   value: "Nejapa (SVNEJ)",
   label: "Nejapa (SVNEJ)"
  },
  {
   value: "Olocuilta (SVOLO)",
   label: "Olocuilta (SVOLO)"
  },
  {
   value: "Paso de la Ceiba (SVPDC)",
   label: "Paso de la Ceiba (SVPDC)"
  },
  {
   value: "Sacacoyo (SVSAC)",
   label: "Sacacoyo (SVSAC)"
  },
  {
   value: "San Bartolo (SVSBT)",
   label: "San Bartolo (SVSBT)"
  },
  {
   value: "San Francisco Gotera (SVSFG)",
   label: "San Francisco Gotera (SVSFG)"
  },
  {
   value: "San Juan Opico (SVSJO)",
   label: "San Juan Opico (SVSJO)"
  },
  {
   value: "San Miguel (SVSMG)",
   label: "San Miguel (SVSMG)"
  },
  {
   value: "San Pablo Tacachico (SVSPT)",
   label: "San Pablo Tacachico (SVSPT)"
  },
  {
   value: "San Vicente (SVSVE)",
   label: "San Vicente (SVSVE)"
  },
  {
   value: "Santa Tecla (SVEZE)",
   label: "Santa Tecla (SVEZE)"
  },
  {
   value: "Santiago de María (SVSDM)",
   label: "Santiago de María (SVSDM)"
  },
  {
   value: "Santo Tomás (SVSTO)",
   label: "Santo Tomás (SVSTO)"
  },
  {
   value: "Sitio del Nino (SVSIT)",
   label: "Sitio del Nino (SVSIT)"
  },
  {
   value: "Sonsonate (SVSST)",
   label: "Sonsonate (SVSST)"
  },
  {
   value: "Soyapango (SVSOY)",
   label: "Soyapango (SVSOY)"
  },
  {
   value: "Usulután (SVUSU)",
   label: "Usulután (SVUSU)"
  },
  {
   value: "Zacatecoluca (SVZAC)",
   label: "Zacatecoluca (SVZAC)"
  },
  {
   value: ".SYRIAN ARAB REPUBLIC (SY)",
   label: ".SYRIAN ARAB REPUBLIC (SY)"
  },
  {
   value: "Al Ladhiqiyah (SYALD)",
   label: "Al Ladhiqiyah (SYALD)"
  },
  {
   value: "Al Thaurah (SYSOR)",
   label: "Al Thaurah (SYSOR)"
  },
  {
   value: "Arwad (SYARW)",
   label: "Arwad (SYARW)"
  },
  {
   value: "Banghazi (SYBEN)",
   label: "Banghazi (SYBEN)"
  },
  {
   value: "Homs (SYHMS)",
   label: "Homs (SYHMS)"
  },
  {
   value: "Palmyra (SYPMS)",
   label: "Palmyra (SYPMS)"
  },
  {
   value: "Rouâd (SYRAD)",
   label: "Rouâd (SYRAD)"
  },
  {
   value: "Sweida (SYQSW)",
   label: "Sweida (SYQSW)"
  },
  {
   value: ".SWAZILAND (SZ)",
   label: ".SWAZILAND (SZ)"
  },
  {
   value: "Ezulwini (SZEZU)",
   label: "Ezulwini (SZEZU)"
  },
  {
   value: "Malkerns (SZMAL)",
   label: "Malkerns (SZMAL)"
  },
  {
   value: "Mhlume (SZMHU)",
   label: "Mhlume (SZMHU)"
  },
  {
   value: "Nhlangano (SZNHL)",
   label: "Nhlangano (SZNHL)"
  },
  {
   value: ".TURKS AND CAICOS ISLANDS (TC)",
   label: ".TURKS AND CAICOS ISLANDS (TC)"
  },
  {
   value: ".CHAD (TD)",
   label: ".CHAD (TD)"
  },
  {
   value: "Abou-Deïa (TDAOD)",
   label: "Abou-Deïa (TDAOD)"
  },
  {
   value: "Am Timan (TDAMC)",
   label: "Am Timan (TDAMC)"
  },
  {
   value: "Banda (TDBND)",
   label: "Banda (TDBND)"
  },
  {
   value: "Bokoro (TDBKR)",
   label: "Bokoro (TDBKR)"
  },
  {
   value: "Bousso (TDOUT)",
   label: "Bousso (TDOUT)"
  },
  {
   value: "Doba (TDDOB)",
   label: "Doba (TDDOB)"
  },
  {
   value: "Faya (TDFYT)",
   label: "Faya (TDFYT)"
  },
  {
   value: "Gaya (TDGAY)",
   label: "Gaya (TDGAY)"
  },
  {
   value: "Kélo (TDKEL)",
   label: "Kélo (TDKEL)"
  },
  {
   value: "Komé (TDKME)",
   label: "Komé (TDKME)"
  },
  {
   value: "Koumara (TDKOU)",
   label: "Koumara (TDKOU)"
  },
  {
   value: "Koumra (TDKMR)",
   label: "Koumra (TDKMR)"
  },
  {
   value: "Lai (TDLTC)",
   label: "Lai (TDLTC)"
  },
  {
   value: "Léré (TDLER)",
   label: "Léré (TDLER)"
  },
  {
   value: "Mao (TDAMO)",
   label: "Mao (TDAMO)"
  },
  {
   value: "Moussoro (TDMOU)",
   label: "Moussoro (TDMOU)"
  },
  {
   value: "Oum Hadjer (TDOUM)",
   label: "Oum Hadjer (TDOUM)"
  },
  {
   value: "Pala (TDPLF)",
   label: "Pala (TDPLF)"
  },
  {
   value: "Zakouma (TDAKM)",
   label: "Zakouma (TDAKM)"
  },
  {
   value: ".TOGO (TG)",
   label: ".TOGO (TG)"
  },
  {
   value: "Dapaong (TGDPG)",
   label: "Dapaong (TGDPG)"
  },
  {
   value: "Kanté (TGKAN)",
   label: "Kanté (TGKAN)"
  },
  {
   value: "Konpiéna (TGKON)",
   label: "Konpiéna (TGKON)"
  },
  {
   value: "Niamtougou Lama-Kara (TGLRL)",
   label: "Niamtougou Lama-Kara (TGLRL)"
  },
  {
   value: ".THAILAND (TH)",
   label: ".THAILAND (TH)"
  },
  {
   value: "Ang Thong (THATH)",
   label: "Ang Thong (THATH)"
  },
  {
   value: "Ayutthaya (THAYU)",
   label: "Ayutthaya (THAYU)"
  },
  {
   value: "Ban Mak Khaen (THBAO)",
   label: "Ban Mak Khaen (THBAO)"
  },
  {
   value: "Ban Map Ta Phut (THMTP)",
   label: "Ban Map Ta Phut (THMTP)"
  },
  {
   value: "Ban Pong (THBPG)",
   label: "Ban Pong (THBPG)"
  },
  {
   value: "Bang Rak (THBRK)",
   label: "Bang Rak (THBRK)"
  },
  {
   value: "Bang Saphan (THBSP)",
   label: "Bang Saphan (THBSP)"
  },
  {
   value: "Bangkok Modern Terminals\/Bangkok (THBMT)",
   label: "Bangkok Modern Terminals\/Bangkok (THBMT)"
  },
  {
   value: "Bangpoomai (THBAI)",
   label: "Bangpoomai (THBAI)"
  },
  {
   value: "Bangsu (THBSE)",
   label: "Bangsu (THBSE)"
  },
  {
   value: "Buri Ram (THBFV)",
   label: "Buri Ram (THBFV)"
  },
  {
   value: "Chai Nat (THCHN)",
   label: "Chai Nat (THCHN)"
  },
  {
   value: "Chaiyaphum (THCYM)",
   label: "Chaiyaphum (THCYM)"
  },
  {
   value: "Hoping (THHOP)",
   label: "Hoping (THHOP)"
  },
  {
   value: "Hua Hin (THHHQ)",
   label: "Hua Hin (THHHQ)"
  },
  {
   value: "Kalasin (THKLN)",
   label: "Kalasin (THKLN)"
  },
  {
   value: "Kamphaeng Phet (THKPT)",
   label: "Kamphaeng Phet (THKPT)"
  },
  {
   value: "Kamphaeng Saen (THKPS)",
   label: "Kamphaeng Saen (THKPS)"
  },
  {
   value: "Kamuting (THKAM)",
   label: "Kamuting (THKAM)"
  },
  {
   value: "Kanchanaburi (THKCB)",
   label: "Kanchanaburi (THKCB)"
  },
  {
   value: "Khlong Toei (THKTY)",
   label: "Khlong Toei (THKTY)"
  },
  {
   value: "Khon Kaen (THKKN)",
   label: "Khon Kaen (THKKN)"
  },
  {
   value: "Krathum Baen (THKRN)",
   label: "Krathum Baen (THKRN)"
  },
  {
   value: "Lamphun (THLPN)",
   label: "Lamphun (THLPN)"
  },
  {
   value: "Lop Buri (THKKM)",
   label: "Lop Buri (THKKM)"
  },
  {
   value: "Mae Sot (THMAQ)",
   label: "Mae Sot (THMAQ)"
  },
  {
   value: "Maha Sarakham (THMSM)",
   label: "Maha Sarakham (THMSM)"
  },
  {
   value: "Min Buri (THMIN)",
   label: "Min Buri (THMIN)"
  },
  {
   value: "Mukdahan (THMDN)",
   label: "Mukdahan (THMDN)"
  },
  {
   value: "Nakhon Nayok (THNNK)",
   label: "Nakhon Nayok (THNNK)"
  },
  {
   value: "Nakhon Pathom (THNPM)",
   label: "Nakhon Pathom (THNPM)"
  },
  {
   value: "Nakhon Ratchasima (THNAK)",
   label: "Nakhon Ratchasima (THNAK)"
  },
  {
   value: "Nakhon Sawan (THNSA)",
   label: "Nakhon Sawan (THNSA)"
  },
  {
   value: "Nim Port (THNIM)",
   label: "Nim Port (THNIM)"
  },
  {
   value: "Nong Khaem (THNON)",
   label: "Nong Khaem (THNON)"
  },
  {
   value: "Nong Ya Plong (THNYP)",
   label: "Nong Ya Plong (THNYP)"
  },
  {
   value: "Nonthaburi (THNTB)",
   label: "Nonthaburi (THNTB)"
  },
  {
   value: "Pai (THPAI)",
   label: "Pai (THPAI)"
  },
  {
   value: "Pak Chong (THPCH)",
   label: "Pak Chong (THPCH)"
  },
  {
   value: "Pak Kret (THPKR)",
   label: "Pak Kret (THPKR)"
  },
  {
   value: "Pat Bangkok (THPAT)",
   label: "Pat Bangkok (THPAT)"
  },
  {
   value: "Pathum Thani (THPTH)",
   label: "Pathum Thani (THPTH)"
  },
  {
   value: "Patong Beach (THPBS)",
   label: "Patong Beach (THPBS)"
  },
  {
   value: "Petchaburi (THPCT)",
   label: "Petchaburi (THPCT)"
  },
  {
   value: "Phan Thong (THPHT)",
   label: "Phan Thong (THPHT)"
  },
  {
   value: "Phanom Sarakham (THPMM)",
   label: "Phanom Sarakham (THPMM)"
  },
  {
   value: "Phatthalung (THPTG)",
   label: "Phatthalung (THPTG)"
  },
  {
   value: "Phayao (THPYO)",
   label: "Phayao (THPYO)"
  },
  {
   value: "Phet Buri (THPHE)",
   label: "Phet Buri (THPHE)"
  },
  {
   value: "Phetchabun (THPCN)",
   label: "Phetchabun (THPCN)"
  },
  {
   value: "Phi Phi Island (THPHZ)",
   label: "Phi Phi Island (THPHZ)"
  },
  {
   value: "Phibun Mangsahan (THPBM)",
   label: "Phibun Mangsahan (THPBM)"
  },
  {
   value: "Phichit (THPHI)",
   label: "Phichit (THPHI)"
  },
  {
   value: "Photharam (THPTR)",
   label: "Photharam (THPTR)"
  },
  {
   value: "Phra Pradaeng (THPRG)",
   label: "Phra Pradaeng (THPRG)"
  },
  {
   value: "Pluak Daeng (THPDG)",
   label: "Pluak Daeng (THPDG)"
  },
  {
   value: "Prachin Buri (THPNB)",
   label: "Prachin Buri (THPNB)"
  },
  {
   value: "Prachuap Khiri Khan (THPKK)",
   label: "Prachuap Khiri Khan (THPKK)"
  },
  {
   value: "Ratchaburi (THRAT)",
   label: "Ratchaburi (THRAT)"
  },
  {
   value: "Rayong (THRYG)",
   label: "Rayong (THRYG)"
  },
  {
   value: "Roi Et (THROI)",
   label: "Roi Et (THROI)"
  },
  {
   value: "Sai Buri (THSUP)",
   label: "Sai Buri (THSUP)"
  },
  {
   value: "Sakon Nakhon (THSNO)",
   label: "Sakon Nakhon (THSNO)"
  },
  {
   value: "Sam Phran (THSAN)",
   label: "Sam Phran (THSAN)"
  },
  {
   value: "Samphanthawong (THSAM)",
   label: "Samphanthawong (THSAM)"
  },
  {
   value: "Samulsakom (THSAS)",
   label: "Samulsakom (THSAS)"
  },
  {
   value: "Samut Sakhon, Changwat (THSAU)",
   label: "Samut Sakhon, Changwat (THSAU)"
  },
  {
   value: "Samut Songkhram (THSSM)",
   label: "Samut Songkhram (THSSM)"
  },
  {
   value: "Sara Buri (THSBI)",
   label: "Sara Buri (THSBI)"
  },
  {
   value: "Sathun (THSTH)",
   label: "Sathun (THSTH)"
  },
  {
   value: "Satun (THSNT)",
   label: "Satun (THSNT)"
  },
  {
   value: "Si Racha (THSIR)",
   label: "Si Racha (THSIR)"
  },
  {
   value: "Siam Bangkok Port (THSBP)",
   label: "Siam Bangkok Port (THSBP)"
  },
  {
   value: "Siam Container Terminal (THSCT)",
   label: "Siam Container Terminal (THSCT)"
  },
  {
   value: "Sing Buri (THSIB)",
   label: "Sing Buri (THSIB)"
  },
  {
   value: "Sisaket (THSSK)",
   label: "Sisaket (THSSK)"
  },
  {
   value: "Sukhothai (THTHS)",
   label: "Sukhothai (THTHS)"
  },
  {
   value: "Suphan Buri (THSUB)",
   label: "Suphan Buri (THSUB)"
  },
  {
   value: "Surat Thani (THURT)",
   label: "Surat Thani (THURT)"
  },
  {
   value: "Surin (THSNR)",
   label: "Surin (THSNR)"
  },
  {
   value: "Suvarnabhumi International Apt (THSIA)",
   label: "Suvarnabhumi International Apt (THSIA)"
  },
  {
   value: "Tak (THTKT)",
   label: "Tak (THTKT)"
  },
  {
   value: "Takhli (THTKH)",
   label: "Takhli (THTKH)"
  },
  {
   value: "Trat (THTRT)",
   label: "Trat (THTRT)"
  },
  {
   value: "Tungprong Pt (THTPP)",
   label: "Tungprong Pt (THTPP)"
  },
  {
   value: "Utapao (THUTP)",
   label: "Utapao (THUTP)"
  },
  {
   value: "Uttaradit (THUTR)",
   label: "Uttaradit (THUTR)"
  },
  {
   value: "Yasothon (THYNT)",
   label: "Yasothon (THYNT)"
  },
  {
   value: ".TAJIKISTAN (TJ)",
   label: ".TAJIKISTAN (TJ)"
  },
  {
   value: "Khudzhand (TJLBD)",
   label: "Khudzhand (TJLBD)"
  },
  {
   value: "Kulob (TJKLB)",
   label: "Kulob (TJKLB)"
  },
  {
   value: "Penjikent (TJPJK)",
   label: "Penjikent (TJPJK)"
  },
  {
   value: "Qurghonteppa (TJKUR)",
   label: "Qurghonteppa (TJKUR)"
  },
  {
   value: "Shaartuz (TJSTZ)",
   label: "Shaartuz (TJSTZ)"
  },
  {
   value: ".TOKELAU (TK)",
   label: ".TOKELAU (TK)"
  },
  {
   value: "Atafu (TKAFU)",
   label: "Atafu (TKAFU)"
  },
  {
   value: "Fakaofo (TKFKO)",
   label: "Fakaofo (TKFKO)"
  },
  {
   value: "Nukunonu (TKNKU)",
   label: "Nukunonu (TKNKU)"
  },
  {
   value: ".TIMOR-LESTE (TL)",
   label: ".TIMOR-LESTE (TL)"
  },
  {
   value: "Dili (TLDIL)",
   label: "Dili (TLDIL)"
  },
  {
   value: "Suai (TLSUA)",
   label: "Suai (TLSUA)"
  },
  {
   value: ".TURKMENISTAN (TM)",
   label: ".TURKMENISTAN (TM)"
  },
  {
   value: "Akdepe (TMAKD)",
   label: "Akdepe (TMAKD)"
  },
  {
   value: "Babadaýhan (TMBAB)",
   label: "Babadaýhan (TMBAB)"
  },
  {
   value: "Bäherden (TMBAH)",
   label: "Bäherden (TMBAH)"
  },
  {
   value: "Balkanabat (TMBAL)",
   label: "Balkanabat (TMBAL)"
  },
  {
   value: "Bayramaly (TMBAY)",
   label: "Bayramaly (TMBAY)"
  },
  {
   value: "Bekdash (TMBKH)",
   label: "Bekdash (TMBKH)"
  },
  {
   value: "Boldumsaz (TMBOL)",
   label: "Boldumsaz (TMBOL)"
  },
  {
   value: "Büzmeyin (TMBZY)",
   label: "Büzmeyin (TMBZY)"
  },
  {
   value: "Chärjew (TMCJV)",
   label: "Chärjew (TMCJV)"
  },
  {
   value: "Cheleken (TMCHE)",
   label: "Cheleken (TMCHE)"
  },
  {
   value: "Dashhowuz (TMDHZ)",
   label: "Dashhowuz (TMDHZ)"
  },
  {
   value: "Farap (TMFAR)",
   label: "Farap (TMFAR)"
  },
  {
   value: "Galkynys (TMGAL)",
   label: "Galkynys (TMGAL)"
  },
  {
   value: "Gubadag (TMGUB)",
   label: "Gubadag (TMGUB)"
  },
  {
   value: "Halach (TMHAL)",
   label: "Halach (TMHAL)"
  },
  {
   value: "Kaka (TMKAK)",
   label: "Kaka (TMKAK)"
  },
  {
   value: "Kerkichi (TMKER)",
   label: "Kerkichi (TMKER)"
  },
  {
   value: "Khodzhambas (TMKHS)",
   label: "Khodzhambas (TMKHS)"
  },
  {
   value: "Köneürgench (TMKON)",
   label: "Köneürgench (TMKON)"
  },
  {
   value: "Krasnovodsk (TMKRA)",
   label: "Krasnovodsk (TMKRA)"
  },
  {
   value: "Lebap (TMLEB)",
   label: "Lebap (TMLEB)"
  },
  {
   value: "Mary (TMMYP)",
   label: "Mary (TMMYP)"
  },
  {
   value: "Murgap (TMMUR)",
   label: "Murgap (TMMUR)"
  },
  {
   value: "Säkar (TMSAK)",
   label: "Säkar (TMSAK)"
  },
  {
   value: "Sayat (TMSAY)",
   label: "Sayat (TMSAY)"
  },
  {
   value: "Shirvan-Kala (TMSHI)",
   label: "Shirvan-Kala (TMSHI)"
  },
  {
   value: "Tagta (TMTAG)",
   label: "Tagta (TMTAG)"
  },
  {
   value: "Tashauz (TMTAZ)",
   label: "Tashauz (TMTAZ)"
  },
  {
   value: "Tejen (TMTEJ)",
   label: "Tejen (TMTEJ)"
  },
  {
   value: "Turkmen-Kala (TMTUR)",
   label: "Turkmen-Kala (TMTUR)"
  },
  {
   value: "Yolöten (TMYOL)",
   label: "Yolöten (TMYOL)"
  },
  {
   value: "Yylanly (TMYLA)",
   label: "Yylanly (TMYLA)"
  },
  {
   value: ".TUNISIA (TN)",
   label: ".TUNISIA (TN)"
  },
  {
   value: "Al Hammamat (TNHMM)",
   label: "Al Hammamat (TNHMM)"
  },
  {
   value: "Al Marsá (TNTZE)",
   label: "Al Marsá (TNTZE)"
  },
  {
   value: "Al Qasrayn (TNAQY)",
   label: "Al Qasrayn (TNAQY)"
  },
  {
   value: "Al Qayrawan (TNAQR)",
   label: "Al Qayrawan (TNAQR)"
  },
  {
   value: "Ariana (TNARI)",
   label: "Ariana (TNARI)"
  },
  {
   value: "Bin Arous (TNBNA)",
   label: "Bin Arous (TNBNA)"
  },
  {
   value: "Borj el Bey (TNBEB)",
   label: "Borj el Bey (TNBEB)"
  },
  {
   value: "Boumhel (TNBOU)",
   label: "Boumhel (TNBOU)"
  },
  {
   value: "Bu Mirdas (TNTZB)",
   label: "Bu Mirdas (TNTZB)"
  },
  {
   value: "Chebba (TNCHB)",
   label: "Chebba (TNCHB)"
  },
  {
   value: "Dar Chabanne (TNDAR)",
   label: "Dar Chabanne (TNDAR)"
  },
  {
   value: "El Borma (TNEBM)",
   label: "El Borma (TNEBM)"
  },
  {
   value: "El Jem (TNTZC)",
   label: "El Jem (TNTZC)"
  },
  {
   value: "Enfida (TNEFA)",
   label: "Enfida (TNEFA)"
  },
  {
   value: "Gafsa (TNGAF)",
   label: "Gafsa (TNGAF)"
  },
  {
   value: "Grombalia (TNGML)",
   label: "Grombalia (TNGML)"
  },
  {
   value: "Jammal (TNJEM)",
   label: "Jammal (TNJEM)"
  },
  {
   value: "Jarjis (TNJAR)",
   label: "Jarjis (TNJAR)"
  },
  {
   value: "Jundubah (TNJUL)",
   label: "Jundubah (TNJUL)"
  },
  {
   value: "Kairouan (TNQKN)",
   label: "Kairouan (TNQKN)"
  },
  {
   value: "Kebili (TNKEB)",
   label: "Kebili (TNKEB)"
  },
  {
   value: "Ksibet el Médiouni (TNKEM)",
   label: "Ksibet el Médiouni (TNKEM)"
  },
  {
   value: "La Mohammedia (TNMOH)",
   label: "La Mohammedia (TNMOH)"
  },
  {
   value: "Madanin (TNMDN)",
   label: "Madanin (TNMDN)"
  },
  {
   value: "Mahdia (TNMAD)",
   label: "Mahdia (TNMAD)"
  },
  {
   value: "Mégrine-Lescure (TNMEG)",
   label: "Mégrine-Lescure (TNMEG)"
  },
  {
   value: "Naassen (TNNAS)",
   label: "Naassen (TNNAS)"
  },
  {
   value: "Qasr Hallal (TNTZD)",
   label: "Qasr Hallal (TNTZD)"
  },
  {
   value: "Radès (TNRAD)",
   label: "Radès (TNRAD)"
  },
  {
   value: "Sidi Bu Zayd (TNSBZ)",
   label: "Sidi Bu Zayd (TNSBZ)"
  },
  {
   value: "Tazerka Terminal (TNTAT)",
   label: "Tazerka Terminal (TNTAT)"
  },
  {
   value: "Tebourba (TNTBB)",
   label: "Tebourba (TNTBB)"
  },
  {
   value: "Tozeur (TNTOE)",
   label: "Tozeur (TNTOE)"
  },
  {
   value: "Zaghouan (TNTZA)",
   label: "Zaghouan (TNTZA)"
  },
  {
   value: "Zarzis (TNZRZ)",
   label: "Zarzis (TNZRZ)"
  },
  {
   value: ".TONGA (TO)",
   label: ".TONGA (TO)"
  },
  {
   value: "Niuatoputapu (TONTT)",
   label: "Niuatoputapu (TONTT)"
  },
  {
   value: ".TURKEY (TR)",
   label: ".TURKEY (TR)"
  },
  {
   value: "Akcansa (TRAKC)",
   label: "Akcansa (TRAKC)"
  },
  {
   value: "Alibeyköy (TRABK)",
   label: "Alibeyköy (TRABK)"
  },
  {
   value: "Alsancak (TRANC)",
   label: "Alsancak (TRANC)"
  },
  {
   value: "Altinsehir (TRATS)",
   label: "Altinsehir (TRATS)"
  },
  {
   value: "Altinusagi (TRAIZ)",
   label: "Altinusagi (TRAIZ)"
  },
  {
   value: "Ambarli (TRAMR)",
   label: "Ambarli (TRAMR)"
  },
  {
   value: "Ambarli (TRPAM)",
   label: "Ambarli (TRPAM)"
  },
  {
   value: "Antakya (TRAKA)",
   label: "Antakya (TRAKA)"
  },
  {
   value: "Antalya Free Zone (TRUZE)",
   label: "Antalya Free Zone (TRUZE)"
  },
  {
   value: "Arnavutköy\/Istambul (TRARN)",
   label: "Arnavutköy\/Istambul (TRARN)"
  },
  {
   value: "Aydinlik Koy (TRUZA)",
   label: "Aydinlik Koy (TRUZA)"
  },
  {
   value: "Baba Point (TRBBP)",
   label: "Baba Point (TRBBP)"
  },
  {
   value: "Bahçesaray (TRBAC)",
   label: "Bahçesaray (TRBAC)"
  },
  {
   value: "Basköy (TRBKY)",
   label: "Basköy (TRBKY)"
  },
  {
   value: "Besiktas (TRBTS)",
   label: "Besiktas (TRBTS)"
  },
  {
   value: "Beylerbeyi (TRBBI)",
   label: "Beylerbeyi (TRBBI)"
  },
  {
   value: "Beyoglu (TRBYO)",
   label: "Beyoglu (TRBYO)"
  },
  {
   value: "Bornova\/Izmir (TRBNI)",
   label: "Bornova\/Izmir (TRBNI)"
  },
  {
   value: "Botas (TRBOT)",
   label: "Botas (TRBOT)"
  },
  {
   value: "Büyükkaristiran (TRBKA)",
   label: "Büyükkaristiran (TRBKA)"
  },
  {
   value: "Çamdibi (TRCMB)",
   label: "Çamdibi (TRCMB)"
  },
  {
   value: "Çaybasi (TRCAB)",
   label: "Çaybasi (TRCAB)"
  },
  {
   value: "Çivril (TRCIV)",
   label: "Çivril (TRCIV)"
  },
  {
   value: "Cizre (TRCZE)",
   label: "Cizre (TRCZE)"
  },
  {
   value: "Çorlu (TRCOR)",
   label: "Çorlu (TRCOR)"
  },
  {
   value: "Çorlu (TRCRU)",
   label: "Çorlu (TRCRU)"
  },
  {
   value: "Corum (TRCOM)",
   label: "Corum (TRCOM)"
  },
  {
   value: "Davutpasa (TRDAV)",
   label: "Davutpasa (TRDAV)"
  },
  {
   value: "Davutpasa (TRDPS)",
   label: "Davutpasa (TRDPS)"
  },
  {
   value: "Demirtas (TRDMT)",
   label: "Demirtas (TRDMT)"
  },
  {
   value: "Ermenek (TREMK)",
   label: "Ermenek (TREMK)"
  },
  {
   value: "Evyap Pt (TREYP)",
   label: "Evyap Pt (TREYP)"
  },
  {
   value: "Evyapan (TREVY)",
   label: "Evyapan (TREVY)"
  },
  {
   value: "Fatih (TRFAT)",
   label: "Fatih (TRFAT)"
  },
  {
   value: "Gaziemir (TRGZM)",
   label: "Gaziemir (TRGZM)"
  },
  {
   value: "Gerze (TRGZE)",
   label: "Gerze (TRGZE)"
  },
  {
   value: "Gürpinar (TRGPR)",
   label: "Gürpinar (TRGPR)"
  },
  {
   value: "Hadimkoy (TRHMY)",
   label: "Hadimkoy (TRHMY)"
  },
  {
   value: "Ihsaniye (TRIHY)",
   label: "Ihsaniye (TRIHY)"
  },
  {
   value: "Ilic (TRILI)",
   label: "Ilic (TRILI)"
  },
  {
   value: "Incirlik (TRINC)",
   label: "Incirlik (TRINC)"
  },
  {
   value: "Isdemir (TRIDM)",
   label: "Isdemir (TRIDM)"
  },
  {
   value: "Istinye\/Istambul (TRITY)",
   label: "Istinye\/Istambul (TRITY)"
  },
  {
   value: "Kabatas (TRKBS)",
   label: "Kabatas (TRKBS)"
  },
  {
   value: "Kabatas (TRKTS)",
   label: "Kabatas (TRKTS)"
  },
  {
   value: "Karaköy\/Istambul (TRKKY)",
   label: "Karaköy\/Istambul (TRKKY)"
  },
  {
   value: "Kavacik (TRKAV)",
   label: "Kavacik (TRKAV)"
  },
  {
   value: "Kayisdagi (TRKIS)",
   label: "Kayisdagi (TRKIS)"
  },
  {
   value: "Kazanli (TRKZI)",
   label: "Kazanli (TRKZI)"
  },
  {
   value: "Kefken (TRKFK)",
   label: "Kefken (TRKFK)"
  },
  {
   value: "Kilis (TRKIL)",
   label: "Kilis (TRKIL)"
  },
  {
   value: "Kirac (TRKRC)",
   label: "Kirac (TRKRC)"
  },
  {
   value: "Kiziltepe (TRKZE)",
   label: "Kiziltepe (TRKZE)"
  },
  {
   value: "Körfez (TRKFZ)",
   label: "Körfez (TRKFZ)"
  },
  {
   value: "Küçükbakkal (TRKUC)",
   label: "Küçükbakkal (TRKUC)"
  },
  {
   value: "Kumburgaz (TRKBG)",
   label: "Kumburgaz (TRKBG)"
  },
  {
   value: "Kumport (TRKMX)",
   label: "Kumport (TRKMX)"
  },
  {
   value: "Kuzuluk (TRKUZ)",
   label: "Kuzuluk (TRKUZ)"
  },
  {
   value: "Limas (TRLMA)",
   label: "Limas (TRLMA)"
  },
  {
   value: "Mardas (TRMAD)",
   label: "Mardas (TRMAD)"
  },
  {
   value: "Marport (TRMPT)",
   label: "Marport (TRMPT)"
  },
  {
   value: "Mersin-Free Zone (TRMFZ)",
   label: "Mersin-Free Zone (TRMFZ)"
  },
  {
   value: "Muradiye (TRMDY)",
   label: "Muradiye (TRMDY)"
  },
  {
   value: "Nilüfer (TRNIL)",
   label: "Nilüfer (TRNIL)"
  },
  {
   value: "Pazar (TRPZR)",
   label: "Pazar (TRPZR)"
  },
  {
   value: "Pinarbasi (TRUZC)",
   label: "Pinarbasi (TRUZC)"
  },
  {
   value: "Sabiha Gokcen Apt\/Istanbul (TRSAW)",
   label: "Sabiha Gokcen Apt\/Istanbul (TRSAW)"
  },
  {
   value: "Safranbolu (TRSAF)",
   label: "Safranbolu (TRSAF)"
  },
  {
   value: "Sakarya (TRSAK)",
   label: "Sakarya (TRSAK)"
  },
  {
   value: "Saraylar (TRSRL)",
   label: "Saraylar (TRSRL)"
  },
  {
   value: "Sariseki (TRSRS)",
   label: "Sariseki (TRSRS)"
  },
  {
   value: "Sasalli (TRSAS)",
   label: "Sasalli (TRSAS)"
  },
  {
   value: "Sekerpinar (TRUZD)",
   label: "Sekerpinar (TRUZD)"
  },
  {
   value: "Sile (TRSLE)",
   label: "Sile (TRSLE)"
  },
  {
   value: "Sirnak (TRSNK)",
   label: "Sirnak (TRSNK)"
  },
  {
   value: "Taksim\/Istambul (TRTAK)",
   label: "Taksim\/Istambul (TRTAK)"
  },
  {
   value: "Tepebasi (TRTPI)",
   label: "Tepebasi (TRTPI)"
  },
  {
   value: "Toros Gubre Terminal, Gubre (TRTGT)",
   label: "Toros Gubre Terminal, Gubre (TRTGT)"
  },
  {
   value: "Turanköy (TRTKY)",
   label: "Turanköy (TRTKY)"
  },
  {
   value: "Tuzla Free Zone (TRTFZ)",
   label: "Tuzla Free Zone (TRTFZ)"
  },
  {
   value: "Vakfikebir (TRVAK)",
   label: "Vakfikebir (TRVAK)"
  },
  {
   value: "Yakuplu (TRYKP)",
   label: "Yakuplu (TRYKP)"
  },
  {
   value: "Yalova&nbsp; (TRYLA)",
   label: "Yalova&nbsp; (TRYLA)"
  },
  {
   value: "Yeniçaga (TRYCA)",
   label: "Yeniçaga (TRYCA)"
  },
  {
   value: "Yenidogan (TRYDG)",
   label: "Yenidogan (TRYDG)"
  },
  {
   value: "Yenimahalle (TRYEH)",
   label: "Yenimahalle (TRYEH)"
  },
  {
   value: "Yilport (TRYPO)",
   label: "Yilport (TRYPO)"
  },
  {
   value: "Yüksekova (TRYUK)",
   label: "Yüksekova (TRYUK)"
  },
  {
   value: ".TRINIDAD AND TOBAGO (TT)",
   label: ".TRINIDAD AND TOBAGO (TT)"
  },
  {
   value: "Arima (TTZAA)",
   label: "Arima (TTZAA)"
  },
  {
   value: "Carenage (TTCRN)",
   label: "Carenage (TTCRN)"
  },
  {
   value: "Champs Fleurs\/Port-of-Spain (TTCHF)",
   label: "Champs Fleurs\/Port-of-Spain (TTCHF)"
  },
  {
   value: "Charlotteville (TTCHV)",
   label: "Charlotteville (TTCHV)"
  },
  {
   value: "Couva (TTCVA)",
   label: "Couva (TTCVA)"
  },
  {
   value: "Guayaguayare (TTGUA)",
   label: "Guayaguayare (TTGUA)"
  },
  {
   value: "Marabella (TTMAR)",
   label: "Marabella (TTMAR)"
  },
  {
   value: "Morvant\/Port-of-Spain (TTMVT)",
   label: "Morvant\/Port-of-Spain (TTMVT)"
  },
  {
   value: "Point Lizza (TTPPL)",
   label: "Point Lizza (TTPPL)"
  },
  {
   value: "San Juan\/Port-of-Spain (TTSAN)",
   label: "San Juan\/Port-of-Spain (TTSAN)"
  },
  {
   value: "Scarborough (TTSCR)",
   label: "Scarborough (TTSCR)"
  },
  {
   value: "Vista Bella (TTVBL)",
   label: "Vista Bella (TTVBL)"
  },
  {
   value: ".TUVALU (TV)",
   label: ".TUVALU (TV)"
  },
  {
   value: ".TAIWAN, PROVINCE OF CHINA (TW)",
   label: ".TAIWAN, PROVINCE OF CHINA (TW)"
  },
  {
   value: "Chang-Hua (TWCHW)",
   label: "Chang-Hua (TWCHW)"
  },
  {
   value: "Chi Mei (TWCMJ)",
   label: "Chi Mei (TWCMJ)"
  },
  {
   value: "Chu-pei (TWCUP)",
   label: "Chu-pei (TWCUP)"
  },
  {
   value: "Green Island (TWGNI)",
   label: "Green Island (TWGNI)"
  },
  {
   value: "Guishan (TWGUE)",
   label: "Guishan (TWGUE)"
  },
  {
   value: "Hengchun (TWHCN)",
   label: "Hengchun (TWHCN)"
  },
  {
   value: "Hoping (TWHOP)",
   label: "Hoping (TWHOP)"
  },
  {
   value: "Hsichih (TWHSI)",
   label: "Hsichih (TWHSI)"
  },
  {
   value: "Hsin-chu (TWHSZ)",
   label: "Hsin-chu (TWHSZ)"
  },
  {
   value: "I-lan (TWILA)",
   label: "I-lan (TWILA)"
  },
  {
   value: "Kinmen (TWKNH)",
   label: "Kinmen (TWKNH)"
  },
  {
   value: "Lishan (TWLHN)",
   label: "Lishan (TWLHN)"
  },
  {
   value: "Lung-men (TWLGM)",
   label: "Lung-men (TWLGM)"
  },
  {
   value: "Mai-Liai (TWMAL)",
   label: "Mai-Liai (TWMAL)"
  },
  {
   value: "Mai-liao (TWMLI)",
   label: "Mai-liao (TWMLI)"
  },
  {
   value: "Matsu (TWMFK)",
   label: "Matsu (TWMFK)"
  },
  {
   value: "Miao-li (TWZMI)",
   label: "Miao-li (TWZMI)"
  },
  {
   value: "Orchid Island (TWKYD)",
   label: "Orchid Island (TWKYD)"
  },
  {
   value: "Pingtung (TWPIF)",
   label: "Pingtung (TWPIF)"
  },
  {
   value: "Selangdor (TWSEL)",
   label: "Selangdor (TWSEL)"
  },
  {
   value: "Sha-lun (TWSHL)",
   label: "Sha-lun (TWSHL)"
  },
  {
   value: "Sijhih (TWSIJ)",
   label: "Sijhih (TWSIJ)"
  },
  {
   value: "Sun Moon Lake (TWSMT)",
   label: "Sun Moon Lake (TWSMT)"
  },
  {
   value: "Toufen (TWTOF)",
   label: "Toufen (TWTOF)"
  },
  {
   value: "Tou-liu (TWTUZ)",
   label: "Tou-liu (TWTUZ)"
  },
  {
   value: "Wonan (TWWOT)",
   label: "Wonan (TWWOT)"
  },
  {
   value: "Wu-jih (TWWUJ)",
   label: "Wu-jih (TWWUJ)"
  },
  {
   value: "Wu-ku (TWWUK)",
   label: "Wu-ku (TWWUK)"
  },
  {
   value: "Wu-tu (TWWTU)",
   label: "Wu-tu (TWWTU)"
  },
  {
   value: "Ying-Ge (TWYGE)",
   label: "Ying-Ge (TWYGE)"
  },
  {
   value: "Yüang-wang (TWFEY)",
   label: "Yüang-wang (TWFEY)"
  },
  {
   value: "Yung-an (TWYAN)",
   label: "Yung-an (TWYAN)"
  },
  {
   value: "Yunlin (TWYLN)",
   label: "Yunlin (TWYLN)"
  },
  {
   value: ".TANZANIA, UNITED REPUBLIC OF (TZ)",
   label: ".TANZANIA, UNITED REPUBLIC OF (TZ)"
  },
  {
   value: "Ikwiriri (TZIKW)",
   label: "Ikwiriri (TZIKW)"
  },
  {
   value: "Iringa (TZIRI)",
   label: "Iringa (TZIRI)"
  },
  {
   value: "Isaka (TZISK)",
   label: "Isaka (TZISK)"
  },
  {
   value: "Kahama (TZKHM)",
   label: "Kahama (TZKHM)"
  },
  {
   value: "Kibaha (TZKIB)",
   label: "Kibaha (TZKIB)"
  },
  {
   value: "Korogwe (TZKRG)",
   label: "Korogwe (TZKRG)"
  },
  {
   value: "Lake Manyara (TZLKY)",
   label: "Lake Manyara (TZLKY)"
  },
  {
   value: "Lushoto (TZLUY)",
   label: "Lushoto (TZLUY)"
  },
  {
   value: "Masasi (TZXMI)",
   label: "Masasi (TZXMI)"
  },
  {
   value: "Mbeya (TZMBI)",
   label: "Mbeya (TZMBI)"
  },
  {
   value: "Mlimba (TZMLB)",
   label: "Mlimba (TZMLB)"
  },
  {
   value: "Morogoro (TZMRG)",
   label: "Morogoro (TZMRG)"
  },
  {
   value: "Moshi (TZMSH)",
   label: "Moshi (TZMSH)"
  },
  {
   value: "Mwadui (TZMWN)",
   label: "Mwadui (TZMWN)"
  },
  {
   value: "Njombe (TZJOM)",
   label: "Njombe (TZJOM)"
  },
  {
   value: "Nzega (TZNZG)",
   label: "Nzega (TZNZG)"
  },
  {
   value: "Seronera (TZSEU)",
   label: "Seronera (TZSEU)"
  },
  {
   value: "Shinyanga (TZSHY)",
   label: "Shinyanga (TZSHY)"
  },
  {
   value: "Sumbawanga (TZSUT)",
   label: "Sumbawanga (TZSUT)"
  },
  {
   value: "Yombo (TZYOB)",
   label: "Yombo (TZYOB)"
  },
  {
   value: ".UKRAINE (UA)",
   label: ".UKRAINE (UA)"
  },
  {
   value: "Aleksandria (UAZUZ)",
   label: "Aleksandria (UAZUZ)"
  },
  {
   value: "Armyansk (UAARM)",
   label: "Armyansk (UAARM)"
  },
  {
   value: "Artemovsk (UAZUB)",
   label: "Artemovsk (UAZUB)"
  },
  {
   value: "Balta (UAZUF)",
   label: "Balta (UAZUF)"
  },
  {
   value: "Bar (UABAR)",
   label: "Bar (UABAR)"
  },
  {
   value: "Beregovo (UAZUE)",
   label: "Beregovo (UAZUE)"
  },
  {
   value: "Bila Tserkva (Belaja Zerkow) (UABZW)",
   label: "Bila Tserkva (Belaja Zerkow) (UABZW)"
  },
  {
   value: "Bobrovitsa (UAZUD)",
   label: "Bobrovitsa (UAZUD)"
  },
  {
   value: "Bogodukhov (UAZUG)",
   label: "Bogodukhov (UAZUG)"
  },
  {
   value: "Bohorodchany (UABOH)",
   label: "Bohorodchany (UABOH)"
  },
  {
   value: "Borodjanka (UABOR)",
   label: "Borodjanka (UABOR)"
  },
  {
   value: "Boyarka (UAZUH)",
   label: "Boyarka (UAZUH)"
  },
  {
   value: "Broshnev-Osada (UABRS)",
   label: "Broshnev-Osada (UABRS)"
  },
  {
   value: "Brovary (UABRO)",
   label: "Brovary (UABRO)"
  },
  {
   value: "Bucha (UABUC)",
   label: "Bucha (UABUC)"
  },
  {
   value: "Cherkasskaya (UACKK)",
   label: "Cherkasskaya (UACKK)"
  },
  {
   value: "Cherkassy (UACKC)",
   label: "Cherkassy (UACKC)"
  },
  {
   value: "Chernigov (UACEJ)",
   label: "Chernigov (UACEJ)"
  },
  {
   value: "Chernihiv (UAZUQ)",
   label: "Chernihiv (UAZUQ)"
  },
  {
   value: "Chernivtsi (Chernovtsy) (UACWC)",
   label: "Chernivtsi (Chernovtsy) (UACWC)"
  },
  {
   value: "Chernobayevka (UACBA)",
   label: "Chernobayevka (UACBA)"
  },
  {
   value: "Chinadiyevo (UACHD)",
   label: "Chinadiyevo (UACHD)"
  },
  {
   value: "Chuguev (UACHU)",
   label: "Chuguev (UACHU)"
  },
  {
   value: "Chuguyev (UACGV)",
   label: "Chuguyev (UACGV)"
  },
  {
   value: "Dneprobugskiy (UADNB)",
   label: "Dneprobugskiy (UADNB)"
  },
  {
   value: "Dneprodzerzhinsk (UADZK)",
   label: "Dneprodzerzhinsk (UADZK)"
  },
  {
   value: "Dnepropetrovsk (UADNK)",
   label: "Dnepropetrovsk (UADNK)"
  },
  {
   value: "Dorozhnoye (UADNE)",
   label: "Dorozhnoye (UADNE)"
  },
  {
   value: "Dubno (UADUB)",
   label: "Dubno (UADUB)"
  },
  {
   value: "Dudarkov (UADDK)",
   label: "Dudarkov (UADDK)"
  },
  {
   value: "Dzhankoy (UAZUI)",
   label: "Dzhankoy (UAZUI)"
  },
  {
   value: "Fastov (UAZUJ)",
   label: "Fastov (UAZUJ)"
  },
  {
   value: "Gorenka (UAGOR)",
   label: "Gorenka (UAGOR)"
  },
  {
   value: "Ichnya (UAZUK)",
   label: "Ichnya (UAZUK)"
  },
  {
   value: "Illintsi (UAZUL)",
   label: "Illintsi (UAZUL)"
  },
  {
   value: "Irshava (UAIHA)",
   label: "Irshava (UAIHA)"
  },
  {
   value: "Ivano Frankivsk (UAIVA)",
   label: "Ivano Frankivsk (UAIVA)"
  },
  {
   value: "Ivano-Frankovsk (UAIFO)",
   label: "Ivano-Frankovsk (UAIFO)"
  },
  {
   value: "Iziaslav (UAIZI)",
   label: "Iziaslav (UAIZI)"
  },
  {
   value: "Kalush (UAKAL)",
   label: "Kalush (UAKAL)"
  },
  {
   value: "Kamenets-Podolskiy (UAKCP)",
   label: "Kamenets-Podolskiy (UAKCP)"
  },
  {
   value: "Kamenka (UAZUM)",
   label: "Kamenka (UAZUM)"
  },
  {
   value: "Kamianets-Podilskyi (UAKAM)",
   label: "Kamianets-Podilskyi (UAKAM)"
  },
  {
   value: "Kaniv (UAZUN)",
   label: "Kaniv (UAZUN)"
  },
  {
   value: "Khartsyzk (UAKHA)",
   label: "Khartsyzk (UAKHA)"
  },
  {
   value: "Khartsyzsk (UAKHT)",
   label: "Khartsyzsk (UAKHT)"
  },
  {
   value: "Khmelnitskiy (UAHMJ)",
   label: "Khmelnitskiy (UAHMJ)"
  },
  {
   value: "Khmelnytskyi (UAKHM)",
   label: "Khmelnytskyi (UAKHM)"
  },
  {
   value: "Khudyaky (UAKHY)",
   label: "Khudyaky (UAKHY)"
  },
  {
   value: "Kirovograd (UAKGO)",
   label: "Kirovograd (UAKGO)"
  },
  {
   value: "Kirovohrad (UAKIR)",
   label: "Kirovohrad (UAKIR)"
  },
  {
   value: "Konotop (UAKTP)",
   label: "Konotop (UAKTP)"
  },
  {
   value: "Konstantinovka (UAKON)",
   label: "Konstantinovka (UAKON)"
  },
  {
   value: "Korostyshiv (UAZUO)",
   label: "Korostyshiv (UAZUO)"
  },
  {
   value: "Korsun Shevchenkivskyy (UAZUT)",
   label: "Korsun Shevchenkivskyy (UAZUT)"
  },
  {
   value: "Kramatorsk (UAKRQ)",
   label: "Kramatorsk (UAKRQ)"
  },
  {
   value: "Krasilov (UAKRS)",
   label: "Krasilov (UAKRS)"
  },
  {
   value: "Krasnograd (UAKGD)",
   label: "Krasnograd (UAKGD)"
  },
  {
   value: "Kraynykovo (UAKKO)",
   label: "Kraynykovo (UAKKO)"
  },
  {
   value: "Kremenchug (UAKHU)",
   label: "Kremenchug (UAKHU)"
  },
  {
   value: "Krivoy Rog (UAKWG)",
   label: "Krivoy Rog (UAKWG)"
  },
  {
   value: "Kulinichi (UAKUL)",
   label: "Kulinichi (UAKUL)"
  },
  {
   value: "Lugansk (UAVSG)",
   label: "Lugansk (UAVSG)"
  },
  {
   value: "Lutsk (UAUCK)",
   label: "Lutsk (UAUCK)"
  },
  {
   value: "Malin (UAMLN)",
   label: "Malin (UAMLN)"
  },
  {
   value: "Mandrykino (UAMDK)",
   label: "Mandrykino (UAMDK)"
  },
  {
   value: "Mena (UAZUP)",
   label: "Mena (UAZUP)"
  },
  {
   value: "Mirgorod (UAMXR)",
   label: "Mirgorod (UAMXR)"
  },
  {
   value: "Mironovka (UAMIR)",
   label: "Mironovka (UAMIR)"
  },
  {
   value: "Mukachëvo (UAMUK)",
   label: "Mukachëvo (UAMUK)"
  },
  {
   value: "Mykolayiv (UAZUA)",
   label: "Mykolayiv (UAZUA)"
  },
  {
   value: "Myronivka (UAMYR)",
   label: "Myronivka (UAMYR)"
  },
  {
   value: "Nemirov (UAZUW)",
   label: "Nemirov (UAZUW)"
  },
  {
   value: "Nikolaev (UANLV)",
   label: "Nikolaev (UANLV)"
  },
  {
   value: "Nikopol (UAPOL)",
   label: "Nikopol (UAPOL)"
  },
  {
   value: "Nizhnedneprovsk (UANNP)",
   label: "Nizhnedneprovsk (UANNP)"
  },
  {
   value: "Nizhyn (UAZUU)",
   label: "Nizhyn (UAZUU)"
  },
  {
   value: "Nova Kakhovka (UAZUR)",
   label: "Nova Kakhovka (UAZUR)"
  },
  {
   value: "Nova Vodolaha (UALAH)",
   label: "Nova Vodolaha (UALAH)"
  },
  {
   value: "Novomoskovsk (UADÉC)",
   label: "Novomoskovsk (UADÉC)"
  },
  {
   value: "Oktyabrsk (UAOCT)",
   label: "Oktyabrsk (UAOCT)"
  },
  {
   value: "Olevsk (UAOLK)",
   label: "Olevsk (UAOLK)"
  },
  {
   value: "Orane (UAZUS)",
   label: "Orane (UAZUS)"
  },
  {
   value: "Ordzhonikidze (UAORD)",
   label: "Ordzhonikidze (UAORD)"
  },
  {
   value: "Ovidiopol (UAOVI)",
   label: "Ovidiopol (UAOVI)"
  },
  {
   value: "Pavlohrad (UAPAH)",
   label: "Pavlohrad (UAPAH)"
  },
  {
   value: "Pervomaysk (UAZUY)",
   label: "Pervomaysk (UAZUY)"
  },
  {
   value: "Plodorodnoye (UAPRN)",
   label: "Plodorodnoye (UAPRN)"
  },
  {
   value: "Podgorodnaya (UAPGN)",
   label: "Podgorodnaya (UAPGN)"
  },
  {
   value: "Polonka (UAGIR)",
   label: "Polonka (UAGIR)"
  },
  {
   value: "Poltava (UAPLV)",
   label: "Poltava (UAPLV)"
  },
  {
   value: "Pryazhevo (UAPRY)",
   label: "Pryazhevo (UAPRY)"
  },
  {
   value: "Pryluky (UAPLK)",
   label: "Pryluky (UAPLK)"
  },
  {
   value: "Pustomyty (UAPMY)",
   label: "Pustomyty (UAPMY)"
  },
  {
   value: "Radisne (UARAD)",
   label: "Radisne (UARAD)"
  },
  {
   value: "Ripky (UACRY)",
   label: "Ripky (UACRY)"
  },
  {
   value: "Rovno (UARWN)",
   label: "Rovno (UARWN)"
  },
  {
   value: "Severodoneck (UASEV)",
   label: "Severodoneck (UASEV)"
  },
  {
   value: "Severodonetsk (UAZUC)",
   label: "Severodonetsk (UAZUC)"
  },
  {
   value: "Shepetovka (UAVKK)",
   label: "Shepetovka (UAVKK)"
  },
  {
   value: "Shostka (UATKK)",
   label: "Shostka (UATKK)"
  },
  {
   value: "Skadovsk (UASKD)",
   label: "Skadovsk (UASKD)"
  },
  {
   value: "Smela (UASMI)",
   label: "Smela (UASMI)"
  },
  {
   value: "Sokilnyky (UASOK)",
   label: "Sokilnyky (UASOK)"
  },
  {
   value: "Soledar (UASDR)",
   label: "Soledar (UASDR)"
  },
  {
   value: "Starokonstantinov (UASTA)",
   label: "Starokonstantinov (UASTA)"
  },
  {
   value: "Sumy (UAUMY)",
   label: "Sumy (UAUMY)"
  },
  {
   value: "Susly (UASLY)",
   label: "Susly (UASLY)"
  },
  {
   value: "Svetlovodsk (UADSK)",
   label: "Svetlovodsk (UADSK)"
  },
  {
   value: "Talne (UATAL)",
   label: "Talne (UATAL)"
  },
  {
   value: "Terebovlya (UATER)",
   label: "Terebovlya (UATER)"
  },
  {
   value: "Ternopol (UATNL)",
   label: "Ternopol (UATNL)"
  },
  {
   value: "Trostyanets (UATSY)",
   label: "Trostyanets (UATSY)"
  },
  {
   value: "Truskavets (UATRU)",
   label: "Truskavets (UATRU)"
  },
  {
   value: "Tyachiv (UATCV)",
   label: "Tyachiv (UATCV)"
  },
  {
   value: "Uman (UAZUV)",
   label: "Uman (UAZUV)"
  },
  {
   value: "Vadul (UAVAD)",
   label: "Vadul (UAVAD)"
  },
  {
   value: "Velikiy (UAVEY)",
   label: "Velikiy (UAVEY)"
  },
  {
   value: "Velyikyy Bychkiv (UAVBO)",
   label: "Velyikyy Bychkiv (UAVBO)"
  },
  {
   value: "Velyka Dymerka (UAVDM)",
   label: "Velyka Dymerka (UAVDM)"
  },
  {
   value: "Vinnytsya (UAVIN)",
   label: "Vinnytsya (UAVIN)"
  },
  {
   value: "Vorzel (UAVOR)",
   label: "Vorzel (UAVOR)"
  },
  {
   value: "Voznesensk (UAZUX)",
   label: "Voznesensk (UAZUX)"
  },
  {
   value: "Vradiyivka (UAVRA)",
   label: "Vradiyivka (UAVRA)"
  },
  {
   value: "Vylkove (UAVYL)",
   label: "Vylkove (UAVYL)"
  },
  {
   value: "Yavoriv (UAYAV)",
   label: "Yavoriv (UAYAV)"
  },
  {
   value: "Yavorov (UAYVV)",
   label: "Yavorov (UAYVV)"
  },
  {
   value: "Yevpatoriya (UAZKA)",
   label: "Yevpatoriya (UAZKA)"
  },
  {
   value: "Zavydovo (UAZDO)",
   label: "Zavydovo (UAZDO)"
  },
  {
   value: "Zhashkiv (UAZKB)",
   label: "Zhashkiv (UAZKB)"
  },
  {
   value: "Zhitomir (UAZTR)",
   label: "Zhitomir (UAZTR)"
  },
  {
   value: "Zhovkva (UAZHO)",
   label: "Zhovkva (UAZHO)"
  },
  {
   value: "Zhytomyr (UAZKC)",
   label: "Zhytomyr (UAZKC)"
  },
  {
   value: "Zolotaya Balka (UAZOL)",
   label: "Zolotaya Balka (UAZOL)"
  },
  {
   value: "Zolotonosha (UAZKD)",
   label: "Zolotonosha (UAZKD)"
  },
  {
   value: ".UGANDA (UG)",
   label: ".UGANDA (UG)"
  },
  {
   value: "Arua (UGRUA)",
   label: "Arua (UGRUA)"
  },
  {
   value: "Gaba (UGGAB)",
   label: "Gaba (UGGAB)"
  },
  {
   value: "Gulu (UGULU)",
   label: "Gulu (UGULU)"
  },
  {
   value: "Kabalega Falls (UGKBG)",
   label: "Kabalega Falls (UGKBG)"
  },
  {
   value: "Kitgum (UGKGM)",
   label: "Kitgum (UGKGM)"
  },
  {
   value: "Koboko (UGKOB)",
   label: "Koboko (UGKOB)"
  },
  {
   value: "Lugazi (UGLUG)",
   label: "Lugazi (UGLUG)"
  },
  {
   value: "Malaba (UGMAL)",
   label: "Malaba (UGMAL)"
  },
  {
   value: "Moyo (UGOYG)",
   label: "Moyo (UGOYG)"
  },
  {
   value: "Pakelle (UGPKE)",
   label: "Pakelle (UGPKE)"
  },
  {
   value: "Pakuba (UGPAF)",
   label: "Pakuba (UGPAF)"
  },
  {
   value: ".UNITED STATES MINOR OUTLYING ISLANDS (UM)",
   label: ".UNITED STATES MINOR OUTLYING ISLANDS (UM)"
  },
  {
   value: ".UNITED STATES (US)",
   label: ".UNITED STATES (US)"
  },
  {
   value: "Abbott Park (USABJ)",
   label: "Abbott Park (USABJ)"
  },
  {
   value: "Aberdeen (USAB3)",
   label: "Aberdeen (USAB3)"
  },
  {
   value: "Aberdeen (USABK)",
   label: "Aberdeen (USABK)"
  },
  {
   value: "Aberdeen (USAEK)",
   label: "Aberdeen (USAEK)"
  },
  {
   value: "Aberdeen (USAHD)",
   label: "Aberdeen (USAHD)"
  },
  {
   value: "Aberdeen (USAPD)",
   label: "Aberdeen (USAPD)"
  },
  {
   value: "Aberdeen (USGHR)",
   label: "Aberdeen (USGHR)"
  },
  {
   value: "Abingdon (USNGD)",
   label: "Abingdon (USNGD)"
  },
  {
   value: "Abingdon (USVJI)",
   label: "Abingdon (USVJI)"
  },
  {
   value: "Abington (USUUM)",
   label: "Abington (USUUM)"
  },
  {
   value: "Abita Springs (USTPG)",
   label: "Abita Springs (USTPG)"
  },
  {
   value: "Absecon (USACX)",
   label: "Absecon (USACX)"
  },
  {
   value: "Acampo (USAA4)",
   label: "Acampo (USAA4)"
  },
  {
   value: "Accident (USAJT)",
   label: "Accident (USAJT)"
  },
  {
   value: "Accomac (USAQC)",
   label: "Accomac (USAQC)"
  },
  {
   value: "Ackerman (USACR)",
   label: "Ackerman (USACR)"
  },
  {
   value: "Acme (USQZA)",
   label: "Acme (USQZA)"
  },
  {
   value: "Acra (USQCA)",
   label: "Acra (USQCA)"
  },
  {
   value: "Acushnet (USKUS)",
   label: "Acushnet (USKUS)"
  },
  {
   value: "Ada (USAJJ)",
   label: "Ada (USAJJ)"
  },
  {
   value: "Ada (USDD2)",
   label: "Ada (USDD2)"
  },
  {
   value: "Adak (USAXK)",
   label: "Adak (USAXK)"
  },
  {
   value: "Adams (USAKM)",
   label: "Adams (USAKM)"
  },
  {
   value: "Adams Run (USUAJ)",
   label: "Adams Run (USUAJ)"
  },
  {
   value: "Adamston (USDST)",
   label: "Adamston (USDST)"
  },
  {
   value: "Adamstown (USAEJ)",
   label: "Adamstown (USAEJ)"
  },
  {
   value: "Addison (USDDX)",
   label: "Addison (USDDX)"
  },
  {
   value: "Addison (USIAB)",
   label: "Addison (USIAB)"
  },
  {
   value: "Addison (USYAI)",
   label: "Addison (USYAI)"
  },
  {
   value: "Adel (USZAE)",
   label: "Adel (USZAE)"
  },
  {
   value: "Adell (USAJD)",
   label: "Adell (USAJD)"
  },
  {
   value: "Adelphia (USAHP)",
   label: "Adelphia (USAHP)"
  },
  {
   value: "Adrian (USAQA)",
   label: "Adrian (USAQA)"
  },
  {
   value: "Adrian (USDIA)",
   label: "Adrian (USDIA)"
  },
  {
   value: "Advance (USA2D)",
   label: "Advance (USA2D)"
  },
  {
   value: "Advance (USAVX)",
   label: "Advance (USAVX)"
  },
  {
   value: "Affton (USAFF)",
   label: "Affton (USAFF)"
  },
  {
   value: "Afton (USAFQ)",
   label: "Afton (USAFQ)"
  },
  {
   value: "Agoura Hills (USAGH)",
   label: "Agoura Hills (USAGH)"
  },
  {
   value: "Agua Dulce (USA2G)",
   label: "Agua Dulce (USA2G)"
  },
  {
   value: "Aguanga (USGKG)",
   label: "Aguanga (USGKG)"
  },
  {
   value: "Ahoskie (USAHE)",
   label: "Ahoskie (USAHE)"
  },
  {
   value: "Ailey (USYAY)",
   label: "Ailey (USYAY)"
  },
  {
   value: "Airway Heights (USAYH)",
   label: "Airway Heights (USAYH)"
  },
  {
   value: "Akhiok (USAKK)",
   label: "Akhiok (USAKK)"
  },
  {
   value: "Akiachak (USKKI)",
   label: "Akiachak (USKKI)"
  },
  {
   value: "Akiak (USAKI)",
   label: "Akiak (USAKI)"
  },
  {
   value: "Akron (USAKA)",
   label: "Akron (USAKA)"
  },
  {
   value: "Akron (USAKC)",
   label: "Akron (USAKC)"
  },
  {
   value: "Akron (USAKH)",
   label: "Akron (USAKH)"
  },
  {
   value: "Akron (USAKO)",
   label: "Akron (USAKO)"
  },
  {
   value: "Akutan (USKQA)",
   label: "Akutan (USKQA)"
  },
  {
   value: "Alabama City (USZAC)",
   label: "Alabama City (USZAC)"
  },
  {
   value: "Alachua (USAHU)",
   label: "Alachua (USAHU)"
  },
  {
   value: "Aladdin (USDNJ)",
   label: "Aladdin (USDNJ)"
  },
  {
   value: "Alakanuk (USAUK)",
   label: "Alakanuk (USAUK)"
  },
  {
   value: "Alamo (USAM8)",
   label: "Alamo (USAM8)"
  },
  {
   value: "Alamosa (USALS)",
   label: "Alamosa (USALS)"
  },
  {
   value: "Alanson (USYAN)",
   label: "Alanson (USYAN)"
  },
  {
   value: "Alba (USXAB)",
   label: "Alba (USXAB)"
  },
  {
   value: "Albany (USAB2)",
   label: "Albany (USAB2)"
  },
  {
   value: "Albany (USAJB)",
   label: "Albany (USAJB)"
  },
  {
   value: "Albany (USAL2)",
   label: "Albany (USAL2)"
  },
  {
   value: "Albany (USAYK)",
   label: "Albany (USAYK)"
  },
  {
   value: "Albany (USAYU)",
   label: "Albany (USAYU)"
  },
  {
   value: "Albany (USAYW)",
   label: "Albany (USAYW)"
  },
  {
   value: "Albany (USAYX)",
   label: "Albany (USAYX)"
  },
  {
   value: "Albany (USY9)",
   label: "Albany (USY9)"
  },
  {
   value: "Albers (USLXR)",
   label: "Albers (USLXR)"
  },
  {
   value: "Albertson (USOBQ)",
   label: "Albertson (USOBQ)"
  },
  {
   value: "Albin (USAQI)",
   label: "Albin (USAQI)"
  },
  {
   value: "Albion (USAB7)",
   label: "Albion (USAB7)"
  },
  {
   value: "Albion (USAB8)",
   label: "Albion (USAB8)"
  },
  {
   value: "Albion (USAOB)",
   label: "Albion (USAOB)"
  },
  {
   value: "Albion (USAOX)",
   label: "Albion (USAOX)"
  },
  {
   value: "Albion (USYAB)",
   label: "Albion (USYAB)"
  },
  {
   value: "Alburg (USALR)",
   label: "Alburg (USALR)"
  },
  {
   value: "Alcade (USAC5)",
   label: "Alcade (USAC5)"
  },
  {
   value: "Alcan (USZAK)",
   label: "Alcan (USZAK)"
  },
  {
   value: "Alcester (USALJ)",
   label: "Alcester (USALJ)"
  },
  {
   value: "Alda (USAD4)",
   label: "Alda (USAD4)"
  },
  {
   value: "Alden (USDNF)",
   label: "Alden (USDNF)"
  },
  {
   value: "Alden (USEDH)",
   label: "Alden (USEDH)"
  },
  {
   value: "Alden (USYLF)",
   label: "Alden (USYLF)"
  },
  {
   value: "Aledo (USAQD)",
   label: "Aledo (USAQD)"
  },
  {
   value: "Alexander (USAEX)",
   label: "Alexander (USAEX)"
  },
  {
   value: "Alexander (USYAX)",
   label: "Alexander (USYAX)"
  },
  {
   value: "Alexander (USZXA)",
   label: "Alexander (USZXA)"
  },
  {
   value: "Alexandria (USAXP)",
   label: "Alexandria (USAXP)"
  },
  {
   value: "Alexandria (USAXY)",
   label: "Alexandria (USAXY)"
  },
  {
   value: "Alfred (USAFE)",
   label: "Alfred (USAFE)"
  },
  {
   value: "Alfred (USQAF)",
   label: "Alfred (USQAF)"
  },
  {
   value: "Alfred Station (USAFS)",
   label: "Alfred Station (USAFS)"
  },
  {
   value: "Alger (USAJE)",
   label: "Alger (USAJE)"
  },
  {
   value: "Alger (USAQG)",
   label: "Alger (USAQG)"
  },
  {
   value: "Algoma (USQAG)",
   label: "Algoma (USQAG)"
  },
  {
   value: "Algona (USAXG)",
   label: "Algona (USAXG)"
  },
  {
   value: "Algonquin (USAGQ)",
   label: "Algonquin (USAGQ)"
  },
  {
   value: "Algood (USYAG)",
   label: "Algood (USYAG)"
  },
  {
   value: "Allakaket (USAET)",
   label: "Allakaket (USAET)"
  },
  {
   value: "Allamuchy (USUOY)",
   label: "Allamuchy (USUOY)"
  },
  {
   value: "Allegany (USNYZ)",
   label: "Allegany (USNYZ)"
  },
  {
   value: "Allen (USAN2)",
   label: "Allen (USAN2)"
  },
  {
   value: "Allen (USXAL)",
   label: "Allen (USXAL)"
  },
  {
   value: "Allendale (USEDL)",
   label: "Allendale (USEDL)"
  },
  {
   value: "Allendale (USGKE)",
   label: "Allendale (USGKE)"
  },
  {
   value: "Allenstown (USATX)",
   label: "Allenstown (USATX)"
  },
  {
   value: "Allenton (USQWU)",
   label: "Allenton (USQWU)"
  },
  {
   value: "Allenton (USZAG)",
   label: "Allenton (USZAG)"
  },
  {
   value: "Allentown (USAWN)",
   label: "Allentown (USAWN)"
  },
  {
   value: "Allentown, Allegany (USAT2)",
   label: "Allentown, Allegany (USAT2)"
  },
  {
   value: "Allenwood (USAWO)",
   label: "Allenwood (USAWO)"
  },
  {
   value: "Allenwood (USAZW)",
   label: "Allenwood (USAZW)"
  },
  {
   value: "Alliance (USAL3)",
   label: "Alliance (USAL3)"
  },
  {
   value: "Alma (USRAA)",
   label: "Alma (USRAA)"
  },
  {
   value: "Alma (USXAM)",
   label: "Alma (USXAM)"
  },
  {
   value: "Almont (USATJ)",
   label: "Almont (USATJ)"
  },
  {
   value: "Alorton (USZON)",
   label: "Alorton (USZON)"
  },
  {
   value: "Alpha (USALP)",
   label: "Alpha (USALP)"
  },
  {
   value: "Alpha (USAPA)",
   label: "Alpha (USAPA)"
  },
  {
   value: "Alpine (USALE)",
   label: "Alpine (USALE)"
  },
  {
   value: "Alpine (USAPY)",
   label: "Alpine (USAPY)"
  },
  {
   value: "Alpine, Los Angeles (USZJI)",
   label: "Alpine, Los Angeles (USZJI)"
  },
  {
   value: "Alpine, San Diego (USJIN)",
   label: "Alpine, San Diego (USJIN)"
  },
  {
   value: "Alstead (USAFA)",
   label: "Alstead (USAFA)"
  },
  {
   value: "Alta (USAJL)",
   label: "Alta (USAJL)"
  },
  {
   value: "Alta (USTUU)",
   label: "Alta (USTUU)"
  },
  {
   value: "Alta Loma (USAJM)",
   label: "Alta Loma (USAJM)"
  },
  {
   value: "Altamont (USAM7)",
   label: "Altamont (USAM7)"
  },
  {
   value: "Altamont (USTMO)",
   label: "Altamont (USTMO)"
  },
  {
   value: "Altenburg (USGUA)",
   label: "Altenburg (USGUA)"
  },
  {
   value: "Altheimer (USTMR)",
   label: "Altheimer (USTMR)"
  },
  {
   value: "Alto (USAOQ)",
   label: "Alto (USAOQ)"
  },
  {
   value: "Alton (USKLQ)",
   label: "Alton (USKLQ)"
  },
  {
   value: "Alton (USONB)",
   label: "Alton (USONB)"
  },
  {
   value: "Altoona (USNOF)",
   label: "Altoona (USNOF)"
  },
  {
   value: "Altura (USAXU)",
   label: "Altura (USAXU)"
  },
  {
   value: "Alturas (USZIF)",
   label: "Alturas (USZIF)"
  },
  {
   value: "Alum Bank (USQAB)",
   label: "Alum Bank (USQAB)"
  },
  {
   value: "Alva (USALF)",
   label: "Alva (USALF)"
  },
  {
   value: "Alva (USXAK)",
   label: "Alva (USXAK)"
  },
  {
   value: "Alvada (USAV8)",
   label: "Alvada (USAV8)"
  },
  {
   value: "Alvarado (USZAD)",
   label: "Alvarado (USZAD)"
  },
  {
   value: "Alvaton (USA2T)",
   label: "Alvaton (USA2T)"
  },
  {
   value: "Ama (USAMD)",
   label: "Ama (USAMD)"
  },
  {
   value: "Amador (USAA6)",
   label: "Amador (USAA6)"
  },
  {
   value: "Amagansett (USAMF)",
   label: "Amagansett (USAMF)"
  },
  {
   value: "Amargosa Valley (USAGY)",
   label: "Amargosa Valley (USAGY)"
  },
  {
   value: "Amasa (USAMM)",
   label: "Amasa (USAMM)"
  },
  {
   value: "Ambler (USAMR)",
   label: "Ambler (USAMR)"
  },
  {
   value: "Amchitka (USAHT)",
   label: "Amchitka (USAHT)"
  },
  {
   value: "Amelia (USAEI)",
   label: "Amelia (USAEI)"
  },
  {
   value: "Amelia (USOHM)",
   label: "Amelia (USOHM)"
  },
  {
   value: "Amelia (USXXS)",
   label: "Amelia (USXXS)"
  },
  {
   value: "Amelia I. (USAD6)",
   label: "Amelia I. (USAD6)"
  },
  {
   value: "American Canyon (USACY)",
   label: "American Canyon (USACY)"
  },
  {
   value: "American Falls (USYAF)",
   label: "American Falls (USYAF)"
  },
  {
   value: "American Fork (USZAF)",
   label: "American Fork (USZAF)"
  },
  {
   value: "Ames (USQEA)",
   label: "Ames (USQEA)"
  },
  {
   value: "Amesbury (USAMX)",
   label: "Amesbury (USAMX)"
  },
  {
   value: "Amherst (USXWI)",
   label: "Amherst (USXWI)"
  },
  {
   value: "Amherst (USYAM)",
   label: "Amherst (USYAM)"
  },
  {
   value: "Amherst (USZAH)",
   label: "Amherst (USZAH)"
  },
  {
   value: "Amherst (USZAM)",
   label: "Amherst (USZAM)"
  },
  {
   value: "Amity (USAMJ)",
   label: "Amity (USAMJ)"
  },
  {
   value: "Amook (USAOS)",
   label: "Amook (USAOS)"
  },
  {
   value: "Anadarko (USNKO)",
   label: "Anadarko (USNKO)"
  },
  {
   value: "Anahuac (USAQH)",
   label: "Anahuac (USAQH)"
  },
  {
   value: "Anaktuvuk (USAKP)",
   label: "Anaktuvuk (USAKP)"
  },
  {
   value: "Anamoose (USAQF)",
   label: "Anamoose (USAQF)"
  },
  {
   value: "Anchorville (USAHF)",
   label: "Anchorville (USAHF)"
  },
  {
   value: "Andalusia (USUSQ)",
   label: "Andalusia (USUSQ)"
  },
  {
   value: "Anderson (USANO)",
   label: "Anderson (USANO)"
  },
  {
   value: "Anderson (USHJG)",
   label: "Anderson (USHJG)"
  },
  {
   value: "Anderson (USNDE)",
   label: "Anderson (USNDE)"
  },
  {
   value: "Anderson City (USAEQ)",
   label: "Anderson City (USAEQ)"
  },
  {
   value: "Andersonville (USAOZ)",
   label: "Andersonville (USAOZ)"
  },
  {
   value: "Andes (USAJS)",
   label: "Andes (USAJS)"
  },
  {
   value: "Andover (USAD7)",
   label: "Andover (USAD7)"
  },
  {
   value: "Andover (USAJR)",
   label: "Andover (USAJR)"
  },
  {
   value: "Andover (USAXZ)",
   label: "Andover (USAXZ)"
  },
  {
   value: "Andrews (USAGM)",
   label: "Andrews (USAGM)"
  },
  {
   value: "Andrews (USANF)",
   label: "Andrews (USANF)"
  },
  {
   value: "Angel Fire (USAXX)",
   label: "Angel Fire (USAXX)"
  },
  {
   value: "Angelica (USAJC)",
   label: "Angelica (USAJC)"
  },
  {
   value: "Angleton (USAGX)",
   label: "Angleton (USAGX)"
  },
  {
   value: "Angola (USANH)",
   label: "Angola (USANH)"
  },
  {
   value: "Angola (USZAI)",
   label: "Angola (USZAI)"
  },
  {
   value: "Angoon (USAGN)",
   label: "Angoon (USAGN)"
  },
  {
   value: "Angwin (USAWG)",
   label: "Angwin (USAWG)"
  },
  {
   value: "Aniak (USANI)",
   label: "Aniak (USANI)"
  },
  {
   value: "Anita Bay (USAIB)",
   label: "Anita Bay (USAIB)"
  },
  {
   value: "Anna (USNNA)",
   label: "Anna (USNNA)"
  },
  {
   value: "Anna (USYRU)",
   label: "Anna (USYRU)"
  },
  {
   value: "Annandale (USAJA)",
   label: "Annandale (USAJA)"
  },
  {
   value: "Annandale (USXAT)",
   label: "Annandale (USXAT)"
  },
  {
   value: "Annette Island (USANN)",
   label: "Annette Island (USANN)"
  },
  {
   value: "Anniston (USNNT)",
   label: "Anniston (USNNT)"
  },
  {
   value: "Annville (USVVY)",
   label: "Annville (USVVY)"
  },
  {
   value: "Ansonia (USAQZ)",
   label: "Ansonia (USAQZ)"
  },
  {
   value: "Ansonville (USVFR)",
   label: "Ansonville (USVFR)"
  },
  {
   value: "Anthem (USAJH)",
   label: "Anthem (USAJH)"
  },
  {
   value: "Anthony (USANY)",
   label: "Anthony (USANY)"
  },
  {
   value: "Anthony (USTNY)",
   label: "Anthony (USTNY)"
  },
  {
   value: "Antioch (USTIH)",
   label: "Antioch (USTIH)"
  },
  {
   value: "Antioch (USTIO)",
   label: "Antioch (USTIO)"
  },
  {
   value: "Antonito (USZJK)",
   label: "Antonito (USZJK)"
  },
  {
   value: "Antwerp (USZAQ)",
   label: "Antwerp (USZAQ)"
  },
  {
   value: "Anvik (USANV)",
   label: "Anvik (USANV)"
  },
  {
   value: "Apalachin (USAPI)",
   label: "Apalachin (USAPI)"
  },
  {
   value: "Apollo (USZAP)",
   label: "Apollo (USZAP)"
  },
  {
   value: "Apollo Beach (USZAB)",
   label: "Apollo Beach (USZAB)"
  },
  {
   value: "Apple Creek (USAPQ)",
   label: "Apple Creek (USAPQ)"
  },
  {
   value: "Apple Valley (USYAW)",
   label: "Apple Valley (USYAW)"
  },
  {
   value: "Aquebogue (USAQO)",
   label: "Aquebogue (USAQO)"
  },
  {
   value: "Arabi (USAJF)",
   label: "Arabi (USAJF)"
  },
  {
   value: "Aransas Pass (USYAS)",
   label: "Aransas Pass (USYAS)"
  },
  {
   value: "Arapahoe (USAAE)",
   label: "Arapahoe (USAAE)"
  },
  {
   value: "Arbyrd (USAYD)",
   label: "Arbyrd (USAYD)"
  },
  {
   value: "Arcade (USAC2)",
   label: "Arcade (USAC2)"
  },
  {
   value: "Arcadia (USAIQ)",
   label: "Arcadia (USAIQ)"
  },
  {
   value: "Arcadia (USJDI)",
   label: "Arcadia (USJDI)"
  },
  {
   value: "Arcadia (USJLM)",
   label: "Arcadia (USJLM)"
  },
  {
   value: "Arcata (USACV)",
   label: "Arcata (USACV)"
  },
  {
   value: "Arcola (USAXL)",
   label: "Arcola (USAXL)"
  },
  {
   value: "Arctic Village (USARC)",
   label: "Arctic Village (USARC)"
  },
  {
   value: "Ardena (USZAA)",
   label: "Ardena (USZAA)"
  },
  {
   value: "Ardmore (USAME)",
   label: "Ardmore (USAME)"
  },
  {
   value: "Argos (USAGJ)",
   label: "Argos (USAGJ)"
  },
  {
   value: "Arion (USIOA)",
   label: "Arion (USIOA)"
  },
  {
   value: "Ariton (USRIU)",
   label: "Ariton (USRIU)"
  },
  {
   value: "Arkadelphia (USADA)",
   label: "Arkadelphia (USADA)"
  },
  {
   value: "Arkansas City (USASC)",
   label: "Arkansas City (USASC)"
  },
  {
   value: "Arlee (USXAI)",
   label: "Arlee (USXAI)"
  },
  {
   value: "Arlington (USAGT)",
   label: "Arlington (USAGT)"
  },
  {
   value: "Arlington (USAGZ)",
   label: "Arlington (USAGZ)"
  },
  {
   value: "Arlington (USIGB)",
   label: "Arlington (USIGB)"
  },
  {
   value: "Arlington (USIGN)",
   label: "Arlington (USIGN)"
  },
  {
   value: "Arlington (USQAR)",
   label: "Arlington (USQAR)"
  },
  {
   value: "Arlington (USRLG)",
   label: "Arlington (USRLG)"
  },
  {
   value: "Arlington (USZAT)",
   label: "Arlington (USZAT)"
  },
  {
   value: "Arlington, Houston (USAGW)",
   label: "Arlington, Houston (USAGW)"
  },
  {
   value: "Arlington, Knox (USAT3)",
   label: "Arlington, Knox (USAT3)"
  },
  {
   value: "Arlington, Shelby (USIGT)",
   label: "Arlington, Shelby (USIGT)"
  },
  {
   value: "Arlington\/Baltimore (USAAP)",
   label: "Arlington\/Baltimore (USAAP)"
  },
  {
   value: "Armstrong (USAEZ)",
   label: "Armstrong (USAEZ)"
  },
  {
   value: "Arnett (USOAR)",
   label: "Arnett (USOAR)"
  },
  {
   value: "Arnold (USAQL)",
   label: "Arnold (USAQL)"
  },
  {
   value: "Arnold (USAZR)",
   label: "Arnold (USAZR)"
  },
  {
   value: "Arnold (USYAJ)",
   label: "Arnold (USYAJ)"
  },
  {
   value: "Arnolds Park (USRNR)",
   label: "Arnolds Park (USRNR)"
  },
  {
   value: "Aromas (USAQR)",
   label: "Aromas (USAQR)"
  },
  {
   value: "Arpin (USRPI)",
   label: "Arpin (USRPI)"
  },
  {
   value: "Arrington (USYZA)",
   label: "Arrington (USYZA)"
  },
  {
   value: "Arroyo Grande (USAG2)",
   label: "Arroyo Grande (USAG2)"
  },
  {
   value: "Artesia (USAJI)",
   label: "Artesia (USAJI)"
  },
  {
   value: "Arthur City (USAC7)",
   label: "Arthur City (USAC7)"
  },
  {
   value: "Arundel (USXJW)",
   label: "Arundel (USXJW)"
  },
  {
   value: "Asbury Park (USARX)",
   label: "Asbury Park (USARX)"
  },
  {
   value: "Asbury, Gloucester (USASB)",
   label: "Asbury, Gloucester (USASB)"
  },
  {
   value: "Asbury, Warren (USASU)",
   label: "Asbury, Warren (USASU)"
  },
  {
   value: "Ash (USAS8)",
   label: "Ash (USAS8)"
  },
  {
   value: "Ash Flat (USAZF)",
   label: "Ash Flat (USAZF)"
  },
  {
   value: "Ash Grove (USZAV)",
   label: "Ash Grove (USZAV)"
  },
  {
   value: "Ashaway (USAHW)",
   label: "Ashaway (USAHW)"
  },
  {
   value: "Ashburn (USQAS)",
   label: "Ashburn (USQAS)"
  },
  {
   value: "Ashburnham (USHHA)",
   label: "Ashburnham (USHHA)"
  },
  {
   value: "Asheville (USAEV)",
   label: "Asheville (USAEV)"
  },
  {
   value: "Ashford (USAF2)",
   label: "Ashford (USAF2)"
  },
  {
   value: "Ashkum (USASM)",
   label: "Ashkum (USASM)"
  },
  {
   value: "Ashland (USAHJ)",
   label: "Ashland (USAHJ)"
  },
  {
   value: "Ashland (USAHL)",
   label: "Ashland (USAHL)"
  },
  {
   value: "Ashland (USANL)",
   label: "Ashland (USANL)"
  },
  {
   value: "Ashland (USASI)",
   label: "Ashland (USASI)"
  },
  {
   value: "Ashland (USNEX)",
   label: "Ashland (USNEX)"
  },
  {
   value: "Ashley (USAHY)",
   label: "Ashley (USAHY)"
  },
  {
   value: "Ashley (USASY)",
   label: "Ashley (USASY)"
  },
  {
   value: "Ashley (USESH)",
   label: "Ashley (USESH)"
  },
  {
   value: "Ashmore (USAOH)",
   label: "Ashmore (USAOH)"
  },
  {
   value: "Ashton (USAS2)",
   label: "Ashton (USAS2)"
  },
  {
   value: "Ashwaubenon (USAWB)",
   label: "Ashwaubenon (USAWB)"
  },
  {
   value: "Asotin (USOAX)",
   label: "Asotin (USOAX)"
  },
  {
   value: "Aspen (USASE)",
   label: "Aspen (USASE)"
  },
  {
   value: "Astatula (USAUA)",
   label: "Astatula (USAUA)"
  },
  {
   value: "Astoria (USAT4)",
   label: "Astoria (USAT4)"
  },
  {
   value: "Atascadero (USAFC)",
   label: "Atascadero (USAFC)"
  },
  {
   value: "Atglen (USAGL)",
   label: "Atglen (USAGL)"
  },
  {
   value: "Athena (USTHN)",
   label: "Athena (USTHN)"
  },
  {
   value: "Athens (USATB)",
   label: "Athens (USATB)"
  },
  {
   value: "Athens (USAZH)",
   label: "Athens (USAZH)"
  },
  {
   value: "Athens (USTHZ)",
   label: "Athens (USTHZ)"
  },
  {
   value: "Atka (USAKB)",
   label: "Atka (USAKB)"
  },
  {
   value: "Atkins (USAIS)",
   label: "Atkins (USAIS)"
  },
  {
   value: "Atkinson (USAN3)",
   label: "Atkinson (USAN3)"
  },
  {
   value: "Atkinson (USZAS)",
   label: "Atkinson (USZAS)"
  },
  {
   value: "Atlanta (USA2N)",
   label: "Atlanta (USA2N)"
  },
  {
   value: "Atlanta (USAZI)",
   label: "Atlanta (USAZI)"
  },
  {
   value: "Atlanta (USTAT)",
   label: "Atlanta (USTAT)"
  },
  {
   value: "Atlanta (USTLN)",
   label: "Atlanta (USTLN)"
  },
  {
   value: "Atlantic (USAIO)",
   label: "Atlantic (USAIO)"
  },
  {
   value: "Atlantic Beach (USQAT)",
   label: "Atlantic Beach (USQAT)"
  },
  {
   value: "Atlantic Beach (USTBH)",
   label: "Atlantic Beach (USTBH)"
  },
  {
   value: "Atlantic Highlands (USAHZ)",
   label: "Atlantic Highlands (USAHZ)"
  },
  {
   value: "Atlasburg (USABW)",
   label: "Atlasburg (USABW)"
  },
  {
   value: "Atmautluak (USATT)",
   label: "Atmautluak (USATT)"
  },
  {
   value: "Atmore (USAMK)",
   label: "Atmore (USAMK)"
  },
  {
   value: "Atoka (USAOD)",
   label: "Atoka (USAOD)"
  },
  {
   value: "Atqasuk (USATK)",
   label: "Atqasuk (USATK)"
  },
  {
   value: "Attica (USIAX)",
   label: "Attica (USIAX)"
  },
  {
   value: "Attica (USXTC)",
   label: "Attica (USXTC)"
  },
  {
   value: "Attu Island (USATU)",
   label: "Attu Island (USATU)"
  },
  {
   value: "Atwater (USYZY)",
   label: "Atwater (USYZY)"
  },
  {
   value: "Auburn (USA2U)",
   label: "Auburn (USA2U)"
  },
  {
   value: "Auburn (USAUE)",
   label: "Auburn (USAUE)"
  },
  {
   value: "Auburn (USAUN)",
   label: "Auburn (USAUN)"
  },
  {
   value: "Auburn (USQAE)",
   label: "Auburn (USQAE)"
  },
  {
   value: "Auburn (USUUN)",
   label: "Auburn (USUUN)"
  },
  {
   value: "Auburn (USUUR)",
   label: "Auburn (USUUR)"
  },
  {
   value: "Auburn (USXUB)",
   label: "Auburn (USXUB)"
  },
  {
   value: "Auburn Hills (USABH)",
   label: "Auburn Hills (USABH)"
  },
  {
   value: "Auburndale (USZJR)",
   label: "Auburndale (USZJR)"
  },
  {
   value: "August F. Haw (USTFH)",
   label: "August F. Haw (USTFH)"
  },
  {
   value: "Augusta (USAGU)",
   label: "Augusta (USAGU)"
  },
  {
   value: "Augusta (USUUA)",
   label: "Augusta (USUUA)"
  },
  {
   value: "Augusta (USUUT)",
   label: "Augusta (USUUT)"
  },
  {
   value: "Aultman (USUTM)",
   label: "Aultman (USUTM)"
  },
  {
   value: "Aumsville (USUSV)",
   label: "Aumsville (USUSV)"
  },
  {
   value: "Aura (USKAR)",
   label: "Aura (USKAR)"
  },
  {
   value: "Aurora (USQQY)",
   label: "Aurora (USQQY)"
  },
  {
   value: "Aurora (USUOA)",
   label: "Aurora (USUOA)"
  },
  {
   value: "Aurora (USUOR)",
   label: "Aurora (USUOR)"
  },
  {
   value: "Aurora (USYAO)",
   label: "Aurora (USYAO)"
  },
  {
   value: "Austin (USZAW)",
   label: "Austin (USZAW)"
  },
  {
   value: "Austinburg (USASG)",
   label: "Austinburg (USASG)"
  },
  {
   value: "Autaugaville (USAGV)",
   label: "Autaugaville (USAGV)"
  },
  {
   value: "Auxier (USKYX)",
   label: "Auxier (USKYX)"
  },
  {
   value: "Ava (USAQB)",
   label: "Ava (USAQB)"
  },
  {
   value: "Avalon (USAOU)",
   label: "Avalon (USAOU)"
  },
  {
   value: "Avalon (USAVB)",
   label: "Avalon (USAVB)"
  },
  {
   value: "Avalon (USAVS)",
   label: "Avalon (USAVS)"
  },
  {
   value: "Avenel\/Washington, D.C. (USAVW)",
   label: "Avenel\/Washington, D.C. (USAVW)"
  },
  {
   value: "Aventura (USAVU)",
   label: "Aventura (USAVU)"
  },
  {
   value: "Avery Hill (USAYB)",
   label: "Avery Hill (USAYB)"
  },
  {
   value: "Avilla (USALQ)",
   label: "Avilla (USALQ)"
  },
  {
   value: "Avinger (USAWJ)",
   label: "Avinger (USAWJ)"
  },
  {
   value: "Avoca (USVOC)",
   label: "Avoca (USVOC)"
  },
  {
   value: "Avon (USANW)",
   label: "Avon (USANW)"
  },
  {
   value: "Avon (USAVF)",
   label: "Avon (USAVF)"
  },
  {
   value: "Avon (USVAO)",
   label: "Avon (USVAO)"
  },
  {
   value: "Avon (USVON)",
   label: "Avon (USVON)"
  },
  {
   value: "Avon (USZVO)",
   label: "Avon (USZVO)"
  },
  {
   value: "Avon-by-the-Sea (USAVH)",
   label: "Avon-by-the-Sea (USAVH)"
  },
  {
   value: "Avondale (USAFB)",
   label: "Avondale (USAFB)"
  },
  {
   value: "Avondale (USAJW)",
   label: "Avondale (USAJW)"
  },
  {
   value: "Avondale (USAVG)",
   label: "Avondale (USAVG)"
  },
  {
   value: "Awendaw (USAWW)",
   label: "Awendaw (USAWW)"
  },
  {
   value: "Axis (USAXS)",
   label: "Axis (USAXS)"
  },
  {
   value: "Axtell (USAX4)",
   label: "Axtell (USAX4)"
  },
  {
   value: "Axtell (USVXT)",
   label: "Axtell (USVXT)"
  },
  {
   value: "Axton (USAXO)",
   label: "Axton (USAXO)"
  },
  {
   value: "Aylett (USAYT)",
   label: "Aylett (USAYT)"
  },
  {
   value: "Azle (USAZL)",
   label: "Azle (USAZL)"
  },
  {
   value: "Aztec (USZZT)",
   label: "Aztec (USZZT)"
  },
  {
   value: "Bacova (USBQV)",
   label: "Bacova (USBQV)"
  },
  {
   value: "Baden (USBAE)",
   label: "Baden (USBAE)"
  },
  {
   value: "Bagley (USGAJ)",
   label: "Bagley (USGAJ)"
  },
  {
   value: "Bailey I. (USEYI)",
   label: "Bailey I. (USEYI)"
  },
  {
   value: "Baileyville (USILY)",
   label: "Baileyville (USILY)"
  },
  {
   value: "Bainbridge Island (USBII)",
   label: "Bainbridge Island (USBII)"
  },
  {
   value: "Baiting Hollow (USNGH)",
   label: "Baiting Hollow (USNGH)"
  },
  {
   value: "Baker (USBK3)",
   label: "Baker (USBK3)"
  },
  {
   value: "Baker (USBKG)",
   label: "Baker (USBKG)"
  },
  {
   value: "Baker (USBKM)",
   label: "Baker (USBKM)"
  },
  {
   value: "Bakersville (USKRS)",
   label: "Bakersville (USKRS)"
  },
  {
   value: "Bakewell (USQBZ)",
   label: "Bakewell (USQBZ)"
  },
  {
   value: "Bala-Cynwyd (USZBC)",
   label: "Bala-Cynwyd (USZBC)"
  },
  {
   value: "Balch Springs (USBPN)",
   label: "Balch Springs (USBPN)"
  },
  {
   value: "Bald Knob (USZBB)",
   label: "Bald Knob (USZBB)"
  },
  {
   value: "Baldwin (USAWI)",
   label: "Baldwin (USAWI)"
  },
  {
   value: "Baldwin (USLDK)",
   label: "Baldwin (USLDK)"
  },
  {
   value: "Baldwin (USZBN)",
   label: "Baldwin (USZBN)"
  },
  {
   value: "Baldwin (USZBW)",
   label: "Baldwin (USZBW)"
  },
  {
   value: "Baldwin City (USBZI)",
   label: "Baldwin City (USBZI)"
  },
  {
   value: "Baldwinsville (USBDV)",
   label: "Baldwinsville (USBDV)"
  },
  {
   value: "Baldwinville (USAWV)",
   label: "Baldwinville (USAWV)"
  },
  {
   value: "Baldwyn (USBWU)",
   label: "Baldwyn (USBWU)"
  },
  {
   value: "Ball Ground (USBBN)",
   label: "Ball Ground (USBBN)"
  },
  {
   value: "Ballard\/Seattle (USAFY)",
   label: "Ballard\/Seattle (USAFY)"
  },
  {
   value: "Ballouville (USBZK)",
   label: "Ballouville (USBZK)"
  },
  {
   value: "Baltic (USQBC)",
   label: "Baltic (USQBC)"
  },
  {
   value: "Baltic (USQBM)",
   label: "Baltic (USQBM)"
  },
  {
   value: "Baltimore (USBZB)",
   label: "Baltimore (USBZB)"
  },
  {
   value: "Baltimore (USZ2A)",
   label: "Baltimore (USZ2A)"
  },
  {
   value: "Bamberg (USBBM)",
   label: "Bamberg (USBBM)"
  },
  {
   value: "Bandera (USZGM)",
   label: "Bandera (USZGM)"
  },
  {
   value: "Bangor (USBG2)",
   label: "Bangor (USBG2)"
  },
  {
   value: "Bangor (USBNQ)",
   label: "Bangor (USBNQ)"
  },
  {
   value: "Bangor (USQGR)",
   label: "Bangor (USQGR)"
  },
  {
   value: "Banks (USNKS)",
   label: "Banks (USNKS)"
  },
  {
   value: "Banner Elk (USBE2)",
   label: "Banner Elk (USBE2)"
  },
  {
   value: "Banning (USBNG)",
   label: "Banning (USBNG)"
  },
  {
   value: "Bannister (USIBI)",
   label: "Bannister (USIBI)"
  },
  {
   value: "Bantam (USYBM)",
   label: "Bantam (USYBM)"
  },
  {
   value: "Bar Nunn (USRNI)",
   label: "Bar Nunn (USRNI)"
  },
  {
   value: "Baraga (USRGA)",
   label: "Baraga (USRGA)"
  },
  {
   value: "Baranof (USBNF)",
   label: "Baranof (USBNF)"
  },
  {
   value: "Barboursville (USBAB)",
   label: "Barboursville (USBAB)"
  },
  {
   value: "Barbourville (USBBZ)",
   label: "Barbourville (USBBZ)"
  },
  {
   value: "Barclay (USBFK)",
   label: "Barclay (USBFK)"
  },
  {
   value: "Barkhamsted (USBH5)",
   label: "Barkhamsted (USBH5)"
  },
  {
   value: "Barling (USZA2)",
   label: "Barling (USZA2)"
  },
  {
   value: "Barnegat (USBG7)",
   label: "Barnegat (USBG7)"
  },
  {
   value: "Barnesville (USBV3)",
   label: "Barnesville (USBV3)"
  },
  {
   value: "Barnet (USBJR)",
   label: "Barnet (USBJR)"
  },
  {
   value: "Barneveld (USVDX)",
   label: "Barneveld (USVDX)"
  },
  {
   value: "Barnwell (USBNL)",
   label: "Barnwell (USBNL)"
  },
  {
   value: "Barre (USBJE)",
   label: "Barre (USBJE)"
  },
  {
   value: "Barre (USVBR)",
   label: "Barre (USVBR)"
  },
  {
   value: "Barree (USBJA)",
   label: "Barree (USBJA)"
  },
  {
   value: "Barron (USYRR)",
   label: "Barron (USYRR)"
  },
  {
   value: "Barrow (USBRW)",
   label: "Barrow (USBRW)"
  },
  {
   value: "Barry (USYRB)",
   label: "Barry (USYRB)"
  },
  {
   value: "Barter Island (USBTI)",
   label: "Barter Island (USBTI)"
  },
  {
   value: "Bartlett (USBA2)",
   label: "Bartlett (USBA2)"
  },
  {
   value: "Bartlett (USBBP)",
   label: "Bartlett (USBBP)"
  },
  {
   value: "Bartlett (USBIJ)",
   label: "Bartlett (USBIJ)"
  }
 ]